{
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.27695425198607, -0.9574282277797865],
            [5.311750093328808, -0.9545647114403742],
            [5.326687470941064, -0.950051814780252],
            [5.326698417829532, -0.9530461026545783],
            [5.32345216492509, -0.9600798447288975],
            [5.331682885435178, -0.9607430128085037],
            [5.333743871075135, -0.9561531077040732],
            [5.336524575046495, -0.9546213150946076],
            [5.339317273693745, -0.9609060545064236],
            [5.34273632121916, -0.9618405591443268],
            [5.362166074923566, -0.9593147345922842],
            [5.365663620818369, -0.9608147372041581],
            [5.369500299508734, -0.958080874698014],
            [5.375603455768494, -0.9580820746283977],
            [5.3720042967043815, -0.9533512676661036],
            [5.37208077122377, -0.9501720023587987],
            [5.375586975356314, -0.9486849348120212],
            [5.381718210531244, -0.9500254780918722],
            [5.386989234068816, -0.9552837702569658],
            [5.387710446276, -0.9600981242759856],
            [5.392266195963154, -0.9590295855709494],
            [5.390701797484605, -0.9543591138543936],
            [5.394383309222111, -0.9495972311265082],
            [5.400234406464521, -0.9526558297311785],
            [5.40719066542164, -0.9543140036734278],
            [5.411279197072571, -0.9515955414577698],
            [5.41591331356472, -0.9541246935278116],
            [5.414519970451922, -0.9594691603407596],
            [5.418916911377, -0.9629630963538124],
            [5.421530391047552, -0.9629388237454242],
            [5.422618481870971, -0.955686859821147],
            [5.426534331052069, -0.9622228478182979],
            [5.4315674852853855, -0.9559258918938767],
            [5.430557535767984, -0.9482430241320552],
            [5.4397616453721875, -0.9470634837016128],
            [5.444297291127499, -0.9480725304074805],
            [5.448653314454973, -0.9417750161753351],
            [5.450621377252774, -0.941633025281465],
            [5.4519563195354905, -0.9475403032477444],
            [5.449314208511531, -0.953268835912046],
            [5.450991066677467, -0.9582110935889575],
            [5.454602655607941, -0.9578010161018108],
            [5.456301226955813, -0.9542576341265807],
            [5.461932958250828, -0.9561878672957521],
            [5.462725281775926, -0.9508553320522253],
            [5.468901919501028, -0.9514865288682836],
            [5.47451809054144, -0.9462694114462833],
            [5.475485063710246, -0.9406739220897289],
            [5.478904358998308, -0.9401065549660343],
            [5.4790788780443185, -0.9513974176587177],
            [5.486800926984045, -0.9578480483433431],
            [5.48813883165179, -0.9613542673930375],
            [5.485510010461135, -0.9641617682513365],
            [5.488747291941348, -0.9678838733994409],
            [5.493444532835422, -0.9614391591429534],
            [5.49682380690493, -0.9654296349057047],
            [5.495955032897684, -0.9691122366057536],
            [5.49781491170205, -0.9714293750677299],
            [5.501066867330376, -0.9697754232884368],
            [5.509934518834791, -0.9678976908329096],
            [5.517863590204242, -0.9641932247698689],
            [5.523536850104078, -0.9674317386563808],
            [5.523774514357948, -0.9715171932809051],
            [5.527912837793615, -0.9734378817433355],
            [5.534278453693381, -0.969152886532834],
            [5.535416628151272, -0.97307478601125],
            [5.539145538443954, -0.9755267471806983],
            [5.5449306768199955, -0.9730873178283598],
            [5.5462824100342685, -0.9855485353861981],
            [5.551177407437126, -1.0036803109537837],
            [5.558993504651768, -1.0145168728691445],
            [5.5654415293510535, -1.0255800011002716],
            [5.567986303595877, -1.0335077930624414],
            [5.573161006138278, -1.0442244263996985],
            [5.5876820646462715, -1.0661189686659713],
            [5.591413204240719, -1.0708363931448095],
            [5.608418651484181, -1.0862657754839473],
            [5.618099242997723, -1.0986208154690522],
            [5.6232443862678005, -1.1087424054401214],
            [5.631022136739136, -1.1278127407883782],
            [5.634471103169864, -1.1380369357510185],
            [5.636239528104631, -1.1474919823321321],
            [5.635966363170453, -1.1547345782000542],
            [5.632840258017334, -1.1796153513212277],
            [5.629822370149722, -1.189035250435314],
            [5.627488161119565, -1.191843021497356],
            [5.61871897898622, -1.1964623895700053],
            [5.6131722592301925, -1.1980513519023255],
            [5.597660640813726, -1.2002507601016015],
            [5.588524301874601, -1.204536746292461],
            [5.585071445755925, -1.2080003209565602],
            [5.58240916686196, -1.2148270726142807],
            [5.572813798611548, -1.2247257385982238],
            [5.570264730694435, -1.2297945696705734],
            [5.568265201128503, -1.2455780132154917],
            [5.566960328812254, -1.2490286034673617],
            [5.566901198529218, -1.2556533419688096],
            [5.5709613347529725, -1.2638079286168056],
            [5.581008762346184, -1.2767061374998696],
            [5.592528314401328, -1.2882924787241121],
            [5.590956606326019, -1.2934368540435428],
            [5.580948239760887, -1.2931399620310038],
            [5.578615832412196, -1.2968491504589041],
            [5.573575278623301, -1.2967252871509698],
            [5.5678375690056905, -1.294214171875017],
            [5.547422403063161, -1.2956343050587384],
            [5.547864571427562, -1.3027619083163646],
            [5.518774691632398, -1.3046358239524498],
            [5.519277910872169, -1.3120880811913875],
            [5.490336888024553, -1.3139497296571552],
            [5.491176225900169, -1.3287945392123695],
            [5.468198562150606, -1.3303473535134793],
            [5.469166283246368, -1.3425023053435043],
            [5.455037258677863, -1.3435109233084637],
            [5.455529713346757, -1.3509364126412116],
            [5.440931042238877, -1.3521799697094268],
            [5.442018230077342, -1.3667579578766538],
            [5.427598063597977, -1.3677571734793372],
            [5.429822872223368, -1.3968618793291687],
            [5.4154492021680785, -1.3977885045092737],
            [5.416622920748965, -1.4123937737851748],
            [5.387683670867048, -1.4142534210394613],
            [5.388878314582065, -1.4289128788395196],
            [5.383371277368619, -1.4292474332757175],
            [5.341728263346542, -1.4319675984027678],
            [5.303449379667156, -1.4342904763803928],
            [5.297273895251198, -1.340870313839908],
            [5.30005595952124, -1.3406298388941456],
            [5.298644044311139, -1.3106151529383807],
            [5.294909985530854, -1.2482717301599449],
            [5.293846958322343, -1.2483232529131496],
            [5.290926351178403, -1.1885260482399571],
            [5.288598126838917, -1.155357927235812],
            [5.285918258341842, -1.1108049754844342],
            [5.282601502688005, -1.061107109251988],
            [5.2829060530343375, -1.0582687243212225],
            [5.2815100027838415, -1.0318675504645556],
            [5.27695425198607, -0.9574282277797865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.68448923303517,
          "lat": 37.383972850288494
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29031"],
        "coty_name": ["Cape Girardeau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cape Girardeau County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00758470"
      },
      "bbox": [
        5.27695425198607, -1.4342904763803928, 5.636239528104631,
        -0.9401065549660343
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2100215530822935, 1.9658241867583985],
            [3.24912835202994, 1.9685426620999893],
            [3.3385317691035428, 1.9741582792903798],
            [3.401197866657003, 1.978017095918405],
            [3.4513097328368363, 1.9819926827177468],
            [3.5162945755612287, 1.9868847595825605],
            [3.5195593750781784, 1.884593291763849],
            [3.521481462875069, 1.825757920107948],
            [3.522940182688718, 1.767095908841738],
            [3.5240327479773166, 1.7085540606410055],
            [3.524414569945995, 1.67941075188859],
            [3.467416833592747, 1.6782092498755479],
            [3.4397535297845687, 1.6777630416412663],
            [3.3514432620610277, 1.675641346826499],
            [3.3029599576540862, 1.6733367367383005],
            [3.2973979530575126, 1.6727749090342696],
            [3.2236967239073997, 1.669165958319526],
            [3.222114452516793, 1.6690819575870555],
            [3.220359955189474, 1.7131902847705063],
            [3.214234465752293, 1.8447222271575254],
            [3.212243913299014, 1.8998571228623626],
            [3.2103440129269925, 1.9609767552619795],
            [3.2100215530822935, 1.9658241867583985]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.14706128937199, "lat": 40.45259555800854 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29199"],
        "coty_name": ["Scotland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scotland County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "00758552"
      },
      "bbox": [
        3.2100215530822935, 1.6690819575870555, 3.524414569945995,
        1.9868847595825605
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.11662807044516706, 2.3360383734152768],
            [0.1879546270687627, 2.3348296367436685],
            [0.2022248149313251, 2.3349178326207793],
            [0.2026255603393879, 2.36433884070758],
            [0.203283994387946, 2.3647958113335044],
            [0.22498358992393744, 2.3647368152068813],
            [0.23087049845939886, 2.356085674822481],
            [0.24130372257629465, 2.3463546617785385],
            [0.2509469240628468, 2.3412294723517904],
            [0.25760446600679837, 2.339529436618699],
            [0.2672684537355698, 2.3381883743488103],
            [0.27608540619837796, 2.3381444340838042],
            [0.2835710117617939, 2.3327290975856996],
            [0.2872420520278053, 2.326567237715632],
            [0.28937481402873994, 2.3200777897421543],
            [0.2966301051181826, 2.314795207382877],
            [0.29985469017341654, 2.31345680041802],
            [0.3083093892398661, 2.314767746255164],
            [0.31564985064034556, 2.3188919103270127],
            [0.32337992081052647, 2.3213859145306515],
            [0.32876592401490856, 2.325366153916842],
            [0.3454756779891455, 2.3324411592538365],
            [0.34898744521608865, 2.3350900900748552],
            [0.3554667501522311, 2.33681479304129],
            [0.35939699986694085, 2.3435679511922825],
            [0.36554903809902123, 2.3506919067632426],
            [0.37337267400521773, 2.3573316054181124],
            [0.38156432334334406, 2.3678149366939256],
            [0.3888045842266875, 2.372686808749424],
            [0.3936630202051623, 2.372638539216817],
            [0.4030363194115783, 2.3765718662249538],
            [0.40866183192879313, 2.377502148368703],
            [0.41647680443216156, 2.3827450112459134],
            [0.4216723639561223, 2.3848572472049727],
            [0.43826905669096194, 2.3854991268326255],
            [0.44270644628640216, 2.3831142174847537],
            [0.45321947171947247, 2.3802962487207675],
            [0.46143072636263754, 2.3799681077127213],
            [0.46981083582771993, 2.3736288104585497],
            [0.47721321564971086, 2.3718971005495595],
            [0.4848118717019642, 2.3753643934768456],
            [0.4882023389884469, 2.378893363980926],
            [0.49290503831122734, 2.380231939577711],
            [0.4988507704696078, 2.379401516593467],
            [0.502300948766122, 2.377369383623591],
            [0.5120039531213201, 2.3771546859019197],
            [0.5276183843573959, 2.3792472532057434],
            [0.531263036814699, 2.3780618997312457],
            [0.5410262132765667, 2.378905955133446],
            [0.54659213428462, 2.3779290069816192],
            [0.5538739242988121, 2.3727558174587045],
            [0.5671361470882116, 2.3587990292759144],
            [0.569152661328895, 2.3509158139725908],
            [0.5685513805583982, 2.3446728045043557],
            [0.5641034108887465, 2.3366067452926704],
            [0.5614146324502871, 2.3285392164751233],
            [0.563072057924844, 2.3206831384553586],
            [0.5659179062161446, 2.316396249065262],
            [0.5741191245991067, 2.3107644612694864],
            [0.5802580644242779, 2.3085436163243607],
            [0.5883654805673065, 2.3016417446414206],
            [0.5907989525296143, 2.2972854677048398],
            [0.5922832627160881, 2.29128926265016],
            [0.5911754830821726, 2.2827019537934947],
            [0.5851159537094388, 2.269352197599485],
            [0.583393353986226, 2.258592288038466],
            [0.5838040631418218, 2.251376535282043],
            [0.5862994838928105, 2.2401579436342245],
            [0.5906117204379067, 2.233476827496303],
            [0.5996125837253204, 2.225244837493951],
            [0.6035583896550408, 2.2200883299698067],
            [0.6063313075265792, 2.213799845741943],
            [0.6065654633011129, 2.209548937774636],
            [0.6046235969615288, 2.202502376456379],
            [0.6017457908448178, 2.1980699556322723],
            [0.59496498773588, 2.193173841702149],
            [0.5846629218500847, 2.190324983635643],
            [0.5806651514964346, 2.1873526251640563],
            [0.5778895799343003, 2.18239016148217],
            [0.5773700817251247, 2.1766241336028775],
            [0.5784317504031808, 2.1721585481533086],
            [0.5827776036716651, 2.1635292963019785],
            [0.5858880715068198, 2.1531979601982894],
            [0.5848422041669374, 2.143952859725454],
            [0.5808645232595976, 2.135391093692921],
            [0.5798086209272162, 2.128977734964327],
            [0.5810196480218682, 2.1213797986663665],
            [0.5869945402160829, 2.108133885492293],
            [0.5882075645494297, 2.1012363482313736],
            [0.5444377615801615, 2.101522115815583],
            [0.4585604658645269, 2.1014111931600383],
            [0.3727634916548778, 2.101512299661298],
            [0.2863147885191615, 2.101297839474201],
            [0.21475083286977392, 2.1012736694363476],
            [0.20098445643606894, 2.1016908675938177],
            [0.11555855564125211, 2.102154085241705],
            [0.11609559431635137, 2.2044591736496484],
            [0.11662807044516706, 2.3360383734152768]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.1408911702373, "lat": 40.90973281405578 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31025"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00835834"
      },
      "bbox": [
        0.11555855564125211, 2.1012363482313736, 0.6065654633011129,
        2.3854991268326255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.11555855564125211, 2.102154085241705],
            [0.20098445643606894, 2.1016908675938177],
            [0.21475083286977392, 2.1012736694363476],
            [0.2863147885191615, 2.101297839474201],
            [0.3727634916548778, 2.101512299661298],
            [0.4585604658645269, 2.1014111931600383],
            [0.5444377615801615, 2.101522115815583],
            [0.5882075645494297, 2.1012363482313736],
            [0.5862022681018685, 2.0938684073982787],
            [0.5817654391381518, 2.0884345845360803],
            [0.5743009000107475, 2.0829176271938623],
            [0.561387973914065, 2.076865615505528],
            [0.5546033032593264, 2.0702408523850604],
            [0.5511426936709565, 2.0649450476366407],
            [0.5473599655804526, 2.0533101859269407],
            [0.5472074272121549, 2.0488378327216887],
            [0.5498937472225263, 2.037993577266327],
            [0.5515294853359836, 2.0344536301045992],
            [0.5561651518627576, 2.031141284438439],
            [0.5694289152010591, 2.024878040252835],
            [0.5745209154712547, 2.0190465654859895],
            [0.5780546217175551, 2.010922744163268],
            [0.579499589165144, 1.9992403536122887],
            [0.5819388449886975, 1.994094416312047],
            [0.5899382933846296, 1.9877615941977953],
            [0.5969119980789673, 1.983782451107418],
            [0.6035051839336049, 1.9821116186786139],
            [0.6109088438833448, 1.9814369752314678],
            [0.6175457445976692, 1.9789288326765073],
            [0.6220678322856148, 1.9759186098347412],
            [0.6320493867684678, 1.9639203773622247],
            [0.6357744186304455, 1.9557941347357923],
            [0.6367453074453652, 1.9407074667787043],
            [0.6410308855593735, 1.933323534384843],
            [0.6509412763254722, 1.9252506018374098],
            [0.6529471931313852, 1.9195075594909974],
            [0.651889824300515, 1.9131505183405517],
            [0.649571076347882, 1.9088981788157735],
            [0.6401822948134792, 1.9011802407597256],
            [0.6342483383052611, 1.8941057326083874],
            [0.6333897457013911, 1.8894348747301664],
            [0.6356125723429867, 1.8819383442047055],
            [0.6407158594608241, 1.8726633524672187],
            [0.641796467812463, 1.8639723212936847],
            [0.6382093318884937, 1.8559472024958439],
            [0.637563701111645, 1.852224292822794],
            [0.6393550734702627, 1.847093764746441],
            [0.6467608062914589, 1.8414934106380183],
            [0.6531174799589197, 1.83978079837002],
            [0.6617312802603796, 1.839456238319712],
            [0.672875745507161, 1.843710403220329],
            [0.6790216911040627, 1.842811109983004],
            [0.6822850357690751, 1.8393828903479632],
            [0.6519364308823618, 1.838446807771465],
            [0.6270978722178698, 1.8384967839669792],
            [0.541255087317799, 1.8382113501383974],
            [0.49161818938278734, 1.838350280553754],
            [0.41324358439759257, 1.8384120537481994],
            [0.3712879310390723, 1.8385627926994277],
            [0.2933822526870305, 1.8383699137197242],
            [0.285555610652359, 1.838254852185689],
            [0.22407003330182224, 1.8386236744849143],
            [0.1960446736628618, 1.8386109768013943],
            [0.11437373252231754, 1.839109833813542],
            [0.11485553057908358, 1.9706467410009751],
            [0.11555855564125211, 2.102154085241705]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.13478658411316,
          "lat": 40.648495082305395
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31131"],
        "coty_name": ["Otoe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Otoe County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00835887"
      },
      "bbox": [
        0.11437373252231754, 1.8382113501383974, 0.6822850357690751,
        2.102154085241705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5446256965067543, 3.424176053434084],
            [-0.4844673443442395, 3.4232346570297674],
            [-0.4027952387416733, 3.4220326129014724],
            [-0.326647040958266, 3.421022856979046],
            [-0.2874325568037227, 3.4206041110630228],
            [-0.28848244252207844, 3.333670273476907],
            [-0.28960499819739494, 3.2461118999168717],
            [-0.29041436236538865, 3.1586149657784794],
            [-0.29159632192582347, 3.0710756314211842],
            [-0.3777811782405075, 3.072149474101024],
            [-0.46378354257383314, 3.073236768373625],
            [-0.5494207316582581, 3.0745384643526172],
            [-0.5483774354015516, 3.1473692131248203],
            [-0.5472930201258149, 3.2271978495497047],
            [-0.5457632586415462, 3.3367650457981206],
            [-0.545009572448694, 3.380077060536393],
            [-0.5446256965067543, 3.424176053434084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.19390736200879, "lat": 41.91694582628813 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31167"],
        "coty_name": ["Stanton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stanton County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00835905"
      },
      "bbox": [
        -0.5494207316582581, 3.0710756314211842, -0.2874325568037227,
        3.424176053434084
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.748667325148178, 3.155507601036023],
            [-15.672694024185452, 3.277582584325736],
            [-15.580523005859792, 3.4251343823295537],
            [-15.546003314972861, 3.480705118662616],
            [-15.54459537672873, 3.4825819216545093],
            [-15.452496043691616, 3.6303211588105024],
            [-15.386952660801365, 3.7355059361614713],
            [-15.243731953253468, 3.703053404688902],
            [-15.219434243344635, 3.6983208931207305],
            [-15.20800979039289, 3.748891740232564],
            [-15.20778029413962, 3.7537948812117676],
            [-15.205979477873903, 3.757923546334362],
            [-15.187509393088373, 3.8384894319355034],
            [-15.140683319099976, 4.0477665934671645],
            [-15.140234290701743, 4.048955559635738],
            [-15.127466682170136, 4.046112064717695],
            [-14.976150368921404, 4.012634644066992],
            [-14.824841840615308, 3.9791208325563066],
            [-14.836641650214043, 3.926732237483241],
            [-14.843867212633736, 3.927741065471447],
            [-14.859226338032135, 3.858700810823068],
            [-14.861627025105642, 3.8457162398094686],
            [-14.88571655260214, 3.73442571680582],
            [-14.886501022022797, 3.7325050694915616],
            [-14.899224854176705, 3.6731468843236477],
            [-14.926498507672093, 3.5506276934435577],
            [-14.927348254959698, 3.54406920270912],
            [-14.940889550562533, 3.4813594116054074],
            [-14.942833265529195, 3.469462450442874],
            [-14.958944737593342, 3.396366507503591],
            [-14.977381761628404, 3.3144905554604573],
            [-14.981519924835455, 3.296573465338327],
            [-15.004892079798843, 3.2012370766428035],
            [-15.014527037917622, 3.161634320699239],
            [-15.016182612887304, 3.1558641781804377],
            [-15.035533822500465, 3.0703655185882632],
            [-15.035819625153216, 3.0686856604551602],
            [-15.02872382184968, 3.0670948140269263],
            [-15.054382453080114, 2.95110670514161],
            [-15.05451356720127, 2.950229458155349],
            [-15.12435137679104, 2.6354707224172236],
            [-15.125719593885071, 2.635767436595193],
            [-15.15858181905222, 2.4865447584510956],
            [-15.181854975673213, 2.3808872532684475],
            [-15.185289522597312, 2.3794377070837847],
            [-15.228165681207136, 2.1858509676549143],
            [-15.231090701094898, 2.186399524844474],
            [-15.234251602814526, 2.171924003511973],
            [-15.337647979095301, 2.195584985990205],
            [-15.346646937496727, 2.1968168754248865],
            [-15.543587447866699, 2.242658355302348],
            [-15.665796162988782, 2.270121438930483],
            [-15.78154702089762, 2.296593762947766],
            [-15.95555303579947, 2.300488558144058],
            [-16.129560808917375, 2.304355938174757],
            [-16.130038467205065, 2.312664077112137],
            [-16.13235909153865, 2.3181263770984613],
            [-16.13957084043767, 2.3220474197411582],
            [-16.14401133668367, 2.3310233883587865],
            [-16.140840541421106, 2.3329687532886654],
            [-16.137178772174636, 2.3311761809939817],
            [-16.135506781248523, 2.340326719143895],
            [-16.13335077018331, 2.3418418185753347],
            [-16.13371414223434, 2.352340134518911],
            [-16.138658341357363, 2.353497566472162],
            [-16.14116952379336, 2.3572201394111216],
            [-16.13880344789015, 2.3606707133183886],
            [-16.131293878709904, 2.357939063745401],
            [-16.130400155326804, 2.361211110933038],
            [-16.12320910224937, 2.362558082652686],
            [-16.127190633736376, 2.373903756407319],
            [-16.123234214422503, 2.3764253473435586],
            [-16.12455780499684, 2.3805665142875534],
            [-16.12113921795978, 2.3809150524306264],
            [-16.11585048987759, 2.386538192439707],
            [-16.11191891488769, 2.3832158147306655],
            [-16.10770173563908, 2.382889960827189],
            [-16.102662995545572, 2.3871436904573713],
            [-16.10187069550557, 2.3895361100225503],
            [-16.097031592233392, 2.3923388520935114],
            [-16.091931093501003, 2.3902400509234525],
            [-16.087443545850686, 2.3950070004790867],
            [-16.08373807733276, 2.3951929270180288],
            [-16.082112342860473, 2.4021887350208853],
            [-16.080065449410146, 2.402097816792421],
            [-16.073846585365132, 2.407266122640821],
            [-16.07227497958009, 2.4118406637190297],
            [-16.065643065611617, 2.413679020921913],
            [-16.060520545771446, 2.4125288314840123],
            [-16.061373288400443, 2.4173167881481548],
            [-16.059124858530936, 2.420135093065156],
            [-16.059128325036657, 2.424204738578087],
            [-16.05519829745703, 2.43557033790184],
            [-16.052019368164448, 2.4406422315469456],
            [-16.048796248010742, 2.443130542667981],
            [-16.049875260664553, 2.4465106558017293],
            [-16.05413853389421, 2.4497805879560106],
            [-16.054310782184487, 2.4638359010061794],
            [-16.05657259840562, 2.467995502993359],
            [-16.055034033740153, 2.4706088208474104],
            [-16.054745282792126, 2.4815755160651793],
            [-16.06119061578647, 2.4897487153742204],
            [-16.058279829001336, 2.4959156393813378],
            [-16.056230023189073, 2.4974095158033576],
            [-16.057511686196694, 2.5031390932595166],
            [-16.05994224719008, 2.506743899160282],
            [-16.059613466097414, 2.510844831639225],
            [-16.062480692962794, 2.5148900285836513],
            [-16.0602160458382, 2.5203806169261966],
            [-16.059253504987478, 2.526769628755197],
            [-16.060608567954414, 2.534754256937575],
            [-16.062749143059857, 2.5380195327793063],
            [-16.06190360317178, 2.54395106063017],
            [-16.058489774052443, 2.548152821392485],
            [-16.05840078176216, 2.555116756493933],
            [-16.0608170459285, 2.5570109938497554],
            [-16.059206710053335, 2.5623728996213506],
            [-16.05516971276008, 2.5671480851890967],
            [-16.054635630832937, 2.5725492326228134],
            [-16.051682900424083, 2.573493855440092],
            [-16.050042071520657, 2.5787222442509408],
            [-16.04745081644596, 2.5797904414291732],
            [-16.044113337076947, 2.585179004082127],
            [-16.040926689087783, 2.5864556877500733],
            [-16.037384167232858, 2.5814888150731385],
            [-16.03131206242295, 2.578506090748172],
            [-16.0263255808787, 2.5780034366618985],
            [-16.022658029102782, 2.5792405767879325],
            [-16.016257676778295, 2.5771572756739256],
            [-16.008956963439108, 2.578419937199545],
            [-16.003463068020572, 2.5779553047988375],
            [-15.999742784508769, 2.580717653195263],
            [-15.997029256197845, 2.5848131937209606],
            [-15.99224629261177, 2.588302376140661],
            [-15.992046092187703, 2.591280017780066],
            [-15.987364707167824, 2.594926459405136],
            [-15.98765410116691, 2.6000001457068875],
            [-15.982286432908785, 2.601720356869416],
            [-15.97967733040735, 2.6102617876441685],
            [-15.977499651872428, 2.6111751788631543],
            [-15.968377179889863, 2.6107866227134036],
            [-15.963260048494877, 2.6092823464387265],
            [-15.956684356769026, 2.609212958598728],
            [-15.953492790437217, 2.611915968658149],
            [-15.952856972929844, 2.6166205147556982],
            [-15.94805492934658, 2.6207395237322815],
            [-15.947908852380396, 2.6274060747584915],
            [-15.944393732509052, 2.6324730082720214],
            [-15.947016357859548, 2.638626151703592],
            [-15.95501283005284, 2.6430013442015334],
            [-15.956863892053953, 2.6459382440548076],
            [-15.95519449492643, 2.6516246920751465],
            [-15.951121730649078, 2.6497508304693573],
            [-15.947883965695716, 2.6525432631984494],
            [-15.943531382965821, 2.6511619427422195],
            [-15.93487038096181, 2.6561878687352416],
            [-15.928412695372515, 2.6540192384306143],
            [-15.922177335132266, 2.6585837089693602],
            [-15.920077592932307, 2.6651467125462345],
            [-15.913881296046325, 2.666194334750646],
            [-15.910465463317033, 2.6641309622724116],
            [-15.907912750514967, 2.6691745409735135],
            [-15.903809859918374, 2.6718594700059937],
            [-15.898290525811081, 2.6716011630573],
            [-15.89520260900237, 2.674096496473695],
            [-15.895315606259624, 2.6797111458938763],
            [-15.893575661339467, 2.6865527808820024],
            [-15.894250426163472, 2.689399334890132],
            [-15.888111901917528, 2.6888101669179014],
            [-15.875808591257686, 2.6863865720944826],
            [-15.870639066978825, 2.6921268695643574],
            [-15.86296345573905, 2.6900481294245275],
            [-15.85021364012659, 2.689904922068412],
            [-15.840004361144265, 2.6934030259837383],
            [-15.836339131801047, 2.6969447132468045],
            [-15.83195917934386, 2.6888358810060233],
            [-15.825266407957848, 2.6867504667787365],
            [-15.820480697894787, 2.6879276334634246],
            [-15.817813923224966, 2.6903152274189437],
            [-15.816177811121213, 2.697078297246659],
            [-15.80988605021184, 2.698529582165238],
            [-15.809803812736705, 2.703993143614242],
            [-15.805668457567553, 2.706975711339217],
            [-15.802337711369846, 2.7153130456005923],
            [-15.802769985919298, 2.7210228932973095],
            [-15.801470970161402, 2.725569454223532],
            [-15.797750456285799, 2.728865639717735],
            [-15.794478881758886, 2.7343247961913133],
            [-15.794288625100899, 2.7437761628692354],
            [-15.792151761549075, 2.7473222151161067],
            [-15.794679839702017, 2.750284299432211],
            [-15.790255562582292, 2.7545433267045603],
            [-15.788363591388906, 2.7583400684520836],
            [-15.779142534458755, 2.76754995481288],
            [-15.774872351534112, 2.7701730705730254],
            [-15.775561183108566, 2.7725976365608522],
            [-15.773837252950527, 2.780752843873637],
            [-15.77838243959782, 2.782005999897292],
            [-15.78384697658232, 2.7873871068972376],
            [-15.788031095200592, 2.7962856958668376],
            [-15.783720360126678, 2.798074148461266],
            [-15.78016332558567, 2.8019961566460667],
            [-15.778510640431373, 2.809179521719566],
            [-15.773889710293162, 2.810191583407563],
            [-15.773270581646463, 2.8183362305106123],
            [-15.769252440982214, 2.822179372392337],
            [-15.765421794992019, 2.823165217382756],
            [-15.765772295007457, 2.8281134996324786],
            [-15.768385302880196, 2.836171241610265],
            [-15.772491053672224, 2.840115755188828],
            [-15.775074365254842, 2.850340405743866],
            [-15.774792884840341, 2.8546264453924075],
            [-15.772221880873198, 2.857972791273644],
            [-15.77354110942444, 2.8644904412201515],
            [-15.768162785726364, 2.870507078089978],
            [-15.765145708786944, 2.8761330931834594],
            [-15.759406308288892, 2.883724019194232],
            [-15.761880345603656, 2.8899871107867834],
            [-15.765462136168518, 2.8914303332088815],
            [-15.766421249791694, 2.8961045290930696],
            [-15.771522635622873, 2.8994498120467354],
            [-15.769940792819371, 2.902919617924652],
            [-15.769612094711649, 2.9121655985050454],
            [-15.766789789957361, 2.9176278640661018],
            [-15.765382159309812, 2.9247618618705804],
            [-15.760191198988908, 2.928955830184069],
            [-15.755761428768857, 2.9352920327589804],
            [-15.756769300546301, 2.9400743649061023],
            [-15.753979603553956, 2.945742591092503],
            [-15.754043171145094, 2.9549621020277],
            [-15.75213864506638, 2.9581444768872],
            [-15.748406222963904, 2.959769367744393],
            [-15.749605939184033, 2.9667674313628773],
            [-15.748278056506308, 2.975258504434492],
            [-15.744015466995302, 2.977480356955703],
            [-15.743310540628663, 2.9815586937198737],
            [-15.733904119847956, 2.9847767741722477],
            [-15.733296384757141, 2.9887739264891673],
            [-15.728871353224857, 2.993756395464873],
            [-15.730023997226736, 2.997226767995692],
            [-15.723900813284352, 3.002129808717324],
            [-15.723920606575271, 3.0091663281619745],
            [-15.719285336555641, 3.0109983191580576],
            [-15.719493455207138, 3.0151814028180204],
            [-15.715214661791682, 3.029710968315459],
            [-15.716456853545047, 3.0412672480286855],
            [-15.71529158549402, 3.0517540136610957],
            [-15.713000217164836, 3.053916744589799],
            [-15.714757465628862, 3.0618684541973504],
            [-15.713701291200302, 3.066796228600869],
            [-15.715222964752444, 3.0740734698240297],
            [-15.71542883207907, 3.0843575603368554],
            [-15.717708192274788, 3.0890159478435733],
            [-15.720725181543354, 3.088778151738133],
            [-15.723729619609323, 3.095362257833731],
            [-15.729680016947546, 3.099986757511048],
            [-15.732447783752887, 3.105224484249532],
            [-15.73140891742948, 3.107364001357951],
            [-15.73298056619798, 3.112378548480025],
            [-15.73036383251637, 3.1179812430884235],
            [-15.73279716537111, 3.1206087783617367],
            [-15.738777053099545, 3.123741921725541],
            [-15.737783170639965, 3.1307517064599852],
            [-15.739831872184501, 3.1363932966282824],
            [-15.744418865377154, 3.1425157607929073],
            [-15.744883106473567, 3.1462418417412685],
            [-15.748667325148178, 3.155507601036023]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.03811375855868,
          "lat": 39.93353134392293
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32015"],
        "coty_name": ["Lander"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lander County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00863368"
      },
      "bbox": [
        -16.14401133668367, 2.171924003511973, -14.824841840615308,
        4.048955559635738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.317379965521905, 3.815740146186134],
            [16.42283874166788, 3.876309907609685],
            [16.43326195672561, 3.881840705428516],
            [16.435923871444956, 3.880325650512145],
            [16.440508358519544, 3.872228460477291],
            [16.443827730603928, 3.8626044683363645],
            [16.443715679568037, 3.859202621857002],
            [16.450198672762237, 3.860766593568501],
            [16.45930940015454, 3.85533023265579],
            [16.459779802830877, 3.8483941293293817],
            [16.466361972403156, 3.8433891958189723],
            [16.465963876095568, 3.839119063549574],
            [16.471975452731385, 3.8373713724642267],
            [16.476704152046867, 3.8330506858870392],
            [16.47737593977199, 3.8267767458175963],
            [16.47162513168881, 3.8195745100728304],
            [16.47021659074167, 3.8142969336326487],
            [16.470546174316425, 3.8099724901216656],
            [16.474930121191637, 3.8012070346515268],
            [16.472719731904746, 3.7990488831990383],
            [16.473423752898984, 3.794719303388596],
            [16.478787606540482, 3.7831256529930246],
            [16.481575453066434, 3.780565812345638],
            [16.488917770757165, 3.7826697870218826],
            [16.492183781826693, 3.7865383051383894],
            [16.493522636823283, 3.7941233633006255],
            [16.49563293776662, 3.793767285162111],
            [16.499038192783726, 3.7978510324043118],
            [16.501741644793842, 3.7978709971102336],
            [16.50605126730146, 3.803012925179116],
            [16.511973190977184, 3.80542755641027],
            [16.51326819815325, 3.8086552997065857],
            [16.516594253990224, 3.8079938676562537],
            [16.52164771465059, 3.8149161977871215],
            [16.533501967241637, 3.7976527180800983],
            [16.53839617860717, 3.8023976630972482],
            [16.542327395459616, 3.8093071874275046],
            [16.54650288739365, 3.8118226172208667],
            [16.555458168731317, 3.8063979875180007],
            [16.56401248480393, 3.8187165833285532],
            [16.56717931073216, 3.815879391780262],
            [16.56823526464811, 3.8080152925508095],
            [16.566740676292206, 3.795186986062931],
            [16.56326264915391, 3.790569036225695],
            [16.56467144330592, 3.7816021915707805],
            [16.563875327718627, 3.777166821400367],
            [16.560702923966144, 3.7740378967747104],
            [16.561126439394535, 3.7696564609142884],
            [16.558728227441037, 3.7645885093028513],
            [16.556481136375357, 3.7632381168196356],
            [16.552845965944144, 3.75620893262573],
            [16.547674858219388, 3.754357952441574],
            [16.54498929611203, 3.748507660295959],
            [16.54255787299287, 3.747955211730964],
            [16.53683565176253, 3.7416502914238126],
            [16.532046391559984, 3.739676818217895],
            [16.528060126598717, 3.735449604471978],
            [16.52442738447424, 3.7287216512406345],
            [16.511597827454025, 3.7215143979526473],
            [16.506162670306413, 3.719139604620509],
            [16.500351329396395, 3.707506121908342],
            [16.497910311267752, 3.7007282573772553],
            [16.501853264867293, 3.6916458489447272],
            [16.50755096541804, 3.686720617216146],
            [16.510519476782783, 3.679614618199312],
            [16.514716164693223, 3.675237522401357],
            [16.529306674049405, 3.6674845138979584],
            [16.539364060572193, 3.656205918466938],
            [16.5431226880442, 3.6528818103377088],
            [16.554612389642138, 3.652468153470544],
            [16.555929692194514, 3.6466044545601384],
            [16.55989533221076, 3.644713936811135],
            [16.563326055081795, 3.6412158089708493],
            [16.56386161810247, 3.636152545966234],
            [16.558682424257043, 3.630620541943057],
            [16.551785541466526, 3.626010322548246],
            [16.54803512050962, 3.620677719667183],
            [16.542818314216785, 3.6084759705989997],
            [16.53543365733408, 3.5985602946447646],
            [16.533057858291492, 3.5935063011024004],
            [16.528422651470855, 3.586922493090461],
            [16.52529596619764, 3.579565291803021],
            [16.519694976474053, 3.571539653539471],
            [16.508316268335452, 3.5606854712749305],
            [16.49391383400241, 3.5490817006920867],
            [16.488837559334733, 3.5441867411453156],
            [16.4882030579495, 3.5408608887259954],
            [16.491092798787705, 3.5289074812450223],
            [16.491655402049467, 3.5194659091254437],
            [16.48920344246028, 3.5167263543196343],
            [16.487681591036512, 3.509876236767517],
            [16.483858437459368, 3.5038234369108],
            [16.47731237506875, 3.4972035291118426],
            [16.47241952523697, 3.4940083980212235],
            [16.473581728838653, 3.4982510228435366],
            [16.468239779898024, 3.5039903922593476],
            [16.44358907272464, 3.505226266848463],
            [16.432047246000252, 3.4972141896617175],
            [16.43062606562894, 3.495551798878445],
            [16.40665373630385, 3.4848164143903575],
            [16.39713330365718, 3.478359593974744],
            [16.382275080361786, 3.499608878548069],
            [16.366975684789043, 3.522062669578573],
            [16.327492640702243, 3.578813514398622],
            [16.309954715340165, 3.6036244770730463],
            [16.31832923015206, 3.6019603599449708],
            [16.324455166696488, 3.5958943265967878],
            [16.32900627901476, 3.596461122643938],
            [16.341818223750487, 3.6496498184564627],
            [16.348597785097358, 3.6618529249922793],
            [16.352498676834795, 3.6654233446194806],
            [16.356998881935187, 3.6850779986792457],
            [16.34719503956256, 3.687520545979324],
            [16.349418411161704, 3.699279575228044],
            [16.346857565322136, 3.699777498161967],
            [16.35050791051641, 3.7123707439801157],
            [16.351972950613426, 3.7121205001076922],
            [16.35626220321234, 3.7229909076432492],
            [16.348896362159696, 3.725363897758537],
            [16.34637603595374, 3.7305492618100224],
            [16.336241408110983, 3.730098269048759],
            [16.334568283076823, 3.733664590265601],
            [16.33753914710404, 3.7397031712755973],
            [16.334909309960754, 3.744709830089013],
            [16.337003027247608, 3.7503086169324003],
            [16.334863525931617, 3.7536737918381604],
            [16.329635518791275, 3.75564680106784],
            [16.325717318953984, 3.7619224895209897],
            [16.330623246385905, 3.767716882144038],
            [16.32992154737062, 3.7744319297345625],
            [16.33114506268768, 3.782180963401273],
            [16.325742608100544, 3.784926334778335],
            [16.32694463138453, 3.7890586993702695],
            [16.326079597685546, 3.794285139943747],
            [16.32867163952728, 3.7967908519835762],
            [16.327003687385613, 3.80286897767738],
            [16.32451886269366, 3.805231501880094],
            [16.32074445891739, 3.812864211435343],
            [16.317379965521905, 3.815740146186134]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.61641775812454,
          "lat": 40.563422133116575
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34035"],
        "coty_name": ["Somerset"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Somerset County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00882234"
      },
      "bbox": [
        16.309954715340165, 3.478359593974744, 16.56823526464811,
        3.881840705428516
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.120494961309227, 5.6248871933911255],
            [13.159102367578049, 5.6341285355001505],
            [13.209274911768754, 5.643657681172666],
            [13.230585162621482, 5.648148320427943],
            [13.272351027879772, 5.656034652119644],
            [13.369486446243272, 5.675445695634159],
            [13.369627886164492, 5.674575285462698],
            [13.417674119266007, 5.68367267334291],
            [13.45363833702394, 5.692039264702527],
            [13.49494028780689, 5.69989564845236],
            [13.518649892994167, 5.705064349635348],
            [13.51076019142945, 5.649410938790585],
            [13.504338917532953, 5.6065294167729745],
            [13.53830471139825, 5.610500205960469],
            [13.542370737862102, 5.576427295922564],
            [13.541096959916286, 5.5758375032460235],
            [13.543606111477347, 5.5612764965023125],
            [13.550599671988431, 5.5190932736398635],
            [13.534190379957403, 5.516474707799458],
            [13.54113930550658, 5.47670235214393],
            [13.526506996913811, 5.474513389345895],
            [13.535094091006362, 5.4322063338490345],
            [13.505807984685111, 5.427237046119821],
            [13.505484115316595, 5.428883986427003],
            [13.469755475751036, 5.421107643632828],
            [13.449576373487721, 5.417005020601072],
            [13.448371543780244, 5.423250239967782],
            [13.40754477269194, 5.415325504663338],
            [13.373464478185213, 5.409125990344955],
            [13.319929807510881, 5.398627863334074],
            [13.31130444312411, 5.396706566413658],
            [13.282084404829376, 5.391534960837687],
            [13.232132316001666, 5.3809005105624],
            [13.169494554192841, 5.367958978200471],
            [13.163865112855115, 5.400073683253987],
            [13.151440495867503, 5.464536224460969],
            [13.14349765951147, 5.511880905169277],
            [13.137682278233536, 5.539795351889651],
            [13.12861082827151, 5.585765602912019],
            [13.120494961309227, 5.6248871933911255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.19374917895883,
          "lat": 43.000937726265015
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36037"],
        "coty_name": ["Genesee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Genesee County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00974117"
      },
      "bbox": [
        13.120494961309227, 5.367958978200471, 13.550599671988431,
        5.705064349635348
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.088637489592665, -2.345432453477886],
            [14.085047433141952, -2.3955552109226663],
            [14.08835691729209, -2.3963211119456758],
            [14.096443770892712, -2.405366593526553],
            [14.097849178220411, -2.411288374957697],
            [14.10111700030011, -2.418350083600363],
            [14.100470186594668, -2.4203942027042764],
            [14.10328366634536, -2.425913503161981],
            [14.105899496281802, -2.4267000130127623],
            [14.109498981062488, -2.4348618740481287],
            [14.108816155424698, -2.438708339764313],
            [14.111669687235924, -2.4403089998034178],
            [14.113668787893257, -2.4472110779118754],
            [14.112721618680258, -2.453721938468096],
            [14.11483291772474, -2.4582417364264235],
            [14.113299400800498, -2.462105742593683],
            [14.117581216788881, -2.4668447346217355],
            [14.116018613890088, -2.4704794945261757],
            [14.118026977096894, -2.4755162503373787],
            [14.124102370457624, -2.4812790280902948],
            [14.125643654852025, -2.4843140539340736],
            [14.136728060091183, -2.4967487607554375],
            [14.138044583020559, -2.500094286541629],
            [14.146634509630331, -2.5042658936829705],
            [14.152631835201007, -2.5140839376133437],
            [14.159416179484296, -2.519341114832793],
            [14.162481431224094, -2.5258072832482217],
            [14.1625677358083, -2.5297026598281165],
            [14.170221432551623, -2.5397054817497997],
            [14.176543135377422, -2.5459355286703125],
            [14.175195991923605, -2.5566710490925466],
            [14.115951403369579, -2.638741579254562],
            [14.074206495462017, -2.696580192390263],
            [13.947957356367402, -2.7140633248469386],
            [13.947129309973404, -2.709805955841401],
            [13.95317327727061, -2.7009930932217703],
            [13.95378490882004, -2.6975212970460003],
            [13.952399918977031, -2.692465192748203],
            [13.948469398527001, -2.6883892848408615],
            [13.945985837121729, -2.6822332859108475],
            [13.945997394648085, -2.678537150246225],
            [13.938573180297594, -2.665705852333581],
            [13.93890939376409, -2.6642049562950425],
            [13.93579492631592, -2.6544598089790816],
            [13.936464151476795, -2.6519628946804628],
            [13.9324838720747, -2.644763547605583],
            [13.931351689718454, -2.631256627348489],
            [13.927020127725466, -2.6275453735063925],
            [13.924936990685165, -2.6218671445972834],
            [13.926158204956641, -2.6144261618379807],
            [13.923458064442991, -2.6090246804442287],
            [13.91525014487107, -2.601806321101035],
            [13.916495433238282, -2.597843746000842],
            [13.910827798726052, -2.593839914050698],
            [13.903297354589256, -2.586952052476621],
            [13.899356563759255, -2.5823796969381383],
            [13.896477297090394, -2.5820304906387683],
            [13.888196514247847, -2.5738425017050277],
            [13.882027331469772, -2.5689135334703352],
            [13.879920989633478, -2.5657960960909416],
            [13.869525135654577, -2.560767257915999],
            [13.864902033508116, -2.5604459393452585],
            [13.852671961906545, -2.550716851487706],
            [13.849360701719355, -2.5460776850144744],
            [13.840692854449486, -2.5448133329753286],
            [13.833583909805743, -2.541358957741318],
            [13.82650509572682, -2.532147105387233],
            [13.82326534287781, -2.526234069282279],
            [13.84128403243119, -2.4936997238983607],
            [13.858172847106829, -2.4661549680816823],
            [13.869536869319788, -2.4469411530864362],
            [13.881392765952643, -2.4261696146721463],
            [13.883252771859391, -2.4237737429329287],
            [13.901089470012213, -2.3918235965207386],
            [13.9038075789777, -2.3916065039530556],
            [13.909781599912838, -2.3846142131513015],
            [13.918337384541212, -2.3817020686450383],
            [13.91895251287341, -2.3770084820637023],
            [13.929690934063066, -2.363034693937802],
            [13.930558919070876, -2.359112696309199],
            [13.933889666222456, -2.3586064756568152],
            [13.93574059386783, -2.353684777706196],
            [13.941856121336373, -2.349555329140531],
            [13.945789036992972, -2.345213269373182],
            [13.95071773214603, -2.344682238406373],
            [13.954732215807976, -2.3384137757546823],
            [13.957443141286141, -2.3395030391860505],
            [13.96146803956106, -2.3341699340996653],
            [13.963802461708125, -2.328153534831663],
            [13.971196712981062, -2.3290423207655917],
            [13.976662143062546, -2.3281753084274],
            [13.982027686979276, -2.3331091347108144],
            [13.986331462668309, -2.3350653339558853],
            [13.988035702439666, -2.3387522792130166],
            [13.994367281954457, -2.342088050170903],
            [14.004948223799888, -2.3420880841534504],
            [14.012499896002087, -2.338769896767481],
            [14.015651954885305, -2.338723918338686],
            [14.019507602243264, -2.3418868073799985],
            [14.02211059121149, -2.338409426109789],
            [14.025871506535411, -2.3389914019780926],
            [14.026034938973414, -2.343466207326731],
            [14.031539558201219, -2.3487951877586895],
            [14.038166611397818, -2.346042221588028],
            [14.04291777609117, -2.3494759832094023],
            [14.04524184699882, -2.3532600235487084],
            [14.050627379648166, -2.354635460673347],
            [14.053551666451552, -2.3570995303539672],
            [14.057131911908577, -2.354206646720805],
            [14.058023169999016, -2.3489703534140687],
            [14.064697028172931, -2.3524618694695483],
            [14.068282870074553, -2.3569284743302377],
            [14.071284709031222, -2.3511383750563155],
            [14.07795346985031, -2.351567108717994],
            [14.07982953518924, -2.345775725672944],
            [14.082285236050216, -2.345142449051888],
            [14.08648739775712, -2.3481450708010554],
            [14.088637489592665, -2.345432453477886]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.23730525238742, "lat": 35.01754942925426 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37093"],
        "coty_name": ["Hoke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hoke County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01008563"
      },
      "bbox": [
        13.82326534287781, -2.7140633248469386, 14.176543135377422,
        -2.328153534831663
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.026415406597234, 9.272876401201255],
            [-4.01952593529948, 9.26385861138114],
            [-4.01559788547326, 9.255143351805735],
            [-4.007701413394632, 9.248805234216993],
            [-3.9975399723689455, 9.242804470227343],
            [-3.9891880260003285, 9.236143478215379],
            [-3.975204321458151, 9.226544389468282],
            [-3.965592552997889, 9.226183652672397],
            [-3.9571351290039987, 9.22776868941126],
            [-3.947895505120287, 9.227926863333062],
            [-3.936029234158822, 9.224863320410545],
            [-3.9303766017631507, 9.222222465134958],
            [-3.925520853918248, 9.217868157359092],
            [-3.9161174179377634, 9.207609770363534],
            [-3.9072658458570952, 9.203085879074168],
            [-3.8895355765040667, 9.20032458781856],
            [-3.8780642262274374, 9.19238830094321],
            [-3.8720225317777968, 9.191396097674579],
            [-3.865684619831392, 9.192741934212863],
            [-3.8576612000504835, 9.196921766441328],
            [-3.8503347079965344, 9.201838010029501],
            [-3.847514536722415, 9.20538287503766],
            [-3.844833493479328, 9.212864998406879],
            [-3.8369144834228712, 9.227561953544134],
            [-3.8323419965344274, 9.232954556098141],
            [-3.825641823263025, 9.236734114061736],
            [-3.8208877187977954, 9.236813403990078],
            [-3.810191479362087, 9.232475799586842],
            [-3.8025187745977966, 9.227553729385262],
            [-3.790358198049716, 9.221749664338887],
            [-3.778761842323826, 9.218635700243789],
            [-3.7717955844137974, 9.214254145788523],
            [-3.770191329780201, 9.206784344788863],
            [-3.770934073729738, 9.200744536226333],
            [-3.7732594346076533, 9.195396743219513],
            [-3.7777432548391037, 9.191269745059532],
            [-3.781632967970713, 9.189952140693391],
            [-3.790210756688728, 9.191592678726028],
            [-3.7940772247225016, 9.188604736598998],
            [-3.792360954442107, 9.178769472024117],
            [-3.7903343690546807, 9.172547511217726],
            [-3.786708646037086, 9.167890707096419],
            [-3.7768312558906403, 9.16125480614222],
            [-3.7758058525562648, 9.156276710235568],
            [-3.776516229749069, 9.147678707021702],
            [-3.7792079675015486, 9.13282265072367],
            [-3.7801337154387484, 9.111857484010368],
            [-3.782464046567217, 9.101397250206968],
            [-3.783393454519781, 9.093596530531574],
            [-3.782757304821223, 9.08480887990689],
            [-3.78305059139465, 9.071265512613367],
            [-3.7851112413928054, 9.060784866871467],
            [-3.7834982838371287, 9.054389039937103],
            [-3.776977473059297, 9.046099780554254],
            [-3.7637795737722186, 9.033839581670005],
            [-3.760678451930666, 9.029313108416348],
            [-3.757990831201465, 9.022650625521031],
            [-3.7476391521585644, 9.009396989890105],
            [-3.748526027114264, 8.998313406576967],
            [-3.753909950863824, 8.916769631618978],
            [-3.758999838368765, 8.838836026809647],
            [-3.7611112365795476, 8.809980028890502],
            [-3.7637576858335615, 8.767957637448884],
            [-3.7221894170243583, 8.765292603593453],
            [-3.730532384204888, 8.637905211555939],
            [-3.7353102749600957, 8.565958757681887],
            [-3.7428292482037775, 8.453403558675006],
            [-3.8082447080364115, 8.457651040141839],
            [-3.900537225869036, 8.463665397190107],
            [-3.9326723198306204, 8.465945783101445],
            [-4.003049182647883, 8.47051900849918],
            [-4.004958562683662, 8.442076141706929],
            [-4.0661545902460885, 8.44630281722998],
            [-4.068343309226835, 8.446304733304299],
            [-4.1290011353756375, 8.450613271182872],
            [-4.185730821896428, 8.454216199351036],
            [-4.228315034831715, 8.45710112823655],
            [-4.35182004313566, 8.465890052708765],
            [-4.347348586889825, 8.52708640661731],
            [-4.344355621231566, 8.565281883641363],
            [-4.338042681128586, 8.650443401765395],
            [-4.330577765475638, 8.749309242509845],
            [-4.326004154381086, 8.807322017457041],
            [-4.3714363839835215, 8.810693473919356],
            [-4.366968526709062, 8.869877695518895],
            [-4.358318006177118, 8.987007657471247],
            [-4.352558282014741, 9.060340692243189],
            [-4.348319979130482, 9.120933348798358],
            [-4.3461156475918425, 9.149152736982211],
            [-4.239470709575075, 9.141261659969615],
            [-4.132828648728597, 9.133333856971175],
            [-4.037065214748, 9.12655762521445],
            [-4.030656872434183, 9.215196263032317],
            [-4.028102149149367, 9.253905737218561],
            [-4.026415406597234, 9.272876401201255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.61823583361102,
          "lat": 47.356788165161724
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38025"],
        "coty_name": ["Dunn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dunn County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01035623"
      },
      "bbox": [
        -4.3714363839835215, 8.442076141706929, -3.7221894170243583,
        9.272876401201255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2336682121596985, 8.908083027297055],
            [-1.2320984066350733, 8.964372987410211],
            [-1.23150816092532, 8.991626338185013],
            [-1.1615084567732117, 8.989741724625551],
            [-1.1182082919458771, 8.988762648607517],
            [-1.0679355818733374, 8.987397087736644],
            [-1.0013288697753335, 8.986004561956102],
            [-0.9683895421898939, 8.985457563388255],
            [-0.9421453128229267, 8.984716006546826],
            [-0.8817394045715924, 8.983366669891064],
            [-0.885210804648022, 8.84703790017202],
            [-0.8880717641986481, 8.728860026996982],
            [-0.8888552401990555, 8.703818003621176],
            [-0.8894906996329542, 8.671987433491184],
            [-0.890404306280313, 8.643639593229842],
            [-0.8725222566915833, 8.643121080103437],
            [-0.8734380757002733, 8.616194893137017],
            [-0.8749783632469653, 8.558870236076073],
            [-0.9331695321811412, 8.560602026682249],
            [-0.9619648543228019, 8.561644552315599],
            [-1.0347978264654423, 8.562923711337321],
            [-1.048325491076388, 8.563349249228633],
            [-1.1339161354940992, 8.56490987559295],
            [-1.2060382092043305, 8.56668951596509],
            [-1.220202261636613, 8.566902090419916],
            [-1.220437397671179, 8.568089646560944],
            [-1.2186026520927162, 8.623949602948707],
            [-1.2180823324875711, 8.651555493103618],
            [-1.2399102873069174, 8.652126320048104],
            [-1.2386465065195962, 8.709382048434916],
            [-1.237140633435324, 8.76491377585119],
            [-1.2372800499251102, 8.76599330417513],
            [-1.235870555497946, 8.822823563804363],
            [-1.2344746846231474, 8.871189316833094],
            [-1.2336682121596985, 8.908083027297055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.23697542182381, "lat": 47.45725480107727 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38039"],
        "coty_name": ["Griggs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Griggs County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01034219"
      },
      "bbox": [
        -1.2399102873069174, 8.558870236076073, -0.8725222566915833,
        8.991626338185013
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3964782782434475, 9.886204982396574],
            [-2.3090640221143652, 9.882775155732618],
            [-2.243702171511179, 9.879932268967456],
            [-2.178341003524718, 9.87707495628962],
            [-2.0619776258767737, 9.872212625911855],
            [-1.9664897727893187, 9.868723284785045],
            [-1.8727791080664287, 9.865124717044417],
            [-1.8760058541380769, 9.780399167610806],
            [-1.8764232899466458, 9.766372274568452],
            [-1.8791168026380562, 9.698274955268404],
            [-1.878923148640216, 9.695602346343929],
            [-1.966708953954875, 9.6990125554606],
            [-2.0298319869347807, 9.701383745304536],
            [-2.1162983932155064, 9.704889838902035],
            [-2.118068189609393, 9.66310440495282],
            [-2.1226652296506296, 9.560281911686847],
            [-2.1274851783255526, 9.448402758755748],
            [-2.131116867696726, 9.363376123674794],
            [-2.106794086377231, 9.362434909414787],
            [-2.1103070562880686, 9.277132894524685],
            [-2.113746022178763, 9.19203507968168],
            [-2.2006912993094567, 9.195718060834205],
            [-2.2084697570233436, 9.196142971378015],
            [-2.2874961945317276, 9.199321271697954],
            [-2.345709139662123, 9.201836657876548],
            [-2.374433934087187, 9.203272773034133],
            [-2.3692026004600466, 9.31452383058299],
            [-2.3665084578410163, 9.373636513525403],
            [-2.3930995381660747, 9.374810239620256],
            [-2.3912770410056234, 9.417548918172079],
            [-2.38923967908429, 9.459826956666596],
            [-2.388295165869497, 9.488415358130254],
            [-2.385469207716294, 9.545050515711635],
            [-2.3803333650095952, 9.656945192444198],
            [-2.380472794839572, 9.658230784688165],
            [-2.378529569686376, 9.702786182667747],
            [-2.377721888781207, 9.71589813040107],
            [-2.4042021065851586, 9.717155841183246],
            [-2.4002682913622966, 9.80173107104811],
            [-2.3964782782434475, 9.886204982396574]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.97182716961774, "lat": 48.24959087267094 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38069"],
        "coty_name": ["Pierce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pierce County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01034230"
      },
      "bbox": [
        -2.4042021065851586, 9.19203507968168, -1.8727791080664287,
        9.886204982396574
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.08101054975315, 2.9647240067421743],
            [10.15249607767656, 2.9747607903571245],
            [10.273450637837945, 2.991428091213069],
            [10.273155956148113, 2.994723794420237],
            [10.290588097838194, 2.996825172820242],
            [10.315184684298101, 2.999763159828797],
            [10.368354115410158, 3.006697176946734],
            [10.373422858461252, 2.9731962537241285],
            [10.377954900581342, 2.9417676855671213],
            [10.389622065589876, 2.8547420123129177],
            [10.395489980758452, 2.8066462433458526],
            [10.406523228644689, 2.7227566101766967],
            [10.342155372396823, 2.7150650565752987],
            [10.308825313460028, 2.7103487944236933],
            [10.309776421669559, 2.702949807664742],
            [10.249571437525463, 2.6939552157749493],
            [10.235959793492432, 2.6909666766434426],
            [10.153739379747917, 2.679548737270786],
            [10.121642082229432, 2.6749133848684754],
            [10.117045817619632, 2.7064415244308173],
            [10.111454950578596, 2.746966567911671],
            [10.107238680759954, 2.7759083317069893],
            [10.097976923430835, 2.8422529420018265],
            [10.094904965088405, 2.8634119231363675],
            [10.091807870622649, 2.888265520527959],
            [10.08101054975315, 2.9647240067421743]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.9197399989306, "lat": 40.850765881552896 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39033"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01074029"
      },
      "bbox": [
        10.08101054975315, 2.6749133848684754, 10.406523228644689,
        3.006697176946734
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.527164361699567, 1.7303049804820851],
            [9.572795412931153, 1.732061176050331],
            [9.614049254652118, 1.7339438367785178],
            [9.614796039796504, 1.7191800676276219],
            [9.67284137566518, 1.7226463982797942],
            [9.701546653739813, 1.7239107836573233],
            [9.703267765758111, 1.698911040475373],
            [9.751546470171863, 1.6990172031247148],
            [9.772282179879076, 1.6988656756712088],
            [9.772210063376658, 1.6912805193688747],
            [9.788110522804123, 1.6917079089464646],
            [9.821830485600993, 1.6933736597320515],
            [9.843378221764052, 1.694130330227913],
            [9.84405349092339, 1.6920025825454332],
            [9.843537247279883, 1.6873047862399597],
            [9.844318278969144, 1.6799153906180468],
            [9.846743191887985, 1.6352203798954557],
            [9.849269686564762, 1.5882075436103806],
            [9.850712760651843, 1.5557703251805304],
            [9.853092575975834, 1.5158733083676375],
            [9.855754662477834, 1.4668478599767822],
            [9.805742246798285, 1.4644966226758052],
            [9.78257301689907, 1.4631107094403475],
            [9.772932182228416, 1.4629902438479767],
            [9.73176097656928, 1.461141598718395],
            [9.711486194570083, 1.45981425190142],
            [9.662568519588605, 1.4581318354916906],
            [9.62853525670329, 1.4561410165939144],
            [9.620887341491404, 1.4560837630195906],
            [9.551509370060627, 1.4533406408351282],
            [9.515837875623008, 1.4517840547859369],
            [9.513265211225912, 1.5000010540454733],
            [9.511473495662369, 1.5001826158610727],
            [9.510515683197994, 1.5119180559958625],
            [9.508715818415526, 1.5420101430892643],
            [9.508528825865561, 1.5492505920827],
            [9.506287489976469, 1.5809283858989984],
            [9.505108359896122, 1.6029594895182908],
            [9.502758035413356, 1.6554853880747897],
            [9.501469108140697, 1.671227314361396],
            [9.499121037628749, 1.7141922602945532],
            [9.527987828508254, 1.7156621007718595],
            [9.527164361699567, 1.7303049804820851]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.8898685237191, "lat": 39.69150895297663 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39057"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01074041"
      },
      "bbox": [
        9.499121037628749, 1.4517840547859369, 9.855754662477834,
        1.7339438367785178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.226038910625054, 2.415465378993149],
            [10.22207121680395, 2.4665175205337064],
            [10.264829110089114, 2.478662737584969],
            [10.247968987052957, 2.603940169964158],
            [10.243948649704317, 2.632935510836932],
            [10.281661205555016, 2.6390472132223746],
            [10.316845192136048, 2.6442979541325324],
            [10.309776421669559, 2.702949807664742],
            [10.308825313460028, 2.7103487944236933],
            [10.342155372396823, 2.7150650565752987],
            [10.406523228644689, 2.7227566101766967],
            [10.43486512202152, 2.726568807517338],
            [10.434920453507477, 2.726139110855672],
            [10.481173538533628, 2.7314597893762955],
            [10.4880598515907, 2.688390750970517],
            [10.47401097124438, 2.686702496862879],
            [10.47877438593243, 2.657677479653854],
            [10.493187454376253, 2.6597593550559817],
            [10.49466202855126, 2.646794618094476],
            [10.506412102520319, 2.5726791728411764],
            [10.492083345587236, 2.5707869923916427],
            [10.49599504692612, 2.542943840991],
            [10.503064542562111, 2.5449153470383634],
            [10.507811885564161, 2.4848836924762874],
            [10.512272283483744, 2.4388887289013987],
            [10.518270127354198, 2.365880934254554],
            [10.444006666868257, 2.360034418243323],
            [10.350700251599008, 2.3527429697811306],
            [10.3046765562116, 2.3493019953075316],
            [10.300403277877441, 2.4065937762047307],
            [10.263965632182316, 2.4037721049298524],
            [10.263946928292405, 2.403090854602558],
            [10.22712907416624, 2.400444320588033],
            [10.226038910625054, 2.415465378993149]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.79406097178416, "lat": 40.52409692459917 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39117"],
        "coty_name": ["Morrow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morrow County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01074071"
      },
      "bbox": [
        10.22207121680395, 2.3493019953075316, 10.518270127354198,
        2.7314597893762955
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.740484202174706, 3.5070616795644556],
            [8.781456368911766, 3.514066847524448],
            [8.911358406632669, 3.533439038071921],
            [9.010113476421285, 3.5483315363768955],
            [9.038327952764098, 3.5527499668198854],
            [9.04256391737659, 3.5201368393670447],
            [9.050094387129892, 3.4641347839105223],
            [9.06269049687593, 3.465425014258352],
            [9.068492026122179, 3.4208232742626787],
            [9.075746585783783, 3.3628539676233093],
            [9.104254484556213, 3.3665236682483153],
            [9.107889379392262, 3.3379924253845656],
            [9.115211059787132, 3.2801452398856785],
            [9.064793637028037, 3.273860878342282],
            [9.051004969349519, 3.271972427442948],
            [8.915314616744798, 3.255056841918262],
            [8.872798478079853, 3.2498298722893084],
            [8.814531141580344, 3.2423494694019874],
            [8.773873265632165, 3.23743627121384],
            [8.772622713716636, 3.248232722806682],
            [8.761084186934797, 3.34137768602517],
            [8.750720314289447, 3.422653059568212],
            [8.742859185288061, 3.485535006131489],
            [8.740484202174706, 3.5070616795644556]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.58815459908716, "lat": 41.56030735131618 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39171"],
        "coty_name": ["Williams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Williams County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "01074097"
      },
      "bbox": [
        8.740484202174706, 3.23743627121384, 9.115211059787132,
        3.5527499668198854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4787000387152201, -3.4421783304035403],
            [0.4787201409787977, -3.354557004984055],
            [0.5644384612580038, -3.3545912706876897],
            [0.5643703081200316, -3.267032016057394],
            [0.6070899500748811, -3.266901753972686],
            [0.6069788835570818, -3.1782464398086576],
            [0.6951994323806152, -3.1779857730754197],
            [0.8202237174214612, -3.177546224308654],
            [0.9272292430445659, -3.1769444319768514],
            [0.992055684175846, -3.17650343150651],
            [0.9924270112298433, -3.2372957597455527],
            [0.9931009123372915, -3.3240168441738915],
            [0.993881731175526, -3.4370779591375187],
            [0.9883863742924178, -3.439939204981307],
            [0.9869580781387336, -3.428402582764963],
            [0.9849960006913209, -3.4253948271186605],
            [0.9760476473683376, -3.418103560743262],
            [0.9690608193220972, -3.413517344489661],
            [0.9605062016733357, -3.404006024948467],
            [0.954025929809323, -3.402536970265832],
            [0.9471607697377514, -3.403990260711574],
            [0.9399797980968312, -3.4068547624380208],
            [0.9354014541226224, -3.41201888217051],
            [0.9272286151442074, -3.424958490829384],
            [0.922720791976093, -3.4287114393323286],
            [0.9077105230919285, -3.4346178922324575],
            [0.8993088262398312, -3.43770899811705],
            [0.8843905590805513, -3.43225341794185],
            [0.8746668923281021, -3.4298870806593897],
            [0.8679473827489496, -3.4299296835976376],
            [0.86213866992543, -3.433993992814345],
            [0.858626538038134, -3.4418605581243114],
            [0.854840636941004, -3.4460084841218133],
            [0.8528419999200721, -3.450650669559356],
            [0.8540919901599211, -3.455688220098874],
            [0.8576023421052678, -3.4624028354460004],
            [0.856335709907748, -3.4679474698122124],
            [0.8509167897639692, -3.4687804307641974],
            [0.8334836391384113, -3.479438721966719],
            [0.822408964818098, -3.4820012744121245],
            [0.8175801628983113, -3.4850443035048584],
            [0.8097165443107136, -3.4872005260467946],
            [0.7987507296689291, -3.497519204315688],
            [0.7923118418311248, -3.5068101001919687],
            [0.7881818508421075, -3.510096849848952],
            [0.781096038097038, -3.5113818800257417],
            [0.7740235545625848, -3.5104098510111688],
            [0.7694751839544832, -3.5071053969777783],
            [0.7692984035156497, -3.5033807107371606],
            [0.7715577003919396, -3.501357991044817],
            [0.7821466462338715, -3.4965826850237782],
            [0.7848005652951285, -3.4922420857434],
            [0.782663264780055, -3.4844978785420078],
            [0.7792514867992905, -3.4818939712160137],
            [0.7748799318430426, -3.481911740279597],
            [0.7648529905986439, -3.4848715748587566],
            [0.7592858475960664, -3.490028278145138],
            [0.7411057359534892, -3.500466678565638],
            [0.7292977565478348, -3.5046363951124553],
            [0.7221111746282654, -3.51100399287721],
            [0.7206689252223029, -3.515640294429236],
            [0.7225276482088931, -3.5197208273106906],
            [0.727642163792323, -3.523155914056472],
            [0.7229700712253714, -3.5286599379694548],
            [0.7174210574487293, -3.5271339301487217],
            [0.7090485796592841, -3.5291696093329747],
            [0.7009624406877082, -3.5298966498155573],
            [0.6967424572732425, -3.535115712924582],
            [0.6937077298485964, -3.542955670519043],
            [0.6888576235898234, -3.5428662759208844],
            [0.6826733073036658, -3.540276487671936],
            [0.6743864866353391, -3.539534396843976],
            [0.6712285816812363, -3.540472224051851],
            [0.6678977936392356, -3.544675386589331],
            [0.6666534300428901, -3.5487128352759263],
            [0.6614830624803818, -3.5552813353703816],
            [0.6550007465024474, -3.555398351119692],
            [0.6513488184332878, -3.5534944638118486],
            [0.6483393368811436, -3.5487698999767376],
            [0.6403761886160905, -3.5389220560787726],
            [0.6358328198196812, -3.5360126163622776],
            [0.6312131745507533, -3.5351166640924228],
            [0.6223842628447018, -3.536142125214769],
            [0.6150177305194866, -3.5389769563461075],
            [0.6061172823671791, -3.54503461649567],
            [0.5942928372148137, -3.548277219852129],
            [0.5870750153842925, -3.544161303549924],
            [0.5797859195072157, -3.5459848163443506],
            [0.5717629132211689, -3.5452917209493586],
            [0.5685327634040207, -3.54661606263381],
            [0.5654226107322943, -3.552372918769195],
            [0.5581007911616004, -3.5701765179413867],
            [0.5542186732969095, -3.577128582923295],
            [0.5511426989184929, -3.5807563046318664],
            [0.540051400066384, -3.588931433482749],
            [0.5303902552265716, -3.590436327903088],
            [0.5217377271220247, -3.5893429955374176],
            [0.5070461997486672, -3.582907729706111],
            [0.5020197038642714, -3.581500992982475],
            [0.49166392306750206, -3.5803980510034537],
            [0.477457745033723, -3.5812082589736107],
            [0.47740564363454446, -3.5298141936509717],
            [0.47880782257194304, -3.5297041904063327],
            [0.4787000387152201, -3.4421783304035403]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.66681466387672, "lat": 35.37364207127592 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40091"],
        "coty_name": ["McIntosh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McIntosh County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01101836"
      },
      "bbox": [
        0.47740564363454446, -3.590436327903088, 0.993881731175526,
        -3.17650343150651
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.440712719368253, 10.299775218940768],
              [-18.429047591850516, 10.30059197094662],
              [-18.43141121656699, 10.296790362197381],
              [-18.44005664857362, 10.297804724627595],
              [-18.440712719368253, 10.299775218940768]
            ]
          ],
          [
            [
              [-18.35873823281522, 10.290830594694793],
              [-18.351957487623743, 10.290378895057591],
              [-18.335833095244986, 10.29132921582633],
              [-18.32452932178959, 10.292986097378911],
              [-18.310718485997157, 10.287023865553499],
              [-18.304787442652675, 10.280576846296922],
              [-18.294916725782517, 10.262634673861365],
              [-18.287471313530297, 10.239476932807861],
              [-18.30327362249369, 10.195146666464618],
              [-18.283981685397265, 10.161700491580586],
              [-18.27772587283168, 10.156360730088453],
              [-18.273641640270892, 10.150429352111432],
              [-18.26853718470192, 10.148892617148228],
              [-18.274128288418876, 10.130980907211583],
              [-18.28321856518699, 10.104745418009466],
              [-18.287537882945916, 10.089654493966083],
              [-18.301273002978043, 10.048968482227128],
              [-18.296101576467603, 10.047300590064006],
              [-18.30400122874986, 10.020727038448134],
              [-18.32089559388334, 9.966499582633665],
              [-18.321108372377, 9.966422119237382],
              [-18.342028581814425, 9.896496828046262],
              [-18.34576839848173, 9.884537914279257],
              [-18.353054667243143, 9.855936400031348],
              [-18.362450630579797, 9.82943397143582],
              [-18.368638239205044, 9.809349401468424],
              [-18.371116083103416, 9.802602981854275],
              [-18.45363131811737, 9.827190451599398],
              [-18.45484539464507, 9.823063594413215],
              [-18.495646092645202, 9.83442016560051],
              [-18.509825004230464, 9.838953908882818],
              [-18.56169175176444, 9.853342112684361],
              [-18.567763742773774, 9.855628593824736],
              [-18.587714611868783, 9.860120391018157],
              [-18.6015167631537, 9.864265428335633],
              [-18.612692221927304, 9.866896605352517],
              [-18.609671813677082, 9.876423400495012],
              [-18.69215024953546, 9.901182750545512],
              [-18.70664965115966, 9.904707320822226],
              [-18.776251559959864, 9.92577997874028],
              [-18.771082238052795, 9.940067202788365],
              [-18.770432188734954, 9.944468863100967],
              [-18.767419552848516, 9.947147132157742],
              [-18.755567724970675, 9.975156683158346],
              [-18.753100363940675, 9.984806163967809],
              [-18.751901533156364, 9.994323717330506],
              [-18.74845486320845, 10.00057538608888],
              [-18.74440460440529, 10.017925712317053],
              [-18.745548453737726, 10.021182049202894],
              [-18.742289398903406, 10.027981895327764],
              [-18.739144046868507, 10.042935481096032],
              [-18.741038217473488, 10.045971386082147],
              [-18.73976070974329, 10.050866283417689],
              [-18.743348888280263, 10.054849765098979],
              [-18.7399975028361, 10.064521424074805],
              [-18.743191454069763, 10.068072770175801],
              [-18.742880540668796, 10.072007122360652],
              [-18.747085370392984, 10.07719951827687],
              [-18.74484858731414, 10.080284201998529],
              [-18.745326857270772, 10.084472537313985],
              [-18.738631777004166, 10.087329294509676],
              [-18.7300547338736, 10.08987748078741],
              [-18.728491547876377, 10.09511725817131],
              [-18.722950500202646, 10.101123833616748],
              [-18.71304608142312, 10.103644781317978],
              [-18.70913584351144, 10.103650813321481],
              [-18.702306453750808, 10.101666153652932],
              [-18.69892620820277, 10.102349501916473],
              [-18.683215614445064, 10.13080081305419],
              [-18.67479911975358, 10.161579556601586],
              [-18.668896452659794, 10.190308535282835],
              [-18.66545387324696, 10.234920525559183],
              [-18.66580961482979, 10.261243167051385],
              [-18.66787727039096, 10.289693448569826],
              [-18.6727150904894, 10.32724603368778],
              [-18.67606653733394, 10.348277020301683],
              [-18.681507394662578, 10.3566677913328],
              [-18.67372005300222, 10.361257147823581],
              [-18.668246239366066, 10.361140949496493],
              [-18.66560643558469, 10.358389569727514],
              [-18.66489025099711, 10.351368573338078],
              [-18.66076413701231, 10.347439396242642],
              [-18.661348324742065, 10.344517758497412],
              [-18.668275822253356, 10.338715571803048],
              [-18.666587328968582, 10.330787130204289],
              [-18.660945246945744, 10.326741135232664],
              [-18.65438887452464, 10.330691759891003],
              [-18.648332417238006, 10.324000880040636],
              [-18.64339593889795, 10.32175302127116],
              [-18.640474849591595, 10.315814905772122],
              [-18.630012015309166, 10.301822564031449],
              [-18.628014629232684, 10.300173351314292],
              [-18.61872019753242, 10.287252335402284],
              [-18.61734700157248, 10.280332485333993],
              [-18.62033843779606, 10.275437051918885],
              [-18.614281286588902, 10.26981293745164],
              [-18.607596386342237, 10.271692238747251],
              [-18.60478723916089, 10.270182249296829],
              [-18.60362302692607, 10.264431800268026],
              [-18.59193019135838, 10.255337484775941],
              [-18.5864930354347, 10.255121472785438],
              [-18.580442905136245, 10.256873098117975],
              [-18.57709231172329, 10.264996081786927],
              [-18.580423548058835, 10.266491450465766],
              [-18.588681677112653, 10.278004922766383],
              [-18.591048597928122, 10.286190812542266],
              [-18.584260532243714, 10.287337073941968],
              [-18.58304935386902, 10.284626527270403],
              [-18.576035503961236, 10.286867597396435],
              [-18.56053558322916, 10.279820870051596],
              [-18.532506264334145, 10.279972525859463],
              [-18.519440071701545, 10.284023958668671],
              [-18.515701724711352, 10.287808679288117],
              [-18.511338479431934, 10.288535644929283],
              [-18.505105924202418, 10.277423598707623],
              [-18.50019622219914, 10.273199693610009],
              [-18.495026104036214, 10.265335304819512],
              [-18.492036495033037, 10.2582098272479],
              [-18.475377170590534, 10.254134835036359],
              [-18.46018134713756, 10.258254559397473],
              [-18.4569121834771, 10.271845301420253],
              [-18.449511570509042, 10.275636247568771],
              [-18.44615731911039, 10.272667161543206],
              [-18.436000387884995, 10.266472310674601],
              [-18.428105835170708, 10.264147449093745],
              [-18.418967879361766, 10.263649023171537],
              [-18.40461024415412, 10.269099120028216],
              [-18.389990179631447, 10.270720455770872],
              [-18.371152832474323, 10.278406735400173],
              [-18.361945990564212, 10.281433674837894],
              [-18.35873823281522, 10.290830594694793]
            ]
          ],
          [
            [
              [-18.674695685230635, 10.411076465011973],
              [-18.672542233368358, 10.408579770156958],
              [-18.6683765872391, 10.408603874555594],
              [-18.66545066869372, 10.406097229138508],
              [-18.664075172045965, 10.402007760909616],
              [-18.663946394141824, 10.395735836062302],
              [-18.66239975902198, 10.389038350100476],
              [-18.664404008856636, 10.388120883500877],
              [-18.667479032472382, 10.395442130888483],
              [-18.673367124638833, 10.39922351224811],
              [-18.676374222021174, 10.407871601572026],
              [-18.674695685230635, 10.411076465011973]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.65573331006743,
          "lat": 45.99492783163833
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41007"],
        "coty_name": ["Clatsop"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clatsop County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01135846"
      },
      "bbox": [
        -18.776251559959864, 9.802602981854275, -18.26853718470192,
        10.411076465011973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.700741883431625, 3.772836203040504],
            [12.757454834443767, 3.7828998164212186],
            [12.751999205840201, 3.813451682175621],
            [12.749150566862856, 3.832062997739242],
            [12.780147648641005, 3.8376163007612947],
            [12.780813314595632, 3.833845052128735],
            [12.88560530967704, 3.851094866707552],
            [12.891232422063554, 3.8518825610299747],
            [12.895134954192926, 3.8291240368697914],
            [12.907548298637918, 3.753589229770981],
            [12.92409728250083, 3.6574142457466694],
            [12.93348453280058, 3.603278178961672],
            [12.944711074226708, 3.536110678793569],
            [12.950597983984233, 3.5025694715103404],
            [12.948255135363379, 3.502190934666634],
            [12.952731013754558, 3.4740984661394054],
            [12.950237252123157, 3.4716812347566837],
            [12.942357670160956, 3.467483455198362],
            [12.938368300026557, 3.4621927027794888],
            [12.936255329118833, 3.4563945908499427],
            [12.922720658789444, 3.4467418345548295],
            [12.919527618211552, 3.4372277253087953],
            [12.91526237730962, 3.4338023301484952],
            [12.910991187373913, 3.4256318016834677],
            [12.9084861372181, 3.4240976490450388],
            [12.897501021578556, 3.4246677534269776],
            [12.894921105592982, 3.4260199301687115],
            [12.884761446092956, 3.4122256954566117],
            [12.874058963497667, 3.407565913650712],
            [12.868868610629704, 3.409614589092483],
            [12.865789436165668, 3.4047116910009305],
            [12.857713059953955, 3.405397665622142],
            [12.853563323903103, 3.4087197797345343],
            [12.8504390388525, 3.4051395862264875],
            [12.848588029439275, 3.393942261465215],
            [12.84951646996532, 3.386333497129446],
            [12.852361237439904, 3.379933691890469],
            [12.851022309356242, 3.3736122624707474],
            [12.84688424105375, 3.3713264610338896],
            [12.843678633800105, 3.3736753777723756],
            [12.84305057632222, 3.3824534630128715],
            [12.846953351147194, 3.3870864121933826],
            [12.844633916892608, 3.3886234577106404],
            [12.839223201172631, 3.3873871611624757],
            [12.837952825138407, 3.391658578499701],
            [12.843348797488273, 3.393633287685096],
            [12.841347278515025, 3.3977092252022447],
            [12.833754581843841, 3.3946360224726835],
            [12.83031407682778, 3.3954065103201843],
            [12.829109203106695, 3.390402548537523],
            [12.82700479116559, 3.388013163494885],
            [12.82263007387917, 3.3902456906932565],
            [12.823100174763326, 3.395069981724433],
            [12.820888769155767, 3.397652820443795],
            [12.815860518123506, 3.3964252716958594],
            [12.814291637265395, 3.398672652634626],
            [12.817150214430294, 3.4038691058863884],
            [12.814934079503065, 3.4067220109483793],
            [12.809856552739433, 3.4012364575496288],
            [12.81028759723882, 3.396259254109802],
            [12.809259193207227, 3.385787182413895],
            [12.805467425132456, 3.3814286889888447],
            [12.798495555461555, 3.3823025750429494],
            [12.794882088123337, 3.3806804264565553],
            [12.790576466656617, 3.375048090225637],
            [12.784881589414049, 3.374489887917558],
            [12.783205018505093, 3.3782520510979546],
            [12.786362724156547, 3.3809566050772033],
            [12.784674021174624, 3.383695565035817],
            [12.779526631335946, 3.3819317427453246],
            [12.775375153102496, 3.384423784897642],
            [12.770656237751009, 3.3850760948961627],
            [12.766287081430555, 3.383459927266781],
            [12.761053844143438, 3.383870450533945],
            [12.758033430964643, 3.373951721349833],
            [12.760435630220558, 3.368963180841291],
            [12.760307153906307, 3.3658880495644095],
            [12.75320542425197, 3.363155656369901],
            [12.749808764726133, 3.3693346875273704],
            [12.743746472042895, 3.3720930157843423],
            [12.741636139919258, 3.3678774199895702],
            [12.744604781219419, 3.3642884594590012],
            [12.739601908666993, 3.3592574216146422],
            [12.734438811510929, 3.3618856897200433],
            [12.72883612460572, 3.3625929337298412],
            [12.725443320989012, 3.366317824201343],
            [12.72293918878311, 3.3656751502382374],
            [12.716493761369518, 3.360148894253578],
            [12.715295971179778, 3.361893693529387],
            [12.709088405165735, 3.364424083018565],
            [12.700665715255074, 3.3630292294864597],
            [12.695384080296023, 3.3571204628035485],
            [12.691223394345087, 3.3466262684985333],
            [12.688540359996068, 3.344245320566325],
            [12.6824710960808, 3.3434956914514413],
            [12.668990421283732, 3.3461154607976957],
            [12.66381440331618, 3.349919224921823],
            [12.663398448126168, 3.3557883756536406],
            [12.665900522196715, 3.3607187530530584],
            [12.674692362867633, 3.367802410182453],
            [12.681225331049088, 3.3689297479819813],
            [12.68924150398282, 3.3671739934154656],
            [12.691921389917379, 3.3688535500134744],
            [12.6918398661904, 3.374449964468555],
            [12.68836222101413, 3.3776197460724884],
            [12.680566302611211, 3.379751875547063],
            [12.672439281966152, 3.3784095151326485],
            [12.6693385041657, 3.381438133731503],
            [12.669553191629916, 3.386894582964543],
            [12.672525036570187, 3.3944213196894646],
            [12.673313295071132, 3.404214430379442],
            [12.67235710772917, 3.4091993602240174],
            [12.666727263595222, 3.4093071359771723],
            [12.664132259143127, 3.406392702947201],
            [12.657842035190296, 3.4047180636664063],
            [12.644352028440462, 3.4070113302616147],
            [12.632477774870674, 3.412227858480377],
            [12.62381882287538, 3.413054840833095],
            [12.620909658735412, 3.4146050359044997],
            [12.61890195630422, 3.421000232552554],
            [12.619713200481161, 3.4237864955187143],
            [12.625220407895123, 3.4311887388542446],
            [12.625349551612874, 3.4346995758562775],
            [12.621831246020323, 3.4394147281152114],
            [12.61576059744532, 3.4438551929805787],
            [12.607304154877191, 3.4482669246501474],
            [12.602870790049618, 3.4567963800327783],
            [12.599774011880358, 3.4691462512170226],
            [12.59955537711919, 3.479236317650641],
            [12.597564941849617, 3.488379101131679],
            [12.597183310025986, 3.4955114042163093],
            [12.595756169727423, 3.4998020945411272],
            [12.589213874100833, 3.506468547133661],
            [12.58886620697494, 3.510382209784534],
            [12.592047297815007, 3.518277751259042],
            [12.589887474103273, 3.525238661366229],
            [12.582996046528105, 3.5307333332449646],
            [12.578253632593073, 3.5333791222780393],
            [12.573758492133672, 3.5348424541230656],
            [12.572802116461004, 3.541637568091498],
            [12.574570702590751, 3.5447403506124258],
            [12.580224072351738, 3.5424553215979024],
            [12.584044656331733, 3.5458255638545233],
            [12.587611236930401, 3.545575798866654],
            [12.590038852435809, 3.547720875415553],
            [12.594464001101258, 3.5481113230615535],
            [12.597255257028083, 3.553169925448598],
            [12.592683015676595, 3.5566078376459704],
            [12.59512143593328, 3.5604257157844503],
            [12.592930911821878, 3.562685075724428],
            [12.60384634531498, 3.5838130613052748],
            [12.597106205341214, 3.619198503200595],
            [12.609997700735645, 3.6213226914285706],
            [12.607818082274225, 3.6345457685734157],
            [12.611481501674632, 3.635169514501178],
            [12.609827139925569, 3.645375186554986],
            [12.62670371120715, 3.6481942935261253],
            [12.619350023690775, 3.6922581020975955],
            [12.665442194843447, 3.6998082382864346],
            [12.662879225262841, 3.7146196277156003],
            [12.7093597597811, 3.7225006890265853],
            [12.700741883431625, 3.772836203040504]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.42098869176228, "lat": 41.1924047615517 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42031"],
        "coty_name": ["Clarion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarion County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01210234"
      },
      "bbox": [
        12.572802116461004, 3.3434956914514413, 12.952731013754558,
        3.8518825610299747
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.160129992542068, -3.387933995163373],
            [11.16719871684439, -3.377355839045088],
            [11.167980039525133, -3.3762045854421263],
            [11.169312929104624, -3.374069147762224],
            [11.170641871129872, -3.3720063669401608],
            [11.206128136494128, -3.316831745511583],
            [11.253811286063884, -3.2781269873041143],
            [11.362271858416172, -3.1901943198225804],
            [11.42794879802897, -3.1367656878202954],
            [11.43876954091898, -3.1439414964425323],
            [11.442125401137684, -3.149861270117975],
            [11.445649969164005, -3.1516698682192588],
            [11.445188183077532, -3.155536005174561],
            [11.452176803303198, -3.156022578694548],
            [11.451651237093635, -3.1598612740228686],
            [11.45502203614611, -3.1641051907385176],
            [11.455305071462188, -3.1708865438333236],
            [11.45672980549852, -3.173157146013091],
            [11.462216265675034, -3.175168223914939],
            [11.463816816113402, -3.1827076179480325],
            [11.460293975475608, -3.190505971082138],
            [11.46212525970456, -3.1942112950860384],
            [11.46013415752576, -3.19664050966992],
            [11.463433459170021, -3.2011780081556735],
            [11.460142016605273, -3.206487622238228],
            [11.457583098549575, -3.2079127811305455],
            [11.4614134467707, -3.213486915328266],
            [11.45869032849669, -3.216017697990159],
            [11.45963144772419, -3.2280058251052988],
            [11.459263086821483, -3.231719763161494],
            [11.461366780371371, -3.236338828746218],
            [11.46682391432701, -3.2377561230518914],
            [11.465725784909685, -3.243521078743606],
            [11.461343613251387, -3.2440742632000643],
            [11.46415975939539, -3.2509851470159528],
            [11.46936069295945, -3.252360735217778],
            [11.465771378056713, -3.2563842888678005],
            [11.465209623968619, -3.2591433663977836],
            [11.4691729819169, -3.2634439791056313],
            [11.465710502210474, -3.2670129379970416],
            [11.471378917743088, -3.26954188908581],
            [11.472261813627524, -3.2715347214605583],
            [11.471649970324785, -3.279359102407331],
            [11.469510769584513, -3.2811084204662926],
            [11.46650530199328, -3.2876888520646115],
            [11.469994303824034, -3.2920877520740053],
            [11.471632163251252, -3.296840035312805],
            [11.476203952915057, -3.294338663977864],
            [11.47601117223983, -3.3010268463216415],
            [11.478310080290708, -3.302953999915295],
            [11.479472898278942, -3.3080792062712323],
            [11.483736929628124, -3.310857466550187],
            [11.481170955963439, -3.314885817182943],
            [11.483025066401243, -3.3203165554892053],
            [11.483392788224068, -3.3273827311752484],
            [11.488473429822367, -3.3270593747341697],
            [11.486594357302955, -3.3314529396356334],
            [11.491898253862722, -3.334892210705312],
            [11.496606234593035, -3.339608342424367],
            [11.494431853762299, -3.343664055122224],
            [11.499810204460863, -3.34400818052783],
            [11.506829280986164, -3.3493408969532448],
            [11.506046675439316, -3.35326016270056],
            [11.509248337935116, -3.3596762744281414],
            [11.512391379552563, -3.3630655217779615],
            [11.515393042758111, -3.37022996115712],
            [11.512394078579797, -3.3738745689712912],
            [11.518328418495743, -3.3784032522819296],
            [11.520058936893948, -3.383585264777738],
            [11.519860940240902, -3.3899074200917783],
            [11.52679409075941, -3.3977347802952647],
            [11.532918752224015, -3.400326692536619],
            [11.543899103591862, -3.4000742076783683],
            [11.549341812943434, -3.4037666063462857],
            [11.551916159230068, -3.407881915404943],
            [11.562797128069679, -3.416086545565097],
            [11.564638620841626, -3.4193584452759476],
            [11.569126875342148, -3.420701201027495],
            [11.57067708980048, -3.4249880084865025],
            [11.578668780333496, -3.426065949716646],
            [11.587128403016322, -3.430221434629259],
            [11.58944157905161, -3.4379808321025984],
            [11.59310183393279, -3.435583308141468],
            [11.598045334636613, -3.4370682347969552],
            [11.603390060033345, -3.440291502735478],
            [11.605266702002526, -3.4451222998626707],
            [11.61056910831598, -3.444975560718157],
            [11.611810826933132, -3.449344953442997],
            [11.615905478163027, -3.4500782746282046],
            [11.570840113879765, -3.4982166664064374],
            [11.506698378534242, -3.5663543059116574],
            [11.47598414021056, -3.598864674873671],
            [11.408071855626238, -3.6698116379714247],
            [11.39600631961146, -3.6821786120718323],
            [11.349751137460325, -3.7282291061039827],
            [11.307533365848858, -3.7709790156954757],
            [11.307605183405288, -3.7625776130842743],
            [11.30364940684723, -3.7571271284784644],
            [11.305070531434476, -3.753843924270298],
            [11.300495942436278, -3.736866236450866],
            [11.301179321008691, -3.731621610142974],
            [11.298721545084646, -3.7292391028663805],
            [11.297911011059702, -3.7249958208183194],
            [11.294905654871938, -3.7195832259572432],
            [11.296108323199839, -3.7170718234646714],
            [11.288948213374825, -3.7088883052590695],
            [11.282414824193035, -3.704778440280468],
            [11.278148931662674, -3.7036821535893196],
            [11.270970395859075, -3.6979324522205794],
            [11.263157446889332, -3.6896792241766154],
            [11.262564974518565, -3.685195794714443],
            [11.256955899471592, -3.677483489239584],
            [11.250808664550016, -3.662110751628706],
            [11.250882495971023, -3.6577442861072793],
            [11.246739591763847, -3.6486411514427317],
            [11.243269845022358, -3.647780547413907],
            [11.219472134835339, -3.6322982426021575],
            [11.212156254414072, -3.6297220944494573],
            [11.210621458270104, -3.627548823938659],
            [11.207640550146, -3.61312744623914],
            [11.201992694362556, -3.604542131407238],
            [11.200687986305013, -3.5957476584855605],
            [11.194008408538282, -3.5833935412501425],
            [11.193426876269736, -3.576028893283998],
            [11.190346477882672, -3.570058732882106],
            [11.186356126967704, -3.5674236991532147],
            [11.183378397814794, -3.554791672051276],
            [11.178064729955508, -3.544174043525572],
            [11.178776798349693, -3.541657509396616],
            [11.172796062621172, -3.5373082829205935],
            [11.167408619863183, -3.5371722084724815],
            [11.165314813133374, -3.534132862953922],
            [11.158701847659216, -3.529958742103095],
            [11.15867661382625, -3.527517170708627],
            [11.152068499847706, -3.5192166156138533],
            [11.147828830084734, -3.5195693942351576],
            [11.139801362691678, -3.5150188752293046],
            [11.127052113703838, -3.519419709740449],
            [11.120580280957851, -3.5228709181642275],
            [11.116247645382057, -3.5194084092148192],
            [11.11101782676145, -3.5193860174881904],
            [11.105603957151096, -3.521013870753058],
            [11.102862076057702, -3.526494178464703],
            [11.097024164349257, -3.5289151926616102],
            [11.09463197597077, -3.5285816637410603],
            [11.090166762025582, -3.5243123965668746],
            [11.081400380080726, -3.530611302735266],
            [11.076994633041654, -3.5275733490592662],
            [11.067405724664955, -3.5326807407920833],
            [11.074825231423983, -3.5209793600258013],
            [11.12832361598317, -3.437828067920289],
            [11.160288309353316, -3.388099983774641],
            [11.160129992542068, -3.387933995163373]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.63773061429438, "lat": 34.51934959346801 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45007"],
        "coty_name": ["Anderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anderson County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01247981"
      },
      "bbox": [
        11.067405724664955, -3.7709790156954757, 11.615905478163027,
        -3.1367656878202954
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.191283699954452, -4.062100903699664],
            [13.206187665888937, -4.042950165072876],
            [13.216072967670115, -4.027075603485204],
            [13.218177962401349, -4.006891447578966],
            [13.224929195647672, -3.9849454208240296],
            [13.244825286773027, -3.982428003370703],
            [13.24508151759738, -3.9579383822740195],
            [13.259915437872646, -3.9547014009632],
            [13.266315823862433, -3.9681246812021884],
            [13.261110075047306, -3.9719489402231454],
            [13.261401893379693, -3.9813601382875814],
            [13.295364772366119, -3.9720257853910077],
            [13.294080854700782, -3.9650522990028105],
            [13.286144522948575, -3.9416547487080273],
            [13.282582190497491, -3.9208963968830006],
            [13.300204693296422, -3.9145458630162167],
            [13.38201556743354, -3.8856181369585276],
            [13.391590685256897, -3.866234756634438],
            [13.434956014389126, -3.823039192405465],
            [13.451447681558959, -3.8085164397782494],
            [13.478668527129544, -3.785346928723596],
            [13.489807212302924, -3.782668143819781],
            [13.504551618882278, -3.7677899289356036],
            [13.536588642865473, -3.736758412298193],
            [13.57725257882279, -3.7008909302411337],
            [13.596256744312523, -3.6861858528899134],
            [13.623194876176699, -3.7349212569703987],
            [13.629765584674866, -3.742219787301343],
            [13.632838716047353, -3.7427349246272628],
            [13.637133198871904, -3.740756585916245],
            [13.664596913833307, -3.733157318832477],
            [13.668852296967236, -3.732696210280562],
            [13.687016729992465, -3.7332222774691495],
            [13.666083368205367, -3.804713233638333],
            [13.652952705733284, -3.8150132584950955],
            [13.64377298995716, -3.8171133334884617],
            [13.615183184616338, -3.8587519695451107],
            [13.60933835739692, -3.866097790374442],
            [13.634460945058004, -3.909048129980555],
            [13.63155716610144, -3.91168186590622],
            [13.631340650940661, -3.914846985286529],
            [13.627751149846095, -3.9219259404373],
            [13.627390704332607, -3.924789182899174],
            [13.622007460110057, -3.928624839280878],
            [13.619095677579368, -3.9459628125527124],
            [13.60938128508075, -3.9905436483232517],
            [13.606176529699196, -4.001045465976224],
            [13.59279056788512, -4.057764837325016],
            [13.58308057787937, -4.09344126240494],
            [13.56848550332258, -4.149164379160016],
            [13.562075745598946, -4.1471543434205085],
            [13.558842062779005, -4.148859732130764],
            [13.548079838475154, -4.146951514367803],
            [13.546752373173268, -4.149486734328373],
            [13.548195733676632, -4.156262526526361],
            [13.542237761346936, -4.1583303547708965],
            [13.541502261124494, -4.162577710796449],
            [13.534929915055262, -4.167367499100315],
            [13.531334756613123, -4.165644062226608],
            [13.530431935533295, -4.174219958482148],
            [13.53431567006549, -4.178203712738845],
            [13.539853581106769, -4.181314724072025],
            [13.546371132435889, -4.183622235732284],
            [13.549539381257096, -4.186456626865281],
            [13.54718313416188, -4.189219369096816],
            [13.543553976040071, -4.185774921682675],
            [13.539223736317085, -4.187475857229367],
            [13.54354124598387, -4.1905695898055635],
            [13.545817942298362, -4.195179184127083],
            [13.542670936695025, -4.19650114505772],
            [13.540254142707052, -4.193165584929809],
            [13.534615716264103, -4.192161131016451],
            [13.53419808687051, -4.1956457725968574],
            [13.537147170198573, -4.196914473779667],
            [13.538284499519065, -4.202133977810411],
            [13.533951921721709, -4.2048378349688935],
            [13.527688527762516, -4.2048490868172035],
            [13.528906285812834, -4.198344450611227],
            [13.524691129110423, -4.1933835575141245],
            [13.523573017699157, -4.198815476092538],
            [13.520116738604381, -4.205312405624947],
            [13.51612132863248, -4.207127711320336],
            [13.514138905163941, -4.202862399297928],
            [13.510756198449018, -4.201899748987711],
            [13.507573759091269, -4.206770701706092],
            [13.504337388907699, -4.208593652806891],
            [13.500726272567222, -4.213737521430858],
            [13.496601239851651, -4.2132324850442435],
            [13.498198032922868, -4.20818568161978],
            [13.495090066540463, -4.206252851413898],
            [13.489584469740228, -4.207542501979764],
            [13.49199548312274, -4.217932298082522],
            [13.4854074471728, -4.216656475307423],
            [13.480904646396915, -4.2139320208792155],
            [13.478867326675976, -4.218349282877989],
            [13.472952135197398, -4.218485239452239],
            [13.468395020043856, -4.224253449237168],
            [13.46475059266927, -4.222760357777749],
            [13.465920159848327, -4.217943792969546],
            [13.464038046847952, -4.213652843628038],
            [13.460622535615848, -4.215884481478718],
            [13.456096305857569, -4.215481993202941],
            [13.450733710935115, -4.218684408277059],
            [13.44976850983192, -4.223567323703509],
            [13.442559416838153, -4.2303773755963014],
            [13.438600739032767, -4.230701840820318],
            [13.43386437683938, -4.222586549690394],
            [13.427475853630481, -4.22305749276548],
            [13.42281638571862, -4.230686235222228],
            [13.413130857512806, -4.23293300324765],
            [13.405932007388461, -4.237810240836926],
            [13.39814078373126, -4.244574511867897],
            [13.392188137627503, -4.245236650402932],
            [13.372942927755423, -4.249520515608651],
            [13.364876077427756, -4.248484817854052],
            [13.356631649854227, -4.243601703576817],
            [13.347767186403175, -4.242383872894719],
            [13.33827930556152, -4.239538796525821],
            [13.33432164173006, -4.235297857637137],
            [13.32606297526373, -4.231145049830236],
            [13.313701221372641, -4.222799050944093],
            [13.297730083670045, -4.213543817683073],
            [13.296991323017679, -4.211324507665277],
            [13.298504962328897, -4.202847705745915],
            [13.291101495191338, -4.196824399105166],
            [13.293371697090182, -4.191664271542281],
            [13.289261964207679, -4.18961949851055],
            [13.280968774995214, -4.192174025012889],
            [13.274785434967445, -4.191943740403887],
            [13.273563365024204, -4.188898841636701],
            [13.276709943569955, -4.183559378260807],
            [13.273521463488196, -4.180467520264534],
            [13.266327193250325, -4.179836088319825],
            [13.264661622013515, -4.172903350900304],
            [13.265066562682389, -4.169587615788646],
            [13.269185199237821, -4.168963075163343],
            [13.277257189396838, -4.1708218082837725],
            [13.281632602030744, -4.168797440183994],
            [13.278541980779758, -4.162256058665265],
            [13.280202540273274, -4.157787599833922],
            [13.278903298666878, -4.153015521165891],
            [13.274418925306044, -4.148211999161173],
            [13.269738256081475, -4.14890609528743],
            [13.267675059775254, -4.154552244508582],
            [13.261692174543516, -4.155251353200415],
            [13.259304197237814, -4.153004507578632],
            [13.25466117712337, -4.144369112273614],
            [13.250802458257684, -4.143568026213924],
            [13.245029511899288, -4.138660271647732],
            [13.239834591441904, -4.142335229260481],
            [13.236096950257403, -4.141721240301614],
            [13.232554602793584, -4.138218721502391],
            [13.227222454649027, -4.137340766685276],
            [13.227877067519374, -4.131354789273825],
            [13.217964790891635, -4.128180946830025],
            [13.217128145059002, -4.121659748853171],
            [13.223990075236365, -4.118212376712939],
            [13.227042874677979, -4.113015507371942],
            [13.22491274010782, -4.109818346460777],
            [13.2156395247133, -4.108863643067236],
            [13.210537124641865, -4.106328557716099],
            [13.20812263307489, -4.100626536989579],
            [13.208630880289556, -4.092189464392831],
            [13.205963613227016, -4.087571136894115],
            [13.19639396954686, -4.084026473532931],
            [13.188756852490993, -4.078690352620692],
            [13.188570439383591, -4.07475667608415],
            [13.196730966626797, -4.07057693598703],
            [13.196393426268852, -4.066120170326517],
            [13.191283699954452, -4.062100903699664]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.21644906902993, "lat": 33.6657900687386 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45027"],
        "coty_name": ["Clarendon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarendon County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01247990"
      },
      "bbox": [
        13.188570439383591, -4.249520515608651, 13.687016729992465,
        -3.6861858528899134
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.711368907281353, 7.396739336652239],
            [-3.7100150584209572, 7.396696546065375],
            [-3.6926602576254783, 7.395510461806366],
            [-3.6322610901108305, 7.39187051455847],
            [-3.5186905342781314, 7.384613697899198],
            [-3.4897908933178377, 7.383147042064744],
            [-3.4032511819377156, 7.377725449026281],
            [-3.3077762512846918, 7.371917131451024],
            [-3.2756882441447304, 7.370606226520126],
            [-3.269799144476527, 7.370104289208464],
            [-3.2046161090073326, 7.366599216246891],
            [-3.157543761555933, 7.363712462665464],
            [-3.0863194000679575, 7.359825710550389],
            [-3.00243027914852, 7.355633974698778],
            [-2.9710810498659743, 7.353702090031181],
            [-2.939504315277773, 7.352184994459921],
            [-2.855772367438791, 7.347866974715406],
            [-2.842326966615436, 7.347082519050814],
            [-2.821765448063919, 7.346437504185863],
            [-2.7569840002418537, 7.342896277174465],
            [-2.676498798160559, 7.339067090584871],
            [-2.6677404638797215, 7.338632826211404],
            [-2.6609487410618513, 7.325073259485896],
            [-2.6492715775646887, 7.316095067362438],
            [-2.643184512701732, 7.313625241212146],
            [-2.6225767870976355, 7.290612949967748],
            [-2.6135910159515, 7.276974615048475],
            [-2.601908173809942, 7.267545740641487],
            [-2.5930582851650623, 7.261285906596844],
            [-2.589108088763392, 7.250228450009118],
            [-2.591214431081528, 7.2309153325866085],
            [-2.59076800598506, 7.2222451176417515],
            [-2.587500000477496, 7.208258998490581],
            [-2.5820201459680323, 7.194172181257756],
            [-2.5734068308379903, 7.167842694882679],
            [-2.572561108664993, 7.163807583345371],
            [-2.5636922985308006, 7.1416836173725855],
            [-2.551819223779205, 7.115853350971529],
            [-2.546035479882162, 7.0990774887207175],
            [-2.545755162982941, 7.092433004743282],
            [-2.546745735446948, 7.081032146255124],
            [-2.5537174707177153, 7.065289014101349],
            [-2.5575550347063394, 7.061936249059863],
            [-2.5678077265847246, 7.055718306961918],
            [-2.5796394767485267, 7.053608176736934],
            [-2.597948645004714, 7.054673077703608],
            [-2.606539901403679, 7.05239256984941],
            [-2.6167159150608694, 7.044873028037112],
            [-2.6217683382300594, 7.036516299124511],
            [-2.62461119662977, 7.0299833112312875],
            [-2.6271979702894197, 7.020334544814711],
            [-2.6300387971485994, 7.020449923304582],
            [-2.6301236791381366, 7.011850267644779],
            [-2.633092842787463, 6.999396397380283],
            [-2.635801509050796, 6.990939108927378],
            [-2.6390739070129046, 6.982040750570383],
            [-2.6440520451291607, 6.975557901386664],
            [-2.6540526073805415, 6.967307877248289],
            [-2.662755116183559, 6.963352004766758],
            [-2.6691620997786956, 6.957344298200137],
            [-2.676614961864849, 6.94552956669082],
            [-2.6780410793489153, 6.934982107868289],
            [-2.673395216728207, 6.923418159933384],
            [-2.6686825818555793, 6.9180013559311915],
            [-2.660569359950217, 6.911951129842158],
            [-2.649477792439443, 6.907152714057859],
            [-2.6332473892847563, 6.906218890777743],
            [-2.6254557609189764, 6.905035450254551],
            [-2.6193597104963446, 6.905624312422593],
            [-2.6127823077783523, 6.907559053921465],
            [-2.606157414744373, 6.905936539634893],
            [-2.594829111251102, 6.894948035352337],
            [-2.5832908513819497, 6.87573810004727],
            [-2.579733710152209, 6.867222669202534],
            [-2.6965109251050583, 6.872490560797008],
            [-2.7044625210256394, 6.872985089943086],
            [-2.763932152716998, 6.875567037259723],
            [-2.778408860923284, 6.87640765569231],
            [-2.851900030515733, 6.879855621242165],
            [-2.93842136253121, 6.8842192552416455],
            [-3.0246357561132053, 6.888705677459659],
            [-3.1106983557333834, 6.89307740554307],
            [-3.1684342444852294, 6.896186983212411],
            [-3.250726905462213, 6.900837037744716],
            [-3.3035324647034146, 6.903479990486641],
            [-3.312492027581508, 6.9042914654224985],
            [-3.3698371422775337, 6.907263593761311],
            [-3.4779634413510596, 6.913501086932311],
            [-3.478549516197504, 6.913367483019869],
            [-3.5426470418079603, 6.917574674452958],
            [-3.6301378368600954, 6.922959220598118],
            [-3.74051619826766, 6.929492745121944],
            [-3.736754875442421, 6.995105695433592],
            [-3.729988337314905, 7.102510512525502],
            [-3.7249019443099405, 7.186561729985568],
            [-3.719245801405611, 7.272551184432113],
            [-3.711690215192598, 7.3869502931735935],
            [-3.711368907281353, 7.396739336652239]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.1968918756872, "lat": 45.70859651874879 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46031"],
        "coty_name": ["Corson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Corson County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01265811"
      },
      "bbox": [
        -3.74051619826766, 6.867222669202534, -2.545755162982941,
        7.396739336652239
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.206302135525127, 5.202192010289855],
            [-1.1964310791499095, 5.202112192983285],
            [-1.1245998151486667, 5.2004117422285825],
            [-1.107462892535842, 5.199868699642663],
            [-1.0426704797027546, 5.198415901090338],
            [-0.9492526781599879, 5.196038221207237],
            [-0.9505407572876144, 5.157068867358845],
            [-0.9517779071158636, 5.106874951570417],
            [-0.9523032990340162, 5.018867761921661],
            [-0.9533868215376347, 4.960628957507156],
            [-0.9539180369520022, 4.94602247477097],
            [-0.9546182432456073, 4.844263983951895],
            [-1.0630362365481956, 4.845837743351931],
            [-1.1260917065490845, 4.846883342282855],
            [-1.1485808243610185, 4.847476400167083],
            [-1.1759483640393575, 4.848800642530865],
            [-1.2116059589971635, 4.849647063324724],
            [-1.2127570037507955, 4.9222816237643645],
            [-1.2127874261273015, 4.937669234838028],
            [-1.2116269002948021, 4.998297451293386],
            [-1.2113908082371976, 5.018112031384628],
            [-1.2107299829511302, 5.03925983845392],
            [-1.207662515390046, 5.156101318319721],
            [-1.206302135525127, 5.202192010289855]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.14594330439617,
          "lat": 43.674730134330765
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46035"],
        "coty_name": ["Davison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Davison County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01266980"
      },
      "bbox": [
        -1.2127874261273015, 4.844263983951895, -0.9492526781599879,
        5.202192010289855
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.16273378050911194, 6.1362362943478574],
            [-0.16174121965720442, 6.221481543521579],
            [-0.1605997743767967, 6.221456059145838],
            [-0.159576208231738, 6.292968424079484],
            [-0.1595546895593315, 6.307906097956241],
            [-0.08549854114155403, 6.307215556493136],
            [-0.07348270912567254, 6.306336574860316],
            [-0.011820369423757476, 6.307087633606972],
            [0.01258956593852213, 6.3064583495159034],
            [0.09857424982958399, 6.306134868767806],
            [0.14437863134846396, 6.306406001010821],
            [0.144128184502302, 6.29171604711663],
            [0.14402095321926459, 6.219385494050882],
            [0.14393666878913922, 6.135222060587276],
            [0.14367817571378366, 6.120183490717247],
            [0.14375387910343237, 6.048353927362706],
            [0.14346078745774446, 6.033168875305303],
            [0.1429645558598693, 5.961624931681519],
            [0.14238337826987982, 5.874179796273672],
            [0.007077163200423631, 5.875192207281341],
            [-0.10257406602138787, 5.875887218358233],
            [-0.16582891966018373, 5.876470943599713],
            [-0.16478583540912883, 5.96303851650946],
            [-0.1646079517731737, 5.9664141755023365],
            [-0.16308731522945033, 6.092940447885176],
            [-0.16273378050911194, 6.1362362943478574]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.66800994951663,
          "lat": 44.760035575517314
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46039"],
        "coty_name": ["Deuel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Deuel County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01265781"
      },
      "bbox": [
        -0.16582891966018373, 5.874179796273672, 0.14437863134846396,
        6.307906097956241
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5153966624400792, 5.532516364493792],
            [-0.4590178949796986, 5.5326903545331225],
            [-0.4297521539615489, 5.532389741854894],
            [-0.3435636408875566, 5.5312277222810335],
            [-0.32943586247005296, 5.5309461981303505],
            [-0.20782959155109476, 5.529491231792207],
            [-0.17173364388277276, 5.529183483486715],
            [-0.17185852888051453, 5.471835387667398],
            [-0.17282678120844855, 5.370649679908732],
            [-0.17375614097883477, 5.290015689368406],
            [-0.17459829422942214, 5.182145452915877],
            [-0.2610172480138157, 5.182831688659075],
            [-0.3472962035510943, 5.183559226879242],
            [-0.4766320072091909, 5.18571949709734],
            [-0.5199404252475279, 5.186372321337153],
            [-0.5189129153089593, 5.273248647735008],
            [-0.5182929205375011, 5.331333850036943],
            [-0.5177998188160838, 5.360539473691144],
            [-0.5167972515245971, 5.447373605190193],
            [-0.5153966624400792, 5.532516364493792]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.12935415081536, "lat": 44.02205451781155 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46079"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01265776"
      },
      "bbox": [
        -0.5199404252475279, 5.182145452915877, -0.17173364388277276,
        5.5326903545331225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.992097044328535, -1.5293450901225556],
            [10.037191810386462, -1.5255343917339652],
            [10.066016700615357, -1.5230843089475943],
            [10.14950207560028, -1.5149952555041868],
            [10.227210902968636, -1.506241698774407],
            [10.23203156845394, -1.4958425805519433],
            [10.234543812597874, -1.4935815167170696],
            [10.236917153213385, -1.486451159722707],
            [10.260524333502422, -1.4841658452728408],
            [10.278884219063809, -1.483739912479101],
            [10.330865606035923, -1.477605008158624],
            [10.397657237127389, -1.4688847186126797],
            [10.432001076784191, -1.488948830151651],
            [10.449168667004749, -1.506836171684971],
            [10.464166060505965, -1.5235711140645178],
            [10.477443960876522, -1.548612895328039],
            [10.480334739763505, -1.5568443036910464],
            [10.488859073711772, -1.5742080557807607],
            [10.490467258011671, -1.579752618545753],
            [10.497092733678368, -1.5962452132843856],
            [10.498266476096275, -1.6088693292380265],
            [10.498748268384826, -1.6217618676043695],
            [10.497964192328585, -1.62496659442929],
            [10.494437811903845, -1.6262448998440913],
            [10.495337300242443, -1.6343291770342085],
            [10.487961036850885, -1.638686501654636],
            [10.489497305971934, -1.6440897671862233],
            [10.483935862715333, -1.6427946428474953],
            [10.47540107764551, -1.643287007074108],
            [10.467727716490456, -1.6394584309433347],
            [10.46493690574119, -1.6430712334268294],
            [10.468002924286129, -1.646954831666428],
            [10.465818420198687, -1.6491024382920485],
            [10.45795924643081, -1.643405240207617],
            [10.455063040666609, -1.6446048038382366],
            [10.457318664500194, -1.652131872777896],
            [10.45592526671657, -1.6542197185490712],
            [10.448202718517106, -1.6499264873122597],
            [10.446539978564568, -1.652294232520886],
            [10.447825968334984, -1.6609376202789379],
            [10.443063621545074, -1.6668633019068109],
            [10.439835449828564, -1.666782915067753],
            [10.43706357815317, -1.662264869082006],
            [10.43399241402096, -1.663419510241089],
            [10.436727521212411, -1.6682132822638014],
            [10.441090318960335, -1.6695682571580692],
            [10.443350122498142, -1.676156378372526],
            [10.440243555574972, -1.678332764789377],
            [10.434838094723727, -1.6757927639640433],
            [10.445356928997674, -1.6895632714252022],
            [10.432749706776173, -1.696427110581655],
            [10.424903449540137, -1.6918688741224064],
            [10.421948371765438, -1.6883925327684168],
            [10.418243793824967, -1.687763521010867],
            [10.414832509167613, -1.6905561493915509],
            [10.410087199528528, -1.6893520058232439],
            [10.406411281653567, -1.6907552902706309],
            [10.406584519280928, -1.6938876070601672],
            [10.410252070086976, -1.6997119452215126],
            [10.411151126122311, -1.7040713802863274],
            [10.406460153102728, -1.7069309420427088],
            [10.402833062091574, -1.702627812991711],
            [10.400286488772739, -1.6973664997525937],
            [10.396307101411747, -1.6995207508411962],
            [10.393448762929774, -1.705903177741104],
            [10.393096761589117, -1.7141936002876976],
            [10.387229159401056, -1.7124236657646177],
            [10.385487979288083, -1.7083788196932717],
            [10.380702874515443, -1.7074833724674863],
            [10.382682296836236, -1.7169927130491356],
            [10.378622480893197, -1.7203776874749066],
            [10.37204359525188, -1.715647167031685],
            [10.365570176813556, -1.706221749243001],
            [10.365174997421137, -1.7123811473886932],
            [10.360429455279402, -1.7117835216218171],
            [10.359454260468889, -1.7074339068218356],
            [10.35655556072644, -1.703744443060609],
            [10.3516653721288, -1.7063212829893721],
            [10.351849132480847, -1.7113856314007267],
            [10.348197438028516, -1.7135957591214068],
            [10.344480252787232, -1.7134736135362756],
            [10.338666892009103, -1.7096576190226562],
            [10.334607461364833, -1.709377442447369],
            [10.33158821360077, -1.7115037170354017],
            [10.331756096096628, -1.7195212040670056],
            [10.330489376920205, -1.7221297540418234],
            [10.323355704934068, -1.7254057758476575],
            [10.321086794845598, -1.72773840805502],
            [10.31816807597074, -1.7355494435757806],
            [10.309515798038676, -1.7395315929038864],
            [10.305106782060946, -1.7445858360420727],
            [10.299236084009275, -1.7476939141179724],
            [10.293384493254939, -1.7447964111827716],
            [10.289030604712593, -1.7471966966184063],
            [10.288366017568809, -1.7519641867151476],
            [10.285133223240413, -1.753709009868831],
            [10.2819831081758, -1.7523902988338909],
            [10.281013928305565, -1.7462080467708314],
            [10.27670732875663, -1.7421919700863713],
            [10.266804699759616, -1.7328996484297785],
            [10.263142110876505, -1.7307323021811931],
            [10.256197845929703, -1.7286858139169814],
            [10.252117583163992, -1.7245363194340395],
            [10.246866849232912, -1.7274579472991185],
            [10.24427153327355, -1.7347144084440667],
            [10.241894770993843, -1.744892929466063],
            [10.23986038720154, -1.74719223191766],
            [10.23388346771988, -1.7494947625283055],
            [10.224678349414031, -1.7482862629842624],
            [10.219047833893041, -1.7414182784056709],
            [10.215702939444077, -1.7413401496667378],
            [10.21210305993428, -1.7354314559453816],
            [10.21419395196715, -1.7331194957557796],
            [10.212775508757458, -1.728832695044446],
            [10.213276214486557, -1.7247621073489061],
            [10.208266599706453, -1.7225522604364216],
            [10.206176499018623, -1.7149988581334488],
            [10.202740601955322, -1.7116152180066115],
            [10.199644422574861, -1.7119805032437607],
            [10.198061339906973, -1.705912889150423],
            [10.192143484489305, -1.7005750896022607],
            [10.191425477270403, -1.6975139025776642],
            [10.183727949881243, -1.6927099931181064],
            [10.179348075214886, -1.6925476238098145],
            [10.177372031294897, -1.6895634502750054],
            [10.173505269917413, -1.6901657093917306],
            [10.166732250963781, -1.6863539228577908],
            [10.1655660225655, -1.6829383818277766],
            [10.168094486016043, -1.679452905071661],
            [10.16736306222134, -1.6762864627602803],
            [10.163037543177802, -1.6758262937734794],
            [10.161267413078583, -1.6820666141785932],
            [10.15852014727341, -1.6842645140393648],
            [10.155452521505214, -1.6785556218363866],
            [10.16176468987916, -1.6720439344796842],
            [10.159958710366453, -1.6673932805656162],
            [10.155605311332216, -1.6648007757856655],
            [10.150403295093886, -1.669948059342696],
            [10.14496832159375, -1.6732935596017173],
            [10.13574860086551, -1.683865798029642],
            [10.134295079997418, -1.6809599892175908],
            [10.129159540699328, -1.6768002004735452],
            [10.119944966681938, -1.6774279922797433],
            [10.116885924731264, -1.6742601769392162],
            [10.111730611643477, -1.6716665759709044],
            [10.104604469939789, -1.6762433511781607],
            [10.100175488723336, -1.677421669448305],
            [10.101007399249182, -1.6807738999967623],
            [10.09485194944998, -1.6874163531136745],
            [10.09073218916971, -1.6852441246039114],
            [10.08796297797339, -1.6899730301603901],
            [10.078498850813013, -1.6908787830430922],
            [10.082711567327612, -1.687114127442686],
            [10.079688455855237, -1.6830970797610765],
            [10.07600485085273, -1.6819405421455413],
            [10.073121968838583, -1.685157466207048],
            [10.068275823339295, -1.6849629594248912],
            [10.064321583021666, -1.6831080249845387],
            [10.061753956102127, -1.6758492178357407],
            [10.058420323590951, -1.671979965269516],
            [10.052355132653025, -1.660343459478215],
            [10.054748284533241, -1.6576983594981776],
            [10.05389428258455, -1.6533517116683003],
            [10.049029095552253, -1.653807675671466],
            [10.02351299637716, -1.6074012301887313],
            [10.002953305682473, -1.5675185270789],
            [10.004000718953934, -1.5624159331069079],
            [9.998053739661977, -1.5574362234017218],
            [9.997870275831472, -1.5482479405963465],
            [9.996232551865472, -1.5437683085411003],
            [9.996680336613615, -1.5331141259528958],
            [9.992097044328535, -1.5293450901225556]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.66045003248438, "lat": 36.48581580297498 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47025"],
        "coty_name": ["Claiborne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Claiborne County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01639733"
      },
      "bbox": [
        9.992097044328535, -1.753709009868831, 10.498748268384826,
        -1.4688847186126797
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.036786247181812, -2.8333170047803873],
            [6.041900677145121, -2.834999114568921],
            [6.040640226753176, -2.838716921175084],
            [6.044159538154895, -2.8429122892101293],
            [6.057630162046929, -2.8462087477046607],
            [6.065605283854306, -2.845729497489395],
            [6.0667311796528445, -2.8485936556027593],
            [6.07176486960096, -2.8483516694989053],
            [6.072635278846739, -2.850570578464047],
            [6.077385990104914, -2.8522053648476917],
            [6.1354992057994275, -2.7777690832743898],
            [6.171667862303357, -2.731213991513338],
            [6.164634959877523, -2.7283486780528756],
            [6.161170764153759, -2.7251131426041613],
            [6.155791046253759, -2.7255855745134454],
            [6.152023424599, -2.7190709766818775],
            [6.17506695477562, -2.7183312721667177],
            [6.277067536878686, -2.714636309408578],
            [6.320303593900206, -2.7126332358572776],
            [6.370109411206562, -2.7096835163084387],
            [6.400538570855934, -2.7081687631485543],
            [6.4050719576809865, -2.78770495911149],
            [6.408635976625451, -2.8520353154050295],
            [6.41478541259918, -2.853821927760786],
            [6.414909319327327, -2.8623104704742],
            [6.415981183577616, -2.8720239876783533],
            [6.4101099976201645, -2.872124195010292],
            [6.410897484155892, -2.9108246453320494],
            [6.411903624596366, -2.9298777108877037],
            [6.398300410892692, -2.964377840087629],
            [6.368555807185537, -3.0140830733369914],
            [6.278573943820336, -3.0728682613842477],
            [6.26066039831428, -3.0846780738763826],
            [6.239846156294107, -3.0858704072138115],
            [6.186578205952355, -3.0888492421672575],
            [6.048473792032745, -3.096411709934071],
            [6.04606169262058, -3.032338565349623],
            [6.046032274437411, -3.027242161626031],
            [6.042494630010738, -2.9546711362129323],
            [6.038707581193387, -2.8711999517898765],
            [6.03808604511216, -2.855161426326156],
            [6.036786247181812, -2.8333170047803873]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.83844394186552,
          "lat": 35.608133580805124
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47113"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01639769"
      },
      "bbox": [
        6.036786247181812, -3.096411709934071, 6.415981183577616,
        -2.7081687631485543
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1701658722860375, -5.725356479822202],
            [1.1728545163611885, -5.722904271775186],
            [1.1740600568526784, -5.7178906665873965],
            [1.1812912898866121, -5.7124633554278965],
            [1.1824987168679324, -5.707733838242241],
            [1.1869483809502854, -5.708824112990981],
            [1.1916976227116334, -5.704002042097579],
            [1.1949420803399344, -5.70279561502023],
            [1.2009411950643025, -5.7044226540905285],
            [1.202984804778645, -5.706915256914779],
            [1.2093448418804664, -5.705956639533674],
            [1.2143342897379166, -5.701237062687913],
            [1.2179527442707212, -5.700769221560125],
            [1.2210029261509305, -5.695958346146724],
            [1.2256623779769311, -5.694460745893791],
            [1.230465555472824, -5.690717192138161],
            [1.2312910771056897, -5.68610944506102],
            [1.238441991307238, -5.683368147832436],
            [1.2459990653000872, -5.6834163687224795],
            [1.2511581515119583, -5.67636593743607],
            [1.2578500855242938, -5.674839186483175],
            [1.2565453246788563, -5.671633294848841],
            [1.26315258965409, -5.667803370026984],
            [1.2703985679499732, -5.664772621441562],
            [1.2811170531150144, -5.661910881203945],
            [1.2868427984014075, -5.66187485476333],
            [1.2903626075164538, -5.666415468659721],
            [1.2940440931692645, -5.6625581715611215],
            [1.3068193764043436, -5.664017237930156],
            [1.308191204663461, -5.661260393812654],
            [1.3134495857172293, -5.659968435747599],
            [1.3173316905013346, -5.664456950823962],
            [1.3278935109935759, -5.663931233120028],
            [1.3374457830879363, -5.662558868074392],
            [1.345495587554532, -5.66393330542239],
            [1.3497367121836676, -5.6629947682993285],
            [1.351507252279888, -5.665308671833184],
            [1.3571504752778103, -5.666264060246081],
            [1.3580374309960423, -5.6745609319642565],
            [1.3607817454734616, -5.674508993844185],
            [1.3594745038720588, -5.680023113512602],
            [1.362025159358248, -5.6815957730007876],
            [1.3650298919885806, -5.690597321227254],
            [1.3679194514858661, -5.692265051216499],
            [1.370941326976718, -5.690800527592584],
            [1.3783941304196872, -5.695048595507798],
            [1.3793030871692933, -5.699001952582599],
            [1.3837537567304148, -5.7007522376316295],
            [1.3853060692688393, -5.705832653756662],
            [1.389504864943848, -5.706027262309979],
            [1.3882178825301468, -5.711441954176187],
            [1.3996773206308077, -5.717093186072163],
            [1.400365555417532, -5.720735203674955],
            [1.4053512457213044, -5.72255398793623],
            [1.4099743669133955, -5.721363574379622],
            [1.4144305134420665, -5.722920711530292],
            [1.4137978861436655, -5.732379269224837],
            [1.4194167532980186, -5.7347092623339],
            [1.42560378182054, -5.740608784745011],
            [1.433666847399259, -5.744101740058174],
            [1.438305851916888, -5.748034360133722],
            [1.4474900886897404, -5.753017079669174],
            [1.4565765423115682, -5.764175782847129],
            [1.4602118784552727, -5.76616194693392],
            [1.4618848199176926, -5.769877691067404],
            [1.4654081686867388, -5.770762616156169],
            [1.4672982302390083, -5.773624412063099],
            [1.4723633692368543, -5.773378202676912],
            [1.475723643451424, -5.77641338409125],
            [1.476327952274714, -5.783340171805648],
            [1.4798616928103185, -5.785877289139955],
            [1.4812276194011458, -5.789030652713256],
            [1.4869489332874, -5.794671144073038],
            [1.4842336528950073, -5.797098774361184],
            [1.4878677441598502, -5.800680363528812],
            [1.488977348851547, -5.808008507002547],
            [1.4952649252513364, -5.812464481536086],
            [1.499347044429992, -5.814047368325374],
            [1.5016069337653142, -5.816881154369801],
            [1.5097705998244486, -5.8156581809252055],
            [1.51690468729675, -5.817387249009423],
            [1.5185324227246324, -5.820750457866554],
            [1.5251068061128363, -5.821451042999427],
            [1.528835130400377, -5.828823366594164],
            [1.531808960599046, -5.830408316161044],
            [1.5006407539194395, -5.8316707561122785],
            [1.4995924565217715, -5.8314671549554085],
            [1.4389721740710595, -5.832961619982837],
            [1.3812558586292452, -5.8341903953694185],
            [1.357404579464978, -5.834346233374144],
            [1.3053682064306396, -5.834996695340755],
            [1.29069252159179, -5.835029163181417],
            [1.1790123141910605, -5.83641476686691],
            [1.1712405715570577, -5.8362869219489015],
            [1.1709302670405313, -5.816196827395669],
            [1.1703388027162924, -5.748550521944204],
            [1.1718664225785764, -5.738688169709311],
            [1.1715765289294489, -5.727384704412011],
            [1.1701658722860375, -5.725356479822202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.97851085862499,
          "lat": 32.973262543681315
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48063"],
        "coty_name": ["Camp"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Camp County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01383817"
      },
      "bbox": [
        1.1701658722860375, -5.83641476686691, 1.531808960599046,
        -5.659968435747599
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.236736172265214, -4.335995181717023],
            [-3.218315038192039, -4.337327509150369],
            [-3.1552683881211325, -4.340397994391492],
            [-3.140367399595594, -4.341071604786272],
            [-3.120605735001503, -4.342808891070885],
            [-3.0998986822443775, -4.343762365475413],
            [-3.0110314029417307, -4.3482571178480365],
            [-2.9235074417700466, -4.352359721278276],
            [-2.9141430080699635, -4.352449746515838],
            [-2.8136353541004926, -4.357098395735857],
            [-2.8114419928391268, -4.357291059602662],
            [-2.8127870067257237, -4.386298554667299],
            [-2.815067992924365, -4.445118178363127],
            [-2.8219231637020297, -4.443509786628764],
            [-2.8227572814130775, -4.438130498538322],
            [-2.8218232478823477, -4.432180846230145],
            [-2.8226122534751514, -4.428921344051401],
            [-2.8257437172769624, -4.426968199456973],
            [-2.835025314188306, -4.429567848024358],
            [-2.8474362282075045, -4.429616086605829],
            [-2.852255716908466, -4.440098398555228],
            [-2.85533403126213, -4.437962322345971],
            [-2.8619401187134375, -4.580847634533952],
            [-2.8734211408200854, -4.8330544505423205],
            [-2.892219483140052, -4.832103118156804],
            [-3.076487610996848, -4.82405168250848],
            [-3.260754611070187, -4.815973073136383],
            [-3.252203765783193, -4.647271212249216],
            [-3.249426568587804, -4.59075588505691],
            [-3.249546138761572, -4.590277611709233],
            [-3.244582754738474, -4.482863732339915],
            [-3.2400367626453854, -4.400262103108187],
            [-3.236736172265214, -4.335995181717023]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.27878135520771,
          "lat": 34.077635899098674
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48101"],
        "coty_name": ["Cottle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cottle County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01383836"
      },
      "bbox": [
        -3.260754611070187, -4.8330544505423205, -2.8114419928391268,
        -4.335995181717023
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.052145858525018, -6.390588315961066],
            [-6.992837139441498, -6.396451616899237],
            [-6.980365928997684, -6.39767889335434],
            [-6.929515928717852, -6.404900625011126],
            [-6.914934050608677, -6.405952743410937],
            [-6.9144853769642, -6.403232240146385],
            [-6.840456679809125, -6.410108673333124],
            [-6.727260627794966, -6.420609637971063],
            [-6.557350694036456, -6.43566863431937],
            [-6.429073674895255, -6.446706272256011],
            [-6.300794644969867, -6.457720659158645],
            [-6.359378541137729, -6.822679554371613],
            [-6.388675858201202, -7.004968009831423],
            [-6.417976849691067, -7.187124757452736],
            [-6.438523162049629, -7.313110200092369],
            [-6.442743412186868, -7.340874480923579],
            [-6.540914169567597, -7.391492329770183],
            [-6.627004010443321, -7.4349104857096],
            [-6.713107926069528, -7.4783067266891505],
            [-6.82899978601322, -7.537871228558863],
            [-6.944917946243461, -7.597394598972705],
            [-7.060862620082237, -7.656876366771625],
            [-7.176834020137501, -7.716316060396256],
            [-7.168525416370475, -7.632953833026957],
            [-7.168414618499531, -7.630072677011013],
            [-7.159991571284314, -7.545861471759217],
            [-7.152491635315767, -7.546620588804646],
            [-7.1424553250561775, -7.442598706649114],
            [-7.138851282618913, -7.399115454742118],
            [-7.138185900926113, -7.3839372014091404],
            [-7.13419578015685, -7.342106207132258],
            [-7.123302663998263, -7.224484886916887],
            [-7.080288899053069, -6.728468988465773],
            [-7.076061759415171, -6.670039672573775],
            [-7.076167493797058, -6.661780572277619],
            [-7.073560635319881, -6.625733838327809],
            [-7.063105380984636, -6.505092729943594],
            [-7.0624049035726495, -6.5051722618744385],
            [-7.052145858525018, -6.390588315961066]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.51726146895487,
          "lat": 31.446956579909806
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48109"],
        "coty_name": ["Culberson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Culberson County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01383840"
      },
      "bbox": [
        -7.176834020137501, -7.716316060396256, -6.300794644969867,
        -6.390588315961066
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1715417286293324, -2.5828758866205437],
            [-3.0397033631136194, -2.5895826003945466],
            [-3.032938332087658, -2.5901944165135284],
            [-2.881611982798243, -2.59713067879518],
            [-2.837148630820989, -2.599166257381198],
            [-2.739622033559495, -2.603096789786427],
            [-2.7470278863839224, -2.7788043236495636],
            [-2.7527620415303593, -2.9148322964338096],
            [-2.75815435692864, -3.0427361579458427],
            [-2.862004016688087, -3.0380480510021215],
            [-3.0632928522445164, -3.0289978763920904],
            [-3.0649000353854636, -3.0287503579147605],
            [-3.1561022312188194, -3.024629550080977],
            [-3.192559259832977, -3.0230501447460023],
            [-3.191107126894376, -2.9931540884993235],
            [-3.1894489119197473, -2.9437021459263573],
            [-3.187013544383017, -2.892733740378491],
            [-3.1871606384375055, -2.8913999054714083],
            [-3.1715417286293324, -2.5828758866205437]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.27062731293238,
          "lat": 35.83755788899274
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48211"],
        "coty_name": ["Hemphill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hemphill County"],
        "coty_fp_code": "211",
        "coty_gnis_code": "01383891"
      },
      "bbox": [
        -3.192559259832977, -3.0427361579458427, -2.739622033559495,
        -2.5828758866205437
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.08366190057753826, -6.382546644984214],
            [0.08498046825425494, -6.382661779786971],
            [0.18620551177081424, -6.382776420013944],
            [0.25394352717233776, -6.383114720212291],
            [0.25390176472416864, -6.386834432541172],
            [0.2692184377423773, -6.387156724978113],
            [0.28943439419623573, -6.386833437792837],
            [0.2982747185863859, -6.387120895554299],
            [0.2993841108315927, -6.383739073370357],
            [0.36692925145223626, -6.384473308424163],
            [0.39996936577973047, -6.384573265121955],
            [0.48508472636547706, -6.384976408812994],
            [0.5915824059473067, -6.38514232005596],
            [0.6536737101814183, -6.385634019158718],
            [0.7141393031045395, -6.385851021844257],
            [0.733940390681253, -6.38569196060122],
            [0.7967533661825357, -6.38609765124372],
            [0.8732621018523405, -6.385924006242869],
            [0.9265649115457074, -6.385535760774241],
            [0.9276445344789966, -6.393858379142815],
            [0.923875169856912, -6.394935125073309],
            [0.9220409589993683, -6.4029844355894205],
            [0.9231632512043341, -6.406815526229855],
            [0.9197040755184778, -6.411530866144645],
            [0.9214431552200583, -6.418537329651808],
            [0.9196215229035691, -6.4214528741300345],
            [0.9233254780604924, -6.423951329494505],
            [0.9229529188348442, -6.434972451970533],
            [0.927589745663266, -6.440442191433717],
            [0.9287576468715679, -6.444892789030948],
            [0.9251181678318657, -6.445728890566974],
            [0.923357028620629, -6.4606378479061135],
            [0.9202280843759139, -6.467612863621206],
            [0.9096238919125456, -6.47864667096972],
            [0.9099916927549869, -6.491560183053137],
            [0.9117005781831822, -6.494110557375969],
            [0.9041110545652082, -6.498328280665015],
            [0.8992027538767862, -6.499977962278398],
            [0.894201334336056, -6.508241448793803],
            [0.8958658024696298, -6.509771558063343],
            [0.8961020130842081, -6.515445941015618],
            [0.9026690213145141, -6.523197140468711],
            [0.902339015351995, -6.528524793139098],
            [0.9054791259303994, -6.529651081041571],
            [0.909737735301124, -6.528620968509742],
            [0.9111112107866048, -6.535303231550872],
            [0.9161674578679049, -6.538893986326175],
            [0.9141905947737146, -6.543619486111128],
            [0.9156443281885616, -6.546240637670291],
            [0.9114391533978907, -6.550186547363318],
            [0.9115821362704838, -6.552700150215653],
            [0.9170813689085866, -6.557287714854266],
            [0.91405261980055, -6.560137570375035],
            [0.9109697016086286, -6.5602825570285885],
            [0.9088876611166199, -6.571645232209131],
            [0.9068956957002086, -6.571772038239779],
            [0.9055306839160088, -6.5783295921077904],
            [0.9019257117377153, -6.588724208805135],
            [0.903563733219569, -6.594435262855061],
            [0.9109250223857858, -6.597121416003028],
            [0.9187932866418571, -6.604983644207374],
            [0.9175144601169767, -6.616834351679143],
            [0.9253723234287553, -6.632771633166618],
            [0.9297090285754873, -6.633954606066074],
            [0.9337090674529954, -6.638623242706672],
            [0.9355643695045381, -6.6445988931655995],
            [0.9385333672826728, -6.643891689431114],
            [0.9429264727079933, -6.646467107339477],
            [0.945866357881081, -6.653755532454439],
            [0.9455542959621722, -6.655824667135638],
            [0.8954912970694003, -6.664629557481087],
            [0.8841491632879588, -6.666163731567624],
            [0.7805620619668159, -6.682623831021136],
            [0.6957944448311305, -6.695796056767617],
            [0.6376860536678907, -6.704626958162237],
            [0.5807459181356994, -6.712748393911993],
            [0.49209892066548805, -6.72526662907257],
            [0.4862583918063002, -6.726480946337661],
            [0.41919273795908885, -6.735676473165868],
            [0.41751379585690823, -6.7290584542462515],
            [0.4209100550302469, -6.724815175154859],
            [0.41513400020371166, -6.72097484549134],
            [0.41014127739811435, -6.712422182766261],
            [0.41127325390918973, -6.710222386296371],
            [0.4076736360176743, -6.703872731330403],
            [0.4092093153072067, -6.69720004485465],
            [0.4079844109255679, -6.693756984304534],
            [0.4097570304694343, -6.690576414197012],
            [0.4076192969147396, -6.681632253046617],
            [0.41113983490975886, -6.6797632071268005],
            [0.4092169009524095, -6.67627257670055],
            [0.4058891367834937, -6.6752851278586025],
            [0.40741228017044767, -6.670273656282946],
            [0.40511062316226404, -6.6652024815209305],
            [0.41029964481442427, -6.665036400484359],
            [0.41060513652460784, -6.660854337525983],
            [0.4080884762442566, -6.655909700585334],
            [0.39495970171844735, -6.660224653695473],
            [0.3860600938896943, -6.659801339112007],
            [0.3798793805045746, -6.660412016936702],
            [0.3791834577695145, -6.663909830910742],
            [0.37489832173323906, -6.666335712464252],
            [0.3716616835063605, -6.6645613741995735],
            [0.37204907497722806, -6.656184228275209],
            [0.369544314569358, -6.651167444382242],
            [0.3644141339227409, -6.646719277476346],
            [0.3649573017655729, -6.637660011819937],
            [0.3697469433879385, -6.625936095763722],
            [0.36738231932162874, -6.62162465798943],
            [0.367089193587247, -6.615267033578459],
            [0.3697373688883188, -6.609790293415106],
            [0.37444857634821194, -6.606535029570784],
            [0.377452312489255, -6.5995227472333235],
            [0.3769954422856939, -6.591250524559841],
            [0.3757720816056826, -6.589150525508758],
            [0.36883081051874983, -6.58502113716168],
            [0.3662937213562631, -6.580893539557596],
            [0.3621923786435831, -6.585053981617852],
            [0.3534067097956514, -6.588825480885626],
            [0.3413058882005629, -6.588947785524738],
            [0.33553288662675734, -6.5833455901813025],
            [0.32980180159639466, -6.586844774017076],
            [0.3230958002124701, -6.583069242746977],
            [0.3244233566741817, -6.579178589558307],
            [0.323546878155931, -6.575651493056281],
            [0.31931154448374505, -6.573198748101839],
            [0.3160965337929288, -6.568379210851146],
            [0.31513458201792716, -6.560382365478158],
            [0.3261839952909393, -6.5512593458374],
            [0.33078837724280913, -6.550469228602466],
            [0.3324271213074162, -6.546220014484502],
            [0.3290830267448968, -6.541246535237905],
            [0.3308225628611742, -6.53606767619517],
            [0.3396682294481607, -6.534501982101458],
            [0.3406675915510457, -6.5305978964593185],
            [0.3370787379549995, -6.527718256026495],
            [0.33294475202342033, -6.526869791053909],
            [0.3228856425203171, -6.531975824114909],
            [0.3157061955651215, -6.5378557804596396],
            [0.3110251460204544, -6.5372249077963],
            [0.3093714289683172, -6.5400188422250345],
            [0.304180007916542, -6.5394545016422665],
            [0.2979355815372611, -6.53482232416241],
            [0.2983824550275173, -6.528811504714914],
            [0.29291758973658705, -6.527393011805695],
            [0.29148657829007313, -6.523549153861217],
            [0.2877471341633294, -6.52310565215218],
            [0.28815343192979204, -6.5182580084341915],
            [0.28607695725723664, -6.515330312605927],
            [0.282881805457728, -6.517752992418127],
            [0.28100543953290147, -6.5084099611409885],
            [0.27833606346378226, -6.508802342937632],
            [0.27072561527558453, -6.505560599973057],
            [0.26642484019082935, -6.494345289254002],
            [0.2668940454561533, -6.491741655998224],
            [0.2543103298442893, -6.4906791598371125],
            [0.25252712999602706, -6.494632617120021],
            [0.24788066141497547, -6.496634783243002],
            [0.24533682223447037, -6.491844846605635],
            [0.24106354741153072, -6.48947003392631],
            [0.23772165986490953, -6.482723868059256],
            [0.2344025196161579, -6.486070437451301],
            [0.23100850250512622, -6.485874918036066],
            [0.2301024183853449, -6.4810191172275236],
            [0.2232230674685799, -6.485659258497967],
            [0.2243397905201295, -6.478008729369128],
            [0.22035315747415044, -6.471203707223919],
            [0.2242502871639121, -6.469750093124105],
            [0.22487617231041204, -6.462446271968717],
            [0.22227705391928745, -6.456187479433039],
            [0.21911292000521915, -6.452495957507538],
            [0.22082393928378882, -6.4484625181523745],
            [0.21361447859501076, -6.448360506630998],
            [0.21437306785443117, -6.44350604464602],
            [0.21115109150602882, -6.440299354935939],
            [0.2079212787997095, -6.439605860133213],
            [0.20337329959777412, -6.441692062365733],
            [0.20088329814233316, -6.438492300752053],
            [0.19818747957884533, -6.439073829125523],
            [0.192081638750866, -6.435392226374457],
            [0.1909932626367683, -6.438458366550292],
            [0.18545378113284136, -6.438089751115552],
            [0.1759102940956114, -6.43385249100913],
            [0.1734402919938915, -6.428770755918936],
            [0.1669175733463638, -6.429855825264038],
            [0.16167388493814377, -6.424844287368816],
            [0.1550496403306627, -6.4237571772408275],
            [0.1487692000178982, -6.416572791281563],
            [0.14190237531726585, -6.4125044485106875],
            [0.13998913514459257, -6.409469615277408],
            [0.1352870108191919, -6.407551310351853],
            [0.12719225256948563, -6.412570090040808],
            [0.1207132136197331, -6.412843419284626],
            [0.11735452298715285, -6.408599989304527],
            [0.11283093758802773, -6.40578196217927],
            [0.10306866913062897, -6.4090346953668],
            [0.09711007783160179, -6.395843708522507],
            [0.09081954592547599, -6.394892580871115],
            [0.086340340979693, -6.396709044409727],
            [0.08387480075433722, -6.3958202068652685],
            [0.0817973012858403, -6.388871419677076],
            [0.08524229956299378, -6.386426828735861],
            [0.08366190057753826, -6.382546644984214]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.8535153313611, "lat": 32.21188900993783 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48213"],
        "coty_name": ["Henderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henderson County"],
        "coty_fp_code": "213",
        "coty_gnis_code": "01383892"
      },
      "bbox": [
        0.0817973012858403, -6.735676473165868, 0.945866357881081,
        -6.382546644984214
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.176607618009883, -11.371743109648072],
            [-2.106686710659859, -11.374500769466938],
            [-2.036765107562459, -11.377244384631918],
            [-2.034457356286902, -11.293388535353378],
            [-1.991892955787902, -11.29426285606346],
            [-1.9906972218071948, -11.29206394212065],
            [-1.9205689756363924, -11.293425243226205],
            [-1.8796867422076409, -11.294111125724763],
            [-1.8801393192603828, -11.313283177404802],
            [-1.848487344294689, -11.3139698853132],
            [-1.847985599199456, -11.29401950880239],
            [-1.8150235963902563, -11.29449793277774],
            [-1.8152824303799984, -11.309456946206668],
            [-1.788376748487049, -11.310629821699472],
            [-1.7913243241615708, -11.386773375715864],
            [-1.8032619236554703, -11.386416926887607],
            [-1.8010838204258601, -11.389703013927408],
            [-1.7990064962311685, -11.396670747364759],
            [-1.7952132954041022, -11.39852120464206],
            [-1.7907155703462647, -11.397576356963867],
            [-1.7881999051067539, -11.401405057076147],
            [-1.7836033911253937, -11.400281038537555],
            [-1.7806546809077854, -11.40182804764161],
            [-1.7798365850301665, -11.407941058317636],
            [-1.776512694302881, -11.413041143042996],
            [-1.7681045301672533, -11.414910887291988],
            [-1.765000801348534, -11.416844405059202],
            [-1.7673951237751884, -11.507390807605345],
            [-1.7444666758476408, -11.508031788788449],
            [-1.7460544658428274, -11.59303851781684],
            [-1.7024554692598106, -11.593577147788851],
            [-1.709912328064233, -11.766908605450636],
            [-1.7101957798365404, -11.769344421383721],
            [-1.7135762997357518, -11.857750795297198],
            [-1.7851283887461082, -11.855647355216739],
            [-1.7910793361019792, -11.855626995446844],
            [-1.911519073845277, -11.8520086464003],
            [-1.9860516973246025, -11.849430379424842],
            [-2.060583617219644, -11.846835366376737],
            [-2.125869842265814, -11.844637524476486],
            [-2.191155568932721, -11.842426835382662],
            [-2.1870367422986634, -11.697481011941735],
            [-2.184703696806785, -11.633755376198007],
            [-2.181955789883631, -11.548117708476841],
            [-2.176607618009883, -11.371743109648072]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.697330831489, "lat": 27.043422185909478 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48247"],
        "coty_name": ["Jim Hogg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jim Hogg County"],
        "coty_fp_code": "247",
        "coty_gnis_code": "01383909"
      },
      "bbox": [
        -2.191155568932721, -11.857750795297198, -1.7024554692598106,
        -11.29206394212065
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8914229906240337, -6.175260272130378],
            [-0.8645349848771308, -6.175897598368943],
            [-0.8357624509589413, -6.176275492946309],
            [-0.7962431401893564, -6.176858793899873],
            [-0.7703165481492121, -6.177673347718881],
            [-0.708869735051758, -6.180076215383123],
            [-0.6693641637517495, -6.180921674131923],
            [-0.6644356099746958, -6.1813452030094975],
            [-0.5929327435210417, -6.183284075872303],
            [-0.5466871068193869, -6.184757559989974],
            [-0.5305166745632565, -6.184934859189943],
            [-0.522784239354394, -6.185485393005271],
            [-0.48328288625641647, -6.186799929024869],
            [-0.4579117617193328, -6.187114783456401],
            [-0.4473831644128209, -6.18772813991472],
            [-0.44846482449988323, -6.282247069228585],
            [-0.4496497110329216, -6.386668357294101],
            [-0.4506213859270735, -6.469991971003009],
            [-0.4506453125548932, -6.471558972472552],
            [-0.4897637951138404, -6.4816491068914175],
            [-0.5128365241489817, -6.485639539829603],
            [-0.5824152137376456, -6.502514403419247],
            [-0.6962459867837246, -6.529966889513787],
            [-0.7790844578179981, -6.550632511866848],
            [-0.7756659622109553, -6.556835883255598],
            [-0.779297787973674, -6.55883711840712],
            [-0.785461715312123, -6.5597683676501095],
            [-0.7902341213944077, -6.562179810160712],
            [-0.7949260046955664, -6.567414287304519],
            [-0.8021188093437007, -6.569159003140003],
            [-0.8067903996406937, -6.568461344398775],
            [-0.8098487202782605, -6.57038829340017],
            [-0.811313475954149, -6.57615793769433],
            [-0.8101325507041562, -6.585110745784909],
            [-0.8069568043663466, -6.591214992715657],
            [-0.8081417218320173, -6.5956546727876555],
            [-0.8133068559584553, -6.597943451176101],
            [-0.818424817657964, -6.596868692761378],
            [-0.8317146874602078, -6.590925698952365],
            [-0.8416006757503407, -6.58381832816231],
            [-0.8457606822591291, -6.5816418785799735],
            [-0.8558941779299933, -6.581115092228991],
            [-0.8584735240633492, -6.5797207471945285],
            [-0.858402865135883, -6.575268233464827],
            [-0.8543470608232956, -6.570527433627572],
            [-0.8568545580902607, -6.563254373394986],
            [-0.8564074411740935, -6.55606047156034],
            [-0.8611220911540286, -6.5506871299274465],
            [-0.8655204717724948, -6.550159267684189],
            [-0.8776707357267896, -6.556346346344203],
            [-0.8850156423581077, -6.554929434562874],
            [-0.8848596323053637, -6.550697665432439],
            [-0.8769049313925479, -6.545946864597952],
            [-0.8748729829552122, -6.542305429937692],
            [-0.8750132130013463, -6.535681569242035],
            [-0.8769776193071175, -6.530785008439806],
            [-0.8829836574657086, -6.526469015835087],
            [-0.8958292732318107, -6.526962272476349],
            [-0.8943948187130951, -6.411978730810444],
            [-0.8939752785534493, -6.411928864864761],
            [-0.893556174542248, -6.383639884920218],
            [-0.8930568019122394, -6.331211600973204],
            [-0.892907055659499, -6.259615212568056],
            [-0.8915975606919652, -6.2402104834527945],
            [-0.8917080708856754, -6.198776264950615],
            [-0.8914229906240337, -6.175260272130378]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.36655759691666, "lat": 32.37899111994467 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48251"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "251",
        "coty_gnis_code": "01383911"
      },
      "bbox": [
        -0.8958292732318107, -6.597943451176101, -0.4473831644128209,
        -6.175260272130378
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.25771017733483365, -7.763357128873294],
            [0.2632704507775536, -7.761108954653607],
            [0.26790816818837265, -7.756726379065905],
            [0.2799546063684801, -7.755827000842327],
            [0.2863354691121759, -7.753421003281701],
            [0.2992270936628044, -7.745960972140374],
            [0.317116590781963, -7.743067875687393],
            [0.33843750938027384, -7.728727892036807],
            [0.34668886095581003, -7.724126039958499],
            [0.359776636985955, -7.715565408876091],
            [0.3703465471050231, -7.707209295230598],
            [0.3803328245436258, -7.700276460484983],
            [0.39272094520658657, -7.693135559549995],
            [0.4111010524424809, -7.679549499939957],
            [0.4219775570808583, -7.669770890943288],
            [0.4260852429818176, -7.668135402682915],
            [0.4353993103473556, -7.668615388686263],
            [0.4408046998206039, -7.6660668898634485],
            [0.44882315395123684, -7.667912042166834],
            [0.45685178955757644, -7.664833978875277],
            [0.47332216123587967, -7.651853588701722],
            [0.48324701250279106, -7.646639693138078],
            [0.48606875587516507, -7.645902184911265],
            [0.5702395864823211, -7.644989782702692],
            [0.6648286975935125, -7.643608925417371],
            [0.6671814311095334, -7.648125274165198],
            [0.6714385191173626, -7.649178492242033],
            [0.676940786532445, -7.645582831366671],
            [0.6849756390742087, -7.64748650624122],
            [0.6861741551885513, -7.651829359490247],
            [0.6911599276742425, -7.653811201652129],
            [0.6955747071082229, -7.649828598654907],
            [0.6977265642938898, -7.655651010727691],
            [0.6998893177695578, -7.657810330634243],
            [0.7110451035239965, -7.656261124634049],
            [0.7133069113472874, -7.659407092182439],
            [0.716796273424836, -7.6551229965224294],
            [0.7205958637840986, -7.660689019760617],
            [0.7233083787980428, -7.659950677892916],
            [0.7263429067840672, -7.655615922061233],
            [0.7302176809960431, -7.657384150453334],
            [0.7321837515764977, -7.660448022213653],
            [0.7370899896564811, -7.65888073748251],
            [0.7415535997499322, -7.661204217089851],
            [0.7495300862651606, -7.654453497603907],
            [0.7528980568732851, -7.6571242389436325],
            [0.7564591526490516, -7.657672354087069],
            [0.758755193729598, -7.663369180478929],
            [0.763821055055878, -7.667373468123466],
            [0.7583878671975876, -7.670071645524088],
            [0.7607237836652984, -7.674410894836835],
            [0.766844503343594, -7.6825775772834906],
            [0.7764623887386904, -7.68333675125581],
            [0.7797346753052281, -7.68546263278316],
            [0.7812794418376546, -7.6938660849352365],
            [0.7757585917407087, -7.699822132522353],
            [0.7730243447757635, -7.695136342436591],
            [0.7695949570915533, -7.69532617161143],
            [0.7650279928042578, -7.701021413905627],
            [0.7514504413036347, -7.703991837861302],
            [0.7466319422238872, -7.7103258995106625],
            [0.746754720616921, -7.714873217162826],
            [0.7486512135226744, -7.717259268648851],
            [0.7555790546510106, -7.720782527909551],
            [0.7516658180476629, -7.728854652791814],
            [0.7507199164363132, -7.732686725580907],
            [0.7456653577492921, -7.740207531269975],
            [0.7454342022660662, -7.743262639205743],
            [0.7381393860335212, -7.746585160505722],
            [0.7361219622639437, -7.7494861023316925],
            [0.741215020057371, -7.751465731202097],
            [0.7436032481074843, -7.7606130381631395],
            [0.7501555124502605, -7.765952114849624],
            [0.7542985916303774, -7.779571318209822],
            [0.7584212708461343, -7.78349881975128],
            [0.758738193166856, -7.785984011592814],
            [0.7630672024040684, -7.791441742203513],
            [0.7632723620753072, -7.800618710873321],
            [0.7687197823947138, -7.801868549095329],
            [0.770880023654742, -7.807895934467303],
            [0.7727816072798365, -7.80973993741863],
            [0.7793811371803617, -7.810566356972401],
            [0.785146620940503, -7.809193630768076],
            [0.7905667250748608, -7.806012440697877],
            [0.7898714444055943, -7.813845023885301],
            [0.7930472930327064, -7.818829176946824],
            [0.793856946250916, -7.823314937539911],
            [0.7913150462074126, -7.82597894507551],
            [0.7875736393520397, -7.822713024708151],
            [0.7843621418960008, -7.826562795908024],
            [0.7806154385536588, -7.827756699883428],
            [0.7806571722295661, -7.836190675592759],
            [0.7776500134665051, -7.836928491831102],
            [0.7687163213491646, -7.836198154826985],
            [0.763795548820416, -7.840977180949457],
            [0.7580163524407938, -7.842830103852619],
            [0.757411603313197, -7.840072338283377],
            [0.7492608052031219, -7.8314127620241925],
            [0.7447124767165312, -7.8330747445552955],
            [0.7392830071756062, -7.83032317012469],
            [0.732751203118053, -7.8329667813678805],
            [0.7316644464402148, -7.8354849494096825],
            [0.7224583863462106, -7.832075884001976],
            [0.7204007071340742, -7.829642210539419],
            [0.7120590496082959, -7.830135830449617],
            [0.7092215482941169, -7.826312241368256],
            [0.7005673233688731, -7.82805950017831],
            [0.6957639272477721, -7.833224723783673],
            [0.6893894043291791, -7.83670690370413],
            [0.68334450886325, -7.8341878377887255],
            [0.6761562448036288, -7.836584245467449],
            [0.6703392150215327, -7.837344226340805],
            [0.6616282102079427, -7.843963495955511],
            [0.6611271461547183, -7.846907377220685],
            [0.6510511274094596, -7.852808272846152],
            [0.6481422049281247, -7.857236633720718],
            [0.6440825930810498, -7.8585708750834025],
            [0.6379740185212651, -7.85835955124419],
            [0.631253912601189, -7.862847854305224],
            [0.6270964036097513, -7.864297649389804],
            [0.6249442435538558, -7.867932729176063],
            [0.6204279302415519, -7.86729179986427],
            [0.6121031647314725, -7.87101552247674],
            [0.6093017202955712, -7.874411858481127],
            [0.6049001202977724, -7.871467285660316],
            [0.6002082166906622, -7.873304983018761],
            [0.5928957997628587, -7.873511505250522],
            [0.5918887336257473, -7.868943609591662],
            [0.5868277990032018, -7.871366228946034],
            [0.5809591075918409, -7.872441684151805],
            [0.5705445804435236, -7.873899232802498],
            [0.4839059235065513, -7.888719973058597],
            [0.45202112585286897, -7.8938816833778285],
            [0.3622614605202106, -7.908665718645992],
            [0.35649155842199454, -7.9097250875550325],
            [0.31954531998337177, -7.91325000889547],
            [0.3170729973502973, -7.9070451072573995],
            [0.3135013554252788, -7.901422976484603],
            [0.3129706363925153, -7.895374121448445],
            [0.31429068505052, -7.889970154151665],
            [0.31089604153948797, -7.877291247918901],
            [0.3037773788625413, -7.869029857229824],
            [0.3010376215953343, -7.869811225804253],
            [0.2954768937998438, -7.861819144004192],
            [0.298532664899081, -7.8574950568662825],
            [0.29803107698989123, -7.854201817855544],
            [0.29397143078180954, -7.850031977073819],
            [0.28900072725059167, -7.840015248622857],
            [0.28978281785686144, -7.835640508409052],
            [0.2840368815546632, -7.83361624925775],
            [0.28138093367219197, -7.825411671570883],
            [0.28390825595056346, -7.819950612473057],
            [0.28713825369352636, -7.818044969752622],
            [0.2867870949565518, -7.813184503235026],
            [0.29110299123832456, -7.811296882263447],
            [0.28958955483302723, -7.808292929755813],
            [0.2912100302503797, -7.799263055042333],
            [0.28816371373811345, -7.796939337142747],
            [0.28632515481169835, -7.789913918640917],
            [0.2753305260843534, -7.78500624921895],
            [0.26915760670967426, -7.7851130730053075],
            [0.26560603451957826, -7.7821939091857475],
            [0.26313762469079605, -7.777710050051604],
            [0.2601633531527459, -7.77593778900547],
            [0.2584154808997484, -7.771373961635641],
            [0.2604019824204013, -7.767099607305803],
            [0.25771017733483365, -7.763357128873294]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.928417895119, "lat": 30.96553097175698 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48313"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "313",
        "coty_gnis_code": "01383939"
      },
      "bbox": [
        0.25771017733483365, -7.91325000889547, 0.793856946250916,
        -7.643608925417371
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.609470306398035, -8.104566432125191],
            [0.6513448504130036, -8.129400235482171],
            [0.7236291093188285, -8.173183827382692],
            [0.8085949620183305, -8.224318185126448],
            [0.9008985653316278, -8.224028813227664],
            [1.0123582116320389, -8.223279079864376],
            [1.0147187476726502, -8.227773198498705],
            [1.0201839510958188, -8.238444942836596],
            [1.0205794731918256, -8.247683393247224],
            [1.0226011582151426, -8.252385355672535],
            [1.0221783707169236, -8.255801644821656],
            [1.0265160185750637, -8.262999538978967],
            [1.030264765916224, -8.267192396495577],
            [1.0314574268146586, -8.272766086476027],
            [1.0350305657422352, -8.282084267555895],
            [1.039978552298685, -8.288361192829182],
            [1.0394101397291353, -8.293489405293235],
            [1.0406947319458284, -8.298178233866519],
            [1.0516106396553286, -8.31178164544646],
            [1.054095681373896, -8.317121620166326],
            [1.0594315177225107, -8.325547906678652],
            [1.063483564073514, -8.328577000045483],
            [1.0665076194506782, -8.32855005425494],
            [1.0770533575307415, -8.335482353343775],
            [1.081940391862793, -8.335518332227526],
            [1.086173447253152, -8.337165896795167],
            [1.093459921903511, -8.344150050716808],
            [1.1003014221285228, -8.347059656699953],
            [1.109430557046041, -8.346949241766186],
            [1.116115159275219, -8.349840889386348],
            [1.1209221778887715, -8.35072670173369],
            [1.1240917279576412, -8.35661133063063],
            [1.1281208543634487, -8.360872103083077],
            [1.1304086193796088, -8.367190503680167],
            [1.1349132127728092, -8.368438670239225],
            [1.137312921117759, -8.373731884674969],
            [1.1495643627003478, -8.377823844379362],
            [1.1500100848040768, -8.38193436798117],
            [1.147450695340687, -8.383465038117166],
            [1.1431267839262818, -8.391147020512738],
            [1.1391830160741554, -8.391714485391443],
            [1.1337705384361505, -8.39544428733748],
            [1.1340723877822092, -8.397457663731606],
            [1.1292718233928503, -8.403796458954291],
            [1.1310691782880706, -8.410163126758341],
            [1.1543325994635434, -8.39908095546351],
            [1.1822748829186114, -8.384519912013145],
            [1.207910848708264, -8.45796296432548],
            [1.2145405162602727, -8.477847757015986],
            [1.2179429103355808, -8.486364412787914],
            [1.2370859174773925, -8.54099016203776],
            [1.2435678942263408, -8.560078102883443],
            [1.2137323465563268, -8.588647444413619],
            [1.1587647800968075, -8.639935433078684],
            [1.1216671554654603, -8.675131636654573],
            [1.1000735324027076, -8.695094083574858],
            [1.0941432836472997, -8.694812668475384],
            [1.0836756552668323, -8.696688609016352],
            [1.075149317048657, -8.699402037193197],
            [1.0714725745622877, -8.695997858526328],
            [1.066532770387894, -8.695394496014016],
            [1.0642343483885048, -8.697638852627252],
            [1.0595498069792626, -8.694584809409617],
            [1.0579604386466146, -8.691521260796442],
            [1.0607075534018813, -8.681969721764998],
            [1.0551123961111857, -8.673878941686505],
            [1.0518153917599238, -8.675005920790442],
            [1.0455047798491064, -8.669787709320632],
            [1.0434920428174883, -8.665403123951839],
            [1.037462235548141, -8.66512526247107],
            [1.0358420149943477, -8.66190073024289],
            [1.0315159863789112, -8.659729026059727],
            [1.0259208779647142, -8.651753242500394],
            [1.0123702170965228, -8.651616152282184],
            [1.0049798534447492, -8.648029796302717],
            [1.0045221095006163, -8.642756624852463],
            [1.0001840014813876, -8.640958359580237],
            [0.9954067834554549, -8.64069704451515],
            [0.9895060513735953, -8.645757383586103],
            [0.9835499976588417, -8.642695481225077],
            [0.9802751990974629, -8.636938723052545],
            [0.9740881316183538, -8.636007815762643],
            [0.9711389180834203, -8.633530231015174],
            [0.9729820067827851, -8.630766870357006],
            [0.9656650061654642, -8.623778590585049],
            [0.9611427061389185, -8.61346602625468],
            [0.9513573277798192, -8.616327847539317],
            [0.9502403684653992, -8.618793619646372],
            [0.9459120032542915, -8.61995837098553],
            [0.9413125375505276, -8.61926619708415],
            [0.9373052329395772, -8.620843463606846],
            [0.9356789324494255, -8.62435633143733],
            [0.9297300295562893, -8.623411807992259],
            [0.9175570774588943, -8.625856179608594],
            [0.9093135338318351, -8.621299321114074],
            [0.9061890185605286, -8.621383345912518],
            [0.903178453416719, -8.618418407053294],
            [0.9027936518174183, -8.614360339837878],
            [0.8987707737870366, -8.609414439627525],
            [0.897577672401843, -8.603570337244205],
            [0.8992415285637265, -8.597654682859451],
            [0.8972937106609178, -8.594233111576168],
            [0.8956727055769617, -8.587115469916489],
            [0.8895367526392589, -8.58397763386081],
            [0.8874433085778732, -8.581467337388787],
            [0.8785805452555767, -8.576184820477629],
            [0.8744162280478617, -8.571119730667197],
            [0.8747697491144762, -8.568467097317717],
            [0.8699147068951408, -8.564128907322255],
            [0.8583192408059082, -8.559566189027544],
            [0.8567366028819923, -8.56095119008086],
            [0.8509945432963978, -8.559479882540368],
            [0.8452997924182939, -8.564535891642814],
            [0.8455630097884632, -8.569467144035597],
            [0.8434329251820862, -8.571670296308223],
            [0.8391508360664637, -8.569360735529697],
            [0.8350852980069987, -8.572623042149415],
            [0.8351356124891407, -8.576258906305481],
            [0.8285756040683434, -8.579876498665804],
            [0.8258841009670995, -8.58008929533292],
            [0.8227754492457738, -8.58341299152284],
            [0.8194723253398722, -8.592077229602328],
            [0.8113758974278833, -8.59637501551929],
            [0.8069880283007085, -8.597119027475127],
            [0.7975536661651061, -8.594559426311346],
            [0.7891519377129442, -8.594363075612675],
            [0.7873822111373904, -8.59802847483193],
            [0.7889825844965248, -8.602750924583502],
            [0.7844153610829351, -8.602179588199013],
            [0.7773064322778188, -8.603680976833196],
            [0.7754038681838942, -8.6075880338837],
            [0.7693964753683226, -8.610906257586654],
            [0.7638865968489672, -8.61620422976836],
            [0.7614285734394449, -8.620854249091886],
            [0.756073092386093, -8.61849428978419],
            [0.7554884123719237, -8.621674257182324],
            [0.7511931661937582, -8.624213709096502],
            [0.7509153601936734, -8.62750139134466],
            [0.7479253007021204, -8.628577868963905],
            [0.7405904846123816, -8.62399926252957],
            [0.7352831940974357, -8.623009967642936],
            [0.7308756817203629, -8.631029159430133],
            [0.7218474700158917, -8.631396267076656],
            [0.7182182764320982, -8.627490199912044],
            [0.7098672184425062, -8.627664851451774],
            [0.7080036184434173, -8.630565984687495],
            [0.7030376678084004, -8.630184458376158],
            [0.6991008158019915, -8.633968388864247],
            [0.693171403234611, -8.636392488926525],
            [0.6877506707066805, -8.633825544164365],
            [0.6801330705977048, -8.634530772800334],
            [0.6716670141211544, -8.639706914007517],
            [0.6703424046184491, -8.643491636306155],
            [0.6669576127526868, -8.641507325096505],
            [0.6615355009173091, -8.64242715803324],
            [0.6586222824211484, -8.638788225683918],
            [0.6561181749547648, -8.640311593131317],
            [0.6515110736528043, -8.63905307163709],
            [0.6487682997402755, -8.636017206510182],
            [0.64639638139314, -8.637958741293662],
            [0.6336909506638903, -8.639921973053037],
            [0.6332136079198503, -8.597963548897848],
            [0.6330274298249234, -8.552203322901157],
            [0.6325269721357906, -8.485963608770746],
            [0.6322979830998989, -8.394579357816054],
            [0.6237985551278648, -8.277679081759443],
            [0.6206761511530144, -8.233579350435132],
            [0.620237317469433, -8.230745675816552],
            [0.609470306398035, -8.104566432125191]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.5029896656119, "lat": 30.30019427598404 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48339"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "339",
        "coty_gnis_code": "01383955"
      },
      "bbox": [
        0.609470306398035, -8.699402037193197, 1.2435678942263408,
        -8.104566432125191
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7887749980114234, -7.919548738241611],
            [-3.6933882699720777, -7.924278577812079],
            [-3.6031198597092224, -7.928365425094556],
            [-3.5128508420753892, -7.932437491979325],
            [-3.346944393759604, -7.938652353544864],
            [-3.3119844649229515, -7.9402107274037],
            [-3.1886212692028644, -7.944880754260704],
            [-3.065257223570834, -7.949523220164354],
            [-3.074620315600377, -8.157570848396865],
            [-3.0836779978646676, -8.365815670774662],
            [-3.1975751950400477, -8.3611829641918],
            [-3.3114714389092708, -8.356525031197426],
            [-3.42536675547887, -8.351841867458255],
            [-3.539261170725254, -8.347133467946971],
            [-3.586604815460678, -8.3447233909276],
            [-3.6727326047786897, -8.340676937093026],
            [-3.8106909421597694, -8.333941273051805],
            [-3.807391877429029, -8.273069708989535],
            [-3.8071394528736238, -8.265967780449204],
            [-3.799567452873968, -8.123614163552004],
            [-3.7995666441935168, -8.12146150097954],
            [-3.7887749980114234, -7.919548738241611]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.53818047881937,
          "lat": 30.498370171041493
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48435"],
        "coty_name": ["Sutton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sutton County"],
        "coty_fp_code": "435",
        "coty_gnis_code": "01384003"
      },
      "bbox": [
        -3.8106909421597694, -8.365815670774662, -3.065257223570834,
        -7.919548738241611
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.483729642984123, -7.933357077583748],
            [-4.477991856365726, -7.928636477254257],
            [-4.472552036251482, -7.929993794658077],
            [-4.470919166848353, -7.936396809114398],
            [-4.464058749113729, -7.936832201755262],
            [-4.456570353370868, -7.934021390911772],
            [-4.449666511504504, -7.937239118540317],
            [-4.441433218076073, -7.938596083893769],
            [-4.437150897976261, -7.936761845991904],
            [-4.43304225361327, -7.936778921240791],
            [-4.432747648594279, -7.939757352527155],
            [-4.428095959313276, -7.94369428183548],
            [-4.424114174904468, -7.941425798663056],
            [-4.419269033846546, -7.944561129355318],
            [-4.417120982696105, -7.951292381542694],
            [-4.410156656453958, -7.953568198584916],
            [-4.405412573144165, -7.953568806104473],
            [-4.403261338777221, -7.951834451125921],
            [-4.397796379261692, -7.962456584877167],
            [-4.390103053084102, -7.968418215024062],
            [-4.386544992319304, -7.972665444140942],
            [-4.391777312659328, -7.974787059765355],
            [-4.391594349441732, -7.980236165834685],
            [-4.392838279400058, -7.983639049068236],
            [-4.3905398849900825, -7.987157488700144],
            [-4.392726420994338, -7.995200825599645],
            [-4.396561823081127, -7.998200877460808],
            [-4.397698104673297, -8.00248078834112],
            [-4.391517217700242, -8.00960767430825],
            [-4.390783229127294, -8.015229610154327],
            [-4.386533206626912, -8.02403922025443],
            [-4.384560521513685, -8.031057892419946],
            [-4.386743770020464, -8.035563950360448],
            [-4.385447958519728, -8.04075897752846],
            [-4.3904024841837455, -8.042328981207724],
            [-4.395086748919155, -8.051205203386512],
            [-4.399646731351328, -8.054314824287454],
            [-4.399934199830619, -8.05747182885028],
            [-4.404462273187745, -8.05961482429336],
            [-4.409891603688707, -8.065886055322466],
            [-4.415041458176798, -8.06630679918747],
            [-4.416157153427209, -8.071217644818669],
            [-4.415842867965589, -8.078843098153252],
            [-4.413727815913539, -8.08198297488331],
            [-4.412840229357232, -8.087937422484519],
            [-4.414574950513485, -8.09023302184317],
            [-4.419154720358712, -8.0911713201116],
            [-4.4219621921906, -8.09403726644316],
            [-4.4252679117451095, -8.093418792543691],
            [-4.42781168532616, -8.097430208827532],
            [-4.426814860245083, -8.10639231532009],
            [-4.428170851397227, -8.108268691062474],
            [-4.425468189335538, -8.115288327421817],
            [-4.426699138846104, -8.121147178239122],
            [-4.434504773004414, -8.124846609785694],
            [-4.436946738140932, -8.130496994394498],
            [-4.441596700438716, -8.130333745324183],
            [-4.447143155865062, -8.125990794848795],
            [-4.449252529516271, -8.120317877445114],
            [-4.4523826309353005, -8.120620205585151],
            [-4.454853591671861, -8.116097116367913],
            [-4.45797186270997, -8.115047361303327],
            [-4.463618407586592, -8.119227860832048],
            [-4.462946562559463, -8.125040913098964],
            [-4.458341027136577, -8.13020232192983],
            [-4.453537772443164, -8.131954707781576],
            [-4.455717594475498, -8.139106651241462],
            [-4.455238326745058, -8.144685006715884],
            [-4.460818027698977, -8.148886109986506],
            [-4.466644414067138, -8.15604699805955],
            [-4.470611978013537, -8.157756249948338],
            [-4.473876675657453, -8.164342300002392],
            [-4.4711507232195125, -8.16704604565115],
            [-4.469701446482672, -8.171484595765374],
            [-4.464164801766072, -8.178007299443353],
            [-4.460021430807937, -8.180446392242702],
            [-4.456607429179665, -8.179938701881916],
            [-4.452353986587877, -8.182245839661979],
            [-4.448247536862428, -8.18182377043414],
            [-4.441017550729104, -8.185649633661498],
            [-4.437297006182744, -8.190398945839874],
            [-4.435958946684074, -8.194448232117521],
            [-4.437162455278471, -8.20270661758479],
            [-4.440128166106842, -8.203533796041693],
            [-4.43768350147985, -8.20858436503965],
            [-4.433828476874184, -8.21213302436624],
            [-4.4294867714193735, -8.218436981120037],
            [-4.4194527481747174, -8.223716559097872],
            [-4.413432058395147, -8.22522963108646],
            [-4.407095199728205, -8.231538502334386],
            [-4.408127695434088, -8.234770203669697],
            [-4.4071861245277635, -8.239596227816556],
            [-4.408408679234615, -8.246411967719641],
            [-4.417780348831787, -8.249103305904322],
            [-4.428418211794822, -8.246674198335903],
            [-4.4357991251135385, -8.241006373191304],
            [-4.44408702628753, -8.24101581397641],
            [-4.450907267267139, -8.243514411114731],
            [-4.454657596412557, -8.246842898222893],
            [-4.468888193627641, -8.2533270441299],
            [-4.472663837274167, -8.257361248686406],
            [-4.4766138583869, -8.257954394679352],
            [-4.480108207516321, -8.263463972330143],
            [-4.480687830387922, -8.271733867703778],
            [-4.482708173191046, -8.275406604652105],
            [-4.4845404192244365, -8.282947605570913],
            [-4.487171392684733, -8.286601373873491],
            [-4.492051565746728, -8.287762676448308],
            [-4.497294013242287, -8.29532387904478],
            [-4.49912741805376, -8.323510981167242],
            [-4.5156021324020275, -8.579875015077384],
            [-4.516946712512915, -8.59213961522446],
            [-4.523682481173204, -8.70331281471829],
            [-4.5241743269503445, -8.706404296324937],
            [-4.530163595296238, -8.795410214272371],
            [-4.5330328398032025, -8.79437176950992],
            [-4.5386310286491485, -8.78930409467011],
            [-4.547862555608224, -8.78665258262395],
            [-4.551197895748478, -8.787814977618131],
            [-4.551376001001789, -8.791858225527516],
            [-4.553852796415777, -8.796284007343456],
            [-4.565027790794746, -8.795653462633776],
            [-4.570549560900148, -8.793462247203639],
            [-4.573386230819002, -8.79081391535506],
            [-4.575955420863157, -8.782745423402273],
            [-4.574882586304107, -8.780281935984158],
            [-4.568973350747017, -8.776070921968627],
            [-4.565805261439978, -8.771880119394174],
            [-4.572871871308714, -8.765399879925441],
            [-4.5779953624179575, -8.763042582794352],
            [-4.584075476758308, -8.766009244145595],
            [-4.584912430579359, -8.76895278875389],
            [-4.58360347427974, -8.77374350841265],
            [-4.579714462999462, -8.780744313306394],
            [-4.579595714244435, -8.783816923355939],
            [-4.5845369312507955, -8.78688995905212],
            [-4.590577065310951, -8.784372571584935],
            [-4.597018671338612, -8.778636011970388],
            [-4.603515968278733, -8.770322178344937],
            [-4.606510868278159, -8.765016118886935],
            [-4.610581688972281, -8.76529120546253],
            [-4.621364889119136, -8.774402849434953],
            [-4.628521273423138, -8.777403523044379],
            [-4.632051394470523, -8.775513013884185],
            [-4.635059576464911, -8.7775363653871],
            [-4.643290087529466, -8.77266620948886],
            [-4.6563410978765525, -8.770957815707389],
            [-4.662843795256148, -8.773533124970827],
            [-4.6720038702344135, -8.784632577721126],
            [-4.675910556728312, -8.785833115096704],
            [-4.679387423067075, -8.78302544687889],
            [-4.678247388273054, -8.778561834980115],
            [-4.678888888155973, -8.771324615795011],
            [-4.681682090629998, -8.767803792914753],
            [-4.689748222872579, -8.766381233925463],
            [-4.697754986894283, -8.77184138141305],
            [-4.702698278416547, -8.768925678426283],
            [-4.7057282229569175, -8.760781422763564],
            [-4.704894397446751, -8.757792977085824],
            [-4.706897376256476, -8.75366008333006],
            [-4.7147637636877056, -8.75031290399677],
            [-4.718752724076008, -8.750648262312362],
            [-4.72074446202006, -8.756541469616508],
            [-4.720021122357756, -8.760008329685709],
            [-4.7224549811922545, -8.766412769647681],
            [-4.7263436038637945, -8.768742813947378],
            [-4.728664443237072, -8.767162217564547],
            [-4.731101875027344, -8.76002395553873],
            [-4.733413562738112, -8.758618124352317],
            [-4.741464895376184, -8.763170840744879],
            [-4.749044292467548, -8.766473971489333],
            [-4.752958819280377, -8.762300563054563],
            [-4.756550076168739, -8.760338206115874],
            [-4.760474545540405, -8.761440667534163],
            [-4.765820677355911, -8.758976272551283],
            [-4.769589357987702, -8.760099997132377],
            [-4.771578644668296, -8.762992418588794],
            [-4.769693311003328, -8.769827689660998],
            [-4.772750760364925, -8.772758822105898],
            [-4.777862350758171, -8.773118859741858],
            [-4.77910208400833, -8.775915451000841],
            [-4.783885838154156, -8.77484110223507],
            [-4.800566217764466, -8.773733378037043],
            [-4.803419189254685, -8.76810759927497],
            [-4.809393813621326, -8.765211217108387],
            [-4.819851984583974, -8.768008496857576],
            [-4.824536190825046, -8.765588315005862],
            [-4.830696705562894, -8.766692074042716],
            [-4.838289809050947, -8.762187203391344],
            [-4.837484803636875, -8.75779866949298],
            [-4.842484644197159, -8.755822989630794],
            [-4.8481683367760375, -8.759116369518654],
            [-4.855154791719365, -8.75521730387785],
            [-4.858982561223521, -8.754233222743338],
            [-4.866363639514446, -8.744783391813266],
            [-4.873186127857558, -8.741923726146332],
            [-4.874647102629021, -8.736744385940417],
            [-4.879405761910768, -8.72994067531698],
            [-4.889050673343091, -8.729649689018016],
            [-4.89087265121962, -8.72414115546707],
            [-4.888249454439738, -8.719357708411172],
            [-4.888082729922006, -8.715335953223695],
            [-4.890414031794313, -8.709416563386434],
            [-4.896086754416284, -8.706167384430822],
            [-4.898816755678933, -8.70827638300272],
            [-4.901268453780903, -8.716429326144809],
            [-4.904160217130422, -8.718060744420317],
            [-4.907082547453929, -8.716709310595904],
            [-4.910962115396273, -8.711655840585767],
            [-4.914777961439252, -8.70950481479113],
            [-4.919639639868975, -8.70990101765612],
            [-4.926782383128635, -8.712523331064784],
            [-4.934155951960768, -8.70415099230813],
            [-4.941752792376808, -8.704457531359237],
            [-4.94462681198472, -8.699902634520633],
            [-4.9426437296708245, -8.693764938064419],
            [-4.944345266965538, -8.688563268507208],
            [-4.947986680854372, -8.688579124854492],
            [-4.949773087608846, -8.69569630122663],
            [-4.952487467937704, -8.698697978465086],
            [-4.960434269668126, -8.696756270341298],
            [-4.960889028114843, -8.693187214995598],
            [-4.958317561130959, -8.687203034423591],
            [-4.960813768700593, -8.68326862974992],
            [-4.964141520731436, -8.682867983437973],
            [-4.9713357674641605, -8.687368205093788],
            [-4.976912313300807, -8.685700631814377],
            [-4.978991295210446, -8.679375618628805],
            [-4.9866754315674005, -8.676088904843478],
            [-4.991653947579993, -8.671465917161985],
            [-5.000429230809803, -8.671547856509576],
            [-5.003614227105614, -8.668452921751584],
            [-5.008279374488164, -8.6692020152992],
            [-5.072187741387718, -8.61017828712735],
            [-5.136079245333018, -8.55113063689842],
            [-5.13998412358846, -8.547637224183735],
            [-5.209192744546373, -8.483134441192316],
            [-5.1931626263843516, -8.2553536574332],
            [-5.13591795755982, -8.258691847280808],
            [-5.134722186156324, -8.258894119831544],
            [-5.000566496361857, -8.267476736285001],
            [-4.988643270008656, -8.093991959070348],
            [-4.988684020179085, -8.093510032861],
            [-4.979456773238871, -7.9560649741277665],
            [-4.864457679952024, -7.964390154124737],
            [-4.804225955931099, -7.968707888726736],
            [-4.799906185096734, -7.910826662290769],
            [-4.711403845981241, -7.9171579457840995],
            [-4.682324879913625, -7.919317151909424],
            [-4.679985416080404, -7.920306218056709],
            [-4.582248882851846, -7.926671687404449],
            [-4.4845111205010975, -7.933019605150559],
            [-4.483729642984123, -7.933357077583748]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.07650053155389,
          "lat": 30.225012376536494
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48443"],
        "coty_name": ["Terrell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Terrell County"],
        "coty_fp_code": "443",
        "coty_gnis_code": "01384007"
      },
      "bbox": [
        -5.209192744546373, -8.796284007343456, -4.384560521513685,
        -7.910826662290769
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.188976331855341, -5.348456468335035],
            [1.2019767169607425, -5.348722255154525],
            [1.2028996066967554, -5.345889602440823],
            [1.2072931093747614, -5.3437802820716485],
            [1.2090768863975476, -5.341075765112886],
            [1.2196206005628354, -5.34278632144609],
            [1.2248340829167532, -5.347992508633424],
            [1.2315041636413704, -5.351624295961231],
            [1.2358454838877837, -5.3465294834114765],
            [1.2389385395847994, -5.34801503807835],
            [1.2452084839059707, -5.345793992068481],
            [1.2473277743357056, -5.351733905898058],
            [1.2519544395644657, -5.354341559972159],
            [1.261251293849318, -5.356157177124001],
            [1.2585140178974474, -5.352696057440853],
            [1.26837791925771, -5.354974314202477],
            [1.2738683997002087, -5.354557424447441],
            [1.2780452232309496, -5.35111812968277],
            [1.2787874626440157, -5.3460839355965],
            [1.2829076138849327, -5.343793765232827],
            [1.2856353785858656, -5.344846202163231],
            [1.2893164340909287, -5.341595817384674],
            [1.292366622848954, -5.345536932367003],
            [1.2998022403324154, -5.3446076078679505],
            [1.3009320467353613, -5.346501448556227],
            [1.3070932041671997, -5.348752847678545],
            [1.3114651883602395, -5.346957770531267],
            [1.320835348764295, -5.348667403430138],
            [1.3251813865779793, -5.346576104216773],
            [1.325065227576342, -5.3443046578776165],
            [1.3297842258976096, -5.343127331872672],
            [1.3319174738883628, -5.345629317607129],
            [1.3388099832086071, -5.3445188182809344],
            [1.3399700419498446, -5.347031332582716],
            [1.3454374698678955, -5.347958100166928],
            [1.3468234015820622, -5.3503988025091545],
            [1.3538424851627888, -5.352456528663112],
            [1.3576417342000104, -5.35200169049165],
            [1.3608182919356389, -5.348591310742863],
            [1.368746738704244, -5.349006331399815],
            [1.3721389239363841, -5.34665065770625],
            [1.3760503128397894, -5.346171581973377],
            [1.3843458083680584, -5.340842319427783],
            [1.3840383468414308, -5.337677854278247],
            [1.3957865503026428, -5.341540532914704],
            [1.4017713479043223, -5.346658943070265],
            [1.40197791135215, -5.352351794875073],
            [1.4065460868263442, -5.353717072223655],
            [1.4112533415856807, -5.358893914944793],
            [1.417862356182794, -5.35327873628918],
            [1.4205989871176998, -5.356643191624532],
            [1.4263357826943703, -5.351933043286008],
            [1.4339288944411999, -5.352528073858632],
            [1.4354472116767378, -5.356251812412551],
            [1.438884910849286, -5.35588673742738],
            [1.4484855281870441, -5.359565369216835],
            [1.4458333539864283, -5.363188224473125],
            [1.4463127020513729, -5.368877338455059],
            [1.4480339769205335, -5.372505923836232],
            [1.451893111671942, -5.371493495309941],
            [1.451666956350503, -5.463173981557525],
            [1.4514470224980491, -5.4659627966917],
            [1.450641111822516, -5.525042190753679],
            [1.4499057430294138, -5.610378015329295],
            [1.449593785617223, -5.613375087190346],
            [1.4488107297788888, -5.659742842705979],
            [1.4485763993397633, -5.698612246419526],
            [1.4474900886897404, -5.753017079669174],
            [1.438305851916888, -5.748034360133722],
            [1.433666847399259, -5.744101740058174],
            [1.42560378182054, -5.740608784745011],
            [1.4194167532980186, -5.7347092623339],
            [1.4137978861436655, -5.732379269224837],
            [1.4144305134420665, -5.722920711530292],
            [1.4099743669133955, -5.721363574379622],
            [1.4053512457213044, -5.72255398793623],
            [1.400365555417532, -5.720735203674955],
            [1.3996773206308077, -5.717093186072163],
            [1.3882178825301468, -5.711441954176187],
            [1.389504864943848, -5.706027262309979],
            [1.3853060692688393, -5.705832653756662],
            [1.3837537567304148, -5.7007522376316295],
            [1.3793030871692933, -5.699001952582599],
            [1.3783941304196872, -5.695048595507798],
            [1.370941326976718, -5.690800527592584],
            [1.3679194514858661, -5.692265051216499],
            [1.3650298919885806, -5.690597321227254],
            [1.362025159358248, -5.6815957730007876],
            [1.3594745038720588, -5.680023113512602],
            [1.3607817454734616, -5.674508993844185],
            [1.3580374309960423, -5.6745609319642565],
            [1.3571504752778103, -5.666264060246081],
            [1.351507252279888, -5.665308671833184],
            [1.3497367121836676, -5.6629947682993285],
            [1.345495587554532, -5.66393330542239],
            [1.3374457830879363, -5.662558868074392],
            [1.3278935109935759, -5.663931233120028],
            [1.3173316905013346, -5.664456950823962],
            [1.3134495857172293, -5.659968435747599],
            [1.308191204663461, -5.661260393812654],
            [1.3068193764043436, -5.664017237930156],
            [1.2940440931692645, -5.6625581715611215],
            [1.2903626075164538, -5.666415468659721],
            [1.2868427984014075, -5.66187485476333],
            [1.2811170531150144, -5.661910881203945],
            [1.2703985679499732, -5.664772621441562],
            [1.26315258965409, -5.667803370026984],
            [1.2565453246788563, -5.671633294848841],
            [1.2578500855242938, -5.674839186483175],
            [1.2511581515119583, -5.67636593743607],
            [1.2459990653000872, -5.6834163687224795],
            [1.238441991307238, -5.683368147832436],
            [1.2312910771056897, -5.68610944506102],
            [1.230465555472824, -5.690717192138161],
            [1.2256623779769311, -5.694460745893791],
            [1.2210029261509305, -5.695958346146724],
            [1.2179527442707212, -5.700769221560125],
            [1.2143342897379166, -5.701237062687913],
            [1.2093448418804664, -5.705956639533674],
            [1.202984804778645, -5.706915256914779],
            [1.2009411950643025, -5.7044226540905285],
            [1.1949420803399344, -5.70279561502023],
            [1.1916976227116334, -5.704002042097579],
            [1.1913597639121007, -5.614750862722504],
            [1.191518740426255, -5.577426945826694],
            [1.190966121113729, -5.481045528993379],
            [1.189893532713676, -5.402349966664466],
            [1.188976331855341, -5.348456468335035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.96574381230975,
          "lat": 33.216648670567984
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48449"],
        "coty_name": ["Titus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Titus County"],
        "coty_fp_code": "449",
        "coty_gnis_code": "01384010"
      },
      "bbox": [
        1.188976331855341, -5.753017079669174, 1.451893111671942,
        -5.337677854278247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.427819180809179, 1.1932693558318979],
            [-13.250260528184711, 1.1599910804920215],
            [-13.072706362383856, 1.1266886217950705],
            [-12.895156657761799, 1.093361983792791],
            [-12.717611387740186, 1.0600111755204142],
            [-12.578781619078985, 1.0350566834330652],
            [-12.439954464343307, 1.0100874716766421],
            [-12.32633881628541, 0.9899997050038225],
            [-12.259151341709648, 0.9782902876903532],
            [-12.262357750459323, 0.9735812295238789],
            [-12.26202433539941, 0.9619794835574932],
            [-12.263715061035741, 0.9603480976579832],
            [-12.265513202727131, 0.9520910842921445],
            [-12.264914403840626, 0.9473721363746733],
            [-12.266835684269372, 0.9363525757832389],
            [-12.269423626571859, 0.9308685552422195],
            [-12.273595075902058, 0.9280336169653981],
            [-12.272176971040507, 0.9220697539239937],
            [-12.272417712629712, 0.9166216379779769],
            [-12.271559216919155, 0.9072246430447336],
            [-12.27448054402654, 0.906339207424959],
            [-12.273252301948514, 0.9001401336167829],
            [-12.269792012368647, 0.8939799862304706],
            [-12.272022794709564, 0.8905878246100728],
            [-12.277882251677509, 0.8876839920147956],
            [-12.27762826931586, 0.8836661035234809],
            [-12.274570877556327, 0.8815508220535982],
            [-12.27332129512806, 0.873031358742711],
            [-12.267031558599193, 0.8694945250171572],
            [-12.267364220233786, 0.8672074817053586],
            [-12.263499058743248, 0.8547947921878382],
            [-12.259777728078069, 0.8517952319819453],
            [-12.253311228483145, 0.8493442589153306],
            [-12.249122913882378, 0.8444215860796015],
            [-12.247846212895988, 0.8402537817123599],
            [-12.239960872983517, 0.8330376409525653],
            [-12.236554315849615, 0.8271241842339492],
            [-12.237189730412691, 0.8169913776965401],
            [-12.234029459124773, 0.802919226334229],
            [-12.228591686315836, 0.7978446463141304],
            [-12.219451964460275, 0.8011410089281694],
            [-12.215173897349477, 0.8049267600756003],
            [-12.210548539197777, 0.8126780657164218],
            [-12.207301259808252, 0.8119015409773126],
            [-12.201031970262457, 0.8061512052622207],
            [-12.199625614318053, 0.7938346424409745],
            [-12.203985186855903, 0.7919409252233833],
            [-12.20492099049761, 0.7862660674662901],
            [-12.203080514578659, 0.7838257376407552],
            [-12.201967853863136, 0.777330626277302],
            [-12.197883346957667, 0.7705638583549581],
            [-12.189565849162726, 0.7683531176133163],
            [-12.186739177096067, 0.7650130237284049],
            [-12.184548199130479, 0.7565639730570682],
            [-12.181873262045796, 0.753806056190188],
            [-12.179505651848537, 0.748074256857649],
            [-12.180013405553748, 0.743042314328123],
            [-12.172912289895194, 0.7337189034348012],
            [-12.167010108401898, 0.7309985924368139],
            [-12.164319084879166, 0.7235614764524628],
            [-12.163484888849634, 0.7150930380786109],
            [-12.16647814416407, 0.7133836421245885],
            [-12.168728131078225, 0.7090129088366234],
            [-12.171180112266176, 0.6983673260336867],
            [-12.16953220184359, 0.6952997946598765],
            [-12.177897822577059, 0.689937343637726],
            [-12.179676246252003, 0.6846044411975327],
            [-12.179492332283404, 0.6755014583005562],
            [-12.18384673963269, 0.6668271056495481],
            [-12.18871575403847, 0.662541637253398],
            [-12.194522800449514, 0.658991365778434],
            [-12.199024870585742, 0.6526163431559332],
            [-12.2008459095506, 0.647755237225565],
            [-12.20653851529209, 0.6450087078393313],
            [-12.212325670908893, 0.6398222290994445],
            [-12.212663803181515, 0.6336535850070592],
            [-12.207372292630875, 0.6263167522101253],
            [-12.207863632258306, 0.6228529273149704],
            [-12.202916452409847, 0.6140453165200641],
            [-12.198643743579831, 0.6112393997235515],
            [-12.206282638536765, 0.6023901306454166],
            [-12.21653831961315, 0.5994636731888907],
            [-12.221604669532518, 0.600454194851494],
            [-12.22668795923333, 0.5974885992223841],
            [-12.230957329893958, 0.5973200740216233],
            [-12.234246991515562, 0.5910935620681171],
            [-12.244525460895195, 0.5857656815975615],
            [-12.247536305575101, 0.5820246857258873],
            [-12.257712295803575, 0.576320574202132],
            [-12.258066192492555, 0.5660079743529551],
            [-12.261602780931447, 0.5626173579863858],
            [-12.267643508085362, 0.561571752580031],
            [-12.26811442964359, 0.5520912515984802],
            [-12.278374353279805, 0.5482098253573962],
            [-12.29234800920332, 0.5506531990372324],
            [-12.300997309700824, 0.5509952333712476],
            [-12.305371864445418, 0.5502860565755947],
            [-12.409034085662714, 0.5691564396019543],
            [-12.471313730072325, 0.5796450096041789],
            [-12.523685945453092, 0.5888844930298834],
            [-12.564685261060687, 0.5962689209419382],
            [-12.571550923762107, 0.5979881932530691],
            [-12.59962846624263, 0.6027193022449833],
            [-12.673992383957534, 0.6166035658562262],
            [-12.901004020585253, 0.6583928711939515],
            [-13.052872178426078, 0.6869737388176351],
            [-13.204742988817321, 0.7155401956729952],
            [-13.356616475072142, 0.7440922377325209],
            [-13.508492660002727, 0.7726298636480258],
            [-13.489381124540223, 0.8730070247636372],
            [-13.48602076340965, 0.8875164871930613],
            [-13.459901294755632, 1.0262681792258475],
            [-13.441990142968608, 1.120925316919056],
            [-13.433140131339396, 1.1642831222012804],
            [-13.427819180809179, 1.1932693558318979]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.23550812119976,
          "lat": 38.356948013026575
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49001"],
        "coty_name": ["Beaver"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beaver County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01448015"
      },
      "bbox": [
        -13.508492660002727, 0.5482098253573962, -12.163484888849634,
        1.1932693558318979
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.699348971454908, 0.8099852257978485],
            [-11.690318590725798, 0.8165654399788692],
            [-11.474009527838234, 0.7806629813107839],
            [-11.34575871947402, 0.7597825465903385],
            [-11.347433055591152, 0.7496503446350526],
            [-11.30451224966825, 0.7426711885703737],
            [-11.145253578818421, 0.7172670548203596],
            [-10.98599785366484, 0.6918443235714625],
            [-10.831212443468356, 0.6681917595821745],
            [-10.676429716670306, 0.6445216656590778],
            [-10.52164965523537, 0.6208340413951758],
            [-10.366872240698948, 0.5971288892069269],
            [-10.363895824771179, 0.5925083573590656],
            [-10.36352864718327, 0.5892525366324685],
            [-10.353629339822842, 0.579497669019561],
            [-10.351716946150564, 0.5761933435492929],
            [-10.353400095447734, 0.5676245116288193],
            [-10.362196300836576, 0.5538999693296748],
            [-10.363113588368899, 0.5452837414995608],
            [-10.364775402563149, 0.5430427858166401],
            [-10.36967883539015, 0.5427390681463691],
            [-10.37392750945843, 0.5478906669178975],
            [-10.37717852045932, 0.5550124885565064],
            [-10.381030645021868, 0.5583467830335074],
            [-10.387236390024713, 0.5559370798426537],
            [-10.389040724993022, 0.5483929715045056],
            [-10.384163112214353, 0.5449230695259508],
            [-10.375673958629493, 0.5447927400428718],
            [-10.368761461272966, 0.5269127201560336],
            [-10.36553265685626, 0.5219845166093302],
            [-10.362409517826972, 0.5108238151211831],
            [-10.363976586294195, 0.5066607662531075],
            [-10.374789972410431, 0.5017443578850402],
            [-10.382893375359272, 0.490948498027654],
            [-10.387228215264464, 0.49055680802842044],
            [-10.38971346801985, 0.4870532482638786],
            [-10.38865649074331, 0.4824144542342871],
            [-10.380365102281797, 0.47978032389248926],
            [-10.373495504573489, 0.4731871832622657],
            [-10.37413852373362, 0.4670014655869172],
            [-10.378998754799433, 0.4628109591920763],
            [-10.374178829467503, 0.4603597742608393],
            [-10.367585929991161, 0.46494576492737827],
            [-10.355215262615106, 0.4789437834279971],
            [-10.347896032972631, 0.4816727809181471],
            [-10.344492444293936, 0.47900050619421947],
            [-10.343558254026238, 0.4749760835297781],
            [-10.34602365227679, 0.46562543058944644],
            [-10.352765670342025, 0.45620087342592125],
            [-10.358239647098166, 0.45299424541054734],
            [-10.356903538544435, 0.4446257304771448],
            [-10.350837987330067, 0.4366857142211808],
            [-10.343883535705194, 0.43014803516416034],
            [-10.338213694600146, 0.43144870132610996],
            [-10.335355607790687, 0.43507023733026307],
            [-10.333192315147102, 0.4433175145688858],
            [-10.330002282207802, 0.44438822388586746],
            [-10.325186882511098, 0.4429395698168193],
            [-10.324866769119689, 0.4376467233187208],
            [-10.328693335608927, 0.43319421305992034],
            [-10.33216599133875, 0.4262203253454915],
            [-10.342747224613579, 0.42414210415917436],
            [-10.346196891378131, 0.42087369056872775],
            [-10.34606953562107, 0.40979984401948966],
            [-10.344944304343038, 0.4074519523482439],
            [-10.337761581210223, 0.40351103757793866],
            [-10.334515346800139, 0.396007363582221],
            [-10.338614736641176, 0.3878848280948585],
            [-10.3401734796879, 0.38282568984654936],
            [-10.33783237858763, 0.3764990010148011],
            [-10.330192917741991, 0.3732696269112605],
            [-10.32516759325586, 0.3680945972397213],
            [-10.324942525837518, 0.3636303903222432],
            [-10.333167873857692, 0.35277559814935905],
            [-10.330143301199916, 0.34681494373535676],
            [-10.324490791612101, 0.3468921764793656],
            [-10.313230900831739, 0.3550334165063262],
            [-10.310346137321476, 0.3545898344007799],
            [-10.308167876665168, 0.34828451069302635],
            [-10.30798087302129, 0.3401914427629015],
            [-10.311793001772907, 0.33563126253347253],
            [-10.32165093834733, 0.3317319530691942],
            [-10.32271637871615, 0.32803689668196223],
            [-10.319970396865443, 0.32355213291652996],
            [-10.317075710731944, 0.32347650057827465],
            [-10.309737527097074, 0.3262717679353408],
            [-10.305912967152233, 0.3233619025279621],
            [-10.301774594830535, 0.3120753151143378],
            [-10.303552285328099, 0.3101476103734829],
            [-10.312595096323012, 0.31286842258724556],
            [-10.323475278232113, 0.31233070428476],
            [-10.32667609027255, 0.3098600521170903],
            [-10.326763226934887, 0.30208271612574844],
            [-10.321277003414407, 0.2956965336701791],
            [-10.313267298690965, 0.2901864704104416],
            [-10.304398065082182, 0.28948900121446003],
            [-10.30838817955116, 0.2834724751522711],
            [-10.317436099807061, 0.27813059192736334],
            [-10.319472565956419, 0.2736741348295466],
            [-10.315433710783662, 0.27106633882831943],
            [-10.309787207520133, 0.2725314895884601],
            [-10.305233042751002, 0.2697402602907922],
            [-10.307126317087322, 0.26527880892688516],
            [-10.310017309570915, 0.26322912450079383],
            [-10.320872260230516, 0.26202789091198725],
            [-10.330385956969325, 0.2524614947105696],
            [-10.336668677497247, 0.24847532132385466],
            [-10.344097933372923, 0.24605827431982133],
            [-10.346346693636917, 0.2442242264334664],
            [-10.343614085175524, 0.23821279632280518],
            [-10.526998885721397, 0.26635614358868737],
            [-10.71038680675912, 0.2944787439260827],
            [-10.893777888886872, 0.32258059288664204],
            [-11.077172171843626, 0.35066169160561983],
            [-11.256760519389442, 0.3794409917995683],
            [-11.274996130524148, 0.38246098995795846],
            [-11.282510828964913, 0.38410113248624334],
            [-11.312184988946475, 0.38891704946280964],
            [-11.486809080638222, 0.4181694593555522],
            [-11.487457192794098, 0.4144640018829823],
            [-11.55878327972648, 0.4260928556080542],
            [-11.657281493900763, 0.4425309593271236],
            [-11.657125580226722, 0.44357474934520474],
            [-11.816876839418326, 0.47032440935231573],
            [-11.793972666349205, 0.6157194658634452],
            [-11.775261329634837, 0.7435760264600622],
            [-11.77151737378027, 0.7462962101933954],
            [-11.766681933000179, 0.7461257845258464],
            [-11.761503459296875, 0.7564531394139898],
            [-11.75651649395911, 0.7588266610507903],
            [-11.750584735399668, 0.7724822302621291],
            [-11.699348971454908, 0.8099852257978485]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.90384506156099,
          "lat": 38.324378099556824
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49055"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01448041"
      },
      "bbox": [
        -11.816876839418326, 0.23821279632280518, -10.301774594830535,
        0.8165654399788692
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.637675532438026, -0.7415400675463432],
            [12.640550721499897, -0.7365349027046628],
            [12.648260839888097, -0.7329446537231867],
            [12.650052406103521, -0.7285128414263128],
            [12.653389613368661, -0.726771626818219],
            [12.655806905734583, -0.7203173165374658],
            [12.655122893144522, -0.7176139873397884],
            [12.65049095597978, -0.714619074994758],
            [12.655441858395283, -0.7115238597833917],
            [12.662409730527434, -0.7186281778629925],
            [12.663616012760388, -0.7233697131176426],
            [12.667877947836715, -0.7294636892007491],
            [12.67354740209958, -0.7320005416071534],
            [12.677405765579621, -0.7321635981377301],
            [12.683260338700446, -0.7303391027121942],
            [12.680539904581012, -0.7197026425706029],
            [12.683947828021656, -0.7201512574754865],
            [12.687990502562133, -0.7240958815036709],
            [12.692652815299642, -0.7224301243064928],
            [12.689943129813456, -0.7160302585650454],
            [12.692010217238058, -0.7142293645577078],
            [12.696077047956118, -0.7163400386868928],
            [12.698894373630885, -0.7124300867054798],
            [12.696663967296997, -0.7047162355701906],
            [12.703696941178778, -0.7028478051683512],
            [12.705382444182025, -0.7005066768409521],
            [12.702976001810013, -0.6975137107879128],
            [12.703690267129568, -0.6930089930950897],
            [12.708788389835282, -0.6950673737830281],
            [12.710673799138931, -0.7034796611491257],
            [12.713219648977018, -0.7060810371540888],
            [12.716987095911788, -0.7011659444707462],
            [12.71803583264565, -0.6955414621281799],
            [12.723217815959714, -0.6962015646420516],
            [12.727576355962487, -0.7000480722531505],
            [12.72824877507762, -0.7058200277602935],
            [12.730103789923374, -0.7082384050706723],
            [12.737032550886077, -0.7063472156914173],
            [12.73725411367231, -0.6996648905040931],
            [12.73168698627189, -0.6941470968822973],
            [12.73292803106089, -0.6875079452130262],
            [12.736959801483845, -0.6894656620176273],
            [12.741390026491855, -0.6938910949987147],
            [12.748260572681353, -0.6904905579365397],
            [12.752132808352647, -0.6847442519592684],
            [12.762419292424173, -0.6861376975035551],
            [12.768506604428215, -0.6818302608432998],
            [12.77191480872215, -0.6828150959178394],
            [12.777347301835364, -0.6820584369324688],
            [12.784606735068026, -0.6794646372793841],
            [12.785701326478918, -0.6742543636990467],
            [12.81287502088336, -0.6332315761286151],
            [12.825156101396686, -0.6141272278111687],
            [12.86535216805316, -0.5897040946696569],
            [12.874484877313964, -0.5850219073357604],
            [12.901625012450161, -0.5659327140417764],
            [12.90595387650509, -0.5696128859252708],
            [12.911701431081616, -0.5667382275748246],
            [12.914477834286572, -0.5680794513932027],
            [12.922582990906939, -0.5630493243170246],
            [12.92255732475602, -0.5606178350791222],
            [12.931195211510538, -0.5550299670973604],
            [12.935578793438388, -0.5541307037726431],
            [12.938543392316529, -0.5499920786270752],
            [12.941236779188525, -0.5499414812224394],
            [12.944341503404488, -0.5548325650062532],
            [12.946126145982511, -0.5602052439509609],
            [12.944486868889648, -0.5634080443650795],
            [12.946399321183762, -0.5659761320286488],
            [12.95489445244553, -0.5726200561888176],
            [12.956136584642246, -0.5759932524932035],
            [12.954010196591266, -0.579705396948039],
            [12.962014545287932, -0.5920028852053802],
            [12.963243634968398, -0.5966591704154264],
            [12.960091828555356, -0.6021059303284434],
            [12.960684607803334, -0.6048637017216251],
            [12.956098464801519, -0.6081828077451422],
            [12.954411121523561, -0.6161845674857106],
            [12.964617426344482, -0.6244646275481243],
            [12.963536637656848, -0.6302744279255169],
            [12.966764783768642, -0.6337639984207369],
            [12.967189671915214, -0.6390801527644451],
            [12.971782431977454, -0.6409416607813327],
            [12.97222003850836, -0.6442559563054585],
            [12.966521671559716, -0.6455185819334803],
            [12.968452143084575, -0.650990244798013],
            [12.96561043159708, -0.6535164254199205],
            [12.969390167525937, -0.6564777963664006],
            [12.966917086554767, -0.6594219982798813],
            [12.96625031361906, -0.6637610993344435],
            [12.962710270272348, -0.6668635274774724],
            [12.95421484006881, -0.6669828386152847],
            [12.953880414359253, -0.6752894305068226],
            [12.95992544381815, -0.6765079208007709],
            [12.962067562899684, -0.675586779762391],
            [12.966392683799834, -0.680013780908598],
            [12.954555731483174, -0.6876584369837324],
            [12.955136458928045, -0.6903577546713737],
            [12.950579798801382, -0.6940850867061218],
            [12.953166247566383, -0.6996665987074832],
            [12.958303877730799, -0.7054572022385921],
            [12.9594761802884, -0.709714425577028],
            [12.954581463863217, -0.7163981849850931],
            [12.953722732449782, -0.7193388182522158],
            [12.954819235305097, -0.7248875579572822],
            [12.949156022249328, -0.7234820060512555],
            [12.94729363085854, -0.7272619828701364],
            [12.944671579852528, -0.7273345615285174],
            [12.938301514766192, -0.7220441498609779],
            [12.933135058300294, -0.7243951276384509],
            [12.930669937034658, -0.7280885106903576],
            [12.929335335341381, -0.7364147088327018],
            [12.926328840000242, -0.7377591970804105],
            [12.9253171479744, -0.7494429993085884],
            [12.92287855989756, -0.7585632223856132],
            [12.918488845635515, -0.7603881405346898],
            [12.92088273137958, -0.7796096485939221],
            [12.897193077037697, -0.8136687387385053],
            [12.892445978567274, -0.8167304426035047],
            [12.883485016859588, -0.8174390098532953],
            [12.882978364667697, -0.8236814881885036],
            [12.868711027380147, -0.8289720164627602],
            [12.856991947419726, -0.8352796998225053],
            [12.853933954419203, -0.8457666107007336],
            [12.846899927287291, -0.8517830978607567],
            [12.843764531777692, -0.8510988123609045],
            [12.837943062385307, -0.8526291781332742],
            [12.835525452313902, -0.8560088289342025],
            [12.835681000885733, -0.8593080501899382],
            [12.831616133559775, -0.8610734684996393],
            [12.83141534622137, -0.8669894477203716],
            [12.820400396365072, -0.8662730535311578],
            [12.819938920966994, -0.8714390427343014],
            [12.822805340010234, -0.8791997437880393],
            [12.821728365099247, -0.8862926707052599],
            [12.818416781371964, -0.8883637134381323],
            [12.818163531963528, -0.8914881446945913],
            [12.810024465641693, -0.8988602357382258],
            [12.80623509434979, -0.8982807036366444],
            [12.802694103298837, -0.9003838450570898],
            [12.799826922173802, -0.8990922524299689],
            [12.795475791620083, -0.9046725073709073],
            [12.791116719325382, -0.9075368890721133],
            [12.789599985464182, -0.9158035708895164],
            [12.794428611958924, -0.9198505454244152],
            [12.79035541434176, -0.9260471477937081],
            [12.790697778102615, -0.9296946220565149],
            [12.794351895454968, -0.9315377543268251],
            [12.795106014119789, -0.935237729002599],
            [12.788428649924695, -0.9421070150493956],
            [12.790357684105583, -0.9532406045832597],
            [12.794353374695799, -0.9574840973696453],
            [12.793763967347594, -0.9615733850553434],
            [12.789832201628816, -0.9641073392225142],
            [12.787523876146578, -0.9629015280512211],
            [12.780907827402487, -0.9663571826333278],
            [12.769519552163228, -0.9658270925288153],
            [12.766902973117697, -0.9672643792584737],
            [12.76320431947502, -0.9657863200692881],
            [12.754801011651669, -0.9645182991955737],
            [12.750973637113644, -0.9679863385086779],
            [12.746929983678939, -0.9747177505056447],
            [12.744790504206984, -0.9758902458980058],
            [12.750446877207125, -0.9809196631395041],
            [12.75034342950572, -0.9845186704189993],
            [12.744705849374355, -0.9896639574721893],
            [12.744084448924184, -0.9982765303756898],
            [12.74526843750658, -1.006137056681714],
            [12.712387819897296, -0.9675155196927362],
            [12.709798648061483, -0.9647383651365938],
            [12.642729687171288, -0.8853026292595066],
            [12.57595672975707, -0.8057105891880569],
            [12.577297431640028, -0.801705084858522],
            [12.580173246509752, -0.7990274559780169],
            [12.586825510794611, -0.7980471800201215],
            [12.59049721090551, -0.7933057559372311],
            [12.5989072192093, -0.7898173815672682],
            [12.602862138514777, -0.7896548123273625],
            [12.606915212170588, -0.7849481939444358],
            [12.613994026870449, -0.7730310347398408],
            [12.62108377907173, -0.7699490591677364],
            [12.624441283373795, -0.759880614767684],
            [12.632927597785844, -0.7571433751029573],
            [12.635477993723361, -0.7512363016457967],
            [12.634498646753674, -0.7442199185866413],
            [12.637675532438026, -0.7415400675463432]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.36253157873709, "lat": 36.93161304639306 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51063"],
        "coty_name": ["Floyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Floyd County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01494354"
      },
      "bbox": [
        12.57595672975707, -1.006137056681714, 12.97222003850836,
        -0.5499414812224394
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.145101232021474, 0.7229850067596736],
            [15.150995515087274, 0.7164314402073201],
            [15.14937147461428, 0.7100114467619305],
            [15.146690476711363, 0.7043774621208416],
            [15.155949832745293, 0.70247015333859],
            [15.161525148887641, 0.6985587340668223],
            [15.163267424449554, 0.6917449390265272],
            [15.167150518947231, 0.6927663495937884],
            [15.168968521312207, 0.6904264247531292],
            [15.176117645758426, 0.6906980295512531],
            [15.180595499693492, 0.6896543197345859],
            [15.183221610144631, 0.6861274646086968],
            [15.183313183678006, 0.6815966077809559],
            [15.192333346618899, 0.6708918446534393],
            [15.190641663924874, 0.6642333098953527],
            [15.190878077240328, 0.6592186526523743],
            [15.195174472296618, 0.653396562153451],
            [15.199188113608542, 0.6520236201530574],
            [15.196432943850565, 0.6479025279294294],
            [15.19827933804089, 0.6459859300920098],
            [15.1938616975502, 0.6423857742136118],
            [15.18605390622973, 0.6405389973179704],
            [15.184460237003305, 0.6363474326172354],
            [15.18638726464365, 0.6326934663397197],
            [15.196439510845499, 0.6286500193396216],
            [15.20407248588101, 0.6280535784279233],
            [15.208081114852002, 0.6161712665869427],
            [15.208236936855325, 0.6122404788888566],
            [15.222070955314033, 0.6059289308838722],
            [15.230517786856929, 0.6061527347183993],
            [15.231042977033693, 0.6088565862868917],
            [15.238044190587921, 0.6122460585207439],
            [15.249150250671075, 0.6037475234947418],
            [15.257634097276627, 0.6054583578404591],
            [15.26130598405734, 0.6072045546477968],
            [15.268144290196, 0.6071739114585446],
            [15.269934423687813, 0.5952778691793267],
            [15.271392681210676, 0.590246969233119],
            [15.275183043721775, 0.585915670090984],
            [15.276300884763973, 0.5824941492474558],
            [15.276595975627878, 0.5737079757418667],
            [15.278908946450196, 0.5646580030248977],
            [15.281137229566982, 0.564028954031818],
            [15.282759465737586, 0.5691934980261294],
            [15.28692008668643, 0.5731050471938876],
            [15.289981943165687, 0.5735639531220448],
            [15.292422203363751, 0.5774114324364523],
            [15.304292905675908, 0.5816165297160059],
            [15.314120318108051, 0.5790222284429483],
            [15.319140721302094, 0.5788767201918614],
            [15.324514228343036, 0.5726367230430205],
            [15.329212979736381, 0.5721252885162275],
            [15.333192938968946, 0.5735873851774366],
            [15.340802486395338, 0.5811104171430685],
            [15.34463171414783, 0.5834803451117055],
            [15.349639828458152, 0.5886019128659644],
            [15.35285858803151, 0.5933820261157154],
            [15.357803450336183, 0.5935680543999151],
            [15.366925621815032, 0.5911105361765864],
            [15.370804522483585, 0.5913009852022207],
            [15.37561485012567, 0.5940868540318058],
            [15.380453063974066, 0.5944061298386702],
            [15.384554145218505, 0.5963672091163426],
            [15.394734743892464, 0.5902973287598339],
            [15.394419027436802, 0.5864539146499174],
            [15.398486132801954, 0.5757180759506578],
            [15.403578767020598, 0.5723212171275825],
            [15.414187149719574, 0.5691217998518202],
            [15.417038537447468, 0.5643032170142154],
            [15.425083526858696, 0.5597246681654122],
            [15.433450022075649, 0.5484391382530527],
            [15.43446807855142, 0.5437846518351204],
            [15.437146500467467, 0.539077291123428],
            [15.441132223689836, 0.5262689508529855],
            [15.44059120886778, 0.5223220681998977],
            [15.444718898156934, 0.5170959323972709],
            [15.44857892825842, 0.5149972164855046],
            [15.44995377469916, 0.5110850502910542],
            [15.459959444136283, 0.5019818167547154],
            [15.465102766279998, 0.5039515316460186],
            [15.464684341165094, 0.4997882709291089],
            [15.46547550914516, 0.4902470509400611],
            [15.470583898859196, 0.48858202133014694],
            [15.47040060796962, 0.4850763378029119],
            [15.473047796360616, 0.4801702901197466],
            [15.477257090260748, 0.4770989941625885],
            [15.476973745781484, 0.47420050905306976],
            [15.483415061295824, 0.4732999713608649],
            [15.487476757682153, 0.4698028305611969],
            [15.488384488301953, 0.46350292376487096],
            [15.491997526754792, 0.4604537698557738],
            [15.496389938620549, 0.46027357503480326],
            [15.499770981874315, 0.4505085666906064],
            [15.508621829380012, 0.4451839975038754],
            [15.512631600713473, 0.4397985139677522],
            [15.520295368964016, 0.43913897781611777],
            [15.522896928273168, 0.4362606721790558],
            [15.529542046199973, 0.4344742801402589],
            [15.530799324015772, 0.431513702012349],
            [15.537159939211268, 0.4303527580603783],
            [15.537936857562814, 0.4000472945404016],
            [15.538515596537724, 0.39308233818804805],
            [15.540699932684289, 0.38446902742521166],
            [15.541112205244405, 0.36592098166858633],
            [15.540629061260018, 0.3552408050460582],
            [15.54381596214239, 0.34607643271485533],
            [15.554369185870264, 0.33490881032617226],
            [15.561401299735458, 0.3258608986784309],
            [15.563727723659458, 0.32522041750057096],
            [15.565100136090086, 0.3163663379274721],
            [15.56749815911934, 0.3161500337017792],
            [15.567671944457377, 0.3108397429190926],
            [15.565392994160737, 0.30918038337548187],
            [15.565870211847331, 0.30218098190967135],
            [15.55949751785186, 0.2887271636243091],
            [15.560877861801156, 0.28625389556080455],
            [15.557021537954105, 0.2822167772927606],
            [15.553822792557375, 0.28594204909028875],
            [15.55078157953306, 0.28690787148207514],
            [15.54370800526487, 0.27726259618950033],
            [15.543502911251093, 0.2715498666233175],
            [15.540309089443522, 0.27058257991799745],
            [15.533581869240322, 0.2726941498146081],
            [15.529830369394166, 0.26889180273629043],
            [15.531591537254053, 0.2657449813152876],
            [15.530826871912643, 0.257900796163484],
            [15.52739423093878, 0.25114685813347365],
            [15.513011328065428, 0.2614327649999732],
            [15.507635922662809, 0.2665945692983232],
            [15.497265116989537, 0.28182454676626123],
            [15.490836373908458, 0.2919229204270413],
            [15.486364397217791, 0.29697116266200296],
            [15.474522048412457, 0.30445908526198645],
            [15.462715328999149, 0.3088334387618157],
            [15.453203906435864, 0.31070385643587195],
            [15.450808753899112, 0.3148278122219854],
            [15.448373382391267, 0.32386853856454034],
            [15.451715797720095, 0.32946404775391414],
            [15.450875960586394, 0.3346529863693578],
            [15.447104395022464, 0.34378165333895083],
            [15.452879110283552, 0.3541259167692939],
            [15.453237735556408, 0.35900604659057544],
            [15.451547043195918, 0.3633701102637575],
            [15.445805583419832, 0.3730781537524892],
            [15.443272683099016, 0.3758852994289341],
            [15.43905301346117, 0.37669657534476325],
            [15.434468648151046, 0.37560480009700103],
            [15.43107373036352, 0.38031572333499003],
            [15.433500094170602, 0.38690653781504775],
            [15.433285074933462, 0.3915493491050673],
            [15.431155923092303, 0.3942982134998714],
            [15.427130464198163, 0.3954816087760479],
            [15.416912861838219, 0.3910078343984331],
            [15.409704519375596, 0.39218503229611784],
            [15.406954894996964, 0.3939200561616291],
            [15.406341256505147, 0.3974411341811101],
            [15.408680315450423, 0.40060967083472243],
            [15.412697782961533, 0.4020283747401449],
            [15.412026268722258, 0.4069888586996115],
            [15.402396375199068, 0.4050066603842793],
            [15.39860250113815, 0.40582851417007737],
            [15.39393912275651, 0.4132123289882085],
            [15.390605656425572, 0.4150438104639356],
            [15.385071218745486, 0.4103831214102074],
            [15.381187431381417, 0.4091477771082571],
            [15.369669309680912, 0.41101384426255155],
            [15.367484611844972, 0.41337953279212086],
            [15.367923236671077, 0.41710289839688264],
            [15.375575457776234, 0.42223478238454765],
            [15.37691058915885, 0.4281150032862006],
            [15.372338378132008, 0.4338124718306389],
            [15.366410631296331, 0.43687335613277606],
            [15.353578700741938, 0.4476150231293696],
            [15.346771015623968, 0.4473967069317175],
            [15.338371885140015, 0.44272648176828744],
            [15.331972268845169, 0.44138083909399645],
            [15.327835687168914, 0.44270579913763963],
            [15.326548444878842, 0.4453229704818599],
            [15.329981645972811, 0.4572451701573665],
            [15.326498509316156, 0.4626756896773564],
            [15.324024164341228, 0.46384444040609457],
            [15.319426755268388, 0.4697583164894456],
            [15.318011744793637, 0.47836033865466066],
            [15.314782155554605, 0.47959298650012494],
            [15.309435030233747, 0.47368871003019386],
            [15.303099021102346, 0.4710864240394026],
            [15.287723306136934, 0.4667761152841877],
            [15.282520181077512, 0.4663224047873317],
            [15.276101151675224, 0.4694254058974267],
            [15.274971984297252, 0.47555260454513],
            [15.271997172997889, 0.48179263892474244],
            [15.268550145702708, 0.4839040901173147],
            [15.264159699650467, 0.4804799273255829],
            [15.252548448363745, 0.4793995859043268],
            [15.248156663712399, 0.4810412209652986],
            [15.24252265916106, 0.48584586249774553],
            [15.239486815043895, 0.4918619818614532],
            [15.227614064451952, 0.4906271323274288],
            [15.222131798179479, 0.48722587189582534],
            [15.218964644710363, 0.4910318470309725],
            [15.207160670181228, 0.4981206341529647],
            [15.201605478691548, 0.5070219876129222],
            [15.19806008247465, 0.5080581760419453],
            [15.196331930340422, 0.5115795098892657],
            [15.18877739531986, 0.5105126499352889],
            [15.179311573086368, 0.5056956128453255],
            [15.17294851307296, 0.5111616790306177],
            [15.174445573456287, 0.5181778255951516],
            [15.177101369236105, 0.5243008651406164],
            [15.181311480138348, 0.5269056367539999],
            [15.180603296039468, 0.5328364144096066],
            [15.177292835471974, 0.5371408781604028],
            [15.175175057200317, 0.5358874577463593],
            [15.172215022837486, 0.5394860482259441],
            [15.16750914637146, 0.5396443850031636],
            [15.163507752188503, 0.5379167650622088],
            [15.160852981673981, 0.5401155195274641],
            [15.155501527280578, 0.540967505535209],
            [15.15104482487933, 0.5485543413709428],
            [15.150336941574116, 0.5531974202403153],
            [15.152714412692461, 0.5565070094235338],
            [15.155705810117343, 0.5561435677345388],
            [15.160428685378609, 0.558630321959427],
            [15.15810762005793, 0.5662476126568747],
            [15.15239397583307, 0.5685293198914882],
            [15.146474278075473, 0.5649273914983376],
            [15.143917827223763, 0.5583187529381994],
            [15.137593073010706, 0.5596061102499817],
            [15.139989548214231, 0.5654653206941296],
            [15.134482504999589, 0.5748404120201404],
            [15.130104845318353, 0.5763171196612773],
            [15.132120703512083, 0.5833231851447054],
            [15.13181344418773, 0.5870096064953862],
            [15.129174367676645, 0.5905295380563504],
            [15.123467002506201, 0.591090968373559],
            [15.119767732200444, 0.5970171248429411],
            [15.114223147595336, 0.6006441521458816],
            [15.112239008958424, 0.6044588675895126],
            [15.11265126535936, 0.6088295693454331],
            [15.115955106465664, 0.6105033546242562],
            [15.116610864000148, 0.6149025145660205],
            [15.112385412811118, 0.6158932974399209],
            [15.108063734625045, 0.6133578932233682],
            [15.103702340138295, 0.6132805372718972],
            [15.09910445115602, 0.6154640348068989],
            [15.095926283701575, 0.6108593019680316],
            [15.091737384594563, 0.6125640668754864],
            [15.092210322127489, 0.6172720852751635],
            [15.099027238933532, 0.6192212241512306],
            [15.10221035685717, 0.6238416235261268],
            [15.100802986091125, 0.628872343532975],
            [15.096189615264455, 0.6266538166191022],
            [15.089315996578069, 0.6279521068416052],
            [15.087826036186485, 0.6306675136810335],
            [15.089491846923154, 0.6347725828781966],
            [15.0829697582041, 0.6392954704491346],
            [15.07995802259057, 0.6382697014699087],
            [15.078497605915878, 0.633878634132023],
            [15.074436789591894, 0.6334562433466435],
            [15.074593701289217, 0.6394548993455138],
            [15.068898828503297, 0.6393135813287616],
            [15.068325673863358, 0.6418969024170513],
            [15.071381718635303, 0.6461010761548455],
            [15.074324393175386, 0.6428623274464422],
            [15.076334583207828, 0.6480392534016914],
            [15.066717350392155, 0.6520883188598147],
            [15.069126427291204, 0.6607333346880209],
            [15.068246231111255, 0.6659183187534862],
            [15.069036812049227, 0.6707886528021263],
            [15.062602382771097, 0.682347611915924],
            [15.065519734895354, 0.6884025521421042],
            [15.062514379929144, 0.6907182775301989],
            [15.065546197576566, 0.6977396377103338],
            [15.071072030148423, 0.7074226501929859],
            [15.080432427675738, 0.7128856963231641],
            [15.083568345314307, 0.7180393142569446],
            [15.10419083618399, 0.7205749343310263],
            [15.115884318641477, 0.7241756991903181],
            [15.118389210814033, 0.7232052953183008],
            [15.122526163489848, 0.7181006342013309],
            [15.13021818731816, 0.7189691477339539],
            [15.134068774920594, 0.721489516050051],
            [15.1363455672205, 0.7252645763347075],
            [15.142724366518522, 0.7261508650777176],
            [15.145101232021474, 0.7229850067596736]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.89529685036781,
          "lat": 37.718634218101876
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51097"],
        "coty_name": ["King and Queen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["King and Queen County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01480136"
      },
      "bbox": [
        15.062514379929144, 0.25114685813347365, 15.567671944457377,
        0.7261508650777176
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.579161235493405, 0.20905810880168937],
            [15.587394160522862, 0.20471851072039682],
            [15.600647847441229, 0.1881878667407753],
            [15.608494141838225, 0.18093756222182086],
            [15.613485801495473, 0.17508458879183011],
            [15.621402782776238, 0.16926964063663633],
            [15.627571086343643, 0.16198191047339333],
            [15.638620274262419, 0.15190381856525845],
            [15.65086235137744, 0.1440115177254484],
            [15.659349185017469, 0.1398065138955912],
            [15.666155853177179, 0.1331821440048206],
            [15.674025080849093, 0.1290720641450572],
            [15.680673131889199, 0.12781128767421232],
            [15.688252200633576, 0.12479725202792008],
            [15.695745324462775, 0.12077491384441318],
            [15.705264115097926, 0.11183593596715315],
            [15.711590300959543, 0.10700606538070262],
            [15.716047360135514, 0.10192611848992479],
            [15.724682370878737, 0.0981886932399876],
            [15.72337379178896, 0.0938859428312892],
            [15.728694728206186, 0.08919345137901202],
            [15.734291494160637, 0.0863676721931516],
            [15.737868530510179, 0.08238946720464235],
            [15.746470678995282, 0.08099974324858347],
            [15.756948840426139, 0.07667651169006107],
            [15.768648418244661, 0.08168619929084153],
            [15.78299676329309, 0.0852261196476686],
            [15.794373776934494, 0.09194216104695532],
            [15.80279905504856, 0.09291405065039968],
            [15.812730421494491, 0.09680062743922986],
            [15.818733692976275, 0.10158406429557203],
            [15.820423087654374, 0.10037580736509226],
            [15.815972867015383, 0.09007206612497781],
            [15.816521359136605, 0.08511334710587479],
            [15.812731740334657, 0.07855694154103768],
            [15.821326375619718, 0.07217549834370443],
            [15.824248408944394, 0.06700170562330211],
            [15.823936509039678, 0.06254172730337312],
            [15.825961846384576, 0.05515212217652951],
            [15.82560841519336, 0.04814261541227188],
            [15.819620395696683, 0.051578412089015],
            [15.814659726342018, 0.04643827100965369],
            [15.81606786977984, 0.038331549448074],
            [15.81415354591487, 0.03236287577827503],
            [15.81960279266801, 0.03193260292946001],
            [15.814872793274445, 0.02666220108954457],
            [15.817421526314826, 0.019030207507891344],
            [15.818033423837775, 0.009216969644870067],
            [15.821272672452173, 0.006226980868191621],
            [15.821203505631509, 0.0018046511228449133],
            [15.824350862343659, 0.0011113801485249251],
            [15.838133884276179, -0.01864253857848709],
            [15.836399584792018, -0.023123487344632345],
            [15.838327829311273, -0.02943568105460712],
            [15.830605836580428, -0.03596823455982245],
            [15.827764315791818, -0.03487263438772509],
            [15.823516310024006, -0.03721400203397654],
            [15.818277604273993, -0.0381363780475038],
            [15.813588058803546, -0.03520033926852094],
            [15.808407803580169, -0.038395626695031104],
            [15.802826337180406, -0.03891603491910505],
            [15.790470444537988, -0.034993512775789555],
            [15.74317100167025, 0.00993528165712085],
            [15.743564493136816, 0.014573669723575261],
            [15.732318117878211, 0.027373682262112852],
            [15.72956300756065, 0.032542282260906476],
            [15.722662918558946, 0.029376459510038606],
            [15.683909229862277, 0.06615675705986061],
            [15.677738547348874, 0.0570906507886401],
            [15.665246137125193, 0.05472619822843404],
            [15.66079879232738, 0.06080898037044523],
            [15.657547072513845, 0.07260149796668655],
            [15.653857705134198, 0.07410629115874849],
            [15.652573910504268, 0.07722378492035643],
            [15.636281530587713, 0.07127354690120301],
            [15.633853005529602, 0.06803393001289464],
            [15.628527051580154, 0.07099054789223898],
            [15.617714592078515, 0.07175127131941626],
            [15.613626204532927, 0.07080920772332507],
            [15.606537922778712, 0.07567369219505388],
            [15.601045163559576, 0.08408457641247065],
            [15.59731231630927, 0.0931246703676537],
            [15.594254202577744, 0.09452191185071042],
            [15.585858749713788, 0.0927569156481966],
            [15.58166915607642, 0.09702258204954668],
            [15.585079919950603, 0.10377641333117278],
            [15.58159487365328, 0.10800990270525448],
            [15.579100789692204, 0.11883464336177435],
            [15.576200124974518, 0.11941218789201416],
            [15.572339153483478, 0.115335124291504],
            [15.571609858891543, 0.11148683498940867],
            [15.567207666625032, 0.10858533415533018],
            [15.56623490432904, 0.10611284214644277],
            [15.55951946137429, 0.10457897387247662],
            [15.560422138561472, 0.09923487651057218],
            [15.554741139947275, 0.10204014534538901],
            [15.550943310489364, 0.10643199721487154],
            [15.545679248255182, 0.11517486551257126],
            [15.542758033558089, 0.11781532305669097],
            [15.540910563879265, 0.12466920955123341],
            [15.536470087913056, 0.13402187203319887],
            [15.533986919803157, 0.13556806351463213],
            [15.531109378598405, 0.14070832157039273],
            [15.530544130076457, 0.14882573310676134],
            [15.513371304147826, 0.15429445972737105],
            [15.5134113454297, 0.16009287280517978],
            [15.509767623226185, 0.168054303200972],
            [15.515471673182693, 0.17772696090741671],
            [15.51600032437188, 0.18572263877257061],
            [15.522536506966114, 0.18877279089590476],
            [15.52821012738187, 0.1893968401916899],
            [15.530112965928119, 0.18754382633160988],
            [15.534238244689499, 0.1885282888887077],
            [15.53724652318738, 0.18627908940440743],
            [15.543574684580037, 0.18588839921612565],
            [15.549355167776994, 0.18880306978860928],
            [15.557339394743554, 0.19112578907070274],
            [15.558024537990761, 0.19392789667188085],
            [15.56279106815446, 0.1948729619556244],
            [15.569621337483674, 0.1942663542131705],
            [15.579161235493405, 0.20905810880168937]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.56342760038144, "lat": 37.24302030937729 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51199"],
        "coty_name": ["York"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["York County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "01480182"
      },
      "bbox": [
        15.509767623226185, -0.03891603491910505, 15.838327829311273,
        0.20905810880168937
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.989040314705973, -0.3981004026661045],
            [12.995053327898594, -0.3979663314893536],
            [12.995462250749068, -0.3950712704307728],
            [13.000479818094746, -0.39476252990958327],
            [13.000891154081451, -0.3885824265132274],
            [13.00260033747235, -0.38750975944549215],
            [13.001282837902123, -0.3781644393507875],
            [12.995036824072063, -0.3780807198083194],
            [12.992342270250628, -0.3695026856972394],
            [12.994312090152349, -0.36622999803675166],
            [12.993255749121746, -0.3558171357446131],
            [12.990094462433984, -0.35137510058352317],
            [12.99301413132975, -0.34479275008687243],
            [12.99544972883362, -0.3423635984344131],
            [13.002266330087624, -0.3418254558375872],
            [13.009485346062474, -0.33135176053977305],
            [13.019656482963564, -0.32175433561025435],
            [13.028560584514633, -0.3171215674034574],
            [13.031611743195734, -0.3191421352768755],
            [13.037180435052678, -0.33128094759525384],
            [13.043346565228436, -0.3239662725545553],
            [13.046986542218962, -0.32878377170917983],
            [13.050186755784106, -0.3267352555327812],
            [13.059047987494093, -0.32577733748768906],
            [13.064493649649885, -0.31942962010438736],
            [13.067947696547032, -0.3252870868415038],
            [13.073380283491858, -0.3256116975866094],
            [13.078467049831726, -0.3224967048770371],
            [13.093686653876228, -0.3326933120261079],
            [13.101824746419586, -0.33672239611065075],
            [13.100992994667081, -0.33859512695884586],
            [13.10446069493831, -0.3487251947217892],
            [13.10144310481412, -0.3576464268516542],
            [13.097285338126419, -0.35511479233638155],
            [13.102558862032723, -0.3489853210082421],
            [13.100473475496678, -0.34748712793150516],
            [13.093578011733722, -0.35773658383761175],
            [13.086731443646245, -0.36224824276251405],
            [13.083766609633484, -0.3605752390608451],
            [13.075859283758058, -0.36535723386439406],
            [13.08293146774906, -0.3666932670256106],
            [13.087974737276292, -0.3728573751511972],
            [13.088297419169336, -0.37798972580663837],
            [13.0908692831918, -0.381582996049422],
            [13.085959898471692, -0.3837642894693039],
            [13.090526006104145, -0.3864542887350161],
            [13.093262799268217, -0.3857967663303448],
            [13.09109233566455, -0.3952665544626593],
            [13.091887043857104, -0.3992876307222554],
            [13.0814166610533, -0.4044963533873262],
            [13.080748162181298, -0.4056256795431441],
            [13.080211318321753, -0.42176888937402013],
            [13.079024366731737, -0.42364431255194424],
            [13.070675197686734, -0.4208338472121726],
            [13.065104078036589, -0.4261457682945698],
            [13.064828722849986, -0.4362728566838691],
            [13.056358118226093, -0.438041486663122],
            [13.047359948118, -0.4309346464953224],
            [13.042885191227759, -0.4230805441445895],
            [13.037166542890512, -0.41821883781138514],
            [13.034633704099907, -0.42102097291611723],
            [13.031441704318736, -0.41827111504039033],
            [13.025521312374266, -0.41597797010236526],
            [13.01909034485342, -0.41085219985764415],
            [13.018265235167032, -0.4041302182573799],
            [13.014240525904608, -0.40830670781306216],
            [13.003176994473758, -0.41077346469893955],
            [12.99868273439166, -0.4133244054138944],
            [12.995890584007963, -0.4166432300977705],
            [12.989045848038948, -0.4118148443261747],
            [12.987497296252585, -0.40833108714785066],
            [12.989177320532429, -0.4035799289603226],
            [12.989040314705973, -0.3981004026661045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.95803256714501,
          "lat": 37.278453440624645
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51770"],
        "coty_name": ["Roanoke"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Roanoke city"],
        "coty_fp_code": "770",
        "coty_gnis_code": "01498439"
      },
      "bbox": [
        12.987497296252585, -0.438041486663122, 13.10446069493831,
        -0.3171215674034574
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.96549954853542, 9.758354479331176],
            [-17.959377198938206, 9.759112842512769],
            [-17.95537237597778, 9.762535645755563],
            [-17.94636121648953, 9.764223674991827],
            [-17.93859754852702, 9.764579240667706],
            [-17.931729155813798, 9.768798873312782],
            [-17.926677666803798, 9.767844842393828],
            [-17.91913431066449, 9.761666899683325],
            [-17.915817640667743, 9.765069793232865],
            [-17.919986713173504, 9.77290472536759],
            [-17.921360970377155, 9.781870451540312],
            [-17.9178090889208, 9.789554103727552],
            [-17.927831536143472, 9.791629771042679],
            [-17.927286572846743, 9.796928607237039],
            [-17.919207744061385, 9.79778120186004],
            [-17.916384945862642, 9.810707067952446],
            [-17.912432883140454, 9.808290912332373],
            [-17.907521042881648, 9.80863632759319],
            [-17.900215011371657, 9.815818922849775],
            [-17.899680621765743, 9.822962393541335],
            [-17.89569018943785, 9.822238791748816],
            [-17.890389321446936, 9.81887284821174],
            [-17.885345973390283, 9.817952927024372],
            [-17.88223230872513, 9.814044021004687],
            [-17.879274649959868, 9.814310614424688],
            [-17.87738557043215, 9.81917468925568],
            [-17.880657160698323, 9.823506114483221],
            [-17.879834216429494, 9.826230180418202],
            [-17.875939752443983, 9.825879120201801],
            [-17.871398703033382, 9.821953446624875],
            [-17.863711633380557, 9.817960175446316],
            [-17.859371750669304, 9.812096527696177],
            [-17.85838082748808, 9.807375313789253],
            [-17.848202830127914, 9.813829313284103],
            [-17.84499838275946, 9.8137732926016],
            [-17.838051885426417, 9.809434400414126],
            [-17.8308142083679, 9.808481379533504],
            [-17.82824931863517, 9.806579850856096],
            [-17.820570280431085, 9.808794132962493],
            [-17.81590955642153, 9.812373762971616],
            [-17.80772095776269, 9.813740244503073],
            [-17.803270441898878, 9.817008119568628],
            [-17.797780374354378, 9.817400792545474],
            [-17.794369557268965, 9.814254975229643],
            [-17.78961709072694, 9.811994378744036],
            [-17.78422781209679, 9.812696222347272],
            [-17.780678115445465, 9.817808758680032],
            [-17.77670583645395, 9.819581080035654],
            [-17.77355636019912, 9.823107282409854],
            [-17.76692925312426, 9.824510528184522],
            [-17.761531068825246, 9.826934907605844],
            [-17.76190484967813, 9.832361201505146],
            [-17.75287818325669, 9.834797933621278],
            [-17.74981635835506, 9.83264494760358],
            [-17.74439358364447, 9.833270000514528],
            [-17.742802993746977, 9.828103819291298],
            [-17.736373443654156, 9.826720973540404],
            [-17.73615435511983, 9.830721388027698],
            [-17.732653084054338, 9.831844308701495],
            [-17.730704901462857, 9.827944166160293],
            [-17.72735419571855, 9.827123334253255],
            [-17.722218689812347, 9.830089827371665],
            [-17.70543160787682, 9.82230830793468],
            [-17.701910388174916, 9.819502623937506],
            [-17.70108602766506, 9.811766224834935],
            [-17.696678766816124, 9.809762565320899],
            [-17.691905057814864, 9.810235022477999],
            [-17.68497449659349, 9.808123190650166],
            [-17.685630742221946, 9.805539604458534],
            [-17.67276519387059, 9.800371112335275],
            [-17.668507467575658, 9.793207143469095],
            [-17.664427852672677, 9.790199038029586],
            [-17.660509893308927, 9.784277225684965],
            [-17.651788297529773, 9.784469639745256],
            [-17.65163977731954, 9.779610370838872],
            [-17.64879795379095, 9.777632272050871],
            [-17.645472201597617, 9.778670281757119],
            [-17.639465958480518, 9.777776013696805],
            [-17.630718297784806, 9.780968050030125],
            [-17.622147660973077, 9.789904010831586],
            [-17.620956315436185, 9.796303111515858],
            [-17.615602879528797, 9.797493159619036],
            [-17.6115724658092, 9.802449275125438],
            [-17.615348663365285, 9.808743435205148],
            [-17.616095820356506, 9.812441015961126],
            [-17.613768832839273, 9.819270886983995],
            [-17.615712529861195, 9.822183411910881],
            [-17.61290671751337, 9.824567332463461],
            [-17.607552968618577, 9.823169133050133],
            [-17.603857993377492, 9.826569532339343],
            [-17.60359277892648, 9.831181789411103],
            [-17.599297308577004, 9.837360496592234],
            [-17.595187598362763, 9.837007823937215],
            [-17.585420802402535, 9.842864373816075],
            [-17.58218424505207, 9.853430629334127],
            [-17.57733280073759, 9.85248981688498],
            [-17.574211986125146, 9.853473015984237],
            [-17.56866804313135, 9.85811124062411],
            [-17.562458224278746, 9.858591235467136],
            [-17.556239733722695, 9.854973456152345],
            [-17.548422573859416, 9.848761864273735],
            [-17.554011183996245, 9.828569697764834],
            [-17.575834328212796, 9.754196581736318],
            [-17.57937027100921, 9.73945540450582],
            [-17.59852128002682, 9.671155592566455],
            [-17.602044673328567, 9.672213626917156],
            [-17.609847157099583, 9.643406054931454],
            [-17.61421188399517, 9.63069729808542],
            [-17.615816562735425, 9.623814055633948],
            [-17.63386050182841, 9.5625788429452],
            [-17.635201175495016, 9.556020426362785],
            [-17.65445411646365, 9.488470977252804],
            [-17.657100865088736, 9.480853439525124],
            [-17.670367372883042, 9.432480718574675],
            [-17.688346733448014, 9.369672770289267],
            [-17.70140660548278, 9.369294077298111],
            [-17.720490833850548, 9.374329922209],
            [-17.743866420868912, 9.385703433891214],
            [-17.752413469097228, 9.409844071468305],
            [-17.769151493913952, 9.421212154790009],
            [-17.777278178905593, 9.422061052118242],
            [-17.79190060543109, 9.419089352818725],
            [-17.81184310094287, 9.420552439366729],
            [-17.82106470724589, 9.42697529228932],
            [-17.832024595859032, 9.441341445085902],
            [-17.84250204230698, 9.44940260230314],
            [-17.861890716674008, 9.461394416525225],
            [-17.876396094848246, 9.472816722741344],
            [-17.896789861353714, 9.48594772055713],
            [-17.910027461141077, 9.493494031936045],
            [-17.93722161690795, 9.50336456203097],
            [-17.95583584850878, 9.517169651713804],
            [-17.964735953252635, 9.526575347376491],
            [-17.976204838132066, 9.542869173655424],
            [-17.99101085245258, 9.553961201194223],
            [-18.004667614472947, 9.57119385217085],
            [-18.005381524104784, 9.595302498506006],
            [-17.99870428990056, 9.613094455588755],
            [-17.98373897894312, 9.638510313199992],
            [-17.980721717166215, 9.643635709716396],
            [-17.974750400233862, 9.667314992717067],
            [-17.9742210766321, 9.689128387907289],
            [-17.983523895447938, 9.721944458692581],
            [-17.97958765622769, 9.736223514896468],
            [-17.96737669529769, 9.752412047083531],
            [-17.96549954853542, 9.758354479331176]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.48251594868961,
          "lat": 45.77919176217464
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53011"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01531820"
      },
      "bbox": [
        -18.005381524104784, 9.369294077298111, -17.548422573859416,
        9.858591235467136
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.163293135386173, 12.432408874305457],
              [-17.1622920318222, 12.431750069683092],
              [-17.16312793287951, 12.421012213365294],
              [-17.165205051747346, 12.420741430855704],
              [-17.163293135386173, 12.432408874305457]
            ]
          ],
          [
            [
              [-17.2308645058995, 12.333953184266088],
              [-17.22813285204345, 12.3349345046743],
              [-17.22390977899448, 12.34116081684793],
              [-17.217939585110692, 12.337210591765194],
              [-17.221545075854237, 12.333448511652083],
              [-17.23055732567378, 12.33169753571183],
              [-17.2308645058995, 12.333953184266088]
            ]
          ],
          [
            [
              [-17.241920924304868, 12.318585831254898],
              [-17.238250189454682, 12.321721573091306],
              [-17.238683510502277, 12.32447417292077],
              [-17.234520524328932, 12.327702811229331],
              [-17.2307545157648, 12.326658213125382],
              [-17.2244409379975, 12.330092258749374],
              [-17.214110385604823, 12.318334892238473],
              [-17.209003076691722, 12.306260031266767],
              [-17.208252533421117, 12.302090624577716],
              [-17.205891213586256, 12.298889818900665],
              [-17.205698755825804, 12.295001906760227],
              [-17.209625912801112, 12.289234969799567],
              [-17.21631524446144, 12.285228354467792],
              [-17.22214938698059, 12.282789938238935],
              [-17.229044296146593, 12.276615221326173],
              [-17.23824133425955, 12.276066693984452],
              [-17.242793763719714, 12.292645980176916],
              [-17.238351612171027, 12.297149695789463],
              [-17.24273678144628, 12.298550943152362],
              [-17.244463865414623, 12.301182373892601],
              [-17.241920924304868, 12.318585831254898]
            ]
          ],
          [
            [
              [-17.204823119336563, 12.483686146043356],
              [-17.1992928181669, 12.484531520094444],
              [-17.19220857638778, 12.47996902282369],
              [-17.196902500211166, 12.477817574533255],
              [-17.204823119336563, 12.483686146043356]
            ]
          ],
          [
            [
              [-17.24428556059768, 12.514832325906955],
              [-17.24057623411186, 12.516567779203923],
              [-17.230824592351475, 12.513976268758176],
              [-17.22560757615039, 12.509856979972866],
              [-17.227416174467766, 12.507868593584861],
              [-17.239145897455273, 12.51315711276382],
              [-17.241604517911004, 12.50943476799027],
              [-17.2393428924121, 12.505759698594572],
              [-17.234431972167336, 12.501754632687044],
              [-17.228163988235337, 12.500346242613517],
              [-17.225412684936057, 12.49599605393977],
              [-17.22896120466611, 12.492052382872268],
              [-17.237515125902025, 12.492427850988182],
              [-17.240737590007, 12.496830247073474],
              [-17.24478627909182, 12.49850299314071],
              [-17.24832452352526, 12.503884219727984],
              [-17.24428556059768, 12.514832325906955]
            ]
          ],
          [
            [
              [-17.341775862185933, 12.251527574296674],
              [-17.333231551850165, 12.269556709843522],
              [-17.326286900583575, 12.27631137326928],
              [-17.32194945735335, 12.285861269955005],
              [-17.317849239981864, 12.288499708290209],
              [-17.31019175046681, 12.28806610570661],
              [-17.30921697266646, 12.297457534549725],
              [-17.309613233812435, 12.303910222364715],
              [-17.305257655628086, 12.314556230874274],
              [-17.296098687224852, 12.311475166096036],
              [-17.289626948708133, 12.31597193973827],
              [-17.284263405164204, 12.316190948204692],
              [-17.283049363949193, 12.322496488853208],
              [-17.28080758655182, 12.326135098851417],
              [-17.27616749128017, 12.328933486225136],
              [-17.280051266203515, 12.31198554484311],
              [-17.27762839635805, 12.309554928868822],
              [-17.273332006043837, 12.308968533823204],
              [-17.271052873211758, 12.317190625078679],
              [-17.26682326261713, 12.316939540772989],
              [-17.268159803622893, 12.308779207419114],
              [-17.272261878438222, 12.30755639053614],
              [-17.275638416472106, 12.304555220925266],
              [-17.277007077311254, 12.30050781670369],
              [-17.27521523859555, 12.297623132663011],
              [-17.26773260323689, 12.295499834452247],
              [-17.26517381245465, 12.290178950204021],
              [-17.258854109902, 12.293614928875296],
              [-17.257768744679577, 12.290290935985592],
              [-17.262967733226315, 12.288127622561644],
              [-17.27099271489766, 12.286759216441386],
              [-17.28148439684785, 12.268177475013697],
              [-17.287393322936385, 12.26446389171442],
              [-17.287821995904302, 12.257448045815876],
              [-17.285263016417336, 12.254965181382316],
              [-17.283836972078777, 12.246322711515425],
              [-17.280186980012665, 12.24243061177681],
              [-17.281753929868596, 12.238273125854885],
              [-17.28070044305997, 12.234006651184886],
              [-17.283993472584285, 12.231290468627305],
              [-17.28405555852504, 12.22829216899229],
              [-17.291184761386944, 12.219360868116018],
              [-17.290374215249155, 12.217066615101087],
              [-17.280655568776513, 12.217398193711194],
              [-17.281788891468732, 12.214154451101535],
              [-17.28883474934227, 12.207736895319066],
              [-17.28473124858661, 12.205078718807298],
              [-17.279267003274988, 12.206451734071274],
              [-17.269908885574765, 12.213962374874585],
              [-17.272152403279094, 12.22368134997501],
              [-17.26791401793838, 12.237998231225994],
              [-17.268528326970237, 12.242341033792245],
              [-17.267174751846476, 12.255823011685038],
              [-17.261105623528145, 12.267881004177449],
              [-17.2574199428732, 12.268328511279806],
              [-17.253952031082807, 12.272440517041584],
              [-17.245361116360865, 12.271569127002877],
              [-17.237437414627337, 12.268690960270002],
              [-17.230415596107324, 12.267861171626652],
              [-17.2225305787018, 12.257901317165622],
              [-17.220622847632544, 12.257616483524057],
              [-17.2189229504262, 12.251248040357995],
              [-17.2203488753535, 12.247357107880823],
              [-17.224336172976578, 12.248384025725686],
              [-17.22928704634743, 12.252218112796788],
              [-17.23590941181821, 12.249122041378218],
              [-17.236717181670688, 12.245975413117975],
              [-17.24305895413779, 12.240177865585707],
              [-17.25570802239219, 12.23717484135994],
              [-17.257229657986628, 12.232035459509934],
              [-17.260356837734413, 12.227919797437377],
              [-17.258051226018562, 12.222543792467075],
              [-17.26520986955937, 12.21212602508898],
              [-17.265621869728765, 12.209413141894172],
              [-17.262650463396287, 12.20369968905529],
              [-17.258155035860426, 12.202338750588297],
              [-17.25656608795687, 12.196497332393786],
              [-17.262408747588626, 12.194527314780252],
              [-17.264320455856062, 12.188079043340393],
              [-17.270059723622676, 12.183826052257016],
              [-17.263393658066825, 12.181317120884534],
              [-17.27181798978847, 12.174443852558158],
              [-17.27867756361102, 12.176129752730711],
              [-17.281024571064187, 12.178567480510722],
              [-17.280062488123033, 12.181417396889547],
              [-17.2850496538376, 12.185850209513704],
              [-17.28586255952784, 12.189259742007861],
              [-17.292960292200338, 12.187140754051025],
              [-17.300132284104425, 12.192036694667125],
              [-17.302488129069772, 12.188572911795458],
              [-17.29498795107922, 12.183106937859622],
              [-17.298571106373885, 12.180830455964324],
              [-17.31131717136306, 12.182653950532977],
              [-17.318528240849805, 12.185309913063593],
              [-17.325046949769465, 12.189548809651896],
              [-17.31892375519073, 12.19467167370003],
              [-17.313502957867062, 12.191700638659142],
              [-17.310448125084235, 12.196395538990256],
              [-17.317110888407438, 12.202282788045519],
              [-17.312857481119597, 12.203912936062512],
              [-17.30844425430421, 12.20313598428021],
              [-17.3067822195607, 12.200916736334985],
              [-17.308592240621834, 12.197616781858931],
              [-17.30668980613639, 12.195646653158827],
              [-17.29852496474193, 12.200796226846265],
              [-17.299161246198306, 12.203678174731538],
              [-17.306286898544297, 12.208719072043102],
              [-17.31524618651715, 12.211343768634213],
              [-17.323918341427262, 12.214682230122042],
              [-17.325705676197384, 12.208676810186876],
              [-17.328393565574984, 12.210235126016354],
              [-17.340513971571674, 12.210136598539394],
              [-17.34184689552008, 12.21625202152353],
              [-17.33462070485372, 12.214389421369125],
              [-17.330692050306457, 12.219785536578295],
              [-17.329624790987395, 12.226153447161721],
              [-17.334016758844083, 12.232008576910513],
              [-17.33976002459336, 12.231101763142346],
              [-17.340929660929636, 12.228237435517656],
              [-17.346377016839437, 12.232827227541193],
              [-17.343583365731224, 12.237749097802688],
              [-17.344854970636334, 12.24014447060431],
              [-17.34116165248399, 12.244204345593012],
              [-17.341775862185933, 12.251527574296674]
            ]
          ],
          [
            [
              [-17.272147903661562, 12.542251403865006],
              [-17.270710486954172, 12.544069568436802],
              [-17.263508594451036, 12.53914532323014],
              [-17.25434581272866, 12.53498712243368],
              [-17.259313328270267, 12.533267996977143],
              [-17.271569042986677, 12.53933654874852],
              [-17.272147903661562, 12.542251403865006]
            ]
          ],
          [
            [
              [-17.356685400139302, 12.368954849335939],
              [-17.35268513964394, 12.368771785842819],
              [-17.351191315684446, 12.362950203932858],
              [-17.346279964406367, 12.362883264918775],
              [-17.33173641987246, 12.364965641123385],
              [-17.318567802993087, 12.356343153737416],
              [-17.308664653243426, 12.351210943304475],
              [-17.308876607894643, 12.347879832472433],
              [-17.31189404076078, 12.345421479827658],
              [-17.306746119563105, 12.338257721300998],
              [-17.30454516986299, 12.339531287521277],
              [-17.305224922047998, 12.344963433538865],
              [-17.30098975792746, 12.34806716403895],
              [-17.29435056995508, 12.348095735385368],
              [-17.292627657786614, 12.344531782420368],
              [-17.28650019079742, 12.341207849350726],
              [-17.287778410648382, 12.334784498302064],
              [-17.302595861136368, 12.32551776143393],
              [-17.307017763681014, 12.31901476531899],
              [-17.308356759951366, 12.324288853723475],
              [-17.305562224667213, 12.327786988900868],
              [-17.314065541836122, 12.329255714698972],
              [-17.313594169602137, 12.325784939804105],
              [-17.318291468799742, 12.322856599664139],
              [-17.31753850405595, 12.319241003023498],
              [-17.320600405465115, 12.31622568763678],
              [-17.324263722991567, 12.316159795310394],
              [-17.327404596056216, 12.318955189209518],
              [-17.33514132721199, 12.321499027597923],
              [-17.33482047135122, 12.327404141600494],
              [-17.34198865875014, 12.326204225406368],
              [-17.346343991678776, 12.332715285101468],
              [-17.343387079461255, 12.33725854396928],
              [-17.336565290876372, 12.331544380608781],
              [-17.3393350514725, 12.341678799680162],
              [-17.341602099979593, 12.344066896733416],
              [-17.34783573411022, 12.356452525564968],
              [-17.357684377393618, 12.35799459989316],
              [-17.355942035419055, 12.36145636736226],
              [-17.356685400139302, 12.368954849335939]
            ]
          ],
          [
            [
              [-17.359666615175954, 12.379392248847699],
              [-17.35762930699548, 12.37876939595767],
              [-17.35649487818695, 12.373235669858364],
              [-17.360396862408027, 12.374766260281492],
              [-17.359666615175954, 12.379392248847699]
            ]
          ],
          [
            [
              [-17.35393676019645, 12.408183791350218],
              [-17.348128074462586, 12.411144450123738],
              [-17.34067457007208, 12.41750259617],
              [-17.338506255171215, 12.423068988445962],
              [-17.334002835432063, 12.427728472350678],
              [-17.324316455197923, 12.431640443999084],
              [-17.322082506346476, 12.433802735731085],
              [-17.315412868259628, 12.436704950717942],
              [-17.312000980955585, 12.441411988825095],
              [-17.30156327076996, 12.44453403941097],
              [-17.2954917121825, 12.44558665476549],
              [-17.29214616535406, 12.447858213295317],
              [-17.29233924128864, 12.451438796609741],
              [-17.28798792893475, 12.450857101412208],
              [-17.283980160301265, 12.45245852821623],
              [-17.27750202996237, 12.45905800520717],
              [-17.27638701823502, 12.462063742582234],
              [-17.278125255682667, 12.466623259279421],
              [-17.265334819560074, 12.46438064438537],
              [-17.258153513596437, 12.465245731516804],
              [-17.242319907480386, 12.461440224829017],
              [-17.23817760112934, 12.457978826171923],
              [-17.23309397027859, 12.457093239250655],
              [-17.22931794472409, 12.4527842584159],
              [-17.227922467362877, 12.448586578518594],
              [-17.22295658933308, 12.446406109680195],
              [-17.210781605781282, 12.437908775093314],
              [-17.205393495505827, 12.432064899510884],
              [-17.203072825227196, 12.42812169639432],
              [-17.192542375849904, 12.415394404629005],
              [-17.19299772315862, 12.412678491547114],
              [-17.189324947777955, 12.410719363490541],
              [-17.177581218637343, 12.39948089951867],
              [-17.160020694505757, 12.385687549091468],
              [-17.1602401269835, 12.383834866613649],
              [-17.169895858619338, 12.382580177748991],
              [-17.171793293509012, 12.376091448463102],
              [-17.183119928099416, 12.371365340126784],
              [-17.189989997377467, 12.370915508101255],
              [-17.195741940322357, 12.366083246732638],
              [-17.203247812607298, 12.364877753288631],
              [-17.210647928572946, 12.359274873452476],
              [-17.214561378315796, 12.358524396933362],
              [-17.21591809667861, 12.355072274824185],
              [-17.21437360608243, 12.351114712252764],
              [-17.212794456737047, 12.340740145430324],
              [-17.21642560727892, 12.341545456253888],
              [-17.221094303116327, 12.347222917561963],
              [-17.224343915100814, 12.346937691268785],
              [-17.22636100648905, 12.3438976351987],
              [-17.229636469242458, 12.343568584781677],
              [-17.233490695509737, 12.345976674434368],
              [-17.227973241815565, 12.358210510518354],
              [-17.229282430510924, 12.363285077480125],
              [-17.233872742253595, 12.362223425494637],
              [-17.239257535888125, 12.36765764749589],
              [-17.2426833986284, 12.386172302218133],
              [-17.24617971017679, 12.394431593074692],
              [-17.25044651610818, 12.394536703925034],
              [-17.252090800358673, 12.402901478200938],
              [-17.251204289452755, 12.409584864220802],
              [-17.247373479867495, 12.423195236376015],
              [-17.243796855312905, 12.432439929810496],
              [-17.244129935238764, 12.43742624959987],
              [-17.249066781824435, 12.443440886525018],
              [-17.252512822198973, 12.44312010946693],
              [-17.253255355645734, 12.439366443857526],
              [-17.25822139970111, 12.442690929619179],
              [-17.265435401380905, 12.443003823335617],
              [-17.26776104719979, 12.440192816111741],
              [-17.265948700631235, 12.436748788301019],
              [-17.267188254448673, 12.433242665380293],
              [-17.26474071691918, 12.423706495284245],
              [-17.268654574958386, 12.420555495256227],
              [-17.269948151510505, 12.408446748486197],
              [-17.267786973177106, 12.402935250965529],
              [-17.26346228146254, 12.399424044296099],
              [-17.256155185785612, 12.388489766700692],
              [-17.256775983971405, 12.373259805698092],
              [-17.25365001721817, 12.365751820382949],
              [-17.25072904380869, 12.361092368172574],
              [-17.253264882488352, 12.353669881563208],
              [-17.259773711001593, 12.350390295572163],
              [-17.26169506774213, 12.346483258921216],
              [-17.268483308906667, 12.345584994673938],
              [-17.27153253930958, 12.343285364515276],
              [-17.27530468794872, 12.346572837720142],
              [-17.278857947662264, 12.347423074786962],
              [-17.28404716610698, 12.351112735562253],
              [-17.29062841059463, 12.35124296521473],
              [-17.293528060280007, 12.353174528172465],
              [-17.297890621832593, 12.353467897155676],
              [-17.304078435780475, 12.357315666852626],
              [-17.30305509114865, 12.360631033407067],
              [-17.30987640082421, 12.362730157768107],
              [-17.31201414038578, 12.368876750236861],
              [-17.309445702899517, 12.373049380785945],
              [-17.309481068463487, 12.38401480936907],
              [-17.305598396662642, 12.38982345876937],
              [-17.3080760611414, 12.392752858348095],
              [-17.308628669961603, 12.396852058315483],
              [-17.313565682919513, 12.395288191292488],
              [-17.32076209085167, 12.411056794725777],
              [-17.323112787682778, 12.407616878297597],
              [-17.328643534937353, 12.40571636890545],
              [-17.32853420124851, 12.40220708306954],
              [-17.32494008020532, 12.39991255070004],
              [-17.32785846544091, 12.39727117673162],
              [-17.3235598467079, 12.388455416541614],
              [-17.321451892599395, 12.378324266473978],
              [-17.323245014229826, 12.373186282951899],
              [-17.32826770915912, 12.369867130820198],
              [-17.335174765591283, 12.373892233387208],
              [-17.336969970906654, 12.367417722102967],
              [-17.34199450944569, 12.367133842133331],
              [-17.347202512165623, 12.369093323571448],
              [-17.349244943219798, 12.371365262485336],
              [-17.348169957571116, 12.375400571882253],
              [-17.33600289294061, 12.376659998869101],
              [-17.33576342488794, 12.382445141415646],
              [-17.338797453378728, 12.38901653968159],
              [-17.338987682611478, 12.394909726257437],
              [-17.34157911496797, 12.395648877856143],
              [-17.343681861899597, 12.390409688862784],
              [-17.354258070924303, 12.387563009041337],
              [-17.357695638305145, 12.390090510264319],
              [-17.3561826248216, 12.399817372519484],
              [-17.35393676019645, 12.408183791350218]
            ]
          ],
          [
            [
              [-17.37236623780257, 12.402014006119124],
              [-17.370035993501194, 12.403496323080374],
              [-17.365795017462148, 12.401083772588843],
              [-17.36376994898932, 12.397994791480713],
              [-17.36394688038587, 12.393154989756997],
              [-17.370431726885066, 12.393708777600454],
              [-17.372160618277945, 12.396875554993729],
              [-17.37236623780257, 12.402014006119124]
            ]
          ],
          [
            [
              [-17.35847572075329, 12.480332752685328],
              [-17.348848028272954, 12.481107646198065],
              [-17.34183690133743, 12.484334006436374],
              [-17.335981763545025, 12.491003911580059],
              [-17.329219553030203, 12.488230713701622],
              [-17.321751927262735, 12.490982045429734],
              [-17.315132650088028, 12.490078654527851],
              [-17.317225285779557, 12.481048157836536],
              [-17.316768782414893, 12.473493912641892],
              [-17.319868052421675, 12.471834859752185],
              [-17.318671523093652, 12.46644401522656],
              [-17.3198695441525, 12.463317174358808],
              [-17.32846524104523, 12.45634861105702],
              [-17.339601514513326, 12.452840881019025],
              [-17.348920625141673, 12.452815101056222],
              [-17.347652688173163, 12.455441336227187],
              [-17.341960948982692, 12.46057429087724],
              [-17.341089015619296, 12.465084079343379],
              [-17.346362693120533, 12.472316417444352],
              [-17.35847572075329, 12.480332752685328]
            ]
          ],
          [
            [
              [-17.433984797513553, 12.450521097836623],
              [-17.425955067340475, 12.44681636908675],
              [-17.420710549629725, 12.44160097983706],
              [-17.412604596526148, 12.438852848639701],
              [-17.406484923799376, 12.4329492430888],
              [-17.405009616338912, 12.426666929098355],
              [-17.409528327015757, 12.427591724967117],
              [-17.420651182912778, 12.43597168849158],
              [-17.42500891571029, 12.441371723638252],
              [-17.434588598503403, 12.449308142623986],
              [-17.433984797513553, 12.450521097836623]
            ]
          ],
          [
            [
              [-17.474423018331123, 12.408121899210355],
              [-17.470140711735695, 12.412089188716068],
              [-17.466140830271712, 12.418053078265984],
              [-17.45915989814823, 12.42071631195034],
              [-17.45486360526874, 12.423944450747179],
              [-17.451859673811267, 12.428325081268625],
              [-17.44889381791495, 12.425488884631845],
              [-17.438537358774404, 12.419194864211512],
              [-17.43448374120712, 12.42056339086128],
              [-17.434151050521347, 12.424422961792606],
              [-17.429293022965286, 12.424846012076125],
              [-17.424594575599563, 12.421523474352957],
              [-17.42451194192894, 12.418494383953332],
              [-17.416710645549834, 12.417912737428018],
              [-17.40401961341917, 12.415207898670225],
              [-17.40195925184217, 12.411026908429573],
              [-17.40298323058803, 12.408056069689302],
              [-17.401656733126217, 12.403750814895549],
              [-17.407420205603238, 12.394927376937952],
              [-17.407510712248712, 12.392420895855153],
              [-17.398998707231218, 12.384919810883947],
              [-17.39295401098168, 12.381047838987907],
              [-17.382738288295208, 12.361803395466403],
              [-17.382393585262253, 12.355788706336266],
              [-17.375734397050532, 12.347820863191194],
              [-17.363783617646117, 12.342711880199898],
              [-17.361231416090956, 12.339486122475424],
              [-17.359343060124633, 12.330560662593085],
              [-17.36232856585604, 12.321540768651015],
              [-17.357575924234446, 12.314162240300515],
              [-17.348947795825524, 12.31262058618469],
              [-17.347390578419475, 12.309990219532134],
              [-17.34106532829334, 12.310090118895632],
              [-17.342632912739255, 12.301835114928238],
              [-17.345143526822913, 12.300313540963526],
              [-17.346900642886208, 12.29585877257885],
              [-17.355134887460046, 12.292378722145246],
              [-17.35735999132865, 12.294915906208988],
              [-17.361231609760786, 12.29430751657931],
              [-17.367895341532684, 12.302362089703639],
              [-17.37583655259761, 12.302408290776809],
              [-17.377875200596336, 12.296644787736437],
              [-17.3824976714154, 12.288447155832692],
              [-17.382475305281105, 12.281900062026802],
              [-17.38464016041412, 12.281282896000706],
              [-17.38066912032803, 12.268934039353203],
              [-17.380478150351767, 12.265810353957846],
              [-17.3830561990567, 12.26162482359126],
              [-17.38235959897942, 12.256186079718857],
              [-17.37245817373552, 12.245012484851973],
              [-17.365659671916642, 12.242688077925289],
              [-17.362178670590744, 12.243280916937701],
              [-17.360641731747485, 12.247039735956065],
              [-17.35635781930573, 12.24496045338355],
              [-17.354912376996882, 12.241210343116714],
              [-17.35749275464603, 12.236707677647438],
              [-17.358934482905983, 12.229652308605608],
              [-17.36295339767339, 12.230369201714211],
              [-17.367146628970733, 12.234369964759],
              [-17.387039254103325, 12.242909246464189],
              [-17.3934225536754, 12.24617367993535],
              [-17.397285594211013, 12.246344560512979],
              [-17.40238587626923, 12.250786637392132],
              [-17.405907844270775, 12.249767122991205],
              [-17.407227041300633, 12.254042498390518],
              [-17.414200148957285, 12.262053578798945],
              [-17.413657097098366, 12.263974435063409],
              [-17.420134568459652, 12.26882008262061],
              [-17.42006177518367, 12.275992935358211],
              [-17.42855494666977, 12.281932291213945],
              [-17.434950746350392, 12.282175955655921],
              [-17.439222432654542, 12.290352095951867],
              [-17.44471107478334, 12.294973024675844],
              [-17.449248844985064, 12.296432637745678],
              [-17.45277303460905, 12.303474470408155],
              [-17.45641365835321, 12.304982904454796],
              [-17.45818719247219, 12.311980548713201],
              [-17.463323734894846, 12.321893818119554],
              [-17.462807964074134, 12.327331477194727],
              [-17.465154974157727, 12.33015132426668],
              [-17.464846209917265, 12.333643923916734],
              [-17.466974236492266, 12.340003242294395],
              [-17.466110877626022, 12.344955607053219],
              [-17.461936999286685, 12.351313115757174],
              [-17.460782197430003, 12.356548045170756],
              [-17.463866559915434, 12.359275046759665],
              [-17.465615208348588, 12.364982591594888],
              [-17.466380958438943, 12.372383333176959],
              [-17.464508968872096, 12.378040085537014],
              [-17.45927995635197, 12.383829623511545],
              [-17.464836433989337, 12.395085784134306],
              [-17.475359527595106, 12.400265764079418],
              [-17.474423018331123, 12.408121899210355]
            ]
          ],
          [
            [
              [-17.470419751507908, 12.497025633333502],
              [-17.470186717574236, 12.501053271481055],
              [-17.456117433838696, 12.497881811901864],
              [-17.450714885195744, 12.495244035042292],
              [-17.448116616239037, 12.492540850348218],
              [-17.436763575143164, 12.486657224604295],
              [-17.430890416013796, 12.48146078181208],
              [-17.429447365989027, 12.477449552755152],
              [-17.419172660477535, 12.466339588660002],
              [-17.41689475307784, 12.460894492091972],
              [-17.408746412480138, 12.450895366562952],
              [-17.413940967071078, 12.452729252489444],
              [-17.42565872270535, 12.465304100984387],
              [-17.43215916614095, 12.464527927239587],
              [-17.44019549468405, 12.466473198409831],
              [-17.444013729940867, 12.461701795209937],
              [-17.447175539161258, 12.465998184172248],
              [-17.45380714457579, 12.46970714086085],
              [-17.46395772421442, 12.480802758582396],
              [-17.465278994329307, 12.485830314898333],
              [-17.46860357326583, 12.487481029292807],
              [-17.468262559304033, 12.491118489244288],
              [-17.470419751507908, 12.497025633333502]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.9654451271241,
          "lat": 48.577358190452564
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53055"],
        "coty_name": ["San Juan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Juan County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01531931"
      },
      "bbox": [
        -17.475359527595106, 12.174443852558158, -17.160020694505757,
        12.544069568436802
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.888063169657853, 0.7161145158173295],
            [11.930373256392455, 0.761805787335132],
            [11.934140202842178, 0.7677898955612121],
            [11.9592407699962, 0.8135502973712061],
            [11.99016345424807, 0.8755514163243406],
            [12.037683371251617, 0.8407482751808706],
            [12.037928064882438, 0.8349269395758887],
            [12.040234667138913, 0.8254652457785014],
            [12.045515605457505, 0.82597579256709],
            [12.04594767167601, 0.8158308222752771],
            [12.048882709357905, 0.8088382333649162],
            [12.0517691544641, 0.8091206362647039],
            [12.054674971959718, 0.8128773913450812],
            [12.057884132764313, 0.8142063769361259],
            [12.059475094203338, 0.8108439217988159],
            [12.066881897319716, 0.8096891058479614],
            [12.068045785977914, 0.8064906493981634],
            [12.073401284028563, 0.803960772868717],
            [12.081021737722288, 0.8035223294329319],
            [12.084711738838966, 0.8001369213266348],
            [12.086972009735275, 0.7927417288740785],
            [12.097503097446328, 0.7855697313021264],
            [12.097095871586358, 0.7781638327071183],
            [12.099947451043825, 0.7699737390979692],
            [12.097080743009892, 0.7665761815603365],
            [12.100450079429253, 0.7648106378737678],
            [12.103629748287695, 0.7661264488631483],
            [12.116533280454881, 0.762701401845346],
            [12.120184939010628, 0.759351905422681],
            [12.121651907650508, 0.7559283110110832],
            [12.122031610685283, 0.7493965942905685],
            [12.125943995196694, 0.7426357346119429],
            [12.12933231817996, 0.7391644620485874],
            [12.130759103212505, 0.7335880176954811],
            [12.13316063894407, 0.730889107553481],
            [12.138153862180783, 0.7304366696976565],
            [12.141946751906126, 0.7322737424001231],
            [12.14459087887175, 0.7287080230677474],
            [12.175598940955403, 0.7278108845716416],
            [12.184156907233792, 0.7130344377963354],
            [12.122463731104247, 0.6379455705117566],
            [12.061390115518185, 0.5847309164101954],
            [12.058196746538458, 0.5806002724785221],
            [12.04898189269386, 0.5729451467815871],
            [12.041194738616687, 0.5678247481563171],
            [11.992801460476588, 0.5265418514583725],
            [11.929035962259219, 0.47249192107857113],
            [11.9007431707393, 0.4483563891586745],
            [11.866284732791225, 0.5542152567851905],
            [11.86568529609956, 0.5567113204550447],
            [11.851936441885503, 0.5900849271876702],
            [11.82801970231398, 0.6498855712889429],
            [11.86289528462432, 0.6890056664345785],
            [11.888063169657853, 0.7161145158173295]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.0750723341392, "lat": 38.46251058708558 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54015"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01550014"
      },
      "bbox": [
        11.82801970231398, 0.4483563891586745, 12.184156907233792,
        0.8755514163243406
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.505713093406081, 1.7015564539974806],
            [12.506549280205649, 1.7011994679826854],
            [12.560639630246866, 1.7190402835181204],
            [12.564593701609265, 1.7209828876302156],
            [12.566399528651552, 1.727897844052598],
            [12.57069870692855, 1.7295767397560504],
            [12.57317466477043, 1.7250458038651018],
            [12.577456080960753, 1.7244462399910103],
            [12.580481037047903, 1.7219206956169428],
            [12.590262478092974, 1.7089101852270554],
            [12.634370772304557, 1.7317101077898125],
            [12.642069242769313, 1.7493056798579067],
            [12.690698053110168, 1.7935075217546423],
            [12.726889838047638, 1.78241273184441],
            [12.74954885701195, 1.6472816868022717],
            [12.749403125108506, 1.6470335806144403],
            [12.742016199477604, 1.6494972036843707],
            [12.739583823682398, 1.6450591792050113],
            [12.74231437095317, 1.638492539708315],
            [12.738973980171169, 1.6348402480452928],
            [12.735247393064657, 1.639492393958949],
            [12.733520266763579, 1.6366749154010187],
            [12.728182052242273, 1.6323043237129637],
            [12.723319663427585, 1.6322904709721449],
            [12.722052564265898, 1.6365776381626373],
            [12.718432566156533, 1.6394335759133762],
            [12.714007918549314, 1.6371363161589525],
            [12.715641898600033, 1.6316350919455636],
            [12.712970058418927, 1.6284739351068471],
            [12.710794037809059, 1.6221717364199164],
            [12.706546619448487, 1.6212545499984083],
            [12.705184575952153, 1.614584559507656],
            [12.70511467746061, 1.6081080482892054],
            [12.700659002635376, 1.6060707777476226],
            [12.698404087308237, 1.6024111663390597],
            [12.693876861503153, 1.6000377101720054],
            [12.661883873859916, 1.5793493460284205],
            [12.641044543791915, 1.5735296179682396],
            [12.567344210207363, 1.5533688235007348],
            [12.554302401338557, 1.5553027322384212],
            [12.534061422161832, 1.5773426456805533],
            [12.529697635967167, 1.5767443354798103],
            [12.524502171219186, 1.5793682488020941],
            [12.52090450767254, 1.5870216002078856],
            [12.517797569591867, 1.6063587903768484],
            [12.505261224271157, 1.6808925682096818],
            [12.501984705558831, 1.6928011757497836],
            [12.502159308347785, 1.697598346445254],
            [12.505713093406081, 1.7015564539974806]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.0462782276702, "lat": 39.335992380318935 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54091"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01689856"
      },
      "bbox": [
        12.501984705558831, 1.5533688235007348, 12.74954885701195,
        1.7935075217546423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.60006398754026, 6.901150797222159],
            [5.600168266292248, 6.901403813411559],
            [5.686701627472916, 6.906839206961083],
            [5.7751308174750005, 6.913129673137054],
            [5.799784465389014, 6.9143888205078685],
            [5.836746401797332, 6.9159762622771845],
            [5.860927055459098, 6.91753185126294],
            [5.86630469470253, 6.831525122765855],
            [5.867981398621953, 6.802937361664391],
            [5.87263950805264, 6.746072639753692],
            [5.8893410615599215, 6.746538315197638],
            [5.915989345883461, 6.748369334429792],
            [5.944427928884086, 6.748528144858916],
            [5.959041247747235, 6.749490936358969],
            [5.960732424289909, 6.723000282905447],
            [5.964088691425012, 6.663994284960305],
            [6.01366542266948, 6.666425328926684],
            [6.01632531520203, 6.623384359294494],
            [6.0192486916529075, 6.580452404864361],
            [6.076119617081599, 6.583529745671142],
            [6.087327598361815, 6.5843684790276455],
            [6.144840628117245, 6.587779265440462],
            [6.145742276065074, 6.574860863083719],
            [6.146146264008782, 6.560574861873327],
            [6.181973720488798, 6.563853035025991],
            [6.189147361245911, 6.564203157970508],
            [6.189328483194024, 6.561640643496638],
            [6.2617600440271355, 6.568015632457293],
            [6.276094359113612, 6.569145930679358],
            [6.276830944557449, 6.554842338335828],
            [6.276497338697924, 6.545293578050522],
            [6.267684760743351, 6.542878960877979],
            [6.242005301971014, 6.529746694238056],
            [6.236417242170688, 6.524865472294141],
            [6.23016071443723, 6.5106026890949735],
            [6.225333615567561, 6.507096672778122],
            [6.222695685677107, 6.498369901112479],
            [6.2230076489308574, 6.4926766335985135],
            [6.227454634118563, 6.480155215006317],
            [6.234265880556143, 6.470519634796103],
            [6.23463009875461, 6.467743912790148],
            [6.231789287544479, 6.462555145286981],
            [6.224264103596914, 6.454887191611579],
            [6.225694383149198, 6.448706978299757],
            [6.2216288235920825, 6.438954167450052],
            [6.2205311757286275, 6.431918230744963],
            [6.215675348737595, 6.421593260912042],
            [6.213823345465599, 6.416105220453609],
            [6.2066777880411514, 6.4127609323085695],
            [6.194461604434593, 6.401265288195707],
            [6.1897958990977004, 6.399242538082884],
            [6.190697947275158, 6.39371588246602],
            [6.187281413297312, 6.386863421869572],
            [6.186878913820685, 6.38223998485201],
            [6.181863577224657, 6.370968266982231],
            [6.1809894372824035, 6.360985500033513],
            [6.176773133546316, 6.348907642330082],
            [6.175975759267048, 6.343813481543193],
            [6.172549178902027, 6.335692629897139],
            [6.168815610142439, 6.333869004101116],
            [6.166995350054616, 6.327475009034267],
            [6.16146134683737, 6.322181691294577],
            [6.150241694511931, 6.307842557885442],
            [6.146521743700069, 6.299049888013751],
            [6.146399719681929, 6.295368432500637],
            [6.142167186150392, 6.289221307426043],
            [6.14072485818749, 6.282198220663518],
            [6.140202966040878, 6.2732850935647475],
            [6.1389859512191185, 6.268073873558369],
            [6.139657977612433, 6.254871972881734],
            [6.142155459755582, 6.2450920837717785],
            [6.139611146702334, 6.244479176331536],
            [6.1381633229390715, 6.2443488692921685],
            [6.137069326260792, 6.2447346811940365],
            [6.086121881239736, 6.240186471998936],
            [6.040908344579301, 6.235981736330563],
            [6.005682328786932, 6.229815524387962],
            [5.970566972007566, 6.225651121640211],
            [5.970133680108287, 6.232809542522549],
            [5.961833140336556, 6.232207022306813],
            [5.961311249172794, 6.238748316768952],
            [5.958323051230416, 6.260516068557031],
            [5.951222728654938, 6.30192770169685],
            [5.947878545953971, 6.318188383172821],
            [5.943795270244369, 6.403700355570093],
            [5.857819455531388, 6.398523156216501],
            [5.829139150178415, 6.396412002566537],
            [5.773614198760815, 6.392794272873922],
            [5.769403813505794, 6.447658241280194],
            [5.763857286305881, 6.530687333073304],
            [5.763718986718474, 6.5363048405475555],
            [5.756753922419864, 6.652383711099358],
            [5.7452828466013415, 6.651048893020371],
            [5.646081071966268, 6.644221515685015],
            [5.645834750501162, 6.654968963805388],
            [5.641404516096555, 6.731075134735411],
            [5.611986008858865, 6.728992535975076],
            [5.606760761573181, 6.803928953084591],
            [5.60006398754026, 6.901150797222159]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.26972317915674, "lat": 45.02638558062195 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55083"],
        "coty_name": ["Oconto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oconto County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01581102"
      },
      "bbox": [
        5.60006398754026, 6.225651121640211, 6.276830944557449, 6.91753185126294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.745550506656694, 6.575183091145432],
            [2.826444149813182, 6.578676330726599],
            [2.8848293910142755, 6.580896410357306],
            [2.913891924699515, 6.581167148973995],
            [2.9747133676949424, 6.58309636163618],
            [3.034933609268264, 6.585303358569437],
            [3.11032077136752, 6.588293352832992],
            [3.1687221089990443, 6.590848200410024],
            [3.171489633282216, 6.51723376856342],
            [3.1718533149967496, 6.503451834044765],
            [3.1866239673521366, 6.503828176741884],
            [3.1882400532719544, 6.4581435390232995],
            [3.1895602620925874, 6.425647378432022],
            [3.1915746367807323, 6.383129691446701],
            [3.1948590770490384, 6.317399414275666],
            [3.1961532683994847, 6.27052640471838],
            [3.1971831909455286, 6.241774169066529],
            [3.165640703684866, 6.2404125155860495],
            [3.14071913746809, 6.2396762280326765],
            [3.1263862492901984, 6.238801295750669],
            [3.11089650392424, 6.238574692270668],
            [3.04307419944829, 6.239318294662393],
            [3.0283156844482186, 6.239594865049925],
            [2.955857002042829, 6.23702143315844],
            [2.88339879109631, 6.234434472681844],
            [2.8087836762245595, 6.2319468622467245],
            [2.749580833904714, 6.22929361087799],
            [2.7530433247203905, 6.239505520400202],
            [2.7526126444521997, 6.243252884855632],
            [2.7485045905120846, 6.250149460092524],
            [2.7444206388299013, 6.259804334363578],
            [2.7454045081719896, 6.268374757045561],
            [2.754758000743028, 6.275156181778214],
            [2.7560560800251936, 6.278544194480954],
            [2.760047797265192, 6.304662008511522],
            [2.759790794886202, 6.308904180911191],
            [2.7566203686406534, 6.32293902309245],
            [2.751999436480982, 6.331956521187979],
            [2.747291827013915, 6.334889334715068],
            [2.745580968320661, 6.338880639226186],
            [2.74456455588857, 6.3499765755986255],
            [2.745314484107574, 6.35484939634757],
            [2.74385255874923, 6.360710833497439],
            [2.7433258745642273, 6.367909104824772],
            [2.7488106843006705, 6.387184642800235],
            [2.749015868621495, 6.390944096648585],
            [2.747069514465347, 6.395305655619384],
            [2.7428361569032966, 6.400176269260663],
            [2.736685905808898, 6.405468229646877],
            [2.730128984873743, 6.409417903909499],
            [2.7234199689609584, 6.416292754341062],
            [2.7196832140609786, 6.422911979415102],
            [2.7188115998722586, 6.43082641187625],
            [2.720126813563063, 6.434925703730473],
            [2.726356268637587, 6.445257451813903],
            [2.7383828002167836, 6.455108890689632],
            [2.7440844575309824, 6.461862575975033],
            [2.751734821728617, 6.469502798421723],
            [2.758216318978694, 6.474861618893018],
            [2.761746562243024, 6.48314871324133],
            [2.7571763494196575, 6.489558298377986],
            [2.754032994994097, 6.50438346558479],
            [2.7520138198237167, 6.508247475894252],
            [2.7539379264007016, 6.514678342150677],
            [2.7522771218169906, 6.523704602325994],
            [2.7529133643045385, 6.5294047107676105],
            [2.750963305384832, 6.5321821229722055],
            [2.7507121497380447, 6.539891494283466],
            [2.7416325163813378, 6.548434544675781],
            [2.739880633685698, 6.553416383909497],
            [2.7397639656154675, 6.560607243599377],
            [2.7415596403306206, 6.570372429676684],
            [2.745550506656694, 6.575183091145432]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.45256712791928,
          "lat": 45.033991170529404
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55109"],
        "coty_name": ["St. Croix"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Croix County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01581833"
      },
      "bbox": [
        2.7188115998722586, 6.22929361087799, 3.1971831909455286,
        6.590848200410024
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.14405609208606,
          "lat": 18.437478908736743
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72033"],
        "coty_name": ["Cataño"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Cataño Municipio"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01804496"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.99896796849164, "lat": 18.3362750299983 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72139"],
        "coty_name": ["Trujillo Alto"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Trujillo Alto Municipio"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01804550"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.7022787143046, "lat": 18.271028500033133 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72141"],
        "coty_name": ["Utuado"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Utuado Municipio"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01804551"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.602734808840108, -5.4177221901061365],
            [7.688290732039537, -5.407150449610624],
            [7.687180322837411, -5.390589215738534],
            [7.686006198592707, -5.319062665550983],
            [7.706961677950261, -5.2777696169552035],
            [7.750314129567888, -5.275619617336206],
            [7.77563974386285, -5.273867675660498],
            [7.769642544938466, -5.208087411244435],
            [7.805252264292322, -5.168610212648638],
            [7.812303635765055, -5.167971349929513],
            [7.812125717233059, -5.164243198781951],
            [7.8299223287019535, -5.1629301076546055],
            [7.831539044336454, -5.176975847615183],
            [7.84597650518446, -5.175916408163119],
            [7.86630181737847, -5.148462301852804],
            [7.875313639038354, -5.14754008312291],
            [7.907523985350712, -5.144960085222561],
            [7.909653100682398, -5.159716105895913],
            [7.9119427294617894, -5.181538465949718],
            [7.915526735692893, -5.1811409378164575],
            [7.917336237837656, -5.19943164669933],
            [7.913747665558925, -5.199781263514649],
            [7.916213336565755, -5.225366197442679],
            [7.93422912587872, -5.223664008117529],
            [7.9345629831369555, -5.227446445983531],
            [7.959015543904757, -5.225433915522068],
            [7.959257585292379, -5.22890787206215],
            [7.963335733703225, -5.228620626693651],
            [7.969265301416267, -5.2882020014286715],
            [7.98450600308018, -5.286564942632813],
            [7.985755698851699, -5.30642308822041],
            [8.000392633540539, -5.304973644418642],
            [8.001821914336746, -5.3196737727941334],
            [8.013311793665148, -5.318317604667755],
            [8.016753955160416, -5.321286930282597],
            [8.017203562780493, -5.3251659325865734],
            [8.031819602190803, -5.323857000208374],
            [8.03258097600253, -5.3310814318713495],
            [8.046945522452646, -5.32961469078322],
            [8.050521363869175, -5.329247801285791],
            [8.055675059324733, -5.378886221136938],
            [8.065329781800225, -5.476780349088705],
            [8.071748541337781, -5.542229944070124],
            [8.010158060527639, -5.546708536639759],
            [7.984350941780015, -5.549549841199523],
            [7.96866326023336, -5.550889549186035],
            [7.952759485704732, -5.552769561567799],
            [7.839730292730413, -5.565108231286735],
            [7.825788090769117, -5.565885155749839],
            [7.8052297017616326, -5.5683828288610595],
            [7.782889858180295, -5.570505318769677],
            [7.775157072696771, -5.574143950866419],
            [7.761669348145007, -5.575915475022026],
            [7.7037844616325195, -5.5814033639768095],
            [7.699543061213995, -5.537945083382786],
            [7.615034412957408, -5.5462228363043184],
            [7.614106911417229, -5.530125061272887],
            [7.6040764261080085, -5.426128401637456],
            [7.602734808840108, -5.4177221901061365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.12646681645651, "lat": 32.9986270272255 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01007"],
        "coty_name": ["Bibb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bibb County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00161529"
      },
      "bbox": [
        7.602734808840108, -5.5814033639768095, 8.071748541337781,
        -5.144960085222561
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.149388760972165, -5.5400791208616305],
            [9.162951328298652, -5.53827157379945],
            [9.162157518138041, -5.530791719092483],
            [9.169350314570924, -5.5298650742070095],
            [9.17018085360849, -5.537305660923936],
            [9.234346807589427, -5.528622222228545],
            [9.233485430337478, -5.5215637146991705],
            [9.240871681096527, -5.520646362175242],
            [9.241516461947354, -5.527929308022539],
            [9.284341328781437, -5.523382585055262],
            [9.282701090709086, -5.508754460565256],
            [9.296944504148646, -5.5074732642090805],
            [9.297760662144343, -5.514736480124715],
            [9.304906087102246, -5.513638378336403],
            [9.305928617896209, -5.520777697644485],
            [9.328737301154138, -5.518460628743466],
            [9.385157912542498, -5.511707939207398],
            [9.405214768477476, -5.5094502164896335],
            [9.403751311401015, -5.4951041187416765],
            [9.450139274325577, -5.489564159938488],
            [9.528036923768111, -5.479588326552424],
            [9.528208635608582, -5.479301343639264],
            [9.530640785148455, -5.481426514963156],
            [9.54238877257845, -5.483705169493498],
            [9.545819831620685, -5.486046919076785],
            [9.547780540921535, -5.491155384030466],
            [9.546683947375342, -5.495294500807971],
            [9.542543056868805, -5.501714114010898],
            [9.54179206021534, -5.509061789055303],
            [9.545549655903898, -5.514346330836333],
            [9.546017698558078, -5.520431516178516],
            [9.549252374031445, -5.532087503723739],
            [9.55389823206062, -5.5402215223801985],
            [9.561484371364187, -5.543181976562529],
            [9.57135402841043, -5.5520271778457],
            [9.576934968220188, -5.563455524133639],
            [9.576137662167628, -5.56568642026071],
            [9.567955462085813, -5.572167271183586],
            [9.564407124673467, -5.577914637551758],
            [9.569411226593159, -5.585117165281049],
            [9.5728465612817, -5.5871930089007344],
            [9.577295166385836, -5.587318549122259],
            [9.583477323269054, -5.584657159371312],
            [9.584780222700438, -5.586662945247852],
            [9.579862952164456, -5.595696628424617],
            [9.58222036626663, -5.600422852394148],
            [9.586909689140814, -5.604122506846321],
            [9.58920105530699, -5.612090115602007],
            [9.589996453663296, -5.616551259087013],
            [9.594260298902398, -5.625040812084576],
            [9.603381785725011, -5.6392252320871945],
            [9.610250170321466, -5.64126029339804],
            [9.613171237490656, -5.646465412551131],
            [9.628603080185405, -5.660402760354843],
            [9.63378253361043, -5.663480860195465],
            [9.6368491949102, -5.669743127112247],
            [9.64510130160979, -5.67131552070741],
            [9.647940732530978, -5.679223499447409],
            [9.651729888962779, -5.682433768410324],
            [9.654313172706642, -5.687191551592506],
            [9.660143052175373, -5.688774374731339],
            [9.665840057201832, -5.697310131854208],
            [9.666986935672801, -5.701757253881775],
            [9.635077099270434, -5.7062394215450585],
            [9.617127896288922, -5.708533908085296],
            [9.62254773444872, -5.744372153863642],
            [9.577790110387223, -5.750865999485667],
            [9.47654302204059, -5.763864565033691],
            [9.394183279384235, -5.774678950372558],
            [9.403778633856856, -5.831786438690938],
            [9.377281576100962, -5.835180481875336],
            [9.317193910621791, -5.842457969196791],
            [9.309306005960995, -5.791145053389676],
            [9.308773582643948, -5.7862857954203415],
            [9.303684840499018, -5.756132863278972],
            [9.261378469589099, -5.760972294707906],
            [9.222491251113242, -5.746889906923437],
            [9.194335423013463, -5.7364712542001985],
            [9.180763079301565, -5.73320524760654],
            [9.170221579125272, -5.727694909451919],
            [9.1331692591716, -5.714404974722658],
            [9.110478294393497, -5.706036155141238],
            [9.108739542327767, -5.691729795154427],
            [9.080119923395207, -5.695136720240074],
            [9.078440814594375, -5.681326621104829],
            [9.075302498569187, -5.655999403748146],
            [9.06664545309361, -5.58041068279199],
            [9.080813552040164, -5.578370229821285],
            [9.079055678083748, -5.5638575839834585],
            [9.13677460429624, -5.556164836310284],
            [9.135451294767554, -5.54218815151268],
            [9.149388760972165, -5.5400791208616305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.35549557710912,
          "lat": 32.601136380357644
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01081"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00161566"
      },
      "bbox": [
        9.06664545309361, -5.842457969196791, 9.666986935672801,
        -5.479301343639264
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.67517983975151, -5.513849081921627],
            [3.680423152603151, -5.5030739497084395],
            [3.677994693829761, -5.500022742889294],
            [3.6819559960147297, -5.492845791898492],
            [3.6810107643766856, -5.488884037042169],
            [3.6764394504644993, -5.490173387387501],
            [3.6751193423590878, -5.480064502009287],
            [3.6771446653828836, -5.476000271416858],
            [3.6809905804216863, -5.4720917402149585],
            [3.6811702777197066, -5.467134399478361],
            [3.6908163643626946, -5.470364723296497],
            [3.6933920842265797, -5.46348553923935],
            [3.6907429035853987, -5.461021032458535],
            [3.6915658690851614, -5.454832818882594],
            [3.698747855911103, -5.452503188831685],
            [3.702109983168383, -5.456968235822685],
            [3.7091646471594086, -5.453832526986045],
            [3.713624068204159, -5.448311316895754],
            [3.7133457909992895, -5.443574841622785],
            [3.7114160196803136, -5.439865809309498],
            [3.71263355961973, -5.436428931663831],
            [3.7160985255372263, -5.434073278028141],
            [3.721385604749208, -5.437682460763789],
            [3.7225698087701398, -5.434495498164828],
            [3.7282296994199524, -5.433359898483548],
            [3.727524548333681, -5.427777236900696],
            [3.7243329735473463, -5.4243660273296594],
            [3.732711708702036, -5.423088038650065],
            [3.7325100147424384, -5.419321007352075],
            [3.7357985191393963, -5.4166726999741615],
            [3.740053457999379, -5.420276287727789],
            [3.743263586109588, -5.4206931525682425],
            [3.7447788210913058, -5.417179006903085],
            [3.7484088776709497, -5.416844052599424],
            [3.745360250952567, -5.410063404236873],
            [3.74838304849965, -5.40597103079444],
            [3.754162559082416, -5.4071696041784305],
            [3.7545547230430922, -5.402086780395399],
            [3.7523358159214077, -5.401464727818727],
            [3.749702717681989, -5.397002912530422],
            [3.758489911192769, -5.390182895739529],
            [3.765563021564991, -5.396866023729401],
            [3.7660107233999347, -5.3935581661625],
            [3.7736770105736577, -5.389662050993701],
            [3.7757468195226482, -5.387343555761956],
            [3.779636432856707, -5.38956626759225],
            [3.7832754070776446, -5.384912745500317],
            [3.7761537363616804, -5.374947595645684],
            [3.7828139323097294, -5.3678289868154945],
            [3.7877268331893115, -5.366859460499123],
            [3.7941441377808904, -5.372580903714291],
            [3.7983518706767905, -5.372650609390707],
            [3.80241900557856, -5.368632966153974],
            [3.8035162481697253, -5.363584670547319],
            [3.801307383953772, -5.360372187887571],
            [3.804798187609351, -5.350213558298819],
            [3.8028894943147096, -5.34905105177275],
            [3.8023442473981217, -5.343518935230797],
            [3.7923618404679176, -5.330456089678063],
            [3.790490670078918, -5.323033925694647],
            [3.7954148442078304, -5.325487592503869],
            [3.799029622004979, -5.324854723348266],
            [3.805334115082951, -5.320396780883769],
            [3.808086708479028, -5.315558687346077],
            [3.8080583041250633, -5.309965080793228],
            [3.8055001120970338, -5.304353866886641],
            [3.80689660500904, -5.300321387622924],
            [3.8128530918432255, -5.294342904117547],
            [3.8135813119513444, -5.291314809711469],
            [3.8004987479691996, -5.285431744004678],
            [3.7908550410589066, -5.284041862175948],
            [3.7898114553773707, -5.27800982844519],
            [3.787645075395431, -5.273092590717414],
            [3.8293138661622637, -5.27246898840097],
            [3.885192861328401, -5.270901749534074],
            [3.9215058890462613, -5.270304583313852],
            [3.971633857959233, -5.2697885866906935],
            [3.9768333500275004, -5.269473440938176],
            [4.057298793549893, -5.2669351816026575],
            [4.106127374772194, -5.265955393676057],
            [4.142876042985282, -5.264836028737257],
            [4.142852784335634, -5.2642519629016],
            [4.1927084119269376, -5.263192965079223],
            [4.2294439114712326, -5.262637193816258],
            [4.231270143431573, -5.320822290367855],
            [4.2311546294841325, -5.321185060143262],
            [4.232868311114832, -5.380013780066782],
            [4.233464824614172, -5.394498159190738],
            [4.238755224324654, -5.510983051908873],
            [4.241780524324164, -5.568599940282995],
            [4.245362558887629, -5.646158024986276],
            [4.2213778442986545, -5.647021956386973],
            [4.212241012256606, -5.646849744359309],
            [4.15212821990747, -5.6495370224368475],
            [4.145923223150366, -5.650215631875547],
            [4.106902607052829, -5.651891951707595],
            [4.016236610790365, -5.6550624183994955],
            [3.9999973660711845, -5.656346686164059],
            [3.900013280082617, -5.660010789404721],
            [3.836061071918249, -5.663049432473683],
            [3.7386414301000075, -5.666385568120356],
            [3.7386158464577264, -5.666386428540216],
            [3.730086675738903, -5.65701519694447],
            [3.730192908941202, -5.653686205031989],
            [3.727890562246489, -5.650347852328341],
            [3.726222962867545, -5.643851082495247],
            [3.716393241936648, -5.641583666171636],
            [3.713200261116944, -5.64205504248935],
            [3.7077543236993344, -5.645720451426268],
            [3.703820259261199, -5.641743296240618],
            [3.702859342327719, -5.63283754655316],
            [3.698453117101076, -5.628912318817826],
            [3.702379879923315, -5.625824472943171],
            [3.7034560227393856, -5.622665203434547],
            [3.700881399939984, -5.619163507447708],
            [3.698030345831077, -5.6102077757832],
            [3.698711481463256, -5.607274003709956],
            [3.695645270497494, -5.604183967408844],
            [3.685697001010698, -5.606078638013476],
            [3.68550681733483, -5.601270631703646],
            [3.680268375967961, -5.585119588228331],
            [3.6809449315350453, -5.578866637497916],
            [3.6732556166858887, -5.579392277732635],
            [3.6780960692350644, -5.575140338490052],
            [3.678134484878999, -5.570025872055723],
            [3.684362657134923, -5.560955037996136],
            [3.684317697284487, -5.557456870274951],
            [3.6916145305570858, -5.556734456404263],
            [3.6966575874836822, -5.542822582867815],
            [3.695335212868731, -5.538282341958837],
            [3.691720426606438, -5.534096980038385],
            [3.6915790276134035, -5.530835059400834],
            [3.697792717584676, -5.531934704851985],
            [3.700209489321636, -5.530028378055508],
            [3.6995840430944478, -5.524501037560479],
            [3.696872580469714, -5.517152475466932],
            [3.688044183786916, -5.514458441871175],
            [3.677895866416139, -5.516597827356791],
            [3.67517983975151, -5.513849081921627]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.76847602272487, "lat": 33.19121663665078 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05003"],
        "coty_name": ["Ashley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ashley County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00063756"
      },
      "bbox": [
        3.6732556166858887, -5.666386428540216, 4.245362558887629,
        -5.262637193816258
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.2294439114712326, -5.262637193816258],
            [4.228147699324292, -5.226062614705276],
            [4.225969437013783, -5.146007462197593],
            [4.228828665377092, -5.143369967755845],
            [4.228594127336658, -5.139147928711138],
            [4.225606278807488, -5.130825822805366],
            [4.22426916249639, -5.0874861121330985],
            [4.281553927459546, -5.084992772670668],
            [4.31011765457432, -5.083449081731796],
            [4.311339342460915, -5.127805722710808],
            [4.314998723733924, -5.127700510267889],
            [4.314549881911527, -5.113372498669525],
            [4.325241209518371, -5.1128770324778925],
            [4.325363904839047, -5.120269044186117],
            [4.333028769311802, -5.120147591906069],
            [4.3329636313949855, -5.127415126780427],
            [4.3982672349198895, -5.125681198005694],
            [4.397208309834038, -5.089167256420571],
            [4.39902709665235, -5.088987136211037],
            [4.398826698623954, -5.081197421214472],
            [4.4059025287206985, -5.080957105884312],
            [4.406645158161258, -5.088840642448339],
            [4.410492165275112, -5.096641650393677],
            [4.420010532425063, -5.112348938407224],
            [4.423222255277807, -5.116019244092823],
            [4.431826999535097, -5.122902993233958],
            [4.448652760069097, -5.132852715249247],
            [4.451408123151349, -5.141094792111518],
            [4.441173533661945, -5.152373142177045],
            [4.438170372862029, -5.1578896611884355],
            [4.431509969818903, -5.172803689778622],
            [4.425934426269768, -5.176925358084313],
            [4.419557590397192, -5.179269312354623],
            [4.412956654577731, -5.185286772643186],
            [4.412158719917757, -5.198441502867553],
            [4.410958484158348, -5.203587843432587],
            [4.425913941717394, -5.207129281250678],
            [4.434704070658114, -5.207544345446573],
            [4.444632626428906, -5.204522544105708],
            [4.455060611607674, -5.19955647776222],
            [4.459234214533045, -5.195482873464453],
            [4.464399973074359, -5.187807294820893],
            [4.464241336750676, -5.18591960980877],
            [4.458199472069511, -5.1671281662343125],
            [4.4565726028737895, -5.158452226674006],
            [4.4566705251254755, -5.152809837654415],
            [4.460556374699771, -5.142829265369022],
            [4.463511110717629, -5.14134095940178],
            [4.468852059024284, -5.1419257027027845],
            [4.4820193121326755, -5.148310059919686],
            [4.494039498748396, -5.156630636520012],
            [4.499527178712111, -5.162802185987166],
            [4.50382792081507, -5.170262119988641],
            [4.507137079040245, -5.1795357457239595],
            [4.508152333956967, -5.18555671889975],
            [4.506790765391486, -5.19147236133745],
            [4.498182011494902, -5.20409102797705],
            [4.4969150214920175, -5.208191014053513],
            [4.4910612870253805, -5.2116101981235055],
            [4.484003063530966, -5.211751810571266],
            [4.4712435157484265, -5.217435194760506],
            [4.4608343568043525, -5.223161134260372],
            [4.453956835434057, -5.220901396849162],
            [4.447803595265284, -5.223067246617891],
            [4.441662556192729, -5.222781286841769],
            [4.436970592863144, -5.227123564420576],
            [4.434410333189377, -5.2327860119386616],
            [4.434395109856604, -5.237892774487408],
            [4.438178546016734, -5.242531459330325],
            [4.449934606010602, -5.251164345819982],
            [4.4620297476177875, -5.257372943867343],
            [4.471001301632963, -5.260062860903299],
            [4.4855352352596825, -5.260272508844906],
            [4.49116740736537, -5.2586857497879755],
            [4.5078786975820355, -5.2494398659534784],
            [4.513826092938144, -5.24441280655318],
            [4.524878862660851, -5.22970461538973],
            [4.527260002643802, -5.223943683364869],
            [4.5277157602076965, -5.212548531079955],
            [4.525312225849784, -5.205059334530015],
            [4.525629066936142, -5.19914908457693],
            [4.5273886104756285, -5.193969811125438],
            [4.532936246608307, -5.185029660504145],
            [4.5370884067847195, -5.181905601623059],
            [4.546180044041544, -5.179766209925629],
            [4.55128723717049, -5.181586648145501],
            [4.555503593219812, -5.184900906261686],
            [4.557147250891754, -5.18855114669576],
            [4.558018343932458, -5.206411358485802],
            [4.553345497311996, -5.2169380925131605],
            [4.545674984386141, -5.228338957914649],
            [4.541455239342544, -5.233416212396438],
            [4.53246179214533, -5.240353433950849],
            [4.524326673797735, -5.249831497941914],
            [4.520248949469629, -5.256113637445067],
            [4.509837702168275, -5.274046577815437],
            [4.5061362675855, -5.277960188073935],
            [4.494084065740768, -5.287255456317832],
            [4.492531180744079, -5.289806959684576],
            [4.494210688312226, -5.302264744550762],
            [4.492390107384747, -5.31048290066619],
            [4.4949312285161644, -5.324485936463283],
            [4.4955753868595565, -5.339286570760016],
            [4.4970174995902665, -5.3421447847598875],
            [4.5098999290947335, -5.357909854426676],
            [4.510194078599244, -5.363437744921783],
            [4.508400439984557, -5.369781749086537],
            [4.516384009182276, -5.37547729709032],
            [4.524098632846556, -5.3916306201370485],
            [4.532579535081125, -5.398879355539071],
            [4.535630731504106, -5.39535578766345],
            [4.536981378152698, -5.386384003946506],
            [4.5402819947067785, -5.379363894807684],
            [4.542920960484281, -5.36284230027281],
            [4.544691873721111, -5.357828241807353],
            [4.548727158039186, -5.352853816039247],
            [4.558057513671508, -5.348483601385161],
            [4.564958979819982, -5.3484063634649015],
            [4.570311636898808, -5.349620327058496],
            [4.5739475755157155, -5.352060247121327],
            [4.578129093360446, -5.360032908389861],
            [4.577313751836396, -5.36934083451135],
            [4.573731442357986, -5.383779944108017],
            [4.57091296864075, -5.389041333574331],
            [4.5632509460429045, -5.398218243085568],
            [4.562054716705516, -5.402669532706398],
            [4.559502105149033, -5.40284770665492],
            [4.558145596311449, -5.408571551346157],
            [4.552210808294313, -5.40871245706809],
            [4.551064624078809, -5.4122065170795315],
            [4.545753496009764, -5.414888651028612],
            [4.5340200643354915, -5.4177159163644095],
            [4.537999862095318, -5.426496185920296],
            [4.5490790318079, -5.446080194038924],
            [4.5521201098278326, -5.4541259076292326],
            [4.553353724212625, -5.466005972376144],
            [4.552872361331199, -5.482585092657237],
            [4.55037688819819, -5.4993875317202665],
            [4.548854861935874, -5.501262669150899],
            [4.538922621443324, -5.5060621331651705],
            [4.527942424950092, -5.5085494497618575],
            [4.515599679933746, -5.509472652469165],
            [4.496991313624659, -5.508634141280144],
            [4.494631632125042, -5.504631078989704],
            [4.488196098395871, -5.498526469604828],
            [4.480556102678721, -5.497486161886388],
            [4.468760211978355, -5.499033568935224],
            [4.461599360196964, -5.5040162916865105],
            [4.456135673724023, -5.512875207403826],
            [4.454471346475759, -5.5183777176443485],
            [4.455599339075448, -5.531849509510021],
            [4.460436493348568, -5.536698580517444],
            [4.473318333576201, -5.542264771704083],
            [4.48020860212407, -5.551620719352647],
            [4.482426122872633, -5.552817431315674],
            [4.4918813603742, -5.554415500411095],
            [4.499604908999349, -5.55721684697406],
            [4.5218005910043875, -5.5741413998850815],
            [4.524920902423301, -5.578957583847509],
            [4.525838988048083, -5.583560292996503],
            [4.523998049306086, -5.587122562051494],
            [4.522549101690662, -5.5994521381380835],
            [4.520273232536526, -5.6041515355619715],
            [4.512977092264224, -5.610085569287063],
            [4.502851949933732, -5.61303178734506],
            [4.493131741868275, -5.620005485285179],
            [4.489890231212415, -5.628658618566938],
            [4.49038541961474, -5.635746950419626],
            [4.408011667062225, -5.6390818730783],
            [4.3918851168781305, -5.639957623391161],
            [4.351396924954769, -5.64142464132099],
            [4.265826496238728, -5.644991815220013],
            [4.245362558887629, -5.646158024986276],
            [4.241780524324164, -5.568599940282995],
            [4.238755224324654, -5.510983051908873],
            [4.233464824614172, -5.394498159190738],
            [4.232868311114832, -5.380013780066782],
            [4.2311546294841325, -5.321185060143262],
            [4.231270143431573, -5.320822290367855],
            [4.2294439114712326, -5.262637193816258]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.29373608281479, "lat": 33.2669614240609 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05017"],
        "coty_name": ["Chicot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chicot County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00069160"
      },
      "bbox": [
        4.22426916249639, -5.646158024986276, 4.578129093360446,
        -5.080957105884312
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4805431360704295, -2.5737846841703957],
            [2.5164368499367686, -2.573672375048676],
            [2.5805378103504792, -2.5736787523406752],
            [2.6235969611145, -2.573393978346189],
            [2.6376444134113326, -2.5738867617388284],
            [2.6948331511033348, -2.5736349605836932],
            [2.7521400564578338, -2.573646351484759],
            [2.7654347091191487, -2.571259171927221],
            [2.7949923859689223, -2.570607679722894],
            [2.807575633961107, -2.5724052370021475],
            [2.8229738455357745, -2.5727203723164918],
            [2.8659452857320176, -2.5715265014055744],
            [2.9086949285197186, -2.5708249366310465],
            [2.908728464737311, -2.571120457268264],
            [2.9094490553061734, -2.615060116913995],
            [2.9150738484085608, -2.614888344797653],
            [2.915831108356648, -2.6971959791023985],
            [2.916463685751782, -2.7456787182988647],
            [2.9165639667383534, -2.8170018315874725],
            [2.9170595966719612, -2.875770429839742],
            [2.9146291557959882, -2.8757959671839317],
            [2.9159772309546894, -2.9648493074789863],
            [2.8828346526899096, -2.9648938794558144],
            [2.8583817385610972, -2.965401815927312],
            [2.8156649459066263, -2.965682023909164],
            [2.759052822492473, -2.9665469754963616],
            [2.744507963784005, -2.9658788653698642],
            [2.7158961694051627, -2.965668642545785],
            [2.6861101706752697, -2.966287377462549],
            [2.59989666246032, -2.9685165744493225],
            [2.5718658024754015, -2.969027698579003],
            [2.5289169095062483, -2.968974851879939],
            [2.4587323095601827, -2.968225599331801],
            [2.458336230116829, -2.9389773280495555],
            [2.4584692496648874, -2.878638935165893],
            [2.4512331640546097, -2.8785138746651677],
            [2.4516473538369614, -2.820153268707582],
            [2.465822383276806, -2.820272022978474],
            [2.465962964459997, -2.7904274031422784],
            [2.4655638933991537, -2.7757972512836173],
            [2.479980051949523, -2.7762335743813398],
            [2.4797573176961025, -2.746973315944709],
            [2.4940651691097573, -2.7467935683903093],
            [2.49392754901258, -2.732250356822307],
            [2.5077935179255944, -2.7319657644618687],
            [2.5080686621874193, -2.7030370605887355],
            [2.507918483502182, -2.673523547909408],
            [2.507507325250328, -2.6452291674818804],
            [2.508767706306307, -2.617681612143478],
            [2.481104609756446, -2.6176458157187708],
            [2.4805431360704295, -2.5737846841703957]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.2178691425262, "lat": 35.91997896531419 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05101"],
        "coty_name": ["Newton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newton County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00069900"
      },
      "bbox": [
        2.4512331640546097, -2.969027698579003, 2.9170595966719612,
        -2.570607679722894
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7254044561340345, -3.789955471748375],
            [1.7324065179420893, -3.7909315784569557],
            [1.7397991287016645, -3.7930785693298104],
            [1.7462900565766248, -3.78777310575187],
            [1.7520717758027609, -3.7777354255248534],
            [1.7564128152735907, -3.773530520089348],
            [1.7633382480493085, -3.7753590426081622],
            [1.7705242730324533, -3.7796876220336646],
            [1.7789723821956227, -3.7753667162706503],
            [1.7847468439466434, -3.775021797901912],
            [1.7861715642907015, -3.7693702680078216],
            [1.785485935444334, -3.762474455942011],
            [1.7901562540178535, -3.760508374345084],
            [1.7958261269995321, -3.761842228117436],
            [1.8034901467348832, -3.7702963055598264],
            [1.8063603426352723, -3.7756201548170387],
            [1.8106222313672442, -3.775568255303316],
            [1.816851915002706, -3.7735130782835826],
            [1.820606957917534, -3.7679952125333713],
            [1.825565858732762, -3.76628866871559],
            [1.8344835706721314, -3.7684179964218747],
            [1.8451330527615963, -3.7691344997539087],
            [1.850741572828237, -3.768725201281738],
            [1.8546336264194172, -3.7665749222118268],
            [1.86278672263597, -3.764502525640041],
            [1.8644364652255188, -3.7652054219833913],
            [1.8726762751643558, -3.7639396367519815],
            [1.8759817553618585, -3.7617143789012006],
            [1.8810287129288343, -3.761298016217267],
            [1.8854919729860355, -3.7571326851987807],
            [1.8908572644418926, -3.756237760278126],
            [1.895612693935686, -3.7536255272732495],
            [1.9014232117651477, -3.7522193541021105],
            [1.9016115664101252, -3.6626892415674006],
            [1.8832449579770683, -3.6623170351383],
            [1.8832440785532334, -3.6548320743101606],
            [1.8962306347705804, -3.650438623451747],
            [1.901636765553231, -3.64792101506242],
            [1.905425824706635, -3.647823225912338],
            [1.9055098926841794, -3.640572014791793],
            [1.9280949667727894, -3.6406143706353173],
            [1.9279127849145061, -3.633343880250253],
            [1.9389081442290999, -3.6335323723706527],
            [1.9390206554970912, -3.6299208925203517],
            [1.942570410334788, -3.6299134230983143],
            [1.9426117849758495, -3.6261985645484893],
            [1.957172239929102, -3.6263875856886405],
            [1.95725123630149, -3.618963863895138],
            [1.9720000805468394, -3.618851427869681],
            [1.9718115752342376, -3.6631422069307757],
            [2.02721171154008, -3.6635534011188136],
            [2.0270329938010607, -3.691494465373523],
            [2.070683383282087, -3.6918468135670928],
            [2.141571941247867, -3.6920845285230977],
            [2.155869279075591, -3.6918001105646985],
            [2.1982271066842545, -3.6916023842937107],
            [2.241187777908974, -3.6925736825768],
            [2.3271175422798382, -3.691605471192176],
            [2.327892013757687, -3.8069859289124355],
            [2.328579656129615, -3.8794681168747576],
            [2.3296907282686834, -3.967058800023382],
            [2.300936751020799, -3.96711386792862],
            [2.3008503981379604, -3.981684416629559],
            [2.2722508264198416, -3.9820691939831696],
            [2.2723934510918586, -3.996486899896273],
            [2.2433311399128124, -3.99672276792182],
            [2.2433758528061096, -4.00404622141757],
            [2.2001413916072425, -4.003731160858398],
            [2.2003753476804517, -4.025613923141109],
            [2.1931744309717263, -4.025722263224674],
            [2.1935719509793317, -4.051037795334382],
            [2.1520284786265793, -4.05154004127384],
            [2.1519418858352375, -4.03737457348677],
            [2.137519371960715, -4.036649440418884],
            [2.0884477622056385, -4.035638918013695],
            [2.065969684435257, -4.035699324680048],
            [2.06581641617491, -4.026336656684412],
            [1.9512895113138018, -4.026490598320863],
            [1.8354877761257828, -4.026112984043389],
            [1.8356641664067528, -3.9969131488300746],
            [1.7276889039858665, -3.9965004540240874],
            [1.7233279364914402, -3.996397455723483],
            [1.724788567770862, -3.8691352865377264],
            [1.7251662945880435, -3.8337647126814556],
            [1.7249202919865427, -3.828422019604886],
            [1.7254044561340345, -3.789955471748375]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.06323463923331,
          "lat": 34.860719067487196
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05127"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00069179"
      },
      "bbox": [
        1.7233279364914402, -4.05154004127384, 2.3296907282686834,
        -3.618851427869681
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.904666937928355, -2.3933853811295234],
            [3.954440528741402, -2.391871296237166],
            [4.004866445095124, -2.392006445408539],
            [4.003614262180101, -2.3611355625255497],
            [4.00089269994507, -2.3038998578907157],
            [4.060333273937133, -2.3019942450834483],
            [4.089889291699737, -2.301587186430197],
            [4.088139154197837, -2.257733074832439],
            [4.087004171515114, -2.213983665500217],
            [4.085522009106681, -2.138168349800434],
            [4.119863541954231, -2.1369640657237703],
            [4.120056120784438, -2.1469809054086526],
            [4.127261493495671, -2.1467616302459147],
            [4.127399135048283, -2.153958165518325],
            [4.141715933379325, -2.1535585230781358],
            [4.1419749970029764, -2.160879428370967],
            [4.156900262056933, -2.1603666029155786],
            [4.157220583637747, -2.167671351535991],
            [4.160802007792823, -2.1673328627655604],
            [4.161350456758552, -2.182163839485241],
            [4.1648212881856725, -2.1819639163874633],
            [4.16544608005238, -2.196874754507793],
            [4.169011595891359, -2.1967205428256342],
            [4.1696039506707425, -2.211509515168146],
            [4.201742738904965, -2.210421741568334],
            [4.20218744599081, -2.2413333569023095],
            [4.216985966629633, -2.2412298224258707],
            [4.216999144966354, -2.255803420249852],
            [4.2310055966165585, -2.2552719528577616],
            [4.232314374146604, -2.2993507000355655],
            [4.246252299649722, -2.2986424962843595],
            [4.249580137518105, -2.372200946152541],
            [4.249981571484666, -2.386734989460209],
            [4.192641703942566, -2.3884140406833705],
            [4.192488421274195, -2.402355858141721],
            [4.17837074007732, -2.4028943712587525],
            [4.180215080854351, -2.4765087622857362],
            [4.183089826223054, -2.4767134320058535],
            [4.1835436392033465, -2.4927016155924946],
            [4.184544976945327, -2.5090907415761183],
            [4.185927438293107, -2.566073229863177],
            [4.185612696772204, -2.581627717891865],
            [4.1875722636589465, -2.679850717449135],
            [4.1890865957159065, -2.7459058252194004],
            [4.130911623514398, -2.7476090753455775],
            [4.102994708533656, -2.7481546020544325],
            [4.102100942061662, -2.703487574720233],
            [4.087621299370293, -2.704664598557648],
            [4.025317986391655, -2.70570085002828],
            [3.9256365408919875, -2.708433758285033],
            [3.925627238181956, -2.707435125446109],
            [3.903650667411381, -2.7077192740937117],
            [3.9028343492472994, -2.673189383304141],
            [3.901720409956153, -2.6480772430547113],
            [3.923616343462843, -2.6474927648371898],
            [3.923268918445949, -2.636350391433965],
            [3.9159004043090953, -2.636503010775417],
            [3.9156146513662775, -2.629168636969439],
            [3.919345654556581, -2.6289550530560075],
            [3.919212551499521, -2.62521573592463],
            [3.9229396442359814, -2.625149496059237],
            [3.919623253612209, -2.532563322011419],
            [3.918198624308481, -2.4977135581788605],
            [3.9178999363353957, -2.482041392355073],
            [3.921871613016145, -2.481838599023953],
            [3.9204952332314233, -2.4376837901175534],
            [3.906146279293103, -2.4378104299632266],
            [3.904666937928355, -2.3933853811295234]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.47978333327802, "lat": 36.16118920598937 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05135"],
        "coty_name": ["Sharp"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sharp County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00069183"
      },
      "bbox": [
        3.901720409956153, -2.7481546020544325, 4.249981571484666,
        -2.1369640657237703
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0299324276825157, -2.9633492163107626],
            [3.088647714238535, -2.962631245661645],
            [3.158943135432157, -2.962338538754974],
            [3.1734521317834665, -2.9624715135171367],
            [3.17312339243686, -2.937639226173656],
            [3.1721414099005583, -2.889464792646137],
            [3.197547005473903, -2.8891786862793314],
            [3.2459887007008654, -2.8876286463724448],
            [3.2583051435635726, -2.887742147669466],
            [3.3002741831832005, -2.8864605934926444],
            [3.343314368511572, -2.885418205119605],
            [3.3448191462125343, -2.9585842035371472],
            [3.37347116189428, -2.9581051338273414],
            [3.4252423804339873, -2.9579181157666112],
            [3.4877731979925164, -2.9570053930885276],
            [3.4892827631893297, -3.037473280937005],
            [3.4903941146092405, -3.0741051217075483],
            [3.4907458008622525, -3.1001988435613734],
            [3.4915310328620666, -3.1325658633375344],
            [3.4885250119630875, -3.132640095533077],
            [3.490745826163129, -3.2350082225401753],
            [3.491948900238958, -3.308188914450585],
            [3.4492562997314504, -3.308729417799734],
            [3.382801427964392, -3.3093254490629485],
            [3.3501325273271263, -3.309504382623103],
            [3.307098188896947, -3.310441442621051],
            [3.3069224730586946, -3.291166305582138],
            [3.3061874879239346, -3.2662164038825194],
            [3.3058314901393597, -3.2366963395538204],
            [3.30529330474066, -3.222674841142726],
            [3.277245456950258, -3.223192325203998],
            [3.206107211376107, -3.2235638812155942],
            [3.1676271978543804, -3.22395047329427],
            [3.158204306129418, -3.2243068200954594],
            [3.091150093581211, -3.224823701150191],
            [3.005471569804097, -3.225723273535144],
            [3.005126434314256, -3.1963796353114335],
            [3.0039290937606626, -3.138571712795897],
            [3.0328120920571062, -3.1381713498661954],
            [3.032211293377513, -3.0951015363588086],
            [3.0305527553079443, -3.026938917498916],
            [3.030549719652013, -3.006907475575861],
            [3.0299324276825157, -2.9633492163107626]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.515752247853, "lat": 35.580621434345 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05141"],
        "coty_name": ["Van Buren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Van Buren County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00069904"
      },
      "bbox": [
        3.0039290937606626, -3.310441442621051, 3.491948900238958,
        -2.885418205119605
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.94295070390469, 2.344217162129159],
            [-17.844102779499003, 2.3950042950454593],
            [-17.839328018527926, 2.3965558746518325],
            [-17.8361491403542, 2.3957493464247954],
            [-17.829952366047984, 2.39725540566666],
            [-17.829081474504168, 2.4003878357965727],
            [-17.824520577486272, 2.4034556560746045],
            [-17.82054715939923, 2.409081004188518],
            [-17.823057281551442, 2.4111067111582227],
            [-17.82019880928148, 2.417110358608125],
            [-17.814633718314628, 2.420022269467165],
            [-17.80967936779719, 2.42589347989318],
            [-17.80391752421286, 2.4298250781860458],
            [-17.800574910779673, 2.43066199575995],
            [-17.801022028285427, 2.4349297954669296],
            [-17.798948652431122, 2.439611396218874],
            [-17.787221750331348, 2.441173028515818],
            [-17.78429602388576, 2.452695552445995],
            [-17.780835042133294, 2.4606955019044925],
            [-17.775650201628732, 2.4622224779829756],
            [-17.76905396810152, 2.460463072995764],
            [-17.758518555123974, 2.4655009147849207],
            [-17.75572430731097, 2.468465927944256],
            [-17.754512050271757, 2.473643505843688],
            [-17.761269246500312, 2.4809962436476947],
            [-17.75632374569867, 2.4818231272179565],
            [-17.752346729354713, 2.487085193553811],
            [-17.754255413063706, 2.495057402877675],
            [-17.749494387436926, 2.4992653707437906],
            [-17.750752618971887, 2.5048982549083925],
            [-17.74991288351657, 2.5105752496864993],
            [-17.750402539202906, 2.518787467117299],
            [-17.753517438552606, 2.519795873772274],
            [-17.75659123980187, 2.5235880715170724],
            [-17.76129111969974, 2.532408388872961],
            [-17.75922910012587, 2.537072781130675],
            [-17.687426192609145, 2.4287224273939554],
            [-17.63676044013676, 2.3525303812196405],
            [-17.575771650064844, 2.2611351524532313],
            [-17.572932536759332, 2.2535896676643343],
            [-17.575449451611963, 2.250058258156451],
            [-17.580520945837623, 2.247021674213398],
            [-17.581232275979048, 2.243471377093291],
            [-17.586298041863827, 2.239771561518887],
            [-17.587983698252135, 2.231921444792508],
            [-17.592609747057107, 2.22862252868228],
            [-17.596840840300917, 2.2217356460980864],
            [-17.605172671719856, 2.2193480322940102],
            [-17.608189193744032, 2.221066145771366],
            [-17.61077968020775, 2.2102151029398485],
            [-17.616342701860752, 2.200023860452269],
            [-17.61650503470541, 2.1933246879779893],
            [-17.62057096793831, 2.187794235628107],
            [-17.620828025378273, 2.1816769559067435],
            [-17.623335896936343, 2.1806149787012816],
            [-17.623831273672433, 2.1755772145840817],
            [-17.627001059194313, 2.1712842195664175],
            [-17.628202084108416, 2.160247932996101],
            [-17.62405856790166, 2.1560254353908888],
            [-17.62273625183511, 2.14968991372168],
            [-17.616286986893034, 2.146629451037599],
            [-17.613826633724603, 2.140075741030398],
            [-17.616292239689233, 2.1346626597959864],
            [-17.613728375625918, 2.1306644366207066],
            [-17.61331045374209, 2.125279846063973],
            [-17.615432637483835, 2.12073215152926],
            [-17.613374980289816, 2.1183633440884466],
            [-17.614894255808913, 2.10325319922998],
            [-17.61203498332594, 2.099076440134375],
            [-17.610020421756087, 2.090366903354353],
            [-17.606459754246217, 2.0865356071561574],
            [-17.60704365114444, 2.0745750834139876],
            [-17.603920317137295, 2.072912694527674],
            [-17.604135166259585, 2.065219369742064],
            [-17.602579833224485, 2.063290654343192],
            [-17.607588511244934, 2.0529717410693213],
            [-17.60657527539017, 2.0487713542243546],
            [-17.599250558593212, 2.0444711576284123],
            [-17.599040417159074, 2.0381496534977916],
            [-17.601018245850625, 2.035218704302166],
            [-17.60114542689634, 2.02548388958887],
            [-17.606228644483817, 2.0193489905890543],
            [-17.61380255792821, 2.0178506839648738],
            [-17.618576854826863, 2.008851398303955],
            [-17.618265556940948, 2.0057277992093243],
            [-17.619868043352625, 1.9956743309827019],
            [-17.62472189820751, 1.991861509796157],
            [-17.627856192936928, 1.9874347800627619],
            [-17.63296235572791, 1.985946151321801],
            [-17.632723060194298, 1.9722106595160305],
            [-17.63054781827056, 1.970662024480031],
            [-17.633156406889157, 1.960798200337636],
            [-17.63872473476377, 1.9563573858480012],
            [-17.64764982831574, 1.9548767295909613],
            [-17.65488780315342, 1.951947395588735],
            [-17.6589761994745, 1.954990136499297],
            [-17.663991283371256, 1.9630041112416052],
            [-17.666943038615504, 1.9606599602762147],
            [-17.673320737577136, 1.958724145564495],
            [-17.676570673506696, 1.9594908833418625],
            [-17.68254956318913, 1.9557574739378718],
            [-17.68201172344222, 1.9486918897913497],
            [-17.68283873931233, 1.9442360165885142],
            [-17.680497514851773, 1.9407446791179737],
            [-17.681167851991777, 1.9378389688799122],
            [-17.6793402356838, 1.9331587821396168],
            [-17.678298112329824, 1.926133160731757],
            [-17.6838210899185, 1.9266327073879275],
            [-17.696017733113546, 1.9224407872284648],
            [-17.699577340178877, 1.9194226371927061],
            [-17.698182983268804, 1.9137615805082575],
            [-17.70239756329004, 1.9090717850274825],
            [-17.70458677383944, 1.899775893367758],
            [-17.708231805123198, 1.8950155442999177],
            [-17.712076082467856, 1.8934911496177036],
            [-17.729576065684636, 1.9202290135576714],
            [-17.74831746393904, 1.9426234697778464],
            [-17.74008732805239, 1.95477982014658],
            [-17.73903873314324, 1.9610061432304289],
            [-17.737160238223616, 1.9823370561813771],
            [-17.736168349415692, 1.9854347911155763],
            [-17.738847745386007, 1.99239741565784],
            [-17.744723022300185, 1.9971507998320808],
            [-17.775661192025073, 2.0032729762232733],
            [-17.783993629184966, 2.0001986002204855],
            [-17.791019019142972, 1.9966766919949632],
            [-17.79777568659895, 1.9994967079396238],
            [-17.80194110579806, 1.9976035076525342],
            [-17.815715972666723, 1.9974986958073346],
            [-17.8289974643479, 1.9864372950772444],
            [-17.84746671826489, 1.985845788900164],
            [-17.863062275880104, 1.9794932457323613],
            [-17.875334170219862, 1.9775524890437608],
            [-17.88706663527935, 1.9719190600420125],
            [-17.889542382094326, 1.9693065655328463],
            [-17.97095117391676, 2.0696249713225585],
            [-17.97169128433585, 2.071036429591145],
            [-17.99137643161899, 2.0990848134088713],
            [-17.994010492521713, 2.0975517560359083],
            [-18.00105678585867, 2.096273540419921],
            [-18.003211760312702, 2.0943739792823526],
            [-18.007776183354274, 2.094493366880153],
            [-17.991827356651097, 2.1558146065981427],
            [-17.949296742292184, 2.3198431784249305],
            [-17.94295070390469, 2.344217162129159]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.82069317587553,
          "lat": 38.597220251475086
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06003"],
        "coty_name": ["Alpine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alpine County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01675840"
      },
      "bbox": [
        -18.007776183354274, 1.8934911496177036, -17.572932536759332,
        2.537072781130675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.655020532223205, 0.8121435147286554],
            [-7.421887857358776, 0.7849643088286405],
            [-7.35938154931112, 0.7778522858458077],
            [-7.355212648876538, 0.772087272959463],
            [-7.356360264256298, 0.7652889563110495],
            [-7.354769380508111, 0.7595647957996122],
            [-7.3587178914429225, 0.7545521748483738],
            [-7.363095089329391, 0.7510540861182368],
            [-7.361968202313587, 0.7428015867676699],
            [-7.36396584295455, 0.7382137827227135],
            [-7.3599838728716, 0.7368166232528292],
            [-7.359446271813014, 0.7336984163136256],
            [-7.354974814904237, 0.731372639347594],
            [-7.354482059834313, 0.7223690720155154],
            [-7.349993074457003, 0.7144693930018738],
            [-7.349775127373766, 0.7112729186768575],
            [-7.342663765129353, 0.7138490738800077],
            [-7.330773944955838, 0.7157126770323827],
            [-7.328931111744944, 0.7130063253111375],
            [-7.321197763449907, 0.7122707825770065],
            [-7.317493792337176, 0.710349496448531],
            [-7.309904242087612, 0.7035142554031045],
            [-7.3045759397483625, 0.7007673257460106],
            [-7.305013774939646, 0.696442108242415],
            [-7.301912073289614, 0.6885042795452698],
            [-7.3028039366247, 0.6844214113406243],
            [-7.30604713907817, 0.6781039890868223],
            [-7.309390851311942, 0.6751357886048652],
            [-7.3111098214122885, 0.6703838230358213],
            [-7.31027098003385, 0.665807453056536],
            [-7.311722189157999, 0.6599881677627591],
            [-7.310627151979552, 0.6548706617889459],
            [-7.3065872052506435, 0.6547084584958631],
            [-7.295425483837682, 0.6496385640997601],
            [-7.291028165354129, 0.6521317845380105],
            [-7.286351261015428, 0.647364444619415],
            [-7.282830584203178, 0.6464852021509587],
            [-7.280444945278954, 0.6435439414397586],
            [-7.276966721670609, 0.6429558342044728],
            [-7.271992287564447, 0.6477646010603444],
            [-7.2700413669979955, 0.6522804686474226],
            [-7.264849098272431, 0.6534013038169624],
            [-7.26051555679384, 0.6510083642474539],
            [-7.253756118939053, 0.649376856540473],
            [-7.246863370252039, 0.6508822046169772],
            [-7.241908044711979, 0.6420113004787419],
            [-7.237883203832936, 0.6396403185258848],
            [-7.2363602557834845, 0.6363858394186369],
            [-7.224022149850483, 0.6200499422449628],
            [-7.217279799897676, 0.6226360936563335],
            [-7.210611624804209, 0.6182805257853237],
            [-7.210824999624181, 0.6143579079203016],
            [-7.205535161835204, 0.6117541700840183],
            [-7.204376802400001, 0.6079094937945889],
            [-7.205753300786954, 0.6037712417900171],
            [-7.210329073219837, 0.6001516024774484],
            [-7.214653602067882, 0.5984275300811435],
            [-7.215062016703772, 0.5927650273117597],
            [-7.212004996883123, 0.5858897137166669],
            [-7.20447803356509, 0.588669840219311],
            [-7.197572188162387, 0.5856227494438506],
            [-7.192647299650282, 0.5845092590302833],
            [-7.186326983471135, 0.5863713069861868],
            [-7.180768144455717, 0.5783031024725706],
            [-7.179745266999921, 0.574632559070737],
            [-7.17648775796749, 0.5738098354790325],
            [-7.178539897040327, 0.5660091482252324],
            [-7.180828566866215, 0.56643997905177],
            [-7.182601002377263, 0.5610667333918343],
            [-7.188062405443901, 0.5571140421787009],
            [-7.190982558407098, 0.553571973771829],
            [-7.188891753675788, 0.5464938175360646],
            [-7.191557777812101, 0.5410316875521055],
            [-7.187781240551035, 0.5367582764060379],
            [-7.175079101299917, 0.5160914521670239],
            [-7.172750067072658, 0.5143633949954587],
            [-7.170796360409812, 0.5084921532972756],
            [-7.168019123970558, 0.504629153103165],
            [-7.171206472666215, 0.502845983979369],
            [-7.175006657073597, 0.4906371175435632],
            [-7.181028442765238, 0.4881216353354868],
            [-7.184833067493277, 0.48172552051100187],
            [-7.188347472976152, 0.4807975034984004],
            [-7.188857615729026, 0.4739038638854659],
            [-7.190689519495617, 0.47227059334808863],
            [-7.1968117035247685, 0.47214030757510544],
            [-7.199647058004871, 0.46890899352836796],
            [-7.197343529047714, 0.463093556623303],
            [-7.197980411999246, 0.4536811480482028],
            [-7.201838030985876, 0.4450534717082085],
            [-7.2066512670298755, 0.4424126891313615],
            [-7.203618495088176, 0.4348280334017198],
            [-7.20674189528662, 0.4279507826180958],
            [-7.2051665852579605, 0.4234288938432582],
            [-7.208625806165414, 0.42079210536058226],
            [-7.20793079579994, 0.4172012288643822],
            [-7.213521999612669, 0.4146728296710979],
            [-7.221075568820812, 0.4077509951041978],
            [-7.224553403438877, 0.40093276447283976],
            [-7.227526305527593, 0.3994252573300197],
            [-7.2284902018804145, 0.39583614201637063],
            [-7.2231450719552255, 0.3928815856657169],
            [-7.217446251918143, 0.3912324779325756],
            [-7.21005200233715, 0.39052357465677573],
            [-7.209824008179753, 0.3850415472717575],
            [-7.196457638599301, 0.3786187720421136],
            [-7.193972087651826, 0.37345869996586295],
            [-7.196275864391673, 0.3711487903376738],
            [-7.19732249262464, 0.3649608683211826],
            [-7.193501506353462, 0.36247821507815803],
            [-7.194490791836449, 0.3579929173947671],
            [-7.191616813297485, 0.35745940073465515],
            [-7.188988977232915, 0.35132832790534096],
            [-7.18514148015432, 0.3490302346547956],
            [-7.19004017545243, 0.3430991304906333],
            [-7.188431083922233, 0.3389824179160807],
            [-7.194848535439359, 0.3310865501573736],
            [-7.193590013736301, 0.3276988340414715],
            [-7.1821373619992945, 0.3183025160576519],
            [-7.177858997619665, 0.3196320591590303],
            [-7.172562474591943, 0.3166484221575629],
            [-7.172089517571151, 0.3107310350223175],
            [-7.167895304296978, 0.30193094885623134],
            [-7.167720640682792, 0.2950792642018851],
            [-7.170292753053277, 0.2895425267379486],
            [-7.178208159585275, 0.282485464094198],
            [-7.179552388065498, 0.2794369798764862],
            [-7.179773553914546, 0.2727584579252183],
            [-7.1817125417997705, 0.2688319806957973],
            [-7.176715936763914, 0.26474975960552233],
            [-7.176146604993453, 0.2603440892111956],
            [-7.177530736940111, 0.2562357161802883],
            [-7.181548266597389, 0.2563922484387415],
            [-7.183808874531306, 0.25424253986268475],
            [-7.18485651104693, 0.2464654978982802],
            [-7.192720149155415, 0.24487010078230487],
            [-7.193250555953767, 0.23933652431229502],
            [-7.195225253556224, 0.23312248421458057],
            [-7.194828137083502, 0.224757757339284],
            [-7.199255887326107, 0.2190906823398546],
            [-7.20016796444887, 0.21349344244436108],
            [-7.197860950333955, 0.20795335596943276],
            [-7.201317886736886, 0.20219082805588037],
            [-7.224146344143943, 0.2023889398245226],
            [-7.286227879331764, 0.15114987193274804],
            [-7.291346230171044, 0.15385095297050097],
            [-7.29203818949168, 0.15976789531941027],
            [-7.300845737558904, 0.15977631923630123],
            [-7.310098805834805, 0.16495392788949606],
            [-7.317283541575945, 0.16221300761156363],
            [-7.322003338134452, 0.16548032727550654],
            [-7.3255416232196975, 0.1591389585646321],
            [-7.3228561581329386, 0.1531274308726322],
            [-7.333176591642116, 0.1394887904722647],
            [-7.338940924897836, 0.1336110097560798],
            [-7.348505805907465, 0.13309808607648627],
            [-7.4709620567479265, 0.1467439381046161],
            [-7.471785777676078, 0.15747341706212584],
            [-7.468120517974119, 0.1628264733589066],
            [-7.479932691121639, 0.1676098728642649],
            [-7.4836537707362085, 0.16738354392587704],
            [-7.4876493055526865, 0.17496851681539355],
            [-7.48726456948667, 0.18144761554095132],
            [-7.493490564493769, 0.18125094004318462],
            [-7.4990760830952885, 0.18960462396561925],
            [-7.4990553865549865, 0.20134820987617744],
            [-7.505966612496851, 0.20432422193622918],
            [-7.509278046185392, 0.2073610372829427],
            [-7.511932308519834, 0.21741127393055518],
            [-7.512806884791107, 0.22430082325257716],
            [-7.518098536678542, 0.22538829518120498],
            [-7.519199479814313, 0.2280842454569589],
            [-7.524695855000288, 0.22857899523475603],
            [-7.527242493259488, 0.2250396009017764],
            [-7.531794626079071, 0.2284009308039276],
            [-7.533254121679498, 0.23254212976852556],
            [-7.536131859485999, 0.2352029088655304],
            [-7.539147277226035, 0.24530321618213596],
            [-7.535209944482791, 0.24991219748617977],
            [-7.533910925915129, 0.25391158048787316],
            [-7.536610511155724, 0.261544526646086],
            [-7.541535489846562, 0.2667789499717782],
            [-7.540525923981149, 0.2725966340502995],
            [-7.541473576010628, 0.2759010114063683],
            [-7.539212230563208, 0.2833756292952056],
            [-7.532930583941978, 0.2917200890301776],
            [-7.532419968850381, 0.2980026615961175],
            [-7.5303100423783755, 0.3012866236062194],
            [-7.534824106050304, 0.31025254105831424],
            [-7.53566782639716, 0.3149787384276199],
            [-7.53381428529246, 0.3168309428953992],
            [-7.540098595604241, 0.33010378965579357],
            [-7.5382369801633695, 0.3334684625233891],
            [-7.541662340507144, 0.3404418395098559],
            [-7.5403774379818165, 0.34470454239795767],
            [-7.540988400578879, 0.35053593174128744],
            [-7.5483476198640345, 0.3567511067594204],
            [-7.551214377129505, 0.35594190182235863],
            [-7.55546063599691, 0.36136159517760763],
            [-7.55450022517835, 0.3687395601727796],
            [-7.550282993556979, 0.3730461399057161],
            [-7.557382213095818, 0.3778647290836421],
            [-7.5660063335214165, 0.3774587342158973],
            [-7.56574319814279, 0.38360692708308913],
            [-7.570320064417446, 0.38603594592639884],
            [-7.577758829185409, 0.38405051241467203],
            [-7.581074281950841, 0.38631502757583924],
            [-7.586759166338821, 0.3937258704159852],
            [-7.585476722588696, 0.39780231375614594],
            [-7.586736454959661, 0.4084051958766136],
            [-7.58922142097106, 0.41195921830864046],
            [-7.590278309542054, 0.41764759676080393],
            [-7.589467084090183, 0.42351601278365053],
            [-7.590762276706318, 0.4280980303635185],
            [-7.594971258198988, 0.43071389809407135],
            [-7.598179409153508, 0.4375460204221146],
            [-7.5984740145112255, 0.44060372758870475],
            [-7.595014156736227, 0.4469110895939577],
            [-7.590835021113141, 0.45082105937135014],
            [-7.581800253962845, 0.44929361941676543],
            [-7.576721844867528, 0.45035845386084106],
            [-7.574497330301364, 0.4560650986455239],
            [-7.574168187992182, 0.4607838266681209],
            [-7.568999010260351, 0.46511908836861665],
            [-7.567585037719323, 0.47317209522505077],
            [-7.569559794506826, 0.4785181457156504],
            [-7.567638131268877, 0.48158053089870534],
            [-7.567150874565816, 0.4887613294991615],
            [-7.568079590437458, 0.4912800974132072],
            [-7.563738429484219, 0.4964562111555762],
            [-7.564496850032196, 0.5039954599084892],
            [-7.5659481763755645, 0.5057448722787083],
            [-7.562350063231115, 0.5118915283295361],
            [-7.560324657583541, 0.5184255977653034],
            [-7.561508384722747, 0.5272203143275324],
            [-7.558293931827655, 0.5302065061331475],
            [-7.558705280896499, 0.5386084066607693],
            [-7.56108168647123, 0.5404473589408534],
            [-7.563926635887826, 0.5485656331326689],
            [-7.561900851866929, 0.5516275927017461],
            [-7.557271675898311, 0.5548490377945485],
            [-7.557259721316217, 0.5635506725057129],
            [-7.549540261477318, 0.5682720128422676],
            [-7.542970261520791, 0.5612525567275531],
            [-7.538210125653237, 0.5603500251628571],
            [-7.532097079100169, 0.5617533736847955],
            [-7.530997239803512, 0.5680652300248495],
            [-7.527453693716589, 0.5717364317795564],
            [-7.52029850576743, 0.5745956175088556],
            [-7.5150452919560875, 0.5818411101072706],
            [-7.5145807897177646, 0.5885566995068378],
            [-7.508266711114584, 0.5901377448803429],
            [-7.502429750676412, 0.5893806006109007],
            [-7.501094629209574, 0.5993008051402109],
            [-7.492612837269591, 0.6050885218791316],
            [-7.487918465771635, 0.6143118427489768],
            [-7.482782507087342, 0.6147548472272446],
            [-7.481613493984349, 0.6197267460894005],
            [-7.476909438982358, 0.6245772270832646],
            [-7.47620775403431, 0.6278126228302363],
            [-7.478389478907301, 0.63522981685672],
            [-7.478562009649353, 0.6434496382000493],
            [-7.485296408907404, 0.6448568005121169],
            [-7.48802794589464, 0.6421630262119832],
            [-7.493658736699429, 0.641099279016684],
            [-7.50207823829803, 0.6479897153112874],
            [-7.505569909603879, 0.6477563030425172],
            [-7.51071482355926, 0.6428127120921463],
            [-7.515313373061004, 0.6430026035471819],
            [-7.5171222846813945, 0.6461777389103267],
            [-7.516259414232604, 0.6594238390541975],
            [-7.518605004061841, 0.6619123797696028],
            [-7.52845545372405, 0.6568015643666114],
            [-7.530411662856628, 0.6503880064822046],
            [-7.536846388668978, 0.6494371615818447],
            [-7.540585464256929, 0.654058159850086],
            [-7.5439243833777585, 0.6553424822722275],
            [-7.547244567675501, 0.6610229047056292],
            [-7.547413377038412, 0.6668634861418642],
            [-7.550014690801903, 0.6686103888816847],
            [-7.556820908079837, 0.6661513433695725],
            [-7.563222297312903, 0.6566965914640259],
            [-7.566959085711623, 0.6577871839594023],
            [-7.576201119945019, 0.6559438128510124],
            [-7.579564169595665, 0.6535960895158393],
            [-7.585064903484813, 0.6544843210959185],
            [-7.589943747655049, 0.6606847206664068],
            [-7.596302521447944, 0.6641472896525505],
            [-7.602367550645825, 0.6726131717673165],
            [-7.602587122562769, 0.6760596817716387],
            [-7.606411386894446, 0.6803283530459666],
            [-7.612247440814646, 0.6844080667095984],
            [-7.612127739985646, 0.6920650493801778],
            [-7.619633792004626, 0.6972298192933721],
            [-7.622210762662549, 0.7029049841259462],
            [-7.627259769553269, 0.7049310626262172],
            [-7.628159898524654, 0.7095738805167019],
            [-7.624267719225786, 0.7135313985439964],
            [-7.6220900918149495, 0.7178208190869106],
            [-7.6237800925384, 0.7204740353398529],
            [-7.625739996965072, 0.7304782004574993],
            [-7.63129576485353, 0.7339040255928775],
            [-7.638641599908691, 0.7424290165166753],
            [-7.642520820227531, 0.7452972686782557],
            [-7.6437270197341505, 0.7507962936749101],
            [-7.64829539619373, 0.7507724967830651],
            [-7.653154695767242, 0.7468044577917009],
            [-7.659836671647644, 0.7465642373746231],
            [-7.661969886386804, 0.7443878991102503],
            [-7.669093242965883, 0.7474699054692079],
            [-7.675913445100584, 0.7467935251113033],
            [-7.677993143395466, 0.7538499794722916],
            [-7.67365737350267, 0.7596538402518289],
            [-7.672146663169847, 0.7763724103810753],
            [-7.66921544550445, 0.7802235919736219],
            [-7.67070301438238, 0.7855058801606107],
            [-7.674202166353214, 0.7897873030651696],
            [-7.671217180529176, 0.8006609487448082],
            [-7.664939555606728, 0.8007314796743528],
            [-7.6581640882999755, 0.8031584610602748],
            [-7.6552301235321005, 0.8073946382450898],
            [-7.655020532223205, 0.8121435147286554]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.19415634396991,
          "lat": 38.74707792183361
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08015"],
        "coty_name": ["Chaffee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chaffee County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00198123"
      },
      "bbox": [
        -7.677993143395466, 0.13309808607648627, -7.167720640682792,
        0.8121435147286554
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-6.4336655435740076, 1.2676150704366727],
              [-6.433891137334859, 1.2656314753599258],
              [-6.437950461975965, 1.2719486326348854],
              [-6.437248576403162, 1.2753129952833142],
              [-6.432916343508805, 1.2749091858463937],
              [-6.4336655435740076, 1.2676150704366727]
            ]
          ],
          [
            [
              [-6.683902231556159, 1.4080958144203766],
              [-6.674446052937375, 1.5033779108802667],
              [-6.6727980881289115, 1.5161481812221076],
              [-6.672509261954186, 1.5229021301164982],
              [-6.670010689191407, 1.545769544586448],
              [-6.667203154021633, 1.5755998322472382],
              [-6.623018314312115, 1.57214427489895],
              [-6.598264120295678, 1.5699118763715212],
              [-6.57999748352466, 1.56781736433816],
              [-6.566551889370307, 1.5670075461974966],
              [-6.526857601108986, 1.5631889888848964],
              [-6.477469819857731, 1.5580540385456456],
              [-6.491828670581846, 1.5560093091972034],
              [-6.493625146837065, 1.536403451894132],
              [-6.48007947367705, 1.5333809482742615],
              [-6.470553871953052, 1.532457216119901],
              [-6.467222153211704, 1.5355872824879349],
              [-6.464846685517289, 1.5427450600267307],
              [-6.4789990651600196, 1.544219939433321],
              [-6.477453079995116, 1.5580534366062198],
              [-6.44829453142544, 1.555495817293883],
              [-6.447272717283692, 1.5529571589862907],
              [-6.442797121588532, 1.549394618991131],
              [-6.443009888533218, 1.5428962935926585],
              [-6.440662897862655, 1.5402203915678556],
              [-6.436156632066451, 1.538891136217544],
              [-6.431228342233287, 1.5393652474369144],
              [-6.42173833871758, 1.5384513165448452],
              [-6.42111300878043, 1.5456742048615362],
              [-6.414012889667291, 1.5450021378594132],
              [-6.411713402079554, 1.5502832992055848],
              [-6.406133876717262, 1.5515450146792726],
              [-6.412062982711976, 1.4930810981759406],
              [-6.418223801898571, 1.4278762247424706],
              [-6.426679134920852, 1.4287015511931578],
              [-6.426050952219077, 1.4213102721279176],
              [-6.4188735350264485, 1.4205736976413128],
              [-6.4286464570764705, 1.3186183268652105],
              [-6.432121525608587, 1.3189310802611869],
              [-6.436481801828455, 1.3119844856555376],
              [-6.429365602573146, 1.3113338049202994],
              [-6.4300655842487116, 1.3040494293058646],
              [-6.44429058105597, 1.3053872873096808],
              [-6.451165729545893, 1.308448188387081],
              [-6.4520232328099745, 1.3003425592870417],
              [-6.448660594411, 1.2972387970576036],
              [-6.44502765168497, 1.297538736391783],
              [-6.442252351936764, 1.2905522317001168],
              [-6.444425333763892, 1.2873844666682808],
              [-6.4393576067137, 1.2865296810196296],
              [-6.439726598383352, 1.2828811202342942],
              [-6.446445979829965, 1.2833445451191603],
              [-6.450737539858564, 1.2765782072244882],
              [-6.461596963860086, 1.2776028087010194],
              [-6.461949756642723, 1.273950637889368],
              [-6.476207734069796, 1.2753085466074239],
              [-6.477016495354034, 1.2672892356455436],
              [-6.475454491218555, 1.2642325997014874],
              [-6.463115305616689, 1.2630276479911429],
              [-6.454234673614845, 1.2675117221130106],
              [-6.451612277847171, 1.2619525380715662],
              [-6.444357322552671, 1.2577404647363328],
              [-6.443817946682155, 1.2554860043653102],
              [-6.468063429834241, 1.2575860655895459],
              [-6.468417153389, 1.2537189943573237],
              [-6.438970140965597, 1.250792153202027],
              [-6.437386759370066, 1.2559426951452834],
              [-6.43476754182399, 1.2569342792193425],
              [-6.4405007558588965, 1.2019523720055099],
              [-6.436395434798682, 1.2015603032018194],
              [-6.438663572607412, 1.1989068720729437],
              [-6.44322987651631, 1.198378995191031],
              [-6.45157479336989, 1.1872069676769659],
              [-6.4577830504973655, 1.181484042810221],
              [-6.461274503721408, 1.1741518360640175],
              [-6.4607665900340905, 1.1689508870890652],
              [-6.464367250716433, 1.1607105853431132],
              [-6.463276005789052, 1.1548666555907359],
              [-6.464201782050505, 1.148867153234166],
              [-6.469439209969749, 1.144396041161119],
              [-6.4716615670488356, 1.132785325483158],
              [-6.476196132525634, 1.1274988606252845],
              [-6.482167653587529, 1.124131951102976],
              [-6.49146146290712, 1.1231582157392634],
              [-6.496581453345918, 1.1255151977552564],
              [-6.499527841203615, 1.1218059018092392],
              [-6.5055389977684674, 1.11826204276802],
              [-6.507389060496126, 1.1146805891863059],
              [-6.511198242593914, 1.1121123095125742],
              [-6.50967437986181, 1.1090483172990266],
              [-6.510490034032118, 1.10316186268822],
              [-6.504499314704703, 1.0954466027260565],
              [-6.5044529390369705, 1.0881883357384172],
              [-6.507423748220903, 1.080723685277966],
              [-6.5059565343389885, 1.0746263935722877],
              [-6.509976078122733, 1.0724217652153785],
              [-6.518267919024473, 1.064412459353417],
              [-6.5240962823263295, 1.0606591425587408],
              [-6.5327036898220445, 1.0564080799224849],
              [-6.535669699909193, 1.057223011839866],
              [-6.541364499332711, 1.0518791564894079],
              [-6.545035266731699, 1.0505550868934455],
              [-6.542614259508443, 1.0431201703139654],
              [-6.543344970288, 1.039129637384802],
              [-6.54227898068975, 1.0343923584411843],
              [-6.548383833906078, 1.0294737444846753],
              [-6.549178783532095, 1.021414923693974],
              [-6.545220486545139, 1.015432258376727],
              [-6.547057962944821, 1.012464416286427],
              [-6.545612800381588, 1.0060982596506798],
              [-6.547082248923427, 1.0022439758191528],
              [-6.55004492082, 1.0007083718761167],
              [-6.550667774974971, 0.9969455925446986],
              [-6.555115724035577, 0.9934507184793181],
              [-6.557142748288677, 0.9847301562190024],
              [-6.561644288091843, 0.9797956431004532],
              [-6.560757864238938, 0.975535693436408],
              [-6.563947887360193, 0.9727173616311243],
              [-6.566940153427768, 0.9619475289359305],
              [-6.57397539848051, 0.9536651227730418],
              [-6.578456733050607, 0.9446940011955358],
              [-6.583378192669701, 0.9440818405701811],
              [-6.582373678415599, 0.9373790504276666],
              [-6.588373741909195, 0.9306632311433448],
              [-6.587841276262705, 0.927044633635889],
              [-6.593181756735556, 0.9211026382645153],
              [-6.594858003693744, 0.9171146572604869],
              [-6.594262428436736, 0.9075963740076639],
              [-6.6109396416517034, 0.8983633525796492],
              [-6.6084371209490556, 0.8944662202604555],
              [-6.609985036624931, 0.8919730093804589],
              [-6.616076405559418, 0.8909381274436706],
              [-6.619251428355301, 0.8889861789286111],
              [-6.6228650509479, 0.8926554908949621],
              [-6.627526115927584, 0.8828181950184522],
              [-6.6328326086268525, 0.878533292693862],
              [-6.63164651574368, 0.8727963161860619],
              [-6.63355283427378, 0.8708527113700677],
              [-6.631738396521086, 0.8661304300014254],
              [-6.631663968989739, 0.8602576524386785],
              [-6.63459097664193, 0.8576023614893329],
              [-6.639283409125779, 0.8594954447078252],
              [-6.644672885977405, 0.8577884171760085],
              [-6.646180521245908, 0.8534579374967136],
              [-6.650458433007485, 0.8509882168092769],
              [-6.652645237840301, 0.845760755186299],
              [-6.654445657264389, 0.8375448109102341],
              [-6.656789978355409, 0.8356019482088782],
              [-6.655876669619973, 0.8307146999515878],
              [-6.665776333932935, 0.8246736556838323],
              [-6.666812865381728, 0.8201987083243811],
              [-6.670421980003523, 0.8167634652749979],
              [-6.674722233123076, 0.816412946347416],
              [-6.6796463993640325, 0.8081491223073876],
              [-6.680792516225629, 0.7990371713069117],
              [-6.685281212600235, 0.7998742451674844],
              [-6.687246994593212, 0.7893193094918818],
              [-6.692964864782494, 0.7836862505525305],
              [-6.693682622283667, 0.7837437424019503],
              [-6.7452799220354605, 0.788934676561572],
              [-6.7422949674501025, 0.8181186286468879],
              [-6.733296824440219, 0.9099091038514748],
              [-6.730905926666854, 0.9247790925934248],
              [-6.726903736170564, 0.9760056701674454],
              [-6.726276191427186, 0.9865056689684062],
              [-6.723448630119118, 1.0110841396428636],
              [-6.721027240080032, 1.0386286698289824],
              [-6.71859650361918, 1.0600089838385027],
              [-6.713264760048634, 1.1130772052239408],
              [-6.706385226485805, 1.1859232279682679],
              [-6.702596417132786, 1.2274378787261973],
              [-6.698518624654121, 1.2679569134163304],
              [-6.695036716430019, 1.2982144616710047],
              [-6.690310550442848, 1.3481496665970634],
              [-6.683902231556159, 1.4080958144203766]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -105.25051417394232, "lat": 39.5863605949278 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08059"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00198145"
      },
      "bbox": [
        -6.7452799220354605, 0.7836862505525305, -6.406133876717262,
        1.5755998322472382
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.390148285501795, -10.934463720791152],
            [13.455341678863016, -10.925241542725951],
            [13.484710191878694, -10.920935465343918],
            [13.482610748077683, -10.90683631810678],
            [13.504293226655822, -10.903557484340887],
            [13.506843377065604, -10.917664438894366],
            [13.61614614106905, -10.901124928251678],
            [13.728039254506031, -10.884191582510782],
            [13.739147842004238, -10.882711564537418],
            [13.819083376577806, -10.870193857155414],
            [13.912549200201747, -10.855106219960366],
            [13.941286535392274, -10.850319400784546],
            [13.945223807244776, -10.818364662700038],
            [13.954414694633765, -10.743587951242182],
            [13.96359430175128, -10.668777919909575],
            [13.964403217046886, -10.659070265903491],
            [13.994029383656372, -10.84194736980742],
            [14.005591154434784, -10.912347144075783],
            [14.012204553640101, -10.95392900686895],
            [14.019280968013677, -10.995894705068633],
            [14.044453927137795, -11.134297825185016],
            [14.044770684291255, -11.136866897998134],
            [14.065770563474523, -11.248109088958756],
            [14.064067166800141, -11.248312084570177],
            [14.066564714357675, -11.260056876139656],
            [14.079674810299654, -11.331376453606946],
            [13.978533619157531, -11.34882484547848],
            [13.877386068814824, -11.366239267485025],
            [13.80549628489851, -11.378750103397325],
            [13.733603208133916, -11.391243764795881],
            [13.704339142678135, -11.228784669756195],
            [13.69002441619233, -11.13794926135955],
            [13.587954485018201, -11.154504084279958],
            [13.530281217924601, -11.163849543269702],
            [13.517217694990702, -11.167435537890894],
            [13.430407911001563, -11.181020615907855],
            [13.422070943027451, -11.132422849640633],
            [13.40899717045525, -11.055429571886686],
            [13.398488985279359, -10.992443912416771],
            [13.390148285501795, -10.934463720791152]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.16586851283365, "lat": 26.55348732393086 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12051"],
        "coty_name": ["Hendry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hendry County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00307626"
      },
      "bbox": [
        13.390148285501795, -11.391243764795881, 14.079674810299654,
        -10.659070265903491
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.477500424403626, -10.002864837308389],
              [12.489759714117694, -9.997742789577742],
              [12.490437468468684, -9.999623782579485],
              [12.48070078798533, -10.003118955364318],
              [12.477500424403626, -10.002864837308389]
            ]
          ],
          [
            [
              [12.45974372444882, -9.985078526637789],
              [12.459077693900277, -9.96814920643422],
              [12.46875806354762, -9.966949090642323],
              [12.471154476238068, -9.982279757139063],
              [12.467028360738308, -9.987802646371101],
              [12.460162843497876, -9.9876871796194],
              [12.45974372444882, -9.985078526637789]
            ]
          ],
          [
            [
              [12.46104857842919, -10.01567597139754],
              [12.462647153940816, -10.011840938650957],
              [12.469251472193266, -10.011892308519059],
              [12.470685971920723, -10.02785951712115],
              [12.462186933120433, -10.027828416990182],
              [12.46104857842919, -10.01567597139754]
            ]
          ],
          [
            [
              [12.22925763076921, -9.713739418521362],
              [12.255834480886284, -9.70995017629948],
              [12.330175066036857, -9.700299256188101],
              [12.347221272016174, -9.697758245160854],
              [12.384525723734114, -9.693277135912188],
              [12.40630959181699, -9.69036236790242],
              [12.424759862574108, -9.688235027400824],
              [12.463813591873212, -9.682729630141898],
              [12.576894075170205, -9.666347568867833],
              [12.613893853022605, -9.660628769686294],
              [12.638341783068602, -9.65731755400587],
              [12.677503540597076, -9.651654318532232],
              [12.690109400966236, -9.64933733210624],
              [12.706763570922764, -9.647417250948449],
              [12.75015730969051, -9.641164579550912],
              [12.756042663619155, -9.680570581095163],
              [12.759458311189002, -9.705264814793603],
              [12.768319540301539, -9.761706035282536],
              [12.771947672454685, -9.783417745712013],
              [12.776862030883002, -9.814802129734908],
              [12.776963397919657, -9.818088365405274],
              [12.789890935339592, -9.897809723492804],
              [12.795682850267545, -9.9385980134356],
              [12.798279239761781, -9.948756584425087],
              [12.828325177307269, -10.150808218691537],
              [12.82658517050587, -10.151212890922817],
              [12.747418669609374, -10.162634833357181],
              [12.640087202544077, -10.177993439475172],
              [12.62708200502952, -10.179566678765461],
              [12.53729504333927, -10.19262809729888],
              [12.437360196405235, -10.207638737133037],
              [12.41406429280315, -10.210987731483467],
              [12.388339510153724, -10.214220530189632],
              [12.399451501786517, -10.18581073733289],
              [12.40536548346407, -10.173524844286046],
              [12.408654953994395, -10.168874452333961],
              [12.413628989541257, -10.159008406067116],
              [12.41314429647324, -10.155426420456655],
              [12.415003112988385, -10.151300026347771],
              [12.430171065229091, -10.135923127018152],
              [12.44099084088896, -10.13348479306658],
              [12.445501324072096, -10.129085146577518],
              [12.443508261066754, -10.117949742801002],
              [12.43858304547352, -10.110573337378645],
              [12.440885708222773, -10.107392591018215],
              [12.44746406075201, -10.104097758700785],
              [12.449644236940376, -10.104580420673381],
              [12.453539889888736, -10.101207998653736],
              [12.456488243864658, -10.103845054948033],
              [12.458287712985621, -10.098676628817048],
              [12.468318551253304, -10.09170490126316],
              [12.470695601421731, -10.091998758312931],
              [12.478477035147675, -10.082204481962487],
              [12.480257571174098, -10.076876936927045],
              [12.474220703102251, -10.07379965273345],
              [12.486335262281784, -10.055262632033825],
              [12.492635705552939, -10.052797602326157],
              [12.490882496096235, -10.041222453711885],
              [12.491422992566125, -10.036376119954628],
              [12.497895928511586, -10.03408892305799],
              [12.50146468963556, -10.031497892493633],
              [12.505710485975284, -10.030983533998267],
              [12.506775658486745, -10.027785386706565],
              [12.51181256729293, -10.0246424738379],
              [12.510306200817492, -10.020568689375272],
              [12.505900063510087, -10.021314224576745],
              [12.5021568610009, -10.012773465524875],
              [12.502656174340606, -10.008236231063083],
              [12.498405476908502, -10.000924326843828],
              [12.496428693333206, -9.992943424329948],
              [12.492459840511383, -9.993387636931976],
              [12.490110485551389, -9.989900298243425],
              [12.49240729819896, -9.98665865258563],
              [12.488760291187084, -9.97404042584061],
              [12.489938913892258, -9.971542928804718],
              [12.488141106946287, -9.9656138329805],
              [12.474461902233514, -9.9499329843272],
              [12.461811603787996, -9.95178563628503],
              [12.459244017930372, -9.95360532004536],
              [12.448539903638089, -9.938829128288404],
              [12.445611182899642, -9.942122177571816],
              [12.443915750282557, -9.947570176404353],
              [12.43232633061071, -9.946632731183358],
              [12.430433827175365, -9.936557891300723],
              [12.429815261248267, -9.919898056487717],
              [12.424532342115821, -9.921515732511734],
              [12.423893644005028, -9.924507732540116],
              [12.419222576468437, -9.926373679870448],
              [12.40577134577992, -9.940383910964579],
              [12.405349616863903, -9.945498740828564],
              [12.411251742363524, -9.96393448252882],
              [12.418576495521194, -9.968813696086915],
              [12.418903308052169, -9.979248354530126],
              [12.41493164584155, -9.984086682988586],
              [12.413858400350392, -9.989538863954456],
              [12.41547599809289, -9.995135812448204],
              [12.424196965039167, -10.003753153877723],
              [12.432511368993271, -10.008430477112796],
              [12.435529698749415, -10.012014619515005],
              [12.435295758528351, -10.03259339880905],
              [12.43302705032951, -10.034467004995815],
              [12.419986426268334, -10.03470469357908],
              [12.400462584439886, -10.03209600176908],
              [12.384017736449703, -10.025869174830206],
              [12.379822213941798, -10.030133188590675],
              [12.376252096135456, -10.027929934890759],
              [12.3762669939593, -10.022843411937638],
              [12.363049622213133, -10.013779455131173],
              [12.358913864824602, -10.003565754441464],
              [12.37116967363755, -9.999666808206491],
              [12.37636119453211, -9.992189567581718],
              [12.377040958289802, -9.986356490516322],
              [12.375125661898805, -9.984984573176247],
              [12.374927210852926, -9.97802104360093],
              [12.368042777535228, -9.97964216371858],
              [12.364136002861917, -9.972236896451196],
              [12.370492276935284, -9.971317484882654],
              [12.372564675920746, -9.968665652347596],
              [12.369364200525297, -9.966467161641262],
              [12.368527665675948, -9.962070301680988],
              [12.37209690004801, -9.96088895225048],
              [12.369801157157502, -9.949264380659365],
              [12.36723182444135, -9.948988048951941],
              [12.366192752359597, -9.943748930956678],
              [12.369086532743848, -9.937173986515619],
              [12.366608035607449, -9.936130559065417],
              [12.365416534622637, -9.927494540404505],
              [12.360830151679512, -9.926032356540743],
              [12.355869321577968, -9.926790454965381],
              [12.354724168451094, -9.923914907388511],
              [12.358008298407274, -9.920107105766085],
              [12.353035107982546, -9.917576639468395],
              [12.353427065559643, -9.91170040765598],
              [12.343384989652582, -9.902374096732098],
              [12.333204322204049, -9.90372451383651],
              [12.331067627561062, -9.909686689032439],
              [12.326868344287858, -9.908609615383748],
              [12.32854942416128, -9.901090456429664],
              [12.33175689395228, -9.898594663294306],
              [12.329274499767337, -9.895893979128887],
              [12.325665735874784, -9.896967749824938],
              [12.31566223404961, -9.894363397630512],
              [12.304268038754063, -9.895116013053297],
              [12.298678514630982, -9.89346367790724],
              [12.287008356833907, -9.88700740905716],
              [12.280865504639213, -9.882825730623685],
              [12.278483961464968, -9.878594534478255],
              [12.270922640124745, -9.877163081523392],
              [12.265480717594762, -9.87472162378177],
              [12.262381086716667, -9.871240439632148],
              [12.26046821031994, -9.86459435838669],
              [12.253216395439651, -9.864288442850961],
              [12.248036482924078, -9.827226396544278],
              [12.2465526302874, -9.820233122157667],
              [12.241401022241925, -9.7858283946093],
              [12.233705175066904, -9.74123864320528],
              [12.22925763076921, -9.713739418521362]
            ]
          ],
          [
            [
              [12.210713595039575, -10.29285054047959],
              [12.21018313296655, -10.283649263955974],
              [12.21419761269456, -10.283286346477134],
              [12.214857366449353, -10.286666643691833],
              [12.214683046482786, -10.297960628445058],
              [12.210713595039575, -10.29285054047959]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.30868988342738, "lat": 27.92927625056424 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12057"],
        "coty_name": ["Hillsborough"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hillsborough County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00295757"
      },
      "bbox": [
        12.21018313296655, -10.297960628445058, 12.828325177307269,
        -9.641164579550912
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.964391787143988, -7.301954309267667],
            [8.995372483336109, -7.299164820469352],
            [9.08462781594112, -7.289167209153765],
            [9.206509272780952, -7.2747994644892735],
            [9.206726083461389, -7.274320817691247],
            [9.347913256008308, -7.257949712680984],
            [9.42030433604238, -7.249456589916426],
            [9.416723552278924, -7.256228144051179],
            [9.40759756267405, -7.265521495657634],
            [9.402213587153902, -7.272859914744358],
            [9.397162202182766, -7.273734731680218],
            [9.3955224516846, -7.277509270570935],
            [9.395260901612184, -7.290623646794813],
            [9.397565103189093, -7.2955507094664895],
            [9.39758303725137, -7.30691495842592],
            [9.399220664423593, -7.309448675432105],
            [9.394234782647594, -7.314815585483423],
            [9.385171900020923, -7.318124585228768],
            [9.381241329482313, -7.324581744601717],
            [9.377509276268569, -7.337233334331933],
            [9.3731039091277, -7.341804025075503],
            [9.36816108852294, -7.351513431302887],
            [9.365200960972526, -7.353917124924382],
            [9.363919085997304, -7.361452693924837],
            [9.359944514821066, -7.371081879272356],
            [9.360593367817453, -7.3785751705384675],
            [9.358554868463049, -7.384393442945867],
            [9.354799412306958, -7.38912911302301],
            [9.352511497217689, -7.3999152513688085],
            [9.352948048572085, -7.405330931373587],
            [9.350868574497895, -7.409596107414484],
            [9.352125757557662, -7.413541653726989],
            [9.351935273254712, -7.423445806626318],
            [9.354298718881022, -7.434885813026019],
            [9.354495064837282, -7.439612681677879],
            [9.353008890804423, -7.448279577770438],
            [9.35280779419712, -7.457636305117542],
            [9.349666960637046, -7.462280966427139],
            [9.345300327531929, -7.4720533205440045],
            [9.344241568412253, -7.478588055958763],
            [9.341336514350813, -7.483421226316219],
            [9.341576408281004, -7.491320408726946],
            [9.34380127032833, -7.500421512867981],
            [9.345170727517473, -7.510877166941995],
            [9.332974296309525, -7.5116592731220155],
            [9.29125845857442, -7.515744560489196],
            [9.288730322544614, -7.516279649419163],
            [9.251411707866342, -7.519011415311752],
            [9.24515886156253, -7.519186825704809],
            [9.245235333856312, -7.515360391290515],
            [9.242830848535226, -7.490519481217512],
            [9.228419147586916, -7.491653475788909],
            [9.226962331859518, -7.477906984658047],
            [9.167475383110844, -7.4831045756972685],
            [9.172669295437968, -7.489542752167952],
            [9.1705568683412, -7.494475153354721],
            [9.164890296929887, -7.497646529178878],
            [9.162535372445923, -7.505844541477496],
            [9.164882345825058, -7.511952935796868],
            [9.162053368336348, -7.514165665831257],
            [9.162293053204174, -7.517341213839846],
            [9.166387929397056, -7.521741665696931],
            [9.162680946999398, -7.5256972616363695],
            [9.167564904818864, -7.527001555537246],
            [9.168135880275456, -7.529421892312799],
            [9.165725776699604, -7.533477232792314],
            [9.170002881141404, -7.535366811895498],
            [9.168117069852658, -7.543935436331596],
            [9.170650532172575, -7.548238689999882],
            [9.166140609245518, -7.550963999576562],
            [9.15986912926228, -7.557383779316475],
            [9.159859274023553, -7.563157006132468],
            [9.156371068733385, -7.567762779445399],
            [9.157420108716561, -7.571790034017461],
            [9.093492254168106, -7.578272025678385],
            [9.063493902533944, -7.581148464883825],
            [9.024653602911702, -7.5845391454705515],
            [8.992517715047525, -7.587713930351787],
            [8.982052627603471, -7.487687953488088],
            [8.976489192529154, -7.4252771213312245],
            [8.974113692184664, -7.4023622509620095],
            [8.970871847549153, -7.367317186174176],
            [8.964391787143988, -7.301954309267667]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.81404242630074,
          "lat": 30.867953559570054
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12059"],
        "coty_name": ["Holmes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Holmes County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00295735"
      },
      "bbox": [
        8.964391787143988, -7.587713930351787, 9.42030433604238,
        -7.249456589916426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.758979129669921, -6.277463802770002],
            [11.847893500454257, -6.265056747276192],
            [11.842436525684958, -6.227223275630729],
            [11.863893718389104, -6.22438468523963],
            [11.873344607012513, -6.2360133878841815],
            [11.883002946693228, -6.2434985176540225],
            [11.883673631202655, -6.24747542587857],
            [11.887632449688791, -6.251696979968063],
            [11.895309627446558, -6.254298233744539],
            [11.899419944662263, -6.259883299696328],
            [11.905471106307527, -6.26116944263643],
            [11.908626266417444, -6.267639558878157],
            [11.916100625169662, -6.2691333635236335],
            [11.9200040028964, -6.266085028765784],
            [11.927449905831768, -6.269641234204887],
            [11.933297538289017, -6.27422000019886],
            [11.945752479906298, -6.281896044171703],
            [11.948195031203689, -6.284354062621452],
            [11.952551240623945, -6.283164674639293],
            [11.95698404899253, -6.284359223250996],
            [11.962931658348278, -6.283405200434251],
            [11.966402612986862, -6.286068313407802],
            [11.971820433225778, -6.286426022492214],
            [11.976639575484064, -6.289054700260106],
            [11.98181961322913, -6.287772775685912],
            [11.994453976777073, -6.294239142773366],
            [11.999377638711254, -6.295020085307126],
            [12.013781666650408, -6.307502045109346],
            [12.02456368657326, -6.313387385042527],
            [12.029706356544022, -6.317943074279435],
            [12.03479247450009, -6.3196748232281434],
            [12.042508639455038, -6.32392431183566],
            [12.04949947809636, -6.32521507349889],
            [12.061152106748278, -6.330300543753713],
            [12.073149823965942, -6.334157660958409],
            [12.08058161638178, -6.3417828432479295],
            [12.085567607827674, -6.3437802070272],
            [12.0939977529751, -6.343704368853076],
            [12.100192667540185, -6.346694605719203],
            [12.109149470726708, -6.356424811761642],
            [12.111579661442022, -6.362730080542222],
            [12.115728495681717, -6.369630949848507],
            [12.10510467696752, -6.371302186591051],
            [12.1073339221421, -6.384017102923313],
            [12.092986170292857, -6.386326747253154],
            [12.094818472565972, -6.398145707522533],
            [12.0832196139512, -6.399546159423314],
            [12.085041927015324, -6.412445786018704],
            [12.059109990573758, -6.415654079804111],
            [12.062346768029949, -6.44077625227681],
            [12.050471319838593, -6.44234193104432],
            [12.051954445614816, -6.4530124674291445],
            [12.039422236907194, -6.4548603263007625],
            [12.041188899615628, -6.469762018342149],
            [12.029039635702766, -6.4718147525004746],
            [12.030833313437348, -6.483272965007977],
            [11.983135300295563, -6.489951551842866],
            [11.98476077561123, -6.50283291256469],
            [11.971781166699815, -6.504849837305285],
            [11.954637582954536, -6.507513525582758],
            [11.917684818844553, -6.512147011389763],
            [11.914068808093527, -6.486927172877233],
            [11.903820919759937, -6.488569021854234],
            [11.899254725941583, -6.46322295715022],
            [11.894954647143656, -6.463990288768367],
            [11.812711912439308, -6.474869896492664],
            [11.80469291753533, -6.412813630560079],
            [11.801238980359539, -6.387202050953264],
            [11.774298762901552, -6.390565030397278],
            [11.758979129669921, -6.277463802770002]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.4526985073062, "lat": 31.553638727390343 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13005"],
        "coty_name": ["Bacon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bacon County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00344784"
      },
      "bbox": [
        11.758979129669921, -6.512147011389763, 12.115728495681717,
        -6.22438468523963
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.309115326823395, -5.44344092034653],
            [10.31313455143793, -5.42908415127289],
            [10.325354969493254, -5.382151924124987],
            [10.326030683000882, -5.380662787650416],
            [10.339455892741997, -5.327439390267303],
            [10.360211796695303, -5.32511996885965],
            [10.354162084084754, -5.276780751866453],
            [10.451698038219627, -5.264922404784462],
            [10.475078082987475, -5.26219561202221],
            [10.474285820263571, -5.254014370892991],
            [10.482402592882142, -5.252986096628564],
            [10.483361081235437, -5.261223067026658],
            [10.546788827444072, -5.253672795171018],
            [10.550363206453422, -5.2822984229478],
            [10.557573732138893, -5.282652028363925],
            [10.561714795119487, -5.283928231462704],
            [10.564693889826172, -5.288722954811204],
            [10.564495064915276, -5.293234628773832],
            [10.57850242908186, -5.300613127924423],
            [10.58277516889567, -5.304230734075376],
            [10.583660823689073, -5.309802418784977],
            [10.588407443766823, -5.311870444792102],
            [10.587172886873818, -5.315511659759554],
            [10.592751125727958, -5.321406658693027],
            [10.595697679224495, -5.327864454713141],
            [10.599326612753496, -5.329528609126732],
            [10.60524488489191, -5.336768732498313],
            [10.610137943469418, -5.341046577174533],
            [10.612554399438356, -5.347947195233283],
            [10.616399327025093, -5.352319606398698],
            [10.620982956545173, -5.3532181211656855],
            [10.62354494377402, -5.357385184986353],
            [10.628953730701667, -5.359566914407612],
            [10.63147232567383, -5.3636938383091985],
            [10.634335132189058, -5.362712169321811],
            [10.639597290499552, -5.366384388580157],
            [10.646071295309913, -5.365638950056365],
            [10.651067736758742, -5.36950519937069],
            [10.655902316589422, -5.368139807555751],
            [10.663551699014429, -5.374068243635565],
            [10.671430455524982, -5.373261053812737],
            [10.681838039989305, -5.382019334660536],
            [10.683649379774868, -5.380284984103044],
            [10.689239977377527, -5.387270468785684],
            [10.6957025074931, -5.390814510711202],
            [10.700698738916119, -5.386576921356496],
            [10.709024829050623, -5.390256758198108],
            [10.71984924342785, -5.388038893438342],
            [10.725047251259326, -5.388496699451876],
            [10.725172807041922, -5.389057073970816],
            [10.672377985191803, -5.394650065087073],
            [10.670531021746392, -5.395082963339227],
            [10.640289907902156, -5.427506167559271],
            [10.63280317906632, -5.435257777191949],
            [10.600320635809634, -5.470094658467112],
            [10.593178929028843, -5.477236280922698],
            [10.55675509537612, -5.516280930130378],
            [10.548719931435302, -5.5169997925981615],
            [10.5490105895931, -5.524276408335219],
            [10.5379903157315, -5.536200372957438],
            [10.54025215663677, -5.553017351039456],
            [10.5321241298398, -5.553974877416363],
            [10.531058277268444, -5.543708618809385],
            [10.494802764349654, -5.581715820807689],
            [10.495232142745254, -5.578336235704007],
            [10.491532661321056, -5.5729880314239875],
            [10.485815516223353, -5.57495876033565],
            [10.484408082239845, -5.5702451330834775],
            [10.481089541466412, -5.5671699092915885],
            [10.480072395218121, -5.5626591260724325],
            [10.473583109536587, -5.566669689037688],
            [10.473309733744916, -5.5636914961035675],
            [10.468443490917707, -5.558657779850309],
            [10.465526258826998, -5.560470105333634],
            [10.460430089309252, -5.558034652469544],
            [10.455857742866755, -5.558024017329248],
            [10.456298462201785, -5.55458459298724],
            [10.454313419973879, -5.548879613494387],
            [10.44908404552921, -5.549756470937493],
            [10.451598007194583, -5.5423633771350005],
            [10.447668896831216, -5.540758993530661],
            [10.441232330663814, -5.540650138822776],
            [10.436777953443347, -5.5364324603055985],
            [10.437976299659304, -5.530694129326273],
            [10.433746482935842, -5.528482140860306],
            [10.430831517245473, -5.525103889184517],
            [10.429733134230014, -5.520961620112437],
            [10.433122651480518, -5.513701693219568],
            [10.431305931457938, -5.511285220999066],
            [10.432144915908438, -5.507649129678229],
            [10.42697269059178, -5.5025471388916],
            [10.42818018022005, -5.491185462261378],
            [10.436420207417203, -5.48780065216647],
            [10.435961584499296, -5.484385860323694],
            [10.432795554202643, -5.483224736967537],
            [10.42899087067305, -5.478962902524407],
            [10.427128228437873, -5.48197611695358],
            [10.422237290408072, -5.483569239371261],
            [10.422456117267743, -5.48005519743263],
            [10.417832886546996, -5.473035709936706],
            [10.402026723826804, -5.460247136779818],
            [10.3979749116858, -5.453281898105198],
            [10.392282349848262, -5.449853281827623],
            [10.391647076112964, -5.439981970786908],
            [10.38875886189694, -5.438355487509215],
            [10.382418084090517, -5.440921402501086],
            [10.382557103331656, -5.445822889829417],
            [10.376658620312709, -5.448163314769719],
            [10.37287339270576, -5.451298757999318],
            [10.367772707387479, -5.450538461569074],
            [10.36254407928315, -5.447777519214514],
            [10.362400370689002, -5.442949411242564],
            [10.35694307354975, -5.4422975962043045],
            [10.35086059762996, -5.449320338536536],
            [10.343868670168192, -5.451427238441539],
            [10.334246028899699, -5.452788369218607],
            [10.3249763853796, -5.451735039980916],
            [10.317839460593309, -5.448876718642972],
            [10.315077758831265, -5.448983834818472],
            [10.309115326823395, -5.44344092034653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.98632447834157,
          "lat": 32.714558208278305
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13079"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00342918"
      },
      "bbox": [
        10.309115326823395, -5.581715820807689, 10.725172807041922,
        -5.252986096628564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.341188949271393, -5.238287053942398],
            [11.453824719773554, -5.171719855927683],
            [11.458068364436658, -5.175642242603707],
            [11.45804976974477, -5.1780759059853185],
            [11.46941159396874, -5.179064910048661],
            [11.475289402905824, -5.181411100812505],
            [11.479973934936393, -5.185222364695906],
            [11.482620517244026, -5.1919025544783715],
            [11.484927979342109, -5.202354772095414],
            [11.487541029009368, -5.208174288812062],
            [11.501995341292604, -5.198686803109906],
            [11.515559223254742, -5.191934912840538],
            [11.532808937587223, -5.186787481041632],
            [11.543357020956337, -5.177824061992349],
            [11.556333016943345, -5.170534277032237],
            [11.56970594145024, -5.1827202734798545],
            [11.577346466999666, -5.176484875615698],
            [11.598122111590872, -5.167082744173523],
            [11.60284309318233, -5.166845887152807],
            [11.614909770557464, -5.161215035788636],
            [11.623687028015993, -5.155054370456602],
            [11.641623074987345, -5.139360656348106],
            [11.65044173523729, -5.135702303965879],
            [11.652472095829866, -5.133390212277821],
            [11.662910556250933, -5.130297154455664],
            [11.684811986119932, -5.126470151572143],
            [11.696510018061979, -5.139784363156124],
            [11.703440098895271, -5.145519635747948],
            [11.71578962550277, -5.151214797236884],
            [11.73072979458219, -5.165272463222362],
            [11.744474458990208, -5.172758330744646],
            [11.749742358120496, -5.174442816412463],
            [11.765267766712816, -5.175822524784336],
            [11.754993807863691, -5.210245202110556],
            [11.756020296868295, -5.220663051372072],
            [11.742342743940291, -5.231372117395849],
            [11.722060721424858, -5.2588201852877745],
            [11.724854230426045, -5.262268281587179],
            [11.726708612483595, -5.267327302598665],
            [11.730549708982334, -5.273303160902795],
            [11.733074737585907, -5.2818430051770395],
            [11.737687484674284, -5.284227960830416],
            [11.74333743146518, -5.2855207656615155],
            [11.744544090578382, -5.287225501066399],
            [11.751482947515882, -5.290502144234798],
            [11.753956794026527, -5.294134410210576],
            [11.75711114040287, -5.293387651250158],
            [11.734900397536995, -5.309900050025633],
            [11.728692841483777, -5.301995686478367],
            [11.714403103691346, -5.313190776730911],
            [11.720351266275962, -5.320957770391454],
            [11.679615273219389, -5.357591304019821],
            [11.658515019294402, -5.3762598426954185],
            [11.6615891171849, -5.383447588343458],
            [11.660026094043111, -5.38856428477766],
            [11.665649511661968, -5.3985363445998],
            [11.670175481532507, -5.402816028905578],
            [11.673897207199955, -5.404637631430264],
            [11.679614368376573, -5.410416810207602],
            [11.686156130942212, -5.414601359437952],
            [11.690086166724655, -5.4190280510625],
            [11.67370721175715, -5.428646622762589],
            [11.66562655269139, -5.41980582924639],
            [11.662224314416077, -5.422548738651261],
            [11.662598255879406, -5.438540911917718],
            [11.659601633568215, -5.434445506396911],
            [11.644072513123799, -5.440177455415844],
            [11.642900487130339, -5.436702813321538],
            [11.631410970219354, -5.441660054654223],
            [11.623689416293118, -5.448569142568778],
            [11.612322518018281, -5.445615911662496],
            [11.599903645551569, -5.440430023617069],
            [11.592386867349328, -5.352202308271423],
            [11.481207474997984, -5.319149144129641],
            [11.481606687939413, -5.306793478922915],
            [11.48242396497069, -5.30032867059091],
            [11.484775749035329, -5.291883087630113],
            [11.416954421702288, -5.271916436717049],
            [11.33984906641345, -5.290083707837113],
            [11.340719428421115, -5.276878727037802],
            [11.343206557494515, -5.272289616140216],
            [11.344178694321622, -5.256179605585267],
            [11.341188949271393, -5.238287053942398]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.66008690273087, "lat": 32.70150809435034 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13167"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00346664"
      },
      "bbox": [
        11.33984906641345, -5.448569142568778, 11.765267766712816,
        -5.126470151572143
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.082026303553137, -3.5365132405224116],
            [10.101045105056858, -3.4879426145289685],
            [10.105701015819328, -3.4842872657766444],
            [10.108498466649186, -3.4883736343198675],
            [10.110736509218079, -3.488410049718899],
            [10.116724456071601, -3.4811641365909916],
            [10.11744522081988, -3.4778119601168234],
            [10.115721579286856, -3.4743561155728186],
            [10.122257587272335, -3.4695399921659895],
            [10.125827185274723, -3.468433264336905],
            [10.132223878109064, -3.4732666110554438],
            [10.148453334301816, -3.4769478368437463],
            [10.158041209626967, -3.4760640968501506],
            [10.163482838322093, -3.4745680104887535],
            [10.163216931069115, -3.47159693881028],
            [10.170291150690074, -3.470528821094034],
            [10.171841655091324, -3.4739862983390934],
            [10.178168553789494, -3.4773511224070526],
            [10.185168706782335, -3.482813501869739],
            [10.187902900599195, -3.4814644032062065],
            [10.193161940556568, -3.484172607103306],
            [10.195420759133873, -3.4820838999017827],
            [10.200393794807338, -3.4817024069384344],
            [10.198674089708616, -3.471212548184002],
            [10.203523080555659, -3.471018884530137],
            [10.204972097143974, -3.466136899120317],
            [10.20373939152277, -3.4621111740049684],
            [10.205632149042842, -3.4597892552564913],
            [10.204766639252895, -3.455540558081446],
            [10.20661125716786, -3.4518368486070483],
            [10.211130755032277, -3.4518607436384063],
            [10.212907015784214, -3.448806615986028],
            [10.218666404632646, -3.4477763397839865],
            [10.224673190451965, -3.4424715679073143],
            [10.229379263067619, -3.4414500898122466],
            [10.22810865902515, -3.434667654080507],
            [10.23010088709614, -3.430560820502351],
            [10.23079494560464, -3.424794306808457],
            [10.229310058801158, -3.423460734149507],
            [10.233374380344426, -3.418582601682762],
            [10.231338996567583, -3.4103283321721474],
            [10.234451858023215, -3.4025165878163803],
            [10.238742553865116, -3.4013632191850376],
            [10.241876362299223, -3.39822577567128],
            [10.242405829487103, -3.393998465292937],
            [10.246180871196888, -3.3933159577350978],
            [10.248445111462088, -3.388455097444654],
            [10.255765383638373, -3.383723280918403],
            [10.260218950656162, -3.3766807339309772],
            [10.266528317086834, -3.3731031569480066],
            [10.269279006493743, -3.375359633913874],
            [10.278295258591559, -3.3777610713956996],
            [10.281103961357555, -3.3746630503185604],
            [10.283973757183135, -3.37690183764591],
            [10.29070359235777, -3.3764823133014943],
            [10.294172305310493, -3.379185163736306],
            [10.299083155978662, -3.3777460062101468],
            [10.305562079829956, -3.3834124672319037],
            [10.311335867916647, -3.381658250114263],
            [10.318559156967117, -3.384273436525195],
            [10.324206277719123, -3.3794047882724665],
            [10.329349909634189, -3.3798589615367844],
            [10.330721967304065, -3.3822201441699566],
            [10.335616923578627, -3.3832172749470355],
            [10.33432391541627, -3.3897753910837327],
            [10.334649411192869, -3.39805499675596],
            [10.336503226764876, -3.4009631509972875],
            [10.333607518527977, -3.4052920158529036],
            [10.335700205522588, -3.4087784026629113],
            [10.332950424165508, -3.4155238239752057],
            [10.334190552682003, -3.4174948452867615],
            [10.327696584939558, -3.4239088678159972],
            [10.327186788098302, -3.434018757507149],
            [10.330859107818279, -3.4382576748457345],
            [10.331084445096527, -3.4419364914579083],
            [10.328464829666704, -3.443177058394024],
            [10.327452153148991, -3.446964615650168],
            [10.331523599994254, -3.4493969840852134],
            [10.330870573284631, -3.4600797271215495],
            [10.334377041946768, -3.466904648971316],
            [10.331144715263711, -3.470542033293709],
            [10.333435305518384, -3.476240071925221],
            [10.330699623794866, -3.4778037899671035],
            [10.334128927741677, -3.483557880590232],
            [10.3361186079367, -3.491284892832003],
            [10.342876795687143, -3.4904648273938856],
            [10.351225527846916, -3.555327277420463],
            [10.359937344040388, -3.55410903657495],
            [10.361097308942442, -3.5633299086770074],
            [10.369173729624297, -3.5623190482349734],
            [10.370307178304492, -3.571339254924291],
            [10.379199234864446, -3.570288707105103],
            [10.38030208576548, -3.5790570464568665],
            [10.377523903821789, -3.57940477655468],
            [10.375733771288541, -3.584636865690807],
            [10.37303174779862, -3.5882755649413984],
            [10.374077106160238, -3.5981465143492675],
            [10.375239496232204, -3.606591235631926],
            [10.352965474038893, -3.6294340574106068],
            [10.350111587752359, -3.6314962732625107],
            [10.342943580301831, -3.639367118201822],
            [10.344059039784886, -3.648202591627436],
            [10.325964863069839, -3.650647088706284],
            [10.324852102561856, -3.641275790111695],
            [10.30694952935262, -3.643396472816649],
            [10.308065193813905, -3.652195367405404],
            [10.31723439378253, -3.651447528211317],
            [10.318364138793896, -3.66041890509397],
            [10.309729995781527, -3.661438311751431],
            [10.291107425252461, -3.6779249955190196],
            [10.285547772279516, -3.679762320415771],
            [10.277869403842617, -3.685891992931309],
            [10.281245915577118, -3.6926295305694206],
            [10.277657404787691, -3.6984401886715097],
            [10.273867744157315, -3.699277016985259],
            [10.255495946800053, -3.6940778846658406],
            [10.232589876033735, -3.6860975794743274],
            [10.209121536229945, -3.678923080279252],
            [10.191929865169982, -3.6728188681287475],
            [10.169503163112648, -3.6656511218019547],
            [10.169388242279805, -3.658843768578552],
            [10.157595335368338, -3.6582910620115796],
            [10.131169721271435, -3.6356391209228422],
            [10.122487437900196, -3.62750235364338],
            [10.109140234274262, -3.616129875370035],
            [10.087949843407651, -3.6001767514403182],
            [10.082026303553137, -3.5365132405224116]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.00271352284199,
          "lat": 34.572177545146985
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13187"],
        "coty_name": ["Lumpkin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lumpkin County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "00357196"
      },
      "bbox": [
        10.082026303553137, -3.699277016985259, 10.38030208576548,
        -3.3731031569480066
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.711002653262089, -3.636331159155209],
            [9.747018296860618, -3.6314085305923434],
            [9.776248138691997, -3.6279722667189995],
            [9.776198610166457, -3.626686102832667],
            [9.81867614216341, -3.6218287323627067],
            [9.818741507593332, -3.6155248243393707],
            [9.825775745717856, -3.6145984394947757],
            [9.825078294847605, -3.6076915373301435],
            [9.832298876157143, -3.6067803872801973],
            [9.833741553681476, -3.6199893359325883],
            [9.85493864247733, -3.6177675051830502],
            [9.854301416936607, -3.6112333915407664],
            [9.846891991797126, -3.6120792814424174],
            [9.845981409070001, -3.6055387838004966],
            [9.860394714305388, -3.6035621658954353],
            [9.862146769351595, -3.6170538659487383],
            [9.890948097622541, -3.614076709534603],
            [9.893208237943812, -3.6095110339307217],
            [9.892974633955202, -3.605665370853351],
            [9.896483493603773, -3.6053199430881193],
            [9.89734432861851, -3.613406143920213],
            [9.933246412238411, -3.609452052119623],
            [9.940590737309233, -3.6089596284988743],
            [9.938700119458789, -3.5945766100808396],
            [9.959754490012028, -3.5921693095820197],
            [9.961434981651204, -3.6064849108666586],
            [9.992455408044371, -3.684321301411116],
            [10.043502483070833, -3.67854929278885],
            [10.053643623950348, -3.7648034675802946],
            [9.944354769886978, -3.7785712430636806],
            [9.94518221406303, -3.7859685007940636],
            [9.938236328943018, -3.786845221177247],
            [9.937390269027338, -3.7796265744513584],
            [9.918034051242076, -3.7818906728247903],
            [9.917130164539879, -3.7745016752888367],
            [9.90280103137507, -3.7760497376967024],
            [9.903592226161384, -3.78385675616143],
            [9.876433882769732, -3.7869579356339065],
            [9.789419750797899, -3.796579093172558],
            [9.785548902595687, -3.7659442106408085],
            [9.728293884607655, -3.7724146456200165],
            [9.72270061605618, -3.7293200547826553],
            [9.730254430728388, -3.7284155187232932],
            [9.729308118357352, -3.721234217579587],
            [9.722170182455553, -3.72187823895223],
            [9.715632931507713, -3.673637308674173],
            [9.711002653262089, -3.636331159155209]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.4655790180032, "lat": 34.464352158529806 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13227"],
        "coty_name": ["Pickens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pickens County"],
        "coty_fp_code": "227",
        "coty_gnis_code": "01673011"
      },
      "bbox": [
        9.711002653262089, -3.796579093172558, 10.053643623950348,
        -3.5921693095820197
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.294454049373895, -4.949120713587623],
            [12.327143297903994, -4.916827824604268],
            [12.364658844832906, -4.879268601410915],
            [12.459947343514342, -4.785833283313016],
            [12.462081411646324, -4.790654030540307],
            [12.466178879829618, -4.7921828467291725],
            [12.469750458441169, -4.7892272364604285],
            [12.472415089873431, -4.794113939482596],
            [12.480663926738252, -4.7994114789225355],
            [12.48603180389317, -4.799234236732266],
            [12.488628703586755, -4.8016176715741095],
            [12.482850849875225, -4.8067825288999515],
            [12.489577767510053, -4.806111037513737],
            [12.491844911635628, -4.809541156231885],
            [12.489885577297203, -4.815144245770521],
            [12.492913893225307, -4.816462136134875],
            [12.49417154725095, -4.810743233558555],
            [12.497309210607856, -4.8111361736833045],
            [12.506940983283354, -4.81820181354901],
            [12.501544840808606, -4.820681559822484],
            [12.501332181412794, -4.825188281580407],
            [12.508876497271983, -4.826904207886756],
            [12.508667543381137, -4.831312952998392],
            [12.505863574923048, -4.834377437939845],
            [12.508065705552978, -4.838760455344912],
            [12.50884150258539, -4.84600982422974],
            [12.507202012548372, -4.85233369887046],
            [12.507114350741077, -4.8606970449707765],
            [12.502722842312169, -4.862606318520594],
            [12.497030733564916, -4.860272304296297],
            [12.501452713230226, -4.873969365142393],
            [12.510161682860371, -4.880307279327413],
            [12.508429420956476, -4.886963134058716],
            [12.511738201937671, -4.892617422489839],
            [12.515799233627616, -4.893027778583818],
            [12.527104335859983, -4.901229043209298],
            [12.52436145809675, -4.905657284813496],
            [12.525005028984928, -4.908681683395442],
            [12.53101434851261, -4.909107050600481],
            [12.530526694694828, -4.913795963056162],
            [12.532889149463255, -4.916737138117696],
            [12.532622010350389, -4.923902472352784],
            [12.54155111647334, -4.92615430148616],
            [12.5399933415594, -4.921360510474759],
            [12.544705482818467, -4.920754739265959],
            [12.546348315428478, -4.924448098131617],
            [12.54393151627835, -4.928595390340765],
            [12.537390342199544, -4.9344749024525365],
            [12.536433998325547, -4.9410995627924645],
            [12.539870574263576, -4.944062256764453],
            [12.546516052262266, -4.9440220208675925],
            [12.548336585239726, -4.939461367113327],
            [12.552923884565661, -4.944573545469939],
            [12.559032143158449, -4.944934289471522],
            [12.561731241879432, -4.951330110839343],
            [12.560595037404235, -4.954869955166321],
            [12.561524804736854, -4.958997937263601],
            [12.559385146142953, -4.966458565647349],
            [12.561440684676997, -4.972325156033602],
            [12.569580894081376, -4.966551651292421],
            [12.57526575892409, -4.9764328319333595],
            [12.579022570517312, -4.972633786064548],
            [12.586323603895627, -4.9743142661611115],
            [12.591195379235375, -4.979238510709373],
            [12.592623756178664, -4.983029641734489],
            [12.590551192788737, -4.986306188959025],
            [12.585900005860388, -4.9881997418332595],
            [12.592362448824513, -4.991518969585828],
            [12.596029276122135, -5.000244825993732],
            [12.591186344924072, -5.004847341330996],
            [12.595603479905176, -5.011064130013877],
            [12.591898015614895, -5.012535206829338],
            [12.595292996155216, -5.0240850643809285],
            [12.593679100573802, -5.02777116572206],
            [12.598547103317681, -5.0300211802092605],
            [12.592414063433647, -5.033211484545297],
            [12.598487342739919, -5.03558121166328],
            [12.604206703169726, -5.033402327090046],
            [12.605873328735614, -5.034811618148126],
            [12.604220583933067, -5.039946781495472],
            [12.59408024092728, -5.0427321125502305],
            [12.595341221477979, -5.046821116266618],
            [12.601130240300364, -5.0454613804086605],
            [12.610360866976453, -5.0493578159996675],
            [12.609713371184428, -5.057264281245025],
            [12.605787201596167, -5.0635736410587056],
            [12.607084408618025, -5.065205025860517],
            [12.61743088047905, -5.06244156361201],
            [12.618712769169054, -5.066478877000825],
            [12.617351905730118, -5.07138668524646],
            [12.612610200940265, -5.075014237112648],
            [12.6150493312981, -5.078313841729227],
            [12.609976950866168, -5.082066054143909],
            [12.61157016877523, -5.084010643771626],
            [12.609882555468538, -5.09330924376254],
            [12.614370335401697, -5.096637930613479],
            [12.614170629010646, -5.100317524257324],
            [12.610478672221177, -5.101195368770729],
            [12.60760530300605, -5.112902176523532],
            [12.612839505881306, -5.113143545315398],
            [12.61481414849397, -5.116511388107485],
            [12.619313238594328, -5.1165685418449485],
            [12.620803213631639, -5.1197625394123545],
            [12.62648766860712, -5.120542994990165],
            [12.626685740154162, -5.126187623953722],
            [12.63125793130917, -5.1292215312694065],
            [12.632454544423403, -5.132768693499074],
            [12.631123025140756, -5.1399202045929835],
            [12.631703150555154, -5.143647462743815],
            [12.637630548594268, -5.147078268628538],
            [12.635947717958015, -5.151497065821771],
            [12.642113482296377, -5.155611544233778],
            [12.642079372982378, -5.159591507686495],
            [12.634435093049614, -5.167744349427398],
            [12.62845581294556, -5.169848729181974],
            [12.629385553216578, -5.171874646768862],
            [12.637269935140866, -5.173043526534905],
            [12.63363111688802, -5.179406397635746],
            [12.630632937781796, -5.178246632522883],
            [12.628384804357665, -5.174071276801892],
            [12.624640694687653, -5.177348239389453],
            [12.62587814681846, -5.183599029340887],
            [12.630584873622798, -5.186468193419618],
            [12.633215886743436, -5.193231815990219],
            [12.636458580904856, -5.193894681206989],
            [12.637874751375486, -5.197265431530618],
            [12.649949812284449, -5.2062505416606255],
            [12.654831952944116, -5.212548736759786],
            [12.553776930697039, -5.308354295336899],
            [12.544386000768524, -5.31696998863335],
            [12.539566173643266, -5.337734638030256],
            [12.537946389366208, -5.335348197359564],
            [12.533532213262047, -5.335365134095536],
            [12.526119224791712, -5.331236320080083],
            [12.51109514092485, -5.3188043524329425],
            [12.503093035763131, -5.319843025678224],
            [12.497774082261323, -5.323895411424525],
            [12.497493391340077, -5.326749849464702],
            [12.487875072892967, -5.32146519154475],
            [12.482359127355442, -5.321627601506459],
            [12.477814436133954, -5.318743357483015],
            [12.476179477337958, -5.3131351440745265],
            [12.470761026716925, -5.312361332518975],
            [12.46707294275325, -5.313411179891411],
            [12.465628585927364, -5.309520056701973],
            [12.457182204522184, -5.306521561160107],
            [12.455414073777835, -5.310454139257624],
            [12.451793939786743, -5.3112043190511375],
            [12.444887349496979, -5.30935987630234],
            [12.445195709433198, -5.306043693904277],
            [12.441690815521888, -5.301267059032836],
            [12.43811909512255, -5.304735959439697],
            [12.434477857575253, -5.303595579152995],
            [12.432599845586246, -5.298284742271856],
            [12.429218159380424, -5.299665376149291],
            [12.424995242509969, -5.296687151086301],
            [12.418411632217179, -5.295421752339472],
            [12.413844517738536, -5.299148344967926],
            [12.400761459898122, -5.28790333766942],
            [12.400009403171065, -5.285513084732949],
            [12.394506482938548, -5.281907149115572],
            [12.38956441653484, -5.2841475184305535],
            [12.378562839423383, -5.27813254851941],
            [12.373339048389058, -5.274600706672965],
            [12.371149851153284, -5.2706146581483],
            [12.371382323689025, -5.265506223256587],
            [12.364091524881394, -5.264492108049884],
            [12.356044382427246, -5.256864703152368],
            [12.351437897458345, -5.25474478594904],
            [12.346161280298523, -5.254433053287727],
            [12.342596648592762, -5.252275572754445],
            [12.338992652315277, -5.247799316327463],
            [12.335644030239903, -5.249681847077309],
            [12.331304347130533, -5.247654481463796],
            [12.325010355402627, -5.242656739649108],
            [12.325357597473632, -5.2386331354067535],
            [12.31486259675606, -5.230694585520259],
            [12.31226579576969, -5.233390311057052],
            [12.308564316708168, -5.230487211011773],
            [12.310929774054248, -5.22841779775738],
            [12.306506452079143, -5.223941399165482],
            [12.307378925293571, -5.218644776759314],
            [12.304377831389262, -5.216354627200324],
            [12.301336625919566, -5.216958221596191],
            [12.298641657204048, -5.214081109901241],
            [12.29593632116126, -5.216100897148516],
            [12.291223787535385, -5.215850313483099],
            [12.283942188379585, -5.212502522573545],
            [12.278011250934933, -5.211028589954613],
            [12.272719991519008, -5.216166951797259],
            [12.268738148134151, -5.216251508208725],
            [12.266858073803192, -5.213795631495888],
            [12.262337072646623, -5.2137497566365125],
            [12.260501658548412, -5.2104362650866385],
            [12.257370174679686, -5.210381161969721],
            [12.252505327177714, -5.207749610608078],
            [12.248515643099765, -5.202618121697706],
            [12.248010653704663, -5.194169988350565],
            [12.245646330693807, -5.187739244054214],
            [12.261630493179767, -5.107856053722529],
            [12.27666964807532, -5.0345726920431835],
            [12.281416137318919, -5.012756418665739],
            [12.281673141095684, -5.00998225758554],
            [12.294454049373895, -4.949120713587623]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.61198398436372, "lat": 32.75053978405077 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13251"],
        "coty_name": ["Screven"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Screven County"],
        "coty_fp_code": "251",
        "coty_gnis_code": "00350204"
      },
      "bbox": [
        12.245646330693807, -5.337734638030256, 12.654831952944116,
        -4.785833283313016
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.582454025354872, -7.031805324749844],
            [10.611322815741781, -7.028584337270415],
            [10.678265183269852, -7.02047961787592],
            [10.682563570204797, -7.055774826313094],
            [10.700328428277395, -7.053900999798683],
            [10.755123688720621, -7.047682153065951],
            [10.85926937191626, -7.036186021042476],
            [10.860619926749978, -7.048791597784193],
            [10.873279984462833, -7.0473259546487315],
            [10.871921706569825, -7.034795573800752],
            [10.909868128380056, -7.030744099129682],
            [10.917220996706567, -7.097154461105225],
            [10.924727830355636, -7.166802001796823],
            [10.930821297615593, -7.217500769837189],
            [10.934241081590699, -7.247909193808343],
            [10.939188219493166, -7.275529702076058],
            [10.945589276686464, -7.32280873945049],
            [10.942834015249044, -7.3231240945365315],
            [10.952365150774343, -7.405757108674071],
            [10.895061351690357, -7.409613866850719],
            [10.886158963500073, -7.4100181714368505],
            [10.83516953922286, -7.413315006911473],
            [10.726159123816904, -7.4207945629824845],
            [10.692569422907969, -7.422909056292304],
            [10.660742266332962, -7.425274359898971],
            [10.65486639881381, -7.373768441033256],
            [10.643642584807587, -7.270161364330675],
            [10.642509774102841, -7.2581787673398495],
            [10.639471819763305, -7.2495239995861285],
            [10.6443663811582, -7.242224024485358],
            [10.646125936626373, -7.236845984489724],
            [10.642682023230725, -7.231017965048516],
            [10.638399051828987, -7.227815550327287],
            [10.63824198476266, -7.224163145847434],
            [10.641057568291453, -7.21688980502317],
            [10.640040431869485, -7.211304128972485],
            [10.63794916370355, -7.208856165256154],
            [10.63892194265571, -7.20445940782564],
            [10.637867780303296, -7.191465815282563],
            [10.636446181520114, -7.18798110709353],
            [10.630849328048713, -7.185033628283911],
            [10.62334687618378, -7.175622382618823],
            [10.615621864145151, -7.169885835389432],
            [10.608845820916482, -7.15904928139453],
            [10.605438219139355, -7.156248962454992],
            [10.602470878876975, -7.1494476972252965],
            [10.59816717280985, -7.142004420522227],
            [10.59466595776527, -7.13944996011979],
            [10.595706197602896, -7.1353370575543105],
            [10.592542768110734, -7.127882360337964],
            [10.587179158793033, -7.084384603716655],
            [10.582454025354872, -7.031805324749844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.91932017338327,
          "lat": 30.863746716026267
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13275"],
        "coty_name": ["Thomas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Thomas County"],
        "coty_fp_code": "275",
        "coty_gnis_code": "00343835"
      },
      "bbox": [
        10.582454025354872, -7.425274359898971, 10.952365150774343,
        -7.02047961787592
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.54492370768861, 5.32059869403157],
            [-12.481944436497546, 5.308115865133776],
            [-12.426509272043225, 5.297436523369626],
            [-12.424698562886151, 5.297322875277603],
            [-12.408721855319497, 5.381276176320159],
            [-12.373087737499276, 5.374486026597427],
            [-12.36648641070261, 5.409068987621984],
            [-12.308290133440863, 5.718838290045352],
            [-12.20108005933843, 5.69894791675523],
            [-12.093874645933369, 5.679031963542222],
            [-12.094272043709633, 5.676422544089769],
            [-12.157600633646737, 5.333805614690124],
            [-12.19988914964111, 5.341653393198129],
            [-12.22289806354222, 5.219145702913421],
            [-12.232978228826326, 5.164525492862432],
            [-12.241461414302433, 5.165343705644214],
            [-12.247646903095022, 5.171567115981926],
            [-12.257960688088724, 5.171570051032009],
            [-12.26203808351776, 5.16944420234344],
            [-12.274084829857408, 5.166186079929456],
            [-12.285157681298504, 5.164083025983475],
            [-12.296375132226546, 5.163498848953757],
            [-12.311432989718893, 5.154860257837127],
            [-12.315780407149028, 5.14997331368445],
            [-12.320510237130351, 5.1405126713035445],
            [-12.321841580790208, 5.135981127211752],
            [-12.325585225383128, 5.130375971187671],
            [-12.330319430819547, 5.125457194026761],
            [-12.33560480553209, 5.12248590525669],
            [-12.339094199781833, 5.118347664326531],
            [-12.343441838746147, 5.110579448836657],
            [-12.355487436962726, 5.102874171527038],
            [-12.362956184293319, 5.0938496224434235],
            [-12.366289435384251, 5.084828192538932],
            [-12.373590035596123, 5.07663096689572],
            [-12.37953319253568, 5.065515954183189],
            [-12.388450343317977, 5.057663331889188],
            [-12.400180687942704, 5.054630472909758],
            [-12.40409276252094, 5.052447222653036],
            [-12.417020751968412, 5.050195121944399],
            [-12.423916625923358, 5.047005645623345],
            [-12.434729139150429, 5.048675628767602],
            [-12.438365359386314, 5.051364341653317],
            [-12.44625532615264, 5.053404294553946],
            [-12.452188412796435, 5.056055424105532],
            [-12.460219261525632, 5.064205924329432],
            [-12.463799131863944, 5.069689029582842],
            [-12.46325446770744, 5.074388379681755],
            [-12.465104791698451, 5.083332641934262],
            [-12.473868773159843, 5.0943847053478155],
            [-12.482125191550839, 5.095613205302294],
            [-12.493618449839548, 5.092024309607828],
            [-12.499695160982137, 5.08735657520641],
            [-12.507333039461734, 5.085827618378799],
            [-12.514430025446353, 5.080742420601077],
            [-12.519887963395792, 5.081241999676591],
            [-12.526580334147406, 5.086409949550861],
            [-12.531918386477953, 5.088848935378233],
            [-12.534693239883605, 5.09338430575004],
            [-12.54002924318796, 5.097668395593807],
            [-12.54695227497888, 5.101357999763801],
            [-12.555487912800045, 5.102628958325054],
            [-12.566516183401058, 5.09953657333461],
            [-12.574758717771497, 5.0956908227754205],
            [-12.579501775436897, 5.096183948058859],
            [-12.584489031606452, 5.094201229502602],
            [-12.588366079624063, 5.094453751223214],
            [-12.573313254951191, 5.173834938384178],
            [-12.547636213008028, 5.306829499615123],
            [-12.54492370768861, 5.32059869403157]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.63745551853617,
          "lat": 42.85431066105233
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16067"],
        "coty_name": ["Minidoka"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Minidoka County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00394807"
      },
      "bbox": [
        -12.588366079624063, 5.047005645623345, -12.093874645933369,
        5.718838290045352
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.30751225241486, 5.6199749148741045],
            [-13.304572371091291, 5.6199835454396485],
            [-13.297943870212093, 5.624056662052623],
            [-13.29101477621032, 5.622926475930963],
            [-13.286451216900794, 5.619546451437008],
            [-13.278452419695522, 5.620556780510349],
            [-13.266736975528609, 5.61367991687524],
            [-13.259534408701176, 5.6135865991937175],
            [-13.251622882913924, 5.611831869054133],
            [-13.249982085707739, 5.609178599648893],
            [-13.249605463744109, 5.6014266581992755],
            [-13.245850945205458, 5.597203598440285],
            [-13.243288110946787, 5.590940031199547],
            [-13.238719015276875, 5.582972352010388],
            [-13.24027978524949, 5.5799497011245895],
            [-13.233719752226298, 5.573546112258337],
            [-13.229021458910438, 5.573140811329776],
            [-13.229974811531987, 5.569761069525163],
            [-13.228725168223576, 5.564231508628144],
            [-13.224873088723143, 5.560615248071293],
            [-13.223407299166512, 5.553377781043246],
            [-13.220824328147321, 5.5486439139091965],
            [-13.224989046617614, 5.533775312340116],
            [-13.232298212256477, 5.524759100408649],
            [-13.233543165612884, 5.520056415148406],
            [-13.236435379715783, 5.518307203622493],
            [-13.245689687446951, 5.517127919334116],
            [-13.253819431445871, 5.510131292435016],
            [-13.254917620786841, 5.507314176339497],
            [-13.25266180505681, 5.500721792758066],
            [-13.258707538049345, 5.4939537861745285],
            [-13.262295227390451, 5.487824598354608],
            [-13.264618190740158, 5.472724902155377],
            [-13.262023976361723, 5.462763825644935],
            [-13.256890745832022, 5.461361555225084],
            [-13.25398920007786, 5.465329896075514],
            [-13.248320473656877, 5.464889249612906],
            [-13.243113682997638, 5.462557924210198],
            [-13.234134269141498, 5.45524523316834],
            [-13.231680661316675, 5.454796130570101],
            [-13.223484929431027, 5.44475434846699],
            [-13.217717729904178, 5.443809523478873],
            [-13.210093317016224, 5.440467790948462],
            [-13.205956786898042, 5.433949184078098],
            [-13.204152081989648, 5.423247268665712],
            [-13.204758319053314, 5.4169409610299075],
            [-13.207634794714787, 5.4126036254818475],
            [-13.211120141457712, 5.401653657350774],
            [-13.213045103729492, 5.39852747011206],
            [-13.203024556476821, 5.390196415228011],
            [-13.199380139674714, 5.391057562432053],
            [-13.196503738389811, 5.385378780270508],
            [-13.197638356983322, 5.37484158061507],
            [-13.200881076189606, 5.3679445474449565],
            [-13.199942803642076, 5.362040757013143],
            [-13.201062837110518, 5.358251320509027],
            [-13.199950981562754, 5.3510355788614925],
            [-13.19714397695948, 5.349659559869413],
            [-13.195414053534053, 5.344682642304304],
            [-13.192221919314136, 5.342434051089661],
            [-13.186418858383224, 5.344508469300257],
            [-13.1756158594088, 5.341911189667262],
            [-13.17071856895225, 5.339696659773606],
            [-13.161331205225784, 5.343472819406061],
            [-13.153580528213384, 5.344686730857437],
            [-13.146052564379008, 5.3439659456882564],
            [-13.138028892160616, 5.338584165096713],
            [-13.132061788868832, 5.337704449272602],
            [-13.124059060418485, 5.332040633364705],
            [-13.117532071516516, 5.3330103306529635],
            [-13.114458939146736, 5.329154009130152],
            [-13.110119249807113, 5.327305103822622],
            [-13.102282121024528, 5.320988590255112],
            [-13.090997169600778, 5.320996299579022],
            [-13.081170044315206, 5.318427226844528],
            [-13.071392452957392, 5.311361970746128],
            [-13.06767231850281, 5.305887960285814],
            [-13.058126224755522, 5.301970683852848],
            [-13.054761031428685, 5.299365271843646],
            [-13.05135245392578, 5.294297082030101],
            [-13.046044180821223, 5.290854031410313],
            [-13.04190963731563, 5.290353760285616],
            [-13.032473221377565, 5.285782961049255],
            [-13.028641789456119, 5.285242182212329],
            [-13.023263692890257, 5.280201228522773],
            [-13.015118148506216, 5.280441541186496],
            [-13.008820919405446, 5.278310418097881],
            [-13.006349773232815, 5.275571186538523],
            [-12.99283988099105, 5.270451274387374],
            [-12.989615874983171, 5.266305579343415],
            [-12.986273954202716, 5.264736045355285],
            [-12.98830810251795, 5.260559271700742],
            [-12.987103520735651, 5.2585425519565785],
            [-12.9734813247223, 5.2452389603227285],
            [-12.969665287274475, 5.243591700140049],
            [-12.962449015492629, 5.236913219937862],
            [-12.959638037469519, 5.2319085769849005],
            [-12.953902567458698, 5.2319236653354],
            [-12.948032395308127, 5.230628124718487],
            [-12.942502003812852, 5.224667214613436],
            [-12.931915178263344, 5.226547467553347],
            [-12.92324781871467, 5.223473688144135],
            [-12.919511725328285, 5.220346059042024],
            [-12.915112021720525, 5.2188720527364065],
            [-12.90805335562474, 5.22158991831694],
            [-12.905079875048337, 5.221430357186925],
            [-12.894977836385749, 5.217696510815038],
            [-12.89036876078464, 5.211836512451226],
            [-12.879567747162623, 5.205249853147725],
            [-12.875585519422232, 5.200573013017001],
            [-12.871122474827203, 5.193202174515875],
            [-12.869540307549185, 5.186637060854831],
            [-12.864364507078962, 5.1855549140127515],
            [-12.853698269359638, 5.181730692325248],
            [-12.851314751952943, 5.182266280325234],
            [-12.846217669265554, 5.175669780946572],
            [-12.841061419664275, 5.173174071671576],
            [-12.838777980727748, 5.169675972788345],
            [-12.829359186693024, 5.169146879925277],
            [-12.825110123714579, 5.165916625337907],
            [-12.817526783628368, 5.1650537529875455],
            [-12.808733051944646, 5.1612354701883145],
            [-12.8038458278851, 5.158263007108704],
            [-12.798717723607423, 5.151250293508841],
            [-12.792399830568915, 5.1466176819772755],
            [-12.78661842901162, 5.14395572374205],
            [-12.778578443166694, 5.138064871941205],
            [-12.767008079923306, 5.125696142115545],
            [-12.76513014611604, 5.1202700494978],
            [-12.765157366193824, 5.109368237194924],
            [-12.763524929967069, 5.104773537535172],
            [-12.758276063996995, 5.099498310536523],
            [-12.756601210035168, 5.093499917724939],
            [-12.752390598210843, 5.087650314256662],
            [-12.743094726091833, 5.086193802476323],
            [-12.73883576441264, 5.082060352214364],
            [-12.734706256163179, 5.082515842676765],
            [-12.725098268752248, 5.091379558751306],
            [-12.711422281915347, 5.0902790511624],
            [-12.697667462040773, 5.095551386511556],
            [-12.695326530885389, 5.095163729365712],
            [-12.687902960544612, 5.100816759841023],
            [-12.683313783436573, 5.10042531508973],
            [-12.67816890252368, 5.102777660487994],
            [-12.669173121389047, 5.103259154799593],
            [-12.66312114246664, 5.100228193033842],
            [-12.660326345852706, 5.0969091816434675],
            [-12.656052014720274, 5.096885986940035],
            [-12.651180828611842, 5.099152654263271],
            [-12.648812824872461, 5.096186251081544],
            [-12.639373597923592, 5.095121280687369],
            [-12.640369863938696, 5.0896693612870845],
            [-12.651238241805938, 5.089381457668114],
            [-12.684465765119535, 5.093026983495375],
            [-12.689597577232187, 5.092561836770962],
            [-12.691634316712108, 5.082288756302905],
            [-12.693185156861514, 5.081740755536311],
            [-12.698752377588933, 5.0540363913156865],
            [-12.709611246154248, 4.997029791754702],
            [-12.825007876828778, 5.019469850676122],
            [-12.86531609014775, 5.027275353629826],
            [-12.873824448872544, 4.985248067397031],
            [-12.882891463050052, 4.942000537726463],
            [-12.878982506424778, 4.941608782624671],
            [-12.895735324737599, 4.856213278997649],
            [-12.915803839903527, 4.753672749560152],
            [-12.944129556663693, 4.610086793351392],
            [-13.078423007116074, 4.637599808644719],
            [-13.100808403934991, 4.641080671273838],
            [-13.173224431979156, 4.655258112380211],
            [-13.261114564614005, 4.676487713777388],
            [-13.32239080314261, 4.692379548193095],
            [-13.340178504676063, 4.6963304660604095],
            [-13.372762727629704, 4.701949054267855],
            [-13.389921050680053, 4.703949126884722],
            [-13.400754365568384, 4.706125686000769],
            [-13.486584581317997, 4.719437143031464],
            [-13.491193354153205, 4.720373952144766],
            [-13.449653123528124, 4.92329730600756],
            [-13.440957398643542, 4.965754188856554],
            [-13.373925640373862, 5.293373729186312],
            [-13.364090381858519, 5.342227112466335],
            [-13.353299357139989, 5.39481551920063],
            [-13.336166466501515, 5.479221349754824],
            [-13.311071220286719, 5.602977642336476],
            [-13.30751225241486, 5.6199749148741045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.66715608563806,
          "lat": 42.35595467364183
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16083"],
        "coty_name": ["Twin Falls"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Twin Falls County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00399334"
      },
      "bbox": [
        -13.491193354153205, 4.610086793351392, -12.639373597923592,
        5.624056662052623
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.200020049948706, 1.1864396702291464],
            [6.320168908301381, 1.1962941453105276],
            [6.371097203361366, 1.200970332359181],
            [6.45279698777371, 1.2074182446486046],
            [6.4822893815666776, 1.2098593512884386],
            [6.510543703058368, 1.2128347906846708],
            [6.50851512580342, 1.2416815448318717],
            [6.536450069915776, 1.2443831749389187],
            [6.536161080488057, 1.247673341368866],
            [6.581563909917282, 1.2525530471774646],
            [6.590399152121908, 1.164389363608866],
            [6.598376892782941, 1.090980695669981],
            [6.603704379843628, 1.0471428707185297],
            [6.562785336140167, 1.0431597589565877],
            [6.566879735006167, 0.9993300311791669],
            [6.572802795272527, 0.9408680622711664],
            [6.561936040752741, 0.9385121643110036],
            [6.504179930961086, 0.9325823146069826],
            [6.475294932697113, 0.9299294706922896],
            [6.475334291488771, 0.9294546770588827],
            [6.446190802272862, 0.9263353389575696],
            [6.421574426984188, 0.9240673896129805],
            [6.392725266092319, 0.9218851281413466],
            [6.378610309442454, 0.9202387203502485],
            [6.307750276417933, 0.9141377669619623],
            [6.251096431462053, 0.9098538752026317],
            [6.23664978327043, 0.9079405613781848],
            [6.223098335836714, 0.9077516719727027],
            [6.218821178364892, 0.9662542681736461],
            [6.217552370191354, 0.9807457201678154],
            [6.207783682609496, 1.0959504183682531],
            [6.200020049948706, 1.1864396702291464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.22175386935237, "lat": 39.52028561629779 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17029"],
        "coty_name": ["Coles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coles County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00424216"
      },
      "bbox": [
        6.200020049948706, 0.9077516719727027, 6.603704379843628,
        1.2525530471774646
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.41530775087412, -0.5626608555717789],
            [6.415257054946406, -0.5619426357250183],
            [6.432969924216112, -0.5600007392416719],
            [6.487360853265524, -0.5556917131185014],
            [6.553691408204008, -0.5510854333511546],
            [6.574724025489987, -0.5497945842622755],
            [6.6010633825919, -0.5473729073725642],
            [6.600455514320481, -0.5391643271343174],
            [6.611677128704472, -0.5456337461434477],
            [6.618569144555849, -0.5476295224593287],
            [6.6280015650227, -0.5550327823737969],
            [6.6298070805432365, -0.5589912341218599],
            [6.635940796335315, -0.5607397514608246],
            [6.643103665948306, -0.5663829011069124],
            [6.64820800589513, -0.5725065880036482],
            [6.657769855016667, -0.5930949831819523],
            [6.660902741124017, -0.597736247184026],
            [6.665648860617376, -0.6018380280759306],
            [6.674712674680776, -0.6050263685634032],
            [6.68657497408993, -0.6069885942301416],
            [6.690824927487557, -0.6100078390582908],
            [6.69311273856926, -0.6157850176178553],
            [6.691424787604934, -0.6215863845692491],
            [6.688289683502414, -0.6246121835524614],
            [6.680097180356108, -0.6281960834208508],
            [6.6689316311088565, -0.6281957561408453],
            [6.662504868381778, -0.6263068858680236],
            [6.6539554930450295, -0.6215550136804213],
            [6.650449231024663, -0.6211760954902062],
            [6.646778244034074, -0.6230166687801351],
            [6.642618230855873, -0.6307403516602281],
            [6.644476409015915, -0.6359931977369485],
            [6.656126452282315, -0.6473177090688018],
            [6.663242664647507, -0.6508417731553023],
            [6.669469899613702, -0.6496862895446355],
            [6.6797297937168105, -0.6418012161610889],
            [6.685921658012764, -0.6395234714480178],
            [6.689612878151587, -0.6404436075761645],
            [6.6936528066577425, -0.6450896313852619],
            [6.6943006719984055, -0.6496011995450596],
            [6.691105719904548, -0.6527708560129695],
            [6.688838719189655, -0.6574644677711436],
            [6.687187476707629, -0.6653144215500857],
            [6.686579180181391, -0.6777531547036341],
            [6.6856495509121, -0.6828591787022412],
            [6.681024133066824, -0.6964625405280545],
            [6.674464667629185, -0.7086345009336472],
            [6.671510058842154, -0.7128974491641139],
            [6.665143393086063, -0.7188600826239555],
            [6.658060683192248, -0.722387231071564],
            [6.647865935686366, -0.7305168831148713],
            [6.643549382196316, -0.7361139508085062],
            [6.631547288580234, -0.7426376530706201],
            [6.626361522425347, -0.7486300042103743],
            [6.6214866219254915, -0.7591180368546031],
            [6.620442078432018, -0.7649231734199518],
            [6.612475567865396, -0.7746089496828577],
            [6.60824775979028, -0.7825497104207721],
            [6.604001292794047, -0.7935960186880456],
            [6.603032688922826, -0.8007175906862916],
            [6.604948320154998, -0.8091660237827737],
            [6.605917561341001, -0.8183552774119961],
            [6.60772143797398, -0.8254471443747773],
            [6.611784670619886, -0.8352162480461296],
            [6.622005745068072, -0.8546148460449728],
            [6.6223768062809345, -0.8651341086527785],
            [6.624229773008484, -0.8722904784990639],
            [6.630198018507552, -0.8825158756022808],
            [6.623654414096021, -0.8826793862836371],
            [6.620588299750775, -0.8847782876625161],
            [6.615875976583777, -0.8845361515784101],
            [6.611434824451808, -0.881153884619951],
            [6.606813509762393, -0.871452158595497],
            [6.602564555075918, -0.8665125846651806],
            [6.592425027716978, -0.860724455708969],
            [6.5075090997515606, -0.8678273150414777],
            [6.439534654150255, -0.8728010164837753],
            [6.43877513699556, -0.8581965250318594],
            [6.435646385596001, -0.8128301885356175],
            [6.4311063322563715, -0.7497854855296806],
            [6.425208197291841, -0.6802612018205426],
            [6.417684594146441, -0.5917525416222752],
            [6.41530775087412, -0.5626608555717789]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.23046622189108, "lat": 37.76280581170167 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17059"],
        "coty_name": ["Gallatin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gallatin County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00424231"
      },
      "bbox": [
        6.415257054946406, -0.8847782876625161, 6.6943006719984055,
        -0.5391643271343174
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.323682832815014, 0.7098209036101467],
            [6.428612623170452, 0.7186149902774646],
            [6.471356448405867, 0.7223411501023222],
            [6.53937060030866, 0.7291137860953834],
            [6.59351177850905, 0.734901627471451],
            [6.637334422036181, 0.7395779543943728],
            [6.640422469097343, 0.7087639592280801],
            [6.64681302667516, 0.6481312516905097],
            [6.647878025934198, 0.6482470238827723],
            [6.653205673113185, 0.5887976702773863],
            [6.659395316140262, 0.5243463288596873],
            [6.664168870733409, 0.4722796710019138],
            [6.668501807175463, 0.4131957344733936],
            [6.632511914303962, 0.40972405981934085],
            [6.599393220920881, 0.4070362186547097],
            [6.568710831697785, 0.4036207205636974],
            [6.511705163390431, 0.3968096074860752],
            [6.428388288348009, 0.3905441968958782],
            [6.414022994325088, 0.38999699804728144],
            [6.34869338113405, 0.38873692201832777],
            [6.343943462475875, 0.4478366550425168],
            [6.335824225435322, 0.5387303334779479],
            [6.331478035876443, 0.6114831454818526],
            [6.330383726298617, 0.6280743271701278],
            [6.323682832815014, 0.7098209036101467]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.15381922747582,
          "lat": 39.010069178106924
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17079"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00424241"
      },
      "bbox": [
        6.323682832815014, 0.38873692201832777, 6.668501807175463,
        0.7395779543943728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.966877469787755, 0.43946151034398423],
            [5.022356584518048, 0.44205023854802555],
            [5.063067886173921, 0.44502007246995673],
            [5.109550885345249, 0.44778590701240895],
            [5.1351533135564065, 0.44949031998330785],
            [5.222761920452452, 0.45470737658030413],
            [5.267179158735919, 0.45804840744002223],
            [5.310592462716562, 0.46114252182590554],
            [5.356118354420993, 0.4643312890364155],
            [5.35740028756276, 0.45024777295944846],
            [5.362598133961109, 0.38302725912281677],
            [5.3663879006778785, 0.33868155055298993],
            [5.395051657936326, 0.34086407422280907],
            [5.398403026536007, 0.29656223087903444],
            [5.405723341068689, 0.20871561627100008],
            [5.413367771607291, 0.12089353705832331],
            [5.32712405912555, 0.11418367745333202],
            [5.285508168276346, 0.11171126751599922],
            [5.240679475768666, 0.1093203811817959],
            [5.167597825285843, 0.10626792636634977],
            [5.134301844616889, 0.10470795186269591],
            [5.056263797536799, 0.10032409417491639],
            [5.028982285106468, 0.09959146567038472],
            [4.986914917316127, 0.09769684556409315],
            [4.960746648213467, 0.09591029045367774],
            [4.955851329370354, 0.11046899686671123],
            [4.9482712230345705, 0.12295394723375183],
            [4.942506849814574, 0.12857022101866494],
            [4.936534286928691, 0.13761365901817463],
            [4.933821169727993, 0.1465526582994354],
            [4.933517289453165, 0.15280607706644747],
            [4.9345619039731075, 0.16106376745499001],
            [4.937811214214495, 0.1674328205027167],
            [4.947864621707431, 0.1789716097814435],
            [4.9537147121427925, 0.1832751167300968],
            [4.958718610621813, 0.1912701897807435],
            [4.959284970076758, 0.19717230670260663],
            [4.965011595353256, 0.2096840630645059],
            [4.979759798064346, 0.22149670931730378],
            [4.997009774857012, 0.2377359900114704],
            [5.000688988310945, 0.24575348183293866],
            [5.002418804368142, 0.25526891949170527],
            [5.005330990549738, 0.2781101462505074],
            [5.0047185140606905, 0.28424307822299866],
            [5.001340646360758, 0.2898584724600936],
            [4.970839168100457, 0.30602217787618635],
            [4.95880046762667, 0.3145879845452957],
            [4.942487042776085, 0.3223878814050751],
            [4.9340924508854105, 0.3245043401032164],
            [4.921064077954075, 0.3366629396534431],
            [4.9133129842175824, 0.3432058369048803],
            [4.907488464929841, 0.34636261219718045],
            [4.898501835967675, 0.34983066015171166],
            [4.8916532513135484, 0.3539835238063035],
            [4.88637869966915, 0.35509956395776376],
            [4.881943891232123, 0.3544075863140089],
            [4.871815821578611, 0.3569357004064936],
            [4.8685708071710225, 0.4331953795029944],
            [4.949267504008198, 0.43812072277563874],
            [4.966877469787755, 0.43946151034398423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.90495080386918,
          "lat": 38.829742107713805
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17119"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00424258"
      },
      "bbox": [
        4.8685708071710225, 0.09591029045367774, 5.413367771607291,
        0.4643312890364155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.1790219469595025, -0.8938257779543172],
            [6.264796927989404, -0.8868431839766725],
            [6.301280980747729, -0.8839927756476256],
            [6.3528817371798665, -0.8794595285416325],
            [6.4103893802364516, -0.8751077211905447],
            [6.41117171162839, -0.8845118629159051],
            [6.416505820141355, -0.963973575676671],
            [6.417609449050382, -0.9781831136324849],
            [6.422417804122918, -1.052214351788876],
            [6.422560454244739, -1.0525350585150655],
            [6.414484165505834, -1.0572844799074927],
            [6.404258678981625, -1.0611640054182476],
            [6.391825984308174, -1.0701894563366667],
            [6.381649294245235, -1.0833813839549267],
            [6.3774039046515085, -1.093218050037438],
            [6.376833045047719, -1.105237246436899],
            [6.3748493809541, -1.1159646396438856],
            [6.375231756263302, -1.1257580177189221],
            [6.374522283237774, -1.1352388327569407],
            [6.373051431137725, -1.1414449375985543],
            [6.364094884320428, -1.164204683372502],
            [6.361337851785392, -1.1745131873811692],
            [6.357046000833377, -1.184301599067041],
            [6.355163250706971, -1.1921253528013185],
            [6.354707931346398, -1.1991538493136293],
            [6.360543711725797, -1.2094732496476184],
            [6.363157823293383, -1.2160942925228158],
            [6.361642991095849, -1.2207972904194344],
            [6.369042367391141, -1.2288720899975276],
            [6.3760475931743255, -1.2335171107132135],
            [6.382475612527796, -1.240776435182271],
            [6.3874947398994975, -1.2516883195670905],
            [6.394520231619532, -1.2607019459572746],
            [6.405262083329074, -1.2665517443412664],
            [6.412158262128547, -1.2725756095182688],
            [6.414711874142131, -1.275936019423834],
            [6.422936876716635, -1.2973443218559277],
            [6.424449260208571, -1.2989787617868016],
            [6.430982136063334, -1.318416736144753],
            [6.437189061070967, -1.3258911015388575],
            [6.437098723118502, -1.3284573539988014],
            [6.431173942102903, -1.3527044855052193],
            [6.425600007771073, -1.3705985922704016],
            [6.427792231300037, -1.3719985974839555],
            [6.425413409275326, -1.3794030885604676],
            [6.425749798729578, -1.3846986587271783],
            [6.422730083619583, -1.3926835752999784],
            [6.414963487524756, -1.406779009037305],
            [6.398513100660043, -1.4151016204796991],
            [6.391909678970133, -1.4147338917755383],
            [6.391978128375223, -1.4120721460547105],
            [6.384752929117004, -1.3229370629249124],
            [6.351961719292022, -1.2956669009288637],
            [6.323963848993859, -1.2712464074169183],
            [6.289751081693766, -1.2409625406148064],
            [6.266322620097002, -1.2195604157488804],
            [6.228366019526238, -1.1842605181949404],
            [6.197576161380279, -1.1576811258744284],
            [6.1943273295512205, -1.1135220816983635],
            [6.190574472556914, -1.065464840919956],
            [6.184918853346672, -0.981628944877177],
            [6.1790219469595025, -0.8938257779543172]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.56152946948654, "lat": 37.41268223623286 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17151"],
        "coty_name": ["Pope"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pope County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00424277"
      },
      "bbox": [
        6.1790219469595025, -1.4151016204796991, 6.437189061070967,
        -0.8751077211905447
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.372133559028692, 0.8630240708879438],
            [8.41594588679619, 0.8686902063037865],
            [8.419282318705289, 0.8687419500055578],
            [8.45811485877084, 0.8739472978068542],
            [8.463927549608995, 0.8750132001797449],
            [8.471334032512125, 0.8810175643438035],
            [8.512042127964719, 0.9150706731026356],
            [8.53873284472022, 0.9366804816260974],
            [8.553311481294944, 0.9487637408912175],
            [8.556341549727787, 0.9146822431130466],
            [8.56393194978064, 0.8410186431467085],
            [8.563241986178648, 0.8409142659117239],
            [8.565962636995927, 0.8114462092831881],
            [8.57205322211414, 0.7530502721575738],
            [8.571613952779243, 0.7527737451617644],
            [8.581240243737351, 0.6647971739774563],
            [8.509862664970882, 0.6560802025391782],
            [8.513716959530534, 0.6266050284473871],
            [8.485855807296952, 0.6234072304854196],
            [8.489074855857977, 0.59439367277845],
            [8.460535112577011, 0.5912804619143218],
            [8.464096773347517, 0.5616855091332568],
            [8.450109583177078, 0.5600421581240407],
            [8.450824347471308, 0.5534615424042126],
            [8.443498818157627, 0.5526736229205662],
            [8.442747013819575, 0.5592796398297958],
            [8.407782976021656, 0.5551475550325159],
            [8.408884748489466, 0.5466682237172232],
            [8.403303846446757, 0.5466229768990303],
            [8.391705654859917, 0.5482422937181428],
            [8.39075538592557, 0.5538334923260562],
            [8.385376030094186, 0.5573619898075103],
            [8.38061414989297, 0.5545880860894633],
            [8.377868306960128, 0.5510350106218184],
            [8.370959945488602, 0.5584913327606008],
            [8.368410386895231, 0.5559318405484373],
            [8.371815277954315, 0.5519798031209514],
            [8.367618163845245, 0.5473618529521487],
            [8.36292310341013, 0.5450138698068908],
            [8.35932030223691, 0.5482522638141365],
            [8.35663695284978, 0.5458392258070176],
            [8.35139619390232, 0.5439051895920887],
            [8.352649798404991, 0.5402741200389747],
            [8.349101930868333, 0.5384290104928166],
            [8.34418769602572, 0.5393642296018468],
            [8.343873827347405, 0.5351005835222135],
            [8.341371529837652, 0.5334602775295625],
            [8.338591809123146, 0.5365082814668132],
            [8.335810697078864, 0.5359764739065497],
            [8.334013145486919, 0.5305311655227504],
            [8.324184186011099, 0.5294681039952206],
            [8.322422651412536, 0.5454868002751184],
            [8.313179216372388, 0.6246907501851634],
            [8.307240612413338, 0.6748956126951974],
            [8.293306012114508, 0.7912007905511921],
            [8.285990769882458, 0.8517004922949326],
            [8.314514917639267, 0.8551464313511666],
            [8.329012417427816, 0.8577805290657786],
            [8.372133559028692, 0.8630240708879438]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.6280320038508, "lat": 38.996940281323056 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18079"],
        "coty_name": ["Jennings"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jennings County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00450364"
      },
      "bbox": [
        8.285990769882458, 0.5294681039952206, 8.581240243737351,
        0.9487637408912175
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.692188068904631, -0.21288323299929368],
            [6.8353665027244, -0.20243584722144672],
            [6.837290615322132, -0.22926709890694377],
            [6.866052449697208, -0.22718018584277982],
            [6.923791530031845, -0.2226900630543307],
            [6.926536467949291, -0.25547721325158596],
            [6.9299693040884565, -0.2994832849040614],
            [6.923860210568546, -0.29988377932796983],
            [6.932992565984753, -0.41806451096585795],
            [6.938888469453075, -0.4967981389694819],
            [6.940803683473842, -0.5285884205219806],
            [6.93338736636914, -0.533149288247311],
            [6.923459550317002, -0.5358817148922604],
            [6.911947150359931, -0.5342098753474191],
            [6.893245960749851, -0.5398499659951727],
            [6.879386222890274, -0.553138633906883],
            [6.875939526339479, -0.5557269520295033],
            [6.8692154525311375, -0.5576095466149003],
            [6.859596469771708, -0.5584808513161061],
            [6.842179508968669, -0.5587766282479035],
            [6.834778384000862, -0.5556173990058015],
            [6.828196502410068, -0.5482570006700613],
            [6.8276811685291605, -0.5426844514178503],
            [6.818693258078115, -0.5362457619225517],
            [6.814493010874821, -0.5276612389952431],
            [6.810548956784498, -0.5222268041710041],
            [6.805028821255511, -0.5167935376202228],
            [6.796186377081122, -0.5122413452184229],
            [6.788919515867872, -0.5111482655419443],
            [6.784603975670086, -0.5119387517500629],
            [6.779593742973882, -0.5150239905880637],
            [6.7678553819387535, -0.533260886657625],
            [6.764220125655987, -0.5398343748431876],
            [6.756377299908676, -0.5515502475068856],
            [6.755318296103508, -0.5548143151074817],
            [6.7553040653394465, -0.5634316256045413],
            [6.759998012863342, -0.5744142819402451],
            [6.767740515486988, -0.5831073546656983],
            [6.778188947696016, -0.5914302329761718],
            [6.7823177573276725, -0.5973634217061766],
            [6.784766535243435, -0.6030374897274713],
            [6.78956468041973, -0.6227436871293803],
            [6.788092378234191, -0.6331436116598592],
            [6.778953320717532, -0.6394928722223135],
            [6.772595664156212, -0.6423419608926852],
            [6.767228059853423, -0.647491818818104],
            [6.767704035550446, -0.6508898213677904],
            [6.76499780245842, -0.655085400101632],
            [6.761472917470745, -0.66821254263904],
            [6.755468113669846, -0.6722834622112754],
            [6.749538805206836, -0.6712856184989213],
            [6.740822643872954, -0.6632757201543538],
            [6.735520882779716, -0.657494314121808],
            [6.723482250515587, -0.6523862662134112],
            [6.718547479106555, -0.6491315231039677],
            [6.712408638700895, -0.6471433658243573],
            [6.70411884623183, -0.64603305924615],
            [6.6943006719984055, -0.6496011995450596],
            [6.6936528066577425, -0.6450896313852619],
            [6.689612878151587, -0.6404436075761645],
            [6.685921658012764, -0.6395234714480178],
            [6.6797297937168105, -0.6418012161610889],
            [6.669469899613702, -0.6496862895446355],
            [6.663242664647507, -0.6508417731553023],
            [6.656126452282315, -0.6473177090688018],
            [6.644476409015915, -0.6359931977369485],
            [6.642618230855873, -0.6307403516602281],
            [6.646778244034074, -0.6230166687801351],
            [6.650449231024663, -0.6211760954902062],
            [6.6539554930450295, -0.6215550136804213],
            [6.662504868381778, -0.6263068858680236],
            [6.6689316311088565, -0.6281957561408453],
            [6.680097180356108, -0.6281960834208508],
            [6.688289683502414, -0.6246121835524614],
            [6.691424787604934, -0.6215863845692491],
            [6.69311273856926, -0.6157850176178553],
            [6.690824927487557, -0.6100078390582908],
            [6.68657497408993, -0.6069885942301416],
            [6.674712674680776, -0.6050263685634032],
            [6.665648860617376, -0.6018380280759306],
            [6.660902741124017, -0.597736247184026],
            [6.657769855016667, -0.5930949831819523],
            [6.64820800589513, -0.5725065880036482],
            [6.643103665948306, -0.5663829011069124],
            [6.635940796335315, -0.5607397514608246],
            [6.63419028980466, -0.5589117193518893],
            [6.631247342341015, -0.551225034051057],
            [6.633534413310831, -0.5465303684625253],
            [6.639970519483417, -0.546245840990886],
            [6.652317941095547, -0.5552460848672461],
            [6.662927470388199, -0.5574589987355073],
            [6.665222476985055, -0.558801929656371],
            [6.673360100299663, -0.5581419976807498],
            [6.680185604117875, -0.5559872647929458],
            [6.685534912782327, -0.5556796711566836],
            [6.689218718292221, -0.5591973278895612],
            [6.6928181797104, -0.5597143086528882],
            [6.696580260176812, -0.556620023094997],
            [6.69763771809264, -0.5524147202925545],
            [6.693499623871642, -0.5448164289794264],
            [6.6908882538229255, -0.5346959622700836],
            [6.68882142292359, -0.5329890878892265],
            [6.681640657795954, -0.5346112576609392],
            [6.678012454885227, -0.5337547605560048],
            [6.665831411426538, -0.5337705092423771],
            [6.656994157845679, -0.5321739899821952],
            [6.652564896214852, -0.5279755672978934],
            [6.651135731710244, -0.5238969515784929],
            [6.652449649732469, -0.5203762461560566],
            [6.658209309264683, -0.516203701111619],
            [6.662139803308008, -0.5162483946520204],
            [6.667452340720259, -0.5226227917004954],
            [6.673393521446361, -0.5246242709535216],
            [6.677921184212936, -0.522989607313449],
            [6.681371627737358, -0.5180626405393897],
            [6.67585961393774, -0.5057150255783229],
            [6.67415188934135, -0.4916239961935037],
            [6.677737739220723, -0.4895017860867929],
            [6.686325841735437, -0.48800846528697656],
            [6.689682945996353, -0.4854731897674088],
            [6.691892863958462, -0.48025065532750866],
            [6.691277468488178, -0.4696438777688162],
            [6.681502445905519, -0.44926610735253286],
            [6.678411454645213, -0.440140331361196],
            [6.680216875243727, -0.42995617229078986],
            [6.683908075785644, -0.4226532765838656],
            [6.6900631220767, -0.4185880014464794],
            [6.689456795696559, -0.414180231111318],
            [6.682457521312648, -0.4119323167629092],
            [6.674861338869314, -0.41561147534258475],
            [6.669860704885132, -0.4157277273179462],
            [6.664815280249848, -0.41250334283401086],
            [6.663051081324818, -0.4092394648830713],
            [6.662434899398313, -0.4018602781008202],
            [6.665446958101878, -0.3976553529844371],
            [6.669360902864539, -0.3958065614562898],
            [6.6937008978514365, -0.3939600681493106],
            [6.710553852231669, -0.3841556083357183],
            [6.718874073859165, -0.3760634596123968],
            [6.725449020194214, -0.3561526890900247],
            [6.721399345934046, -0.34343910504564457],
            [6.715762264463979, -0.3467645643634947],
            [6.688333818193346, -0.36155867935312747],
            [6.683073841075421, -0.36126629602794774],
            [6.680071397273102, -0.3557358362072735],
            [6.677862469829251, -0.34897107466013044],
            [6.680135186728648, -0.3424257975836393],
            [6.691212145161908, -0.33646449023158176],
            [6.703161180313618, -0.33682225217682515],
            [6.708945117115858, -0.3333799037359564],
            [6.709754858995091, -0.32885841533396026],
            [6.708726560293658, -0.3213103703907649],
            [6.711712064060446, -0.3121769981513355],
            [6.714430855625612, -0.3100444843621708],
            [6.722077970986518, -0.3091164148727198],
            [6.730686684694228, -0.3147510076821219],
            [6.737613727524956, -0.3011778882441078],
            [6.743949274982708, -0.29747875677313673],
            [6.744506378708781, -0.29367644110525193],
            [6.741959289555025, -0.2891888259242669],
            [6.751521519250193, -0.2813862784185992],
            [6.75409638545587, -0.2771614219726153],
            [6.754303362288517, -0.2722142167240364],
            [6.749814883040471, -0.26578852314203094],
            [6.744205431325705, -0.26629801022505223],
            [6.742466415527379, -0.2733559214204617],
            [6.743920480657363, -0.2777399727096479],
            [6.742738714443825, -0.2810684911887658],
            [6.739210176765021, -0.28389439859046967],
            [6.735871340523516, -0.2817593408250759],
            [6.736548188208887, -0.27601020461469505],
            [6.733866615952869, -0.26914006160032655],
            [6.730423121172204, -0.26583812493379283],
            [6.715345259259468, -0.2578513825695827],
            [6.706198992176819, -0.2507825791421871],
            [6.701066472654271, -0.245087926228232],
            [6.693784313025036, -0.23427966839785075],
            [6.691746121398552, -0.22544680955644933],
            [6.691437334879292, -0.21480172191078928],
            [6.692188068904631, -0.21288323299929368]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.86844209546743, "lat": 38.02178104730661 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18129"],
        "coty_name": ["Posey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Posey County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00450383"
      },
      "bbox": [
        6.631247342341015, -0.6722834622112754, 6.940803683473842,
        -0.20243584722144672
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.115407255914441, 1.3505832361960513],
            [8.112064138339933, 1.3819706532832792],
            [8.10941761058609, 1.4096045923034142],
            [8.151601245135515, 1.415422532021448],
            [8.181026237374786, 1.4184438610550956],
            [8.20997783539004, 1.421989675168914],
            [8.248404107795078, 1.4264454656416545],
            [8.2659218279832, 1.4281108500162485],
            [8.295729380189952, 1.4313732139280737],
            [8.350664448840318, 1.4369518863585606],
            [8.351213085042277, 1.4370048445506587],
            [8.355617288130588, 1.3945677012356381],
            [8.359005260331541, 1.3640112995217901],
            [8.361018632492588, 1.349465639195898],
            [8.369668773312615, 1.278213738082488],
            [8.38062976675097, 1.190793320209615],
            [8.382223154352925, 1.176799453552662],
            [8.382831184618194, 1.164028571894942],
            [8.387966874995156, 1.1171255591394518],
            [8.390910572704177, 1.087802586075424],
            [8.349895958244803, 1.083164179172783],
            [8.262859481604481, 1.073876199006192],
            [8.208007489889503, 1.0670451395156082],
            [8.1464583905615, 1.0585740170882885],
            [8.143924989108259, 1.0767041662193542],
            [8.138174931097122, 1.1311462271824237],
            [8.136614985566059, 1.1474035317834788],
            [8.137820266840604, 1.147703947920259],
            [8.135398028998491, 1.1662769412363794],
            [8.131625255469174, 1.2070574274044445],
            [8.126228738394975, 1.2497740785417832],
            [8.124721544585919, 1.2646541381671792],
            [8.118180637655987, 1.3212512775205372],
            [8.115407255914441, 1.3505832361960513]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.79165874563368, "lat": 39.52371857699174 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18145"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00450387"
      },
      "bbox": [
        8.10941761058609, 1.0585740170882885, 8.390910572704177,
        1.4370048445506587
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.160215933591472, 2.1921956414675563],
            [7.230230057789228, 2.1982150936494285],
            [7.245633105819377, 2.1993502401774268],
            [7.28810820786862, 2.2029964703637],
            [7.330047737034315, 2.20710166022551],
            [7.368839160257303, 2.2112802247148013],
            [7.403245400752218, 2.2146095821524656],
            [7.460187023300291, 2.2199641788463294],
            [7.473493913813162, 2.0898766903114208],
            [7.47778284587939, 2.046223121940521],
            [7.4845879458170135, 1.9731799681356599],
            [7.4916298232230565, 1.9004547109642451],
            [7.494240475312798, 1.8712564761471422],
            [7.408437737747178, 1.863381627249144],
            [7.322648103405245, 1.855309725838607],
            [7.238016882300333, 1.8469454618866834],
            [7.195174741669851, 1.8429755556366514],
            [7.190949362169581, 1.8867256633492309],
            [7.181153346700563, 1.9954108984409575],
            [7.180513864734206, 2.004757906186855],
            [7.1785434344970485, 2.0169996048169554],
            [7.170380433255228, 2.10490328533688],
            [7.169702512006495, 2.104847712449632],
            [7.160215933591472, 2.1921956414675563]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.89408521139643, "lat": 40.38863220280469 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18157"],
        "coty_name": ["Tippecanoe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tippecanoe County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00450393"
      },
      "bbox": [
        7.160215933591472, 1.8429755556366514, 7.494240475312798,
        2.2199641788463294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2646035925009145, 2.4831903770995947],
            [1.348716687632213, 2.484071563334974],
            [1.4308409040218173, 2.484649526192643],
            [1.4341188207980184, 2.484877554656901],
            [1.4630170955476347, 2.4851452119347717],
            [1.5484726371926003, 2.486250611838232],
            [1.6058632918014515, 2.486908379674082],
            [1.6062453712968798, 2.45817851850715],
            [1.6073164693618802, 2.4001269218207795],
            [1.6073660297522532, 2.3731313623212005],
            [1.6087209081693, 2.3136781477445867],
            [1.609929049122798, 2.2378778718278896],
            [1.6099182707852848, 2.226957426345764],
            [1.5529946156623586, 2.2259238003454165],
            [1.4350159108729144, 2.2247427442233962],
            [1.3311204108519272, 2.2243128787357374],
            [1.323433672069247, 2.2240383739848624],
            [1.266883562355521, 2.22342720780022],
            [1.2667621889934955, 2.2245514637166233],
            [1.266102909877681, 2.332078233723715],
            [1.265254624023731, 2.425746046145256],
            [1.2646035925009145, 2.4831903770995947]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.69917699206967, "lat": 41.02897313043659 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19003"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00465191"
      },
      "bbox": [
        1.2646035925009145, 2.22342720780022, 1.609929049122798,
        2.486908379674082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.63157949499294, 4.904158843781277],
            [3.6603129520728674, 4.9053796624097705],
            [3.7572172624203195, 4.910113821050103],
            [3.886389495572894, 4.916702985907932],
            [3.8932456049742616, 4.916570410527588],
            [3.915091965080603, 4.917702139268153],
            [3.9156397579344295, 4.908166124481999],
            [3.9176362422771662, 4.902042160745052],
            [3.9146270022373524, 4.888367956747304],
            [3.911898234507241, 4.882436620945176],
            [3.9066529153251417, 4.876654016341807],
            [3.9060847760766153, 4.8717640732869825],
            [3.9099018409598267, 4.862300937371041],
            [3.926532015926377, 4.842578950718372],
            [3.9277884534630396, 4.840554438330911],
            [3.9320560652367678, 4.830495868083614],
            [3.932148554779872, 4.826274773692398],
            [3.934878932613338, 4.813226378255368],
            [3.934231377603913, 4.807680384118317],
            [3.9298425200085476, 4.792561140833708],
            [3.9248244359184254, 4.7874168466344775],
            [3.924019340657423, 4.783142064142642],
            [3.9305840713614315, 4.770085705629238],
            [3.9342067299213963, 4.766837616388744],
            [3.9442798314523233, 4.765840402990931],
            [3.9493510090735393, 4.764416021899368],
            [3.9568744812739904, 4.75982406011695],
            [3.96893290373547, 4.754277896323273],
            [3.981815801404388, 4.749850750872081],
            [3.9879345185630863, 4.746746520033049],
            [4.004411173013478, 4.734848915050221],
            [4.021148443803267, 4.7138707932764525],
            [4.032288406230293, 4.693905951105893],
            [4.032101676006859, 4.684604660223014],
            [4.0341607059151965, 4.6828484001657396],
            [4.040066486938258, 4.6828332496567695],
            [4.043192313618133, 4.676992601701091],
            [4.0403898391606115, 4.666010200434333],
            [4.0290670833390205, 4.650470806926574],
            [4.009446105756714, 4.62770906922166],
            [4.001667765287336, 4.621077757610824],
            [3.9985573675540538, 4.614065986390447],
            [3.9984632731132264, 4.608392455099052],
            [3.9920979604627838, 4.594540981744009],
            [3.9890818705743856, 4.589960152041456],
            [3.9864216336447815, 4.576198394495659],
            [3.984513394084496, 4.572079435881403],
            [3.977750514890249, 4.56224269732573],
            [3.967762047284341, 4.556155345422076],
            [3.9643625016941573, 4.553254664081995],
            [3.96271560992577, 4.547361153597211],
            [3.9633806280490127, 4.537217317440512],
            [3.9659820578869245, 4.5223340666116325],
            [3.965710139788604, 4.49871157197582],
            [3.926594081367906, 4.496895766899505],
            [3.886982197821093, 4.495546258909882],
            [3.7896724811909146, 4.491122163524285],
            [3.6926854596203778, 4.4868723412293186],
            [3.655031244465157, 4.485091970446816],
            [3.6540053839963904, 4.506567607372157],
            [3.6516519779775813, 4.571789622381838],
            [3.6496948413446497, 4.615083047932997],
            [3.6473556116974684, 4.658431038287754],
            [3.644761474432961, 4.7189045182357034],
            [3.6438831927004305, 4.74575779410625],
            [3.63878226865559, 4.745556781554236],
            [3.634712240331313, 4.835398636018396],
            [3.6342896622328444, 4.849360805022542],
            [3.63157949499294, 4.904158843781277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.37808297570452, "lat": 43.28427233407039 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19005"],
        "coty_name": ["Allamakee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allamakee County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00465192"
      },
      "bbox": [
        3.63157949499294, 4.485091970446816, 4.043192313618133,
        4.917702139268153
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5661492634906407, 4.238569276505625],
            [0.6235118383857865, 4.239173098816873],
            [0.6807512368165682, 4.239560159712183],
            [0.7382570650088297, 4.2402542542739505],
            [0.7813039643997136, 4.240227240164038],
            [0.9092906098575911, 4.240726251990105],
            [0.9096028900997921, 4.196072426120764],
            [0.9101550872539018, 4.1524355830817195],
            [0.9109255303368897, 4.064567091913687],
            [0.9109856583825869, 3.977747979894297],
            [0.9116711510812587, 3.891362562222825],
            [0.8252221416271586, 3.8909943153161572],
            [0.7605470923534167, 3.8905926259891896],
            [0.6964582325595735, 3.889929595842543],
            [0.6528638851154448, 3.889721419299995],
            [0.5662492956629902, 3.8888726280708426],
            [0.5665094705288118, 3.914341480033829],
            [0.566342581061408, 3.9544377914923894],
            [0.5658132144306945, 4.02783032435528],
            [0.565383085472802, 4.0496393957267385],
            [0.5663153587859111, 4.107917735975309],
            [0.5668665604610909, 4.1517121432720145],
            [0.5661492634906407, 4.238569276505625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.62381042709205, "lat": 42.73562186613406 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19035"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00465207"
      },
      "bbox": [
        0.565383085472802, 3.8888726280708426, 0.9116711510812587,
        4.240726251990105
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9116711510812587, 3.891362562222825],
            [0.9695972964921757, 3.890809963540484],
            [1.0564195541572088, 3.8917529589716944],
            [1.1717228630228602, 3.892795289011033],
            [1.2582608618220052, 3.893011830305959],
            [1.2581628299041785, 3.889745510110295],
            [1.2592492346197541, 3.806544654044917],
            [1.3016063753796603, 3.806845396993156],
            [1.302365898938866, 3.7174271746728715],
            [1.3026224780459013, 3.628326576207695],
            [1.3035393790011245, 3.541336093001199],
            [1.2320334846838867, 3.5406630528955345],
            [1.1747399912028784, 3.5404932459162506],
            [1.1325466586283413, 3.5402113516549147],
            [1.047067772106095, 3.5399297647411503],
            [1.0042415709846457, 3.5394555851294474],
            [0.9614025077874261, 3.539316016862615],
            [0.9615500397455137, 3.5398788280791127],
            [0.9608587536538518, 3.684521830152215],
            [0.9603477618786926, 3.8043275567941395],
            [0.9126484767271599, 3.804085855213649],
            [0.9116711510812587, 3.891362562222825]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.10536872541115, "lat": 42.38623549901117 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19161"],
        "coty_name": ["Sac"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sac County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00465269"
      },
      "bbox": [
        0.9116711510812587, 3.539316016862615, 1.3035393790011245,
        3.893011830305959
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.862307181384222, -0.8487441049197114],
            [-3.605375227889715, -0.8633177799838324],
            [-3.5219177328097784, -0.8676130781528935],
            [-3.5202962998487064, -0.8678405489370523],
            [-3.52203950295177, -0.8973283244654328],
            [-3.5301589413666346, -1.0436003146371196],
            [-3.5347835700510886, -1.141905124050099],
            [-3.539128031100956, -1.2193117958824227],
            [-3.583184515882541, -1.2166526719753605],
            [-3.615044662141833, -1.215206761937688],
            [-3.638126947503382, -1.2137434946903254],
            [-3.7354541623921507, -1.2081223814291704],
            [-3.795919680051907, -1.2040195194487786],
            [-3.804441809052673, -1.2039950534325268],
            [-3.8817424915788785, -1.199484289460205],
            [-3.875816876314864, -1.0975507078015443],
            [-3.871934965905666, -1.024399008702102],
            [-3.8698545105087656, -0.987692360849664],
            [-3.862307181384222, -0.8487441049197114]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.30797145367657,
          "lat": 37.56228116522038
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20067"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00485099"
      },
      "bbox": [
        -3.8817424915788785, -1.2193117958824227, -3.5202962998487064,
        -0.8487441049197114
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4917860969561271, -1.4158122923015302],
            [0.4915429386335973, -1.3275591746448026],
            [0.49395152213676347, -1.3275784308989116],
            [0.5810058527835467, -1.3281245731435036],
            [0.6343006880960205, -1.3285893905458939],
            [0.7267451090105183, -1.3292048227461153],
            [0.8009431758585592, -1.3295401326417065],
            [0.837069408891911, -1.3293352532700733],
            [0.8405552206390572, -1.3293066713136692],
            [0.8420109829960173, -1.374127606579778],
            [0.8423214520001537, -1.4040613709635665],
            [0.8436393498710703, -1.448020905204927],
            [0.843682095066603, -1.4628171405883459],
            [0.8422826002232334, -1.5030276907131526],
            [0.8412990433491592, -1.5213443096026515],
            [0.8415854381650003, -1.552660209704773],
            [0.8410721165499874, -1.5651477493687587],
            [0.8414538001981913, -1.5954912100694385],
            [0.8415413851088066, -1.6390979547841869],
            [0.8409293963303974, -1.6539590825673443],
            [0.8414960431281987, -1.7176255622030951],
            [0.7117478614956235, -1.7180967578017299],
            [0.7036748663743151, -1.718258184392711],
            [0.6324056774728494, -1.718355900009323],
            [0.6156232044380163, -1.7185793827572624],
            [0.5347853294197329, -1.7184852270425186],
            [0.4920017041977629, -1.7187581050751781],
            [0.4916284582756504, -1.7042398348167407],
            [0.4917377909701398, -1.6496380706166651],
            [0.4916313637707621, -1.6205589867844876],
            [0.4920328428358005, -1.5185201681572948],
            [0.4918198173367959, -1.488970044118474],
            [0.4917860969561271, -1.4158122923015302]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.742898299574, "lat": 37.192504195031255 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20125"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00485027"
      },
      "bbox": [
        0.4915429386335973, -1.7187581050751781, 0.843682095066603,
        -1.3275591746448026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.42551810522577, 0.12324788391788205],
            [9.429546147953062, 0.1241217323525261],
            [9.433289300050614, 0.12121616711805173],
            [9.439646799498751, 0.12282415618270372],
            [9.443266486504918, 0.12952091986080402],
            [9.446255962009621, 0.13012512031289294],
            [9.456952053518076, 0.12770850423293886],
            [9.468118568318564, 0.12740114191659935],
            [9.470885029315221, 0.12463173152743305],
            [9.480258821648855, 0.12616621293332408],
            [9.483228313330232, 0.13101615670089284],
            [9.483888729472758, 0.1370879479810776],
            [9.485683265977908, 0.14237956432615678],
            [9.492213329625153, 0.13645921112038265],
            [9.500705287257682, 0.1343166879049685],
            [9.506493195568781, 0.1393330836073556],
            [9.501345496932355, 0.1445110582335048],
            [9.503927901849826, 0.1464054779905885],
            [9.509802725324958, 0.14349780761607756],
            [9.513870044700516, 0.1453713222318112],
            [9.515980756314365, 0.1491177718493365],
            [9.519225325448497, 0.14770839013455866],
            [9.521144386108302, 0.15403000312724566],
            [9.523488980684332, 0.1564869816191724],
            [9.525380742978289, 0.16527790537700457],
            [9.530799423047169, 0.16481659075137947],
            [9.537170370847347, 0.1657403416348052],
            [9.533947172815422, 0.17167230383040957],
            [9.538578497777372, 0.1712006540653217],
            [9.539207723542992, 0.16720037702307844],
            [9.54596115424668, 0.16780393894750564],
            [9.547909758085973, 0.1709576032910037],
            [9.557860811007568, 0.1815206044526559],
            [9.606239625501816, 0.23563308233711291],
            [9.629765767214595, 0.2214398265088267],
            [9.662014401509978, 0.1742263803217417],
            [9.664847166303607, 0.1737281149207917],
            [9.66892871189225, 0.166966916112648],
            [9.67421677622255, 0.1659448697872249],
            [9.676338241360417, 0.159480107786067],
            [9.686348867887395, 0.1581457212138991],
            [9.685993962042085, 0.15478315294438635],
            [9.678476573321202, 0.1504273031592891],
            [9.675258173901849, 0.14634163755677915],
            [9.676872922216566, 0.1435055474416855],
            [9.681404685418393, 0.14449957898932664],
            [9.683795072610097, 0.1469191369457753],
            [9.688725883652872, 0.1422928298314822],
            [9.691014787840254, 0.1365332600414229],
            [9.690609154679805, 0.13121219123591427],
            [9.696516174524016, 0.1322203453232582],
            [9.698389031533639, 0.13400220394014528],
            [9.698568227505726, 0.13860887983434403],
            [9.695100016049404, 0.14082853845696205],
            [9.699639883232049, 0.14687293956042077],
            [9.703592878144994, 0.14433802220970576],
            [9.703300464605551, 0.14029716624464955],
            [9.705992993026072, 0.139620765882837],
            [9.7099518993355, 0.14395399227187805],
            [9.712328330339535, 0.13944051611775887],
            [9.708925727703551, 0.13843836228848347],
            [9.708033148772012, 0.13385664972789327],
            [9.710442227489358, 0.13106729841606438],
            [9.713868165472768, 0.13277573267046225],
            [9.717394875098062, 0.13101408827667063],
            [9.72619376908936, 0.1337392976243282],
            [9.726709054893691, 0.1266815871974891],
            [9.731351074560642, 0.12126079569073851],
            [9.73153552602349, 0.11673028148035025],
            [9.724938249097063, 0.11301849711380689],
            [9.724703978305511, 0.1115395277224389],
            [9.733075787265003, 0.10754448478127873],
            [9.73930035335781, 0.10360952662545789],
            [9.745519350934849, 0.10159602927976072],
            [9.748309927446176, 0.10276957570011809],
            [9.754028032569494, 0.09774252262533234],
            [9.753483107103378, 0.09365391731016089],
            [9.765313850281657, 0.09870439267804564],
            [9.768752436431775, 0.10147757652527424],
            [9.770479189526236, 0.09691653459668932],
            [9.774951155816188, 0.09671343180637697],
            [9.775862237971461, 0.09070936061561424],
            [9.783999727386052, 0.09094155225864023],
            [9.783546012379908, 0.10229185848386381],
            [9.784779997813427, 0.10390021794375155],
            [9.792476859778944, 0.10470153456258792],
            [9.793954169659838, 0.10165133063505342],
            [9.791712484419067, 0.09748278722162003],
            [9.792755381010263, 0.09231597409494649],
            [9.7968229563658, 0.09517969200129918],
            [9.80008386255139, 0.09475886616025696],
            [9.800333956736585, 0.08953904361105695],
            [9.790878412790237, 0.07915863005652043],
            [9.795605016945903, 0.0766680666437403],
            [9.78831919151944, 0.058385092166899445],
            [9.763171648191122, 0.03215385405560872],
            [9.759313610380637, 0.02772715911726562],
            [9.75404791474849, 0.023936923212752554],
            [9.752204105183278, 0.019553842660075454],
            [9.747262184098886, 0.014617319625235898],
            [9.739541641601042, 0.010304322400314904],
            [9.73554126849428, 0.004777223854533259],
            [9.733058305812682, -0.0007891708239307075],
            [9.726107449475208, -0.010508712163161849],
            [9.646853047854014, -0.045725967499723574],
            [9.572868649053627, -0.07859936776490667],
            [9.57421833687841, -0.0762536047392815],
            [9.571188160687306, -0.07009330226283814],
            [9.562349851492632, -0.06672259957080143],
            [9.556361854677451, -0.06159228745343676],
            [9.550871955157339, -0.06124743398411981],
            [9.548055167705366, -0.05523105375045207],
            [9.545167923695516, -0.055715987856620096],
            [9.54388766854362, -0.05971314573636792],
            [9.539341738785199, -0.06474734529550748],
            [9.525705639105885, -0.05999890835210561],
            [9.524431057840227, -0.05618179040425926],
            [9.51626061166991, -0.05369950354413715],
            [9.511626247421484, -0.053927169019093536],
            [9.503427470216524, -0.04831438006359726],
            [9.50312684286022, -0.04449732556398742],
            [9.495549205116706, -0.0432739389237111],
            [9.494046418606192, -0.04104832775159924],
            [9.496196790875926, -0.036298292968706215],
            [9.495541929320417, -0.03291140819198806],
            [9.502063947338863, -0.027436521621501436],
            [9.50248355219589, -0.023171724564661055],
            [9.498798221729048, -0.013198360755367306],
            [9.499324442637953, -0.01004371574350564],
            [9.497134993401072, -0.0032143738837431403],
            [9.497564508743881, -0.000046193293151095985],
            [9.494167226988045, 0.003815369559407408],
            [9.494561180132958, 0.008880717919889813],
            [9.49746216286845, 0.008581219345756863],
            [9.501216151543034, 0.014170901842819062],
            [9.500816713434547, 0.01814367275376017],
            [9.506020359662962, 0.0260945296103158],
            [9.501514631873542, 0.031413513557256335],
            [9.502916466244562, 0.03446848279096822],
            [9.501262699164851, 0.04258959098764946],
            [9.494539332675027, 0.04354071578783881],
            [9.48812630593053, 0.04936228976577604],
            [9.486895868504199, 0.05418009832426383],
            [9.483890098466844, 0.05727394620531282],
            [9.477372955364501, 0.05539898184194283],
            [9.470177006287111, 0.049719734269741855],
            [9.466270856413072, 0.05158260829775445],
            [9.45487690455414, 0.05607567064290338],
            [9.45187090089131, 0.05602290419892813],
            [9.449340950238057, 0.05886898483922707],
            [9.453059962395773, 0.06355658178298988],
            [9.451000172879422, 0.07141571755718663],
            [9.44827327049337, 0.0734990516376809],
            [9.445908517081223, 0.07982742965531585],
            [9.445678471238123, 0.08648834332500115],
            [9.446938618132197, 0.08873937987731717],
            [9.44576328793276, 0.09473621136215181],
            [9.432054743185777, 0.10686429091557634],
            [9.432553984055092, 0.11165998328043956],
            [9.431008768947656, 0.1147081859347774],
            [9.427283465475936, 0.11609518056144746],
            [9.42551810522577, 0.12324788391788205]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.21724826366408, "lat": 38.20675977748372 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21017"],
        "coty_name": ["Bourbon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bourbon County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00516855"
      },
      "bbox": [
        9.42551810522577, -0.07859936776490667, 9.800333956736585,
        0.23563308233711291
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.954858398866412, -1.6170065776759353],
            [8.980486482758407, -1.4941300356955725],
            [8.98333503447766, -1.4675281251655075],
            [8.992341703903609, -1.3805232062877717],
            [8.994151135157637, -1.3770356996329838],
            [8.992125667230736, -1.3718903633995],
            [8.98560528176286, -1.3641858461110925],
            [8.974680916999885, -1.3570712445199247],
            [8.973003634771478, -1.3526732227590674],
            [8.976124211100576, -1.348560517172578],
            [8.979466710762127, -1.348507319223767],
            [8.986935431688185, -1.351506254018186],
            [8.990545929547924, -1.3544311917481298],
            [8.999578455745546, -1.3586639301908594],
            [9.004600516783851, -1.3592277808066724],
            [9.07184150743537, -1.3989905753751564],
            [9.110812270951701, -1.3625864862000723],
            [9.117832723993661, -1.3878335359948064],
            [9.146699772108393, -1.411097878603194],
            [9.170154764104899, -1.4598660511625072],
            [9.16299782963024, -1.489261564599409],
            [9.16207854175737, -1.499710455972519],
            [9.166237920824422, -1.5014641349994535],
            [9.165228383525317, -1.510475610071242],
            [9.162547436852535, -1.5139698122261642],
            [9.164907997119165, -1.5163162963451622],
            [9.164447323560761, -1.5234086842236292],
            [9.166525848835322, -1.5277172523908682],
            [9.173808653505406, -1.5304564774206113],
            [9.177704342758663, -1.533330501853966],
            [9.176637109233555, -1.5359548795855775],
            [9.181558975364606, -1.5391017360183046],
            [9.178371217997238, -1.5456453705752922],
            [9.179759103488186, -1.550312230949215],
            [9.182740453650771, -1.5501081060166402],
            [9.18570951120643, -1.5526932329613357],
            [9.186300648344336, -1.563669538898576],
            [9.187543139835304, -1.5682850881791524],
            [9.18313538715183, -1.57351350250408],
            [9.18504312136746, -1.5827374762954414],
            [9.188478209499065, -1.5846344463826627],
            [9.189161328515375, -1.5914505116179687],
            [9.196097601586825, -1.5932856407257836],
            [9.197742191814706, -1.595945204491612],
            [9.20567223189542, -1.5934363527065825],
            [9.209629364380968, -1.5982162282175043],
            [9.200359772091366, -1.5981613371764365],
            [9.169896398677537, -1.5989708317553284],
            [9.120803613798502, -1.6020471891372103],
            [9.113066872513704, -1.602359714826743],
            [9.034338816337147, -1.6083238307105654],
            [8.970311191429019, -1.6145746894835407],
            [8.954858398866412, -1.6170065776759353]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.1362162398394, "lat": 36.72742539161541 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21053"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00516873"
      },
      "bbox": [
        8.954858398866412, -1.6170065776759353, 9.209629364380968,
        -1.348507319223767
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.763111010745221, -1.9030128697761979],
              [5.771097887076521, -1.9096677499828747],
              [5.775214279975538, -1.9143737652596717],
              [5.785789955317128, -1.9297940917754848],
              [5.7919760094246024, -1.9398860800285964],
              [5.805575846836785, -1.955138658372457],
              [5.814835209029547, -1.9633746444036353],
              [5.822846915494205, -1.9668116533115318],
              [5.839993280417342, -1.963694537666732],
              [5.84712885073432, -1.9606054684580143],
              [5.854474143012134, -1.9532188673323203],
              [5.857270661818628, -1.9490133173109474],
              [5.864415199932448, -1.9267971465510043],
              [5.8645696335699835, -1.9099927862615536],
              [5.866368525578332, -1.898980123973972],
              [5.873341376934265, -1.8861596575480528],
              [5.883022291032329, -1.8759977610784626],
              [5.904984512266073, -1.8757869799746607],
              [5.987053363732842, -1.9169538348182733],
              [5.994499139619941, -1.9218784536910405],
              [6.001103527830846, -1.922491566746522],
              [6.004622542152143, -1.926189924144985],
              [6.072746862768626, -1.9217717675566588],
              [6.0762279378987465, -1.9271241275030648],
              [6.083879751637896, -1.9338381759791288],
              [6.0890176848486535, -1.9359037154454606],
              [6.095929912513688, -1.9356409074340495],
              [6.1031833247435365, -1.9342126822031356],
              [6.1293099238148345, -1.9644535716484894],
              [6.163555999259991, -2.004613974938797],
              [6.131943040538618, -2.0074642795834277],
              [6.124192274368445, -2.0087963820106847],
              [6.112280349034717, -2.009168320905965],
              [6.060699831849336, -2.013036192839508],
              [6.004914624392885, -2.0163679619789665],
              [5.93904371245615, -2.0205257737854603],
              [5.864346271386023, -2.0238536171702575],
              [5.810529819623169, -2.02679133258775],
              [5.793652578752229, -2.0273408889253957],
              [5.757579104899267, -2.0338594463861477],
              [5.730743666994013, -2.0385609426598124],
              [5.72213220532714, -2.040512978416927],
              [5.701299804083866, -2.0420288825828727],
              [5.70849085120401, -2.0120458614931165],
              [5.713032318814526, -1.997405514494931],
              [5.714022229327384, -1.9798197371211046],
              [5.722774959501791, -1.9549832998607637],
              [5.72392750430225, -1.9472900030165552],
              [5.724822481542215, -1.9300676060065713],
              [5.726316309491103, -1.9222531264068308],
              [5.729486175992066, -1.9168522048646062],
              [5.733514445167503, -1.912303456054487],
              [5.740443353797834, -1.9084001536880075],
              [5.750378970856374, -1.905122928483166],
              [5.763111010745221, -1.9030128697761979]
            ]
          ],
          [
            [
              [5.647265000096341, -2.04729262884135],
              [5.6372205967241324, -2.047580621708009],
              [5.604489220131763, -2.049767203232579],
              [5.6010501400211945, -2.042899407588668],
              [5.59119569655455, -2.0313686287524715],
              [5.5858367345555795, -2.0232238424040387],
              [5.57568772631737, -2.001758589693611],
              [5.575118373991717, -1.9965124132376149],
              [5.578048086682571, -1.9845360071708924],
              [5.584340393363628, -1.974706694093033],
              [5.588414365646052, -1.9707248789483267],
              [5.596262061522658, -1.9667653677696872],
              [5.608027489021804, -1.9653767415662375],
              [5.618665331157397, -1.9680326821576548],
              [5.630190115366934, -1.9687595725392264],
              [5.642594704635868, -1.97244417919315],
              [5.6474028052247665, -1.9757700602778807],
              [5.652542173727762, -1.9837987978210068],
              [5.657877593885243, -1.996650820731157],
              [5.660457248848402, -2.0072781292971835],
              [5.660536644847745, -2.0135599134040376],
              [5.658929061363318, -2.022423232387841],
              [5.656440610060415, -2.030229508519388],
              [5.653148778510312, -2.03720189337766],
              [5.649290003711671, -2.0424614667090455],
              [5.647265000096341, -2.04729262884135]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.18728482404141, "lat": 36.55401795656207 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21075"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00516884"
      },
      "bbox": [
        5.575118373991717, -2.049767203232579, 6.163555999259991,
        -1.8757869799746607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.331441675318288, -1.4118705974982173],
            [6.332787895975206, -1.4103338229634808],
            [6.348085760090303, -1.4158413483510588],
            [6.359613053676138, -1.4183520932264706],
            [6.367729083237786, -1.4193409407747035],
            [6.381233412741269, -1.4182792971885891],
            [6.391909678970133, -1.4147338917755383],
            [6.398513100660043, -1.4151016204796991],
            [6.414963487524756, -1.406779009037305],
            [6.422730083619583, -1.3926835752999784],
            [6.425749798729578, -1.3846986587271783],
            [6.425413409275326, -1.3794030885604676],
            [6.427792231300037, -1.3719985974839555],
            [6.425600007771073, -1.3705985922704016],
            [6.431173942102903, -1.3527044855052193],
            [6.437098723118502, -1.3284573539988014],
            [6.437189061070967, -1.3258911015388575],
            [6.430982136063334, -1.318416736144753],
            [6.424449260208571, -1.2989787617868016],
            [6.422936876716635, -1.2973443218559277],
            [6.414711874142131, -1.275936019423834],
            [6.412158262128547, -1.2725756095182688],
            [6.405262083329074, -1.2665517443412664],
            [6.394520231619532, -1.2607019459572746],
            [6.3874947398994975, -1.2516883195670905],
            [6.382475612527796, -1.240776435182271],
            [6.3760475931743255, -1.2335171107132135],
            [6.369042367391141, -1.2288720899975276],
            [6.361642991095849, -1.2207972904194344],
            [6.363157823293383, -1.2160942925228158],
            [6.360543711725797, -1.2094732496476184],
            [6.354707931346398, -1.1991538493136293],
            [6.355163250706971, -1.1921253528013185],
            [6.357046000833377, -1.184301599067041],
            [6.361337851785392, -1.1745131873811692],
            [6.364094884320428, -1.164204683372502],
            [6.373051431137725, -1.1414449375985543],
            [6.374522283237774, -1.1352388327569407],
            [6.375231756263302, -1.1257580177189221],
            [6.3748493809541, -1.1159646396438856],
            [6.376833045047719, -1.105237246436899],
            [6.3774039046515085, -1.093218050037438],
            [6.381649294245235, -1.0833813839549267],
            [6.391825984308174, -1.0701894563366667],
            [6.404258678981625, -1.0611640054182476],
            [6.414484165505834, -1.0572844799074927],
            [6.422560454244739, -1.0525350585150655],
            [6.427482679744922, -1.0503962821458728],
            [6.436761103398081, -1.0532710959871108],
            [6.444759910573154, -1.0578579683595632],
            [6.453265633199516, -1.0639175566480497],
            [6.458774307618736, -1.0706610053000407],
            [6.463364155450919, -1.071372461363351],
            [6.468570871276018, -1.0677581704340042],
            [6.472160648544171, -1.07379375426079],
            [6.490117732182461, -1.0763573299011195],
            [6.492824188084525, -1.070940268054654],
            [6.495735636317608, -1.0727508038008533],
            [6.496883871282242, -1.076628480956529],
            [6.501043999605559, -1.0733572793277253],
            [6.505420437989516, -1.077821151757234],
            [6.505358732744982, -1.081733975459726],
            [6.5096874496425094, -1.0827008659199158],
            [6.508227242058915, -1.087629595480098],
            [6.517069534241063, -1.0910601408290723],
            [6.514008003067364, -1.0991961901903222],
            [6.5163390828553425, -1.1024944851086163],
            [6.514050804704158, -1.107400324385936],
            [6.522511492499316, -1.122150243375201],
            [6.522489961548323, -1.128019754029197],
            [6.525120383881879, -1.1335198727541045],
            [6.547219027929274, -1.1500105081157659],
            [6.58884226205852, -1.1913526562707852],
            [6.606134388734078, -1.2282902131526139],
            [6.603457835230172, -1.2369387783196846],
            [6.607491411575716, -1.237255470595975],
            [6.6111389087416965, -1.2438777841035817],
            [6.608826786161529, -1.25342936589542],
            [6.60660027725304, -1.253589123423019],
            [6.605731595885524, -1.2604166306263895],
            [6.601198209073205, -1.2644061212808881],
            [6.601950083670176, -1.2672665903203515],
            [6.596859475984343, -1.2745042609182868],
            [6.59776065224374, -1.2769382264902516],
            [6.5952169143825214, -1.2821252280715354],
            [6.604806616770791, -1.2862202235824713],
            [6.609061607259003, -1.2870506160699666],
            [6.615348965618121, -1.2903886426775895],
            [6.620557015465591, -1.2969003502227863],
            [6.623566295433516, -1.3086350739829251],
            [6.619268813643268, -1.3163667642169377],
            [6.606978411669625, -1.3344236954470736],
            [6.6052278451171915, -1.3395202641693946],
            [6.603744758817334, -1.354460881940073],
            [6.605786798350121, -1.363492891169026],
            [6.604700899379992, -1.3706454605806622],
            [6.595968841158782, -1.375587824470429],
            [6.5937601835750455, -1.380362822803399],
            [6.595081347832974, -1.384877071502279],
            [6.603015988410599, -1.395051713265939],
            [6.608868979546413, -1.4094213328631913],
            [6.6027523058583215, -1.4208884439565808],
            [6.60203264519452, -1.4283913586314192],
            [6.602975466160187, -1.4388935339299673],
            [6.60846505397072, -1.4493996628328132],
            [6.616954011466471, -1.4615662617179668],
            [6.6190915889933075, -1.4655501628747776],
            [6.60911886502741, -1.4748168986272991],
            [6.596022882238713, -1.4857361664554805],
            [6.5873923918689075, -1.4761382194393102],
            [6.581285237693734, -1.4713889762800785],
            [6.5733591326634055, -1.4627569646238698],
            [6.566415244136324, -1.4525059016844717],
            [6.549934295173659, -1.4383457852246726],
            [6.539621480923269, -1.424993796324303],
            [6.5329645724415135, -1.4203291558031135],
            [6.5242161623559936, -1.4177239606993322],
            [6.511570845082119, -1.4122871458013706],
            [6.501817684666385, -1.4127206727932844],
            [6.493336602262545, -1.4109917608857898],
            [6.486848589614313, -1.4121913054270512],
            [6.478727181091029, -1.4175741220611275],
            [6.469111858550945, -1.4212995663768522],
            [6.454340830164713, -1.4251131724662665],
            [6.4437502905551325, -1.429010380976309],
            [6.435271825569405, -1.4338778606147518],
            [6.427328804411609, -1.4456601162709275],
            [6.417500487072198, -1.4533068972365544],
            [6.409981322717128, -1.457371915231018],
            [6.401475076797243, -1.4602314328219246],
            [6.393238158034592, -1.4613493526063568],
            [6.387292393001655, -1.4611796233550327],
            [6.379670239136287, -1.459728304848626],
            [6.372091267306735, -1.4556423289710354],
            [6.366008540590571, -1.4501934284485758],
            [6.354104974338547, -1.4368457064976596],
            [6.346259336631272, -1.4290543182969486],
            [6.338570549074287, -1.4230187333080009],
            [6.332489485224834, -1.4198818237077748],
            [6.331441675318288, -1.4118705974982173]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.35369733896142, "lat": 37.2095750024903 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21139"],
        "coty_name": ["Livingston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Livingston County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00516916"
      },
      "bbox": [
        6.331441675318288, -1.4857361664554805, 6.623566295433516,
        -1.0503962821458728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.406454184021957, -1.578661355846108],
            [8.46223193980158, -1.5277024546960833],
            [8.5298871326811, -1.4650891167997195],
            [8.541881243836897, -1.4579357462844227],
            [8.555666266173162, -1.4473848937939535],
            [8.560083219117633, -1.4474935306548335],
            [8.57267936213055, -1.4399223082000197],
            [8.581139436417825, -1.4394153167015715],
            [8.681405729944123, -1.4373615325953157],
            [8.690273128183405, -1.4395959991633283],
            [8.69643675185687, -1.450631584371874],
            [8.70680991871398, -1.490807367593861],
            [8.716619359132691, -1.4888986505839767],
            [8.718604782684244, -1.494140815299181],
            [8.721509136702053, -1.4959421395726178],
            [8.727604413685498, -1.4929544785177316],
            [8.73247730441055, -1.4937494431498246],
            [8.735934230304121, -1.490646824357402],
            [8.740508830314397, -1.4909664703954872],
            [8.743552209337553, -1.4893327262079858],
            [8.746459660616114, -1.4915389757083741],
            [8.745755178247562, -1.4996233899384657],
            [8.748727253081597, -1.5060354068481112],
            [8.754170786922852, -1.5072351601847087],
            [8.758652861221064, -1.5171242580042767],
            [8.763519604601111, -1.5191558940599252],
            [8.762512875980775, -1.523824491719085],
            [8.768164903872524, -1.5307699374171393],
            [8.773005096005432, -1.5286966037257175],
            [8.774568203709725, -1.524505378427901],
            [8.781627560374982, -1.5271489907019085],
            [8.79423671488609, -1.5236883362642555],
            [8.803103147491749, -1.5240435231186793],
            [8.805621632287032, -1.526944971733826],
            [8.805079415641432, -1.5305421629615963],
            [8.800100382345326, -1.5413639585794887],
            [8.798571410899173, -1.5465887340883429],
            [8.79426975429282, -1.5555961083920649],
            [8.78885817445524, -1.5697108305681564],
            [8.844699097212882, -1.6368069160384657],
            [8.804068408187419, -1.6449117835608063],
            [8.754100111857024, -1.6496975201035344],
            [8.654013654563341, -1.6582061439249378],
            [8.611029002213094, -1.6605723122319063],
            [8.56602029456761, -1.66400075805306],
            [8.555780302356192, -1.6645226349777849],
            [8.531568758765196, -1.667503147705949],
            [8.498447276766893, -1.6694314253685407],
            [8.429889865797657, -1.6721834280397143],
            [8.419618096169078, -1.6728661798111142],
            [8.42644059490275, -1.6563019666790915],
            [8.431219222831796, -1.6494731316085303],
            [8.43481700578664, -1.6484197319218963],
            [8.434679225094936, -1.6376547812294795],
            [8.428451165676192, -1.6292995219361879],
            [8.41980959697415, -1.6093573221953963],
            [8.40676157246, -1.5855755311146682],
            [8.406454184021957, -1.578661355846108]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.71652901097197,
          "lat": 36.712143012010024
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21171"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00516932"
      },
      "bbox": [
        8.406454184021957, -1.6728661798111142, 8.844699097212882,
        -1.4373615325953157
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.63366381497282, 0.27613336080332895],
            [8.637447412245248, 0.27139093314673796],
            [8.642527820774639, 0.27327936267652286],
            [8.649867944840691, 0.2710366012284021],
            [8.658519100222026, 0.27278611721146206],
            [8.66349318522769, 0.2727468047960446],
            [8.667389209066108, 0.27072347080659875],
            [8.676291132337349, 0.274949985318612],
            [8.68126010889792, 0.27166585584925274],
            [8.683185314472968, 0.26750666575157567],
            [8.688070301442483, 0.26480383331713886],
            [8.694402720857925, 0.2677287723728522],
            [8.698596072251233, 0.26746985171043386],
            [8.708781994443887, 0.26232864646682563],
            [8.720658295037273, 0.2616533449209962],
            [8.727508959874333, 0.25744918815834394],
            [8.72910818476815, 0.2542417823456253],
            [8.728334170887518, 0.25365646422707],
            [8.708137223872878, 0.2182911282388678],
            [8.721015490294867, 0.20304820435495527],
            [8.730574262544886, 0.1644592592943267],
            [8.756787013261444, 0.1367689203327938],
            [8.768212173044631, 0.12194330685993206],
            [8.741633695063724, 0.0701919565069876],
            [8.721391397662156, 0.06077390416024734],
            [8.694349423272781, 0.06279488467678151],
            [8.689205367789228, 0.06205969402669505],
            [8.68744807297555, 0.0593265306673966],
            [8.677449342683953, 0.05679659117392139],
            [8.67676500898028, 0.05441446895540421],
            [8.678586450670554, 0.04738968307970465],
            [8.673978439956278, 0.04836277279526957],
            [8.671299512583612, 0.05452153212946743],
            [8.666301532181105, 0.05369969287534383],
            [8.662856650585677, 0.05469670460499875],
            [8.664697174134439, 0.044177498341737044],
            [8.660452275226529, 0.044211473139499684],
            [8.655932804470112, 0.04711289578709654],
            [8.649758021675904, 0.04907704100050358],
            [8.647307151258666, 0.04545179288299489],
            [8.642643818035225, 0.04809305111226522],
            [8.642936620654996, 0.04081820735791679],
            [8.636955148888756, 0.03938191509628527],
            [8.639175274653118, 0.03421356063291622],
            [8.633476839774717, 0.03289955858717856],
            [8.608418647526118, 0.04681070403409007],
            [8.55580163281476, 0.07693853742009234],
            [8.545800465468957, 0.07263929669674384],
            [8.53705528732344, 0.07721739217953753],
            [8.542205022906519, 0.07940247610479685],
            [8.549042850639157, 0.08089517648606297],
            [8.50235422757899, 0.10793028235236933],
            [8.491964670723812, 0.11373176003136479],
            [8.494071434734998, 0.12962624198619432],
            [8.495637368299732, 0.13654286603455207],
            [8.499084867763026, 0.14710029298693358],
            [8.502000750882958, 0.1616681260191186],
            [8.51106692365482, 0.17735930893175839],
            [8.516263912536093, 0.18228011625220905],
            [8.52424828522001, 0.1882271859048337],
            [8.532547045385922, 0.19166305530439984],
            [8.549781110931788, 0.1946104796847412],
            [8.560548610688198, 0.19743328543177086],
            [8.57062382716919, 0.2010081109647477],
            [8.581835351334254, 0.20819913775228158],
            [8.589421891708005, 0.21386618871936347],
            [8.594438733775235, 0.22098614596175295],
            [8.600755150333686, 0.23557823916227352],
            [8.601434846515318, 0.24191124389808463],
            [8.603762561892378, 0.2514724075683155],
            [8.609326130956335, 0.25935664826475907],
            [8.615297178084493, 0.26392078398077623],
            [8.629977946304294, 0.272926497796858],
            [8.63366381497282, 0.27613336080332895]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.44834676838562,
          "lat": 38.399424830433986
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21185"],
        "coty_name": ["Oldham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oldham County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00516939"
      },
      "bbox": [
        8.491964670723812, 0.03289955858717856, 8.768212173044631,
        0.27613336080332895
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.4694918046630048, -6.190226930375244],
            [3.4664238943134755, -6.103045920882695],
            [3.4971728624320786, -6.102116438701678],
            [3.5585434952741304, -6.099689496095852],
            [3.565953438655181, -6.094206447833376],
            [3.5733086495181294, -6.098341487385993],
            [3.574527642185092, -6.097485465744659],
            [3.581649485214139, -6.100231690387916],
            [3.586604124726847, -6.100211628347543],
            [3.5890670076125315, -6.097331253959475],
            [3.594119408018987, -6.098832127200524],
            [3.5994122705646068, -6.097339863893626],
            [3.606082135398751, -6.091404560054428],
            [3.6153562662984564, -6.090595427343781],
            [3.618796978544122, -6.092043150658743],
            [3.624400882868445, -6.089059658210165],
            [3.627045533191587, -6.085776429639293],
            [3.6258359573697874, -6.0755052132574665],
            [3.627368737165536, -6.069334087953689],
            [3.6298132390856654, -6.067751002441946],
            [3.6951950729482954, -6.016065193035568],
            [3.692241504564749, -6.008479830121921],
            [3.6923986109294082, -6.003160352671121],
            [3.6949405816944307, -6.00143972024499],
            [3.7017395310588572, -6.000556793060667],
            [3.7097029184628356, -6.002660558906233],
            [3.712238588870824, -6.001161877987228],
            [3.7204347011091112, -5.99239917259414],
            [3.7295573732041056, -5.991086660498237],
            [3.7332506475835316, -5.988720897023934],
            [3.735320113602688, -5.985144866545284],
            [3.7366930078760223, -5.979029044469116],
            [3.7404366972827328, -5.970831291536959],
            [3.7444088579831223, -5.967026507948011],
            [3.7481967086547354, -5.958495763325733],
            [3.7536382342194408, -5.9514455655657885],
            [3.7576466951860477, -5.952223598096588],
            [3.761379468922808, -5.95563937441241],
            [3.7537250472665704, -5.96482690786465],
            [3.7628803139724423, -5.959185237038656],
            [3.7599201706643015, -5.967512336352761],
            [3.7632652394791952, -5.972191502533336],
            [3.762474050493397, -5.976043109018918],
            [3.7663535735978373, -5.976288325156999],
            [3.7712227122101383, -5.973449454103488],
            [3.770007717304646, -5.980351556378461],
            [3.7674073831964967, -5.982627887570592],
            [3.7679564131315484, -5.98782774206621],
            [3.7720309271345496, -5.984794529137073],
            [3.7800418001671647, -5.980625513556926],
            [3.7836057315691964, -5.97606180144774],
            [3.7824143696016552, -5.972916158746816],
            [3.7769424302639476, -5.972712759153769],
            [3.7730535735077493, -5.9701434126807005],
            [3.7717721990787663, -5.967155501657918],
            [3.774796107712245, -5.961018208322124],
            [3.780773810932866, -5.9610044642718885],
            [3.786186660741639, -5.969934636707562],
            [3.788839966710198, -5.971525457984834],
            [3.795677998505756, -5.972076600548531],
            [3.8015204690979987, -5.9641224261549],
            [3.8117292488516346, -5.967470184722284],
            [3.817828310918786, -5.965170545815888],
            [3.82268967223768, -5.964979256849807],
            [3.829206529931618, -5.959703105023971],
            [3.8330267657859554, -5.965161674735183],
            [3.8332156914837783, -5.971692479647807],
            [3.8369980678973272, -5.984798232249611],
            [3.842398788261608, -5.9931579931899135],
            [3.849621855703906, -5.997806474998562],
            [3.852961482382159, -6.0016348474843095],
            [3.854285360262523, -6.005509545404505],
            [3.8654073538257676, -6.011067284925923],
            [3.8690741282150127, -6.003478979720681],
            [3.8743752453736935, -6.00183112529763],
            [3.8780621591461535, -6.0030383850516245],
            [3.8845642239117515, -6.00765840584067],
            [3.886872267524667, -6.014468052425111],
            [3.884348553507829, -6.018937366134109],
            [3.878304087939908, -6.020023802928646],
            [3.8747804982118264, -6.024212031969545],
            [3.8749684786785505, -6.031753805915628],
            [3.8779153670633364, -6.03968219589616],
            [3.8778725013497812, -6.0448037552307525],
            [3.875438611243883, -6.047758790114076],
            [3.875773926196289, -6.050867901177369],
            [3.8692197363823513, -6.061238070951879],
            [3.86869598795025, -6.065234521820109],
            [3.8621738062883177, -6.073083645318878],
            [3.863437762595696, -6.082984818345622],
            [3.869945625733494, -6.088241375712329],
            [3.8743732912161617, -6.085689467389271],
            [3.8777132887105723, -6.087397812084312],
            [3.8792184773303613, -6.092426462064549],
            [3.8754319144961236, -6.098318391032983],
            [3.8764326768341015, -6.103339387541312],
            [3.8801532131221923, -6.1127172241549035],
            [3.881910057089801, -6.121851221423415],
            [3.887293452717673, -6.129350687568176],
            [3.8936884352670624, -6.133506623204445],
            [3.892485950784213, -6.135674857166427],
            [3.8964093187446736, -6.141045203538106],
            [3.8976934242095855, -6.14805168509288],
            [3.8971828713064784, -6.1533085749882455],
            [3.8901367234553463, -6.163041277239092],
            [3.8849233859405308, -6.171750072717095],
            [3.8746377568589674, -6.1770669669038],
            [3.8723216055408805, -6.184872546664769],
            [3.86968279766453, -6.186066448822359],
            [3.870914446949286, -6.190201695836998],
            [3.8679062360235887, -6.196969561506391],
            [3.8690116412694464, -6.200921940011867],
            [3.866190768860208, -6.2047338620548524],
            [3.8647047018590803, -6.211179467205838],
            [3.86801991082737, -6.212804685131135],
            [3.8664281917168037, -6.221211632151348],
            [3.86343082744149, -6.220775518312535],
            [3.859711814669585, -6.228664965553138],
            [3.856004651698458, -6.230393655124568],
            [3.850091240433647, -6.238472200880304],
            [3.849755606772616, -6.242454098604156],
            [3.8436762945139753, -6.247645620924074],
            [3.8451543344382477, -6.250560511626551],
            [3.8406239487053195, -6.255403198715938],
            [3.838868778274216, -6.254068543617922],
            [3.8349146194950445, -6.25747606197027],
            [3.8319672048596245, -6.265280609611578],
            [3.8290105138485173, -6.269793159678476],
            [3.8231214222289176, -6.284593283028424],
            [3.818952286570544, -6.29151545065212],
            [3.818778026987541, -6.298523356538502],
            [3.8166393122752074, -6.301630379454458],
            [3.8157139234590303, -6.309833607110578],
            [3.8185069339647306, -6.317794263335418],
            [3.814314791539456, -6.323849162879721],
            [3.8148547630029483, -6.329642318710367],
            [3.8165317520882454, -6.334035764059933],
            [3.8143659940114194, -6.341408752976533],
            [3.814521266706196, -6.344905489975994],
            [3.8103335221263115, -6.348576274106988],
            [3.809458899629426, -6.3533718660061185],
            [3.812211549919978, -6.353904170032253],
            [3.8118121077587395, -6.359710893923121],
            [3.8094515790916876, -6.3747698692391195],
            [3.8043358200719335, -6.387289799837154],
            [3.797940343088521, -6.394156664916526],
            [3.797994079208524, -6.395656243373597],
            [3.737483396429823, -6.3984948062952505],
            [3.73837458692367, -6.41661087745565],
            [3.6994419085909036, -6.41808431854754],
            [3.6995010838580864, -6.413174142025813],
            [3.6936948285415365, -6.409496557232392],
            [3.6896585530081176, -6.405486564286184],
            [3.6884828051799006, -6.400664746740082],
            [3.6846938338762647, -6.400657710469136],
            [3.5646268756291883, -6.404887676620091],
            [3.5630989357525618, -6.3613369046957535],
            [3.4727602440153156, -6.277709679203894],
            [3.4694918046630048, -6.190226930375244]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.1548743617451, "lat": 32.478377927839055 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22073"],
        "coty_name": ["Ouachita"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Ouachita Parish"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00558114"
      },
      "bbox": [
        3.4664238943134755, -6.41808431854754, 3.8976934242095855,
        -5.9514455655657885
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8901367234553463, -6.163041277239092],
            [3.892407831393909, -6.163072182381029],
            [3.8976168410252585, -6.159598664345928],
            [3.900444021234597, -6.152641294836614],
            [3.8998580712774493, -6.147495471729303],
            [3.9011645019617665, -6.1454208280481435],
            [3.90050677576902, -6.138931884538754],
            [3.9016085820850184, -6.132768592450156],
            [3.9101460167432385, -6.124106516882936],
            [3.9187308496775826, -6.13071741297477],
            [3.9185602291313866, -6.1335751609878475],
            [3.928470698812914, -6.144798426017045],
            [3.9324932182987626, -6.145448935384582],
            [3.9364941402687332, -6.14866621750174],
            [3.946436413808952, -6.14921621789899],
            [3.9514963011022872, -6.147664940288231],
            [3.951330756022302, -6.136231777156279],
            [3.950032009525559, -6.130485420354075],
            [3.951657760224637, -6.122725906486773],
            [3.955633213104487, -6.119608962827733],
            [3.957373333069845, -6.115352249148261],
            [3.961570600174823, -6.1122562567056375],
            [3.9677791241168943, -6.111525259619036],
            [3.9695278015550945, -6.108995387460219],
            [3.9702206132020645, -6.103502851987582],
            [3.968407179522635, -6.1007986116897746],
            [3.9730051134994016, -6.095794416338514],
            [3.9783377284544157, -6.0937475728558965],
            [3.983737945949376, -6.096939596323429],
            [3.9877360504223756, -6.100733524246222],
            [3.991109187128375, -6.099137490848439],
            [3.9944917929910964, -6.100500800275566],
            [3.9954488819977043, -6.104878869545854],
            [4.000613624200828, -6.102656839646406],
            [4.007994823500808, -6.109397121792812],
            [4.012902180289826, -6.107982499324044],
            [4.015805461299953, -6.103789741715349],
            [4.020580689107234, -6.101815910412229],
            [4.0239752652279925, -6.105890117586961],
            [4.030826188501746, -6.103847340563717],
            [4.032924456039484, -6.101358409056255],
            [4.036260346828828, -6.091021206286904],
            [4.0341426421624185, -6.082607835523719],
            [4.035812760143317, -6.074646810223828],
            [4.04087040338654, -6.068360130226318],
            [4.041182388856563, -6.065320799433307],
            [4.047461198598248, -6.056234675156175],
            [4.054287271015905, -6.049891431714174],
            [4.058748178279025, -6.048267318078888],
            [4.064735924282531, -6.049725946821625],
            [4.065856150110001, -6.05261896933872],
            [4.072094186744533, -6.052385792774687],
            [4.07596341934604, -6.045429010603966],
            [4.084869333023304, -6.047299928566756],
            [4.087289175416627, -6.048971448757457],
            [4.094475389887446, -6.041237471557827],
            [4.096968532223689, -6.0351988706058926],
            [4.102130692108967, -6.026678608956773],
            [4.1023788071911795, -6.0214345657622355],
            [4.1067925663630085, -6.019312014277227],
            [4.111083160105657, -6.007260567235224],
            [4.112442903970374, -5.997761600282863],
            [4.114478139670594, -5.995404497461388],
            [4.113472779451174, -5.99159604272239],
            [4.1475224168035245, -5.990184585814305],
            [4.1495866670947885, -6.039051258403765],
            [4.150388922561572, -6.044714424165611],
            [4.15204058060427, -6.075119702306591],
            [4.259498075558399, -6.070005671706723],
            [4.278345273285266, -6.069353369987021],
            [4.279517387147575, -6.073898089925067],
            [4.285111079537371, -6.07975546939476],
            [4.286980036495747, -6.084161532192896],
            [4.2914266638421035, -6.09023331237582],
            [4.282839923723707, -6.098051139307766],
            [4.282448401066804, -6.100752858978788],
            [4.285467706931877, -6.105011658012116],
            [4.283510010008071, -6.1081775246149705],
            [4.279202073953167, -6.1087283961700924],
            [4.275969718000498, -6.110876607034565],
            [4.2720900651303495, -6.110442634712466],
            [4.270158428648334, -6.113902166969119],
            [4.2609109179986895, -6.117719007884457],
            [4.259571842173506, -6.121472397780264],
            [4.262056607871384, -6.1251174451679695],
            [4.260919458848618, -6.129740075010281],
            [4.25795808949105, -6.1327183470702025],
            [4.255433728378566, -6.14249347457373],
            [4.252572962666888, -6.14986881709227],
            [4.248726363019362, -6.149844522983459],
            [4.251605028163423, -6.155276618359748],
            [4.249299002562786, -6.157816889069293],
            [4.251907427141069, -6.161544063335972],
            [4.248696278706881, -6.165549325347977],
            [4.249974972582643, -6.170899657449446],
            [4.249558970953701, -6.175917630646309],
            [4.252238638042786, -6.177348281152008],
            [4.2509213781187, -6.181135704545615],
            [4.253970699247169, -6.183616694190952],
            [4.256653792746154, -6.188900171351097],
            [4.259663020383306, -6.199509237464641],
            [4.259501559060893, -6.20274938399025],
            [4.256859597088016, -6.206337101594336],
            [4.259880460505552, -6.2110767246298195],
            [4.259598328769589, -6.215745488948162],
            [4.254026881489421, -6.213968656630207],
            [4.250859306443926, -6.2179481253956945],
            [4.25073547584122, -6.228085999269041],
            [4.253238410580257, -6.233377345956898],
            [4.251641738996226, -6.238886317451598],
            [4.256524656766914, -6.244086937801298],
            [4.260677049244938, -6.246748209513133],
            [4.19271040224809, -6.249936362274205],
            [4.167054569162828, -6.251271260958742],
            [4.127654980951724, -6.252731717786209],
            [4.131120723309463, -6.254512332865946],
            [4.122899530202364, -6.2598803776103],
            [4.121542634144902, -6.264960730957875],
            [4.1161014584230315, -6.265595849265939],
            [4.116310045871646, -6.269666269868189],
            [4.109074190672566, -6.2731858487354595],
            [4.1039234766181645, -6.270821562687634],
            [4.098355039172051, -6.272174538042757],
            [4.099241447458549, -6.276671360921529],
            [4.090796540536012, -6.276159210051077],
            [4.092544512611248, -6.280640085904075],
            [4.091294954100136, -6.286518933217821],
            [4.082216199744254, -6.290526225182581],
            [4.0758254634185604, -6.2912723171374525],
            [4.077834262690208, -6.297485127637664],
            [4.072460207457281, -6.301623274924331],
            [4.076025874304652, -6.310606762318342],
            [4.074671223801914, -6.316047275797926],
            [4.071313967469935, -6.317747650535094],
            [4.0641362679715485, -6.3181999256815775],
            [4.060551018893484, -6.324710260636328],
            [4.052926662471626, -6.328263224005655],
            [4.049783635343563, -6.327074364090482],
            [4.046057167341128, -6.328984112420233],
            [4.040711745928635, -6.327758110474064],
            [4.039625964001308, -6.323865572495356],
            [4.030718139366797, -6.328824853965734],
            [4.025313821327221, -6.3277784926773535],
            [4.022582337553318, -6.3332377062676635],
            [4.025371992937336, -6.336268617347789],
            [4.0274867461212285, -6.343544074155605],
            [4.025662060034246, -6.358416014179047],
            [4.022073991662528, -6.357657946314362],
            [4.021311229502243, -6.365910508670394],
            [4.020167501220986, -6.368335329125305],
            [4.025775914766916, -6.3698949787234405],
            [4.021739925257009, -6.374608087521804],
            [4.0210211788682635, -6.379925123967074],
            [4.016759038629666, -6.386167810586821],
            [4.017838012766514, -6.394621027202533],
            [4.017439335151288, -6.399952483418114],
            [4.0211061888497515, -6.403142114973518],
            [4.021821765119651, -6.406106271966946],
            [4.019574513405957, -6.411358344581125],
            [4.020235021053062, -6.415311773676953],
            [4.017493788701867, -6.416461898212582],
            [4.016285112024502, -6.424722367905958],
            [4.011747529135456, -6.423059975580384],
            [4.007738369600142, -6.424815589969447],
            [4.009168371548706, -6.4283950326517365],
            [4.002198199093402, -6.4350680381314245],
            [3.9998126085201027, -6.439136252472265],
            [3.9886875270147306, -6.445227503545762],
            [3.981216103243469, -6.45140226256086],
            [3.980502705359153, -6.453747886007308],
            [3.9821392079461413, -6.459801719972298],
            [3.9780069541735057, -6.46201078612615],
            [3.9776705687167073, -6.46926434518202],
            [3.973874351391041, -6.476345829140318],
            [3.972540727924182, -6.481605201420497],
            [3.967411153739329, -6.487759526903421],
            [3.9619832535923725, -6.489703000980501],
            [3.9603998085965215, -6.492144880664201],
            [3.956356622428115, -6.490946991642642],
            [3.9499672102406853, -6.493733009846685],
            [3.9458863748812463, -6.492577219610128],
            [3.9293438417871394, -6.499014811516132],
            [3.928545460134092, -6.503305286385584],
            [3.9238673217575224, -6.510195385620065],
            [3.9242634999550083, -6.512536213910321],
            [3.9208755399510418, -6.516116069176149],
            [3.9214874656167917, -6.511596012903348],
            [3.9192744463108635, -6.507412090310385],
            [3.921933140956285, -6.504827069571573],
            [3.9125218403548523, -6.501380616201022],
            [3.909536935561159, -6.502764878353791],
            [3.9067732972620584, -6.4992188080501085],
            [3.902683546044002, -6.502324310903819],
            [3.8976397502671785, -6.500683500322593],
            [3.892652371650098, -6.503528890321485],
            [3.8882833810522985, -6.5038298294607895],
            [3.881420255509791, -6.498944950051696],
            [3.881191918541444, -6.494694572458128],
            [3.87659015097655, -6.497708563150499],
            [3.8726414490103553, -6.495596940413488],
            [3.86933434181939, -6.496315680827842],
            [3.863774042192451, -6.5006978263365385],
            [3.8582183041591116, -6.500563492765807],
            [3.854455928696189, -6.503756604111523],
            [3.8503654223132155, -6.504756399191881],
            [3.8473274487194242, -6.501750696423656],
            [3.8514639105748376, -6.493449516376324],
            [3.8476253484214564, -6.482839709423697],
            [3.8445555443255093, -6.481045542030524],
            [3.845390644629146, -6.477599836503732],
            [3.8499112403257914, -6.475651414201978],
            [3.8532637134961223, -6.471945620478203],
            [3.850859775522973, -6.466375943245],
            [3.847059632968937, -6.467441519946953],
            [3.8383198310243096, -6.473776327816819],
            [3.8305240215386185, -6.481121062531686],
            [3.825061002541472, -6.481347452012263],
            [3.8228449626329173, -6.478325294423065],
            [3.824784414269466, -6.470130529673098],
            [3.8311982453620015, -6.466810471211872],
            [3.8388176131944847, -6.459176745060294],
            [3.8461717068799146, -6.4575332949165345],
            [3.8480633127983013, -6.45461264630652],
            [3.845842302096839, -6.44748426779023],
            [3.842004270714412, -6.447955478678453],
            [3.8393370261919624, -6.45595601014889],
            [3.835570100753276, -6.458747125986377],
            [3.829623578150496, -6.4598738637217465],
            [3.829436702669363, -6.455464168119053],
            [3.8352250839864026, -6.452068765875407],
            [3.8365239865512737, -6.449567064770531],
            [3.835314462504465, -6.444233365662852],
            [3.8306236923424994, -6.442747357184157],
            [3.824464100323797, -6.442872029885651],
            [3.8235493086489436, -6.43914830432973],
            [3.827924539322238, -6.438503515993411],
            [3.8299084622221575, -6.435711207653956],
            [3.8307983533716423, -6.425137465220384],
            [3.8390339546788086, -6.421026936923275],
            [3.8363391822299215, -6.417932659033892],
            [3.833545270940238, -6.419619510218223],
            [3.8278826977962987, -6.418792872770249],
            [3.827635375026089, -6.41295632384706],
            [3.834145358293049, -6.407633477749987],
            [3.8340090069866966, -6.401071145661282],
            [3.832554761658728, -6.394656906434241],
            [3.797994079208524, -6.395656243373597],
            [3.797940343088521, -6.394156664916526],
            [3.8043358200719335, -6.387289799837154],
            [3.8094515790916876, -6.3747698692391195],
            [3.8118121077587395, -6.359710893923121],
            [3.812211549919978, -6.353904170032253],
            [3.809458899629426, -6.3533718660061185],
            [3.8103335221263115, -6.348576274106988],
            [3.814521266706196, -6.344905489975994],
            [3.8143659940114194, -6.341408752976533],
            [3.8165317520882454, -6.334035764059933],
            [3.8148547630029483, -6.329642318710367],
            [3.814314791539456, -6.323849162879721],
            [3.8185069339647306, -6.317794263335418],
            [3.8157139234590303, -6.309833607110578],
            [3.8166393122752074, -6.301630379454458],
            [3.818778026987541, -6.298523356538502],
            [3.818952286570544, -6.29151545065212],
            [3.8231214222289176, -6.284593283028424],
            [3.8290105138485173, -6.269793159678476],
            [3.8319672048596245, -6.265280609611578],
            [3.8349146194950445, -6.25747606197027],
            [3.838868778274216, -6.254068543617922],
            [3.8406239487053195, -6.255403198715938],
            [3.8451543344382477, -6.250560511626551],
            [3.8436762945139753, -6.247645620924074],
            [3.849755606772616, -6.242454098604156],
            [3.850091240433647, -6.238472200880304],
            [3.856004651698458, -6.230393655124568],
            [3.859711814669585, -6.228664965553138],
            [3.86343082744149, -6.220775518312535],
            [3.8664281917168037, -6.221211632151348],
            [3.86801991082737, -6.212804685131135],
            [3.8647047018590803, -6.211179467205838],
            [3.866190768860208, -6.2047338620548524],
            [3.8690116412694464, -6.200921940011867],
            [3.8679062360235887, -6.196969561506391],
            [3.870914446949286, -6.190201695836998],
            [3.86968279766453, -6.186066448822359],
            [3.8723216055408805, -6.184872546664769],
            [3.8746377568589674, -6.1770669669038],
            [3.8849233859405308, -6.171750072717095],
            [3.8901367234553463, -6.163041277239092]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.76351742489715, "lat": 32.41779950530594 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22083"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Richland Parish"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00559481"
      },
      "bbox": [
        3.797940343088521, -6.516116069176149, 4.2914266638421035,
        -5.990184585814305
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [20.121943069346248, 8.553395316994045],
              [20.12516028026758, 8.557716065212125],
              [20.12663869033207, 8.550582638292811],
              [20.123965105317886, 8.548900500010578],
              [20.121943069346248, 8.553395316994045]
            ]
          ],
          [
            [
              [20.0659823050747, 8.56941297593966],
              [20.067956625140894, 8.571059747498747],
              [20.075161700063912, 8.563707364930728],
              [20.075893926973933, 8.558995787437349],
              [20.06808125981993, 8.563703235794048],
              [20.0659823050747, 8.56941297593966]
            ]
          ],
          [
            [
              [20.030766211268354, 8.615188329417457],
              [20.035029601550562, 8.616285066703817],
              [20.039938652379455, 8.613531718196349],
              [20.043311268191328, 8.609439282362755],
              [20.041927724010822, 8.605860979308654],
              [20.037178044708444, 8.604618788370072],
              [20.031897942841887, 8.611482058929107],
              [20.030766211268354, 8.615188329417457]
            ]
          ],
          [
            [
              [20.019155149148705, 8.629475597913386],
              [20.018527852779435, 8.637899485979274],
              [20.020047485265838, 8.644502568758186],
              [20.023533112427337, 8.644663863306329],
              [20.028065964417117, 8.641976642576354],
              [20.028839252237027, 8.638868013104698],
              [20.027328873052, 8.634551503072663],
              [20.027123449942597, 8.623066072399434],
              [20.02345070077104, 8.62003656315863],
              [20.02052252032227, 8.622678478962008],
              [20.019155149148705, 8.629475597913386]
            ]
          ],
          [
            [
              [20.028456510331825, 8.581612489187517],
              [20.02781059334042, 8.58709547904165],
              [20.030267293575196, 8.589013337976278],
              [20.03318630622114, 8.599733924061296],
              [20.0367469341192, 8.602555417449176],
              [20.040788144163727, 8.597430713150692],
              [20.04446018105596, 8.586565213416103],
              [20.041050178790698, 8.577453427836097],
              [20.037269157025296, 8.573726047222994],
              [20.0328383743791, 8.578867052537293],
              [20.028456510331825, 8.581612489187517]
            ]
          ],
          [
            [
              [19.997639202377105, 8.65538209292944],
              [20.00243992946482, 8.654706774915601],
              [20.007246414413583, 8.652276468176034],
              [20.006024956915844, 8.648750157287935],
              [19.997639202377105, 8.65538209292944]
            ]
          ],
          [
            [
              [20.011077822362704, 8.596831834124549],
              [20.014206355648238, 8.603390946056964],
              [20.017596091868207, 8.6038747713083],
              [20.0161876307535, 8.597476231638124],
              [20.01384466435471, 8.594139903170285],
              [20.011077822362704, 8.596831834124549]
            ]
          ],
          [
            [
              [19.976950050770146, 8.650797787941679],
              [19.9814366509637, 8.65230911322494],
              [19.98835720319964, 8.652791316218293],
              [19.990521991315532, 8.649748833027134],
              [19.976159541820966, 8.649332539766988],
              [19.976950050770146, 8.650797787941679]
            ]
          ],
          [
            [
              [20.033017709009492, 8.433576400379676],
              [20.03600222225415, 8.438192893028495],
              [20.03945219483593, 8.436895290347529],
              [20.04129033101164, 8.432161912369724],
              [20.037912725428914, 8.428759653641901],
              [20.03428126853989, 8.430339199754675],
              [20.033017709009492, 8.433576400379676]
            ]
          ],
          [
            [
              [19.980746906785793, 8.579708627167335],
              [19.988088437452465, 8.583476212682678],
              [19.989248978111366, 8.580779394378936],
              [19.98344350805751, 8.578400858047546],
              [19.980746906785793, 8.579708627167335]
            ]
          ],
          [
            [
              [20.004552628730607, 8.435515235600299],
              [20.00464161263577, 8.441739762088716],
              [20.001946181388604, 8.447126639730643],
              [20.007775362875563, 8.450429263820446],
              [20.010072455831196, 8.448393991572301],
              [20.014267947865473, 8.44997404677103],
              [20.01941076613908, 8.444813329126223],
              [20.010153623717507, 8.440597467195115],
              [20.004552628730607, 8.435515235600299]
            ]
          ],
          [
            [
              [20.021339067205897, 8.360670535739454],
              [20.025822482281768, 8.362932672105291],
              [20.028324845125713, 8.361541859268717],
              [20.025311772507543, 8.356118115775761],
              [20.021339067205897, 8.360670535739454]
            ]
          ],
          [
            [
              [20.02452710112094, 8.340192568433897],
              [20.028283989198982, 8.344740854795118],
              [20.031183702513243, 8.344542939373147],
              [20.029861604410033, 8.338223485849472],
              [20.03451838429244, 8.330412695296827],
              [20.029937944672135, 8.330255960839787],
              [20.02452710112094, 8.340192568433897]
            ]
          ],
          [
            [
              [19.97797740124678, 8.4514116288651],
              [19.988312482183865, 8.454129462809712],
              [19.992582247068817, 8.456985886024338],
              [19.995155431991446, 8.454929932418313],
              [19.994222554768765, 8.45042042811265],
              [19.984261352921486, 8.447636806864942],
              [19.979137795761552, 8.448758322991633],
              [19.97797740124678, 8.4514116288651]
            ]
          ],
          [
            [
              [19.97977308146224, 8.434237141401935],
              [19.985556773876247, 8.434619896556399],
              [19.98777718875873, 8.438789765599694],
              [19.996559352204883, 8.438066099918444],
              [19.99899381813937, 8.43296910611378],
              [20.00647221698459, 8.423846030094284],
              [20.00412739836608, 8.4174041448891],
              [20.001426075761298, 8.416265282310258],
              [19.995778025509505, 8.416683613024293],
              [19.99238874204977, 8.412453983521859],
              [19.98619721665907, 8.413791302873703],
              [19.983469082052785, 8.416809350255392],
              [19.97977308146224, 8.434237141401935]
            ]
          ],
          [
            [
              [19.952435966489194, 8.452112870173936],
              [19.961219672535726, 8.449431454500461],
              [19.95520948443518, 8.445885927052249],
              [19.952435966489194, 8.452112870173936]
            ]
          ],
          [
            [
              [19.952199862247443, 8.358723480539782],
              [19.9555421794247, 8.366422969637856],
              [19.952377057144222, 8.372192639649269],
              [19.954065536590168, 8.374811897601617],
              [19.959777948261433, 8.375269295253634],
              [19.963785610410554, 8.372574239067399],
              [19.965179778222723, 8.368110482469225],
              [19.962201757246497, 8.362132578588286],
              [19.95724934143898, 8.356687666014123],
              [19.95243183658427, 8.355613328300654],
              [19.952199862247443, 8.358723480539782]
            ]
          ],
          [
            [
              [19.880420731029794, 8.588765219764817],
              [19.886128751613043, 8.589752947483383],
              [19.888791734903382, 8.587379902856837],
              [19.885099665653133, 8.58206977497178],
              [19.88073153171243, 8.586573118203965],
              [19.880420731029794, 8.588765219764817]
            ]
          ],
          [
            [
              [19.948100031833352, 8.34355704732815],
              [19.95024088931306, 8.350549133096058],
              [19.957240940472957, 8.350857695372374],
              [19.960071770190797, 8.34868446784863],
              [19.96226476562736, 8.344221751014862],
              [19.960711844666463, 8.33704866116518],
              [19.95330631021046, 8.333971493254547],
              [19.950108070876016, 8.338424843894174],
              [19.948100031833352, 8.34355704732815]
            ]
          ],
          [
            [
              [19.951825273981154, 8.27839839549599],
              [19.955080603178544, 8.283976231204713],
              [19.960375395942027, 8.285736900928947],
              [19.960989975347168, 8.29024290554797],
              [19.965507412164946, 8.295042784000985],
              [19.968544743123413, 8.294518679525044],
              [19.96889126427668, 8.29076264609535],
              [19.97666134463361, 8.287804234893937],
              [19.9750051465933, 8.283704203917571],
              [19.975795440762973, 8.280426689479397],
              [19.9846798821311, 8.280826674498453],
              [19.98234365834831, 8.272090146299753],
              [19.97839711963085, 8.272588189348788],
              [19.97791414869047, 8.276012894426199],
              [19.97480142703708, 8.276459657222759],
              [19.973518501710576, 8.272767733479096],
              [19.96788019511831, 8.270406961066323],
              [19.96482748433535, 8.271421347443935],
              [19.96167431087055, 8.262681591210624],
              [19.959360075643815, 8.271128972471528],
              [19.95779062063217, 8.27348141336601],
              [19.953856970482843, 8.27333984817417],
              [19.951825273981154, 8.27839839549599]
            ]
          ],
          [
            [
              [19.931010119879474, 8.345934465462747],
              [19.93255456997346, 8.351818514225418],
              [19.935974603167818, 8.357904547718064],
              [19.942468000889907, 8.361855004469005],
              [19.946664418471933, 8.358849004953642],
              [19.94445601411429, 8.355016060686156],
              [19.941226432637617, 8.345760310470308],
              [19.93686916519755, 8.340231502897959],
              [19.929890089058368, 8.342571441297233],
              [19.931010119879474, 8.345934465462747]
            ]
          ],
          [
            [
              [19.85467036263476, 8.55356477276292],
              [19.857053710974363, 8.557958879599465],
              [19.862459816279333, 8.552352902273864],
              [19.858957442596143, 8.54815446473295],
              [19.85467036263476, 8.55356477276292]
            ]
          ],
          [
            [
              [19.84041395817102, 8.448036484132333],
              [19.843900842115364, 8.45100517110159],
              [19.849166308334336, 8.440585532330958],
              [19.849508045610175, 8.43593106255033],
              [19.84416077489791, 8.436642658614723],
              [19.84393897552444, 8.44267103858038],
              [19.84041395817102, 8.448036484132333]
            ]
          ],
          [
            [
              [19.830633808664963, 8.478751631159147],
              [19.832139379480004, 8.48766166293452],
              [19.831533861113687, 8.492509296320438],
              [19.836260294900217, 8.498377295082767],
              [19.83801793771724, 8.507251901233108],
              [19.83997570935932, 8.509958835796862],
              [19.843909285753618, 8.511361287499478],
              [19.855781693534237, 8.499565687392613],
              [19.853770692491203, 8.491582765986294],
              [19.85161166914694, 8.487602633024402],
              [19.850752223434835, 8.480486659107232],
              [19.854621148897955, 8.470012766206848],
              [19.85355004866702, 8.46476871419155],
              [19.850122540415466, 8.463227909366276],
              [19.848417027526967, 8.460084636927013],
              [19.843809043676533, 8.462590400500071],
              [19.842843131274922, 8.474456520391842],
              [19.84055273286931, 8.476772276383704],
              [19.8377268254463, 8.472067032833463],
              [19.833401044595387, 8.474218350865327],
              [19.830633808664963, 8.478751631159147]
            ]
          ],
          [
            [
              [19.851785433847862, 8.397839851777432],
              [19.856354558513214, 8.397954354099602],
              [19.858273986242455, 8.395699856719949],
              [19.85544450946234, 8.392749550173868],
              [19.851785433847862, 8.397839851777432]
            ]
          ],
          [
            [
              [19.862435528797512, 8.340436085195226],
              [19.864849201700636, 8.343314694724262],
              [19.864572056586503, 8.346585669680175],
              [19.86940624016466, 8.346423834995415],
              [19.87358756054723, 8.343762957353084],
              [19.871078623737993, 8.338877456826863],
              [19.864403177838376, 8.338847457530257],
              [19.862435528797512, 8.340436085195226]
            ]
          ],
          [
            [
              [19.846413150942425, 8.362755039930788],
              [19.849993733145553, 8.367338730069111],
              [19.854744580781514, 8.36626951045794],
              [19.85754219315429, 8.362861834358489],
              [19.85515025939605, 8.356687248711939],
              [19.850821397370808, 8.355764248618968],
              [19.846689546774645, 8.35948530050405],
              [19.846413150942425, 8.362755039930788]
            ]
          ],
          [
            [
              [19.84805076385874, 8.33730411353148],
              [19.848121401600388, 8.348418010459566],
              [19.850349311429788, 8.352625872169657],
              [19.854140477267354, 8.35180258795313],
              [19.860080208190414, 8.34561418517328],
              [19.860487255292643, 8.341321995560456],
              [19.857833435338833, 8.335421969452712],
              [19.84914802874312, 8.334721260628143],
              [19.84805076385874, 8.33730411353148]
            ]
          ],
          [
            [
              [19.82339908899742, 8.412733013996684],
              [19.824992245827456, 8.41390736921347],
              [19.831966369206764, 8.411910008301266],
              [19.838144601256438, 8.407765155491914],
              [19.843281415408434, 8.406083234761798],
              [19.845411139251148, 8.403714657712477],
              [19.845605655734744, 8.39954323749297],
              [19.841232004945677, 8.400534865721411],
              [19.83649624377518, 8.399912434948506],
              [19.831872507500503, 8.401276085829679],
              [19.82339908899742, 8.412733013996684]
            ]
          ],
          [
            [
              [19.85484294490969, 8.288809187934731],
              [19.8532700077807, 8.294409902577462],
              [19.85599328221397, 8.297590527623417],
              [19.855944328614466, 8.302253025346014],
              [19.859719319040664, 8.307615548627263],
              [19.86245321529621, 8.305358269036743],
              [19.864390111220875, 8.300101261935787],
              [19.86885261742797, 8.300003794316986],
              [19.86758309466749, 8.309519297555545],
              [19.861503966611053, 8.318563162319757],
              [19.8644769088133, 8.320842139622648],
              [19.868300190739664, 8.320678851894487],
              [19.871168278045847, 8.331821010023369],
              [19.878083705577474, 8.334687957340343],
              [19.88252928259883, 8.328761273791958],
              [19.886910727629438, 8.320696022124633],
              [19.885739336446527, 8.317524202693898],
              [19.895575337023466, 8.315483287870789],
              [19.903225441051653, 8.324807438864974],
              [19.902946410302437, 8.328080620481035],
              [19.89884199434798, 8.331106267617253],
              [19.89908401334537, 8.33559198997207],
              [19.90541548702624, 8.338698703668266],
              [19.90983108043314, 8.333469741447706],
              [19.912126284814022, 8.328847854672496],
              [19.917570273654338, 8.326044689660456],
              [19.92330296915223, 8.325266746836999],
              [19.924822306173894, 8.321721855609516],
              [19.935087425163502, 8.31444347582125],
              [19.928981481864753, 8.310915988347492],
              [19.928499209710335, 8.308191151124948],
              [19.932706215190372, 8.299505382985265],
              [19.929559641624166, 8.29618411372654],
              [19.927453918331008, 8.29068070198923],
              [19.92264275476399, 8.288075968656353],
              [19.92105160230386, 8.284312483558667],
              [19.917963483478054, 8.283235073431692],
              [19.91742486193547, 8.27245540560663],
              [19.90861139618668, 8.265518459170199],
              [19.898971031054188, 8.272413650027257],
              [19.897483963657564, 8.280172764921568],
              [19.890993670600803, 8.281810070996965],
              [19.888596061256134, 8.283918680310434],
              [19.88727580060505, 8.288300225177624],
              [19.888545017093055, 8.294682817987898],
              [19.883821290048896, 8.29858821816073],
              [19.88414575161941, 8.303984121061143],
              [19.88144211908, 8.303539673291562],
              [19.87961866398144, 8.296641831337778],
              [19.871914845833924, 8.294547002756289],
              [19.872402799822748, 8.291157187506855],
              [19.870948699550212, 8.285686357008684],
              [19.86751921821313, 8.281131335780293],
              [19.863760715996435, 8.286245666786845],
              [19.859582025766613, 8.283004640004599],
              [19.853815631730427, 8.285150268499539],
              [19.85484294490969, 8.288809187934731]
            ]
          ],
          [
            [
              [19.854474252994166, 8.24649107322544],
              [19.85466664506341, 8.251647075406837],
              [19.856395802721757, 8.255337849705061],
              [19.856180616733102, 8.259280748108392],
              [19.86174323228564, 8.262922750846657],
              [19.867397237166642, 8.259462169937118],
              [19.871715830325222, 8.259851022959932],
              [19.871116062431366, 8.255225305211237],
              [19.874086052501664, 8.248756592221051],
              [19.86845262599812, 8.242977013606463],
              [19.87022789961007, 8.239433198817638],
              [19.86959214953156, 8.233686940662626],
              [19.86494621875605, 8.237522996767524],
              [19.857589568878048, 8.238556134248515],
              [19.854474252994166, 8.24649107322544]
            ]
          ],
          [
            [
              [19.783451250115775, 8.453775348988358],
              [19.781502974589568, 8.464609266379764],
              [19.78301417515701, 8.47928545385895],
              [19.779513716330175, 8.487811256483964],
              [19.777966940660868, 8.501254295088685],
              [19.78090068348256, 8.506025778225066],
              [19.784221107535572, 8.507437591046902],
              [19.78936212080724, 8.505910781049618],
              [19.794828766678577, 8.494486688975085],
              [19.803882261194655, 8.482850511358059],
              [19.811830087857544, 8.469358430437099],
              [19.812708658998872, 8.461172259543005],
              [19.816133382940233, 8.457643402546307],
              [19.821186646985048, 8.455926663262956],
              [19.822744245031465, 8.450832137460141],
              [19.820550154528856, 8.445705409931348],
              [19.81633114387079, 8.440889066519903],
              [19.80705010660602, 8.450001602046852],
              [19.796369193203713, 8.448482427457222],
              [19.79486153621734, 8.446477926706153],
              [19.7898019054799, 8.445725171396148],
              [19.782376992958394, 8.44970769852064],
              [19.783451250115775, 8.453775348988358]
            ]
          ],
          [
            [
              [19.798293655556893, 8.348415819690308],
              [19.800166059888717, 8.349848392296089],
              [19.8087082436355, 8.349714606859582],
              [19.808613757745473, 8.344571648798956],
              [19.80591994545127, 8.343074356727268],
              [19.8003575965769, 8.345671919587334],
              [19.798293655556893, 8.348415819690308]
            ]
          ],
          [
            [
              [19.7880119748511, 8.33428379082017],
              [19.79086094997008, 8.336002858405738],
              [19.79662040657342, 8.334520488235347],
              [19.79479424762185, 8.331161261257455],
              [19.7880119748511, 8.33428379082017]
            ]
          ],
          [
            [
              [19.79692284402451, 8.264494057402592],
              [19.800381306937616, 8.268210669818458],
              [19.803364392904697, 8.26768856460119],
              [19.802607417733274, 8.262580749657342],
              [19.80061821955767, 8.260937052728314],
              [19.79692284402451, 8.264494057402592]
            ]
          ],
          [
            [
              [19.772322603926227, 8.344666627122121],
              [19.777402274937003, 8.347215962376874],
              [19.78202029076994, 8.3453977573601],
              [19.781284834684946, 8.342536491926818],
              [19.775196630484906, 8.340396927908003],
              [19.772322603926227, 8.344666627122121]
            ]
          ],
          [
            [
              [19.776244234600984, 8.291394188584155],
              [19.782611416362716, 8.292027196547648],
              [19.78213860082134, 8.288805664559995],
              [19.77604459176368, 8.288511808378642],
              [19.776244234600984, 8.291394188584155]
            ]
          ],
          [
            [
              [19.783147612305875, 8.256515744534589],
              [19.78881810809759, 8.257120007879983],
              [19.79044320495642, 8.254064169526321],
              [19.788596469712264, 8.250165560613167],
              [19.785991153808798, 8.25116701580053],
              [19.783147612305875, 8.256515744534589]
            ]
          ],
          [
            [
              [19.773511556770544, 8.26146081399939],
              [19.774466225317994, 8.267745057220504],
              [19.778672842788016, 8.267744459603668],
              [19.78101715774374, 8.258894143273745],
              [19.777462877126187, 8.257145350734234],
              [19.77432104921254, 8.258166804517167],
              [19.773511556770544, 8.26146081399939]
            ]
          ],
          [
            [
              [19.77551921634776, 8.253572054717255],
              [19.77833837057615, 8.254221695571172],
              [19.780269279076197, 8.248959356814726],
              [19.774749627420636, 8.251403557423743],
              [19.77551921634776, 8.253572054717255]
            ]
          ],
          [
            [
              [19.77651779705777, 8.236021492619857],
              [19.78074227825248, 8.238496811293665],
              [19.780927525483634, 8.242615212181603],
              [19.789004122305798, 8.241225738670561],
              [19.786564914582108, 8.238066858966521],
              [19.786357135560237, 8.233959271865217],
              [19.781102634402327, 8.23133900052245],
              [19.77547095037881, 8.233593490401196],
              [19.77651779705777, 8.236021492619857]
            ]
          ],
          [
            [
              [19.763864883467843, 8.259340130548571],
              [19.766197935858287, 8.261612480448974],
              [19.769520589452327, 8.261174002425903],
              [19.769122454692436, 8.257171809598317],
              [19.766477594458973, 8.253570441884007],
              [19.763864883467843, 8.259340130548571]
            ]
          ],
          [
            [
              [19.76705078972811, 8.23625005083762],
              [19.770754310970705, 8.239279362049913],
              [19.772393496428386, 8.234988526424381],
              [19.768432545883464, 8.231970697507359],
              [19.76705078972811, 8.23625005083762]
            ]
          ],
          [
            [
              [19.751402200138475, 8.250037053848434],
              [19.756226376442516, 8.251096903043953],
              [19.75471764124013, 8.24606338238033],
              [19.751402200138475, 8.250037053848434]
            ]
          ],
          [
            [
              [19.67732402619774, 8.307908211171366],
              [19.681480901875478, 8.31369436896151],
              [19.684455567411746, 8.315010242936065],
              [19.68530784209712, 8.318337135679377],
              [19.692780661743345, 8.324613773654546],
              [19.697119874174902, 8.324400985549406],
              [19.6943264836804, 8.332572084858874],
              [19.693898594180943, 8.337988031482109],
              [19.695538073063542, 8.346321249206888],
              [19.701626942557944, 8.358492193030465],
              [19.701586768568372, 8.362179097885544],
              [19.699412616210743, 8.369633596566146],
              [19.69902973692748, 8.374286964497854],
              [19.702850565166067, 8.374525181231624],
              [19.706892233370496, 8.371657429945715],
              [19.711190397535937, 8.36675053843278],
              [19.715354691572877, 8.367617636948827],
              [19.7185453766684, 8.36168183048567],
              [19.721675762986767, 8.36541663090015],
              [19.72900274392998, 8.365884981414723],
              [19.737798372668987, 8.3606260054512],
              [19.74025947503882, 8.363637918634476],
              [19.74767793677816, 8.355416221678942],
              [19.754957399912634, 8.353195012585127],
              [19.76085191712934, 8.343944689845785],
              [19.76558814167032, 8.334049808665947],
              [19.77385651902752, 8.335418111167526],
              [19.780299596279438, 8.335193349345616],
              [19.780992774914584, 8.329930112599198],
              [19.787221078687704, 8.326290030577715],
              [19.796431516539, 8.325114775289295],
              [19.800910190980353, 8.311962591416117],
              [19.799180728565204, 8.308277377824501],
              [19.792246676949713, 8.302812938501528],
              [19.775571676478265, 8.304874377698708],
              [19.77505420981568, 8.307193095350561],
              [19.781342273950656, 8.310449852664128],
              [19.78089417598118, 8.316670748010653],
              [19.774808529102103, 8.318060148305287],
              [19.774942700363734, 8.320568928960698],
              [19.7693459978333, 8.3221021104651],
              [19.768898578033575, 8.316502065349841],
              [19.76637046460235, 8.313114046895386],
              [19.759885186520233, 8.308742816887538],
              [19.764105496048693, 8.30115890068285],
              [19.769126421861923, 8.295042752985246],
              [19.769446569886945, 8.291606786228622],
              [19.766672144258187, 8.287263279181238],
              [19.763466542477797, 8.278241596467305],
              [19.75823682440697, 8.27755369082916],
              [19.75187191488902, 8.278689367752756],
              [19.7518898805848, 8.27092784896098],
              [19.757364512065283, 8.27217873941069],
              [19.758418831677744, 8.269838940820621],
              [19.75759414794408, 8.264300758989275],
              [19.75162417877463, 8.259372912581345],
              [19.74497298624339, 8.256719004200239],
              [19.74094307389815, 8.253597784666994],
              [19.747084622995853, 8.237473188760326],
              [19.735413825296558, 8.237432441027385],
              [19.72773544296168, 8.249762212810872],
              [19.719961737724333, 8.250731711576426],
              [19.718612656949304, 8.253107877787462],
              [19.711327282504673, 8.250280500190158],
              [19.71244975776908, 8.257621740414265],
              [19.7074236947289, 8.26021217053229],
              [19.699101911319076, 8.260780990208298],
              [19.699461455313422, 8.266710115086566],
              [19.69714499738542, 8.27074043778154],
              [19.69688316682034, 8.276772457446054],
              [19.69982474462319, 8.28093089376675],
              [19.696021478790076, 8.289521931995122],
              [19.689415008264884, 8.285596488693635],
              [19.683094921756155, 8.288433624782531],
              [19.690290690166158, 8.295077830984392],
              [19.688882579853427, 8.299193816650728],
              [19.67732402619774, 8.307908211171366]
            ]
          ],
          [
            [
              [19.6470315228951, 8.380662646613125],
              [19.647545235241925, 8.387191408932171],
              [19.651425395135018, 8.389258956346247],
              [19.656314197098702, 8.38662022148134],
              [19.674481263958697, 8.382640410817853],
              [19.6758384607322, 8.380020907136906],
              [19.6795096080407, 8.379374054481636],
              [19.682975429772622, 8.380875430078879],
              [19.69086309037882, 8.375257411459682],
              [19.688863579692704, 8.372408697293848],
              [19.690676488404197, 8.36724638483268],
              [19.68722162456762, 8.362357960005822],
              [19.683856963051266, 8.359835814057561],
              [19.676829045546803, 8.360982859363132],
              [19.66893010379093, 8.365799733407519],
              [19.665640233681486, 8.365429853002317],
              [19.662197154711865, 8.368340802941667],
              [19.660662670183747, 8.37397442993101],
              [19.65199381376279, 8.377283392529844],
              [19.648727191702918, 8.376309504661167],
              [19.6470315228951, 8.380662646613125]
            ]
          ],
          [
            [
              [19.646033252668825, 8.348351935526722],
              [19.655080939362982, 8.347126579144682],
              [19.65892068283954, 8.35041778987354],
              [19.66489917621493, 8.342828369833196],
              [19.66011561195402, 8.344014975650998],
              [19.65528299434763, 8.341795750455772],
              [19.646414225745602, 8.346593424805969],
              [19.646033252668825, 8.348351935526722]
            ]
          ],
          [
            [
              [19.64811898435311, 8.323136178061368],
              [19.649042999564294, 8.325875530282703],
              [19.6559902787543, 8.32600388296479],
              [19.65914841504747, 8.32353311480607],
              [19.65252829396255, 8.3184305791146],
              [19.649352741263506, 8.31917578820146],
              [19.64811898435311, 8.323136178061368]
            ]
          ],
          [
            [
              [19.642349618514857, 8.286030456271861],
              [19.648927964475295, 8.296219984406639],
              [19.654194272355436, 8.295551952870058],
              [19.65411155265117, 8.292119973872765],
              [19.65025685452758, 8.284018089950466],
              [19.65216095240785, 8.280426172304438],
              [19.650345005830143, 8.277604582134721],
              [19.646849472483627, 8.283053057236263],
              [19.642349618514857, 8.286030456271861]
            ]
          ],
          [
            [
              [19.614031335936133, 8.354275103550716],
              [19.616541017646835, 8.35672516995592],
              [19.62321811674605, 8.35567818693504],
              [19.619654538175524, 8.3526467244573],
              [19.614031335936133, 8.354275103550716]
            ]
          ],
          [
            [
              [19.62709511761793, 8.306967398989272],
              [19.631909018461958, 8.309108093600036],
              [19.639029144785948, 8.305785056400806],
              [19.639777918953236, 8.299169545038273],
              [19.63135467675303, 8.300215587918716],
              [19.628135931857962, 8.302521142261185],
              [19.62709511761793, 8.306967398989272]
            ]
          ],
          [
            [
              [19.611309736229114, 8.282619032170528],
              [19.61508554323989, 8.28961830891413],
              [19.6164728845337, 8.28554783617273],
              [19.611309736229114, 8.282619032170528]
            ]
          ],
          [
            [
              [19.605792527153564, 8.298502362067957],
              [19.60792580922558, 8.301212763938258],
              [19.606537132449976, 8.305556691991745],
              [19.61215771910785, 8.310195274865977],
              [19.615490856350675, 8.305527455182872],
              [19.613181577903564, 8.30240339546189],
              [19.61408813112569, 8.295957375809238],
              [19.609373289181708, 8.29474100971793],
              [19.605792527153564, 8.298502362067957]
            ]
          ],
          [
            [
              [19.489216314661206, 8.729713204642641],
              [19.500028703160623, 8.738095799252974],
              [19.504313374325417, 8.735898910858234],
              [19.508686598935853, 8.738367003842946],
              [19.511597584120757, 8.730735055715352],
              [19.51427284589982, 8.731867837262007],
              [19.525157709131378, 8.731860731908002],
              [19.524557858337584, 8.720060696600685],
              [19.534833120179023, 8.720516159157548],
              [19.544680370006844, 8.721927589176499],
              [19.54621170088119, 8.759082683039663],
              [19.552946481814264, 8.768789888619088],
              [19.563425232279876, 8.790480869000477],
              [19.59833460461012, 8.782063251519553],
              [19.608415107887566, 8.823592348008294],
              [19.648264264279685, 8.84327131908568],
              [19.71861062462301, 8.878713050650138],
              [19.701010487296625, 8.913330598539444],
              [19.6603169853846, 8.991737154169423],
              [19.618447042662403, 9.073980988260509],
              [19.69841558859825, 9.114728981743148],
              [19.659564539702764, 9.191907988994608],
              [19.67393743081463, 9.198987903998475],
              [19.740122914215654, 9.233088226460577],
              [19.697297466997743, 9.313560239522635],
              [19.68277691930327, 9.341314700104189],
              [19.761183761442453, 9.380698613536008],
              [19.841392124961096, 9.420491768329514],
              [19.876226311721847, 9.356919848148513],
              [19.926574045597572, 9.255871291209456],
              [19.97692128416628, 9.154759104237073],
              [19.89849199708734, 9.113948205746768],
              [19.928847398076023, 9.054023026415653],
              [19.982347690709855, 8.95541522396969],
              [20.023080659690443, 8.8772877794755],
              [20.034957862927154, 8.88346676058007],
              [20.074842704065393, 8.807961936428505],
              [20.059645807195217, 8.800223074626693],
              [20.101557562750887, 8.725193671106659],
              [20.106546029867058, 8.722546031546276],
              [20.11340331653698, 8.721990202434275],
              [20.118997850641236, 8.714017298062679],
              [20.120895306807867, 8.704724849609024],
              [20.120576741111396, 8.701953876415576],
              [20.117288415211892, 8.69768328953362],
              [20.115569241862655, 8.694523217194332],
              [20.11362681580091, 8.683574384950628],
              [20.1060431122533, 8.686394300047992],
              [20.104368576655474, 8.683784366271476],
              [20.09749606704375, 8.687169420499515],
              [20.095796072947163, 8.693861808225336],
              [20.089179597988238, 8.694688170418415],
              [20.085940460069253, 8.69775732975125],
              [20.083674003683758, 8.697078188366982],
              [20.085548419821983, 8.690965412449781],
              [20.088422333472433, 8.686206222660944],
              [20.09132568160501, 8.6784678081584],
              [20.097169664286174, 8.676706229626861],
              [20.100706316536197, 8.672670590472425],
              [20.106233919997386, 8.673097484168563],
              [20.107525631456536, 8.67596970591318],
              [20.11257065003208, 8.673768574735247],
              [20.114206050434543, 8.67074358827049],
              [20.11987746246232, 8.668402266265236],
              [20.126646089352977, 8.667093958774368],
              [20.134255008078174, 8.656719945809547],
              [20.13803750603618, 8.649590383664997],
              [20.14133571640237, 8.648646538492905],
              [20.142576562561523, 8.640576229844244],
              [20.148157163979228, 8.640844314609224],
              [20.151270021282475, 8.636501385260146],
              [20.149651132398567, 8.634255672064604],
              [20.154840362562243, 8.631768426694174],
              [20.147890261955702, 8.626160727268921],
              [20.145076367284616, 8.620916115173667],
              [20.145061855173385, 8.614048049430348],
              [20.142031837439834, 8.612962226306866],
              [20.13141487210332, 8.621717332075335],
              [20.126034409319292, 8.628750071623449],
              [20.120541685717832, 8.633962925734334],
              [20.11557428991974, 8.634583454990867],
              [20.11758112960115, 8.625158876130643],
              [20.112945090520185, 8.624120054089891],
              [20.10766667433665, 8.625176469141223],
              [20.111051579855797, 8.619330724976164],
              [20.113356075017485, 8.619318076727483],
              [20.119693734248454, 8.612317524245904],
              [20.12083962878277, 8.608188334396162],
              [20.118441355665624, 8.604401380843889],
              [20.115948646874614, 8.59632058165053],
              [20.117436018565673, 8.5927348332682],
              [20.11677545369505, 8.587960198565451],
              [20.120317143244694, 8.58391552122206],
              [20.121662576735208, 8.578044637229004],
              [20.113407403814143, 8.582197011218017],
              [20.11029885454941, 8.580208784481632],
              [20.10743033063763, 8.575124105097048],
              [20.109851542031986, 8.567220088197418],
              [20.113430202576502, 8.562168056590298],
              [20.11484953398296, 8.55321725972697],
              [20.112893538504633, 8.548601338092498],
              [20.107956893646612, 8.554323851039715],
              [20.105004103191078, 8.547542554555411],
              [20.09936051260896, 8.549691376629672],
              [20.089651197300057, 8.559461257709629],
              [20.081122428961912, 8.582937399434767],
              [20.08236393602361, 8.586456132164255],
              [20.076817133170444, 8.597643508343506],
              [20.07291881418915, 8.594190224338723],
              [20.065624138351154, 8.596055160007674],
              [20.065813316523432, 8.593121173109742],
              [20.07324853644258, 8.5844340992558],
              [20.07451642778543, 8.579709103403518],
              [20.071422389637984, 8.577862992339837],
              [20.063167535613765, 8.584412033144654],
              [20.058708490907065, 8.592053089147576],
              [20.060591698431004, 8.596310739903672],
              [20.05868272481996, 8.599082790207953],
              [20.05561713587527, 8.598693880229739],
              [20.04936236327062, 8.603007611651256],
              [20.046376300971083, 8.609827630385176],
              [20.046704510399067, 8.618014470016691],
              [20.039424787084332, 8.626211893527962],
              [20.03143202969943, 8.64329238795481],
              [20.02770288321826, 8.656520141886416],
              [20.029338205349525, 8.659221248393097],
              [20.02812877115688, 8.665339744507243],
              [20.0207598524126, 8.674571858639109],
              [20.014519424919907, 8.66954909549887],
              [20.008605640706865, 8.670452273100187],
              [20.006366407683288, 8.674840453939742],
              [20.00584922397934, 8.679426579501747],
              [20.00321341211883, 8.682852521304387],
              [19.999062110083337, 8.68372076651594],
              [19.994970050431135, 8.686711373678017],
              [19.989926196847883, 8.688190591944023],
              [19.98680100680439, 8.687434822166834],
              [19.9890191562502, 8.682480498935957],
              [19.988481218942887, 8.675266549203084],
              [19.98686028116565, 8.672184066881993],
              [19.994963878474806, 8.661256807862213],
              [19.989422164463395, 8.65618132275542],
              [19.972918919355916, 8.65300311293768],
              [19.97531251797815, 8.657332814597055],
              [19.981564702909758, 8.65884424188881],
              [19.975196979232862, 8.664399593068296],
              [19.97318993825673, 8.669514698471927],
              [19.969255632917754, 8.66932949400986],
              [19.96509490594639, 8.672895472103908],
              [19.96196605756476, 8.679685375545414],
              [19.95695374524291, 8.68768625818718],
              [19.95821250167626, 8.690848112300246],
              [19.95693853384765, 8.695029885894762],
              [19.954163420477574, 8.697185441464255],
              [19.947477858001196, 8.695370727262484],
              [19.94883773664025, 8.68858483198348],
              [19.94870807802975, 8.674511347557742],
              [19.950358832428766, 8.668509940023778],
              [19.945014380308994, 8.666920284039046],
              [19.948531038552318, 8.661385644535425],
              [19.948377221116065, 8.656347948650003],
              [19.946698485976167, 8.65267941819385],
              [19.949546859253022, 8.647382343177958],
              [19.952499917071474, 8.645650117289401],
              [19.954829601407734, 8.641052586064701],
              [19.951601098035518, 8.637970369196266],
              [19.947908340514587, 8.640574867631644],
              [19.939487878228555, 8.64386489389658],
              [19.929615816766418, 8.652516004644687],
              [19.92304788229226, 8.654952024109887],
              [19.92086230807687, 8.65342531295217],
              [19.924148463737488, 8.646679646979154],
              [19.92440245755627, 8.640612574388022],
              [19.922978108481068, 8.637718069016923],
              [19.918102408039026, 8.637512384038002],
              [19.913941954304594, 8.63434723543725],
              [19.910842262812825, 8.636411030878978],
              [19.905413014669517, 8.635677696343901],
              [19.905110089376226, 8.63260420747112],
              [19.915744259194412, 8.622592884933418],
              [19.918055738225487, 8.626614735910909],
              [19.92569660653297, 8.624142796745515],
              [19.921648436672978, 8.6211844339024],
              [19.920146882148348, 8.616283902159916],
              [19.908660274412078, 8.6110083625354],
              [19.90520269017848, 8.613670498757124],
              [19.89868092778185, 8.615950888087394],
              [19.895244633465357, 8.615633823099888],
              [19.888027138193596, 8.617883636584152],
              [19.886367607284534, 8.608789920045828],
              [19.88742615498523, 8.604713455078734],
              [19.876594795674965, 8.60431499660117],
              [19.870592120368663, 8.607805131995661],
              [19.86946074280304, 8.603958018201373],
              [19.871901713655095, 8.594145708104422],
              [19.868095242520017, 8.588629171573748],
              [19.86685369138227, 8.579303741378663],
              [19.870359427109644, 8.576476640321594],
              [19.874009327617316, 8.576679149200238],
              [19.87984549916807, 8.580163092494075],
              [19.883013731740803, 8.574952272267659],
              [19.889598374526496, 8.576550407808785],
              [19.889026068959907, 8.58077353911635],
              [19.891960684971032, 8.582169704182315],
              [19.88972953478097, 8.590116855254234],
              [19.89612188787447, 8.60167057013197],
              [19.900823176745504, 8.603064210447739],
              [19.91147906500345, 8.599552432795539],
              [19.91615285417808, 8.595903265762628],
              [19.923081458348065, 8.598425063084056],
              [19.928195573822613, 8.604862104005017],
              [19.93180733448512, 8.607516237472806],
              [19.948020611535348, 8.605622940143215],
              [19.950993402306104, 8.603031232976699],
              [19.954834824962415, 8.593975639286203],
              [19.95078532283124, 8.590368051976057],
              [19.95163331068375, 8.587578347150028],
              [19.960354900214412, 8.584542765902931],
              [19.973060863801862, 8.577069648014481],
              [19.980272682061077, 8.574291652301113],
              [19.982145218179774, 8.571447228812053],
              [19.986017693491018, 8.57459422294061],
              [19.989784442885924, 8.575687612973363],
              [19.996028613588617, 8.571320029567687],
              [20.00496005759119, 8.561015160863825],
              [20.009471454224784, 8.557503897524848],
              [20.013124055990616, 8.551745042371891],
              [20.014291681060847, 8.546241936218125],
              [20.018564999050156, 8.539769688256797],
              [20.023256944982492, 8.536790689727615],
              [20.0228880010886, 8.533135984626572],
              [20.02569939395579, 8.529747604834464],
              [20.026341911593036, 8.524127682347995],
              [20.02872136267598, 8.521033046468418],
              [20.027050836897683, 8.517480071733315],
              [20.022456432725882, 8.519446462983908],
              [20.02089784438386, 8.507708992074024],
              [20.024356184358, 8.497891652890996],
              [20.021327891026413, 8.496538777568084],
              [20.018806882168583, 8.500038430262311],
              [20.016808585367624, 8.493805453725908],
              [20.01695080151543, 8.489265620254956],
              [20.00999104295512, 8.481892228943737],
              [20.006920696401505, 8.483812767796106],
              [20.005155816674193, 8.474475484251542],
              [20.00129591691825, 8.470859301700402],
              [19.997540830360265, 8.470976123010928],
              [19.99330162755274, 8.476764906270493],
              [19.99112553092637, 8.47576556290882],
              [19.989306246766112, 8.467778386336468],
              [19.984489079710354, 8.470795643059757],
              [19.981753657693044, 8.46522473627279],
              [19.97660378563546, 8.46412026675568],
              [19.969071464828296, 8.464619620400411],
              [19.962727072081993, 8.474230035541913],
              [19.960996605258213, 8.467765670313794],
              [19.964364453285047, 8.466584169117851],
              [19.96798895670571, 8.459510444120536],
              [19.958101261656143, 8.456790565080652],
              [19.951832903092754, 8.46286044515175],
              [19.945151396853312, 8.463873648451798],
              [19.940460842657206, 8.459487245594216],
              [19.94032360797709, 8.452926626940839],
              [19.942236473943012, 8.45222502752526],
              [19.9504142072507, 8.445344837139722],
              [19.949809125698568, 8.437409046591709],
              [19.957367417292158, 8.438769665680503],
              [19.961113910710132, 8.436959116389442],
              [19.964844356306788, 8.432961207152173],
              [19.969250091208504, 8.425227018555615],
              [19.97165587147028, 8.423789411426636],
              [19.97221738437504, 8.419016383780308],
              [19.968695909706224, 8.414267351169789],
              [19.968186926485917, 8.407765411038403],
              [19.96378138758141, 8.405928808517386],
              [19.96403181901154, 8.397954078880263],
              [19.9601273634173, 8.39362252719098],
              [19.951655046822346, 8.39058724902946],
              [19.950111020674274, 8.38670033273699],
              [19.94577030150475, 8.387078781518731],
              [19.941380443628137, 8.392627957975073],
              [19.933354554202612, 8.398144219272211],
              [19.928446329780872, 8.393867877943645],
              [19.929946493295283, 8.387196402320034],
              [19.927620679256343, 8.385304057505325],
              [19.922626499762767, 8.389675413794489],
              [19.923761342657542, 8.396076363126541],
              [19.919189951716596, 8.400358199259616],
              [19.91234159359068, 8.402735796183634],
              [19.90508442323148, 8.39810831797243],
              [19.90020045228082, 8.401736039891528],
              [19.89235721583083, 8.403357091451218],
              [19.88967512909167, 8.405501515479832],
              [19.89038862989305, 8.4101190943682],
              [19.884759104101033, 8.412907500174224],
              [19.876068648426745, 8.42002560968364],
              [19.880691238700177, 8.421177959526768],
              [19.87984370541698, 8.425156709382435],
              [19.881890072127984, 8.428933250944926],
              [19.875418541015772, 8.431602181257505],
              [19.87064096770998, 8.428076478179932],
              [19.866477842938778, 8.432485108034436],
              [19.865772907770832, 8.43820167883223],
              [19.861453671286103, 8.440572982805449],
              [19.857505365678406, 8.453886698483197],
              [19.867646217645014, 8.466875740301548],
              [19.868690256422592, 8.470660825062089],
              [19.867031905530165, 8.47408118162677],
              [19.866735314294832, 8.482039751002892],
              [19.863972411144655, 8.48474324182183],
              [19.861488419688165, 8.48242546001944],
              [19.86110170115402, 8.476469318536573],
              [19.8570732677761, 8.478092249288842],
              [19.859181815595885, 8.482448055032608],
              [19.857675136621342, 8.487075567731523],
              [19.85932091468183, 8.499611283085557],
              [19.861781192634997, 8.500772987160238],
              [19.86621048082221, 8.509599406968151],
              [19.865304091685033, 8.515149030670656],
              [19.861679825556923, 8.520940601902321],
              [19.86659563843746, 8.526834362478546],
              [19.86722487831524, 8.531634866425716],
              [19.871563322663796, 8.528676999023432],
              [19.874094572631982, 8.530832394336809],
              [19.87176697608657, 8.539111022923873],
              [19.876989660463813, 8.543468416644458],
              [19.881448528504283, 8.53997872025039],
              [19.88549310147329, 8.544578301481408],
              [19.884560678996067, 8.552916505101479],
              [19.882448315341843, 8.555806345795359],
              [19.87779091411374, 8.556009427014423],
              [19.873306257185526, 8.56382054651595],
              [19.869067976686154, 8.569067215197705],
              [19.86317736710843, 8.571014216217227],
              [19.859135158181626, 8.575930838268928],
              [19.855614107533576, 8.577911439898916],
              [19.848282686231745, 8.57820279301933],
              [19.851826316543658, 8.571014987241606],
              [19.853391771380497, 8.561835705305818],
              [19.84844844445253, 8.550592759368056],
              [19.845376128728887, 8.54747963547313],
              [19.84461563394281, 8.540049798469022],
              [19.839660269955605, 8.53536352674567],
              [19.83333846246375, 8.534083916692083],
              [19.829917361717147, 8.537789099360605],
              [19.830695843549325, 8.546144628238183],
              [19.826359258296055, 8.54959588567614],
              [19.82300570432946, 8.566858502172304],
              [19.823177381518438, 8.577109407961677],
              [19.81652747569598, 8.590945748677454],
              [19.814256834322755, 8.604315876120262],
              [19.81832565160504, 8.606043561630285],
              [19.813494557030552, 8.612687850803885],
              [19.81244011633924, 8.618516370808335],
              [19.808014959838484, 8.6314173515267],
              [19.805357968888327, 8.630282482640592],
              [19.80224617084882, 8.621296813246836],
              [19.804385154507695, 8.61420990887177],
              [19.801581481559143, 8.613558611944773],
              [19.79044483670564, 8.614393271472393],
              [19.78736855146376, 8.616207792779589],
              [19.78193917245317, 8.615484601418874],
              [19.778745281696136, 8.610860124575701],
              [19.783071004614033, 8.607047774793452],
              [19.787231886077265, 8.594414871406652],
              [19.79822103592119, 8.58256182144724],
              [19.800165501883782, 8.576113504920015],
              [19.798477599100206, 8.571753762356654],
              [19.793351396163672, 8.567083192789545],
              [19.79909106994412, 8.562102683423868],
              [19.807896966759618, 8.550473026993497],
              [19.80984492078126, 8.542843995140624],
              [19.811934617814018, 8.5388399314244],
              [19.810284721293392, 8.528421488448133],
              [19.8121826715682, 8.521740326424005],
              [19.815171455833365, 8.517652100980596],
              [19.816971367374933, 8.511059626846903],
              [19.805793737085853, 8.50729307489027],
              [19.800006800522542, 8.515126162727425],
              [19.798768809826306, 8.520374182801218],
              [19.7992902805257, 8.526854421641993],
              [19.80260544370794, 8.532395638207438],
              [19.79743020576908, 8.541239594451882],
              [19.789795534007805, 8.556026774415995],
              [19.792732079355012, 8.5574185812664],
              [19.788260308929914, 8.570498233542175],
              [19.790288136977964, 8.571974071382698],
              [19.788133067659267, 8.57678070963343],
              [19.783529511539236, 8.578582734110103],
              [19.78221411108759, 8.575914186745303],
              [19.78128630175251, 8.568443844226222],
              [19.782857190685743, 8.563815582769623],
              [19.78327305012528, 8.5559688524542],
              [19.78043537487771, 8.554850776836036],
              [19.781776742068104, 8.546289352731833],
              [19.781381797505198, 8.536566628509371],
              [19.778090254751046, 8.532992490199494],
              [19.771493738978744, 8.53278834814509],
              [19.768543700080542, 8.526490836448584],
              [19.768471711745057, 8.521822158405728],
              [19.766681218402347, 8.51602511684218],
              [19.762273914295957, 8.514010032334431],
              [19.746549420768382, 8.515467701497027],
              [19.74277610826874, 8.513490256496278],
              [19.740987755941415, 8.509057588640628],
              [19.74144570060261, 8.504415583231742],
              [19.745228552524264, 8.495973235421603],
              [19.751172339455824, 8.491784498901197],
              [19.752071540223398, 8.486693248904443],
              [19.759100236268726, 8.486152008794253],
              [19.76403078021881, 8.477807259519407],
              [19.767050807683585, 8.471117184074561],
              [19.76378049723937, 8.46110765654681],
              [19.764611029394636, 8.456051271248674],
              [19.761172460808183, 8.44666388226879],
              [19.763484937656216, 8.44018076798589],
              [19.76303102051454, 8.431235137920233],
              [19.76777096829122, 8.422711526738473],
              [19.775141712232358, 8.417421898639573],
              [19.779482929558956, 8.415409329526215],
              [19.78186380903932, 8.410198780525656],
              [19.791489006475743, 8.412323704334405],
              [19.78838728255231, 8.416166964910055],
              [19.78746998893576, 8.420096642936606],
              [19.79260247852932, 8.422160882002624],
              [19.795119517991704, 8.413799325848052],
              [19.795675585479774, 8.408471339167745],
              [19.799464501966046, 8.404630391373614],
              [19.801098697689184, 8.39948366838105],
              [19.8108030698898, 8.391053517760845],
              [19.812393535095058, 8.385177092558022],
              [19.807693032165854, 8.384322988011709],
              [19.803612489563747, 8.38611766978281],
              [19.797805796347088, 8.38423382207888],
              [19.793677891619875, 8.386721088392651],
              [19.792135865279175, 8.390143629062692],
              [19.78915985875162, 8.389444723753185],
              [19.784935992543847, 8.393488883776545],
              [19.783438275070797, 8.3919917993277],
              [19.78437536172537, 8.385924599580932],
              [19.789181219503075, 8.378174228787813],
              [19.796647031892654, 8.379839971733727],
              [19.80432164062872, 8.377866737763535],
              [19.807866688424113, 8.374015492158751],
              [19.811377418973112, 8.366422566074053],
              [19.81644562219579, 8.36345323917811],
              [19.818623526039524, 8.35915607966428],
              [19.818816087831106, 8.354980763092456],
              [19.81037847988329, 8.353774016300218],
              [19.796414747354014, 8.357032882472563],
              [19.79534455742871, 8.360596743866912],
              [19.796650050826873, 8.364505843502519],
              [19.79445540031375, 8.366504924698063],
              [19.789948248012852, 8.365004206878663],
              [19.774110949703037, 8.36881189668637],
              [19.76669890320815, 8.372275402261902],
              [19.76325616145861, 8.375493422244705],
              [19.750333809955155, 8.383114508333854],
              [19.742954467458535, 8.381483301922524],
              [19.73455907899856, 8.383118544994419],
              [19.73167262694108, 8.389888677300966],
              [19.732258736736902, 8.395668661257007],
              [19.734249767962563, 8.397942303463049],
              [19.728247833767046, 8.40499291862142],
              [19.725333691441527, 8.39758102979456],
              [19.728300390028235, 8.39053867339307],
              [19.727215082520228, 8.388453035884801],
              [19.718522979161975, 8.389338373624787],
              [19.71440701838761, 8.388000556546032],
              [19.709787109290424, 8.389618916394776],
              [19.7021388272649, 8.388220592492386],
              [19.698120867317364, 8.38916207162849],
              [19.69018709024967, 8.394881094335467],
              [19.688788673877276, 8.394107899309436],
              [19.68862029512474, 8.387414819751257],
              [19.685210141396333, 8.386794345797584],
              [19.67719682798722, 8.39290000182325],
              [19.676573004842037, 8.396765154100514],
              [19.653329297044138, 8.403237402642446],
              [19.646525663532433, 8.406813720130241],
              [19.645439860284338, 8.41045454458723],
              [19.64069973412776, 8.411533175728461],
              [19.633956762317123, 8.40569647727741],
              [19.626179458285204, 8.403598285638278],
              [19.62464029376077, 8.398408129155152],
              [19.62105161614324, 8.390968818407224],
              [19.616261575160625, 8.390337538480244],
              [19.611767728644722, 8.387621814208089],
              [19.611970963382444, 8.379316221815706],
              [19.609727965653164, 8.376321255234089],
              [19.598311680450696, 8.374489619677727],
              [19.586516695758878, 8.374014354341407],
              [19.5836933428677, 8.382433150171178],
              [19.587566219305153, 8.38937079874588],
              [19.581401116179318, 8.39567940950406],
              [19.581063465883865, 8.406932878154715],
              [19.57909918006985, 8.413101785537513],
              [19.581471660506125, 8.41487869645378],
              [19.580836412021597, 8.424104928644976],
              [19.578900883757505, 8.42786102566728],
              [19.581024900578516, 8.436328176679158],
              [19.57835551876675, 8.442928969985628],
              [19.571921712297918, 8.441408910939439],
              [19.567511650188976, 8.45277409069471],
              [19.569137275031977, 8.455525551632247],
              [19.57259788291097, 8.456356442147749],
              [19.572400960107288, 8.459985971136915],
              [19.5672459424062, 8.461295420142216],
              [19.56334092253341, 8.465426025397939],
              [19.562425876196524, 8.475490547800735],
              [19.5634284607606, 8.478588813774758],
              [19.561430048951188, 8.483824450883027],
              [19.5634671248809, 8.489509117910094],
              [19.56929571429572, 8.495816431886604],
              [19.569143582974146, 8.49957624099654],
              [19.566747883303314, 8.509668641093418],
              [19.571195913963045, 8.515363640043121],
              [19.578338461434146, 8.511200852293191],
              [19.576404237600663, 8.518881297770228],
              [19.571290802282817, 8.525984035984848],
              [19.570495177573086, 8.536556607332106],
              [19.571357259656786, 8.54826570464161],
              [19.568571860491218, 8.557618077160344],
              [19.558322829653598, 8.572502864574538],
              [19.550228988412066, 8.57837854725966],
              [19.546490879993648, 8.583243555592624],
              [19.543309806043425, 8.58139081327478],
              [19.541355570544617, 8.584948379773762],
              [19.537436419498295, 8.598731996563995],
              [19.532628607752226, 8.607951109459732],
              [19.5342374839735, 8.618410316924917],
              [19.533867000906664, 8.623252011680098],
              [19.52649561255958, 8.62431528511137],
              [19.51967809630751, 8.629199092185093],
              [19.514331813812866, 8.637800662141741],
              [19.50869002159894, 8.644773957898584],
              [19.502153771460097, 8.650746696301555],
              [19.48934733151835, 8.657201331911741],
              [19.486419652472076, 8.660955990409606],
              [19.484518002468057, 8.667999094353352],
              [19.487070410505158, 8.678847796976754],
              [19.488250847886704, 8.686848524214696],
              [19.48752161224335, 8.69603107369106],
              [19.4902905107996, 8.709634991688064],
              [19.49516662609571, 8.715414704679816],
              [19.495420157545063, 8.71870676585271],
              [19.489216314661206, 8.729713204642641]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -68.35811057826491, "lat": 44.66562430913634 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23009"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00581290"
      },
      "bbox": [
        19.484518002468057, 8.23133900052245, 20.154840362562243,
        9.420491768329514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.576094282456479, 1.78512809748376],
              [15.577033766661996, 1.7903179835289642],
              [15.580027348230391, 1.7892059804950637],
              [15.581063353865163, 1.7838672485426537],
              [15.577001561293011, 1.7820034195370806],
              [15.576094282456479, 1.78512809748376]
            ]
          ],
          [
            [
              [15.621660924855663, 1.996329097135225],
              [15.630274014639854, 1.9986453233695656],
              [15.634161280834556, 2.001791840601288],
              [15.647233646653719, 2.0249454085922345],
              [15.652794714537716, 2.030467617615161],
              [15.66013084420499, 2.0349979295182012],
              [15.661282731375927, 2.0386779398887653],
              [15.65890569927019, 2.0424420469311197],
              [15.652302015009946, 2.047483137143746],
              [15.65380797031241, 2.051329011856078],
              [15.657286161088523, 2.05443796570379],
              [15.664057243234275, 2.0576957555760758],
              [15.673623891157908, 2.0667279242007788],
              [15.677743836718582, 2.07184713057145],
              [15.678891234693577, 2.076157019938458],
              [15.677575227660894, 2.0812595212017717],
              [15.671586628162592, 2.085721729695194],
              [15.6661203413966, 2.0870336865322145],
              [15.657418752923336, 2.0867210099739992],
              [15.652528982671361, 2.0936255795666843],
              [15.654779704920593, 2.100796758481418],
              [15.656384864500914, 2.110077333796181],
              [15.657934042360734, 2.1133354697946074],
              [15.67586670412634, 2.133497350321285],
              [15.68143828575115, 2.135943587237345],
              [15.686510179104797, 2.149523880380923],
              [15.695452853624344, 2.1499404850577286],
              [15.703425629060705, 2.152905495775441],
              [15.704271782530142, 2.1600879112884113],
              [15.71017613333777, 2.16001545744352],
              [15.71500175288203, 2.162663430824974],
              [15.721756557438773, 2.1596023435274967],
              [15.726969501219532, 2.159240972746292],
              [15.732264769360741, 2.1622671575381407],
              [15.735850374061101, 2.1596381471837165],
              [15.738926873369488, 2.1596704729531484],
              [15.748161084068535, 2.167017363474798],
              [15.75527849191192, 2.1681298718638637],
              [15.772041183743134, 2.1764796152148196],
              [15.770814366739737, 2.1809359182890597],
              [15.775008095925184, 2.182280742969049],
              [15.777952799570723, 2.1790827089345326],
              [15.781664174255788, 2.1822807560957456],
              [15.786505591260028, 2.1815375752788975],
              [15.785506602135683, 2.185900347711991],
              [15.7899839002973, 2.1936985093058676],
              [15.799422452455042, 2.194914415239448],
              [15.807032535851723, 2.194258374055541],
              [15.811088608514728, 2.1920600814548266],
              [15.815334713345242, 2.191762444243427],
              [15.827764647918166, 2.186701284735328],
              [15.835402736245205, 2.1872675777651476],
              [15.838965230164897, 2.184768060946873],
              [15.846243375189102, 2.185673761962158],
              [15.854727875843622, 2.1914642361172207],
              [15.866700853473763, 2.1964766648669802],
              [15.875872763175444, 2.196945630775693],
              [15.894153426656153, 2.130391252617656],
              [15.898172211950373, 2.117895750926485],
              [15.904020860032801, 2.096997833371589],
              [15.8973673211433, 2.090473542485238],
              [15.884841275910977, 2.08378433959931],
              [15.873668362219053, 2.0795861146877885],
              [15.872148218749366, 2.0761110487859704],
              [15.868710125480643, 2.0741855788759076],
              [15.86700820870348, 2.0696537705541536],
              [15.86219938182742, 2.064251019969025],
              [15.853347918239262, 2.0569074910901697],
              [15.847610487795977, 2.048802147082355],
              [15.845930295630415, 2.048332058234577],
              [15.844124900180995, 2.0395410597628945],
              [15.84343867437029, 2.029391223345532],
              [15.840761114655175, 2.0237908430708003],
              [15.843947028590646, 2.01326856708342],
              [15.843241674660538, 2.009601436801492],
              [15.835128880106643, 1.9954127314288943],
              [15.830653661644694, 1.9924176500439854],
              [15.827777796780873, 1.981645102538075],
              [15.828867817869265, 1.9775868469806566],
              [15.828322930917874, 1.97275937179866],
              [15.825638111363347, 1.965696112973006],
              [15.827019395025694, 1.9612555028087557],
              [15.824001267408944, 1.9592605541475514],
              [15.82225906223232, 1.955165903025257],
              [15.823074872475095, 1.9505057781458244],
              [15.818947637105524, 1.945460701675316],
              [15.815294035327105, 1.9467573619086325],
              [15.812841069143998, 1.9451505721371463],
              [15.814713560982806, 1.9405695280944057],
              [15.811809575939751, 1.938048688202415],
              [15.810787261728201, 1.9332265313732249],
              [15.805203033311162, 1.92788564898828],
              [15.804637518959392, 1.9218922054481413],
              [15.799612261092832, 1.9169267068582816],
              [15.798229926385481, 1.9126232707544228],
              [15.798126801965747, 1.9058157113823757],
              [15.794215793539923, 1.9009522807659782],
              [15.798101523702709, 1.8988163489402536],
              [15.794764631066796, 1.8921646400776646],
              [15.799940091326992, 1.8841797894828887],
              [15.797658450853879, 1.8809419087040935],
              [15.798825767447083, 1.874724179520074],
              [15.79747119223033, 1.871995500715956],
              [15.79301787503429, 1.8698420286225972],
              [15.798302601609015, 1.8560058168243192],
              [15.795267374538039, 1.8526378546892837],
              [15.798738696129922, 1.8480204489842176],
              [15.80014465655769, 1.8424037048021116],
              [15.78643655618308, 1.8428177674940844],
              [15.78238917111245, 1.8422227389467496],
              [15.77082506443959, 1.8432806774993342],
              [15.7079040993036, 1.844954993098756],
              [15.698649669145299, 1.8432610979067794],
              [15.690127891885332, 1.8438360191222227],
              [15.688152099762537, 1.846141922185235],
              [15.68345184217637, 1.844273633920145],
              [15.679492950361052, 1.838009315759441],
              [15.678806992000906, 1.8317468769693896],
              [15.67658410384899, 1.8246495932906068],
              [15.67802782547229, 1.8187113398429355],
              [15.675882362689697, 1.8111560190713365],
              [15.679495476156905, 1.8091270181308006],
              [15.67942857853708, 1.8024182371322934],
              [15.688230237635727, 1.793593195732721],
              [15.690493029521877, 1.7899623127875846],
              [15.691510923934276, 1.7820701729120976],
              [15.683669151803196, 1.778888815965371],
              [15.677195968418944, 1.7787553844051638],
              [15.676263303173492, 1.7735115907527221],
              [15.67436452348413, 1.771915212829622],
              [15.670571894674646, 1.774695995803396],
              [15.656464700814652, 1.7751631491935604],
              [15.651246874201009, 1.7713520904821185],
              [15.646685015301454, 1.7696950620018927],
              [15.64491204438091, 1.7550054363044452],
              [15.639016231270872, 1.7532514917482924],
              [15.637086954215356, 1.7460897270287956],
              [15.629587578575615, 1.7501414992619513],
              [15.628022130158636, 1.7485397275952455],
              [15.624621411259715, 1.7326198308623109],
              [15.620268820059954, 1.7367501566916983],
              [15.619543408533971, 1.7392603145948276],
              [15.620889936159879, 1.7467973781397714],
              [15.618555595682517, 1.7672119629345135],
              [15.618475065134925, 1.779785529299672],
              [15.613086033534671, 1.7794318642828917],
              [15.609260810954671, 1.7919825573100892],
              [15.607013766118689, 1.8072285370505332],
              [15.604789004977, 1.8137910849789045],
              [15.598234062906373, 1.815192702007205],
              [15.596807277081668, 1.8188139965903372],
              [15.599845949565001, 1.8209625649397416],
              [15.599392650353701, 1.8262055609425796],
              [15.594938713910846, 1.826027296702945],
              [15.589254832546839, 1.8276875954913623],
              [15.58671549500998, 1.8268660082326624],
              [15.58561940747181, 1.8208135204360172],
              [15.579905938203396, 1.8205674944164278],
              [15.576598935025626, 1.8269246891910487],
              [15.576224421470357, 1.8318014354787073],
              [15.568553106588817, 1.8420022666253293],
              [15.564471648720744, 1.8422857388154128],
              [15.561274351245773, 1.8397061065154612],
              [15.563688519637896, 1.8338463568799186],
              [15.568115572484201, 1.815698438513049],
              [15.562328593735868, 1.806757644560986],
              [15.567086974825681, 1.8019432170670566],
              [15.573870566975984, 1.7999732732533709],
              [15.56859000782306, 1.7937439963220811],
              [15.563956054209115, 1.7939508679425071],
              [15.556539082903127, 1.8062841492529638],
              [15.554673028561258, 1.81067451358351],
              [15.551202465886432, 1.8139041514807674],
              [15.546353342712223, 1.8072538811223122],
              [15.541663452790855, 1.802868229302911],
              [15.541789496243764, 1.800235086380115],
              [15.536750838773644, 1.7971852417877046],
              [15.537576152185071, 1.7931811144473353],
              [15.536199862405464, 1.7866320396425415],
              [15.542145872050945, 1.7791977372625714],
              [15.54086587802767, 1.776931036299104],
              [15.54399748675707, 1.7724918348908654],
              [15.539364873665905, 1.7709342069980891],
              [15.538589808327202, 1.7750634430991523],
              [15.535075026103533, 1.7824304264460304],
              [15.532930148371753, 1.7895119255328156],
              [15.52771301108148, 1.7911814591630322],
              [15.522323399968318, 1.7883323772117732],
              [15.523684707164444, 1.7765220186305233],
              [15.519128107928298, 1.775447750138214],
              [15.515364254303456, 1.7818183716727543],
              [15.510256429743835, 1.7807464622183857],
              [15.506809915480298, 1.7735393708987717],
              [15.511150134940179, 1.7684143184001058],
              [15.51151508660887, 1.7623934441848947],
              [15.513020861942923, 1.7592321502556332],
              [15.51214243449078, 1.7546982777617404],
              [15.518282386161381, 1.743690320420749],
              [15.518791961156925, 1.7401611644670874],
              [15.5236196264714, 1.7280734771199522],
              [15.522210548786292, 1.723568291583082],
              [15.518186027649257, 1.718085524716454],
              [15.51044269181202, 1.718172531092754],
              [15.50210111289075, 1.7087698328981145],
              [15.502435688704528, 1.7003935351192265],
              [15.501408446879813, 1.694341882849627],
              [15.495512017668654, 1.6965604710046094],
              [15.494004280022672, 1.704612631431349],
              [15.49239513125532, 1.707237191573255],
              [15.492540728211289, 1.7122769986645527],
              [15.49512683354378, 1.7206903668736626],
              [15.49625449942588, 1.7321434762505912],
              [15.494738083564174, 1.7424147000889865],
              [15.491998577446273, 1.7504085802164822],
              [15.4885467484279, 1.765222595718202],
              [15.486557358268362, 1.7872955729909399],
              [15.484945968892506, 1.797152549783444],
              [15.487159364403619, 1.8162371263852761],
              [15.490248420569024, 1.8271050587530164],
              [15.493343157584691, 1.835424511573631],
              [15.496822899085139, 1.8370772917435478],
              [15.4967346285508, 1.8487311374444588],
              [15.501262704450484, 1.8588533447676674],
              [15.502053216895392, 1.866974512436332],
              [15.499241049781515, 1.872107948281344],
              [15.498797036955484, 1.886504074335647],
              [15.502661304248255, 1.8999406602632551],
              [15.506775106328202, 1.904527292809048],
              [15.509703569453219, 1.9044332525986154],
              [15.510031055482226, 1.898243005288024],
              [15.508384756874507, 1.8944530344582278],
              [15.516419161450715, 1.8862640523156924],
              [15.518023994719908, 1.88080515831487],
              [15.522572852869137, 1.871840405420378],
              [15.527828301581197, 1.8654599853168274],
              [15.535433480927429, 1.8589233436531598],
              [15.539451363984238, 1.8532646912198651],
              [15.552419945746113, 1.8573046422930823],
              [15.552184720552745, 1.8513220942691577],
              [15.556662961039214, 1.8495973906472358],
              [15.560403573518863, 1.8518148943621389],
              [15.558470004742002, 1.8552181636594447],
              [15.56497807197816, 1.8567846546698976],
              [15.567311127010873, 1.8523178433841745],
              [15.570587250961637, 1.8505312954364699],
              [15.576311014274554, 1.8522149228531446],
              [15.574336726121485, 1.857133687876421],
              [15.576191589023658, 1.8583366366068197],
              [15.579750382620063, 1.8535882187991233],
              [15.586052450010245, 1.8507575808053425],
              [15.59358135733674, 1.8553805354582253],
              [15.598004983633635, 1.8559023445378895],
              [15.604869373321744, 1.8641118807666397],
              [15.616216860284567, 1.8826869609493775],
              [15.621375998605274, 1.888138845533097],
              [15.619456221704999, 1.898579526411927],
              [15.611470014348898, 1.9109863341499922],
              [15.608030477090189, 1.9125576895796146],
              [15.603898050405913, 1.9175730063737466],
              [15.604489789448307, 1.9254400367454487],
              [15.602140138097452, 1.9301042238912778],
              [15.596386155337521, 1.9310440121620853],
              [15.598159901417482, 1.9387905051426975],
              [15.600479299794019, 1.9448444786019299],
              [15.604329574222115, 1.9497661752571216],
              [15.611363702289902, 1.954038868184936],
              [15.6131415439258, 1.9635022574578587],
              [15.615141834276956, 1.968588003614071],
              [15.62219418325512, 1.970941362693215],
              [15.622822985980783, 1.9739823109228956],
              [15.616772686425215, 1.9806042318162043],
              [15.616254878396619, 1.983489821636389],
              [15.621556290762491, 1.9900985123464665],
              [15.621660924855663, 1.996329097135225]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.02017100917337, "lat": 39.06787393361233 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24035"],
        "coty_name": ["Queen Anne's"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Queen Anne's County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00596089"
      },
      "bbox": [
        15.484945968892506, 1.694341882849627, 15.904020860032801,
        2.196945630775693
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.098949092995783, 7.524543712555367],
              [8.112459848932671, 7.525997971154702],
              [8.102814637369208, 7.52165679769497],
              [8.098949092995783, 7.524543712555367]
            ]
          ],
          [
            [
              [8.07422432577834, 7.5232765769051575],
              [8.080932013697646, 7.524742805679347],
              [8.085317416829598, 7.523258868537473],
              [8.08477375823058, 7.520436126050187],
              [8.07556635621103, 7.5199119328196735],
              [8.07422432577834, 7.5232765769051575]
            ]
          ],
          [
            [
              [8.308745984435022, 7.572804717971079],
              [8.318668049480875, 7.494990587292516],
              [8.32387826324732, 7.451956713721209],
              [8.327635160271344, 7.424271885683529],
              [8.334686283690607, 7.367375819521834],
              [8.344932832880454, 7.282594967704863],
              [8.356284922913614, 7.191906993048167],
              [8.357631912246768, 7.179829967108015],
              [8.36753629100977, 7.081555811137963],
              [8.242460964672047, 7.068593019925337],
              [8.205205571843232, 7.064786234941429],
              [8.204610081242103, 7.054618137071154],
              [8.20787274403849, 7.045904874507307],
              [8.202311207708405, 7.044129563270532],
              [8.193359183076646, 7.046126967174319],
              [8.187950296228225, 7.045676198162954],
              [8.182822352520223, 7.042772909910527],
              [8.180330773100488, 7.0433592626625785],
              [8.171894672244445, 7.050797359399081],
              [8.167651953052323, 7.058419939135855],
              [8.169731956123988, 7.064086589600762],
              [8.168267014664597, 7.068018253305729],
              [8.16253073543854, 7.0783410079942835],
              [8.159171087302452, 7.082215314191855],
              [8.151931021815539, 7.088241043925758],
              [8.148972285026483, 7.095477799378776],
              [8.143555564736381, 7.100711962427975],
              [8.12228596261209, 7.099282342278765],
              [8.108135431118022, 7.097739755538787],
              [8.104982276728187, 7.1281385813755165],
              [8.133340838839146, 7.129537920017721],
              [8.142466109987465, 7.127420147217715],
              [8.146116816571546, 7.128424300756817],
              [8.154731465738603, 7.1353039468042505],
              [8.16238508974442, 7.1392900356525475],
              [8.165039835919329, 7.138353867742454],
              [8.171111420480397, 7.139568562020243],
              [8.176051990746624, 7.137928196592313],
              [8.180560925262874, 7.1391143076451025],
              [8.184409844836129, 7.142585811091131],
              [8.192371755866555, 7.147343605901713],
              [8.19837567092075, 7.148165312253739],
              [8.203287181926948, 7.152989090874974],
              [8.213459831392033, 7.161007472247194],
              [8.21845258995884, 7.161666835750674],
              [8.221731513899687, 7.166037653425167],
              [8.227563631722496, 7.168840723673164],
              [8.228841362362031, 7.175108645099928],
              [8.227641854790075, 7.185497828706389],
              [8.224489783070581, 7.19298781209393],
              [8.219921274386628, 7.1967282307951805],
              [8.208104777374139, 7.197958248729912],
              [8.204955225560784, 7.197652951494396],
              [8.195698494236183, 7.1995855136119085],
              [8.184389531222777, 7.198057040382077],
              [8.179239811826427, 7.1998134462064245],
              [8.171209213970439, 7.197287503692138],
              [8.17135835759292, 7.191003868931999],
              [8.16496443994238, 7.195421066958559],
              [8.16237525584117, 7.1951214816415785],
              [8.15540063509228, 7.198873022824659],
              [8.138308036802544, 7.200272548366243],
              [8.131728719181407, 7.204415237166392],
              [8.130240999381051, 7.206591767525543],
              [8.118640119588497, 7.214383017367953],
              [8.103516231924203, 7.2321061397326725],
              [8.093395007890624, 7.241728899739323],
              [8.088158740112496, 7.25934268963083],
              [8.084587855377087, 7.267134547567535],
              [8.078640290761115, 7.276910309223565],
              [8.075195015114684, 7.288685666993126],
              [8.071633828140715, 7.296997932920719],
              [8.070900746331287, 7.30284530150673],
              [8.06852742610629, 7.3104719691746105],
              [8.067851050380533, 7.318925781860925],
              [8.065287763351916, 7.325842430226061],
              [8.066037944951141, 7.336531404502562],
              [8.068812580737447, 7.343016343293939],
              [8.079960980127138, 7.358554197642004],
              [8.080750490767642, 7.364441067746428],
              [8.087748299149421, 7.376373296624518],
              [8.089661473675259, 7.383183879706708],
              [8.0895639932946, 7.388715275811462],
              [8.097713192944635, 7.399890435893055],
              [8.102580444727199, 7.400797848613534],
              [8.116612007281292, 7.410600651058122],
              [8.128385845988493, 7.415447551360524],
              [8.133608583454087, 7.420834799583787],
              [8.137125720839396, 7.426094652003172],
              [8.139495169043146, 7.434809411841047],
              [8.140651623890017, 7.44521792280265],
              [8.143852094373278, 7.448594402001777],
              [8.14895234634625, 7.447577795612758],
              [8.152217981823458, 7.449736989015405],
              [8.156714988075173, 7.4561264442445285],
              [8.157821220795046, 7.4612289960911555],
              [8.160320868878733, 7.465530857013337],
              [8.164932263504996, 7.469807795191741],
              [8.166600823853335, 7.475591917308383],
              [8.17083526016965, 7.477697556393891],
              [8.172199824532605, 7.490617324930188],
              [8.170321440609024, 7.49701160844551],
              [8.163221478147436, 7.504999469669023],
              [8.155331658279803, 7.5118568074305365],
              [8.149214775563962, 7.511045811378278],
              [8.146593846360824, 7.515578496625852],
              [8.143413628769029, 7.518017823967192],
              [8.138516237764678, 7.51684294352971],
              [8.12733914907273, 7.518851086541291],
              [8.125328494089244, 7.517402583066699],
              [8.119812460218977, 7.518807799730125],
              [8.120546419896053, 7.524385649286525],
              [8.128431670543387, 7.522037914554941],
              [8.166071977363567, 7.5265834236601785],
              [8.169319356059258, 7.528248379625303],
              [8.179247939355879, 7.526293922382728],
              [8.189825644117668, 7.5207714777658365],
              [8.193580542312645, 7.5175690379575375],
              [8.199238395075305, 7.519013076263881],
              [8.202856586228583, 7.521945860234761],
              [8.205975117336893, 7.5277223533718916],
              [8.21107042264983, 7.529456062936054],
              [8.225661392912533, 7.524394835483801],
              [8.231073092677557, 7.524065221414093],
              [8.233896788032133, 7.522339190959233],
              [8.241168773712133, 7.521548432983277],
              [8.244393299739814, 7.523771245164041],
              [8.247369159876502, 7.529419691294725],
              [8.250537577478921, 7.53035036628461],
              [8.261499737031809, 7.52405951613382],
              [8.269361952298317, 7.52801289478371],
              [8.274103399583312, 7.532672942105533],
              [8.277964358692486, 7.541173223270253],
              [8.279097787596625, 7.547271860003792],
              [8.277210420609668, 7.5521123984346685],
              [8.273057285827992, 7.5517020702689495],
              [8.271895311004668, 7.556370465510943],
              [8.268359891283968, 7.558610437818606],
              [8.268414516005661, 7.561899472734432],
              [8.276702303574712, 7.568607683874179],
              [8.280643339824845, 7.5705813125081685],
              [8.296105543602009, 7.565850819477893],
              [8.301540076888324, 7.567355443528031],
              [8.308745984435022, 7.572804717971079]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.8903746953062, "lat": 45.52014099197153 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26047"],
        "coty_name": ["Emmet"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Emmet County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01622966"
      },
      "bbox": [
        8.065287763351916, 7.042772909910527, 8.36753629100977,
        7.572804717971079
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [7.8200082121368935, 6.593407244818625],
              [7.820739351342762, 6.599703583551194],
              [7.825101790968925, 6.602447996633631],
              [7.8287632554349695, 6.595157698740416],
              [7.822380162384844, 6.591480273098006],
              [7.8200082121368935, 6.593407244818625]
            ]
          ],
          [
            [
              [7.666429585065994, 6.487511149667803],
              [7.708666145859957, 6.492111998139537],
              [7.751405707930171, 6.497592057843092],
              [7.789224320634953, 6.501585315007579],
              [7.7908117846617175, 6.498719442839991],
              [7.798958769021761, 6.494489641713667],
              [7.809927147016801, 6.4933792249197495],
              [7.819425823792587, 6.495411915886317],
              [7.823116782230276, 6.498683129795026],
              [7.821904401939231, 6.504583404471553],
              [7.823934734832767, 6.512129536402581],
              [7.825753859589771, 6.527813501035621],
              [7.827552523554905, 6.532167654552754],
              [7.827191827521412, 6.538183130992777],
              [7.828474349735985, 6.544933848753346],
              [7.827952071552385, 6.548219940873117],
              [7.834573789559267, 6.556586986615643],
              [7.83965565113712, 6.575554569758116],
              [7.841360267926082, 6.589018408118378],
              [7.844194378582202, 6.595535944924883],
              [7.851192898879348, 6.60178479250927],
              [7.854332765255458, 6.60664037706933],
              [7.854525688360226, 6.615303500225883],
              [7.855813301490541, 6.618210762241739],
              [7.854112689971715, 6.623206055534126],
              [7.8576838685433525, 6.628360132188609],
              [7.854812891649702, 6.632753080810696],
              [7.849909829484383, 6.6346117034556915],
              [7.841713384997317, 6.633644040565686],
              [7.840605634775713, 6.628644048254729],
              [7.837335247148955, 6.620785399286181],
              [7.833956453022681, 6.618977760644215],
              [7.8300084012993185, 6.624632068706384],
              [7.83170022394011, 6.630038153571154],
              [7.837868250738608, 6.638344948230126],
              [7.840921683478235, 6.645186490031881],
              [7.844775288985608, 6.649221430970953],
              [7.845152256414517, 6.654528223110756],
              [7.848108590734395, 6.658577884620449],
              [7.848367052569017, 6.665155517158339],
              [7.8501807324711015, 6.668628312682137],
              [7.848955170262092, 6.679843169225706],
              [7.851825197550092, 6.68399531390894],
              [7.853676500664296, 6.6938004800060344],
              [7.851642720399133, 6.699961063409766],
              [7.8522925270534385, 6.707306056786551],
              [7.857671246118387, 6.711488887789255],
              [7.865524542889989, 6.715819644940712],
              [7.868525983650701, 6.723259538220193],
              [7.871046637868687, 6.725922772517862],
              [7.881995359682973, 6.72831458583708],
              [7.8863516611632, 6.71781314226441],
              [7.886998825346651, 6.713158615534257],
              [7.89153125834324, 6.702841148665108],
              [7.8914534870339095, 6.696460972706838],
              [7.887454579820263, 6.696566517645808],
              [7.88179868622618, 6.698856054733652],
              [7.878608889303212, 6.6979146186842184],
              [7.877052296485752, 6.692946486241036],
              [7.879539506966577, 6.688844671788045],
              [7.8794128191385475, 6.679944919587349],
              [7.877970263518539, 6.673976188510586],
              [7.877606300954124, 6.663648540769385],
              [7.880242335165625, 6.654633141017378],
              [7.88032693744182, 6.649650957173933],
              [7.878777883244052, 6.645795735279558],
              [7.882337216139192, 6.638268753923507],
              [7.882162139121955, 6.6332595563406205],
              [7.880477533832474, 6.626855550773628],
              [7.880938562725184, 6.620519813779761],
              [7.877647762946628, 6.608331481828386],
              [7.879635607672567, 6.605575286652483],
              [7.878161010405886, 6.598226742659142],
              [7.879558183674968, 6.5922947129551694],
              [7.874811034883924, 6.5881926012645105],
              [7.874224418050077, 6.583481525002504],
              [7.867181379034965, 6.5803796702648985],
              [7.865357956548608, 6.57658683598045],
              [7.85835102585507, 6.572755031164984],
              [7.857040861936772, 6.5693481686044635],
              [7.853708484052751, 6.5675034620006025],
              [7.8442191384033, 6.55053268187696],
              [7.842295276883391, 6.53984528409059],
              [7.844233088596543, 6.536336699478759],
              [7.843171313637469, 6.524243079717713],
              [7.845040950876118, 6.519778421181406],
              [7.842415504633968, 6.50869639139888],
              [7.839121942096836, 6.504425067317642],
              [7.838325410441809, 6.497213373845515],
              [7.8360347510078165, 6.491507536429078],
              [7.840282886280126, 6.487049934046904],
              [7.844583050052666, 6.484699412550088],
              [7.852961193873979, 6.481879656272451],
              [7.864474347129307, 6.481216904697587],
              [7.872215077697535, 6.482747487341866],
              [7.879185505731388, 6.495926950438986],
              [7.88463486574063, 6.502392082335701],
              [7.8857899092989605, 6.509732429941299],
              [7.882898804398781, 6.520130043802059],
              [7.88045879374863, 6.523549743631981],
              [7.880899106832221, 6.531638813771647],
              [7.883226833019913, 6.5347662851464765],
              [7.885530045463414, 6.541142669357655],
              [7.89093940165238, 6.544323667518642],
              [7.903810024771436, 6.5554289271323],
              [7.9089002774631245, 6.56447411002356],
              [7.908026879565838, 6.569471273751378],
              [7.909463950028114, 6.575150410439812],
              [7.91366211180485, 6.585647740394262],
              [7.913792673823344, 6.593936436482697],
              [7.918978388470883, 6.600384874374215],
              [7.96199475946343, 6.6049144135301345],
              [7.968480878699332, 6.58048310634967],
              [7.970242890169574, 6.575550431519387],
              [7.974690917714972, 6.572478550210491],
              [7.982388331245927, 6.573140598826627],
              [7.989069026990384, 6.576136398708609],
              [7.993440247006591, 6.573871242283765],
              [7.9963512132931385, 6.567168537997207],
              [8.001851043355632, 6.562104571741571],
              [8.01384002498554, 6.453976685783735],
              [8.015712818466575, 6.436180601374537],
              [8.020859432810514, 6.393339457768998],
              [8.025829623421858, 6.35036421754928],
              [8.03470806696006, 6.265059872243543],
              [7.999044294497652, 6.261148440935781],
              [7.9028034050660585, 6.2502412285537226],
              [7.877171671661516, 6.247416353242166],
              [7.806947634666088, 6.240059761257504],
              [7.735410190411249, 6.23288413724938],
              [7.692569306675904, 6.228275320978225],
              [7.683792452345712, 6.314800900646358],
              [7.681715157760983, 6.329125946272486],
              [7.675416857564173, 6.387204994555871],
              [7.671390949401097, 6.430449569358805],
              [7.666429585065994, 6.487511149667803]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.56048643198915, "lat": 44.66874086587817 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26055"],
        "coty_name": ["Grand Traverse"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grand Traverse County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01622970"
      },
      "bbox": [
        7.666429585065994, 6.228275320978225, 8.03470806696006, 6.72831458583708
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.140605375432809, 8.965882391348593],
              [6.148031016394971, 8.96722070876959],
              [6.149010023239243, 8.969551130306417],
              [6.154482461989431, 8.971932289123382],
              [6.15813649131716, 8.976096702909413],
              [6.16300456444145, 8.973304916538648],
              [6.167618352342691, 8.974233400757507],
              [6.1764249591797125, 8.973239696138178],
              [6.178264090932439, 8.96819872860942],
              [6.175331402367223, 8.962338623789796],
              [6.175585349995854, 8.959317127700084],
              [6.163927024597478, 8.958297761701715],
              [6.157417479843029, 8.963986289295022],
              [6.152907244438457, 8.965324614369388],
              [6.148211239061083, 8.96431414721729],
              [6.140605375432809, 8.965882391348593]
            ]
          ],
          [
            [
              [5.590826692947765, 9.714950660069595],
              [5.593876803650811, 9.719887821232632],
              [5.5992396217183895, 9.724660965261156],
              [5.606778186367568, 9.728517197692446],
              [5.609936697599161, 9.72714037559269],
              [5.596291660477143, 9.717030523000787],
              [5.590826692947765, 9.714950660069595]
            ]
          ],
          [
            [
              [5.767325449466238, 8.720025093595927],
              [5.718696601478769, 8.715956880633488],
              [5.713668753087987, 8.772040757001621],
              [5.711370095542974, 8.8004908023603],
              [5.696528230695166, 8.79941287445845],
              [5.653260271910269, 8.795680061063436],
              [5.635057446124331, 8.794494453171586],
              [5.566538714507377, 8.788895881985912],
              [5.573576331517867, 8.796879578898228],
              [5.587678495387287, 8.817654298110474],
              [5.591489187968776, 8.831941461609347],
              [5.598150282741727, 8.844536844696542],
              [5.606744085261166, 8.85416934512553],
              [5.61225313174435, 8.861903067706619],
              [5.619496900914608, 8.87474389754824],
              [5.622269716333385, 8.877059533147635],
              [5.627693363077856, 8.878801447605502],
              [5.638080416221883, 8.88794807296505],
              [5.6396132635902765, 8.890068609885388],
              [5.647246548209914, 8.893704572514444],
              [5.6527865266760955, 8.900122849654121],
              [5.664804076722648, 8.902799984569713],
              [5.671917135899775, 8.906274222970858],
              [5.686068786699674, 8.914682034186288],
              [5.697974706402925, 8.923111726449786],
              [5.703331428296588, 8.92918517327078],
              [5.709919164255902, 8.934529390518756],
              [5.713586337527258, 8.936019112898991],
              [5.724897835177029, 8.938403490556045],
              [5.736123934133945, 8.942365984863342],
              [5.740383889131326, 8.944612397237115],
              [5.747915242677713, 8.950269128992533],
              [5.75350749019963, 8.957116947683186],
              [5.754099053329765, 8.963589987973126],
              [5.756053001337662, 8.965538111855762],
              [5.7649075230240365, 8.968384376419408],
              [5.767191839813502, 8.968008574138464],
              [5.770115237972864, 8.9717201808687],
              [5.777021789678809, 8.974857858201279],
              [5.780866967139358, 8.974625449477394],
              [5.791310761185217, 8.97848541620506],
              [5.792506280433698, 8.973679967725841],
              [5.804227306553157, 8.976903735273883],
              [5.80520148085653, 8.982119006647329],
              [5.820246676231609, 8.98547020426334],
              [5.838123979170428, 8.990128825249718],
              [5.854798006774514, 8.991371745789339],
              [5.8665772337794175, 8.994378282519522],
              [5.866265924855319, 8.999242707214659],
              [5.871458071196502, 9.000683509626107],
              [5.912758000395908, 9.007490393832793],
              [5.914785864175481, 9.008415307226626],
              [5.931183178215012, 9.008800992603293],
              [5.94026474888197, 9.010122448208445],
              [5.946474019629881, 9.009643434920688],
              [5.964815202946226, 9.009521349842911],
              [5.972111127350225, 9.004344167255397],
              [5.981347674459585, 9.001856436621875],
              [5.990417052472216, 9.003771946148456],
              [5.999807855826158, 9.003629579966384],
              [6.002706623146367, 9.005962146054646],
              [6.00252040560675, 9.009551743034498],
              [6.0231593971155535, 9.009497278623863],
              [6.028233891075269, 9.01182047997946],
              [6.033737857280549, 9.011683521535131],
              [6.064939973367353, 9.001958477171629],
              [6.08352022528701, 8.992122621782087],
              [6.091906860205965, 8.986799629137916],
              [6.094399153260377, 8.983900916990736],
              [6.097535169710313, 8.970966918026912],
              [6.0953550339298115, 8.966228745001295],
              [6.097086753923108, 8.959376107789689],
              [6.099642678588594, 8.956419369105015],
              [6.101018689460389, 8.951344200521097],
              [6.100111454882608, 8.946534909404894],
              [6.094137605663746, 8.945656599529013],
              [6.086613122662887, 8.946554369379026],
              [6.079381184772725, 8.94910730668717],
              [6.073366357960131, 8.94784398552012],
              [6.068335282328702, 8.945388386688338],
              [6.064665842005597, 8.940775243184552],
              [6.063467268119457, 8.936050850563076],
              [6.0556573499514945, 8.9337205813752],
              [6.048753368006072, 8.934643463964246],
              [6.0412907064489225, 8.932363387901171],
              [6.031689578112827, 8.924291520300173],
              [6.023602967845189, 8.924952700979894],
              [6.020893910238006, 8.928461501224529],
              [6.015569066426698, 8.92807252168304],
              [6.011981094239706, 8.931123429683414],
              [6.002741329123859, 8.932273472390087],
              [5.996284925869722, 8.930193441739764],
              [5.985391139111068, 8.931001750770154],
              [5.976029025796879, 8.926373867026102],
              [5.966665281466833, 8.926864148258385],
              [5.945570765750381, 8.922210824960509],
              [5.935325544999879, 8.918579146291862],
              [5.932436040399063, 8.912016734367137],
              [5.93096966007732, 8.90556942519018],
              [5.9310920519144075, 8.899877829868613],
              [5.9336620733151015, 8.894078508315713],
              [5.939419982577865, 8.888908939764079],
              [5.944557201275316, 8.88801103341836],
              [5.95113470533235, 8.880002840546192],
              [5.951876539969236, 8.875650693140058],
              [5.947051156765609, 8.867314381249551],
              [5.93886219840527, 8.866806083342109],
              [5.93207735621659, 8.86441108212759],
              [5.921530936387149, 8.854344821216328],
              [5.9189656782160025, 8.853506541857659],
              [5.901752812198719, 8.835943868739504],
              [5.89013976424815, 8.83064924051471],
              [5.888442134395941, 8.828889309924591],
              [5.883387139886799, 8.828517340041726],
              [5.87634438434112, 8.825912504445137],
              [5.872985066085984, 8.82322462252344],
              [5.865994113168506, 8.813744538723975],
              [5.8593714523950196, 8.801808225874392],
              [5.855365841447623, 8.796784777267355],
              [5.850843597525717, 8.787429957736373],
              [5.847812572989983, 8.785221757176457],
              [5.842878066860992, 8.784584971537523],
              [5.837339549615235, 8.780227238250104],
              [5.829522696476569, 8.766625053741732],
              [5.828330266656384, 8.762266386532765],
              [5.82566400440423, 8.759427134149233],
              [5.8126682691902465, 8.749390543519132],
              [5.807326188049257, 8.738670794313252],
              [5.802091077468977, 8.7346736199572],
              [5.798446301213134, 8.735411217028725],
              [5.78887615913731, 8.730960301782664],
              [5.781566402838578, 8.731132461273138],
              [5.776511940141424, 8.730134072419093],
              [5.77185993333588, 8.722989530657081],
              [5.767325449466238, 8.720025093595927]
            ]
          ],
          [
            [
              [5.014720316572866, 9.322415586474067],
              [5.01940528306353, 9.328867107303166],
              [5.02564645271001, 9.331185858492185],
              [5.032640262787843, 9.331364383576437],
              [5.040072477655585, 9.334391628392723],
              [5.045426470148135, 9.342747985069387],
              [5.044034071570331, 9.346403951720982],
              [5.0389250696833585, 9.346903532950686],
              [5.036225500096957, 9.343037744674962],
              [5.026978060508112, 9.338398445087781],
              [5.023976760607513, 9.341359800507965],
              [5.037509356959703, 9.349118072345421],
              [5.039689009678555, 9.354152328161716],
              [5.04019209596253, 9.364568887030073],
              [5.051546109639361, 9.372042437864417],
              [5.052175275042235, 9.37682758130671],
              [5.058405015616879, 9.382568144988554],
              [5.060816741427197, 9.383337493194585],
              [5.066490981941097, 9.390019593868157],
              [5.120671699229776, 9.426157444929201],
              [5.164392827087737, 9.451054508078883],
              [5.1706558519348755, 9.453901355247808],
              [5.177335801736546, 9.45850553022503],
              [5.181496988326383, 9.45971454251277],
              [5.186187898289143, 9.464609393780139],
              [5.192645093224667, 9.468249296558106],
              [5.202743460762025, 9.472774815166417],
              [5.2098131700806105, 9.476811319225753],
              [5.214555141253229, 9.478470066559215],
              [5.220551967239875, 9.48363057206843],
              [5.2280003600570994, 9.487030796065783],
              [5.232130230268104, 9.486090839874462],
              [5.241657226619334, 9.490023220117854],
              [5.2508783286711, 9.4956105485664],
              [5.251375309697461, 9.501248349132126],
              [5.288639090151538, 9.52591213898796],
              [5.280619376294963, 9.512565788382595],
              [5.289674640551996, 9.516044424180311],
              [5.29809443072821, 9.521502976145516],
              [5.297259749678597, 9.52401099918377],
              [5.301903189624416, 9.526808249163652],
              [5.305814701346818, 9.525375543965419],
              [5.309169501234919, 9.528380036827858],
              [5.320625975234696, 9.53412152986077],
              [5.326873240791882, 9.539388358391875],
              [5.329842071062334, 9.55037586469502],
              [5.33461544671111, 9.556895205592458],
              [5.3473438651918554, 9.565285839423922],
              [5.371056049503058, 9.579229084706892],
              [5.37897754720237, 9.585111327533898],
              [5.391468944257754, 9.59576145441597],
              [5.391920147726255, 9.602384271786285],
              [5.396423835330301, 9.611021142281405],
              [5.418124587445901, 9.625380213057],
              [5.4301872915036915, 9.632394626936117],
              [5.44558045163699, 9.639153055423577],
              [5.453499974483866, 9.641610934238107],
              [5.473582450390136, 9.655434573386387],
              [5.4892756229007675, 9.647243508170044],
              [5.504926644610379, 9.651293978391909],
              [5.510479816725951, 9.658866912932922],
              [5.516786863821122, 9.663719625060233],
              [5.53144095513358, 9.66868065146605],
              [5.539893767717706, 9.66847046902051],
              [5.545358563446647, 9.672244529165106],
              [5.555779671267136, 9.677617500935861],
              [5.55953885552596, 9.667520434647097],
              [5.559206022709486, 9.658047026461793],
              [5.5544893560398005, 9.653787351987443],
              [5.542773833861955, 9.641543202038852],
              [5.528885596456725, 9.629043174598184],
              [5.5183680144680025, 9.620742872523978],
              [5.5012979503947435, 9.605447435029374],
              [5.46651572676182, 9.575316031998357],
              [5.460625301503259, 9.566310500244578],
              [5.460035768819945, 9.559404539173647],
              [5.463180863734896, 9.553514153347281],
              [5.4637086303409905, 9.544839201468767],
              [5.456834842318932, 9.535880119695873],
              [5.434675234792363, 9.516446036860376],
              [5.424396496498197, 9.50904000033232],
              [5.422860226923252, 9.506092381225812],
              [5.403525060455769, 9.48978892644475],
              [5.38805259606805, 9.480105829048831],
              [5.37215435948652, 9.471402555075333],
              [5.35811255286841, 9.466112311742313],
              [5.34952850924732, 9.461593302338628],
              [5.347071468277456, 9.45789763103401],
              [5.341124209438958, 9.458604803918666],
              [5.336966793490963, 9.454587342288438],
              [5.3239852232127225, 9.451883207342599],
              [5.312933189452379, 9.44417865340723],
              [5.2965283625088855, 9.435403603902262],
              [5.283970783694391, 9.435536680925924],
              [5.275174032754636, 9.43145313784442],
              [5.271251516605734, 9.427629800861341],
              [5.2601007795441985, 9.42049083570773],
              [5.258642041566421, 9.422455457604135],
              [5.2537191265351755, 9.421499068160276],
              [5.2373193741263595, 9.410435092643835],
              [5.237907006021646, 9.404050529950595],
              [5.232786277344315, 9.400993828081694],
              [5.223294598673616, 9.396759021717116],
              [5.21316212052174, 9.38928515498951],
              [5.211460495863653, 9.387114355749038],
              [5.198033419804428, 9.379713812902386],
              [5.187031291153699, 9.372680802957365],
              [5.188446891176477, 9.365590221948667],
              [5.1863908210818375, 9.362937641372682],
              [5.187707699095225, 9.357167501678912],
              [5.1897811880090305, 9.355284504837899],
              [5.205321841779112, 9.360943866802513],
              [5.211252737187529, 9.359445495624586],
              [5.218799986424308, 9.361158128783206],
              [5.220213214785001, 9.358110612210108],
              [5.223829027401093, 9.35769337622587],
              [5.230404204164164, 9.361000984389905],
              [5.257138355492666, 9.371840476478898],
              [5.257748467449826, 9.3701578962712],
              [5.252045282701862, 9.365787866166663],
              [5.2498950924110455, 9.360408864792399],
              [5.228870185404781, 9.350236232813836],
              [5.22399020311622, 9.346588549181451],
              [5.207450684836548, 9.339813692954513],
              [5.1941088436670055, 9.331894511552349],
              [5.182741669837026, 9.327310276116703],
              [5.1774219310309, 9.322894654835954],
              [5.168909628613754, 9.31983175655181],
              [5.162971758187678, 9.319116192035692],
              [5.152513863190815, 9.313967764144094],
              [5.1512237349237955, 9.31188740054856],
              [5.144607963340251, 9.309684261166773],
              [5.136497380432036, 9.305459623430995],
              [5.1354009867257115, 9.303813697066413],
              [5.121568328116293, 9.296452943878212],
              [5.115998824988946, 9.292672194203943],
              [5.114603019921488, 9.288122108834827],
              [5.111185959269885, 9.288748621894104],
              [5.101088397926374, 9.286558238588697],
              [5.096151281424833, 9.28662244258297],
              [5.085964370764024, 9.281988906560136],
              [5.08080928885665, 9.282955937084765],
              [5.073477183102795, 9.288430033492102],
              [5.066416335425805, 9.28849509135951],
              [5.064592339433168, 9.290159817484268],
              [5.064370269642235, 9.297635612079066],
              [5.059695094965499, 9.304314781346378],
              [5.0526782054667345, 9.307082135301796],
              [5.04775761383994, 9.306096612431404],
              [5.035063104433804, 9.306030712638435],
              [5.034803804233074, 9.309600649239568],
              [5.038432814998694, 9.312712852123655],
              [5.042757996511307, 9.320652036170376],
              [5.041879215428512, 9.322782086328104],
              [5.050513475628648, 9.331450274255184],
              [5.055957489184736, 9.338563633823949],
              [5.053344257936004, 9.341273429496303],
              [5.048897178492671, 9.340411580838495],
              [5.039347585143507, 9.331054284891417],
              [5.0191482321056915, 9.321351741534166],
              [5.014720316572866, 9.322415586474067]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.43444862429911, "lat": 47.62769235353602 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26083"],
        "coty_name": ["Keweenaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Keweenaw County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01622984"
      },
      "bbox": [
        5.014720316572866, 8.715956880633488, 6.178264090932439,
        9.728517197692446
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [7.607910839542585, 7.194248859463711],
              [7.612294133359113, 7.198485110602516],
              [7.617516475894897, 7.197605469148144],
              [7.621230495582921, 7.194346097309446],
              [7.6250102429904, 7.184072110234011],
              [7.6242160729229855, 7.1707132191652105],
              [7.618531280938428, 7.175018347191149],
              [7.617834930484776, 7.178513654476639],
              [7.613536763135074, 7.184124118020634],
              [7.606136217593329, 7.188226135496038],
              [7.607910839542585, 7.194248859463711]
            ]
          ],
          [
            [
              [7.546128461477179, 7.144749297748441],
              [7.56427871717679, 7.141267211859087],
              [7.569729449151373, 7.139403340977822],
              [7.585513454708125, 7.124647079831546],
              [7.590857852113064, 7.110638473790508],
              [7.591340791718524, 7.098099312863588],
              [7.590561498721282, 7.089017041316179],
              [7.588571985353562, 7.084137552053573],
              [7.585015917365416, 7.086758885680776],
              [7.581534794349943, 7.094888208898927],
              [7.562661470777487, 7.118951793990912],
              [7.554887474462132, 7.126311415189527],
              [7.546128461477179, 7.144749297748441]
            ]
          ],
          [
            [
              [7.452584013167618, 6.83010927875981],
              [7.454825277772066, 6.843023777647071],
              [7.460434845036104, 6.849731103394997],
              [7.464547033494831, 6.851323325096729],
              [7.491912018628611, 6.850357091821895],
              [7.501156423891163, 6.8483824587541315],
              [7.503989002261498, 6.846944887505359],
              [7.508108835494361, 6.840169101152314],
              [7.514162535134119, 6.835315451252028],
              [7.515379699040239, 6.830752124504624],
              [7.515387215011045, 6.823369024141869],
              [7.517313135982885, 6.819884418918015],
              [7.514743825224995, 6.813418530403611],
              [7.5140572292179755, 6.799842690822083],
              [7.514452903011436, 6.784080584357649],
              [7.516023868712766, 6.7779617979396845],
              [7.520855134128863, 6.770677910393859],
              [7.531321916213893, 6.762368328395526],
              [7.533539018076265, 6.759530423043999],
              [7.522083659123433, 6.760476824666621],
              [7.514947917743445, 6.755314217185278],
              [7.510601747892579, 6.7539392246125045],
              [7.507112461229972, 6.750309934019029],
              [7.501160244164395, 6.752794190096224],
              [7.4934828246495, 6.763848699408871],
              [7.486264728620862, 6.770861761556905],
              [7.480977938222712, 6.774655369661554],
              [7.4740722615632915, 6.783181102599942],
              [7.465667382938354, 6.787208662625797],
              [7.460727707570155, 6.7921559212283205],
              [7.458719328253106, 6.799451692531408],
              [7.459625154390878, 6.80612449123316],
              [7.456760355438875, 6.814115040374707],
              [7.454849765419247, 6.824252425936984],
              [7.452584013167618, 6.83010927875981]
            ]
          ],
          [
            [
              [7.789224320634953, 6.501585315007579],
              [7.751405707930171, 6.497592057843092],
              [7.708666145859957, 6.492111998139537],
              [7.666429585065994, 6.487511149667803],
              [7.608905655308279, 6.484035570390847],
              [7.580097637692852, 6.482154675848084],
              [7.565600467825786, 6.4808156238115995],
              [7.5155177988224136, 6.4756118597793],
              [7.483222525770517, 6.471759158272277],
              [7.478716186746595, 6.487588775059875],
              [7.48246062248478, 6.498311446788092],
              [7.484562318834033, 6.513694510332661],
              [7.482978288287262, 6.528596456887986],
              [7.476566300997856, 6.558442582456476],
              [7.473589376674477, 6.577510502995829],
              [7.4734711141513195, 6.588591141953803],
              [7.475432195589094, 6.598608396054807],
              [7.480419324887605, 6.604457255089034],
              [7.490616654945311, 6.609239817098635],
              [7.4968276464601695, 6.606475486559018],
              [7.500260547568656, 6.602864821275042],
              [7.507548994631311, 6.599050443273861],
              [7.516448598096319, 6.596661106253274],
              [7.521898593437073, 6.596564208806008],
              [7.528218274818251, 6.5984679632375665],
              [7.536236234396935, 6.605423120441743],
              [7.540524874522025, 6.614522948417312],
              [7.542949594910128, 6.62948697786899],
              [7.546220135680832, 6.635916473687569],
              [7.551914841617992, 6.64170918213918],
              [7.557946217550086, 6.655908380064207],
              [7.559328949684552, 6.666298969828636],
              [7.563791554996651, 6.671000104599375],
              [7.569227793622882, 6.6720055634539195],
              [7.574906798969865, 6.671693826167279],
              [7.588378937551645, 6.666825511841088],
              [7.593102537664488, 6.663093952050658],
              [7.597194131128907, 6.6565275792327085],
              [7.602800170563071, 6.649639737402574],
              [7.610340786097832, 6.646164935743847],
              [7.621362226485829, 6.64645271547389],
              [7.63389532468108, 6.649897813918071],
              [7.64580629119259, 6.656186184315816],
              [7.653072850001104, 6.66150775719946],
              [7.659310027127272, 6.6741449674913556],
              [7.665677451748447, 6.683837251584596],
              [7.668996780662235, 6.69134148345047],
              [7.669961696806799, 6.69658959929916],
              [7.669534844746444, 6.714047608425009],
              [7.665869696353573, 6.722707532187641],
              [7.676474961516974, 6.736822573983423],
              [7.677898867368626, 6.740693011695999],
              [7.681039886160136, 6.755671979576728],
              [7.6845414798048575, 6.765593934571557],
              [7.688435036215537, 6.771085910246266],
              [7.7073921870383595, 6.783175749803013],
              [7.71609550881676, 6.793101382750108],
              [7.718829966771605, 6.798241722471674],
              [7.7193177485334985, 6.802276232951498],
              [7.726313559647023, 6.812290231818792],
              [7.7287224366167715, 6.825396431672727],
              [7.7276159022511415, 6.835089918677664],
              [7.7287672667646605, 6.839410746069928],
              [7.732150147563845, 6.844567164168947],
              [7.736559687132119, 6.856543270023979],
              [7.738116903069281, 6.86665322231407],
              [7.742352347196041, 6.874111532920309],
              [7.747152906459912, 6.884264380473098],
              [7.7520736431675825, 6.891738459106153],
              [7.75340026684489, 6.897144526486626],
              [7.7606065898150645, 6.910341104536019],
              [7.7638917098490685, 6.908275989671306],
              [7.76531904922809, 6.904913053219524],
              [7.7689109764162305, 6.902678587228312],
              [7.778635939482941, 6.9037892268266114],
              [7.78338813943669, 6.90616129476484],
              [7.789775063750151, 6.913530360308136],
              [7.796987324208537, 6.919807808454409],
              [7.798103413501819, 6.927904264919871],
              [7.799693315494216, 6.928723011116576],
              [7.8044953560336525, 6.938817199814308],
              [7.811701031729617, 6.939771069112841],
              [7.81401993071111, 6.936481219822273],
              [7.815172660531197, 6.930116772179775],
              [7.819210702576947, 6.9275692900061125],
              [7.823882658905096, 6.919527866771062],
              [7.821901958682, 6.907245792052489],
              [7.818564038879618, 6.9024129079845205],
              [7.814654291660824, 6.900905350368028],
              [7.808484871539983, 6.895882437143354],
              [7.807236783895847, 6.89089717763127],
              [7.802755461084481, 6.886845457668559],
              [7.804716040472022, 6.8830292241150985],
              [7.806965485139079, 6.874126775541845],
              [7.804340624362883, 6.871475870440972],
              [7.807894072442691, 6.863012649231508],
              [7.803054035904649, 6.865441219994547],
              [7.802329564087778, 6.870720851919996],
              [7.803340233305448, 6.874157742242998],
              [7.800749781693032, 6.8795158537199415],
              [7.797220665183619, 6.882445849116783],
              [7.785859790966845, 6.880031441635653],
              [7.777115720024992, 6.87439240530852],
              [7.776591810424395, 6.865551540471895],
              [7.771520978196402, 6.858047344444676],
              [7.7693188300078075, 6.851823643938231],
              [7.770097420046157, 6.8474342641984105],
              [7.77237457630738, 6.844628846684112],
              [7.774393826033058, 6.838326783316896],
              [7.777569568329067, 6.833152535414692],
              [7.782081916850699, 6.830005918330372],
              [7.785673221580582, 6.825296042478301],
              [7.783884637440864, 6.821682996560023],
              [7.784390380668416, 6.817369252625325],
              [7.793069525291703, 6.805761323437618],
              [7.799977080796338, 6.793986856919426],
              [7.804895023644175, 6.795482700964706],
              [7.810580442185332, 6.787633472429518],
              [7.81049910636498, 6.77934196901747],
              [7.81186306895181, 6.7764235743715755],
              [7.81131665403852, 6.770702415959837],
              [7.806811803037343, 6.77171293611794],
              [7.802573646107753, 6.77950930883442],
              [7.801858925432164, 6.7832668946980075],
              [7.796563684239559, 6.783207350594],
              [7.794197625124861, 6.779401324873658],
              [7.795022452187769, 6.774568448774569],
              [7.790511644334962, 6.771636529789044],
              [7.790909523449901, 6.763165015184217],
              [7.7898458750121025, 6.756413234641072],
              [7.791163613192812, 6.74838560516199],
              [7.785665839880052, 6.739842441123342],
              [7.781782668268593, 6.736301183663489],
              [7.776417087490363, 6.7290104500135195],
              [7.77374206197005, 6.728796334636398],
              [7.76890538647622, 6.722319981651967],
              [7.768966897955905, 6.717566786987388],
              [7.765785755186249, 6.7128441752602175],
              [7.765767289539202, 6.708465284180349],
              [7.76133252435839, 6.697959935699899],
              [7.762272811735881, 6.695028573474478],
              [7.767692242160378, 6.692044524350056],
              [7.776214633573382, 6.691703572876339],
              [7.777407258620221, 6.695659359133033],
              [7.781510070017827, 6.699806885239408],
              [7.7886796187191765, 6.711534388543493],
              [7.7900822766834334, 6.717331909479937],
              [7.794661627676771, 6.716791946675661],
              [7.7960407628201365, 6.708391344249386],
              [7.794430852852729, 6.698010402637622],
              [7.796417857366058, 6.689401212738767],
              [7.795049980618397, 6.685642870644998],
              [7.797048221529637, 6.678032034702189],
              [7.796694029663033, 6.665584211619438],
              [7.798838525540161, 6.656106241293751],
              [7.800623766513708, 6.6520918828671896],
              [7.787299929431235, 6.64988291386048],
              [7.784490485897289, 6.647995839101637],
              [7.781239155122734, 6.633699290944181],
              [7.7820640714395735, 6.631895524739763],
              [7.778375099869568, 6.619840631047581],
              [7.7790123758962935, 6.618583793121248],
              [7.774058750483544, 6.608335859780635],
              [7.772663367514398, 6.598540475124782],
              [7.7741703247837455, 6.592228032332911],
              [7.774223832491718, 6.585553320146933],
              [7.7729679857620795, 6.573630960998402],
              [7.775505052704594, 6.560254853163589],
              [7.775516740915411, 6.556420863857802],
              [7.784668823318335, 6.53658290392468],
              [7.791706234176784, 6.526956275955331],
              [7.792416463671221, 6.5190191888832345],
              [7.790854841934494, 6.514514597283515],
              [7.789224320634953, 6.501585315007579]
            ]
          ],
          [
            [
              [7.4016434432491796, 6.699670354381241],
              [7.402029472539337, 6.7034214595573465],
              [7.40605993630716, 6.713223610739485],
              [7.408800756988988, 6.726264400457037],
              [7.411002978608926, 6.729278263174433],
              [7.424607288696328, 6.736124946057165],
              [7.428244075651442, 6.733736766238957],
              [7.4356813387066385, 6.731789051284995],
              [7.4448087030203585, 6.731195399989413],
              [7.448460175864779, 6.729668447831487],
              [7.454425960446914, 6.723157577036475],
              [7.453686768454984, 6.721465986628144],
              [7.447519300201712, 6.72214731334165],
              [7.441126288870989, 6.719493479143255],
              [7.438518135397684, 6.7119071123238445],
              [7.4394858507081265, 6.707298373323679],
              [7.442463325516849, 6.702878225950023],
              [7.446621089161177, 6.700068538963595],
              [7.444377627102635, 6.696071871887504],
              [7.440740936450798, 6.69489431005569],
              [7.4372245285833385, 6.691134686368404],
              [7.431290810197752, 6.687442571543186],
              [7.424793456221287, 6.687260299528466],
              [7.4180732505626965, 6.683943910659111],
              [7.40378319232618, 6.688234224600307],
              [7.4024898969275155, 6.6902873769743465],
              [7.4016434432491796, 6.699670354381241]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.81204659638934, "lat": 44.9384707451868 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26089"],
        "coty_name": ["Leelanau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leelanau County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01622987"
      },
      "bbox": [
        7.4016434432491796, 6.471759158272277, 7.823882658905096,
        7.198485110602516
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.634140811622487, 7.0229086835044],
            [8.717979054860239, 7.033187906902728],
            [8.795735742571564, 7.042751826727972],
            [8.881181687353417, 7.05341649304048],
            [8.972805855807268, 7.068464155954314],
            [8.975068655803922, 7.054696020054161],
            [8.977043749731466, 7.026376759369711],
            [8.983750340621105, 6.983698408222428],
            [8.989800021838104, 6.941742256146918],
            [8.995323839269947, 6.899573464580983],
            [8.98819700461117, 6.898525409462305],
            [9.00037759029885, 6.813002208016262],
            [9.011691595382606, 6.727241231656815],
            [8.92648013228205, 6.715538906242104],
            [8.840990803155323, 6.704006012027411],
            [8.756344360072637, 6.694353742639318],
            [8.712170648063434, 6.6881931255411455],
            [8.672558735306868, 6.683356718560307],
            [8.66670758709924, 6.728918834860857],
            [8.661077294500688, 6.777140450285655],
            [8.658967311783854, 6.797007868843007],
            [8.651898270860702, 6.867039109715908],
            [8.643893516508115, 6.93790017742735],
            [8.634140811622487, 7.0229086835044]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.12722674697852, "lat": 45.02759637466487 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26119"],
        "coty_name": ["Montmorency"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montmorency County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01623002"
      },
      "bbox": [
        8.634140811622487, 6.683356718560307, 9.011691595382606,
        7.068464155954314
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.44726272692803, 8.189261836574444],
            [7.465882408934514, 8.019395322635159],
            [7.472214647858138, 7.959532365855091],
            [7.474813786391109, 7.9338205646794755],
            [7.4807571951981435, 7.877597157103189],
            [7.49034580932001, 7.792867875179376],
            [7.503902897938198, 7.662142743863972],
            [7.499071655232025, 7.663018305784272],
            [7.497253403503292, 7.661349415893488],
            [7.492231547280501, 7.6614962431543026],
            [7.483993758914025, 7.658593770696735],
            [7.480924838733962, 7.653934304068601],
            [7.47464746041023, 7.6497671257175455],
            [7.46813737830448, 7.6421417652483274],
            [7.466057090464068, 7.637430850803694],
            [7.467154234195378, 7.634542269844141],
            [7.465019173951575, 7.627865330236117],
            [7.465787705603858, 7.621984211591951],
            [7.472348086905659, 7.618992799781777],
            [7.475608761665047, 7.610411577613647],
            [7.470628091271047, 7.611121428706993],
            [7.4603326593837815, 7.6173593470497725],
            [7.453628608894176, 7.618135677062908],
            [7.443753411490781, 7.625651212086091],
            [7.413360574679711, 7.6352540691412845],
            [7.400032408884795, 7.638331277457252],
            [7.3681543611353515, 7.643783474319178],
            [7.352012434078727, 7.643938700743415],
            [7.347445598378772, 7.642333420030384],
            [7.345339390102927, 7.643829775183726],
            [7.33441683817389, 7.640850309031736],
            [7.3255959048030235, 7.639839420565008],
            [7.317066217452677, 7.634531749120063],
            [7.316589251553011, 7.630852028475817],
            [7.311026442171216, 7.630994630540737],
            [7.308035808247305, 7.627067708508607],
            [7.2993599561070335, 7.626514305140829],
            [7.296687617079068, 7.628620724165671],
            [7.2909353975632625, 7.629605341066348],
            [7.287730249636896, 7.6283941211847255],
            [7.2841456436426, 7.6306768910026594],
            [7.279604285337681, 7.630660326731968],
            [7.275183726629575, 7.633092531121471],
            [7.267148178626453, 7.632062616494529],
            [7.259058497419301, 7.627159157322127],
            [7.258641306381495, 7.62406340943295],
            [7.253579707305716, 7.615132624439303],
            [7.249377280380338, 7.612961524262241],
            [7.246456228141241, 7.615112214403781],
            [7.238005618900008, 7.615674659956868],
            [7.231697338355478, 7.613331741361598],
            [7.229493299152307, 7.611294999048789],
            [7.222385413932476, 7.608159008245049],
            [7.21876900978355, 7.602872008311685],
            [7.222213795120478, 7.597941986769582],
            [7.217289970283261, 7.5902228770705085],
            [7.212752924587078, 7.589801571673255],
            [7.203533395998301, 7.584299429903236],
            [7.19740851284727, 7.5774540671729795],
            [7.192621655410937, 7.567845375953818],
            [7.192233399151015, 7.5638795606768126],
            [7.194711464115859, 7.559269305638046],
            [7.192358949632105, 7.554544997115156],
            [7.1939432127896366, 7.548998877120465],
            [7.191082445889655, 7.539980439625338],
            [7.189000690649567, 7.530830561599537],
            [7.189631576394226, 7.525456986853485],
            [7.193888852362197, 7.5220301558565446],
            [7.195805909974854, 7.517385867403156],
            [7.187441672609592, 7.508457484939805],
            [7.187957917993277, 7.50386817885028],
            [7.18330215543494, 7.49708532150911],
            [7.182632688864178, 7.493340751717477],
            [7.185469457946914, 7.487247069954045],
            [7.186311723216723, 7.482818648342984],
            [7.182107854782003, 7.475165926592569],
            [7.181448807294956, 7.466439162341652],
            [7.18613458681972, 7.461392646699743],
            [7.182242833892385, 7.456071204164327],
            [7.17506242909095, 7.452051386238456],
            [7.172444063608913, 7.448321790638539],
            [7.157788302378401, 7.454685176399296],
            [7.153115126874376, 7.449436336480132],
            [7.151554401895664, 7.452902247902909],
            [7.145126824983732, 7.4526977366480125],
            [7.140332913654626, 7.450787632323522],
            [7.134590286453903, 7.446182740654865],
            [7.132452568619121, 7.442608624840516],
            [7.132211321821624, 7.438092248613485],
            [7.1353481091194, 7.432837730240081],
            [7.132750728544134, 7.431201147664578],
            [7.131658550984503, 7.424436167412025],
            [7.129622413239641, 7.423808992477372],
            [7.1292099149129795, 7.417709474325772],
            [7.126760824359514, 7.4171386525043195],
            [7.122264758486476, 7.420756192378556],
            [7.119844430080733, 7.4195999163876625],
            [7.117770920724209, 7.412676100273392],
            [7.113450786268387, 7.412351238355226],
            [7.100110019701862, 7.548871570850982],
            [7.078527734817996, 7.546694239768247],
            [7.072909203947146, 7.604133618433036],
            [7.061730278966048, 7.7187980127927975],
            [7.061178118846566, 7.718747056782835],
            [7.055742783618096, 7.7740808641312],
            [7.0524865643939965, 7.804508397911613],
            [6.965798469571255, 7.796453093045314],
            [6.9574587435768445, 7.882160359154987],
            [6.948767488482947, 7.968173404033892],
            [7.051840675340506, 7.9776307741027415],
            [7.121355982684395, 7.98400591296589],
            [7.119826877126327, 7.998397614262621],
            [7.103827008310521, 8.154862807402715],
            [7.189597302412226, 8.162970369031607],
            [7.318427498427023, 8.176141019242275],
            [7.44726272692803, 8.189261836574444]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.19962121934583,
          "lat": 46.196660833039545
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26153"],
        "coty_name": ["Schoolcraft"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schoolcraft County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01623017"
      },
      "bbox": [
        6.948767488482947, 7.412351238355226, 7.503902897938198,
        8.189261836574444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.786181400796913, 9.401793743665047],
              [4.7914581066086495, 9.40783678315544],
              [4.79333521426434, 9.413149037525033],
              [4.798118418949962, 9.41464036641925],
              [4.807417352116469, 9.415652630966067],
              [4.81138466839343, 9.408945403650188],
              [4.790524655171234, 9.39433394540489],
              [4.786181400796913, 9.401793743665047]
            ]
          ],
          [
            [
              [3.804352581614507, 9.56109009520264],
              [3.809553182243247, 9.562870261389628],
              [3.8104640400765484, 9.565263893634201],
              [3.8170631120590226, 9.571077242582088],
              [3.823037056585462, 9.573462340400559],
              [3.8223146451152314, 9.575817264229734],
              [3.8397595832809515, 9.593185826529893],
              [3.874031711064114, 9.605201571722777],
              [3.880789037975981, 9.606248720369592],
              [3.8858976040127313, 9.613108573661902],
              [3.8997783730932842, 9.622105651667171],
              [3.9027665143498638, 9.617055169225008],
              [3.9071676041984404, 9.614672305005614],
              [3.912535376262787, 9.615342650720347],
              [3.9254405237492245, 9.622161731349257],
              [3.9311932113818653, 9.617644857566301],
              [3.932393624421241, 9.613016187811377],
              [3.931364055932477, 9.606679942405437],
              [3.933184175463482, 9.604162259008477],
              [3.936104469675029, 9.581363729037925],
              [3.9372933568528445, 9.568215359463256],
              [3.9364805903706794, 9.556724031441782],
              [3.9391548588198617, 9.553737489967537],
              [3.9449308585225973, 9.558319937264871],
              [3.9432375234102817, 9.563550155982679],
              [3.94627353587599, 9.564831035878624],
              [3.94884662190866, 9.559938951857779],
              [3.95359151037502, 9.5602845463648],
              [3.958004318124391, 9.558733405509724],
              [3.9611562340735196, 9.544615215129648],
              [3.9641188575918256, 9.540994941263508],
              [3.971241324087033, 9.542876946450967],
              [3.9727522099822807, 9.545931555939683],
              [3.9776335042673168, 9.544226766788398],
              [3.975451642143699, 9.52837343789449],
              [3.9721406660502345, 9.52785237575887],
              [3.965052358819392, 9.521611643599988],
              [3.9662782952563895, 9.51776382030999],
              [3.971629168261967, 9.51545788742134],
              [3.9722062069887065, 9.510434222510236],
              [3.9793332417762386, 9.507289898761625],
              [3.982257634277504, 9.501005924784643],
              [3.986410553373705, 9.498253892196166],
              [3.986271372775912, 9.494153299248115],
              [3.9909022712114424, 9.484447237357477],
              [3.9909562164826666, 9.482638497648407],
              [3.998094478187511, 9.4758636174845],
              [4.004682798316755, 9.479763467179247],
              [4.030043585959, 9.482550365391857],
              [4.041286615222269, 9.487577882587862],
              [4.071399793804916, 9.492189930017037],
              [4.080826438808409, 9.500873824954867],
              [4.088007112914643, 9.501906655261818],
              [4.094369488481208, 9.50566572469777],
              [4.10432757579684, 9.507771650068467],
              [4.104798359137005, 9.509968086502761],
              [4.110190186826665, 9.51420971179162],
              [4.114596545988741, 9.511640644684379],
              [4.121083153590317, 9.513683878992063],
              [4.125723581670537, 9.513028452399293],
              [4.128301616450254, 9.508655967863698],
              [4.119516101985538, 9.49825124738096],
              [4.121376991967269, 9.49270250210893],
              [4.128828981049456, 9.48806007891836],
              [4.155379334404991, 9.492891033438891],
              [4.159667017535886, 9.491163860315615],
              [4.163160304208011, 9.493571735230907],
              [4.169489336235283, 9.493088089984893],
              [4.170924872812519, 9.495654941605896],
              [4.17557270606141, 9.493731025454693],
              [4.179960945918838, 9.496937382268941],
              [4.181555772804499, 9.500318622296762],
              [4.185969213877928, 9.50117723334023],
              [4.188034913007578, 9.503981349794119],
              [4.1920687927441085, 9.501932364358137],
              [4.198805781114389, 9.5008678929077],
              [4.20829598371022, 9.495285389206998],
              [4.2268279635538475, 9.50253024046838],
              [4.2316173083659105, 9.502873183684367],
              [4.238451516606716, 9.498613700175762],
              [4.24332240464203, 9.496791755509012],
              [4.246411066982048, 9.492048069667316],
              [4.2561484818427235, 9.493983549939653],
              [4.265501153766961, 9.494961526169078],
              [4.270278728641946, 9.494348649517521],
              [4.275703682882327, 9.49672743654981],
              [4.276341330285319, 9.500255873860196],
              [4.280977354411355, 9.503102868067119],
              [4.297235567407094, 9.50672485555256],
              [4.302456942480689, 9.504482429682092],
              [4.305867555640708, 9.501372874395637],
              [4.308558209669889, 9.501397287175879],
              [4.31818933156098, 9.506148995477425],
              [4.332213278823372, 9.505990519837532],
              [4.345420419994689, 9.511507431036492],
              [4.3514773296223765, 9.51292548581158],
              [4.36050934167683, 9.511636402575846],
              [4.371365551246638, 9.514350126025311],
              [4.375702084450826, 9.514186708043677],
              [4.383546654742588, 9.519066600886969],
              [4.392033446925309, 9.51691640034522],
              [4.401080243341107, 9.517998415238834],
              [4.405613856342722, 9.520597481253711],
              [4.413140675849899, 9.52020077770663],
              [4.420269222952803, 9.514595916710025],
              [4.424614071517301, 9.513588933126128],
              [4.441146553407976, 9.514922042025473],
              [4.453306542761056, 9.512248910516233],
              [4.464513659584636, 9.50826317127322],
              [4.470602799125767, 9.504051622906973],
              [4.483898576031756, 9.50086517154312],
              [4.488133626202241, 9.498306396251301],
              [4.492125036047689, 9.486134539438282],
              [4.494968425400643, 9.481564919093522],
              [4.49933999200948, 9.483020626232213],
              [4.507143677110111, 9.4728955609103],
              [4.51038965785045, 9.46472913916132],
              [4.5093053159527114, 9.451297575220055],
              [4.512200683293342, 9.444630215470733],
              [4.515169540989613, 9.442131975655697],
              [4.518214276748876, 9.442727064743744],
              [4.525156341043746, 9.439970985438146],
              [4.52976476133535, 9.432082785993888],
              [4.53296241564358, 9.43244114285261],
              [4.540907134680311, 9.429135667291492],
              [4.543150386191706, 9.434275069664675],
              [4.548060566323739, 9.432891193160573],
              [4.5524232631428365, 9.434630574715822],
              [4.555416218235161, 9.427498582216058],
              [4.559094184040459, 9.426261206245917],
              [4.557992773032196, 9.421458626596372],
              [4.562075244961867, 9.419807664674137],
              [4.569481261623645, 9.41378675971029],
              [4.573875116061196, 9.413078676640906],
              [4.579164375840969, 9.40884315538491],
              [4.58657798403543, 9.408045110178032],
              [4.59689335618072, 9.408348452402143],
              [4.598722907158555, 9.412340839892119],
              [4.613295634674673, 9.416035215045135],
              [4.61537391229129, 9.420781152622016],
              [4.615215497262053, 9.424639717727642],
              [4.617772789427305, 9.425632852652505],
              [4.6210702104185675, 9.423198969075838],
              [4.623487748732119, 9.424106911702095],
              [4.62965840941679, 9.439027077582347],
              [4.637838974808998, 9.44163625382936],
              [4.639757285805505, 9.438378608153323],
              [4.645552110038593, 9.43982546827993],
              [4.648270414322065, 9.443269210011044],
              [4.6566238837234675, 9.443962672835926],
              [4.664255331899734, 9.448616982682108],
              [4.676568391407891, 9.4501215742948],
              [4.681005587607847, 9.44712201091792],
              [4.6869529230714475, 9.449371685948197],
              [4.6890805926397405, 9.446487919164579],
              [4.693855688014782, 9.44700314167775],
              [4.6942065586772195, 9.441809508772927],
              [4.699362967215116, 9.444857805312976],
              [4.699564566802717, 9.438802365111998],
              [4.705138498365866, 9.439079397524853],
              [4.709912603817818, 9.435518110525749],
              [4.718066158930802, 9.440532047597195],
              [4.720078108457527, 9.439701283364927],
              [4.728169109709267, 9.441911297945403],
              [4.73135795953604, 9.438985623331027],
              [4.735353391803832, 9.441509563425273],
              [4.739544255089881, 9.441134724779639],
              [4.742484753636094, 9.436087098539],
              [4.74760336072429, 9.437989835247803],
              [4.753253703467322, 9.43712887277544],
              [4.752966947730989, 9.441387717459905],
              [4.760955171725289, 9.444082374711204],
              [4.765852660494378, 9.443848225747054],
              [4.7695799080986845, 9.45054886289703],
              [4.772050316843896, 9.445764677189864],
              [4.77290631199055, 9.44002105944064],
              [4.781854416134418, 9.438425774191249],
              [4.788041019718056, 9.434477534723813],
              [4.791668946594815, 9.43081097965651],
              [4.79848506118443, 9.43334596065604],
              [4.810134871209728, 9.435474881563822],
              [4.815431864783462, 9.437479398398498],
              [4.827638141901438, 9.436711026643184],
              [4.830397212214937, 9.438853976828904],
              [4.837235051231844, 9.440404155070278],
              [4.837892298347272, 9.44290284316877],
              [4.84722151485525, 9.444501563240978],
              [4.848677497620748, 9.441347433570066],
              [4.837339004935553, 9.438523544760073],
              [4.825329579153523, 9.4335658973633],
              [4.819627374488054, 9.432942443075811],
              [4.801721509287198, 9.428458360813009],
              [4.797462341910344, 9.425024893189756],
              [4.796697410243097, 9.4200970569689],
              [4.787253498466578, 9.416223899363743],
              [4.782548799222256, 9.41650186607656],
              [4.77923059881278, 9.41468550302074],
              [4.773839556796308, 9.41464288839809],
              [4.770257889032489, 9.418648297896219],
              [4.775257096176279, 9.422748911838413],
              [4.774502635032801, 9.425318944197995],
              [4.767445379878831, 9.429810065034822],
              [4.762451301982736, 9.42765309326191],
              [4.758997160868667, 9.422857724762942],
              [4.753649398484689, 9.419902320021375],
              [4.746596019385022, 9.411532422141386],
              [4.748150772280871, 9.40484782190971],
              [4.754450724574078, 9.392962655050423],
              [4.755065769421101, 9.386887016272132],
              [4.746733924965175, 9.392490151747877],
              [4.7450543458287004, 9.397343931656872],
              [4.742033917575147, 9.39920426130129],
              [4.729653931336849, 9.396797473641149],
              [4.723990376354363, 9.39278588406097],
              [4.720726853541946, 9.38451663564105],
              [4.726759918324564, 9.381281663488926],
              [4.727135407729461, 9.37658944956531],
              [4.719269605604003, 9.373650536038188],
              [4.713095303672633, 9.37039855987197],
              [4.706913453357596, 9.36463946126755],
              [4.706726040249185, 9.362238668601229],
              [4.7013945346497135, 9.359476354419327],
              [4.6962231364554885, 9.35530741643413],
              [4.691105613148561, 9.346981926247496],
              [4.677823782257152, 9.336607480234239],
              [4.677218101406263, 9.333208003549084],
              [4.667853391086555, 9.330644823982734],
              [4.654889610078354, 9.31994480281681],
              [4.648599429749556, 9.3178820842216],
              [4.644097863001939, 9.314063978766471],
              [4.6353884036656225, 9.310363345911902],
              [4.632245900728885, 9.306882480050627],
              [4.628868559838813, 9.308588999436315],
              [4.62272081467147, 9.305570446824062],
              [4.61571019484945, 9.299744005901761],
              [4.603474568019457, 9.299203646795078],
              [4.59838450114269, 9.295946653028034],
              [4.596146808767032, 9.292306167173278],
              [4.5902842646695445, 9.290252700371854],
              [4.587941903178615, 9.292106724790731],
              [4.583673885408682, 9.28965955993082],
              [4.577795660893023, 9.287995795426669],
              [4.574706026948479, 9.284932016812915],
              [4.5724333418847705, 9.287168836254901],
              [4.566599473533733, 9.283539490439235],
              [4.564695256700829, 9.279685500098633],
              [4.566578123192083, 9.273801608285536],
              [4.560646413124933, 9.272151686509893],
              [4.561622769960752, 9.26866759991656],
              [4.555618142502472, 9.26460326222329],
              [4.550508890893216, 9.262343587133383],
              [4.545256782463787, 9.262768284377822],
              [4.5387118607871, 9.260515594204238],
              [4.539584734837749, 9.254567011591535],
              [4.537092623003186, 9.252709001713997],
              [4.512694537987785, 9.243772024658842],
              [4.506806898743238, 9.240556419354094],
              [4.5041871312900055, 9.237669930951617],
              [4.492203764785615, 9.23659466908225],
              [4.488110642051702, 9.235298869726169],
              [4.481649145204087, 9.23054140430145],
              [4.472480597657137, 9.229032327700157],
              [4.4664259119384075, 9.221286050744231],
              [4.458958163374511, 9.219761888322441],
              [4.452393289007485, 9.215567137366136],
              [4.442726955518416, 9.211115467599749],
              [4.432864290209189, 9.211501361544217],
              [4.421599871940059, 9.209678304367669],
              [4.410976832505154, 9.206685831453413],
              [4.401896491534104, 9.200484365489949],
              [4.39665374563885, 9.19366579330259],
              [4.396038276537269, 9.190990842387142],
              [4.387260524356509, 9.188523088810374],
              [4.378897907863073, 9.189946371468562],
              [4.366619313313509, 9.18816615607637],
              [4.3501916901503215, 9.182349113024257],
              [4.340951401951362, 9.176591960211566],
              [4.335673832910245, 9.175121280347202],
              [4.318236238714071, 9.166566106013484],
              [4.31379151532026, 9.166881271246314],
              [4.301630608645016, 9.159621596237981],
              [4.299906222666507, 9.156641355215],
              [4.293864854132647, 9.156905097071016],
              [4.292224312290535, 9.153337943125075],
              [4.264355466689801, 9.14782085364263],
              [4.261290597072121, 9.147577193866871],
              [4.25671710263916, 9.143702387386089],
              [4.240928180661886, 9.14061557459432],
              [4.2392047644734285, 9.139058569389713],
              [4.2300948908772815, 9.136514240561556],
              [4.228091452983561, 9.134065500394884],
              [4.228085458024433, 9.129691892620373],
              [4.2084818816529745, 9.12353329383027],
              [4.19035009219683, 9.114959885630473],
              [4.173380349050849, 9.108232944582019],
              [4.171288211644269, 9.108461435107847],
              [4.164497079926138, 9.10471295909629],
              [4.161437423024489, 9.101198472269443],
              [4.155625092568713, 9.091650529433089],
              [4.133379405769675, 9.081038489032778],
              [4.125019527541525, 9.075045785764999],
              [4.103867162384252, 9.062900921602791],
              [4.098782282258866, 9.058559666935],
              [4.08594758464217, 9.050716144155235],
              [4.084820041438521, 9.048802940698923],
              [4.07682998437339, 9.044177094371497],
              [4.066777691783185, 9.040837915725355],
              [4.047885428789631, 9.028372229650893],
              [4.038996465458908, 9.023908618744846],
              [4.016868281447142, 9.005782061560769],
              [4.007430373477032, 9.000879898375814],
              [4.003089039470306, 8.99631826769208],
              [3.9997542848162597, 8.990993921475743],
              [3.9947401787406767, 8.986549449272554],
              [3.9698511573809054, 8.966573996858838],
              [3.9616413600176994, 8.95843115708067],
              [3.9518535558088095, 8.95271559443828],
              [3.933414247658275, 8.93507180341229],
              [3.92288344991228, 8.924256910310106],
              [3.9212399839125074, 8.921520973689525],
              [3.9135882926648735, 8.914440284198927],
              [3.908333876332004, 8.908378237805255],
              [3.9024239233826385, 8.905148319010022],
              [3.897788500822993, 8.89958050192958],
              [3.894459998635496, 8.898304594938216],
              [3.884320627199879, 8.888549899966135],
              [3.874529477162557, 8.878236468571698],
              [3.8747713394319714, 8.875942673792512],
              [3.8685138574802456, 8.872503620215955],
              [3.857039333788032, 8.861703220066941],
              [3.855129048283665, 8.858365321523298],
              [3.8479447747405677, 8.853572211741394],
              [3.8409907721251124, 8.987888456493229],
              [3.8359025369619775, 9.099305782531403],
              [3.8275701701374767, 9.267898433367629],
              [3.823654943400217, 9.26797342519816],
              [3.815803213732311, 9.439896824565206],
              [3.8110920165550475, 9.439654469414227],
              [3.804352581614507, 9.56109009520264]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.53541359462656, "lat": 47.90254994746751 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27031"],
        "coty_name": ["Cook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cook County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00659461"
      },
      "bbox": [
        3.804352581614507, 8.853572211741394, 4.848677497620748,
        9.622161731349257
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5113211841184229, 9.98347448541759],
            [1.5171245014086427, 9.991165967550868],
            [1.5205673237565305, 9.993357360469417],
            [1.5271615064931157, 9.993063671913271],
            [1.5387940262394024, 9.994630148519501],
            [1.5459158539715194, 9.993119973979766],
            [1.5524082256891523, 9.989491184185628],
            [1.5628147017713723, 9.987425746942082],
            [1.5696925106742243, 9.986812970736208],
            [1.5792314690045701, 9.988047973273067],
            [1.5924673916871206, 9.993887024235663],
            [1.6043271658720297, 9.991668775475254],
            [1.6103367047430281, 9.989348219729873],
            [1.6154055164365877, 9.984205052508313],
            [1.6220105375976868, 9.983385469617833],
            [1.6246803475974017, 9.980961287052475],
            [1.626371709214254, 9.976562466932878],
            [1.6311687770568246, 9.968544160809667],
            [1.6316292877642251, 9.963410593962825],
            [1.6292064003952207, 9.949387666138271],
            [1.632316643652307, 9.942072946289931],
            [1.6362402527459425, 9.939336975878792],
            [1.6434853379594976, 9.938391513106422],
            [1.6497470624456552, 9.935769281880379],
            [1.6563131129504935, 9.935749171552558],
            [1.6662541235742148, 9.937506665409803],
            [1.687540030802131, 9.935089304079145],
            [1.6944888817024248, 9.932943335797455],
            [1.7069820553782962, 9.933132479034166],
            [1.7152520371497364, 9.932057883280336],
            [1.7261465313571829, 9.932021887647274],
            [1.7328809373651601, 9.93378254418213],
            [1.7387040343613478, 9.931759446352201],
            [1.7484234659812372, 9.932472860794807],
            [1.7556648462474198, 9.93447015065179],
            [1.7594036232704158, 9.931632426692868],
            [1.7646046578928725, 9.932619140835527],
            [1.77080464131222, 9.932155991640618],
            [1.77591003648275, 9.929922837410407],
            [1.7800040504583816, 9.929853326011266],
            [1.7950218183725077, 9.932434419655182],
            [1.7992099287792322, 9.932115674701494],
            [1.8145991337202358, 9.928243939655713],
            [1.8211181243155221, 9.928338036084028],
            [1.82670048270516, 9.927227900776323],
            [1.8312229819272936, 9.924357069552034],
            [1.8439147389038808, 9.923166685796295],
            [1.855335229143875, 9.923632529081967],
            [1.8576021644434537, 9.92599425052357],
            [1.8721712774414796, 9.92332966915316],
            [1.9038925546899934, 9.922134054531586],
            [1.911283116150859, 9.917787915633905],
            [1.9142324702754943, 9.9100692422851],
            [1.919682492767491, 9.90196216487183],
            [1.921940680187816, 9.888512585799907],
            [1.926508269683628, 9.878506017862724],
            [1.9293234612625778, 9.87403918811565],
            [1.9313661297458196, 9.86433723724846],
            [1.9305724793889647, 9.856011332269686],
            [1.927248225004966, 9.845096839864555],
            [1.9280367797330162, 9.837040760993087],
            [1.923924226530932, 9.830557486861029],
            [1.9236001218793206, 9.824905927630839],
            [1.9278037332016886, 9.81986292183],
            [1.9350119238865005, 9.815903821862436],
            [1.9398438258370705, 9.811595433981035],
            [1.9464117181551635, 9.811228011788023],
            [1.9607711273670028, 9.812172061550642],
            [1.9676424751189605, 9.811358295906391],
            [1.9750170173719794, 9.813702899525564],
            [1.9814949118141514, 9.814487003145677],
            [1.9871707599920105, 9.813971077262838],
            [1.996878419106264, 9.814883769477913],
            [2.006639275269513, 9.811941229558993],
            [2.0200575390295454, 9.813749045889631],
            [2.032059381306521, 9.813487451698684],
            [2.0395524156498555, 9.815181954633186],
            [2.0442395235942317, 9.820419655941595],
            [2.0479818780250807, 9.827884552947921],
            [2.051893381073992, 9.828851720052045],
            [2.0575033263210294, 9.822147559267199],
            [2.06271434776406, 9.820024172662498],
            [2.0672665636328094, 9.821761236806548],
            [2.0734005485005427, 9.827246572741476],
            [2.077694536284538, 9.827439663229846],
            [2.0841923153256667, 9.825299557503781],
            [2.0950173011543813, 9.827890860364992],
            [2.1049710468477487, 9.827935494947642],
            [2.1149783785879275, 9.831867093660392],
            [2.1260421999203687, 9.834432598298548],
            [2.1361122826343566, 9.840944865556143],
            [2.148556466654936, 9.843164681207796],
            [2.1578313590941782, 9.845863417520015],
            [2.1621870077216445, 9.850745190985597],
            [2.164645488732032, 9.861812635653724],
            [2.164255418842467, 9.867034206604238],
            [2.160942744771791, 9.873608125039985],
            [2.157734528097309, 9.886454150247069],
            [2.158751262393428, 9.89086937250403],
            [2.175960420697367, 9.892872366395348],
            [2.178822497663692, 9.894662451492593],
            [2.1844431896975594, 9.900819882682027],
            [2.1955591496741103, 9.908054030127674],
            [2.1988551411386954, 9.907341304011641],
            [2.2047427180325045, 9.90331768194878],
            [2.212185962887711, 9.905318833650256],
            [2.2206404395276556, 9.905486302522016],
            [2.2229192577352075, 9.907434904968644],
            [2.2264296512812556, 9.914171701205058],
            [2.2309818707336886, 9.912115570439312],
            [2.2358328865234247, 9.92689550070716],
            [2.2972688856519077, 9.944369780091609],
            [2.3289655037984587, 9.944977417694043],
            [2.3449412342889455, 9.931698889192942],
            [2.349093643250125, 9.926911055415891],
            [2.408764646341531, 9.932829258770154],
            [2.409001360108522, 9.906966991347936],
            [2.4102034458065744, 9.85502698879314],
            [2.4109217442623, 9.809788070789239],
            [2.4125943769772094, 9.746107947815783],
            [2.4127513920705455, 9.724985955909766],
            [2.412041510651381, 9.719678702232015],
            [2.416138333239922, 9.557167141610556],
            [2.414084932475622, 9.557111128110776],
            [2.416401248905469, 9.495620449027125],
            [2.42036889996725, 9.3864017427439],
            [2.425373494299213, 9.386668300710905],
            [2.4288534025918005, 9.313336447242543],
            [2.4287995665372066, 9.299288271961728],
            [2.4336033683624927, 9.299416113590992],
            [2.4362605179322174, 9.214597145568641],
            [2.40632375826853, 9.214742586558604],
            [2.392322633066557, 9.214336711690247],
            [2.3057038829655916, 9.212590650019386],
            [2.219085366707319, 9.210820188218964],
            [2.1915868911137357, 9.21034648710623],
            [2.176003841939959, 9.210351769571629],
            [2.1037472035386275, 9.211521919110822],
            [2.0881248685243166, 9.21082033826807],
            [2.0010926662924318, 9.208256486467542],
            [2.0009966763570244, 9.209594339010652],
            [1.9666530669611606, 9.208993567648008],
            [1.9676019591691984, 9.157532223065902],
            [1.9006299804488131, 9.156685721071668],
            [1.8354612424929162, 9.155627633220742],
            [1.790436217651289, 9.154505263404129],
            [1.713098655335624, 9.152236151160405],
            [1.621055028238485, 9.150075125556423],
            [1.533257511033147, 9.148370636342591],
            [1.5326788984153576, 9.21961071380481],
            [1.5323540041748933, 9.233865267291769],
            [1.5309137340936703, 9.318720991340811],
            [1.5269067787900494, 9.318632773123102],
            [1.525531028539845, 9.357522247488337],
            [1.5261550899118277, 9.375018113095381],
            [1.525744353635297, 9.402730503035924],
            [1.5222375991398214, 9.57222518244062],
            [1.5201569359277645, 9.658367765282412],
            [1.5178380161876794, 9.65833090277341],
            [1.5165183893184122, 9.707827923127958],
            [1.5161933138045316, 9.738685880917373],
            [1.5148061276106852, 9.78182708026496],
            [1.5140877547937928, 9.827234858645967],
            [1.5139714049634312, 9.876724820103245],
            [1.5133189136714438, 9.892903045523251],
            [1.5130201861451649, 9.911906497930453],
            [1.5113211841184229, 9.98347448541759]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.78338982789484, "lat": 48.24534777179227 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27071"],
        "coty_name": ["Koochiching"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Koochiching County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00659481"
      },
      "bbox": [
        1.5113211841184229, 9.148370636342591, 2.4362605179322174,
        9.994630148519501
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2866026498277958, 5.183826164592582],
            [1.3336959920530997, 5.1845256571446185],
            [1.405067239312927, 5.185381621697668],
            [1.4984986087591368, 5.186732376554417],
            [1.5786910671967527, 5.187906885446205],
            [1.635291625690685, 5.1888469370494725],
            [1.722808413547816, 5.190297674081555],
            [1.7232568864941462, 5.154244623873636],
            [1.724082085047735, 5.104005360301425],
            [1.7241299739291367, 5.088476568482414],
            [1.7254464829485754, 5.016023936762962],
            [1.7268175578971854, 4.943728970502884],
            [1.7286408161053846, 4.842348036055659],
            [1.6730482544106158, 4.841454734324407],
            [1.5879509105631382, 4.840170280215661],
            [1.4986704697629964, 4.838748055410061],
            [1.4648594310810807, 4.83863364819859],
            [1.4178453118125025, 4.8380411630218045],
            [1.2907245832660252, 4.836538285512279],
            [1.289612696330548, 4.923751271481368],
            [1.2885764269111193, 5.010486465396096],
            [1.2875698494700276, 5.097844701235465],
            [1.2866026498277958, 5.183826164592582]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.55107678736125, "lat": 43.67434026504953 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27091"],
        "coty_name": ["Martin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Martin County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00659490"
      },
      "bbox": [
        1.2866026498277958, 4.836538285512279, 1.7286408161053846,
        5.190297674081555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.12672841351624206, 9.461746191055989],
            [0.2017100218728241, 9.462064547633672],
            [0.21576748867245907, 9.462267336930259],
            [0.23050414105219616, 9.461475560175158],
            [0.2883026211815095, 9.461857458973988],
            [0.30241489754935835, 9.459688719177608],
            [0.317303005334413, 9.459112781084777],
            [0.3403230052051072, 9.458920193818704],
            [0.34689909894536514, 9.46057184972273],
            [0.37645095026375014, 9.45977357366828],
            [0.39071389017767133, 9.458656161074613],
            [0.47603627737581744, 9.458503780411132],
            [0.5776372197938984, 9.459014216401446],
            [0.6504570902274535, 9.460043301821448],
            [0.6931388647648704, 9.4600707766465],
            [0.7369935789659825, 9.460279874256488],
            [0.7378682778991906, 9.396428150090603],
            [0.7386042977577529, 9.311377116819312],
            [0.7450773399872438, 9.31140482796301],
            [0.7455151867355769, 9.282596942123991],
            [0.7459504751957247, 9.226535743049645],
            [0.6957590740012141, 9.227352693489834],
            [0.6765683214529343, 9.227418263803658],
            [0.6598566832184527, 9.228019792093432],
            [0.6596210441316097, 9.255946631586136],
            [0.5729406365682973, 9.255948818774712],
            [0.48576788248489733, 9.25579230640816],
            [0.47138200107505335, 9.25539744010502],
            [0.4023542076763401, 9.254838596078216],
            [0.3988507229771905, 9.255063244459295],
            [0.36070052516874684, 9.2544536747906],
            [0.30618622274471147, 9.25432798366911],
            [0.26166443761881875, 9.254653777048157],
            [0.25446215730504584, 9.254960465070734],
            [0.1965063914181193, 9.255270768478391],
            [0.13797778350291023, 9.255748191175398],
            [0.13824594254808956, 9.312592602769284],
            [0.12589288322393646, 9.312639038070206],
            [0.1262621344124777, 9.397785891053152],
            [0.12672841351624206, 9.461746191055989]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.03672438276055, "lat": 48.06623662250265 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27113"],
        "coty_name": ["Pennington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pennington County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00659502"
      },
      "bbox": [
        0.12589288322393646, 9.226535743049645, 0.7459504751957247,
        9.462267336930259
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.408764646341531, 9.932829258770154],
            [2.4780735927961057, 9.931195649631409],
            [2.4979217860941976, 9.93938600751487],
            [2.501131850411378, 9.938440447466991],
            [2.502022569517849, 9.91687407757556],
            [2.5155778964279474, 9.915944032339853],
            [2.529055716046458, 9.906076900829902],
            [2.539296686147013, 9.905042625151363],
            [2.5959192060130305, 9.879796332109223],
            [2.6525291543956495, 9.854534033074144],
            [2.6992046308618565, 9.862937138834031],
            [2.71466769671401, 9.860167860667495],
            [2.72225470870952, 9.831334206329409],
            [2.718560318442952, 9.827441461806535],
            [2.7211986747184915, 9.821866240145477],
            [2.71500870934966, 9.81779057982176],
            [2.7080215401705354, 9.81801270039155],
            [2.7033278866100448, 9.81953784152738],
            [2.698567362138772, 9.814417479469531],
            [2.6828414170635586, 9.814903401085042],
            [2.6735953576845004, 9.811932809098957],
            [2.6722938548376383, 9.801830667520196],
            [2.6673544328703573, 9.790443081280142],
            [2.6678634175610356, 9.787784210841735],
            [2.6654938240026684, 9.780543030539723],
            [2.682598437108525, 9.76246062856153],
            [2.6992861213627934, 9.75941915538476],
            [2.704258478597151, 9.756198937463182],
            [2.7579519208646035, 9.762104201126716],
            [2.78344216385896, 9.76972749325597],
            [2.7983465956037668, 9.770860108977706],
            [2.8034680956098157, 9.770617873722326],
            [2.816225747753053, 9.753950046306548],
            [2.8210474621579933, 9.752499193441807],
            [2.821791765630567, 9.749291560152521],
            [2.825761253101637, 9.74303510116185],
            [2.838832473333468, 9.739033310609901],
            [2.8392719692888577, 9.726286126992196],
            [2.8267067951180063, 9.697136480017969],
            [2.8319993076790406, 9.677867455796408],
            [2.8437255223549807, 9.656489509328729],
            [2.85256283417531, 9.643216686047024],
            [2.8550986830066964, 9.637683710109247],
            [2.8591828241461044, 9.63316756662227],
            [2.8631807834614356, 9.632756742085688],
            [2.8700888826890876, 9.624190391631306],
            [2.877121082490151, 9.60870485490482],
            [2.8872355451576253, 9.589134943460873],
            [2.8868474767321035, 9.587686309184914],
            [2.8927987396004267, 9.58037882692345],
            [2.8908312327505556, 9.577331030606283],
            [2.8944718800723326, 9.569289276217551],
            [2.897416919957463, 9.566872490661423],
            [2.8983334980380677, 9.560896691010322],
            [2.904552320544521, 9.551971664676653],
            [2.9055194568144067, 9.555611425147838],
            [2.9092086042312877, 9.55469752265166],
            [2.9149186160609326, 9.562199998674751],
            [2.9228781106754513, 9.56460597114584],
            [2.9257070084487027, 9.56755190930145],
            [2.9288439317092916, 9.56619778720987],
            [2.9403994622418086, 9.57314174688933],
            [2.9630502151597304, 9.577670835759278],
            [2.970273815315728, 9.581833534326721],
            [2.9672812711846324, 9.59003366114823],
            [2.95575304919864, 9.598172044483823],
            [2.9527182262154015, 9.603952755628972],
            [2.953566353790557, 9.608720402971358],
            [2.9517084532322193, 9.61032434596627],
            [2.9474220592069873, 9.620412991809262],
            [2.951380352144706, 9.638006703632257],
            [2.9430902070489644, 9.647449136008635],
            [2.9440113370078467, 9.653870374826138],
            [2.9501109498717475, 9.65506220644511],
            [2.953680391946414, 9.673797633533756],
            [2.9711302533512356, 9.68613933653305],
            [2.997817656638919, 9.681581768132709],
            [3.001888024217604, 9.677746366451426],
            [3.0086954460485384, 9.678484901799584],
            [3.0079869548217126, 9.680622128095173],
            [3.0105312028050575, 9.684875591803543],
            [3.0165043893123475, 9.68348250548493],
            [3.0174487718654786, 9.68177777385062],
            [3.027479255556166, 9.685367662064436],
            [3.0279797457379094, 9.690611487925377],
            [3.0379238133371476, 9.696918282557752],
            [3.0492999510439285, 9.699689623972438],
            [3.0506655006220407, 9.690433832702677],
            [3.085138142480723, 9.6903531413408],
            [3.091030496586871, 9.689857630452515],
            [3.0945735526424865, 9.694288870062149],
            [3.1023565881900015, 9.695924078152268],
            [3.1097742626011824, 9.69584724660923],
            [3.114611476859773, 9.685931127149187],
            [3.1165916772556868, 9.67221438608271],
            [3.1225850353500935, 9.670939092132242],
            [3.1274826035505714, 9.663949353755147],
            [3.1482861081995996, 9.660442256969827],
            [3.1406642384857473, 9.636704916560868],
            [3.14169817198, 9.626852747294917],
            [3.1452192009088873, 9.620273161026379],
            [3.146291032611831, 9.60568574083094],
            [3.1579429754862507, 9.601078999854158],
            [3.164353025379754, 9.589209422557227],
            [3.1678227546454063, 9.586160788164777],
            [3.170883152183479, 9.589351180223527],
            [3.171182214560634, 9.595158937180667],
            [3.1783518353531837, 9.595417203763683],
            [3.1818773801378852, 9.593733817431042],
            [3.1854442228751196, 9.586884646066743],
            [3.1796089909140277, 9.585925748427767],
            [3.17934636091158, 9.578586746870734],
            [3.1804044706777135, 9.57539728003234],
            [3.191225240796168, 9.573517987129765],
            [3.194082864537923, 9.577169657250433],
            [3.2050936126694656, 9.58011294952656],
            [3.2083814514142315, 9.582329273513505],
            [3.216522103871145, 9.580884439746225],
            [3.2234094694070694, 9.581822111030968],
            [3.229750540965459, 9.571943845544828],
            [3.241395471232885, 9.564397427885934],
            [3.2442667207994345, 9.552721310688744],
            [3.2608967362108636, 9.555992293014599],
            [3.2659425571106517, 9.555876913432666],
            [3.276722292207498, 9.558736711932948],
            [3.277729556886923, 9.555764014085884],
            [3.2814970148850184, 9.55333483744634],
            [3.2888835765771245, 9.55056986231873],
            [3.2937601413014397, 9.41679728240708],
            [3.297893292298784, 9.344261371228932],
            [3.298247230579916, 9.329930420098675],
            [3.30231091787718, 9.258968275578079],
            [3.303468932770529, 9.223411156102095],
            [3.3053343365223924, 9.159651840074638],
            [3.307655428625941, 9.115124418142129],
            [3.30964023943836, 9.081955518323777],
            [3.3115868656120364, 9.065427185216986],
            [3.313690837173272, 9.03256173896268],
            [3.31365902400181, 9.025440457507367],
            [3.315773677033883, 9.004360716222239],
            [3.3173474901435576, 8.993782449692958],
            [3.320560172857362, 8.96185645622174],
            [3.3207046354034397, 8.954698306309558],
            [3.324885977728006, 8.87988626139815],
            [3.3257980145362556, 8.85109179370257],
            [3.3267629561823235, 8.843831739746594],
            [3.3269352056136023, 8.829641531566706],
            [3.3293988661597345, 8.781371065263725],
            [3.3305297326970855, 8.737991103985905],
            [3.3297496829877864, 8.737958906304815],
            [3.333013249434508, 8.652044451845741],
            [3.3370819065085016, 8.56701474405357],
            [3.3407431404510897, 8.481768479727757],
            [3.339250557487211, 8.481860712788812],
            [3.343209348565348, 8.396648850979354],
            [3.346987288287007, 8.312295523548162],
            [3.343683343203581, 8.310418774641741],
            [3.3353405470901123, 8.302947249806927],
            [3.3318279122349734, 8.296071448406918],
            [3.325822875630894, 8.299160061673517],
            [3.319806301704721, 8.298835598418595],
            [3.3154377330982356, 8.296752764103402],
            [3.3091064241802264, 8.29115738066447],
            [3.306383569422808, 8.285433177458692],
            [3.2990808463080783, 8.279739340534666],
            [3.292452969365374, 8.278516312749506],
            [3.2881074353014528, 8.275591906420276],
            [3.273306197564186, 8.261910968900557],
            [3.2670668816901642, 8.253469197265277],
            [3.257139414182555, 8.247316468359227],
            [3.252922004545321, 8.243728699376994],
            [3.242022939730205, 8.236266353630294],
            [3.23324683161961, 8.2271447753415],
            [3.2274559362671162, 8.224224212247595],
            [3.2201112947548194, 8.218147312277505],
            [3.2113357002174654, 8.207236319070876],
            [3.1959385405547565, 8.199169893689819],
            [3.1911832320830147, 8.19235840814179],
            [3.1846868005079734, 8.187855067395118],
            [3.1799022064106275, 8.186416472096374],
            [3.1739507490082723, 8.178710943041182],
            [3.1706559626728335, 8.177264192378619],
            [3.1692190840531635, 8.172030651406121],
            [3.1582636143426335, 8.164222518487362],
            [3.153532290515281, 8.162244192096985],
            [3.1476869575506243, 8.154751773554137],
            [3.149970035685047, 8.145009436216966],
            [3.1524494911899836, 8.139989293494954],
            [3.1608683245548614, 8.126209207518293],
            [3.1699256594356098, 8.113242811568309],
            [3.180658072329552, 8.099331591676838],
            [3.1969674025758237, 8.080254857170026],
            [3.2023507840329124, 8.080097874834143],
            [3.205364789869224, 8.07623315619551],
            [3.2020286596569982, 8.073695404159762],
            [3.1924033350941334, 8.078134816954382],
            [3.1525888167537928, 8.11628593370485],
            [3.1339898041431433, 8.11493830722498],
            [3.1197202037904046, 8.105379774647783],
            [3.1162066905412327, 8.100401501882725],
            [3.116399965432271, 8.093992708111024],
            [3.1179608679791992, 8.091192613655672],
            [3.1148990878698304, 8.081888366877864],
            [3.1087796771603524, 8.081642858244537],
            [3.1002992842268666, 8.085253479336728],
            [3.095594769120749, 8.082400209707536],
            [3.085406756794856, 8.08229092961002],
            [3.082770304136059, 8.0759666368998],
            [3.074588874151701, 8.067053195346089],
            [3.0750997823488677, 8.062926670500403],
            [3.0797962063686564, 8.060940454460944],
            [3.09042422714128, 8.060473813630818],
            [3.0951640730380126, 8.055725701309825],
            [3.095595519795556, 8.051892052964742],
            [3.0921938343151867, 8.045733279372016],
            [3.0846964823746434, 8.041979226000722],
            [3.076229770911781, 8.02979392574309],
            [3.0787314766636156, 8.024165215511678],
            [3.0788179099330657, 8.020317140709066],
            [3.0720692854887255, 8.015013639188503],
            [3.0693201151037233, 8.014806391426685],
            [3.064322435878763, 8.0173747130729],
            [3.060869279679647, 8.017535136901323],
            [3.056097083478339, 8.014483702823544],
            [3.051378703351945, 8.013508645824071],
            [3.041301562678315, 8.022496535364443],
            [3.035133130103164, 8.014651967385646],
            [3.0319794213779887, 8.014233016884972],
            [3.029102254014842, 8.020737842976157],
            [3.020868273181484, 8.023283392691244],
            [3.0197700280119806, 8.030153352921246],
            [3.0165996439827722, 8.02666144501984],
            [3.0101995620075352, 8.029346231142211],
            [3.006189248177614, 8.125181878607348],
            [2.9912885079144655, 8.125523159141228],
            [2.9190441022872515, 8.12256477927105],
            [2.904446453012328, 8.122787916467589],
            [2.874834793419515, 8.12136348995493],
            [2.8688115577359063, 8.121577843098464],
            [2.788876677080493, 8.119560830862145],
            [2.7746475070051586, 8.119652953694068],
            [2.760359268251521, 8.12102791325383],
            [2.7456558511619775, 8.120486116449971],
            [2.6580726524815126, 8.114561554785258],
            [2.5995371194628136, 8.113126176613452],
            [2.5704638795543078, 8.111789858082577],
            [2.4840698124561, 8.10951118563626],
            [2.482268123058573, 8.19474870580411],
            [2.48143496107447, 8.251499993155482],
            [2.480605303309133, 8.280127832941535],
            [2.479199958982909, 8.365561815415349],
            [2.479644020828669, 8.365582322552811],
            [2.4771611411840997, 8.447171687009778],
            [2.47015441360489, 8.44698783704813],
            [2.4682688891055693, 8.531924464931057],
            [2.4651838453688804, 8.617551889561154],
            [2.4642854741595115, 8.6681001425553],
            [2.4632302294320274, 8.704701493003208],
            [2.461821185718684, 8.70475088916122],
            [2.4602052544688804, 8.715948824293937],
            [2.458925901886769, 8.732751138469268],
            [2.4577710887385886, 8.78943310521856],
            [2.458338602805371, 8.803103568861866],
            [2.457995151259726, 8.817257864551559],
            [2.4588944836311204, 8.83117178113994],
            [2.4588197048182465, 8.854229350733085],
            [2.4583430506074455, 8.859230601933222],
            [2.4585465199808163, 8.87455133923991],
            [2.456243939467919, 8.946400822501253],
            [2.4555694103654226, 8.953508224428862],
            [2.455613428460215, 8.970590068207626],
            [2.455042454493581, 8.987125245874262],
            [2.4555552655731696, 9.01105936768889],
            [2.45544379527659, 9.025340877030073],
            [2.4546319282500555, 9.047064624914293],
            [2.4407137216504755, 9.046801884449938],
            [2.439623655581747, 9.074836992522236],
            [2.436955086007248, 9.130950204985332],
            [2.436745966515896, 9.20084685737238],
            [2.4362605179322174, 9.214597145568641],
            [2.4336033683624927, 9.299416113590992],
            [2.4287995665372066, 9.299288271961728],
            [2.4288534025918005, 9.313336447242543],
            [2.425373494299213, 9.386668300710905],
            [2.42036889996725, 9.3864017427439],
            [2.416401248905469, 9.495620449027125],
            [2.414084932475622, 9.557111128110776],
            [2.416138333239922, 9.557167141610556],
            [2.412041510651381, 9.719678702232015],
            [2.4127513920705455, 9.724985955909766],
            [2.4125943769772094, 9.746107947815783],
            [2.4109217442623, 9.809788070789239],
            [2.4102034458065744, 9.85502698879314],
            [2.409001360108522, 9.906966991347936],
            [2.408764646341531, 9.932829258770154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.47072237150016, "lat": 47.60312820959129 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27137"],
        "coty_name": ["St. Louis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Louis County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00662850"
      },
      "bbox": [
        2.408764646341531, 8.013508645824071, 3.346987288287007,
        9.93938600751487
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.0587218363489015, 5.544997396823788],
            [2.098108835891612, 5.546226237839041],
            [2.138822208789838, 5.546996990795163],
            [2.2321359331645074, 5.549569766277667],
            [2.2606304982008494, 5.550563078548872],
            [2.3169038897942396, 5.552062556892514],
            [2.319321975823495, 5.465051058618655],
            [2.3218860469112297, 5.37803843699591],
            [2.3230419683310606, 5.328551024750715],
            [2.3263844801061833, 5.204217774962722],
            [2.239893948443975, 5.201798532726808],
            [2.1528608323362532, 5.199740183382778],
            [2.1100112083839133, 5.198457452322279],
            [2.067071045096728, 5.1974964498316165],
            [2.0648436825139003, 5.28449589447924],
            [2.0619866423550266, 5.396797988488509],
            [2.0587218363489015, 5.544997396823788]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.58725939037761, "lat": 44.02210769851873 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27161"],
        "coty_name": ["Waseca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Waseca County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00659525"
      },
      "bbox": [
        2.0587218363489015, 5.1974964498316165, 2.3263844801061833,
        5.552062556892514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.600093384913504, -8.1219715398824],
              [6.601144069288488, -8.121378107927296],
              [6.632592633283516, -8.130816990369537],
              [6.6376313468616965, -8.13415464779939],
              [6.6430805801232, -8.139748729995489],
              [6.641908957502784, -8.140952426419283],
              [6.628796192618326, -8.13488139918768],
              [6.600527491801651, -8.123412248328698],
              [6.600093384913504, -8.1219715398824]
            ]
          ],
          [
            [
              [6.579677800410787, -8.276057657598765],
              [6.589894699737613, -8.268724973783952],
              [6.59792750853732, -8.26044459971676],
              [6.603811165261667, -8.255809824292209],
              [6.605094185902893, -8.25737541900659],
              [6.598382426466648, -8.264436399071668],
              [6.584736155571215, -8.275328251575317],
              [6.579677800410787, -8.276057657598765]
            ]
          ],
          [
            [
              [6.51526111176361, -8.299688385892761],
              [6.522714200914372, -8.296705686535557],
              [6.531679899822096, -8.296167176471844],
              [6.537822124346619, -8.29497960674009],
              [6.538617149892863, -8.29774447036296],
              [6.533398859157755, -8.30040950683455],
              [6.519521844344865, -8.301542663877123],
              [6.51526111176361, -8.299688385892761]
            ]
          ],
          [
            [
              [6.384073998972226, -8.288795108853694],
              [6.429901465172437, -8.28707925051949],
              [6.4340921490297465, -8.277606198743047],
              [6.436984940585497, -8.26896968913497],
              [6.439283034907805, -8.27026242653092],
              [6.437508112678184, -8.280167706504237],
              [6.433073155937016, -8.290442523370576],
              [6.424994791330131, -8.303558930608725],
              [6.418824232012971, -8.301248324929249],
              [6.403039212353191, -8.303361823766627],
              [6.4023981579357665, -8.295852147071777],
              [6.398794699741158, -8.294333316896958],
              [6.383072636585099, -8.292298020819016],
              [6.384073998972226, -8.288795108853694]
            ]
          ],
          [
            [
              [6.173871759112406, -7.889232065350867],
              [6.252484377218415, -7.884139095035914],
              [6.2606113253194255, -7.883230516258163],
              [6.258562784088123, -7.853993937436097],
              [6.349026198007687, -7.847762329911724],
              [6.4035548496013295, -7.843778477971465],
              [6.492408896379973, -7.837137893426205],
              [6.562777635035187, -7.831824928887542],
              [6.572002345175117, -7.9469460931626825],
              [6.5775030928980245, -8.013477190101797],
              [6.580449488312171, -8.052675419017037],
              [6.583358389638425, -8.087582149881857],
              [6.593839080132689, -8.086133381476895],
              [6.595436323054903, -8.096354167718527],
              [6.6048802869799506, -8.098448080541111],
              [6.605231880685657, -8.103889832206624],
              [6.603615871563176, -8.10613989024936],
              [6.6065969163766525, -8.109681644895987],
              [6.603711528333742, -8.112884630961538],
              [6.586435057482852, -8.112814085800053],
              [6.58390845819895, -8.11419928239461],
              [6.575989992696831, -8.113394368390585],
              [6.551834032307868, -8.114784276962157],
              [6.522928697318671, -8.11882575108888],
              [6.509794555221318, -8.120308308882965],
              [6.485792432789515, -8.125700222939045],
              [6.47150416684873, -8.129809727760628],
              [6.433069702663161, -8.143163192948824],
              [6.419581435689707, -8.148135877326233],
              [6.409863800354382, -8.154049455052524],
              [6.409841469040903, -8.157043973511659],
              [6.406291460647846, -8.16096781277801],
              [6.411801020955521, -8.16848715769592],
              [6.407391867360841, -8.170976413632514],
              [6.402566180367677, -8.164626625282226],
              [6.403958418944197, -8.160291711559145],
              [6.402325738927013, -8.156759195264021],
              [6.37005050190831, -8.172497080017083],
              [6.364022172954329, -8.176721328515407],
              [6.356426973701256, -8.179554750708718],
              [6.328949119894277, -8.193183609822878],
              [6.30069268440332, -8.203835216614982],
              [6.284343137925944, -8.211422943697466],
              [6.280210366280052, -8.214922774195514],
              [6.274322927150241, -8.216373092279564],
              [6.257726054344214, -8.22376551312736],
              [6.245935770185951, -8.226971455658214],
              [6.241021133015169, -8.227117717550142],
              [6.238138236798989, -8.2230457179424],
              [6.241534169682594, -8.218359421068657],
              [6.238925279758018, -8.202614985679498],
              [6.242002728187627, -8.197330201117936],
              [6.247485995912669, -8.198154815357865],
              [6.254894801492573, -8.195603474781185],
              [6.257902376179685, -8.188867459022127],
              [6.2547808796525235, -8.185416501166925],
              [6.243005506331791, -8.17673271080343],
              [6.237034565059763, -8.169736654271802],
              [6.235710527538461, -8.165523686876769],
              [6.231524194857155, -8.164413769280044],
              [6.2240561033741795, -8.166158422108637],
              [6.222113076759266, -8.1705757876786],
              [6.219234435157449, -8.16941175380053],
              [6.221859830452764, -8.15879298015984],
              [6.21576303153906, -8.156497343087558],
              [6.197799994702698, -8.159835860798344],
              [6.193579038603472, -8.161242226989357],
              [6.186955236449289, -8.075308261829104],
              [6.183910971666665, -8.034189500430035],
              [6.175577305194259, -7.9120550894075805],
              [6.173871759112406, -7.889232065350867]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.11599825841323,
          "lat": 30.512290839475668
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28047"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00695747"
      },
      "bbox": [
        6.173871759112406, -8.303558930608725, 6.6430805801232,
        -7.831824928887542
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.980750279921401, -4.0456435939414],
            [5.974877443146156, -3.957739507284998],
            [5.973876640811129, -3.943323863948985],
            [6.059008042276052, -3.9369396323243],
            [6.101784632953563, -3.933482639358486],
            [6.145624484661084, -3.929828209042342],
            [6.1704641131494515, -3.9282125881219523],
            [6.231720589035783, -3.924684363615026],
            [6.260611142347241, -3.9228705502067602],
            [6.389370857731074, -3.9138251411704803],
            [6.3952769698916, -4.00170767633349],
            [6.396206131021875, -4.016012917086822],
            [6.353166476730471, -4.019012045106273],
            [6.356264025823896, -4.06276230605967],
            [6.360630297882012, -4.120534341738881],
            [6.331757429643561, -4.122515192284244],
            [6.334102856147966, -4.1517117091151805],
            [6.319173391011364, -4.152498769832384],
            [6.249496759168651, -4.157803928501909],
            [6.24813095904104, -4.143428978836608],
            [6.153053660104528, -4.149652444705328],
            [6.095557605411282, -4.153878123549816],
            [6.049941364609894, -4.157601331334157],
            [5.988904988273805, -4.162282964364114],
            [5.980750279921401, -4.0456435939414]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.0038652078123, "lat": 34.49048725219671 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28145"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00695793"
      },
      "bbox": [
        5.973876640811129, -4.162282964364114, 6.396206131021875,
        -3.9138251411704803
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.735614201994383, -0.40771118964547837],
            [2.7394275554125067, -0.40319208578279253],
            [2.744064534365213, -0.39969297182701086],
            [2.7516848207345666, -0.3984813910128246],
            [2.7560693291427634, -0.4000063266944133],
            [2.76291837909696, -0.4047569195912584],
            [2.7691110221446116, -0.4127501765055014],
            [2.780426969371366, -0.42140990055746647],
            [2.7859996461112897, -0.427994756359445],
            [2.7888336362693944, -0.4378599631213253],
            [2.7928877834200514, -0.44672989758319404],
            [2.795761660715279, -0.4484123256494274],
            [2.8080758440824725, -0.4481460091875231],
            [2.810647438675999, -0.4531158588555992],
            [2.8093885844730893, -0.4576011036551569],
            [2.8008777188545606, -0.4592850920286313],
            [2.792589318085166, -0.4587990723035939],
            [2.788315138182685, -0.45948320142893073],
            [2.782296244827132, -0.46515502088733746],
            [2.780719927749402, -0.47142270704116884],
            [2.7851045415051394, -0.47872082649802145],
            [2.7936273809891667, -0.48378705120562804],
            [2.798292117140087, -0.4833924051026681],
            [2.8062302079260726, -0.48099146492073125],
            [2.8139777992875774, -0.4712902872352779],
            [2.8167948805513565, -0.46539452001888615],
            [2.8207593586443798, -0.45340633256520146],
            [2.825383518110217, -0.44288800618755825],
            [2.827741656272476, -0.4399120385061804],
            [2.834684444815474, -0.4387298299007441],
            [2.8455468841512763, -0.4425076365528427],
            [2.8502427314933194, -0.4474016363496947],
            [2.85037309619579, -0.45143866804241684],
            [2.848439536897265, -0.45665365449900175],
            [2.8411456980390697, -0.4622432257582504],
            [2.831647204584246, -0.4646697246426536],
            [2.8292116260502396, -0.46646419811992823],
            [2.826878339533173, -0.4713892636644514],
            [2.9013438614045697, -0.4727996805901363],
            [2.981502771391969, -0.47397393885865546],
            [2.981624170766374, -0.46745494802589094],
            [2.9832870696360265, -0.46154825193315946],
            [2.9858658967698783, -0.45732486036597003],
            [2.9873671079051607, -0.4506910456801385],
            [2.992591026345154, -0.4453646323830966],
            [2.998934572047492, -0.4438338091239144],
            [3.006166785008952, -0.44082904005675166],
            [3.0161839036032383, -0.4419558749079926],
            [3.024911424759513, -0.43771340145916704],
            [3.03376807743233, -0.43942670593892597],
            [3.041663993411748, -0.4422839233116958],
            [3.0498764266601173, -0.4481604521873969],
            [3.0638803392979064, -0.4478701845199919],
            [3.0679341996793137, -0.44861762833799107],
            [3.0774748339441147, -0.4469865036853242],
            [3.077996272030156, -0.4888002401280446],
            [3.1065278068854743, -0.48869345083618865],
            [3.107159048598033, -0.5198314026501432],
            [3.1141120974683445, -0.5196907517612747],
            [3.114128286841695, -0.5325438079692539],
            [3.1148604482651865, -0.5489996335214331],
            [3.121929551979324, -0.5488653048821012],
            [3.122224682786195, -0.5635079122033647],
            [3.1364858641897633, -0.5631964587458995],
            [3.1370867853467983, -0.5927793735344791],
            [3.15127783296253, -0.592568853065925],
            [3.1515637682006954, -0.6068965429871617],
            [3.166247542680407, -0.6067027596840988],
            [3.166509828232035, -0.6211839046204441],
            [3.1808046144960596, -0.6211975589395222],
            [3.1810339549749256, -0.6359416344488847],
            [3.2665994499449615, -0.6339235001419968],
            [3.267789643251059, -0.6777101965444496],
            [3.270474107313827, -0.7974720863078549],
            [3.2624657040372345, -0.7971862485152801],
            [3.2584716623118877, -0.8013238731081144],
            [3.2580301695345226, -0.8050195047104285],
            [3.2485052983655947, -0.8132839044858017],
            [3.2454673159042295, -0.818168997243883],
            [3.239942912832039, -0.8226891804755975],
            [3.240518126624411, -0.8257868697199074],
            [3.2374633726814346, -0.8297274596487257],
            [3.23763704821035, -0.8341688574769739],
            [3.230609923641903, -0.8335922249682064],
            [3.225887860293424, -0.8312196497524218],
            [3.219632086688409, -0.8314640817141359],
            [3.2160339739391746, -0.8299858501515196],
            [3.1995791835951657, -0.8318899411268049],
            [3.1954595478611725, -0.8378422336414884],
            [3.1907889208612383, -0.8491907969925279],
            [3.1876036766126843, -0.8469776468962648],
            [3.1765747042136536, -0.8495018836711752],
            [3.174836061261871, -0.8508566040326618],
            [3.1707122862258457, -0.858884875872165],
            [3.163364109546436, -0.860692961635083],
            [3.152820171058835, -0.8568952665706308],
            [3.150426123244071, -0.8546691047786533],
            [3.150890174122781, -0.8492730993161264],
            [3.148608407756823, -0.847178214604553],
            [3.1449274154507108, -0.8380207288540726],
            [3.1404789865675684, -0.8383841972115226],
            [3.137786736358492, -0.8353489809459251],
            [3.1339802642707366, -0.8339703189890474],
            [3.1306913627183093, -0.827514975684591],
            [3.125695477755186, -0.8255784344145931],
            [3.122044751320021, -0.8219707923493145],
            [3.1223800213567694, -0.8182204273946531],
            [3.120785585339283, -0.8130235515103773],
            [3.1223326911794835, -0.8103412264528728],
            [3.114753536960303, -0.8062675357114587],
            [3.109798399149145, -0.798967509444685],
            [3.1097458914480587, -0.7908874257452561],
            [3.1063040669230735, -0.7886861381603152],
            [3.107381477006414, -0.7837980021198726],
            [3.104055066713607, -0.7760354629577849],
            [3.1044591359568163, -0.7698739754313483],
            [3.0949058738965576, -0.770252597978599],
            [3.052405048518247, -0.7705737846908703],
            [2.987395029733694, -0.7718130422078143],
            [2.9206525782377866, -0.7729365350458054],
            [2.821506363288232, -0.7724509885650535],
            [2.771966161086878, -0.7718540329061898],
            [2.7509009152354436, -0.7713988218821319],
            [2.750967901303478, -0.6687132049931578],
            [2.7515779423756808, -0.6098900810720314],
            [2.7525027866613527, -0.4853916339876762],
            [2.7345126367884585, -0.4851198786760614],
            [2.735614201994383, -0.40771118964547837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.76601498593337, "lat": 38.02699492037366 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29029"],
        "coty_name": ["Camden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Camden County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00758469"
      },
      "bbox": [
        2.7345126367884585, -0.860692961635083, 3.270474107313827,
        -0.3984813910128246
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.171564198936021, -6.410775496540545],
            [8.199190284077895, -6.4078508861576395],
            [8.213898543589691, -6.407264711261506],
            [8.262012809322984, -6.40219875066216],
            [8.376418873399038, -6.389108867172833],
            [8.471937395657124, -6.379958245378849],
            [8.47837889911071, -6.3786275384209],
            [8.515324140774007, -6.374599464861414],
            [8.51694993071085, -6.386381222371572],
            [8.52492665577228, -6.463426661998084],
            [8.524918064464737, -6.465635746611812],
            [8.528566883495055, -6.491873778989142],
            [8.532285730026006, -6.495084394750631],
            [8.53587505851421, -6.494741535779865],
            [8.536630167495566, -6.501989922283104],
            [8.533297085030275, -6.502323138837283],
            [8.533705811692718, -6.506155292415581],
            [8.530230574101916, -6.506521672322428],
            [8.536129838277994, -6.563593404298748],
            [8.539785528132372, -6.563194933420621],
            [8.540942590997041, -6.578004055925722],
            [8.537649331667689, -6.5782498530915525],
            [8.543749563310861, -6.6360412294731415],
            [8.543339061793711, -6.6522355220594145],
            [8.546098290740632, -6.681469677106937],
            [8.50320944998814, -6.6861243326140585],
            [8.512146928828697, -6.772200248266677],
            [8.508154739259744, -6.772375295309007],
            [8.50979033049276, -6.786895553293514],
            [8.513512126465324, -6.786637203898155],
            [8.516497933315005, -6.814998350214566],
            [8.493393170841466, -6.818251768599003],
            [8.367464336533006, -6.8313522036676435],
            [8.345685358092599, -6.833214076377936],
            [8.307939484090346, -6.836693186672527],
            [8.299678591079283, -6.837934591047749],
            [8.259541574861577, -6.841656522090115],
            [8.244889644910955, -6.841515859038754],
            [8.230246186141116, -6.843120397252466],
            [8.22459923724126, -6.83319643736016],
            [8.219583523622997, -6.834413679464621],
            [8.216919952380232, -6.833315971457273],
            [8.208968048603102, -6.826185693054047],
            [8.204344127697407, -6.824354862713102],
            [8.202224752678173, -6.812887305754125],
            [8.199620519492482, -6.805002400440745],
            [8.19581522937697, -6.802016960860369],
            [8.194283334838806, -6.793693493497709],
            [8.187594519851078, -6.789899506344438],
            [8.188867989425203, -6.785600778692904],
            [8.185158737563839, -6.781913366544964],
            [8.181481149846928, -6.780678930999086],
            [8.180650230311857, -6.774193017121258],
            [8.177606088980134, -6.768881935777049],
            [8.17782753597487, -6.7659677304632035],
            [8.174279476439816, -6.761599090393195],
            [8.174456348861188, -6.757748396314213],
            [8.170938362012587, -6.7565212816289915],
            [8.166171528643503, -6.750614477713714],
            [8.165791205783329, -6.7469009478379975],
            [8.162105057135761, -6.7420408195812085],
            [8.156435887368366, -6.690112824019393],
            [8.1568009035123, -6.6798671182696765],
            [8.15633801636304, -6.671704146762956],
            [8.154125956776676, -6.648153117535585],
            [8.151025926844845, -6.6224355445674155],
            [8.142737841763719, -6.5454442028998985],
            [8.140996752255171, -6.531403395731014],
            [8.13898697857782, -6.5105952761739125],
            [8.128446689804463, -6.415393691053718],
            [8.156992605822245, -6.412705018758343],
            [8.171564198936021, -6.410775496540545]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.6802705944692, "lat": 31.752435920930587 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01013"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00161532"
      },
      "bbox": [
        8.128446689804463, -6.843120397252466, 8.546098290740632,
        -6.374599464861414
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.107715319918052, -5.16285667263451],
            [9.150382997625483, -5.157411935842798],
            [9.17275558058531, -5.154364967270126],
            [9.221134482454495, -5.14864937614008],
            [9.265151701914291, -5.1441719000231885],
            [9.361672417423895, -5.133773442831752],
            [9.406051864388282, -5.128876938329145],
            [9.4477400412477, -5.274671194906172],
            [9.467075907113985, -5.34217830978839],
            [9.47309228015733, -5.360854898324085],
            [9.473921163702222, -5.370044487343855],
            [9.478798783458064, -5.3755870793362925],
            [9.486792335651053, -5.377471480606528],
            [9.492797837504838, -5.372772184774989],
            [9.495021524493387, -5.3740652526537875],
            [9.500510846574834, -5.380969560149696],
            [9.501116677985724, -5.388634459843045],
            [9.496320109577304, -5.390750356825319],
            [9.493338191206668, -5.39457663865431],
            [9.491185478726921, -5.400455615289626],
            [9.495338446918176, -5.40796979680255],
            [9.493262007248164, -5.417952931462829],
            [9.498921762867548, -5.42474248467991],
            [9.50856917594306, -5.4338568558589815],
            [9.514010589069182, -5.436248810311663],
            [9.517140726483396, -5.435179631021172],
            [9.52010557819917, -5.441796571710169],
            [9.52405118997276, -5.442369861207782],
            [9.528474291285782, -5.446154465036865],
            [9.531611595664549, -5.4462593509847],
            [9.535628090708324, -5.4516827925862135],
            [9.528843463312224, -5.456280310561701],
            [9.523504274883905, -5.4573885679752046],
            [9.52016028117228, -5.466223619486004],
            [9.526533975325904, -5.477837939480791],
            [9.528208635608582, -5.479301343639264],
            [9.528036923768111, -5.479588326552424],
            [9.450139274325577, -5.489564159938488],
            [9.403751311401015, -5.4951041187416765],
            [9.405214768477476, -5.5094502164896335],
            [9.385157912542498, -5.511707939207398],
            [9.328737301154138, -5.518460628743466],
            [9.305928617896209, -5.520777697644485],
            [9.304906087102246, -5.513638378336403],
            [9.297760662144343, -5.514736480124715],
            [9.296944504148646, -5.5074732642090805],
            [9.282701090709086, -5.508754460565256],
            [9.284341328781437, -5.523382585055262],
            [9.241516461947354, -5.527929308022539],
            [9.240871681096527, -5.520646362175242],
            [9.233485430337478, -5.5215637146991705],
            [9.234346807589427, -5.528622222228545],
            [9.17018085360849, -5.537305660923936],
            [9.169350314570924, -5.5298650742070095],
            [9.162157518138041, -5.530791719092483],
            [9.162951328298652, -5.53827157379945],
            [9.149388760972165, -5.5400791208616305],
            [9.140872869326598, -5.463460245262338],
            [9.136166821887265, -5.424063426420939],
            [9.121115701186413, -5.28544423748071],
            [9.117900205684258, -5.253691206125712],
            [9.107715319918052, -5.16285667263451]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.39202201041202, "lat": 32.91433074056267 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01017"],
        "coty_name": ["Chambers"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chambers County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00161534"
      },
      "bbox": [
        9.107715319918052, -5.5400791208616305, 9.535628090708324,
        -5.128876938329145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.564323564673854, -5.945143615526849],
            [7.562166304292045, -5.923599832468887],
            [7.551325521221879, -5.8086547752129825],
            [7.548173108622894, -5.772124411371377],
            [7.590914075482623, -5.768156236990568],
            [7.584486825326616, -5.696055656406858],
            [7.5844546442795115, -5.680719718582282],
            [7.5774802688352185, -5.607488913844526],
            [7.576613503774798, -5.593799775891815],
            [7.6188401234932215, -5.58979741157779],
            [7.615034412957408, -5.5462228363043184],
            [7.699543061213995, -5.537945083382786],
            [7.7037844616325195, -5.5814033639768095],
            [7.761669348145007, -5.575915475022026],
            [7.775157072696771, -5.574143950866419],
            [7.782889858180295, -5.570505318769677],
            [7.8052297017616326, -5.5683828288610595],
            [7.825788090769117, -5.565885155749839],
            [7.839730292730413, -5.565108231286735],
            [7.952759485704732, -5.552769561567799],
            [7.962260510704951, -5.63927747607696],
            [7.964124818715846, -5.6598109529270095],
            [7.962238929107503, -5.665314993429434],
            [7.961958564704864, -5.671864028009143],
            [7.959285765127473, -5.676742129600983],
            [7.954418521750245, -5.694597508224483],
            [7.95488794866677, -5.697174358659737],
            [7.953085003294802, -5.70411930520565],
            [7.954247126195246, -5.709252828153561],
            [7.958512879819905, -5.715616084507675],
            [7.957663879039061, -5.718470729493288],
            [7.9584141550549115, -5.72623543048969],
            [7.95471898110373, -5.740224747315132],
            [7.950862439438665, -5.748106630887591],
            [7.949336737714232, -5.759748470866166],
            [7.9508347288421, -5.766426658337709],
            [7.949344395532869, -5.770538074189453],
            [7.9520151590282095, -5.778518978737361],
            [7.957241590387805, -5.7867758766381625],
            [7.956890679111514, -5.793247414618023],
            [7.954008492825926, -5.796963781045998],
            [7.95109367145179, -5.797902094574921],
            [7.946043497031322, -5.8029584599955575],
            [7.9451625671434885, -5.807448167135991],
            [7.94017541666179, -5.810809624273052],
            [7.937085608924853, -5.815272125573148],
            [7.926132701240033, -5.823317023398138],
            [7.927757257802422, -5.827401682206699],
            [7.926658681879316, -5.832889865046084],
            [7.930825688376176, -5.836005735704991],
            [7.929873527605725, -5.841751413839013],
            [7.931553863740684, -5.84820906682209],
            [7.930494856959032, -5.85370024292558],
            [7.922379889536783, -5.859855577586164],
            [7.923190210933276, -5.866139137539134],
            [7.920121519140256, -5.872457740465278],
            [7.917688939692342, -5.874316835802605],
            [7.915934890759629, -5.882516612503081],
            [7.91532591461454, -5.892126233668507],
            [7.910321024775701, -5.897961492340863],
            [7.910663728449732, -5.902425343730404],
            [7.907985041948312, -5.907182093264553],
            [7.904717530205675, -5.908439224034557],
            [7.817420820673902, -5.9172471133992985],
            [7.806957615282903, -5.920839216033182],
            [7.723816603534536, -5.929838736611918],
            [7.64890297510963, -5.936635653035089],
            [7.65649324953261, -6.012713825154326],
            [7.658879738703395, -6.043564516976354],
            [7.66592696674642, -6.1106621689543585],
            [7.62298587568343, -6.115003474827388],
            [7.5801328190250965, -6.1191470558477405],
            [7.572480883934264, -6.047105342895774],
            [7.572668021836971, -6.037012310837248],
            [7.564323564673854, -5.945143615526849]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.29441402092941,
          "lat": 32.638464528474735
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01105"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00161579"
      },
      "bbox": [
        7.548173108622894, -6.1191470558477405, 7.964124818715846,
        -5.537945083382786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-13.494175337177882, -11.09157427298814],
              [-13.453895217580175, -10.980658544428252],
              [-13.444520922965467, -10.992529081290096],
              [-13.41989859087922, -11.024446708375683],
              [-13.366284058501442, -11.06406208123688],
              [-13.331227074534834, -11.10270385245664],
              [-13.304271964887851, -11.124985881538082],
              [-13.301921862249882, -11.128620316828355],
              [-13.302146287407586, -11.130027813243075],
              [-13.30005892068855, -11.132564396034711],
              [-13.299557422905687, -11.13543107234218],
              [-13.299765881165005, -11.136726964823069],
              [-13.301363608603946, -11.136834694247463],
              [-13.302199584177362, -11.138198870634117],
              [-13.30325683487896, -11.13850655237514],
              [-13.30737500462796, -11.141021959752793],
              [-13.30984068076108, -11.141944991833684],
              [-13.310790361497927, -11.14281294617262],
              [-13.313698970818594, -11.141824507846907],
              [-13.31651106001175, -11.142119875330454],
              [-13.320631532645168, -11.143579143721249],
              [-13.322273379031754, -11.144704805386374],
              [-13.322830069082125, -11.14666111621263],
              [-13.326846676885058, -11.147994418893276],
              [-13.330054369252396, -11.147456222612147],
              [-13.331181529842024, -11.145011069043441],
              [-13.33382024240267, -11.144479424755541],
              [-13.336896271313572, -11.143136302843107],
              [-13.337699640667905, -11.141149305640155],
              [-13.338370552417432, -11.140818421530016],
              [-13.34269193090863, -11.141240375405996],
              [-13.343640744285826, -11.142634285393132],
              [-13.344408425013286, -11.140104609332827],
              [-13.344010750804289, -11.13708293330378],
              [-13.344373723764656, -11.134717912970913],
              [-13.346053318007161, -11.130941859290548],
              [-13.34520779036864, -11.128556125245355],
              [-13.34371258953685, -11.126221185444722],
              [-13.341642260501324, -11.124098269685557],
              [-13.341515833291066, -11.121270604454168],
              [-13.342898068056899, -11.119497537785861],
              [-13.347516805461526, -11.116227371270627],
              [-13.350372275435971, -11.11611752647075],
              [-13.353183427097465, -11.117677538265365],
              [-13.35434228718728, -11.116970811616003],
              [-13.354375932595401, -11.114818014226367],
              [-13.354836629632219, -11.111376343094491],
              [-13.352513669793861, -11.107856708140645],
              [-13.352450379573103, -11.106788334737598],
              [-13.35396051782584, -11.105040471864982],
              [-13.355905029752291, -11.103757338668863],
              [-13.359435361795684, -11.102850252681565],
              [-13.363159096117704, -11.104677642097291],
              [-13.36352334429212, -11.10355667197856],
              [-13.366362493349673, -11.102595857194807],
              [-13.366955584950576, -11.101797624297621],
              [-13.370044150945752, -11.100513455552782],
              [-13.370835763303525, -11.101002377430447],
              [-13.370977533693182, -11.10557872329207],
              [-13.371419083576589, -11.108295116475357],
              [-13.37207567725341, -11.109958783552159],
              [-13.373653890150235, -11.11098562171241],
              [-13.376336762737184, -11.113343396978562],
              [-13.377536725052058, -11.113665797187313],
              [-13.379255308758976, -11.113224296613003],
              [-13.381635684945685, -11.113242581179199],
              [-13.38394603524363, -11.114224884382459],
              [-13.386202583405595, -11.113342594315844],
              [-13.38710266746087, -11.111296977783008],
              [-13.39054822740792, -11.108303870655753],
              [-13.392165918459249, -11.109771093310178],
              [-13.392394621488304, -11.110559269176811],
              [-13.394320473887097, -11.112922105392155],
              [-13.39538984715587, -11.115446961219162],
              [-13.397994583490478, -11.115362502263592],
              [-13.400369873206294, -11.11573779804862],
              [-13.401537187239708, -11.11219858512448],
              [-13.405351266105699, -11.113669513406663],
              [-13.40647627503559, -11.114569503144855],
              [-13.407940904579233, -11.113937237942821],
              [-13.409335077331338, -11.114288974754203],
              [-13.41059935663933, -11.115502174479207],
              [-13.412582100142288, -11.11450745320845],
              [-13.413121440963195, -11.111947345101822],
              [-13.415008998247528, -11.111677008660534],
              [-13.416587352794288, -11.112385916593544],
              [-13.418699235851152, -11.111998072452051],
              [-13.419038533145756, -11.110578535983047],
              [-13.421393178347916, -11.107456262691922],
              [-13.425073830198945, -11.108940879350385],
              [-13.42653297196196, -11.110127608846524],
              [-13.427472266787234, -11.11015304156493],
              [-13.428444051540765, -11.111293257388418],
              [-13.430629985903476, -11.112158269905386],
              [-13.431761305663363, -11.11066486662777],
              [-13.431384727623664, -11.107282837806244],
              [-13.431579761959695, -11.105936758711023],
              [-13.433598670662438, -11.103046480410297],
              [-13.435579555914599, -11.104671664412853],
              [-13.436957682443644, -11.107020250495404],
              [-13.438106450800376, -11.11001026288891],
              [-13.439071714474826, -11.11153196110493],
              [-13.441895125662608, -11.112106273828115],
              [-13.442671106119946, -11.11373236685717],
              [-13.444085071169617, -11.114490477444159],
              [-13.445696026988363, -11.11379004558317],
              [-13.447848756260544, -11.113539760576264],
              [-13.449288905582126, -11.11394195107247],
              [-13.451161035565887, -11.113034551666162],
              [-13.453217491453096, -11.112555678056165],
              [-13.455342078643508, -11.114548238439305],
              [-13.457101206566755, -11.114149588244366],
              [-13.458197203407098, -11.11273344638384],
              [-13.459234934590722, -11.109270480890082],
              [-13.46071947244467, -11.1076945903196],
              [-13.46273707955142, -11.108059432019353],
              [-13.466185594801235, -11.106334332526194],
              [-13.469881514281333, -11.105918741093362],
              [-13.471974474498886, -11.106442462755348],
              [-13.474765837854095, -11.105342009243316],
              [-13.475055993450686, -11.107430625395455],
              [-13.477589872747487, -11.110467336583278],
              [-13.478079722927118, -11.112179511254864],
              [-13.478222881234482, -11.1166752932889],
              [-13.47917100843702, -11.119007763233673],
              [-13.479984014399111, -11.12197618598484],
              [-13.479238634630496, -11.123476879312049],
              [-13.479852516386085, -11.12561314433178],
              [-13.483378883640983, -11.127454281101727],
              [-13.485894594337095, -11.127519681718049],
              [-13.487257308650467, -11.128016529115868],
              [-13.483900204303605, -11.126516420256204],
              [-13.484085116268245, -11.125658007881594],
              [-13.482602812996987, -11.12464631217851],
              [-13.481513733606928, -11.124856357439143],
              [-13.4812671756592, -11.123039004359702],
              [-13.482509776315888, -11.118344278104354],
              [-13.48333323107488, -11.115946270387449],
              [-13.485664314858449, -11.114476357458454],
              [-13.486595116445052, -11.112890573363629],
              [-13.489814565146107, -11.108816181931223],
              [-13.490771436835642, -11.107148044897974],
              [-13.490461756745704, -11.103667756834085],
              [-13.491697461293935, -11.097562306793925],
              [-13.492996659690606, -11.09540846078251],
              [-13.494175337177882, -11.09157427298814]
            ]
          ],
          [
            [
              [-13.499884945294827, -11.107041344950876],
              [-13.499196748390904, -11.108169888511595],
              [-13.499176869161632, -11.109809462728345],
              [-13.499734807864277, -11.112817919116287],
              [-13.498727625261557, -11.11378536111504],
              [-13.496210147637136, -11.11785106726243],
              [-13.498054666251674, -11.116732061174979],
              [-13.498917947589058, -11.118509646005709],
              [-13.4968644333524, -11.119701505428518],
              [-13.49627803104747, -11.120800363628177],
              [-13.496532309469162, -11.122023523100731],
              [-13.495480056755254, -11.123847551241731],
              [-13.496238561195954, -11.125090048937382],
              [-13.498662519358101, -11.126345958910566],
              [-13.5027809815579, -11.127669448039052],
              [-13.505727204772727, -11.126294853653112],
              [-13.507175712118181, -11.12706773517211],
              [-13.507243269561531, -11.12684210250153],
              [-13.499884945294827, -11.107041344950876]
            ]
          ],
          [
            [
              [-13.484494329602217, -11.308234151287483],
              [-13.484078264262967, -11.307180158383458],
              [-13.484278849424786, -11.304045573752127],
              [-13.48570735692877, -11.302955501974493],
              [-13.48546024024858, -11.301814831112786],
              [-13.485387173121183, -11.297625678058708],
              [-13.48558910882683, -11.29537308023066],
              [-13.484941702316442, -11.294017460809796],
              [-13.482405622153694, -11.294164729491118],
              [-13.480926118011373, -11.293061931542535],
              [-13.480940628707833, -11.291400146709305],
              [-13.48011628575656, -11.29045263836402],
              [-13.478150396909738, -11.29160719423238],
              [-13.476555189870906, -11.292042204453592],
              [-13.475041068553862, -11.29310389663147],
              [-13.472266162098736, -11.294287225833354],
              [-13.471613327458995, -11.295151519189176],
              [-13.471699308502394, -11.296937919983137],
              [-13.474542913049135, -11.297303623465885],
              [-13.476039204334642, -11.299384756236535],
              [-13.477391433547405, -11.2979481925247],
              [-13.478809665833891, -11.297921133636343],
              [-13.479790722595228, -11.297203627235096],
              [-13.481052027360809, -11.297961741186999],
              [-13.480703633918658, -11.300818081931789],
              [-13.479504522941605, -11.302070825481037],
              [-13.479967054852148, -11.305038382291917],
              [-13.481718793472613, -11.304557260298607],
              [-13.48327078105548, -11.30809041803758],
              [-13.484494329602217, -11.308234151287483]
            ]
          ],
          [
            [
              [-13.512796681726142, -11.309053510333896],
              [-13.51209169625485, -11.307127485844482],
              [-13.510748017818836, -11.305885545234892],
              [-13.509209723658712, -11.30629614672837],
              [-13.5102055742587, -11.307894943612945],
              [-13.509941374070227, -11.309619044131612],
              [-13.507288967383394, -11.308949930740551],
              [-13.506617440707135, -11.310179963170267],
              [-13.508775312029798, -11.311670531749403],
              [-13.513054235759116, -11.309872135671267],
              [-13.512796681726142, -11.309053510333896]
            ]
          ],
          [
            [
              [-13.569473253533992, -11.150658537987542],
              [-13.569244781914712, -11.149463224640765],
              [-13.569956126922028, -11.147943493480199],
              [-13.56878821929696, -11.147141469798509],
              [-13.567990067014913, -11.149805792955066],
              [-13.568243120941043, -11.15071696642757],
              [-13.56712559409075, -11.15198483897389],
              [-13.568925283938587, -11.152549466817309],
              [-13.569473253533992, -11.150658537987542]
            ]
          ],
          [
            [
              [-13.574462933516546, -11.142531966240899],
              [-13.573980149955812, -11.14095843928982],
              [-13.57292983313247, -11.141333747176489],
              [-13.572242433552633, -11.142747624608361],
              [-13.574086490485108, -11.143285396883181],
              [-13.574462933516546, -11.142531966240899]
            ]
          ],
          [
            [
              [-13.517936611980335, -11.321768317001702],
              [-13.517076787513899, -11.320107483137857],
              [-13.515847047849643, -11.320354647964402],
              [-13.515301082917558, -11.322458183528585],
              [-13.516340806717569, -11.323500974206004],
              [-13.517369748435366, -11.32301881161623],
              [-13.517936611980335, -11.321768317001702]
            ]
          ],
          [
            [
              [-13.619835478835766, -11.048711927037816],
              [-13.618470886848677, -11.047801205419807],
              [-13.6167699015059, -11.047376923363082],
              [-13.614417800213968, -11.048294957495004],
              [-13.61166106124993, -11.048456038730862],
              [-13.610722723931838, -11.050708613363597],
              [-13.609904867684913, -11.051412008062004],
              [-13.610492010156298, -11.053628942241469],
              [-13.611773617064717, -11.053201602937545],
              [-13.61426560756781, -11.053593949926759],
              [-13.618002521731805, -11.052505138983452],
              [-13.618930739383671, -11.051155454105997],
              [-13.619835478835766, -11.048711927037816]
            ]
          ],
          [
            [
              [-13.610436898331496, -11.122056209547088],
              [-13.608547949176632, -11.120576901538232],
              [-13.606549116747857, -11.121658470081401],
              [-13.605547668927542, -11.121174466131617],
              [-13.603270481119585, -11.123583180799143],
              [-13.603267885190201, -11.125358556338195],
              [-13.600314031906766, -11.128156336056879],
              [-13.598159342054219, -11.129874729302772],
              [-13.596310532251321, -11.130911235682394],
              [-13.595910413583148, -11.133068990247814],
              [-13.593363200674846, -11.135444589557407],
              [-13.592417755202442, -11.135660068995387],
              [-13.590276646769636, -11.137475143480264],
              [-13.590262368781838, -11.138109086513692],
              [-13.587813642536704, -11.140606833546945],
              [-13.586551610312668, -11.141091674777368],
              [-13.584701426433943, -11.142858398710553],
              [-13.580763313139016, -11.147142593415134],
              [-13.579397990157693, -11.149422379138107],
              [-13.578405021050607, -11.152135378767907],
              [-13.577499421027294, -11.15368792728842],
              [-13.578932952934979, -11.156634744076802],
              [-13.580453227744204, -11.15636425069588],
              [-13.582597073170946, -11.155140635085717],
              [-13.583742213874704, -11.15370616814177],
              [-13.5842156068729, -11.151611810546692],
              [-13.585844057366375, -11.15055233142993],
              [-13.587024797225366, -11.148855331945963],
              [-13.587977259231279, -11.148915237706708],
              [-13.59523947787431, -11.143307135251375],
              [-13.599049175399037, -11.139851241726612],
              [-13.6013670411951, -11.135992079660426],
              [-13.597228107656733, -11.135198878113275],
              [-13.60118797050737, -11.13170031334723],
              [-13.604652704708847, -11.128007795675398],
              [-13.60552599208582, -11.127724490406269],
              [-13.6078490276333, -11.124872724894312],
              [-13.609436570348834, -11.123484679089295],
              [-13.610436898331496, -11.122056209547088]
            ]
          ],
          [
            [
              [-13.619044880771526, -11.124463746157298],
              [-13.617524271746111, -11.123870275331807],
              [-13.616365530402703, -11.126252524708939],
              [-13.615193875532698, -11.12749359161535],
              [-13.61619258798771, -11.128431064035341],
              [-13.617837481469714, -11.127741684164201],
              [-13.619044880771526, -11.124463746157298]
            ]
          ],
          [
            [
              [-13.628369126173714, -11.104758611319117],
              [-13.627362569442345, -11.104002148579072],
              [-13.62508033167446, -11.104088976619865],
              [-13.623012005342293, -11.10378505949005],
              [-13.621617084973517, -11.103093193583634],
              [-13.615572389721033, -11.106818213218911],
              [-13.613296011914423, -11.106587094966871],
              [-13.611943151816467, -11.105906474034441],
              [-13.609628046583591, -11.10770919108669],
              [-13.608816616448175, -11.108828405543004],
              [-13.60744852151781, -11.109370937969187],
              [-13.60563751766363, -11.111326079084172],
              [-13.60501482518394, -11.113458620456939],
              [-13.604215892038841, -11.11453678130049],
              [-13.60560873348081, -11.1150938219098],
              [-13.608220818229423, -11.115290516323611],
              [-13.608999037969197, -11.117663784776274],
              [-13.611109040703344, -11.117844570414983],
              [-13.612519785205032, -11.117313974997607],
              [-13.614670559659146, -11.119280852929117],
              [-13.616855828530461, -11.118482451793223],
              [-13.61723575632512, -11.117413979532976],
              [-13.619832330686933, -11.115738861149861],
              [-13.620500413133401, -11.11448426923079],
              [-13.622982692093125, -11.11272973932954],
              [-13.624359956144644, -11.110234185744398],
              [-13.625422197010646, -11.11037128677811],
              [-13.627080478277366, -11.106824907916502],
              [-13.628369126173714, -11.104758611319117]
            ]
          ],
          [
            [
              [-13.739324121070567, -11.027883046191223],
              [-13.738676658135761, -11.026569057333337],
              [-13.740090065353082, -11.024915155497926],
              [-13.73928020397724, -11.022789602041737],
              [-13.737799939180228, -11.024513738560938],
              [-13.737444075714413, -11.02553339827291],
              [-13.737643624765061, -11.028020021647945],
              [-13.736028986068511, -11.029435675749012],
              [-13.7354469666227, -11.030749387432282],
              [-13.73613592131581, -11.032975886964689],
              [-13.737282328281514, -11.032051983866202],
              [-13.738278567259567, -11.028925770279468],
              [-13.739324121070567, -11.027883046191223]
            ]
          ],
          [
            [
              [-13.727565701581828, -11.08763962167866],
              [-13.72562300475757, -11.089389333498689],
              [-13.724404903540561, -11.089585198730227],
              [-13.720316999754429, -11.091992386910633],
              [-13.719713375228816, -11.093067114385073],
              [-13.716368385669533, -11.0945951800992],
              [-13.714533218526817, -11.096855908763406],
              [-13.713707206215101, -11.096673014919647],
              [-13.71154383972079, -11.098554626334565],
              [-13.709306949916213, -11.101546380312183],
              [-13.708085442514982, -11.10130248755531],
              [-13.706145074757782, -11.099951517034295],
              [-13.70469891099126, -11.101069258715388],
              [-13.703727094840515, -11.099776638916225],
              [-13.703334746542465, -11.098086435506774],
              [-13.702267741170557, -11.096440426787682],
              [-13.702152954254506, -11.094587500405668],
              [-13.701086586564521, -11.090306335033725],
              [-13.699965491352007, -11.088385502093836],
              [-13.697693837768899, -11.08762995893441],
              [-13.694286022055222, -11.087339460963308],
              [-13.69269788463712, -11.086708351927442],
              [-13.690309001720012, -11.088009949605908],
              [-13.68720370993767, -11.086720677790456],
              [-13.68655725138267, -11.085947622246938],
              [-13.686892186690178, -11.082537958322453],
              [-13.688750453999107, -11.082061425300788],
              [-13.69093095523795, -11.079392915252189],
              [-13.690003138703238, -11.077950914282638],
              [-13.68872588776357, -11.07710779854032],
              [-13.687922802123415, -11.074806330751906],
              [-13.688318093080747, -11.073411171642551],
              [-13.687819016111995, -11.071420479140782],
              [-13.685824384372006, -11.071202878201953],
              [-13.684380218077898, -11.071967287090265],
              [-13.682352818124398, -11.071742329920658],
              [-13.678854500693399, -11.069824188066429],
              [-13.675701646657771, -11.06921162462656],
              [-13.674553092062366, -11.067662039873001],
              [-13.671802450557534, -11.066619914726878],
              [-13.670907205630787, -11.065934731676773],
              [-13.668960878947301, -11.063429873627186],
              [-13.668248052520891, -11.061835480517555],
              [-13.66823020479934, -11.059587848374433],
              [-13.630277764320368, -11.032546872703906],
              [-13.629894365878808, -11.032823821594175],
              [-13.629363589292323, -11.037838203865554],
              [-13.627044447762948, -11.038223361071779],
              [-13.626771266733165, -11.03967890555389],
              [-13.625301185224043, -11.042175335482566],
              [-13.625824174879602, -11.043283707780594],
              [-13.628102364350003, -11.044786027832888],
              [-13.629919361015205, -11.04483684084216],
              [-13.63375415399751, -11.046490482671095],
              [-13.63202857136053, -11.048052063999638],
              [-13.630052941207119, -11.04836118110065],
              [-13.628419381637602, -11.050357907935274],
              [-13.627594575322142, -11.050064005256361],
              [-13.626969802151619, -11.051912581558268],
              [-13.625427928674206, -11.052443277241856],
              [-13.624328881408175, -11.054194433014676],
              [-13.624839034180933, -11.057836090054167],
              [-13.624030994532482, -11.058950871094776],
              [-13.621428284829223, -11.060521276027044],
              [-13.61985397735849, -11.062175607248012],
              [-13.617927290301544, -11.062318462339249],
              [-13.615434119361188, -11.063241903127894],
              [-13.615133749123194, -11.064783174807147],
              [-13.612733798885845, -11.066868710978845],
              [-13.609824028292161, -11.06852781246267],
              [-13.608391813599983, -11.070453299529],
              [-13.60633414042279, -11.071735679247261],
              [-13.604620328562378, -11.073530933828984],
              [-13.602736008923229, -11.073821951772864],
              [-13.601132560783945, -11.076286472646094],
              [-13.59992745161981, -11.077192441492237],
              [-13.598438782620471, -11.079874083498016],
              [-13.598277637054247, -11.08082440433543],
              [-13.599702950687002, -11.083164477656238],
              [-13.599275001570732, -11.084670273876434],
              [-13.595723563038751, -11.087909668674142],
              [-13.592189884008878, -11.090064527599834],
              [-13.590756308621625, -11.090083563622388],
              [-13.5905606698031, -11.091433773063715],
              [-13.587859560740306, -11.092841429452077],
              [-13.587332352860637, -11.093636144893944],
              [-13.583900022302094, -11.095458215947883],
              [-13.582487534173417, -11.097303525725021],
              [-13.57988621572629, -11.09824126390127],
              [-13.577557865460973, -11.099626020530716],
              [-13.57667504457972, -11.100813557200196],
              [-13.574695353374405, -11.102259470044315],
              [-13.572002722613345, -11.103624530841778],
              [-13.573020440354941, -11.104344560006203],
              [-13.573033735633054, -11.105760368435822],
              [-13.570474428090733, -11.106847816009212],
              [-13.571360732151888, -11.108712698568002],
              [-13.572676533151343, -11.110389428522005],
              [-13.570774270220074, -11.112315722219456],
              [-13.568397545219094, -11.11355074611659],
              [-13.566910101423334, -11.115330883853046],
              [-13.566006964914376, -11.115556748643675],
              [-13.56476399000406, -11.117001216617345],
              [-13.563676403662912, -11.117079774519398],
              [-13.563635938178646, -11.120122999609617],
              [-13.560922821968074, -11.120663309868563],
              [-13.558912494127979, -11.121463318669],
              [-13.552829951834187, -11.125764718038514],
              [-13.550877644291742, -11.127541257895777],
              [-13.549888802987459, -11.130069642099947],
              [-13.548398716982708, -11.130389929955037],
              [-13.54480021094144, -11.133261973453378],
              [-13.544460677384208, -11.134620271506593],
              [-13.543379629438753, -11.135979753770364],
              [-13.544151749440879, -11.13850154460108],
              [-13.542931100401628, -11.141464525352134],
              [-13.541269139989145, -11.146396651791598],
              [-13.540307588088574, -11.146650823629294],
              [-13.538821547679184, -11.14971775331315],
              [-13.536646496649855, -11.150286418556293],
              [-13.537098058211296, -11.152072179535663],
              [-13.536385892366429, -11.152997920801877],
              [-13.535997412652206, -11.1548007021154],
              [-13.533454368470753, -11.155211200251552],
              [-13.532601504680695, -11.156139860874928],
              [-13.532633885487241, -11.158805209119855],
              [-13.53392765498928, -11.15984299505791],
              [-13.534089908287863, -11.162686094459373],
              [-13.532437146592583, -11.165981168624935],
              [-13.532578799749304, -11.168452754706497],
              [-13.530532290570342, -11.170941641836187],
              [-13.530616030843227, -11.173304529673041],
              [-13.527541489079823, -11.17566281038653],
              [-13.525753307833979, -11.177773846703912],
              [-13.520329315234152, -11.18165959375171],
              [-13.518372845491786, -11.18225143073579],
              [-13.51796313979878, -11.182951774950514],
              [-13.514221425747985, -11.185197975392759],
              [-13.512722756374332, -11.184645407702684],
              [-13.51013213883644, -11.186924401300919],
              [-13.50942796828964, -11.188544346557611],
              [-13.506180754401768, -11.194618964866217],
              [-13.505529503694028, -11.197819310591766],
              [-13.504706139241863, -11.19995594227341],
              [-13.503792994888608, -11.200916037228392],
              [-13.503530134976463, -11.203777609028986],
              [-13.504164646885105, -11.20470861658544],
              [-13.503935111312575, -11.20615551383805],
              [-13.50503233791874, -11.20695314454526],
              [-13.50637045972028, -11.206996737191453],
              [-13.50841120339762, -11.205279188858842],
              [-13.509414319110652, -11.205495518456724],
              [-13.511968249352568, -11.201729678773225],
              [-13.514954899525863, -11.19864915350473],
              [-13.516030743903098, -11.196590987041361],
              [-13.517150963270403, -11.1922044100414],
              [-13.519808080000537, -11.19058678550381],
              [-13.5209844030137, -11.189524609778084],
              [-13.525914455660379, -11.186171665448567],
              [-13.529336037999066, -11.183458207334432],
              [-13.53163570759421, -11.1809064466443],
              [-13.534718590727573, -11.18056590962201],
              [-13.53654136664381, -11.179656246528756],
              [-13.537392740710404, -11.177854001532294],
              [-13.539227874277042, -11.176902805980399],
              [-13.542341289737049, -11.176020928636275],
              [-13.544720296907341, -11.176426656059052],
              [-13.545893211304694, -11.174631466517395],
              [-13.545631745825835, -11.173406405112694],
              [-13.547264645929369, -11.171477485637462],
              [-13.548145555150144, -11.17133407537309],
              [-13.548756756813198, -11.169551672157025],
              [-13.550468101062565, -11.167372789597973],
              [-13.552938025482275, -11.16748466057409],
              [-13.553387480434706, -11.16679808702255],
              [-13.552805775877369, -11.164972950916013],
              [-13.554153737725688, -11.162913105072992],
              [-13.554779927117638, -11.161228196871285],
              [-13.555625534768224, -11.160753910500919],
              [-13.556655658843255, -11.156768200819789],
              [-13.55882681370211, -11.156058011188394],
              [-13.559209465105491, -11.154848719570616],
              [-13.56129585712247, -11.154112426890569],
              [-13.562267038634792, -11.152945257709248],
              [-13.562091615301503, -11.149692521106097],
              [-13.563604874293857, -11.144761855351256],
              [-13.565406359909405, -11.143163741620043],
              [-13.568028156289367, -11.142043293622567],
              [-13.566587511916289, -11.141330915975994],
              [-13.569762839460866, -11.136407779880262],
              [-13.571115765582238, -11.136956281988684],
              [-13.574765551770582, -11.134916613235948],
              [-13.575581592926019, -11.133795932128113],
              [-13.577068446798918, -11.134065106360318],
              [-13.578332481757075, -11.132988788854266],
              [-13.58158769306118, -11.131605232274463],
              [-13.582011295766762, -11.131140712029808],
              [-13.585349924026616, -11.129782113628991],
              [-13.586116824044364, -11.128373303974426],
              [-13.587566784979717, -11.127582021040999],
              [-13.586857791257714, -11.125726304266736],
              [-13.588960056301175, -11.124768198404459],
              [-13.590026949851298, -11.125045921112408],
              [-13.590945852611934, -11.122271459042631],
              [-13.59249785657042, -11.12041822677143],
              [-13.59634571817709, -11.121536724075016],
              [-13.597690728015767, -11.12048623363404],
              [-13.5987453842978, -11.116980326661947],
              [-13.602072427224456, -11.11152327103107],
              [-13.60526873595819, -11.1072117477124],
              [-13.603161519984363, -11.103209638296716],
              [-13.605841956279491, -11.100245986292283],
              [-13.606578754803913, -11.097604932196024],
              [-13.612870176435656, -11.093688661174763],
              [-13.614684388809035, -11.092010190896834],
              [-13.61527400988696, -11.089100110896922],
              [-13.616200334036616, -11.088198863052504],
              [-13.6195333415752, -11.08607168390369],
              [-13.623875103732564, -11.08247869868475],
              [-13.627216001276295, -11.083257336681154],
              [-13.629152115601997, -11.082206695250493],
              [-13.629957488800333, -11.080952093158773],
              [-13.631194528037259, -11.08155099462247],
              [-13.631290838311777, -11.082713831383394],
              [-13.633817676299403, -11.08197633195397],
              [-13.636024404281388, -11.080643716804886],
              [-13.638585987095269, -11.08082302941005],
              [-13.639199409141312, -11.080327238309986],
              [-13.641922063274105, -11.079692904977067],
              [-13.642071200447782, -11.081278646404394],
              [-13.640068999433895, -11.08240110319166],
              [-13.638844834089344, -11.083530456443972],
              [-13.63653489712001, -11.084605995582862],
              [-13.634146712235868, -11.086519851566695],
              [-13.630875434429965, -11.088168529470263],
              [-13.626596695926954, -11.091420776981966],
              [-13.62412497943953, -11.092856503360963],
              [-13.623153392405499, -11.094788782433014],
              [-13.622399296214189, -11.095288268550329],
              [-13.620930913506255, -11.098661786116105],
              [-13.624234815249853, -11.09883781163223],
              [-13.626066491369757, -11.097980828389435],
              [-13.628354208900998, -11.096397816565482],
              [-13.62986156947692, -11.096578192150567],
              [-13.633409925879597, -11.095963764639594],
              [-13.634163464148969, -11.095463596224207],
              [-13.637468372134071, -11.094593647046755],
              [-13.640600523210018, -11.092945852360247],
              [-13.642440703782592, -11.093678322994855],
              [-13.64155134461652, -11.097722494441344],
              [-13.63918136257363, -11.098692072615373],
              [-13.63706979364012, -11.10001139300496],
              [-13.63730350671044, -11.101624745227008],
              [-13.63588978784033, -11.101882311737661],
              [-13.634460138729139, -11.103224533422273],
              [-13.634473468559463, -11.104363823126619],
              [-13.632419328383529, -11.107563533726875],
              [-13.628945885144358, -11.11147419543563],
              [-13.626377581283771, -11.11484015471013],
              [-13.623694755532307, -11.11753571948393],
              [-13.623023710046745, -11.119244433527639],
              [-13.62291332837588, -11.121667154626886],
              [-13.621652126666971, -11.123199377535261],
              [-13.621826982760139, -11.124116349017925],
              [-13.62126587490079, -11.126359390673091],
              [-13.621635732798708, -11.129018686970085],
              [-13.62165876775413, -11.132348493758613],
              [-13.621165648243368, -11.13333865515101],
              [-13.621195507703568, -11.13694442848922],
              [-13.62268911620358, -11.138667480775167],
              [-13.622248223711606, -11.140083480906487],
              [-13.620914264175044, -11.141551173883666],
              [-13.620966453477548, -11.142569034408245],
              [-13.619513050978286, -11.147236133751592],
              [-13.617944095797176, -11.147677151601666],
              [-13.616322834194461, -11.14650728298442],
              [-13.616150679346413, -11.143949011343727],
              [-13.61711199317515, -11.141458238044425],
              [-13.618374987777175, -11.140516217264402],
              [-13.618293605312928, -11.138259920604662],
              [-13.616297541150475, -11.135337850091966],
              [-13.614818650050493, -11.132388643301887],
              [-13.613812812166639, -11.131767834282046],
              [-13.614024764015808, -11.130055631299886],
              [-13.612363146414191, -11.13064848898583],
              [-13.61004836227367, -11.132001441565764],
              [-13.608608613109693, -11.13439213255227],
              [-13.606558311843987, -11.136371938958577],
              [-13.60566852239972, -11.136559690910278],
              [-13.604041149219608, -11.139988860057313],
              [-13.602232797109208, -11.14222458263633],
              [-13.600379912207277, -11.14312523499336],
              [-13.596663582556113, -11.147021184660863],
              [-13.594994661388116, -11.148068718323849],
              [-13.594462786951025, -11.149322769853232],
              [-13.59087372808931, -11.152802957994588],
              [-13.58823503434775, -11.155018900973154],
              [-13.58592240607415, -11.158110349318566],
              [-13.58599856587122, -11.159046820504038],
              [-13.58345136000694, -11.161702859410484],
              [-13.58129391129732, -11.164294555779717],
              [-13.578880313100807, -11.16607811099705],
              [-13.576473257591356, -11.16886987594669],
              [-13.575192094475401, -11.169259242340583],
              [-13.573425047533165, -11.168540846922777],
              [-13.572980696473907, -11.171424827020296],
              [-13.571949859246436, -11.173079456835909],
              [-13.569065783993175, -11.175316150333721],
              [-13.568007353364285, -11.174995176172818],
              [-13.562088730150966, -11.17846253113354],
              [-13.56227491168924, -11.179343397153193],
              [-13.55904578028061, -11.181338697548556],
              [-13.557765728561902, -11.182598770195842],
              [-13.55711892604122, -11.184646748168472],
              [-13.559662149994795, -11.186152200852936],
              [-13.56133843054572, -11.186432283757783],
              [-13.563455698086399, -11.187670129273227],
              [-13.564117107024874, -11.189107558971351],
              [-13.563863193953962, -11.191092256805945],
              [-13.564352584675825, -11.192340096655855],
              [-13.56193846370203, -11.195136811866028],
              [-13.56069794085527, -11.19288150775125],
              [-13.559565364270219, -11.191758615315996],
              [-13.558195613584617, -11.191388518772204],
              [-13.555866002323352, -11.19008503143179],
              [-13.554109763634225, -11.19005545060229],
              [-13.55291182844125, -11.18914108400849],
              [-13.551471052214138, -11.189435970197211],
              [-13.548986097634183, -11.188771494081413],
              [-13.546837912916317, -11.189538330144867],
              [-13.5457597913368, -11.190447502409032],
              [-13.540695983277471, -11.192343052498813],
              [-13.54031675717111, -11.193099177713588],
              [-13.53747502014094, -11.194433842608614],
              [-13.536774828737334, -11.195321256733916],
              [-13.532650845948242, -11.197319740157006],
              [-13.532069167453193, -11.198564891865558],
              [-13.531085206935675, -11.198585775665489],
              [-13.530288078646425, -11.20036183469498],
              [-13.529811796651291, -11.205818820564717],
              [-13.52869906583073, -11.21034837446457],
              [-13.528107256705283, -11.214119342492246],
              [-13.52736778332927, -11.2160077141782],
              [-13.52513939070733, -11.219648378837391],
              [-13.523793998191369, -11.220800520344698],
              [-13.52146890253254, -11.223861106468904],
              [-13.51942589398405, -11.225444334540908],
              [-13.5155577515315, -11.22748188535461],
              [-13.51264987956017, -11.230457653812977],
              [-13.511028650870964, -11.231296230240376],
              [-13.507929037963265, -11.234721122062275],
              [-13.506565922044205, -11.23665224842134],
              [-13.50460400051322, -11.238262195993805],
              [-13.50232362828316, -11.241894471419444],
              [-13.500233630539523, -11.244341499330359],
              [-13.50082699904986, -11.245999035158965],
              [-13.500216807095526, -11.247471757685057],
              [-13.498784891568876, -11.24800086261922],
              [-13.495359796855125, -11.250961866455913],
              [-13.494903489484962, -11.252390532018135],
              [-13.497092177536446, -11.25227836980107],
              [-13.498581812772816, -11.250982661444834],
              [-13.499998563418155, -11.248742360071182],
              [-13.501903881500589, -11.247021177289986],
              [-13.503671299376558, -11.24631846626706],
              [-13.504481868871526, -11.24421584986239],
              [-13.505704662917573, -11.243899495739278],
              [-13.50726433303977, -11.242672291293614],
              [-13.50776655162838, -11.241535985276391],
              [-13.511605898390586, -11.239164310063742],
              [-13.513882041611259, -11.238617502952653],
              [-13.514509119180738, -11.239730615342362],
              [-13.512828914302052, -11.242809744387145],
              [-13.511237399474606, -11.244580432802508],
              [-13.513668302426389, -11.244725420767468],
              [-13.514529127812041, -11.247015925024703],
              [-13.512929891128202, -11.248370562136023],
              [-13.510700601558746, -11.250823009474093],
              [-13.508876527284423, -11.25229351739538],
              [-13.506684759620535, -11.251391672301619],
              [-13.50319579788417, -11.255442413253748],
              [-13.502292340541809, -11.257103230290703],
              [-13.500674597998582, -11.258360793840893],
              [-13.500403573206261, -11.264647094655142],
              [-13.499707946608021, -11.266095692420421],
              [-13.49651854044969, -11.269782125585335],
              [-13.494541707857115, -11.27083876909675],
              [-13.494603785432117, -11.271966554686458],
              [-13.493425244821134, -11.27419209223546],
              [-13.491953449444905, -11.275866443495756],
              [-13.492355920317006, -11.277838514898127],
              [-13.4931639045925, -11.27868700122002],
              [-13.49341777937218, -11.281862198000082],
              [-13.494433694939923, -11.283236736688822],
              [-13.496220120455932, -11.284107368907808],
              [-13.496804024841826, -11.28507239684968],
              [-13.499161634047242, -11.28694963562582],
              [-13.499862714618, -11.288874765651352],
              [-13.499802708210272, -11.290243372581847],
              [-13.50159084772481, -11.290374117910936],
              [-13.502566071019574, -11.290995795804857],
              [-13.5038321800509, -11.292769367903327],
              [-13.502425776329726, -11.293357169317376],
              [-13.50221328442948, -11.295650660723007],
              [-13.503564401491708, -11.3011515879018],
              [-13.506488222923196, -11.30273714926878],
              [-13.508836739491514, -11.30243551071423],
              [-13.509481162207457, -11.301290481242448],
              [-13.511575449665175, -11.30104969706335],
              [-13.512706265364848, -11.300145663413478],
              [-13.513513246325802, -11.29863427678593],
              [-13.51450744942695, -11.298012456915265],
              [-13.519882068981342, -11.298814971995629],
              [-13.523423195481273, -11.297995993522749],
              [-13.52523447847927, -11.295080448376032],
              [-13.527976529318474, -11.29337184467523],
              [-13.528881883980036, -11.29124516518545],
              [-13.530692313105154, -11.289069903285233],
              [-13.531787683379372, -11.289309865074197],
              [-13.531648611467132, -11.290791216498317],
              [-13.530652479323983, -11.292613462516185],
              [-13.529812173788429, -11.29512977611516],
              [-13.530524402926236, -11.295992177278713],
              [-13.529116301776297, -11.297782761913838],
              [-13.528889798454985, -11.299839338022732],
              [-13.529976656377686, -11.303680368886667],
              [-13.531435078126854, -11.304260756840781],
              [-13.532615930030742, -11.302446535487448],
              [-13.534554807403387, -11.300307886980217],
              [-13.53552129062491, -11.29976892826825],
              [-13.537415910568628, -11.294939004850534],
              [-13.541853038372857, -11.290510967329299],
              [-13.54337306106827, -11.290739622028147],
              [-13.545641302141616, -11.290225183555863],
              [-13.547933733570249, -11.286949695078809],
              [-13.549554566134615, -11.285363697517608],
              [-13.551024887147891, -11.285300125899637],
              [-13.553740208303505, -11.2864877235274],
              [-13.553631677493447, -11.289222316883281],
              [-13.550339541521724, -11.290766603007174],
              [-13.549461620557492, -11.292670129925666],
              [-13.548246173512656, -11.293410835332747],
              [-13.545181179354351, -11.293777785413356],
              [-13.542510229109647, -11.299896094434592],
              [-13.542456297128224, -11.30066467535467],
              [-13.544160934833798, -11.301502667226666],
              [-13.544073462182258, -11.302676897588604],
              [-13.54274073618201, -11.30393711552139],
              [-13.53956286633061, -11.303161942223461],
              [-13.53865983465464, -11.303350964242158],
              [-13.536699006087552, -11.305114364329118],
              [-13.534865917644508, -11.305576424364652],
              [-13.534163562010306, -11.30721254330944],
              [-13.535473419400766, -11.308117122612082],
              [-13.537119271237804, -11.307505769432476],
              [-13.537982577302303, -11.309383942609832],
              [-13.539282772124434, -11.310469743959887],
              [-13.539867193393329, -11.311893997824123],
              [-13.538922868068259, -11.312810534359777],
              [-13.536151664078826, -11.311927251476098],
              [-13.534716863343174, -11.310522833752373],
              [-13.533823432332783, -11.310529877735553],
              [-13.533171136191466, -11.31185812750358],
              [-13.532020486176746, -11.311787630301081],
              [-13.529124179520565, -11.313684997437923],
              [-13.52818602972732, -11.315620828850621],
              [-13.524719125501157, -11.316791325823951],
              [-13.524668612243682, -11.318441463834437],
              [-13.52396172279275, -11.31993914733886],
              [-13.523445244606531, -11.323068439351559],
              [-13.524354516607694, -11.325102817511382],
              [-13.524083823184998, -11.326409597286498],
              [-13.524878457291615, -11.331048111772164],
              [-13.526072292287703, -11.330390852427469],
              [-13.526769943901861, -11.32847238212078],
              [-13.530404893719213, -11.330358507459076],
              [-13.531426426208466, -11.331593036851913],
              [-13.530903055556657, -11.334304979210108],
              [-13.529677667897662, -11.336111160354495],
              [-13.529908530588262, -11.338218639240967],
              [-13.528413544963383, -11.342677180846716],
              [-13.52850574992164, -11.344928740433577],
              [-13.5306196294417, -11.348532516118395],
              [-13.530984428958583, -11.350218184700704],
              [-13.532650014872354, -11.354057486083247],
              [-13.535312522917614, -11.358475495770582],
              [-13.53803783898385, -11.360593748365634],
              [-13.538964589607355, -11.36003777756047],
              [-13.539792889494995, -11.35769140793728],
              [-13.54112312040253, -11.357349498674838],
              [-13.544318498917331, -11.358263569503679],
              [-13.545373815120872, -11.359553531927295],
              [-13.544679073844, -11.360874159370802],
              [-13.544980123661755, -11.363375015045301],
              [-13.544467413237575, -11.363962493821314],
              [-13.54268676725663, -11.362732499281153],
              [-13.541445661711949, -11.363240686753718],
              [-13.541292929891055, -11.365837432787549],
              [-13.545367874324585, -11.366504613193932],
              [-13.546275242994767, -11.36751847926626],
              [-13.54599447988877, -11.369474377686402],
              [-13.544368947046955, -11.370609680933994],
              [-13.543932277336628, -11.372612311548654],
              [-13.54600970532355, -11.374858784402317],
              [-13.547659987047153, -11.375909689381295],
              [-13.551101151528735, -11.37559518164914],
              [-13.553100491511895, -11.374616994941764],
              [-13.554122218079867, -11.376174691066154],
              [-13.551083252903942, -11.381248731313033],
              [-13.552058391428874, -11.382050648080005],
              [-13.554513901502025, -11.382181786655638],
              [-13.55655949653023, -11.383024851851244],
              [-13.558495795058548, -11.381794303930013],
              [-13.560151553685795, -11.381314615646277],
              [-13.561802193776021, -11.38176071862645],
              [-13.56310101471052, -11.383492854481213],
              [-13.559071364423652, -11.387068498915943],
              [-13.561539637989378, -11.38655229218029],
              [-13.563515557889971, -11.386862719014855],
              [-13.564253343643083, -11.387824812913774],
              [-13.564409299373077, -11.389448483348039],
              [-13.5627124691636, -11.39112330974359],
              [-13.55783683738591, -11.39180408540914],
              [-13.555868129477032, -11.392377001753326],
              [-13.555897594827748, -11.394103050176806],
              [-13.556546811943837, -11.395503885162357],
              [-13.55866931465425, -11.398690045122098],
              [-13.559656050706081, -11.400980727791593],
              [-13.561711831244253, -11.403171521707641],
              [-13.562592758851304, -11.405198308064083],
              [-13.5646517420888, -11.406925587152996],
              [-13.565088984187541, -11.407798372280132],
              [-13.567214306331723, -11.409312585557716],
              [-13.567509049625155, -11.410189565340032],
              [-13.569811714089685, -11.41189519974666],
              [-13.571484066778789, -11.41457438309641],
              [-13.571257364889059, -11.416225456191906],
              [-13.56992019334214, -11.418569899029968],
              [-13.567438186182189, -11.421411256292057],
              [-13.569496547607136, -11.42192927580556],
              [-13.571137459796345, -11.421811641156772],
              [-13.572934908543154, -11.42271617750769],
              [-13.574617485020628, -11.423075241290642],
              [-13.576724377576289, -11.424813887358422],
              [-13.577888237338565, -11.425018910487195],
              [-13.580143883239815, -11.426429413263442],
              [-13.581055966678786, -11.425305232694418],
              [-13.583483010709378, -11.425697360620383],
              [-13.584027643335787, -11.427762888545487],
              [-13.586764358623283, -11.427455714364173],
              [-13.585364986531218, -11.422490777233623],
              [-13.586931816907398, -11.422303391198238],
              [-13.587928403268766, -11.42366544544928],
              [-13.589506170542398, -11.424363195809452],
              [-13.591031138727848, -11.425695026045679],
              [-13.591375455460854, -11.42672536168837],
              [-13.591224130101951, -11.428910039272361],
              [-13.59169018857125, -11.429697559079122],
              [-13.591430609069217, -11.432082906647139],
              [-13.592772139449705, -11.432477990932115],
              [-13.593363879450763, -11.43070138020656],
              [-13.593322869733337, -11.429295977997842],
              [-13.594114523314234, -11.42702136321333],
              [-13.594244061227235, -11.424598754086757],
              [-13.593681028407342, -11.422436647886295],
              [-13.59477015708849, -11.420575600089105],
              [-13.595753128938359, -11.419983333575212],
              [-13.596903777535086, -11.417305907040184],
              [-13.59809096068435, -11.415892244245283],
              [-13.5979733361957, -11.413816432672434],
              [-13.599432340913111, -11.412437170463198],
              [-13.602164442387553, -11.409206453507563],
              [-13.60176880785554, -11.40788470171744],
              [-13.602342799740743, -11.405549993989416],
              [-13.603614938834726, -11.404163268913024],
              [-13.605308750630217, -11.403549325299185],
              [-13.605733607677207, -11.402469363788189],
              [-13.605286753813921, -11.40085502954089],
              [-13.605962222758073, -11.399570886089005],
              [-13.605956113322877, -11.397901265869752],
              [-13.604524693869648, -11.396738818810183],
              [-13.605135757914672, -11.395204836385004],
              [-13.608322656501146, -11.394011987616004],
              [-13.60748938495748, -11.39135887656258],
              [-13.607126893892742, -11.388705525843916],
              [-13.604618947653556, -11.387226011716033],
              [-13.604230418441237, -11.385120865895042],
              [-13.607623364767173, -11.383250749218464],
              [-13.60833641290147, -11.382303669210296],
              [-13.610761303337169, -11.38098176800919],
              [-13.612657956655182, -11.381076964084071],
              [-13.612371315339104, -11.379558427936368],
              [-13.613489951487756, -11.377898502710867],
              [-13.614594039556193, -11.377205951611016],
              [-13.614518036157099, -11.376073645338513],
              [-13.61598372266533, -11.372204551965334],
              [-13.61768234334904, -11.370947357466022],
              [-13.618989616888133, -11.36897423614006],
              [-13.619185249747948, -11.367414384674523],
              [-13.620412933457834, -11.36324703037059],
              [-13.620412255746148, -11.360336934274908],
              [-13.619190167634587, -11.35743731280044],
              [-13.617734802515594, -11.358209641657796],
              [-13.617621483630508, -11.359192322488745],
              [-13.61579010104478, -11.360731971590242],
              [-13.614713876282515, -11.360877287870466],
              [-13.611767122133097, -11.360239989451411],
              [-13.610605919673546, -11.36188470873146],
              [-13.609515493448887, -11.362533726048062],
              [-13.604621087984816, -11.362429629267279],
              [-13.603573948870906, -11.361103685633042],
              [-13.602748626361837, -11.359057055691657],
              [-13.601792116443393, -11.359421381006488],
              [-13.599895773152884, -11.358721956955382],
              [-13.599536207515992, -11.358060844262713],
              [-13.601763376510453, -11.355853838983617],
              [-13.604571122468373, -11.355112675010433],
              [-13.607943870449395, -11.355277154221884],
              [-13.60847564982685, -11.355988793145716],
              [-13.61208447387889, -11.354466354224806],
              [-13.612883056918227, -11.353085381378191],
              [-13.614858322645263, -11.352605505220374],
              [-13.616645109896494, -11.351515982709953],
              [-13.616708452943323, -11.349780337692431],
              [-13.618457478326098, -11.347895088642456],
              [-13.616837642506752, -11.347371870273072],
              [-13.616995190165051, -11.345941223928467],
              [-13.614044991638979, -11.344563741699917],
              [-13.613897513558554, -11.341381804317786],
              [-13.61305673251775, -11.340764336589324],
              [-13.612490617812844, -11.336813603409402],
              [-13.613002490527284, -11.334842780638782],
              [-13.611653551753472, -11.333290915133048],
              [-13.607312010680165, -11.330208244070032],
              [-13.60482146850917, -11.328871136872737],
              [-13.603375293065453, -11.327335768036265],
              [-13.6041531922909, -11.32466042756731],
              [-13.604933553232428, -11.323646282700127],
              [-13.606925890893415, -11.323406566020916],
              [-13.608973050186634, -11.32207624730572],
              [-13.61032561921043, -11.32178508374709],
              [-13.613099593384815, -11.322651547483362],
              [-13.61559808606447, -11.323804965187522],
              [-13.618575457120363, -11.3223335495299],
              [-13.618327714784863, -11.320094804356705],
              [-13.619103810379377, -11.31848099812124],
              [-13.618842401868791, -11.316745142728676],
              [-13.619479492780323, -11.315735628881066],
              [-13.620075763077475, -11.312273416571585],
              [-13.620097257555177, -11.31053009761366],
              [-13.620874084441086, -11.308457540333533],
              [-13.622629377518049, -11.307456584514618],
              [-13.62308026191375, -11.305380440333405],
              [-13.624403892712781, -11.30365430824453],
              [-13.622521603252013, -11.30263846999892],
              [-13.621488975786274, -11.301137002087629],
              [-13.621453894289491, -11.299884231456899],
              [-13.619893971812289, -11.30025113685873],
              [-13.615648602435256, -11.2991790981419],
              [-13.614331154378819, -11.301182545038401],
              [-13.6138895036828, -11.302616772219999],
              [-13.614902421441357, -11.303423094156411],
              [-13.614602216258133, -11.304853523573613],
              [-13.611997012551713, -11.304818605800927],
              [-13.609294986432165, -11.305399711400222],
              [-13.60511146596587, -11.307751668410763],
              [-13.603850988712832, -11.306686663791071],
              [-13.60111996093032, -11.306750777665538],
              [-13.600055034350412, -11.307171793202482],
              [-13.597655586967882, -11.305859587498647],
              [-13.594607882722178, -11.305736453563478],
              [-13.591463362587389, -11.303509525115066],
              [-13.591604643461181, -11.301846660730853],
              [-13.595009868009251, -11.300511145333749],
              [-13.596613668575593, -11.30121899519391],
              [-13.598663779920072, -11.302750043759145],
              [-13.600357569269105, -11.302562519252904],
              [-13.602661680285093, -11.302970630737642],
              [-13.603590301933592, -11.302233278733912],
              [-13.603376448028742, -11.300051413172266],
              [-13.604868548597281, -11.299757860284918],
              [-13.608324895635308, -11.297791121468451],
              [-13.609481295582864, -11.295556531376793],
              [-13.614196884703189, -11.291617314573948],
              [-13.615200312696896, -11.291086776164198],
              [-13.618149737648697, -11.288327229030596],
              [-13.623437463219128, -11.284329262247729],
              [-13.62510835178031, -11.281928130481505],
              [-13.624618966591196, -11.28109432774182],
              [-13.625157892839876, -11.279645546366707],
              [-13.628496133577556, -11.27833571403798],
              [-13.629562763466527, -11.279110243677717],
              [-13.628720470488785, -11.280790753291202],
              [-13.633521655041017, -11.28275921694265],
              [-13.637237942429039, -11.282339273450654],
              [-13.637667050837866, -11.281547256262781],
              [-13.636797356523667, -11.280280769426302],
              [-13.635712624874959, -11.279868923811977],
              [-13.634253017267485, -11.280678583015298],
              [-13.632116962461627, -11.280048213549462],
              [-13.63176069123004, -11.2789323983711],
              [-13.632400804188526, -11.277605788064882],
              [-13.632190771690981, -11.27616615772348],
              [-13.63387761278719, -11.274919264579081],
              [-13.635769910591856, -11.27148409066619],
              [-13.636588041363744, -11.270486302707726],
              [-13.63858842076453, -11.269883246937967],
              [-13.640307430073296, -11.268830062341891],
              [-13.6381131891853, -11.266577103538124],
              [-13.640386580027657, -11.263715532918534],
              [-13.640817350423804, -11.260036090475802],
              [-13.642480548721522, -11.258555294888382],
              [-13.643303587186944, -11.25678064128247],
              [-13.645214757451107, -11.25463995003472],
              [-13.646803281676645, -11.251579546582466],
              [-13.648310315466421, -11.250603660643042],
              [-13.649558213893945, -11.248955448786358],
              [-13.650599296174631, -11.248437651055525],
              [-13.652712424179404, -11.246541286664767],
              [-13.65433724899238, -11.245783268407676],
              [-13.656769842986657, -11.243294112081257],
              [-13.65861561796329, -11.24241816288779],
              [-13.65976694113964, -11.241383906203701],
              [-13.663568533989569, -11.23911483361876],
              [-13.663357991496342, -11.236765828910762],
              [-13.665025138792897, -11.234191438533195],
              [-13.670807416657505, -11.224507037619485],
              [-13.67176261815904, -11.22122416205358],
              [-13.673566033550909, -11.220017723706153],
              [-13.673473308642842, -11.218803271326989],
              [-13.67544210601394, -11.217508305326858],
              [-13.67492896729608, -11.215851098449155],
              [-13.675091456674734, -11.21425548766933],
              [-13.675809852441347, -11.21387260189483],
              [-13.676512062344496, -11.212024572551766],
              [-13.678003899964523, -11.210773556836443],
              [-13.681058221509314, -11.209250589685652],
              [-13.682752879428868, -11.207785569340556],
              [-13.682897717932443, -11.206550627687223],
              [-13.684082448403151, -11.205392473526846],
              [-13.68497032573797, -11.201867819404287],
              [-13.686625752583602, -11.199161494011468],
              [-13.686584424227375, -11.195047265756397],
              [-13.686945403083422, -11.193558252171908],
              [-13.68697239607025, -11.188919347846621],
              [-13.68609183810315, -11.186656997245109],
              [-13.686559963296824, -11.183606140186383],
              [-13.688166442483311, -11.182574546697953],
              [-13.689145735229483, -11.181177166871988],
              [-13.688955721298239, -11.179983296902286],
              [-13.689596587204727, -11.177121722095777],
              [-13.689135728292936, -11.175757804698916],
              [-13.689653006934392, -11.174817249908758],
              [-13.690478302863403, -11.168325957999123],
              [-13.692379549850157, -11.166018557481147],
              [-13.694753816656608, -11.164577468146263],
              [-13.695058839650203, -11.163575686292056],
              [-13.694429649709292, -11.161254861470807],
              [-13.6965751305694, -11.158293458996722],
              [-13.698533788764943, -11.15473262168309],
              [-13.698948601344611, -11.153219140467758],
              [-13.700272032629218, -11.151290386062348],
              [-13.704150817931318, -11.147613664167253],
              [-13.703564029107989, -11.14712379417073],
              [-13.704341322845124, -11.145172582982811],
              [-13.70634308014624, -11.14312654286958],
              [-13.70736047953073, -11.140384372403068],
              [-13.707825022828368, -11.13825203546427],
              [-13.709276603983563, -11.136499813382553],
              [-13.710251414459378, -11.136014061989707],
              [-13.710879827091087, -11.13470165243738],
              [-13.70872809639437, -11.134978881945278],
              [-13.70817566989246, -11.133774098568475],
              [-13.713043083091323, -11.130302211328578],
              [-13.713177821999674, -11.128800436625282],
              [-13.716467082113557, -11.125427624145045],
              [-13.716346979927788, -11.123655835424232],
              [-13.714457921573048, -11.124168412962444],
              [-13.714933956041552, -11.121664739267098],
              [-13.71579998879779, -11.12093714577113],
              [-13.716173325364863, -11.119392932550092],
              [-13.71809387962462, -11.11624159084904],
              [-13.720883314650441, -11.113726142300875],
              [-13.723272323246622, -11.112110161904985],
              [-13.725417251152935, -11.10933004565678],
              [-13.727547947009109, -11.108098555404291],
              [-13.727057825098438, -11.106352222708443],
              [-13.728889277296577, -11.103921315685005],
              [-13.730428147991, -11.102923733148199],
              [-13.731538857477597, -11.098501539358283],
              [-13.730209050835414, -11.096847985610664],
              [-13.73103772831942, -11.094987600064282],
              [-13.731009642304421, -11.09392736241332],
              [-13.729106932151963, -11.093989673310011],
              [-13.728475146384392, -11.0933054980097],
              [-13.729499780306009, -11.091068875652246],
              [-13.729339742160647, -11.089025330477606],
              [-13.727565701581828, -11.08763962167866]
            ]
          ],
          [
            [
              [-13.731365962942542, -11.037159742288145],
              [-13.73287307611173, -11.051017627860514],
              [-13.733071136146995, -11.052036479448208],
              [-13.735040207617818, -11.053438865306637],
              [-13.734122135459353, -11.055626073967572],
              [-13.734623260845082, -11.059295675686691],
              [-13.73605386260323, -11.061036064252864],
              [-13.73500539059869, -11.063244447501475],
              [-13.734327551582009, -11.065580576853604],
              [-13.734485008222075, -11.066425111664806],
              [-13.73262380730393, -11.06962248281664],
              [-13.732927955102486, -11.070147510186231],
              [-13.73231837292535, -11.073058591950529],
              [-13.731103518375035, -11.075261319145596],
              [-13.730634991074709, -11.077293596691186],
              [-13.730860762804896, -11.080478228821768],
              [-13.730038822485142, -11.083491173949762],
              [-13.731080621288283, -11.084770657931594],
              [-13.733788489489815, -11.083078333565664],
              [-13.734934969533311, -11.082916246664828],
              [-13.738336408236846, -11.078628544888536],
              [-13.738976688817143, -11.076514551615677],
              [-13.740866926692238, -11.07404369103865],
              [-13.741888380895615, -11.071725923261324],
              [-13.74459479389202, -11.068817736000241],
              [-13.746774408020794, -11.068100623310862],
              [-13.748461707207285, -11.06629357157272],
              [-13.74955526315669, -11.065845693143276],
              [-13.750378224340023, -11.063877804485912],
              [-13.751758461102632, -11.062027150835693],
              [-13.753726021373291, -11.060797959259308],
              [-13.75588460008242, -11.061200300791798],
              [-13.757287503490316, -11.06093278191439],
              [-13.760981301057575, -11.05835898729325],
              [-13.762995294580726, -11.054398005298115],
              [-13.765398559643664, -11.05262067595235],
              [-13.765960234504815, -11.051209403231876],
              [-13.767499953514244, -11.049271882189032],
              [-13.766877854066108, -11.046348621478286],
              [-13.764757773709876, -11.044923619953732],
              [-13.764510843947129, -11.042873567717255],
              [-13.763081590821516, -11.041424384016922],
              [-13.763260809214884, -11.038869021197106],
              [-13.76454021597023, -11.038701359032187],
              [-13.766231417666633, -11.037619588588894],
              [-13.767090478589108, -11.038543247691793],
              [-13.768142369319309, -11.037770141243788],
              [-13.76925157876136, -11.03831665660443],
              [-13.767991038495873, -11.041141966166798],
              [-13.769062056938639, -11.043025922219211],
              [-13.770051896465882, -11.042458854809984],
              [-13.776608091385159, -11.03487889375373],
              [-13.77835425058423, -11.031792181928886],
              [-13.77855162626079, -11.030681927431473],
              [-13.781295392185736, -11.024878600167439],
              [-13.782850365913328, -11.022726189541345],
              [-13.782905661669547, -11.020275108342512],
              [-13.78399140554051, -11.014849125161764],
              [-13.785111479503868, -11.014142456841165],
              [-13.786023091555899, -11.012164805444796],
              [-13.78613527276697, -11.010583495684275],
              [-13.787232818411708, -11.010856594315257],
              [-13.790959700939217, -11.004183722647396],
              [-13.790506197510346, -11.001768239460727],
              [-13.791575014754166, -10.997152291360578],
              [-13.791953635679917, -10.992875155310427],
              [-13.792782922832577, -10.99177257988513],
              [-13.79271879534509, -10.989874872032741],
              [-13.790082369291856, -10.9908117048791],
              [-13.78834295143476, -10.992679787520299],
              [-13.787248399254818, -10.99285496506272],
              [-13.786765345927034, -10.994460945085697],
              [-13.784943748033003, -10.9955447997954],
              [-13.782659708521187, -10.998465036536217],
              [-13.777808636143106, -11.00583910879245],
              [-13.7766611897837, -11.00738866713991],
              [-13.776534324558837, -11.008562390076142],
              [-13.774560836213341, -11.01224928216866],
              [-13.771426344018378, -11.015869037081773],
              [-13.769794096008708, -11.01570878984319],
              [-13.768661596007126, -11.014796087638617],
              [-13.772404195792497, -11.007810738307915],
              [-13.773875519236292, -11.004796187613335],
              [-13.77909332800325, -10.997627956156448],
              [-13.77727541867512, -10.998314870528327],
              [-13.774240936741721, -11.002338312049167],
              [-13.77386247826538, -11.003178381517953],
              [-13.769941667012374, -11.006646313421028],
              [-13.768883105433323, -11.006402993120895],
              [-13.7677703355061, -11.007673491650245],
              [-13.76461984779264, -11.006531950272999],
              [-13.763373958652863, -11.007648714845493],
              [-13.757081072309848, -11.011332392062995],
              [-13.756143208251462, -11.013078350576636],
              [-13.755648302924397, -11.015761911549015],
              [-13.754680424235445, -11.017006093016995],
              [-13.754514839105193, -11.019203246789752],
              [-13.750213828524021, -11.020641726180457],
              [-13.748247136077282, -11.02352655986524],
              [-13.744724853769384, -11.023889549027983],
              [-13.74266447313927, -11.02557916315757],
              [-13.740427609595393, -11.029195264060055],
              [-13.739541059129868, -11.0295653560849],
              [-13.739753856483361, -11.031111896240226],
              [-13.73882935487214, -11.032955076390124],
              [-13.737377392600575, -11.034734355188856],
              [-13.734556868215083, -11.036967713463964],
              [-13.732841722216225, -11.036464846558177],
              [-13.731365962942542, -11.037159742288145]
            ]
          ],
          [
            [
              [-13.873571187644012, -11.042302587827844],
              [-13.872621465534818, -11.042422573401362],
              [-13.87048647955569, -11.044769728708488],
              [-13.87246930352151, -11.045151694164723],
              [-13.872758506864889, -11.043285691210471],
              [-13.873571187644012, -11.042302587827844]
            ]
          ],
          [
            [
              [-13.86692976958852, -11.090436868077699],
              [-13.864921271842297, -11.089918177740582],
              [-13.864464275745444, -11.091563405503173],
              [-13.866525661626312, -11.091199266793035],
              [-13.86692976958852, -11.090436868077699]
            ]
          ],
          [
            [
              [-13.925055395280085, -11.042095870822884],
              [-13.92429382985235, -11.040698505806192],
              [-13.921908285355883, -11.038402738118556],
              [-13.920666465387605, -11.03856037150373],
              [-13.9185780928626, -11.036669525702813],
              [-13.91448893961348, -11.03391101774791],
              [-13.91296874144796, -11.03316541342824],
              [-13.911083099578377, -11.03294010285448],
              [-13.909517879079031, -11.033417791336763],
              [-13.905938620872702, -11.0333375442754],
              [-13.902403359864184, -11.03476843147785],
              [-13.901429490064746, -11.034647095898537],
              [-13.89910538513609, -11.035464689717548],
              [-13.896991830261058, -11.037381395697032],
              [-13.894554256673661, -11.038580185925758],
              [-13.892575536492547, -11.038997849777015],
              [-13.888234330477959, -11.041151977736893],
              [-13.887891651379146, -11.042266980720656],
              [-13.889456394538012, -11.046574768222403],
              [-13.893373646219594, -11.048689420111943],
              [-13.894763044091027, -11.048548427152294],
              [-13.896314491536376, -11.049280915080953],
              [-13.8986340231828, -11.04943642365077],
              [-13.899494645747378, -11.050281984471827],
              [-13.902355232630104, -11.049936014786947],
              [-13.90621456234789, -11.052055078920995],
              [-13.910043900132907, -11.051608716746708],
              [-13.912153464658948, -11.052038479809108],
              [-13.913774512173777, -11.051535350259412],
              [-13.915267406125304, -11.049869422295238],
              [-13.917678324882255, -11.048701665591336],
              [-13.919697609466246, -11.046706949047215],
              [-13.925055395280085, -11.042095870822884]
            ]
          ],
          [
            [
              [-14.055877300099018, -10.707390500271487],
              [-14.054678625591217, -10.707056975160771],
              [-14.055171154165661, -10.705342887242228],
              [-14.049681295552325, -10.70377368304968],
              [-14.048973145015198, -10.706148581746879],
              [-14.04655567849794, -10.70548761380409],
              [-14.045831693776838, -10.707888239848748],
              [-14.043451365523069, -10.707201102599207],
              [-14.042584899508412, -10.70996215459568],
              [-14.044990282498926, -10.708984396208157],
              [-14.048180147124691, -10.707000459334756],
              [-14.051766675117713, -10.708530123864906],
              [-14.054258998624105, -10.708482134619926],
              [-14.055877300099018, -10.707390500271487]
            ]
          ],
          [
            [
              [-13.997717735163619, -10.959522325584832],
              [-13.996809161509445, -10.959178761800757],
              [-13.996287379294385, -10.9610893644657],
              [-13.997522680207124, -10.960817126061187],
              [-13.997717735163619, -10.959522325584832]
            ]
          ],
          [
            [
              [-13.990439430610907, -11.008755216157521],
              [-13.989693334739572, -11.00591018246299],
              [-13.987913172227957, -11.00418147437423],
              [-13.986351372230953, -11.003666813928364],
              [-13.983873961226545, -11.004878043132447],
              [-13.984904502166012, -11.006158562040717],
              [-13.984748866681112, -11.008136768603059],
              [-13.985987902021494, -11.009873889836056],
              [-13.989785753530334, -11.010908794069284],
              [-13.990439430610907, -11.008755216157521]
            ]
          ],
          [
            [
              [-14.015872224150671, -10.939462693743113],
              [-14.014842891886245, -10.938520485733045],
              [-14.014134030981811, -10.939608246469358],
              [-14.01132704163468, -10.941007705127415],
              [-14.01460222372919, -10.941590066924235],
              [-14.015967917025451, -10.940548484206142],
              [-14.015872224150671, -10.939462693743113]
            ]
          ],
          [
            [
              [-14.025396121787523, -10.917704886965623],
              [-14.023672235012251, -10.918602643043096],
              [-14.023256867424088, -10.920076305692884],
              [-14.02452694107831, -10.920156955394926],
              [-14.025396121787523, -10.917704886965623]
            ]
          ],
          [
            [
              [-14.020502901729072, -10.985862135053925],
              [-14.020642582748906, -10.984420246151855],
              [-14.019962949053212, -10.982272230290523],
              [-14.017254134677138, -10.982348121459774],
              [-14.015434406004411, -10.981894683464013],
              [-14.014472884139177, -10.982601948661078],
              [-14.012991690315332, -10.982693009091479],
              [-14.012673000679149, -10.983748939762846],
              [-14.00965096549676, -10.986654412095772],
              [-14.009612584477948, -10.98757282906979],
              [-14.00804591663416, -10.989111355698007],
              [-14.007647037333031, -10.990536764225917],
              [-14.006398198742824, -10.99256057164781],
              [-14.007299395082619, -10.994733883850692],
              [-14.00708368322125, -10.995899219499972],
              [-14.008374651296828, -10.996433123994606],
              [-14.011011330942095, -10.994727359636531],
              [-14.011513256841628, -10.993561632177494],
              [-14.015937947732475, -10.990261798542493],
              [-14.017058284209467, -10.989974924934424],
              [-14.018049235322746, -10.988728983590898],
              [-14.019954162679891, -10.987450515240797],
              [-14.020502901729072, -10.985862135053925]
            ]
          ],
          [
            [
              [-13.99178922066983, -11.091852637860514],
              [-13.990071901331927, -11.089110854823371],
              [-13.989212791904086, -11.088789182991615],
              [-13.988670473982712, -11.086856485692946],
              [-13.987416869801631, -11.08504390728049],
              [-13.986863529941758, -11.082349441891813],
              [-13.98362494266811, -11.08165065347363],
              [-13.98244891377693, -11.082135399965507],
              [-13.980216628746055, -11.08059206261825],
              [-13.978738254544972, -11.078940806768005],
              [-13.978051913331935, -11.07656697420556],
              [-13.975887336815738, -11.074148288076413],
              [-13.974278915994763, -11.073442958334109],
              [-13.972976906839294, -11.075812028205517],
              [-13.973031557110643, -11.076898215087628],
              [-13.971613843610436, -11.079995593313129],
              [-13.971127483174522, -11.082676991357921],
              [-13.969814448114464, -11.087323833855866],
              [-13.96966792036322, -11.088803234999821],
              [-13.971699673889102, -11.088819564520414],
              [-13.973698024614198, -11.089273401348201],
              [-13.974369199341416, -11.09106458961958],
              [-13.976292646175507, -11.092748770635103],
              [-13.975516372492288, -11.094057738688452],
              [-13.975768314241822, -11.094930479322427],
              [-13.978190181015401, -11.096615654154881],
              [-13.979458701854863, -11.097093635500999],
              [-13.982780884138412, -11.097189133985218],
              [-13.984521171385635, -11.095828161363688],
              [-13.985450886756176, -11.096705596562884],
              [-13.987398535878521, -11.095087712677762],
              [-13.988988834065552, -11.094579573656011],
              [-13.991376648119804, -11.092678924325513],
              [-13.99178922066983, -11.091852637860514]
            ]
          ],
          [
            [
              [-14.043121177244869, -10.968714586395567],
              [-14.043129561558642, -10.967082129570803],
              [-14.041868177198468, -10.963915478348442],
              [-14.039663639959965, -10.963807903020612],
              [-14.037780631322352, -10.96590739935644],
              [-14.036862055247424, -10.967913734450402],
              [-14.036733651587738, -10.970133273427829],
              [-14.03496553949943, -10.972618555563606],
              [-14.034943510655834, -10.973497107511466],
              [-14.032735528684693, -10.975953088398015],
              [-14.033033263422455, -10.97744873963821],
              [-14.034313487330914, -10.977351460832361],
              [-14.038705000013387, -10.975084776872942],
              [-14.040291807946355, -10.972284415714734],
              [-14.042483249398526, -10.97084085704503],
              [-14.043121177244869, -10.968714586395567]
            ]
          ],
          [
            [
              [-14.03448840609266, -11.107009769215116],
              [-14.033975901059092, -11.106248561846378],
              [-14.029736159621407, -11.106055926136197],
              [-14.027056106481039, -11.107572512016723],
              [-14.025710336330306, -11.106231403713483],
              [-14.022722370507413, -11.107039053455015],
              [-14.022110373448227, -11.106757660325782],
              [-14.01986254498612, -11.107981432698692],
              [-14.018920903806015, -11.106035075775575],
              [-14.02002564543527, -11.105050736450913],
              [-14.022062524046612, -11.105608969685917],
              [-14.023624940920147, -11.104121833187767],
              [-14.019931786106529, -11.103740024030847],
              [-14.019053589278036, -11.102554377846912],
              [-14.017146167846834, -11.102659792707138],
              [-14.01636335876103, -11.103408356984579],
              [-14.015272549321553, -11.102765418523454],
              [-14.014020535847012, -11.10298883930957],
              [-14.013561838199342, -11.101983315508162],
              [-14.012196620074405, -11.101990105415073],
              [-14.01191594399237, -11.104165757855167],
              [-14.013580999757238, -11.105890451413572],
              [-14.01347917260286, -11.107290699413483],
              [-14.011353735336252, -11.109401061099097],
              [-14.011618065729705, -11.111214471571898],
              [-14.012784478034925, -11.11206312500843],
              [-14.013651706891272, -11.115289206005105],
              [-14.015074760049117, -11.116519367555696],
              [-14.017582601234393, -11.11482207372264],
              [-14.019125431183731, -11.11545778596484],
              [-14.022756362804124, -11.115579107636174],
              [-14.023192082414159, -11.116454869227077],
              [-14.021566298259357, -11.118075921677743],
              [-14.022994104330387, -11.119127276992895],
              [-14.025435013393937, -11.118482904318446],
              [-14.026471451166902, -11.115721830470457],
              [-14.028233379330432, -11.115075237870414],
              [-14.027231739544439, -11.112977032927557],
              [-14.030107871030344, -11.11173451570555],
              [-14.030786152783714, -11.110263748752958],
              [-14.033178924232534, -11.109293922208623],
              [-14.034579905486565, -11.10814972206388],
              [-14.03448840609266, -11.107009769215116]
            ]
          ],
          [
            [
              [-14.02817358370719, -11.131648313244622],
              [-14.028105095368403, -11.130176954497898],
              [-14.026619652299681, -11.12924489190652],
              [-14.026160420133477, -11.127468712798253],
              [-14.024761990391424, -11.129331088619027],
              [-14.022239752253787, -11.128301233765866],
              [-14.02166795444044, -11.128975870609034],
              [-14.022467836532375, -11.130910650408044],
              [-14.024055257244935, -11.13131136157795],
              [-14.026109057454123, -11.130517463685665],
              [-14.02590508611906, -11.132564555358389],
              [-14.02693665892699, -11.13292849538884],
              [-14.02817358370719, -11.131648313244622]
            ]
          ],
          [
            [
              [-14.027257453073066, -11.138649163600489],
              [-14.026089281365415, -11.137712210091125],
              [-14.024577143952277, -11.139411968108181],
              [-14.022352442702655, -11.140900019715092],
              [-14.021754737121523, -11.142486245701821],
              [-14.020430190592482, -11.143095599911929],
              [-14.020559910555981, -11.144428052769445],
              [-14.022454398125566, -11.144708980233057],
              [-14.023324461712916, -11.143284879413283],
              [-14.025038509464451, -11.142577636452394],
              [-14.02572038521216, -11.140275648059148],
              [-14.027257453073066, -11.138649163600489]
            ]
          ],
          [
            [
              [-14.09415366816239, -10.942299538151723],
              [-14.094703886299438, -10.939851616894384],
              [-14.093440040861378, -10.939753186697844],
              [-14.090310684774604, -10.940378138924414],
              [-14.088395434818956, -10.942380647398918],
              [-14.087105059903811, -10.944557271515986],
              [-14.08929968731855, -10.945638891339506],
              [-14.09149360765618, -10.944317045388987],
              [-14.092184841627393, -10.944547245472217],
              [-14.094192528812687, -10.943441015107087],
              [-14.09415366816239, -10.942299538151723]
            ]
          ],
          [
            [
              [-14.099777668430416, -10.944628421067106],
              [-14.095988140258648, -10.94412235720323],
              [-14.093180798677324, -10.945415054301005],
              [-14.091720733391407, -10.94671757904484],
              [-14.091706858461638, -10.947970445020164],
              [-14.093841485841965, -10.947493570022537],
              [-14.095854433835413, -10.946603421280086],
              [-14.099269238679682, -10.9457523655532],
              [-14.099777668430416, -10.944628421067106]
            ]
          ],
          [
            [
              [-13.756542914245454, -11.210469560298865],
              [-13.758037800309179, -11.21245760599117],
              [-13.767185892109797, -11.216823701833698],
              [-13.774725331548701, -11.218578733176162],
              [-13.778612652471587, -11.218638587364303],
              [-13.786492945154468, -11.216730940592443],
              [-13.794140873969418, -11.213635800245406],
              [-13.803066197932042, -11.209902003937307],
              [-13.809840637019057, -11.205512690323507],
              [-13.82031920136453, -11.200962698535012],
              [-13.82882322496542, -11.198414446048613],
              [-13.842013543997743, -11.193991954027931],
              [-13.850620811119288, -11.192067237355797],
              [-13.858138666354085, -11.191264682247096],
              [-13.866569723261463, -11.189082045151993],
              [-13.879992656509144, -11.187053088708193],
              [-13.888726318908569, -11.184709446588107],
              [-13.896462707256067, -11.181461050869313],
              [-13.902743556145147, -11.177335606939767],
              [-13.91560721121055, -11.172548472326623],
              [-13.91866612040459, -11.17215087346415],
              [-13.920113000996267, -11.172381365660629],
              [-13.92354686120926, -11.213018530835061],
              [-13.926653263022176, -11.232270521596268],
              [-13.989768443742603, -11.25166683462617],
              [-13.991299431499213, -11.252132786711977],
              [-13.998305149237288, -11.254262830970692],
              [-13.999529173587273, -11.252322453293514],
              [-14.001031804428523, -11.250691062281886],
              [-14.003641167971317, -11.251676944554118],
              [-14.00618890572549, -11.25048075361241],
              [-14.006621163229356, -11.248249782504983],
              [-14.007288521683675, -11.247569743031839],
              [-14.008500942063892, -11.248229586612467],
              [-14.008874017919956, -11.249613714723239],
              [-14.010842728448244, -11.249188054221074],
              [-14.011021328281172, -11.24779252258522],
              [-14.012411496278183, -11.246311984921178],
              [-14.01376550304239, -11.24554318718307],
              [-14.014089236249532, -11.244366508487236],
              [-14.013025386523427, -11.241425626385182],
              [-14.011670888020904, -11.239376757720528],
              [-14.01142750422137, -11.237690252061924],
              [-14.014594072059399, -11.23771776233254],
              [-14.014707122181857, -11.235067286938078],
              [-14.015468756439253, -11.234705852036903],
              [-14.017035875261687, -11.23548121764586],
              [-14.018973050353042, -11.23516031392432],
              [-14.021406044038864, -11.2354433770667],
              [-14.021759071800556, -11.232496782789235],
              [-14.020542208655641, -11.229203839560821],
              [-14.02089299047456, -11.227180821267686],
              [-14.02226573608769, -11.226418738150635],
              [-14.0228000504577, -11.228292739442798],
              [-14.024144878382529, -11.230538740999528],
              [-14.024873028314925, -11.23453528079113],
              [-14.025772188570894, -11.23558306750112],
              [-14.028154088088002, -11.23380267408504],
              [-14.030480082134408, -11.235721483080306],
              [-14.031188093511332, -11.235052766326728],
              [-14.03174343057214, -11.232858216188603],
              [-14.033422379640571, -11.229475468896009],
              [-14.033786490234807, -11.227479328882312],
              [-14.032372220719449, -11.226566876186784],
              [-14.031502465551139, -11.224583029777314],
              [-14.031676058221644, -11.223616555293614],
              [-14.033195829938322, -11.22181341623285],
              [-14.034989673044487, -11.22183657275581],
              [-14.035660510703446, -11.219720067300399],
              [-14.035796577783367, -11.215147899764466],
              [-14.035066828555461, -11.214236353899489],
              [-14.036444998693522, -11.208376110324505],
              [-14.033932574051828, -11.207825716828786],
              [-14.032968809941687, -11.206111032818686],
              [-14.03236879107274, -11.203818937176974],
              [-14.034746056256084, -11.201706699102031],
              [-14.038893378541637, -11.202845607683818],
              [-14.039136562810404, -11.2012933149392],
              [-14.040545470991635, -11.198723910866681],
              [-14.039340856964543, -11.195152364127832],
              [-14.040178921490718, -11.19425148539265],
              [-14.042065545851875, -11.196162326432583],
              [-14.043088496882984, -11.194502003477128],
              [-14.043154868596172, -11.19326323569538],
              [-14.041085699859945, -11.19226927527686],
              [-14.04233333226747, -11.190287736381261],
              [-14.04162151435501, -11.187991757913101],
              [-14.041824153696835, -11.185511026134657],
              [-14.042688553381304, -11.184595294483008],
              [-14.0434321993115, -11.186607624056835],
              [-14.04462505552824, -11.182998571268906],
              [-14.043742438229138, -11.18240712339474],
              [-14.043980210423182, -11.181124972567805],
              [-14.04241183846055, -11.180218066786523],
              [-14.043808716651771, -11.179264120459763],
              [-14.043555309348488, -11.176709677738385],
              [-14.043749831860492, -11.174923520757606],
              [-14.042196018188298, -11.17090672369387],
              [-14.041304615463854, -11.170267872362327],
              [-14.037917099614507, -11.16921554276104],
              [-14.037056500694016, -11.169704930224567],
              [-14.036319515884575, -11.16619441627253],
              [-14.034512630503228, -11.16641064564687],
              [-14.034431150266856, -11.167531403269221],
              [-14.032227496255535, -11.167127117202211],
              [-14.031784627950602, -11.16642713437023],
              [-14.02994533289473, -11.1671718458602],
              [-14.027404750268277, -11.16181529441926],
              [-14.027375440642633, -11.160687416770152],
              [-14.028600936463892, -11.159041661679433],
              [-14.027120596941634, -11.156678040885241],
              [-14.024982224808117, -11.156288895496033],
              [-14.025139623797067, -11.155390030084622],
              [-14.023034746623834, -11.151516091174527],
              [-14.020649270854797, -11.151284318938549],
              [-14.020154321968176, -11.150122394034293],
              [-14.018789207367492, -11.14964656455275],
              [-14.01814633671627, -11.148691702017725],
              [-14.018777375766021, -11.146822453684443],
              [-14.016614576715325, -11.145462100081243],
              [-14.014589737279808, -11.146712689719855],
              [-14.01304555836518, -11.14688263581968],
              [-14.009792065830167, -11.148633773590268],
              [-14.006340550273828, -11.152236066956942],
              [-14.004956639847096, -11.151417706571799],
              [-14.003165433991574, -11.152798054120344],
              [-14.001295907769533, -11.153642024298044],
              [-14.000428075535641, -11.153252404742748],
              [-13.999176858472246, -11.15423965346202],
              [-13.997638584577006, -11.15723516696762],
              [-13.9966107853273, -11.157744423352238],
              [-13.995631860602261, -11.156203487339809],
              [-13.996442447388617, -11.154761910064211],
              [-13.998045253726461, -11.153084634688325],
              [-13.999444847831265, -11.150994255127308],
              [-14.003942055182115, -11.148210790774378],
              [-14.004704364486205, -11.145144602380801],
              [-14.002788952901717, -11.142571096752544],
              [-14.00604646078771, -11.140891040332543],
              [-14.008304384713725, -11.14174183755752],
              [-14.010310888112622, -11.140151688078356],
              [-14.01093046729783, -11.139064169965122],
              [-14.010795259701293, -11.137103164920223],
              [-14.012498165066996, -11.136439584473026],
              [-14.013453572074017, -11.134734493927292],
              [-14.016005030515238, -11.133439079078391],
              [-14.017320829604857, -11.131554135373804],
              [-14.01888509827547, -11.130406303299536],
              [-14.017926329242217, -11.128718964381164],
              [-14.019681817079514, -11.12753328501799],
              [-14.021437485856444, -11.125610248900212],
              [-14.021958234979579, -11.12413978622495],
              [-14.0212680467645, -11.120670524593232],
              [-14.01908769288338, -11.120535161911121],
              [-14.016903022437795, -11.120822820671986],
              [-14.015901708795198, -11.122879605306608],
              [-14.01472815073692, -11.123437353216817],
              [-14.012613587894279, -11.122491575170324],
              [-14.012940035199618, -11.120992020730702],
              [-14.011453382657749, -11.119744370972418],
              [-14.010695095778177, -11.117507401035361],
              [-14.008301353711952, -11.116999622597229],
              [-14.006273135016238, -11.119160297216824],
              [-14.005368916465777, -11.12151135386783],
              [-14.005105375042941, -11.124006773739602],
              [-14.003118132449531, -11.125482126736243],
              [-14.001724894419187, -11.12531952429062],
              [-14.000991545388398, -11.126399102744541],
              [-13.999414990762286, -11.126888536667845],
              [-13.998422049211799, -11.128235103111674],
              [-13.996409650025164, -11.133420531766395],
              [-13.994478260572498, -11.13560943765258],
              [-13.994046052512669, -11.136910869144048],
              [-13.991604607464078, -11.135789049007244],
              [-13.989387394882133, -11.136372741347527],
              [-13.987428580526531, -11.13546712756679],
              [-13.9864843138574, -11.13272332922822],
              [-13.98784196723323, -11.131925040284637],
              [-13.989367935621063, -11.130119568624256],
              [-13.990136088572735, -11.127617563295928],
              [-13.989995767715467, -11.126012856367467],
              [-13.98900806186242, -11.123307220330577],
              [-13.987351432043468, -11.12169671994328],
              [-13.98744570939527, -11.1200661044191],
              [-13.986796030929927, -11.118503715397742],
              [-13.985736588906034, -11.117574508378125],
              [-13.985489640470579, -11.115265240495162],
              [-13.984000282928617, -11.114012345114082],
              [-13.984862748029395, -11.112618439465413],
              [-13.986309898412317, -11.111798059973486],
              [-13.984026511248558, -11.110136780502584],
              [-13.982838002326774, -11.109721029752754],
              [-13.979008621805818, -11.10987117015738],
              [-13.975613942161841, -11.109594751825666],
              [-13.975031402266135, -11.109973680320879],
              [-13.972462332995224, -11.109120273228326],
              [-13.970008270363145, -11.109707005068717],
              [-13.967306901305513, -11.107876669748757],
              [-13.965152449047848, -11.106999810939614],
              [-13.964576460084782, -11.108476981997429],
              [-13.963242694243803, -11.109747961554731],
              [-13.962214574065719, -11.109535361543424],
              [-13.960083946326662, -11.110656390141704],
              [-13.958745305595555, -11.112262182216366],
              [-13.959740655286168, -11.113473620282106],
              [-13.958932360741265, -11.114888141812585],
              [-13.957208591153734, -11.115448992023413],
              [-13.954381673990502, -11.114857497016034],
              [-13.954165150794879, -11.114260653314895],
              [-13.951884153641886, -11.112384157844193],
              [-13.951643232532945, -11.110033999484372],
              [-13.95205747687581, -11.108892977094861],
              [-13.952014725272209, -11.106485269540219],
              [-13.950016050307628, -11.104819766678844],
              [-13.950229339722714, -11.103669227029252],
              [-13.948712168388017, -11.102784435263361],
              [-13.947987520956845, -11.101265340522408],
              [-13.948639422781987, -11.100167868559582],
              [-13.946948840024348, -11.09798152920532],
              [-13.947034929989996, -11.0964834515988],
              [-13.944948339338083, -11.09409937453685],
              [-13.945022358387892, -11.092485908420258],
              [-13.942893005894796, -11.09033587921083],
              [-13.941180916591668, -11.090380965764869],
              [-13.938143359062309, -11.088003025328158],
              [-13.935732527595103, -11.082798754357553],
              [-13.933968361113664, -11.08128411888454],
              [-13.9334285966796, -11.080240852132981],
              [-13.933996184003975, -11.077780350508943],
              [-13.933152962073423, -11.075423705353817],
              [-13.931707250554021, -11.074779467049673],
              [-13.928713709182801, -11.072187572403429],
              [-13.92620626360712, -11.07200980158048],
              [-13.92522205931009, -11.07252049619358],
              [-13.923769906004376, -11.075452031844952],
              [-13.92169882019377, -11.0780119916299],
              [-13.919257325404494, -11.077045911965271],
              [-13.918242653482903, -11.079316669478228],
              [-13.916995859529157, -11.081053119394703],
              [-13.915525211135396, -11.081832546279276],
              [-13.914788232467062, -11.08345150815112],
              [-13.912957580633128, -11.085085185826607],
              [-13.911798116977707, -11.085361218316034],
              [-13.909975735495593, -11.084572316028662],
              [-13.908545335643959, -11.084892546764285],
              [-13.907503016524736, -11.086149178634555],
              [-13.90271814300191, -11.086456784841426],
              [-13.901956761826126, -11.087208551687437],
              [-13.899629461450017, -11.086739422241513],
              [-13.896037804283027, -11.083537763360033],
              [-13.893908603467072, -11.085447686548436],
              [-13.892576162926064, -11.085898866499909],
              [-13.89108146339177, -11.088396801314166],
              [-13.889991893269434, -11.088945219362206],
              [-13.886452597258197, -11.089011917200477],
              [-13.886023263071085, -11.089475265259363],
              [-13.883101642591036, -11.089915856886714],
              [-13.882546918463717, -11.088930883589734],
              [-13.884820367944965, -11.087592006240227],
              [-13.884614026445133, -11.086188891584857],
              [-13.881974495382648, -11.087694433906028],
              [-13.881454203721969, -11.088939377386527],
              [-13.880349017996815, -11.089146704653624],
              [-13.879377860745013, -11.090692247659003],
              [-13.877137162832158, -11.09120985254022],
              [-13.875138468397452, -11.09237849763097],
              [-13.874383150026038, -11.093491266648337],
              [-13.872992222956128, -11.093662888331021],
              [-13.871456342854236, -11.092222593585564],
              [-13.868404662267377, -11.09372450108264],
              [-13.867266438013722, -11.095134201191703],
              [-13.864202794392629, -11.096048295819314],
              [-13.865322311495119, -11.098294298048692],
              [-13.864415837712135, -11.099297688584544],
              [-13.865447651171237, -11.10044107519191],
              [-13.86541759214854, -11.102184815627975],
              [-13.866865137882913, -11.1031525242318],
              [-13.867160639895626, -11.104560681454336],
              [-13.865745719702174, -11.107310242032433],
              [-13.864059388375066, -11.112007600787486],
              [-13.863830013280209, -11.114281793662387],
              [-13.865854564806812, -11.119302101216226],
              [-13.864957624476935, -11.12136767221366],
              [-13.86687537106976, -11.12417667453553],
              [-13.868584098244906, -11.126139692529938],
              [-13.868781157051647, -11.128287289850515],
              [-13.871108650963333, -11.129927946604202],
              [-13.871101990562877, -11.130893810232388],
              [-13.872342349587592, -11.13290546098712],
              [-13.871585328716483, -11.134337257381674],
              [-13.873115966590111, -11.135349581058284],
              [-13.87454683630123, -11.138990163654634],
              [-13.873301352795323, -11.140376776012168],
              [-13.875511633604189, -11.14196075560137],
              [-13.875430116866207, -11.142951371591833],
              [-13.879308095063674, -11.142950589027066],
              [-13.880170631280276, -11.143280451605648],
              [-13.883623027268339, -11.142934771242723],
              [-13.884232381123354, -11.143509360425826],
              [-13.882825824241516, -11.145932684242094],
              [-13.881107509476161, -11.147143716036107],
              [-13.877008499682157, -11.148773772004462],
              [-13.878601650306939, -11.149262191078835],
              [-13.88274013921227, -11.148363251722389],
              [-13.883955077029919, -11.147552384822317],
              [-13.88638404156104, -11.148542207294678],
              [-13.882989967261842, -11.15145041033102],
              [-13.881157734911156, -11.150603742833404],
              [-13.88028645801139, -11.151645308958582],
              [-13.879218122705819, -11.151393382108346],
              [-13.87757420892989, -11.152580820441107],
              [-13.87609211701894, -11.151312029225904],
              [-13.87300185170999, -11.151893664378088],
              [-13.871909274876586, -11.153302156164658],
              [-13.873276784763807, -11.154967742864526],
              [-13.873225796201133, -11.1566437936074],
              [-13.872386618072301, -11.157649949581428],
              [-13.872713170112076, -11.159995334275633],
              [-13.87089539547855, -11.163909235997632],
              [-13.869493675482003, -11.16306771095493],
              [-13.868007443813147, -11.162991896948824],
              [-13.866361096040873, -11.161811060553541],
              [-13.864210624229585, -11.16103063739936],
              [-13.86361674217738, -11.158744648444962],
              [-13.864103395352469, -11.157775447540848],
              [-13.86287829005141, -11.156328247672926],
              [-13.862737617592888, -11.15453026943614],
              [-13.861787063101856, -11.153791228529899],
              [-13.861996433184746, -11.152519299147533],
              [-13.861316061251896, -11.15030026275357],
              [-13.862090127907337, -11.148893570192522],
              [-13.862618292572074, -11.1455027276935],
              [-13.862338769645387, -11.144342927332485],
              [-13.863662528829229, -11.14167159658566],
              [-13.863226013505393, -11.140896232988098],
              [-13.861352871964359, -11.141138001333532],
              [-13.861271578077275, -11.138434569436876],
              [-13.862069104008066, -11.13726118487538],
              [-13.862195964454987, -11.13439170274426],
              [-13.86062625815246, -11.13602410151179],
              [-13.860059237168414, -11.133973561377092],
              [-13.857140830073071, -11.132322403842155],
              [-13.85742807757821, -11.128282255092262],
              [-13.853897280524423, -11.126390623258628],
              [-13.855555546265613, -11.125865854524427],
              [-13.856394553770352, -11.123534895551657],
              [-13.854645059553123, -11.12320136439043],
              [-13.851140672819113, -11.123567593627685],
              [-13.850457113940381, -11.120989175063645],
              [-13.852875613819716, -11.121061358172788],
              [-13.853682772469762, -11.119779962342822],
              [-13.85343793984794, -11.11890096295024],
              [-13.851759094245283, -11.118249111924781],
              [-13.849462299934036, -11.116747926411595],
              [-13.849313856182246, -11.116008380625209],
              [-13.851380628285316, -11.114317487773434],
              [-13.850414499268705, -11.113100583346617],
              [-13.85331843581092, -11.111038024533658],
              [-13.85419690774241, -11.108653913241355],
              [-13.855234562871452, -11.107596437500723],
              [-13.854193266584288, -11.106561744493067],
              [-13.851120965323615, -11.105697097914105],
              [-13.849327867934727, -11.10474223765174],
              [-13.848049834448723, -11.102650433440004],
              [-13.848107546346665, -11.101520018170422],
              [-13.84591820798523, -11.100520428311206],
              [-13.8429448519619, -11.101030522277279],
              [-13.841361100622548, -11.102314789146632],
              [-13.839342281909827, -11.103138982075148],
              [-13.838179160339996, -11.10283278641292],
              [-13.835851180863232, -11.103389113886097],
              [-13.833953297126088, -11.104651981467423],
              [-13.832317559874367, -11.104324075088515],
              [-13.831297329462235, -11.104898211110449],
              [-13.831092965589914, -11.107713171999778],
              [-13.831700548160375, -11.10851555773319],
              [-13.83108134627157, -11.109690914307901],
              [-13.828726394832572, -11.11048720945669],
              [-13.828154311162287, -11.108479151865035],
              [-13.826482555949845, -11.10865786533148],
              [-13.825191150251959, -11.109868028089954],
              [-13.823299235785365, -11.11063733713159],
              [-13.822568802616722, -11.112186892548973],
              [-13.820812354271416, -11.112882153003069],
              [-13.818818067987863, -11.111211858500447],
              [-13.818061517146111, -11.109600274803046],
              [-13.813090653194305, -11.10881723821763],
              [-13.810140077255735, -11.10914851287276],
              [-13.808869007155844, -11.107659873509906],
              [-13.806456380012134, -11.108639403423041],
              [-13.80187482411361, -11.108616165289757],
              [-13.799599638611857, -11.108281876862215],
              [-13.799250194806168, -11.106536460921864],
              [-13.797368636360245, -11.105953188546156],
              [-13.795297156856481, -11.10623964219022],
              [-13.793054400970313, -11.106025995632445],
              [-13.791319032805694, -11.105258230748095],
              [-13.789271850087282, -11.103544029904404],
              [-13.786586195311768, -11.104892994293607],
              [-13.783096668349573, -11.105334397850783],
              [-13.782272032576056, -11.105954684738402],
              [-13.781425601482425, -11.107719146623834],
              [-13.781675072289644, -11.109257151636339],
              [-13.786273819112965, -11.109314289835545],
              [-13.786329614657964, -11.112578753343687],
              [-13.784714600988332, -11.113243505772742],
              [-13.782429806218595, -11.111324275380301],
              [-13.780819947090908, -11.110974583113014],
              [-13.778664146606932, -11.112070147450313],
              [-13.778015494758657, -11.111409831192582],
              [-13.77443035051376, -11.1107844627021],
              [-13.77340662349923, -11.11130254442214],
              [-13.771413946472062, -11.110931857742992],
              [-13.770854987867734, -11.11004844064516],
              [-13.769120808247427, -11.11011265405936],
              [-13.768395820347363, -11.111235698526606],
              [-13.765243701865593, -11.110687624103988],
              [-13.762618819142691, -11.11112698227716],
              [-13.760179211836864, -11.11048962810129],
              [-13.759603051343328, -11.111113509905428],
              [-13.757755789902756, -11.110941021557789],
              [-13.756407219607912, -11.11215483971155],
              [-13.755051739462782, -11.112090153980795],
              [-13.752668679928961, -11.114846042417337],
              [-13.751913613733793, -11.11518912376152],
              [-13.749108936051202, -11.118972246501297],
              [-13.74926271904919, -11.120480046644703],
              [-13.748556646364694, -11.121003518750827],
              [-13.747008836684582, -11.124267733368352],
              [-13.744516753423856, -11.127091856021096],
              [-13.74205433593039, -11.130700151837786],
              [-13.742387793625506, -11.131724955915155],
              [-13.744370442742314, -11.133136854471209],
              [-13.745439172161992, -11.133242850504597],
              [-13.745668846280795, -11.134690245284748],
              [-13.7449261373981, -11.13517687128095],
              [-13.744897580897508, -11.137024943429292],
              [-13.744293875071302, -11.137506572666025],
              [-13.744158184671145, -11.139482681878425],
              [-13.742845641714668, -11.140642420327362],
              [-13.740799090071446, -11.14027561574531],
              [-13.740095285713375, -11.141317465214197],
              [-13.739021179844771, -11.145265144168855],
              [-13.739287153802927, -11.146135210978867],
              [-13.73831318339267, -11.148912325319975],
              [-13.73880086749455, -11.150572388141983],
              [-13.740807711962702, -11.151153735209295],
              [-13.740644118463385, -11.152919427603182],
              [-13.742156812048577, -11.152700225125827],
              [-13.743793453429172, -11.154896224129619],
              [-13.7427534878639, -11.156522455474418],
              [-13.743819450669918, -11.15832691537425],
              [-13.745937210357175, -11.160684975931067],
              [-13.747242658052222, -11.161311571584058],
              [-13.748558241431521, -11.16404958591313],
              [-13.747268033272933, -11.165899617559955],
              [-13.744642093080166, -11.167933920476518],
              [-13.73432574073722, -11.17301552462745],
              [-13.735148640242407, -11.173523775721668],
              [-13.737218280612815, -11.172516408273063],
              [-13.739316002682694, -11.172289521465194],
              [-13.742150254480494, -11.170876499602008],
              [-13.746900970391987, -11.167137674911816],
              [-13.750978517868953, -11.164489754431038],
              [-13.75186819820808, -11.164505448170809],
              [-13.754696749535308, -11.162577694197894],
              [-13.755354470117592, -11.162529938577558],
              [-13.75656892035099, -11.164328683692105],
              [-13.760015089561932, -11.163069508186423],
              [-13.763348901810359, -11.162406756317841],
              [-13.765409431955309, -11.161308627074574],
              [-13.768191886419105, -11.161292369170912],
              [-13.771712843222378, -11.160875552078512],
              [-13.7730459606156, -11.160329208132746],
              [-13.775985486702753, -11.159858395316693],
              [-13.776742899543498, -11.16016573557605],
              [-13.779891480609562, -11.158757710887484],
              [-13.782742908481788, -11.156879926887989],
              [-13.78469681059383, -11.156940588231736],
              [-13.788527091714384, -11.155930528575562],
              [-13.789467931889222, -11.156855134166623],
              [-13.78936394820908, -11.159834756774258],
              [-13.788247588884866, -11.159810642250887],
              [-13.786707440105541, -11.1607511771179],
              [-13.785290580604276, -11.16220278510996],
              [-13.78127382715307, -11.16313758518652],
              [-13.781982158096612, -11.163996891723432],
              [-13.780938948090368, -11.165577968792906],
              [-13.779048429759305, -11.167460879973605],
              [-13.777425070984952, -11.167517370355881],
              [-13.776568735337916, -11.169084651151522],
              [-13.771895701705361, -11.171825610989803],
              [-13.767954766414965, -11.172486647788483],
              [-13.765782371134506, -11.1720675830969],
              [-13.762366226608155, -11.17219765320114],
              [-13.761465013249504, -11.171598555613057],
              [-13.759314197608317, -11.17256790488959],
              [-13.758729617044034, -11.17360163604279],
              [-13.756293831191691, -11.175214675379616],
              [-13.753335171979671, -11.17449914592962],
              [-13.75204945013884, -11.175875987823382],
              [-13.750197225831759, -11.178837404064778],
              [-13.750015453689029, -11.180827878799859],
              [-13.748708178464891, -11.181813263119691],
              [-13.746788095793004, -11.180465195742974],
              [-13.744789676671479, -11.180070423434206],
              [-13.74331620652057, -11.180303527577122],
              [-13.741642655477087, -11.181432820541053],
              [-13.741781785368397, -11.182426732019943],
              [-13.74382031953144, -11.182152189030798],
              [-13.744771519317649, -11.182971455782605],
              [-13.744603508242122, -11.184376635178745],
              [-13.74323483651212, -11.18502629391991],
              [-13.74009553087322, -11.184210937995342],
              [-13.738401524942478, -11.184562301914957],
              [-13.736911422164757, -11.185767545054464],
              [-13.733360144190852, -11.186626449802652],
              [-13.732428154108684, -11.189879679914396],
              [-13.733506630508794, -11.191351120468752],
              [-13.736356653919648, -11.191833844643279],
              [-13.73787942766771, -11.19359205278181],
              [-13.73846268848642, -11.195487949124457],
              [-13.739347374947576, -11.196379616634859],
              [-13.73967553524142, -11.197974874908198],
              [-13.74040482585901, -11.198617337648008],
              [-13.74122842970455, -11.201560411573077],
              [-13.742206434985748, -11.202296957903847],
              [-13.744031013842237, -11.20182209944655],
              [-13.747576141750192, -11.203683993610294],
              [-13.748261328436753, -11.202471321316926],
              [-13.749291838901355, -11.203495343783185],
              [-13.749552652674758, -11.205707299512223],
              [-13.751124810536252, -11.205613777789747],
              [-13.752547469285444, -11.204090140816252],
              [-13.755039435549767, -11.203305381382938],
              [-13.757432423977049, -11.205014803444874],
              [-13.7587372836853, -11.207207299649053],
              [-13.756542914245454, -11.210469560298865]
            ]
          ],
          [
            [
              [-14.121661006317362, -10.908678103801279],
              [-14.121567308555685, -10.907075027140266],
              [-14.120208282740611, -10.905883399249852],
              [-14.11816563672815, -10.906703473273],
              [-14.11631135068143, -10.910073333343954],
              [-14.116195110952425, -10.91228003028162],
              [-14.118660235741807, -10.911702584374096],
              [-14.121451979373763, -10.909280755491693],
              [-14.121661006317362, -10.908678103801279]
            ]
          ],
          [
            [
              [-14.175780419743996, -10.905919404002532],
              [-14.175804506236325, -10.905007153768329],
              [-14.174501386677981, -10.901957627489864],
              [-14.172674208175868, -10.901352336608635],
              [-14.16931768861565, -10.901662008447365],
              [-14.16670241390649, -10.902338394762907],
              [-14.166686038714705, -10.904040224964874],
              [-14.165941833943165, -10.907128667187182],
              [-14.16355944266076, -10.908085021651646],
              [-14.162395366381677, -10.909445488034121],
              [-14.161099073603157, -10.909983694464426],
              [-14.159727638500721, -10.911290748814547],
              [-14.15955866548141, -10.913392504134862],
              [-14.161078759723459, -10.913832020265344],
              [-14.164075119368396, -10.912903479148373],
              [-14.165730353911984, -10.913333658840166],
              [-14.16896547321154, -10.91167845913298],
              [-14.16986407563385, -10.91064211754104],
              [-14.174067882930519, -10.908669407316411],
              [-14.175780419743996, -10.905919404002532]
            ]
          ],
          [
            [
              [-14.353313236941657, -10.996601967292246],
              [-14.28841106460954, -10.944939215670875],
              [-14.288427602427051, -10.945742286546261],
              [-14.274860653968132, -10.941407150070196],
              [-14.251125547149186, -10.90239118325455],
              [-14.228120070219203, -10.877198330304775],
              [-14.202502406091378, -10.848956100795512],
              [-14.193654592939875, -10.839155363148627],
              [-14.188998571844873, -10.830840046963818],
              [-14.147246683621594, -10.8175837775844],
              [-14.139814265909726, -10.781893171580997],
              [-14.137140985488696, -10.782189023322887],
              [-14.135969961072487, -10.781127486469332],
              [-14.135181311656945, -10.778887616268428],
              [-14.133046075178727, -10.778817399229872],
              [-14.131316763787893, -10.781823443716904],
              [-14.127495158612394, -10.783306971123274],
              [-14.124520310743469, -10.783321193780338],
              [-14.122283422465527, -10.78202727872626],
              [-14.122126017510142, -10.780628697880724],
              [-14.121112858038707, -10.779839186632929],
              [-14.120163710301894, -10.78025203736098],
              [-14.117588525362628, -10.78015331234347],
              [-14.117255730426894, -10.782365574026628],
              [-14.117451942911856, -10.783727496741786],
              [-14.115697561390244, -10.784886256646182],
              [-14.113518183217943, -10.78493276092154],
              [-14.11023820650634, -10.784453662966818],
              [-14.106567861076499, -10.782615351572357],
              [-14.101362613187685, -10.783732600795904],
              [-14.097825066995131, -10.782202060678275],
              [-14.094262852998028, -10.784693271662254],
              [-14.091969231469553, -10.78561263800252],
              [-14.08939387376679, -10.784943681060565],
              [-14.086078101645676, -10.781926277876652],
              [-14.084448246251025, -10.781664246227773],
              [-14.082953849801587, -10.785395122366383],
              [-14.080824966021416, -10.786202936703708],
              [-14.07949820560437, -10.786148971279266],
              [-14.078059017475287, -10.787506045307373],
              [-14.077547370983655, -10.790939042635069],
              [-14.074867097727852, -10.790806488821634],
              [-14.073332057222455, -10.790201364360893],
              [-14.07217163548917, -10.789114045389466],
              [-14.072255625823248, -10.786906518236776],
              [-14.071491273777504, -10.78589156122259],
              [-14.071898476678589, -10.782170042679198],
              [-14.070590694864864, -10.780538989012758],
              [-14.070305803065851, -10.77884401931103],
              [-14.069218345380156, -10.779261391585614],
              [-14.067753709640565, -10.780748750214542],
              [-14.068075604317535, -10.781854597834773],
              [-14.067337780626334, -10.783214839233056],
              [-14.064748759954723, -10.783170617247201],
              [-14.063274956581719, -10.7818840898432],
              [-14.061072473236159, -10.782528762322967],
              [-14.060077663328164, -10.782048715591545],
              [-14.05935013307323, -10.783040585550182],
              [-14.059552333863246, -10.784427542597605],
              [-14.058408598549322, -10.786671762496823],
              [-14.058066893522351, -10.788630034119011],
              [-14.056933431110547, -10.788902367219439],
              [-14.055450133737052, -10.788313827866501],
              [-14.053814429635525, -10.788604883670407],
              [-14.051566922191546, -10.787173405521697],
              [-14.050895782723115, -10.78390848786532],
              [-14.047955909413206, -10.784988498421537],
              [-14.047508052393075, -10.783917137914356],
              [-14.043175039947208, -10.784329046701938],
              [-14.040544585616784, -10.783677498757042],
              [-14.037113943087258, -10.782310297428772],
              [-14.03196710035607, -10.781678001297486],
              [-14.03092609461852, -10.781216301269495],
              [-14.029506592137349, -10.782395430861138],
              [-14.028915435957492, -10.783556951629931],
              [-14.026897207872175, -10.78395691680173],
              [-14.026500600528781, -10.784890586179422],
              [-14.026803747997883, -10.787003689829154],
              [-14.024094805107733, -10.786651337762775],
              [-14.022823012095877, -10.787250348515494],
              [-14.020299249049772, -10.78735125488329],
              [-14.018437597983496, -10.788004635243267],
              [-14.01627559652269, -10.790607337082397],
              [-14.01416534198095, -10.79131538221541],
              [-14.012402222650076, -10.791299975930063],
              [-14.010245799365048, -10.788806220131065],
              [-14.009333680793308, -10.788471133723991],
              [-14.006100994472282, -10.788518587483876],
              [-14.003645736685204, -10.78907325628312],
              [-14.002959214567914, -10.790037927386601],
              [-14.000860001065648, -10.790577054672966],
              [-14.000391472505841, -10.791691995768463],
              [-13.995412336147327, -10.794263685744944],
              [-13.990427358205588, -10.795574112424296],
              [-13.990205936462898, -10.797210034353999],
              [-13.991063201801042, -10.798013101056993],
              [-13.99052344673998, -10.799323266045],
              [-13.990971289264262, -10.802506216941653],
              [-13.989843438782806, -10.804013136638403],
              [-13.990774160628545, -10.804655727955572],
              [-13.990765352877549, -10.806002386536877],
              [-13.989899105567424, -10.807336321371567],
              [-13.99023296476501, -10.80912792082667],
              [-13.98874571105477, -10.810980779243653],
              [-13.984766866463383, -10.817279162589553],
              [-13.982119289400904, -10.820297334147044],
              [-13.980750016734556, -10.822966248691055],
              [-13.98069718051834, -10.824017830946202],
              [-13.977998679652714, -10.823602030910012],
              [-13.976009254549309, -10.824220862541758],
              [-13.975088068399579, -10.825693211865875],
              [-13.972564207177339, -10.826111992182677],
              [-13.9724246953966, -10.827397388038397],
              [-13.970039727617623, -10.827816436161694],
              [-13.967850255437495, -10.830734566738855],
              [-13.965530404995361, -10.831675696119094],
              [-13.964101327305524, -10.831370997114437],
              [-13.960810903888163, -10.832384822276511],
              [-13.959275981588199, -10.831397588897412],
              [-13.958189550582729, -10.831759649662285],
              [-13.958180786809123, -10.832956608348521],
              [-13.957391369123366, -10.8357703214399],
              [-13.955725881489107, -10.836614968010222],
              [-13.953086706983653, -10.8368007203568],
              [-13.951852337296785, -10.839207574257959],
              [-13.951761362915908, -10.841376610025078],
              [-13.950902698099146, -10.843854836604615],
              [-13.951742928193442, -10.84592707061619],
              [-13.95468391651169, -10.847815182085851],
              [-13.953416878988358, -10.849960862300568],
              [-13.955168474401841, -10.85060049126151],
              [-13.956323211029895, -10.85230611466263],
              [-13.954316931002195, -10.854934018660702],
              [-13.954634693086955, -10.856656219548201],
              [-13.954021130687169, -10.858520363064756],
              [-13.95319634722986, -10.858416289928202],
              [-13.951350123603266, -10.859389199683442],
              [-13.949385457403931, -10.859464488654256],
              [-13.948158086729691, -10.857868162507136],
              [-13.94634466908309, -10.856949384622284],
              [-13.945006798716522, -10.856780374791654],
              [-13.941708554675124, -10.859325402860012],
              [-13.939715374062981, -10.860033313271572],
              [-13.937671447417163, -10.864598036410124],
              [-13.938617552966367, -10.865856555979391],
              [-13.941114404234414, -10.865250588162708],
              [-13.941920094843896, -10.865430338168297],
              [-13.943599757857392, -10.867033229504203],
              [-13.945368643011914, -10.87128836928151],
              [-13.948640633808468, -10.872214565027434],
              [-13.949563035654297, -10.873154177079227],
              [-13.949864626241588, -10.874523513140216],
              [-13.95134200891808, -10.876298321436312],
              [-13.952873695163772, -10.875799385088026],
              [-13.955364652985526, -10.875838316016672],
              [-13.957483132662977, -10.87792190739366],
              [-13.958528308184883, -10.87824294731066],
              [-13.961558333448396, -10.878289643138105],
              [-13.96251328808579, -10.879548037203868],
              [-13.960967206915027, -10.881259673810243],
              [-13.960027164344627, -10.883716848535206],
              [-13.962098931387308, -10.88522890664123],
              [-13.963749064907477, -10.887368901539048],
              [-13.96404921352402, -10.888910935040252],
              [-13.964898033617525, -10.890195874152852],
              [-13.963917016644494, -10.891940329921262],
              [-13.96353226922198, -10.894101091688755],
              [-13.962575605503911, -10.896133954173706],
              [-13.962378352071015, -10.899298187732755],
              [-13.963544736349656, -10.902119843177173],
              [-13.96489174171479, -10.903251847294515],
              [-13.96341655887325, -10.906873227056552],
              [-13.963312388176304, -10.909718525894132],
              [-13.961849977030763, -10.910466325053521],
              [-13.964176851010345, -10.912397062462349],
              [-13.96430760444883, -10.91334085962005],
              [-13.965588657786652, -10.914673303607328],
              [-13.965115892951127, -10.915631283973545],
              [-13.964933531117035, -10.91819985839639],
              [-13.962878115706383, -10.921174328344632],
              [-13.961756952678384, -10.921943056839673],
              [-13.961495938172332, -10.92479330586634],
              [-13.958703240162393, -10.923854918205418],
              [-13.95604964596705, -10.919080744247921],
              [-13.954226119008256, -10.9184369971154],
              [-13.952489161471558, -10.921257712197098],
              [-13.951194061415642, -10.922447207743515],
              [-13.948532847349519, -10.923828190682984],
              [-13.947550052461335, -10.925179886888312],
              [-13.94587539041499, -10.925718733808196],
              [-13.94614575524786, -10.924137050074785],
              [-13.945493141221956, -10.92267558955203],
              [-13.943934593116822, -10.921266831980791],
              [-13.941652386600836, -10.92062072237813],
              [-13.941288061677197, -10.922072736531119],
              [-13.940274590201854, -10.923205833886449],
              [-13.938281715330765, -10.923311241657446],
              [-13.936567803735873, -10.924436274973523],
              [-13.936413073891584, -10.923151318137132],
              [-13.934460794058548, -10.923778683334397],
              [-13.933399252817695, -10.923265364331208],
              [-13.933097815792888, -10.92170731402474],
              [-13.931039320767743, -10.922583772408803],
              [-13.92987929283805, -10.924873206997294],
              [-13.928147488420562, -10.925324033116803],
              [-13.927086345203058, -10.92411969374845],
              [-13.924817104512456, -10.923936320412793],
              [-13.922870914601097, -10.926354580207336],
              [-13.921973993138593, -10.926741957867204],
              [-13.922062990203287, -10.928300195240947],
              [-13.92068983422936, -10.930248430824804],
              [-13.921775586418555, -10.931508904296862],
              [-13.92084356585019, -10.93314792308303],
              [-13.919642806812409, -10.933863234167056],
              [-13.918837385193461, -10.935374503224306],
              [-13.917170718759088, -10.93677272947013],
              [-13.91521537773502, -10.93511920754405],
              [-13.913222331773433, -10.935304779954894],
              [-13.91256004057032, -10.936710799075637],
              [-13.911273459680343, -10.937313924774065],
              [-13.909984126550013, -10.934936918301549],
              [-13.90762292175017, -10.936560440061283],
              [-13.90720599390068, -10.937564762598319],
              [-13.905155577130705, -10.938441108922497],
              [-13.90424993813168, -10.939634311214181],
              [-13.901480821452802, -10.94023803568775],
              [-13.898899176457157, -10.939010777549717],
              [-13.897913518418092, -10.939733820006659],
              [-13.895928724861903, -10.939983499583162],
              [-13.894310552768323, -10.942032523156959],
              [-13.891830697041433, -10.942709926019978],
              [-13.891241809823013, -10.944139813682447],
              [-13.888512170586761, -10.947837062151324],
              [-13.888519135695507, -10.950174237194453],
              [-13.890581865599714, -10.953001184944142],
              [-13.890391086624804, -10.954508552808068],
              [-13.887879061225966, -10.956118473403402],
              [-13.886458215990476, -10.955637266587622],
              [-13.885437618653281, -10.95665772743202],
              [-13.883003332422557, -10.95747951576082],
              [-13.87919360161863, -10.96208348784696],
              [-13.87779036537034, -10.963164327284302],
              [-13.877858105338085, -10.964662071272647],
              [-13.879005261073614, -10.967544618904517],
              [-13.876562349215877, -10.969209718160144],
              [-13.875144762632843, -10.969097741674801],
              [-13.872559725018613, -10.970086964510028],
              [-13.871074163965302, -10.970189611447962],
              [-13.869676898196294, -10.971162163386207],
              [-13.868926012342314, -10.972679213066185],
              [-13.866186009067427, -10.97468462222886],
              [-13.865057810336022, -10.976825859464302],
              [-13.866330691611722, -10.978888449216768],
              [-13.866534336470504, -10.980430970893831],
              [-13.867957435597372, -10.981668507704727],
              [-13.870571323136016, -10.983191984781737],
              [-13.873404870446784, -10.982789760066352],
              [-13.874672876935456, -10.981255617490524],
              [-13.875807618789004, -10.980584170781816],
              [-13.878347801174678, -10.980365006273132],
              [-13.879619270012945, -10.981232391314522],
              [-13.881289511389266, -10.981196321692865],
              [-13.882096382564002, -10.97962518673372],
              [-13.885148600393205, -10.979098026047229],
              [-13.887103499176463, -10.97953102942496],
              [-13.888839323108206, -10.9815635466879],
              [-13.891313773355542, -10.982269322746525],
              [-13.892513124937123, -10.98321091812184],
              [-13.893859041576032, -10.985292931302478],
              [-13.895457741856957, -10.98710489196388],
              [-13.896630203879603, -10.986135599927891],
              [-13.898735506786954, -10.987260764663889],
              [-13.898588134969943, -10.989624025045169],
              [-13.891620914456599, -10.994661057749775],
              [-13.891586902324262, -10.996478667661753],
              [-13.889623375828464, -10.997798863662522],
              [-13.889666297409084, -10.99981666423424],
              [-13.888222705848207, -11.002754739672266],
              [-13.890418392212087, -11.002034012358127],
              [-13.894022461104468, -10.997251599035463],
              [-13.893243778020771, -10.996364666969862],
              [-13.894956590279042, -10.994974405311698],
              [-13.896415941001186, -10.995072059660687],
              [-13.897230816664887, -10.995835202252984],
              [-13.895296050448252, -10.998143960205198],
              [-13.894930404371472, -10.999244512201148],
              [-13.8928564297779, -11.002183722348873],
              [-13.892305383102212, -11.003455553972806],
              [-13.88971038522614, -11.006784940834189],
              [-13.887679476617713, -11.008176973038967],
              [-13.886398435496867, -11.010092206615864],
              [-13.885526190072436, -11.010605335782458],
              [-13.88309601906923, -11.0136705675425],
              [-13.880500076494442, -11.015752739233651],
              [-13.879823671975618, -11.018687894894148],
              [-13.88035464355277, -11.021203995890282],
              [-13.87980197899269, -11.024800551505916],
              [-13.880387444131674, -11.027288344026735],
              [-13.881861686769899, -11.027970828955056],
              [-13.884158633576916, -11.02829656983878],
              [-13.885697884619065, -11.027841807637284],
              [-13.886434863716545, -11.026708699606461],
              [-13.890118266093134, -11.024615812911653],
              [-13.891206726533515, -11.023670707792519],
              [-13.892801289775088, -11.023626504073746],
              [-13.894899539179802, -11.02184829581341],
              [-13.89622542247701, -11.021639251158359],
              [-13.898089324756306, -11.020509740248878],
              [-13.89917475240571, -11.021438050225475],
              [-13.901174273383006, -11.021863073423017],
              [-13.906518059983908, -11.019162270493156],
              [-13.907890589479683, -11.019099179834518],
              [-13.908881457661984, -11.01818598755915],
              [-13.910420998835473, -11.017842826054341],
              [-13.911834843941719, -11.018415386832858],
              [-13.912539064837905, -11.020662801960563],
              [-13.913378598347858, -11.022042751238972],
              [-13.914545652131551, -11.022377356523487],
              [-13.91705477432215, -11.025092362245875],
              [-13.919344029999518, -11.02865522511881],
              [-13.920924782417394, -11.030072076796966],
              [-13.92382979734416, -11.031954106206308],
              [-13.92514192139577, -11.031933663529962],
              [-13.925357511118944, -11.033775836178505],
              [-13.92738955211635, -11.03398327297823],
              [-13.928164561660406, -11.03143118803981],
              [-13.929774086921155, -11.03284590848092],
              [-13.931521228884963, -11.033476949470092],
              [-13.931797200472975, -11.03257682043531],
              [-13.93349488582553, -11.031972532998333],
              [-13.934604926837622, -11.034714919869735],
              [-13.936678192474366, -11.035062157775515],
              [-13.937799879434074, -11.03691674413127],
              [-13.943365793676179, -11.040900601466983],
              [-13.944871244367855, -11.041780187289675],
              [-13.948032218277278, -11.042897371914846],
              [-13.948771394800117, -11.04232256451582],
              [-13.9520313510377, -11.043918194353973],
              [-13.956764242809488, -11.047289391569898],
              [-13.958289856426678, -11.047797059674728],
              [-13.959534793166085, -11.047001437694371],
              [-13.959684208855903, -11.04532991179095],
              [-13.958742903603477, -11.040800217079049],
              [-13.959227838468179, -11.038615113064528],
              [-13.958957335757527, -11.036257870079138],
              [-13.959067066583389, -11.033971568047248],
              [-13.960912421897408, -11.031448818549526],
              [-13.960959503469196, -11.029858522540872],
              [-13.960114273570335, -11.028869763702419],
              [-13.961164636622103, -11.027555022460902],
              [-13.961056582823119, -11.025433243845198],
              [-13.961917222033211, -11.023488099840081],
              [-13.96123856052542, -11.022233586336236],
              [-13.958581201215413, -11.019545794980516],
              [-13.959169534453434, -11.017482576079436],
              [-13.961949498356686, -11.018156867896849],
              [-13.963777983454937, -11.017902396739313],
              [-13.964952718621621, -11.019470373950579],
              [-13.96679347278566, -11.020597625767564],
              [-13.968009515125571, -11.02328893160958],
              [-13.967913472877248, -11.02441950126031],
              [-13.969873897721609, -11.02544563544216],
              [-13.97075052576692, -11.024261772580529],
              [-13.97250907219995, -11.024253300214006],
              [-13.978918606653698, -11.022836638758934],
              [-13.980942775265683, -11.021687186613848],
              [-13.981751438566205, -11.020169166110074],
              [-13.981484841474344, -11.018983859482374],
              [-13.982717569102775, -11.017660558774844],
              [-13.98166698290774, -11.015395931342718],
              [-13.97811767361795, -11.01511336054379],
              [-13.97894633692713, -11.012499259380606],
              [-13.977297917513289, -11.008489622063285],
              [-13.973146662521138, -11.008949050537838],
              [-13.973240418201074, -11.005202182064059],
              [-13.973913196036618, -11.002676656416957],
              [-13.978423512929465, -11.002622752095462],
              [-13.979408690052072, -11.000893658131172],
              [-13.98049675466555, -10.997884055198826],
              [-13.983170913163072, -10.996816532186067],
              [-13.984255140124496, -10.993784297432272],
              [-13.984268871799888, -10.991835736045205],
              [-13.986846085422624, -10.986862143411452],
              [-13.988904805297482, -10.984986865609775],
              [-13.991207041087463, -10.983663033804039],
              [-13.992390661498746, -10.980750309099209],
              [-13.991390770489755, -10.97982262445821],
              [-13.990608847279722, -10.980707341818894],
              [-13.989063750543986, -10.980462547322558],
              [-13.988310697598662, -10.982961041788501],
              [-13.986443505104122, -10.983692258242247],
              [-13.984792106747307, -10.981290108136433],
              [-13.983596236444715, -10.978391584534428],
              [-13.982449980642071, -10.97705818124219],
              [-13.97909017602983, -10.97862077322473],
              [-13.9784127845699, -10.979898340982645],
              [-13.976567222908258, -10.981654212814353],
              [-13.974859029629261, -10.982294670673035],
              [-13.973031016712309, -10.978555296280694],
              [-13.971924956877134, -10.977488000418251],
              [-13.969576394501292, -10.977207141358777],
              [-13.9686811324543, -10.975940682215295],
              [-13.968576060106624, -10.974580665435266],
              [-13.966721618134878, -10.972430306527771],
              [-13.966527674561698, -10.971224358712101],
              [-13.967543325948412, -10.969552886737349],
              [-13.968566009074506, -10.97005593993236],
              [-13.970180481015706, -10.971785680212573],
              [-13.973921897630557, -10.972193348498896],
              [-13.976423285229869, -10.971284163398751],
              [-13.97826651215398, -10.969219671655845],
              [-13.97983013452589, -10.968452215982973],
              [-13.98082501431664, -10.96526961435275],
              [-13.982606000675684, -10.96562504201376],
              [-13.983491816018613, -10.96471626188466],
              [-13.983686343121201, -10.96308648948451],
              [-13.982976953169837, -10.962272089690174],
              [-13.983746779724466, -10.960667878188891],
              [-13.98507382578664, -10.960411548187558],
              [-13.987006658116872, -10.959126185022036],
              [-13.98975306462779, -10.955762154200647],
              [-13.99069294118455, -10.954028557246097],
              [-13.99248346686978, -10.951820035113426],
              [-13.995903815690134, -10.945282713236946],
              [-13.997029645859014, -10.944308793303012],
              [-13.999174225615745, -10.944629633351553],
              [-14.000757876996122, -10.947404487594117],
              [-14.001431640167455, -10.945025259685918],
              [-14.0030065265129, -10.942936330696824],
              [-14.005369533514292, -10.942167016886087],
              [-14.007255499966584, -10.940870457413238],
              [-14.008362361744592, -10.937903863429337],
              [-14.008279807084547, -10.934879240206545],
              [-14.005153854756772, -10.935351077408132],
              [-14.004891762142996, -10.933910590481373],
              [-14.007396614027462, -10.931371636416685],
              [-14.009238309682642, -10.93085862026586],
              [-14.010421927152233, -10.931093254228049],
              [-14.011365037404167, -10.929804659876215],
              [-14.015025247498048, -10.926964376979392],
              [-14.015637171476476, -10.925587224197656],
              [-14.016915368187203, -10.924248285036372],
              [-14.016960045755315, -10.92263975769083],
              [-14.018306702105715, -10.920713561143623],
              [-14.020546561093287, -10.919506920330965],
              [-14.022076688913387, -10.917464018416803],
              [-14.024599971171224, -10.91515350624342],
              [-14.026431095056896, -10.914505634265511],
              [-14.028683587537515, -10.912518566095672],
              [-14.029068363336739, -10.91099360693865],
              [-14.029974754481088, -10.909830637697064],
              [-14.030067705395975, -10.907918733593316],
              [-14.029114253418408, -10.907351781025104],
              [-14.029246221293716, -10.90593488567952],
              [-14.026164486349591, -10.903600960753188],
              [-14.025934285698565, -10.901733689481297],
              [-14.024914547127404, -10.900752723306713],
              [-14.023225336365892, -10.900292266104447],
              [-14.019463448924299, -10.898167219316688],
              [-14.02013617815092, -10.894213664413588],
              [-14.023160664947182, -10.895478113524192],
              [-14.024269615038968, -10.89564803374907],
              [-14.025531925619134, -10.897084626127855],
              [-14.028270873189669, -10.896604661788372],
              [-14.027516139534034, -10.893760096724336],
              [-14.028537066621867, -10.892190792723795],
              [-14.029388949932704, -10.891850585960736],
              [-14.0311558064274, -10.890000507636726],
              [-14.032680245238112, -10.886326586645714],
              [-14.031233016784006, -10.883735742281905],
              [-14.032784641748666, -10.882487768927309],
              [-14.033575645856171, -10.880154687625078],
              [-14.03354477813268, -10.87900391995595],
              [-14.032331197165401, -10.877323878120167],
              [-14.033025943718469, -10.875173594788516],
              [-14.034863336293194, -10.873696970933024],
              [-14.035112239983405, -10.872184160241734],
              [-14.03777475109968, -10.872029967414043],
              [-14.039560360470961, -10.870890967560909],
              [-14.04017092898904, -10.869037657326516],
              [-14.041640089050725, -10.867286484394716],
              [-14.04521070884592, -10.865316325336623],
              [-14.047626230494696, -10.86461148292742],
              [-14.04932506222672, -10.86235307209884],
              [-14.048588361543645, -10.859610610891156],
              [-14.049291123150805, -10.858530047660473],
              [-14.05388767946236, -10.859205038220265],
              [-14.054601814930288, -10.860450220992888],
              [-14.056539521850535, -10.859703477241322],
              [-14.05706680698011, -10.86177445445146],
              [-14.055671737008515, -10.865671951605465],
              [-14.054226528554379, -10.866530160290445],
              [-14.052297432266135, -10.869297407569906],
              [-14.05232321620782, -10.871102922048175],
              [-14.047175623484174, -10.87284662913671],
              [-14.046263770721339, -10.875145038479545],
              [-14.044627391406182, -10.877335478321665],
              [-14.042204445145991, -10.87900555364874],
              [-14.042816299368292, -10.879830180870576],
              [-14.044652471384117, -10.879932772284155],
              [-14.045981925444186, -10.880731875473947],
              [-14.045714051130759, -10.88263537307462],
              [-14.046195713046975, -10.884083100493807],
              [-14.0447235224675, -10.88473887623768],
              [-14.043654968352929, -10.885855202808317],
              [-14.041590747184893, -10.886877358777765],
              [-14.04039193767602, -10.888872388291011],
              [-14.040945671073937, -10.89043753047681],
              [-14.039334322233724, -10.893165826642146],
              [-14.036925923805422, -10.895722273073826],
              [-14.037453727156093, -10.897008538003238],
              [-14.036737080474179, -10.898133762241665],
              [-14.037080794003387, -10.901657711126846],
              [-14.036111142381463, -10.904474604813633],
              [-14.036738142530917, -10.905568632427514],
              [-14.036820686559617, -10.907967214499887],
              [-14.036248481546536, -10.908736630525231],
              [-14.036416300116672, -10.913052118754],
              [-14.037474116058986, -10.914835596933607],
              [-14.03780790048137, -10.916819312850757],
              [-14.038541882313018, -10.917854561212165],
              [-14.03816350765226, -10.920791198528638],
              [-14.036094290269894, -10.924989485889638],
              [-14.037698867547373, -10.926260423125374],
              [-14.037947915147175, -10.92712106682494],
              [-14.036954159059361, -10.928439026899623],
              [-14.03492708333996, -10.933299578715472],
              [-14.034779627207204, -10.935874584563306],
              [-14.039256533658566, -10.935496995038653],
              [-14.041711802080577, -10.935807062644908],
              [-14.04528292125936, -10.938665420544334],
              [-14.047961736876948, -10.9388136733065],
              [-14.04900141279458, -10.939402046115086],
              [-14.051756155896584, -10.93943794803836],
              [-14.052981556411384, -10.938400944145904],
              [-14.05574357737864, -10.936807480975096],
              [-14.058510303087894, -10.934554220025657],
              [-14.063365082505463, -10.93391847191628],
              [-14.066879497472936, -10.933934789197945],
              [-14.068743269706648, -10.933156923647537],
              [-14.071460252194239, -10.931065193848454],
              [-14.073425891635848, -10.929919137872355],
              [-14.076412223018671, -10.929034370129141],
              [-14.078865557461075, -10.927447542403591],
              [-14.081692535920764, -10.926098661381497],
              [-14.083772624835326, -10.924366606711104],
              [-14.08525454287667, -10.920936346404547],
              [-14.087076137184892, -10.92287225279788],
              [-14.08756873525315, -10.92559736874603],
              [-14.0889019510785, -10.92608575060141],
              [-14.091293194802313, -10.9233790651323],
              [-14.094226715476717, -10.924510200343766],
              [-14.094742803906986, -10.925218850582816],
              [-14.096617710361164, -10.924705639470911],
              [-14.098499451405228, -10.92335919268343],
              [-14.101367097627463, -10.922142478517827],
              [-14.107207250145732, -10.914950577461585],
              [-14.107953437877603, -10.909838917018739],
              [-14.110200861907156, -10.905825795271772],
              [-14.111253572923816, -10.905486838907565],
              [-14.11210162763783, -10.903917106126027],
              [-14.11179457665438, -10.903090047064971],
              [-14.113865172575201, -10.900652170867392],
              [-14.1164875631655, -10.89600227307015],
              [-14.115712389401663, -10.894789289156021],
              [-14.117744937825549, -10.890770515736534],
              [-14.118629632322953, -10.887544329518981],
              [-14.12348117559613, -10.885673892686981],
              [-14.124597230046678, -10.884830646495777],
              [-14.12650235497126, -10.885979854109907],
              [-14.12570414415725, -10.888712467310254],
              [-14.125849644442178, -10.891771818056466],
              [-14.124354134566065, -10.894618645790318],
              [-14.123784103524661, -10.896702451483945],
              [-14.123534129006424, -10.90101832772349],
              [-14.124373032380056, -10.903299246069224],
              [-14.126160889808945, -10.903346828498117],
              [-14.127802089659415, -10.901616968947955],
              [-14.128969751740778, -10.898638620531006],
              [-14.130937951678334, -10.89613446035621],
              [-14.132327724854653, -10.895098674962826],
              [-14.137011683741827, -10.89269612892888],
              [-14.138432376416995, -10.889918176412866],
              [-14.139989036809567, -10.887614298498406],
              [-14.143478938577097, -10.883893393730682],
              [-14.146305509560507, -10.882072917985823],
              [-14.147355801613047, -10.881018806808065],
              [-14.152817777061099, -10.876855310515955],
              [-14.153682070122152, -10.876600698880864],
              [-14.154904514096696, -10.877794395563031],
              [-14.154247432740576, -10.879239513313706],
              [-14.153081988986845, -10.880114326682852],
              [-14.150168291364743, -10.884335218361606],
              [-14.149233075446604, -10.884354828385963],
              [-14.142303613885623, -10.892116119685996],
              [-14.139932025130404, -10.895301648191692],
              [-14.136575385764749, -10.897778418229139],
              [-14.133329625951033, -10.901494077297022],
              [-14.13021138749773, -10.907729216497785],
              [-14.130421608872217, -10.911510748945693],
              [-14.133792299163515, -10.91134419291716],
              [-14.136082188744119, -10.910586219952261],
              [-14.13694008641794, -10.912044262541327],
              [-14.137976584977974, -10.912164014190989],
              [-14.140570168759659, -10.911132585778041],
              [-14.143030352616176, -10.907850333794741],
              [-14.147767560803658, -10.90541092945627],
              [-14.148826088010237, -10.90542396653019],
              [-14.156354301325196, -10.902968978659285],
              [-14.157840924490161, -10.90330636183517],
              [-14.159869320007015, -10.90257258183177],
              [-14.160345873887517, -10.903265520029601],
              [-14.162882052600937, -10.903050700706661],
              [-14.164843110872514, -10.900993530880443],
              [-14.167077201320811, -10.900948434291044],
              [-14.169022764600752, -10.900351699124998],
              [-14.170437984239204, -10.899266989182843],
              [-14.17267855010961, -10.899035732156738],
              [-14.174326534382782, -10.89981331681992],
              [-14.175668112593613, -10.899592997162578],
              [-14.17689028505737, -10.898335669327189],
              [-14.180024864286024, -10.898186142342238],
              [-14.185001790240008, -10.89346911485554],
              [-14.186757091059489, -10.891539063684158],
              [-14.1912255873263, -10.889199881374891],
              [-14.19295256292849, -10.888685289204352],
              [-14.19608577439446, -10.888358405863388],
              [-14.198017753550532, -10.886891520857349],
              [-14.198629767570377, -10.885610002660119],
              [-14.200598183492522, -10.884851881021973],
              [-14.202330532427174, -10.882985480759828],
              [-14.202886202904356, -10.880903817393781],
              [-14.205080730110991, -10.880116421032973],
              [-14.206008910839339, -10.878785567891018],
              [-14.207260059150506, -10.878713662189815],
              [-14.208374343201104, -10.87751897929526],
              [-14.210189027641304, -10.877738542574193],
              [-14.212597877079604, -10.874899117763643],
              [-14.214262699732183, -10.874106404191224],
              [-14.21644811539677, -10.871070169046193],
              [-14.218092938874127, -10.87153436523763],
              [-14.218112190385462, -10.872890433549475],
              [-14.220078616966067, -10.875191639989179],
              [-14.221568223529575, -10.877687524956173],
              [-14.220237069560453, -10.880083338554405],
              [-14.218753735074676, -10.88075762724252],
              [-14.21788645736255, -10.882800854630196],
              [-14.215132058039073, -10.886113693486294],
              [-14.211260961755924, -10.888314526533255],
              [-14.210289267350477, -10.887534734537658],
              [-14.209201612638715, -10.88566798802243],
              [-14.207062618754636, -10.886679087804588],
              [-14.207135465093398, -10.888218390406063],
              [-14.205248565136444, -10.89040216876631],
              [-14.205329180199685, -10.89229928323168],
              [-14.203405247055837, -10.893419161321592],
              [-14.202620361651414, -10.894563636274453],
              [-14.199893218228212, -10.896612888136458],
              [-14.197841355537047, -10.897826184678081],
              [-14.195448313035332, -10.898617946532651],
              [-14.193268256095152, -10.898527834299719],
              [-14.19111409428955, -10.900132178181922],
              [-14.188429268810436, -10.902876673568462],
              [-14.18691958585045, -10.903879829873473],
              [-14.18506782693945, -10.907438490429158],
              [-14.184733918281632, -10.909294733683092],
              [-14.185380595473488, -10.91190342415062],
              [-14.186490544246613, -10.912977998399954],
              [-14.18588022403803, -10.915770892313292],
              [-14.187614887525228, -10.916213030709242],
              [-14.188686534460656, -10.915204652945842],
              [-14.19197990134299, -10.914663472557667],
              [-14.194857853396615, -10.915578662623012],
              [-14.196270900839675, -10.915630904059977],
              [-14.197894948555357, -10.916963191243811],
              [-14.201852930812962, -10.91760824671245],
              [-14.204114529031415, -10.92065603783161],
              [-14.205497075502786, -10.92180343980495],
              [-14.205874495942007, -10.924176518486563],
              [-14.206445001318647, -10.925046126526636],
              [-14.206322434984672, -10.927716904243498],
              [-14.206878404651665, -10.928415904004222],
              [-14.206820760045266, -10.930824154206862],
              [-14.205893197814563, -10.93227240015413],
              [-14.207084743902922, -10.933234814796682],
              [-14.207491052778114, -10.93457531197639],
              [-14.20740193674715, -10.936614007808824],
              [-14.210235162388097, -10.941077734666914],
              [-14.21026205529334, -10.942420399120309],
              [-14.212922930666407, -10.943836690560936],
              [-14.21331478331709, -10.945349984230953],
              [-14.212694050175054, -10.947660275212],
              [-14.214352468531379, -10.951017158100877],
              [-14.211336647205895, -10.951603884210316],
              [-14.209555749246304, -10.952977928034988],
              [-14.207696978755957, -10.951433891957832],
              [-14.20748539609994, -10.949889831332758],
              [-14.206475304980652, -10.949018230202903],
              [-14.20648848035199, -10.946962466175176],
              [-14.205128415781866, -10.944905831235905],
              [-14.204842641212263, -10.94264267927602],
              [-14.204155087893133, -10.942026326744644],
              [-14.203112924264861, -10.939735817831204],
              [-14.202254335402275, -10.93548457362684],
              [-14.20097350011344, -10.935187362991396],
              [-14.200200548071347, -10.933439553733137],
              [-14.20021464181874, -10.930364790605294],
              [-14.19882184811816, -10.928139020715044],
              [-14.19926767606791, -10.925110319120696],
              [-14.199013755020403, -10.924529707231487],
              [-14.197029607922653, -10.924547007262579],
              [-14.194810849574113, -10.92352441620774],
              [-14.193769541421009, -10.92432362912952],
              [-14.190555248242553, -10.92361025166842],
              [-14.189960799450919, -10.92417344056735],
              [-14.187964658290321, -10.92404823138194],
              [-14.186583914183073, -10.924781255636121],
              [-14.18509577141902, -10.9247002664618],
              [-14.18329543666062, -10.92339857550905],
              [-14.182740688823253, -10.921403657050698],
              [-14.179970072689612, -10.923091148523625],
              [-14.177990100773334, -10.923170306751889],
              [-14.176101374967342, -10.924634007163764],
              [-14.173131030727424, -10.923066379645478],
              [-14.172326801924637, -10.923760788069355],
              [-14.16993065384956, -10.923349273603469],
              [-14.169304872551939, -10.923886486497967],
              [-14.167315983261206, -10.92384649296698],
              [-14.16590001095358, -10.924361536665373],
              [-14.163394303821, -10.926137672563693],
              [-14.162686371682677, -10.927081732587952],
              [-14.162008106857705, -10.930083864076384],
              [-14.159534668363007, -10.934976015176424],
              [-14.158058242606849, -10.936154017313072],
              [-14.157625402319914, -10.934843986954625],
              [-14.15750883368804, -10.932449988422768],
              [-14.159167451049019, -10.925534629557665],
              [-14.159053421791501, -10.923512156496052],
              [-14.157579037449747, -10.92300185858976],
              [-14.155372153935664, -10.92380442417405],
              [-14.152459850604634, -10.923209673363717],
              [-14.149593286498451, -10.921094939530963],
              [-14.148030012866615, -10.922279774135648],
              [-14.145504821583668, -10.923141803261945],
              [-14.144045121562145, -10.922802043119587],
              [-14.142703945278624, -10.92316795489148],
              [-14.141590355455607, -10.925174996191846],
              [-14.139852127218957, -10.925654161487497],
              [-14.13897324745895, -10.924956924906025],
              [-14.136880262002283, -10.924381994051569],
              [-14.134328478663141, -10.925275091960243],
              [-14.133248496393131, -10.926649866421847],
              [-14.132942219076138, -10.928534480652496],
              [-14.132069935956123, -10.928919640017504],
              [-14.129684460747189, -10.927996323992797],
              [-14.128070177709224, -10.927897977255425],
              [-14.126564321063737, -10.926674486512438],
              [-14.123864393441956, -10.925147353811038],
              [-14.120694362085139, -10.926662215784708],
              [-14.117941734231449, -10.926226625680632],
              [-14.116363842288774, -10.927241050277129],
              [-14.114899510590526, -10.9271876447442],
              [-14.113166922105274, -10.927756728976188],
              [-14.112703187166318, -10.92848098409077],
              [-14.110613078882732, -10.929651401000086],
              [-14.110294292024939, -10.930363895453917],
              [-14.10739470883194, -10.931628284638087],
              [-14.105652667205833, -10.933114024046843],
              [-14.103949348715387, -10.933680594417634],
              [-14.102552825860947, -10.93510996040545],
              [-14.100962943552329, -10.935982323214617],
              [-14.10017751693269, -10.935673622398784],
              [-14.097690865109291, -10.93596057554834],
              [-14.098220684245033, -10.937720380482032],
              [-14.099802642000439, -10.937765123646429],
              [-14.099179357404337, -10.939447241376273],
              [-14.099823629918747, -10.941606403701606],
              [-14.099504136385166, -10.943412138579768],
              [-14.10269741735874, -10.94319529257441],
              [-14.105480618511791, -10.94220371170037],
              [-14.107474156654176, -10.942349292209729],
              [-14.107979520957015, -10.943994553901115],
              [-14.106629356488963, -10.945891897917193],
              [-14.107143202621582, -10.947025911067303],
              [-14.110612698957441, -10.94735855447217],
              [-14.111666340982294, -10.949930171031118],
              [-14.111300010298736, -10.951748295932811],
              [-14.109341326334027, -10.953234889298859],
              [-14.105867431352126, -10.952851551906635],
              [-14.103045558854886, -10.953999191885819],
              [-14.100525997755074, -10.95624641398509],
              [-14.098817963786793, -10.95945028451566],
              [-14.09861132581174, -10.96130635694774],
              [-14.096863985766428, -10.962213715102571],
              [-14.095603338261093, -10.960271871870948],
              [-14.096232373568125, -10.956644493279228],
              [-14.098363569777344, -10.954735120524742],
              [-14.097607228940163, -10.950146460740212],
              [-14.095348907654971, -10.95115912037815],
              [-14.093404496889184, -10.951610367358949],
              [-14.092718814624908, -10.952738649190845],
              [-14.094811163213045, -10.95479012535626],
              [-14.093783911025193, -10.956287963214871],
              [-14.092280338756442, -10.955586376164476],
              [-14.09064830830355, -10.955971602134701],
              [-14.089203858285865, -10.953983034518005],
              [-14.087546215185125, -10.953628101728947],
              [-14.085219145514166, -10.954060249445767],
              [-14.082632727677957, -10.955414337300242],
              [-14.079163681905506, -10.956286331444664],
              [-14.077929622366124, -10.955974286821188],
              [-14.073311678396228, -10.957839725713075],
              [-14.071991644190879, -10.960518583679866],
              [-14.069369670774254, -10.961167627655852],
              [-14.068585713324472, -10.962131428800369],
              [-14.066413781075381, -10.96343890571835],
              [-14.065586332648792, -10.964508897441625],
              [-14.06341220823494, -10.965790781417859],
              [-14.063833985373627, -10.967042606352637],
              [-14.065107046607798, -10.966888128802086],
              [-14.064811929120511, -10.968661220789338],
              [-14.065621242125633, -10.972917135362383],
              [-14.067888564818814, -10.975762660658866],
              [-14.0684666605593, -10.977403964458592],
              [-14.068446418775494, -10.979276914560106],
              [-14.069931872205771, -10.98123403301782],
              [-14.07227388171686, -10.982332159773474],
              [-14.072796244553812, -10.984006665658535],
              [-14.074757330161608, -10.984767056895619],
              [-14.077092678142037, -10.98853249763559],
              [-14.079541974066904, -10.993253153339799],
              [-14.080503079579206, -10.995625842590874],
              [-14.080584145997404, -10.998206106792653],
              [-14.082824588522355, -11.00085364256795],
              [-14.085457588138805, -11.00021048122868],
              [-14.087146125917085, -11.000461378828076],
              [-14.088058566188453, -11.002387958722371],
              [-14.087527222560986, -11.00355128551198],
              [-14.085790986964051, -11.00386986829958],
              [-14.0847639006123, -11.004889915744359],
              [-14.08148008879552, -11.005069555488527],
              [-14.078162700605006, -11.004006900099867],
              [-14.07590938856368, -11.004957364343428],
              [-14.07489121722404, -11.004753696697328],
              [-14.074744408364227, -11.003254965610212],
              [-14.075242835711553, -10.99973878030675],
              [-14.075886043453737, -10.998167538447507],
              [-14.074733895633095, -10.997003212955626],
              [-14.073500625729546, -10.993841498517343],
              [-14.069565893348527, -10.990840556729792],
              [-14.066599406025226, -10.990609815401216],
              [-14.064300625548276, -10.991409384455643],
              [-14.061949813233147, -10.992944201959997],
              [-14.059233996230141, -10.993964759839121],
              [-14.057524041700301, -10.996144088451961],
              [-14.05657821908366, -10.995600007724839],
              [-14.057815508424484, -10.993117007687529],
              [-14.063479132813333, -10.98911491096297],
              [-14.064200690258128, -10.987840866737015],
              [-14.063784504089611, -10.98570006380368],
              [-14.062792089953156, -10.98376016855745],
              [-14.05977618846459, -10.979443545966806],
              [-14.058783120005886, -10.979094546931895],
              [-14.05636255785469, -10.9822088025876],
              [-14.050972508370908, -10.985763275457224],
              [-14.049969375673172, -10.985300921550827],
              [-14.052056799486955, -10.982636715576453],
              [-14.05473926272102, -10.98054751561606],
              [-14.056612272513298, -10.974365447769417],
              [-14.057772702696791, -10.97203661568983],
              [-14.056686524591592, -10.969837327983337],
              [-14.05530992129804, -10.969645635192048],
              [-14.05325727781312, -10.971163899163848],
              [-14.048388553277723, -10.97295955144106],
              [-14.04567549598048, -10.974695374981208],
              [-14.04303747043131, -10.977655506566697],
              [-14.042324970653498, -10.978885950413257],
              [-14.039473835039537, -10.979688758229253],
              [-14.036550523390927, -10.98169914451245],
              [-14.034977291080674, -10.98174075384646],
              [-14.03174958025874, -10.983260462904601],
              [-14.028577775377707, -10.987150979143179],
              [-14.028201257220964, -10.988554555571657],
              [-14.029293661673034, -10.989038527622347],
              [-14.030544163013305, -10.988213680635736],
              [-14.032816363568957, -10.987552020110932],
              [-14.034109410228323, -10.988334442497475],
              [-14.0333245121143, -10.99008599313584],
              [-14.031626042580962, -10.990709682791309],
              [-14.030082510497335, -10.99315194240934],
              [-14.030928834878347, -10.994857629831577],
              [-14.029551726491555, -10.995827258993334],
              [-14.02893647033474, -10.994181938950792],
              [-14.026982022737318, -10.992058221330499],
              [-14.025972220412921, -10.992762586820438],
              [-14.026463018774969, -10.993845546308245],
              [-14.028265789209499, -10.994443416652613],
              [-14.028490709546828, -10.99536948111117],
              [-14.027408468707069, -10.996372624353732],
              [-14.027196236582057, -10.997991998941055],
              [-14.025833050816054, -10.997218440346874],
              [-14.02251371427681, -10.999229180893114],
              [-14.021077875248052, -10.997448353511453],
              [-14.01970204126047, -10.997060674645411],
              [-14.017725054468457, -10.9978690283736],
              [-14.016942631848513, -10.998962229646628],
              [-14.01538902069451, -10.999917669316442],
              [-14.014454428759407, -11.00196758329955],
              [-14.0134953536493, -11.002703245107911],
              [-14.01153932026998, -11.008002270263031],
              [-14.010255440246828, -11.008897005865787],
              [-14.008705652191097, -11.009184729261248],
              [-14.007860316185738, -11.010912466727897],
              [-14.006708014126522, -11.012121508865473],
              [-14.004284564760045, -11.01246070970332],
              [-14.00305660048882, -11.012241857958246],
              [-14.0019580152101, -11.013936505472012],
              [-14.002115648885347, -11.016126657964682],
              [-14.002761093515124, -11.017190268501317],
              [-14.001176496044078, -11.02158846570526],
              [-14.00044483126939, -11.022146741410694],
              [-14.000198394001872, -11.024283710270165],
              [-13.998919077725686, -11.025540571992238],
              [-13.995096370963152, -11.025408335311987],
              [-13.994088472760927, -11.025982904311213],
              [-13.993782950967029, -11.028989019851405],
              [-13.995457735743383, -11.030484267210376],
              [-13.99553195846615, -11.03189077988597],
              [-13.994654051990176, -11.033724779121378],
              [-13.991199058856825, -11.034977085624297],
              [-13.989339235046181, -11.037130311425093],
              [-13.988119846675778, -11.040633633703406],
              [-13.98731044137813, -11.041070957782473],
              [-13.986194742620338, -11.043049628200562],
              [-13.986721659905395, -11.044094019627284],
              [-13.986188466387325, -11.047083858913899],
              [-13.984616224068214, -11.049871739698865],
              [-13.982417744835443, -11.05079348306204],
              [-13.980062364036476, -11.05261492828761],
              [-13.982435759158363, -11.055455437676617],
              [-13.98208573301644, -11.056828199672132],
              [-13.984966521578317, -11.059112696771848],
              [-13.98549600053974, -11.059842131922638],
              [-13.98575019890434, -11.062139003386461],
              [-13.9864538988677, -11.06422738301823],
              [-13.98716200366801, -11.064999717992212],
              [-13.987597484885201, -11.067367629965933],
              [-13.988586036158905, -11.068345944994569],
              [-13.991568100538668, -11.070107082459636],
              [-13.994527935255418, -11.06955291266665],
              [-13.996001874432382, -11.070406502243655],
              [-13.997968906056851, -11.070533148434917],
              [-13.999138638186604, -11.071926324888349],
              [-14.002016712095923, -11.073838878311864],
              [-14.00552748571883, -11.073583270788983],
              [-14.006412200250084, -11.074369788343068],
              [-14.004987064671171, -11.07648755047702],
              [-14.00680457201161, -11.079315745776766],
              [-14.011753899497933, -11.082576686323554],
              [-14.013235181027149, -11.084564744598286],
              [-14.01402592199586, -11.084643467956713],
              [-14.016821497719954, -11.086543547074735],
              [-14.020241127819562, -11.0855078390494],
              [-14.021750167214266, -11.084085126208091],
              [-14.022730649507686, -11.081182409273563],
              [-14.022791924486574, -11.078123785140004],
              [-14.022198168208977, -11.077095981115434],
              [-14.021538422808787, -11.073956420207587],
              [-14.0201843093923, -11.070074470193699],
              [-14.020674202830538, -11.069067730183956],
              [-14.028081842602662, -11.06658039602866],
              [-14.029594344950393, -11.065828684326812],
              [-14.030599825654383, -11.06769255193535],
              [-14.029288240631331, -11.069772598913943],
              [-14.030533379961202, -11.070786449494069],
              [-14.034114028321804, -11.071532775271628],
              [-14.035587620603565, -11.070035327759122],
              [-14.037343694403114, -11.072135050593928],
              [-14.040058007632991, -11.071790598897483],
              [-14.041099950719122, -11.073737328269912],
              [-14.039599511101521, -11.074287939629416],
              [-14.038143036464122, -11.077065856985543],
              [-14.036843185250564, -11.077236599074812],
              [-14.036362482309206, -11.078439958198313],
              [-14.033721972973163, -11.080684947024258],
              [-14.03318839048057, -11.08230123387102],
              [-14.034053665329912, -11.083890545640031],
              [-14.031789721490822, -11.08507495238785],
              [-14.03232163791051, -11.086519271285638],
              [-14.031981603118819, -11.089378755865086],
              [-14.032155939623383, -11.09108104147336],
              [-14.032853157299586, -11.091813002031449],
              [-14.031139208709337, -11.094224063808385],
              [-14.032234039938617, -11.09619287085193],
              [-14.034424533618603, -11.097491965526428],
              [-14.037946149915262, -11.096333492292972],
              [-14.038788943098188, -11.09354788951307],
              [-14.041280144553324, -11.094004433629284],
              [-14.044672396893539, -11.093729997579166],
              [-14.0469368887827, -11.096321425898832],
              [-14.046671564485006, -11.098688523953713],
              [-14.048580594746014, -11.098000446791652],
              [-14.050387733082104, -11.098156336490149],
              [-14.051228519337286, -11.099960630704354],
              [-14.054215600194436, -11.09979256778976],
              [-14.055888298247176, -11.098642639801838],
              [-14.05650328829183, -11.100048672097293],
              [-14.051172006667807, -11.103178352709639],
              [-14.04929946167062, -11.105340227479218],
              [-14.050105663745502, -11.10650638725641],
              [-14.052838826246656, -11.10371190405328],
              [-14.054481898431419, -11.10256454186705],
              [-14.055705166847348, -11.102833290258122],
              [-14.056170668360995, -11.101075483037695],
              [-14.057603744527285, -11.100283024541678],
              [-14.058325154347559, -11.098710274809221],
              [-14.062628839814572, -11.09760853354688],
              [-14.066654413794422, -11.098637480465838],
              [-14.06856633550614, -11.096592448522872],
              [-14.069043429204475, -11.094603239481218],
              [-14.070407489307394, -11.093673768982939],
              [-14.07199536490856, -11.090400303816965],
              [-14.074075037283627, -11.090184286410297],
              [-14.074683644796346, -11.088761950934881],
              [-14.07593842484472, -11.088403038202665],
              [-14.076634004115508, -11.089222545786452],
              [-14.077088338418871, -11.09162842725317],
              [-14.08116973375793, -11.094301781299498],
              [-14.081896914386173, -11.0955592354876],
              [-14.080874544363086, -11.098317239478474],
              [-14.07933035108605, -11.09926923072201],
              [-14.078012502115921, -11.099048180944159],
              [-14.076770844019377, -11.100921963030903],
              [-14.076812020243649, -11.101748198780788],
              [-14.075550903000709, -11.102708294184099],
              [-14.07453156376281, -11.10479308469637],
              [-14.072954013739038, -11.106836961775937],
              [-14.07100645279852, -11.10693736498362],
              [-14.07018972908309, -11.105916529430786],
              [-14.069201104136281, -11.106469911021293],
              [-14.069281557785548, -11.108072845428755],
              [-14.068725686840807, -11.10977575013948],
              [-14.066143414067394, -11.111212769271326],
              [-14.065032742626444, -11.112302089155568],
              [-14.063165795068635, -11.114998174041022],
              [-14.062045719677249, -11.11735631841146],
              [-14.061309127423547, -11.120128406566888],
              [-14.060892956447924, -11.123298150150928],
              [-14.062784482993896, -11.124064581414908],
              [-14.062327850703031, -11.12605422620329],
              [-14.063935743017796, -11.127290639640083],
              [-14.06300733889705, -11.129032242217288],
              [-14.0618204196194, -11.130148205956253],
              [-14.062860297818284, -11.133403943334965],
              [-14.064529467929573, -11.134544774375701],
              [-14.067086915361955, -11.137364236239977],
              [-14.069499144480714, -11.138330627002127],
              [-14.072103388668886, -11.13885616897235],
              [-14.073303747494656, -11.13843432301516],
              [-14.075129161425673, -11.140110597699348],
              [-14.076040068178441, -11.139843684909534],
              [-14.078776052388859, -11.140091328436185],
              [-14.079560747110774, -11.13795322167431],
              [-14.082523613410697, -11.13761282327227],
              [-14.082901276064401, -11.136305839255689],
              [-14.084571762015122, -11.135395679389905],
              [-14.08527634632182, -11.134048991176785],
              [-14.088642053528947, -11.130521948991406],
              [-14.090814841369749, -11.127148585159585],
              [-14.091360506905744, -11.125467558934062],
              [-14.09065920987777, -11.124117257093205],
              [-14.09193145276103, -11.123569234197712],
              [-14.091943502849487, -11.121644048106788],
              [-14.090982795553055, -11.12086017254257],
              [-14.090523683957189, -11.119125184969873],
              [-14.088522684813675, -11.117354629281868],
              [-14.086607137524279, -11.116747318535346],
              [-14.086474552576027, -11.118274020916717],
              [-14.084679419575874, -11.11947724748396],
              [-14.083123313875957, -11.119374339133882],
              [-14.083055507809501, -11.118235835801325],
              [-14.08593087325723, -11.114025813905249],
              [-14.085760707593616, -11.11058011334479],
              [-14.09048330634355, -11.112879097611788],
              [-14.093826020163633, -11.116589656311167],
              [-14.094748013483235, -11.116107675852586],
              [-14.094594653664595, -11.114843028648794],
              [-14.096044466247516, -11.11415259209757],
              [-14.095865140587872, -11.111939629816902],
              [-14.09655803814442, -11.111296556028494],
              [-14.098327868029406, -11.112109419638278],
              [-14.098323242894244, -11.114455364363673],
              [-14.09889390264483, -11.117383961893783],
              [-14.101066168904927, -11.11855265316406],
              [-14.102728430599088, -11.117159706095947],
              [-14.104900583135429, -11.118084912633094],
              [-14.106709337787704, -11.113391401562312],
              [-14.10721612550171, -11.110764046356904],
              [-14.106028193949868, -11.107740637600635],
              [-14.104267336378294, -11.107504669777871],
              [-14.104617801308766, -11.104643964002852],
              [-14.107616008225977, -11.105007726167221],
              [-14.108019915838899, -11.105513105059334],
              [-14.110071699584424, -11.105278188813758],
              [-14.11181930054549, -11.103975556639588],
              [-14.112118862095814, -11.100362878726894],
              [-14.112926643802354, -11.099366980857882],
              [-14.113963152108532, -11.099884011806623],
              [-14.114313948338742, -11.102337141549823],
              [-14.113811597924252, -11.104615698083192],
              [-14.111402959488245, -11.107184621578021],
              [-14.11054542504215, -11.110258681697202],
              [-14.111405732108157, -11.111331842565809],
              [-14.11189178233949, -11.113952481404189],
              [-14.114793656017806, -11.11443321879694],
              [-14.115110100722479, -11.113349255211403],
              [-14.116624920277019, -11.111939571231314],
              [-14.117483410883304, -11.113012026032633],
              [-14.119152648772326, -11.113240697465155],
              [-14.119334891198344, -11.115219594591565],
              [-14.120125750716356, -11.115465351095276],
              [-14.121707241207261, -11.114340747181433],
              [-14.121942556670007, -11.11306901287451],
              [-14.121044718076542, -11.111889134953719],
              [-14.118131540182521, -11.111551104419185],
              [-14.11999131076105, -11.107652341557921],
              [-14.118246473362333, -11.107778522851577],
              [-14.118849421244859, -11.103436335599454],
              [-14.120219082948402, -11.101621073152662],
              [-14.120037345484274, -11.096475121826277],
              [-14.12114147563878, -11.095041473742736],
              [-14.123412926400903, -11.096345446615864],
              [-14.125493257685905, -11.096091304442513],
              [-14.126319708419492, -11.09653936504567],
              [-14.125812617301138, -11.099154855440725],
              [-14.124408760929263, -11.099811690152517],
              [-14.124542108310573, -11.102747227914293],
              [-14.125810790434018, -11.103931778951562],
              [-14.126224176256983, -11.10570023200199],
              [-14.128676671071437, -11.106388728190336],
              [-14.130544453389742, -11.10569439250806],
              [-14.131457768338684, -11.10476233639322],
              [-14.1308628347953, -11.103708366209577],
              [-14.13074690732845, -11.10190229345114],
              [-14.131701116271334, -11.099050752292152],
              [-14.131492945361728, -11.094653887462462],
              [-14.130768646774479, -11.092579557877297],
              [-14.13137608617355, -11.091404623980226],
              [-14.133093899284084, -11.091870669137956],
              [-14.132956240725951, -11.093389002722542],
              [-14.133959497270196, -11.094425239217419],
              [-14.136636703525813, -11.095338220802004],
              [-14.137468726081835, -11.093910406436441],
              [-14.134651720784968, -11.092095604054341],
              [-14.135675538576725, -11.089785643994043],
              [-14.13740041363821, -11.088966015456025],
              [-14.14010119539305, -11.089618148587666],
              [-14.14207223279873, -11.090814103900321],
              [-14.144905615380994, -11.08945831398804],
              [-14.14982686827889, -11.088772474144244],
              [-14.15381716373656, -11.088710717958273],
              [-14.154994864906042, -11.088924291549507],
              [-14.156600790421487, -11.091154424362498],
              [-14.15875196204871, -11.091085071109111],
              [-14.160698358424067, -11.093135595767459],
              [-14.162633917525577, -11.093726775493247],
              [-14.164623723708546, -11.095514728089531],
              [-14.163285524522664, -11.099829332121224],
              [-14.163944711367607, -11.100863782197642],
              [-14.166389771895163, -11.101976194592199],
              [-14.169319175550516, -11.100328533440782],
              [-14.170547041341997, -11.098490687500322],
              [-14.172986811605002, -11.096652047098026],
              [-14.17436118690636, -11.096292809103078],
              [-14.176016377550582, -11.094786397650964],
              [-14.178245129027989, -11.093824569022342],
              [-14.182223165957717, -11.090737949315356],
              [-14.185891896980129, -11.090335835611482],
              [-14.187700275711096, -11.088674717631589],
              [-14.198548808632973, -11.084611776673933],
              [-14.20118032497444, -11.084365708108523],
              [-14.202745493891815, -11.084716865091911],
              [-14.206038899965748, -11.084254187797429],
              [-14.209659654715091, -11.082785594874922],
              [-14.213447573634364, -11.079500392024908],
              [-14.217646599384347, -11.07781673974636],
              [-14.22105695003295, -11.076663710399071],
              [-14.224327183899508, -11.075872421068505],
              [-14.229428518305454, -11.073883847021197],
              [-14.230898870364607, -11.073986351959084],
              [-14.232661620389045, -11.072883290132054],
              [-14.233907904539697, -11.071098034758108],
              [-14.237627116812446, -11.069424375878153],
              [-14.238774913246168, -11.068100726654869],
              [-14.240343133365073, -11.067566002948787],
              [-14.245276432168048, -11.064298199980502],
              [-14.24983016232531, -11.062863454731685],
              [-14.253135951625516, -11.061120885248034],
              [-14.260896458543085, -11.05824705811698],
              [-14.264054491414079, -11.056894278368922],
              [-14.266593415953533, -11.055432118657402],
              [-14.267482973543235, -11.054573815147734],
              [-14.273396912186247, -11.052496694070676],
              [-14.276178175400926, -11.051949989374886],
              [-14.279785796571556, -11.052907673035502],
              [-14.283063207405819, -11.052110296437323],
              [-14.287989798203196, -11.049563265507338],
              [-14.290371860648024, -11.047906916597912],
              [-14.290803720004407, -11.046826011789191],
              [-14.291144016788989, -11.04262277356592],
              [-14.291954969031572, -11.040668602158243],
              [-14.292042317135897, -11.039195794070434],
              [-14.294382906730423, -11.036300802528258],
              [-14.295088320049075, -11.034409395929421],
              [-14.297728726401612, -11.032511763046625],
              [-14.298979513213851, -11.032138452842027],
              [-14.309457607930016, -11.024658832273463],
              [-14.31472230833324, -11.02132108069465],
              [-14.31992626683065, -11.018384644331244],
              [-14.328843622367465, -11.01390012166155],
              [-14.336760729083231, -11.010800864024635],
              [-14.338790804865825, -11.00916125600228],
              [-14.341652622896897, -11.007470888336783],
              [-14.346863701828472, -11.005147300398312],
              [-14.348639749158785, -11.004068528278333],
              [-14.351555128919374, -11.001218713002675],
              [-14.352982208703242, -10.99840781246286],
              [-14.353313236941657, -10.996601967292246]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -135.64025880758197,
          "lat": 58.28718975405681
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02105"],
        "coty_name": ["Hoonah-Angoon"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Hoonah-Angoon Census Area"],
        "coty_fp_code": "105",
        "coty_gnis_code": "02371430"
      },
      "bbox": [
        -14.353313236941657, -11.432477990932115, -13.299557422905687,
        -10.70377368304968
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.898049508131912, -9.744250529966173],
              [-18.893523946413193, -9.740912159271527],
              [-18.889854024223734, -9.741757408289871],
              [-18.888517114041246, -9.742666878115271],
              [-18.887871891089127, -9.744202483121006],
              [-18.889075349971435, -9.747503191899382],
              [-18.89024343878951, -9.748243306138976],
              [-18.892927517267786, -9.748932186171942],
              [-18.895209084877877, -9.748551741276092],
              [-18.896788976594607, -9.747376265192496],
              [-18.89710352685492, -9.74557087985966],
              [-18.898049508131912, -9.744250529966173]
            ]
          ],
          [
            [
              [-18.899313530372638, -9.730696720535144],
              [-18.898001205106237, -9.727795989325543],
              [-18.89521519803978, -9.724716492819406],
              [-18.89417657469553, -9.724410692815443],
              [-18.89266223848797, -9.722937390236622],
              [-18.89150947197672, -9.723327344211466],
              [-18.890624962159954, -9.725011753751268],
              [-18.890099872100535, -9.728786785155306],
              [-18.890845686545745, -9.73091090252981],
              [-18.8932146451864, -9.732721604024993],
              [-18.896429357875345, -9.734114831704224],
              [-18.899779498241795, -9.734468273171506],
              [-18.899778919590634, -9.732375393827292],
              [-18.899313530372638, -9.730696720535144]
            ]
          ],
          [
            [
              [-18.95265480906743, -9.818718369729833],
              [-18.95183499485986, -9.818319736129935],
              [-18.950443795092742, -9.820020127804218],
              [-18.94907193907909, -9.820712510485327],
              [-18.949141460934175, -9.821900710385266],
              [-18.95226699950653, -9.822712165587983],
              [-18.953288847778918, -9.821584238632365],
              [-18.95265480906743, -9.818718369729833]
            ]
          ],
          [
            [
              [-18.963645375101386, -9.861477605645304],
              [-18.962313126269056, -9.86123362768127],
              [-18.961199736739804, -9.862713213685973],
              [-18.959890807310707, -9.86276203008132],
              [-18.95906841434767, -9.859639802468216],
              [-18.958035352920923, -9.859720659629316],
              [-18.956950179147654, -9.862242166115086],
              [-18.955702329026227, -9.862714845661328],
              [-18.95541924479528, -9.864316745458675],
              [-18.958245359577976, -9.865461432564521],
              [-18.96073777256029, -9.865159535646733],
              [-18.963748633188285, -9.862433553323056],
              [-18.963645375101386, -9.861477605645304]
            ]
          ],
          [
            [
              [-18.971400666490272, -9.868273791570202],
              [-18.970162474570127, -9.86533494231976],
              [-18.968539709796158, -9.863557711742596],
              [-18.966901043676447, -9.863309326720383],
              [-18.96443878743339, -9.867402951987499],
              [-18.96055647446468, -9.868098158556638],
              [-18.959717136235824, -9.866986540457255],
              [-18.958620990500027, -9.867356266032674],
              [-18.956176428560777, -9.87027862865601],
              [-18.955611585265306, -9.871403257352977],
              [-18.95543226760217, -9.875412980853572],
              [-18.95605778355435, -9.876497938798549],
              [-18.9551565661663, -9.878271464305469],
              [-18.954239673959005, -9.883510868570752],
              [-18.954399215812273, -9.889944687307196],
              [-18.958478204071874, -9.891084429493256],
              [-18.960730466355198, -9.890796232871066],
              [-18.964753544572847, -9.891023802522794],
              [-18.966392429418562, -9.88822626003269],
              [-18.96742555938882, -9.88877499656589],
              [-18.969429512365373, -9.887308955382139],
              [-18.971947466665032, -9.883313101655137],
              [-18.9727552044968, -9.880536790343974],
              [-18.972569560490015, -9.877194539441355],
              [-18.97086872450972, -9.875539525588877],
              [-18.971551235970853, -9.874202505975967],
              [-18.971400666490272, -9.868273791570202]
            ]
          ],
          [
            [
              [-18.983048897076454, -9.900317376062427],
              [-18.981803872508753, -9.899497485194535],
              [-18.977559948905768, -9.89994423140982],
              [-18.97466610587165, -9.899093621084708],
              [-18.97271556758519, -9.89923977396657],
              [-18.966981029893063, -9.900991850223074],
              [-18.966329579066315, -9.901714511613687],
              [-18.965887638827283, -9.905935558257513],
              [-18.96642654167137, -9.908507954478665],
              [-18.967656172047473, -9.908909313290584],
              [-18.96920648884802, -9.90767704547446],
              [-18.981824688333308, -9.903905794259275],
              [-18.983055267385325, -9.901548400526115],
              [-18.983048897076454, -9.900317376062427]
            ]
          ],
          [
            [
              [-18.98724217557778, -9.879612837483698],
              [-18.98663132871121, -9.87922941776722],
              [-18.986031795354865, -9.877100958716893],
              [-18.983710237039844, -9.874205626413485],
              [-18.98342582995906, -9.872640560029426],
              [-18.98179156827582, -9.872856592341687],
              [-18.9818613042048, -9.87461480971562],
              [-18.980936572957855, -9.875823896279806],
              [-18.98052359382555, -9.877933602081345],
              [-18.979482018718915, -9.88031735607114],
              [-18.97962434750878, -9.881100042834573],
              [-18.976387824066734, -9.886239892316661],
              [-18.97600917868671, -9.888972819503019],
              [-18.977229668853877, -9.889530684344667],
              [-18.977618742507815, -9.89055512660955],
              [-18.979946444957136, -9.89114632370838],
              [-18.980994405273773, -9.890720643541696],
              [-18.984745583928774, -9.890828206544267],
              [-18.986491027522128, -9.8895717263761],
              [-18.987330464046615, -9.885060212811936],
              [-18.987164432373092, -9.883515248154334],
              [-18.98778076074857, -9.881354034494215],
              [-18.98724217557778, -9.879612837483698]
            ]
          ],
          [
            [
              [-18.995802518304462, -9.888462487205274],
              [-18.993371643479282, -9.888149785409968],
              [-18.99227665354607, -9.886039277379846],
              [-18.991327216511138, -9.88607642332552],
              [-18.988119724239567, -9.890658341557403],
              [-18.988404821611827, -9.891249490746253],
              [-18.995870500512126, -9.89184356320918],
              [-18.996627197560464, -9.890483994137082],
              [-18.995802518304462, -9.888462487205274]
            ]
          ],
          [
            [
              [-19.21892537477608, -10.14137724103478],
              [-19.2182404130593, -10.139587795637064],
              [-19.217107499617097, -10.138014877151692],
              [-19.214896994724587, -10.137072772662473],
              [-19.215332581715302, -10.140670172891335],
              [-19.21580069215894, -10.1418898272134],
              [-19.215476989868662, -10.146971730993295],
              [-19.21457298834256, -10.14832282745659],
              [-19.21493974226073, -10.149641073721934],
              [-19.21597917744337, -10.149650227624418],
              [-19.217420246866002, -10.14854065967215],
              [-19.21892537477608, -10.14137724103478]
            ]
          ],
          [
            [
              [-18.56995802009623, -9.712101724069132],
              [-18.538269999827968, -9.716120168929494],
              [-18.542095193939204, -9.74583659123919],
              [-18.529464262678715, -9.74708556905098],
              [-18.51918536948751, -9.748683937819079],
              [-18.51231502559267, -9.749522266902833],
              [-18.516045837379803, -9.779252377575729],
              [-18.48615755779641, -9.782868321303711],
              [-18.48980641243763, -9.812603972609919],
              [-18.449281234732496, -9.817357301717296],
              [-18.379517052517976, -9.824931627745054],
              [-18.309754841773053, -9.832523393647598],
              [-18.310214554364272, -9.836885098410189],
              [-18.323682430017833, -9.83550196893154],
              [-18.327356601863652, -9.870004389664956],
              [-18.335702576647417, -9.86913932001599],
              [-18.34849004602278, -9.988285936541757],
              [-18.35680342611497, -9.987421858219001],
              [-18.369690356228304, -10.106555596837865],
              [-18.348304067528417, -10.108778324623858],
              [-18.357790547481127, -10.198140557027044],
              [-18.295563972981817, -10.204364722154946],
              [-18.295529396690142, -10.207468976711349],
              [-18.29518032806653, -10.211174722457105],
              [-18.293966755520586, -10.216838981894522],
              [-18.292075934076447, -10.223281040040929],
              [-18.289475482341373, -10.229009814794765],
              [-18.28753672675036, -10.231740965802613],
              [-18.282750728433143, -10.236025565222485],
              [-18.276399189756532, -10.239100024422273],
              [-18.27091546741931, -10.240527387926628],
              [-18.264151383542256, -10.241893483616115],
              [-18.25837520771225, -10.241584459180142],
              [-18.254503910475442, -10.239415032926859],
              [-18.252446192167636, -10.239072155496586],
              [-18.25158612341999, -10.239768594014894],
              [-18.25127323812671, -10.242132247536153],
              [-18.25315076440949, -10.243033014024892],
              [-18.253069407897865, -10.244305615385079],
              [-18.25209679413381, -10.244831292730408],
              [-18.247643608599375, -10.24543337378855],
              [-18.245874287463163, -10.246770781466306],
              [-18.24253170344993, -10.247826022390077],
              [-18.242468822533, -10.24905332124837],
              [-18.24348476979994, -10.252422409986789],
              [-18.245786836899804, -10.256166224272274],
              [-18.24769667981088, -10.25588831549054],
              [-18.255832755397414, -10.25270386751676],
              [-18.262244582700365, -10.251444654859018],
              [-18.26968900135324, -10.250899429653096],
              [-18.278737778513353, -10.252314641391637],
              [-18.288494454163335, -10.255652883782568],
              [-18.299785149066977, -10.261551253920103],
              [-18.31233005913825, -10.26725492852241],
              [-18.320624126539006, -10.268685656746783],
              [-18.32672802876187, -10.268815841910781],
              [-18.333435125292862, -10.269828708815673],
              [-18.342249471603164, -10.271793938693325],
              [-18.346151668190334, -10.27334886292604],
              [-18.355738527286068, -10.277600026412024],
              [-18.358595578990133, -10.278765089535387],
              [-18.373545960940547, -10.28696531516155],
              [-18.386808897334326, -10.296754741243978],
              [-18.39343801025299, -10.304474244928016],
              [-18.397599386100826, -10.308856051463856],
              [-18.40303843832381, -10.312771327966557],
              [-18.405218845899462, -10.313582472211811],
              [-18.430178273424357, -10.314906628241205],
              [-18.438907877003395, -10.316603060019888],
              [-18.459648599614173, -10.318356219907477],
              [-18.464924692239606, -10.320184539573974],
              [-18.470258034201084, -10.323255556198358],
              [-18.47511455763969, -10.325294752834683],
              [-18.480732789409835, -10.326924204932038],
              [-18.485757815997157, -10.327803817463781],
              [-18.490643405414996, -10.327387748958294],
              [-18.49628458516663, -10.326483676435833],
              [-18.499039131028354, -10.326562371106828],
              [-18.50204157863392, -10.32705837272488],
              [-18.504609104240213, -10.328055469719747],
              [-18.509366410592502, -10.330398100636748],
              [-18.535085359045947, -10.339677655171046],
              [-18.53767602245092, -10.3402409460358],
              [-18.547500151307677, -10.338839511287098],
              [-18.55465312762625, -10.33869703391417],
              [-18.556512457199492, -10.339144784348758],
              [-18.56330112149808, -10.33675556223445],
              [-18.574330593385923, -10.329960706878532],
              [-18.58154580674594, -10.326479755626718],
              [-18.589540429552557, -10.323733640966928],
              [-18.59687719822042, -10.322727821925163],
              [-18.60284385394854, -10.319725698845636],
              [-18.606731908966488, -10.318647875030923],
              [-18.611998718233316, -10.321068528856367],
              [-18.61404404062833, -10.322789568305891],
              [-18.619189215330696, -10.323789987426244],
              [-18.626238771485298, -10.322818149268283],
              [-18.63177569682686, -10.320536359164088],
              [-18.6310151756912, -10.317243648431486],
              [-18.629843525796126, -10.31365680053177],
              [-18.63048236520771, -10.310654308234257],
              [-18.62872828847366, -10.30720188856994],
              [-18.630235934288596, -10.303737756946227],
              [-18.634301837035142, -10.30193553587288],
              [-18.64380091932918, -10.302822612959103],
              [-18.65006527681756, -10.302559923191719],
              [-18.654506759199712, -10.30333429905099],
              [-18.658984005693807, -10.303461764461918],
              [-18.66565551758589, -10.30419483567119],
              [-18.67008146521086, -10.304151363276592],
              [-18.67306031079521, -10.302346921401956],
              [-18.675819747031866, -10.30139328232782],
              [-18.679524931624595, -10.303630108905002],
              [-18.684035954748616, -10.30777198669924],
              [-18.690475534955596, -10.312594949121037],
              [-18.69322440872947, -10.314427050639246],
              [-18.696968590878498, -10.316075494568718],
              [-18.705011839191666, -10.317400421698848],
              [-18.712627908521178, -10.317518977386339],
              [-18.718791882555834, -10.316553144272062],
              [-18.72954329247409, -10.316138145171792],
              [-18.736147832419757, -10.31718260731727],
              [-18.743052768574394, -10.322133962317944],
              [-18.749072853087107, -10.324250075798208],
              [-18.753617505701424, -10.323228556626416],
              [-18.75851222172751, -10.321674679952158],
              [-18.764753607744215, -10.320696743123495],
              [-18.769165783965992, -10.31913790825164],
              [-18.77400191063348, -10.315451277905401],
              [-18.776910884767315, -10.311819007758542],
              [-18.778835632112333, -10.311284204544584],
              [-18.781762324775993, -10.312729229077055],
              [-18.785625705448396, -10.314239247938945],
              [-18.787303656778015, -10.31214398883923],
              [-18.786361606762796, -10.306942678789225],
              [-18.78749821365927, -10.305799016931543],
              [-18.7902255798884, -10.306314303191973],
              [-18.79182762662896, -10.307553401569953],
              [-18.7909162464966, -10.31383724467319],
              [-18.791815744038924, -10.315808874960563],
              [-18.794804928312114, -10.318700062962051],
              [-18.79891017839592, -10.320570364148647],
              [-18.801857690040933, -10.32250862044743],
              [-18.80061978678646, -10.324490497686556],
              [-18.798768043750652, -10.3266265578241],
              [-18.79850103027026, -10.328391011803463],
              [-18.798984841101653, -10.329931142437198],
              [-18.800067066059828, -10.331095605095488],
              [-18.805109649803928, -10.332310697186141],
              [-18.808594504730227, -10.332062668739985],
              [-18.810882903068027, -10.33225083777787],
              [-18.813151937306987, -10.334820986301464],
              [-18.81365306098079, -10.338735526470044],
              [-18.810991549974034, -10.345145040488772],
              [-18.812006142548938, -10.348277060478615],
              [-18.815179947299832, -10.349759799899038],
              [-18.81864778332094, -10.349895299733982],
              [-18.822904219555436, -10.3523006538314],
              [-18.826570977192556, -10.352525909027644],
              [-18.830053694839535, -10.35239507824724],
              [-18.834702162691553, -10.351760047662182],
              [-18.837069033928202, -10.350155583231551],
              [-18.83851454608393, -10.347381864091497],
              [-18.839767543668597, -10.346100916065538],
              [-18.84263651198609, -10.345774851660194],
              [-18.84518028585038, -10.344260050910902],
              [-18.850291640467425, -10.340290456212117],
              [-18.854550349974865, -10.337958758222669],
              [-18.861253056750986, -10.340885715221274],
              [-18.865580792002753, -10.338363720972685],
              [-18.869523633100147, -10.335105712721722],
              [-18.873094955041175, -10.334303039108187],
              [-18.8791918887835, -10.334971651282048],
              [-18.88297693148018, -10.333636734033073],
              [-18.887354085024285, -10.331405127297366],
              [-18.88862582824559, -10.331299403775237],
              [-18.889314031477735, -10.333444266778717],
              [-18.889763434583337, -10.338491262281293],
              [-18.892382429753347, -10.342523408151264],
              [-18.893809737584114, -10.34750644677481],
              [-18.892174463677787, -10.351288861321786],
              [-18.88960849934947, -10.354945553995849],
              [-18.891009768693905, -10.358935809404251],
              [-18.89286393837844, -10.361193400125421],
              [-18.892162940257055, -10.369200825313987],
              [-18.892648847473676, -10.372300466297816],
              [-18.893567768654687, -10.375467346471872],
              [-18.891920363415462, -10.375377474584386],
              [-18.889997770825634, -10.373668265472812],
              [-18.887274959596223, -10.372211129619542],
              [-18.88369507625819, -10.375235637357921],
              [-18.883063166542886, -10.37923348596733],
              [-18.883332671278986, -10.384284505621526],
              [-18.885170892460362, -10.388104670642395],
              [-18.893332678539814, -10.390014849604798],
              [-18.899005628526805, -10.392571215668582],
              [-18.902179171171223, -10.391797011963092],
              [-18.904947243190293, -10.393743481900897],
              [-18.91429276878797, -10.401459857626234],
              [-18.91466487583104, -10.404374685189625],
              [-18.914699919309005, -10.407189186943544],
              [-18.917862956174233, -10.40909314450418],
              [-18.922940362545507, -10.411706757410718],
              [-18.924466954221554, -10.411216645319673],
              [-18.923729586354376, -10.406620293495589],
              [-18.92578009219359, -10.404571496128794],
              [-18.927412425424592, -10.401946860524436],
              [-18.929029485461086, -10.40126246463603],
              [-18.93121388297687, -10.401789438027112],
              [-18.93375848544504, -10.400876637876163],
              [-18.934995256567497, -10.401273312729932],
              [-18.9386552801574, -10.405875996396805],
              [-18.941064022649485, -10.411039658351118],
              [-18.93684339864962, -10.41562510018478],
              [-18.93667635220724, -10.417866846019134],
              [-18.93818629277742, -10.420819656423811],
              [-18.940493466431118, -10.422666602535598],
              [-18.940373898313318, -10.424701893869985],
              [-18.938872022915405, -10.427144557579993],
              [-18.93731966191322, -10.428915973756354],
              [-18.930968754001825, -10.42759065904785],
              [-18.92986866796171, -10.428947992405625],
              [-18.930278917984765, -10.432198462186758],
              [-18.93163368492599, -10.43567360545464],
              [-18.932217009768646, -10.438637722902692],
              [-18.932082544246217, -10.44093974734848],
              [-18.934053639789724, -10.446511789485852],
              [-18.938157955861357, -10.44778237719836],
              [-18.93969821615104, -10.449273900354918],
              [-18.942721266535326, -10.44998092709095],
              [-18.945745079667876, -10.450228052543778],
              [-18.94715862596119, -10.451439167028905],
              [-18.946295194989005, -10.452697402753119],
              [-18.947410339926137, -10.455117577893938],
              [-18.95016342339231, -10.456472858018293],
              [-18.955284492669108, -10.45513302403997],
              [-18.95790455389679, -10.455707657484437],
              [-18.95960835765967, -10.458031083611159],
              [-18.96119956814531, -10.459077146748795],
              [-18.963752839938095, -10.459258060393],
              [-18.967284328281455, -10.456880809225158],
              [-18.97027809865918, -10.45669005753069],
              [-18.976090576442147, -10.457645621884112],
              [-18.97866314536864, -10.459728203886192],
              [-18.980896764089767, -10.46457129904259],
              [-18.98207803945254, -10.464977680842686],
              [-18.983759859942595, -10.462402160897154],
              [-18.985278814588334, -10.46125290812911],
              [-18.987078326690533, -10.461158001629892],
              [-18.99015679029018, -10.462657518784201],
              [-18.99523100571994, -10.46283166027231],
              [-19.00120887992446, -10.464760251786922],
              [-19.008684476873515, -10.46183484801515],
              [-19.011091497611424, -10.462575553712805],
              [-19.01332974644033, -10.461878428797936],
              [-19.014911977347445, -10.458715556557852],
              [-19.013563218666455, -10.449424460096061],
              [-19.017841423378943, -10.448624879717855],
              [-19.023586556730407, -10.448586938640824],
              [-19.024017390871602, -10.451119812542649],
              [-19.02532569595188, -10.449904480486499],
              [-19.026352988686394, -10.447634769996839],
              [-19.027707316493796, -10.446113114265712],
              [-19.029930343464965, -10.444948557086681],
              [-19.03171628698396, -10.444755281752169],
              [-19.03205987719358, -10.445601256153678],
              [-19.03103161531327, -10.447270492506442],
              [-19.031902314596362, -10.448831902797592],
              [-19.03298259131159, -10.449257731357786],
              [-19.034241510949656, -10.448349455959265],
              [-19.035416996923665, -10.446354139389243],
              [-19.036742351937132, -10.445837414367793],
              [-19.039231300407213, -10.446833380909013],
              [-19.040816931723256, -10.446075788899835],
              [-19.042482539492568, -10.44400020279475],
              [-19.043594018288626, -10.443417985608578],
              [-19.045789666851658, -10.444459523016555],
              [-19.05022605201952, -10.445037717367269],
              [-19.051471010127035, -10.445836146370052],
              [-19.05355114587777, -10.446198636363386],
              [-19.056512202753947, -10.445815432236913],
              [-19.059214494936217, -10.446276518943876],
              [-19.068744073482193, -10.449527567526586],
              [-19.072381212913257, -10.450136979344594],
              [-19.077978746703003, -10.449827306199724],
              [-19.07854266846922, -10.444328326350725],
              [-19.083105706472733, -10.446172685572025],
              [-19.090707039311354, -10.449822411401321],
              [-19.09661710305318, -10.453049561064407],
              [-19.101427359263084, -10.455155051849035],
              [-19.102274916744665, -10.455286972874463],
              [-19.10497571339874, -10.453386089287944],
              [-19.10656079704881, -10.451877192262893],
              [-19.1085449413335, -10.448274431671082],
              [-19.109658688019998, -10.44444719643261],
              [-19.10955319734719, -10.442753908506521],
              [-19.110386462304255, -10.43797581188604],
              [-19.11023156330728, -10.434158448425581],
              [-19.109268583795778, -10.432425631463493],
              [-19.09898479311607, -10.424620728526392],
              [-19.094866005957574, -10.423463718516734],
              [-19.089545821192495, -10.424144704848027],
              [-19.087091085390366, -10.425983835075389],
              [-19.08582353629426, -10.424882063185565],
              [-19.08388813401504, -10.426765191959039],
              [-19.07930547055668, -10.427733362990605],
              [-19.075244962397655, -10.427288574509662],
              [-19.068877021287403, -10.42489341050592],
              [-19.067359364207466, -10.424995205622256],
              [-19.066256304586222, -10.424369074367716],
              [-19.065879912854676, -10.420701022235779],
              [-19.064844755856637, -10.417827258230528],
              [-19.065094730053648, -10.41385453537455],
              [-19.06487944098841, -10.411126773953976],
              [-19.064414788709794, -10.409638129548732],
              [-19.069195127118054, -10.407747276109383],
              [-19.071098891099307, -10.40823054660827],
              [-19.072566606607758, -10.410237328310108],
              [-19.0727468526966, -10.412005545831658],
              [-19.073517224032088, -10.41276029026808],
              [-19.0754158072491, -10.413372082722184],
              [-19.076589403338744, -10.4130982583325],
              [-19.07953232593137, -10.410956279231648],
              [-19.080455448918507, -10.410953518221188],
              [-19.084058959131692, -10.409326125292502],
              [-19.090649533483482, -10.403298050023906],
              [-19.091982215580977, -10.401827619077844],
              [-19.09234138397379, -10.399069481827825],
              [-19.091974650117194, -10.39788219356063],
              [-19.093401004361503, -10.393538196596227],
              [-19.096244983767637, -10.391655314811908],
              [-19.098748926647367, -10.388852930700569],
              [-19.100187034508465, -10.386252593951912],
              [-19.100197934760075, -10.384219903641824],
              [-19.097925756468, -10.381850398944165],
              [-19.096681543027046, -10.37971444879235],
              [-19.09679418359418, -10.378368620441934],
              [-19.09828202604445, -10.377235598917148],
              [-19.101157483581503, -10.376151124118156],
              [-19.10198468519589, -10.375188426282005],
              [-19.107377320279333, -10.374001877575731],
              [-19.108009361131465, -10.373553814820497],
              [-19.110038019059587, -10.370056866003537],
              [-19.11127877656861, -10.366934376272143],
              [-19.115601493053322, -10.361938456397366],
              [-19.11698126334517, -10.361973414978682],
              [-19.121678543142757, -10.364834683180865],
              [-19.121385339166466, -10.36671377321476],
              [-19.1217402769537, -10.368150937466448],
              [-19.123887945036856, -10.371562059475071],
              [-19.125154304751714, -10.37445974136455],
              [-19.12838094944022, -10.378638622385951],
              [-19.12918777710853, -10.380111487421567],
              [-19.12889639466494, -10.381227746857311],
              [-19.130743584890094, -10.384979553202955],
              [-19.132231414683705, -10.389339376865333],
              [-19.132846034237293, -10.389597443902357],
              [-19.13290966117825, -10.393313948621207],
              [-19.135815340981356, -10.394108932023165],
              [-19.13741059414184, -10.394159791799263],
              [-19.142053167756465, -10.393266884123635],
              [-19.145286217437185, -10.390960285028163],
              [-19.146391233001005, -10.391113743130026],
              [-19.151650171548695, -10.390030336535643],
              [-19.157832573747047, -10.387394253095097],
              [-19.160806229081455, -10.386276445352511],
              [-19.164414279088408, -10.384286320988465],
              [-19.166171057353093, -10.382174206891365],
              [-19.16743539318834, -10.381334094747755],
              [-19.169340137216473, -10.377876960683757],
              [-19.169519190352492, -10.376964072033847],
              [-19.16888382073005, -10.375010703552542],
              [-19.16898014062834, -10.373007169656077],
              [-19.169727837785956, -10.370647298631216],
              [-19.169477530827287, -10.36733461799639],
              [-19.170065028108624, -10.365679343198789],
              [-19.169683769062505, -10.363330539491987],
              [-19.170554895160116, -10.361584789687145],
              [-19.170586810071192, -10.3573995493409],
              [-19.169683723905493, -10.353957044673972],
              [-19.16942207397284, -10.351147969314214],
              [-19.168843006619024, -10.350959182949316],
              [-19.167094267082355, -10.347748590183974],
              [-19.167833525358144, -10.347169428925044],
              [-19.167873393268966, -10.345707461576792],
              [-19.168922013503792, -10.343488389366907],
              [-19.169377635646125, -10.338294416657819],
              [-19.169319878306933, -10.336121422478115],
              [-19.16789327627577, -10.33179183250613],
              [-19.167040429697167, -10.330734415424633],
              [-19.1648643302148, -10.330753384270858],
              [-19.16411291789848, -10.329499876967292],
              [-19.16236021330736, -10.328982233212978],
              [-19.159850232394874, -10.325707545116034],
              [-19.158529029613305, -10.322288081509216],
              [-19.158194492332576, -10.316474466907827],
              [-19.16009246414381, -10.315223237230333],
              [-19.162369052016444, -10.316530334961147],
              [-19.16290229290128, -10.318822433507306],
              [-19.165225799776092, -10.318698781717556],
              [-19.166133829928725, -10.313971350567323],
              [-19.16825556426313, -10.313741668467856],
              [-19.169723201611443, -10.314046360984078],
              [-19.170897449120123, -10.313233239168289],
              [-19.171818295628654, -10.313497715078771],
              [-19.173964423149613, -10.312663444015016],
              [-19.17446847017096, -10.311874154204792],
              [-19.17649136629535, -10.311098809116189],
              [-19.17989948811726, -10.308376748684747],
              [-19.183202473573623, -10.30689194645079],
              [-19.186809026308545, -10.304355993173887],
              [-19.188036525417548, -10.303218065821678],
              [-19.19087022130448, -10.302797673277015],
              [-19.193445153312776, -10.303504300148726],
              [-19.196637847488347, -10.302957815163019],
              [-19.199690757671192, -10.300331456575146],
              [-19.20108171415996, -10.29820146831073],
              [-19.20220150070166, -10.2953087799958],
              [-19.202500590246522, -10.292385241659346],
              [-19.203244686861005, -10.290389420998657],
              [-19.203651808998334, -10.287233950070215],
              [-19.20383681359068, -10.283360279773193],
              [-19.203636272329877, -10.281874334720024],
              [-19.204369064011573, -10.280483674303442],
              [-19.205148029945104, -10.277264685327939],
              [-19.205663837628872, -10.273046344893949],
              [-19.20545067949939, -10.268477476407238],
              [-19.20486891854031, -10.265721435687443],
              [-19.20325693613205, -10.263000053557478],
              [-19.19661350203869, -10.261437207767946],
              [-19.193715348672672, -10.260137321457407],
              [-19.19182986328091, -10.25898333897363],
              [-19.19065152485803, -10.258900286979095],
              [-19.184074746293067, -10.25638521268596],
              [-19.180206555662856, -10.256467992824302],
              [-19.176425356518273, -10.254636800261128],
              [-19.175535106628246, -10.253841333228593],
              [-19.1755966555564, -10.252318389586197],
              [-19.172202236147964, -10.247631609296553],
              [-19.172295926071282, -10.24617328464413],
              [-19.171676898004115, -10.244730841314562],
              [-19.172782063493564, -10.242253023863563],
              [-19.172427968654688, -10.240739365199655],
              [-19.173793633748083, -10.238378699263189],
              [-19.175896944767164, -10.236623297024641],
              [-19.17467886818758, -10.235056317412505],
              [-19.17683301154788, -10.232835040346584],
              [-19.178251883178472, -10.231808101795446],
              [-19.179768392111967, -10.229669238532098],
              [-19.179414841270688, -10.228215214228324],
              [-19.180980633994807, -10.227405164742853],
              [-19.182062068763262, -10.227611511494723],
              [-19.18375374427078, -10.226873554282555],
              [-19.18507441545484, -10.227404944524377],
              [-19.186081418163127, -10.225445924179375],
              [-19.187122145404697, -10.225320376788067],
              [-19.189478029313054, -10.223494145682405],
              [-19.18940850631424, -10.222729809935936],
              [-19.191405780043866, -10.221474108959534],
              [-19.19201526169133, -10.220087772982737],
              [-19.193690342788, -10.219309488137784],
              [-19.195302325599798, -10.217351151273297],
              [-19.1962122187474, -10.217794316165994],
              [-19.198679082900433, -10.216357158869721],
              [-19.200471470774332, -10.216715849173967],
              [-19.201713449261, -10.215965944718935],
              [-19.206053235312073, -10.216763370794853],
              [-19.20724383098379, -10.218144167299494],
              [-19.208472165094758, -10.21865011783845],
              [-19.20917461597905, -10.219917869911212],
              [-19.213850977815717, -10.220617373427675],
              [-19.217576784839324, -10.220747963925392],
              [-19.220748120225693, -10.220257111837958],
              [-19.2230529782074, -10.220667069483738],
              [-19.225477671371355, -10.224080953486224],
              [-19.226541351753568, -10.224165125995365],
              [-19.228137575812003, -10.225681664065464],
              [-19.228067140399673, -10.226475852269148],
              [-19.225017746368692, -10.228817701253229],
              [-19.223582026455134, -10.230373860076423],
              [-19.22666679067659, -10.23316006765451],
              [-19.22829226371394, -10.2327255606108],
              [-19.2329982231462, -10.227866203449597],
              [-19.23498562238435, -10.224854292769724],
              [-19.234444963669567, -10.222940079527184],
              [-19.234491551863606, -10.220075548976121],
              [-19.235092557184043, -10.216057715047057],
              [-19.236313897710794, -10.20352769445641],
              [-19.236076671801833, -10.19637258162387],
              [-19.235543550234908, -10.194093064443894],
              [-19.23330272649822, -10.187977057851624],
              [-19.230768514420312, -10.182031142637362],
              [-19.228491997758532, -10.174481446295253],
              [-19.226614493998955, -10.167129223412314],
              [-19.22524598678442, -10.163576411445506],
              [-19.22401603388495, -10.161047477560345],
              [-19.22273291962904, -10.159458147305163],
              [-19.221882376577785, -10.15992979128608],
              [-19.223797389401135, -10.16405833284317],
              [-19.22759800395099, -10.173775988245863],
              [-19.22806057335937, -10.178430885682527],
              [-19.22931699316864, -10.181277984151365],
              [-19.229174396007007, -10.182435422599422],
              [-19.227534850611633, -10.183726693758366],
              [-19.2263752359269, -10.184093917098837],
              [-19.222060776256356, -10.183714662562446],
              [-19.217946966689563, -10.184003327641703],
              [-19.214042932261798, -10.184569227528629],
              [-19.21137672163634, -10.184727777201822],
              [-19.207311522230665, -10.183640712146516],
              [-19.20474040615534, -10.18320174618402],
              [-19.195976536490416, -10.182175031926704],
              [-19.19256514892374, -10.182308178347562],
              [-19.19083245733365, -10.181480727184889],
              [-19.18573196918356, -10.181078239255562],
              [-19.178598703130113, -10.181156875537908],
              [-19.171820228346725, -10.180813760122504],
              [-19.166929736388933, -10.179687222368074],
              [-19.165100434596383, -10.179466553075867],
              [-19.16343571658509, -10.179760265165168],
              [-19.161279754629003, -10.18152647039641],
              [-19.160158360046122, -10.180852598049862],
              [-19.16040509980701, -10.178472959653197],
              [-19.161842232189983, -10.177150685471116],
              [-19.16715238223006, -10.174946116297459],
              [-19.169403487524253, -10.175023194365355],
              [-19.173290876773358, -10.174225947348686],
              [-19.176790252149633, -10.174720162554209],
              [-19.177025757438148, -10.172800228380702],
              [-19.1752604345029, -10.172321971492803],
              [-19.1764596300415, -10.169495933506454],
              [-19.179486765317442, -10.169234726915876],
              [-19.180408243480564, -10.169901924036749],
              [-19.18220077942447, -10.168790642753425],
              [-19.184896768691356, -10.168395466006926],
              [-19.188909275429356, -10.165798877226958],
              [-19.19045448583988, -10.164309266885681],
              [-19.19152143365118, -10.162555071266974],
              [-19.190864569579617, -10.160988115225242],
              [-19.19048516782695, -10.158721322957096],
              [-19.19261156873472, -10.159210573145327],
              [-19.195145498383216, -10.159196117254933],
              [-19.196997413978746, -10.158093326211524],
              [-19.19799676949592, -10.15879787119888],
              [-19.19916228030955, -10.158152357440544],
              [-19.199735385991097, -10.156832410848592],
              [-19.199092493084542, -10.153764204554298],
              [-19.200764130838795, -10.149800274142684],
              [-19.201680328285743, -10.146746478596727],
              [-19.202782453411057, -10.145090943406288],
              [-19.202681076654432, -10.141743192806409],
              [-19.204280028583984, -10.140599409662295],
              [-19.204679343303244, -10.137665077426325],
              [-19.206799834624814, -10.133833758309535],
              [-19.207357160289764, -10.130415169787009],
              [-19.208652671158635, -10.129909963104428],
              [-19.20862793677885, -10.128085234147058],
              [-19.208056794660973, -10.124877020785883],
              [-19.206986449832957, -10.12336741004604],
              [-19.205218014083847, -10.123582781409892],
              [-19.202616026866682, -10.125210718861995],
              [-19.200248056338516, -10.124237932555786],
              [-19.19911360295533, -10.124491704148145],
              [-19.197611864977354, -10.123668859425168],
              [-19.19349469025547, -10.123775498271991],
              [-19.189115064446526, -10.123342592234245],
              [-19.187956707480833, -10.12374782436218],
              [-19.185858750860998, -10.123591892239332],
              [-19.177964426021436, -10.123675286542746],
              [-19.175374006750236, -10.12530573874707],
              [-19.171963235745732, -10.125387980979394],
              [-19.170029203211175, -10.127404261461894],
              [-19.16370107953456, -10.127084704322222],
              [-19.15891642285943, -10.127707052940064],
              [-19.157303911579657, -10.130124290234736],
              [-19.157223375095164, -10.133174500824401],
              [-19.1556229281811, -10.132905180939355],
              [-19.1523606009253, -10.129628636350342],
              [-19.151337188770373, -10.129829990911407],
              [-19.14880720755995, -10.127676200622165],
              [-19.148309155144897, -10.125774481581436],
              [-19.14681610694593, -10.125023396016342],
              [-19.141947211307254, -10.124476521857774],
              [-19.137368475920738, -10.12469614221447],
              [-19.135082416362128, -10.125482031788515],
              [-19.132851184840657, -10.125173524685053],
              [-19.13101298976064, -10.125636329469692],
              [-19.128537958133897, -10.126894352209602],
              [-19.126689449108504, -10.124341858894105],
              [-19.13335318867584, -10.11239782704688],
              [-19.13509105668958, -10.108397173362638],
              [-19.134592070718643, -10.104835055057492],
              [-19.13709803208052, -10.099989027280001],
              [-19.139054933526715, -10.094928577203849],
              [-19.13981723583821, -10.090186579432974],
              [-19.140621846190587, -10.0825921164839],
              [-19.141186311893975, -10.07528426101133],
              [-19.140919372292398, -10.069499528359774],
              [-19.140124568583634, -10.065996513051719],
              [-19.139594699689155, -10.061143565963956],
              [-19.138549966994365, -10.06015330675257],
              [-19.138093815405472, -10.05788398084566],
              [-19.138745722459063, -10.056907804005542],
              [-19.13401763230195, -10.046859965184364],
              [-19.13457015384335, -10.045436332986295],
              [-19.131172938738263, -10.04040487442404],
              [-19.129439965630077, -10.039107319323051],
              [-19.127769702728624, -10.038745511786296],
              [-19.128110725569734, -10.0359027121321],
              [-19.126087450279176, -10.034687041913205],
              [-19.12513170346883, -10.032778852085464],
              [-19.123795421662393, -10.031523187248304],
              [-19.123415777474307, -10.030112090186151],
              [-19.121243856725947, -10.02912556049573],
              [-19.11911325343469, -10.025020054257059],
              [-19.117545471946418, -10.023621417079868],
              [-19.117606092749345, -10.021139350134149],
              [-19.114882908025894, -10.018163281728688],
              [-19.112794611583432, -10.017500967572252],
              [-19.111638409653395, -10.016481585327622],
              [-19.11002723080377, -10.01698334542889],
              [-19.108715792958233, -10.015428893552233],
              [-19.105544192730086, -10.012597038442221],
              [-19.105063840965116, -10.010844729151325],
              [-19.10017341508592, -10.00703204313857],
              [-19.093724291503605, -9.999919210736644],
              [-19.090048932290845, -9.995569756416613],
              [-19.08753616218023, -9.993127527610906],
              [-19.085505182191213, -9.991515686604608],
              [-19.08505471758527, -9.990525035774132],
              [-19.07662320584363, -9.982851212261686],
              [-19.073050745557165, -9.979834268681575],
              [-19.06928544635756, -9.976099056284784],
              [-19.06591180390329, -9.972279185398103],
              [-19.05924868813536, -9.964425859107648],
              [-19.057993380944335, -9.962800374688724],
              [-19.05511302434047, -9.959961596477818],
              [-19.054424068325382, -9.959595185869535],
              [-19.050562340812338, -9.960298590801287],
              [-19.04908556699518, -9.95946793443658],
              [-19.0476678005556, -9.955558099842774],
              [-19.044670732262304, -9.948894097049926],
              [-19.040021023710363, -9.942011648521797],
              [-19.0372612875889, -9.938578172355294],
              [-19.03271943639655, -9.933728951031956],
              [-19.03059122615258, -9.93225835342436],
              [-19.023083588115263, -9.924590881243716],
              [-19.019685666601816, -9.922136080856792],
              [-19.013805712714834, -9.91855281023023],
              [-19.003881971200283, -9.910972084617635],
              [-18.99920883791685, -9.908144141575924],
              [-18.996869394719536, -9.906943792936561],
              [-18.993141136540686, -9.906003825745813],
              [-18.989627851551855, -9.90686324347554],
              [-18.97926873589651, -9.912419238963741],
              [-18.973489262396484, -9.913280071309511],
              [-18.965513143086852, -9.912779222426625],
              [-18.96286249047188, -9.913681513272325],
              [-18.96300176879758, -9.917036231907781],
              [-18.96577043155535, -9.920337019001998],
              [-18.969899585431456, -9.925577956537213],
              [-18.970382221491974, -9.9273518746338],
              [-18.96859963581418, -9.93385661538653],
              [-18.965993608807363, -9.933651350728303],
              [-18.963125188767812, -9.925941962578309],
              [-18.95696924440341, -9.920096691493354],
              [-18.953531599354847, -9.915842398362187],
              [-18.95231958555059, -9.913103049074076],
              [-18.9537679763818, -9.910356265779301],
              [-18.96107514880351, -9.90995663365757],
              [-18.963440502929988, -9.907710536568045],
              [-18.96314346386673, -9.903239397282949],
              [-18.96202605358977, -9.900501573336625],
              [-18.951182870669907, -9.895832036226292],
              [-18.947790800318746, -9.895209859878143],
              [-18.9465739441319, -9.891841021595226],
              [-18.94736350985179, -9.88926073250137],
              [-18.949705131302856, -9.888461682810172],
              [-18.951181648045665, -9.887111866506611],
              [-18.951591646898322, -9.884327043681948],
              [-18.953215279359217, -9.876587590435639],
              [-18.953428689293855, -9.874204761331898],
              [-18.9533455614052, -9.870201621160055],
              [-18.953005133053047, -9.865495704867781],
              [-18.953152617047625, -9.860042200684894],
              [-18.952874772934468, -9.856418557333553],
              [-18.954701436289945, -9.85616017424565],
              [-18.95573256664184, -9.852993532713597],
              [-18.95555799012103, -9.852295981314285],
              [-18.956356585058032, -9.849702568871265],
              [-18.95576635094208, -9.847679285308585],
              [-18.95585653364293, -9.844076194589704],
              [-18.954112838627594, -9.844703365378644],
              [-18.954361304174398, -9.84204872150311],
              [-18.953990894460482, -9.840182102634381],
              [-18.952307836354336, -9.839902587339973],
              [-18.951978401890518, -9.83804857902679],
              [-18.952587838007883, -9.835488484338347],
              [-18.952016760267945, -9.832417817362645],
              [-18.952904045610264, -9.830596210252555],
              [-18.953108044614588, -9.828600356579642],
              [-18.952364190743637, -9.825653849768537],
              [-18.949309583922656, -9.823941134436586],
              [-18.94818108183337, -9.823743408661587],
              [-18.94455104930222, -9.824674953313567],
              [-18.943562267005422, -9.822664502838595],
              [-18.94459947361815, -9.820821086775991],
              [-18.946707645862265, -9.819641809370385],
              [-18.94727954722117, -9.817778510706479],
              [-18.949006971517775, -9.816279778698721],
              [-18.948469643107877, -9.814103053366543],
              [-18.947455053063035, -9.813202331757287],
              [-18.947583792436664, -9.81190690031219],
              [-18.94692895364452, -9.80914144094457],
              [-18.944653686598024, -9.805518163024852],
              [-18.943738861832998, -9.80543844252177],
              [-18.94344245144652, -9.803205743121909],
              [-18.94170307038885, -9.80071356569887],
              [-18.941481224566775, -9.799244805921745],
              [-18.940041172778855, -9.796728155737885],
              [-18.93939951040737, -9.794178472890056],
              [-18.938204479916514, -9.791690724690495],
              [-18.937566970705788, -9.789023630229677],
              [-18.93541082346596, -9.78377630890048],
              [-18.933400660196522, -9.780174934167524],
              [-18.932968027707084, -9.778901826203818],
              [-18.930560003599503, -9.774400693778638],
              [-18.929306832657783, -9.772727655291307],
              [-18.926680230912908, -9.771067829575857],
              [-18.92604016612517, -9.76882329198766],
              [-18.92504300800779, -9.766958348202989],
              [-18.92282135342242, -9.764042204473325],
              [-18.92146396265441, -9.762920156084306],
              [-18.92046069698161, -9.761432681621168],
              [-18.919143168832754, -9.760622909614092],
              [-18.918141865698985, -9.758231246851798],
              [-18.914374327760427, -9.754279281520745],
              [-18.90988454233396, -9.751105940303585],
              [-18.908761567590812, -9.751002008917242],
              [-18.904992511130164, -9.748714260715012],
              [-18.903524579874272, -9.7498735598457],
              [-18.89914609180689, -9.750721266737745],
              [-18.89796317613571, -9.751645542672074],
              [-18.89537087491236, -9.751528210308736],
              [-18.890509873832134, -9.752222039896711],
              [-18.886005398234563, -9.751120830316056],
              [-18.884273342608147, -9.747958880423523],
              [-18.884852969413235, -9.74718806211223],
              [-18.88476787731868, -9.744786479999998],
              [-18.882413155097893, -9.74411998373879],
              [-18.884442289738555, -9.742310370917156],
              [-18.885466730661737, -9.742054252101816],
              [-18.887943830978813, -9.740079257338628],
              [-18.890845164760023, -9.736461802988781],
              [-18.889352593520254, -9.734237965370395],
              [-18.88677716166922, -9.73360871294858],
              [-18.887145180247224, -9.731779198769125],
              [-18.886673519888774, -9.729931768820114],
              [-18.88489350527442, -9.729158291177411],
              [-18.88654038341723, -9.726543539664],
              [-18.887803050090213, -9.725891968359788],
              [-18.88801980841331, -9.723372003694449],
              [-18.888663233245907, -9.722422771259717],
              [-18.888417971593746, -9.720918204168925],
              [-18.889098077628677, -9.719379846969364],
              [-18.88875417176192, -9.717853426517944],
              [-18.886476574701575, -9.715843283757238],
              [-18.886326883438155, -9.713797452365123],
              [-18.885758350170615, -9.712871933865951],
              [-18.883283346195896, -9.711777402123035],
              [-18.88055392559988, -9.712151950120498],
              [-18.880382168608637, -9.709896384035162],
              [-18.878206921050523, -9.708571449705591],
              [-18.871132266784468, -9.702149312977541],
              [-18.868838114755388, -9.700823018689047],
              [-18.867389270032717, -9.699092140455411],
              [-18.863363414479238, -9.696011343778533],
              [-18.86037882844967, -9.694057596392991],
              [-18.856635410868897, -9.691106202814805],
              [-18.853314450045346, -9.68990708023744],
              [-18.85306437129734, -9.689213135614171],
              [-18.848893237559416, -9.68675152153378],
              [-18.8412879731069, -9.684125677461935],
              [-18.8396413434364, -9.68435291087584],
              [-18.837552713067833, -9.68382151344038],
              [-18.83490340465894, -9.683686156197044],
              [-18.832691281634766, -9.68440077536337],
              [-18.82910792355893, -9.684007006733108],
              [-18.82677835403451, -9.684077535798261],
              [-18.82122727924247, -9.683253891546087],
              [-18.81847559792826, -9.682213613252449],
              [-18.816872425326327, -9.683024213467679],
              [-18.81262921033751, -9.68360762851606],
              [-18.811961346512845, -9.683022738920329],
              [-18.805692976665735, -9.683210842939548],
              [-18.80139697976248, -9.683528277001875],
              [-18.798935073296818, -9.684460019943538],
              [-18.798156689184694, -9.683869313946346],
              [-18.794122581682444, -9.685738193012062],
              [-18.791576749568335, -9.687556566924407],
              [-18.791371327236362, -9.68819492532524],
              [-18.789284737017642, -9.688750361703544],
              [-18.787893079575262, -9.690511262955328],
              [-18.786177608315228, -9.690638433452186],
              [-18.785752150014545, -9.691578747589492],
              [-18.782313605510197, -9.694541722378851],
              [-18.78056720770235, -9.69671080918652],
              [-18.77922362974335, -9.697565596552568],
              [-18.778360162162787, -9.697161329077925],
              [-18.776630134080108, -9.69878192128435],
              [-18.774953718332, -9.701296483525649],
              [-18.77410011769898, -9.702021707857973],
              [-18.772776272816476, -9.701984331631593],
              [-18.772181199954183, -9.702829266963837],
              [-18.76771764771072, -9.702438628811466],
              [-18.765828147487497, -9.703676669379947],
              [-18.766754121008688, -9.705314086923925],
              [-18.765635896291172, -9.706545938636248],
              [-18.764292938442676, -9.7070427664911],
              [-18.761018813934733, -9.706267865806973],
              [-18.759692727400804, -9.705441404735744],
              [-18.754861095692817, -9.706550051742845],
              [-18.751373032107175, -9.708499928313227],
              [-18.75067280097863, -9.710903801513293],
              [-18.751554586489632, -9.711732029958965],
              [-18.752182824656067, -9.713401509288195],
              [-18.750268618278305, -9.71574271574975],
              [-18.75002806584639, -9.717330828718199],
              [-18.747888896438383, -9.717761196320382],
              [-18.74646085398481, -9.719676137207383],
              [-18.74527104759932, -9.722939836688608],
              [-18.745661687498423, -9.725481145696616],
              [-18.74475347508358, -9.72553178263603],
              [-18.744467699019765, -9.727379182667752],
              [-18.742630806096145, -9.727495663585954],
              [-18.738971599088945, -9.732755366723053],
              [-18.7375180900023, -9.734271643904018],
              [-18.73726331474145, -9.73562169119755],
              [-18.739206332019492, -9.73825147530859],
              [-18.739872309942267, -9.741723035099277],
              [-18.738160487762425, -9.742964618025164],
              [-18.736558315657284, -9.74007768837272],
              [-18.734290369602896, -9.738450978982844],
              [-18.73336731635668, -9.736819176347199],
              [-18.733187313377382, -9.734573728853935],
              [-18.73130512018404, -9.734120382802361],
              [-18.731069283117076, -9.737035858899846],
              [-18.7298546205476, -9.739592971534226],
              [-18.728057278826554, -9.738153598586006],
              [-18.72366996309055, -9.73940589439478],
              [-18.723130579375304, -9.740120743156838],
              [-18.723016193058758, -9.74367981829649],
              [-18.724142613182046, -9.74534523242764],
              [-18.726720273648468, -9.746893544740441],
              [-18.726389253499878, -9.74928858719192],
              [-18.7215432941922, -9.748306551091565],
              [-18.720772330353626, -9.747702223608071],
              [-18.71781728190073, -9.748365688734959],
              [-18.717034613997495, -9.750148051950637],
              [-18.719117397553273, -9.751167644393838],
              [-18.718561850480516, -9.75229843276405],
              [-18.716221016285616, -9.753518781234694],
              [-18.714711047888088, -9.755593435610672],
              [-18.712434753291763, -9.757242103901714],
              [-18.710920033317826, -9.75696416486892],
              [-18.710691266837827, -9.75785825326441],
              [-18.709137638286652, -9.759229193290306],
              [-18.709692962944047, -9.761420699120633],
              [-18.70694106387018, -9.762769065667626],
              [-18.70392729229036, -9.766897872341545],
              [-18.703920260899555, -9.76798276499481],
              [-18.702388208163836, -9.76978421039288],
              [-18.701834746268947, -9.771423363693737],
              [-18.70204479191497, -9.772541070600312],
              [-18.70327598077425, -9.773968222746184],
              [-18.703352988660892, -9.775425205263462],
              [-18.70095940920521, -9.776547254780114],
              [-18.701154858619248, -9.778631389807888],
              [-18.700361435045984, -9.779720905351597],
              [-18.696387359959726, -9.777715273250015],
              [-18.69381248760638, -9.777245499398495],
              [-18.692210598161715, -9.777599770207841],
              [-18.69119794128875, -9.776893454684737],
              [-18.689313382804695, -9.777662989986315],
              [-18.68703062774736, -9.777904068085482],
              [-18.683561893484917, -9.777818863512632],
              [-18.681636253474938, -9.77896905368164],
              [-18.6805803313184, -9.7776846432821],
              [-18.679155857060238, -9.777147178647743],
              [-18.676276005021048, -9.776924824552621],
              [-18.671076154333065, -9.777071240405888],
              [-18.6683397391898, -9.777550559064974],
              [-18.661764603082723, -9.777401593928568],
              [-18.655349946657967, -9.776448481376203],
              [-18.65397446382889, -9.776108253032877],
              [-18.65088727669088, -9.774646143933218],
              [-18.64966603438512, -9.77328805804216],
              [-18.64811278493036, -9.770769383768707],
              [-18.646143289781474, -9.769367350515617],
              [-18.644450054412957, -9.767362447729155],
              [-18.640080507559027, -9.762843217488122],
              [-18.637678525154975, -9.76001262722514],
              [-18.635857902347787, -9.758755677157525],
              [-18.630602309770516, -9.757596840148304],
              [-18.627777966249297, -9.756459558945473],
              [-18.62139058614849, -9.751147138851552],
              [-18.620433100310198, -9.750787234595283],
              [-18.616386214516922, -9.747432756785967],
              [-18.614609883129546, -9.744752850134802],
              [-18.614029619135916, -9.741872084972389],
              [-18.613986902106458, -9.736414508727876],
              [-18.613220631163436, -9.73397210920998],
              [-18.61182336965587, -9.731744465631747],
              [-18.609558697498134, -9.730061168269401],
              [-18.606978548708703, -9.728993576335903],
              [-18.600980868336038, -9.727184778661467],
              [-18.5980918393056, -9.729266679601412],
              [-18.594505289706582, -9.730089594405316],
              [-18.59033510589877, -9.729230783269122],
              [-18.5847673618828, -9.726646595363999],
              [-18.5824152602982, -9.72441154812138],
              [-18.58065603828206, -9.722146703499682],
              [-18.578423266428874, -9.720316913961263],
              [-18.573424461981876, -9.714991486363065],
              [-18.572368149036407, -9.714548906189798],
              [-18.56995802009623, -9.712101724069132]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -163.38119160800807, "lat": 62.1546657668918 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02158"],
        "coty_name": ["Kusilvak"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Kusilvak Census Area"],
        "coty_fp_code": "158",
        "coty_gnis_code": "01419985"
      },
      "bbox": [
        -19.236313897710794, -10.464977680842686, -18.242468822533,
        -9.682213613252449
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-13.270375247431678, -11.378206341822466],
              [-13.268981485184915, -11.377381236688741],
              [-13.268412598430135, -11.379077896559822],
              [-13.269890359944448, -11.379083845758284],
              [-13.270375247431678, -11.378206341822466]
            ]
          ],
          [
            [
              [-13.276039925374844, -11.377821320573158],
              [-13.275104591652891, -11.376909890313636],
              [-13.273930137655174, -11.37742441161737],
              [-13.272759353130002, -11.379067768530804],
              [-13.273824143549522, -11.38002135452045],
              [-13.276039925374844, -11.377821320573158]
            ]
          ],
          [
            [
              [-13.258341279225032, -11.509407782453021],
              [-13.25727067587828, -11.50963494787472],
              [-13.25598409310217, -11.511647227659887],
              [-13.2566397612309, -11.512196746415984],
              [-13.258198849380433, -11.510397945408176],
              [-13.258341279225032, -11.509407782453021]
            ]
          ],
          [
            [
              [-13.261911182770609, -11.530367185794464],
              [-13.260090986499149, -11.529455290638378],
              [-13.258866219073859, -11.529728882402482],
              [-13.257298368098725, -11.52849379067166],
              [-13.25694036184849, -11.525723108475608],
              [-13.256195032266564, -11.524845070803618],
              [-13.253939758558571, -11.523793058416441],
              [-13.24943441717205, -11.525152500898889],
              [-13.248688013598992, -11.526669704694958],
              [-13.24977900160724, -11.528394395324836],
              [-13.252484366006938, -11.529329742919943],
              [-13.254919595656045, -11.528754771953997],
              [-13.255452207829151, -11.5304193411381],
              [-13.256978812209095, -11.530835111926176],
              [-13.25807877059856, -11.532609144492325],
              [-13.258750246519506, -11.530877889652379],
              [-13.2618151656879, -11.531237845640206],
              [-13.261911182770609, -11.530367185794464]
            ]
          ],
          [
            [
              [-13.382923993427823, -11.262370025634413],
              [-13.382015581092576, -11.262268254722303],
              [-13.38014833101825, -11.264509456974022],
              [-13.380990240020129, -11.26510043961642],
              [-13.38218795324824, -11.264179378689915],
              [-13.382923993427823, -11.262370025634413]
            ]
          ],
          [
            [
              [-13.295252494715305, -11.541663953671058],
              [-13.294498767249909, -11.540451329619605],
              [-13.29264389295775, -11.5409950319447],
              [-13.292907116850607, -11.542026961773646],
              [-13.294302637785073, -11.54255009414573],
              [-13.295252494715305, -11.541663953671058]
            ]
          ],
          [
            [
              [-13.459157877136928, -11.141618726294945],
              [-13.458952821867067, -11.140819920628118],
              [-13.456626603745368, -11.1409632071589],
              [-13.455153851303116, -11.142199880505471],
              [-13.452038335261776, -11.143334657747445],
              [-13.453020032749784, -11.144606898189126],
              [-13.455737455208668, -11.14426529141971],
              [-13.458883804957551, -11.142175244822237],
              [-13.459157877136928, -11.141618726294945]
            ]
          ],
          [
            [
              [-13.42191909505827, -11.299174264895003],
              [-13.420684856917113, -11.29818549539388],
              [-13.421719939054361, -11.296883371526954],
              [-13.420080523517733, -11.296418291557204],
              [-13.418564593484552, -11.297895165801139],
              [-13.415805198013564, -11.301166645695362],
              [-13.413743070940635, -11.304610951761543],
              [-13.41308213781309, -11.305194118858271],
              [-13.412864200286524, -11.30717083787025],
              [-13.413550919469415, -11.307524766258892],
              [-13.416188503859129, -11.305792897226052],
              [-13.417149101021195, -11.304141284624095],
              [-13.421546406077473, -11.30003282086186],
              [-13.42191909505827, -11.299174264895003]
            ]
          ],
          [
            [
              [-13.423897436126069, -11.310520051073427],
              [-13.422951327407631, -11.306601720579271],
              [-13.421776892447076, -11.30702516493713],
              [-13.42227113787855, -11.308991069784781],
              [-13.423897436126069, -11.310520051073427]
            ]
          ],
          [
            [
              [-13.357270501040915, -11.362873784771619],
              [-13.35652198562358, -11.362389178951007],
              [-13.354884523985024, -11.360002272311268],
              [-13.352826291100538, -11.360053558719631],
              [-13.350861548511524, -11.359386103427193],
              [-13.348991581588004, -11.359730088573532],
              [-13.34741668331033, -11.359465764796333],
              [-13.345561460725698, -11.3599075695407],
              [-13.343183010042416, -11.35934174699499],
              [-13.339282373737895, -11.357918459937943],
              [-13.3387404608027, -11.358121092340923],
              [-13.336577572945487, -11.355750874766663],
              [-13.334373058166477, -11.355378218790635],
              [-13.333496019509603, -11.354725520643939],
              [-13.329274723558392, -11.354272978362667],
              [-13.323954438444014, -11.354124336908184],
              [-13.323008656463042, -11.353823136074023],
              [-13.319476458331081, -11.353867810528781],
              [-13.316637684488613, -11.352681433279761],
              [-13.315482885912806, -11.353296330720664],
              [-13.312494951921026, -11.353559860741804],
              [-13.310184414052111, -11.354788729816967],
              [-13.30743905185329, -11.357752423429888],
              [-13.306609384104934, -11.35781490188021],
              [-13.303328587515209, -11.35995214278363],
              [-13.298199133576576, -11.364919978833543],
              [-13.295276361827716, -11.36468735091794],
              [-13.29354558740969, -11.365164439536734],
              [-13.289985525581674, -11.366696136656978],
              [-13.287458004941765, -11.36870045221076],
              [-13.284662139896007, -11.37193290554857],
              [-13.28303778196493, -11.374368617922476],
              [-13.282427777866022, -11.376051040563663],
              [-13.281243546261372, -11.377596031480815],
              [-13.280220074271677, -11.379944539285805],
              [-13.279019086033554, -11.380968062238852],
              [-13.278880516184524, -11.382238851091076],
              [-13.27713670129428, -11.384027949134422],
              [-13.275088425468514, -11.385014136246676],
              [-13.273206304986273, -11.388498678068133],
              [-13.272024668028253, -11.391315686701297],
              [-13.269209361603728, -11.395301703148197],
              [-13.268597078657285, -11.396845256072204],
              [-13.26874771462375, -11.39882274405577],
              [-13.268337179452178, -11.400620040404494],
              [-13.26674572614642, -11.401661117662934],
              [-13.26444703743478, -11.401956602805887],
              [-13.261637596706166, -11.404488664589293],
              [-13.260546253653064, -11.40489056280101],
              [-13.260320117867858, -11.406136051418873],
              [-13.258809551623681, -11.405931979561386],
              [-13.255114765797408, -11.40624773082046],
              [-13.251547545484588, -11.406038704081181],
              [-13.24521604052332, -11.40451116450244],
              [-13.242770683093111, -11.404380043665206],
              [-13.240514084042406, -11.40539322612757],
              [-13.23963829845162, -11.406570913970036],
              [-13.237395866702684, -11.407965965636842],
              [-13.236477205154658, -11.409695933767681],
              [-13.233067965781371, -11.411137888373483],
              [-13.232090366441758, -11.41233011104439],
              [-13.230924343137387, -11.412376708232694],
              [-13.228016978919594, -11.413320370068606],
              [-13.226002502827333, -11.41530923649591],
              [-13.224492552896708, -11.418358770845465],
              [-13.223283323109294, -11.419665560198196],
              [-13.220244112667656, -11.421700290858412],
              [-13.218300248765578, -11.42574457139823],
              [-13.214725253224339, -11.426377806821103],
              [-13.211005358518593, -11.427577318657484],
              [-13.207040022002687, -11.426805582427285],
              [-13.20643391747437, -11.42760093936272],
              [-13.206735556360234, -11.431245008806384],
              [-13.2051484700605, -11.431957257866975],
              [-13.202537350820776, -11.431437137537614],
              [-13.200805573653874, -11.432149229870417],
              [-13.19943516954686, -11.431796638635996],
              [-13.198597703329288, -11.432422113053196],
              [-13.19634661041972, -11.432538532802372],
              [-13.194339572289042, -11.433491560418176],
              [-13.192131831352475, -11.433196146802159],
              [-13.191017792472485, -11.435197942146635],
              [-13.190826924104552, -11.437596787356272],
              [-13.191330593314937, -11.438802682706555],
              [-13.190995895285107, -11.440918553143348],
              [-13.189780943420562, -11.44236813916568],
              [-13.186630796948139, -11.443279850995255],
              [-13.185718138803983, -11.444970489715764],
              [-13.184039974455416, -11.446363570358574],
              [-13.182475177842074, -11.448836777782004],
              [-13.18033464368763, -11.449605072789033],
              [-13.179469381122363, -11.448468789361623],
              [-13.177331148759441, -11.448099920718764],
              [-13.174190156724379, -11.449961869596027],
              [-13.17318018020385, -11.449109183449892],
              [-13.172951881738747, -11.447801741514144],
              [-13.17085203449418, -11.449293840513205],
              [-13.169600108957018, -11.45267648066552],
              [-13.169554276314463, -11.453657359932185],
              [-13.168347629440522, -11.456059945936543],
              [-13.170107027159807, -11.458392225548007],
              [-13.170494408648104, -11.459800262098936],
              [-13.172039672956855, -11.461208358951618],
              [-13.172153706257628, -11.462004849256074],
              [-13.174551437170356, -11.464450793127364],
              [-13.174982667097197, -11.466157494517432],
              [-13.176300134888546, -11.465972060649285],
              [-13.176731783655603, -11.467536706308769],
              [-13.177945536795923, -11.469072679217573],
              [-13.179030668139028, -11.469569844076211],
              [-13.179274362766463, -11.47140528277217],
              [-13.181258055627127, -11.471388792233936],
              [-13.184673629969197, -11.472551517804185],
              [-13.184976431937624, -11.474216383308914],
              [-13.1863654893651, -11.475808155819788],
              [-13.186639322680247, -11.4778432506604],
              [-13.187478940924327, -11.4789234417285],
              [-13.18688460846529, -11.479821508436414],
              [-13.185058912608948, -11.480792458025281],
              [-13.185884290584044, -11.48148889561152],
              [-13.189737673069486, -11.482222376957871],
              [-13.19156306090367, -11.483670846200878],
              [-13.19224398918546, -11.485933711142586],
              [-13.192215180277389, -11.487158179060083],
              [-13.194475972880499, -11.488036125060077],
              [-13.193563840637236, -11.490445237531267],
              [-13.195072202247134, -11.49240742622799],
              [-13.197254161494204, -11.49338774994162],
              [-13.1983595750926, -11.493150193348194],
              [-13.201135366521237, -11.495004039232155],
              [-13.201553215775078, -11.497447128502861],
              [-13.203814518942917, -11.49730629256483],
              [-13.204842857157848, -11.498183088584733],
              [-13.205365060691019, -11.499610480390515],
              [-13.208669962129619, -11.501473676660598],
              [-13.211540179887843, -11.500978476801466],
              [-13.214626627505556, -11.501259888660503],
              [-13.22052451534654, -11.50022229689348],
              [-13.221558267942877, -11.501884411793315],
              [-13.224740789825207, -11.504476212392785],
              [-13.231175619105239, -11.503844108504692],
              [-13.231932507375033, -11.504751514412588],
              [-13.234816356372308, -11.504493098398273],
              [-13.236734136086417, -11.501932566371247],
              [-13.239811937470042, -11.49619093312006],
              [-13.241911769798438, -11.496107108562125],
              [-13.243778880050016, -11.499170370947798],
              [-13.243637252821776, -11.499883069931675],
              [-13.241399632124297, -11.501819423271705],
              [-13.240873322599397, -11.504115474367781],
              [-13.241281949204062, -11.505633071627802],
              [-13.24259827675034, -11.506671736238552],
              [-13.24453267133197, -11.506509731793352],
              [-13.24807112597133, -11.506956409220733],
              [-13.25084790790741, -11.506207400961127],
              [-13.253019665533621, -11.506328759907431],
              [-13.25594164637492, -11.502829440816036],
              [-13.257313989663249, -11.502851490708492],
              [-13.261812314171767, -11.50589327225705],
              [-13.26210014473452, -11.50777703956153],
              [-13.26492566163323, -11.506360204733976],
              [-13.267017392027, -11.507358828234842],
              [-13.2689342099768, -11.506704438821643],
              [-13.270607034405122, -11.50735579257486],
              [-13.2720705841524, -11.506846389146304],
              [-13.27243420592716, -11.509139750866012],
              [-13.270509175182706, -11.512953686857163],
              [-13.269569760133932, -11.513851788730546],
              [-13.269648191697426, -11.51578372761033],
              [-13.268708847880564, -11.517218629794407],
              [-13.267663162302123, -11.51749908709508],
              [-13.266941258353706, -11.519755978940847],
              [-13.265467798209269, -11.51945325340779],
              [-13.264274850696053, -11.520156241354066],
              [-13.264727512501652, -11.522781475936396],
              [-13.263431026781731, -11.525350159049635],
              [-13.265449538146862, -11.528861651324721],
              [-13.266768354231791, -11.532814355395132],
              [-13.271657198200867, -11.537356073572054],
              [-13.272277387759335, -11.538762657952782],
              [-13.274658435185959, -11.539660537577555],
              [-13.27667280293209, -11.539184830974182],
              [-13.27868669595177, -11.53776062743454],
              [-13.279931072906626, -11.538154984281014],
              [-13.279866730009182, -11.535574119185078],
              [-13.280924598934709, -11.534487216659388],
              [-13.281647190963387, -11.535877601878234],
              [-13.28183470531501, -11.537501308355068],
              [-13.280703333869514, -11.539395345891931],
              [-13.28320651510092, -11.539263465427965],
              [-13.284539686599025, -11.53814472163442],
              [-13.282894258206582, -11.535751271655794],
              [-13.283517146825575, -11.5347398358003],
              [-13.28494687813276, -11.534789605087704],
              [-13.28600967101647, -11.536903133812004],
              [-13.286728548443763, -11.536111514506663],
              [-13.285617582986703, -11.534290722122103],
              [-13.286970703457488, -11.533036680925196],
              [-13.289005438371639, -11.533443549167876],
              [-13.291240777177446, -11.53682743165168],
              [-13.293449874729395, -11.53641180425418],
              [-13.293055725127271, -11.535339507997799],
              [-13.295718924002747, -11.534640787267277],
              [-13.297138129128887, -11.535159816451134],
              [-13.297707997892646, -11.536358070571733],
              [-13.296799451053987, -11.537729725770808],
              [-13.29938001668128, -11.54050960273007],
              [-13.302641251447119, -11.54011622658565],
              [-13.303713991980203, -11.540738030175676],
              [-13.305688182851634, -11.540080794504002],
              [-13.306857670932926, -11.538212932635574],
              [-13.307339099498352, -11.535061933261083],
              [-13.31080203439456, -11.533725369962138],
              [-13.314072936529875, -11.5339483564457],
              [-13.314679224247106, -11.533139174814675],
              [-13.31599993269041, -11.533080395496604],
              [-13.316919284310497, -11.53388751640937],
              [-13.316961157781572, -11.535844328125243],
              [-13.319910439195029, -11.536423870580128],
              [-13.32073332241968, -11.535355014878595],
              [-13.320211914479477, -11.53357437541866],
              [-13.318547218290457, -11.531711815361914],
              [-13.31835884947012, -11.530053121239552],
              [-13.319281142123732, -11.528125512752625],
              [-13.320816338864994, -11.527284570146366],
              [-13.322086517288621, -11.525804443647806],
              [-13.323262114899425, -11.52560982940982],
              [-13.324109342316167, -11.524224887330895],
              [-13.325745995759494, -11.523928350856892],
              [-13.32734444990827, -11.524541275870881],
              [-13.328456380105111, -11.520714553937179],
              [-13.330366541223247, -11.519098026005326],
              [-13.331234567733585, -11.514463915802004],
              [-13.33292138496831, -11.512627565207215],
              [-13.332673164593947, -11.51142180633985],
              [-13.334052167639914, -11.50944926619368],
              [-13.33362119455251, -11.508321857800711],
              [-13.330912475040325, -11.507260960935898],
              [-13.330542194091477, -11.504588745263423],
              [-13.331472399843012, -11.503721351718399],
              [-13.3319784459428, -11.501126956327816],
              [-13.332922335132702, -11.499868397456867],
              [-13.333830989082147, -11.496655185140026],
              [-13.335711641747748, -11.494333399950825],
              [-13.336031197381038, -11.493068729621093],
              [-13.338509401264092, -11.491235364122707],
              [-13.341058758655358, -11.492218474855251],
              [-13.342287543194916, -11.49174180143015],
              [-13.344605266204878, -11.491583852668986],
              [-13.347787711680688, -11.48909846298381],
              [-13.349290050304763, -11.486366550661014],
              [-13.349923070886746, -11.48300236210489],
              [-13.35050137862854, -11.481855009051278],
              [-13.354553226199487, -11.480242293807532],
              [-13.356572235302965, -11.479706827394462],
              [-13.35607424881468, -11.477591972582722],
              [-13.35625631550567, -11.475922497191617],
              [-13.353590070505053, -11.474417850455064],
              [-13.352999684220434, -11.47362861787027],
              [-13.35107923015324, -11.473887547431906],
              [-13.348724392145384, -11.473139659353341],
              [-13.347198648547227, -11.471908112300422],
              [-13.346535219538415, -11.469983127205568],
              [-13.346749118071548, -11.469104796309667],
              [-13.348408906842371, -11.469296112640643],
              [-13.350995535193, -11.470461413104363],
              [-13.351993075785492, -11.46892460379161],
              [-13.358557132957015, -11.470515947459084],
              [-13.35950922335136, -11.470201194246542],
              [-13.361381657077581, -11.46808921301611],
              [-13.363253091605982, -11.467387483447249],
              [-13.364746585793863, -11.46745889949333],
              [-13.366453157951073, -11.466290954495896],
              [-13.367136127192643, -11.464903976261818],
              [-13.368539506121856, -11.464879150272779],
              [-13.371790412201348, -11.462919316410106],
              [-13.373366345446986, -11.462475374282182],
              [-13.374549099217038, -11.46043676635346],
              [-13.376237435376387, -11.460166432735718],
              [-13.37583345540721, -11.458069821771183],
              [-13.374356087340248, -11.457730959276951],
              [-13.37350478957493, -11.455427293354298],
              [-13.372778470825597, -11.455750992106747],
              [-13.371593122848962, -11.458754249911788],
              [-13.36923590399222, -11.460091172750113],
              [-13.366971623217127, -11.459727238596562],
              [-13.365676567873566, -11.460099729830926],
              [-13.363718859922539, -11.457884372440425],
              [-13.361553821824327, -11.458120358892133],
              [-13.359907171330377, -11.45783442197771],
              [-13.359875294998218, -11.45549418154982],
              [-13.362613198881066, -11.45233712986284],
              [-13.363278875577915, -11.449676975509533],
              [-13.362429285941579, -11.448856119464999],
              [-13.362959612633544, -11.445890897027544],
              [-13.364518418503492, -11.445510879910739],
              [-13.364690375869062, -11.443352199551498],
              [-13.366437466191176, -11.442203973682666],
              [-13.368581592449454, -11.443591435028994],
              [-13.369928268139288, -11.441689688577226],
              [-13.370139017569647, -11.438127509305236],
              [-13.36764797377039, -11.435491710011515],
              [-13.368575699234494, -11.432953225195789],
              [-13.367488627543388, -11.431822752384871],
              [-13.368449414120867, -11.428004883226139],
              [-13.36717993355027, -11.425605316029712],
              [-13.367815788146293, -11.424833164783575],
              [-13.370025993032728, -11.42461947073401],
              [-13.371543750791751, -11.422250870882516],
              [-13.37074736777562, -11.421109428486602],
              [-13.371190234058917, -11.41892032267565],
              [-13.374896009655883, -11.417596178569532],
              [-13.375424589947382, -11.416083765241657],
              [-13.375059332847453, -11.41442404449689],
              [-13.372077035998121, -11.412818348440796],
              [-13.364426064120467, -11.411042811766178],
              [-13.363969008389436, -11.409061024023956],
              [-13.362468644162535, -11.408468699464265],
              [-13.36181915060278, -11.40629773398573],
              [-13.35990748284905, -11.404792763037085],
              [-13.35784883561682, -11.404826583510111],
              [-13.356680844335349, -11.403764420544977],
              [-13.35409785413835, -11.403329082929082],
              [-13.353601159175758, -11.40098992176404],
              [-13.354195724073797, -11.399203179831545],
              [-13.338511993758075, -11.388631870071926],
              [-13.337915102134705, -11.388034433153678],
              [-13.338921295974576, -11.385602411145781],
              [-13.337598582408539, -11.384094516619161],
              [-13.338267048585681, -11.38325747019105],
              [-13.341032189715172, -11.381400981024987],
              [-13.342671806622695, -11.378602234066241],
              [-13.346698482570073, -11.37526401596555],
              [-13.346590708302267, -11.374388484208499],
              [-13.348614829117013, -11.371675133474152],
              [-13.349293736299032, -11.371611034523307],
              [-13.350557725906828, -11.369824050650076],
              [-13.352289329565524, -11.3686402387013],
              [-13.354169880656872, -11.366603703526554],
              [-13.355436723188705, -11.364386022554822],
              [-13.356698392724732, -11.364650063326353],
              [-13.357270501040915, -11.362873784771619]
            ]
          ],
          [
            [
              [-13.45685471270459, -11.217137627770622],
              [-13.455606307691038, -11.215503579764338],
              [-13.453956457276812, -11.2155432298509],
              [-13.454229248289288, -11.217011895473837],
              [-13.456061784506026, -11.217997660117963],
              [-13.45685471270459, -11.217137627770622]
            ]
          ],
          [
            [
              [-13.496201209613464, -11.132540535022502],
              [-13.495309759393022, -11.131851594537128],
              [-13.491283065372661, -11.132249256324789],
              [-13.48946079027829, -11.133148344781414],
              [-13.488642237213497, -11.132664704105222],
              [-13.485798372216067, -11.134712066403813],
              [-13.486883834033039, -11.135233028466574],
              [-13.488882510479609, -11.134938532658577],
              [-13.490336254158303, -11.135756835445504],
              [-13.49374658732133, -11.134251288656085],
              [-13.494406504021448, -11.133357016491086],
              [-13.496201209613464, -11.132540535022502]
            ]
          ],
          [
            [
              [-13.487257308650467, -11.128016529115868],
              [-13.485894594337095, -11.127519681718049],
              [-13.483378883640983, -11.127454281101727],
              [-13.479852516386085, -11.12561314433178],
              [-13.479238634630496, -11.123476879312049],
              [-13.479984014399111, -11.12197618598484],
              [-13.47917100843702, -11.119007763233673],
              [-13.478222881234482, -11.1166752932889],
              [-13.478079722927118, -11.112179511254864],
              [-13.477589872747487, -11.110467336583278],
              [-13.475055993450686, -11.107430625395455],
              [-13.474765837854095, -11.105342009243316],
              [-13.471974474498886, -11.106442462755348],
              [-13.469881514281333, -11.105918741093362],
              [-13.466185594801235, -11.106334332526194],
              [-13.46273707955142, -11.108059432019353],
              [-13.46071947244467, -11.1076945903196],
              [-13.459234934590722, -11.109270480890082],
              [-13.458197203407098, -11.11273344638384],
              [-13.457101206566755, -11.114149588244366],
              [-13.455342078643508, -11.114548238439305],
              [-13.453217491453096, -11.112555678056165],
              [-13.451161035565887, -11.113034551666162],
              [-13.449288905582126, -11.11394195107247],
              [-13.447848756260544, -11.113539760576264],
              [-13.445696026988363, -11.11379004558317],
              [-13.444085071169617, -11.114490477444159],
              [-13.442671106119946, -11.11373236685717],
              [-13.441895125662608, -11.112106273828115],
              [-13.439071714474826, -11.11153196110493],
              [-13.438106450800376, -11.11001026288891],
              [-13.436957682443644, -11.107020250495404],
              [-13.435579555914599, -11.104671664412853],
              [-13.433598670662438, -11.103046480410297],
              [-13.431579761959695, -11.105936758711023],
              [-13.431384727623664, -11.107282837806244],
              [-13.431761305663363, -11.11066486662777],
              [-13.430629985903476, -11.112158269905386],
              [-13.428444051540765, -11.111293257388418],
              [-13.427472266787234, -11.11015304156493],
              [-13.42653297196196, -11.110127608846524],
              [-13.425073830198945, -11.108940879350385],
              [-13.421393178347916, -11.107456262691922],
              [-13.419038533145756, -11.110578535983047],
              [-13.418699235851152, -11.111998072452051],
              [-13.416587352794288, -11.112385916593544],
              [-13.415008998247528, -11.111677008660534],
              [-13.413121440963195, -11.111947345101822],
              [-13.412582100142288, -11.11450745320845],
              [-13.41059935663933, -11.115502174479207],
              [-13.409335077331338, -11.114288974754203],
              [-13.407940904579233, -11.113937237942821],
              [-13.40647627503559, -11.114569503144855],
              [-13.405351266105699, -11.113669513406663],
              [-13.401537187239708, -11.11219858512448],
              [-13.400369873206294, -11.11573779804862],
              [-13.397994583490478, -11.115362502263592],
              [-13.39538984715587, -11.115446961219162],
              [-13.394320473887097, -11.112922105392155],
              [-13.392394621488304, -11.110559269176811],
              [-13.392165918459249, -11.109771093310178],
              [-13.39054822740792, -11.108303870655753],
              [-13.38710266746087, -11.111296977783008],
              [-13.386202583405595, -11.113342594315844],
              [-13.38394603524363, -11.114224884382459],
              [-13.381635684945685, -11.113242581179199],
              [-13.379255308758976, -11.113224296613003],
              [-13.377536725052058, -11.113665797187313],
              [-13.376336762737184, -11.113343396978562],
              [-13.373653890150235, -11.11098562171241],
              [-13.37207567725341, -11.109958783552159],
              [-13.371419083576589, -11.108295116475357],
              [-13.370977533693182, -11.10557872329207],
              [-13.370835763303525, -11.101002377430447],
              [-13.370044150945752, -11.100513455552782],
              [-13.366955584950576, -11.101797624297621],
              [-13.366362493349673, -11.102595857194807],
              [-13.36352334429212, -11.10355667197856],
              [-13.363159096117704, -11.104677642097291],
              [-13.359435361795684, -11.102850252681565],
              [-13.355905029752291, -11.103757338668863],
              [-13.35396051782584, -11.105040471864982],
              [-13.352450379573103, -11.106788334737598],
              [-13.352513669793861, -11.107856708140645],
              [-13.354836629632219, -11.111376343094491],
              [-13.354375932595401, -11.114818014226367],
              [-13.35434228718728, -11.116970811616003],
              [-13.353183427097465, -11.117677538265365],
              [-13.350372275435971, -11.11611752647075],
              [-13.347516805461526, -11.116227371270627],
              [-13.342898068056899, -11.119497537785861],
              [-13.341515833291066, -11.121270604454168],
              [-13.341642260501324, -11.124098269685557],
              [-13.34371258953685, -11.126221185444722],
              [-13.34520779036864, -11.128556125245355],
              [-13.346053318007161, -11.130941859290548],
              [-13.344373723764656, -11.134717912970913],
              [-13.344010750804289, -11.13708293330378],
              [-13.344408425013286, -11.140104609332827],
              [-13.343640744285826, -11.142634285393132],
              [-13.34269193090863, -11.141240375405996],
              [-13.338370552417432, -11.140818421530016],
              [-13.337699640667905, -11.141149305640155],
              [-13.336896271313572, -11.143136302843107],
              [-13.33382024240267, -11.144479424755541],
              [-13.331181529842024, -11.145011069043441],
              [-13.330054369252396, -11.147456222612147],
              [-13.326846676885058, -11.147994418893276],
              [-13.322830069082125, -11.14666111621263],
              [-13.322273379031754, -11.144704805386374],
              [-13.320631532645168, -11.143579143721249],
              [-13.31651106001175, -11.142119875330454],
              [-13.313698970818594, -11.141824507846907],
              [-13.310790361497927, -11.14281294617262],
              [-13.30984068076108, -11.141944991833684],
              [-13.30737500462796, -11.141021959752793],
              [-13.30325683487896, -11.13850655237514],
              [-13.302199584177362, -11.138198870634117],
              [-13.301363608603946, -11.136834694247463],
              [-13.299765881165005, -11.136726964823069],
              [-13.299557422905687, -11.13543107234218],
              [-13.30005892068855, -11.132564396034711],
              [-13.302146287407586, -11.130027813243075],
              [-13.301921862249882, -11.128620316828355],
              [-13.272058450178159, -11.15907576442408],
              [-13.246314494537394, -11.178536483931042],
              [-13.22819239905978, -11.19217516285126],
              [-13.220800179332327, -11.198281156603183],
              [-13.201478909516778, -11.217903355939823],
              [-13.185510136892882, -11.234067976391549],
              [-13.19374895225893, -11.280304854478182],
              [-13.130308674940535, -11.276005642388094],
              [-13.128126969398473, -11.300425748873748],
              [-13.125460535813847, -11.330632743573737],
              [-13.128159750009873, -11.330076751680554],
              [-13.134917980437939, -11.329087568660658],
              [-13.13692491216472, -11.330140063002032],
              [-13.138332738378802, -11.332028888765345],
              [-13.138485302313594, -11.332939538068532],
              [-13.141268349602523, -11.333662886624664],
              [-13.143625472241741, -11.336247627783598],
              [-13.14470340692924, -11.338811843960846],
              [-13.145899621647846, -11.340524173158931],
              [-13.146243467335054, -11.342135627043481],
              [-13.144773773593892, -11.344603447589462],
              [-13.144405864741895, -11.347758797387726],
              [-13.144658192813443, -11.348721463925706],
              [-13.147726171720548, -11.35073440367045],
              [-13.148178946821691, -11.35363922288609],
              [-13.149711806327808, -11.354890719602155],
              [-13.149756970649324, -11.356585502023243],
              [-13.148618961858311, -11.358644195375419],
              [-13.147593027325021, -11.364593648988174],
              [-13.147889370180996, -11.365637639113945],
              [-13.14946286501089, -11.367580917725927],
              [-13.148620417108182, -11.369083931522107],
              [-13.14914808321663, -11.371957359628736],
              [-13.150792348203662, -11.373826579991507],
              [-13.152417859261876, -11.376614412326612],
              [-13.15497416019978, -11.379527722238732],
              [-13.15394963610156, -11.381336700243407],
              [-13.153862745731868, -11.382848553494814],
              [-13.154969527675595, -11.38336415417549],
              [-13.155947682712496, -11.382829950147526],
              [-13.15846348016191, -11.382534552334489],
              [-13.160639385447594, -11.384289309495532],
              [-13.164483508168582, -11.3840863845769],
              [-13.166036797176215, -11.386825200735842],
              [-13.169361469444716, -11.387774659337605],
              [-13.170517884859251, -11.389166188633038],
              [-13.170452839875281, -11.391872195900046],
              [-13.170986160851992, -11.392773194350188],
              [-13.170432530893342, -11.395347313306189],
              [-13.171345040993833, -11.398900866127232],
              [-13.17103615884948, -11.400239304166782],
              [-13.171764606108217, -11.403910200710957],
              [-13.173212351836536, -11.405779166750914],
              [-13.174898691051734, -11.405825826025453],
              [-13.17590945069177, -11.406407157407642],
              [-13.177958161849913, -11.408905126648095],
              [-13.178885863193177, -11.411220848751682],
              [-13.181119861540411, -11.413221776180965],
              [-13.184115983137062, -11.414239994071409],
              [-13.185815533059088, -11.414126085126624],
              [-13.186489405704558, -11.412307096557534],
              [-13.186262663123102, -11.410719686162176],
              [-13.188270691145243, -11.408495344834943],
              [-13.189167689225114, -11.406851959568863],
              [-13.185065662273093, -11.406473755428275],
              [-13.184197716173022, -11.401582245870005],
              [-13.185135113242024, -11.40108703489916],
              [-13.185210392124295, -11.399883399776295],
              [-13.187197834575384, -11.399685766667151],
              [-13.189656635255538, -11.401059246972086],
              [-13.194019582135398, -11.400789515095939],
              [-13.19566258078549, -11.399910875608082],
              [-13.200112103312385, -11.398959865488935],
              [-13.20143610621387, -11.399015398127283],
              [-13.202344131349799, -11.398179472677159],
              [-13.204503741387901, -11.39732836321634],
              [-13.206963454489768, -11.397990538198599],
              [-13.208776819526987, -11.39773343647595],
              [-13.218666407835828, -11.393897660666198],
              [-13.221595463741002, -11.392151690960262],
              [-13.228340225307333, -11.390302009144428],
              [-13.232001674234624, -11.388704144705601],
              [-13.23322309775363, -11.388770994049288],
              [-13.239084217104372, -11.387424101627852],
              [-13.242013383091278, -11.386114192541934],
              [-13.245081544784577, -11.381978240284573],
              [-13.24674451540357, -11.38016465165767],
              [-13.246011402411549, -11.379362534516412],
              [-13.247557083766774, -11.375770445255693],
              [-13.252100038039929, -11.372069522873424],
              [-13.253276179575892, -11.371979875706897],
              [-13.254838075126004, -11.37102820798937],
              [-13.2560429368328, -11.37113593946176],
              [-13.261203221688847, -11.369843475766714],
              [-13.267932757107625, -11.366285517581291],
              [-13.275431446588621, -11.356153061057157],
              [-13.28085331365876, -11.351772658756463],
              [-13.2840001393179, -11.35119146144469],
              [-13.28604391148652, -11.350489437263057],
              [-13.287271077761881, -11.349524616643201],
              [-13.28819074236047, -11.346633418875859],
              [-13.286544935936822, -11.346432015099971],
              [-13.285768785608132, -11.345338905340483],
              [-13.282105441961692, -11.344909188697173],
              [-13.27715292380939, -11.343281355185292],
              [-13.277119594336249, -11.342036690406342],
              [-13.275369542288473, -11.340018934961721],
              [-13.272234573538455, -11.338725171288852],
              [-13.27114441878912, -11.337154298642814],
              [-13.272726645006864, -11.334712738207545],
              [-13.273119656367628, -11.33352986732345],
              [-13.27234647180363, -11.330466345623147],
              [-13.270104450564988, -11.331615559381676],
              [-13.266892183745046, -11.334232145197205],
              [-13.265379068102327, -11.33589853496087],
              [-13.265539175669378, -11.337685278056012],
              [-13.265114071879141, -11.34007973684147],
              [-13.26159724468508, -11.34189593935869],
              [-13.262543805880226, -11.343328504640736],
              [-13.261215524533759, -11.34515016495564],
              [-13.259985600202594, -11.34583119719959],
              [-13.258881515494787, -11.344300346463305],
              [-13.257292730241192, -11.344207797090501],
              [-13.256360935951365, -11.34287333123203],
              [-13.257546267669007, -11.340489404304586],
              [-13.258917792759279, -11.338823263790431],
              [-13.25878784598786, -11.337796191312126],
              [-13.260602827979373, -11.336227006336733],
              [-13.260887599352294, -11.335240908863922],
              [-13.260298618028093, -11.33275220933706],
              [-13.264454871714271, -11.32931793264642],
              [-13.26702606876874, -11.326535663697792],
              [-13.27455138905077, -11.317692124057997],
              [-13.274834770739586, -11.316426208465714],
              [-13.273372672607923, -11.31272370823934],
              [-13.272000709831904, -11.31143683115863],
              [-13.27291143391783, -11.309579179725333],
              [-13.273790586306193, -11.305559698086327],
              [-13.277522005087153, -11.301950753358303],
              [-13.27830860450983, -11.303421096096146],
              [-13.278386892832472, -11.307562257499386],
              [-13.278789813261902, -11.309470025705433],
              [-13.2786425228286, -11.311223340057259],
              [-13.280097950761869, -11.314337126644071],
              [-13.282495409443339, -11.314269554874182],
              [-13.28249767086599, -11.31525282894897],
              [-13.281286571889078, -11.316171638299165],
              [-13.28203240413112, -11.31776949856284],
              [-13.280953750882182, -11.320557048370306],
              [-13.279456910041255, -11.321618224825695],
              [-13.278006144568439, -11.324380013380122],
              [-13.278694939450691, -11.325726211886954],
              [-13.277799993880684, -11.327965998755811],
              [-13.27767553077401, -11.329752390846833],
              [-13.280713338233225, -11.333027788473823],
              [-13.283029386444127, -11.333353161081465],
              [-13.285240589227291, -11.332004984714988],
              [-13.285765563025754, -11.330722680300608],
              [-13.289045739310309, -11.328876742059668],
              [-13.290587345212185, -11.328530241685385],
              [-13.291189347158166, -11.329145378309523],
              [-13.29264501218587, -11.32877135733039],
              [-13.296559876044567, -11.329141095198716],
              [-13.299876063467526, -11.328865713775615],
              [-13.300519135356657, -11.329944800980181],
              [-13.298740855734426, -11.33171336254868],
              [-13.300062770317226, -11.333588333565771],
              [-13.299945721140809, -11.336359156990028],
              [-13.29934424953695, -11.339442748483],
              [-13.299988771076624, -11.340729732831592],
              [-13.302758721829552, -11.334073670962049],
              [-13.303823326532699, -11.331145442407186],
              [-13.304932711475411, -11.330097799869131],
              [-13.307230245372748, -11.329758452189031],
              [-13.30881909659743, -11.330547968439673],
              [-13.31436427368347, -11.32872252862023],
              [-13.320680159291225, -11.324712167112514],
              [-13.32293810182681, -11.325340066004413],
              [-13.323599530668783, -11.326205295147346],
              [-13.327758675624636, -11.32496304835316],
              [-13.331887806726554, -11.325952248672488],
              [-13.332551423230036, -11.327097825289023],
              [-13.336527694183728, -11.328677013874183],
              [-13.340851435851546, -11.328664215411862],
              [-13.343529428283853, -11.326153357284467],
              [-13.344228351582723, -11.324181287726082],
              [-13.346104737875818, -11.32337711042451],
              [-13.34669248635913, -11.321883855951384],
              [-13.347713087137056, -11.321088061903769],
              [-13.348006472962641, -11.318335264740188],
              [-13.345954952369716, -11.31651762252661],
              [-13.348242384801395, -11.31360611225571],
              [-13.349473221569246, -11.314323082509585],
              [-13.35095460014548, -11.31428055152902],
              [-13.352187452574922, -11.315277685851424],
              [-13.353966725429688, -11.315049447180657],
              [-13.355282063367252, -11.315652972004244],
              [-13.35593857851047, -11.316676981860901],
              [-13.359297437529083, -11.317973924366397],
              [-13.359360152147605, -11.322096838285008],
              [-13.359173963746429, -11.325161254434663],
              [-13.360660551338194, -11.327498946949383],
              [-13.362329162448702, -11.329192637754488],
              [-13.365835959442618, -11.330626501197063],
              [-13.367732005911405, -11.329032903424812],
              [-13.369759569461758, -11.329346232279208],
              [-13.371993695777302, -11.328884630193766],
              [-13.375839439816096, -11.328557817199941],
              [-13.375744020081095, -11.327549030040133],
              [-13.377313301621024, -11.32622516921844],
              [-13.382956278054303, -11.326183022330296],
              [-13.386473611806228, -11.32598394077884],
              [-13.388129460925033, -11.326270953710559],
              [-13.38933214888418, -11.325484020076349],
              [-13.389845466053629, -11.324201102639723],
              [-13.391611255764875, -11.32414987326625],
              [-13.393825870902994, -11.324751273209866],
              [-13.397429274645992, -11.32471658819918],
              [-13.397728808446576, -11.323506751678035],
              [-13.399404630694528, -11.321843935406328],
              [-13.403758069428655, -11.321530979166354],
              [-13.404672079668659, -11.321770276138274],
              [-13.406950394027941, -11.319411705923317],
              [-13.414168386098888, -11.318410213039767],
              [-13.415318013255646, -11.319226640053603],
              [-13.4209708948132, -11.319554453646077],
              [-13.42045539135415, -11.317542517494577],
              [-13.417329877824352, -11.315211667093346],
              [-13.416037612068424, -11.31541326363806],
              [-13.413118922667996, -11.313307978887934],
              [-13.412897818313462, -11.3122944183139],
              [-13.411438149975695, -11.310397396033586],
              [-13.411008261617898, -11.307197049174206],
              [-13.412061213760929, -11.30543292632458],
              [-13.41101720185494, -11.303712296440462],
              [-13.41157789233778, -11.30184299734512],
              [-13.415152148990554, -11.297201031263464],
              [-13.416564534631036, -11.295710858357824],
              [-13.42176788793431, -11.292395468284505],
              [-13.420653391956876, -11.291026722645162],
              [-13.419577556589712, -11.291294118973495],
              [-13.418036582462413, -11.290673289698622],
              [-13.418927993624008, -11.289234362931833],
              [-13.422362929420007, -11.288967493700248],
              [-13.422638838728329, -11.287377441474444],
              [-13.422266127634723, -11.285915603200824],
              [-13.420248775389673, -11.285749117825246],
              [-13.419081358097944, -11.284270904168288],
              [-13.416304742739678, -11.284701723420266],
              [-13.415540104847434, -11.282420791511056],
              [-13.4171337115386, -11.281574019295052],
              [-13.41695534627466, -11.279662854627356],
              [-13.419866672105087, -11.27751221187664],
              [-13.42204855466332, -11.277313099445077],
              [-13.421980471345861, -11.276364741246676],
              [-13.419926762259479, -11.276603520511896],
              [-13.417314458850354, -11.273931481440265],
              [-13.416355255898859, -11.27362179548856],
              [-13.411039453409783, -11.27473202358798],
              [-13.409321620966999, -11.277085981005705],
              [-13.408421764220993, -11.27763936524326],
              [-13.405032937042021, -11.278014973113269],
              [-13.40248557058356, -11.276688933382186],
              [-13.40144302602125, -11.276701002611484],
              [-13.400310281602946, -11.275555808695332],
              [-13.39760918782991, -11.27503119158349],
              [-13.393692977646712, -11.275051763047456],
              [-13.39285164721131, -11.27316220577322],
              [-13.39171811805715, -11.273315722942906],
              [-13.392158443197992, -11.270390625003651],
              [-13.391167635760706, -11.269103452660042],
              [-13.389272073364952, -11.26813436975649],
              [-13.386291087603803, -11.269468047883677],
              [-13.384690373742679, -11.269752122564098],
              [-13.383604385855534, -11.268528428166443],
              [-13.381790547234578, -11.269114292374162],
              [-13.378647466617585, -11.268213304681344],
              [-13.37751360564436, -11.268365442446056],
              [-13.377552880093832, -11.266241656819892],
              [-13.374997311425776, -11.265989742378348],
              [-13.373999856294091, -11.265441618332856],
              [-13.373319994280658, -11.263786551123125],
              [-13.373406000464685, -11.262095669116889],
              [-13.371916197402317, -11.260183942315617],
              [-13.368979993955412, -11.260088224305786],
              [-13.368731786401323, -11.259127270407511],
              [-13.367172566705259, -11.257285540037666],
              [-13.365322449897858, -11.256326252778948],
              [-13.365961010153738, -11.254393456750492],
              [-13.366762144734912, -11.25339423604933],
              [-13.36696330938971, -11.251787256900455],
              [-13.369038452368287, -11.250636406843803],
              [-13.371824041653763, -11.253609366473633],
              [-13.374234553580791, -11.255580574651567],
              [-13.37518625987842, -11.25583600972789],
              [-13.377986742923387, -11.255052648227464],
              [-13.381412415569427, -11.255094092540913],
              [-13.38488206141522, -11.254265941317644],
              [-13.388598169155943, -11.25469860825176],
              [-13.391765437357169, -11.257089864920374],
              [-13.394442499775241, -11.256960570067776],
              [-13.397605820773103, -11.258792352073364],
              [-13.404901681177257, -11.258631936080784],
              [-13.410607495205802, -11.258292884819868],
              [-13.41204249834929, -11.25735336058763],
              [-13.415053043372039, -11.256768964256707],
              [-13.417124050363254, -11.25704773380866],
              [-13.420515024612305, -11.255006322064212],
              [-13.422139214101916, -11.2535169030442],
              [-13.424102425186577, -11.24988935516064],
              [-13.424066080671155, -11.247416254755965],
              [-13.422091213190427, -11.243429421952507],
              [-13.421223551178679, -11.242453166397441],
              [-13.419467059349886, -11.242226353037166],
              [-13.41922391227774, -11.240669251891],
              [-13.41710107801297, -11.240558346177773],
              [-13.416675844368562, -11.239128915054996],
              [-13.417279947904396, -11.237421718791994],
              [-13.418381198889056, -11.235916876181795],
              [-13.421291933301127, -11.238357162404153],
              [-13.422758535765624, -11.23726879052642],
              [-13.422278625612101, -11.235475223342096],
              [-13.423357673545894, -11.233316370053704],
              [-13.424688812165742, -11.233548805479465],
              [-13.42464043061671, -11.235568331356427],
              [-13.425888111433935, -11.236125964597692],
              [-13.427087374497562, -11.235687683255453],
              [-13.429638047803788, -11.233758714504791],
              [-13.431641962004273, -11.231058196490164],
              [-13.433082043231218, -11.230954334501908],
              [-13.436760532496466, -11.22900921283459],
              [-13.436882135298083, -11.22733772951013],
              [-13.439878862483976, -11.224025775693816],
              [-13.441695316316459, -11.223623427939907],
              [-13.442880847068123, -11.22126998845779],
              [-13.441667093137823, -11.22010610398816],
              [-13.442730136058485, -11.218130191846186],
              [-13.4445965957067, -11.217282727169763],
              [-13.445217270417304, -11.216091911177916],
              [-13.446711632693834, -11.209123186430968],
              [-13.44560827198122, -11.2063888561601],
              [-13.44800189098024, -11.201466027044459],
              [-13.448827285037288, -11.198547396759626],
              [-13.448217098506445, -11.196829030683837],
              [-13.445707551206755, -11.195815461334234],
              [-13.44452900447121, -11.194501714909741],
              [-13.443828879292493, -11.19054480056469],
              [-13.445563387926834, -11.189275186808377],
              [-13.44496408405341, -11.186093404835516],
              [-13.44294517333178, -11.185553066658793],
              [-13.442625796714946, -11.184670126584598],
              [-13.443637769173547, -11.183283155232884],
              [-13.446124812346522, -11.182957098810093],
              [-13.447798645026733, -11.184125910067344],
              [-13.448492722787904, -11.18572432498043],
              [-13.452402824549354, -11.189065253668188],
              [-13.45401363079062, -11.189568505611467],
              [-13.454252997444447, -11.191009347431095],
              [-13.455083836028084, -11.192054215680342],
              [-13.457627665661418, -11.193828170135312],
              [-13.458798374163797, -11.195114451171893],
              [-13.460254102276565, -11.195522010053676],
              [-13.464581803883458, -11.194844060102557],
              [-13.465722201951738, -11.193772004812976],
              [-13.468190373837787, -11.193067144462505],
              [-13.470669336197533, -11.192955011247735],
              [-13.472248954495178, -11.190325356656185],
              [-13.472571157699932, -11.18918315404736],
              [-13.474694819518968, -11.188095148308149],
              [-13.47735943165729, -11.185473254965391],
              [-13.480734050070636, -11.184755608645105],
              [-13.482534336408127, -11.183421573036473],
              [-13.484155166544197, -11.180247959405275],
              [-13.48529921118022, -11.180367976461055],
              [-13.48631810851976, -11.179312431592638],
              [-13.48658560493539, -11.17800301453148],
              [-13.485142827598281, -11.176833137723527],
              [-13.485463400791968, -11.1754625037577],
              [-13.487320929313794, -11.174996688056227],
              [-13.488599589530414, -11.17216090116331],
              [-13.488802679138072, -11.169652104016965],
              [-13.487727758268848, -11.168197892118148],
              [-13.486967826795693, -11.166079584658833],
              [-13.487099962245347, -11.164318488305668],
              [-13.486241870791677, -11.162770073121198],
              [-13.487498003208476, -11.161368260420543],
              [-13.488463461149202, -11.158028134480386],
              [-13.48823105312019, -11.156476647717215],
              [-13.489960733949232, -11.153334276650991],
              [-13.490926838062602, -11.152212175431826],
              [-13.491239627199395, -11.149512304537371],
              [-13.490114538047678, -11.149085025814694],
              [-13.487147291023023, -11.150671628432569],
              [-13.485409479521195, -11.14971905266191],
              [-13.485598519737444, -11.148126623405792],
              [-13.484358213980792, -11.147649202276812],
              [-13.483159665197169, -11.148193621568103],
              [-13.480973222016233, -11.147192412730961],
              [-13.479037569367765, -11.147139936901556],
              [-13.478567924634438, -11.144425111831735],
              [-13.48006144500556, -11.142826581007697],
              [-13.480728815833222, -11.1413381082361],
              [-13.480763236405979, -11.138945715920235],
              [-13.479456543858378, -11.13938261874346],
              [-13.479586269706404, -11.141853310413694],
              [-13.478774917348574, -11.143067825929045],
              [-13.477805591245701, -11.14290341230736],
              [-13.475521837354355, -11.1452187138625],
              [-13.472867125914856, -11.147097564583598],
              [-13.472204948704228, -11.147992372005492],
              [-13.470390523707977, -11.148711136837486],
              [-13.467859444309703, -11.150490967459593],
              [-13.466419222113124, -11.152061252790842],
              [-13.464627560441222, -11.15241975698264],
              [-13.462561535991277, -11.153335214775085],
              [-13.461300941020136, -11.152343939526308],
              [-13.460199972050495, -11.153010083334145],
              [-13.457526534832613, -11.153643380122908],
              [-13.455756391633859, -11.153502225721356],
              [-13.454645340772608, -11.152051653490224],
              [-13.452455761274374, -11.152054720786333],
              [-13.448619522933944, -11.152964810516368],
              [-13.445751894820935, -11.152874395102696],
              [-13.443147891844918, -11.153314919776243],
              [-13.441399520360795, -11.15396038337381],
              [-13.44029546627768, -11.153327914672852],
              [-13.437456696730221, -11.153994795989238],
              [-13.435502151479655, -11.155461793833787],
              [-13.432300711989098, -11.155557167481605],
              [-13.430018982106857, -11.156402205902522],
              [-13.42610202596658, -11.158249435572971],
              [-13.423647559222228, -11.158763482680737],
              [-13.418303064493886, -11.159303226330865],
              [-13.413295900951285, -11.16129219164207],
              [-13.409278345982916, -11.161724044250487],
              [-13.4026640538591, -11.16294414426237],
              [-13.400731791901615, -11.164128297836573],
              [-13.398752757206962, -11.164744413736551],
              [-13.3956410563982, -11.16638358749639],
              [-13.394107058739012, -11.166357021666908],
              [-13.391831801155208, -11.167017089637245],
              [-13.389887496060082, -11.168796768271879],
              [-13.379675447875885, -11.177312995138537],
              [-13.379130087425152, -11.177970276367715],
              [-13.376279566628872, -11.179647306892136],
              [-13.369447723644395, -11.182871635830484],
              [-13.365747606654027, -11.184416026078804],
              [-13.362856112501609, -11.184230745541687],
              [-13.364498177543675, -11.179856332050795],
              [-13.365240553588999, -11.178891998430128],
              [-13.368249282329629, -11.177451831426435],
              [-13.369432766961603, -11.177414553676513],
              [-13.374031668154196, -11.175835307743586],
              [-13.376417996891107, -11.174288007593054],
              [-13.381448540493873, -11.169984163540324],
              [-13.388642358316945, -11.16337275430015],
              [-13.395296512039677, -11.159220806698256],
              [-13.39548949662499, -11.15863680634246],
              [-13.397982443649168, -11.157171649785747],
              [-13.403482276954582, -11.155647837474595],
              [-13.407600442273006, -11.153776928752539],
              [-13.410619582309936, -11.151695663801448],
              [-13.413928007807622, -11.149015916934937],
              [-13.417261963347027, -11.14795499710376],
              [-13.419499268351803, -11.146823229306264],
              [-13.422016315810247, -11.147251073762929],
              [-13.426818949591715, -11.148952712086865],
              [-13.428040272440237, -11.148924456700046],
              [-13.43405420965983, -11.145558980073103],
              [-13.439180164476884, -11.143932228896258],
              [-13.441272188976042, -11.142661013579577],
              [-13.449256761718063, -11.136171151480246],
              [-13.451331322345844, -11.134803382945822],
              [-13.453510987153791, -11.134925568869331],
              [-13.456397539275848, -11.134099152416843],
              [-13.460430507411683, -11.134357476579082],
              [-13.46371017534461, -11.13329674123244],
              [-13.465721966402512, -11.132158852669845],
              [-13.467207117740776, -11.132164877669537],
              [-13.469582257800207, -11.130432115872974],
              [-13.470979748773695, -11.128989501366348],
              [-13.473581226711305, -11.12755692501676],
              [-13.475080706473829, -11.127658867127112],
              [-13.478307328084274, -11.129307640936617],
              [-13.479304545984226, -11.130672521301582],
              [-13.48112932970077, -11.129912796504353],
              [-13.483132040970968, -11.131041061864856],
              [-13.48409665027193, -11.130929282646585],
              [-13.487257308650467, -11.128016529115868]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -132.9339285011432,
          "lat": 57.120492710178425
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02195"],
        "coty_name": ["Petersburg"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Petersburg Borough"],
        "coty_fp_code": "195",
        "coty_gnis_code": "02516404"
      },
      "bbox": [
        -13.496201209613464, -11.54255009414573, -13.125460535813847,
        -11.100513455552782
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.652683646706897, -4.2998987422071835],
            [-10.650227571924711, -4.297762190008593],
            [-10.64469067219676, -4.297201807191154],
            [-10.63833268990035, -4.2908300424545525],
            [-10.638196900688703, -4.285276465958981],
            [-10.640479169216587, -4.2813091574074695],
            [-10.638915458172551, -4.277838822132917],
            [-10.635575422918867, -4.264282655546682],
            [-10.630753507195504, -4.264804800069118],
            [-10.629548488889316, -4.259784581631878],
            [-10.627434135464208, -4.25862446332675],
            [-10.624388542730808, -4.262158446464255],
            [-10.619731140681145, -4.26403940786313],
            [-10.618893486222388, -4.260357874122124],
            [-10.613072517676038, -4.257430400769246],
            [-10.61122369640281, -4.254680827790255],
            [-10.601575767132767, -4.2479832999155605],
            [-10.600211626740968, -4.246129537456035],
            [-10.590635612098476, -4.249423410801752],
            [-10.583456807985549, -4.24981038417433],
            [-10.581380675370601, -4.25297181169606],
            [-10.576899048863265, -4.2541110964278905],
            [-10.575397883577358, -4.248843181516465],
            [-10.569132719882925, -4.249991205270206],
            [-10.566420187810612, -4.246369798098974],
            [-10.563852560279207, -4.2513909324349495],
            [-10.5601889816271, -4.248041910163079],
            [-10.546808835728791, -4.241936211742743],
            [-10.539272159918191, -4.245277401913061],
            [-10.532527160429124, -4.240653868519782],
            [-10.525155967947622, -4.241551777582954],
            [-10.528262401458214, -4.234310327600947],
            [-10.533408011104603, -4.229821277113303],
            [-10.530410757756592, -4.222948761949068],
            [-10.530079702895009, -4.216397812995062],
            [-10.52132778474349, -4.203811149971587],
            [-10.520757032285367, -4.198940444327014],
            [-10.516145362706075, -4.19641109688182],
            [-10.514829311336323, -4.192189226549038],
            [-10.410620266364361, -4.2071380338024635],
            [-10.268425693256706, -4.227257759797019],
            [-10.273743632029213, -4.264450246407879],
            [-10.289192281391495, -4.378871973748453],
            [-10.319378453699798, -4.592881083585155],
            [-10.32355958837059, -4.627483661363779],
            [-10.32512420289199, -4.637183981957351],
            [-10.341524809952203, -4.751618966931861],
            [-10.34700396489143, -4.7925540596340435],
            [-10.362793963602945, -4.9078017053920115],
            [-10.366552966737945, -4.932081245026099],
            [-10.37912508016368, -5.023439445500565],
            [-10.400962318404844, -5.182098383840862],
            [-10.406271297758622, -5.220665706554359],
            [-10.4183149883906, -5.304310189897188],
            [-10.424708638217094, -5.350333182657517],
            [-10.455048555995198, -5.569169690661018],
            [-10.510405696037662, -5.561562774740874],
            [-10.530151201466674, -5.5328457703962854],
            [-10.546310061886238, -5.509817744610791],
            [-10.553314870715552, -5.499211165279914],
            [-10.553888952386071, -5.497058612386642],
            [-10.589103675644921, -5.446804444905302],
            [-10.587062712651555, -5.433002214106691],
            [-10.5691198999829, -5.393788116638051],
            [-10.573514567931218, -5.375587481867789],
            [-10.557782609591372, -5.343285345019585],
            [-10.560861899374183, -5.324830675204484],
            [-10.557815088066246, -5.297918163265429],
            [-10.5751953536638, -5.233396700506798],
            [-10.57655368757705, -5.2249453481801345],
            [-10.580023682065463, -5.224443254411619],
            [-10.621481358749266, -5.12500203010584],
            [-10.634044192426627, -5.122743234635288],
            [-10.691194534717376, -4.979462265227313],
            [-10.734754304620983, -4.8704043312448055],
            [-10.720183052646908, -4.769071717272559],
            [-10.654587146517452, -4.312506760939791],
            [-10.652683646706897, -4.2998987422071835]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.24023521745232,
          "lat": 33.215231824610804
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04011"],
        "coty_name": ["Greenlee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greenlee County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00042807"
      },
      "bbox": [
        -10.734754304620983, -5.569169690661018, -10.268425693256706,
        -4.192189226549038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.71935624485019, -3.445613323566157],
            [-13.564522546891807, -3.4739612560049213],
            [-13.435879988550058, -3.4972176372650443],
            [-13.307235149080366, -3.5204609286580855],
            [-13.242104702123804, -3.5321248959953047],
            [-13.19705910653962, -3.5550926560968574],
            [-12.999868714716191, -3.6555664445001628],
            [-12.933787672531436, -3.6892413046839208],
            [-12.88327799300809, -3.71480051047733],
            [-12.88307560589272, -3.706704030723401],
            [-12.880580644626386, -3.704109539760052],
            [-12.870821971621028, -3.6998755300980752],
            [-12.867001081124418, -3.6956646967996383],
            [-12.862669072402081, -3.694932116032332],
            [-12.85772342443995, -3.6966434359921476],
            [-12.852454107300176, -3.696759425749554],
            [-12.850079567246164, -3.6942096901962698],
            [-12.851611882004928, -3.688970098555337],
            [-12.85064953514759, -3.686764785923461],
            [-12.84407743000493, -3.6869312444530964],
            [-12.841496504465104, -3.677386277348383],
            [-12.837885834019893, -3.667964245130518],
            [-12.84089831073398, -3.663883895103656],
            [-12.845075181947946, -3.6621515448667337],
            [-12.839395342090322, -3.6562332721781723],
            [-12.842465199892255, -3.6524356104713136],
            [-12.841484086578385, -3.6463264594193086],
            [-12.836009358398897, -3.6481332552170826],
            [-12.83386197503114, -3.6502924888839368],
            [-12.825857871961638, -3.6449049439378594],
            [-12.819308927470576, -3.6429028856575636],
            [-12.819129321325741, -3.639457576873022],
            [-12.812852116400311, -3.6377674796909796],
            [-12.80869861960483, -3.637831241033134],
            [-12.802909477701112, -3.6350882975626146],
            [-12.800358357374796, -3.6316798763544784],
            [-12.797623115690097, -3.619524244941556],
            [-12.793747453940817, -3.6149482329587883],
            [-12.790671405888256, -3.6137069821320567],
            [-12.784458329052892, -3.6060309703690594],
            [-12.78588263599865, -3.6028816953053058],
            [-12.784571386276994, -3.5984294274102298],
            [-12.779704522379118, -3.5979909676784145],
            [-12.777779423727639, -3.596021297204181],
            [-12.773861110523193, -3.596504436043829],
            [-12.770413576528803, -3.6010961133514834],
            [-12.766796759526864, -3.596840882574603],
            [-12.7681774620846, -3.587179451155902],
            [-12.767590733600775, -3.580976274745166],
            [-12.765129627057672, -3.576464639558919],
            [-12.757034886764355, -3.5739660277548073],
            [-12.76014884879686, -3.571394904280979],
            [-12.762900790154891, -3.5724967708591846],
            [-12.764546173908556, -3.5661536985314073],
            [-12.63100628831487, -3.6075946093823634],
            [-12.534677717502362, -3.6375211680735973],
            [-12.417079951341744, -3.673971016813229],
            [-12.233902697619508, -3.7042776907666846],
            [-12.229302923074695, -3.705121520039017],
            [-12.222936131929362, -3.704335263392448],
            [-12.215347634445589, -3.7052375283436363],
            [-12.205220616145859, -3.70296426858385],
            [-12.19920844312072, -3.70775572444919],
            [-12.195577586308959, -3.70575912194969],
            [-12.192307720021025, -3.7107061659812954],
            [-12.185520192699244, -3.7158962146435277],
            [-12.188338243590085, -3.7205743896563215],
            [-12.18158284904416, -3.728781398548296],
            [-12.183780345145685, -3.7321999162000368],
            [-12.189205010355932, -3.7336744492930247],
            [-12.195572453993451, -3.737818552015869],
            [-12.196983375970905, -3.7423587976265713],
            [-12.200396516951441, -3.7445245055329552],
            [-12.201113378958825, -3.7479668932213346],
            [-12.19804221355263, -3.7534768963602048],
            [-12.201593418201249, -3.7565307707131956],
            [-12.202916301967793, -3.761736198084235],
            [-12.200146724414196, -3.7692127763511425],
            [-12.201098565309204, -3.776167847826203],
            [-12.205225397705346, -3.7764990286717772],
            [-12.203683945681702, -3.781230658384562],
            [-12.20706110391174, -3.789209733342829],
            [-12.200817957822782, -3.793939285610397],
            [-12.196092970119635, -3.795825425425916],
            [-12.189423408438405, -3.7890342370862715],
            [-12.185631887007915, -3.78754415085268],
            [-12.1788590786894, -3.7921668517894846],
            [-12.174841851371522, -3.793508273462409],
            [-12.16941831539269, -3.7971722013766986],
            [-12.173320545818392, -3.8034986719208344],
            [-12.17418390001437, -3.810690665469235],
            [-12.177233570761091, -3.8116749822901492],
            [-12.180017447114725, -3.8177069094814096],
            [-12.17914125794681, -3.8239114607799696],
            [-12.1811765203788, -3.826903822392955],
            [-12.180873414231481, -3.830560000702665],
            [-12.175651157810469, -3.8343079408472955],
            [-12.176343898447342, -3.8364611375679885],
            [-12.170173511304812, -3.839211321573467],
            [-12.170528392214509, -3.8485816438846463],
            [-12.16466784458601, -3.8547871725050924],
            [-12.164265707347399, -3.8578713858747338],
            [-12.167140602124626, -3.859866481415391],
            [-12.17404945475997, -3.8727457255206565],
            [-12.17435188175065, -3.8761732965443416],
            [-12.170737175610153, -3.8799654275477318],
            [-12.169044257692505, -3.884316916059917],
            [-12.165832667158394, -3.884934898157479],
            [-12.16233832741666, -3.891847430961712],
            [-12.158253858792115, -3.896045078223322],
            [-12.158424330015826, -3.9011853156147387],
            [-12.169097886903273, -3.9021538769903095],
            [-12.170718513984374, -3.9075059253865634],
            [-12.174309623130043, -3.9145194731884776],
            [-12.168923245204628, -3.9230117522827523],
            [-12.168819981144459, -3.9269580772045214],
            [-12.172593966152169, -3.9301588326003234],
            [-12.171763609892666, -3.9332480544392676],
            [-12.17556845935176, -3.9347095617419896],
            [-12.179868572088413, -3.940649935531782],
            [-12.178142030456238, -3.9442405610155533],
            [-12.180760081768666, -3.9464674773958337],
            [-12.180063918533369, -3.954427344231517],
            [-12.177116761732822, -3.95522312352179],
            [-12.177080508257788, -3.959855718178071],
            [-12.182047020285141, -3.967398814495207],
            [-12.177593343541826, -3.970527192991699],
            [-12.172207077010984, -3.969204009082356],
            [-12.170875582171677, -3.9741388545410588],
            [-12.166250894566751, -3.977826731019666],
            [-12.16114069069527, -3.9800405909595016],
            [-12.158725914796845, -3.9833277172326826],
            [-12.158714132432662, -3.988298904642363],
            [-12.15553748891492, -3.989853731330609],
            [-12.150944364190964, -3.9981204528238794],
            [-12.146563897785745, -4.00258032252765],
            [-12.148307365915342, -4.007649884522202],
            [-12.14817163024563, -4.014616688260087],
            [-12.150196468243347, -4.020732694623459],
            [-12.147713884755804, -4.028597433809609],
            [-12.146880117130097, -4.035937721518708],
            [-12.143131887547723, -4.040575940582688],
            [-12.136642461151457, -4.0431890586126915],
            [-12.131092030831521, -4.05323849967488],
            [-12.12821136003408, -4.055483493332965],
            [-12.125538523405421, -4.063016831494872],
            [-12.121665707143487, -4.067985963150846],
            [-12.115909662968125, -4.0708515334162785],
            [-12.116693904351315, -4.077376686134593],
            [-12.111646141391457, -4.0848768556228015],
            [-12.111819880442253, -4.087325875632894],
            [-12.106221341074674, -4.098242214431859],
            [-12.105765787306165, -4.10275796233469],
            [-12.101467537849643, -4.109631706387801],
            [-12.095978095280747, -4.11258315654046],
            [-12.090430035490426, -4.1102195154098276],
            [-12.088607824551238, -4.113401590236981],
            [-12.082251178569111, -4.117526775785491],
            [-12.080941137832607, -4.120786701699357],
            [-12.0770331297817, -4.124515304060787],
            [-12.078455926543509, -4.127236783897379],
            [-12.075272430156256, -4.130124901188507],
            [-12.073196902551185, -4.134584411301399],
            [-12.066238928147826, -4.130415359915407],
            [-12.063834739786891, -4.124961033219338],
            [-12.056683345579719, -4.119484344983653],
            [-12.05596242829765, -4.116032950422708],
            [-12.056234007431417, -4.106402970239193],
            [-12.052155128790215, -4.102531417320854],
            [-12.047672653208739, -4.100904221108471],
            [-12.035643946813835, -4.090814295033506],
            [-12.028496735792817, -4.08410946814858],
            [-12.023715300121154, -4.085233770448934],
            [-12.021013765470073, -4.083696651591901],
            [-12.01835103527147, -4.078078914305081],
            [-12.007920130051339, -4.0732631463882765],
            [-12.003402298289414, -4.070011279895472],
            [-11.994780662858714, -4.103234114543683],
            [-11.947726321310132, -4.281342822669426],
            [-11.944483644414877, -4.294647639918255],
            [-11.950976279438242, -4.293902972912578],
            [-12.132443987686676, -4.26460641161863],
            [-12.301756727431583, -4.237089338675698],
            [-12.386638691486585, -4.223220763785731],
            [-12.400995176644857, -4.309456265664263],
            [-12.403755006106518, -4.308943997471824],
            [-12.412894529380685, -4.366377678180218],
            [-12.417122473107346, -4.394479693205424],
            [-12.418574067514514, -4.402172792820587],
            [-12.431059423577263, -4.480843735445996],
            [-12.515877482210016, -4.467591510754125],
            [-12.572848276726411, -4.457962683656181],
            [-12.614629231266877, -4.451079806720413],
            [-12.62890197891332, -4.449144790186371],
            [-12.685509213052468, -4.440613789273127],
            [-12.685705374494477, -4.439128421515366],
            [-12.769527755938496, -4.424986863899795],
            [-12.840481784912534, -4.412946520635403],
            [-12.848048836777997, -4.406971572534206],
            [-12.842980782245522, -4.3966595858156055],
            [-12.843552426349495, -4.391234870532257],
            [-12.847487860315546, -4.385615422003777],
            [-12.85332073297305, -4.384410993870722],
            [-12.862614870181806, -4.3859696055004855],
            [-12.863990199759009, -4.381537472393974],
            [-12.871723957617386, -4.3762209645957455],
            [-12.876984185876536, -4.377396563603937],
            [-12.877461488951637, -4.369094920428366],
            [-12.881146570438727, -4.366313187291705],
            [-12.880985511800874, -4.363205139935625],
            [-12.883862967052117, -4.358504091345146],
            [-12.888586296493655, -4.354261029794266],
            [-12.897067422490784, -4.3527789501870355],
            [-12.902949465468714, -4.346362609872722],
            [-12.906997682451887, -4.34706744045913],
            [-12.907379140945505, -4.3420186057097565],
            [-12.911802530616251, -4.341859356429783],
            [-12.920170403507912, -4.337864907245767],
            [-12.919929736493973, -4.334838348979104],
            [-12.922437792293042, -4.328494318174113],
            [-12.922571880537744, -4.323807252107838],
            [-12.919958745634029, -4.317771306145221],
            [-12.920691954692463, -4.313036310922024],
            [-12.915951942910255, -4.306590945685749],
            [-12.915944039742705, -4.304054905625503],
            [-12.92102861888308, -4.294457620444316],
            [-12.925154104900033, -4.311113300664995],
            [-12.924225648430017, -4.3112696230626],
            [-12.939182045563843, -4.397503090736192],
            [-12.95093079891929, -4.465451921410818],
            [-12.968930378923801, -4.569684890637337],
            [-12.969616922515236, -4.569568098510294],
            [-12.98452219950224, -4.655674482426238],
            [-12.984958279772243, -4.655911064493791],
            [-13.002946599709825, -4.759885105496289],
            [-13.029089447267319, -4.9109443008035845],
            [-13.043379603197813, -4.993650829286288],
            [-13.05931127278562, -5.085578597403685],
            [-13.190301530235292, -5.062881556499511],
            [-13.321288036256604, -5.040162275584284],
            [-13.366050531479788, -5.033038595991872],
            [-13.49060576488174, -5.011775067115953],
            [-13.647799149960372, -4.983780221940867],
            [-13.740456947223576, -4.967414398225242],
            [-13.866602678772233, -4.9443948099716515],
            [-13.9927447311618, -4.921354492710982],
            [-13.97646041943651, -4.8342706600107626],
            [-13.944743954557774, -4.662850003746172],
            [-13.934294343375825, -4.606012357807288],
            [-13.909989715115826, -4.474668610231551],
            [-13.898092422889196, -4.410329870228522],
            [-13.881050891081953, -4.317979977278207],
            [-13.864673245227147, -4.231586009650875],
            [-13.8570242329333, -4.189112215230012],
            [-13.857085858043531, -4.186640518863429],
            [-13.833583817919475, -4.060895305581273],
            [-13.834495837541438, -4.06068258613352],
            [-13.814769981340833, -3.9539213835172795],
            [-13.800068888917297, -3.8744691505215445],
            [-13.786803383091303, -3.802671102477606],
            [-13.71935624485019, -3.445613323566157]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -112.4914750530748, "lat": 33.34900946464533 },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04013"],
        "coty_name": ["Maricopa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Maricopa County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00037026"
      },
      "bbox": [
        -13.9927447311618, -5.085578597403685, -11.944483644414877,
        -3.445613323566157
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.974326091092946, -4.175089792528583],
            [3.9964430749449082, -4.174912483457011],
            [4.005708752764909, -4.1747802846260855],
            [4.020369929414119, -4.175491648999386],
            [4.047364408303642, -4.1749762480549855],
            [4.063727075158979, -4.173241940580676],
            [4.060863094558588, -4.085258180414664],
            [4.149601587235044, -4.083558054184551],
            [4.237810873278997, -4.0814702550785125],
            [4.308231991277681, -4.079749277211689],
            [4.308253200173103, -4.084832721345461],
            [4.306694548428871, -4.090534869851642],
            [4.307831170587891, -4.095811731082121],
            [4.306509670067532, -4.099476342561351],
            [4.3015031017376275, -4.106765009352389],
            [4.305500066144545, -4.111023620041436],
            [4.310511958194082, -4.112070585727099],
            [4.32024692634646, -4.110330008821134],
            [4.326327926715721, -4.113300248097292],
            [4.333099703153739, -4.1127783964352425],
            [4.335355544040663, -4.115198172807671],
            [4.334400855800356, -4.118817700176559],
            [4.335352775453665, -4.127246188757853],
            [4.331284699549587, -4.135567846905238],
            [4.333294795901966, -4.138382354760238],
            [4.339610274028351, -4.1368931489527565],
            [4.343715593425052, -4.137900622782098],
            [4.344374063780084, -4.141124528713059],
            [4.341485642295808, -4.147370203086385],
            [4.342342690549834, -4.150947577494001],
            [4.3458457239397, -4.153168830968806],
            [4.352345632224573, -4.151825525640462],
            [4.355097256682029, -4.152967491359222],
            [4.361344010474606, -4.159232613628587],
            [4.368509963673809, -4.158279456122772],
            [4.371048889974223, -4.152618187107291],
            [4.374055698953453, -4.151592323693733],
            [4.378615184082687, -4.1543489852436934],
            [4.379674727028266, -4.157604718098346],
            [4.375695752705845, -4.163003392143932],
            [4.374338979443688, -4.169406605783648],
            [4.369436714436346, -4.175272936107331],
            [4.371067284338881, -4.178601645935489],
            [4.37684374827634, -4.178105134333686],
            [4.382631165569041, -4.181758069830032],
            [4.381357349767297, -4.187743240123864],
            [4.371928314115786, -4.185488141660229],
            [4.373665444993442, -4.195221535306108],
            [4.377951649225031, -4.197175440436654],
            [4.3841522925992455, -4.1931853197057105],
            [4.3877146046595925, -4.193070300427163],
            [4.395553480303314, -4.198115664964389],
            [4.398488012620349, -4.196716206415274],
            [4.403419210303811, -4.187161512905652],
            [4.406286466607093, -4.185223524482917],
            [4.409171813340738, -4.186569220071206],
            [4.410758483128057, -4.193048107699088],
            [4.413998307041236, -4.197048263973609],
            [4.413718157026839, -4.202510331443982],
            [4.420776409760387, -4.2012973719085505],
            [4.422765492890394, -4.20422923061544],
            [4.4231901448329385, -4.2095557841678195],
            [4.427743318406995, -4.214440747154282],
            [4.425825386903231, -4.219172689027148],
            [4.418528061510626, -4.218623516328657],
            [4.41801808314601, -4.223964138615397],
            [4.420893174384851, -4.226425156547719],
            [4.42640841443176, -4.2283451594600985],
            [4.430397792772025, -4.233240372829547],
            [4.433837190609534, -4.23468674572048],
            [4.440709342896015, -4.233098179698224],
            [4.444218304539202, -4.236197352877088],
            [4.443831724917329, -4.240256403320157],
            [4.44946881494729, -4.249948104956868],
            [4.4488399427290055, -4.254570017401839],
            [4.453564749034439, -4.2575964311505095],
            [4.46095416121976, -4.265541621590003],
            [4.469853659261034, -4.268640689007764],
            [4.470488152449028, -4.274094466423326],
            [4.467388501189615, -4.278449734693273],
            [4.469023032755634, -4.281387200536035],
            [4.4767325591005935, -4.28246622587828],
            [4.479351341453682, -4.284160139361423],
            [4.4807763233049585, -4.289596104664084],
            [4.4863892360619, -4.288250946572781],
            [4.490197828902473, -4.288886701872337],
            [4.492328333327181, -4.28570390283133],
            [4.502350399931091, -4.295242026747144],
            [4.506465399224338, -4.296394552954001],
            [4.5119648550219, -4.296029731114395],
            [4.51477128665245, -4.300411023314849],
            [4.5123671200375, -4.306437653852765],
            [4.513521245330376, -4.310659087508506],
            [4.506963106598558, -4.312597532462817],
            [4.507590856500665, -4.315383953622529],
            [4.513009868466363, -4.314238304869475],
            [4.516638602732637, -4.319331489222857],
            [4.514592725439419, -4.323225854700971],
            [4.5080231535273345, -4.320826316066077],
            [4.506472257599314, -4.322732308989627],
            [4.510341656171212, -4.3298138931079695],
            [4.510058907126507, -4.336414242135759],
            [4.512575704327726, -4.34091795652832],
            [4.5116473825707235, -4.3456224859143315],
            [4.506440733915378, -4.343356428792596],
            [4.507442192502421, -4.339420032567169],
            [4.503725668596727, -4.335039673796387],
            [4.500512415217116, -4.337279087016962],
            [4.500518607936844, -4.345443235952266],
            [4.497299811796095, -4.350460176419512],
            [4.501104159943999, -4.356807514108298],
            [4.500159757440709, -4.3660830862274995],
            [4.503433643486623, -4.368327791362431],
            [4.508616512293558, -4.368045302967337],
            [4.506097642024863, -4.372180775005914],
            [4.510934602453909, -4.378550389290249],
            [4.506273127472358, -4.383464939210078],
            [4.498210085245769, -4.38559965790562],
            [4.501892480743092, -4.390473657313513],
            [4.508678134688611, -4.393227647662399],
            [4.5096741724260605, -4.395034537279208],
            [4.5083964134800905, -4.402056664520509],
            [4.509502032024626, -4.409385863973893],
            [4.513578469175918, -4.41343276174445],
            [4.514732497163387, -4.416529286691759],
            [4.50775317723821, -4.421994174428681],
            [4.50762717465548, -4.431267260274078],
            [4.50391790529114, -4.436863038701337],
            [4.4990104717808315, -4.436540138661458],
            [4.496034509765527, -4.433165336417815],
            [4.49309733758811, -4.43319412337121],
            [4.492545643674175, -4.438194769243522],
            [4.48875456111364, -4.445267801929209],
            [4.488826339442696, -4.448239084871269],
            [4.494183383734024, -4.452082855367731],
            [4.494025266657224, -4.455103173888128],
            [4.489616948659468, -4.457119150272148],
            [4.490905447484839, -4.461360679003158],
            [4.494362800722169, -4.4636372160535345],
            [4.499147786305539, -4.47320518813943],
            [4.497135413935257, -4.476617828783884],
            [4.493599828738357, -4.478599904896491],
            [4.499544210446999, -4.488707342850197],
            [4.498975678339627, -4.493564368205458],
            [4.493615836560371, -4.493069193878126],
            [4.489953968721472, -4.494233609815849],
            [4.487695367013159, -4.4978978799090195],
            [4.488201875815663, -4.502787880355211],
            [4.485389634508425, -4.506330593422464],
            [4.481199859747177, -4.503501972691304],
            [4.478048537132016, -4.50451480777981],
            [4.476264105454616, -4.510784750384597],
            [4.472843060822014, -4.5170056601721],
            [4.469657821602905, -4.5283572506432455],
            [4.4676159702906215, -4.530438292574073],
            [4.461072808196418, -4.5293878045667295],
            [4.4549090674979235, -4.525482905082884],
            [4.4521399154974, -4.531209644368389],
            [4.454583400574975, -4.535423251998965],
            [4.448506329644386, -4.537224629672616],
            [4.4496435054878445, -4.549683085512752],
            [4.446480121155662, -4.552897730375416],
            [4.441727723520702, -4.551922427633428],
            [4.437977359975518, -4.546477499678001],
            [4.433267526892479, -4.5438751580521455],
            [4.428087629614752, -4.550010578147094],
            [4.421016385514528, -4.554914567841691],
            [4.41858118830817, -4.560821791081019],
            [4.421551736132507, -4.564901828204746],
            [4.419420351370112, -4.567256391377327],
            [4.414685549586552, -4.565791794366018],
            [4.413948048133823, -4.571172467162339],
            [4.418400168666898, -4.577093640665073],
            [4.412603051508846, -4.585314174688775],
            [4.411554084767884, -4.590715279856825],
            [4.413657366909891, -4.604219788772634],
            [4.415412306289623, -4.6064593165629475],
            [4.421428878215755, -4.607527217191973],
            [4.42364258070117, -4.611460990788675],
            [4.422749761638035, -4.619571172604009],
            [4.423502569414083, -4.621610703121658],
            [4.431389616511961, -4.622375131725796],
            [4.435570425781994, -4.623951244295026],
            [4.442276435262111, -4.6324139676616545],
            [4.44729262759196, -4.644504520202289],
            [4.447394133347591, -4.651883100610823],
            [4.446475377751427, -4.659197755808461],
            [4.449123535642324, -4.661715708247166],
            [4.456055158807798, -4.663319704552373],
            [4.460073388265895, -4.669945366327587],
            [4.466384310874572, -4.675249150075561],
            [4.463821276085922, -4.681951775057036],
            [4.455705264760198, -4.682719330839736],
            [4.45438151760144, -4.686986511316636],
            [4.461735890874447, -4.689167744894153],
            [4.4620101136434105, -4.692855815982809],
            [4.455893675339204, -4.695146123300734],
            [4.454628424741549, -4.700656902533152],
            [4.463511224278693, -4.705665807288092],
            [4.4639336858488, -4.709702072676302],
            [4.454619713849371, -4.707955596163276],
            [4.451424297899981, -4.708438836657396],
            [4.447317092406703, -4.711862765746741],
            [4.444989282193234, -4.7172893252779655],
            [4.439203102665428, -4.715882693154898],
            [4.437180415973031, -4.713688910048246],
            [4.437026930396104, -4.707202931142144],
            [4.441468259840196, -4.699791209829717],
            [4.445850438097444, -4.6949167481766345],
            [4.4452909628862445, -4.690165330912445],
            [4.443048680391101, -4.684633581331875],
            [4.438172207783831, -4.680022555844549],
            [4.430912399733675, -4.6803761504198675],
            [4.421228823317564, -4.6853146059279265],
            [4.4122322315759375, -4.686914346122998],
            [4.40776030203841, -4.68572979690264],
            [4.401092335771192, -4.685992515311134],
            [4.394844889987266, -4.691075650511244],
            [4.3917447138246315, -4.699534544267588],
            [4.387484388570269, -4.700821550353235],
            [4.382929200095111, -4.6967090926170805],
            [4.3816981207940575, -4.69244341062815],
            [4.383267623659221, -4.683644076821357],
            [4.387415408949367, -4.6792088054452705],
            [4.388357933534177, -4.670385106338574],
            [4.387824368376593, -4.6633625037932855],
            [4.381931267428374, -4.666095551447478],
            [4.3775370190337535, -4.672717785927931],
            [4.375284049295006, -4.678533052984354],
            [4.371109692879968, -4.685325667506892],
            [4.367926967393947, -4.686342819196834],
            [4.362355351851712, -4.6852526909991346],
            [4.360459098214835, -4.694455774697699],
            [4.358351842152096, -4.700075906787937],
            [4.352200985394744, -4.700791295013798],
            [4.342848776831727, -4.693345254726078],
            [4.338091670354189, -4.685212669945282],
            [4.339172385496208, -4.676419319288049],
            [4.338127564006701, -4.675065392092933],
            [4.325453437146417, -4.6837177771119265],
            [4.316080965148883, -4.6864137670970205],
            [4.3066893420813175, -4.687078697875997],
            [4.292353077122111, -4.6911318325380185],
            [4.285989078836029, -4.688062312617709],
            [4.283875538727311, -4.683605016915507],
            [4.285108271460908, -4.6809289871856326],
            [4.291630743912336, -4.674692143841443],
            [4.299709479985993, -4.671998937624036],
            [4.304746639768362, -4.6762836312306915],
            [4.309864122524152, -4.678127986651662],
            [4.315198413762052, -4.676918038149548],
            [4.320733162211332, -4.66985742675475],
            [4.321279048253393, -4.662395428681656],
            [4.318387074503726, -4.653712891225987],
            [4.314237238522491, -4.644121611000446],
            [4.31309849792902, -4.638568950532154],
            [4.308080856457104, -4.63145904431693],
            [4.305809557920202, -4.6297142831422455],
            [4.299561965410754, -4.62828790955915],
            [4.296869699452627, -4.629612208565379],
            [4.295856212020253, -4.6348069304314645],
            [4.298262693842618, -4.638529165980314],
            [4.3033743213474, -4.643363583015539],
            [4.306551137509388, -4.6495282474158905],
            [4.308292629040842, -4.65868595009712],
            [4.3044892365483385, -4.661658467536291],
            [4.30077226178968, -4.662092869120349],
            [4.297484929389177, -4.658183741414439],
            [4.293303823031013, -4.648827370351811],
            [4.288427201464334, -4.6428668500939105],
            [4.285786592237576, -4.641448269539673],
            [4.28093327465746, -4.642510324395426],
            [4.278106123302816, -4.646275683477316],
            [4.273185497073559, -4.660669507081903],
            [4.2699730956827135, -4.664784856631986],
            [4.264692090800486, -4.667668201239017],
            [4.2609054556605646, -4.6682860400466115],
            [4.254777669248022, -4.6660580942749865],
            [4.251010374318399, -4.661753127758098],
            [4.24497713225943, -4.650529447626797],
            [4.241377155675165, -4.646183657684562],
            [4.228553724804693, -4.637067117261616],
            [4.2193412426038615, -4.63021967709875],
            [4.216349297801037, -4.626069700024636],
            [4.213953652079101, -4.61919835139982],
            [4.214161196341632, -4.615439942166526],
            [4.217269996526632, -4.601725621407062],
            [4.216704728462128, -4.587891198916165],
            [4.214377448264591, -4.578750385463344],
            [4.212368196323012, -4.575123908994956],
            [4.206256585188791, -4.56889297126535],
            [4.213096581607129, -4.565205885615609],
            [4.213779513367722, -4.559675388205715],
            [4.208090049596635, -4.5615095166712445],
            [4.210323940326569, -4.55657153936485],
            [4.207558041545395, -4.545571285243177],
            [4.208693451899897, -4.543199886263013],
            [4.2050556255210845, -4.53540083942899],
            [4.205261821802705, -4.532506639618181],
            [4.201714517816961, -4.528353679161728],
            [4.203115821880703, -4.521390499854497],
            [4.199180855588567, -4.52125767018401],
            [4.198058310814997, -4.515694252232573],
            [4.188465659943346, -4.5143171593147935],
            [4.176328970364915, -4.516118118214378],
            [4.174649229621241, -4.519482507078554],
            [4.164462796255569, -4.523869216417591],
            [4.161408022311211, -4.520695854063877],
            [4.162156902190807, -4.502198279464337],
            [4.156168501339913, -4.502218743630266],
            [4.152701935555104, -4.505761630854682],
            [4.152563448637706, -4.508439394128087],
            [4.14754660048741, -4.509867631479471],
            [4.1451379845818, -4.506457972128674],
            [4.146464823321883, -4.5031922340682025],
            [4.145121244108254, -4.494874571517889],
            [4.140157290915573, -4.488020468989182],
            [4.144448737458556, -4.479393083153],
            [4.141068759085357, -4.477458063231056],
            [4.137310099592267, -4.470725876945189],
            [4.133797238737024, -4.468992905384213],
            [4.136560307643543, -4.460950264306351],
            [4.134155833796357, -4.454424628790638],
            [4.130204983729174, -4.450184305423443],
            [4.132280225000973, -4.442668598871902],
            [4.13145039690027, -4.436873397400288],
            [4.127162964410091, -4.433556914255666],
            [4.124484488003957, -4.42944659201943],
            [4.121365293940305, -4.428057667642325],
            [4.113069276242366, -4.430614360011567],
            [4.108320135076064, -4.427777102337227],
            [4.100925214034878, -4.4285351604551035],
            [4.098535028028419, -4.430339324841649],
            [4.091457672687726, -4.4309207522658145],
            [4.0910413705931425, -4.4336489295894586],
            [4.084789467601707, -4.439962082475453],
            [4.08100592478138, -4.442429677575525],
            [4.076467800313467, -4.4423841388708825],
            [4.075010383429319, -4.438051890732297],
            [4.0767789398960375, -4.433445733395581],
            [4.078048754255039, -4.425963576722686],
            [4.072831076709406, -4.4261011922851985],
            [4.072749889960027, -4.423400095997958],
            [4.065944119886911, -4.424776439598237],
            [4.000872583566777, -4.424752356342608],
            [3.98039199857686, -4.425211282478889],
            [3.9788053508534573, -4.36433430459383],
            [3.977239630121088, -4.293370066843331],
            [3.9767023188016513, -4.263319210855645],
            [3.9754895884491956, -4.223296025720226],
            [3.974326091092946, -4.175089792528583]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.3741889362752, "lat": 34.28916622384243 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05001"],
        "coty_name": ["Arkansas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Arkansas County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00063755"
      },
      "bbox": [
        3.974326091092946, -4.7172893252779655, 4.516638602732637,
        -4.079749277211689
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.316194590434821, -2.9373767624039195],
            [2.458336230116829, -2.9389773280495555],
            [2.4587323095601827, -2.968225599331801],
            [2.5289169095062483, -2.968974851879939],
            [2.5718658024754015, -2.969027698579003],
            [2.59989666246032, -2.9685165744493225],
            [2.6861101706752697, -2.966287377462549],
            [2.7158961694051627, -2.965668642545785],
            [2.744507963784005, -2.9658788653698642],
            [2.7454692855867013, -3.0829014201755673],
            [2.7457348391633145, -3.0979540377049792],
            [2.7313925031800563, -3.0977425352417063],
            [2.7026278948627587, -3.097979090346031],
            [2.7027759379254723, -3.1417030333516265],
            [2.7033022113029435, -3.1418247461528934],
            [2.7039830754461023, -3.1783622800449565],
            [2.704434945490085, -3.2293243595784507],
            [2.660626997886773, -3.22934524536512],
            [2.646261200525919, -3.230010741880426],
            [2.647073350258321, -3.3100019269047904],
            [2.647909920198174, -3.373588830706122],
            [2.631514516281132, -3.3649759752959203],
            [2.625728502234566, -3.362409457751298],
            [2.619059836065325, -3.3619819519873206],
            [2.612351398982713, -3.3636535710154893],
            [2.593945143368119, -3.3704428118710203],
            [2.583589669413995, -3.372536114219478],
            [2.5773925891058855, -3.371270924451363],
            [2.561562771804408, -3.374245816567974],
            [2.5516718670431704, -3.3768046773052536],
            [2.5485261796664367, -3.374090269365459],
            [2.5475599541259446, -3.366725793583617],
            [2.554315740611376, -3.361785336869891],
            [2.5580458673540822, -3.362361937419733],
            [2.5640216001302485, -3.359809356670013],
            [2.5681694840214933, -3.356214192306487],
            [2.565520356823725, -3.352812795552061],
            [2.5597694111071476, -3.3484470574711596],
            [2.5535491861776283, -3.342001045165398],
            [2.55042534173943, -3.334248440586693],
            [2.5463058568725403, -3.3187232686359316],
            [2.5425691984794017, -3.3100748284235926],
            [2.5450072710314777, -3.28451918431661],
            [2.5414046921411932, -3.277776012571152],
            [2.535334187790531, -3.274186509483004],
            [2.5274644481928346, -3.273213266469932],
            [2.5237839396600585, -3.2741604122928343],
            [2.5169775136214803, -3.2797543797942774],
            [2.5071212732682784, -3.2912546262610722],
            [2.492397061058324, -3.3054612177628355],
            [2.485008071693123, -3.30913987686543],
            [2.4803407454868336, -3.307715848583091],
            [2.4686395238196672, -3.295576634930377],
            [2.461996690721691, -3.293408017705373],
            [2.451427209851885, -3.2955469877321666],
            [2.448286494711094, -3.2979051774896804],
            [2.439864540080063, -3.308801943210083],
            [2.4349092030170643, -3.313362202615935],
            [2.422719564650809, -3.3192895099867883],
            [2.406803299940381, -3.3241463771039967],
            [2.3961263014447747, -3.3266610395571434],
            [2.3871877231802863, -3.327535913734056],
            [2.382300639245372, -3.326528591573688],
            [2.3726750622595305, -3.320433077537195],
            [2.364179924114208, -3.317390304923983],
            [2.3605218508782375, -3.31292878762775],
            [2.352087366137364, -3.3047479567508624],
            [2.3465002310444913, -3.3038814922219055],
            [2.3410866235952934, -3.3113141608947094],
            [2.3372398007408366, -3.325151940751864],
            [2.3312535329681867, -3.331678738366116],
            [2.322069970729929, -3.3348932547621177],
            [2.314353335369694, -3.3338633043220405],
            [2.3147235576407774, -3.2296927917773517],
            [2.314998980761373, -3.207798191359242],
            [2.315477142585937, -3.1416039744567894],
            [2.3156935667575858, -3.0545171659648793],
            [2.315893716663671, -2.9958934139599918],
            [2.3164611473261005, -2.9520329256163476],
            [2.316194590434821, -2.9373767624039195]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.4601779973353, "lat": 35.5697143264046 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05071"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00066863"
      },
      "bbox": [
        2.314353335369694, -3.3768046773052536, 2.7457348391633145,
        -2.9373767624039195
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5483035533985783, -5.237351823985043],
            [2.548483285698764, -5.149683881899702],
            [2.5486486068573426, -5.106427837995596],
            [2.548411603013694, -5.070465177752635],
            [2.548653855780672, -5.047480461885775],
            [2.5486017794164244, -5.012237788891308],
            [2.548360893734577, -4.988275473070417],
            [2.5487836466724354, -4.955740090697966],
            [2.5488603861676458, -4.88692898610919],
            [2.5574017064876946, -4.886980167966397],
            [2.5573387720310996, -4.8394725585638],
            [2.5576243697584164, -4.798982882974677],
            [2.557336898226828, -4.754655328834833],
            [2.5598443427454662, -4.750754541909867],
            [2.5677425465901966, -4.755292100631332],
            [2.5715036604303525, -4.75391557965522],
            [2.575641171216194, -4.7562229945955234],
            [2.582060964170093, -4.755097809521977],
            [2.591032586353487, -4.758821606003148],
            [2.592513105003642, -4.7568178361786835],
            [2.6044443665098753, -4.758903943216795],
            [2.6080363866538243, -4.7554360627131755],
            [2.6136693243873452, -4.7545818836387435],
            [2.612018491042279, -4.751491243875381],
            [2.6258829931619516, -4.752522765183056],
            [2.6263810589508063, -4.755009084938768],
            [2.631427239173217, -4.757968552675473],
            [2.635213938422392, -4.764429779462979],
            [2.6380495720619135, -4.7609895042013],
            [2.6402382199063443, -4.763266132154932],
            [2.640394635456648, -4.769016053096],
            [2.6453319542857336, -4.7754226351670725],
            [2.649495138916018, -4.772261526769769],
            [2.654264959858645, -4.774783198737776],
            [2.6522807622152524, -4.778173095044272],
            [2.6543696254003653, -4.784578991400858],
            [2.6574072169363934, -4.789578258955628],
            [2.6615912604152205, -4.792466284540042],
            [2.6666507189106414, -4.790772799187752],
            [2.6702879131666557, -4.794093509023232],
            [2.6682469144355623, -4.799113264982911],
            [2.672916121618658, -4.802861787059765],
            [2.6757121001288167, -4.801513625726359],
            [2.6868206401684995, -4.811204013020461],
            [2.6893951481057434, -4.816389627713498],
            [2.689723283129449, -4.821476083014171],
            [2.6856023989744915, -4.82327088030125],
            [2.6847178202089115, -4.825817615034193],
            [2.684510259816011, -4.834802529311241],
            [2.68567784169018, -4.839380983121763],
            [2.691769950175335, -4.848493530231008],
            [2.690549196992026, -4.851604008042883],
            [2.698056349502379, -4.863998531189613],
            [2.7023107980796306, -4.863773060441211],
            [2.7106889996053494, -4.86826668382613],
            [2.710936465947937, -4.871103391559258],
            [2.7170867264657614, -4.868329588344257],
            [2.718078845471811, -4.872721458298692],
            [2.722809368775662, -4.875390273089847],
            [2.7256096625983206, -4.878708795695797],
            [2.732107455958176, -4.876931039266318],
            [2.738102276981082, -4.8780019988525725],
            [2.741387972589075, -4.877261220145335],
            [2.743310162134095, -4.879776131882253],
            [2.7542327465776086, -4.877430324761583],
            [2.7571247495370845, -4.877979644826445],
            [2.763823594580382, -4.885258833027528],
            [2.766160926394743, -4.8836058989634195],
            [2.77388441733884, -4.888687243695614],
            [2.779963207208181, -4.889668206426522],
            [2.7828565849741165, -4.895546422018307],
            [2.7861671703295094, -4.899012324153685],
            [2.7854467996857424, -4.9021222127207835],
            [2.790539552261329, -4.905310340641813],
            [2.793869512821166, -4.899112852522671],
            [2.8010008849420607, -4.899352098902931],
            [2.8091520604081768, -4.894609982070168],
            [2.8171966454840733, -4.895205095800187],
            [2.816084026218469, -4.892540281500113],
            [2.82199445923078, -4.88895219801139],
            [2.824196402350408, -4.893034245601428],
            [2.827399022085678, -4.894835871087782],
            [2.829236504218995, -4.900057310219252],
            [2.833122309723662, -4.90640984330303],
            [2.8323133464637595, -4.911602292079839],
            [2.8392642345905394, -4.915194170777114],
            [2.852737783745879, -4.926718556160988],
            [2.8528603370292616, -5.03146726105707],
            [2.8531444307394285, -5.091016548837062],
            [2.8527517806209834, -5.1498118721444035],
            [2.852720578325128, -5.237447569307621],
            [2.8528077834545824, -5.252057129311578],
            [2.765928885636622, -5.252469301914212],
            [2.7661911334796954, -5.2671008857028525],
            [2.751472146977483, -5.266072677490836],
            [2.64654486373916, -5.266478274100146],
            [2.5917940274580515, -5.266465296093097],
            [2.548480025324569, -5.2662390769028775],
            [2.5483035533985783, -5.237351823985043]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.30717773694646,
          "lat": 33.664019964054134
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05099"],
        "coty_name": ["Nevada"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nevada County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00069169"
      },
      "bbox": [
        2.5483035533985783, -5.2671008857028525, 2.8531444307394285,
        -4.750754541909867
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.969397410751065, -5.324461799802985],
            [3.0010835897414734, -5.324216408778848],
            [3.0851968468399344, -5.32434523953455],
            [3.122277587103396, -5.324046985235328],
            [3.125475163407328, -5.322036716313912],
            [3.1361646067571045, -5.3212120089133474],
            [3.1398700079454964, -5.315004190537086],
            [3.1441923097448803, -5.315041440954222],
            [3.149323631918926, -5.311003557319548],
            [3.1499862677978077, -5.307987828704405],
            [3.1603138540364792, -5.311634832984852],
            [3.1674474297849735, -5.309863657595653],
            [3.173445620568087, -5.3101599968987525],
            [3.1759777717002287, -5.311754426055581],
            [3.18337586600095, -5.312354102322498],
            [3.1863035664172354, -5.3174464213201045],
            [3.1881047940759215, -5.323884358844188],
            [3.1923431542781913, -5.323970033787577],
            [3.199120465354455, -5.327578794866926],
            [3.2032399035305197, -5.324655794467532],
            [3.210801042635692, -5.327353731380371],
            [3.21596742847804, -5.327621587102642],
            [3.215629233433246, -5.333408960008818],
            [3.2233269613555353, -5.336129008155207],
            [3.2276518545562802, -5.334523669875828],
            [3.2318710143071523, -5.336702285941228],
            [3.2366340713273347, -5.334884530542701],
            [3.2388246876926234, -5.328381113068093],
            [3.2438424611172034, -5.326672289928889],
            [3.245391078281164, -5.323879444759601],
            [3.2564099680855945, -5.326337106267376],
            [3.258930490333075, -5.3301481019883905],
            [3.2639025546662235, -5.332607410807391],
            [3.2728117972118036, -5.331340764625045],
            [3.274761509025484, -5.326909111176636],
            [3.278000985493537, -5.329122146980163],
            [3.281943270554881, -5.326792101330448],
            [3.285645155531366, -5.319631398317952],
            [3.2900955888572785, -5.3174873734035435],
            [3.294450897282425, -5.321568870335511],
            [3.300848445233244, -5.32188042934841],
            [3.305667076193873, -5.320306150964418],
            [3.307387816945588, -5.322987868704153],
            [3.310721099140543, -5.322890081018476],
            [3.315464639323547, -5.3279755924833765],
            [3.3175254405279824, -5.328216278605032],
            [3.327869304216576, -5.323797008115593],
            [3.3281762045299064, -5.33002025982202],
            [3.334090243692371, -5.3331533361257755],
            [3.338630547178825, -5.332813995946428],
            [3.3398867722977914, -5.335966229139349],
            [3.337711510618217, -5.340950335057087],
            [3.3431457185445566, -5.345047995984509],
            [3.34328241944832, -5.350515719563614],
            [3.345416490197797, -5.356418213886915],
            [3.3507121843511296, -5.355446917460493],
            [3.351624678857229, -5.358331470854647],
            [3.3486679025556283, -5.360672009340547],
            [3.3459283458052136, -5.368299391513497],
            [3.3481487538986854, -5.371946676335304],
            [3.360606963582389, -5.365350484539765],
            [3.3638555163663857, -5.361649770107581],
            [3.367948657299571, -5.360515760037418],
            [3.3707013287036545, -5.362275362868044],
            [3.3748007985050603, -5.3677396639167965],
            [3.375293873742368, -5.370821839607645],
            [3.3808135556926358, -5.371297728762948],
            [3.380185566491089, -5.364814296055889],
            [3.3838668092899793, -5.359708577197815],
            [3.3857848580976766, -5.360121276285376],
            [3.390393971685961, -5.36695321119211],
            [3.3912657604848415, -5.371955123680339],
            [3.395825407570783, -5.371917815094406],
            [3.399598114461029, -5.366741862829218],
            [3.402219235808023, -5.368222394338492],
            [3.402463644287843, -5.372043854596872],
            [3.3972116733844744, -5.3760500094986385],
            [3.392984811110955, -5.381539368053992],
            [3.3965409260401027, -5.383555139125192],
            [3.401202165024555, -5.380885967107684],
            [3.40232626022866, -5.3843286262524614],
            [3.3950437244004745, -5.389558164778295],
            [3.391489615186639, -5.3937064358722395],
            [3.400745073868243, -5.3999139998648],
            [3.40263778331912, -5.403772264300595],
            [3.4057046934330653, -5.399862353042024],
            [3.408438080659071, -5.399341567234508],
            [3.4140936680305014, -5.404654269180902],
            [3.415235853157937, -5.412093444472848],
            [3.420679276415808, -5.412044928524745],
            [3.423364374501189, -5.409373218065898],
            [3.4267152040275253, -5.411575729721913],
            [3.427846142326534, -5.416349355335396],
            [3.4358136605771996, -5.41224889671816],
            [3.4493671855434966, -5.410672223005792],
            [3.455057605677732, -5.408008440632868],
            [3.46918663404608, -5.405748661840429],
            [3.472807381773675, -5.403141964358172],
            [3.4760282606787936, -5.39620542475336],
            [3.4823916723928674, -5.394041474274398],
            [3.48508002487134, -5.39078758622544],
            [3.4854470562226836, -5.38333429650586],
            [3.488699132420529, -5.38204564596482],
            [3.4931429531484226, -5.384687252378444],
            [3.4917196563272013, -5.390437752825493],
            [3.486849605339741, -5.395657773661082],
            [3.486274117000382, -5.401301389945507],
            [3.4878541662723292, -5.402603111305528],
            [3.493243786360356, -5.401534639100243],
            [3.5000314357836766, -5.403032975899936],
            [3.504252511911926, -5.407372366190171],
            [3.508264279692598, -5.4063657893706685],
            [3.51153794091671, -5.403046480399189],
            [3.513287247547409, -5.405719264736344],
            [3.513047034656305, -5.411325993729863],
            [3.5153147358272747, -5.415248441053467],
            [3.5142963626213133, -5.420101702876846],
            [3.5220277933499022, -5.420912917410552],
            [3.5283520759816853, -5.417633720678856],
            [3.529055383024561, -5.415591617090166],
            [3.5255181755349394, -5.411338492879012],
            [3.5285018452057084, -5.408415861258025],
            [3.532856226714759, -5.40958725626438],
            [3.5345821414686855, -5.403733251201796],
            [3.5376402051772566, -5.400837393948792],
            [3.540222871518108, -5.40182738424428],
            [3.543157090618799, -5.407244808214402],
            [3.5413477547165253, -5.416174227611376],
            [3.5455566831341803, -5.418303362630676],
            [3.5539158578621346, -5.412897862305254],
            [3.560288992286342, -5.4144654040517155],
            [3.5628640183240905, -5.41808568190061],
            [3.562560286733744, -5.424671813211641],
            [3.5663125974508, -5.426073513828264],
            [3.5718941528707964, -5.423591180824681],
            [3.5742470440796845, -5.424142744465715],
            [3.5790966689394623, -5.429037091404971],
            [3.582879648206671, -5.430024602579225],
            [3.5871632774502866, -5.427166045053061],
            [3.5892994042052337, -5.421429252477616],
            [3.599643020649235, -5.427120507890581],
            [3.5994175979209837, -5.434489897933951],
            [3.5971138143806254, -5.440310603811408],
            [3.5933131931065527, -5.443323001637212],
            [3.5942275741319003, -5.448719483641382],
            [3.60323253780309, -5.452304641307446],
            [3.6098016810178795, -5.452176600167458],
            [3.6105360825623722, -5.45591520111881],
            [3.6024727102803724, -5.457620773605929],
            [3.600567640264336, -5.46383854153773],
            [3.6011296836288516, -5.46789477795109],
            [3.6042021466586283, -5.470364421824263],
            [3.6093164498710038, -5.4703873460748005],
            [3.6131255848403474, -5.476968975368248],
            [3.621271092727092, -5.474176184517553],
            [3.625309203267973, -5.476927439006048],
            [3.6323173239357636, -5.47351998881384],
            [3.636002396539286, -5.465147477531037],
            [3.638790051011082, -5.4657499237495015],
            [3.639696986413841, -5.471456812885565],
            [3.638891324958453, -5.479147533960669],
            [3.642669774540439, -5.484095371974151],
            [3.6386276952277874, -5.485472647488046],
            [3.6371624278583488, -5.488912637329801],
            [3.639853071869306, -5.491664829914618],
            [3.644887145458324, -5.489892770987034],
            [3.643612839054768, -5.495251474066563],
            [3.646288877072192, -5.495391837425769],
            [3.6519864865605944, -5.500825560449224],
            [3.6537816398078844, -5.5042930482012595],
            [3.6529577578978416, -5.507740444056127],
            [3.6462572995917784, -5.513358932405402],
            [3.6486459246071106, -5.5154499716417025],
            [3.6544589647940975, -5.516429696509964],
            [3.6572351279030064, -5.514467039007498],
            [3.6550937131861936, -5.510536360234033],
            [3.6604298280887844, -5.509331872582876],
            [3.66433797514682, -5.50678783819999],
            [3.6687056078842124, -5.50951842339216],
            [3.6660048355059516, -5.513443796189477],
            [3.667663155681383, -5.515758275325068],
            [3.67517983975151, -5.513849081921627],
            [3.677895866416139, -5.516597827356791],
            [3.688044183786916, -5.514458441871175],
            [3.696872580469714, -5.517152475466932],
            [3.6995840430944478, -5.524501037560479],
            [3.700209489321636, -5.530028378055508],
            [3.697792717584676, -5.531934704851985],
            [3.6915790276134035, -5.530835059400834],
            [3.691720426606438, -5.534096980038385],
            [3.695335212868731, -5.538282341958837],
            [3.6966575874836822, -5.542822582867815],
            [3.6916145305570858, -5.556734456404263],
            [3.684317697284487, -5.557456870274951],
            [3.684362657134923, -5.560955037996136],
            [3.678134484878999, -5.570025872055723],
            [3.6780960692350644, -5.575140338490052],
            [3.6732556166858887, -5.579392277732635],
            [3.6809449315350453, -5.578866637497916],
            [3.680268375967961, -5.585119588228331],
            [3.68550681733483, -5.601270631703646],
            [3.685697001010698, -5.606078638013476],
            [3.695645270497494, -5.604183967408844],
            [3.698711481463256, -5.607274003709956],
            [3.698030345831077, -5.6102077757832],
            [3.700881399939984, -5.619163507447708],
            [3.7034560227393856, -5.622665203434547],
            [3.702379879923315, -5.625824472943171],
            [3.698453117101076, -5.628912318817826],
            [3.702859342327719, -5.63283754655316],
            [3.703820259261199, -5.641743296240618],
            [3.7077543236993344, -5.645720451426268],
            [3.713200261116944, -5.64205504248935],
            [3.716393241936648, -5.641583666171636],
            [3.726222962867545, -5.643851082495247],
            [3.727890562246489, -5.650347852328341],
            [3.730192908941202, -5.653686205031989],
            [3.730086675738903, -5.65701519694447],
            [3.7386158464577264, -5.666386428540216],
            [3.610465673893632, -5.670640504476521],
            [3.5522731652278887, -5.671896513990493],
            [3.5162680583761765, -5.673040095193557],
            [3.469619845518046, -5.674166768400905],
            [3.404733433216322, -5.6755782165335225],
            [3.376404087668829, -5.676469420308467],
            [3.2429860242610893, -5.679583854522751],
            [3.192318703534295, -5.680807246558839],
            [3.1325174679408176, -5.682346244772846],
            [3.0928869954453466, -5.682465723826605],
            [3.07336821368946, -5.683080446154197],
            [3.007517601549186, -5.684467183485939],
            [2.9723379797060123, -5.685092185718959],
            [2.9718118813740775, -5.604543717588981],
            [2.9709700232589404, -5.49845318037127],
            [2.9704868911715874, -5.455370630564104],
            [2.9705220873081584, -5.411350668383682],
            [2.970010509583611, -5.411329751649389],
            [2.969397410751065, -5.324461799802985]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.5972537853818, "lat": 33.171298771506166 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05139"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00069903"
      },
      "bbox": [
        2.969397410751065, -5.685092185718959, 3.7386158464577264,
        -5.307987828704405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.74199419602021, 0.8916378573979445],
            [-19.733640424522974, 0.895492864153177],
            [-19.731665990028464, 0.8999586412314964],
            [-19.73206166046595, 0.9064735734448284],
            [-19.720809074427333, 0.9165175122850344],
            [-19.714735144624218, 0.9200179971916604],
            [-19.70398302881029, 0.9157677165169859],
            [-19.69708613541175, 0.9185691087268516],
            [-19.68813776407519, 0.9283534315968375],
            [-19.681982563005036, 0.932247146378335],
            [-19.675628261628173, 0.9348066257318212],
            [-19.669489009210285, 0.9321122054293152],
            [-19.662842125090062, 0.9333100841218316],
            [-19.659924446724926, 0.9355702586131477],
            [-19.653636026781776, 0.928091017277182],
            [-19.647764970873155, 0.9332024569159744],
            [-19.645379006892764, 0.9323565663400457],
            [-19.638921077345614, 0.9353383539254518],
            [-19.638574545256464, 0.9321571292436567],
            [-19.641307022244508, 0.929710871081771],
            [-19.646429065976843, 0.9285284203200587],
            [-19.643831975705766, 0.9246436393195883],
            [-19.639179908262065, 0.9269496737905887],
            [-19.631690139486278, 0.9209398288678464],
            [-19.628586443289354, 0.9152970741393891],
            [-19.61929756160129, 0.9189097929885317],
            [-19.616336437909393, 0.9210692579826747],
            [-19.611505236500303, 0.9218847959244715],
            [-19.60573071967802, 0.9174400746325663],
            [-19.605577521351965, 0.9139253598261688],
            [-19.607903907517155, 0.9100909908956474],
            [-19.606074360869602, 0.9058538689333109],
            [-19.60246911312786, 0.9068437809297252],
            [-19.603134329169574, 0.898523585118904],
            [-19.60487319616555, 0.8841623039675348],
            [-19.607499923266314, 0.8784720523083921],
            [-19.59925697107611, 0.8473934467068007],
            [-19.58300057513333, 0.8336323786755904],
            [-19.57063565019002, 0.8100112304654534],
            [-19.55661051929587, 0.7814607502646816],
            [-19.533729404670545, 0.7379192215267991],
            [-19.526956856489324, 0.7376152335420126],
            [-19.52248616502711, 0.7394373717938453],
            [-19.5136965615091, 0.7392712084290611],
            [-19.512894171908385, 0.7344641790826557],
            [-19.510316797880428, 0.729143576642707],
            [-19.5129438928511, 0.7264552317127932],
            [-19.513293839361708, 0.7221490363814284],
            [-19.511032279184956, 0.7175905618149914],
            [-19.50732772720953, 0.716685479954584],
            [-19.50354840665634, 0.7108177822253696],
            [-19.504579616521518, 0.7036544136672576],
            [-19.501031062354496, 0.6978441893545966],
            [-19.501210942002427, 0.6932706723702637],
            [-19.510971837803904, 0.6884589322306071],
            [-19.521006510879197, 0.6902654130977953],
            [-19.52325626291709, 0.6893411595930434],
            [-19.52821613186743, 0.6909548057495621],
            [-19.52974077998424, 0.6888222755871309],
            [-19.5268220370767, 0.6720601818569408],
            [-19.52511959658799, 0.6706211376750386],
            [-19.52449042719264, 0.6595774272330877],
            [-19.522706087996255, 0.6572262079732853],
            [-19.518756083267416, 0.6581938315117121],
            [-19.516862234999024, 0.6527297637953724],
            [-19.51212119184853, 0.6480758888207322],
            [-19.50963891206733, 0.6415191691091505],
            [-19.498371775593082, 0.6442707519579584],
            [-19.490915741758347, 0.6363246134403546],
            [-19.48759870610549, 0.6353833676435334],
            [-19.485943493147325, 0.6224782299735191],
            [-19.486463895965382, 0.6179074467952314],
            [-19.4818882481953, 0.6153617962615867],
            [-19.46988728226386, 0.6115327242273152],
            [-19.464473779614945, 0.6079134512938958],
            [-19.460015703919154, 0.609420543922912],
            [-19.454206325231045, 0.6087938520784728],
            [-19.44609246298299, 0.5993255901651559],
            [-19.444636185616904, 0.5921126894078157],
            [-19.442724255152623, 0.5918069979475463],
            [-19.440255915002254, 0.58575058177531],
            [-19.442398160614374, 0.5836210674005153],
            [-19.4424118790132, 0.5793749660614704],
            [-19.440370705609926, 0.575718839551724],
            [-19.437788921216466, 0.566605425905521],
            [-19.429894237418985, 0.5536387803437602],
            [-19.436078406730736, 0.5473117560509584],
            [-19.43805592580296, 0.5437421040741911],
            [-19.440303662149145, 0.533607600066301],
            [-19.442219865027273, 0.5295021996899633],
            [-19.44235176940505, 0.5233882975043959],
            [-19.448868244493, 0.5234519348391916],
            [-19.45129221625861, 0.5222028996380186],
            [-19.450278710614327, 0.5178450049286473],
            [-19.451794048086956, 0.5134638563799555],
            [-19.45086514665838, 0.5085410163732418],
            [-19.452666748711703, 0.5027363704293554],
            [-19.44745882261012, 0.49855757200249395],
            [-19.444259558563214, 0.49420109660394473],
            [-19.44210955962011, 0.49407285283999014],
            [-19.43396050234469, 0.47342919595277067],
            [-19.434253942435333, 0.4680860229454736],
            [-19.437023649012925, 0.46537457445183766],
            [-19.44607712610561, 0.4605146494311311],
            [-19.446981189556446, 0.45590817534601485],
            [-19.450935832751444, 0.4534030074544751],
            [-19.453349145825385, 0.4477694622185544],
            [-19.452062117048065, 0.44410348861385845],
            [-19.445245567133487, 0.4480015465504161],
            [-19.44178259550934, 0.44587081103184123],
            [-19.439196796893764, 0.4474395726606242],
            [-19.43195607963594, 0.44503510394591744],
            [-19.43046824798754, 0.44150025353383315],
            [-19.42540766917554, 0.44074315561346933],
            [-19.418637755867493, 0.43792963103678356],
            [-19.41145953433282, 0.4382374572019864],
            [-19.40023436891448, 0.4376688228403357],
            [-19.397648341655753, 0.43332789513112285],
            [-19.397143244012074, 0.4271113102704373],
            [-19.39412427015368, 0.42044457366957355],
            [-19.395957151213835, 0.4181957578771359],
            [-19.393863423861628, 0.4125946538917025],
            [-19.39728049169391, 0.40720292702121486],
            [-19.39741053546216, 0.4038069904540389],
            [-19.3951704567067, 0.39976155712080186],
            [-19.391000683472946, 0.40053426117491175],
            [-19.386884065565162, 0.3987911377338224],
            [-19.385048648214415, 0.3894919183040079],
            [-19.382403066631326, 0.3862816354020065],
            [-19.380882528616823, 0.38118033975396126],
            [-19.378281437087026, 0.3774667392089927],
            [-19.379358752696803, 0.3742561065880708],
            [-19.37751136461005, 0.367515102389267],
            [-19.334441832209723, 0.2922485078679214],
            [-19.29209640467454, 0.21704780843140614],
            [-19.305517330938056, 0.16546152540794537],
            [-19.29937260426493, 0.1680353756306763],
            [-19.294773997019554, 0.16705162965636486],
            [-19.294028691258383, 0.16342165693500038],
            [-19.296946728724393, 0.16172014948999847],
            [-19.2984846670216, 0.15178069207355266],
            [-19.294291536076962, 0.15230324001779866],
            [-19.29213232686761, 0.14980715163955088],
            [-19.287333911538514, 0.1571513115684567],
            [-19.28318948655287, 0.15701948032020205],
            [-19.279095333706202, 0.1540600762980094],
            [-19.274740448645012, 0.15679279841805363],
            [-19.268991887810266, 0.15431891061666303],
            [-19.263826585389186, 0.15838107374789087],
            [-19.26162328437036, 0.1683344367955408],
            [-19.257997426315164, 0.17256752114617396],
            [-19.2491694718641, 0.17014852815204776],
            [-19.243159545442264, 0.15897330990029734],
            [-19.240488448683372, 0.15795210397010245],
            [-19.239824021668756, 0.1528002396332119],
            [-19.23767036463198, 0.15089604941282705],
            [-19.22778569225892, 0.15427521164544292],
            [-19.224366881386654, 0.15647470616052034],
            [-19.22513109652416, 0.15995874804865207],
            [-19.21883057462565, 0.1625267818226203],
            [-19.21950296890826, 0.1663404086897459],
            [-19.21543020926353, 0.17111646219146373],
            [-19.209105406507856, 0.17189230332671626],
            [-19.208342677819594, 0.17613471562357674],
            [-19.20561308522887, 0.17910710531018298],
            [-19.20221988618816, 0.17929275874681558],
            [-19.1967149229431, 0.17497183447028905],
            [-19.196423817598024, 0.1720855064535405],
            [-19.192871152755142, 0.16770357190375929],
            [-19.188888329839145, 0.16502606904384073],
            [-19.18591871778962, 0.15559242987722177],
            [-19.18162780817866, 0.1547955618432101],
            [-19.174647045807536, 0.155590911659851],
            [-19.164849758838407, 0.1500398619792151],
            [-19.160122803473374, 0.14201560373196814],
            [-19.156502147710082, 0.1408940346802869],
            [-19.15576415838767, 0.13622529514625165],
            [-19.152427458481785, 0.13450183863328047],
            [-19.149875018671963, 0.12938239438104912],
            [-19.150745268061833, 0.12327265410499227],
            [-19.148169100865893, 0.1136656638550487],
            [-19.140835008588088, 0.10538684113352978],
            [-19.13950607722039, 0.10219080030155221],
            [-19.135951907179248, 0.10105825617691594],
            [-19.134188249115955, 0.09577994229176086],
            [-19.136378475023225, 0.09291513576563457],
            [-19.132831540537943, 0.08992403954696525],
            [-19.132521363732884, 0.0866326756367173],
            [-19.12869280802146, 0.08070823490235512],
            [-19.12136692709168, 0.07825630893515867],
            [-19.122310125697435, 0.0738423032920042],
            [-19.118134624427295, 0.07108467976470526],
            [-19.117355389922732, 0.06654961543153086],
            [-19.110684166261077, 0.05623199230605542],
            [-19.110470503672268, 0.04993529740297593],
            [-19.108423700657813, 0.04772961758266512],
            [-19.108383099472928, 0.043472347714126364],
            [-19.106305372242943, 0.03985145166803218],
            [-19.09936030099086, 0.03458683288899397],
            [-19.09296611898895, 0.03425914945735],
            [-19.088361738349114, 0.036202083311454476],
            [-19.08483927249287, 0.035661075534449437],
            [-19.077402203871063, 0.029512736452311797],
            [-19.076559166491467, 0.02645987736942227],
            [-19.071745723119815, 0.026976737405547235],
            [-19.06594339566262, 0.030792501463349782],
            [-19.064003361293537, 0.033580176650595976],
            [-19.059273851237535, 0.05407766638785595],
            [-19.059618624126294, 0.0770574606696564],
            [-19.060421224361217, 0.07965563814236146],
            [-19.05960030883675, 0.08792293145444166],
            [-19.062911246387692, 0.09600305030454674],
            [-19.062417980414168, 0.09943995460519574],
            [-19.066659285373504, 0.10583993482044196],
            [-19.065786684559566, 0.1148312684042223],
            [-19.06816106997164, 0.11969940398881236],
            [-19.069335756717322, 0.13025784753599634],
            [-19.073485781699784, 0.13742864507511277],
            [-19.077190117243457, 0.13988878088102621],
            [-19.07203983072958, 0.1433728754670306],
            [-19.06890304192356, 0.1428609457288151],
            [-19.065707103973683, 0.13741948942846355],
            [-19.05937229289402, 0.13095868329889368],
            [-19.054590298435524, 0.12226402368865745],
            [-19.045187295927878, 0.11098079662935871],
            [-19.04181639438827, 0.11143900557389277],
            [-19.038254732622654, 0.10613537520374132],
            [-19.034850632172365, 0.09555451222256467],
            [-19.03311402293297, 0.09282234212788586],
            [-19.02878569615137, 0.09176935931468395],
            [-19.027510321913866, 0.08702305782232282],
            [-19.025664163260096, 0.0764645779823001],
            [-19.0302563103843, 0.07524878237933724],
            [-19.03410216047515, 0.07212938910298285],
            [-19.033758022191854, 0.06711144542676961],
            [-19.028790828570546, 0.06163220391982483],
            [-19.026618032827876, 0.05407354530590452],
            [-19.01914348087079, 0.04950351545845559],
            [-19.01612918249728, 0.045284460759323956],
            [-19.016103403639043, 0.03870364450103221],
            [-19.010974633167994, 0.03330061132275512],
            [-19.010356466072807, 0.027805600580026874],
            [-19.00502746911795, 0.01849903431133281],
            [-19.004194045151195, 0.013902735733983373],
            [-19.009876589187385, 0.010699659095229925],
            [-19.014348940811853, 0.010655441923143744],
            [-19.020617353197686, 0.00017937068611189344],
            [-19.023180256029224, -0.0014361130013077284],
            [-19.024067746727205, -0.0057485128952867726],
            [-19.02731069643161, -0.004824476397160081],
            [-19.03171837543677, -0.010512812965006073],
            [-19.030076298342454, -0.014633813869235054],
            [-19.03479946592298, -0.01505764526857561],
            [-19.04043067066571, -0.009973654678156533],
            [-19.044075735876305, -0.015278143069801294],
            [-19.04908111839785, -0.0148523508800765],
            [-19.04698165843809, -0.01928750879007939],
            [-19.047829655916317, -0.023821357295058368],
            [-19.04789094490622, -0.032936643629733815],
            [-19.049793334830635, -0.039665531570412776],
            [-19.04908241189619, -0.04362944747122901],
            [-19.044959035358648, -0.049893183969930144],
            [-19.044266660205153, -0.05719887846477389],
            [-19.046364396787002, -0.06306028410152967],
            [-19.041023116173935, -0.06720921742931105],
            [-19.043051733913135, -0.07235591165697539],
            [-19.045747957309807, -0.07452793298838374],
            [-19.042156451755496, -0.08249585355150413],
            [-19.034529003512628, -0.08393586749594062],
            [-19.031683584281655, -0.08744163659892543],
            [-19.020792228223886, -0.09447410797382727],
            [-19.01634141701166, -0.09050862679724733],
            [-19.015575148952742, -0.08805323765176387],
            [-19.010126322123543, -0.09065514065986706],
            [-19.008646124899446, -0.09300576693978986],
            [-19.006225979307555, -0.10187379204457118],
            [-19.008211076633906, -0.10784354135732799],
            [-19.012731520251943, -0.11481683296110468],
            [-19.01128920839334, -0.12194224594571584],
            [-19.005196510680427, -0.13237558558711912],
            [-19.002004362436345, -0.1354792531050329],
            [-18.996399355420873, -0.14508477617315507],
            [-18.991387120441004, -0.14944977788697306],
            [-18.98576301370759, -0.15145696283576682],
            [-18.981704628061255, -0.15607637618689427],
            [-18.981496108024956, -0.1627153513770585],
            [-18.980270438106725, -0.16632941408827415],
            [-18.972949216623174, -0.16959971222852485],
            [-18.97226045041792, -0.17247467527403576],
            [-18.975238975061394, -0.18058412668306573],
            [-18.96995196204917, -0.18315178818921482],
            [-18.964924533640254, -0.17990015777041043],
            [-18.96083301046246, -0.18676738603985335],
            [-18.952928037594535, -0.19025474840914694],
            [-18.9392702339141, -0.20478374108269523],
            [-18.94172204407504, -0.20857882076787287],
            [-18.94066309550994, -0.21418473327393459],
            [-18.937683541208543, -0.21705051695779182],
            [-18.935520104772475, -0.22229889919200693],
            [-18.929844134296715, -0.22446517189442153],
            [-18.92237975000526, -0.23193021029362823],
            [-18.92275694520395, -0.23529570331807365],
            [-18.919588406094473, -0.2405247009719966],
            [-18.916869706881357, -0.2426203081575325],
            [-18.915745001784448, -0.24646829965477676],
            [-18.916367428410496, -0.2519731828674669],
            [-18.91447603663211, -0.2543571502681419],
            [-18.90527789928076, -0.25174910009363793],
            [-18.893044428342876, -0.2542781049162494],
            [-18.88584165652616, -0.2603919081199145],
            [-18.88446167108031, -0.2633470052907377],
            [-18.88012205319588, -0.26303963242827677],
            [-18.859279916855204, -0.2735559544263646],
            [-18.862182949889533, -0.27802111135171004],
            [-18.859320811062553, -0.28279835975461676],
            [-18.86044830593966, -0.2903193201157008],
            [-18.856139725017346, -0.2956149842601307],
            [-18.852977519838774, -0.29562010996334304],
            [-18.848382055095918, -0.3061511167511172],
            [-18.848827477419935, -0.3138555638802672],
            [-18.85119430291161, -0.31877127372300734],
            [-18.84897288231517, -0.32385319754428854],
            [-18.849965627752965, -0.3270056630040853],
            [-18.845688154138198, -0.33062672125390097],
            [-18.84544569205369, -0.3351622711288864],
            [-18.838725237332895, -0.33864370557879986],
            [-18.83169804984081, -0.33962391699773214],
            [-18.82317376247381, -0.34233717801001806],
            [-18.817667287911142, -0.3458861098911753],
            [-18.810761774796106, -0.3462170319406129],
            [-18.808535521586297, -0.34789461308323383],
            [-18.804299395792793, -0.3567762388496981],
            [-18.800882534617198, -0.36010446741129526],
            [-18.79789490278725, -0.3682234586469759],
            [-18.795353477463006, -0.3708461754645878],
            [-18.79049208401288, -0.38202712795711324],
            [-18.793157201454235, -0.386077449170487],
            [-18.791684349630238, -0.3944282804646615],
            [-18.7960464718162, -0.3946935659268149],
            [-18.801668685955583, -0.400371248488485],
            [-18.805908940179656, -0.40093694006177605],
            [-18.810171533263663, -0.40958148721880017],
            [-18.807272555194544, -0.4241397566359101],
            [-18.80774704153825, -0.42730843972136934],
            [-18.80513993200446, -0.4341914616621358],
            [-18.800322526334334, -0.433608921518141],
            [-18.787714780719323, -0.44336942182901495],
            [-18.787042076666236, -0.4490141421485858],
            [-18.789985372911275, -0.45575457798420177],
            [-18.788558569987654, -0.45973008588030495],
            [-18.790211879572805, -0.4742799984648468],
            [-18.813945887141156, -0.46790538473264937],
            [-18.819068137244464, -0.46707113352692936],
            [-18.938499109321583, -0.4347824984533888],
            [-19.024216240607046, -0.4119078471339417],
            [-19.078473113067638, -0.3969646150795753],
            [-19.16109074188857, -0.3750162444187463],
            [-19.20711454997192, -0.3623189716898443],
            [-19.30378277736153, -0.33589188704469447],
            [-19.400817772674376, -0.3087762649834614],
            [-19.401289239372588, -0.3088948983485698],
            [-19.488735555009708, -0.2846207395620459],
            [-19.497478506992685, -0.28159496698687736],
            [-19.53339009942815, -0.2717191600598233],
            [-19.589667361634287, -0.2559557763400218],
            [-19.668112432749222, -0.233894249948382],
            [-19.673760334838583, -0.22293122337698185],
            [-19.677377308654737, -0.21752252247695358],
            [-19.684719193314347, -0.21165350622933102],
            [-19.683986634394696, -0.20878008993524455],
            [-19.69277634088648, -0.1975912345544618],
            [-19.69595126526548, -0.18620509326600793],
            [-19.701807133367875, -0.17295207867012485],
            [-19.70231966061814, -0.16408730737260122],
            [-19.70468117547748, -0.15825987728209437],
            [-19.711941492166225, -0.15434923320496005],
            [-19.72122698083691, -0.14426718054924328],
            [-19.721791246416217, -0.14060786252907678],
            [-19.728007576160547, -0.1277774422324838],
            [-19.732270005867772, -0.12449165934360577],
            [-19.73362148848487, -0.11752339071955997],
            [-19.731670018115242, -0.11605182071278645],
            [-19.72935447306352, -0.10930203345015474],
            [-19.731574983113223, -0.10648743715919594],
            [-19.72922776656131, -0.10360074182593766],
            [-19.733185463195802, -0.09114642183776549],
            [-19.731949491261496, -0.0853727630530719],
            [-19.728833747403165, -0.08434447451502776],
            [-19.727504063560474, -0.07915016762963878],
            [-19.731945206883672, -0.07436486285527445],
            [-19.729709790498205, -0.06842186383278542],
            [-19.731728481028366, -0.054788871362722306],
            [-19.73039763576283, -0.04613878698547702],
            [-19.731296061368273, -0.04462865523879424],
            [-19.72910244778813, -0.03336969474377385],
            [-19.730299986491993, -0.03056424435841759],
            [-19.730154801385222, -0.021542076664130095],
            [-19.732362695699646, -0.014893767645697076],
            [-19.73356539014007, -0.003620878040223523],
            [-19.739373486966876, 0.00716037844592311],
            [-19.748180136752893, 0.0127770223315399],
            [-19.753106093357097, 0.018983752762853155],
            [-19.76070862296675, 0.022175198291502],
            [-19.766142052864602, 0.02750021884896609],
            [-19.774227128920764, 0.03115190546949885],
            [-19.77905995803804, 0.03150522024671471],
            [-19.783318450631292, 0.03840304914297257],
            [-19.784928020536974, 0.05517137587006291],
            [-19.78872919891586, 0.06348210837757755],
            [-19.786898587658854, 0.06935434365587853],
            [-19.788672021337096, 0.07311148889414802],
            [-19.78659110608184, 0.0816181091985497],
            [-19.790706784029595, 0.08680511927290696],
            [-19.795495874614396, 0.09090522892254564],
            [-19.795205000100893, 0.09406457790284976],
            [-19.798636718930467, 0.10108235400708161],
            [-19.800930999938146, 0.10792971786282997],
            [-19.799817788776583, 0.11106616526221627],
            [-19.799900647917163, 0.12102635323605787],
            [-19.80341490993374, 0.13918253051393933],
            [-19.802567209103756, 0.14351077828261102],
            [-19.809949838125057, 0.15346368597061613],
            [-19.813831945998327, 0.16837059232129573],
            [-19.82421127029889, 0.1909127389924851],
            [-19.825668416950556, 0.19671004674058565],
            [-19.831134233966367, 0.20139961041555085],
            [-19.839075419920277, 0.21274709001433761],
            [-19.8394265471023, 0.21712941581230516],
            [-19.843427547127252, 0.22654279078189754],
            [-19.84644367053433, 0.22996855757319332],
            [-19.84757097628208, 0.23419040272809447],
            [-19.856244879845654, 0.24306117781033654],
            [-19.866150429630487, 0.25532923571315935],
            [-19.871240165991857, 0.25732120509482587],
            [-19.87918394891363, 0.2699743634320932],
            [-19.88712825276723, 0.2789729501281958],
            [-19.891486734858212, 0.2811699915752483],
            [-19.89853599226831, 0.2892750946954084],
            [-19.906467040573947, 0.2903049791208592],
            [-19.911853071450984, 0.29412971168317825],
            [-19.911202824384716, 0.29629777758272935],
            [-19.913978702101176, 0.3007958351840117],
            [-19.918901451298566, 0.3031867462790622],
            [-19.919588755485087, 0.3084089108482891],
            [-19.922773703660425, 0.3101022640407719],
            [-19.92386552681628, 0.3136570263540896],
            [-19.923971714060837, 0.32388240860919243],
            [-19.928974164830663, 0.34346150774124307],
            [-19.932851013036455, 0.34791413400589016],
            [-19.936918139664613, 0.349410443982418],
            [-19.937811744079404, 0.35309503597692316],
            [-19.94348725007784, 0.3592829565451933],
            [-19.950286290818177, 0.37558765882173284],
            [-19.956066489573548, 0.3794327347650457],
            [-19.95737268120001, 0.3826904147780594],
            [-19.950997974969184, 0.3915031459911903],
            [-19.950215126775724, 0.4010849664954805],
            [-19.946160405692517, 0.40539160067333013],
            [-19.943024536907934, 0.4150853323208715],
            [-19.948875507457455, 0.4310058844900089],
            [-19.944588725494032, 0.4380239085745704],
            [-19.943115057242924, 0.44546555551436195],
            [-19.945180677582165, 0.4478771240872288],
            [-19.93904625059241, 0.45531789646246973],
            [-19.937500222326808, 0.46030144083512403],
            [-19.939043544852307, 0.4619402052510876],
            [-19.93692203096091, 0.46701236838451515],
            [-19.937561900112733, 0.47201574167432164],
            [-19.943419670648552, 0.4788993537921865],
            [-19.94293877380027, 0.4870013740567225],
            [-19.936490835309783, 0.5009334755479934],
            [-19.9407172588902, 0.5237113678435126],
            [-19.942872779938213, 0.5262012137465655],
            [-19.94107178747977, 0.5309373836487296],
            [-19.937647918930605, 0.5304354951375013],
            [-19.936718559982484, 0.5354312488214508],
            [-19.937516377661616, 0.5439395795452112],
            [-19.940804942614918, 0.5469593789721127],
            [-19.941576508145715, 0.5510003576746086],
            [-19.940066139540388, 0.5599071034609675],
            [-19.94347226455821, 0.5707803419029317],
            [-19.936477529249075, 0.5751591249669782],
            [-19.933537809594043, 0.5843231496686178],
            [-19.93570725192907, 0.5857826229232902],
            [-19.935264037160636, 0.5915121357435171],
            [-19.940773685106766, 0.5978412633292294],
            [-19.935351696040488, 0.6024692649374114],
            [-19.934176837918766, 0.5994850275353978],
            [-19.928669465843498, 0.5966771600605403],
            [-19.92672471776765, 0.5992011720372427],
            [-19.92090782764777, 0.5975232693063461],
            [-19.917568873298354, 0.599956142201727],
            [-19.917434528517557, 0.6127520983701459],
            [-19.91952553712668, 0.6153801769423749],
            [-19.919084705513594, 0.620513828975261],
            [-19.91588966015284, 0.621418650157254],
            [-19.914184159320403, 0.6350016806669351],
            [-19.92009630997876, 0.6434700820173749],
            [-19.925237934851907, 0.6461329192163535],
            [-19.92981703783643, 0.640812879751224],
            [-19.932248202227633, 0.6455780764951452],
            [-19.939907251542582, 0.6549827285718263],
            [-19.94277673702815, 0.663451734272476],
            [-19.939856002349742, 0.6664240574071714],
            [-19.935209365039444, 0.6643408116318898],
            [-19.92985667096373, 0.6699332634721488],
            [-19.926177097250136, 0.676663431142514],
            [-19.92629298514404, 0.6789026841385387],
            [-19.920484799119556, 0.6881565398618622],
            [-19.915714257067837, 0.6862858407991462],
            [-19.91137980476589, 0.6877024376341899],
            [-19.909772605500127, 0.6905525649088279],
            [-19.90492326543448, 0.6933411227191832],
            [-19.903856491531048, 0.6978919536240576],
            [-19.900474729286486, 0.7012790834949175],
            [-19.89868528874409, 0.7082085568703499],
            [-19.896289581927164, 0.7105131342262008],
            [-19.89105432851004, 0.7092715301377417],
            [-19.887775104949363, 0.7059295631760757],
            [-19.887304071038656, 0.6992515231816121],
            [-19.882967834264125, 0.6924256682623786],
            [-19.87616172723172, 0.6879413448903131],
            [-19.8703404281319, 0.6746182367087616],
            [-19.869221700315858, 0.6682265037128081],
            [-19.86535320550824, 0.6642731755487793],
            [-19.85925733140861, 0.6640112579496305],
            [-19.850705655616093, 0.666136383752418],
            [-19.842493579228147, 0.6700831789445267],
            [-19.835512856934574, 0.6748540115120345],
            [-19.82087255200858, 0.6875162060694814],
            [-19.80563975846514, 0.7051908125942364],
            [-19.797260065771958, 0.7165228921063087],
            [-19.789981287689038, 0.7286397580502915],
            [-19.781973183554516, 0.7433779297814853],
            [-19.775961715502355, 0.7580465370187959],
            [-19.765434390216154, 0.7929423658756103],
            [-19.747417277204658, 0.8259751374985339],
            [-19.73761193265386, 0.8415294905597607],
            [-19.73707836729045, 0.853108789895129],
            [-19.739624051103497, 0.8665426096531489],
            [-19.74199419602021, 0.8916378573979445]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.23875902079827,
          "lat": 36.21707012176094
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06053"],
        "coty_name": ["Monterey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monterey County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00277291"
      },
      "bbox": [
        -19.95737268120001, -0.4742799984648468, -18.787042076666236,
        0.9355702586131477
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.183178558507407, 2.2686063601318995],
            [-19.179776769755545, 2.272331497760222],
            [-19.17801001056516, 2.277231819757261],
            [-19.173811068328217, 2.2790269417967584],
            [-19.17329215639691, 2.282316022840602],
            [-19.169084876529016, 2.2836233367635272],
            [-19.165875476881734, 2.278565747593282],
            [-19.162333814809386, 2.28162581517727],
            [-19.14986186223756, 2.290279057595208],
            [-19.13165977776728, 2.2907299540240604],
            [-19.120343205052905, 2.29821013542408],
            [-19.116923745775004, 2.2995690322973217],
            [-19.11466306136492, 2.306046823093721],
            [-19.11462626759531, 2.3147737870888534],
            [-19.112635052406528, 2.3198196982225436],
            [-19.105689780186143, 2.323335156903291],
            [-19.103842547474326, 2.3255063114233105],
            [-19.10066298999578, 2.3336401372657414],
            [-19.100068185652418, 2.33893484360693],
            [-19.100717551780747, 2.3462112942301228],
            [-19.106078389893412, 2.367140895712956],
            [-19.106003579988823, 2.37123813213621],
            [-19.10094889980892, 2.3733650668417132],
            [-19.092283832766537, 2.3706657070519754],
            [-19.087730021245324, 2.370844593373756],
            [-19.082314316196438, 2.373258476787563],
            [-19.07998728732165, 2.3761077660250995],
            [-19.07739405793203, 2.3829124064028093],
            [-19.075317725527732, 2.3995345445830765],
            [-19.077180001005242, 2.406581714333557],
            [-19.083048830271526, 2.409965103616382],
            [-19.095200984504167, 2.412606536667143],
            [-19.098922244942774, 2.414402480756798],
            [-19.102361730613282, 2.418570856055602],
            [-19.10413319457265, 2.424150415184035],
            [-19.107885937928337, 2.4408427938101496],
            [-19.10617201625212, 2.446330529248477],
            [-19.098248913342182, 2.455332742029338],
            [-19.08935329369852, 2.45565037644418],
            [-19.08210551530337, 2.454458173091225],
            [-19.077297037179495, 2.454712734870842],
            [-19.07559286543342, 2.457103850108548],
            [-19.07865616349313, 2.465752035350932],
            [-19.075941725226205, 2.4682869227791797],
            [-19.069017333831532, 2.469795193278647],
            [-19.06222449635183, 2.4735530932564482],
            [-19.059313277873795, 2.4785568678166867],
            [-19.05980314646564, 2.487980467658774],
            [-19.06120337794224, 2.4999133141523897],
            [-19.051829569796276, 2.5065442106529536],
            [-19.044858817418973, 2.516433739900833],
            [-19.043829388792638, 2.5271520695542717],
            [-19.044893901246798, 2.531735179468076],
            [-19.04754599477758, 2.5343472442710477],
            [-19.055917433114967, 2.538636477025261],
            [-19.065147450014617, 2.538350043838371],
            [-19.070377537074425, 2.5353944327606595],
            [-19.07387769686833, 2.538137472984963],
            [-19.077784208368676, 2.5484196949373965],
            [-19.07745582201273, 2.5592114572270916],
            [-19.073730795763083, 2.5829843400299435],
            [-19.07631248151404, 2.5892389509810854],
            [-19.08021828329229, 2.5913633573837385],
            [-19.09007950985495, 2.5879081348775936],
            [-19.09484809380255, 2.5906887288942193],
            [-19.098873628488676, 2.6034153175003296],
            [-19.101834900323684, 2.6104072811303825],
            [-19.111912336837943, 2.6274718299353523],
            [-19.113237973197688, 2.6339985786358793],
            [-19.112432180432553, 2.6434028067119635],
            [-19.109137164311406, 2.648771869896655],
            [-19.105954924461482, 2.651091269067307],
            [-19.092416864348035, 2.657967740045613],
            [-19.083630252128422, 2.665252260160115],
            [-19.076777339212512, 2.6816935548696983],
            [-19.05044366399123, 2.674384993379469],
            [-19.043431602668427, 2.672998348905089],
            [-19.016207038968773, 2.6656056403852584],
            [-18.988852678270764, 2.656206284678038],
            [-18.921952767167856, 2.631626461217991],
            [-18.874814997381353, 2.613837371102181],
            [-18.859055399127946, 2.608202412226698],
            [-18.80090177546094, 2.5862867480568816],
            [-18.74323375069938, 2.565001282947103],
            [-18.739344979534035, 2.564517381749706],
            [-18.735246664108846, 2.5565602223509285],
            [-18.726630278088752, 2.559540723474508],
            [-18.72088387949785, 2.5648862249844746],
            [-18.714334319517477, 2.490762505441965],
            [-18.71370225389451, 2.4749443433751703],
            [-18.713756927313828, 2.4485576993224574],
            [-18.710590580493598, 2.3917475438620808],
            [-18.7092525760243, 2.3736612042782266],
            [-18.707758356063703, 2.3431753843234104],
            [-18.712579449398877, 2.324577955905394],
            [-18.7395715535414, 2.224424571463441],
            [-18.7621228030586, 2.140409449033568],
            [-18.765049321686362, 2.1397953243460686],
            [-18.772908415434877, 2.1406674447165654],
            [-18.77983369683738, 2.135661298898275],
            [-18.783719209352522, 2.138852762526392],
            [-18.790615118668466, 2.1472738153795925],
            [-18.793638102784577, 2.147091329613583],
            [-18.799091873748036, 2.143074615389749],
            [-18.802748531960216, 2.1424018239544163],
            [-18.8086604319899, 2.1384423527173735],
            [-18.81831664882522, 2.136108258774584],
            [-18.822896078412334, 2.1390160946989],
            [-18.829026990158248, 2.1384078675864444],
            [-18.835496633517145, 2.136273422855269],
            [-18.843689862647725, 2.1385918854997636],
            [-18.849695052466874, 2.134391481454064],
            [-18.85265883229415, 2.1348830413632305],
            [-18.861696921089056, 2.129307653008132],
            [-18.870008731842518, 2.1283049069407967],
            [-18.87341590011768, 2.1292310022429217],
            [-18.8798084309683, 2.1281338344228504],
            [-18.883556458266806, 2.1261362981844014],
            [-18.88888519895045, 2.127698985105875],
            [-18.889842845567127, 2.1295343523364503],
            [-18.899217193972408, 2.1309485696240387],
            [-18.90802514288779, 2.126024127888143],
            [-18.916727322077033, 2.1284334026665377],
            [-18.923514914116293, 2.125682820396582],
            [-18.929007310017194, 2.1296092888646942],
            [-18.933947605944567, 2.1317308113565763],
            [-18.93815289805014, 2.1307132321653417],
            [-18.942060853321333, 2.1317892228704687],
            [-18.949370981983115, 2.138839965269437],
            [-18.955850749026084, 2.1426987374031814],
            [-18.96300174722948, 2.141491708977456],
            [-18.966054244744686, 2.143153142499199],
            [-18.972436530570437, 2.1402744422719255],
            [-18.97619654439364, 2.135724816239915],
            [-18.980093125437918, 2.1339800125798516],
            [-18.988215105791618, 2.1331880657139286],
            [-18.990742152063703, 2.134962549762474],
            [-18.997423682138436, 2.1361763910266807],
            [-19.00111483989376, 2.1345438782559345],
            [-19.00673324188504, 2.136223864613036],
            [-19.0150740703884, 2.1344274634713374],
            [-19.018992504070464, 2.134792968633398],
            [-19.026252745202836, 2.139673990832563],
            [-19.03233461560979, 2.14015827675605],
            [-19.035423760208474, 2.142396754205761],
            [-19.038780378613374, 2.141730082204606],
            [-19.051474428532345, 2.1487992242579237],
            [-19.05785608123869, 2.145125285797562],
            [-19.068442777402907, 2.152147631554865],
            [-19.070802349469343, 2.156647022731047],
            [-19.073991230551457, 2.1592266577241905],
            [-19.07696317753241, 2.167950643932178],
            [-19.073902508612324, 2.1729706104950854],
            [-19.075774101603653, 2.177953061218784],
            [-19.079875264857503, 2.178654935644915],
            [-19.086772905928697, 2.183240553972607],
            [-19.091784660601792, 2.18228210469972],
            [-19.098923655321634, 2.1890197091140604],
            [-19.105768454117197, 2.1916478182226804],
            [-19.109822202031843, 2.1908641283398445],
            [-19.11429289347561, 2.1873675582314287],
            [-19.11532457001237, 2.1797154609064657],
            [-19.122709028806963, 2.175950510303315],
            [-19.12507047870678, 2.1705544041560167],
            [-19.128030535380827, 2.168755198700643],
            [-19.12991775546958, 2.1645683928142807],
            [-19.13714861089452, 2.1656724096094555],
            [-19.143155575296703, 2.1628395813332837],
            [-19.14358419332615, 2.152039663499344],
            [-19.14716856153806, 2.1499938076267915],
            [-19.152448413852927, 2.144463243664452],
            [-19.157644058874837, 2.146511208584378],
            [-19.1596718442757, 2.1457626176030895],
            [-19.16710732653013, 2.1393507824218143],
            [-19.165809937600404, 2.1302942783949814],
            [-19.16953633769493, 2.126613453642666],
            [-19.168788777670812, 2.1199437572094606],
            [-19.17011684549217, 2.1165756137585343],
            [-19.173867999495343, 2.1152461020447015],
            [-19.177028232507002, 2.109918109412025],
            [-19.181920988334728, 2.106091517023282],
            [-19.181351395317805, 2.103421699082751],
            [-19.183803422966, 2.099725372790426],
            [-19.18877479929354, 2.100306316860061],
            [-19.195483715366834, 2.097163305862392],
            [-19.203035049153055, 2.096964902018172],
            [-19.203832038337417, 2.089715709644956],
            [-19.207606361619476, 2.0899513224827184],
            [-19.220028769080756, 2.086020259615916],
            [-19.22808181943791, 2.0791011767292185],
            [-19.22946575892217, 2.0724132904791155],
            [-19.228085739328005, 2.069451304493701],
            [-19.222954968744464, 2.0658251900576876],
            [-19.218332536541897, 2.0607651927383275],
            [-19.218078497912547, 2.0566576542069686],
            [-19.22154479974501, 2.053319595387744],
            [-19.231970140325416, 2.053149467192462],
            [-19.235398364511955, 2.0561380657229518],
            [-19.249208605654953, 2.063623998844533],
            [-19.266482478162988, 2.0668033687309695],
            [-19.267993467304677, 2.066070048073848],
            [-19.273025642052385, 2.058403432828412],
            [-19.277819494031498, 2.057131251646113],
            [-19.282804403270912, 2.0598511537096638],
            [-19.284780539554507, 2.0631448683973415],
            [-19.293125785818084, 2.071296136970545],
            [-19.302103760202748, 2.071580875516604],
            [-19.307892230171383, 2.0687858219025705],
            [-19.311812901367635, 2.0622267547978477],
            [-19.3120466852185, 2.0566671335739084],
            [-19.314790566061955, 2.0453537895769327],
            [-19.3171161615572, 2.041939695641361],
            [-19.32685942206898, 2.036548696048199],
            [-19.33518501128305, 2.030162613525085],
            [-19.343970529990212, 2.0270714750191337],
            [-19.357651690698194, 2.024450448406611],
            [-19.368807451278144, 2.0200143777847646],
            [-19.377887389338976, 2.020144029061681],
            [-19.390257298336554, 2.022371044334286],
            [-19.400702848767512, 2.020792019114603],
            [-19.409321280558185, 2.022668037741573],
            [-19.41784713404222, 2.0283922035113067],
            [-19.42424186673166, 2.0288083955219434],
            [-19.4303977634625, 2.0324795683835504],
            [-19.438462988270626, 2.044060570990057],
            [-19.440704791351774, 2.052901706844826],
            [-19.44096167811537, 2.0595996888610375],
            [-19.43996815620271, 2.06634741551753],
            [-19.441666443356983, 2.0751820069358153],
            [-19.44549331191734, 2.0812994278842267],
            [-19.451778837444834, 2.0843656313823606],
            [-19.45008248015952, 2.0879336081128743],
            [-19.446526387797356, 2.0891213209139803],
            [-19.439102121714456, 2.089415426263243],
            [-19.43445297075579, 2.0906677849502353],
            [-19.431834876223803, 2.088681200285391],
            [-19.42578273977889, 2.0773239353545283],
            [-19.414413985433356, 2.0684437010401915],
            [-19.40786987769013, 2.065298940310032],
            [-19.40356392368488, 2.0655091866007016],
            [-19.377267583046013, 2.0740214750091317],
            [-19.36761570962022, 2.0762848543785357],
            [-19.356448159476447, 2.0800536994379084],
            [-19.349169644619625, 2.073221923612138],
            [-19.34596061701092, 2.0720480941532653],
            [-19.335214674386346, 2.071350863801305],
            [-19.33240744132874, 2.072611840786861],
            [-19.32921853173585, 2.076957019751818],
            [-19.325050281535177, 2.090096720206349],
            [-19.322257877329847, 2.096366598695849],
            [-19.31535545804167, 2.1021293139456754],
            [-19.305715814346858, 2.114056138115743],
            [-19.30289373946221, 2.120132520989318],
            [-19.298725919190097, 2.126469817437465],
            [-19.293664279943805, 2.1385513643515863],
            [-19.28888276908677, 2.1404812004982743],
            [-19.270675619367545, 2.15539779745728],
            [-19.264491052073993, 2.154984840098832],
            [-19.256617516751234, 2.1563681302564444],
            [-19.252893196981606, 2.15902005829926],
            [-19.244031860054655, 2.1611208666410193],
            [-19.236352179349726, 2.1581718989265815],
            [-19.231325109583103, 2.1590014090375496],
            [-19.22766591534061, 2.1625683891034693],
            [-19.22539296158926, 2.168464149465613],
            [-19.22113086801664, 2.1741710771435234],
            [-19.214953546281354, 2.180355676224037],
            [-19.20601219137631, 2.2114039963526233],
            [-19.203256194718502, 2.2162870367558916],
            [-19.20277334836589, 2.2290148238786287],
            [-19.19788882164126, 2.237399331465662],
            [-19.199547619330136, 2.244891384020238],
            [-19.19750883613868, 2.247880639136498],
            [-19.196667313213187, 2.2545268859127017],
            [-19.191258312345205, 2.2587197147888114],
            [-19.187992825050422, 2.263743648467751],
            [-19.18806800967046, 2.266608413709132],
            [-19.183178558507407, 2.2686063601318995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.34424732840348,
          "lat": 38.44928439334752
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06067"],
        "coty_name": ["Sacramento"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sacramento County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00277298"
      },
      "bbox": [
        -19.451778837444834, 2.0200143777847646, -18.707758356063703,
        2.6816935548696983
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.71616974152788, 5.42298046066319],
            [-19.714635141564763, 5.41685548194108],
            [-19.710385165512744, 5.415135935502458],
            [-19.708232268174893, 5.410976814292045],
            [-19.710152653993962, 5.406126252287062],
            [-19.710397727071115, 5.4016625901102575],
            [-19.70518822003671, 5.396493746184153],
            [-19.704980468139677, 5.3896813650916675],
            [-19.698908360074576, 5.38857171445247],
            [-19.69587955266274, 5.392224772639208],
            [-19.686921297343513, 5.395046652127038],
            [-19.68159473191901, 5.395100189273075],
            [-19.679160962809902, 5.392664272836054],
            [-19.675274186728643, 5.385659608521017],
            [-19.66995404151794, 5.382878480442112],
            [-19.667936353175133, 5.37915471554091],
            [-19.667488796097512, 5.368433444374158],
            [-19.66099039207624, 5.3651819727411745],
            [-19.65667343239781, 5.367003549658756],
            [-19.651459078424914, 5.366062987698494],
            [-19.64633520781745, 5.3612706498394385],
            [-19.642312267535203, 5.345334619305276],
            [-19.64327343474583, 5.342371520345041],
            [-19.635882881332208, 5.339611376887295],
            [-19.637149147915547, 5.335917322081693],
            [-19.635886022615193, 5.3289618841625614],
            [-19.632548831496496, 5.323718693137983],
            [-19.63214963376625, 5.320608104773284],
            [-19.633870915973162, 5.314416227786257],
            [-19.633078160075243, 5.306400556017892],
            [-19.630967560881647, 5.30388533824145],
            [-19.62822374013361, 5.295563863900762],
            [-19.628488358663308, 5.290441784683414],
            [-19.625004350865183, 5.287091511499693],
            [-19.619143129109606, 5.284730170794263],
            [-19.614685450321982, 5.284443036296783],
            [-19.609872141944322, 5.279776604703602],
            [-19.603374152707232, 5.27959952608188],
            [-19.600088402306177, 5.275598383366734],
            [-19.59128739513781, 5.2789064566398585],
            [-19.58030965443225, 5.27481678949984],
            [-19.57108861969491, 5.273770213175354],
            [-19.56387859210321, 5.26828514273733],
            [-19.559143338242336, 5.2706065485682245],
            [-19.55363797732275, 5.269761712430203],
            [-19.547768102979084, 5.267489274553912],
            [-19.53824781112368, 5.261762309292098],
            [-19.53173262121837, 5.259470374255406],
            [-19.531918303477713, 5.249108903706919],
            [-19.528171243534022, 5.245671394910772],
            [-19.52669158301515, 5.240955041378599],
            [-19.522398139068933, 5.240076717469144],
            [-19.518910549439987, 5.236803499833147],
            [-19.515823774348405, 5.236103985227589],
            [-19.513676744615815, 5.232569289215164],
            [-19.50607713405971, 5.227402177414711],
            [-19.504083137698522, 5.221877685450472],
            [-19.50116032485461, 5.220486082418178],
            [-19.500572923816467, 5.2135669727076746],
            [-19.49818566598253, 5.205470687460822],
            [-19.50177336262705, 5.1976669363984795],
            [-19.500305110901582, 5.191576010328729],
            [-19.502115429558106, 5.186606386621189],
            [-19.50008557006895, 5.175661534299703],
            [-19.494619600216264, 5.175209372610208],
            [-19.49103951382668, 5.172959880825057],
            [-19.477391034743267, 5.173602279456832],
            [-19.47407011868203, 5.175962084378623],
            [-19.468828350203054, 5.176136722107941],
            [-19.463718168866247, 5.173713818601466],
            [-19.456281824047284, 5.173525596390927],
            [-19.448999743498533, 5.168595241450003],
            [-19.445799917836716, 5.168038358913076],
            [-19.438319693137913, 5.160023691989147],
            [-19.436789436566762, 5.147848626742027],
            [-19.4340406459597, 5.144038553888609],
            [-19.43001164138269, 5.143010974659957],
            [-19.421687922329138, 5.143982871763861],
            [-19.417031912108587, 5.140875887490322],
            [-19.413443328322938, 5.144150194013284],
            [-19.413051582204503, 5.148588456443819],
            [-19.40959899965836, 5.154045178880171],
            [-19.40440305099611, 5.15296837335061],
            [-19.399710195116487, 5.157460369851505],
            [-19.39678666660624, 5.167577890265761],
            [-19.392629605962373, 5.170609284837145],
            [-19.396955104387672, 5.179558206436336],
            [-19.39777039594343, 5.184656296325139],
            [-19.396695158988855, 5.188878207179003],
            [-19.397262661743856, 5.1948174069370445],
            [-19.39929073483357, 5.199216987040718],
            [-19.39813885156987, 5.20264162718348],
            [-19.399972776634932, 5.211101101006207],
            [-19.399228859303815, 5.217250934464786],
            [-19.407513398776416, 5.219027751595313],
            [-19.413216635692287, 5.219344498517591],
            [-19.416234618731526, 5.223329313850802],
            [-19.426154727007017, 5.233294177814764],
            [-19.427693045042695, 5.236069942254599],
            [-19.428289649364316, 5.244724939833013],
            [-19.425260803049678, 5.250270849692005],
            [-19.423168598509804, 5.257462853638097],
            [-19.426113067039516, 5.260407500546088],
            [-19.423834116027784, 5.266348700367201],
            [-19.41801218522199, 5.270788232398285],
            [-19.41082346698835, 5.275034066554732],
            [-19.410097588249226, 5.286861425475999],
            [-19.40337472607158, 5.295533838445126],
            [-19.399307832792477, 5.295723307318562],
            [-19.397314784827536, 5.299401665517377],
            [-19.398415418065273, 5.310353849877413],
            [-19.39481880140457, 5.315296028692255],
            [-19.397434820869947, 5.323299051969427],
            [-19.39721787273889, 5.328932346759796],
            [-19.39560304513669, 5.330774279537914],
            [-19.39106482360813, 5.330784941447933],
            [-19.38727104614829, 5.33259374594293],
            [-19.383880138824708, 5.326912469323288],
            [-19.378350912912655, 5.321310783560079],
            [-19.37333940385231, 5.321352736402822],
            [-19.367987143374155, 5.328137641781979],
            [-19.36105395255225, 5.3266709237343735],
            [-19.35514635424876, 5.329503723396037],
            [-19.352504476477645, 5.33333077025163],
            [-19.3465694653375, 5.334664322287852],
            [-19.341716359496136, 5.337263763488389],
            [-19.33553678363156, 5.337843609231465],
            [-19.331693409906915, 5.33524813024977],
            [-19.32399083678141, 5.334656633920005],
            [-19.318965241971895, 5.330027849202952],
            [-19.30618687326947, 5.324425763155359],
            [-19.299168534385483, 5.329194772139424],
            [-19.28998205475192, 5.329993775834812],
            [-19.2846950786572, 5.325922747662626],
            [-19.282194180810727, 5.3198251207101235],
            [-19.275408056750678, 5.318491062351021],
            [-19.271083266238083, 5.321313997484542],
            [-19.268375411809384, 5.325149895659329],
            [-19.262859279424454, 5.324835235158123],
            [-19.26047271460798, 5.328759682658128],
            [-19.256184183933918, 5.328753376397316],
            [-19.25224369849052, 5.334137005273038],
            [-19.24962698194116, 5.3401006139358795],
            [-19.24158611633571, 5.341253918728528],
            [-19.238085635406822, 5.344342479724836],
            [-19.22978865995606, 5.345914140664991],
            [-19.223322261873903, 5.343774828221755],
            [-19.219377970821, 5.345406276047186],
            [-19.21420889183725, 5.343436393461277],
            [-19.207911860772196, 5.345461393418294],
            [-19.20696750446156, 5.350900122189196],
            [-19.203607772086947, 5.358440728756842],
            [-19.19893391378285, 5.363221553741604],
            [-19.190714455465358, 5.3690609779301175],
            [-19.185634010970485, 5.36785894534637],
            [-19.179430569058507, 5.368191916348993],
            [-19.170788718755507, 5.370161755134312],
            [-19.16853869319473, 5.366028161149002],
            [-19.16461165326353, 5.366972077791783],
            [-19.163022770493026, 5.371757174117517],
            [-19.151288901645444, 5.375343982763336],
            [-19.14639795738712, 5.373634047919384],
            [-19.144939648796605, 5.3710090480724855],
            [-19.140519076452012, 5.380560066743326],
            [-19.13481105071209, 5.384289374923349],
            [-19.13257600428835, 5.394636847093419],
            [-19.132373910864438, 5.39976693304098],
            [-19.12941988575734, 5.403332153637535],
            [-19.117895190584527, 5.4072617828892895],
            [-19.11423653504724, 5.406893441166482],
            [-19.108629138160655, 5.4005876350517354],
            [-19.100858097480046, 5.400098300531401],
            [-19.09720573989658, 5.39562198276867],
            [-19.089688320342674, 5.393480663802273],
            [-19.086954715441898, 5.395061588923624],
            [-19.08565818714645, 5.398904707069607],
            [-19.080333299532324, 5.401825508523899],
            [-19.078445022259245, 5.406479711112184],
            [-19.07990308415437, 5.4095944163893686],
            [-19.080294616374452, 5.415913151911527],
            [-19.076491523655655, 5.424262393883226],
            [-19.07164350330214, 5.426868391597272],
            [-19.06284672477232, 5.429667616385937],
            [-19.06074479956398, 5.426501000512349],
            [-19.057243041185632, 5.426018287314006],
            [-19.05172800027215, 5.4199980676949115],
            [-19.04750657501795, 5.410839280281004],
            [-19.04847230537201, 5.402561250606851],
            [-19.045972058441755, 5.397289869827051],
            [-19.04128461544403, 5.395808126481586],
            [-19.03395733971983, 5.396213655381493],
            [-19.02270430024273, 5.392179247419265],
            [-19.025260883487732, 5.384270355732011],
            [-19.02036056427616, 5.377923837847377],
            [-19.017095499178385, 5.3714549796762805],
            [-19.012449938538456, 5.368255931834972],
            [-19.011064405791732, 5.364959545083385],
            [-19.01770895705255, 5.363617287564851],
            [-19.02180813062576, 5.3610825993896265],
            [-19.030690888930945, 5.359098220577885],
            [-19.031778428528142, 5.345456238319059],
            [-19.036329098869754, 5.340614944937742],
            [-19.042274290017016, 5.341053004474851],
            [-19.045924297728124, 5.336890593373051],
            [-19.048605064399954, 5.326725253057933],
            [-19.048474323214485, 5.323124665680272],
            [-19.05103978211308, 5.32071789095887],
            [-19.054264757620174, 5.309550443286121],
            [-19.05255282992529, 5.302701638017279],
            [-19.052935962293205, 5.298806781697901],
            [-19.058841978790408, 5.2955377994753565],
            [-19.062608008653, 5.2917849586917685],
            [-19.061042474652485, 5.281451287823382],
            [-19.068302849574835, 5.275695057810757],
            [-19.07207328647153, 5.271099642828749],
            [-19.069317301122506, 5.261402996463011],
            [-19.066184374202855, 5.259118517655314],
            [-19.063539679258614, 5.253637169826209],
            [-19.05895167356955, 5.248607605385906],
            [-19.058110203612763, 5.245098346418342],
            [-19.06305309970769, 5.238383233746964],
            [-19.063228627177246, 5.236362539363816],
            [-19.063906886875778, 5.232271333636703],
            [-19.059871747324678, 5.227983271522268],
            [-19.056001395236837, 5.228434211689307],
            [-19.047980818181784, 5.224639520298394],
            [-19.04535847735406, 5.217233935207722],
            [-19.042085934266293, 5.2142117662576855],
            [-19.037818133866647, 5.214137217480328],
            [-19.035926894197672, 5.2114803755097014],
            [-19.03494037813931, 5.203747436860917],
            [-19.0331879435635, 5.199911683984491],
            [-19.03883860806835, 5.192100807369204],
            [-19.04009989577684, 5.180936737304578],
            [-19.045325505227243, 5.163976815132636],
            [-19.05015965619946, 5.160392039534671],
            [-19.050461998459784, 5.154990235898086],
            [-19.05438403100149, 5.150875396186287],
            [-19.057476423974922, 5.144847207360159],
            [-19.060889918842868, 5.146938473954811],
            [-19.065313446535736, 5.147314430126651],
            [-19.072731397454515, 5.144361753169727],
            [-19.075732251427862, 5.144809310049242],
            [-19.08640491631711, 5.141991319908086],
            [-19.090774806374704, 5.144949044272443],
            [-19.095690255139502, 5.144699349518117],
            [-19.100197887741317, 5.148264248348591],
            [-19.10332727941095, 5.145678689346534],
            [-19.107289067944162, 5.144906976863716],
            [-19.114509417325536, 5.140360661307936],
            [-19.11980568611456, 5.140951344256806],
            [-19.123525814772123, 5.138603919419731],
            [-19.123751449520217, 5.129856622602741],
            [-19.11992597654554, 5.129439229072728],
            [-19.116133458206072, 5.12650133345044],
            [-19.115308494723717, 5.122262808679411],
            [-19.116652433954428, 5.115414231289563],
            [-19.122051620045326, 5.11010218906994],
            [-19.12404346668918, 5.105332355937977],
            [-19.12868490665498, 5.0897640568068026],
            [-19.128720600603774, 5.086263875992539],
            [-19.131054463974955, 5.079940624671684],
            [-19.134017675103706, 5.076849825270149],
            [-19.138075999571914, 5.075370453865753],
            [-19.141675052618517, 5.0704239311387775],
            [-19.148243456472148, 5.075267510327303],
            [-19.153283091017023, 5.075033638058078],
            [-19.15511981658421, 5.0712358446310155],
            [-19.159883214301068, 5.069592159556119],
            [-19.164698075088626, 5.062168172500424],
            [-19.169036200071318, 5.060065701161415],
            [-19.174078873479612, 5.059605949164696],
            [-19.178648646421085, 5.060692649741488],
            [-19.18217784957498, 5.0642261360696725],
            [-19.185262491531425, 5.059035139953761],
            [-19.19269876387883, 5.057283316860837],
            [-19.196494492801982, 5.0528415228359425],
            [-19.19713734916, 5.048526416338949],
            [-19.200566153273527, 5.042333427901133],
            [-19.203807035674885, 5.041925803848882],
            [-19.204972516298024, 5.038554523832203],
            [-19.204987371187038, 5.029299690679593],
            [-19.205866170481595, 5.024236626765461],
            [-19.20900067995854, 5.023041785278399],
            [-19.211955659750437, 5.0145909589085615],
            [-19.218149728064148, 5.007503610039516],
            [-19.218014663347116, 4.999832425114673],
            [-19.215049255156455, 4.993693054096736],
            [-19.215284835424956, 4.984214071895997],
            [-19.218620931142798, 4.9832638312865365],
            [-19.220243531815502, 4.978397491104772],
            [-19.22658972107382, 4.971362297925343],
            [-19.239995606159564, 4.967982190564543],
            [-19.243096217417495, 4.958045625696034],
            [-19.250447382157123, 4.954084258012971],
            [-19.251837781367357, 4.950057436481215],
            [-19.25589524370837, 4.947408052272292],
            [-19.25863356778873, 4.9396651274798975],
            [-19.26738400890049, 4.940041333153174],
            [-19.271106428419845, 4.939370701721073],
            [-19.274145269523594, 4.933793619724881],
            [-19.2829506521704, 4.926624097649704],
            [-19.280284454363976, 4.908835534719597],
            [-19.28364639283655, 4.901559493632501],
            [-19.28669753372552, 4.901164772927316],
            [-19.288804433499443, 4.8950592917309],
            [-19.288175700444842, 4.887907014201846],
            [-19.295046367855033, 4.884054637104924],
            [-19.300501308685675, 4.876722501516915],
            [-19.30389677527118, 4.8749639276695556],
            [-19.316320117986287, 4.871720517129728],
            [-19.32067464217949, 4.869087650629462],
            [-19.32767547516041, 4.8683662730782435],
            [-19.327246879072682, 4.866040338501784],
            [-19.333518824965832, 4.861098613509819],
            [-19.34220225506919, 4.861113280179898],
            [-19.34615215766486, 4.854080505104275],
            [-19.343039522477923, 4.846982111234217],
            [-19.340499268472836, 4.838126020788143],
            [-19.346997843428113, 4.8287012173563415],
            [-19.349005726196488, 4.824184513912432],
            [-19.353836440885516, 4.823808571892394],
            [-19.356339806448375, 4.817993950030394],
            [-19.360246110217137, 4.812214753714523],
            [-19.366665368259362, 4.810614349586194],
            [-19.372271429871315, 4.812893831739725],
            [-19.374258300129096, 4.8160689321243],
            [-19.383235543727604, 4.8129856030827485],
            [-19.384144443559855, 4.808804131943018],
            [-19.382839844909597, 4.804763298474852],
            [-19.379518868389006, 4.800331078856566],
            [-19.381482632773867, 4.7945889477282435],
            [-19.382286394614326, 4.787094943741989],
            [-19.377609365744803, 4.78263967637481],
            [-19.379273092742114, 4.777395742424539],
            [-19.37621687301853, 4.769727769592097],
            [-19.381205475749823, 4.765780914765682],
            [-19.386796305380166, 4.757928083988014],
            [-19.38458445189103, 4.75535237130209],
            [-19.378014517888705, 4.754013465277658],
            [-19.372568688038225, 4.751495180630041],
            [-19.369051615891117, 4.747505658100787],
            [-19.374066468187497, 4.735149171520904],
            [-19.374973881323722, 4.72969644675976],
            [-19.37235721751662, 4.726241148905588],
            [-19.374248190979895, 4.722070483606332],
            [-19.3745921709092, 4.716963019086776],
            [-19.372833829018173, 4.7117907606872365],
            [-19.374873614616316, 4.701620198033109],
            [-19.371188729398654, 4.695333191558187],
            [-19.372683658144645, 4.6901034240212205],
            [-19.378508824380614, 4.6854532456392874],
            [-19.389328917615217, 4.690300702308016],
            [-19.39374175060266, 4.696148732122071],
            [-19.402527315973014, 4.69420456941386],
            [-19.41072249813248, 4.689309633711504],
            [-19.411774329419245, 4.6855176664730935],
            [-19.41550228399766, 4.679886569002921],
            [-19.419160591422568, 4.6826223930846265],
            [-19.424606208616726, 4.683891443633479],
            [-19.425824921038103, 4.685727812754606],
            [-19.432143842537712, 4.686122088283709],
            [-19.432980475430817, 4.684450164199063],
            [-19.443115415552214, 4.680168417303117],
            [-19.448977768276, 4.676056132594352],
            [-19.45055376666904, 4.671929585518345],
            [-19.449365743195788, 4.666700840201654],
            [-19.459980915015695, 4.6609332299964965],
            [-19.462216595189595, 4.652245762063955],
            [-19.46841292069713, 4.65060125442851],
            [-19.482223528069916, 4.65430053969402],
            [-19.490049394626134, 4.652413613797325],
            [-19.49835071825162, 4.654466219137193],
            [-19.502989059330293, 4.654253079529568],
            [-19.508611162275386, 4.651455139434391],
            [-19.50675550540231, 4.647151316500887],
            [-19.507773395131974, 4.64055570656896],
            [-19.512082201848152, 4.636714975751977],
            [-19.517040421010698, 4.634727023909432],
            [-19.528276762842374, 4.636852020923303],
            [-19.538830697771473, 4.632790664879721],
            [-19.540353988113974, 4.630125173647805],
            [-19.545148900966986, 4.628128033065715],
            [-19.54546572246182, 4.625251176396863],
            [-19.549270000775785, 4.620992144884084],
            [-19.555418076794805, 4.6117188842590515],
            [-19.560654556176505, 4.608120169781611],
            [-19.569063777471268, 4.613969676958571],
            [-19.578690156714366, 4.6154043271126195],
            [-19.582083865098454, 4.611035405765957],
            [-19.588713530487674, 4.607619510519667],
            [-19.589771888844467, 4.601716973116656],
            [-19.591587910482716, 4.600007030884162],
            [-19.60200875573822, 4.597904228444969],
            [-19.606048323425533, 4.596177409238439],
            [-19.60882766899005, 4.60198549161277],
            [-19.613130679761703, 4.599936548737863],
            [-19.62049928577864, 4.598719321807968],
            [-19.626159928054633, 4.598972204319342],
            [-19.63188877384551, 4.601849573709053],
            [-19.637793370401727, 4.60228229044423],
            [-19.64086369322746, 4.590889716618814],
            [-19.643037284937723, 4.5884674769628],
            [-19.642755274068236, 4.580860394098203],
            [-19.651705473385753, 4.576445226060465],
            [-19.656760824595917, 4.576239790965474],
            [-19.662079885432302, 4.572795500857916],
            [-19.66211784816852, 4.57016213512112],
            [-19.666375143723567, 4.561875141842465],
            [-19.670137436184547, 4.558649115446703],
            [-19.67707300423188, 4.556516500697242],
            [-19.681195474025323, 4.558589732855321],
            [-19.684143227390514, 4.55659893003591],
            [-19.688951955391904, 4.550352688506251],
            [-19.6910758394028, 4.543210446739329],
            [-19.69685555023036, 4.544725035421498],
            [-19.70232728983876, 4.547661377366857],
            [-19.707732901874294, 4.544877139708708],
            [-19.70667562208459, 4.54292337220528],
            [-19.70871241410853, 4.537707905838552],
            [-19.71325959248752, 4.53419329481387],
            [-19.71279509362348, 4.525155201371082],
            [-19.7140401685878, 4.513805163320421],
            [-19.720092325975084, 4.51105856470444],
            [-19.721086372025198, 4.505723912653635],
            [-19.719990766213435, 4.501038072643762],
            [-19.72228441775018, 4.496826694776821],
            [-19.723650204449605, 4.489790380215055],
            [-19.72254626676839, 4.486278994173117],
            [-19.723222871436473, 4.480016158766128],
            [-19.71977408851775, 4.473330538582065],
            [-19.71865485460622, 4.468214438629152],
            [-19.710033779917538, 4.458888317013805],
            [-19.705298736609613, 4.4612265181597],
            [-19.69650077796192, 4.456525078042837],
            [-19.692825974095996, 4.4526849272917275],
            [-19.68805052382038, 4.443895800381787],
            [-19.678609467087497, 4.438072238203484],
            [-19.672787536442968, 4.427094084441248],
            [-19.675533387264895, 4.420866495972701],
            [-19.673484878167635, 4.418162286554162],
            [-19.677230865114737, 4.409873874701238],
            [-19.680051938518115, 4.407379774863345],
            [-19.68209691212437, 4.401950957505777],
            [-19.683105839403744, 4.3935934255475075],
            [-19.68092462378189, 4.390268869725513],
            [-19.680553232819168, 4.383131053431203],
            [-19.684811187200975, 4.3783769366545355],
            [-19.682881824937773, 4.372414472326732],
            [-19.687040960077262, 4.368813635200518],
            [-19.69262755312308, 4.366436168960924],
            [-19.69701305853225, 4.361514874994844],
            [-19.699006970316756, 4.355000587240654],
            [-19.702377089768753, 4.349887576918875],
            [-19.702701081461466, 4.343703703173334],
            [-19.706992641148346, 4.336316992714585],
            [-19.701473939149288, 4.330448633956213],
            [-19.69514851349526, 4.3264372737796215],
            [-19.701395014223188, 4.318812509868203],
            [-19.70225222782256, 4.312138927184975],
            [-19.70155579990416, 4.306733448694316],
            [-19.703268649366322, 4.304334504209275],
            [-19.70156447389382, 4.297838309313371],
            [-19.700732887844648, 4.287145457383479],
            [-19.703867754657942, 4.2835288229195125],
            [-19.703882413474734, 4.277325827110188],
            [-19.707941509386764, 4.2777230385986185],
            [-19.712555323773337, 4.270555454194488],
            [-19.715904392834652, 4.268032636533893],
            [-19.71328339715888, 4.263355229826269],
            [-19.714865289510886, 4.258561532400732],
            [-19.710436560596396, 4.255258037360619],
            [-19.706094686466635, 4.2464907055650185],
            [-19.7060389130545, 4.236015437307971],
            [-19.71112404699592, 4.232974408914229],
            [-19.712918697870247, 4.225722236210556],
            [-19.71165668055668, 4.2191529284071025],
            [-19.714747307818058, 4.213287746444047],
            [-19.71991171238121, 4.20880419519336],
            [-19.7202944583834, 4.204638388419731],
            [-19.717068465856624, 4.199787456147892],
            [-19.722600463300807, 4.186869846428122],
            [-19.71765152989495, 4.1822741344495435],
            [-19.713847971088818, 4.171661021077584],
            [-19.716303748780888, 4.168115081525718],
            [-19.715413879296797, 4.163668580318482],
            [-19.762096878585137, 4.177010986000427],
            [-19.7643463262008, 4.17784950561615],
            [-19.88505195763831, 4.212829205330983],
            [-20.00576280004253, 4.247789424298069],
            [-20.064134743646136, 4.264830825067198],
            [-20.06677514938456, 4.265737013786435],
            [-20.160433643632587, 4.293293065893084],
            [-20.15317411446594, 4.317290282479471],
            [-20.12281253892004, 4.418174462996957],
            [-20.08344094023691, 4.548900477513835],
            [-20.08158900303255, 4.556302500910117],
            [-20.055385341088986, 4.6443445080092545],
            [-20.02974200355222, 4.729767641813104],
            [-20.00962251270814, 4.796653924281268],
            [-20.009557815268945, 4.797585082148091],
            [-19.996277829390976, 4.841364366701636],
            [-19.982588945267462, 4.887959292551386],
            [-19.943166673317357, 5.018730901534583],
            [-19.94113180567252, 5.022435462703841],
            [-19.940272537702214, 5.027812286089588],
            [-19.941399270831806, 5.04015121381825],
            [-19.940307677265036, 5.046312215293962],
            [-19.941705528681105, 5.049571841530063],
            [-19.93793772395576, 5.051669759035685],
            [-19.938678160243793, 5.058976697339553],
            [-19.934505435352747, 5.061478431075418],
            [-19.933953079182974, 5.064118621150385],
            [-19.938135695083222, 5.0694059435743215],
            [-19.9383710378746, 5.074142053311765],
            [-19.936226644645195, 5.0767944165095225],
            [-19.93776057267549, 5.080657367018471],
            [-19.94126845640777, 5.078762625201334],
            [-19.939364670975472, 5.087276327601082],
            [-19.933442166836954, 5.082834451323596],
            [-19.93144932482302, 5.084061067906844],
            [-19.931371857097023, 5.089262732548862],
            [-19.92900484567069, 5.097251664854877],
            [-19.933403617186386, 5.0998651152057475],
            [-19.932670611133716, 5.102418893265532],
            [-19.934661030898923, 5.110974321883352],
            [-19.930644437998982, 5.115137961962142],
            [-19.92563085733327, 5.11801791732802],
            [-19.925321681727855, 5.120309689864893],
            [-19.928671472799806, 5.124575804331858],
            [-19.924813983768853, 5.1291304535242555],
            [-19.92505340201731, 5.131100963559318],
            [-19.930428080312456, 5.133448209071606],
            [-19.930398208262098, 5.1453963449744355],
            [-19.928931067334897, 5.148778678084959],
            [-19.9367983887372, 5.1513491981235076],
            [-19.92935061408689, 5.158826684084094],
            [-19.933024909761038, 5.162175270733226],
            [-19.936265796631876, 5.160938175955668],
            [-19.938837554967215, 5.1672149128872045],
            [-19.938133067995885, 5.169946565276128],
            [-19.94117920658208, 5.17544011116029],
            [-19.937058641363116, 5.177739930533394],
            [-19.937347671760648, 5.1825658775775265],
            [-19.941670746301288, 5.1917518920432615],
            [-19.93755281160412, 5.19537912526348],
            [-19.937151178057196, 5.2002750635545825],
            [-19.94146497642007, 5.211284328817773],
            [-19.93757732040994, 5.217970055419443],
            [-19.941993387478345, 5.223443164471413],
            [-19.94303394264564, 5.227061079995123],
            [-19.941079089653055, 5.229653648687519],
            [-19.93387241754284, 5.224941745597487],
            [-19.928717946755395, 5.223616939014996],
            [-19.924637105237196, 5.22418414623016],
            [-19.920206464702353, 5.218883148323505],
            [-19.91640011586383, 5.218798899320575],
            [-19.9134095673213, 5.221472741324843],
            [-19.903670951523935, 5.2239490393366275],
            [-19.900393633971742, 5.222634239011917],
            [-19.89991008429683, 5.231292344446374],
            [-19.897522801603774, 5.234040963527108],
            [-19.891061450570632, 5.234218682094243],
            [-19.88878247786211, 5.229033459341902],
            [-19.88212538427882, 5.222551218597097],
            [-19.880060882563633, 5.2179562172684895],
            [-19.883166948844796, 5.213848610444769],
            [-19.877798567024385, 5.209844586477351],
            [-19.87290073812706, 5.209753071124095],
            [-19.86925422620672, 5.206260907970987],
            [-19.865882658123247, 5.20002139801796],
            [-19.864922717292163, 5.195127178079423],
            [-19.855285881510103, 5.187868750796573],
            [-19.850301114159926, 5.187019950447969],
            [-19.844713545821286, 5.183478265194161],
            [-19.839181558653237, 5.1944114273158615],
            [-19.835172284779933, 5.198149198352243],
            [-19.820574422770754, 5.204620046936469],
            [-19.817187631418527, 5.203082324324716],
            [-19.812378068265744, 5.204079120707652],
            [-19.809783646292775, 5.206764398170813],
            [-19.80683934647767, 5.213219045825228],
            [-19.8073391282283, 5.217567620781201],
            [-19.81151760457099, 5.2216334717463075],
            [-19.810327098688116, 5.224837658013353],
            [-19.80505645285652, 5.226004902867639],
            [-19.796472948849075, 5.229646264349836],
            [-19.791275731269785, 5.239209421343149],
            [-19.788649583761945, 5.238855036643508],
            [-19.784745869157785, 5.242519130484957],
            [-19.781932544249127, 5.249858323827605],
            [-19.781528014465845, 5.254601794123963],
            [-19.773434999659923, 5.261608779104426],
            [-19.765844319646828, 5.260484494445477],
            [-19.762452674018224, 5.261739569155499],
            [-19.763287337199092, 5.2701309020101625],
            [-19.758216149701134, 5.279047989509033],
            [-19.761004447394615, 5.279943904226587],
            [-19.766063040520727, 5.286099949567752],
            [-19.76646088684018, 5.293600789735289],
            [-19.764413798986833, 5.304058956213604],
            [-19.76183020004166, 5.308954613286779],
            [-19.76570571814008, 5.315451487825617],
            [-19.770439971599863, 5.315242650070241],
            [-19.776825197813903, 5.317078677519632],
            [-19.779822889204976, 5.325139356021929],
            [-19.783796426672584, 5.325984181376853],
            [-19.783396559471203, 5.33165108749837],
            [-19.785806221572713, 5.335096656920157],
            [-19.780171900746105, 5.339777697760081],
            [-19.779443344653696, 5.342871426037006],
            [-19.78151132565779, 5.350766058546491],
            [-19.778048306531534, 5.350822917215233],
            [-19.7763288516659, 5.347105367435769],
            [-19.76953996726544, 5.343401451362259],
            [-19.763813702990333, 5.345547954050592],
            [-19.764181301026962, 5.34802223445478],
            [-19.75815189156484, 5.354146447996373],
            [-19.758552648539638, 5.356080680343591],
            [-19.754374739753153, 5.362772170474516],
            [-19.748944934047703, 5.367810861316969],
            [-19.746605082668502, 5.374295855242205],
            [-19.74474910683753, 5.3848972528341825],
            [-19.741375647179492, 5.393607040017989],
            [-19.742019097068198, 5.396889035767484],
            [-19.738825537789246, 5.400483803902991],
            [-19.73966491512465, 5.407632549932911],
            [-19.738309252221125, 5.411300342847607],
            [-19.729635214820917, 5.412926721548102],
            [-19.72729594558573, 5.410609710165214],
            [-19.720303013217336, 5.414530232524545],
            [-19.71616974152788, 5.42298046066319]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.11263708249417,
          "lat": 40.65068449198221
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06105"],
        "coty_name": ["Trinity"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trinity County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00277317"
      },
      "bbox": [
        -20.160433643632587, 4.163668580318482, -19.011064405791732,
        5.429667616385937
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.57315909865779, 3.0179625400886905],
            [-19.56077540877529, 3.0142488881697744],
            [-19.514878951209074, 3.001237183449544],
            [-19.50444656614727, 2.9981140527354815],
            [-19.4908882751654, 2.995183685157395],
            [-19.36582297558599, 2.96108508483441],
            [-19.32087169697593, 2.948135895679476],
            [-19.23359174940585, 2.9233242012952676],
            [-19.198782413805326, 2.9129290172810234],
            [-19.196185260302904, 2.9065303729758782],
            [-19.18862833129694, 2.902762256442046],
            [-19.184687886350208, 2.8994690642611327],
            [-19.17870453388911, 2.8969176335714497],
            [-19.183012972010555, 2.8935978578384436],
            [-19.182939157759517, 2.8901492323542413],
            [-19.175477798310048, 2.886542565014396],
            [-19.171837562265146, 2.8864687490365704],
            [-19.171543295823334, 2.8832060416605376],
            [-19.174898771590247, 2.88122131443889],
            [-19.18156485278683, 2.8843135766690713],
            [-19.182064086834906, 2.879950319183514],
            [-19.189188595202726, 2.871798595535745],
            [-19.195266115099326, 2.8705746158627665],
            [-19.19650719007888, 2.8687414451324273],
            [-19.19641202747436, 2.862128478358075],
            [-19.193907445504557, 2.8567579453022254],
            [-19.19007839329943, 2.853501275624148],
            [-19.190020765733294, 2.847475679758875],
            [-19.185106263883384, 2.84859778442314],
            [-19.183907406020857, 2.844405192344619],
            [-19.18041853420216, 2.844743102375468],
            [-19.17814841496626, 2.8424124786553344],
            [-19.179103874693006, 2.8364895956909706],
            [-19.17225333543043, 2.8394592883186176],
            [-19.16720926648026, 2.838264843393379],
            [-19.16298051273374, 2.839864587538572],
            [-19.15804795208057, 2.836846009110888],
            [-19.15840163221629, 2.841739954176984],
            [-19.14952072194384, 2.843514645043502],
            [-19.148122363479047, 2.8418205563110326],
            [-19.147762444243078, 2.8356084697480175],
            [-19.143465913340215, 2.8309338359376572],
            [-19.13846977476483, 2.8277265895872254],
            [-19.138300311597746, 2.8217371156026676],
            [-19.135847149095728, 2.817936323991754],
            [-19.140020760480443, 2.81589364110317],
            [-19.139951773951044, 2.8094746151339796],
            [-19.143428506232354, 2.8083513598279417],
            [-19.145197769991025, 2.8040211221842397],
            [-19.143371520179763, 2.8002086725785014],
            [-19.14227231484848, 2.793752092893754],
            [-19.144958221936797, 2.7869284254012316],
            [-19.14812234637333, 2.772496400232607],
            [-19.137064212182096, 2.766583970833255],
            [-19.13188676546403, 2.7672339748401433],
            [-19.13002047973643, 2.7607864175548693],
            [-19.126134293254697, 2.7570587706901044],
            [-19.129586168891603, 2.752769918084451],
            [-19.128089704498944, 2.744311923944665],
            [-19.12832850964288, 2.737292847879149],
            [-19.134699472104046, 2.7305411770747203],
            [-19.131232268112992, 2.725549175947475],
            [-19.126955387848767, 2.724446403460683],
            [-19.12579984380402, 2.721218379157349],
            [-19.120433709720373, 2.718311955425863],
            [-19.12729958052485, 2.712600482946667],
            [-19.12872226293824, 2.710102398797951],
            [-19.127979386976012, 2.7040539918222946],
            [-19.124321756133458, 2.704226050817837],
            [-19.12132541819916, 2.7122553176400315],
            [-19.116960960615398, 2.7136093693058245],
            [-19.112916896782554, 2.7120058416707566],
            [-19.11246029167705, 2.717911621213237],
            [-19.114566928304527, 2.722911265857915],
            [-19.11179059628635, 2.7269251537875405],
            [-19.10941047504809, 2.7260568699809498],
            [-19.1084469379469, 2.7210290709082594],
            [-19.105893609177127, 2.719772987027397],
            [-19.095099052914303, 2.72009446624999],
            [-19.099693282022553, 2.7250469822425343],
            [-19.094766009864845, 2.7252942525784962],
            [-19.093166003542976, 2.7192487749698953],
            [-19.090727811020802, 2.719701428436946],
            [-19.087227246558577, 2.7267262455039383],
            [-19.083771238295547, 2.7289855620475247],
            [-19.08484039417357, 2.733441151622628],
            [-19.08013676036025, 2.734415386899361],
            [-19.072579945913155, 2.7285484439815333],
            [-19.06856068441621, 2.726535621081171],
            [-19.06401249133838, 2.7190201218280317],
            [-19.061869463239436, 2.705856908684979],
            [-19.064837122503736, 2.6973890594453342],
            [-19.06777816151317, 2.6928228565723424],
            [-19.07415311497, 2.6859923418077765],
            [-19.076777339212512, 2.6816935548696983],
            [-19.083630252128422, 2.665252260160115],
            [-19.092416864348035, 2.657967740045613],
            [-19.105954924461482, 2.651091269067307],
            [-19.109137164311406, 2.648771869896655],
            [-19.112432180432553, 2.6434028067119635],
            [-19.113237973197688, 2.6339985786358793],
            [-19.111912336837943, 2.6274718299353523],
            [-19.101834900323684, 2.6104072811303825],
            [-19.098873628488676, 2.6034153175003296],
            [-19.09484809380255, 2.5906887288942193],
            [-19.09007950985495, 2.5879081348775936],
            [-19.08021828329229, 2.5913633573837385],
            [-19.07631248151404, 2.5892389509810854],
            [-19.073730795763083, 2.5829843400299435],
            [-19.07745582201273, 2.5592114572270916],
            [-19.077784208368676, 2.5484196949373965],
            [-19.07387769686833, 2.538137472984963],
            [-19.070377537074425, 2.5353944327606595],
            [-19.065147450014617, 2.538350043838371],
            [-19.055917433114967, 2.538636477025261],
            [-19.04754599477758, 2.5343472442710477],
            [-19.044893901246798, 2.531735179468076],
            [-19.043829388792638, 2.5271520695542717],
            [-19.044858817418973, 2.516433739900833],
            [-19.051829569796276, 2.5065442106529536],
            [-19.06120337794224, 2.4999133141523897],
            [-19.05980314646564, 2.487980467658774],
            [-19.059313277873795, 2.4785568678166867],
            [-19.06222449635183, 2.4735530932564482],
            [-19.069017333831532, 2.469795193278647],
            [-19.075941725226205, 2.4682869227791797],
            [-19.07865616349313, 2.465752035350932],
            [-19.07559286543342, 2.457103850108548],
            [-19.077297037179495, 2.454712734870842],
            [-19.08210551530337, 2.454458173091225],
            [-19.08935329369852, 2.45565037644418],
            [-19.098248913342182, 2.455332742029338],
            [-19.10617201625212, 2.446330529248477],
            [-19.107885937928337, 2.4408427938101496],
            [-19.10413319457265, 2.424150415184035],
            [-19.102361730613282, 2.418570856055602],
            [-19.098922244942774, 2.414402480756798],
            [-19.095200984504167, 2.412606536667143],
            [-19.083048830271526, 2.409965103616382],
            [-19.077180001005242, 2.406581714333557],
            [-19.075317725527732, 2.3995345445830765],
            [-19.07739405793203, 2.3829124064028093],
            [-19.07998728732165, 2.3761077660250995],
            [-19.082314316196438, 2.373258476787563],
            [-19.087730021245324, 2.370844593373756],
            [-19.092283832766537, 2.3706657070519754],
            [-19.10094889980892, 2.3733650668417132],
            [-19.106003579988823, 2.37123813213621],
            [-19.106078389893412, 2.367140895712956],
            [-19.100717551780747, 2.3462112942301228],
            [-19.100068185652418, 2.33893484360693],
            [-19.10066298999578, 2.3336401372657414],
            [-19.103842547474326, 2.3255063114233105],
            [-19.105689780186143, 2.323335156903291],
            [-19.112635052406528, 2.3198196982225436],
            [-19.11462626759531, 2.3147737870888534],
            [-19.11466306136492, 2.306046823093721],
            [-19.116923745775004, 2.2995690322973217],
            [-19.120343205052905, 2.29821013542408],
            [-19.13165977776728, 2.2907299540240604],
            [-19.14986186223756, 2.290279057595208],
            [-19.162333814809386, 2.28162581517727],
            [-19.165875476881734, 2.278565747593282],
            [-19.169084876529016, 2.2836233367635272],
            [-19.17329215639691, 2.282316022840602],
            [-19.173811068328217, 2.2790269417967584],
            [-19.17801001056516, 2.277231819757261],
            [-19.179776769755545, 2.272331497760222],
            [-19.183178558507407, 2.2686063601318995],
            [-19.200829420015143, 2.273533789774219],
            [-19.257599167743198, 2.2898586355105834],
            [-19.258222170944507, 2.290772435489266],
            [-19.254502560152552, 2.3056226167362444],
            [-19.25014209400215, 2.319687901356276],
            [-19.211281711904284, 2.4590547910140628],
            [-19.212890785610117, 2.459511820868289],
            [-19.20292853571479, 2.4935579045600096],
            [-19.201418382583576, 2.497622352253806],
            [-19.205840650416878, 2.4992373595440944],
            [-19.209095686765377, 2.5084844950062837],
            [-19.21249094489302, 2.5118392278479185],
            [-19.219105050881687, 2.5107575846461776],
            [-19.231328010957533, 2.5170601635410166],
            [-19.240852536793124, 2.512635398884274],
            [-19.247000468101042, 2.5129584989201916],
            [-19.254314923065834, 2.511034474202753],
            [-19.256238594294715, 2.5129528312108573],
            [-19.257264808368628, 2.518647937435086],
            [-19.264114203528454, 2.5180030428827065],
            [-19.270527252083895, 2.5126249671303102],
            [-19.276478467944806, 2.5183303907578547],
            [-19.28696329576659, 2.521183187424049],
            [-19.29026898464153, 2.521202203482681],
            [-19.29819849944277, 2.526836242867782],
            [-19.303606500550945, 2.5288244947960945],
            [-19.30765258518474, 2.5337390379082003],
            [-19.313867082875987, 2.5388579815458323],
            [-19.323740067219408, 2.543464162404251],
            [-19.343102838805645, 2.5482769866581587],
            [-19.348296795787775, 2.5451284511332006],
            [-19.353581275416367, 2.545502780022392],
            [-19.360673617531294, 2.544548289788824],
            [-19.37284009126869, 2.548082447456875],
            [-19.383001183047053, 2.5547768509347963],
            [-19.390062682978403, 2.5501647669195107],
            [-19.407173465701636, 2.547621845141483],
            [-19.410478195400085, 2.5440222953305778],
            [-19.413962529926867, 2.5428554770896636],
            [-19.418029324376697, 2.5382772449954185],
            [-19.429385471543753, 2.5342849782187904],
            [-19.433497702861875, 2.5343802452794018],
            [-19.43908686068609, 2.5307825651281397],
            [-19.4456782738503, 2.528665900406719],
            [-19.44807674105638, 2.526708567103262],
            [-19.453377682615827, 2.528160847128485],
            [-19.461400977572247, 2.53506977924147],
            [-19.465587318603138, 2.5419599288388004],
            [-19.46610752424602, 2.5490732378358034],
            [-19.47472378221855, 2.5637829066137394],
            [-19.483875522281956, 2.562861025515996],
            [-19.49749351167647, 2.567078053532276],
            [-19.500001516124197, 2.5693755064573702],
            [-19.505242092835445, 2.567608574885971],
            [-19.510681977026298, 2.5696206766964087],
            [-19.50992787762073, 2.571897500232437],
            [-19.512580324069507, 2.5790006121363422],
            [-19.513516905077203, 2.5845140187614346],
            [-19.511459018006704, 2.5881959300996225],
            [-19.513023998418397, 2.5931694323088452],
            [-19.511218364724684, 2.5954896417079656],
            [-19.51110695371601, 2.611927264719591],
            [-19.510331321608753, 2.618905723856421],
            [-19.510828869540187, 2.6237956162207228],
            [-19.50849785732312, 2.626698151057606],
            [-19.508876047427915, 2.6408201066709305],
            [-19.507418823311635, 2.6463403970135846],
            [-19.508867674899403, 2.654425496338628],
            [-19.508225197865624, 2.6645854473991997],
            [-19.509367504305942, 2.670809950831038],
            [-19.511732100662652, 2.672990898351273],
            [-19.511884483057674, 2.6776767275528837],
            [-19.51537520277729, 2.6877549795839446],
            [-19.52290186518532, 2.6840725387354487],
            [-19.526671858067036, 2.683683458860221],
            [-19.526857279269183, 2.696284818579128],
            [-19.52013867400834, 2.6974716157583862],
            [-19.51832284735039, 2.6993762544103537],
            [-19.520366529979654, 2.7065704018580297],
            [-19.516797503904492, 2.708257068401633],
            [-19.51653962343645, 2.712179569974011],
            [-19.51809608650863, 2.7206301891954543],
            [-19.5230387960007, 2.7256493500500976],
            [-19.528459139849737, 2.7253547054002576],
            [-19.53370692950079, 2.7338160732569863],
            [-19.536666427288573, 2.740861249520955],
            [-19.538569665954054, 2.7497747810462982],
            [-19.533952364293285, 2.754586163114249],
            [-19.534453835220987, 2.7621486845085728],
            [-19.538943104438815, 2.768466271691908],
            [-19.54192689174772, 2.7670278032332263],
            [-19.54668241209384, 2.771326042937432],
            [-19.547882022736545, 2.775817154045667],
            [-19.54558805532156, 2.7800079507565774],
            [-19.54623853166575, 2.7835618179999013],
            [-19.544927016611517, 2.789760946912485],
            [-19.54503765603796, 2.7965435835531975],
            [-19.542340405022156, 2.7978006024260957],
            [-19.54631856938359, 2.819601235110332],
            [-19.548972195598633, 2.821564857778299],
            [-19.54892130206438, 2.828117411149234],
            [-19.55100032824825, 2.8302571607994818],
            [-19.55183833507209, 2.835341272173055],
            [-19.550123316532275, 2.8444793541054545],
            [-19.549402007088137, 2.8528892564875115],
            [-19.549764656622237, 2.8704853057352295],
            [-19.5522952280746, 2.8780561788228542],
            [-19.555216613036116, 2.89472331871973],
            [-19.554448380323755, 2.8962897093285833],
            [-19.555054275797158, 2.905210845629048],
            [-19.55692067739284, 2.910297448722579],
            [-19.556616567087634, 2.9204209276333555],
            [-19.557469556825083, 2.925173228208074],
            [-19.563446487519588, 2.9256320233660738],
            [-19.56803715537069, 2.927748495509081],
            [-19.568175315461346, 2.9308465234675545],
            [-19.57827192435716, 2.930758268316774],
            [-19.57956029940488, 2.934930345736534],
            [-19.582741531557264, 2.9389227928962085],
            [-19.588458408293324, 2.9364134902311165],
            [-19.591333929451434, 2.938752335795365],
            [-19.59750641177183, 2.938779061724912],
            [-19.603004992037896, 2.934337282847308],
            [-19.605400946655198, 2.9344719626699383],
            [-19.608553843853194, 2.9383309584960373],
            [-19.619143726546778, 2.9482012096385835],
            [-19.620644236310927, 2.952604905753043],
            [-19.62422515408186, 2.954691095842307],
            [-19.62986076075957, 2.9654400285293114],
            [-19.63069993455888, 2.9711584380664524],
            [-19.626267099545878, 2.974058018157032],
            [-19.62887059975949, 2.977701411963952],
            [-19.62872051727691, 2.981148096893553],
            [-19.634164610330394, 2.9893071585063646],
            [-19.632705910134074, 2.9920791970903293],
            [-19.635350020959216, 2.9991234751570555],
            [-19.636539139542272, 3.007531720162907],
            [-19.640303409687444, 3.0125804323702794],
            [-19.63939866737037, 3.015342386269811],
            [-19.63382278972429, 3.017846950059695],
            [-19.626374782096747, 3.027131747678809],
            [-19.620126364301466, 3.032414595016585],
            [-19.58367677672488, 3.021977373249996],
            [-19.57315909865779, 3.0179625400886905]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.90112685696153,
          "lat": 38.68662891891922
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06113"],
        "coty_name": ["Yolo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yolo County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00277321"
      },
      "bbox": [
        -19.640303409687444, 2.2686063601318995, -19.043829388792638,
        3.032414595016585
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.505631036074499, 1.1042826691942575],
            [-7.501717721450248, 1.1058075206409166],
            [-7.490369873026397, 1.1146107499935254],
            [-7.487504091292476, 1.1196072684758924],
            [-7.483844839358622, 1.1212715218918812],
            [-7.477185637279528, 1.1189512784433453],
            [-7.473222454299874, 1.1156317670391143],
            [-7.469151573647956, 1.1147731001695214],
            [-7.468043667751249, 1.10779897534296],
            [-7.463929380872686, 1.101567693289697],
            [-7.463387691666629, 1.0983901855098623],
            [-7.457693997206222, 1.0963422328841543],
            [-7.457537931542639, 1.0942771828256868],
            [-7.449625923970198, 1.0898234688537545],
            [-7.43952591714761, 1.09418344171468],
            [-7.434793169365929, 1.0928200265112733],
            [-7.425291303266996, 1.0929462606033058],
            [-7.418707685173255, 1.0951763673986106],
            [-7.412167503702191, 1.0935303178550269],
            [-7.4070218377054875, 1.0888861064557789],
            [-7.406736697785527, 1.0843888846675378],
            [-7.39891457028657, 1.0819448521914972],
            [-7.3948856846327296, 1.082505366845371],
            [-7.3876311678619695, 1.0875304866668878],
            [-7.382124887802184, 1.0876390313584994],
            [-7.3781576015134, 1.090501519982605],
            [-7.373455153000552, 1.0870470265174408],
            [-7.367217630326879, 1.0914439725503686],
            [-7.362868926141947, 1.0925573328656621],
            [-7.357822587637594, 1.0993913067970977],
            [-7.352336604742677, 1.1001234429546782],
            [-7.350779468373642, 1.1054261115570012],
            [-7.33639468767027, 1.103880296468961],
            [-7.282853491521601, 1.0981882749312109],
            [-7.2821971353740125, 1.0979677918390711],
            [-7.285248023025, 1.090879172472395],
            [-7.290150021455428, 1.087220925075215],
            [-7.293501536315742, 1.0878134974038165],
            [-7.297266028974542, 1.0822573123584227],
            [-7.294284891734119, 1.078013341822814],
            [-7.294282009438723, 1.0691724026477705],
            [-7.292119035441163, 1.062059195835934],
            [-7.2898438677524915, 1.058189539297663],
            [-7.3022992118111505, 1.0400995597523917],
            [-7.314219234214476, 1.0432201396393486],
            [-7.318232247316444, 1.0396351968944955],
            [-7.320613343171493, 1.033595950109445],
            [-7.326655726720568, 1.031483219980035],
            [-7.326843659029031, 1.023136217515815],
            [-7.325462252122827, 1.020640553575961],
            [-7.3271594685413906, 1.0118568081127242],
            [-7.330336791382112, 1.0079173852584598],
            [-7.331965696700505, 1.0021028552437166],
            [-7.331157314963868, 0.9908576514395752],
            [-7.329204552220874, 0.9827665156018678],
            [-7.33049191767877, 0.9787506329697659],
            [-7.331046150293769, 0.9698315428046159],
            [-7.334728395706306, 0.9646772304989694],
            [-7.33328207275223, 0.9613886530814816],
            [-7.326069488239639, 0.9577677236867881],
            [-7.32319287605029, 0.9512810856705111],
            [-7.325440293562097, 0.9436787460125926],
            [-7.332004942218832, 0.9404632092271449],
            [-7.332816280482257, 0.9343025634844649],
            [-7.3380465201976435, 0.9311389361423428],
            [-7.335054188100296, 0.9213650735019157],
            [-7.335614258661831, 0.9148209782859829],
            [-7.341096815086759, 0.9083990514140986],
            [-7.339695797067969, 0.9019698785541436],
            [-7.336960622715587, 0.8957638343852999],
            [-7.338782355024704, 0.8862697989049824],
            [-7.336595918958333, 0.8771632171894812],
            [-7.336394742257292, 0.8654637239298508],
            [-7.337522283031158, 0.8577467789916592],
            [-7.341264276695022, 0.8558076326109475],
            [-7.344708726974692, 0.8516293664910938],
            [-7.347497948923841, 0.8508724080955572],
            [-7.350223461776185, 0.8432258130053117],
            [-7.352734934806028, 0.8429274983058425],
            [-7.359442839664753, 0.8382065467944257],
            [-7.362646508114152, 0.8371109277857096],
            [-7.3688592100043, 0.8274534534973835],
            [-7.36381091140521, 0.8257050620991607],
            [-7.357791170444244, 0.8268233389275345],
            [-7.344765251370043, 0.8242228302750743],
            [-7.34053375214758, 0.8164080298960387],
            [-7.339553315472801, 0.8069231525156338],
            [-7.344770710793871, 0.8035594061074224],
            [-7.348930739358928, 0.7982252170227878],
            [-7.35359410579017, 0.7964340786267441],
            [-7.35427307569199, 0.7931067021640785],
            [-7.358531252550646, 0.7898537736378848],
            [-7.358125449204257, 0.7857486459309578],
            [-7.35938154931112, 0.7778522858458077],
            [-7.421887857358776, 0.7849643088286405],
            [-7.655020532223205, 0.8121435147286554],
            [-7.6535643852389565, 0.8175281485969867],
            [-7.653065690956739, 0.8270098312745723],
            [-7.653958099746662, 0.831963068945902],
            [-7.651926302469623, 0.8336670552437111],
            [-7.656239645716893, 0.8377268078503187],
            [-7.658071399272421, 0.8427912404669603],
            [-7.657225332954668, 0.8491032895388574],
            [-7.651849174068049, 0.8567443846033059],
            [-7.648797768860542, 0.8582693874727509],
            [-7.64295103161078, 0.8576244927606568],
            [-7.63894691058072, 0.8592415878221509],
            [-7.638816301154463, 0.8673185963736738],
            [-7.632915505642235, 0.8729741888721643],
            [-7.633707720830041, 0.8814170990948131],
            [-7.636439299577709, 0.8857584765455773],
            [-7.632751249507221, 0.8908340259819747],
            [-7.630659249816755, 0.8967184642657395],
            [-7.63276945574822, 0.9051813385945721],
            [-7.631309102870024, 0.908807088142391],
            [-7.628079877209553, 0.9094961347534979],
            [-7.6233428659090885, 0.9137977452463223],
            [-7.6185531072478625, 0.9106302865799656],
            [-7.613703895698788, 0.9090969257550767],
            [-7.610870413955586, 0.913995124827588],
            [-7.604829304692069, 0.9112855828710834],
            [-7.600510773874256, 0.907056587893849],
            [-7.592122851086207, 0.9124240355450384],
            [-7.589892070143957, 0.9153747080962874],
            [-7.590061755035118, 0.9234903925916039],
            [-7.587099563110607, 0.9273887419290803],
            [-7.581106613795359, 0.9318355936400452],
            [-7.579213442061108, 0.9399193292454512],
            [-7.574949601034607, 0.9458572461494336],
            [-7.574560056070259, 0.9577628359195485],
            [-7.572460846396509, 0.9633871889825284],
            [-7.572848655324703, 0.966344974882731],
            [-7.5687058039391175, 0.9750161260608549],
            [-7.574759830285421, 0.983012743464597],
            [-7.572831610461698, 0.990716540452328],
            [-7.565898277035824, 0.9958486349584266],
            [-7.563053001077101, 1.000987097698305],
            [-7.560568002809511, 1.0020747915455175],
            [-7.559390244650662, 1.007615315879852],
            [-7.560187404689799, 1.0123376099643138],
            [-7.558786153989398, 1.019568617983667],
            [-7.563716013865109, 1.0205930113926618],
            [-7.565807668481979, 1.0253867281159479],
            [-7.569669810470042, 1.0275342644199876],
            [-7.573246044207835, 1.033451600395642],
            [-7.570742808643249, 1.0466870179414989],
            [-7.568235440960463, 1.0498780425143592],
            [-7.562331226586713, 1.0517755308374075],
            [-7.5557457722092805, 1.0597490900052677],
            [-7.548726232191994, 1.0611878830834593],
            [-7.546879671428898, 1.0545604290549575],
            [-7.543493791804742, 1.053060774303924],
            [-7.541417262877878, 1.056881056321408],
            [-7.5358533144607875, 1.058031130090028],
            [-7.532240109554581, 1.0568379445041818],
            [-7.530468245013238, 1.0601051396784156],
            [-7.527370994547423, 1.0608041382059237],
            [-7.523007713686989, 1.0588980250379412],
            [-7.520673778772092, 1.0607020519756067],
            [-7.514887997458326, 1.0594316703320505],
            [-7.510238354619162, 1.0656793952853256],
            [-7.510915814060503, 1.0769585089606204],
            [-7.513702621118823, 1.0804164961313025],
            [-7.513805399953481, 1.0903619546383716],
            [-7.511805845165418, 1.097147121570086],
            [-7.505631036074499, 1.1042826691942575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.34478780007623,
          "lat": 39.20248160349226
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08065"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00198149"
      },
      "bbox": [
        -7.658071399272421, 0.7778522858458077, -7.2821971353740125,
        1.1212715218918812
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.729963067797904, -9.503775912279744],
            [12.738181097376943, -9.497101456949547],
            [12.743485015138193, -9.495540194996721],
            [12.754991884775787, -9.490104726190046],
            [12.763327936075799, -9.488189582484797],
            [12.7682762398033, -9.488885037025499],
            [12.770513704523614, -9.487503795076504],
            [12.775491940810918, -9.489649201637695],
            [12.781583452035564, -9.490235289145836],
            [12.789764107903169, -9.50075363724368],
            [12.7922220874147, -9.502109771363592],
            [12.798171466839529, -9.500825385150591],
            [12.799859498479472, -9.496786567012185],
            [12.809808457708057, -9.496818063136956],
            [12.81592895986896, -9.495048815789714],
            [12.810945370890224, -9.45972577622305],
            [12.826094057900217, -9.457495465534661],
            [12.89822259519167, -9.446085427800826],
            [12.895773549022492, -9.430627144163486],
            [12.929582240626726, -9.425775706840847],
            [12.95400746647455, -9.422025574811435],
            [12.956438249315042, -9.437010335071951],
            [13.030273299497063, -9.425816925176228],
            [13.072783955291262, -9.418958277509619],
            [13.07600526989138, -9.437956379525064],
            [13.076674774909002, -9.444164535583958],
            [13.081816771223876, -9.476001471580178],
            [13.086027418057295, -9.50440750563161],
            [13.124099146888401, -9.498447051552898],
            [13.173097980412397, -9.491158373232958],
            [13.179994557943104, -9.500380641601778],
            [13.211067876587334, -9.543462268707728],
            [13.219745445190947, -9.600035639524396],
            [13.264296674856196, -9.593328607345102],
            [13.279156475525799, -9.590666446030939],
            [13.288408586916516, -9.64720186464108],
            [13.297805549623211, -9.645423539476326],
            [13.359205249410685, -9.636191733938794],
            [13.384088692862147, -9.63279055859232],
            [13.384025783287882, -9.637165505953018],
            [13.386460305170978, -9.647369253253679],
            [13.380596847198966, -9.650860505811334],
            [13.370344645477768, -9.65127551386983],
            [13.369769860773557, -9.657880717192205],
            [13.372227936194923, -9.663943120007636],
            [13.374083438267704, -9.671925734077249],
            [13.376841581887524, -9.674643174444885],
            [13.376125772782874, -9.680672685558454],
            [13.366997381380981, -9.690075076877173],
            [13.367279060213578, -9.694993161836118],
            [13.36514763090148, -9.697986853450981],
            [13.368309033617969, -9.703653308050562],
            [13.36697459851279, -9.707936424250704],
            [13.363590031055836, -9.707839415103757],
            [13.360032577044686, -9.703546458015072],
            [13.354101475249406, -9.702092730703912],
            [13.35113619408835, -9.69417035863008],
            [13.348073081325674, -9.69331898185682],
            [13.340597149917773, -9.694846513232378],
            [13.33553162391232, -9.69100713609995],
            [13.328703800374157, -9.687659735936093],
            [13.31958763937703, -9.687729854207701],
            [13.315062154359193, -9.684529642243557],
            [13.311071008273826, -9.675506359890448],
            [13.307777613605708, -9.67198583620894],
            [13.303161697918831, -9.670511392404007],
            [13.297187851743985, -9.673926193241927],
            [13.294191574992936, -9.673496180280928],
            [13.291456582005324, -9.676368221009122],
            [13.290455572547824, -9.68438674744714],
            [13.292560694312497, -9.689377420198003],
            [13.300420828333756, -9.696127722080666],
            [13.30289086450385, -9.697272712896062],
            [13.30969316165249, -9.694678286295218],
            [13.312990091595386, -9.697375884583002],
            [13.318308569446526, -9.704786661636517],
            [13.32136667708367, -9.705716346578239],
            [13.326225769694176, -9.71203656765875],
            [13.332364094302113, -9.723106594013876],
            [13.336746846625905, -9.726038071411786],
            [13.338184361019156, -9.723182389429995],
            [13.355993784654316, -9.716751098445224],
            [13.360973704273599, -9.71692777462537],
            [13.365595495070654, -9.722015881909096],
            [13.370754153020725, -9.730450260126451],
            [13.374026547455097, -9.740144273032938],
            [13.37925152007549, -9.739667442809786],
            [13.381551808283852, -9.743407950361256],
            [13.38479216770381, -9.743820615862553],
            [13.399605970337879, -9.750633138406291],
            [13.4017166317467, -9.753379517951288],
            [13.401938672118572, -9.760643198846473],
            [13.413322838117962, -9.762620467675802],
            [13.413197428442583, -9.772175736971608],
            [13.406486201202231, -9.771745274027616],
            [13.405388609327666, -9.774419245847204],
            [13.41102188691915, -9.779131411026835],
            [13.414379317326748, -9.77852856020585],
            [13.419145324744507, -9.780782819241375],
            [13.434293671374217, -9.784155615713741],
            [13.434477172831924, -9.780250455881877],
            [13.442233395644847, -9.786008966752323],
            [13.442652316531433, -9.792178261673662],
            [13.440662323729562, -9.797846837242467],
            [13.439780662489275, -9.806587720184158],
            [13.443408928732252, -9.812903451546303],
            [13.449806720371734, -9.82001747020635],
            [13.452144395389455, -9.825939601492504],
            [13.451304108658832, -9.828383157173565],
            [13.45462189743745, -9.8349640214199],
            [13.460653878513249, -9.840887223259362],
            [13.461774411501619, -9.844595789262035],
            [13.468673669627133, -9.845805089649353],
            [13.47594509409347, -9.844513144929042],
            [13.478738800298645, -9.849517604863612],
            [13.495553220531145, -9.85194135385246],
            [13.501086687101068, -9.849227434852708],
            [13.507845077829682, -9.848225422133194],
            [13.51261149229399, -9.849089627222414],
            [13.523789083466962, -9.85267616740774],
            [13.532485240733442, -9.858190161373269],
            [13.539088501855693, -9.863506174722225],
            [13.541058971566247, -9.86836362243202],
            [13.54574786968361, -9.869851870803474],
            [13.544759733263302, -9.873863280340379],
            [13.55496531952819, -9.885779834588753],
            [13.556529517624922, -9.892187977488703],
            [13.56080417733004, -9.897672147805656],
            [13.567567324148364, -9.902038025606963],
            [13.568140481171586, -9.90497222534516],
            [13.572053652903115, -9.908430118283361],
            [13.570715919940131, -9.911348172185594],
            [13.573769169888738, -9.913376977685992],
            [13.577056977217831, -9.912072517412502],
            [13.579822743740445, -9.914828835141092],
            [13.579746773386214, -9.919520633738438],
            [13.583546917945588, -9.92032521395517],
            [13.586030917010186, -9.923837858201512],
            [13.581785284443642, -9.926042547140687],
            [13.58243668115421, -9.932885264899724],
            [13.590413592013675, -9.938117390109626],
            [13.595784964738462, -9.940499949268293],
            [13.597268749328036, -9.946374138600678],
            [13.594153773687207, -9.950639637537579],
            [13.59502438146574, -9.956692911869203],
            [13.602369952302835, -9.957742477001519],
            [13.603764525256723, -9.96201960065476],
            [13.610387722367136, -9.961963370544842],
            [13.617644714836741, -9.968888718340624],
            [13.61810416485486, -9.972497507467173],
            [13.615674651842655, -9.976172312445332],
            [13.618520375454013, -9.983016094096094],
            [13.617616285102306, -9.986903653475844],
            [13.620913064913951, -9.99187143646796],
            [13.62545411856536, -10.008275722730238],
            [13.631939945643007, -10.012286138591964],
            [13.637424791107527, -10.014125091933717],
            [13.638467628498505, -10.01614860919834],
            [13.63905149716466, -10.027807718055453],
            [13.635727249143798, -10.031456981609075],
            [13.632512532263458, -10.02961892521392],
            [13.631185722338168, -10.033226808065711],
            [13.534490082433582, -10.046520292234877],
            [13.437791135675518, -10.05978709438966],
            [13.400925040643232, -10.065276356530772],
            [13.33585681392484, -10.075166965980834],
            [13.289777200306602, -10.082349114260596],
            [13.260161812258985, -10.086596526912224],
            [13.17362324487998, -10.099757611879932],
            [13.10381757758935, -10.110375228612128],
            [13.036432967957024, -10.120450628179745],
            [12.983319436724791, -10.128251479561172],
            [12.955925479881182, -10.132074426970854],
            [12.921088317978471, -10.137355338621207],
            [12.828325177307269, -10.150808218691537],
            [12.798279239761781, -9.948756584425087],
            [12.795682850267545, -9.9385980134356],
            [12.789890935339592, -9.897809723492804],
            [12.776963397919657, -9.818088365405274],
            [12.776862030883002, -9.814802129734908],
            [12.771947672454685, -9.783417745712013],
            [12.768319540301539, -9.761706035282536],
            [12.759458311189002, -9.705264814793603],
            [12.756042663619155, -9.680570581095163],
            [12.75015730969051, -9.641164579550912],
            [12.706763570922764, -9.647417250948449],
            [12.703032116569855, -9.622455570377827],
            [12.698825088494148, -9.59636509118133],
            [12.693737610901968, -9.562293148074577],
            [12.738066851153366, -9.556141285820635],
            [12.732892688937586, -9.521433724443208],
            [12.729963067797904, -9.503775912279744]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.69748238426727, "lat": 27.94886739053957 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12105"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00295747"
      },
      "bbox": [
        12.693737610901968, -10.150808218691537, 13.63905149716466,
        -9.418958277509619
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.362422205966515, -6.586311288561297],
            [11.479843425784365, -6.572882198256487],
            [11.516106375954703, -6.568520066639146],
            [11.518452343525135, -6.582569472238394],
            [11.590413288743628, -6.573162513609985],
            [11.61439404366968, -6.569017727905757],
            [11.618625757632783, -6.5700590220544015],
            [11.622315055516136, -6.573749708421254],
            [11.622002247758772, -6.579505719386801],
            [11.63030199162599, -6.5928025306784575],
            [11.63641078223962, -6.59425844143201],
            [11.636883898744067, -6.598329642316356],
            [11.642454373135067, -6.60423809168637],
            [11.690925842039375, -6.59757600908405],
            [11.7683583595626, -6.587258064384231],
            [11.801073750386006, -6.582640139606126],
            [11.813081961046334, -6.670769640700545],
            [11.811252341829409, -6.672416224997455],
            [11.805138485650048, -6.671861346599722],
            [11.80555760956171, -6.668814520108293],
            [11.799250039446294, -6.668992163280315],
            [11.794402433145306, -6.664205602244954],
            [11.790547859075245, -6.6632146062711035],
            [11.784719131645028, -6.663785031722329],
            [11.779718198610087, -6.662296003230095],
            [11.775873427708795, -6.666235763474891],
            [11.76807054654968, -6.666457575296113],
            [11.75393036089731, -6.675666995610856],
            [11.75640539982065, -6.701476217198234],
            [11.760057338477015, -6.730053891950844],
            [11.768654217749695, -6.728702995236649],
            [11.790387357303656, -6.765535430728274],
            [11.727417798279822, -6.775042564113852],
            [11.695305760728669, -6.77927936719903],
            [11.643017410630694, -6.78565753864621],
            [11.537381831232556, -6.8003455811684566],
            [11.473535845910003, -6.809374958964413],
            [11.47353223233694, -6.802675713015847],
            [11.471917033407571, -6.792545026771909],
            [11.469944451868578, -6.792696970063106],
            [11.467131337977392, -6.783134286422141],
            [11.469268751695745, -6.779686182195241],
            [11.469947079349847, -6.773031077369676],
            [11.466201800140013, -6.769978554900333],
            [11.463699575500376, -6.762028274109302],
            [11.468510009780024, -6.759599922502663],
            [11.465951896458181, -6.75406103382973],
            [11.465535563229468, -6.74982565627734],
            [11.47030377248888, -6.739019406337936],
            [11.46938680889618, -6.73289943194486],
            [11.466762914936627, -6.728848810673441],
            [11.470466116054123, -6.7236190429440645],
            [11.472400302562221, -6.71763518121657],
            [11.468722245258153, -6.712623501127895],
            [11.461833272600462, -6.711531000695944],
            [11.459123432342174, -6.708445348214262],
            [11.457243319579023, -6.699733358123947],
            [11.453978938712115, -6.698298501661527],
            [11.45419447073677, -6.6950909287287255],
            [11.446872426708545, -6.691748280516394],
            [11.445689341427343, -6.682499079980124],
            [11.443498846365092, -6.679480904178386],
            [11.444721994624727, -6.670940199778992],
            [11.440866749944563, -6.665024175417016],
            [11.436769428691326, -6.66232043752492],
            [11.43080023054397, -6.656414644874127],
            [11.428402704666443, -6.652484222578022],
            [11.42344504220346, -6.651706948864085],
            [11.416370742770521, -6.652902207672046],
            [11.41600575432032, -6.6487648875512555],
            [11.408718048394341, -6.648974228276674],
            [11.40213053373029, -6.643874766019071],
            [11.399652981093231, -6.63886158402562],
            [11.394441549504329, -6.6347320401798875],
            [11.392062859571759, -6.630340086702713],
            [11.392122027608915, -6.6256206815587255],
            [11.388435359716388, -6.623478736511335],
            [11.388339245336594, -6.617340236179402],
            [11.382155244733879, -6.611220225878297],
            [11.379672751097603, -6.6115926190846315],
            [11.374387346088094, -6.609006339698452],
            [11.368088674238669, -6.607382991784161],
            [11.363784495057425, -6.602733177208626],
            [11.366063292723549, -6.596857860565427],
            [11.365926347905742, -6.593761666502379],
            [11.362422205966515, -6.586311288561297]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.88005941535198, "lat": 31.29716405009271 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13003"],
        "coty_name": ["Atkinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Atkinson County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00345784"
      },
      "bbox": [
        11.362422205966515, -6.809374958964413, 11.813081961046334,
        -6.568520066639146
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.076705306227995, -3.9596163807120557],
            [10.073636259249112, -3.9326920190923285],
            [10.067493143654374, -3.883306477643546],
            [10.061715717287518, -3.835064917214951],
            [10.058939516071261, -3.8106009222899675],
            [10.175427944110115, -3.7966322997821593],
            [10.253759020999702, -3.7870680627835798],
            [10.303752005649645, -3.781035804606828],
            [10.308012748682907, -3.7836543012069397],
            [10.314034098051005, -3.7843544151574044],
            [10.313922649315817, -3.7899651159318744],
            [10.310149937932955, -3.791604865949865],
            [10.309344118242077, -3.7986186652451215],
            [10.317622961374079, -3.8078721154901514],
            [10.319538678744893, -3.8123040431187345],
            [10.316788950694955, -3.8163390958404495],
            [10.320199922127482, -3.819254666559359],
            [10.32446380738899, -3.8134522935016655],
            [10.329275751612323, -3.8145021330608024],
            [10.32566427169013, -3.818102873584665],
            [10.32961510312041, -3.822282481466421],
            [10.332595034516878, -3.8220691199442047],
            [10.335418633572925, -3.8252566141886177],
            [10.334937307182091, -3.8324337697377104],
            [10.323069213590717, -3.838642887069069],
            [10.316399109349268, -3.843935645897302],
            [10.314630716847436, -3.847071911799086],
            [10.318184577832008, -3.8517392812158113],
            [10.316762776664937, -3.8604128558108193],
            [10.320417188183907, -3.8662512562837263],
            [10.32165071939426, -3.874230103503172],
            [10.31343320390594, -3.8825557141352367],
            [10.305688721640731, -3.887626190215759],
            [10.307199580722441, -3.8933963732852206],
            [10.312187984860083, -3.8952462133387002],
            [10.310955090693028, -3.8996892703998722],
            [10.30670597241625, -3.9021464475919783],
            [10.302161733736023, -3.9029714594191813],
            [10.30071796009626, -3.9059084567048425],
            [10.298156324470213, -3.9174541967398198],
            [10.29470475691065, -3.9229623479429296],
            [10.29014630847136, -3.9249395957597715],
            [10.283791664883832, -3.9237569077986647],
            [10.28197893608648, -3.9267683720728166],
            [10.275841952440217, -3.929347841933088],
            [10.267149082989246, -3.9266505263415548],
            [10.261466820408616, -3.9269863796260966],
            [10.253020612373836, -3.92976845855676],
            [10.245877995789147, -3.934269090169801],
            [10.243767662926746, -3.938934289905033],
            [10.240084515801929, -3.943550282656366],
            [10.24052854489811, -3.9496981313238284],
            [10.239214572622368, -3.9569226207600274],
            [10.229377930322956, -3.96347588916389],
            [10.229266954290145, -3.9682604530645667],
            [10.222780492574588, -3.97897591017474],
            [10.22372492908129, -3.9845911468897754],
            [10.22005093397284, -3.992927730930169],
            [10.217217229768734, -3.9964895342636497],
            [10.218967039138683, -4.000329606277838],
            [10.218611155111866, -4.004003559625054],
            [10.216190437590965, -4.006033049818878],
            [10.216422411506992, -4.009511519578802],
            [10.213748526633701, -4.012542263784728],
            [10.21515007886686, -4.023008377169743],
            [10.208925790124471, -4.033237769342061],
            [10.209903013719492, -4.037612297167303],
            [10.207628053777844, -4.045337659411043],
            [10.20908721990375, -4.05412830403056],
            [10.206575994616996, -4.0642472587684795],
            [10.212047309349735, -4.067128042206476],
            [10.215874636128232, -4.073409781012652],
            [10.225123132920208, -4.078079817676386],
            [10.21072834475524, -4.079543628464705],
            [10.204440639647702, -4.0788122787510614],
            [10.196657409664894, -4.075598531087926],
            [10.187070664938137, -4.078122197138455],
            [10.173444680332233, -4.072434953790559],
            [10.170113590559934, -4.069085875252603],
            [10.158063865790762, -4.067295624236086],
            [10.150948332851142, -4.058746293924936],
            [10.149434735612315, -4.055286309862284],
            [10.144795696784765, -4.051895627228018],
            [10.13687228508826, -4.049318798153089],
            [10.131913605420893, -4.049318026818237],
            [10.124391774812393, -4.0416030306790764],
            [10.117091352413718, -4.04171727444823],
            [10.11205977868463, -4.045698078497084],
            [10.106462974531295, -4.041598700896251],
            [10.101619278348316, -4.042060918101083],
            [10.094761449679035, -4.039928273884775],
            [10.09085830485307, -4.040547737489695],
            [10.089806698150973, -4.0374620559032035],
            [10.086250890831778, -4.035822029533686],
            [10.076705306227995, -3.9596163807120557]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.1249587997478, "lat": 34.225548859509615 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13117"],
        "coty_name": ["Forsyth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Forsyth County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01673358"
      },
      "bbox": [
        10.058939516071261, -4.079543628464705, 10.335418633572925,
        -3.781035804606828
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.740979463998015, -3.5953300619010493],
            [10.759569253763749, -3.5838905803503485],
            [10.763531176006127, -3.5829895391748745],
            [10.803706438967053, -3.5761048811159033],
            [10.859908133829952, -3.565839475517241],
            [10.891740691672657, -3.5597902449624836],
            [10.91731430657266, -3.5553878666928544],
            [10.92947215060531, -3.539103894763463],
            [10.958031241182084, -3.5022841046126385],
            [10.969612697069419, -3.4877173912592467],
            [10.97049714956869, -3.491744802710095],
            [10.975493442202582, -3.492130108771636],
            [10.97877627622149, -3.4902402713474645],
            [10.985287716788688, -3.4913597539773606],
            [10.991738707743135, -3.496777965065939],
            [10.985461757561833, -3.504710460160765],
            [10.98544998080298, -3.5066000379909896],
            [10.99160248627226, -3.5072684435349246],
            [10.994319001037544, -3.5122090517696516],
            [11.001702110574525, -3.5184040868329056],
            [11.004811478984086, -3.519086159263982],
            [11.010887499933096, -3.515543821590486],
            [11.015054820186675, -3.5173980374799503],
            [11.01530730416428, -3.521489882383786],
            [11.01742583470116, -3.5245944029412866],
            [11.010470962807105, -3.5479556625347946],
            [10.993487128682178, -3.6069148682044494],
            [10.992703602287635, -3.679516298472419],
            [11.002407591292004, -3.6758040969554426],
            [11.00258380152344, -3.74492149792758],
            [10.997284697600884, -3.751105992686625],
            [10.953786517344069, -3.792544359448099],
            [10.947197801314298, -3.7919277134624507],
            [10.934370929926818, -3.7864328424755342],
            [10.928006799277062, -3.786072498428155],
            [10.923578026278012, -3.7910377300702054],
            [10.9190592070172, -3.7916633218485507],
            [10.917126600789306, -3.7893812059258156],
            [10.910809508675401, -3.792761716425433],
            [10.908689755439537, -3.7912403951365143],
            [10.89887388483594, -3.792145937220436],
            [10.90101751603579, -3.7957587431428355],
            [10.890214303526635, -3.7945688469582417],
            [10.88576193030432, -3.7925452001291573],
            [10.870835342211357, -3.793206496236208],
            [10.86692403268672, -3.7879624779794705],
            [10.859335938210023, -3.790276525587758],
            [10.85584385390382, -3.784323276701439],
            [10.848807179863652, -3.7802630315451644],
            [10.840872439813698, -3.78715650744766],
            [10.83652631209688, -3.787417293932865],
            [10.83690008729657, -3.7920702040013854],
            [10.832263110041854, -3.7949134170324523],
            [10.82902982929455, -3.798942214086273],
            [10.825907969773194, -3.799234248309865],
            [10.821853450268101, -3.8088696673587266],
            [10.819236231818657, -3.8118555928980236],
            [10.81462839722042, -3.813516606204564],
            [10.81349850963557, -3.818694789550021],
            [10.80970209375407, -3.8266355701179053],
            [10.807383856110137, -3.827236339330481],
            [10.809652030934204, -3.815719627913385],
            [10.815067988032634, -3.8095537450488073],
            [10.813565716686693, -3.804306187248283],
            [10.815655717471346, -3.8003285817404784],
            [10.81498920178464, -3.797540247693264],
            [10.816548181804412, -3.7897961781615828],
            [10.814677937433741, -3.7850988691918297],
            [10.790809694784572, -3.7609969152904865],
            [10.785944594016717, -3.755343900122562],
            [10.762486478064218, -3.7306849493348793],
            [10.761528575874765, -3.6842395810516475],
            [10.760715668151168, -3.6754327302618344],
            [10.761166797610938, -3.6663324769897963],
            [10.763214046312582, -3.6502662868432836],
            [10.762560931603147, -3.64351701317479],
            [10.75780307947701, -3.625522315693582],
            [10.753265353382176, -3.6196171325739064],
            [10.749374879506629, -3.6103938702379845],
            [10.741242828236958, -3.5966956771260237],
            [10.740979463998015, -3.5953300619010493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.22908023805091, "lat": 34.37539720407294 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13119"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00349324"
      },
      "bbox": [
        10.740979463998015, -3.827236339330481, 11.01742583470116,
        -3.4877173912592467
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.703071407472873, -3.3266433542855274],
            [9.703949095325823, -3.3264588282933563],
            [9.799008431541294, -3.3153748646458765],
            [9.800405038784717, -3.315379755028067],
            [9.856612928088012, -3.308429398526282],
            [9.863852271994679, -3.308071176036568],
            [9.866299443986494, -3.312521792547464],
            [9.871137543365618, -3.313603633797167],
            [9.882520474178676, -3.318401473071846],
            [9.889647653085623, -3.3253554546270876],
            [9.892599793731344, -3.3203543013653647],
            [9.896813150237163, -3.3253857806380687],
            [9.901126892057407, -3.3246933077728538],
            [9.906228928187248, -3.328283526071366],
            [9.90962973487894, -3.326956143718982],
            [9.920406639561598, -3.3310391770753927],
            [9.928965544547122, -3.330227870148341],
            [9.928969382416643, -3.334318121384632],
            [9.932636184596303, -3.33384149119122],
            [9.93719421887011, -3.3366143552143885],
            [9.94031570068621, -3.3366954584989985],
            [9.938353435508066, -3.3429814385346526],
            [9.943836340385769, -3.3470377565119374],
            [9.949817247617515, -3.3474345742938043],
            [9.954560436818463, -3.3447773595897763],
            [9.993891195957461, -3.3979786843134887],
            [10.011072657635864, -3.4208660541449416],
            [10.00815151991472, -3.4211936231641458],
            [10.009074885602708, -3.428525694853616],
            [10.016138594449163, -3.4276013296404813],
            [10.022694376579345, -3.4810989289302454],
            [10.026803952230145, -3.475562090910401],
            [10.029737421907539, -3.4738380945133356],
            [10.035774904297028, -3.4782435186304435],
            [10.037895205864476, -3.477500487292032],
            [10.041908507576272, -3.4858990972656287],
            [10.044934091379261, -3.4892217177525287],
            [10.049243976602082, -3.4898147063782328],
            [10.053651326374139, -3.493215700325065],
            [10.066080595486069, -3.4987545966856537],
            [10.069972805242484, -3.4986764427119197],
            [10.073193612565383, -3.500961617332338],
            [10.07148652710206, -3.5058090317592416],
            [10.073600257543932, -3.508551575727336],
            [10.075226053633939, -3.5145392735886745],
            [10.073543082547365, -3.5170439787103858],
            [10.073483445683713, -3.522131141587927],
            [10.071503110711575, -3.525167667124266],
            [10.064985767652734, -3.527506432045805],
            [10.060250326121892, -3.532094235036077],
            [10.057800502029021, -3.5417952298239115],
            [10.054098002249376, -3.5457702221958654],
            [10.029104382708558, -3.5483618023470065],
            [10.03220271387079, -3.5775630146072457],
            [10.023811096091162, -3.576287009674974],
            [10.01854578403466, -3.5766408767948983],
            [10.01477127596838, -3.5742609671557712],
            [10.012954294287786, -3.5786356844554854],
            [10.00574902378193, -3.5803814179302527],
            [9.999728949781055, -3.5793814848762113],
            [9.997278038630197, -3.5748612126183033],
            [9.988478242300566, -3.5696585425539693],
            [9.985554995178282, -3.5739338021500746],
            [9.980984365635154, -3.5730740559259058],
            [9.97797295708157, -3.5702506467389536],
            [9.972706261923232, -3.569388041485671],
            [9.965122449809403, -3.5766990729791956],
            [9.96993405550238, -3.5809872334737847],
            [9.965865578299134, -3.582153222009735],
            [9.961922557705298, -3.5870870733446227],
            [9.958538574147228, -3.588967267173252],
            [9.959754490012028, -3.5921693095820197],
            [9.938700119458789, -3.5945766100808396],
            [9.940590737309233, -3.6089596284988743],
            [9.933246412238411, -3.609452052119623],
            [9.89734432861851, -3.613406143920213],
            [9.896483493603773, -3.6053199430881193],
            [9.892974633955202, -3.605665370853351],
            [9.893208237943812, -3.6095110339307217],
            [9.890948097622541, -3.614076709534603],
            [9.862146769351595, -3.6170538659487383],
            [9.860394714305388, -3.6035621658954353],
            [9.845981409070001, -3.6055387838004966],
            [9.846891991797126, -3.6120792814424174],
            [9.854301416936607, -3.6112333915407664],
            [9.85493864247733, -3.6177675051830502],
            [9.833741553681476, -3.6199893359325883],
            [9.832298876157143, -3.6067803872801973],
            [9.825078294847605, -3.6076915373301435],
            [9.825775745717856, -3.6145984394947757],
            [9.818741507593332, -3.6155248243393707],
            [9.81867614216341, -3.6218287323627067],
            [9.776198610166457, -3.626686102832667],
            [9.776248138691997, -3.6279722667189995],
            [9.747018296860618, -3.6314085305923434],
            [9.711002653262089, -3.636331159155209],
            [9.70676433290119, -3.6021400258218486],
            [9.702785155632535, -3.568584337032266],
            [9.702146998671381, -3.560353282080752],
            [9.696658413832633, -3.519836929421763],
            [9.68718407685012, -3.4567921945907254],
            [9.689392303900393, -3.453813167502986],
            [9.690916112764269, -3.4471287770240187],
            [9.691734011280968, -3.4387334688453417],
            [9.695362050326922, -3.430977496050095],
            [9.69835924434928, -3.430452993011533],
            [9.699248211958425, -3.423621051393663],
            [9.698069925749964, -3.4187390366322847],
            [9.699763016037462, -3.41570752912667],
            [9.694059150486755, -3.4064956909686854],
            [9.704100690119562, -3.3982898160480515],
            [9.707792162983834, -3.39672943635126],
            [9.708348288713205, -3.393202379782536],
            [9.718023496629543, -3.390205880854659],
            [9.71906140985994, -3.3847277914635088],
            [9.722741474621603, -3.380979924678168],
            [9.722906205221243, -3.3738921256229424],
            [9.727322096887852, -3.373995484533348],
            [9.728829871421082, -3.3714180784546053],
            [9.728202445833618, -3.366869035599038],
            [9.732791957481261, -3.3639873588621847],
            [9.73389376259667, -3.358346795364687],
            [9.736235580374277, -3.3538900973589367],
            [9.729216581934438, -3.3488068904857524],
            [9.728218615142056, -3.343526571199079],
            [9.72393133438071, -3.340666143651529],
            [9.719332060226924, -3.3421585638206732],
            [9.715703663052622, -3.340440294933032],
            [9.70857822115569, -3.3301420913897766],
            [9.703071407472873, -3.3266433542855274]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.45563507441501, "lat": 34.69113783221575 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13123"],
        "coty_name": ["Gilmer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gilmer County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00351260"
      },
      "bbox": [
        9.68718407685012, -3.636331159155209, 10.075226053633939,
        -3.308071176036568
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.080552586494141, -4.671052634927594],
            [11.11247618315119, -4.632871477463389],
            [11.178118439367168, -4.554141311949105],
            [11.189309906874481, -4.540609013070897],
            [11.191149196130478, -4.5405392610114985],
            [11.203804972700521, -4.549651886514445],
            [11.208658907523294, -4.554171252021264],
            [11.21609125799458, -4.558761708609284],
            [11.222472321307746, -4.554959648983901],
            [11.234060277511563, -4.553739723757797],
            [11.23739748159412, -4.550518241053371],
            [11.24228571251978, -4.5509516469588585],
            [11.253030173796633, -4.558684881510433],
            [11.284653169325503, -4.558277236487576],
            [11.289198578057777, -4.5562127931835],
            [11.29391023280854, -4.556220640751542],
            [11.300176530177419, -4.549172780485784],
            [11.301774980371178, -4.550574851055864],
            [11.307563826154114, -4.5473762947924365],
            [11.31204258108774, -4.549704531108063],
            [11.318547752555935, -4.551142447172295],
            [11.324905953594776, -4.547882834555825],
            [11.329003242780756, -4.551176207075792],
            [11.330669055953653, -4.5549418068673395],
            [11.335105759511869, -4.5585637203085145],
            [11.338141271389143, -4.556087854600127],
            [11.340792233994376, -4.557696654921444],
            [11.349551499591145, -4.560236643700796],
            [11.350632770494258, -4.5677527008064205],
            [11.350304184558773, -4.575745375443783],
            [11.353120340403809, -4.5775172772951445],
            [11.354256136792628, -4.581128017610378],
            [11.352806999729234, -4.584219672278841],
            [11.354595000358023, -4.588548295628146],
            [11.353755731041899, -4.5976978385707445],
            [11.357216116765109, -4.597606695790043],
            [11.360736183082997, -4.600022167359927],
            [11.360908862595375, -4.608191752850069],
            [11.362999420526073, -4.613778975282102],
            [11.368491436802968, -4.622689395864343],
            [11.376094995357047, -4.62032146926479],
            [11.379071950064263, -4.623320487383381],
            [11.378906104763944, -4.626175701821661],
            [11.381954836231497, -4.629738111431546],
            [11.37974756861134, -4.6340399274176045],
            [11.382036510066841, -4.637457866933713],
            [11.38456911607954, -4.651213117238493],
            [11.383648020850128, -4.653697155353942],
            [11.38657216143927, -4.659685980893016],
            [11.393129989866553, -4.661579403824952],
            [11.392304720034295, -4.664172718805165],
            [11.388176350939903, -4.66559518717838],
            [11.39143444136812, -4.674145042698138],
            [11.395934078545995, -4.672915903420974],
            [11.399851477962425, -4.673766691055103],
            [11.402081675679275, -4.678067469622885],
            [11.402678130581577, -4.683842270905834],
            [11.404845915568663, -4.692638724923727],
            [11.403883382836304, -4.694937016645999],
            [11.40575745695911, -4.701528165993389],
            [11.403190539111936, -4.705724805263152],
            [11.4062131864778, -4.712319683250379],
            [11.412761457438148, -4.717011204736096],
            [11.414891908656859, -4.7214042529919205],
            [11.42203334618502, -4.721315747016313],
            [11.424114276331071, -4.726169333221603],
            [11.43036889923047, -4.72581298003545],
            [11.4376842876548, -4.733298763314357],
            [11.438679050339717, -4.739939891281939],
            [11.425744404206107, -4.74204158771712],
            [11.42308728639965, -4.743598927161257],
            [11.414242817423611, -4.743272571229844],
            [11.402530014650312, -4.756503199773526],
            [11.399399141583118, -4.762279503966103],
            [11.392822640072485, -4.7643247789166026],
            [11.388597087231497, -4.768249349392194],
            [11.383783668353823, -4.7707117946931215],
            [11.378683752337267, -4.776512499575087],
            [11.376987172221723, -4.782720871314418],
            [11.374564873725081, -4.785784945064691],
            [11.361856077972947, -4.790016858127158],
            [11.35666627201846, -4.7938237483383315],
            [11.354920825218159, -4.8013634821827145],
            [11.351808672139532, -4.8037231558296565],
            [11.348603199983737, -4.810853150709637],
            [11.34873183458975, -4.813176607256862],
            [11.342532661093054, -4.838637762285992],
            [11.34002155193781, -4.840557868370986],
            [11.33631155615138, -4.853529505954281],
            [11.336822149463542, -4.855126488952376],
            [11.32749866192175, -4.866750039237169],
            [11.317068043445378, -4.870009088581056],
            [11.308748327884114, -4.8816153229018715],
            [11.297743589550302, -4.886291920345561],
            [11.290225413681995, -4.892962002613661],
            [11.283136082844498, -4.894562223181124],
            [11.273678999801648, -4.893753052486219],
            [11.266171337099587, -4.900351120025561],
            [11.263138941281413, -4.904917771399599],
            [11.259286942626478, -4.91431665203178],
            [11.250678121678435, -4.922432009797556],
            [11.245218316707929, -4.926449638025061],
            [11.23519301541506, -4.928249841328844],
            [11.225201142214848, -4.928116081520369],
            [11.21013290269368, -4.931173394158094],
            [11.20467120808267, -4.936725396179076],
            [11.19620348133352, -4.948884403427776],
            [11.186580764624855, -4.951368846906459],
            [11.17996290880462, -4.961393905879397],
            [11.174207044733084, -4.967258083674382],
            [11.168793261016534, -4.960715724752257],
            [11.170314418715796, -4.958107537472336],
            [11.164668942997142, -4.94664080697861],
            [11.155651219273961, -4.939035011850949],
            [11.154325944288837, -4.932391281496468],
            [11.157831311842742, -4.922040759141839],
            [11.15587365092175, -4.916541279714822],
            [11.155833023006767, -4.904920262687446],
            [11.158873486793603, -4.89942620563727],
            [11.155588444894784, -4.891531068818424],
            [11.157658215449747, -4.887642419344319],
            [11.161301227089718, -4.887515340394943],
            [11.164520733216568, -4.8844700052006065],
            [11.166108063898438, -4.872682795329323],
            [11.16299001511279, -4.865886161417406],
            [11.147627735241182, -4.862714085551091],
            [11.126340197156381, -4.859636636169028],
            [11.079092509783544, -4.852159247304949],
            [11.043748153014576, -4.849713762923265],
            [11.021860611493492, -4.84692280337255],
            [11.016252988835522, -4.849854844096184],
            [11.012746082258817, -4.850058440848393],
            [11.011281485244904, -4.8461249126436226],
            [11.011133618411336, -4.836082951272528],
            [11.019445003506707, -4.82781140835793],
            [11.020766539394737, -4.81756526692731],
            [11.0199247006204, -4.81446788298382],
            [11.021477526591934, -4.80560117418892],
            [11.024104426626588, -4.8009249873632625],
            [11.023795973280288, -4.797142378015747],
            [11.020285790164317, -4.790430645102227],
            [11.019106600575762, -4.781088359653711],
            [11.020060652200751, -4.776148856055242],
            [11.027132261819252, -4.772274262796885],
            [11.031487258382022, -4.771252882413444],
            [11.040218811459814, -4.77646972133053],
            [11.042970084404029, -4.766290764042001],
            [11.041432800104094, -4.762132755177957],
            [11.037087293907222, -4.756887145138483],
            [11.043907847861245, -4.754341196293338],
            [11.048345353046233, -4.749911044054857],
            [11.051499587103772, -4.749035070658361],
            [11.054001596139646, -4.751796422026108],
            [11.058110409838177, -4.7509634882869864],
            [11.05946540299038, -4.746400907003993],
            [11.067699605297578, -4.740093935490451],
            [11.077376457042991, -4.735258255336151],
            [11.079112941393149, -4.728709495825685],
            [11.082638132755102, -4.725047119673541],
            [11.097814178042498, -4.716194293293489],
            [11.1015882080367, -4.712320847863565],
            [11.096342290329606, -4.702758425779828],
            [11.097758180457246, -4.694759215608557],
            [11.100304960896915, -4.688918240530653],
            [11.099123612093514, -4.68389167381816],
            [11.094775584309646, -4.681713729362287],
            [11.090929131850606, -4.676649335806279],
            [11.084445692680045, -4.674661046768781],
            [11.080552586494141, -4.671052634927594]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.00073785883002, "lat": 33.2704356273631 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13141"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00348209"
      },
      "bbox": [
        11.011133618411336, -4.967258083674382, 11.438679050339717,
        -4.5405392610114985
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.563670169470393, -6.160075012664233],
            [11.568591541774397, -6.157188492343681],
            [11.571803735284476, -6.161424955272416],
            [11.581010151613956, -6.155368787181181],
            [11.587116345406011, -6.148440062502074],
            [11.584611103223724, -6.1454591294000736],
            [11.589386324221053, -6.1436875001539395],
            [11.59501313499292, -6.136622597262905],
            [11.598171945476178, -6.137381478593113],
            [11.603818137476761, -6.131924599656449],
            [11.602027426395598, -6.128247514701737],
            [11.598540903301378, -6.127451677272095],
            [11.596662761919573, -6.124279796964779],
            [11.59735486537202, -6.117607692943992],
            [11.604336783807216, -6.117454199475762],
            [11.604798389993075, -6.113722691462357],
            [11.608372061984978, -6.110502914009397],
            [11.614079473776654, -6.113473168046598],
            [11.613203482977596, -6.1076987576401045],
            [11.619334600211388, -6.107696683257291],
            [11.619955365931544, -6.110331476662835],
            [11.624206864216223, -6.110565826959302],
            [11.626969504085215, -6.106237697049558],
            [11.625642976398431, -6.102529251935047],
            [11.627717933451667, -6.097656320703823],
            [11.634443459963967, -6.088983806131547],
            [11.638809935588476, -6.087264424688994],
            [11.642840372343901, -6.081960140683356],
            [11.646552182551893, -6.0822484115671465],
            [11.650358479188995, -6.076571371282084],
            [11.65345556717626, -6.077347784423798],
            [11.654834977898894, -6.073825703668082],
            [11.65797355805302, -6.073689198537473],
            [11.661193115428826, -6.0686987536434955],
            [11.661301644938698, -6.063437438183321],
            [11.664481951231217, -6.062386786405986],
            [11.665775991039467, -6.057665503290778],
            [11.668510055979942, -6.058291402900393],
            [11.671455777506088, -6.062216942301435],
            [11.674925896075104, -6.0584011738217844],
            [11.67507685193431, -6.055252343295265],
            [11.67811355487166, -6.050790780617923],
            [11.68327311079218, -6.049259864180893],
            [11.684176020588604, -6.0453999660273094],
            [11.677852661244573, -6.039325067098772],
            [11.68480907449886, -6.038473161251131],
            [11.688364615136951, -6.036437329351515],
            [11.69578336180033, -6.0370088531102155],
            [11.704092403717773, -6.034832034692629],
            [11.704473605241276, -6.038713716021399],
            [11.708974554266955, -6.036163583258793],
            [11.71964411758878, -6.0277993051355905],
            [11.723091948068141, -6.029836516103946],
            [11.726281267124048, -6.02897957230858],
            [11.73027969728012, -6.025190989638667],
            [11.733890312862885, -6.024782924105682],
            [11.738898444018428, -6.018021722237399],
            [11.741693799577451, -6.012642982224516],
            [11.745973090468567, -6.013187471779858],
            [11.748281124762466, -6.017402995752782],
            [11.750600829923004, -6.012735900394517],
            [11.755506867680145, -6.012667600318125],
            [11.757017250512932, -6.007492832778463],
            [11.75990161498797, -6.006173828616428],
            [11.761534667141122, -6.00029112218176],
            [11.766190088862674, -5.99347609645055],
            [11.771072284774064, -5.98884795909202],
            [11.777054044935422, -5.989515141768543],
            [11.782581689360216, -5.98701632468848],
            [11.788381176965135, -5.987606551849107],
            [11.788620818137398, -5.984517235906189],
            [11.793297884699326, -5.985637654499577],
            [11.797101143605778, -5.980854734636202],
            [11.801419792414253, -5.982698805968284],
            [11.810980859901541, -5.982353741549569],
            [11.82327305355887, -5.988485318928046],
            [11.831185987789796, -5.988879012465145],
            [11.839513570412716, -5.98478449383939],
            [11.842207819272447, -5.980892927691658],
            [11.839575421127849, -5.977978986325239],
            [11.835019352805942, -5.979425153779934],
            [11.825300100397952, -5.977640429834476],
            [11.827896558205351, -5.9710749649981345],
            [11.830124541981677, -5.9690599818095],
            [11.83778398843001, -5.967390139240761],
            [11.840345824769397, -5.964307640504611],
            [11.859900038430037, -5.969457860426375],
            [11.86438362734251, -5.968010370417249],
            [11.870321469075689, -5.964234831433643],
            [11.874540947351681, -5.9633292072251916],
            [11.881306315505109, -5.963985725094732],
            [11.886130947915804, -5.990997869841256],
            [11.898786045430391, -6.084437443171534],
            [11.899770874427622, -6.090736091176045],
            [11.825301303273038, -6.10094591249302],
            [11.838043962809776, -6.1891225332086295],
            [11.81246362992459, -6.192828269274762],
            [11.814254399343271, -6.205462475288826],
            [11.839545198072946, -6.202010755388167],
            [11.842436525684958, -6.227223275630729],
            [11.847893500454257, -6.265056747276192],
            [11.758979129669921, -6.277463802770002],
            [11.684743092789889, -6.28850109423802],
            [11.602487876951228, -6.300602505576421],
            [11.5835185843442, -6.303254120323341],
            [11.563670169470393, -6.160075012664233]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.63671859400795,
          "lat": 31.805557239247232
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13161"],
        "coty_name": ["Jeff Davis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jeff Davis County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01687999"
      },
      "bbox": [
        11.563670169470393, -6.303254120323341, 11.899770874427622,
        -5.9633292072251916
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.191116856410485, -5.145442317203235],
              [10.19055795696048, -5.140997896509153],
              [10.18718895069992, -5.141402932175739],
              [10.187740843278215, -5.1458330651294615],
              [10.191116856410485, -5.145442317203235]
            ]
          ],
          [
            [
              [10.00485014833894, -4.982162384907224],
              [10.007584443858848, -4.979374318666555],
              [10.017068612598115, -4.976040182789109],
              [10.019259918326966, -4.972843693737451],
              [10.020408742827259, -4.963330442289648],
              [10.036811373575086, -4.959320999716444],
              [10.039306893733567, -4.952700185193686],
              [10.087121655119796, -4.9474525202286594],
              [10.087973013662593, -4.955471735687948],
              [10.104867207063746, -4.953314345068845],
              [10.105736888720697, -4.964054091403477],
              [10.178967262632396, -4.955584821317348],
              [10.209364344121997, -4.951904931298364],
              [10.215520598790318, -4.9984243825190235],
              [10.216443559849754, -5.007650106710372],
              [10.22292352248282, -5.061834037008937],
              [10.224647743312255, -5.074483392433115],
              [10.227553443053097, -5.100886259565175],
              [10.219083196779868, -5.101579733551476],
              [10.219927624235218, -5.1097205116523075],
              [10.21157682979285, -5.110833616918196],
              [10.215782255583164, -5.151144618745685],
              [10.200058481066657, -5.152767503431844],
              [10.195883325408136, -5.145076919630128],
              [10.191116856410485, -5.145442317203235],
              [10.192082357707203, -5.153605469520037],
              [10.174881007983652, -5.1554003130562105],
              [10.10685777972037, -5.162960178619273],
              [10.03380793861994, -5.1706692266170355],
              [10.03382064048358, -5.173727797211527],
              [10.030328228951788, -5.176468008971009],
              [10.030355515091793, -5.1798124725562324],
              [10.023312046421756, -5.193016196808652],
              [10.008287740436867, -5.199067000709641],
              [10.005745506272438, -5.19746723268553],
              [10.009573370260188, -5.1941720691486335],
              [10.009548694958577, -5.191364587065022],
              [10.00596957598868, -5.186759621384795],
              [10.001086218338404, -5.182514914153055],
              [10.00210171338973, -5.1786842457926],
              [9.999447044219767, -5.174900060873726],
              [10.002198446470814, -5.1680489918898065],
              [9.996745361919626, -5.163955532895766],
              [9.991740131481484, -5.157950016731723],
              [9.99402183501398, -5.148477048099115],
              [9.992680706626967, -5.143450476136289],
              [9.993649561914104, -5.140716501151394],
              [9.98957191531349, -5.133420301689248],
              [9.990322823583359, -5.127014129340232],
              [9.996345959191158, -5.124288522596133],
              [9.998274442851466, -5.106709301256887],
              [9.997083006465745, -5.1030989926450205],
              [9.993515715549831, -5.09847209754334],
              [9.994213436678494, -5.089904514104239],
              [9.997285836883337, -5.086768292443296],
              [10.004283778628364, -5.08877780266614],
              [10.004595167607905, -5.081021945743386],
              [9.997612839336883, -5.077532182418018],
              [9.99442701826406, -5.073545662563266],
              [9.990390546347678, -5.076762074027344],
              [9.988987686438357, -5.070440233367245],
              [9.9967924658379, -5.066479414502226],
              [9.996436523829313, -5.057319260058626],
              [9.994340163058016, -5.053902716759308],
              [9.994689780895774, -5.045394177914921],
              [10.000157183578313, -5.040895983759577],
              [9.994658532140276, -5.027795139492183],
              [9.993890466677183, -5.019837241451921],
              [9.995977682802195, -5.01769194463101],
              [9.997953071286874, -5.009835132443668],
              [9.996525058955521, -5.005194994937208],
              [9.99946766564352, -4.998789417475437],
              [9.997023783780925, -4.992400405357706],
              [10.00485014833894, -4.982162384907224]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.3892809484261, "lat": 33.09229246728705 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13231"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "231",
        "coty_gnis_code": "00346482"
      },
      "bbox": [
        9.988987686438357, -5.199067000709641, 10.227553443053097,
        -4.9474525202286594
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.623689416293118, -5.448569142568778],
            [11.629517936966142, -5.45070265172949],
            [11.636903071803182, -5.451879345384948],
            [11.643232797007867, -5.451600695775084],
            [11.648901583664722, -5.452640204151801],
            [11.664677406582355, -5.449844583506227],
            [11.675770924391962, -5.447105480900359],
            [11.695235202422094, -5.4456251109161276],
            [11.70019600438527, -5.448635047891038],
            [11.708482834045103, -5.450333732650921],
            [11.715654240635809, -5.4496589649392115],
            [11.719858783638005, -5.450491882141064],
            [11.733659613841809, -5.4460698209902905],
            [11.744825506680396, -5.4461955959816075],
            [11.748374545030039, -5.445204039984061],
            [11.756530242641746, -5.447072292966023],
            [11.758142526221805, -5.4502009385534755],
            [11.763524532687265, -5.4493743074476795],
            [11.771413237157267, -5.452034591291482],
            [11.776088942029126, -5.45749471312385],
            [11.783552755908671, -5.460466311247811],
            [11.787082390629065, -5.462999074636619],
            [11.793311741154954, -5.462891920926209],
            [11.797017721578177, -5.4665144885928],
            [11.80083232405508, -5.46563546804868],
            [11.807536089380521, -5.467883399590403],
            [11.81565897729348, -5.472099844790712],
            [11.820545705414036, -5.476648565775468],
            [11.827288158975174, -5.477093433223897],
            [11.834521504544266, -5.479060104512455],
            [11.839674482799042, -5.479180704337948],
            [11.845072856175936, -5.482300587102686],
            [11.847690193709024, -5.487286664380363],
            [11.851231438722005, -5.489159838320906],
            [11.854659810677138, -5.488439024217812],
            [11.850832711668867, -5.50364727977755],
            [11.848550077052394, -5.51872178727361],
            [11.851099753018888, -5.531395446554235],
            [11.85140937636738, -5.538285101640349],
            [11.850203483869183, -5.543312245063675],
            [11.844126706433164, -5.553872381219659],
            [11.841158217100581, -5.566752183909255],
            [11.842080101120315, -5.572832420201258],
            [11.844514159938017, -5.577623265101421],
            [11.84451736125056, -5.577715812137254],
            [11.745912181626602, -5.613503736815278],
            [11.650848334434269, -5.647910139161453],
            [11.650819800121115, -5.651491889882672],
            [11.64667297809233, -5.65860110983573],
            [11.647496305978034, -5.6624609635668754],
            [11.643934097355151, -5.659722793298477],
            [11.63833996043824, -5.666550786670075],
            [11.633466050488126, -5.668404418444337],
            [11.630985071678111, -5.667089927963794],
            [11.61797078933383, -5.6688477041051515],
            [11.611966156982723, -5.669062321697556],
            [11.607767011014484, -5.6666615559067175],
            [11.604970226673776, -5.667935376515316],
            [11.604292621298367, -5.662755807336448],
            [11.60017395072451, -5.6607636551126195],
            [11.592726984178412, -5.6617537344163615],
            [11.590505403958696, -5.658613637715631],
            [11.583612162993093, -5.658201997774751],
            [11.583994465027342, -5.653491283213081],
            [11.580319067529095, -5.650884572992079],
            [11.579354523784929, -5.645453861362515],
            [11.576219174920121, -5.647138861693023],
            [11.571619490097328, -5.639361036399411],
            [11.569419047221768, -5.641625401122911],
            [11.565444319024738, -5.642046221497394],
            [11.569779140144075, -5.634907183959283],
            [11.573853577913725, -5.631899898980609],
            [11.576033634249788, -5.627510377484064],
            [11.57933361986247, -5.6142112035967875],
            [11.578343466248478, -5.6096695552550875],
            [11.580859685808079, -5.6051091612067],
            [11.58236945437655, -5.59796730023198],
            [11.585805318858032, -5.594847028883051],
            [11.582529938502667, -5.592385285681364],
            [11.586623549547937, -5.576190788338334],
            [11.59115844838398, -5.572982676612254],
            [11.593966328643058, -5.568617677788987],
            [11.594610966925783, -5.562200058988178],
            [11.597044929178708, -5.558786584603819],
            [11.59402598276658, -5.552122388457979],
            [11.595973583134906, -5.548516234565458],
            [11.592264983284267, -5.542422508909508],
            [11.589837509677043, -5.535092823952772],
            [11.591989693073142, -5.530335971234063],
            [11.59795699438833, -5.5216426650989865],
            [11.593477890866204, -5.515628377674701],
            [11.593496535075383, -5.511809128200326],
            [11.596809614649352, -5.510895548469266],
            [11.599265595985832, -5.504787371621771],
            [11.60823846546159, -5.502326595166498],
            [11.616404062050538, -5.501434848228448],
            [11.61823890710673, -5.502355525830788],
            [11.629359878848165, -5.493536066708841],
            [11.630500339991688, -5.491680262196077],
            [11.633224172266393, -5.474865120703364],
            [11.638843964728647, -5.468140970088085],
            [11.636126354890267, -5.463446710513033],
            [11.633101743838314, -5.46401538486068],
            [11.623851664640975, -5.460551064367615],
            [11.616639550469367, -5.455039948347445],
            [11.623689416293118, -5.448569142568778]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.56714505526439, "lat": 32.4038739894373 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13283"],
        "coty_name": ["Treutlen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Treutlen County"],
        "coty_fp_code": "283",
        "coty_gnis_code": "00347505"
      },
      "bbox": [
        11.565444319024738, -5.669062321697556, 11.854659810677138,
        -5.445204039984061
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.400192496055682, -5.107864373328422],
            [9.494730855890227, -5.062692259378495],
            [9.49291003598865, -5.047921657296219],
            [9.50091815841744, -5.047042213192885],
            [9.498896315934878, -5.030479259331135],
            [9.50750209067522, -5.029500108121303],
            [9.508462966774657, -5.037930757119109],
            [9.516616499430398, -5.03703491784421],
            [9.51806550481358, -5.051894022061713],
            [9.536697757761795, -5.042907268290688],
            [9.540547286766644, -5.037750344730845],
            [9.543288016456783, -5.036895624961277],
            [9.54881230897302, -5.038516913136997],
            [9.552712413882965, -5.037533246638093],
            [9.55519054623848, -5.030864024499812],
            [9.594712794743204, -5.00821105529886],
            [9.634968685631524, -4.98487871376275],
            [9.698521048635655, -4.978294243981449],
            [9.700389416745663, -4.994550802171331],
            [9.692348424775783, -4.995602468370234],
            [9.695710496174229, -5.004340995588478],
            [9.697711247641498, -5.006603377920488],
            [9.701225860278317, -5.002932077876057],
            [9.702182807433463, -5.0108668884677305],
            [9.709623454100145, -5.076513188216275],
            [9.714621683641209, -5.1248826599768424],
            [9.719614422982787, -5.165622494005395],
            [9.727494754210975, -5.240396469600648],
            [9.729974675738742, -5.240117868975295],
            [9.740168490355245, -5.328019046508096],
            [9.74055257045757, -5.3318857850411066],
            [9.668049708780023, -5.339970605327754],
            [9.596766569089604, -5.3476628148906045],
            [9.543348086831752, -5.353202755004371],
            [9.543798327405664, -5.356687461617375],
            [9.536115971692254, -5.357559119633869],
            [9.535577945783935, -5.354009854357391],
            [9.47309228015733, -5.360854898324085],
            [9.467075907113985, -5.34217830978839],
            [9.4477400412477, -5.274671194906172],
            [9.406051864388282, -5.128876938329145],
            [9.400192496055682, -5.107864373328422]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.02833983235755, "lat": 33.03353063075246 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13285"],
        "coty_name": ["Troup"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Troup County"],
        "coty_fp_code": "285",
        "coty_gnis_code": "01673298"
      },
      "bbox": [
        9.400192496055682, -5.360854898324085, 9.74055257045757,
        -4.978294243981449
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.820068405955944, 5.538692273337421],
            [-11.81212701882377, 5.58190262367335],
            [-11.788682484013869, 5.709778022868787],
            [-11.745694228903512, 5.702098672181088],
            [-11.73098033605144, 5.783303712813222],
            [-11.723783470197406, 5.782020785182638],
            [-11.709123004817673, 5.862725542207709],
            [-11.623727735728878, 5.847255108338169],
            [-11.608078139818113, 5.932578222537345],
            [-11.566877127294882, 5.925313440917819],
            [-11.566145468068475, 5.929389768549998],
            [-11.523961630661871, 5.921836115526253],
            [-11.509488810816904, 6.003579551884645],
            [-11.508117510712072, 6.003347600501165],
            [-11.467035517015184, 5.99613536534036],
            [-11.46643947208293, 5.999486681737926],
            [-11.38170560975227, 5.984685087166],
            [-11.394748616850773, 5.911490786203057],
            [-11.416821722693602, 5.786422526063091],
            [-11.332211893165201, 5.771788230157398],
            [-11.247604843067654, 5.757137634930417],
            [-11.134220322705916, 5.737495644358985],
            [-11.120058593902016, 5.735130260665455],
            [-11.122635556939793, 5.720559819961675],
            [-11.080093655241424, 5.7132133089303],
            [-11.08753273010165, 5.670416842590212],
            [-11.05588142193235, 5.665051478307298],
            [-11.017674416767823, 5.658198376724403],
            [-10.929764930889675, 5.643165427308222],
            [-10.943725797716283, 5.560559906012699],
            [-10.860428422761395, 5.546340550700567],
            [-10.776302007237934, 5.532319136967365],
            [-10.790919487113596, 5.446255955975408],
            [-10.791815339243897, 5.446394427920155],
            [-10.82030587211489, 5.27399405334581],
            [-10.902241115320418, 5.288272887981849],
            [-10.9895477171969, 5.30264855855591],
            [-11.076666360188469, 5.3177118613814764],
            [-11.07651481505712, 5.319079540119757],
            [-11.159449266776893, 5.333097903605044],
            [-11.242827157190748, 5.347343037536233],
            [-11.24296095209378, 5.3465766172051685],
            [-11.390647880681966, 5.3724605445445395],
            [-11.469868515496774, 5.386207203442371],
            [-11.584673654072711, 5.406271846925983],
            [-11.591659927268246, 5.401078393217759],
            [-11.593054619727786, 5.404950885255209],
            [-11.59869355670191, 5.408813895836274],
            [-11.603621944990634, 5.406350154547683],
            [-11.603452075186095, 5.399746120565956],
            [-11.608453613147924, 5.395918735444785],
            [-11.612079333987001, 5.398570285068156],
            [-11.614500765564708, 5.397469925156005],
            [-11.613027059984493, 5.392001689274309],
            [-11.614800771749868, 5.389012564763851],
            [-11.619170838850222, 5.385892510188271],
            [-11.622265061020356, 5.388470017336874],
            [-11.625111281602754, 5.383041121406095],
            [-11.63284637743988, 5.38305686684502],
            [-11.639849091891397, 5.386219131041607],
            [-11.647385924218923, 5.386452604571614],
            [-11.651362529184636, 5.384417664084658],
            [-11.653029889399292, 5.380356697766374],
            [-11.652731372764348, 5.376492365278187],
            [-11.64949793744111, 5.37385408210866],
            [-11.649884501016453, 5.368267378567151],
            [-11.65718484792237, 5.366132812330352],
            [-11.662657902383804, 5.360511982162253],
            [-11.664520379444427, 5.355368668273891],
            [-11.664386954171343, 5.348762762493064],
            [-11.670658116617494, 5.340210792674429],
            [-11.678578011553531, 5.333766025886629],
            [-11.676646642328672, 5.326448777113246],
            [-11.676944482661984, 5.322598821226845],
            [-11.680771301950287, 5.318701691250702],
            [-11.691566188225123, 5.315243526589764],
            [-11.69409388035982, 5.308505805033585],
            [-11.695831123231365, 5.297976506803222],
            [-11.695533975997757, 5.294964436491308],
            [-11.699398123226139, 5.293699804445658],
            [-11.699383016237656, 5.28987814111526],
            [-11.705258226132685, 5.285641359361336],
            [-11.709019244553408, 5.281357529709894],
            [-11.717120541123624, 5.2880023928849145],
            [-11.721338961061893, 5.28402434217276],
            [-11.724387411093794, 5.2787983033937165],
            [-11.723758543504289, 5.275931175158293],
            [-11.727388647823481, 5.274191583136493],
            [-11.727317284314786, 5.270124354268179],
            [-11.777905909737132, 5.279175274195095],
            [-11.779010443772139, 5.279217095558936],
            [-11.864471439435146, 5.29450269632094],
            [-11.830327813742745, 5.481743622693638],
            [-11.820068405955944, 5.538692273337421]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.39808081821785,
          "lat": 43.21654959425553
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16011"],
        "coty_name": ["Bingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bingham County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00400593"
      },
      "bbox": [
        -11.864471439435146, 5.270124354268179, -10.776302007237934,
        6.003579551884645
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.295524031845271, 2.05807635115779],
            [4.302860528913767, 2.0579382128671724],
            [4.381776001128428, 2.0592705645661025],
            [4.411177640096923, 2.0593494599492947],
            [4.469495691802767, 2.0598423375936132],
            [4.540093562639921, 2.0630814240818474],
            [4.554601945665973, 2.063604807658886],
            [4.6406656429361295, 2.065747683182332],
            [4.642680302722216, 2.021905167026717],
            [4.647886772743844, 1.9184537906057668],
            [4.649629569228551, 1.8889564374847911],
            [4.653381568807889, 1.8154557931057558],
            [4.655757883641154, 1.7636246836701612],
            [4.657892664685836, 1.711942657980293],
            [4.634530733172047, 1.7113339869484443],
            [4.571936146515374, 1.7089495487740625],
            [4.485860194152658, 1.704346696870795],
            [4.421306785448949, 1.703300154637682],
            [4.398979728790095, 1.7020636610230615],
            [4.310522784097033, 1.700627395108776],
            [4.308934226320452, 1.7425501464584876],
            [4.303629421137115, 1.8612822752742004],
            [4.301744123918552, 1.90215634806349],
            [4.297518727988694, 2.0023277137632687],
            [4.295524031845271, 2.05807635115779]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.67785689622193,
          "lat": 40.456176965665016
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17109"],
        "coty_name": ["McDonough"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McDonough County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01784729"
      },
      "bbox": [
        4.295524031845271, 1.700627395108776, 4.657892664685836,
        2.065747683182332
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.159951979765992, -0.6275332136862429],
            [6.156703591613818, -0.5838903290268699],
            [6.183922943465699, -0.5817864813000865],
            [6.242702266079681, -0.5767409661901984],
            [6.242901923271923, -0.5773108081818341],
            [6.27086079029059, -0.5751221446706225],
            [6.290970320491347, -0.5738186209946737],
            [6.31488744489652, -0.5712242209869574],
            [6.329861398156089, -0.570223598451],
            [6.41530775087412, -0.5626608555717789],
            [6.417684594146441, -0.5917525416222752],
            [6.425208197291841, -0.6802612018205426],
            [6.4311063322563715, -0.7497854855296806],
            [6.435646385596001, -0.8128301885356175],
            [6.43877513699556, -0.8581965250318594],
            [6.439534654150255, -0.8728010164837753],
            [6.439564517839653, -0.8733780238297794],
            [6.4103893802364516, -0.8751077211905447],
            [6.3528817371798665, -0.8794595285416325],
            [6.301280980747729, -0.8839927756476256],
            [6.264796927989404, -0.8868431839766725],
            [6.1790219469595025, -0.8938257779543172],
            [6.1790050751490835, -0.8936063134664923],
            [6.178289018582188, -0.8844967036758288],
            [6.172975496288871, -0.8051137154219753],
            [6.169868111672265, -0.7609586344960927],
            [6.168224235019037, -0.7403344771527315],
            [6.159951979765992, -0.6275332136862429]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.54075231869187, "lat": 37.75310166015305 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17165"],
        "coty_name": ["Saline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saline County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00424283"
      },
      "bbox": [
        6.156703591613818, -0.8938257779543172, 6.439564517839653,
        -0.5626608555717789
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.546326546076726, 1.9717924867646237],
            [6.546834240115113, 1.9718356615539956],
            [6.541061222767896, 2.022779083807143],
            [6.5367311892548265, 2.0585243310570056],
            [6.579404039812128, 2.0626703511723417],
            [6.665576590177765, 2.071894558878195],
            [6.721313626433422, 2.0765127218343626],
            [6.74875346232944, 2.0791749467469223],
            [6.843405378832722, 2.09063368589357],
            [6.844522301894536, 2.076198192317737],
            [6.852572368567168, 1.9729633687489712],
            [6.858834347146405, 1.8921161111147948],
            [6.867071262046399, 1.7881523653848048],
            [6.8703863863871035, 1.7456886313043714],
            [6.880627523308951, 1.6234923857834385],
            [6.885390145013584, 1.567893837989221],
            [6.892884282988741, 1.479188085432668],
            [6.856220655922219, 1.4752221431838999],
            [6.875718530556068, 1.46325839118182],
            [6.830367437897708, 1.4590567900476006],
            [6.830425579431331, 1.4721893391460206],
            [6.800296818380974, 1.468938375124056],
            [6.708039306039128, 1.4607311092205284],
            [6.673592459229571, 1.457507755337235],
            [6.628982075723258, 1.4531042853987237],
            [6.58679381066276, 1.4492757774459772],
            [6.578592015940015, 1.5370335689739731],
            [6.570685974671054, 1.6247775263399022],
            [6.562286211757617, 1.7125514856836064],
            [6.561153395129226, 1.720079398780416],
            [6.55387750177951, 1.7964256064596187],
            [6.563926147666566, 1.7974185417954132],
            [6.555488196893159, 1.8855182983024523],
            [6.546326546076726, 1.9717924867646237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.73279922120618, "lat": 40.18343450314353 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17183"],
        "coty_name": ["Vermilion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vermilion County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "01785114"
      },
      "bbox": [
        6.5367311892548265, 1.4492757774459772, 6.892884282988741,
        2.09063368589357
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.183170627941339, 0.11881837682219601],
            [8.197420953417234, 0.12151989813816678],
            [8.212559752296077, 0.12237261734418305],
            [8.213346480541391, 0.11486047183313601],
            [8.234753734879304, 0.11713672999381526],
            [8.235650497451589, 0.10990329320574754],
            [8.249095225783167, 0.11125093540202181],
            [8.299985430002492, 0.11725949277022618],
            [8.35826910353011, 0.12366368746043001],
            [8.358278430475634, 0.12000234713417321],
            [8.380966093930759, 0.09410208651941328],
            [8.38200681160364, 0.09502287094752672],
            [8.40011983022826, 0.07341818292561988],
            [8.39102459166508, 0.06476577024657625],
            [8.385285818139211, 0.06315892104362705],
            [8.384227399556005, 0.05653327128886157],
            [8.381601340630095, 0.05243513212115164],
            [8.376865414345312, 0.05456920989153066],
            [8.374201416769155, 0.05242140327247926],
            [8.37739317276092, 0.045012943625403874],
            [8.384708228255674, 0.04340894080240059],
            [8.37905199173427, 0.03547499660018369],
            [8.379170823912089, 0.03289382217283789],
            [8.383862324111934, 0.030082574347240352],
            [8.378291140005995, 0.025161274138813312],
            [8.382822890605887, 0.018536154771400002],
            [8.383731541190679, 0.008032361162394752],
            [8.379170088440226, 0.0054436258887309704],
            [8.363970978708148, 0.00044558536572454843],
            [8.358725894395421, -0.0026401178589714035],
            [8.3554718155792, -0.00643880987131642],
            [8.351307292090738, -0.018279193727217008],
            [8.350827056049045, -0.02447113031809424],
            [8.352007588460923, -0.03374288927270568],
            [8.351801801270518, -0.044186166766758864],
            [8.348645648284071, -0.053341283584516286],
            [8.343455711245628, -0.06314580675977034],
            [8.329630492008974, -0.07716960262980645],
            [8.323861762116639, -0.08410529586699535],
            [8.315124369936537, -0.09961585771335932],
            [8.311404001085883, -0.10879177761188934],
            [8.31043077682283, -0.10371577945491142],
            [8.279506814041465, -0.10633350085988118],
            [8.265547402350887, -0.10801429184885813],
            [8.264418976683839, -0.09452553635697225],
            [8.266051561378315, -0.09417974177509966],
            [8.260084648552183, -0.03568135920790795],
            [8.245622194369886, -0.03681606056602082],
            [8.244134019629827, -0.022111430434719033],
            [8.229712133765684, -0.02361572281643728],
            [8.228180741607746, -0.009288358217358347],
            [8.22602558838156, -0.009530310457312285],
            [8.224322603393809, 0.005323172188123344],
            [8.209780091320885, 0.0037505849177520453],
            [8.206651728111172, 0.03269783296532611],
            [8.19253823271095, 0.031393668409580924],
            [8.18811157851834, 0.075058104286567],
            [8.187498539850658, 0.07497123972988967],
            [8.183170627941339, 0.11881837682219601]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.90705974498715, "lat": 38.3187466419896 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18043"],
        "coty_name": ["Floyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Floyd County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00450350"
      },
      "bbox": [
        8.183170627941339, -0.10879177761188934, 8.40011983022826,
        0.12366368746043001
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.134403792660468, 3.2633033230109074],
            [8.205400727904063, 3.2724570266268866],
            [8.262185227894344, 3.2794027570632847],
            [8.304912092600162, 3.2843920322264357],
            [8.354065310577793, 3.290373784197891],
            [8.427700221135655, 3.2990197851460414],
            [8.474175501174878, 3.3043326462309426],
            [8.484015247358949, 3.2220308476087665],
            [8.484961668397547, 3.2153793927032273],
            [8.491757469372114, 3.158044503653844],
            [8.494989402334776, 3.1291569804972545],
            [8.497945753804618, 3.0999303513155727],
            [8.50563424612424, 3.042312609948173],
            [8.458442256798708, 3.0365838007836863],
            [8.41992561813751, 3.032538848562969],
            [8.356259063520795, 3.0261682637951317],
            [8.30537250871407, 3.020746621791826],
            [8.249703887489986, 3.0155673315008493],
            [8.247143852245655, 3.0447393686971505],
            [8.21625859471198, 3.0414493537241354],
            [8.16151835896256, 3.0348693414931596],
            [8.154377146431035, 3.0912157825268616],
            [8.146972544152337, 3.156476992283295],
            [8.14478968728649, 3.17689092000147],
            [8.139947488914899, 3.220744223467483],
            [8.134403792660468, 3.2633033230109074]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.41747031520089, "lat": 41.39859983207772 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18113"],
        "coty_name": ["Noble"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Noble County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00450377"
      },
      "bbox": [
        8.134403792660468, 3.0155673315008493, 8.50563424612424,
        3.3043326462309426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.9660949396686425, 3.2475106975367374],
            [6.997259957905623, 3.2572590541401802],
            [6.999629260084504, 3.26042032932497],
            [7.009771240382488, 3.2629025971955263],
            [7.012143128851044, 3.2693845202569873],
            [7.017792381927296, 3.269736174568458],
            [7.018289581088568, 3.2641973565675384],
            [7.0205401059178945, 3.264436506046246],
            [7.019594234522514, 3.274092014745316],
            [7.023774305323514, 3.274443577689094],
            [7.032146623536847, 3.2780998013428913],
            [7.033640724768782, 3.2761702476893677],
            [7.039467943273867, 3.277503187126356],
            [7.0547873281907965, 3.2836543253557777],
            [7.07821129540513, 3.296034336258918],
            [7.1051519017695295, 3.311524345998415],
            [7.128660915637595, 3.326467243048303],
            [7.150553792528924, 3.3410120032868895],
            [7.164454601761027, 3.3494267395154664],
            [7.172039024186027, 3.3531052657889377],
            [7.174318407425389, 3.3318527651995913],
            [7.181223702837857, 3.260777100285046],
            [7.189179892557296, 3.1898886825755146],
            [7.19079654821078, 3.1795939084407525],
            [7.1981773481752995, 3.1065615548686027],
            [7.198952186113496, 3.093070724508589],
            [7.208373782589418, 2.9900505508096162],
            [7.217371783221043, 2.902434092566218],
            [7.219381908494971, 2.879748931397915],
            [7.214361751920902, 2.8726050871491267],
            [7.202334039525196, 2.8664741112094445],
            [7.19276873464271, 2.859874737271224],
            [7.1859831388674715, 2.8611416265163943],
            [7.180176322315625, 2.8668105643259256],
            [7.158877268498724, 2.8781473873991175],
            [7.120005946180349, 2.903408988118088],
            [7.072099425632077, 2.915944052730787],
            [7.065271324548293, 2.9151842164741866],
            [7.045233561266215, 2.9032569574328946],
            [7.0218222268842485, 2.889871909909263],
            [7.004420888418732, 2.8648157043089175],
            [7.00269152948161, 2.8838604635848464],
            [6.994888667714273, 2.9562402608946914],
            [6.993961213849371, 2.970302247542575],
            [6.990657327733094, 3.0067456056340935],
            [6.989274958682779, 3.0195753553025644],
            [6.985948187467572, 3.057777620020741],
            [6.978790555717495, 3.130345816592732],
            [6.972227053498277, 3.1883570635983305],
            [6.9660949396686425, 3.2475106975367374]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.06716944324847, "lat": 41.46035831990222 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18127"],
        "coty_name": ["Porter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Porter County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00450382"
      },
      "bbox": [
        6.9660949396686425, 2.859874737271224, 7.219381908494971,
        3.3531052657889377
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.327548954277465, 4.029446683623654],
            [3.4136873465559097, 4.033170086310006],
            [3.4432285827207054, 4.034078952800403],
            [3.465125206440189, 4.036020468061664],
            [3.500308434594658, 4.0383474828151025],
            [3.5240198726775276, 4.039379159092684],
            [3.5872306309754407, 4.041655245918269],
            [3.674100019117443, 4.046497038396159],
            [3.6767150523755703, 3.9586636552463252],
            [3.679768265259835, 3.900485300715169],
            [3.681161875812436, 3.8712533245671006],
            [3.6892980598883907, 3.8715959694230393],
            [3.6929453162848613, 3.786054516812326],
            [3.697659225694054, 3.6982037797502487],
            [3.6114427863123746, 3.6944051910465943],
            [3.52570831293775, 3.6931305470348685],
            [3.468470763859077, 3.6895107288142794],
            [3.427436382466314, 3.6871045583948954],
            [3.408001708741027, 3.686650424002948],
            [3.3542541635107233, 3.6840175255994785],
            [3.350668439244221, 3.7716962045656652],
            [3.347554985235452, 3.8556032017367894],
            [3.3349175046638693, 3.8550527622145645],
            [3.332186398233371, 3.9098843878539724],
            [3.3317968629933734, 3.9133321709005853],
            [3.3301952484260866, 3.9530319273045174],
            [3.3302825035289136, 3.956573269655855],
            [3.327548954277465, 4.029446683623654]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.83784342110307, "lat": 42.4708048434917 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19019"],
        "coty_name": ["Buchanan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buchanan County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00465199"
      },
      "bbox": [
        3.327548954277465, 3.6840175255994785, 3.697659225694054,
        4.046497038396159
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.2938392827723795, 3.9098854698548973],
            [2.3520703320112526, 3.9112789135363335],
            [2.3733845841756254, 3.9119479567133926],
            [2.467513948233993, 3.9140710442586797],
            [2.5535437874209523, 3.9162256436833864],
            [2.6395700023191737, 3.918926327170926],
            [2.6406077277332844, 3.8908147921505645],
            [2.642193678443374, 3.8325806890488407],
            [2.659934863059436, 3.832998167254557],
            [2.664107182898671, 3.7157240552095674],
            [2.6665765801752843, 3.6433396395223476],
            [2.669133285081441, 3.5705976762550846],
            [2.645822183743367, 3.5698623251387245],
            [2.5801189185786817, 3.567282680172379],
            [2.499984445541556, 3.56509160477013],
            [2.415486870788971, 3.5630303929470646],
            [2.3298642271901215, 3.5607697813787462],
            [2.3276506749361596, 3.647854794267519],
            [2.326804697303608, 3.6769750974922304],
            [2.3241116158971127, 3.779464590381925],
            [2.32313746490511, 3.823376049375396],
            [2.2964187749755767, 3.8228430694784272],
            [2.2938392827723795, 3.9098854698548973]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.2404019098487, "lat": 42.38387712268164 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19083"],
        "coty_name": ["Hardin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardin County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00465230"
      },
      "bbox": [
        2.2938392827723795, 3.5607697813787462, 2.669133285081441,
        3.918926327170926
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.788137078825251, 2.869310106809241],
            [2.873470488523108, 2.872442041064077],
            [2.9567701476488493, 2.8756889607273006],
            [3.0152199263932657, 2.8777418528130148],
            [3.1292796506680403, 2.8823872528121366],
            [3.130211603497724, 2.857487479629529],
            [3.1351347262397846, 2.740713364826545],
            [3.1388801002936795, 2.6502383117720028],
            [3.140276668837178, 2.6212060175908083],
            [3.1418968337448288, 2.5764167483879707],
            [3.1433768430847575, 2.5475972732970575],
            [3.143818337194333, 2.5327055174077926],
            [3.0577826472099803, 2.5290744175613202],
            [2.9720895134221994, 2.5258863737344495],
            [2.886734853980926, 2.522883980167995],
            [2.8008948617627, 2.5197063252806746],
            [2.797527736579605, 2.6075706909260914],
            [2.7964362881846445, 2.629539422659635],
            [2.7943104545556836, 2.700345596245813],
            [2.7913231748778493, 2.7821549983091303],
            [2.788137078825251, 2.869310106809241]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.64089417872736, "lat": 41.33520687240092 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19123"],
        "coty_name": ["Mahaska"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mahaska County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00465250"
      },
      "bbox": [
        2.788137078825251, 2.5197063252806746, 3.143818337194333,
        2.8823872528121366
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.266883562355521, 2.22342720780022],
            [1.323433672069247, 2.2240383739848624],
            [1.3311204108519272, 2.2243128787357374],
            [1.4350159108729144, 2.2247427442233962],
            [1.5529946156623586, 2.2259238003454165],
            [1.6099182707852848, 2.226957426345764],
            [1.6098219939194842, 2.193720214421298],
            [1.6107552250482375, 2.132934291023825],
            [1.6131203311239406, 2.004933377795679],
            [1.6139091369542753, 1.9503613734246334],
            [1.6149535367831314, 1.9013760866932614],
            [1.6149248974299026, 1.8957160833449502],
            [1.567742976293633, 1.8948863429552203],
            [1.4938309381590524, 1.894235577991261],
            [1.4300917869643817, 1.8943703709722384],
            [1.3589029999130962, 1.8947869711033698],
            [1.3494332896986883, 1.8950825868759145],
            [1.2944261983981658, 1.8952258506317883],
            [1.2807978325091274, 1.8954017539723231],
            [1.279890278755009, 1.9870897079352978],
            [1.280376348704331, 2.048849242263909],
            [1.2688008295142603, 2.048832798187715],
            [1.2687432448528844, 2.070783973045964],
            [1.2682282315698976, 2.072355633823797],
            [1.2676730625850767, 2.14307824046075],
            [1.2674008958035836, 2.1460513521672118],
            [1.2667822488654912, 2.2125395608013467],
            [1.266883562355521, 2.22342720780022]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.69642928000725, "lat": 40.73739306968857 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19173"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00465275"
      },
      "bbox": [
        1.2667822488654912, 1.894235577991261, 1.6149535367831314,
        2.226957426345764
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1919016160390408, -1.3711852923631713],
            [1.3260159645664198, -1.3697503481348592],
            [1.4259369802826323, -1.3693644241754974],
            [1.5138875415502588, -1.3690594526343018],
            [1.55213577298278, -1.3683484819043743],
            [1.5530000390306522, -1.4455513523154642],
            [1.5537946190940664, -1.5193956719427795],
            [1.5537592822486392, -1.5270582308516836],
            [1.5548179058453735, -1.5763444546411067],
            [1.5549888707370734, -1.595699134438248],
            [1.556082678433758, -1.6525852007666537],
            [1.556862308451191, -1.711009596695432],
            [1.5511238112432528, -1.7113279689232503],
            [1.4921910276408201, -1.7120227547425988],
            [1.4625749957300929, -1.7125632419593388],
            [1.3708149519100283, -1.7135150223056637],
            [1.2486706281527276, -1.7142430841496825],
            [1.1965569773285054, -1.7147739842025458],
            [1.194607929524899, -1.5668901289650516],
            [1.1936073696091756, -1.469879808967432],
            [1.1924959612001365, -1.4450382743358148],
            [1.1919016160390408, -1.3711852923631713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.8462872319673, "lat": 37.16930722318381 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20021"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00484980"
      },
      "bbox": [
        1.1919016160390408, -1.7147739842025458, 1.556862308451191,
        -1.3683484819043743
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.763232612914343, -1.1688222336392362],
            [-2.663146186568718, -1.175515182120397],
            [-2.539335435047594, -1.1845410284418882],
            [-2.4737514966712104, -1.1884030692822243],
            [-2.4164153608497028, -1.1908227222894987],
            [-2.3667035694359293, -1.192216572204177],
            [-2.3307093841646807, -1.1934531280882696],
            [-2.3331122651659744, -1.2714877728707286],
            [-2.3337096138698876, -1.280839421006671],
            [-2.3238127052994932, -1.281196986045466],
            [-2.328008680353838, -1.361466157086921],
            [-2.329573451322871, -1.4028197623105916],
            [-2.3315796357948004, -1.471797828179218],
            [-2.332922366227053, -1.5462335952629536],
            [-2.3365334204356825, -1.666130750521799],
            [-2.4215293404775027, -1.662883938948823],
            [-2.428624528047017, -1.6620122646401922],
            [-2.52068724735861, -1.6577665977570162],
            [-2.6006624590703464, -1.6537170480155257],
            [-2.695331825784767, -1.6498249089955592],
            [-2.7011464549258046, -1.6495044572804936],
            [-2.7698172733480213, -1.6461911173282973],
            [-2.767541569746947, -1.5894567321792108],
            [-2.765715406739048, -1.5333496943026113],
            [-2.7658325642532176, -1.5226576611181792],
            [-2.7608664911470773, -1.39999884489759],
            [-2.758019670056803, -1.3318802637207012],
            [-2.7547119707082026, -1.2580574893701426],
            [-2.767197125566816, -1.257316672168728],
            [-2.763232612914343, -1.1688222336392362]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.82030728273539,
          "lat": 37.235513787886646
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20025"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00484982"
      },
      "bbox": [
        -2.7698172733480213, -1.666130750521799, -2.3238127052994932,
        -1.1688222336392362
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2952084055136184, 0.48720787467927384],
            [-2.2390154359944647, 0.4852585854724959],
            [-2.152878497182911, 0.48238900965755255],
            [-2.1037542703680123, 0.4806341275791434],
            [-2.1035198322696544, 0.4802177628048728],
            [-2.0568677965326865, 0.4793270014428076],
            [-2.033058106423157, 0.47833380151102056],
            [-2.011512394732579, 0.47792616384991377],
            [-1.9370618743610426, 0.475337127645588],
            [-1.9247400521802902, 0.4747055769392862],
            [-1.9065028581362584, 0.4744777087025949],
            [-1.8774124730879802, 0.4732731427381153],
            [-1.869586306172871, 0.4731306087274863],
            [-1.870086785905036, 0.464954811538659],
            [-1.8731436618052704, 0.38006194769460033],
            [-1.8765261626529992, 0.2966005323430731],
            [-1.879873670239435, 0.20888222904864415],
            [-1.8796891580644073, 0.2014341701305378],
            [-1.8849062358786477, 0.08649135808192161],
            [-1.887623047556883, 0.03295239459557152],
            [-1.9724355685335915, 0.035959927038739604],
            [-2.0732994217560687, 0.03919311285889128],
            [-2.186004680612027, 0.042982351585646505],
            [-2.306667272653698, 0.0472962143758149],
            [-2.316891508077201, 0.04765953251779183],
            [-2.314677719944346, 0.08642972774042298],
            [-2.3100544285995137, 0.17917945869376883],
            [-2.3049413227556075, 0.2904493840937846],
            [-2.30341891414659, 0.3254072593321734],
            [-2.3003549340716907, 0.38906775344511135],
            [-2.298223109409966, 0.4288233176369465],
            [-2.2981800510908696, 0.4331761537079508],
            [-2.2952084055136184, 0.48720787467927384]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.31724729805303, "lat": 38.91473231890306 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20051"],
        "coty_name": ["Ellis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ellis County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00484995"
      },
      "bbox": [
        -2.316891508077201, 0.03295239459557152, -1.869586306172871,
        0.48720787467927384
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4469407034090602, 0.54836013142484],
            [-1.3608382386383249, 0.5457699502037938],
            [-1.2746606603274828, 0.5438401821390796],
            [-1.25997780001825, 0.5432644067944169],
            [-1.1890829766015296, 0.5414311432316505],
            [-1.081280858447755, 0.5391279822527255],
            [-1.0413807060324742, 0.5378482344425853],
            [-1.0170239216598969, 0.5378504142529875],
            [-1.0190139160187761, 0.45026315228090663],
            [-1.0177974387231608, 0.4498082910771653],
            [-1.018404190369006, 0.43558972871851],
            [-1.0199336407398374, 0.36232307662186775],
            [-1.0197928339434974, 0.34768784791807233],
            [-1.0214580931507424, 0.27450588527744507],
            [-1.023271133662892, 0.1863844608870193],
            [-1.0948625814533794, 0.18795112503843434],
            [-1.1658099533015658, 0.1890311122489998],
            [-1.176065339559074, 0.1894619025555761],
            [-1.205952624492582, 0.18994399594256214],
            [-1.209065148151778, 0.18969180879033667],
            [-1.2519257481786188, 0.19127777108683186],
            [-1.2697621776604238, 0.19225511242311613],
            [-1.2809008274152967, 0.19211349475137152],
            [-1.3239772154865812, 0.19278124666721086],
            [-1.3525564527748233, 0.19343467969244027],
            [-1.381222513932491, 0.19440950462684858],
            [-1.4457796618543952, 0.19578085628953457],
            [-1.4520951332573835, 0.1960315873871219],
            [-1.4500695092310623, 0.2887513168313541],
            [-1.44854792642777, 0.3492195423627583],
            [-1.448789316504062, 0.35726317584926276],
            [-1.4475473016488993, 0.3719114963410934],
            [-1.446319591523807, 0.40185677150095184],
            [-1.4443283183306819, 0.4603210557653588],
            [-1.4491271492838524, 0.4604729025015944],
            [-1.4470015035449948, 0.5417632294877106],
            [-1.4469407034090602, 0.54836013142484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.20770121958792,
          "lat": 39.045303988777114
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20105"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00485017"
      },
      "bbox": [
        -1.4520951332573835, 0.1863844608870193, -1.0170239216598969,
        0.54836013142484
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1926453764929699, 0.04111702783888576],
            [1.2212843772117252, 0.041237307070039114],
            [1.263204295636822, 0.04185752464347336],
            [1.278211316092141, 0.04175387311470904],
            [1.335404108284309, 0.042407611971593505],
            [1.3400572852184633, 0.042594280294663556],
            [1.4213683715142131, 0.0433887266095331],
            [1.4500130510140243, 0.043895196042067035],
            [1.464289687581998, 0.0438712702627728],
            [1.5378567083907875, 0.0448661704516648],
            [1.5377767575323258, -0.07391019630184857],
            [1.5383493043089909, -0.11464583952389751],
            [1.5381785657733629, -0.11827679099362651],
            [1.5391524854769578, -0.212576871375543],
            [1.5391032683771961, -0.2181840949627819],
            [1.539808516512156, -0.29308743417362665],
            [1.5400946663926867, -0.30793228093954966],
            [1.4825541269548668, -0.3086498159128653],
            [1.4470629470873244, -0.30890927626533843],
            [1.3554543993548578, -0.31033002143435656],
            [1.3538050748604356, -0.31022168826432556],
            [1.2318085104005203, -0.31104036730033613],
            [1.1888297521915199, -0.3109825279395806],
            [1.1878095330656344, -0.18314370304189226],
            [1.187756728056568, -0.14217094592787397],
            [1.186998072113287, -0.0835358146425857],
            [1.187202426635273, -0.07363168367517936],
            [1.1858487358798642, -0.0030614036359931677],
            [1.1928861978089502, -0.002992899545414498],
            [1.1926453764929699, 0.04111702783888576]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.83810214557188, "lat": 38.56353167222512 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20121"],
        "coty_name": ["Miami"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miami County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00485025"
      },
      "bbox": [
        1.1858487358798642, -0.31104036730033613, 1.5400946663926867,
        0.0448661704516648
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.4035954968837356, 0.5100230031930181],
            [1.4077250692236425, 0.4993743119465004],
            [1.4133847231737757, 0.4892514996263099],
            [1.4217651251119585, 0.48259647846957393],
            [1.4339509937631076, 0.4787189005788825],
            [1.4438589992524675, 0.4786493597299806],
            [1.4511344823290935, 0.4801609327950538],
            [1.4646928200403133, 0.48858433738473606],
            [1.4716073774196936, 0.4936671486594094],
            [1.4768932608434289, 0.4945480660541426],
            [1.4855246227699304, 0.49234624212954325],
            [1.489634640708219, 0.4894759348284467],
            [1.4932931716436744, 0.48450243461233766],
            [1.4917390214989732, 0.47298662589432977],
            [1.4934882473298419, 0.46806294753597055],
            [1.5000503201109736, 0.4643817006662901],
            [1.5084702843360063, 0.4641018953794403],
            [1.5205970066870678, 0.4672004555445047],
            [1.5267676042479696, 0.47072292398089344],
            [1.5322637007603697, 0.47185423858185316],
            [1.5376022141535408, 0.47047765686301174],
            [1.5461772298625995, 0.4657215528945195],
            [1.547977110792163, 0.46080288449325],
            [1.5469996820063208, 0.4497929862154438],
            [1.539062110323329, 0.43909822597270437],
            [1.5331826726042002, 0.428350611483101],
            [1.5339684473667157, 0.42381851940964943],
            [1.5347669434999052, 0.37562702673753695],
            [1.5348687633870444, 0.3538001599875658],
            [1.4418203339967615, 0.3523973655935176],
            [1.4185502634998777, 0.35179188393102867],
            [1.395849449293385, 0.3515968700545026],
            [1.3842642458960244, 0.35117746160769303],
            [1.370981567793805, 0.35778443952838956],
            [1.364106194961832, 0.3629578924433041],
            [1.3564044793149388, 0.36741711150586315],
            [1.3517924351911574, 0.3687704479944205],
            [1.3383414009954306, 0.3681165419891716],
            [1.331464778901062, 0.3664857324538528],
            [1.3278740544324914, 0.36424007180639084],
            [1.3224587058818917, 0.35766380928486047],
            [1.3206644082158663, 0.3483829384924201],
            [1.316868266638549, 0.3373945313784818],
            [1.3169387581928225, 0.33352924459720146],
            [1.3190971793938002, 0.3268834096645602],
            [1.319124828352911, 0.32274296700727867],
            [1.3143296525715158, 0.313725964876047],
            [1.3037647125710623, 0.297583932717117],
            [1.3026373471353065, 0.3973751987411984],
            [1.3025501817861322, 0.43615086103988154],
            [1.3078364841925931, 0.4362440833778784],
            [1.3080763474934483, 0.45085027012688783],
            [1.307689818981084, 0.509758099694363],
            [1.3078936271738013, 0.511183998143402],
            [1.336369918384244, 0.510864849877022],
            [1.4022855244169004, 0.5104089763464136],
            [1.4035954968837356, 0.5100230031930181]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.76455666744043,
          "lat": 39.114605965085524
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20209"],
        "coty_name": ["Wyandotte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wyandotte County"],
        "coty_fp_code": "209",
        "coty_gnis_code": "00485065"
      },
      "bbox": [
        1.3025501817861322, 0.297583932717117, 1.547977110792163,
        0.511183998143402
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.234535397604773, -1.3822517417181739],
            [8.263127127607582, -1.2503276122045452],
            [8.294794473653823, -1.254919436324441],
            [8.296792981689025, -1.1390729661641184],
            [8.335639939643766, -1.1419980681277153],
            [8.348294634821915, -1.1439256454872662],
            [8.366561056730774, -1.142988108163045],
            [8.389568937130575, -1.1451192019408132],
            [8.416488360875405, -1.1455129012318417],
            [8.441088169186314, -1.141618892984126],
            [8.454996498800876, -1.138611683267007],
            [8.496747092594862, -1.1219893304504802],
            [8.517680823490464, -1.1152266268887117],
            [8.54152235152275, -1.110329074691228],
            [8.531805042580554, -1.131253928172862],
            [8.519247127741865, -1.1447084416985092],
            [8.526422938781081, -1.1729687183199382],
            [8.53350814828873, -1.170132700549716],
            [8.538724974081962, -1.1715353665201669],
            [8.537978133240987, -1.1821732717207607],
            [8.540702111129301, -1.2132185737414958],
            [8.548267521622163, -1.2548293254048741],
            [8.55449115513282, -1.2753604313751283],
            [8.56456559291405, -1.3374099103659705],
            [8.581139436417825, -1.4394153167015715],
            [8.57267936213055, -1.4399223082000197],
            [8.560083219117633, -1.4474935306548335],
            [8.555666266173162, -1.4473848937939535],
            [8.541881243836897, -1.4579357462844227],
            [8.5298871326811, -1.4650891167997195],
            [8.46223193980158, -1.5277024546960833],
            [8.406454184021957, -1.578661355846108],
            [8.399742880073394, -1.5602501959686055],
            [8.390258102294641, -1.553464552640892],
            [8.38258629474954, -1.5446597870724206],
            [8.37865693291065, -1.5434171350175419],
            [8.359554168514832, -1.5413309500125725],
            [8.356938695307042, -1.546127209809777],
            [8.354813013397159, -1.5460960765652012],
            [8.35133342873616, -1.5390963760770997],
            [8.342484824333065, -1.5349804812089578],
            [8.34099084106813, -1.5327048556479206],
            [8.34502687872439, -1.5281252384385864],
            [8.351817968937862, -1.528249673367818],
            [8.35473244407626, -1.5256019054746355],
            [8.352894476160518, -1.5203110303504714],
            [8.349708773333719, -1.5186051950138402],
            [8.350061600864825, -1.5154850030057683],
            [8.343378702718033, -1.51183477750866],
            [8.339506477645527, -1.5129245022074644],
            [8.339549536580613, -1.5056699892451053],
            [8.342134831242623, -1.5024614623745303],
            [8.341790425374466, -1.4990339714841574],
            [8.334753525712305, -1.4985013711958042],
            [8.324243939619922, -1.5030258144420396],
            [8.322553470638965, -1.5007826521033722],
            [8.324757907843576, -1.4961594135215077],
            [8.325531907669205, -1.4855737086970187],
            [8.327188582398056, -1.4825289677157767],
            [8.33293432669156, -1.4774718539004457],
            [8.329872974640672, -1.4725646294718426],
            [8.318502870103151, -1.4644853522870247],
            [8.312741203315124, -1.454588361219995],
            [8.313748183377147, -1.4447808515830654],
            [8.311639231513762, -1.4425082648060548],
            [8.312005566628674, -1.4367074974233394],
            [8.315345473956965, -1.4372648370941765],
            [8.316510902120985, -1.431263521371797],
            [8.31089293636663, -1.4278333243150862],
            [8.308923344308749, -1.4168008993266892],
            [8.316384931946716, -1.4139881623965593],
            [8.318913010105941, -1.4109696368832039],
            [8.313753047765923, -1.4065650924909567],
            [8.30737101294206, -1.406753767246999],
            [8.29976856330555, -1.4101091603237335],
            [8.292621286512368, -1.4098955755823914],
            [8.289089626604019, -1.4152435659521696],
            [8.285718039428247, -1.424034199523826],
            [8.285602769684028, -1.428815981014608],
            [8.289229437077752, -1.434890574037842],
            [8.294650578846177, -1.4400041762964693],
            [8.295997859291488, -1.4431433076225972],
            [8.294029302611998, -1.4468847443068988],
            [8.289264857584145, -1.4465259751198591],
            [8.286200926189498, -1.4435690435630422],
            [8.286142879928484, -1.4397725498733016],
            [8.282387285637286, -1.4365812233627264],
            [8.280578974517047, -1.4312096909620922],
            [8.271616841228028, -1.4175369665344144],
            [8.268134186781413, -1.416939913291235],
            [8.262143281702686, -1.4192870783727536],
            [8.258932476105556, -1.4220568460759795],
            [8.253985462940946, -1.4172986048368765],
            [8.256680303734866, -1.4136430066425163],
            [8.26305961084447, -1.4110457185705298],
            [8.262157002164018, -1.407679166812393],
            [8.256215980176757, -1.4007869151012218],
            [8.257131418111788, -1.3937065950978365],
            [8.25989016119397, -1.3839144263228307],
            [8.258903870541989, -1.3816677716085115],
            [8.250469736279767, -1.3848329407906455],
            [8.248100069545782, -1.3881532724147523],
            [8.247566197203305, -1.398058592345837],
            [8.250873477517416, -1.4033398376715653],
            [8.244474313060362, -1.4091571483865282],
            [8.235564138258173, -1.4080710307189876],
            [8.229236973244127, -1.4033764420586847],
            [8.231626727384095, -1.398496076407034],
            [8.23759323447009, -1.3954210600426133],
            [8.240426636693678, -1.3915699347402488],
            [8.239582942395954, -1.38580312308268],
            [8.234535397604773, -1.3822517417181739]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.93363986729263, "lat": 36.9655782896806 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21009"],
        "coty_name": ["Barren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barren County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00516851"
      },
      "bbox": [
        8.229236973244127, -1.578661355846108, 8.581139436417825,
        -1.110329074691228
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.572868649053627, -0.07859936776490667],
            [9.646853047854014, -0.045725967499723574],
            [9.726107449475208, -0.010508712163161849],
            [9.761611052957111, -0.06331598174063026],
            [9.77854731211049, -0.08963351208507288],
            [9.790336618359841, -0.10875517286013842],
            [9.80444207955817, -0.1290515790506075],
            [9.822592697880781, -0.1577635040225763],
            [9.837897936771729, -0.18399570382540023],
            [9.829562903509029, -0.18644165079207076],
            [9.831303312385172, -0.19103727100225779],
            [9.824276736722938, -0.1942932963494714],
            [9.819824504694234, -0.19951910345631335],
            [9.82202445697811, -0.20422142191550025],
            [9.82078071640603, -0.21019691501657378],
            [9.823391205473586, -0.21736036952683524],
            [9.821399179910554, -0.22637881168260768],
            [9.81863038839594, -0.2306249613537432],
            [9.820988246981539, -0.23489303273385653],
            [9.821155113902371, -0.23971310205567467],
            [9.818589814053572, -0.24293577153516355],
            [9.819156986024657, -0.24750346023046993],
            [9.815731072973959, -0.2546788410739672],
            [9.815895291307385, -0.25815351375046464],
            [9.80968442129891, -0.2614604935707586],
            [9.806406622904476, -0.25687708687837923],
            [9.804884638222504, -0.2511417567963508],
            [9.80147982692029, -0.24981119804394233],
            [9.798364156773022, -0.2514283150014689],
            [9.805467297093406, -0.2636684121420607],
            [9.8123445136305, -0.2636374311650138],
            [9.811323311543768, -0.26803395838206867],
            [9.822115659356152, -0.2808494966144223],
            [9.82005520936214, -0.28520092094174204],
            [9.811028354479685, -0.28711007979994374],
            [9.808267475684762, -0.2853743138591441],
            [9.808266795476207, -0.27829599453136744],
            [9.803633982145422, -0.2835662250423465],
            [9.79344154451883, -0.28842302555202237],
            [9.789708515171522, -0.2808602274193148],
            [9.785295842979728, -0.28513128486657496],
            [9.782695688852314, -0.28176614707188263],
            [9.77878548755745, -0.2805888987609686],
            [9.779349493161607, -0.28846697432823093],
            [9.777749511673038, -0.29112815099192474],
            [9.77267683877973, -0.294514699232002],
            [9.773145975085711, -0.3018357272507083],
            [9.769535779965661, -0.3035167320466342],
            [9.76634898530908, -0.30156043539258526],
            [9.763892559464011, -0.2919781124963251],
            [9.764237964942243, -0.2884475331288493],
            [9.760676098589693, -0.2815725020004716],
            [9.761853657924215, -0.27451614366896565],
            [9.759354956370121, -0.2730378187638759],
            [9.752071272125065, -0.2661929877799843],
            [9.746611063063673, -0.2664918959676493],
            [9.742622643635961, -0.2701450254523474],
            [9.738693262413534, -0.278192329428352],
            [9.736545299432617, -0.27905379979192757],
            [9.731831812467831, -0.27689130600189577],
            [9.72669567394953, -0.26977531723858406],
            [9.720433890327305, -0.2635891831061],
            [9.716119305248743, -0.2633308571441523],
            [9.706000077770366, -0.2654621552412747],
            [9.701634570680099, -0.26740559496200333],
            [9.695119494301274, -0.2726964670843345],
            [9.690134399755438, -0.2716137729981676],
            [9.685533387908842, -0.26019087249181844],
            [9.67831484008705, -0.2574909374202196],
            [9.673447702934272, -0.2571893729747939],
            [9.665850444809676, -0.2623451174113534],
            [9.660910243822185, -0.26765904325778417],
            [9.653064647061708, -0.2698188003736104],
            [9.646404326791078, -0.26682949461849265],
            [9.641872883271926, -0.2582342225406741],
            [9.63697678454434, -0.2546185445655656],
            [9.633006541810216, -0.25399111523840634],
            [9.62238693664966, -0.25973169993981043],
            [9.616524721674281, -0.26758377371161046],
            [9.613325755704105, -0.26561398728997593],
            [9.612071663375444, -0.25960217156427245],
            [9.613575609944021, -0.256446261281475],
            [9.61369101320903, -0.24869740326858145],
            [9.611299874364063, -0.24424012956335028],
            [9.605206105359155, -0.23751714977087118],
            [9.605683798287618, -0.2308773346774851],
            [9.602322011352898, -0.22705416601499634],
            [9.594517842550815, -0.2321243562343886],
            [9.582345139052407, -0.2427567246911828],
            [9.57674901243017, -0.24406243749493067],
            [9.559477125444637, -0.25392981368186257],
            [9.555093537927325, -0.25888131506405404],
            [9.550798486798048, -0.25809123496504727],
            [9.550067773074053, -0.254245771026594],
            [9.546806527326755, -0.25398330032935496],
            [9.547071381717569, -0.24928359208143566],
            [9.551001311641516, -0.2449267171368747],
            [9.549203925306038, -0.24329753906671084],
            [9.549605594177207, -0.23362586301593752],
            [9.547456377246446, -0.23131155043530852],
            [9.556275185753034, -0.22997159338592013],
            [9.55672999410882, -0.2254355111826299],
            [9.55439383280906, -0.2221809142242794],
            [9.54824593535086, -0.21993662833969663],
            [9.549237908991211, -0.21526825817407413],
            [9.55385916408137, -0.21499633762249123],
            [9.552200137650903, -0.20396094988046415],
            [9.555704826712994, -0.20398734375865216],
            [9.562569170397806, -0.20108137868783227],
            [9.5673743323217, -0.19397664358652209],
            [9.559326725871328, -0.1953412674286077],
            [9.558179643827064, -0.19218115432795457],
            [9.559814109962355, -0.1892290234921169],
            [9.564400720931689, -0.1876001237741373],
            [9.566108036189867, -0.18483925540403764],
            [9.565100274995556, -0.18126822884507215],
            [9.559291409344782, -0.183003426365434],
            [9.555870224675969, -0.18147333659588727],
            [9.557405536000928, -0.17647203317730267],
            [9.557135954769997, -0.16954464531523822],
            [9.553313021769439, -0.16344981603022204],
            [9.552401823614813, -0.15852166671551268],
            [9.555672237104636, -0.15515284857232595],
            [9.555694509252367, -0.15191445803476009],
            [9.553200418094368, -0.14834276964616797],
            [9.581784871723281, -0.12626054257701871],
            [9.577521180875044, -0.12356415650220938],
            [9.577214020614583, -0.11986579235605976],
            [9.572238281611742, -0.1129501423287318],
            [9.577585961076448, -0.10542047275925111],
            [9.576066673747729, -0.0999124795426127],
            [9.576516837417508, -0.09643572890344772],
            [9.574597052203428, -0.09081454215771419],
            [9.574757894719053, -0.08072907599270267],
            [9.572868649053627, -0.07859936776490667]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.14726614622292,
          "lat": 37.970795708347595
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21049"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00516871"
      },
      "bbox": [
        9.546806527326755, -0.3035167320466342, 9.837897936771729,
        -0.010508712163161849
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.499450522177834, -0.4446175138051333],
            [7.507606574075968, -0.44103628956146185],
            [7.510168102314864, -0.4414128935936653],
            [7.525726336258072, -0.4387612282259017],
            [7.5401979179289595, -0.43577914935056544],
            [7.546115966382946, -0.43305044215663846],
            [7.557639836026134, -0.42260402734888053],
            [7.5656682448119374, -0.4106960326774171],
            [7.568083837458279, -0.4047391507412429],
            [7.573014207877399, -0.39797608194192785],
            [7.5755808178329, -0.39620524519568506],
            [7.584274067218465, -0.3834727656153906],
            [7.589460064203632, -0.3781059706896428],
            [7.594573474669753, -0.3748447563988869],
            [7.60498232856192, -0.3700545908692504],
            [7.613542198390595, -0.3639617287931177],
            [7.621389175237562, -0.3639814526901609],
            [7.629983967100558, -0.3689215116737934],
            [7.636201520010226, -0.37138779446705505],
            [7.641005307306113, -0.3804649796897114],
            [7.644699899566637, -0.3915145878847154],
            [7.6525066306193406, -0.40242574546191406],
            [7.651640197993661, -0.40437282271803404],
            [7.65565728698053, -0.4101220224466109],
            [7.665696326174446, -0.4263919375537724],
            [7.67829541325427, -0.44496472986178837],
            [7.692550615952826, -0.46011606801844934],
            [7.695305387016664, -0.46212646416957137],
            [7.70263730786712, -0.4631255898747165],
            [7.7055343659417534, -0.4623598929421761],
            [7.71329738854988, -0.4562782122188595],
            [7.7245985280194835, -0.4448580054824072],
            [7.728797565392523, -0.43982354807394397],
            [7.732561613134352, -0.43749915434055764],
            [7.738707371995203, -0.4370029512800013],
            [7.748336469695037, -0.4379254565632805],
            [7.7569764739993055, -0.4395521718739895],
            [7.760938370491251, -0.44330817651862153],
            [7.7624167737258505, -0.4473864208360517],
            [7.762691901238711, -0.4550304445050109],
            [7.760472131192076, -0.4641485504087649],
            [7.754619819174647, -0.4816307204036535],
            [7.752644551012968, -0.4944329068655902],
            [7.754029046829203, -0.5016396994698112],
            [7.757202649275056, -0.5069786136073323],
            [7.759677698542658, -0.5083945533377305],
            [7.757468516302943, -0.5123444269143159],
            [7.751942774202985, -0.5159604726900782],
            [7.747023032799658, -0.5600419103068608],
            [7.8039950917394165, -0.6942688124941697],
            [7.7903468419981685, -0.688648771591452],
            [7.692576440218686, -0.6485173258312235],
            [7.6390163251792345, -0.6264700383939998],
            [7.6387053015830455, -0.571884771189065],
            [7.616172339428625, -0.5453228284316024],
            [7.605160076480334, -0.5251939279174191],
            [7.583950998156427, -0.5318334791156161],
            [7.580307371769161, -0.5322053102374193],
            [7.579298533334179, -0.5371807755919471],
            [7.573796714666823, -0.539510229621393],
            [7.5690132882844905, -0.539103348387115],
            [7.559945552500468, -0.5329222426865197],
            [7.558361628053442, -0.52789959849143],
            [7.561081837048466, -0.5238589874620221],
            [7.559304478187441, -0.5196532652323403],
            [7.5619652298044855, -0.516176214120844],
            [7.563108410950711, -0.5073657787846979],
            [7.561352859680969, -0.5027644201658479],
            [7.5677416238889155, -0.4957327324675971],
            [7.57036629374761, -0.4867228899155463],
            [7.564066569999968, -0.4871221144632921],
            [7.557463974029591, -0.48393849525346383],
            [7.558778577268704, -0.4743284582936661],
            [7.554555754115652, -0.47555525699262435],
            [7.551848348618772, -0.47380528743396905],
            [7.555414483792803, -0.4689663537691195],
            [7.551191921142052, -0.4662955465453995],
            [7.543027035508605, -0.4645337174149414],
            [7.537876863716817, -0.4617491799940184],
            [7.534396705819921, -0.46320913970764666],
            [7.525803637441489, -0.4692363999390552],
            [7.518338973115044, -0.4755362763996832],
            [7.5081603714541085, -0.47731621975209876],
            [7.500185031370599, -0.47974018867817325],
            [7.496135939567346, -0.4782529139878742],
            [7.498497313470828, -0.46752363259947494],
            [7.501148635296417, -0.4654799352236517],
            [7.501026417131153, -0.46108011797500964],
            [7.504414891710505, -0.45619179941741883],
            [7.501167262559605, -0.45060863502361614],
            [7.499450522177834, -0.4446175138051333]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.77789404505869, "lat": 37.84145963573705 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21091"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00516892"
      },
      "bbox": [
        7.496135939567346, -0.6942688124941697, 7.8039950917394165,
        -0.3639617287931177
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.863618851708456, -1.1728247633290774],
            [9.867129459499278, -1.1663307823888274],
            [9.872893543464896, -1.1627981985368507],
            [9.87385499341847, -1.1574766734951236],
            [9.880223330487, -1.1515106775651243],
            [9.884680569715185, -1.1495398876209706],
            [9.888446896470638, -1.1522012755167381],
            [9.890590924906869, -1.1487700799304446],
            [9.900330546521113, -1.1470638612512394],
            [9.902174219351027, -1.139581758385697],
            [9.906232106187456, -1.134238025169989],
            [9.910624218336242, -1.136214715042059],
            [9.913110954154329, -1.1328817187962983],
            [9.916475008388067, -1.1366611642394506],
            [9.9199232399857, -1.1377871951063514],
            [9.924437303835223, -1.1334458277087356],
            [9.93112443545161, -1.1383499802427584],
            [9.94194659284803, -1.1384107919896829],
            [9.946630121492355, -1.13468141670993],
            [9.94992728993957, -1.1386899311189598],
            [9.954528144144096, -1.1393392125648278],
            [9.958496464126258, -1.1377566554822192],
            [9.965106647243168, -1.1383184977120975],
            [9.969644718460977, -1.1272911485564006],
            [9.976585126155213, -1.12405052022416],
            [9.981074352831936, -1.117460316450587],
            [9.984211793958284, -1.1164075833649207],
            [9.98123580135405, -1.112078513822049],
            [9.981067502089994, -1.105594871431236],
            [9.983520178527087, -1.1032922163443923],
            [9.986199196906941, -1.0867125044250794],
            [9.986422937791566, -1.0754135973388055],
            [9.991172195227154, -1.074708047753535],
            [10.000099355624613, -1.077707811408646],
            [10.004402662127132, -1.0713508558443698],
            [10.008345510139355, -1.0681775002947655],
            [10.010178494862785, -1.0647927353095252],
            [10.01501379376078, -1.0652287276291155],
            [10.021395825467211, -1.058423917217299],
            [10.022161943090666, -1.053425929571612],
            [10.024054466218676, -1.0517612830233019],
            [10.034813397369234, -1.0518937779096973],
            [10.036985321088595, -1.0576892468512655],
            [10.037521985902151, -1.0627155786998967],
            [10.046997702455604, -1.0606387577979293],
            [10.051952876527453, -1.06328403990453],
            [10.054813907947976, -1.059596692923216],
            [10.058917015529314, -1.062616851980486],
            [10.062049487458195, -1.0627713167235668],
            [10.058441504194533, -1.0691129962983699],
            [10.058248052002444, -1.0716347051323394],
            [10.065896625444797, -1.075796198491575],
            [10.07157906952066, -1.0741805248792153],
            [10.07764172863378, -1.0693894122837373],
            [10.079102116129006, -1.0670166383191235],
            [10.089295733083109, -1.0640733138306953],
            [10.093764998042255, -1.063606965664142],
            [10.09786094250306, -1.060413715654461],
            [10.102544844540306, -1.0597897901029139],
            [10.10220934403292, -1.0660578807338636],
            [10.099557744374208, -1.0676110344174092],
            [10.099513067475915, -1.0745346524389106],
            [10.102892978824315, -1.0770629203971271],
            [10.104777326412274, -1.0817551952329316],
            [10.111428711686795, -1.0774948272593068],
            [10.11190874621332, -1.0743971884805399],
            [10.116043156766734, -1.0750142950763943],
            [10.122323026466187, -1.0680065739269708],
            [10.126932066479114, -1.0682388546057067],
            [10.132081850289884, -1.0728839254487792],
            [10.13775537166267, -1.0761159832377465],
            [10.13629031501839, -1.0865785512259918],
            [10.137960139500573, -1.0887521213040503],
            [10.1428300327387, -1.0900970224949031],
            [10.148302497198243, -1.0885455564874604],
            [10.150488664846996, -1.096180569562529],
            [10.157574764184382, -1.0941897830731673],
            [10.159483151015806, -1.0983812025372697],
            [10.162408259495956, -1.0973686310271709],
            [10.167174882700927, -1.1028311863385145],
            [10.170933966312095, -1.1021811229576164],
            [10.172705276054927, -1.1053008573365142],
            [10.178619315640017, -1.1063947131002934],
            [10.180940606499219, -1.1041447879910806],
            [10.18456113246944, -1.1076382322755964],
            [10.188601360827247, -1.1057768482915757],
            [10.18953414851265, -1.110450228997042],
            [10.199370020192456, -1.1088900300570252],
            [10.204321025710502, -1.1125408637125997],
            [10.210700458023036, -1.1203998215258182],
            [10.213633528353526, -1.120779045739463],
            [10.21701181850232, -1.1238844128254084],
            [10.22196058310184, -1.1205932173314084],
            [10.230483810738383, -1.123030923395635],
            [10.236092644434411, -1.1187502358795918],
            [10.239548054922633, -1.1207368866537277],
            [10.240793049120004, -1.124881406836384],
            [10.245210188106567, -1.12707675416783],
            [10.253498034422158, -1.123248738283889],
            [10.257959247521036, -1.1223179700789565],
            [10.25753706223978, -1.1265183055643777],
            [10.260380735885935, -1.128482603957522],
            [10.264345584499106, -1.1362801903453237],
            [10.268860814969061, -1.1391670121120552],
            [10.272610336612768, -1.1359862099693794],
            [10.275555612928034, -1.1365560182216656],
            [10.275961213243555, -1.1412473630099114],
            [10.278912247202522, -1.1433517182500192],
            [10.278748534556444, -1.1474113232260414],
            [10.275476130598594, -1.1494452836723092],
            [10.273130510808702, -1.1542651099713028],
            [10.275512787503974, -1.16097517219152],
            [10.275388751869503, -1.1637669580972492],
            [10.271369589885346, -1.1685846225923728],
            [10.271296801204548, -1.1726127718162365],
            [10.264939441752716, -1.1730272834310091],
            [10.259538112517033, -1.1798174587790509],
            [10.257156177864209, -1.178217967953932],
            [10.254170084295584, -1.1825822629325078],
            [10.249857430555581, -1.183942820903687],
            [10.244775672887693, -1.1922667156922366],
            [10.243276435329586, -1.1971350015360134],
            [10.238768170355899, -1.1972407024296023],
            [10.234461191184012, -1.1942636087632816],
            [10.231472766621094, -1.1961521409797427],
            [10.226257205159728, -1.205661557740193],
            [10.228482335534082, -1.2085194133885846],
            [10.226444826853886, -1.2126929586506017],
            [10.228179631763721, -1.2173791503862235],
            [10.220838394481907, -1.2219371387369662],
            [10.212048460339979, -1.2215201238116968],
            [10.210005039473497, -1.2293503726678816],
            [10.197901832609531, -1.2332045496612436],
            [10.196606315454805, -1.238981215564005],
            [10.194014269097496, -1.240809092734738],
            [10.194483810059504, -1.2452411239743932],
            [10.192956615662117, -1.249796737729283],
            [10.196416190223546, -1.2528631865555708],
            [10.18793875727498, -1.2548666326995144],
            [10.182255175540233, -1.254020076313851],
            [10.17962162574836, -1.2565184323719905],
            [10.181664503300073, -1.2602022741718237],
            [10.180347604100414, -1.2659230635734826],
            [10.177293802041818, -1.270524881952173],
            [10.172159371654333, -1.2710616444408158],
            [10.168136224765624, -1.2779691291694566],
            [10.1643736982302, -1.2802936765023243],
            [10.160450747693213, -1.2849574554568597],
            [10.160911486028922, -1.2921070444922138],
            [10.157602808481407, -1.2976109689969855],
            [10.155713710044177, -1.2943606465518547],
            [10.150255948260934, -1.2950790792261568],
            [10.148361324505093, -1.2897529873752325],
            [10.140841198988147, -1.294068128933962],
            [10.138051467970902, -1.2934408513063478],
            [10.132597045238017, -1.2990541238191162],
            [10.127336706124394, -1.2951775452256789],
            [10.123701787072422, -1.2976980332157817],
            [10.121257898357944, -1.3015901206181193],
            [10.116198982509113, -1.3144226289353242],
            [10.11935899935172, -1.3268453526058075],
            [10.117382922204815, -1.3301464452117655],
            [10.117386159946932, -1.3342301471908948],
            [10.111083705707166, -1.3389877610876724],
            [10.109733001139096, -1.3441282915079942],
            [10.111905136434283, -1.34711606814425],
            [10.112400008401195, -1.3526638356680722],
            [10.104891953816784, -1.3582965603335564],
            [10.097492207995305, -1.3595089831309708],
            [10.095885429914741, -1.3684717006935507],
            [10.098165610761177, -1.370833287525568],
            [10.09620787577749, -1.3773040808142603],
            [10.09906455576003, -1.3796281069465028],
            [10.097111933558216, -1.3836853759986039],
            [10.093996151651755, -1.3847965507369204],
            [10.092973649132897, -1.3898330318598235],
            [10.088429183113531, -1.3964385794628924],
            [10.081288271300153, -1.4000049260728245],
            [10.077193087068409, -1.3948882573762018],
            [10.072242337991277, -1.3918136149045583],
            [10.067972228362432, -1.397587756930644],
            [10.067125407782404, -1.403796698354276],
            [10.069480143687672, -1.407789839971603],
            [10.065770374447792, -1.4125433979307411],
            [10.06439500141113, -1.41815140149917],
            [10.066421639366471, -1.4204914367405588],
            [9.997477977335997, -1.38861442434998],
            [9.993760261386962, -1.3665690824639838],
            [9.985300701950313, -1.3558979981112145],
            [9.978483232942464, -1.35480443535129],
            [9.974859422743975, -1.3594499050549393],
            [9.97157160174835, -1.3581207082736897],
            [9.969769971273536, -1.354115958126797],
            [9.969734916933028, -1.3485040483203155],
            [9.972619798678592, -1.3427113456498463],
            [9.976512765085351, -1.338661424494439],
            [9.976129131049253, -1.3347532142043745],
            [9.972825476691662, -1.3326447581839866],
            [9.971779327866878, -1.327273151211724],
            [9.97335515486708, -1.3210930556390492],
            [9.968310883001534, -1.317444467718837],
            [9.959219231573334, -1.317989753242617],
            [9.955747042297764, -1.3190206010328782],
            [9.953749421350363, -1.3086639351580491],
            [9.94718198618932, -1.3038684101991118],
            [9.941356533998361, -1.3079116251200886],
            [9.931560145638048, -1.3039899962741548],
            [9.931660442070983, -1.3003022994099434],
            [9.928835927052766, -1.298552751488326],
            [9.928385743854122, -1.294928631813667],
            [9.922438483178528, -1.2894972210682998],
            [9.920847009974596, -1.2904209190860343],
            [9.916135809753255, -1.2847106447346488],
            [9.918734579056936, -1.2823084890794028],
            [9.918317499169621, -1.2750916175893074],
            [9.910433021931611, -1.2725365618081277],
            [9.90713280425681, -1.269412907408002],
            [9.906103306945191, -1.2742241512677352],
            [9.89753419400815, -1.2728958333545812],
            [9.8960142612862, -1.2628066658902144],
            [9.899878807754488, -1.257163538446434],
            [9.895130306707939, -1.2564952401059315],
            [9.892812573373163, -1.2522937531992344],
            [9.893156679447687, -1.2486812032291994],
            [9.888694491282171, -1.2362048170079374],
            [9.884774113911089, -1.2350133965160628],
            [9.878269377442399, -1.2287734940323989],
            [9.875175657003195, -1.2234321945650852],
            [9.87700349624428, -1.2191321751579842],
            [9.872558676767452, -1.2065073723610535],
            [9.875741289436576, -1.2020447212511842],
            [9.873796916007464, -1.1946233404651856],
            [9.868308609933845, -1.1875812439870843],
            [9.861984140915055, -1.1747480394203156],
            [9.863618851708456, -1.1728247633290774]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.85405015738598, "lat": 36.89067639358747 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21121"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00516907"
      },
      "bbox": [
        9.861984140915055, -1.4204914367405588, 10.278912247202522,
        -1.0517612830233019
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.286714153865516, 0.5748818004506191],
            [10.29065652039426, 0.5800442611130415],
            [10.295600950223022, 0.5814039237042502],
            [10.301723345563463, 0.5874884560789005],
            [10.312024364611291, 0.5878660390846899],
            [10.317095465452264, 0.58624680616174],
            [10.327990411894948, 0.5811803341714392],
            [10.335479038589948, 0.5799954565752987],
            [10.356437621481374, 0.585330733898422],
            [10.373489538655848, 0.5872908420183272],
            [10.381031665883846, 0.5946846298192887],
            [10.386098515938487, 0.6021437430629791],
            [10.39095014784818, 0.6165869352358182],
            [10.391931385121179, 0.6309421712726748],
            [10.394585030351012, 0.6383077367463796],
            [10.398023742607355, 0.644495561647],
            [10.404629057617262, 0.6511352425206987],
            [10.418299642556802, 0.6568489448349769],
            [10.43246734477564, 0.666824042044931],
            [10.440116576365513, 0.6748579262737064],
            [10.446647205606089, 0.6884800710369537],
            [10.448523984618923, 0.6969496161523493],
            [10.453046199512984, 0.706936765760717],
            [10.455629539724534, 0.7032540137151359],
            [10.451123249349665, 0.6799821968606365],
            [10.455381382842113, 0.6725205427137818],
            [10.459589251948149, 0.668958490612975],
            [10.458140920129264, 0.6660099753340434],
            [10.464130935854685, 0.6648156938614668],
            [10.461881625041615, 0.6615287771268796],
            [10.45712719637834, 0.6602869246667809],
            [10.455624582924003, 0.6458636574875214],
            [10.451452233320955, 0.6420891302422146],
            [10.448745698104062, 0.6434352011687917],
            [10.445062926087756, 0.6360746692101507],
            [10.449777114172312, 0.6281663236719196],
            [10.446714462875262, 0.6184438684455076],
            [10.439973270652034, 0.6174693771916275],
            [10.440314607186398, 0.6149601761922024],
            [10.435562307719385, 0.6110962462224963],
            [10.434755308046658, 0.6047783975156734],
            [10.437816298752296, 0.5980768189056591],
            [10.432163496067746, 0.594214343399105],
            [10.430595312622655, 0.5865573191381932],
            [10.434523499644884, 0.5852714774657385],
            [10.433996540868415, 0.5792691759002583],
            [10.440189931658159, 0.5721328783285058],
            [10.438824560811737, 0.5672733391438773],
            [10.432828227317525, 0.5639490800960179],
            [10.42830329405854, 0.5508739203437961],
            [10.42607863655376, 0.5486662367894934],
            [10.423296836710556, 0.5386078565191065],
            [10.421607911295254, 0.5271722794470772],
            [10.41833952754377, 0.5235669419374103],
            [10.417539892546401, 0.5199755928479843],
            [10.413914231649105, 0.5175640256217389],
            [10.413180748299155, 0.5116052907789083],
            [10.40918504143608, 0.5072705073507732],
            [10.39955546477435, 0.5035228608624688],
            [10.397213001930334, 0.5057341878047269],
            [10.391017375486342, 0.4994023305187223],
            [10.39119944544081, 0.49103633639606786],
            [10.385301353527714, 0.48223171944158394],
            [10.382952281227471, 0.4773695856359527],
            [10.378608146103412, 0.47629221334929545],
            [10.379414851811992, 0.4710509425455741],
            [10.376366741314518, 0.4672405498241532],
            [10.371407257878813, 0.46911880034001696],
            [10.368864893887958, 0.46658698032185675],
            [10.36664233254756, 0.4608837257086779],
            [10.363914655843834, 0.45883241602394065],
            [10.366802522163947, 0.45593785294425926],
            [10.367179663525372, 0.44758127091616173],
            [10.365133260243546, 0.44160959197932687],
            [10.367820792545034, 0.4401612750991496],
            [10.368749622857194, 0.43440966802437],
            [10.364647616353134, 0.43360476738623166],
            [10.363303908381056, 0.42902361881417983],
            [10.36079479333655, 0.42873245726228837],
            [10.361729939199822, 0.42044642816878464],
            [10.360052546854357, 0.4173241993964824],
            [10.34994329230432, 0.4166746346496526],
            [10.351373529245485, 0.41016137385160856],
            [10.356363637610187, 0.40394359171877064],
            [10.354102862671304, 0.40192765372867684],
            [10.350323899730066, 0.40228534871338445],
            [10.347510672799709, 0.39329447196178213],
            [10.343124552723094, 0.3935724983968784],
            [10.341898846882636, 0.3883252671267283],
            [10.338095720380727, 0.3885978686061509],
            [10.335525612336756, 0.3861414020100223],
            [10.338061506917764, 0.3828260179999605],
            [10.3367347463075, 0.37596860715613356],
            [10.340153084807131, 0.3704940806049846],
            [10.338693260733104, 0.36353510505836345],
            [10.342532792317849, 0.3487339456524732],
            [10.343300950863258, 0.340046201204518],
            [10.34627035394168, 0.3343102761670276],
            [10.346656586309292, 0.32986987546727686],
            [10.34322216756861, 0.31522197479514047],
            [10.34614352857061, 0.3077624772676098],
            [10.347963800014545, 0.30839663485568547],
            [10.353060634956739, 0.3046254627745732],
            [10.352371954088703, 0.2998053607016039],
            [10.345516088484121, 0.2940899076761657],
            [10.340990723235306, 0.2925709640635187],
            [10.34075180760906, 0.2892658473075423],
            [10.332218275491249, 0.2863628886529945],
            [10.327851321860477, 0.28687450891368504],
            [10.326336945220925, 0.2825763482120912],
            [10.321489180479203, 0.2819374036400681],
            [10.31946314354186, 0.2795370211723893],
            [10.31467874465622, 0.27916588913720475],
            [10.305348487572898, 0.2836447969582297],
            [10.296930833835848, 0.2838621521526079],
            [10.292987439573364, 0.2827658661262461],
            [10.290265039230537, 0.28553423526704924],
            [10.280455069678395, 0.28010447382855275],
            [10.278424357304347, 0.27102122373558474],
            [10.274932831036011, 0.26772991969169624],
            [10.269798014508147, 0.26832855291527224],
            [10.261325913696874, 0.2700262296968063],
            [10.25794087637581, 0.2691330455320094],
            [10.255587136544639, 0.2713406336353725],
            [10.256111313227748, 0.2746810860316443],
            [10.250793777635346, 0.2758209006507286],
            [10.250406683459651, 0.28635630811451784],
            [10.245438826827213, 0.2942599167254778],
            [10.241766515974076, 0.29486829324328084],
            [10.237419363325522, 0.30068117366067976],
            [10.235652741836017, 0.30757748262029894],
            [10.231927626724746, 0.30930898252366273],
            [10.224238951273053, 0.3101551075323739],
            [10.223842313227099, 0.31299844167956065],
            [10.215729020274381, 0.3222267665169639],
            [10.216038712586418, 0.32454999076882873],
            [10.212679182267282, 0.33247284667254484],
            [10.205172884740374, 0.3378913547681766],
            [10.201377213891359, 0.33726048758399124],
            [10.19352201590596, 0.32812451130458814],
            [10.190083881738591, 0.3288997572575033],
            [10.184192175493346, 0.3267096334799504],
            [10.180509585568595, 0.31864045657304874],
            [10.175649992467804, 0.31921535790678096],
            [10.17036808611837, 0.3207195380799422],
            [10.170495885126789, 0.3251726538914185],
            [10.164219138521108, 0.32918136197023706],
            [10.162801785702378, 0.3349380394124806],
            [10.15940422525107, 0.33240339015601217],
            [10.154288468505277, 0.3364516191291702],
            [10.14721722238029, 0.3391451200529321],
            [10.138880143792639, 0.3347097422419739],
            [10.129821433942224, 0.34368513437060627],
            [10.123555853202344, 0.34580578187587824],
            [10.121265727862976, 0.34178250284392897],
            [10.11773946522595, 0.3389263249368214],
            [10.11314652807977, 0.3419857615838473],
            [10.113710375361826, 0.3474981109187362],
            [10.111802107526227, 0.3482291450475534],
            [10.10671834325282, 0.3451547487441759],
            [10.102336347088874, 0.34700711017307934],
            [10.094104571603392, 0.34726576221764277],
            [10.083687405409389, 0.35278741053441437],
            [10.072136558246969, 0.35480446555830136],
            [10.069059054985974, 0.356723127759698],
            [10.069181312923284, 0.3629374735888928],
            [10.07351299448778, 0.3694250713223928],
            [10.070852481776482, 0.3724596369822866],
            [10.069099230126058, 0.38013846928261236],
            [10.07034143887717, 0.3820891326397074],
            [10.065515301061344, 0.38857886246330514],
            [10.062867774074324, 0.3955627424654246],
            [10.058639353844324, 0.4010955060760492],
            [10.05783998357575, 0.4053066205638904],
            [10.053435684349687, 0.412298252967671],
            [10.04624655599033, 0.41861299698128307],
            [10.048334077667327, 0.4226132503440677],
            [10.043003157146252, 0.42205849337257284],
            [10.043852807914368, 0.4274869989990905],
            [10.040961164128854, 0.4273653979567134],
            [10.039708601472817, 0.42389341530335584],
            [10.033940976057075, 0.42527094931960596],
            [10.027372167851935, 0.423756706490712],
            [10.023198692724339, 0.42678784558878535],
            [10.025199036909921, 0.43090421509631854],
            [10.024373419450331, 0.4371262732988887],
            [10.02204854877881, 0.4417528192347608],
            [10.018804522663824, 0.4411052226068094],
            [10.016248219798907, 0.4367594838804491],
            [10.01138738731449, 0.4438071551910188],
            [10.013362585702918, 0.5316873571723941],
            [9.998153410701006, 0.5536235014159763],
            [9.994333225091633, 0.5546962314983239],
            [9.996350899207572, 0.5669881875743585],
            [9.99672464453357, 0.5851077408326761],
            [9.99813101545653, 0.5907375698629106],
            [10.002669301775276, 0.5994942162997634],
            [10.011869376505684, 0.6053662035081576],
            [10.015596479698562, 0.6069168621949094],
            [10.021504057998404, 0.6065969204496887],
            [10.028271600103782, 0.6124189517702829],
            [10.045222500811281, 0.6187800498597593],
            [10.059612470641563, 0.6267286817630661],
            [10.071403453338682, 0.6316622023056111],
            [10.080769801764804, 0.6338557316720889],
            [10.08736803098636, 0.633373808306844],
            [10.093981274646637, 0.6317425628915947],
            [10.103099080347983, 0.6277860844885575],
            [10.108901500368555, 0.6243906444265392],
            [10.12495745607202, 0.6116185702684912],
            [10.13359142632262, 0.611231193867067],
            [10.14181477829048, 0.6084302632718268],
            [10.146966120689552, 0.6083182453696192],
            [10.162580980199921, 0.6094450127230778],
            [10.169088788604668, 0.6083467929271793],
            [10.190445999565345, 0.607805051908126],
            [10.204934909695046, 0.605020373201875],
            [10.213372096560166, 0.6015363089607795],
            [10.227092723597739, 0.5948825956689675],
            [10.23767303069474, 0.587962638160673],
            [10.242623612350156, 0.581623904983154],
            [10.246332128155839, 0.5672762657186725],
            [10.249206792914288, 0.5607334931556146],
            [10.254677562756052, 0.5554287411095105],
            [10.262652966458177, 0.5512677319851833],
            [10.268818008089188, 0.5504766628534249],
            [10.27435124728516, 0.5539238969971371],
            [10.286022010734575, 0.5716570448488769],
            [10.286714153865516, 0.5748818004506191]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.37796324603399, "lat": 38.53150605362243 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21135"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00516914"
      },
      "bbox": [
        9.994333225091633, 0.26772991969169624, 10.464130935854685,
        0.706936765760717
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [3.9492383235120982, -8.618379889254566],
              [3.9520733629067912, -8.61944182118445],
              [3.962198019052518, -8.583550091958415],
              [4.00025747704767, -8.582118551361168],
              [4.0106695476541985, -8.596911476072243],
              [4.027635070987901, -8.585747667805217],
              [4.078243702544996, -8.607170721237571],
              [4.094107063257256, -8.583685550325999],
              [4.091702532151259, -8.58066513830302],
              [4.104619224886815, -8.569868269168474],
              [4.110012621549926, -8.564370933423644],
              [4.115646461882629, -8.560465095799842],
              [4.125980820316846, -8.558512059770658],
              [4.123136068736679, -8.55312795784838],
              [4.118727828916984, -8.55338471641428],
              [4.121065377011769, -8.54136702608995],
              [4.126744890410913, -8.540033051306196],
              [4.132075200007831, -8.537004288838881],
              [4.137064225246257, -8.53131689053426],
              [4.145653921255527, -8.530126163967854],
              [4.149243959732745, -8.526447745302228],
              [4.153846147553835, -8.526056739333962],
              [4.166460283104463, -8.530662969225085],
              [4.1709167642806255, -8.529935551814967],
              [4.174052867450925, -8.526413101585256],
              [4.178586534452168, -8.52741454903967],
              [4.180249784705668, -8.5312733768032],
              [4.189063780762987, -8.533992476486059],
              [4.190587651384558, -8.538211129622173],
              [4.195689055670007, -8.541344000600475],
              [4.198882852739709, -8.539292145590313],
              [4.199609707634539, -8.53496239223354],
              [4.203618530359708, -8.533264121484667],
              [4.207173274041759, -8.53597145831466],
              [4.21295040154914, -8.537468998052375],
              [4.217413372117655, -8.545644005571853],
              [4.225826695580085, -8.556481131553854],
              [4.228332340808394, -8.561374769011612],
              [4.239053075696674, -8.572310316804124],
              [4.255098476874506, -8.575719619379571],
              [4.260942528137398, -8.585535515503924],
              [4.261188875168207, -8.591965900918801],
              [4.259950989909996, -8.596734707394456],
              [4.2656431170053635, -8.605687257141046],
              [4.2670677642177735, -8.609526305849931],
              [4.344489454540274, -8.605696197755124],
              [4.346935996140062, -8.605317221157852],
              [4.347980077011775, -8.59990906259578],
              [4.351245242328475, -8.598100248304052],
              [4.357189642728542, -8.597091300415206],
              [4.35822939036249, -8.588435259789483],
              [4.36348757463232, -8.580258663602267],
              [4.465670622466687, -8.574632283906993],
              [4.467685109099799, -8.578623735090295],
              [4.480873399944868, -8.572641952985375],
              [4.489878933571995, -8.570845605238013],
              [4.493817060926247, -8.573062114197304],
              [4.551773071461892, -8.56995583783987],
              [4.556030639718723, -8.57404006875635],
              [4.556528089739414, -8.578153904519295],
              [4.564096333519308, -8.58870827874523],
              [4.574213860139843, -8.596800233164242],
              [4.579459920616339, -8.597122123814522],
              [4.582671393142554, -8.589854278991865],
              [4.586364267012744, -8.585497076632723],
              [4.590305093107089, -8.584934511969886],
              [4.593585421255859, -8.589239662542484],
              [4.594046635895852, -8.595189493658927],
              [4.592197314499551, -8.601405721486179],
              [4.5864522374331465, -8.619451296926766],
              [4.58335254982295, -8.626058619400208],
              [4.575702536632317, -8.627357349967836],
              [4.56618772637046, -8.626707046174204],
              [4.5630957552622675, -8.627980514522733],
              [4.563282185328136, -8.640079781264332],
              [4.566052041023689, -8.647596829793352],
              [4.568125004580354, -8.65621411973343],
              [4.568089339087607, -8.656074189688821],
              [4.474806200589101, -8.668162774265776],
              [4.381519152232543, -8.680233069569098],
              [4.250258411346558, -8.697057012140403],
              [4.208971893438944, -8.756799332496298],
              [4.179563412621755, -8.79860404687597],
              [4.104807755788863, -8.867311641078784],
              [4.071392855887913, -8.8980930134999],
              [4.059780505408214, -8.910061006850373],
              [4.0594043560209085, -8.907945965195903],
              [4.054963704365568, -8.903236737876718],
              [4.039935779054626, -8.901840313292388],
              [4.038018692816028, -8.893449915358287],
              [4.0442935164601685, -8.890628879412628],
              [4.04676563838789, -8.888174643747282],
              [4.0468121448564505, -8.882721467260431],
              [4.058240614991877, -8.869919489141619],
              [4.059619147668803, -8.866082752464251],
              [4.060377995929265, -8.85757882293528],
              [4.0653367575009485, -8.866388104943955],
              [4.065843332683417, -8.869182612669439],
              [4.074284892436499, -8.87316664356937],
              [4.080802493133258, -8.870455665761773],
              [4.083019595881169, -8.865935905901363],
              [4.084770331519403, -8.85558541938656],
              [4.0848896405037705, -8.848025975349305],
              [4.082822414438453, -8.840074296641033],
              [4.082934558854345, -8.8358837704114],
              [4.07710978239108, -8.827201852617272],
              [4.076812070698217, -8.819815875164116],
              [4.0677924635239755, -8.821116265215537],
              [4.064087335905345, -8.82039257491594],
              [4.052090446887169, -8.82405388383567],
              [4.0494992721934775, -8.823756671065706],
              [4.039577802015359, -8.81857091073647],
              [4.032230180362261, -8.81562056597297],
              [4.026019456380568, -8.815319243101932],
              [4.015803422063347, -8.818305322672387],
              [4.01084768943606, -8.820997954485614],
              [4.004104920739164, -8.832739412098327],
              [4.001966225947633, -8.830993299466849],
              [3.9901870947052553, -8.830472292923062],
              [3.988770710150503, -8.8334915543555],
              [3.9849372118463475, -8.836126978983494],
              [3.9753335289877434, -8.830386093226698],
              [3.9635746220605146, -8.827921576889603],
              [3.9597840533200186, -8.823692154205991],
              [3.957730217322206, -8.819084800007134],
              [3.954201635832867, -8.820719093754665],
              [3.9357690894643826, -8.71721693953826],
              [3.934952720520284, -8.701577433552574],
              [3.9316003589208566, -8.687603470620157],
              [3.9294168507823017, -8.681759916621678],
              [3.9292365977155304, -8.672703752753641],
              [3.933725287169275, -8.667677912187493],
              [3.9492383235120982, -8.618379889254566]
            ]
          ],
          [
            [
              [3.9131982719343608, -9.075654978648876],
              [3.9192645947000098, -9.077244127473643],
              [3.9227096096144844, -9.07556851360171],
              [3.9242576356175505, -9.070600371918799],
              [3.923674867398925, -9.064188985097887],
              [3.9248226218165994, -9.061995273456684],
              [3.933295361986348, -9.059396998426672],
              [3.9351541970286807, -9.04961449289716],
              [3.948962534440152, -9.040738928068302],
              [3.954395789153104, -9.037781358910408],
              [3.9632389931010175, -9.041496878468857],
              [3.9699619646611946, -9.043250837414067],
              [3.9735182754621277, -9.04219394247446],
              [3.9916833743520956, -9.040090404010579],
              [3.9978137771499354, -9.037692771787336],
              [4.001572263760214, -9.031404470946516],
              [4.002888764665642, -9.021236332565667],
              [4.000559539059247, -9.015206182697904],
              [4.011457464858735, -9.0186253175774],
              [4.014419226779719, -9.015435068690046],
              [4.022436590352213, -9.01202944430917],
              [4.02483059179977, -9.014788218617577],
              [4.032943920088599, -9.020672723665598],
              [4.04336037456246, -9.020125236394215],
              [4.054646383454876, -9.018210059879916],
              [4.058773920285402, -9.022731550807794],
              [4.066360657115616, -9.023630925899951],
              [4.069814138503334, -9.02225578853095],
              [4.072001892497792, -9.017973541681119],
              [4.075057702646476, -9.019271404123865],
              [4.075073040348488, -9.026625738275682],
              [4.077748251694078, -9.03100521732],
              [4.086242195454047, -9.034733027956081],
              [4.092555800014861, -9.043133581707618],
              [4.095212002799067, -9.042405185628523],
              [4.1078588735617085, -9.045085957779238],
              [4.1085364378155615, -9.051326938730433],
              [4.111757516391445, -9.056295056807533],
              [4.118368441067153, -9.056108133391765],
              [4.127209070444906, -9.050305977169582],
              [4.131698246546069, -9.055830805020307],
              [4.1356382353621, -9.056067155334224],
              [4.134682065559256, -9.060093579080329],
              [4.134978201863422, -9.068970608354777],
              [4.136013268165551, -9.075873185907938],
              [4.142409868432473, -9.075490196713668],
              [4.141294718020675, -9.06910132720145],
              [4.144983440518414, -9.068326040360263],
              [4.149927345037826, -9.07015174603043],
              [4.153677684494602, -9.068314521620543],
              [4.166390466983908, -9.068198384837455],
              [4.168919812562844, -9.070684509042461],
              [4.1686949082219265, -9.075658396329302],
              [4.17022723561872, -9.07978021856669],
              [4.1800678853030915, -9.080058230043015],
              [4.1842272218866485, -9.0782381223394],
              [4.192230707602292, -9.071885585722496],
              [4.194234952961013, -9.080017633205982],
              [4.190861682701155, -9.083052781100392],
              [4.1909782042240655, -9.085602094830524],
              [4.172463250436576, -9.101652515528716],
              [4.163414662402405, -9.105222257009956],
              [4.14701477596433, -9.117903944122947],
              [4.140253309336317, -9.137825906929562],
              [4.141565288454754, -9.146252617940458],
              [4.14606865861847, -9.1519831045991],
              [4.14042652871883, -9.155978402962159],
              [4.130790432819449, -9.159822146432711],
              [4.125467753451566, -9.159020477808339],
              [4.121012918590497, -9.156659741680937],
              [4.115485662677811, -9.155776448102502],
              [4.10613402548015, -9.161933034927642],
              [4.100427146286386, -9.170220589279362],
              [4.091966106557245, -9.164772496156674],
              [4.078548039565255, -9.165848889564794],
              [4.072526609641269, -9.150618155358027],
              [4.0682399198265635, -9.145761963482068],
              [4.063553629623268, -9.142795359138285],
              [4.049900305371897, -9.143074088199105],
              [4.045805506026757, -9.145603370670147],
              [4.041122253424466, -9.13885045109975],
              [4.033721865506419, -9.136986346138565],
              [4.0291217000681785, -9.131901143686344],
              [4.025075341204668, -9.129314143465066],
              [4.0169739993747005, -9.129742512802245],
              [4.005096776001219, -9.124808383179689],
              [3.9997557417037113, -9.120593758161768],
              [3.995824431084846, -9.119943443081542],
              [3.9922146176073583, -9.116194795725782],
              [3.9886668246204238, -9.115525988592749],
              [3.982917498442362, -9.111782978311679],
              [3.974264641917182, -9.114324816994555],
              [3.9694144890591105, -9.111974289740962],
              [3.966683965301083, -9.107252593526978],
              [3.9573121387354386, -9.103454737801755],
              [3.9479908226269185, -9.100552145881752],
              [3.9283998125715875, -9.091140709607611],
              [3.926249951752958, -9.088296029043883],
              [3.9177990634824864, -9.084149955571817],
              [3.9148511100705345, -9.080490728797947],
              [3.9131982719343608, -9.075654978648876]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.73073761333801,
          "lat": 29.896743635507917
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22045"],
        "coty_name": ["Iberia"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Iberia Parish"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00558576"
      },
      "bbox": [
        3.9131982719343608, -9.170220589279362, 4.594046635895852,
        -8.526056739333962
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.10256684815202, -8.899113983515734],
              [6.098684302406409, -8.894758183082095],
              [6.089152323776501, -8.894985686315977],
              [6.081073750042021, -8.884768819197868],
              [6.0903295482528375, -8.886592144990386],
              [6.096764983057467, -8.893376213664126],
              [6.100594501095927, -8.895944583724807],
              [6.10256684815202, -8.899113983515734]
            ]
          ],
          [
            [
              [6.041378206574423, -8.958835735373428],
              [6.051528213719065, -8.96239804694638],
              [6.0456248114592315, -8.963918872221308],
              [6.041378206574423, -8.958835735373428]
            ]
          ],
          [
            [
              [6.004202882513691, -9.005161373021942],
              [6.007806267069768, -9.003284853709152],
              [6.012523814597769, -9.00409721617625],
              [6.01793589601159, -9.002918792845323],
              [6.024680064591774, -9.000013850023645],
              [6.032512826367148, -8.991815195873597],
              [6.036169830151482, -8.990751486817487],
              [6.040759017399103, -8.992697546557894],
              [6.047980699157069, -8.987711098807056],
              [6.0567106024232364, -8.991118913017628],
              [6.057109298030469, -8.996926673089765],
              [6.049602323686731, -8.999271543879106],
              [6.046382574797168, -9.00522000560661],
              [6.036527962494426, -9.014169064657276],
              [6.0368694306002935, -9.019162311492781],
              [6.031249044165558, -9.026396083325059],
              [6.029580834406566, -9.030807238758943],
              [6.024549693747779, -9.02848044582847],
              [6.019435482637999, -9.023395095876156],
              [6.01624304165228, -9.02217394115514],
              [6.004893878904661, -9.010745454356835],
              [6.004202882513691, -9.005161373021942]
            ]
          ],
          [
            [
              [5.985688032160344, -8.97660325283984],
              [5.988024613612745, -8.9744021236867],
              [5.997036147045106, -8.971348857852174],
              [5.998136732060457, -8.97383441547102],
              [5.985688032160344, -8.97660325283984]
            ]
          ],
          [
            [
              [5.9683508724736845, -8.989824788197216],
              [5.971039374407254, -8.986679395203586],
              [5.977049410653992, -8.991298357513116],
              [5.974526227360138, -8.995353673377874],
              [5.969045406811785, -8.992440187433896],
              [5.9683508724736845, -8.989824788197216]
            ]
          ],
          [
            [
              [5.780218953341581, -9.236029577412154],
              [5.785425896568399, -9.22985997961284],
              [5.789056456563811, -9.228195754033932],
              [5.7922231532951685, -9.230555237180061],
              [5.804546072590862, -9.2299755619088],
              [5.80742583808295, -9.234299503934603],
              [5.815100871998898, -9.237293001685561],
              [5.815084250879318, -9.238626800299919],
              [5.80497252318148, -9.242857572100515],
              [5.79603165216148, -9.244348170291595],
              [5.790519273542244, -9.242650166694085],
              [5.780118051700343, -9.237675177975142],
              [5.780218953341581, -9.236029577412154]
            ]
          ],
          [
            [
              [5.6504787047757645, -8.670964084824886],
              [5.655464249976273, -8.673805410273605],
              [5.65533415267835, -8.668402526645696],
              [5.667182156216038, -8.67600712642708],
              [5.667851344351434, -8.66048333607729],
              [5.674965889062578, -8.66272926638027],
              [5.680471385402982, -8.660279976629038],
              [5.692421490317523, -8.661287778315554],
              [5.713455240711249, -8.669555003318454],
              [5.727721460562215, -8.689794186814096],
              [5.73053186100129, -8.694548092177182],
              [5.7364031266158895, -8.692982390469437],
              [5.744210670482309, -8.70967109830241],
              [5.751404067929123, -8.726355297263183],
              [5.761659265934825, -8.737442129185508],
              [5.767532615122997, -8.74288087333924],
              [5.767040118019731, -8.750433694506096],
              [5.771579740486149, -8.752555535460749],
              [5.771987249170745, -8.755802030786644],
              [5.776516012473417, -8.762205542627342],
              [5.780440814750249, -8.764347241280175],
              [5.7852438165796025, -8.76403532838777],
              [5.809943619673766, -8.754321664010739],
              [5.819801478163076, -8.753090130324622],
              [5.828184119634572, -8.755579953317007],
              [5.834431371356675, -8.761190896695307],
              [5.841673248478424, -8.770432581620838],
              [5.8502467694401235, -8.7794375141372],
              [5.846010953328131, -8.78595856253571],
              [5.847116884043766, -8.791987296766928],
              [5.857922837855451, -8.796013658821392],
              [5.867413041537563, -8.796120714431154],
              [5.875606288848549, -8.792442391773498],
              [5.886816113957738, -8.79309441766672],
              [5.8965133289500296, -8.790987715933708],
              [5.909146574503702, -8.79136152168393],
              [5.921860172429056, -8.795077629174921],
              [5.928557899729027, -8.803593494988856],
              [5.934221601704223, -8.808897599714744],
              [5.939327435158721, -8.825777334185084],
              [5.942639810636321, -8.830137107184456],
              [5.953454548106617, -8.834115629517465],
              [5.957852946555444, -8.833822728360516],
              [5.9635419067943065, -8.835978860994674],
              [5.974438140171249, -8.843069198577506],
              [5.9831356971941725, -8.850971369442272],
              [5.993229284596771, -8.861819240909346],
              [5.998294563450972, -8.8642430838158],
              [6.011644486445276, -8.866283045016113],
              [6.018381423840693, -8.866018649111899],
              [6.025416929013112, -8.869320023833478],
              [6.028472152094828, -8.871835489842352],
              [6.036088302734004, -8.873557696540281],
              [6.040131889996123, -8.872676079370747],
              [6.043895462928559, -8.8739330124327],
              [6.050509818248474, -8.878985128738233],
              [6.055317980029995, -8.877988168182455],
              [6.061640932845035, -8.880850796293222],
              [6.066215070476013, -8.884502909696051],
              [6.061437766869278, -8.88383432746467],
              [6.0558273326545535, -8.88076344562741],
              [6.049088429749486, -8.879321087355354],
              [6.034316282227994, -8.884491734773732],
              [6.025495635879761, -8.896464073598105],
              [6.019618412219339, -8.899295479507808],
              [6.00284868097022, -8.905321789553886],
              [5.9992491780306105, -8.904128540470188],
              [5.991800600129002, -8.89807448063018],
              [5.981621078783513, -8.897521404254379],
              [5.966511696358037, -8.897496576892994],
              [5.963228789309151, -8.900986652098286],
              [5.967899654098182, -8.902724820725865],
              [5.969397656205248, -8.906513474525154],
              [5.977559291437162, -8.910884923201634],
              [5.9817094752002005, -8.91408884300874],
              [5.99519392408304, -8.912990731970485],
              [5.991776254244991, -8.920583943534492],
              [5.9970291216966105, -8.92780810815849],
              [6.004066190538747, -8.930819236951907],
              [6.011223410639386, -8.926455515025943],
              [6.020556613805559, -8.929722612094643],
              [6.01211936818407, -8.930489107529533],
              [6.005030763377837, -8.935661301193461],
              [6.007163678637562, -8.939823536041644],
              [6.0152612593247765, -8.943173147662193],
              [6.023079654349332, -8.95597869465233],
              [6.022034678279464, -8.957458373915335],
              [6.014320567407824, -8.953674106161726],
              [5.997723862180889, -8.944133941240946],
              [5.990550454923362, -8.945223280329847],
              [5.989334715429507, -8.930364094519819],
              [5.978663074342247, -8.917755725500077],
              [5.971438516334633, -8.919213506163075],
              [5.9564841431165405, -8.917784942767877],
              [5.948151374041123, -8.920144567688022],
              [5.945933472897751, -8.928779533532538],
              [5.950857764151487, -8.927787359778806],
              [5.959419208915363, -8.934999816577161],
              [5.96135754590626, -8.94223981159476],
              [5.959309339853606, -8.945648488974706],
              [5.951571121599668, -8.947590557571594],
              [5.962207612370797, -8.955425152899853],
              [5.980272426073632, -8.955521426741015],
              [5.988454873991325, -8.966237677377585],
              [5.98618766838794, -8.96945814277745],
              [5.970227223465793, -8.978494610996425],
              [5.957659847837595, -8.976457163476324],
              [5.952238526531135, -8.980814596608562],
              [5.956394098667, -8.988412225208672],
              [5.954062861830173, -8.994552122441595],
              [5.9602988651582764, -9.005605834877386],
              [5.964597480761551, -9.007881865185366],
              [5.977987658326848, -9.00976293646668],
              [5.978526507233892, -9.019246364017366],
              [5.9851515752317885, -9.025257858366912],
              [5.994662074768651, -9.03711866699266],
              [6.004336361181965, -9.037604243869465],
              [6.010860065651259, -9.040549705807301],
              [6.022521226421219, -9.048886922505032],
              [6.026876726505391, -9.04890397808182],
              [6.029798928273986, -9.046149861661089],
              [6.03615482051316, -9.043576509527089],
              [6.044803506007402, -9.042692585132338],
              [6.056603020805881, -9.042415548895832],
              [6.059284433071761, -9.052781398720162],
              [6.055708569995606, -9.061109914880006],
              [6.067980966214242, -9.07370261875039],
              [6.074759763295799, -9.0714833969428],
              [6.074286790258084, -9.079424572098974],
              [6.080673844959933, -9.083296797923895],
              [6.085587652025248, -9.082352048638487],
              [6.091172041938688, -9.078085117195837],
              [6.099843054520884, -9.076988486776788],
              [6.096490280142027, -9.081003829067852],
              [6.0891610782398695, -9.08303310617118],
              [6.086466803616507, -9.092026829701393],
              [6.087570841925241, -9.102087772095706],
              [6.091982983753229, -9.11039397530462],
              [6.103551976689646, -9.11862917499776],
              [6.106239320121583, -9.12959211778503],
              [6.104168238600946, -9.133542921511665],
              [6.101537648422216, -9.130032666889855],
              [6.092697793765772, -9.128270943419764],
              [6.084952750068399, -9.129475220810354],
              [6.083472733078682, -9.126944771822947],
              [6.076885147245359, -9.124724380859384],
              [6.075130913279828, -9.126378597042512],
              [6.073975239573805, -9.133728122553158],
              [6.070516858718152, -9.139286582675421],
              [6.083601170608959, -9.140867608238485],
              [6.090829216438782, -9.14632394631189],
              [6.105547070247892, -9.147484074287227],
              [6.1139691557820015, -9.14916971059973],
              [6.116985732172083, -9.145108628251466],
              [6.120049094299652, -9.145028319347155],
              [6.134965475047625, -9.136790614535117],
              [6.137251276742479, -9.132554372051315],
              [6.142491192272409, -9.133819661274115],
              [6.149332409159086, -9.127776717247167],
              [6.1610661314733735, -9.135213849607496],
              [6.1703193347091245, -9.138380850623216],
              [6.178161545882468, -9.139177552788501],
              [6.186800853061528, -9.136538157930193],
              [6.191967025870423, -9.137840064735636],
              [6.18654747743803, -9.147722919207201],
              [6.1932296551949255, -9.149725420792802],
              [6.198498371152032, -9.146393523281334],
              [6.204573988052417, -9.145669363081629],
              [6.204741926553417, -9.139202884250691],
              [6.20817536686232, -9.136869691002085],
              [6.212074112977063, -9.137163029670333],
              [6.2253520837926954, -9.135532666436033],
              [6.241093320713715, -9.139365200074687],
              [6.246239224008049, -9.143109146404043],
              [6.266173595409654, -9.141513932734219],
              [6.266897834385632, -9.142691645277571],
              [6.257698739536602, -9.155367164118115],
              [6.266919192623182, -9.165245542833375],
              [6.282444831294515, -9.16447575364373],
              [6.290896481609685, -9.157738980636854],
              [6.290209562824294, -9.148241834848246],
              [6.292036657612763, -9.147603098642401],
              [6.317419738794844, -9.160152098130778],
              [6.324654746582543, -9.165428971946344],
              [6.329827258626012, -9.166334157067428],
              [6.338446825480478, -9.178633049316806],
              [6.3431908958008725, -9.192219497829079],
              [6.360317596342106, -9.209303514956616],
              [6.365060924076423, -9.205894156771663],
              [6.36936994096541, -9.199291157303996],
              [6.368578373834276, -9.19139528441966],
              [6.372492167727343, -9.188564948387436],
              [6.384550394634461, -9.173603401468657],
              [6.3878923711598015, -9.167683933945087],
              [6.39898313003566, -9.16926127086851],
              [6.404256942444532, -9.173192215004507],
              [6.4084238900398, -9.183491732181347],
              [6.413275119265243, -9.185721544055356],
              [6.42163091706948, -9.206228262334232],
              [6.428545728051473, -9.21201590584335],
              [6.444020419011409, -9.216458431910587],
              [6.45003541814242, -9.227646872767274],
              [6.448031541829179, -9.231846435451734],
              [6.455071432978686, -9.240845894628322],
              [6.463610986587794, -9.24568495622391],
              [6.468688263073736, -9.252463391630823],
              [6.464396450202035, -9.262000094878571],
              [6.466165565771189, -9.271924281932213],
              [6.4575772856372575, -9.27397442633712],
              [6.457138277396098, -9.279338957498009],
              [6.461077193097191, -9.28480081876348],
              [6.469752745850255, -9.285387506356555],
              [6.471392335726166, -9.29206251970236],
              [6.466359703359029, -9.302884286421198],
              [6.474419878122242, -9.302102593730119],
              [6.483297398932943, -9.303928244174648],
              [6.486500782117905, -9.310673129344808],
              [6.489745624547287, -9.315158445180172],
              [6.493868590796848, -9.311785333149672],
              [6.496689395402504, -9.307684891346018],
              [6.501855016307568, -9.309980054761521],
              [6.511290045467837, -9.30806959397134],
              [6.5151448744027265, -9.30389386335249],
              [6.523574280147869, -9.302464789360828],
              [6.525609337649668, -9.299034879723935],
              [6.5238616970392425, -9.288367697192331],
              [6.531265763442417, -9.293908184050471],
              [6.540814696128037, -9.290754706519625],
              [6.544070367450038, -9.284159121418886],
              [6.549053725223611, -9.284002454301683],
              [6.553772464015687, -9.291456603840775],
              [6.568438581128247, -9.311151701179249],
              [6.570899306486366, -9.317293988456042],
              [6.565769937653223, -9.326695323497272],
              [6.562578536333371, -9.328569526218352],
              [6.559733402165872, -9.32672363572353],
              [6.558524172490348, -9.321681923694399],
              [6.551062151111984, -9.319351171042491],
              [6.532872117030385, -9.31553893925811],
              [6.5303658920576355, -9.329525610685783],
              [6.505065004073856, -9.330881739433268],
              [6.497318479675062, -9.33595301920038],
              [6.49732976329297, -9.344569858203641],
              [6.4866211442758255, -9.33774637291151],
              [6.478311557730861, -9.343677515544684],
              [6.480080207325922, -9.35073165683419],
              [6.483653793649865, -9.356836675871532],
              [6.492691159111747, -9.363576349069396],
              [6.510723833524113, -9.365152423677445],
              [6.520613755328667, -9.366491854560053],
              [6.543080794127763, -9.363226650958744],
              [6.535837162928466, -9.377911522592868],
              [6.5305101641527035, -9.393176620598114],
              [6.522715673061449, -9.408927296034943],
              [6.517314318454362, -9.411984812248942],
              [6.515194148395779, -9.400232776697829],
              [6.510782509764942, -9.391314497659604],
              [6.5043982308686505, -9.389516369770774],
              [6.498986654010869, -9.383953372527246],
              [6.48849058948417, -9.385732678654158],
              [6.486586881196464, -9.391000663825753],
              [6.48750987777654, -9.40920095315643],
              [6.4823715058837905, -9.410184764283068],
              [6.481725692462826, -9.415567363182046],
              [6.484842223484139, -9.421091457124243],
              [6.480375334321355, -9.42838962282323],
              [6.468172626210541, -9.432546569920186],
              [6.459741333715258, -9.4313005790362],
              [6.454053967504552, -9.433348230864995],
              [6.4550948281740705, -9.4390216813839],
              [6.459942244399636, -9.442575963816566],
              [6.452728058118776, -9.443706649089606],
              [6.452641415891056, -9.44822807108508],
              [6.455444577367814, -9.452340013942267],
              [6.455314096981749, -9.462900729077672],
              [6.448896610498185, -9.47540698500258],
              [6.4474331747636064, -9.482446734498314],
              [6.448919339980596, -9.485631443636892],
              [6.454282377227921, -9.490420907837658],
              [6.463503053651452, -9.483329322198118],
              [6.4658452879045445, -9.483983149755648],
              [6.457316952108669, -9.499990594665922],
              [6.4633346747806115, -9.511083492658278],
              [6.454197974639777, -9.515817253576165],
              [6.453259457291511, -9.510705706012285],
              [6.449611173236406, -9.507314753032054],
              [6.427751835227259, -9.497984053497857],
              [6.394921365244325, -9.485420162097226],
              [6.391609613062571, -9.480008367301995],
              [6.3959759568272805, -9.462559447081425],
              [6.39357146268616, -9.452757951828286],
              [6.389468564837856, -9.444255279552351],
              [6.381422848147716, -9.435772798390264],
              [6.370832109670225, -9.425906007958645],
              [6.361761132015031, -9.427828400573418],
              [6.359448557027016, -9.435129148281186],
              [6.361382786198745, -9.44585442147379],
              [6.356862953545853, -9.452687734088418],
              [6.336391907749263, -9.459091782547938],
              [6.328638690479798, -9.47148975028311],
              [6.319207932314418, -9.48394948582619],
              [6.310893711118138, -9.496023433371954],
              [6.2957821046734885, -9.510825514783308],
              [6.271738161758644, -9.543898286137697],
              [6.271726239938015, -9.55108513036065],
              [6.260317604285411, -9.560029244966275],
              [6.238361555218789, -9.586037645430858],
              [6.227442984949238, -9.589777117952648],
              [6.226251849995565, -9.585194436316321],
              [6.231849654273397, -9.573125333816039],
              [6.23225316966367, -9.568478538644786],
              [6.236141312164012, -9.567333574911267],
              [6.2386017275362144, -9.562294848317205],
              [6.238695860437903, -9.556231444725345],
              [6.240432821549273, -9.54628453367105],
              [6.245571953735929, -9.54128531876651],
              [6.245147326858244, -9.530844031618832],
              [6.24961674328374, -9.532076421376813],
              [6.255696930203793, -9.528066056661828],
              [6.261214241266691, -9.519064602157147],
              [6.264009812740079, -9.516250172745034],
              [6.265420426435428, -9.509228318100575],
              [6.270395347833987, -9.504369059579771],
              [6.272786429428401, -9.496917463442724],
              [6.27842837968869, -9.486777615208661],
              [6.278916833017403, -9.481919929951951],
              [6.27652653492221, -9.475096928836892],
              [6.277130067987978, -9.472909823615268],
              [6.286563659739915, -9.469948935212022],
              [6.283580026088482, -9.463176635483538],
              [6.283868296022742, -9.45843586237821],
              [6.295602457786267, -9.459264811875563],
              [6.304213410593374, -9.457230935582293],
              [6.307969128585147, -9.451429026412482],
              [6.31177048409436, -9.443365156507102],
              [6.308286054684194, -9.432525446797841],
              [6.308129001007952, -9.427405654817298],
              [6.315714383941218, -9.425646865224822],
              [6.316315788722071, -9.416576131070084],
              [6.314534468344982, -9.406235117386803],
              [6.307888459096088, -9.40361952047529],
              [6.306428308590043, -9.397770375488804],
              [6.315330739470014, -9.394072667999783],
              [6.3198962918216735, -9.388010073649772],
              [6.319799663242608, -9.380835191129412],
              [6.328787607267055, -9.378362033822262],
              [6.3344442348043675, -9.375915182239378],
              [6.334450305606316, -9.36729753132128],
              [6.330389819177289, -9.354246033671794],
              [6.33377323765656, -9.340469744749806],
              [6.315831254921404, -9.316696573063163],
              [6.304548471307672, -9.313175248501409],
              [6.2951388929068965, -9.315470700433552],
              [6.28721106129235, -9.326892343857812],
              [6.290642185588857, -9.339987063228145],
              [6.288138850605976, -9.354519581888963],
              [6.2872474368893245, -9.368326365599174],
              [6.275535144211783, -9.382267741060332],
              [6.272258349138122, -9.388187474276675],
              [6.264526276000638, -9.390774154321997],
              [6.237852472983211, -9.396509751320131],
              [6.2298796293753265, -9.39695745878793],
              [6.22422020348657, -9.392983043289375],
              [6.213080724851044, -9.383273535770357],
              [6.204256956162282, -9.378182008985373],
              [6.18467144166119, -9.34276200349923],
              [6.17645959110712, -9.333369030789772],
              [6.160750089677787, -9.318783636731554],
              [6.151057271253661, -9.312024364588313],
              [6.102781823885772, -9.294366096593592],
              [6.041176212205894, -9.281245768472399],
              [6.041585435622997, -9.27427153688286],
              [6.033425850196278, -9.267434540486837],
              [6.024456506967523, -9.267004523825912],
              [6.021721948202811, -9.26042127830919],
              [6.01568354337631, -9.257440949619866],
              [6.009368693421868, -9.246891877457665],
              [5.981506204794955, -9.250216361003794],
              [5.958817910396752, -9.244141796098317],
              [5.933170099193702, -9.238554838347337],
              [5.883967157791593, -9.234724905807942],
              [5.855506310318176, -9.233259149847429],
              [5.850406622348241, -9.231538399812948],
              [5.830811504744788, -9.23054115798805],
              [5.829328943498402, -9.226948105247523],
              [5.836023080951347, -9.223702303381234],
              [5.8375913193476165, -9.217557342313922],
              [5.83457418476471, -9.212731593772101],
              [5.83585931001984, -9.207014832509627],
              [5.841985789308406, -9.203855942091558],
              [5.8435123183240485, -9.193924359590213],
              [5.851428578062872, -9.191161803672186],
              [5.864353967597231, -9.194273346384122],
              [5.865842808389757, -9.204215746302387],
              [5.875503138882238, -9.218345005864288],
              [5.893590435087091, -9.209184031282796],
              [5.9009529561507215, -9.194978440556723],
              [5.929809311865469, -9.185435724617049],
              [5.9444789717285795, -9.18435641683384],
              [5.9622054155852835, -9.182374640175633],
              [5.979394273963562, -9.175507707364098],
              [5.997433475212169, -9.162844519701377],
              [6.003856039597964, -9.165697925527873],
              [6.014906104502209, -9.181576616308407],
              [6.019910650769452, -9.191065265426971],
              [6.0434491305437845, -9.179869785464039],
              [6.0353305261381545, -9.16135508670513],
              [6.02975593310225, -9.149638407018163],
              [6.025317702653839, -9.148498953487884],
              [6.018385360449333, -9.144247329582807],
              [6.004302887398569, -9.14169837996456],
              [5.999500050216646, -9.133331043178556],
              [5.991895540117079, -9.129531092718405],
              [5.990591392961861, -9.139696376709423],
              [5.991890203037219, -9.144158321880195],
              [5.998173731251576, -9.149274055062305],
              [5.9766658487552, -9.15048845935339],
              [5.954606518878228, -9.149684832019569],
              [5.936085692000547, -9.155199568257226],
              [5.927087921406084, -9.154148169272204],
              [5.891150623022136, -9.15689515444695],
              [5.889086066078227, -9.148477694228752],
              [5.879680798070433, -9.14437524702428],
              [5.869854270018354, -9.13702263143595],
              [5.849889434269443, -9.148960306380136],
              [5.846922468573886, -9.14331409347522],
              [5.8426784475407, -9.140104009417898],
              [5.838974067212711, -9.134318719474741],
              [5.823361886858157, -9.129297587191536],
              [5.8243259167787915, -9.115273260319029],
              [5.828526862554902, -9.098724214953767],
              [5.833424193340691, -9.097487858039845],
              [5.844835885412214, -9.089689962552457],
              [5.838227952051458, -9.085406034193339],
              [5.835274448177052, -9.081500353967108],
              [5.826129514512214, -9.076457058817839],
              [5.812550605459921, -9.076507440867193],
              [5.80329647087153, -9.082432131341355],
              [5.803147858553622, -9.097593613128241],
              [5.799064025081334, -9.101744395762966],
              [5.795429175013215, -9.108017061869894],
              [5.794309984781525, -9.1162788263889],
              [5.791247677479987, -9.11862455103191],
              [5.787522380887316, -9.118758775770814],
              [5.785097037050718, -9.11338497029397],
              [5.780652548865052, -9.108855576192054],
              [5.768499974186759, -9.114950378542021],
              [5.767725551994853, -9.10783305161455],
              [5.7558100218818256, -9.10720558658541],
              [5.743350140789019, -9.11659257566993],
              [5.7330345016306445, -9.098201039665046],
              [5.721792887217934, -9.100750552467813],
              [5.716041335061095, -9.0951749379208],
              [5.711897897489709, -9.095230224675909],
              [5.704574704928413, -9.099283452062245],
              [5.702864292523601, -9.073670924447368],
              [5.7010283198079925, -9.073808697217128],
              [5.699799625032208, -9.053973197060229],
              [5.698560744143927, -9.026418030552366],
              [5.692999162497711, -9.020279875213557],
              [5.689151270711847, -9.011915006800434],
              [5.688544986358237, -8.998423699094797],
              [5.693246391221014, -8.993671297641804],
              [5.6923828884051035, -8.988403943588423],
              [5.689915590331147, -8.985583841864216],
              [5.694000004899558, -8.980666734561217],
              [5.692323076790517, -8.968305574414439],
              [5.693912251417998, -8.964795581182827],
              [5.69025913642603, -8.959450735919315],
              [5.692952611864798, -8.953580520037622],
              [5.688398981923395, -8.951947988593128],
              [5.685433142596484, -8.947203148850226],
              [5.688507837338903, -8.944970185197109],
              [5.685542683350064, -8.940273668010184],
              [5.679228054127492, -8.940961631614407],
              [5.672710023742197, -8.939164808883099],
              [5.668981222666311, -8.925869435175164],
              [5.657632855199053, -8.88961212038907],
              [5.645018656427213, -8.877841246412629],
              [5.6368969486951706, -8.865820972540488],
              [5.63407494371942, -8.857827820878306],
              [5.613968675755622, -8.836266240625733],
              [5.609014661770408, -8.828776470700852],
              [5.609515521095112, -8.8146478535232],
              [5.599725559115005, -8.796686334412616],
              [5.602120453520776, -8.795122797443312],
              [5.6122570163791075, -8.78293705553677],
              [5.607208969641874, -8.775880239256344],
              [5.604081220819556, -8.76677706314394],
              [5.60233359850203, -8.764929932353741],
              [5.60089112342826, -8.758465042238365],
              [5.6035378612478, -8.7451177687981],
              [5.602293444290016, -8.740067133292175],
              [5.60574093295577, -8.73567492864871],
              [5.611023157183597, -8.73155647232836],
              [5.616334984211089, -8.730255382452192],
              [5.622291660121484, -8.726404492905605],
              [5.626089085269871, -8.721531465248729],
              [5.6309341268361, -8.71944359022481],
              [5.636390150466248, -8.71414766183758],
              [5.637595628742485, -8.70776872339866],
              [5.63969901750337, -8.704394582544099],
              [5.639302616909264, -8.698744442542914],
              [5.643197014842687, -8.688294775073967],
              [5.649195084345632, -8.675029518324369],
              [5.6504787047757645, -8.670964084824886]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.61006595012141, "lat": 29.44061025525997 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22075"],
        "coty_name": ["Plaquemines"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Plaquemines Parish"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00558125"
      },
      "bbox": [
        5.599725559115005, -9.589777117952648, 6.570899306486366,
        -8.660279976629038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.343667097579161, -9.368514893942415],
              [5.344024524217213, -9.374512868614413],
              [5.3408777482584595, -9.373774073294523],
              [5.339512823051333, -9.370062502070066],
              [5.343667097579161, -9.368514893942415]
            ]
          ],
          [
            [
              [5.310215597730016, -9.31787500904658],
              [5.318826672588553, -9.326390378705153],
              [5.313416124383106, -9.3280348828292],
              [5.311936484303835, -9.325866909821885],
              [5.310215597730016, -9.31787500904658]
            ]
          ],
          [
            [
              [5.227667530182002, -9.49085489959553],
              [5.254522608901733, -9.499507344893388],
              [5.299217996139196, -9.51170855729462],
              [5.33524938438582, -9.51234506786556],
              [5.3400926227040655, -9.515288059760396],
              [5.3237127942851235, -9.52098250144598],
              [5.29679523988405, -9.519140162856347],
              [5.246937896193124, -9.503671534122564],
              [5.227667530182002, -9.49085489959553]
            ]
          ],
          [
            [
              [5.047647374922138, -9.545508377868334],
              [5.051718039467527, -9.542793437985997],
              [5.059711469654979, -9.543096568654496],
              [5.066863349234102, -9.540119866238804],
              [5.0685795677011, -9.537255410666976],
              [5.0803658128379485, -9.534947422570873],
              [5.0843102562575035, -9.530021397964195],
              [5.088327994877716, -9.528046367150042],
              [5.094080768609577, -9.531885374135559],
              [5.101479722197501, -9.528338302458293],
              [5.108702974447618, -9.526647429588657],
              [5.121355968317229, -9.52641019460932],
              [5.124472068356136, -9.52346683626582],
              [5.128901157113702, -9.527100593383519],
              [5.1108293342328786, -9.531055381773063],
              [5.082153211887389, -9.540021696568521],
              [5.063744210950646, -9.544723403798416],
              [5.050640310050126, -9.547007902567376],
              [5.047647374922138, -9.545508377868334]
            ]
          ],
          [
            [
              [4.951997342891369, -9.540487490246],
              [4.964724412482827, -9.542794675050693],
              [4.973555969747589, -9.546388974267774],
              [4.975709613970562, -9.544073485730268],
              [4.979716082706588, -9.544895658951068],
              [4.993754550092867, -9.538127130685954],
              [5.0038435893760145, -9.53920187400579],
              [5.006342518908134, -9.540932856376587],
              [4.999569129774228, -9.547229549840338],
              [4.992882464190877, -9.549787558651404],
              [4.982201688586138, -9.550983799049249],
              [4.976665418180892, -9.549952703325934],
              [4.968854809999379, -9.546638621267471],
              [4.9546867676169315, -9.543413452077619],
              [4.951997342891369, -9.540487490246]
            ]
          ],
          [
            [
              [4.893013604540474, -9.545147651420562],
              [4.901422768202275, -9.54876167717872],
              [4.910985425064878, -9.549894927513742],
              [4.9074088606180135, -9.552249166155056],
              [4.895790563982909, -9.549180595068453],
              [4.893013604540474, -9.545147651420562]
            ]
          ],
          [
            [
              [4.576900767760657, -9.142940859883097],
              [4.578038897491372, -9.125491590662794],
              [4.582330640575162, -9.114544386815291],
              [4.5818923206239, -9.107899609254874],
              [4.577695772202322, -9.100877951119752],
              [4.575401074111516, -9.093345153622726],
              [4.576458888653116, -9.086096121099787],
              [4.578194808540701, -9.082607404381166],
              [4.5847228533045925, -9.07800154416557],
              [4.59746035451236, -9.075414009744307],
              [4.6058766235336925, -9.071165785383117],
              [4.616143780079421, -9.059278460746173],
              [4.616171845530441, -9.056051218002677],
              [4.613757045025931, -9.04982214342175],
              [4.613933872853509, -9.04512071487591],
              [4.618965891909918, -9.037377036013288],
              [4.6255020600033125, -9.030264991746806],
              [4.637264164404619, -9.019993174179206],
              [4.641551400057141, -9.018287307162177],
              [4.6483732701400635, -9.012043664548084],
              [4.652513451785892, -9.010248558272892],
              [4.655588625487303, -9.010863878598323],
              [4.656978455487406, -9.014143429758718],
              [4.657168510789618, -9.020391180709314],
              [4.6618699807233455, -9.024738636283939],
              [4.666510255807632, -9.026252116846786],
              [4.671685019447547, -9.023580227328155],
              [4.674792599742286, -9.016285080525835],
              [4.678032129416252, -9.014801202949744],
              [4.685784873951182, -9.016129909124265],
              [4.687277709995613, -9.014233401461437],
              [4.686735725477014, -9.009216967628538],
              [4.689234567389023, -9.008244841536184],
              [4.694989936413773, -9.00958173532803],
              [4.7011598022004435, -9.009662692416931],
              [4.704222091762601, -9.0079463345595],
              [4.705637399456722, -8.999740041460276],
              [4.716592099630347, -8.998400460733901],
              [4.723593261958177, -8.992854899644714],
              [4.729236477687176, -8.993982543144133],
              [4.7351492867677445, -8.989044454490271],
              [4.796225688662504, -8.898538956780568],
              [4.905961423766085, -8.891067047650473],
              [4.902754173976619, -8.862441978040238],
              [4.937958005380521, -8.860079501006473],
              [4.93503033724737, -8.850830865909915],
              [4.936600467668929, -8.846578234215718],
              [4.939359613195577, -8.846853862879964],
              [4.948725449366984, -8.84144514507801],
              [4.948165595282534, -8.830375348674126],
              [4.954815133888298, -8.827939676842064],
              [4.965597507752491, -8.829740192187613],
              [4.967195064726898, -8.830743090455302],
              [4.9676485507455705, -8.841696813354432],
              [4.97000959813273, -8.846549630266045],
              [4.969359357312288, -8.855316650639162],
              [4.976337085928106, -8.859881666462432],
              [4.9839888524635265, -8.856461113883613],
              [4.986008266850491, -8.864353407967071],
              [4.986734863804055, -8.871593787589658],
              [4.989593569347437, -8.873185039406545],
              [5.000410301540949, -8.89355098685739],
              [5.005435852769908, -8.906361919481329],
              [5.015995690952203, -8.915057199979158],
              [5.023189516516128, -8.92217702117322],
              [5.026264661998842, -8.92418645138472],
              [5.03297354059382, -8.925594973862804],
              [5.0407716178024575, -8.9245865208902],
              [5.049570637191943, -8.930402343037215],
              [5.060462924287789, -8.93505567131533],
              [5.0644517474440605, -8.93868893229609],
              [5.073722350878068, -8.949748102940687],
              [5.083170959326214, -8.958010039796788],
              [5.087622878685445, -8.963232323326444],
              [5.0962442577899125, -8.975292663012384],
              [5.099521672385333, -8.981215377124293],
              [5.104634614313723, -8.988083722747099],
              [5.110052309035417, -8.991731610002615],
              [5.115914051257693, -8.993312054581427],
              [5.12526908308559, -8.993002166250317],
              [5.137130904992473, -8.994848626881181],
              [5.139974447435986, -8.997333400920471],
              [5.140298884588637, -9.002288359622355],
              [5.15520752889037, -9.019891394942006],
              [5.1683540970534265, -9.025272472179225],
              [5.179892584436066, -9.032322175879083],
              [5.186573947190704, -9.05538301550398],
              [5.194654565362663, -9.054377060689882],
              [5.202100592332424, -9.058392028884882],
              [5.208279768394173, -9.06507978545363],
              [5.210459251198192, -9.069986060448583],
              [5.215441535684708, -9.074417404500583],
              [5.215110877867376, -9.083133590455287],
              [5.219353758447005, -9.086842883867838],
              [5.225432467898844, -9.089137873466118],
              [5.23114395436211, -9.096568762221034],
              [5.2392035671393105, -9.10207390456681],
              [5.243745219848557, -9.109193509402557],
              [5.2518855188790825, -9.111223238557002],
              [5.256710925656626, -9.118350371056518],
              [5.261663647787071, -9.123476036423162],
              [5.267626742102025, -9.124492706941323],
              [5.270935726577943, -9.128173314934385],
              [5.277633413009788, -9.13042473783621],
              [5.279611407820693, -9.132471681206932],
              [5.287584901962963, -9.148191211521478],
              [5.289112128868907, -9.153759161457176],
              [5.294297405749209, -9.157967008278137],
              [5.29792719768707, -9.164928966134994],
              [5.3060533952199735, -9.170686440317432],
              [5.309812091713149, -9.175281040021295],
              [5.31756504898961, -9.181496758990637],
              [5.325243053404318, -9.19099229738506],
              [5.334842196540402, -9.195166167373442],
              [5.338854051360217, -9.195942156152409],
              [5.345433531804718, -9.200889521426626],
              [5.34890945179846, -9.205849245653104],
              [5.355283373346929, -9.211277194967568],
              [5.357929803503447, -9.219704976051329],
              [5.360003827737302, -9.22309493644595],
              [5.361565748480715, -9.229390144538302],
              [5.35957893063085, -9.2351650068536],
              [5.360260099407796, -9.243932824078255],
              [5.357008283399983, -9.25368495790522],
              [5.364759079327263, -9.266630568889688],
              [5.366839074185683, -9.274714355973199],
              [5.361664817121261, -9.282199898559838],
              [5.362125778332847, -9.295691800196392],
              [5.357115283748199, -9.300425680029404],
              [5.3552500691812375, -9.306171368430448],
              [5.351772012119507, -9.311313247988199],
              [5.351687068856419, -9.313625706897655],
              [5.349149739869761, -9.303428219670199],
              [5.350208778539496, -9.29681161796954],
              [5.348843550160366, -9.293101731700082],
              [5.3511690421227724, -9.28856219113123],
              [5.350742835710224, -9.284900232785198],
              [5.353043674347824, -9.281692947383712],
              [5.348323325947962, -9.272239151002578],
              [5.348219502751914, -9.268763656523586],
              [5.340451699305189, -9.26563136338968],
              [5.328137664850943, -9.25590155545311],
              [5.323293328219723, -9.251267628645062],
              [5.319909862230376, -9.245011856415648],
              [5.318012746795264, -9.239285467248846],
              [5.318494416989628, -9.235162693317795],
              [5.313882613697708, -9.232665124959606],
              [5.308765498608728, -9.232141688233858],
              [5.3026611025479795, -9.234234896244354],
              [5.296087585031653, -9.238914548843033],
              [5.291977019760487, -9.244884806531871],
              [5.2939357842270764, -9.246410619116787],
              [5.296914825982177, -9.252894203881599],
              [5.300473773831456, -9.255146845686832],
              [5.300459902314958, -9.26016509532644],
              [5.297242143464019, -9.267210983653575],
              [5.28869794936878, -9.273744848066157],
              [5.288748411700293, -9.281627473923516],
              [5.2823103091107955, -9.285171434288047],
              [5.27825779977591, -9.29042270349718],
              [5.265922743011612, -9.289081411574296],
              [5.254735275001568, -9.278968493618969],
              [5.247876425230591, -9.282432063405114],
              [5.239159738277715, -9.280778637102282],
              [5.2313526815065785, -9.28224643241685],
              [5.227623517631423, -9.289524104371386],
              [5.219467110240072, -9.292137886639498],
              [5.2162589239598205, -9.299487833464584],
              [5.213126641586902, -9.300996040260607],
              [5.2017080005105205, -9.283209778198094],
              [5.197381154319051, -9.278436525275865],
              [5.191757386476905, -9.274555233563593],
              [5.186641474407056, -9.27586716598544],
              [5.18170230475855, -9.280241809564222],
              [5.180472764772194, -9.28305486048796],
              [5.174417393895314, -9.285361389900672],
              [5.173179768059161, -9.289116301918426],
              [5.174569018044758, -9.291598293005677],
              [5.17307865608002, -9.29997725284554],
              [5.184617768767426, -9.316328417499214],
              [5.184089910735436, -9.334178102112737],
              [5.18191895747576, -9.341572280581026],
              [5.188813988568251, -9.345793428451666],
              [5.193670411875097, -9.34531551331779],
              [5.204621661923327, -9.34777077853558],
              [5.209478113158576, -9.35087650325364],
              [5.198609782492506, -9.35702128891177],
              [5.19045248072066, -9.352564019340573],
              [5.1795672400697494, -9.347644781963083],
              [5.162156094201041, -9.352103575373752],
              [5.170046528131009, -9.360982542963246],
              [5.171436733684805, -9.363465630891813],
              [5.167004019674056, -9.373137934765367],
              [5.148997092921536, -9.374554137186312],
              [5.146228205743054, -9.375221092672557],
              [5.140121776185537, -9.392053086208657],
              [5.140890958473978, -9.396415419980183],
              [5.1400001114331415, -9.406299931475255],
              [5.137877504749953, -9.40918473526682],
              [5.139657510256747, -9.41834041547297],
              [5.136576255597147, -9.417350642773224],
              [5.113431197470119, -9.416380090479107],
              [5.105922955599393, -9.425196242137064],
              [5.10967088891441, -9.43441572584305],
              [5.103695787598731, -9.450114587741572],
              [5.100092432227444, -9.465479560701608],
              [5.089505824670891, -9.469648462264951],
              [5.0856383357473245, -9.474882148233007],
              [5.083303631558947, -9.470398929474428],
              [5.074279193671405, -9.456139101147985],
              [5.068251623858495, -9.454420058824658],
              [5.063358639940237, -9.458068686864564],
              [5.056415046693068, -9.475252804900276],
              [5.050829880962281, -9.47402075364013],
              [5.040102922626694, -9.47573215045146],
              [5.037546830442269, -9.48027806822202],
              [5.033833311237668, -9.482734109212517],
              [5.031756233744696, -9.486536133762579],
              [5.033033074288885, -9.490770812506394],
              [5.025132005383892, -9.487202446908288],
              [5.019298330525748, -9.487108922575835],
              [5.016752024459948, -9.491857630657897],
              [5.016945268912794, -9.495331909045445],
              [5.014600732291814, -9.499967764845367],
              [5.010802318084711, -9.499046086070301],
              [5.007600225996085, -9.501370389724565],
              [5.007279961575959, -9.504974852391713],
              [5.007745114731868, -9.527169941832819],
              [5.005954471299931, -9.530429951949058],
              [4.998195346144114, -9.530128887962206],
              [4.992813951302792, -9.52790245858748],
              [4.988086576431299, -9.529594251954206],
              [4.979506372079357, -9.530270973854092],
              [4.972705338308684, -9.527472145666284],
              [4.965588821134358, -9.522893801518425],
              [4.9631619993779035, -9.513727466403482],
              [4.957098259706828, -9.502954944524484],
              [4.955970526097942, -9.497583632099282],
              [4.951064635624159, -9.501124616614046],
              [4.948276552381692, -9.499634114616018],
              [4.950285839359469, -9.49450595249404],
              [4.949638360581514, -9.492183841331915],
              [4.9433666547737145, -9.49169786976246],
              [4.943154164527471, -9.487814957545645],
              [4.947846881351365, -9.480393113141728],
              [4.942516762823985, -9.479959536940477],
              [4.937401455990718, -9.481564044056201],
              [4.9304057686893605, -9.477324825532024],
              [4.936206035608306, -9.473020495380162],
              [4.929712303987254, -9.472238384252522],
              [4.928841044772158, -9.469620803997756],
              [4.91930717022145, -9.464594294465238],
              [4.92124111149087, -9.459983160396982],
              [4.920283063052759, -9.457677894544576],
              [4.913398349524553, -9.457324858284373],
              [4.904849810682419, -9.453167241789114],
              [4.897235520280182, -9.44701195914429],
              [4.891039499220645, -9.443189696353707],
              [4.89067488422351, -9.441109332859545],
              [4.883985574624365, -9.436646128688377],
              [4.885205791918231, -9.432280024551956],
              [4.879357475538507, -9.427978370197131],
              [4.874713205318781, -9.426685168629506],
              [4.871612670940558, -9.42277963533527],
              [4.871664888979307, -9.420290148223378],
              [4.865180193404185, -9.41765945922396],
              [4.85753210043199, -9.424307545044716],
              [4.845302808897965, -9.430886545668967],
              [4.838475697388041, -9.42960344829798],
              [4.830315718511835, -9.432588290102453],
              [4.8263700280707775, -9.430744858805985],
              [4.821147112030977, -9.430298095066124],
              [4.820847882541246, -9.424679995535651],
              [4.814921260313139, -9.424679977112314],
              [4.806311905177454, -9.419185432700058],
              [4.805617853070375, -9.406111149106126],
              [4.801346315480619, -9.405922030242985],
              [4.796367463586215, -9.400239552457162],
              [4.795288104017189, -9.397529840628339],
              [4.7906621960242965, -9.398484942271052],
              [4.788734756008857, -9.40134950559132],
              [4.784269286352469, -9.415199903602884],
              [4.779544969002576, -9.422202726387894],
              [4.773638607820894, -9.424554081616892],
              [4.767574160052817, -9.419948840015378],
              [4.760689551601076, -9.417535063193014],
              [4.753081694507123, -9.41915265882374],
              [4.746874103575682, -9.41772886569075],
              [4.740967362669297, -9.410143158188328],
              [4.733940903141187, -9.40539665548063],
              [4.730525417018709, -9.401253029370228],
              [4.714942558747677, -9.391393396937104],
              [4.708970221304844, -9.39446069792652],
              [4.692231507966054, -9.390286533304023],
              [4.678922410357157, -9.390135885833638],
              [4.671616796694172, -9.391526866710175],
              [4.649942995198946, -9.39035666393248],
              [4.640210229601664, -9.388997855196733],
              [4.592766976969789, -9.371951017610968],
              [4.57499513527416, -9.363803565397946],
              [4.561915486407661, -9.35262107065489],
              [4.550716853307671, -9.338427530931334],
              [4.531490613904397, -9.319300167472424],
              [4.532504474994933, -9.31464599210868],
              [4.535476537636806, -9.313887566584373],
              [4.539217621249991, -9.315852971602615],
              [4.545820288059498, -9.315227893400317],
              [4.5492198288988215, -9.316801595310668],
              [4.554231631634503, -9.315488900599098],
              [4.556595611633116, -9.312758493329152],
              [4.565867296959538, -9.311142376585847],
              [4.570927579306234, -9.305938931810719],
              [4.570516806109844, -9.300615818485731],
              [4.579469025714576, -9.293433186964384],
              [4.582747139699779, -9.287940554334199],
              [4.583044083398504, -9.283525539783744],
              [4.581197969470127, -9.277959187024443],
              [4.584288625548824, -9.273231897634512],
              [4.586495381747104, -9.263504830143699],
              [4.589698310775713, -9.25915177328023],
              [4.599570765648316, -9.255391484963093],
              [4.6018780243407855, -9.252278308154665],
              [4.6103678714293155, -9.24943542224978],
              [4.61235975088672, -9.251894668854955],
              [4.613162077000607, -9.257482181646276],
              [4.6117867223567846, -9.263075529524027],
              [4.613913802094766, -9.268189196026348],
              [4.6168837033882015, -9.269474557183107],
              [4.625694489483177, -9.28152288630321],
              [4.626927619983398, -9.289443894761549],
              [4.629122997009273, -9.291790459620506],
              [4.634051426587107, -9.29277436155137],
              [4.635776279952633, -9.29811221488242],
              [4.64132251747111, -9.303056255868835],
              [4.645862359700292, -9.30252292592157],
              [4.650153235478888, -9.3113155663528],
              [4.6531356706714595, -9.310757836008603],
              [4.656016592913926, -9.306212896963952],
              [4.659205241360577, -9.305643636660388],
              [4.661791227094741, -9.301420283762814],
              [4.667884475116014, -9.29477001123101],
              [4.673160360719953, -9.290411191485132],
              [4.677208333160076, -9.290413431957555],
              [4.681119158476537, -9.2937985594271],
              [4.6818983294473195, -9.296829316722993],
              [4.677643242020736, -9.302877633790285],
              [4.676470926775593, -9.306314437436582],
              [4.675431738758192, -9.320388346134155],
              [4.678243343516751, -9.326593557839502],
              [4.674848176577963, -9.335260970361283],
              [4.675676278699096, -9.341259146855226],
              [4.671654374883255, -9.34381503468316],
              [4.675510968920775, -9.348125591688556],
              [4.6788997247686055, -9.349389351097964],
              [4.684652257771736, -9.358211598889518],
              [4.682167551816301, -9.360384366435847],
              [4.678853781072434, -9.368638504430514],
              [4.676859329677847, -9.376314529951241],
              [4.678954624792407, -9.378666870095394],
              [4.683219256467492, -9.372719280311575],
              [4.686452614450191, -9.372966541951989],
              [4.6901545795279205, -9.370220113673234],
              [4.697804001033863, -9.371473885363894],
              [4.700300656117409, -9.361518472046807],
              [4.702792418667722, -9.361495424488442],
              [4.714069660113789, -9.364611467461875],
              [4.720520222702909, -9.360803102353326],
              [4.723587458904487, -9.35389042527861],
              [4.721595166950582, -9.351534630575868],
              [4.721717585453909, -9.345897715018884],
              [4.719608547757208, -9.341295154365941],
              [4.71378461089313, -9.339341563905023],
              [4.709144599973853, -9.331793392613047],
              [4.709646901916259, -9.327468024557717],
              [4.714984173742099, -9.322284478392614],
              [4.715404971810279, -9.31747507552471],
              [4.719248434177643, -9.312446620814677],
              [4.720094756218986, -9.306773827608934],
              [4.71782460104197, -9.297062966314144],
              [4.7120188060334, -9.291216176324411],
              [4.713282419656845, -9.287569437878464],
              [4.712279193475008, -9.280252074540128],
              [4.705986995133731, -9.272996647522154],
              [4.7011200155584705, -9.271196793861938],
              [4.696354550269667, -9.271334697411284],
              [4.690578025072, -9.269988127170535],
              [4.687993272025024, -9.264157387324524],
              [4.690864186578849, -9.261480674312027],
              [4.6806485898959975, -9.254525219427295],
              [4.672876010980075, -9.252664218335381],
              [4.6662379310634154, -9.252689951150328],
              [4.664186630502244, -9.249109599536604],
              [4.657722533246733, -9.2464653215466],
              [4.652410036472891, -9.246014631285028],
              [4.647464269973868, -9.241663463832028],
              [4.645171000229405, -9.22817257408116],
              [4.639425172567958, -9.22333484190383],
              [4.627824601219138, -9.221559396974513],
              [4.628287195944123, -9.211538558367772],
              [4.633222809236683, -9.197758872923833],
              [4.6278974528351675, -9.186542290312397],
              [4.624468352501067, -9.182886066239199],
              [4.614094638430048, -9.183249558669173],
              [4.600184996512212, -9.176239839482806],
              [4.59328111984818, -9.175946060668256],
              [4.591252362095131, -9.164799752048868],
              [4.583139385081224, -9.145717691584672],
              [4.576900767760657, -9.142940859883097]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.86632763779785,
          "lat": 29.414930929681717
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22109"],
        "coty_name": ["Terrebonne"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Terrebonne Parish"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00559517"
      },
      "bbox": [
        4.531490613904397, -9.552249166155056, 5.366839074185683,
        -8.827939676842064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [19.88429609193353, 9.874093391333918],
            [19.841959217957474, 9.850091187717394],
            [19.838013802596766, 9.85191751478978],
            [19.830689976225223, 9.849320970389936],
            [19.825020735211666, 9.851007216093816],
            [19.81962642580338, 9.854524232350727],
            [19.82749084643224, 9.84163495839865],
            [19.733796409554593, 9.787440617189352],
            [19.659885559139312, 9.745341653912378],
            [19.601937790784397, 9.711794783416686],
            [19.605582858177243, 9.706151338297298],
            [19.578680782794816, 9.6905576335442],
            [19.507581248639706, 9.651386322961544],
            [19.493465773858343, 9.653026845654928],
            [19.480468849413136, 9.697106367422908],
            [19.468300720536202, 9.737499691214301],
            [19.443152789012306, 9.82475572469732],
            [19.445279032961416, 9.825327682445671],
            [19.419173920907202, 9.913713575633599],
            [19.392459776645183, 9.999507627023288],
            [19.387492557240552, 10.00610591072095],
            [19.3763624549648, 10.041374570646736],
            [19.363357531279657, 10.084312016885537],
            [19.35818296276752, 10.09030295227968],
            [19.335226064821857, 10.167507429541764],
            [19.322424993916663, 10.208178942461133],
            [19.318457217956848, 10.222615561042527],
            [19.310847625963827, 10.245208108911092],
            [19.29920252959281, 10.28537411336914],
            [19.261682627801832, 10.409607142061535],
            [19.174442137636568, 10.384493483915207],
            [19.090195458692943, 10.360021804242244],
            [19.08652320534223, 10.37214446682587],
            [19.00387869667693, 10.348465301761783],
            [19.002309503745987, 10.348033920259352],
            [18.952837608063103, 10.514341709414118],
            [18.860183584061936, 10.487981436565228],
            [18.767537253324768, 10.461592479050942],
            [18.67489867840295, 10.435174853225307],
            [18.58226792181583, 10.408728575601504],
            [18.5018693853251, 10.38667330641057],
            [18.421476321960714, 10.364596594415579],
            [18.356326664592505, 10.34644228013212],
            [18.256086682959186, 10.318374185697717],
            [18.15585573740826, 10.290272714947424],
            [18.153238294513315, 10.308541283765923],
            [18.14052978519153, 10.409970405433215],
            [18.141513012722807, 10.413635312258613],
            [18.158980481544724, 10.46320039342551],
            [18.161509762986256, 10.471543367001473],
            [18.188386971499064, 10.548766593183675],
            [18.210108005968983, 10.61218244374855],
            [18.2346227358918, 10.682616072918208],
            [18.2591602985829, 10.753020338752101],
            [18.283720909101543, 10.82339507804336],
            [18.308304783383534, 10.893740128369416],
            [18.332952615831598, 10.964172835166448],
            [18.357624225964347, 11.034575429880398],
            [18.379088271610645, 11.095706669019743],
            [18.400570573683062, 11.156814959809692],
            [18.420548848727528, 11.21383328409421],
            [18.440543247358953, 11.27083144178972],
            [18.44413271040756, 11.269286431615456],
            [18.454036617578968, 11.26897974301001],
            [18.45603137195632, 11.267636719564418],
            [18.460393141024205, 11.27220921757534],
            [18.464829536492477, 11.271572481153262],
            [18.471458681777765, 11.276498160263602],
            [18.48218420098623, 11.273888393365867],
            [18.48661620892391, 11.27509671003248],
            [18.49449971344218, 11.27518413966761],
            [18.510602006104847, 11.272895479666571],
            [18.511949693600773, 11.273611410207081],
            [18.520105454463042, 11.269324335132195],
            [18.523092061881258, 11.27010682548008],
            [18.52501256140579, 11.265912069212233],
            [18.530714595757566, 11.267597155848847],
            [18.53302857484372, 11.263989680781886],
            [18.536186313921558, 11.264894632904213],
            [18.54436933483044, 11.2642362165769],
            [18.54693969050625, 11.267653144645577],
            [18.55087816729186, 11.269302581510532],
            [18.552669149802757, 11.275645314166825],
            [18.55855231264649, 11.27661736426387],
            [18.56484952676915, 11.271112251257835],
            [18.567369299012253, 11.274426460767751],
            [18.57243512141616, 11.268177743250622],
            [18.571540399690754, 11.264142877072675],
            [18.576418884921086, 11.26361259522728],
            [18.577454734716454, 11.257351384029633],
            [18.580756852831797, 11.256617196043177],
            [18.581922810104324, 11.252779183188533],
            [18.57576760235259, 11.249929538006777],
            [18.57635342494939, 11.240721108962802],
            [18.582264865521644, 11.235446661380516],
            [18.577888535118348, 11.233060056851755],
            [18.5742801883296, 11.225968806170425],
            [18.588511370781454, 11.179340859743512],
            [18.59142719311167, 11.167210499656328],
            [18.597688778643867, 11.160031803759413],
            [18.59767574318208, 11.151714232729242],
            [18.60121448445117, 11.145827189710246],
            [18.603570356726593, 11.139579328374596],
            [18.603655564809564, 11.135478724965916],
            [18.60914542377535, 11.127360074205294],
            [18.61102192887729, 11.112426223293152],
            [18.619595101845064, 11.104472362879147],
            [18.626172870160083, 11.101622152489249],
            [18.629800691926018, 11.101249285904894],
            [18.66674043102739, 11.092034647236185],
            [18.668595653051685, 11.090104809695905],
            [18.677982269201376, 11.087720808393202],
            [18.683448800590238, 11.082038354591266],
            [18.68822308466887, 11.084595471715392],
            [18.69222272037445, 11.081746750715004],
            [18.69544735025238, 11.08630047164659],
            [18.702855065718612, 11.081924967087163],
            [18.709543342165667, 11.081607986165855],
            [18.713189464850394, 11.079865824382788],
            [18.7149687543322, 11.075099038581001],
            [18.724405242406927, 11.07277370651204],
            [18.726984044657375, 11.06945940914304],
            [18.731259499624052, 11.067433746387918],
            [18.73269945274463, 11.073101501075305],
            [18.73650553444464, 11.073543544451855],
            [18.741270345012715, 11.07605028030604],
            [18.745051015145005, 11.08227426484897],
            [18.752413579927456, 11.084615460711019],
            [18.75856915803516, 11.092267325927498],
            [18.759517209216316, 11.095753326102676],
            [18.768657683581267, 11.104672658727234],
            [18.775823847712427, 11.114026987689678],
            [18.778313915902146, 11.11938754506625],
            [18.783841395833942, 11.12103289205893],
            [18.796908909120216, 11.130440982148],
            [18.807784549632814, 11.134597654512573],
            [18.814508780464624, 11.141223173809243],
            [18.823390506469842, 11.152714354659645],
            [18.827242029634917, 11.154569898998787],
            [18.83291078842885, 11.16107131118541],
            [18.839621154030752, 11.160762622680716],
            [18.844074562777774, 11.161880083349015],
            [18.848299919755267, 11.167720776726881],
            [18.85989528409862, 11.17062945755289],
            [18.8693013417221, 11.167392035934338],
            [18.872860715472655, 11.168818916666991],
            [18.875191480848738, 11.171866397955483],
            [18.878971793534188, 11.173195022614486],
            [18.88670329693098, 11.17809246053959],
            [18.89331028928213, 11.180093767619038],
            [18.90084469742085, 11.184737513187823],
            [18.90450856916327, 11.190499228037506],
            [18.909203177721178, 11.202085410643582],
            [18.902710289424775, 11.210795703581217],
            [18.905401924530942, 11.216510392848164],
            [18.905145638693806, 11.22185463635083],
            [18.910907774769544, 11.231161184409324],
            [18.915926345045428, 11.232111622673667],
            [18.92853160373931, 11.23090069074752],
            [18.93706075031452, 11.23636079253916],
            [18.941820252666307, 11.24535033191365],
            [18.94809190383087, 11.250688124652271],
            [18.95715898304025, 11.253583633835092],
            [18.962441056345448, 11.252813989964135],
            [18.966778173277714, 11.253826225426941],
            [18.975877320952282, 11.260269018935707],
            [18.982235484991143, 11.259419648653356],
            [18.990396065202, 11.251376707048891],
            [18.996576797460317, 11.250657484698737],
            [19.001364583756505, 11.253397664279186],
            [19.010586851300815, 11.25412351731048],
            [19.01681401856667, 11.26196532149634],
            [19.020182230672166, 11.263860868557838],
            [19.026666209233763, 11.264369392778539],
            [19.038806123190668, 11.267133446784639],
            [19.04250755730825, 11.270604002372638],
            [19.040399812114583, 11.277220714496494],
            [19.034053043133422, 11.28134197690126],
            [19.03263826967302, 11.284578860523581],
            [19.03369981930558, 11.289029332116497],
            [19.027791210814126, 11.300671086693146],
            [19.026692298607536, 11.305070619840116],
            [19.02687055925321, 11.311096128330563],
            [19.025777002478534, 11.321287619980723],
            [19.02897660937376, 11.330272390080568],
            [19.033362846107444, 11.336191822556563],
            [19.037115413935002, 11.33878370163155],
            [19.052723730277666, 11.346582348025596],
            [19.0668837955263, 11.346676856371364],
            [19.072937921583275, 11.3483167244891],
            [19.07721887973951, 11.353016537828054],
            [19.082556291325638, 11.355516137607612],
            [19.086862835351337, 11.354967186555502],
            [19.09168945069127, 11.352642064030718],
            [19.097175573829123, 11.351835410512587],
            [19.108377383010147, 11.355106011414737],
            [19.116389523084994, 11.360033593206026],
            [19.124104428288042, 11.35798506802334],
            [19.127041785661344, 11.352478653229008],
            [19.131477164189807, 11.350042273001023],
            [19.13621020313025, 11.34967278118991],
            [19.141917938466637, 11.351660878701338],
            [19.161994358645597, 11.347237271689568],
            [19.17203051678693, 11.348688967463499],
            [19.176735693217395, 11.347705975915549],
            [19.17960607943014, 11.3445981764941],
            [19.181075203427532, 11.337399890001654],
            [19.183057809212272, 11.3337502204087],
            [19.196977211913012, 11.323805030790316],
            [19.20328455914352, 11.323759524579772],
            [19.210847332112923, 11.318971335115007],
            [19.23164519386628, 11.314343223763503],
            [19.23929255945966, 11.311746631804533],
            [19.24431618381964, 11.307883145301233],
            [19.248563865322964, 11.30211142474197],
            [19.257499714305595, 11.301387854165883],
            [19.27661398992789, 11.296087149645055],
            [19.293725272236472, 11.289726857687581],
            [19.302430967872333, 11.284160429001508],
            [19.31792445376082, 11.272064195936803],
            [19.32929998744124, 11.272243423616285],
            [19.337247774283075, 11.270467021975165],
            [19.346506174347663, 11.26639540753038],
            [19.35064548306681, 11.254786908834703],
            [19.352336499670656, 11.254266289001176],
            [19.362217770261964, 11.245893794238123],
            [19.36628565143727, 11.240377356286311],
            [19.37467343849161, 11.232795241209091],
            [19.380752571594716, 11.23082357649486],
            [19.387797984370945, 11.2297651041493],
            [19.3946378418175, 11.221008232977685],
            [19.40425830559369, 11.216115952835377],
            [19.407904447280664, 11.21183407050131],
            [19.412870421601294, 11.198406472122196],
            [19.422955781738775, 11.1929972501572],
            [19.431946839614067, 11.193033374623477],
            [19.44380302600933, 11.19071148100413],
            [19.453597897823112, 11.187093046724941],
            [19.463278916701558, 11.187219082670007],
            [19.468743159345866, 11.185661818720432],
            [19.4739096773257, 11.182006682400942],
            [19.48950802928733, 11.1783456068258],
            [19.50975659372352, 11.115109726982775],
            [19.544774084412776, 11.003977712084659],
            [19.569487427388548, 10.923338848960373],
            [19.58050356009651, 10.889160146134856],
            [19.600797769498474, 10.824887552080414],
            [19.626670803889276, 10.742928993027764],
            [19.654564830698718, 10.658313780379542],
            [19.677132672130824, 10.589846642015246],
            [19.69663685390764, 10.529443029136011],
            [19.724878909425623, 10.441964486923206],
            [19.752319978536743, 10.35454733169508],
            [19.77881725910903, 10.270115527082101],
            [19.80582988456495, 10.184020346693865],
            [19.817483633986363, 10.145867263467721],
            [19.82378331757722, 10.12626072193986],
            [19.82867186768491, 10.118659323934198],
            [19.83757331347792, 10.117619004122387],
            [19.83830742624233, 10.11513171958064],
            [19.844481096263056, 10.114908143358184],
            [19.84433741706519, 10.112731027742266],
            [19.851556010023227, 10.108785517165481],
            [19.851449932135083, 10.10574543650098],
            [19.84773189160889, 10.099433015165284],
            [19.844879952829054, 10.099092713309874],
            [19.844025575992653, 10.090162474916545],
            [19.84561565348246, 10.087115077202023],
            [19.8390750899427, 10.081598202236057],
            [19.834798591741688, 10.080853094281295],
            [19.829326881050502, 10.07129978473278],
            [19.829050895952868, 10.067406235924674],
            [19.826153539202206, 10.065134358323688],
            [19.828194604486995, 10.056644446977735],
            [19.831651138626057, 10.051088808488476],
            [19.835629401388466, 10.048943533303683],
            [19.837780153944443, 10.045045637665718],
            [19.844733959879438, 10.038697394475838],
            [19.850646148524596, 10.035090785427023],
            [19.859526322029538, 10.032448733773656],
            [19.866351245154934, 10.026976860425345],
            [19.869441832412324, 10.022239432002642],
            [19.876025123931104, 10.01923420068557],
            [19.869674794264686, 10.012033755536553],
            [19.862277567984076, 10.010513241451509],
            [19.86128281678782, 10.00711027004082],
            [19.850607772241474, 9.990868723502336],
            [19.850109306553787, 9.981640076868954],
            [19.8559188075837, 9.96990975639917],
            [19.858162049902177, 9.958375807542264],
            [19.85640231758775, 9.955517106062326],
            [19.86178693138199, 9.94469324661951],
            [19.872033605235565, 9.942791181890678],
            [19.885169182936266, 9.926810114110147],
            [19.867065374592446, 9.919385879319078],
            [19.88121532767948, 9.889522503393032],
            [19.872068734915068, 9.88427511958923],
            [19.88429609193353, 9.874093391333918]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -68.59890505089902, "lat": 46.65891504320638 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23003"],
        "coty_name": ["Aroostook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Aroostook County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00581287"
      },
      "bbox": [
        18.14052978519153, 9.651386322961544, 19.885169182936266,
        11.360033593206026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.853622022202034, 1.0743231044852075],
              [15.854750084528709, 1.0762464549293285],
              [15.85309982593861, 1.0817792264215584],
              [15.856848882765822, 1.0881689243035568],
              [15.853322077405066, 1.092806114171376],
              [15.851300462799678, 1.1013565041058317],
              [15.866039135100543, 1.102756636098636],
              [15.870587175471929, 1.106713157713923],
              [15.871370856611021, 1.113243950830543],
              [15.864241858535328, 1.1151967288904956],
              [15.86239170950119, 1.1179709219864886],
              [15.87086528064823, 1.1185980320037945],
              [15.875397166985696, 1.12091756815053],
              [15.887194957204883, 1.1115940685564234],
              [15.883298801031547, 1.1065281762903918],
              [15.884777500564741, 1.1026975272519592],
              [15.889970359458902, 1.1049604664061714],
              [15.89741516619219, 1.1031917074325897],
              [15.901973130757067, 1.0956025801521267],
              [15.898172424132438, 1.0892503460594325],
              [15.890709443139704, 1.0864092317951817],
              [15.895159653524779, 1.079737138915509],
              [15.9011319402916, 1.0752045552872296],
              [15.899821417107917, 1.068816733934656],
              [15.89565868510096, 1.066803091440771],
              [15.893738945596255, 1.0680838685352236],
              [15.885582424988922, 1.0650226709687167],
              [15.882665093241613, 1.0673320432544058],
              [15.878869401996415, 1.0762665108491056],
              [15.874177347091907, 1.0845270551691342],
              [15.871100652656061, 1.0860904575155579],
              [15.868420368539265, 1.0822405282334158],
              [15.867714505246411, 1.0775577003887944],
              [15.863907475645206, 1.0714430574273732],
              [15.860090514175724, 1.0715953526585353],
              [15.858086571833937, 1.0685649283207777],
              [15.853622022202034, 1.0743231044852075]
            ]
          ],
          [
            [
              [15.682667008627229, 1.222730617022793],
              [15.686564353386016, 1.222768557030901],
              [15.688018543554893, 1.218554858681263],
              [15.69519952225664, 1.2104500918648888],
              [15.691320860558003, 1.2068737494271944],
              [15.689876302696542, 1.2134965803430857],
              [15.687304585573743, 1.2152307749813267],
              [15.682667008627229, 1.222730617022793]
            ]
          ],
          [
            [
              [15.813380152845728, 1.4881405967961843],
              [15.816864152356219, 1.4904634527904006],
              [15.825893167246123, 1.5052327944878874],
              [15.83140168203987, 1.5105714727890218],
              [15.837139090552114, 1.5135917597937092],
              [15.839076666895771, 1.5191047479909814],
              [15.841305826161634, 1.5299134489823207],
              [15.840589601208507, 1.5372139378061183],
              [15.836284272629992, 1.547496289811598],
              [15.838375462529255, 1.553266240310619],
              [15.846778000398556, 1.5661745839920165],
              [15.850799843723024, 1.5742605821510363],
              [15.851614078637063, 1.5800687486004559],
              [15.849312074122695, 1.589868489526476],
              [15.852522058027027, 1.599163308398185],
              [15.85487207612309, 1.6020457338824818],
              [15.859945063721375, 1.6093545444424313],
              [15.862731433090826, 1.6103684820167579],
              [15.866118051269819, 1.6063931472149262],
              [15.87023146959928, 1.6134849304536127],
              [15.87363163092279, 1.6130711105779703],
              [15.879515839747555, 1.621602511521612],
              [15.882535581020845, 1.6219509679924045],
              [15.885903861557704, 1.6348036258630463],
              [15.88731966311816, 1.6362131546515961],
              [15.89287515806134, 1.6322493241561538],
              [15.901325095358136, 1.6320583566882874],
              [15.907128555054369, 1.6340497931356772],
              [15.914993986419061, 1.6428768335958617],
              [15.925413584376527, 1.6478235275011683],
              [15.929612175051487, 1.6489399807457934],
              [15.947342394640721, 1.6468595443364473],
              [15.954790209948943, 1.6485477529795192],
              [15.959456127897676, 1.6480609785085634],
              [15.965394564819437, 1.6281001173603116],
              [15.974197689352815, 1.6309837872259916],
              [15.979357078164842, 1.631266404120559],
              [15.983803533567551, 1.6334534176283202],
              [15.98562197019021, 1.64225906123536],
              [15.990254817584777, 1.6436721510844035],
              [16.003843526477258, 1.6309681172464396],
              [16.013622785213354, 1.627142524732743],
              [16.02285917176099, 1.6198946258992075],
              [16.035299974794015, 1.6117211992246656],
              [16.042959145686613, 1.602598651632878],
              [16.063317166901307, 1.5298922586314851],
              [16.05993904956883, 1.528961656190778],
              [16.057610116842184, 1.5184712483127787],
              [16.050137313277713, 1.5068896786534853],
              [16.045012902921144, 1.5024617338954682],
              [16.035431363026287, 1.5001383903653096],
              [16.030965504856333, 1.489838222916431],
              [16.03179717587419, 1.4761571384533285],
              [16.030079199729037, 1.4704214969654177],
              [16.02688759325381, 1.4659692971083222],
              [16.014998420982476, 1.4583581662284912],
              [16.007421272341485, 1.4471978751491206],
              [15.992625609517766, 1.4403109148135962],
              [15.987828485666416, 1.4312512932583985],
              [15.989504148603043, 1.4264367093869128],
              [15.996320391199356, 1.4210519259553769],
              [15.99691561952412, 1.4149160333348971],
              [15.985640486492189, 1.4066140500268014],
              [15.984950939924126, 1.3966224505841602],
              [15.988680354181907, 1.3926289344549674],
              [15.993857575604787, 1.3924925312480065],
              [15.998505892848582, 1.3904270512192316],
              [16.00037132474178, 1.3873437620088604],
              [16.000489439959548, 1.381430256745947],
              [15.998717292228667, 1.3761297455094754],
              [15.996168490627268, 1.3735617683467214],
              [15.985333535563884, 1.3705346930497766],
              [15.983828535183855, 1.3693051327956425],
              [15.983431237901641, 1.3513220638058616],
              [15.984088913650364, 1.3471389166592922],
              [15.99235478401126, 1.341414690143763],
              [15.996604498377115, 1.336540503945214],
              [15.995675056651756, 1.3335604540497388],
              [15.984216842524129, 1.3316738660004168],
              [15.980372172572139, 1.3290212117712188],
              [15.978244109783878, 1.3245835466029638],
              [15.973840771094487, 1.3212271143334842],
              [15.977159457581655, 1.3150127768371773],
              [15.979059923856006, 1.3140748360471908],
              [15.983029705886409, 1.3079045450395081],
              [15.983412415159789, 1.3048115165817842],
              [15.977366620728771, 1.2995661127454952],
              [15.962711627547494, 1.2904515908281944],
              [15.957827796001588, 1.2890180201137704],
              [15.956133165374759, 1.285479236976076],
              [15.949965545542687, 1.2807878217934658],
              [15.948989672964554, 1.2765361755454123],
              [15.952341775696253, 1.2646397446248543],
              [15.947931826594775, 1.2625448002965314],
              [15.945883569870817, 1.2584474496795452],
              [15.943121952549102, 1.2567971448653013],
              [15.941353986746607, 1.2469832671029086],
              [15.938822929795363, 1.2455746815217676],
              [15.9378027496165, 1.240638692730423],
              [15.939607751208218, 1.2377234810768627],
              [15.937682650189743, 1.2319462954399534],
              [15.938539293850502, 1.2275073501643403],
              [15.943617036131027, 1.2221926179762952],
              [15.942177700173152, 1.21846360293058],
              [15.944590737265814, 1.2104613885712199],
              [15.94395547923501, 1.20487783977381],
              [15.937747375611442, 1.200419917108723],
              [15.934262820638672, 1.1956576476212664],
              [15.93842325491819, 1.188431952292085],
              [15.936888500523487, 1.184755097081636],
              [15.942123167609028, 1.181650808432537],
              [15.945317525032873, 1.1826889720448195],
              [15.948683983748925, 1.181094087205062],
              [15.944184794837067, 1.170429196252763],
              [15.92896808025332, 1.1633528251005911],
              [15.932101118709678, 1.1715382324492394],
              [15.931575012304746, 1.1820630867659567],
              [15.927463627855264, 1.1849013558119657],
              [15.913165538059733, 1.19161904737256],
              [15.913368386006493, 1.1959241776630662],
              [15.910240852333567, 1.2039247750592905],
              [15.908131433314916, 1.2029412407268862],
              [15.903296228002473, 1.2085659309575418],
              [15.891912872232753, 1.218895640443521],
              [15.892555093475428, 1.2216518409338508],
              [15.887669243239866, 1.2236055610419256],
              [15.88586777255487, 1.2269394635438435],
              [15.878483053624953, 1.2283448089610722],
              [15.877267189034782, 1.230046777819485],
              [15.883226385708484, 1.234575417646814],
              [15.903363220109815, 1.2418559561317133],
              [15.907129223505738, 1.2440857345518077],
              [15.913994966938784, 1.2517154638145502],
              [15.915091470181777, 1.2607080541625166],
              [15.912109909193624, 1.2728700149181216],
              [15.914407292677115, 1.2762482398926833],
              [15.906599373036988, 1.280229134249151],
              [15.898329859759102, 1.2931245882162434],
              [15.886655758200575, 1.2943653973634683],
              [15.883026546249638, 1.2936860577648688],
              [15.878524455634064, 1.2975340503149784],
              [15.866747720508354, 1.2956930247829082],
              [15.869177075978303, 1.292268139855663],
              [15.874058219755243, 1.2906167626004146],
              [15.87111871727891, 1.2849486102014325],
              [15.87091560653245, 1.2770567479774406],
              [15.872219254671416, 1.2727175017138912],
              [15.872337753238542, 1.2535947650440697],
              [15.866999279404165, 1.2498577601924588],
              [15.861694586373984, 1.241286113737254],
              [15.856091963155702, 1.2389834087436016],
              [15.853885853424426, 1.2344969224437088],
              [15.852681172512533, 1.2253094090984393],
              [15.844083091907246, 1.219181496143764],
              [15.844699750917764, 1.2180617255507344],
              [15.853350538233315, 1.219781925127011],
              [15.861592480485807, 1.215287556996601],
              [15.867628537566226, 1.2079617913002163],
              [15.871713650504235, 1.2070333987988227],
              [15.873457906234412, 1.2022655360717933],
              [15.875807265022196, 1.2011447652118477],
              [15.872718428815503, 1.1940198964758404],
              [15.873992389685364, 1.1878789104025405],
              [15.872234728703797, 1.1779132756454889],
              [15.87199936677022, 1.168176180694161],
              [15.864555135489535, 1.1665313693615444],
              [15.863258293997394, 1.1637509125911836],
              [15.871133350548286, 1.1591377908975038],
              [15.87987568303655, 1.149515617897816],
              [15.880460478867745, 1.1436622105369643],
              [15.883883753268572, 1.1412692146886219],
              [15.885574738553935, 1.1364103434137465],
              [15.877513321401182, 1.1402933564936608],
              [15.877182682415286, 1.1432062225786876],
              [15.87259076700077, 1.1443481339802395],
              [15.867808596325958, 1.1432035658874429],
              [15.863236058529594, 1.1437297586703843],
              [15.857294904603318, 1.1486636518828852],
              [15.850269535240493, 1.1558744163523298],
              [15.849441357142586, 1.1596195921511914],
              [15.845035494689938, 1.165459753839002],
              [15.84212397848002, 1.1671525893174088],
              [15.839453233090579, 1.1637192676099521],
              [15.83458499012398, 1.1647258987870932],
              [15.829747061841758, 1.1629173415367644],
              [15.828687740073082, 1.1719124743349043],
              [15.834527182627097, 1.172664426351119],
              [15.836572201500612, 1.1763732878316364],
              [15.84015659700091, 1.1790626439237233],
              [15.838417810513686, 1.1823519341751414],
              [15.833243917341138, 1.1826967960388834],
              [15.830870174620696, 1.1894142088796853],
              [15.824544832440395, 1.1874030089516718],
              [15.8212498898333, 1.1889096181950893],
              [15.821673175121704, 1.1931394512612172],
              [15.816311323972231, 1.1997031176292376],
              [15.814718164886326, 1.1960908388977203],
              [15.81003972117552, 1.1950013631059067],
              [15.806545904673293, 1.1981103817059973],
              [15.81302606267431, 1.2022781670274667],
              [15.805064057492011, 1.2059782366020997],
              [15.804364919098742, 1.2101604679139915],
              [15.801717675278502, 1.2101765120360197],
              [15.802180467283303, 1.2048841763229041],
              [15.799924841788064, 1.203058620597648],
              [15.79623950613952, 1.2057413156988985],
              [15.792731307316682, 1.2040341967734869],
              [15.794648619707608, 1.2007832805108456],
              [15.79511789680857, 1.1950114369446476],
              [15.794038933604035, 1.1920868503699502],
              [15.799285619466964, 1.1869423759736712],
              [15.790986773730927, 1.1830830996823674],
              [15.789893226997444, 1.178625036602267],
              [15.784044539119956, 1.1733130196201922],
              [15.78388611140936, 1.1789597116473758],
              [15.781667816455876, 1.1844908501649087],
              [15.787932907549553, 1.1941616915220943],
              [15.786641074627655, 1.198027311738555],
              [15.791368436618013, 1.2042271029222134],
              [15.788533109389842, 1.2118057856489775],
              [15.779905109024918, 1.214210939950922],
              [15.77994369276417, 1.210466702235125],
              [15.772448084902667, 1.2116163085194824],
              [15.767751952994963, 1.2136576918951894],
              [15.764138326258577, 1.2128924599556088],
              [15.754427167680232, 1.2199768542507494],
              [15.747163805802934, 1.2172854226310912],
              [15.74718221547985, 1.2136332159966616],
              [15.742050444111653, 1.2088919691760325],
              [15.739227136841187, 1.2110853772400476],
              [15.737420564889023, 1.2156101689177152],
              [15.744433098247221, 1.2181515408716102],
              [15.745957913851324, 1.2216482076424517],
              [15.741673987817471, 1.2258408990569345],
              [15.745842343352484, 1.2306664739028763],
              [15.750000016787183, 1.2288527463505161],
              [15.75367927718841, 1.223955642930659],
              [15.760541299594811, 1.21828864318524],
              [15.766805881234895, 1.219903075887537],
              [15.765402806538935, 1.225186855112174],
              [15.763063302682552, 1.227769778542353],
              [15.757615542376964, 1.2285409458009888],
              [15.754301296981218, 1.230820716503347],
              [15.754247023512294, 1.2368698413986403],
              [15.751949441406246, 1.2414813310939132],
              [15.746451596287603, 1.2469542295485472],
              [15.742539057907573, 1.249395586777249],
              [15.741249421765188, 1.2532576440827567],
              [15.73561851782916, 1.25312442920916],
              [15.729178434316784, 1.2550319051758436],
              [15.729697104755687, 1.257930698712541],
              [15.721973074151672, 1.2610087676079942],
              [15.719786393431384, 1.2557394055714395],
              [15.713797119894501, 1.252840044725552],
              [15.711287664141626, 1.2598094874691315],
              [15.713787737948499, 1.2622596929270664],
              [15.713505813224172, 1.2667185338607057],
              [15.709799205285817, 1.2775664935013307],
              [15.702503024439855, 1.2813120516784096],
              [15.697289345390352, 1.2787703537603172],
              [15.697190235528133, 1.2743282566010312],
              [15.702851757701682, 1.2671612926440379],
              [15.700389120702962, 1.2658718987669115],
              [15.699781179758098, 1.2602648262680425],
              [15.70238726412787, 1.2528358340978953],
              [15.700970072549467, 1.2506135688371973],
              [15.706556515750377, 1.242465862573631],
              [15.70701019392634, 1.239869614767407],
              [15.715955324542202, 1.230121836001185],
              [15.72335237651049, 1.2272592983371882],
              [15.726104570616608, 1.21870248636515],
              [15.720409013990373, 1.215287391259029],
              [15.71906404622839, 1.2118284580709433],
              [15.721287110816965, 1.2084500503523834],
              [15.720771542188682, 1.2015103917734669],
              [15.725249775121796, 1.196393753577753],
              [15.735661676984254, 1.1908951548108064],
              [15.741268836913948, 1.1831293472854236],
              [15.74509066200815, 1.1833592691002457],
              [15.745673947621327, 1.1868517717164104],
              [15.75119858904021, 1.188404850274211],
              [15.757075663110456, 1.1869525817843636],
              [15.76214751348264, 1.1933197637698865],
              [15.764393493011863, 1.1898489173738616],
              [15.759214732912564, 1.1857684883752386],
              [15.763542631875808, 1.181237651828661],
              [15.759013981724861, 1.1773517158184093],
              [15.760928344370845, 1.1656261002867168],
              [15.766799659548152, 1.1574909345849536],
              [15.775975882931208, 1.1517676892817008],
              [15.778978560324939, 1.1470267467781465],
              [15.78751078633968, 1.1485615493634083],
              [15.791715549177269, 1.1505145396989238],
              [15.798056336524377, 1.1486593050117793],
              [15.801974731066581, 1.1488967615068906],
              [15.808093375813778, 1.1470426517730823],
              [15.80960691823217, 1.1433055792772562],
              [15.80729132963617, 1.1382669498252336],
              [15.803584907772755, 1.1349770250266817],
              [15.799820114335143, 1.133820639501773],
              [15.792239737462344, 1.1349540527227338],
              [15.791762419435695, 1.1369056394751555],
              [15.78271074260121, 1.1439470899662783],
              [15.772741284020235, 1.1446288640768978],
              [15.764762681886697, 1.1542013633090875],
              [15.758712882729233, 1.1582908493165807],
              [15.752323415762659, 1.170514781853901],
              [15.747735072367025, 1.1763099757915565],
              [15.743419375835884, 1.178004344161854],
              [15.73575113271728, 1.1889875240298857],
              [15.731089453070206, 1.1923583139243479],
              [15.720290478450202, 1.1952518380106285],
              [15.714806663182863, 1.2010222115219846],
              [15.713070872485948, 1.207807501667128],
              [15.710130560270395, 1.2090526310901057],
              [15.711290557593268, 1.2155749518265144],
              [15.707161961971169, 1.2217253265416734],
              [15.705869449576392, 1.2309741305241972],
              [15.701105968775977, 1.232802580806877],
              [15.69460662883836, 1.2423832573128604],
              [15.690193870567676, 1.2440705033564525],
              [15.689203324310014, 1.2470364150804985],
              [15.683134399227903, 1.2488092545501945],
              [15.676849673948364, 1.2532535867697436],
              [15.671446042278182, 1.2540015156453588],
              [15.669723259331002, 1.2588313174106365],
              [15.663842019702175, 1.2604489103764904],
              [15.662707530281306, 1.2643708951634514],
              [15.659527409831592, 1.266597520929733],
              [15.658605666852685, 1.280859303002421],
              [15.653269983841495, 1.2926683010614068],
              [15.647840688920065, 1.298975501361662],
              [15.643356010330995, 1.300737123556098],
              [15.629033766036487, 1.3209742349257463],
              [15.624134105054203, 1.322234720528568],
              [15.621734424103995, 1.3283686845355465],
              [15.614229293264033, 1.3320542173690921],
              [15.609425186663065, 1.3385498973428243],
              [15.603362262911219, 1.3442719242092795],
              [15.60101224582684, 1.3500874162800987],
              [15.606336520886739, 1.362660038418137],
              [15.601659253986417, 1.3666592265419273],
              [15.60603794685008, 1.368502792588371],
              [15.615294977576953, 1.3678189023592036],
              [15.62272940730802, 1.3744732051905144],
              [15.631448209144597, 1.3786092843336109],
              [15.63196840376121, 1.3737072318992725],
              [15.637467118968674, 1.3721778610186688],
              [15.643757419910024, 1.372254605174582],
              [15.64952484895534, 1.3761554238459233],
              [15.650153089665915, 1.3816605648888285],
              [15.655183142818872, 1.3996704823960082],
              [15.657746744001896, 1.4050710277472251],
              [15.668472652863356, 1.4103692781798083],
              [15.672977882820676, 1.4099766151267517],
              [15.676594103020062, 1.417358373429217],
              [15.672964348750261, 1.4247448136403447],
              [15.663466978651813, 1.4242749149340894],
              [15.657208473198606, 1.4185219319879945],
              [15.648096618055602, 1.4213221811497379],
              [15.638606660492604, 1.4203774046260855],
              [15.634749671532822, 1.4118942846045919],
              [15.631061317266663, 1.4115790709188105],
              [15.6316376878137, 1.4236359090507809],
              [15.63036145499498, 1.4288646138308065],
              [15.624209420805771, 1.4364878373176235],
              [15.622143190780386, 1.437126924583095],
              [15.61591505649817, 1.443035531389497],
              [15.608879905614891, 1.44191614485758],
              [15.607371305295116, 1.447308470723699],
              [15.611449803227547, 1.45474512988306],
              [15.614356228420144, 1.4511260825327843],
              [15.621649837851356, 1.4499774923150792],
              [15.62440669545422, 1.4569781847241177],
              [15.628302396630987, 1.4599068683310532],
              [15.630454921802626, 1.4635229781266994],
              [15.629122215012378, 1.4671706001523264],
              [15.624722524245156, 1.46852914832127],
              [15.62618573924459, 1.4746944987076114],
              [15.630146411079766, 1.4765849494187915],
              [15.628343454908357, 1.4815704710359845],
              [15.624043144386844, 1.4805689467247627],
              [15.621813012726323, 1.4781951535344808],
              [15.619276503222165, 1.4830954480183607],
              [15.61557585104904, 1.4866604018391492],
              [15.612428249041479, 1.4942173042271205],
              [15.615409851809757, 1.4965685016474024],
              [15.620040150215019, 1.4918738162436078],
              [15.618980628584673, 1.487646273515198],
              [15.622677497961064, 1.4866038721560684],
              [15.62602617801692, 1.4885541388736825],
              [15.625964183969932, 1.4925518393013406],
              [15.63669295458034, 1.4950165810892697],
              [15.631759089603907, 1.5011371013818093],
              [15.642855890596838, 1.5087582232641834],
              [15.646271094318967, 1.5063228012705574],
              [15.645311201438492, 1.4982706640650347],
              [15.647640834914846, 1.494355905769548],
              [15.651155278063134, 1.4967283029685292],
              [15.664072641646705, 1.4947121329476587],
              [15.6668766761686, 1.4925444864010364],
              [15.673129503237764, 1.4979952095215525],
              [15.679710085125828, 1.5086260892129888],
              [15.6835177465908, 1.5108518727879958],
              [15.689622443655507, 1.518924837987792],
              [15.69567274644639, 1.5204683004760084],
              [15.699824249771561, 1.515154352313979],
              [15.701550659420105, 1.5083344506074488],
              [15.70097333641212, 1.4950847222729107],
              [15.70803681388292, 1.4892584190861324],
              [15.714461602779814, 1.4913290472357503],
              [15.720870507134874, 1.5032284205578108],
              [15.72934812907804, 1.4942923122936471],
              [15.740763006462963, 1.4870324696088641],
              [15.746124567661752, 1.4848155776031857],
              [15.754798522460048, 1.49135473246773],
              [15.762395439364315, 1.4985280021308849],
              [15.766577097211359, 1.4921320495201846],
              [15.773321296857373, 1.4927032218745506],
              [15.774492452537727, 1.4871998633050458],
              [15.780688367944977, 1.4837240106887395],
              [15.786596447665039, 1.4824877219871049],
              [15.788853553279173, 1.480282707930716],
              [15.795281779745084, 1.4792537077455592],
              [15.801209270882575, 1.4757210081384653],
              [15.80442613477279, 1.4756394311084164],
              [15.816027889422577, 1.4830034063016508],
              [15.813380152845728, 1.4881405967961843]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.01228537134998,
          "lat": 38.483149998270875
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24019"],
        "coty_name": ["Dorchester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dorchester County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00596495"
      },
      "bbox": [
        15.60101224582684, 1.0650226709687167, 16.063317166901307,
        1.6489399807457934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.194211034109497, 5.667139009763591],
            [17.219781085834104, 5.705684323845473],
            [17.262016395289383, 5.712834137913213],
            [17.26485414554002, 5.704028599639236],
            [17.27141070212192, 5.706803868470219],
            [17.29099517535826, 5.642247808916767],
            [17.274735147458976, 5.6111387369124115],
            [17.308876293061807, 5.596137971778942],
            [17.310676166232458, 5.612923065613266],
            [17.313425110312377, 5.622082810811421],
            [17.34387465551884, 5.634288954113597],
            [17.346922396358153, 5.624667165758805],
            [17.360133890008786, 5.629903238609885],
            [17.365911311782156, 5.611146257153682],
            [17.372967839734375, 5.612864372340115],
            [17.378000102705435, 5.59601796535091],
            [17.449226956038178, 5.596829319686229],
            [17.44833682160469, 5.602225987805123],
            [17.43936115821883, 5.625035703050142],
            [17.45313821509338, 5.632009720642661],
            [17.452562480679518, 5.641112890801638],
            [17.460018269835427, 5.6453304560799],
            [17.46435665730132, 5.69413640791785],
            [17.476623638007712, 5.7099272402957455],
            [17.482700337605298, 5.709584916146204],
            [17.486353689378305, 5.7071889783884036],
            [17.49084604540176, 5.69658155866431],
            [17.49094496588644, 5.691940515574264],
            [17.48674182970847, 5.685926365873505],
            [17.48244351203697, 5.672238781988258],
            [17.481337572580706, 5.658523542734969],
            [17.483718708764183, 5.65380054588536],
            [17.48978549658078, 5.651803159718802],
            [17.494721009942268, 5.645402492142255],
            [17.501038630361357, 5.641245196803581],
            [17.508993198558795, 5.640848128966314],
            [17.55656228033689, 5.660181304638242],
            [17.609493244402262, 5.682289373759176],
            [17.639137764266746, 5.69450676963923],
            [17.65658686363987, 5.651249342554817],
            [17.68068733401094, 5.661892659565165],
            [17.679370501856503, 5.667944329334176],
            [17.674295206667765, 5.673720029039411],
            [17.678024687502454, 5.680713953069913],
            [17.682093611209876, 5.6796864915935625],
            [17.68527637803268, 5.6843915569784675],
            [17.68424142875188, 5.689495908055565],
            [17.686651735372184, 5.693469233154433],
            [17.6904937289221, 5.695399406126531],
            [17.72577015534939, 5.719697864512851],
            [17.72883009559078, 5.718492088445264],
            [17.73290456627474, 5.7236848118313155],
            [17.736499865644884, 5.716517509355038],
            [17.743925763828, 5.7189843205162285],
            [17.748437264367062, 5.73276394777416],
            [17.766027648322115, 5.740499063146441],
            [17.74703938564076, 5.691507072949146],
            [17.747131065227865, 5.685523988932332],
            [17.749166189376783, 5.6817763512047765],
            [17.750886564699208, 5.673144736016388],
            [17.801645492365598, 5.662732519050932],
            [17.80444835888198, 5.655606211849301],
            [17.84831443611025, 5.675141951164789],
            [17.86603589355372, 5.606091271071394],
            [17.88072305024713, 5.547322623244734],
            [17.830951294159217, 5.535505787278883],
            [17.799058612656893, 5.5279537755801895],
            [17.750657108079864, 5.515966755152931],
            [17.650389530523817, 5.492811105552544],
            [17.59922373113464, 5.480256718792404],
            [17.56798967953646, 5.468131795091844],
            [17.562817658522135, 5.461206878471406],
            [17.54514532803431, 5.457095004592625],
            [17.543006789119985, 5.462555534232559],
            [17.517433332557932, 5.457819122932693],
            [17.478589799655396, 5.4526721755200525],
            [17.435868729293393, 5.441431880943359],
            [17.43535939866346, 5.438308791413802],
            [17.440265821756014, 5.436324525680792],
            [17.437759236164425, 5.422061796003833],
            [17.435444516286232, 5.411876745100042],
            [17.4361606043838, 5.407197764366401],
            [17.401674616370915, 5.393063545182944],
            [17.394503396602314, 5.4314774506009815],
            [17.370358390915403, 5.425912139028087],
            [17.358353523502085, 5.423785045851981],
            [17.260832109890323, 5.40072171068424],
            [17.22206211135859, 5.392454279396467],
            [17.217907685156746, 5.399238969612625],
            [17.217977849902717, 5.407073464233836],
            [17.216815372222754, 5.409483378727511],
            [17.210694583552158, 5.412463274697193],
            [17.212104913738028, 5.417779253163962],
            [17.208555711785984, 5.420920611061491],
            [17.194808862912506, 5.441891965233095],
            [17.190680496517228, 5.453199809312744],
            [17.19090286556778, 5.458971192484377],
            [17.1965666958602, 5.464659169519383],
            [17.197123369197765, 5.468448903905472],
            [17.19211126538522, 5.472797392215884],
            [17.18775480632406, 5.480439462191853],
            [17.186835313706524, 5.486138242106556],
            [17.183625247826985, 5.490080626144121],
            [17.183231870640533, 5.494792266960805],
            [17.21020544976568, 5.496702871666304],
            [17.206691026501375, 5.59364606866096],
            [17.20612100076328, 5.606858604492241],
            [17.207945140473438, 5.60696607441626],
            [17.194211034109497, 5.667139009763591]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.63162742786857,
          "lat": 42.135090361969134
        },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25013"],
        "coty_name": ["Hampden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hampden County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00606933"
      },
      "bbox": [
        17.183231870640533, 5.392454279396467, 17.88072305024713,
        5.740499063146441
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.502510641569001, 5.26715973993217],
            [8.559400369643587, 5.27399355669614],
            [8.63070815459324, 5.282222955764173],
            [8.673545762401778, 5.287302583865028],
            [8.730220378032968, 5.294283606132444],
            [8.843963221279731, 5.307994075017334],
            [8.853356093670998, 5.232093507844152],
            [8.865635890738767, 5.1352623838140765],
            [8.87929731790054, 5.0305896802905385],
            [8.886808340617424, 4.972764567246924],
            [8.8881927081628, 4.962328148194208],
            [8.804664802403307, 4.9518361251511935],
            [8.726137507170655, 4.94242498704202],
            [8.641935605207022, 4.932713115086057],
            [8.549923744302596, 4.92263580689237],
            [8.543838817790482, 4.9752585412648855],
            [8.530643453000962, 5.095161963235859],
            [8.52325490594547, 5.094325118796113],
            [8.513431529521398, 5.18080228297928],
            [8.502510641569001, 5.26715973993217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.60491899725774, "lat": 43.29273033478645 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26057"],
        "coty_name": ["Gratiot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gratiot County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01622971"
      },
      "bbox": [
        8.502510641569001, 4.92263580689237, 8.8881927081628, 5.307994075017334
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.019767541831705, 3.922736094635244],
            [9.104407165357369, 3.932986439946789],
            [9.153927630785825, 3.93967606840475],
            [9.189218071350732, 3.9418446484269833],
            [9.279507795984314, 3.955257223503284],
            [9.278814060054698, 3.959632309656975],
            [9.285253473897338, 3.960460627545074],
            [9.365260788012119, 3.9730332819990877],
            [9.449618609260321, 3.9859410090046206],
            [9.462691471799875, 3.8992611694298813],
            [9.472954126746352, 3.8269764337931615],
            [9.478402363832979, 3.7902898170833055],
            [9.488174843242327, 3.725969262067438],
            [9.492053168990232, 3.702722225463541],
            [9.503905295458408, 3.6292523998983888],
            [9.433378969358321, 3.617847116977203],
            [9.418209632232731, 3.614727911999927],
            [9.403987222386935, 3.6127793142232947],
            [9.331567763060916, 3.6003840887135166],
            [9.316502261883041, 3.5983209244151433],
            [9.23240667968276, 3.583948935771482],
            [9.14805074459442, 3.570175251424539],
            [9.06701331803218, 3.5570420662921136],
            [9.06284770549319, 3.588432128770839],
            [9.046499128700523, 3.7143440239848933],
            [9.031194837516802, 3.8357981051834784],
            [9.019767541831705, 3.922736094635244]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.06640319172261, "lat": 41.89511797187069 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26091"],
        "coty_name": ["Lenawee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lenawee County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01622988"
      },
      "bbox": [
        9.019767541831705, 3.5570420662921136, 9.503905295458408,
        3.9859410090046206
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.949842201125833, 5.555950339134277],
            [7.9923928519125464, 5.560592225766227],
            [8.035132792682838, 5.564687699855747],
            [8.161685290915045, 5.578041081031422],
            [8.22504726171738, 5.584848159997784],
            [8.288283354133402, 5.592123758541459],
            [8.294796887381942, 5.539139576340048],
            [8.29939594700989, 5.505732066647475],
            [8.309933968670347, 5.419378346619027],
            [8.315355464836466, 5.375962553243069],
            [8.331000338491421, 5.247273883929055],
            [8.302873170944281, 5.244263380198714],
            [8.245260802143706, 5.238684001286412],
            [8.159693377732607, 5.22946653663683],
            [8.134077630490298, 5.226922978277297],
            [8.074025918502848, 5.220268415163588],
            [8.05975393592682, 5.218562842393641],
            [7.98813952811747, 5.210711540263007],
            [7.974598677737132, 5.331378758585945],
            [7.969055211008331, 5.383699855609835],
            [7.96703690333184, 5.398265378070313],
            [7.959191900680799, 5.4695084993368095],
            [7.949842201125833, 5.555950339134277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.32463116282013, "lat": 43.64078916166698 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26107"],
        "coty_name": ["Mecosta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mecosta County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01622996"
      },
      "bbox": [
        7.949842201125833, 5.210711540263007, 8.331000338491421,
        5.592123758541459
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.9099030713556955, 5.902591851656483],
            [8.03688902948112, 5.916840416428472],
            [8.06464939365856, 5.919649476170878],
            [8.073149191779848, 5.9209491185571475],
            [8.07373348177638, 5.92072638897401],
            [8.164326758578756, 5.93101183155194],
            [8.248978546540062, 5.940007505128559],
            [8.25772523048473, 5.8644594874053135],
            [8.259249761520072, 5.8501775097261435],
            [8.268693103275039, 5.768524507909457],
            [8.269335261953676, 5.7612409726450355],
            [8.280313173830844, 5.664247600693046],
            [8.283993267631296, 5.635284331671801],
            [8.285216151270951, 5.620418871896338],
            [8.288283354133402, 5.592123758541459],
            [8.22504726171738, 5.584848159997784],
            [8.161685290915045, 5.578041081031422],
            [8.035132792682838, 5.564687699855747],
            [7.9923928519125464, 5.560592225766227],
            [7.949842201125833, 5.555950339134277],
            [7.946605205330832, 5.584686173196534],
            [7.938817000218895, 5.656146884030677],
            [7.928935805299706, 5.742038840634499],
            [7.923125946642154, 5.7918517532354725],
            [7.9099030713556955, 5.902591851656483]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.32524746509537, "lat": 43.98981235779316 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26133"],
        "coty_name": ["Osceola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osceola County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01623009"
      },
      "bbox": [
        7.9099030713556955, 5.555950339134277, 8.288283354133402,
        5.940007505128559
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.2866196649522318, 6.910228246648455],
            [0.29473646107822626, 6.910290656804431],
            [0.2948774599718497, 6.838314131331814],
            [0.2943694365924976, 6.738573093157436],
            [0.3383965604767097, 6.7378099780867595],
            [0.3815811309612947, 6.7377393003444395],
            [0.38076407210159957, 6.7247520718386165],
            [0.3809059764528444, 6.65288039970978],
            [0.3809002957781389, 6.566609750204112],
            [0.39076471324367423, 6.566581433866197],
            [0.3906120755135984, 6.503918010044712],
            [0.3879662400545946, 6.51033289556633],
            [0.3707201915195696, 6.519033419528974],
            [0.36645291197468893, 6.520399723158953],
            [0.35838080880078865, 6.517822560909166],
            [0.3419002994202755, 6.5200180540131045],
            [0.3409393642774351, 6.521662463773671],
            [0.33151892216622175, 6.52594202007141],
            [0.3275589592117885, 6.5296199364904925],
            [0.3200532285480125, 6.532581649513657],
            [0.316169702089098, 6.536931099141378],
            [0.31513754370205477, 6.5403297885731435],
            [0.3089040120895393, 6.546573778321715],
            [0.3061682498800048, 6.547826887626545],
            [0.30161784385214857, 6.545224847676734],
            [0.29654566165262, 6.546889668330503],
            [0.2941482117548236, 6.545195522435986],
            [0.2872977968110069, 6.546156654511352],
            [0.2809790664492877, 6.549705000785677],
            [0.27533548428931515, 6.548869502603775],
            [0.2690509058029716, 6.550798268151916],
            [0.26506030207195364, 6.56399975907857],
            [0.2618789021311624, 6.563981386987658],
            [0.2611920743295406, 6.568586330662187],
            [0.26371944018252885, 6.569726992924958],
            [0.26435267937685314, 6.573940169648642],
            [0.25129350202726813, 6.576991249971021],
            [0.2443236000061383, 6.57510991138018],
            [0.2422693602801963, 6.577693337956095],
            [0.2331752580221497, 6.577239752144157],
            [0.23272273486783288, 6.579018735577398],
            [0.22606216009492858, 6.58306197012068],
            [0.22015022669852266, 6.584057290709755],
            [0.21752331350533013, 6.582499206778452],
            [0.20441557905680796, 6.584759236068413],
            [0.20042677536933004, 6.587914937935378],
            [0.1797336957192045, 6.583762410713538],
            [0.17204524452756872, 6.588537935506371],
            [0.1700643320602482, 6.593774170739449],
            [0.1608019841123464, 6.596633261513771],
            [0.14516453269552276, 6.596282020811771],
            [0.14521977256869698, 6.62529498095343],
            [0.14252288462734436, 6.630810825834602],
            [0.14195146570420134, 6.634747180498729],
            [0.13907959212821652, 6.640996193030499],
            [0.13576835709308105, 6.6442699208986085],
            [0.13318460065195864, 6.653667166924964],
            [0.12697067520802421, 6.666654573567815],
            [0.12021577637682275, 6.684004967745576],
            [0.11117036298555244, 6.6923998913791625],
            [0.10688059755080977, 6.69476633589013],
            [0.09733373813724783, 6.702580195896509],
            [0.09091955382890461, 6.7054469800736864],
            [0.08038122319266285, 6.708044663426243],
            [0.0690579936464086, 6.713117365093861],
            [0.05734482833082623, 6.719351583882328],
            [0.05323437101883073, 6.722764181731897],
            [0.04175775302314077, 6.730262012301705],
            [0.0301758163515238, 6.7352142578267875],
            [0.009020158440411293, 6.737374647752198],
            [-0.0010730292966093739, 6.736336133203707],
            [-0.006707183430214101, 6.7378991781564554],
            [-0.013833221859788629, 6.737903772131699],
            [-0.02226643028573328, 6.744757755475061],
            [-0.028842773949200044, 6.753655058683129],
            [-0.03492349370279905, 6.764310970517069],
            [-0.0442582973466639, 6.7788340580062245],
            [-0.04922787421399642, 6.784371952172646],
            [-0.05296823434181863, 6.794088536868881],
            [-0.05404427963483779, 6.800774313393262],
            [-0.05752222588353017, 6.807901538996877],
            [-0.05886186446208415, 6.815918623361212],
            [-0.06392733948875332, 6.8293146014411015],
            [-0.072473567787591, 6.848496388395242],
            [-0.0833935570957973, 6.863037829387053],
            [-0.08603040446126456, 6.86834880521398],
            [-0.09223964751790265, 6.8777554159198715],
            [-0.09790583811501795, 6.882458352658889],
            [-0.12107075244992178, 6.913144306277281],
            [-0.0689662885533693, 6.9125570240564045],
            [0.018381055813483337, 6.911654628114313],
            [0.04579008916776663, 6.911495952199217],
            [0.10602111732456956, 6.910873455368506],
            [0.16417565308797202, 6.910696459894067],
            [0.25188085176740344, 6.910020391102751],
            [0.2585145319873657, 6.910351096048137],
            [0.2866196649522318, 6.910228246648455]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.4109555079474, "lat": 45.42608901076365 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27011"],
        "coty_name": ["Big Stone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Big Stone County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00659451"
      },
      "bbox": [
        -0.12107075244992178, 6.503918010044712, 0.39076471324367423,
        6.913144306277281
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2796238492792404, 5.443518388789068],
            [1.3377199985116337, 5.444644522322467],
            [1.366518915287513, 5.445492553163486],
            [1.408543747962958, 5.446037878752714],
            [1.4514792257859535, 5.446759084887199],
            [1.4798677232957933, 5.447040597814761],
            [1.5449901191520097, 5.448028348597132],
            [1.6308910373544896, 5.449298190392496],
            [1.6321399744634966, 5.362516301368506],
            [1.6332736724810002, 5.304643382193632],
            [1.635291625690685, 5.1888469370494725],
            [1.5786910671967527, 5.187906885446205],
            [1.4984986087591368, 5.186732376554417],
            [1.405067239312927, 5.185381621697668],
            [1.3336959920530997, 5.1845256571446185],
            [1.2866026498277958, 5.183826164592582],
            [1.283051575858747, 5.183777629012912],
            [1.2822732620189243, 5.255922295196337],
            [1.2807622734872313, 5.385662404578965],
            [1.2796238492792404, 5.443518388789068]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.6140728142993, "lat": 43.97843186383808 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27165"],
        "coty_name": ["Watonwan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Watonwan County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00659527"
      },
      "bbox": [
        1.2796238492792404, 5.183777629012912, 1.635291625690685,
        5.449298190392496
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.368937738864213, -5.596313693675309],
            [6.453525306588568, -5.590610388995174],
            [6.4633800177332965, -5.589695953052267],
            [6.5571123037383625, -5.581856647009368],
            [6.590330730417009, -5.579263031093925],
            [6.690454811346227, -5.570492522996248],
            [6.755830424142764, -5.564717462131464],
            [6.812084235377599, -5.5596259849886165],
            [6.839933577500794, -5.5574078811210725],
            [6.838939249592509, -5.611686551167742],
            [6.837529958201746, -5.739829652415678],
            [6.836261385187079, -5.775908873887957],
            [6.835052247225148, -5.861206874144007],
            [6.834079571685108, -5.910294690225472],
            [6.754117452872502, -5.916910230997487],
            [6.696011089531252, -5.9213923826621855],
            [6.653177875274276, -5.924987233599134],
            [6.636852619042155, -5.92656249039173],
            [6.5391146981488, -5.9337689576323065],
            [6.529648053423192, -5.935305472655639],
            [6.495697034369055, -5.937643167743667],
            [6.463944305194539, -5.940190391345231],
            [6.395049283283499, -5.9452961468987],
            [6.387024924760432, -5.8434999849925555],
            [6.384544641388869, -5.813880190658382],
            [6.380955597637042, -5.765809673168206],
            [6.375884216081481, -5.693933867218379],
            [6.374597537589413, -5.669773278656903],
            [6.370588817511264, -5.619618323670277],
            [6.368937738864213, -5.596313693675309]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.6411698565964, "lat": 32.7545665096973 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28069"],
        "coty_name": ["Kemper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kemper County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00695758"
      },
      "bbox": [
        6.368937738864213, -5.9452961468987, 6.839933577500794,
        -5.5574078811210725
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.918966620170357, -5.694899724829249],
            [4.937166369557207, -5.693657792481225],
            [4.9868474632290285, -5.690932822183841],
            [5.01151783163684, -5.6890679409509355],
            [5.0340131085626, -5.687942172203736],
            [5.091104617994933, -5.684290451652397],
            [5.08654461298078, -5.598569417153396],
            [5.157436025136265, -5.593553737572194],
            [5.157401638637382, -5.592823357166775],
            [5.165774783235298, -5.5908472874860875],
            [5.167714903417472, -5.588378627624193],
            [5.168918563284959, -5.582083638934532],
            [5.171511105958877, -5.580160101968041],
            [5.174760084018123, -5.58118653138175],
            [5.179643358766873, -5.588004439898947],
            [5.178800659313442, -5.592022630722238],
            [5.197674072513891, -5.598621732789456],
            [5.217250031022203, -5.604558336968652],
            [5.233881968483153, -5.611022142183914],
            [5.373172118982942, -5.660336492612486],
            [5.453816551364585, -5.688528209257212],
            [5.496915785869849, -5.70350259489944],
            [5.491653417609387, -5.711143430509772],
            [5.491135631252503, -5.716583139157372],
            [5.484977615194158, -5.7176630883346355],
            [5.485104050819288, -5.721983614396378],
            [5.482565817351933, -5.7249624744536876],
            [5.48195595637063, -5.731136896441984],
            [5.476450530193521, -5.738207409303326],
            [5.479200156238593, -5.739801616623717],
            [5.475470015764442, -5.7474199584509265],
            [5.475194265456166, -5.750584819741513],
            [5.470576210053797, -5.754438062570507],
            [5.463156704331365, -5.757421785910549],
            [5.460269880821944, -5.754009248992648],
            [5.4572197904041015, -5.758755175784663],
            [5.456481281787602, -5.767788087746915],
            [5.457801608073718, -5.773039978809206],
            [5.455981519387613, -5.780635903884915],
            [5.459028360320886, -5.782454722779823],
            [5.455927982551615, -5.787009694713255],
            [5.456659468884095, -5.7924405988192005],
            [5.452666024452837, -5.80528257009452],
            [5.4539053409577996, -5.80794268393265],
            [5.449631382833726, -5.8105548000662885],
            [5.450566934785025, -5.8157890546968485],
            [5.448277209214566, -5.82327666465561],
            [5.449000152519997, -5.826512492455922],
            [5.444212504305079, -5.828980741788001],
            [5.443165085104744, -5.834548199127048],
            [5.44392731534388, -5.839152206582216],
            [5.4416755021517655, -5.8428033186092865],
            [5.438240584476264, -5.843837920583245],
            [5.436627611659382, -5.85161005122652],
            [5.430383476141551, -5.853664652546849],
            [5.429879861919844, -5.856499433167633],
            [5.414541790859976, -5.859145619866961],
            [5.411368173565773, -5.8672902878272355],
            [5.403993328078419, -5.874481789802679],
            [5.403785268859675, -5.880624324703033],
            [5.39669564363839, -5.889581553100291],
            [5.391751898881551, -5.886102582852226],
            [5.388232174468576, -5.887145003817046],
            [5.383262711690263, -5.8861623724131755],
            [5.383254154553704, -5.889118305506146],
            [5.377760626343654, -5.888792211243075],
            [5.377283306221944, -5.890899794426106],
            [5.371674433611963, -5.891685129496537],
            [5.370234854547948, -5.889143131523084],
            [5.366439028837294, -5.893005497885775],
            [5.364852149805144, -5.904547106815256],
            [5.360607916798229, -5.9024810030812604],
            [5.351836734748573, -5.90101390932912],
            [5.3500722400103635, -5.905524687829325],
            [5.345680190550715, -5.906931260752563],
            [5.336031356263049, -5.913683746312242],
            [5.332254725273336, -5.915073986183582],
            [5.327238898890764, -5.920671332336204],
            [5.321315863197162, -5.925817253288624],
            [5.317013102108404, -5.930979382354621],
            [5.30920526738191, -5.929019058055022],
            [5.3029260631247634, -5.933758016279135],
            [5.29998461603193, -5.932801659883732],
            [5.297276794743548, -5.936223127817601],
            [5.2948500596157055, -5.931946879354044],
            [5.291425357088758, -5.929514992032561],
            [5.286518725838715, -5.929928853875317],
            [5.280352320296306, -5.932536287608886],
            [5.276301654083266, -5.93720265761733],
            [5.267456730980678, -5.93496808168209],
            [5.263207701541609, -5.937653144333082],
            [5.261817294131995, -5.941377920945497],
            [5.257266474087386, -5.9413235454191895],
            [5.250315969536139, -5.938436137684341],
            [5.24636179823781, -5.948342665175489],
            [5.245448579065855, -5.9540788737060595],
            [5.2378778501141685, -5.9557575321912],
            [5.236659570830408, -5.9530562924519606],
            [5.230816468585133, -5.953594743305437],
            [5.2235988266351825, -5.959812849258396],
            [5.224183189634875, -5.9642215840663715],
            [5.220439253399736, -5.969311041595099],
            [5.221044252244484, -5.973939893065863],
            [5.215709149607892, -5.981249108931173],
            [5.215932903352764, -5.984830265904357],
            [5.207579238975871, -5.9882657948510785],
            [5.205235308797839, -5.995037475882278],
            [5.197697816608511, -5.996013478923923],
            [5.1965306991649935, -5.989387010981147],
            [5.192677276959295, -5.989303550315309],
            [5.190893084657698, -5.997809151688092],
            [5.1880245227230795, -6.000592043492032],
            [5.185545468903922, -5.9983668221044795],
            [5.1810736644930975, -6.000552789684543],
            [5.182318763654833, -6.004402084163428],
            [5.177654974629379, -6.0062464337143915],
            [5.167605782761598, -6.007985826740158],
            [5.166667898039089, -6.01538133342387],
            [5.161828426153391, -6.017307117934772],
            [5.162328192405227, -6.021366594770775],
            [5.154177736316883, -6.022041656613211],
            [5.154481480543127, -6.025095673863053],
            [5.150669254830582, -6.026892262512062],
            [5.149642627258214, -6.03018954029215],
            [5.145114670153899, -6.027176667767097],
            [5.140334718064885, -6.025658063865412],
            [5.138308985406164, -6.0285878333805325],
            [5.134765566801227, -6.022611323951339],
            [5.130848292591852, -6.022831123006558],
            [5.129421207660977, -6.020464800347551],
            [5.124867958319848, -6.020485988110357],
            [5.115859122478996, -6.02215798575879],
            [5.1115037777293555, -6.03345488079784],
            [5.107821821187816, -6.041418991542568],
            [5.109131920623755, -6.049073797311476],
            [5.105957271913862, -6.050681697100299],
            [5.101929170680793, -6.0487766316098535],
            [5.100436933645717, -6.054352903125919],
            [5.100402039389767, -6.060273302122368],
            [5.095396737796163, -6.059335189533982],
            [5.095342730470818, -6.064921997474463],
            [5.086732652664501, -6.0645295937432],
            [5.082989889097104, -6.068403096516908],
            [5.082746855253922, -6.071128740651162],
            [5.078389944765502, -6.075365927764693],
            [5.079468539389448, -6.077286020989368],
            [5.0734748411169655, -6.0821230812478175],
            [5.070407383046507, -6.086657926512681],
            [5.059414753514099, -6.087528489881601],
            [5.053037292521295, -6.091877979990379],
            [5.056505179263604, -6.094380332298609],
            [5.0543476524310345, -6.096932010185073],
            [5.056264459862954, -6.101404278602565],
            [5.052846330924482, -6.1053692724976205],
            [5.046565984763018, -6.100230557508943],
            [5.043056771536208, -6.104152269414719],
            [5.038314464063224, -6.106207257922187],
            [5.034412634322991, -6.101308236510673],
            [5.0285001903999955, -6.104556230796978],
            [5.02702931499417, -6.080268423069338],
            [4.998562641848119, -6.082038353716326],
            [4.997664899404039, -6.06775489456308],
            [4.942258183861165, -6.070902370263455],
            [4.940331821184696, -6.042260646528447],
            [4.938699343003252, -6.0272980403328775],
            [4.9096782640876455, -6.029301015820897],
            [4.90828785015732, -6.000056291402281],
            [4.883061968712391, -6.001255035441464],
            [4.8822699223059285, -5.9961044223281315],
            [4.8909796685194, -5.995461010259833],
            [4.894213155777568, -5.993328198431576],
            [4.897400846686758, -5.995464622132906],
            [4.90155574662515, -5.993941587610945],
            [4.905535691182918, -5.986145376212936],
            [4.906078257907097, -5.982520469474196],
            [4.904520791887493, -5.978770827368687],
            [4.8999844885230095, -5.977159352911597],
            [4.892781122739214, -5.977939792045075],
            [4.88783811595944, -5.97745928251749],
            [4.882517460097284, -5.973537818582311],
            [4.8771529544908425, -5.963028769532533],
            [4.878090795670588, -5.95817864733619],
            [4.886397645417932, -5.941432827101121],
            [4.885828116246209, -5.93238404063072],
            [4.889157557398899, -5.929318656656022],
            [4.896501713612675, -5.9299763498813265],
            [4.899830637204397, -5.933936898750535],
            [4.901221905410144, -5.947916907434823],
            [4.902755126121886, -5.950664317506725],
            [4.9105813522862, -5.954753829792329],
            [4.917467580659739, -5.952980303918221],
            [4.923955629489186, -5.946757447735626],
            [4.925727392509959, -5.9431333443061725],
            [4.926388944780313, -5.9315678193054415],
            [4.925663822425645, -5.928478886138016],
            [4.91941865517653, -5.921478450070209],
            [4.909162417807855, -5.915584803237706],
            [4.900575704213494, -5.9124470217155505],
            [4.893869804255661, -5.911923671046031],
            [4.883439723158821, -5.912606198889983],
            [4.880005394684748, -5.911104771923779],
            [4.875060730842016, -5.906724458458955],
            [4.865984888639042, -5.90215794974773],
            [4.860940851426659, -5.897141816996658],
            [4.858084163695783, -5.892047959928328],
            [4.8586940442181294, -5.88777823023101],
            [4.862010954277726, -5.88192309173703],
            [4.8634577543954345, -5.877139990325368],
            [4.861773845086128, -5.868411321999997],
            [4.862247278974714, -5.864752093950293],
            [4.8674251084536335, -5.8634791334235645],
            [4.874256994103624, -5.870202508682027],
            [4.87791507322536, -5.872143914946174],
            [4.884801516457289, -5.872321742418835],
            [4.892919633744919, -5.869168283303681],
            [4.898069102403892, -5.864707725724874],
            [4.900715509540491, -5.8579855711025495],
            [4.900175375960565, -5.852980069710005],
            [4.893901791367063, -5.8461563114236],
            [4.8845598296905655, -5.841915803629665],
            [4.881314684975344, -5.8378217137110155],
            [4.877421768399981, -5.830206942543316],
            [4.877674305971422, -5.820242291719696],
            [4.881404912388137, -5.812922459120507],
            [4.888816502024865, -5.806145741433624],
            [4.887656784826718, -5.8018935478742835],
            [4.884205528018434, -5.803712087968103],
            [4.881484276008824, -5.801806966210286],
            [4.876044967813837, -5.805807409623185],
            [4.8719344433205745, -5.805358267489406],
            [4.869148651362877, -5.801573712489381],
            [4.865009816289833, -5.802066086689984],
            [4.8654070527553035, -5.805001361171041],
            [4.861663744243055, -5.810909875990382],
            [4.854989511134518, -5.812128988290181],
            [4.849460673605863, -5.804171500399403],
            [4.843674884621571, -5.803874253078767],
            [4.839188214497435, -5.808112397811501],
            [4.837888862726289, -5.786469669745229],
            [4.879646155352383, -5.741127730382669],
            [4.879830149554306, -5.740577091599622],
            [4.918966620170357, -5.694899724829249]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.3965221525968, "lat": 32.78032030069394 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28163"],
        "coty_name": ["Yazoo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yazoo County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00695802"
      },
      "bbox": [
        4.837888862726289, -6.106207257922187, 5.496915785869849,
        -5.580160101968041
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.610541857980989, -1.329432722686156],
            [4.625963111398875, -1.3275713013261776],
            [4.633192472725348, -1.3272202713731502],
            [4.655884582991736, -1.324533485389022],
            [4.668304992232703, -1.3224400687316071],
            [4.683760871671657, -1.3241560770865468],
            [4.697310471821788, -1.323665459247817],
            [4.712425804301008, -1.322569819359052],
            [4.72689321376302, -1.3205646538853242],
            [4.74130785832481, -1.3196456393323066],
            [4.755897721688893, -1.3196480880271324],
            [4.753981877799087, -1.2742696056695877],
            [4.7835859054423, -1.2738104435069506],
            [4.84149508556123, -1.270669898773415],
            [4.914153705121581, -1.267955669128837],
            [4.930041425522561, -1.2661574699569456],
            [5.000441780807176, -1.261010159188018],
            [5.015224047587193, -1.26147474238585],
            [5.01669872815156, -1.2980001063510191],
            [5.018030838117524, -1.3223556304983446],
            [5.018016631719702, -1.3277490512011914],
            [5.022009682229663, -1.409849391874796],
            [5.023730212354599, -1.4530247311087328],
            [5.023548758669612, -1.4617518959350544],
            [5.024854555128406, -1.4919231189542257],
            [5.053642174426897, -1.4899680803704256],
            [5.067217012664026, -1.4897880681002662],
            [5.102262275372486, -1.4880547901547654],
            [5.113904593787729, -1.4871080446820975],
            [5.1159929568988165, -1.5321493755870768],
            [5.101475736969444, -1.5326498188247295],
            [5.086569146925836, -1.5337306737713854],
            [5.087949362083546, -1.5680240090660336],
            [5.073390371383063, -1.56871026721493],
            [5.0738220022332, -1.5833019043145329],
            [5.059706550471389, -1.584015724132725],
            [5.060414101753996, -1.5987985183151574],
            [5.045950943281852, -1.5995874813553337],
            [5.046596294425047, -1.6139319806056158],
            [5.03250208871245, -1.614692622879999],
            [5.033806397245486, -1.6438281424161512],
            [5.01954214433824, -1.644503322659531],
            [5.020272115970768, -1.6587541362407854],
            [5.007017012604376, -1.6593180488708628],
            [4.986157682739319, -1.6588210004798243],
            [4.966495212817889, -1.6592990095718414],
            [4.954217348561135, -1.6590438423913247],
            [4.9323667929637685, -1.659739698945768],
            [4.914831939498962, -1.6609825245718743],
            [4.875223979361994, -1.6632300192626572],
            [4.797783281790558, -1.6667925393245175],
            [4.712779992195709, -1.672358802943964],
            [4.674775935353538, -1.6741720900059505],
            [4.669999200339469, -1.673468148781662],
            [4.660247462196253, -1.6742810984717584],
            [4.659851148100724, -1.6501646999230015],
            [4.658957372476175, -1.6303161453269635],
            [4.644718848378779, -1.6308067252515603],
            [4.643416006283272, -1.6012450734995922],
            [4.629236793686473, -1.6020016511177357],
            [4.627447451676845, -1.5524306697240515],
            [4.588075182877666, -1.5538064039583228],
            [4.584691505975211, -1.482091927847208],
            [4.583647734639527, -1.465790595280583],
            [4.601166669104671, -1.4647173600503276],
            [4.600285085834979, -1.4354656815786384],
            [4.61505668545452, -1.4349609999411708],
            [4.614382620612362, -1.4203098840101502],
            [4.614419137491173, -1.3909082395411148],
            [4.613794804904531, -1.373630369479573],
            [4.612443875404899, -1.3737507515101213],
            [4.610541857980989, -1.329432722686156]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.46139904028864, "lat": 37.1126219761275 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29223"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "223",
        "coty_gnis_code": "00758564"
      },
      "bbox": [
        4.583647734639527, -1.6742810984717584, 5.1159929568988165,
        -1.261010159188018
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.866254829782537, 10.246800010442758],
            [-9.787920110333289, 10.234642946672365],
            [-9.709588538601407, 10.22246498194683],
            [-9.594400990784731, 10.20459074595565],
            [-9.479220445602946, 10.186671346667184],
            [-9.466085335371458, 10.269900774243059],
            [-9.418556584821788, 10.262597495822407],
            [-9.331945451806563, 10.249446437979843],
            [-9.318683887398926, 10.332991832766224],
            [-9.254545357275594, 10.323320806014594],
            [-9.190408966818211, 10.313635668057284],
            [-9.147094436103478, 10.306934246841115],
            [-9.060575450479707, 10.293968031705052],
            [-8.974060414875675, 10.280976160868398],
            [-8.901039081185871, 10.270187092667],
            [-8.801190587942274, 10.255653003828444],
            [-8.81361787464766, 10.171747062804165],
            [-8.809492236439494, 10.173729069481395],
            [-8.73416742059897, 10.162808099311968],
            [-8.746795090453265, 10.077201793267662],
            [-8.661014485272208, 10.064617557337016],
            [-8.660629006660738, 10.067015130714857],
            [-8.618192113965407, 10.060598063612794],
            [-8.64851737537848, 9.847667103743456],
            [-8.654354978072709, 9.805690716776374],
            [-8.658207648630535, 9.806173830999636],
            [-8.67226918104655, 9.710120202591764],
            [-8.6768377448842, 9.678212539500315],
            [-8.68353109967145, 9.681261977416941],
            [-8.686031906622748, 9.684869368090249],
            [-8.698208368515685, 9.687769353479574],
            [-8.703090694304278, 9.690763972696454],
            [-8.70881565100515, 9.689649238152118],
            [-8.716163729467544, 9.685142949000863],
            [-8.720097487099853, 9.680523822748725],
            [-8.7243697692884, 9.678358431605576],
            [-8.727911723445034, 9.67948875362945],
            [-8.730641183946508, 9.683635058590644],
            [-8.740361375932878, 9.687803472268705],
            [-8.751388886379052, 9.685470871460415],
            [-8.76586253515378, 9.687741316544889],
            [-8.773381779906243, 9.686985984740334],
            [-8.780477819805107, 9.682754444475654],
            [-8.782055424646245, 9.678794088147074],
            [-8.786182575169027, 9.673502296231801],
            [-8.796842538676993, 9.667729472391615],
            [-8.802605607899341, 9.662053120828087],
            [-8.80611086948281, 9.660535801976279],
            [-8.82165250075592, 9.664028589058303],
            [-8.825964291681602, 9.663899109667517],
            [-8.83034470336178, 9.669155589450877],
            [-8.83590317061961, 9.67208826027663],
            [-8.845583538943547, 9.67178594552179],
            [-8.85555144545226, 9.677902387983927],
            [-8.864887505431836, 9.678604859120169],
            [-8.871074966180883, 9.682940098639717],
            [-8.875197545169225, 9.683930153714542],
            [-8.878427069854444, 9.67762799711266],
            [-8.882735576505794, 9.675855871401074],
            [-8.882438575167622, 9.66765581609028],
            [-8.884405256427605, 9.66575087694835],
            [-8.88298634047628, 9.649039042209601],
            [-8.88775907885293, 9.646784522322005],
            [-8.888314014916947, 9.643583884520964],
            [-8.884998576010211, 9.637409458797565],
            [-8.88696666336191, 9.627414172171035],
            [-8.890344605250409, 9.625333661604474],
            [-8.886131563117452, 9.619063467175492],
            [-8.893618658702344, 9.606792835746301],
            [-8.888936073121606, 9.602942061349204],
            [-8.893075432095191, 9.601338339798515],
            [-8.892863732270275, 9.596715466647879],
            [-8.895454646573555, 9.591257478642142],
            [-8.9005603657544, 9.585364294454763],
            [-8.898729797312143, 9.582746692192647],
            [-8.903721509993108, 9.57867595913016],
            [-8.901106428637638, 9.573725352258682],
            [-8.90516263802988, 9.572989697880363],
            [-8.903178784855207, 9.569223080024203],
            [-8.90573584898717, 9.564992781640914],
            [-8.908550415932352, 9.564760606258131],
            [-8.909906279182595, 9.561018711511654],
            [-8.907156612875093, 9.558180367870074],
            [-8.909755806461563, 9.554647936538798],
            [-8.907605110073659, 9.549613135558765],
            [-8.910893616721161, 9.539587054092394],
            [-8.908783901883293, 9.537367795810429],
            [-8.908993631444195, 9.532201776196477],
            [-8.911008445995757, 9.527506706937059],
            [-8.909379813864087, 9.523582462916346],
            [-8.91548112382508, 9.515503553307864],
            [-8.918895099755774, 9.517049565015594],
            [-8.921380990813075, 9.51490709729899],
            [-8.92948371980543, 9.504498921727896],
            [-8.937908863552844, 9.502982231770916],
            [-8.944810352555432, 9.503319318208403],
            [-8.947142543428436, 9.506316356171025],
            [-8.95620468464789, 9.503577142537809],
            [-8.96035755039705, 9.49932846638791],
            [-8.96448902257643, 9.498961667270915],
            [-8.965101981107717, 9.495644343423544],
            [-8.96973273812499, 9.497118627013403],
            [-8.97536695017476, 9.496162912765095],
            [-8.976142431725, 9.489849790374551],
            [-8.98125465097555, 9.48600688512257],
            [-8.984317221526803, 9.487346828682375],
            [-8.988398585295062, 9.485094686454623],
            [-8.99227353216384, 9.485151662925043],
            [-8.996140054635301, 9.482543587395003],
            [-8.997305806846597, 9.478621960560453],
            [-9.000170868293466, 9.479511801256107],
            [-9.003269510451126, 9.477169312005186],
            [-9.005257241103104, 9.48020310637169],
            [-9.017461838216251, 9.469582938128646],
            [-9.023727977870797, 9.472448721859422],
            [-9.026433984209362, 9.467862617306812],
            [-9.029943404401696, 9.47098945410124],
            [-9.036357976355946, 9.47003255391391],
            [-9.03709008878449, 9.472695407316671],
            [-9.04476755729262, 9.474400758124776],
            [-9.04564411999064, 9.47025149224872],
            [-9.049738284317, 9.470180314878942],
            [-9.053938174169648, 9.46620954823742],
            [-9.061056307820436, 9.464424597903909],
            [-9.063908488124161, 9.460831951108823],
            [-9.071567779971625, 9.460311773251586],
            [-9.073462978702747, 9.457648966578962],
            [-9.080537002043172, 9.455709582845692],
            [-9.082443194449915, 9.451195014093052],
            [-9.088061332241846, 9.447418275327086],
            [-9.091932619735168, 9.44668913906017],
            [-9.095370694183268, 9.443983256191233],
            [-9.105412210651968, 9.443276463495872],
            [-9.110855643141925, 9.440735269469434],
            [-9.113511090404982, 9.43719973005263],
            [-9.11639399353988, 9.441176466821986],
            [-9.122067138469113, 9.435533305412592],
            [-9.125435499812598, 9.436399034832794],
            [-9.135132471972685, 9.42972070254164],
            [-9.141757464638335, 9.427237282900277],
            [-9.143111384869174, 9.429409838910255],
            [-9.147977931136364, 9.427618389400164],
            [-9.176871720510908, 9.431710184340387],
            [-9.205646150455278, 9.436011459162],
            [-9.305965966028689, 9.451039160662065],
            [-9.406290668465463, 9.466034143543675],
            [-9.463559561004407, 9.474798449855172],
            [-9.459167092613567, 9.502833698047633],
            [-9.459711923027264, 9.503791011110158],
            [-9.546163074689208, 9.516880601465685],
            [-9.533484558185831, 9.593814338047016],
            [-9.595432863420207, 9.602628566857193],
            [-9.599021322456272, 9.609208972380713],
            [-9.599772994312726, 9.614190939680814],
            [-9.598242215175096, 9.616354620869677],
            [-9.606601579397733, 9.619932871964826],
            [-9.607704841376604, 9.624036357900227],
            [-9.611452897459143, 9.620125859343787],
            [-9.612579380757404, 9.626332340153809],
            [-9.624014262034427, 9.624222115760627],
            [-9.625193944256814, 9.627511894059129],
            [-9.630549083050632, 9.629214905287622],
            [-9.634491132348789, 9.626715303260468],
            [-9.635322171154348, 9.630424909941157],
            [-9.643248418312828, 9.631892802078665],
            [-9.642983377316376, 9.637628710223925],
            [-9.645287260465919, 9.63975776557893],
            [-9.650805666548594, 9.639271790891451],
            [-9.651541173186128, 9.644422269099596],
            [-9.659682335375875, 9.651298525459646],
            [-9.661951844079782, 9.65590173287501],
            [-9.661466271278384, 9.659329867615206],
            [-9.664542811586163, 9.66251457577336],
            [-9.66782149838133, 9.66233211266874],
            [-9.677660293780699, 9.665345821093192],
            [-9.683301958520792, 9.66350700108795],
            [-9.69736734058017, 9.675192178299088],
            [-9.700480941263528, 9.67605142575796],
            [-9.69995233559192, 9.680547267178026],
            [-9.702384803737951, 9.68403317861298],
            [-9.705143155933742, 9.683184954585693],
            [-9.708050965086548, 9.68641667929111],
            [-9.707599475829594, 9.692775477910262],
            [-9.710993845469286, 9.693572413773483],
            [-9.707839370864235, 9.69971175026478],
            [-9.707428014194507, 9.704594174015009],
            [-9.702178420403243, 9.708530813412022],
            [-9.701282647432253, 9.714165451903018],
            [-9.697994040419866, 9.719350184559197],
            [-9.689648464160781, 9.725976163185836],
            [-9.686029090562752, 9.732241716771062],
            [-9.684095786696703, 9.73890372160803],
            [-9.6797673341445, 9.744853306996129],
            [-9.671810510220421, 9.747193913090493],
            [-9.668746197485731, 9.750803048424656],
            [-9.668877269257884, 9.756480082771853],
            [-9.661482319214393, 9.765965703283719],
            [-9.655627074545627, 9.765936761475745],
            [-9.65359482497044, 9.767384039733184],
            [-9.652375419555147, 9.774679601291998],
            [-9.649869717856932, 9.779630315900937],
            [-9.645951344129529, 9.782872616879468],
            [-9.727453041311433, 9.795226535313388],
            [-9.80895791158064, 9.80755843039874],
            [-9.872279598695794, 9.817925702987685],
            [-9.935603540685324, 9.828279638196465],
            [-9.921552456692492, 9.912407863507195],
            [-9.907774105964734, 9.995434643400399],
            [-9.899125511263621, 10.046178703051282],
            [-9.88907953376421, 10.107049062586094],
            [-9.866254829782537, 10.246800010442758]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.43529110303709,
          "lat": 47.88060002349841
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30015"],
        "coty_name": ["Chouteau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chouteau County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01719619"
      },
      "bbox": [
        -9.935603540685324, 9.427237282900277, -8.618192113965407,
        10.332991832766224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.792734871764758, 10.135550069610236],
            [-12.784458043641491, 10.138829430467904],
            [-12.784074577140428, 10.133654514365144],
            [-12.781862601851657, 10.12818158758267],
            [-12.777050134174035, 10.127067161397692],
            [-12.772166881274863, 10.123832781472252],
            [-12.758749691036588, 10.120924678123236],
            [-12.752109027761877, 10.118609738562267],
            [-12.739279094408898, 10.119418189324282],
            [-12.732176108722664, 10.118252577530109],
            [-12.726051826669279, 10.119467961912644],
            [-12.718979479816408, 10.127814582557686],
            [-12.720591115352432, 10.135982564634759],
            [-12.715556423901763, 10.13682133837259],
            [-12.709044885017384, 10.133022650011153],
            [-12.705914340637745, 10.128269772437545],
            [-12.705292079483034, 10.12391891734627],
            [-12.700556722420856, 10.11614071019403],
            [-12.700539544112056, 10.111463950003875],
            [-12.697486807518791, 10.108010190382991],
            [-12.693194241921635, 10.107218583065352],
            [-12.688996851942672, 10.104053646431344],
            [-12.683656746181002, 10.102934540769414],
            [-12.678707205695256, 10.104008982891905],
            [-12.674619368993822, 10.097994844510945],
            [-12.671899091398704, 10.096835594793113],
            [-12.669923772876157, 10.10067360254584],
            [-12.65980669748114, 10.104886415569496],
            [-12.65757511025031, 10.10366767268742],
            [-12.647664831359284, 10.105718236737154],
            [-12.639659714551618, 10.109432023749813],
            [-12.63483478013191, 10.108891414871831],
            [-12.625363718401704, 10.103788937276118],
            [-12.620718042596279, 10.104464698916052],
            [-12.615357747043165, 10.102881656623923],
            [-12.609131596915939, 10.098436932829635],
            [-12.605550881393071, 10.093468579167322],
            [-12.603182373837589, 10.088032422670642],
            [-12.598585830392357, 10.088506199197507],
            [-12.590738625560194, 10.085616224657972],
            [-12.58545651579346, 10.085759975240729],
            [-12.578621968193145, 10.083565514214024],
            [-12.576095619670596, 10.087422393725372],
            [-12.570662493880123, 10.091197389673095],
            [-12.559665386507628, 10.095196848687781],
            [-12.555235472247242, 10.090181939879912],
            [-12.548377536669754, 10.088056907592302],
            [-12.547238296686777, 10.086296307823707],
            [-12.538900642829807, 10.08449625200742],
            [-12.530390439930851, 10.078426796440631],
            [-12.531257788241817, 10.073575209206313],
            [-12.525954764548562, 10.067877712873546],
            [-12.518331169326895, 10.062397531222983],
            [-12.512261488511852, 10.061921093271557],
            [-12.505976045180361, 10.05853224728307],
            [-12.500644498239325, 10.052763402033149],
            [-12.494673241122825, 10.049374169340954],
            [-12.491843889558432, 10.046230529388355],
            [-12.48430746131515, 10.04091817949163],
            [-12.48628488934088, 10.0369152661035],
            [-12.48200226464402, 10.025596569543508],
            [-12.47581285823215, 10.020810931005004],
            [-12.467323020007393, 10.010414406259168],
            [-12.465686803319533, 10.009374532877365],
            [-12.450435017714721, 10.013958567915687],
            [-12.447482910384048, 10.014125518326766],
            [-12.442057632965799, 10.01178410295745],
            [-12.438561724546632, 10.006461777905614],
            [-12.430164075406783, 9.999358696181634],
            [-12.42063999572042, 9.997097545271787],
            [-12.41842209645963, 9.995267394989728],
            [-12.419361180991444, 9.989509110137222],
            [-12.408444869606686, 9.99233818997491],
            [-12.404388823038433, 9.991554466579027],
            [-12.399030542660695, 9.984997465794578],
            [-12.399573352415427, 9.980053766319712],
            [-12.398044823118592, 9.976554132759027],
            [-12.391566750160045, 9.97232812670925],
            [-12.377589950524344, 9.968599146390066],
            [-12.375815405527355, 9.966834030959205],
            [-12.378161628377866, 9.959169919413082],
            [-12.377725339981826, 9.950287420519754],
            [-12.373257479707725, 9.945006654083109],
            [-12.38531264550646, 9.886034916180378],
            [-12.343255683377464, 9.877525446224297],
            [-12.34612850461305, 9.863594067524051],
            [-12.303613049966847, 9.855137739230097],
            [-12.309225227689002, 9.827171831212276],
            [-12.279025810963892, 9.821270397433395],
            [-12.284623560999352, 9.79350871414561],
            [-12.270369714026256, 9.790715576476444],
            [-12.273187544951206, 9.776797898162735],
            [-12.230627339935886, 9.768434225582299],
            [-12.239078301329224, 9.726708711011717],
            [-12.225044975698548, 9.72403434254391],
            [-12.227996138881831, 9.70954821867919],
            [-12.200407933794532, 9.704098463667332],
            [-12.206180926705889, 9.676315039422994],
            [-12.191882101621088, 9.673525662313837],
            [-12.194740564215955, 9.659551870093253],
            [-12.166238614775667, 9.654015340519747],
            [-12.171784126664248, 9.62619385004868],
            [-12.157678627719621, 9.623437604453096],
            [-12.163280511361558, 9.597056058317431],
            [-12.107924583207634, 9.586408721837351],
            [-12.11610212599358, 9.543836161157516],
            [-12.073317296591954, 9.535428429895582],
            [-12.075961835964442, 9.521585676746735],
            [-12.097460072749886, 9.52575452822774],
            [-12.100413521321787, 9.51062084434272],
            [-12.112060554549954, 9.51867245878207],
            [-12.117512674537814, 9.520909616855782],
            [-12.12270368194008, 9.520946394885945],
            [-12.131877282704707, 9.532613580160495],
            [-12.147132913261675, 9.535755978552226],
            [-12.150376442715299, 9.519455392893246],
            [-12.165038339611705, 9.522422880993256],
            [-12.167866278665946, 9.50844854818107],
            [-12.170160313661096, 9.494330806647982],
            [-12.183391651577095, 9.496945599985917],
            [-12.208575474543471, 9.371844218083858],
            [-12.19693480571727, 9.369641838823545],
            [-12.213680464605472, 9.286481290141964],
            [-12.298542399650367, 9.30314230639679],
            [-12.300611705824828, 9.292942381586691],
            [-12.304971285449351, 9.295833517264427],
            [-12.310443789636462, 9.294627514524356],
            [-12.31447367992643, 9.299340716756271],
            [-12.317838073304669, 9.297168396152632],
            [-12.318135758595634, 9.293280997531562],
            [-12.325218203037407, 9.288128786267592],
            [-12.325577970443065, 9.284341559303922],
            [-12.328587748122176, 9.278856956244427],
            [-12.333715428202167, 9.276591731832518],
            [-12.33949095298157, 9.278269723602278],
            [-12.34920740246797, 9.277548472375035],
            [-12.360724298757832, 9.264993524744126],
            [-12.370646837205912, 9.266991114046835],
            [-12.371630196563116, 9.269907091837826],
            [-12.370359743836822, 9.274743672216438],
            [-12.376602965125347, 9.277689698396049],
            [-12.381814689206816, 9.284167044768276],
            [-12.37643834328536, 9.29033264260751],
            [-12.375393713171832, 9.297165523774412],
            [-12.371079819059666, 9.301496196780619],
            [-12.368256870471296, 9.301169202130444],
            [-12.36508028614626, 9.303828618298713],
            [-12.360038739879293, 9.313456971386138],
            [-12.360979994953428, 9.317200930460881],
            [-12.35730875875097, 9.325581184735483],
            [-12.362279747778993, 9.330982699365116],
            [-12.36176824593704, 9.33343200483405],
            [-12.367709387997131, 9.338073181935213],
            [-12.367791511134447, 9.347331974048913],
            [-12.369653774729665, 9.348930991987483],
            [-12.376754413740782, 9.347093922688465],
            [-12.381456360522382, 9.3543724461361],
            [-12.389329589421228, 9.355099587243062],
            [-12.395903117960618, 9.3579871906414],
            [-12.398855589994778, 9.368184531598251],
            [-12.405528123233616, 9.372809035452068],
            [-12.409709620174484, 9.378394672702328],
            [-12.412325997118687, 9.384030887439227],
            [-12.411522443078907, 9.389823489117633],
            [-12.414078323028901, 9.393228399466045],
            [-12.420716836268227, 9.391868847114832],
            [-12.429446167275206, 9.391195879844977],
            [-12.43336738174808, 9.385231708347643],
            [-12.436426093658488, 9.384736915838012],
            [-12.43699749050409, 9.392930190077756],
            [-12.433263911791098, 9.399954578037592],
            [-12.435252852078548, 9.405521098576152],
            [-12.43981314415565, 9.406190317849315],
            [-12.448619828671912, 9.412676563991003],
            [-12.450303590999557, 9.419633154407137],
            [-12.450701849077662, 9.429681242943397],
            [-12.446966712769306, 9.432839401909206],
            [-12.448601269214128, 9.440588208774454],
            [-12.4542233376325, 9.443766351619777],
            [-12.45719265697654, 9.443917931452477],
            [-12.460509759309318, 9.449095862484505],
            [-12.456063041395183, 9.455325091310325],
            [-12.453819846641844, 9.455125690873976],
            [-12.446147369310157, 9.462010187152964],
            [-12.444587094921147, 9.472634679848388],
            [-12.445890301878132, 9.477716762849981],
            [-12.445543571403281, 9.482461128535686],
            [-12.442162832267032, 9.488056918005285],
            [-12.440390015028692, 9.488205881258038],
            [-12.438097547455797, 9.493562362343733],
            [-12.432695844537118, 9.495090010488967],
            [-12.433636800943987, 9.501550610613158],
            [-12.440172557442564, 9.503845543424186],
            [-12.443773756793872, 9.508904581246837],
            [-12.450494091691167, 9.51282228756047],
            [-12.455321327884292, 9.517550368893506],
            [-12.45370043070102, 9.519692936551204],
            [-12.456147947349903, 9.524777651400742],
            [-12.459890389435332, 9.526788348497462],
            [-12.466484635168314, 9.538684556120664],
            [-12.467683658255638, 9.54389533269495],
            [-12.471206977472034, 9.5496263077085],
            [-12.471185645510289, 9.552590939760798],
            [-12.474801917981162, 9.55879731247454],
            [-12.474216542309255, 9.562885095001743],
            [-12.480522545338703, 9.56637099757791],
            [-12.48439884591559, 9.566879636435992],
            [-12.491685977665457, 9.570142269021956],
            [-12.493177300536795, 9.567286566102675],
            [-12.498712430784025, 9.566421213812086],
            [-12.506275556447639, 9.567213593412715],
            [-12.507419253844358, 9.571976310207402],
            [-12.505235212910476, 9.578435076846944],
            [-12.508879993499702, 9.582773186547458],
            [-12.51045890595968, 9.59020293898498],
            [-12.513990753559568, 9.593970781688753],
            [-12.511699847234752, 9.599129132769702],
            [-12.514041457480836, 9.61238373266817],
            [-12.511433514320071, 9.613633309141138],
            [-12.51083979046558, 9.624250370850765],
            [-12.513482290572671, 9.62477934585623],
            [-12.516293125953366, 9.629341720988633],
            [-12.51518964519813, 9.637470530263624],
            [-12.518973140217367, 9.641168635672235],
            [-12.51753578595338, 9.645554205667999],
            [-12.523962724572897, 9.649639998709775],
            [-12.52728699651372, 9.649144119451364],
            [-12.534745131427448, 9.661109017269375],
            [-12.537122847527645, 9.667054792681096],
            [-12.542131460540492, 9.673691897219944],
            [-12.543331743596958, 9.680658363901259],
            [-12.545619602329301, 9.685469766344847],
            [-12.545273740481209, 9.697457644150198],
            [-12.542698743435114, 9.70164344928774],
            [-12.544414238536994, 9.70720910265365],
            [-12.555079673178948, 9.709603930574056],
            [-12.562038316132622, 9.71593828572163],
            [-12.561526367261624, 9.720714086174704],
            [-12.564403531938526, 9.726704522471511],
            [-12.564419473078093, 9.72990685715538],
            [-12.56811679727021, 9.73475645471134],
            [-12.566855727645686, 9.739182471016461],
            [-12.573516997642688, 9.748254503934115],
            [-12.573572788048496, 9.750766980782563],
            [-12.582120914699983, 9.754871023813452],
            [-12.586993491659154, 9.762858538833678],
            [-12.59310112862993, 9.765392180832754],
            [-12.60085196923587, 9.76739609780128],
            [-12.603145555638148, 9.772226975469469],
            [-12.6031321872485, 9.776212675851406],
            [-12.606530828657267, 9.781519391298099],
            [-12.604763258170511, 9.792455489738021],
            [-12.607587071948663, 9.799742150559583],
            [-12.614185088136322, 9.802056265436628],
            [-12.617728590029715, 9.802186844587307],
            [-12.62357457234051, 9.804780906262515],
            [-12.6256606788722, 9.808536398374194],
            [-12.631778990949947, 9.811102457445624],
            [-12.631196224284869, 9.81630109600884],
            [-12.62524208705979, 9.827307362929316],
            [-12.621423060772843, 9.830878457096288],
            [-12.621581395764819, 9.840523972383737],
            [-12.62313322525833, 9.846736798418247],
            [-12.62779310432344, 9.851804333156252],
            [-12.63049598407576, 9.852429957695977],
            [-12.633351825444489, 9.856603494716287],
            [-12.634548858603695, 9.866074795298113],
            [-12.636219660722306, 9.869644511188941],
            [-12.631244191788317, 9.874255275825286],
            [-12.630909601071664, 9.879112088534768],
            [-12.633485100979714, 9.879668139285783],
            [-12.643481093152827, 9.888250482797371],
            [-12.647512844967222, 9.886783385567714],
            [-12.65258713659898, 9.889379972278908],
            [-12.656679902810486, 9.887706722215507],
            [-12.660768679341537, 9.890821754812631],
            [-12.663585959738322, 9.894754580882655],
            [-12.667323066876879, 9.894880360125915],
            [-12.672374471898918, 9.89892255519309],
            [-12.677510241497306, 9.897677293267009],
            [-12.691005863590679, 9.899662272066028],
            [-12.69202916619769, 9.903501687580933],
            [-12.69573124460792, 9.908037920133776],
            [-12.694369864754426, 9.913310228374428],
            [-12.69712175142988, 9.916593085696478],
            [-12.704847355434154, 9.917072602802902],
            [-12.710283641939945, 9.916023613190822],
            [-12.71841790622858, 9.918987288290205],
            [-12.717817595004863, 9.922579103004338],
            [-12.719568115970262, 9.926236511084701],
            [-12.722930789705286, 9.928766222115664],
            [-12.726940818886371, 9.92665065374307],
            [-12.735268779802558, 9.926250792004526],
            [-12.738590530118, 9.934282496817632],
            [-12.742306998743691, 9.934875956727865],
            [-12.748908454062754, 9.938741317375925],
            [-12.753479845017507, 9.944623016138506],
            [-12.761754312205056, 9.948869077326535],
            [-12.759577427769573, 9.958324165049953],
            [-12.763704126190964, 9.967800405192966],
            [-12.764748070058022, 9.975955208212914],
            [-12.762610156648295, 9.978799998167139],
            [-12.769229855967016, 9.98484304128195],
            [-12.76575859650272, 9.99759645924637],
            [-12.767254083038702, 10.002140368439731],
            [-12.77013092374514, 10.004825915853553],
            [-12.775868269968873, 10.004926362373178],
            [-12.78132361211196, 10.009467988189337],
            [-12.782463482786216, 10.014916200001013],
            [-12.780708381825102, 10.020871650737286],
            [-12.791928479685504, 10.027496718779362],
            [-12.794938966251, 10.033923202659413],
            [-12.799346631209094, 10.037989580078925],
            [-12.805438416382366, 10.040875465552926],
            [-12.813247391500932, 10.039499928370239],
            [-12.81752236442601, 10.040784115064715],
            [-12.822210363718684, 10.03938955975083],
            [-12.82475879113831, 10.045218355689581],
            [-12.822421020342194, 10.049433988659962],
            [-12.824220949175588, 10.055051950903279],
            [-12.827799910768606, 10.058931329726304],
            [-12.827137173050296, 10.063249468551282],
            [-12.830627929422562, 10.066644744231548],
            [-12.833471645842799, 10.065936486987102],
            [-12.840051530725516, 10.06815993087666],
            [-12.837451147204494, 10.074593140189503],
            [-12.844479493706046, 10.078361868566207],
            [-12.84724778606104, 10.082539606199814],
            [-12.853712231257118, 10.08446481508963],
            [-12.86049112248291, 10.085347868608219],
            [-12.865043461528007, 10.091692118148199],
            [-12.864652256327188, 10.096517838759548],
            [-12.870772588100946, 10.09694672489881],
            [-12.876496402974253, 10.099202885192394],
            [-12.87926277356545, 10.097390883257344],
            [-12.885775896090479, 10.09743966327334],
            [-12.89025586283086, 10.099977912401949],
            [-12.887100422138124, 10.104964676873172],
            [-12.88396639040479, 10.106962912294406],
            [-12.879029891385276, 10.115459498448887],
            [-12.873537077055218, 10.115429598761681],
            [-12.862787586348217, 10.118010605680471],
            [-12.856225632605257, 10.121628551620399],
            [-12.846302321668329, 10.119499204341311],
            [-12.840296257119437, 10.120375355169768],
            [-12.838581972596572, 10.12248084246898],
            [-12.832244481987672, 10.120938807454364],
            [-12.82908715240321, 10.116515094721262],
            [-12.824361495010036, 10.116961678884945],
            [-12.820788376182529, 10.115603443417106],
            [-12.810183528358074, 10.115747102248111],
            [-12.803558785702796, 10.117874174697205],
            [-12.795277498061361, 10.130052866086446],
            [-12.792734871764758, 10.135550069610236]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.99831621284451,
          "lat": 47.147260216011986
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30061"],
        "coty_name": ["Mineral"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mineral County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01720030"
      },
      "bbox": [
        -12.89025586283086, 9.264993524744126, -12.073317296591954,
        10.138829430467904
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.4645314235818105, 2.7135065523911726],
            [-4.356395372531056, 2.706429112996341],
            [-4.292851077256716, 2.70207890011515],
            [-4.208134149798463, 2.6960624800039295],
            [-4.079925822573145, 2.687713522631634],
            [-4.051489938759936, 2.685906669290247],
            [-4.060047444835114, 2.5547086297049653],
            [-4.062612053156523, 2.510925714643732],
            [-4.0598365557700005, 2.5107276673740797],
            [-4.062596329128302, 2.466932580043449],
            [-4.0626598904326165, 2.4654257708940404],
            [-4.117377920299942, 2.4688928507178782],
            [-4.24165118216062, 2.476882017762314],
            [-4.2959548910897425, 2.4804660390994453],
            [-4.307541545576862, 2.4813714824425257],
            [-4.388450441172935, 2.486997059671716],
            [-4.439864232018421, 2.490299349649632],
            [-4.487806282827806, 2.4940068258850654],
            [-4.484499586763904, 2.539622852877189],
            [-4.476531727226484, 2.539276908047491],
            [-4.470220790874481, 2.632613631664588],
            [-4.468496547846673, 2.6626934666639843],
            [-4.467749882537882, 2.670255047988975],
            [-4.4645314235818105, 2.7135065523911726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.33386286935945,
          "lat": 41.11155593593222
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31049"],
        "coty_name": ["Deuel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Deuel County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00835846"
      },
      "bbox": [
        -4.487806282827806, 2.4654257708940404, -4.051489938759936,
        2.7135065523911726
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5521845148605515, 2.127644643292366],
            [-3.4933676080543665, 2.1239206888848874],
            [-3.4790985428327046, 2.1232764746887383],
            [-3.4113288994216635, 2.1199753221666895],
            [-3.3391706019094993, 2.117056842346774],
            [-3.338914020165443, 2.116758538740265],
            [-3.2931865459678966, 2.115410396944917],
            [-3.291770502309514, 2.1149997911076905],
            [-3.264763996112214, 2.1141312844320637],
            [-3.2115507657163067, 2.111459876333462],
            [-3.126079933094492, 2.1070073105513116],
            [-3.128555826126176, 2.0891406134101027],
            [-3.133578131014767, 2.019423010119441],
            [-3.135619736297165, 1.9752075790463235],
            [-3.138013343028031, 1.94765588151173],
            [-3.138681768612486, 1.9314131668655459],
            [-3.139361296925067, 1.894545579351194],
            [-3.141577380425495, 1.8425613591051058],
            [-3.14387090626621, 1.779703300582264],
            [-3.1433761000654505, 1.7661921530335822],
            [-3.143510106956352, 1.7538988024184756],
            [-3.175586113966258, 1.755427013728128],
            [-3.2282361790809957, 1.758200231652392],
            [-3.2782870882929536, 1.7613794365555564],
            [-3.3000574527857607, 1.7630395250691582],
            [-3.3657798053016403, 1.7666162931103602],
            [-3.4705436543401693, 1.7725288918675064],
            [-3.5552901740349077, 1.776887627987021],
            [-3.5699539770434003, 1.7776008192585389],
            [-3.563966167379112, 1.894067448748897],
            [-3.5611829847739065, 1.9448045227494228],
            [-3.561308692398349, 1.9532936823817593],
            [-3.556598432506506, 2.039329100199094],
            [-3.5521845148605515, 2.127644643292366]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.06183427739387,
          "lat": 40.52476358124986
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31085"],
        "coty_name": ["Hayes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hayes County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00835864"
      },
      "bbox": [
        -3.5699539770434003, 1.7538988024184756, -3.126079933094492,
        2.127644643292366
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.087392685068563, -3.5697587858452082],
            [-9.0751117756574, -3.571591880158701],
            [-9.06030093210412, -3.5717956538015048],
            [-8.946363283689815, -3.5861792437764493],
            [-8.932155913931014, -3.586281809568066],
            [-8.917207176266503, -3.589190436591188],
            [-8.818859846055421, -3.600992147859454],
            [-8.775700109980624, -3.6067704695293146],
            [-8.76845043106499, -3.6071055322559737],
            [-8.745370354906434, -3.6101228287501903],
            [-8.663257207995391, -3.6204289253863453],
            [-8.515788503098154, -3.6368779660007977],
            [-8.421888328616179, -3.6468504051923123],
            [-8.404266596554324, -3.6498846499068986],
            [-8.317035923483758, -3.7086466308517623],
            [-8.158093801561787, -3.784595464482298],
            [-8.111186360385226, -3.8068993370218993],
            [-8.074118399812278, -3.831181752415441],
            [-8.059788211621793, -3.832326730966771],
            [-8.041794234308602, -3.8320733328520644],
            [-8.04299010289163, -3.844088152242552],
            [-8.0516387045779, -3.9242354642859487],
            [-8.051523076184218, -3.925025102664903],
            [-8.060848544644793, -4.011942344383476],
            [-7.804646657462877, -4.039472975941311],
            [-7.706436250765258, -4.049928646298149],
            [-7.661299478398621, -4.0545873922220315],
            [-7.669821010711252, -4.142056850182084],
            [-7.678616513364334, -4.228984657845404],
            [-7.679328443940013, -4.229326538989414],
            [-7.692823687029191, -4.357964695360292],
            [-7.6975898516083205, -4.403391680483382],
            [-7.696931980915372, -4.403460427266923],
            [-7.705872986284595, -4.488775639530635],
            [-7.81082995363792, -4.477756372035113],
            [-7.819069986704844, -4.554990269241417],
            [-7.829518146494135, -4.6527901895058115],
            [-7.916291760114455, -4.643577689563632],
            [-7.9160627277093845, -4.641434530798993],
            [-8.00553918461906, -4.623626165805233],
            [-8.092132141560546, -4.614247700930531],
            [-8.111236385293973, -4.794538256144966],
            [-8.194751979090695, -4.785054211513965],
            [-8.19525721685939, -4.78944661914183],
            [-8.421719516456916, -4.764454195401397],
            [-8.615402888112737, -4.740785420981485],
            [-8.809081618882091, -4.717081320437573],
            [-8.997396406312038, -4.696142466762162],
            [-9.214037537714821, -4.669341086372038],
            [-9.180933119061894, -4.4087452775594045],
            [-9.172615057969828, -4.3359929124852625],
            [-9.169746869357763, -4.3219137127242195],
            [-9.173323169508786, -4.32147095600424],
            [-9.12154483334351, -3.9012614208007155],
            [-9.119958419154296, -3.8883274084044164],
            [-9.12738380428068, -3.887442587174629],
            [-9.11507808548775, -3.786823940003421],
            [-9.104057988701324, -3.7038015551843717],
            [-9.100635307223293, -3.672076486309117],
            [-9.096419621390872, -3.6298158548042063],
            [-9.087392685068563, -3.5697587858452082]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.9302480177757, "lat": 34.00716393029486 },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35053"],
        "coty_name": ["Socorro"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Socorro County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01702371"
      },
      "bbox": [
        -9.214037537714821, -4.794538256144966, -7.661299478398621,
        -3.5697587858452082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.800803430923875, 4.964961303031986],
            [12.806099008196092, 4.9642747769788365],
            [12.807462221185544, 4.967452444834182],
            [12.815931199917863, 4.96750060414464],
            [12.819778207354943, 4.973897972156256],
            [12.835485138467659, 4.967960675490525],
            [12.839114782576683, 4.969748962786171],
            [12.845494343648465, 4.966855077324491],
            [12.84904830600446, 4.967465750714309],
            [12.852115849508719, 4.965423484260928],
            [12.854477706746742, 4.959916286329952],
            [12.857749356210736, 4.956113584937118],
            [12.858041786708197, 4.950069182267757],
            [12.861718938779536, 4.949130375773775],
            [12.86174405611513, 4.945791798363036],
            [12.866627748473627, 4.9410866206001645],
            [12.868877433135443, 4.941238694264549],
            [12.876606253429914, 4.933617305344102],
            [12.880433284469381, 4.934633220814574],
            [12.880138147470456, 4.927007556464042],
            [12.887310234267707, 4.913806393139508],
            [12.892200708809948, 4.910823291217894],
            [12.901540190519235, 4.9116857359350075],
            [12.904714932363971, 4.908042562689059],
            [12.912376277434403, 4.904354980761455],
            [12.918516603219306, 4.899918739959158],
            [12.917598162736482, 4.890783307770616],
            [12.920567423955813, 4.88942802101884],
            [12.92437461306961, 4.895588661196859],
            [12.92916745694991, 4.894735260078316],
            [12.93377510103305, 4.897424196096621],
            [12.937003280113828, 4.89063685143091],
            [12.940027204208878, 4.889614307219294],
            [12.943160610231057, 4.893076306155882],
            [12.945420697022119, 4.889822816777011],
            [12.950029195480449, 4.893939085598221],
            [12.954826391458996, 4.892578440429845],
            [12.956947972435684, 4.895465067889329],
            [12.969300687708804, 4.898452171799976],
            [12.974037464467726, 4.901452934862974],
            [12.97943185909432, 4.901286182115771],
            [12.981656816882603, 4.907030508084513],
            [12.985002282878595, 4.906941029215052],
            [12.988726063735195, 4.9101449331703],
            [12.995995446536307, 4.91976775876579],
            [12.998767326372713, 4.919894635613943],
            [13.002766920978662, 4.924263900413196],
            [13.006158905018767, 4.925480741932152],
            [13.01747520289163, 4.9198994559369735],
            [13.023785399984124, 4.9230189641481035],
            [13.021728021060134, 4.93084883668569],
            [13.027291606707356, 4.928325395537881],
            [13.03200841328589, 4.931205718127778],
            [13.030638949399318, 4.93443080203916],
            [13.03664110671894, 4.937757423515152],
            [13.03790195670376, 4.9429506768896],
            [13.04387387688704, 4.942761481931054],
            [13.04524399037448, 4.945652577335259],
            [13.043231396969508, 4.948288704524282],
            [13.049342534600092, 4.950264375590085],
            [13.049985393933127, 4.953759532722873],
            [13.060205090648084, 4.957756743813377],
            [13.070061166868369, 4.959706006679246],
            [13.071628666399176, 4.950838172289403],
            [13.076182219725307, 4.9475686021487055],
            [13.078014062765169, 4.952837218616972],
            [13.08207476612393, 4.95253729300901],
            [13.084108962253229, 4.955523773764469],
            [13.08343172711366, 4.960487002618361],
            [13.088029792677172, 4.9617716362869375],
            [13.088573808311963, 4.9651738512616],
            [13.095687587070792, 4.969111118927878],
            [13.096050305712732, 4.972298618181983],
            [13.105232967825227, 4.974168266901349],
            [13.108406648423172, 4.9729555221287125],
            [13.112114184873445, 4.980983726347982],
            [13.115666788858894, 4.980150031335834],
            [13.120686573416288, 4.984600001846011],
            [13.123029512877439, 4.989244459254255],
            [13.131713214058484, 4.990341961615373],
            [13.132644343226522, 4.993298146243172],
            [13.139544167670701, 5.000949206380793],
            [13.14674396573587, 4.998497023238143],
            [13.149660303602591, 5.004432261484977],
            [13.156876636850617, 5.002005589189291],
            [13.164182292831008, 5.001523224017444],
            [13.165349045716857, 5.005738035139772],
            [13.170409191325138, 5.005716184530593],
            [13.174544870204816, 5.012623712640358],
            [13.181064741049235, 5.010158378447123],
            [13.181096809974834, 5.013748540657304],
            [13.184634643634057, 5.013799867640753],
            [13.185061526566942, 5.017947498902563],
            [13.187709518427743, 5.019337278068242],
            [13.19438192100728, 5.017692790916028],
            [13.198590060512222, 5.02453193956469],
            [13.198203374609486, 5.027223663241505],
            [13.207222474170297, 5.028864746544901],
            [13.20799129461759, 5.031150855563253],
            [13.212322512606457, 5.032111674745496],
            [13.213523691931657, 5.037237504977375],
            [13.217592811721644, 5.0360667416423475],
            [13.22307179973469, 5.038574258676054],
            [13.228080961060114, 5.038423097324569],
            [13.230934295089664, 5.042010732137849],
            [13.233628454323094, 5.025045644346988],
            [13.26059099191507, 5.030151258436751],
            [13.345345643616248, 5.047938022077164],
            [13.361480249547517, 4.964513271095321],
            [13.370330235958107, 4.916864612442257],
            [13.374947300806864, 4.890532462582143],
            [13.393539795986717, 4.7915601900275755],
            [13.409853900272058, 4.705946249963164],
            [13.420132587283575, 4.652870889864637],
            [13.427489471947643, 4.61384119743693],
            [13.432229415314902, 4.590372741912217],
            [13.443081214722634, 4.533583855818049],
            [13.386656650535492, 4.5231419180874655],
            [13.289504899970403, 4.505274185201207],
            [13.233718185740868, 4.495077679568177],
            [13.122939027583389, 4.472912910806083],
            [13.032301213213584, 4.455829739097817],
            [13.000156221251483, 4.450577724658094],
            [12.953417878340668, 4.442968574651726],
            [12.896577580779935, 4.43305275806662],
            [12.88254531324091, 4.519762278428555],
            [12.86782387248334, 4.598508016510396],
            [12.854024889443068, 4.673590254251619],
            [12.850593193400936, 4.691109225421314],
            [12.834769512826842, 4.7773745909558825],
            [12.816739326382965, 4.874943146598794],
            [12.80505916238806, 4.940436717130928],
            [12.800803430923875, 4.964961303031986]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.67883566889589,
          "lat": 42.248594329978744
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36009"],
        "coty_name": ["Cattaraugus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cattaraugus County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00974103"
      },
      "bbox": [
        12.800803430923875, 4.43305275806662, 13.443081214722634,
        5.047938022077164
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.039148344122953, 5.594883060573438],
            [15.08752090681095, 5.608630205107836],
            [15.099913930311846, 5.612589826249613],
            [15.225622664925549, 5.648444948145382],
            [15.23004662326215, 5.649452808577774],
            [15.276538774047532, 5.6620062522026915],
            [15.320970954895424, 5.6745959695334625],
            [15.363552360281462, 5.68715500808904],
            [15.36561653152621, 5.680113981628107],
            [15.405715282892313, 5.691147493381785],
            [15.458497566598565, 5.706650137159867],
            [15.462054775895202, 5.700918064673774],
            [15.4585854528022, 5.691274881162295],
            [15.462331382817272, 5.690198944990437],
            [15.463578192732081, 5.681672108312656],
            [15.460350259473326, 5.674190854534619],
            [15.457794598026215, 5.658595260925883],
            [15.45790112747336, 5.650780559467352],
            [15.45350079600538, 5.641983284743977],
            [15.450467136161052, 5.639989087882085],
            [15.451356606550153, 5.633635349243278],
            [15.449315700973493, 5.630096887006566],
            [15.449886078710488, 5.626594305590771],
            [15.453004196046479, 5.623351506353924],
            [15.451413501879712, 5.619950922918587],
            [15.456016414831966, 5.612574730193112],
            [15.45647804874118, 5.607798930610418],
            [15.460950084435154, 5.6043461831776265],
            [15.462542647024172, 5.594583495140726],
            [15.459366160051461, 5.589700447095374],
            [15.461687180911932, 5.586073723403323],
            [15.465444902416914, 5.583903522740952],
            [15.464729719937479, 5.580588315660135],
            [15.45757211155302, 5.572580533172991],
            [15.458036600361625, 5.564685840331348],
            [15.459795317158408, 5.562205814541518],
            [15.46217945855985, 5.5538569656805],
            [15.46595073259234, 5.553811338520115],
            [15.471168262333137, 5.550195576113506],
            [15.46935181451333, 5.541964581721432],
            [15.472120426543437, 5.537794589565176],
            [15.470666775390395, 5.526996645044814],
            [15.466558702234146, 5.520271047695397],
            [15.461106456933967, 5.518827523397834],
            [15.46076159591701, 5.516211934595681],
            [15.45508432545474, 5.5105785094150255],
            [15.448739232423417, 5.507549115752182],
            [15.449728006851974, 5.500887415595864],
            [15.44843458429534, 5.491347849336414],
            [15.44313302496924, 5.48571613090346],
            [15.44323816585873, 5.480147577418226],
            [15.441432621054954, 5.477026974476891],
            [15.443984634615077, 5.474560627174424],
            [15.441931862765404, 5.463450949344335],
            [15.433139322420795, 5.462013582801467],
            [15.43878111399731, 5.457595954960002],
            [15.439731791680881, 5.454241605528738],
            [15.438064633345187, 5.4512560610703735],
            [15.440710027442664, 5.446965184806958],
            [15.44340385950664, 5.439665666922653],
            [15.438421229431647, 5.430468706032478],
            [15.442395979475332, 5.426237989026823],
            [15.442036505568238, 5.423730787843607],
            [15.446145430821858, 5.413643447981455],
            [15.448968308156813, 5.413358465622089],
            [15.454692549970252, 5.404803030857682],
            [15.458879638421953, 5.399940716871542],
            [15.461802542107431, 5.388563446743179],
            [15.466569972893911, 5.382794011813967],
            [15.469862584924119, 5.381622359490192],
            [15.470104927199442, 5.373214875013055],
            [15.474383025454374, 5.368243052492978],
            [15.4711958773527, 5.364321275099237],
            [15.471032853881875, 5.359740459639552],
            [15.463857704562859, 5.355804067945614],
            [15.463668827024353, 5.3512248074676485],
            [15.459736672766653, 5.343819545658745],
            [15.458106214366358, 5.33388345696245],
            [15.462012746616905, 5.329745066255415],
            [15.46160055889127, 5.324604515530509],
            [15.463760646715548, 5.319678820979467],
            [15.46793004005987, 5.314885707946808],
            [15.472534752103758, 5.314984143474492],
            [15.472956835907858, 5.3091753249794165],
            [15.468255997786914, 5.303605050505319],
            [15.469148073304405, 5.300400363928499],
            [15.472933158398215, 5.295775195262394],
            [15.47377756121014, 5.291426852714513],
            [15.46979002334769, 5.287363631817894],
            [15.46950597550445, 5.282131466313736],
            [15.46767146522414, 5.2782139959205585],
            [15.470179302116614, 5.273410929910452],
            [15.465626521551425, 5.273334928815977],
            [15.466335166408953, 5.267303014406018],
            [15.46938566501033, 5.253078800181872],
            [15.478783621767628, 5.20426180029945],
            [15.489877158112467, 5.1501740013692405],
            [15.40764249164732, 5.132421505380551],
            [15.332553630477666, 5.116502644627734],
            [15.323681528982556, 5.156207786633866],
            [15.319800865220277, 5.168177559837509],
            [15.288256308934518, 5.160614318161032],
            [15.260296056416909, 5.154481889212691],
            [15.259856805498403, 5.1558993955769745],
            [15.218990340809182, 5.147057295204979],
            [15.18985506268065, 5.140469048542906],
            [15.184099253973589, 5.135869000054756],
            [15.17902506104724, 5.133122608367291],
            [15.170337633004603, 5.147276890549932],
            [15.146257279563665, 5.229925793307741],
            [15.133541026649853, 5.263714391146149],
            [15.127736923816414, 5.279723946341846],
            [15.122779539060982, 5.29704583854418],
            [15.119748186109982, 5.30712370626093],
            [15.102954544865637, 5.369182179874712],
            [15.078490419837406, 5.455342168437095],
            [15.05784076060584, 5.529018133466326],
            [15.039148344122953, 5.594883060573438]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.61156149452205,
          "lat": 42.493525528099696
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36017"],
        "coty_name": ["Chenango"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chenango County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00974107"
      },
      "bbox": [
        15.039148344122953, 5.116502644627734, 15.489877158112467,
        5.706650137159867
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.7528724638382, 6.327932857865078],
            [15.751958620680766, 6.330656122389028],
            [15.821769614216935, 6.315336191651569],
            [15.891575985383978, 6.300003844057372],
            [15.892621685916602, 6.300859806099042],
            [15.944847880374473, 6.317082710710391],
            [16.035609555653902, 6.34692449521249],
            [16.044560962282777, 6.321348522704189],
            [16.11468267353586, 6.344457086667319],
            [16.106234248401748, 6.369951137077144],
            [16.16422516845173, 6.389382379312706],
            [16.172896370719684, 6.365599570356073],
            [16.190300195673604, 6.31692632165126],
            [16.22038816976096, 6.233212678177599],
            [16.256578333511438, 6.132681990237638],
            [16.245972644595028, 6.130089715433877],
            [16.19772235549199, 6.119504022490923],
            [16.192218915647757, 6.118129966893694],
            [16.13503863516695, 6.105869379134919],
            [16.05010804954631, 6.086526035421462],
            [15.978763010899057, 6.0707133561439965],
            [15.94072551170401, 6.06243728931376],
            [15.910833911529505, 6.066633309744626],
            [15.89103322487205, 6.070032561175723],
            [15.849077614397679, 6.076223036163078],
            [15.772668043817669, 6.087737661176059],
            [15.769034107832349, 6.0927331019181095],
            [15.76854698447301, 6.0991069702075364],
            [15.761550499510713, 6.103947529114442],
            [15.759273505504172, 6.112883728690995],
            [15.755616151520158, 6.115718703207005],
            [15.754853739834212, 6.120572969320104],
            [15.756349761936946, 6.12556712699057],
            [15.758958041762446, 6.128427028521079],
            [15.753664185144826, 6.139003860183572],
            [15.75347900241876, 6.146857329634329],
            [15.750904813051417, 6.1495428207134415],
            [15.753028510755412, 6.1522274267555055],
            [15.758468552065501, 6.152706156971352],
            [15.757263956657628, 6.158213328670919],
            [15.765125436855481, 6.16247919370609],
            [15.770729861027524, 6.161902446503823],
            [15.770791841517461, 6.16619010049125],
            [15.777608217684724, 6.1685605872571365],
            [15.772832428603309, 6.175314702444679],
            [15.772701249338075, 6.1793934878892145],
            [15.769086001020574, 6.185815436550889],
            [15.77460342107012, 6.188823868271759],
            [15.778544881984423, 6.192494919425674],
            [15.78654458915437, 6.19570156879874],
            [15.780865387587754, 6.202124669299233],
            [15.776857626763416, 6.2046140993919865],
            [15.776334666307097, 6.209398238522372],
            [15.778723318915882, 6.214967659165306],
            [15.782734503214408, 6.2188639756864985],
            [15.786590759247007, 6.218774148828148],
            [15.789534020967537, 6.220819741915333],
            [15.788191070860842, 6.2270650528915725],
            [15.765026800420122, 6.291007836990167],
            [15.764399728273846, 6.29358125120642],
            [15.7528724638382, 6.327932857865078]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.42224187317046,
          "lat": 43.113833796446336
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36035"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00974116"
      },
      "bbox": [
        15.750904813051417, 6.06243728931376, 16.256578333511438,
        6.389382379312706
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.410886367309686, 5.920368386191225],
            [13.420626916817548, 5.924202466453967],
            [13.42375523685731, 5.926813834864428],
            [13.428940801218078, 5.925791836312705],
            [13.431920342166814, 5.9272535885654385],
            [13.464221758509478, 5.922134426119194],
            [13.476938921358903, 5.924570986226871],
            [13.480141992385466, 5.922943483378076],
            [13.48931331366726, 5.921711684138468],
            [13.499287598714433, 5.9214272141236375],
            [13.519142169118116, 5.9223715253962474],
            [13.521771353384986, 5.923594962965002],
            [13.530763306072997, 5.922689228434725],
            [13.534931364631275, 5.921330086890978],
            [13.542228214905421, 5.923475635326231],
            [13.556542946440917, 5.922464490323913],
            [13.570500782550425, 5.924861570093687],
            [13.57804297376852, 5.927940305574192],
            [13.58268578278175, 5.928839453997492],
            [13.585758611046451, 5.925563838024278],
            [13.605825535754462, 5.9221135346938585],
            [13.608172003134303, 5.91991999650026],
            [13.618817079121076, 5.917908173856611],
            [13.620256148751915, 5.912458250694094],
            [13.625841294605861, 5.906319683377758],
            [13.630782688585528, 5.904644853237614],
            [13.646410174932914, 5.8970970868070305],
            [13.6648370629864, 5.885523075542522],
            [13.670206209103585, 5.882987120737667],
            [13.689872981846438, 5.8784793605181695],
            [13.731622784168026, 5.858050734881425],
            [13.741249386502453, 5.854736319952152],
            [13.751709202501424, 5.854333308462763],
            [13.759999628865934, 5.855270289440912],
            [13.766576900627163, 5.857477939942419],
            [13.775386591463343, 5.864053321404071],
            [13.776209057694082, 5.86752452364638],
            [13.784500848508495, 5.8756334433700985],
            [13.794464821030134, 5.877684930676945],
            [13.805383508587903, 5.886558036948624],
            [13.815562834392116, 5.892691054560782],
            [13.823927234044465, 5.8961633861940514],
            [13.829746722666437, 5.902754966218723],
            [13.834283421816993, 5.905593696288716],
            [13.842234057580896, 5.906243469231945],
            [13.847648160464106, 5.908905468835983],
            [13.857546014756192, 5.916498586949162],
            [13.863399513780529, 5.916604834529173],
            [13.868208880926316, 5.9184617012162],
            [13.891933645776923, 5.805026540418092],
            [13.900322829544425, 5.767808248789419],
            [13.910371861056301, 5.7222299289396545],
            [13.918741182732989, 5.6821605983782675],
            [13.896486631586953, 5.677872522702939],
            [13.837517231889478, 5.66602840429202],
            [13.849945045169996, 5.609344120960155],
            [13.857380469328303, 5.576695089157061],
            [13.78733466540236, 5.563790257462832],
            [13.748205071346021, 5.556669252318639],
            [13.74728814869025, 5.551900957307156],
            [13.660595124380436, 5.535583559928257],
            [13.659328305447607, 5.5394479930104685],
            [13.663560550154392, 5.541446464214224],
            [13.668730897551354, 5.540839877462833],
            [13.673655277906247, 5.545533544019624],
            [13.678944997300652, 5.547248359665502],
            [13.681065572153626, 5.558678419086817],
            [13.678935817476237, 5.565143668436163],
            [13.679729276880147, 5.571660249566443],
            [13.683492633751584, 5.573569406508258],
            [13.680287055489927, 5.578890719079047],
            [13.671057652859105, 5.579874991204111],
            [13.671233384010169, 5.586495747874347],
            [13.583250343934269, 5.5690465777635625],
            [13.543606111477347, 5.5612764965023125],
            [13.541096959916286, 5.5758375032460235],
            [13.542370737862102, 5.576427295922564],
            [13.53830471139825, 5.610500205960469],
            [13.504338917532953, 5.6065294167729745],
            [13.51076019142945, 5.649410938790585],
            [13.518649892994167, 5.705064349635348],
            [13.49494028780689, 5.69989564845236],
            [13.45363833702394, 5.692039264702527],
            [13.43709927611709, 5.779229313788641],
            [13.431838280166016, 5.807690709734844],
            [13.42600570255917, 5.841537703687687],
            [13.419039986519975, 5.87945288550707],
            [13.410886367309686, 5.920368386191225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.69611722611542,
          "lat": 43.146461046610035
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36055"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00974126"
      },
      "bbox": [
        13.410886367309686, 5.535583559928257, 13.918741182732989,
        5.928839453997492
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.18159809416619, 5.9237937348983145],
            [16.179920662886992, 5.926615686476864],
            [16.183663414764624, 5.93028375405159],
            [16.18493726251554, 5.936838068390656],
            [16.182628377997823, 5.940140188436624],
            [16.229235937531723, 5.990414015018991],
            [16.261332605590102, 6.024546705861778],
            [16.285869669018854, 6.0516115760364935],
            [16.2758829358489, 6.080056974121887],
            [16.265974525940692, 6.107075656229281],
            [16.29304747529837, 6.110749184360444],
            [16.303632857110493, 6.1081507356399465],
            [16.311464337497505, 6.104625621627092],
            [16.322318931003043, 6.102742766755736],
            [16.332245110700722, 6.1001815372258426],
            [16.34174926644148, 6.095881724540789],
            [16.35747900181581, 6.087424854335671],
            [16.369219856571483, 6.075959968724597],
            [16.376932352308614, 6.072885687920632],
            [16.383099659862037, 6.077772993212431],
            [16.389891120741545, 6.084378997502568],
            [16.400119777889245, 6.091747151554336],
            [16.40992279478028, 6.09488357551937],
            [16.41761329258732, 6.073535085154046],
            [16.429838158342896, 6.037814825152001],
            [16.43568817942107, 6.038274010819637],
            [16.439933668711873, 6.0399879126422205],
            [16.441961097350823, 6.038100426839763],
            [16.44797380072706, 6.024816324042943],
            [16.455794437217218, 6.020598106264844],
            [16.46363397079918, 6.013811506944095],
            [16.469667206482928, 6.006512509237765],
            [16.476201532844268, 6.00073639661651],
            [16.480760020789393, 5.995129325243392],
            [16.48854615303472, 5.992033861314736],
            [16.49142468087448, 5.98973298792072],
            [16.493079700886494, 5.984676088117561],
            [16.498623103950965, 5.98125486613965],
            [16.508034758840473, 5.98203128222325],
            [16.50876540540574, 5.978241704296534],
            [16.44245442401329, 5.950681159344995],
            [16.426503452459727, 5.944565642631108],
            [16.40585325203427, 5.9360487672623],
            [16.38290207922565, 5.925953740751214],
            [16.3525906927959, 5.913061103344484],
            [16.286341707488464, 5.885584916981646],
            [16.255824188990353, 5.872627886917147],
            [16.2569647632247, 5.854922798700321],
            [16.244250297689348, 5.850254519885012],
            [16.215989997739662, 5.852019592780445],
            [16.215631235075048, 5.849812308944845],
            [16.193972100867835, 5.842136819203451],
            [16.19385620192797, 5.847527327295193],
            [16.188842097093936, 5.846294920504502],
            [16.163076290343547, 5.868869356372473],
            [16.162210097408796, 5.87374957754604],
            [16.16967366262708, 5.879147718799558],
            [16.17385685077058, 5.881063382818338],
            [16.185975319719823, 5.884569115491592],
            [16.190568066168723, 5.8837819626322565],
            [16.193940731677383, 5.886444243383703],
            [16.196950980533934, 5.896078276260387],
            [16.193467358599438, 5.901580701449189],
            [16.192629459122518, 5.905258906845047],
            [16.195164093740136, 5.914644694340638],
            [16.194586510910018, 5.916890278483979],
            [16.18998717519157, 5.9195715335016335],
            [16.18876072963115, 5.923367022717691],
            [16.18159809416619, 5.9237937348983145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.05856009325447,
          "lat": 42.818129299524095
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36093"],
        "coty_name": ["Schenectady"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schenectady County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00974144"
      },
      "bbox": [
        16.162210097408796, 5.842136819203451, 16.50876540540574,
        6.110749184360444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.666285723252136, 5.063695240220306],
            [14.712739606562875, 5.072683122260829],
            [14.715924379747568, 5.05555001638706],
            [14.758034148486216, 5.063499775481071],
            [14.747267754269087, 5.118003021028495],
            [14.762088650552796, 5.1212347392433415],
            [14.776819836070452, 5.123961405633899],
            [14.793607051982884, 5.127584876224839],
            [14.79582385834837, 5.117955775742482],
            [14.840727279308608, 5.127136262418761],
            [14.843136567225763, 5.115895719355533],
            [14.87049333745152, 5.121544788721556],
            [14.869676406479014, 5.1284151681422285],
            [14.866839918417341, 5.134341784490862],
            [14.867097976461356, 5.140367859014601],
            [14.863760415095154, 5.149045768319203],
            [14.865849632027755, 5.153482674710504],
            [14.86438658792551, 5.164656370033274],
            [14.866952037151016, 5.175474104412649],
            [14.86806969972167, 5.176697667180593],
            [14.864851872547582, 5.18494260862557],
            [14.860956304076335, 5.188430472495795],
            [14.855901823303665, 5.190056328742157],
            [14.852166099528333, 5.1927891571319],
            [14.843485450172357, 5.196285444921242],
            [14.835384357771433, 5.196553163917306],
            [14.831234937715635, 5.198929578064474],
            [14.828046361189381, 5.1973853309478315],
            [14.820612894470209, 5.196566358709004],
            [14.816716244203448, 5.20077167540832],
            [14.818058810949408, 5.205776203772194],
            [14.815266278829842, 5.2114049741806285],
            [14.81681271746373, 5.222703489652304],
            [14.845159903126575, 5.229841595040268],
            [14.932984992324647, 5.251174331791816],
            [14.935083217737043, 5.243114123518485],
            [14.938785739389905, 5.2438708720220175],
            [14.942017509607755, 5.2341933062251735],
            [14.946325391826395, 5.223663872231536],
            [14.944417861049814, 5.223310882655974],
            [14.947558038053549, 5.210037886797168],
            [14.953176825738778, 5.211145825860938],
            [14.955243910316566, 5.201514146147774],
            [14.957169268788007, 5.201902857434207],
            [14.960701928744523, 5.192481447199953],
            [14.963246847098128, 5.182751427511913],
            [14.957939861838819, 5.181531735734936],
            [14.960417157187528, 5.171125989260955],
            [14.963249479382414, 5.1716808669317516],
            [14.964924310068739, 5.163917559853565],
            [14.969213231220778, 5.164956999376171],
            [14.971067969772015, 5.156753935016394],
            [14.97438606901422, 5.15750623175559],
            [14.975885513774662, 5.150579790440721],
            [14.977651613644875, 5.151025301747446],
            [14.979946669879702, 5.1415220160964425],
            [14.974356985776629, 5.140213113444662],
            [14.975641277447634, 5.134156164321393],
            [14.979505366853518, 5.134904087649294],
            [14.982018012194475, 5.126355634776491],
            [14.990994704533788, 5.128586150656495],
            [14.992818490074846, 5.121718525810176],
            [14.995526962315274, 5.122431611286255],
            [14.997460576334174, 5.115593279515164],
            [15.000420997168504, 5.109293221866122],
            [14.98905439233035, 5.106337612817363],
            [14.990917415865097, 5.098603306099825],
            [14.994804184396532, 5.099544114050332],
            [14.996162844238137, 5.094284369822908],
            [14.99860351122992, 5.094813542633848],
            [15.001069192934605, 5.085725107234684],
            [15.003426892165638, 5.081721515849928],
            [15.005842476495113, 5.082257851680264],
            [15.008358138513175, 5.070638931694825],
            [15.009372600647875, 5.063006989365317],
            [15.006729226009542, 5.06229423916194],
            [15.011659569233581, 5.045915670319032],
            [15.009117857961263, 5.045132199026445],
            [15.010988873410495, 5.038605032351824],
            [14.989984582330644, 5.032879680694148],
            [15.008733922181552, 4.961665942913643],
            [15.011548140776052, 4.962323967462442],
            [15.013976123218987, 4.952236128523553],
            [15.011024038049385, 4.9507386808553635],
            [15.030421796085951, 4.883451518960684],
            [15.029466081647882, 4.882845056769776],
            [15.036537607544977, 4.851189692661362],
            [15.007884910379527, 4.845187532975031],
            [14.922201826165104, 4.826795298391018],
            [14.864897893795202, 4.814556779392628],
            [14.779236644825733, 4.7973055031897545],
            [14.709964142174817, 4.784194309446115],
            [14.709267256040356, 4.788528594093062],
            [14.705446842803582, 4.792847300553339],
            [14.711114777742742, 4.8372967332857995],
            [14.698847943700889, 4.863348033398048],
            [14.688741640360012, 4.895598045881815],
            [14.685142785995884, 4.908736062026721],
            [14.681911513228622, 4.912748627491838],
            [14.682303600867035, 4.920751903965272],
            [14.678403424802807, 4.929680275053917],
            [14.674550097328474, 4.933094871215801],
            [14.674472121494675, 4.936478170959741],
            [14.693481049309758, 4.939887377594468],
            [14.674619104890807, 5.032969902926589],
            [14.666285723252136, 5.063695240220306]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.30628332975, "lat": 42.17033915397908 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36107"],
        "coty_name": ["Tioga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tioga County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00974151"
      },
      "bbox": [
        14.666285723252136, 4.784194309446115, 15.036537607544977,
        5.251174331791816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.868208880926316, 5.9184617012162],
            [13.87939858203549, 5.923111710231549],
            [13.886597804893839, 5.924640803639251],
            [13.892173245469312, 5.927719862824615],
            [13.896872355325408, 5.925796566865724],
            [13.905707421520388, 5.9303557474987105],
            [13.912927564279897, 5.9320519541329],
            [13.91428236787648, 5.930066622839569],
            [13.927089877342333, 5.9318492900890245],
            [13.931291646877954, 5.933397413418011],
            [13.935499654061374, 5.932852172556432],
            [13.947459226975514, 5.935317601734287],
            [13.98172591093421, 5.949016502404388],
            [13.994720310071598, 5.950039127839623],
            [13.99806988375358, 5.953365059247993],
            [14.003985641094259, 5.951078639626555],
            [14.011336167226947, 5.952265281619719],
            [14.022539540465507, 5.959194133238529],
            [14.026457810065253, 5.963157398069726],
            [14.036588954519303, 5.961436071766992],
            [14.042078791753868, 5.9625466882575315],
            [14.047167501578231, 5.965318053936796],
            [14.052969855336999, 5.9659170677529625],
            [14.056663323294217, 5.969286730708048],
            [14.065368308970076, 5.966521100561703],
            [14.080680850116035, 5.966043773499283],
            [14.084363673295424, 5.968220910393151],
            [14.087712577908386, 5.965522850461965],
            [14.091842384464538, 5.966248213762214],
            [14.095876000407676, 5.964099983940961],
            [14.100544445883825, 5.965630641538269],
            [14.10620780200708, 5.960062429977408],
            [14.127159922154535, 5.963853008226305],
            [14.136457975632643, 5.967110156736725],
            [14.143834541809511, 5.971701922583591],
            [14.148133052547493, 5.971431530632338],
            [14.160645505889462, 5.972689659100425],
            [14.161599351281634, 5.971228763231453],
            [14.171238906723719, 5.973175714158181],
            [14.175313291485413, 5.976491096897217],
            [14.182884404116924, 5.984850179755067],
            [14.187152216289512, 5.991416691209527],
            [14.190030416489243, 5.991531914252689],
            [14.200102739279131, 6.000736144108559],
            [14.205006338963956, 6.005953690762545],
            [14.212015890751445, 6.005266916938907],
            [14.218962099813215, 6.005691109240214],
            [14.226345342178217, 6.008881540854149],
            [14.23376193077939, 6.014322938525045],
            [14.24179907487037, 6.023051806017615],
            [14.24921929008676, 6.025142685686633],
            [14.25293866809449, 6.024561628275196],
            [14.264298291352576, 6.03059779801687],
            [14.267793141124043, 6.030957378592339],
            [14.274861423404586, 6.033828417397476],
            [14.290412951004985, 6.045450446066081],
            [14.295183992639256, 6.050063112543342],
            [14.304207035454526, 6.061953575728479],
            [14.314541431273959, 6.076990556141929],
            [14.318606928494756, 6.077660931500373],
            [14.335776928551525, 6.01434834639482],
            [14.336672607462909, 6.014505061582698],
            [14.344179152773188, 5.98667590150328],
            [14.355406321454986, 5.943950288689415],
            [14.369290597245005, 5.888849813348917],
            [14.386249159542368, 5.82286069529011],
            [14.385663989160012, 5.812927683149143],
            [14.382636384786132, 5.810832046880564],
            [14.37884382050671, 5.803208175781658],
            [14.380773367797435, 5.797155737799623],
            [14.382426779031269, 5.781134646409791],
            [14.38423665571331, 5.774164542672715],
            [14.389500318416067, 5.7659666663675155],
            [14.331016969773762, 5.7509649927736755],
            [14.273440534225779, 5.735769493301422],
            [14.213512905283132, 5.719070355589856],
            [14.182834400225888, 5.7125507387225465],
            [14.092860897604494, 5.694101193741501],
            [14.086774364237211, 5.720871764978472],
            [14.006766758075178, 5.704781046638611],
            [14.007629495333598, 5.699748922666239],
            [13.918741182732989, 5.6821605983782675],
            [13.910371861056301, 5.7222299289396545],
            [13.900322829544425, 5.767808248789419],
            [13.891933645776923, 5.805026540418092],
            [13.868208880926316, 5.9184617012162]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.02941249928817, "lat": 43.15654424827415 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36117"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00974156"
      },
      "bbox": [
        13.868208880926316, 5.6821605983782675, 14.389500318416067,
        6.077660931500373
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.721966750556295, 4.530982789966924],
            [16.819938372714308, 4.5691437725869894],
            [16.88285228236511, 4.593376455125998],
            [16.961091354340883, 4.623963582171681],
            [16.990104962872895, 4.634856592162943],
            [17.02873957059428, 4.650044714883262],
            [17.035144192448954, 4.609995968675279],
            [17.037154084282417, 4.599765771228818],
            [17.03958708031421, 4.591737841261897],
            [17.04098690174082, 4.579490184692928],
            [17.07373550521143, 4.547351129436457],
            [17.10999921259019, 4.510629640258678],
            [17.09339747701563, 4.494285789966145],
            [17.05920566639018, 4.459565680700876],
            [17.012865370873484, 4.413661890742038],
            [16.958410835479782, 4.358503898064173],
            [16.96940316922573, 4.347581266745385],
            [16.992471837603574, 4.323825475431256],
            [17.024565711815963, 4.291372151704411],
            [17.032003656790202, 4.28421029889332],
            [17.031014612976822, 4.272220271070445],
            [17.03466443577536, 4.261070048342278],
            [17.032619400706555, 4.260322146645265],
            [17.03156752851337, 4.255033471965886],
            [17.036830497241215, 4.2549099000152975],
            [17.038780735028325, 4.252610798505229],
            [17.0378576935489, 4.247753853605928],
            [17.03849195621447, 4.241576133852156],
            [17.02690251473277, 4.233718022548872],
            [17.026314052326928, 4.218522578878585],
            [17.024907413584526, 4.213598078053479],
            [17.020619561970296, 4.211549684439043],
            [17.017390132363197, 4.206948707691239],
            [17.018508993342966, 4.220680063170227],
            [17.016177028249672, 4.221361672727344],
            [17.012617489599236, 4.205648716365094],
            [17.009761790344527, 4.205255612637968],
            [17.008752078925937, 4.209270809867851],
            [17.003582173647192, 4.207807475298795],
            [17.001018841202796, 4.203544007891286],
            [17.002296797206274, 4.194600708503607],
            [16.99556267541917, 4.182139857613496],
            [16.991748800807564, 4.187970373167174],
            [16.98836836628385, 4.186793780654651],
            [16.988163862453813, 4.182289948670813],
            [16.989581072852165, 4.176838124645541],
            [16.9813091602445, 4.169508766788729],
            [16.977876180540335, 4.1584888686290595],
            [16.97775199563889, 4.152855459005757],
            [16.96974606735904, 4.138687865950396],
            [16.969289070853833, 4.134991605381943],
            [16.96546181860533, 4.13656418357276],
            [16.96174569417508, 4.134624115502771],
            [16.937840942643426, 4.137064416871043],
            [16.93756609856796, 4.135621195392247],
            [16.926115113930315, 4.137244599285688],
            [16.92158632823073, 4.1466262975107275],
            [16.914430444031765, 4.148365899279503],
            [16.910229205263168, 4.145996608716365],
            [16.90933789981659, 4.139805699940777],
            [16.862338982346962, 4.146605853318911],
            [16.862921523675787, 4.157341884315765],
            [16.862537906327454, 4.181577752365613],
            [16.863595181696823, 4.21321862649404],
            [16.861613442729684, 4.228558884927271],
            [16.86001963074788, 4.236580565100936],
            [16.85854717388803, 4.254109965183086],
            [16.85556928892037, 4.268906412493847],
            [16.8529355668697, 4.27675624938565],
            [16.847576003761677, 4.287992799222629],
            [16.841154756500146, 4.311790188816049],
            [16.839438535970576, 4.3225401401686],
            [16.835679625522925, 4.35843401039016],
            [16.8335440539456, 4.367743841363454],
            [16.83050976729047, 4.374051880964115],
            [16.824152709928942, 4.3817444140182555],
            [16.81417833539786, 4.387550136365736],
            [16.809102305056857, 4.39244663037049],
            [16.80565455775038, 4.398243902632799],
            [16.797532333272727, 4.408818745058891],
            [16.79257083035606, 4.416847332999424],
            [16.786084448543278, 4.425439703225638],
            [16.764688367299048, 4.445184397602622],
            [16.757602472681803, 4.448885934512544],
            [16.75586811304387, 4.456532418960886],
            [16.74760476603249, 4.460679073705999],
            [16.74459407758828, 4.4685412901280825],
            [16.74596593386324, 4.48022255197075],
            [16.750874293891165, 4.4908776763229765],
            [16.756011730275596, 4.500554686955731],
            [16.755181142141637, 4.506967500583994],
            [16.740180774771986, 4.512418555239156],
            [16.733125168191343, 4.518605115841302],
            [16.72485541313869, 4.523783737854573],
            [16.722446820255755, 4.526521076191123],
            [16.721966750556295, 4.530982789966924]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.75610294252797,
          "lat": 41.162652152722195
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36119"],
        "coty_name": ["Westchester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Westchester County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00974157"
      },
      "bbox": [
        16.721966750556295, 4.134624115502771, 17.10999921259019,
        4.650044714883262
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.605251423641647, -1.0642165067663665],
              [16.61112110346935, -1.0589494342365402],
              [16.62133519529219, -1.0570568641328635],
              [16.632975651772604, -1.0570836878519865],
              [16.637580098563294, -1.060172457126332],
              [16.647138872746172, -1.0621751298546533],
              [16.661480075250175, -1.0688282646183012],
              [16.659543777995886, -1.0727577520580143],
              [16.662331275968267, -1.0821103830507581],
              [16.66942335224292, -1.082464965044188],
              [16.672820189152034, -1.0793556357033705],
              [16.675741933081834, -1.0799532748935106],
              [16.694286742171954, -1.0992965448760232],
              [16.7085476848451, -1.12388525611788],
              [16.708115041360134, -1.1329892225765454],
              [16.719223770663337, -1.1635592426680712],
              [16.715815494283873, -1.1709162622802558],
              [16.71281783184187, -1.171430500995054],
              [16.69925470463313, -1.1648285655030275],
              [16.675504591249165, -1.1649305658059779],
              [16.668453322601668, -1.1595813799198151],
              [16.678402762060088, -1.1487410882418827],
              [16.6728719509749, -1.1252333082868642],
              [16.669144600147632, -1.1185117736054342],
              [16.65901435051204, -1.1077145042767806],
              [16.651945595257256, -1.1076415322310613],
              [16.635413029205452, -1.092995610806806],
              [16.6343474741894, -1.0850524315070478],
              [16.628939324779054, -1.0801624169443464],
              [16.609818791607147, -1.0738357751153824],
              [16.605378422914228, -1.0664851797386705],
              [16.605251423641647, -1.0642165067663665]
            ]
          ],
          [
            [
              [16.757859262953282, -1.7902431837601187],
              [16.765466227282545, -1.7876256446007033],
              [16.770301987857057, -1.784246848272469],
              [16.780694940281354, -1.7738476663940403],
              [16.78066150590549, -1.7668878885322343],
              [16.784010915120497, -1.7623546189816648],
              [16.787889765284046, -1.7520987174413643],
              [16.791528933212394, -1.7489051221826508],
              [16.793442324237247, -1.7559020725446453],
              [16.797530484166735, -1.7620256183417848],
              [16.802547970233555, -1.7597344199470528],
              [16.804761135192823, -1.7608572546946937],
              [16.81128507836443, -1.7564347012539772],
              [16.820215436593987, -1.747682937649924],
              [16.823934775402783, -1.746674124120596],
              [16.828661140476385, -1.7412391324380243],
              [16.832446825223823, -1.734204588517194],
              [16.83669030773772, -1.72927520917969],
              [16.83788402229981, -1.7248092207917678],
              [16.852447654886088, -1.71122148510885],
              [16.853263413367618, -1.7068372429179246],
              [16.851511687415982, -1.698807060884212],
              [16.86525181539418, -1.702220161043896],
              [16.87193516250278, -1.7003616127647985],
              [16.87477515244627, -1.697137868551685],
              [16.88246025829011, -1.6944589168427766],
              [16.893359511934126, -1.6884726541433308],
              [16.89619842047145, -1.6852490636368962],
              [16.901773613264677, -1.6846309204062129],
              [16.907996378974577, -1.6860734287317005],
              [16.909227288635623, -1.6836014427048787],
              [16.907241868046942, -1.67902852302757],
              [16.908610752145123, -1.6619057602666865],
              [16.90821009799194, -1.6537839153113068],
              [16.90480288176256, -1.644518607868834],
              [16.90458832344862, -1.6327531684688628],
              [16.901560092826827, -1.628811851676624],
              [16.899009587147688, -1.6189613152500684],
              [16.899545989849717, -1.6088366817820394],
              [16.897245436291644, -1.5983334786988614],
              [16.89897305683277, -1.5927523152690928],
              [16.904117125961065, -1.5812217741393857],
              [16.904937663113504, -1.5634364326602457],
              [16.901386886721852, -1.5544124073752608],
              [16.901748653978963, -1.5381320103749554],
              [16.899595166723138, -1.5292042698607409],
              [16.898127543406776, -1.5189284688778215],
              [16.898575369992567, -1.506633424987309],
              [16.897084936971524, -1.4935662220475883],
              [16.8946977774899, -1.479099026104768],
              [16.893318558025516, -1.474604094122329],
              [16.893603343046752, -1.466948209340194],
              [16.89126321028539, -1.4580688942261595],
              [16.88587947219706, -1.4442641082396344],
              [16.884170345182874, -1.4418414130610173],
              [16.883202075108947, -1.4302675615339262],
              [16.88413176551498, -1.422872645106342],
              [16.888558907209944, -1.4171084806740897],
              [16.88742996510866, -1.411963565506098],
              [16.88729110486999, -1.3988141516197203],
              [16.885873113261418, -1.3959300627707556],
              [16.8858311184779, -1.3767022926807135],
              [16.884669057073367, -1.3747017849324656],
              [16.882760046478904, -1.3632340105065357],
              [16.87911242889222, -1.3572388461943836],
              [16.87633202884551, -1.3417287965719746],
              [16.873768914164952, -1.3363041958568238],
              [16.873408683441525, -1.3301980681803298],
              [16.867850212728268, -1.3218404736681568],
              [16.86246163929329, -1.3160386034447973],
              [16.85817162647711, -1.3092913275571365],
              [16.855100555898293, -1.2993034157633296],
              [16.849320339279746, -1.2945369278068255],
              [16.847372678622378, -1.2892288562583942],
              [16.84304708298836, -1.2837952577920764],
              [16.84223326582229, -1.279187774207708],
              [16.837114651893685, -1.2683466814803876],
              [16.835052153329038, -1.259826847709356],
              [16.826595484179116, -1.2525100514017582],
              [16.822802411342277, -1.2462950529006442],
              [16.824396283825, -1.2425162672376964],
              [16.820227754596274, -1.2410194778151322],
              [16.818656873245374, -1.2372953078399875],
              [16.819968510171947, -1.2329132404202445],
              [16.816902395090878, -1.2308672428299106],
              [16.818624507074027, -1.2276532167925809],
              [16.81246045104968, -1.225511720981644],
              [16.809040830945616, -1.2176251209762],
              [16.810223551819245, -1.2124265209617793],
              [16.809380405350996, -1.2092338576837018],
              [16.805493234963485, -1.2084000585920742],
              [16.795841626500426, -1.1924937937410327],
              [16.799677231781242, -1.1894641754742372],
              [16.804128177902435, -1.1931181747704396],
              [16.813776725853273, -1.2051896525677985],
              [16.820754770198757, -1.2151289174835387],
              [16.83584403093299, -1.23932291643022],
              [16.845390469276428, -1.2569634483951455],
              [16.8541928088031, -1.274771527142367],
              [16.86177100358186, -1.291456243234881],
              [16.871787367979305, -1.316588680336385],
              [16.88716059414245, -1.3571161319068774],
              [16.891553750243467, -1.372364965326106],
              [16.89473691261041, -1.3917961440570845],
              [16.895608551705802, -1.4173022232491321],
              [16.896144408286226, -1.4414125479004252],
              [16.89712355306494, -1.4677748846007905],
              [16.89985701117842, -1.4879559184005091],
              [16.904908778937138, -1.520643046590195],
              [16.90981243887625, -1.550343405192171],
              [16.909957015148755, -1.5736396905741987],
              [16.909784100503188, -1.5991064628897902],
              [16.910160745002862, -1.6282465090874305],
              [16.913322314418686, -1.683354746785794],
              [16.914653693090763, -1.6971220955432293],
              [16.912623355689185, -1.7117050395685625],
              [16.913967788173387, -1.7281039294609366],
              [16.911447148218734, -1.7297636324411598],
              [16.902317694026628, -1.7279766004759316],
              [16.88855618358808, -1.7268503101591246],
              [16.872896597033154, -1.7291854148256285],
              [16.85402130841855, -1.7360506199868961],
              [16.83747701074061, -1.7443060867832254],
              [16.81906051640388, -1.7541446019880804],
              [16.804426193956484, -1.7645938057498263],
              [16.789493873494347, -1.7742764896125687],
              [16.767772791285314, -1.789922875383658],
              [16.759343289818393, -1.7939214699105028],
              [16.757859262953282, -1.7902431837601187]
            ]
          ],
          [
            [
              [16.489410024112374, -0.7885272788429736],
              [16.505737373489033, -0.7804404249568617],
              [16.522154756152357, -0.8045896987221695],
              [16.54949173006542, -0.8507432013279761],
              [16.573903002953024, -0.8873895758227356],
              [16.59851464904283, -0.9194120616153306],
              [16.64064445032076, -0.9691968586111094],
              [16.704238403926816, -1.0552936220307085],
              [16.743956755449638, -1.1089671069439695],
              [16.76654306935043, -1.1465102717540308],
              [16.77560521358012, -1.1622131039383785],
              [16.785452878671833, -1.172911168021783],
              [16.785841941757486, -1.1766721532944269],
              [16.781901335321077, -1.1782142318393218],
              [16.7777742583633, -1.1734619347743838],
              [16.768129852034942, -1.1731669220541028],
              [16.763028006488426, -1.170936114304303],
              [16.76149765071587, -1.164024699184045],
              [16.755147621400805, -1.1627827540743885],
              [16.75474807612034, -1.1566592208523987],
              [16.75116137726839, -1.1543769854299646],
              [16.747748323246427, -1.1496680729700564],
              [16.750949361874174, -1.1435569649419406],
              [16.745944344179126, -1.1390767248181617],
              [16.732935731222756, -1.1303481827276454],
              [16.72672892869932, -1.1230134556325484],
              [16.716156668876895, -1.1035559052422408],
              [16.710046868439626, -1.1009918866097135],
              [16.700922015678312, -1.09172109836707],
              [16.69605135827882, -1.0894409187429845],
              [16.6955077837691, -1.0808269984640306],
              [16.70166124242333, -1.0748584237426364],
              [16.698250471094898, -1.068881524076839],
              [16.694615428750847, -1.0545264659473619],
              [16.67911827043818, -1.0376686085045121],
              [16.663621787350493, -1.0220456426736748],
              [16.644472105480173, -1.0190163536572765],
              [16.642826774502673, -1.017547019426658],
              [16.641918226740504, -1.010672891777368],
              [16.63584287731253, -1.0035319841462305],
              [16.627304933601973, -0.9974819090121742],
              [16.623189567234977, -0.997463267370691],
              [16.616203826268478, -1.001578881987972],
              [16.6083478051678, -0.9986162456543642],
              [16.602912277610653, -0.9951283601715453],
              [16.590210350603737, -0.9976819484385101],
              [16.587620082625055, -0.9942728445335481],
              [16.589081353552398, -0.990626539769934],
              [16.586432980721703, -0.9793435717341561],
              [16.589322130713278, -0.9760383855047513],
              [16.598775053633315, -0.9728987238693092],
              [16.597108393391352, -0.9670077070767452],
              [16.599134724122525, -0.9588281822230239],
              [16.5902969948087, -0.951318231664631],
              [16.58758590435403, -0.954088526605633],
              [16.58184713413544, -0.9559263642323402],
              [16.57862469883727, -0.9617610606761492],
              [16.574780029656953, -0.962464297121402],
              [16.571815848694275, -0.9532369938154037],
              [16.56807080732687, -0.9478213673893588],
              [16.56736010879551, -0.9371604075287046],
              [16.565355497169683, -0.9288961069177721],
              [16.55939091237637, -0.9124838170897043],
              [16.54574519580176, -0.88450474764409],
              [16.545226630289015, -0.8798599051852882],
              [16.54900420593794, -0.8743847405001921],
              [16.545855680692515, -0.8620832733700002],
              [16.54034885782393, -0.8532667686975349],
              [16.53201434227882, -0.8415197662150622],
              [16.52931631432473, -0.8305888215060754],
              [16.516137867854425, -0.8056084962156003],
              [16.50946623313783, -0.7940799477891743],
              [16.50115898125905, -0.7925083112271812],
              [16.499283189338463, -0.796873251951535],
              [16.489410024112374, -0.7885272788429736]
            ]
          ],
          [
            [
              [16.540730476955087, -1.3829931629051286],
              [16.537447272752583, -1.3803035872669218],
              [16.538347768000726, -1.3772563762710743],
              [16.536980303147356, -1.3716318004061168],
              [16.53224693987286, -1.367840060419623],
              [16.526770033881622, -1.3616881339214146],
              [16.524905380148645, -1.357000714344528],
              [16.437019298656857, -1.3758972475358162],
              [16.438466356679267, -1.3683431507645807],
              [16.440679766953433, -1.3658798762658357],
              [16.439198642485277, -1.3534504642281335],
              [16.442126041647736, -1.3488426358814465],
              [16.4378796541315, -1.3372055853283273],
              [16.439416335700695, -1.332497416497243],
              [16.43787912677273, -1.3280484461890603],
              [16.434960595579827, -1.3252859886138992],
              [16.434414260200892, -1.3182383158757949],
              [16.43720268438075, -1.3120691456812696],
              [16.436965297980915, -1.3045571240227902],
              [16.43928951046307, -1.299880497238687],
              [16.437274488502688, -1.2847982600023167],
              [16.43744695591709, -1.2737391801152296],
              [16.438843211815076, -1.2685372445394543],
              [16.43447682440088, -1.2590318488057302],
              [16.434963224444868, -1.2540480199019646],
              [16.43157603863066, -1.2482051543399402],
              [16.428234980754382, -1.246336721207302],
              [16.42159437207364, -1.2309852273625],
              [16.42285427704855, -1.2248157875578376],
              [16.42506937755229, -1.2205643682495741],
              [16.42448395759117, -1.2169112993633482],
              [16.430349269019516, -1.2023377935931556],
              [16.4267672595514, -1.1965436556739393],
              [16.415910822042395, -1.1813725480016666],
              [16.415307039365874, -1.1779296127052543],
              [16.418936225624165, -1.1763533836430826],
              [16.420094893908427, -1.1717340760309587],
              [16.417520259097124, -1.1633419235608897],
              [16.411803273816084, -1.154189152483225],
              [16.416529828305446, -1.1447304623713874],
              [16.425176920478787, -1.1407081851394707],
              [16.42762446612282, -1.1380114750053492],
              [16.435188872205284, -1.116834040701158],
              [16.442174375634284, -1.1090616881908366],
              [16.446752631385984, -1.1076194031568518],
              [16.452483811499576, -1.0970566741005836],
              [16.440271757903098, -1.0855743909195725],
              [16.436581168318696, -1.0850235844125573],
              [16.427256350699288, -1.077783789615595],
              [16.434593494215076, -1.0709079285012448],
              [16.45328821099942, -1.0580110990293135],
              [16.46279472974337, -1.0533453101090238],
              [16.475255970144854, -1.0514637391038433],
              [16.4831533413906, -1.0464708662197644],
              [16.4912845518021, -1.0462314206753458],
              [16.512036209508032, -1.0485694572243291],
              [16.535530733641103, -1.0550602416570116],
              [16.539953459445332, -1.0595413210636897],
              [16.541286097197794, -1.0674326225717812],
              [16.55034523095963, -1.070307138147573],
              [16.553607766814235, -1.073911812852379],
              [16.562097719409913, -1.0760512063588836],
              [16.56513947028393, -1.0847243954462884],
              [16.565208031360655, -1.0896853216524562],
              [16.56979905242904, -1.0946522712676447],
              [16.578035292640802, -1.094863142011195],
              [16.577793914614663, -1.1018711221758444],
              [16.579660983066294, -1.1053192595335513],
              [16.58399291319424, -1.10887881397787],
              [16.585165069259524, -1.1133958337782714],
              [16.588287544343128, -1.1163350422282685],
              [16.59323741207827, -1.1164210338402774],
              [16.598493792183884, -1.1190615546698273],
              [16.597821426774512, -1.1253081430369385],
              [16.59845558503288, -1.1322373218174755],
              [16.603843277498967, -1.1401720030738647],
              [16.603697554827857, -1.152136139253516],
              [16.620052368779064, -1.1627185937172348],
              [16.628081796702812, -1.174210693046564],
              [16.624442782644465, -1.1784785783451577],
              [16.62592718195149, -1.18352945455139],
              [16.62909484649297, -1.186424789510129],
              [16.63030759782753, -1.1929270263400547],
              [16.62689498549511, -1.2006307788218897],
              [16.627879499918283, -1.2069851451200595],
              [16.631561032248037, -1.213154154733913],
              [16.631821772039924, -1.2188702592049503],
              [16.627413258859505, -1.2255967970559374],
              [16.629417129521006, -1.2303389313825777],
              [16.635176004503684, -1.2352634365645474],
              [16.63688945255771, -1.2404667655901314],
              [16.635053607659078, -1.2464393140663292],
              [16.635836078526935, -1.250053146353508],
              [16.640415543280717, -1.254039438080457],
              [16.64773554409845, -1.2580308183063342],
              [16.647014910921936, -1.2673480998217412],
              [16.653385139641777, -1.282301843451358],
              [16.660562206998424, -1.286523728838711],
              [16.664568798694706, -1.3013953391668605],
              [16.659423989188298, -1.3110781601782124],
              [16.654826618837866, -1.3160588531660635],
              [16.64896231132498, -1.3146733559082537],
              [16.64977026726061, -1.3089835879729423],
              [16.647910200345198, -1.3040064123981332],
              [16.643286760106598, -1.299827408574142],
              [16.62996262522525, -1.2961343447753222],
              [16.622567312849615, -1.2981312459179406],
              [16.6201794692325, -1.3059112206851116],
              [16.616637016916517, -1.3119029621176606],
              [16.615607872755028, -1.3173836696937669],
              [16.61684977275394, -1.3215688769219633],
              [16.629341698586494, -1.3261382077566333],
              [16.628510263725172, -1.3320944859678439],
              [16.629169942556867, -1.3381444318613456],
              [16.634968374052363, -1.346289525623887],
              [16.645090118062154, -1.3523622447221122],
              [16.65002969964658, -1.3524953286935946],
              [16.65335372845399, -1.3496562797455152],
              [16.65714491453502, -1.353614696005407],
              [16.65910619576138, -1.3587338130441446],
              [16.664169367082778, -1.3670024502563627],
              [16.664254846143688, -1.371808067554717],
              [16.658517009084854, -1.376089221766589],
              [16.65578128726382, -1.3808723031537842],
              [16.654444861160197, -1.3870420650517943],
              [16.655317027290383, -1.3918155876329383],
              [16.648235295722582, -1.3955872438859713],
              [16.645047795856854, -1.4009191896131536],
              [16.64218052079718, -1.402910256646267],
              [16.637506870770828, -1.403310962347871],
              [16.633929671185662, -1.4059854192513452],
              [16.63202980667155, -1.4096855297043371],
              [16.634023284984828, -1.4162074492912],
              [16.64130761547087, -1.4221873940982783],
              [16.64100811669056, -1.4240373729354652],
              [16.626550393103344, -1.43187210329318],
              [16.60429483953327, -1.440971023839081],
              [16.605785827482833, -1.4323156048219687],
              [16.613445290547908, -1.4263329530757796],
              [16.613705579932663, -1.4236754531735634],
              [16.610453470166355, -1.4182925712106393],
              [16.606283328202846, -1.4200582155378587],
              [16.600814219208335, -1.4187550720720958],
              [16.59683054944517, -1.4199630317017407],
              [16.592411137637598, -1.4265413671463623],
              [16.580997917201717, -1.4318992547665164],
              [16.577149776449705, -1.4295873627708184],
              [16.577202226881017, -1.423488553341455],
              [16.5741732105509, -1.4200243014823166],
              [16.560494428614497, -1.409534758713168],
              [16.560616958341452, -1.403529289691548],
              [16.558724845905434, -1.3940886565183004],
              [16.55880038015353, -1.389988577114312],
              [16.555880636322822, -1.387104993305307],
              [16.55134799464052, -1.3860681593200672],
              [16.54762774450268, -1.3878208442070552],
              [16.540730476955087, -1.3829931629051286]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.79876851456105, "lat": 35.78244140169224 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37055"],
        "coty_name": ["Dare"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dare County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01026133"
      },
      "bbox": [
        16.411803273816084, -1.7939214699105028, 16.914653693090763,
        -0.7804404249568617
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.56118852566391, -1.9662375757084352],
              [16.563666417349523, -1.9602955819449208],
              [16.571252084504554, -1.9542651032270268],
              [16.574425395128237, -1.9469720310466714],
              [16.5789832006446, -1.9341710058562775],
              [16.574277938660956, -1.928761201361661],
              [16.57513074503524, -1.9253721138258588],
              [16.57286795901137, -1.916636580522755],
              [16.576908041656026, -1.911564465614704],
              [16.5806360496312, -1.9105667895339677],
              [16.588201119493586, -1.912757743948133],
              [16.591871798029963, -1.9105697324855917],
              [16.597011648769698, -1.9124775080187593],
              [16.604860091505472, -1.9067886701296197],
              [16.61665249540767, -1.8928399734548669],
              [16.622206014081222, -1.8902466752395222],
              [16.655857473095963, -1.8615822003639222],
              [16.661366637065942, -1.8587947524900794],
              [16.670860149398703, -1.8525450689042482],
              [16.67516617911998, -1.8460076802963716],
              [16.696699877278714, -1.8325542083031368],
              [16.70466768916785, -1.8238244171793705],
              [16.709351025345455, -1.8236158210251492],
              [16.71950685329282, -1.8168161721592078],
              [16.722407010272892, -1.810178822787022],
              [16.7280753193865, -1.8101647295730512],
              [16.727068072226473, -1.8136613028477473],
              [16.723353900580687, -1.8176288128252502],
              [16.69633169526747, -1.837242614580449],
              [16.660884002080905, -1.8657115875012833],
              [16.6251932885241, -1.8968215462235591],
              [16.60775688567836, -1.9147873463066616],
              [16.59486914160932, -1.9291715032360244],
              [16.582722453356865, -1.9451998781929953],
              [16.571259049950413, -1.9616820346702237],
              [16.571570656026378, -1.9668290742076566],
              [16.567075835764307, -1.969793055411166],
              [16.56118852566391, -1.9662375757084352]
            ]
          ],
          [
            [
              [16.29859421932194, -1.7676450901762495],
              [16.299512509951203, -1.7576266344975244],
              [16.302726236503617, -1.7557848225614139],
              [16.307439321059157, -1.7579561795443999],
              [16.31444445323017, -1.767889399944653],
              [16.3096859488498, -1.7728885320531094],
              [16.299959828650795, -1.7710209310317921],
              [16.29859421932194, -1.7676450901762495]
            ]
          ],
          [
            [
              [15.93753535310836, -1.4432977122172925],
              [16.009972958408532, -1.428436108203487],
              [16.021232914490987, -1.4267547331956016],
              [16.121539496399205, -1.4129303690140702],
              [16.192518562224553, -1.4027264799685426],
              [16.230648076997703, -1.3970723968057113],
              [16.22509036880917, -1.4824885837592483],
              [16.235511329013693, -1.485000296423431],
              [16.238616648052346, -1.4824276139590606],
              [16.242463827744814, -1.4828033762039328],
              [16.247497504808603, -1.4788553813547516],
              [16.251911624857083, -1.482792353769923],
              [16.259076897763453, -1.4807572325972975],
              [16.261248298006972, -1.4788389574488974],
              [16.266798704284934, -1.4804121894390887],
              [16.27028198368337, -1.479243798804533],
              [16.28096574551457, -1.4802489265367458],
              [16.28360513892704, -1.477572413744048],
              [16.288220194122747, -1.4795982892849315],
              [16.293649328002097, -1.47898912710459],
              [16.2958247612308, -1.4752255174808613],
              [16.30039203398561, -1.4630777379911277],
              [16.299753219898196, -1.460383701415216],
              [16.30319590137274, -1.4545887846367949],
              [16.300246040505783, -1.4439856084185652],
              [16.29800233311549, -1.4413451199722653],
              [16.301124951418906, -1.4389509351774832],
              [16.299663723889733, -1.433478835457035],
              [16.300273149343823, -1.4281525441137695],
              [16.30592008378964, -1.424784004282603],
              [16.31013774649011, -1.4169753724958383],
              [16.304803661003422, -1.4074454326992871],
              [16.308576841564836, -1.4042921556920585],
              [16.30805993831565, -1.3999966323991007],
              [16.31243748894466, -1.397341035811923],
              [16.308319611218273, -1.3950047012986235],
              [16.306968456463544, -1.3922374658001901],
              [16.308615278624142, -1.388741969080813],
              [16.30458388089738, -1.386116030117691],
              [16.30420208907574, -1.3816041661189813],
              [16.30952056751848, -1.3806817341648279],
              [16.306019950888132, -1.3740695399764182],
              [16.308506463586834, -1.3722347049933492],
              [16.312231607925792, -1.3745230703550786],
              [16.32267873756223, -1.3684836135710554],
              [16.32868779896973, -1.3639700465241005],
              [16.332848930586763, -1.3660959876762024],
              [16.34023881653686, -1.3738863213708281],
              [16.344753522967814, -1.3705144369833164],
              [16.349998531967696, -1.3726055699082749],
              [16.349205038760743, -1.379680325528535],
              [16.350136999916874, -1.382290662931116],
              [16.355090893326235, -1.3839329021508664],
              [16.35991129183379, -1.3817225151007977],
              [16.365379141013257, -1.383306567487616],
              [16.368273877357556, -1.3882327954078435],
              [16.37412899470075, -1.3883634702828638],
              [16.377337506396728, -1.3832015009662304],
              [16.37990569213289, -1.381686086726503],
              [16.386327119988607, -1.3833836657909269],
              [16.391655585569822, -1.3816540374645208],
              [16.397812594066725, -1.37769724507565],
              [16.40131161673881, -1.3782075742333848],
              [16.41241094558143, -1.3845344096218994],
              [16.413170690320054, -1.3974383943870998],
              [16.41707524039714, -1.4019853616710007],
              [16.42216161404525, -1.4028932143415402],
              [16.426158382772787, -1.4014441598048701],
              [16.42887751124202, -1.3976773482074978],
              [16.43245899236518, -1.3961163253830466],
              [16.4356578233574, -1.3918486880696297],
              [16.438832108122867, -1.3838005112645506],
              [16.437019298656857, -1.3758972475358162],
              [16.524905380148645, -1.357000714344528],
              [16.526770033881622, -1.3616881339214146],
              [16.53224693987286, -1.367840060419623],
              [16.536980303147356, -1.3716318004061168],
              [16.538347768000726, -1.3772563762710743],
              [16.537447272752583, -1.3803035872669218],
              [16.540730476955087, -1.3829931629051286],
              [16.544693523356607, -1.3923996843913085],
              [16.54725620847973, -1.3934938622688164],
              [16.54828224987216, -1.3987582859927816],
              [16.546057785689786, -1.422745024043342],
              [16.54303267356068, -1.426258454072958],
              [16.544140765511415, -1.4289000464354513],
              [16.550160729783094, -1.4312339882334175],
              [16.55365256033693, -1.4370416245155158],
              [16.55759430161598, -1.43909511414976],
              [16.559519113334154, -1.4453495586356317],
              [16.556906579470976, -1.4475067615493005],
              [16.550452631734046, -1.4480177678109325],
              [16.54867284159271, -1.4513813646272504],
              [16.544467769841805, -1.4540645097540759],
              [16.544533045952267, -1.4603589995476924],
              [16.53762900723153, -1.4629253494109784],
              [16.533207436221627, -1.4660677350570313],
              [16.53296004619636, -1.4713065889611179],
              [16.534633161048628, -1.4745388382789406],
              [16.543832811550462, -1.4727649487630345],
              [16.541137819810313, -1.4765348267322085],
              [16.54220205240581, -1.4814934401683078],
              [16.538733992534322, -1.4854299272236466],
              [16.530221919269216, -1.4914437131268363],
              [16.51963727533779, -1.4951077856779316],
              [16.51412247636973, -1.5004784136067126],
              [16.51088935784687, -1.507355082054285],
              [16.51335271237784, -1.5106185649641506],
              [16.509864982176914, -1.5186912627713431],
              [16.504567677463868, -1.5162896581131384],
              [16.501192980912585, -1.5170113419287448],
              [16.497167628081147, -1.523858230916789],
              [16.49964701924407, -1.5281170077729358],
              [16.504661760947634, -1.528641433385665],
              [16.511485999699357, -1.5331774912565288],
              [16.513284833112962, -1.54006932927509],
              [16.506053104244426, -1.5443099690413458],
              [16.494833180648197, -1.553294219737401],
              [16.491469926367987, -1.5638617658814775],
              [16.49127781131263, -1.5706217468780446],
              [16.493318177822456, -1.5755766302097138],
              [16.49255932235844, -1.5821275055605954],
              [16.48927163274318, -1.5906164987442768],
              [16.484978637079482, -1.595326653794598],
              [16.48272602810547, -1.600399333532864],
              [16.487434090779843, -1.61381334654048],
              [16.48694862738386, -1.6197360039117263],
              [16.48347480254724, -1.6252534489271597],
              [16.483447917939532, -1.6307079043756194],
              [16.47609453212421, -1.6313022792665262],
              [16.473471692373142, -1.626936559712941],
              [16.473636746147736, -1.6231067371286023],
              [16.47048657085397, -1.6193843862879667],
              [16.467686001380304, -1.6189149737843271],
              [16.46606448799181, -1.6152183714105561],
              [16.454953307494865, -1.6129676112670543],
              [16.450245267178843, -1.6146267528386018],
              [16.44960302418723, -1.6186239153762974],
              [16.45682987603514, -1.6270675956811942],
              [16.45049160680273, -1.629634523496175],
              [16.448913836579838, -1.6323665099571147],
              [16.452589971285157, -1.636097208273979],
              [16.45071823301195, -1.639291803893117],
              [16.445571718832547, -1.641196147105561],
              [16.445475287761102, -1.6444871376711174],
              [16.4493225750516, -1.6492734621188703],
              [16.449589521680707, -1.6529170778602142],
              [16.441662912527363, -1.6554803402321159],
              [16.43987730347671, -1.6618531991874121],
              [16.447083854920724, -1.667113139951843],
              [16.4564210431182, -1.6639277459107114],
              [16.45860016151986, -1.665861167908014],
              [16.455412324665325, -1.6693367115203925],
              [16.45410632208232, -1.6798050765206112],
              [16.447539767954996, -1.6794035885520926],
              [16.43819075053412, -1.6843878867477702],
              [16.436220736836955, -1.6935982978820365],
              [16.43087737290297, -1.6943342948998434],
              [16.426183720274977, -1.6981277482529507],
              [16.424442792019512, -1.7022177783115862],
              [16.417156371578454, -1.7046402583726112],
              [16.40943065525791, -1.702482333892456],
              [16.404502840584314, -1.7033271785861952],
              [16.4006408812578, -1.7073423255804003],
              [16.40261001418291, -1.712920163720721],
              [16.40693315348603, -1.7165146235586122],
              [16.40556918035773, -1.7194745585304663],
              [16.401463649884313, -1.7210641339641526],
              [16.39790202239009, -1.7265252468216221],
              [16.398213821929303, -1.7321479625862337],
              [16.39520617968752, -1.7325870877904919],
              [16.3935340780134, -1.7266330175581261],
              [16.38811518224839, -1.7223855136132191],
              [16.37729992453492, -1.7204774053653307],
              [16.370049142681072, -1.7224110740530953],
              [16.367864583191952, -1.7278687742684167],
              [16.360156290674833, -1.7294981504226228],
              [16.356116582421937, -1.734547485484863],
              [16.353831789960616, -1.733032757505557],
              [16.353290012299926, -1.726753095293227],
              [16.347648914421043, -1.727944515087797],
              [16.341636017190947, -1.7348081092975205],
              [16.33869043324846, -1.7292358565629136],
              [16.33224081273756, -1.7238040738225553],
              [16.329525455724653, -1.7183829414918905],
              [16.318698681299225, -1.7126759909845948],
              [16.313193059628247, -1.7126379462181374],
              [16.305593721269062, -1.7166361574193667],
              [16.30696462410285, -1.7231386370488546],
              [16.31221696328742, -1.7266273057039523],
              [16.314301743294422, -1.7306595430775027],
              [16.311913387836494, -1.7369543165443206],
              [16.30448265983739, -1.7430400884639263],
              [16.29541517338907, -1.7419520510913256],
              [16.284501136003833, -1.7375757448088074],
              [16.271669958698276, -1.734559305594544],
              [16.270959600436655, -1.7293163695116898],
              [16.266168317341315, -1.7205360976182862],
              [16.260728704129473, -1.7226772406803281],
              [16.254136893312637, -1.7202674533318576],
              [16.25305302385437, -1.7123073939674542],
              [16.24898790432462, -1.7069711062751844],
              [16.232853427958343, -1.7039678465498511],
              [16.22927984801929, -1.707511508934588],
              [16.228579051191055, -1.7116520812584148],
              [16.22473648491595, -1.7148530239300346],
              [16.227027883384114, -1.7201632730128884],
              [16.231402621626515, -1.7232398667789248],
              [16.240992550790533, -1.739002380392601],
              [16.24255864136193, -1.746463222339425],
              [16.24588537872551, -1.7529561243971314],
              [16.239260015239143, -1.7569427925184655],
              [16.23062251293548, -1.7569552126403092],
              [16.220015198977244, -1.7653686283505958],
              [16.215950846676606, -1.7600277892377336],
              [16.214343990279165, -1.7429881053006486],
              [16.204352000023526, -1.7430826391631793],
              [16.20276061570307, -1.7468698961190468],
              [16.202689429618164, -1.7520173089911457],
              [16.198908389801016, -1.756039799069293],
              [16.18936772170348, -1.7605941220692563],
              [16.1866621168087, -1.7457832197337704],
              [16.17791947317853, -1.7462117423136372],
              [16.175718875525163, -1.7442411889150957],
              [16.177327810500202, -1.7377489168709859],
              [16.177092037503918, -1.7338052147517025],
              [16.182572791988463, -1.7318617867042074],
              [16.208391231931575, -1.7342499365318458],
              [16.214725651005693, -1.7373169733300646],
              [16.220928784526578, -1.7388131132410105],
              [16.223860013471608, -1.735004177356008],
              [16.221420506776912, -1.7299238081921327],
              [16.22358663634042, -1.7252766579707404],
              [16.217011259581444, -1.7210636511589543],
              [16.216745357747556, -1.7179243661295698],
              [16.20598012966008, -1.716186035776294],
              [16.202809623262805, -1.718846268092223],
              [16.19899400571502, -1.7090637808838496],
              [16.19067797690728, -1.7040170445660867],
              [16.189289680294483, -1.6983194722900459],
              [16.19529127401075, -1.6960656672289833],
              [16.196252981421726, -1.6884802622365978],
              [16.191232317255878, -1.6785549053646907],
              [16.18473053705788, -1.6737290372291531],
              [16.174392292439023, -1.6786836621030585],
              [16.168615204338348, -1.6838820485086152],
              [16.168591172081896, -1.6912697643833317],
              [16.16111941566292, -1.7062010908507625],
              [16.157491888161886, -1.7085550049326528],
              [16.157926548610302, -1.713453400630782],
              [16.16156921622108, -1.7186815173699737],
              [16.159855578777844, -1.7236295314874992],
              [16.15432153015162, -1.7177987832687158],
              [16.149257280231787, -1.7198533230231243],
              [16.15055200212668, -1.7241735540094023],
              [16.146096353096706, -1.7235059876688525],
              [16.143206948882998, -1.7181203228673585],
              [16.142944086326352, -1.7149817517361687],
              [16.1387626031957, -1.7118627260137333],
              [16.13621015387488, -1.7127933495245464],
              [16.135880163592272, -1.716853772860329],
              [16.130411370179903, -1.7132032434151538],
              [16.12285212102526, -1.7145777459673859],
              [16.12182606415238, -1.7171862821369936],
              [16.127118214266307, -1.7218722857347657],
              [16.130365168318768, -1.7289792538578448],
              [16.13574377865241, -1.7378391924814045],
              [16.138062418678143, -1.7431584850095259],
              [16.136453493735843, -1.7459153103667169],
              [16.126962145615078, -1.7446585349842738],
              [16.12087034371564, -1.7427324176514158],
              [16.115332343035305, -1.7396936237877891],
              [16.10101296896745, -1.7265057246944644],
              [16.096297221750707, -1.7307818483391122],
              [16.08292010803086, -1.7262737387694098],
              [16.074571076413108, -1.7183224869293225],
              [16.077409588762343, -1.7060514689256558],
              [16.075837071949234, -1.6957578897969265],
              [16.07118636376623, -1.6933986718047216],
              [16.06867404475894, -1.6945185674016032],
              [16.05957771880256, -1.6944366967975917],
              [16.046717006129015, -1.6841149473578725],
              [16.05135186871228, -1.677172092433571],
              [16.057541687490307, -1.6748912232238453],
              [16.059970514831733, -1.669600949671053],
              [16.054757764851416, -1.6680910190185023],
              [16.050337543667244, -1.6651547024726463],
              [16.043547730733604, -1.6584526156993038],
              [16.042453896886016, -1.6475165049009048],
              [16.040780069000693, -1.642282039519425],
              [16.03619181685847, -1.6390473333133242],
              [16.02430742743061, -1.6361045265405618],
              [16.017456533305648, -1.628978777705279],
              [16.02636090722256, -1.6275320790384122],
              [16.030510527951574, -1.624879019873231],
              [16.03557677383585, -1.623813445776928],
              [16.04180794708324, -1.6255259536297841],
              [16.05751846312302, -1.6200740117385506],
              [16.066662944680786, -1.619825102632361],
              [16.074857520888596, -1.6224518882873442],
              [16.08150789116394, -1.6214680250239977],
              [16.090180124863462, -1.6177141725740931],
              [16.094412118323852, -1.617587634277348],
              [16.098292585872912, -1.6145866777880398],
              [16.104067071648423, -1.6081003891383159],
              [16.10824159864685, -1.5993598408212184],
              [16.106526166487306, -1.592926902740507],
              [16.108178703097476, -1.5867183482601808],
              [16.106081417964198, -1.5839780407957234],
              [16.106151904381633, -1.579618715298142],
              [16.10957406457489, -1.5715976891967813],
              [16.113290172069885, -1.5675517441934512],
              [16.110332898902925, -1.563958474663697],
              [16.10338814261303, -1.5601216138338603],
              [16.100718590594443, -1.5613008924352656],
              [16.089779008520914, -1.5574249840448247],
              [16.08794588500859, -1.5541605551097188],
              [16.084261455264954, -1.55371292498932],
              [16.079286617742365, -1.5502080234887026],
              [16.074207780227567, -1.553933097447511],
              [16.070192953462154, -1.549313136131047],
              [16.071495475965673, -1.54561873366386],
              [16.06667282365716, -1.5444809483136983],
              [16.062393498076624, -1.5502632142826729],
              [16.056821545331648, -1.5488077015148658],
              [16.055416807547065, -1.5428803000747437],
              [16.050905662196325, -1.5433004641316794],
              [16.049413143994236, -1.5474901895597146],
              [16.040241984187617, -1.5479915382912472],
              [16.039226222310834, -1.5453210521490133],
              [16.042492821292218, -1.540734405307785],
              [16.04325431120983, -1.5368727866382093],
              [16.04135216793124, -1.534722197116366],
              [16.034314887874345, -1.5324673139575555],
              [16.02792426573292, -1.5364399043257988],
              [16.022603868075013, -1.5332303262007845],
              [16.016612597999217, -1.5339720306860296],
              [16.004015523511654, -1.5263454923402793],
              [16.00264768245288, -1.5236292131415825],
              [15.993709179002435, -1.5187858848106432],
              [15.98828766233752, -1.5126503260144146],
              [15.980915122817567, -1.5059829203181763],
              [15.974132343484902, -1.4957618336077871],
              [15.975292191353688, -1.4779856014343347],
              [15.972726409447695, -1.4722410859174344],
              [15.955073941581725, -1.457226436067007],
              [15.951280420802423, -1.4558535321905994],
              [15.949649472426975, -1.4526604961397962],
              [15.93753535310836, -1.4432977122172925]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.2517461054767, "lat": 35.53064198467845 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37095"],
        "coty_name": ["Hyde"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hyde County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01008564"
      },
      "bbox": [
        15.93753535310836, -1.969793055411166, 16.7280753193865,
        -1.357000714344528
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.391513654986758, -2.8416100730721308],
            [10.392681250975059, -2.8376889128663363],
            [10.396686590778815, -2.831622707361013],
            [10.39780241640243, -2.8260062000335933],
            [10.402786702109848, -2.814933913931935],
            [10.402799983663373, -2.8118016400154744],
            [10.405454067257272, -2.8083753601949453],
            [10.410795392126786, -2.8042381928956472],
            [10.483934907830776, -2.7858471719663784],
            [10.549125116229055, -2.769292067009547],
            [10.551387419791705, -2.768461489854963],
            [10.554426511927332, -2.762242768049343],
            [10.565001363796162, -2.765421715372513],
            [10.57067611731701, -2.76837020271774],
            [10.576684305293039, -2.7659784470995334],
            [10.578135648743928, -2.7629888172337314],
            [10.582367270196862, -2.7613381773766257],
            [10.58391910039321, -2.7495373722062393],
            [10.586752187635497, -2.746653823177007],
            [10.592547146747798, -2.7453418759532386],
            [10.594376814797167, -2.7403111176652852],
            [10.597939538615313, -2.7365951617565654],
            [10.6016140986295, -2.7368144213273204],
            [10.607628134371241, -2.742820733192394],
            [10.611307852334365, -2.7407252126645565],
            [10.616602226957525, -2.742832588913156],
            [10.620822701183343, -2.7337600288474433],
            [10.62395803698097, -2.730592596274777],
            [10.631053016362191, -2.731764779422238],
            [10.63488620373505, -2.729975861647299],
            [10.64073651344369, -2.7304896727520664],
            [10.645477625220765, -2.726322114392104],
            [10.652769454158125, -2.728388131663471],
            [10.657682446967511, -2.7240645854056402],
            [10.66637325220525, -2.7239883057739362],
            [10.671833964984655, -2.7207555508429158],
            [10.676650344021436, -2.7252785926678045],
            [10.677571151150392, -2.7308080686349805],
            [10.68004366393831, -2.7349472991841197],
            [10.686655988071694, -2.7360917487210026],
            [10.68911397474837, -2.7377245151702714],
            [10.688348575810181, -2.742543498415042],
            [10.689396701039351, -2.7484379974532036],
            [10.694379389355822, -2.7511606290904607],
            [10.695459278281177, -2.754615853979694],
            [10.694415192722863, -2.760077055641405],
            [10.700514305961635, -2.766979610850507],
            [10.698752806398657, -2.776428676202009],
            [10.70055148733465, -2.7794762639548507],
            [10.69969862470945, -2.784322007952451],
            [10.704379086558152, -2.7842686307320954],
            [10.704357770727976, -2.7888656091440134],
            [10.706658177228835, -2.791019235647208],
            [10.714801241426963, -2.791450142252153],
            [10.71840573329335, -2.799021825724793],
            [10.718029405754518, -2.8044726395064097],
            [10.720200413645937, -2.805452833111666],
            [10.720930084307792, -2.8101074717769365],
            [10.723746446777541, -2.8126325467549225],
            [10.72938612274277, -2.813776693041654],
            [10.73137915577555, -2.816324767945255],
            [10.735911331297626, -2.816820346509816],
            [10.751849556742302, -2.8110992657439926],
            [10.760501764581075, -2.8101140428377804],
            [10.763046884804888, -2.8021060293551945],
            [10.76970428076913, -2.7999581792073265],
            [10.776425026638101, -2.80050053471032],
            [10.780341297711454, -2.8099616999740844],
            [10.784954387926417, -2.815048151080611],
            [10.784396194337717, -2.8214667569316316],
            [10.786691171911441, -2.8248451462389657],
            [10.787227716842153, -2.829667958122603],
            [10.78505438572612, -2.83232949532035],
            [10.787459571639442, -2.8448713458245094],
            [10.784158641469027, -2.846539332732868],
            [10.783423710730274, -2.8504642100593305],
            [10.784911349223881, -2.858510150935397],
            [10.784207252353623, -2.8620424272716787],
            [10.787447953815942, -2.8695972769456377],
            [10.78714678630278, -2.8739076715980674],
            [10.789714454427967, -2.8801310486639067],
            [10.796638884019172, -2.8795998941710073],
            [10.802928602045952, -2.8873925135999943],
            [10.813717265518825, -2.89506878844976],
            [10.817041120021763, -2.899599053801502],
            [10.820788093303223, -2.9009763447024115],
            [10.822362662077474, -2.9064488534559447],
            [10.825328514864514, -2.909457676260363],
            [10.826227783773628, -2.9157758768811854],
            [10.82971699389395, -2.917874949701185],
            [10.83184187312629, -2.9249885955442205],
            [10.836811696249042, -2.9282387057323755],
            [10.840199894878495, -2.927867571716342],
            [10.846897686868544, -2.9337168796612443],
            [10.853342595948051, -2.932104748435235],
            [10.857883035984374, -2.936842301422352],
            [10.858694501976062, -2.941891209271088],
            [10.861259551003494, -2.945207409536553],
            [10.863448766387009, -2.952235292907016],
            [10.859104274528434, -2.9520754501961095],
            [10.851610050678657, -2.9541728409446018],
            [10.852067924157446, -2.956664233145456],
            [10.845631638615005, -2.962466886755438],
            [10.84186748105662, -2.963848616936154],
            [10.84437470818126, -2.968753739075795],
            [10.843507510053694, -2.9725907268329435],
            [10.84992202677682, -2.97564217758968],
            [10.856885616954349, -2.9748951222388027],
            [10.86299820488129, -2.9769497228971695],
            [10.871322404095853, -2.987478804406954],
            [10.877973498947881, -2.9947612695333596],
            [10.882226977128221, -3.0035486406009637],
            [10.884827087846983, -3.005302007989619],
            [10.885784033807452, -3.0123980059155335],
            [10.891373613909455, -3.0139302794881857],
            [10.895481742773969, -3.013453109850054],
            [10.900495883708173, -3.016349020033341],
            [10.901950926572978, -3.0247827897753323],
            [10.901176457974957, -3.0250479223237448],
            [10.89827863859475, -3.0253949901404456],
            [10.836343577064836, -3.035624472133281],
            [10.730286438342016, -3.0535504244362492],
            [10.601634787862729, -3.073106957869668],
            [10.597835760629957, -3.068343373556745],
            [10.592603229276762, -3.0688095799079504],
            [10.58325515208672, -3.0682463838961542],
            [10.578835959526613, -3.064495052063264],
            [10.575159089210622, -3.065774691827875],
            [10.573460860212162, -3.0710384221299423],
            [10.569006224499809, -3.0716990442311474],
            [10.5688490735441, -3.0671403098270438],
            [10.564024376047298, -3.0620926358622578],
            [10.567697415189357, -3.057328569685746],
            [10.567614300701402, -3.0526492213569547],
            [10.56291797973719, -3.0491804776470413],
            [10.553613850157275, -3.0402059120633265],
            [10.55190181810721, -3.0371571841984344],
            [10.546932516365098, -3.034343213107252],
            [10.539317328376029, -3.0346016115178718],
            [10.535771819030035, -3.0359232352100975],
            [10.531949964137223, -3.029887546788125],
            [10.526576373628076, -3.02428616659097],
            [10.529113827122385, -3.015680379480689],
            [10.523243764205175, -3.008173173449151],
            [10.523494703235675, -3.0045672728270483],
            [10.516983164954366, -3.004852564750514],
            [10.513512862452922, -2.999746091480849],
            [10.507743919332185, -2.995650167647042],
            [10.508514974690181, -2.990657420183646],
            [10.504442643048474, -2.985488331271246],
            [10.497343266213067, -2.9843365988680284],
            [10.493253229542804, -2.979684379409439],
            [10.48863787589051, -2.977874196435671],
            [10.48288642570384, -2.977727187970807],
            [10.478735709774831, -2.97538324093556],
            [10.477396534921697, -2.9724457617335385],
            [10.479859361891867, -2.9672837146799123],
            [10.475663146972373, -2.9617515648550836],
            [10.473823272796771, -2.955013919532576],
            [10.470943989426004, -2.9529695985301934],
            [10.468476346001616, -2.957426059874216],
            [10.464068899129279, -2.957498309887141],
            [10.462683470381368, -2.9616484737133373],
            [10.457083633955122, -2.952810255842685],
            [10.459095774387809, -2.948475659106889],
            [10.456297208164838, -2.9448943975240143],
            [10.44933726260116, -2.9496594862170378],
            [10.444957712754807, -2.949358296963735],
            [10.44225355303638, -2.9450552019825715],
            [10.449039859524026, -2.9436567345816456],
            [10.451167675442962, -2.9386691965385086],
            [10.447611515882622, -2.9365590610097456],
            [10.447513896268628, -2.9314088779143015],
            [10.444079282684767, -2.930343366511299],
            [10.441393365371727, -2.926695098037055],
            [10.437784013439922, -2.9254408172184556],
            [10.438496725372035, -2.9309669278517276],
            [10.433848120100281, -2.9360663207665088],
            [10.426881904736597, -2.929871841484919],
            [10.424147314185674, -2.9311585441906614],
            [10.416895844806014, -2.9311810579239532],
            [10.416277902429682, -2.934245091227341],
            [10.410979575578422, -2.9330173253011704],
            [10.406695456731129, -2.9361078635292177],
            [10.400052773226303, -2.9373783385859196],
            [10.394395949383478, -2.935867904984102],
            [10.392318769025163, -2.9372793281616163],
            [10.385858173234448, -2.946959167947911],
            [10.381791874829664, -2.9444542586338383],
            [10.375038010450435, -2.9377313885311964],
            [10.378969274204108, -2.921493951648394],
            [10.377400101122227, -2.9144381611086194],
            [10.38180127233616, -2.9088409946304803],
            [10.388700683582302, -2.904955037711453],
            [10.391283820156831, -2.90177011910578],
            [10.391396641586121, -2.8954070994999808],
            [10.386915837637932, -2.8917230364819337],
            [10.384453829866196, -2.894976490359224],
            [10.376674971875257, -2.8922602459769653],
            [10.380487560312575, -2.8823635681063813],
            [10.387853926728022, -2.877818242310708],
            [10.389463484012564, -2.871869156265217],
            [10.391374180365787, -2.8713456635890076],
            [10.399230271371772, -2.864053158231408],
            [10.40306991381028, -2.8539750426116273],
            [10.400923251635732, -2.8460347413572267],
            [10.395331242518155, -2.8423564551724545],
            [10.391513654986758, -2.8416100730721308]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.42221980354435,
          "lat": 35.150530739161674
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37113"],
        "coty_name": ["Macon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macon County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01025833"
      },
      "bbox": [
        10.375038010450435, -3.073106957869668, 10.901950926572978,
        -2.7207555508429158
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.63873472371489, -1.5839184244730236],
            [14.649973840814313, -1.5414080626390534],
            [14.674302140334111, -1.4533221938781578],
            [14.699740451768946, -1.3683444107404017],
            [14.71966815252378, -1.304224842103688],
            [14.76051389302852, -1.1724542962490632],
            [14.762586580485657, -1.1654379872853693],
            [14.770480438392196, -1.1694185614908792],
            [14.772275840529502, -1.1740734142338787],
            [14.777743491101013, -1.1793024707363329],
            [14.779917629872873, -1.1755778734753197],
            [14.784084048127294, -1.1777391399709767],
            [14.78369354641668, -1.1821873411434956],
            [14.787572021192943, -1.1846236132435755],
            [14.794873761689772, -1.1845345737248445],
            [14.795629843138986, -1.1784016881387966],
            [14.791886487719538, -1.1737994137171002],
            [14.789961437089843, -1.1694132206709402],
            [14.794331348793936, -1.1677029678425996],
            [14.810334596145536, -1.1789426288033882],
            [14.81535113786122, -1.1762303727074168],
            [14.81554552758496, -1.1719406030447477],
            [14.813575940719938, -1.1686176792642118],
            [14.816150845141497, -1.1658597133392095],
            [14.822798021144274, -1.1705345301510655],
            [14.825087570497162, -1.1740619027168921],
            [14.829467040963653, -1.1725984943447179],
            [14.830227675759913, -1.1666569740095158],
            [14.836166328823717, -1.1729861086226],
            [14.834975483719269, -1.1882596513132255],
            [14.841453240007874, -1.1904789008439058],
            [14.845003262207147, -1.187973101664639],
            [14.853286279323617, -1.189049241992409],
            [14.85392977290003, -1.1951161775314532],
            [14.862073366531805, -1.1991926428558497],
            [14.866350375478712, -1.2043636311498578],
            [14.86919613685271, -1.2018075701185709],
            [14.8737457335118, -1.20503975418893],
            [14.879692531581117, -1.201829310429892],
            [14.883454953804724, -1.197786256521697],
            [14.887524491510478, -1.1966878392688216],
            [14.891945109571584, -1.1988010625295331],
            [14.899000488297197, -1.1983604752413612],
            [14.903278438094286, -1.1969865594094735],
            [14.91009684459866, -1.1969669330554624],
            [14.911560199491198, -1.1954082460815254],
            [14.918646250586788, -1.1948426744547755],
            [14.92530826011838, -1.1988637800777104],
            [14.930205361423232, -1.1993254915558373],
            [14.932298005621341, -1.194896850442471],
            [14.931020961281144, -1.1878677442539842],
            [14.93647789149169, -1.1916979201437643],
            [14.941673292691151, -1.1900091738064482],
            [14.950513957489726, -1.1920279012936161],
            [14.956159327758838, -1.1863897580441525],
            [14.96842845377068, -1.181073202273567],
            [14.97120454806332, -1.1770210294389263],
            [14.970512819171185, -1.171979337825673],
            [14.973543905978106, -1.171680115735365],
            [14.97587526716531, -1.1745875736206306],
            [14.979476256469395, -1.172416287639635],
            [14.983446213397684, -1.1730464566190677],
            [14.988850196578776, -1.1785100060794031],
            [14.99100830467559, -1.1820974898221757],
            [14.990669992158592, -1.1864770753778642],
            [14.995348127374827, -1.1871139357105605],
            [14.999742895333798, -1.1903882317517882],
            [15.002955922817035, -1.1863267638086332],
            [14.998318545917884, -1.182309285091027],
            [15.002315415060089, -1.1767133640535488],
            [15.005240477147236, -1.177389704882642],
            [15.00891534951928, -1.175246744046707],
            [15.014363605450956, -1.1676408434268286],
            [15.012500120163313, -1.1712797361055753],
            [15.011639825108254, -1.179103878242817],
            [15.01450536415895, -1.1994356960187516],
            [15.0145576390112, -1.2063086172077884],
            [15.013469311907459, -1.2120250244187014],
            [14.997573938214238, -1.2655217057842656],
            [14.986295038953235, -1.3156398329277206],
            [14.984562741788292, -1.3239882852384668],
            [14.984115185911833, -1.3467542177233003],
            [14.970809548021379, -1.4502890390370307],
            [14.96673502458747, -1.4708014325655097],
            [14.959559510221625, -1.5025943032044133],
            [14.95146615888808, -1.4976183765097548],
            [14.934266759006963, -1.4950337120766268],
            [14.92766669990109, -1.499917619035669],
            [14.916863825448452, -1.504429408687717],
            [14.85040102612042, -1.5560561664369201],
            [14.827567970894965, -1.5734370703617386],
            [14.75977372613974, -1.6235430748508841],
            [14.73823473383525, -1.6393537863236092],
            [14.713822719817873, -1.651355494108903],
            [14.705611125629511, -1.6611748207442698],
            [14.704680692728921, -1.6635563687756219],
            [14.696598604324045, -1.6653799869198667],
            [14.688801569434498, -1.6609593552966966],
            [14.685331837883373, -1.656109350378804],
            [14.686310705984514, -1.65003645719704],
            [14.684017126814064, -1.6495702137160906],
            [14.682285373916166, -1.6437115511957539],
            [14.679152544883305, -1.6410078975299105],
            [14.67443621586641, -1.6465793657167505],
            [14.669606046208393, -1.6466560825388499],
            [14.666989627885977, -1.6432096726962502],
            [14.66640860855812, -1.6388713093649472],
            [14.663060515244059, -1.6357776766073806],
            [14.66226763763734, -1.6318068089964657],
            [14.652727453791217, -1.6282198725239259],
            [14.652025741819337, -1.6197517325667872],
            [14.652177422084204, -1.6110647862039682],
            [14.653191258986832, -1.608055202550783],
            [14.648198784976026, -1.6055838988455329],
            [14.64645645183135, -1.6028444870770404],
            [14.643442183577223, -1.592643672872292],
            [14.63873472371489, -1.5839184244730236]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.98647269155207, "lat": 35.96724386079597 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37127"],
        "coty_name": ["Nash"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nash County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01008574"
      },
      "bbox": [
        14.63873472371489, -1.6653799869198667, 15.0145576390112,
        -1.1654379872853693
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.305320937654855, 8.116050305489182],
            [-4.268752585224349, 8.113603110857218],
            [-4.21896959791747, 8.109931420370463],
            [-4.119066941424464, 8.102806435726684],
            [-4.0373366848499055, 8.09712173797121],
            [-3.9444059755706213, 8.09094882930924],
            [-3.8844687269310967, 8.087360406050882],
            [-3.7913535849588995, 8.081899860408585],
            [-3.7342117232044, 8.078243923341313],
            [-3.7029290738603815, 8.07615408960741],
            [-3.7080925748864466, 7.9763670431472375],
            [-3.7126488458020077, 7.891963454810382],
            [-3.7128665266329772, 7.890839946383386],
            [-3.718977159922548, 7.781923121148417],
            [-3.721984074196016, 7.733625499200523],
            [-3.6882038650775972, 7.731566005194812],
            [-3.693038043171647, 7.6542406142816874],
            [-3.7797551144180295, 7.659684769810556],
            [-3.909376228404104, 7.668407931023459],
            [-3.9964044603248285, 7.674369852746255],
            [-3.997944502693365, 7.674688495660052],
            [-4.038448330700446, 7.677350025046255],
            [-4.033529293244755, 7.753620481649489],
            [-4.062188336721082, 7.755244083232634],
            [-4.155234987163844, 7.761326868187503],
            [-4.241893219218158, 7.766436707275164],
            [-4.318952081442849, 7.772058005218713],
            [-4.32862171799721, 7.772638608631247],
            [-4.323123798929574, 7.858537586509587],
            [-4.316475726610698, 7.944157603255923],
            [-4.310645702427606, 8.027899748546925],
            [-4.308410312588249, 8.073101937813828],
            [-4.305320937654855, 8.116050305489182]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.46026648157999,
          "lat": 46.43248715255218
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38041"],
        "coty_name": ["Hettinger"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hettinger County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01034209"
      },
      "bbox": [
        -4.32862171799721, 7.6542406142816874, -3.6882038650775972,
        8.116050305489182
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.008462402212574, 8.928294857945263],
            [-4.9971840522145285, 9.05199063733067],
            [-4.988419327142259, 9.151091293022395],
            [-4.977834424493673, 9.270298449419618],
            [-4.9725448551739575, 9.325055168609595],
            [-4.972250437167509, 9.329926219632293],
            [-4.967107759192593, 9.382604828306123],
            [-4.960912334765136, 9.467806559779378],
            [-4.957543507839851, 9.513205784949491],
            [-4.946879351227969, 9.508165062208663],
            [-4.942978563238628, 9.505221410742623],
            [-4.938725423173109, 9.495423892979925],
            [-4.937717872695658, 9.487331877942696],
            [-4.934034444796983, 9.482777857966568],
            [-4.92982436351634, 9.483036099721398],
            [-4.923120280960915, 9.486566635012707],
            [-4.920366226596772, 9.490379577513496],
            [-4.920046823486165, 9.496729147594339],
            [-4.916404956374856, 9.498921100009033],
            [-4.906827855219188, 9.498613597547212],
            [-4.898467077892813, 9.494191009465307],
            [-4.891027837240698, 9.48768591508866],
            [-4.886976328486489, 9.481951962589111],
            [-4.883029662202785, 9.474165071876186],
            [-4.877259801983705, 9.467140960815758],
            [-4.860665721850428, 9.471049080009495],
            [-4.855407119740422, 9.471309522309678],
            [-4.846540160832145, 9.475486245245863],
            [-4.841943054142505, 9.480773092745661],
            [-4.83728319699629, 9.495304301235793],
            [-4.831092324505162, 9.501822944652753],
            [-4.831563429731634, 9.508336235086798],
            [-4.835652828132784, 9.515466021309237],
            [-4.832030822546758, 9.52145565878129],
            [-4.829704276025033, 9.521272389984727],
            [-4.812952928620296, 9.505135836307662],
            [-4.811130624756268, 9.502107882861694],
            [-4.811639810192337, 9.49214689353635],
            [-4.8140853286306875, 9.485694980704142],
            [-4.81096022146592, 9.484332380697408],
            [-4.806169643833959, 9.486608643402159],
            [-4.794092415805253, 9.497956492309424],
            [-4.7910021482, 9.503352080019326],
            [-4.786343755751271, 9.516021873837676],
            [-4.785718553354169, 9.521016149483897],
            [-4.786115066477958, 9.529975850875532],
            [-4.788688818564455, 9.538023407032044],
            [-4.786306017614116, 9.549505862330795],
            [-4.782237716082923, 9.557243568544942],
            [-4.777756663256147, 9.560631185011879],
            [-4.7686743477251206, 9.556939848373737],
            [-4.75920685552502, 9.5431921562324],
            [-4.754487608553631, 9.540382530180986],
            [-4.750441585648785, 9.540485429797133],
            [-4.748773283813622, 9.542823521132151],
            [-4.739476132674832, 9.547231452224924],
            [-4.731326476376282, 9.552193557945216],
            [-4.728588490517117, 9.55523772184654],
            [-4.726928585292767, 9.562394100603123],
            [-4.729031839528156, 9.566492289413567],
            [-4.734205702197553, 9.569422470256912],
            [-4.746218619484294, 9.581542435144197],
            [-4.748273440129266, 9.585785097533861],
            [-4.7466840296243, 9.591386868598809],
            [-4.742827530187129, 9.593332266543353],
            [-4.732438369590804, 9.601287425746365],
            [-4.728540121739495, 9.605308069095448],
            [-4.713292148764779, 9.613243263068753],
            [-4.704636462949254, 9.61578713091884],
            [-4.699344807644012, 9.616051046073855],
            [-4.68980008814743, 9.612152477758775],
            [-4.682705875293454, 9.605609482411564],
            [-4.6766236700979436, 9.60306394724539],
            [-4.672453101911505, 9.602831857235069],
            [-4.666631105771546, 9.605449981729825],
            [-4.657425406152199, 9.613112986665925],
            [-4.65254055988866, 9.6200603178028],
            [-4.6463332840359275, 9.623577668189052],
            [-4.641386565783249, 9.622907748983382],
            [-4.639477114147941, 9.619760048819662],
            [-4.639122709729284, 9.613362273752642],
            [-4.643912688052478, 9.609789894205003],
            [-4.65150778121733, 9.606958081409408],
            [-4.65502718110833, 9.604392851597334],
            [-4.655064035270155, 9.599787191830472],
            [-4.643805234906913, 9.584482860030956],
            [-4.640956342716687, 9.582100699150812],
            [-4.630237639526679, 9.576745292580007],
            [-4.623643349899727, 9.57554028399426],
            [-4.617088138623778, 9.575515831317126],
            [-4.616297220457587, 9.573590482172941],
            [-4.619815653042918, 9.566020968912618],
            [-4.624876166077853, 9.561122378438323],
            [-4.635292361996823, 9.55438952295314],
            [-4.64125286366699, 9.549268204094918],
            [-4.644059181218951, 9.544683058839432],
            [-4.644774508549249, 9.535028056028423],
            [-4.643240393272412, 9.532258405594742],
            [-4.63516183835893, 9.525932127006522],
            [-4.627011230477228, 9.523819571791092],
            [-4.6203640866355915, 9.523199469924622],
            [-4.6099454215513775, 9.524051372892995],
            [-4.605838623009164, 9.521277343946663],
            [-4.600936716387309, 9.507355348663657],
            [-4.597117275530713, 9.499306035497902],
            [-4.591645079838209, 9.49328627750487],
            [-4.588538804301757, 9.492357220562335],
            [-4.580754598192507, 9.493222624579237],
            [-4.573792531429782, 9.498098964476178],
            [-4.5671471301861395, 9.50599851767364],
            [-4.562137021256509, 9.509435799675222],
            [-4.551202438259164, 9.512512606534006],
            [-4.544231390749413, 9.517662056261821],
            [-4.540358189340353, 9.518736100146043],
            [-4.531592314239672, 9.516686326674842],
            [-4.519468874412906, 9.509180391769233],
            [-4.508515028432212, 9.505690287033534],
            [-4.503911862345324, 9.505729618495703],
            [-4.492638168577005, 9.508005355466787],
            [-4.4690556060787525, 9.517191618948008],
            [-4.459744876215128, 9.51864023415457],
            [-4.451530841089839, 9.515564495308249],
            [-4.447915566282342, 9.515094160940325],
            [-4.442525083122993, 9.518314722379023],
            [-4.439658271333466, 9.523001556756684],
            [-4.43709238775646, 9.53251655016406],
            [-4.434542840952327, 9.53487347044074],
            [-4.425250196456053, 9.536132727520856],
            [-4.415760844695776, 9.532965561080555],
            [-4.411250065087368, 9.53272398937906],
            [-4.406916407924326, 9.535437957296848],
            [-4.402992729008925, 9.539849943835002],
            [-4.4013231051443364, 9.546588470361021],
            [-4.403977232362102, 9.552473971403444],
            [-4.407275130133729, 9.55527125016675],
            [-4.416901763052156, 9.559240529942482],
            [-4.4183144315093426, 9.564509163529575],
            [-4.40636672442395, 9.580105276617761],
            [-4.399070636304658, 9.587105041534207],
            [-4.389125464021678, 9.598087947963617],
            [-4.384393641312113, 9.602276347144102],
            [-4.380636000875598, 9.603940522311563],
            [-4.369268334532639, 9.602080087854446],
            [-4.350498263931916, 9.602656975099078],
            [-4.342425228439703, 9.604253281515842],
            [-4.3330470940298405, 9.607929460294637],
            [-4.328753969636572, 9.607602557853474],
            [-4.322562088136121, 9.609454182793785],
            [-4.316147736533341, 9.610206042342584],
            [-4.309295739616143, 9.608988812605952],
            [-4.306308124384531, 9.606190160082251],
            [-4.306163041791803, 9.601131392354606],
            [-4.308166618460174, 9.591243161523012],
            [-4.30549992867569, 9.588010226884506],
            [-4.302914435955716, 9.5881863451961],
            [-4.291673414232729, 9.594608235270073],
            [-4.274733830118564, 9.59602470285133],
            [-4.26350037160698, 9.595554102797465],
            [-4.251306541774395, 9.591206178470172],
            [-4.247836248998187, 9.59128668354308],
            [-4.240879354325815, 9.594286115642554],
            [-4.226672374175309, 9.595346267697538],
            [-4.214036174470252, 9.59370465168651],
            [-4.209728370638728, 9.59211560025151],
            [-4.203955143825466, 9.588309306953088],
            [-4.198018350025806, 9.57918199775599],
            [-4.192258370886188, 9.576942653701817],
            [-4.18352248835485, 9.576337502041012],
            [-4.173536516496206, 9.580006965003662],
            [-4.160792803942525, 9.58865473101684],
            [-4.15421457444643, 9.589067001919645],
            [-4.147723600659109, 9.58644845075858],
            [-4.138066658437681, 9.580959602194534],
            [-4.130724043439139, 9.574405491331797],
            [-4.116278861472193, 9.568749646698397],
            [-4.108417882425044, 9.568383185740801],
            [-4.101842968432081, 9.570505347961298],
            [-4.0884768563446965, 9.5779767675189],
            [-4.08287736089455, 9.576125194015766],
            [-4.074514805911, 9.57063598991535],
            [-4.070150166314214, 9.563220743140686],
            [-4.071735952562635, 9.552892849205252],
            [-4.074001173598069, 9.547959177047408],
            [-4.084905014625641, 9.5437961677378],
            [-4.085332379922465, 9.54148859160734],
            [-4.076383882400831, 9.538578962134157],
            [-4.069180698894148, 9.535427096078871],
            [-4.0630996390991205, 9.534511750037685],
            [-4.049380906870709, 9.533652468156943],
            [-4.039758610152923, 9.528837750744017],
            [-4.031983636177222, 9.52729402083251],
            [-4.025772896229212, 9.524148260180182],
            [-4.0231614384486205, 9.520787648231394],
            [-4.022928844710322, 9.512828877712312],
            [-4.024554247655557, 9.503419081970263],
            [-4.028015500789689, 9.495840747506907],
            [-4.024274763115993, 9.487741456470568],
            [-4.019837792286144, 9.483895060976922],
            [-4.009950767888445, 9.481121627106507],
            [-4.000074561807452, 9.484030041913389],
            [-3.9935730462594594, 9.488980585083473],
            [-3.9881885577650973, 9.488673247219277],
            [-3.9827918249250973, 9.479376408386678],
            [-3.9838457317698577, 9.46221401864264],
            [-3.983197589613944, 9.45720310747647],
            [-3.980824722396828, 9.45411439518166],
            [-3.974846342323931, 9.450010040455318],
            [-3.967032640454892, 9.4459033376239],
            [-3.95655822292432, 9.441804414591225],
            [-3.953435244688459, 9.436979675395392],
            [-3.953796398802151, 9.432553987482057],
            [-3.9615973872868917, 9.416805372139107],
            [-3.9649242421849755, 9.411257310516023],
            [-3.973962002221285, 9.399888391396606],
            [-3.9836683583303816, 9.39163299909916],
            [-3.996993343755314, 9.384111631587919],
            [-4.005109151282699, 9.37466267064016],
            [-4.007990954707901, 9.372212035379023],
            [-4.013458285589869, 9.363855312008983],
            [-4.022348038081457, 9.354067622185772],
            [-4.0247911481694345, 9.349231755995206],
            [-4.025988409632202, 9.343818952472937],
            [-4.027336180427902, 9.330564883294635],
            [-4.031424228325942, 9.323584691440761],
            [-4.033149757026814, 9.310750530364231],
            [-4.032832495561112, 9.300908327999876],
            [-4.030102150194169, 9.279219489036514],
            [-4.026415406597234, 9.272876401201255],
            [-4.028102149149367, 9.253905737218561],
            [-4.030656872434183, 9.215196263032317],
            [-4.037065214748, 9.12655762521445],
            [-4.132828648728597, 9.133333856971175],
            [-4.239470709575075, 9.141261659969615],
            [-4.3461156475918425, 9.149152736982211],
            [-4.348319979130482, 9.120933348798358],
            [-4.352558282014741, 9.060340692243189],
            [-4.358318006177118, 8.987007657471247],
            [-4.366968526709062, 8.869877695518895],
            [-4.3714363839835215, 8.810693473919356],
            [-4.432705669542118, 8.81521871211502],
            [-4.538461550768169, 8.82333703517434],
            [-4.64422019535441, 8.831419998811377],
            [-4.645627068791304, 8.831391979449908],
            [-4.718258548993402, 8.83730688640117],
            [-4.7570877656873245, 8.84088975395489],
            [-4.805314311996987, 8.84485262364293],
            [-4.84169922217138, 8.848123481276858],
            [-4.927194778845845, 8.85533433856939],
            [-5.014251260967113, 8.862812064769981],
            [-5.0101782140896605, 8.906706328820587],
            [-5.008462402212574, 8.928294857945263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.39530956563813,
          "lat": 47.740179553631094
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38053"],
        "coty_name": ["McKenzie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McKenzie County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01035299"
      },
      "bbox": [
        -5.014251260967113, 8.810693473919356, -3.953435244688459,
        9.623577668189052
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.981124174412908, 3.707117665009963],
              [9.984212074265535, 3.7122280943737405],
              [9.986413880124656, 3.7083292671332675],
              [9.981124174412908, 3.707117665009963]
            ]
          ],
          [
            [
              [9.741326426205957, 3.6409704526529887],
              [9.751933153329096, 3.6497744905089458],
              [9.757692761226089, 3.6420504444288713],
              [9.748849275347494, 3.634516129749555],
              [9.74630799706178, 3.631351900668764],
              [9.74051436138109, 3.6373115942811904],
              [9.741326426205957, 3.6409704526529887]
            ]
          ],
          [
            [
              [9.728073488344904, 3.6404840254882225],
              [9.736133918887514, 3.6464145420497545],
              [9.738417253504972, 3.6431590404381065],
              [9.728952170838104, 3.6360907859779603],
              [9.728073488344904, 3.6404840254882225]
            ]
          ],
          [
            [
              [9.446124613911609, 3.382498363492387],
              [9.433472504682728, 3.483820448557777],
              [9.429839726625664, 3.512223175853794],
              [9.43357062635159, 3.5127310619346312],
              [9.42764372457191, 3.5527555660880465],
              [9.418209632232731, 3.614727911999927],
              [9.433378969358321, 3.617847116977203],
              [9.503905295458408, 3.6292523998983888],
              [9.543524671181515, 3.6360078700609257],
              [9.560692040817129, 3.6395552012551686],
              [9.633838533361926, 3.6520455426493923],
              [9.72872167487993, 3.6680951964867674],
              [9.728997425209815, 3.6628261922278704],
              [9.725468732871125, 3.6621021879492734],
              [9.721066884431542, 3.6566631758617736],
              [9.719048995614193, 3.649425141975501],
              [9.718360103884915, 3.6379223966564953],
              [9.715491600259385, 3.6358704391872316],
              [9.71681360935496, 3.631645280229672],
              [9.722873959588679, 3.6301891973633413],
              [9.718205064338283, 3.6222755443845327],
              [9.713979563416073, 3.6173897496525504],
              [9.717220444024479, 3.6150836004074303],
              [9.722413104481573, 3.620973966504574],
              [9.725856939649088, 3.622211776213142],
              [9.730634650572215, 3.6267718711563277],
              [9.731109581103116, 3.631925698414994],
              [9.733120287116524, 3.6334062125933233],
              [9.739610930110832, 3.631799586823361],
              [9.742912977984886, 3.632233393181445],
              [9.7456690726234, 3.6295477972465826],
              [9.758128069144583, 3.62798007527371],
              [9.767928259628228, 3.6310841900150277],
              [9.774966660512913, 3.631692882578341],
              [9.779831431489736, 3.633347804636754],
              [9.783315766424948, 3.6309775347838062],
              [9.790595444964154, 3.6284112158207793],
              [9.796150945851245, 3.6287066514139728],
              [9.810973338216886, 3.6324890581881566],
              [9.81216995900433, 3.635459070634558],
              [9.816708439530752, 3.6383381267910777],
              [9.81950123782929, 3.6455278960891957],
              [9.818712707283444, 3.6502695883563803],
              [9.82014406055407, 3.6525214211294044],
              [9.825169832624114, 3.650383786099358],
              [9.829985689220054, 3.645689199913654],
              [9.83482001895069, 3.6439474918603763],
              [9.84464295862253, 3.6377920071288568],
              [9.84220129547491, 3.632568432073282],
              [9.84576951569606, 3.6266743400993398],
              [9.850364369560369, 3.6262131207144703],
              [9.862771107911582, 3.628018653214716],
              [9.86644222915677, 3.6253249953079094],
              [9.89953693633614, 3.607749031218846],
              [9.900558619405848, 3.6060115649140236],
              [9.923406950595703, 3.595129573767631],
              [9.928641001382534, 3.594426518191643],
              [9.939626545449135, 3.590319002488601],
              [9.95342924773503, 3.587056069856322],
              [9.858131458076956, 3.5726528784911586],
              [9.806196414315284, 3.564379314750103],
              [9.772823254185788, 3.5585765107068816],
              [9.701888682592283, 3.5479656693081814],
              [9.663781209345254, 3.5427187781070852],
              [9.659818458294932, 3.5416597920723523],
              [9.654453529533225, 3.5346666183044215],
              [9.652506069878449, 3.528426344755303],
              [9.648629590231184, 3.52375908578068],
              [9.645480812367536, 3.5112781968338687],
              [9.641211177245866, 3.5078755469502103],
              [9.636632957476046, 3.4988576389370456],
              [9.63643858423506, 3.4940675022434244],
              [9.634410108650716, 3.491262987990588],
              [9.625005477317808, 3.4893231172398194],
              [9.621763987286462, 3.4814943824165026],
              [9.618556098370663, 3.478539367989527],
              [9.61306373820462, 3.4787353343062177],
              [9.607451320471336, 3.4724239215347668],
              [9.60199345873074, 3.4694806788910433],
              [9.598270254457447, 3.464735063171372],
              [9.58794128911564, 3.460963864819832],
              [9.578673384197183, 3.4513321253161204],
              [9.575146907896182, 3.446207708024528],
              [9.569600433517044, 3.434503551973341],
              [9.570273310701161, 3.41751209818539],
              [9.569296796874095, 3.4112003030952747],
              [9.57145068551535, 3.4067697097449776],
              [9.568012915588076, 3.3992791779976472],
              [9.564717989179906, 3.3968594041725377],
              [9.557292985991221, 3.3939126823322994],
              [9.552606095466833, 3.3860948142952845],
              [9.549794652980072, 3.375926991011315],
              [9.543994268364502, 3.3700148588444665],
              [9.536393236811772, 3.3684519276340152],
              [9.53006300968957, 3.3690179221382697],
              [9.525674174888408, 3.3643732213652404],
              [9.527129354594821, 3.3576302292719507],
              [9.526304323262789, 3.354782641561171],
              [9.519321946513392, 3.349295469307478],
              [9.509077793705025, 3.338810614852005],
              [9.50699516944782, 3.338559684332125],
              [9.501454921734714, 3.3335574319134507],
              [9.493495986835882, 3.3303669685874144],
              [9.489941067981592, 3.327548437112073],
              [9.481676576306885, 3.323642508907599],
              [9.478973861875348, 3.3204916948288785],
              [9.478342290386092, 3.3149559444390446],
              [9.476601381183126, 3.31225529550126],
              [9.466950439392818, 3.311325360195574],
              [9.462658269950674, 3.3124199026970738],
              [9.45526916714393, 3.3095810088477893],
              [9.452426516769986, 3.333694611884674],
              [9.446124613911609, 3.382498363492387]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.65886054185606,
          "lat": 41.619712276571406
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39095"],
        "coty_name": ["Lucas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lucas County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01074060"
      },
      "bbox": [
        9.418209632232731, 3.3095810088477893, 9.986413880124656,
        3.7122280943737405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.142793671473447, 1.1457510104347868],
            [10.215968211136815, 1.1516120271858723],
            [10.356077202373568, 1.160520769169377],
            [10.447306066335416, 1.167160751386752],
            [10.536648175274602, 1.173487966763793],
            [10.578530029727165, 1.1760300672582278],
            [10.58133483086659, 1.1311668138513602],
            [10.583847651757997, 1.086705858872452],
            [10.586736080629095, 1.0414757015983707],
            [10.588110413191886, 1.041541406790461],
            [10.589608650932258, 1.0109741741756317],
            [10.59323797833757, 0.953136517580111],
            [10.521990599050561, 0.9476175889002677],
            [10.467372744430815, 0.9430043912506294],
            [10.411663211768573, 0.9370365359340513],
            [10.351607989098925, 0.9299579981274344],
            [10.345952594338915, 0.9290446763826022],
            [10.2825398638787, 0.9227148997367325],
            [10.280161010454629, 0.9256600477650435],
            [10.282627189667494, 0.9313167186195813],
            [10.280010782271876, 0.9345485301369274],
            [10.277055210649225, 0.9338001959831012],
            [10.276702275660481, 0.9403007998580237],
            [10.27807052539924, 0.9485083807433567],
            [10.275837310308711, 0.9541768832520097],
            [10.266744575903601, 0.9565736612731595],
            [10.265812218710654, 0.9590167681668095],
            [10.256419372515955, 0.9657880319460789],
            [10.256203834640484, 0.9697918449613381],
            [10.248087996390334, 0.968880471524727],
            [10.237162651824729, 0.9726905172182057],
            [10.23199892808845, 0.9712092053190918],
            [10.230229896255933, 0.9723337844122922],
            [10.226394703984049, 0.9764498745548635],
            [10.217953753625425, 0.9790304741094693],
            [10.215448775963093, 0.9825233463287335],
            [10.207425658732967, 0.9895115296532443],
            [10.202499262821064, 0.9922972559860282],
            [10.198498069244021, 0.9929891180162896],
            [10.193927729229086, 0.9989714746583893],
            [10.191954653959515, 1.004266779992843],
            [10.183198233201116, 1.0037304064126051],
            [10.137389334047894, 1.00001979148775],
            [10.139032989758551, 1.0342771774214063],
            [10.140776191776224, 1.0780259404195114],
            [10.142793671473447, 1.1457510104347868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.06676241629717, "lat": 39.07730084514644 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39131"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01074078"
      },
      "bbox": [
        10.137389334047894, 0.9227148997367325, 10.59323797833757,
        1.1760300672582278
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.7148019693230467, -4.300965147370325],
            [-1.6719069884771514, -4.301955581494001],
            [-1.6715267400582532, -4.28740552790762],
            [-1.6281112299147926, -4.288792591450511],
            [-1.5859849128128352, -4.289873205074081],
            [-1.585191010881528, -4.260770628826683],
            [-1.549653052425919, -4.262062819152024],
            [-1.5070951790801086, -4.263352697183527],
            [-1.4142586721318169, -4.265449776331639],
            [-1.4138722866153295, -4.250886476066208],
            [-1.3714671351879288, -4.251707611126124],
            [-1.370507031933775, -4.208088544246991],
            [-1.3172130281192527, -4.2094873993596185],
            [-1.2871768433525719, -4.210134263353262],
            [-1.2847976915854151, -4.210178663350692],
            [-1.2865411763848174, -4.297384900572124],
            [-1.2872036246482084, -4.319223638436944],
            [-1.2887995584255754, -4.384651502921419],
            [-1.2897164080248604, -4.428416543688496],
            [-1.292241508453101, -4.5376601571284025],
            [-1.292869910713662, -4.577096650847338],
            [-1.2960934453026782, -4.5824965788944665],
            [-1.3059300348493912, -4.595964429328359],
            [-1.3182542177726413, -4.604288329538736],
            [-1.336563071312845, -4.602280158500832],
            [-1.3436192049377664, -4.601082781256997],
            [-1.356961115282541, -4.5957119170407505],
            [-1.3627455630847731, -4.592289700634734],
            [-1.3686461510018615, -4.583179348476985],
            [-1.3768558172277188, -4.583911176223481],
            [-1.3826124231184251, -4.586173020536996],
            [-1.3896328150983415, -4.587249054140605],
            [-1.393880142736133, -4.585051450137104],
            [-1.4031390273458821, -4.5841831563538245],
            [-1.4091911305460614, -4.585508609961452],
            [-1.4254294987589222, -4.5812711736041605],
            [-1.4457463438614644, -4.564253061444977],
            [-1.4772648310061338, -4.557364280584023],
            [-1.4801371830774677, -4.55821546130966],
            [-1.4827026356419435, -4.562227416434602],
            [-1.4919351092784143, -4.564944523936236],
            [-1.4966052361279292, -4.573157848120628],
            [-1.4959862436991673, -4.576372717649481],
            [-1.491810094191882, -4.579448392052295],
            [-1.4908391302238495, -4.58308694025267],
            [-1.493505437178785, -4.5846531410347735],
            [-1.498115437085631, -4.580852129231909],
            [-1.503368026894825, -4.58262847557467],
            [-1.508479332592858, -4.591625494355861],
            [-1.5061954323738516, -4.592527005063264],
            [-1.5068114219131776, -4.609421713361527],
            [-1.510058007203093, -4.6152809846883365],
            [-1.513754566181616, -4.612688975973685],
            [-1.5175862446968815, -4.613412015173394],
            [-1.5162854034572875, -4.619728486113979],
            [-1.5180748314893013, -4.6257245854899836],
            [-1.5241437397843594, -4.63099823156618],
            [-1.528023753486, -4.6307108093176215],
            [-1.5325607563914394, -4.627861545160132],
            [-1.5415916999022892, -4.6288898109604295],
            [-1.5446318461685815, -4.630981095429137],
            [-1.5464625450583511, -4.636284151490562],
            [-1.5492205075384966, -4.639594115325044],
            [-1.55387085627715, -4.6403636591963835],
            [-1.560647137136041, -4.638923993266548],
            [-1.5631740372376974, -4.639617208850618],
            [-1.5678575974384454, -4.646946611476117],
            [-1.576637830802397, -4.650129347708687],
            [-1.580153361993446, -4.649708212858895],
            [-1.5820932529743712, -4.646163353224741],
            [-1.5863941944808595, -4.6422844056695105],
            [-1.5945425896259056, -4.639597250178806],
            [-1.6046348247475568, -4.62556990456011],
            [-1.6136989561108568, -4.616310448007927],
            [-1.6199849640609776, -4.603702328191757],
            [-1.631702098950611, -4.591340998368074],
            [-1.6341216159051895, -4.591067210802625],
            [-1.6395179873363006, -4.586877984213499],
            [-1.6377640530773092, -4.582215359875106],
            [-1.6343032022181427, -4.583965171496283],
            [-1.631578595806599, -4.582819251604517],
            [-1.6328928554743851, -4.5770061411170015],
            [-1.638941959257343, -4.577211690662115],
            [-1.644575921102834, -4.572133276057447],
            [-1.6486843976082985, -4.565002356374031],
            [-1.6524248840954163, -4.561011334622519],
            [-1.6592317005580486, -4.5574444580607665],
            [-1.6707013678424905, -4.548848821785278],
            [-1.6741485898664186, -4.549078318232284],
            [-1.679166432214752, -4.552051333131109],
            [-1.6749038718725895, -4.412342014389406],
            [-1.6740125858242503, -4.374715997717956],
            [-1.7168882244369406, -4.373820646417688],
            [-1.7148019693230467, -4.300965147370325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.37219738521024,
          "lat": 34.290213014783355
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40033"],
        "coty_name": ["Cotton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cotton County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01101804"
      },
      "bbox": [
        -1.7168882244369406, -4.650129347708687, -1.2847976915854151,
        -4.208088544246991
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2408192689059083, -2.5128492684858768],
            [-2.13864524747404, -2.516801831043729],
            [-2.1320151454799645, -2.517541988746838],
            [-2.0358495663796567, -2.5219388594143726],
            [-2.029185070252815, -2.521584533026436],
            [-1.9815179865390038, -2.5236838904402936],
            [-1.9001811971868015, -2.526948464421415],
            [-1.8513519943401369, -2.5288135554990747],
            [-1.716728317150385, -2.5307510669409696],
            [-1.6662214142792002, -2.530856605950343],
            [-1.6450795170918613, -2.531102706174334],
            [-1.6456101071391205, -2.5528829865299127],
            [-1.6502927847120905, -2.740971167639854],
            [-1.6519276563761367, -2.7992819090009737],
            [-1.6486770462799027, -2.799391074306218],
            [-1.651001102808676, -2.8864330520546404],
            [-1.7129412382086393, -2.884656088369956],
            [-1.724292752581656, -2.8846667589883723],
            [-1.810839212730188, -2.881780456956743],
            [-1.8217580366300588, -2.88120772131259],
            [-1.8524363212874968, -2.880535346174106],
            [-1.9556533647218615, -2.877498240128002],
            [-2.0780315811383656, -2.873415511542532],
            [-2.1209435399727194, -2.872048950814284],
            [-2.235086669447422, -2.868311180054127],
            [-2.248437526666808, -2.867784078180365],
            [-2.2454914946087094, -2.7804386601373876],
            [-2.2496414726882064, -2.7803033523533176],
            [-2.247871494142555, -2.7322506111591025],
            [-2.247628741139603, -2.7305736551980524],
            [-2.245412347299589, -2.6654129106458955],
            [-2.243333764124289, -2.5804675470243317],
            [-2.2430368684851465, -2.5789697434625567],
            [-2.2408192689059083, -2.5128492684858768]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.00788643148107,
          "lat": 35.987642470366765
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40043"],
        "coty_name": ["Dewey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dewey County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01101809"
      },
      "bbox": [
        -2.2496414726882064, -2.8864330520546404, -1.6450795170918613,
        -2.5128492684858768
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.04055686979842702, -3.26636598963416],
            [-0.037556966422520766, -3.176668531169411],
            [-0.03628451730235833, -3.0887822671372094],
            [-0.0006165183287797402, -3.0890368463832747],
            [0.07990782551805647, -3.089416823517429],
            [0.12614851978463335, -3.089366382368203],
            [0.1461147050839148, -3.0896330729995545],
            [0.2370233853884085, -3.0902661625864893],
            [0.30864598139161337, -3.0901734815586073],
            [0.30835741418254203, -3.1779457728647085],
            [0.39294217413695265, -3.178035137906812],
            [0.3928864171121934, -3.312498866519098],
            [0.39299797332085645, -3.3544363098020598],
            [0.4787201409787977, -3.354557004984055],
            [0.4787000387152201, -3.4421783304035403],
            [0.4101426265015608, -3.442101727864445],
            [0.3215548864761585, -3.441795826627422],
            [0.23548605754454252, -3.4415687628958676],
            [0.13531268204210373, -3.4410739241240003],
            [0.10661951815812014, -3.4410076858949266],
            [0.10747402930640976, -3.2951635484708226],
            [0.10751448492202753, -3.262153472455803],
            [0.1057133069592249, -3.268761003852618],
            [0.10350546767833531, -3.2714703572451036],
            [0.09837618384751906, -3.2716828561838422],
            [0.09519718021415394, -3.2685914272014194],
            [0.09057045268146471, -3.268920644644649],
            [0.08785293875883537, -3.271731831226503],
            [0.08309391262967272, -3.2667948576688794],
            [0.0796724251893183, -3.2663416770592524],
            [0.07885828462863603, -3.270917748853356],
            [0.07533870204674868, -3.2759273840505925],
            [0.0699266230978085, -3.2806582039107353],
            [0.06972366625011366, -3.284011360607035],
            [0.07268844688831429, -3.2853349335112685],
            [0.073689096543466, -3.2900620370475613],
            [0.07001250147704068, -3.297417346971444],
            [0.0626668224466918, -3.3010306146385533],
            [0.055317570945228385, -3.299878932001411],
            [0.050702447710741116, -3.300215876175383],
            [0.04487994891322486, -3.298610063994794],
            [0.04256286861879845, -3.2912565953521824],
            [0.033899708037143955, -3.2832734502605567],
            [0.03054764525500562, -3.2824548622232435],
            [0.027486798339172766, -3.2761672689011876],
            [0.02413883854498936, -3.276809976207409],
            [0.016742762315657075, -3.2751798451211713],
            [0.017003524106467827, -3.279615400768074],
            [0.01440553412060885, -3.2821698098840284],
            [0.010571647688521054, -3.2820365034480763],
            [0.009659798711679738, -3.2853430197585287],
            [0.00416437239551703, -3.287826506100258],
            [0.004668037481114264, -3.2913700280691165],
            [0.007757968179991491, -3.2935117066235806],
            [0.014946163596527166, -3.295055812783662],
            [0.012214574716258841, -3.300446701931822],
            [0.011331640103473083, -3.3081357583713586],
            [0.017372847035880535, -3.3067327445868853],
            [0.02127083603966293, -3.3112283517033636],
            [0.019455786435784224, -3.3148478943801725],
            [0.02424179074538734, -3.317997746048911],
            [0.029799294846201453, -3.318937804422142],
            [0.028983112074208287, -3.324679272559287],
            [0.03414966299741813, -3.330170294528696],
            [0.03131752604700442, -3.338656014658018],
            [0.02586203387632403, -3.337427628183251],
            [0.01931884760815401, -3.3377748459380805],
            [0.013898150843628655, -3.3349272755252564],
            [0.013835395852532361, -3.3274465462763594],
            [0.010386936908172285, -3.3296562164383974],
            [0.005668562619610373, -3.3304380410600176],
            [-0.002171524897890495, -3.3278216116973356],
            [-0.0037640464903727156, -3.3225302089989053],
            [-0.00936979019049048, -3.3181689749342484],
            [-0.014269157411032801, -3.320848067677653],
            [-0.018843266241553584, -3.3308401034176285],
            [-0.02082260430154484, -3.332721170629957],
            [-0.024937395674683883, -3.3302517036831785],
            [-0.02652335098163762, -3.333771800434443],
            [-0.0350406614272583, -3.333768411515938],
            [-0.040174501691421755, -3.3288027479358595],
            [-0.04062502687620923, -3.3248243894241005],
            [-0.04055686979842702, -3.26636598963416]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.32284990513305, "lat": 35.46544437471614 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40107"],
        "coty_name": ["Okfuskee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Okfuskee County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01101841"
      },
      "bbox": [
        -0.04062502687620923, -3.4421783304035403, 0.4787201409787977,
        -3.0887822671372094
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2515078969855415, -3.21739711263464],
            [-2.1519811430893037, -3.220773751982074],
            [-2.080394810058285, -3.223351790573922],
            [-1.938066452508607, -3.2279917967406373],
            [-1.824554571276001, -3.2315560621793837],
            [-1.7390374241122422, -3.234688843198165],
            [-1.6626234408451441, -3.2367997014530063],
            [-1.6537494160486044, -3.237313876529752],
            [-1.655535620180151, -3.3029585728093642],
            [-1.657414320589215, -3.3683766283601893],
            [-1.660952616930843, -3.4845294105825566],
            [-1.661198256926972, -3.4991205641422787],
            [-1.6566861630573886, -3.4992639209887004],
            [-1.6592803937401848, -3.5867746471460595],
            [-1.65963616029784, -3.6019823106015636],
            [-1.6618078472427773, -3.6062507591897623],
            [-1.6654482059504547, -3.6015050481838786],
            [-1.6657205308072613, -3.594636579279326],
            [-1.6684670878478238, -3.593382530814648],
            [-1.6688154059663394, -3.5873064093426184],
            [-1.6728316172314694, -3.5822103764398716],
            [-1.6758751480265857, -3.5802791011879633],
            [-1.6780102990419348, -3.590183822755889],
            [-1.6816501511465827, -3.591764547604174],
            [-1.6854449901487636, -3.588405185139029],
            [-1.6827516382181915, -3.5819301357693725],
            [-1.6866753638607404, -3.5791672733896616],
            [-1.6908281899981432, -3.5804795134047342],
            [-1.6964250535894407, -3.584819701837941],
            [-1.7029967785112838, -3.5837120358819385],
            [-1.7053777447991842, -3.5887419800320384],
            [-1.7049350554486287, -3.5930676830737935],
            [-1.7081033370923813, -3.5947309097940217],
            [-1.7191485987192712, -3.5934979501437443],
            [-1.7227220177301836, -3.5903061333512247],
            [-1.728592598091107, -3.591547538912183],
            [-1.7319148830145983, -3.595489465816385],
            [-1.7360098226755871, -3.5971272153177694],
            [-1.7404032405319523, -3.590175973745477],
            [-1.743184390258348, -3.5877671365838246],
            [-1.745539776300497, -3.5902839451233803],
            [-1.7504170080771924, -3.5892469079661393],
            [-1.7525782230017126, -3.590477990760425],
            [-1.7541240710434256, -3.5995446123141237],
            [-1.7569645086932817, -3.594413506435905],
            [-1.7654315334046649, -3.5846162427381283],
            [-1.923663213211406, -3.5798031287131455],
            [-2.017921965827412, -3.5766519548991105],
            [-2.089298074557833, -3.5742415030198322],
            [-2.1189267715565965, -3.573337371506352],
            [-2.2607181064015136, -3.5683284815958864],
            [-2.257584629549827, -3.480063072406365],
            [-2.2611059656142207, -3.479935652032956],
            [-2.2582299671321246, -3.3997865329047214],
            [-2.255552760866436, -3.326737772254574],
            [-2.2515078969855415, -3.21739711263464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.99222523587729,
          "lat": 35.290364158694636
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40149"],
        "coty_name": ["Washita"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washita County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01101862"
      },
      "bbox": [
        -2.2611059656142207, -3.6062507591897623, -1.6537494160486044,
        -3.21739711263464
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.717915296635171, 8.928121465869856],
            [-14.641277282349952, 8.910644711518612],
            [-14.56464316427484, 8.893150208341835],
            [-14.584679993406745, 8.809122451038021],
            [-14.61240356252587, 8.815397618729463],
            [-14.630942402924038, 8.734533973624977],
            [-14.61680487249517, 8.731313522321637],
            [-14.62360593680885, 8.703077955470492],
            [-14.609240275145964, 8.70028573005909],
            [-14.619117699979563, 8.65781432996184],
            [-14.606270735990115, 8.655218179370745],
            [-14.62943585171649, 8.556807675213538],
            [-14.599814082488864, 8.550456097045288],
            [-14.601596154371814, 8.542277941335016],
            [-14.616372616108304, 8.479820428724047],
            [-14.619328221430353, 8.466736104244106],
            [-14.6059063417941, 8.463633770294694],
            [-14.619538392762431, 8.403181722552047],
            [-14.606015663874357, 8.399646317485702],
            [-14.612447708576624, 8.372215522413606],
            [-14.598285121252415, 8.368887739044094],
            [-14.597989706800925, 8.370224139466009],
            [-14.570312108649889, 8.363814586987441],
            [-14.573632118474375, 8.350617958069694],
            [-14.576477082009557, 8.336866745645247],
            [-14.562800390253697, 8.333777024107881],
            [-14.565863816473835, 8.31990700318182],
            [-14.552206287749073, 8.316867221507703],
            [-14.558730038918963, 8.289364870931413],
            [-14.544976005040606, 8.28653951802017],
            [-14.54822646417974, 8.272776983421634],
            [-14.553811136904038, 8.24370444386111],
            [-14.55710149324302, 8.230398097837647],
            [-14.543632810388358, 8.227714758781703],
            [-14.52674735810307, 8.22369268854106],
            [-14.53643331155134, 8.1817487099759],
            [-14.465491802598393, 8.165646626675233],
            [-14.391763691391677, 8.14899440999624],
            [-14.410857638711382, 8.065922717480099],
            [-14.481121415588534, 8.081791797806432],
            [-14.490661890125555, 8.083371067838664],
            [-14.615627913576505, 8.11124761430009],
            [-14.625327729572994, 8.069387875924175],
            [-14.63550345747355, 8.027705060052046],
            [-14.76194056840616, 8.056286960477761],
            [-14.782525382902469, 8.060767353213382],
            [-14.78323067544849, 8.064068878662363],
            [-14.786455180560699, 8.065252422370982],
            [-14.784562330921439, 8.072999150458347],
            [-14.779529821079839, 8.075814168222076],
            [-14.780624371300501, 8.082136075431745],
            [-14.786380197161186, 8.084759538939197],
            [-14.789237342541398, 8.089120081008664],
            [-14.785816002459116, 8.09576651136614],
            [-14.78892907265712, 8.100037482778621],
            [-14.79745808362545, 8.105053063840105],
            [-14.798457765103201, 8.10045720227551],
            [-14.802730429318588, 8.099793382640092],
            [-14.807725254758731, 8.108487191749614],
            [-14.807460567939337, 8.112784770852306],
            [-14.810006452290164, 8.117972091542622],
            [-14.812807526008056, 8.12731870708964],
            [-14.812739164127278, 8.135261662955497],
            [-14.819406475873274, 8.138807343300707],
            [-14.822544689006458, 8.138832257637006],
            [-14.826438523363665, 8.134413203239058],
            [-14.832814556454073, 8.142190480184254],
            [-14.838399157201188, 8.14237540045643],
            [-14.841948509524311, 8.140233711220889],
            [-14.84439709256244, 8.133398205159763],
            [-14.85099125401437, 8.130657278445826],
            [-14.854032966904708, 8.125602362989598],
            [-14.862279704902383, 8.117999450981554],
            [-14.872157917532498, 8.114443501601809],
            [-14.87552092910897, 8.10972084140011],
            [-14.883764032017172, 8.106085153264335],
            [-14.88768808629352, 8.106123276396302],
            [-14.890694141582731, 8.103316689356959],
            [-14.896256255423385, 8.101818906146535],
            [-14.900475638934685, 8.099119810971873],
            [-14.913206377763801, 8.094868578812447],
            [-14.925165531091782, 8.096341407709696],
            [-14.937189224834407, 8.099401007582076],
            [-14.944732026146642, 8.107023459649362],
            [-14.952371524439599, 8.111667947415988],
            [-14.958309203103893, 8.113670768988836],
            [-14.966382762051577, 8.124499288246566],
            [-14.970397160738807, 8.12521838460341],
            [-14.977627302487658, 8.131294270502009],
            [-14.981621293848818, 8.140224932565271],
            [-14.983097270648127, 8.14151273457693],
            [-14.987093495685475, 8.15066624399324],
            [-14.987520813295808, 8.1584274464236],
            [-14.99127014913644, 8.163027638231474],
            [-14.998761513452425, 8.166892300077103],
            [-15.002660534610328, 8.165973524970505],
            [-15.012893534125, 8.168234231919014],
            [-15.019116524201, 8.164596380579786],
            [-15.022916788164185, 8.15920003487727],
            [-15.025142970610279, 8.153489892605757],
            [-15.02952043625835, 8.153502617849623],
            [-15.03502146474864, 8.150262121716795],
            [-15.035941577120349, 8.146909819548174],
            [-15.041025763436272, 8.144929507601695],
            [-15.0524914584237, 8.15000697488847],
            [-15.055345518542234, 8.152097719646791],
            [-15.06363032796522, 8.15195023707234],
            [-15.073573601942009, 8.147031864627866],
            [-15.079171812966273, 8.145516449110689],
            [-15.078478045309012, 8.14319795993005],
            [-15.08318706535643, 8.127869970242989],
            [-15.08791308101973, 8.126432370154294],
            [-15.092292389754599, 8.11980982934514],
            [-15.095404077188833, 8.117989808175933],
            [-15.099979694341373, 8.112209401649324],
            [-15.102375379447032, 8.103402383020127],
            [-15.111285401324679, 8.105465124566855],
            [-15.111491454347233, 8.103179767092405],
            [-15.116546980154657, 8.102288916723012],
            [-15.122750442419942, 8.10406377546053],
            [-15.124081231902236, 8.10666229252995],
            [-15.129241860404946, 8.106268127926292],
            [-15.133151084922437, 8.107786299906577],
            [-15.133897238832045, 8.11191239020165],
            [-15.138565180737181, 8.116354215965034],
            [-15.148339171532418, 8.114165108212493],
            [-15.149024052873363, 8.122409261312336],
            [-15.154693588202719, 8.126818368532872],
            [-15.158476109838722, 8.132159201066107],
            [-15.1632547425153, 8.129173119510783],
            [-15.166525669843802, 8.13039659317685],
            [-15.167278727907346, 8.13414063201685],
            [-15.171439025183966, 8.138965426036375],
            [-15.174892930414476, 8.147322067524573],
            [-15.181271504792418, 8.150084631807204],
            [-15.182468780210668, 8.154534568836612],
            [-15.186096295894703, 8.15382767730489],
            [-15.192603056369412, 8.14688205282493],
            [-15.199848963118415, 8.147436461243572],
            [-15.203075878572134, 8.15067195949701],
            [-15.204728260839213, 8.146675981535061],
            [-15.207316770023347, 8.14540813224922],
            [-15.208003715897199, 8.140313055614142],
            [-15.217973872977659, 8.145363109131129],
            [-15.222869701817853, 8.142613558488982],
            [-15.234204502537139, 8.137783082946997],
            [-15.24210159021265, 8.138246872083629],
            [-15.243429557212176, 8.142468192920925],
            [-15.240622570491917, 8.147320757735427],
            [-15.240324848515447, 8.152806420276871],
            [-15.237723769205122, 8.160002655379014],
            [-15.243120436564006, 8.163312715819739],
            [-15.243731796198759, 8.167389551496129],
            [-15.24731224977014, 8.166882632411621],
            [-15.255036479080099, 8.169267133237293],
            [-15.257842034702605, 8.171888497062872],
            [-15.256931142559694, 8.175177423976539],
            [-15.290968337328962, 8.18401799348809],
            [-15.28783692758237, 8.197845542218788],
            [-15.27103532047683, 8.265713122373638],
            [-15.290878720464425, 8.270522192532942],
            [-15.26285839318462, 8.382164961270218],
            [-15.33768474763946, 8.400138203003301],
            [-15.323392848670396, 8.458642644041491],
            [-15.351341664458833, 8.465352199719547],
            [-15.331063243991204, 8.550022180143806],
            [-15.302842150973355, 8.542724115308603],
            [-15.303988408378942, 8.538103407114596],
            [-15.27472086098496, 8.53061594632044],
            [-15.271075458689038, 8.545079963554636],
            [-15.218667581306459, 8.532092491101515],
            [-15.172954835188216, 8.521841888311004],
            [-15.144851626650231, 8.51517884819944],
            [-15.12774483538037, 8.586153396884235],
            [-15.111538960459397, 8.582365336549072],
            [-15.108406105081583, 8.595389591546136],
            [-15.09432744053294, 8.592077996877228],
            [-15.095968803637447, 8.585008577021172],
            [-15.08394990095308, 8.582222988836214],
            [-15.08529912588795, 8.576075607539915],
            [-15.017902493194013, 8.560287467424232],
            [-15.000252855773143, 8.555858020222727],
            [-15.000591203330579, 8.554463445521467],
            [-14.970742714389516, 8.54724422096122],
            [-14.960798043781113, 8.588816950915623],
            [-14.905122047416722, 8.576082487684785],
            [-14.89489008260051, 8.618315105968833],
            [-14.896285823805691, 8.618654355324452],
            [-14.875408028596715, 8.701189476099254],
            [-14.855388870261956, 8.785726909178804],
            [-14.820879561558385, 8.777438535440679],
            [-14.801403074785332, 8.859209252981648],
            [-14.786844946669987, 8.855889076190888],
            [-14.776778522264216, 8.897700295207644],
            [-14.727896946217216, 8.886133177151688],
            [-14.717915296635171, 8.928121465869856]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.00882449681379,
          "lat": 45.310219242957295
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41061"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01164165"
      },
      "bbox": [
        -15.351341664458833, 8.027705060052046, -14.391763691391677,
        8.928121465869856
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.689017573042511, 9.06341646246679],
            [-14.601120678673317, 9.042681849882696],
            [-14.51322935172644, 9.021923543458026],
            [-14.435905567152039, 9.003222220380689],
            [-14.36920335315343, 8.987440696037554],
            [-14.352423765564994, 8.983174700631904],
            [-14.325137898544309, 8.977756476643734],
            [-14.291780684144948, 8.97016872545435],
            [-14.267318236016017, 8.96236597235918],
            [-14.25577620460146, 8.962101749717604],
            [-14.171027555133966, 8.942697816222982],
            [-14.074468250336954, 8.920302510164104],
            [-14.061892970680189, 8.916835263889066],
            [-14.017460911068879, 8.907092860325736],
            [-13.986929866485346, 8.89962216415433],
            [-13.970354314944897, 8.895086305804204],
            [-13.968661673721197, 8.888139952036452],
            [-13.962583556522114, 8.88061914998469],
            [-13.95879784323947, 8.873284504154256],
            [-13.961470515056861, 8.86711373538501],
            [-13.961035802617598, 8.85723452037858],
            [-13.954294921846895, 8.85422818077242],
            [-13.95211186532841, 8.849603070865866],
            [-13.95397160985453, 8.840506618219184],
            [-13.953164432010078, 8.827587560391825],
            [-13.954473936957145, 8.819170547061232],
            [-13.953847394517096, 8.81211417749285],
            [-13.950314928980598, 8.798391412130805],
            [-13.94357961964589, 8.784886117876542],
            [-13.935640589007793, 8.777203036160893],
            [-13.926773543944876, 8.766296836292694],
            [-13.918602926967448, 8.745203822099333],
            [-13.918022522871455, 8.742717096677485],
            [-13.916061817700877, 8.730275777896727],
            [-13.91910215676766, 8.718461788709066],
            [-13.916673538506462, 8.711300036512494],
            [-13.905453241193761, 8.699938101560393],
            [-13.903082192492048, 8.699000006046955],
            [-13.896570231429424, 8.69996910113408],
            [-13.884899952986276, 8.70514113421436],
            [-13.870647818362823, 8.702620208389787],
            [-13.868234104980791, 8.701580008618738],
            [-13.86004409952791, 8.694310623829683],
            [-13.855638846564883, 8.678646615727674],
            [-13.853705675477741, 8.665347464081533],
            [-13.846123279393197, 8.651963902402517],
            [-13.842655527238886, 8.6492015179706],
            [-13.833643055654555, 8.647030970693185],
            [-13.828761763617583, 8.647441985789202],
            [-13.822778395934463, 8.649885031607017],
            [-13.805233235236962, 8.642055126566273],
            [-13.7975612746453, 8.63787941793278],
            [-13.779692222965837, 8.610371659745361],
            [-13.773153860778583, 8.60646893084139],
            [-13.771866324470855, 8.604405898567027],
            [-13.767988205532392, 8.586628302531372],
            [-13.77370418341096, 8.568340725605347],
            [-13.776887508981199, 8.545562163641216],
            [-13.774222240217444, 8.534600471912993],
            [-13.77209994408209, 8.530260226333603],
            [-13.76574254001655, 8.52137778221304],
            [-13.753430787322273, 8.498009518314063],
            [-13.75455937832842, 8.492721073070536],
            [-13.751848583616502, 8.487695161063291],
            [-13.75341227942352, 8.481636290016246],
            [-13.749031883482562, 8.478770089329265],
            [-13.74677563108317, 8.47420197628256],
            [-13.74849215764793, 8.471754663073003],
            [-13.747309085145156, 8.467166669892496],
            [-13.744026226977699, 8.461578827877482],
            [-13.7468923560538, 8.449040202517155],
            [-13.754321719965496, 8.44139757789003],
            [-13.761792065487645, 8.437239342606636],
            [-13.76472525623222, 8.432481599538487],
            [-13.76562177175301, 8.426999222414384],
            [-13.771157000962855, 8.425657907352253],
            [-13.7813788663746, 8.41988353332801],
            [-13.783410635898168, 8.414598153391129],
            [-13.78866537538221, 8.411541446896136],
            [-13.793544074826448, 8.41258036522388],
            [-13.799958544952585, 8.410877647878028],
            [-13.802418548675224, 8.40751900238096],
            [-13.799945583800232, 8.403660807112994],
            [-13.812664073734382, 8.384616725162799],
            [-13.820716423281482, 8.375339978829093],
            [-13.831151484923403, 8.369543946508838],
            [-13.832483051407038, 8.366779394463956],
            [-13.830548709131365, 8.362195662192406],
            [-13.831023221518105, 8.3590826099876],
            [-13.838044246078729, 8.345672835059773],
            [-13.837225534133806, 8.336998074379016],
            [-13.839240480395665, 8.327435462498173],
            [-13.84610472528521, 8.326130630510672],
            [-13.86042451282563, 8.317913339875341],
            [-13.866395335256811, 8.31306862056091],
            [-13.872633607551753, 8.298655074804895],
            [-13.879218191480714, 8.285307127678086],
            [-13.89716432743, 8.274461818729176],
            [-13.930768640997073, 8.234022724017533],
            [-13.951243446510253, 8.208511146874848],
            [-13.953378123223663, 8.201707679549342],
            [-13.955491876740068, 8.185619185284262],
            [-13.957157565477868, 8.17676888435919],
            [-13.961475748449777, 8.164944148657124],
            [-13.967168877982814, 8.160479937136481],
            [-13.972064853481882, 8.158430093641854],
            [-13.980521085949317, 8.14781404127992],
            [-13.984729605633477, 8.138792344056093],
            [-13.988862349766443, 8.134876451764825],
            [-13.992348466675924, 8.12262454883112],
            [-13.998471484458815, 8.11307971600277],
            [-13.99978291968763, 8.103334215010376],
            [-14.001402549662513, 8.09928398921138],
            [-14.018308682077798, 8.071007597465258],
            [-14.020154069672115, 8.062706594649182],
            [-14.023893419686457, 8.056522053592266],
            [-14.027312418449467, 8.045454308170187],
            [-14.029967348886561, 8.041522529457875],
            [-14.041313427010035, 8.037012698266023],
            [-14.043819862191508, 8.029278690063734],
            [-14.04878263465966, 8.027211343393471],
            [-14.05171469668655, 8.019940078742101],
            [-14.067450607638822, 8.014833758329232],
            [-14.07482889813192, 8.006560285135553],
            [-14.077698944706425, 7.9994109578075605],
            [-14.079515815304203, 7.989795025837481],
            [-14.161639485510332, 8.008442371702285],
            [-14.24376743992152, 8.027070772046178],
            [-14.24364290627556, 8.027619150643902],
            [-14.291059573022679, 8.038625825080914],
            [-14.410857638711382, 8.065922717480099],
            [-14.391763691391677, 8.14899440999624],
            [-14.465491802598393, 8.165646626675233],
            [-14.53643331155134, 8.1817487099759],
            [-14.52674735810307, 8.22369268854106],
            [-14.543632810388358, 8.227714758781703],
            [-14.55710149324302, 8.230398097837647],
            [-14.553811136904038, 8.24370444386111],
            [-14.54822646417974, 8.272776983421634],
            [-14.544976005040606, 8.28653951802017],
            [-14.558730038918963, 8.289364870931413],
            [-14.552206287749073, 8.316867221507703],
            [-14.565863816473835, 8.31990700318182],
            [-14.562800390253697, 8.333777024107881],
            [-14.576477082009557, 8.336866745645247],
            [-14.573632118474375, 8.350617958069694],
            [-14.570312108649889, 8.363814586987441],
            [-14.597989706800925, 8.370224139466009],
            [-14.598285121252415, 8.368887739044094],
            [-14.612447708576624, 8.372215522413606],
            [-14.606015663874357, 8.399646317485702],
            [-14.619538392762431, 8.403181722552047],
            [-14.6059063417941, 8.463633770294694],
            [-14.619328221430353, 8.466736104244106],
            [-14.616372616108304, 8.479820428724047],
            [-14.601596154371814, 8.542277941335016],
            [-14.599814082488864, 8.550456097045288],
            [-14.62943585171649, 8.556807675213538],
            [-14.606270735990115, 8.655218179370745],
            [-14.619117699979563, 8.65781432996184],
            [-14.609240275145964, 8.70028573005909],
            [-14.62360593680885, 8.703077955470492],
            [-14.61680487249517, 8.731313522321637],
            [-14.630942402924038, 8.734533973624977],
            [-14.61240356252587, 8.815397618729463],
            [-14.584679993406745, 8.809122451038021],
            [-14.56464316427484, 8.893150208341835],
            [-14.641277282349952, 8.910644711518612],
            [-14.717915296635171, 8.928121465869856],
            [-14.721075134363817, 8.928863448121618],
            [-14.689017573042511, 9.06341646246679]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.18103434899537,
          "lat": 45.579870147009146
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41063"],
        "coty_name": ["Wallowa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wallowa County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01155135"
      },
      "bbox": [
        -14.721075134363817, 7.989795025837481, -13.744026226977699,
        9.06341646246679
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.634217914836224, 4.004224246421085],
            [12.647793522971794, 4.006758996570753],
            [12.714416675751448, 4.019737676579126],
            [12.79461492768706, 4.033771408944987],
            [12.858215159070916, 4.045636934770617],
            [12.941011620971423, 4.06037253611979],
            [13.040461027743326, 4.075208528978541],
            [13.047614937427609, 4.030549458268185],
            [13.056247172604472, 3.9781100782170675],
            [13.071879713023007, 3.890578106788098],
            [13.05894204178947, 3.888139734523832],
            [13.056284316935242, 3.9027810671961034],
            [12.99245557477444, 3.8927590419635827],
            [12.996620827626396, 3.862842805992522],
            [12.975784026341428, 3.8591960385902073],
            [12.984638094700806, 3.8040570862903738],
            [12.989414634027112, 3.7772123832107725],
            [12.98572547945321, 3.778521943961262],
            [12.982015910466405, 3.7767726297577946],
            [12.981275700602867, 3.7714089853172554],
            [12.98419840522153, 3.7667233456603433],
            [12.983992055963585, 3.761979502780604],
            [12.979883381561864, 3.7595191748874317],
            [12.970026069573214, 3.7638233736995494],
            [12.96252462819118, 3.770658269401252],
            [12.956508998573685, 3.772107807719627],
            [12.952057144734715, 3.761324446796804],
            [12.947825142650062, 3.7574953211724127],
            [12.941611759649605, 3.7596323270910834],
            [12.940716949597281, 3.763025213579053],
            [12.942008816272352, 3.7679970572212835],
            [12.93655918864364, 3.771028858458515],
            [12.935287130690687, 3.7664939642248654],
            [12.938573618815095, 3.7577102327914242],
            [12.93585437323758, 3.7525571375064137],
            [12.932843190719693, 3.753091405074787],
            [12.931560713751507, 3.7620685795277025],
            [12.927694736549954, 3.764647131741436],
            [12.922622400857385, 3.761843736273453],
            [12.924786053285251, 3.753251653269559],
            [12.920919806657476, 3.7481327794898593],
            [12.913119959513066, 3.7494008673144914],
            [12.907548298637918, 3.753589229770981],
            [12.895134954192926, 3.8291240368697914],
            [12.891232422063554, 3.8518825610299747],
            [12.88560530967704, 3.851094866707552],
            [12.780813314595632, 3.833845052128735],
            [12.780147648641005, 3.8376163007612947],
            [12.749150566862856, 3.832062997739242],
            [12.751999205840201, 3.813451682175621],
            [12.757454834443767, 3.7828998164212186],
            [12.700741883431625, 3.772836203040504],
            [12.691138643505198, 3.825937687565257],
            [12.65924290074394, 3.820785337594675],
            [12.654643370403559, 3.8451615267718404],
            [12.661779113782423, 3.8464302175606986],
            [12.655357191705976, 3.8873537597870635],
            [12.634217914836224, 4.004224246421085]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.23604170669233,
          "lat": 41.512995251908904
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42053"],
        "coty_name": ["Forest"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Forest County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01213669"
      },
      "bbox": [
        12.634217914836224, 3.7481327794898593, 13.071879713023007,
        4.075208528978541
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.045337343156369, 4.181385071146426],
            [14.150346790929198, 4.2033271348398635],
            [14.264071811851176, 4.2266838616910825],
            [14.266839909867016, 4.226941149141153],
            [14.340537977561764, 4.243349943073496],
            [14.472598268596284, 4.274054642393347],
            [14.50891276974602, 4.282973715411936],
            [14.508335931379477, 4.2896060571541295],
            [14.511937235517607, 4.2976043745727965],
            [14.517856732513758, 4.303185229513175],
            [14.525282502186158, 4.304351176413489],
            [14.529511403569648, 4.307361185368652],
            [14.530713498433265, 4.317803780333303],
            [14.533823727111645, 4.320143217062035],
            [14.54062168489504, 4.320251616958907],
            [14.55567484828484, 4.329678847353134],
            [14.560687172229818, 4.3336430923461595],
            [14.562034090616566, 4.340452292222408],
            [14.60776769933029, 4.342709091685529],
            [14.619550992864962, 4.318959526187282],
            [14.630718634195853, 4.295680309043829],
            [14.661787868240214, 4.2323346370916],
            [14.691867651595107, 4.170664198321922],
            [14.695289064716288, 4.168397271951883],
            [14.739830265159137, 4.144133938475485],
            [14.82696324220479, 4.094531311873974],
            [14.8613544084348, 4.092802503554766],
            [14.861397611348298, 4.0901549395633054],
            [14.882993929123064, 4.089587391941339],
            [14.898582434473639, 4.090001306282051],
            [14.938626289174463, 4.088208176798117],
            [14.931236295280405, 4.075597160039782],
            [14.909211524986127, 4.039188226350342],
            [14.897163511442724, 4.016561375131406],
            [14.856916270255944, 3.950269815893371],
            [14.822065622647235, 3.940912112196193],
            [14.794579634406064, 3.933666239046039],
            [14.753515973140757, 3.9434176748915504],
            [14.751527289447575, 3.9431731089771884],
            [14.708259334312586, 3.9381050404915117],
            [14.684374839938535, 3.9239247780872257],
            [14.682941686809086, 3.922717670238266],
            [14.66234084267836, 3.9163221029327966],
            [14.653299550558783, 3.910799834082326],
            [14.643662502774614, 3.9058044548377766],
            [14.640964712033547, 3.900009296768432],
            [14.63860598722928, 3.886269197734517],
            [14.589720380062568, 3.8863370163229822],
            [14.588967161781603, 3.823656867559361],
            [14.523335647740243, 3.8076830277726956],
            [14.498936374642891, 3.7896021162631888],
            [14.49314036964182, 3.7849839318301477],
            [14.470987311298364, 3.7803393637689684],
            [14.456229051072476, 3.7772450361445267],
            [14.375641025469264, 3.8472479900924434],
            [14.365906319395176, 3.8553269870931155],
            [14.35674091862543, 3.863886278823452],
            [14.355850479102518, 3.866692658390658],
            [14.351212646542793, 3.8709958858221913],
            [14.342752670515297, 3.871825694228783],
            [14.338586221876247, 3.8745689387513984],
            [14.337246773789406, 3.8790161922246615],
            [14.338700087685172, 3.8834395724602238],
            [14.331373008262192, 3.8879991520446238],
            [14.324589508399539, 3.8939420527507735],
            [14.311820399586937, 3.902536580788993],
            [14.301701673982755, 3.902110670128097],
            [14.290496041701926, 3.8993151587189536],
            [14.29075688720955, 3.9026257129681468],
            [14.288836939810867, 3.9081687826131946],
            [14.282336953135903, 3.9086477628323437],
            [14.27832506832951, 3.910911298481635],
            [14.273117079404813, 3.908956543714963],
            [14.254981059369607, 3.92085441639036],
            [14.247935465723904, 3.9248607220952003],
            [14.243008554388712, 3.929132610755262],
            [14.236851990454431, 3.9361695959943592],
            [14.232108676742465, 3.9391638387483954],
            [14.225061103957918, 3.9408953379190232],
            [14.220034123793445, 3.9491669157647116],
            [14.21601819277177, 3.9508241444797854],
            [14.209980286243146, 3.951232761086082],
            [14.206700737088923, 3.9530111219580193],
            [14.20152043084574, 3.9588573724330858],
            [14.195873938606113, 3.9674634817695984],
            [14.18610057851034, 3.9714721339882586],
            [14.183159840667086, 3.9740261872160723],
            [14.177966618958925, 3.9865358480524975],
            [14.175554018317168, 3.9972959521407314],
            [14.16663669205986, 4.003360276389651],
            [14.154449592530883, 4.009850071451947],
            [14.142229554078616, 4.009409417179601],
            [14.13411830298215, 4.01054306633589],
            [14.12607821046361, 4.014451139682529],
            [14.122413152226283, 4.018055196012672],
            [14.118464986115299, 4.0308013855555185],
            [14.109394648176135, 4.043910430807321],
            [14.095905541015302, 4.058537792146525],
            [14.090022280713688, 4.060723195402706],
            [14.085919410281631, 4.0657195122030725],
            [14.0797020628744, 4.078821541404522],
            [14.075576282222148, 4.083875914380075],
            [14.066419094999073, 4.0818333083537555],
            [14.058525287845859, 4.118724209270362],
            [14.046169120782851, 4.176399169513595],
            [14.045337343156369, 4.181385071146426]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.0645284454526, "lat": 41.34337402445848 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42081"],
        "coty_name": ["Lycoming"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lycoming County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01213677"
      },
      "bbox": [
        14.045337343156369, 3.7772450361445267, 14.938626289174463,
        4.342709091685529
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.074289619022837, -5.080168713608642],
            [13.094926999660812, -5.037402924717889],
            [13.09740672779707, -5.034620404128838],
            [13.103213581921665, -5.031507144038489],
            [13.105576413266007, -5.03624841621347],
            [13.11085138913694, -5.036206868050077],
            [13.11568441559362, -5.038932603412155],
            [13.117353869129845, -5.036832612795737],
            [13.120819063012988, -5.043786644053023],
            [13.125021189209955, -5.0416207522880345],
            [13.127717903190971, -5.045299984959291],
            [13.130336577354901, -5.043341545358449],
            [13.138894470966571, -5.042883192604804],
            [13.141557530324336, -5.045947321697784],
            [13.144170910696523, -5.0427235832158015],
            [13.14695516783094, -5.043026642190284],
            [13.147045182100292, -5.048405661099163],
            [13.153095644882802, -5.051294737675862],
            [13.159938082322231, -5.051774206282338],
            [13.16339341540766, -5.047128216625247],
            [13.168423766282581, -5.0514137857849954],
            [13.175291807960457, -5.0504566973869816],
            [13.17819282546746, -5.045904392878568],
            [13.178656531220035, -5.0417177215686495],
            [13.185081481345732, -5.043444852036119],
            [13.18701325560612, -5.047998075846739],
            [13.190641782404693, -5.047269134889519],
            [13.191212403590356, -5.043748181354213],
            [13.196362839357118, -5.041704289967976],
            [13.198496210806706, -5.046777985542572],
            [13.202163777451037, -5.047517070797463],
            [13.207164202099097, -5.046309825536798],
            [13.209578190056071, -5.053943533414041],
            [13.211178340633944, -5.0544491082990834],
            [13.221721467525692, -5.050019930441644],
            [13.224269453606947, -5.043986875540092],
            [13.233824542590098, -5.042842249101929],
            [13.238281076146116, -5.044540103305299],
            [13.240423946794879, -5.048750672486951],
            [13.238311959760447, -5.0530509060858355],
            [13.23029482696154, -5.053121523390314],
            [13.228556539752967, -5.054836334271784],
            [13.227810134041462, -5.060374614582162],
            [13.233736086006761, -5.071782276111344],
            [13.237091996393795, -5.072679006579191],
            [13.244695315795429, -5.0681885348959295],
            [13.249842341898855, -5.069814508420449],
            [13.252295016036744, -5.073351109110362],
            [13.251385690711986, -5.079121952743666],
            [13.242390098935982, -5.080485837689452],
            [13.239671231230231, -5.08346694821755],
            [13.240821172054623, -5.0896466781116505],
            [13.246725322292328, -5.091076161788908],
            [13.251450896406817, -5.085899875198595],
            [13.2550550549853, -5.083950150210865],
            [13.258436945927656, -5.086789688214187],
            [13.254954808494874, -5.094635179126126],
            [13.255566186477095, -5.0999428446829596],
            [13.268060363745994, -5.114471890404254],
            [13.271323123499409, -5.115920422427061],
            [13.28028574122248, -5.1162654896813935],
            [13.284028580131418, -5.1176314928862805],
            [13.286959598621932, -5.123870154273234],
            [13.292797053148988, -5.125851438792256],
            [13.29445446010434, -5.124527406614183],
            [13.299014341437559, -5.116039416626925],
            [13.302794613064345, -5.116150051093479],
            [13.307304018767441, -5.122907822131026],
            [13.310263225950118, -5.123164993613963],
            [13.320535655817626, -5.116289795741698],
            [13.326237298806742, -5.117288022175935],
            [13.329969541783505, -5.119938783996712],
            [13.330328992105393, -5.123230805605403],
            [13.325332905895413, -5.131180845021443],
            [13.32670244421218, -5.1355575565573375],
            [13.332069474730558, -5.135828510226658],
            [13.339490951258279, -5.1332294686214315],
            [13.342158163597027, -5.135423131151856],
            [13.340169134472141, -5.143140910708103],
            [13.34074611056298, -5.146700693818541],
            [13.346040129776119, -5.1478738849195045],
            [13.348241746559115, -5.143198797877151],
            [13.347259106266629, -5.137212339412248],
            [13.347727029812676, -5.132129849384896],
            [13.352672416460834, -5.131756709840731],
            [13.357319772038545, -5.140200868323043],
            [13.364588084895566, -5.1504016337250045],
            [13.371047159947128, -5.165847384564874],
            [13.377697971511836, -5.171329664221223],
            [13.388182003237613, -5.1732833567094625],
            [13.400636830792077, -5.188198712269949],
            [13.404274075325718, -5.1944830615994295],
            [13.419199636367033, -5.199909170875584],
            [13.427380284837264, -5.201052567854191],
            [13.425468892766215, -5.211371342604053],
            [13.428919027302056, -5.214442633681032],
            [13.430378498117243, -5.218355050276392],
            [13.428534359014117, -5.222638014968179],
            [13.425108531585705, -5.226259829808851],
            [13.431908890332457, -5.240591980661074],
            [13.43577316744697, -5.243537094663748],
            [13.441962125902132, -5.251113502878598],
            [13.445050653836773, -5.259233066589796],
            [13.452088886561743, -5.270625666854718],
            [13.455859422202014, -5.272673991367253],
            [13.467705727778917, -5.269708844205869],
            [13.469231014094968, -5.267319827373579],
            [13.473672861379866, -5.2675176102114065],
            [13.480063934465466, -5.273479006769588],
            [13.481843989121229, -5.279505000457724],
            [13.482607666837142, -5.2891757029708355],
            [13.479452226779971, -5.3045350522884025],
            [13.47719128343755, -5.312199352053136],
            [13.475931842482844, -5.325515368533632],
            [13.470380046218215, -5.342324107930268],
            [13.465984510938236, -5.341128836111078],
            [13.462251569484566, -5.342806185271495],
            [13.464112672156007, -5.349289578416678],
            [13.47154870750998, -5.354791070358727],
            [13.473809051566153, -5.359366247905291],
            [13.468700043722128, -5.361392544671572],
            [13.454038062358942, -5.369997539418268],
            [13.438163062203177, -5.381212028521388],
            [13.434204109613722, -5.380493198599978],
            [13.42098269760858, -5.390652997924938],
            [13.408062759462092, -5.402225050783765],
            [13.40332794759353, -5.402957989008765],
            [13.400639718025426, -5.40818392839237],
            [13.389298055129373, -5.414981985916032],
            [13.387048044726853, -5.417731145283645],
            [13.379404286998101, -5.4221099278018325],
            [13.368064207399179, -5.416482719174724],
            [13.363112087984339, -5.420243012390678],
            [13.354816127371736, -5.428929494050133],
            [13.353394531281902, -5.43384741936508],
            [13.345328580758537, -5.440864336246205],
            [13.34280978499217, -5.445532168679124],
            [13.335288310686266, -5.447903599267374],
            [13.324342613480564, -5.445698546631237],
            [13.32277192151975, -5.441674701918517],
            [13.324382331174373, -5.433567682378504],
            [13.320045033072452, -5.418786222914788],
            [13.319880410646887, -5.415350158143722],
            [13.299388313873248, -5.412244843555223],
            [13.295019087585949, -5.414388303277915],
            [13.28175221406741, -5.410017025388483],
            [13.27224123607172, -5.4036373183779],
            [13.270523165112415, -5.3992762245623585],
            [13.262107494995787, -5.392016628024748],
            [13.256441469263251, -5.390983081970924],
            [13.250276484894737, -5.392943816270839],
            [13.241641929449422, -5.39964505317674],
            [13.23826441691504, -5.405972012574395],
            [13.24091388920588, -5.413389109908467],
            [13.23673343456982, -5.4167123217982125],
            [13.227231919506822, -5.414790289072845],
            [13.219064976948074, -5.430515402130512],
            [13.22064603199767, -5.436988192159385],
            [13.225050120020697, -5.442288686149147],
            [13.230539333045483, -5.445560067415323],
            [13.235545916129109, -5.45017297365651],
            [13.243353629996893, -5.455841493246586],
            [13.24684137244439, -5.45487169789759],
            [13.248130608431364, -5.45191254210951],
            [13.254951866448856, -5.447091728985273],
            [13.259136087940663, -5.449526700403115],
            [13.263235207325495, -5.449381990846202],
            [13.274856038570872, -5.458468870491954],
            [13.286826548951007, -5.465837089268328],
            [13.292884195240113, -5.467687653865357],
            [13.301338073103299, -5.474210592705789],
            [13.307120570554286, -5.4802702071243],
            [13.312156130949719, -5.488400806688446],
            [13.31019421483936, -5.496092253981611],
            [13.299688008067484, -5.508125025889503],
            [13.290521729327413, -5.524678311282806],
            [13.281984464544783, -5.546070161363921],
            [13.27723974249285, -5.554852399148453],
            [13.271544437258564, -5.563762949316136],
            [13.264267774306111, -5.571696346859091],
            [13.241424782550816, -5.58953722593734],
            [13.226423844775347, -5.601736071397411],
            [13.209737959837257, -5.6173296455068975],
            [13.20241155587909, -5.619676519639404],
            [13.195959808197433, -5.616017020093645],
            [13.183549127485895, -5.613329382652434],
            [13.180330726205565, -5.622904915436206],
            [13.1728879538929, -5.633528219486223],
            [13.164401888972218, -5.651803037552717],
            [13.158714619003117, -5.654581759085621],
            [13.148815251885276, -5.655778186476445],
            [13.142634999336032, -5.660509280913428],
            [13.138986723679597, -5.661923427516242],
            [13.1351946672151, -5.6612294164146855],
            [13.131180645524203, -5.657164612140125],
            [13.13187416577032, -5.651890871606747],
            [13.14089877733204, -5.635634306551395],
            [13.140865109163311, -5.630416185592512],
            [13.136153086626875, -5.627202102271548],
            [13.112974814950064, -5.622957495227053],
            [13.112384031329501, -5.618410469685796],
            [13.123590020425157, -5.613019995643647],
            [13.127510537601571, -5.608931993307701],
            [13.125087033635822, -5.605547978780483],
            [13.120406825509246, -5.606190339903633],
            [13.116095040201774, -5.611724987781641],
            [13.11276593859659, -5.6112187888210725],
            [13.109655115659603, -5.604572780826207],
            [13.10457129750952, -5.608480318211979],
            [13.098166471632718, -5.607207810350023],
            [13.094860540287124, -5.616321722409577],
            [13.08899901376599, -5.6145063100534855],
            [13.083161047358304, -5.620839204146832],
            [13.08168615227661, -5.61395510805391],
            [13.084223146970869, -5.609019602272846],
            [13.078946640421771, -5.609139389379254],
            [13.073952931979383, -5.605118912966266],
            [13.073849297153112, -5.59893040009537],
            [13.076226121045067, -5.596068426263455],
            [13.0810566287763, -5.596854177277004],
            [13.081032843128567, -5.6003980908272055],
            [13.087765089209233, -5.604580578793843],
            [13.088862765846402, -5.600489222573507],
            [13.08548801051091, -5.597485285556038],
            [13.087631330176261, -5.5894696450861],
            [13.086723828531834, -5.584781002089722],
            [13.081066706807455, -5.58301269462828],
            [13.080870469367133, -5.5806775579647985],
            [13.086104649336768, -5.579311031520437],
            [13.081500757392872, -5.571329774877504],
            [13.076636633848038, -5.573532823664753],
            [13.075515247308367, -5.568857612567027],
            [13.068715891868338, -5.57250003829301],
            [13.068691129591333, -5.568407416386765],
            [13.073819760758745, -5.565765682726386],
            [13.071029940000349, -5.562846448421371],
            [13.067971865950454, -5.565637555074611],
            [13.065766895671386, -5.563541096895526],
            [13.059529644969475, -5.5640515879173],
            [13.05850250630303, -5.560336722261072],
            [13.05261828751105, -5.55862389762614],
            [13.048933932255459, -5.561434540583072],
            [13.039940390962531, -5.5568930159489955],
            [13.042553910828804, -5.551944774154949],
            [13.037888753010218, -5.546279489154227],
            [13.035134586293188, -5.547153311285734],
            [13.031891817019531, -5.54087949095448],
            [13.031824078134944, -5.538173236074687],
            [13.026281661885983, -5.536657808606817],
            [13.026018912127546, -5.533076730031456],
            [13.022653534518035, -5.5243377467497865],
            [13.023148284605021, -5.52119384568132],
            [13.019056550457302, -5.5113982593688595],
            [13.022934112157662, -5.505160645300129],
            [13.02734155430859, -5.503601632290686],
            [13.03325920034037, -5.491212114896188],
            [13.034214667643573, -5.480192691425259],
            [13.030005389161362, -5.476340615329481],
            [13.028634262353117, -5.4723568474195785],
            [13.029944778082594, -5.462798481927326],
            [13.025068973961277, -5.455991466278493],
            [13.01984003539257, -5.454022988235926],
            [13.017325276148005, -5.448621930627905],
            [13.037932194296785, -5.446015612366885],
            [13.077647128745854, -5.445545231920408],
            [13.076752599513688, -5.441284066349773],
            [13.074984480338472, -5.424642002822401],
            [13.077709752115688, -5.414537955557447],
            [13.07684907949379, -5.400114710429367],
            [13.078380646897592, -5.394567519794248],
            [13.080272644613379, -5.392700105527672],
            [13.090100439733375, -5.388588756042857],
            [13.10471964447904, -5.386879281474937],
            [13.106681133585363, -5.392840034201869],
            [13.11796350212476, -5.392701901298971],
            [13.117823642161877, -5.383059307774508],
            [13.118539705800988, -5.379102746862324],
            [13.122678574160101, -5.373878225246475],
            [13.117492122399007, -5.369300615650201],
            [13.12690555646756, -5.363281154865794],
            [13.12816214101909, -5.356806464436174],
            [13.13505340910162, -5.35604342382821],
            [13.136567699944841, -5.351159457921226],
            [13.141321684578603, -5.349427949464066],
            [13.141716483977952, -5.346790388258683],
            [13.139169905998362, -5.3411633288016125],
            [13.144025180818263, -5.33085235116995],
            [13.147603727538447, -5.3214803708068885],
            [13.14240139323742, -5.318821839039759],
            [13.138059504601472, -5.320249553231208],
            [13.1344736501934, -5.3238840721349305],
            [13.13204711213926, -5.323798034950026],
            [13.129458949325068, -5.319482092675041],
            [13.128796097543033, -5.312911987517864],
            [13.129480148051037, -5.3066169105181675],
            [13.136460106171471, -5.277206596234615],
            [13.138747039038837, -5.271563350132685],
            [13.147958618275334, -5.268218042293482],
            [13.147619041571753, -5.259495458315631],
            [13.1455650686992, -5.251002043809454],
            [13.142390199382072, -5.241875761742924],
            [13.138799714205918, -5.235960183008554],
            [13.133812591489239, -5.231149771893441],
            [13.124944997070083, -5.21690794138204],
            [13.113343306791485, -5.206699692245775],
            [13.12004998600697, -5.196271821894229],
            [13.120305661590942, -5.18839549268634],
            [13.116015505417932, -5.178424183275543],
            [13.11836036854992, -5.171270740248943],
            [13.117468494997258, -5.163224650083008],
            [13.115273569243973, -5.156977992369322],
            [13.115288357682692, -5.150577933278317],
            [13.116622652488315, -5.141926912189895],
            [13.112331215100605, -5.136639900308473],
            [13.110013474452124, -5.127303608079496],
            [13.09921826032282, -5.122933143805415],
            [13.097344477346429, -5.119827116764781],
            [13.099827290937876, -5.114080351982725],
            [13.097238888342522, -5.108144181415992],
            [13.081852218012184, -5.093900493414107],
            [13.078134330644557, -5.085928196997979],
            [13.074289619022837, -5.080168713608642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.73060607994628, "lat": 32.38572412435094 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45013"],
        "coty_name": ["Beaufort"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beaufort County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01247984"
      },
      "bbox": [
        13.017325276148005, -5.661923427516242, 13.482607666837142,
        -5.031507144038489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.9523655751553766, 4.861896488060562],
            [-3.872663374428931, 4.85709962028944],
            [-3.864895700204326, 4.855965674967393],
            [-3.8223272649809403, 4.85308763967767],
            [-3.782479906601613, 4.851144158569376],
            [-3.781730727536709, 4.850607394472975],
            [-3.6980103952690238, 4.845079633716308],
            [-3.6054840066987124, 4.839666787051264],
            [-3.5129587172260353, 4.834235164036976],
            [-3.510404330878679, 4.8342010384067375],
            [-3.412844253621417, 4.828743423909871],
            [-3.3152853482771225, 4.8232649412011765],
            [-3.3176774617536346, 4.779450637924841],
            [-3.3239459608689135, 4.663408161368577],
            [-3.3279783823443503, 4.590872916445835],
            [-3.336748808254025, 4.431772394303199],
            [-3.4777709891286004, 4.439122745214259],
            [-3.5346093303370076, 4.4421543981224305],
            [-3.6254211206721316, 4.446578953104414],
            [-3.689397575272638, 4.450771931790908],
            [-3.78826052938638, 4.459496228911805],
            [-3.872642627032079, 4.464805089666701],
            [-3.957025662667998, 4.470099097290037],
            [-3.9564920517634405, 4.4747041460751555],
            [-3.9483724582798128, 4.590343894187099],
            [-3.9479103676089085, 4.599909407376642],
            [-3.9678018870043243, 4.601261015914572],
            [-3.962646592294735, 4.688441299997087],
            [-3.9533856511107013, 4.843136757008107],
            [-3.9523655751553766, 4.861896488060562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.66403435767899,
          "lat": 43.19497980224243
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46007"],
        "coty_name": ["Bennett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bennett County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01265812"
      },
      "bbox": [
        -3.9678018870043243, 4.431772394303199, -3.3152853482771225,
        4.861896488060562
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.317026270067634, -2.8106313623125607],
            [9.321296810936865, -2.806825995149893],
            [9.330616222826842, -2.793868960303698],
            [9.333259691827722, -2.791431466656264],
            [9.339327370902668, -2.7813927904594897],
            [9.342882993453705, -2.7770226150617945],
            [9.343067960186591, -2.772334243078012],
            [9.340693560626404, -2.765914486542815],
            [9.337519648786468, -2.761007979765703],
            [9.335925868635758, -2.7550045309751283],
            [9.337581114922848, -2.7476045645764944],
            [9.340784120771614, -2.7458084988931653],
            [9.345058534684847, -2.7462241556552773],
            [9.348583119126664, -2.748556210238491],
            [9.355273259836949, -2.761985087193284],
            [9.360777572547871, -2.7680397364170304],
            [9.370268882971596, -2.7734259483987347],
            [9.381470957638514, -2.7746543491821813],
            [9.388345356476055, -2.773646886389428],
            [9.39484407720451, -2.7694370002980624],
            [9.398569136189524, -2.7651453987566685],
            [9.400754226870081, -2.760634142339829],
            [9.402260483003218, -2.7536534740952097],
            [9.399668340443109, -2.7371146413825613],
            [9.401139408731533, -2.730955638847708],
            [9.40568178359876, -2.7253497378581675],
            [9.41169629961113, -2.7219035927283506],
            [9.421926157758692, -2.7183687784488813],
            [9.427652917729588, -2.7144131287728004],
            [9.431105683688477, -2.710085103697904],
            [9.433493603368703, -2.7045710173663813],
            [9.432680089671274, -2.696203338054411],
            [9.430201608428542, -2.6921241246073384],
            [9.424303963370908, -2.686992600398205],
            [9.415129427830943, -2.6815118580850474],
            [9.411976034075842, -2.675819696178211],
            [9.411038758538671, -2.670414246493492],
            [9.411453790598426, -2.664762708293752],
            [9.414893952566603, -2.656027916670988],
            [9.41777122292638, -2.6528411730537513],
            [9.423980039903403, -2.6504316756553195],
            [9.428919285366538, -2.6504291250133476],
            [9.462278272972714, -2.6553455602350162],
            [9.47290578032953, -2.6525176027477104],
            [9.477270256062665, -2.6477761994918936],
            [9.47831297415085, -2.64314136033657],
            [9.476868869325017, -2.6390696934965105],
            [9.473501538382177, -2.635634518232025],
            [9.465448306662221, -2.6311809455523285],
            [9.461807456738685, -2.624783496819024],
            [9.462387205783239, -2.617703578164338],
            [9.468207268082233, -2.611694050568157],
            [9.47830636553065, -2.6065517880027946],
            [9.482952740786692, -2.6027514434525676],
            [9.486349581329675, -2.596291212682859],
            [9.48615942618222, -2.5887729059758953],
            [9.484421966049188, -2.583857820370381],
            [9.475953866210853, -2.5704337491194282],
            [9.475290817282357, -2.5651191438901697],
            [9.476294125661337, -2.5603410674775344],
            [9.480287978246038, -2.552513494205967],
            [9.48018270449984, -2.5472899991404905],
            [9.478081884780797, -2.540968050381111],
            [9.474002554708612, -2.523508788560176],
            [9.473945436997868, -2.5189504080368756],
            [9.475634304904982, -2.5141668339736056],
            [9.48192015803664, -2.5068300756967243],
            [9.483268958723004, -2.4958653214425635],
            [9.48661416736037, -2.493743533337191],
            [9.493572610779665, -2.495801616999438],
            [9.497638670433734, -2.5011459738376978],
            [9.498344948307336, -2.5071878780973256],
            [9.497345377909456, -2.5140313592227557],
            [9.501146308223944, -2.515928930742333],
            [9.504719645770141, -2.5150087758142203],
            [9.518937127316725, -2.5021697975911055],
            [9.520550885732797, -2.4967083974539275],
            [9.5169705075343, -2.484886645004307],
            [9.518473107658961, -2.4763934981618045],
            [9.523794925689922, -2.465691504577478],
            [9.523477473695415, -2.460612131693019],
            [9.521221678244348, -2.4547210564056905],
            [9.511950696057323, -2.441676020805649],
            [9.51089545887602, -2.438934379444],
            [9.512807915013594, -2.439377735529089],
            [9.52007904234349, -2.4489175499202127],
            [9.532534708588432, -2.4476064646420808],
            [9.53362957920737, -2.4567215814898695],
            [9.536258605182034, -2.456431078940715],
            [9.537015272064933, -2.464219815372955],
            [9.534440784933269, -2.4644266350031305],
            [9.535150292475656, -2.4716066369068774],
            [9.55292183777058, -2.4698569907502788],
            [9.553829401365205, -2.476870112733757],
            [9.55742955265608, -2.4765481062886034],
            [9.55811733849237, -2.484016940301909],
            [9.565077625422422, -2.483291514323715],
            [9.564448135375518, -2.4758887836774255],
            [9.571505864055656, -2.475231224020457],
            [9.570674630985279, -2.467942933525194],
            [9.57794446274082, -2.4672755154261377],
            [9.577225516974217, -2.4599025980923734],
            [9.584243796734308, -2.4592108360048472],
            [9.58465083009902, -2.463128196380132],
            [9.596355506336225, -2.4704642396363115],
            [9.596885314511306, -2.4743129735264033],
            [9.600022979593495, -2.47397851343921],
            [9.600613443072948, -2.4784708128851776],
            [9.59754541979187, -2.4824015912259956],
            [9.60145939313227, -2.487049831938129],
            [9.594948147703906, -2.4926248520346506],
            [9.598323144994314, -2.5205155671335313],
            [9.60046506364943, -2.523690130308006],
            [9.605252642669582, -2.5231189030644674],
            [9.606977865125314, -2.5373435384073217],
            [9.59963679079919, -2.5429314905415352],
            [9.599783822561152, -2.546196310668481],
            [9.597199366864407, -2.553657310944856],
            [9.59456544905692, -2.5575878215173833],
            [9.591614750618776, -2.5579469132110777],
            [9.588215451176053, -2.568646247018589],
            [9.581480445011188, -2.5829508367660527],
            [9.581391592757953, -2.588418222489732],
            [9.576080411724696, -2.5913221043466357],
            [9.576305115408372, -2.597228970026174],
            [9.56541922853695, -2.6086055051341894],
            [9.561032622753984, -2.608852567745899],
            [9.559980987546476, -2.625128812810926],
            [9.55630857314207, -2.6282583506168384],
            [9.556864850147258, -2.6310078231349956],
            [9.551926737157764, -2.6383474554662234],
            [9.55031724367185, -2.6430697055965897],
            [9.549839060716135, -2.649057728761919],
            [9.546693529095636, -2.6528108603133296],
            [9.546463160208647, -2.656070208945771],
            [9.543480820390227, -2.658956115396001],
            [9.53772638012293, -2.670784337134542],
            [9.531924580202448, -2.672230034135036],
            [9.524829304531485, -2.682724226797549],
            [9.52112964610925, -2.6834978417846567],
            [9.519412200269093, -2.687968726182048],
            [9.520301720990231, -2.694068386409267],
            [9.51623234275503, -2.698807264368176],
            [9.513428116469811, -2.70939070943696],
            [9.507275396192176, -2.711642979925705],
            [9.505346780817533, -2.715931184215629],
            [9.50602612241604, -2.7243775489713085],
            [9.502160781537594, -2.731534716979763],
            [9.498848208233445, -2.733753865529155],
            [9.49409086750475, -2.7334038644877046],
            [9.491164876647685, -2.7409543725602914],
            [9.488985114979918, -2.7431404077356794],
            [9.485510678644427, -2.74262891045083],
            [9.484040171642764, -2.746047084676734],
            [9.485129393936107, -2.7503945213923364],
            [9.481740754685486, -2.7513025048054285],
            [9.482630587512316, -2.75606824141221],
            [9.486337646086826, -2.757152146829548],
            [9.485909146032176, -2.761770285673231],
            [9.483589054198951, -2.763465219509078],
            [9.475899151973405, -2.7637649083466256],
            [9.472034209585312, -2.775788146289528],
            [9.47110766580868, -2.7817686232888086],
            [9.476181739591533, -2.7840250940359916],
            [9.47219399108839, -2.7936280722641986],
            [9.466349367612802, -2.797869879864818],
            [9.458394084411616, -2.819189599926302],
            [9.454868106164373, -2.8306771890210465],
            [9.452763221480257, -2.834261912523001],
            [9.453293732478503, -2.837758643383851],
            [9.451724602883493, -2.8490639647039617],
            [9.449562675086604, -2.855037277612661],
            [9.440316855871927, -2.8501463926481194],
            [9.434687387673375, -2.8488748946921705],
            [9.433216665769475, -2.855744450011011],
            [9.439188480802095, -2.857375603066362],
            [9.43284712745936, -2.878206213319858],
            [9.40378676968918, -2.920665856256494],
            [9.398805940650206, -2.917090089227463],
            [9.391474845593514, -2.91500364109635],
            [9.38766511206522, -2.925544994863838],
            [9.385769327026289, -2.9221034326998],
            [9.377334985703314, -2.9145199099631225],
            [9.37076730983218, -2.9045930912036435],
            [9.367250458503207, -2.8935142169021377],
            [9.36255484699635, -2.8859116005161534],
            [9.36165363376442, -2.8759296121861766],
            [9.356630862326579, -2.868749116047107],
            [9.356239325331746, -2.8580461557195083],
            [9.351972946894866, -2.853571968353878],
            [9.342959548679188, -2.8507946442203056],
            [9.337435472590515, -2.8445933033309196],
            [9.333325619846594, -2.837896712094136],
            [9.326691600419, -2.8357289823563145],
            [9.322568252751116, -2.847737785207474],
            [9.315504806466441, -2.8456929156901425],
            [9.309508892434382, -2.8419130257025795],
            [9.311650707441656, -2.8354773096023984],
            [9.310336858126316, -2.8177244077029746],
            [9.31202946595223, -2.812136687652819],
            [9.317026270067634, -2.8106313623125607]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.81327693347592,
          "lat": 35.512884814656374
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47121"],
        "coty_name": ["Meigs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meigs County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01639775"
      },
      "bbox": [
        9.309508892434382, -2.925544994863838, 9.606977865125314,
        -2.438934379444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.3721722101568785, -3.0351346233004866],
              [5.378835673899544, -3.0303527837626736],
              [5.383699855729864, -3.0220753417750164],
              [5.387815652894143, -3.0038637814669915],
              [5.386595933756683, -3.001196848319517],
              [5.392528058970442, -2.9935432794843284],
              [5.388260519159503, -2.988793559065743],
              [5.393812037982303, -2.9846951923368006],
              [5.397852397254227, -2.9854021915746727],
              [5.404022229251066, -2.9820830710097233],
              [5.407289710343177, -2.985259806552102],
              [5.410881120974093, -2.978350310613665],
              [5.414475467444114, -2.978942882541046],
              [5.415674323013883, -2.9747030923988813],
              [5.419205518245713, -2.9746603412108574],
              [5.422447032705328, -2.9716997749319387],
              [5.419734548552477, -2.96530887948206],
              [5.433859915579601, -2.9660508799247247],
              [5.4367550937219935, -2.9651498803683225],
              [5.435821886123833, -2.9586841629715903],
              [5.436506954757327, -2.9550467360456034],
              [5.440728665818884, -2.9489284042623725],
              [5.4453194799972175, -2.9478934635122935],
              [5.451281043227686, -2.9446350958017824],
              [5.449129971379526, -2.939995699286333],
              [5.453547455268887, -2.9376526356040307],
              [5.459429652760865, -2.929119080170039],
              [5.464707551562127, -2.9284520302835313],
              [5.468541789118192, -2.9311622161495268],
              [5.472997080825921, -2.9275783450066735],
              [5.481333663252956, -2.924794985686715],
              [5.48210754470646, -2.9193573755156983],
              [5.486441061272577, -2.922094549536372],
              [5.486721693851814, -2.914197765567351],
              [5.491322456768378, -2.91494171552971],
              [5.493433699383514, -2.9177932730094223],
              [5.5011318542421, -2.9183692352412134],
              [5.5009477829448645, -2.9221574656797444],
              [5.508014890800722, -2.915428080098997],
              [5.510263126277024, -2.9156796876465934],
              [5.512610757289281, -2.923615319681409],
              [5.516000812212764, -2.9246377096969858],
              [5.525450464677417, -2.9212406239041724],
              [5.529270522498552, -2.922184489040631],
              [5.5340951099756674, -2.9186026483461007],
              [5.540919650769035, -2.919160852996454],
              [5.5401557858858546, -2.922237387910932],
              [5.543288560491345, -2.9248077699686603],
              [5.54578628831077, -2.922677482798172],
              [5.552019723620773, -2.9227033725068288],
              [5.553470458150008, -2.919838525157647],
              [5.556996563755444, -2.9212692184915894],
              [5.56007950663119, -2.9280629103639244],
              [5.564977116341479, -2.92750413411254],
              [5.571023619040839, -2.9232940335175437],
              [5.573761952667141, -2.9194277178987047],
              [5.570924127104944, -2.914200715517264],
              [5.575696675761087, -2.911632567066908],
              [5.5815909418456275, -2.913240139237696],
              [5.589221087893205, -2.9127594101588388],
              [5.588869453607294, -2.9070582182428613],
              [5.593296284889311, -2.9064795807137327],
              [5.603827957999389, -2.9136121708833964],
              [5.604919187086698, -2.918748485450524],
              [5.60846059251873, -2.921022238850145],
              [5.607869829983746, -2.923718302090588],
              [5.6111924826715045, -2.92571273185039],
              [5.618087268594438, -2.9263594127489023],
              [5.625184464562924, -2.930209727961178],
              [5.628798817179005, -2.9357854284483307],
              [5.63219548351146, -2.9384860349486863],
              [5.638685943518049, -2.940934856953449],
              [5.64187638172334, -2.940373548967867],
              [5.64727922290169, -2.943541681716225],
              [5.652273706806375, -2.943714182305233],
              [5.652450616982526, -2.9485724449645967],
              [5.656479738980073, -2.947715306356477],
              [5.660996860361342, -2.944028063766782],
              [5.660927226787426, -2.9493020415050637],
              [5.666894088227313, -2.9484238025246237],
              [5.671596787074339, -2.9500764101830868],
              [5.671201317875396, -2.9555371996022157],
              [5.676724922482952, -2.954193488120245],
              [5.676099837146764, -2.960143623142084],
              [5.680670069642706, -2.956311275261321],
              [5.682753868789407, -2.958883086100228],
              [5.681192730693746, -2.962030683988557],
              [5.689179488528827, -2.96362088837543],
              [5.689067598979898, -2.969149222303546],
              [5.6906122106021195, -2.9708112482107105],
              [5.697221431468661, -2.9705221925159178],
              [5.700787329325666, -2.9753575830960313],
              [5.704200012930735, -2.9739534004649126],
              [5.71209824433159, -2.975825118026082],
              [5.708188713832697, -2.979911921816649],
              [5.716948803649192, -2.985736848304595],
              [5.718475663798058, -2.989134719218731],
              [5.71643334230235, -2.9934087615735208],
              [5.716696822970609, -3.003148067390594],
              [5.7255190445884425, -3.002977606019563],
              [5.728676914975669, -3.0747959809974907],
              [5.7319873893632, -3.1474748120205143],
              [5.713406534536341, -3.148260727742193],
              [5.711032078423753, -3.14779915475118],
              [5.678354794722955, -3.149389927850224],
              [5.671107760804086, -3.151394622337644],
              [5.669549181031159, -3.1535641526230163],
              [5.660199642436277, -3.154846112370164],
              [5.658126387256389, -3.1580760339337144],
              [5.652597798876904, -3.1597141565895677],
              [5.650154638702684, -3.1572794891692704],
              [5.646932353300986, -3.1608411439103534],
              [5.642903625520174, -3.159158502394398],
              [5.637339357479239, -3.161817634573129],
              [5.632263334402112, -3.1628139194577467],
              [5.625601774499822, -3.1687475083682206],
              [5.6184958061241135, -3.169698620531875],
              [5.617936639547563, -3.174851782274054],
              [5.612840376269855, -3.1771382985138215],
              [5.605978887794004, -3.183499219236142],
              [5.596752866721336, -3.185059632017623],
              [5.595948987538754, -3.176914752004234],
              [5.597078832717231, -3.17181960489594],
              [5.548550981124206, -3.1739636984301165],
              [5.547579747448186, -3.1543165917999954],
              [5.542038302960152, -3.153775947885316],
              [5.541653013170332, -3.158949182914551],
              [5.533032202069656, -3.15729715945139],
              [5.525291666703878, -3.1576355026975644],
              [5.525236576932164, -3.1633379741856382],
              [5.519955499085155, -3.1633963778846916],
              [5.487945999462666, -3.161687828918144],
              [5.487463465359602, -3.179237078943152],
              [5.469745356594992, -3.176868622608108],
              [5.460774002666483, -3.178456612614736],
              [5.453905823751885, -3.1786228134879924],
              [5.446901449030559, -3.1774678067960167],
              [5.43968325675766, -3.17950778162026],
              [5.438575171857116, -3.1785933900793726],
              [5.4229651739858795, -3.1806068926704407],
              [5.402387503912338, -3.18136127398595],
              [5.367613404377715, -3.181277221639756],
              [5.331063848981748, -3.1835035724645024],
              [5.27497115941908, -3.1839674343282955],
              [5.272964017214526, -3.183990261591711],
              [5.262241750072731, -3.1774539187566893],
              [5.2687565032391435, -3.1690990480565335],
              [5.289902019333033, -3.1592039010577295],
              [5.295641329211137, -3.1556067150933824],
              [5.304173057918857, -3.1479054427739546],
              [5.302273499900548, -3.1351868068706996],
              [5.299402731914894, -3.1252696995452713],
              [5.294686685553338, -3.1161338396404306],
              [5.287787656803092, -3.1059428310928765],
              [5.2810112205787965, -3.1021615097278237],
              [5.274725729984459, -3.0970849755346883],
              [5.266842335259122, -3.0858040149103743],
              [5.263347338729981, -3.0777109917519634],
              [5.2605318541685575, -3.0647347240375655],
              [5.260969920631203, -3.058026448295156],
              [5.265651579841609, -3.043295060895717],
              [5.266841520788494, -3.0326222987098217],
              [5.270789663424576, -3.0267473511693956],
              [5.279086699745131, -3.0224856996438336],
              [5.2839345979540315, -3.0224937145113047],
              [5.291411051885051, -3.0179450706634974],
              [5.298877531159329, -3.0163907318571237],
              [5.306644531233547, -3.0170054756591713],
              [5.317541911951365, -3.0225458925990614],
              [5.3326552054116485, -3.033872542886049],
              [5.335415314216973, -3.0409510065144594],
              [5.333598224230307, -3.0518498589561407],
              [5.353170437384213, -3.059054572949561],
              [5.3583745933983415, -3.061853026924107],
              [5.366803119577304, -3.0623056151398016],
              [5.37431950729646, -3.058939933532407],
              [5.377447872092185, -3.0535823647857594],
              [5.37890172334647, -3.0477464616611196],
              [5.3786183826059135, -3.0425257313419074],
              [5.376571513202808, -3.036939511741004],
              [5.3721722101568785, -3.0351346233004866]
            ]
          ],
          [
            [
              [5.193050105311221, -3.1486406786781815],
              [5.201274986546845, -3.1426301193073902],
              [5.20524133731055, -3.12448561218881],
              [5.207332892830098, -3.1175461720463047],
              [5.21148819080095, -3.111367073852399],
              [5.216597829378364, -3.106540630665082],
              [5.222328266301793, -3.105020382695268],
              [5.232356461176228, -3.103898730529243],
              [5.239734803474753, -3.105164580219657],
              [5.249434704496964, -3.1153099567296745],
              [5.250243162207098, -3.1205759705827414],
              [5.247590574870192, -3.1314600385204416],
              [5.246060101437246, -3.142382835699851],
              [5.246398584774655, -3.1480423118104115],
              [5.249918815160222, -3.158614557126527],
              [5.257306893746943, -3.1663399844174447],
              [5.251695551004829, -3.173803838278104],
              [5.265145297301785, -3.191993807674837],
              [5.259318848261103, -3.1954796440037785],
              [5.248797114430625, -3.198186940055868],
              [5.243878416469126, -3.196717297247745],
              [5.241091979388252, -3.1940736760327786],
              [5.233222248329701, -3.189890155454956],
              [5.225770516586712, -3.1839399630377305],
              [5.2176620635855, -3.1744488589164366],
              [5.214754031542673, -3.172796093207268],
              [5.203111718869364, -3.171068433305277],
              [5.199159116710158, -3.1718967735950656],
              [5.192330580995959, -3.1786286120482594],
              [5.1904186364279985, -3.186345901661368],
              [5.193346097601285, -3.1981409813993986],
              [5.200450511966576, -3.2087376523275],
              [5.191717539934712, -3.2119774324011128],
              [5.184030178924826, -3.2118024520344433],
              [5.176600403308095, -3.212915756040929],
              [5.170852514903217, -3.2097251047176236],
              [5.165564659418008, -3.2054078864634867],
              [5.16462779140876, -3.2023347840508847],
              [5.169998328371839, -3.176905835853632],
              [5.169567299286747, -3.168568734471542],
              [5.170735120254985, -3.164938515675903],
              [5.193050105311221, -3.1486406786781815]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.75658054542633, "lat": 35.49730042474471 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47167"],
        "coty_name": ["Tipton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tipton County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "01639795"
      },
      "bbox": [
        5.16462779140876, -3.212915756040929, 5.7319873893632,
        -2.9064795807137327
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.7643645651928868, -8.204000586899042],
            [-1.6482413659213178, -8.205202278780982],
            [-1.6094146043424329, -8.205835430009026],
            [-1.6004547395812014, -8.208546336863334],
            [-1.5578774261125272, -8.222986592870683],
            [-1.531714614466687, -8.231776726200946],
            [-1.4718980597070834, -8.251475623287067],
            [-1.4711890260501164, -8.252051681688885],
            [-1.3653634215539219, -8.286899272371503],
            [-1.4077639500487555, -8.355236707705801],
            [-1.4168209599659412, -8.379181487006933],
            [-1.4386347782611952, -8.438777422599163],
            [-1.4665254311390208, -8.515246481355321],
            [-1.4872780581744536, -8.571183878071084],
            [-1.522782520956866, -8.667928046571445],
            [-1.546992947998606, -8.69090700851435],
            [-1.6259707110354686, -8.764811448862234],
            [-1.646496029565633, -8.735905372587231],
            [-1.7224826443704435, -8.629955916396463],
            [-1.72474886443789, -8.627388924983492],
            [-1.7425728538619687, -8.60186817503284],
            [-1.7709648560464288, -8.561640018562912],
            [-1.7691253045520492, -8.49587834409844],
            [-1.7681269333184986, -8.45535943136109],
            [-1.7671819057960925, -8.390100140482938],
            [-1.7643645651928868, -8.204000586899042]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.39987343647022, "lat": 30.26638416670671 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48031"],
        "coty_name": ["Blanco"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blanco County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01383801"
      },
      "bbox": [
        -1.7709648560464288, -8.764811448862234, -1.3653634215539219,
        -8.204000586899042
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.579075441503858, -6.169770649467121],
            [-2.5643673042953545, -6.170330999595773],
            [-2.4782729267435872, -6.17341313357291],
            [-2.384210382512435, -6.176482182348699],
            [-2.337242026340124, -6.1782461495385705],
            [-2.193792581037647, -6.1831529135500904],
            [-2.147253733251473, -6.18485410784624],
            [-2.1475329967194683, -6.199534090521981],
            [-2.1481957206063274, -6.2042866639650605],
            [-2.1509427884309615, -6.27284039395354],
            [-2.153447613862087, -6.324746271302066],
            [-2.1586971533138963, -6.448812448048469],
            [-2.158546439322057, -6.450009632732288],
            [-2.1609568649733246, -6.514610936281483],
            [-2.1637155811563074, -6.5735270013296505],
            [-2.163563264865998, -6.574250209523273],
            [-2.165271830282442, -6.619297140505751],
            [-2.1709099303860846, -6.619510623052932],
            [-2.1964213951351406, -6.61839331185232],
            [-2.2303435162811565, -6.617498707317971],
            [-2.2732823357851824, -6.6159316463886695],
            [-2.2762156894337098, -6.615123839395299],
            [-2.327358507929755, -6.613340591019739],
            [-2.421618228121338, -6.609962274091346],
            [-2.486118679335532, -6.60774682532636],
            [-2.4868795773740353, -6.607879809500293],
            [-2.5972543290579435, -6.602365716024672],
            [-2.5946647651770416, -6.5387269165753406],
            [-2.590183330219186, -6.434932052061436],
            [-2.5902524166181626, -6.426593575490374],
            [-2.5884191479580685, -6.3847283356294735],
            [-2.587613794486735, -6.370240689728644],
            [-2.5852615686406795, -6.311801744940954],
            [-2.582258075811891, -6.247751309390816],
            [-2.5808320065511934, -6.209819204547278],
            [-2.579075441503858, -6.169770649467121]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.37349705874732, "lat": 32.29765149289253 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48059"],
        "coty_name": ["Callahan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Callahan County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01383815"
      },
      "bbox": [
        -2.5972543290579435, -6.619510623052932, -2.147253733251473,
        -6.169770649467121
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.6560397861504875, -12.239213953588047],
              [-0.642027381058989, -12.239377335601768],
              [-0.6359607656541626, -12.262671604189975],
              [-0.6302141188620023, -12.289221974135769],
              [-0.6220789337807487, -12.323238604920409],
              [-0.6145798080613597, -12.35719610422651],
              [-0.6126159518624157, -12.369304453891338],
              [-0.605531505052406, -12.408491983185638],
              [-0.602883985030776, -12.42582110373979],
              [-0.595851340947268, -12.486692511480912],
              [-0.595453340367851, -12.494409242733587],
              [-0.5921615553591769, -12.52128003109437],
              [-0.5882035618850818, -12.550053971893341],
              [-0.5840439052017218, -12.56695492662042],
              [-0.5818632438313783, -12.572925784452536],
              [-0.5935319063997384, -12.567941768721436],
              [-0.5958817206071244, -12.562956196990507],
              [-0.5966569733574525, -12.556090044059834],
              [-0.5935439031492556, -12.548361671089026],
              [-0.5950628199326266, -12.545864444505979],
              [-0.5953299270616565, -12.539665464053838],
              [-0.5994778237841651, -12.527140946776129],
              [-0.5978884189096466, -12.524020708689696],
              [-0.5999033125235926, -12.513092234602901],
              [-0.6031899646533859, -12.507434123488526],
              [-0.6040092443550071, -12.497428621833267],
              [-0.6065714209994069, -12.49574622946343],
              [-0.6054698168239848, -12.483616125449434],
              [-0.6065477124193687, -12.480381387974981],
              [-0.6050720352660383, -12.472634319249648],
              [-0.6034752821372429, -12.4693020492471],
              [-0.6033965836531429, -12.463107810768141],
              [-0.6067370195177592, -12.44665004203136],
              [-0.607392453723502, -12.439002134890073],
              [-0.6095430734630986, -12.43061319093508],
              [-0.6116814711662033, -12.41282867437281],
              [-0.6160565498541397, -12.40193517459745],
              [-0.616355558500352, -12.391710693152694],
              [-0.6178459725772623, -12.382297167228558],
              [-0.6187457569671887, -12.368762275260682],
              [-0.6221819301893382, -12.360255264002893],
              [-0.623109686267704, -12.348888356122064],
              [-0.6315431196917529, -12.311931488177905],
              [-0.6394925697124946, -12.295832943612986],
              [-0.6431234914731965, -12.286188129023554],
              [-0.6376715249013952, -12.279754120541552],
              [-0.6398296785924565, -12.272501984028127],
              [-0.6508107873637814, -12.250792655621263],
              [-0.6523641157753818, -12.246540633078606],
              [-0.6570178800423564, -12.241968706862856],
              [-0.6560397861504875, -12.239213953588047]
            ]
          ],
          [
            [
              [-1.2233692639571256, -12.56086267350073],
              [-1.2232750821752556, -12.546737158665513],
              [-1.2220118695258027, -12.483748810219943],
              [-1.2217778107202637, -12.462112352769461],
              [-1.2204806070502017, -12.405759930510014],
              [-1.2181517737285437, -12.291358942273712],
              [-1.15925782352849, -12.302029198861426],
              [-1.0689034565703857, -12.317972089171157],
              [-0.9929454364104909, -12.330972229806777],
              [-0.9169817138991524, -12.34395314485025],
              [-0.9154431337116293, -12.340656488387957],
              [-0.9162607073591479, -12.327214329262011],
              [-0.9133678075675511, -12.3205135593374],
              [-0.9108883521899352, -12.318335895932654],
              [-0.9035537726770075, -12.317125438742305],
              [-0.8985540360295533, -12.322169042921368],
              [-0.8988859420176982, -12.32702406769953],
              [-0.9036691708329363, -12.327256033717173],
              [-0.9045975566988752, -12.330091711843048],
              [-0.896975287854222, -12.33076046181453],
              [-0.8924920830025164, -12.325391135672161],
              [-0.8928983467456584, -12.322233253225978],
              [-0.8956984989739546, -12.319516105128418],
              [-0.896703837073706, -12.315136358884414],
              [-0.8949253500473285, -12.31189960695927],
              [-0.8848190144761908, -12.30820358031545],
              [-0.878337499851611, -12.307930615285878],
              [-0.8728185347115074, -12.309198152472453],
              [-0.8642403267721919, -12.31512984652025],
              [-0.8625503753450778, -12.312954330670106],
              [-0.8646421265783582, -12.308374218188474],
              [-0.8685819184192314, -12.30553092299167],
              [-0.8665066412750212, -12.302755392757183],
              [-0.8623523322721802, -12.302541941555411],
              [-0.8593956153234771, -12.305444850580672],
              [-0.8612074674522724, -12.311233895160818],
              [-0.859511313635432, -12.313352926888703],
              [-0.854535165133467, -12.313432552304725],
              [-0.8515481776066196, -12.319288474610772],
              [-0.8485268508541529, -12.320607097139362],
              [-0.843753621907794, -12.320222729106192],
              [-0.8392699277901644, -12.313456663169198],
              [-0.834795179001507, -12.308448116587538],
              [-0.833090222334596, -12.300508959056593],
              [-0.8298618407868508, -12.29030899876279],
              [-0.8299175397661065, -12.286422996930755],
              [-0.8265739438597592, -12.281710552593966],
              [-0.8199282534642734, -12.280648510575949],
              [-0.8167110353319672, -12.276825546878632],
              [-0.8118153363634044, -12.27415132497404],
              [-0.8072718905956038, -12.268119239489195],
              [-0.8013904823159712, -12.262192251908026],
              [-0.7988481765558673, -12.251871040614406],
              [-0.795028072579826, -12.246125673805723],
              [-0.7953054361910592, -12.24355118391505],
              [-0.7878690878928042, -12.238161459763512],
              [-0.7818237041114524, -12.237857632083617],
              [-0.7537741133223768, -12.238055511563388],
              [-0.752280816621792, -12.241239988494618],
              [-0.7418331382126936, -12.268322519950916],
              [-0.7417805667035086, -12.272141965596598],
              [-0.7372770252406435, -12.27994550111691],
              [-0.736757186570724, -12.288622671573188],
              [-0.731698066991525, -12.295194831464169],
              [-0.7122829959303568, -12.34242429553339],
              [-0.7086300289389552, -12.350112351038563],
              [-0.702544106135528, -12.352773519578815],
              [-0.6990130867045742, -12.361595474557948],
              [-0.6945526368762857, -12.365370810894738],
              [-0.6934982580512494, -12.374675482126168],
              [-0.699239032742153, -12.377903248773608],
              [-0.7084587198359152, -12.368592973587138],
              [-0.7149599792982614, -12.364789687075596],
              [-0.7203372346655453, -12.357491689762515],
              [-0.7288398401504443, -12.366048099223233],
              [-0.733594947405367, -12.36794537234457],
              [-0.7322839363859488, -12.37315598127351],
              [-0.7291787883133255, -12.374818907842362],
              [-0.7242003778699371, -12.371858831330393],
              [-0.7172017532180962, -12.371366942364665],
              [-0.7136834716538969, -12.373375896120843],
              [-0.7115974740778902, -12.377842672040604],
              [-0.7107210193525654, -12.384358420256842],
              [-0.7122206996457596, -12.391668413525972],
              [-0.7186371843759622, -12.404590954382936],
              [-0.718266264175525, -12.408829508953142],
              [-0.7202868301894882, -12.414893408077177],
              [-0.7232362142461807, -12.41815722386397],
              [-0.7274509181380422, -12.419648894192349],
              [-0.7240881317438639, -12.42516707153027],
              [-0.7227144893632553, -12.4302184718403],
              [-0.716665355139497, -12.440648717310708],
              [-0.7115532441839113, -12.441956549761333],
              [-0.7080540752780724, -12.450619060118418],
              [-0.7093393231337491, -12.46021070298457],
              [-0.7121424682109468, -12.466398736699128],
              [-0.7158110594294037, -12.471328863911724],
              [-0.7125190892564616, -12.482111912220283],
              [-0.7087054043646113, -12.4863959758839],
              [-0.7123615588884872, -12.493885090682861],
              [-0.7076975868624207, -12.503606308878316],
              [-0.7003459384849052, -12.51351990109836],
              [-0.6981166601657932, -12.521631539645142],
              [-0.7035160961081344, -12.522645118683414],
              [-0.7043994364643752, -12.514247337125855],
              [-0.7072612037976894, -12.510765759483897],
              [-0.7115497042254678, -12.515606970277544],
              [-0.7158707559674239, -12.516279008784684],
              [-0.7207850887195993, -12.512381442286138],
              [-0.7250756364544169, -12.520058579798869],
              [-0.7230260446759441, -12.522777622289757],
              [-0.7171795553067155, -12.522266732302615],
              [-0.7096521960298131, -12.527943491577492],
              [-0.7106501949134669, -12.532197913315775],
              [-0.7054054595414172, -12.535387487797676],
              [-0.6958065693246961, -12.547821803130569],
              [-0.6864797783766508, -12.553725266869153],
              [-0.6662208326243644, -12.559531128499433],
              [-0.6471720228957802, -12.561028872096378],
              [-0.6309538322220873, -12.560713957367076],
              [-0.6233769872863398, -12.563269948685324],
              [-0.622456975148161, -12.565364293342007],
              [-0.6147660501390831, -12.570312423807048],
              [-0.6222813969925973, -12.573311237006775],
              [-0.6201542395411689, -12.592800820322463],
              [-0.6083390557147555, -12.586592702942294],
              [-0.5921216996785659, -12.576388907637737],
              [-0.5863346674867898, -12.579330160034282],
              [-0.5809102001960244, -12.576319172354989],
              [-0.5798742235050828, -12.58019423974755],
              [-0.580941167338908, -12.587346843041177],
              [-0.5817531359722447, -12.600666481794589],
              [-0.5808407638392922, -12.621232655208464],
              [-0.5769521943302008, -12.66685772214811],
              [-0.5762948905557786, -12.680263659428444],
              [-0.5773982339082054, -12.683472664707839],
              [-0.5859174416910252, -12.687530541901841],
              [-0.5892476664915767, -12.686310646649057],
              [-0.5876010319560804, -12.679246344006703],
              [-0.5888378429637046, -12.674591324533354],
              [-0.5942066065863825, -12.676547714464434],
              [-0.5981372725161205, -12.675561881844171],
              [-0.6010374266572962, -12.672319314667233],
              [-0.6045403216627394, -12.671898075879396],
              [-0.6057229519286144, -12.675270312691412],
              [-0.6129941098822665, -12.677776755672628],
              [-0.6142419073160755, -12.681881675214578],
              [-0.6201863820054384, -12.681099428394896],
              [-0.6232671821301011, -12.678471773732161],
              [-0.6306723211403377, -12.677678560030367],
              [-0.6316057792618857, -12.672839073267442],
              [-0.6441762583535148, -12.678844420962172],
              [-0.6481745467969994, -12.67703283868869],
              [-0.6587808960638678, -12.679897571324819],
              [-0.6645321162415623, -12.68240353211457],
              [-0.6679657565459451, -12.68728006366638],
              [-0.6733318077339083, -12.687084577521006],
              [-0.6805025453392526, -12.68450962829147],
              [-0.694863158827736, -12.683149023113991],
              [-0.7017919771434206, -12.676282183852376],
              [-0.7063958055588644, -12.681432028327713],
              [-0.7021891421797224, -12.685624104244688],
              [-0.696652512979362, -12.687592598377618],
              [-0.6989084112047173, -12.691496281364397],
              [-0.6951984296916502, -12.696619765705094],
              [-0.6954993999435917, -12.699292329649987],
              [-0.7087597764751515, -12.698282357867514],
              [-0.7124478736204374, -12.700997819901792],
              [-0.7168521569242082, -12.697283476572386],
              [-0.7201843784086835, -12.698690757111523],
              [-0.7206875900761379, -12.705742890876095],
              [-0.7251890508049531, -12.707629102736636],
              [-0.7300557296877646, -12.702669884919437],
              [-0.7349654444370207, -12.704213765964935],
              [-0.738996073715949, -12.709727284917294],
              [-0.73883257721795, -12.714995992146378],
              [-0.7448153594088276, -12.714949239022983],
              [-0.7512234208590329, -12.712033471498183],
              [-0.7494735400973397, -12.704644182871325],
              [-0.7548964839229974, -12.704731034799725],
              [-0.7601006958692644, -12.702573315410131],
              [-0.7632394697502239, -12.710010909406495],
              [-0.7667713205876089, -12.713803721944105],
              [-0.7738721539550448, -12.717365699608305],
              [-0.7779004338218832, -12.717270584994669],
              [-0.7786464351125331, -12.722843331775177],
              [-0.7845507146200211, -12.724074561567093],
              [-0.784267946484148, -12.726867641543489],
              [-0.7765764304680757, -12.730077955510414],
              [-0.7776195824471293, -12.74040427236048],
              [-0.7744433725129557, -12.742436476380831],
              [-0.7702703121639434, -12.742464815940993],
              [-0.7690118074043427, -12.745279777233119],
              [-0.7776458077026592, -12.746925435516125],
              [-0.7831033335790982, -12.750200675989047],
              [-0.7836027991910791, -12.753134878296304],
              [-0.7701992384131997, -12.753665784622596],
              [-0.7707558746504662, -12.759537390450804],
              [-0.780631522566176, -12.772930892476037],
              [-0.7852253205171349, -12.774090242502279],
              [-0.7864556813940187, -12.776545077179655],
              [-0.7778237625185618, -12.777292560474558],
              [-0.7828708314671254, -12.78315510027859],
              [-0.7837221407249454, -12.790199760677428],
              [-0.7925547552292465, -12.790391734984865],
              [-0.7966373877463718, -12.786407926933105],
              [-0.7988704692151096, -12.790730803984854],
              [-0.803432067889312, -12.792566678254214],
              [-0.8074883191048245, -12.79083451525512],
              [-0.8088481212353626, -12.783513938128678],
              [-0.8073772951364613, -12.780710373815491],
              [-0.8102521329768577, -12.778411384769113],
              [-0.8132904753691493, -12.784328096397658],
              [-0.8157898735539393, -12.784413732647781],
              [-0.8176768948142833, -12.779609381880817],
              [-0.8156337673629103, -12.774558355310553],
              [-0.8152215892022046, -12.769436215259601],
              [-0.818522853407274, -12.769404882445421],
              [-0.8206539736635224, -12.773310894433823],
              [-0.820334467761528, -12.77780105363984],
              [-0.8216053980597333, -12.783259145850675],
              [-0.8198621207427401, -12.78866125732577],
              [-0.8285190166012498, -12.789363202676897],
              [-0.8336265414710919, -12.787425111365064],
              [-0.8403558933553408, -12.780436544493647],
              [-0.8472988309128693, -12.781577315775133],
              [-0.8498658767346061, -12.778369635613263],
              [-0.848530015603705, -12.77416476982939],
              [-0.8520714430326386, -12.770707638237841],
              [-0.8513150045146451, -12.766836954308463],
              [-0.8486212660965833, -12.763230649026157],
              [-0.8505741000946934, -12.759243214293184],
              [-0.8532915121585039, -12.758441453806238],
              [-0.8572650745556722, -12.763012216535188],
              [-0.8597494808940155, -12.761254337609842],
              [-0.8575072879847891, -12.751238184556373],
              [-0.8605518200483787, -12.74642123240129],
              [-0.8667268497986442, -12.749247734853668],
              [-0.8709882388917753, -12.754705689427592],
              [-0.8735430685230366, -12.754612047671147],
              [-0.8752010220217857, -12.750218571868087],
              [-0.8699123382942012, -12.746829507187815],
              [-0.8715938692781725, -12.742088594637263],
              [-0.8820565120032541, -12.750271119160471],
              [-0.8874027831391674, -12.751090211857733],
              [-0.8862624123849058, -12.746311026168422],
              [-0.8880597051711364, -12.744933672966807],
              [-0.8920739215977204, -12.749295920327752],
              [-0.8962942635143362, -12.749465965383298],
              [-0.8961937091836932, -12.742060849227792],
              [-0.8951238751369544, -12.734755278834644],
              [-0.8973083421512044, -12.731902766802866],
              [-0.9039344846572909, -12.739559535605125],
              [-0.9086269029375666, -12.742640015130322],
              [-0.9165355411724269, -12.743912364847274],
              [-0.9196988661199942, -12.740131017860563],
              [-0.9194829927880894, -12.73301906882728],
              [-0.9230833843238255, -12.727742185843155],
              [-0.9239787630728727, -12.724158133499433],
              [-0.9280159172154331, -12.722819957839766],
              [-0.9284207043662243, -12.717865241690646],
              [-0.9256529151039161, -12.714451583838853],
              [-0.9273637831857748, -12.710342077534037],
              [-0.9346556317893773, -12.711595701739272],
              [-0.9391851286027814, -12.705686941433996],
              [-0.9393177626573392, -12.698231380598877],
              [-0.9409747761853635, -12.696013714061825],
              [-0.9479789898799758, -12.69398046432167],
              [-0.9516749017287853, -12.69863761743859],
              [-0.9516172205548138, -12.70352087855107],
              [-0.9558338507337262, -12.704885773534933],
              [-0.9597243860675181, -12.702690935623032],
              [-0.9581929118118606, -12.697326688786173],
              [-0.965426921189106, -12.695636369938274],
              [-0.9704247850086004, -12.697837685276099],
              [-0.9740953185455303, -12.69593082693605],
              [-0.970895225191923, -12.691937337547445],
              [-0.958843905089982, -12.686913880745838],
              [-0.9574320217186337, -12.684366095983503],
              [-0.9598664476284628, -12.67857094117158],
              [-0.9652280688035223, -12.678583041046542],
              [-0.9638608654851202, -12.684771010044736],
              [-0.9659062568810903, -12.687141205403599],
              [-0.969958207784419, -12.687184826798722],
              [-0.9727843646312551, -12.675883149479041],
              [-0.9714902709060202, -12.670678618515087],
              [-0.9832689570965727, -12.67017428509902],
              [-0.9863586476727481, -12.673618671133939],
              [-0.9900870909322644, -12.673726614794708],
              [-0.9921444069076298, -12.670148420031762],
              [-0.9974070752063735, -12.665430408153137],
              [-0.9952327900965053, -12.66020363336976],
              [-0.9953305773662211, -12.655063862978842],
              [-1.0037855305172922, -12.651672998082166],
              [-1.007308029488136, -12.642755903902069],
              [-1.0162588825357948, -12.643514434632088],
              [-1.018821857457406, -12.641450400413843],
              [-1.0172993412639324, -12.636393179877633],
              [-1.0150696143519076, -12.635577588714241],
              [-1.0063948178041722, -12.639924194470176],
              [-1.0041666788977046, -12.636027311954393],
              [-1.0034311476608782, -12.631254454386472],
              [-1.0048763655386674, -12.629444212110307],
              [-1.009088009181877, -12.635394172727295],
              [-1.0131407484161103, -12.634431005713477],
              [-1.0113164898006572, -12.629418135305011],
              [-1.0142209201069283, -12.626620082961585],
              [-1.0189981309968998, -12.632510909219013],
              [-1.0232989334733114, -12.627941600776683],
              [-1.0286703997056892, -12.625257176694623],
              [-1.0308999112817516, -12.619585810012476],
              [-1.024606869632234, -12.620502575909109],
              [-1.0208315068755465, -12.617505980314162],
              [-1.021078147352205, -12.612108710463902],
              [-1.027959762778799, -12.605038227550866],
              [-1.0325780528014525, -12.6087875228778],
              [-1.032629348603216, -12.614422680602782],
              [-1.0350029835567993, -12.6160053928272],
              [-1.0392013554145731, -12.612549775071171],
              [-1.0478606776352026, -12.613290844388795],
              [-1.0484126837162218, -12.608581608249574],
              [-1.042139854922522, -12.601913082111604],
              [-1.0485781107684808, -12.60360993101371],
              [-1.0514322315627802, -12.598590042961549],
              [-1.0558456971884798, -12.601451902325632],
              [-1.054928002629688, -12.60612322160551],
              [-1.0617007356936123, -12.606077082804177],
              [-1.0673791272404751, -12.603903989790696],
              [-1.0705250886546447, -12.599879589250524],
              [-1.071788793999609, -12.605220292677348],
              [-1.0688636322699414, -12.60937520158801],
              [-1.0718240698654649, -12.612168414612771],
              [-1.0756242718797038, -12.606769815801096],
              [-1.0749771662143657, -12.601688354355788],
              [-1.0798471377625556, -12.60080918973142],
              [-1.0817427952249608, -12.596042917537918],
              [-1.0854915994266745, -12.596049760820822],
              [-1.0864092848664233, -12.605544215870689],
              [-1.0970455852929222, -12.607998450527557],
              [-1.0947515980844034, -12.604210505773038],
              [-1.0956268275355776, -12.600889799620463],
              [-1.1091856101046949, -12.599507848262219],
              [-1.1076681685859286, -12.60400478076204],
              [-1.1014450607395303, -12.604196570357198],
              [-1.1017120202479485, -12.608696419806439],
              [-1.1064418621257721, -12.60797694863793],
              [-1.1123744764826133, -12.60915867304048],
              [-1.1103956036937195, -12.604221233630485],
              [-1.1160284440293873, -12.601525368416262],
              [-1.119562391887971, -12.604265294551308],
              [-1.1226340768187792, -12.600132975183922],
              [-1.1265720751260109, -12.600348454120534],
              [-1.1307007746245052, -12.60440243898739],
              [-1.13547701362428, -12.603570275173842],
              [-1.1345762381746958, -12.58896033013093],
              [-1.1397901784476236, -12.583979369206117],
              [-1.146973273891517, -12.587262602223863],
              [-1.1466986758346343, -12.590394239974618],
              [-1.1414125249849736, -12.593826025303812],
              [-1.1480755685789032, -12.60134466139973],
              [-1.1528157188691976, -12.596764752714138],
              [-1.161203932835984, -12.596485968643627],
              [-1.1659078479154716, -12.5905544200593],
              [-1.1628481350736335, -12.583602925967632],
              [-1.1579238606460944, -12.581484868266056],
              [-1.1606991483966984, -12.57838730327977],
              [-1.1670287666289505, -12.577847789111994],
              [-1.1679819507925342, -12.571978765518919],
              [-1.1751418657661432, -12.573273166212566],
              [-1.1787208230866904, -12.577762549654553],
              [-1.1781518705288834, -12.585304743911141],
              [-1.1825522800094803, -12.585450125253072],
              [-1.1812605772775735, -12.578425374658197],
              [-1.183357305880309, -12.574845273373539],
              [-1.1912617382008457, -12.574924756800987],
              [-1.1976454994975538, -12.584209567497474],
              [-1.2003924969010569, -12.583001726950469],
              [-1.201716821369629, -12.578086228677003],
              [-1.2061532346097477, -12.576863671383524],
              [-1.2127713314678483, -12.578165239989952],
              [-1.2234218411778326, -12.575954741263612],
              [-1.2239915011601445, -12.56924087799173],
              [-1.221024545082523, -12.564049536663045],
              [-1.2233692639571256, -12.56086267350073]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.51861278138566, "lat": 26.13323548296397 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48061"],
        "coty_name": ["Cameron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cameron County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01383816"
      },
      "bbox": [
        -1.2239915011601445, -12.792566678254214, -0.5762948905557786,
        -12.237857632083617
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1334019207404613, -3.90454735699182],
            [-3.106051231167554, -3.905812255079331],
            [-3.1004553243355515, -3.9064684475185874],
            [-3.0186772622669613, -3.910181836043786],
            [-2.7955356163861, -3.920570876402809],
            [-2.795188356897902, -3.9206720578837504],
            [-2.800706259794063, -4.051375477423122],
            [-2.8030728865587426, -4.107427701059519],
            [-2.8007263360961336, -4.107611898698249],
            [-2.8051087955192733, -4.2050785412063485],
            [-2.8081858437587446, -4.27796881220145],
            [-2.8114419928391268, -4.357291059602662],
            [-2.8136353541004926, -4.357098395735857],
            [-2.9141430080699635, -4.352449746515838],
            [-2.9235074417700466, -4.352359721278276],
            [-3.0110314029417307, -4.3482571178480365],
            [-3.0998986822443775, -4.343762365475413],
            [-3.120605735001503, -4.342808891070885],
            [-3.140367399595594, -4.341071604786272],
            [-3.1552683881211325, -4.340397994391492],
            [-3.1492959060847636, -4.228936887176221],
            [-3.142251072552923, -4.094951364160137],
            [-3.139292037893474, -4.03171467121739],
            [-3.1334019207404613, -3.90454735699182]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.20761573922594,
          "lat": 34.52914676693785
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48075"],
        "coty_name": ["Childress"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Childress County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01383823"
      },
      "bbox": [
        -3.1552683881211325, -4.357291059602662, -2.795188356897902,
        -3.90454735699182
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.35746212735395333, -9.65003994280877],
            [-0.2772245384952238, -9.585337946410773],
            [-0.23902155494001656, -9.555440280147149],
            [-0.1837572042127533, -9.512000125117082],
            [-0.12850391741045772, -9.468543041607086],
            [-0.11099042051810952, -9.454375156045487],
            [-0.09525610015669472, -9.470326216067331],
            [-0.08219370413052804, -9.48365327399691],
            [-0.07187671878020024, -9.492383279269523],
            [-0.001073762416195606, -9.56220948249976],
            [0.043251687473482354, -9.605687885905805],
            [0.0875861915611593, -9.649151802566779],
            [0.17340178556401, -9.732730278488463],
            [0.1929008407311238, -9.752017505102607],
            [0.19152672909632226, -9.784670053159735],
            [0.19144695987024604, -9.792073631146732],
            [0.18709260664504, -9.884032077346049],
            [0.18441655845317645, -9.935912332986987],
            [0.17935781442589221, -10.034948140941086],
            [0.10822023488124431, -10.035847482866687],
            [0.10843181543627659, -10.020647231632738],
            [0.11212218090914623, -10.020658677727011],
            [0.11276608835205694, -9.980994395706295],
            [0.10565056393628335, -9.981203538348218],
            [0.09430782806633517, -9.99725586319908],
            [0.08718364604952987, -9.997116390322107],
            [0.0872994332050055, -10.007140730255765],
            [0.043633599734130044, -10.007906859142235],
            [0.045914736207312644, -10.003774788225417],
            [-0.030812479545396457, -10.005098036862178],
            [-0.04117973137576517, -10.004526762718154],
            [-0.04213075750338997, -10.012139267161299],
            [-0.045881135362741625, -10.011938897439842],
            [-0.043802473879826706, -10.003632292601564],
            [-0.04556410790706968, -9.997784489831163],
            [-0.046273290657257556, -9.990860424827355],
            [-0.05049864721986071, -9.985565489325879],
            [-0.058374386079990036, -9.985669734786006],
            [-0.06318453939742355, -9.987213933737982],
            [-0.0736851596055444, -9.989005099670045],
            [-0.08526650045098057, -9.99270890174352],
            [-0.0937887563741392, -9.996178575058984],
            [-0.1016082783424173, -9.997655450963727],
            [-0.10731911907379135, -9.994681765956445],
            [-0.10796341220716364, -9.989158396844251],
            [-0.11511790264799765, -9.990075251828056],
            [-0.1153796539888353, -9.985824485102656],
            [-0.11909782365414238, -9.976807196823103],
            [-0.12342619556244067, -9.972421848856937],
            [-0.11959062316919229, -9.969625574488283],
            [-0.11919730253945944, -9.965687555403074],
            [-0.12639045276227043, -9.957938951100381],
            [-0.12467708249544569, -9.949237922487484],
            [-0.12989815583367753, -9.946754016263366],
            [-0.13884610195385938, -9.946622018457822],
            [-0.1414922010946551, -9.943088703017455],
            [-0.13808938147145364, -9.939935716067069],
            [-0.14008302067410142, -9.937848583236372],
            [-0.1467958406613197, -9.937890942389187],
            [-0.1502236460623427, -9.931895002930352],
            [-0.14769604719645785, -9.92966027970926],
            [-0.14915864547706162, -9.92376776898482],
            [-0.1464764867062838, -9.919123540534898],
            [-0.14860350213034904, -9.913474736968212],
            [-0.15237693695229068, -9.911239376620022],
            [-0.1565447784534775, -9.906746659107036],
            [-0.15562381702828446, -9.899609770864346],
            [-0.1568503663909217, -9.895611329862572],
            [-0.16180489546338842, -9.895575851148841],
            [-0.16777332274139437, -9.893866288748757],
            [-0.17075798417189159, -9.88989963087506],
            [-0.16624557907573523, -9.887926702045617],
            [-0.16757180992936074, -9.882146655972033],
            [-0.16125673516227404, -9.880277306203599],
            [-0.16494953813140106, -9.876463703361912],
            [-0.16471666750251104, -9.872745993392005],
            [-0.16214634270870001, -9.868750402377204],
            [-0.15476865610500545, -9.86436591587977],
            [-0.15266371627650252, -9.86068422128234],
            [-0.15661590188662858, -9.85806401139823],
            [-0.16037626793392593, -9.86024597527698],
            [-0.16386315012757594, -9.856229867912214],
            [-0.16465896347141062, -9.852820907669713],
            [-0.16956866394334894, -9.849922300219689],
            [-0.17243753586601765, -9.842890703999927],
            [-0.1764152481621544, -9.840584947754323],
            [-0.1785918779739458, -9.834858779909892],
            [-0.17765121202276393, -9.83118991247668],
            [-0.17953106394937288, -9.823105089204496],
            [-0.18522464197190108, -9.818284231352678],
            [-0.18830355757249642, -9.82101283306052],
            [-0.19365516794142107, -9.817253785019293],
            [-0.20118438166308034, -9.815594880990107],
            [-0.20496956141771372, -9.812407231628184],
            [-0.2053545989056824, -9.80683435919144],
            [-0.21317884396808895, -9.806227879011086],
            [-0.21432820567650307, -9.799129170027726],
            [-0.216448822316588, -9.796300467900155],
            [-0.22328121820864213, -9.797123068304243],
            [-0.22617939552598354, -9.79434878344482],
            [-0.23012415143116619, -9.793886421263512],
            [-0.23012500911510234, -9.788699850833018],
            [-0.23197946074989031, -9.78672213883909],
            [-0.23146464428206256, -9.7826448857278],
            [-0.23705130319382645, -9.77932719040663],
            [-0.2387851997378297, -9.776516571105454],
            [-0.23777227793497496, -9.7729403246211],
            [-0.24135205608220228, -9.767248946877183],
            [-0.24101360433369282, -9.759876293891773],
            [-0.24393087292853302, -9.756694134393559],
            [-0.24504232312456162, -9.748136505287839],
            [-0.24187374076981805, -9.740697214543221],
            [-0.24565038693500124, -9.739334616176942],
            [-0.24751337979076404, -9.735686313427857],
            [-0.24668445720818336, -9.732309658534344],
            [-0.25223300108497604, -9.722179464257472],
            [-0.2508478191326384, -9.720296942895772],
            [-0.25567514356531446, -9.716442767461148],
            [-0.2562288991104799, -9.712988096798275],
            [-0.2601978916321998, -9.70591030717496],
            [-0.26075302343090445, -9.701551496946474],
            [-0.26466497154777396, -9.69219990250047],
            [-0.2674736515181868, -9.69233415198965],
            [-0.2704873429214517, -9.6881830601865],
            [-0.35746212735395333, -9.65003994280877]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.57764994040129, "lat": 28.95423128131181 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48239"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "239",
        "coty_gnis_code": "01383905"
      },
      "bbox": [
        -0.35746212735395333, -10.035847482866687, 0.1929008407311238,
        -9.454375156045487
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7810110228931713, -7.693797723614096],
            [1.8262832807258231, -7.682416593764896],
            [1.895457215547342, -7.664585398970745],
            [2.006194098172626, -7.636637780953834],
            [2.0599974738496853, -7.623247826315204],
            [2.119859919212413, -7.608164284477998],
            [2.1268620984357445, -7.606669504051463],
            [2.133325239993844, -7.602615880110949],
            [2.1369984616952777, -7.5941645068670365],
            [2.1365829618182643, -7.5869134912183185],
            [2.1825624118659768, -7.576016286005257],
            [2.245155734433161, -7.560943753762467],
            [2.263102889805626, -7.647367036607132],
            [2.2886291924766735, -7.769667616878129],
            [2.2884766285768325, -7.824593450101568],
            [2.288083979605549, -7.907782017238021],
            [2.287639107899166, -7.9846783362228715],
            [2.2867189445499156, -8.039482432950637],
            [2.2837479752407654, -8.14473889359766],
            [2.2816730900291002, -8.218914632522523],
            [2.279877575843702, -8.27518491670841],
            [2.2776115306390823, -8.352425908036173],
            [2.2752425254650763, -8.42056602238997],
            [2.2734371996518026, -8.459079534742097],
            [2.273664965594832, -8.469242438900414],
            [2.1896210065885957, -8.471605286330966],
            [2.1699189019423692, -8.472016263533218],
            [2.0872871091083156, -8.474101481071848],
            [2.0866505061113862, -8.47143371361384],
            [2.093445414713574, -8.468019614420353],
            [2.0964517513407035, -8.461809023224422],
            [2.10518413675098, -8.45688704119064],
            [2.099015580340201, -8.451217018497495],
            [2.0906688106258033, -8.453206678133622],
            [2.0924143810010944, -8.4477499016269],
            [2.0848981595723353, -8.430889811984034],
            [2.0891869847143436, -8.429039704048705],
            [2.086649102731582, -8.424245186559558],
            [2.0859569298037277, -8.415770075508545],
            [2.0889567211959945, -8.411199671152195],
            [2.0943280760413416, -8.409568697938841],
            [2.095125333188596, -8.406266351182769],
            [2.099257305485787, -8.402999226449628],
            [2.101028368757029, -8.398848839345707],
            [2.0984163430579406, -8.390372114164746],
            [2.103000098674001, -8.384437092124513],
            [2.10488204542491, -8.376901804950057],
            [2.108913411275127, -8.378702223787524],
            [2.1147655732006596, -8.373939469232262],
            [2.1150967715772326, -8.370490028126184],
            [2.113075816917101, -8.362726520699006],
            [2.1082398981667576, -8.365946526645699],
            [2.108335460647056, -8.361488504526244],
            [2.1032867719856356, -8.355949788061594],
            [2.100760336458, -8.355024298586983],
            [2.097635881604497, -8.347342200561938],
            [2.0994365022021086, -8.343181256830489],
            [2.0982159973227095, -8.335416474872279],
            [2.0938226556740336, -8.330533853739194],
            [2.0968599530183214, -8.324807427009507],
            [2.096024035652769, -8.32272684658495],
            [2.0912742380068186, -8.323073321172659],
            [2.088934581821214, -8.319598384434883],
            [2.084943569200135, -8.31973028328093],
            [2.0849175824393753, -8.314950494782835],
            [2.087997573997247, -8.314226678425605],
            [2.0876267062772595, -8.310676174806396],
            [2.0831400711002956, -8.310887144674656],
            [2.0827228727591116, -8.30776386477039],
            [2.0846443108172075, -8.299715911215467],
            [2.0866209969118366, -8.299036523786503],
            [2.0866230215651327, -8.293943358034708],
            [2.0830071272564608, -8.292410758385357],
            [2.086095708875579, -8.28880889963802],
            [2.084476352644334, -8.284797531614963],
            [2.0926603297184916, -8.279901158415424],
            [2.091929143167074, -8.267175457938993],
            [2.0995019212064876, -8.258929745908858],
            [2.1026924217913603, -8.251838315435835],
            [2.099743528945961, -8.25215664539062],
            [2.0952655497445973, -8.248839169978725],
            [2.100549930317242, -8.247151579226514],
            [2.1034967064922117, -8.243385450621926],
            [2.106591033885921, -8.232244191810617],
            [2.1126575691772014, -8.224433551269202],
            [2.114925517846468, -8.222829812819667],
            [2.1147174487136855, -8.214745138497529],
            [2.110859636204263, -8.211959201647023],
            [2.1157586450663675, -8.206484380341633],
            [2.121735486333037, -8.194943584107522],
            [2.1211031141318295, -8.191482859994716],
            [2.1239499981819225, -8.18915462913747],
            [2.1250209921981593, -8.185547439412382],
            [2.119179155801719, -8.181370750945852],
            [2.1217129833695125, -8.176577213764599],
            [2.1150201950360867, -8.17059248119767],
            [2.1084532573609995, -8.17065917544676],
            [2.108879245822014, -8.166125108413961],
            [2.106537288896377, -8.162871561451453],
            [2.107640646611503, -8.158302018685152],
            [2.101210845607101, -8.150921246736013],
            [2.1064375105325257, -8.149845829614382],
            [2.1056197627584132, -8.14288206511734],
            [2.10023725002064, -8.142773723039403],
            [2.101539775291349, -8.133913830328815],
            [2.1072140668657298, -8.132894868155525],
            [2.1067051203628258, -8.128736934424554],
            [2.1105193039290455, -8.126123228832313],
            [2.1075080692858785, -8.122432938081197],
            [2.1095621247778986, -8.119913824450679],
            [2.1130897067113845, -8.120157923988693],
            [2.1138194561445123, -8.115682220399556],
            [2.111079564094888, -8.11248369305887],
            [2.112652161839258, -8.11025289635113],
            [2.1172159778281374, -8.111000120406311],
            [2.12021985537048, -8.109554282998843],
            [2.120534342343907, -8.104997318879084],
            [2.1151917011622254, -8.102476355516396],
            [2.1156733774646357, -8.10028809451695],
            [2.1208917959099343, -8.097346629876204],
            [2.125821481525389, -8.097125262232113],
            [2.1270470645963453, -8.093714909372398],
            [2.1309304735365577, -8.092902918215938],
            [2.1325789812330433, -8.084875223021177],
            [2.13660419352879, -8.0794920021952],
            [2.1336834288377626, -8.072060734552727],
            [2.1345830118573756, -8.069691848940826],
            [2.1320093793507056, -8.063624090146511],
            [2.1287522394836467, -8.061894196464774],
            [2.1233553656400144, -8.055443219029003],
            [2.120215583065727, -8.055475658765152],
            [2.116344889414555, -8.051038424526613],
            [2.113807509496122, -8.052486106646102],
            [2.1116236865377878, -8.05788861722969],
            [2.1079840220841133, -8.06186967549827],
            [2.105663750018038, -8.059919628258369],
            [2.109069629983888, -8.052341653355843],
            [2.1031515697344934, -8.045724800861425],
            [2.1010261498217555, -8.03676840844985],
            [2.102674808415185, -8.033655875464465],
            [2.1009451507897823, -8.030956029001949],
            [2.096128635289646, -8.030082665395973],
            [2.0927873010853606, -8.031514006012715],
            [2.086856093436519, -8.031056309841302],
            [2.081027500623499, -8.034816679208465],
            [2.0714577832538943, -8.035636537621516],
            [2.0731057397656905, -8.030325492129856],
            [2.0725143848640313, -8.026398436616335],
            [2.073717952779967, -8.02101541930021],
            [2.072484763404355, -8.017294369370369],
            [2.06819904763206, -8.014107416496387],
            [2.060937546897419, -8.005825695486717],
            [2.0622838999554025, -8.003516769854045],
            [2.0673418997732287, -8.001494007780938],
            [2.066081576413623, -7.995212177964182],
            [2.0600806395086284, -7.98991400349612],
            [2.062992087123739, -7.980960901107378],
            [2.0677675701206177, -7.9755401401126935],
            [2.066074746145995, -7.968403026929524],
            [2.0600414697167047, -7.967567958167617],
            [2.058432773050406, -7.96277956564418],
            [2.063868071343578, -7.955789512430975],
            [2.0598147300487195, -7.949786102719049],
            [2.055242114717409, -7.94718915193794],
            [2.0578992817088326, -7.943077454313783],
            [2.056094905592581, -7.937898986332803],
            [2.048548299892607, -7.930668942614182],
            [2.0424980328550646, -7.9314369478581375],
            [2.0367540161883264, -7.930645185156114],
            [2.032737042386934, -7.927752083911131],
            [2.026304043467368, -7.92746837772769],
            [2.021548026781332, -7.923637174415622],
            [2.023696877603911, -7.92039899175327],
            [2.020937899465172, -7.917245896439592],
            [2.021845935955942, -7.911386906328446],
            [2.0185602405329073, -7.908843585757409],
            [2.0182054055224636, -7.905191747251001],
            [2.0146453239386557, -7.903550418434483],
            [2.0156768003703522, -7.8974156365259605],
            [2.0224025038200626, -7.899276112095347],
            [2.0203377798742737, -7.894998911088943],
            [2.0215740994049116, -7.891515389073683],
            [2.017079678851867, -7.890384532899199],
            [2.0187962851582615, -7.885290455775631],
            [2.013578863170769, -7.885020487000537],
            [2.010224113231039, -7.880416414699583],
            [2.011597081675581, -7.876458344525833],
            [2.0072279187977724, -7.871219367339262],
            [2.0062017039744044, -7.868290873336195],
            [2.0071603583216078, -7.862372232334644],
            [2.00409677583366, -7.8580193405868215],
            [2.009671676986475, -7.858452092128042],
            [2.009080297866697, -7.852437148536891],
            [2.0055276790305174, -7.848460967720122],
            [2.009509312632674, -7.84459046810997],
            [2.0076555423786178, -7.841167499541447],
            [1.9996616725588567, -7.835954711237193],
            [2.003857625553586, -7.830331375412326],
            [1.9962324744602693, -7.823738793983118],
            [1.990080474399917, -7.821170396592948],
            [1.9916351217435135, -7.814752717835781],
            [1.9940148456074682, -7.811920878938774],
            [1.9969519997968839, -7.8132553319686835],
            [1.9995301618207575, -7.805496400023985],
            [1.9962726575466232, -7.800713512191023],
            [2.003274412654229, -7.793471562894207],
            [1.998114772884595, -7.792910306222918],
            [2.0000616927433854, -7.788019863882661],
            [1.9944468970261282, -7.784824178379033],
            [1.9923068014146612, -7.7880683371811035],
            [1.9859458350375139, -7.788187620446061],
            [1.9810413702893024, -7.7833021591097316],
            [1.976135736822854, -7.775909692295734],
            [1.978693114502276, -7.771691982705948],
            [1.974049460251531, -7.770513349904848],
            [1.9788290868580072, -7.7654663685949],
            [1.9697548257380388, -7.763344433745032],
            [1.965589103348997, -7.7601576243468005],
            [1.9647356549248802, -7.754925973526476],
            [1.9682077648807956, -7.752950857561088],
            [1.9686499734370368, -7.749667451347421],
            [1.9646693534351285, -7.740780122267157],
            [1.9667947207899978, -7.734562997107977],
            [1.9728477056829605, -7.737620910096352],
            [1.9737205656076642, -7.7329316313788325],
            [1.9717415031948635, -7.726990490657411],
            [1.9677931790773286, -7.7208457355487],
            [1.9668100638269792, -7.715570878152247],
            [1.9690428389140275, -7.710620630017451],
            [1.9628438483081463, -7.712590428205065],
            [1.956803023825211, -7.705093148252832],
            [1.9510413536711708, -7.70436281135361],
            [1.9417561933631489, -7.7049941525343195],
            [1.9387548282419, -7.707721654556207],
            [1.9321059064874706, -7.7060853335639745],
            [1.9275893798122183, -7.697462760822477],
            [1.930459896003725, -7.688497898750815],
            [1.9273297352237537, -7.684320230332782],
            [1.9223579698496274, -7.682013665210964],
            [1.916337108040478, -7.683231306544387],
            [1.9170335752231613, -7.690243545085725],
            [1.9031500963780947, -7.70165798268185],
            [1.8946101429817979, -7.705171982252617],
            [1.8839496322958718, -7.695192594456497],
            [1.8847044872506207, -7.69139738659134],
            [1.8826245107692654, -7.688120563401498],
            [1.8779234295341412, -7.685790756115605],
            [1.8741550939039924, -7.687484355217266],
            [1.8697589927918825, -7.686311133868782],
            [1.8704758926509395, -7.690619899824602],
            [1.8613516289216487, -7.692472286084236],
            [1.8558413292573424, -7.6952416191187245],
            [1.848179840369113, -7.693820457515866],
            [1.8473521465595506, -7.697753697577165],
            [1.842371733342258, -7.696790750295695],
            [1.8423400531611138, -7.700027463747235],
            [1.8369524173040648, -7.697585686128833],
            [1.8330839995794943, -7.697444639063852],
            [1.8308399849644628, -7.701239247637802],
            [1.8268334918862295, -7.699009388775131],
            [1.8187066737462665, -7.699975370947133],
            [1.813677941847877, -7.704467655919885],
            [1.8088086583305796, -7.7054464882695175],
            [1.8071953362111528, -7.7104020645365745],
            [1.7999768692514557, -7.712940874884782],
            [1.8015276063703105, -7.719712476247451],
            [1.7930819889713658, -7.721540911857328],
            [1.7894295382924308, -7.7235206962858385],
            [1.7853358644148247, -7.7206581740815],
            [1.7873911451957996, -7.717435858175242],
            [1.787724043492517, -7.7081172987612705],
            [1.7909951124433279, -7.704295449587857],
            [1.7943239328509715, -7.69690723333726],
            [1.791609216727022, -7.692531954601657],
            [1.7865000032187077, -7.695566480270656],
            [1.7810110228931713, -7.693797723614096]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.02502667333785, "lat": 30.74399396727361 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48241"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "241",
        "coty_gnis_code": "01383906"
      },
      "bbox": [
        1.7810110228931713, -8.474101481071848, 2.2886291924766735,
        -7.560943753762467
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.280679890039239, -5.254722858386963],
            [-3.065107901588021, -5.264955191398278],
            [-3.059459864580571, -5.264721333200539],
            [-2.8554849644445026, -5.2739344128620385],
            [-2.8445936088846047, -5.2746366862631575],
            [-2.8453128448992597, -5.296994221100188],
            [-2.84631797375569, -5.308674718674178],
            [-2.849423633837408, -5.4185695513315055],
            [-2.851394583243558, -5.465719222545774],
            [-2.8563873438280667, -5.581930333227866],
            [-2.8612769283755357, -5.712453601824613],
            [-2.8873437004885067, -5.711229854805546],
            [-2.969655053653735, -5.708138752840326],
            [-2.9907388804712425, -5.707081883222401],
            [-3.10377619890511, -5.70094027058423],
            [-3.166279982970607, -5.697487566300205],
            [-3.30294550066394, -5.689958356532307],
            [-3.301283338734138, -5.659264641540112],
            [-3.3002908863997504, -5.652817130218396],
            [-3.299203825397135, -5.628298000522241],
            [-3.296417237212342, -5.578723627670595],
            [-3.29105724515561, -5.471377067404137],
            [-3.2890045441323763, -5.434373161569768],
            [-3.280679890039239, -5.254722858386963]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.25337438032201,
          "lat": 33.17918963433714
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48433"],
        "coty_name": ["Stonewall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stonewall County"],
        "coty_fp_code": "433",
        "coty_gnis_code": "01384002"
      },
      "bbox": [
        -3.30294550066394, -5.712453601824613, -2.8445936088846047,
        -5.254722858386963
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.25879030781974, -10.424213273965632],
            [-3.1718001407376124, -10.426999383504189],
            [-3.063890123991269, -10.43054898780113],
            [-2.9611495672066326, -10.433504518138374],
            [-2.9606359414489685, -10.433770440939744],
            [-2.8544662928928703, -10.436629325672964],
            [-2.7482961685796092, -10.439459014636643],
            [-2.64212555029142, -10.442259514711123],
            [-2.535954419793076, -10.445030832295542],
            [-2.5363105457642576, -10.468130357227633],
            [-2.5375233999189426, -10.61579797827843],
            [-2.508450193057021, -10.615298179494472],
            [-2.4220048510871925, -10.613392381574686],
            [-2.3355609847970427, -10.611466811540698],
            [-2.249118584174164, -10.609521483277781],
            [-2.1626776392006644, -10.607556410461656],
            [-2.1553605073259585, -10.607651271649166],
            [-2.0182660451205883, -10.605909682782798],
            [-2.019391675436894, -10.651261601274701],
            [-2.0251116508274536, -10.864739656405696],
            [-2.0260663555345064, -10.906445512896411],
            [-2.0308674034282292, -11.146737841856316],
            [-2.0335274527501075, -11.257190541467446],
            [-2.034457356286902, -11.293388535353378],
            [-2.036765107562459, -11.377244384631918],
            [-2.106686710659859, -11.374500769466938],
            [-2.176607618009883, -11.371743109648072],
            [-2.2528405254132755, -11.3686816737352],
            [-2.329072601198127, -11.36560354334998],
            [-2.35297146491512, -11.364211960120596],
            [-2.433972257300097, -11.3606317311177],
            [-2.51497199861212, -11.357032647983718],
            [-2.5464085512721804, -11.311106122220682],
            [-2.547520037265884, -11.31173694405816],
            [-2.6226113056564624, -11.361231412401471],
            [-2.63098623886319, -11.357633394921903],
            [-2.6386554970608493, -11.36077772761267],
            [-2.6468163661462287, -11.365308611814376],
            [-2.6504566025640566, -11.365780726330053],
            [-2.657133625184011, -11.360908890847409],
            [-2.660614630940959, -11.353377801422404],
            [-2.657791018999737, -11.345934221249776],
            [-2.6527766863740134, -11.33866962460103],
            [-2.652016224762081, -11.331017194089288],
            [-2.6576546743571625, -11.322420439667154],
            [-2.664195472066299, -11.319667367174418],
            [-2.6727474218064664, -11.321352621531666],
            [-2.6835720132825136, -11.320900083976495],
            [-2.6888545029453543, -11.318840832528815],
            [-2.6946754445116126, -11.312297478677712],
            [-2.6957052963703614, -11.307332051130095],
            [-2.689735724040605, -11.301476970435901],
            [-2.680670476930891, -11.300855291224353],
            [-2.6749704879769967, -11.297081909803131],
            [-2.66776366133086, -11.290942890961704],
            [-2.6650649010437855, -11.286670468416354],
            [-2.667808629816895, -11.278038556252655],
            [-2.667556316647425, -11.272571195513493],
            [-2.663534586513858, -11.262540323106245],
            [-2.659099144952303, -11.254432339614164],
            [-2.6526457114298956, -11.247462719068787],
            [-2.6526262625745356, -11.235958467755816],
            [-2.6494865685318487, -11.228980591183962],
            [-2.647358514846502, -11.216524625130425],
            [-2.653681468513134, -11.190427571656613],
            [-2.6526889279849364, -11.178123116012767],
            [-2.6456944223285745, -11.169433542653113],
            [-2.642055736320241, -11.163092841580562],
            [-2.640357424523847, -11.15434422355692],
            [-2.637572315456134, -11.152177851936393],
            [-2.6391677647600704, -11.142319533819823],
            [-2.6428816442873426, -11.137768828228802],
            [-2.652445241464615, -11.130664728095516],
            [-2.657643994156323, -11.129988272862303],
            [-2.6639509245556043, -11.131408211871788],
            [-2.6671595710238494, -11.130728067749336],
            [-2.6725998200304364, -11.133070884033236],
            [-2.679118866862512, -11.132702753583406],
            [-2.6805428725496503, -11.130827645550143],
            [-2.677446283097792, -11.119704577272273],
            [-2.676381814307082, -11.106129114445334],
            [-2.673785687263094, -11.095994605747132],
            [-2.6731747855066677, -11.086927768476395],
            [-2.670079690866863, -11.0781462410894],
            [-2.6656699359239666, -11.074740846174679],
            [-2.662809897013517, -11.067365269399508],
            [-2.6636565900755476, -11.06381565931341],
            [-2.6668535935798, -11.059753454357404],
            [-2.6751083950359127, -11.055074888421846],
            [-2.6791572442885934, -11.051411080371912],
            [-2.684124250807661, -11.040011860665532],
            [-2.684499741215211, -11.035511731203247],
            [-2.688657801254855, -11.025846779630337],
            [-2.6999624594164073, -11.017167438480525],
            [-2.7034654439410697, -11.022454502697505],
            [-2.722707795456387, -11.028260447222047],
            [-2.7264966688110115, -11.024246460103795],
            [-2.7222714028726815, -11.022625304253209],
            [-2.720064622332023, -11.01990465311103],
            [-2.7203763796724703, -11.011778470211535],
            [-2.726215184526754, -11.008813742868929],
            [-2.732700617401464, -11.002113566990612],
            [-2.733824355533221, -10.992331929326957],
            [-2.7421388630406853, -10.988679137530005],
            [-2.7530278760160054, -10.992420460312639],
            [-2.757719432013119, -10.986804672239836],
            [-2.762360972368992, -10.987475833008943],
            [-2.7632514978979463, -10.991391459601902],
            [-2.759946828295635, -10.99520011770601],
            [-2.761926132285852, -10.998555537370898],
            [-2.7687115074877364, -11.001496854735562],
            [-2.774194048888798, -11.002377309084153],
            [-2.7843580768593963, -10.998340101241563],
            [-2.7877764846014528, -10.999070669885809],
            [-2.7978702399338116, -10.992477081533698],
            [-2.797237173936799, -10.988288963048932],
            [-2.7938694784375504, -10.986006705369919],
            [-2.7905087151235257, -10.981194892191304],
            [-2.7912273880361576, -10.976453603564586],
            [-2.795507181612237, -10.971434594796944],
            [-2.7996103733403395, -10.968932688857947],
            [-2.8085450205583733, -10.969566661364954],
            [-2.8151714785770485, -10.96689757273949],
            [-2.81910645940427, -10.959624784868831],
            [-2.824052090240342, -10.964909663745072],
            [-2.826825118839833, -10.972353681687288],
            [-2.8315061298685826, -10.972627450007444],
            [-2.8375168852164725, -10.96906083107174],
            [-2.8461105085971914, -10.961111110744353],
            [-2.8477837630145175, -10.95403026107485],
            [-2.859571061839226, -10.935034823177755],
            [-2.8763311197660766, -10.915236771216701],
            [-2.8770097066989027, -10.910104830086745],
            [-2.8796528851610663, -10.904602800440006],
            [-2.887258356717693, -10.894966594168519],
            [-2.8908986389890017, -10.893448751872585],
            [-2.900319930000087, -10.89619734106711],
            [-2.9058682016853585, -10.894391837529657],
            [-2.9098611375153753, -10.890704495541469],
            [-2.9143301613004846, -10.884476241311189],
            [-2.9172251092822634, -10.867805979294957],
            [-2.920758051077699, -10.8570374753921],
            [-2.9232003024056925, -10.852630537082232],
            [-2.9284495195660147, -10.850400182267325],
            [-2.931569303166875, -10.859246824047158],
            [-2.9348649330874057, -10.86154489743888],
            [-2.9432121800075066, -10.862675647785993],
            [-2.946413068265356, -10.861276258555069],
            [-2.9499828134306343, -10.85652827447609],
            [-2.9511031436713857, -10.84677167167472],
            [-2.954425682884278, -10.838230793134882],
            [-2.95594188359074, -10.831733890595762],
            [-2.964388338982972, -10.831691831769902],
            [-2.972946361066214, -10.830415868269762],
            [-2.9785927950347024, -10.827515142703025],
            [-2.979718194401197, -10.824177629644096],
            [-2.97641711932708, -10.815946991773794],
            [-2.975734662634757, -10.809721923756669],
            [-2.9786374635141217, -10.801061734935196],
            [-2.9786148602869966, -10.79756703648978],
            [-2.9764557252290933, -10.787840064929407],
            [-2.9773482702548053, -10.783680704243366],
            [-2.9812834879819436, -10.775480016392255],
            [-2.9879416297899546, -10.77184262987043],
            [-2.993111159271205, -10.767863084276216],
            [-2.9979901212846376, -10.761322001910372],
            [-3.0001059337984746, -10.750343448989184],
            [-2.9995864815281004, -10.745994036400562],
            [-2.9969373918626485, -10.741536525031131],
            [-2.9929298626311067, -10.737758525971708],
            [-2.9902577368760164, -10.733436715913959],
            [-2.9894395126780986, -10.727339529747418],
            [-2.9921240479321876, -10.718927206388395],
            [-2.9947825964786676, -10.714453701629315],
            [-3.0099476912642995, -10.708128001449593],
            [-3.017332499666393, -10.69866886946861],
            [-3.01534245260536, -10.695016735682396],
            [-3.0172165517262575, -10.69059523471572],
            [-3.0228045400341528, -10.688699445156061],
            [-3.026458319204688, -10.685349592057788],
            [-3.027704575835884, -10.676689683471581],
            [-3.027139687683424, -10.672071854502928],
            [-3.02315484861064, -10.664961988938362],
            [-3.02092553946618, -10.65894743870674],
            [-3.020070160149933, -10.645989938224488],
            [-3.0362664102767476, -10.643076325515],
            [-3.047377303241872, -10.642356866765146],
            [-3.054703829009206, -10.639382407973844],
            [-3.059794028514782, -10.636102349662083],
            [-3.0666944485950376, -10.634512559469917],
            [-3.070889256589085, -10.632235088343094],
            [-3.076760672423621, -10.62267668386878],
            [-3.0793640030756277, -10.614364268872484],
            [-3.0853717263567866, -10.60417309779744],
            [-3.0894572600210433, -10.58801250638198],
            [-3.089564864545558, -10.58086348071381],
            [-3.090866664874192, -10.576505068884911],
            [-3.0927865390971974, -10.560827750339481],
            [-3.0950295858094896, -10.557761270194156],
            [-3.1019985278719533, -10.552274654342666],
            [-3.11712220863675, -10.545807734299052],
            [-3.1230862505075048, -10.540005015895051],
            [-3.1260970420736363, -10.530584094356866],
            [-3.124575687146413, -10.523847135073884],
            [-3.128237310035228, -10.516764718425978],
            [-3.1347047253732456, -10.511198888468904],
            [-3.1387451258024757, -10.502559429495959],
            [-3.143018620060159, -10.496074514472244],
            [-3.1469006245312126, -10.484437579309331],
            [-3.1473185721344827, -10.480812559644436],
            [-3.153229673676894, -10.476365395290594],
            [-3.1688584904540282, -10.470790673209923],
            [-3.1788432081609264, -10.468139201107178],
            [-3.197269654636498, -10.455026455191254],
            [-3.212184528212541, -10.455071574416865],
            [-3.2212763125955926, -10.450664384702558],
            [-3.226208943206904, -10.442693231607356],
            [-3.235896334331021, -10.436059138991107],
            [-3.245245181578971, -10.43129907858934],
            [-3.255448290335637, -10.430693191890565],
            [-3.25879030781974, -10.424213273965632]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.33152991717196, "lat": 27.76110373697804 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48479"],
        "coty_name": ["Webb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webb County"],
        "coty_fp_code": "479",
        "coty_gnis_code": "01384025"
      },
      "bbox": [
        -3.25879030781974, -11.377244384631918, -2.0182660451205883,
        -10.424213273965632
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9852562058145504, -5.305782726622934],
            [-1.9197795315578867, -5.30812957256397],
            [-1.8179333391890793, -5.312453243418974],
            [-1.816563657073714, -5.312707360398515],
            [-1.711075749062803, -5.315914969314039],
            [-1.6093223055857435, -5.318024596627045],
            [-1.607173275705753, -5.318189180501098],
            [-1.5432813887054544, -5.3195718494252],
            [-1.5436314588031141, -5.340713073781216],
            [-1.5441009962906944, -5.34667662884002],
            [-1.546004657977561, -5.418052100937741],
            [-1.549181637727298, -5.493073832082851],
            [-1.5525340585888239, -5.560359027900123],
            [-1.5551249340532358, -5.627608744528807],
            [-1.5581388073248532, -5.708352587654332],
            [-1.5591173750161538, -5.726989199202811],
            [-1.560115970582855, -5.764003102641715],
            [-1.636622055904644, -5.7606088295847115],
            [-1.6837736773314629, -5.758712188831383],
            [-1.7934424806982239, -5.753603628832373],
            [-1.8493061804038375, -5.751387370003862],
            [-1.9403305674230609, -5.748489599627395],
            [-1.9964851551213156, -5.747090689077343],
            [-1.9950550335835644, -5.689654145024422],
            [-1.9927040095461022, -5.592512516576727],
            [-1.991356711922333, -5.536614728350757],
            [-1.9883857165697345, -5.417602273726948],
            [-1.9872081699735935, -5.370555202823797],
            [-1.9852562058145504, -5.305782726622934]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.68776913028293, "lat": 33.17664295652906 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48503"],
        "coty_name": ["Young"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Young County"],
        "coty_fp_code": "503",
        "coty_gnis_code": "01384037"
      },
      "bbox": [
        -1.9964851551213156, -5.764003102641715, -1.5432813887054544,
        -5.305782726622934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.928535766747435, 4.254493290953512],
            [-10.906839755536003, 4.250995068529408],
            [-10.885585655419971, 4.248154983636133],
            [-10.789120663483045, 4.23342949122344],
            [-10.686790738254324, 4.217171238470117],
            [-10.592349556832646, 4.202332016486536],
            [-10.627268423696604, 3.981962568425353],
            [-10.658693603422627, 3.783579308070293],
            [-10.668008107456599, 3.725738405839021],
            [-10.69113098738478, 3.5829044556038103],
            [-10.69408552071222, 3.566017583283496],
            [-10.711381273537787, 3.4576535933130446],
            [-10.71974478737603, 3.4589014467300303],
            [-10.724935019586121, 3.4583170563145322],
            [-10.734279343225202, 3.4527957108403307],
            [-10.74040794727047, 3.4447570172661837],
            [-10.747895325789676, 3.4370212638355135],
            [-10.755373771931788, 3.424439565220811],
            [-10.758879615511653, 3.4204855034080937],
            [-10.764226132548988, 3.42845253684332],
            [-10.773641771916145, 3.4239878252518112],
            [-10.78240963452668, 3.423300363268642],
            [-10.781107191754133, 3.4136996584416104],
            [-10.791383222873357, 3.407973060191124],
            [-10.791313519754004, 3.4046483067749813],
            [-10.80377880811458, 3.398878676560845],
            [-10.807783902682411, 3.396061278283372],
            [-10.81247002242858, 3.396883347419044],
            [-10.819572077126232, 3.3920769706947502],
            [-10.828779267616925, 3.3928696717086853],
            [-10.83507560556476, 3.3901174104685046],
            [-10.843281522318392, 3.3877129443550715],
            [-10.857300950527817, 3.37928384786524],
            [-10.860345815313039, 3.3754483449700565],
            [-10.866042701861112, 3.3716197705128783],
            [-10.87233108165349, 3.371738724239039],
            [-10.874301815197414, 3.3753132729887994],
            [-10.888334165938055, 3.373370296082834],
            [-10.889561791330529, 3.3766050140452064],
            [-10.878080080149612, 3.3877386073026474],
            [-10.87322222082169, 3.391277432823243],
            [-10.865259981178726, 3.3995307967752733],
            [-10.860654776737986, 3.406202839317032],
            [-10.862199232725075, 3.410871269842636],
            [-10.856488046343703, 3.4143840549564337],
            [-10.852986060709195, 3.4188365498346185],
            [-10.85648782589295, 3.426078383031863],
            [-10.854822501152215, 3.4318616514513574],
            [-10.846447926532191, 3.4396563931936712],
            [-10.846478103309833, 3.442291109540698],
            [-10.854520601773075, 3.446613828372954],
            [-10.861713859972019, 3.444801574466714],
            [-10.867871190863749, 3.444850125942301],
            [-10.871230699852878, 3.448456190260606],
            [-10.868148861028148, 3.453308792720269],
            [-10.867657422006422, 3.4596339414230415],
            [-10.88456577752817, 3.459054247394676],
            [-10.889137781221084, 3.460347818594777],
            [-10.887590676201256, 3.464292135180966],
            [-10.88301402921544, 3.4674494653231673],
            [-10.878060076272602, 3.4692656618890214],
            [-10.878291263943757, 3.473133763766579],
            [-10.882296341076325, 3.478255703950967],
            [-10.879958103031516, 3.4900644107624266],
            [-10.882371168185921, 3.4950816467661516],
            [-10.876984896247158, 3.4972535780457648],
            [-10.87712044372297, 3.5105190804066124],
            [-10.870805381742697, 3.51573520998306],
            [-10.863920739309535, 3.5181199247612502],
            [-10.861838792472044, 3.5217175672212213],
            [-10.862621521771581, 3.5278431684478675],
            [-10.871619936227786, 3.5323276138929423],
            [-10.871266120245046, 3.5337808468707936],
            [-10.878999653942573, 3.5395936241378423],
            [-10.877000140763453, 3.542039099997942],
            [-10.883055888308224, 3.544122599079939],
            [-10.884134911830788, 3.5477607287210993],
            [-10.882671797056325, 3.5545012303165024],
            [-10.881585220408667, 3.5648392146209615],
            [-10.888669294865574, 3.569759352309618],
            [-10.89531983657354, 3.5778041451762657],
            [-10.896920840558376, 3.5814568096893393],
            [-10.902587782265597, 3.5840236474893685],
            [-10.901517042998558, 3.5917964534477704],
            [-10.904382710551532, 3.5965678389242655],
            [-10.910802648051842, 3.595560164659879],
            [-10.914866198820063, 3.6001853146009517],
            [-10.915336173411077, 3.603264282178631],
            [-10.919398955657176, 3.604461029610059],
            [-10.929578002239014, 3.6049339826671076],
            [-10.929519438525642, 3.608625260379595],
            [-10.940072787119407, 3.619176807774444],
            [-10.948983052519713, 3.619973072005174],
            [-10.955083560092719, 3.616871876649631],
            [-10.957003000571966, 3.609977764663603],
            [-10.966750936044628, 3.6115610629567456],
            [-10.969011509413525, 3.6110047845069206],
            [-10.970720673707278, 3.613152432638449],
            [-10.978760306864448, 3.6136408553371004],
            [-10.980591796948517, 3.6184193094089387],
            [-10.984010247801013, 3.618471851371731],
            [-10.987102208437665, 3.620929793841017],
            [-10.987044767330048, 3.6257337163695125],
            [-10.996349886727295, 3.628605762965893],
            [-10.996260253262905, 3.6328346321692626],
            [-10.998750921373848, 3.635910282246965],
            [-11.007051273167543, 3.6407161718513583],
            [-11.00662743595223, 3.646988056364035],
            [-11.00292748609322, 3.655827552631836],
            [-11.007490453228986, 3.658173065907534],
            [-11.00920442979504, 3.6620442721688726],
            [-11.013405235880958, 3.6626438345069596],
            [-11.019407586481654, 3.667796209267204],
            [-11.019555692454345, 3.6707307312507407],
            [-11.02452397891635, 3.673870877215579],
            [-11.02272177642837, 3.677746933909356],
            [-11.025083678188588, 3.6832163248774465],
            [-11.024052513375675, 3.6880537685004415],
            [-11.021081487491754, 3.6893361716791357],
            [-11.020449094767944, 3.6925939257705123],
            [-11.015294848615637, 3.696607317536101],
            [-11.018017823231007, 3.702200823688826],
            [-11.014942166546088, 3.708518574831027],
            [-11.01380468567677, 3.7183355795781203],
            [-11.01093974173824, 3.7229999195802628],
            [-11.002481720103832, 3.7237743121853444],
            [-11.00218866756914, 3.7294713523173493],
            [-10.994744132777587, 3.7331706321032208],
            [-10.995000806536966, 3.7349789105528943],
            [-10.990935999017864, 3.742365556078012],
            [-10.98852837979929, 3.74393569643636],
            [-10.986154955786796, 3.755479259912187],
            [-10.98795677756298, 3.7592874267617002],
            [-10.97886882271053, 3.763482309855029],
            [-10.976137619275683, 3.7689198482572364],
            [-10.969078632835606, 3.7741266082815144],
            [-10.967973854524793, 3.779572646266352],
            [-10.961858108287968, 3.783387359602573],
            [-10.957736239821095, 3.7824327938831703],
            [-10.956113741075589, 3.7859996964194433],
            [-10.956819548946433, 3.7960202579741855],
            [-10.954236726659875, 3.7998354763275803],
            [-10.947142176354362, 3.8027469710000865],
            [-10.94416836450892, 3.8122255302889445],
            [-10.941878760795495, 3.8162181696603015],
            [-10.940980225354204, 3.826174158172536],
            [-10.938626848952413, 3.827615324212412],
            [-10.936968199050842, 3.8345544477369446],
            [-10.937980339803522, 3.8390099978097623],
            [-10.936089394210764, 3.841494542450669],
            [-10.933787686964882, 3.8578547751253502],
            [-10.932667563474983, 3.859186636806894],
            [-10.933841882647684, 3.867235006495987],
            [-10.92775979442231, 3.8719909805682087],
            [-10.924275366276337, 3.8697828499004343],
            [-10.918319037793072, 3.8739110871661366],
            [-10.91850862646419, 3.8784211300137383],
            [-10.92069297370179, 3.886225146392354],
            [-10.914013749484624, 3.8910257569806723],
            [-10.913022060571791, 3.8951635500423736],
            [-10.907377936292217, 3.8992634897224705],
            [-10.906915490117992, 3.9044653796898676],
            [-10.909651516894964, 3.9088037212729834],
            [-10.90927577462541, 3.9124113352904386],
            [-10.913862784767085, 3.9125731960813557],
            [-10.91416337943699, 3.9228100540789352],
            [-10.920140875923513, 3.922208370969034],
            [-10.921941554003679, 3.925864848883408],
            [-10.917632483367598, 3.939768094044659],
            [-10.919264229322705, 3.9424047811652456],
            [-10.913816611027286, 3.9458376411519227],
            [-10.913175862450071, 3.9534359791248055],
            [-10.910360584092878, 3.9559645411293483],
            [-10.908228531220002, 3.9669245472017947],
            [-10.909475544003447, 3.971471862571452],
            [-10.915633978589138, 3.974819191932154],
            [-10.92025957728063, 3.9818793910604766],
            [-10.92309330708948, 3.984449865397979],
            [-10.921713754717848, 3.989516171884326],
            [-10.924465475702451, 3.994551186906389],
            [-10.921492514745987, 3.997225203091622],
            [-10.919640841902343, 4.004932282200825],
            [-10.922112086378299, 4.00979701731343],
            [-10.918839514674888, 4.0208123559769],
            [-10.92321669719189, 4.021894914804305],
            [-10.925710607984392, 4.030072148494738],
            [-10.924058852856792, 4.038706358711177],
            [-10.92081223136975, 4.0424776076698326],
            [-10.921195450931242, 4.0539240808376995],
            [-10.924910737707032, 4.059285600016792],
            [-10.92569404439853, 4.0636570910437175],
            [-10.924106977957942, 4.069210669560252],
            [-10.928171903081425, 4.076511385595014],
            [-10.933466343185499, 4.081916201329818],
            [-10.93597064314142, 4.0877499711203304],
            [-10.943888170248288, 4.097710774247938],
            [-10.948752967748325, 4.106006581097716],
            [-10.952575989735474, 4.108802111453323],
            [-10.946999536824604, 4.116815643453755],
            [-10.94972011809849, 4.120466654213568],
            [-10.948177473105801, 4.1235307680616025],
            [-10.93824488171639, 4.1292389382879815],
            [-10.936095930192407, 4.137805623710292],
            [-10.936533826599629, 4.141291336914567],
            [-10.94339271455517, 4.143401419192906],
            [-10.940946796778537, 4.146472905934225],
            [-10.93972003413981, 4.153136923106575],
            [-10.942074751460142, 4.1578963076320745],
            [-10.947051906379338, 4.1613739425217755],
            [-10.943613732641754, 4.167726459782548],
            [-10.941317542119096, 4.166622524376457],
            [-10.935271497649822, 4.167366073668936],
            [-10.931100973294537, 4.164251715905785],
            [-10.923712802196272, 4.163940311062805],
            [-10.920835814993179, 4.165583321309492],
            [-10.920584901760456, 4.169365000545698],
            [-10.91374504394717, 4.179481393618453],
            [-10.916398759368564, 4.187064577993284],
            [-10.914214357760876, 4.194409796169295],
            [-10.911955265187997, 4.198288707250802],
            [-10.914037001100544, 4.205680151135655],
            [-10.912159304383046, 4.208039513176518],
            [-10.914022834514224, 4.213958795981868],
            [-10.91659646089943, 4.216265825922897],
            [-10.915579572489964, 4.228072928722617],
            [-10.921873865824448, 4.233215392434654],
            [-10.923807808473546, 4.239515911528061],
            [-10.930534767962836, 4.243083317337203],
            [-10.928535766747435, 4.254493290953512]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.24442769298031,
          "lat": 41.632275435970804
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49033"],
        "coty_name": ["Rich"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rich County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01448030"
      },
      "bbox": [
        -11.025083678188588, 3.3716197705128783, -10.592349556832646,
        4.254493290953512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.065834087406968, 10.426881574293327],
            [-14.99584400738275, 10.409940023739297],
            [-14.925857867054669, 10.392981880572004],
            [-14.855875697012081, 10.376007151102838],
            [-14.785897527835157, 10.359015841672464],
            [-14.711295551554944, 10.34104290368201],
            [-14.629515446772523, 10.321786689926387],
            [-14.611755500934857, 10.317915401583926],
            [-14.511747469977124, 10.294461905867024],
            [-14.487368980606577, 10.288563696267236],
            [-14.46304688888602, 10.282106141687569],
            [-14.390154194249652, 10.265590606281915],
            [-14.398811029518287, 10.227899397275706],
            [-14.420916948761706, 10.133694812861098],
            [-14.42175499909238, 10.130823038410213],
            [-14.434708506193603, 10.075137711305334],
            [-14.445012767437854, 10.033348844794208],
            [-14.46426419074571, 9.951586464771685],
            [-14.467881559976522, 9.935623280796733],
            [-14.47306193693575, 9.93684403388598],
            [-14.486467837709515, 9.891971294476416],
            [-14.491197550895707, 9.889112323126184],
            [-14.498482491508199, 9.88952944657535],
            [-14.500224253362164, 9.885959434150914],
            [-14.509429975663771, 9.879801829836078],
            [-14.512968796360537, 9.879127728080801],
            [-14.514689177813993, 9.87471895200976],
            [-14.514666486649153, 9.8698860462728],
            [-14.50737245813862, 9.86743843782758],
            [-14.508903830223874, 9.86161335885457],
            [-14.51241742479253, 9.860207182146437],
            [-14.514881446866228, 9.856182190401096],
            [-14.514460325557346, 9.85343696469143],
            [-14.521499854087871, 9.851109657454627],
            [-14.526568942333231, 9.84820804708587],
            [-14.529951670331688, 9.84982195122844],
            [-14.531786237427736, 9.846986609825956],
            [-14.531272489837669, 9.838787662243199],
            [-14.53345258503869, 9.8342264290078],
            [-14.531697991517008, 9.825413801650491],
            [-14.535139393785215, 9.820256812354714],
            [-14.538427778177534, 9.819130304924352],
            [-14.541275791032424, 9.824668330821792],
            [-14.548683924434393, 9.823551462077557],
            [-14.552170919091605, 9.81944627172911],
            [-14.55587930251477, 9.811247330383942],
            [-14.560636161400753, 9.809396231682115],
            [-14.563478145315852, 9.811625238801785],
            [-14.57461133152278, 9.816917477281196],
            [-14.576479040642287, 9.821478000366136],
            [-14.580958491409596, 9.821205869752836],
            [-14.58989790885777, 9.827069965772834],
            [-14.594313132299884, 9.822132807088632],
            [-14.600958303580173, 9.822812200179659],
            [-14.607674507969202, 9.817030611829944],
            [-14.614475640107614, 9.815057147344154],
            [-14.620782232081211, 9.81524661270407],
            [-14.625738265090304, 9.816601893671601],
            [-14.631038429241817, 9.816038471780882],
            [-14.635000063529162, 9.81780154799818],
            [-14.635690126253065, 9.811933752384595],
            [-14.642620072316094, 9.806656072252085],
            [-14.653265882525764, 9.80949864911555],
            [-14.65650310209543, 9.811262925769817],
            [-14.65946576942466, 9.815573378659387],
            [-14.666621034094323, 9.812785444946885],
            [-14.67258092730687, 9.806788261730654],
            [-14.675977576126902, 9.806695838727471],
            [-14.762639407773252, 9.825577686201445],
            [-14.775940951782943, 9.827992913282369],
            [-14.839094572449222, 9.842949116866333],
            [-14.90225118543036, 9.857892342594816],
            [-14.971851676109901, 9.87384821576506],
            [-15.008471096102186, 9.882521839549522],
            [-15.072675265013764, 9.898135161148845],
            [-15.136882652520994, 9.91373501994945],
            [-15.194048240893034, 9.928052304676871],
            [-15.258167000800446, 9.94491886397306],
            [-15.321975175833371, 9.960804054197787],
            [-15.366910804419875, 9.972084897691813],
            [-15.450837038290244, 9.99216829027093],
            [-15.436763860797818, 10.047245955534674],
            [-15.418492830309921, 10.116677358705282],
            [-15.417805600687448, 10.120353405838145],
            [-15.40793351481099, 10.158361489589218],
            [-15.349549001148597, 10.143926993553384],
            [-15.320619880994725, 10.136516458077194],
            [-15.253191189323413, 10.11998782887739],
            [-15.215291923478311, 10.110309540886027],
            [-15.15122555647948, 10.094258966669102],
            [-15.140070797226123, 10.137252666915058],
            [-15.109071269461905, 10.258463865620298],
            [-15.087352780683947, 10.343856032468246],
            [-15.079799494656953, 10.371517984844264],
            [-15.065834087406968, 10.426881574293327]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.56057145214562,
          "lat": 46.98337549658684
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01531601"
      },
      "bbox": [
        -15.450837038290244, 9.806656072252085, -14.390154194249652,
        10.426881574293327
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.065977647740218, 4.397520248388595],
            [6.126745988186363, 4.402439278085164],
            [6.151854065078289, 4.4052697537322],
            [6.198659557873849, 4.409513451944939],
            [6.237663323919752, 4.412857273364723],
            [6.302048418077203, 4.418543827885121],
            [6.323371263014493, 4.420281636974084],
            [6.350919145638692, 4.421790139860181],
            [6.365631589896257, 4.4230909960731095],
            [6.402148437961442, 4.425555168935198],
            [6.414104919143198, 4.4266869536176365],
            [6.416678474154549, 4.419381411735806],
            [6.426558075068212, 4.407729211070459],
            [6.441309681423867, 4.392787291902298],
            [6.457150909560076, 4.381333298677632],
            [6.462167236076665, 4.378644459578881],
            [6.46961168630204, 4.370990393206547],
            [6.469449116297317, 4.368520679163378],
            [6.4651697121007725, 4.365874471196648],
            [6.459212543308475, 4.357827708140606],
            [6.456563638440444, 4.350411737937469],
            [6.455082891882399, 4.337430016716041],
            [6.455736162711102, 4.331011127212977],
            [6.459061397628088, 4.321582820235556],
            [6.457379248352553, 4.3176915524258135],
            [6.459321422265046, 4.314884933814809],
            [6.460493630537786, 4.306538825638064],
            [6.458532157237862, 4.305501208560582],
            [6.4582532893023075, 4.295579327144373],
            [6.456931322766489, 4.2880131280951534],
            [6.4507450833459306, 4.276502149051453],
            [6.449337607109413, 4.269802562586252],
            [6.446033294525339, 4.261493153519436],
            [6.4446604205966915, 4.253791302338483],
            [6.422808684119783, 4.251867076486596],
            [6.387132160604754, 4.249791480253022],
            [6.33707017234351, 4.246291742571945],
            [6.2834945223107646, 4.241840776371339],
            [6.241971304116197, 4.238650252901445],
            [6.22274009866867, 4.236542405964162],
            [6.180196445958495, 4.232729515535847],
            [6.166003375507208, 4.23216917784773],
            [6.170912365810832, 4.1739188378120495],
            [6.143590882431903, 4.171400613466592],
            [6.085151223682826, 4.166282647639188],
            [6.080860037502163, 4.215040103091215],
            [6.080440484884064, 4.224217611397263],
            [6.077403774912421, 4.253130857534233],
            [6.071802995611693, 4.310836263067262],
            [6.067252068885205, 4.376974714331286],
            [6.065977647740218, 4.397520248388595]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.06132005266757,
          "lat": 42.747445574024425
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55101"],
        "coty_name": ["Racine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Racine County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01581111"
      },
      "bbox": [
        6.065977647740218, 4.166282647639188, 6.46961168630204,
        4.4266869536176365
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": 145.69307761422834,
          "lat": 17.947980881494754
        },
        "year": "2023",
        "ste_code": ["69"],
        "ste_name": ["Commonwealth of the Northern Mariana Islands"],
        "coty_code": ["69085"],
        "coty_name": ["Northern Islands"],
        "coty_area_code": "MNP",
        "coty_type": "municipality",
        "coty_name_long": ["Northern Islands Municipality"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01805245"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.79165404775598,
          "lat": 18.040595342789814
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72059"],
        "coty_name": ["Guayanilla"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Guayanilla Municipio"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01804510"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.01235446783184, "lat": 18.03178312128232 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72109"],
        "coty_name": ["Patillas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Patillas Municipio"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01804535"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.89650875880912, "lat": 18.07067540725217 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72151"],
        "coty_name": ["Yabucoa"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Yabucoa Municipio"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01804556"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-16.838543073963585, -11.543079048074611],
              [-16.837178812539793, -11.542002035656445],
              [-16.837041807245583, -11.54083411481989],
              [-16.838467737040123, -11.537301458868022],
              [-16.837264461855447, -11.535325232311843],
              [-16.83617597461936, -11.535204863377688],
              [-16.83369083970713, -11.532369961487735],
              [-16.833465705264377, -11.531242865887407],
              [-16.835120877017914, -11.528710992183024],
              [-16.835924337880353, -11.526841688985874],
              [-16.83448489267853, -11.525461722711638],
              [-16.834026362294498, -11.523467079337744],
              [-16.832335444135296, -11.523112574606705],
              [-16.829773117156517, -11.521395623334753],
              [-16.828893846674116, -11.518957734774077],
              [-16.827995634745072, -11.518412722483074],
              [-16.826957315363245, -11.519455190865905],
              [-16.823664639009557, -11.520037693211107],
              [-16.82338406759348, -11.520588335056786],
              [-16.820843774166043, -11.522141365005597],
              [-16.81965726538624, -11.52494392409903],
              [-16.819405279638893, -11.527217867284982],
              [-16.820595775726, -11.53332953520825],
              [-16.819945252593925, -11.534471426764222],
              [-16.820270966966945, -11.536464275586967],
              [-16.820001673863327, -11.537963781318608],
              [-16.821789264078156, -11.543280699988928],
              [-16.822213254273848, -11.546269523834303],
              [-16.82398008073581, -11.54705964971177],
              [-16.824794742317458, -11.548853873380418],
              [-16.82579705982864, -11.54897243014525],
              [-16.827530125012597, -11.550796533466077],
              [-16.829247059091777, -11.551800059144856],
              [-16.830897764227142, -11.553491962521703],
              [-16.832147251764937, -11.554092053762014],
              [-16.83470407957876, -11.552188022412397],
              [-16.83470097752541, -11.54826278938668],
              [-16.83822838237887, -11.54604425022533],
              [-16.838543073963585, -11.543079048074611]
            ]
          ],
          [
            [
              [-16.86954317785504, -11.29691238684621],
              [-16.868944294123217, -11.294780915603724],
              [-16.86669031522745, -11.296384975282653],
              [-16.86465268160645, -11.294422079276586],
              [-16.86188909395334, -11.29311394492186],
              [-16.858665283761106, -11.294222401622392],
              [-16.85719733480051, -11.29529840753034],
              [-16.857579890453074, -11.296747568981038],
              [-16.860747117755235, -11.29680066448202],
              [-16.86171766569565, -11.297950227329911],
              [-16.863675578228506, -11.297649069127335],
              [-16.864120090340496, -11.298507839521246],
              [-16.8669026350166, -11.299245680532726],
              [-16.869073199107426, -11.298991942817258],
              [-16.86954317785504, -11.29691238684621]
            ]
          ],
          [
            [
              [-16.87409475305843, -11.306498483444798],
              [-16.873186411733847, -11.305351113923141],
              [-16.870179256028916, -11.305602299525974],
              [-16.87043678676512, -11.307006287851587],
              [-16.87268392240174, -11.307811888253077],
              [-16.87409475305843, -11.306498483444798]
            ]
          ],
          [
            [
              [-16.87931426583791, -11.294445709855918],
              [-16.87758832767066, -11.29346658673247],
              [-16.876313386347128, -11.289562601375014],
              [-16.877328791189683, -11.288514144893806],
              [-16.876825801635594, -11.287443618277479],
              [-16.875196395310226, -11.286847618978],
              [-16.873610293963967, -11.287667866257816],
              [-16.87261155606745, -11.286730652902236],
              [-16.8731669777679, -11.285331497344757],
              [-16.872260832447346, -11.284882790674267],
              [-16.871230428462063, -11.285718831952229],
              [-16.869489182165307, -11.286006124495987],
              [-16.86751867725486, -11.287490443540115],
              [-16.86605494125998, -11.287785402139225],
              [-16.867055118863988, -11.289357247361291],
              [-16.868006818473763, -11.28972323949285],
              [-16.870590077301294, -11.289207079021967],
              [-16.874610807242423, -11.293550103873457],
              [-16.87517415323511, -11.294749915338508],
              [-16.874901005932468, -11.296729210834252],
              [-16.87549476571674, -11.299072097208926],
              [-16.876760203607613, -11.298283793897161],
              [-16.878064528571944, -11.298342032973466],
              [-16.879327840704534, -11.297616807130275],
              [-16.87898317471095, -11.295514119722776],
              [-16.87931426583791, -11.294445709855918]
            ]
          ],
          [
            [
              [-16.895016822293087, -11.278785476851292],
              [-16.894260514260882, -11.278321792282203],
              [-16.892370300604743, -11.278650304854198],
              [-16.8917795240306, -11.2798794589416],
              [-16.894351674016693, -11.279632999743848],
              [-16.895016822293087, -11.278785476851292]
            ]
          ],
          [
            [
              [-16.90565243158202, -11.304975752024507],
              [-16.903887500495657, -11.303723504173524],
              [-16.903111907781184, -11.302328337056322],
              [-16.900937752711524, -11.3019537270886],
              [-16.900958793504362, -11.303519184904351],
              [-16.901816862337085, -11.305022445259509],
              [-16.903163102131423, -11.305142826833137],
              [-16.904174918894892, -11.306523515239592],
              [-16.90575955835087, -11.305760989672716],
              [-16.90565243158202, -11.304975752024507]
            ]
          ],
          [
            [
              [-16.91081942424733, -11.697404000080073],
              [-16.908958075555436, -11.694088098412003],
              [-16.907573489323852, -11.692876398228508],
              [-16.90595204504512, -11.69226883819362],
              [-16.905150935428047, -11.690766621555419],
              [-16.903533365055093, -11.690028174150413],
              [-16.90204623229322, -11.687724598674848],
              [-16.901094915037923, -11.685260258922833],
              [-16.89969220188578, -11.684788463100352],
              [-16.89870849920952, -11.683543384529456],
              [-16.89794788246559, -11.683872327334143],
              [-16.896871052643874, -11.68606594749108],
              [-16.894643074733523, -11.686661046039918],
              [-16.893891565548365, -11.685029689825363],
              [-16.89280335375979, -11.684391046900645],
              [-16.893214127309864, -11.687146498601052],
              [-16.893802084188764, -11.688294943567533],
              [-16.896332816587226, -11.68796886877938],
              [-16.898457865688044, -11.689549051057377],
              [-16.89722868536, -11.690824771359125],
              [-16.89883307904806, -11.692042996715832],
              [-16.90089763470495, -11.69261921350917],
              [-16.90275638331407, -11.694279767009714],
              [-16.902957752141905, -11.695025860096736],
              [-16.905190780773157, -11.69595463001093],
              [-16.906438183696046, -11.697337763430921],
              [-16.907713120116473, -11.697675212452557],
              [-16.908481961714934, -11.700441611999443],
              [-16.910504124298768, -11.699314629323997],
              [-16.91081942424733, -11.697404000080073]
            ]
          ],
          [
            [
              [-16.90876110016605, -11.831742896198945],
              [-16.906486500345288, -11.827987645336002],
              [-16.90633853697125, -11.826795589068803],
              [-16.90408843944751, -11.823877984069384],
              [-16.90385178157479, -11.820967500818139],
              [-16.90194307179391, -11.8221073389137],
              [-16.899671699260427, -11.821741736366413],
              [-16.89859058264923, -11.822021941548906],
              [-16.896669559988606, -11.823601143168679],
              [-16.896930570784384, -11.82554455695229],
              [-16.89922409762266, -11.828464880717585],
              [-16.90173594279481, -11.829937707959726],
              [-16.903039669547383, -11.831423557573059],
              [-16.90536577929493, -11.831482045765163],
              [-16.907542839120538, -11.832109093296975],
              [-16.90876110016605, -11.831742896198945]
            ]
          ],
          [
            [
              [-16.929852227996555, -11.298354065750425],
              [-16.92407680694392, -11.299016171968393],
              [-16.922415452897067, -11.297854597926822],
              [-16.921441249438733, -11.295801049263149],
              [-16.921876360300242, -11.292219389517244],
              [-16.920478425814622, -11.290029719237987],
              [-16.919139608328628, -11.28887636559109],
              [-16.9189618841027, -11.285851561918117],
              [-16.920083718387477, -11.284654842615705],
              [-16.92135332936954, -11.28517242148828],
              [-16.923049313873687, -11.283250683448161],
              [-16.922752381400493, -11.28233540349516],
              [-16.920469081602626, -11.283819991650956],
              [-16.918608745293703, -11.28463879854015],
              [-16.915617484141617, -11.285365562058416],
              [-16.913668867311944, -11.2862664836288],
              [-16.913263997871933, -11.287819021787092],
              [-16.911358736929767, -11.288678308790715],
              [-16.910808915066905, -11.29003717268322],
              [-16.909611957523246, -11.289203401488098],
              [-16.90741622071804, -11.29049867961957],
              [-16.901469085055624, -11.289708056011591],
              [-16.900304160403405, -11.288515168477051],
              [-16.899407442312306, -11.288448827994417],
              [-16.89801486454468, -11.286996354962945],
              [-16.89631410638545, -11.288154451418213],
              [-16.89336810710923, -11.287187254576935],
              [-16.893473369914762, -11.289513895536599],
              [-16.894196369815084, -11.291181623255577],
              [-16.89842296723451, -11.293070921587766],
              [-16.903056388489, -11.29188433690952],
              [-16.90522424890898, -11.293991220588275],
              [-16.907016718151212, -11.297335477242465],
              [-16.90915068381258, -11.299166770797868],
              [-16.910535184389317, -11.299435156674253],
              [-16.91490460700014, -11.300984914219306],
              [-16.91708432540447, -11.301145974726154],
              [-16.91837152205448, -11.301876111794103],
              [-16.92131479506432, -11.301505740822805],
              [-16.923127113527894, -11.301804698589363],
              [-16.924979350358914, -11.30138534754593],
              [-16.926097943092046, -11.302026094956355],
              [-16.927223821814568, -11.299854575985965],
              [-16.928909184016963, -11.299240377085349],
              [-16.929852227996555, -11.298354065750425]
            ]
          ],
          [
            [
              [-16.92003519578126, -11.688346748731716],
              [-16.918330881218985, -11.685778912058998],
              [-16.917018044610522, -11.685223914299527],
              [-16.916837092389816, -11.683651587815683],
              [-16.91558998524374, -11.68227075070896],
              [-16.91445238801765, -11.681807447022438],
              [-16.91322664281542, -11.683040105931017],
              [-16.913860338342985, -11.684188045339933],
              [-16.912785461152914, -11.686426664325893],
              [-16.910636514491667, -11.685719938594552],
              [-16.91088014652366, -11.688252874169686],
              [-16.912228131904605, -11.689157674098588],
              [-16.91209693290569, -11.690810304708393],
              [-16.913363958965952, -11.693151513793612],
              [-16.915534139709976, -11.69481783087668],
              [-16.91655160574422, -11.694842761522391],
              [-16.9179791956419, -11.696141812570545],
              [-16.918619612696084, -11.695329138826835],
              [-16.91833984043991, -11.692401943475366],
              [-16.91988418030138, -11.69082689162205],
              [-16.920467463866824, -11.68874950940237],
              [-16.92003519578126, -11.688346748731716]
            ]
          ],
          [
            [
              [-16.950554125792838, -11.641368545980344],
              [-16.94682003937662, -11.637676346914407],
              [-16.946999134602454, -11.635956634396823],
              [-16.94487270569088, -11.635061576672591],
              [-16.941909205453673, -11.631675515890368],
              [-16.942851598826223, -11.630660855616794],
              [-16.9440323938972, -11.631263100735948],
              [-16.944891078961327, -11.629674121402724],
              [-16.94394348062962, -11.628449510059932],
              [-16.941534032783625, -11.628707546409464],
              [-16.93973788987034, -11.629837885677173],
              [-16.938824954952395, -11.629348647758706],
              [-16.9386850367782, -11.627827680723861],
              [-16.936835209759, -11.627582371248256],
              [-16.936049224634548, -11.626561014500483],
              [-16.936487501139734, -11.625496303043114],
              [-16.93533515515394, -11.624012785813921],
              [-16.932983911694198, -11.623470157511827],
              [-16.931896174871287, -11.624297058880625],
              [-16.930985157220928, -11.625886406910949],
              [-16.931953331354936, -11.627368419395333],
              [-16.933091877145642, -11.62805981564158],
              [-16.936079700753176, -11.628514240498003],
              [-16.931349845827736, -11.634143871803687],
              [-16.93241036343222, -11.634640865284993],
              [-16.934335595284022, -11.637430457372089],
              [-16.933693444011933, -11.63839435252815],
              [-16.930406361341706, -11.63735428615482],
              [-16.929658705862725, -11.638669397597317],
              [-16.92574563317068, -11.63945367947032],
              [-16.923384183583675, -11.63963960636205],
              [-16.921291575006283, -11.639144099176184],
              [-16.917142158057143, -11.641918185082687],
              [-16.914960421619675, -11.643069238767763],
              [-16.916116792792558, -11.644348231813563],
              [-16.916646962743147, -11.647037257517695],
              [-16.91941302482104, -11.646999984064907],
              [-16.918625447939462, -11.648115348010215],
              [-16.91916175088043, -11.649562164170804],
              [-16.9176809679358, -11.650568737695698],
              [-16.920293556641266, -11.651892093807867],
              [-16.921533588423994, -11.653443166409827],
              [-16.928027641558874, -11.653033331684776],
              [-16.929226504262104, -11.65271393944208],
              [-16.932239965865122, -11.650308159658906],
              [-16.933052409576504, -11.647720679904266],
              [-16.934454077084826, -11.648100870240796],
              [-16.937436600325107, -11.64696829350685],
              [-16.940315974301434, -11.645427907969202],
              [-16.943089380751832, -11.643589764174273],
              [-16.94480695334334, -11.64385932204366],
              [-16.94580058833842, -11.642414042710973],
              [-16.94626326107727, -11.640808329617029],
              [-16.947542268345767, -11.64073934901978],
              [-16.949256460168957, -11.642736332592937],
              [-16.950610616060235, -11.64268037982773],
              [-16.950554125792838, -11.641368545980344]
            ]
          ],
          [
            [
              [-16.963821233187158, -11.393004692477017],
              [-16.96267943988462, -11.391958334640035],
              [-16.95963748463134, -11.390998691701428],
              [-16.958622485636297, -11.391998743181299],
              [-16.959310708966484, -11.394015344850155],
              [-16.961408157640463, -11.394784353622837],
              [-16.963821233187158, -11.393004692477017]
            ]
          ],
          [
            [
              [-17.014647943856307, -11.629998143232635],
              [-17.0142369962844, -11.628343321863026],
              [-17.01306896928761, -11.627196342402229],
              [-17.012223083727648, -11.625274760384944],
              [-17.007631679715264, -11.623721976223852],
              [-17.006311719967787, -11.623742333635455],
              [-17.00229405818536, -11.62215457651259],
              [-16.999160909852574, -11.622705131853964],
              [-16.99776034215354, -11.62233314071885],
              [-16.995236810585197, -11.623197437132138],
              [-16.994143318324657, -11.62287365974387],
              [-16.99357018087365, -11.62065275187142],
              [-16.992572357636618, -11.619940937440536],
              [-16.98897450735749, -11.619526976349805],
              [-16.9886019849091, -11.622813645339958],
              [-16.98934004902818, -11.623304559432547],
              [-16.990051258906185, -11.625181913707667],
              [-16.989812781542536, -11.626131096579154],
              [-16.991535059561205, -11.628071285636272],
              [-16.99099201932232, -11.628841471499623],
              [-16.991872497391217, -11.63336842705754],
              [-16.99148495348567, -11.635183492132162],
              [-16.993528719396213, -11.63652299425595],
              [-16.993593338609063, -11.637739129388354],
              [-16.99569454499057, -11.640728545224988],
              [-16.997056391694667, -11.640927019391807],
              [-16.999368428039233, -11.642140731442874],
              [-17.001308723505595, -11.642045146448623],
              [-17.002744365248613, -11.640638435223545],
              [-17.005220898256127, -11.640117772213149],
              [-17.00598123096762, -11.639480119020115],
              [-17.006280107955725, -11.637576139377323],
              [-17.007531632912766, -11.636556642609937],
              [-17.01023642173939, -11.635518665175889],
              [-17.012221726655234, -11.635292195911747],
              [-17.01431655422798, -11.63133682835831],
              [-17.014647943856307, -11.629998143232635]
            ]
          ],
          [
            [
              [-17.11819052038672, -11.595715018617588],
              [-17.117590569033293, -11.594109965350105],
              [-17.115906657164526, -11.591155509632875],
              [-17.114086658607143, -11.588762232800669],
              [-17.110597141331233, -11.586829109565233],
              [-17.109197559062128, -11.586470536709243],
              [-17.107645725216027, -11.583777095762535],
              [-17.105597400692005, -11.582590995558885],
              [-17.10427993589312, -11.58283764141936],
              [-17.103279978061597, -11.582050261156395],
              [-17.10264078768798, -11.580273022043372],
              [-17.103762017910654, -11.577735992520452],
              [-17.103391307244202, -11.575400364707205],
              [-17.099910549267516, -11.573164216638645],
              [-17.099352134207937, -11.572122579029736],
              [-17.099905544371158, -11.56945208670158],
              [-17.09926073470134, -11.568323561423487],
              [-17.09760333067405, -11.567745697254779],
              [-17.09573851798222, -11.566129747618339],
              [-17.092070007213106, -11.565400760474311],
              [-17.08899335531688, -11.566532592734756],
              [-17.088317170584144, -11.568251264074991],
              [-17.08739303745333, -11.568672777205148],
              [-17.08570246224771, -11.570984402647285],
              [-17.082155120722675, -11.574700029103006],
              [-17.08125526905216, -11.57667607228003],
              [-17.0795318257913, -11.577908442556248],
              [-17.07712775741179, -11.580989883838434],
              [-17.076898580380856, -11.581808183082032],
              [-17.075141237141896, -11.582132865854804],
              [-17.072341449345434, -11.585166274117759],
              [-17.070976497015085, -11.585624836184635],
              [-17.06879710986836, -11.584647410046419],
              [-17.06638165688534, -11.584962608028643],
              [-17.06463762133941, -11.584248971373418],
              [-17.063713741339306, -11.584496059857043],
              [-17.061628624607273, -11.583086234023897],
              [-17.06025516023579, -11.584148539258702],
              [-17.05792191604469, -11.58485220350394],
              [-17.053728221352376, -11.580733871647627],
              [-17.05029177804588, -11.578958473966926],
              [-17.0486010520586, -11.577725279193496],
              [-17.05001680321931, -11.576795172614329],
              [-17.050972326682903, -11.577369904754589],
              [-17.05538800553268, -11.578035437232579],
              [-17.057762138975868, -11.577462803847686],
              [-17.058251735279356, -11.576908003110448],
              [-17.06140444594906, -11.577036098655924],
              [-17.06209769807512, -11.577606528484635],
              [-17.06372374423477, -11.577238982260804],
              [-17.066032215999144, -11.578261995581284],
              [-17.068248993000857, -11.579629100309276],
              [-17.070459203956013, -11.578144975495848],
              [-17.07180821333169, -11.575440862501331],
              [-17.07193459464867, -11.572420296520143],
              [-17.074502975708967, -11.570163806320776],
              [-17.07564776391603, -11.569659552985149],
              [-17.076501521998928, -11.567900336165645],
              [-17.077955967958275, -11.567097541594],
              [-17.079965391016177, -11.563841913177493],
              [-17.07997952277623, -11.562677338313636],
              [-17.081831983287316, -11.561448034725354],
              [-17.08200141630323, -11.558258419846476],
              [-17.08055665509918, -11.554749457261789],
              [-17.080927344330608, -11.553029263916764],
              [-17.0818072506973, -11.55256538335668],
              [-17.08091685202141, -11.55027088670766],
              [-17.080011627924115, -11.549225923909008],
              [-17.080258281984236, -11.546901881272802],
              [-17.07952030802584, -11.54650556109766],
              [-17.078930661994775, -11.544689448339739],
              [-17.07736018146565, -11.544498541757804],
              [-17.075279424863407, -11.543181502396884],
              [-17.07390178174523, -11.541570954938765],
              [-17.071272940079215, -11.542184806599677],
              [-17.06927667886199, -11.544529273885466],
              [-17.06699597762551, -11.54518958259284],
              [-17.06416075954718, -11.544808518863617],
              [-17.063444263577704, -11.546091733776656],
              [-17.060604371106166, -11.546054516983823],
              [-17.059239794027206, -11.546768833552177],
              [-17.057493288546187, -11.54665942797315],
              [-17.0560706793733, -11.548363749197286],
              [-17.05221449977803, -11.54904321164724],
              [-17.04969441185526, -11.548016820086966],
              [-17.047752215559314, -11.546352068628963],
              [-17.044195559156968, -11.547464044467734],
              [-17.043067457486277, -11.546930520223029],
              [-17.042360810796616, -11.544550809543589],
              [-17.04209918213226, -11.541660829940179],
              [-17.043048660178655, -11.539564405665006],
              [-17.04617094297168, -11.53814546088932],
              [-17.049698016298017, -11.535870642986964],
              [-17.051227821695743, -11.535763111755465],
              [-17.052067861151706, -11.535043040294422],
              [-17.054213482498746, -11.534598962401517],
              [-17.05633366968829, -11.532863295373348],
              [-17.05781000767756, -11.5303011360538],
              [-17.06037294861583, -11.528011617604669],
              [-17.060615320677876, -11.526251177679912],
              [-17.05821180897337, -11.523423248390271],
              [-17.054550577553393, -11.52019119022965],
              [-17.05435360573435, -11.51872650321302],
              [-17.053459904261626, -11.517209520925613],
              [-17.053741181144343, -11.515837768030801],
              [-17.052711905193, -11.514662918027003],
              [-17.05050978028629, -11.513256815836254],
              [-17.05067760088388, -11.510723911922334],
              [-17.049897954681374, -11.510411844124205],
              [-17.04826755162604, -11.511635020606075],
              [-17.045067277060614, -11.512920982480468],
              [-17.043029322691314, -11.512246762393051],
              [-17.04161526578785, -11.513515251448498],
              [-17.04012649387737, -11.51396593382971],
              [-17.03962453115923, -11.515419796175136],
              [-17.038337784871647, -11.516862191290103],
              [-17.035885471807305, -11.517555898750784],
              [-17.033405810147503, -11.517216782105411],
              [-17.03202612485852, -11.518958164999427],
              [-17.030055964517274, -11.519443504555989],
              [-17.027071539101705, -11.517977246310524],
              [-17.026391236907976, -11.519557446054334],
              [-17.02671076943613, -11.521325651872562],
              [-17.024824964758686, -11.52194054476082],
              [-17.021390011359486, -11.521325543443293],
              [-17.020200113228075, -11.522037154824373],
              [-17.019481201862696, -11.520734946048048],
              [-17.02135338617392, -11.518357858217733],
              [-17.021279499593795, -11.517582780423785],
              [-17.01959748331111, -11.516523112672969],
              [-17.01679764228775, -11.51639111628487],
              [-17.01356976526052, -11.518500913694222],
              [-17.012798422839644, -11.51864018470738],
              [-17.01237340550503, -11.516406252634622],
              [-17.011172573205734, -11.516250387877399],
              [-17.008528493588937, -11.517847972204393],
              [-17.007611222581126, -11.516703289273801],
              [-17.00795375292236, -11.51546122365588],
              [-17.009302511873244, -11.513670964849192],
              [-17.010640714066152, -11.512760940467508],
              [-17.01362094545878, -11.51182345911904],
              [-17.016064403457616, -11.511650133836934],
              [-17.020838814827215, -11.510225549638317],
              [-17.022664051730573, -11.510513197614442],
              [-17.025071396135235, -11.509864716232155],
              [-17.027726971724707, -11.50737220816009],
              [-17.02775756699813, -11.505525851656541],
              [-17.028570359748137, -11.503777583307592],
              [-17.03037645566983, -11.502517706297038],
              [-17.030493632567204, -11.500673006395344],
              [-17.02805333015692, -11.498187397563868],
              [-17.024191891857573, -11.497438528857945],
              [-17.022962787333835, -11.496821478862898],
              [-17.02215900187911, -11.497341745227834],
              [-17.019777766172734, -11.500327758709124],
              [-17.017738050040307, -11.5003743358623],
              [-17.01666985917653, -11.500944879846754],
              [-17.014145776754784, -11.501016096757061],
              [-17.01366647876244, -11.50198008971976],
              [-17.012185418629397, -11.502782369040782],
              [-17.010418944169288, -11.503051991061819],
              [-17.010510821080523, -11.504826849862551],
              [-17.009133002174035, -11.506584449872081],
              [-17.00708833627935, -11.508009126328247],
              [-17.006044955373145, -11.508051656960642],
              [-17.004857011430477, -11.509349629013279],
              [-17.00178925898878, -11.509441392429814],
              [-17.000275744416374, -11.507459801478076],
              [-17.000398441596175, -11.505833286795063],
              [-17.002882250438834, -11.501110823545154],
              [-17.00466084120922, -11.499124229507013],
              [-17.006463910467016, -11.49812581918696],
              [-17.007092089994185, -11.497106537885958],
              [-17.006563434149502, -11.495079881715904],
              [-17.002919460684993, -11.49445722985959],
              [-17.0019052312088, -11.492851112745141],
              [-17.00314314815127, -11.491800296248964],
              [-17.001781929946624, -11.49014524627092],
              [-17.002593535496672, -11.488615289313627],
              [-17.005946460968573, -11.488417986944894],
              [-17.007459508109726, -11.488916500149436],
              [-17.009178774396606, -11.487659461521158],
              [-17.01262277539015, -11.487204521209453],
              [-17.010595636427368, -11.486268577936594],
              [-17.010764693148978, -11.484127062454027],
              [-17.013028632629148, -11.483951639117322],
              [-17.01532845673422, -11.484205231057219],
              [-17.015349635833196, -11.483004823621421],
              [-17.016323095037876, -11.482035263621093],
              [-17.0184076261474, -11.482155943300823],
              [-17.018788688474814, -11.480232937513351],
              [-17.019817732114138, -11.478535428818928],
              [-17.02100465779192, -11.477740424908893],
              [-17.022126561860386, -11.475659118431677],
              [-17.021321881017162, -11.474445768041532],
              [-17.017201260905434, -11.476563029707929],
              [-17.013638021854455, -11.476588338740923],
              [-17.01195694245859, -11.475830878722196],
              [-17.010425082457374, -11.476447308165847],
              [-17.009480352559525, -11.475830640468727],
              [-17.008085103822943, -11.476106365166883],
              [-17.0047343011641, -11.474033004867703],
              [-17.003264863993405, -11.47130731119967],
              [-17.001717830639723, -11.470422438278057],
              [-17.000939814556077, -11.467923991924122],
              [-17.00170357230699, -11.466567236885854],
              [-17.000613142529055, -11.464534618114609],
              [-16.99659985846708, -11.463304900024927],
              [-16.995756563052396, -11.459778713964718],
              [-16.995725938968008, -11.456867828384274],
              [-16.9901232711891, -11.455008027829262],
              [-16.98918468997071, -11.454219764183238],
              [-16.986849049631253, -11.45605782401922],
              [-16.985777073699634, -11.455437808351467],
              [-16.98361341701965, -11.455181929874806],
              [-16.983663916665062, -11.452701041787698],
              [-16.981762222782056, -11.450268199621654],
              [-16.981737437155086, -11.449369257253236],
              [-16.979326474190785, -11.448551774635565],
              [-16.976756541880356, -11.451195031744906],
              [-16.975361543858952, -11.451552093573106],
              [-16.973696348740436, -11.450320352384372],
              [-16.972047516146155, -11.45037238183748],
              [-16.970775277915603, -11.453084309234969],
              [-16.9689167493538, -11.452789092125604],
              [-16.966682530095888, -11.453812085868549],
              [-16.96596522892403, -11.452898594260635],
              [-16.964617611124975, -11.453041328668968],
              [-16.96390418605457, -11.453925067810582],
              [-16.96162588965767, -11.454946223087237],
              [-16.96094983596197, -11.456087387666612],
              [-16.959773373769437, -11.456318974401304],
              [-16.957927094214206, -11.455466088760614],
              [-16.95472284752843, -11.453299580138891],
              [-16.954033673847608, -11.451187662083434],
              [-16.95599590122467, -11.450717309212202],
              [-16.957671723693547, -11.451395397302749],
              [-16.96356208848215, -11.449767644261216],
              [-16.963005665094396, -11.448158879373823],
              [-16.964279149839857, -11.447315936285777],
              [-16.96400911775487, -11.44619382158068],
              [-16.966113003935902, -11.446543156330085],
              [-16.96749735227185, -11.445522854183674],
              [-16.968412940970435, -11.446358836774067],
              [-16.97010517309973, -11.44592677165017],
              [-16.97033268223546, -11.444165811535175],
              [-16.97207752257904, -11.443907379456844],
              [-16.97301144060741, -11.444592963099339],
              [-16.97429093592071, -11.444283049121596],
              [-16.977332513356295, -11.442311363238153],
              [-16.97861972819633, -11.440841031241131],
              [-16.980409455342944, -11.440192634226175],
              [-16.980516320829004, -11.437117798336375],
              [-16.978167144748166, -11.435532477441363],
              [-16.977683410221108, -11.433813852988854],
              [-16.978243705225285, -11.431860009702831],
              [-16.98151913457948, -11.430473052936568],
              [-16.982409971460115, -11.429251945472705],
              [-16.982196825380747, -11.426984495374061],
              [-16.98238961189458, -11.42391424119414],
              [-16.979893672558433, -11.423267474495141],
              [-16.979735876118635, -11.422538582405641],
              [-16.98103372120648, -11.42043014805693],
              [-16.983409000220558, -11.420605075566266],
              [-16.983700592763963, -11.419031897654042],
              [-16.98288973984088, -11.418504014408285],
              [-16.98016917135145, -11.418322111754305],
              [-16.977559339971986, -11.41698982651659],
              [-16.97758879320746, -11.415582591875198],
              [-16.978555532461183, -11.414833867390355],
              [-16.978216319524055, -11.412438655646932],
              [-16.97637926483142, -11.411420391365835],
              [-16.976248775747216, -11.409413541292084],
              [-16.97536862675004, -11.408116591358377],
              [-16.972737458345687, -11.405888538546431],
              [-16.969182883873195, -11.406454480421145],
              [-16.968210211224136, -11.40549627534],
              [-16.967825710482135, -11.403314529781065],
              [-16.966279796524123, -11.40093790408494],
              [-16.964260617667783, -11.400469286907011],
              [-16.9611613607515, -11.403897738425607],
              [-16.961670388701123, -11.406253163173188],
              [-16.96117074157873, -11.407351168578849],
              [-16.959358829585884, -11.4072267627177],
              [-16.95796437074617, -11.407750915711487],
              [-16.956459891310224, -11.411215069677198],
              [-16.955857937785236, -11.411073825872977],
              [-16.95362424850286, -11.408593832214153],
              [-16.953645786864573, -11.405780472816152],
              [-16.94978591588064, -11.406419486092394],
              [-16.949034586822837, -11.40529389703315],
              [-16.949321475533473, -11.404106874375172],
              [-16.94783233829269, -11.401302845024931],
              [-16.946808355069592, -11.400768360777136],
              [-16.94636583798649, -11.399394735764481],
              [-16.946680988421942, -11.397015558675735],
              [-16.944546912175554, -11.395987346312598],
              [-16.942209343222025, -11.39806391071358],
              [-16.94121191546677, -11.400043642424766],
              [-16.940114469707442, -11.400785453171808],
              [-16.939934616698956, -11.402869731629696],
              [-16.93838027996101, -11.404623819532915],
              [-16.93756927633021, -11.404221287535542],
              [-16.936230062210598, -11.400694790565478],
              [-16.935303520092926, -11.39973531764842],
              [-16.934915861393062, -11.397936569848326],
              [-16.932807890192016, -11.397630761796924],
              [-16.931659672094003, -11.396921916158716],
              [-16.931502247622518, -11.394574782194574],
              [-16.928945387260647, -11.39498209882936],
              [-16.926776413958233, -11.39369438792829],
              [-16.92530012979748, -11.394041734616497],
              [-16.92414528762971, -11.393630218500117],
              [-16.92077664797816, -11.395378945364433],
              [-16.91913506451719, -11.395423239926373],
              [-16.919790120781915, -11.396802886358943],
              [-16.922875954088877, -11.397688759759754],
              [-16.92408392574967, -11.399422990952365],
              [-16.922859943519835, -11.401694648162742],
              [-16.92462614953812, -11.403570932910895],
              [-16.925599748466848, -11.406067454656931],
              [-16.925938736071693, -11.408037093251105],
              [-16.925448456940654, -11.408622251322749],
              [-16.923455281294935, -11.408829388624257],
              [-16.92296670410424, -11.411035306529149],
              [-16.923997807005065, -11.412980263351217],
              [-16.924919087558855, -11.415861420009469],
              [-16.926277077925864, -11.416875795790697],
              [-16.928842002530427, -11.419797390536113],
              [-16.9300590676898, -11.423028071125934],
              [-16.930676662017323, -11.426031814583546],
              [-16.929633328414322, -11.42622031046892],
              [-16.92906735575567, -11.42808595716054],
              [-16.92734449383401, -11.427745590530957],
              [-16.927155651314035, -11.430090226023562],
              [-16.926443969778575, -11.43084183232342],
              [-16.928355727391445, -11.432297914923716],
              [-16.930549249967346, -11.431154426609272],
              [-16.930816122984762, -11.432613395347072],
              [-16.93241636301333, -11.434445952725518],
              [-16.932175598194476, -11.437175278891429],
              [-16.933843885869173, -11.436274540312134],
              [-16.936698985114095, -11.436427368914288],
              [-16.937777815246193, -11.438375721566462],
              [-16.937707703912775, -11.439485428156729],
              [-16.935053648951214, -11.439936287403969],
              [-16.934673793432463, -11.441295520402962],
              [-16.935353538785606, -11.443620222303002],
              [-16.93744612259617, -11.444909591994248],
              [-16.93764297069499, -11.445726656049677],
              [-16.939521482814296, -11.446924936824532],
              [-16.940103518956043, -11.447964986605127],
              [-16.94360332998402, -11.448473207349386],
              [-16.94430955024568, -11.449772688447679],
              [-16.94542232768729, -11.450396608369758],
              [-16.94690121644604, -11.452055928869935],
              [-16.94784788086853, -11.452376718315788],
              [-16.94794022223496, -11.455845022826098],
              [-16.949442014140235, -11.456563671436133],
              [-16.9498754632858, -11.458456676257908],
              [-16.951806457066976, -11.46128233640581],
              [-16.95350288708167, -11.464916921171175],
              [-16.953624467766264, -11.467189742863496],
              [-16.95479784604377, -11.469057707506664],
              [-16.9573300936889, -11.472326363638782],
              [-16.95606968145598, -11.474270299249408],
              [-16.95230004622688, -11.471916305344106],
              [-16.951380375854686, -11.47223882621239],
              [-16.950082435095116, -11.473881536056146],
              [-16.948822177233758, -11.47389614028401],
              [-16.94691654797747, -11.475482250921207],
              [-16.94553488071907, -11.475108277308077],
              [-16.945375345890227, -11.476347962110012],
              [-16.946628186527906, -11.478519595893923],
              [-16.947071326965464, -11.481874168300175],
              [-16.94877569311133, -11.483370685085426],
              [-16.94981362312753, -11.485495787931733],
              [-16.949115620232885, -11.489341350955215],
              [-16.949193350807953, -11.491617782055515],
              [-16.948299484163098, -11.492627977111884],
              [-16.946728704867688, -11.49280721659976],
              [-16.94242770122086, -11.492495434158732],
              [-16.94055902341291, -11.490564121687719],
              [-16.94081431081785, -11.48898223873029],
              [-16.94192077790206, -11.488192192756179],
              [-16.942610617272212, -11.486620529865364],
              [-16.942107324416337, -11.48583666912046],
              [-16.939204141510572, -11.485383805030843],
              [-16.937247665806016, -11.488942561990552],
              [-16.935689412150655, -11.490408313997],
              [-16.936049132291494, -11.493507174543101],
              [-16.934483250443872, -11.493470556193728],
              [-16.931236800438935, -11.496270369615472],
              [-16.928841950869558, -11.49453890239625],
              [-16.929084120603648, -11.493557210309806],
              [-16.93118581761287, -11.491289450218868],
              [-16.930476123358584, -11.490071015633747],
              [-16.92864106117043, -11.490370408354122],
              [-16.92699727460328, -11.489987805723121],
              [-16.92638898513429, -11.488213607398484],
              [-16.926693143252876, -11.483029627829476],
              [-16.926078992223168, -11.481513703507032],
              [-16.924555671718398, -11.479847301125087],
              [-16.922708109167775, -11.478987541039933],
              [-16.922558271171276, -11.47804036927172],
              [-16.9246553408065, -11.474190358253178],
              [-16.924354429201998, -11.472340043532483],
              [-16.925795772595087, -11.470317868752067],
              [-16.92547852017147, -11.467396569761279],
              [-16.92285343980338, -11.469860776478273],
              [-16.920745430550443, -11.470751606331547],
              [-16.919752846777694, -11.472184294627574],
              [-16.91775330403921, -11.472220495307702],
              [-16.91716751695338, -11.471348778120984],
              [-16.918439791324484, -11.469194810177381],
              [-16.921630816357315, -11.4667030725382],
              [-16.922012004534768, -11.465384328615931],
              [-16.921479559813722, -11.464129222928973],
              [-16.919885099868498, -11.463661370176474],
              [-16.917336192319734, -11.46484057580247],
              [-16.914981848424084, -11.465209992650516],
              [-16.914350697611187, -11.46609367108029],
              [-16.912104754294024, -11.467279420599404],
              [-16.911707717153035, -11.469154807913151],
              [-16.909518113747914, -11.47145618027303],
              [-16.907764252770374, -11.472054017983865],
              [-16.90520192672963, -11.473616989642004],
              [-16.903990124656865, -11.475043121334092],
              [-16.903494336825123, -11.47730256883277],
              [-16.901949439898008, -11.478162855824044],
              [-16.899573048493487, -11.4808024983209],
              [-16.899203192218046, -11.481607568638895],
              [-16.901609100421904, -11.484287481802042],
              [-16.90347852764362, -11.485923726204062],
              [-16.898754181778596, -11.491636751703226],
              [-16.89766333389038, -11.49173671482411],
              [-16.894966106054454, -11.490119959234795],
              [-16.893105796612105, -11.489726723206491],
              [-16.892393029832157, -11.48876339931021],
              [-16.89247954753027, -11.487220835618173],
              [-16.89075128442809, -11.483698601422232],
              [-16.88840802422346, -11.481962118695066],
              [-16.887074267429767, -11.481454170397043],
              [-16.884678176190487, -11.481602990743225],
              [-16.88533790811819, -11.47981933404167],
              [-16.883241857922272, -11.477102643407628],
              [-16.882763800985636, -11.475588824908098],
              [-16.88071128476283, -11.477418746029372],
              [-16.880119160885368, -11.479846794768417],
              [-16.8816846819746, -11.481348551748349],
              [-16.880733604169798, -11.484153549797178],
              [-16.87872177671139, -11.484526720035781],
              [-16.875921679088183, -11.483589890443525],
              [-16.87330541218007, -11.485274955716607],
              [-16.87209600043147, -11.48644231063811],
              [-16.872468500173987, -11.488555897978442],
              [-16.873804701488766, -11.48752085695653],
              [-16.87621350126909, -11.486987881727762],
              [-16.876988487714037, -11.487267174115807],
              [-16.87818997977551, -11.492323249024986],
              [-16.87882738801964, -11.49285638333085],
              [-16.878694270426422, -11.494441269197683],
              [-16.880794821508037, -11.495573418298038],
              [-16.88035243516114, -11.498825007199205],
              [-16.879413677250348, -11.499658037362988],
              [-16.88236819603172, -11.505970182469964],
              [-16.88412446131858, -11.51160691103971],
              [-16.884800707705566, -11.51846368920414],
              [-16.88530373884622, -11.520714590444387],
              [-16.884926838897982, -11.521693770013737],
              [-16.884757342278107, -11.524572568154678],
              [-16.884950700807572, -11.530044845481893],
              [-16.884464018034507, -11.53179668845906],
              [-16.884147424460423, -11.53523363652269],
              [-16.88311314937635, -11.537789773990086],
              [-16.881659638623926, -11.536672913743212],
              [-16.881670572958093, -11.534777652863175],
              [-16.881180267678438, -11.533601223342618],
              [-16.88169930390606, -11.529223455668427],
              [-16.88006497801724, -11.528360140823676],
              [-16.87967722601242, -11.526670542795367],
              [-16.878245499324308, -11.523359345509464],
              [-16.878366564065676, -11.522201137797795],
              [-16.877799982895773, -11.519173414789643],
              [-16.87823009538578, -11.516389289499333],
              [-16.877057458527812, -11.514721936596397],
              [-16.876424656978674, -11.511006172102325],
              [-16.874750364391467, -11.508637403894289],
              [-16.873992415658083, -11.50625198499437],
              [-16.871285937497472, -11.503467540831382],
              [-16.870061835191205, -11.503604334280926],
              [-16.86922289536296, -11.505428385120895],
              [-16.869673780207375, -11.510771704739982],
              [-16.87119401141182, -11.515373338286183],
              [-16.871364964094944, -11.518432550499226],
              [-16.87083941797929, -11.51996641239768],
              [-16.86969452559082, -11.520320923416625],
              [-16.868262402301617, -11.518601959823325],
              [-16.868397089862906, -11.517013945819233],
              [-16.866953943533705, -11.515682033129023],
              [-16.866778553378875, -11.514257504773846],
              [-16.86486063624957, -11.51278287332186],
              [-16.86392876549826, -11.510433790388669],
              [-16.86309046374731, -11.506454374420516],
              [-16.86243160330814, -11.505188725422288],
              [-16.86164995393772, -11.502243754185338],
              [-16.861488550381615, -11.500391216264427],
              [-16.86042802016338, -11.49804030615847],
              [-16.86048058707984, -11.496323775494089],
              [-16.859622180614327, -11.495911923482499],
              [-16.85899332584262, -11.493703312455615],
              [-16.85780975396456, -11.492551915250571],
              [-16.856928484664362, -11.490078506748096],
              [-16.85617868400058, -11.490399425916573],
              [-16.855663881894934, -11.492960448942657],
              [-16.854684248509905, -11.493661016113602],
              [-16.854240641867737, -11.495322848908337],
              [-16.852565183707814, -11.497376975926732],
              [-16.85256694827137, -11.498708893469146],
              [-16.853324961659272, -11.499547827009074],
              [-16.85342463175115, -11.503332214568417],
              [-16.85263275434933, -11.506360043645472],
              [-16.852847074573255, -11.507870729668133],
              [-16.852814905769844, -11.511696440143119],
              [-16.854231109319375, -11.512426905774642],
              [-16.854997568943197, -11.514428293464691],
              [-16.853849834508058, -11.514866978076453],
              [-16.85266595194725, -11.516466173863245],
              [-16.852018676444775, -11.519028282024639],
              [-16.8523532364758, -11.520888399574277],
              [-16.85182109392919, -11.52255073093545],
              [-16.854182070302947, -11.523826784072856],
              [-16.854799794049086, -11.52642799383445],
              [-16.855952186890825, -11.52728004840507],
              [-16.85563455149225, -11.529078946197043],
              [-16.852978664143485, -11.531626877855967],
              [-16.852984632079643, -11.532833052251705],
              [-16.854282952689527, -11.534637776604354],
              [-16.854938204283773, -11.537457442638829],
              [-16.857719362705055, -11.540814890126962],
              [-16.86111772652923, -11.541173532502524],
              [-16.86237325733933, -11.540132638004913],
              [-16.863675460414406, -11.540428979041684],
              [-16.866499599825396, -11.542450286687885],
              [-16.86659704328784, -11.543573631520989],
              [-16.86800777769079, -11.544648666263347],
              [-16.86857182329555, -11.547725938815349],
              [-16.867661746896335, -11.5489070787967],
              [-16.865875139853173, -11.548683269379627],
              [-16.86730544132726, -11.552045305504365],
              [-16.867985571807104, -11.55271177733567],
              [-16.870444665483053, -11.556837131934541],
              [-16.872560059707325, -11.559313846795877],
              [-16.874752977846313, -11.560670197050868],
              [-16.878015065456694, -11.56140903233631],
              [-16.878350018813915, -11.558914992222173],
              [-16.879529605933616, -11.557480817708539],
              [-16.881276408201547, -11.557615493679123],
              [-16.882304960292892, -11.558377110380183],
              [-16.8836149982999, -11.553883231404644],
              [-16.883496883799218, -11.551895833000165],
              [-16.884390666315802, -11.551230355420483],
              [-16.88675838331069, -11.55103611014937],
              [-16.887925101818105, -11.551542275177441],
              [-16.889847490571114, -11.553189793316106],
              [-16.89127564635013, -11.553745674704924],
              [-16.8944687296866, -11.552191835944226],
              [-16.89422249731735, -11.550029111309447],
              [-16.895146438619427, -11.548242901830658],
              [-16.898031649399154, -11.546680682961762],
              [-16.898858246615777, -11.545236779312509],
              [-16.89884718478239, -11.542435015328968],
              [-16.89599170635497, -11.541368768471878],
              [-16.895685137857775, -11.539809331883644],
              [-16.898509262724726, -11.537212632374498],
              [-16.898120955654214, -11.535436340323958],
              [-16.8987366910884, -11.533686744996809],
              [-16.900971860410557, -11.533400709781798],
              [-16.901360270691306, -11.530353490949178],
              [-16.903050879836353, -11.529192205356233],
              [-16.904765223316268, -11.528762951593741],
              [-16.9064964060371, -11.530960025996645],
              [-16.911896478063973, -11.529848343147593],
              [-16.915201408301083, -11.530361662206202],
              [-16.91635942812474, -11.531165451199922],
              [-16.91740044421312, -11.533129034967757],
              [-16.915714077146745, -11.534163626195703],
              [-16.914977814832962, -11.53728953912333],
              [-16.915777254770116, -11.538472558502269],
              [-16.915078773836466, -11.540135149416804],
              [-16.913418101110853, -11.541817336519342],
              [-16.91092473973821, -11.543564339465044],
              [-16.90988194188873, -11.54664149633666],
              [-16.90957582393254, -11.549953306376215],
              [-16.91026152414709, -11.550487837972483],
              [-16.910649908632266, -11.552351984655688],
              [-16.91327510435405, -11.550650009827171],
              [-16.916555033151315, -11.548964066416147],
              [-16.917142054416484, -11.548245668044062],
              [-16.918631120592202, -11.548153019990899],
              [-16.920620374978125, -11.549020759446497],
              [-16.92083450670226, -11.550923316497103],
              [-16.918976593401656, -11.551740088693105],
              [-16.91770889790231, -11.551708872911863],
              [-16.9164260218822, -11.553962941201762],
              [-16.918023720262067, -11.55477867621247],
              [-16.91716351966785, -11.557604392445167],
              [-16.915043215614826, -11.558371429604291],
              [-16.91249921043873, -11.561932762650958],
              [-16.910303817141195, -11.562179629484259],
              [-16.907760084530874, -11.56565431092241],
              [-16.906841119295184, -11.565630896711838],
              [-16.90549261092619, -11.566934858015763],
              [-16.907455844713763, -11.570525791853369],
              [-16.908860107002628, -11.570431747741578],
              [-16.910288344920897, -11.569431546805358],
              [-16.915359776700427, -11.569817550989745],
              [-16.91500635550651, -11.571622643860835],
              [-16.915719559067707, -11.572849695961468],
              [-16.91753532850407, -11.573801492673999],
              [-16.91778101608908, -11.576183536928061],
              [-16.919211822395855, -11.578508621124273],
              [-16.920246979837582, -11.577453650203424],
              [-16.92012555867161, -11.575333786210178],
              [-16.92115817620991, -11.57436536770179],
              [-16.92163662173133, -11.572778907695852],
              [-16.920988585023327, -11.57069022344198],
              [-16.9227713957003, -11.569481191833223],
              [-16.92428735689229, -11.570165684836457],
              [-16.92745449488294, -11.569637141015013],
              [-16.927677488843013, -11.571240224063446],
              [-16.928550905151127, -11.571347366967528],
              [-16.92930291739849, -11.57283325638511],
              [-16.930885594277477, -11.572611603146408],
              [-16.932254048534496, -11.570398212135505],
              [-16.9324212439359, -11.568934083645232],
              [-16.93436603969666, -11.570015824817991],
              [-16.936034866015117, -11.569838883433311],
              [-16.93624959025734, -11.568203099208535],
              [-16.93724992915156, -11.566672153509499],
              [-16.938754484890673, -11.566015932065048],
              [-16.9404406686836, -11.56691809119656],
              [-16.94018957845156, -11.57010715842013],
              [-16.9416200898123, -11.570744220912635],
              [-16.945636458369446, -11.56945316548382],
              [-16.947013121161767, -11.570520168369177],
              [-16.94671434229807, -11.572067857920324],
              [-16.949617325626786, -11.57347124996412],
              [-16.951030757993486, -11.574884327239655],
              [-16.95297155349321, -11.57432199508604],
              [-16.953557004388536, -11.577488057242347],
              [-16.95419374204051, -11.578409066823058],
              [-16.954698005580568, -11.581315223996226],
              [-16.954110740190405, -11.582080304595232],
              [-16.954724205928937, -11.584038280116086],
              [-16.956011881433135, -11.585276293621774],
              [-16.957189737047266, -11.58556098633987],
              [-16.959268214575136, -11.584784253583134],
              [-16.959757080550517, -11.582503922013201],
              [-16.95963262156498, -11.58021121113499],
              [-16.96051741642026, -11.579840913721908],
              [-16.9619164403481, -11.57801281510032],
              [-16.96054428928551, -11.576644560792888],
              [-16.961824848668613, -11.574209837332196],
              [-16.961117378260372, -11.572510557600046],
              [-16.960820502719816, -11.57008610910332],
              [-16.961294271246235, -11.568455799214973],
              [-16.96005174188365, -11.567220525868693],
              [-16.96060560153947, -11.561967103114954],
              [-16.960218854677937, -11.559672357797727],
              [-16.960578293182095, -11.557264409695685],
              [-16.9606204961122, -11.553383658081572],
              [-16.961688553873586, -11.550560892239778],
              [-16.962405891361062, -11.549756823554123],
              [-16.964417379743697, -11.549756081621757],
              [-16.96668064633637, -11.550234360949093],
              [-16.96712979352986, -11.553735871228955],
              [-16.96682095253125, -11.555885658477914],
              [-16.96754023794904, -11.559049279797453],
              [-16.96912624923034, -11.560591959048278],
              [-16.9684433036364, -11.561828850046476],
              [-16.968695993418816, -11.564336922601742],
              [-16.968630374706212, -11.567399869610787],
              [-16.967820317499953, -11.568419402388995],
              [-16.96857028163286, -11.57020486170615],
              [-16.968436545388293, -11.572360851740125],
              [-16.97004148528238, -11.575157591388383],
              [-16.971066851324913, -11.578461395641627],
              [-16.97105670814844, -11.581010267082375],
              [-16.972344784645294, -11.582289599617772],
              [-16.97281354734386, -11.585021812094308],
              [-16.972135978778198, -11.588034205120897],
              [-16.9748335693743, -11.589082991142744],
              [-16.975148429910593, -11.590818842652016],
              [-16.976717271225862, -11.591325500999092],
              [-16.976770907931336, -11.59297009648703],
              [-16.977505056792285, -11.593546716282853],
              [-16.980002735466385, -11.593725958319522],
              [-16.981866113640265, -11.594886796664902],
              [-16.98443879207002, -11.595714984789563],
              [-16.985537330411272, -11.595649745808752],
              [-16.98624622862533, -11.597523471632462],
              [-16.988282544818574, -11.596653795076955],
              [-16.98955415791235, -11.596720809695114],
              [-16.99146873000529, -11.597578796981146],
              [-16.993461561769347, -11.596664133475164],
              [-16.995311063866644, -11.59635223604734],
              [-16.996774489129972, -11.595557323850992],
              [-16.997328610078622, -11.591804801204294],
              [-16.998346632382987, -11.58901273092638],
              [-17.000836133152603, -11.589576713790851],
              [-17.00132924469208, -11.59135802518468],
              [-17.000070444204674, -11.592978893100033],
              [-16.999777321467157, -11.596909215644693],
              [-16.99815040735232, -11.599388950215355],
              [-16.99681925194675, -11.60243724099537],
              [-16.995881773912227, -11.603242134749058],
              [-16.99529684637123, -11.606261558778296],
              [-16.99599697331628, -11.606404062176022],
              [-16.996701573842977, -11.608625030014817],
              [-16.996779850262122, -11.611440871302863],
              [-16.998764692784857, -11.613382620468986],
              [-16.999698154628867, -11.617514834032866],
              [-17.00314466273655, -11.618962702301085],
              [-17.004052565801256, -11.617419100852374],
              [-17.005324846167145, -11.617571489254095],
              [-17.00692355687895, -11.616689781499664],
              [-17.00869742389532, -11.618280206750935],
              [-17.00994289407546, -11.617478334477555],
              [-17.011551389414002, -11.61850251796055],
              [-17.013281792095178, -11.617621910505719],
              [-17.015684773169486, -11.61848563745489],
              [-17.015787218234827, -11.620176965971705],
              [-17.01696905922487, -11.620499980191424],
              [-17.018088097909004, -11.62190548006191],
              [-17.020042056637845, -11.62596842138833],
              [-17.02164442503502, -11.624867597099662],
              [-17.024746870151205, -11.623487324232524],
              [-17.02772710974255, -11.624141248120099],
              [-17.03218878125514, -11.622953802567224],
              [-17.03354656512742, -11.623321276977528],
              [-17.0370664060146, -11.623244602033525],
              [-17.039419063118224, -11.621849790190197],
              [-17.041676707724953, -11.62088610512286],
              [-17.048333732823373, -11.619725234412945],
              [-17.04924942544236, -11.620258088321362],
              [-17.051151047446936, -11.619504696857089],
              [-17.052928010355892, -11.61822968162093],
              [-17.05659988070245, -11.616590077135466],
              [-17.059496114714687, -11.613770248641185],
              [-17.06215754242193, -11.611943300366065],
              [-17.064734608875334, -11.60981171790486],
              [-17.06826486845246, -11.608600868264357],
              [-17.069551490571836, -11.607621321503506],
              [-17.072492666258068, -11.607744211646514],
              [-17.073291515413043, -11.60710463589176],
              [-17.076989372296623, -11.606413007710458],
              [-17.079201793269586, -11.605054094354845],
              [-17.08108991768907, -11.601398185704774],
              [-17.082521288263873, -11.59916503123256],
              [-17.083267417662434, -11.599173520242848],
              [-17.085397082044604, -11.600971082856528],
              [-17.087510717335746, -11.600388892070576],
              [-17.090188572124916, -11.600374748782283],
              [-17.092040174673663, -11.599659307928077],
              [-17.093309439384292, -11.599975401391477],
              [-17.09564530931491, -11.599091536453455],
              [-17.097870192038993, -11.600368981982044],
              [-17.099186805971588, -11.600382315857972],
              [-17.10552803466818, -11.602737429681678],
              [-17.108067298388608, -11.603453742950583],
              [-17.109099265817036, -11.601170200888069],
              [-17.110704482202753, -11.598546523161366],
              [-17.112605795575288, -11.59704988239892],
              [-17.114621318595756, -11.597370515012345],
              [-17.117787945678256, -11.596576511952986],
              [-17.11819052038672, -11.595715018617588]
            ]
          ],
          [
            [
              [-17.148677227306763, -11.411060658363823],
              [-17.146103427811727, -11.408337583127746],
              [-17.14634532969885, -11.407678528359742],
              [-17.145189628126406, -11.406158087918053],
              [-17.144324052713927, -11.406429543726361],
              [-17.143427170568827, -11.411218606141546],
              [-17.14476301697819, -11.411738958975116],
              [-17.146838370590427, -11.411475246342746],
              [-17.148152303584133, -11.412037775723181],
              [-17.148677227306763, -11.411060658363823]
            ]
          ],
          [
            [
              [-17.15243710145839, -11.994679553649313],
              [-17.151853046665057, -11.993785569655165],
              [-17.149506417490883, -11.992080208482978],
              [-17.146069887339834, -11.990812783463614],
              [-17.14113761847087, -11.989713207918879],
              [-17.13891113098236, -11.990588905894695],
              [-17.139128960991858, -11.991837209635019],
              [-17.14092325684588, -11.994565030265385],
              [-17.14273259111664, -11.995155846314043],
              [-17.14421382206656, -11.997436497932558],
              [-17.147015102721667, -11.999013082041067],
              [-17.149690558263973, -11.999028977889477],
              [-17.149784985040878, -11.99840579306049],
              [-17.151880224686984, -11.996858835565897],
              [-17.15243710145839, -11.994679553649313]
            ]
          ],
          [
            [
              [-17.19824278447092, -12.047727145602927],
              [-17.19715216098694, -12.046875620101906],
              [-17.194375733088165, -12.046735207267872],
              [-17.195646495806546, -12.048347068704006],
              [-17.195596528371382, -12.050180140886958],
              [-17.196779968533583, -12.050406406837704],
              [-17.19824278447092, -12.047727145602927]
            ]
          ],
          [
            [
              [-17.2066553586887, -12.054180127524509],
              [-17.205198686732817, -12.053596637792925],
              [-17.20310837595582, -12.050910565497595],
              [-17.201698273448308, -12.050103133768063],
              [-17.20114842249911, -12.051890702041284],
              [-17.200464727979828, -12.052202198891083],
              [-17.203147603218454, -12.054487747938406],
              [-17.204104024200497, -12.054534269707133],
              [-17.20583216374695, -12.056325839931489],
              [-17.2066553586887, -12.054180127524509]
            ]
          ],
          [
            [
              [-17.215263479481507, -12.055084061796475],
              [-17.213169291670265, -12.053696031580207],
              [-17.21202965801146, -12.054589359059705],
              [-17.215080628334952, -12.055799671734183],
              [-17.215263479481507, -12.055084061796475]
            ]
          ],
          [
            [
              [-17.22786256354702, -11.461788445627436],
              [-17.22652516694838, -11.459899622958625],
              [-17.223802560941543, -11.459076727004584],
              [-17.222795796714603, -11.459860880478606],
              [-17.22786256354702, -11.461788445627436]
            ]
          ],
          [
            [
              [-17.23215840851085, -11.964189611893321],
              [-17.231841077042617, -11.962412205727452],
              [-17.230484939844153, -11.963301607349644],
              [-17.230576023728243, -11.964545521733369],
              [-17.23215840851085, -11.964189611893321]
            ]
          ],
          [
            [
              [-17.255383364680753, -12.0691485339975],
              [-17.253690552508534, -12.066735014606383],
              [-17.252774039639487, -12.064677995322752],
              [-17.251084930947652, -12.06351785520883],
              [-17.251719200074596, -12.061726770037078],
              [-17.251033927243714, -12.06092290660273],
              [-17.248205514650998, -12.059361944436164],
              [-17.247111633743827, -12.05918514493174],
              [-17.24647808557197, -12.061825849992593],
              [-17.245111210273965, -12.062051598492436],
              [-17.243606117796176, -12.061427584083214],
              [-17.23886178334324, -12.057183216386143],
              [-17.236354643007232, -12.055799015751116],
              [-17.235533746968983, -12.054636715212972],
              [-17.235577699799506, -12.05262452479387],
              [-17.234530301907693, -12.052848920866547],
              [-17.233621534653437, -12.055845631020047],
              [-17.231526646423614, -12.057412388027782],
              [-17.229339881589052, -12.057502758322867],
              [-17.229978893458412, -12.06085795934831],
              [-17.228795411668283, -12.066183492129639],
              [-17.22893289408864, -12.067973899557732],
              [-17.230392166414063, -12.068555362880131],
              [-17.235135132452996, -12.06900051554078],
              [-17.237413508529325, -12.067163241950944],
              [-17.24233728836849, -12.066754794607075],
              [-17.243885758467353, -12.065588762248666],
              [-17.249036682191786, -12.065132869978827],
              [-17.250405549070887, -12.065667342841992],
              [-17.251321457636593, -12.067679935021763],
              [-17.253423561662444, -12.069645351879174],
              [-17.255383364680753, -12.0691485339975]
            ]
          ],
          [
            [
              [-17.264014316250236, -11.510006774782747],
              [-17.262492469970734, -11.506727326351252],
              [-17.26157845775828, -11.50687281706238],
              [-17.261347787294945, -11.509240312052878],
              [-17.262571680698315, -11.510735089870023],
              [-17.264014316250236, -11.510006774782747]
            ]
          ],
          [
            [
              [-17.27900685738386, -11.517983697643281],
              [-17.278374360773473, -11.516506653618563],
              [-17.276717787495112, -11.515658989948703],
              [-17.274984135553527, -11.51592614338679],
              [-17.2751398575805, -11.517210894849473],
              [-17.27610100243003, -11.518554643952864],
              [-17.278654992899757, -11.518574223390182],
              [-17.27900685738386, -11.517983697643281]
            ]
          ],
          [
            [
              [-17.295374451163713, -12.117293988290937],
              [-17.293946167399422, -12.115639546100441],
              [-17.29168404291761, -12.112058360010042],
              [-17.291676413695587, -12.110621231327427],
              [-17.289186479859904, -12.106862376186676],
              [-17.286382312827403, -12.104048305775192],
              [-17.28555097045579, -12.102346810720435],
              [-17.284634684571586, -12.101992032491783],
              [-17.282705315068796, -12.10002612902453],
              [-17.28064142670625, -12.098554555098449],
              [-17.27624513899309, -12.096598560233405],
              [-17.271892453575948, -12.093744298540788],
              [-17.269696885505713, -12.09307922678151],
              [-17.26791054788156, -12.091829564484277],
              [-17.267002020090338, -12.093357264921302],
              [-17.265493633348477, -12.0932275868733],
              [-17.265040150285913, -12.094260335965755],
              [-17.26266680644031, -12.095254121159819],
              [-17.2577767040793, -12.095177360138225],
              [-17.253342274724375, -12.094380514480866],
              [-17.24794527640339, -12.091789945900459],
              [-17.243878069921337, -12.090989229805155],
              [-17.242371811138923, -12.092022657488798],
              [-17.24123179786286, -12.093728178207682],
              [-17.240411960293024, -12.095881683874747],
              [-17.240006525774533, -12.100861859173953],
              [-17.239231803957285, -12.103196162492658],
              [-17.23758862982347, -12.106204915999443],
              [-17.233841600966894, -12.11155032534425],
              [-17.231096651001728, -12.11289880309659],
              [-17.229678347796238, -12.113932289508945],
              [-17.225238879722856, -12.114112657044657],
              [-17.22093718473596, -12.113123899359753],
              [-17.21942773150302, -12.111237402297615],
              [-17.216590938387675, -12.111011262289722],
              [-17.214119125643673, -12.111997418375804],
              [-17.211648588291794, -12.111635783444749],
              [-17.210231423087624, -12.110511450280638],
              [-17.2079901014336, -12.109925168781826],
              [-17.202682249615993, -12.110186525983437],
              [-17.20208861203036, -12.109646548167948],
              [-17.200576824762027, -12.110586570463893],
              [-17.19947058935105, -12.114536222610171],
              [-17.20211690740826, -12.118988237844032],
              [-17.203120224363037, -12.121236423697184],
              [-17.20586631798532, -12.122274358659759],
              [-17.207420797179445, -12.12411915070445],
              [-17.210168314362807, -12.124796908992838],
              [-17.211220799237402, -12.125651998741281],
              [-17.21319027573877, -12.126193192425562],
              [-17.214700821403795, -12.127588312291515],
              [-17.21433318216769, -12.128936555733434],
              [-17.215981661994448, -12.13033161685285],
              [-17.217769222641895, -12.130018089214232],
              [-17.220014602554937, -12.130153906475568],
              [-17.22280974996275, -12.131188928353048],
              [-17.22404729094503, -12.131324164297165],
              [-17.225605496086832, -12.129795390981528],
              [-17.227346844667185, -12.129435650557157],
              [-17.230050459243696, -12.129434952311973],
              [-17.2328004434955, -12.130242994502236],
              [-17.233351581227318, -12.132175980609532],
              [-17.23491072002939, -12.133209106411895],
              [-17.237292902694744, -12.13181338943718],
              [-17.243388093840363, -12.13131175917656],
              [-17.246001069817467, -12.131757285355928],
              [-17.248612083194814, -12.13094358411917],
              [-17.2491607267626, -12.130268333196321],
              [-17.25172638234877, -12.1299487306382],
              [-17.25287065235715, -12.129316667570771],
              [-17.25639754332401, -12.128634500428998],
              [-17.26015700569668, -12.1294343702029],
              [-17.264286668660244, -12.13113119599283],
              [-17.269705625162334, -12.13421683790834],
              [-17.272588260200813, -12.132767751761472],
              [-17.27524525997003, -12.13239797005247],
              [-17.278308309407645, -12.130497517380183],
              [-17.27963601919486, -12.13022230195514],
              [-17.28385304934835, -12.130384098988493],
              [-17.290721107654285, -12.129182334413143],
              [-17.291763945816836, -12.127109331248564],
              [-17.295040150210585, -12.123046855947573],
              [-17.295353257722756, -12.121697251331314],
              [-17.294978965907138, -12.120261143411794],
              [-17.295374451163713, -12.117293988290937]
            ]
          ],
          [
            [
              [-17.307474432816036, -11.597247148531899],
              [-17.30546568901517, -11.595877317829189],
              [-17.30496296355861, -11.597231055347933],
              [-17.306838212892753, -11.598304349927822],
              [-17.307474432816036, -11.597247148531899]
            ]
          ],
          [
            [
              [-17.32044166919053, -11.594531600122242],
              [-17.31999545158134, -11.593584056921232],
              [-17.317528410084066, -11.592218901866238],
              [-17.3159952382228, -11.592489423019522],
              [-17.313773113182744, -11.594494196193585],
              [-17.311317876973586, -11.594727633333084],
              [-17.309968011132465, -11.59616372593392],
              [-17.311031609225132, -11.597626696434181],
              [-17.312703151631673, -11.598177425910148],
              [-17.314249105415644, -11.599550757896912],
              [-17.316307521572945, -11.598973679975062],
              [-17.31785017646834, -11.59982729361538],
              [-17.319897912972795, -11.597908809255372],
              [-17.32044166919053, -11.594531600122242]
            ]
          ],
          [
            [
              [-17.378974155528223, -12.154591566863523],
              [-17.3786323231783, -12.152929077607187],
              [-17.373812334612406, -12.145284594962966],
              [-17.373425147724923, -12.143578513885766],
              [-17.371649237813415, -12.140808207235347],
              [-17.367548105657853, -12.13513936887559],
              [-17.365579381321933, -12.131292424760346],
              [-17.36302491520128, -12.128262023114535],
              [-17.361209233346457, -12.12562863716441],
              [-17.358149932399712, -12.122289082590305],
              [-17.34841978215006, -12.115599625757097],
              [-17.34403750042335, -12.112091739915739],
              [-17.337994655384037, -12.106802253092102],
              [-17.332692360805247, -12.101954631905977],
              [-17.330485459351237, -12.100536660755292],
              [-17.324011444047915, -12.097087501013753],
              [-17.320439892317633, -12.096261959465423],
              [-17.31637635103711, -12.096829234953532],
              [-17.31282487914258, -12.098782498297137],
              [-17.30994862710633, -12.099339749876583],
              [-17.30543592679682, -12.101387324419388],
              [-17.30246820902378, -12.102078217900903],
              [-17.299939899922208, -12.107523673985643],
              [-17.301149736374935, -12.110884105581903],
              [-17.300935696411525, -12.113310219440914],
              [-17.308382451856886, -12.118206227025706],
              [-17.31017124936029, -12.118688755461136],
              [-17.31455006084009, -12.122748758558586],
              [-17.31540514581946, -12.127012924496015],
              [-17.3171563883862, -12.128394250244307],
              [-17.321606518982477, -12.129081823726807],
              [-17.326062936089443, -12.130487028450444],
              [-17.332132626502016, -12.132822397545732],
              [-17.337103375668594, -12.135074546747358],
              [-17.341019349084846, -12.137109964155155],
              [-17.345125062641905, -12.139682342330591],
              [-17.34831516363159, -12.142263055245445],
              [-17.35123447414797, -12.145160910565496],
              [-17.353648370385603, -12.147883418337411],
              [-17.357884042045548, -12.15347007742147],
              [-17.360555471813246, -12.158488399825947],
              [-17.362924677310424, -12.160896885879882],
              [-17.366079347545952, -12.163612860543878],
              [-17.36783466778022, -12.164405173929213],
              [-17.371929057543632, -12.164765560095748],
              [-17.373895416617973, -12.163932219252448],
              [-17.377881016632415, -12.159109427297976],
              [-17.37890831106667, -12.156709524238344],
              [-17.378974155528223, -12.154591566863523]
            ]
          ],
          [
            [
              [-17.375349267831997, -11.84024457372279],
              [-17.373276572111067, -11.839167652029476],
              [-17.372816895572612, -11.83816013990698],
              [-17.37369914622636, -11.837093130670501],
              [-17.372095199731277, -11.833985886553787],
              [-17.37133728899384, -11.834214385055224],
              [-17.36975977219028, -11.8332641166361],
              [-17.368612941877146, -11.834685545988066],
              [-17.368862086215252, -11.836840314729766],
              [-17.365688457275347, -11.837227610655422],
              [-17.3642519313253, -11.836846972779085],
              [-17.36257977257107, -11.835412255527496],
              [-17.360493477433888, -11.832925234815661],
              [-17.358484196471593, -11.829205389748696],
              [-17.357011412512982, -11.825348771700238],
              [-17.35617208783928, -11.822146273315994],
              [-17.35573931025595, -11.819292269412626],
              [-17.35641993594706, -11.81607576258235],
              [-17.357304547028427, -11.815231270676042],
              [-17.359541668879757, -11.81551568975817],
              [-17.36064834020226, -11.81458068705618],
              [-17.35995116370411, -11.812126577129115],
              [-17.35696971460667, -11.809037697701182],
              [-17.35607236185112, -11.808651561751565],
              [-17.354300448178574, -11.805770076884052],
              [-17.350301733076485, -11.80330607348207],
              [-17.34795795042593, -11.796610636807372],
              [-17.34702388278663, -11.792405853569083],
              [-17.345402507516823, -11.790797702487357],
              [-17.343700468663577, -11.785417280085612],
              [-17.342752385057583, -11.784154248836948],
              [-17.340109248647927, -11.782687365334484],
              [-17.334840654514743, -11.78150597214121],
              [-17.33349231681505, -11.780202041842388],
              [-17.331074365485257, -11.778775664198168],
              [-17.330439721970844, -11.777509413193316],
              [-17.324800789307147, -11.77422395043784],
              [-17.323359901922867, -11.77221909069656],
              [-17.32213202587581, -11.768986549847822],
              [-17.321835479697892, -11.765265429322655],
              [-17.32298284851953, -11.764074379785933],
              [-17.323020011691977, -11.76315431044581],
              [-17.321461632364134, -11.762990977159408],
              [-17.318738603861323, -11.761785380554707],
              [-17.31847978842485, -11.762838321490602],
              [-17.3166181631283, -11.763727648124691],
              [-17.314790004326902, -11.763171340353548],
              [-17.311816302700255, -11.764155360639048],
              [-17.308647798569144, -11.762731432208264],
              [-17.307482903642946, -11.761513105020462],
              [-17.304631809257184, -11.76083066121263],
              [-17.30270184035676, -11.75808456161101],
              [-17.300462315534404, -11.755471909109394],
              [-17.299425083395434, -11.753071423280316],
              [-17.29643165203534, -11.750463405997213],
              [-17.29384865179611, -11.74947153813278],
              [-17.29304253900843, -11.748338514831971],
              [-17.290367551138168, -11.746646820527335],
              [-17.28942685227444, -11.74516478167544],
              [-17.28910692281911, -11.743461009136363],
              [-17.2894104748963, -11.74206058764152],
              [-17.288741017847173, -11.741451615668208],
              [-17.286258511381583, -11.74229468111321],
              [-17.284568808877548, -11.741821619951626],
              [-17.28194927181811, -11.74196486101437],
              [-17.27763405922692, -11.740147420648322],
              [-17.275948089310724, -11.740460097070155],
              [-17.274170131912662, -11.73998634311664],
              [-17.273535081545788, -11.736623261958181],
              [-17.272292238940217, -11.736627931853901],
              [-17.270911317985977, -11.73532201190176],
              [-17.268998660111343, -11.734149047531764],
              [-17.26868234752972, -11.732577296665749],
              [-17.267486173030168, -11.733105731837625],
              [-17.264469822460118, -11.733508540250112],
              [-17.26229119429614, -11.732117160926139],
              [-17.260788600503044, -11.734174703771613],
              [-17.25839377256719, -11.734792857677764],
              [-17.252004838506632, -11.735681794174011],
              [-17.247967415201952, -11.736520217516048],
              [-17.243574068607845, -11.737138974603619],
              [-17.24139904852061, -11.737141922615505],
              [-17.235938167540258, -11.736098916366274],
              [-17.23296336484373, -11.734396981768974],
              [-17.23251839345551, -11.73247493529393],
              [-17.231054746079003, -11.733655048991618],
              [-17.231277541369046, -11.73566486662282],
              [-17.230035170692787, -11.736626872554961],
              [-17.225640814468367, -11.734661479826014],
              [-17.224176114124695, -11.735141833533582],
              [-17.22169000189959, -11.737588709233606],
              [-17.222266467659345, -11.740167434340561],
              [-17.223287621123948, -11.740910895921191],
              [-17.22337587844917, -11.74392754483183],
              [-17.2221763444938, -11.745545043084645],
              [-17.22164261746519, -11.747294225710856],
              [-17.222130638185305, -11.750224980197656],
              [-17.222083710915058, -11.759370773100462],
              [-17.22097121005348, -11.761427819185077],
              [-17.219857311515195, -11.76576264525786],
              [-17.220034370867353, -11.767996272131917],
              [-17.22092325653489, -11.771413706493108],
              [-17.222436183763964, -11.773736255080442],
              [-17.219006804475622, -11.77561941340417],
              [-17.216380036583235, -11.774960619867754],
              [-17.21250464138567, -11.776403662021828],
              [-17.211211815176107, -11.777541849800487],
              [-17.210271068773086, -11.782012349560627],
              [-17.2103991405612, -11.786573622610133],
              [-17.203449607018662, -11.78467757857095],
              [-17.202556958480212, -11.785377853549882],
              [-17.201267370459455, -11.78401576869352],
              [-17.20167001094218, -11.783183445501944],
              [-17.200960571124003, -11.78142799132999],
              [-17.20123072341217, -11.779981845274346],
              [-17.201013228463406, -11.777394863533324],
              [-17.20168719112445, -11.774328205829299],
              [-17.20226787481243, -11.773365251170684],
              [-17.201561873615276, -11.771154858460564],
              [-17.19999872126125, -11.771549684739988],
              [-17.1969835334407, -11.767440108761507],
              [-17.196630730299304, -11.766037888009745],
              [-17.195468763470807, -11.765340847459166],
              [-17.19650378507754, -11.763278686483241],
              [-17.194594310979618, -11.762028388570844],
              [-17.19175697862916, -11.762308782701197],
              [-17.189042247243204, -11.759275370681793],
              [-17.191851614521386, -11.756481801494077],
              [-17.193192509730007, -11.75377223934516],
              [-17.19599954872806, -11.751022673858602],
              [-17.196155455796646, -11.750100112598806],
              [-17.19818736831482, -11.749255228463912],
              [-17.19924766268533, -11.747547657765427],
              [-17.200342672215612, -11.746991838432628],
              [-17.200721874509004, -11.745259397172415],
              [-17.201833280840596, -11.74478044388633],
              [-17.202635359634343, -11.743382697216436],
              [-17.20130712966699, -11.741325402055818],
              [-17.20210912525921, -11.739884364095989],
              [-17.200781544004165, -11.737740377915483],
              [-17.200072164994737, -11.737301887043339],
              [-17.19696560956265, -11.736945499483328],
              [-17.195055308113268, -11.73759672753175],
              [-17.191946846506138, -11.738026018240165],
              [-17.19088290822339, -11.737454807139912],
              [-17.18697490558303, -11.738011946857787],
              [-17.182760602418877, -11.73712429436766],
              [-17.181648198140298, -11.737863439540666],
              [-17.17920405723758, -11.738554066437274],
              [-17.177078780883036, -11.737103933290545],
              [-17.17569719382272, -11.738453535554491],
              [-17.17351616116413, -11.739799734808715],
              [-17.17249548400837, -11.739664598878488],
              [-17.169579598934, -11.736505131106158],
              [-17.16823964199331, -11.738290866741252],
              [-17.16800869414152, -11.740169476769486],
              [-17.165119020208902, -11.740899343946328],
              [-17.163254194283834, -11.740890348159688],
              [-17.162058378604993, -11.74027243472548],
              [-17.159546898756464, -11.736675566375993],
              [-17.159640993958394, -11.735714559615792],
              [-17.16231519262649, -11.733587270752814],
              [-17.162942875110744, -11.732323367934614],
              [-17.164681975836743, -11.73062802202894],
              [-17.166410440948997, -11.730985670032808],
              [-17.167883129086103, -11.729201345126802],
              [-17.170101346814164, -11.729167570929562],
              [-17.173967498042433, -11.72756799986074],
              [-17.1747248771494, -11.726741472496089],
              [-17.179387342903503, -11.725317964539265],
              [-17.181564812130695, -11.724059648530954],
              [-17.183246340116888, -11.725069515915678],
              [-17.18431041936379, -11.7251166528586],
              [-17.18591404298655, -11.722938834332071],
              [-17.187470473232192, -11.721415668166888],
              [-17.190663376858975, -11.72107565560954],
              [-17.192035337427, -11.721908596060498],
              [-17.19430143966083, -11.719950319781761],
              [-17.196474419500493, -11.719519006111591],
              [-17.199890308546845, -11.718216963214182],
              [-17.203745750488586, -11.7184423553602],
              [-17.205384021095377, -11.719405247304268],
              [-17.210525108380523, -11.71989240368735],
              [-17.211368428216208, -11.718933161002681],
              [-17.210794605799563, -11.71692514931675],
              [-17.212038013173732, -11.714570297717845],
              [-17.21017818629781, -11.713651968234169],
              [-17.209515547511327, -11.712211489983225],
              [-17.21128804689606, -11.711690156727137],
              [-17.211865284802915, -11.710469683306952],
              [-17.21288442385718, -11.710121544748986],
              [-17.21355005862947, -11.708770469640175],
              [-17.213197774486325, -11.706851326496801],
              [-17.212490308968043, -11.705891386939866],
              [-17.212448336347016, -11.703667987843524],
              [-17.211874141611816, -11.702490226468669],
              [-17.21276597727142, -11.696215785443798],
              [-17.21316529396665, -11.695039994080902],
              [-17.21281783053123, -11.688724158270537],
              [-17.213175873557294, -11.684501447861624],
              [-17.212602930531425, -11.682933794954204],
              [-17.206424218470154, -11.677791235735288],
              [-17.20603140962717, -11.674832330878825],
              [-17.20250115885162, -11.673347602783624],
              [-17.20055925818932, -11.672952398310231],
              [-17.198490639890014, -11.669947486728494],
              [-17.197831698734987, -11.668467537628452],
              [-17.198591754772217, -11.664122208884546],
              [-17.19758226208892, -11.6617730668533],
              [-17.196701124931447, -11.661336558101741],
              [-17.195284729591833, -11.663245347770417],
              [-17.193431865915116, -11.663154159359202],
              [-17.192768595779413, -11.663717284698258],
              [-17.18950859818878, -11.662056930558292],
              [-17.186995104425602, -11.66170196843129],
              [-17.18615495603479, -11.662307870505769],
              [-17.183695271455488, -11.659171223792534],
              [-17.18237205905628, -11.659210094314444],
              [-17.179773847667498, -11.658158257104063],
              [-17.180132915581993, -11.65646536337344],
              [-17.17943167558636, -11.655333471824964],
              [-17.17586588819078, -11.653973663057497],
              [-17.175212580709026, -11.652060253909282],
              [-17.174422879113386, -11.651188300811395],
              [-17.173184274772286, -11.6522256275222],
              [-17.173309015849682, -11.653963350472466],
              [-17.17184350925903, -11.656345880935698],
              [-17.170694436249864, -11.656949109695585],
              [-17.16862067738183, -11.657200871762631],
              [-17.167697199320223, -11.656631828682835],
              [-17.164428959215027, -11.6576591516953],
              [-17.162975349338364, -11.657347779065462],
              [-17.162395933493613, -11.658517903213626],
              [-17.159884193421934, -11.658114204421206],
              [-17.15936261503663, -11.656721192155958],
              [-17.156755576330156, -11.657662994668764],
              [-17.154908664691447, -11.656740371693447],
              [-17.15446173585095, -11.657780582434535],
              [-17.155765116271496, -11.66117690844394],
              [-17.15558460012293, -11.661871383013189],
              [-17.156673622935575, -11.664310988284145],
              [-17.156744710723448, -11.6673544696586],
              [-17.15504734384678, -11.670823707721198],
              [-17.153498542982167, -11.671423780033901],
              [-17.150412880263033, -11.670623054986848],
              [-17.148497217965303, -11.67335131781024],
              [-17.145486020101696, -11.674637513504702],
              [-17.144261652706216, -11.679415799655313],
              [-17.143682896044524, -11.680064846040278],
              [-17.142955233980942, -11.683106394577264],
              [-17.143037035360084, -11.684064595558736],
              [-17.140280119131358, -11.686440798105892],
              [-17.139408692430447, -11.690876616067897],
              [-17.137942586001113, -11.69182486384244],
              [-17.137791653239468, -11.694350197212605],
              [-17.13892230735776, -11.69705928062863],
              [-17.140947898408704, -11.698467433124938],
              [-17.141514521914697, -11.699691386611965],
              [-17.14160901807775, -11.705228086347386],
              [-17.142169333239664, -11.707455514552372],
              [-17.142150775577207, -11.710159572640057],
              [-17.141647709710018, -11.71246790210942],
              [-17.139771669530816, -11.714636711997159],
              [-17.136260646118707, -11.716096143286231],
              [-17.135616796963117, -11.713255519045346],
              [-17.133134861767857, -11.707567433677086],
              [-17.1328891507821, -11.704949392413248],
              [-17.132160257017432, -11.701848965862666],
              [-17.13107647616445, -11.698920746962187],
              [-17.13095969865615, -11.696871664969219],
              [-17.130142721482482, -11.693859338166869],
              [-17.127867935805046, -11.69619442161448],
              [-17.125468703044895, -11.697439532195153],
              [-17.123394720010026, -11.696769203211307],
              [-17.121837653147253, -11.697758824433055],
              [-17.120611602021683, -11.696267278269625],
              [-17.121587269664364, -11.690830000928338],
              [-17.123192527667733, -11.689274980881578],
              [-17.12478777772623, -11.688852280230659],
              [-17.12498598797005, -11.686285100437276],
              [-17.128079809968433, -11.680867839077097],
              [-17.128185593931384, -11.678692698406532],
              [-17.128855830331126, -11.677740829225508],
              [-17.128695275007097, -11.675738236006385],
              [-17.129686535490812, -11.673266236076557],
              [-17.12828258465326, -11.672124508747661],
              [-17.128691753785336, -11.670649102887912],
              [-17.127012039861103, -11.670897027354039],
              [-17.124884952789973, -11.67183695895723],
              [-17.122454887481634, -11.672034956571784],
              [-17.119707267582267, -11.673186535569151],
              [-17.118285383152973, -11.674174898126534],
              [-17.115323256575056, -11.674540937117676],
              [-17.114427597756467, -11.675881676473775],
              [-17.111135579358628, -11.678375835093878],
              [-17.106829745908737, -11.680468428485197],
              [-17.1050499397509, -11.681713846403529],
              [-17.101509986215653, -11.682158432568153],
              [-17.09844179618942, -11.683956014573893],
              [-17.0969894478187, -11.683375500797352],
              [-17.09472427409933, -11.684396911219594],
              [-17.092664693412026, -11.68276492459325],
              [-17.0903342604227, -11.68169551177132],
              [-17.08885600599756, -11.679546902554142],
              [-17.089573150267043, -11.678640920487195],
              [-17.09413504319324, -11.677601208960995],
              [-17.096521300168316, -11.67753884783682],
              [-17.097942170649244, -11.676857162960403],
              [-17.10014999111183, -11.67692259860603],
              [-17.100917521139937, -11.675320338810348],
              [-17.099781411348356, -11.674134754196213],
              [-17.099222024302584, -11.672737233977818],
              [-17.10016407725636, -11.671311024114448],
              [-17.099703664458954, -11.668871456562874],
              [-17.100817473110908, -11.6678821118384],
              [-17.10590171190921, -11.667061926303976],
              [-17.109832162107615, -11.666837656710115],
              [-17.11262349066165, -11.665689273953785],
              [-17.11300271925065, -11.662867081691912],
              [-17.115350464886525, -11.661844753633247],
              [-17.115404135419002, -11.660802158800099],
              [-17.12026123907912, -11.660278791301604],
              [-17.123583661400612, -11.658611531377653],
              [-17.125583955893777, -11.65671603793878],
              [-17.125634211068427, -11.655977956435725],
              [-17.12749957118084, -11.654342012337976],
              [-17.128702370093833, -11.652787690638318],
              [-17.130692381854278, -11.651977688187385],
              [-17.131591230189997, -11.649769608185325],
              [-17.132874969941454, -11.649041294762421],
              [-17.13722835464229, -11.644297305248426],
              [-17.138876412857012, -11.641791975333017],
              [-17.138929037232025, -11.640577259313377],
              [-17.13779114718215, -11.63961491835574],
              [-17.138328910304732, -11.638316915353176],
              [-17.136234733637007, -11.635699760951084],
              [-17.136086239102262, -11.631969077588272],
              [-17.135613575582703, -11.630448322018418],
              [-17.13425452699381, -11.629787977219992],
              [-17.133429484509502, -11.628351551208594],
              [-17.13259329192294, -11.628388726086133],
              [-17.128468500944475, -11.627057120687972],
              [-17.126269148594456, -11.627039953319128],
              [-17.125339354564762, -11.627769459248341],
              [-17.12346237460103, -11.631222786548372],
              [-17.122144981312132, -11.630908410314458],
              [-17.11940283419699, -11.632489964443955],
              [-17.117669813644955, -11.634339893060197],
              [-17.11617297872941, -11.634370295449884],
              [-17.11537404426448, -11.635100867693462],
              [-17.113349340033338, -11.635082977295724],
              [-17.112198340005104, -11.635766534659158],
              [-17.11156888290811, -11.637148931804022],
              [-17.10850953907114, -11.639376769459929],
              [-17.105513927422493, -11.639478527155882],
              [-17.105106838104575, -11.640559437848195],
              [-17.103655030724056, -11.640415492784507],
              [-17.103542732517816, -11.642800945941508],
              [-17.10149712290839, -11.644690581087744],
              [-17.100131091872626, -11.644720370479279],
              [-17.099066060259315, -11.646787455699004],
              [-17.09784162414536, -11.648165861154743],
              [-17.096175429995174, -11.648899760879248],
              [-17.094878561047217, -11.648643290886397],
              [-17.09206260028304, -11.649982509943682],
              [-17.092093328152323, -11.651263559211479],
              [-17.090428793524303, -11.65378557747903],
              [-17.08846313419797, -11.655133746727554],
              [-17.08728153749136, -11.656512234486456],
              [-17.087654557454204, -11.659189756133925],
              [-17.086360195088616, -11.660567584861528],
              [-17.086634486048883, -11.662073357999294],
              [-17.084905104981473, -11.662252899630628],
              [-17.084821272406476, -11.663666344486684],
              [-17.083921857806217, -11.663833328800912],
              [-17.082433446699856, -11.666358531846337],
              [-17.079298801030024, -11.66872909825218],
              [-17.07765459856989, -11.666259045298176],
              [-17.08042643580999, -11.661561296479222],
              [-17.083320761789086, -11.653906062758312],
              [-17.08290956878284, -11.652642702928693],
              [-17.081446711698426, -11.653133871286274],
              [-17.07990708776961, -11.65439722364931],
              [-17.079128360538768, -11.653902041655797],
              [-17.076441151907808, -11.655461011856259],
              [-17.076368546160246, -11.655901952842887],
              [-17.07289711216538, -11.657340485702585],
              [-17.072191450716222, -11.65817150345446],
              [-17.07066747818845, -11.658086508877199],
              [-17.07084937368517, -11.659635541458131],
              [-17.067620668823857, -11.6629764802992],
              [-17.065981515424546, -11.66335911868405],
              [-17.063574153096113, -11.665197664737127],
              [-17.062209587655346, -11.664919115552017],
              [-17.061213287372354, -11.665569359237072],
              [-17.060621962909003, -11.667794604827069],
              [-17.061061471010973, -11.668485528442584],
              [-17.059037246335713, -11.67040483263379],
              [-17.05765381447287, -11.67051266475659],
              [-17.055861505826986, -11.669227301282644],
              [-17.05610303147581, -11.667752225963541],
              [-17.05554696141026, -11.66648368723727],
              [-17.05596667673097, -11.664880692268524],
              [-17.057095246961822, -11.663069878033655],
              [-17.056764222400528, -11.661500780738445],
              [-17.060317545699192, -11.659765901105922],
              [-17.060642339999234, -11.658597067998185],
              [-17.062602192275524, -11.65718851632257],
              [-17.063903540141116, -11.655510951560252],
              [-17.06432989407947, -11.653301181730901],
              [-17.066790528985102, -11.650596286149177],
              [-17.070044089751068, -11.647814399226617],
              [-17.071098138769663, -11.644658260878863],
              [-17.07571240324332, -11.64206648825924],
              [-17.076365364151016, -11.639123389123442],
              [-17.0773962551522, -11.637660469766717],
              [-17.079606467370347, -11.636948751998919],
              [-17.081678671094583, -11.636712329740815],
              [-17.085722935650075, -11.633461443190127],
              [-17.08979376029073, -11.631554674009346],
              [-17.091054855185384, -11.628966942114618],
              [-17.091988946296755, -11.62806635694434],
              [-17.092846542280363, -11.626081376275815],
              [-17.093993481787138, -11.625790143935934],
              [-17.09510851705172, -11.624371281079583],
              [-17.095614312648344, -11.622339781760662],
              [-17.096814849435965, -11.621095629359198],
              [-17.096566367862746, -11.619663593339581],
              [-17.094441606844352, -11.616955556696249],
              [-17.092206799583696, -11.616325762665882],
              [-17.091150660685926, -11.616444492605314],
              [-17.08872011711729, -11.617587793722462],
              [-17.086699854379415, -11.617435633171214],
              [-17.08491856424723, -11.619408609363377],
              [-17.08394687907343, -11.619787308876768],
              [-17.082211723126562, -11.621500776750935],
              [-17.081243409704832, -11.62157634818083],
              [-17.08068719819823, -11.623953345258126],
              [-17.078827664609747, -11.62497198344396],
              [-17.077443022944905, -11.626689534258151],
              [-17.073383679116958, -11.627638260109197],
              [-17.072718936635628, -11.628020140794426],
              [-17.06871690522643, -11.627884183615642],
              [-17.06645562176027, -11.62919994548086],
              [-17.064316169497584, -11.631253763011372],
              [-17.063757347256082, -11.633544960648281],
              [-17.062171099204903, -11.633654772265226],
              [-17.05952232675506, -11.631018053966475],
              [-17.056412078907222, -11.629979024862239],
              [-17.053494597022084, -11.630893665023523],
              [-17.050877923818707, -11.629253068472725],
              [-17.049330457092722, -11.629751745874827],
              [-17.047597213705895, -11.630898209961266],
              [-17.045924683255564, -11.630917746555076],
              [-17.044323604153025, -11.632022318358214],
              [-17.043494248998506, -11.634482405610045],
              [-17.041541069854745, -11.635538524462568],
              [-17.040639349906538, -11.634050450616126],
              [-17.038659381106005, -11.63397784480507],
              [-17.035696326239634, -11.634844356661622],
              [-17.03283517367007, -11.634800824270846],
              [-17.031662164198718, -11.63382854484296],
              [-17.02947074395549, -11.633230600407773],
              [-17.027798350000943, -11.633204401315366],
              [-17.025378786289544, -11.635768885350878],
              [-17.022130968271473, -11.637755911132473],
              [-17.016297673359183, -11.638918412676357],
              [-17.014670093755996, -11.638804568855072],
              [-17.01241378192102, -11.639373804748375],
              [-17.009829754553976, -11.641022272695984],
              [-17.007215402870195, -11.643600180604134],
              [-17.00581454915842, -11.64357578922541],
              [-17.0039156875951, -11.644766638324441],
              [-17.00257523224864, -11.649796320820574],
              [-17.003660051379068, -11.650051032752893],
              [-17.005452790034234, -11.651828587898386],
              [-17.005821966701728, -11.653346938078878],
              [-17.008050786228115, -11.65299468535294],
              [-17.010287585406125, -11.654882662505626],
              [-17.011456380087736, -11.65490362009768],
              [-17.01417419531469, -11.656852677430713],
              [-17.01509309452422, -11.658797317092397],
              [-17.015252419660914, -11.660286356766404],
              [-17.013771751995073, -11.660183504439583],
              [-17.012070521372852, -11.65908547474152],
              [-17.011041448233147, -11.66088479880848],
              [-17.01257995396548, -11.662439900469584],
              [-17.01426364324991, -11.662330370865387],
              [-17.015816174903406, -11.664416837327106],
              [-17.01561214773519, -11.66548306363421],
              [-17.017196635892144, -11.667283447351714],
              [-17.018852543790583, -11.668563215957352],
              [-17.02001096860442, -11.670539458074572],
              [-17.020034482235566, -11.671757944973367],
              [-17.020859373165404, -11.672597863752866],
              [-17.02152451520736, -11.674531516436767],
              [-17.021339631362356, -11.675883773485586],
              [-17.02347511253591, -11.67782999224098],
              [-17.02132804091011, -11.679015882785352],
              [-17.021477844587427, -11.679933815966953],
              [-17.022894088953823, -11.680733251125819],
              [-17.022456184767236, -11.682828450991074],
              [-17.021038901550572, -11.68326623729794],
              [-17.019596854743067, -11.68527384762965],
              [-17.01978641247696, -11.688043300511918],
              [-17.02118334585034, -11.689012729487033],
              [-17.021627237114558, -11.692046086855436],
              [-17.023623430148177, -11.692532604876119],
              [-17.023202517172958, -11.695179353938594],
              [-17.02223238652232, -11.69742225714059],
              [-17.02241914913451, -11.69877758040493],
              [-17.021139032375785, -11.701153906094167],
              [-17.01845839043668, -11.704447698503483],
              [-17.01559743695725, -11.705553779062718],
              [-17.01588690616286, -11.708760492222508],
              [-17.0151549039378, -11.709894346400988],
              [-17.013679848708893, -11.710818088133907],
              [-17.012126726470633, -11.71079370563144],
              [-17.01059210891904, -11.710082667813232],
              [-17.009682037258234, -11.70814843809332],
              [-17.009995201063596, -11.706068995323935],
              [-17.011044463800694, -11.704342337194358],
              [-17.010409076277643, -11.702718339821779],
              [-17.011252781121037, -11.70007306861854],
              [-17.01126702809288, -11.696760528958924],
              [-17.011858606957897, -11.693327761074585],
              [-17.011494428843687, -11.691404744433354],
              [-17.012049047334614, -11.690063797283756],
              [-17.01101856623299, -11.688303742498448],
              [-17.01083207735017, -11.683858580533224],
              [-17.011565369587906, -11.682391031779593],
              [-17.010931644244497, -11.678244797368432],
              [-17.011071602248506, -11.675331418830094],
              [-17.01043858058039, -11.673667288227394],
              [-17.008243061861, -11.670263755470954],
              [-17.004768393809496, -11.667567688706455],
              [-17.003583995117598, -11.667155620814896],
              [-17.002651368887747, -11.666017269783948],
              [-16.999941677892355, -11.66420144270929],
              [-17.000053282378254, -11.665575311385217],
              [-16.999322865502627, -11.666397373984404],
              [-16.99800451278577, -11.666160470303538],
              [-16.99728313088342, -11.66837368723197],
              [-16.99506873378299, -11.669194670005567],
              [-16.993935944821626, -11.671449309335905],
              [-16.994134880752945, -11.673395520566563],
              [-16.993728318993288, -11.674846506800487],
              [-16.992888905605483, -11.675079970202551],
              [-16.992238686271055, -11.677183075315247],
              [-16.99021441041258, -11.677667719896439],
              [-16.98898858752032, -11.676626431118313],
              [-16.988805342889084, -11.673803039168593],
              [-16.988187315846695, -11.672877900677312],
              [-16.98802609173905, -11.670290710275442],
              [-16.986259086136783, -11.667203769504464],
              [-16.987266530599317, -11.665813837131097],
              [-16.98710541786849, -11.66458468011584],
              [-16.98556144841452, -11.662954121608292],
              [-16.985808017001272, -11.661654631823728],
              [-16.984303926637676, -11.659626124238837],
              [-16.981961575300296, -11.657625231282008],
              [-16.978999263655865, -11.655786076059776],
              [-16.978368549211204, -11.656425660731966],
              [-16.976965722004845, -11.656006736827699],
              [-16.9755825756335, -11.654632459924677],
              [-16.97469738763774, -11.65265965199439],
              [-16.97329220800315, -11.652370920854809],
              [-16.9722664669143, -11.651208339140643],
              [-16.972889424557266, -11.649055165420883],
              [-16.97294463174515, -11.64547859069537],
              [-16.97218718631798, -11.642969182020012],
              [-16.971184350259445, -11.642338543264065],
              [-16.967670940497364, -11.641905908147418],
              [-16.96699478380722, -11.644626268784247],
              [-16.965799540350925, -11.64469621214761],
              [-16.965077074347725, -11.642612103446814],
              [-16.963449971079456, -11.64078283937674],
              [-16.96323080209031, -11.645706198715452],
              [-16.962662739894025, -11.646705014426907],
              [-16.96112900435164, -11.646815927655618],
              [-16.960302605519708, -11.648309550840652],
              [-16.959234019178666, -11.648663872748688],
              [-16.95950792361962, -11.650770765813007],
              [-16.957688880456864, -11.652544407590941],
              [-16.957714334878162, -11.649323505654603],
              [-16.956834072183646, -11.64929339062727],
              [-16.9532640380518, -11.646074899934256],
              [-16.95226356077831, -11.646056987810187],
              [-16.951383527163753, -11.647521033049697],
              [-16.950229636064417, -11.645360961994678],
              [-16.94813042325141, -11.646603062452536],
              [-16.945561370324842, -11.647594673999679],
              [-16.940942379849005, -11.650542378941978],
              [-16.94159806936561, -11.651645249329563],
              [-16.939875409544097, -11.654816077058872],
              [-16.94033564284134, -11.656240199709895],
              [-16.939800355947657, -11.657784447777614],
              [-16.938753999020474, -11.65887481345083],
              [-16.933077590179185, -11.659658626071487],
              [-16.932800272901208, -11.66221472770819],
              [-16.931728132120533, -11.663261609890691],
              [-16.930319841256637, -11.662960809436102],
              [-16.928712626833562, -11.663797161231617],
              [-16.92912088882598, -11.666015782752934],
              [-16.92988258407375, -11.666151624377548],
              [-16.931507370016984, -11.66868745468735],
              [-16.933982494694526, -11.66947702720638],
              [-16.936384749646272, -11.668617711702316],
              [-16.936053715899515, -11.671377103391091],
              [-16.935043381317374, -11.671510314264644],
              [-16.934560470222053, -11.67395357358284],
              [-16.93284649698757, -11.675767922666385],
              [-16.93309809521361, -11.677419390881223],
              [-16.931220345124782, -11.677077601291451],
              [-16.92853505563034, -11.675778180822087],
              [-16.92763577265337, -11.673897429795556],
              [-16.923524349899054, -11.672703063301372],
              [-16.921551041887124, -11.671726530007344],
              [-16.920489211739383, -11.669537639724123],
              [-16.919331810601662, -11.669457649987711],
              [-16.918228966106902, -11.670660470216475],
              [-16.91824409980461, -11.672149076803002],
              [-16.919244264076003, -11.6734787066163],
              [-16.919673633655695, -11.675134481362404],
              [-16.91792235435129, -11.67585386269462],
              [-16.916280662748076, -11.674322745527592],
              [-16.91475675411025, -11.673439723762554],
              [-16.91404436735752, -11.674205458192715],
              [-16.916933640750457, -11.678000448090517],
              [-16.918207220313008, -11.680069186807467],
              [-16.918791850634342, -11.680192415061057],
              [-16.92103877767839, -11.682437119309899],
              [-16.92197391195524, -11.682172202653607],
              [-16.924120616710834, -11.684392581309151],
              [-16.92614445952347, -11.685096786656688],
              [-16.926008889444073, -11.687402377633852],
              [-16.92763135456229, -11.69034469338004],
              [-16.929270056405883, -11.689985795701032],
              [-16.92867207616454, -11.68819797721505],
              [-16.92906589122364, -11.686404904729214],
              [-16.93334386129678, -11.687945616503773],
              [-16.934869853024544, -11.689127821627277],
              [-16.93627501390595, -11.689481905036104],
              [-16.937314402932476, -11.691161478744643],
              [-16.940319028782735, -11.693615721448708],
              [-16.941590066009915, -11.695374716010758],
              [-16.943086557908597, -11.698351851147695],
              [-16.942390460240183, -11.699301986926608],
              [-16.942462741583277, -11.701893717382037],
              [-16.94502358382605, -11.703756361399027],
              [-16.944788646323918, -11.705870892749209],
              [-16.94807048622582, -11.708796650906057],
              [-16.949806809582505, -11.710771751144657],
              [-16.951033255639846, -11.714150437935594],
              [-16.948294266821225, -11.715295249052984],
              [-16.945464772102753, -11.712273840276774],
              [-16.944144818041664, -11.71185162522054],
              [-16.942073124679204, -11.709475300346083],
              [-16.94103366348827, -11.7095825947745],
              [-16.93927915314339, -11.70844361426901],
              [-16.937354209096355, -11.708897341302091],
              [-16.936501681478322, -11.707856865673378],
              [-16.935262573275892, -11.708535293599617],
              [-16.935678499644375, -11.709540755919235],
              [-16.93900111160148, -11.710309513222965],
              [-16.93897932286638, -11.710876587223762],
              [-16.940876037336707, -11.712891267901037],
              [-16.941389735171214, -11.714454912014807],
              [-16.939768314487093, -11.715305648964543],
              [-16.939517568093017, -11.716384206877537],
              [-16.940447833815835, -11.720133229749239],
              [-16.941277653869665, -11.72135948522312],
              [-16.940544656518988, -11.722582219849903],
              [-16.93925556229344, -11.7228195442614],
              [-16.94031496009451, -11.726258886595808],
              [-16.941570805680488, -11.727529716887403],
              [-16.94316389683069, -11.72804037087053],
              [-16.94441615343171, -11.729874190215712],
              [-16.946763419185224, -11.731034574553998],
              [-16.9463420548299, -11.733205886509031],
              [-16.94533053645801, -11.734713467818443],
              [-16.942824915369926, -11.735532255657196],
              [-16.940096485063798, -11.732585886171998],
              [-16.939155299625646, -11.731078365313214],
              [-16.93779234312609, -11.73052329572364],
              [-16.9336722529355, -11.726496332224682],
              [-16.932099818575317, -11.725454888110582],
              [-16.930298946896652, -11.722879593170095],
              [-16.929838792914218, -11.721733090443974],
              [-16.92845700950888, -11.722006342100299],
              [-16.927377607469566, -11.720801878987361],
              [-16.926008788622877, -11.72055127879362],
              [-16.924137098529748, -11.722690759993753],
              [-16.921225720079914, -11.723800556732087],
              [-16.922123003994344, -11.725176140166045],
              [-16.923966084275825, -11.72600666690142],
              [-16.925788747295897, -11.727666582084359],
              [-16.92629622378966, -11.728683691278437],
              [-16.926109321543315, -11.730864443202346],
              [-16.928037931925147, -11.731871306511762],
              [-16.929814596562004, -11.73366146605457],
              [-16.930721994033885, -11.73652420885016],
              [-16.931633992756442, -11.737376166617034],
              [-16.931637226559545, -11.73908178786548],
              [-16.935504271408455, -11.74643238971252],
              [-16.939086305033303, -11.750977341532913],
              [-16.93889012333975, -11.751760995076626],
              [-16.93716705464279, -11.753166494984974],
              [-16.93408337223411, -11.753796513770268],
              [-16.93298579254702, -11.753202118944778],
              [-16.931122068376023, -11.753027743400375],
              [-16.93013601811458, -11.75151629712319],
              [-16.928646367804607, -11.750606143985108],
              [-16.927736180032994, -11.747827643355707],
              [-16.926320882978573, -11.747531757387003],
              [-16.92413961746096, -11.745861261487574],
              [-16.922942765300288, -11.742157764765226],
              [-16.920510298391168, -11.7417055911579],
              [-16.919511999589734, -11.740763112244265],
              [-16.91886440450421, -11.738254413550655],
              [-16.919617625091735, -11.73656736098388],
              [-16.918274785071446, -11.735223190875786],
              [-16.91599712045731, -11.732238756228455],
              [-16.913789353772692, -11.73349601716562],
              [-16.9135815093466, -11.734671311813495],
              [-16.912134253830683, -11.735684703831284],
              [-16.910338766657773, -11.738132973028863],
              [-16.911718770442693, -11.739741505297433],
              [-16.912339670304796, -11.741506439792657],
              [-16.91172964570585, -11.74276005533555],
              [-16.91027787373111, -11.74390543659029],
              [-16.908812292426777, -11.743868925948584],
              [-16.907560829567608, -11.742437612426707],
              [-16.90614774774487, -11.742095841386387],
              [-16.90395976516829, -11.74081548374734],
              [-16.901670688603286, -11.740013723467321],
              [-16.901451085606407, -11.741582770056043],
              [-16.8997109169522, -11.743507089901616],
              [-16.89763143949682, -11.744809868977718],
              [-16.89647061617194, -11.744998422119412],
              [-16.894665111283746, -11.744382577526512],
              [-16.893451330998744, -11.743257089241451],
              [-16.89025247657514, -11.74321692787729],
              [-16.88863332941876, -11.742298854268945],
              [-16.888351721935155, -11.741241231917133],
              [-16.88675184474118, -11.741242589484179],
              [-16.884024853882988, -11.741825655192914],
              [-16.880647619116875, -11.740246843169613],
              [-16.8798273207746, -11.740968041412252],
              [-16.880138747961748, -11.744082984537028],
              [-16.88174640016247, -11.745395760246387],
              [-16.881816424868834, -11.750781253468839],
              [-16.880387933625652, -11.752537786268384],
              [-16.88375024758208, -11.756350931782858],
              [-16.884675267442837, -11.756682393473866],
              [-16.88507461725952, -11.758313722287495],
              [-16.88603458926261, -11.75899625507904],
              [-16.88970344838442, -11.763124417444564],
              [-16.889002150206217, -11.764332866243098],
              [-16.891028322109776, -11.765131502131599],
              [-16.893099266053014, -11.767552505489203],
              [-16.89369015326065, -11.7687512607175],
              [-16.895165286491178, -11.77019260048856],
              [-16.8959261347056, -11.771702888324285],
              [-16.899089010050243, -11.77502944372737],
              [-16.902907251268022, -11.777231818880619],
              [-16.904717100552013, -11.777891713290746],
              [-16.905536880611493, -11.77892133958425],
              [-16.9063530238631, -11.781793473915277],
              [-16.90736637143807, -11.783968706885386],
              [-16.9082188187436, -11.787193752876833],
              [-16.909333425143018, -11.78893347479783],
              [-16.910404456551234, -11.79409691173641],
              [-16.91090113498554, -11.795602562023394],
              [-16.91041995245554, -11.796952082997885],
              [-16.910991413954267, -11.799030633549393],
              [-16.910981806267188, -11.801139470900983],
              [-16.910298711042827, -11.80164968907357],
              [-16.911173822490458, -11.804088207432123],
              [-16.911052782627113, -11.805315653535747],
              [-16.908700041193406, -11.808202382841554],
              [-16.911365959041767, -11.81051059693557],
              [-16.913213599076265, -11.811655094371798],
              [-16.914995570238986, -11.811874506708525],
              [-16.917152374950838, -11.809640617602073],
              [-16.920491852433962, -11.808313933317589],
              [-16.923585721467756, -11.807860148248137],
              [-16.926287228444625, -11.807000950677157],
              [-16.931873136859117, -11.806910900873728],
              [-16.933338974260632, -11.80725207303564],
              [-16.935228427174597, -11.808570236564629],
              [-16.936091344413565, -11.809864507370886],
              [-16.9387636941687, -11.812123014320296],
              [-16.940134910543442, -11.812725451201658],
              [-16.94144457004908, -11.812139008874142],
              [-16.94089870525754, -11.810631984002098],
              [-16.935405476017774, -11.804882155429961],
              [-16.933998385493442, -11.802081778495046],
              [-16.934767837012867, -11.799771170658909],
              [-16.93614083694833, -11.798352790269039],
              [-16.93835469897773, -11.79721711788654],
              [-16.941356689304335, -11.796713359374687],
              [-16.94222039256952, -11.79796231801183],
              [-16.942195948225447, -11.799015916824697],
              [-16.94383056084961, -11.803621154694772],
              [-16.94661955596452, -11.808604513222553],
              [-16.949007910560915, -11.807689366149349],
              [-16.948833304718473, -11.805532070412005],
              [-16.949987916186583, -11.80384366067157],
              [-16.95133688537797, -11.803433306039997],
              [-16.954081590647196, -11.804502486758253],
              [-16.95448049367128, -11.802621653708384],
              [-16.95587657124304, -11.802080233007166],
              [-16.95757858370513, -11.803873501100206],
              [-16.95966489146949, -11.80444455325056],
              [-16.960391579617706, -11.801823452603108],
              [-16.96164109716445, -11.801849377576584],
              [-16.961672397040356, -11.800400479095115],
              [-16.963538602380176, -11.798725891458233],
              [-16.96284174644473, -11.797920968526544],
              [-16.962621353530857, -11.795720577980372],
              [-16.965017180363212, -11.794276902001927],
              [-16.96706772048691, -11.794362643560177],
              [-16.972291256457034, -11.798507342467591],
              [-16.975007393942406, -11.798824539221467],
              [-16.976205792452433, -11.796959752072741],
              [-16.97859426912564, -11.798016362916794],
              [-16.980974691578187, -11.795032274757869],
              [-16.981134839863895, -11.79371840901914],
              [-16.982218399555798, -11.793080504027444],
              [-16.984786597405478, -11.794051113733829],
              [-16.985412145618294, -11.791736195362594],
              [-16.98521346445787, -11.790503450476344],
              [-16.985782919711482, -11.788758799198627],
              [-16.988287521727234, -11.78608515992677],
              [-16.9887073414797, -11.78512782247154],
              [-16.99233049852218, -11.784492739936614],
              [-16.99561007744159, -11.785517535163235],
              [-17.000497011559485, -11.78885170938961],
              [-17.001310661341797, -11.788251736839024],
              [-17.00384916660492, -11.788427765731],
              [-17.00528754929698, -11.78779442144157],
              [-17.006026800938812, -11.786359331734458],
              [-17.00763590595738, -11.786123782620864],
              [-17.008780505263204, -11.784432269078067],
              [-17.011834513886562, -11.783123981827561],
              [-17.015223970081443, -11.783005195394963],
              [-17.015887767503482, -11.783279329547353],
              [-17.01785041835858, -11.785811736633887],
              [-17.019668084370817, -11.786411588796508],
              [-17.021631899292117, -11.786267958679664],
              [-17.02269439285317, -11.78672367116767],
              [-17.022259679977164, -11.788734886802636],
              [-17.020508525567866, -11.789452713276892],
              [-17.01854993624789, -11.789245818097907],
              [-17.016715003611875, -11.79224408828049],
              [-17.017893517923387, -11.793755790209667],
              [-17.021362495403935, -11.794382495470222],
              [-17.021045686181967, -11.797318948984044],
              [-17.018662816172267, -11.798378154775513],
              [-17.016393681505175, -11.797990018012786],
              [-17.015113502181, -11.797178428716256],
              [-17.01211773032152, -11.797523713871662],
              [-17.009861347222518, -11.796432039016976],
              [-17.009000584439555, -11.797164001103448],
              [-17.004649722618232, -11.798406555848633],
              [-17.00320934043229, -11.796625229065741],
              [-17.000513678102177, -11.797631631480431],
              [-16.996897074787054, -11.800114438911823],
              [-16.99367529871542, -11.80053929821477],
              [-16.992593568127877, -11.801090576360643],
              [-16.990082679800867, -11.803987713259826],
              [-16.98899943651949, -11.804582973876943],
              [-16.98669554536558, -11.808231152920744],
              [-16.98465788025898, -11.809642954445238],
              [-16.985969883049453, -11.811074468242266],
              [-16.98552311680045, -11.81335198879277],
              [-16.98335722610139, -11.81441039496731],
              [-16.981705275626062, -11.81433497137144],
              [-16.98015736953756, -11.815756064285768],
              [-16.976630544294466, -11.81555586360508],
              [-16.975953265233446, -11.815894421941584],
              [-16.974338066597866, -11.81836952089737],
              [-16.97232001109764, -11.818681779706623],
              [-16.971441716427897, -11.817916455304069],
              [-16.96986595433683, -11.818456984504715],
              [-16.967137190634556, -11.818533967817412],
              [-16.96627042445846, -11.81935187713732],
              [-16.965832768758787, -11.82101462049261],
              [-16.966276812596192, -11.823267580396646],
              [-16.964897354205668, -11.825043707220576],
              [-16.963839410676677, -11.824317849981444],
              [-16.962012297810336, -11.826084485708346],
              [-16.963163887725635, -11.828705204375952],
              [-16.962700947083015, -11.831512860623913],
              [-16.962968836313987, -11.833631984339698],
              [-16.962578667648597, -11.835120966564327],
              [-16.96426783713423, -11.83568424741939],
              [-16.967553615848125, -11.839098347869808],
              [-16.968457537198123, -11.840834693832843],
              [-16.96840579519813, -11.843300923586819],
              [-16.966728600856804, -11.8442364216766],
              [-16.966660498242636, -11.845336936374897],
              [-16.967632237002835, -11.848133233648047],
              [-16.969444018391822, -11.849359743736745],
              [-16.97139322711295, -11.852617219001576],
              [-16.975041603666636, -11.856172802307071],
              [-16.976737815277332, -11.858764224926942],
              [-16.97801493642826, -11.859935728197431],
              [-16.979365106544144, -11.861947177074738],
              [-16.981000644762634, -11.863169874742038],
              [-16.982011857100694, -11.861953783988028],
              [-16.981381324487497, -11.859824129224936],
              [-16.98240358981691, -11.85803498782031],
              [-16.9820727601218, -11.85436786556225],
              [-16.984815515170673, -11.851686145768639],
              [-16.98599159285331, -11.851134969024283],
              [-16.988682558127127, -11.851052798368562],
              [-16.990404732809903, -11.852407187240045],
              [-16.991882944084136, -11.85481538959522],
              [-16.992255284884244, -11.856453891218425],
              [-16.993634865747765, -11.857008186309745],
              [-16.993913751513293, -11.85886575211844],
              [-16.99564072514139, -11.860043590283155],
              [-16.996883596248285, -11.863154309940171],
              [-16.998485057219536, -11.863888863654235],
              [-16.999308830364303, -11.865447806926657],
              [-17.000470360853136, -11.865733028586568],
              [-17.00080573843093, -11.867018837696861],
              [-17.002327284250374, -11.867265888967705],
              [-17.00253305169179, -11.86581303025782],
              [-17.0042103323158, -11.864871244693353],
              [-17.00578113182259, -11.86485430879108],
              [-17.00691353858716, -11.864255855618133],
              [-17.008287614432945, -11.865205761914211],
              [-17.009830575685278, -11.864217011017958],
              [-17.00766332676264, -11.86245946790836],
              [-17.00687630272893, -11.860984097849395],
              [-17.007040973423216, -11.859292765752317],
              [-17.006109669539352, -11.856522158364552],
              [-17.006935482339877, -11.854633620439198],
              [-17.008110803516466, -11.854080420485323],
              [-17.01056281415415, -11.85436015644496],
              [-17.01180859801804, -11.855933001585926],
              [-17.01331489466782, -11.859054089144117],
              [-17.014901828851894, -11.858919204354162],
              [-17.01598731377953, -11.855761286653273],
              [-17.01718713518782, -11.854989924265153],
              [-17.016715778156275, -11.853703286766645],
              [-17.017154285296773, -11.851638448059523],
              [-17.018537316873, -11.849368725563842],
              [-17.020754766740993, -11.849489900284796],
              [-17.02088007296499, -11.848613022758675],
              [-17.01941351882203, -11.847884394841417],
              [-17.017853925589126, -11.848440994590748],
              [-17.01733075328344, -11.845999480359932],
              [-17.016041063167243, -11.84439235212089],
              [-17.015871111871267, -11.843332055583305],
              [-17.014085593331362, -11.842456728523318],
              [-17.011989075423248, -11.840941916192637],
              [-17.011363448618347, -11.839847813082782],
              [-17.013763014694025, -11.837800139964589],
              [-17.014900931008807, -11.83879645039093],
              [-17.01643227595135, -11.838795126312721],
              [-17.01772947221517, -11.839926354861065],
              [-17.017577699641464, -11.840954631425745],
              [-17.018785143297464, -11.841394599781259],
              [-17.02668576000369, -11.845749133109571],
              [-17.02972627589367, -11.846104422059927],
              [-17.032013295173954, -11.845963011018426],
              [-17.032829803793078, -11.845314532475738],
              [-17.032731482848085, -11.843021882310461],
              [-17.03413810693238, -11.841853610505359],
              [-17.037911733401625, -11.841961012067872],
              [-17.039797797363477, -11.843389467328052],
              [-17.04030965784554, -11.845380988233558],
              [-17.04171845609117, -11.844035404537234],
              [-17.04693134819598, -11.845915379527009],
              [-17.04855817058473, -11.847108762237871],
              [-17.051871308102072, -11.848529250078833],
              [-17.053665672277805, -11.851252148281647],
              [-17.05485726488892, -11.852245477341182],
              [-17.055650607061605, -11.850308783197185],
              [-17.059281444310667, -11.850224206931463],
              [-17.062378133671444, -11.849867367649562],
              [-17.0640450410003, -11.84918343275991],
              [-17.065277396437995, -11.845055382977028],
              [-17.064832406524406, -11.838002301261339],
              [-17.065386732125184, -11.836688326782895],
              [-17.0665668278256, -11.836538185502723],
              [-17.067503554545997, -11.839136673259288],
              [-17.068297020037424, -11.843595087297974],
              [-17.068160436464826, -11.848660448001782],
              [-17.068525238775436, -11.852016076740151],
              [-17.069774591324876, -11.852805742466252],
              [-17.0723244592956, -11.853180250335967],
              [-17.074052174468523, -11.852645484628447],
              [-17.075568319770476, -11.854012264218435],
              [-17.07550520432589, -11.85477871523927],
              [-17.073389514464683, -11.856208815166502],
              [-17.070657934100748, -11.855249908402731],
              [-17.068910006810572, -11.8552286641268],
              [-17.06728884616467, -11.855790836749314],
              [-17.065432328831324, -11.857205309226151],
              [-17.06356281424149, -11.856855575682632],
              [-17.062960234038368, -11.857659431992777],
              [-17.058837665966653, -11.857482845658339],
              [-17.05738253716566, -11.859886954855027],
              [-17.054922165811686, -11.86155260174282],
              [-17.0503314678018, -11.85906207703028],
              [-17.048902162505698, -11.858649592100521],
              [-17.04675228445915, -11.859388346793494],
              [-17.044650624549465, -11.858488640600354],
              [-17.04351623818824, -11.858725678405861],
              [-17.04052473776035, -11.857105855475131],
              [-17.038986177075017, -11.85700318809665],
              [-17.03670104130756, -11.858735592166916],
              [-17.036774317175688, -11.860669772446302],
              [-17.03499329162056, -11.861754026436556],
              [-17.031796887313728, -11.861778918826442],
              [-17.030083306322915, -11.863922940067374],
              [-17.02930394764321, -11.866922390524017],
              [-17.02778746611988, -11.86769682744444],
              [-17.025982844221037, -11.869318587743122],
              [-17.025649212146813, -11.870917074927698],
              [-17.027041687037446, -11.873631949749536],
              [-17.031718896624255, -11.875999689918395],
              [-17.03245777020278, -11.877556398556418],
              [-17.035128041440025, -11.87914218222931],
              [-17.03754708232289, -11.879575463048557],
              [-17.03861479345055, -11.880253766473432],
              [-17.040729681416206, -11.880019297450751],
              [-17.042402818590936, -11.88229612758806],
              [-17.045025204478137, -11.884233440747764],
              [-17.049759711714614, -11.886243206647396],
              [-17.05128746489801, -11.88626401929782],
              [-17.052825766437884, -11.885533526825965],
              [-17.054702563094665, -11.886309885392516],
              [-17.056231538703873, -11.886241883276606],
              [-17.05822963590277, -11.888035980373058],
              [-17.05890551405406, -11.887911886222016],
              [-17.059648417351642, -11.886153921915964],
              [-17.061039592293106, -11.886304343690245],
              [-17.063701188219216, -11.885542596043228],
              [-17.065942058706238, -11.886012522825512],
              [-17.067129170339165, -11.884568992543302],
              [-17.068442113122625, -11.883789904212238],
              [-17.071457748405304, -11.883384529731352],
              [-17.0723063697693, -11.883792285599771],
              [-17.07451091891221, -11.88355332216266],
              [-17.076383378776512, -11.88476834883793],
              [-17.076994157234978, -11.886277579179106],
              [-17.075755172520033, -11.888384732654925],
              [-17.075724512794064, -11.890903813517168],
              [-17.07350702125229, -11.892071221841316],
              [-17.07227413275033, -11.889979035499154],
              [-17.07142840287857, -11.889305928420296],
              [-17.070600510617655, -11.890798782950059],
              [-17.068667091510736, -11.890819623609376],
              [-17.068070257620267, -11.891784665417054],
              [-17.068484316373425, -11.894575216835978],
              [-17.066364093904443, -11.895079937548584],
              [-17.06692648331801, -11.896811437685553],
              [-17.067199837855583, -11.900043781967016],
              [-17.06936872145055, -11.902857353219181],
              [-17.068256709022336, -11.905365786055608],
              [-17.06686272654514, -11.905260100237237],
              [-17.063388915388366, -11.902429423014686],
              [-17.06043788104091, -11.901020325623444],
              [-17.059246958013325, -11.89923549102005],
              [-17.05782574690011, -11.897890073477416],
              [-17.056030164344307, -11.897601137030753],
              [-17.054207658693773, -11.89602923803954],
              [-17.052903656066942, -11.896011796199526],
              [-17.047850080864606, -11.893997244687249],
              [-17.046891157596285, -11.895000930336325],
              [-17.04853328092518, -11.896527119522947],
              [-17.04966137523378, -11.899417666308784],
              [-17.04882698318604, -11.9011314522095],
              [-17.04488544869337, -11.899882257327116],
              [-17.04283895687123, -11.901357475671908],
              [-17.041126662804956, -11.901510198090062],
              [-17.03969293506267, -11.90109130096258],
              [-17.037876009164222, -11.89925109451639],
              [-17.038250769682474, -11.898283545715795],
              [-17.037554723978822, -11.89672527717389],
              [-17.03598131853749, -11.896657885397568],
              [-17.03518416631204, -11.895849898257733],
              [-17.03178381634731, -11.894693528803568],
              [-17.030356983166616, -11.89392035460395],
              [-17.028275816562513, -11.894684466090972],
              [-17.026168164365533, -11.894298299298715],
              [-17.02501309750687, -11.896181793567118],
              [-17.024660204382386, -11.898520635788655],
              [-17.023478342315524, -11.89925403470185],
              [-17.021775577066354, -11.89882923259493],
              [-17.021713699711984, -11.899845570814959],
              [-17.020602486309993, -11.901730347161582],
              [-17.018837537176456, -11.902321481948182],
              [-17.018131027996404, -11.90151391015062],
              [-17.01517449325162, -11.900713632758166],
              [-17.01475600366125, -11.901502986038052],
              [-17.012951078523997, -11.901783313337102],
              [-17.011890884705085, -11.903225963446209],
              [-17.01217831870717, -11.9048238091591],
              [-17.010924592520933, -11.907015726638619],
              [-17.012826575593515, -11.908995000521731],
              [-17.01343081955351, -11.910510442131937],
              [-17.015260185118805, -11.911514455184554],
              [-17.016309963013445, -11.913347013039232],
              [-17.019200066431882, -11.915608005609323],
              [-17.019976937983703, -11.914956130769639],
              [-17.021644105612097, -11.914938352028887],
              [-17.02279699134554, -11.916063718141743],
              [-17.02700402250245, -11.917812470761172],
              [-17.028825065481755, -11.916644356586472],
              [-17.030757087523824, -11.916984065518388],
              [-17.03308495418914, -11.917949054429064],
              [-17.035293927191866, -11.917893300706979],
              [-17.036974984077734, -11.916987688455261],
              [-17.03850118260165, -11.917364567225917],
              [-17.039726767491107, -11.916761970991184],
              [-17.041612843187075, -11.917187952211323],
              [-17.04366670502667, -11.918457089901382],
              [-17.04655008567481, -11.921598728746938],
              [-17.049201235193113, -11.922167026077956],
              [-17.05128566977447, -11.921397938963416],
              [-17.052938724808822, -11.922439043440445],
              [-17.052456945847712, -11.924648091882284],
              [-17.05297736616377, -11.926117755765437],
              [-17.05494621890701, -11.92720775307868],
              [-17.058584257656964, -11.92827487795187],
              [-17.059538213603606, -11.927755134233363],
              [-17.060972706118687, -11.925025663561382],
              [-17.06503185562732, -11.92489971767484],
              [-17.06821412611499, -11.926356984258652],
              [-17.071473607167572, -11.928922752227283],
              [-17.07440873823004, -11.932282589168315],
              [-17.07630438821876, -11.935940666819304],
              [-17.076676211574597, -11.938783893458984],
              [-17.075172352911572, -11.939964009813137],
              [-17.074043534763856, -11.939995088336548],
              [-17.074023408824306, -11.941636533969218],
              [-17.073402929337686, -11.944380210589422],
              [-17.072617228571488, -11.94583546612875],
              [-17.073371248818326, -11.94695400546825],
              [-17.073621449130663, -11.948643865963044],
              [-17.07646843837235, -11.952272855850964],
              [-17.077586154387674, -11.953262808346247],
              [-17.079307320080517, -11.956746319894837],
              [-17.078886396848507, -11.95794101982256],
              [-17.079783942029938, -11.958484148938078],
              [-17.081912934755533, -11.958108154778188],
              [-17.08402757381035, -11.958975379843531],
              [-17.084979757715896, -11.95871944974681],
              [-17.087406715504986, -11.959989319322144],
              [-17.090413185536303, -11.962064743787737],
              [-17.093253780882083, -11.96280517567691],
              [-17.09457163951231, -11.962196400074124],
              [-17.09495875312811, -11.959801121825048],
              [-17.096732227409525, -11.958797241091586],
              [-17.09903612615991, -11.958953138945446],
              [-17.098463992583262, -11.957437502429755],
              [-17.10013797780501, -11.957276072203234],
              [-17.10301537290093, -11.95881402195313],
              [-17.10298129792764, -11.957703146774096],
              [-17.100648468915047, -11.955948745523903],
              [-17.099179070547127, -11.953802541032609],
              [-17.097608693872356, -11.95272146265486],
              [-17.096227692145405, -11.950843101130145],
              [-17.096525097589865, -11.948315606863508],
              [-17.09594447611374, -11.947688584785855],
              [-17.096376577731526, -11.945251631006904],
              [-17.098336259435055, -11.94349629734983],
              [-17.09978317118326, -11.943288403133977],
              [-17.101354118165798, -11.944191166106176],
              [-17.103385788276924, -11.94421053850016],
              [-17.103318371539586, -11.941902779442465],
              [-17.101179349696277, -11.939131750044353],
              [-17.09804502883524, -11.936706107639676],
              [-17.09596396245585, -11.932915932609783],
              [-17.09579997765467, -11.931362474610257],
              [-17.100520558561183, -11.932872325832525],
              [-17.107249839420753, -11.936749457699735],
              [-17.108903321496737, -11.938449760045735],
              [-17.11002607119224, -11.939036474333905],
              [-17.110845731048585, -11.938245434143248],
              [-17.111509490293052, -11.934791882353611],
              [-17.111578382014958, -11.932220951859748],
              [-17.11023677472499, -11.93096752782019],
              [-17.10767967114724, -11.929526133798053],
              [-17.106251829984476, -11.92796152395594],
              [-17.102938579994493, -11.925581569456208],
              [-17.102998232983932, -11.924119854627255],
              [-17.105762839377697, -11.922594975161589],
              [-17.10873628994565, -11.92271115705811],
              [-17.10865922601668, -11.921337062508869],
              [-17.106934226659426, -11.917954872926499],
              [-17.106124890606164, -11.917769928195462],
              [-17.104170127822613, -11.914961861473765],
              [-17.101675941372857, -11.912148608573915],
              [-17.098999775100307, -11.90964370510551],
              [-17.097004250085188, -11.906702839634004],
              [-17.096703013712006, -11.905372286230334],
              [-17.094037172778396, -11.902115507978209],
              [-17.092890354190928, -11.899980353773016],
              [-17.09030007169939, -11.898228221878625],
              [-17.088622324110542, -11.895380470139694],
              [-17.09056190892679, -11.89487019057752],
              [-17.09003693922126, -11.893538396890381],
              [-17.09046387961426, -11.891508997037171],
              [-17.088111438005175, -11.88878784657217],
              [-17.089297460848865, -11.88720943126308],
              [-17.090515758033, -11.886780405953381],
              [-17.092873575604923, -11.889014694821093],
              [-17.093488007023268, -11.890391274426175],
              [-17.096559464828168, -11.893295786078376],
              [-17.099019038654827, -11.894602537941617],
              [-17.100500303901672, -11.894882068406481],
              [-17.103531325603573, -11.893054477670791],
              [-17.103767164044857, -11.891951542454914],
              [-17.105520328385047, -11.89196802298711],
              [-17.106540279559212, -11.89343629328444],
              [-17.105529166948205, -11.895681840762194],
              [-17.10522223424738, -11.89948222954545],
              [-17.104076734464055, -11.901594841876198],
              [-17.105330858673188, -11.902181654788611],
              [-17.107578386740233, -11.902423536141178],
              [-17.109176355010607, -11.904738892562488],
              [-17.111361516487865, -11.90692671948296],
              [-17.11455686771429, -11.912000650635797],
              [-17.11543204649993, -11.914841592202238],
              [-17.116406077849856, -11.91675402159959],
              [-17.11878355984544, -11.917925260830787],
              [-17.119719124115402, -11.919173201491443],
              [-17.1207345867777, -11.921617982695603],
              [-17.122353657458525, -11.922029563621214],
              [-17.122632157050855, -11.921057270551406],
              [-17.123990496598527, -11.920270638472557],
              [-17.12478189019365, -11.91717646176438],
              [-17.126867129961102, -11.915554155292261],
              [-17.127297863515015, -11.912369438382594],
              [-17.127796798153593, -11.911930743891354],
              [-17.13154217743892, -11.910896149075285],
              [-17.132565476437257, -11.912541360261054],
              [-17.13325932380033, -11.9160885935644],
              [-17.13284264962156, -11.917591182730728],
              [-17.131708677684802, -11.918601796828753],
              [-17.13115249940347, -11.920635349933418],
              [-17.128785140256447, -11.923718805667212],
              [-17.127862259632384, -11.926414964401546],
              [-17.12734074241212, -11.929646444988679],
              [-17.127889513696893, -11.934394151213459],
              [-17.12926479392528, -11.93737581130619],
              [-17.129892967171553, -11.937823925110067],
              [-17.132301882652516, -11.935535397167694],
              [-17.134251272627925, -11.934263239332752],
              [-17.137326820016593, -11.933176315636093],
              [-17.138597581155384, -11.932076629692359],
              [-17.139544366182076, -11.932127246416206],
              [-17.141634670124617, -11.929835815230811],
              [-17.143898445820177, -11.928476333641026],
              [-17.14489128091557, -11.928349394976477],
              [-17.147456335347094, -11.929163195512304],
              [-17.150513371962166, -11.930688473873253],
              [-17.157864001049795, -11.930773346321667],
              [-17.15979984782211, -11.931403906638545],
              [-17.1623739731939, -11.930751899391746],
              [-17.163624716309258, -11.933151649340378],
              [-17.163619393285963, -11.9342156307633],
              [-17.162216460978975, -11.935095732079152],
              [-17.16617178708761, -11.938174657981666],
              [-17.169465755495846, -11.938189354164187],
              [-17.1692767312522, -11.940095782854632],
              [-17.168551135237138, -11.940846646416285],
              [-17.163445821487468, -11.941843521224484],
              [-17.160736118149945, -11.942096219802524],
              [-17.15906767968976, -11.941777147953843],
              [-17.158712168010844, -11.94075528874736],
              [-17.156142972547542, -11.94012053915707],
              [-17.154915691931627, -11.941622319081791],
              [-17.153061082741218, -11.942321819198995],
              [-17.150940047799097, -11.942220865177863],
              [-17.14981970737548, -11.940883715619881],
              [-17.147741158096416, -11.941226258122338],
              [-17.145426159603193, -11.943252859557132],
              [-17.144685877389325, -11.94599940135375],
              [-17.14481496189755, -11.94697662124245],
              [-17.147419406902994, -11.949300630299783],
              [-17.14885979204984, -11.950108207635122],
              [-17.150384981298096, -11.951848564103711],
              [-17.150873971851954, -11.953183312536122],
              [-17.14959453188128, -11.955529091482548],
              [-17.14692677369594, -11.955779817287146],
              [-17.145973962969297, -11.9563512280349],
              [-17.14407546450436, -11.956428302246131],
              [-17.142487182559965, -11.957395244565634],
              [-17.140801943854616, -11.959294108839307],
              [-17.13931018020555, -11.959284257252905],
              [-17.137812945937203, -11.960073796474926],
              [-17.138067535157955, -11.962430369865174],
              [-17.1387866165405, -11.96305703079335],
              [-17.13944690839427, -11.96563895522059],
              [-17.13969854815797, -11.96848507654568],
              [-17.140363300858706, -11.970489711097226],
              [-17.141983750178166, -11.971745212308663],
              [-17.14242940907711, -11.972770659108107],
              [-17.14400719805179, -11.973670114285499],
              [-17.14690272334079, -11.97382148665269],
              [-17.1482500453991, -11.975474954461646],
              [-17.1484173243937, -11.977699481904825],
              [-17.148998171613325, -11.97894849845375],
              [-17.14893938552782, -11.98112805599916],
              [-17.146667672872297, -11.982315728491482],
              [-17.14937859468783, -11.983355121956475],
              [-17.150332590641725, -11.982871393240622],
              [-17.15526972122608, -11.982765593990683],
              [-17.157937553367674, -11.98353600520226],
              [-17.15857386991969, -11.983138881060906],
              [-17.16142251446952, -11.984043318513137],
              [-17.162465246016165, -11.983825741632431],
              [-17.164103539584683, -11.982276512905877],
              [-17.164062816604854, -11.981341993654368],
              [-17.165609264328715, -11.979925593646984],
              [-17.164443127999128, -11.977695985983427],
              [-17.16526008410139, -11.977255105506051],
              [-17.167430096328374, -11.977843181218859],
              [-17.168150734995407, -11.978646912270314],
              [-17.168593917151583, -11.980739542674854],
              [-17.16804729095427, -11.981449118247957],
              [-17.168084817272685, -11.983140191453506],
              [-17.166757914902494, -11.98598212925948],
              [-17.167341836757107, -11.98705287019456],
              [-17.167109556680586, -11.988253744647611],
              [-17.16610873658435, -11.989094967722842],
              [-17.16704783595671, -11.991770299880436],
              [-17.167996836365607, -11.99235334794259],
              [-17.168940658605635, -11.994093913208614],
              [-17.170161890599005, -11.994722577498592],
              [-17.170972731189643, -11.995883946677251],
              [-17.174090227412613, -11.99848011459382],
              [-17.177304502421464, -11.999828741333888],
              [-17.178477773263182, -12.001392340498478],
              [-17.18047376557696, -12.001310201781074],
              [-17.18106036296104, -12.002114336350468],
              [-17.18213590508094, -12.005905838520222],
              [-17.18145110360165, -12.007106678396001],
              [-17.17931210961748, -12.008793318591762],
              [-17.177453111502977, -12.008340605754773],
              [-17.176822040297864, -12.007223983408466],
              [-17.176332138664282, -12.004904707425453],
              [-17.17139686956986, -12.002612585518147],
              [-17.167225317457874, -12.00223809699338],
              [-17.16650441472155, -12.001210064817013],
              [-17.16514383835487, -12.001203817350076],
              [-17.165680568346083, -12.002765595663437],
              [-17.163954401852926, -12.003247794269418],
              [-17.165661275194545, -12.006776378743458],
              [-17.168637547747714, -12.010846125583454],
              [-17.171536828159763, -12.01215145987234],
              [-17.17244632634823, -12.01179876365632],
              [-17.174804016282682, -12.012476778203741],
              [-17.176023461749953, -12.014086961257224],
              [-17.177340850907033, -12.013868917271912],
              [-17.179876784415747, -12.015661909132215],
              [-17.18168447702201, -12.018165826006348],
              [-17.18422826538876, -12.018040344497367],
              [-17.185278195145766, -12.016348646121799],
              [-17.184419789771056, -12.01500808314205],
              [-17.184741757996328, -12.01376039106417],
              [-17.18683416348191, -12.012473458445175],
              [-17.18892056963373, -12.01314843593939],
              [-17.19014247579789, -12.014489706901808],
              [-17.193317476919816, -12.015791219213218],
              [-17.19517504862403, -12.017445713036597],
              [-17.196167576441315, -12.020258504749211],
              [-17.194984481918652, -12.021148029074723],
              [-17.19466346549554, -12.02235200792816],
              [-17.197018055876118, -12.025793467113507],
              [-17.198198616783, -12.026286853433872],
              [-17.19914890370414, -12.028208348445112],
              [-17.2008282033194, -12.029461578852857],
              [-17.200643581541907, -12.030934475832385],
              [-17.20145957102791, -12.032141341861431],
              [-17.203687999819, -12.031832761035014],
              [-17.205005433008356, -12.032549376943965],
              [-17.206456175023696, -12.035409487237255],
              [-17.206861827359464, -12.037866633756295],
              [-17.206494627574823, -12.039965920580578],
              [-17.20926825171196, -12.04135463723222],
              [-17.21054229997719, -12.041356147552834],
              [-17.211860993124347, -12.042206474909316],
              [-17.21340840088987, -12.041939768117452],
              [-17.21431753879354, -12.042878980563234],
              [-17.214588949893706, -12.04475635616302],
              [-17.217773547348287, -12.047216721149807],
              [-17.220413400309436, -12.048290808884794],
              [-17.22828970589764, -12.048291393042426],
              [-17.2294265757314, -12.044313225932529],
              [-17.23083660473287, -12.042390961760042],
              [-17.23201931055904, -12.04145199150753],
              [-17.23370268616901, -12.041183140112299],
              [-17.23565942171323, -12.041449605017737],
              [-17.241443769501963, -12.045778692542651],
              [-17.244860230359343, -12.047427502022877],
              [-17.248821926436577, -12.04791277256597],
              [-17.25009798206057, -12.048580918496175],
              [-17.25191860287312, -12.048353703713756],
              [-17.253464697729108, -12.047545830523195],
              [-17.252550800612035, -12.046028042677186],
              [-17.252547082687983, -12.04432995086703],
              [-17.251723056773027, -12.042052511626684],
              [-17.251261819161922, -12.03910474402303],
              [-17.249435952484767, -12.035936900910231],
              [-17.24956907923592, -12.034239472170169],
              [-17.24779359662797, -12.033126179125313],
              [-17.247882119898136, -12.031831166168057],
              [-17.24496810454848, -12.029291086196809],
              [-17.245374365762306, -12.02741552774749],
              [-17.24491545038171, -12.024649059619588],
              [-17.242318491424346, -12.019700028500543],
              [-17.241363571196516, -12.01885359738553],
              [-17.239543448268744, -12.015912075401088],
              [-17.239541914499934, -12.014574193983147],
              [-17.237496337455504, -12.012212654970337],
              [-17.233136890035578, -12.00976419421482],
              [-17.231638872725394, -12.009452827384012],
              [-17.230005516281313, -12.01056811740689],
              [-17.228235103840348, -12.00998886930579],
              [-17.226646531697703, -12.008384294523703],
              [-17.224604527343946, -12.004328613324596],
              [-17.224423219722915, -12.001387771799536],
              [-17.222427790138266, -12.000363048622592],
              [-17.22161183275297, -11.999249201020572],
              [-17.222292459198997, -11.997422798945287],
              [-17.221522255787058, -11.995819347443755],
              [-17.218395293700397, -11.993680591747784],
              [-17.217942987262884, -11.991988192481015],
              [-17.21504340567842, -11.99091780574538],
              [-17.21440992833721, -11.989715402625423],
              [-17.211465316094873, -11.989089167167121],
              [-17.20947168447711, -11.989042619657846],
              [-17.20738964221537, -11.987526461698675],
              [-17.206667085043307, -11.985967722868402],
              [-17.204674418758856, -11.985653152015049],
              [-17.202499299808945, -11.986049910679526],
              [-17.201096245439263, -11.985424268997258],
              [-17.198385434550186, -11.98217062713196],
              [-17.197891428125434, -11.980345552491528],
              [-17.19648780183844, -11.980342499987314],
              [-17.195720000398893, -11.979495648709348],
              [-17.194144806643468, -11.975800210914299],
              [-17.194151192159467, -11.973265817193747],
              [-17.195104164788642, -11.972156303602539],
              [-17.196822522853175, -11.972649525760774],
              [-17.197729305229828, -11.971806678163565],
              [-17.197643156633177, -11.969894834952656],
              [-17.19882232865273, -11.968563832755025],
              [-17.202079031221466, -11.968614366545209],
              [-17.203794387898963, -11.970706759467756],
              [-17.203791293401107, -11.972484920054008],
              [-17.205284794307218, -11.972398447558275],
              [-17.20582600838208, -11.973511047698253],
              [-17.209082245339395, -11.975071672289765],
              [-17.211164127848242, -11.975074119000217],
              [-17.212430922537997, -11.975520145896343],
              [-17.21505657936936, -11.975033529744673],
              [-17.218178759617214, -11.975969297728195],
              [-17.219129436716663, -11.975925523478702],
              [-17.220216264843234, -11.97450267625686],
              [-17.219900682868094, -11.971612630185913],
              [-17.21895204035621, -11.96872257031838],
              [-17.219812276246948, -11.96707858905714],
              [-17.218184965855457, -11.965211377832837],
              [-17.21786951053773, -11.963611397632626],
              [-17.219000471387506, -11.962590067552316],
              [-17.21900094802447, -11.961657351159387],
              [-17.217329658306266, -11.959390841472137],
              [-17.21566080500342, -11.954548888066109],
              [-17.21417208785667, -11.952016720781337],
              [-17.211736337455477, -11.948596572502721],
              [-17.210070887973806, -11.944112557592897],
              [-17.208942468116764, -11.943933738487877],
              [-17.208990492043412, -11.941804214712457],
              [-17.2103456798353, -11.940874050367992],
              [-17.210708541488124, -11.939455291780082],
              [-17.210077628442747, -11.93865590514512],
              [-17.207463021587014, -11.936834191717255],
              [-17.204264617602945, -11.933769890938848],
              [-17.203771615352792, -11.931995625808339],
              [-17.20084399035117, -11.929995884115655],
              [-17.196652097440364, -11.929189217902989],
              [-17.195346111482134, -11.92847712037821],
              [-17.191702015644637, -11.925499100913717],
              [-17.189949346787984, -11.923589052626083],
              [-17.187251884873604, -11.921366368832226],
              [-17.185684665719098, -11.918305292615916],
              [-17.18546617075028, -11.916179146566437],
              [-17.183444272372622, -11.914711445435143],
              [-17.179708581766725, -11.91399058027183],
              [-17.17759136780066, -11.914115399483338],
              [-17.17782298173911, -11.912478515989019],
              [-17.180075158426273, -11.91230950857991],
              [-17.180573132278727, -11.911558454170283],
              [-17.183140027631463, -11.911478908798529],
              [-17.18314442610942, -11.910195075961994],
              [-17.184141584373865, -11.908206608821818],
              [-17.184237158769413, -11.906525519637176],
              [-17.18608578483662, -11.905513456174646],
              [-17.1882446283003, -11.906006642995406],
              [-17.189449686725055, -11.909461750254648],
              [-17.19124467046102, -11.911546877535358],
              [-17.190790140575743, -11.913050908199523],
              [-17.191276786156713, -11.916240116111023],
              [-17.195189217238298, -11.918862765309342],
              [-17.196901396375768, -11.918822380445084],
              [-17.20000711518084, -11.92029044395504],
              [-17.202756033765255, -11.920074158595684],
              [-17.204642024904338, -11.923975610739996],
              [-17.20639703556529, -11.925750475058459],
              [-17.207026194361642, -11.927125373644543],
              [-17.21121597806078, -11.929745411741015],
              [-17.21369254369251, -11.93347157269577],
              [-17.215496316488466, -11.934315344945796],
              [-17.21657818208056, -11.935336179008337],
              [-17.217388765597114, -11.937553892825198],
              [-17.21919357261152, -11.937643426359106],
              [-17.220095780443014, -11.938397866310698],
              [-17.22086193738371, -11.941325742217401],
              [-17.226866047393557, -11.9501126360714],
              [-17.227182551914275, -11.951977127752755],
              [-17.228628554584287, -11.954019116867709],
              [-17.230481429304433, -11.954906656545012],
              [-17.231974123513556, -11.957614657288596],
              [-17.23324058983004, -11.959168506351594],
              [-17.234825339085795, -11.962632722097506],
              [-17.234735669652512, -11.963787866217878],
              [-17.237270536919983, -11.966540971262232],
              [-17.239717936603892, -11.97084979600955],
              [-17.243203136205945, -11.971868008594088],
              [-17.24460323601696, -11.970221306536342],
              [-17.245689166783656, -11.970219640129804],
              [-17.24759121394072, -11.97132794673416],
              [-17.247461055550303, -11.974440450042207],
              [-17.24950170196516, -11.976482217849497],
              [-17.25100172112156, -11.979548613794764],
              [-17.251999907185606, -11.98052518427314],
              [-17.25645637937434, -11.988079892437339],
              [-17.256549731881336, -11.989192703860216],
              [-17.25940227963291, -11.988428614148836],
              [-17.26239971601188, -11.9907799021147],
              [-17.26543843804901, -11.99157198180995],
              [-17.26576110141679, -11.993218537357418],
              [-17.266903214398766, -11.995886592281312],
              [-17.266499805874716, -11.997268816774435],
              [-17.269408355382968, -11.999130091065119],
              [-17.268286403397337, -12.002519721411876],
              [-17.268652624543567, -12.003498668778013],
              [-17.273198949266167, -12.006067373133158],
              [-17.27470362449904, -12.007933846091015],
              [-17.277483132798675, -12.010597819105305],
              [-17.28121394881095, -12.012543878589984],
              [-17.28331172455112, -12.0145861294524],
              [-17.2846727024818, -12.0143569889825],
              [-17.284622526466755, -12.013331488695236],
              [-17.28284296484647, -12.011422161545388],
              [-17.282512014443757, -12.008570381579577],
              [-17.282356602705917, -12.00438150276562],
              [-17.28256009187521, -11.999301311890333],
              [-17.28299724664584, -11.99582490991254],
              [-17.28388276676437, -11.991323608242872],
              [-17.285002653064904, -11.988603152907269],
              [-17.286490288128473, -11.987082745344281],
              [-17.287794033631304, -11.985073755575243],
              [-17.291996691291015, -11.983228412512124],
              [-17.29461012364814, -11.980811776395807],
              [-17.295142666905605, -11.978896309229725],
              [-17.29675957673144, -11.976663282104491],
              [-17.301801396061496, -11.972098784539911],
              [-17.306131548868745, -11.969982991716885],
              [-17.30847832165652, -11.969123256897738],
              [-17.313885900589177, -11.966153997954804],
              [-17.320696152790482, -11.963661478982024],
              [-17.32210136334284, -11.964095085307747],
              [-17.32471596955605, -11.963053267630718],
              [-17.325159906761908, -11.96202787608368],
              [-17.324989160493477, -11.957675981404673],
              [-17.32410627100849, -11.954662732948185],
              [-17.32418697341743, -11.953463007600405],
              [-17.32326180853396, -11.950761915769515],
              [-17.323151486782965, -11.948232682026608],
              [-17.32336989993011, -11.941619083678573],
              [-17.323044407359276, -11.940423723535595],
              [-17.32285710105241, -11.933861277103214],
              [-17.323300890056775, -11.927252926545762],
              [-17.324420397710856, -11.92068681213451],
              [-17.32405270641671, -11.919803676831954],
              [-17.3244856148751, -11.90642965852709],
              [-17.32494174903257, -11.901603484588344],
              [-17.32558195296962, -11.897352477284212],
              [-17.327116210476188, -11.892520917470781],
              [-17.32879596859929, -11.88910409167831],
              [-17.33234644691989, -11.883905013333097],
              [-17.33298699176202, -11.88010052956018],
              [-17.33363998641354, -11.87775439557748],
              [-17.33491977071355, -11.875226704825117],
              [-17.336955537785872, -11.871986316802065],
              [-17.340066834040602, -11.868692678716457],
              [-17.342518185801158, -11.866949477011802],
              [-17.34548657656464, -11.867672258661706],
              [-17.347635841953792, -11.867210673264113],
              [-17.35006693595738, -11.8680257633868],
              [-17.352128712653506, -11.867784726408324],
              [-17.354198568673546, -11.868337858445093],
              [-17.35395440309579, -11.866442784047035],
              [-17.352789300259023, -11.866586634512197],
              [-17.35237459436511, -11.865532101128984],
              [-17.35307305497723, -11.863671890805644],
              [-17.35583319083459, -11.861703204109887],
              [-17.357855856790966, -11.862123344684953],
              [-17.359572604164306, -11.86325273640335],
              [-17.3624559433215, -11.86436911090837],
              [-17.36373475859144, -11.866384781487795],
              [-17.364581642025527, -11.865890395135379],
              [-17.364475284185385, -11.864435579384413],
              [-17.365322001996013, -11.863941138274829],
              [-17.367475011123744, -11.863917419381279],
              [-17.372845556049857, -11.862885896237787],
              [-17.37448635216752, -11.861322965276704],
              [-17.37317945934466, -11.860808944289804],
              [-17.3723863873902, -11.858260064742801],
              [-17.371622763476093, -11.858136260984965],
              [-17.37071534043874, -11.861013673477084],
              [-17.369143751736825, -11.860854917314455],
              [-17.366883332272685, -11.859292225417029],
              [-17.365949607960918, -11.856083433088365],
              [-17.367907015776797, -11.854783254668929],
              [-17.366543709257353, -11.853167159248278],
              [-17.36657416822667, -11.851932584024194],
              [-17.36522241940366, -11.851286014921085],
              [-17.365321075835976, -11.848156017398956],
              [-17.366695472303316, -11.84690696446969],
              [-17.369152156050816, -11.846306727004547],
              [-17.369814260898057, -11.845462319874372],
              [-17.37182527064377, -11.845086729041208],
              [-17.371628377571593, -11.84359126301606],
              [-17.372878982934377, -11.843312442070008],
              [-17.37365771854237, -11.841056986681245],
              [-17.375349267831997, -11.84024457372279]
            ]
          ],
          [
            [
              [-17.569488286126113, -12.359611403879704],
              [-17.56895039449563, -12.358711166597796],
              [-17.564739973712346, -12.35667093939467],
              [-17.560686687925767, -12.355219438162916],
              [-17.55841510316275, -12.354042804821052],
              [-17.554849197198312, -12.351526984861682],
              [-17.551158807276543, -12.34773516399979],
              [-17.549652988187614, -12.345397149124695],
              [-17.5476589093484, -12.340332340910754],
              [-17.546371898690747, -12.335525356618763],
              [-17.545484139606074, -12.333584749638554],
              [-17.542380597564552, -12.33060265525127],
              [-17.540212860295867, -12.329604942178825],
              [-17.538061173924056, -12.329245099577621],
              [-17.53393307245142, -12.329980007109182],
              [-17.531499497917597, -12.33144997097327],
              [-17.53099518418183, -12.335659000706052],
              [-17.531260920186657, -12.337021777604473],
              [-17.53316041728074, -12.340401198982452],
              [-17.53530539890827, -12.346149615163863],
              [-17.536335779509663, -12.350144293399113],
              [-17.536271720441736, -12.35325232001846],
              [-17.535504463431415, -12.354320851342205],
              [-17.532602579523722, -12.363665618268172],
              [-17.532766426515945, -12.366587998754152],
              [-17.53325308729092, -12.369320771451148],
              [-17.532366288154893, -12.371307735490518],
              [-17.53354141929361, -12.373522076266866],
              [-17.535020767750225, -12.374769101071701],
              [-17.53624145413545, -12.378813021669254],
              [-17.53743564053014, -12.379838073866654],
              [-17.537317795260737, -12.380756094243836],
              [-17.539911237562638, -12.381610943633232],
              [-17.5413124592562, -12.381532041546652],
              [-17.542647553238837, -12.382553293126191],
              [-17.544015926536098, -12.381147507487752],
              [-17.54764881535525, -12.378680476009373],
              [-17.548681898842737, -12.377008049267843],
              [-17.55044138159434, -12.376324583443559],
              [-17.55383730909223, -12.37564662780753],
              [-17.55599376239871, -12.375867984390363],
              [-17.55845334523014, -12.376950904657274],
              [-17.56288678626691, -12.376611023796938],
              [-17.564692093702334, -12.375924504724775],
              [-17.565126504554147, -12.374678054014003],
              [-17.564198655143198, -12.373191648468502],
              [-17.56452993088476, -12.37158220512073],
              [-17.56626933164993, -12.370211419738094],
              [-17.564388306494862, -12.368018056352527],
              [-17.564010355653142, -12.366106804760921],
              [-17.565170758693846, -12.364065393903644],
              [-17.56757859155229, -12.36327230580352],
              [-17.5678759118078, -12.362167114002276],
              [-17.569488286126113, -12.359611403879704]
            ]
          ],
          [
            [
              [-17.63983313327348, -11.814219104718433],
              [-17.635162241639872, -11.808959502832066],
              [-17.633431000657456, -11.809322973723095],
              [-17.63577237802068, -11.8118207951655],
              [-17.63672133369421, -11.812120123096564],
              [-17.638288996779014, -11.81418122834217],
              [-17.63983313327348, -11.814219104718433]
            ]
          ],
          [
            [
              [-17.6490312435488, -11.820254581323276],
              [-17.64781732824482, -11.819436390531035],
              [-17.647091262502286, -11.821088983053478],
              [-17.648042945189026, -11.821431725125578],
              [-17.6490312435488, -11.820254581323276]
            ]
          ],
          [
            [
              [-17.65480469271674, -11.823473355461534],
              [-17.654184928880504, -11.822393476551273],
              [-17.65207422577881, -11.820901300249123],
              [-17.65034150311147, -11.821905899557759],
              [-17.649069458867647, -11.82329084242807],
              [-17.650317468760594, -11.8250768568433],
              [-17.65338167349752, -11.8250184465063],
              [-17.65480469271674, -11.823473355461534]
            ]
          ],
          [
            [
              [-17.659704292472874, -11.827843741764113],
              [-17.658415113074078, -11.826213972537584],
              [-17.655143315559325, -11.826742776631132],
              [-17.65435002017914, -11.827738539205034],
              [-17.657378018258303, -11.83107250504639],
              [-17.659704292472874, -11.827843741764113]
            ]
          ],
          [
            [
              [-17.66525673469886, -11.837716853409386],
              [-17.663768458434205, -11.836681787772106],
              [-17.66248021863515, -11.834854157822466],
              [-17.66173096347438, -11.83637148914565],
              [-17.6597240522772, -11.83739207958606],
              [-17.65974335369286, -11.838945301228366],
              [-17.661619363966253, -11.839920854675311],
              [-17.662061224280475, -11.838965258655065],
              [-17.66379862808678, -11.838608179349386],
              [-17.66525673469886, -11.837716853409386]
            ]
          ],
          [
            [
              [-17.666518157505084, -11.839754048082806],
              [-17.664834257475615, -11.83987117425651],
              [-17.665039948241045, -11.841182592464293],
              [-17.666754696299698, -11.840514233509388],
              [-17.666518157505084, -11.839754048082806]
            ]
          ],
          [
            [
              [-17.281997040133017, -11.392348701612107],
              [-17.192122247380258, -11.392431455766474],
              [-17.192206099948447, -11.362586363757739],
              [-17.159978556949994, -11.362455605056706],
              [-17.160267016460633, -11.322657010651772],
              [-17.101826126320752, -11.322204025914315],
              [-17.10033166798793, -11.322774310615397],
              [-17.099518847213854, -11.322180142464655],
              [-17.090604605070887, -11.32200596085722],
              [-17.090197067977435, -11.323401047413224],
              [-17.091288769571115, -11.32419658445959],
              [-17.09235842296092, -11.32320640630165],
              [-17.093401178784738, -11.323711924686085],
              [-17.09359402124794, -11.325485596004794],
              [-17.09266291553527, -11.326903739818063],
              [-17.095901612726585, -11.326722180555546],
              [-17.097141488199863, -11.327647545925192],
              [-17.10165595812611, -11.327003199577812],
              [-17.101154459000973, -11.3248638995989],
              [-17.103737261323197, -11.324191432284392],
              [-17.105663988960764, -11.32436267349864],
              [-17.107101383368153, -11.325039624394863],
              [-17.108596042440638, -11.32645360537799],
              [-17.110079445449458, -11.32942047454492],
              [-17.110858637415788, -11.331801637257225],
              [-17.11154878480212, -11.33535656403448],
              [-17.11177272559868, -11.338986963977797],
              [-17.112471695292676, -11.343828332944666],
              [-17.11346339584884, -11.34553754313763],
              [-17.113262965047305, -11.349788503218083],
              [-17.113738877503284, -11.3507060677451],
              [-17.114482935017044, -11.354270619905318],
              [-17.11596437396944, -11.358585087041726],
              [-17.118943851527423, -11.362854859681036],
              [-17.120249015115697, -11.365252640132681],
              [-17.121645471422717, -11.368615459619043],
              [-17.1227574425247, -11.370266164700597],
              [-17.12489323682326, -11.372497076118059],
              [-17.127421739379717, -11.372811892022858],
              [-17.128764907941015, -11.371800274426194],
              [-17.131375507397355, -11.371421480483649],
              [-17.132464187184766, -11.372047804612151],
              [-17.13435758080764, -11.37448040299761],
              [-17.136457080172864, -11.378768566226318],
              [-17.139754786903985, -11.378494515100096],
              [-17.14242227222213, -11.37902306149429],
              [-17.144865446992256, -11.380846513542565],
              [-17.146296350865658, -11.382748715967507],
              [-17.148364460909406, -11.3861227684149],
              [-17.149619974479968, -11.388662409831358],
              [-17.15111066457915, -11.395013701459966],
              [-17.151362065106216, -11.39878353542394],
              [-17.154218087469832, -11.398396212564888],
              [-17.157428966911688, -11.39909564460593],
              [-17.15863428134204, -11.39963480645616],
              [-17.16127473477265, -11.402161905615898],
              [-17.16384755105589, -11.405477080797672],
              [-17.166741879885425, -11.406505346189407],
              [-17.16872341116162, -11.406182419116888],
              [-17.174128925026753, -11.407052583437796],
              [-17.177312366602376, -11.407177633105526],
              [-17.18065629668166, -11.407978534005931],
              [-17.18337681913142, -11.409041822679006],
              [-17.185000402738286, -11.407788015106142],
              [-17.186175318467605, -11.40838080293025],
              [-17.19011233772559, -11.40841024692623],
              [-17.191594573090594, -11.407636068552181],
              [-17.196164453286798, -11.406384371214934],
              [-17.201151124744396, -11.406757314379043],
              [-17.205791126070697, -11.4079803745264],
              [-17.207192586799245, -11.409410074137481],
              [-17.207793994169176, -11.411563792238768],
              [-17.20813372292055, -11.415678850914263],
              [-17.206911182985287, -11.418237768948345],
              [-17.203657222910724, -11.418701308785035],
              [-17.20356764379566, -11.419647069087022],
              [-17.205580699730252, -11.420199142796447],
              [-17.206726513295138, -11.421417733658403],
              [-17.207313735915456, -11.423318671496343],
              [-17.209184027688497, -11.426280095369505],
              [-17.210768988993316, -11.43185850269955],
              [-17.211223591682806, -11.436473643693212],
              [-17.214656878131432, -11.434098373795754],
              [-17.215993474659648, -11.433919786572394],
              [-17.21746605519477, -11.435394991314094],
              [-17.217554230688155, -11.436465137231131],
              [-17.216933737831933, -11.438961471249737],
              [-17.215371055823358, -11.440650944984679],
              [-17.213656617506484, -11.441104110077372],
              [-17.212436891985107, -11.440269975185783],
              [-17.209963932702507, -11.439412193260582],
              [-17.209348885963394, -11.440757861255397],
              [-17.21141764857867, -11.44309184445804],
              [-17.211771599743166, -11.444654803280184],
              [-17.21312417500488, -11.446800417565743],
              [-17.215524495243397, -11.44768845079273],
              [-17.216097218418174, -11.447349538918415],
              [-17.21777547720728, -11.448588313188624],
              [-17.220848057166936, -11.449005562245821],
              [-17.22195341491377, -11.448150652552776],
              [-17.223469816555095, -11.448975257101887],
              [-17.22566596436411, -11.447693703178976],
              [-17.228886621785698, -11.448076941995593],
              [-17.231530628039607, -11.449529663330742],
              [-17.23371238735105, -11.448322407011911],
              [-17.23578859564962, -11.448653633229002],
              [-17.23707099712927, -11.449671217349563],
              [-17.238438536107076, -11.452447939431398],
              [-17.239509054639253, -11.453293738419502],
              [-17.23931777438543, -11.457053879314188],
              [-17.238066142325643, -11.466083226383645],
              [-17.238807811631933, -11.46653876704123],
              [-17.239921500152338, -11.46847085885997],
              [-17.23637820547015, -11.470956069165767],
              [-17.235253878272243, -11.474458512103977],
              [-17.235115395617896, -11.47581549713262],
              [-17.23585861469589, -11.476638367096657],
              [-17.234820926262543, -11.478017057499894],
              [-17.233669236771192, -11.47800962888585],
              [-17.231774170065783, -11.479309111959433],
              [-17.23049797601452, -11.478699938885157],
              [-17.227492562701194, -11.478667108122632],
              [-17.225512080047963, -11.48014458231676],
              [-17.223089556114672, -11.482636093109532],
              [-17.22457662018934, -11.483375415837816],
              [-17.225719548509595, -11.484903607578634],
              [-17.22552336089364, -11.487584171592871],
              [-17.228324272729758, -11.488171530666838],
              [-17.229220748078777, -11.489031182674008],
              [-17.231705095343774, -11.48957244858365],
              [-17.233461816705507, -11.492221633858698],
              [-17.233760129510532, -11.494327610100457],
              [-17.235295913833152, -11.494972322221042],
              [-17.23642683105155, -11.494692305951219],
              [-17.23878767188732, -11.494910870920192],
              [-17.242254636634772, -11.493527513819933],
              [-17.24378059156487, -11.493857382612543],
              [-17.244447350140575, -11.494661539744945],
              [-17.244434352111675, -11.496484873472017],
              [-17.24279923170783, -11.498224905144907],
              [-17.243331331977995, -11.498738545304962],
              [-17.2448881451536, -11.497588330727055],
              [-17.246418486400643, -11.497371802723958],
              [-17.24629397611642, -11.496425438537496],
              [-17.247857170815745, -11.495959557892188],
              [-17.248942467480006, -11.49668183795469],
              [-17.24984020945822, -11.495075966506805],
              [-17.251616912716422, -11.495125316301896],
              [-17.253686383298483, -11.493665603744924],
              [-17.254706937139183, -11.493903402375686],
              [-17.257989624052392, -11.493563486383135],
              [-17.25958161668687, -11.495061829575716],
              [-17.261626288413073, -11.494974464220553],
              [-17.263952275275926, -11.497092174022637],
              [-17.261669577431523, -11.498544222864204],
              [-17.259030715495925, -11.49779744419693],
              [-17.25769452525109, -11.498587919517412],
              [-17.257727635444986, -11.501539343765916],
              [-17.26151823704484, -11.502790247881336],
              [-17.26345443248867, -11.502907284810673],
              [-17.26477078211841, -11.504002830041067],
              [-17.26686370909178, -11.502981672732343],
              [-17.268566872077255, -11.504172199946098],
              [-17.274365853557683, -11.507684243667917],
              [-17.27821278191405, -11.51050526885886],
              [-17.279319738532713, -11.512354649491025],
              [-17.283081798662256, -11.514285782794536],
              [-17.282466359165696, -11.515019402341192],
              [-17.28541660298143, -11.516319426050384],
              [-17.285946389607535, -11.518635066967462],
              [-17.28721930144118, -11.518047349624137],
              [-17.289147653075673, -11.518067184795035],
              [-17.29031402400049, -11.520080017143476],
              [-17.288337986424356, -11.520088815106638],
              [-17.284242305745092, -11.52170802075927],
              [-17.282708539146327, -11.523443657543444],
              [-17.281269508924577, -11.526028773073511],
              [-17.279725119076044, -11.525488952876744],
              [-17.27929680583883, -11.526991495679656],
              [-17.277756499199757, -11.527430876746385],
              [-17.27651177619156, -11.525986651043134],
              [-17.27414493817711, -11.525805916681758],
              [-17.27270848612478, -11.524768702630388],
              [-17.2719818906884, -11.523234979644934],
              [-17.27321244547186, -11.521767786350134],
              [-17.27315524091754, -11.520768907577441],
              [-17.27415819999269, -11.51927047764164],
              [-17.273305148102068, -11.517722146317166],
              [-17.273155342221735, -11.515898568515762],
              [-17.272504560573864, -11.515288987164675],
              [-17.26940141284281, -11.514275447359282],
              [-17.26697091440073, -11.514329247946351],
              [-17.2665944713412, -11.515533658002864],
              [-17.26498052051632, -11.515684792078929],
              [-17.264933534075528, -11.517548660505481],
              [-17.263266682791766, -11.517361538681138],
              [-17.262017083674117, -11.516162838585274],
              [-17.260595437781998, -11.512872644657167],
              [-17.25964626849276, -11.51167488758578],
              [-17.260514114668975, -11.51097023437785],
              [-17.259599425293775, -11.509280011367963],
              [-17.259860389063554, -11.507888925719044],
              [-17.258469695374362, -11.506799274102287],
              [-17.256062046778666, -11.507037369742063],
              [-17.252813936218402, -11.50922635466812],
              [-17.253054470028975, -11.51123891804536],
              [-17.25160789002694, -11.512209210274374],
              [-17.251676141844325, -11.513647906175322],
              [-17.2506632556033, -11.51502450548188],
              [-17.250697064355897, -11.516955245210427],
              [-17.246905323492033, -11.519255820599675],
              [-17.24532338326126, -11.519796551091432],
              [-17.24470861935898, -11.521753742811136],
              [-17.245628146316516, -11.523198610602043],
              [-17.24707868080102, -11.524406130311307],
              [-17.249228032675997, -11.525289447049408],
              [-17.250383498134937, -11.524733621758196],
              [-17.25138810406296, -11.525388660678574],
              [-17.25300673541806, -11.525037000534603],
              [-17.260324169540656, -11.526643767912795],
              [-17.26154310701969, -11.528383133353039],
              [-17.262442085058783, -11.528361561597947],
              [-17.263421850541288, -11.526277559105326],
              [-17.265716215472917, -11.526488779377408],
              [-17.267694789122668, -11.52772793297605],
              [-17.26894570761973, -11.529856584151066],
              [-17.268346368254857, -11.530784787756861],
              [-17.266625049968155, -11.530846696972397],
              [-17.265647968038337, -11.52992034642329],
              [-17.263149820458747, -11.52996982019863],
              [-17.262085388345188, -11.53132640270463],
              [-17.26033356126764, -11.532541036178088],
              [-17.258207188646313, -11.532243066984806],
              [-17.256456312732627, -11.535293164012906],
              [-17.254728041408384, -11.535576019469964],
              [-17.25339094671361, -11.536659997707119],
              [-17.252998557145197, -11.537669862853265],
              [-17.253951800320603, -11.538916462508535],
              [-17.2537484670841, -11.540400631754885],
              [-17.252327679430987, -11.54107529245789],
              [-17.251775219069355, -11.542269138361581],
              [-17.25223949208462, -11.544263690892727],
              [-17.253150494514486, -11.544387936374815],
              [-17.2551908145131, -11.543639828172529],
              [-17.25777234582699, -11.543388097588636],
              [-17.25845009351216, -11.54463159208482],
              [-17.257059057412363, -11.5471883526543],
              [-17.255548151478422, -11.548897966329555],
              [-17.258052277573327, -11.551662121085855],
              [-17.260666508787068, -11.550893396003154],
              [-17.26293766656532, -11.552648299716358],
              [-17.263654642467912, -11.55254292027026],
              [-17.26627632209533, -11.5536748884175],
              [-17.2693856207486, -11.55255700220825],
              [-17.271140516369677, -11.552476374712025],
              [-17.272943447456168, -11.551300063298822],
              [-17.274256320845154, -11.549312566248675],
              [-17.27576951067422, -11.548239123819963],
              [-17.27738749520998, -11.548242444423538],
              [-17.27652251519488, -11.551312362472618],
              [-17.27306502583453, -11.554300522256366],
              [-17.27471385092305, -11.554268988636391],
              [-17.27678496855264, -11.552299900609782],
              [-17.27746280935086, -11.552361753210631],
              [-17.27885225902091, -11.550737401319763],
              [-17.28074168510441, -11.55058879564867],
              [-17.279409153176033, -11.55294511596839],
              [-17.279333808199443, -11.553856657552608],
              [-17.27770860085304, -11.5556973591934],
              [-17.27731279147487, -11.557881900313621],
              [-17.27643381062209, -11.558146955044062],
              [-17.27657164073167, -11.559824638072369],
              [-17.275806296436397, -11.561631196900818],
              [-17.273355005758255, -11.563307740069826],
              [-17.27137391048373, -11.562949573644893],
              [-17.27001279251182, -11.563741859416359],
              [-17.269652774922747, -11.56575257275158],
              [-17.26881886429995, -11.56687027997514],
              [-17.267172877741057, -11.566632728968537],
              [-17.265767197866044, -11.567795468567791],
              [-17.26449603529838, -11.569681986630215],
              [-17.2655427099611, -11.571417676752647],
              [-17.271451060558356, -11.571802075930826],
              [-17.271905814209823, -11.572158095037699],
              [-17.275475112241686, -11.57266019298358],
              [-17.275754267301615, -11.572100151489618],
              [-17.2783211924042, -11.570454375508035],
              [-17.279378211683742, -11.57022455444657],
              [-17.279988914318366, -11.56713488654997],
              [-17.28379040359661, -11.564542757511413],
              [-17.28529813085704, -11.562491064557278],
              [-17.28628142951699, -11.561973097167735],
              [-17.287606459471665, -11.562872223056473],
              [-17.28677834978733, -11.566192151555528],
              [-17.286412564839168, -11.569353210067346],
              [-17.287794646100327, -11.571251190298264],
              [-17.28776728407173, -11.574874833305673],
              [-17.285499000615324, -11.577720401828019],
              [-17.283992715203087, -11.578572969299351],
              [-17.28331357149475, -11.583398438734141],
              [-17.283085351268667, -11.587013471244951],
              [-17.283994738759255, -11.588336774593332],
              [-17.28517735997391, -11.589026575978957],
              [-17.28822923637018, -11.588089201625136],
              [-17.287925740346978, -11.584547268440565],
              [-17.290854575638576, -11.583106669013745],
              [-17.292845235454354, -11.583382912372727],
              [-17.293638509934834, -11.584220199267067],
              [-17.294571437219844, -11.583288173354305],
              [-17.292750084637493, -11.58115267684423],
              [-17.293561532953373, -11.579313369207195],
              [-17.29505937735415, -11.57713999185663],
              [-17.29760996289176, -11.574076411589948],
              [-17.29944944110234, -11.573212977431623],
              [-17.301045207004154, -11.57294991164258],
              [-17.301914647986976, -11.571046330149597],
              [-17.303101831423575, -11.570267497704016],
              [-17.303819496825017, -11.567457671443478],
              [-17.305518418895875, -11.566171454496944],
              [-17.306353766737853, -11.56264623112573],
              [-17.305483785697444, -11.560585602941165],
              [-17.30609883777568, -11.559240126953778],
              [-17.305373819377458, -11.556994829383617],
              [-17.306926240798543, -11.557321182128762],
              [-17.307811183101215, -11.55602198479765],
              [-17.30774362869214, -11.553746619190267],
              [-17.30949961729868, -11.553615866982694],
              [-17.31214111762597, -11.550852353485707],
              [-17.31440909776038, -11.550635801046434],
              [-17.314709322506776, -11.552765722355657],
              [-17.313641021882173, -11.554685229431062],
              [-17.311910865617133, -11.555555266714205],
              [-17.311581279624416, -11.557024987916218],
              [-17.312250094817976, -11.55846541134777],
              [-17.312013927581283, -11.559854322682057],
              [-17.31076109760147, -11.56044222368986],
              [-17.310135203309663, -11.561959640437818],
              [-17.310333621316943, -11.563461448641235],
              [-17.309548564397783, -11.56625532166043],
              [-17.311000757900494, -11.565489055145747],
              [-17.312287899738, -11.566537849546743],
              [-17.311456030762045, -11.567680075898345],
              [-17.311122842518056, -11.570324676868843],
              [-17.31016258464239, -11.574255415135829],
              [-17.30883888823826, -11.576328372188664],
              [-17.30862797746384, -11.578439881321527],
              [-17.30926753830372, -11.579642148495685],
              [-17.307992400830834, -11.583868686488092],
              [-17.308095356002998, -11.585426700985165],
              [-17.309262408342377, -11.58628734072709],
              [-17.31001506303508, -11.58820894205651],
              [-17.311073571854127, -11.589520332291455],
              [-17.311706551183274, -11.588412324966606],
              [-17.313832759787708, -11.588691856652487],
              [-17.314179233000093, -11.587122815790163],
              [-17.313094850256423, -11.585495092455242],
              [-17.31369408139026, -11.584567071225988],
              [-17.317018087498344, -11.583302561110857],
              [-17.317697816703134, -11.58244149885158],
              [-17.32064516796114, -11.581769324993672],
              [-17.32207064835273, -11.580947705005181],
              [-17.323765290683113, -11.584215985017702],
              [-17.325021876419544, -11.585095785184564],
              [-17.325984115852975, -11.584726599588018],
              [-17.325567869943423, -11.583315679989406],
              [-17.32372012997356, -11.580622183900202],
              [-17.324308658467547, -11.579866365471517],
              [-17.32615948654929, -11.580161460521168],
              [-17.3293543206361, -11.57976346859875],
              [-17.327493346933245, -11.578734949256988],
              [-17.328118455236822, -11.577511216410803],
              [-17.33139519023465, -11.577498616088693],
              [-17.332936577874285, -11.576667520160044],
              [-17.336379281869103, -11.573803202470273],
              [-17.337947407027215, -11.574414130829691],
              [-17.338526844157226, -11.575983520400474],
              [-17.33792873300574, -11.577841451907489],
              [-17.335312579942286, -11.578585329788606],
              [-17.335171711672427, -11.579306107360129],
              [-17.337322122199147, -11.580507339737297],
              [-17.335580965156147, -11.583678488979398],
              [-17.333378538145475, -11.584585767714076],
              [-17.33108717989828, -11.581364425240318],
              [-17.330150555537422, -11.581536032674306],
              [-17.327436841450346, -11.584441045431305],
              [-17.327102268778788, -11.58615587646496],
              [-17.328723673042358, -11.587619069343768],
              [-17.328561474188405, -11.588836197469108],
              [-17.326241218437957, -11.592120694198758],
              [-17.32462671508603, -11.593177754461038],
              [-17.32461309293111, -11.594230938171599],
              [-17.325595128691862, -11.595523795241412],
              [-17.32496688034411, -11.59640544910876],
              [-17.325308571191833, -11.597822045823095],
              [-17.328168706350002, -11.6013380207347],
              [-17.329058077489368, -11.605158641598008],
              [-17.329787211508123, -11.605811142942388],
              [-17.330355000005138, -11.608458158318419],
              [-17.331732330592274, -11.608546607095262],
              [-17.33280363645638, -11.609935031589982],
              [-17.333531781481565, -11.609375789346423],
              [-17.333280372458052, -11.607928111712726],
              [-17.334837114892505, -11.60718657520163],
              [-17.335973866006658, -11.607668010212233],
              [-17.337893278270617, -11.607455576066902],
              [-17.33961923302351, -11.606667555800842],
              [-17.341549517704365, -11.60645514689082],
              [-17.343759017292893, -11.605633852025257],
              [-17.34530095938166, -11.60278094472235],
              [-17.34489105785537, -11.60205475285889],
              [-17.345384234188543, -11.600338400193628],
              [-17.344160638527825, -11.597731870895592],
              [-17.344065176434814, -11.596610923560545],
              [-17.345542040211793, -11.595054003923279],
              [-17.349127862036177, -11.594845702276348],
              [-17.351297663707868, -11.595066510194377],
              [-17.356550686706218, -11.597122479665938],
              [-17.358703338317834, -11.59892283406907],
              [-17.360459407807795, -11.604256647746576],
              [-17.36096276610457, -11.60705058992995],
              [-17.360832221110357, -11.609108181381359],
              [-17.35992356413805, -11.610831955552928],
              [-17.361622416895926, -11.612019971077371],
              [-17.364882015598564, -11.612525381698926],
              [-17.36663975622687, -11.613705524158487],
              [-17.36763666976716, -11.615486597955224],
              [-17.371333771909445, -11.615416567608245],
              [-17.37465531023873, -11.616256420008982],
              [-17.377256327521753, -11.6150246423129],
              [-17.377966469460265, -11.612977064624106],
              [-17.37792240069965, -11.611252953122335],
              [-17.378613005387614, -11.610222794540563],
              [-17.38060770619662, -11.609386620128337],
              [-17.382909068792102, -11.609392962834933],
              [-17.384816428053707, -11.608050975813732],
              [-17.387827559595884, -11.607562786690513],
              [-17.391037520072576, -11.607653139031228],
              [-17.39438195919065, -11.608588252867957],
              [-17.396848924616855, -11.610361964746016],
              [-17.39920014654218, -11.613030254627816],
              [-17.400981268214093, -11.613085890373855],
              [-17.402418289771255, -11.613829478287261],
              [-17.40231427831205, -11.615305600419642],
              [-17.404939404782443, -11.614977318121205],
              [-17.406974094186793, -11.615380282839137],
              [-17.409485249243065, -11.616406300469725],
              [-17.410553386850445, -11.617227619479438],
              [-17.413479227875268, -11.618123587510862],
              [-17.413356678457014, -11.616934152429765],
              [-17.41453754074549, -11.615470956423954],
              [-17.415576678811536, -11.615634059009407],
              [-17.41492096338893, -11.617398590559242],
              [-17.415210646259382, -11.618794914592026],
              [-17.416831269099, -11.621163453299456],
              [-17.416811823224972, -11.622755292522337],
              [-17.416160598552647, -11.623662774334985],
              [-17.41594586178986, -11.625750348094474],
              [-17.417690487583098, -11.628932160919442],
              [-17.41823750500974, -11.631076793646386],
              [-17.42001249118923, -11.632387069864217],
              [-17.42143920104853, -11.632418163341782],
              [-17.422816551180333, -11.631584331474144],
              [-17.424506801548848, -11.631318972515771],
              [-17.428054662777008, -11.633757359428948],
              [-17.429316272726577, -11.633323583554953],
              [-17.430433878628254, -11.634324971580183],
              [-17.432122499385617, -11.633949956196533],
              [-17.432138063981537, -11.636140533925229],
              [-17.43152934560043, -11.6378860660031],
              [-17.429418936900554, -11.640347894442202],
              [-17.42904066345983, -11.6421115169639],
              [-17.42734501085248, -11.64461811122979],
              [-17.42513878435227, -11.646087939006073],
              [-17.424604224148087, -11.647500022167067],
              [-17.422511456736007, -11.64852089767179],
              [-17.422375816941145, -11.650831590307595],
              [-17.424201068986363, -11.653257181622934],
              [-17.423868245432658, -11.654384378029821],
              [-17.426488683672595, -11.65887582113284],
              [-17.4296531854623, -11.660853754130915],
              [-17.433697499808783, -11.661432113541949],
              [-17.436923227268334, -11.663468407124292],
              [-17.438237150117512, -11.66363844863764],
              [-17.43936085735992, -11.66481830308052],
              [-17.441217549681625, -11.663717993532819],
              [-17.444728277935134, -11.662976168538572],
              [-17.446688431034854, -11.665392989651062],
              [-17.448365803640257, -11.66581345111005],
              [-17.44912800556637, -11.661965892529363],
              [-17.44851325649021, -11.661182211654493],
              [-17.448690845552026, -11.659382177435168],
              [-17.45092737056421, -11.659992817846094],
              [-17.452065862388828, -11.659655680440983],
              [-17.452471785085663, -11.660944969523399],
              [-17.453956843366164, -11.66171061924184],
              [-17.457114205431893, -11.659657224838238],
              [-17.458108796112853, -11.661917142766942],
              [-17.45702511689986, -11.662937012862288],
              [-17.455804583282568, -11.665124529099463],
              [-17.452248788448404, -11.667108704267527],
              [-17.451386256429636, -11.669385531569231],
              [-17.4514824926629, -11.670993213515782],
              [-17.453196926298773, -11.672322791759097],
              [-17.455087822724803, -11.674301815341613],
              [-17.459451639174574, -11.674819714360147],
              [-17.461281527700482, -11.675819079311768],
              [-17.462820409240045, -11.676013990839685],
              [-17.46557954356723, -11.674515944898118],
              [-17.466489122296437, -11.674903927222358],
              [-17.4688726876513, -11.673718321372563],
              [-17.472742543980676, -11.673259211686064],
              [-17.474553723157864, -11.675603786533786],
              [-17.47454898410635, -11.67708676556342],
              [-17.472972018266738, -11.678236624314128],
              [-17.47337818252627, -11.681267920195582],
              [-17.472871752412622, -11.6835201698613],
              [-17.47196442207416, -11.684561445999545],
              [-17.470331758809632, -11.685236175872515],
              [-17.46968445551898, -11.684495472880721],
              [-17.46731770926068, -11.684246134208333],
              [-17.465123416363678, -11.683007060392468],
              [-17.46533150862965, -11.684570132817523],
              [-17.467381964802787, -11.68533748852098],
              [-17.472209087259504, -11.686167355258856],
              [-17.472937755621945, -11.684645167942898],
              [-17.47409130186129, -11.68412876558699],
              [-17.476002185956656, -11.684796062270115],
              [-17.478079424808566, -11.684804450814338],
              [-17.479282206191222, -11.687572294082498],
              [-17.47858534450224, -11.688532090371144],
              [-17.4774447674648, -11.688352442084057],
              [-17.476535376935004, -11.689769481734242],
              [-17.47403332129862, -11.68854702312345],
              [-17.47226590725979, -11.693921447531771],
              [-17.471348159907247, -11.69557370043703],
              [-17.46846652336834, -11.697525454745003],
              [-17.466141117586833, -11.697439393414053],
              [-17.464811104519708, -11.698445469812995],
              [-17.465141597203132, -11.69948528325545],
              [-17.466582447420038, -11.700700551985918],
              [-17.46660543952859, -11.702967231917688],
              [-17.465799232337552, -11.703583499823868],
              [-17.466999485576995, -11.704965877822175],
              [-17.46678614450528, -11.706668109982324],
              [-17.468017245705138, -11.708239536019649],
              [-17.46784033526044, -11.709355652091446],
              [-17.471295748262, -11.708712741212677],
              [-17.472595001915636, -11.709318514052084],
              [-17.474888285642685, -11.709141776633679],
              [-17.476245506451164, -11.709420498005164],
              [-17.47796878221519, -11.710640520221354],
              [-17.480078578598892, -11.712695740399738],
              [-17.482051400845716, -11.713568483131162],
              [-17.484312300227455, -11.712461208556395],
              [-17.48477674382156, -11.70988177310984],
              [-17.486013798730568, -11.707643874840855],
              [-17.485761534654557, -11.70620973785311],
              [-17.487002715189618, -11.704155172562269],
              [-17.48871559814431, -11.702547500439687],
              [-17.49099137960985, -11.701322400090952],
              [-17.492045467460557, -11.70193238908353],
              [-17.493460492700272, -11.701428698721028],
              [-17.49629903145763, -11.701056989505993],
              [-17.49918163798173, -11.70125642571642],
              [-17.499486822512516, -11.700072686838674],
              [-17.501142680516416, -11.69890281521519],
              [-17.503296028125646, -11.698201701420187],
              [-17.504958306462093, -11.698295634657306],
              [-17.50483901031248, -11.696968827125566],
              [-17.50649847471048, -11.695857609595482],
              [-17.507281885916424, -11.694473530417238],
              [-17.509217102501847, -11.693013677675484],
              [-17.511439125833043, -11.690610122386872],
              [-17.51174755208462, -11.688109441447748],
              [-17.515617612839808, -11.685896846116465],
              [-17.519023666024246, -11.685923885979049],
              [-17.52252486238224, -11.68743515713768],
              [-17.52508566241034, -11.689680588946102],
              [-17.52646066820936, -11.691961068829599],
              [-17.526186203825418, -11.693337382068176],
              [-17.526939345989526, -11.696115981733206],
              [-17.525518321379142, -11.699916591641612],
              [-17.525948498814653, -11.701192861135477],
              [-17.528168848601585, -11.70497796670715],
              [-17.529110980808042, -11.707118143308339],
              [-17.530096498756485, -11.7108447840366],
              [-17.530287427760744, -11.714579815969177],
              [-17.5296891946374, -11.716718064963564],
              [-17.528316852396067, -11.718725971672107],
              [-17.525655217554856, -11.721387952292254],
              [-17.522861019427115, -11.720702867119252],
              [-17.521005777415038, -11.720652865944196],
              [-17.52034273046219, -11.722025839966554],
              [-17.52076756513991, -11.723851912221956],
              [-17.520141865591132, -11.724458444515534],
              [-17.521766073574668, -11.729004356505385],
              [-17.52319655774075, -11.730550267860522],
              [-17.52684587401383, -11.730897684220839],
              [-17.527689590951464, -11.731477047752207],
              [-17.529634131490486, -11.731302245855622],
              [-17.53190812872269, -11.731882281165328],
              [-17.535365545490667, -11.733470063362452],
              [-17.538223739431416, -11.733955597742083],
              [-17.539526003715924, -11.735394228611248],
              [-17.541611017032345, -11.73488824980739],
              [-17.543959774133636, -11.736685246252529],
              [-17.54498416957691, -11.738194925642787],
              [-17.54622404557599, -11.737755217166224],
              [-17.549951951619327, -11.739316729898498],
              [-17.551606144947517, -11.738409383410907],
              [-17.554440487508916, -11.736058742515521],
              [-17.557063473008103, -11.736317913006273],
              [-17.55732424443859, -11.737667174994545],
              [-17.555302189006646, -11.739856380895658],
              [-17.555062706552743, -11.740902433836563],
              [-17.552837818788944, -11.743669804993287],
              [-17.550959791843255, -11.743646009402047],
              [-17.54808440486729, -11.745192432471015],
              [-17.54873712226662, -11.74704944501889],
              [-17.549405211081336, -11.74726611769552],
              [-17.550067643759963, -11.749244475682518],
              [-17.551112329657165, -11.74979100523978],
              [-17.550865549966375, -11.752263857117477],
              [-17.549712444210925, -11.75284368406257],
              [-17.549805839611558, -11.75420479846482],
              [-17.54932235250968, -11.756934846006791],
              [-17.548581663024894, -11.75797143977546],
              [-17.54959208533504, -11.760818301061608],
              [-17.550339840864165, -11.761325032637291],
              [-17.550482099995985, -11.764147235079419],
              [-17.550836918112758, -11.7649269118267],
              [-17.549509257181146, -11.765990219222825],
              [-17.549935773831834, -11.767864432447203],
              [-17.549211215499447, -11.769088561289736],
              [-17.550346670833033, -11.769914289618837],
              [-17.555645918274802, -11.769054147383017],
              [-17.55754033613907, -11.769114378524494],
              [-17.55941693685037, -11.768517322892398],
              [-17.56087291656525, -11.769640608239616],
              [-17.561926701312565, -11.769086543040864],
              [-17.56237433711978, -11.767562435732158],
              [-17.561970088463607, -11.766630752032066],
              [-17.56322408492969, -11.765282812922297],
              [-17.56488521103241, -11.764975572850437],
              [-17.566174284879498, -11.764108248949894],
              [-17.564944457264136, -11.763111472949033],
              [-17.565297944155933, -11.760626644242395],
              [-17.56527438996278, -11.758195866291757],
              [-17.568074562254125, -11.758076896269362],
              [-17.5687385646614, -11.759526262231546],
              [-17.57163010307186, -11.761046995283554],
              [-17.57305915327345, -11.763548980519706],
              [-17.57303193719614, -11.76493039514178],
              [-17.573976531341156, -11.766043875707014],
              [-17.57666443892894, -11.767372453391564],
              [-17.57753276507125, -11.768137544899517],
              [-17.579343392395547, -11.768372137871173],
              [-17.581518543166048, -11.766786301963624],
              [-17.583369906990317, -11.768982430488204],
              [-17.58231442142333, -11.770963333399898],
              [-17.582746068366053, -11.772003604124823],
              [-17.587606168684314, -11.772128888080022],
              [-17.5897087838956, -11.770928694307718],
              [-17.591347169688028, -11.770596664134684],
              [-17.59267584067161, -11.769593864381152],
              [-17.59424673607981, -11.769986572286873],
              [-17.594714195853147, -11.768504301879327],
              [-17.597267628123646, -11.766062593175032],
              [-17.597243727214366, -11.764550910989696],
              [-17.5988852914977, -11.762903013518995],
              [-17.601042648617526, -11.762839352420775],
              [-17.601361231366404, -11.761625136751364],
              [-17.600817273701008, -11.760356357211228],
              [-17.602603515793994, -11.75933164057984],
              [-17.605866342307593, -11.759759812399205],
              [-17.60793301465891, -11.761009744923209],
              [-17.60741810860252, -11.76310933866079],
              [-17.60776644068867, -11.764983546344757],
              [-17.606972495902365, -11.766092591144583],
              [-17.606890267016183, -11.76899920732137],
              [-17.60506792484618, -11.77341731033572],
              [-17.605055447234243, -11.775873838309595],
              [-17.60798735364319, -11.7762684735832],
              [-17.608680826023186, -11.777059418335856],
              [-17.608686757995663, -11.778660569804895],
              [-17.607790875543603, -11.780662123965149],
              [-17.60893791465819, -11.78380952736369],
              [-17.608114124053888, -11.785985515194103],
              [-17.608138821328815, -11.787477409885273],
              [-17.607515674291726, -11.790372085261726],
              [-17.60729320993143, -11.793958496978748],
              [-17.60656553540345, -11.794243906998398],
              [-17.605943670285367, -11.797205686957339],
              [-17.60338384800891, -11.800193430693506],
              [-17.6033430473764, -11.801897451015273],
              [-17.605457478856113, -11.805966582774161],
              [-17.60734090175661, -11.805470732441304],
              [-17.61059684303576, -11.805284727273031],
              [-17.611533618933688, -11.804530915679317],
              [-17.61316273805225, -11.80518489177417],
              [-17.615312946952944, -11.80395426384705],
              [-17.618626369775633, -11.804181980349988],
              [-17.61908860372494, -11.80258513515726],
              [-17.62133570038134, -11.802999017732043],
              [-17.620304097689317, -11.801492793004977],
              [-17.620453503700663, -11.800587059295802],
              [-17.62234880307011, -11.799121811406394],
              [-17.623113346041098, -11.797230068362223],
              [-17.625344547273443, -11.796501331737169],
              [-17.626342424935125, -11.795613136977494],
              [-17.625159728017767, -11.793585467468837],
              [-17.62841912554713, -11.792252594089172],
              [-17.62989218379692, -11.792249849679411],
              [-17.631798233390413, -11.79117899252773],
              [-17.633928531155497, -11.789485748334407],
              [-17.634479399189765, -11.788611532560214],
              [-17.637300070684216, -11.789100697550584],
              [-17.63985801724168, -11.791929170217815],
              [-17.64085946582618, -11.794466381060479],
              [-17.64020252678559, -11.795498625272206],
              [-17.64153330504609, -11.798509269910177],
              [-17.642277686574747, -11.80088697442376],
              [-17.64105441409462, -11.802810353957959],
              [-17.645867882781268, -11.801817200007362],
              [-17.64874990439315, -11.802468911976554],
              [-17.650772490001227, -11.804094545857096],
              [-17.65111158123912, -11.804852393857123],
              [-17.653762273654948, -11.805884998404677],
              [-17.655924816747543, -11.80510856959892],
              [-17.658844825724795, -11.807048684692596],
              [-17.662021240931374, -11.807495642745252],
              [-17.663577831645995, -11.808520031757029],
              [-17.66567390913292, -11.810877685659802],
              [-17.66786056822972, -11.815059558136019],
              [-17.67049025019042, -11.816640396428623],
              [-17.67426189555752, -11.82066845681392],
              [-17.677303924780325, -11.824876243547484],
              [-17.683340995980405, -11.826489037786185],
              [-17.685202509861856, -11.828955321382574],
              [-17.686749737713868, -11.831983922183184],
              [-17.688164342860723, -11.833849694778232],
              [-17.692524283202566, -11.835387986642036],
              [-17.693292774573354, -11.837321483257899],
              [-17.694296979020613, -11.8418924102691],
              [-17.695918629522033, -11.842670977342342],
              [-17.694072599959537, -11.838373021094895],
              [-17.696369899222166, -11.83692179468945],
              [-17.69802661791608, -11.836882602215397],
              [-17.699256769037106, -11.838556732329629],
              [-17.700338831382396, -11.838141615570816],
              [-17.70268107410369, -11.838900437658856],
              [-17.70365611361963, -11.839869888947163],
              [-17.70440236368211, -11.843367225132594],
              [-17.704351354859156, -11.844923497160151],
              [-17.705749642574272, -11.846555628359866],
              [-17.705852104802464, -11.848037041569086],
              [-17.705336655010164, -11.851299044782474],
              [-17.705936541646693, -11.852586484400573],
              [-17.705098887320066, -11.853824095523477],
              [-17.70342679258835, -11.854681167371231],
              [-17.701668823872083, -11.853907922934138],
              [-17.70166467957643, -11.852650029999344],
              [-17.699824975847093, -11.852227339706856],
              [-17.69880266701002, -11.853034954568605],
              [-17.697682699263215, -11.852346134307142],
              [-17.696304560564876, -11.852943316382378],
              [-17.694982038473384, -11.852098152150614],
              [-17.6952193438852, -11.850803222474083],
              [-17.693110860586028, -11.849703903756492],
              [-17.688960156662812, -11.848312128566436],
              [-17.686895512746055, -11.84842357881641],
              [-17.68475581891218, -11.846962192119317],
              [-17.681818054532833, -11.846707966468099],
              [-17.679909448693437, -11.845169150739077],
              [-17.676342424430523, -11.84348798879641],
              [-17.672731715324723, -11.843814513007153],
              [-17.6722795739872, -11.843329664701066],
              [-17.668775876100693, -11.84156861646285],
              [-17.665513262757244, -11.843709794727893],
              [-17.664569003559066, -11.843631971547648],
              [-17.663705518435986, -11.845183145830875],
              [-17.664912474417303, -11.846332675675562],
              [-17.665875645789693, -11.84568205041454],
              [-17.667271795307904, -11.847089426554014],
              [-17.66669818842969, -11.84984438093387],
              [-17.663785420595662, -11.851180160219041],
              [-17.66196456070116, -11.852323405989397],
              [-17.663061197035923, -11.854139295675004],
              [-17.662874138604444, -11.856440894520873],
              [-17.66402817920772, -11.858586614931147],
              [-17.664911483658866, -11.861315641810563],
              [-17.664613004662954, -11.862385832557175],
              [-17.66609439321068, -11.864874310838214],
              [-17.666739229143435, -11.86719321330719],
              [-17.668271166011642, -11.867316927948568],
              [-17.670433334024093, -11.868103662784295],
              [-17.669411032884202, -11.869604468875156],
              [-17.670567974302518, -11.869954610543573],
              [-17.67445316867338, -11.868073649044916],
              [-17.675823436958673, -11.868688295882666],
              [-17.677532696978943, -11.870572375189981],
              [-17.677727808402622, -11.874034865165003],
              [-17.67941031837807, -11.875168920739616],
              [-17.67948423983886, -11.87655877004201],
              [-17.676816336064856, -11.879194990449605],
              [-17.676494119978614, -11.881439765823297],
              [-17.675997702818048, -11.882009989557],
              [-17.675655977461716, -11.884344016337085],
              [-17.673596681795093, -11.885234453437619],
              [-17.67195837128448, -11.885335909615536],
              [-17.671088592181814, -11.887400913433153],
              [-17.66933259177853, -11.888612274300646],
              [-17.668144890562825, -11.888122219391573],
              [-17.66551947666178, -11.888942537056773],
              [-17.663782747230034, -11.888825076826599],
              [-17.664419943432414, -11.890285584885742],
              [-17.66655078138296, -11.891965846865984],
              [-17.74589333739313, -11.888997877547672],
              [-17.74484413723321, -11.864211034264443],
              [-17.729937838764954, -11.864806363040797],
              [-17.729146246786094, -11.844972606783427],
              [-17.719083525199412, -11.845365171790302],
              [-17.718490356186628, -11.830488299234407],
              [-17.703666463404662, -11.831051496900562],
              [-17.703480461634566, -11.826092156467178],
              [-17.705807801383035, -11.826004764351323],
              [-17.705616884510473, -11.821045114166417],
              [-17.695554258279163, -11.821419579120526],
              [-17.694601064273506, -11.79661945251542],
              [-17.684609972177277, -11.796983415850205],
              [-17.684074151483568, -11.782100776769989],
              [-17.674011707740327, -11.782459097098489],
              [-17.673833186429285, -11.777498048979165],
              [-17.66880209758079, -11.777673531663801],
              [-17.66844373171752, -11.767751742710171],
              [-17.638400695871727, -11.76876327752239],
              [-17.638565996967504, -11.773728813675822],
              [-17.623601376583704, -11.774202158819808],
              [-17.623293139950334, -11.764277820441405],
              [-17.618261551305988, -11.764434181587797],
              [-17.618107320300243, -11.759471804851819],
              [-17.61307567199562, -11.759626520448823],
              [-17.612763545895522, -11.749675330152536],
              [-17.602704416782526, -11.75000444094037],
              [-17.60255052435534, -11.745041290705233],
              [-17.592689357165487, -11.745330901114766],
              [-17.593114963828572, -11.760219923602554],
              [-17.588083008145656, -11.760364731104774],
              [-17.587941205120316, -11.755401870883874],
              [-17.582909372185874, -11.755544682984013],
              [-17.58276755931436, -11.750581683851776],
              [-17.577735841502847, -11.750722155538933],
              [-17.577594022094548, -11.745759016818525],
              [-17.56773236378782, -11.746018898516098],
              [-17.567602705623674, -11.74106560516589],
              [-17.57242060934502, -11.74093421101517],
              [-17.572278794994695, -11.735971132620445],
              [-17.58234226768127, -11.735691478527828],
              [-17.581916941355505, -11.72080033384643],
              [-17.55702011149849, -11.72147591530415],
              [-17.55676017440036, -11.711548208773783],
              [-17.552795001232035, -11.71165155864018],
              [-17.552391070584385, -11.696757422843115],
              [-17.542364844826455, -11.697011142278614],
              [-17.541875046030146, -11.677151636667348],
              [-17.511769176500465, -11.67787082800128],
              [-17.51154959258221, -11.66793866405384],
              [-17.496453144024017, -11.668272752415945],
              [-17.496124257471024, -11.653373835403658],
              [-17.476140477497488, -11.653787901455415],
              [-17.475063185300407, -11.598795073809413],
              [-17.465342494919216, -11.5989852423131],
              [-17.4649612459143, -11.579111906016701],
              [-17.475022714061364, -11.578914900287323],
              [-17.474452004104165, -11.549101168491095],
              [-17.454327247359632, -11.549486502405873],
              [-17.454041517266454, -11.53457773028949],
              [-17.42401326564611, -11.53509257336016],
              [-17.42384762941811, -11.525152328263228],
              [-17.413968351951805, -11.525305754975063],
              [-17.41382726147693, -11.515364962629464],
              [-17.388878923680778, -11.515717336809896],
              [-17.388820687336818, -11.510746767897684],
              [-17.36366450039112, -11.511051379224396],
              [-17.363548083708608, -11.501109194523965],
              [-17.333605117064902, -11.501405527136628],
              [-17.333513317139, -11.491462934440708],
              [-17.313658807749576, -11.49161957925594],
              [-17.3135925446544, -11.481676281958409],
              [-17.30758058189327, -11.481717656102624],
              [-17.307531751294487, -11.47177373672964],
              [-17.292441245774114, -11.471864757832293],
              [-17.292368166459877, -11.456948128260441],
              [-17.28230743528467, -11.456998253513184],
              [-17.281997040133017, -11.392348701612107]
            ]
          ],
          [
            [
              [-17.762334212174473, -12.27979560369012],
              [-17.761926942756084, -12.277855497092967],
              [-17.760276779786548, -12.278376967519572],
              [-17.759646460821653, -12.279949751793398],
              [-17.757288872036497, -12.28022651319245],
              [-17.7570333626226, -12.27746110649016],
              [-17.75598662894076, -12.27686592818165],
              [-17.752995699502222, -12.277531250021172],
              [-17.75177311270885, -12.277170649854169],
              [-17.75169865299521, -12.274262218985472],
              [-17.754789908732683, -12.272683541422921],
              [-17.757572939576022, -12.268206285900396],
              [-17.759021148441718, -12.2673295511099],
              [-17.757619220785447, -12.26379463476685],
              [-17.75588010827881, -12.264364492486951],
              [-17.755435363266113, -12.265927749533398],
              [-17.751481493877783, -12.269040819497121],
              [-17.747112368070493, -12.263258218147548],
              [-17.747393329146895, -12.262201772416661],
              [-17.748565543384636, -12.261382949820094],
              [-17.748974159961175, -12.260048916133954],
              [-17.748244003320185, -12.259214378968062],
              [-17.746475231367082, -12.259056881107291],
              [-17.745428950882538, -12.259552516405162],
              [-17.744181121841752, -12.261919132268359],
              [-17.743711311784157, -12.265164423912038],
              [-17.741808354608576, -12.266284440026077],
              [-17.741541449129674, -12.267704144658312],
              [-17.740305162431714, -12.26925236190264],
              [-17.739953833560655, -12.275450972358602],
              [-17.739412193325098, -12.276973031877391],
              [-17.748246650095176, -12.279493938205622],
              [-17.74875925129518, -12.280656729071945],
              [-17.747106938277327, -12.282269125269291],
              [-17.74745266142548, -12.28389394692802],
              [-17.74903061423345, -12.284969831662993],
              [-17.749157160849855, -12.28578421085787],
              [-17.74772772762137, -12.289437042592626],
              [-17.747231927024927, -12.294329364849522],
              [-17.74949043650462, -12.294969250553986],
              [-17.75179255846233, -12.291052542138813],
              [-17.754043162404795, -12.289278104684948],
              [-17.753118834448767, -12.287175149564387],
              [-17.753628239664387, -12.286016794353909],
              [-17.75631231465905, -12.284634808177026],
              [-17.75801161194134, -12.284157155311306],
              [-17.75892559798145, -12.284894248121038],
              [-17.760151476704838, -12.284207454600097],
              [-17.761160969808543, -12.281708803090245],
              [-17.762334212174473, -12.27979560369012]
            ]
          ],
          [
            [
              [-17.771206569763947, -12.234676743743165],
              [-17.77140247578812, -12.231719861843445],
              [-17.769977501151896, -12.23087187195442],
              [-17.77060827701863, -12.227263047680072],
              [-17.771288228301692, -12.225874488071012],
              [-17.770858196119626, -12.224486877399793],
              [-17.768798699426327, -12.22284928779858],
              [-17.76828186727092, -12.220513350101346],
              [-17.769297820194932, -12.218341580289042],
              [-17.768224047122597, -12.217026303109227],
              [-17.768344353759506, -12.215526052467114],
              [-17.766863504083048, -12.214409133596778],
              [-17.764468629440653, -12.215685033391603],
              [-17.76561665336691, -12.216589545378605],
              [-17.765937449960894, -12.220836237428331],
              [-17.761134990352573, -12.225338366074824],
              [-17.758985801973754, -12.2259242630418],
              [-17.76018246753613, -12.226873177878339],
              [-17.76316186843324, -12.232738506241931],
              [-17.763187027732954, -12.234415989863543],
              [-17.762609620386957, -12.236072716399528],
              [-17.76268097241966, -12.237748623487661],
              [-17.7633936631568, -12.240351449790726],
              [-17.764526550748496, -12.240850020262643],
              [-17.766119484847415, -12.24019495465563],
              [-17.767516031066876, -12.240364689553749],
              [-17.768120289416526, -12.239341247306234],
              [-17.770254683473883, -12.239435116030535],
              [-17.77114384276307, -12.238581467470537],
              [-17.771206569763947, -12.234676743743165]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -153.7990148934779, "lat": 57.67906318723013 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02150"],
        "coty_name": ["Kodiak Island"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Kodiak Island Borough"],
        "coty_fp_code": "150",
        "coty_gnis_code": "01419974"
      },
      "bbox": [
        -17.77140247578812, -12.382553293126191, -16.819405279638893,
        -11.278321792282203
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-12.692288692004588, -11.468424040349866],
              [-12.692170245357431, -11.468441560227525],
              [-12.669423926621187, -11.450404125504683],
              [-12.63692354705123, -11.480504913865552],
              [-12.62761704247958, -11.512345992775954],
              [-12.62506856367422, -11.511407699749167],
              [-12.624504810731388, -11.51290311874915],
              [-12.62854182483081, -11.54579654009191],
              [-12.634149001047229, -11.55375493566591],
              [-12.63438138036942, -11.567848306576307],
              [-12.636395395435846, -11.567308596775195],
              [-12.642376836301061, -11.564295476187638],
              [-12.64452163850094, -11.563712794784067],
              [-12.645440283487805, -11.561954513823682],
              [-12.647443219909416, -11.559497466067887],
              [-12.649393950674874, -11.558892232663455],
              [-12.650492085400499, -11.557939657333696],
              [-12.653664879376366, -11.557917329176469],
              [-12.655405161106136, -11.55825856805811],
              [-12.65632956460025, -11.557867587356208],
              [-12.65980689643104, -11.554956164265342],
              [-12.662383563380452, -11.553324753341254],
              [-12.664274831938286, -11.551719310064602],
              [-12.666921778408298, -11.550905264271625],
              [-12.668713538565944, -11.549435278848414],
              [-12.671359258877832, -11.548452003185572],
              [-12.673642346263673, -11.545708870072025],
              [-12.673109579922318, -11.5440501725146],
              [-12.673361655793988, -11.54125987035436],
              [-12.674275834151358, -11.538651381528517],
              [-12.678380609091052, -11.535545486262919],
              [-12.680571661875254, -11.532995055289051],
              [-12.6813102644267, -11.532966503784486],
              [-12.68350800235717, -11.535926442220168],
              [-12.68451801010947, -11.536084599946026],
              [-12.687179180742906, -11.533483036356998],
              [-12.689423073684905, -11.532063586461776],
              [-12.691549685321837, -11.531612512563493],
              [-12.694756946224238, -11.530084087249532],
              [-12.695240533591802, -11.52830281065807],
              [-12.696325207234793, -11.527947236478994],
              [-12.697921716187885, -11.528522833713929],
              [-12.699490905225856, -11.527268431414985],
              [-12.699454409920254, -11.52492763864692],
              [-12.700227621665377, -11.522471214475663],
              [-12.69805728363412, -11.51920392212883],
              [-12.695839737996666, -11.516753808549117],
              [-12.69433969375565, -11.51600222743237],
              [-12.691587283811858, -11.515975538783085],
              [-12.690088317816022, -11.514392764310454],
              [-12.691820058837916, -11.512634308690863],
              [-12.692389397053185, -11.510839648675736],
              [-12.691755791827235, -11.50901301871694],
              [-12.688925597557315, -11.503669843926662],
              [-12.687874159319193, -11.502901485718235],
              [-12.686653615164479, -11.503061854881741],
              [-12.684053195076498, -11.504594415283378],
              [-12.681426550313137, -11.505271444395637],
              [-12.680473744736464, -11.503625069923991],
              [-12.67896804881826, -11.502493789151067],
              [-12.6792398312785, -11.500685221962485],
              [-12.678174683103284, -11.499565088045953],
              [-12.675839138794341, -11.498380177263792],
              [-12.67612592481991, -11.49686328330736],
              [-12.677605926356257, -11.496976522403587],
              [-12.678886083738726, -11.495979915403026],
              [-12.680162853786337, -11.495853457602749],
              [-12.683125965790783, -11.494358225402529],
              [-12.68383691124087, -11.49349639332153],
              [-12.6847515876129, -11.490721793727278],
              [-12.686034437196966, -11.490024219623564],
              [-12.689657457106025, -11.489631518658296],
              [-12.692147324680429, -11.488647018708688],
              [-12.694023349894287, -11.487117840319273],
              [-12.695608488328991, -11.484443078340849],
              [-12.695786197247463, -11.483129455264372],
              [-12.69512233922648, -11.480253380720685],
              [-12.696710105973521, -11.476268620973519],
              [-12.696124862515791, -11.474045292460223],
              [-12.694069823725114, -11.468994186319632],
              [-12.692288692004588, -11.468424040349866]
            ]
          ],
          [
            [
              [-12.82775979774005, -11.899409920749768],
              [-12.824941787008502, -11.897407308000881],
              [-12.82505061368562, -11.894282268533045],
              [-12.823235255656508, -11.890893656264437],
              [-12.824757961205794, -11.888896622652823],
              [-12.823769010879523, -11.884754669409098],
              [-12.822470785403432, -11.884012981378248],
              [-12.821897053729788, -11.882235895471972],
              [-12.822716677979331, -11.879949698826133],
              [-12.823671651810077, -11.879536980629023],
              [-12.825277361696733, -11.879841196135208],
              [-12.826071720951843, -11.881002310192047],
              [-12.827051097752566, -11.880943303999643],
              [-12.827665151953894, -11.879228675595321],
              [-12.827095485540115, -11.874344825939518],
              [-12.827697526045347, -11.870554949174513],
              [-12.826027009982688, -11.868748225387193],
              [-12.824183554755743, -11.867424131500012],
              [-12.820237913582233, -11.86774543724261],
              [-12.817404278036367, -11.869880171020215],
              [-12.816445134768227, -11.868760348059187],
              [-12.817238443373615, -11.865430637856521],
              [-12.816357158007426, -11.862413359446926],
              [-12.81777494252803, -11.861273389669176],
              [-12.818002542991604, -11.859378629358003],
              [-12.82234892541726, -11.858358734833912],
              [-12.823595788681915, -11.85839319422993],
              [-12.825550217070674, -11.85926227996822],
              [-12.826973941428179, -11.857680744198715],
              [-12.827281518185783, -11.855420024687154],
              [-12.828857585981776, -11.855517858626596],
              [-12.829733563881726, -11.856163708410332],
              [-12.83174198224291, -11.856459049289228],
              [-12.832962515689722, -11.855300825142741],
              [-12.83491948970336, -11.855036407321911],
              [-12.836245709684734, -11.852879560167366],
              [-12.834986808271676, -11.85175814749066],
              [-12.833822546075076, -11.853181570927958],
              [-12.832733744246962, -11.852709048036553],
              [-12.831086391734996, -11.850566713776645],
              [-12.831985836708526, -11.849742391279099],
              [-12.832216848774642, -11.847555158209188],
              [-12.835792753993882, -11.844596472053212],
              [-12.837400137858971, -11.842637014230714],
              [-12.83920043488538, -11.842664092522973],
              [-12.838979040130091, -11.839633917147852],
              [-12.840336613549114, -11.838229444354464],
              [-12.841157907397436, -11.835656493140728],
              [-12.842760675071302, -11.834828787458124],
              [-12.842245620103727, -11.832339366729878],
              [-12.842911156321954, -11.831042627138693],
              [-12.841777537507864, -11.827898704065776],
              [-12.842576511299947, -11.824828319337419],
              [-12.843378537739223, -11.823431681197558],
              [-12.843413142815752, -11.822214225476701],
              [-12.84069013669962, -11.821967482790829],
              [-12.838507166144247, -11.822594151667376],
              [-12.838125350822958, -11.822118558482686],
              [-12.835759640345227, -11.82199368078429],
              [-12.835295174790808, -11.820210520558808],
              [-12.838796411582628, -11.818710096449765],
              [-12.841206009237396, -11.817030730303484],
              [-12.83920366757844, -11.816735716735687],
              [-12.836968210836195, -11.816950128577934],
              [-12.833377801571439, -11.818419364032382],
              [-12.83148639185828, -11.819489698666905],
              [-12.831658277880448, -11.820828037087157],
              [-12.829369305868648, -11.821466300375526],
              [-12.822460682840994, -11.82139730142219],
              [-12.820070675260341, -11.821753729171956],
              [-12.819476491294093, -11.823123845807372],
              [-12.82082547318489, -11.824820546017198],
              [-12.815149259771545, -11.827735774765655],
              [-12.815548797330232, -11.828858909676237],
              [-12.81265708240841, -11.830322586886385],
              [-12.809359301381857, -11.830956405060652],
              [-12.807701960410906, -11.829693370377116],
              [-12.806288643211799, -11.829845093884071],
              [-12.803854840518841, -11.829199567395296],
              [-12.79918168354763, -11.830291506225487],
              [-12.79666768866717, -11.832230294095679],
              [-12.793653570207452, -11.835130266536964],
              [-12.791489967675865, -11.835958030312963],
              [-12.785726665216341, -11.837262239711844],
              [-12.781357927787313, -11.838606256780656],
              [-12.781325159446677, -11.840223849101353],
              [-12.783320806055583, -11.84111502269931],
              [-12.7850392352428, -11.842353800156522],
              [-12.786138615471167, -11.842241927047908],
              [-12.787697083569816, -11.843227288578838],
              [-12.785201873107109, -11.848581442959235],
              [-12.782834421966731, -11.851216198234622],
              [-12.780587280465538, -11.855326299416111],
              [-12.780107066080094, -11.856789908719778],
              [-12.780692433147202, -11.859908882947595],
              [-12.779293604192764, -11.862932025178992],
              [-12.781469845858647, -11.865565788102463],
              [-12.780504954631894, -11.867950007091503],
              [-12.776692741800161, -11.868851567474552],
              [-12.776572726409, -11.869601183846518],
              [-12.774418198050997, -11.871919641995884],
              [-12.773408467447563, -11.874982344573462],
              [-12.77248549191523, -11.879758259130893],
              [-12.771804437045096, -11.882194556704137],
              [-12.772284139868091, -11.884637993612051],
              [-12.773694940876585, -11.887305470247876],
              [-12.772928561345932, -11.888722829531366],
              [-12.77376360088988, -11.889210550083298],
              [-12.77294350343873, -11.891055498191218],
              [-12.774850172935523, -11.893895358872205],
              [-12.778474296673126, -11.894507251097803],
              [-12.78211338666242, -11.896757285964522],
              [-12.78537010306888, -11.897685637935293],
              [-12.787465759655857, -11.897766314231138],
              [-12.789894634915818, -11.89944682795297],
              [-12.792247134089648, -11.900357685058665],
              [-12.794310920823667, -11.900525352019708],
              [-12.796657056887978, -11.899206474066638],
              [-12.7991132313704, -11.896738228511493],
              [-12.7990957294769, -11.894258940368474],
              [-12.800645945355313, -11.890935733461017],
              [-12.801253884643195, -11.890650692065988],
              [-12.803543310470085, -11.887237125534497],
              [-12.806111047128345, -11.885996349591743],
              [-12.80777949660217, -11.887114461264305],
              [-12.808563483583333, -11.88886719216794],
              [-12.80727254004011, -11.89035048863314],
              [-12.805282947360658, -11.893917677081292],
              [-12.804713398985257, -11.895501785965461],
              [-12.80586609314943, -11.897777759419462],
              [-12.805746412029702, -11.8995173409657],
              [-12.806815110141063, -11.899637765972704],
              [-12.807330467869322, -11.901298713850744],
              [-12.808424797405525, -11.902614816198144],
              [-12.810103113084057, -11.903290373451002],
              [-12.811230810930041, -11.905359812200647],
              [-12.811743094553869, -11.909146725441081],
              [-12.813049145966227, -11.912415257020653],
              [-12.814023416934903, -11.91378847292992],
              [-12.815304960022196, -11.913881427987791],
              [-12.816422604324393, -11.911889966383256],
              [-12.818010107208412, -11.911692469203107],
              [-12.81686520859043, -11.908678482088694],
              [-12.817765991688011, -11.90799811676392],
              [-12.8194988295942, -11.90908674095265],
              [-12.821103817937582, -11.910675164571703],
              [-12.823051016995533, -11.910600013986887],
              [-12.823771203946535, -11.90788005379959],
              [-12.82481995489705, -11.906360349596222],
              [-12.824327040722405, -11.905054763034718],
              [-12.826952639160416, -11.902938456957656],
              [-12.826682553668439, -11.90185759664866],
              [-12.827795875320255, -11.90100358457602],
              [-12.82775979774005, -11.899409920749768]
            ]
          ],
          [
            [
              [-12.90144211404386, -11.888509405271652],
              [-12.90005182074648, -11.88703184780988],
              [-12.900046133093149, -11.886119787606425],
              [-12.89886777380735, -11.884541275960537],
              [-12.897905838882146, -11.887415569733403],
              [-12.900155550864227, -11.890093513890816],
              [-12.90144211404386, -11.888509405271652]
            ]
          ],
          [
            [
              [-12.895441893793969, -11.919169207047768],
              [-12.89496366178292, -11.917666030342318],
              [-12.893783880265099, -11.917909934621944],
              [-12.8946824124511, -11.919941450937419],
              [-12.895441893793969, -11.919169207047768]
            ]
          ],
          [
            [
              [-12.899761185040681, -11.916638064238386],
              [-12.89833672196498, -11.916165146577578],
              [-12.898475769191167, -11.918087521208719],
              [-12.899553786266322, -11.918121563702883],
              [-12.899761185040681, -11.916638064238386]
            ]
          ],
          [
            [
              [-12.938417197679463, -11.847106349404944],
              [-12.938714148021111, -11.845686374377548],
              [-12.937681513890055, -11.843918709426688],
              [-12.936976410413417, -11.844074528416442],
              [-12.936564832435803, -11.846607667785197],
              [-12.937913702039747, -11.848187578185486],
              [-12.938417197679463, -11.847106349404944]
            ]
          ],
          [
            [
              [-12.938043123760837, -11.871316996592345],
              [-12.937099122810148, -11.869925332292237],
              [-12.936176189511162, -11.870539781744775],
              [-12.93728375892755, -11.87179542215521],
              [-12.938043123760837, -11.871316996592345]
            ]
          ],
          [
            [
              [-12.96751051236407, -11.801764608255835],
              [-12.967406107519027, -11.801009226840034],
              [-12.965958772234767, -11.799756622250836],
              [-12.963994707526838, -11.800653400649107],
              [-12.962152258381824, -11.799792669618698],
              [-12.960233185682931, -11.800422197127235],
              [-12.9607087584431, -11.801774463821062],
              [-12.962775571911223, -11.803423669975869],
              [-12.96736831146739, -11.802677710841813],
              [-12.96751051236407, -11.801764608255835]
            ]
          ],
          [
            [
              [-12.975104000155026, -11.81977416947723],
              [-12.975181710647027, -11.819335889164918],
              [-12.972646100688914, -11.817880030025394],
              [-12.970088524456871, -11.817491327826367],
              [-12.968089977054928, -11.818217225328013],
              [-12.966273611822615, -11.817488856702816],
              [-12.96493413459011, -11.818899058715445],
              [-12.965883482482731, -11.819753847623222],
              [-12.968688421731692, -11.81907672148906],
              [-12.970109866910931, -11.819722189325123],
              [-12.972540497738153, -11.820190449629102],
              [-12.97316018754877, -11.82127683553941],
              [-12.975104000155026, -11.81977416947723]
            ]
          ],
          [
            [
              [-13.018115953860349, -11.797846417613915],
              [-13.015073940229586, -11.797084504913208],
              [-13.0152070415261, -11.795618475414395],
              [-13.011784629070755, -11.79509532119185],
              [-13.01009397396489, -11.795241743154364],
              [-13.009329319795892, -11.796304101182168],
              [-13.006915503392511, -11.797965325318378],
              [-13.005215530067241, -11.798352503528244],
              [-13.006227664535356, -11.799954938676912],
              [-13.008200634541614, -11.800145466827228],
              [-13.009245717598729, -11.79971157483902],
              [-13.011082955616581, -11.800222261560018],
              [-13.012321566717958, -11.79973061499557],
              [-13.014151876475697, -11.800116630994523],
              [-13.018115953860349, -11.797846417613915]
            ]
          ],
          [
            [
              [-13.057758791244552, -11.781647979413485],
              [-13.058023365639249, -11.77976511885536],
              [-13.05716023012582, -11.77932163499468],
              [-13.056355467940575, -11.781028160106692],
              [-13.057758791244552, -11.781647979413485]
            ]
          ],
          [
            [
              [-13.02790349604949, -11.990028246365233],
              [-13.028166241980935, -11.987240970625617],
              [-13.02547360111233, -11.986164629374638],
              [-13.02350143410293, -11.987966146256651],
              [-13.022810263984658, -11.989540301969283],
              [-13.023435220355907, -11.99012555328254],
              [-13.025126126491482, -11.98971775455163],
              [-13.025645565098522, -11.988475601936734],
              [-13.027154208799372, -11.988865856362192],
              [-13.02790349604949, -11.990028246365233]
            ]
          ],
          [
            [
              [-13.038266401934038, -12.014758662784022],
              [-13.035462298169529, -12.015010304991357],
              [-13.036588893333409, -12.012493598574045],
              [-13.036202471233974, -12.012147442456664],
              [-13.03383390241978, -12.013942380500028],
              [-13.031567024005545, -12.011560192261529],
              [-13.03459627195779, -12.010865291276943],
              [-13.034742861039504, -12.009164909141296],
              [-13.030878642809618, -12.008235431522147],
              [-13.02874195781765, -12.009193157247672],
              [-13.028010936393196, -12.010163333297932],
              [-13.026536591644815, -12.009981284820267],
              [-13.027384976209413, -12.00732594079665],
              [-13.02715663096568, -12.006587424857546],
              [-13.024722330463725, -12.006192541185905],
              [-13.024213663230228, -12.004944376950002],
              [-13.022928946152671, -12.004872631085336],
              [-13.021859475849366, -12.002457470113944],
              [-13.019902105327409, -12.002216189601109],
              [-13.017078137267209, -12.003934176520785],
              [-13.017971570352152, -12.005234157607807],
              [-13.019049123871495, -12.008071346810555],
              [-13.018233874070352, -12.008841513496114],
              [-13.016261247540209, -12.009309546557986],
              [-13.015185124581455, -12.007285144800152],
              [-13.015327724322836, -12.006567888943627],
              [-13.013527720307964, -12.00571223245549],
              [-13.012560633602014, -12.00618609139152],
              [-13.00908575771423, -12.009516283630326],
              [-13.007535246195815, -12.009258346841316],
              [-13.007942253016303, -12.007468385500497],
              [-13.005515421903496, -12.0081573530723],
              [-13.003261972818079, -12.008113791211269],
              [-12.999034713173936, -12.01134664518069],
              [-12.997158751893089, -12.012337783426476],
              [-12.996871425678117, -12.01347731803777],
              [-12.994169953645974, -12.01562999023571],
              [-12.993594658249494, -12.018205373503559],
              [-12.996205930898636, -12.017576842544772],
              [-12.99715978199553, -12.017739448599256],
              [-12.998174376938103, -12.019278946170552],
              [-12.999824494537265, -12.019471154840188],
              [-12.99865950266781, -12.02104048489119],
              [-12.999681811865397, -12.02174349451922],
              [-12.998933291207123, -12.023572158214293],
              [-12.995889468800371, -12.023987286824473],
              [-12.994882592472713, -12.02509065476208],
              [-12.992391125818491, -12.025512349187021],
              [-12.99100497914099, -12.027060097560671],
              [-12.99232316348717, -12.027860023522493],
              [-12.991732561707463, -12.028926520895793],
              [-12.992490275294958, -12.029889583475411],
              [-12.993777912238505, -12.029223008691892],
              [-12.995096259015964, -12.029652493726639],
              [-12.997784517582899, -12.027985214466925],
              [-13.00015732809794, -12.030657881222309],
              [-13.001133637159008, -12.029642764499801],
              [-13.003647800089714, -12.02930038217687],
              [-13.004187642791498, -12.031203340481255],
              [-13.001076546697899, -12.033746194814233],
              [-12.998628535648228, -12.032777212760244],
              [-12.998220011947401, -12.03368087116745],
              [-12.99633333535712, -12.033733409514982],
              [-12.996896122544673, -12.036756181560156],
              [-12.99586564364028, -12.03711224696593],
              [-12.99366740599712, -12.036964703594935],
              [-12.992818293472546, -12.03641656989071],
              [-12.990301942092195, -12.036905763324526],
              [-12.990006768665664, -12.038291394735067],
              [-12.988574103536184, -12.039899672776901],
              [-12.98648143719777, -12.03981045045168],
              [-12.985396913903196, -12.041656154138634],
              [-12.985639976493857, -12.04361335390817],
              [-12.98199134906376, -12.044672727940817],
              [-12.98274224800857, -12.04640069830091],
              [-12.981368928933946, -12.04775738582361],
              [-12.980215351897623, -12.04817240392664],
              [-12.979418067689453, -12.05087959916624],
              [-12.979448369795595, -12.051903486748737],
              [-12.98180136747129, -12.051978514783396],
              [-12.981998885136248, -12.053328815884377],
              [-12.981057737365227, -12.05549518521628],
              [-12.981854885961635, -12.055903700673571],
              [-12.982182032156754, -12.058434418010382],
              [-12.98363213489956, -12.058041024748954],
              [-12.985811428551756, -12.05855325687001],
              [-12.987018753855944, -12.058426690726108],
              [-12.987792321804196, -12.057120616249923],
              [-12.98896136933492, -12.056956945978804],
              [-12.990493570616987, -12.055353864271803],
              [-12.992224190643242, -12.0556204142747],
              [-12.993095470965105, -12.05395076120898],
              [-12.994558886673614, -12.052622182007546],
              [-12.994625656757698, -12.051012533460272],
              [-12.996445191996532, -12.049750604536227],
              [-12.99733863993576, -12.048311591325714],
              [-12.998430550359334, -12.047851155577789],
              [-13.0005647537923, -12.044172424319783],
              [-13.00303294577784, -12.041442546553238],
              [-13.005163497180497, -12.041788896274316],
              [-13.005858439401694, -12.040113173518458],
              [-13.010629653021352, -12.038181034368613],
              [-13.011217925758334, -12.036595012501119],
              [-13.012201254662244, -12.035778854160338],
              [-13.013905717201924, -12.03573901777323],
              [-13.017774105340862, -12.034599470914753],
              [-13.017506179176321, -12.033229983448038],
              [-13.020868739936322, -12.033208666551824],
              [-13.021778315643731, -12.03357690318833],
              [-13.023314336934414, -12.033063029118807],
              [-13.025950917073482, -12.0307842443398],
              [-13.027547284132757, -12.03046220648746],
              [-13.027905368102058, -12.028507103517947],
              [-13.029868853822174, -12.026948243434752],
              [-13.030689525364094, -12.025488617772874],
              [-13.030731111035625, -12.024097335762399],
              [-13.031506616439088, -12.022771235187571],
              [-13.031915549299773, -12.020292113394992],
              [-13.034002277312686, -12.017395089382156],
              [-13.035385574515175, -12.017176833618656],
              [-13.037453249109818, -12.015825528522054],
              [-13.038266401934038, -12.014758662784022]
            ]
          ],
          [
            [
              [-13.047404653720994, -11.999663156678698],
              [-13.046461122623242, -11.99944678051031],
              [-13.044503200012384, -12.000537441350144],
              [-13.044368848833368, -12.00160076862425],
              [-13.046131953686354, -12.002630957167636],
              [-13.046899801791891, -12.001956174904736],
              [-13.047404653720994, -11.999663156678698]
            ]
          ],
          [
            [
              [-13.0511630292329, -12.000921141710982],
              [-13.051740355750825, -11.999185322811721],
              [-13.049598412861318, -11.999874835270644],
              [-13.04803390522438, -12.00323377192949],
              [-13.04651892023642, -12.00365184544623],
              [-13.047619990154844, -12.004834056884954],
              [-13.048422943493911, -12.004572398938402],
              [-13.0511630292329, -12.000921141710982]
            ]
          ],
          [
            [
              [-13.050968608387898, -12.006860129896504],
              [-13.047843481307048, -12.006284382409417],
              [-13.047932399515924, -12.00762317387929],
              [-13.048973529723941, -12.00810063043012],
              [-13.050968608387898, -12.006860129896504]
            ]
          ],
          [
            [
              [-13.075017540998477, -11.973320999329687],
              [-13.074817023267, -11.972275619972057],
              [-13.075693477586016, -11.969663780484096],
              [-13.07516409580049, -11.969150294301436],
              [-13.071896110524627, -11.969032292176626],
              [-13.071782023580878, -11.966984695808652],
              [-13.073536287617978, -11.965342327129626],
              [-13.07186931139387, -11.962698034493663],
              [-13.070059070757612, -11.961674441005393],
              [-13.068726242684013, -11.96340307322445],
              [-13.068702319862334, -11.96496459000212],
              [-13.066083741524785, -11.969173289070493],
              [-13.065577044213457, -11.970531063409071],
              [-13.06758285445122, -11.974856394896431],
              [-13.067199591070553, -11.97689215239374],
              [-13.068019258430267, -11.978333583038705],
              [-13.067710051691487, -11.98000093393695],
              [-13.068286285601603, -11.98082407828842],
              [-13.07098032726159, -11.9799720669136],
              [-13.071756761703998, -11.978405836303493],
              [-13.070678096651285, -11.976391010305553],
              [-13.071969133781424, -11.975382944615646],
              [-13.07335534337376, -11.975435740639975],
              [-13.074661023164488, -11.974383554554652],
              [-13.075017540998477, -11.973320999329687]
            ]
          ],
          [
            [
              [-13.099900304321105, -11.947446623436296],
              [-13.097939608472764, -11.946134275148832],
              [-13.097040118763026, -11.94374252496608],
              [-13.095695769797334, -11.942382560820985],
              [-13.092817367776005, -11.940530645376036],
              [-13.09175400185185, -11.941168260342556],
              [-13.091121313194861, -11.94380338543026],
              [-13.09560760321585, -11.948323610960337],
              [-13.09854571437616, -11.949704262318544],
              [-13.099900304321105, -11.947446623436296]
            ]
          ],
          [
            [
              [-13.212745240093184, -11.65032539959848],
              [-13.211800254804595, -11.648701387155604],
              [-13.211304358016266, -11.645940024614188],
              [-13.211905673469635, -11.642202816585321],
              [-13.210927004123928, -11.64095681545668],
              [-13.212004699134004, -11.639081304860765],
              [-13.2144047476643, -11.63618856913239],
              [-13.213250517957288, -11.63424194714027],
              [-13.211589857743524, -11.636371730328753],
              [-13.210139823623416, -11.637002327625417],
              [-13.209100491542836, -11.63654542129802],
              [-13.208561569446912, -11.638079655266985],
              [-13.205211266816734, -11.637731089995905],
              [-13.20369308849673, -11.636997671066998],
              [-13.202488911736301, -11.635531046933718],
              [-13.201337542646616, -11.636352938807319],
              [-13.201093518239261, -11.63742977160399],
              [-13.199771931331417, -11.638405085401905],
              [-13.199510245200326, -11.63999199819704],
              [-13.200035479747577, -11.6408302591776],
              [-13.19795826660183, -11.643572175386094],
              [-13.196572434324843, -11.643756026871074],
              [-13.195148686335523, -11.645229645083997],
              [-13.193710867689012, -11.645839775698914],
              [-13.192275235868482, -11.647798456305855],
              [-13.192223965151568, -11.64895043826126],
              [-13.19321338898432, -11.649405044070276],
              [-13.19195952700854, -11.651497138426993],
              [-13.192316864882184, -11.65365772401327],
              [-13.193329574846084, -11.653667854991044],
              [-13.1956446216426, -11.654580582952258],
              [-13.196631085913983, -11.65381864160062],
              [-13.1982586933281, -11.653620907249255],
              [-13.202390351347459, -11.655477071534508],
              [-13.204397709319363, -11.655560327809098],
              [-13.204687983428622, -11.656300093412243],
              [-13.203369442985478, -11.658712445274038],
              [-13.205135200154574, -11.658168015895097],
              [-13.206383373366505, -11.658478670238619],
              [-13.20771723282883, -11.656860985599229],
              [-13.21047729278764, -11.654796738762888],
              [-13.211487420732182, -11.652054609186504],
              [-13.212745240093184, -11.65032539959848]
            ]
          ],
          [
            [
              [-13.209572869753613, -11.660447427197155],
              [-13.209649194864655, -11.65853187195752],
              [-13.20688311928378, -11.660978296598186],
              [-13.206202570973254, -11.66251001314246],
              [-13.207154403584749, -11.663388948153159],
              [-13.208090978931521, -11.66292116644191],
              [-13.209572869753613, -11.660447427197155]
            ]
          ],
          [
            [
              [-13.150574324608959, -11.862158999221363],
              [-13.149898529276271, -11.861876527433406],
              [-13.146605941277734, -11.864040799426155],
              [-13.146053546821042, -11.8660690993481],
              [-13.148522602043451, -11.865108046855468],
              [-13.149308824873986, -11.86346699317918],
              [-13.150574324608959, -11.862158999221363]
            ]
          ],
          [
            [
              [-13.167836301637319, -11.847869224755332],
              [-13.166722622735989, -11.846246369898653],
              [-13.165536692398518, -11.8467109500058],
              [-13.166075050840227, -11.848037821795916],
              [-13.1642618269926, -11.848480148740837],
              [-13.163643036438339, -11.84943676899003],
              [-13.162440673179807, -11.849706417511358],
              [-13.162190539892519, -11.853815998193866],
              [-13.16429536323131, -11.853570064303202],
              [-13.16506306617291, -11.851426225727225],
              [-13.166870003587372, -11.851204742525416],
              [-13.167836301637319, -11.847869224755332]
            ]
          ],
          [
            [
              [-13.174980117402333, -11.828822295642125],
              [-13.174582527644338, -11.82738584465046],
              [-13.172378401247752, -11.82734580045704],
              [-13.172726335463253, -11.83084313037464],
              [-13.174684153552452, -11.830340316585541],
              [-13.174980117402333, -11.828822295642125]
            ]
          ],
          [
            [
              [-13.149443505132963, -11.95831287978557],
              [-13.148241577457867, -11.95673057154989],
              [-13.146739216027447, -11.958341218371299],
              [-13.14893739025663, -11.958787903168444],
              [-13.149443505132963, -11.95831287978557]
            ]
          ],
          [
            [
              [-13.201210988482707, -11.828378456017651],
              [-13.199573786092488, -11.827631449914852],
              [-13.198842171513755, -11.82884575906042],
              [-13.199017359520607, -11.829898674206609],
              [-13.201210988482707, -11.828378456017651]
            ]
          ],
          [
            [
              [-13.186206389757409, -11.882835606598086],
              [-13.186498391381484, -11.880742041978774],
              [-13.185863410170496, -11.879959563793879],
              [-13.184054961381936, -11.873709065787391],
              [-13.183998451476269, -11.872526459764574],
              [-13.181383566384863, -11.872041502767381],
              [-13.178766777750461, -11.869758795466684],
              [-13.176636530035864, -11.868406230580145],
              [-13.175143994687101, -11.868274439700725],
              [-13.174406241229125, -11.867507055478189],
              [-13.173355816485776, -11.86843723811331],
              [-13.17160184238506, -11.869096167367632],
              [-13.170883495278684, -11.87051993003709],
              [-13.170209800057552, -11.87360954149247],
              [-13.170436672754684, -11.875624373721191],
              [-13.171453707530997, -11.879152313892101],
              [-13.171283756974502, -11.88177104034651],
              [-13.17156144484106, -11.882733153681976],
              [-13.173978979647028, -11.882622645500021],
              [-13.175775835551086, -11.883190046249696],
              [-13.177442127929144, -11.885659152793844],
              [-13.180246837721544, -11.88693251673148],
              [-13.181016562649408, -11.887758354093775],
              [-13.184810918192616, -11.886475881217283],
              [-13.18613772254284, -11.884853653193469],
              [-13.186206389757409, -11.882835606598086]
            ]
          ],
          [
            [
              [-13.226447418265256, -11.779492042238765],
              [-13.224656546190786, -11.779431157124204],
              [-13.222755559580937, -11.781467975574747],
              [-13.223578894382918, -11.782371172274418],
              [-13.224968071915796, -11.781645460129697],
              [-13.226447418265256, -11.779492042238765]
            ]
          ],
          [
            [
              [-13.235268555623177, -11.791026550302258],
              [-13.236275593829983, -11.789101470568509],
              [-13.233097881985593, -11.789428260707085],
              [-13.232324349262283, -11.792288226458247],
              [-13.23475244214729, -11.792330261999012],
              [-13.235268555623177, -11.791026550302258]
            ]
          ],
          [
            [
              [-13.235924948801493, -11.809888118626972],
              [-13.23549718442221, -11.808780483582895],
              [-13.234059990429593, -11.808321881387393],
              [-13.233179169289036, -11.809786279293855],
              [-13.23346664226833, -11.81089652742395],
              [-13.23495267936491, -11.812101853531876],
              [-13.235924948801493, -11.809888118626972]
            ]
          ],
          [
            [
              [-13.223206585062584, -11.853430366972159],
              [-13.22311908387191, -11.849918116938698],
              [-13.221858363129678, -11.848844841008399],
              [-13.221777165942989, -11.84789055451325],
              [-13.222966481434726, -11.846332392595166],
              [-13.224380137439097, -11.845563068333442],
              [-13.223625955479172, -11.843472161308462],
              [-13.222302403395757, -11.843160356912817],
              [-13.221631368866905, -11.844750494877621],
              [-13.220007928921643, -11.84414446841871],
              [-13.22037574262277, -11.840640239785593],
              [-13.219585295082839, -11.839134496785631],
              [-13.216990803967734, -11.838466018101075],
              [-13.21496598556965, -11.839524108661337],
              [-13.21421742433965, -11.837741181885923],
              [-13.212630005820277, -11.835355874751993],
              [-13.211580119939681, -11.83449391634725],
              [-13.206311502116318, -11.836708527294872],
              [-13.206275761582898, -11.834712894337253],
              [-13.205304121083994, -11.834213789653633],
              [-13.201953931439373, -11.836595217123465],
              [-13.200687767792736, -11.83639017236809],
              [-13.2000077793856, -11.835304440186574],
              [-13.20114354016549, -11.83440398300744],
              [-13.200151731905553, -11.833365457396],
              [-13.198269819341295, -11.835483107184517],
              [-13.196720831368498, -11.836737512444037],
              [-13.193581981918582, -11.838168460627658],
              [-13.19273487407657, -11.841340017274911],
              [-13.191715020088399, -11.842035313957942],
              [-13.19039092096507, -11.845154225226565],
              [-13.189291405124287, -11.84534023328979],
              [-13.188545374307628, -11.851356628768416],
              [-13.187020033177205, -11.852232597657009],
              [-13.186854809208612, -11.853634699126472],
              [-13.18860273555581, -11.854186258412193],
              [-13.188900151080734, -11.857189059956106],
              [-13.189686857739769, -11.859910230869557],
              [-13.189671201739072, -11.86131176469643],
              [-13.190860668463346, -11.864014756660415],
              [-13.193281392484701, -11.864631303024666],
              [-13.194076754072963, -11.86657915758395],
              [-13.195863025518042, -11.867771893617373],
              [-13.196589670937275, -11.871589744760069],
              [-13.19597999789078, -11.874503100862697],
              [-13.196417577858226, -11.874980440304409],
              [-13.199641649889937, -11.872548836110866],
              [-13.201321248017457, -11.8707483070147],
              [-13.203151434687554, -11.87045011038602],
              [-13.20441859811947, -11.869150463145004],
              [-13.207954292136435, -11.87074467913387],
              [-13.208335409904922, -11.867615842655937],
              [-13.21092040739298, -11.864403414522384],
              [-13.209752589872288, -11.863891894116772],
              [-13.20980003459081, -11.86284073559806],
              [-13.213373860699539, -11.860230349866072],
              [-13.215142684593367, -11.859961125246285],
              [-13.215862496867254, -11.8591209909466],
              [-13.218551166261614, -11.858606507399394],
              [-13.22038587981192, -11.857679740898924],
              [-13.220986997193934, -11.855688924122731],
              [-13.22241788607671, -11.854635650518246],
              [-13.223206585062584, -11.853430366972159]
            ]
          ],
          [
            [
              [-13.271218185678519, -11.731492720516119],
              [-13.270909738593302, -11.730807620215344],
              [-13.268741671662612, -11.730042041863246],
              [-13.267877338371358, -11.730443543791754],
              [-13.266752141315319, -11.732564491907253],
              [-13.267084865552937, -11.733471581457664],
              [-13.26907003203642, -11.73387257928959],
              [-13.270123467548853, -11.733615011732228],
              [-13.271218185678519, -11.731492720516119]
            ]
          ],
          [
            [
              [-13.273627864567425, -11.74133347131482],
              [-13.272045397970242, -11.740935677070096],
              [-13.271038844672487, -11.738318309709513],
              [-13.268940089890684, -11.737854995173228],
              [-13.26656633076484, -11.738985271581624],
              [-13.26648855320856, -11.741025038350253],
              [-13.267227729522297, -11.742359939156334],
              [-13.268668104230507, -11.741993776662905],
              [-13.272383165956287, -11.744256871675582],
              [-13.273389669715371, -11.743419001212773],
              [-13.273627864567425, -11.74133347131482]
            ]
          ],
          [
            [
              [-13.169154921059457, -12.082913241949823],
              [-13.168899116588916, -12.080917737439693],
              [-13.169285706881846, -12.079883192831783],
              [-13.16888079025947, -12.077497559485026],
              [-13.167057487590386, -12.077077451256265],
              [-13.166079356717542, -12.078615567132282],
              [-13.165152090956527, -12.083240811024204],
              [-13.162478824802333, -12.085505076403638],
              [-13.161568228783468, -12.08814670109352],
              [-13.160397421341285, -12.087880126703324],
              [-13.158553157442135, -12.090452772186318],
              [-13.159157146062242, -12.091378852485422],
              [-13.158324929965508, -12.093701468178605],
              [-13.156565249212386, -12.094776716462679],
              [-13.154779657386866, -12.097861120165975],
              [-13.155054481719038, -12.100185618185499],
              [-13.15439614287986, -12.1019737121416],
              [-13.154114554637289, -12.106857850635443],
              [-13.152524600751859, -12.108258001739985],
              [-13.151921152276822, -12.109645864511192],
              [-13.149464370864994, -12.110997971774612],
              [-13.149680200657894, -12.112887427084083],
              [-13.151733409426637, -12.112000491324395],
              [-13.152937104556448, -12.110085483821031],
              [-13.155762233666051, -12.107444863024154],
              [-13.156502405058896, -12.105558435705614],
              [-13.157750943547471, -12.105823895142734],
              [-13.159527009294457, -12.104235685830334],
              [-13.160852112883674, -12.104032518751739],
              [-13.161624653232485, -12.102353873946418],
              [-13.16187343585063, -12.099577781197006],
              [-13.161260268471247, -12.098058620863272],
              [-13.16275681244532, -12.097171696261098],
              [-13.16246255929253, -12.095137056140269],
              [-13.162849829226083, -12.094101778072393],
              [-13.165155474506138, -12.092040684432352],
              [-13.16372642831472, -12.088548116449962],
              [-13.16625258483503, -12.08766258791252],
              [-13.169285061410646, -12.084059227391867],
              [-13.169154921059457, -12.082913241949823]
            ]
          ],
          [
            [
              [-13.268436614368971, -11.812511528598705],
              [-13.2662201088899, -11.812754052102628],
              [-13.264826752042067, -11.811809420200616],
              [-13.261487095663227, -11.811312955188228],
              [-13.260806170446216, -11.812225503127312],
              [-13.257727427588367, -11.812048886582936],
              [-13.257249290105111, -11.813287804125912],
              [-13.254477213096001, -11.813628746349469],
              [-13.255073842513923, -11.815493705013397],
              [-13.254417165888423, -11.819775469980772],
              [-13.252451606162525, -11.821707246470034],
              [-13.253702569753456, -11.822690282195264],
              [-13.253463416889346, -11.825061884850225],
              [-13.254812768400408, -11.825341394604983],
              [-13.255354562365069, -11.82941082788095],
              [-13.256216688429262, -11.829597548580683],
              [-13.25634714473538, -11.831471880696766],
              [-13.257513519099053, -11.832147959507045],
              [-13.259476459825276, -11.828816611347369],
              [-13.262026172031891, -11.825496466753236],
              [-13.261735215198161, -11.823593260148114],
              [-13.259512379792078, -11.82238650031495],
              [-13.256692503608338, -11.823008151376593],
              [-13.256177920914748, -11.821371695320604],
              [-13.257394475882222, -11.819103373324825],
              [-13.258146967073825, -11.816890691123689],
              [-13.257650196525576, -11.815254631523777],
              [-13.25840853901169, -11.81490698907116],
              [-13.25981905683975, -11.816030275196976],
              [-13.261229141755605, -11.81821836941063],
              [-13.263115049974639, -11.817749936364212],
              [-13.26321381210353, -11.816170856213562],
              [-13.26602454615908, -11.815255220774787],
              [-13.266422934682966, -11.814451569633318],
              [-13.268386170831484, -11.813176791033609],
              [-13.268436614368971, -11.812511528598705]
            ]
          ],
          [
            [
              [-13.245808383816923, -11.889865928644182],
              [-13.245729571137312, -11.888581859694183],
              [-13.243842950302238, -11.88295801408131],
              [-13.242973029731639, -11.88259088558185],
              [-13.242427155768691, -11.88091991488917],
              [-13.238178770393858, -11.878776281883217],
              [-13.237748255350537, -11.876753389923024],
              [-13.236346990462636, -11.875539587926696],
              [-13.23667950977107, -11.872739731264344],
              [-13.235406195371368, -11.873651421420247],
              [-13.234486313927968, -11.872422721429096],
              [-13.235337822779188, -11.871821086473327],
              [-13.234825046836633, -11.8706360167261],
              [-13.235816571786016, -11.869104727292457],
              [-13.235595696489485, -11.866898757970986],
              [-13.236810045498185, -11.865953326369427],
              [-13.236305243138082, -11.863709222732359],
              [-13.23664883449429, -11.861740450882909],
              [-13.236310226836027, -11.858682820807456],
              [-13.235262884999175, -11.858259626474426],
              [-13.23263680016987, -11.85889267537666],
              [-13.232244710319907, -11.859641681020323],
              [-13.229744119377946, -11.860797678748444],
              [-13.227545119018776, -11.861255648234092],
              [-13.225999305486976, -11.860872536472275],
              [-13.225232683984931, -11.861906702947016],
              [-13.223056525545013, -11.861759168484244],
              [-13.221541045975034, -11.862170155287712],
              [-13.22040358730682, -11.86398127833299],
              [-13.219389973810408, -11.863906410677481],
              [-13.215316480333668, -11.865780562124192],
              [-13.21431640064808, -11.86687300289694],
              [-13.213480942672117, -11.86927678125565],
              [-13.212572325731415, -11.870543177763398],
              [-13.211806567964112, -11.872581884815581],
              [-13.210840478143556, -11.872812587463168],
              [-13.209986555066303, -11.874969366883958],
              [-13.210531659565486, -11.876934585731778],
              [-13.209491192014648, -11.87845141054767],
              [-13.21149885600428, -11.881699374180387],
              [-13.212672141755338, -11.884928505620367],
              [-13.214896944025396, -11.885090646668914],
              [-13.216689007144373, -11.886426637227656],
              [-13.219072526607473, -11.88731673407362],
              [-13.220671211475794, -11.888640153709506],
              [-13.222558959043864, -11.889229075251354],
              [-13.222852516948354, -11.88999967077072],
              [-13.224529957134873, -11.890474100266747],
              [-13.22552670635238, -11.891366993161054],
              [-13.228033759328822, -11.89248739228395],
              [-13.230020257990331, -11.892620685910181],
              [-13.231164603978291, -11.893364755140452],
              [-13.23311419589397, -11.893001391659109],
              [-13.234260739685908, -11.891757485220625],
              [-13.233668044929813, -11.890991413908237],
              [-13.23415629455251, -11.889640599539074],
              [-13.235804921220568, -11.889134890041902],
              [-13.238109357987401, -11.889657224787271],
              [-13.239866049863522, -11.889427336950593],
              [-13.243880839698633, -11.890624845875678],
              [-13.245808383816923, -11.889865928644182]
            ]
          ],
          [
            [
              [-13.267095705639504, -11.825890877697368],
              [-13.267182682301986, -11.82416995445465],
              [-13.266615449767148, -11.823520713671156],
              [-13.264289758481913, -11.824463670696343],
              [-13.264007277156825, -11.825943456912599],
              [-13.265361989220734, -11.82677558935154],
              [-13.267095705639504, -11.825890877697368]
            ]
          ],
          [
            [
              [-13.296515480399488, -11.737827349152683],
              [-13.295530371977762, -11.736946726397386],
              [-13.293304737813257, -11.73989925162427],
              [-13.293773188645124, -11.7407161349209],
              [-13.296735949968731, -11.7388065274105],
              [-13.296515480399488, -11.737827349152683]
            ]
          ],
          [
            [
              [-13.263781668905631, -11.84181008935703],
              [-13.260990275435942, -11.841381916335084],
              [-13.260771934255558, -11.840087896187859],
              [-13.259686090294096, -11.839520843422097],
              [-13.25809078443455, -11.839566606561652],
              [-13.257203590775383, -11.840823987417842],
              [-13.26010142802194, -11.845918846736687],
              [-13.261045797250652, -11.845841646103189],
              [-13.261925767515809, -11.844246384904148],
              [-13.264118606137723, -11.843093581014829],
              [-13.263781668905631, -11.84181008935703]
            ]
          ],
          [
            [
              [-13.269285996740356, -11.838545387164238],
              [-13.26803930973276, -11.83761029619898],
              [-13.268225253579429, -11.83573334134611],
              [-13.267191253802672, -11.835775495276014],
              [-13.26613083181593, -11.839311095259852],
              [-13.267044913761858, -11.840653907539563],
              [-13.269130422539014, -11.839256257809069],
              [-13.269285996740356, -11.838545387164238]
            ]
          ],
          [
            [
              [-13.250821370858336, -11.901395223174756],
              [-13.248759330061333, -11.898765290063203],
              [-13.249466903966269, -11.89610832293888],
              [-13.247991519235853, -11.894544012652133],
              [-13.246388076302749, -11.894903780169004],
              [-13.244296991788408, -11.89261855991891],
              [-13.243478561173413, -11.892599833827123],
              [-13.243307036062003, -11.894698837324402],
              [-13.244688271552453, -11.895499516197129],
              [-13.245620370062797, -11.89719422549818],
              [-13.247049691627733, -11.898562224737548],
              [-13.247474763523185, -11.901497661033916],
              [-13.249585122581022, -11.902638933462708],
              [-13.250821370858336, -11.901395223174756]
            ]
          ],
          [
            [
              [-13.279080458429103, -11.825332512280243],
              [-13.27853293606953, -11.824170117372852],
              [-13.277301400485177, -11.823529959941554],
              [-13.276196540345424, -11.824264353095225],
              [-13.275569116563366, -11.82590263341485],
              [-13.276149725816836, -11.826998458244779],
              [-13.278619438616447, -11.826508457531618],
              [-13.279080458429103, -11.825332512280243]
            ]
          ],
          [
            [
              [-13.326923917767928, -11.678673613053396],
              [-13.324885125972676, -11.677613803598895],
              [-13.324007372031362, -11.678677905663172],
              [-13.324286859954507, -11.680672814720706],
              [-13.32494649915142, -11.681640322837529],
              [-13.326923917767928, -11.678673613053396]
            ]
          ],
          [
            [
              [-13.24374062556131, -11.940712273950359],
              [-13.24355802682594, -11.938663540011278],
              [-13.24462724204598, -11.937196205886174],
              [-13.242442798300269, -11.935355031282384],
              [-13.241733469308727, -11.934018382083831],
              [-13.24211871852504, -11.932825766764378],
              [-13.239629011488681, -11.931472479301183],
              [-13.236935652246645, -11.932436451943842],
              [-13.236428270039216, -11.931550611396226],
              [-13.237703877071695, -11.930828083911912],
              [-13.238134622227335, -11.929649890996398],
              [-13.239443871792174, -11.92820932528557],
              [-13.239556698773635, -11.923873241554915],
              [-13.238372458685115, -11.92170964366577],
              [-13.238423892083949, -11.920171998091083],
              [-13.237081101346291, -11.918347761200511],
              [-13.23856987968699, -11.916964422040193],
              [-13.239814635967605, -11.917253084894003],
              [-13.242080589836023, -11.918828475107983],
              [-13.244142420800964, -11.917816510300431],
              [-13.246269639491077, -11.918134670116089],
              [-13.247288844142785, -11.91927483798054],
              [-13.24875279050083, -11.917349462368593],
              [-13.246970167014597, -11.916119164034761],
              [-13.245259868334486, -11.913746228990638],
              [-13.245390482155509, -11.910584333776967],
              [-13.243786945435144, -11.909263405993311],
              [-13.242113755170083, -11.909229929225615],
              [-13.241257297080168, -11.90988642964863],
              [-13.240136035171572, -11.911819762259483],
              [-13.238525234896494, -11.910980408254362],
              [-13.239672967915446, -11.908813085063997],
              [-13.239962944242356, -11.90623491201023],
              [-13.238084044912867, -11.904390792655105],
              [-13.238254960152794, -11.90279422702049],
              [-13.240086587515863, -11.902489690843987],
              [-13.240881839409969, -11.899729453143213],
              [-13.239710885123113, -11.897232646067556],
              [-13.238416681921542, -11.896491558730906],
              [-13.238722443716556, -11.894937792843395],
              [-13.235002613273334, -11.893588473451912],
              [-13.233744170183833, -11.89639762195009],
              [-13.231869829654155, -11.895766332629417],
              [-13.2312851991899, -11.896651681791093],
              [-13.231283077293481, -11.898639712296783],
              [-13.229780293707813, -11.898997140385513],
              [-13.228251110877727, -11.897454139516933],
              [-13.225934866550581, -11.897266673669115],
              [-13.224539158970574, -11.895618969665119],
              [-13.22232257831935, -11.896189747871167],
              [-13.222125404526054, -11.894818124641642],
              [-13.220567901461381, -11.894429536962784],
              [-13.22022529117254, -11.893352305015991],
              [-13.217460966152368, -11.891955831081985],
              [-13.216397556419762, -11.894001363811123],
              [-13.21400568160887, -11.893739883065422],
              [-13.213847038178997, -11.891797485915264],
              [-13.212641918403403, -11.88972250130817],
              [-13.210644431051595, -11.889922745395122],
              [-13.208018189853675, -11.887499192874149],
              [-13.204975056749968, -11.886352142037861],
              [-13.202915968613448, -11.887648085456846],
              [-13.201657509803097, -11.889826723089575],
              [-13.200799441091661, -11.89305341265651],
              [-13.201304282032961, -11.894086002324995],
              [-13.200479496169569, -11.898878395951694],
              [-13.20108504701549, -11.900817020920222],
              [-13.202546070637052, -11.90180884324284],
              [-13.204711303295609, -11.901709566919115],
              [-13.207365868955499, -11.903754395209434],
              [-13.207918642389771, -11.904947341948079],
              [-13.209740972586276, -11.907265632392967],
              [-13.212569062194579, -11.90984883196352],
              [-13.214783716958431, -11.910054016701393],
              [-13.215572251727096, -11.912049091562146],
              [-13.214965003343389, -11.913608466376196],
              [-13.215191369106321, -11.914893756977326],
              [-13.217978200697512, -11.919746510006151],
              [-13.218634726434257, -11.922915626072287],
              [-13.224210912559899, -11.921637411341882],
              [-13.225675854226964, -11.923696347802451],
              [-13.224178629949892, -11.92464013875597],
              [-13.22345574945596, -11.926407963621596],
              [-13.22353177793877, -11.927549517326684],
              [-13.222700050779302, -11.929040841143554],
              [-13.222405484611468, -11.931477306021772],
              [-13.222940795601174, -11.93227555328813],
              [-13.223099592059302, -11.934999042572327],
              [-13.226123704928241, -11.938077485842971],
              [-13.223792737006946, -11.939445241456111],
              [-13.22266447177932, -11.946294807609291],
              [-13.222863953850897, -11.94966566076113],
              [-13.222764906951106, -11.954112608185406],
              [-13.220855484597413, -11.956781890884576],
              [-13.220451667047117, -11.957873997691335],
              [-13.221767739229596, -11.959645789448075],
              [-13.222647580571984, -11.958311806843577],
              [-13.224233015993464, -11.95802397962289],
              [-13.225823367102159, -11.957105179123545],
              [-13.22734529911385, -11.955629732902022],
              [-13.228122770880942, -11.95353451066122],
              [-13.229376705604707, -11.95319281624363],
              [-13.230626619979118, -11.951633646386178],
              [-13.230994010604318, -11.950190288565818],
              [-13.235057587201123, -11.950377939624728],
              [-13.23631805639306, -11.9495517190153],
              [-13.237182047942632, -11.947338663817668],
              [-13.237430612621532, -11.94503261244343],
              [-13.238956743721994, -11.94399744778986],
              [-13.238087551406649, -11.942999387549083],
              [-13.237815468454599, -11.9409220072793],
              [-13.2393864265366, -11.939901105600864],
              [-13.240366813511967, -11.941322250041882],
              [-13.242530833541853, -11.94276875158947],
              [-13.24374062556131, -11.940712273950359]
            ]
          ],
          [
            [
              [-13.303289178797833, -11.758193212485567],
              [-13.301092273883288, -11.755567555614249],
              [-13.300081198834452, -11.754803318435473],
              [-13.299325469383373, -11.757771252204396],
              [-13.299695423472278, -11.759373554640133],
              [-13.298933867484953, -11.760611094566597],
              [-13.299433434372782, -11.76217031997913],
              [-13.300860245771918, -11.761694564144626],
              [-13.301884026538197, -11.75961896995255],
              [-13.303256755806837, -11.759082455613786],
              [-13.303289178797833, -11.758193212485567]
            ]
          ],
          [
            [
              [-13.308232168242558, -11.751331953360989],
              [-13.308004877964615, -11.75041104846218],
              [-13.306562077796986, -11.749814230034696],
              [-13.304848902381611, -11.752706493143801],
              [-13.305592865609471, -11.75430006966271],
              [-13.306785098617876, -11.754175933953727],
              [-13.306456062662884, -11.752694464701898],
              [-13.306892313561454, -11.751626722115118],
              [-13.308232168242558, -11.751331953360989]
            ]
          ],
          [
            [
              [-13.286102933493261, -11.825462799919155],
              [-13.286332925361993, -11.822297526589848],
              [-13.284822937999351, -11.822009655480649],
              [-13.284301124433483, -11.823122309832444],
              [-13.284681730762058, -11.825944455289108],
              [-13.286102933493261, -11.825462799919155]
            ]
          ],
          [
            [
              [-13.363430413365853, -11.586160874592208],
              [-13.363454263699243, -11.58488916025404],
              [-13.361952118101376, -11.58461484793825],
              [-13.360052909513723, -11.584974956300254],
              [-13.358309803375295, -11.58604685414864],
              [-13.357741334905835, -11.586913285810063],
              [-13.358813137900311, -11.588524266427122],
              [-13.359852131028454, -11.587992680715839],
              [-13.36307215707529, -11.587423995230234],
              [-13.363430413365853, -11.586160874592208]
            ]
          ],
          [
            [
              [-13.281616315715373, -11.847428731604696],
              [-13.281541837474167, -11.845635958204047],
              [-13.280262113278235, -11.844312372228867],
              [-13.27821746594048, -11.844232330021343],
              [-13.274730014469652, -11.848220935557778],
              [-13.273602490505912, -11.850398246318678],
              [-13.274399269587983, -11.851514255044133],
              [-13.277492727582183, -11.851847417511173],
              [-13.278334087555542, -11.850333977258332],
              [-13.279747867955379, -11.850266947391743],
              [-13.280663013856683, -11.849363846885316],
              [-13.281616315715373, -11.847428731604696]
            ]
          ],
          [
            [
              [-13.389213952482848, -11.545974465557206],
              [-13.388348977638657, -11.543583878372033],
              [-13.386151042049427, -11.544802037947479],
              [-13.386324821519514, -11.545850229813393],
              [-13.38861831548598, -11.546401432352644],
              [-13.389213952482848, -11.545974465557206]
            ]
          ],
          [
            [
              [-13.335554036596026, -11.73646530431121],
              [-13.33347775708752, -11.736401803441344],
              [-13.333723011404263, -11.734419985181598],
              [-13.33529194936137, -11.732414400587363],
              [-13.335684188686644, -11.730430230706881],
              [-13.333791310852295, -11.730709446761436],
              [-13.33269061074899, -11.731710637214235],
              [-13.332098202373071, -11.72975845828702],
              [-13.33169842020011, -11.726143802896194],
              [-13.33187932038768, -11.72466915602497],
              [-13.332869715235146, -11.723252563960516],
              [-13.332073529271806, -11.7222426079905],
              [-13.331595646606583, -11.719178948134141],
              [-13.330600642997078, -11.715908689102259],
              [-13.32927832402773, -11.715931553776224],
              [-13.328582412937214, -11.711128701077078],
              [-13.329011160408205, -11.709492717254149],
              [-13.32784783865502, -11.706601592352412],
              [-13.326279453912774, -11.706786532101898],
              [-13.326603857913852, -11.704115526576802],
              [-13.324460858258814, -11.702307171748513],
              [-13.325088242980785, -11.700208125112912],
              [-13.324050030963033, -11.698597739641384],
              [-13.32514593198708, -11.696404811796777],
              [-13.325020890282847, -11.694981462474303],
              [-13.325976396837753, -11.693223355151773],
              [-13.325726049101215, -11.691284057333416],
              [-13.324453839151904, -11.68964956994663],
              [-13.322594481054836, -11.68893128039893],
              [-13.32207453240605, -11.68752907032495],
              [-13.320143250418273, -11.684926421104407],
              [-13.318165127359297, -11.685029677851809],
              [-13.317419301491428, -11.684177996526229],
              [-13.315028648564454, -11.683150339561525],
              [-13.312792985472111, -11.682695508997696],
              [-13.309904824840551, -11.682754140810825],
              [-13.308661481721167, -11.681938075527528],
              [-13.303728031324875, -11.683652492185963],
              [-13.303091359984748, -11.683215371818918],
              [-13.303282754380426, -11.681125484127502],
              [-13.301744087545138, -11.681220010643804],
              [-13.301317362788767, -11.678937976772904],
              [-13.29835992098137, -11.680405077360476],
              [-13.295968400987748, -11.679230168257456],
              [-13.293207647267796, -11.680089155350702],
              [-13.290268657318082, -11.678503106623435],
              [-13.290020847368059, -11.677470057130302],
              [-13.291774108945221, -11.674625537199049],
              [-13.294881930601576, -11.673445987713924],
              [-13.29649237603096, -11.673279760571015],
              [-13.298389170407507, -11.673727760329182],
              [-13.300279742437429, -11.674794438051052],
              [-13.306994969898442, -11.675977205882871],
              [-13.309277491122957, -11.675684244389261],
              [-13.311730585725561, -11.676064659402439],
              [-13.31392045566107, -11.6754559481238],
              [-13.316008383848157, -11.675912686649585],
              [-13.31755760264634, -11.675629961971987],
              [-13.31798452985538, -11.674760429640946],
              [-13.319960451971946, -11.673607543496491],
              [-13.321041061646383, -11.672368533158352],
              [-13.321647030506352, -11.669742156141455],
              [-13.319953436824061, -11.66912170189198],
              [-13.319513511265857, -11.668079063070335],
              [-13.320499992527122, -11.667431262920369],
              [-13.320573018978976, -11.665403489219361],
              [-13.322261584194022, -11.662733191557091],
              [-13.320520995302937, -11.66181166504173],
              [-13.316661920880895, -11.664285226633117],
              [-13.314864994844138, -11.664585631787494],
              [-13.313180341735805, -11.665588347875289],
              [-13.310237648782802, -11.665675465855816],
              [-13.308212979798064, -11.662183561623802],
              [-13.307317721989845, -11.65985407870291],
              [-13.304360906008453, -11.658789731451277],
              [-13.304731447865844, -11.656902062240428],
              [-13.304535305639419, -11.654218145880415],
              [-13.30577250333779, -11.653697784128342],
              [-13.307551694019958, -11.654347561492834],
              [-13.309242980343022, -11.651680365561367],
              [-13.309161971502789, -11.649986642865375],
              [-13.31043112272148, -11.648618658565544],
              [-13.31008310399141, -11.647747700000135],
              [-13.311455935581877, -11.646507421150876],
              [-13.313381162912991, -11.646106103825401],
              [-13.312792813303055, -11.649115407022466],
              [-13.313487729496542, -11.64966517404775],
              [-13.314870091737934, -11.64914253693874],
              [-13.316284306762036, -11.649867926952837],
              [-13.318754337536902, -11.646586502629736],
              [-13.321788389230383, -11.647100519572152],
              [-13.322134683212644, -11.645731529543783],
              [-13.321535828041576, -11.644735946163157],
              [-13.323397511037257, -11.6430283388965],
              [-13.325583688181258, -11.643611915606916],
              [-13.328297949221453, -11.646310865390967],
              [-13.330034292909907, -11.647087076836524],
              [-13.331446773846405, -11.645715437230423],
              [-13.333849439791628, -11.644127580970597],
              [-13.336480708046855, -11.645132168300261],
              [-13.337140084642762, -11.644289253715163],
              [-13.33693311298789, -11.640276052717756],
              [-13.334779703784065, -11.641845627050472],
              [-13.333904364289031, -11.640955964792497],
              [-13.332699637138322, -11.638536787271544],
              [-13.331305419632603, -11.639103889579737],
              [-13.330763891345706, -11.640030327579733],
              [-13.329160534073356, -11.639295116673559],
              [-13.329931705144716, -11.637059990708204],
              [-13.330255812151117, -11.633211803366295],
              [-13.33126024154595, -11.629955938065917],
              [-13.33288503050773, -11.62822459585233],
              [-13.336441692914823, -11.625904366497036],
              [-13.337150263956747, -11.624460235805653],
              [-13.338474198683743, -11.623207134972219],
              [-13.340297863909814, -11.620255634121595],
              [-13.341497929796832, -11.619534417985957],
              [-13.341276190562093, -11.617375631908335],
              [-13.340032140084913, -11.615090087981397],
              [-13.34231420438148, -11.614609853835523],
              [-13.342191113439771, -11.613194221916752],
              [-13.344029051573111, -11.612291703959487],
              [-13.344884186193504, -11.610989629989039],
              [-13.345454468105006, -11.60817537176626],
              [-13.34508423505667, -11.604833084738695],
              [-13.343968547324764, -11.604250018456876],
              [-13.339788905472094, -11.605374772609663],
              [-13.338853341050667, -11.606176620603312],
              [-13.338418994321701, -11.607935394673598],
              [-13.337161743772105, -11.609165416920577],
              [-13.334584615656611, -11.609362791120459],
              [-13.33354846756729, -11.607188677801142],
              [-13.335937393500084, -11.60607874025202],
              [-13.336959080747652, -11.605161130898646],
              [-13.33793843965343, -11.603329075219367],
              [-13.337331430205536, -11.6016215401105],
              [-13.338322886197728, -11.600647685380837],
              [-13.339789009355231, -11.600295896085074],
              [-13.343848839374877, -11.598044081065499],
              [-13.343644439808894, -11.595988042700274],
              [-13.342568444777607, -11.59304548464409],
              [-13.340975629274554, -11.592598252624065],
              [-13.336599366557905, -11.592994349284671],
              [-13.335644196294554, -11.59340899758868],
              [-13.33339946690283, -11.592141636335137],
              [-13.329024388718695, -11.592678046664737],
              [-13.326973091348373, -11.591706764560977],
              [-13.324640222386657, -11.591454183757161],
              [-13.323400855747215, -11.592444376412487],
              [-13.322674212792428, -11.591410422254633],
              [-13.319186905463411, -11.590844210700649],
              [-13.317222315650984, -11.590942817295534],
              [-13.316471399155692, -11.590281045321017],
              [-13.314838279482318, -11.590102936314066],
              [-13.314527775996064, -11.59090812787777],
              [-13.31036571113209, -11.59240836087194],
              [-13.308104800363783, -11.590893054351186],
              [-13.306484633349163, -11.591858377597994],
              [-13.305172246119742, -11.591732020864715],
              [-13.304593946127078, -11.59083833475101],
              [-13.301889510710431, -11.591272925677561],
              [-13.30146624712013, -11.589904810848873],
              [-13.299546207495151, -11.58749710390776],
              [-13.298298370333034, -11.587912739725613],
              [-13.297344689306026, -11.58728072438765],
              [-13.295833593914084, -11.587613818249553],
              [-13.295238865336989, -11.586476607654285],
              [-13.290650294258816, -11.584985869597615],
              [-13.291368079070347, -11.583976356446431],
              [-13.288426119422462, -11.583953096522418],
              [-13.286962847052301, -11.5847277117519],
              [-13.283849458520098, -11.583604029601899],
              [-13.282341824875251, -11.584364600496913],
              [-13.28061289051196, -11.586386504098606],
              [-13.279652679283872, -11.58496618216642],
              [-13.278220367863092, -11.585275002860996],
              [-13.2765488990411, -11.584105307009645],
              [-13.275348476784405, -11.580183691349681],
              [-13.273771515733387, -11.580564585964336],
              [-13.271562835426828, -11.579485655178392],
              [-13.269254064933289, -11.580324529641743],
              [-13.267713532979169, -11.58162003526155],
              [-13.266426758415234, -11.581926057147939],
              [-13.264749646115554, -11.580847924330914],
              [-13.264006376763435, -11.578994957773684],
              [-13.26291147362023, -11.577767783274926],
              [-13.262256156632674, -11.575943127558137],
              [-13.258861663785, -11.577387070016213],
              [-13.256463856479096, -11.57686460306385],
              [-13.254554014857383, -11.579325109756],
              [-13.252426346187454, -11.580012868276468],
              [-13.250801714006538, -11.581069388809498],
              [-13.249668118216443, -11.58241267230598],
              [-13.249974339458095, -11.583768672132658],
              [-13.24801586634419, -11.584219868543183],
              [-13.245441055176832, -11.58716244313623],
              [-13.245850947584357, -11.589507591061714],
              [-13.24526833823172, -11.590679756214474],
              [-13.24321678105548, -11.589264586308254],
              [-13.24001121205496, -11.59088819320402],
              [-13.241107128713926, -11.593357511798928],
              [-13.239122432432138, -11.595537417086264],
              [-13.237745348016789, -11.594717371406682],
              [-13.236613750337366, -11.599147965204445],
              [-13.234532974654023, -11.600225212740511],
              [-13.233115387538, -11.597627182098991],
              [-13.231098905581804, -11.597341704300462],
              [-13.228795545763042, -11.597846224703158],
              [-13.227056911762501, -11.60015274528539],
              [-13.227331164932814, -11.602100928565267],
              [-13.225876820358224, -11.604427740093092],
              [-13.222619932044228, -11.60713384137016],
              [-13.221518179284939, -11.607378372325723],
              [-13.220621851487508, -11.609120854227266],
              [-13.21968502122475, -11.608869041156323],
              [-13.218908950097314, -11.611271115928194],
              [-13.220222685209185, -11.613529625366082],
              [-13.21999512280737, -11.614650815433693],
              [-13.21656279624231, -11.61532070095168],
              [-13.215281301368256, -11.616320084123743],
              [-13.214621519531335, -11.618736832395857],
              [-13.214785787966418, -11.62203894745964],
              [-13.213439294654059, -11.627320386616194],
              [-13.217041815660291, -11.628925806612344],
              [-13.216705350298051, -11.63022872174601],
              [-13.214623302946036, -11.630925999269808],
              [-13.21441950678683, -11.632415004719965],
              [-13.2169120872593, -11.635458636454263],
              [-13.216605049961943, -11.636747765330538],
              [-13.215135511554756, -11.639626967848551],
              [-13.21382461820483, -11.639686806354623],
              [-13.21330476702847, -11.640955969471424],
              [-13.21362650660256, -11.642111508642488],
              [-13.214864040129077, -11.641980185464726],
              [-13.216271811103177, -11.640970200873154],
              [-13.216991852306313, -11.642539664851029],
              [-13.216467764807183, -11.644262351654717],
              [-13.218508417740663, -11.647137841481594],
              [-13.219105925712755, -11.648859849162497],
              [-13.221226939010792, -11.645994647982777],
              [-13.222996773733264, -11.644405658116801],
              [-13.223852190663948, -11.643075817522838],
              [-13.225906679638502, -11.643562397499135],
              [-13.225016949281223, -11.645216323380101],
              [-13.2250553172413, -11.64759618485853],
              [-13.223232820343672, -11.648977726680311],
              [-13.222451839527086, -11.650523618371832],
              [-13.221241816868487, -11.650425285901244],
              [-13.21927910983945, -11.65288724933118],
              [-13.218224666361616, -11.655328025797225],
              [-13.217015106176262, -11.656474480459668],
              [-13.216494234319702, -11.655327104167844],
              [-13.21418782749296, -11.657057935060015],
              [-13.21222106501395, -11.65923254413103],
              [-13.211801733412544, -11.660200458396822],
              [-13.212178052720049, -11.661709774882649],
              [-13.211484140738474, -11.663356772224084],
              [-13.208783675367636, -11.664579941749762],
              [-13.207227958444092, -11.664634695093524],
              [-13.205849933900838, -11.666002587533642],
              [-13.20509835821445, -11.665679962327822],
              [-13.205323748956985, -11.663766130683946],
              [-13.20428048060606, -11.6631567505764],
              [-13.20373072121418, -11.661921181707978],
              [-13.201442998199468, -11.660533957954746],
              [-13.200437783035408, -11.66054792026215],
              [-13.199878804903369, -11.658939331657304],
              [-13.198151305218708, -11.657012983384359],
              [-13.1967646505096, -11.656289894019338],
              [-13.19548499263861, -11.6576166246136],
              [-13.19389025634415, -11.657654989791833],
              [-13.190987066483839, -11.659583173137099],
              [-13.191475758483735, -11.656296013418478],
              [-13.190716733940029, -11.655914642962959],
              [-13.18785599587213, -11.657738478142505],
              [-13.18793110216495, -11.656137294716016],
              [-13.189053952438027, -11.654073044887472],
              [-13.188930796313223, -11.651856285224458],
              [-13.187374166833584, -11.651832605376033],
              [-13.186038976067085, -11.652707783529078],
              [-13.185248892140338, -11.650464722159816],
              [-13.182180230394907, -11.650148452602092],
              [-13.179525676286937, -11.653751202828206],
              [-13.177768889326973, -11.658165281425639],
              [-13.178052370339586, -11.659578270753837],
              [-13.17734810771482, -11.6616785076168],
              [-13.174195595136474, -11.6610962146796],
              [-13.17287294712546, -11.659875204629117],
              [-13.171579456491049, -11.660589797887612],
              [-13.170364600897853, -11.659622489664796],
              [-13.168759745019011, -11.65923891925702],
              [-13.167607837732527, -11.657727134485691],
              [-13.16841699188319, -11.656410474048613],
              [-13.1660001275123, -11.656179729406457],
              [-13.165724293037382, -11.654919528104234],
              [-13.164167639867058, -11.654647954902414],
              [-13.16411046258492, -11.653245373444555],
              [-13.162556377531661, -11.65326385833441],
              [-13.160462337410156, -11.65563505789269],
              [-13.161362931024504, -11.656784359753297],
              [-13.163248868289907, -11.65590488991308],
              [-13.163701121581203, -11.656984719588266],
              [-13.162126904454642, -11.658936339400073],
              [-13.161090241350836, -11.65874681938632],
              [-13.15998768054713, -11.660130395243934],
              [-13.159106605584366, -11.659653827520726],
              [-13.159425052777156, -11.657027396491317],
              [-13.15781459323908, -11.65717978918353],
              [-13.15755329229866, -11.658535578366944],
              [-13.155951758676762, -11.658559861714501],
              [-13.154947799480123, -11.65711355695404],
              [-13.153887735334953, -11.658454560146206],
              [-13.151399412227951, -11.659522255125909],
              [-13.150204039394136, -11.660816765777769],
              [-13.148256718119763, -11.660714536041155],
              [-13.146413687060758, -11.661606690268991],
              [-13.145092462128005, -11.662764346750535],
              [-13.144041324422176, -11.66254358451363],
              [-13.142020921787799, -11.663306204014562],
              [-13.137139886528686, -11.66304370323584],
              [-13.136435025374876, -11.664185104329645],
              [-13.135244241317626, -11.664683766519994],
              [-13.13393006492049, -11.66738655331604],
              [-13.131151674203956, -11.67001908245406],
              [-13.12584097405932, -11.672598074894982],
              [-13.1235376066687, -11.673533125729133],
              [-13.120704174468509, -11.674295215196162],
              [-13.119261503629408, -11.675149160487331],
              [-13.115521375964216, -11.67640983395216],
              [-13.107094259616959, -11.680475825407482],
              [-13.105403788696478, -11.684140876262516],
              [-13.10304500304656, -11.685081380707473],
              [-13.100256984867858, -11.686918334136797],
              [-13.097366453674148, -11.687756911014908],
              [-13.09472173366613, -11.691184767757884],
              [-13.093267900832274, -11.691914935240243],
              [-13.09269814988758, -11.69300725219373],
              [-13.090727104217793, -11.694098962778067],
              [-13.088985880965282, -11.694372871319299],
              [-13.087102792923368, -11.69534866601053],
              [-13.085276520401873, -11.697163880578307],
              [-13.083629793719647, -11.697734563142237],
              [-13.080560878074758, -11.700446117905317],
              [-13.079376280044212, -11.701892899040889],
              [-13.077876217859592, -11.702463502622958],
              [-13.076004429282342, -11.703974658612761],
              [-13.074808594105225, -11.703799275163112],
              [-13.07403502353575, -11.70584078226788],
              [-13.07274054753473, -11.706599423957682],
              [-13.072271925362951, -11.70775067180982],
              [-13.070814486986768, -11.708552625949837],
              [-13.06828797138279, -11.710961769793636],
              [-13.06581608172217, -11.712204140702342],
              [-13.065657828837727, -11.713167552572802],
              [-13.067147254120488, -11.714359209539364],
              [-13.06660451803831, -11.715438226539089],
              [-13.067385528643877, -11.716323992395488],
              [-13.06798619117097, -11.718311563082382],
              [-13.065448159751506, -11.719025089793162],
              [-13.067482039235895, -11.721508444012029],
              [-13.06655393639354, -11.722848662465303],
              [-13.064386418331317, -11.72298311386191],
              [-13.063432172583978, -11.725476888146723],
              [-13.060761437441633, -11.725493899427493],
              [-13.060304659258268, -11.727256050004742],
              [-13.056168830839438, -11.729163732323537],
              [-13.05385892896082, -11.731502827698892],
              [-13.053621253497857, -11.733847374128446],
              [-13.052626535968267, -11.73674224854395],
              [-13.054451648338341, -11.738118380563389],
              [-13.054363170289237, -11.74024622351086],
              [-13.052891786665993, -11.741724847477846],
              [-13.052954223150424, -11.742981815928939],
              [-13.051613987849972, -11.745013386822185],
              [-13.052082625590739, -11.746816164717822],
              [-13.051435870722395, -11.749707336949152],
              [-13.049573786037703, -11.750088635743925],
              [-13.04977186066971, -11.748504631968792],
              [-13.047900853145096, -11.747184927570776],
              [-13.046206195927262, -11.750531690511202],
              [-13.045948463940368, -11.7521449286137],
              [-13.04663415364584, -11.75331703748788],
              [-13.044821724294854, -11.756286561818513],
              [-13.044883973953576, -11.759850398221017],
              [-13.04582692322785, -11.761933010471331],
              [-13.044695712037743, -11.76522623958968],
              [-13.043426433665672, -11.765245350791067],
              [-13.042817422739857, -11.760893337091458],
              [-13.04161864381934, -11.759915731968288],
              [-13.042130348913382, -11.75792383331605],
              [-13.042334068463273, -11.754957208394893],
              [-13.040859279819033, -11.75456786742825],
              [-13.040831092172898, -11.752204524044876],
              [-13.04264365132298, -11.749454211502801],
              [-13.043209969997374, -11.746729929104688],
              [-13.041947075912057, -11.74551272890981],
              [-13.040426303665438, -11.745762876425816],
              [-13.03960913934448, -11.74440148752708],
              [-13.038179765575004, -11.744099165499687],
              [-13.036690271843986, -11.74569341691179],
              [-13.034226921449866, -11.74609262002565],
              [-13.031431952420022, -11.749173069505202],
              [-13.029917152931032, -11.749545862771564],
              [-13.028709790410465, -11.750748601406352],
              [-13.028455660579613, -11.752703998284892],
              [-13.027081253133455, -11.753098810629897],
              [-13.026612183929075, -11.754959537901792],
              [-13.024884821963376, -11.756160512734231],
              [-13.02492317851044, -11.757412328636489],
              [-13.023496443845529, -11.759247762615367],
              [-13.023401185116112, -11.760528090881596],
              [-13.021192608981833, -11.764195443599496],
              [-13.017665212316619, -11.765506442677472],
              [-13.01752550123283, -11.766700029640045],
              [-13.01632252767247, -11.768027841655227],
              [-13.01643912151797, -11.76991449460691],
              [-13.015957106311834, -11.771165130292395],
              [-13.014491162887836, -11.771530790696021],
              [-13.011267560396547, -11.773891826297213],
              [-13.009597134432676, -11.774846367862516],
              [-13.008283296293323, -11.777135862957689],
              [-13.008218004172992, -11.77818506505783],
              [-13.006393140467077, -11.780013873532353],
              [-13.00609594839437, -11.78130253326246],
              [-13.004062985561374, -11.781650574229165],
              [-13.002479114971223, -11.778982043407803],
              [-12.99975148179132, -11.778611627697474],
              [-12.998074426304786, -11.780367184976956],
              [-12.996095357416833, -11.780342391852692],
              [-12.994180556987294, -11.780776876236867],
              [-12.993425973964598, -11.782377314383774],
              [-12.990415411645145, -11.7818864635228],
              [-12.988838573339374, -11.782847553032001],
              [-12.98747948374328, -11.782394742860001],
              [-12.984841073359442, -11.782904250777168],
              [-12.98002241113495, -11.785245593181369],
              [-12.977881492684576, -11.787749677585952],
              [-12.976659068205311, -11.787902263407233],
              [-12.974614271375382, -11.791341578565302],
              [-12.973057190976865, -11.793296243628996],
              [-12.971347329949305, -11.792678923942022],
              [-12.969756038153918, -11.79326856101738],
              [-12.969981414620525, -11.794719745568033],
              [-12.969042358402284, -11.795991052113177],
              [-12.968737470993764, -11.798465425030336],
              [-12.970469871781715, -11.797879424311109],
              [-12.970385017460362, -11.800090694205565],
              [-12.96983925403293, -11.800839624147905],
              [-12.971724721201673, -11.801918869425071],
              [-12.973957745675532, -11.80220106387002],
              [-12.976308771836088, -11.799887882748896],
              [-12.979137507946188, -11.798775696336921],
              [-12.980988766184332, -11.799127710913561],
              [-12.98285716881134, -11.798577697131481],
              [-12.984675784505301, -11.797184928766713],
              [-12.986300831958143, -11.795432813582346],
              [-12.988110862032496, -11.794254181503474],
              [-12.992494928971265, -11.793008668356357],
              [-12.99551708052458, -11.793257658896298],
              [-12.997265358974701, -11.792303096987835],
              [-12.998847372350967, -11.792524043415447],
              [-13.003972074810946, -11.790799171399389],
              [-13.005221052103574, -11.791432737938448],
              [-13.007928615504758, -11.791423515213621],
              [-13.008905888157761, -11.790324153785367],
              [-13.011308596582868, -11.790716063781518],
              [-13.012509748404513, -11.789831463929648],
              [-13.01708912827189, -11.78917275885718],
              [-13.017666417985478, -11.788737609211966],
              [-13.020977749705612, -11.789033148803698],
              [-13.022120186842907, -11.78825302754441],
              [-13.02373505804808, -11.788727394151495],
              [-13.02495346728314, -11.787528224879377],
              [-13.026227527013035, -11.788115205182258],
              [-13.02803020922224, -11.788051881917696],
              [-13.029580232666076, -11.788775106663993],
              [-13.031988661478293, -11.786583366708214],
              [-13.034230463685612, -11.78688146102462],
              [-13.036262858408154, -11.786138593412131],
              [-13.03906162307588, -11.785782279064176],
              [-13.041682795498982, -11.78436730498659],
              [-13.042872195543127, -11.781721257040882],
              [-13.044909760472404, -11.780576968294065],
              [-13.046630548339303, -11.779124369229896],
              [-13.047742761331905, -11.777499151137377],
              [-13.049407998199065, -11.778571426100124],
              [-13.050437274040144, -11.776738018166853],
              [-13.050097695710924, -11.775688287085686],
              [-13.050774043734211, -11.773355164710471],
              [-13.054086886373566, -11.7736082760982],
              [-13.055138364281389, -11.77450162315009],
              [-13.056475352329132, -11.774049187211773],
              [-13.057048127154445, -11.774977682961897],
              [-13.056121253809078, -11.776018209931415],
              [-13.057969596676212, -11.777010539669128],
              [-13.060520167547256, -11.776659347476656],
              [-13.061378263052182, -11.778633004451791],
              [-13.060692291770026, -11.779459046862804],
              [-13.060485672122468, -11.781434950420628],
              [-13.06232197118189, -11.783023231454154],
              [-13.062049016925796, -11.78510273446389],
              [-13.063386686723735, -11.788176586944529],
              [-13.062350678465492, -11.789550121106762],
              [-13.060800365492206, -11.790509865627085],
              [-13.059356390794203, -11.788264669356737],
              [-13.057788377461844, -11.789688329669586],
              [-13.056919039236623, -11.788185159227972],
              [-13.055677853278588, -11.788045666372321],
              [-13.053156639918205, -11.788677083113036],
              [-13.050937625826577, -11.790298950677094],
              [-13.04994839409732, -11.791604509668124],
              [-13.05285176694466, -11.792611579733771],
              [-13.052332355575663, -11.794557538873665],
              [-13.053723418056283, -11.795936085678383],
              [-13.052706803404357, -11.798836574289712],
              [-13.05394796194726, -11.799632154546014],
              [-13.055223583638883, -11.802505889284346],
              [-13.055125258934764, -11.803665168604503],
              [-13.056159086931292, -11.804124965252011],
              [-13.056373476792862, -11.805240845538005],
              [-13.055768620167193, -11.806867260430236],
              [-13.055959865031422, -11.808705297241394],
              [-13.056770845008135, -11.809238013981876],
              [-13.057267406050148, -11.811273687666722],
              [-13.055770158456012, -11.81195189072446],
              [-13.057741325531696, -11.814250528808934],
              [-13.06034702754138, -11.815345381174613],
              [-13.062505418212083, -11.817826101581872],
              [-13.059264953571553, -11.818155101317927],
              [-13.059651280646072, -11.820081930109788],
              [-13.06288364558786, -11.822621149760689],
              [-13.063926730938544, -11.82262062116025],
              [-13.064216749441844, -11.827461117797581],
              [-13.065215637729429, -11.828833236743792],
              [-13.066930105328911, -11.830219327763288],
              [-13.06555146953122, -11.833105674299732],
              [-13.066021648998538, -11.834646628956357],
              [-13.064612520661814, -11.836087097511035],
              [-13.063068567758174, -11.835730120434006],
              [-13.06272552926204, -11.834619862463542],
              [-13.063344383438002, -11.833092560428952],
              [-13.061659594842343, -11.830157566356702],
              [-13.061347229877015, -11.826696008231089],
              [-13.060207875487022, -11.824279581590467],
              [-13.057980681197815, -11.82235970698936],
              [-13.056342867603542, -11.820388611239835],
              [-13.054211784018552, -11.820592688612571],
              [-13.052030796695053, -11.818540406062656],
              [-13.050852409558718, -11.819518184714127],
              [-13.049616972627728, -11.818261941426167],
              [-13.05068882659411, -11.813671688113606],
              [-13.05112554001099, -11.810358982290161],
              [-13.0521247616061, -11.80946940236541],
              [-13.05173972845636, -11.807907880322725],
              [-13.049315909991154, -11.80592198954666],
              [-13.047997710551623, -11.806219861920397],
              [-13.046550104572738, -11.804139237591018],
              [-13.046957248711525, -11.80149961902449],
              [-13.045923875483405, -11.800966079690127],
              [-13.045221339144613, -11.80243822160507],
              [-13.044342534181435, -11.802612290895123],
              [-13.044092767454254, -11.804500915331042],
              [-13.044999337997693, -11.805333850534542],
              [-13.043351777799941, -11.80630206953317],
              [-13.042220960718023, -11.805906330566598],
              [-13.041926316502595, -11.804519825622695],
              [-13.040126248063146, -11.803831398447983],
              [-13.039393305065175, -11.80517266467337],
              [-13.037386639075352, -11.806606713621479],
              [-13.036802120823264, -11.80519737855951],
              [-13.037267374697196, -11.803841226597397],
              [-13.034799353597453, -11.802494072533369],
              [-13.033909854911348, -11.801106296573087],
              [-13.030700034142649, -11.799173217108585],
              [-13.0296324765789, -11.797872384825245],
              [-13.027222120705346, -11.797516048908411],
              [-13.026957424272121, -11.796552605180866],
              [-13.02560545080847, -11.795863268473186],
              [-13.02420386959529, -11.796399034824315],
              [-13.02425955764082, -11.797464038367835],
              [-13.023101790527587, -11.798445584727638],
              [-13.022735090205291, -11.800881261114407],
              [-13.021676173883282, -11.803235012941673],
              [-13.019567168758998, -11.803513594496433],
              [-13.017717215797544, -11.807872633271678],
              [-13.01533691405622, -11.80684307772777],
              [-13.014094485512993, -11.80467812343378],
              [-13.011769685064234, -11.803129739342578],
              [-13.011086171574304, -11.804317056827506],
              [-13.009018409545389, -11.80519259199205],
              [-13.00787949972889, -11.804961876310804],
              [-13.007085264218647, -11.802797978861472],
              [-13.004542447355226, -11.80173641790921],
              [-13.003446909883149, -11.801812026779029],
              [-13.001755852927223, -11.803177323625176],
              [-13.002277379206566, -11.804617669426257],
              [-13.001566642432579, -11.80516239713231],
              [-12.996652798182206, -11.80692231708687],
              [-12.995743165421095, -11.808254706178372],
              [-12.994070293721572, -11.808772689311649],
              [-12.992388588260338, -11.810751764240505],
              [-12.992429618908675, -11.811424170030797],
              [-12.994161283795991, -11.812462633569844],
              [-12.995516588638264, -11.814229731207543],
              [-12.998511158364385, -11.814929846954971],
              [-12.998652741674954, -11.816392124770449],
              [-13.002858601660009, -11.818126695971822],
              [-13.006449117357613, -11.820851548452785],
              [-13.007744917815979, -11.821353011261195],
              [-13.009350668957953, -11.82095644162128],
              [-13.010436234125923, -11.821778856477128],
              [-13.012886340008741, -11.820953563967489],
              [-13.013531588052793, -11.821898354979394],
              [-13.013822224600064, -11.823872343698254],
              [-13.017003507024324, -11.823019191551431],
              [-13.018078321098816, -11.824958817310305],
              [-13.01619844946227, -11.82694895120739],
              [-13.015296925901035, -11.82660284249624],
              [-13.010344829594214, -11.827750316729125],
              [-13.010360503820431, -11.829439297417291],
              [-13.009020479926374, -11.830436901668712],
              [-13.00675433986267, -11.831445775066868],
              [-13.006158339718546, -11.832957722442274],
              [-13.005049928981368, -11.833714725048143],
              [-13.003179098864544, -11.83292534595807],
              [-13.00163362666754, -11.832853912872586],
              [-13.003575924599163, -11.827588047101425],
              [-13.002319095236762, -11.8249512654545],
              [-13.000876603881085, -11.825377016792087],
              [-12.99987148412794, -11.826411289085229],
              [-12.998511801739282, -11.826669246703425],
              [-12.996624897126258, -11.827802161326144],
              [-12.995402363921608, -11.827446014399356],
              [-12.994720466153527, -11.826463049145458],
              [-12.996469508630792, -11.826017451192499],
              [-12.997872615551005, -11.824553578746876],
              [-12.997854372804552, -11.823741697745746],
              [-12.996233670841132, -11.822521527381877],
              [-12.994741413107455, -11.822441612158114],
              [-12.993180064785104, -11.819971035169724],
              [-12.991759193987363, -11.81918221209707],
              [-12.990831713937336, -11.819558088490485],
              [-12.989179857393085, -11.818716518845122],
              [-12.988149248667126, -11.816299437027627],
              [-12.986617375163231, -11.81669358547216],
              [-12.986189523143045, -11.818358059569993],
              [-12.983865454677787, -11.81887966486685],
              [-12.984082739588949, -11.82119876398176],
              [-12.981347318527913, -11.82290285776962],
              [-12.981001686541648, -11.82447335287438],
              [-12.977838343010351, -11.824032060272978],
              [-12.976380165750811, -11.825501270431825],
              [-12.975902711993399, -11.827737455079118],
              [-12.974581418445382, -11.827590829699814],
              [-12.973320475911615, -11.828490900713938],
              [-12.97319768734016, -11.830136694509603],
              [-12.971620348526798, -11.829146846596593],
              [-12.968726827219045, -11.830505530118177],
              [-12.968318792597671, -11.829024435330851],
              [-12.967359332990474, -11.828411220208366],
              [-12.965142021378826, -11.82918764917507],
              [-12.964096366423805, -11.827102392772327],
              [-12.961942147314694, -11.827410509807232],
              [-12.96142448289724, -11.828680366860366],
              [-12.962174447480239, -11.829322250086905],
              [-12.962700582265663, -11.831968203055107],
              [-12.960991232413958, -11.832645407760573],
              [-12.960519492195221, -11.833784258629555],
              [-12.958732384995566, -11.833823692739546],
              [-12.95712088270244, -11.834361940353034],
              [-12.954810465416477, -11.837261180946715],
              [-12.955802488694292, -11.838571522433611],
              [-12.954158511840316, -11.839344283728545],
              [-12.953889786893956, -11.840257932548313],
              [-12.95433350857325, -11.84285485548681],
              [-12.952877251726168, -11.842514878443613],
              [-12.952146849351141, -11.845038081809514],
              [-12.95095963933551, -11.844714748598303],
              [-12.949583219428177, -11.845577033249906],
              [-12.94799570151246, -11.845683076562647],
              [-12.948535747654178, -11.847431412183482],
              [-12.946555585087047, -11.847944916506883],
              [-12.944460973501254, -11.849571905222385],
              [-12.943977433383793, -11.851027445873173],
              [-12.942507950025455, -11.852153314463543],
              [-12.939143060853938, -11.851541040591512],
              [-12.938788667280274, -11.854486730987318],
              [-12.939220475934032, -11.855685643096999],
              [-12.937249366084052, -11.856668515700562],
              [-12.93863171855104, -11.859804639776883],
              [-12.93861307577208, -11.86114737653351],
              [-12.93957651073999, -11.862475528990824],
              [-12.942924294172727, -11.862785907475716],
              [-12.944190958912392, -11.864680921978575],
              [-12.942247731534264, -11.865870939444944],
              [-12.941665355147379, -11.867467036952597],
              [-12.943646522152255, -11.869184017790335],
              [-12.945818364420635, -11.870498638416402],
              [-12.951461704151045, -11.870836778444675],
              [-12.953136549485539, -11.871493364590838],
              [-12.95698944854492, -11.87157563531032],
              [-12.9579087462058, -11.870876391506629],
              [-12.960524932781025, -11.870840447963507],
              [-12.961263130832343, -11.871453797102644],
              [-12.961986362942312, -11.874489185524924],
              [-12.961291636063217, -11.875263368108095],
              [-12.959419515408388, -11.874885828220933],
              [-12.959721336308982, -11.87697261157503],
              [-12.960500732177879, -11.878261756748172],
              [-12.963237696431746, -11.879539773880767],
              [-12.962737893384498, -11.882856547592302],
              [-12.963914283436473, -11.885675778009306],
              [-12.963161035924017, -11.887486316479244],
              [-12.962235577734745, -11.887914769438497],
              [-12.96047767840357, -11.885686935417608],
              [-12.95821647624736, -11.884910460256298],
              [-12.95721430839823, -11.88317852485093],
              [-12.957351936247454, -11.880402867342502],
              [-12.955979183948964, -11.879234457083975],
              [-12.954496358751003, -11.878887958877785],
              [-12.95206860896174, -11.879600262102738],
              [-12.951056350467923, -11.877324725563149],
              [-12.950185551241182, -11.876371648721353],
              [-12.948678290407, -11.876310876736934],
              [-12.946866251484174, -11.876908388506383],
              [-12.94546774154606, -11.876318875748971],
              [-12.942805560999474, -11.877196810187495],
              [-12.942088547236555, -11.878749253329872],
              [-12.93981683413937, -11.878505714757749],
              [-12.93966480566168, -11.875852933090608],
              [-12.938801225812417, -11.875024007536927],
              [-12.93697775002471, -11.876009736922631],
              [-12.937220278742487, -11.878545978719506],
              [-12.933713217421518, -11.880687769775458],
              [-12.931090722875476, -11.879220387123064],
              [-12.932333866055641, -11.877745789715252],
              [-12.930950256461344, -11.877183937665844],
              [-12.930614633360191, -11.874272305270155],
              [-12.931901298756609, -11.873819412037614],
              [-12.932442123066638, -11.872846847158888],
              [-12.93127630685867, -11.871449539497839],
              [-12.931253533235486, -11.869723523277374],
              [-12.929673188163322, -11.870298736105102],
              [-12.928575897784212, -11.869709528778342],
              [-12.929388634407175, -11.868533736349132],
              [-12.928959235463038, -11.866180777107225],
              [-12.930836420378395, -11.865043215042192],
              [-12.931532926247455, -11.862552766707834],
              [-12.930633899543666, -11.85574981705802],
              [-12.92834579550371, -11.852774069366742],
              [-12.929176261510701, -11.851262620823235],
              [-12.926635606966268, -11.849011330006373],
              [-12.926657173751064, -11.848307363071639],
              [-12.924554569695617, -11.848091051365625],
              [-12.923045926023054, -11.849177924220367],
              [-12.920570144353453, -11.850307403021944],
              [-12.919190290406222, -11.850456074454836],
              [-12.917236382546523, -11.85252212936219],
              [-12.916795510496177, -11.854631570126518],
              [-12.915582193075462, -11.856014882633072],
              [-12.915066102364985, -11.857411916286397],
              [-12.915048403140108, -11.859173516953351],
              [-12.91378944872944, -11.859830097584688],
              [-12.911610548234385, -11.862460286524716],
              [-12.911786269777576, -11.865098687542432],
              [-12.910407438267997, -11.864953455666129],
              [-12.909344794337137, -11.866904708724892],
              [-12.910969686125274, -11.868705018210411],
              [-12.906430935918712, -11.873688306480668],
              [-12.904659033484366, -11.878081999222491],
              [-12.90452001129898, -11.879190608625107],
              [-12.905650622314372, -11.880260270383237],
              [-12.905469499526127, -11.881846656808086],
              [-12.906262584660821, -11.883663246942264],
              [-12.905860853690365, -11.885520161387547],
              [-12.907648623943874, -11.885580700091664],
              [-12.908630622100002, -11.886575130285816],
              [-12.906802612268748, -11.88755900956888],
              [-12.906185512655517, -11.889171653177465],
              [-12.908084682202562, -11.888629759734018],
              [-12.910616365915004, -11.888718700828855],
              [-12.911598731955626, -11.889713222740271],
              [-12.910877671695857, -11.891266297736752],
              [-12.912303765266985, -11.892286644595973],
              [-12.911140710250722, -11.893667291917257],
              [-12.90978140913135, -11.892742849337296],
              [-12.908313954821457, -11.892913755967953],
              [-12.908064548596522, -11.895413508441095],
              [-12.908641535855253, -11.897206913851594],
              [-12.90987648376864, -11.898630941446196],
              [-12.91385665983441, -11.90090252449558],
              [-12.913884024511068, -11.902043682565262],
              [-12.912356808173584, -11.902097089353735],
              [-12.911822866198861, -11.901253323418866],
              [-12.909869648238251, -11.901803674078861],
              [-12.907273651921077, -11.900315699562235],
              [-12.905302206537124, -11.898052999171664],
              [-12.902836019632302, -11.897986435061648],
              [-12.901912949703028, -11.89853713501059],
              [-12.900292427359616, -11.901143402054032],
              [-12.901267886088085, -11.902948881178757],
              [-12.901264642007527, -11.904031523206761],
              [-12.902470474735, -11.904609627197422],
              [-12.904240531829805, -11.906805353117264],
              [-12.903753925084963, -11.908119392743304],
              [-12.904619110809652, -11.90895236880281],
              [-12.906859429176071, -11.909236884761986],
              [-12.9057393876803, -11.910707848863193],
              [-12.906716483396112, -11.9125138732372],
              [-12.90786210898644, -11.913194029594608],
              [-12.909514231918237, -11.91278832087619],
              [-12.911409564989672, -11.913842803491098],
              [-12.91260953443005, -11.916092417197099],
              [-12.91467209248731, -11.917029927458312],
              [-12.91392243520848, -11.919315743057238],
              [-12.91286116351461, -11.920117825904558],
              [-12.915255345702063, -11.921116885342059],
              [-12.914499545029724, -11.922341750889435],
              [-12.91571851149462, -11.924326737166933],
              [-12.915166697210415, -11.926408626015732],
              [-12.912306068077903, -11.925228681304679],
              [-12.91198189224268, -11.927954071177606],
              [-12.91027150777374, -11.928810864575444],
              [-12.913219980269087, -11.932263032162735],
              [-12.913686445027464, -11.93330665079958],
              [-12.915524160031799, -11.934463736919009],
              [-12.917627991787029, -11.936301487550383],
              [-12.91791476852574, -11.939232277565912],
              [-12.919151995021943, -11.941174147663428],
              [-12.920220291184213, -11.941506361756947],
              [-12.92271137837226, -11.943250131085577],
              [-12.924390099979878, -11.942626817324639],
              [-12.92420586370657, -11.94416772090372],
              [-12.92598421228711, -11.945500247585203],
              [-12.9265586324326, -11.947541020923945],
              [-12.928411400175598, -11.949095265687207],
              [-12.930754255444237, -11.949604185881125],
              [-12.932969840117817, -11.951204170602953],
              [-12.93107003090981, -11.954566346853008],
              [-12.928118481205486, -11.954718113544567],
              [-12.92473219160302, -11.95322037576165],
              [-12.924143232008166, -11.952160603860772],
              [-12.924020301984909, -11.950270012697137],
              [-12.922365380917002, -11.950605885915284],
              [-12.921954718509918, -11.949975815316806],
              [-12.920072017868673, -11.949446384237154],
              [-12.917704575732717, -11.950234583956892],
              [-12.918320327012935, -11.95273429503982],
              [-12.915850625466447, -11.953957841258894],
              [-12.916154083129243, -11.955835568482714],
              [-12.913179392176449, -11.954817415641802],
              [-12.91400718454938, -11.952157477559407],
              [-12.915102479808814, -11.950031552346058],
              [-12.913464928307569, -11.949015349633038],
              [-12.91401263378245, -11.947447083098405],
              [-12.911673185401996, -11.944617302079727],
              [-12.912110719059827, -11.943653760868447],
              [-12.911847370481452, -11.941666423673196],
              [-12.90985888062176, -11.941296942130988],
              [-12.908546396486408, -11.94223861313937],
              [-12.907860056786365, -11.940380774551382],
              [-12.905862511118253, -11.939316976437667],
              [-12.905243404955787, -11.937629351492522],
              [-12.905406762211044, -11.936155094368795],
              [-12.90436336397865, -11.93388118173118],
              [-12.903004909493038, -11.933154307933505],
              [-12.901470969782777, -11.934366066235224],
              [-12.900763623279623, -11.933364015496606],
              [-12.900816847421716, -11.929978230751823],
              [-12.900133907090465, -11.927184295959144],
              [-12.89899897241195, -11.926827968725426],
              [-12.897951283541076, -11.925218263457984],
              [-12.895757279552146, -11.927661816718272],
              [-12.89469658447239, -11.927452853319384],
              [-12.894561261648699, -11.925829159011455],
              [-12.892072016059354, -11.923733338897145],
              [-12.889616715269472, -11.923547940654164],
              [-12.888838182537095, -11.925258907055925],
              [-12.888986611062776, -11.926986538547064],
              [-12.890652773715207, -11.926980069840797],
              [-12.890328899571676, -11.928474685275676],
              [-12.888956729785484, -11.92922158034105],
              [-12.889047052475382, -11.930757134060213],
              [-12.88852572913388, -11.932382965434092],
              [-12.887347533966935, -11.93178885021849],
              [-12.885946620216401, -11.9323288722579],
              [-12.884678444664932, -11.93392544038593],
              [-12.88493943303076, -11.934976018994783],
              [-12.887618087417396, -11.933385454502279],
              [-12.887780676183988, -11.934501295009596],
              [-12.884487983025574, -11.937836027141824],
              [-12.884367865834724, -11.940042334749178],
              [-12.883458819707082, -11.941119186393703],
              [-12.885384976416459, -11.941743176730427],
              [-12.884684779286266, -11.943087747622126],
              [-12.882686779800325, -11.943600543522502],
              [-12.883312271020884, -11.945984660524193],
              [-12.881836443106293, -11.945586520805254],
              [-12.880166996452903, -11.947890068031947],
              [-12.878339900219338, -11.947842610438656],
              [-12.877370646324179, -11.950308435581025],
              [-12.878742650413646, -11.952080565629629],
              [-12.877532831222073, -11.952933509938296],
              [-12.875516049987123, -11.958805378501797],
              [-12.875971103239344, -11.96167875089601],
              [-12.875450797501937, -11.962295019855578],
              [-12.874678471234226, -11.965423606582565],
              [-12.873048962880915, -11.966531931796625],
              [-12.87193684390006, -11.969547039588322],
              [-12.872645415045719, -11.970552957430531],
              [-12.871613839428669, -11.972333689041188],
              [-12.871396725429856, -11.973597278299367],
              [-12.869590918230491, -11.975563181857341],
              [-12.869850728039193, -11.976838974399499],
              [-12.869097933024948, -11.978689972728326],
              [-12.871024340516545, -11.979115743388633],
              [-12.873117095316784, -11.977988415912868],
              [-12.87616647342815, -11.977306486095102],
              [-12.878413974478136, -11.975735795223004],
              [-12.880828881951572, -11.975632099164427],
              [-12.881730358516288, -11.973064981070204],
              [-12.881417521562298, -11.971722962787434],
              [-12.882098862656283, -11.9708634758116],
              [-12.883392251729962, -11.972510312906806],
              [-12.884810894154537, -11.972071425047192],
              [-12.88697824616203, -11.974184195547624],
              [-12.883073809895748, -11.979256418633872],
              [-12.882296952051396, -11.981470405149796],
              [-12.88062900025581, -11.98175174074996],
              [-12.88044382982506, -11.980476689981941],
              [-12.875185471952362, -11.980961664653885],
              [-12.873285614911198, -11.981684363892246],
              [-12.871556055187744, -11.983578422507344],
              [-12.8701160140163, -11.982920663955063],
              [-12.86852341804163, -11.983919728293696],
              [-12.867167925344027, -11.983884215887713],
              [-12.86582874264251, -11.986752522467476],
              [-12.86296542727006, -11.988191192013943],
              [-12.861810010339829, -11.990031892309437],
              [-12.860831060801049, -11.992378790715758],
              [-12.860219423423908, -11.992891593793884],
              [-12.859835542930519, -11.994844592915593],
              [-12.857614426922456, -11.997765250035194],
              [-12.857778252394848, -11.999531782976351],
              [-12.856710936030405, -12.002272244497552],
              [-12.857712558409917, -12.003750920356914],
              [-12.857315594987995, -12.00473352146342],
              [-12.858474470166568, -12.005694524542777],
              [-12.862218430991046, -12.006880765246642],
              [-12.862676432972744, -12.008176089139681],
              [-12.865267276742138, -12.007807427123733],
              [-12.865734034334537, -12.009006318438246],
              [-12.86333587243975, -12.009836610112501],
              [-12.86249385959414, -12.010570659859443],
              [-12.862310276674563, -12.013113921044308],
              [-12.865145492544691, -12.013496694374014],
              [-12.864884679112107, -12.014599946218778],
              [-12.863603093402096, -12.01607977309115],
              [-12.863332333117773, -12.01742826645122],
              [-12.861748683826661, -12.017094031474604],
              [-12.860073235086448, -12.01839198134543],
              [-12.858598446474895, -12.020924436684158],
              [-12.858638197602904, -12.023122854350529],
              [-12.857892181688062, -12.02408850163731],
              [-12.858737786245594, -12.026235470262248],
              [-12.85856473932543, -12.027667385553265],
              [-12.859616721220315, -12.028145216867923],
              [-12.859587976205885, -12.032059929622434],
              [-12.858368530921135, -12.03321527767594],
              [-12.85781300609045, -12.035736726720307],
              [-12.856781266050492, -12.037949354624082],
              [-12.85729242826521, -12.038593308885902],
              [-12.860357852933419, -12.037685112085464],
              [-12.86258834420838, -12.038284639184914],
              [-12.86578210546206, -12.037368939754893],
              [-12.869042092517578, -12.039381142360531],
              [-12.870276003232803, -12.039124059102033],
              [-12.872255591604619, -12.03971267233399],
              [-12.87368429321073, -12.042674823876066],
              [-12.871287466139638, -12.042841242486585],
              [-12.869784955763372, -12.044300384763895],
              [-12.871121088286733, -12.045567698981207],
              [-12.8732399064726, -12.04503474046918],
              [-12.874567255807905, -12.04647259351749],
              [-12.875829696549527, -12.046497448463699],
              [-12.87657169300668, -12.044957117561275],
              [-12.8843410357828, -12.047453271105056],
              [-12.885967612401007, -12.047598724959382],
              [-12.8864144560826, -12.046754733021283],
              [-12.886106066559956, -12.045162037888389],
              [-12.886880874095983, -12.043086935321062],
              [-12.889158257587747, -12.043548734903887],
              [-12.890654271159745, -12.044941134196339],
              [-12.89368248997571, -12.044560332624206],
              [-12.896272586078123, -12.038872544951476],
              [-12.898732968980434, -12.039096453357857],
              [-12.898464392470032, -12.040743453129084],
              [-12.90128941856876, -12.043568894708786],
              [-12.903010255167848, -12.042999760945598],
              [-12.904267185038325, -12.041135734520108],
              [-12.908365852061877, -12.041902218363363],
              [-12.908876944080312, -12.042914945569947],
              [-12.908962990455505, -12.0467628243414],
              [-12.909760586021429, -12.04826788339917],
              [-12.913068908104702, -12.049414506611459],
              [-12.91448599764854, -12.0486937943962],
              [-12.916352749951072, -12.049312275206237],
              [-12.91839305411738, -12.04854984518568],
              [-12.91818338142501, -12.044612516591435],
              [-12.919253133468054, -12.043281177830051],
              [-12.920113333167038, -12.041236272839498],
              [-12.921665881363422, -12.040560721097687],
              [-12.930134774534856, -12.042023627206387],
              [-12.932627838611726, -12.041410325429869],
              [-12.93331656083802, -12.040002754619406],
              [-12.932598593676007, -12.037091140286888],
              [-12.932926244129437, -12.034822015494516],
              [-12.935308672168642, -12.031004078104516],
              [-12.938169227785, -12.03298796244294],
              [-12.939480670747741, -12.035500150357448],
              [-12.941454113638102, -12.035358960660085],
              [-12.94283872468438, -12.034280635362213],
              [-12.946740032414999, -12.033685375296425],
              [-12.947996471876918, -12.034742167181696],
              [-12.951619109750983, -12.036132399815532],
              [-12.956859222249035, -12.040773837639321],
              [-12.960089797112664, -12.04183416575466],
              [-12.961594909261258, -12.04025000762894],
              [-12.960962282636784, -12.037667825061266],
              [-12.954281730940579, -12.033099019414683],
              [-12.95392191210096, -12.031348453502215],
              [-12.955213759892354, -12.030239873496424],
              [-12.956204066915738, -12.028389085983324],
              [-12.956048622647401, -12.023838122157155],
              [-12.954132554501344, -12.020439261940849],
              [-12.949218249935194, -12.021639171182473],
              [-12.946321752541689, -12.02197059443495],
              [-12.946544401095142, -12.018829248530468],
              [-12.94543794289103, -12.018810710257698],
              [-12.94367620826765, -12.019811890471503],
              [-12.942558756865079, -12.01865172618712],
              [-12.937509694143074, -12.01891354648305],
              [-12.936044018564319, -12.017736571338311],
              [-12.935793659017314, -12.015971701344826],
              [-12.934813805649297, -12.01470793295581],
              [-12.93313472701335, -12.01400391156854],
              [-12.931691312788463, -12.011448489232047],
              [-12.932680720681995, -12.010490062637432],
              [-12.936711576964099, -12.01038981006663],
              [-12.937731147468783, -12.009342494026015],
              [-12.938044186891874, -12.006973956258987],
              [-12.940813390397604, -12.003935131164349],
              [-12.942450188704317, -12.00358629814457],
              [-12.952169548668383, -12.003682284456556],
              [-12.95342743094526, -12.003257193142625],
              [-12.954390770520588, -12.000315188661551],
              [-12.955678240051505, -11.9999492344198],
              [-12.957850366565886, -11.997307597439162],
              [-12.96022346964089, -11.998040132863464],
              [-12.961384490635545, -11.99936032898382],
              [-12.96205375080719, -11.998148951078235],
              [-12.963691458011363, -11.996762904488634],
              [-12.965129810889385, -11.99624908118266],
              [-12.966554598095799, -11.995039810550537],
              [-12.96774601293179, -11.996418551107967],
              [-12.96662115909021, -11.998664037375743],
              [-12.968238759792085, -11.999097158469034],
              [-12.970402348191687, -11.998821117397618],
              [-12.969549772957857, -12.001304500933871],
              [-12.971303275396838, -12.002077845947241],
              [-12.973237002911603, -12.003502163231241],
              [-12.977019080502629, -12.003804995456717],
              [-12.979501732087275, -12.002595956200253],
              [-12.979352969700365, -12.000968535404615],
              [-12.982077989608062, -11.999197521309435],
              [-12.982623854073793, -11.998044960498333],
              [-12.980843115786346, -11.995587473975009],
              [-12.980890231007802, -11.994419458039438],
              [-12.982374668473623, -11.992440853889592],
              [-12.98560753925812, -11.993894107220362],
              [-12.988887442041923, -11.993883248687446],
              [-12.99024852049569, -11.992849987598573],
              [-12.992833230127983, -11.992216742192715],
              [-12.99700522715775, -11.98914601423914],
              [-12.998199456098689, -11.987713416615014],
              [-13.000419773858326, -11.987699649366078],
              [-13.003123650805055, -11.985233662199027],
              [-13.004392686845687, -11.980922015263673],
              [-13.00401569063442, -11.979666757315535],
              [-13.00486143766466, -11.97851532900113],
              [-13.00465055965628, -11.976625946012614],
              [-13.00371628683728, -11.974057009404753],
              [-13.001814894888717, -11.974469370480582],
              [-12.99828434086876, -11.973905942706002],
              [-12.998044104549614, -11.972695606060306],
              [-12.99991864140582, -11.968240301334408],
              [-13.001667762122006, -11.969008947352476],
              [-13.003945080231189, -11.96896618583742],
              [-13.005635837040439, -11.96607540251027],
              [-13.006013471830629, -11.964821571650964],
              [-13.005307153774865, -11.961296235254272],
              [-13.001722416796307, -11.958403324063678],
              [-13.000459471534981, -11.955777690640172],
              [-13.00070498658055, -11.952269097877394],
              [-13.003854790334412, -11.951137449409055],
              [-13.005377281485073, -11.949915700925986],
              [-13.004323872913305, -11.949030499289492],
              [-13.003588694003616, -11.94677527172633],
              [-13.003546683766023, -11.944256048162508],
              [-13.00464758459616, -11.942651575785808],
              [-13.003173904130655, -11.941530520424864],
              [-13.003808121283027, -11.940117038971756],
              [-13.001988851876852, -11.938833385912156],
              [-13.001403348201833, -11.93790505763831],
              [-13.00217327367818, -11.93638904693153],
              [-13.000942151057957, -11.934856010524237],
              [-13.002705635608594, -11.93292994216635],
              [-13.004042051701605, -11.93444824410859],
              [-13.005289699248957, -11.935053450020272],
              [-13.00555878095272, -11.936467042323597],
              [-13.007694064372279, -11.937411682063564],
              [-13.008795059858388, -11.935071798765529],
              [-13.008994070478375, -11.932142676348953],
              [-13.010123316457308, -11.931039870923586],
              [-13.012482978853459, -11.93235177597839],
              [-13.013653078300166, -11.935973497086131],
              [-13.013650757524333, -11.939065069884357],
              [-13.014715052371303, -11.946679573970155],
              [-13.01435326811152, -11.947740198325219],
              [-13.014321019414217, -11.953575082906307],
              [-13.0146523865762, -11.954370888532692],
              [-13.013958400373536, -11.959352945423545],
              [-13.015887194835468, -11.959441258199984],
              [-13.017212820248787, -11.956286721634171],
              [-13.017122329039735, -11.955520510873507],
              [-13.018492929947648, -11.953855053281996],
              [-13.019275944682175, -11.951556178774643],
              [-13.017138167121276, -11.949287330688541],
              [-13.019291029429432, -11.948270856401216],
              [-13.020104020537055, -11.945884550286992],
              [-13.0193517926172, -11.943823048221939],
              [-13.020947181528825, -11.940612815701247],
              [-13.020677084146532, -11.9372856446974],
              [-13.02024125150489, -11.93576968495078],
              [-13.020678680044295, -11.93257601305277],
              [-13.020093512981564, -11.92944191696413],
              [-13.020034542742584, -11.927264462330546],
              [-13.019419132040497, -11.92613144956371],
              [-13.019750772877691, -11.924425247204706],
              [-13.01778334726811, -11.922850578934327],
              [-13.018537533076309, -11.919615764172168],
              [-13.021677965307022, -11.918338129556336],
              [-13.022896371267713, -11.91564820032762],
              [-13.02376801243161, -11.914561025362561],
              [-13.025765992477117, -11.913106431413988],
              [-13.027132839095636, -11.911445969735116],
              [-13.028798902608248, -11.911696240716322],
              [-13.031321113712083, -11.910021126124454],
              [-13.031411259270731, -11.909022133498793],
              [-13.034712872712888, -11.90681803942614],
              [-13.035117905076737, -11.905922087940102],
              [-13.037128239667668, -11.90530457907049],
              [-13.038103092382187, -11.90390933384749],
              [-13.039917619150822, -11.90254280241238],
              [-13.043786669310856, -11.90233455455999],
              [-13.043997420735607, -11.904213691193261],
              [-13.042798078591561, -11.905095647375052],
              [-13.041974109283665, -11.907078464319556],
              [-13.038449310667065, -11.909357429665864],
              [-13.03715897153363, -11.910651011885161],
              [-13.036483944869328, -11.912046780392597],
              [-13.033242010753092, -11.915545372160535],
              [-13.030554442314774, -11.916677772854914],
              [-13.028196130559275, -11.920367773787298],
              [-13.027309022311409, -11.926205825675522],
              [-13.027624523989585, -11.928956461544567],
              [-13.029353060352621, -11.929323409353369],
              [-13.029894295104105, -11.930382379430485],
              [-13.029534046974378, -11.932471746944751],
              [-13.031444307186735, -11.934515642354288],
              [-13.03254108235742, -11.933352660779923],
              [-13.035931236573274, -11.933842722693633],
              [-13.037295283605651, -11.933416787944273],
              [-13.040219287615699, -11.933491143511802],
              [-13.042440649746164, -11.932166435665598],
              [-13.043795218009567, -11.932998134905828],
              [-13.046682286464474, -11.93152668384554],
              [-13.048592699293266, -11.93109087749092],
              [-13.055059023009889, -11.92807008899314],
              [-13.058662394664536, -11.927620670464018],
              [-13.061337227155212, -11.92829005866382],
              [-13.062139722900003, -11.924878190036676],
              [-13.06359397747768, -11.924125117157395],
              [-13.065171606574769, -11.924635081673772],
              [-13.066008480680878, -11.923192751774858],
              [-13.068230329735014, -11.923274231331517],
              [-13.069493856035756, -11.924269482274891],
              [-13.069077696054306, -11.925651873828023],
              [-13.06768530663099, -11.92696395855857],
              [-13.066364157368726, -11.927026747719149],
              [-13.065530142712356, -11.929498381961917],
              [-13.063850104752277, -11.930179500613917],
              [-13.062607160327753, -11.931638415247733],
              [-13.060458945780733, -11.93148252471588],
              [-13.05725487785026, -11.932525459749325],
              [-13.054430941080707, -11.932737714212806],
              [-13.053222260227521, -11.933646569091062],
              [-13.052369275369212, -11.935428217130585],
              [-13.050828922850217, -11.935762663575643],
              [-13.047678090080844, -11.937134698054146],
              [-13.045904332484735, -11.938837382532272],
              [-13.044694375149293, -11.939017577415456],
              [-13.043494375452179, -11.937533121692626],
              [-13.040271110196514, -11.936699250902327],
              [-13.036108989749879, -11.93951514264322],
              [-13.033928432161533, -11.93973806664121],
              [-13.034161283199998, -11.942219170924488],
              [-13.034841118488627, -11.943516677632447],
              [-13.033837500042551, -11.945698932354816],
              [-13.034100877359501, -11.946762130901927],
              [-13.035564943605435, -11.94640317791474],
              [-13.038302252155681, -11.944740671664357],
              [-13.040363258528027, -11.94747251704477],
              [-13.037892011507125, -11.950022473084818],
              [-13.036723657796438, -11.949263934625757],
              [-13.03546238759459, -11.949854931124051],
              [-13.035400204218515, -11.95139245835185],
              [-13.034256879748312, -11.952531207757092],
              [-13.033950122392854, -11.955887566095239],
              [-13.031820819965393, -11.954613136504562],
              [-13.029622127700051, -11.954924404145322],
              [-13.029201557589248, -11.956162536959532],
              [-13.029579678983469, -11.957856584407486],
              [-13.02937024803113, -11.959359968507872],
              [-13.028548091918775, -11.960580116243444],
              [-13.027097102691231, -11.961027844591953],
              [-13.026766748888672, -11.962295607492354],
              [-13.024267391751783, -11.96477482573332],
              [-13.023787271165837, -11.967517673143314],
              [-13.022704517602143, -11.970999376341473],
              [-13.022752049358061, -11.973669363828888],
              [-13.023536912653551, -11.974465352856566],
              [-13.022619085053874, -11.976723621116795],
              [-13.024040903167391, -11.980234569597156],
              [-13.024946366794175, -11.98052866644028],
              [-13.025832985086238, -11.97762029530656],
              [-13.026963861632904, -11.97739768896026],
              [-13.02799190794983, -11.979108029844369],
              [-13.027767537740651, -11.980510250096733],
              [-13.029065730932862, -11.98098055827882],
              [-13.029806710806746, -11.982056693483441],
              [-13.031493797598477, -11.980489736568035],
              [-13.032837041891602, -11.980974631083766],
              [-13.03280938200725, -11.982243569123131],
              [-13.030823285653925, -11.985435261022138],
              [-13.030435435996399, -11.9879157647907],
              [-13.03155303621584, -11.988327376269305],
              [-13.032771428149928, -11.986214145572216],
              [-13.034174662531706, -11.986078694667409],
              [-13.036402308197673, -11.983505966980996],
              [-13.03887603978304, -11.983323630419019],
              [-13.039983315680841, -11.985844473518865],
              [-13.041278717265321, -11.984985462747103],
              [-13.04313377034513, -11.98484817242216],
              [-13.043995684173206, -11.985568807460698],
              [-13.047101459444116, -11.98499969296516],
              [-13.04910323068359, -11.983533207408366],
              [-13.050444123024613, -11.983130998392006],
              [-13.053131255104967, -11.983948492176212],
              [-13.055105213813773, -11.983455129647707],
              [-13.057881732261182, -11.984006288086698],
              [-13.061841599546074, -11.982531397127811],
              [-13.063207966131637, -11.981154489639563],
              [-13.063352353421584, -11.979531730762229],
              [-13.062231726607603, -11.978238517611455],
              [-13.062497215327388, -11.976704046289946],
              [-13.064165717397401, -11.975621577781808],
              [-13.06310632962738, -11.974446406127436],
              [-13.061778855203881, -11.96989655184069],
              [-13.06255019839992, -11.966563677673284],
              [-13.062634734567599, -11.964972134664976],
              [-13.063348934988547, -11.962553786339805],
              [-13.061989594396145, -11.961232965911943],
              [-13.063220016704681, -11.960109167147186],
              [-13.067251143419451, -11.959447057193163],
              [-13.068719523231398, -11.957762889088311],
              [-13.070318140803046, -11.954797434664671],
              [-13.068968310479129, -11.951814407237984],
              [-13.069896755763278, -11.9506925281046],
              [-13.071900891126717, -11.95172978747034],
              [-13.076841137691448, -11.953564209714902],
              [-13.078862187150243, -11.951421557123822],
              [-13.08090573665187, -11.951147792538796],
              [-13.082395852745748, -11.951479309507006],
              [-13.083287666385715, -11.949268459787437],
              [-13.082410021352757, -11.94800722710737],
              [-13.078971391339461, -11.94886116165778],
              [-13.077958602765042, -11.947556069046152],
              [-13.077996336575005, -11.94580529997087],
              [-13.077465859845832, -11.944704170325211],
              [-13.078677543101985, -11.943331295175613],
              [-13.076958591093186, -11.94189714922014],
              [-13.076772436522347, -11.940368354760546],
              [-13.077500798363687, -11.938351086149613],
              [-13.07944594465695, -11.936431844477298],
              [-13.08195846081467, -11.937435737774624],
              [-13.082223157591399, -11.939625209276059],
              [-13.084791521846316, -11.93956982830385],
              [-13.087041986930307, -11.93897141685371],
              [-13.088575740220191, -11.939317077678272],
              [-13.09017136005415, -11.936942543303346],
              [-13.08966403191517, -11.93443193401077],
              [-13.087778962596712, -11.932603816731184],
              [-13.088164110770208, -11.931456004630801],
              [-13.089542110986612, -11.930773777786772],
              [-13.090817571564438, -11.927418183442526],
              [-13.09241173972933, -11.928174395874851],
              [-13.095071230773554, -11.928880986483545],
              [-13.097109923858453, -11.928459463618205],
              [-13.097681919411286, -11.925857198129906],
              [-13.099152689623663, -11.925937571423999],
              [-13.100023709584654, -11.92900217279953],
              [-13.10190761454236, -11.930534310600638],
              [-13.102712732465196, -11.932307155700883],
              [-13.104315313056247, -11.934383969791755],
              [-13.105649636182667, -11.934126391861996],
              [-13.107293553704942, -11.932941398004992],
              [-13.109703504428657, -11.93439582286931],
              [-13.111204257584916, -11.931992252694595],
              [-13.11265211420845, -11.930793559995786],
              [-13.113287282367954, -11.92918900974384],
              [-13.113451051874828, -11.926604056172886],
              [-13.112238763921924, -11.924556314364075],
              [-13.107545589465659, -11.922030063202616],
              [-13.106293732193073, -11.920701364283083],
              [-13.108264076388572, -11.919134453113506],
              [-13.112047003456338, -11.920051308424195],
              [-13.112366957127142, -11.920885868542918],
              [-13.11458862010116, -11.921400779138391],
              [-13.116197237581337, -11.919717479140191],
              [-13.115834464717024, -11.916770614750126],
              [-13.117909558491927, -11.915481287007927],
              [-13.120294043133438, -11.915803226817776],
              [-13.121468905534567, -11.916763638743578],
              [-13.121860299927278, -11.919328544096087],
              [-13.120920810710238, -11.92005361901019],
              [-13.120674749832588, -11.921390788159664],
              [-13.122563584004347, -11.921407256980778],
              [-13.12701067845253, -11.920774691860428],
              [-13.128227272161755, -11.921162088129822],
              [-13.129954549785182, -11.923761198235075],
              [-13.126908583715043, -11.925426829825394],
              [-13.125506811895738, -11.926493859642402],
              [-13.122219960932476, -11.926032522393925],
              [-13.120936376434095, -11.926892619418835],
              [-13.12018965148762, -11.929584295942043],
              [-13.119164205566983, -11.931015490603512],
              [-13.122839682859317, -11.931063486699736],
              [-13.12359889598736, -11.932379485383523],
              [-13.121230880106394, -11.934848600887202],
              [-13.120006786694569, -11.937926912562268],
              [-13.117746995196876, -11.938868238275374],
              [-13.117140803695198, -11.940238450781141],
              [-13.119463556773395, -11.941809165095544],
              [-13.120451277425566, -11.943492079510813],
              [-13.119514632256307, -11.944806782060004],
              [-13.116951996390036, -11.94335510370751],
              [-13.116479849771073, -11.94237360755415],
              [-13.114538930373232, -11.94175484782009],
              [-13.112430800185088, -11.945384207083547],
              [-13.109204321045253, -11.948169153951639],
              [-13.108435153060956, -11.950026478148786],
              [-13.11168738227975, -11.95106390870568],
              [-13.113858778828362, -11.952196215189856],
              [-13.114440563029584, -11.953751009084916],
              [-13.11311206818725, -11.955039700781786],
              [-13.109928432944782, -11.953193471206948],
              [-13.10878112301789, -11.95468627043834],
              [-13.110321408144248, -11.955764618660911],
              [-13.11141403037233, -11.957287143948907],
              [-13.110169325994173, -11.95772207727157],
              [-13.10841950269202, -11.956821560923661],
              [-13.105914855795668, -11.957735341461712],
              [-13.104359919939915, -11.959098936062219],
              [-13.103438303741683, -11.958413134824442],
              [-13.101754056006335, -11.95836447837938],
              [-13.101261689102115, -11.956543123161346],
              [-13.099919929476565, -11.955918344578302],
              [-13.09640259537674, -11.958661119159384],
              [-13.09483243012265, -11.96021546715209],
              [-13.09507543602339, -11.96323174795557],
              [-13.093563031723786, -11.964462249918322],
              [-13.091296437158094, -11.968096950925517],
              [-13.09126802028046, -11.971028105233447],
              [-13.090463033469648, -11.972387845510621],
              [-13.086341117874454, -11.973029225593676],
              [-13.085024358844931, -11.97456829633316],
              [-13.081434671720473, -11.97645849907046],
              [-13.08061490256886, -11.978157332346065],
              [-13.084454993413988, -11.977916493625074],
              [-13.088139072791577, -11.976791094146531],
              [-13.089202975736992, -11.975856875689761],
              [-13.090497386468462, -11.97573161746119],
              [-13.09271420418359, -11.973744735060844],
              [-13.093510513968566, -11.973460375308134],
              [-13.095582815931182, -11.97505377278063],
              [-13.097254702574794, -11.975146490580824],
              [-13.099127967866185, -11.976136745866503],
              [-13.099767499473273, -11.977222896007914],
              [-13.099039949075856, -11.978803844798303],
              [-13.096256293135818, -11.97918965644742],
              [-13.094101582441512, -11.979040718237375],
              [-13.09260724058334, -11.980965510914487],
              [-13.088874124997691, -11.981488284237685],
              [-13.08650245592441, -11.983034841645866],
              [-13.086286296570197, -11.984731228667567],
              [-13.087393301404775, -11.985919233750606],
              [-13.084277883708667, -11.986688831813087],
              [-13.08260981700651, -11.987626916183489],
              [-13.082122949835934, -11.989532043008682],
              [-13.080612944304965, -11.98909758879816],
              [-13.079574776087384, -11.98950147773517],
              [-13.079226531460789, -11.992040370361998],
              [-13.07724898165781, -11.991652227442799],
              [-13.07599094696474, -11.990463638621135],
              [-13.074633057891148, -11.990322656802396],
              [-13.072407293229677, -11.991572821431527],
              [-13.071648373783038, -11.993686498515128],
              [-13.072091312389041, -11.994761395332974],
              [-13.071059665339899, -11.996640906004398],
              [-13.071414118221611, -11.998129808900394],
              [-13.071036533053984, -12.001054504225214],
              [-13.069407556489942, -12.001268849223855],
              [-13.069324906632216, -12.002863948647736],
              [-13.068158788606885, -12.005143689275215],
              [-13.066785726782705, -12.005341971600695],
              [-13.065265256973948, -12.006279332415913],
              [-13.065230722492496, -12.008480376300787],
              [-13.062739556390893, -12.008713328602548],
              [-13.060541680076618, -12.010318456921375],
              [-13.059271307581751, -12.010058069788231],
              [-13.057838373048389, -12.010581257658437],
              [-13.055985763672494, -12.01190374109757],
              [-13.05513406795348, -12.014138870636074],
              [-13.05649482829878, -12.014281201596733],
              [-13.058964206888733, -12.015615768187088],
              [-13.059227311259294, -12.016930265794427],
              [-13.058018754374174, -12.017083256691814],
              [-13.05347846315558, -12.01577134267903],
              [-13.051847980122725, -12.016280327643022],
              [-13.052489902040968, -12.017963091413888],
              [-13.053247098806562, -12.018255957045607],
              [-13.054479829622155, -12.020128790497681],
              [-13.053521406403066, -12.022232556787355],
              [-13.051934411900103, -12.022460623642765],
              [-13.048856031696204, -12.024128898631798],
              [-13.047272926657875, -12.025392286524047],
              [-13.046362885235768, -12.024803909432844],
              [-13.043476192657387, -12.025598278068964],
              [-13.040535898511111, -12.024158181621651],
              [-13.039481532956144, -12.02549298076223],
              [-13.038158849867706, -12.028071763191038],
              [-13.03590616140539, -12.028774168409608],
              [-13.034428123561685, -12.030465824069971],
              [-13.029516197239936, -12.033218079730162],
              [-13.028112903296407, -12.034983951116365],
              [-13.02931720958964, -12.0375425742298],
              [-13.030727830030148, -12.038146054401835],
              [-13.032307502708553, -12.039444627313513],
              [-13.03201135369409, -12.04151920416982],
              [-13.02436248647496, -12.037125502683978],
              [-13.022378860639655, -12.037470684273883],
              [-13.018140262199923, -12.039109230982978],
              [-13.015826064927618, -12.041024728968901],
              [-13.015692833132048, -12.042462470527893],
              [-13.01191882782662, -12.042720901775539],
              [-13.011421795036698, -12.044337146359446],
              [-13.01003106229123, -12.046503352356927],
              [-13.009594082015896, -12.047942175903419],
              [-13.008171006832736, -12.049308296484806],
              [-13.008598448044184, -12.050730949179066],
              [-13.006520984679105, -12.051193783941603],
              [-13.004202386154677, -12.052665105532082],
              [-13.004037923194593, -12.054192978832521],
              [-13.001551332807995, -12.05556088223254],
              [-13.000020828688722, -12.057090671600832],
              [-13.000175106729703, -12.05872235744773],
              [-12.998901191654548, -12.05964388934744],
              [-13.000254038497317, -12.06057720927105],
              [-13.000271341666702, -12.06201690212101],
              [-12.998302906819264, -12.06558160469336],
              [-12.999611138318185, -12.066648774292695],
              [-12.998020069215848, -12.06910045991606],
              [-12.994707256349487, -12.068569628711035],
              [-12.993780898811256, -12.06891197443176],
              [-12.989525464270814, -12.068172487953344],
              [-12.988767095330344, -12.06950947213714],
              [-12.991338447612609, -12.072077104079561],
              [-12.990535241784807, -12.073845501046735],
              [-12.991388729142633, -12.07565737205975],
              [-12.988519565819512, -12.07888375112708],
              [-12.989402801321608, -12.079863878736909],
              [-12.992565660819464, -12.079801753007441],
              [-12.9941920110461, -12.0793393108684],
              [-12.994589992897023, -12.080854322323496],
              [-12.992295324242411, -12.081941998637431],
              [-12.986288655555539, -12.082913127063799],
              [-12.983536028502206, -12.083702696501025],
              [-12.98139154071153, -12.084640257883738],
              [-12.980769375481225, -12.086320526104725],
              [-12.980983469381268, -12.087480354297606],
              [-12.983344994645119, -12.089784150114976],
              [-12.984684100106536, -12.089723971239504],
              [-12.985716998849195, -12.088027917584043],
              [-12.987466913920667, -12.088100972051432],
              [-12.988930611736114, -12.08991373448969],
              [-12.990346642063408, -12.090224362308911],
              [-12.990562473607575, -12.091830104141406],
              [-12.99284389942765, -12.09108401290922],
              [-12.995310967726285, -12.091883611578975],
              [-12.995686336284022, -12.089429629675802],
              [-12.997162042690597, -12.089412580153315],
              [-12.997377073794937, -12.090274316793781],
              [-13.000912793098294, -12.092557953053829],
              [-13.00048096955296, -12.090239653495926],
              [-12.99930629399771, -12.088918526508293],
              [-12.997554213084014, -12.08780622416641],
              [-12.996545782028168, -12.085697014469316],
              [-12.998095040304962, -12.084565004761783],
              [-13.000178271210128, -12.084398295576616],
              [-13.001308837900265, -12.086596055613702],
              [-13.003469987823971, -12.087097210897399],
              [-13.004539947924362, -12.089027620387132],
              [-13.00563663159674, -12.089530652584948],
              [-13.007003475433974, -12.088784198834551],
              [-13.007044126666651, -12.08701565501856],
              [-13.008261287129818, -12.087161501121752],
              [-13.010095601089438, -12.085180952719798],
              [-13.011359984891655, -12.085935573394972],
              [-13.011689451710973, -12.089159693321475],
              [-13.013807151899202, -12.090239040755591],
              [-13.015531811746772, -12.0918839067717],
              [-13.015800150209412, -12.090337590018256],
              [-13.017199121521232, -12.090244012069629],
              [-13.018745678631376, -12.088961307512285],
              [-13.019781013487608, -12.0893446435085],
              [-13.023272719327082, -12.08784751183352],
              [-13.022096768391561, -12.086529108395265],
              [-13.020075110225012, -12.086669135784655],
              [-13.019586842983184, -12.086165622200882],
              [-13.021253497844947, -12.084674743809957],
              [-13.024225977455881, -12.082912389090536],
              [-13.02511471906636, -12.080874620774258],
              [-13.02805516778567, -12.079052830407209],
              [-13.028839969253802, -12.077773186882787],
              [-13.028648309062511, -12.075487688565984],
              [-13.027672177964739, -12.074481478493201],
              [-13.027575790328184, -12.07311620597499],
              [-13.02878428027226, -12.071479489713715],
              [-13.030331941303652, -12.071236777649247],
              [-13.031936729112587, -12.07007361942779],
              [-13.032145994673984, -12.069301327753625],
              [-13.03571173949597, -12.068917115218957],
              [-13.036770967240036, -12.068171366400453],
              [-13.03676311082889, -12.066391363064723],
              [-13.038810234433507, -12.066012448913304],
              [-13.042120849200876, -12.06653282046296],
              [-13.044701100532295, -12.0666699928515],
              [-13.046563822896397, -12.0659348456877],
              [-13.048101573644892, -12.064059645723852],
              [-13.050860280584061, -12.063661086458008],
              [-13.052086359366818, -12.06316604032376],
              [-13.053671167429231, -12.061749898811327],
              [-13.054100672031366, -12.059864934797574],
              [-13.056477730040585, -12.059245370925527],
              [-13.058184281787382, -12.058065936198505],
              [-13.061689109817275, -12.058595766366741],
              [-13.060574638592163, -12.057253138699375],
              [-13.06156388193102, -12.055351377589728],
              [-13.061376411422119, -12.054404236705782],
              [-13.063691703865151, -12.053813732987631],
              [-13.066660221485321, -12.051116367775043],
              [-13.066592549324938, -12.049961711950537],
              [-13.067947567406074, -12.048621288069867],
              [-13.069527103826358, -12.049322928943173],
              [-13.070730311899814, -12.047983154283253],
              [-13.069967531784544, -12.047099373492326],
              [-13.070199844780777, -12.04549910152084],
              [-13.071164964134159, -12.044871719554774],
              [-13.070925434137932, -12.042874767060535],
              [-13.073122736344923, -12.043232112115946],
              [-13.074631268024945, -12.044747690589926],
              [-13.076227542341023, -12.043435179724566],
              [-13.075121838749215, -12.041014744208287],
              [-13.07509936933924, -12.039875663334046],
              [-13.07867796136788, -12.038655405883828],
              [-13.081358772031315, -12.036804025307582],
              [-13.081805489053801, -12.035765698506866],
              [-13.083326796087235, -12.034824098056227],
              [-13.085992103121525, -12.035280019068077],
              [-13.086010394999043, -12.033564119493704],
              [-13.08456889941477, -12.032908197503017],
              [-13.08500834416571, -12.030835043589892],
              [-13.088398185124895, -12.03122685902444],
              [-13.090101681053037, -12.032605084463304],
              [-13.090560380824071, -12.031226722617268],
              [-13.093171064946086, -12.03259844391921],
              [-13.093843030648816, -12.031484789873495],
              [-13.095543695961753, -12.030452424376191],
              [-13.097628025238167, -12.030230352772682],
              [-13.097075671335556, -12.02917014623243],
              [-13.100806294259023, -12.028832079088081],
              [-13.102992474769353, -12.026332729962581],
              [-13.105983415592178, -12.026250635215211],
              [-13.106391226602947, -12.024415200941037],
              [-13.104349388140106, -12.02224449511585],
              [-13.104642003492225, -12.021060508595752],
              [-13.105831793701544, -12.020652595765547],
              [-13.106819387965482, -12.017676334089076],
              [-13.109545565979538, -12.016872313981777],
              [-13.109918756963637, -12.01453667696324],
              [-13.109116359804428, -12.012417062101404],
              [-13.10803101076765, -12.010698350292861],
              [-13.10998042178438, -12.011022781520056],
              [-13.109496175315163, -12.009004363780175],
              [-13.111089606707527, -12.008283541118502],
              [-13.112962601271223, -12.008534462240032],
              [-13.112700210796508, -12.005998475698904],
              [-13.113436003672646, -12.005594162627217],
              [-13.113173723429796, -12.003058836718846],
              [-13.11396095519452, -12.001592166441558],
              [-13.117350302356423, -12.001196271041056],
              [-13.120442925791483, -12.001391901231436],
              [-13.124888362029896, -11.997800483415618],
              [-13.125143457480517, -11.995970369022556],
              [-13.128031585563354, -11.995414441559562],
              [-13.128735656718781, -11.99495132497184],
              [-13.126487803453303, -11.992966414985622],
              [-13.123748006389821, -11.993225564333333],
              [-13.122465611231549, -11.993015039408249],
              [-13.118825108217383, -11.99372313702101],
              [-13.117944274355308, -11.992904556854846],
              [-13.118935385036789, -11.99067093302052],
              [-13.119927338621705, -11.990397785423765],
              [-13.123938209041095, -11.990836350131772],
              [-13.12608586733795, -11.990096125655958],
              [-13.126335347876935, -11.989342341459935],
              [-13.128337244417423, -11.989192695759074],
              [-13.129188910589962, -11.988433731291954],
              [-13.132117789067992, -11.987597772555148],
              [-13.133974910692494, -11.986520371900628],
              [-13.134509089346768, -11.985661172288113],
              [-13.134963993810079, -11.982770345551483],
              [-13.135878399247542, -11.980759587532203],
              [-13.134277540815662, -11.978491682295292],
              [-13.132243002333228, -11.978141533760212],
              [-13.130490905201192, -11.977391009260243],
              [-13.12894619039217, -11.977978288436997],
              [-13.12628874762567, -11.976940313728456],
              [-13.125088466942714, -11.977391985761736],
              [-13.121534512761471, -11.977096428505826],
              [-13.11807486234998, -11.975459615628928],
              [-13.117174480658699, -11.975760758037675],
              [-13.114803829525163, -11.97476273407209],
              [-13.115008689501762, -11.97399540285748],
              [-13.118130255905427, -11.972882399690182],
              [-13.119649369926085, -11.972826768531508],
              [-13.123085139275151, -11.973476981679077],
              [-13.124338634502921, -11.974070565313422],
              [-13.127171528225215, -11.974577318560552],
              [-13.130506671849542, -11.974019458516315],
              [-13.13610124664413, -11.973882540547406],
              [-13.137468064805388, -11.972016213297081],
              [-13.1354412291242, -11.970738987917063],
              [-13.132569259615162, -11.967335569228517],
              [-13.132767936385836, -11.965980245202358],
              [-13.13459605629027, -11.965287920148281],
              [-13.136868081843227, -11.965518078883347],
              [-13.138127807712488, -11.963521373321802],
              [-13.140138695445268, -11.961518232890269],
              [-13.141994688535922, -11.960736839890439],
              [-13.144096654112662, -11.960570717892077],
              [-13.14366300470693, -11.959163137726431],
              [-13.140440503932426, -11.960000838186568],
              [-13.137326657769554, -11.959602004223749],
              [-13.13430372856141, -11.961039460328834],
              [-13.130903507936186, -11.96059745742151],
              [-13.130736065358995, -11.958539769466485],
              [-13.132272838513279, -11.95902709132608],
              [-13.135187612366177, -11.958973110793634],
              [-13.136354422860114, -11.95665472145408],
              [-13.137263939715039, -11.955867895994187],
              [-13.139862514104868, -11.955859877429665],
              [-13.140722423923055, -11.956278902898035],
              [-13.144183408191171, -11.95532169048368],
              [-13.144955367295863, -11.954344524488679],
              [-13.145758623289602, -11.950252213549946],
              [-13.14458417445766, -11.948220232675288],
              [-13.14562153041093, -11.94674207500613],
              [-13.143381345964102, -11.944617344716894],
              [-13.145390680333357, -11.94276359024794],
              [-13.14517047209602, -11.941620025197793],
              [-13.14609305300856, -11.940789526952669],
              [-13.147801826491252, -11.935620959045927],
              [-13.147788878561787, -11.934153393156118],
              [-13.14692405357137, -11.933001522417358],
              [-13.143988456180578, -11.931632453539704],
              [-13.141587222245555, -11.929554116430566],
              [-13.138678087449867, -11.929460592861231],
              [-13.138271544422457, -11.927380041303108],
              [-13.135715383005195, -11.92637316047591],
              [-13.13447449627405, -11.922905514449868],
              [-13.131810269563562, -11.921326447464093],
              [-13.13083956255624, -11.91974926248181],
              [-13.132362841988012, -11.919063523363752],
              [-13.13389470548115, -11.919550722838133],
              [-13.136078919887206, -11.921074198117381],
              [-13.141573068866004, -11.92418399742949],
              [-13.144528375088775, -11.924585025751027],
              [-13.148306641985597, -11.923100388171473],
              [-13.151026673439809, -11.924059245456995],
              [-13.152653305342515, -11.926670082855482],
              [-13.152011477844786, -11.928612411504533],
              [-13.152421248322417, -11.929180879736029],
              [-13.151690635564249, -11.932900136016688],
              [-13.151562677593992, -11.936908081776737],
              [-13.152114868135689, -11.93825361160159],
              [-13.151728044226365, -11.940180252536608],
              [-13.152013147256437, -11.943393243414544],
              [-13.15280361347431, -11.944472581976719],
              [-13.15447106664863, -11.94470650360365],
              [-13.154377491940277, -11.945897051575917],
              [-13.155685523447234, -11.946163420512445],
              [-13.157365107247754, -11.947571782486458],
              [-13.161336229656833, -11.948530703913704],
              [-13.162124513928397, -11.949315903853702],
              [-13.16298969817932, -11.95168645656535],
              [-13.164661138394385, -11.952212602016052],
              [-13.165097935607413, -11.953765083218281],
              [-13.166476223512833, -11.953515466822097],
              [-13.169592169610153, -11.950250800875988],
              [-13.170681216884322, -11.949666403432825],
              [-13.171521537877585, -11.948320966404026],
              [-13.174008563118601, -11.948029605364324],
              [-13.175316960137481, -11.94965960098505],
              [-13.177208324859711, -11.948448965630678],
              [-13.178050180649837, -11.948615664850545],
              [-13.178968769728199, -11.95022032614568],
              [-13.17912464412039, -11.952024822452506],
              [-13.178181993227499, -11.953533331719342],
              [-13.17945992219693, -11.953739121420087],
              [-13.18084536656784, -11.955441533466367],
              [-13.181162958601771, -11.956906601838028],
              [-13.186107464068236, -11.957479149729103],
              [-13.18681051878108, -11.956090314685039],
              [-13.189086366992546, -11.955680674967555],
              [-13.191359538966786, -11.953905314067805],
              [-13.191086424204341, -11.952454981238132],
              [-13.192574978432932, -11.951555728611655],
              [-13.193177830281343, -11.949405115764705],
              [-13.191998035234374, -11.94859757493198],
              [-13.192196450775432, -11.947685114789298],
              [-13.195097082768712, -11.947032669244189],
              [-13.196143585718639, -11.944437016013083],
              [-13.196854776853925, -11.943782573806326],
              [-13.196863018174636, -11.942080712945671],
              [-13.197855698767691, -11.941173318561294],
              [-13.197724965804067, -11.939136008537144],
              [-13.197174116809165, -11.938233496644829],
              [-13.19350311022255, -11.936988030257195],
              [-13.192017469130827, -11.93803293171511],
              [-13.189957943206634, -11.937485651249014],
              [-13.189093751918836, -11.936630525232566],
              [-13.188560892215353, -11.933395418346013],
              [-13.187074871476653, -11.931858420664401],
              [-13.187147888476375, -11.930420470592532],
              [-13.188340868771864, -11.929966753642459],
              [-13.191464365223709, -11.93318521668518],
              [-13.19280505147251, -11.932582422251281],
              [-13.196779870793302, -11.933047099355116],
              [-13.200101490316056, -11.928051288773474],
              [-13.199839605330236, -11.926266495444967],
              [-13.200555282253779, -11.924836226132523],
              [-13.201752341380232, -11.924821300339742],
              [-13.202004284087167, -11.923440968301742],
              [-13.20083614385036, -11.922151440107337],
              [-13.199249848734622, -11.922141572857338],
              [-13.198287411649627, -11.91931145427712],
              [-13.196195305309212, -11.918267262127719],
              [-13.194665170486495, -11.917934022126223],
              [-13.192004945628469, -11.918170195957497],
              [-13.189714092871247, -11.918035707941257],
              [-13.187838047952724, -11.917544582785393],
              [-13.187546252382122, -11.915555420789296],
              [-13.190021334153252, -11.914824263184858],
              [-13.192010771611061, -11.914815783708676],
              [-13.192106065494752, -11.912705708478905],
              [-13.190800125550911, -11.912296045698163],
              [-13.189237360671024, -11.9129732021839],
              [-13.187564401270897, -11.910502442084528],
              [-13.184247403197581, -11.908049595586235],
              [-13.1821137646193, -11.908497536750582],
              [-13.18045648952115, -11.907343814978283],
              [-13.17910921956446, -11.907211663548322],
              [-13.178161640323403, -11.908129508267578],
              [-13.176476224784727, -11.908571641657323],
              [-13.175633529808826, -11.91098263643277],
              [-13.173903664583024, -11.910048208373057],
              [-13.172926516718649, -11.91105405583351],
              [-13.173035778172435, -11.912986805635223],
              [-13.172230088358713, -11.914679788255084],
              [-13.171307630849322, -11.915216914576309],
              [-13.16983016822064, -11.917136846647901],
              [-13.169025116933058, -11.917467213880974],
              [-13.168756493754445, -11.919038233919565],
              [-13.170455488814287, -11.919768487578493],
              [-13.171197531312309, -11.922047643486362],
              [-13.170908435602879, -11.92307693767777],
              [-13.170844683355895, -11.927050872213597],
              [-13.169343076203802, -11.928136936310533],
              [-13.167702419155402, -11.927376373899268],
              [-13.168189120011903, -11.92514252340672],
              [-13.1680390002903, -11.923633966950769],
              [-13.166808841660481, -11.921930948325107],
              [-13.164645604424736, -11.92275855479592],
              [-13.163682179041313, -11.92070081915615],
              [-13.16276510923823, -11.920313773246976],
              [-13.161423046824561, -11.920913068621427],
              [-13.157143473280486, -11.924531457826037],
              [-13.15546522013426, -11.924488403500467],
              [-13.15283235160468, -11.923265753239944],
              [-13.15281670151344, -11.921505947695495],
              [-13.155121675281903, -11.921309143977242],
              [-13.156921200860207, -11.919929016198802],
              [-13.158435191453155, -11.916851337970588],
              [-13.157726255101954, -11.914629684170281],
              [-13.158100954634238, -11.91304371613043],
              [-13.160878205682453, -11.912314576781428],
              [-13.162800743870518, -11.911461126179116],
              [-13.163643827239065, -11.910413039693426],
              [-13.166993897492377, -11.90869602314746],
              [-13.168934532714408, -11.906729166502357],
              [-13.169472064918056, -11.905098443901114],
              [-13.171967721393559, -11.903404418831633],
              [-13.17322625273568, -11.902147583920732],
              [-13.166963073001883, -11.902311031642576],
              [-13.16578643663353, -11.901209483155702],
              [-13.164211805701612, -11.900711807275728],
              [-13.161822166012925, -11.899372419939915],
              [-13.162081598893502, -11.898286697423762],
              [-13.165123086515191, -11.89900508866288],
              [-13.168864288585628, -11.899408685030918],
              [-13.169706444751961, -11.898361202152945],
              [-13.167894810137028, -11.896475880792893],
              [-13.167742152604744, -11.894530804760125],
              [-13.165705783246844, -11.894081546755812],
              [-13.165024634943382, -11.893136590683627],
              [-13.165253340379683, -11.891993209192146],
              [-13.164330598004199, -11.890728646555498],
              [-13.163758490508654, -11.888553573180483],
              [-13.161882915927734, -11.887619474366588],
              [-13.159327644372496, -11.887539764740774],
              [-13.1570637151931, -11.88657869503195],
              [-13.155249198392449, -11.887559725076473],
              [-13.15382684830166, -11.887206119111486],
              [-13.153312815403064, -11.888307758970582],
              [-13.15066630250849, -11.889997668794187],
              [-13.149219199559733, -11.890316659512123],
              [-13.149993879149529, -11.886183826522597],
              [-13.14900866158907, -11.884362746072986],
              [-13.147054289985794, -11.88471437200634],
              [-13.145256060865226, -11.883996659511089],
              [-13.1454510215225, -11.882063968005978],
              [-13.146815890278132, -11.880795572639215],
              [-13.147846700834426, -11.880831496253375],
              [-13.149381654219793, -11.882340832894071],
              [-13.151009923923258, -11.882371778361815],
              [-13.152837963445545, -11.881201446518137],
              [-13.151619571478028, -11.880084932264431],
              [-13.149550441907834, -11.878989693171356],
              [-13.146637515481753, -11.876847670043663],
              [-13.147098758892293, -11.874562827782087],
              [-13.148223917013425, -11.873267881081919],
              [-13.146844011445687, -11.872342348057805],
              [-13.142754351538697, -11.876730224716933],
              [-13.139627098571811, -11.87583124825106],
              [-13.140038780391075, -11.874892426424617],
              [-13.13387691611058, -11.870148090901473],
              [-13.131309164111528, -11.869462705105128],
              [-13.131421374137304, -11.867406544968423],
              [-13.132083321197491, -11.865970545692912],
              [-13.13784381166755, -11.86639410011997],
              [-13.139271533489548, -11.865970105481995],
              [-13.140787797047746, -11.866281057188715],
              [-13.1419753989794, -11.865185887001353],
              [-13.14166377331717, -11.864290311220982],
              [-13.138475119672652, -11.861224849315938],
              [-13.13607600903305, -11.859757963840538],
              [-13.134533468244728, -11.85791384904059],
              [-13.130834154886918, -11.854071313377386],
              [-13.127569824598147, -11.853187124810495],
              [-13.12762812838006, -11.852030891416147],
              [-13.130544027284017, -11.851587349646662],
              [-13.134660719701827, -11.852657671689776],
              [-13.13533784686115, -11.853549112386249],
              [-13.13650376397388, -11.853120973938536],
              [-13.138913766063599, -11.855021852391193],
              [-13.139320554964225, -11.85611431145741],
              [-13.140572979630322, -11.856395867081387],
              [-13.14201575926575, -11.857685010574906],
              [-13.144925466851525, -11.858086280928893],
              [-13.147650887915184, -11.857863036447807],
              [-13.15184315659805, -11.857059236392995],
              [-13.152926803191521, -11.8573190249744],
              [-13.15605585206172, -11.85909112954162],
              [-13.157936820384835, -11.857455131425558],
              [-13.157152004993899, -11.854477014342997],
              [-13.157848962588673, -11.854018919313464],
              [-13.159571772359406, -11.854527163841059],
              [-13.160515075623737, -11.853452839284717],
              [-13.158968062853992, -11.852550446067013],
              [-13.15826341341765, -11.851443896450743],
              [-13.156677971778462, -11.852155707791388],
              [-13.155677809587589, -11.851073897850403],
              [-13.155988835840724, -11.849539487935226],
              [-13.157942559603931, -11.849306049035482],
              [-13.158634655935378, -11.848384399592751],
              [-13.15866855758759, -11.845698662061146],
              [-13.160094617186676, -11.839886024543905],
              [-13.159138165110715, -11.835006206400735],
              [-13.15819366036519, -11.834318387149878],
              [-13.157835459256827, -11.830726009822644],
              [-13.160160484361722, -11.826967853765435],
              [-13.160150408664766, -11.824874095840812],
              [-13.158965230231155, -11.822814359780882],
              [-13.15728468988547, -11.823637622379866],
              [-13.156566056754038, -11.823338948735998],
              [-13.156148619350988, -11.82132484619606],
              [-13.15856109077223, -11.819248177388662],
              [-13.158914873094155, -11.818117410307622],
              [-13.16070932656833, -11.816868566431902],
              [-13.16219759710743, -11.817897589788583],
              [-13.1620859971085, -11.818934968154979],
              [-13.160782249491628, -11.820951778256703],
              [-13.161123788591032, -11.822025675645925],
              [-13.164180975723678, -11.824297422727366],
              [-13.165170579084494, -11.827105577527337],
              [-13.165241265850662, -11.829695163266846],
              [-13.163511299283236, -11.832726012857563],
              [-13.163716191664115, -11.834545750484315],
              [-13.163056214238056, -11.835603521828512],
              [-13.163196949696218, -11.836963088969048],
              [-13.16470580641012, -11.837059947354026],
              [-13.166964567270215, -11.834840747993924],
              [-13.16706153888904, -11.832457926340593],
              [-13.168154436252353, -11.832368332837467],
              [-13.169300909997538, -11.830854443899224],
              [-13.170500808734111, -11.82556524020868],
              [-13.17057306919168, -11.822302894429908],
              [-13.169887522235825, -11.818813940474643],
              [-13.16867005869228, -11.816293898284785],
              [-13.169030435225343, -11.814450354980224],
              [-13.168745566485983, -11.81300030391557],
              [-13.170369637494003, -11.812262016314099],
              [-13.171793687645165, -11.813136225038733],
              [-13.174320258095522, -11.813921123502057],
              [-13.175296995209242, -11.813057765613472],
              [-13.178066574243324, -11.814164192855825],
              [-13.176303296889621, -11.817886999566674],
              [-13.1776696579267, -11.819474618747712],
              [-13.176131865837455, -11.820212725121037],
              [-13.173766624079926, -11.819595906699595],
              [-13.173457435437399, -11.820854712112563],
              [-13.176761423448788, -11.821551353607827],
              [-13.180633995326614, -11.82000859317478],
              [-13.183014717837727, -11.821776727268167],
              [-13.18415939567721, -11.822001283433593],
              [-13.183861577065256, -11.82437626912274],
              [-13.18522966122588, -11.825170416291085],
              [-13.186752891022595, -11.82426208398944],
              [-13.18927384880717, -11.824496400053775],
              [-13.188354408493364, -11.827729451413509],
              [-13.190069022821657, -11.830013992648993],
              [-13.19134197348146, -11.829689609699667],
              [-13.190004803276613, -11.827497196594807],
              [-13.190008696914342, -11.826076857445045],
              [-13.193355739568636, -11.828080036026428],
              [-13.194135998744589, -11.8281387482723],
              [-13.194969935222923, -11.826478853371924],
              [-13.196918849636802, -11.826447805977146],
              [-13.198258287730091, -11.825397586823566],
              [-13.200930468392343, -11.824762537557813],
              [-13.207938403612852, -11.824618098792195],
              [-13.20987152377653, -11.822561934040023],
              [-13.213283817985225, -11.823060085151328],
              [-13.21788137741758, -11.820584275507924],
              [-13.220485063619687, -11.821791325421923],
              [-13.220948881390997, -11.823124624393012],
              [-13.222732915902226, -11.822929692225761],
              [-13.221201195682617, -11.82080238676497],
              [-13.219764836404702, -11.820087260589107],
              [-13.221058372217705, -11.81853681148208],
              [-13.22366614202725, -11.816854295816132],
              [-13.22394787674929, -11.815412874257719],
              [-13.225383043481608, -11.815366585118783],
              [-13.22486937405763, -11.816845777004174],
              [-13.225611677774914, -11.817674761205158],
              [-13.226998389991227, -11.81780600828717],
              [-13.231431667453187, -11.81582720611454],
              [-13.23038423949966, -11.81468880908991],
              [-13.22975402039412, -11.81204547077551],
              [-13.228899986024603, -11.811435775381959],
              [-13.226683234597967, -11.814591266584056],
              [-13.226153849491261, -11.814179360368042],
              [-13.22664901949647, -11.809626758694565],
              [-13.229316145393485, -11.80778985970916],
              [-13.229427008807596, -11.806352401558291],
              [-13.22757477364429, -11.806969386391927],
              [-13.226106073165761, -11.806491650281218],
              [-13.227097665472455, -11.800777582513701],
              [-13.225782295887553, -11.801180618425246],
              [-13.223823319566048, -11.799962509435112],
              [-13.225126157751307, -11.803439488100288],
              [-13.223588106391949, -11.803879430516407],
              [-13.222286084679823, -11.799215463547606],
              [-13.222170039251186, -11.797853648916906],
              [-13.221017577576115, -11.796211997914638],
              [-13.222277044859215, -11.796035735891234],
              [-13.222721170945329, -11.794852501247153],
              [-13.224568614126955, -11.797131961331605],
              [-13.228263364808655, -11.79669229077383],
              [-13.229182275664733, -11.794560089367348],
              [-13.229101485319335, -11.793317900733381],
              [-13.23022726731653, -11.791854506739694],
              [-13.23117495915674, -11.789769064708214],
              [-13.231820625801717, -11.785294024697194],
              [-13.231130351233913, -11.78412722967255],
              [-13.231606270007612, -11.782597292153675],
              [-13.22998573543119, -11.782645102033841],
              [-13.227331844599135, -11.785712196400366],
              [-13.225864500933781, -11.78549911093321],
              [-13.225133927762803, -11.786123763983527],
              [-13.224161956201883, -11.788414344982648],
              [-13.22112819940721, -11.789988962967236],
              [-13.220187918763843, -11.788494635609393],
              [-13.218899292088539, -11.788228712296094],
              [-13.218159445604233, -11.786701754495482],
              [-13.219730645086454, -11.785573341537484],
              [-13.219480427695844, -11.78434898736624],
              [-13.220941223582276, -11.784372353361562],
              [-13.222206947477884, -11.782415970769218],
              [-13.220823683975958, -11.781769729044507],
              [-13.220595963031407, -11.779829387494727],
              [-13.222339346421592, -11.77979297571583],
              [-13.224614615527393, -11.778851683564117],
              [-13.225611633073816, -11.777703591980911],
              [-13.224812280142597, -11.776247061400761],
              [-13.225099109142015, -11.775373685646336],
              [-13.22685072324474, -11.774527511720567],
              [-13.229196313481511, -11.775313513053884],
              [-13.230694938008448, -11.774339119230968],
              [-13.234360790085317, -11.778140152861265],
              [-13.234332253832505, -11.779576844058331],
              [-13.235780138376692, -11.780705766834425],
              [-13.237013860094555, -11.78248966973333],
              [-13.239292854921542, -11.783782454498565],
              [-13.2405354347603, -11.783738273171151],
              [-13.242563028389224, -11.782494531040111],
              [-13.24440232156245, -11.782877770762855],
              [-13.245662709693459, -11.78187562282814],
              [-13.247735454619619, -11.78319805242314],
              [-13.25004678344294, -11.78107986518532],
              [-13.251151750482313, -11.781906570278247],
              [-13.253486042384939, -11.781672877290719],
              [-13.254455173739409, -11.781109066225294],
              [-13.255083541865593, -11.779331513886513],
              [-13.255888429727, -11.778668486299246],
              [-13.25834626287406, -11.777751006706206],
              [-13.25966633392027, -11.778066760786228],
              [-13.25949446227704, -11.779649478236298],
              [-13.260328660752181, -11.780101854143147],
              [-13.26056849581086, -11.78147635266942],
              [-13.259066877967683, -11.782018786837329],
              [-13.255929906341397, -11.786528542347819],
              [-13.255723986484059, -11.787764384062148],
              [-13.253834449051032, -11.788137926837582],
              [-13.252705203918103, -11.79009736620579],
              [-13.25121602694508, -11.789391579462764],
              [-13.250454848901056, -11.790068868113247],
              [-13.249792606973356, -11.7939093866659],
              [-13.248668003467857, -11.796304921570497],
              [-13.24897061446687, -11.79914681801206],
              [-13.25020743358414, -11.799725468337527],
              [-13.253357490326161, -11.802732523719921],
              [-13.254250482831997, -11.805276587836033],
              [-13.255441624078294, -11.805695956676693],
              [-13.25695603787014, -11.804817927330747],
              [-13.261773119298756, -11.804967946946597],
              [-13.265382595153316, -11.804596404520128],
              [-13.26628538129893, -11.803479619905229],
              [-13.268717589827771, -11.803705258555494],
              [-13.270351828477791, -11.80199703219112],
              [-13.272934016991206, -11.802364965186289],
              [-13.273858247663716, -11.801722892362177],
              [-13.279417276307159, -11.800234086231708],
              [-13.280373170324351, -11.798955526038778],
              [-13.282412746756755, -11.797648173038462],
              [-13.28201969150608, -11.796012579366684],
              [-13.283916412807814, -11.793855929795143],
              [-13.286098329245657, -11.793833186267781],
              [-13.286945778016188, -11.79240393016149],
              [-13.287941069650621, -11.793039130906527],
              [-13.28862351992859, -11.791076489924613],
              [-13.287979596828286, -11.789350515938096],
              [-13.290533104117417, -11.789817732649148],
              [-13.292216912452975, -11.787790227181226],
              [-13.293725705938801, -11.787823542024706],
              [-13.295839962155808, -11.786890406716863],
              [-13.296189803312608, -11.785652760644703],
              [-13.294456831200696, -11.784492310581616],
              [-13.293835680485476, -11.783531402855669],
              [-13.291282425903205, -11.781876851161043],
              [-13.290558592518394, -11.78093172801114],
              [-13.288890743855575, -11.781088519990814],
              [-13.287988756393304, -11.780088392676939],
              [-13.288766564054994, -11.778742890436401],
              [-13.290923928751646, -11.77873805371517],
              [-13.291934283534712, -11.777732764125],
              [-13.291197976821207, -11.77621860235623],
              [-13.291336674737426, -11.77452519142088],
              [-13.292419913971543, -11.772740662664447],
              [-13.291509009024278, -11.771524474040888],
              [-13.291811521120044, -11.77007667368942],
              [-13.291092850630669, -11.76942171665648],
              [-13.28929037327007, -11.769163386977253],
              [-13.288482844975636, -11.768029904451229],
              [-13.289189341078453, -11.766963754898287],
              [-13.288508534921347, -11.765287697899682],
              [-13.28775030937478, -11.765072040304966],
              [-13.285581464697808, -11.766176429201135],
              [-13.283865459057175, -11.767997884821712],
              [-13.282582179716108, -11.77014602692642],
              [-13.281089467382792, -11.771124466501291],
              [-13.279682050920306, -11.772898222803034],
              [-13.278632350687614, -11.774927639883211],
              [-13.276493361022442, -11.775176469950836],
              [-13.278156226041085, -11.772616492470528],
              [-13.278196495850032, -11.771283213857167],
              [-13.279747642597309, -11.76921811290354],
              [-13.28027911255856, -11.767124827035774],
              [-13.281084030340448, -11.766605842153824],
              [-13.281255191372255, -11.76411308813846],
              [-13.279566597030318, -11.762675823727607],
              [-13.279324045165149, -11.761159121717789],
              [-13.273887988133525, -11.759804582470545],
              [-13.27092055957244, -11.762003361012841],
              [-13.26730191314545, -11.763038356366886],
              [-13.264231486003396, -11.76313842349416],
              [-13.264577702639679, -11.764784654287862],
              [-13.262724074608897, -11.765360124544852],
              [-13.261391080530613, -11.765088457209517],
              [-13.260876296707476, -11.764110522255702],
              [-13.259321160092421, -11.763768879773657],
              [-13.259331174423819, -11.766897715201917],
              [-13.26003445390685, -11.767598273902168],
              [-13.259291219941124, -11.769578449745804],
              [-13.256548461899861, -11.771223607288503],
              [-13.254119722718508, -11.768443762234185],
              [-13.256753931703187, -11.766381380806918],
              [-13.25638532868558, -11.76525591068425],
              [-13.254821148542066, -11.764189746321321],
              [-13.253865288501032, -11.76456450463244],
              [-13.252920005716051, -11.767010400568779],
              [-13.253094349541628, -11.767979122065418],
              [-13.25178571262351, -11.769734865096979],
              [-13.250259894196846, -11.769449785486746],
              [-13.24977088095764, -11.76809372508209],
              [-13.2476803918587, -11.768786728228898],
              [-13.244930220817238, -11.767444092788486],
              [-13.244283071200293, -11.766423038886094],
              [-13.241785214607837, -11.76640979013401],
              [-13.242139066095916, -11.76502900303498],
              [-13.239898573140277, -11.76422983126958],
              [-13.237688586718127, -11.76483521332371],
              [-13.234453140158832, -11.76632192159194],
              [-13.23321850494845, -11.765597063629045],
              [-13.236724220996724, -11.7631365148098],
              [-13.236932592697856, -11.760555077857052],
              [-13.23922785068427, -11.759688228664382],
              [-13.240453887026726, -11.754300735374851],
              [-13.23727365550629, -11.755177255601188],
              [-13.236788627173755, -11.758152108710636],
              [-13.23335228518525, -11.760103616181079],
              [-13.232436445231869, -11.758708439944883],
              [-13.232616542186292, -11.757561782955499],
              [-13.231352717742022, -11.756779291773112],
              [-13.22907523798709, -11.756543615207988],
              [-13.228247384445874, -11.753539702021335],
              [-13.229361426391538, -11.752687529745728],
              [-13.231307397370937, -11.749451790564612],
              [-13.234083683441998, -11.74950794530808],
              [-13.23598601674577, -11.747894292775987],
              [-13.239328683935428, -11.745772162623702],
              [-13.234386948740163, -11.74455389228474],
              [-13.23476962786541, -11.740107066430259],
              [-13.236311891330303, -11.73943921750366],
              [-13.236550675358252, -11.738264719558806],
              [-13.24049480030507, -11.734604710291096],
              [-13.240115072850871, -11.73352420593365],
              [-13.24157860915627, -11.732495410856433],
              [-13.246017472032744, -11.735380070802782],
              [-13.247445630439326, -11.73654920076389],
              [-13.248910541135817, -11.737009122769118],
              [-13.250188038349425, -11.736545468649297],
              [-13.250603140047293, -11.735427115987493],
              [-13.252963140865424, -11.73554317839677],
              [-13.253819822609954, -11.7369641471168],
              [-13.255070981953207, -11.735531883773117],
              [-13.25535256744597, -11.734371649998996],
              [-13.25294933466627, -11.73169763036365],
              [-13.255058758107632, -11.729287114367594],
              [-13.256760240804041, -11.729916783766363],
              [-13.257645136117862, -11.731249925240123],
              [-13.259591888195986, -11.728884532765246],
              [-13.260910247778405, -11.729489084288984],
              [-13.261305419301523, -11.730524824067603],
              [-13.26456751315699, -11.731017702427712],
              [-13.265163881570668, -11.730388493985334],
              [-13.263982711443445, -11.727716384765323],
              [-13.262596930015638, -11.727618312317421],
              [-13.260936632708855, -11.726714424688645],
              [-13.26121319463143, -11.723922935420312],
              [-13.259921569979682, -11.721743330312263],
              [-13.260192843999869, -11.7197180316518],
              [-13.26088868682442, -11.718785144187725],
              [-13.262926026062699, -11.719279454610238],
              [-13.264232976492844, -11.722758163547365],
              [-13.265917841918807, -11.723285518592032],
              [-13.268317628700922, -11.72326869895491],
              [-13.271983210752843, -11.720866705426277],
              [-13.274567051632701, -11.722680786492276],
              [-13.274495484062822, -11.720501280683893],
              [-13.274940235667568, -11.719585713834071],
              [-13.277262687613014, -11.719352176729382],
              [-13.277043221964158, -11.715977351441412],
              [-13.275953988670924, -11.710032027452101],
              [-13.27502377634094, -11.708544051754522],
              [-13.277073036092089, -11.7065983955132],
              [-13.278111119653053, -11.707305600846729],
              [-13.278976526160342, -11.704798639160591],
              [-13.277090756413932, -11.704448923980857],
              [-13.275953684942287, -11.705242886709295],
              [-13.274862962150126, -11.704997315134394],
              [-13.274137108636614, -11.703333754567295],
              [-13.277395237355487, -11.700522431975672],
              [-13.278404236272241, -11.698923326022772],
              [-13.278282283686103, -11.696157254838399],
              [-13.279777549970307, -11.693514179837912],
              [-13.28190410563062, -11.693269988859893],
              [-13.28184944548137, -11.694783800402162],
              [-13.28238103218829, -11.69853845678455],
              [-13.283222661251896, -11.70119420843504],
              [-13.284403023703197, -11.703859953998561],
              [-13.28461214280734, -11.706964676883334],
              [-13.28611198596765, -11.709251584696405],
              [-13.286512750123181, -11.711770352277904],
              [-13.288431021188826, -11.713373575489653],
              [-13.289483478658804, -11.715089956416575],
              [-13.292079759133081, -11.715658418745306],
              [-13.293273924371485, -11.71799288584498],
              [-13.295322898232335, -11.719347875812367],
              [-13.295661565736161, -11.721464563957989],
              [-13.295219275317647, -11.72554182978403],
              [-13.296221451086701, -11.726667163812902],
              [-13.296002365205553, -11.728850821446047],
              [-13.296379186789963, -11.732513187905246],
              [-13.298802179977018, -11.73407945203256],
              [-13.298659538968728, -11.737389839126799],
              [-13.302910367298786, -11.737987723925592],
              [-13.30409624918149, -11.739456885916885],
              [-13.304346868526693, -11.741403551178493],
              [-13.307114705637915, -11.741301188633736],
              [-13.30796199117726, -11.743671620836533],
              [-13.308840225170782, -11.743871063929756],
              [-13.30925581761371, -11.746694171711596],
              [-13.308039596518814, -11.74767353909719],
              [-13.30999988097805, -11.75029043008063],
              [-13.312199537678849, -11.748710512518864],
              [-13.312878009996322, -11.74674089510291],
              [-13.314121717214032, -11.746267862266738],
              [-13.314425947214627, -11.743378470430137],
              [-13.315869532564642, -11.74178222646929],
              [-13.31662990040038, -11.741927559976567],
              [-13.318312818424783, -11.744067846807438],
              [-13.318072908382279, -11.745507699682403],
              [-13.319575586015509, -11.746413457865701],
              [-13.322155678930113, -11.744169571232472],
              [-13.32338085888846, -11.742343357518083],
              [-13.325183093503362, -11.743576303506721],
              [-13.327114026348577, -11.744328149769009],
              [-13.326285223824694, -11.746999217746726],
              [-13.327291107750435, -11.747582859282419],
              [-13.328840020408725, -11.746906547507018],
              [-13.331311896143552, -11.74259986808822],
              [-13.332594036684158, -11.741895284332271],
              [-13.333813375885136, -11.740452941621204],
              [-13.333938924124885, -11.739185583903993],
              [-13.335554036596026, -11.73646530431121]
            ]
          ],
          [
            [
              [-13.283337658244719, -11.903668624646789],
              [-13.282119628278462, -11.901455069549025],
              [-13.283564091474775, -11.900494504589853],
              [-13.2822962937987, -11.897975681193548],
              [-13.281331248134382, -11.898212000712611],
              [-13.28004501669613, -11.897139201509622],
              [-13.27977393397969, -11.89613642211828],
              [-13.277856392545173, -11.893030141531396],
              [-13.277923491533924, -11.891744306770757],
              [-13.279524546891922, -11.88952665066048],
              [-13.279976874425117, -11.88811783856152],
              [-13.279190150325633, -11.886569769690423],
              [-13.278727345064693, -11.88217066157034],
              [-13.277361499199348, -11.882427544071055],
              [-13.276365896381455, -11.881685608242721],
              [-13.27602623628189, -11.87921113189751],
              [-13.271227767800598, -11.874492005059041],
              [-13.270764662908965, -11.873478389114414],
              [-13.271038648078624, -11.872015831774922],
              [-13.27341919932868, -11.870139394758732],
              [-13.275356160697552, -11.871171453253467],
              [-13.28081140149318, -11.870773555025648],
              [-13.280968518182526, -11.869517277624547],
              [-13.28032322172522, -11.868303527493385],
              [-13.280770222775345, -11.865686946979332],
              [-13.278670316838781, -11.862865941088465],
              [-13.27857976700249, -11.860084537232886],
              [-13.276897226708494, -11.859952054874798],
              [-13.276172971402632, -11.862047812930403],
              [-13.275207692923502, -11.862136406135228],
              [-13.274221043121955, -11.86091406485342],
              [-13.269928339877374, -11.859395130060234],
              [-13.26754942844133, -11.859433064051776],
              [-13.265643638617219, -11.857393880073586],
              [-13.264026085290665, -11.8585848119285],
              [-13.261944296433166, -11.85861735699261],
              [-13.260232034893818, -11.859488870855118],
              [-13.25853715143116, -11.861526179251868],
              [-13.257690754846445, -11.864600331200672],
              [-13.256528681174467, -11.86453076096529],
              [-13.255869534205273, -11.861231179574608],
              [-13.256766379746955, -11.859527014143444],
              [-13.25614654915137, -11.858851238999854],
              [-13.257743455086601, -11.856203790157895],
              [-13.257125791270191, -11.855673932962018],
              [-13.25141228068175, -11.856560240269392],
              [-13.249198112373081, -11.857758399415026],
              [-13.247943404634187, -11.859496837324777],
              [-13.248147765599278, -11.861301586726952],
              [-13.247459277406332, -11.86311950658345],
              [-13.246476001202865, -11.867217018767766],
              [-13.24474975327346, -11.87040759683847],
              [-13.246141822417455, -11.872969709610727],
              [-13.250517701464071, -11.875779613117308],
              [-13.251957544512086, -11.877436404373446],
              [-13.251696847826246, -11.879921305448072],
              [-13.250833823498013, -11.88197794115004],
              [-13.250896299802708, -11.883159493381646],
              [-13.251827995975479, -11.88562754259199],
              [-13.249944340401923, -11.888240731305267],
              [-13.24977693011181, -11.889981460963845],
              [-13.25017070306734, -11.891362906770366],
              [-13.25187372737208, -11.89252024053904],
              [-13.252245659916436, -11.895348524766117],
              [-13.253205859818635, -11.896663375246188],
              [-13.255182882689493, -11.896208459010467],
              [-13.255926569934157, -11.895130250516889],
              [-13.257810838233429, -11.894501551220797],
              [-13.258526014995468, -11.89351148499463],
              [-13.260542166086582, -11.893698365260665],
              [-13.261474655863761, -11.893259711592174],
              [-13.264505878773146, -11.89351754622612],
              [-13.267474833345593, -11.891818537666673],
              [-13.26844181803538, -11.889889719109462],
              [-13.26933115003946, -11.889582882333285],
              [-13.271235572485617, -11.890266382896629],
              [-13.27143994494042, -11.891781523094243],
              [-13.273720953254962, -11.892677515135242],
              [-13.274202177816239, -11.893793782960271],
              [-13.277846360364737, -11.896754147652379],
              [-13.27974797985306, -11.899758962590239],
              [-13.280550404000973, -11.902958319770857],
              [-13.280526190489471, -11.9041130547368],
              [-13.282263366232302, -11.905324221849483],
              [-13.283337658244719, -11.903668624646789]
            ]
          ],
          [
            [
              [-13.387860408650875, -11.584025565017923],
              [-13.382348060009807, -11.582900180167973],
              [-13.379794795192577, -11.585758990506239],
              [-13.377693769877247, -11.58615404691663],
              [-13.375565084544855, -11.587534608617686],
              [-13.37546160255708, -11.588307694176914],
              [-13.373653479406345, -11.590639587563025],
              [-13.374878896119858, -11.590875017233076],
              [-13.376362335771582, -11.59000541046217],
              [-13.38012729848953, -11.591637013698344],
              [-13.38143870503679, -11.590098938131025],
              [-13.38331209862165, -11.589964381521607],
              [-13.384811139549631, -11.58753752532962],
              [-13.386318430052874, -11.586438687284538],
              [-13.387860408650875, -11.584025565017923]
            ]
          ],
          [
            [
              [-13.396457249559194, -11.560902185556598],
              [-13.396348809356935, -11.558838351671977],
              [-13.392011745132695, -11.559631718579244],
              [-13.38899642423364, -11.562295250847916],
              [-13.388094024141198, -11.562112097820146],
              [-13.38562410688878, -11.562770098765146],
              [-13.384073107460802, -11.564608549255263],
              [-13.38254393603592, -11.564279656091147],
              [-13.382397153853402, -11.565936057424931],
              [-13.38134280786311, -11.56712433680173],
              [-13.382051465832033, -11.57046294983543],
              [-13.383578936978907, -11.570649292555805],
              [-13.386495786943145, -11.568000734498415],
              [-13.389892857690713, -11.568052369175124],
              [-13.39079637989636, -11.566581179142883],
              [-13.39239729338431, -11.565183038683845],
              [-13.394054325876505, -11.564510415580997],
              [-13.396307301825429, -11.562273311562887],
              [-13.396457249559194, -11.560902185556598]
            ]
          ],
          [
            [
              [-13.402020121047176, -11.54665493778312],
              [-13.400316029640162, -11.546131954641734],
              [-13.399846527827737, -11.547450502457934],
              [-13.401676741000003, -11.54772924207602],
              [-13.402020121047176, -11.54665493778312]
            ]
          ],
          [
            [
              [-13.353754259460962, -11.761035869762132],
              [-13.355034649529129, -11.75793184445782],
              [-13.35532314548932, -11.756105465450654],
              [-13.354503059587136, -11.754084593798439],
              [-13.352039011069047, -11.752327422148939],
              [-13.351077973247111, -11.752129517010706],
              [-13.350006005494542, -11.750749450766317],
              [-13.348765986627852, -11.746685961790769],
              [-13.347247189351956, -11.74655645547678],
              [-13.345690325548382, -11.745170763541823],
              [-13.3433189500249, -11.745114812144168],
              [-13.34029331860372, -11.746341520606947],
              [-13.339201766946948, -11.748687604230984],
              [-13.335582231218169, -11.754665082741996],
              [-13.336907353300289, -11.757849099156006],
              [-13.33362640815808, -11.75818489402942],
              [-13.332966108967879, -11.75918014868622],
              [-13.332553049513043, -11.762455775494324],
              [-13.335929345030882, -11.762436333822643],
              [-13.336946318980306, -11.76322694667952],
              [-13.335951607054636, -11.765270348021579],
              [-13.33223417480691, -11.766048440852616],
              [-13.33168445444141, -11.767461800446041],
              [-13.332607581760252, -11.767936688969643],
              [-13.333449879881245, -11.771263077942201],
              [-13.332696888954526, -11.772854576409934],
              [-13.334358920680069, -11.775761006302115],
              [-13.336661051479362, -11.775746464234045],
              [-13.337715551538137, -11.776884025660474],
              [-13.339862032607336, -11.776437538052578],
              [-13.341487384457576, -11.777317641564196],
              [-13.342222651926095, -11.775624649388726],
              [-13.344335167496093, -11.774208939775148],
              [-13.345921534907351, -11.772296805681002],
              [-13.347863465157456, -11.771260180894748],
              [-13.349253905189974, -11.766893702351595],
              [-13.351901021114005, -11.765019236472693],
              [-13.353724057484952, -11.762510886104057],
              [-13.353754259460962, -11.761035869762132]
            ]
          ],
          [
            [
              [-13.45760616723093, -11.437991913449753],
              [-13.45439047034336, -11.439441192418295],
              [-13.454043698848093, -11.440083518186272],
              [-13.451725810541696, -11.441245935410368],
              [-13.449758544040604, -11.443544814383133],
              [-13.450990312224208, -11.44415540399457],
              [-13.452991531472545, -11.44369094256468],
              [-13.455967991134527, -11.440904876032988],
              [-13.45760616723093, -11.437991913449753]
            ]
          ],
          [
            [
              [-13.490495948473482, -11.36210689605814],
              [-13.48975845682241, -11.360794493349974],
              [-13.487880167397567, -11.359305295279547],
              [-13.487202208753523, -11.361048330984056],
              [-13.488639237349636, -11.362919921544215],
              [-13.490495948473482, -11.36210689605814]
            ]
          ],
          [
            [
              [-13.475511188263875, -11.4280071463155],
              [-13.474216357607466, -11.42775338808357],
              [-13.472519534316374, -11.428462539764189],
              [-13.470345800896911, -11.430359065391169],
              [-13.468675260598124, -11.430882906228502],
              [-13.469362511996312, -11.431822267984256],
              [-13.472333208441587, -11.430471808097783],
              [-13.473762503471699, -11.429421347261346],
              [-13.47587363732591, -11.429026975629263],
              [-13.475511188263875, -11.4280071463155]
            ]
          ],
          [
            [
              [-13.395638265131547, -11.755666372126393],
              [-13.39463076273168, -11.74943917532374],
              [-13.395036620900518, -11.747842719408414],
              [-13.393838822736186, -11.744233887082478],
              [-13.393892750506586, -11.742674600329323],
              [-13.39275934275163, -11.741949848018717],
              [-13.39157177402487, -11.742784273817717],
              [-13.391629755057265, -11.744759534538087],
              [-13.392592281473542, -11.749730548158785],
              [-13.392120549846295, -11.751689821623728],
              [-13.39254093810739, -11.754062235537466],
              [-13.390655297545699, -11.756645803541986],
              [-13.390344266032294, -11.758559113205555],
              [-13.390331351777567, -11.762618121145561],
              [-13.39157364075547, -11.762849712589256],
              [-13.393479013143521, -11.761130687394438],
              [-13.395638265131547, -11.755666372126393]
            ]
          ],
          [
            [
              [-13.434005978131003, -11.781936715185278],
              [-13.43289538896118, -11.778309819163217],
              [-13.430279165842103, -11.77452022589339],
              [-13.428072206954397, -11.77519838182648],
              [-13.425515105555647, -11.775436939851655],
              [-13.424538144536756, -11.774667426920562],
              [-13.422043577639718, -11.775640699552637],
              [-13.42035435848295, -11.774657309328736],
              [-13.419669684243615, -11.771394930048356],
              [-13.417162695670909, -11.770070813341688],
              [-13.416273393736935, -11.771046224526062],
              [-13.41499553365802, -11.774819965019898],
              [-13.415054616611501, -11.776032294339092],
              [-13.413286333719808, -11.779660305252307],
              [-13.412561610456782, -11.781976752637384],
              [-13.411109365955268, -11.782880072773985],
              [-13.409792986408384, -11.782102777564118],
              [-13.410182539128282, -11.779924705239374],
              [-13.4092778529517, -11.779079182748822],
              [-13.407568468296592, -11.780335136327436],
              [-13.406211507854902, -11.780310454244933],
              [-13.406345093925983, -11.779107012813105],
              [-13.407697747908951, -11.775879785778802],
              [-13.405560166254869, -11.773994595723526],
              [-13.403309892288492, -11.774178868728397],
              [-13.401750887372538, -11.7761960052041],
              [-13.40013092196366, -11.774991219822493],
              [-13.400762134296938, -11.77236052243272],
              [-13.400324675917899, -11.770651216758564],
              [-13.399188861191737, -11.768683759433307],
              [-13.396803373328828, -11.767439153389189],
              [-13.394555493243082, -11.765757374274198],
              [-13.393154481732154, -11.766338685662227],
              [-13.39186811219488, -11.765472304740001],
              [-13.388484921192838, -11.76569374325685],
              [-13.387791300636156, -11.76696647292798],
              [-13.387860875449993, -11.770765835764267],
              [-13.388488950866186, -11.77248616866717],
              [-13.390556415366326, -11.773971011369474],
              [-13.391171883261773, -11.775113629645855],
              [-13.39358313145404, -11.77612756193148],
              [-13.394880719522876, -11.777427734572955],
              [-13.39563282800047, -11.779998165165413],
              [-13.3984420258249, -11.782853457661885],
              [-13.400196597481933, -11.785342561165207],
              [-13.400446703700103, -11.78656629756173],
              [-13.403097257090169, -11.788846054290907],
              [-13.403567337226917, -11.789992142944762],
              [-13.403235060727994, -11.791519321100116],
              [-13.40360585223058, -11.793449512319045],
              [-13.406149835150007, -11.797323746262684],
              [-13.40720983347885, -11.797210827332323],
              [-13.409670931774805, -11.798858107003113],
              [-13.409582807606226, -11.800076275828083],
              [-13.408566013243776, -11.802548044225718],
              [-13.407674536104816, -11.80352584296411],
              [-13.408386830390805, -11.805462930067785],
              [-13.409094460212016, -11.806010200398152],
              [-13.410379948910583, -11.804240443097793],
              [-13.412081668641004, -11.80379231891737],
              [-13.415545078440456, -11.80645602255686],
              [-13.416789381630071, -11.805439892711915],
              [-13.41893739931083, -11.805124335865376],
              [-13.419789557453845, -11.803799397051936],
              [-13.42197901402967, -11.803974857333456],
              [-13.424118698701808, -11.799924392230286],
              [-13.423706158056271, -11.797648819188362],
              [-13.422376584149733, -11.796438909738754],
              [-13.420354347619126, -11.792917102327946],
              [-13.421505300584396, -11.790009186944342],
              [-13.424086364888591, -11.790015507550589],
              [-13.427095757803738, -11.788332618362283],
              [-13.427539149186375, -11.787222467904515],
              [-13.429424818503634, -11.78773714792541],
              [-13.43029120882221, -11.7858929491678],
              [-13.433308542728627, -11.78402179546216],
              [-13.434005978131003, -11.781936715185278]
            ]
          ],
          [
            [
              [-13.357270501040915, -11.362873784771619],
              [-13.356698392724732, -11.364650063326353],
              [-13.355436723188705, -11.364386022554822],
              [-13.354169880656872, -11.366603703526554],
              [-13.352289329565524, -11.3686402387013],
              [-13.350557725906828, -11.369824050650076],
              [-13.349293736299032, -11.371611034523307],
              [-13.348614829117013, -11.371675133474152],
              [-13.346590708302267, -11.374388484208499],
              [-13.346698482570073, -11.37526401596555],
              [-13.342671806622695, -11.378602234066241],
              [-13.341032189715172, -11.381400981024987],
              [-13.338267048585681, -11.38325747019105],
              [-13.337598582408539, -11.384094516619161],
              [-13.338921295974576, -11.385602411145781],
              [-13.337915102134705, -11.388034433153678],
              [-13.338511993758075, -11.388631870071926],
              [-13.354195724073797, -11.399203179831545],
              [-13.353601159175758, -11.40098992176404],
              [-13.35409785413835, -11.403329082929082],
              [-13.356680844335349, -11.403764420544977],
              [-13.35784883561682, -11.404826583510111],
              [-13.35990748284905, -11.404792763037085],
              [-13.36181915060278, -11.40629773398573],
              [-13.362468644162535, -11.408468699464265],
              [-13.363969008389436, -11.409061024023956],
              [-13.364426064120467, -11.411042811766178],
              [-13.372077035998121, -11.412818348440796],
              [-13.375059332847453, -11.41442404449689],
              [-13.375424589947382, -11.416083765241657],
              [-13.374896009655883, -11.417596178569532],
              [-13.371190234058917, -11.41892032267565],
              [-13.37074736777562, -11.421109428486602],
              [-13.371543750791751, -11.422250870882516],
              [-13.370025993032728, -11.42461947073401],
              [-13.367815788146293, -11.424833164783575],
              [-13.36717993355027, -11.425605316029712],
              [-13.368449414120867, -11.428004883226139],
              [-13.367488627543388, -11.431822752384871],
              [-13.368575699234494, -11.432953225195789],
              [-13.36764797377039, -11.435491710011515],
              [-13.370139017569647, -11.438127509305236],
              [-13.369928268139288, -11.441689688577226],
              [-13.368581592449454, -11.443591435028994],
              [-13.366437466191176, -11.442203973682666],
              [-13.364690375869062, -11.443352199551498],
              [-13.364518418503492, -11.445510879910739],
              [-13.362959612633544, -11.445890897027544],
              [-13.362429285941579, -11.448856119464999],
              [-13.363278875577915, -11.449676975509533],
              [-13.362613198881066, -11.45233712986284],
              [-13.359875294998218, -11.45549418154982],
              [-13.359907171330377, -11.45783442197771],
              [-13.361553821824327, -11.458120358892133],
              [-13.363718859922539, -11.457884372440425],
              [-13.365676567873566, -11.460099729830926],
              [-13.366971623217127, -11.459727238596562],
              [-13.36923590399222, -11.460091172750113],
              [-13.371593122848962, -11.458754249911788],
              [-13.372778470825597, -11.455750992106747],
              [-13.37350478957493, -11.455427293354298],
              [-13.374356087340248, -11.457730959276951],
              [-13.37583345540721, -11.458069821771183],
              [-13.376237435376387, -11.460166432735718],
              [-13.374549099217038, -11.46043676635346],
              [-13.373366345446986, -11.462475374282182],
              [-13.371790412201348, -11.462919316410106],
              [-13.368539506121856, -11.464879150272779],
              [-13.367136127192643, -11.464903976261818],
              [-13.366453157951073, -11.466290954495896],
              [-13.364746585793863, -11.46745889949333],
              [-13.363253091605982, -11.467387483447249],
              [-13.361381657077581, -11.46808921301611],
              [-13.35950922335136, -11.470201194246542],
              [-13.358557132957015, -11.470515947459084],
              [-13.351993075785492, -11.46892460379161],
              [-13.350995535193, -11.470461413104363],
              [-13.348408906842371, -11.469296112640643],
              [-13.346749118071548, -11.469104796309667],
              [-13.346535219538415, -11.469983127205568],
              [-13.347198648547227, -11.471908112300422],
              [-13.348724392145384, -11.473139659353341],
              [-13.35107923015324, -11.473887547431906],
              [-13.352999684220434, -11.47362861787027],
              [-13.353590070505053, -11.474417850455064],
              [-13.35625631550567, -11.475922497191617],
              [-13.35607424881468, -11.477591972582722],
              [-13.356572235302965, -11.479706827394462],
              [-13.354553226199487, -11.480242293807532],
              [-13.35050137862854, -11.481855009051278],
              [-13.349923070886746, -11.48300236210489],
              [-13.349290050304763, -11.486366550661014],
              [-13.347787711680688, -11.48909846298381],
              [-13.344605266204878, -11.491583852668986],
              [-13.342287543194916, -11.49174180143015],
              [-13.341058758655358, -11.492218474855251],
              [-13.338509401264092, -11.491235364122707],
              [-13.336031197381038, -11.493068729621093],
              [-13.335711641747748, -11.494333399950825],
              [-13.333830989082147, -11.496655185140026],
              [-13.332922335132702, -11.499868397456867],
              [-13.3319784459428, -11.501126956327816],
              [-13.331472399843012, -11.503721351718399],
              [-13.330542194091477, -11.504588745263423],
              [-13.330912475040325, -11.507260960935898],
              [-13.33362119455251, -11.508321857800711],
              [-13.334052167639914, -11.50944926619368],
              [-13.332673164593947, -11.51142180633985],
              [-13.33292138496831, -11.512627565207215],
              [-13.331234567733585, -11.514463915802004],
              [-13.330366541223247, -11.519098026005326],
              [-13.328456380105111, -11.520714553937179],
              [-13.32734444990827, -11.524541275870881],
              [-13.325745995759494, -11.523928350856892],
              [-13.324109342316167, -11.524224887330895],
              [-13.323262114899425, -11.52560982940982],
              [-13.322086517288621, -11.525804443647806],
              [-13.320816338864994, -11.527284570146366],
              [-13.319281142123732, -11.528125512752625],
              [-13.31835884947012, -11.530053121239552],
              [-13.318547218290457, -11.531711815361914],
              [-13.320211914479477, -11.53357437541866],
              [-13.32073332241968, -11.535355014878595],
              [-13.319910439195029, -11.536423870580128],
              [-13.321236075756616, -11.536107487870252],
              [-13.321577346714436, -11.53512411615541],
              [-13.32322913890581, -11.534548385921472],
              [-13.324074122583971, -11.536243321973389],
              [-13.32307462216385, -11.537133661477343],
              [-13.322888641731113, -11.538765852740918],
              [-13.322053161495816, -11.540573174722063],
              [-13.318535016306722, -11.542112473996575],
              [-13.31664294081296, -11.543410398491051],
              [-13.317075451763877, -11.545390661865882],
              [-13.31860112084682, -11.545388347871707],
              [-13.318916070364486, -11.546734639607351],
              [-13.317208648566485, -11.548417754713522],
              [-13.318086585129638, -11.550375120651925],
              [-13.320949974590949, -11.550635804957231],
              [-13.32227087190697, -11.551753011888918],
              [-13.323283574897006, -11.553360961531357],
              [-13.32637215272031, -11.553794583438911],
              [-13.328266810147763, -11.55577136770903],
              [-13.329501690290945, -11.560276819323802],
              [-13.331513949841337, -11.56070025542293],
              [-13.332304974090393, -11.562056654624952],
              [-13.334333568680451, -11.56149916079413],
              [-13.33566052572323, -11.561807285113549],
              [-13.337039606327433, -11.563017447761975],
              [-13.339921097188334, -11.56337036334495],
              [-13.3416216562984, -11.56390691716044],
              [-13.345424849177968, -11.565973054670973],
              [-13.350041279127847, -11.56672287245935],
              [-13.35398906450166, -11.56755220387065],
              [-13.354873070733618, -11.567357610380606],
              [-13.355732449128613, -11.568858246983385],
              [-13.356577104596735, -11.568827490545457],
              [-13.357458830847149, -11.566942849124821],
              [-13.35853709389112, -11.56637162644992],
              [-13.359211167981751, -11.56383576505508],
              [-13.362086336128812, -11.561935092393318],
              [-13.361475128817546, -11.560847038806275],
              [-13.362179431758532, -11.55940947573168],
              [-13.362562751254089, -11.556879643253438],
              [-13.364445337994036, -11.553727538484724],
              [-13.364421146658051, -11.55112004948169],
              [-13.365508870714672, -11.548195773507775],
              [-13.366352023333281, -11.54736995021511],
              [-13.370223522788095, -11.545497113336955],
              [-13.370751793816355, -11.544007379207521],
              [-13.368870236291817, -11.542244089249557],
              [-13.36936464532566, -11.540413473278367],
              [-13.370549085730612, -11.53823010123266],
              [-13.37081000704199, -11.535336348547306],
              [-13.37009921733134, -11.53233106278265],
              [-13.37047946497905, -11.531598867408752],
              [-13.373172421797486, -11.531583511665342],
              [-13.374282320865074, -11.529331497886341],
              [-13.375201766461531, -11.52886087913014],
              [-13.376608604043716, -11.530004084960362],
              [-13.377020787909624, -11.531405471164321],
              [-13.377630472019602, -11.5362188228912],
              [-13.379209164744092, -11.536234738023353],
              [-13.379736879205474, -11.533849544260217],
              [-13.380700313348175, -11.532495538853214],
              [-13.380315918797573, -11.530112339033776],
              [-13.380493922409679, -11.528515980587146],
              [-13.381510151983797, -11.526849007913466],
              [-13.380312071166557, -11.526101540464454],
              [-13.379771184442625, -11.524802359039779],
              [-13.378019364027953, -11.52473218294995],
              [-13.374255630609165, -11.519747015715579],
              [-13.372805269386435, -11.51948609970072],
              [-13.372976724442502, -11.518360500396998],
              [-13.374265862346311, -11.517486470067539],
              [-13.374951834501974, -11.515954521544598],
              [-13.378186627454157, -11.51469339370756],
              [-13.37928886432334, -11.513950720788998],
              [-13.379766027585712, -11.51202469505034],
              [-13.38091147723402, -11.511295333520842],
              [-13.383023374533254, -11.51425754208842],
              [-13.382771822283553, -11.515782359459111],
              [-13.38071554022801, -11.516513027745784],
              [-13.380320547316861, -11.519077980755686],
              [-13.38130482664679, -11.521975689211791],
              [-13.382557045641425, -11.523447126660425],
              [-13.38381737457623, -11.523553717540247],
              [-13.38443633540544, -11.525206382245889],
              [-13.383976573805503, -11.526337822226312],
              [-13.384048721314104, -11.529095281802785],
              [-13.383492005369442, -11.531423288678834],
              [-13.384660442956667, -11.533906927014538],
              [-13.38682210599612, -11.535092719514484],
              [-13.388735907186668, -11.535258071407801],
              [-13.389645716581258, -11.536010214533649],
              [-13.394494011512618, -11.537644458162239],
              [-13.39328700971846, -11.535574781193185],
              [-13.393419763732357, -11.534861214599548],
              [-13.39521807212954, -11.534188512258805],
              [-13.396443797969075, -11.53305681830553],
              [-13.39653487431622, -11.53157602108679],
              [-13.397395113126377, -11.530237857526425],
              [-13.403929165960578, -11.528240517053547],
              [-13.404400949234377, -11.527065808893036],
              [-13.406645585253278, -11.527236941290267],
              [-13.407443621430168, -11.524891032871691],
              [-13.408403246618573, -11.523536935195358],
              [-13.411776039355654, -11.523771325008589],
              [-13.41247528136407, -11.524880348936827],
              [-13.413928377575388, -11.525278566090874],
              [-13.414595276334637, -11.526189199585724],
              [-13.41764248518514, -11.525191876107934],
              [-13.418930206993604, -11.524456134515143],
              [-13.42037737387607, -11.52532261002789],
              [-13.420171638929022, -11.526719221198443],
              [-13.418660439031106, -11.527104523397721],
              [-13.41705793654225, -11.528827034533892],
              [-13.415922809118184, -11.529233278037541],
              [-13.415067522699212, -11.530713951558951],
              [-13.413353027875837, -11.529482209814102],
              [-13.412936116755068, -11.53123894637779],
              [-13.411375366543007, -11.531325865370972],
              [-13.409559208536985, -11.532512563877146],
              [-13.408031742734016, -11.532044145589088],
              [-13.406269838478261, -11.534708440445856],
              [-13.4047756129001, -11.535333930710438],
              [-13.404549879748698, -11.536490505430935],
              [-13.406258753735822, -11.53819307595494],
              [-13.405565251051419, -11.539913512586189],
              [-13.406713408202078, -11.540972967070088],
              [-13.409364769076525, -11.541078257740327],
              [-13.41030585360664, -11.541885225744021],
              [-13.409744720336473, -11.542892155950616],
              [-13.407503980863122, -11.543903143085783],
              [-13.40585216502281, -11.545471640905507],
              [-13.406604941152764, -11.546268577828489],
              [-13.4066249476568, -11.549812550560771],
              [-13.405428107057606, -11.554164135870442],
              [-13.407381964445173, -11.554809676536436],
              [-13.408283200863547, -11.55574597342624],
              [-13.406518650735489, -11.556763395503316],
              [-13.407121002064812, -11.558788273520868],
              [-13.409854992836932, -11.559247301362205],
              [-13.414358203221736, -11.558972185554374],
              [-13.415150927892414, -11.55949751290214],
              [-13.41519156347615, -11.560878280337185],
              [-13.413599163452508, -11.563317879311164],
              [-13.413834012685669, -11.564239105816812],
              [-13.412632692885069, -11.565902182239],
              [-13.411659215445985, -11.565038077947701],
              [-13.408841383637592, -11.56559303200864],
              [-13.407640787488006, -11.564989801902934],
              [-13.406334686682667, -11.566526229557535],
              [-13.405228720084233, -11.56713243563466],
              [-13.40413453170811, -11.566797539979676],
              [-13.403028408678953, -11.567403554268347],
              [-13.398548324632808, -11.567589693700045],
              [-13.397003741037802, -11.572124970120074],
              [-13.395945385692812, -11.57137507544876],
              [-13.393369648011802, -11.572664602848535],
              [-13.393075706723964, -11.573283463437857],
              [-13.39496887149255, -11.574431390338084],
              [-13.394865289885255, -11.575959429961078],
              [-13.393864365130533, -11.576834406261554],
              [-13.391134687001076, -11.577699391328938],
              [-13.391551527658397, -11.57910389708609],
              [-13.390084391821745, -11.57993067818051],
              [-13.388821117404971, -11.581623983968658],
              [-13.390568949039574, -11.581876739143407],
              [-13.39140286452283, -11.581375695941658],
              [-13.392618451145372, -11.581937806889998],
              [-13.392966929081132, -11.583557937503565],
              [-13.394208025575903, -11.583891202465164],
              [-13.395434425516527, -11.582611646991053],
              [-13.396588439353586, -11.582161266355527],
              [-13.398401303466596, -11.580399778552744],
              [-13.399338694153625, -11.5800246800269],
              [-13.403051031217274, -11.582862446002197],
              [-13.402644135560363, -11.585196484035338],
              [-13.399191102385924, -11.585464333177296],
              [-13.398222124491857, -11.58729608827842],
              [-13.39906029627749, -11.587836458927907],
              [-13.395824320258624, -11.592097128082987],
              [-13.392607140288662, -11.595087249447639],
              [-13.392512471612822, -11.596289183819126],
              [-13.39410852166896, -11.596872505748195],
              [-13.395001668472258, -11.597997852985896],
              [-13.396359505929532, -11.598271182487276],
              [-13.398206071141, -11.597463421662924],
              [-13.400480905983772, -11.595461403080696],
              [-13.401818886682404, -11.596249078077166],
              [-13.40062211912078, -11.598344027201193],
              [-13.39922018302867, -11.598814579586],
              [-13.399101278256472, -11.601002879330748],
              [-13.40054035053678, -11.604803752811964],
              [-13.399700502360625, -11.60502061983472],
              [-13.39738731481947, -11.604266325752373],
              [-13.39552251155482, -11.606489956346573],
              [-13.391843806095887, -11.606691070496343],
              [-13.389360885278574, -11.607825561920546],
              [-13.388677120881919, -11.60543726477273],
              [-13.387482000112287, -11.606160602953421],
              [-13.386678479994167, -11.607619863452433],
              [-13.385303961863643, -11.608904462411083],
              [-13.383175735853053, -11.608773349336209],
              [-13.381672745563204, -11.611061086784462],
              [-13.379299290848252, -11.61275060603374],
              [-13.376976559009245, -11.616542509062846],
              [-13.37750644359184, -11.618507164474703],
              [-13.378488609153695, -11.619662347969122],
              [-13.378261462300294, -11.62082572790263],
              [-13.379667191890604, -11.622015998041043],
              [-13.380511053351634, -11.624361746333168],
              [-13.381458656313653, -11.62517413066032],
              [-13.37931807856666, -11.626130975069014],
              [-13.376900960172717, -11.629613665333387],
              [-13.378227662794506, -11.631206857337242],
              [-13.379705831533702, -11.630662936116462],
              [-13.379314860220127, -11.633248758491233],
              [-13.380403139763645, -11.634531385409444],
              [-13.382322698206256, -11.632603583342851],
              [-13.383535957262765, -11.632737505038087],
              [-13.385998856052135, -11.627892281565066],
              [-13.38819044365956, -11.628135618663501],
              [-13.389394907699002, -11.627839865118997],
              [-13.390437879818906, -11.625929712388485],
              [-13.391870563179088, -11.625371579437962],
              [-13.393509533048181, -11.623406739449011],
              [-13.39533486851969, -11.622068051295248],
              [-13.396684500017825, -11.62025238384666],
              [-13.398127073743153, -11.61950801408196],
              [-13.401931550255219, -11.615883283496931],
              [-13.403930859899463, -11.615356105257936],
              [-13.405655852410376, -11.616450368312913],
              [-13.407285766468384, -11.618604547418158],
              [-13.404348349663548, -11.622542050398804],
              [-13.402454818107095, -11.621823040788652],
              [-13.401273563933565, -11.622505467694863],
              [-13.403112526780683, -11.624155880068608],
              [-13.402965469349342, -11.627049588465756],
              [-13.398229237545314, -11.627834070723983],
              [-13.397324856642332, -11.629312784393386],
              [-13.394654928706371, -11.629209495208258],
              [-13.391436418028235, -11.633254599017672],
              [-13.39050596904481, -11.636481570787323],
              [-13.388830291154166, -11.636586558727126],
              [-13.387514664299125, -11.637228645200791],
              [-13.386476127369168, -11.639427015376825],
              [-13.384773828541663, -11.642039976975394],
              [-13.382598408657383, -11.642799448889111],
              [-13.382093819743204, -11.643927319130707],
              [-13.380840234315855, -11.644826082446441],
              [-13.378992273310718, -11.648346140296697],
              [-13.377048854414625, -11.649889634294604],
              [-13.375729923442389, -11.652051792143128],
              [-13.377135331342027, -11.655381407408145],
              [-13.377099401007605, -11.659743874551639],
              [-13.377856798274246, -11.661164332658714],
              [-13.379175185317981, -11.66052123431299],
              [-13.380433365176911, -11.658243622449893],
              [-13.38203501196441, -11.657924951525727],
              [-13.385290165495244, -11.659251403574391],
              [-13.387771728168984, -11.662099439448848],
              [-13.386641675267626, -11.664131667380953],
              [-13.385408919657543, -11.663137654763311],
              [-13.384493550788232, -11.663428973766145],
              [-13.385387081903671, -11.66503255344814],
              [-13.384918636487686, -11.667267202505872],
              [-13.383763066967191, -11.667247275514153],
              [-13.383481831719616, -11.668588077703154],
              [-13.382077597753115, -11.670870825860709],
              [-13.381042860920159, -11.671078182292753],
              [-13.379464227286485, -11.674212143880355],
              [-13.378528575469012, -11.675020931091328],
              [-13.379464308195647, -11.676496210656303],
              [-13.378362728730933, -11.679348551648804],
              [-13.376311004285267, -11.680007513281835],
              [-13.376156252097273, -11.681102822475353],
              [-13.377103414054922, -11.682391759306974],
              [-13.37718085597942, -11.684129132593332],
              [-13.378849132855054, -11.684066879963511],
              [-13.380691983221883, -11.686200055078096],
              [-13.380430041240745, -11.687786644101363],
              [-13.378758697378432, -11.687705576713881],
              [-13.378966308317574, -11.689340440386124],
              [-13.377884120072824, -11.69320206334062],
              [-13.378177866826098, -11.695483096537213],
              [-13.37655562591107, -11.6972278736536],
              [-13.376722547824425, -11.699756652776864],
              [-13.378554896685655, -11.702698139814897],
              [-13.379353905398048, -11.702321876093915],
              [-13.38125563691369, -11.704282569324322],
              [-13.382542469930039, -11.704817106701705],
              [-13.38529926884683, -11.704082942265627],
              [-13.386524985133978, -11.704503270557858],
              [-13.38956937478247, -11.70209297956064],
              [-13.392338080154017, -11.699171010856583],
              [-13.393946702238647, -11.698992374576132],
              [-13.395143874235615, -11.69597505585522],
              [-13.394461697901958, -11.692768900870004],
              [-13.395038991453834, -11.69094525719009],
              [-13.394510956907421, -11.688785998797973],
              [-13.39539967772177, -11.686438447351946],
              [-13.394985891734908, -11.6848380303877],
              [-13.396726022553509, -11.683320697638408],
              [-13.396234751431987, -11.679366267883196],
              [-13.396959972264412, -11.67692362395662],
              [-13.398824659065722, -11.676539053824454],
              [-13.399224956280618, -11.674663608944625],
              [-13.400048040406299, -11.673439760098065],
              [-13.400987375339145, -11.670778118530885],
              [-13.402716317690114, -11.668831940404203],
              [-13.40617833181954, -11.666604298695553],
              [-13.408128172004512, -11.664108074051553],
              [-13.408367637840481, -11.66090407057558],
              [-13.409558749623338, -11.659888565671677],
              [-13.410696921599273, -11.657052955613949],
              [-13.41062253400514, -11.655606578051785],
              [-13.40987165418102, -11.65461947415986],
              [-13.408679607364064, -11.651362474895443],
              [-13.409680014345469, -11.650337715802351],
              [-13.409904572493145, -11.64779617446275],
              [-13.410540652978746, -11.6460914969848],
              [-13.411922336714758, -11.644471094772484],
              [-13.412734643565791, -11.641445405114707],
              [-13.414503491001932, -11.638141634978943],
              [-13.41853169290883, -11.634860851129023],
              [-13.419738624958638, -11.631957134785806],
              [-13.420879796238223, -11.632160693614798],
              [-13.422020945311495, -11.633738464776274],
              [-13.422004558237862, -11.635012563375822],
              [-13.419700413434004, -11.637726567095855],
              [-13.418841180114212, -11.639836380158727],
              [-13.41880030649324, -11.641340590628694],
              [-13.41734840306378, -11.644409275977853],
              [-13.418950935288734, -11.644989616930278],
              [-13.417483939081087, -11.648718504969194],
              [-13.416107377515328, -11.649866862642348],
              [-13.414856583616379, -11.652144621095912],
              [-13.413395945148743, -11.656921617030802],
              [-13.413321486068476, -11.658228262417087],
              [-13.414372720082367, -11.660255292559013],
              [-13.413514874461995, -11.661134900067783],
              [-13.414103817231371, -11.662025424904057],
              [-13.415393356008845, -11.66084925994616],
              [-13.416665073094876, -11.661566530849228],
              [-13.414423661199288, -11.668057482568846],
              [-13.415500419162964, -11.66985556176594],
              [-13.413990842030062, -11.670348755214148],
              [-13.412465313283539, -11.67349706609205],
              [-13.413339352297934, -11.676707433487039],
              [-13.412333539352877, -11.678209107901008],
              [-13.411129098120087, -11.678652282371514],
              [-13.410945365260325, -11.680307800369084],
              [-13.411691098891708, -11.681626581147812],
              [-13.413348140617988, -11.681129771489106],
              [-13.414308598125338, -11.682228013608555],
              [-13.413085937545077, -11.683189295577675],
              [-13.413029152021595, -11.684598206083658],
              [-13.41499058840981, -11.685286168870988],
              [-13.41631753214769, -11.685069208199254],
              [-13.417764948529317, -11.686314042989347],
              [-13.420200679326886, -11.685956208882457],
              [-13.42067802964895, -11.685054383194101],
              [-13.422217780816348, -11.685851712382856],
              [-13.42432310573143, -11.685773517873042],
              [-13.425844438587756, -11.684473726831234],
              [-13.427789509080704, -11.684441948098709],
              [-13.429636426301153, -11.683335421334242],
              [-13.430445294038384, -11.684148731249406],
              [-13.429179257230018, -11.686333305445677],
              [-13.428192639938777, -11.68731895219052],
              [-13.42431834700193, -11.687482890860444],
              [-13.423130107158139, -11.688645626110862],
              [-13.424183793810684, -11.689913687776423],
              [-13.425195920309347, -11.692547575114315],
              [-13.421026539279666, -11.693335701618128],
              [-13.419952425530655, -11.695674653291329],
              [-13.417540897636867, -11.6939486817952],
              [-13.416314463254139, -11.692152083302451],
              [-13.413355958955462, -11.692780502355111],
              [-13.411743935052314, -11.69205567893696],
              [-13.41046985836955, -11.690719415811804],
              [-13.40879135094482, -11.690972979740772],
              [-13.409214539420676, -11.692242528131521],
              [-13.407783397824959, -11.693093840441996],
              [-13.407496405830976, -11.695386045253514],
              [-13.40799961660096, -11.697631954765933],
              [-13.407594806551945, -11.701221670979425],
              [-13.406093888115683, -11.704290283781406],
              [-13.402428474447575, -11.705610026503681],
              [-13.400731083049868, -11.705762963735976],
              [-13.400977840529253, -11.708362069868933],
              [-13.403057765205327, -11.711611061451553],
              [-13.405032394903733, -11.713351114529067],
              [-13.404588421901867, -11.71583714041561],
              [-13.407155593641342, -11.713849592138164],
              [-13.408958595743389, -11.711822086844931],
              [-13.411090344697206, -11.71075119314351],
              [-13.412367578965446, -11.71147014604795],
              [-13.409981581926525, -11.714273957741879],
              [-13.40869823414781, -11.715268050234355],
              [-13.406866889184238, -11.71800233022975],
              [-13.40287853128767, -11.720800586606396],
              [-13.40116879065086, -11.721141787883917],
              [-13.400379154602597, -11.721951712379468],
              [-13.399588360981038, -11.725383550847793],
              [-13.399594868248, -11.727674467068192],
              [-13.39907957156313, -11.729616938254233],
              [-13.3989762038462, -11.732256967991955],
              [-13.399509028239795, -11.734421590519538],
              [-13.399312500098086, -11.738131285262012],
              [-13.39958117830685, -11.738975755306575],
              [-13.401064127574005, -11.738898530843025],
              [-13.401090675998274, -11.736807243052686],
              [-13.404356506959516, -11.736313900103447],
              [-13.405432794194844, -11.735827851827525],
              [-13.406161909199538, -11.734282801004115],
              [-13.40819389339532, -11.73384637098598],
              [-13.410190998050151, -11.73444813182361],
              [-13.410294730839631, -11.732572071856834],
              [-13.41136334783732, -11.732417233325641],
              [-13.412366219256056, -11.728143225724786],
              [-13.410056049156093, -11.727923540070591],
              [-13.408286943511989, -11.725674330475625],
              [-13.408660035634075, -11.724642941661754],
              [-13.411442200142556, -11.723051475419416],
              [-13.412322303667134, -11.723030945027645],
              [-13.414665361159768, -11.724070317888472],
              [-13.418581661076447, -11.723962485405265],
              [-13.4201028492086, -11.724372634862473],
              [-13.42078190620708, -11.72329067870821],
              [-13.422422443863939, -11.723783842396553],
              [-13.425781891292079, -11.722507058404549],
              [-13.42551899339596, -11.72071385910113],
              [-13.426391553582276, -11.718548108799059],
              [-13.426023271877098, -11.71724722773292],
              [-13.426609427428906, -11.715376596143292],
              [-13.425903986975653, -11.71283245445522],
              [-13.42464371829304, -11.709741101780272],
              [-13.42697747713245, -11.708634521798725],
              [-13.429345000471972, -11.708346896430898],
              [-13.430210181911518, -11.707750640345278],
              [-13.432959301564534, -11.708718476186403],
              [-13.435203214967936, -11.70758449297427],
              [-13.435498755230517, -11.705865950628935],
              [-13.436825496204495, -11.703791594794946],
              [-13.435295809262287, -11.701098258187024],
              [-13.434277829153336, -11.70079270894238],
              [-13.433640973132938, -11.698652278789915],
              [-13.431517018503731, -11.698632446972988],
              [-13.431472869925047, -11.69676494245204],
              [-13.430741381467236, -11.695547029269028],
              [-13.428767698784274, -11.695048690067733],
              [-13.42965290556063, -11.692843328006488],
              [-13.431095878464205, -11.691328781331393],
              [-13.432460115519103, -11.690835971140139],
              [-13.434722088177118, -11.691183254175051],
              [-13.437600344083936, -11.692807509820234],
              [-13.438468916958323, -11.695443788180462],
              [-13.440549775866705, -11.693122360284827],
              [-13.44019496112595, -11.691163352617172],
              [-13.440374345372046, -11.688889608242604],
              [-13.44112148792368, -11.687119291418023],
              [-13.441640360792736, -11.683761237002274],
              [-13.442937406745756, -11.680542530935405],
              [-13.441533828495286, -11.67993140719819],
              [-13.441791566623428, -11.678490151135437],
              [-13.442925914905315, -11.67702694326632],
              [-13.445124000231393, -11.677259593360935],
              [-13.446390105341912, -11.675219343246136],
              [-13.445353487398835, -11.673437560309708],
              [-13.447335774837747, -11.671423278674872],
              [-13.44777657212109, -11.67032229295612],
              [-13.448974686552186, -11.66973308755025],
              [-13.449612132260963, -11.668311931887153],
              [-13.450863921640101, -11.666932763116241],
              [-13.452209579105268, -11.66463390384284],
              [-13.453306911081155, -11.661740000648424],
              [-13.453156737583202, -11.660368086728985],
              [-13.451544661717866, -11.658889523190275],
              [-13.44955318241633, -11.658007710274406],
              [-13.448714878459738, -11.655907993056369],
              [-13.445852356821675, -11.654574612588338],
              [-13.44417769098961, -11.650991088840247],
              [-13.443696961397624, -11.64852503215735],
              [-13.443925291713235, -11.645798793738043],
              [-13.44520755382318, -11.642632454462387],
              [-13.444239467138578, -11.640494642917064],
              [-13.442019861057446, -11.640962898742517],
              [-13.44062910328629, -11.63879175731361],
              [-13.440146580193705, -11.636799569474183],
              [-13.441341035147, -11.63422425065487],
              [-13.44419485016945, -11.635415486007178],
              [-13.444546039395101, -11.637367153635278],
              [-13.445744345706007, -11.63876944142877],
              [-13.447139999745309, -11.638621101462105],
              [-13.448575621599549, -11.64141998459537],
              [-13.450177960043264, -11.642611891872907],
              [-13.450770918644476, -11.643642212956113],
              [-13.449666230813477, -11.644399205766154],
              [-13.448842720945525, -11.646566858674063],
              [-13.449137678730878, -11.648549772967584],
              [-13.450327586539577, -11.64890712631782],
              [-13.450883961485804, -11.651442679678597],
              [-13.45217232192633, -11.651639732915118],
              [-13.453934508728878, -11.650321372512083],
              [-13.45574964745519, -11.65299654645637],
              [-13.460187922895331, -11.653758052120805],
              [-13.460292000076162, -11.652652633786515],
              [-13.459523856837027, -11.650481124822619],
              [-13.460860637552097, -11.648514477254293],
              [-13.461347164633338, -11.646955923167646],
              [-13.460461544233329, -11.645318133823745],
              [-13.458662718759514, -11.64567855428797],
              [-13.457960260617394, -11.643763942940746],
              [-13.458975589237621, -11.642364581407112],
              [-13.459556603683449, -11.639888516979346],
              [-13.462399900257829, -11.63818589186407],
              [-13.46446699348179, -11.63634521144217],
              [-13.465559977892056, -11.632227148786797],
              [-13.463700378882569, -11.630015444764439],
              [-13.46261256436999, -11.627183604766882],
              [-13.46126864239016, -11.625173126919206],
              [-13.459106998491603, -11.624240675377745],
              [-13.460648615008946, -11.621158319757155],
              [-13.460651118583499, -11.615772018455667],
              [-13.458585709733216, -11.61515157318122],
              [-13.460113590792758, -11.612728832515252],
              [-13.460421096678479, -11.610978902808757],
              [-13.463999329978058, -11.609833748308086],
              [-13.464742307500183, -11.608073401331453],
              [-13.464745334037293, -11.60576080004159],
              [-13.463208502218885, -11.6052992752156],
              [-13.463397510807683, -11.604081583637377],
              [-13.467209557365056, -11.601261394070168],
              [-13.467117908888426, -11.599251825894399],
              [-13.467718637075349, -11.59763902420619],
              [-13.467421389745772, -11.596134483185946],
              [-13.468075721492779, -11.593736325701999],
              [-13.466287372877098, -11.594236999179877],
              [-13.464357569778954, -11.592430587112299],
              [-13.464624711368854, -11.590199402187885],
              [-13.465286314570408, -11.588700411102625],
              [-13.464699814833782, -11.587203721181742],
              [-13.46353593084484, -11.587702290658923],
              [-13.458543350008593, -11.592757311228423],
              [-13.457662544020623, -11.59296386119541],
              [-13.45685064047471, -11.5955510543464],
              [-13.455460218600399, -11.595085188793576],
              [-13.45440626920991, -11.595994712979705],
              [-13.45336772145482, -11.598231128302132],
              [-13.451021502068285, -11.601112494857553],
              [-13.449742024481923, -11.603655225157066],
              [-13.446934295706061, -11.60677687235529],
              [-13.444138107122122, -11.610470141948579],
              [-13.443720419798295, -11.611951376583725],
              [-13.441834293491805, -11.614124170930044],
              [-13.439485852090021, -11.615164715766824],
              [-13.437563012286791, -11.614394448566067],
              [-13.440133868668685, -11.611577555063487],
              [-13.4411135610286, -11.609840575832548],
              [-13.441015076874779, -11.608014735246332],
              [-13.441720664474971, -11.6063846713551],
              [-13.442999165101863, -11.60568372333127],
              [-13.444955238337862, -11.603439326158938],
              [-13.446654168042945, -11.598803236332301],
              [-13.448218002901704, -11.59856691324532],
              [-13.448965459328045, -11.597564885403221],
              [-13.44872858063124, -11.595415576832652],
              [-13.447643489814386, -11.591688976416929],
              [-13.446406055825477, -11.590890413992344],
              [-13.445052835709856, -11.58878216739675],
              [-13.447225262408706, -11.58523806111744],
              [-13.449806014290537, -11.58313944188053],
              [-13.452251881631224, -11.58024574774751],
              [-13.453703526202194, -11.578986090147177],
              [-13.455014632363682, -11.576647040065515],
              [-13.455823867605194, -11.576513849923606],
              [-13.457460693574612, -11.577714868511713],
              [-13.459360878960961, -11.575176616386779],
              [-13.459544458897744, -11.573676542790293],
              [-13.460367613295448, -11.572887870875128],
              [-13.462651738363567, -11.573246296816363],
              [-13.46554097458101, -11.570300064103007],
              [-13.467985794116645, -11.56571365849044],
              [-13.470140656544336, -11.565561876665369],
              [-13.472036250778416, -11.564860722320862],
              [-13.475066044579686, -11.564359382926968],
              [-13.476850180302026, -11.563247991362388],
              [-13.479828640473158, -11.563059781849208],
              [-13.481975769294108, -11.563233408668482],
              [-13.485947678384328, -11.56461241374832],
              [-13.48748320292819, -11.565825279350367],
              [-13.487070611094401, -11.567301254562787],
              [-13.490286327299822, -11.568499031031056],
              [-13.491909833436607, -11.566820681720753],
              [-13.492352314656515, -11.565400702415639],
              [-13.491886601912322, -11.56413215741702],
              [-13.489259006468982, -11.560899942165953],
              [-13.488581425537639, -11.559239287136876],
              [-13.489053917255964, -11.556653176328618],
              [-13.493177190793917, -11.553703610346552],
              [-13.493183031068341, -11.552765278168996],
              [-13.492058784058678, -11.551159858461412],
              [-13.492827577475088, -11.550074190924862],
              [-13.492144199940645, -11.548741497191092],
              [-13.493645359630479, -11.54745268395622],
              [-13.494386158434441, -11.545231274287223],
              [-13.49351150309283, -11.543747839979709],
              [-13.492046988700766, -11.544154774847325],
              [-13.490639158022063, -11.543920718470636],
              [-13.490343094104537, -11.54303325695405],
              [-13.491107976503427, -11.541195568975903],
              [-13.493780850319277, -11.539977140856086],
              [-13.494464447640638, -11.537786993550164],
              [-13.496927369195458, -11.535707680265933],
              [-13.49963686035168, -11.536049287709499],
              [-13.5006633415647, -11.538422049178667],
              [-13.502844887641798, -11.537853773567363],
              [-13.503006664460685, -11.535649096311156],
              [-13.504586247524584, -11.534713522733544],
              [-13.504990840133146, -11.533567484950154],
              [-13.506154131452673, -11.532742300925342],
              [-13.506608438308824, -11.531282772846902],
              [-13.507579914260603, -11.53030644932146],
              [-13.510040474709202, -11.531135092376735],
              [-13.510623158864059, -11.532481782301668],
              [-13.512335278862036, -11.531116371782677],
              [-13.514157319883875, -11.526173890135443],
              [-13.515682976541388, -11.524331688187617],
              [-13.519521230950502, -11.521023820525942],
              [-13.520892511567983, -11.518293747981327],
              [-13.52208381810646, -11.517524186884001],
              [-13.523506765551069, -11.515700103264841],
              [-13.524362979285458, -11.513707146963176],
              [-13.525292463704165, -11.510097810019415],
              [-13.525514105715724, -11.507542552700428],
              [-13.5248752695908, -11.506229012615387],
              [-13.52505500667296, -11.504269987369964],
              [-13.527197114336644, -11.501352244520268],
              [-13.526608004330678, -11.499726215730977],
              [-13.52829673512035, -11.499340747475307],
              [-13.529074422613162, -11.497140268364783],
              [-13.531338119907447, -11.493979678960457],
              [-13.532156492734458, -11.492259987253727],
              [-13.533041802141879, -11.492009219767528],
              [-13.533845311454051, -11.489724342071582],
              [-13.535081127025983, -11.488035805605993],
              [-13.535963592135792, -11.4854948998069],
              [-13.536561104152147, -11.485252473977138],
              [-13.538286532896175, -11.481982099080753],
              [-13.538991426877578, -11.478175533067564],
              [-13.538563555411612, -11.476647213768475],
              [-13.538372819705517, -11.473742411239892],
              [-13.536496909356881, -11.472296642529697],
              [-13.534254604847245, -11.46943446994493],
              [-13.533697928568536, -11.466187734006155],
              [-13.532983198392031, -11.465740913474832],
              [-13.531984569369861, -11.46315603099678],
              [-13.530777555165988, -11.461395891874739],
              [-13.531155449368393, -11.459875463902883],
              [-13.532151236829263, -11.458959681094939],
              [-13.531352019628322, -11.457414635338447],
              [-13.528256920514373, -11.454110554678397],
              [-13.526839614537595, -11.453639818030636],
              [-13.52717131293263, -11.451966350771913],
              [-13.524237484100345, -11.451647709231123],
              [-13.522086562976513, -11.450490335090562],
              [-13.520220075108499, -11.451003901179009],
              [-13.518413421053316, -11.4522351555008],
              [-13.513752044581423, -11.454103163399232],
              [-13.510933604694822, -11.455684206799088],
              [-13.506913334069557, -11.456857047107006],
              [-13.506469370720415, -11.457517459745684],
              [-13.502544719806863, -11.458531736638186],
              [-13.50068190538407, -11.459325785889849],
              [-13.498321918561826, -11.459736054147442],
              [-13.496196813412158, -11.461665775106564],
              [-13.491804729010296, -11.46309869112579],
              [-13.491048363134588, -11.462028741493212],
              [-13.487571664527113, -11.460698358928965],
              [-13.4919761732628, -11.457868564675136],
              [-13.492726618775846, -11.456085550136157],
              [-13.491369971216374, -11.455115077344535],
              [-13.491495882326792, -11.453657790072219],
              [-13.492421671219452, -11.452676283572107],
              [-13.49534061199353, -11.45290327597569],
              [-13.495651901785381, -11.452063112244257],
              [-13.494032606666412, -11.450873591760269],
              [-13.495755611062648, -11.449618997360618],
              [-13.497815519958591, -11.45061394387359],
              [-13.500455117772399, -11.449308768762254],
              [-13.501661495922955, -11.449999325909692],
              [-13.504090188906476, -11.448910169720241],
              [-13.507805161533811, -11.448254561336114],
              [-13.509396363414092, -11.44635307099818],
              [-13.50591372650224, -11.445211688215426],
              [-13.506258006394143, -11.44396203992673],
              [-13.508525162399431, -11.442778114488778],
              [-13.512531040091954, -11.441790705767634],
              [-13.51366772894708, -11.440732909405511],
              [-13.515699818092365, -11.4412037707021],
              [-13.513896780355703, -11.443180816952918],
              [-13.514443140338933, -11.443858132146362],
              [-13.516592537980097, -11.443804102830313],
              [-13.519227876196968, -11.441890407486603],
              [-13.521166748743006, -11.441446101046012],
              [-13.521116263141348, -11.439939230278624],
              [-13.519637308171783, -11.438609414864795],
              [-13.514367816250129, -11.438798366476405],
              [-13.509368046146324, -11.438273485081755],
              [-13.506532362258572, -11.439005578267343],
              [-13.505871569814662, -11.440205951602493],
              [-13.504478087463513, -11.440719388730733],
              [-13.50304908050292, -11.440288621330728],
              [-13.501008221075956, -11.441352903655917],
              [-13.498823191786888, -11.440460488286998],
              [-13.499288786676237, -11.438827602231763],
              [-13.500317245556394, -11.437364589381767],
              [-13.499693061641768, -11.433770566640915],
              [-13.499484798666154, -11.430815622485763],
              [-13.497792270924815, -11.42941777441518],
              [-13.500603355924937, -11.42695611022356],
              [-13.499712628372833, -11.426173975544003],
              [-13.49821600752031, -11.427167308495811],
              [-13.49649064346777, -11.427531880122096],
              [-13.494064249790565, -11.428617172889702],
              [-13.492696600989705, -11.429649445795896],
              [-13.489486132300984, -11.429610490875548],
              [-13.487606082573953, -11.430160773976658],
              [-13.486264815123741, -11.429754250370461],
              [-13.48378471037211, -11.430402478735502],
              [-13.48228954287043, -11.430182063248138],
              [-13.480396402422379, -11.431521446797259],
              [-13.478324034443832, -11.432526202763837],
              [-13.47716747942675, -11.437685634228233],
              [-13.47421230125537, -11.439076993343509],
              [-13.47031239324023, -11.444200025502214],
              [-13.467891514676756, -11.446595948958892],
              [-13.46527314916043, -11.450662862733125],
              [-13.463280238238655, -11.455903956413398],
              [-13.461650089511638, -11.457747389899081],
              [-13.461396662440881, -11.460197695603341],
              [-13.460229041726802, -11.461480689719961],
              [-13.457487811697458, -11.460224385749804],
              [-13.457359545244802, -11.457330049649261],
              [-13.455337891700589, -11.45755614120802],
              [-13.453836260939868, -11.460188023519724],
              [-13.453559697768867, -11.462257834702715],
              [-13.45229076904962, -11.465805087197644],
              [-13.447924082321157, -11.464566279932628],
              [-13.448178835847932, -11.465861972363243],
              [-13.446851600589559, -11.467940105814632],
              [-13.445456724747007, -11.468732797763211],
              [-13.445106295611511, -11.469984824210071],
              [-13.443477027236508, -11.472112031606143],
              [-13.442434578073689, -11.472543463209576],
              [-13.442270660461414, -11.474556636395391],
              [-13.441138153285321, -11.47557038011926],
              [-13.44045512213504, -11.478315932083548],
              [-13.439129529819363, -11.479036587151173],
              [-13.437305321229905, -11.47772856391579],
              [-13.438014145153472, -11.481791783593886],
              [-13.439018187370111, -11.483881703707674],
              [-13.440342830312694, -11.487664674827634],
              [-13.438176669273068, -11.48817664100399],
              [-13.434133133518252, -11.490837072093022],
              [-13.4325947203552, -11.490272659744447],
              [-13.431301315993073, -11.492835245949825],
              [-13.429329908785201, -11.495426128053637],
              [-13.428719087689649, -11.494346704342352],
              [-13.428937997388134, -11.49291059254103],
              [-13.427743281003325, -11.49141752996471],
              [-13.427099588072831, -11.488496532731935],
              [-13.427408827568977, -11.48483497967298],
              [-13.428340764153623, -11.482961125109004],
              [-13.429292640590216, -11.482220407238067],
              [-13.42882277318692, -11.480104959706246],
              [-13.427872523478559, -11.47770203684681],
              [-13.428891052295457, -11.475855764024011],
              [-13.429969419422074, -11.475763890049285],
              [-13.430693194435408, -11.47274903659352],
              [-13.430927082058089, -11.470522440083748],
              [-13.431734083976162, -11.468143407191846],
              [-13.433462056223203, -11.466610201892582],
              [-13.434677295937503, -11.46698253028598],
              [-13.436959894119564, -11.46669703238127],
              [-13.436627885929292, -11.465048387684018],
              [-13.438551496878693, -11.462450442418342],
              [-13.438054747633052, -11.460423977766203],
              [-13.43559926853917, -11.459015946004946],
              [-13.432596846523797, -11.459173024881924],
              [-13.431162917064357, -11.460232914805884],
              [-13.428658257644901, -11.45927691744316],
              [-13.426572443643678, -11.459245459428622],
              [-13.423917852616862, -11.458757855775648],
              [-13.4248512024684, -11.46120141783405],
              [-13.424306387281124, -11.46215933073461],
              [-13.422836878320542, -11.462880212626226],
              [-13.424229261387858, -11.46523094156116],
              [-13.422891972620667, -11.466133364770057],
              [-13.42132907504912, -11.46476176399596],
              [-13.4184276220814, -11.461617628991679],
              [-13.417267930880705, -11.461964259458766],
              [-13.414849872899515, -11.461031831356696],
              [-13.411949143043104, -11.460887251167367],
              [-13.410886115405988, -11.457518841090987],
              [-13.408367727592395, -11.454097478057054],
              [-13.408548800177106, -11.450063582431348],
              [-13.412119912215068, -11.449698663690432],
              [-13.413391425307942, -11.451114446344455],
              [-13.41464389888746, -11.451134978470847],
              [-13.415203305652577, -11.453000729383747],
              [-13.416783376825975, -11.4542195381711],
              [-13.417277596051468, -11.452684425696674],
              [-13.416703981266226, -11.45211851077617],
              [-13.415870773276877, -11.448216407629959],
              [-13.417058994084682, -11.448070684933343],
              [-13.418305596311518, -11.449488336440371],
              [-13.420829681380434, -11.450924422336826],
              [-13.422361672851965, -11.450995346200632],
              [-13.424609792047702, -11.449456530444804],
              [-13.426422757948668, -11.449592570502087],
              [-13.427874081302374, -11.447883656460062],
              [-13.431422748799552, -11.448692952909239],
              [-13.432101871828184, -11.446419512444635],
              [-13.43028804545349, -11.44197550322572],
              [-13.431878353230658, -11.441762042437247],
              [-13.436024066160096, -11.442332910890784],
              [-13.43712435157524, -11.446930605737197],
              [-13.438576448985495, -11.447001242402921],
              [-13.437699768942775, -11.444532050968332],
              [-13.437656381461581, -11.442880548300721],
              [-13.439416064764382, -11.441688361975439],
              [-13.440746485168079, -11.443032336043444],
              [-13.44188576938849, -11.441696560902473],
              [-13.443440846766947, -11.441143619129297],
              [-13.444466705457515, -11.43911855267304],
              [-13.445363296427681, -11.43869153582459],
              [-13.447780924905421, -11.435876949999258],
              [-13.447117140240332, -11.434083605081993],
              [-13.44893921650662, -11.433285398234162],
              [-13.449482905951355, -11.430526562722825],
              [-13.445978013809055, -11.429760383099255],
              [-13.445945077650576, -11.426290831067183],
              [-13.44741116936527, -11.424076347814074],
              [-13.45154419579547, -11.422725423026534],
              [-13.452974501190766, -11.422555964208488],
              [-13.456633418485758, -11.42045214911216],
              [-13.459366361895581, -11.419466337581062],
              [-13.459342776489894, -11.41819862107498],
              [-13.457816446807135, -11.417778467273273],
              [-13.453792798292932, -11.417901750011215],
              [-13.452909663479767, -11.417397974529985],
              [-13.452613997006923, -11.41609317075365],
              [-13.45379598252269, -11.414914123486682],
              [-13.454998210775251, -11.414862165745083],
              [-13.455947933162271, -11.413518615781602],
              [-13.458649971306423, -11.412478071463633],
              [-13.460505618676716, -11.412158742607229],
              [-13.462694128224529, -11.410494148588997],
              [-13.464122627516616, -11.41032408836572],
              [-13.466890348079184, -11.409069656380089],
              [-13.4675736718635, -11.408112145267133],
              [-13.47079661784139, -11.406763792628846],
              [-13.472124542057767, -11.405116893757102],
              [-13.476330526584926, -11.402877567497624],
              [-13.47910102650498, -11.402554370464292],
              [-13.480607178570436, -11.403296545886738],
              [-13.482087295873125, -11.400779784707499],
              [-13.484894630330178, -11.399182545231827],
              [-13.485604981842634, -11.399636140194437],
              [-13.48796075267662, -11.398676601211928],
              [-13.489941880955909, -11.399014861642234],
              [-13.490078634519326, -11.398284927047671],
              [-13.487532604373168, -11.397412094366205],
              [-13.4862077184775, -11.396217656797093],
              [-13.48632396203714, -11.393459084547532],
              [-13.485956018648917, -11.391484614797003],
              [-13.487294007771471, -11.389796764225089],
              [-13.488317604195412, -11.389549231988541],
              [-13.490376749613079, -11.387522391013782],
              [-13.49072500480231, -11.38567391555898],
              [-13.488219766330698, -11.38104988554518],
              [-13.482761129032722, -11.377107775388218],
              [-13.478553391491326, -11.376522337568826],
              [-13.477581857971385, -11.37496938450257],
              [-13.477219277305757, -11.373137201056924],
              [-13.476183532125676, -11.37193682357848],
              [-13.472966752649967, -11.369278677445832],
              [-13.473431181485456, -11.367373994693134],
              [-13.472673285453267, -11.366490752529065],
              [-13.47071393270252, -11.367007702192586],
              [-13.469171484944141, -11.36532585579992],
              [-13.467388840284992, -11.364546963174147],
              [-13.463575369054062, -11.365099605027975],
              [-13.461161864262323, -11.364963787156698],
              [-13.456761031795224, -11.365427293276062],
              [-13.455984696236996, -11.365933729524164],
              [-13.454347256540315, -11.365290525112258],
              [-13.452777921344886, -11.365320093429073],
              [-13.45076514945143, -11.366144119342184],
              [-13.449430884689257, -11.364848784475418],
              [-13.44455513785593, -11.364277779240652],
              [-13.443445381561732, -11.36449442296314],
              [-13.439708669950914, -11.363760785234525],
              [-13.437924581857171, -11.362837013963006],
              [-13.434984007621615, -11.363745132618194],
              [-13.430935789941621, -11.366034647964149],
              [-13.427282931535842, -11.366209242469372],
              [-13.423711321502955, -11.365102682785718],
              [-13.422324687118943, -11.364998852389098],
              [-13.419129176063526, -11.365612778884989],
              [-13.417061483347773, -11.364980636308553],
              [-13.416553770789788, -11.364164207068901],
              [-13.413935054452606, -11.362890534767137],
              [-13.411604217156759, -11.362594425271988],
              [-13.41043300158576, -11.363576671008934],
              [-13.408884722428503, -11.363559640451994],
              [-13.405537706828419, -11.36572006870721],
              [-13.40099884140465, -11.36451737270216],
              [-13.399962483980227, -11.36468785511747],
              [-13.397492327539657, -11.366519315376722],
              [-13.394209669525134, -11.366358120764827],
              [-13.39234448041205, -11.365023116692994],
              [-13.390438491164684, -11.364234846448834],
              [-13.389160747694113, -11.364280309262007],
              [-13.388210896074241, -11.365747352021534],
              [-13.387049256046208, -11.36649973346735],
              [-13.38499643896002, -11.366724325395174],
              [-13.381976840197675, -11.365883923495602],
              [-13.380443616847074, -11.367410132868631],
              [-13.376745806806838, -11.36819815623717],
              [-13.374521054687067, -11.367779104705363],
              [-13.372521326827451, -11.368285451370522],
              [-13.369980066384715, -11.36757767964687],
              [-13.369192858263379, -11.367927576776673],
              [-13.367054801450552, -11.36681537027339],
              [-13.365627309801338, -11.366502783146622],
              [-13.363268291562067, -11.365123746756819],
              [-13.362192781102095, -11.363335767536302],
              [-13.361015941734927, -11.362871383569052],
              [-13.357270501040915, -11.362873784771619]
            ]
          ],
          [
            [
              [-13.5248015988479, -11.685535123235084],
              [-13.524594834659473, -11.684208125079113],
              [-13.523486035294184, -11.683267738210498],
              [-13.523336421042973, -11.682183130136572],
              [-13.522108871237494, -11.680687293729738],
              [-13.520266629651365, -11.68009867805985],
              [-13.51833959835789, -11.68009986816354],
              [-13.517762745980749, -11.682295745459184],
              [-13.516948092045093, -11.683381210120084],
              [-13.517764940056542, -11.684331397625083],
              [-13.517343708344688, -11.685390618973232],
              [-13.519041046032385, -11.685984139436226],
              [-13.519993136867376, -11.689482339960913],
              [-13.51994262184703, -11.692165515772547],
              [-13.518662535952776, -11.694299085022791],
              [-13.519387079822438, -11.696026874037935],
              [-13.518952117166789, -11.698077800064537],
              [-13.51915888634757, -11.700080208967883],
              [-13.516744903494994, -11.70245055780109],
              [-13.516756256622042, -11.705723111014366],
              [-13.516008936017855, -11.711475411437675],
              [-13.516469410878248, -11.71217947068927],
              [-13.515932181017426, -11.714408103208042],
              [-13.5248015988479, -11.685535123235084]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -133.01665449768942,
          "lat": 55.801123401079735
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02198"],
        "coty_name": ["Prince of Wales-Hyder"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Prince of Wales-Hyder Census Area"],
        "coty_fp_code": "198",
        "coty_gnis_code": "01419980"
      },
      "bbox": [
        -13.538991426877578, -12.112887427084083, -12.624504810731388,
        -11.359305295279547
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5291139498337953, -4.369507377813363],
            [2.5867244265000853, -4.369341154925516],
            [2.6296440770275358, -4.368935194720804],
            [2.630394447440978, -4.4276151732255915],
            [2.67357568964128, -4.427478272805138],
            [2.717202207911398, -4.427070444375087],
            [2.7604543289969987, -4.426922708214718],
            [2.760324341362037, -4.456319412269518],
            [2.8501635674965744, -4.456042452363347],
            [2.8497171628657654, -4.464271988918654],
            [2.85498860233052, -4.465985671600421],
            [2.856413552897866, -4.461515978945878],
            [2.861726548450616, -4.465267586509844],
            [2.8721637067770875, -4.465437253397527],
            [2.8784056332368912, -4.463154762643674],
            [2.881496824763144, -4.465333085365651],
            [2.8918321137344947, -4.463260556693623],
            [2.8955675050889043, -4.463745574114154],
            [2.897184338808394, -4.467834888827417],
            [2.8962724846285033, -4.471976725438637],
            [2.893031425713968, -4.474688103051665],
            [2.8939616167913678, -4.4794450680193885],
            [2.8988932818072155, -4.478839263926884],
            [2.8972902513660075, -4.4850551621875026],
            [2.902678087363168, -4.489086018663723],
            [2.9023969617419225, -4.492737610711379],
            [2.9041409910431444, -4.4980518884337695],
            [2.9012909920459116, -4.49964652588716],
            [2.898833419383429, -4.5037326968217695],
            [2.8955702435654898, -4.505621401800897],
            [2.8947477563448603, -4.511433609422728],
            [2.890745603926495, -4.520152751020028],
            [2.8902255359129225, -4.526699083218004],
            [2.891078385711305, -4.534127401182057],
            [2.8932183949511066, -4.5376290163749315],
            [2.8923943584382985, -4.542044743931767],
            [2.894934851275353, -4.545471508166014],
            [2.9000549709135583, -4.544715264113085],
            [2.9028538663376793, -4.538974560774065],
            [2.9064624328999735, -4.540377646179478],
            [3.020262242267793, -4.541094446215802],
            [3.019980419503499, -4.58445395411518],
            [3.020157534516171, -4.598852681869268],
            [3.0202575422503157, -4.714345002072085],
            [2.974049893585573, -4.712778124523313],
            [2.970725349832581, -4.72202475866239],
            [2.9644945488662042, -4.7255017341514405],
            [2.966364409750771, -4.7289020354423155],
            [2.971666642169872, -4.7293957806994085],
            [2.9743834416516997, -4.7364737869556075],
            [2.9798294047660536, -4.73035505439437],
            [2.9837894514922185, -4.731714802404999],
            [2.9817927763772976, -4.7380014588855],
            [2.984723254356253, -4.743244786199086],
            [2.9839484104438796, -4.749392594868249],
            [2.986579770144562, -4.751130346650334],
            [2.990697583017869, -4.750027456486149],
            [2.992001134475913, -4.7539233868489195],
            [2.9872878216125303, -4.760457002133004],
            [2.9892618787375924, -4.767527736042935],
            [2.9953336805839545, -4.769683763723774],
            [2.999141730221785, -4.7670093660886765],
            [2.9998933625401687, -4.762911682706997],
            [3.00520156403423, -4.765149901548364],
            [3.004081515909601, -4.769262555551918],
            [3.001026253463579, -4.7693925017989836],
            [3.0008572861106533, -4.773771650180765],
            [3.009277967460788, -4.779772251865515],
            [3.0111262782510124, -4.784332999599801],
            [3.0087559953498197, -4.786807573103769],
            [3.010740547707843, -4.79023681365694],
            [3.0214309962744, -4.792280008395916],
            [3.0227210870032963, -4.795524611926042],
            [3.0152368077080567, -4.7970930102631035],
            [3.0095549797243932, -4.800250580676772],
            [3.0071853697868813, -4.804304951495594],
            [3.0085840863550155, -4.807910764057971],
            [3.015031104718271, -4.814695425050202],
            [3.0153013717134307, -4.8189754718121565],
            [3.0130927491827597, -4.820195204054898],
            [3.013984402507178, -4.826082130775333],
            [3.0180829835574765, -4.83014629300665],
            [3.013651368264928, -4.834562812376313],
            [3.017302231402994, -4.840306675554985],
            [3.0242061043886554, -4.841583535504945],
            [3.027648127411767, -4.839281827476882],
            [3.033447414335442, -4.843653158964093],
            [3.0353912510361067, -4.8510548020497595],
            [3.038581271853451, -4.8527360507284305],
            [3.038341007625685, -4.8579553146627665],
            [3.0367498147183607, -4.860737115298635],
            [3.0251621689774204, -4.86624244348969],
            [3.0292975442222247, -4.872049892731052],
            [3.029464282365716, -4.874436609665475],
            [3.023911564338111, -4.875377839972588],
            [3.0202567622536636, -4.882196089117815],
            [3.0258327432728658, -4.8881584902522714],
            [3.0223839850516883, -4.889946819862678],
            [3.0144535997325823, -4.886654531106949],
            [3.010075079475935, -4.883144064349253],
            [3.009176367560929, -4.880105225694218],
            [3.0044904017763012, -4.877321388646525],
            [3.001609967549384, -4.879862751209565],
            [2.9938759942456006, -4.8800226194001235],
            [2.993559055980839, -4.886640611187713],
            [2.9884965372162853, -4.8876940501014765],
            [2.9874871138743235, -4.899330923657517],
            [2.9782881427683554, -4.902957398227317],
            [2.974622270005188, -4.905590935030361],
            [2.9714032466854636, -4.905490785725657],
            [2.9661593931744727, -4.909585013988499],
            [2.9539900707909923, -4.912206408025175],
            [2.9496270785121395, -4.918028739192524],
            [2.94706772526921, -4.917424762295618],
            [2.944759952215848, -4.9235694050811585],
            [2.93866771174822, -4.922232040188657],
            [2.9313580269262416, -4.922828135499452],
            [2.9206152123952855, -4.929003075295548],
            [2.9183326234011417, -4.928801206707573],
            [2.9134041830768496, -4.932186891306803],
            [2.905348570624762, -4.930029518196374],
            [2.903166054955351, -4.926845029986477],
            [2.89674311862371, -4.925948458952317],
            [2.891830988417198, -4.923081948217107],
            [2.8911457821831843, -4.920744500916004],
            [2.88216774726743, -4.91670140668681],
            [2.8800164221508897, -4.914482189631553],
            [2.870381125948311, -4.918583045181606],
            [2.8735788491001615, -4.92135884235459],
            [2.867278703209518, -4.927131168314957],
            [2.852737783745879, -4.926718556160988],
            [2.8392642345905394, -4.915194170777114],
            [2.8323133464637595, -4.911602292079839],
            [2.833122309723662, -4.90640984330303],
            [2.829236504218995, -4.900057310219252],
            [2.827399022085678, -4.894835871087782],
            [2.824196402350408, -4.893034245601428],
            [2.82199445923078, -4.88895219801139],
            [2.816084026218469, -4.892540281500113],
            [2.8171966454840733, -4.895205095800187],
            [2.8091520604081768, -4.894609982070168],
            [2.8010008849420607, -4.899352098902931],
            [2.793869512821166, -4.899112852522671],
            [2.790539552261329, -4.905310340641813],
            [2.7854467996857424, -4.9021222127207835],
            [2.7861671703295094, -4.899012324153685],
            [2.7828565849741165, -4.895546422018307],
            [2.779963207208181, -4.889668206426522],
            [2.77388441733884, -4.888687243695614],
            [2.766160926394743, -4.8836058989634195],
            [2.763823594580382, -4.885258833027528],
            [2.7571247495370845, -4.877979644826445],
            [2.7542327465776086, -4.877430324761583],
            [2.743310162134095, -4.879776131882253],
            [2.741387972589075, -4.877261220145335],
            [2.738102276981082, -4.8780019988525725],
            [2.732107455958176, -4.876931039266318],
            [2.7256096625983206, -4.878708795695797],
            [2.722809368775662, -4.875390273089847],
            [2.718078845471811, -4.872721458298692],
            [2.7170867264657614, -4.868329588344257],
            [2.710936465947937, -4.871103391559258],
            [2.7106889996053494, -4.86826668382613],
            [2.7023107980796306, -4.863773060441211],
            [2.698056349502379, -4.863998531189613],
            [2.690549196992026, -4.851604008042883],
            [2.691769950175335, -4.848493530231008],
            [2.68567784169018, -4.839380983121763],
            [2.684510259816011, -4.834802529311241],
            [2.6847178202089115, -4.825817615034193],
            [2.6856023989744915, -4.82327088030125],
            [2.689723283129449, -4.821476083014171],
            [2.6893951481057434, -4.816389627713498],
            [2.6868206401684995, -4.811204013020461],
            [2.6757121001288167, -4.801513625726359],
            [2.672916121618658, -4.802861787059765],
            [2.6682469144355623, -4.799113264982911],
            [2.6702879131666557, -4.794093509023232],
            [2.6666507189106414, -4.790772799187752],
            [2.6615912604152205, -4.792466284540042],
            [2.6574072169363934, -4.789578258955628],
            [2.6543696254003653, -4.784578991400858],
            [2.6522807622152524, -4.778173095044272],
            [2.654264959858645, -4.774783198737776],
            [2.649495138916018, -4.772261526769769],
            [2.6453319542857336, -4.7754226351670725],
            [2.640394635456648, -4.769016053096],
            [2.6402382199063443, -4.763266132154932],
            [2.6380495720619135, -4.7609895042013],
            [2.635213938422392, -4.764429779462979],
            [2.631427239173217, -4.757968552675473],
            [2.6263810589508063, -4.755009084938768],
            [2.6258829931619516, -4.752522765183056],
            [2.6227042709793547, -4.747419297484654],
            [2.623118677951273, -4.74050022007323],
            [2.620241031820326, -4.737446403453884],
            [2.6216695671511556, -4.733517776324595],
            [2.618345831675521, -4.727183365887351],
            [2.6203139828763367, -4.723480919091406],
            [2.6168150006298867, -4.716863816856273],
            [2.6132858720777112, -4.715219750507944],
            [2.609275697697366, -4.70877592702919],
            [2.59847580817749, -4.7046335090832585],
            [2.6022043409240956, -4.698549765798028],
            [2.59552687618368, -4.697839501088113],
            [2.5960832970690864, -4.690206641191467],
            [2.594893087509204, -4.684151136718856],
            [2.588455247914073, -4.672240295805177],
            [2.5778362619497597, -4.663350983790553],
            [2.572963188611134, -4.6601648894061665],
            [2.574621721906395, -4.654468989851896],
            [2.5716928684224456, -4.647273917295592],
            [2.572019289894075, -4.6400734889787945],
            [2.5643593451440436, -4.6310357948133],
            [2.5671546731317285, -4.624237082222837],
            [2.5653761149253085, -4.618537617557027],
            [2.565451990438539, -4.608896784314712],
            [2.562817373450417, -4.596220527961857],
            [2.5654173478261537, -4.590238401274484],
            [2.557356571528672, -4.588090969113484],
            [2.556505203152753, -4.58436467004234],
            [2.5630573986235747, -4.581145573529712],
            [2.5606836226718883, -4.578196622736169],
            [2.553073008540539, -4.580460049327408],
            [2.553622358918968, -4.5710257805276],
            [2.5571398390428692, -4.569716897400009],
            [2.5582667561927535, -4.5644261630433025],
            [2.562413555191134, -4.562187720397065],
            [2.5575161986199744, -4.557572705983271],
            [2.5544432268252826, -4.557091096583797],
            [2.5519797920430505, -4.547461365608026],
            [2.5536633859228424, -4.542288203323814],
            [2.5526417825500904, -4.539449360289742],
            [2.5544476129766345, -4.534463754342089],
            [2.557531805074985, -4.531186472217061],
            [2.556629775828335, -4.528580574843956],
            [2.5523256786224873, -4.525328894273835],
            [2.5480002649710247, -4.520104715587098],
            [2.553250856198948, -4.51395568507975],
            [2.5565029520253324, -4.5126757833768565],
            [2.5584656224036206, -4.506934778230193],
            [2.5487673537419644, -4.498381699244537],
            [2.5464983202723905, -4.504776967942702],
            [2.5331567861895774, -4.501447659115452],
            [2.5305152673811304, -4.502314509233536],
            [2.5219692063098615, -4.501483595861181],
            [2.5195081405782105, -4.499214623917717],
            [2.513043353316415, -4.497322956000181],
            [2.5125702832638597, -4.457538645204498],
            [2.529866320289296, -4.457514533348812],
            [2.5291139498337953, -4.369507377813363]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.17637601970543, "lat": 34.05097394477862 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05019"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00066845"
      },
      "bbox": [
        2.5125702832638597, -4.932186891306803, 3.038581271853451,
        -4.368935194720804
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.575112162970353, 4.023887171861774],
            [-18.551527580624274, 4.0171719843107745],
            [-18.561402473844534, 3.982190219854687],
            [-18.547477103956062, 3.978757943946382],
            [-18.549532998214833, 3.971752664660614],
            [-18.5425093447452, 3.969810672208521],
            [-18.54874570511287, 3.9479341238994055],
            [-18.541446104216853, 3.9459634631737464],
            [-18.545453228150286, 3.9322719265431165],
            [-18.552587526676454, 3.9340712479739817],
            [-18.556659868419466, 3.919883677914957],
            [-18.560285484021453, 3.9207709076116735],
            [-18.56185819834376, 3.915810230949294],
            [-18.575019925562803, 3.9196838728085956],
            [-18.58075765046287, 3.8987336788762184],
            [-18.5875396515337, 3.9006920716501874],
            [-18.591452180423264, 3.8862114531009087],
            [-18.598701618051717, 3.8882326055214746],
            [-18.606473629421863, 3.86089999827442],
            [-18.59954332789482, 3.858748824573419],
            [-18.60727503138317, 3.8307689176152406],
            [-18.61420745037295, 3.832817390547558],
            [-18.622481214352135, 3.804781740409865],
            [-18.615574901183244, 3.802713129577981],
            [-18.61933645580071, 3.7887669904969767],
            [-18.63333992336397, 3.792326543753562],
            [-18.637173770117542, 3.778213997321622],
            [-18.623245989738553, 3.7745226421408478],
            [-18.631665680187513, 3.746539489763476],
            [-18.622226604787468, 3.7438201334837067],
            [-18.62410733857216, 3.7355599573848517],
            [-18.61064302300043, 3.731811934662831],
            [-18.61263662103251, 3.7246349594246886],
            [-18.598699480751424, 3.7208859901452445],
            [-18.602113875438032, 3.7064349524916205],
            [-18.595292041026028, 3.7041672831278123],
            [-18.598998783853258, 3.6898864399665046],
            [-18.58540025770782, 3.6861715540053486],
            [-18.589322170205946, 3.6719520861647217],
            [-18.579183142168077, 3.6690368226990473],
            [-18.581831162141818, 3.6549283872884053],
            [-18.575076056909282, 3.652999527355498],
            [-18.5770745062378, 3.645973248566157],
            [-18.567055366996613, 3.6431267376896055],
            [-18.568122237223804, 3.6395040609645672],
            [-18.56464531343498, 3.6384924863325545],
            [-18.56567622348927, 3.6348245013928753],
            [-18.56234856063857, 3.633834906423109],
            [-18.56671644801371, 3.620456891558738],
            [-18.55348724492601, 3.6180870586161693],
            [-18.55716544606554, 3.6038916164072945],
            [-18.54476086208806, 3.600309742984182],
            [-18.544940800796628, 3.591790965118667],
            [-18.546399384243024, 3.586139428730711],
            [-18.53271674916365, 3.582604930015318],
            [-18.536377756622795, 3.568411406268352],
            [-18.522727666861982, 3.5646943959969257],
            [-18.52616887854373, 3.551296915264257],
            [-18.524947082106067, 3.5509197260878267],
            [-18.527808494383784, 3.5396686689487193],
            [-18.51457637531709, 3.5355950998235106],
            [-18.518237686603772, 3.5214111129305214],
            [-18.504130415325303, 3.517811045599529],
            [-18.507921856490505, 3.5037266524891377],
            [-18.501966235384103, 3.502009298838535],
            [-18.5037469621107, 3.4950141357999684],
            [-18.498040752562662, 3.493563122485289],
            [-18.499873493318955, 3.4866184828484896],
            [-18.486125680521898, 3.4829268840762713],
            [-18.493905739239345, 3.4551342062168957],
            [-18.47914653098376, 3.45101974809399],
            [-18.480777518478735, 3.444122470190664],
            [-18.46696394479514, 3.440272835082401],
            [-18.46898369297337, 3.4332977659837076],
            [-18.462572970321183, 3.431408173343905],
            [-18.465250426928872, 3.4214437356841643],
            [-18.458182482442982, 3.4195831199425295],
            [-18.457831812557554, 3.4131364814605996],
            [-18.463090197832038, 3.4020287219424494],
            [-18.483666808650298, 3.4075939409495617],
            [-18.48806813706101, 3.3899055918058973],
            [-18.494980982099484, 3.3916754159963367],
            [-18.496019269554132, 3.3882448812206714],
            [-18.51460750395872, 3.3919479242264634],
            [-18.5161412701764, 3.385338896090233],
            [-18.52285492539607, 3.3868820911886064],
            [-18.530476147314083, 3.358831212841145],
            [-18.53724938267695, 3.3603348652425784],
            [-18.53921006857783, 3.354041433801432],
            [-18.558427245334094, 3.359383482273814],
            [-18.55641873357296, 3.3661138746047077],
            [-18.574604125533966, 3.3715909974604035],
            [-18.597225755389932, 3.3770954903133124],
            [-18.60063043931648, 3.3638989797960654],
            [-18.627867965693866, 3.371008785660793],
            [-18.625676684941162, 3.3782030960926863],
            [-18.64674867758897, 3.383220050802074],
            [-18.6527539032006, 3.362117432642654],
            [-18.65629002857677, 3.3630228122246963],
            [-18.659167034173468, 3.352389524724198],
            [-18.66268473844955, 3.3534833263805335],
            [-18.665481544801352, 3.34269014647216],
            [-18.67237674541263, 3.3443742425752196],
            [-18.674319813561034, 3.337481783810702],
            [-18.68113833927535, 3.3394664131802316],
            [-18.682114034629503, 3.335930939212171],
            [-18.685690183449154, 3.336844188537999],
            [-18.68863757538084, 3.3265221239685916],
            [-18.6940778256135, 3.326110505450693],
            [-18.69709711172284, 3.318180406431138],
            [-18.696315629312434, 3.304821740587962],
            [-18.692597033712634, 3.3021927984312587],
            [-18.693027762525308, 3.297862936685979],
            [-18.69963589191726, 3.2961386796526098],
            [-18.70894431120716, 3.291272324499695],
            [-18.711550321974666, 3.2880413560492046],
            [-18.715915600725033, 3.286650774271366],
            [-18.720736321192295, 3.2819086076185857],
            [-18.719434893338562, 3.276770266563803],
            [-18.72611795692229, 3.2640292974322076],
            [-18.731365790672918, 3.2568490415889806],
            [-18.735354343950508, 3.2548482909403087],
            [-18.737990458077036, 3.2461755334158933],
            [-18.74604341191604, 3.2454125063317125],
            [-18.75132723896755, 3.240837128869693],
            [-18.762286549153927, 3.23752892470308],
            [-18.76549661255879, 3.2336924707888803],
            [-18.76855162786465, 3.2334597549638153],
            [-18.77019088865974, 3.229021441751501],
            [-18.77496976458167, 3.230795515968235],
            [-18.779012005313128, 3.2306775006716286],
            [-18.784697960053307, 3.228160579358319],
            [-18.78819657832395, 3.229109704040858],
            [-18.790958160538047, 3.232328945196626],
            [-18.798859787678296, 3.2282362784859453],
            [-18.80306751959048, 3.228970637183395],
            [-18.80528180429998, 3.233206024331404],
            [-18.809044039508976, 3.234962189855176],
            [-18.813988531019476, 3.2317131458447244],
            [-18.815440992108094, 3.23424138487647],
            [-18.821729652954765, 3.236431630947725],
            [-18.82519506304849, 3.232597864533416],
            [-18.831077596107967, 3.2301609344761877],
            [-18.832097611994097, 3.223595232196465],
            [-18.83615412001273, 3.22595093529319],
            [-18.8410768160573, 3.2264184821202586],
            [-18.84427963754986, 3.2249121239242684],
            [-18.847582695233683, 3.227518561915756],
            [-18.851344949448446, 3.227482165608946],
            [-18.857165237399595, 3.229467426422469],
            [-18.85962390853643, 3.2323475417782115],
            [-18.866832382859226, 3.2330445518860733],
            [-18.872252233996747, 3.230304518319484],
            [-18.875218696647465, 3.231434748329746],
            [-18.879784452629412, 3.230254324194195],
            [-18.882812871924163, 3.227524256163982],
            [-18.888764600077266, 3.227851487025633],
            [-18.894468727351917, 3.2267926545836385],
            [-18.901156322500952, 3.2343745428534807],
            [-18.906207257643743, 3.235114009792185],
            [-18.909839025807, 3.2375655671931174],
            [-18.91377386262218, 3.2352754539746744],
            [-18.916646206749718, 3.235857754647901],
            [-18.92205420124926, 3.2424696353690976],
            [-18.92130741598168, 3.247791977123312],
            [-18.92612559691707, 3.25043784899532],
            [-18.927650080325407, 3.24772339136689],
            [-18.932054141301617, 3.2448462975971517],
            [-18.936346061322627, 3.2351833223480853],
            [-18.941781681497183, 3.230016485830086],
            [-18.94365566543507, 3.2315729628315686],
            [-18.946204722887757, 3.238998250132404],
            [-18.943800976705692, 3.241079887711494],
            [-18.99973824407035, 3.255465889565975],
            [-19.06861318045296, 3.2735083084531227],
            [-19.149670260662027, 3.2963408944354775],
            [-19.1488685596014, 3.3004203614198553],
            [-19.142447425729557, 3.314076588259232],
            [-19.135153990458555, 3.3252373137296263],
            [-19.13133900542897, 3.3266405373866137],
            [-19.12931661955332, 3.329597611745476],
            [-19.130636798279983, 3.332838259644629],
            [-19.12972090953879, 3.3432393880593154],
            [-19.127859669124888, 3.346791697302471],
            [-19.123659528062433, 3.3480634303114614],
            [-19.122718432557466, 3.35058221871833],
            [-19.115710505503376, 3.358298351560266],
            [-19.11263751234854, 3.359310309109078],
            [-19.114468914050807, 3.370219395774899],
            [-19.11283372426605, 3.3767957701409657],
            [-19.10867466007823, 3.3842084674700175],
            [-19.103418268626243, 3.3910996746325166],
            [-19.10312335385022, 3.3945852619417107],
            [-19.098947939257037, 3.3999583496515604],
            [-19.098021452867798, 3.403264678582229],
            [-19.093744600566644, 3.4102636030900624],
            [-19.091588302351788, 3.4099262940198427],
            [-19.089342600349305, 3.416195031969151],
            [-19.09003871041056, 3.420411709829833],
            [-19.08265975525155, 3.434133038177785],
            [-19.08314192159005, 3.4375230935436036],
            [-19.07688851734686, 3.445883447786166],
            [-19.077991556986287, 3.447220182727257],
            [-19.075223485434663, 3.4622257476081764],
            [-19.072880620580758, 3.4645659201758403],
            [-19.071956497511497, 3.4702179561947775],
            [-19.07296073999498, 3.482016543954079],
            [-19.071077011410633, 3.4830879615644053],
            [-19.071005484461885, 3.4895967517460114],
            [-19.064006597553533, 3.496954585950424],
            [-19.055156184532283, 3.5013283189165287],
            [-19.04974555279819, 3.5073748956465733],
            [-19.04826667725657, 3.5118772254405934],
            [-19.113736512881413, 3.5292533798838046],
            [-19.136915431235426, 3.5281936267198413],
            [-19.138786067350807, 3.53313992067401],
            [-19.14488797744525, 3.5326920653879603],
            [-19.150238584282636, 3.5372338684334936],
            [-19.151037236731252, 3.548876780876571],
            [-19.150023424587793, 3.5637193775267573],
            [-19.143489664654645, 3.5643559404526557],
            [-19.139468099487836, 3.565995508629506],
            [-19.14009301388075, 3.5691399536692576],
            [-19.146119418674136, 3.5727830539516154],
            [-19.14636616079996, 3.577307546125723],
            [-19.143975854579892, 3.580333794519798],
            [-19.137816494407048, 3.584366978349325],
            [-19.13768460277479, 3.5899027246030637],
            [-19.13560767278671, 3.59437171196448],
            [-19.13453297646566, 3.600600748760393],
            [-19.132644755256443, 3.6047542003784043],
            [-19.128746170330853, 3.6089108312379223],
            [-19.12045385479864, 3.6099263632386487],
            [-19.117561468995486, 3.6126972009220713],
            [-19.116803456160213, 3.6167243723830333],
            [-19.1181799663851, 3.6217547512270603],
            [-19.121444553072926, 3.6236382698421137],
            [-19.12288665072066, 3.629219732293601],
            [-19.1199175887616, 3.6361097165668186],
            [-19.115139656084228, 3.6425268181456487],
            [-19.111118577465888, 3.6446676799024758],
            [-19.105717734044973, 3.6447948573493294],
            [-19.100068441529842, 3.6429102674262617],
            [-19.097803354669185, 3.6465617464065083],
            [-19.098454428320167, 3.6514932041436627],
            [-19.10268858621098, 3.660268264732698],
            [-19.108972121484104, 3.658123291688476],
            [-19.112714907170602, 3.6589239199414783],
            [-19.116629584379325, 3.663776631522855],
            [-19.115996539395333, 3.6684317014952454],
            [-19.112978990654714, 3.67069923726418],
            [-19.106575818566565, 3.667561623875992],
            [-19.097527264403663, 3.6705900553789457],
            [-19.09338111402351, 3.6709723064043986],
            [-19.087227646576054, 3.6695947382207725],
            [-19.083329630497115, 3.6729957141199288],
            [-19.081125046542088, 3.6785960612595017],
            [-19.07226819696161, 3.679046582636213],
            [-19.06862196380814, 3.6821951015564367],
            [-19.066984890779697, 3.6857197968339115],
            [-19.068662162770536, 3.696754780516478],
            [-19.067749403070824, 3.6995142169038533],
            [-19.069264315180337, 3.7040241184833786],
            [-19.067947658023357, 3.708191473112809],
            [-19.063522956927656, 3.7128061347996417],
            [-19.062059810222483, 3.7183790193921347],
            [-19.065755686700598, 3.7206323726384714],
            [-19.072767142188958, 3.7092748613950595],
            [-19.077012214570193, 3.7090526329412365],
            [-19.079762171443022, 3.7142565842673174],
            [-19.075926044575215, 3.719888731112222],
            [-19.07252143905608, 3.7214064066252366],
            [-19.07042711562258, 3.7267243354522575],
            [-19.07150368901499, 3.732257189514944],
            [-19.07597519989134, 3.7316216313223767],
            [-19.077600137054976, 3.726055380730571],
            [-19.080498800097697, 3.7245052458428947],
            [-19.0855513385069, 3.72734743765981],
            [-19.087842772334735, 3.730567007598625],
            [-19.089553441066595, 3.739627319094591],
            [-19.0922010216828, 3.746921761780246],
            [-19.099605913533924, 3.7587767755843173],
            [-19.104776566349454, 3.762516121313538],
            [-19.108831242910536, 3.7704717033201653],
            [-19.11122252688199, 3.7839345475449204],
            [-19.105211067065255, 3.788693239872005],
            [-19.1001803162022, 3.799148558245228],
            [-19.103522887970257, 3.8029588597319415],
            [-19.10945537969653, 3.8020665267713354],
            [-19.112492675205086, 3.797560217388611],
            [-19.11678164112535, 3.803775940649552],
            [-19.117784102037966, 3.8099926784239404],
            [-19.120724715961373, 3.811681782777099],
            [-19.12645596648652, 3.8210147192591655],
            [-19.126164582593457, 3.8231894032014035],
            [-19.120179108076112, 3.8271824630936147],
            [-19.116486144660396, 3.833093155080113],
            [-19.116235879783787, 3.8361151073990594],
            [-19.1196196333667, 3.8406883404407597],
            [-19.121884285025327, 3.850066138186293],
            [-19.118944488090108, 3.8535182355219257],
            [-19.111948542955354, 3.8566541583336886],
            [-19.107035183462905, 3.863373744947284],
            [-19.106499606643023, 3.8683039228716884],
            [-19.098894281289606, 3.8741030086344717],
            [-19.09015678619357, 3.8823441766931905],
            [-19.09208295654634, 3.8869341753437263],
            [-18.974840094913393, 3.8535697839351717],
            [-18.966570219712978, 3.852088661483253],
            [-18.915591248712733, 3.838274361351453],
            [-18.916054040059183, 3.842451152985367],
            [-18.894730249147077, 3.836847216193997],
            [-18.884514023075077, 3.8435001914607154],
            [-18.87291682313244, 3.8472808047050893],
            [-18.870402174682408, 3.849212197929827],
            [-18.863888882119348, 3.868404078685104],
            [-18.86118257695773, 3.871930334611768],
            [-18.858624332321668, 3.8791038811553626],
            [-18.854038090082074, 3.8846694615764603],
            [-18.846465908432222, 3.891751871825917],
            [-18.84072151255188, 3.8937473189689302],
            [-18.835190840176228, 3.90301922707316],
            [-18.831638755960633, 3.9051193736534837],
            [-18.826802494359725, 3.904668004324953],
            [-18.81848983415415, 3.909342344182572],
            [-18.81382727540073, 3.914592055253538],
            [-18.773413356186396, 3.9015084858471267],
            [-18.76937043060452, 3.915572127720232],
            [-18.761817926804554, 3.9132420681035187],
            [-18.75455986098757, 3.941519338438547],
            [-18.747629110309624, 3.9394263656835156],
            [-18.743502708799028, 3.952765118742282],
            [-18.73747142942919, 3.951019039519389],
            [-18.73503687549558, 3.9583327372660766],
            [-18.728862263408356, 3.9563023499650742],
            [-18.72655843272767, 3.9643747260636264],
            [-18.71918538030806, 3.9623470322424543],
            [-18.71635136439823, 3.964311184763351],
            [-18.70668404456901, 3.998979099995674],
            [-18.69985158991293, 3.996925935674351],
            [-18.698106374089857, 4.003992305788948],
            [-18.642677929298234, 3.988752952050122],
            [-18.640675206898923, 3.995993878688039],
            [-18.6262759649536, 3.9921145889538128],
            [-18.624328470125658, 3.9991409213238587],
            [-18.61715561990567, 3.9969671123936625],
            [-18.61519824873712, 4.004029285026319],
            [-18.594760486922087, 3.99818015519585],
            [-18.592603576720673, 4.005533165058728],
            [-18.585423610306076, 4.003476397366833],
            [-18.5803141334292, 4.021965129418183],
            [-18.575112162970353, 4.023887171861774]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.60071939741329,
          "lat": 39.66692443957373
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06007"],
        "coty_name": ["Butte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butte County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01675842"
      },
      "bbox": [
        -19.151037236731252, 3.223595232196465, -18.457831812557554,
        4.023887171861774
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.06109571485781, -3.5679514058477046],
            [-16.02557878068809, -3.575257661199233],
            [-15.990326020557806, -3.5827237749240544],
            [-15.984167178184759, -3.5837639822184006],
            [-15.892121047437973, -3.6033915096795277],
            [-15.78887859080204, -3.624579773842941],
            [-15.737192154138622, -3.6352998093677362],
            [-15.730272378729849, -3.6365833136027326],
            [-15.644096130375933, -3.655076926049064],
            [-15.559948821306026, -3.6724599627487535],
            [-15.559659244294865, -3.671072954812098],
            [-15.463645983265014, -3.691269422735555],
            [-15.384497719989847, -3.7073705675326236],
            [-15.37604060190722, -3.7087535387211217],
            [-15.231462535106575, -3.738690581379195],
            [-15.226918863986514, -3.739072936357401],
            [-15.180517990584613, -3.747676722748004],
            [-15.126830479741825, -3.7580377764180724],
            [-15.04228254412235, -3.774788479054455],
            [-15.041595535940008, -3.7712226413563754],
            [-14.989281009039159, -3.781650439317351],
            [-14.949675919419283, -3.789686296382658],
            [-14.876028386845457, -3.804363341355568],
            [-14.879135022570033, -3.8092953763686896],
            [-14.884703048989147, -3.8137354299181103],
            [-14.892477819963657, -3.8183204639486843],
            [-14.898160763302371, -3.820381081277163],
            [-14.90546751398687, -3.819543032813252],
            [-14.91705143831352, -3.8118523604018817],
            [-14.928545738653492, -3.8099323040216553],
            [-14.935361794114137, -3.8114629771529063],
            [-14.937853732545143, -3.815254533657424],
            [-14.94162903214115, -3.817119978413222],
            [-14.949288731555166, -3.816757698116593],
            [-14.95663289224271, -3.8146432285836203],
            [-14.961434899610163, -3.8165994518652115],
            [-14.960710762723956, -3.8231658161491984],
            [-14.95524528383545, -3.8350325996930406],
            [-14.951830425706007, -3.8399222910942874],
            [-14.952448758801374, -3.847501264905556],
            [-14.948748092053442, -3.864093530309266],
            [-14.949633145998778, -3.872834717735863],
            [-14.9550317533971, -3.887562926408804],
            [-14.960353999148778, -3.8959751526054434],
            [-14.966281928036278, -3.9021290110579567],
            [-14.978400254855893, -3.908419418856387],
            [-14.984767847138981, -3.913670315938459],
            [-14.986494320363343, -3.9167175321757717],
            [-14.982839016024368, -3.93214749064991],
            [-14.979030408218899, -3.9358982450805016],
            [-14.961010023473868, -3.944983359517197],
            [-14.953535125290768, -3.950320341476082],
            [-14.948714900708579, -3.9572734060686563],
            [-14.946848737326984, -3.9675765038230697],
            [-14.949509045844176, -3.972037971248918],
            [-14.962182629341047, -3.9773341703430405],
            [-14.96370755897438, -3.979812188786074],
            [-14.960287839271748, -3.991070951573655],
            [-14.955413093461134, -4.001678038505525],
            [-14.956020340640967, -4.007965798443113],
            [-14.963228483163919, -4.022707926935471],
            [-14.963327573002369, -4.038320612384662],
            [-14.965158865909245, -4.04477423173954],
            [-14.971080848491562, -4.05568145827027],
            [-14.971172354996858, -4.06259289073525],
            [-14.982059451746833, -4.081674066282611],
            [-14.985290770855283, -4.085447133418302],
            [-14.992179597034163, -4.090909984112708],
            [-15.001203424266222, -4.1069684777385564],
            [-15.00785823013727, -4.122368000863964],
            [-15.008533719144268, -4.131724458598869],
            [-15.004540586216951, -4.13435275756705],
            [-14.999231494700313, -4.135553491172012],
            [-14.995083489948724, -4.138619348580276],
            [-14.996721254342107, -4.146394095609382],
            [-14.995995909836541, -4.151812314191665],
            [-14.98833978645223, -4.167454476650753],
            [-14.990893568279478, -4.1768121770039075],
            [-14.990820225213444, -4.182593559227547],
            [-14.989255669540114, -4.186908586438872],
            [-14.983365846485288, -4.193514379788847],
            [-14.979470749141317, -4.193106095274455],
            [-14.969720975022524, -4.181799508333153],
            [-14.966833220930804, -4.18018199573073],
            [-14.96229123166331, -4.184778357899276],
            [-14.95588280161195, -4.200618210974646],
            [-14.948870094518295, -4.205945893182336],
            [-14.934695916875471, -4.210583254368341],
            [-14.925353411276784, -4.211592872440082],
            [-14.920864907922176, -4.2104302813161185],
            [-14.914174459626587, -4.204442335998084],
            [-14.908509288554217, -4.204282915969066],
            [-14.893938158148696, -4.20986892673854],
            [-14.882007934875542, -4.212785234549216],
            [-14.87032582077021, -4.217603670675314],
            [-14.86545901735193, -4.22176225653307],
            [-14.861787889259356, -4.226962402388475],
            [-14.858781656166327, -4.234146577003786],
            [-14.856155324182696, -4.248068104862719],
            [-14.85745233511179, -4.272186332958574],
            [-14.856797425927807, -4.2807990502687865],
            [-14.854868568909465, -4.28311723549861],
            [-14.847234993825033, -4.282388179696279],
            [-14.842411585753764, -4.280160718843102],
            [-14.837148347290313, -4.284132164406323],
            [-14.837079405010986, -4.28970308737234],
            [-14.839180902322939, -4.30006774100737],
            [-14.843078039721032, -4.306451337459471],
            [-14.851021936193284, -4.313868738496567],
            [-14.85406932567209, -4.318693442975413],
            [-14.852826165076605, -4.330824498022854],
            [-14.844886334174662, -4.343118742141823],
            [-14.844649935259369, -4.3484669620605665],
            [-14.845989094416522, -4.354400713365417],
            [-14.852471804934408, -4.376097933915858],
            [-14.85322909268107, -4.380663860973527],
            [-14.861795505491239, -4.409301405606764],
            [-14.868721727782443, -4.414547569558945],
            [-14.886650910640816, -4.426776921037586],
            [-14.901183445769759, -4.430944856293647],
            [-14.906391645488531, -4.435009848677992],
            [-14.913737600776546, -4.4435469448074745],
            [-14.920372361938751, -4.447729112551617],
            [-14.92368236184937, -4.452313995273612],
            [-14.927087816237607, -4.466224111036734],
            [-14.925697076374872, -4.476360080566615],
            [-14.92637971002104, -4.486634456301012],
            [-14.936443959910035, -4.484801043041114],
            [-14.937942988756818, -4.491801736765706],
            [-14.958680692626112, -4.487978012453254],
            [-14.96014740753528, -4.495106596218066],
            [-14.974273644705521, -4.492295488230172],
            [-14.975754241477777, -4.499542858815712],
            [-15.001194922946436, -4.494955482060847],
            [-15.004681419185387, -4.499468846691959],
            [-15.007078384501119, -4.500203157930851],
            [-15.018309326279175, -4.4953212200851835],
            [-15.038706062535141, -4.488260809768793],
            [-15.046194715599496, -4.4863390879591964],
            [-15.059309984292385, -4.4803506169332845],
            [-15.062974016304938, -4.479481917463895],
            [-15.069773561586294, -4.470798072959917],
            [-15.072200379500671, -4.469597910450658],
            [-15.085518144377062, -4.482451154216914],
            [-15.09199840085031, -4.493052079178924],
            [-15.202018280998251, -4.480179489014579],
            [-15.312038129308721, -4.467292063248936],
            [-15.326361005699619, -4.465593681268992],
            [-15.464246600620001, -4.4493751628207105],
            [-15.602132202211235, -4.4331331676703964],
            [-15.713575718841039, -4.419737496315605],
            [-15.770607103499191, -4.413170045064384],
            [-15.902935064427197, -4.397770580091412],
            [-16.035666242180366, -4.382097722738627],
            [-16.198949404730094, -4.362505993353271],
            [-16.248706971161575, -4.356699277100353],
            [-16.244146117917662, -4.33556032404459],
            [-16.242386726390272, -4.329251924762037],
            [-16.239047142884466, -4.311491740067434],
            [-16.22549729204625, -4.251025733843183],
            [-16.223452691677238, -4.251457428389623],
            [-16.211085715737244, -4.191907873087949],
            [-16.2002314970507, -4.142065208229612],
            [-16.195247501409664, -4.12279831817762],
            [-16.192117331942548, -4.105715874693149],
            [-16.1793125545778, -4.046745238111419],
            [-16.14998961321176, -3.909794455546456],
            [-16.131913590659558, -3.913497251719374],
            [-16.119687110564442, -3.8572099514891116],
            [-16.095795911116944, -3.74021875007673],
            [-16.08966276234927, -3.707020037586888],
            [-16.070186734774897, -3.6103870056491183],
            [-16.06109571485781, -3.5679514058477046]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.36534822712558,
          "lat": 33.039494203644644
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06025"],
        "coty_name": ["Imperial"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Imperial County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00277277"
      },
      "bbox": [
        -16.248706971161575, -4.500203157930851, -14.837079405010986,
        -3.5679514058477046
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.292067457778256, -3.333392719838325],
            [-17.262924879390095, -3.271881700534822],
            [-17.24689761216424, -3.2779432434422717],
            [-17.230200565797958, -3.277651705268814],
            [-17.208561235636214, -3.2701516728517235],
            [-17.203295241798944, -3.2673452974356247],
            [-17.195865526331104, -3.234610729125011],
            [-17.07847399900267, -3.2614971518377125],
            [-17.0870945508264, -3.2744578929548895],
            [-17.08174737810831, -3.2782496425586554],
            [-16.99201011440836, -3.339015379308798],
            [-16.995468593800183, -3.3556875770187253],
            [-16.955200000317788, -3.364629816298535],
            [-16.92460257042468, -3.371081098765084],
            [-16.91063028298086, -3.3743941481543485],
            [-16.88715844303629, -3.381599228762546],
            [-16.825715429261425, -3.3960360511251313],
            [-16.826487668099155, -3.3990481191031154],
            [-16.803034512222123, -3.4043110837234103],
            [-16.796348882669843, -3.405244437597636],
            [-16.739483102173484, -3.4179792289839983],
            [-16.68601707351747, -3.4308252884200727],
            [-16.657417532765614, -3.4368792171601465],
            [-16.54401374373089, -3.461638084154553],
            [-16.492110650487547, -3.4729368222246495],
            [-16.411834817494732, -3.4910333764409995],
            [-16.328209153163858, -3.508880469059054],
            [-16.207991308844168, -3.534073684472423],
            [-16.151571454352254, -3.5454795227257083],
            [-16.083348478813544, -3.563183428776567],
            [-16.06109571485781, -3.5679514058477046],
            [-16.070186734774897, -3.6103870056491183],
            [-16.08966276234927, -3.707020037586888],
            [-16.095795911116944, -3.74021875007673],
            [-16.119687110564442, -3.8572099514891116],
            [-16.131913590659558, -3.913497251719374],
            [-16.14998961321176, -3.909794455546456],
            [-16.1793125545778, -4.046745238111419],
            [-16.192117331942548, -4.105715874693149],
            [-16.195247501409664, -4.12279831817762],
            [-16.2002314970507, -4.142065208229612],
            [-16.211085715737244, -4.191907873087949],
            [-16.223452691677238, -4.251457428389623],
            [-16.22549729204625, -4.251025733843183],
            [-16.239047142884466, -4.311491740067434],
            [-16.242386726390272, -4.329251924762037],
            [-16.244146117917662, -4.33556032404459],
            [-16.248706971161575, -4.356699277100353],
            [-16.26523029077143, -4.355178762083777],
            [-16.336316642624162, -4.346418904804011],
            [-16.386400684116786, -4.340577718949337],
            [-16.48570550091956, -4.328900516968133],
            [-16.611787421955466, -4.313891590933679],
            [-16.68411020578842, -4.305710950168735],
            [-16.79302024638385, -4.29262044954917],
            [-16.87645526914437, -4.282488497452153],
            [-16.93591868665631, -4.276125477559328],
            [-16.950713905495, -4.273541110729467],
            [-17.018145435633773, -4.26625959920909],
            [-17.0484882935864, -4.262120720165326],
            [-17.09949647090371, -4.256216870228566],
            [-17.09762184682392, -4.239526155457447],
            [-17.098925026057753, -4.234872725156907],
            [-17.100004982747052, -4.22283820202333],
            [-17.097374334294056, -4.213394165170266],
            [-17.092742811697125, -4.193402819376709],
            [-17.091143443592404, -4.177578671092404],
            [-17.090998379333797, -4.165464539992524],
            [-17.094186448334586, -4.1424093950831145],
            [-17.100645815447322, -4.120985392774624],
            [-17.113853760613978, -4.102360312366899],
            [-17.12242917578885, -4.094556432230231],
            [-17.138091276710703, -4.089673882797968],
            [-17.147899648408284, -4.0917749223196545],
            [-17.161021809623602, -4.101490511968697],
            [-17.162744017150843, -4.105075629728915],
            [-17.16816269277274, -4.10688133018854],
            [-17.169551682385826, -4.0698258225650985],
            [-17.16633576499428, -4.0448238374309415],
            [-17.16417425084678, -4.04316044623488],
            [-17.164192426896065, -4.038655199696128],
            [-17.161834442783455, -4.033357384101921],
            [-17.159214397930995, -4.024325659949009],
            [-17.15611353277886, -4.020442384128638],
            [-17.15492023898359, -4.010777904783393],
            [-17.150626641633337, -3.99138783380706],
            [-17.149933805008942, -3.978139493994379],
            [-17.15119478124118, -3.968664163880095],
            [-17.1533636621375, -3.9634732126504995],
            [-17.155863314542525, -3.962359204030901],
            [-17.159272495503668, -3.9533021252331184],
            [-17.16356612729738, -3.945936587510364],
            [-17.161950558164662, -3.9422251940141697],
            [-17.16219688030032, -3.9350334394514013],
            [-17.15933584145051, -3.925175099589556],
            [-17.152662347488103, -3.9193120447962935],
            [-17.14448340775769, -3.9227020356450693],
            [-17.135320181721397, -3.913745473976561],
            [-17.128332737004392, -3.8999934895300075],
            [-17.126975693195472, -3.889938887985877],
            [-17.12338814422092, -3.870756988220413],
            [-17.12471078377087, -3.857900496554131],
            [-17.121989144847582, -3.834122838024791],
            [-17.123130347282775, -3.8158115650671967],
            [-17.121302821011657, -3.8037916938732144],
            [-17.121282199734164, -3.7720109898329954],
            [-17.120389580804638, -3.7607020848731625],
            [-17.12100022666745, -3.754682699554298],
            [-17.12522414821677, -3.7363199056504484],
            [-17.127677972671965, -3.7318078822024536],
            [-17.127579865551564, -3.7244317430941085],
            [-17.128857653295686, -3.707102245628146],
            [-17.130725917818758, -3.692545340069969],
            [-17.13026710024984, -3.680591012433713],
            [-17.131485966444334, -3.6734691515394133],
            [-17.13532599866845, -3.6435164626901866],
            [-17.139749671843475, -3.6317872163289717],
            [-17.14151119694101, -3.619984897667735],
            [-17.15021084383189, -3.5962694586767956],
            [-17.16835169785512, -3.552596220618965],
            [-17.171733735541544, -3.5467905454855213],
            [-17.176911381007827, -3.547049869904955],
            [-17.17848110189684, -3.5436349232039097],
            [-17.175569061710686, -3.5376238365822257],
            [-17.197379123021943, -3.47817362052692],
            [-17.210686709562122, -3.4463570997898767],
            [-17.231596998114615, -3.4035713130152208],
            [-17.258336009647476, -3.3648030143859584],
            [-17.267212545264982, -3.356939649827183],
            [-17.27308112568976, -3.3506594929013023],
            [-17.274447722339094, -3.346535947832975],
            [-17.286501435465425, -3.339773934373165],
            [-17.292067457778256, -3.333392719838325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.7350520533143,
          "lat": 33.034259353587345
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06073"],
        "coty_name": ["San Diego"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Diego County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00277301"
      },
      "bbox": [
        -17.292067457778256, -4.356699277100353, -16.06109571485781,
        -3.234610729125011
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.668112432749222, -0.233894249948382],
            [-19.589667361634287, -0.2559557763400218],
            [-19.53339009942815, -0.2717191600598233],
            [-19.497478506992685, -0.28159496698687736],
            [-19.488735555009708, -0.2846207395620459],
            [-19.401289239372588, -0.3088948983485698],
            [-19.400817772674376, -0.3087762649834614],
            [-19.30378277736153, -0.33589188704469447],
            [-19.20711454997192, -0.3623189716898443],
            [-19.16109074188857, -0.3750162444187463],
            [-19.078473113067638, -0.3969646150795753],
            [-19.024216240607046, -0.4119078471339417],
            [-18.938499109321583, -0.4347824984533888],
            [-18.819068137244464, -0.46707113352692936],
            [-18.813945887141156, -0.46790538473264937],
            [-18.790211879572805, -0.4742799984648468],
            [-18.77493513392873, -0.4781659237681048],
            [-18.790501427737148, -0.5396701119720356],
            [-18.819100338131747, -0.6491083881916172],
            [-18.735025919918122, -0.6709239891923212],
            [-18.757736351314826, -0.7567202151678304],
            [-18.743657664000178, -0.7602345496524427],
            [-18.74727999589743, -0.7734896411018704],
            [-18.733195837694932, -0.776999451593429],
            [-18.73686935337062, -0.7914905575076648],
            [-18.722865791365823, -0.7950621221208242],
            [-18.72648354335087, -0.8095455158744764],
            [-18.712004161116056, -0.8133902296453434],
            [-18.716307489272538, -0.8274473670681018],
            [-18.702533809992357, -0.8311373417212162],
            [-18.702801557875457, -0.8460999045999079],
            [-18.70654143400941, -0.8605646211026632],
            [-18.618170567047706, -0.8836519122917611],
            [-18.62150831235562, -0.8976154897761135],
            [-18.64048884210464, -0.969579892572322],
            [-18.626096133371615, -0.9731847445388166],
            [-18.58481566531682, -0.98403746836184],
            [-18.606788766611356, -1.0692520550291338],
            [-18.49503776885015, -1.098854249277353],
            [-18.517392530613037, -1.1843852058955235],
            [-18.44064669540593, -1.198393323034648],
            [-18.426981302919234, -1.2019649398716117],
            [-18.456055152263357, -1.2906128256055713],
            [-18.3989764988799, -1.30106570683386],
            [-18.402794777908802, -1.3156677028519612],
            [-18.388645924299247, -1.3192456905491434],
            [-18.423668032112744, -1.4547221231569485],
            [-18.431818588568447, -1.490630448786399],
            [-18.44595332780682, -1.4872787982194666],
            [-18.446944790156337, -1.4908746540574749],
            [-18.455432463419942, -1.4883194943536049],
            [-18.482641827983233, -1.481756786061412],
            [-18.489062466286967, -1.4726476715205286],
            [-18.4990597169747, -1.4604477289464013],
            [-18.510213810089244, -1.4495125744596526],
            [-18.514944830029247, -1.4426982998209854],
            [-18.518056345132766, -1.4337966215486748],
            [-18.52813217160428, -1.4189706532042288],
            [-18.5328087610349, -1.4139361521153506],
            [-18.54045746402391, -1.413347931744516],
            [-18.546799321600638, -1.4069534879827355],
            [-18.554502902873775, -1.405129595432726],
            [-18.555391281313756, -1.4016667393838387],
            [-18.55919253768562, -1.3975054787572645],
            [-18.56041851954812, -1.3931691782282098],
            [-18.565986383615552, -1.3854343895040988],
            [-18.572385388691746, -1.3799593444906548],
            [-18.57681804979837, -1.3807046718762361],
            [-18.587828151639073, -1.375894417970585],
            [-18.592874165110825, -1.3715219970284884],
            [-18.60009344503924, -1.3712349613741626],
            [-18.607321590978238, -1.3729385401211016],
            [-18.616025998401188, -1.3677309147754102],
            [-18.624871071145133, -1.3671123761382962],
            [-18.62905065151771, -1.3654219773063667],
            [-18.634928944812778, -1.357334272586968],
            [-18.639595953703395, -1.354983839064778],
            [-18.645650731551427, -1.3480370432306374],
            [-18.65221584126126, -1.3417624520622755],
            [-18.655771442076574, -1.342988386546361],
            [-18.65972662219297, -1.3419859186505927],
            [-18.666220123297595, -1.3355604539392283],
            [-18.6679959179543, -1.330386589084253],
            [-18.67262638320776, -1.3247133911480158],
            [-18.677298808233555, -1.324547262193958],
            [-18.683251160780657, -1.3190240262580641],
            [-18.68812987947225, -1.3169110784957778],
            [-18.693964816503865, -1.3058053419676519],
            [-18.69620140577494, -1.3047524965110804],
            [-18.696708732592935, -1.2942738457741534],
            [-18.698921769251402, -1.2914864202279825],
            [-18.70016405318207, -1.2863817918758655],
            [-18.707275373488873, -1.2853122688856153],
            [-18.70845679568712, -1.2812014244856953],
            [-18.71545289606889, -1.2787760330107394],
            [-18.716984072347408, -1.2741951717825417],
            [-18.7207459252938, -1.2736909764654338],
            [-18.725666584893435, -1.271012098590329],
            [-18.72771222457878, -1.2721369881509574],
            [-18.737418998478383, -1.2705946608919025],
            [-18.742120715466754, -1.2678833562874],
            [-18.739879485519495, -1.2618190022164544],
            [-18.74531340201099, -1.257274160421359],
            [-18.747942613667743, -1.2528855425144068],
            [-18.751330814621156, -1.2444647881055266],
            [-18.754707645441815, -1.247189501953896],
            [-18.763917216113324, -1.2468027361216203],
            [-18.767980881593, -1.242906031194691],
            [-18.773496250112792, -1.241484141487473],
            [-18.777720401206494, -1.241923994258805],
            [-18.78034260979793, -1.2380071255571226],
            [-18.788890946069134, -1.2363869028078727],
            [-18.791082782844203, -1.2320742754803415],
            [-18.793445813730084, -1.232167068316934],
            [-18.797301915088926, -1.2272803539329598],
            [-18.800949224669466, -1.2284205349713067],
            [-18.805792191005814, -1.2164720133675857],
            [-18.808958544905426, -1.2171193130507463],
            [-18.81138939063243, -1.212856368370351],
            [-18.81428023977565, -1.2118103109243543],
            [-18.81316733058387, -1.2059852357565068],
            [-18.816248790729038, -1.2042409821742024],
            [-18.820738456444854, -1.2052136730943919],
            [-18.82039173474674, -1.201419472160456],
            [-18.824622290039198, -1.2008153286367973],
            [-18.826301583728483, -1.1959519522036297],
            [-18.831261223797494, -1.1932873488786913],
            [-18.83557748614015, -1.195462140241721],
            [-18.838111970596962, -1.1907365617080161],
            [-18.846304756705102, -1.1854193601658267],
            [-18.846707477325452, -1.1828340650186675],
            [-18.851137487344044, -1.1802214514103617],
            [-18.853525772001067, -1.1743285664672134],
            [-18.853135300138835, -1.1714254590414697],
            [-18.85962458920341, -1.1695531329365163],
            [-18.862235058760454, -1.1660490770715233],
            [-18.85727005801429, -1.160329067109355],
            [-18.863776938612915, -1.1600349822855598],
            [-18.867114917661347, -1.1579183157278141],
            [-18.872265892332802, -1.158924752863627],
            [-18.875494075071092, -1.1614719460433378],
            [-18.879818518541253, -1.160118959329208],
            [-18.880995886877844, -1.1647340879130965],
            [-18.885053310947644, -1.1644053660093574],
            [-18.886667027690795, -1.1606928764427622],
            [-18.889980290591023, -1.1630643979204125],
            [-18.892140403380857, -1.168393535151872],
            [-18.895716920800364, -1.1669138385584814],
            [-18.90052470204308, -1.1698944013648989],
            [-18.90472840766821, -1.1652000226543462],
            [-18.907780243266405, -1.1682586911274953],
            [-18.91020585753977, -1.1656579489595755],
            [-18.91460127217737, -1.1734467293057975],
            [-18.91142329085011, -1.174974899894541],
            [-18.91419151542495, -1.1790342652557668],
            [-18.917599132734225, -1.1758044347039793],
            [-18.919461721953972, -1.1784443340390867],
            [-18.923256264359473, -1.1767526028622288],
            [-18.92524999704794, -1.1804867068727092],
            [-18.935341564225286, -1.180750084977886],
            [-18.940570744188218, -1.1848684614393028],
            [-18.942255835888307, -1.1902172718985287],
            [-18.948285571191363, -1.1914359464742987],
            [-18.95060765118751, -1.1979777345023037],
            [-18.95572320783863, -1.2034253008093252],
            [-18.954469816298246, -1.213306574846285],
            [-18.959930846042962, -1.2147268142155598],
            [-18.96305574687515, -1.2203468948600462],
            [-18.97203756626321, -1.2187719911039043],
            [-18.976484567712063, -1.2212230110058024],
            [-18.982226436350096, -1.2226813639881646],
            [-18.991476030459708, -1.222471444827836],
            [-18.993434259079162, -1.2204035918123652],
            [-19.000060472494315, -1.2207477568486749],
            [-19.00042303378733, -1.2175969980180972],
            [-19.00616657630407, -1.2174036668180837],
            [-19.013504189553323, -1.2086211479043738],
            [-19.01760923498285, -1.2158862323483286],
            [-19.021626051163274, -1.2182773783202179],
            [-19.022126545920017, -1.2120733883235437],
            [-19.026824476466036, -1.2132381918861137],
            [-19.0324996756266, -1.2122280201273201],
            [-19.036052621826318, -1.2146656090695542],
            [-19.038743833247025, -1.2202325773906342],
            [-19.04687724397437, -1.2140700461042013],
            [-19.063938689771856, -1.2160886765242245],
            [-19.07279070487614, -1.2053375432873366],
            [-19.0840251739938, -1.2138621895894217],
            [-19.085375154389695, -1.216430461114305],
            [-19.086087999709616, -1.2253702918232456],
            [-19.08323840227178, -1.2346949534538947],
            [-19.077433401618535, -1.23664500244847],
            [-19.07463241791738, -1.2421822127474564],
            [-19.077110683859935, -1.246637891279659],
            [-19.076794414472797, -1.2496179572016186],
            [-19.072614344138266, -1.2543460750694184],
            [-19.069363649010768, -1.2624440923001221],
            [-19.07268392832897, -1.268123143377604],
            [-19.071695094427593, -1.2723949177656029],
            [-19.068437761126827, -1.2762193362542793],
            [-19.06782569500499, -1.2803403648794214],
            [-19.07011544383189, -1.296711776580801],
            [-19.07256783839138, -1.3018025833095137],
            [-19.077766158930455, -1.3062290099062903],
            [-19.080461242736764, -1.3102787678182908],
            [-19.08084901560254, -1.316336169291165],
            [-19.08401297282051, -1.3188606801403755],
            [-19.0915951217628, -1.318739931031134],
            [-19.096597108255636, -1.3140419464036057],
            [-19.098305476225548, -1.3007828646856547],
            [-19.09754040530057, -1.2979721717904902],
            [-19.0996737803905, -1.2936621776173616],
            [-19.106996127168106, -1.283455029968567],
            [-19.110848451730742, -1.2811561585369367],
            [-19.115677625136264, -1.2754378812630733],
            [-19.120301597452176, -1.2667438820250698],
            [-19.1392880545631, -1.24441778258073],
            [-19.162218176513996, -1.2196681654502772],
            [-19.168311686598177, -1.2121554167776571],
            [-19.174862007450347, -1.2082417396420673],
            [-19.185358232073455, -1.204906370379179],
            [-19.214401102556888, -1.1933411199369939],
            [-19.25008204223341, -1.1937328300683496],
            [-19.25564041901074, -1.1969393870647238],
            [-19.25805041683008, -1.196783689514209],
            [-19.265467852417018, -1.1999658851982167],
            [-19.27289616333332, -1.1944203585715987],
            [-19.280253359129933, -1.191458387857312],
            [-19.28740334316967, -1.1958566947154705],
            [-19.2912186495248, -1.2001041829306387],
            [-19.299250324653656, -1.1987435134036413],
            [-19.302896060866257, -1.1912479633437518],
            [-19.31187307478034, -1.1904115058087115],
            [-19.315730684765175, -1.1949421160742684],
            [-19.326397671424605, -1.195320190540245],
            [-19.33139391386207, -1.1974538609386285],
            [-19.339410937137053, -1.1795258793168921],
            [-19.324764778410607, -1.1539364542841424],
            [-19.311938706541547, -1.1259130565115771],
            [-19.30173515211569, -1.0989583446459457],
            [-19.297107945343193, -1.082608919474266],
            [-19.291291902927526, -1.057509031756956],
            [-19.289725416823803, -1.032002732824253],
            [-19.293136927120862, -1.0152386759377785],
            [-19.29605507165344, -1.0104735220978733],
            [-19.303494360765953, -1.0026675957649513],
            [-19.308161650177304, -1.0028132914691654],
            [-19.31344139320028, -1.0003355122990316],
            [-19.31614020246272, -0.9941674145343915],
            [-19.320782822804492, -0.9904055373836187],
            [-19.327411808096087, -0.9777029733087382],
            [-19.338131300096144, -0.9698367324811997],
            [-19.341200460172647, -0.9708580886251247],
            [-19.347552150745628, -0.9679488995994281],
            [-19.353186638307783, -0.9632480290960802],
            [-19.364824926634512, -0.9608550692802802],
            [-19.370289794197937, -0.9626283802315728],
            [-19.373313354666518, -0.9675560225970481],
            [-19.374978453593688, -0.9762440943681497],
            [-19.378623647289533, -0.9760543785704293],
            [-19.38517506467887, -0.9701107961318742],
            [-19.39072772703699, -0.9632375966471144],
            [-19.39398925311731, -0.9532140150166868],
            [-19.396619077663708, -0.9502407964080672],
            [-19.400164352875624, -0.9501724742289192],
            [-19.402305726523934, -0.9464451679057115],
            [-19.428609169888126, -0.9221124993300359],
            [-19.434451236852215, -0.9144642056548303],
            [-19.441248881473104, -0.9104966628718015],
            [-19.44438630372975, -0.8978374826655381],
            [-19.44843204983625, -0.895481466613721],
            [-19.45064252150224, -0.8908600962057097],
            [-19.449538621686287, -0.8882289264075273],
            [-19.452295744785268, -0.88121908530714],
            [-19.45721333281378, -0.8750355543947972],
            [-19.462314940921523, -0.8616353713236644],
            [-19.460785258561675, -0.8556618280887494],
            [-19.455376781527857, -0.8450638542493739],
            [-19.45559730163086, -0.8395295672053197],
            [-19.45333315874631, -0.8367007930554614],
            [-19.449809325722615, -0.8382144044494451],
            [-19.44551313180888, -0.8294973426505653],
            [-19.437670671905305, -0.822026837003862],
            [-19.42703260061294, -0.8078380983073589],
            [-19.418244534832787, -0.7923303411352305],
            [-19.40929919594633, -0.7723320254523636],
            [-19.405762584830118, -0.7589012022558832],
            [-19.411589844151248, -0.7556492384940838],
            [-19.408635980860737, -0.7464012817352865],
            [-19.40496309128623, -0.7474024723140353],
            [-19.403114398029174, -0.742848214671265],
            [-19.400435705009386, -0.7266151245342292],
            [-19.40019306667817, -0.7159955024579314],
            [-19.405296840154378, -0.6865136200677081],
            [-19.41159241306646, -0.6722438572753204],
            [-19.41844614305874, -0.6632763242422187],
            [-19.423454012923187, -0.6616540447628954],
            [-19.427930535852923, -0.6625095779917263],
            [-19.443871771110427, -0.659175260488807],
            [-19.4521010584957, -0.6553370307720133],
            [-19.454595575683555, -0.6486881836233586],
            [-19.4634873738478, -0.6395553883310778],
            [-19.469006238749838, -0.6392923412093188],
            [-19.47559096561117, -0.636070693214379],
            [-19.481552681203993, -0.6311166497476124],
            [-19.48564983669593, -0.6334070902239116],
            [-19.48979852647339, -0.6319389333552622],
            [-19.499052364641884, -0.6107966510504013],
            [-19.500879129947794, -0.6039942478264975],
            [-19.503307874351414, -0.6028149952108219],
            [-19.505005025331027, -0.5982749714405265],
            [-19.507892555475877, -0.5970930118739214],
            [-19.50897643397413, -0.5918738369820508],
            [-19.512793454359727, -0.5846152468708311],
            [-19.512990939724755, -0.581843999584623],
            [-19.516152299708025, -0.5758945884558972],
            [-19.521603420831372, -0.570616325010052],
            [-19.52238620993955, -0.5667745721190487],
            [-19.52583991983682, -0.5599458786727479],
            [-19.53117944646946, -0.547136310495712],
            [-19.542523865352, -0.5255962268314434],
            [-19.543774395065864, -0.518906470363739],
            [-19.54232315052096, -0.5179600502361797],
            [-19.544581976925397, -0.5092132850405207],
            [-19.543939683616713, -0.5051131364690221],
            [-19.545861294240392, -0.49578513742429414],
            [-19.549622640537265, -0.4891950863655377],
            [-19.54965849072904, -0.4819113321195194],
            [-19.55074279204204, -0.4734687596760523],
            [-19.55402153267503, -0.4683726686070798],
            [-19.55733457887744, -0.4662901091169389],
            [-19.56030850803947, -0.46166180014416347],
            [-19.562232101205378, -0.4507340693469686],
            [-19.563326770768573, -0.4493460843566119],
            [-19.570270007244186, -0.42774339317041726],
            [-19.577852741171604, -0.42004871680177225],
            [-19.585933923789895, -0.41517638397431716],
            [-19.591786645253265, -0.41620679509243513],
            [-19.595647380920905, -0.41873647242231693],
            [-19.596511689975674, -0.41407595723911905],
            [-19.601641664771524, -0.4123209710061952],
            [-19.602847327337415, -0.4063755246308582],
            [-19.60885399737057, -0.39965549080555046],
            [-19.623253908116855, -0.39549796831373474],
            [-19.62984462237222, -0.38910085652345683],
            [-19.636420501879993, -0.3792747268123345],
            [-19.640033699865185, -0.37951984168922603],
            [-19.64476582628798, -0.37463795863619503],
            [-19.651872585914806, -0.37246783005015505],
            [-19.65611774409606, -0.3727867794048743],
            [-19.653206020309952, -0.36155727142525607],
            [-19.652310510797736, -0.3488243604979322],
            [-19.655534109537953, -0.3402103591507232],
            [-19.660154203339147, -0.3326898362619335],
            [-19.66584518695424, -0.32007981904691246],
            [-19.662685210987444, -0.3160970469701949],
            [-19.661975148644935, -0.3125253085728383],
            [-19.664123710085352, -0.30456500312190926],
            [-19.661534197402936, -0.3029348483774333],
            [-19.659868491188387, -0.29515537912530787],
            [-19.659583784643335, -0.28911926644754327],
            [-19.655735874510132, -0.28190061358429064],
            [-19.657966790428002, -0.27696771566548883],
            [-19.662576270284383, -0.27479232248047225],
            [-19.6601425039399, -0.2705361121510814],
            [-19.65834969200555, -0.2635860913868044],
            [-19.660553977421994, -0.25301347646752576],
            [-19.66053406317061, -0.24859721504108984],
            [-19.668112432749222, -0.233894249948382]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.40431913130597,
          "lat": 35.38710917493755
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06079"],
        "coty_name": ["San Luis Obispo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Luis Obispo County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00277304"
      },
      "bbox": [
        -19.668112432749222, -1.4908746540574749, -18.388645924299247,
        -0.233894249948382
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.97169128433585, 2.071036429591145],
            [-17.97095117391676, 2.0696249713225585],
            [-17.889542382094326, 1.9693065655328463],
            [-17.88706663527935, 1.9719190600420125],
            [-17.875334170219862, 1.9775524890437608],
            [-17.863062275880104, 1.9794932457323613],
            [-17.84746671826489, 1.985845788900164],
            [-17.8289974643479, 1.9864372950772444],
            [-17.815715972666723, 1.9974986958073346],
            [-17.80194110579806, 1.9976035076525342],
            [-17.79777568659895, 1.9994967079396238],
            [-17.791019019142972, 1.9966766919949632],
            [-17.783993629184966, 2.0001986002204855],
            [-17.775661192025073, 2.0032729762232733],
            [-17.744723022300185, 1.9971507998320808],
            [-17.738847745386007, 1.99239741565784],
            [-17.736168349415692, 1.9854347911155763],
            [-17.737160238223616, 1.9823370561813771],
            [-17.73903873314324, 1.9610061432304289],
            [-17.74008732805239, 1.95477982014658],
            [-17.74831746393904, 1.9426234697778464],
            [-17.729576065684636, 1.9202290135576714],
            [-17.712076082467856, 1.8934911496177036],
            [-17.717573654901955, 1.8894303936049979],
            [-17.717401113940202, 1.8837634999482267],
            [-17.719268716169786, 1.8746013234015075],
            [-17.722733687902526, 1.8677919182192324],
            [-17.722754620253227, 1.8617971063826637],
            [-17.72507669827876, 1.8592772533669197],
            [-17.73124778672036, 1.8564540500847013],
            [-17.726330412062055, 1.8463955959889073],
            [-17.723044090165935, 1.8457779446904057],
            [-17.720080689896655, 1.8390174290669214],
            [-17.719747129683647, 1.8348581322570168],
            [-17.717356256515764, 1.8335840217494082],
            [-17.708750673796782, 1.8244809617034852],
            [-17.717450403966772, 1.817705157566038],
            [-17.71398740071997, 1.8064285477030042],
            [-17.708005521418727, 1.801157189114888],
            [-17.709287988323652, 1.7962321984130658],
            [-17.713003687609397, 1.7953143944716252],
            [-17.717063719050216, 1.7967051400256135],
            [-17.72113488275636, 1.7943471313316963],
            [-17.725341934757406, 1.7945937308534357],
            [-17.726705909063934, 1.7863207140039612],
            [-17.731206493685036, 1.7799680445541433],
            [-17.730755052814366, 1.7751737371500733],
            [-17.732763384759963, 1.7714762499766632],
            [-17.73639269957534, 1.771642170256093],
            [-17.738971042515523, 1.767004299798489],
            [-17.73638334773292, 1.7622238717266343],
            [-17.7297590724867, 1.7559646798625577],
            [-17.723911089375964, 1.7544078425980691],
            [-17.721179780422773, 1.7516120023179684],
            [-17.717393916821052, 1.7436623163253688],
            [-17.713083756129194, 1.7454337258863037],
            [-17.707665583080896, 1.7444694164438337],
            [-17.703766107368907, 1.7339160867002237],
            [-17.706791311520664, 1.7314032055521575],
            [-17.706228837404193, 1.72681885104199],
            [-17.706809473095795, 1.7159537103265183],
            [-17.69907094368752, 1.7132682804565578],
            [-17.69846555961834, 1.7100955884304925],
            [-17.693524517979803, 1.7095285751675895],
            [-17.68455273560753, 1.7055282583572553],
            [-17.687626686799177, 1.7011610607099128],
            [-17.688239177468567, 1.697007568267332],
            [-17.67584820856464, 1.6944057073478778],
            [-17.672500070430054, 1.6897191886355227],
            [-17.666248499723284, 1.6863600926757076],
            [-17.665806400087074, 1.6844442590253015],
            [-17.659041475855034, 1.6824856612591765],
            [-17.657388751361076, 1.6853395672847395],
            [-17.655729073916437, 1.6934365601857226],
            [-17.65608450180534, 1.6977623250970906],
            [-17.652333538317173, 1.702663260109799],
            [-17.65004883355549, 1.7032766404557758],
            [-17.64655168886528, 1.6979387098804521],
            [-17.648838899901445, 1.6925953741434336],
            [-17.644366152369688, 1.6853688892628242],
            [-17.64668955004794, 1.6742288064775752],
            [-17.639835574205133, 1.6713503923797057],
            [-17.63325210883506, 1.6667899750135267],
            [-17.638087209579275, 1.6553146724082723],
            [-17.634729100622934, 1.652324109711201],
            [-17.630545842540446, 1.6446019312009543],
            [-17.635602594200424, 1.641676425331085],
            [-17.636288605000775, 1.6363799745481697],
            [-17.633859076829847, 1.6336256903512083],
            [-17.629809422690958, 1.6323882756426724],
            [-17.62447704313757, 1.634261188580867],
            [-17.62412551753209, 1.6278251118416616],
            [-17.619393418485643, 1.6293602955710091],
            [-17.61889023272588, 1.6348774904833343],
            [-17.61694440846551, 1.6383120400029094],
            [-17.611121425924427, 1.642191900224387],
            [-17.607918267631938, 1.646821584038385],
            [-17.605685878693137, 1.646606670079885],
            [-17.604017810887207, 1.6377332502752577],
            [-17.600616690249478, 1.6360984718656582],
            [-17.594082417093755, 1.635493686803243],
            [-17.588272999557557, 1.6318117890038624],
            [-17.583816835526935, 1.6320142295245883],
            [-17.581839068845444, 1.6263229636143175],
            [-17.57867588355635, 1.6213822717397677],
            [-17.5753468419542, 1.6203977408941763],
            [-17.574629423199845, 1.614850494090194],
            [-17.57010678857247, 1.6147333953270329],
            [-17.568671263260686, 1.6092434422151738],
            [-17.563748364815943, 1.6096799601450504],
            [-17.55952232063678, 1.601102141810446],
            [-17.553380912397976, 1.6022569359039818],
            [-17.547174737848838, 1.5849118619417253],
            [-17.54647158687277, 1.5793774348711178],
            [-17.541683658536776, 1.5786560253296267],
            [-17.540044103102243, 1.5732858894682644],
            [-17.541574357598947, 1.562147207647635],
            [-17.534920271621424, 1.5561330621485414],
            [-17.53483896521415, 1.550453943078421],
            [-17.538757840401416, 1.5454895921556888],
            [-17.535695729212527, 1.5440844474463835],
            [-17.534283424698952, 1.5332939697224715],
            [-17.538057483944897, 1.5296605259105795],
            [-17.53896918444842, 1.5224274996656986],
            [-17.543854758852962, 1.5143218194297823],
            [-17.54387216438538, 1.5120420233808334],
            [-17.55391725767725, 1.499216967193664],
            [-17.552414931890947, 1.4933255630708988],
            [-17.55622638069515, 1.490637255145492],
            [-17.56091056705124, 1.4828601830486396],
            [-17.556744112302397, 1.4779668652192235],
            [-17.558380619648073, 1.4669293018734721],
            [-17.556053154409963, 1.4585431319489626],
            [-17.547587650290307, 1.4521591418146984],
            [-17.547126033991503, 1.447569119673298],
            [-17.54390209417748, 1.4411439139972353],
            [-17.538174491717307, 1.4405459320281453],
            [-17.527381546237223, 1.4302539068851263],
            [-17.531702196488265, 1.4181180527841184],
            [-17.5308044354452, 1.4162290129087525],
            [-17.52126328345929, 1.41187131969266],
            [-17.51446459337015, 1.4100709597480725],
            [-17.51263314322542, 1.411278871863042],
            [-17.503973180188762, 1.4037090494019133],
            [-17.500771259780457, 1.3945875199831448],
            [-17.493676084300244, 1.3936519961824594],
            [-17.494943180064805, 1.3882454429580737],
            [-17.492905759284287, 1.3828480809191301],
            [-17.489331090821477, 1.3807093947493487],
            [-17.489199177140048, 1.3770362648752206],
            [-17.494270004592185, 1.3770505866110656],
            [-17.496928052892844, 1.3751116563938268],
            [-17.502991207206414, 1.3669463065007692],
            [-17.50653754459923, 1.3504548247745],
            [-17.508900859404815, 1.3493789833799783],
            [-17.510035410037478, 1.3432120413007713],
            [-17.50658343594684, 1.340895412927211],
            [-17.499518229372505, 1.3411124902897056],
            [-17.501020630733674, 1.3366997465858559],
            [-17.50524206716445, 1.3346298707190967],
            [-17.50550730467464, 1.3241888195173186],
            [-17.506857448416156, 1.3226523327573885],
            [-17.513737639098416, 1.3212449289278911],
            [-17.518008631718065, 1.3157543407140693],
            [-17.51263638466529, 1.3075500745947086],
            [-17.510733187600714, 1.3064517900851453],
            [-17.50968088666834, 1.2986987416094389],
            [-17.511280871535327, 1.2938951025521035],
            [-17.514743997861945, 1.2884109903683751],
            [-17.521488604066036, 1.2885304057625309],
            [-17.525654703177533, 1.2854066558476127],
            [-17.5310204756732, 1.277796926542177],
            [-17.535596498594813, 1.2782082295876755],
            [-17.53938366195398, 1.274991531907517],
            [-17.543984123586608, 1.2753063873356698],
            [-17.550020890497464, 1.2721298865258213],
            [-17.55827164485244, 1.2620277953959114],
            [-17.56219102063149, 1.2618468526068478],
            [-17.564333176266267, 1.2522901068383254],
            [-17.57064251479566, 1.24803694931436],
            [-17.57700914310285, 1.247753822648605],
            [-17.579137224618748, 1.2482854012955698],
            [-17.58583680697674, 1.254746310578772],
            [-17.59032883532089, 1.2571179135297526],
            [-17.588411863462348, 1.2670442624591824],
            [-17.591058006042058, 1.2725970082647848],
            [-17.5885172049237, 1.2804951827813706],
            [-17.597920943328607, 1.2909636520774732],
            [-17.597907953193896, 1.2933103166295672],
            [-17.59542174617359, 1.2977273306604034],
            [-17.597164740907118, 1.3010774311944693],
            [-17.595472895324413, 1.3078349494767962],
            [-17.59644698119213, 1.309743841815495],
            [-17.603683954207423, 1.3114501995328136],
            [-17.606306224429645, 1.3177267907382433],
            [-17.610074501951825, 1.3184623887352243],
            [-17.614221221766893, 1.3260580472692298],
            [-17.619564950125817, 1.3282297983786515],
            [-17.62020628651954, 1.333073105199334],
            [-17.624513772511953, 1.3351937846202129],
            [-17.61868278730778, 1.3462216282770507],
            [-17.618903317331263, 1.348878921846418],
            [-17.6327038757486, 1.3591649774399293],
            [-17.63195229527602, 1.366057328177238],
            [-17.635791034421086, 1.3683374189451618],
            [-17.64025628976545, 1.3647972508223492],
            [-17.646624833223346, 1.3679077550808538],
            [-17.653481092791342, 1.3662990493069822],
            [-17.655975563395295, 1.3695281448827719],
            [-17.6535718381808, 1.3803744492608865],
            [-17.653590987762378, 1.387352506340415],
            [-17.65988279305888, 1.3886216964495397],
            [-17.664047889359665, 1.392895960895478],
            [-17.66432579301912, 1.4010854956050145],
            [-17.66547059537242, 1.4026226121098353],
            [-17.671475060190094, 1.4024675408706497],
            [-17.6765502296987, 1.3986436664486115],
            [-17.67922586982486, 1.3989006730461488],
            [-17.676797713809425, 1.4063043960823929],
            [-17.681554457966364, 1.408542856056241],
            [-17.683136983996977, 1.4115439315563585],
            [-17.692344260851602, 1.411156139352217],
            [-17.695707814202507, 1.4080474379733858],
            [-17.69870914288312, 1.4076585158750057],
            [-17.704222466262543, 1.4008232663757667],
            [-17.70520600694324, 1.4052356737309335],
            [-17.708169486382417, 1.407232150502293],
            [-17.70947877169729, 1.4113103831233988],
            [-17.716016573688446, 1.41160579289746],
            [-17.723810292736488, 1.4203389737039933],
            [-17.724039022537756, 1.4254985652872583],
            [-17.728184258225255, 1.4368530339936016],
            [-17.734056986249932, 1.440731067747038],
            [-17.73751452332761, 1.4461860578910763],
            [-17.738909452657246, 1.4527860843739173],
            [-17.737777000433628, 1.4585391974563509],
            [-17.755468911235845, 1.460929939857389],
            [-17.756363135014237, 1.4634470720124293],
            [-17.762239720423054, 1.4634761813979642],
            [-17.769963334697874, 1.4590789156972432],
            [-17.776115980902294, 1.4586582020812078],
            [-17.7806458503378, 1.4560564894782575],
            [-17.78153068367519, 1.4506570327020956],
            [-17.78415540575833, 1.4450734435359152],
            [-17.782653172516042, 1.4420894040319452],
            [-17.785029276355807, 1.4386099807435855],
            [-17.796571312797038, 1.4297329209688778],
            [-17.80886496416033, 1.4257956857544474],
            [-17.814593304743546, 1.4262050085554063],
            [-17.818684623639445, 1.4223165981423633],
            [-17.823273436730847, 1.4221863892996571],
            [-17.830001346267707, 1.4258731084222638],
            [-17.83671281878215, 1.4251817551936934],
            [-17.84337659035915, 1.418645848907511],
            [-17.84858786895741, 1.4149701831940307],
            [-17.846722513122902, 1.4089756603537544],
            [-17.846741159842193, 1.4006475229564472],
            [-17.851602430932665, 1.3910497529231838],
            [-17.85640045550786, 1.3912283536634935],
            [-17.86397636575339, 1.3846124623663767],
            [-17.8668035478847, 1.3842895726551332],
            [-17.874894476500995, 1.386763901601481],
            [-17.88275138203406, 1.3876170724530685],
            [-17.890147916055206, 1.3791864929535118],
            [-17.89305572696786, 1.3801351258672354],
            [-17.89820015884162, 1.385299696613078],
            [-17.903957943608336, 1.384891184437406],
            [-17.909454690128122, 1.3820203881928954],
            [-17.917873187647977, 1.3844788327002833],
            [-17.922438361885145, 1.38210062128352],
            [-17.928297895128335, 1.3819281658750544],
            [-17.93448704564983, 1.3735050735834384],
            [-17.948686395330288, 1.3748425613475987],
            [-17.95206167966687, 1.3711189012911302],
            [-17.956763846854372, 1.3713790650326856],
            [-17.959791008518845, 1.3696516908862815],
            [-17.96298314623824, 1.3729681290071112],
            [-17.967379645280403, 1.3728413895842253],
            [-17.973057917558616, 1.370885623665354],
            [-17.979242539384863, 1.3706571713204696],
            [-17.979670819306307, 1.3674394456710564],
            [-17.98335867080234, 1.3669238763217686],
            [-17.985187210961612, 1.3708304951684502],
            [-17.990728261549357, 1.373811545284647],
            [-17.994581498438354, 1.3795915367065308],
            [-17.994084530183493, 1.383424314058852],
            [-18.001165492234833, 1.3873228507242945],
            [-18.00470363341692, 1.3870817643707223],
            [-18.004517286658142, 1.3827612339027795],
            [-18.01017343279352, 1.3808764742404798],
            [-18.01499337063415, 1.3778387408868336],
            [-18.01555654001531, 1.3816307083316623],
            [-18.019834695781725, 1.3860624097546546],
            [-18.020733830112654, 1.3942126440914095],
            [-18.02614562715001, 1.3970596976517065],
            [-18.02910075682391, 1.3968808130412171],
            [-18.02823349839384, 1.3914471660452454],
            [-18.031663719423495, 1.388470879419307],
            [-18.039190770276996, 1.3871713895192745],
            [-18.044576956766853, 1.3901174351509547],
            [-18.056653056879995, 1.388736940925429],
            [-18.061689171956406, 1.3949299594892168],
            [-18.06391273706962, 1.395084500990952],
            [-18.071346661046892, 1.3994973506482764],
            [-18.079179223634544, 1.3998440553026792],
            [-18.08355312347082, 1.402950019290573],
            [-18.08429197155807, 1.4088735257382698],
            [-18.08919646527236, 1.4130547789392565],
            [-18.094282203319928, 1.4243719909149473],
            [-18.099209270385685, 1.4268921301510973],
            [-18.101384215166814, 1.430371498826801],
            [-18.10979864975338, 1.4387953796382769],
            [-18.11629097903648, 1.4440142237945457],
            [-18.11763021467369, 1.4469660776416267],
            [-18.126341783243788, 1.4552244080279595],
            [-18.13368677806123, 1.4648214419216257],
            [-18.138290570603164, 1.4649417543889012],
            [-18.14181383801468, 1.4627468666031809],
            [-18.143394144459446, 1.4662205879744754],
            [-18.14829566981187, 1.4700803685490087],
            [-18.150747107005778, 1.468522262488881],
            [-18.15506965394825, 1.471301804939717],
            [-18.154066499854657, 1.4826019270134256],
            [-18.156580615869487, 1.4855001898513183],
            [-18.160548397029093, 1.484595333425535],
            [-18.169480275002375, 1.491729227432408],
            [-18.17387308356447, 1.49100914905876],
            [-18.175304893430724, 1.487715473697178],
            [-18.179533847365796, 1.487099218407737],
            [-18.181370566742682, 1.4812491813627207],
            [-18.180914647687107, 1.4774322879522133],
            [-18.18938808638586, 1.4749018245671726],
            [-18.192686044964244, 1.46839062471962],
            [-18.197233391647554, 1.467864825275952],
            [-18.203129501240216, 1.4640096103817226],
            [-18.209880196211152, 1.46137224131987],
            [-18.210559767811514, 1.4575875119609347],
            [-18.214041626857462, 1.4583214252306451],
            [-18.21723437691424, 1.4550601801584429],
            [-18.228502833687074, 1.4592957929096073],
            [-18.231353398237953, 1.4635004337589923],
            [-18.236194980902482, 1.4668434152045902],
            [-18.242307724612793, 1.4674348951333416],
            [-18.246956884056257, 1.4733822413697748],
            [-18.25016014324095, 1.4807514347095905],
            [-18.25300606447892, 1.4777831043261975],
            [-18.256830200060083, 1.4773492916014699],
            [-18.256267735815292, 1.4721076704976388],
            [-18.258599910038015, 1.4684519929929924],
            [-18.264489836903213, 1.4657068563512348],
            [-18.26192386433846, 1.459536306408298],
            [-18.26783661855329, 1.4537596604503116],
            [-18.274375207763615, 1.456983371309215],
            [-18.27541619074449, 1.4529846917027998],
            [-18.278449257854028, 1.451532157448704],
            [-18.284638615953607, 1.4531658680163684],
            [-18.28644461592087, 1.4557202230733253],
            [-18.290265388641448, 1.4542916775789514],
            [-18.29554939007062, 1.4564876578449772],
            [-18.298575155006432, 1.4538707746444952],
            [-18.30046459392147, 1.4579286853607427],
            [-18.307322213028534, 1.4593077360188187],
            [-18.309576608642327, 1.45478029435019],
            [-18.309928188416883, 1.4496504876893488],
            [-18.317841649049203, 1.4476999797337864],
            [-18.320968184308025, 1.4496545128463942],
            [-18.325229796074947, 1.4465124857070708],
            [-18.327086512791016, 1.4428559368554377],
            [-18.333381296380455, 1.4374839410723494],
            [-18.341206776513268, 1.4426583119461576],
            [-18.3450389812213, 1.4486596388658581],
            [-18.348872706411914, 1.4460214805492722],
            [-18.348417274396272, 1.4389797398896575],
            [-18.35120643637546, 1.4356785791761795],
            [-18.3576208973525, 1.4411291022145398],
            [-18.362807423786222, 1.4437103795240258],
            [-18.372205059692728, 1.445436632530299],
            [-18.378392400898996, 1.4390084967823704],
            [-18.38241301076288, 1.4399641835127353],
            [-18.38599441359094, 1.4444835535394653],
            [-18.38947119293578, 1.4422440602453719],
            [-18.397380098530526, 1.4425465875374701],
            [-18.395080421541905, 1.4339165809997108],
            [-18.395825137172196, 1.425779921321785],
            [-18.39273652352957, 1.4223095520247124],
            [-18.39267648639004, 1.4134385366514752],
            [-18.390926048350583, 1.4070962061973644],
            [-18.3874968319146, 1.3999298839724161],
            [-18.387499578183967, 1.395678380834133],
            [-18.38406547117833, 1.3851532999576257],
            [-18.382883466483595, 1.3771581371754402],
            [-18.38808101264609, 1.3755826534209545],
            [-18.387984619948018, 1.3682844166430195],
            [-18.39863345543678, 1.3646880908529688],
            [-18.401992189813473, 1.3646317016616167],
            [-18.405886334275568, 1.3701951684929237],
            [-18.40554602815697, 1.3726617425830618],
            [-18.411503381083147, 1.3818974235173158],
            [-18.41301700983228, 1.3907529200090782],
            [-18.417556887983952, 1.3963959216011215],
            [-18.423586236090394, 1.3951775698847675],
            [-18.424460212470382, 1.4037294525844215],
            [-18.43077850257286, 1.4048657805430944],
            [-18.43883193007176, 1.4117220352883852],
            [-18.443174558851744, 1.4115221307327452],
            [-18.44538070025922, 1.4080659920221896],
            [-18.445711840565203, 1.4036253019237939],
            [-18.44866010651134, 1.401164402736654],
            [-18.446351221368698, 1.3910662022576363],
            [-18.443974165076558, 1.385056247188965],
            [-18.44082708401799, 1.3832457283933663],
            [-18.438479680628184, 1.3775705838307852],
            [-18.441843559338864, 1.3728616131527192],
            [-18.44682998006219, 1.3690885409229758],
            [-18.45083310165126, 1.3624871386214898],
            [-18.452678112856496, 1.361981645993849],
            [-18.488496980986067, 1.421006813288871],
            [-18.495163264398997, 1.4322483279203997],
            [-18.5396997691765, 1.5062237151147282],
            [-18.542779913600864, 1.5120852408508316],
            [-18.602799633362423, 1.6084604813378494],
            [-18.597827166126656, 1.6130975718220877],
            [-18.593135349764577, 1.6148986919944321],
            [-18.59239793606563, 1.6184397891157294],
            [-18.586421800440988, 1.6217052422383214],
            [-18.585916429607167, 1.6254122580579313],
            [-18.58062620134615, 1.6326056794213846],
            [-18.575314150529866, 1.6340227521109567],
            [-18.5704836724231, 1.637083981197104],
            [-18.558787611240092, 1.639463467926679],
            [-18.54641522110779, 1.647303111570267],
            [-18.544669910642344, 1.652602011921541],
            [-18.5394346501284, 1.6544579736591354],
            [-18.536955506884482, 1.6569367135994848],
            [-18.53180287006669, 1.65665670459424],
            [-18.526015906194484, 1.6531595075152168],
            [-18.52148752015651, 1.6555375429954884],
            [-18.51720430052709, 1.6601376289147336],
            [-18.513654591869635, 1.6690003800378892],
            [-18.511731243519645, 1.6708799650096027],
            [-18.506691747306252, 1.6717494841358713],
            [-18.50238521520308, 1.6756703929327486],
            [-18.496088533226416, 1.6727235729422085],
            [-18.490419834656176, 1.6786019957758327],
            [-18.489524050706265, 1.6886770683780397],
            [-18.484542801056495, 1.6946879323961366],
            [-18.48007911772538, 1.6952033176256327],
            [-18.46690756628016, 1.699416517296942],
            [-18.464527059551113, 1.7035438398272935],
            [-18.46583426923556, 1.7115748895209668],
            [-18.47049166222896, 1.7158620418153188],
            [-18.471992023083693, 1.7190504038218901],
            [-18.47117902147629, 1.7240368253142333],
            [-18.479396306622878, 1.724699976248156],
            [-18.481819772747215, 1.7282576410047519],
            [-18.4761615728346, 1.7298176781663253],
            [-18.472608158615156, 1.729400846824873],
            [-18.468695345149012, 1.7317758532351555],
            [-18.472202874584944, 1.7384503834569565],
            [-18.47036278653606, 1.7408053722439227],
            [-18.461204407479798, 1.7415167615603289],
            [-18.457277776761508, 1.7478521491771855],
            [-18.454761672294453, 1.7491845419697216],
            [-18.45132227827135, 1.7466617318563022],
            [-18.45140631386995, 1.7420647239311013],
            [-18.455055039765604, 1.7414316683258109],
            [-18.452744393494722, 1.7354735942299333],
            [-18.449307193293134, 1.7341875837524905],
            [-18.44465594669206, 1.7374430581116065],
            [-18.44224528506797, 1.7484916056940254],
            [-18.434741927860284, 1.7512880984726287],
            [-18.43128876753463, 1.7485664711496074],
            [-18.428189422756528, 1.7505048428278573],
            [-18.420634680273494, 1.7488654980233977],
            [-18.41737561268273, 1.7450935404285588],
            [-18.415483594631738, 1.7487111612425048],
            [-18.41505445662312, 1.7549191892493297],
            [-18.409293529750375, 1.7562495994989176],
            [-18.407063230575112, 1.7613709914922897],
            [-18.403627674435228, 1.764337345382022],
            [-18.39823824427904, 1.773142919882453],
            [-18.390807485900343, 1.7779029975386775],
            [-18.38767406261232, 1.7811234496718247],
            [-18.38516325648681, 1.78785879723694],
            [-18.381251692373848, 1.7890776494055198],
            [-18.376200234179745, 1.7873484337674064],
            [-18.37257237738153, 1.799837076601211],
            [-18.36775937452758, 1.798375469058105],
            [-18.364196345967756, 1.8032274138251645],
            [-18.358180019898427, 1.804950500949749],
            [-18.35360840643754, 1.8099761863651702],
            [-18.350860596746728, 1.8168946923550355],
            [-18.350453777473184, 1.821730119978573],
            [-18.34781926125694, 1.8251824748843783],
            [-18.341954771429123, 1.8277350454913603],
            [-18.33686171040808, 1.8285515235166379],
            [-18.32953267097286, 1.8322159808269647],
            [-18.323898458373968, 1.8415999432290362],
            [-18.318893044162124, 1.8445835228509435],
            [-18.316842894669865, 1.8500854908742956],
            [-18.312499738791036, 1.8501888082494178],
            [-18.31042082478288, 1.8532239438156282],
            [-18.313649684984238, 1.8566484506766359],
            [-18.30825095006528, 1.8628243430717215],
            [-18.304544226265026, 1.8648601170264278],
            [-18.296717980981203, 1.8639295170542383],
            [-18.297154482290676, 1.8707996222006174],
            [-18.291190970878272, 1.8728165259164726],
            [-18.28732955928315, 1.8781061825328749],
            [-18.279665106303646, 1.8779820349064174],
            [-18.277241757630804, 1.884197098903956],
            [-18.265843379349878, 1.897582776235975],
            [-18.257734228572474, 1.903237209847804],
            [-18.252725270745284, 1.9081054972826215],
            [-18.250478886916266, 1.9125767502743547],
            [-18.246669732793812, 1.9154450399226906],
            [-18.241055033371534, 1.922971950379076],
            [-18.235560368241117, 1.9267572529683639],
            [-18.226313537367464, 1.929105946446898],
            [-18.223126339251262, 1.938581758190669],
            [-18.218454818772393, 1.9434912771660218],
            [-18.214879166629874, 1.9450184603613352],
            [-18.208448326631693, 1.950325454845775],
            [-18.205584197576776, 1.9505773089753127],
            [-18.2055846320729, 1.9553744373181605],
            [-18.200997105483527, 1.9612127949060458],
            [-18.197479331582525, 1.9618189480606993],
            [-18.191927900611596, 1.9660909063380776],
            [-18.18688149242317, 1.9727883265138717],
            [-18.18317041248666, 1.9731505718734816],
            [-18.174756263595356, 1.9773769087797848],
            [-18.16982445033375, 1.981558941104115],
            [-18.168484401561894, 1.9844793998729775],
            [-18.16268456120605, 1.9891290702891462],
            [-18.15880836887629, 1.9953499591847055],
            [-18.15590024038305, 1.996051643753744],
            [-18.15284770372924, 1.999457546770815],
            [-18.142934253275588, 2.00182335293096],
            [-18.137192065008513, 2.0056288935075317],
            [-18.13078620981743, 2.0139609505510796],
            [-18.123260140705998, 2.0225743722946388],
            [-18.121587775474108, 2.0226421388926634],
            [-18.119011431836622, 2.0283404419585067],
            [-18.11446606958632, 2.030143165552496],
            [-18.10921171701567, 2.0384394651552302],
            [-18.105048055322065, 2.0406503775810254],
            [-18.104127545906145, 2.0432974127917842],
            [-18.09938897806564, 2.044047440814953],
            [-18.095597157012914, 2.047070588297268],
            [-18.091136380670513, 2.047105986829597],
            [-18.088012811835227, 2.0508742905204342],
            [-18.083490523011555, 2.0514195936987867],
            [-18.072613465988095, 2.0559671651872917],
            [-18.070099033505613, 2.0544317989463172],
            [-18.067411316392363, 2.0572408504058983],
            [-18.063045558073448, 2.055297529329897],
            [-18.056684475761795, 2.057534968750081],
            [-18.045940899696454, 2.0574425973331034],
            [-18.043951124175603, 2.0556865666972914],
            [-18.037894419028277, 2.056214339416929],
            [-18.030364400704, 2.054785012666497],
            [-18.023352936869834, 2.059977650032921],
            [-18.01226624708502, 2.062728163881105],
            [-18.003733194572078, 2.0622073857471226],
            [-17.99711050482315, 2.0628503842161923],
            [-17.991498234700895, 2.0651620572125715],
            [-17.9890914473067, 2.067614078513294],
            [-17.981413780903534, 2.064333669407713],
            [-17.97169128433585, 2.071036429591145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.95480495907009,
          "lat": 38.027604286661095
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06109"],
        "coty_name": ["Tuolumne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tuolumne County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00277319"
      },
      "bbox": [
        -18.602799633362423, 1.247753822648605, -17.489199177140048,
        2.071036429591145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.55509089081942, 2.2093906940914],
            [-7.5532213907670185, 2.2023969148967435],
            [-7.546425909602062, 2.1952422911895706],
            [-7.541821289291073, 2.1950508780918723],
            [-7.535526433922216, 2.191319502336491],
            [-7.537961497837729, 2.1889267358814952],
            [-7.540841441857778, 2.181103911100411],
            [-7.53831489798355, 2.1768458119037657],
            [-7.537819761047862, 2.172626951898078],
            [-7.535159849209003, 2.166588857286543],
            [-7.535104594180411, 2.154361374148225],
            [-7.531571063107713, 2.1475061941586953],
            [-7.532663422471777, 2.1400727115226754],
            [-7.52633780903997, 2.1383000482664847],
            [-7.524604875271965, 2.1355394256862663],
            [-7.5208699930328615, 2.1382146259276205],
            [-7.512158609083398, 2.1406968094388747],
            [-7.5059161305596644, 2.136243947098231],
            [-7.495389881670519, 2.134900922119447],
            [-7.491150210469404, 2.1332961580823837],
            [-7.4891547656042174, 2.1255558397486607],
            [-7.481999825158762, 2.126989756835222],
            [-7.478608177714509, 2.1254812175454507],
            [-7.476178501618826, 2.1192572968618766],
            [-7.473309609327192, 2.120502498644305],
            [-7.468106121844996, 2.134055734065505],
            [-7.467919382337768, 2.1376177980850968],
            [-7.461261790106599, 2.1439149117525242],
            [-7.456785750151608, 2.1390876737207125],
            [-7.454681547232968, 2.1455824119454348],
            [-7.446532060334169, 2.1540206316390877],
            [-7.4425186886878905, 2.1545789905920545],
            [-7.441493043601073, 2.1578065157325463],
            [-7.437174963903415, 2.16209445380942],
            [-7.434004573264212, 2.1602666155040984],
            [-7.429229615253476, 2.15434520742262],
            [-7.42891955675755, 2.1491501370275996],
            [-7.433213505691974, 2.1391919125393315],
            [-7.428279733974356, 2.1371784389377217],
            [-7.426372036056794, 2.13117776786234],
            [-7.422039643084443, 2.1242438356735973],
            [-7.422114839997236, 2.1152053107190145],
            [-7.41853330007221, 2.1143381204193994],
            [-7.417241358981979, 2.1109587525566846],
            [-7.417386116522803, 2.105544973545127],
            [-7.419302257364258, 2.103863730774896],
            [-7.409547312841521, 2.0930649796864125],
            [-7.403642576177699, 2.0962920228241604],
            [-7.401416496100285, 2.0952393977021555],
            [-7.394019886356499, 2.0974325679509573],
            [-7.3893906119880945, 2.0944433275485035],
            [-7.384299718462639, 2.093960748135397],
            [-7.380133897837942, 2.0882246332930388],
            [-7.373758512340267, 2.089614142250891],
            [-7.369325425827444, 2.0877970300254933],
            [-7.365236140085058, 2.0941169002556337],
            [-7.353218396675362, 2.0979740856797164],
            [-7.350613084312644, 2.0961148236473304],
            [-7.345683923112181, 2.0980381631861054],
            [-7.341013054110078, 2.096701910019751],
            [-7.338957473404566, 2.0919893075572453],
            [-7.335410063916147, 2.088498263199245],
            [-7.334809856853947, 2.0848626228108222],
            [-7.330372244380619, 2.0804511090946285],
            [-7.330386898281642, 2.0773958054955894],
            [-7.324796537992556, 2.076281936685618],
            [-7.318793012734955, 2.07377864362113],
            [-7.312828578063079, 2.0658865281153074],
            [-7.307936103180752, 2.0638490202022624],
            [-7.3032824998127825, 2.0649565347666736],
            [-7.298217571856014, 2.0718441599397135],
            [-7.301059301499998, 2.0749562347561707],
            [-7.3004403462116425, 2.0845936907785685],
            [-7.293871595676647, 2.09224269835646],
            [-7.290463986556647, 2.0925307972732434],
            [-7.288997130150396, 2.0892651871983947],
            [-7.284505014903117, 2.086681430403426],
            [-7.274493775278077, 2.0929251397868778],
            [-7.270802938772667, 2.0897263183757326],
            [-7.2687607370204494, 2.0836303410004224],
            [-7.266570723472308, 2.081291999089997],
            [-7.266968047098242, 2.077583730430968],
            [-7.265497036882153, 2.072513079977527],
            [-7.2605450122642585, 2.065802358690262],
            [-7.258041049858708, 2.0576842497854106],
            [-7.252228468225268, 2.0535372155255716],
            [-7.245305309880452, 2.0541133547269235],
            [-7.241452096250987, 2.0570331608387393],
            [-7.233427494452099, 2.054961413449817],
            [-7.22669828909891, 2.0519317477707855],
            [-7.220523790993521, 2.053359517977196],
            [-7.212949328420481, 2.0589451395502847],
            [-7.212011467577669, 2.063177481015835],
            [-7.208130936633896, 2.0677487938540438],
            [-7.204854453359882, 2.0682315550259145],
            [-7.198635727041235, 2.0661506849353937],
            [-7.195016646497907, 2.0601215086871467],
            [-7.190295629332155, 2.0544622375367334],
            [-7.185411319539455, 2.0521270925527295],
            [-7.1807001467489044, 2.0517344437440417],
            [-7.178890331298451, 2.0567620426270863],
            [-7.173502526792086, 2.058825387028096],
            [-7.167306071450684, 2.0639917254353044],
            [-7.155044274722768, 2.0691531606112257],
            [-7.1503273622974195, 2.0730122862494125],
            [-7.147369892411556, 2.069319630410762],
            [-7.1417925331011105, 2.0679519645989806],
            [-7.1408098190673295, 2.0646067699654127],
            [-7.133641771203495, 2.066651706119907],
            [-7.125087402289074, 2.070208786683274],
            [-7.123816848140696, 2.0723490442879764],
            [-7.116324925258001, 2.0726030335503594],
            [-7.10736508412275, 2.076985851860667],
            [-7.101180877147412, 2.0826196416406333],
            [-7.096600217197253, 2.0814583715101342],
            [-7.094506105856155, 2.083705470416891],
            [-7.087663912247056, 2.085443324038721],
            [-7.084675077000463, 2.0846904058399027],
            [-7.0832492955298045, 2.073777811647133],
            [-7.0735781905910695, 2.073004051794398],
            [-7.0703947137214564, 2.074771900662346],
            [-7.064579287729672, 2.074172945137796],
            [-7.0610539032516195, 2.068782077427173],
            [-7.0572110634680465, 2.0669519662765734],
            [-7.055181804228854, 2.059982280116582],
            [-7.048110131292961, 2.055678897627919],
            [-7.042165283723518, 2.061907427481137],
            [-7.0407632486860505, 2.0673228199452103],
            [-7.037080477573363, 2.0696225608130776],
            [-7.028407237273535, 2.071866208068399],
            [-7.0267445446900645, 2.077655775871328],
            [-7.033244833788323, 2.0837177783492353],
            [-7.03234405236134, 2.091529469139716],
            [-7.027784970090375, 2.090520877898693],
            [-7.014823261723592, 2.0979188358646255],
            [-7.011179993335318, 2.1060554825230144],
            [-7.005818830958642, 2.105547132698781],
            [-7.000311985479634, 2.102979367936471],
            [-6.998192138845576, 2.1038718339513713],
            [-6.996342298168089, 2.1094959906643473],
            [-6.995999349424005, 2.115964823356059],
            [-6.9921693658105, 2.120450510701506],
            [-6.991899443435332, 2.1296251490994424],
            [-6.9947919752228715, 2.135964544241927],
            [-6.991362442717577, 2.143722279233418],
            [-6.990010371816884, 2.1490920351941263],
            [-6.989929704601963, 2.1574903995344643],
            [-6.9885081108025116, 2.1602782756851218],
            [-6.988401437820284, 2.1686271571919264],
            [-6.984212042769137, 2.1721446016866954],
            [-6.981553148827573, 2.1790774899980923],
            [-6.977180697220426, 2.1793124759440357],
            [-6.973982275150933, 2.177481898694356],
            [-6.964150170327636, 2.1816466412503424],
            [-6.959221533128541, 2.180363286181147],
            [-6.952931743997922, 2.1858163747969828],
            [-6.947461242009216, 2.1828954158689884],
            [-6.9404418432047414, 2.1812563034814887],
            [-6.938358234290202, 2.1778333818457907],
            [-6.935391947659278, 2.1772205726293716],
            [-6.927895795270912, 2.172798953922036],
            [-6.922417017306528, 2.172112896370329],
            [-6.918118603740123, 2.1696998243858023],
            [-6.919967351960868, 2.1670179597445287],
            [-6.917389478822744, 2.1598048550528848],
            [-6.920984262531463, 2.148053450668039],
            [-6.919995778393782, 2.1435120299371624],
            [-6.925049080242892, 2.1389380908994444],
            [-6.929292137776413, 2.1319442852735135],
            [-6.928586387037493, 2.1247794692826365],
            [-6.930880677140703, 2.122955550502809],
            [-6.929981596416897, 2.117792645972849],
            [-6.927035505931857, 2.1153723020012403],
            [-6.925349905850572, 2.1106925811336588],
            [-6.920613226345045, 2.1053587539021805],
            [-6.918789833898411, 2.100771371357727],
            [-6.914045034122558, 2.092988433946782],
            [-6.91502705253523, 2.0887264996306736],
            [-6.9151623643166555, 2.080558919829903],
            [-6.9131087318511915, 2.0748825841140346],
            [-6.909432863299475, 2.0705683411040754],
            [-6.909865403530256, 2.0673380953800455],
            [-6.906160933859367, 2.0626845782264707],
            [-6.903807277454397, 2.057238057591824],
            [-6.90119920697908, 2.057033018278696],
            [-6.900609418771836, 2.0521982200262068],
            [-6.895060756728075, 2.0475874054408014],
            [-6.893498102064319, 2.0432413825350353],
            [-6.886892917731508, 2.038363374874414],
            [-6.882717078498107, 2.0397128195074763],
            [-6.878409579049608, 2.036586188938408],
            [-6.878104844798428, 2.032874575117901],
            [-6.874320288786821, 2.0290802779876183],
            [-6.874125029164995, 2.0246551981624985],
            [-6.86871122644588, 2.020795354638745],
            [-6.8631283417484505, 2.0136853073592684],
            [-6.854653030789142, 2.011541088596502],
            [-6.855175720067304, 2.0089613294372644],
            [-6.85224237690764, 2.005176425229626],
            [-6.856232508018263, 1.9993107340303904],
            [-6.851046331857301, 1.9959824984246026],
            [-6.845178563028727, 1.98904962265683],
            [-6.847343330298145, 1.98345187123232],
            [-6.847033181390506, 1.9797701990447203],
            [-6.8444979955158765, 1.9769335196623705],
            [-6.846038603311734, 1.9722449092533565],
            [-6.842878753112008, 1.9699465438900483],
            [-6.842457241488943, 1.9642799868260359],
            [-6.845281859645475, 1.9587422458656862],
            [-6.840889123555612, 1.9523162736993795],
            [-6.833137509817283, 1.9511472151889628],
            [-6.831270910980711, 1.9481491652235714],
            [-6.8248316366155395, 1.9437760382212736],
            [-6.823870126586563, 1.9373835701294155],
            [-6.821288990572982, 1.9319361148479628],
            [-6.83018401632127, 1.9331269613260507],
            [-6.83157491841581, 1.9289749744478435],
            [-6.836323137744224, 1.9214442084591439],
            [-6.835941580960218, 1.9172928913635277],
            [-6.838412579762847, 1.915260125666342],
            [-6.841115154684488, 1.9044685631154423],
            [-6.842771610711731, 1.9016350591549185],
            [-6.843198385603692, 1.8922745795543958],
            [-6.847202642004131, 1.888031406972579],
            [-6.849619452393194, 1.8821938658564894],
            [-6.850444383456254, 1.8734546376101016],
            [-6.845545523856153, 1.8697977852583378],
            [-6.846688294822275, 1.8664788735029734],
            [-6.845143523035571, 1.8550221042583888],
            [-6.848017118528157, 1.8508943621711713],
            [-6.846141891090462, 1.8423689199890159],
            [-6.841509405649791, 1.8401203729817939],
            [-6.838016851301298, 1.8344492756664448],
            [-6.832631183919868, 1.8331140413219682],
            [-6.829914057086246, 1.8303750477136966],
            [-6.8232274599507, 1.827596384715593],
            [-6.823656532969584, 1.8219741823185749],
            [-6.81988936810168, 1.8192413854185248],
            [-6.820541297198201, 1.811537223192344],
            [-6.81792169465299, 1.8081405938089492],
            [-6.820342359583868, 1.80449975605957],
            [-6.819167374007374, 1.799455505479014],
            [-6.822194978642012, 1.7952051915961298],
            [-6.8258174879174085, 1.7946346398938813],
            [-6.828386281653195, 1.7840523221892686],
            [-6.825472054171261, 1.778337279959019],
            [-6.827847443330945, 1.7751896061484962],
            [-6.8276825839319635, 1.769628312957748],
            [-6.8303132134414355, 1.756278098635535],
            [-6.834806249896124, 1.7547611471020934],
            [-6.835853322594801, 1.7496666600576587],
            [-6.839804608262325, 1.7473820914647857],
            [-6.843794051777697, 1.740919392116021],
            [-6.8422660138495, 1.7361932596328427],
            [-6.83713809341908, 1.7287780331002711],
            [-6.834816252063221, 1.7268902587380466],
            [-6.83654828438038, 1.720251154064766],
            [-6.848648440791471, 1.7062592025028245],
            [-6.848275139420037, 1.703314285048736],
            [-6.854787942163296, 1.7013863700436629],
            [-6.8560498340849785, 1.6996057961007363],
            [-6.862447664428714, 1.7006771717344584],
            [-6.868607376109037, 1.698935435210827],
            [-6.877489181033903, 1.700418052063156],
            [-6.879586085636879, 1.6891300267073766],
            [-6.880005833926382, 1.6815853337476556],
            [-6.874746700456136, 1.6776001440919623],
            [-6.878772611015495, 1.6704442557954593],
            [-6.877477574626187, 1.664138656054451],
            [-6.880504177244675, 1.6604893941355938],
            [-6.882525907335981, 1.6549588526644958],
            [-6.881949907132195, 1.6446532681980994],
            [-6.883500292973099, 1.6385684163060328],
            [-6.88764254378999, 1.6351164536233553],
            [-6.886057158245421, 1.63146291428574],
            [-6.887632125139014, 1.626551749898729],
            [-6.883043182979169, 1.6222594844864924],
            [-6.880644761762362, 1.618282633561609],
            [-6.875381959482685, 1.6163821363437079],
            [-6.881356941220294, 1.6063074020884374],
            [-6.88238573975537, 1.6016930704694046],
            [-6.884599245699725, 1.6004722288493043],
            [-6.887605126889556, 1.5919793561823712],
            [-6.8869264405671125, 1.5889123205522429],
            [-6.890977125175241, 1.5834458263257642],
            [-6.897673080857382, 1.5771387516269366],
            [-6.897746535606843, 1.566454392261705],
            [-6.899761443650003, 1.5646182064862615],
            [-6.897539131337358, 1.5570463714965384],
            [-6.898615397295596, 1.5533900186382414],
            [-6.898036635403867, 1.5467692824276738],
            [-6.894643570557848, 1.536767469025517],
            [-6.897486241493591, 1.5328566126377323],
            [-6.900525720521972, 1.5241070836694908],
            [-6.9059946678035065, 1.5224286883183697],
            [-6.913483048462772, 1.5247172733334418],
            [-6.916498999772409, 1.5222476397132443],
            [-6.919027846820405, 1.5144664373397367],
            [-6.922308732943411, 1.51258093666794],
            [-6.924572017177188, 1.5046741259849683],
            [-6.9296140061787055, 1.5021400214135012],
            [-6.932727294723917, 1.4983136510060255],
            [-6.934381772735262, 1.4929763088498824],
            [-6.9406349439296, 1.4921728677393444],
            [-6.957772090052442, 1.485295796313013],
            [-6.967752483369218, 1.4905802866983155],
            [-6.971149646326111, 1.4943634537321895],
            [-6.978067213079871, 1.4945812178092504],
            [-6.982337926577231, 1.4963799925952181],
            [-6.9845537149932415, 1.492606703555917],
            [-6.988909794973969, 1.4917571569789834],
            [-6.991861004086197, 1.485389394974914],
            [-6.997997005477713, 1.4845420876877704],
            [-7.001894741148863, 1.4804748512808812],
            [-7.006956083833864, 1.4836513846745074],
            [-7.013486803502918, 1.4842410724047657],
            [-7.0174912543879655, 1.486062992735691],
            [-7.022694984201906, 1.4861707663364752],
            [-7.0257051302007865, 1.4929901318548304],
            [-7.028851480649012, 1.4947772406949305],
            [-7.03810833689833, 1.4954856797178222],
            [-7.040308040320554, 1.4983179108327158],
            [-7.049714441936758, 1.4966027829467083],
            [-7.050563960581931, 1.4890041466258757],
            [-7.054601066676645, 1.4844406956906602],
            [-7.053645861607455, 1.4737400412075614],
            [-7.0522350366072475, 1.4658271733497445],
            [-7.048213949591981, 1.4586108194210077],
            [-7.052000361380256, 1.4524686640098707],
            [-7.0510621555492365, 1.4449854740256367],
            [-7.052998511323388, 1.4364965018824187],
            [-7.0579103124662375, 1.4314659862185375],
            [-7.066172226939365, 1.4295218488342465],
            [-7.069787360371447, 1.429897722357236],
            [-7.0750074745727956, 1.422260605144095],
            [-7.076543845928892, 1.416924645445318],
            [-7.080506860192123, 1.4155954345170756],
            [-7.0844082809316555, 1.412311029042489],
            [-7.087472922818157, 1.4060242908196454],
            [-7.087995773623478, 1.401563271388308],
            [-7.092297365725243, 1.4005389049282293],
            [-7.094651322049647, 1.3979083808980886],
            [-7.104969126376712, 1.3930901785359278],
            [-7.10842733929462, 1.3998280630751792],
            [-7.117156179544433, 1.3963147940336385],
            [-7.124952222824671, 1.3980563954200687],
            [-7.131676530213032, 1.3968155386549785],
            [-7.135303769225393, 1.3947698093550804],
            [-7.1395170612976875, 1.3953602007867512],
            [-7.143941861520912, 1.3923792677996074],
            [-7.153013361276012, 1.3970427599467847],
            [-7.156329375870653, 1.3959392106621185],
            [-7.165827251464466, 1.399781945013278],
            [-7.170881703108013, 1.4080510606871381],
            [-7.170728853972438, 1.4143238487752858],
            [-7.1729493198248315, 1.4192479386330719],
            [-7.17263797433867, 1.423759665069662],
            [-7.1768818278875175, 1.4311762988044932],
            [-7.18160478627997, 1.4342738698678004],
            [-7.185166510418152, 1.4345717586165856],
            [-7.186782979308824, 1.4380887995220308],
            [-7.185958996062199, 1.4421726422067875],
            [-7.186992405891116, 1.4467104304084528],
            [-7.1859101448255265, 1.4529432637636488],
            [-7.188669990595693, 1.4598236456623819],
            [-7.187309724547165, 1.464929997270182],
            [-7.189247865636149, 1.4678755138100261],
            [-7.187696906465355, 1.47474631591078],
            [-7.190700909394592, 1.480657331791469],
            [-7.191121176302785, 1.4872312687231455],
            [-7.19336878268579, 1.495872549572925],
            [-7.197253160065297, 1.5028191183629278],
            [-7.1952114830777845, 1.5075400766177691],
            [-7.197021886424841, 1.5118623051354738],
            [-7.197396581966298, 1.5223721326286566],
            [-7.201544351535226, 1.5255340514009887],
            [-7.2027116854839415, 1.5292451155318405],
            [-7.207948190379498, 1.536837661989334],
            [-7.211734229462493, 1.5398561693084536],
            [-7.216354118908313, 1.5477813830779872],
            [-7.219599193103805, 1.550447358827741],
            [-7.2245257799628595, 1.5612550316710656],
            [-7.229215404913844, 1.563861852409511],
            [-7.235341672224925, 1.5633109951431583],
            [-7.238754412861149, 1.5599597387321262],
            [-7.242893663773793, 1.560504601858627],
            [-7.2563927225914, 1.5681347173809579],
            [-7.259097067362659, 1.5681734352103411],
            [-7.264155708114105, 1.5732778376561574],
            [-7.26536084077551, 1.576114523435824],
            [-7.275049672625441, 1.5844877170285323],
            [-7.279324963487502, 1.5893730669835167],
            [-7.279464217034072, 1.5939358908491585],
            [-7.283384716013807, 1.6043782825661246],
            [-7.288017086869844, 1.6052855958008119],
            [-7.29138724466621, 1.6105297780166319],
            [-7.2920502680941635, 1.6147361670143112],
            [-7.297147111940072, 1.6212030113464757],
            [-7.298871369490251, 1.6287852805804353],
            [-7.309083668398681, 1.6419579524903565],
            [-7.312731520391334, 1.644394255618147],
            [-7.3408089751121235, 1.6516389329512016],
            [-7.34457294100993, 1.652117980357851],
            [-7.344998476372369, 1.6471311519455962],
            [-7.400065327376706, 1.6530020289924345],
            [-7.421154863649742, 1.6555066661861109],
            [-7.419857175832852, 1.6660941715192974],
            [-7.449469106087774, 1.669680549295271],
            [-7.487891640002489, 1.6740574153654002],
            [-7.48851537434012, 1.6743345436075672],
            [-7.588391328432102, 1.685445163683838],
            [-7.59453485616161, 1.6856816361096312],
            [-7.5857226039686285, 1.761026033916039],
            [-7.585825683808655, 1.7629508976086519],
            [-7.593720452508289, 1.7640758344950815],
            [-7.579987481455419, 1.8858208170612367],
            [-7.573759259598066, 1.9413501187966065],
            [-7.570842983608701, 1.941033779244886],
            [-7.551882564109649, 2.103854684330735],
            [-7.5673287018597035, 2.105593409526516],
            [-7.561910426517205, 2.153085094564726],
            [-7.55509089081942, 2.2093906940914]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.11833725574454,
          "lat": 40.102650690830956
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08049"],
        "coty_name": ["Grand"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grand County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00198140"
      },
      "bbox": [
        -7.59453485616161, 1.3923792677996074, -6.81792169465299,
        2.2093906940914
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.795991621869968, -0.3564770002173376],
            [-8.788119050811696, -0.3567049264957932],
            [-8.783573834018492, -0.3599357415907377],
            [-8.780636957336581, -0.3598038956797825],
            [-8.777768294188293, -0.3539287265394377],
            [-8.767962232482914, -0.3455041761754905],
            [-8.766036992154374, -0.34525749921308424],
            [-8.76358164021149, -0.3398564115453996],
            [-8.767818383162915, -0.3354715936032523],
            [-8.764243256511078, -0.33059936661613315],
            [-8.766827508910897, -0.32721699718371355],
            [-8.766331534112403, -0.3232083224363065],
            [-8.760801797895498, -0.3211867606998283],
            [-8.75662421951542, -0.3168038028622762],
            [-8.751765866338488, -0.31570726616712547],
            [-8.749403962207609, -0.3128597439203924],
            [-8.745908660263593, -0.3124362619554781],
            [-8.740073739025165, -0.31542972232961347],
            [-8.737750075159939, -0.3092382535253171],
            [-8.732376759438672, -0.30072215610013436],
            [-8.727754123701674, -0.2990117433064831],
            [-8.72668363007694, -0.29622049110300747],
            [-8.728263091280517, -0.2926370039221474],
            [-8.723231230670747, -0.29000250581739173],
            [-8.722526251585716, -0.2769375891907787],
            [-8.723591158656061, -0.2716435212578157],
            [-8.716802656553112, -0.2710664723435904],
            [-8.709482703443964, -0.2634561475624176],
            [-8.705662487796555, -0.2639181645545512],
            [-8.701177107954893, -0.25871328767709645],
            [-8.700438940074969, -0.2518701731730852],
            [-8.693652336424067, -0.2478027615981647],
            [-8.684635780297674, -0.2381657166753853],
            [-8.68035191122523, -0.23991742496482704],
            [-8.67470087711963, -0.24614467140495813],
            [-8.668884324530445, -0.24860967710878817],
            [-8.66312374122516, -0.24696965773420138],
            [-8.662048116168357, -0.25272468470066944],
            [-8.657110824276254, -0.25523751457937727],
            [-8.653203147569862, -0.255310859505605],
            [-8.646159732661587, -0.24661611840923978],
            [-8.642562454093285, -0.24796723689655376],
            [-8.638358852229134, -0.24486216349399506],
            [-8.63324663393873, -0.24711721989244106],
            [-8.627081781562303, -0.24723581660582966],
            [-8.624416495217854, -0.24153194245838386],
            [-8.617834517853536, -0.24293035412818015],
            [-8.613060800856635, -0.2389032713733715],
            [-8.611303240037833, -0.2349288531454164],
            [-8.604911497129287, -0.2323225335383982],
            [-8.604219663162812, -0.22965550380864816],
            [-8.606599644325144, -0.22180401262197527],
            [-8.606779313567895, -0.21606589357719327],
            [-8.604771514871127, -0.21380608066002266],
            [-8.60522719085295, -0.20901277196374834],
            [-8.603959774561272, -0.20550497752016963],
            [-8.604773786293489, -0.19950155529410968],
            [-8.601899244678446, -0.1950479892408828],
            [-8.602405602297326, -0.18796529868038908],
            [-8.5459573291318, -0.19463187344458008],
            [-8.543353447862236, -0.19881523854919284],
            [-8.54280307656667, -0.20425308558904243],
            [-8.534017363529275, -0.2116850404409902],
            [-8.523651779355772, -0.21506019853470904],
            [-8.520420704397287, -0.21922643265976358],
            [-8.522454164405115, -0.22586253411526513],
            [-8.525512885036923, -0.2280266064079698],
            [-8.526286360736588, -0.2365793469615653],
            [-8.52428606922606, -0.2383218179120653],
            [-8.525893577344986, -0.2427524456725675],
            [-8.522299940974975, -0.24655183096927077],
            [-8.521088127357814, -0.25750422186699595],
            [-8.515988685767253, -0.2630960168736689],
            [-8.52146876651938, -0.2676154643284456],
            [-8.522628195646892, -0.27239376463707987],
            [-8.52781328802366, -0.27411768189741553],
            [-8.527650379101726, -0.27923826851621464],
            [-8.531224985255857, -0.28280741719638586],
            [-8.53068563279638, -0.28807566695506887],
            [-8.525645111071682, -0.2934053785388023],
            [-8.523311132366192, -0.29751073342456963],
            [-8.52156929177991, -0.3049018818292013],
            [-8.519610609762399, -0.30775483702832407],
            [-8.521131690391059, -0.31549720022361316],
            [-8.523270711829714, -0.3170972599713032],
            [-8.524952208086672, -0.3222412567548557],
            [-8.522941004700995, -0.3234058655563125],
            [-8.521064024175471, -0.33039624188696526],
            [-8.522318536939697, -0.3384792843306553],
            [-8.51256977847306, -0.3424549945279236],
            [-8.507091411354871, -0.3437548459269896],
            [-8.502211451778061, -0.34313835499869993],
            [-8.498684311347596, -0.34545270287531826],
            [-8.494256323357089, -0.3518250339558879],
            [-8.4911847873778, -0.35330751787028036],
            [-8.48731066221524, -0.3597463686271056],
            [-8.485844602459848, -0.3689110675080076],
            [-8.483349758000466, -0.37137396795074923],
            [-8.48173974654906, -0.37633356485310804],
            [-8.48301831489913, -0.3841991770710738],
            [-8.482333217990004, -0.38845466911358795],
            [-8.487418722910967, -0.3929396421897844],
            [-8.492749017212713, -0.40336559452903703],
            [-8.499670966195934, -0.39940106594839264],
            [-8.502754692476497, -0.39995751655411077],
            [-8.518384610653667, -0.5291283312887943],
            [-8.53271826154821, -0.5272576937001827],
            [-8.603841357096591, -0.5185739426658361],
            [-8.721528300381268, -0.5041376408390511],
            [-8.727209169122467, -0.5026504759794118],
            [-8.770425308902565, -0.49743844698612594],
            [-8.898068366329577, -0.48195950921332464],
            [-8.889882580551584, -0.47989005247026534],
            [-8.886769309715293, -0.47391631763607733],
            [-8.88918294085918, -0.464246980425107],
            [-8.88862087934336, -0.4605979104237435],
            [-8.890557212363142, -0.45769125792700716],
            [-8.890557571074314, -0.451344981661212],
            [-8.892540430802589, -0.44605057791850483],
            [-8.892521813310104, -0.44230929131572405],
            [-8.896346769672054, -0.4373300894474648],
            [-8.892141944680889, -0.43376876773030365],
            [-8.889909836861264, -0.4250790026723335],
            [-8.885329363822338, -0.42153137404622976],
            [-8.875974917786845, -0.4163550923744284],
            [-8.869256647634042, -0.4179644389758719],
            [-8.867788370798129, -0.42151989897584263],
            [-8.864522306134353, -0.4221033333044156],
            [-8.857975535485146, -0.41622029124511145],
            [-8.842869951112863, -0.4146592204225916],
            [-8.839147499182765, -0.4099293033577551],
            [-8.830966507586021, -0.4094273990848429],
            [-8.829231273363174, -0.41131076153763857],
            [-8.819291171732672, -0.41166696699252275],
            [-8.816763566940685, -0.41441591340873046],
            [-8.812086399464722, -0.4084990561723168],
            [-8.813726372287029, -0.40486233755716805],
            [-8.812499516531233, -0.4018696043906909],
            [-8.812082289354677, -0.3917731947759872],
            [-8.806601021575528, -0.3855317547797361],
            [-8.803671712760668, -0.3846903805932616],
            [-8.800091809819035, -0.37498377191583615],
            [-8.799746979045333, -0.37160037727861084],
            [-8.80507979019488, -0.3683175551315857],
            [-8.799867303762715, -0.359871302997083],
            [-8.795991621869968, -0.3564770002173376]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.67615800861012,
          "lat": 37.764041949197825
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08111"],
        "coty_name": ["San Juan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Juan County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00198171"
      },
      "bbox": [
        -8.898068366329577, -0.5291283312887943, -8.48173974654906,
        -0.18796529868038908
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.66031166310965, 0.14191647559182485],
            [-9.55605983446707, 0.12786107618605996],
            [-9.555831937740178, 0.12952894419378375],
            [-9.3596681635933, 0.1010669272477267],
            [-9.339134353107294, 0.09855343509795671],
            [-9.27279321442564, 0.08905785075800308],
            [-9.25878038688436, 0.08786480308925178],
            [-9.16441150513558, 0.0752513755397657],
            [-9.107622280410263, 0.0671730260822664],
            [-9.049668699294143, 0.05993963400488428],
            [-9.042852849826279, 0.058770400464790394],
            [-8.953478229396584, 0.04744246631979478],
            [-8.945863665572148, 0.04600894450591565],
            [-8.87767599659491, 0.037692077546140415],
            [-8.8297103263543, 0.03129173992258835],
            [-8.830392200138192, 0.023820310520354215],
            [-8.819769125532119, 0.02255700576716756],
            [-8.823313347153602, -0.00636729185967977],
            [-8.776874093593865, -0.012394003998618721],
            [-8.779542477316543, -0.026928133252380144],
            [-8.78097259089963, -0.04133914926325257],
            [-8.78460076485232, -0.04106794682136406],
            [-8.783481095096487, -0.055823174360227865],
            [-8.785993322737747, -0.07049705580659922],
            [-8.784608153047584, -0.07057460423564696],
            [-8.785261221602418, -0.07978480090894052],
            [-8.783117273449594, -0.0834303802799498],
            [-8.786274541172117, -0.08489179672757],
            [-8.791049966063422, -0.09325873455561912],
            [-8.794674427173584, -0.10187519156346311],
            [-8.788094331909345, -0.10392339309759947],
            [-8.78761490246128, -0.11113358122243237],
            [-8.78945239929625, -0.11505910730824809],
            [-8.784233463391695, -0.12198475804730922],
            [-8.780526711333183, -0.12157425382315627],
            [-8.776768617094183, -0.12348439664698989],
            [-8.767808891145217, -0.12195169568408389],
            [-8.764072069521795, -0.1235124582207309],
            [-8.757462355320042, -0.1241619533702433],
            [-8.75256043970039, -0.12769183554760155],
            [-8.752653756398269, -0.1322985311322581],
            [-8.75789539846618, -0.13531789575666095],
            [-8.759330499192687, -0.1402867170444147],
            [-8.749551606784145, -0.1417618609034909],
            [-8.745106751845718, -0.1456256484163947],
            [-8.741375150038477, -0.14690657742645402],
            [-8.73291996859464, -0.14540912648128856],
            [-8.725537739530976, -0.14838784272596353],
            [-8.723768870044912, -0.15038548503764126],
            [-8.718589560208864, -0.14938926910601116],
            [-8.716461924428197, -0.1559284423324193],
            [-8.71316326947423, -0.16025255437213815],
            [-8.715374001333014, -0.1632710510172399],
            [-8.712953378011688, -0.16790896392946034],
            [-8.710986413948717, -0.17608959222987422],
            [-8.701336564187011, -0.17880551167507677],
            [-8.695382311834665, -0.1816772088899046],
            [-8.692051219559268, -0.18716517998104978],
            [-8.686928491907924, -0.18935877526582098],
            [-8.68428970367635, -0.1971342715939544],
            [-8.684428993369785, -0.20093594992956992],
            [-8.68109782187286, -0.2041814960078137],
            [-8.680955389679522, -0.20823894012398012],
            [-8.67736060826314, -0.21440685850841507],
            [-8.680110516151489, -0.21895909233755037],
            [-8.679050105272943, -0.2241215285662774],
            [-8.682499558591639, -0.22596057365328054],
            [-8.681456853699547, -0.23259835022982345],
            [-8.684635780297674, -0.2381657166753853],
            [-8.693652336424067, -0.2478027615981647],
            [-8.700438940074969, -0.2518701731730852],
            [-8.701177107954893, -0.25871328767709645],
            [-8.705662487796555, -0.2639181645545512],
            [-8.709482703443964, -0.2634561475624176],
            [-8.716802656553112, -0.2710664723435904],
            [-8.723591158656061, -0.2716435212578157],
            [-8.722526251585716, -0.2769375891907787],
            [-8.723231230670747, -0.29000250581739173],
            [-8.728263091280517, -0.2926370039221474],
            [-8.72668363007694, -0.29622049110300747],
            [-8.727754123701674, -0.2990117433064831],
            [-8.732376759438672, -0.30072215610013436],
            [-8.737750075159939, -0.3092382535253171],
            [-8.740073739025165, -0.31542972232961347],
            [-8.745908660263593, -0.3124362619554781],
            [-8.749403962207609, -0.3128597439203924],
            [-8.751765866338488, -0.31570726616712547],
            [-8.75662421951542, -0.3168038028622762],
            [-8.760801797895498, -0.3211867606998283],
            [-8.766331534112403, -0.3232083224363065],
            [-8.766827508910897, -0.32721699718371355],
            [-8.764243256511078, -0.33059936661613315],
            [-8.767818383162915, -0.3354715936032523],
            [-8.76358164021149, -0.3398564115453996],
            [-8.766036992154374, -0.34525749921308424],
            [-8.767962232482914, -0.3455041761754905],
            [-8.777768294188293, -0.3539287265394377],
            [-8.780636957336581, -0.3598038956797825],
            [-8.783573834018492, -0.3599357415907377],
            [-8.788119050811696, -0.3567049264957932],
            [-8.795991621869968, -0.3564770002173376],
            [-8.798182196037155, -0.3525281939672847],
            [-8.802741243088864, -0.34959077356131496],
            [-8.802003651814054, -0.34678181816832687],
            [-8.80470956387022, -0.34422237847217185],
            [-8.814475607358538, -0.344042549129096],
            [-8.817371197247148, -0.33811539238443933],
            [-8.815060128461818, -0.33308414583120405],
            [-8.817161510911248, -0.3261962728972546],
            [-8.826134663477516, -0.32017966723508196],
            [-8.83499508268121, -0.30763662906094125],
            [-8.836889282147649, -0.3022802973855795],
            [-8.846632647230933, -0.3012750188226218],
            [-8.849670636835132, -0.30173221438865755],
            [-8.854489169933055, -0.29561306270443294],
            [-8.858034623498206, -0.2874741850995234],
            [-8.864744511351532, -0.28776471247649493],
            [-8.87043228630031, -0.28978818362747594],
            [-8.874621759962373, -0.288643016563716],
            [-8.877221291607258, -0.2848112704128819],
            [-8.879817623597233, -0.27721157586158496],
            [-8.882935986702684, -0.2747551243854952],
            [-8.885368686428317, -0.26263599124884357],
            [-8.893055583192169, -0.2624822189202901],
            [-8.8957596727983, -0.26085536307067864],
            [-8.899593373023064, -0.2624328933374639],
            [-8.903731621296792, -0.25989268205464866],
            [-8.90854918362365, -0.26083780881762364],
            [-8.917825142219156, -0.25967828587048947],
            [-8.922104055010209, -0.262506145226704],
            [-8.930888129127828, -0.262598669201175],
            [-8.935086310120369, -0.26693870700144207],
            [-8.938645397683253, -0.2685015421571576],
            [-8.94480467663467, -0.2651656917037751],
            [-8.946016083420488, -0.2606122689959584],
            [-8.958171528753377, -0.26597924630224323],
            [-8.96126095203133, -0.2682658586833852],
            [-8.966083575947247, -0.26930147469911486],
            [-8.969267919462748, -0.26642943610046804],
            [-8.971015599991087, -0.2601015646169921],
            [-8.981840879147914, -0.25199093648707827],
            [-8.987906036616351, -0.2524097214843708],
            [-8.991380688652143, -0.2538770926126346],
            [-8.993403066555926, -0.26035641033090845],
            [-9.002736768336687, -0.26674637963196546],
            [-9.006614913712495, -0.2717827726081619],
            [-9.00840426048466, -0.2655358583174373],
            [-9.013081773201376, -0.26904592296167545],
            [-9.021060684411076, -0.26854627158930444],
            [-9.023616587460713, -0.26708320833222315],
            [-9.028210132416497, -0.27037415208974735],
            [-9.032490266117598, -0.26831409142294105],
            [-9.039690627347444, -0.273610379214426],
            [-9.047109941821354, -0.27475626467862113],
            [-9.052330008448655, -0.27431387474598384],
            [-9.061323239622208, -0.2762703901476173],
            [-9.060945017504418, -0.2682509875730907],
            [-9.064653204179761, -0.25992751217930055],
            [-9.068323556486542, -0.2570876826157395],
            [-9.070852107975458, -0.2501900440151979],
            [-9.072022516741598, -0.24119120329653865],
            [-9.071218263857608, -0.23434784076349702],
            [-9.074390959359999, -0.22551435757656543],
            [-9.075625174192739, -0.21814640646658973],
            [-9.083064402157204, -0.21414025609286447],
            [-9.08427330669088, -0.2086967529676411],
            [-9.089202387940546, -0.2019348289892515],
            [-9.087725259115977, -0.19803087533051406],
            [-9.166077192058372, -0.18881501468673004],
            [-9.180177835676385, -0.18697295799430358],
            [-9.372533707626928, -0.15979731982189893],
            [-9.373652957684344, -0.15975983406188274],
            [-9.463905583779498, -0.14748027999307134],
            [-9.521579838909195, -0.1395214810689518],
            [-9.525826833671088, -0.14862337812364398],
            [-9.52720927346299, -0.15365447131798773],
            [-9.576745097030663, -0.14682663389429074],
            [-9.697735776967825, -0.1301402897066738],
            [-9.693661694162007, -0.10404451017355784],
            [-9.685999246617166, -0.03677772534566125],
            [-9.68230722785451, -0.011760520623773847],
            [-9.66031166310965, 0.14191647559182485]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.40586515662746,
          "lat": 38.003822836301374
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08113"],
        "coty_name": ["San Miguel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Miguel County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00198172"
      },
      "bbox": [
        -9.697735776967825, -0.3599357415907377, -8.67736060826314,
        0.14191647559182485
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.693682622283667, 0.7837437424019503],
            [-6.692964864782494, 0.7836862505525305],
            [-6.565409603112756, 0.7713366161943087],
            [-6.466588945702061, 0.7620516701252603],
            [-6.471398484471613, 0.6602574491843771],
            [-6.473273723003264, 0.6456295245601732],
            [-6.476356195820484, 0.6309927873359712],
            [-6.4756946152171695, 0.6164708026126541],
            [-6.478389250259256, 0.5861815521720677],
            [-6.48315657708814, 0.542861072096197],
            [-6.48440933004121, 0.5284042206915062],
            [-6.48788725350674, 0.49933134677150853],
            [-6.516866498441828, 0.5025516093431387],
            [-6.51915110494166, 0.4902622751360968],
            [-6.527388589869028, 0.4419138074349416],
            [-6.527991379923146, 0.4328245843874658],
            [-6.514289812031699, 0.43160840601428874],
            [-6.494946584430337, 0.42832043607989534],
            [-6.484625495324672, 0.4271024452751264],
            [-6.468525493085931, 0.4263118505340398],
            [-6.43324408194577, 0.42298071897065925],
            [-6.426591516095093, 0.42030825438883784],
            [-6.4340505587230865, 0.3337728262152049],
            [-6.435977798570407, 0.3195478917605584],
            [-6.437917226731367, 0.31967915109618983],
            [-6.442275209686196, 0.2732995926267361],
            [-6.4827567967219455, 0.27867862929518267],
            [-6.4966899218720116, 0.2810878336051188],
            [-6.524901669392338, 0.28344706442569656],
            [-6.543497750120893, 0.2812989017588152],
            [-6.557349882480503, 0.28183645771893256],
            [-6.574780201789378, 0.28371887926160855],
            [-6.633573567522146, 0.2895946824060521],
            [-6.671752742736816, 0.2926090395654953],
            [-6.670600884388518, 0.30741527264770774],
            [-6.666442329721934, 0.3242961237261548],
            [-6.66465291047541, 0.34244269254719856],
            [-6.735332844932007, 0.3496632188703354],
            [-6.719646348275736, 0.5104073457416242],
            [-6.716257919453526, 0.5458460144884859],
            [-6.709980264185122, 0.6141888560591245],
            [-6.706504900821594, 0.6464134746855856],
            [-6.693682622283667, 0.7837437424019503]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -105.16175458867798, "lat": 38.8823998799187 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08119"],
        "coty_name": ["Teller"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Teller County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00198175"
      },
      "bbox": [
        -6.735332844932007, 0.2732995926267361, -6.426591516095093,
        0.7837437424019503
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.996066546681053, -8.157092970450021],
            [13.052202119027216, -8.147639912673974],
            [13.127991633724553, -8.134211025774885],
            [13.167008334697845, -8.1277515668587],
            [13.162475420868567, -8.100520278329716],
            [13.16781174188099, -8.101886792432165],
            [13.175201151568839, -8.10921356345597],
            [13.179964832257095, -8.108679171707509],
            [13.182192413362596, -8.101158049692227],
            [13.185681600444974, -8.099300423019317],
            [13.192143415416464, -8.09974694926889],
            [13.195132348185606, -8.097617334578091],
            [13.199192734805699, -8.097923097225063],
            [13.206143768003187, -8.092383944599462],
            [13.206012883127686, -8.08665039664133],
            [13.213478978362273, -8.079888683359052],
            [13.227772999602541, -8.084802843721375],
            [13.23557990653555, -8.080032153337434],
            [13.24045141266391, -8.078512864208614],
            [13.243123027039621, -8.070949404024939],
            [13.255486131936356, -8.068901137890697],
            [13.25716793564909, -8.072231100956097],
            [13.315726374042955, -8.175180914022347],
            [13.362421991799218, -8.248883557580504],
            [13.372716351483113, -8.265502317297956],
            [13.388729753512232, -8.292265516278569],
            [13.381573140502876, -8.29345028916786],
            [13.365929773688611, -8.301237427578986],
            [13.350038652998181, -8.308589890929253],
            [13.351305918803074, -8.313341808098754],
            [13.344792501599477, -8.315250260067735],
            [13.350957105310936, -8.342393479241094],
            [13.35697450883535, -8.37398029663718],
            [13.372339069027957, -8.456120747692259],
            [13.333103931270488, -8.463399420172406],
            [13.321443166169646, -8.465932261807145],
            [13.217915292675656, -8.483712647556878],
            [13.189212186993435, -8.488738794468746],
            [13.142637956884856, -8.496385970762182],
            [13.141071067954785, -8.488477462473835],
            [13.118505259690547, -8.361508650919978],
            [13.115462412522174, -8.364303116141548],
            [13.10726391091602, -8.364321370776839],
            [13.103343691693105, -8.366321581472489],
            [13.093300759047214, -8.374860934078333],
            [13.09052942368912, -8.375784273726268],
            [13.078854282862226, -8.37496301083084],
            [13.071197885670886, -8.372226926830376],
            [13.068603394672746, -8.369719953030588],
            [13.066615663217695, -8.364318216327401],
            [13.064957578436715, -8.355363150050401],
            [13.062647086222768, -8.35071178132261],
            [13.058584165074741, -8.346125966069488],
            [13.054726795223635, -8.325293237124084],
            [13.049975974385003, -8.317407931787773],
            [13.038784426197719, -8.30442675692853],
            [13.02131209156731, -8.285718784651996],
            [13.01792102233907, -8.279874736023308],
            [13.006748987134303, -8.218168150719583],
            [12.996066546681053, -8.157092970450021]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.31356513739688, "lat": 29.46139172833092 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12035"],
        "coty_name": ["Flagler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Flagler County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00308547"
      },
      "bbox": [
        12.996066546681053, -8.496385970762182, 13.388729753512232,
        -8.068901137890697
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.718169317583047, -7.820720461097944],
            [10.705870936143521, -7.72601678386452],
            [10.705574597152802, -7.720667470246467],
            [10.69874975565139, -7.6623754526965495],
            [10.723448991503137, -7.630248952052465],
            [10.721103735997577, -7.60986098475267],
            [10.716367378322518, -7.572473841787263],
            [10.7696039491798, -7.5649937295299825],
            [10.765862590550979, -7.557373672221066],
            [10.763780932999738, -7.555788302978596],
            [10.763481398380012, -7.549411625619585],
            [10.76115209258612, -7.546676607847828],
            [10.759278752413636, -7.539381263462796],
            [10.764280867486342, -7.53516443825082],
            [10.754291652538726, -7.528447575506161],
            [10.748126265034806, -7.519340213374535],
            [10.74715219066789, -7.511382785831284],
            [10.742483251540518, -7.507127465427721],
            [10.740475317615731, -7.494559703578507],
            [10.738491065512427, -7.492320126494762],
            [10.737014485971965, -7.486863205474435],
            [10.73388266676612, -7.482742314787685],
            [10.731585461479204, -7.46606509351881],
            [10.726159123816904, -7.4207945629824845],
            [10.83516953922286, -7.413315006911473],
            [10.886158963500073, -7.4100181714368505],
            [10.895061351690357, -7.409613866850719],
            [10.952365150774343, -7.405757108674071],
            [11.009796436844715, -7.401851300144824],
            [11.065628304927, -7.398268930177141],
            [11.066917590940568, -7.410654997154108],
            [11.073553918797296, -7.410293342417039],
            [11.075694124105317, -7.42776986026076],
            [11.081078462497208, -7.465769678040958],
            [11.066980039834991, -7.467537862970589],
            [11.068493339490587, -7.482002804294299],
            [11.054717022334595, -7.483670486648887],
            [11.05658215959942, -7.498260135251708],
            [11.027839903391238, -7.5017922515360915],
            [11.029801359524733, -7.5164094702658],
            [11.001481013975452, -7.519992999006815],
            [11.003372652717667, -7.534850623237762],
            [10.984904851176776, -7.537300446605448],
            [10.982093278451341, -7.541869984217952],
            [10.977541387494874, -7.5531345702823485],
            [10.980043569074644, -7.5623021052885795],
            [10.981696448613093, -7.562396997487973],
            [10.984534278953811, -7.5680380669671665],
            [10.987778638253765, -7.569941442627587],
            [10.989527057657881, -7.575073348838666],
            [10.988315038420703, -7.576870076041492],
            [10.989676385050949, -7.5846278410095715],
            [10.988914574337345, -7.5870887010848325],
            [10.992886714046568, -7.590754113566758],
            [10.994658708195633, -7.597902651308832],
            [10.991879107708465, -7.603694881111492],
            [10.993846441441535, -7.610454352399656],
            [10.998067247238293, -7.616438780483637],
            [11.000021055879678, -7.624096852022099],
            [10.99568291929033, -7.626478948058939],
            [10.995450514896717, -7.629904716693074],
            [10.991591002628109, -7.635302202433088],
            [10.985623419631514, -7.639490330413604],
            [10.98409983180166, -7.6447730590876075],
            [10.978417709432453, -7.653667868932517],
            [10.979555366897458, -7.6561481240183555],
            [10.978869279763478, -7.66313598236015],
            [10.975790730591239, -7.665086225246517],
            [10.976921295812115, -7.669703918397113],
            [10.975983491641967, -7.676138906121113],
            [10.966919805542972, -7.680822975874859],
            [10.964826470979807, -7.679872010644549],
            [10.957177484156526, -7.681968708579583],
            [10.954693937653845, -7.68548047033116],
            [10.949815462432358, -7.682758477737883],
            [10.949246783823535, -7.675586041633379],
            [10.946231742273751, -7.675519519320698],
            [10.941325951438763, -7.6838770296953305],
            [10.93726423878106, -7.688989542337233],
            [10.935560478059532, -7.695110650270417],
            [10.935239656165965, -7.70215888776669],
            [10.936845183689465, -7.704185911772473],
            [10.940148797897717, -7.713137823864121],
            [10.93823016882786, -7.718087619650926],
            [10.944938050590496, -7.719554100477548],
            [10.95138311249472, -7.729305372201463],
            [10.957403627891019, -7.732372226638139],
            [10.956835919416939, -7.7398054442781286],
            [10.954359830326869, -7.745258767517771],
            [10.94908514112276, -7.747441864514809],
            [10.947405277926729, -7.749994619629241],
            [10.943402124621068, -7.7500540773330355],
            [10.938582948777876, -7.7481359368707325],
            [10.934835593239248, -7.749879679947077],
            [10.931222848845097, -7.754263100611873],
            [10.930812284783359, -7.760066870936372],
            [10.932696786378894, -7.763686126595817],
            [10.933165237955919, -7.7675021118915275],
            [10.928763277211779, -7.770642802499816],
            [10.926436908457037, -7.776248230730908],
            [10.926812064104965, -7.780124940396212],
            [10.9233100013302, -7.781729364590435],
            [10.920044557624115, -7.788456596915078],
            [10.91496981581682, -7.7920720592971024],
            [10.90742793623145, -7.793437802574923],
            [10.907371290012286, -7.796412653499483],
            [10.891788612225378, -7.803601502558517],
            [10.886739171433362, -7.80393397993114],
            [10.884001094209205, -7.808457733007276],
            [10.876464215559185, -7.813631372205001],
            [10.873168699007106, -7.818356252733399],
            [10.873333020375133, -7.822682104342846],
            [10.866072876570191, -7.828727466020801],
            [10.862956004483177, -7.828447208568373],
            [10.858614602494889, -7.831290905273883],
            [10.859204634534642, -7.834475204328991],
            [10.858632334798365, -7.8449746189337475],
            [10.856184359991502, -7.846876937527799],
            [10.860524227751648, -7.853018050964401],
            [10.858957912978454, -7.856747119043882],
            [10.860349582198905, -7.861654907257175],
            [10.858398740102578, -7.863376134160819],
            [10.855016112437855, -7.872559508340534],
            [10.857011174741961, -7.873843254333207],
            [10.855498353782998, -7.886191771633921],
            [10.843725955801473, -7.886480105168927],
            [10.835498453758232, -7.893327398759479],
            [10.836561746276907, -7.898223118350795],
            [10.8321861573631, -7.905628121094118],
            [10.83300548090291, -7.9178856604283245],
            [10.829184546178382, -7.922570099372691],
            [10.831352745277542, -7.928967600429301],
            [10.821775994564897, -7.935710827589206],
            [10.823872245672046, -7.941857231645908],
            [10.82689462663683, -7.943873737749147],
            [10.823587177477032, -7.954440767061524],
            [10.820858971450628, -7.958351323229284],
            [10.819507328167866, -7.963320938134944],
            [10.819261750388065, -7.97143390337977],
            [10.817200971971491, -7.977091166708759],
            [10.814523154941163, -7.978627664706213],
            [10.811856917191509, -7.986359807939733],
            [10.813826489952307, -7.996292942681529],
            [10.809952751094354, -8.001080020964277],
            [10.804825765030287, -7.9982303759525015],
            [10.806492851215955, -7.991854003397115],
            [10.804040403928227, -7.9888738876999446],
            [10.799195201236053, -7.986605118862313],
            [10.792980560886855, -7.987610516023791],
            [10.783460301956149, -7.98286721176329],
            [10.772928867449753, -7.9851731526359355],
            [10.770196472088095, -7.988163135983661],
            [10.762518157530263, -7.985554571740086],
            [10.752577118480565, -7.989507956882213],
            [10.75051128403188, -7.988885770556067],
            [10.740063225777808, -7.9961018748979376],
            [10.736166495349774, -7.966778634956085],
            [10.719304473604797, -7.8315074377633165],
            [10.718169317583047, -7.820720461097944]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.89532085754945, "lat": 30.4375446698938 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12065"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00295733"
      },
      "bbox": [
        10.69874975565139, -8.001080020964277, 11.081078462497208,
        -7.398268930177141
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.217506821098114, -8.960097663291222],
            [13.218802578421435, -8.968406651084004],
            [13.218490649208931, -8.97595807635481],
            [13.2203850853509, -8.981502847346011],
            [13.220521520848589, -8.989439240345925],
            [13.218936115727455, -8.990744003918802],
            [13.217289628546233, -9.01024281459017],
            [13.214828411518535, -9.01220774577132],
            [13.205043227181855, -9.032305961861695],
            [13.200935606163867, -9.034328634237283],
            [13.19080649187765, -9.035252452561624],
            [13.189601620719975, -9.036486258588594],
            [13.200538118127152, -9.107689118857103],
            [13.239254730333844, -9.101924046911089],
            [13.28573600156209, -9.094459991470028],
            [13.285921084409525, -9.095512660890277],
            [13.314683676633987, -9.090797215030156],
            [13.31966760341084, -9.119078705631283],
            [13.37649784243503, -9.109339865636224],
            [13.437506091248883, -9.09931208649943],
            [13.452717142083776, -9.096994346261152],
            [13.519079741330044, -9.085970684393894],
            [13.545408824712785, -9.081910192426882],
            [13.608204137519888, -9.071568916257425],
            [13.615290053240342, -9.070629299397217],
            [13.618785521159895, -9.0729044503081],
            [13.626232390930173, -9.074055609317497],
            [13.62782623308846, -9.07033199786147],
            [13.631448538386447, -9.072694479533297],
            [13.631913471821177, -9.075799563365162],
            [13.640580442498312, -9.076700479233027],
            [13.647096139132442, -9.074355229838613],
            [13.646837296438038, -9.077570390788525],
            [13.653113101373432, -9.080439652513897],
            [13.65647395279898, -9.083430073985499],
            [13.655549265679063, -9.09079047873559],
            [13.657991833544763, -9.09554402766497],
            [13.661451036256494, -9.09818532015511],
            [13.663365026868917, -9.103524864170927],
            [13.666074205574674, -9.104090139683048],
            [13.672828375454168, -9.111233630154821],
            [13.66992611507915, -9.11556700659303],
            [13.672414458693911, -9.122891505946914],
            [13.672105872168968, -9.129674489241522],
            [13.673674576623068, -9.133157078638343],
            [13.668401929279298, -9.133076321577683],
            [13.670812458033662, -9.138284609039365],
            [13.674393275550296, -9.140784128817833],
            [13.683427696477638, -9.139978224105514],
            [13.686995846332579, -9.14692451275333],
            [13.691138255853287, -9.1486901731838],
            [13.69958809800034, -9.149759734601423],
            [13.70156676297532, -9.153220690062165],
            [13.700542600007635, -9.156171794894634],
            [13.703275222227248, -9.158995687263973],
            [13.707161538074079, -9.15746728487269],
            [13.711794626815735, -9.158187715764745],
            [13.715457398280465, -9.15574459240965],
            [13.7196915218414, -9.15660555923361],
            [13.722755448010208, -9.16212770624549],
            [13.724539412825214, -9.162159409236846],
            [13.726774748516743, -9.168168639600244],
            [13.723578997078576, -9.171396949042315],
            [13.725404985520917, -9.17447532407463],
            [13.729714530560233, -9.175513414794692],
            [13.734860739816444, -9.182212021384798],
            [13.735106129951117, -9.188046054336848],
            [13.738714024014907, -9.192062446422616],
            [13.73546403023327, -9.195472853212008],
            [13.725323343865242, -9.196314838053162],
            [13.718962334755787, -9.199822911141332],
            [13.720675953664996, -9.208606345106476],
            [13.71744726530527, -9.212046114522014],
            [13.720348321247082, -9.215499427241722],
            [13.72395530795848, -9.216977064024253],
            [13.72610798937942, -9.220447836326063],
            [13.723112141216596, -9.222306038859287],
            [13.722896175212233, -9.229887949680153],
            [13.721145842801173, -9.234729798622086],
            [13.725312843751553, -9.245100751123736],
            [13.736027818876718, -9.253213375237443],
            [13.736303687974077, -9.263952582265901],
            [13.738649806870695, -9.267715743976847],
            [13.734969571484932, -9.271860377086458],
            [13.737178122499488, -9.275804709326014],
            [13.743924690657108, -9.282104034118376],
            [13.747096737927519, -9.289800212442675],
            [13.750431267444366, -9.288459683439608],
            [13.753196789153792, -9.291608386722643],
            [13.75349504823861, -9.299567819270111],
            [13.761545959723296, -9.309520280723737],
            [13.765305980144895, -9.311744243839088],
            [13.629606456522998, -9.332706304936588],
            [13.493899518462744, -9.353619593731459],
            [13.461723820492114, -9.358704752527373],
            [13.390337863680191, -9.369733644286121],
            [13.30707569121213, -9.382693824439901],
            [13.255267217854351, -9.390576165190518],
            [13.246795400937494, -9.392483797710948],
            [13.22079842430443, -9.396630060382064],
            [13.181014035855142, -9.402459562006714],
            [13.080692681880716, -9.417951611874665],
            [13.072783955291262, -9.418958277509619],
            [13.067243990276802, -9.382986596769971],
            [13.057066708145353, -9.31829574085218],
            [13.046297961763353, -9.248398687916547],
            [13.039436110806063, -9.202180714744687],
            [13.043034104752632, -9.200525651717387],
            [13.043689974425497, -9.196272377007181],
            [13.042441921266041, -9.191443039190293],
            [13.045155560870933, -9.186722049101],
            [13.03960338158409, -9.181611193563034],
            [13.036029976798789, -9.180034237606106],
            [13.033981671722328, -9.165159327075491],
            [13.025196329568072, -9.115510490695009],
            [13.022291332140528, -9.098147291521965],
            [13.008726248809104, -9.010800081906059],
            [13.017018888458104, -9.009051671158627],
            [13.01944508687797, -9.002963128487092],
            [13.019296349173407, -8.999652193817836],
            [13.016297824899837, -8.990283255488016],
            [13.09140127395844, -8.978762251048666],
            [13.163025684476606, -8.967778811503154],
            [13.170041329368498, -8.967121400235191],
            [13.217506821098114, -8.960097663291222]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.32347624204735, "lat": 28.51441299392291 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12095"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00295750"
      },
      "bbox": [
        13.008726248809104, -9.418958277509619, 13.765305980144895,
        -8.960097663291222
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.261044800432353, -10.212490356350504],
              [12.261969882500416, -10.209144259603425],
              [12.267372770091391, -10.209113134071263],
              [12.268709169602078, -10.214246197865434],
              [12.261946247663737, -10.216226236469636],
              [12.261044800432353, -10.212490356350504]
            ]
          ],
          [
            [
              [12.068328149753434, -9.78929899668444],
              [12.068549575663177, -9.783453128122733],
              [12.071555244071002, -9.779085249824439],
              [12.076778143921869, -9.778697985385065],
              [12.072561409435998, -9.784253935663553],
              [12.071481233917078, -9.789073318058152],
              [12.073538592573255, -9.794612036921425],
              [12.079028399319713, -9.797392244346973],
              [12.079706127604457, -9.800451629132294],
              [12.070024522971897, -9.797309974806916],
              [12.068328149753434, -9.78929899668444]
            ]
          ],
          [
            [
              [12.061452963085877, -9.738472770789583],
              [12.064422835132223, -9.742895566525108],
              [12.0628668011908, -9.746100004886888],
              [12.059206362244364, -9.745156303758288],
              [12.057057114030007, -9.739092872956922],
              [12.061452963085877, -9.738472770789583]
            ]
          ],
          [
            [
              [12.105294905111938, -9.731200870894895],
              [12.113242110298373, -9.730224735188575],
              [12.160836431358264, -9.72334099557306],
              [12.22925763076921, -9.713739418521362],
              [12.233705175066904, -9.74123864320528],
              [12.241401022241925, -9.7858283946093],
              [12.2465526302874, -9.820233122157667],
              [12.248036482924078, -9.827226396544278],
              [12.253216395439651, -9.864288442850961],
              [12.247611992641255, -9.866411335373147],
              [12.246012109853092, -9.86969182532166],
              [12.248844924812031, -9.873521029683443],
              [12.247514466352623, -9.882885872968311],
              [12.241130008463843, -9.882628372726435],
              [12.240765270067646, -9.874734931610497],
              [12.236690112101593, -9.868352831984424],
              [12.237908488854485, -9.865473620702902],
              [12.237067947829921, -9.856645164449564],
              [12.226181224507359, -9.853375148595473],
              [12.218013457673122, -9.85721410536474],
              [12.21547385344969, -9.860271658121595],
              [12.220774016118593, -9.866282407312063],
              [12.223597504197313, -9.872456434512317],
              [12.229690106354015, -9.876394256361218],
              [12.23125914371567, -9.879920655576832],
              [12.222860136762174, -9.896862938748441],
              [12.219250653607068, -9.903018331137034],
              [12.219451163298391, -9.910676426743006],
              [12.223163634006356, -9.911348435678963],
              [12.219088092269246, -9.923370089175933],
              [12.215981628782568, -9.926782435976891],
              [12.210388318066505, -9.927342239928034],
              [12.207240676495557, -9.93124646028786],
              [12.201860031454851, -9.930632493663751],
              [12.197750699518254, -9.934952918359981],
              [12.196275684693132, -9.943938480357359],
              [12.199259919204126, -9.943536078187416],
              [12.201180740205048, -9.947977115560144],
              [12.197328891450493, -9.951122736141608],
              [12.201358969815491, -9.952743645667521],
              [12.218554750010618, -9.962463159400212],
              [12.227283343227748, -9.96252138901425],
              [12.230835357932142, -9.960304077898105],
              [12.232123840715259, -9.96537600510964],
              [12.236082586729266, -9.968069419615732],
              [12.242983480416685, -9.969112231330307],
              [12.25191385224884, -9.969255930285728],
              [12.26617929862428, -9.973106138690804],
              [12.269774778907252, -9.973244554861981],
              [12.271999773650453, -9.968712326964239],
              [12.277925151620549, -9.97334461517063],
              [12.283502131559473, -9.968879857849602],
              [12.2790631162838, -9.97968030961024],
              [12.279707749861021, -9.984715186755448],
              [12.285350879749211, -9.985715976032392],
              [12.300533843280233, -9.993759612735952],
              [12.314281023226277, -10.007367189562785],
              [12.320518010367174, -10.007576354520245],
              [12.319627270814424, -10.014139719587208],
              [12.324797492727376, -10.027464878446873],
              [12.330710184758688, -10.034265921522037],
              [12.33195234007776, -10.039314650423568],
              [12.327706164739892, -10.045068343194586],
              [12.329327714914928, -10.048439273370656],
              [12.334537540833336, -10.050265243002382],
              [12.334286854223995, -10.053892923132187],
              [12.331856750436055, -10.056546591150747],
              [12.32687760872207, -10.056614747097097],
              [12.323459479500034, -10.064756586691821],
              [12.320763475233628, -10.067978698694537],
              [12.319946220627388, -10.072218833967646],
              [12.321821244579104, -10.074373464675539],
              [12.321077022055945, -10.078018942335934],
              [12.317446089645657, -10.081083019093523],
              [12.308111465945302, -10.083486968757379],
              [12.306413187005358, -10.091918368651537],
              [12.310956273452163, -10.09817868869935],
              [12.31005800721128, -10.10331044854217],
              [12.310766269216613, -10.11165576020987],
              [12.307475349279182, -10.114089983532853],
              [12.305914266360515, -10.118736354511197],
              [12.307604282418723, -10.123047193506302],
              [12.31193437129872, -10.123340426915213],
              [12.313657181265489, -10.126891091990714],
              [12.310640626118046, -10.130793715698655],
              [12.313714574120919, -10.138636556506214],
              [12.31389452243306, -10.144254261479832],
              [12.309229822590874, -10.161137776353993],
              [12.30470619035609, -10.168399756650864],
              [12.294025304942458, -10.173449833739946],
              [12.28458955108376, -10.172782749110585],
              [12.276428231444232, -10.170354002797112],
              [12.27136783466705, -10.170760034180143],
              [12.272994589749587, -10.181575258049161],
              [12.270735061421219, -10.182052323027298],
              [12.268780992864107, -10.171538906288374],
              [12.265097274420613, -10.174132669319444],
              [12.261915464850327, -10.178739849679653],
              [12.25403054684495, -10.177333642284486],
              [12.252345647192728, -10.171528176625134],
              [12.241424131185182, -10.175748569220241],
              [12.240445829664276, -10.182516689010127],
              [12.236795647005978, -10.189606932762336],
              [12.239335497465147, -10.192491199504113],
              [12.237355965486863, -10.195469712150148],
              [12.238588022037671, -10.207107999166329],
              [12.234548556754982, -10.208410134007378],
              [12.235304895427424, -10.212880706739137],
              [12.238378463563643, -10.215806581322136],
              [12.236615972388662, -10.218970248915754],
              [12.242170544247886, -10.22268939820772],
              [12.244628031776156, -10.228693050440262],
              [12.248607687487445, -10.232853279185244],
              [12.247189828662032, -10.236769470679215],
              [12.250519346899365, -10.237379832614769],
              [12.254948660063244, -10.248316196286577],
              [12.258098512942246, -10.247579067661473],
              [12.260656780887413, -10.239695068911198],
              [12.262484096062517, -10.239697006839728],
              [12.260080423264354, -10.249859674715491],
              [12.258211167601784, -10.25263136423765],
              [12.237209656123586, -10.266397494292407],
              [12.231792339594788, -10.268823938777876],
              [12.231096344143234, -10.256795310761511],
              [12.228486368974496, -10.249378043432415],
              [12.2257553989632, -10.245380131554153],
              [12.220520559505287, -10.235085037633919],
              [12.218733276830244, -10.22993133803002],
              [12.218772592837473, -10.20845535520245],
              [12.22071889566643, -10.200069736064455],
              [12.217837061079909, -10.177583476098222],
              [12.214232624991546, -10.166800608784701],
              [12.207014000321719, -10.15593640347199],
              [12.199931095417089, -10.150862358394486],
              [12.192362877908518, -10.143099066269091],
              [12.181043853759439, -10.123807527139812],
              [12.171440183163853, -10.116660881518598],
              [12.166552921346979, -10.109121727098264],
              [12.159975060945731, -10.102184163191708],
              [12.130547202616295, -10.08376443483248],
              [12.12222717207879, -10.076479697727306],
              [12.107319023785587, -10.057033707931305],
              [12.102024097772638, -10.047520091847144],
              [12.098515724966875, -10.039188786264802],
              [12.09525277646998, -10.028736695067137],
              [12.092713705523805, -10.01743196661177],
              [12.09320051350262, -9.993368723026462],
              [12.094276530619974, -9.969781913263697],
              [12.098971004866488, -9.953328193217866],
              [12.100053922720274, -9.938668616802456],
              [12.09885573056575, -9.933157320355628],
              [12.099055824289424, -9.920865834975261],
              [12.096648681673868, -9.899357833015804],
              [12.095344857363294, -9.884146388235937],
              [12.09989044598511, -9.855204582140933],
              [12.102037341258335, -9.857854642578388],
              [12.106533769668294, -9.871585455885358],
              [12.106102822945513, -9.88204394724059],
              [12.106899307722344, -9.890668817145059],
              [12.113908669336741, -9.89511231875998],
              [12.108970717068026, -9.900783991045788],
              [12.107758390215585, -9.905733765556159],
              [12.113254706579093, -9.916002370543742],
              [12.11574603617136, -9.918571279151411],
              [12.117362040831084, -9.923965964928865],
              [12.11753966218016, -9.931221196026032],
              [12.123248269721604, -9.933972342716483],
              [12.125368785964689, -9.917409351172513],
              [12.125007702931779, -9.911888349260124],
              [12.126436392516982, -9.910025597478574],
              [12.12809102106437, -9.893159504062568],
              [12.12626659889868, -9.887794732254461],
              [12.127366667339505, -9.880571695993265],
              [12.126173671596119, -9.866177911116878],
              [12.12791113026077, -9.863442232742427],
              [12.126964874303793, -9.85856724003199],
              [12.128440352300798, -9.852017871364756],
              [12.11687902008498, -9.853108377212918],
              [12.110759046932364, -9.850415729245972],
              [12.102016322272773, -9.848708075085355],
              [12.095811307791893, -9.850438811400885],
              [12.084127075185423, -9.842432857646642],
              [12.07800304835987, -9.827680282942028],
              [12.078384852537855, -9.815360586742848],
              [12.087599065699196, -9.82288566248161],
              [12.091227583107349, -9.832730346191855],
              [12.091630783430855, -9.841430515979914],
              [12.095931589243415, -9.84435684242419],
              [12.09871144764037, -9.84188461260593],
              [12.103358637876884, -9.841757890815021],
              [12.115258323233743, -9.849172615660764],
              [12.130058054160571, -9.847133076061334],
              [12.128957118690531, -9.839382844074759],
              [12.125610051901093, -9.835268560242103],
              [12.131027607548926, -9.827035267356644],
              [12.130818683136312, -9.823501342345924],
              [12.12612093155734, -9.82065592519979],
              [12.125731672226424, -9.818475517634448],
              [12.126670205583833, -9.803557499478881],
              [12.122681847505255, -9.795870412743234],
              [12.122047929902179, -9.791344215655421],
              [12.123819941714471, -9.788633255266781],
              [12.12285160668878, -9.783854474243336],
              [12.12506149103943, -9.779460307784584],
              [12.11980076860831, -9.777660817959175],
              [12.121593067599415, -9.773981787021965],
              [12.118020891539663, -9.764668736446815],
              [12.114695183492335, -9.76342923247921],
              [12.116163742808054, -9.760019816404586],
              [12.112589139563987, -9.753143543016522],
              [12.105909717425828, -9.743138533753303],
              [12.10170533496882, -9.742124744299545],
              [12.104938840145833, -9.738568134254042],
              [12.100938962424353, -9.732434868763345],
              [12.105294905111938, -9.731200870894895]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.72551886914303, "lat": 27.9197807834445 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12103"],
        "coty_name": ["Pinellas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pinellas County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00295745"
      },
      "bbox": [
        12.057057114030007, -10.268823938777876, 12.334537540833336,
        -9.713739418521362
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.835916250313788, -4.356157718639566],
            [10.92494599100026, -4.307813209952107],
            [10.91982330639019, -4.3046976754612905],
            [10.919931975849362, -4.299517450079235],
            [10.923536776789534, -4.296792178672137],
            [10.922878831774643, -4.291822074247979],
            [10.927591139413668, -4.288697593717285],
            [10.930418285477774, -4.279218595128446],
            [11.04110631489204, -4.314400718869255],
            [11.071161764710412, -4.3240135838453915],
            [11.125820866419637, -4.299587918360478],
            [11.133533412769598, -4.303734879333315],
            [11.136584567794744, -4.30746686293931],
            [11.139732262939003, -4.308203939060073],
            [11.143621536390286, -4.311643522747044],
            [11.146678546830584, -4.3116232865233775],
            [11.1517741204627, -4.3175868704056395],
            [11.156570881836561, -4.32007120979263],
            [11.163103940907037, -4.320528804837021],
            [11.17112753535731, -4.315146457653795],
            [11.172642640323692, -4.315454494962919],
            [11.179793400326757, -4.322108604762537],
            [11.183909271668428, -4.3230161761649475],
            [11.189434201649568, -4.327538781448083],
            [11.201083322961399, -4.3285996587664775],
            [11.204055572877333, -4.333247551891871],
            [11.209516469813607, -4.337383299824954],
            [11.213825713088246, -4.342752024231502],
            [11.213925356978356, -4.3458192899152985],
            [11.200311929553115, -4.364222956434609],
            [11.20044230263415, -4.3844995484514],
            [11.196174033986411, -4.39217292524746],
            [11.187975178217021, -4.3788800866412805],
            [11.180666483073892, -4.383499446780659],
            [11.177796640330913, -4.389094322677526],
            [11.184859964511674, -4.395468594243157],
            [11.186705476193264, -4.40343362538045],
            [11.189720563520597, -4.404652512137423],
            [11.18270289183486, -4.417755637263081],
            [11.174962823695653, -4.424599612736985],
            [11.17308434328017, -4.430141641678538],
            [11.204284964797157, -4.486694957455258],
            [11.203572000785684, -4.487734337418899],
            [11.20884605561182, -4.516991104450226],
            [11.189309906874481, -4.540609013070897],
            [11.178118439367168, -4.554141311949105],
            [11.11247618315119, -4.632871477463389],
            [11.080552586494141, -4.671052634927594],
            [11.077277911394107, -4.663852387740027],
            [11.073857781741419, -4.66008440124204],
            [11.073696789946212, -4.656138450560085],
            [11.065750788670998, -4.6495151527407765],
            [11.065793701369078, -4.645656980518599],
            [11.05936943411734, -4.6448528419678],
            [11.056716348162531, -4.642109576571484],
            [11.056009142247184, -4.636444799624641],
            [11.047406462408246, -4.63473313900261],
            [11.044206171728105, -4.641810740023472],
            [11.040161749487746, -4.643998279118913],
            [11.036813525255436, -4.643746284382052],
            [11.036426860647483, -4.648423332747877],
            [11.03406640925754, -4.652384266792181],
            [11.027505375583141, -4.652505345594617],
            [11.026918356717042, -4.6482219861826355],
            [11.02981693744653, -4.642669682556384],
            [11.029185452068482, -4.639243874133879],
            [11.034819597376226, -4.63268121447126],
            [11.03090196490476, -4.629463665425529],
            [11.02356729886558, -4.628604390226637],
            [11.016363266802149, -4.631588250954503],
            [11.010514503778833, -4.636932767104152],
            [11.00844805270767, -4.6333273241569986],
            [11.009868645743277, -4.623558158001563],
            [11.00996105506573, -4.616097239377735],
            [11.002691973789211, -4.611427640759317],
            [11.000978937970963, -4.606504340593246],
            [10.993532525378242, -4.599265190849745],
            [10.990559199027015, -4.595281752922441],
            [10.987490392937714, -4.593823669662095],
            [10.988250056054003, -4.588541310852773],
            [10.991446693945107, -4.585340631386785],
            [10.990054122667196, -4.580332263856855],
            [10.981512356556765, -4.576500341641925],
            [10.974913889989223, -4.574824190065481],
            [10.971887223717056, -4.570408622241625],
            [10.970445395778578, -4.56275495388487],
            [10.968157224749767, -4.55616070705867],
            [10.96780314696909, -4.550371245762466],
            [10.969273072290301, -4.545112696605692],
            [10.961813739457899, -4.5339198414671245],
            [10.961601900573458, -4.529516871129493],
            [10.963526364596332, -4.522894512915679],
            [10.962176454226409, -4.517816585753203],
            [10.964122653611247, -4.511940620346274],
            [10.970188337603833, -4.506883772193579],
            [10.96974948769271, -4.504335319496352],
            [10.964728134863089, -4.497683803431609],
            [10.959718042030847, -4.497021288618088],
            [10.954734745788121, -4.497960442575761],
            [10.950574983980358, -4.494704529971527],
            [10.946467338072356, -4.489331377435446],
            [10.9382406505319, -4.485395279903326],
            [10.938971558453902, -4.482356644312332],
            [10.93460727955852, -4.478612729815875],
            [10.932116071319335, -4.480422274113208],
            [10.925497524532219, -4.470751793388329],
            [10.922798166842908, -4.470189144041519],
            [10.920169737377982, -4.465377476367925],
            [10.917234102347093, -4.46528388450292],
            [10.916556865002118, -4.461007342114369],
            [10.912889696871524, -4.462336459251883],
            [10.907908446338029, -4.457920962084379],
            [10.906210088444197, -4.452122438655279],
            [10.89642015918636, -4.450509415913304],
            [10.89755849514395, -4.447037752432922],
            [10.895579053667053, -4.438842122854095],
            [10.893387052882828, -4.43365917912573],
            [10.888744995413786, -4.428381673999564],
            [10.885850007729887, -4.428628127408936],
            [10.883352817674352, -4.42115854340043],
            [10.879581659387759, -4.416344811792565],
            [10.87943463533762, -4.4094419066073],
            [10.870782104547198, -4.394468533675463],
            [10.867603677641, -4.394593200884737],
            [10.866116160359738, -4.391457150337343],
            [10.862744727431433, -4.390812039295154],
            [10.858316978903803, -4.3853227843128595],
            [10.858486902856946, -4.3814684295182085],
            [10.854957148051474, -4.379368956921263],
            [10.852730075046313, -4.373424287402845],
            [10.847084847137827, -4.369545211175666],
            [10.842536515705449, -4.36273367302663],
            [10.84015310745567, -4.357368622331891],
            [10.835916250313788, -4.356157718639566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.1666438637026, "lat": 33.57882409575978 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13133"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00348672"
      },
      "bbox": [
        10.835916250313788, -4.671052634927594, 11.213925356978356,
        -4.279218595128446
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.189555898149212, -4.35174632000757],
            [9.332024666912167, -4.3382186234276725],
            [9.331229622044905, -4.331140421738168],
            [9.374008182706085, -4.32688707767093],
            [9.46440401002822, -4.317722741183918],
            [9.475573583515855, -4.316595883730612],
            [9.485267770268708, -4.408896307001264],
            [9.476125109202593, -4.409567612401859],
            [9.481974518701659, -4.466314617680303],
            [9.485913822426026, -4.507197930586774],
            [9.473032098393299, -4.508343201798497],
            [9.473587413888803, -4.512596349746156],
            [9.436117674655598, -4.536403842744842],
            [9.423934889502208, -4.537779680291774],
            [9.423177202031198, -4.5294223258485165],
            [9.415283476134412, -4.530084339214146],
            [9.339459728585169, -4.5691475643662685],
            [9.323233830478511, -4.57764528358778],
            [9.3159827107164, -4.582003897508476],
            [9.297023586707729, -4.591953104574711],
            [9.257109474461922, -4.595405360283838],
            [9.230423459722989, -4.500404009863391],
            [9.202094912399442, -4.396508194522014],
            [9.189555898149212, -4.35174632000757]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.21100925043044,
          "lat": 33.794219753963496
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13143"],
        "coty_name": ["Haralson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haralson County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00350637"
      },
      "bbox": [
        9.189555898149212, -4.595405360283838, 9.485913822426026,
        -4.316595883730612
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.971781166699815, -6.504849837305285],
            [11.98476077561123, -6.50283291256469],
            [11.983135300295563, -6.489951551842866],
            [12.030833313437348, -6.483272965007977],
            [12.029039635702766, -6.4718147525004746],
            [12.041188899615628, -6.469762018342149],
            [12.039422236907194, -6.4548603263007625],
            [12.051954445614816, -6.4530124674291445],
            [12.050471319838593, -6.44234193104432],
            [12.062346768029949, -6.44077625227681],
            [12.059109990573758, -6.415654079804111],
            [12.085041927015324, -6.412445786018704],
            [12.0832196139512, -6.399546159423314],
            [12.094818472565972, -6.398145707522533],
            [12.092986170292857, -6.386326747253154],
            [12.1073339221421, -6.384017102923313],
            [12.10510467696752, -6.371302186591051],
            [12.115728495681717, -6.369630949848507],
            [12.123802618348023, -6.380550043740893],
            [12.13211356116352, -6.386301287383562],
            [12.143275632837144, -6.391373197958226],
            [12.15990067796119, -6.404994111436876],
            [12.176393664072643, -6.416056665350269],
            [12.184479993498899, -6.419713969917573],
            [12.19395088108694, -6.420211149944352],
            [12.203187248173819, -6.416837218933947],
            [12.209076363196505, -6.410256559958982],
            [12.218982989358986, -6.405173124834118],
            [12.231069221457641, -6.402699698135093],
            [12.237447182368413, -6.403006076991585],
            [12.254448317529816, -6.409093930997359],
            [12.258502951505568, -6.412564167527265],
            [12.262242633343, -6.413132740728871],
            [12.267425253889204, -6.417842760771059],
            [12.270954920410796, -6.422812350046627],
            [12.274848449470797, -6.4389637645730975],
            [12.27395465307565, -6.441942637738784],
            [12.275623244595112, -6.449579781037702],
            [12.274955194317483, -6.453557885849031],
            [12.27683091500957, -6.462061648402724],
            [12.275956198325389, -6.465194733414838],
            [12.27748832237852, -6.470561538654399],
            [12.282641678179345, -6.473136927293364],
            [12.28383072890719, -6.480585466514233],
            [12.288650762204838, -6.484126909719662],
            [12.29012197754664, -6.4910537669479575],
            [12.293453398876885, -6.4953610553339605],
            [12.294559362544474, -6.501795871958635],
            [12.296786663364701, -6.50481751502347],
            [12.296491248606264, -6.5127897927906195],
            [12.298784268498459, -6.5160314811392945],
            [12.30272658330003, -6.517693853948286],
            [12.306598658529394, -6.528049926311599],
            [12.31386179582586, -6.534158731539553],
            [12.316368084930673, -6.5400518013133215],
            [12.325294000823964, -6.548446930328121],
            [12.327586582122956, -6.554129029869126],
            [12.330016080671031, -6.5543961281306835],
            [12.336556895979633, -6.559628428774741],
            [12.34550608816878, -6.5606807912546055],
            [12.344065983961967, -6.580277903768122],
            [12.337507585249403, -6.583951693105443],
            [12.33718034737772, -6.589152113561708],
            [12.334770275329918, -6.592500431243849],
            [12.33083949498624, -6.593799880080784],
            [12.324459204132282, -6.593031783689142],
            [12.323652343705085, -6.595241726422808],
            [12.318458193648418, -6.598382210101856],
            [12.316742997802974, -6.59549215798863],
            [12.31109723556518, -6.600867266343863],
            [12.307389691072245, -6.59841903581833],
            [12.303845409457514, -6.599847723886373],
            [12.30308674106215, -6.60277884673522],
            [12.293926415231434, -6.602222116757327],
            [12.287641419013184, -6.603330672802192],
            [12.283308716471064, -6.601906300510563],
            [12.279142456631702, -6.603020934015343],
            [12.274768062559449, -6.607801571469664],
            [12.27324957785248, -6.604427601516267],
            [12.268475933317147, -6.604344821989382],
            [12.262251326410421, -6.606086418762481],
            [12.25720833182877, -6.610120363914868],
            [12.253195305063645, -6.610209540918292],
            [12.247649499686478, -6.6128522012831725],
            [12.246816240686796, -6.6166305997686115],
            [12.243235979313933, -6.618841464402298],
            [12.24271617606392, -6.6234948211282365],
            [12.236789257194049, -6.628096373259629],
            [12.22847258523849, -6.627353512743657],
            [12.224407219363451, -6.634361313767125],
            [12.228290576190266, -6.643436519444392],
            [12.229579669240872, -6.648463069193092],
            [12.225489360363024, -6.652666174092585],
            [12.227174107164377, -6.658506285332281],
            [12.219740070550223, -6.668591701900602],
            [12.217182799141295, -6.66880811034171],
            [12.211518627895432, -6.673973518288385],
            [12.205483383250435, -6.671553000711593],
            [12.204197276450394, -6.676913617905109],
            [12.199727668813583, -6.679362751820852],
            [12.199724572859894, -6.684688579921532],
            [12.195042518721559, -6.684892858166091],
            [12.191249208369756, -6.689574772035769],
            [12.189262050295753, -6.684517148993608],
            [12.176098847612227, -6.679827168630892],
            [12.170061429796446, -6.67912182513199],
            [12.168386391806836, -6.681138498373925],
            [12.16191143449875, -6.675626117773713],
            [12.15699435263363, -6.676503956332457],
            [12.149773049375959, -6.680711596278043],
            [12.14420336934215, -6.681222811903198],
            [12.135325571629775, -6.679465598552849],
            [12.133784334593033, -6.6816826732033805],
            [12.127990326614755, -6.68061476993041],
            [12.127222474761364, -6.683714959710577],
            [12.122674019665105, -6.68375378649322],
            [12.12147972877409, -6.680573544984717],
            [12.11519509001996, -6.677409270182396],
            [12.11122980418278, -6.678911279078787],
            [12.108827540923938, -6.680231856817197],
            [12.104215070801532, -6.6779333289515],
            [12.100548901077206, -6.679868011576994],
            [12.08562254596538, -6.681187071394652],
            [12.084979007073517, -6.675947163402036],
            [12.081650923727187, -6.675337697206022],
            [12.080798768851565, -6.670802478393013],
            [12.07039928645636, -6.667730759427006],
            [12.067734921607896, -6.664318135162206],
            [12.061142216116973, -6.661355375404044],
            [12.06001668604311, -6.658268136577434],
            [12.054100644162812, -6.655755450899516],
            [12.050952369923525, -6.656182526638404],
            [12.048074894303435, -6.651078639697794],
            [12.039277022162075, -6.643904657056261],
            [12.041412771631942, -6.640579598808672],
            [12.035257655758105, -6.640237165848258],
            [12.032787897884129, -6.63747222536806],
            [12.031748481058711, -6.6331221817505055],
            [12.032816274868988, -6.62886763258662],
            [12.025868235742832, -6.625003285907675],
            [12.018057331394012, -6.625137816941859],
            [12.014247150574022, -6.6196746086265845],
            [12.012120165882111, -6.606244341206424],
            [12.009763576817095, -6.606593985398597],
            [12.002649386811107, -6.553041091575867],
            [11.991538592861815, -6.554550303749933],
            [11.989566923106045, -6.540940208175907],
            [11.977469465940898, -6.542588950941708],
            [11.975754724299158, -6.530737897996055],
            [11.987901345173123, -6.5289964388298065],
            [11.985896237197087, -6.515208426633953],
            [11.97337580335983, -6.516845182752491],
            [11.971781166699815, -6.504849837305285]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.212804136349, "lat": 31.358806008756556 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13229"],
        "coty_name": ["Pierce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pierce County"],
        "coty_fp_code": "229",
        "coty_gnis_code": "00349086"
      },
      "bbox": [
        11.971781166699815, -6.689574772035769, 12.34550608816878,
        -6.369630949848507
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.787408970288315, -6.424667207934412],
            [9.828130279909209, -6.420952564486505],
            [9.821324254051415, -6.354671156886288],
            [9.81366178112391, -6.274239903151921],
            [9.894895815609292, -6.266289419765866],
            [9.894079126159333, -6.257409905786467],
            [9.902055004846895, -6.256786507810891],
            [9.903075678404731, -6.26539264452114],
            [9.951085867308121, -6.26107915012878],
            [9.999968047278534, -6.256482120601507],
            [9.998775964746555, -6.247904289111746],
            [10.00713089793972, -6.247215235364721],
            [10.008068848009104, -6.255300267020054],
            [10.024880423780548, -6.253522181581404],
            [10.071905902092865, -6.248039878837931],
            [10.076497157147445, -6.291319390111865],
            [10.086935316845256, -6.395250600871821],
            [10.120647426036722, -6.392610321055558],
            [10.119181552208964, -6.398179667662137],
            [10.115827360317212, -6.403186382457602],
            [10.12108293851046, -6.414370533050887],
            [10.123882475401688, -6.417445405204226],
            [10.123474684272457, -6.4204863614522365],
            [10.127101730250255, -6.4298887748209275],
            [10.130132015104197, -6.432246956309864],
            [10.134219155448458, -6.4419020852263165],
            [10.141360713261838, -6.448615824364419],
            [10.141974785634009, -6.456539755175049],
            [10.144991518688416, -6.463151035980645],
            [10.149279774664649, -6.467553382703421],
            [10.149436657235507, -6.471247708459318],
            [10.154601813041506, -6.477774637254708],
            [10.15532464109494, -6.483049134871102],
            [10.152857759112385, -6.485667086400246],
            [10.154343954423231, -6.491966210415222],
            [10.153013515928313, -6.496065423280649],
            [10.15676332654843, -6.509995613996102],
            [10.158423243032605, -6.513228977463528],
            [10.156014343578377, -6.519734110816498],
            [10.154013976588285, -6.536600248698859],
            [10.15239278769847, -6.538976022563514],
            [10.14389329281491, -6.540031244568443],
            [10.142863371198318, -6.532836111668836],
            [10.133003191987676, -6.5338417701416205],
            [10.133895774451954, -6.541298596121459],
            [10.126164290684272, -6.54222854299551],
            [10.12426328168983, -6.52622317103045],
            [10.116988142516858, -6.5269600137203305],
            [10.119020348991327, -6.543023994643245],
            [10.109812274393228, -6.543927371614349],
            [10.108077489333892, -6.527800649634926],
            [10.099951974194429, -6.5285875372464846],
            [10.100968342078334, -6.538055571186955],
            [10.087818903615682, -6.539417004645987],
            [10.086942325571757, -6.530117207546936],
            [10.075141890958816, -6.53130849400605],
            [10.07446541859394, -6.525855389437876],
            [10.063458122662619, -6.527045843366142],
            [10.06390594711386, -6.532747263189168],
            [10.058248569146771, -6.533472753270016],
            [10.06021334912987, -6.551235665773029],
            [10.039646654443112, -6.553637038028116],
            [9.957698908161458, -6.563724203519309],
            [9.924392806068045, -6.567511511963917],
            [9.886181127755442, -6.572730536631205],
            [9.819658114856809, -6.5808474229741565],
            [9.81522568232051, -6.544316144818688],
            [9.824637680400373, -6.543350354112401],
            [9.82296293001755, -6.5265844903777985],
            [9.814849463084247, -6.5275472237660885],
            [9.81404630518499, -6.520038962852129],
            [9.806264443871694, -6.520884054489184],
            [9.80270215748379, -6.487655491591117],
            [9.794339777863454, -6.488648593735886],
            [9.787408970288315, -6.424667207934412]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.7542085423166, "lat": 31.762656939564668 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13243"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "243",
        "coty_gnis_code": "00352242"
      },
      "bbox": [
        9.787408970288315, -6.5808474229741565, 10.158423243032605,
        -6.247215235364721
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.795396946935298, -4.57131300733218],
            [11.827163987124603, -4.534539794388066],
            [11.84756251210115, -4.509885675935326],
            [11.877457246498148, -4.474450869925879],
            [11.913888199023736, -4.432890502741164],
            [11.935742311112275, -4.407474716695421],
            [11.955118273356762, -4.384189145731725],
            [11.960710517786776, -4.378657510865784],
            [11.985633278139067, -4.350424178968101],
            [11.990182786012396, -4.354015672690083],
            [11.99059578987306, -4.3567958601015455],
            [11.993971382968006, -4.359240932156336],
            [12.00043370401079, -4.361258120581007],
            [12.002674949581795, -4.3626239888811655],
            [12.005688944835947, -4.369385331464184],
            [12.011320936970328, -4.371800572537769],
            [12.021340549665263, -4.386254146941859],
            [12.023158701885437, -4.389716256653871],
            [12.023668085257011, -4.396262840560079],
            [12.028902997622511, -4.403302276241221],
            [12.033615884279612, -4.405141722845888],
            [12.045261689304093, -4.406866644473319],
            [12.06345920897005, -4.413198829277718],
            [12.074042995459616, -4.4150774609224905],
            [12.081236405065376, -4.419489156083985],
            [12.0889473521552, -4.4323890838538205],
            [12.093569619827708, -4.437385282766089],
            [12.095719498792501, -4.4423077755255544],
            [12.09342041697214, -4.4484770291504825],
            [12.090589964431354, -4.45052824406301],
            [12.082614927839046, -4.453695518019621],
            [12.082513421196445, -4.4583062499969754],
            [12.092317539931779, -4.46404105047431],
            [12.101119490520368, -4.4651506950248185],
            [12.102412611545834, -4.467426502216889],
            [12.100838663612251, -4.472241211269422],
            [12.09655691337889, -4.4737817582957895],
            [12.091063107338673, -4.471290483012991],
            [12.086876870524824, -4.474657307177189],
            [12.08266343819353, -4.47625792801882],
            [12.075456987200313, -4.475057354812157],
            [12.075164010252, -4.480540530671083],
            [12.083820033556805, -4.485781053013814],
            [12.08983350944282, -4.502308879103969],
            [12.09565686729586, -4.507466925359693],
            [12.095364179988376, -4.5105548673904545],
            [12.091788454858516, -4.514105531336351],
            [12.088389195543877, -4.513824333656921],
            [12.083752779961431, -4.5108600530650005],
            [12.078537900452455, -4.513562667420965],
            [12.080829525465344, -4.519918731756989],
            [12.089638336348814, -4.525969063988524],
            [12.090499087228629, -4.528914799133057],
            [12.08726879390644, -4.535502395752359],
            [12.087766366730875, -4.538269662156064],
            [12.093719015162662, -4.538805727898887],
            [12.101130942705128, -4.53632673300806],
            [12.105240624679295, -4.540342577442464],
            [12.109398984369761, -4.533079237309426],
            [12.112851379305305, -4.5331924154159475],
            [12.112444687103054, -4.537236897824631],
            [12.109149747894103, -4.53823777277825],
            [12.106627389689384, -4.5471337651027675],
            [12.116346648244662, -4.552079877510481],
            [12.114252738284598, -4.560509183467344],
            [12.11881542135861, -4.5573154820592086],
            [12.118234017884891, -4.5529150257170325],
            [12.120417319731898, -4.548311790864855],
            [12.120122329086886, -4.542654928449974],
            [12.125033861727323, -4.547335819994482],
            [12.123880826946852, -4.552708126891401],
            [12.127507764355125, -4.555998262523987],
            [12.132823551766558, -4.555763985354731],
            [12.130535588416311, -4.560518084621898],
            [12.13262453747658, -4.562134641379296],
            [12.136588209845234, -4.55890535885442],
            [12.140132975071536, -4.561826702303574],
            [12.138302276992313, -4.566970397701327],
            [12.14359965152682, -4.573181632250777],
            [12.145796082164551, -4.567678888920048],
            [12.150262392678679, -4.560594023975903],
            [12.154088544705202, -4.56197604924132],
            [12.155602811051235, -4.570375145691518],
            [12.157846236906275, -4.570913727144027],
            [12.163578416226413, -4.562097513356073],
            [12.168992562504197, -4.564518058495068],
            [12.17072434043394, -4.56710041333764],
            [12.168485393415017, -4.572305005223552],
            [12.160006108063355, -4.573978207839936],
            [12.158773521195817, -4.584207920936111],
            [12.161415888997132, -4.587263139483759],
            [12.169275742278252, -4.588422330632897],
            [12.173587081198326, -4.586985217204882],
            [12.176093427151173, -4.592171941225329],
            [12.184262151406642, -4.598457479357108],
            [12.185032274139802, -4.606358184987696],
            [12.191170688729638, -4.606961316456043],
            [12.187141899259537, -4.611285210215897],
            [12.183149668216782, -4.607343062502755],
            [12.178144391025851, -4.604267589845617],
            [12.174943804713061, -4.606852653630629],
            [12.177333426458034, -4.61268464019442],
            [12.181455778289555, -4.61328563315454],
            [12.183076496391609, -4.615681230078057],
            [12.179200471158849, -4.618391732038391],
            [12.173266697067213, -4.620430499914942],
            [12.174513053209433, -4.6240090494513835],
            [12.169404766343177, -4.626762401196325],
            [12.16516639695429, -4.625805708930468],
            [12.15794304673276, -4.6215638516433515],
            [12.1517119152339, -4.6162328379287],
            [12.1434133675132, -4.614384281508452],
            [12.142668509390829, -4.6158345705998],
            [12.131625567075533, -4.61665030315157],
            [12.128128636960232, -4.619347268118107],
            [12.121134347833967, -4.620363035387503],
            [12.11341466667319, -4.623759523586699],
            [12.111640736546946, -4.626245014291979],
            [12.105669136227164, -4.628929228531982],
            [12.102633652032722, -4.631888963267551],
            [12.101696346799667, -4.635636562837865],
            [12.093142867354551, -4.64538491732517],
            [12.087097356013548, -4.64893644316809],
            [12.086070115996705, -4.651261562102179],
            [12.081000331735606, -4.6550846645045025],
            [12.07608863947286, -4.656771074458345],
            [12.073057496575561, -4.65990905687249],
            [12.066052245963078, -4.659342682073561],
            [12.063860028092629, -4.660535389081713],
            [12.05778820675641, -4.658252923635611],
            [12.045267715404169, -4.657210215003042],
            [12.04038763049353, -4.659189853708078],
            [12.036839149603335, -4.658679327635778],
            [12.033163204763802, -4.661081112915469],
            [12.02519851593033, -4.660460085986146],
            [12.017295106587353, -4.65882313979967],
            [12.004095002832667, -4.654499939754657],
            [11.994838041363789, -4.659329915344283],
            [11.991899868239244, -4.663094679330347],
            [11.98247588028505, -4.670144045555478],
            [11.975351702910487, -4.670849756834398],
            [11.969848929740937, -4.669226778710655],
            [11.963927180977002, -4.661682638875716],
            [11.960018091886088, -4.660472226274137],
            [11.954378159908504, -4.656539963009511],
            [11.949383290623558, -4.655337134134562],
            [11.948563512952514, -4.652420978957548],
            [11.943782780554486, -4.644974889662087],
            [11.943100379186331, -4.638980829159541],
            [11.941213897842063, -4.637750132619093],
            [11.93862795421785, -4.630327905106132],
            [11.9310748232418, -4.6260870486885315],
            [11.922640096423095, -4.6260615908044835],
            [11.914185074499631, -4.620208828920309],
            [11.909946866607784, -4.614119478342379],
            [11.90230669953522, -4.614451574394013],
            [11.874104850891522, -4.629989334030223],
            [11.829880699091891, -4.654777757288249],
            [11.820615850179355, -4.654319070854306],
            [11.817290270516898, -4.6519051683666355],
            [11.805233414689221, -4.649044723945925],
            [11.802834016652634, -4.64320711258072],
            [11.799150080781663, -4.638030739327799],
            [11.789450409217002, -4.63046826490785],
            [11.783196300597545, -4.628381001914925],
            [11.771362299678357, -4.622076902218107],
            [11.762198963446899, -4.619433589188992],
            [11.756223353587584, -4.618950771429163],
            [11.752787630412282, -4.620376724776],
            [11.75505801482762, -4.61753198478432],
            [11.795396946935298, -4.57131300733218]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.07360220371147,
          "lat": 33.359656698411406
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13245"],
        "coty_name": ["Richmond"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richmond County"],
        "coty_fp_code": "245",
        "coty_gnis_code": "00358024"
      },
      "bbox": [
        11.752787630412282, -4.670849756834398, 12.191170688729638,
        -4.350424178968101
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.211682642061328, -5.750316195865531],
              [10.203692612827082, -5.7513958273512324],
              [10.204782648002606, -5.759525243620454],
              [10.212939630545122, -5.758427195507258],
              [10.211682642061328, -5.750316195865531]
            ]
          ],
          [
            [
              [10.185419034495895, -5.737000618518036],
              [10.193894533984192, -5.735762480143313],
              [10.192451763078601, -5.7220287597123844],
              [10.208616365491565, -5.720051112792658],
              [10.211682642061328, -5.750316195865531],
              [10.220005110743799, -5.749195009686414],
              [10.221649290300062, -5.76179414275134],
              [10.229665077460659, -5.760912289630511],
              [10.227924682101758, -5.748223143763128],
              [10.244914242458188, -5.746037903953947],
              [10.247626965039084, -5.771306452024257],
              [10.305368348922038, -5.764591989122618],
              [10.313689821828401, -5.840058663884996],
              [10.344450557860993, -5.837359606888365],
              [10.351613871183481, -5.900870584841712],
              [10.383933404503365, -5.898316941702495],
              [10.391212524053328, -5.969157381116387],
              [10.335570181164611, -5.97450340301908],
              [10.326734342769276, -5.976473252546901],
              [10.32604697306015, -5.969606798805345],
              [10.31834532190096, -5.970458681297053],
              [10.318756643098602, -5.977356144362566],
              [10.310582015164647, -5.978306822515222],
              [10.310032874845188, -5.973900265891787],
              [10.184080498360114, -5.986810615149647],
              [10.183273920841467, -5.978853236939266],
              [10.191202687221544, -5.977786404059317],
              [10.189450534499397, -5.9605564005987075],
              [10.180998355807647, -5.959091587811317],
              [10.176678533356604, -5.9213452037093],
              [10.192615224352448, -5.919701378077791],
              [10.186571916909806, -5.867450203491288],
              [10.185834583796924, -5.862503648615977],
              [10.183176404963385, -5.862802475078616],
              [10.182173686757787, -5.854812234616859],
              [10.201719819609554, -5.852723780162605],
              [10.19966073147963, -5.836649409165027],
              [10.185419034495895, -5.737000618518036]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.31476398809464,
          "lat": 32.261663401088775
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13249"],
        "coty_name": ["Schley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schley County"],
        "coty_fp_code": "249",
        "coty_gnis_code": "00344129"
      },
      "bbox": [
        10.176678533356604, -5.986810615149647, 10.391212524053328,
        -5.720051112792658
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.801073750386006, -6.582640139606126],
            [11.786906880371134, -6.478474253523948],
            [11.812711912439308, -6.474869896492664],
            [11.894954647143656, -6.463990288768367],
            [11.899254725941583, -6.46322295715022],
            [11.903820919759937, -6.488569021854234],
            [11.914068808093527, -6.486927172877233],
            [11.917684818844553, -6.512147011389763],
            [11.954637582954536, -6.507513525582758],
            [11.971781166699815, -6.504849837305285],
            [11.97337580335983, -6.516845182752491],
            [11.985896237197087, -6.515208426633953],
            [11.987901345173123, -6.5289964388298065],
            [11.975754724299158, -6.530737897996055],
            [11.977469465940898, -6.542588950941708],
            [11.989566923106045, -6.540940208175907],
            [11.991538592861815, -6.554550303749933],
            [12.002649386811107, -6.553041091575867],
            [12.009763576817095, -6.606593985398597],
            [12.012120165882111, -6.606244341206424],
            [12.014247150574022, -6.6196746086265845],
            [12.018057331394012, -6.625137816941859],
            [12.025868235742832, -6.625003285907675],
            [12.032816274868988, -6.62886763258662],
            [12.031748481058711, -6.6331221817505055],
            [12.032787897884129, -6.63747222536806],
            [12.035257655758105, -6.640237165848258],
            [12.041412771631942, -6.640579598808672],
            [12.039277022162075, -6.643904657056261],
            [12.048074894303435, -6.651078639697794],
            [12.050952369923525, -6.656182526638404],
            [12.054100644162812, -6.655755450899516],
            [12.06001668604311, -6.658268136577434],
            [12.061142216116973, -6.661355375404044],
            [12.067734921607896, -6.664318135162206],
            [12.07039928645636, -6.667730759427006],
            [12.080798768851565, -6.670802478393013],
            [12.081650923727187, -6.675337697206022],
            [12.084979007073517, -6.675947163402036],
            [12.08562254596538, -6.681187071394652],
            [12.100548901077206, -6.679868011576994],
            [12.104215070801532, -6.6779333289515],
            [12.108827540923938, -6.680231856817197],
            [12.11122980418278, -6.678911279078787],
            [12.116141307260174, -6.710683578495448],
            [12.14492361477489, -6.716057094952835],
            [12.14663854112956, -6.7166347476101915],
            [12.162694937214848, -6.7266804260295014],
            [12.16882745057279, -6.7270264017837205],
            [12.182938337522145, -6.722423950852498],
            [12.184899322832889, -6.7377776153518525],
            [12.188119241800306, -6.756296734989417],
            [12.195836312144216, -6.807316661388109],
            [12.238858373766666, -6.8375153986070005],
            [12.271305989579881, -6.870882153969539],
            [12.26916557444242, -6.871200460055738],
            [12.180940141701958, -6.882610009212865],
            [12.092713184630714, -6.894005807620567],
            [12.030842044397652, -6.902707323626383],
            [12.057932167021606, -7.118430418750038],
            [12.160949961359776, -7.1057507713227706],
            [12.26396581540817, -7.093051647030653],
            [12.28890873640947, -7.096076909571628],
            [12.277020609157244, -7.206292611505915],
            [12.2651174526958, -7.316459567042961],
            [12.227884040427663, -7.318788968278215],
            [12.089703534467304, -7.32839447660762],
            [12.085327545518176, -7.297494639535852],
            [12.075110767002302, -7.299237272186643],
            [12.069363171140894, -7.26131022834428],
            [12.06924992556655, -7.248617085620923],
            [12.065726009257977, -7.222751570552665],
            [12.058615783766893, -7.210495499745985],
            [12.05671020058219, -7.19766237043203],
            [12.069535773353666, -7.195761478806787],
            [12.067625478561292, -7.183411648133064],
            [12.054805538770493, -7.185289663394532],
            [12.041322227695266, -7.095831309123829],
            [11.990847422447544, -7.1035301702135465],
            [11.991773514076293, -7.090320220149519],
            [11.974614405085642, -6.961439446766463],
            [11.949596506858768, -6.965023466871816],
            [11.948143025082283, -6.961204660487206],
            [11.94328146619449, -6.960113419757827],
            [11.936480051554435, -6.951614942780459],
            [11.932073120433072, -6.944781306378672],
            [11.92430745798857, -6.942075497035954],
            [11.920032589220067, -6.936428361760436],
            [11.918750635685367, -6.931904631228465],
            [11.908939920297389, -6.929785339938057],
            [11.899720526976784, -6.925095139252173],
            [11.895061580135508, -6.925912766255081],
            [11.890756412611383, -6.924535896965485],
            [11.884899872690047, -6.919227748335026],
            [11.880893783560564, -6.919062425158378],
            [11.835636480419502, -6.842312969136271],
            [11.790387357303656, -6.765535430728274],
            [11.768654217749695, -6.728702995236649],
            [11.760057338477015, -6.730053891950844],
            [11.75640539982065, -6.701476217198234],
            [11.75393036089731, -6.675666995610856],
            [11.76807054654968, -6.666457575296113],
            [11.775873427708795, -6.666235763474891],
            [11.779718198610087, -6.662296003230095],
            [11.784719131645028, -6.663785031722329],
            [11.790547859075245, -6.6632146062711035],
            [11.794402433145306, -6.664205602244954],
            [11.799250039446294, -6.668992163280315],
            [11.80555760956171, -6.668814520108293],
            [11.805138485650048, -6.671861346599722],
            [11.811252341829409, -6.672416224997455],
            [11.813081961046334, -6.670769640700545],
            [11.801073750386006, -6.582640139606126]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.42373814447639, "lat": 31.05377278653662 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13299"],
        "coty_name": ["Ware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ware County"],
        "coty_fp_code": "299",
        "coty_gnis_code": "00357722"
      },
      "bbox": [
        11.75393036089731, -7.32839447660762, 12.28890873640947,
        -6.46322295715022
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.287933485868855, -3.4642911047801386],
            [9.289428071563286, -3.4477690910750782],
            [9.290317528015544, -3.4291262566500587],
            [9.293016662187712, -3.4162531866388766],
            [9.29249924112017, -3.4110437511619103],
            [9.299917669905962, -3.410699502122279],
            [9.300653572517852, -3.417809005889323],
            [9.314624646911216, -3.416001992007695],
            [9.313909706206244, -3.409092701624512],
            [9.349218514091271, -3.4047224906790805],
            [9.344112758192079, -3.360624396033274],
            [9.367469486811267, -3.3577683541335923],
            [9.366606387112187, -3.3504051633624545],
            [9.37422958512811, -3.349486224579066],
            [9.370709786203369, -3.3198516908000326],
            [9.378398399626134, -3.3189507331728194],
            [9.377200899426287, -3.308182715782607],
            [9.37899988047373, -3.3079407174946844],
            [9.38181913447983, -3.3010255593839277],
            [9.381890727025077, -3.291794577925697],
            [9.38673061078771, -3.2780244546412574],
            [9.386457973605012, -3.273280839002405],
            [9.383333279264901, -3.2457503787460014],
            [9.397638018507685, -3.2437639022440488],
            [9.395739873118334, -3.228888070669579],
            [9.398066487334532, -3.2285953876316356],
            [9.428429791624438, -3.22480692539148],
            [9.49136838049157, -3.2175614229344527],
            [9.515154316595007, -3.214545688280072],
            [9.532402233762628, -3.2129131831321103],
            [9.530674714899646, -3.2143716305820735],
            [9.53018577821048, -3.2249978704436497],
            [9.531629729667735, -3.228686497531342],
            [9.52943057978042, -3.2356735404270576],
            [9.525721078741304, -3.2382759435336452],
            [9.527246394150303, -3.243019565890592],
            [9.524779019184859, -3.244995720386241],
            [9.52137365021683, -3.2541400176771007],
            [9.517744163263435, -3.2600396101157947],
            [9.51767138562047, -3.2672556678412676],
            [9.515824085350557, -3.270325206737861],
            [9.515885155321968, -3.2774442227636906],
            [9.51460999680314, -3.285457513763547],
            [9.52016116957915, -3.2901079591762],
            [9.520937631177517, -3.295187869970087],
            [9.525284936405875, -3.2958191720603423],
            [9.53156185641938, -3.300064989525798],
            [9.529578903391414, -3.3034466479855356],
            [9.524697873215095, -3.3059451240676565],
            [9.530216156890669, -3.316221120821388],
            [9.539020271153234, -3.326729464239768],
            [9.539717065071354, -3.33408916194548],
            [9.535156331490315, -3.340197547433508],
            [9.528309342482043, -3.3435175855326458],
            [9.52363393744769, -3.340291263560278],
            [9.521569829311193, -3.342244425888232],
            [9.526793478795843, -3.348369307918693],
            [9.52141242017914, -3.350247772779363],
            [9.518837872247174, -3.354195967212625],
            [9.51873951634622, -3.3576864333201235],
            [9.515223437626535, -3.362576375585598],
            [9.519767511820595, -3.372417391225143],
            [9.518113137841032, -3.380621645297491],
            [9.516386694750452, -3.3847463334665218],
            [9.510540733945911, -3.391381288479498],
            [9.51543061852041, -3.398897889757304],
            [9.523472520399146, -3.3993659785447328],
            [9.528309908388291, -3.398122590907159],
            [9.5321962418979, -3.402214949826467],
            [9.531810979782918, -3.4069825858740286],
            [9.518473096810691, -3.411862357369745],
            [9.514232323834912, -3.417963671999427],
            [9.513549998794245, -3.4215729298887196],
            [9.509645370768132, -3.42141237161255],
            [9.505572499820259, -3.417157533904469],
            [9.504224788973792, -3.4193681070478],
            [9.506064213172133, -3.4241568571021594],
            [9.501849097396391, -3.4280386738239876],
            [9.505041241805237, -3.434654043089158],
            [9.512937327898818, -3.4391175979608923],
            [9.512749537786004, -3.446091047247919],
            [9.515068209241534, -3.450512023724028],
            [9.518848308346062, -3.448352075787592],
            [9.521604610148978, -3.449663829790971],
            [9.525373331813022, -3.4558335591468183],
            [9.522758559067675, -3.4594093865085416],
            [9.52496051155936, -3.4640231485307003],
            [9.524084255613129, -3.4683430761754557],
            [9.519158969553072, -3.4720392106555757],
            [9.513011824119179, -3.4683305622093616],
            [9.512043518616684, -3.472300272598101],
            [9.522014944935755, -3.4801666045115223],
            [9.526988908462005, -3.480801063413275],
            [9.525276365235463, -3.489702398987256],
            [9.521494979721242, -3.498281096000433],
            [9.516267574119961, -3.4957688118740444],
            [9.505674791343834, -3.4926300962933836],
            [9.503947517348276, -3.4984729182257803],
            [9.500666648195596, -3.5031641629771593],
            [9.472694975471473, -3.495057033017931],
            [9.46547098257734, -3.49913723838262],
            [9.465867754204387, -3.5053600431594494],
            [9.47310256174686, -3.510949359500383],
            [9.481499444353593, -3.51351031148393],
            [9.488597142015347, -3.5182712884798644],
            [9.492311671533352, -3.524288026229074],
            [9.500527971492847, -3.5285188337654274],
            [9.506092038857805, -3.5294434239156334],
            [9.507083091818101, -3.540092129126351],
            [9.50161118362037, -3.5440365066635446],
            [9.496571139105953, -3.5434757240700754],
            [9.493443137104334, -3.53702082310004],
            [9.487664301870119, -3.5285272135489287],
            [9.480366304080164, -3.5296998134040387],
            [9.472735440500132, -3.5358297437079225],
            [9.46826842266351, -3.535909526886073],
            [9.460404831494996, -3.533111610798894],
            [9.46086160246479, -3.5365923644904407],
            [9.467343983584374, -3.544050024347673],
            [9.474968898812334, -3.5444779864265303],
            [9.476140647298118, -3.545841661429908],
            [9.479877852441502, -3.5596595042370174],
            [9.484053946017381, -3.567015402228362],
            [9.490506033001687, -3.5708597671162727],
            [9.490806340006367, -3.5760768268501355],
            [9.489501604891288, -3.5810053436800504],
            [9.481944719997882, -3.5843504405698803],
            [9.48014071066303, -3.5861628962123167],
            [9.482769143869046, -3.591092614349719],
            [9.482647871359, -3.595230086681678],
            [9.476561584095432, -3.5963754159028256],
            [9.381862435346344, -3.6071197785877374],
            [9.381110856805561, -3.6006235353842584],
            [9.369486076491537, -3.503196936853808],
            [9.27422088833277, -3.513888919035005],
            [9.274405388088605, -3.506218753833766],
            [9.276456936688236, -3.501932293203127],
            [9.278037119245125, -3.4942553169349124],
            [9.282825976090898, -3.4795249427904262],
            [9.284264574483288, -3.473484493800819],
            [9.287933485868855, -3.4642911047801386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.96720931657684,
          "lat": 34.805577159435934
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13313"],
        "coty_name": ["Whitfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Whitfield County"],
        "coty_fp_code": "313",
        "coty_gnis_code": "00353513"
      },
      "bbox": [
        9.27422088833277, -3.6071197785877374, 9.539717065071354,
        -3.2129131831321103
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.634719805382167, -6.251333977510833],
            [10.636624685072436, -6.254120472698285],
            [10.644760145106153, -6.252243530333353],
            [10.647094475959747, -6.249319666268063],
            [10.657902492445137, -6.249746547071492],
            [10.665988721694639, -6.253297865839247],
            [10.67045955728213, -6.25406594299763],
            [10.675627602707317, -6.253031556289643],
            [10.68614397789515, -6.255805377939787],
            [10.693660154767272, -6.2538644535843275],
            [10.695067768452004, -6.254940321364005],
            [10.7064137607103, -6.253380368368446],
            [10.708865416552637, -6.270151725904487],
            [10.717071686234636, -6.269236150761598],
            [10.717514600861858, -6.2617628504559715],
            [10.725341091115158, -6.266601183158984],
            [10.725319150290522, -6.270529283480495],
            [10.733171193347983, -6.276877696447658],
            [10.738437525955915, -6.273863761472906],
            [10.744169890736252, -6.274846903886713],
            [10.74739626814368, -6.279360398490658],
            [10.755085809296016, -6.280629523016771],
            [10.758748909498202, -6.282586831691717],
            [10.763308819972226, -6.322620656648063],
            [10.7651362819344, -6.322456647563495],
            [10.777214143129777, -6.413216447174629],
            [10.777940283215141, -6.417273069800874],
            [10.782644761934643, -6.456640699492116],
            [10.783248457117386, -6.458825960452061],
            [10.849019380049794, -6.451267648808108],
            [10.851161795168869, -6.453087938519028],
            [10.859737410632148, -6.452841332365234],
            [10.865598034085401, -6.465099908751941],
            [10.872717012792428, -6.467582040101552],
            [10.876493602845445, -6.471922979467128],
            [10.881214847829375, -6.472446776838885],
            [10.882517510712802, -6.468930533325724],
            [10.886332031355785, -6.467727087559041],
            [10.890352802745818, -6.472676773489208],
            [10.893544347926868, -6.47256496885767],
            [10.896672744161013, -6.481482603606124],
            [10.8930301962859, -6.486132295783381],
            [10.8953690479247, -6.495774644912648],
            [10.902611992482958, -6.50107841630063],
            [10.910051984768248, -6.494645944844783],
            [10.914400362759544, -6.497186338141685],
            [10.924183092127377, -6.579652826369258],
            [10.91137085655723, -6.580914633213386],
            [10.9172477629411, -6.631407705332247],
            [10.929835031884886, -6.630028489526579],
            [10.934402626682898, -6.671897426955358],
            [10.941300101500168, -6.73235710943203],
            [10.89072473226923, -6.737906136174447],
            [10.892218439040525, -6.751068068586358],
            [10.854326299828376, -6.755358524487935],
            [10.852487266811165, -6.742257295822405],
            [10.806343268914556, -6.747726382245451],
            [10.706439768623484, -6.759102868477705],
            [10.649259241466405, -6.76538085851364],
            [10.644875023056214, -6.725527965279732],
            [10.636885760479286, -6.6576212710550635],
            [10.634579580534314, -6.638794316083775],
            [10.647226116552856, -6.636487816770739],
            [10.64578250859392, -6.624270635304115],
            [10.633083715226778, -6.625677103089919],
            [10.62419333353124, -6.550739171165909],
            [10.63616634111973, -6.549271229968854],
            [10.635395987622628, -6.537601499677792],
            [10.622776530833304, -6.538997279493765],
            [10.61923321964101, -6.5105219074493625],
            [10.61821323575116, -6.504982601396347],
            [10.615250886181261, -6.477961105626407],
            [10.601480140652694, -6.480264505717054],
            [10.60050111491338, -6.471306710427373],
            [10.608444288607403, -6.470289446198187],
            [10.607578571812423, -6.4622796164307035],
            [10.615533946560918, -6.461564754019028],
            [10.614518921791202, -6.453028317371923],
            [10.593439806471457, -6.455444270426133],
            [10.594803199992025, -6.454028327560178],
            [10.594710944080266, -6.445234575874096],
            [10.596875478659326, -6.442171533207909],
            [10.592341918212929, -6.435141999922072],
            [10.590734075130433, -6.429588572108374],
            [10.58719798696829, -6.424753648140936],
            [10.585901599042286, -6.42082260908065],
            [10.58709835544444, -6.41378496034548],
            [10.582354756629604, -6.406438775171423],
            [10.579829138363296, -6.3970544876152795],
            [10.573959579422624, -6.393759823865962],
            [10.57310136557296, -6.391620248791425],
            [10.57639761821158, -6.388108820677669],
            [10.583310169960725, -6.383234326275102],
            [10.585564712266589, -6.3743127264775685],
            [10.588314415398196, -6.370795855520546],
            [10.591735326791685, -6.369904842955779],
            [10.591148999381897, -6.362596372757418],
            [10.592707332093662, -6.358223109684642],
            [10.59278722540945, -6.350573708305521],
            [10.59613030456725, -6.347430085414104],
            [10.600585844198525, -6.346904054707013],
            [10.605480763547737, -6.338975320028562],
            [10.605056591954707, -6.333882573577091],
            [10.59752898270773, -6.326266053956832],
            [10.59912580979428, -6.320429866049537],
            [10.597249188623865, -6.318454761259626],
            [10.591763679153113, -6.318551244634281],
            [10.58420615067564, -6.313700646275952],
            [10.582433244052103, -6.305609353218923],
            [10.584143822111221, -6.302179190020489],
            [10.594979959902656, -6.300989161719915],
            [10.59714986309732, -6.297921307357686],
            [10.602617691912576, -6.297536671148339],
            [10.606418580060424, -6.299614825593566],
            [10.608821451588659, -6.2961246216500175],
            [10.605730765948532, -6.29376457125673],
            [10.606862768769671, -6.28391578222721],
            [10.609424385698773, -6.27488229367842],
            [10.613017369963831, -6.267624359716904],
            [10.61995087570316, -6.266776008918216],
            [10.621095984300359, -6.260909401326561],
            [10.627544107693844, -6.25513684266997],
            [10.630472329803272, -6.250286009959046],
            [10.634719805382167, -6.251333977510833]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.85089050216183,
          "lat": 31.551489367928074
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13321"],
        "coty_name": ["Worth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Worth County"],
        "coty_fp_code": "321",
        "coty_gnis_code": "00343365"
      },
      "bbox": [
        10.57310136557296, -6.76538085851364, 10.941300101500168,
        -6.249319666268063
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.928482233869568, -10.821342212773844],
            [-8.913108332508736, -10.825574190553818],
            [-8.904458711488537, -10.822642939268103],
            [-8.901036612783216, -10.819006284389108],
            [-8.898303416293505, -10.804089310026196],
            [-8.895727116001286, -10.803027533996785],
            [-8.898214703881754, -10.797658290723312],
            [-8.89274905237224, -10.792787014792104],
            [-8.887206410605538, -10.790123678492902],
            [-8.879917386339637, -10.793428527091402],
            [-8.874745816033291, -10.80048615716102],
            [-8.874042161610035, -10.80438016147781],
            [-8.8661771904676, -10.816625967452143],
            [-8.865183114471392, -10.825894073088305],
            [-8.86193569758358, -10.828518052294202],
            [-8.862133995039525, -10.831655972743292],
            [-8.85268617962261, -10.835070677229806],
            [-8.846913830814879, -10.83284258149817],
            [-8.844398399182397, -10.835134778402168],
            [-8.83790094723074, -10.835917791099316],
            [-8.83696678007368, -10.840663786570092],
            [-8.829023693575795, -10.849990757142388],
            [-8.81985322177459, -10.856372304738173],
            [-8.821366625119744, -10.860893259095077],
            [-8.822460379935006, -10.870348065028018],
            [-8.821128465656061, -10.871963287058252],
            [-8.837868318456177, -10.874062938129352],
            [-8.842103334439528, -10.871503072840248],
            [-8.847945564614996, -10.865544290988286],
            [-8.848955697109554, -10.862314067693374],
            [-8.8555893814059, -10.850779192128709],
            [-8.863142802866081, -10.845776557505362],
            [-8.868820288298817, -10.850669833933102],
            [-8.874983999932288, -10.846203201623299],
            [-8.876236745296167, -10.843368021793882],
            [-8.876607437503482, -10.832433374132556],
            [-8.877872011807154, -10.825399682662503],
            [-8.88012567950704, -10.825758098708969],
            [-8.87967585068839, -10.833472961580622],
            [-8.880686165612216, -10.838004276787386],
            [-8.87883884608921, -10.84376455244353],
            [-8.88147745733068, -10.84493186241377],
            [-8.88815820393074, -10.838776986238464],
            [-8.887958618555027, -10.835610806049672],
            [-8.890288188708285, -10.829297252765546],
            [-8.89978687382753, -10.825569833065664],
            [-8.908153106534291, -10.827039623568645],
            [-8.918653945003827, -10.826231794819034],
            [-8.928502172674797, -10.822489585660618],
            [-8.928482233869568, -10.821342212773844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -156.94745733856382,
          "lat": 21.170908651067514
        },
        "year": "2023",
        "ste_code": ["15"],
        "ste_name": ["Hawaii"],
        "coty_code": ["15005"],
        "coty_name": ["Kalawao"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kalawao County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01702380"
      },
      "bbox": [
        -8.928502172674797, -10.874062938129352, -8.81985322177459,
        -10.790123678492902
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-11.52245827753722, -9.981166895677017],
              [-11.51845118171811, -9.963925924957147],
              [-11.51911332628147, -9.959520469462518],
              [-11.517503856038443, -9.953362853906444],
              [-11.518157391832563, -9.947249295467632],
              [-11.513109744178498, -9.942845477773504],
              [-11.506242497222553, -9.938374116731827],
              [-11.500974007125006, -9.932217362823092],
              [-11.481807402895804, -9.915804509807032],
              [-11.480535357299738, -9.910117478809848],
              [-11.478266363726922, -9.908193141467077],
              [-11.47526256362238, -9.900262724371164],
              [-11.475000160776933, -9.894446900986175],
              [-11.470355140250186, -9.887588912023178],
              [-11.469516273264423, -9.880077794974893],
              [-11.467610353895719, -9.874523292148902],
              [-11.465116653677965, -9.872356199245644],
              [-11.459581619668425, -9.864485383057236],
              [-11.455532766103712, -9.86322178604568],
              [-11.45106432288908, -9.859454885990072],
              [-11.444023187676652, -9.855865063642614],
              [-11.441742458099286, -9.857126536951796],
              [-11.437435367659186, -9.852506545213249],
              [-11.42914912428783, -9.851868302332617],
              [-11.411837220867266, -9.847322771542142],
              [-11.39979269324113, -9.842839244393927],
              [-11.390596401700936, -9.835801866800878],
              [-11.385648530769341, -9.835282276326522],
              [-11.376736414648896, -9.82754943465753],
              [-11.37360517083829, -9.823997926302903],
              [-11.36668532878662, -9.819898074053546],
              [-11.361157244365675, -9.818286718056187],
              [-11.350568526664166, -9.813151637034803],
              [-11.349719723886501, -9.811247003837435],
              [-11.341684917385365, -9.80672035364657],
              [-11.327023337078113, -9.794423336821794],
              [-11.316410885476511, -9.794661428833459],
              [-11.313089828602177, -9.79739223228304],
              [-11.306382100658565, -9.791539431719249],
              [-11.301252484618514, -9.793630989841978],
              [-11.297069875450912, -9.793349031191038],
              [-11.292337013829178, -9.796516062584898],
              [-11.290275053705555, -9.802435794787307],
              [-11.287849351132133, -9.804178449867686],
              [-11.281657690013809, -9.80033946120654],
              [-11.279937451363832, -9.802436304776133],
              [-11.26800181890016, -9.804053658110156],
              [-11.268537037069656, -9.807009934679686],
              [-11.261515729221463, -9.81452948660116],
              [-11.254622897813476, -9.813951866160787],
              [-11.249919780393503, -9.810130890987464],
              [-11.248973473342916, -9.804341030937309],
              [-11.252174958015841, -9.799368232961173],
              [-11.249106482799837, -9.795318698848801],
              [-11.243952539523328, -9.79368547679977],
              [-11.239939784792618, -9.789394044573385],
              [-11.22872639516058, -9.789708246633026],
              [-11.224084474386963, -9.793273260882572],
              [-11.220870482051861, -9.793011997766504],
              [-11.218646344638145, -9.795718365869067],
              [-11.208529072561722, -9.792778640795225],
              [-11.199338528794247, -9.795452042906835],
              [-11.190463673821903, -9.795801967814013],
              [-11.184965031215375, -9.801511895766467],
              [-11.182517880624529, -9.801105314375993],
              [-11.180458872547277, -9.794896141603534],
              [-11.17625076215609, -9.79622386066936],
              [-11.16409257721438, -9.793849876827698],
              [-11.162930118105862, -9.789763044714395],
              [-11.160032909588656, -9.787130053997869],
              [-11.155877043466097, -9.790015745421103],
              [-11.153684656730642, -9.794169724441197],
              [-11.149263738127146, -9.794359845322186],
              [-11.148219716225055, -9.796820416003039],
              [-11.14183884828988, -9.794942550102556],
              [-11.141210842694928, -9.802561786025606],
              [-11.134983028732725, -9.801759930721783],
              [-11.128243671488288, -9.804502846636918],
              [-11.117919288735061, -9.806211309217131],
              [-11.11094511237315, -9.804756759202617],
              [-11.101841074658847, -9.811169916251245],
              [-11.094077294745372, -9.81953944567559],
              [-11.095868654274183, -9.824023087543932],
              [-11.09120764550379, -9.824494435849],
              [-11.079276657807481, -9.83255530607297],
              [-11.076206875119642, -9.83622835016913],
              [-11.075274254325214, -9.840949186192697],
              [-11.076588806557854, -9.846163421360398],
              [-11.067526640007037, -9.858864759204684],
              [-11.069624581406758, -9.861321478469636],
              [-11.070945809339548, -9.868287753632908],
              [-11.067640555953977, -9.871325391956274],
              [-11.061619980005165, -9.869015646630896],
              [-11.058778217983672, -9.874197416521511],
              [-11.058014305582496, -9.887957156445717],
              [-11.058719518214843, -9.895067536953766],
              [-11.062258539229836, -9.902748263789501],
              [-11.060341640564765, -9.90685207204608],
              [-11.062262962789001, -9.912462186458946],
              [-11.066479348813713, -9.9174770375119],
              [-11.06910362198961, -9.918226813620736],
              [-11.070222896184449, -9.926699022751938],
              [-11.075759145839434, -9.93272199676939],
              [-11.08123098454862, -9.94126859203951],
              [-11.080970915111475, -9.946140581347722],
              [-11.082896065148734, -9.954923738728715],
              [-11.086047515637523, -9.960355767337273],
              [-11.092568933996318, -9.96435785029868],
              [-11.096487740972364, -9.965249942877657],
              [-11.09909941333703, -9.969816967226183],
              [-11.098233101649889, -9.974033618145722],
              [-11.102235077511189, -9.991816907928207],
              [-11.101555810414055, -9.999155328906586],
              [-11.096815575625207, -10.015379377130975],
              [-11.098998916567028, -10.017884861325864],
              [-11.099261455020853, -10.022185043826582],
              [-11.095020967655833, -10.020502324038931],
              [-11.093930596899952, -10.022878116787595],
              [-11.09813166734095, -10.029589950141466],
              [-11.097876422230396, -10.035966988097186],
              [-11.094802172370963, -10.047402944470184],
              [-11.094660570853657, -10.05363643721692],
              [-11.100224518307742, -10.058527325037613],
              [-11.104330850938707, -10.055263457096553],
              [-11.11141593008026, -10.056684105102004],
              [-11.111918247963665, -10.05325842725258],
              [-11.115256026822973, -10.053485900769536],
              [-11.11570471211766, -10.058646238528434],
              [-11.121586543306739, -10.05975440924639],
              [-11.120573408652497, -10.065573193021361],
              [-11.11395730001876, -10.064407223291916],
              [-11.111367948458701, -10.065786410791029],
              [-11.113825769200446, -10.071767015255872],
              [-11.110665268796444, -10.076731586378036],
              [-11.117557351508687, -10.076453491288072],
              [-11.118503848469189, -10.081301833494086],
              [-11.124999701569429, -10.08136679504257],
              [-11.129218730803833, -10.083613362632287],
              [-11.130535664365356, -10.086826292604457],
              [-11.14180177124806, -10.091278621617999],
              [-11.146923385130215, -10.099757597140682],
              [-11.150031929912098, -10.09971926469855],
              [-11.151680361371273, -10.104687903859512],
              [-11.151014254640234, -10.109937470158371],
              [-11.157877647204163, -10.1089059630578],
              [-11.164373521835302, -10.113202114843784],
              [-11.165204669813534, -10.118204574059387],
              [-11.17052172953566, -10.121630084004723],
              [-11.176530950315476, -10.123043221445156],
              [-11.17860460677584, -10.128844201037355],
              [-11.186424313376657, -10.129876154823803],
              [-11.192843305796602, -10.13665732896722],
              [-11.196420626484125, -10.13577850526984],
              [-11.20310794003751, -10.141998580289446],
              [-11.210485500628218, -10.137848089576424],
              [-11.225661476020342, -10.13149943159901],
              [-11.23150024227026, -10.128557617140174],
              [-11.238354131330512, -10.128436560324621],
              [-11.243561248648241, -10.12496267307885],
              [-11.255864151891915, -10.125872293018581],
              [-11.265942678476513, -10.12240658733543],
              [-11.272950991354369, -10.123517790668751],
              [-11.279752234317062, -10.126371146307838],
              [-11.284277879010595, -10.123416419555113],
              [-11.288676094549851, -10.123616546402454],
              [-11.296100634029427, -10.12209249758448],
              [-11.30300691396721, -10.122818286562142],
              [-11.311580329617044, -10.1203386058477],
              [-11.319794435147143, -10.116051550538458],
              [-11.324213773080611, -10.117227877814832],
              [-11.332549341365059, -10.111858659740168],
              [-11.33649490861967, -10.1112874142112],
              [-11.338507996713718, -10.107279083832003],
              [-11.342720772349276, -10.105945679384677],
              [-11.345630153376018, -10.107638403588096],
              [-11.34561324983766, -10.115160246983459],
              [-11.351132343786226, -10.117504189730312],
              [-11.354833569048147, -10.11466278250769],
              [-11.355603260408515, -10.110090900328691],
              [-11.363704209095294, -10.107811271850155],
              [-11.368614599833132, -10.103470883168944],
              [-11.374542844947783, -10.10099417039171],
              [-11.3794235053474, -10.096796361975402],
              [-11.383731703515245, -10.090766296487882],
              [-11.383435856131634, -10.088165103611153],
              [-11.388052969711708, -10.08430848582424],
              [-11.394209444531965, -10.076463391298953],
              [-11.394326672883254, -10.071243044630855],
              [-11.39708720904148, -10.068849790729608],
              [-11.404435384726138, -10.067672598935967],
              [-11.411735428844494, -10.057018797138655],
              [-11.41699999634807, -10.055020253295979],
              [-11.44821852320979, -10.049179809830273],
              [-11.455479842632343, -10.04332450192575],
              [-11.47502886624001, -10.037592575844686],
              [-11.487715813770599, -10.03431547958593],
              [-11.496307777895147, -10.030829434749162],
              [-11.502153543979192, -10.023853496096208],
              [-11.509839797434553, -10.004959995980792],
              [-11.515974173206148, -10.000494078454153],
              [-11.52141963864046, -9.99220905217758],
              [-11.52245827753722, -9.981166895677017]
            ]
          ],
          [
            [
              [-11.81634643724056, -9.989193970176787],
              [-11.816264108910296, -9.982511375650716],
              [-11.811570787234475, -9.986298189912493],
              [-11.808437913160768, -9.986296499085986],
              [-11.804369202008358, -9.982070471693925],
              [-11.80317814930063, -9.986475281947211],
              [-11.807940214221619, -9.99154815973957],
              [-11.81434062785411, -9.992676364614818],
              [-11.81634643724056, -9.989193970176787]
            ]
          ],
          [
            [
              [-11.952412503529986, -10.154700643128514],
              [-11.948031961155193, -10.150676129591401],
              [-11.940769114909836, -10.139569553550498],
              [-11.940380460323878, -10.126656376177511],
              [-11.937222594697536, -10.12325091995573],
              [-11.936708082071581, -10.117874963055645],
              [-11.93331111129835, -10.113181012294131],
              [-11.926369161678489, -10.109607633732358],
              [-11.911747481451021, -10.096872278490137],
              [-11.90563518638285, -10.088552887798784],
              [-11.90137669228594, -10.086022430410576],
              [-11.896995568144504, -10.079564488951648],
              [-11.886134154492071, -10.076738908057063],
              [-11.87628656755503, -10.071909190883941],
              [-11.8737731637176, -10.06655939634915],
              [-11.865986874190655, -10.066439351383178],
              [-11.849666770853108, -10.059750466715066],
              [-11.839119794213262, -10.052131106042621],
              [-11.8354977337432, -10.047009990397964],
              [-11.833413924070657, -10.040365154027958],
              [-11.828634605237387, -10.031601259159363],
              [-11.827679870287643, -10.021962696277653],
              [-11.8245513886801, -10.018341661814492],
              [-11.825740564498556, -10.013349147412754],
              [-11.819331361111168, -10.00890347084774],
              [-11.81548701660149, -10.01132043790395],
              [-11.80853140554154, -10.006240665124942],
              [-11.807144701301635, -10.001955379929962],
              [-11.802506901141607, -10.004591459649042],
              [-11.801943846282855, -10.009410471242555],
              [-11.788535346540021, -10.007553799356831],
              [-11.786716869641278, -10.004349207628374],
              [-11.77594925423262, -10.011229152011863],
              [-11.77083986465196, -10.015291408396331],
              [-11.768675420402818, -10.022742236133478],
              [-11.769215409574144, -10.028004034870236],
              [-11.77235909741136, -10.030548919495347],
              [-11.780369376796726, -10.030884045157219],
              [-11.7857284984722, -10.039542437021044],
              [-11.787916431416113, -10.048007870705895],
              [-11.793078502440485, -10.051820022213077],
              [-11.799623661391369, -10.077781422247387],
              [-11.79643669502963, -10.090286232921887],
              [-11.790768975111769, -10.104689601678988],
              [-11.792407666618713, -10.110195991829682],
              [-11.79604135789998, -10.110605858576584],
              [-11.80233884139535, -10.115219400512297],
              [-11.806765415095603, -10.116316633384788],
              [-11.812990096329333, -10.120764828823937],
              [-11.81503888329578, -10.11976818027452],
              [-11.822919177909624, -10.125621490708946],
              [-11.826759789311026, -10.123210383167061],
              [-11.835153349408339, -10.126866749835454],
              [-11.843033001678554, -10.129445532821558],
              [-11.853556129159388, -10.131417185668008],
              [-11.857346580845476, -10.130776875175798],
              [-11.871556180176446, -10.138053194924954],
              [-11.877151321446155, -10.146187378858212],
              [-11.879413337786097, -10.152318113513319],
              [-11.884865891605488, -10.158747601921155],
              [-11.885839109834047, -10.163467907499154],
              [-11.890159393536015, -10.167310741818836],
              [-11.902885350274483, -10.187415819862608],
              [-11.905138263660474, -10.194000285550166],
              [-11.9038211844669, -10.197048266728665],
              [-11.910986365966233, -10.20600079565299],
              [-11.913137602229076, -10.213982248435553],
              [-11.909551545017862, -10.2162119242794],
              [-11.914277630982946, -10.221593509450576],
              [-11.91829217608172, -10.218229125607733],
              [-11.924835581827356, -10.218148237902925],
              [-11.927586308920702, -10.21423709407727],
              [-11.930756561973036, -10.213042095093986],
              [-11.932986818130376, -10.209446761358302],
              [-11.939451155940041, -10.210227382884888],
              [-11.942096324191597, -10.20825592369086],
              [-11.941420189829355, -10.20336622740315],
              [-11.945248399357157, -10.197289125743428],
              [-11.95116258321996, -10.169648918814486],
              [-11.952888793109167, -10.166951817982568],
              [-11.951393034891233, -10.16159892493035],
              [-11.953725841664662, -10.161008509577321],
              [-11.952412503529986, -10.154700643128514]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -159.59578873278764,
          "lat": 22.04012737954741
        },
        "year": "2023",
        "ste_code": ["15"],
        "ste_name": ["Hawaii"],
        "coty_code": ["15007"],
        "coty_name": ["Kauai"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kauai County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00365282"
      },
      "bbox": [
        -11.953725841664662, -10.221593509450576, -11.058014305582496,
        -9.787130053997869
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.159449266776893, 5.333097903605044],
            [-11.07651481505712, 5.319079540119757],
            [-11.076666360188469, 5.3177118613814764],
            [-10.9895477171969, 5.30264855855591],
            [-10.902241115320418, 5.288272887981849],
            [-10.82030587211489, 5.27399405334581],
            [-10.734933603203602, 5.260349673402237],
            [-10.650600519344723, 5.247283077674488],
            [-10.650689915917463, 5.246682771280478],
            [-10.566153462342479, 5.233085938487507],
            [-10.56632586057536, 5.232083102987745],
            [-10.429036113304402, 5.209999780893528],
            [-10.43590786964345, 5.166119782473772],
            [-10.451934223227743, 5.06708802264877],
            [-10.462111707649782, 5.002445717190621],
            [-10.475671273858199, 4.916309021241383],
            [-10.499630947254548, 4.778084200831191],
            [-10.511047112656057, 4.7100293416192685],
            [-10.51221102139027, 4.70817408979681],
            [-10.526322002852362, 4.707394083913681],
            [-10.524237637598292, 4.703781202384548],
            [-10.5248078522525, 4.6989070698862045],
            [-10.527807643731784, 4.696462616236177],
            [-10.532146368194908, 4.696166689356608],
            [-10.533716182095501, 4.691470030279605],
            [-10.539104222650211, 4.693759353223935],
            [-10.54684401241845, 4.691648044474526],
            [-10.55001863480506, 4.693308746281434],
            [-10.55453185591789, 4.692864219662658],
            [-10.56023215458041, 4.695166547122917],
            [-10.56514410637861, 4.69222236950549],
            [-10.568556927747945, 4.691793791211707],
            [-10.570684221435835, 4.688937998936397],
            [-10.577117735296836, 4.687538177806186],
            [-10.577395769444758, 4.6902900761278],
            [-10.581272009259186, 4.694438770301685],
            [-10.585885782171395, 4.693669949751698],
            [-10.58876850140061, 4.698913654199898],
            [-10.592977268665532, 4.6971224330280235],
            [-10.596251815626875, 4.6999575641850155],
            [-10.598763177852002, 4.691401607162704],
            [-10.601627965152007, 4.686019164231653],
            [-10.610851616986782, 4.689587916281453],
            [-10.615499509848004, 4.688000357084748],
            [-10.61969949908696, 4.692295999322537],
            [-10.623932846837983, 4.692336119157421],
            [-10.628680059484521, 4.695218649242642],
            [-10.634315760812708, 4.694322561610429],
            [-10.642482447235055, 4.69614176933891],
            [-10.648555210310109, 4.694846714496981],
            [-10.653486812927502, 4.698130651291162],
            [-10.653790297776425, 4.70132026252436],
            [-10.65748439721585, 4.706302121128914],
            [-10.658130855076191, 4.711546634038862],
            [-10.660290258207896, 4.7150090916494865],
            [-10.659321818187859, 4.720886190846681],
            [-10.649223347579115, 4.72726741346312],
            [-10.647476977632053, 4.735227650916627],
            [-10.64285616622885, 4.743535307138284],
            [-10.642804807838479, 4.7459510513885705],
            [-10.638042357648013, 4.755595012177424],
            [-10.635765149828705, 4.768979119431398],
            [-10.628663742643615, 4.788496384448187],
            [-10.634744221288777, 4.792178524580034],
            [-10.63337254944011, 4.796572269871173],
            [-10.636663073200618, 4.797900747540497],
            [-10.639958477269321, 4.802911355601245],
            [-10.637920978375776, 4.80759678249943],
            [-10.639838331253923, 4.809934267000199],
            [-10.637395279240138, 4.820186411128806],
            [-10.640607810553572, 4.821613343351116],
            [-10.643047593797874, 4.8191972285603955],
            [-10.648985954718619, 4.807120776874493],
            [-10.65242067700912, 4.805054192081449],
            [-10.65793021069456, 4.798666115166065],
            [-10.659240901741331, 4.792468771630015],
            [-10.662655085516418, 4.7895589848872575],
            [-10.667312388647847, 4.7832660311855255],
            [-10.670107992363826, 4.7819113922369265],
            [-10.67303215744166, 4.775556922613272],
            [-10.68175467255541, 4.780703673829556],
            [-10.683936106870167, 4.783828009691943],
            [-10.69286345528677, 4.7869176449811395],
            [-10.700065916586775, 4.788491585780129],
            [-10.705623001909737, 4.7913997310203085],
            [-10.708169833620948, 4.795802357929075],
            [-10.711666162609923, 4.795742526471494],
            [-10.715153603371359, 4.800842596805899],
            [-10.71396293240268, 4.806218908297171],
            [-10.710897348683098, 4.811663796038937],
            [-10.711605386756556, 4.815619886215633],
            [-10.718130509716005, 4.816222705725317],
            [-10.72544449730497, 4.819018705485745],
            [-10.731037537620654, 4.822987603140032],
            [-10.802023976904485, 4.834392597222147],
            [-10.88024167627215, 4.847527960900335],
            [-10.90073966562767, 4.850765053427175],
            [-10.90227432960478, 4.848042568564666],
            [-10.912402552125835, 4.845335802515985],
            [-10.915837533793438, 4.839657731733571],
            [-10.92093803737563, 4.839131736744046],
            [-10.926685647773025, 4.8347937716401725],
            [-10.928129616365608, 4.824544856779203],
            [-10.9262699941809, 4.817436067760897],
            [-10.92861551699741, 4.81116795724325],
            [-10.92816752688714, 4.804473320824214],
            [-10.926348437747533, 4.799391823358565],
            [-10.927199066486201, 4.786368145364272],
            [-10.926075020468122, 4.781873098862628],
            [-10.919114585211268, 4.7719896439552505],
            [-10.917979158128725, 4.762711753748818],
            [-10.91948488823856, 4.755647874755293],
            [-10.917169210650343, 4.752704644913658],
            [-10.91838049254059, 4.747875320555299],
            [-10.914816844425989, 4.742955150194586],
            [-10.915938511305823, 4.73800209043664],
            [-10.91483599732417, 4.7233100800065815],
            [-10.909668757583006, 4.705945346311207],
            [-10.910144203817232, 4.700551653629918],
            [-10.91266081976145, 4.694609851709625],
            [-10.910216946836252, 4.68930811187741],
            [-10.915667081488508, 4.685644454352316],
            [-10.920610427740316, 4.6855010593208535],
            [-10.92489507439703, 4.681681227628311],
            [-10.926684883179096, 4.67726765811331],
            [-10.92964179993011, 4.678385240651266],
            [-11.007507654660671, 4.691160639407932],
            [-11.00569799047231, 4.702029580579757],
            [-11.009182437843371, 4.702586636900677],
            [-11.0086662783916, 4.706281984138783],
            [-11.021483881337112, 4.708482112323301],
            [-11.025234808498446, 4.705058983071222],
            [-11.02455956647242, 4.69988876594571],
            [-11.027251638133727, 4.694720917937915],
            [-11.096229368851077, 4.706139483139372],
            [-11.126524728187954, 4.711327148094468],
            [-11.121531637561702, 4.740132810884246],
            [-11.128564901866348, 4.741246809992676],
            [-11.121401948608195, 4.784365069085684],
            [-11.128357817393608, 4.785545047763598],
            [-11.12614417207501, 4.799405733142314],
            [-11.127276704452369, 4.799631861340184],
            [-11.123687919379165, 4.820668519722342],
            [-11.137795299271868, 4.823197978643025],
            [-11.127108784577228, 4.886568151509672],
            [-11.127408160995907, 4.88725714941482],
            [-11.122652085946974, 4.91520478731745],
            [-11.126199268807735, 4.915762685076883],
            [-11.123781781013905, 4.930385719326773],
            [-11.127367854258651, 4.931011353431876],
            [-11.126755029373053, 4.934494010335551],
            [-11.140881487356285, 4.936860017425215],
            [-11.13424296972301, 4.975537606585078],
            [-11.148435382302825, 4.97793791494638],
            [-11.146047246195044, 4.981866372580246],
            [-11.141709172354824, 4.984812853205373],
            [-11.139213169069803, 4.991817629218958],
            [-11.142202019666197, 4.997366622996478],
            [-11.146232749591189, 5.00026977408508],
            [-11.146082913870151, 5.006336761563192],
            [-11.147769322555426, 5.0080540805194405],
            [-11.146208769203655, 5.013076424494875],
            [-11.147377832780009, 5.018051731501467],
            [-11.143568113565465, 5.021184292390509],
            [-11.206797438434323, 5.031891949619994],
            [-11.213314244476434, 5.027962944178674],
            [-11.21704455175364, 5.021006488571138],
            [-11.224229293926209, 5.020020220113119],
            [-11.230072621297143, 5.015650256875533],
            [-11.237358591776221, 5.015194857510477],
            [-11.244981265646704, 5.019245066809661],
            [-11.249156866472818, 5.036914798084579],
            [-11.246619128036741, 5.045990608344224],
            [-11.249543919853483, 5.058292500364308],
            [-11.252816242832125, 5.059047052133694],
            [-11.255765811124851, 5.069077959566851],
            [-11.258817838850788, 5.074539134174141],
            [-11.258162410467547, 5.082752709478731],
            [-11.259428360541827, 5.086668522705976],
            [-11.255566691061022, 5.1010926298174],
            [-11.255741968606412, 5.106920181125373],
            [-11.257656313495994, 5.114394723422488],
            [-11.256915232359708, 5.119720935746082],
            [-11.253471748687492, 5.121551079438552],
            [-11.249847180572303, 5.133113971480739],
            [-11.240928423216216, 5.131662675268481],
            [-11.2377789310866, 5.138268979614183],
            [-11.234421391922972, 5.140163137919888],
            [-11.234902500159263, 5.144950226789964],
            [-11.23300740587334, 5.151196014774802],
            [-11.235223456248418, 5.1531921343968685],
            [-11.235670365209458, 5.160024302433999],
            [-11.238447473001237, 5.16089356954286],
            [-11.240266894671828, 5.1648305544992255],
            [-11.240503315113958, 5.17083496152725],
            [-11.237496017088292, 5.174271158462208],
            [-11.24006758786197, 5.176902380798929],
            [-11.236384545163538, 5.190336419543076],
            [-11.236172947242531, 5.201173444908318],
            [-11.238150895686998, 5.209047698957594],
            [-11.240397427206041, 5.210882573834959],
            [-11.243226918467366, 5.218543636269922],
            [-11.240137872754223, 5.226097836694302],
            [-11.233320855595947, 5.225554484722406],
            [-11.228887380533168, 5.23349195238423],
            [-11.233217856934282, 5.2367523307692005],
            [-11.233575886084504, 5.24159341118312],
            [-11.228955343122083, 5.243607983464026],
            [-11.22507890584217, 5.248258526270365],
            [-11.218825720504881, 5.264106913464024],
            [-11.215533429629568, 5.262897074995808],
            [-11.209324835368795, 5.265703320175533],
            [-11.205374813474252, 5.264303625449725],
            [-11.199906575974687, 5.268138937802623],
            [-11.192793341045988, 5.2660650895827175],
            [-11.189820496787258, 5.2633859610425],
            [-11.185270301453928, 5.264411990141025],
            [-11.18583817798716, 5.278197087825723],
            [-11.186805349700638, 5.280781535337287],
            [-11.184837437662146, 5.285189821554677],
            [-11.186137771043095, 5.287978214218661],
            [-11.17517084074061, 5.293023435210216],
            [-11.167227476243694, 5.291266923396645],
            [-11.16298303452746, 5.294119421114514],
            [-11.157476079907825, 5.300950770603214],
            [-11.156223065663054, 5.31029204356623],
            [-11.159550976363903, 5.314044545164119],
            [-11.156822876522211, 5.318032050790575],
            [-11.16077518082255, 5.322580307995066],
            [-11.15898835206153, 5.325939339269485],
            [-11.159449266776893, 5.333097903605044]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.56224051903229,
          "lat": 42.77050968311737
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16029"],
        "coty_name": ["Caribou"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caribou County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00395406"
      },
      "bbox": [
        -11.259428360541827, 4.67726765811331, -10.429036113304402,
        5.333097903605044
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.622855534944884, 10.810231083883147],
            [-13.559693365953342, 10.796295217188472],
            [-13.496534249511418, 10.78234541823578],
            [-13.441871597165584, 10.770485871979778],
            [-13.354053075970782, 10.751012941569028],
            [-13.350250951404165, 10.764580087079539],
            [-13.265459682634505, 10.746155949087496],
            [-13.274863935048304, 10.706422451220886],
            [-13.287470087713835, 10.649869022303541],
            [-13.280557915016818, 10.648473497834342],
            [-13.1714875310929, 10.625248502759504],
            [-13.189508793130349, 10.543584075305578],
            [-13.20466343774749, 10.474906297372062],
            [-13.242042278789304, 10.30551698910719],
            [-13.271818567958686, 10.170531534446177],
            [-13.314974839517003, 10.179475247705989],
            [-13.315125470293614, 10.178898799226392],
            [-13.375969259860208, 10.191841673353977],
            [-13.400670305695341, 10.197387656556382],
            [-13.40042598494099, 10.198527679400351],
            [-13.442702882846739, 10.207988605295366],
            [-13.44574105193366, 10.194203876041568],
            [-13.474073689607787, 10.200403718960867],
            [-13.480226445193457, 10.172790184774444],
            [-13.550958334113048, 10.188200446505448],
            [-13.547727078649647, 10.201987987576727],
            [-13.569657842376046, 10.206699762421616],
            [-13.570784111578451, 10.201803891173109],
            [-13.59913169522061, 10.20793051529236],
            [-13.602219097245305, 10.194247860604804],
            [-13.65884236744146, 10.206652129396472],
            [-13.66944480389758, 10.208823450756622],
            [-13.754717204414268, 10.227554717960142],
            [-13.747377657105627, 10.259074488591862],
            [-13.730237661449834, 10.3341976926713],
            [-13.720900460414436, 10.376742232498556],
            [-13.713583193300316, 10.411039149577174],
            [-13.709829664812435, 10.426145130592785],
            [-13.677977029230584, 10.567812247491101],
            [-13.675203354151074, 10.579792655875433],
            [-13.670308266212178, 10.604271613818957],
            [-13.666042537660205, 10.621101697299213],
            [-13.656460504938762, 10.662743694667485],
            [-13.653151710484764, 10.678615547474696],
            [-13.62533814272638, 10.799686649675222],
            [-13.622855534944884, 10.810231083883147]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.70181812319616,
          "lat": 47.674376265467195
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16055"],
        "coty_name": ["Kootenai"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kootenai County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00395661"
      },
      "bbox": [
        -13.754717204414268, 10.170531534446177, -13.1714875310929,
        10.810231083883147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.554184930495765, 6.670870001531256],
            [-14.550524728280974, 6.667070532498067],
            [-14.540431594999777, 6.65984939347434],
            [-14.531674126145546, 6.6562374063584535],
            [-14.523525460244446, 6.655084184680467],
            [-14.516772210871272, 6.649775130565288],
            [-14.514306819273223, 6.641964079389341],
            [-14.516598005502976, 6.633043759099033],
            [-14.516142703175865, 6.6216751194016386],
            [-14.513990838972104, 6.615765708998059],
            [-14.50820486136852, 6.610813347345022],
            [-14.500453386924736, 6.602651530621513],
            [-14.49511553465831, 6.594744061075762],
            [-14.4927100283063, 6.584193224946562],
            [-14.488403983797845, 6.57403197613425],
            [-14.48497742397568, 6.573540861595344],
            [-14.47818576013981, 6.568846880295111],
            [-14.470596867332217, 6.565277432911087],
            [-14.462853405212082, 6.559588864072217],
            [-14.458055802904981, 6.560730779215959],
            [-14.445424229549738, 6.558339248837052],
            [-14.44088216920092, 6.55357628358139],
            [-14.43766143665173, 6.546617554847466],
            [-14.428986900032852, 6.5378535322656575],
            [-14.426629873271319, 6.533279508372344],
            [-14.424025372490636, 6.523387407188882],
            [-14.423439636314251, 6.517864551558654],
            [-14.42394826879261, 6.506471070452128],
            [-14.420657623191872, 6.498458720748957],
            [-14.418638455496914, 6.491330595677265],
            [-14.415168433776865, 6.4850437250495965],
            [-14.415564599509725, 6.47910331871605],
            [-14.420471264374825, 6.471578709352581],
            [-14.421186508421396, 6.462128214250353],
            [-14.423573557356146, 6.455294347619778],
            [-14.423513500600933, 6.446516802202856],
            [-14.425860527387131, 6.435633901574129],
            [-14.424469106711523, 6.429798817836899],
            [-14.410965553688184, 6.41348996391871],
            [-14.405072244952205, 6.407429821977802],
            [-14.403930826199987, 6.402201563084227],
            [-14.399080812934441, 6.392043670716436],
            [-14.39730644719788, 6.385505966903759],
            [-14.394282980705398, 6.383715109695809],
            [-14.391272924883124, 6.379356100092179],
            [-14.389326743724563, 6.372951588210892],
            [-14.384116024779754, 6.365934213325746],
            [-14.382532450261774, 6.360607900668171],
            [-14.378279115854479, 6.354513516402842],
            [-14.373222715148701, 6.349961282279353],
            [-14.368882134938739, 6.342900299674639],
            [-14.367336900871136, 6.333261316101317],
            [-14.365435445039854, 6.328198982297279],
            [-14.358632254508139, 6.3226344841058],
            [-14.353395631254456, 6.315901694814996],
            [-14.348698025851592, 6.315625105726693],
            [-14.341702905881238, 6.307410304947082],
            [-14.337400873713664, 6.3050785089501895],
            [-14.33517453845271, 6.299671971513773],
            [-14.333146858321804, 6.289179434370033],
            [-14.330553181256501, 6.284475029511554],
            [-14.328391410339963, 6.2692395783024315],
            [-14.329922863974218, 6.263366740902344],
            [-14.325687926319475, 6.258173316548312],
            [-14.321490399297995, 6.246401719736661],
            [-14.320520831367798, 6.236091025180802],
            [-14.309727175600214, 6.230192272033404],
            [-14.301679221006967, 6.224836679446688],
            [-14.297309057918115, 6.225211340972435],
            [-14.291787288859542, 6.221847853385512],
            [-14.288188991591152, 6.221702102245209],
            [-14.281755056946048, 6.219164471865754],
            [-14.277879284209131, 6.214307738049333],
            [-14.276317359901352, 6.210424005307906],
            [-14.27053031712947, 6.200579939529767],
            [-14.256908342936814, 6.2049193128495554],
            [-14.247999268466534, 6.204970317238452],
            [-14.241760254602662, 6.202941599291382],
            [-14.230212718642903, 6.202426438894888],
            [-14.22424517118893, 6.204499206670776],
            [-14.21930085732405, 6.203879788007679],
            [-14.2143853041512, 6.200047514418707],
            [-14.208165143087939, 6.190669859163244],
            [-14.205706126098557, 6.188835712091839],
            [-14.2036625375419, 6.18346110784418],
            [-14.202637132385805, 6.177109629476583],
            [-14.203895690298376, 6.168996918021167],
            [-14.205400968304161, 6.166842992372414],
            [-14.202646910863765, 6.161235476888014],
            [-14.197062832743796, 6.155002722012254],
            [-14.191955275621723, 6.139721726713734],
            [-14.192916769967631, 6.1315171528750465],
            [-14.201781100460604, 6.119136825879464],
            [-14.203106694468687, 6.107499652074113],
            [-14.207164696988723, 6.099975926912466],
            [-14.207951350495442, 6.096402174471324],
            [-14.205495096986464, 6.0904012181972575],
            [-14.19790427129577, 6.081612189647472],
            [-14.196727055015451, 6.07563776582429],
            [-14.192247111246605, 6.066173362400287],
            [-14.188955340309585, 6.062688031656402],
            [-14.184732239585168, 6.061885477360079],
            [-14.179455476509155, 6.057291336482475],
            [-14.17888743551167, 6.049440668367605],
            [-14.18020868760594, 6.045684079968216],
            [-14.178608848676744, 6.042982356785086],
            [-14.1713731085566, 6.037744897188985],
            [-14.168335791130042, 6.029148301846951],
            [-14.168477324832663, 6.017852365286336],
            [-14.166208292575666, 6.012698449669176],
            [-14.162842126658738, 6.01057676277329],
            [-14.152727212835437, 6.009150767837125],
            [-14.146238959549429, 6.00704358745889],
            [-14.14156863886337, 6.003942369408435],
            [-14.14038099598525, 5.998628667346124],
            [-14.142142978191558, 5.992695791637125],
            [-14.13506810665727, 5.985618419329288],
            [-14.127790178870189, 5.981194042106509],
            [-14.123708723235078, 5.976825585262442],
            [-14.11369009219565, 5.976692530094355],
            [-14.105324343948553, 5.97340797903059],
            [-14.101676600295947, 5.970831420909264],
            [-14.093798583117485, 5.958134213234219],
            [-14.097610579750263, 5.954277930967606],
            [-14.106728122192552, 5.948850507579232],
            [-14.109447771908586, 5.942416017826002],
            [-14.108957087100688, 5.936603717715779],
            [-14.11010084779001, 5.932131618956988],
            [-14.108062454825413, 5.926878068646761],
            [-14.098150095899886, 5.919303908846368],
            [-14.092323154734816, 5.917080328517617],
            [-14.090022541293704, 5.912550900867008],
            [-14.085846853988237, 5.910734135427551],
            [-14.078646713385533, 5.911003545116613],
            [-14.074108146737355, 5.909791204995797],
            [-14.068455003264987, 5.9032406136272915],
            [-14.0693629389356, 5.896151524056304],
            [-14.076324551201177, 5.891764824826444],
            [-14.077859256369482, 5.886569406430282],
            [-14.075843956172555, 5.883635312314402],
            [-14.070277769538594, 5.882254753196515],
            [-14.06466275716785, 5.882916628158347],
            [-14.060945326166078, 5.881527158685848],
            [-14.054866493859432, 5.876501409126209],
            [-14.049604352982156, 5.864167709197607],
            [-14.044750275385931, 5.858512583527486],
            [-14.042077814086916, 5.850293047778311],
            [-14.031444135191654, 5.845828309500677],
            [-14.023035824044113, 5.846160286302947],
            [-14.015936065974993, 5.8441345820635195],
            [-14.01369816733943, 5.841612681544784],
            [-14.009435324364988, 5.830507754763438],
            [-14.005886705426253, 5.81597214665653],
            [-14.000256852815557, 5.8097527004151175],
            [-13.994575486519285, 5.801623971547742],
            [-13.985875373971357, 5.798261417803696],
            [-13.97075223293516, 5.793878088228854],
            [-13.961879602027958, 5.787996276185639],
            [-13.957277918564177, 5.795461254034426],
            [-13.957015145198692, 5.799886262751821],
            [-13.961340834568347, 5.815310737855531],
            [-13.95613580913016, 5.821139980925257],
            [-13.956002663915742, 5.824121178963646],
            [-13.950044087540121, 5.831721800226506],
            [-13.947051161172793, 5.831520864578562],
            [-13.943662412013847, 5.833935461421953],
            [-13.937170239219661, 5.834073364999048],
            [-13.931590286880823, 5.839439269867826],
            [-13.92885554746641, 5.840387075886097],
            [-13.922072724808174, 5.8385347050498],
            [-13.916981610665177, 5.8292312017171835],
            [-13.918654477887051, 5.8235732354153065],
            [-13.912338424364798, 5.816998485984589],
            [-13.90283001824313, 5.815379118051394],
            [-13.897398875745505, 5.819305404304243],
            [-13.890825620732315, 5.819230243879694],
            [-13.884333093123587, 5.811768399346452],
            [-13.884002426483766, 5.803339928610067],
            [-13.877798775608383, 5.799791398216587],
            [-13.872033568235567, 5.795166990453776],
            [-13.86119455163553, 5.796667758352868],
            [-13.850660336387495, 5.793834829680312],
            [-13.843975057027931, 5.79425636911045],
            [-13.834384555723018, 5.791115369789318],
            [-13.830938414829367, 5.786521407563127],
            [-13.831025317228534, 5.777471155342307],
            [-13.840460600042546, 5.770463553810925],
            [-13.84074492980278, 5.767566771797881],
            [-13.835812345078352, 5.762216066457443],
            [-13.831199927898382, 5.760074739339068],
            [-13.825167701064087, 5.754017357256839],
            [-13.817858773832448, 5.752881608770205],
            [-13.814190510416813, 5.750669799001197],
            [-13.808548985912683, 5.750565065680457],
            [-13.802409676446002, 5.753678835319203],
            [-13.79756574626237, 5.748604688715772],
            [-13.789849276808424, 5.748682204728822],
            [-13.786666239777523, 5.747310950030028],
            [-13.7701545313506, 5.743195437589592],
            [-13.760343580936299, 5.744026322922355],
            [-13.752554320144082, 5.743728767703289],
            [-13.741107447466652, 5.745971869044197],
            [-13.733943066815648, 5.749830846365054],
            [-13.723813124214734, 5.750653020457478],
            [-13.715760861673695, 5.7485461324454725],
            [-13.709539592814679, 5.741142698847401],
            [-13.709697545980719, 5.7379777787703805],
            [-13.70634619846714, 5.728182158079089],
            [-13.69678810745148, 5.725082634374372],
            [-13.689872175062659, 5.7242380942979905],
            [-13.680055224276519, 5.71944342562371],
            [-13.675755546081001, 5.718740282676688],
            [-13.669647435921629, 5.72278435374585],
            [-13.656814290666514, 5.723233449124305],
            [-13.652561300888893, 5.7221079931414165],
            [-13.647998893290394, 5.71749235253592],
            [-13.642502941916268, 5.714445846283091],
            [-13.639499876335297, 5.708012596357033],
            [-13.634510952229027, 5.702565555004531],
            [-13.630624010455401, 5.700943054840984],
            [-13.62240974960806, 5.702804237978142],
            [-13.61132443860176, 5.698487892435641],
            [-13.602420849765446, 5.697008719818495],
            [-13.591592374245703, 5.6976762191737516],
            [-13.60786400440658, 5.619238407780705],
            [-13.616882958944872, 5.621106167676658],
            [-13.634010926960459, 5.539600722521895],
            [-13.485084069899267, 5.509434529800809],
            [-13.336166466501515, 5.479221349754824],
            [-13.353299357139989, 5.39481551920063],
            [-13.364090381858519, 5.342227112466335],
            [-13.373925640373862, 5.293373729186312],
            [-13.440957398643542, 4.965754188856554],
            [-13.449653123528124, 4.92329730600756],
            [-13.491193354153205, 4.720373952144766],
            [-13.644902095362921, 4.75180093810439],
            [-13.647344990394098, 4.752879855109436],
            [-13.69050772247273, 4.76109580987815],
            [-13.782950785804825, 4.780591259019899],
            [-13.875397193979856, 4.800070546617587],
            [-13.915681194920893, 4.809061191114107],
            [-13.993249597113465, 4.82500593246908],
            [-14.09218657125436, 4.8454747031213765],
            [-14.143816408854718, 4.856136770638951],
            [-14.219984748009061, 4.872182347881086],
            [-14.233353613523978, 4.8761831530517625],
            [-14.303992045292413, 4.891400658662102],
            [-14.425815893781039, 4.917378529908844],
            [-14.451783118264759, 4.921975426511769],
            [-14.522757144672598, 4.938133329828769],
            [-14.545044786209996, 4.943458410018657],
            [-14.605523464597471, 4.957088168159065],
            [-14.609025434748029, 4.957379129541589],
            [-14.637135378409369, 4.963557040986793],
            [-14.637647976291905, 4.964050829095016],
            [-14.722381260268776, 4.98321916340998],
            [-14.807117575388395, 5.0023737861913],
            [-14.883997628083016, 5.019903411444217],
            [-14.913058538814575, 5.0255141109891985],
            [-14.91923514899055, 5.028150946946971],
            [-14.92486600987085, 5.029971282100715],
            [-14.898773570926311, 5.145196961047391],
            [-14.89567778499254, 5.16055072046479],
            [-14.888070478072866, 5.192916489985554],
            [-14.845875823439721, 5.379507098231641],
            [-14.841459174727527, 5.400463045737311],
            [-14.830012477310783, 5.451209049419269],
            [-14.803162847191029, 5.57022267013895],
            [-14.787144119729161, 5.641215506329828],
            [-14.746697546589303, 5.8190441608463805],
            [-14.746546691853846, 5.8194535211898435],
            [-14.69879092753657, 6.031967765700701],
            [-14.634818466837654, 6.314911899014345],
            [-14.611564209578452, 6.417725016034443],
            [-14.584036752385039, 6.5394039989505925],
            [-14.571667509156171, 6.59410195632967],
            [-14.554184930495765, 6.670870001531256]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.16989478630207,
          "lat": 42.58141584895974
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16073"],
        "coty_name": ["Owyhee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Owyhee County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00399760"
      },
      "bbox": [
        -14.92486600987085, 4.720373952144766, -13.336166466501515,
        6.670870001531256
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.914837968220349, 3.6921451703449697],
            [6.024209152398331, 3.700916644050499],
            [6.075601422262175, 3.705298011770438],
            [6.114734916406931, 3.708273565520295],
            [6.157667164329145, 3.7119968912063475],
            [6.164965232231627, 3.7121361572620266],
            [6.171804546848111, 3.7133214844033633],
            [6.179165798331686, 3.6259365081853145],
            [6.160472617090667, 3.624299148855791],
            [6.167627426457318, 3.5437051484837014],
            [6.175107220445952, 3.4564144652272466],
            [6.180569381393734, 3.385902022307975],
            [6.182228036846631, 3.3660252365711343],
            [6.186690695874231, 3.317328806229663],
            [6.189747407203623, 3.281456440351097],
            [6.103580779015099, 3.272399391815058],
            [5.993919602505605, 3.261676750858771],
            [5.969146679914313, 3.259098980659887],
            [5.939086680715992, 3.256352187331901],
            [5.934614986328015, 3.31155627510796],
            [5.931781968202098, 3.3438381674207918],
            [5.925786894383899, 3.431276320811607],
            [5.919045069405461, 3.518960924276678],
            [5.911896581023805, 3.6040981594225685],
            [5.921912895317582, 3.6048715108756326],
            [5.917296599952955, 3.663565535146939],
            [5.914837968220349, 3.6921451703449697]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.42863656189787,
          "lat": 41.938845677286906
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17089"],
        "coty_name": ["Kane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kane County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00424246"
      },
      "bbox": [
        5.911896581023805, 3.256352187331901, 6.189747407203623,
        3.7133214844033633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.980412834255255, 2.17198932423897],
            [4.975366604559622, 2.260244101764198],
            [4.969021135158586, 2.3594944228662866],
            [4.964133969011873, 2.435628796565458],
            [5.050845280134141, 2.4417146269053775],
            [5.083351850126698, 2.4436280574638145],
            [5.136671021815952, 2.4462008351695643],
            [5.223268981996456, 2.4517129925297985],
            [5.252439557405875, 2.453279747461292],
            [5.308728002946808, 2.456889908342844],
            [5.366010174305236, 2.460950651993357],
            [5.3652867891731795, 2.4547135980289183],
            [5.366663767879593, 2.4467905226170457],
            [5.3623625851545516, 2.4336608457507305],
            [5.363642543268409, 2.4267476840601914],
            [5.362941699995284, 2.4226285960110365],
            [5.360460088760351, 2.4199036673163508],
            [5.356346821803931, 2.412094892913985],
            [5.3510642149448335, 2.4073679152202567],
            [5.349402312727436, 2.39802127759122],
            [5.346012600302966, 2.3934166436999433],
            [5.342244137152189, 2.3847717927012226],
            [5.338998573434337, 2.379396690447719],
            [5.338645048380388, 2.3713233513428937],
            [5.336684931995591, 2.363485272548748],
            [5.331627802662302, 2.3537254103945178],
            [5.317026130764959, 2.3399158666528717],
            [5.315312991636929, 2.336225827884991],
            [5.314318820312583, 2.328784280435863],
            [5.315945771981848, 2.3252612463017317],
            [5.307589834695536, 2.309704000571084],
            [5.306466525679463, 2.3037271563199764],
            [5.301795906324863, 2.298355607111892],
            [5.2996595979991, 2.2910363719418605],
            [5.294383224968715, 2.2801750711675095],
            [5.29244732285713, 2.262908417464376],
            [5.296460227595916, 2.254891875028849],
            [5.298418281608466, 2.2483824050878756],
            [5.300150393033679, 2.2343575453210645],
            [5.302440640668553, 2.228741180327868],
            [5.306238494650727, 2.2169279906369734],
            [5.306542642748644, 2.211172629285777],
            [5.309387177665982, 2.204321041088685],
            [5.3079402728060385, 2.1939371678209487],
            [5.305396788575482, 2.1831292214853018],
            [5.302234816458262, 2.178694070209338],
            [5.295587199605398, 2.1764432992020413],
            [5.288690363040975, 2.1726610248549716],
            [5.285057851680327, 2.1686211500246753],
            [5.277864848132357, 2.163315776155895],
            [5.269813798875436, 2.1530862240772604],
            [5.262822135595455, 2.142670206308338],
            [5.261154069752766, 2.1381919194997616],
            [5.26153671914009, 2.134679859977837],
            [5.265774777619213, 2.1299794025828445],
            [5.265120644000621, 2.124010368153987],
            [5.261983651641351, 2.1172985319289146],
            [5.256737012554009, 2.1104613158154795],
            [5.254036278871972, 2.105315680585658],
            [5.244137642668382, 2.093123235379346],
            [5.236735043911978, 2.0827406320020465],
            [5.233824055759164, 2.0776311835220196],
            [5.23265835406835, 2.0725332731520805],
            [5.234135315360044, 2.064062621036066],
            [5.238534558192481, 2.0535815929743446],
            [5.238102904945014, 2.0469715314148185],
            [5.235722469328675, 2.0421306778694057],
            [5.2293214348189645, 2.0335279473899432],
            [5.224081821573883, 2.0279977761873296],
            [5.219816406591519, 2.0258952184887287],
            [5.216677086696663, 2.026854339314618],
            [5.213615331358959, 2.03164079838235],
            [5.207193018859241, 2.034847353060163],
            [5.203372367588931, 2.0334138335669567],
            [5.199937486818253, 2.0298955545034683],
            [5.17122942673, 2.0208683618025463],
            [5.154672957491242, 2.02222077226659],
            [5.148934023563443, 2.0215857524760295],
            [5.1425287372062325, 2.0177222035654374],
            [5.1270258440448195, 2.0099687340949615],
            [5.121052632610517, 2.0074941812236715],
            [5.114365912371008, 2.002870364186821],
            [5.1066016795083895, 1.996214283026907],
            [5.0917452295705194, 1.9876985082857008],
            [5.078555642555503, 1.9771193946430075],
            [5.07633557759681, 2.0155288162107006],
            [5.074404266605911, 2.044897636331832],
            [5.072720612372375, 2.04506681800801],
            [5.0703786471391865, 2.0894797030918766],
            [4.9995611633192825, 2.0855286856399067],
            [4.983713086943468, 2.084810792923055],
            [4.9810794208252025, 2.1512355579756783],
            [4.980412834255255, 2.17198932423897]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.76004492697312,
          "lat": 40.788039364693724
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17143"],
        "coty_name": ["Peoria"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Peoria County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01784920"
      },
      "bbox": [
        4.964133969011873, 1.9771193946430075, 5.366663767879593,
        2.460950651993357
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.314233406625983, 0.5255067612519301],
            [7.376837139309157, 0.5300133625424011],
            [7.421086826514466, 0.5348541712274641],
            [7.4634629898256435, 0.5399104630852807],
            [7.471846426259571, 0.45278276704225373],
            [7.457496333011996, 0.4511298025738618],
            [7.461523074418218, 0.40863475634053986],
            [7.4714795508521625, 0.297695284426155],
            [7.477890213293598, 0.2309718815220477],
            [7.4865678031526235, 0.13755863595528445],
            [7.479730383428276, 0.1369131845621035],
            [7.477104919069018, 0.13554111338587724],
            [7.4747346819185365, 0.13017964600243587],
            [7.475535795331781, 0.12601917415014044],
            [7.469887761094673, 0.12084365617063632],
            [7.466052714994301, 0.12069040183877008],
            [7.462918170543003, 0.12300418695464588],
            [7.462041437526036, 0.1332670253062453],
            [7.452363269785222, 0.13314225942440922],
            [7.447875568731353, 0.13040907046193817],
            [7.440710152859186, 0.13280647402875598],
            [7.43201257521124, 0.1401426883638423],
            [7.427708674830231, 0.1358590748305933],
            [7.4241022119601086, 0.13457230741968462],
            [7.41744539682853, 0.1376642153573841],
            [7.412503185271622, 0.13303501779766683],
            [7.408300782887452, 0.13216930504531355],
            [7.401854025332381, 0.13641339489529647],
            [7.392781613879288, 0.13422171457644455],
            [7.389336264619346, 0.1314477737335639],
            [7.385923734773441, 0.12488478435982572],
            [7.381297374683134, 0.12283049363924838],
            [7.378364682540295, 0.12441811791413503],
            [7.3737227788569735, 0.13471943285676252],
            [7.37135985932431, 0.13609016771179472],
            [7.36865593023565, 0.13596733485981277],
            [7.363303958674571, 0.13250602257359523],
            [7.359870759945405, 0.13434336574021596],
            [7.3634919057248345, 0.14140940379316197],
            [7.355978006839987, 0.1422219765682036],
            [7.353073296948433, 0.1480647100260547],
            [7.347788685784653, 0.15385943330332025],
            [7.341969030502518, 0.15665899746024886],
            [7.336310423880323, 0.15531486121972973],
            [7.3331776429377715, 0.15113483039715087],
            [7.334091698812461, 0.1451089595127115],
            [7.330056177541796, 0.14260109761834372],
            [7.32447609253785, 0.14734028814899938],
            [7.321041991347178, 0.14883335481784032],
            [7.318782462245076, 0.14289195346759617],
            [7.322339257226484, 0.13600466108566153],
            [7.3197290883568344, 0.133974587559317],
            [7.310404933988624, 0.13150300598088663],
            [7.305948970945098, 0.1356376106905224],
            [7.3073486536933485, 0.13968390882801465],
            [7.304214926561545, 0.14502307754751378],
            [7.298673646218933, 0.14746655956489205],
            [7.293181208428949, 0.14709363309029716],
            [7.2919022070446236, 0.15290619338953643],
            [7.289058143232314, 0.15805072645596815],
            [7.280981203063155, 0.16192248495197803],
            [7.274307652825286, 0.1621022274563313],
            [7.269274957655561, 0.16400474280410157],
            [7.2639458340700775, 0.16358110593299405],
            [7.261778358353929, 0.16126361981621362],
            [7.257924906148278, 0.15262929467273426],
            [7.254483979384021, 0.14964239048780476],
            [7.249154783950245, 0.1509408170334105],
            [7.242705202442886, 0.15478475723467852],
            [7.237602075046394, 0.15426737723941322],
            [7.2405044793308555, 0.1620975687857939],
            [7.231649785243876, 0.16708998894520302],
            [7.232212597378847, 0.1697115889934658],
            [7.239243866275314, 0.17035723457243582],
            [7.237982289435057, 0.17522170581118698],
            [7.2310894823092315, 0.17854678821424946],
            [7.235336898930109, 0.18148952328658438],
            [7.238029200226389, 0.18553097342109848],
            [7.237736999418585, 0.19089472249916417],
            [7.230046652532095, 0.19230551526119966],
            [7.228014507765613, 0.19932675371048952],
            [7.230581269455612, 0.2049828935513603],
            [7.227567387441221, 0.20751954501024356],
            [7.22961265168972, 0.2131041888656585],
            [7.228044365436872, 0.21706623123191104],
            [7.221182082969038, 0.22113284857056087],
            [7.224612335369424, 0.2241883565470566],
            [7.229783028418328, 0.21986639757440216],
            [7.234027310526296, 0.22047765772582273],
            [7.233844906096425, 0.2244683361278195],
            [7.230909747663779, 0.22956441843417297],
            [7.224821152813299, 0.23488751277531983],
            [7.221195953124709, 0.24049207508553924],
            [7.22450929572128, 0.24494536131876865],
            [7.2306310244921, 0.2420469352883457],
            [7.2335825487218655, 0.24466020982716075],
            [7.22902904876053, 0.24725912922295828],
            [7.227295414557582, 0.25395690488176675],
            [7.222191319152975, 0.2544934556423475],
            [7.220246870930457, 0.25686019485612066],
            [7.22168672887385, 0.26238167070629687],
            [7.228761029373532, 0.2575228327415106],
            [7.229769096492214, 0.2680444032614437],
            [7.228566946714215, 0.2707908430350149],
            [7.217896754129604, 0.26332980994878796],
            [7.213944652502337, 0.2702306910653891],
            [7.216344797605382, 0.27508212148946826],
            [7.221970330581947, 0.28296730186940605],
            [7.222385785351317, 0.28738018739583027],
            [7.2174628140336905, 0.28625739515000526],
            [7.216047740782263, 0.27934503556143914],
            [7.2120228062303084, 0.27565185018688365],
            [7.2087704233394785, 0.2834134074865003],
            [7.201583890926627, 0.2877280542012503],
            [7.201374791241417, 0.291195944554081],
            [7.2077736754693555, 0.2929465030669623],
            [7.2082980251903015, 0.29669900545196176],
            [7.201527785398228, 0.2969360845188548],
            [7.195465581083606, 0.2993338280986979],
            [7.19521968383479, 0.30145781810192357],
            [7.200027470381504, 0.3044698205358381],
            [7.203951644230409, 0.30914077185553684],
            [7.201221552486175, 0.31670209390702747],
            [7.204969305538874, 0.31965744339220775],
            [7.205902649215447, 0.32445856765360553],
            [7.209941480864373, 0.3280879884886203],
            [7.2096128433374975, 0.3310195716204204],
            [7.204428920732083, 0.3391817954111904],
            [7.211340871537872, 0.33941979532517513],
            [7.214738151831639, 0.33537213860340753],
            [7.216735313229256, 0.338884526432873],
            [7.210151675611136, 0.34215027772647433],
            [7.210353368760877, 0.3451520735263908],
            [7.214049224782064, 0.3516228489926415],
            [7.220055877777899, 0.3509010743462712],
            [7.221904455671797, 0.3539060972779552],
            [7.216636392342052, 0.3556784916552695],
            [7.216590104414939, 0.358799376167217],
            [7.210184696809824, 0.36401712153897753],
            [7.209563139113019, 0.36648257124313954],
            [7.215922812903259, 0.3710345296317612],
            [7.219281088998358, 0.3768975381866033],
            [7.21598615174155, 0.3793217085751689],
            [7.2089168807514, 0.3744425835110469],
            [7.204755496735746, 0.3780415702974395],
            [7.204650306389273, 0.38616704728590207],
            [7.207274350317883, 0.38942474665251464],
            [7.215253020769732, 0.3897315888210688],
            [7.216910442073105, 0.39191578324843723],
            [7.216310316093393, 0.40041335647916915],
            [7.213613422368809, 0.4085579366487937],
            [7.214752956099912, 0.41138376650024133],
            [7.209726948741879, 0.41814912513244407],
            [7.211898330051047, 0.4218935658995973],
            [7.213789715160162, 0.43024914636737444],
            [7.217012329834139, 0.42959900326663664],
            [7.215297564455037, 0.4230837909604282],
            [7.220393255670585, 0.424901596630713],
            [7.224923168264294, 0.4231934445107895],
            [7.2235886109781875, 0.41811857012610604],
            [7.226975762869317, 0.4171636054773885],
            [7.228420673109976, 0.42267669250273865],
            [7.233332879826867, 0.4253271512696176],
            [7.230169278496963, 0.43154996780433436],
            [7.231715262758248, 0.4363495283648137],
            [7.235857827877334, 0.43395216221032634],
            [7.235316891555846, 0.4207969398002122],
            [7.242381197338787, 0.43002068854254705],
            [7.240213461042033, 0.43425582663739964],
            [7.2410497837266, 0.4391966512508469],
            [7.245568887732729, 0.4383213206668056],
            [7.2483800353673695, 0.42952417416314087],
            [7.250845826790188, 0.42904347053615083],
            [7.2524099013994245, 0.4347528295014823],
            [7.2515872540628274, 0.43830860749888245],
            [7.245934286466222, 0.44062767625290417],
            [7.245759544999272, 0.44426901219575593],
            [7.249863571025531, 0.4453814371822308],
            [7.254266038120158, 0.44155108503510504],
            [7.253756625077777, 0.4494861444585806],
            [7.256780270410469, 0.44936585016938374],
            [7.260397102171145, 0.4456787584617929],
            [7.26524102777115, 0.44701508229701875],
            [7.26279227464008, 0.4506616561789671],
            [7.2633859402207746, 0.45484408176896035],
            [7.259425777671586, 0.4580102636081412],
            [7.255795417305246, 0.45752740441492135],
            [7.252866097964947, 0.4595192397287655],
            [7.254398409034036, 0.4625841801575181],
            [7.261459322290241, 0.4605572212283263],
            [7.264623294311893, 0.46302601438418856],
            [7.269550922517689, 0.46105866175826227],
            [7.276925730883288, 0.46037559656698923],
            [7.281601675691774, 0.45593351116683717],
            [7.285019686912238, 0.45743012880219786],
            [7.287836974594903, 0.46172130713618664],
            [7.286184457789272, 0.4651941572342068],
            [7.288013513238715, 0.4685584275150149],
            [7.284735864820462, 0.47302626424339844],
            [7.286180862829091, 0.4763454741908274],
            [7.285306621083943, 0.48293829521010073],
            [7.2947335133308595, 0.4774425883556792],
            [7.288800692968448, 0.4906615509364076],
            [7.292560372801447, 0.49413966094241707],
            [7.295161721835726, 0.48986244671882473],
            [7.299401376051724, 0.4896287258167126],
            [7.300618771868067, 0.4946133812113901],
            [7.297673660852881, 0.49732493812504625],
            [7.295542230039809, 0.502835541759243],
            [7.2926538252188955, 0.5030275412822701],
            [7.29214435200147, 0.5083543732141351],
            [7.295782573076913, 0.5106450474401864],
            [7.30138022898379, 0.5069053342640404],
            [7.3038307310562125, 0.5110027282000031],
            [7.299698190914532, 0.5123859253893532],
            [7.296426872385454, 0.5154623605754013],
            [7.300630948108562, 0.519169227807893],
            [7.3031506082157165, 0.5154485378759646],
            [7.308253911299861, 0.5163845541281652],
            [7.308751225701027, 0.5205311347370809],
            [7.31226626754278, 0.522135784043827],
            [7.315166491087492, 0.5186722650814563],
            [7.320307876410452, 0.5195549260855269],
            [7.32077961631565, 0.5223849836694636],
            [7.317601740350195, 0.5250940821441431],
            [7.314233406625983, 0.5255067612519301]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.07209755304137, "lat": 38.70243758035259 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18027"],
        "coty_name": ["Daviess"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Daviess County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00450343"
      },
      "bbox": [
        7.19521968383479, 0.12069040183877008, 7.4865678031526235,
        0.5399104630852807
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.835126495749868, 1.9070232219454977],
            [7.92118683475734, 1.9173288556258],
            [8.042849544661172, 1.9311945410066473],
            [8.121437825211688, 1.9402281370799905],
            [8.121726246589255, 1.9334081597347683],
            [8.123681605590356, 1.9134073215065295],
            [8.129613648146128, 1.8570997604342425],
            [8.129407980826102, 1.853919243152947],
            [8.139373718195621, 1.7660199516456376],
            [8.141196278805715, 1.7522820054985515],
            [8.146344642761163, 1.7052886633318811],
            [8.149457504174778, 1.6790095597662857],
            [8.150573710642016, 1.664074559181029],
            [8.152221387888899, 1.6493625698411234],
            [8.121764771964875, 1.6457118022727681],
            [8.095601501434311, 1.641493278419472],
            [8.071047048694755, 1.6386031460984332],
            [8.038293849545187, 1.6356753522371157],
            [8.026173786778063, 1.6341268454047593],
            [7.981431223619866, 1.6292005726383927],
            [7.948005466362283, 1.625702332783284],
            [7.938188163583888, 1.6249777214531558],
            [7.895008967234092, 1.6199490066677942],
            [7.866609880385625, 1.6164471524068094],
            [7.8609978735937505, 1.6676211835585693],
            [7.858840059913795, 1.68938290406442],
            [7.851091605104926, 1.7616403074637388],
            [7.8429172988594456, 1.8371526974609846],
            [7.8390361449285955, 1.8718859306847089],
            [7.835126495749868, 1.9070232219454977]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.05202078603291, "lat": 40.07246798387864 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18057"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00450356"
      },
      "bbox": [
        7.835126495749868, 1.6164471524068094, 8.152221387888899,
        1.9402281370799905
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.104916122587463, 3.498630065069532],
            [8.143340973260873, 3.5028078354917707],
            [8.209013124221348, 3.510474180101201],
            [8.210717732094482, 3.5104997177650996],
            [8.31134540972757, 3.5222263394980633],
            [8.375314388389617, 3.5295094734762515],
            [8.445528129836179, 3.537243905711975],
            [8.44935412440333, 3.5091292315746996],
            [8.453073667492166, 3.4778945263795538],
            [8.465706593343993, 3.3773419532311952],
            [8.471874317142602, 3.325484319896439],
            [8.474175501174878, 3.3043326462309426],
            [8.427700221135655, 3.2990197851460414],
            [8.354065310577793, 3.290373784197891],
            [8.304912092600162, 3.2843920322264357],
            [8.262185227894344, 3.2794027570632847],
            [8.205400727904063, 3.2724570266268866],
            [8.134403792660468, 3.2633033230109074],
            [8.127180339051169, 3.321388315891039],
            [8.123405311894942, 3.350340871121413],
            [8.115305400506214, 3.4153668766920116],
            [8.111665143421284, 3.4436298847957594],
            [8.104916122587463, 3.498630065069532]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.42648289658459,
          "lat": 41.642617160972705
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18087"],
        "coty_name": ["LaGrange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["LaGrange County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00450368"
      },
      "bbox": [
        8.104916122587463, 3.2633033230109074, 8.474175501174878,
        3.537243905711975
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.63325445123059, 0.5569083784080235],
            [7.625028568610998, 0.6450765946292321],
            [7.691378154755634, 0.6512305279486059],
            [7.697354210411004, 0.6520319721511441],
            [7.773698414807928, 0.6593607518820818],
            [7.860578109779402, 0.666896330351022],
            [7.9046091420407425, 0.6715573226641762],
            [7.932992868461244, 0.674624692285064],
            [7.935212382185555, 0.6589714615101501],
            [7.9434904537707745, 0.5869989572691642],
            [7.9439171198180745, 0.5860125934695661],
            [7.949095547470954, 0.5428771885218894],
            [7.960338978077249, 0.4468027838963622],
            [7.957048272987162, 0.4457291187948419],
            [7.952571568917386, 0.4371671739624149],
            [7.952225089723536, 0.42976484720402675],
            [7.950023396989194, 0.4241718642080955],
            [7.9515519887806905, 0.418017345185137],
            [7.950406358506635, 0.4166555327788155],
            [7.942518301556006, 0.4165762241390417],
            [7.936774386811179, 0.41326416014469947],
            [7.937408092854252, 0.41083520429922155],
            [7.942445529802952, 0.36813977817146454],
            [7.91388416184605, 0.3656452457677282],
            [7.870885127777338, 0.3604299235228869],
            [7.8295613513096995, 0.35608998054840224],
            [7.82598479038526, 0.3568794984414952],
            [7.795337282440747, 0.3531246163843119],
            [7.725692933702238, 0.34525847452207326],
            [7.6992700406588925, 0.34263076875717446],
            [7.654619916666204, 0.33769945495640386],
            [7.65092914088021, 0.3731047382676034],
            [7.645863399111164, 0.4243872214822432],
            [7.637258352379671, 0.5132113587483049],
            [7.63325445123059, 0.5569083784080235]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.48345837532258, "lat": 38.84117149104014 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18093"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00451703"
      },
      "bbox": [
        7.625028568610998, 0.33769945495640386, 7.960338978077249,
        0.674624692285064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.225507998697581, 2.815115528432914],
            [7.3115898122213725, 2.823069297841606],
            [7.334861926905224, 2.82465689178839],
            [7.354531527363348, 2.827331579644751],
            [7.4264762988600435, 2.834363876836003],
            [7.510135458171818, 2.8425272811514093],
            [7.56973573433448, 2.847983615285481],
            [7.58015013076774, 2.7423933768236752],
            [7.5874147849397025, 2.665775294662601],
            [7.5950515857774095, 2.58577703284121],
            [7.571550585422378, 2.5834479885693917],
            [7.510664851885906, 2.5783938882676263],
            [7.42461447773587, 2.5712208819815863],
            [7.365587171704705, 2.565687924353742],
            [7.2500376444621635, 2.5545019677552663],
            [7.243675240940595, 2.6195265864259505],
            [7.236317640805961, 2.6987871043874434],
            [7.225507998697581, 2.815115528432914]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.69876418595003,
          "lat": 41.041856698804814
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18131"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00446852"
      },
      "bbox": [
        7.225507998697581, 2.5545019677552663, 7.5950515857774095,
        2.847983615285481
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6298853507256426, 4.270750549000279],
            [2.716027021397277, 4.2733180882428785],
            [2.7798599914885624, 4.275210150706097],
            [2.900486011599478, 4.279272220401369],
            [2.9726717796485995, 4.281862599704447],
            [2.9757693555705913, 4.192802292830405],
            [2.978430138415367, 4.118969217814555],
            [2.979696097456411, 4.076896447855563],
            [2.980592275299831, 4.060048890892781],
            [2.9821218437582075, 4.016350509559311],
            [2.9830689475390875, 3.995050297949719],
            [2.984915527803566, 3.936847365999719],
            [2.9854155326914817, 3.9296212636142442],
            [2.933558708617365, 3.9277018812692397],
            [2.8125175743901347, 3.9235707125718955],
            [2.7694037300127827, 3.9222245083979517],
            [2.72668819307375, 3.921086683961139],
            [2.6979057653044536, 3.9205307795485016],
            [2.6395700023191737, 3.918926327170926],
            [2.637236986365945, 4.005690331712425],
            [2.6338386414297497, 4.129641079964478],
            [2.6298853507256426, 4.270750549000279]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.7901662185611, "lat": 42.73154058089467 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19023"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00465201"
      },
      "bbox": [
        2.6298853507256426, 3.918926327170926, 2.9854155326914817,
        4.281862599704447
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.238679237503182, 3.196795822640561],
            [4.287334929949261, 3.1995860021440334],
            [4.321591456504953, 3.2012694356797433],
            [4.32363130758883, 3.1982070335070305],
            [4.3285598518773565, 3.197532617448234],
            [4.340049790436896, 3.1936665409650473],
            [4.347182769035264, 3.1841497354228903],
            [4.34735965351469, 3.180149868896125],
            [4.350352215389287, 3.175719040821566],
            [4.354719515125256, 3.1730296008145005],
            [4.360312153678803, 3.172378839828677],
            [4.363863920656458, 3.1693858486600694],
            [4.367583974548884, 3.1745347652523166],
            [4.372494708024751, 3.1692953216277195],
            [4.377101606324574, 3.167269288881216],
            [4.377889176046594, 3.1716100536330942],
            [4.381861432936074, 3.1732455636747834],
            [4.385621858893128, 3.170917087846214],
            [4.388725858628015, 3.176429831669168],
            [4.393082993433465, 3.176773678630048],
            [4.390760456725018, 3.1824874888327996],
            [4.395055964225685, 3.185605661939158],
            [4.39780961312539, 3.190621602017189],
            [4.399754657662471, 3.188655973633694],
            [4.404171497085184, 3.196321138607529],
            [4.4094691720310575, 3.1991970933914766],
            [4.414362793866636, 3.2003924879426995],
            [4.41719017217667, 3.1992365428512453],
            [4.4185127228608865, 3.1930211953500542],
            [4.421783018683798, 3.1908304075059526],
            [4.426657384789183, 3.1931761235460447],
            [4.4284640326698925, 3.197308834492013],
            [4.432943860665296, 3.196983083982224],
            [4.436896857717768, 3.201625997529163],
            [4.4447634211500535, 3.1982260469761186],
            [4.447018780465376, 3.1940697898382764],
            [4.45048818894679, 3.195192153810671],
            [4.451328057740107, 3.201043943894288],
            [4.4575541539580605, 3.199927110497109],
            [4.460470915559836, 3.201591881267109],
            [4.4615946467258905, 3.2052958037193493],
            [4.464874299773171, 3.208535934222151],
            [4.467422881186499, 3.2074447209471297],
            [4.467738500053058, 3.2024221647440827],
            [4.471416381317737, 3.2014809729261597],
            [4.475357350009874, 3.197536437243887],
            [4.485592643765817, 3.204873098776793],
            [4.489508214666554, 3.2028824912077285],
            [4.494162915770441, 3.204140363666811],
            [4.49726081588661, 3.2089716238405153],
            [4.501809622070433, 3.2058905930252717],
            [4.50469229194392, 3.216004327293177],
            [4.522000231057929, 3.210454715655927],
            [4.525234956085198, 3.2073678721974543],
            [4.528333435914407, 3.21100065927035],
            [4.531492230645048, 3.2088316105018224],
            [4.536572815747315, 3.2078620578857624],
            [4.540979410940949, 3.2095721893321265],
            [4.543676979131329, 3.208762319058253],
            [4.548594971511822, 3.214510646601385],
            [4.554815903016854, 3.216187990368002],
            [4.557480410446562, 3.2120820216064923],
            [4.557049028213641, 3.2059278737993275],
            [4.559594926412397, 3.202298601993693],
            [4.564010632742426, 3.2015431471546205],
            [4.569266301545516, 3.2079435053782817],
            [4.573059417313839, 3.207925135381982],
            [4.578109139123844, 3.2029212959243694],
            [4.582619595412072, 3.2014541105328784],
            [4.588909270586968, 3.1975855251136336],
            [4.590499758581198, 3.1940906133634765],
            [4.5885562942930145, 3.190543657058644],
            [4.591791723752539, 3.185572196017346],
            [4.590790791931333, 3.181020350925718],
            [4.599895842171718, 3.1864369592488764],
            [4.6028426106996125, 3.1751811700197403],
            [4.606837312974748, 3.175414168342423],
            [4.610103354951075, 3.1776561232228935],
            [4.6171640391830175, 3.1769851072873534],
            [4.61674348418487, 3.183388332786912],
            [4.622856316795187, 3.183053994188142],
            [4.628092965689378, 3.1813573233197214],
            [4.6354986480355675, 3.175420110788045],
            [4.641037721159575, 3.175590401641601],
            [4.640623801652683, 3.179090828953852],
            [4.6446040493051886, 3.179950915860286],
            [4.647299721114287, 3.1780613913208917],
            [4.650040100199588, 3.181843042172937],
            [4.65140046292616, 3.1878684457506776],
            [4.657829007869493, 3.1882996263942367],
            [4.661808805592332, 3.183514453544904],
            [4.6657468762734835, 3.1828052194254526],
            [4.671412554963752, 3.1785099268607073],
            [4.671261588411617, 3.167867291122678],
            [4.674826958559661, 3.1591727351660706],
            [4.675659618994524, 3.152099444835354],
            [4.674699122450202, 3.144386664755887],
            [4.671132284543763, 3.139024499834681],
            [4.663859742055145, 3.1327782406994684],
            [4.660939701053882, 3.1281747203631705],
            [4.660210463878995, 3.112986203110385],
            [4.656287794033364, 3.0950410136624367],
            [4.65674394485914, 3.0889158446514045],
            [4.662091122410317, 3.0466756810537476],
            [4.659997419929906, 3.035664378356133],
            [4.6450014578937155, 3.026507781562976],
            [4.63243351203075, 3.0227397155266704],
            [4.62039210936104, 3.017593713654808],
            [4.609757789596039, 3.010012400387078],
            [4.6076761835048545, 3.0074707842968587],
            [4.603446496570564, 2.9984523986925447],
            [4.595939064724127, 2.993274426383022],
            [4.587460508742232, 2.9792702296275437],
            [4.576186445283997, 2.9659104195670225],
            [4.56684137432623, 2.9615357959493633],
            [4.555357390852749, 2.959357067809613],
            [4.547432411676817, 2.9586965497940185],
            [4.538072590942985, 2.95966784247666],
            [4.522998372140166, 2.964242969736936],
            [4.517069605298842, 2.9651119382457947],
            [4.505831537240281, 2.962551207636283],
            [4.498057741728442, 2.955352560389842],
            [4.4872171272133325, 2.9523145662515],
            [4.477659243436073, 2.947637497379456],
            [4.47282639864108, 2.9423226293118554],
            [4.4706816386497765, 2.9303056477925598],
            [4.461856520992594, 2.92053107410285],
            [4.451824027023907, 2.913612879191957],
            [4.446415644546075, 2.907863977455006],
            [4.43946339094825, 2.899105039275342],
            [4.435469598082332, 2.895956858711317],
            [4.4278333328800565, 2.8940158166500174],
            [4.4202492653391126, 2.893792332304282],
            [4.409710777756824, 2.8889800081416075],
            [4.4022382149312005, 2.886647682129463],
            [4.385755910778205, 2.883215693971296],
            [4.3754845268647795, 2.8805081736099893],
            [4.3661519419440875, 2.879493174335799],
            [4.345684462663243, 2.8800080351949546],
            [4.33913488139697, 2.8812886779127656],
            [4.3359792416517875, 2.959871693620332],
            [4.333028543380286, 3.025734246105308],
            [4.254897437515729, 3.0218530861433153],
            [4.24700214644833, 3.0216740285746058],
            [4.242861754633724, 3.109163324563515],
            [4.238679237503182, 3.196795822640561]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.6232834741646, "lat": 41.63709213420416 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19163"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00465270"
      },
      "bbox": [
        4.238679237503182, 2.879493174335799, 4.675659618994524,
        3.216187990368002
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7910563058015877, 3.188968916251466],
            [0.8632264541511814, 3.1890549345459367],
            [0.9007207524919407, 3.189428622535586],
            [0.9271269956076591, 3.190132612681564],
            [0.9637111947759303, 3.1907460972229953],
            [1.0485224278479823, 3.190898854032079],
            [1.134403693762264, 3.1913279514193698],
            [1.1348969895073115, 3.1260212027081367],
            [1.1349067677611535, 3.1043938921185172],
            [1.1358642247471806, 3.0152700436303808],
            [1.1365152832620358, 2.9864771257357163],
            [1.1371695147333096, 2.928443053398622],
            [1.175586606626301, 2.9289174629308037],
            [1.176561483310714, 2.830833220149866],
            [1.0918793739554316, 2.830554713190004],
            [0.9923316365946819, 2.830205540975608],
            [0.8802345774790896, 2.829681919570799],
            [0.8367849381944382, 2.8296175147347626],
            [0.8363738928124143, 2.9094472631224657],
            [0.8364239854441935, 2.926495360657768],
            [0.7916388285015875, 2.9263235415923177],
            [0.7917156600825709, 2.940898564200716],
            [0.7913780310102922, 3.0463176730109103],
            [0.791502998238939, 3.079090361447128],
            [0.791276724193738, 3.156150512951933],
            [0.7910563058015877, 3.188968916251466]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.31017194610916, "lat": 41.68508032941319 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19165"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00465271"
      },
      "bbox": [
        0.7910563058015877, 2.8296175147347626, 1.176561483310714,
        3.1913279514193698
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1888297521915199, -0.3109825279395806],
            [1.2318085104005203, -0.31104036730033613],
            [1.3538050748604356, -0.31022168826432556],
            [1.3554543993548578, -0.31033002143435656],
            [1.4470629470873244, -0.30890927626533843],
            [1.4825541269548668, -0.3086498159128653],
            [1.5400946663926867, -0.30793228093954966],
            [1.5404244287840794, -0.33247924933005335],
            [1.5416512416102148, -0.3825266346412428],
            [1.543095332199839, -0.4806496108103408],
            [1.5431630179551517, -0.5491995823839299],
            [1.5443291624115925, -0.6397817111526356],
            [1.544725174396295, -0.6630013911058943],
            [1.523241674684776, -0.6635855920754312],
            [1.4670557964814368, -0.6640432027384827],
            [1.4526454089189071, -0.6639005676954478],
            [1.4382988363188862, -0.6643894862701307],
            [1.4105297973058712, -0.6642787792616894],
            [1.3236590641272754, -0.6656615756020435],
            [1.3097927765875395, -0.665568676067943],
            [1.280814800244052, -0.666369369926603],
            [1.2672397691031292, -0.666008806394005],
            [1.1829318258092911, -0.6667393736923161],
            [1.1829922137766082, -0.6079830026774055],
            [1.183219016855989, -0.6074223726616073],
            [1.1823872847642538, -0.5203627998810169],
            [1.1828074926819117, -0.4508200448212627],
            [1.1826459128687268, -0.4435639785487556],
            [1.1906989427538557, -0.44355185215103515],
            [1.189266241122643, -0.35515224101045584],
            [1.1888297521915199, -0.3109825279395806]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.84297499228366, "lat": 38.21226651785838 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20107"],
        "coty_name": ["Linn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Linn County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00485018"
      },
      "bbox": [
        1.1823872847642538, -0.6667393736923161, 1.544725174396295,
        -0.30793228093954966
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8353590739864636, -0.977211680246519],
            [0.8781001177005476, -0.9770355318974885],
            [0.9141653580087389, -0.9764878127881966],
            [0.9157418407206365, -0.9767316907743436],
            [0.950253655336567, -0.9764010645377248],
            [1.0211562849621985, -0.9762088684360882],
            [1.0636816723918021, -0.9759520174613484],
            [1.1140971608193262, -0.9752348272539518],
            [1.120993190793373, -0.9737990315051113],
            [1.1490138226267133, -0.9738088910590695],
            [1.1562901037908517, -0.9752743081035684],
            [1.1779294429669855, -0.9749991730576941],
            [1.1785458404303355, -1.033513065578124],
            [1.1795171917772471, -1.1142006293457427],
            [1.1793067072890575, -1.1472265451837917],
            [1.1797778480548617, -1.1948638708062236],
            [1.1807645009237733, -1.2386374420541293],
            [1.1812230943087731, -1.3269694227517774],
            [1.1263827520927574, -1.3269806313941597],
            [1.0406421531703751, -1.3280009290491304],
            [0.9521754784105285, -1.3286308646741285],
            [0.8405552206390572, -1.3293066713136692],
            [0.837069408891911, -1.3293352532700733],
            [0.8366488501333069, -1.2589631873838618],
            [0.8369154483526116, -1.2048859724155794],
            [0.8364188993732683, -1.1806500926264065],
            [0.8365356995601325, -1.1529499127685325],
            [0.8355510905343666, -1.0942136819370303],
            [0.8353590739864636, -0.977211680246519]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.30677662678174,
          "lat": 37.558479417865826
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20133"],
        "coty_name": ["Neosho"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Neosho County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00485030"
      },
      "bbox": [
        0.8353590739864636, -1.3293352532700733, 1.1812230943087731,
        -0.9737990315051113
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.6414144512393576, 1.4300000632976437],
            [-3.5754567463542752, 1.4266072794563898],
            [-3.5526937897397866, 1.4251964128999006],
            [-3.4577368332249394, 1.4199540362058156],
            [-3.375595450540829, 1.4152884314315888],
            [-3.282450458410086, 1.4102227253816777],
            [-3.147050415012653, 1.403470713857097],
            [-3.1318884507187117, 1.402638427109348],
            [-3.134862677756303, 1.3525020962552001],
            [-3.139379660233474, 1.2735642780384349],
            [-3.139952624052726, 1.26568771676982],
            [-3.146315397737433, 1.1402218200933165],
            [-3.151097992590317, 1.052555003541038],
            [-3.1552900886040747, 0.9651390769289601],
            [-3.212453157786008, 0.9678886632827821],
            [-3.234542429623672, 0.9688180579228229],
            [-3.257924145776124, 0.9701944480449994],
            [-3.3257976137161402, 0.9738661897116365],
            [-3.3827558610745023, 0.9768387309964174],
            [-3.439939474424774, 0.9799450975556794],
            [-3.4929156534836334, 0.9831095031066974],
            [-3.521968399611319, 0.9845606968710117],
            [-3.6036779103550765, 0.9891665831039768],
            [-3.649584232495439, 0.9918311295193522],
            [-3.6685277154603737, 0.9929006322776487],
            [-3.6417000398719965, 1.4276240262894926],
            [-3.6414144512393576, 1.4300000632976437]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.07646813636534,
          "lat": 39.785206627439266
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20153"],
        "coty_name": ["Rawlins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rawlins County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00485040"
      },
      "bbox": [
        -3.6685277154603737, 0.9651390769289601, -3.1318884507187117,
        1.4300000632976437
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1395323562708572, 0.9643451456878989],
            [-3.054759741988578, 0.9601121122761007],
            [-2.9365846855680844, 0.9540861376050224],
            [-2.926680377297791, 0.9533647391995055],
            [-2.8988711907238183, 0.9524093470535783],
            [-2.8135294133309867, 0.9484437081116519],
            [-2.7811960372247446, 0.9464977315051429],
            [-2.7277512506260133, 0.9438967796861014],
            [-2.7134789788142863, 0.9436610845481281],
            [-2.7164297725757383, 0.8848950948936433],
            [-2.721489846242312, 0.7678772046874898],
            [-2.7282353782944626, 0.6364237340278509],
            [-2.7290583870456535, 0.6215372983990125],
            [-2.7346546801871905, 0.5048585654605677],
            [-2.81772918398423, 0.509314970643997],
            [-2.905585782014929, 0.5136089339208489],
            [-2.9303561803891385, 0.514559164110075],
            [-2.9482562014617657, 0.515634764847774],
            [-3.047543580209789, 0.5201101010676038],
            [-3.1621461951131793, 0.5261790944024106],
            [-3.159374778870824, 0.5845650849648408],
            [-3.1556062102711726, 0.6574410112222494],
            [-3.150585809997218, 0.7531250671134513],
            [-3.1485818335136724, 0.7889775194203313],
            [-3.144055823388066, 0.8772305874850743],
            [-3.139515194326597, 0.9615370925404266],
            [-3.1395323562708572, 0.9643451456878989]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.44185537097748, "lat": 39.3503482153428 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20179"],
        "coty_name": ["Sheridan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sheridan County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00485052"
      },
      "bbox": [
        -3.1621461951131793, 0.5048585654605677, -2.7134789788142863,
        0.9643451456878989
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8941558866826944, -0.6705755677257084],
            [-1.8662707432091208, -0.6714703638757678],
            [-1.8091336469296475, -0.673013775085186],
            [-1.807333115515424, -0.6146227356166188],
            [-1.803150888783928, -0.49732466046949253],
            [-1.8006379994937207, -0.4099659179828256],
            [-1.7012739349199753, -0.41316713608993355],
            [-1.6360022001975405, -0.4150754474879918],
            [-1.5438586290281842, -0.4173621554418504],
            [-1.5014133635487001, -0.4185347044850419],
            [-1.4642950199586862, -0.41981069874838445],
            [-1.458541120788582, -0.4200101293080593],
            [-1.4611299490536351, -0.5088174819696517],
            [-1.4631959722565668, -0.5968034372262015],
            [-1.4653282176125368, -0.6845633873233288],
            [-1.4673246067766614, -0.7724607675968834],
            [-1.468503741854384, -0.8163399365334878],
            [-1.4698588869465419, -0.860365518157957],
            [-1.5559492063925577, -0.858268931484654],
            [-1.6146834490704964, -0.8565708849623788],
            [-1.7279870551021337, -0.8524330732683646],
            [-1.7798112925324474, -0.85088765734785],
            [-1.8140400786831883, -0.8497171369820614],
            [-1.8928770061776896, -0.8473084380081438],
            [-1.9001541122057901, -0.8470550865489557],
            [-1.8975776176085688, -0.7732503648477672],
            [-1.8941558866826944, -0.6705755677257084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.71741205350074,
          "lat": 38.030966445720644
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20185"],
        "coty_name": ["Stafford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stafford County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00485054"
      },
      "bbox": [
        -1.9001541122057901, -0.860365518157957, -1.458541120788582,
        -0.4099659179828256
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.421024140390063, -1.7343051109292045],
            [6.449467831236895, -1.7316706344764818],
            [6.464079422724293, -1.731452086735505],
            [6.478060372312062, -1.7294173467235676],
            [6.4926432411072765, -1.7286873182759628],
            [6.568392419589794, -1.7227923610365978],
            [6.607874461158598, -1.7198984396356298],
            [6.628564367416474, -1.7178591111449437],
            [6.687269199138841, -1.7144610231050772],
            [6.697696272192702, -1.7135721136498037],
            [6.716012856637085, -1.7144515424938789],
            [6.717814581906869, -1.713430856550966],
            [6.726734275382796, -1.728061643431656],
            [6.740115217277254, -1.7434697786628073],
            [6.74740436634572, -1.7559437289156226],
            [6.75346336678544, -1.7706747153292384],
            [6.7554952046045, -1.780193727200703],
            [6.758880973739128, -1.7985134735912465],
            [6.76264417031741, -1.8072038793162337],
            [6.767889070720297, -1.8143990142486603],
            [6.770887027227541, -1.821848838316118],
            [6.771222135170327, -1.8271217142677787],
            [6.781951264893076, -1.854105211333327],
            [6.786655010782693, -1.8727632054017935],
            [6.7888579126594575, -1.8840607776940357],
            [6.792962222979736, -1.8949019336569661],
            [6.797229935912164, -1.9158817681911466],
            [6.796733371977699, -1.925584936043338],
            [6.794653887233988, -1.9359908864476782],
            [6.795265482701825, -1.9431941042498067],
            [6.79424002737592, -1.9467651484998822],
            [6.790154140876047, -1.9535138241214276],
            [6.784402336641367, -1.9610328442504188],
            [6.7254931733765595, -1.9645169496385155],
            [6.686822211140475, -1.967233542837435],
            [6.563889457282864, -1.9757361244487448],
            [6.495960694675151, -1.9809675512448046],
            [6.438217359715151, -1.9852443341664423],
            [6.431971194781449, -1.896676201562661],
            [6.430473542782702, -1.8736504156436928],
            [6.421024140390063, -1.7343051109292045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.27227313163249, "lat": 36.62103742823175 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21035"],
        "coty_name": ["Calloway"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calloway County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00516864"
      },
      "bbox": [
        6.421024140390063, -1.9852443341664423, 6.797229935912164,
        -1.713430856550966
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.634465032685826, -0.7953888437765484],
            [8.637804156073084, -0.7994461792474986],
            [8.647685240426704, -0.8001447478875593],
            [8.650024480215663, -0.8039684599987678],
            [8.657282815559697, -0.8046125553115969],
            [8.661602903357275, -0.803326218278768],
            [8.666478813193484, -0.8041155449144722],
            [8.667559248940814, -0.8066576962046933],
            [8.672566917816477, -0.8048437373732997],
            [8.678912986223873, -0.8065861958744726],
            [8.679520747425796, -0.7991550415565101],
            [8.688204151726293, -0.791498286042889],
            [8.687187775795895, -0.7859067203105586],
            [8.693899233289994, -0.7813880731001968],
            [8.69615139037102, -0.7759928943519455],
            [8.704551485311807, -0.7783504496553756],
            [8.705625937158246, -0.7854999779882278],
            [8.708503965598286, -0.7895620600445596],
            [8.713374504930053, -0.788855512331016],
            [8.715958994403268, -0.790976049937717],
            [8.720076192006669, -0.7887496637968293],
            [8.7265417531181, -0.789590941598299],
            [8.734652316218952, -0.7842391560338862],
            [8.744219374819794, -0.7813268199549012],
            [8.742834728550628, -0.7762297265624405],
            [8.746197923552472, -0.7740543024710962],
            [8.753705220893254, -0.7735211630176451],
            [8.757527424889808, -0.7772049284599046],
            [8.76269327677437, -0.7771925481025389],
            [8.77663798118303, -0.7753611780815264],
            [8.779752406945741, -0.7806634699317535],
            [8.788365619529417, -0.7804602497505011],
            [8.792844594124109, -0.7822714297344247],
            [8.797630589854405, -0.7780928803230999],
            [8.802100716588, -0.7805415765076511],
            [8.805678391356404, -0.7779317998251306],
            [8.807880875087287, -0.7794420782690203],
            [8.812552942376556, -0.7745040684336676],
            [8.821784061844122, -0.7760299672951619],
            [8.824369608483176, -0.7746597581932738],
            [8.827540044056972, -0.7820757264138312],
            [8.83291490112556, -0.7819892871650351],
            [8.84269024775329, -0.792218380685265],
            [8.848973110877818, -0.7908812176571751],
            [8.85411295291453, -0.7956169751904887],
            [8.858220738624215, -0.7957329500733564],
            [8.862546291684671, -0.7997392253778955],
            [8.866420831999136, -0.8003363853159113],
            [8.869074572923948, -0.8028639980401067],
            [8.876763428896261, -0.8039748988751226],
            [8.876719175002862, -0.8097384174176581],
            [8.878629750599531, -0.8139086940617065],
            [8.881917223920063, -0.8151762607320476],
            [8.883549805959737, -0.8210454513886812],
            [8.893969425101293, -0.8201807766520517],
            [8.896160661230544, -0.8172117885618708],
            [8.903583066910912, -0.8156432856224597],
            [8.906292897912934, -0.8084049357271006],
            [8.90915678684398, -0.8076068173271994],
            [8.911041446172133, -0.7996835921565302],
            [8.913616696689193, -0.7999546196236887],
            [8.915332218732088, -0.7933542269001164],
            [8.919562329627002, -0.7890140720807161],
            [8.924363616258546, -0.7871348829066417],
            [8.93054628808085, -0.7881831568197603],
            [8.934370168409254, -0.78695639689829],
            [8.935744480369541, -0.7830018800269863],
            [8.939130474028111, -0.7842841379167595],
            [8.940845070532067, -0.7765772259294084],
            [8.948809363845642, -0.7766491298727816],
            [8.952411928125988, -0.7750777295242998],
            [8.956284649868557, -0.7711591141409914],
            [8.955527992461082, -0.7676439458196455],
            [8.958453458532427, -0.7650347633483625],
            [8.965685863935988, -0.7665909987280928],
            [8.967618063202515, -0.7721992085592204],
            [8.9723392762327, -0.773846360745618],
            [8.974754426201867, -0.7767251741528916],
            [8.978169440501043, -0.7748040394771757],
            [8.981049999621844, -0.7793916041709018],
            [8.985961682464495, -0.7768928799810508],
            [8.98763809609446, -0.7723820201021177],
            [8.991525797510244, -0.7721611608207001],
            [8.996732038712313, -0.7794314891390228],
            [9.002921372509423, -0.7814924979633007],
            [9.006456425087315, -0.7876383018630485],
            [9.008805092804604, -0.786429952155318],
            [9.014018615674377, -0.7908404719522195],
            [9.017814126490006, -0.7906198239558637],
            [9.019282686097855, -0.7964055611957795],
            [9.023752202794395, -0.7986499652551438],
            [9.027228211693346, -0.8035079742270794],
            [9.032583001363648, -0.8029818269133221],
            [9.035725075290213, -0.8062365747169845],
            [9.039087968506681, -0.8069237199480642],
            [9.034425242058429, -0.8126810623267257],
            [9.033763483163302, -0.8208356135006594],
            [9.027450462420694, -0.824958305457379],
            [9.023793726923202, -0.8231417084388769],
            [9.01565400180302, -0.8262267109103181],
            [9.01203168123597, -0.8333494033617588],
            [9.007113591150777, -0.8399835687440607],
            [9.00054401715811, -0.8389336350928188],
            [8.99763103879454, -0.8415823859833578],
            [8.996828336385544, -0.8465447157973387],
            [8.997446553087602, -0.8540380849771038],
            [8.99978189707297, -0.8608515059253916],
            [8.99769981821658, -0.8711387068255244],
            [8.994333849018076, -0.8731267091195677],
            [8.991858981376636, -0.8889343000889007],
            [8.989056861529773, -0.8906021845401686],
            [8.986979776667734, -0.8967701876402677],
            [8.985297952037419, -0.9092545179699031],
            [8.979526653662605, -0.9187293530031546],
            [8.975623187957222, -0.9174993408334202],
            [8.970686357265228, -0.9178445908015486],
            [8.9617647037781, -0.9242573582294813],
            [8.96278480360253, -0.9295836109409534],
            [8.96628130056138, -0.9345140951735746],
            [8.965810510840623, -0.9395320406560502],
            [8.961721436536653, -0.9467761387350999],
            [8.961742381480676, -0.9515975899435019],
            [8.963335407375467, -0.9547812787508638],
            [8.96272577120179, -0.9590751772564449],
            [8.959113829111883, -0.9608766531185525],
            [8.957701748904604, -0.9645649486380123],
            [8.952845585563825, -0.9673463779386897],
            [8.948441719321876, -0.9656789939499274],
            [8.942768055839222, -0.967825342020455],
            [8.939280688089251, -0.9720015260366607],
            [8.919562419094557, -0.9725277146851865],
            [8.917179639167484, -0.9763902613874267],
            [8.912045390287624, -0.9782117048364661],
            [8.907429716377932, -0.9752501698399653],
            [8.902586207501509, -0.9761448425076481],
            [8.90130272920667, -0.9788173062007207],
            [8.886038886440112, -0.9950578549398646],
            [8.883039850906943, -0.9945242224741411],
            [8.879996362508889, -0.9982354038384954],
            [8.876392919732263, -0.9996271004698191],
            [8.87236952360949, -0.9955246561677048],
            [8.870423476271254, -1.0019115988904956],
            [8.875401492006413, -1.0092724090467842],
            [8.877262280952952, -1.014054939994044],
            [8.875538190648754, -1.016432063847003],
            [8.870314244535894, -1.0190202996633946],
            [8.846020803659734, -1.053741167820817],
            [8.827773701268644, -1.0264514167857626],
            [8.816000906049249, -1.0251887780746054],
            [8.812538514193479, -1.027133268098253],
            [8.800586549449974, -1.0287226594955163],
            [8.796300231692237, -1.0256049443035897],
            [8.798513188103556, -1.016466281939871],
            [8.801058844895355, -1.0139616423948996],
            [8.810516729037207, -1.0117452400799514],
            [8.812008429503564, -1.0088807863354545],
            [8.810172776804242, -1.0022656215480676],
            [8.808256725810459, -1.0001823223744029],
            [8.771879971801818, -0.9475731997834006],
            [8.767565868825159, -0.9489730898509517],
            [8.763440639149707, -0.9375391995375372],
            [8.72742123803642, -0.8931771538250723],
            [8.728669906963187, -0.892897172048111],
            [8.637876847022312, -0.8334365104670399],
            [8.6355191895291, -0.8275747999489661],
            [8.6348508768734, -0.8220249703255438],
            [8.637332727973435, -0.8186009865128985],
            [8.637934362441797, -0.8126483066823774],
            [8.63463703541465, -0.8089388209557286],
            [8.634465032685826, -0.7953888437765484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.32792396319587, "lat": 37.3664874309388 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21217"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "217",
        "coty_gnis_code": "00516955"
      },
      "bbox": [
        8.634465032685826, -1.053741167820817, 9.039087968506681,
        -0.7650347633483625
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.592197314499551, -8.601405721486179],
            [4.692399297142144, -8.55949761478997],
            [4.706976516413835, -8.558700877368848],
            [4.706127678625989, -8.544869416041648],
            [4.715609167119445, -8.54398839437201],
            [4.718471891961528, -8.539332406829235],
            [4.735303726011327, -8.549535087541367],
            [4.73938630833807, -8.548121163193983],
            [4.760419322438209, -8.542761207189008],
            [4.760715647141828, -8.544238040877461],
            [4.778080254673788, -8.53886903313111],
            [4.7828436277504425, -8.543841419794136],
            [4.796975560257749, -8.551728348538175],
            [4.813178903108015, -8.55067522218734],
            [4.814982124113975, -8.549112281231086],
            [4.816963543385556, -8.579789770551717],
            [4.831615398846451, -8.578763236260146],
            [4.834775391112072, -8.636196678196297],
            [4.864547539655923, -8.634061787587816],
            [4.866890951156965, -8.676975110740317],
            [4.888886477585624, -8.67523722889932],
            [4.890999086910184, -8.705146649943103],
            [4.892751729790514, -8.732581420031474],
            [4.87170193361112, -8.734063006990414],
            [4.8617206984863754, -8.777724537479159],
            [4.861384020969477, -8.781033454384094],
            [4.8435017748870095, -8.819403425883603],
            [4.81637046978157, -8.868009303642134],
            [4.796225688662504, -8.898538956780568],
            [4.7351492867677445, -8.989044454490271],
            [4.734242528939657, -8.984727893586014],
            [4.728501106470912, -8.978689478512043],
            [4.723553356806132, -8.976582405159052],
            [4.717075647104335, -8.975493881063294],
            [4.714455517315936, -8.971616355327656],
            [4.718328520781369, -8.960621503141146],
            [4.718701529823439, -8.940275193704428],
            [4.7177806782870935, -8.930755941288657],
            [4.720547975398873, -8.921017449644678],
            [4.716307376650284, -8.91818164100001],
            [4.708880672614701, -8.88482480029053],
            [4.710893123146092, -8.881805298195964],
            [4.718394007644663, -8.880830940084836],
            [4.719607781109266, -8.872218551821911],
            [4.72255000902051, -8.86229094872504],
            [4.719109750705267, -8.855003424955585],
            [4.712227217150697, -8.845979391425878],
            [4.715696351658984, -8.839509842178924],
            [4.711854550501829, -8.833619940277616],
            [4.712517693093131, -8.829106013328571],
            [4.717328422950958, -8.816988948732208],
            [4.710880245538299, -8.804370409424385],
            [4.704289660990668, -8.799123408639325],
            [4.700188953385937, -8.793131222704234],
            [4.691804776404674, -8.792204690361379],
            [4.687727110308801, -8.787951488070432],
            [4.681655374970622, -8.783732717149128],
            [4.673371195288277, -8.783755896089236],
            [4.665749815517974, -8.784695475037422],
            [4.660829427499973, -8.781751977629055],
            [4.653771451408681, -8.779811013556278],
            [4.635582181563823, -8.77641771864205],
            [4.630541314924163, -8.772003829297391],
            [4.626976623928021, -8.767311727362099],
            [4.621172948679312, -8.762213294809277],
            [4.618986535234395, -8.752098670057114],
            [4.615630477187845, -8.74509348282427],
            [4.613911966492326, -8.738008254781745],
            [4.61376815392094, -8.727905333591425],
            [4.610983446842143, -8.72253779599654],
            [4.605297327780452, -8.716331916102455],
            [4.596763503702762, -8.713121982147886],
            [4.591052990345879, -8.70817619562763],
            [4.590182566214634, -8.704729432297725],
            [4.592176869642854, -8.693404304530457],
            [4.590366038506764, -8.690590489335587],
            [4.584325735804542, -8.687872415503366],
            [4.575670194580035, -8.675965394069218],
            [4.5764547128380295, -8.670354465710272],
            [4.572131969179853, -8.669754825016689],
            [4.5721483677255215, -8.665076450464392],
            [4.568125004580354, -8.65621411973343],
            [4.566052041023689, -8.647596829793352],
            [4.563282185328136, -8.640079781264332],
            [4.5630957552622675, -8.627980514522733],
            [4.56618772637046, -8.626707046174204],
            [4.575702536632317, -8.627357349967836],
            [4.58335254982295, -8.626058619400208],
            [4.5864522374331465, -8.619451296926766],
            [4.592197314499551, -8.601405721486179]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.06074976536553, "lat": 29.90238733045985 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22007"],
        "coty_name": ["Assumption"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Assumption Parish"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00558414"
      },
      "bbox": [
        4.5630957552622675, -8.989044454490271, 4.892751729790514,
        -8.53886903313111
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.111565330245728, -6.5289963997223674],
            [2.1885158266231137, -6.527824356456363],
            [2.207033412788192, -6.51252036222007],
            [2.216493304793954, -6.505822996300086],
            [2.2254190429645457, -6.500581504658927],
            [2.227854313072733, -6.4974264113082025],
            [2.233247576358304, -6.495753630374772],
            [2.2438408711049194, -6.485878793625148],
            [2.252327977562017, -6.480208994478497],
            [2.2515346849187385, -6.476261455146869],
            [2.2624100714158653, -6.469879877846804],
            [2.265248732292407, -6.464507268706938],
            [2.2664100627133683, -6.459357889160632],
            [2.264768504797035, -6.45535325179341],
            [2.2670713557685196, -6.4440153756955585],
            [2.2662169586416314, -6.440768258674909],
            [2.271056064665546, -6.435720700908648],
            [2.2719050622547976, -6.430301940731768],
            [2.278299391198007, -6.428504195198104],
            [2.2838566180213196, -6.422782909778434],
            [2.288553355637268, -6.419357949782147],
            [2.2934673806004753, -6.418773613425544],
            [2.294901296648031, -6.416038965960362],
            [2.303769427390665, -6.411466645008821],
            [2.306529638772335, -6.407493190638421],
            [2.3049451244213537, -6.400775170044076],
            [2.308214501894622, -6.397276509908894],
            [2.3067534629414936, -6.393195741180964],
            [2.311087530361886, -6.389946263283275],
            [2.316345338900184, -6.383031478055012],
            [2.3186458256992055, -6.383699961567955],
            [2.3278657424873392, -6.377172397224867],
            [2.332884942258542, -6.380672634483913],
            [2.3365159677773333, -6.375665999275594],
            [2.3503797313809454, -6.376450001831242],
            [2.3536315116580933, -6.380066407447086],
            [2.3573193150041334, -6.378585405437914],
            [2.3649316544102463, -6.393418455640603],
            [2.3713809117433824, -6.393649382086571],
            [2.375122358207483, -6.390890169249596],
            [2.380195723557298, -6.396541675086899],
            [2.383460349709276, -6.40247582581456],
            [2.3884651753012647, -6.403026686830214],
            [2.3925048742140382, -6.399845880414564],
            [2.395743523567318, -6.400246781710638],
            [2.3967723923188773, -6.395537066868066],
            [2.400211437571584, -6.394783701304499],
            [2.406220172850513, -6.401737121512526],
            [2.4119628632525925, -6.4016460962135895],
            [2.417881925362934, -6.399872462719791],
            [2.420604064630666, -6.40169000875052],
            [2.42517322195788, -6.400693209045647],
            [2.4292333266660298, -6.402947492800277],
            [2.4311278032343404, -6.406947469035112],
            [2.4423777254692056, -6.4133098435889515],
            [2.444254374188324, -6.418716833653643],
            [2.4469396231779066, -6.419915743075397],
            [2.449801114450612, -6.42718181324439],
            [2.4562133269117514, -6.431435905731678],
            [2.4616802114137397, -6.433666481124605],
            [2.4664193279192657, -6.443354047154737],
            [2.470253385431062, -6.447383211457093],
            [2.470453687967904, -6.4518805768978345],
            [2.4672720306231164, -6.460047169724385],
            [2.469271291150837, -6.46857097655789],
            [2.4692346865554, -6.474055036153666],
            [2.4707052699800767, -6.479425480190625],
            [2.4719798454991437, -6.482163137496608],
            [2.47778875922506, -6.484880305750792],
            [2.4804435959064746, -6.4915714510214],
            [2.485683302147086, -6.49676086439847],
            [2.4852018184339495, -6.505038808444559],
            [2.4894443904829924, -6.510772257588723],
            [2.5017050894419817, -6.515138016149432],
            [2.511818035877026, -6.520781250632631],
            [2.5204909800168354, -6.523546024295801],
            [2.5274080106612873, -6.52181766835868],
            [2.538640815746296, -6.522370098499014],
            [2.539834260349474, -6.527013400035445],
            [2.5442173044948895, -6.529548445807569],
            [2.5490701464318035, -6.537907709629235],
            [2.5483117673401927, -6.544292263885609],
            [2.550767913389047, -6.547803619765953],
            [2.551255512638258, -6.562717634719562],
            [2.5521756632642356, -6.570159810486822],
            [2.5619608457564924, -6.582332241823839],
            [2.560988108097885, -6.5868049354363025],
            [2.5574094755905477, -6.589030256886943],
            [2.551078389063209, -6.5891045920326885],
            [2.5450520691900542, -6.599021710354694],
            [2.539758975310819, -6.601878592736356],
            [2.5358188500721393, -6.609273133678456],
            [2.538197195046986, -6.613502096340096],
            [2.544561121526518, -6.617189778370901],
            [2.551831808143794, -6.624526280212392],
            [2.5593544836984408, -6.628858705240275],
            [2.5597521643884806, -6.63415874328288],
            [2.564573796514785, -6.6377598789114405],
            [2.5665718181290114, -6.641009978510957],
            [2.566270436496977, -6.648056405458883],
            [2.5704868226106905, -6.651218488217434],
            [2.586107674544762, -6.654399606778801],
            [2.5885515497400173, -6.6566677391435745],
            [2.58952866800736, -6.666308139570169],
            [2.5884306633618785, -6.672842865182852],
            [2.5884866166118985, -6.681642352228552],
            [2.5931756271836828, -6.686819180870519],
            [2.6018870370029186, -6.687778931019189],
            [2.603243077021845, -6.691380044842694],
            [2.6062083639758855, -6.692262809335563],
            [2.605379033200239, -6.696168399534095],
            [2.6081070981107204, -6.699550221269668],
            [2.6085097678314524, -6.706445892073572],
            [2.613006884955537, -6.711637239502103],
            [2.618152706683922, -6.713789162873187],
            [2.6228794231543864, -6.723331105591418],
            [2.628361882575108, -6.72425345423486],
            [2.6368903972993096, -6.721835223903079],
            [2.6390825019611905, -6.723908472090911],
            [2.6388096413981152, -6.7285426734057],
            [2.643036744704743, -6.726957311567039],
            [2.6457190577065797, -6.723301171233903],
            [2.6526050908850967, -6.723908425919867],
            [2.65443391897617, -6.729488934846761],
            [2.657958898200206, -6.73341609972349],
            [2.6657060336455385, -6.737518544276945],
            [2.6749970808115857, -6.746305366437451],
            [2.6788791887788217, -6.745575141006021],
            [2.681797033451077, -6.749076532816429],
            [2.6809885463660708, -6.756691699315663],
            [2.683999193689226, -6.758716090670819],
            [2.684649635927163, -6.766746059753126],
            [2.6878765856140747, -6.77483865975857],
            [2.696594966473761, -6.773684997351007],
            [2.697306733471341, -6.778338315346594],
            [2.6783326504688243, -6.778371427890537],
            [2.6798212302356395, -6.782461566883259],
            [2.6789526861139947, -6.787606299451981],
            [2.673292339679296, -6.785358975958676],
            [2.6702658839860893, -6.786023506275374],
            [2.667322408701816, -6.790699690343453],
            [2.661087042096141, -6.793614942373862],
            [2.6536384179452748, -6.792840035111256],
            [2.6478646167734246, -6.7877008224549025],
            [2.646259956719515, -6.782430676187478],
            [2.6462512671228704, -6.777670236919654],
            [2.6429383548119474, -6.77799018666243],
            [2.6395737008002613, -6.780717678944391],
            [2.6375479687532946, -6.788362174079171],
            [2.634521141790923, -6.78862216417884],
            [2.6300627185277037, -6.793391455846928],
            [2.6287327995790153, -6.797231396454222],
            [2.625914936040249, -6.798882610800086],
            [2.6284584345362974, -6.813958305882987],
            [2.6261505485804557, -6.81853856728081],
            [2.626143804945861, -6.837213708063701],
            [2.627074064941507, -6.852554909403701],
            [2.627279393473894, -6.867047595140133],
            [2.5789805350905177, -6.868463168299213],
            [2.578582221682296, -6.868212182585552],
            [2.512649083742593, -6.869765718024549],
            [2.505427258742927, -6.869616017195683],
            [2.437932698871026, -6.871596966236437],
            [2.3686912947716934, -6.873808119920918],
            [2.359064532946884, -6.873913432016493],
            [2.2827867855410577, -6.876364133275932],
            [2.2571239538322625, -6.877040604904115],
            [2.25665021230214, -6.877704159160526],
            [2.25244909040238, -6.871575526861656],
            [2.253131064265441, -6.866384862715643],
            [2.2493537728802986, -6.866939174903308],
            [2.2486018319644288, -6.863836206186209],
            [2.2538336132424797, -6.859515603787642],
            [2.251594839028956, -6.8556154064290835],
            [2.2462093719375544, -6.850366789366692],
            [2.2458881687768293, -6.846701396186547],
            [2.24201118817197, -6.845512660424657],
            [2.237655837744192, -6.848165353493287],
            [2.237032156197055, -6.841791791472574],
            [2.241303675064145, -6.834483522552487],
            [2.240495175944421, -6.827375376668572],
            [2.235606737491453, -6.825738535053747],
            [2.2320862349247834, -6.829517269440735],
            [2.2248680239284004, -6.829288640270101],
            [2.221839839638947, -6.831462757505978],
            [2.2198077860327823, -6.836536463374375],
            [2.2159241350705727, -6.834078482739272],
            [2.211100267858731, -6.828938728716864],
            [2.21215512931323, -6.8259665720753135],
            [2.2187174272735617, -6.819609308593307],
            [2.218366463781245, -6.814531170152843],
            [2.213255918319697, -6.810686590430422],
            [2.2041975543907513, -6.812293985816834],
            [2.1927187235769607, -6.812319737620316],
            [2.1879146554704114, -6.800776697696232],
            [2.1854729693897355, -6.799072519532289],
            [2.1803102596451174, -6.803198629764899],
            [2.175251651524045, -6.8016105509076565],
            [2.1705140533756464, -6.792669129641753],
            [2.170148069620608, -6.786743436003038],
            [2.1684018444883506, -6.783389415014158],
            [2.1634392176081336, -6.78013096651196],
            [2.157880250825982, -6.7722063520678555],
            [2.150677254732285, -6.759741728566054],
            [2.1459327923016, -6.7502328328407],
            [2.1389909303003205, -6.743999815381119],
            [2.1372415531371884, -6.7348696968970785],
            [2.1269635034346392, -6.728572473120705],
            [2.1227798597915646, -6.729233431582476],
            [2.119331094560662, -6.73215076161648],
            [2.1164448852095377, -6.732244808654151],
            [2.115554355144486, -6.72541308642032],
            [2.1143970051534926, -6.668791137606859],
            [2.113380438922474, -6.605010078042756],
            [2.1129221577516564, -6.599778025243156],
            [2.111565330245728, -6.5289963997223674]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.73730836009133,
          "lat": 32.055409518286076
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22031"],
        "coty_name": ["De Soto"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["De Soto Parish"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00558521"
      },
      "bbox": [
        2.111565330245728, -6.877704159160526, 2.697306733471341,
        -6.375665999275594
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.200600318063293, -5.935831953301513],
            [3.274427405475337, -5.93345202158968],
            [3.28172942917044, -5.932783092864321],
            [3.2830863470906966, -5.9355055497210785],
            [3.2944047477650353, -5.9394853268653485],
            [3.298992108056812, -5.93891705848197],
            [3.3060944386204154, -5.935871121917998],
            [3.310272566883476, -5.935792340532501],
            [3.316538736976807, -5.942663270092775],
            [3.324668256629378, -5.9453940056562775],
            [3.329744580078059, -5.942177300385649],
            [3.3332140992126735, -5.944459582716367],
            [3.3351461795586053, -5.948448978036296],
            [3.3401697942022204, -5.954129096809675],
            [3.343306131251084, -5.955948324647353],
            [3.3476665721521406, -5.962390625928679],
            [3.347138073049137, -5.967009959514586],
            [3.3506446549600244, -5.971362342978627],
            [3.3577777714886223, -5.970833905303221],
            [3.361385360701687, -5.968334430248441],
            [3.3657867448162384, -5.969771441698878],
            [3.372970768414758, -5.969106637048042],
            [3.374612078789598, -5.972880176694505],
            [3.376303252393805, -6.018350419870682],
            [3.4558897853316433, -6.016219444180065],
            [3.4631584725345963, -6.0156917373426655],
            [3.465923352814056, -6.093302398726923],
            [3.4664238943134755, -6.103045920882695],
            [3.4694918046630048, -6.190226930375244],
            [3.42622193819438, -6.1917243209460775],
            [3.328186374542938, -6.19468252853497],
            [3.2960544871876696, -6.195745642158395],
            [3.297059791066701, -6.212026358451659],
            [3.2982075889671068, -6.239021497045982],
            [3.2667391358331517, -6.240225719707712],
            [3.2344910683232095, -6.240917424529682],
            [3.1679400313778134, -6.2429773277486],
            [3.081975361113968, -6.245424118222658],
            [3.0797750558733306, -6.189899210760313],
            [3.0789214960553104, -6.157202860981779],
            [3.0764159570049214, -6.114315470054294],
            [3.0760587593278186, -6.098775303692814],
            [3.083474652214819, -6.096816836597157],
            [3.087678626159747, -6.091972209127337],
            [3.089150302955461, -6.086193319040639],
            [3.088385719463233, -6.082065718538294],
            [3.0908114939469633, -6.078281649391152],
            [3.0903039224435562, -6.071474686192922],
            [3.0916132212694345, -6.0697795376410095],
            [3.0902997794595395, -6.0636052901084785],
            [3.0918468884887673, -6.057626160230792],
            [3.0887880909162475, -6.052664856988174],
            [3.089358560082889, -6.050043159508008],
            [3.0865161694145007, -6.0409633317688085],
            [3.086736286073863, -6.032452273379357],
            [3.084236252321528, -6.0292055231580335],
            [3.0858290979526695, -6.026383985416619],
            [3.0837515874989334, -6.021428858834855],
            [3.0881892574136796, -6.01351453071001],
            [3.087252988365003, -6.0114374059814475],
            [3.090662226940746, -6.007415917180818],
            [3.096460015366422, -6.0035407694845055],
            [3.1024615376156657, -5.997786657484054],
            [3.101986361619292, -5.993707479308736],
            [3.105798578328082, -5.9900190937738795],
            [3.1111439416059365, -5.988062421799722],
            [3.1130737433825653, -5.985086599848586],
            [3.1161553614199633, -5.986985311672892],
            [3.11490725914346, -5.938734680378043],
            [3.13791810271603, -5.93786811056522],
            [3.200600318063293, -5.935831953301513]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.66490900140354, "lat": 32.6016047275635 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22061"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Lincoln Parish"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00558077"
      },
      "bbox": [
        3.0760587593278186, -6.245424118222658, 3.4694918046630048,
        -5.932783092864321
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.086962912996042, -8.43558595383482],
            [5.092665339999824, -8.380947019429987],
            [5.104904856411729, -8.382314811058023],
            [5.108588711269657, -8.386351708112013],
            [5.1115783117268165, -8.386793203550058],
            [5.115540830696505, -8.383648891376438],
            [5.1193296204339775, -8.38312520281451],
            [5.122565207454395, -8.384838652749584],
            [5.127753248321421, -8.391745383460067],
            [5.128313426906985, -8.394178910289781],
            [5.140628730637626, -8.402089813545318],
            [5.14960977667939, -8.403384030272095],
            [5.161109514761092, -8.402458383375905],
            [5.174253923862077, -8.393931084819371],
            [5.192440305974258, -8.375153697506603],
            [5.1979473423905835, -8.366112441739144],
            [5.203053916757512, -8.344746029770008],
            [5.215249406111397, -8.318606729604564],
            [5.23910837362779, -8.317157603818215],
            [5.26135894139182, -8.313722881185386],
            [5.271280279731335, -8.312542865976816],
            [5.279610717144313, -8.310478359607531],
            [5.284446351218947, -8.307349949872446],
            [5.290395956074766, -8.30521159872363],
            [5.295979098214175, -8.305516878695643],
            [5.3036000281536415, -8.30406818200225],
            [5.3113538720315265, -8.306672941481208],
            [5.320294465506933, -8.299209619926678],
            [5.330707439787529, -8.29219152539862],
            [5.333458966256705, -8.291510111673814],
            [5.339077878434446, -8.292874834895663],
            [5.345147172261727, -8.292926673393893],
            [5.3562573788610415, -8.288543970029595],
            [5.363571695699617, -8.291747986266985],
            [5.373328840771019, -8.291806422692114],
            [5.3768342275684615, -8.293816463668277],
            [5.388833064937942, -8.29830656022093],
            [5.497742829833425, -8.344240307928443],
            [5.500243727053823, -8.350252494588295],
            [5.505326783825433, -8.374412309598327],
            [5.504266278427132, -8.388242237032193],
            [5.485264690728608, -8.393705236491027],
            [5.462663267667231, -8.400986055547552],
            [5.4318067870365025, -8.41263669160167],
            [5.416571082847341, -8.419542929224004],
            [5.395986049532177, -8.426171355932945],
            [5.3642683495701355, -8.43445209715338],
            [5.359836562138481, -8.43603797856051],
            [5.355139549320753, -8.443092955636365],
            [5.347752774873521, -8.459008869216731],
            [5.3417258007099955, -8.46681129706315],
            [5.294509306375951, -8.506423883882592],
            [5.260150539528872, -8.558012108077962],
            [5.239192269785405, -8.560978234191037],
            [5.237931909917067, -8.556517815862804],
            [5.222098662166425, -8.563301943228364],
            [5.185317428942261, -8.578347072125696],
            [5.1852433013604, -8.592978146079524],
            [5.175978458941942, -8.592988006078482],
            [5.178310382646112, -8.627208502678933],
            [5.193124661226185, -8.626472354257677],
            [5.200148368669101, -8.70827795624571],
            [5.194770393721619, -8.70257497582249],
            [5.1794286691668345, -8.701190036125418],
            [5.157335577384871, -8.702424199991176],
            [5.144427501654104, -8.703574934353842],
            [5.139964312380551, -8.706542158390157],
            [5.13660286354413, -8.711608320900094],
            [5.131283990349575, -8.714057217203798],
            [5.128457325796956, -8.706279781024831],
            [5.12421412919644, -8.707390682549633],
            [5.118181012766693, -8.703914590217948],
            [5.113484366421528, -8.703028880208324],
            [5.1081818196937565, -8.703728520695899],
            [5.095103005353166, -8.707470300892421],
            [5.090316844106389, -8.7102505676096],
            [5.081245933319984, -8.692484432214297],
            [5.078036213303469, -8.648960303541598],
            [5.0707600585133505, -8.649514734333165],
            [5.069712385588233, -8.635142208282133],
            [5.0771544222236535, -8.634539901707207],
            [5.075803276756345, -8.620109875013922],
            [5.068491226440351, -8.620856622053418],
            [5.0680947033308765, -8.614476801870556],
            [5.066715794176651, -8.612792667016866],
            [5.071267084454352, -8.608686945996851],
            [5.053972699722172, -8.566850686730954],
            [5.059283509974275, -8.561958943154009],
            [5.06962192246089, -8.554434724327733],
            [5.076998088793617, -8.550839852323707],
            [5.0662317830970505, -8.508496652290251],
            [5.080900280761242, -8.505450451152042],
            [5.082897786756924, -8.481239111264602],
            [5.086962912996042, -8.43558595383482]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.47095258615094,
          "lat": 30.126414008772556
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22095"],
        "coty_name": ["St. John the Baptist"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. John the Baptist Parish"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01629472"
      },
      "bbox": [
        5.053972699722172, -8.714057217203798, 5.505326783825433,
        -8.288543970029595
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.550188033555127, -7.526330085883241],
            [2.552038024812787, -7.514235024341517],
            [2.5543877241582487, -7.514348082632066],
            [2.5567239822381644, -7.5090706671547816],
            [2.552335121153016, -7.502217746230917],
            [2.552618629185804, -7.495189312015736],
            [2.551436038943319, -7.493086782015161],
            [2.5562447599973943, -7.488788685646151],
            [2.5554772845964053, -7.482170945908054],
            [2.5511122367978665, -7.482405063460118],
            [2.5491724549552974, -7.47408324447137],
            [2.554778671120282, -7.468835860132534],
            [2.556165180301548, -7.464221773477508],
            [2.5626390895836093, -7.4592211112184685],
            [2.559528478273719, -7.454710343453539],
            [2.5632814049128987, -7.451395778423903],
            [2.562133717040803, -7.444686321540415],
            [2.563068653940133, -7.441375342519607],
            [2.5624221452610545, -7.435648191860563],
            [2.5651084274283105, -7.434907117503249],
            [2.641468500161499, -7.433264308589286],
            [2.683378039461303, -7.34508067213587],
            [2.771227898252666, -7.342691263416407],
            [2.814198251525087, -7.341069766103416],
            [2.8142151002509874, -7.341557282032557],
            [2.8700215517472567, -7.33960476488512],
            [2.9880424606118963, -7.3367919832436685],
            [2.9882939502198704, -7.339696466696231],
            [3.0223381449133795, -7.3388447608987635],
            [3.0285696413223877, -7.34895626268511],
            [3.031743904833552, -7.35206028995433],
            [3.0320382691621135, -7.359468730388896],
            [3.0464797976483635, -7.358784341410397],
            [3.0468374310384685, -7.366000342951066],
            [3.075516130327635, -7.365264797589008],
            [3.0758816393745905, -7.372982225295415],
            [3.104768279484523, -7.371775690204228],
            [3.104806900548049, -7.378998547550408],
            [3.1192416253766058, -7.3785615571445025],
            [3.1202701886733823, -7.407381743783906],
            [3.134709256108469, -7.406893274845663],
            [3.1350910568216426, -7.421096852384906],
            [3.1490155079434445, -7.420763191763031],
            [3.150024106741927, -7.441778407030737],
            [3.1641283373722504, -7.442194053504887],
            [3.166399767724797, -7.49916570481823],
            [3.1701213762537312, -7.59530101835809],
            [3.173688887442712, -7.681781876101559],
            [3.1768352125625254, -7.6816120597902735],
            [3.180354129923423, -7.7878013967484785],
            [3.1810091032614336, -7.799779261230434],
            [3.1812504851923835, -7.814520829193907],
            [3.092126923717348, -7.818039134021212],
            [3.0490606809036653, -7.817895283397353],
            [3.0055688772308033, -7.817700289885905],
            [2.9725042794284096, -7.819605397417598],
            [2.916240589095122, -7.8223338404989375],
            [2.9159784728037823, -7.817015009677118],
            [2.9013392354323932, -7.816970079992249],
            [2.8557389486691815, -7.818549477522218],
            [2.8292439155891427, -7.819656405933416],
            [2.728201353138289, -7.822531503861468],
            [2.6701072731289073, -7.8243086672246065],
            [2.667549447144259, -7.823721434392007],
            [2.660600830848818, -7.827623787855976],
            [2.6580319105472663, -7.825624286360371],
            [2.650143863993853, -7.8344603619221855],
            [2.6448028637164405, -7.836577168956228],
            [2.6388714640250157, -7.841414364625381],
            [2.632136586235548, -7.842259368797907],
            [2.631998800735554, -7.844107466960681],
            [2.6217914240602194, -7.849077920455016],
            [2.6167755033479065, -7.844674085043202],
            [2.6116033506428455, -7.84251494203825],
            [2.60313119395788, -7.843759754467632],
            [2.600521285386247, -7.839336835645188],
            [2.598014409916245, -7.841410489342178],
            [2.5884848982477213, -7.83360299239114],
            [2.5833298808163843, -7.833598131290574],
            [2.578808341234896, -7.829872672211847],
            [2.5708002891608857, -7.828594861393908],
            [2.556386999222673, -7.832606936305168],
            [2.5563568945836175, -7.837842023997094],
            [2.5530405766585207, -7.841332492293742],
            [2.5484538064777595, -7.841658460640777],
            [2.5493713712555435, -7.837413597632479],
            [2.5477078878023045, -7.834602675867043],
            [2.5425520287398773, -7.834827823111699],
            [2.5395372120659925, -7.826010501688681],
            [2.5404200571984785, -7.822965909061219],
            [2.5459144938734073, -7.815602317151222],
            [2.553144614352723, -7.81352320807121],
            [2.560486167613337, -7.812647177709657],
            [2.560917918532789, -7.810196123452768],
            [2.556248835956491, -7.807453864087845],
            [2.556940084456929, -7.802141589860916],
            [2.5521403713156783, -7.798991847041102],
            [2.5522253665754815, -7.796857652396738],
            [2.557594765224026, -7.791642585286566],
            [2.5595090347332605, -7.786517375746919],
            [2.5631711704845794, -7.783137518795451],
            [2.5658471665888043, -7.784271741682647],
            [2.5650214382646404, -7.78997462236076],
            [2.57540404691788, -7.785333388055233],
            [2.5793553227917148, -7.779763427043921],
            [2.5778883262726096, -7.777006003402945],
            [2.5792741153019074, -7.772310114024831],
            [2.5759037120510353, -7.767787446913595],
            [2.5735440451236262, -7.761083327347861],
            [2.574964946899112, -7.755478638353579],
            [2.57382397121076, -7.751890307216501],
            [2.5674440924042816, -7.753741336144628],
            [2.5613825484879027, -7.752622152580775],
            [2.5603590052019007, -7.745735916823952],
            [2.548893437720261, -7.7395353209500355],
            [2.5421915784044855, -7.741878841033398],
            [2.538405173588609, -7.7403611886222405],
            [2.537039210569057, -7.737428061093428],
            [2.541279877847015, -7.734852051719905],
            [2.5454067149928035, -7.722994367528751],
            [2.5435448014657736, -7.720355111421937],
            [2.5374015691586185, -7.719403170564658],
            [2.533056057446077, -7.71139258359569],
            [2.536087055978816, -7.708961422113795],
            [2.5385694219885697, -7.7017035287170605],
            [2.543461259119361, -7.6980425221833],
            [2.5474077368587724, -7.703303851717976],
            [2.5519924720473233, -7.707184390619277],
            [2.5556612428737178, -7.701628822588605],
            [2.5605145037286126, -7.700713232429503],
            [2.5662133811760337, -7.702298363610395],
            [2.570813602566215, -7.691561111505521],
            [2.5723635426785174, -7.690308042045815],
            [2.580277859296464, -7.690196396674344],
            [2.5864424470087894, -7.684470038586969],
            [2.591864135029648, -7.680605111625873],
            [2.591931052006707, -7.67770847739117],
            [2.5804655700897197, -7.6740784401995805],
            [2.577712860853349, -7.671458456869628],
            [2.581734527352958, -7.668501302992381],
            [2.581631290127194, -7.665230025069031],
            [2.575984360288287, -7.663195895503968],
            [2.5718497939107285, -7.659008041308144],
            [2.571030736683105, -7.655462656864872],
            [2.573372078855538, -7.65311186757488],
            [2.580303685545027, -7.6532233608787275],
            [2.5820897583953233, -7.648614013408453],
            [2.5804143842273706, -7.644416371947208],
            [2.5766587388433067, -7.64409169033437],
            [2.5733074896532124, -7.640915789020543],
            [2.5742166021168273, -7.636178785893876],
            [2.570052121127474, -7.636303972564649],
            [2.563559758690868, -7.633038278570839],
            [2.553229633420295, -7.632379639056169],
            [2.553430447580634, -7.626799414519463],
            [2.556196558460387, -7.622771870444574],
            [2.5492245064622794, -7.624023130955893],
            [2.5470415545800362, -7.619758775292448],
            [2.543226767829631, -7.61765651667863],
            [2.5468719443286276, -7.614202632199984],
            [2.5551996241346, -7.611236746345182],
            [2.5555230924117436, -7.605360420677015],
            [2.5583780346298415, -7.599567387095772],
            [2.562979488148155, -7.596799283270327],
            [2.564117805124123, -7.584536635591625],
            [2.5581568735645215, -7.575593397705352],
            [2.5567695565396726, -7.568201947806782],
            [2.5545786554848737, -7.563136099218977],
            [2.55423106334388, -7.555844991125612],
            [2.5615034369121132, -7.555444770937258],
            [2.564580767674073, -7.552960871677727],
            [2.5622791978854518, -7.546374390701336],
            [2.5592693131631057, -7.543130241543179],
            [2.5592049857025807, -7.540043311436778],
            [2.5646684087037106, -7.539090097710753],
            [2.5673018539780066, -7.537175546767223],
            [2.56834751134844, -7.532483772000694],
            [2.5666101024275023, -7.527045593991128],
            [2.5564318729937825, -7.527868130895328],
            [2.5532381960727424, -7.525261121087156],
            [2.550188033555127, -7.526330085883241]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.1842346271364, "lat": 31.108312246968705 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22115"],
        "coty_name": ["Vernon"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Vernon Parish"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00559548"
      },
      "bbox": [
        2.533056057446077, -7.849077920455016, 3.1812504851923835,
        -7.3367919832436685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [19.013426750602694, 8.994596228601534],
            [19.092580205611863, 9.034342719692598],
            [19.160946350890868, 9.069124099727238],
            [19.24656536864621, 9.11443875442968],
            [19.331929165477213, 9.157401379296902],
            [19.301970084361564, 9.212455429924201],
            [19.292327416983664, 9.230529347195981],
            [19.358788591696705, 9.26563415544995],
            [19.316927984482607, 9.344907849092168],
            [19.264547847608394, 9.446241653478209],
            [19.223076167085598, 9.521477289409008],
            [19.212301794826445, 9.5155115503662],
            [19.155085362880264, 9.486482453691867],
            [19.14419321955126, 9.55504737947367],
            [19.132534495619105, 9.595730413308603],
            [19.129082118262687, 9.608484280964511],
            [19.11690318624081, 9.62937039436882],
            [19.199003727910256, 9.676339972518877],
            [19.066539257453407, 10.132331540096937],
            [19.05398814423159, 10.177773650096803],
            [19.00387869667693, 10.348465301761783],
            [19.08652320534223, 10.37214446682587],
            [19.090195458692943, 10.360021804242244],
            [19.174442137636568, 10.384493483915207],
            [19.261682627801832, 10.409607142061535],
            [19.29920252959281, 10.28537411336914],
            [19.310847625963827, 10.245208108911092],
            [19.318457217956848, 10.222615561042527],
            [19.322424993916663, 10.208178942461133],
            [19.335226064821857, 10.167507429541764],
            [19.35818296276752, 10.09030295227968],
            [19.363357531279657, 10.084312016885537],
            [19.3763624549648, 10.041374570646736],
            [19.387492557240552, 10.00610591072095],
            [19.392459776645183, 9.999507627023288],
            [19.419173920907202, 9.913713575633599],
            [19.445279032961416, 9.825327682445671],
            [19.443152789012306, 9.82475572469732],
            [19.468300720536202, 9.737499691214301],
            [19.480468849413136, 9.697106367422908],
            [19.493465773858343, 9.653026845654928],
            [19.507581248639706, 9.651386322961544],
            [19.578680782794816, 9.6905576335442],
            [19.605582858177243, 9.706151338297298],
            [19.601937790784397, 9.711794783416686],
            [19.659885559139312, 9.745341653912378],
            [19.733796409554593, 9.787440617189352],
            [19.777434124442717, 9.711302904539068],
            [19.81102682394338, 9.65185986508223],
            [19.82065913256401, 9.635362170646586],
            [19.877444009914285, 9.53509852385575],
            [19.87182443810874, 9.53200394640197],
            [19.91451613056973, 9.458131289831403],
            [19.87671538486415, 9.438375744720656],
            [19.87457784637531, 9.437856643552436],
            [19.854747859657426, 9.42809815697341],
            [19.841392124961096, 9.420491768329514],
            [19.761183761442453, 9.380698613536008],
            [19.68277691930327, 9.341314700104189],
            [19.697297466997743, 9.313560239522635],
            [19.740122914215654, 9.233088226460577],
            [19.67393743081463, 9.198987903998475],
            [19.659564539702764, 9.191907988994608],
            [19.69841558859825, 9.114728981743148],
            [19.618447042662403, 9.073980988260509],
            [19.6603169853846, 8.991737154169423],
            [19.701010487296625, 8.913330598539444],
            [19.71861062462301, 8.878713050650138],
            [19.648264264279685, 8.84327131908568],
            [19.608415107887566, 8.823592348008294],
            [19.59833460461012, 8.782063251519553],
            [19.563425232279876, 8.790480869000477],
            [19.552946481814264, 8.768789888619088],
            [19.54621170088119, 8.759082683039663],
            [19.544680370006844, 8.721927589176499],
            [19.534833120179023, 8.720516159157548],
            [19.524557858337584, 8.720060696600685],
            [19.525157709131378, 8.731860731908002],
            [19.51427284589982, 8.731867837262007],
            [19.511597584120757, 8.730735055715352],
            [19.508686598935853, 8.738367003842946],
            [19.504313374325417, 8.735898910858234],
            [19.500028703160623, 8.738095799252974],
            [19.489216314661206, 8.729713204642641],
            [19.485800260647505, 8.732602224401772],
            [19.473587184366547, 8.73298305356837],
            [19.471315537700235, 8.735100272203605],
            [19.471379783992344, 8.738843539138365],
            [19.46923065378359, 8.742871942997843],
            [19.45132693770877, 8.732342504490871],
            [19.452523467292067, 8.72985921496161],
            [19.43314415446325, 8.719111123229842],
            [19.431872927792355, 8.721298458676744],
            [19.366773961314102, 8.684587684548992],
            [19.36563294406849, 8.6837805427975],
            [19.310265760057167, 8.652737592028732],
            [19.249710268132908, 8.619577828638784],
            [19.224450828087484, 8.669671225721197],
            [19.211218079233603, 8.6968034279455],
            [19.1714026792988, 8.677521276327369],
            [19.13416643525122, 8.75560261771072],
            [19.13742401302692, 8.757221697675222],
            [19.10654983867359, 8.816839534724503],
            [19.0966786562797, 8.835578411517982],
            [19.042862756412145, 8.938790021186339],
            [19.013426750602694, 8.994596228601534]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -68.64948276987917, "lat": 45.40064414516339 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23019"],
        "coty_name": ["Penobscot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Penobscot County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00581295"
      },
      "bbox": [
        19.00387869667693, 8.619577828638784, 19.91451613056973,
        10.409607142061535
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.601676228900303, 1.9069493644565858],
            [14.604554568397171, 1.9088822915021646],
            [14.643289381775128, 1.9436270485715326],
            [14.69784114600129, 1.994035020386202],
            [14.706177816386155, 2.0012277335270587],
            [14.728291147139661, 2.0224615328993925],
            [14.73227109893455, 2.0257456589629244],
            [14.761370319316175, 2.0529568079013547],
            [14.793557622813523, 2.082138467732757],
            [14.786358761890186, 2.073542224880212],
            [14.78388299388422, 2.071922236678944],
            [14.78307472892586, 2.0642941236784957],
            [14.791802847446624, 2.0529348937858236],
            [14.797272536864018, 2.0478702830602193],
            [14.800422550779231, 2.0419515195133204],
            [14.803298411389964, 2.0415272991548514],
            [14.80587430528263, 2.0372160042001486],
            [14.815349483733685, 2.0335489023310065],
            [14.82736234206199, 2.025736069588995],
            [14.829780310688532, 2.0221642356985248],
            [14.829118050416826, 2.01718505838729],
            [14.83508692764818, 2.010905088698806],
            [14.835256225109257, 2.0077477807077426],
            [14.839196796266824, 2.0037421390282817],
            [14.849590658716286, 2.0049301431042292],
            [14.854917550734275, 2.0025060096940135],
            [14.85995048657004, 2.0054345662570383],
            [14.868490912644594, 2.003519524695621],
            [14.877317223416517, 2.0027931241730186],
            [14.881269171873717, 1.9999679231288086],
            [14.887517149699852, 1.9987474651240342],
            [14.894829449555406, 1.9932452262734104],
            [14.89653778140225, 1.9873585171460815],
            [14.905754438705646, 1.9854188882353787],
            [14.909826368781104, 1.9863308603676186],
            [14.918142286727518, 1.9797843667815047],
            [14.922059162418208, 1.9751521879180174],
            [14.922688568152685, 1.9710712284535334],
            [14.931501546850873, 1.9663410925636724],
            [14.93590266347393, 1.962866526310074],
            [14.942638267981033, 1.9611215411124348],
            [14.94288762469567, 1.9492806303834531],
            [14.948730500022474, 1.948488711144681],
            [14.949970585149629, 1.9446156260821363],
            [14.948434337163098, 1.936390939422416],
            [14.95542552318449, 1.9347785630541492],
            [14.958202107702151, 1.930682293748671],
            [14.955859389493009, 1.9268876776709016],
            [14.95981388909903, 1.9231503524211913],
            [14.967512663316935, 1.924524694794443],
            [14.976838591083856, 1.923233745255263],
            [14.979132970980565, 1.9218447258215563],
            [14.977804774024468, 1.9141191369651527],
            [14.979512984349245, 1.9099239814265916],
            [14.988511064656475, 1.9101511349283098],
            [14.989807664914125, 1.9079894608397743],
            [14.995599943731028, 1.908161103792658],
            [14.998224757800694, 1.9100757478418118],
            [14.998645627000737, 1.9027096293910433],
            [14.995536420022805, 1.896984835951069],
            [15.003908652146622, 1.8941272428457618],
            [15.007084044266168, 1.8973545639592562],
            [15.011024785909294, 1.8988491297622925],
            [15.016803925406327, 1.9058032941141005],
            [15.019430533316514, 1.9031595941053443],
            [15.025683802827675, 1.9011618316763679],
            [15.029225952872865, 1.8966008244614254],
            [15.035815207964815, 1.8963845764081957],
            [15.043086495256738, 1.8994135924362117],
            [15.048862636621914, 1.9046813988964475],
            [15.045951167650491, 1.8967706527287727],
            [15.037349395540863, 1.8888891429036891],
            [15.040568758613436, 1.8861564543599463],
            [15.039585875638052, 1.8773268584504705],
            [15.032959707210095, 1.8553514252085463],
            [15.021133669234928, 1.8181504151831978],
            [15.01141678308108, 1.7891874904048484],
            [15.002840098191866, 1.7619461584131135],
            [14.999410762508868, 1.751949817512717],
            [15.005220108832978, 1.7477488896908302],
            [15.00571636905699, 1.7372401944042513],
            [15.00051560408908, 1.7345511889866123],
            [14.996137935385878, 1.7235660830306176],
            [14.984230676874521, 1.7318913860862384],
            [14.961219572292226, 1.747007252643242],
            [14.930816648679974, 1.7011308997402805],
            [14.913897606654318, 1.6749028482263562],
            [14.913863712788537, 1.6749240686738776],
            [14.906846067848363, 1.6793182964472482],
            [14.896172582193905, 1.6929226692893997],
            [14.887681500785167, 1.700378029285201],
            [14.8839741785464, 1.7013029266131237],
            [14.872807432202158, 1.7013026960744089],
            [14.867923837397445, 1.6998079785481894],
            [14.85928428442102, 1.699413164817161],
            [14.848733399837718, 1.6952396893718307],
            [14.8391097442853, 1.6970174854603708],
            [14.837646965060696, 1.6956953376122754],
            [14.829719862749855, 1.6960642557909882],
            [14.826698084678375, 1.6975582634916624],
            [14.82310986425937, 1.7020431980661377],
            [14.819968328046272, 1.702544955662122],
            [14.8186866459743, 1.6990034187048186],
            [14.810041633593293, 1.703682008551329],
            [14.804371032380287, 1.7140488802063296],
            [14.801106857739478, 1.7154550943391962],
            [14.797743309168428, 1.72167855393244],
            [14.79890605301432, 1.7311730935631162],
            [14.801930989156606, 1.7352765540899562],
            [14.802617511901085, 1.7408682398188262],
            [14.800611036367547, 1.7454071768677957],
            [14.792584947317176, 1.749052312847918],
            [14.777138652478722, 1.7501696918845067],
            [14.760805225050694, 1.7596903117035576],
            [14.754253561091186, 1.7614718185100042],
            [14.743235419044998, 1.7620558374490178],
            [14.732044034230618, 1.7655774124658155],
            [14.721964375468852, 1.7689194026926538],
            [14.696053692494377, 1.7620304826078679],
            [14.691963097217009, 1.7627735296606366],
            [14.687921196339687, 1.7611272330358276],
            [14.677169980472122, 1.7618736312733956],
            [14.673161296673088, 1.7607831308925315],
            [14.664605833280048, 1.7610836379077077],
            [14.658672649015093, 1.7603650035554128],
            [14.647213990621104, 1.7619385596882213],
            [14.63521291402363, 1.7614768198579558],
            [14.627088077831623, 1.7637604008795544],
            [14.619955796955203, 1.7727816891740469],
            [14.61152212059368, 1.7854603304107175],
            [14.603140130281169, 1.7930354293570265],
            [14.595507433210496, 1.795372295828058],
            [14.579068465458521, 1.7978453709794837],
            [14.575138101253943, 1.7994721714313897],
            [14.57030240230637, 1.8056129001316732],
            [14.5668158875427, 1.814691140526016],
            [14.56465875210062, 1.8234415761967864],
            [14.566042423065795, 1.825995960595709],
            [14.566335236980755, 1.8390141240767912],
            [14.568030526769414, 1.8494615842654833],
            [14.570914730288024, 1.857838493236514],
            [14.574338561594182, 1.8621803076939263],
            [14.58808828374079, 1.8686081594152812],
            [14.59295845521285, 1.873171558778515],
            [14.594529631619354, 1.8794119235421252],
            [14.592453514889048, 1.8862944008664757],
            [14.592951628723904, 1.8929576035833118],
            [14.5949133144388, 1.8968755749948538],
            [14.60127677777862, 1.905168903267885],
            [14.601676228900303, 1.9069493644565858]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.20413471354018, "lat": 39.13632917562862 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24031"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01712500"
      },
      "bbox": [
        14.56465875210062, 1.6749028482263562, 15.048862636621914,
        2.082138467732757
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.596208733963303, 4.463166774642402],
            [7.630255079852818, 4.467370148822184],
            [7.720575196342672, 4.477506964332538],
            [7.776331277356154, 4.483173006221931],
            [7.8193251032695335, 4.4866548183271036],
            [7.839344556377231, 4.488626991059452],
            [7.876987946923037, 4.492913096196008],
            [7.905557234771552, 4.49641555993039],
            [7.93528634459102, 4.4996911021423935],
            [7.992047277712055, 4.505673545635608],
            [8.034324967615206, 4.5104479785176705],
            [8.077443917128, 4.515062704713531],
            [8.087352048086656, 4.42865496178307],
            [8.096219623397792, 4.35688665917161],
            [8.09870954211686, 4.338536439859412],
            [8.104882019647142, 4.284267870073356],
            [8.112446889605707, 4.2132206005764585],
            [8.117471388302377, 4.169482646497287],
            [8.032148767522312, 4.159586860387241],
            [8.001386412149307, 4.1563780378629],
            [7.956054561691449, 4.151163144420046],
            [7.884582110626033, 4.142942493489179],
            [7.840875154995636, 4.137425943154019],
            [7.776171094753545, 4.130176268156159],
            [7.719089913462334, 4.12417843395416],
            [7.690400340215164, 4.1214018254581255],
            [7.661900538279305, 4.1183267587818335],
            [7.619392852106144, 4.1143662654259625],
            [7.584898166132361, 4.110698273536886],
            [7.591240364232035, 4.134363913849666],
            [7.593398025800971, 4.146174370179691],
            [7.597415485605383, 4.183456068574001],
            [7.596723725085522, 4.191531983766075],
            [7.596609080516964, 4.233712258351152],
            [7.597582395403, 4.244897053049022],
            [7.598205122166316, 4.262454707631991],
            [7.600750538215078, 4.273459472720221],
            [7.601897080281989, 4.289505231173747],
            [7.598079059355361, 4.309501974200373],
            [7.5951095259569, 4.332070162184945],
            [7.596093646708865, 4.339087601891553],
            [7.601328080418017, 4.355779268000926],
            [7.602734039087332, 4.36686507617266],
            [7.602224722518722, 4.372800345733912],
            [7.603290758199492, 4.376547978056484],
            [7.6043775180284685, 4.3880138508307045],
            [7.604007231407524, 4.405470697883651],
            [7.599814794977306, 4.442736255790126],
            [7.596208733963303, 4.463166774642402]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.88831029595083,
          "lat": 42.591266599079965
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26005"],
        "coty_name": ["Allegan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allegan County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01622945"
      },
      "bbox": [
        7.584898166132361, 4.110698273536886, 8.117471388302377,
        4.515062704713531
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.549923744302596, 4.92263580689237],
            [8.641935605207022, 4.932713115086057],
            [8.726137507170655, 4.94242498704202],
            [8.804664802403307, 4.9518361251511935],
            [8.8881927081628, 4.962328148194208],
            [8.897771601810522, 4.886858140765734],
            [8.90965958980892, 4.800602698134636],
            [8.911078742529023, 4.789113539632359],
            [8.919707137858852, 4.726141279513704],
            [8.92449840201908, 4.6886875943886235],
            [8.933172189462494, 4.622355031772295],
            [8.933884884499697, 4.616575839090208],
            [8.883932156552547, 4.610085703064525],
            [8.84707701589021, 4.6054873514687324],
            [8.760696985141008, 4.595462872075323],
            [8.712635086696059, 4.589740580911172],
            [8.675854387010839, 4.585691054110043],
            [8.590836687392802, 4.575877855846595],
            [8.584874550564678, 4.626293977235963],
            [8.57002169485516, 4.748340208568523],
            [8.559553405125035, 4.83680296841574],
            [8.555660965666222, 4.8723871383407324],
            [8.549923744302596, 4.92263580689237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.60153050768781, "lat": 42.94366046381596 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26037"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01622961"
      },
      "bbox": [
        8.549923744302596, 4.575877855846595, 8.933884884499697,
        4.962328148194208
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.358900582031065, 5.126136557917967],
            [9.440747537470536, 5.138152124462693],
            [9.527504284409911, 5.149935364796692],
            [9.528777371083153, 5.142191916766832],
            [9.539719132311351, 5.0645136856932],
            [9.546375631464752, 5.017801537126795],
            [9.551589581663707, 4.978236684079546],
            [9.564742513142233, 4.892175382480365],
            [9.569756902593143, 4.860579117598365],
            [9.57815578421586, 4.810342522990397],
            [9.577619137221605, 4.805925018993051],
            [9.508504467869038, 4.794755177472285],
            [9.494092245994175, 4.79203881393001],
            [9.408861065687725, 4.7788860837622025],
            [9.413230681050392, 4.749881691586538],
            [9.416954710082, 4.727697642085712],
            [9.422385894708443, 4.691681365673365],
            [9.336613623853825, 4.678449805446556],
            [9.279695311841385, 4.671712813300175],
            [9.251913949215714, 4.667291119354197],
            [9.237397144886348, 4.753896538784508],
            [9.224180673865083, 4.841295262546733],
            [9.224951398981409, 4.841429691433675],
            [9.214118611030665, 4.928899893777934],
            [9.202331475602898, 5.01653451428637],
            [9.18902632904651, 5.103268034057542],
            [9.224957408637842, 5.108131993969114],
            [9.280487143794751, 5.115859893724415],
            [9.358900582031065, 5.126136557917967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.70667797821781, "lat": 43.02170897505091 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26049"],
        "coty_name": ["Genesee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Genesee County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01622967"
      },
      "bbox": [
        9.18902632904651, 4.667291119354197, 9.57815578421586, 5.149935364796692
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0392010940860306, 8.032847517678219],
            [1.0388881876152942, 8.075795589495437],
            [1.03891883570339, 8.118735883518514],
            [1.1250555579888, 8.120373388324381],
            [1.2116674513235854, 8.120797515979019],
            [1.235961512376181, 8.121169123169189],
            [1.2596034640419644, 8.120466931369284],
            [1.297224008794176, 8.120727371299331],
            [1.2986686020751, 8.034709261649441],
            [1.3002783806395346, 7.949345182169686],
            [1.3039826230588956, 7.9489449870968105],
            [1.30500603008233, 7.90630224821653],
            [1.3057328919917373, 7.8641697794811725],
            [1.3068565899678661, 7.81988176635017],
            [1.3079704197698485, 7.716344583598604],
            [1.31250853137038, 7.714220066437714],
            [1.3145203597182458, 7.719038682884139],
            [1.319371302752046, 7.716109164736523],
            [1.3174860187452804, 7.712525526387068],
            [1.324746575677188, 7.706980234556133],
            [1.326242055486845, 7.702638466471336],
            [1.328726559823142, 7.70285863363244],
            [1.3308918857111491, 7.707204610184751],
            [1.3344404406545487, 7.702630911283593],
            [1.340716001587977, 7.70667149796616],
            [1.3433316303889473, 7.70397988676236],
            [1.3415603509600011, 7.699191818060393],
            [1.3412791591063398, 7.691461660478304],
            [1.2722472189525316, 7.690352129807772],
            [1.2216597492887622, 7.690128575482391],
            [1.148747974810928, 7.689182441976242],
            [1.1347066184233168, 7.689204030802235],
            [1.087711485795829, 7.6887404398954295],
            [1.0478911225086665, 7.68850143492259],
            [1.0469024993697365, 7.803223207549876],
            [1.0465290442370456, 7.853247372676695],
            [1.0455992737153232, 7.94635784624358],
            [1.0401891593670163, 7.946308484981686],
            [1.039189289785415, 8.003960576577933],
            [1.0392010940860306, 8.032847517678219]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.96941291157812,
          "lat": 46.585753479189286
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27159"],
        "coty_name": ["Wadena"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wadena County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00659524"
      },
      "bbox": [
        1.0388881876152942, 7.68850143492259, 1.3433316303889473,
        8.121169123169189
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.709405707081906, -5.9358541268663645],
            [5.713310450829954, -5.992719486980119],
            [5.79535513791182, -5.9881727557705355],
            [5.843618079126549, -5.984941321943791],
            [5.880666656064172, -5.982272358197285],
            [6.010221485659514, -5.973733842039231],
            [6.054057241476208, -5.9704181643578185],
            [6.056968936412399, -6.008325741768862],
            [6.060668305962999, -6.062906280234596],
            [6.067227348691463, -6.157079847850449],
            [6.0729845307256465, -6.238186683037867],
            [6.078890520396829, -6.322395127335344],
            [6.041634541232847, -6.324889077039466],
            [6.034942025974395, -6.325770386019944],
            [5.920542497789583, -6.333345485249844],
            [5.848014380061488, -6.337992229306465],
            [5.760699338385586, -6.343731079641046],
            [5.761113225818871, -6.345482932454778],
            [5.736624970559796, -6.34703541960846],
            [5.734960668899084, -6.3190019899648915],
            [5.729628857254977, -6.2341022240466355],
            [5.728267215238099, -6.216705556378559],
            [5.698450239644301, -6.101786676513564],
            [5.679231002847916, -6.028357225471886],
            [5.66755293994093, -5.986046874957245],
            [5.669760684582051, -5.982996100360875],
            [5.668802125532811, -5.975467313976979],
            [5.677896892583395, -5.973049728925417],
            [5.680823629077075, -5.970449750092148],
            [5.677327717289992, -5.966103827855759],
            [5.681377073640799, -5.963882576141914],
            [5.6853271938617675, -5.965026872164808],
            [5.686666837990877, -5.958082298967073],
            [5.692545500322754, -5.951098078869374],
            [5.700963508523696, -5.9447878171063895],
            [5.704607042676056, -5.937285162896957],
            [5.709405707081906, -5.9358541268663645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.53764265103668, "lat": 32.4063872892311 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28123"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00695782"
      },
      "bbox": [
        5.66755293994093, -6.34703541960846, 6.078890520396829,
        -5.9358541268663645
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6401822948134792, 1.9011802407597256],
            [0.6990626776108124, 1.9005148048042038],
            [0.733396490277555, 1.900488693731867],
            [0.7565667103123276, 1.8998346790926994],
            [0.82107962269591, 1.8987111233883225],
            [0.9351320205061773, 1.8977695691884187],
            [0.9472725687221495, 1.8974458748726653],
            [1.0498885362990558, 1.8969289800673526],
            [1.0643928447470592, 1.8967475000682272],
            [1.0646715755509095, 1.8834186020578327],
            [1.0654209644256252, 1.7965419071826165],
            [1.0837515771017496, 1.7964641477484469],
            [1.084579371639346, 1.709030260096235],
            [1.084257981478763, 1.650494583624271],
            [1.0834495943262854, 1.5774223239953074],
            [1.0619629847647232, 1.5778283851478854],
            [0.9827807378804421, 1.577660053769478],
            [0.9109997303211195, 1.577528749508461],
            [0.8758362014690477, 1.5780720569979707],
            [0.800425923196658, 1.5783177071911836],
            [0.7992938425335011, 1.5846676922310572],
            [0.8028648006374676, 1.5950728043632787],
            [0.8032361970536512, 1.6000024253495058],
            [0.8014529062310387, 1.6052496448868951],
            [0.7973186538055266, 1.6098858350382248],
            [0.7901913013275751, 1.6132367977145998],
            [0.7798733382700641, 1.613645528689572],
            [0.7735245813258907, 1.6172678070894733],
            [0.767077557793489, 1.6239067418657158],
            [0.758155493528625, 1.6280661303583408],
            [0.7485074437630846, 1.6265134478797727],
            [0.7386275748105708, 1.6216400742914443],
            [0.7318182457314256, 1.6196154332145676],
            [0.7271449575386275, 1.6205976121174122],
            [0.722730056905336, 1.6247891639963008],
            [0.7223826136342079, 1.6297619665936554],
            [0.7254070509978865, 1.6366247973364176],
            [0.7297772973981332, 1.6396401647235361],
            [0.7404353554330364, 1.6434532543746079],
            [0.7469158887605598, 1.64851195067202],
            [0.7487784399646834, 1.6551431251518034],
            [0.747982024994372, 1.6608994503867494],
            [0.7453919738917534, 1.6671751107621022],
            [0.7379059868044017, 1.6757786574677453],
            [0.7337780887551317, 1.6843036633497426],
            [0.7339477568673364, 1.692789390009291],
            [0.7325659079323931, 1.701462816292197],
            [0.7283909597552531, 1.7108256610186747],
            [0.7210111034237816, 1.723445308714628],
            [0.7192272040470026, 1.7307568755658973],
            [0.7230858924832606, 1.7436961845688883],
            [0.7235605545680615, 1.7497188878310996],
            [0.721603173435057, 1.7569155672502557],
            [0.7161210950339166, 1.7662757519792256],
            [0.7113279021378655, 1.771818028856643],
            [0.7017862283084878, 1.7785123071340774],
            [0.6951524788636128, 1.7845707815482827],
            [0.692389910647049, 1.7940934948540341],
            [0.6938727492224883, 1.8089736231206728],
            [0.6929362167037939, 1.8144647483899812],
            [0.6898831221722344, 1.8207305435000283],
            [0.6958176942823829, 1.8236311413052966],
            [0.713959288558183, 1.830575580857294],
            [0.7186941764866784, 1.8329606603027442],
            [0.7232027455468375, 1.8392763829284275],
            [0.7257200793611711, 1.853962412582397],
            [0.7229874293927007, 1.8625172842892643],
            [0.7182681059946715, 1.8658778615428184],
            [0.7156914432078094, 1.872650927400427],
            [0.710949796466817, 1.8786230696999582],
            [0.7057052905437579, 1.8785386183403177],
            [0.6993921452896861, 1.8766060400459565],
            [0.6941036160081335, 1.8728363390526157],
            [0.6922390840771597, 1.8609285149607246],
            [0.6918072651629559, 1.8527081418491587],
            [0.6935005817792839, 1.848820787620618],
            [0.6918880980065623, 1.844130375836676],
            [0.6833341222830278, 1.8371205730778246],
            [0.6822850357690751, 1.8393828903479632],
            [0.6790216911040627, 1.842811109983004],
            [0.672875745507161, 1.843710403220329],
            [0.6617312802603796, 1.839456238319712],
            [0.6531174799589197, 1.83978079837002],
            [0.6467608062914589, 1.8414934106380183],
            [0.6393550734702627, 1.847093764746441],
            [0.637563701111645, 1.852224292822794],
            [0.6382093318884937, 1.8559472024958439],
            [0.641796467812463, 1.8639723212936847],
            [0.6407158594608241, 1.8726633524672187],
            [0.6356125723429867, 1.8819383442047055],
            [0.6333897457013911, 1.8894348747301664],
            [0.6342483383052611, 1.8941057326083874],
            [0.6401822948134792, 1.9011802407597256]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.4280831316425, "lat": 40.430796625256974 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29005"],
        "coty_name": ["Atchison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Atchison County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00758457"
      },
      "bbox": [
        0.6333897457013911, 1.5774223239953074, 1.084579371639346,
        1.9011802407597256
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9962456549884013, -1.956773486076901],
            [1.9965808977296613, -1.945936525739409],
            [1.9976361471528465, -1.873612341666983],
            [1.996552604340886, -1.8735930031279553],
            [1.9964588430511947, -1.861977665020249],
            [1.996936712620518, -1.829555090104322],
            [1.9969482008701918, -1.7952071073718054],
            [1.9973464377548011, -1.771079565249968],
            [2.068894882463805, -1.771434918666898],
            [2.097530112465866, -1.7718453713102784],
            [2.1836759749095838, -1.771770372511061],
            [2.2694426030896726, -1.7712233251602605],
            [2.3551168578955877, -1.7719679551231875],
            [2.355376317958414, -1.8090613050353117],
            [2.3558965000742416, -1.8313564481789764],
            [2.356185430425978, -1.875177958167222],
            [2.387213473935876, -1.8749275318057288],
            [2.3872963876956055, -1.9596363349484665],
            [2.3866670868078406, -2.067739756600744],
            [2.386894499296494, -2.111079865416945],
            [2.3867235896918633, -2.1785091316288834],
            [2.387160704266452, -2.19904151094914],
            [2.2799813445905723, -2.201403816965943],
            [2.2727175288217443, -2.201719986895591],
            [2.162333814476749, -2.204527315472288],
            [2.0886954859050073, -2.2062156840250617],
            [1.9948336274963112, -2.208158617982089],
            [1.9948184566392215, -2.197695804918671],
            [1.9954556835572368, -2.131922964736875],
            [1.996564957340935, -2.052571198371756],
            [1.9960354962165208, -2.0441898965538363],
            [1.9976382300857487, -1.956823911700529],
            [1.9962456549884013, -1.956773486076901]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.82903997050786, "lat": 36.70987130528629 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29009"],
        "coty_name": ["Barry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barry County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00758459"
      },
      "bbox": [
        1.9948184566392215, -2.208158617982089, 2.3872963876956055,
        -1.771079565249968
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5200612971203824, 1.4457424164946093],
            [1.5202953560759935, 1.4459566992615118],
            [1.5198849243094144, 1.5337960869227694],
            [1.5205749369131538, 1.5376263450734613],
            [1.519873418915862, 1.5921399479612062],
            [1.5199663264932035, 1.6213531280378797],
            [1.5208823272417258, 1.6215249534421252],
            [1.5218328320226122, 1.7086213526712648],
            [1.6116263712896948, 1.7098992680781562],
            [1.6260134105426431, 1.7098826798157774],
            [1.6969382830043487, 1.711379820560605],
            [1.7400470216913708, 1.7120920511287374],
            [1.811913211795395, 1.711002427058981],
            [1.8123231051871256, 1.6227143221044233],
            [1.8133763791166126, 1.5420855161627345],
            [1.813732168982237, 1.5346662932539823],
            [1.814775533254694, 1.4612597099661786],
            [1.8151481105521663, 1.4495673333731638],
            [1.8151056659056757, 1.3586127884960688],
            [1.7865339956680426, 1.3597721684375386],
            [1.7306966735133398, 1.3614898848683408],
            [1.6824190804558765, 1.3605711313682416],
            [1.6376620178982462, 1.3595179345682238],
            [1.5370507836095944, 1.3583983972864753],
            [1.5217762125567849, 1.358083906777559],
            [1.520851686879139, 1.3580562241987901],
            [1.5200612971203824, 1.4457424164946093]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.40988846647659, "lat": 40.21207434808538 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29075"],
        "coty_name": ["Gentry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gentry County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00758492"
      },
      "bbox": [
        1.519873418915862, 1.3580562241987901, 1.8151481105521663,
        1.7120920511287374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9019668734285267, -1.7516380244053316],
            [3.9624297045151646, -1.7495278042638909],
            [3.9979786494063725, -1.7488989474284622],
            [4.027056918978789, -1.7476628533788097],
            [4.032625645588038, -1.748244563559414],
            [4.126037956616915, -1.744433653538496],
            [4.130628445965512, -1.7439271551867306],
            [4.224959825791131, -1.7397958156431692],
            [4.246624171895078, -1.7400161340294198],
            [4.246606298858818, -1.750190410686496],
            [4.247995672093328, -1.7987328759875068],
            [4.334325473594547, -1.7963723914332899],
            [4.3352011150071466, -1.8199167571265635],
            [4.335319838928764, -1.8403944554954856],
            [4.333661089310737, -1.840453408328831],
            [4.33527697290513, -1.8903656935021016],
            [4.336294614866086, -1.9280427574964625],
            [4.338663328513282, -1.9928959744094776],
            [4.3395491128281485, -2.0225758165184917],
            [4.340200255346304, -2.0279179755495877],
            [4.342459593432086, -2.1229026275007494],
            [4.342796797041927, -2.1252612096054966],
            [4.270571356069662, -2.1291338056689795],
            [4.262582775859673, -2.1294283641331666],
            [4.18300900244827, -2.1336657689802068],
            [4.119863541954231, -2.1369640657237703],
            [4.085522009106681, -2.138168349800434],
            [4.045598691339873, -2.138806946575266],
            [4.016367136086727, -2.1398379160893493],
            [3.9411423743307474, -2.1432906128473297],
            [3.9085929650363544, -2.144512084199942],
            [3.906912119633469, -2.0993843107934005],
            [3.9037006111657275, -2.036531608517473],
            [3.899190100625063, -2.0365894112289387],
            [3.8980647021461556, -2.0181479033736616],
            [3.8962959826188786, -1.9486883610191477],
            [3.8938405941705576, -1.8539293230057607],
            [3.905122346469218, -1.8537189751852716],
            [3.9040870352627026, -1.800058137996866],
            [3.903162453150858, -1.7830167260100478],
            [3.9019668734285267, -1.7516380244053316]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.40331270829151,
          "lat": 36.686684195287356
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29149"],
        "coty_name": ["Oregon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oregon County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00758529"
      },
      "bbox": [
        3.8938405941705576, -2.144512084199942, 4.342796797041927,
        -1.7397958156431692
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0287900737069964, -1.869892021940513],
            [3.043148144810948, -1.8697947673914839],
            [3.1733049334467505, -1.867981346437954],
            [3.200707969892473, -1.8674960508381466],
            [3.2523517462293254, -1.867081185856637],
            [3.3442431152820205, -1.865333643237521],
            [3.473437726730816, -1.8635214860349525],
            [3.546383908527352, -1.8624806832805427],
            [3.5467023956818875, -1.8945782998721554],
            [3.549091496675444, -2.006618334017477],
            [3.5498773169600377, -2.0395193986293316],
            [3.5511053985889243, -2.105678574765281],
            [3.551590179317729, -2.119854048265811],
            [3.5521807284203213, -2.160504943863495],
            [3.5284007668939528, -2.161703446663458],
            [3.4757965636374752, -2.16403434575599],
            [3.401809318558344, -2.167470929265601],
            [3.3693064506474717, -2.1688337886483886],
            [3.349530012843981, -2.1701840573746947],
            [3.341732518948014, -2.1698288208260887],
            [3.3135164663425614, -2.1708268696222115],
            [3.2945977298560947, -2.1709190485624648],
            [3.2367334440971263, -2.1728472254725903],
            [3.2269552491878133, -2.1733352280748015],
            [3.1990308015116278, -2.1747218819312706],
            [3.146192081376006, -2.176763704078592],
            [3.033443277537629, -2.1809970735778603],
            [3.0316142276167626, -2.058239384648696],
            [3.0307385384104966, -1.9936339002366952],
            [3.0294455741863637, -1.9205707406292398],
            [3.0287900737069964, -1.869892021940513]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.44469939995689, "lat": 36.64930850788055 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29153"],
        "coty_name": ["Ozark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ozark County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00758531"
      },
      "bbox": [
        3.0287900737069964, -2.1809970735778603, 3.5521807284203213,
        -1.8624806832805427
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.8161395118107055, -0.5376887318205796],
            [4.880450973597394, -0.481230212051231],
            [4.884256825054302, -0.48198402565576964],
            [4.8866779220539405, -0.4803006126658578],
            [4.889813327275148, -0.482296018539469],
            [4.900471189579481, -0.4846465812895041],
            [4.90897164182483, -0.4845285686882778],
            [4.910255311540648, -0.4820882639043313],
            [4.917096960350179, -0.47505750840751065],
            [4.917040758809229, -0.46989961235629335],
            [4.922855972283135, -0.46788193901242425],
            [4.925903086374952, -0.4650152487163404],
            [4.932006940976276, -0.46443715833636734],
            [4.933720812849285, -0.45779636378076033],
            [4.938861978756417, -0.45342052051499593],
            [4.935573839726664, -0.4456579391791221],
            [4.938096643429673, -0.44392209061555227],
            [4.940245331292901, -0.4465830338000448],
            [4.946447071633164, -0.4587363764216987],
            [4.966553063372418, -0.4760317833989009],
            [4.977418787719767, -0.48316780833435846],
            [5.000307973736835, -0.49745262472298124],
            [5.0042457103263285, -0.49874469981503183],
            [5.0108083441365805, -0.4935754282627527],
            [5.015103388954788, -0.4928549480676732],
            [5.025812358829804, -0.49803770878064996],
            [5.03693969229097, -0.5041107717421147],
            [5.040821771537746, -0.5114018656936519],
            [5.041864305972568, -0.5256986600416379],
            [5.049253598383629, -0.5343404713174197],
            [5.054950397374585, -0.539208727394614],
            [5.068534622560188, -0.5471809236635348],
            [5.072957445921352, -0.5489907945107831],
            [5.078664093569373, -0.5489832152928308],
            [5.0853207756032, -0.5469763592206045],
            [5.095469677693872, -0.5478170371047688],
            [5.098785970857651, -0.5512416323976388],
            [5.101461901310474, -0.5569432236975347],
            [5.115096438620853, -0.5646391587138265],
            [5.118320336118737, -0.5671399735569618],
            [5.126799490975004, -0.5763477574385613],
            [5.140569950037069, -0.5930771979498666],
            [5.147285407958272, -0.5974911713784803],
            [5.153951238854548, -0.5985020249226293],
            [5.172832800022228, -0.5945061922524769],
            [5.190687744829551, -0.5868282131279676],
            [5.195238612853706, -0.5981372150648591],
            [5.2036054497864725, -0.5971499161949196],
            [5.203748539771812, -0.6031014971985165],
            [5.198660416300401, -0.6101384325393164],
            [5.194489310719347, -0.6117243662571793],
            [5.187460526329532, -0.618099157643813],
            [5.177947618438797, -0.6188467845431908],
            [5.176274066260099, -0.6248551457327722],
            [5.1717117310457095, -0.6280865186835987],
            [5.166906706986636, -0.633184580527658],
            [5.167930035301129, -0.6407101287051086],
            [5.187176581592704, -0.6759099491326196],
            [5.198858808188511, -0.6833677521155123],
            [5.198579164441769, -0.6842170871381565],
            [5.154115650598261, -0.740429788593047],
            [5.147487937119171, -0.7547114005241912],
            [5.118954624335614, -0.8149500952921214],
            [5.118386134890398, -0.8155431679366303],
            [5.0771499245210405, -0.8971892644582741],
            [5.041236293672012, -0.8706525387604345],
            [5.007100999676493, -0.9032336388765736],
            [4.957941134842827, -0.8573832675610894],
            [4.950508317919933, -0.84965903754179],
            [4.909090800910068, -0.8093616241309629],
            [4.8837722426731744, -0.7853743809264517],
            [4.858453689153879, -0.7625799690950735],
            [4.824661958542362, -0.732666740990096],
            [4.79218867401403, -0.7043618395770744],
            [4.79800618253379, -0.697719602285173],
            [4.8292954421240735, -0.6635454805421769],
            [4.892312822353591, -0.5944548668378432],
            [4.819271820678571, -0.540175880403486],
            [4.8161395118107055, -0.5376887318205796]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.19442745722033, "lat": 37.89446239970994 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29186"],
        "coty_name": ["Ste. Genevieve"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ste. Genevieve County"],
        "coty_fp_code": "186",
        "coty_gnis_code": "00765806"
      },
      "bbox": [
        4.79218867401403, -0.9032336388765736, 5.203748539771812,
        -0.44392209061555227
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.150568230195054, 7.962572218854304],
            [-11.146413906128677, 7.966666642332494],
            [-11.142071957137084, 7.967902974825061],
            [-11.139350794458517, 7.9667848208033485],
            [-11.132205975838797, 7.966999981633501],
            [-11.12576717782376, 7.971516936961044],
            [-11.11292334642521, 7.976766837168032],
            [-11.110764099696619, 7.978601291868971],
            [-11.103377705625567, 7.980302818399019],
            [-11.090986554744088, 7.9862613446383515],
            [-11.084727032510308, 7.987638895759663],
            [-11.076681801331155, 7.994002993710721],
            [-11.074400658651342, 7.997046035008414],
            [-11.06589613513244, 8.00131641627022],
            [-11.045845336441575, 8.003864597958934],
            [-11.040476704997742, 8.011500530876242],
            [-11.036354243474035, 8.014812348501728],
            [-11.031898471337472, 8.015698868349794],
            [-11.023990134275307, 8.02362769945802],
            [-11.023958013365531, 8.03006769937705],
            [-11.021633133267375, 8.043353613915382],
            [-11.01128773923842, 8.060692995495367],
            [-11.008283394718088, 8.063938959780433],
            [-10.997325934271377, 8.071389689162439],
            [-10.988433438457575, 8.06908505209283],
            [-10.975103685468229, 8.050277762468163],
            [-10.919374894540029, 8.042493919606045],
            [-10.796138982091918, 8.025314620272542],
            [-10.787254952251445, 8.02395342127535],
            [-10.784082601010688, 8.022273561902173],
            [-10.778452606458096, 8.024771020873631],
            [-10.772207183123754, 8.022876045056204],
            [-10.76759666692987, 8.025664174762932],
            [-10.763013188117698, 8.026827666950327],
            [-10.752386437348365, 8.0362250070086],
            [-10.746412844380597, 8.040319447169358],
            [-10.745321460609878, 8.049743786254883],
            [-10.738422570784463, 8.055339454632303],
            [-10.737235514364151, 8.060558235140736],
            [-10.733971266149128, 8.061190917217651],
            [-10.730438842489443, 8.065756874919863],
            [-10.727315364977164, 8.067125258492572],
            [-10.723817340980787, 8.071136074292523],
            [-10.727240472209163, 8.078232790876333],
            [-10.722872567115758, 8.08953517314072],
            [-10.723053137227772, 8.098973698539362],
            [-10.718128536175982, 8.097849054579601],
            [-10.712923227372217, 8.104248280089717],
            [-10.708756378811337, 8.100869500971871],
            [-10.706055154548453, 8.101300248167046],
            [-10.700466260273336, 8.110139504863307],
            [-10.694485615697971, 8.108233845896915],
            [-10.686690876508457, 8.111437146654257],
            [-10.678277093033438, 8.107168405457761],
            [-10.66970743234739, 8.111556957269519],
            [-10.667195861605405, 8.109545037734723],
            [-10.663370728835899, 8.113176698789891],
            [-10.661245487606562, 8.110300188184688],
            [-10.65354464380775, 8.111979766161838],
            [-10.649666867391252, 8.11097837752855],
            [-10.643635823062564, 8.107411680792001],
            [-10.644168824635077, 8.102134181925141],
            [-10.630447397494812, 8.097282734963056],
            [-10.62891519536741, 8.095507301757772],
            [-10.612511728876852, 8.09953157150575],
            [-10.60805887757285, 8.095966482668251],
            [-10.604546127429316, 8.100079932230742],
            [-10.599928775762123, 8.100497331946322],
            [-10.598164756401754, 8.096560303175208],
            [-10.588145787523324, 8.097896957782078],
            [-10.587845822203944, 8.094276713749922],
            [-10.584239003928374, 8.090951394900264],
            [-10.584259178101666, 8.085466696187547],
            [-10.578972796098878, 8.079621524528385],
            [-10.583258376976579, 8.073210068963181],
            [-10.578777768526693, 8.068516856940414],
            [-10.569686710594594, 8.06903830862354],
            [-10.563153892283962, 8.068541663538399],
            [-10.56057748909992, 8.066252526701657],
            [-10.559331010774436, 8.059438500731847],
            [-10.556717093049517, 8.054856952226226],
            [-10.55151684968782, 8.05639184343183],
            [-10.54932969015591, 8.054620539331294],
            [-10.536149375282243, 8.054712683910845],
            [-10.530415793947128, 8.052626225857558],
            [-10.525168192489469, 8.045854243757953],
            [-10.522608033086486, 8.044154260780138],
            [-10.515246422644902, 8.04284369011574],
            [-10.513436143987947, 8.039218337722309],
            [-10.514536856067883, 8.03401931291181],
            [-10.513966350083656, 8.027952472970696],
            [-10.515961246132509, 8.0166885933765],
            [-10.487001270612092, 8.01196202693058],
            [-10.489320863763487, 7.99802621107328],
            [-10.460829952203957, 7.993124176062821],
            [-10.465503759845603, 7.964709929351979],
            [-10.451551750242093, 7.962150896067127],
            [-10.422821791961034, 7.957733612792248],
            [-10.425202895129766, 7.943567532754611],
            [-10.411425342266279, 7.941291143008583],
            [-10.413783117603597, 7.9271100217376285],
            [-10.399519671109942, 7.924823912425686],
            [-10.401891142296842, 7.910663947100552],
            [-10.387591202363762, 7.908416059027139],
            [-10.38996017282385, 7.893912333101467],
            [-10.375766673676077, 7.891716082763335],
            [-10.378135756025, 7.877573459244224],
            [-10.363826839522444, 7.875455691341433],
            [-10.366174129260878, 7.861220044532215],
            [-10.351858967808653, 7.859286995792393],
            [-10.354178296217968, 7.845037618501212],
            [-10.226638611107376, 7.824004155218615],
            [-10.233586408147524, 7.781529906839486],
            [-10.249547262216717, 7.683185737142519],
            [-10.259238131543107, 7.625272145473397],
            [-10.258586561240792, 7.625166922232189],
            [-10.272563777321936, 7.5388342482532185],
            [-10.288514637191321, 7.541385391977062],
            [-10.305451077807486, 7.439035254299006],
            [-10.319418532795487, 7.352010054010141],
            [-10.331702558458353, 7.276960565698539],
            [-10.344714046343391, 7.19765279125043],
            [-10.344484746495635, 7.197615672248087],
            [-10.358673636797162, 7.111410140251818],
            [-10.362345459839048, 7.112002729751319],
            [-10.388033698564971, 6.954345362440203],
            [-10.392995878929563, 6.958918637330573],
            [-10.398558971845056, 6.957272073911767],
            [-10.402869860207336, 6.952406462797343],
            [-10.401215745176115, 6.950072181792827],
            [-10.402693607782634, 6.945501697411328],
            [-10.406317019368084, 6.94028751413224],
            [-10.405700441066449, 6.933804749590868],
            [-10.406827643559234, 6.930100259121167],
            [-10.411478090956315, 6.928074146698791],
            [-10.420541973673558, 6.918882879474445],
            [-10.427401457867793, 6.923995028574508],
            [-10.427789434354004, 6.926836032540659],
            [-10.431149801063777, 6.930641073269755],
            [-10.438922312287444, 6.9314397409448985],
            [-10.44193491119749, 6.92941513478915],
            [-10.456405331852011, 6.9274607380650375],
            [-10.463314350853182, 6.923643158296746],
            [-10.507039949384755, 6.93075449333639],
            [-10.507119927529153, 6.930264515475629],
            [-10.59180075143218, 6.944675234687685],
            [-10.621097116510931, 6.949423019126847],
            [-10.677521076675244, 6.959217354298965],
            [-10.66560812419971, 7.030021694991453],
            [-10.750761743307542, 7.044240313731712],
            [-10.75058070590784, 7.045304065128473],
            [-10.835869558681786, 7.05965653583294],
            [-10.835635595605115, 7.061003792984496],
            [-10.864033884325465, 7.0657952897769345],
            [-10.856786339481234, 7.107440458852614],
            [-10.913323995415098, 7.117193035458144],
            [-10.927441850088416, 7.120203858250192],
            [-10.912800098277126, 7.204277542567249],
            [-10.929254661859138, 7.207232771597114],
            [-10.926538479887999, 7.221507931387451],
            [-10.917648428256879, 7.279018237799364],
            [-10.914737661677941, 7.293236055895337],
            [-11.01428627375696, 7.310305386735018],
            [-10.998992628869539, 7.396264145949251],
            [-11.0844038401963, 7.411108404403318],
            [-11.069947685411174, 7.4955112859238024],
            [-11.057003252723486, 7.568199495652721],
            [-11.04257697084589, 7.65187297527631],
            [-11.040169878664832, 7.666712062082527],
            [-11.044718946043679, 7.6675008100134185],
            [-11.036911370697458, 7.710430262841013],
            [-11.056950511685827, 7.76331242468231],
            [-11.07643824633581, 7.768141583845444],
            [-11.079401537201795, 7.770624689701298],
            [-11.084797725516662, 7.76832793685957],
            [-11.090888331970817, 7.767081302862846],
            [-11.102123927597887, 7.76294526675726],
            [-11.108750691424245, 7.7590836262006215],
            [-11.112733346667412, 7.760273196634281],
            [-11.115312836684339, 7.762937656412848],
            [-11.117854804982336, 7.761112551497478],
            [-11.124781580061022, 7.762060628267501],
            [-11.129606744108129, 7.769985011946536],
            [-11.13396204535393, 7.77048339065962],
            [-11.136128453053647, 7.773860393332603],
            [-11.14207735012914, 7.775600361833888],
            [-11.142991877188997, 7.780660303627697],
            [-11.14585353581334, 7.782483908834947],
            [-11.144672203921823, 7.786883760481377],
            [-11.148047504463275, 7.791541588033428],
            [-11.151998373148059, 7.794505309609544],
            [-11.156192820261213, 7.79433821176389],
            [-11.160553025504457, 7.797113666240784],
            [-11.160292441383032, 7.8027070938236935],
            [-11.167073169242038, 7.809548438236421],
            [-11.16757955387233, 7.812290819358843],
            [-11.174965631557919, 7.818553061231874],
            [-11.17689056590326, 7.818719290560166],
            [-11.178330864042769, 7.83059923181236],
            [-11.174617407959673, 7.83553169780821],
            [-11.17461133490455, 7.841253535857628],
            [-11.172403591467845, 7.848115471342044],
            [-11.173155891336622, 7.853317304886757],
            [-11.178329705503623, 7.855568063332072],
            [-11.17894908395445, 7.860117735407776],
            [-11.177507081543064, 7.864530111048984],
            [-11.178842444308838, 7.875396395167922],
            [-11.169732244175302, 7.883374894646714],
            [-11.168419360350505, 7.887109352522324],
            [-11.169117927121192, 7.890984089525722],
            [-11.164173309163349, 7.896672087875825],
            [-11.161942023748155, 7.901303017353951],
            [-11.160085675138035, 7.908582538305529],
            [-11.16020494032941, 7.912684830547525],
            [-11.158401804140935, 7.918682934432114],
            [-11.157263585337333, 7.930447475563077],
            [-11.154863065992009, 7.93913461515472],
            [-11.15231147967354, 7.940428029969174],
            [-11.14743087463342, 7.949201017269201],
            [-11.149068964543703, 7.951189050400197],
            [-11.148624364439728, 7.960088068218464],
            [-11.150568230195054, 7.962572218854304]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.92026941716169,
          "lat": 45.300688300948224
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30057"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01720033"
      },
      "bbox": [
        -11.17894908395445, 6.918882879474445, -10.226638611107376,
        8.113176698789891
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.832677412376311, 8.01661720622315],
            [-8.819731340409275, 8.102265472180903],
            [-8.736614728070244, 8.090466502501664],
            [-8.653501081819643, 8.078647137059516],
            [-8.597778730761691, 8.070935539763603],
            [-8.481678266712946, 8.05558542610235],
            [-8.496535076414128, 7.950340260149168],
            [-8.500007021969935, 7.914494834081446],
            [-8.503522589861992, 7.8859651746151025],
            [-8.489271693017152, 7.884007604224372],
            [-8.49741238735314, 7.826433799975799],
            [-8.513137823398473, 7.7122782332083615],
            [-8.515160453785764, 7.71255203163024],
            [-8.526702877605068, 7.627255935385046],
            [-8.528795684907813, 7.6129935735184215],
            [-8.514631776890957, 7.611192109853436],
            [-8.518662920862027, 7.58256411781773],
            [-8.504406103292537, 7.580566047964099],
            [-8.506240324506676, 7.566546394704132],
            [-8.4919848534466, 7.564659572213288],
            [-8.495722229872163, 7.536744415312189],
            [-8.507856732094856, 7.540853514190864],
            [-8.51095659148087, 7.540027742510954],
            [-8.513238945151334, 7.535968027648906],
            [-8.530398302528162, 7.532915134311493],
            [-8.544004809916325, 7.5345624041074615],
            [-8.55053299335501, 7.538846356124144],
            [-8.55980519618284, 7.537223498652121],
            [-8.57153134450683, 7.546581874070832],
            [-8.577089789360931, 7.548272017464642],
            [-8.579071855146402, 7.551030434814638],
            [-8.585962617629411, 7.554591176262676],
            [-8.5885381855033, 7.554678862451026],
            [-8.595634187010058, 7.550472054711453],
            [-8.605230136582275, 7.55028121977627],
            [-8.614036838328087, 7.54907856671956],
            [-8.620466027302097, 7.543748358454492],
            [-8.625849984611822, 7.544713512162149],
            [-8.632096336680362, 7.539449112350332],
            [-8.634859834769731, 7.5355311518727355],
            [-8.642717916799095, 7.534319956332242],
            [-8.655847184979896, 7.530706712030454],
            [-8.666570581579062, 7.535619690684389],
            [-8.677190428439719, 7.533890212346644],
            [-8.685507640645366, 7.535765879602599],
            [-8.695399425525073, 7.540710401209567],
            [-8.696910066032677, 7.539850886289468],
            [-8.705551568193293, 7.477278441286421],
            [-8.749487675263525, 7.483419047876139],
            [-8.757739706562859, 7.4259011771486865],
            [-8.872110697123052, 7.4416658784642555],
            [-8.874165228149876, 7.427448138645932],
            [-8.917164179821455, 7.433412816867089],
            [-8.919170592330687, 7.419206499469625],
            [-8.933257948760566, 7.421167388397282],
            [-8.935258805737362, 7.406922244267657],
            [-8.963853545645335, 7.411027912740989],
            [-8.965906898697668, 7.396816338117901],
            [-8.980232845736941, 7.398813351004525],
            [-8.982284268181488, 7.384592523743442],
            [-8.996575254295733, 7.386627852230562],
            [-8.998622653491278, 7.372397476045056],
            [-9.012885207013458, 7.374415908409661],
            [-9.014935750856894, 7.360195040249406],
            [-9.029222025077466, 7.36219897344997],
            [-9.031283362964086, 7.347988707228047],
            [-9.035246911479515, 7.348558598207667],
            [-9.037327305514173, 7.33434002468898],
            [-9.051629248949576, 7.336387397740515],
            [-9.055741919035636, 7.3078692838598736],
            [-9.070112988245702, 7.3098806607316735],
            [-9.076080122558297, 7.267227124746757],
            [-9.131324808008523, 7.275145946832141],
            [-9.144795176589247, 7.182681926732112],
            [-9.222085826778022, 7.193848192837498],
            [-9.221387495543649, 7.19855293608622],
            [-9.31400946203216, 7.21213188265863],
            [-9.406634843682367, 7.225687475683977],
            [-9.380620024433156, 7.399080629465598],
            [-9.288479003009034, 7.385524473186917],
            [-9.263132051069734, 7.555937989460692],
            [-9.177735821534348, 7.543509066505903],
            [-9.17141196228209, 7.586121979357152],
            [-9.085947268604185, 7.5734667341714985],
            [-9.079719430385975, 7.616042294066269],
            [-8.994299442082708, 7.603919172110372],
            [-8.979736535977553, 7.704248413682975],
            [-8.980179264055163, 7.710176631434299],
            [-8.97078760222651, 7.775034106127343],
            [-8.958796785606394, 7.773332097202135],
            [-8.947977997831352, 7.859062331804777],
            [-8.918482016197293, 7.85434448283775],
            [-8.916044962316546, 7.8700878993089045],
            [-8.906348907744261, 7.941467725732722],
            [-8.848628244973925, 7.934212392523669],
            [-8.838355801370291, 8.005692330387],
            [-8.83457172610437, 8.011060779650657],
            [-8.832677412376311, 8.01661720622315]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.39518822603328,
          "lat": 45.66905013689393
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30095"],
        "coty_name": ["Stillwater"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stillwater County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01719572"
      },
      "bbox": [
        -9.406634843682367, 7.182681926732112, -8.481678266712946,
        8.102265472180903
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5888030523564733, 4.395430667108472],
            [-2.5368424134263843, 4.393329683465021],
            [-2.469624860505453, 4.3901634520227235],
            [-2.4164476300483124, 4.387841595845579],
            [-2.385354862217553, 4.386276785708913],
            [-2.335669742755007, 4.384365479138848],
            [-2.2995371122563273, 4.382715049220947],
            [-2.276433859571433, 4.3819508624530314],
            [-2.257993169449715, 4.381010162873133],
            [-2.1920637407152954, 4.378460757748323],
            [-2.106026649696285, 4.375335521659958],
            [-2.060460515964137, 4.373586550440904],
            [-1.970271935267108, 4.370610243006759],
            [-1.9027999520999714, 4.368195349764271],
            [-1.9056555851316646, 4.274690172188459],
            [-1.908384402490251, 4.2719002455438035],
            [-1.9113584977858111, 4.17395607233112],
            [-1.9184827846255537, 4.167773370573938],
            [-1.9247330726257217, 4.164909118196528],
            [-1.930590508605409, 4.165119777920707],
            [-1.9329744851599455, 4.166589335084152],
            [-1.9430743809596591, 4.1668913263912355],
            [-1.948738963470017, 4.163151571043619],
            [-1.9562139519433963, 4.1608455753802325],
            [-1.970071210805824, 4.151985116703058],
            [-1.9757781260937415, 4.151220458401386],
            [-1.985164712460621, 4.152314641132814],
            [-1.9903334929752423, 4.154724749214284],
            [-2.000297397747082, 4.1548856296629335],
            [-2.005861052186897, 4.149923833777128],
            [-2.0164364851517, 4.14458084979606],
            [-2.027823837703229, 4.145711072399955],
            [-2.039704601102191, 4.135668279153905],
            [-2.0444188216423074, 4.127750734864519],
            [-2.0499264795854897, 4.127010907750554],
            [-2.055544289315943, 4.127742429438837],
            [-2.063050298195228, 4.126428474317578],
            [-2.067468122228093, 4.115842539442691],
            [-2.0693220391323925, 4.113293380616449],
            [-2.0813801327938877, 4.106613561244906],
            [-2.0903803510357086, 4.107020928782025],
            [-2.099500926686857, 4.103923413242297],
            [-2.1107064639068347, 4.097426758526364],
            [-2.119023455793966, 4.094345060194076],
            [-2.125114940022587, 4.095214257959339],
            [-2.131636574610826, 4.099184906349504],
            [-2.14304160207812, 4.101894053166516],
            [-2.1510314212667856, 4.10208661111706],
            [-2.1579456609428695, 4.099829462097151],
            [-2.16578795697584, 4.099759060072791],
            [-2.1793827436310176, 4.10206701164212],
            [-2.182923212339451, 4.103233004631609],
            [-2.1893413289224926, 4.1086632827180605],
            [-2.1988204415436634, 4.11276826858539],
            [-2.2076467895342575, 4.115246786069209],
            [-2.2166157884715747, 4.113672005859029],
            [-2.22081315853741, 4.111533345786742],
            [-2.226618896205496, 4.109212107196791],
            [-2.2300927572233227, 4.111237549333285],
            [-2.2353394826594863, 4.11089274699716],
            [-2.245412890091473, 4.108676596295918],
            [-2.257776430801893, 4.114096229410698],
            [-2.266372385056598, 4.115871312946233],
            [-2.2751237538659392, 4.12041015744545],
            [-2.289231498149298, 4.119590654901964],
            [-2.291714392478429, 4.118450820308551],
            [-2.302394246464294, 4.123193137682805],
            [-2.3049061663364583, 4.122317038727833],
            [-2.3103475724303726, 4.123548248388376],
            [-2.323597902321448, 4.128020901199399],
            [-2.3246919296938193, 4.12962533580901],
            [-2.3362940882237573, 4.13939173253947],
            [-2.3468156221807814, 4.136906261612278],
            [-2.3493158229909032, 4.138657328624036],
            [-2.3512446239033586, 4.144732495757504],
            [-2.351530101808621, 4.150564291705387],
            [-2.3538448603707045, 4.15505737026433],
            [-2.362657827049084, 4.154023530302826],
            [-2.3664317416948855, 4.155179308185931],
            [-2.3719871743498797, 4.154724987829191],
            [-2.3801498157907224, 4.152574257428978],
            [-2.3900082611634907, 4.155944815372152],
            [-2.3957388623388844, 4.154987446220304],
            [-2.4034679071307457, 4.156708813456713],
            [-2.415734317329514, 4.161603389925456],
            [-2.423351124836216, 4.161091035380881],
            [-2.4279449094976586, 4.162383678485775],
            [-2.431491490732367, 4.1617360639267345],
            [-2.437895113779326, 4.1648320240920205],
            [-2.443590863715813, 4.170680521092664],
            [-2.4493906699190098, 4.174765459913659],
            [-2.4592080523802036, 4.179055962605826],
            [-2.4657873228570777, 4.178118094535228],
            [-2.469107288875132, 4.1764205568548585],
            [-2.476485645032886, 4.178954721842679],
            [-2.4846981325843833, 4.176560417927015],
            [-2.4944098325040183, 4.177405128085073],
            [-2.5003199841632795, 4.179727715948427],
            [-2.5034647364284153, 4.182777134047106],
            [-2.514056529515666, 4.184917456835978],
            [-2.525405310819908, 4.190239082827455],
            [-2.5356419341142096, 4.193478061731633],
            [-2.53837070152624, 4.19929762220274],
            [-2.545570999912621, 4.200237885270287],
            [-2.5512651560716906, 4.203083647222301],
            [-2.5537448700635124, 4.208015296129188],
            [-2.5500700145191857, 4.215731073835668],
            [-2.5572137996176667, 4.219306942416414],
            [-2.5571793591556493, 4.2241974430370535],
            [-2.561703415010269, 4.227543309933066],
            [-2.5690073645850178, 4.222880679934393],
            [-2.570577670018766, 4.228897600901363],
            [-2.588205687603032, 4.233852484043165],
            [-2.595621306939211, 4.242705619602852],
            [-2.5926189351067714, 4.308958897546006],
            [-2.5921922125136936, 4.3093767741816515],
            [-2.5888030523564733, 4.395430667108472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.71240238044459, "lat": 42.87887409032023 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31103"],
        "coty_name": ["Keya Paha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Keya Paha County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00835873"
      },
      "bbox": [
        -2.595621306939211, 4.094345060194076, -1.9027999520999714,
        4.395430667108472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9200061072860368, 2.7560830432354058],
            [-1.7984022851147923, 2.752245473950932],
            [-1.6981674274829215, 2.7491515515121216],
            [-1.6705466431233567, 2.748505780982898],
            [-1.6211647977231618, 2.746890154848625],
            [-1.5957622139518415, 2.7462261429501016],
            [-1.5839690114951563, 2.7455083655349086],
            [-1.5785886966349307, 2.7454476154528584],
            [-1.5815284198318058, 2.7024011515011805],
            [-1.5824730139172567, 2.6627264554049135],
            [-1.586681211470103, 2.5564795147159853],
            [-1.5880117545187968, 2.5272618006703085],
            [-1.589378525090677, 2.483412625448703],
            [-1.588458109053601, 2.476169164879283],
            [-1.5886848061052907, 2.4687229569682914],
            [-1.5906116510961645, 2.4546910796460124],
            [-1.5918406489099077, 2.3956890725463205],
            [-1.6435639602480072, 2.3974678293147487],
            [-1.7426230787347117, 2.400461848280415],
            [-1.869595367210444, 2.404701881220501],
            [-1.8778757589873587, 2.4047865730967404],
            [-1.935014808782968, 2.4068018453119713],
            [-1.9315921177720188, 2.483553886257467],
            [-1.9288248061145552, 2.540793378325517],
            [-1.9251767508575426, 2.6250860071287923],
            [-1.9240451230618079, 2.645149227240879],
            [-1.9230722757785208, 2.6834429967208093],
            [-1.9200061072860368, 2.7560830432354058]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.97621135246284, "lat": 41.22057223018169 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31163"],
        "coty_name": ["Sherman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sherman County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00835903"
      },
      "bbox": [
        -1.935014808782968, 2.3956890725463205, -1.5785886966349307,
        2.7560830432354058
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.004715860355017, 3.613568412724809],
            [16.011047381767597, 3.6176170439851334],
            [16.010468486980137, 3.6205648802449906],
            [16.014496535868872, 3.6232534308129165],
            [16.014433383198003, 3.62765246678498],
            [16.02054547537907, 3.6370164616650027],
            [16.02032578158985, 3.6444303275959493],
            [16.024537882628202, 3.64896551329334],
            [16.02828950585022, 3.648571871838281],
            [16.028243369769218, 3.6539163468766653],
            [16.02962411515125, 3.657614671507209],
            [16.035962748021106, 3.660231348924773],
            [16.04151785700617, 3.665895114318909],
            [16.050691915152072, 3.6707570671463223],
            [16.05439333818848, 3.674243232302011],
            [16.0553410461495, 3.679777601169702],
            [16.061762268179752, 3.6846485257025297],
            [16.064905303096403, 3.6924851476768725],
            [16.071182398707716, 3.6981151350953585],
            [16.07216391221606, 3.702749821210139],
            [16.077483266676442, 3.7091558791352144],
            [16.081754753611897, 3.7112819668928596],
            [16.082416678987837, 3.7148223027180385],
            [16.089096761979537, 3.7229498506271788],
            [16.093011124792387, 3.723052658930174],
            [16.096613300194193, 3.728925009197969],
            [16.09929429500754, 3.7294650499004285],
            [16.109387446415166, 3.7431151979261195],
            [16.11290219427462, 3.7422417037634106],
            [16.120193120335845, 3.7447304075325727],
            [16.123559701770446, 3.7520279988077876],
            [16.126244060749684, 3.7554376756636585],
            [16.132999940969558, 3.7601517325765434],
            [16.132851010723297, 3.764508581431905],
            [16.13999831527658, 3.7656152607390325],
            [16.141562198585905, 3.7678324128729908],
            [16.142852637625573, 3.7772906655550265],
            [16.145556293616526, 3.7830133061172426],
            [16.149879088574234, 3.786370323439133],
            [16.15212611168623, 3.7941694263955315],
            [16.155117901588095, 3.798775186980875],
            [16.161860717793907, 3.8167438005534127],
            [16.164787166840252, 3.819541578407604],
            [16.16892923904758, 3.8264495228141926],
            [16.169431694689823, 3.830799293238078],
            [16.176010596952736, 3.8377364357677406],
            [16.17501022103851, 3.8431219355747546],
            [16.172678575466726, 3.845984579212671],
            [16.17857493070848, 3.85085390476803],
            [16.18192780552131, 3.855464303203542],
            [16.22191809401454, 3.8344174643197135],
            [16.223253509650636, 3.832074677911629],
            [16.237299448277362, 3.822919339346655],
            [16.240301072225623, 3.8218406394198476],
            [16.24519378059976, 3.823485494851453],
            [16.25206023436881, 3.823233875276246],
            [16.25931038478972, 3.8259548891159927],
            [16.262900543183516, 3.8248585922132152],
            [16.280479604816662, 3.8244125850023303],
            [16.294831568217333, 3.8225904828790163],
            [16.302274134850858, 3.819416244171575],
            [16.30836430184332, 3.8158467957592],
            [16.317379965521905, 3.815740146186134],
            [16.32074445891739, 3.812864211435343],
            [16.32451886269366, 3.805231501880094],
            [16.327003687385613, 3.80286897767738],
            [16.32867163952728, 3.7967908519835762],
            [16.326079597685546, 3.794285139943747],
            [16.32694463138453, 3.7890586993702695],
            [16.325742608100544, 3.784926334778335],
            [16.33114506268768, 3.782180963401273],
            [16.32992154737062, 3.7744319297345625],
            [16.330623246385905, 3.767716882144038],
            [16.325717318953984, 3.7619224895209897],
            [16.329635518791275, 3.75564680106784],
            [16.334863525931617, 3.7536737918381604],
            [16.337003027247608, 3.7503086169324003],
            [16.334909309960754, 3.744709830089013],
            [16.33753914710404, 3.7397031712755973],
            [16.334568283076823, 3.733664590265601],
            [16.336241408110983, 3.730098269048759],
            [16.34637603595374, 3.7305492618100224],
            [16.348896362159696, 3.725363897758537],
            [16.35626220321234, 3.7229909076432492],
            [16.351972950613426, 3.7121205001076922],
            [16.35050791051641, 3.7123707439801157],
            [16.346857565322136, 3.699777498161967],
            [16.349418411161704, 3.699279575228044],
            [16.34719503956256, 3.687520545979324],
            [16.356998881935187, 3.6850779986792457],
            [16.352498676834795, 3.6654233446194806],
            [16.348597785097358, 3.6618529249922793],
            [16.341818223750487, 3.6496498184564627],
            [16.32900627901476, 3.596461122643938],
            [16.324455166696488, 3.5958943265967878],
            [16.31832923015206, 3.6019603599449708],
            [16.309954715340165, 3.6036244770730463],
            [16.327492640702243, 3.578813514398622],
            [16.366975684789043, 3.522062669578573],
            [16.324257578468675, 3.5046448115838458],
            [16.33607968562964, 3.474597007598622],
            [16.287856707477953, 3.4562655787898127],
            [16.30465525989798, 3.4279695036896363],
            [16.250254616838486, 3.4082034153151106],
            [16.24189406044639, 3.408610380270964],
            [16.239060283386745, 3.4138466464051915],
            [16.236473029556517, 3.4221017173444435],
            [16.232517713930537, 3.4303753434536066],
            [16.226200637783435, 3.440477889535325],
            [16.21451312403888, 3.4577907758331388],
            [16.210609397288458, 3.460922084577318],
            [16.203571565617345, 3.4621557190465313],
            [16.196335414915115, 3.4647429845374305],
            [16.193178758459666, 3.4669639772963925],
            [16.187284629923088, 3.467453351034556],
            [16.16793482300402, 3.4558173257511386],
            [16.160249614924254, 3.456791390067625],
            [16.149864396905027, 3.4626245154813597],
            [16.139617466613572, 3.4645589067597875],
            [16.136618132450504, 3.4688241969783356],
            [16.133234520251197, 3.4789639536903225],
            [16.12755511602877, 3.491902800187649],
            [16.1228111267398, 3.499086337902318],
            [16.122206391084724, 3.5022964786898974],
            [16.123190106867906, 3.509637025229445],
            [16.120833038793744, 3.517737468229409],
            [16.12263707221782, 3.521366087502903],
            [16.12264328404724, 3.5263635507008346],
            [16.118443434240273, 3.5437063325198355],
            [16.11637136796684, 3.547523071166359],
            [16.11210313938781, 3.563069075923306],
            [16.111197888418328, 3.5697308957793927],
            [16.10794465439464, 3.579717257776229],
            [16.105063559664515, 3.5849448917093696],
            [16.096456708756076, 3.5892877293916414],
            [16.08027054141702, 3.602288908065174],
            [16.07612101386142, 3.6048808386342834],
            [16.06246389464338, 3.607405973235367],
            [16.047611647993346, 3.6066966534806],
            [16.040372930456073, 3.602425129884274],
            [16.03395693436682, 3.5928842992307675],
            [16.03096533117361, 3.5909915412174644],
            [16.021626383561326, 3.5898436450210904],
            [16.012257754557055, 3.592310516684357],
            [16.005384543445896, 3.5978489002367358],
            [16.003691102522716, 3.6033349906944463],
            [16.00545490431065, 3.608778069379431],
            [16.004715860355017, 3.613568412724809]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.91221373561976, "lat": 40.56730301115942 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34019"],
        "coty_name": ["Hunterdon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hunterdon County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00882228"
      },
      "bbox": [
        16.003691102522716, 3.4082034153151106, 16.366975684789043,
        3.855464303203542
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.10311429218625, 2.389271068839108],
              [16.10594512415772, 2.392377953913628],
              [16.108068366233688, 2.3869901638839046],
              [16.1040348545683, 2.3859172854495454],
              [16.10311429218625, 2.389271068839108]
            ]
          ],
          [
            [
              [15.940510946379339, 2.607055640309153],
              [15.941797611274806, 2.6126001804555674],
              [15.947332131719715, 2.6196047194411016],
              [15.94998968881609, 2.6258452263277343],
              [15.9548738402986, 2.6281506940661408],
              [15.959429067208768, 2.6373010827151493],
              [15.961478353399867, 2.6436322829570917],
              [15.965531498529723, 2.6525693236089136],
              [15.966461267352265, 2.6586559541578674],
              [15.965874602143598, 2.669881246090482],
              [15.964111505737124, 2.678991207937341],
              [15.964982888230944, 2.68170849606279],
              [15.972153365548625, 2.6878727682681545],
              [15.973705621505237, 2.6982244310069494],
              [15.977230972258669, 2.7038475329644847],
              [15.982354069892864, 2.7029054349054804],
              [15.982903307949181, 2.707695307175482],
              [15.981262449805826, 2.7139168611132445],
              [15.981221787352464, 2.7250139346905033],
              [15.983129005317208, 2.7338336255799534],
              [15.984462377959678, 2.747957719737777],
              [15.983375131208756, 2.75158883816491],
              [15.98561641194449, 2.7572925769076826],
              [15.990205010350065, 2.7616018618708433],
              [15.990122879988055, 2.7678293737580835],
              [15.997313327821102, 2.7790455863404664],
              [16.019115159256557, 2.796187196249616],
              [16.01026631591132, 2.7873846594404617],
              [16.01259104299654, 2.7836645059709104],
              [16.015615505495333, 2.7836943879117526],
              [16.019052813425542, 2.7872142672778426],
              [16.022097209755806, 2.7811049665750143],
              [16.02434402997369, 2.7831040392464304],
              [16.026964050752145, 2.779399519341866],
              [16.031043842783316, 2.770801100350818],
              [16.02546639395645, 2.769377279214494],
              [16.025901366687044, 2.763734588762566],
              [16.028434692566996, 2.7619886656799473],
              [16.03845668628054, 2.763426349173701],
              [16.036286178994583, 2.757831644572718],
              [16.03932976087148, 2.752777158325768],
              [16.04149296464073, 2.7542473036480706],
              [16.044447335929632, 2.750766156274425],
              [16.04835713567731, 2.7528831937563707],
              [16.051648921720474, 2.7502611181834538],
              [16.052972539764657, 2.7434086495709775],
              [16.054791733555703, 2.7429111028450337],
              [16.055799616806297, 2.7320525547313483],
              [16.064782775341083, 2.7276066249196664],
              [16.064576810256437, 2.7249698845487322],
              [16.069633201398368, 2.7245705147842894],
              [16.070745732174018, 2.7217421416896923],
              [16.078698687813286, 2.721432501355246],
              [16.081701082531172, 2.7178211890551407],
              [16.090870740182154, 2.716511099391651],
              [16.092266026155105, 2.713064782859834],
              [16.099484477167735, 2.710572305354464],
              [16.100609376090926, 2.7050859031699654],
              [16.109263161408432, 2.707677356062865],
              [16.12518310760136, 2.7057869543237665],
              [16.13277180554672, 2.7009441504829983],
              [16.145891009545632, 2.706350694915822],
              [16.15084837154619, 2.706883576183841],
              [16.15979474991755, 2.7037649133848443],
              [16.162096809864877, 2.695850964553778],
              [16.167098790977246, 2.6922987328969334],
              [16.176679704029674, 2.6916810740201242],
              [16.183243122605845, 2.6948154707628715],
              [16.186910672233243, 2.6943331952584315],
              [16.191039621177385, 2.697957850570037],
              [16.197745066483126, 2.7004653168373833],
              [16.200210096281626, 2.702668582319551],
              [16.205298407021733, 2.699543720627838],
              [16.259555391787103, 2.667690494778498],
              [16.324696860705696, 2.6288809431955653],
              [16.323218055338124, 2.62000359413357],
              [16.32387559380366, 2.615760070727132],
              [16.32216806787111, 2.6121676829643072],
              [16.320635612182656, 2.6029849818207893],
              [16.324181115516463, 2.599155622639527],
              [16.32386099369001, 2.594934167688153],
              [16.326773236117766, 2.5834001095607975],
              [16.32539939841014, 2.5775221486568007],
              [16.32638462193951, 2.57384768674407],
              [16.3251642743857, 2.5703311760265812],
              [16.327590527555994, 2.563555265545431],
              [16.32623350702836, 2.559668213591311],
              [16.332595777636314, 2.55154102830665],
              [16.33250059968203, 2.54767139541406],
              [16.334634594243077, 2.5449511772532833],
              [16.3322284638913, 2.530615296985028],
              [16.33263739132778, 2.5232217378791413],
              [16.33476758551019, 2.5194277860379404],
              [16.332870694563724, 2.5155997685627045],
              [16.3070090319004, 2.529872819166754],
              [16.252490420082143, 2.5605606340995983],
              [16.2434190505842, 2.565352215248069],
              [16.19520194063297, 2.5900102283049025],
              [16.177693337408435, 2.557412578052037],
              [16.164195255885307, 2.534094488396766],
              [16.15762350167247, 2.524259880897434],
              [16.15046521850395, 2.510918228436432],
              [16.145204894691993, 2.5060827210690992],
              [16.13837748871056, 2.504510466950177],
              [16.132645433096243, 2.5054919139470737],
              [16.132489200168948, 2.500644683859992],
              [16.129300874927036, 2.4936610752551],
              [16.129969147335817, 2.485267360762593],
              [16.1262135287699, 2.483135878502474],
              [16.12072663020928, 2.4679521136418603],
              [16.117221864617402, 2.466123424640626],
              [16.11012157038368, 2.466721150552368],
              [16.106716440056505, 2.4659352940798684],
              [16.095844121143347, 2.4681216030296684],
              [16.090739637168944, 2.463394788084083],
              [16.086915974736282, 2.455818992423328],
              [16.090703294306266, 2.4543343657605696],
              [16.090728156561067, 2.4496132600821845],
              [16.093005740515867, 2.447655247000849],
              [16.0898295937569, 2.437979786115347],
              [16.089579181879614, 2.433101068142314],
              [16.092704129001998, 2.4331023193877925],
              [16.09760282817085, 2.430116796742512],
              [16.096439589831657, 2.4250361697214884],
              [16.092201750636793, 2.4189636948064046],
              [16.09283859779102, 2.413911234152776],
              [16.099324381557285, 2.410210641535391],
              [16.100045657382097, 2.413724581375761],
              [16.10357565614351, 2.4134000131327253],
              [16.10345215581769, 2.409236717193539],
              [16.100653869144512, 2.4060002551468194],
              [16.10415141831531, 2.4036081613823193],
              [16.10334125617452, 2.4002088519295466],
              [16.097525148582317, 2.3999101682030783],
              [16.100172423124423, 2.3952499667149607],
              [16.09938282282605, 2.3915567071680255],
              [16.09563772922111, 2.3898485974151766],
              [16.09107984984198, 2.3901596611723805],
              [16.077046191647707, 2.402050521065813],
              [16.067548834859952, 2.4144663339325585],
              [16.061913759521698, 2.4197746570622543],
              [16.052056928556325, 2.4344015677491364],
              [16.046791163756797, 2.431387445823683],
              [16.037927266679, 2.4332602228479594],
              [16.0339139965942, 2.435002649566231],
              [16.03275062283729, 2.439501497787137],
              [16.02846816034997, 2.4401351050181503],
              [16.024727080997987, 2.4386294281330914],
              [16.018797823271143, 2.4415678820514883],
              [16.01543235783916, 2.447236774015843],
              [15.994168107296034, 2.444061579017018],
              [15.987207265481373, 2.4527489380587535],
              [15.98413239295146, 2.4615284561182564],
              [15.981725698597968, 2.4785172905504127],
              [15.992484514610718, 2.4824806549653746],
              [15.989387092993258, 2.488706928991483],
              [15.988147216239147, 2.494629945532464],
              [15.989357070440583, 2.501344394115081],
              [15.9860800452498, 2.515467660196626],
              [15.984588425337982, 2.5191036068824006],
              [15.981344584632934, 2.519991596771519],
              [15.978687976360558, 2.523413240649042],
              [15.979379758100878, 2.526225634444229],
              [15.986701159990051, 2.5403384937480573],
              [15.989922940848595, 2.554178106955057],
              [15.987591742271682, 2.5630124473238918],
              [15.980241712973585, 2.567671863072298],
              [15.97491515487365, 2.5686926093124085],
              [15.963017209482466, 2.5752650250892937],
              [15.958097133881585, 2.576804973656972],
              [15.950934660296543, 2.5806249751822925],
              [15.94800009285296, 2.5845114583017774],
              [15.943622298766355, 2.595474104062719],
              [15.940510946379339, 2.607055640309153]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.34910388826233, "lat": 39.5876722586825 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34033"],
        "coty_name": ["Salem"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Salem County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00882233"
      },
      "bbox": [
        15.940510946379339, 2.3859172854495454, 16.33476758551019,
        2.796187196249616
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.809140981993235, -4.051061744094826],
            [-6.787092823469438, -3.8148172481317046],
            [-6.78512870103774, -3.7933203239013826],
            [-6.756769840145144, -3.795896441832872],
            [-6.511244166407525, -3.8182084121017144],
            [-6.4214553813353445, -3.825976365832395],
            [-6.4138389618589775, -3.7390811037202556],
            [-6.364044779398681, -3.743014810871697],
            [-6.328325889081418, -3.746050606320182],
            [-6.320728165450482, -3.6590125116815564],
            [-6.1497440541277415, -3.673555415147751],
            [-6.164529113070665, -3.848132855124614],
            [-6.018032863686573, -3.860669476152127],
            [-6.025233472985757, -3.944493071311015],
            [-6.036332207625407, -4.076035816742852],
            [-6.047438801965119, -4.2067480682733],
            [-6.044642538748016, -4.206983821688386],
            [-6.059774699422927, -4.3843988771499145],
            [-6.1028366195675385, -4.380961327215443],
            [-6.231355152459191, -4.369124333698967],
            [-6.239485000519093, -4.456950776113575],
            [-6.371537906079336, -4.445044579023719],
            [-6.576273227535166, -4.425161863949404],
            [-6.755252895864513, -4.406231926720253],
            [-6.747377592074992, -4.318644647190799],
            [-6.819928141617215, -4.31080646513034],
            [-6.834826249133632, -4.3097609018990815],
            [-6.817772024704348, -4.1382264417140275],
            [-6.809140981993235, -4.051061744094826]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.41198787357418,
          "lat": 34.34246732903015
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35011"],
        "coty_name": ["De Baca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["De Baca County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00933054"
      },
      "bbox": [
        -6.834826249133632, -4.456950776113575, -6.018032863686573,
        -3.6590125116815564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.55847839851452, 6.810601165382412],
              [14.559374320841542, 6.813749375355411],
              [14.565869506833218, 6.823296416089235],
              [14.569163160131136, 6.821725475299341],
              [14.565266365104634, 6.815509880404747],
              [14.55847839851452, 6.810601165382412]
            ]
          ],
          [
            [
              [14.449520125732958, 6.808957547287962],
              [14.452355015007353, 6.819473893242203],
              [14.458551687026485, 6.827119609425029],
              [14.455390968324505, 6.8158294376210335],
              [14.459328234551778, 6.813102023913265],
              [14.460894884958131, 6.807928219092557],
              [14.459031142704742, 6.806845059746594],
              [14.454857457696852, 6.809699494777635],
              [14.449520125732958, 6.808957547287962]
            ]
          ],
          [
            [
              [14.467709206111628, 6.65543336602906],
              [14.472527048681078, 6.670749287182119],
              [14.480600396123318, 6.681204943469048],
              [14.487041568768422, 6.682743015273454],
              [14.49117356938849, 6.686185823742806],
              [14.490290451607926, 6.694384056259493],
              [14.495542940808598, 6.699990611347177],
              [14.497335957959882, 6.699446087669331],
              [14.496558671454393, 6.687205990369254],
              [14.49320029053435, 6.679445529176602],
              [14.487646366585128, 6.661397239730488],
              [14.483256563255473, 6.657116453406137],
              [14.47833265356907, 6.657080327389861],
              [14.475395315662727, 6.660806390051024],
              [14.469523963990587, 6.654148683055041],
              [14.467709206111628, 6.65543336602906]
            ]
          ],
          [
            [
              [14.705599611182143, 7.238300604616591],
              [14.765797679472682, 7.215369441897596],
              [14.79200672412076, 7.20585038394277],
              [14.804675273694938, 7.201565584948333],
              [14.829327161041071, 7.19188982849265],
              [14.84508901041782, 7.186260323658975],
              [14.863482291701422, 7.180270180324827],
              [14.906632645608111, 7.165723329926833],
              [14.961825713184199, 7.146443978214776],
              [15.003214583605981, 7.131578092612989],
              [15.03360353540669, 7.120088913157128],
              [14.993473976522957, 7.009600040015009],
              [14.98746441690256, 6.991779547855515],
              [15.03756681957226, 6.974101087710735],
              [15.028848831182042, 6.949191581018291],
              [15.03754005893221, 6.94652134711015],
              [15.034229665873477, 6.935288677036655],
              [15.038134798585412, 6.918198992254337],
              [15.041579530914882, 6.910146011895498],
              [15.005563930733418, 6.899097076343053],
              [15.019550383820595, 6.86241941210254],
              [14.996492407210578, 6.854502438024969],
              [14.993613422398301, 6.857366021169172],
              [14.981818313441893, 6.852823713445206],
              [14.976440362056758, 6.856450442993764],
              [14.966437992158326, 6.843724424491916],
              [14.926003872379999, 6.791463324621386],
              [14.887505808776154, 6.7429137589326915],
              [14.840433585063515, 6.73718905765121],
              [14.828989770326142, 6.735591208388769],
              [14.841051789453742, 6.644297366426159],
              [14.88667769634769, 6.6508108328747335],
              [14.91710143864383, 6.555362487145312],
              [14.916318558549047, 6.555351628243937],
              [14.786864287360952, 6.540470827312387],
              [14.73639554364163, 6.535431460442667],
              [14.746712889916102, 6.497955556628438],
              [14.714779570642204, 6.494443713944086],
              [14.689107881234687, 6.492030876817289],
              [14.662188452852078, 6.48901800977284],
              [14.619041643086398, 6.483306482689805],
              [14.614530623952385, 6.496551811469881],
              [14.61466054819061, 6.4991889694116916],
              [14.606971949377405, 6.520097274755845],
              [14.594286437028899, 6.552881178128484],
              [14.572483711815071, 6.59991690822554],
              [14.56529878892092, 6.60504477539159],
              [14.56437969196314, 6.610074183341035],
              [14.565866625051262, 6.614581341300901],
              [14.564629333434363, 6.61711794474706],
              [14.560141383058145, 6.609636593973136],
              [14.556169019194607, 6.610102006283992],
              [14.557297216557728, 6.613834485624153],
              [14.55333010206305, 6.617722748345595],
              [14.550240326621958, 6.618298805218862],
              [14.543803044992211, 6.615010601984256],
              [14.539546030669683, 6.614120823273796],
              [14.538056017421752, 6.617321292757591],
              [14.540505121071215, 6.625522529973675],
              [14.535841146018601, 6.626119258909827],
              [14.530585224897012, 6.628688856811036],
              [14.521514698943998, 6.623165549300715],
              [14.516291260995281, 6.6231860239295495],
              [14.51705135051946, 6.6343132726212195],
              [14.514414722960048, 6.636663682760048],
              [14.51386672409085, 6.640433801999217],
              [14.519357001926535, 6.653971422274149],
              [14.525695018706442, 6.663239779694509],
              [14.534570475762722, 6.6712148435278165],
              [14.540695578780012, 6.671305899195084],
              [14.55271825259458, 6.679483270343861],
              [14.560495273195375, 6.676701205015973],
              [14.56120726944156, 6.6750019053360825],
              [14.558558715543574, 6.668936334686483],
              [14.554466408277838, 6.6567460610773255],
              [14.55636356150311, 6.655509987064302],
              [14.562867511067008, 6.659896231347569],
              [14.568125465327116, 6.659884041655895],
              [14.571064589946362, 6.655827725038068],
              [14.576083178150668, 6.654175871346606],
              [14.577775504175907, 6.646879733650654],
              [14.581270210997802, 6.649277724300463],
              [14.583111328157258, 6.653266274659707],
              [14.58255892564188, 6.65631703193442],
              [14.578863869174542, 6.66319036267426],
              [14.58529743704552, 6.668765919854702],
              [14.591452282754277, 6.678707910071887],
              [14.598732140750915, 6.684223360740558],
              [14.599978773799503, 6.686888764499867],
              [14.608031812962848, 6.695425809568024],
              [14.613784515794581, 6.694771662293747],
              [14.62148522326472, 6.700769978134457],
              [14.624661962243138, 6.706447701673668],
              [14.623705501954342, 6.713637250604409],
              [14.62203121758826, 6.715838438415846],
              [14.623148529985386, 6.721298053713609],
              [14.620085954308578, 6.72473731265138],
              [14.62084393148806, 6.729257817224012],
              [14.616727800582254, 6.73527131932244],
              [14.615110542269894, 6.740300995549241],
              [14.610432899834787, 6.740854361799118],
              [14.607456014672902, 6.7465320235287916],
              [14.609744451881635, 6.751991775080411],
              [14.615275445910179, 6.75807574538315],
              [14.618800587751668, 6.756402697069176],
              [14.62201288026781, 6.759565249329823],
              [14.626379928030989, 6.766816212103881],
              [14.62969414519695, 6.77739236438908],
              [14.633355068335915, 6.78370812907877],
              [14.639240544241781, 6.790188180612406],
              [14.646101285519215, 6.790189483026342],
              [14.647782894538384, 6.785003532522698],
              [14.650808261023146, 6.785520582891573],
              [14.655834630884534, 6.791147261845567],
              [14.654482698154327, 6.793630050094334],
              [14.654204526306907, 6.802170401737416],
              [14.650400916461528, 6.808831017608802],
              [14.650405408680133, 6.813147087407721],
              [14.64280487204292, 6.8139605053180095],
              [14.6386729378311, 6.811494019640918],
              [14.637569410378019, 6.815810149327824],
              [14.632178526919283, 6.812680821028877],
              [14.634000097371894, 6.807514696597899],
              [14.625350452544907, 6.796289812772778],
              [14.61186662292294, 6.777065743310777],
              [14.604437501435376, 6.77024101577705],
              [14.597454887634587, 6.769498236487343],
              [14.589677136946253, 6.76135085785891],
              [14.587849897445714, 6.7622808329237305],
              [14.582334664054638, 6.7595193216255955],
              [14.581434577767883, 6.762884852549836],
              [14.577326138102514, 6.764218794202836],
              [14.579011611815174, 6.771021198242602],
              [14.575430312014404, 6.773927871643712],
              [14.568538384810894, 6.769270481460409],
              [14.559105254333478, 6.764452254578665],
              [14.557587080633697, 6.7693393704420215],
              [14.552125018502391, 6.770477006023489],
              [14.551021116693745, 6.774190819596273],
              [14.551260681492455, 6.780017046924582],
              [14.554518121805724, 6.787252814788897],
              [14.561241464130626, 6.796778193629489],
              [14.567477338512406, 6.799294401034694],
              [14.57197261964964, 6.804035798651221],
              [14.586758556058564, 6.810628770055631],
              [14.59170324626094, 6.815764800211479],
              [14.601056202184742, 6.830379810324806],
              [14.599884724059546, 6.8319268292631365],
              [14.602184572276652, 6.840877524741996],
              [14.598964127993566, 6.845065793094906],
              [14.593166907274874, 6.8422145995595525],
              [14.590757388212973, 6.843522226934602],
              [14.586509989733637, 6.842070653991059],
              [14.581241058840089, 6.832746681836779],
              [14.574434901422157, 6.830345067934508],
              [14.567837802613171, 6.831865800364986],
              [14.56788518120832, 6.833817111240001],
              [14.575023625531767, 6.844483201558835],
              [14.578172585394126, 6.847731812945442],
              [14.577385539591345, 6.850022872878327],
              [14.579070199818407, 6.856890778046687],
              [14.58147876711276, 6.8605958549199615],
              [14.576539171983908, 6.862611587723452],
              [14.58059294329158, 6.870466809326962],
              [14.57506092405661, 6.871551077571648],
              [14.571321198508196, 6.8656556948389245],
              [14.564568669247059, 6.861685296977132],
              [14.558860405716965, 6.863871478105732],
              [14.550686856671476, 6.854807297270346],
              [14.548379513370456, 6.855121117480811],
              [14.542406260080107, 6.852127544174606],
              [14.538137933884746, 6.847573677559457],
              [14.532521427337128, 6.849531935467602],
              [14.530228753094118, 6.8530490981315],
              [14.536473592795438, 6.870187047574629],
              [14.534847572730943, 6.872105396187202],
              [14.528619964718763, 6.862928475927255],
              [14.52662829863745, 6.8639903547414685],
              [14.523471615203764, 6.8570160575238175],
              [14.517614512349148, 6.855741569446037],
              [14.510251459555443, 6.849947740362293],
              [14.506252580636222, 6.851668266169819],
              [14.497003283410839, 6.83739516638844],
              [14.49692013499283, 6.833316845461295],
              [14.492980184733446, 6.82437593890967],
              [14.489476955397677, 6.802388693435803],
              [14.491456138802398, 6.800036405867045],
              [14.49219973334163, 6.795215901113984],
              [14.496334555399915, 6.798958311188026],
              [14.525352763491192, 6.81877425096198],
              [14.535305237551759, 6.822209200898785],
              [14.542937433049243, 6.822480172006832],
              [14.546567169423344, 6.818693257552698],
              [14.545555386823537, 6.813634751450636],
              [14.536568702085692, 6.794658327686206],
              [14.53869010046795, 6.790424784146821],
              [14.53852392728103, 6.786152551633023],
              [14.533074176423522, 6.775505429527076],
              [14.530871618298786, 6.768285242400605],
              [14.521067798837931, 6.75502080665008],
              [14.516654686130348, 6.754630927692218],
              [14.512002207492447, 6.750833834524419],
              [14.509984483918544, 6.7471134232353265],
              [14.50339603412843, 6.745243823662197],
              [14.500255510182582, 6.750653241832113],
              [14.50824506556947, 6.76954091298266],
              [14.507044813274579, 6.7726123782114325],
              [14.507134645083749, 6.781205176587746],
              [14.503304573041698, 6.786173841383533],
              [14.499961501548102, 6.786292556161058],
              [14.497505568442522, 6.790078998324895],
              [14.488453144397534, 6.793530626268378],
              [14.482981582829966, 6.789402652075157],
              [14.479563534669538, 6.79008914591369],
              [14.477726057310186, 6.793492833949925],
              [14.477073086245657, 6.800504337420598],
              [14.471670175300957, 6.804137078428605],
              [14.47552481914741, 6.811407013032755],
              [14.473883527492278, 6.820076070983826],
              [14.476862825184167, 6.823993330396322],
              [14.4760184975679, 6.82846935560512],
              [14.473242109228156, 6.830824062784629],
              [14.474261681305935, 6.835780839689858],
              [14.472493245157263, 6.839409963079487],
              [14.468266465094153, 6.839255386693734],
              [14.46422220552103, 6.836811644839961],
              [14.45927449043098, 6.836167129059903],
              [14.454304728038547, 6.838425145051373],
              [14.445225335106533, 6.8387129175211],
              [14.444309941682462, 6.843319326475237],
              [14.452447994035186, 6.850538123031306],
              [14.449919495273308, 6.852586506560344],
              [14.445575523795462, 6.847938414381374],
              [14.441502039890421, 6.849603957411386],
              [14.434290178974033, 6.843101850885962],
              [14.425780545776036, 6.841149857556963],
              [14.42519595767333, 6.846073408556867],
              [14.432971164672914, 6.85810639789763],
              [14.433118938278641, 6.859874863443656],
              [14.428339442440956, 6.863572197392343],
              [14.422903329434462, 6.858628223452236],
              [14.422416678257385, 6.863235878135498],
              [14.420275248891384, 6.864847366091282],
              [14.421757552488861, 6.869148118121598],
              [14.419767231318168, 6.871166594893299],
              [14.4148043649797, 6.867776430998914],
              [14.411993768802551, 6.868284928475284],
              [14.411840614225733, 6.872499579065386],
              [14.414501770492812, 6.880203580212885],
              [14.420239718966387, 6.888232573055522],
              [14.423495027212184, 6.894826975662962],
              [14.41577364031286, 6.902413962476777],
              [14.417551568432831, 6.9042801883316915],
              [14.432324219264743, 6.972810238006546],
              [14.449599583798165, 6.981228392591825],
              [14.475308855315554, 6.987008726078916],
              [14.478331196368966, 6.987130448554782],
              [14.503140336889508, 7.003395027681168],
              [14.51254838311394, 7.0121886096527515],
              [14.527647069368133, 7.034043618952902],
              [14.520788102217546, 7.074499563175025],
              [14.539096973012715, 7.094486322430239],
              [14.542539499362952, 7.093121236376716],
              [14.548367431566712, 7.094622432045452],
              [14.552036047012066, 7.0986321059862485],
              [14.561896775657592, 7.102253421462381],
              [14.59154899572426, 7.141255347915154],
              [14.614724333175005, 7.158504418036498],
              [14.619088616230403, 7.163171483833338],
              [14.6320900394691, 7.165795699990495],
              [14.637615088207047, 7.165714254342404],
              [14.641560377164305, 7.163155897199356],
              [14.654634558416548, 7.1723370631374745],
              [14.660203796478259, 7.1798968984430935],
              [14.666429378328843, 7.185502661875743],
              [14.669876918510509, 7.195682206174608],
              [14.676133006162885, 7.196197480496623],
              [14.699408681694607, 7.228381978914752],
              [14.705599611182143, 7.238300604616591]
            ]
          ],
          [
            [
              [14.416803450741215, 6.8073243987330745],
              [14.417783729020432, 6.813918819658513],
              [14.42377317883533, 6.822072353455788],
              [14.429786942937662, 6.822122526185269],
              [14.434773356108947, 6.826143708745517],
              [14.441122418179589, 6.8271179441386955],
              [14.442207525852515, 6.825241589158195],
              [14.44047418854149, 6.811011230607782],
              [14.432616746795206, 6.8044655592831935],
              [14.422233247685641, 6.802310181939746],
              [14.420010053649522, 6.806333699205291],
              [14.416803450741215, 6.8073243987330745]
            ]
          ],
          [
            [
              [14.402358108869858, 6.652205244833436],
              [14.412292159294655, 6.6726886506310565],
              [14.423956505517317, 6.687702620747675],
              [14.428480327401665, 6.688197271630374],
              [14.434781607875006, 6.691156911566711],
              [14.442801502942771, 6.692020845076357],
              [14.440488731658995, 6.687759785653643],
              [14.437972707985482, 6.677440507344255],
              [14.431411449340123, 6.669316172594209],
              [14.427269501554436, 6.667297566692103],
              [14.414964909001727, 6.6554165962863046],
              [14.41097363656135, 6.65525071329814],
              [14.40767303878102, 6.650818663747523],
              [14.403886988038531, 6.649720980860042],
              [14.402358108869858, 6.652205244833436]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.92025675156884, "lat": 44.04959131823596 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36045"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00974121"
      },
      "bbox": [
        14.402358108869858, 6.483306482689805, 15.041579530914882,
        7.238300604616591
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.075762305603092, 5.863405501373971],
            [13.085184005104527, 5.8666260104386145],
            [13.08836337315126, 5.866564895496308],
            [13.101378488761386, 5.870075962704599],
            [13.111599115181923, 5.8738991762663675],
            [13.119743260327361, 5.8752207540429735],
            [13.142532241950404, 5.88119648739068],
            [13.146790777727295, 5.8795759735588335],
            [13.162601590121856, 5.8819167379466455],
            [13.166793083487473, 5.881781017720089],
            [13.179052300842564, 5.8843820554961646],
            [13.185060353715766, 5.886250632069618],
            [13.191673287790966, 5.88530157468427],
            [13.204956352447054, 5.888233565963333],
            [13.212624842204574, 5.889318596816968],
            [13.216196577029242, 5.891060327433902],
            [13.226661249021168, 5.89236080345125],
            [13.231713871872971, 5.8905302344962145],
            [13.241025367503783, 5.8920911842126396],
            [13.257549411028803, 5.897854332921307],
            [13.264448954323994, 5.898150379764389],
            [13.271931599494456, 5.900521692897438],
            [13.279711990272666, 5.901041404798707],
            [13.292351578756076, 5.907576215431866],
            [13.302654708663239, 5.910267378448452],
            [13.331542581515397, 5.91585620302711],
            [13.353391023988964, 5.916599945642722],
            [13.365615182750739, 5.9165690992249695],
            [13.378801922552237, 5.920005474285607],
            [13.384094307903528, 5.917084201085872],
            [13.390730662992215, 5.917887471033601],
            [13.403793788769695, 5.92199021627027],
            [13.407926505846007, 5.919690198134597],
            [13.410886367309686, 5.920368386191225],
            [13.419039986519975, 5.87945288550707],
            [13.42600570255917, 5.841537703687687],
            [13.431838280166016, 5.807690709734844],
            [13.43709927611709, 5.779229313788641],
            [13.45363833702394, 5.692039264702527],
            [13.417674119266007, 5.68367267334291],
            [13.369627886164492, 5.674575285462698],
            [13.369486446243272, 5.675445695634159],
            [13.272351027879772, 5.656034652119644],
            [13.230585162621482, 5.648148320427943],
            [13.209274911768754, 5.643657681172666],
            [13.159102367578049, 5.6341285355001505],
            [13.120494961309227, 5.6248871933911255],
            [13.117689680572848, 5.639607217635043],
            [13.11225385229451, 5.678766082720524],
            [13.107966774573386, 5.711708519159345],
            [13.102191978285454, 5.73682382986195],
            [13.087723193425427, 5.79600191758805],
            [13.075762305603092, 5.863405501373971]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.23121793642807, "lat": 43.25209743933253 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36073"],
        "coty_name": ["Orleans"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orleans County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00974135"
      },
      "bbox": [
        13.075762305603092, 5.6248871933911255, 13.45363833702394,
        5.92199021627027
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.775696553840536, -0.8822030429852776],
            [15.770692402881732, -0.8688790565261071],
            [15.779457869781124, -0.8625434064299043],
            [15.786066383465183, -0.860431165890719],
            [15.78478148326379, -0.8554567651655244],
            [15.7876014005431, -0.845736410074686],
            [15.796313836027533, -0.8460932186954815],
            [15.800054307835902, -0.8442217160983467],
            [15.804664022312915, -0.837197814833832],
            [15.808343702629385, -0.8360525443681275],
            [15.808128528902559, -0.826871748059686],
            [15.813504551286389, -0.8247964882028229],
            [15.818575068462957, -0.8256316908609165],
            [15.82186794153079, -0.8246717176838272],
            [15.830295164700969, -0.8278991092765559],
            [15.836139790715254, -0.8264766392639308],
            [15.839388426801207, -0.8270505142779966],
            [15.844958848871588, -0.8240163378735698],
            [15.844855495378093, -0.8183655303084469],
            [15.849339934930576, -0.8141569506609205],
            [15.853745830759776, -0.8116557841229389],
            [15.861251242544848, -0.8108424732380608],
            [15.866496103420104, -0.7924772524175722],
            [15.86658516634409, -0.7991953095093673],
            [15.86946805096701, -0.8074192307418235],
            [15.868592051379721, -0.8171092332039113],
            [15.870676534626888, -0.8219907930724608],
            [15.86774842780968, -0.828759117211878],
            [15.867949170309117, -0.8352506761578552],
            [15.871581051020314, -0.8468156024418256],
            [15.87372196171968, -0.8508319039818967],
            [15.873097580414655, -0.8572625260944537],
            [15.874586365812714, -0.8616572794938352],
            [15.875534855500154, -0.8701994922718087],
            [15.874420941468015, -0.8772859889694063],
            [15.875150048468393, -0.8874052202322309],
            [15.869032387082175, -0.8952685276124444],
            [15.865976125788666, -0.8978640709689982],
            [15.866591750720398, -0.9050895710033947],
            [15.865666179032944, -0.9082949906290128],
            [15.873778669662352, -0.9328436626886314],
            [15.896358730070983, -1.003548938102082],
            [15.905035458606992, -1.0311401606163229],
            [15.908502276702347, -1.035323201425728],
            [15.91764075011754, -1.0395142112362195],
            [15.927626449267656, -1.0394068658527607],
            [15.93521548199832, -1.0425911387405558],
            [15.938685874265033, -1.0396874693658107],
            [15.943042957834372, -1.0397729300967815],
            [15.951511943180833, -1.0362896314705776],
            [15.95798699084841, -1.0388004398421251],
            [15.961586814747314, -1.0433879893235254],
            [15.96755210871005, -1.0451259634214718],
            [15.972265723257202, -1.0451985454645099],
            [15.976878290585066, -1.0419067565945497],
            [15.981335691095545, -1.034456654823868],
            [15.986107585356887, -1.0360933005389785],
            [15.993878489342658, -1.0358099024761618],
            [15.99778998999044, -1.0366984894466755],
            [16.004073634499548, -1.043326867604029],
            [16.009791651819306, -1.0425835757795758],
            [16.0123272141612, -1.0457842699415452],
            [16.018610234442164, -1.0433142449234718],
            [16.02452131847645, -1.044120244402109],
            [16.038920644600196, -1.0408217921656542],
            [16.039256892564996, -1.0437323244322487],
            [16.043337400493925, -1.047435113013424],
            [16.03901319958977, -1.052200977990141],
            [16.035119429587084, -1.0537084853617191],
            [16.02790766285291, -1.0629395423926007],
            [16.023621085581947, -1.0731454456222396],
            [16.020289408617625, -1.0758221151677096],
            [16.015350509105904, -1.0831201121084637],
            [16.012747339693107, -1.089084177777409],
            [16.01144608926855, -1.0993306782091319],
            [15.988369934823657, -1.1112028160671292],
            [15.977846516469924, -1.1195354031358276],
            [15.972865987125644, -1.1255255187655375],
            [15.947496311824723, -1.1270306793110927],
            [15.93334949316301, -1.1291730666520277],
            [15.926203678172312, -1.1322394351873755],
            [15.919998090867717, -1.132336109934174],
            [15.907279169559525, -1.1221889083444527],
            [15.906816916693113, -1.119415710640196],
            [15.8970183327531, -1.1115397801580529],
            [15.890368852234811, -1.0935084314609307],
            [15.886924860816894, -1.0928348673607147],
            [15.882833027164365, -1.094671400219951],
            [15.879242714171738, -1.1055121590404529],
            [15.87130241785787, -1.1150738160600948],
            [15.8681813989936, -1.1169075396230117],
            [15.858592320627256, -1.1195497928938902],
            [15.850904148887992, -1.1179533687501808],
            [15.848689259670326, -1.1147916568677143],
            [15.837865829169756, -1.115245030670085],
            [15.824201854337161, -1.099636414797541],
            [15.821154251279681, -1.0953227650677309],
            [15.818528450659366, -1.0865701445598697],
            [15.82099580827757, -1.082292012486515],
            [15.815549091026494, -1.0709458745791616],
            [15.817847457375468, -1.0651291574101533],
            [15.815471344516816, -1.0545382703709416],
            [15.81253083784003, -1.0515830601328626],
            [15.809901271892098, -1.0539050286636615],
            [15.802027664919857, -1.0543390060810223],
            [15.796201533565608, -1.0444991498331344],
            [15.793471897192138, -1.0373066209714914],
            [15.79251632077232, -1.03077832011191],
            [15.78624142398548, -1.021983375485285],
            [15.781394463332825, -1.019485387095132],
            [15.778198739079274, -1.007423272231183],
            [15.775013448901948, -0.9768446671089319],
            [15.772578101936126, -0.9665463522342657],
            [15.773281299108415, -0.9516663381517283],
            [15.774483759188284, -0.9431634456712102],
            [15.780535930636612, -0.9307769564502161],
            [15.784286246786689, -0.9267238268341188],
            [15.78471266632912, -0.916561245819584],
            [15.793162305866584, -0.8943979046061772],
            [15.794698762220905, -0.8888296101127605],
            [15.791755480800651, -0.8848938703969097],
            [15.785395546234202, -0.8860078905757891],
            [15.775696553840536, -0.8822030429852776]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.6079149963474, "lat": 36.15085440139784 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37041"],
        "coty_name": ["Chowan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chowan County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01025822"
      },
      "bbox": [
        15.770692402881732, -1.132336109934174, 16.043337400493925,
        -0.7924772524175722
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.079755876566642, -2.2771942651798502],
            [12.130400295755578, -2.271460757559344],
            [12.157430533638095, -2.2686231701269657],
            [12.191868493971116, -2.2647369257052983],
            [12.241511831451671, -2.2593984995650276],
            [12.312590446449414, -2.252263012939811],
            [12.348881589265623, -2.2484056857634442],
            [12.36143662864221, -2.246823984448066],
            [12.439402563386688, -2.238159933446361],
            [12.44917877107296, -2.2368659483510998],
            [12.49690710811691, -2.23199217760556],
            [12.54139100701664, -2.226565129818633],
            [12.542747806980934, -2.228807273635502],
            [12.5484398159644, -2.2317566220798155],
            [12.559140722567607, -2.239579629077155],
            [12.560476624974232, -2.2422945149441436],
            [12.556876109683497, -2.2455493918166742],
            [12.547296995720135, -2.2404456496446845],
            [12.546917683169868, -2.2495354576862523],
            [12.549430009493, -2.25910118887787],
            [12.54513376935348, -2.267887247404283],
            [12.547393781155726, -2.2749846682974106],
            [12.551421303534095, -2.2784373149737025],
            [12.559198062816364, -2.2802349676220155],
            [12.560805532801382, -2.2832412914971387],
            [12.563187321243998, -2.287818712588896],
            [12.561630674531424, -2.2910471698827535],
            [12.560388470143728, -2.3032775806909824],
            [12.561884733349352, -2.306737496094021],
            [12.569568360982254, -2.313230091397635],
            [12.569858316220753, -2.318096251856903],
            [12.563963472018289, -2.32737938728262],
            [12.560641349674395, -2.3402714654805234],
            [12.564170530554197, -2.3472606027768776],
            [12.565294927899759, -2.3535255981019727],
            [12.56398071700611, -2.3613114794612384],
            [12.566577286813168, -2.3686706365495356],
            [12.56887426894784, -2.3721914032623928],
            [12.523215443311367, -2.3758659222411826],
            [12.448756990721613, -2.384212602705983],
            [12.357198398739074, -2.394543869541555],
            [12.344783405993098, -2.3965469166465305],
            [12.33874222521109, -2.3964677002223596],
            [12.299493124949482, -2.4005885487363283],
            [12.239706242724056, -2.407054635980325],
            [12.166155064093111, -2.4152017953076554],
            [12.163003047603878, -2.4117404061504844],
            [12.153678783207308, -2.3942805302314096],
            [12.144099292123467, -2.3774382137778294],
            [12.137636112059978, -2.3668705939356696],
            [12.127078755889483, -2.3528684672027946],
            [12.123112106373327, -2.3460580072791366],
            [12.117497693982058, -2.3384724000677837],
            [12.104470678299862, -2.3191189445762372],
            [12.10540294934716, -2.3125235178839283],
            [12.10501455506902, -2.3019957161554445],
            [12.103346466815017, -2.2917162490346596],
            [12.097185630451307, -2.284557988708935],
            [12.078603830971813, -2.2813579159721105],
            [12.079755876566642, -2.2771942651798502]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.2234776003077, "lat": 35.485582372220236 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37109"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01008569"
      },
      "bbox": [
        12.078603830971813, -2.4152017953076554, 12.569858316220753,
        -2.226565129818633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.922797079398594, -2.510662612366333],
            [12.962889187995412, -2.5279954392911197],
            [12.966838986075635, -2.531860287384167],
            [12.973387842489156, -2.53266167605548],
            [12.977695286697106, -2.53526825535849],
            [12.982759229646671, -2.529755422942929],
            [12.985946592181953, -2.53110587948819],
            [12.987213582474158, -2.5361580379512247],
            [12.993466941905364, -2.5410896609578497],
            [12.997320344878235, -2.537504312856773],
            [13.001914763620281, -2.5412481695371323],
            [13.012382329943973, -2.5404792365855147],
            [13.018887918737855, -2.5432400059326703],
            [13.021899768852924, -2.5383050710855724],
            [13.02540684077776, -2.537016174780782],
            [13.028739804197242, -2.5324026368032944],
            [13.033416848802942, -2.528765881858654],
            [13.039910181356307, -2.536934304260012],
            [13.043478114221081, -2.536414836206744],
            [13.045521669850975, -2.533275101886378],
            [13.051380110542302, -2.5332333219161707],
            [13.059302991553238, -2.5316357967676075],
            [13.065144514232617, -2.523597605158702],
            [13.068135430974877, -2.51707311946115],
            [13.072914285429741, -2.5158815081346204],
            [13.077881413900972, -2.524053252611781],
            [13.08401081865927, -2.5285413896294133],
            [13.087783636293697, -2.5238148966071945],
            [13.09142647832903, -2.523253064514011],
            [13.09628660854049, -2.517037857925209],
            [13.100947131629358, -2.5166394910345793],
            [13.104023736156265, -2.513418950179465],
            [13.11217236433356, -2.514327903566992],
            [13.112423414239796, -2.5083812738594924],
            [13.11934188428832, -2.5065987525217492],
            [13.123585214405578, -2.5033515638582533],
            [13.123004509718069, -2.4989989822718894],
            [13.12799018083323, -2.4921173479427687],
            [13.131811773125472, -2.490985115017762],
            [13.135992092436924, -2.4927782605162343],
            [13.139818610992643, -2.4876141858308443],
            [13.14348159130948, -2.487141222761626],
            [13.151920024146104, -2.602894700807753],
            [13.159750152321235, -2.710310794784676],
            [13.164758980361873, -2.779069283606843],
            [13.171548393108944, -2.872258573939346],
            [13.10787374079587, -2.881750258128065],
            [13.066065509555969, -2.8873599931135314],
            [13.033743547554092, -2.8922711657405324],
            [13.027261914544168, -2.892864051928598],
            [12.977479346260818, -2.9008033568929847],
            [12.925642587614927, -2.9085188806489284],
            [12.910657095707599, -2.9106014333540684],
            [12.787596609355505, -2.9292878767067188],
            [12.781405212577173, -2.811944636665745],
            [12.742648833062212, -2.773381915584867],
            [12.724052876472614, -2.754004803867855],
            [12.725389585510127, -2.7503097099054483],
            [12.730384604586822, -2.7466660969292915],
            [12.7346668861846, -2.7417316391887665],
            [12.737054424591374, -2.7358843461075835],
            [12.744278190205298, -2.730510436462559],
            [12.748611713252961, -2.7233878761936987],
            [12.766594332064455, -2.7148437666048704],
            [12.772898330810591, -2.7141652970810997],
            [12.776854983027329, -2.7101210206434074],
            [12.794325339377883, -2.687263653060026],
            [12.823510588935253, -2.648186833014004],
            [12.865392098217342, -2.5905266503689406],
            [12.922797079398594, -2.510662612366333]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.53072765816982,
          "lat": 34.988407674818156
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37179"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "01008590"
      },
      "bbox": [
        12.724052876472614, -2.9292878767067188, 13.171548393108944,
        -2.487141222761626
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.545797078311333, 10.203372665625569],
            [-3.551088638215603, 10.11904238475947],
            [-3.4317825950763834, 10.111488892576185],
            [-3.438248956594075, 10.013181852566559],
            [-3.4427608833746146, 9.942789386078884],
            [-3.4480192278622606, 9.858129492585064],
            [-3.3318738414285147, 9.850915306643069],
            [-3.26553723876523, 9.846910592805617],
            [-3.1863021237567803, 9.842266713363355],
            [-3.0989437585253157, 9.837198094115807],
            [-3.0323113402662942, 9.83340483516338],
            [-2.924386454279673, 9.82745529242493],
            [-2.9290246231388557, 9.742699543529204],
            [-2.8984229943600566, 9.741079096987958],
            [-2.901370424703193, 9.683578091353313],
            [-2.903074366764578, 9.65534653504538],
            [-2.908905967203148, 9.549481215484246],
            [-2.9135020752361864, 9.467702711294026],
            [-2.9171776632177355, 9.40085188866757],
            [-2.8871573461758118, 9.39933186066152],
            [-2.892011460567724, 9.31229323545682],
            [-2.895297448181237, 9.257030774569866],
            [-2.8966581830412546, 9.229180995369193],
            [-2.9182884236055338, 9.229808966343148],
            [-2.983602455302491, 9.233510334979044],
            [-3.070573860474697, 9.238046911096294],
            [-3.157522444119784, 9.242742961918282],
            [-3.2589653411125847, 9.248218097509431],
            [-3.308853655113231, 9.251095832237857],
            [-3.33121113721902, 9.252145902306868],
            [-3.417788946457054, 9.257321361445259],
            [-3.470533177712315, 9.26025959916937],
            [-3.5048676443679296, 9.262375178175791],
            [-3.4995035320641676, 9.347247008480906],
            [-3.493894777097633, 9.43390002603625],
            [-3.52794786290628, 9.43598395396092],
            [-3.5211451480400426, 9.544699521827319],
            [-3.5152973649800106, 9.635456128609363],
            [-3.5091287925850447, 9.732536101244188],
            [-3.506479138801442, 9.776472688616012],
            [-3.5408319063245295, 9.778540272676299],
            [-3.5352145053474295, 9.863338711644749],
            [-3.529826869968538, 9.948094891571548],
            [-3.6167709331267885, 9.953351509215631],
            [-3.7038280996377266, 9.958973419991343],
            [-3.6991600011332, 10.02938567163212],
            [-3.692355886209594, 10.128027441644715],
            [-3.638390254599689, 10.124564793026591],
            [-3.6325790467867836, 10.208939697341338],
            [-3.6074548875974095, 10.207236572594267],
            [-3.545797078311333, 10.203372665625569]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.54181251737454,
          "lat": 48.22170165779892
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38101"],
        "coty_name": ["Ward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ward County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01034231"
      },
      "bbox": [
        -3.7038280996377266, 9.229180995369193, -2.8871573461758118,
        10.208939697341338
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.585080187618521, 3.4774393511598394],
            [10.58788125781434, 3.47921195486148],
            [10.59654899737431, 3.481356698998154],
            [10.603267056075552, 3.482136950453741],
            [10.62665242298966, 3.4835837433314873],
            [10.643311168259851, 3.488440619691248],
            [10.65298524292881, 3.4933737418509097],
            [10.655444513710343, 3.4964821761088585],
            [10.659871690707615, 3.4989661041003886],
            [10.672389268751806, 3.5101003867534635],
            [10.680628889006112, 3.5185872303823795],
            [10.696149227197678, 3.532200547115689],
            [10.696009500758636, 3.5358134862775166],
            [10.701736726234634, 3.539440859684156],
            [10.704111300621696, 3.5386564599016928],
            [10.722057136173895, 3.547903610792028],
            [10.734610149524162, 3.556150221050663],
            [10.744478933043972, 3.561856019043055],
            [10.796664229888723, 3.588360997718067],
            [10.808925778295434, 3.5954925672023785],
            [10.819278481193953, 3.6003166766322794],
            [10.829808486327323, 3.6001021359713854],
            [10.832073432462364, 3.6011971479144234],
            [10.853234194101407, 3.594612172918372],
            [10.856390534544275, 3.567689015644669],
            [10.865079916593203, 3.5068518093234755],
            [10.873856556044096, 3.4413717520328198],
            [10.943406900350594, 3.4511362612355736],
            [10.953888993850981, 3.3757447865353556],
            [10.939308282938885, 3.373437339730169],
            [10.922583109789349, 3.371415810398225],
            [10.917826387318666, 3.3701355638050137],
            [10.884286130592475, 3.365160699433163],
            [10.889178236697346, 3.328143641970085],
            [10.892764181623498, 3.2993659078073327],
            [10.894363030078882, 3.290351082488538],
            [10.821585196988858, 3.2796078157762696],
            [10.829586029358996, 3.21628796052655],
            [10.758828989648597, 3.206550714041066],
            [10.768386423645316, 3.133107431957331],
            [10.70399735706139, 3.1249302189772075],
            [10.68044876589794, 3.1223255447382736],
            [10.653071637644546, 3.118844312164031],
            [10.645961852232912, 3.117566016248974],
            [10.6376423483635, 3.1672795669319487],
            [10.633951068149269, 3.180619848914138],
            [10.632496074696784, 3.1889970661211833],
            [10.624775390018895, 3.238782790084802],
            [10.62211609006399, 3.262129625097881],
            [10.610096679768274, 3.334586088589911],
            [10.5896989293796, 3.451538003430675],
            [10.585080187618521, 3.4774393511598394]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.15091391471054,
          "lat": 41.295660661339056
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39093"],
        "coty_name": ["Lorain"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lorain County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01074059"
      },
      "bbox": [
        10.585080187618521, 3.117566016248974, 10.953888993850981,
        3.6011971479144234
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.794818727497699, 3.0640879814971305],
            [8.879424007692224, 3.074017673161758],
            [8.937198342399903, 3.0813119141745093],
            [8.975952504377256, 3.0858016327184914],
            [9.051142826011567, 3.0957892728549017],
            [9.056639696479554, 3.051787305601478],
            [9.07161464819313, 3.053351344434576],
            [9.127833770719384, 3.0603251745627724],
            [9.142202302060166, 3.0618886849637197],
            [9.147576182918211, 3.018390571509149],
            [9.152788720389148, 2.9746365124775003],
            [9.15997907366286, 2.9158754443596924],
            [9.165089276629091, 2.872729152954263],
            [9.168914634121116, 2.843643484962929],
            [9.126183505145367, 2.838012682929353],
            [9.083322995782005, 2.832591207551058],
            [8.983287298733352, 2.820121768499436],
            [8.91592584023214, 2.8118012735851305],
            [8.826205544662422, 2.8009721727805723],
            [8.814287175165944, 2.900863712574156],
            [8.810397644997442, 2.93282138292211],
            [8.803452213716488, 2.9918779632990202],
            [8.794818727497699, 3.0640879814971305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.58021556206941, "lat": 41.11660755582608 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39125"],
        "coty_name": ["Paulding"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Paulding County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01074075"
      },
      "bbox": [
        8.794818727497699, 2.8009721727805723, 9.168914634121116,
        3.0957892728549017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6678360011245417, -3.8501538829066715],
            [-1.578370642286183, -3.852666977003407],
            [-1.4571183781792723, -3.8558620826497294],
            [-1.3822294032086462, -3.85768924333336],
            [-1.2999263392836973, -3.8596362195458656],
            [-1.2393887983833465, -3.8611090285714926],
            [-1.2364865621759709, -3.861232131421334],
            [-1.236376850692168, -3.8755360280979567],
            [-1.2383467091103493, -3.963121050706395],
            [-1.2399625464765172, -4.035999005035591],
            [-1.2829350651441778, -4.035049781025322],
            [-1.2835883274489988, -4.057063510917909],
            [-1.2851111493936984, -4.122426236136209],
            [-1.2871768433525719, -4.210134263353262],
            [-1.3172130281192527, -4.2094873993596185],
            [-1.370507031933775, -4.208088544246991],
            [-1.3714671351879288, -4.251707611126124],
            [-1.4138722866153295, -4.250886476066208],
            [-1.4142586721318169, -4.265449776331639],
            [-1.5070951790801086, -4.263352697183527],
            [-1.549653052425919, -4.262062819152024],
            [-1.585191010881528, -4.260770628826683],
            [-1.5859849128128352, -4.289873205074081],
            [-1.6281112299147926, -4.288792591450511],
            [-1.6715267400582532, -4.28740552790762],
            [-1.6719069884771514, -4.301955581494001],
            [-1.7148019693230467, -4.300965147370325],
            [-1.714343272139456, -4.279159848612747],
            [-1.711957574020818, -4.198956604476109],
            [-1.7668455293288559, -4.19734834580165],
            [-1.8460951606722202, -4.195183669255806],
            [-1.843375223375317, -4.10770395564867],
            [-1.840933761262256, -4.020214209350099],
            [-1.837994760650482, -3.919184180609798],
            [-1.8373426476526247, -3.9078878877731418],
            [-1.8355869304729255, -3.8455768950315754],
            [-1.8041168534846257, -3.8460282855661236],
            [-1.772435204610595, -3.8471433813337135],
            [-1.6998781818663684, -3.849227551062051],
            [-1.6723445346269243, -3.8505772815667774],
            [-1.6678360011245417, -3.8501538829066715]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.4716647518524, "lat": 34.662114688407804 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40031"],
        "coty_name": ["Comanche"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Comanche County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01101803"
      },
      "bbox": [
        -1.8460951606722202, -4.301955581494001, -1.236376850692168,
        -3.8455768950315754
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2126569566932497, -2.2410266803278587],
            [-1.211436456413361, -2.189907208765864],
            [-1.2096286626669668, -2.109440031053888],
            [-1.181452959219671, -2.1101309308365153],
            [-1.0564265202425194, -2.1127042158688907],
            [-0.9471336074264104, -2.1150764888217806],
            [-0.8421355886772577, -2.1167959412204214],
            [-0.7629772501200237, -2.118098145540102],
            [-0.6992838418947911, -2.1189611686825587],
            [-0.6986030043471924, -2.118961545642294],
            [-0.7002342195881425, -2.2292454258037226],
            [-0.7010008172780344, -2.2948539463990585],
            [-0.7020243405663751, -2.367642678583562],
            [-0.7037371382127287, -2.4691888791469734],
            [-0.7031481153062142, -2.470532277600012],
            [-0.7046165490392404, -2.5517950838513728],
            [-0.8048238187327253, -2.5499008887238515],
            [-0.87641557775791, -2.5487602689718907],
            [-0.9116694266039979, -2.5480504421787074],
            [-0.9681084092635839, -2.5471352694707794],
            [-1.0501454634895284, -2.5454694285211743],
            [-1.1017448896502087, -2.544598635927426],
            [-1.104819621020744, -2.5442639971362517],
            [-1.133539375628329, -2.543656352598262],
            [-1.2136584961667516, -2.5416929721205013],
            [-1.2189037583200668, -2.541740532998681],
            [-1.21695095790082, -2.4600405520678756],
            [-1.217192653630226, -2.4454540788195027],
            [-1.2154214508282042, -2.365399865279461],
            [-1.2137054956438234, -2.2848121756320285],
            [-1.2126569566932497, -2.2410266803278587]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.78271469814786, "lat": 36.37906117622351 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40047"],
        "coty_name": ["Garfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garfield County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01101811"
      },
      "bbox": [
        -1.2189037583200668, -2.5517950838513728, -0.6986030043471924,
        -2.109440031053888
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6415461941676881, -4.2221710637208245],
            [-0.5835626621368971, -4.2229601602415014],
            [-0.47136478432552165, -4.2245909200662775],
            [-0.47136714846584576, -4.221264899176499],
            [-0.4764801884893691, -4.217813986576952],
            [-0.4786963834861778, -4.214265091551134],
            [-0.4722372146513247, -4.212155096487268],
            [-0.47595348930914594, -4.209637903820687],
            [-0.48165661759351586, -4.209212946205355],
            [-0.48446411453928523, -4.201196299896272],
            [-0.48814370861947604, -4.200224345213182],
            [-0.48428879131446156, -4.196020129540347],
            [-0.48697418389188374, -4.183379215175309],
            [-0.48186541516422726, -4.178657097018217],
            [-0.4873338137576071, -4.170950309811939],
            [-0.48168089807734044, -4.1679622681259145],
            [-0.49162822922389793, -4.167489865628772],
            [-0.49449984730955776, -4.165526888146259],
            [-0.496752766399666, -4.158939721506806],
            [-0.4953403055834546, -4.1562209303260715],
            [-0.48975464221608295, -4.15823538349355],
            [-0.48713784275421323, -4.155594541067137],
            [-0.49306271338007657, -4.151959087125756],
            [-0.4945166448812046, -4.143657972980814],
            [-0.49076202687081066, -4.144678567489001],
            [-0.4927838345296109, -4.137191988535806],
            [-0.49639618651890294, -4.134739994617929],
            [-0.5001375270100505, -4.135320246268635],
            [-0.5073270166233596, -4.134250340140371],
            [-0.51014799130105, -4.129560932114856],
            [-0.5081194249862344, -4.1255656772698],
            [-0.5142393449962069, -4.121343609586258],
            [-0.5143391570119894, -4.116257640593579],
            [-0.5115523790049467, -4.113949384334897],
            [-0.5157410133974547, -4.107242045982077],
            [-0.46884006674597095, -4.107988571712904],
            [-0.46871859210415956, -4.093374008900243],
            [-0.4258981627650454, -4.094005478572297],
            [-0.35539354466041034, -4.094848588889187],
            [-0.35441408260003454, -4.094989643408586],
            [-0.29718192172372027, -4.095557710962035],
            [-0.2975890128895359, -4.139350917062381],
            [-0.2116307343828284, -4.140185777563959],
            [-0.21255808459754502, -4.227814641050667],
            [-0.256246341135826, -4.227432162329649],
            [-0.2569316483914458, -4.300118381009353],
            [-0.25803924414383594, -4.401391707632703],
            [-0.3008897452600614, -4.401401989322817],
            [-0.3794461845797351, -4.400920953158657],
            [-0.38069042584025575, -4.3982542665755675],
            [-0.3878463483596953, -4.395498170763259],
            [-0.39030438844526966, -4.388367734925873],
            [-0.38117624398226063, -4.38252117276249],
            [-0.38412719151949065, -4.377608596605052],
            [-0.38377659463997144, -4.372355862757041],
            [-0.3866254079122662, -4.367964816039595],
            [-0.3863754135044814, -4.364432617298071],
            [-0.3827228486679109, -4.359999598095603],
            [-0.38638083541643126, -4.357153562517632],
            [-0.5009745708832005, -4.355309572972915],
            [-0.5791613938603091, -4.354364218019136],
            [-0.6433635475613991, -4.353447684328235],
            [-0.6423034492554364, -4.273298447246929],
            [-0.6415461941676881, -4.2221710637208245]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.0679159997606, "lat": 34.48232962244742 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40099"],
        "coty_name": ["Murray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Murray County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01101837"
      },
      "bbox": [
        -0.6433635475613991, -4.401401989322817, -0.2116307343828284,
        -4.093374008900243
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.403107537458013, -2.0744345768771377],
            [-2.4030687129312542, -2.073244696082739],
            [-2.2786852150362784, -2.0777318637398716],
            [-2.271411873134326, -2.078134724179565],
            [-2.160059095834649, -2.0810048389308866],
            [-2.1563653010793877, -2.079654049013191],
            [-2.153435753695104, -1.9938737675866571],
            [-2.149897247066722, -1.9023260303920653],
            [-2.148435688918129, -1.8546736199317766],
            [-2.1481779025990533, -1.868441888216195],
            [-2.1423070593332776, -1.8725536678135517],
            [-2.1350591338074594, -1.8791144974836291],
            [-2.129686358524912, -1.8854495233265378],
            [-2.114125937409316, -1.890740801733471],
            [-2.1077597704190474, -1.8902120716129323],
            [-2.0977269820530497, -1.8881233576921563],
            [-2.0882005291603374, -1.8898094772627179],
            [-2.0823634293291096, -1.8860903781278837],
            [-2.073238713909991, -1.8862011248785007],
            [-2.065453591402093, -1.8900187031617026],
            [-2.0589099458585554, -1.890189484195285],
            [-2.0464648266566035, -1.8873427391798598],
            [-2.040906178653781, -1.8903949960815505],
            [-2.03627752268166, -1.890728344453576],
            [-2.0265649302803923, -1.895677930637515],
            [-2.0228785513549075, -1.900497370485731],
            [-2.0212830292094224, -1.9049458426234942],
            [-2.017835074441047, -1.9097258138709823],
            [-2.016703986849953, -1.9166737710687236],
            [-2.0070632531188894, -1.9256242716246181],
            [-2.0021881437699025, -1.929387019055378],
            [-2.00149816828506, -1.9324463925884818],
            [-1.998127091113583, -1.9361334163178994],
            [-1.9942917312181085, -1.9381110483912924],
            [-1.9930970081761954, -1.9435077444733564],
            [-1.9846823379349625, -1.9590962323700458],
            [-1.9798467940933182, -1.9629802027947694],
            [-1.9732161385711413, -1.9649956262657688],
            [-1.9666508402450376, -1.9658695958041164],
            [-1.9596098234530912, -1.9764638304021802],
            [-1.957680357415505, -1.98206698438645],
            [-1.9536895489726296, -1.9869829952442641],
            [-1.9571976583713158, -1.995072793333281],
            [-1.9525717169693648, -2.000058486709294],
            [-1.9507318757563612, -2.003633397866225],
            [-1.950392493281809, -2.0086240431540143],
            [-1.948151051531594, -2.0129243803923162],
            [-1.9439654656721879, -2.0175894717508087],
            [-1.93873324881253, -2.021133774269706],
            [-1.9373969020453228, -2.0238806250073273],
            [-1.939622643976988, -2.0324578712322925],
            [-1.9380648426380696, -2.04049317776768],
            [-1.93052341408705, -2.0429462644964875],
            [-1.9284656375484148, -2.050050245705158],
            [-1.9208674413296283, -2.054067704396376],
            [-1.9137347710635335, -2.0647328578120043],
            [-1.9121174744559117, -2.0683893265600704],
            [-1.9024055105429036, -2.0813689931372195],
            [-1.898836531337083, -2.0842402876590165],
            [-1.8897290734671846, -2.085865848221971],
            [-1.8930447205594452, -2.1786280633564448],
            [-1.892910836416613, -2.1787028815457274],
            [-1.893412610365655, -2.189762025615988],
            [-1.8968155896520582, -2.292699506713423],
            [-1.8992256738144524, -2.3673902986049673],
            [-1.9012795843954953, -2.441032149919361],
            [-1.8975830411095123, -2.441098707865272],
            [-1.9001811971868015, -2.526948464421415],
            [-1.9815179865390038, -2.5236838904402936],
            [-2.029185070252815, -2.521584533026436],
            [-2.0358495663796567, -2.5219388594143726],
            [-2.1320151454799645, -2.517541988746838],
            [-2.13864524747404, -2.516801831043729],
            [-2.2408192689059083, -2.5128492684858768],
            [-2.298020830696193, -2.511171732579687],
            [-2.411883596940683, -2.5068148288745533],
            [-2.4086168443891545, -2.423487340195168],
            [-2.41590269354753, -2.42322456747051],
            [-2.4124217704706155, -2.32104425918596],
            [-2.410176272346982, -2.2594076454424377],
            [-2.4084309245718676, -2.2188326890906587],
            [-2.4038538417490125, -2.098926623087378],
            [-2.403107537458013, -2.0744345768771377]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.26515921960711,
          "lat": 36.422665318626144
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40153"],
        "coty_name": ["Woodward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woodward County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01101864"
      },
      "bbox": [
        -2.41590269354753, -2.526948464421415, -1.8897290734671846,
        -1.8546736199317766
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.169354323092826, 9.269267462047688],
            [-18.154961005370854, 9.26498562805323],
            [-18.146935724447825, 9.292253341233096],
            [-18.120323994238447, 9.284972225943525],
            [-18.119394281504075, 9.284073151744575],
            [-18.123203103798698, 9.27088597595712],
            [-18.081455228146563, 9.259264779246202],
            [-18.05756234823407, 9.34163280440726],
            [-18.0533234983887, 9.355257304340345],
            [-17.989444642302345, 9.336480497532023],
            [-17.99017707809291, 9.340119955591348],
            [-17.98588725220898, 9.342521213456399],
            [-17.98561293177627, 9.346960981761985],
            [-17.988455695160283, 9.349574211665773],
            [-17.99075613784356, 9.362631628343895],
            [-17.977220483046153, 9.359660227887996],
            [-17.97666850740787, 9.362389966806154],
            [-17.93451297482048, 9.350467088057352],
            [-17.92062104505953, 9.34606408986993],
            [-17.90662866503918, 9.342402763738669],
            [-17.879176344046, 9.334261808954958],
            [-17.84358044905652, 9.32423767539967],
            [-17.82352160699642, 9.319180291819182],
            [-17.795049210114716, 9.310804552458587],
            [-17.775259717277983, 9.305560573981836],
            [-17.727950457498466, 9.292158598261475],
            [-17.712738713363958, 9.28743081444101],
            [-17.64342276489545, 9.2679716167537],
            [-17.6296873580522, 9.263337576486755],
            [-17.62934463021, 9.264534394076092],
            [-17.602158435810953, 9.25623583092867],
            [-17.546681674192996, 9.241821975120315],
            [-17.532505088044083, 9.237762432806996],
            [-17.53282060411719, 9.236654360811256],
            [-17.423947547110743, 9.206607685778458],
            [-17.42195818406787, 9.207545615951169],
            [-17.417623427560017, 9.20004420080924],
            [-17.415234222231398, 9.19849698245569],
            [-17.417252757711342, 9.193245068491535],
            [-17.41716023073394, 9.188427426059004],
            [-17.41919509496667, 9.187197240894942],
            [-17.42046860363193, 9.180213083642332],
            [-17.417468861131468, 9.171567528961155],
            [-17.41507557646246, 9.167275559470552],
            [-17.416257201679894, 9.158320071528678],
            [-17.412288564969373, 9.154144829428997],
            [-17.408456414423856, 9.143363267765384],
            [-17.39891590033007, 9.140921229107803],
            [-17.388545469877286, 9.132354450314992],
            [-17.375691229962342, 9.125128373034896],
            [-17.37460429255301, 9.120476629068925],
            [-17.36780851147, 9.112690282951043],
            [-17.365769373740637, 9.112056177444373],
            [-17.363686168372276, 9.10634679178452],
            [-17.363469887721664, 9.099555513162718],
            [-17.368861321301996, 9.09224259641197],
            [-17.37017335981773, 9.085203782482884],
            [-17.373653575416654, 9.078820744302604],
            [-17.37696221450002, 9.06968709704734],
            [-17.378203705931607, 9.061870383593519],
            [-17.377070747274747, 9.054036970276526],
            [-17.374454096187762, 9.050674595608344],
            [-17.373184910121285, 9.045232697183309],
            [-17.374841642806867, 9.034049769823099],
            [-17.370933870126592, 9.024928643626199],
            [-17.37346657938277, 9.018287902446279],
            [-17.377563771799423, 9.01554704115055],
            [-17.379074576378915, 9.011385882556246],
            [-17.384415882006987, 9.006517152051423],
            [-17.385650472235902, 9.002769366025518],
            [-17.390644519245793, 8.996155375251904],
            [-17.393212591708636, 8.990767323664674],
            [-17.39007538947853, 8.983168239421223],
            [-17.38461021041017, 8.98088617393112],
            [-17.386936226677474, 8.974254874841312],
            [-17.39005983345366, 8.971593529940067],
            [-17.39286363748692, 8.965420854768992],
            [-17.39337034520625, 8.960541616753181],
            [-17.397152965263786, 8.96275541116321],
            [-17.402189959159127, 8.961911417284195],
            [-17.404279013135408, 8.959060307591253],
            [-17.412015794648827, 8.956999867867644],
            [-17.41656257249783, 8.950436426256637],
            [-17.4187343853892, 8.949567478678487],
            [-17.42867220184459, 8.952908780135244],
            [-17.433852310883953, 8.94958502691943],
            [-17.44244755048155, 8.950076301982381],
            [-17.44628372466592, 8.937482147952403],
            [-17.44625405991101, 8.931881694628485],
            [-17.443201977537026, 8.92681372839992],
            [-17.442191027708418, 8.920467850941217],
            [-17.440459928352457, 8.918556515367737],
            [-17.439316382293892, 8.911758623762939],
            [-17.439820782422228, 8.904674562324423],
            [-17.438508816559843, 8.90102896385889],
            [-17.431830444423866, 8.894139447233645],
            [-17.431715066510964, 8.889293808317143],
            [-17.4340077393026, 8.881359878569887],
            [-17.434180300212738, 8.8749055766044],
            [-17.43072319983663, 8.866785664430461],
            [-17.431771889618112, 8.861657908133024],
            [-17.42879867238457, 8.85585970663673],
            [-17.42129891969859, 8.860740467069514],
            [-17.40992911569169, 8.854375118007006],
            [-17.408691760786542, 8.846679212228752],
            [-17.410314528126015, 8.838989355632597],
            [-17.405102879834825, 8.834040938016724],
            [-17.40647318007935, 8.830915686242346],
            [-17.40876169380141, 8.81935188765064],
            [-17.415829844422312, 8.81402644390876],
            [-17.41908100735663, 8.804484199456688],
            [-17.41874412608336, 8.801191320145769],
            [-17.43500432440022, 8.807341146869753],
            [-17.438568136118608, 8.80738976105211],
            [-17.446487417505047, 8.803929341792903],
            [-17.448870246872477, 8.801393166701228],
            [-17.456961328480315, 8.800932364369162],
            [-17.467769732869, 8.793134564356212],
            [-17.46614847422623, 8.789499744189103],
            [-17.466521034597196, 8.784715182228792],
            [-17.475714346394977, 8.785814896967285],
            [-17.48127504556381, 8.784705298669712],
            [-17.48907025284925, 8.787339493807881],
            [-17.49035944745237, 8.789812986345993],
            [-17.499196660747746, 8.795749766860903],
            [-17.502012879138018, 8.796787309083026],
            [-17.50809439441695, 8.795829244040407],
            [-17.511201927261073, 8.793007622350096],
            [-17.511144956878322, 8.785329225627802],
            [-17.513995997242205, 8.781233183435187],
            [-17.51558100771473, 8.775746564365917],
            [-17.518037139813504, 8.775817744328597],
            [-17.52330176354652, 8.779667664078438],
            [-17.532157680166023, 8.777384706666874],
            [-17.534815215442343, 8.771179121179369],
            [-17.534859933206327, 8.76450408246714],
            [-17.537067566046908, 8.757467479209645],
            [-17.53834227752441, 8.748130564019492],
            [-17.541028609350565, 8.743075326447476],
            [-17.5390161380604, 8.741852856007055],
            [-17.537826564763105, 8.735397319321045],
            [-17.538215134762062, 8.721204555731711],
            [-17.536119679107795, 8.714266321639219],
            [-17.538280476987822, 8.709564801410659],
            [-17.5467687746778, 8.703887610035013],
            [-17.54313082232784, 8.700067394376418],
            [-17.536239985813133, 8.69865672224113],
            [-17.529851897417053, 8.701716883229384],
            [-17.52288910457305, 8.70123508739363],
            [-17.51960962502931, 8.690884689591611],
            [-17.51695166342504, 8.685534229972493],
            [-17.516383458842906, 8.6774571632558],
            [-17.519623005977945, 8.673009478586941],
            [-17.509783688469923, 8.66021633522737],
            [-17.50530069170332, 8.660528906680172],
            [-17.49959555717816, 8.658774227265805],
            [-17.501934955934058, 8.653135383275249],
            [-17.504413443913858, 8.651176262037964],
            [-17.509261956688572, 8.650373852751056],
            [-17.51285464965954, 8.647221240924155],
            [-17.51842642044981, 8.645795627536502],
            [-17.51846191248604, 8.642976192940674],
            [-17.56786152512469, 8.656552590000693],
            [-17.64460045817239, 8.677892149936747],
            [-17.72134387340021, 8.699214816293546],
            [-17.798091747350732, 8.720520582290442],
            [-17.87484405653624, 8.741809441266524],
            [-17.972509150642836, 8.769255333311222],
            [-17.96557255455056, 8.773428418771656],
            [-17.96460299613701, 8.783283427301013],
            [-17.96646964469217, 8.786448413662956],
            [-17.971777801885544, 8.788906789542382],
            [-17.97410372820296, 8.78770459524024],
            [-17.98221147840421, 8.790965542997743],
            [-17.98752256872345, 8.790276384121146],
            [-17.995018326791268, 8.794377227456902],
            [-17.99907205225219, 8.802126998790117],
            [-18.003489372488612, 8.808353383455549],
            [-18.008851329490263, 8.810134621862847],
            [-18.013914955464365, 8.814575336562859],
            [-18.01657540233283, 8.818592476550972],
            [-18.020261857217537, 8.820758731967123],
            [-18.03042685793638, 8.818612009358533],
            [-18.034454610032228, 8.820318755604601],
            [-18.037469221067735, 8.825594369305826],
            [-18.039020287164043, 8.831416329320382],
            [-18.0387750418316, 8.836432254291172],
            [-18.043853826869206, 8.841214745969179],
            [-18.04639210386535, 8.8408928135444],
            [-18.049979428680764, 8.846994285729208],
            [-18.051969580662387, 8.8534154964589],
            [-18.051775852912193, 8.856661891104999],
            [-18.055020844114036, 8.859180104535836],
            [-18.0550954390955, 8.866950442500265],
            [-18.058511126393775, 8.875373334698134],
            [-18.057744553484724, 8.881537869552675],
            [-18.05971333445078, 8.884678684726433],
            [-18.05889268529866, 8.893359680670336],
            [-18.060943823593245, 8.89666487850337],
            [-18.066418638565104, 8.899013625080006],
            [-18.06698279536224, 8.901668691583817],
            [-18.07417943037641, 8.904192858685814],
            [-18.07514855785246, 8.908488432570035],
            [-18.07281573394223, 8.910551732095708],
            [-18.06843792618097, 8.9266186499798],
            [-18.069404568272734, 8.92860150255678],
            [-18.067745980411043, 8.934010306557898],
            [-18.071655366271752, 8.937347331909809],
            [-18.076417212051833, 8.938784036842202],
            [-18.077400494948428, 8.941623914586827],
            [-18.08140603383702, 8.945447995120348],
            [-18.08634145652266, 8.948282096648677],
            [-18.089886672867248, 8.954888594074136],
            [-18.094543639442488, 8.953791011035412],
            [-18.100370638003003, 8.95997887998207],
            [-18.105973103667896, 8.961606854157747],
            [-18.10794120387437, 8.965007617406938],
            [-18.110567145898564, 8.973880718637705],
            [-18.11663417183513, 8.97537558178749],
            [-18.117327666811235, 8.979679665960573],
            [-18.11985201111183, 8.982604276966702],
            [-18.125432825022056, 8.985857492014741],
            [-18.131163646382728, 8.992878829194085],
            [-18.131112624399595, 8.998204876443543],
            [-18.136259706021093, 9.00523945454909],
            [-18.13707504566876, 9.01155655712898],
            [-18.135299337186503, 9.01500311572756],
            [-18.138208470782452, 9.019153997348663],
            [-18.137647538657482, 9.021860144896262],
            [-18.140801628647264, 9.029469963596046],
            [-18.1466789823241, 9.035385323381936],
            [-18.1469244959962, 9.042109650428563],
            [-18.151803456262503, 9.052861355132453],
            [-18.15620037848852, 9.056729124930142],
            [-18.166552360955876, 9.073247808842826],
            [-18.166492716796025, 9.076289121271042],
            [-18.163821670804516, 9.08104726440857],
            [-18.1605587159136, 9.082006830645836],
            [-18.160252760582587, 9.08820544387041],
            [-18.150209486633546, 9.097469156857755],
            [-18.148553903705302, 9.101043668167565],
            [-18.143822760132426, 9.10352440819166],
            [-18.140316814262775, 9.107298660860966],
            [-18.1346027047995, 9.110662459958807],
            [-18.135584684994754, 9.11336763306058],
            [-18.131708957533977, 9.11975611500188],
            [-18.128008800796742, 9.123917083991156],
            [-18.126814989438646, 9.127940800515502],
            [-18.122918506413946, 9.13448335903742],
            [-18.12788383983094, 9.140133664138832],
            [-18.12135161713461, 9.144893561963721],
            [-18.118172872752456, 9.145298577168768],
            [-18.11483924071129, 9.149406315440704],
            [-18.115342996709316, 9.154421976468521],
            [-18.113157418475975, 9.158435474676487],
            [-18.11408452354517, 9.162497052764273],
            [-18.11009749822166, 9.165350385508074],
            [-18.11314418203793, 9.168554391414627],
            [-18.111178042816142, 9.17124597430681],
            [-18.11187674574178, 9.17590542300323],
            [-18.109285612166047, 9.180036045406645],
            [-18.09839628987071, 9.189529223772666],
            [-18.129315119187062, 9.19838875886615],
            [-18.125375460470995, 9.212180490674228],
            [-18.15893429217532, 9.221769159759932],
            [-18.162455907178156, 9.218141526299883],
            [-18.170683887580374, 9.212103973413297],
            [-18.173307171577253, 9.211116349530005],
            [-18.185567361802683, 9.214628335158103],
            [-18.169354323092826, 9.269267462047688]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.22075615904298,
          "lat": 45.18800748012509
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41005"],
        "coty_name": ["Clackamas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clackamas County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01155127"
      },
      "bbox": [
        -18.185567361802683, 8.642976192940674, -17.363469887721664,
        9.362631628343895
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.52748916460093, 8.757414544678074],
            [-18.52635892369994, 8.764709868041878],
            [-18.522619830096247, 8.767726218752932],
            [-18.51174299008533, 8.771874228470802],
            [-18.509852603807012, 8.776177369433778],
            [-18.512248370604233, 8.78068968243989],
            [-18.515864889514695, 8.783650243108502],
            [-18.508153994477695, 8.784710318988221],
            [-18.500544046237213, 8.781725358051137],
            [-18.496090625941843, 8.787750453947996],
            [-18.491062575399173, 8.786916323653848],
            [-18.48992506956164, 8.776533122685985],
            [-18.486839982388116, 8.772547748911315],
            [-18.48143481613065, 8.772262709874832],
            [-18.47495433870914, 8.766044225754902],
            [-18.47149797098127, 8.765209883331254],
            [-18.46370412441185, 8.767690606078233],
            [-18.46054591801832, 8.766723304288357],
            [-18.46046011850851, 8.763439055865565],
            [-18.462922887840307, 8.757946107862606],
            [-18.459009220567864, 8.754920732314526],
            [-18.454981805322166, 8.755258446152707],
            [-18.44979833777487, 8.752836473425916],
            [-18.44916532203235, 8.748520144292037],
            [-18.452712904413666, 8.744781661665526],
            [-18.452952563386557, 8.741003204706848],
            [-18.449186650350335, 8.735073355296162],
            [-18.440903996700058, 8.737867345541254],
            [-18.438236323908868, 8.736888399956342],
            [-18.436581826274118, 8.732054348116781],
            [-18.437007356491453, 8.725718062687683],
            [-18.439432883869596, 8.720468847569844],
            [-18.444369942218547, 8.712840857174944],
            [-18.44428663159233, 8.70637962980639],
            [-18.44009398289887, 8.697720432066914],
            [-18.436108880853247, 8.698660773853266],
            [-18.432314285331422, 8.697660558164348],
            [-18.432245525359033, 8.702887948247872],
            [-18.428532894482217, 8.703835990651163],
            [-18.42571693087925, 8.700926779294207],
            [-18.422541120788072, 8.702590304551538],
            [-18.41599451166406, 8.701787780288251],
            [-18.41366257152091, 8.704148923115573],
            [-18.412161770603017, 8.709212526788535],
            [-18.40702481062983, 8.715220021055968],
            [-18.401990721470295, 8.716300898206446],
            [-18.39672961357266, 8.720497254717607],
            [-18.39106726733972, 8.715659770229587],
            [-18.38875310858201, 8.712406992505398],
            [-18.382440117046652, 8.710899898599962],
            [-18.369409328204142, 8.718627110881116],
            [-18.361285282285937, 8.72206770472621],
            [-18.359728852943366, 8.725709826529762],
            [-18.35258158104124, 8.728370469512678],
            [-18.34946889515946, 8.731512543892869],
            [-18.345847547909468, 8.730648098205132],
            [-18.343413594258827, 8.733552174841149],
            [-18.33761614965977, 8.73437300827843],
            [-18.332005692920095, 8.732866750815262],
            [-18.328394574119, 8.738018369219109],
            [-18.31725092716178, 8.73693250272903],
            [-18.311986570713337, 8.738622762137846],
            [-18.308754751623965, 8.74310498465118],
            [-18.30827553995522, 8.74823442776998],
            [-18.303957200138914, 8.748767166353494],
            [-18.302474994936162, 8.744479660507563],
            [-18.298249859297066, 8.742940289594834],
            [-18.292840084394424, 8.742843330733411],
            [-18.286973899473555, 8.747849391960347],
            [-18.28270815268706, 8.74806748818964],
            [-18.280155958703702, 8.75312827537098],
            [-18.277118341922773, 8.752490154677908],
            [-18.27005644963165, 8.756885236088783],
            [-18.26621013414928, 8.755658317506246],
            [-18.257391829792084, 8.756030238079255],
            [-18.254910758412247, 8.753523696242238],
            [-18.245943452616427, 8.751547602027998],
            [-18.242595281920046, 8.747575345477747],
            [-18.235700201158615, 8.743016445348118],
            [-18.227917047270022, 8.742587454472833],
            [-18.22218951224198, 8.741335230902928],
            [-18.219862257284966, 8.744032865408045],
            [-18.21592999189586, 8.739019531478274],
            [-18.214375457882703, 8.72906978443562],
            [-18.200733401819832, 8.720293999541004],
            [-18.195054019840295, 8.719408757056813],
            [-18.190417058892773, 8.719978446699905],
            [-18.18594032521147, 8.718343210840718],
            [-18.178078149250823, 8.71888949710692],
            [-18.16761688188131, 8.718100139423811],
            [-18.161778145102108, 8.721233524725184],
            [-18.15338453210826, 8.719667106962001],
            [-18.14846232761578, 8.719670873120373],
            [-18.14516737217207, 8.71776348008669],
            [-18.138754018718668, 8.70995408641982],
            [-18.137222380495654, 8.705108727789916],
            [-18.126163392011424, 8.700971502250336],
            [-18.119425103950476, 8.697352492995726],
            [-18.116136481645157, 8.68870592394312],
            [-18.104253983909707, 8.684604276650008],
            [-18.099682011508303, 8.680733405422485],
            [-18.093762964441765, 8.681056884798988],
            [-18.08830904999083, 8.676653752904318],
            [-18.08968673798201, 8.673551247141138],
            [-18.090058052974026, 8.6667222986329],
            [-18.084420155533337, 8.663869728450685],
            [-18.07946267468577, 8.659448470416736],
            [-18.074621805372026, 8.65939724409367],
            [-18.062100718483705, 8.66077580209782],
            [-18.058636870623303, 8.656005132945609],
            [-18.049467956837766, 8.656915220032106],
            [-18.0376379574378, 8.653028475332839],
            [-18.035634977309464, 8.650937258929783],
            [-18.031293041721035, 8.652395963197106],
            [-18.024571017423174, 8.645671747914346],
            [-18.02137233357189, 8.646911878710513],
            [-18.016959008132837, 8.644104345406944],
            [-18.014695691696712, 8.645955706962557],
            [-18.009208324469558, 8.644845190884952],
            [-18.00730127128328, 8.641800476735876],
            [-18.00205468419235, 8.642973033140498],
            [-17.993975717931175, 8.637629563380745],
            [-17.986911242683405, 8.6402718645092],
            [-17.97250028622323, 8.637790618434888],
            [-17.96308743742991, 8.632436698275246],
            [-17.956073724619213, 8.633911856607842],
            [-17.9503764782799, 8.632470401682333],
            [-17.947109088527704, 8.62876786114632],
            [-17.939868784408645, 8.624723217036493],
            [-17.934990163930646, 8.623067262067783],
            [-17.929069871903994, 8.617961157881323],
            [-17.92607471413225, 8.612487937816379],
            [-17.925489213216864, 8.607043038978816],
            [-17.92652091338318, 8.601667557098708],
            [-17.921612460235437, 8.59646420051017],
            [-17.917181869719812, 8.588956695039256],
            [-17.916790763828338, 8.585549599178394],
            [-17.91317118801824, 8.582723712701865],
            [-17.913028014336046, 8.57908024905247],
            [-17.90824048908479, 8.558397323637367],
            [-17.902575938707546, 8.554252928834682],
            [-17.900777041307496, 8.550925411132171],
            [-17.894669185787993, 8.552302419824155],
            [-17.88987690064481, 8.551937810993687],
            [-17.886954211214423, 8.55007598427933],
            [-17.883556220423213, 8.556043737855104],
            [-17.878127744864216, 8.555346437276546],
            [-17.870626497983505, 8.556664103912007],
            [-17.86356162623079, 8.56102244186717],
            [-17.85982015712758, 8.56052188414255],
            [-17.84983807003956, 8.563873790604076],
            [-17.847524231343282, 8.567975135555784],
            [-17.84459182512327, 8.569084872856344],
            [-17.837669539744606, 8.566177022248196],
            [-17.834661350838697, 8.561182642446786],
            [-17.834345907346815, 8.557864000152962],
            [-17.829988230070462, 8.555769418236137],
            [-17.82788233733237, 8.548825919038807],
            [-17.82452694647621, 8.546994812607803],
            [-17.822102017318816, 8.543297258724765],
            [-17.81637721587249, 8.541683489265253],
            [-17.808123310266964, 8.534229800328136],
            [-17.80553774483998, 8.529973576927237],
            [-17.802300607539607, 8.531024348887085],
            [-17.795693174648125, 8.524880268776679],
            [-17.790778462798166, 8.524148211133458],
            [-17.790110179021525, 8.520463200682508],
            [-17.78402078394953, 8.517371868855662],
            [-17.78434699975259, 8.513802849246382],
            [-17.77781686076484, 8.510553682177788],
            [-17.77623200265923, 8.508417767198189],
            [-17.77052453002885, 8.511214287502012],
            [-17.76309802458853, 8.509798111012804],
            [-17.75942077940799, 8.504811982938742],
            [-17.754957690700692, 8.506029209721568],
            [-17.752964524175553, 8.504081285694276],
            [-17.737995270212423, 8.505981241811165],
            [-17.73389934551513, 8.503086636417397],
            [-17.731434954012855, 8.495771957010954],
            [-17.72944773527049, 8.493579539999063],
            [-17.617203276073536, 8.462605485315473],
            [-17.619576583962573, 8.457749195935197],
            [-17.62109781675326, 8.450814358369618],
            [-17.625359033807, 8.437626251837731],
            [-17.62431450250763, 8.43401704757381],
            [-17.625122101907383, 8.429381359351845],
            [-17.6273340197661, 8.426610926693959],
            [-17.62781343127673, 8.420661124053824],
            [-17.62956683783202, 8.419953207897176],
            [-17.638084717936394, 8.411034997658343],
            [-17.64349966492468, 8.398301872370068],
            [-17.640850324807058, 8.39689387759809],
            [-17.637729076681236, 8.38725181600986],
            [-17.640133515539432, 8.382819999224294],
            [-17.637379581528926, 8.379440178587343],
            [-17.637471548312906, 8.375712695172492],
            [-17.640862946606664, 8.37142670290068],
            [-17.646430482905892, 8.360004075937415],
            [-17.64673732278597, 8.35670798566646],
            [-17.651623607976408, 8.349626580460885],
            [-17.65169422197245, 8.346648201197734],
            [-17.654311089696236, 8.340475395581093],
            [-17.657850431770203, 8.337877807444242],
            [-17.65956097219552, 8.333280506077326],
            [-17.664547841956185, 8.33115589338452],
            [-17.668641731606893, 8.323085326060099],
            [-17.667676614346313, 8.31971909039938],
            [-17.66912578917748, 8.313499665735396],
            [-17.66866826222825, 8.305536536806233],
            [-17.669977946751175, 8.302052375742973],
            [-17.675969695104182, 8.302847773963583],
            [-17.67975149182061, 8.30205925322433],
            [-17.68260495283684, 8.298497074238691],
            [-17.688336532025023, 8.295963319356934],
            [-17.690869807421457, 8.292902988708404],
            [-17.701459226136027, 8.287332762106985],
            [-17.70494133642138, 8.281529937894124],
            [-17.70291457656224, 8.279785133022408],
            [-17.702079419033897, 8.275087654926748],
            [-17.704639821178443, 8.268375989779795],
            [-17.709383941699468, 8.266111941894895],
            [-17.711674262871316, 8.252713183344815],
            [-17.70995032773959, 8.242110210027693],
            [-17.711020594347474, 8.23937890423824],
            [-17.71668512801148, 8.232602612397821],
            [-17.718714690364465, 8.227881771264373],
            [-17.718053573663923, 8.225462642285377],
            [-17.719478344772746, 8.216883200477334],
            [-17.721124661489377, 8.214000396564446],
            [-17.719213934047115, 8.209759867395197],
            [-17.722803721563444, 8.206982582337297],
            [-17.725314259088208, 8.202345425674736],
            [-17.725408588841308, 8.19251061363355],
            [-17.726375317915117, 8.18913384183053],
            [-17.729587477467113, 8.186429285245923],
            [-17.730330073618042, 8.181012034473772],
            [-17.729911018033558, 8.173410909745416],
            [-17.734304901016046, 8.168417788066135],
            [-17.733217645478128, 8.162863968235753],
            [-17.73070679871613, 8.158571348646754],
            [-17.738374609405874, 8.148481018550878],
            [-17.739215689502753, 8.144293761581991],
            [-17.737157342356298, 8.137959158505014],
            [-17.743087564359147, 8.123552762077749],
            [-17.743976679328156, 8.115035602441141],
            [-17.746288463314787, 8.111276242107257],
            [-17.745458950786187, 8.105680885675408],
            [-17.751799574158305, 8.09346264287504],
            [-17.74970232180574, 8.090185952518635],
            [-17.74476886943916, 8.08690309032704],
            [-17.74235736617363, 8.083809076585037],
            [-17.744692239378203, 8.076401732071528],
            [-17.743541638815977, 8.072553420365198],
            [-17.74319997139698, 8.064772428779351],
            [-17.744125722837463, 8.062983326469125],
            [-17.731531610904227, 8.05572776664041],
            [-17.842304854625784, 8.0853554311501],
            [-17.889288706129573, 8.097219285038895],
            [-17.88991138268294, 8.094972467923863],
            [-17.971176270115826, 8.117704489767137],
            [-18.05244586622096, 8.140418730806953],
            [-18.052778940092992, 8.139256105056749],
            [-18.095736734997796, 8.151548885151017],
            [-18.101969504056076, 8.143538237241616],
            [-18.102067043605494, 8.140696701103364],
            [-18.0989575774629, 8.136699558914934],
            [-18.101792865957243, 8.134544888998246],
            [-18.101788452647796, 8.130899218062424],
            [-18.10588061230823, 8.128400383334304],
            [-18.109449564029585, 8.128732002556532],
            [-18.113563612321443, 8.124290259326457],
            [-18.122045779483816, 8.125817321415129],
            [-18.12782457801204, 8.119788160110069],
            [-18.135181153471713, 8.11778701219405],
            [-18.139434057205328, 8.120052824275788],
            [-18.14368017867373, 8.120245534315927],
            [-18.146670459771826, 8.122713404576892],
            [-18.145000968315543, 8.128489984752866],
            [-18.15892764878624, 8.132291186435047],
            [-18.157902957273024, 8.135762921587055],
            [-18.1718556044273, 8.13978316165361],
            [-18.172527157098873, 8.13743341990626],
            [-18.1784061861839, 8.142304621566797],
            [-18.18180788655335, 8.140585168419479],
            [-18.188970654104796, 8.140584158070586],
            [-18.19376748066016, 8.144304031227104],
            [-18.199045659829082, 8.149931850675438],
            [-18.204750705080677, 8.15089284145175],
            [-18.20863428758872, 8.148676862276346],
            [-18.21497990232719, 8.153294702092445],
            [-18.218193270998167, 8.152180493141119],
            [-18.220794295590114, 8.15533545243612],
            [-18.2252161745818, 8.15592953497927],
            [-18.229549014125713, 8.16350917460928],
            [-18.229525836127415, 8.167340903380813],
            [-18.23384844198735, 8.167721687928708],
            [-18.241057004370468, 8.16540833845038],
            [-18.24338732086386, 8.169552649548],
            [-18.24368325256321, 8.174791067053103],
            [-18.253384508356813, 8.178044684774976],
            [-18.25574517425028, 8.175565378481576],
            [-18.26089580400318, 8.175244093389532],
            [-18.263138992155667, 8.176964918243419],
            [-18.267149245080283, 8.175759211931565],
            [-18.274195007199253, 8.17821915405671],
            [-18.271063020222122, 8.182326937550817],
            [-18.271619735916868, 8.184508908726164],
            [-18.276980184284934, 8.188709384277502],
            [-18.280912467002658, 8.195250091719648],
            [-18.28862049301524, 8.197237204408603],
            [-18.299202689313617, 8.206059300713214],
            [-18.311297702851626, 8.208895704790644],
            [-18.313723002257976, 8.213920836871786],
            [-18.311616687771387, 8.220170239725068],
            [-18.311361686110256, 8.226843705723082],
            [-18.31773189934158, 8.233282585279143],
            [-18.3258901010932, 8.233345491890864],
            [-18.329632242219493, 8.239199508689186],
            [-18.338506673326872, 8.242158795377778],
            [-18.344296873071585, 8.250000613822063],
            [-18.347695448623135, 8.249196242051303],
            [-18.360346703947148, 8.25791716868843],
            [-18.3598919625436, 8.26140959639327],
            [-18.363176120532753, 8.26396232998919],
            [-18.36864921388552, 8.263045566956276],
            [-18.37087086086889, 8.265374453083943],
            [-18.37698114890258, 8.264294447424545],
            [-18.381713417541995, 8.271162198581171],
            [-18.38420782568596, 8.272362866454195],
            [-18.39539431097927, 8.268621110029457],
            [-18.40090037430866, 8.26982947046474],
            [-18.403312490823858, 8.272784716056554],
            [-18.41670582359954, 8.274973684394302],
            [-18.423619116440456, 8.268912054839346],
            [-18.430058811230435, 8.268745283437477],
            [-18.43279314231661, 8.273875872388643],
            [-18.43296452447921, 8.277688037301584],
            [-18.435815127255246, 8.279838469948075],
            [-18.442116505810358, 8.27930369736202],
            [-18.442602162981558, 8.281938105906363],
            [-18.44733811062866, 8.285301372294091],
            [-18.452354451812244, 8.286791184292014],
            [-18.455523997739512, 8.289491132853362],
            [-18.463506641010188, 8.262495506754266],
            [-18.48982945357822, 8.270221082888566],
            [-18.507395229851994, 8.214903090875975],
            [-18.557817548907668, 8.2293170554228],
            [-18.598371852629008, 8.240536132185142],
            [-18.621411075388103, 8.247099223001298],
            [-18.685689302637936, 8.265807242194779],
            [-18.683548855329605, 8.270000584407057],
            [-18.677243863552444, 8.275293514784996],
            [-18.6773920413734, 8.277904715149171],
            [-18.66783729930955, 8.288094633207256],
            [-18.66859168702778, 8.293193079034339],
            [-18.674470910686235, 8.299011680298905],
            [-18.6754211056193, 8.31019150234689],
            [-18.67874298927543, 8.314045185102412],
            [-18.680186803372298, 8.318276551380368],
            [-18.675440521321057, 8.32432901526914],
            [-18.672778767809074, 8.330893529481006],
            [-18.67098438459441, 8.341748560819223],
            [-18.672273670045353, 8.34845325851736],
            [-18.678516670638338, 8.35426478414014],
            [-18.678939774967155, 8.359234177003009],
            [-18.67524032634053, 8.36190199834591],
            [-18.67586774356834, 8.369803063573523],
            [-18.674852600654745, 8.373251938616463],
            [-18.676859217294183, 8.375489923076305],
            [-18.686219861356456, 8.378886775082751],
            [-18.68910636800215, 8.381368067583889],
            [-18.689048929514406, 8.384369640613544],
            [-18.68560034925794, 8.394976561177964],
            [-18.686647761562163, 8.399913318224622],
            [-18.689043502494094, 8.40251031551306],
            [-18.697900784083956, 8.402746949093004],
            [-18.703002675075787, 8.406287659239673],
            [-18.702587547699974, 8.408903502097818],
            [-18.698268323826504, 8.411945865720298],
            [-18.691913397652982, 8.412244684097598],
            [-18.68802825166308, 8.416011714976072],
            [-18.6889321785817, 8.429071658176671],
            [-18.684345007175004, 8.430700795928775],
            [-18.677573015499345, 8.428813535050146],
            [-18.676841014107033, 8.43503159198792],
            [-18.67892923631557, 8.439955365167876],
            [-18.684053099371763, 8.443235495712235],
            [-18.68675128001671, 8.446956839609614],
            [-18.68877323180547, 8.453681771061753],
            [-18.688002893502357, 8.456892466214276],
            [-18.67945735610675, 8.456413715430672],
            [-18.670778610589046, 8.461498422758554],
            [-18.670084861250924, 8.463419100424478],
            [-18.669735683438574, 8.475111791964796],
            [-18.668545949003295, 8.483202988517524],
            [-18.666209587327316, 8.484779263646264],
            [-18.661342849510156, 8.482539632214396],
            [-18.66052406593577, 8.485376899422256],
            [-18.66321678682258, 8.4970414539982],
            [-18.6601045499791, 8.500441638828917],
            [-18.651812051019878, 8.498487565626718],
            [-18.647472041146713, 8.499810434357162],
            [-18.644212409757035, 8.505026664248293],
            [-18.646276263108106, 8.513102123182303],
            [-18.644656970807805, 8.519736096475413],
            [-18.644642278044568, 8.531442832560879],
            [-18.641446471215293, 8.536021325335701],
            [-18.639984956552446, 8.541637980442099],
            [-18.64314318386996, 8.54783077276704],
            [-18.637785358418064, 8.550276524752821],
            [-18.636418164308665, 8.555625685868366],
            [-18.63230162950643, 8.561692384692108],
            [-18.631682007779755, 8.565397672583686],
            [-18.63388536548165, 8.57145631341698],
            [-18.638330406122087, 8.57591922820945],
            [-18.639280222833694, 8.585844684820932],
            [-18.64253253769802, 8.592316662899218],
            [-18.65126544086867, 8.592772419966389],
            [-18.652719786677967, 8.596217072253046],
            [-18.647023581758578, 8.60292578384863],
            [-18.640341300447083, 8.608837624775699],
            [-18.639807043288503, 8.611522440519927],
            [-18.64249137283932, 8.61567224756772],
            [-18.64988877442861, 8.622545883120813],
            [-18.648765060342352, 8.62656106644554],
            [-18.641281411439167, 8.636907968077356],
            [-18.638270089650465, 8.639283590852],
            [-18.623642882810966, 8.642118859039233],
            [-18.615394326201585, 8.642920171112866],
            [-18.60442962514924, 8.64120681071197],
            [-18.594707944730075, 8.638157588637721],
            [-18.589806319597727, 8.638265101243524],
            [-18.58669088535062, 8.643328505520849],
            [-18.58870035532128, 8.646501194459994],
            [-18.594833930522878, 8.650327049428013],
            [-18.595139042347434, 8.653369908078357],
            [-18.591502105780233, 8.656994066659953],
            [-18.5858554997601, 8.657703758655428],
            [-18.581413591796178, 8.660343216231706],
            [-18.580352617838887, 8.665251403776933],
            [-18.57687108797823, 8.66817830476106],
            [-18.57090490309226, 8.66759070470505],
            [-18.568576976725375, 8.670560786073628],
            [-18.569144893053533, 8.674079996023755],
            [-18.566656279958373, 8.680022772860493],
            [-18.561339346584262, 8.68184652905446],
            [-18.556394308070285, 8.68016449279749],
            [-18.540199265289715, 8.676276095851373],
            [-18.529789509906788, 8.676188916617091],
            [-18.520960045315967, 8.671826473074306],
            [-18.51325673775182, 8.67161472703824],
            [-18.500040639432648, 8.673442492739106],
            [-18.49578373694671, 8.676246556763907],
            [-18.493942010840886, 8.683832437701275],
            [-18.498842326770873, 8.692408948455272],
            [-18.499149976481043, 8.701735643731784],
            [-18.501527038911842, 8.70412111932836],
            [-18.5149185791037, 8.706906306758517],
            [-18.517825811364187, 8.709958224567318],
            [-18.517962108275633, 8.715279938849287],
            [-18.516768038734988, 8.72450269085731],
            [-18.518793367069335, 8.729901231683709],
            [-18.52412854701095, 8.73781143309426],
            [-18.52790822805137, 8.748434446799354],
            [-18.52748916460093, 8.757414544678074]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.53432258458271,
          "lat": 44.48868490504085
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41043"],
        "coty_name": ["Linn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Linn County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01135857"
      },
      "bbox": [
        -18.703002675075787, 8.05572776664041, -17.617203276073536,
        8.787750453947996
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.056550515569413, -4.555021996996596],
            [13.113402494326884, -4.503715567703294],
            [13.147652930398344, -4.472631333293822],
            [13.151673711077946, -4.469208051480967],
            [13.186727205818048, -4.437354894136653],
            [13.26738689462544, -4.364522207153803],
            [13.271568268993752, -4.367833331785174],
            [13.276658500907246, -4.376560888143336],
            [13.27773954656548, -4.381850501423994],
            [13.278311541470885, -4.3927657484087765],
            [13.28065885853683, -4.399940836870956],
            [13.29121045575045, -4.416015397685945],
            [13.30146465729488, -4.420803461770625],
            [13.311012647653559, -4.422290566448597],
            [13.318165035869178, -4.42077926029108],
            [13.321675011659945, -4.421682739281504],
            [13.32967998029244, -4.4276240025639835],
            [13.334156845085007, -4.4293087161612394],
            [13.341969307066167, -4.430320347580339],
            [13.347704136276908, -4.428875318166338],
            [13.362238137741034, -4.422293753289403],
            [13.367781420189196, -4.419040366066769],
            [13.37143420179445, -4.41881531843926],
            [13.376262243500232, -4.420614737653989],
            [13.38433022713669, -4.420362158815997],
            [13.395487124668904, -4.421804223320778],
            [13.398751532674524, -4.423218203329292],
            [13.404947023104185, -4.42824775145026],
            [13.407910006239723, -4.428416161057107],
            [13.40949503687298, -4.431892509162497],
            [13.40883765418078, -4.435381230453282],
            [13.41130053729404, -4.440914690834101],
            [13.420244432456865, -4.447308788012301],
            [13.423276730425265, -4.452260131310239],
            [13.423238377724267, -4.460004509157181],
            [13.430666955412994, -4.476018316303244],
            [13.43567950694874, -4.475094163465694],
            [13.443716174134693, -4.479212087849225],
            [13.450043848536524, -4.480935546791937],
            [13.450695207349147, -4.483461218233858],
            [13.460670560629515, -4.487909688066597],
            [13.46177225509266, -4.491618849715728],
            [13.458464971678952, -4.496013959400234],
            [13.458138912489614, -4.500659188448512],
            [13.455354458736496, -4.505573386810524],
            [13.453581620794939, -4.512976406289842],
            [13.448322828389164, -4.515178056095726],
            [13.44608375821802, -4.519245239136406],
            [13.435212658072016, -4.529138174716189],
            [13.51387575558625, -4.572782530534183],
            [13.594966824516632, -4.617616911891839],
            [13.609080825814898, -4.6261265972958965],
            [13.60661268980919, -4.629397917471632],
            [13.600751272334012, -4.631579144324426],
            [13.598049712441174, -4.636910243114284],
            [13.593199035305922, -4.635048145126347],
            [13.58884431630549, -4.641302628123584],
            [13.594945251986807, -4.6460474761398585],
            [13.594566349602275, -4.641501473912975],
            [13.596517086597231, -4.637326818000093],
            [13.59996716560027, -4.638944479524241],
            [13.597198290685963, -4.647380675613578],
            [13.617971938255529, -4.662489287273358],
            [13.619599828025676, -4.660857253313644],
            [13.624131232067752, -4.646704092942689],
            [13.646925401267909, -4.656497932292821],
            [13.635217728741418, -4.661685445880153],
            [13.631485923676445, -4.66568718881636],
            [13.623960921391848, -4.664129470680167],
            [13.62297988955932, -4.666548025252119],
            [13.627966699471834, -4.66985840507491],
            [13.681804199565496, -4.708912148419832],
            [13.67402620228008, -4.752146058368201],
            [13.67188280209677, -4.74816359601288],
            [13.666483969406334, -4.746860250722806],
            [13.661062714596044, -4.74948147332621],
            [13.65496077795905, -4.748577277559011],
            [13.65595889126289, -4.744283997558711],
            [13.65471216599001, -4.7409679869319366],
            [13.650864230130194, -4.740987286963887],
            [13.65071523888302, -4.753347009054925],
            [13.64163155083656, -4.760871913886937],
            [13.64183555397117, -4.7567866552107505],
            [13.635135389763326, -4.7580709131836585],
            [13.632584842806905, -4.767352046678987],
            [13.622982417839802, -4.773275279751979],
            [13.630556887187598, -4.781728401370043],
            [13.626836466563176, -4.7916549928250625],
            [13.625253972101348, -4.79329986541618],
            [13.617451014641366, -4.786016326297486],
            [13.612254734171557, -4.78273752341343],
            [13.605928429044472, -4.790169057452409],
            [13.606402593400288, -4.79904118886918],
            [13.609829891065012, -4.803476483044081],
            [13.617034428609697, -4.803605124353173],
            [13.628995092088784, -4.806394685808372],
            [13.633857556725651, -4.814665221130957],
            [13.635354564054273, -4.819879565969156],
            [13.638529929954375, -4.8208425583275085],
            [13.643048679483016, -4.827270046504352],
            [13.636076447587007, -4.828418917460841],
            [13.534090952551477, -4.81961307501972],
            [13.513672428851836, -4.815095872838552],
            [13.50351616112646, -4.816715296971984],
            [13.42873424539298, -4.8219293878863905],
            [13.429424461973287, -4.81580247003481],
            [13.42644938222957, -4.81484632961552],
            [13.425309855294229, -4.811202126530875],
            [13.428043040046473, -4.807125083077831],
            [13.427592580756391, -4.802552035833258],
            [13.430928964877547, -4.799149567367891],
            [13.430949728715076, -4.794379688536866],
            [13.436017257634473, -4.794257252248922],
            [13.437355286027282, -4.7924700657910995],
            [13.429795441523538, -4.785560594170051],
            [13.425131430845775, -4.779598392236088],
            [13.420788477960695, -4.776541523483228],
            [13.41917972895051, -4.772479379966061],
            [13.416017068628303, -4.771488883858362],
            [13.415969532429282, -4.767120273904924],
            [13.418743204846757, -4.763776072323005],
            [13.41993608452825, -4.753898975337006],
            [13.417010463205598, -4.747879810124421],
            [13.417569973293633, -4.744999371103666],
            [13.409139847252122, -4.7345539553721006],
            [13.410846579598495, -4.731496381028031],
            [13.408054373123168, -4.7296222399224375],
            [13.402783051786978, -4.723364207139952],
            [13.400276435407408, -4.721960105182853],
            [13.396471514383137, -4.716740616071746],
            [13.395279108145159, -4.70871672218378],
            [13.398761313700543, -4.70437019982821],
            [13.399012025663923, -4.699788961505243],
            [13.401943674237183, -4.698210540295616],
            [13.39876034936395, -4.689674957945715],
            [13.400732807776857, -4.686642379112378],
            [13.3993593411498, -4.678332516823199],
            [13.398108474166717, -4.663865701104267],
            [13.407543552358097, -4.655115119922127],
            [13.41117405277159, -4.647645422767831],
            [13.407966055732153, -4.637854337041934],
            [13.397307803018904, -4.62966430340386],
            [13.389022726534126, -4.6373190574107435],
            [13.379565756506576, -4.630420320235699],
            [13.377759559713825, -4.634212533990226],
            [13.372022391754461, -4.6352036527995155],
            [13.364277797434397, -4.634615521272464],
            [13.354148300085736, -4.629201429647036],
            [13.351243678084845, -4.630937917530149],
            [13.345784930816677, -4.628482624006503],
            [13.34035998245021, -4.629004347546968],
            [13.334530042263772, -4.628194322917825],
            [13.333453605141463, -4.631678315223603],
            [13.326877100690108, -4.6324583658203045],
            [13.322347591198508, -4.631038475041807],
            [13.31902971379182, -4.635543645342778],
            [13.307027522162171, -4.639956691181053],
            [13.302607249074912, -4.639468292156821],
            [13.297455029920988, -4.636674030363669],
            [13.292924602119689, -4.63828506865589],
            [13.29105932490481, -4.633372473483201],
            [13.286651884502513, -4.630698603197606],
            [13.282557534436666, -4.634125460058804],
            [13.274612374710992, -4.636634552524791],
            [13.27759802121916, -4.639711296436227],
            [13.273472894541383, -4.6443663634332975],
            [13.270495672805623, -4.641196646331789],
            [13.261399048340994, -4.645221929200958],
            [13.256256904601676, -4.646061500441018],
            [13.25048391886392, -4.6492154286701],
            [13.247312433850984, -4.648499885338499],
            [13.23970307571237, -4.65039530600829],
            [13.236461219506225, -4.64882788359133],
            [13.224853555422621, -4.647766205360234],
            [13.219091740553685, -4.646238462022386],
            [13.211657348500683, -4.645706089685952],
            [13.208020307210553, -4.643666259151515],
            [13.203032020997746, -4.636162364310116],
            [13.19299494997183, -4.631198294971177],
            [13.189645527982112, -4.630368242635607],
            [13.187003916032527, -4.626416651076126],
            [13.18324727961856, -4.623650203815603],
            [13.179482695650425, -4.625190297346997],
            [13.176332643566314, -4.623326238603254],
            [13.17727912316038, -4.620121453461846],
            [13.17248429987192, -4.619013052486972],
            [13.16741633682922, -4.615666895091843],
            [13.16412366253572, -4.611658584257854],
            [13.163688793656023, -4.607443955444437],
            [13.159044935668362, -4.604726810572685],
            [13.155231985375796, -4.596402391281204],
            [13.145960527207396, -4.594161984030296],
            [13.143822713992972, -4.590199588511498],
            [13.144510894981778, -4.584849454239525],
            [13.141640877587955, -4.582030097904948],
            [13.134077045725183, -4.579553659901672],
            [13.130595489168206, -4.574527619045589],
            [13.13272632767842, -4.571550198820409],
            [13.12371626357885, -4.5686543676827105],
            [13.101640223615243, -4.5583960647418085],
            [13.09680362950619, -4.561392677291389],
            [13.093066932376683, -4.557898485445967],
            [13.087837267496512, -4.556694074286666],
            [13.079836602432644, -4.558584815607291],
            [13.073058572606488, -4.561793163842648],
            [13.066410354885791, -4.55757567872799],
            [13.060370487316579, -4.560245301887931],
            [13.056550515569413, -4.555021996996596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.40676017141183, "lat": 33.07931633421302 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45035"],
        "coty_name": ["Dorchester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dorchester County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01247998"
      },
      "bbox": [
        13.056550515569413, -4.828418917460841, 13.681804199565496,
        -4.364522207153803
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.910136602672882, -3.9469315389102957],
            [11.94038861633961, -3.933890650600841],
            [11.947858602470985, -3.930219387939466],
            [12.000210896702088, -3.909500386500744],
            [12.030918889387195, -3.906449601150028],
            [12.063096441088767, -3.9864354811004654],
            [12.066192448775066, -3.988133337134385],
            [12.071052987346347, -3.9937724072189322],
            [12.076149041957724, -3.9969319869992526],
            [12.084904345954493, -4.000698135912574],
            [12.09425185733363, -4.007672333538444],
            [12.099943546079613, -4.008396892847319],
            [12.104076430135278, -4.005400552866072],
            [12.113252404547548, -4.007961528130261],
            [12.118863479929706, -4.011894990428036],
            [12.146380307908572, -4.020689728984323],
            [12.252934197152292, -4.036589551649006],
            [12.208468390935652, -4.094119249335108],
            [12.136322502452524, -4.187219615450628],
            [12.085329354558397, -4.2528286064990075],
            [12.051017052136519, -4.296771734612478],
            [12.00043370401079, -4.361258120581007],
            [11.993971382968006, -4.359240932156336],
            [11.99059578987306, -4.3567958601015455],
            [11.990182786012396, -4.354015672690083],
            [11.985633278139067, -4.350424178968101],
            [11.981491620115339, -4.349492654114744],
            [11.976718697124454, -4.3418652215306],
            [11.96803323338061, -4.3338399857200764],
            [11.958275081122833, -4.33228985231782],
            [11.947749872104662, -4.325102083003439],
            [11.944110002931545, -4.323477739280707],
            [11.931881736078097, -4.3221256324516615],
            [11.926135042877299, -4.320810226278853],
            [11.921767668208814, -4.317781418037645],
            [11.914330923737309, -4.309454737325057],
            [11.906760342793703, -4.309592630003332],
            [11.917484109900869, -4.270181110322633],
            [11.914459213210423, -4.267556616629906],
            [11.912539720323315, -4.263046862228653],
            [11.90488503765509, -4.2578249069419085],
            [11.902116476132168, -4.25068221239808],
            [11.892334565928662, -4.252257498567794],
            [11.889159737153003, -4.2499139933033225],
            [11.884109010383437, -4.24903817344883],
            [11.885722578953635, -4.244876914932198],
            [11.882912243008136, -4.242991410646286],
            [11.879762531997827, -4.235071359025674],
            [11.87328767127328, -4.235989379363836],
            [11.868156521541541, -4.234149834221082],
            [11.869095909834064, -4.224256042270692],
            [11.861736526108285, -4.220670271850451],
            [11.853302495205831, -4.223472434934472],
            [11.851799258822606, -4.222714567139105],
            [11.843950645588293, -4.210294299129512],
            [11.835523991549309, -4.194929074030723],
            [11.832918528024813, -4.191336833225835],
            [11.832666437017014, -4.184537807205741],
            [11.841297808520483, -4.178917160887557],
            [11.842591959729099, -4.172562959887025],
            [11.84532535958739, -4.169588432303442],
            [11.841325499664421, -4.164251703331919],
            [11.84260205468647, -4.159921392327808],
            [11.840668071246107, -4.156497020779009],
            [11.835951874443559, -4.152592801125826],
            [11.835164652501813, -4.148642258131358],
            [11.839359092226585, -4.141420941698211],
            [11.841673823351131, -4.140389967939627],
            [11.843509942323788, -4.134964069687945],
            [11.843210581992269, -4.131147147319505],
            [11.846628787871019, -4.130386100699845],
            [11.844894580832886, -4.124457712404582],
            [11.849399932271153, -4.117802970864377],
            [11.854318446235677, -4.115908903916708],
            [11.857554347185793, -4.108705065586249],
            [11.854849585446582, -4.104984312635624],
            [11.860138933875325, -4.09956927760095],
            [11.854483626241107, -4.093128522515659],
            [11.85538942814727, -4.09108857024099],
            [11.862119253203762, -4.090524739281462],
            [11.866181773805227, -4.080812935135573],
            [11.87206516875586, -4.079804525137886],
            [11.873854643650532, -4.077555297881848],
            [11.86321021957149, -4.066817557091516],
            [11.835555063239696, -4.034286022369279],
            [11.832975103363351, -4.030942120679965],
            [11.826908080523449, -4.015237170250411],
            [11.834999497677098, -4.009175265548722],
            [11.825215299817938, -3.984089418311289],
            [11.910136602672882, -3.9469315389102957]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.96642511887933,
          "lat": 33.772217930698424
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45037"],
        "coty_name": ["Edgefield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edgefield County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01247999"
      },
      "bbox": [
        11.825215299817938, -4.361258120581007, 12.252934197152292,
        -3.906449601150028
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.228129269796959, -3.2623346805009517],
            [14.233157552299042, -3.2600251559847555],
            [14.239480777631803, -3.2478139761352005],
            [14.240499477144725, -3.240209076635581],
            [14.242479511664298, -3.2373011236227702],
            [14.246736620392639, -3.2364423466676406],
            [14.251000560520955, -3.231157169037141],
            [14.25347127714269, -3.2182319190752997],
            [14.25686053677388, -3.215492496490313],
            [14.261393255570512, -3.216409279591954],
            [14.26231977165398, -3.2118646076593307],
            [14.26591277436081, -3.2088729176327306],
            [14.265923571926416, -3.208880675624153],
            [14.338171724861073, -3.2606397951284247],
            [14.40914318970246, -3.3113504414339348],
            [14.454185781983266, -3.3434657031410446],
            [14.555437239370146, -3.4161613667866058],
            [14.610605111890871, -3.4556559946507774],
            [14.61960162988239, -3.4616365700032286],
            [14.658519756935371, -3.4900128609966816],
            [14.670231636862276, -3.498267431330278],
            [14.703391568171813, -3.5216188308018186],
            [14.769818767471937, -3.569706734684254],
            [14.765285607166726, -3.574381710015515],
            [14.76523433715746, -3.578036834272598],
            [14.759348782929242, -3.5794696392723626],
            [14.746570475086305, -3.5838607556883315],
            [14.73623499724966, -3.589269352801123],
            [14.704118999677858, -3.6094123901618564],
            [14.678829201807416, -3.6243970245358024],
            [14.656770348239867, -3.6401364425509084],
            [14.628843738635403, -3.6640337183121754],
            [14.6092059439742, -3.683349028004108],
            [14.586784933793574, -3.7070647898025437],
            [14.568232323654998, -3.728712434369351],
            [14.553907413781019, -3.7475264149324254],
            [14.53866728291888, -3.768998984916149],
            [14.529936744098345, -3.7826517960449686],
            [14.526161074426593, -3.7905006811287856],
            [14.521839261480856, -3.7961703436992256],
            [14.507580240897065, -3.8169444146420886],
            [14.491650334939296, -3.841892950511976],
            [14.479780451167114, -3.8636305312627592],
            [14.462387283943754, -3.8974597614167275],
            [14.452185127882862, -3.9177876683055675],
            [14.429629121400044, -3.9224750964771906],
            [14.383436624316776, -3.9315935826497292],
            [14.382434219808266, -3.930099305730673],
            [14.371286223402523, -3.932035418614967],
            [14.368834211811413, -3.9235879283589212],
            [14.370902764669733, -3.916907378789948],
            [14.369009772976584, -3.9084053055356747],
            [14.369898954997112, -3.9043339322709265],
            [14.365889560453546, -3.896224370704874],
            [14.361689923581523, -3.8947854276457305],
            [14.360984365297119, -3.9050571835274277],
            [14.358258358779059, -3.9063072108505357],
            [14.34828066907016, -3.9027360214964566],
            [14.34937060841059, -3.899103714714594],
            [14.346580482426639, -3.8978709596489676],
            [14.346649499432166, -3.8935935304170672],
            [14.344283897852309, -3.885556243063851],
            [14.33915732964503, -3.8837247969671767],
            [14.339439497880171, -3.8804779664402065],
            [14.336460737146204, -3.878004646417723],
            [14.336024605572813, -3.87056188039034],
            [14.332384415381378, -3.868041415076714],
            [14.330463398994784, -3.864076973630584],
            [14.33148887664405, -3.8612422009989844],
            [14.337390334490237, -3.865976568665397],
            [14.339562482731248, -3.860324872453245],
            [14.332644023800361, -3.8578635069000877],
            [14.329083481972738, -3.8531295945178767],
            [14.326408179576601, -3.847339756184994],
            [14.323164710194625, -3.853249181270128],
            [14.314733462611812, -3.855160953269194],
            [14.312025516399837, -3.85117956230747],
            [14.311124467934848, -3.8362249454055495],
            [14.304085847791773, -3.8290151395591407],
            [14.300641730918189, -3.830200101381331],
            [14.296565175848038, -3.826002188403117],
            [14.289529764435207, -3.824895843594582],
            [14.285084401903884, -3.8224365435531618],
            [14.287253270566454, -3.818086244414692],
            [14.285491999609711, -3.815460282904987],
            [14.2802594540662, -3.8155812661054958],
            [14.275117906914067, -3.8136428143514127],
            [14.270217861492709, -3.808998442825231],
            [14.26931363393642, -3.803597613770572],
            [14.270679958899116, -3.7987250235318704],
            [14.266620548879358, -3.792596124060656],
            [14.26068887647902, -3.786917098650123],
            [14.252826944202596, -3.7807892692543694],
            [14.250611848198155, -3.7813216415217985],
            [14.243327091869505, -3.773409681625947],
            [14.243658108547573, -3.768902361137434],
            [14.23449846380835, -3.767523821604559],
            [14.233122713708838, -3.7636673609407865],
            [14.228001143148068, -3.7621975192254684],
            [14.228245850694348, -3.758466240531812],
            [14.224108145598919, -3.7516182679032037],
            [14.219975043755191, -3.750101889509011],
            [14.214209754607872, -3.7442105249863906],
            [14.207881511401865, -3.7312238079902977],
            [14.208640895769918, -3.7266985007546523],
            [14.205008368396747, -3.726367802286746],
            [14.206229387301697, -3.7213071235622595],
            [14.202773470105354, -3.7176113078184243],
            [14.198935775993682, -3.715845533569656],
            [14.19773966997061, -3.711975843707276],
            [14.199054896451605, -3.704729652851909],
            [14.202969485540503, -3.703985205497399],
            [14.205525272822655, -3.6994569161222737],
            [14.202404744473554, -3.698148977971868],
            [14.201304720032267, -3.6935657124701504],
            [14.194217631596114, -3.6925363823601534],
            [14.190974961050992, -3.6890043661572918],
            [14.192707336875554, -3.6868802111883],
            [14.193577221865517, -3.68099117087843],
            [14.19117683004845, -3.674250227363821],
            [14.192679991108237, -3.666853619693307],
            [14.191598289867338, -3.6572129707814773],
            [14.189123192530237, -3.6547218545385625],
            [14.183425085730626, -3.645622044419213],
            [14.182546988906008, -3.639504745047085],
            [14.177394850389456, -3.638728363683475],
            [14.174765336378904, -3.636614527094484],
            [14.165295082532493, -3.6341334252090647],
            [14.16547057524162, -3.6388640563431465],
            [14.163581060406818, -3.6400344646830565],
            [14.158869114431942, -3.6356068198782916],
            [14.154816559675872, -3.636019817725226],
            [14.154966648528935, -3.6322598442330936],
            [14.151179792437395, -3.630153357612317],
            [14.146330740639545, -3.6239643510166797],
            [14.138465588867806, -3.6210111671879246],
            [14.138465397696622, -3.612511956978953],
            [14.137447216872369, -3.60924062384976],
            [14.139063641542554, -3.6050329709105786],
            [14.133805991812462, -3.6057045280687556],
            [14.132699820387998, -3.598469055504936],
            [14.13449107283493, -3.595203658786606],
            [14.12440337795464, -3.5921149375812806],
            [14.12076642317684, -3.589160664395334],
            [14.115296852255799, -3.5898931657441646],
            [14.116364420410896, -3.583770133637216],
            [14.10830465390304, -3.574889081357711],
            [14.109195430800112, -3.5687124545969255],
            [14.112413777296716, -3.56356712305892],
            [14.109969756774731, -3.551411120976038],
            [14.108660747005585, -3.547888351355497],
            [14.112270564767847, -3.543989856760091],
            [14.122268029644237, -3.5397407727071837],
            [14.125772610092268, -3.5345128672039587],
            [14.127058474515934, -3.522613761165447],
            [14.126622557820996, -3.516281651330577],
            [14.123237206335599, -3.5136536624190366],
            [14.12723089851828, -3.5096827151846908],
            [14.126507076123097, -3.506711923551055],
            [14.131073309964401, -3.5047321436199512],
            [14.132684903176344, -3.502038890891168],
            [14.1380086969883, -3.50381001365117],
            [14.141088470281119, -3.4980010887952804],
            [14.144883557524732, -3.4959487391744895],
            [14.147256119587434, -3.4909431206939083],
            [14.151283605201783, -3.4902067193002138],
            [14.15953747360075, -3.4819617278769672],
            [14.15843617798014, -3.4787412414577332],
            [14.166313914910724, -3.4742498454376998],
            [14.164244393450742, -3.465052353945919],
            [14.168274543962351, -3.4627890199107796],
            [14.168878968417598, -3.4519173513819172],
            [14.164577457404809, -3.4531757926943367],
            [14.160056709365154, -3.446775789037486],
            [14.161696522175967, -3.444400054319239],
            [14.158510284631717, -3.4416266372257147],
            [14.163018172787126, -3.4379174469027634],
            [14.162922999794825, -3.4335349307500866],
            [14.165561327229893, -3.4300454972916734],
            [14.169272717933756, -3.4290797239595867],
            [14.17145545687893, -3.4204764725150634],
            [14.179084106608153, -3.420215714699925],
            [14.179769818191856, -3.4153198355654855],
            [14.176597450297594, -3.415183830738227],
            [14.17675163185257, -3.4060297171346146],
            [14.179169298412171, -3.3992709979699005],
            [14.185139055344766, -3.3983248528316485],
            [14.18685681703539, -3.3930514751910352],
            [14.184918299936419, -3.3845323035531565],
            [14.181682223583506, -3.375959132635231],
            [14.183931094378371, -3.3753007747766035],
            [14.189820664600555, -3.3637882030217625],
            [14.187588297708762, -3.3565810309401303],
            [14.190867296390593, -3.353210269432996],
            [14.190555175008122, -3.348000737336313],
            [14.194092718841707, -3.345941794342833],
            [14.196107582733696, -3.3423056477234985],
            [14.198919429710859, -3.341453136741909],
            [14.200981353504785, -3.3375743237085183],
            [14.20595985215507, -3.3398084849539935],
            [14.208925845868135, -3.3231668111939037],
            [14.211489931079257, -3.3217038194876873],
            [14.214544177269063, -3.3169457187811515],
            [14.215576311837745, -3.3120573742559856],
            [14.21897670779394, -3.3118008303069826],
            [14.224796692642048, -3.30837387597322],
            [14.225825208012605, -3.3015436966551026],
            [14.228929316801883, -3.2988598539573326],
            [14.227283238003288, -3.2840075665986075],
            [14.232126420931227, -3.285037500025783],
            [14.23109931221458, -3.2803096383280117],
            [14.2269594392784, -3.276438696040066],
            [14.23022136005026, -3.2674526048277523],
            [14.228129269796959, -3.2623346805009517]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.99691186709964,
          "lat": 33.921650830928634
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45051"],
        "coty_name": ["Horry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Horry County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01248005"
      },
      "bbox": [
        14.10830465390304, -3.932035418614967, 14.769818767471937,
        -3.2088729176327306
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.27663744734959, -2.658092309235345],
            [12.307748396903332, -2.65477626988769],
            [12.377416636900804, -2.6473046190503027],
            [12.484356553430127, -2.636591134021101],
            [12.537601663920334, -2.6324936756973405],
            [12.538305548570372, -2.6330238205411205],
            [12.535207701359571, -2.6391310620248114],
            [12.534162924367719, -2.6500147302933357],
            [12.535136601965648, -2.652093643482451],
            [12.545058235712842, -2.6553659815969897],
            [12.551819115368447, -2.667099165399],
            [12.552879835020924, -2.672743878110264],
            [12.550095766997819, -2.678804471550897],
            [12.543065842276699, -2.6818816110094836],
            [12.539302204599041, -2.686906287098344],
            [12.536772211202527, -2.697657984438779],
            [12.538180053201046, -2.7106338601864266],
            [12.540184110817714, -2.7212893033864485],
            [12.54743528390055, -2.7274719260014306],
            [12.555938745674784, -2.7368787596156823],
            [12.615351088264704, -2.6785312247532773],
            [12.631360046299788, -2.6609069327987585],
            [12.659302333141527, -2.68806150036512],
            [12.659470904532022, -2.694789260992338],
            [12.661545485238522, -2.7006446716536217],
            [12.665780100234935, -2.7015894202705653],
            [12.666900863885298, -2.706255606971557],
            [12.664307928930171, -2.7174990923863276],
            [12.666760365571655, -2.718131093502657],
            [12.671730066640633, -2.7240615845020453],
            [12.673256020452493, -2.7300319553533656],
            [12.67034666704402, -2.742698024726537],
            [12.666152381443386, -2.7477224016715964],
            [12.67144343104641, -2.75279851542474],
            [12.67373215323509, -2.7578640624429984],
            [12.682172349342153, -2.7642526289816596],
            [12.682207761580587, -2.7689328996500753],
            [12.684509388802134, -2.7716332311826624],
            [12.689388161249145, -2.7701387090336933],
            [12.687944596337875, -2.777114695774891],
            [12.691521315949695, -2.784643375906659],
            [12.69525177273014, -2.7900262322164884],
            [12.694554596833074, -2.7953083368899505],
            [12.698644431252724, -2.7979758308019878],
            [12.702707662292353, -2.794457777361489],
            [12.704551709454375, -2.7978104331868234],
            [12.70435527652304, -2.80299500333232],
            [12.70955954602158, -2.80826849425494],
            [12.70906953252983, -2.8120973249825254],
            [12.712065570136549, -2.8191305558668116],
            [12.710719268875193, -2.823261907508147],
            [12.712127057223395, -2.827061755865483],
            [12.716153974967863, -2.8327195221844246],
            [12.716911814933628, -2.836382763987894],
            [12.716560332890639, -2.845218546370732],
            [12.71444863882261, -2.850684362062827],
            [12.709429203274109, -2.8570118689531494],
            [12.709600769614228, -2.8620736349656606],
            [12.712271640535182, -2.874627161911238],
            [12.712985173279895, -2.8884998293486195],
            [12.714975177024499, -2.896470780730194],
            [12.717503448433318, -2.899327657864641],
            [12.725864565449681, -2.904400139298541],
            [12.7274803758644, -2.9093900792932152],
            [12.722819494340127, -2.9210739198361995],
            [12.716930833418271, -2.9267727059552993],
            [12.708478280977621, -2.9314238236993764],
            [12.705356540514781, -2.9360083110782207],
            [12.706524062148008, -2.9413270084524012],
            [12.645215174798565, -2.950756295646966],
            [12.598169381477991, -2.9583070848661723],
            [12.540007355415415, -2.968034762077179],
            [12.511269016218037, -2.9724947320185477],
            [12.448100506106146, -2.9816754976874082],
            [12.363479029913195, -2.9938592822775707],
            [12.32458157474623, -2.9999868659868487],
            [12.23975625367467, -3.013786326374234],
            [12.245498458547234, -3.006751024441106],
            [12.251731277336393, -3.0022550896858684],
            [12.254080027774895, -2.993475013062187],
            [12.25616762182953, -2.985941315191746],
            [12.254977359165848, -2.983854416334458],
            [12.247473294152996, -2.97991110982768],
            [12.24462421101275, -2.97353995674832],
            [12.24074765052598, -2.968654527094602],
            [12.237187377525608, -2.9595414326966134],
            [12.233391104224232, -2.943025704709366],
            [12.227682886315275, -2.9373127392204377],
            [12.228756067118622, -2.927346714201032],
            [12.2318306483109, -2.922476539812268],
            [12.22994320125258, -2.9159423303011827],
            [12.225699952486394, -2.91277870365232],
            [12.224610645414348, -2.90915533338381],
            [12.226242960727813, -2.9024749136027514],
            [12.225552469356472, -2.8988298845798868],
            [12.217051386483641, -2.897931912999363],
            [12.21166915631466, -2.8951485675240156],
            [12.209339526241344, -2.890819809215416],
            [12.211559860113145, -2.8814321872304247],
            [12.211533811877565, -2.871797467487958],
            [12.214913048179328, -2.8659642132393928],
            [12.21659832038809, -2.8517935973830437],
            [12.208856095234204, -2.8429382395671294],
            [12.207300065138755, -2.8367556241865226],
            [12.209755581135342, -2.830492252523244],
            [12.206617322041435, -2.825564880343268],
            [12.199821606414044, -2.8079558659398236],
            [12.200140719044215, -2.802467177199147],
            [12.203688411468681, -2.799819061739007],
            [12.210315381630211, -2.7919319272440077],
            [12.210703922439425, -2.787342447088183],
            [12.260998126332273, -2.78062683836667],
            [12.258418738646949, -2.7551363511857008],
            [12.25218973708674, -2.6904303014566047],
            [12.27663744734959, -2.658092309235345]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.18454027723037, "lat": 34.97478582920119 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45091"],
        "coty_name": ["York"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["York County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01248019"
      },
      "bbox": [
        12.199821606414044, -3.013786326374234, 12.7274803758644,
        -2.6324936756973405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.39833326060677227, 6.629599854872604],
            [-0.36252579849989264, 6.628781716183954],
            [-0.2445968828019809, 6.627028974294658],
            [-0.2340213536727923, 6.656747825545071],
            [-0.1422498565802628, 6.654999507626516],
            [-0.05614703538331248, 6.654525117968603],
            [0.024300978466657117, 6.654160932645008],
            [0.030357313702623304, 6.654273670134978],
            [0.13318460065195864, 6.653667166924964],
            [0.13576835709308105, 6.6442699208986085],
            [0.13907959212821652, 6.640996193030499],
            [0.14195146570420134, 6.634747180498729],
            [0.14252288462734436, 6.630810825834602],
            [0.14521977256869698, 6.62529498095343],
            [0.14516453269552276, 6.596282020811771],
            [0.14532400046492822, 6.536692942550115],
            [0.14489274361944562, 6.452248607748468],
            [0.14458310061277377, 6.370946263041997],
            [0.14437863134846396, 6.306406001010821],
            [0.09857424982958399, 6.306134868767806],
            [0.01258956593852213, 6.3064583495159034],
            [-0.011820369423757476, 6.307087633606972],
            [-0.07348270912567254, 6.306336574860316],
            [-0.08549854114155403, 6.307215556493136],
            [-0.1595546895593315, 6.307906097956241],
            [-0.1596324292281151, 6.336400180340022],
            [-0.1590693150760417, 6.394383655131072],
            [-0.1590729119445587, 6.480384300572451],
            [-0.24441536147966753, 6.481468700979285],
            [-0.2954716230817473, 6.482465136632386],
            [-0.29892831248245505, 6.482914935449629],
            [-0.3205656545895751, 6.483544207162678],
            [-0.40024203828137667, 6.484637940507645],
            [-0.39890097504638494, 6.571534245012804],
            [-0.39833326060677227, 6.629599854872604]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.76770563656663,
          "lat": 45.171916026603085
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46051"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01265782"
      },
      "bbox": [
        -0.40024203828137667, 6.306134868767806, 0.14532400046492822,
        6.656747825545071
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.8021592224002956, 5.974801194824724],
            [-3.8016611031276675, 5.97550617878819],
            [-3.7995156416459213, 5.9767420155259945],
            [-3.7971245372885214, 5.9835420505609545],
            [-3.7911621663894204, 5.987919048242157],
            [-3.7854557932381034, 5.985566345196409],
            [-3.7818520706743906, 5.989429535192741],
            [-3.7776922927584486, 5.987409092352779],
            [-3.7713948246471523, 5.990384121777588],
            [-3.762240396262438, 5.990017924398511],
            [-3.7593546166344436, 5.994839880658489],
            [-3.756206064438294, 5.9959854612676375],
            [-3.753793908813852, 5.9924570486756075],
            [-3.747215988255737, 5.990405096681186],
            [-3.7417085124964107, 5.993209009152479],
            [-3.736603531640832, 5.992323288147767],
            [-3.73237099292217, 5.994642481089562],
            [-3.7259117994152735, 5.995010322878217],
            [-3.720915800139009, 5.997244048824022],
            [-3.7157235576794547, 5.991564858093956],
            [-3.712186086044869, 5.9917385370853316],
            [-3.70721913578747, 5.9894541077310866],
            [-3.702616032476197, 5.988935466534558],
            [-3.6978923249002547, 5.983985612502242],
            [-3.691997383873059, 5.986418127150859],
            [-3.6870624524888638, 5.983371000231817],
            [-3.685741919689536, 5.979019876984684],
            [-3.68129198361476, 5.979897575503428],
            [-3.680128283254466, 5.985541162241797],
            [-3.6778295682308557, 5.9878769878018465],
            [-3.6698968716333042, 5.986957588420084],
            [-3.6690384231854645, 5.981242637508622],
            [-3.666658640450805, 5.977851286144414],
            [-3.662234049072373, 5.980697578604566],
            [-3.662675424458243, 5.986762613842568],
            [-3.657679429752246, 5.996428255488354],
            [-3.653168135885064, 5.9979621057528485],
            [-3.646695595280438, 5.9950295525013635],
            [-3.644175026679699, 5.99053298478063],
            [-3.6353248416215824, 5.996916277283915],
            [-3.632846939303175, 6.001391906059738],
            [-3.627465223200273, 6.001473529167247],
            [-3.620674509350647, 6.006845950573167],
            [-3.61653975606005, 6.008447678914383],
            [-3.616725059311341, 6.012097151738213],
            [-3.6201041130388147, 6.016165558174365],
            [-3.618322392965877, 6.020284704421527],
            [-3.609960292969813, 6.020543750750994],
            [-3.6055618763910044, 6.017814907733298],
            [-3.5960628859865773, 6.023831590272366],
            [-3.594954225517275, 6.030560846174125],
            [-3.5906995717806724, 6.030320233926641],
            [-3.5855071879042626, 6.025497165707192],
            [-3.5778623530770535, 6.025027015788693],
            [-3.577898428233293, 6.021310295109531],
            [-3.5720516940080937, 6.020779267782001],
            [-3.569131826532874, 6.024627952327492],
            [-3.5672381641718487, 6.029777932846233],
            [-3.563708547259878, 6.032743620640477],
            [-3.558978274071007, 6.0326754505550975],
            [-3.5562223416335974, 6.036742836314626],
            [-3.552362153911242, 6.03084124326994],
            [-3.545665427755367, 6.033325674718925],
            [-3.541994731025007, 6.02735598416488],
            [-3.53652878640059, 6.034447469852321],
            [-3.5334638232635567, 6.032836770612904],
            [-3.532174756874511, 6.027211842511705],
            [-3.534258388762132, 6.024584634203981],
            [-3.5329063959439964, 6.021290497703151],
            [-3.5256902880621364, 6.020671785402739],
            [-3.520865899411413, 6.018907193517629],
            [-3.5182675569165154, 6.023783341747958],
            [-3.5070085637122546, 6.019843733352767],
            [-3.5001820029295767, 6.023496402707383],
            [-3.4950253698666107, 6.023147178034037],
            [-3.4891379861011553, 6.020474075847246],
            [-3.4854430995703445, 6.01431437047665],
            [-3.4817670216001804, 6.015216757825709],
            [-3.481538280250015, 6.0188142073839455],
            [-3.4770223104410176, 6.0193204565572795],
            [-3.473721305645286, 6.016000248585797],
            [-3.46818501095837, 6.017200752991402],
            [-3.465106089659853, 6.011320578455201],
            [-3.459029381677084, 6.015793727240266],
            [-3.4525992295042984, 6.018703165614847],
            [-3.4528081073356884, 6.024072204389239],
            [-3.4506133916346604, 6.028027251907021],
            [-3.4477462235185508, 6.028385962447405],
            [-3.443130309711627, 6.023396004755031],
            [-3.4379017237001346, 6.025815757063014],
            [-3.437029735008799, 6.028973642954196],
            [-3.4398919140981445, 6.037143902132664],
            [-3.439896932800721, 6.040919209030368],
            [-3.433970254587632, 6.04447788792891],
            [-3.4295554128078423, 6.042512912951444],
            [-3.424565950025764, 6.042893429105548],
            [-3.423204730347713, 6.047826200084252],
            [-3.418619518368536, 6.052499243078727],
            [-3.4142237291512845, 6.052471198870446],
            [-3.411721691342617, 6.050193628236868],
            [-3.4088792297186665, 6.051822168407606],
            [-3.411519851307205, 6.055664926079088],
            [-3.4155190858517472, 6.056677415470688],
            [-3.416556503247263, 6.059843562957614],
            [-3.406863742267906, 6.071180709472772],
            [-3.4079110059629496, 6.076860635511687],
            [-3.4046807328743274, 6.0783900646486275],
            [-3.4006223305000254, 6.077869971000482],
            [-3.394518972173932, 6.082924383088957],
            [-3.3902342895704756, 6.0796429944831925],
            [-3.3764486069534865, 6.082211075478575],
            [-3.3738700389131653, 6.087712555003511],
            [-3.3697328682728975, 6.089249011222038],
            [-3.3659053837376467, 6.094163880255213],
            [-3.360214194639786, 6.094963224727087],
            [-3.3565392410554815, 6.090791357007061],
            [-3.3541079123497166, 6.09062633228126],
            [-3.350717663187812, 6.09546379025026],
            [-3.345025407811409, 6.092564390878899],
            [-3.341204609711902, 6.093995517768805],
            [-3.3419696535198975, 6.098209486798735],
            [-3.347942978073229, 6.106166586941222],
            [-3.3464588215501605, 6.110288798678127],
            [-3.3383416558813823, 6.10821978028036],
            [-3.3362818774644567, 6.110210998150339],
            [-3.338328558105292, 6.123829695135303],
            [-3.3347736857410797, 6.12512810544452],
            [-3.324809483732078, 6.118772691037111],
            [-3.3205672847658296, 6.119333847740195],
            [-3.3184832339907944, 6.124587386308933],
            [-3.3143007537983484, 6.125609282400729],
            [-3.312745418143225, 6.122887960947186],
            [-3.3122950930873585, 6.116018861933149],
            [-3.3084605782398184, 6.114869051592826],
            [-3.2979126681164748, 6.119114393192265],
            [-3.2942245970712674, 6.122710738764272],
            [-3.290719225721344, 6.122663971169596],
            [-3.2836381539108035, 6.118445659833839],
            [-3.2801524996538642, 6.117522362557279],
            [-3.274686785642315, 6.118703307139575],
            [-3.270023934931043, 6.1256219684257225],
            [-3.257134069849647, 6.130456538612811],
            [-3.251265303787158, 6.1296363253230215],
            [-3.249410825920262, 6.1275279011234725],
            [-3.2491971766486083, 6.121760447016046],
            [-3.244279156040969, 6.12306659714895],
            [-3.2257660939632697, 6.132669323532543],
            [-3.20639976927384, 6.143869413023173],
            [-3.195904220217296, 6.148918409425344],
            [-3.1885860069581957, 6.156502725742233],
            [-3.185073008331638, 6.1697845180030315],
            [-3.1812712614461707, 6.173433399372338],
            [-3.175676035793648, 6.174057995842557],
            [-3.176168710465398, 6.169244113648456],
            [-3.1790005527523073, 6.117203298556808],
            [-3.1912942607042343, 6.11785079269571],
            [-3.204714377961451, 5.880355174734504],
            [-3.210618566627483, 5.772589307287515],
            [-3.2188922834904603, 5.773002767182674],
            [-3.220812431501682, 5.73682290650848],
            [-3.2252787179191924, 5.65658942587817],
            [-3.225468797641076, 5.648638559946283],
            [-3.2283948714155595, 5.598552901013288],
            [-3.142820185998504, 5.594371331868021],
            [-3.1472387347763395, 5.507615429342998],
            [-3.1519686117739485, 5.4212972935431445],
            [-3.164340583879797, 5.421912016945966],
            [-3.287145273370565, 5.428774835451227],
            [-3.4099519812694017, 5.435602112534697],
            [-3.456419815218292, 5.438146502477198],
            [-3.4638557925765503, 5.437924057457473],
            [-3.4766186714338163, 5.4393055034043325],
            [-3.5060888788238964, 5.440870496627619],
            [-3.591481563930757, 5.445818051527907],
            [-3.676862680690073, 5.450901004719783],
            [-3.744949700082861, 5.455011209330417],
            [-3.81124925587373, 5.458883396689838],
            [-3.8313581696743286, 5.4605164052589705],
            [-3.8393276484611487, 5.4606936844021465],
            [-3.83395887470848, 5.547183327286371],
            [-3.8311908798680467, 5.589684630274192],
            [-3.8313461410596523, 5.590760061469345],
            [-3.8283178196790235, 5.63552575758466],
            [-3.817119376604097, 5.808701358302472],
            [-3.8126570772201056, 5.808467527301096],
            [-3.8071594084015183, 5.892860213265454],
            [-3.8021592224002956, 5.974801194824724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.53994410694644, "lat": 44.2944667897031 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46055"],
        "coty_name": ["Haakon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haakon County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01266988"
      },
      "bbox": [
        -3.8393276484611487, 5.4212972935431445, -3.142820185998504,
        6.174057995842557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.3472962035510943, 5.183559226879242],
            [-0.2610172480138157, 5.182831688659075],
            [-0.17459829422942214, 5.182145452915877],
            [-0.1314991226389208, 5.181607672062605],
            [-0.04225060763102379, 5.180838805312681],
            [-0.008658157739900835, 5.180824056714961],
            [0.009921775345360423, 5.180194589672547],
            [0.08152552652832606, 5.179377001098666],
            [0.10115672186985188, 5.179441337781293],
            [0.11278479813309852, 5.180197726889996],
            [0.13815704416418823, 5.181062575626108],
            [0.13807076679864128, 5.136686638283521],
            [0.13786649743800175, 5.122998731999682],
            [0.137307690818881, 5.021175811994435],
            [0.1367884096635679, 4.90660560185837],
            [0.13648753483494733, 4.8317847135304826],
            [0.03131650927215039, 4.832415886978624],
            [-0.028224132080212305, 4.832705351233934],
            [-0.1359933629915925, 4.8335225371080295],
            [-0.20398844371473177, 4.8338609481988835],
            [-0.24675723376312575, 4.834066679096108],
            [-0.3517324191517778, 4.83512766234593],
            [-0.3510284601238286, 4.893241138919407],
            [-0.35065720485463325, 4.910942274684645],
            [-0.3495450414141194, 5.002382206691143],
            [-0.3496153236681122, 5.010317570028578],
            [-0.34881138099075726, 5.081865871892271],
            [-0.3482860572060065, 5.096715770158175],
            [-0.3472962035510943, 5.183559226879242]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.79145479899394, "lat": 43.67414940942849 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46099"],
        "coty_name": ["Minnehaha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Minnehaha County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01265772"
      },
      "bbox": [
        -0.3517324191517778, 4.8317847135304826, 0.13815704416418823,
        5.183559226879242
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5803801281458596, 5.112128248561142],
            [-2.5769453806785285, 5.112651782023932],
            [-2.5753790958263414, 5.107004435980651],
            [-2.5762883087000907, 5.10427922397265],
            [-2.5765007898782817, 5.095438292502615],
            [-2.5749877790450153, 5.091475203225288],
            [-2.5658777706710856, 5.08112529489987],
            [-2.5596324245560673, 5.092307004781291],
            [-2.558182245404764, 5.098644354381228],
            [-2.555412399368478, 5.1024614179088035],
            [-2.546148586459754, 5.103291004558166],
            [-2.5370441034300004, 5.102311537313561],
            [-2.525710245518656, 5.097572561938906],
            [-2.5202035165153123, 5.091822960291381],
            [-2.5161644958608673, 5.089945307817492],
            [-2.514887041921031, 5.0922628633812],
            [-2.518315529481642, 5.09591916715462],
            [-2.5160196935459123, 5.099642204599113],
            [-2.5102003715053396, 5.098363496287739],
            [-2.503539606480753, 5.091339768164008],
            [-2.5013938088589094, 5.083077636466897],
            [-2.498438731953981, 5.080084346955531],
            [-2.495098789888655, 5.080352827500873],
            [-2.491291673121655, 5.08871368602155],
            [-2.481932324807901, 5.08253204927692],
            [-2.4783055233146123, 5.078970145074947],
            [-2.4755535172292196, 5.07951209312311],
            [-2.4728531337660478, 5.084724277046126],
            [-2.4654015174368777, 5.08551525994334],
            [-2.462914677071575, 5.084625194243988],
            [-2.455909875154966, 5.085806715428787],
            [-2.4513984656089365, 5.084855011915962],
            [-2.4483761129931714, 5.086962483082427],
            [-2.4487103559089034, 5.095607193845822],
            [-2.444159530218101, 5.096823904635139],
            [-2.43898673182919, 5.0937064356341235],
            [-2.4368362301670814, 5.089843948133736],
            [-2.4242265145225996, 5.09935616145844],
            [-2.4205589709656112, 5.098108630701666],
            [-2.4202428693509708, 5.093426817498541],
            [-2.422752447531958, 5.088037710472317],
            [-2.419472011932359, 5.083452403837814],
            [-2.4155226574497624, 5.084910605304786],
            [-2.4134775702584434, 5.0930287191987444],
            [-2.4081703532719043, 5.089064962582855],
            [-2.404660397416451, 5.084433775276602],
            [-2.402098625382976, 5.077688643316644],
            [-2.398308370545061, 5.079376776443487],
            [-2.3974334907782686, 5.082636325578249],
            [-2.3940871168032043, 5.083441058694333],
            [-2.3880824370009863, 5.078588721524584],
            [-2.3832028189176815, 5.082558223920085],
            [-2.3826636653782427, 5.087940322430688],
            [-2.368746122187476, 5.085060821190387],
            [-2.3662092750997035, 5.080686086636508],
            [-2.3654302366643174, 5.07553578768352],
            [-2.3618701494886665, 5.075659481715782],
            [-2.345331777258364, 5.088300460838949],
            [-2.3417342540630477, 5.088897173648481],
            [-2.3384738763452253, 5.086450302965909],
            [-2.337123868571643, 5.079226793866507],
            [-2.3334415271480973, 5.074756494319816],
            [-2.3332897400419217, 5.071099912003531],
            [-2.3362480202362588, 5.066017150109526],
            [-2.332778787589331, 5.064850486107843],
            [-2.3239156259011153, 5.058060067625746],
            [-2.320378556747328, 5.060232434917805],
            [-2.3166284383351985, 5.065952682472573],
            [-2.3179967817674436, 5.072065428914503],
            [-2.3239216773356706, 5.075663782461174],
            [-2.319417274922152, 5.078816945472425],
            [-2.3126412567011236, 5.078050964954937],
            [-2.309990557343857, 5.080502789882374],
            [-2.315699692329116, 5.086288148775743],
            [-2.3140119703751676, 5.088186068391765],
            [-2.30922915106009, 5.0873629489538725],
            [-2.3050465038497845, 5.082160329497965],
            [-2.3013306128140596, 5.075472936585836],
            [-2.298766107146705, 5.0753997199845955],
            [-2.2788862152696963, 5.084713143652652],
            [-2.2725992146778187, 5.085881804219789],
            [-2.2695924722087444, 5.0889575496708],
            [-2.269643069160429, 5.096831157860434],
            [-2.2591219963314986, 5.094466816194542],
            [-2.253640385642947, 5.095397782733674],
            [-2.250229705607285, 5.097779500460315],
            [-2.240365737825858, 5.092665081279805],
            [-2.2314251992800522, 5.094543769490793],
            [-2.232860901518411, 5.0991249340277784],
            [-2.23755303461724, 5.101898174390423],
            [-2.2392962555562033, 5.104922876372668],
            [-2.239725415978665, 5.110148096441454],
            [-2.243392950678381, 5.114013443296911],
            [-2.2436103818444773, 5.120875791321113],
            [-2.2397263322781464, 5.126513201155939],
            [-2.2336988713609607, 5.131479820782294],
            [-2.230312951481208, 5.132425756478781],
            [-2.2263175554923578, 5.1305623709582395],
            [-2.2239279609610607, 5.115395303772052],
            [-2.2270647308432574, 5.106815559926679],
            [-2.222025615998996, 5.102485925755545],
            [-2.218274434128068, 5.102581458324077],
            [-2.213266182205658, 5.10874631910924],
            [-2.2056975328725192, 5.115789652281413],
            [-2.2049910826027506, 5.124806782389209],
            [-2.201980405218682, 5.132498916792919],
            [-2.1974308301572325, 5.13587945579846],
            [-2.1939633591276886, 5.141570138121921],
            [-2.190976795889844, 5.142568438111433],
            [-2.1870942388677452, 5.140277412314361],
            [-2.1844286277976654, 5.135897694485497],
            [-2.183578966315395, 5.13120374124852],
            [-2.1852090919576685, 5.126832645221436],
            [-2.1896477155441056, 5.120644273116471],
            [-2.191186615848555, 5.115193565926157],
            [-2.186841846936666, 5.10975146907792],
            [-2.180405665654963, 5.109630264635012],
            [-2.175176402674225, 5.1114048606978715],
            [-2.17056031012966, 5.117419367003681],
            [-2.1704019620168644, 5.123947354650252],
            [-2.1718201090616716, 5.136759240764765],
            [-2.173301823374315, 5.1449231517631295],
            [-2.1691894038483674, 5.147724626715825],
            [-2.1648693012241402, 5.14693238529937],
            [-2.1564534512887645, 5.1396655029563245],
            [-2.1550748317503317, 5.1335366113202925],
            [-2.1557634168672366, 5.123389834823943],
            [-2.1571026167536043, 5.119331212852147],
            [-2.155725239425042, 5.116449980331128],
            [-2.1482073530819865, 5.117649739023817],
            [-2.1425904496514696, 5.122688924247059],
            [-2.1436731157755586, 5.097351972859883],
            [-2.1450967995595254, 5.053984550332312],
            [-2.1453628029141942, 5.053342908356392],
            [-2.1464905525864544, 5.017810612098103],
            [-2.148426728046329, 4.967052857793428],
            [-2.151870212586626, 4.8801633184235325],
            [-2.087589442450587, 4.877692244377395],
            [-2.0889923981052263, 4.828849137353306],
            [-2.0918033606326096, 4.752772058640615],
            [-2.0963170041223322, 4.633355156960833],
            [-2.0995924296149893, 4.546501462768509],
            [-2.102949980008307, 4.458334830786676],
            [-2.106026649696285, 4.375335521659958],
            [-2.1920637407152954, 4.378460757748323],
            [-2.257993169449715, 4.381010162873133],
            [-2.276433859571433, 4.3819508624530314],
            [-2.2995371122563273, 4.382715049220947],
            [-2.335669742755007, 4.384365479138848],
            [-2.385354862217553, 4.386276785708913],
            [-2.4164476300483124, 4.387841595845579],
            [-2.469624860505453, 4.3901634520227235],
            [-2.5368424134263843, 4.393329683465021],
            [-2.5888030523564733, 4.395430667108472],
            [-2.5888035534246074, 4.395430687556932],
            [-2.586671801549383, 4.442881186554006],
            [-2.583097288315813, 4.525730352562626],
            [-2.594219087427565, 4.526225349254389],
            [-2.588575995740496, 4.654269006287245],
            [-2.582711162335815, 4.788240735962333],
            [-2.5809506992415523, 4.82823537619687],
            [-2.5791108581226676, 4.875156463548348],
            [-2.591028952869688, 4.876334746090532],
            [-2.5894941862327134, 4.905215901918769],
            [-2.5887021427561008, 4.926923639047143],
            [-2.586932718399967, 4.962638542377466],
            [-2.5849907664409724, 5.006410506409567],
            [-2.584225751423281, 5.028181931778163],
            [-2.5803801281458596, 5.112128248561142]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.88393102408934,
          "lat": 43.345955403362844
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46123"],
        "coty_name": ["Tripp"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tripp County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01265784"
      },
      "bbox": [
        -2.594219087427565, 4.375335521659958, -2.087589442450587,
        5.147724626715825
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.822079566015177, -1.8580644710442475],
            [8.821745653187754, -1.8513294989641589],
            [8.82270682372789, -1.8332058596845309],
            [8.827212675490275, -1.8054823683271497],
            [8.835182036576699, -1.78875721329638],
            [8.843892748376913, -1.7756648866563793],
            [8.845612909050992, -1.7649855735940898],
            [8.850332316616065, -1.7585833043896297],
            [8.855967790868656, -1.7547751052192688],
            [8.867086324769888, -1.7521229575253494],
            [8.870000812870398, -1.7525142370636708],
            [8.89213846895776, -1.747298334468195],
            [8.88483304362685, -1.7551516938996345],
            [8.883915724691317, -1.7586801169545954],
            [8.887171623676918, -1.7612490701911216],
            [8.894099253178172, -1.7597402410589795],
            [8.901370898414367, -1.762204903591048],
            [8.90193382017127, -1.756346068086398],
            [8.894130775999479, -1.7459023779344074],
            [8.901173075856095, -1.7432081105986559],
            [8.908252462912793, -1.7367469088582346],
            [8.911335444822765, -1.7359072933001984],
            [8.91499301404584, -1.7295126356117656],
            [8.932782213418776, -1.71901253670277],
            [8.950182233026167, -1.7173020229323344],
            [8.96403236065661, -1.7210327588354926],
            [8.963157566221001, -1.7163018887922143],
            [8.96843037925279, -1.713670721922343],
            [8.968941826115296, -1.7110415908253869],
            [8.974341245267267, -1.7108196860940297],
            [8.978813750661269, -1.705274305830915],
            [8.985705263194639, -1.700421242387738],
            [8.995050933026862, -1.706530338909706],
            [8.9935718871874, -1.710295231398601],
            [9.002893736725326, -1.715889281375682],
            [9.011198491226958, -1.7175366254228577],
            [9.0249217224833, -1.721610246046972],
            [9.037409569928668, -1.7282750402958267],
            [9.057737368265565, -1.7429091048145],
            [9.082301897652908, -1.7640539910250645],
            [9.081493308794824, -1.7671223616296128],
            [9.088952581875533, -1.770101875612947],
            [9.091279072865476, -1.7738002472149021],
            [9.094432943358244, -1.7941502319494695],
            [9.10480549690278, -1.8102990545269342],
            [9.10708056993128, -1.8158055889928675],
            [9.107101593895344, -1.821926219278555],
            [9.112214574127107, -1.8227377750209846],
            [9.118690011106837, -1.8204197570634146],
            [9.11976446383684, -1.830332532996695],
            [9.12908801970385, -1.9233858357273654],
            [9.142291866225277, -1.9585445769663197],
            [9.173157030858325, -2.0284189389037928],
            [9.149633612920221, -2.083369907282559],
            [9.08152139015054, -2.0832769602102723],
            [9.043603902142992, -2.0691767680002284],
            [9.031904463478046, -2.064077961293494],
            [9.029087130219802, -2.059649340003749],
            [9.028940791376089, -2.054949378277949],
            [9.023267283488977, -2.05710488658688],
            [9.022632734190099, -2.0603867415804946],
            [9.001216350452536, -2.051955379549541],
            [8.97860215368511, -2.045797402549635],
            [8.98069634082087, -2.042568744940779],
            [8.976714719620805, -2.028786288775546],
            [8.945496306210432, -2.029536067667304],
            [8.945216310954834, -2.0238768330145955],
            [8.941769191727271, -2.024253690951217],
            [8.938422031049575, -2.027875599155011],
            [8.934405780459514, -2.023479049323462],
            [8.92884211809313, -2.0259340209170498],
            [8.910975324647682, -2.019360067427826],
            [8.90103348355324, -2.0186534150734476],
            [8.900418891329075, -2.0136620300009294],
            [8.897430198147992, -2.009856461304883],
            [8.889425692697031, -2.0103206299003515],
            [8.886744168202593, -2.0091510084724673],
            [8.885559644426621, -2.002604122910011],
            [8.888074032938068, -2.00069650153628],
            [8.885212363730513, -1.9940098147191223],
            [8.879691980998688, -1.9978684658018206],
            [8.874789001754293, -1.9980351952656703],
            [8.871615422798346, -1.996309871875965],
            [8.87112260835208, -1.9901526983472226],
            [8.869384143441788, -1.9859562105132735],
            [8.869291328191013, -1.9809572681315069],
            [8.861475898096863, -1.9817093960436418],
            [8.859120001741964, -1.9773814344880478],
            [8.868626821942229, -1.9768492307125132],
            [8.868578466334766, -1.9727974163940416],
            [8.866044211836702, -1.9691208396105964],
            [8.85963499489704, -1.9651455494226597],
            [8.862472701484458, -1.9601351093648023],
            [8.861777719591723, -1.956132879676494],
            [8.854749479026257, -1.9541476747613846],
            [8.852404667252912, -1.9573084196358168],
            [8.84262615856253, -1.9566651888788926],
            [8.84237790663462, -1.959909429772453],
            [8.837925742477289, -1.961497829217241],
            [8.836887605316727, -1.9576919429642847],
            [8.833538798823012, -1.959109951835853],
            [8.823969012913796, -1.8887775299160658],
            [8.823483457378195, -1.886355534539756],
            [8.822079566015177, -1.8580644710442475]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.28799469012371,
          "lat": 36.344997710579285
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47133"],
        "coty_name": ["Overton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Overton County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01639780"
      },
      "bbox": [
        8.821745653187754, -2.083369907282559, 9.173157030858325,
        -1.700421242387738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.900510351024555, -3.0691328265060793],
            [6.907094671078963, -3.07330486094063],
            [6.910783843963452, -3.0736911904732183],
            [6.925300207848, -3.069796657376069],
            [6.9328853538177775, -3.0666009242689016],
            [6.935927312618443, -3.0634434573257123],
            [6.939851331803839, -3.0560488487416877],
            [6.940365196684018, -3.0482799883322182],
            [6.9381075134023895, -3.043289131496768],
            [6.928212418525509, -3.0428780917382223],
            [6.92064277290584, -3.039266004662973],
            [6.911591231918199, -3.0367849606564614],
            [6.907368847677348, -3.0339008612536023],
            [6.907486538480048, -3.0275809814944687],
            [6.9124822417316585, -3.0229534831654914],
            [6.916197300250989, -3.016833949263006],
            [6.922742089419593, -3.0118344177213077],
            [6.923863308713966, -3.0055093886125435],
            [6.929235533701843, -3.0054341115815193],
            [6.930409857280247, -3.0005765891783067],
            [6.935744718634461, -2.9975211295877933],
            [6.941605490026344, -3.0002297915878673],
            [6.945740362217412, -2.9975117323583094],
            [6.950678945787894, -2.9964655249963585],
            [6.953389530260284, -2.9981287009525803],
            [6.968857316729623, -2.9891512670652545],
            [6.973916608889362, -2.994136110706557],
            [6.977549556647228, -2.9944853785998364],
            [6.978646700236406, -2.990222867851995],
            [6.986069666314018, -2.987498604114948],
            [6.990264333066735, -2.9906105640046188],
            [7.001556943494103, -2.9866588186322156],
            [7.007294147579934, -2.9805157785553407],
            [7.013505834900574, -2.9805366440911008],
            [7.022016432380455, -2.974224718220063],
            [7.025625443920584, -2.9761745709304974],
            [7.028042100550558, -2.9843901972302773],
            [7.036421285828475, -2.9838309643904983],
            [7.052668553987629, -2.9777569267224924],
            [7.05644559148034, -2.970822787030164],
            [7.062059609073778, -2.970266163029459],
            [7.064293357523157, -2.965125115424166],
            [7.068023271816172, -2.966747101442576],
            [7.070512855603741, -2.9609738800034635],
            [7.111109409354722, -2.953122148823801],
            [7.1166298047475784, -2.9500723495908834],
            [7.126026172764867, -2.9493467616001325],
            [7.139824324693674, -2.956583428645893],
            [7.155307922212998, -2.9586506234402927],
            [7.166280020997747, -2.964927259816189],
            [7.198379286790134, -2.962175844585921],
            [7.200622205887979, -2.9930039140817937],
            [7.204848603809699, -2.9937808724796486],
            [7.211871176601565, -2.9930539681301114],
            [7.212132492115851, -2.9957628393527083],
            [7.2326856600416285, -2.9961382132583294],
            [7.232500105391388, -3.0054043593005817],
            [7.235914083670878, -3.0128147400748193],
            [7.239113788311375, -3.0133337791141983],
            [7.242998277636865, -3.019958799113908],
            [7.248210930421654, -3.019661057779939],
            [7.259280435159393, -3.0238804983090173],
            [7.261151664860565, -3.0238267187512546],
            [7.261734807664656, -3.031718795880365],
            [7.2708451418196685, -3.1616861490643737],
            [7.272781582105926, -3.186281305491432],
            [7.277724208009525, -3.244179939823171],
            [7.279846193942815, -3.2401749367826023],
            [7.282487224957041, -3.2402206325891405],
            [7.281723992203823, -3.2644615030061543],
            [7.28339801745218, -3.266503856366144],
            [7.281109484787768, -3.2717366998629864],
            [7.282607089164774, -3.2758915275286555],
            [7.276925479295387, -3.276028375452324],
            [7.278032805214658, -3.2884795848290107],
            [7.272436723671747, -3.2893322936445624],
            [7.281199964602013, -3.3737993705948632],
            [7.285573879964224, -3.3734259727978775],
            [7.285821417902744, -3.3779314635578737],
            [7.290957407798176, -3.3776307380800143],
            [7.288079700571052, -3.3825063270688718],
            [7.289744916829555, -3.386668730091478],
            [7.291535563753828, -3.3966986702528312],
            [7.285305766860056, -3.3975632128205566],
            [7.2695453162034225, -3.397639938743126],
            [7.269331240459095, -3.411326061052178],
            [7.266036792660412, -3.414989899547488],
            [7.268336340651326, -3.419834243735303],
            [7.26813345133084, -3.423283504702333],
            [7.2720516020298955, -3.4299867773330206],
            [7.225183663133975, -3.4342352827985163],
            [7.136494665655543, -3.440530379925754],
            [7.073077693526557, -3.4452794823604025],
            [7.051988277449902, -3.447275701114543],
            [6.965409293491189, -3.4542130696456046],
            [6.964551295330243, -3.4446183269564847],
            [6.955755276104891, -3.334583004518615],
            [6.948771696840391, -3.238643036354954],
            [6.94347318613272, -3.1631985547060957],
            [6.941066332955327, -3.1638192263171834],
            [6.933569943032719, -3.1607893078210765],
            [6.930176057189987, -3.1576566946014393],
            [6.9244095552892375, -3.159773921008613],
            [6.920442132741212, -3.159228421017359],
            [6.915904210035737, -3.162207944807832],
            [6.91368623627769, -3.1567590306130073],
            [6.916174433945479, -3.1517918118737596],
            [6.915669404546184, -3.147026683328183],
            [6.912752898877438, -3.1446396299038093],
            [6.914032847133865, -3.1323581540660506],
            [6.911023676960992, -3.1302517501969835],
            [6.912038591990508, -3.1263402417287227],
            [6.916664737773534, -3.1220764098076255],
            [6.920017529924953, -3.1093407830138955],
            [6.915610963449879, -3.1042627790484283],
            [6.915142160176918, -3.1019184465277907],
            [6.910769427894863, -3.09811816951233],
            [6.908859713460563, -3.0946241905447667],
            [6.902501444604138, -3.0919335613905425],
            [6.900510351024555, -3.0691328265060793]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.78809213990664, "lat": 35.23994405810156 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47181"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "01639798"
      },
      "bbox": [
        6.900510351024555, -3.4542130696456046, 7.291535563753828,
        -2.9493467616001325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.41919273795908885, -6.735676473165868],
            [0.4862583918063002, -6.726480946337661],
            [0.49209892066548805, -6.72526662907257],
            [0.5807459181356994, -6.712748393911993],
            [0.6376860536678907, -6.704626958162237],
            [0.6957944448311305, -6.695796056767617],
            [0.7805620619668159, -6.682623831021136],
            [0.8841491632879588, -6.666163731567624],
            [0.8954912970694003, -6.664629557481087],
            [0.9455542959621722, -6.655824667135638],
            [0.9492715999356056, -6.6563843275003745],
            [0.9474208329448954, -6.663577352325183],
            [0.9447650957134053, -6.663349676664475],
            [0.9433390376598494, -6.668489698770825],
            [0.9377105651099655, -6.672057378962043],
            [0.9390654553587134, -6.676957199281872],
            [0.9423794091920807, -6.680688514146755],
            [0.9387042569784922, -6.6827104212459005],
            [0.9399115129846267, -6.687283536427211],
            [0.9443105409936114, -6.690158868534249],
            [0.9463851331243323, -6.6894059204512955],
            [0.951239768656935, -6.692931859193276],
            [0.9503327420334008, -6.698686099663939],
            [0.9461042253862229, -6.70151395722202],
            [0.9414590242722424, -6.699762089556205],
            [0.937659091981494, -6.704641878638073],
            [0.9373234015312408, -6.7076328923783315],
            [0.9422756459426076, -6.709315266028734],
            [0.9494361279853027, -6.721525682695008],
            [0.9463193950715956, -6.724774731525031],
            [0.9468922535458197, -6.727678300310395],
            [0.9442458690409179, -6.732992062657945],
            [0.9348119850340242, -6.7374743421908905],
            [0.9309350898257738, -6.741699965124778],
            [0.9314660415245288, -6.745592589475417],
            [0.9286409554303675, -6.747612605110704],
            [0.9268861252073496, -6.76416866586218],
            [0.9284792782805822, -6.770835698268916],
            [0.9333871689186702, -6.772956518190976],
            [0.9331580283468139, -6.777058633378617],
            [0.9271895818113621, -6.776426583143125],
            [0.9253476446274502, -6.780595722727768],
            [0.9284302328812434, -6.785738302467063],
            [0.9319703979940395, -6.794236252340302],
            [0.940314334729103, -6.803909775251701],
            [0.9502888905833976, -6.810515591781749],
            [0.9513990965403034, -6.815106927651947],
            [0.9481096268627695, -6.820417969043058],
            [0.9484424005590283, -6.823181280653205],
            [0.9437461281546412, -6.826198022954419],
            [0.9468367664080667, -6.834557069651856],
            [0.944338823071037, -6.837060794045397],
            [0.9390451226065019, -6.838261173478229],
            [0.9388663239191725, -6.841581959703978],
            [0.9436388892130887, -6.846427581021338],
            [0.9426462976159597, -6.851988442065325],
            [0.9446824945975937, -6.859721621617667],
            [0.9397369121361432, -6.865683589473429],
            [0.9391158406569905, -6.868561790456311],
            [0.9414444750675347, -6.872034999631767],
            [0.9348945237981625, -6.878078652323254],
            [0.932623965054517, -6.882885171795676],
            [0.9338586301359111, -6.888948843901781],
            [0.9321752793567007, -6.89186182198863],
            [0.9368459141109999, -6.898195503957824],
            [0.9387051812586504, -6.8964283693934645],
            [0.9454622026444045, -6.900528227504254],
            [0.9501806520635109, -6.898633081279284],
            [0.9540747890467354, -6.903964027078839],
            [0.9567839061744011, -6.902356912399711],
            [0.962435485857645, -6.905544504738574],
            [0.9622345354654098, -6.911556232744096],
            [0.9643963209821813, -6.916389484285516],
            [0.9680995364153342, -6.917726725288975],
            [0.9702912764370623, -6.925731623699971],
            [0.9678012698300997, -6.929164528009306],
            [0.9718987427196326, -6.937976815033104],
            [0.9764531758130555, -6.952186045055895],
            [0.9746491470870268, -6.956049196230403],
            [0.9759734577251117, -6.958270300971364],
            [0.9732688889116127, -6.964543912797285],
            [0.9745091698746664, -6.968565151420432],
            [0.9719488879103321, -6.979096753926975],
            [0.9763879662219855, -6.97603891620733],
            [0.9780937173460524, -6.9795943759921935],
            [0.982253812476897, -6.980796163001281],
            [0.985496602837763, -6.983979655886461],
            [0.9900967884956332, -6.9827954142089865],
            [0.9911998729296704, -6.985229839577941],
            [0.9965381263835672, -6.9865607773926595],
            [1.0032068728491494, -6.986675190219961],
            [1.0067205549494358, -6.9919356062198315],
            [1.0038813180936976, -6.995267407193182],
            [1.0064265140548718, -6.997632076768448],
            [0.9990711401485244, -6.999308949363356],
            [0.9968288844651044, -7.003234605150385],
            [1.0004955853550057, -7.012319964529828],
            [1.005858412088555, -7.010118084618649],
            [1.0105304702932916, -7.010965961530377],
            [1.011525572513195, -7.0082517188314535],
            [1.016992989693151, -7.005215950135428],
            [1.024527210673039, -7.003415628588405],
            [1.0282809126222747, -7.005907751297365],
            [1.0288450949725807, -7.01084339295422],
            [1.0206300085755342, -7.020877765271675],
            [1.0270135356351033, -7.024692415810999],
            [1.0295784420485075, -7.020282519766759],
            [1.0328670403047595, -7.02167701371469],
            [1.0359853621582185, -7.028609903692189],
            [1.0327100524778858, -7.031270487384273],
            [1.0384324345561053, -7.034365063026613],
            [1.0422808848365788, -7.03224942899774],
            [1.047074584753285, -7.032468284557531],
            [1.0466364748335943, -7.041389608066793],
            [1.053679180131021, -7.046421140481096],
            [1.053837037296831, -7.049899596336486],
            [1.0620385656019105, -7.052685182862697],
            [1.071149077143874, -7.062164898342836],
            [1.0718073458181365, -7.065705146071065],
            [1.0690234495213413, -7.067165142434428],
            [1.0694813631693851, -7.070667964720958],
            [1.072246336225722, -7.074945799323686],
            [1.0756661945196941, -7.077371797712939],
            [1.0775304847501934, -7.081071119606098],
            [1.0746599150279295, -7.086664761083486],
            [1.0718496826476507, -7.086646993056254],
            [1.0711911954112041, -7.092694167487318],
            [1.0687114813319212, -7.094706800715543],
            [1.0725237273636592, -7.099579328812936],
            [1.0720377509671124, -7.105686696205996],
            [1.0675279744896813, -7.10537157262678],
            [1.0728188372057366, -7.112834721744064],
            [1.0864183680747606, -7.113461020023371],
            [1.0897207511642584, -7.120223606961579],
            [1.0916097326325336, -7.130210300029375],
            [1.089125965265895, -7.134068639590571],
            [1.0837081178777705, -7.1387204910053335],
            [1.0830688685550804, -7.1430357010420025],
            [1.0802672757893628, -7.145167310852364],
            [1.0019412706679418, -7.157378953803848],
            [0.993814223687983, -7.159053356459745],
            [0.928460381135534, -7.16884325238614],
            [0.8938248406398477, -7.174245259412697],
            [0.8878438137627838, -7.175662443254195],
            [0.8336916506906936, -7.185210585128656],
            [0.7928820285122407, -7.191888069517048],
            [0.7593318191654338, -7.197871320492716],
            [0.7632855363738899, -7.212576332457355],
            [0.6851509613395224, -7.235693417806492],
            [0.6897263209924204, -7.231378146624728],
            [0.6870172501718073, -7.22126803792301],
            [0.6835210424524136, -7.217353125266312],
            [0.6784990647095054, -7.215478009027092],
            [0.6774678684181874, -7.211159761836431],
            [0.6704612884348566, -7.208843047782518],
            [0.6685745221727409, -7.206691277497522],
            [0.6702467558869157, -7.203346111751215],
            [0.6752068421295029, -7.199186517178239],
            [0.6724283804325973, -7.19390021504954],
            [0.6744696888210587, -7.188412087079291],
            [0.6819644668974452, -7.185798274273223],
            [0.6888650195006428, -7.188733119603093],
            [0.6936278065659724, -7.188334274419086],
            [0.6963226661042037, -7.184880829547967],
            [0.7026392777127605, -7.186235253299867],
            [0.7037251447303233, -7.181265053659381],
            [0.7038480924637203, -7.1721791897596425],
            [0.7001832227427526, -7.162145695105629],
            [0.6932948722922859, -7.156899085171695],
            [0.6997062189024305, -7.153744367207234],
            [0.7010450517211992, -7.148064444581716],
            [0.7047602463913385, -7.1459721692445815],
            [0.7045645612440433, -7.1412709899899305],
            [0.7087043864650525, -7.136160209792906],
            [0.7076939551922896, -7.132461687560543],
            [0.7095786854410551, -7.124515649050507],
            [0.7034016024928087, -7.112956433899793],
            [0.7024424098126456, -7.107781570302621],
            [0.6980341956013928, -7.102243922777109],
            [0.6949712595717387, -7.096456952021169],
            [0.690279175434083, -7.091452604590171],
            [0.6881521511890999, -7.0868713571921536],
            [0.6846587487156497, -7.086481315300951],
            [0.6727069702990035, -7.091363207050788],
            [0.6695165715346278, -7.0967646199492345],
            [0.6732622785479224, -7.104976263294609],
            [0.6730246181093081, -7.111030517381127],
            [0.6767014060074275, -7.119408131445419],
            [0.6768749879071675, -7.122493632203676],
            [0.6737736905846418, -7.125055542651562],
            [0.6729074425298416, -7.133340866070971],
            [0.6666629483600361, -7.13616749183278],
            [0.6664956114393507, -7.140085624166369],
            [0.6601558425974151, -7.142762459084348],
            [0.6523890118965987, -7.137950521036355],
            [0.6459482370272159, -7.128813426819144],
            [0.6441134815997418, -7.121899405193893],
            [0.6426879667076041, -7.118113109239417],
            [0.6433608208009582, -7.114140763326545],
            [0.6370216461700351, -7.111407282736738],
            [0.636084617300195, -7.108218559862626],
            [0.6374533987132567, -7.102117098600112],
            [0.6419850456951742, -7.094174965813527],
            [0.6412172158887565, -7.08739612130245],
            [0.6382718649339786, -7.080133473162593],
            [0.6411458204544283, -7.077378629757454],
            [0.6425686128820473, -7.06855742318682],
            [0.6464815514524499, -7.064584058417352],
            [0.6504229685995858, -7.055919024464039],
            [0.6434476584241241, -7.053209821652205],
            [0.6410052789946862, -7.051082257806155],
            [0.6394680414850028, -7.0586574452168955],
            [0.6370892485950824, -7.065560450262762],
            [0.6329559692696318, -7.065372833882662],
            [0.6293147590781349, -7.069130703123647],
            [0.6256031004968415, -7.068401677107605],
            [0.6192591189264324, -7.059280747442102],
            [0.616347513998755, -7.053908181734326],
            [0.6126207398787343, -7.053717760036628],
            [0.6067477790796879, -7.04689391339785],
            [0.6032539662452787, -7.045032138951329],
            [0.5946066885176808, -7.044596027290329],
            [0.5903957922721098, -7.042792647277372],
            [0.5864475354537745, -7.044188158464893],
            [0.583354608286147, -7.0505348840306254],
            [0.5804913289769343, -7.053173330217982],
            [0.5777828676595962, -7.0486501583941035],
            [0.5717517123504011, -7.0476607013713926],
            [0.5679191529509627, -7.042052152945093],
            [0.5648629242616108, -7.040332656622127],
            [0.5650218112598733, -7.037361149931505],
            [0.5697577435286478, -7.037754797335257],
            [0.5673445625820815, -7.032091311754427],
            [0.5690541048401765, -7.0290020800693505],
            [0.5688215994780287, -7.023531958354675],
            [0.5727115341586655, -7.020885271281159],
            [0.5762702172352852, -7.02255506065147],
            [0.576385963622181, -7.013341207401797],
            [0.5733859311832002, -7.001307118936702],
            [0.5695508096567464, -7.002405803517704],
            [0.5677793746639569, -7.008232850659136],
            [0.5643786956311913, -7.004968397601686],
            [0.565110409720627, -7.000374825335582],
            [0.5747952325042711, -6.994843261266677],
            [0.5710582637468042, -6.993759657884544],
            [0.5705391768220608, -6.987365012819402],
            [0.5687680197558797, -6.98536744556393],
            [0.5599558961001195, -6.983116286736206],
            [0.5572772588899444, -6.98442145112476],
            [0.5525021715196627, -6.982458819955671],
            [0.5467655255781357, -6.9860529490509],
            [0.5501074363343472, -6.973964140850328],
            [0.5450630087052479, -6.973534668360046],
            [0.5425201118155967, -6.975070558968385],
            [0.5362455730497258, -6.975372521461056],
            [0.532699213046152, -6.9737864074350036],
            [0.5278670517257307, -6.975094443924865],
            [0.5226226952666734, -6.96863284913469],
            [0.5180384996025886, -6.970922199723535],
            [0.5161076720176734, -6.966818755930242],
            [0.5035024377980513, -6.964707237301679],
            [0.5033500706359112, -6.961246592274359],
            [0.4981696364219073, -6.9589387960521885],
            [0.494994028695602, -6.951607649227703],
            [0.49133546764691033, -6.9529291102552175],
            [0.48682913746878165, -6.952305352136452],
            [0.48236295731540335, -6.956627805102555],
            [0.48018463857150934, -6.956462764083701],
            [0.4777456080703871, -6.951061080221271],
            [0.4819083963871421, -6.944959029705506],
            [0.4838927536435024, -6.938878134572174],
            [0.4849274626684641, -6.929156675083428],
            [0.4833676907372952, -6.926541487785477],
            [0.4863830401903095, -6.9219855605086185],
            [0.4836823194354185, -6.919518205237801],
            [0.4819293370925085, -6.906905696314031],
            [0.47693736460920516, -6.904305822174889],
            [0.47387968493161736, -6.900855720272382],
            [0.47048605779578045, -6.901564137137354],
            [0.4683547263067982, -6.897832474313097],
            [0.47146196107545946, -6.892698167144444],
            [0.4753440489767289, -6.881061904619725],
            [0.48057869095544065, -6.878842874565358],
            [0.4824236490322958, -6.872511178859788],
            [0.4854145172290614, -6.869174177102504],
            [0.49069014448711656, -6.868804554156626],
            [0.48885344072344694, -6.864090423678287],
            [0.48295919227364603, -6.863737957075504],
            [0.4732035988291448, -6.869030907045519],
            [0.47294026361659264, -6.872582629164781],
            [0.46870509160975765, -6.874994652247296],
            [0.462668981554982, -6.871979729812487],
            [0.4596562640306651, -6.8686304051763525],
            [0.4603825849875207, -6.864331634792437],
            [0.4581158137116322, -6.860270023176859],
            [0.4522997447751138, -6.865818030385069],
            [0.44689323541523096, -6.86962016265469],
            [0.44322820962758663, -6.868148161582226],
            [0.4403918362739892, -6.863404732415135],
            [0.44115999969763037, -6.855129279343443],
            [0.4440403347557613, -6.845141432711937],
            [0.4472861691018929, -6.837576148912555],
            [0.4496790355852774, -6.838604033977518],
            [0.45226682403510127, -6.830252189786687],
            [0.457553284277444, -6.833295239555825],
            [0.4626069614392457, -6.834187255287271],
            [0.4596796182914741, -6.825021762962413],
            [0.4567033328169965, -6.822864831477891],
            [0.4585277335378803, -6.8171069614511115],
            [0.45238525067513524, -6.811493851056139],
            [0.4549494044069155, -6.807782047278186],
            [0.44988653770702947, -6.806704902745859],
            [0.4460964079461098, -6.803206467322209],
            [0.451483875954906, -6.795349949465001],
            [0.4462511454264056, -6.790890373875073],
            [0.4473928065058323, -6.787327859698486],
            [0.4452215613714886, -6.784175647500673],
            [0.4392726927844426, -6.783558478471548],
            [0.4355892033807963, -6.788577715410631],
            [0.42925356450598895, -6.78932352900304],
            [0.43185817123883424, -6.793058925513172],
            [0.4278190865531708, -6.796124070206357],
            [0.4259071369404514, -6.790486333549144],
            [0.4175542546620276, -6.793217632552998],
            [0.41572872390511295, -6.78843167461766],
            [0.4117557645836127, -6.7866313678055485],
            [0.4114852522772745, -6.781913029026281],
            [0.41543075332172164, -6.781249007636143],
            [0.41654655128897333, -6.777827466135548],
            [0.421187569386841, -6.780313387689873],
            [0.42674160200628036, -6.781186134366978],
            [0.42750439145388647, -6.7786881774898],
            [0.4238067782991553, -6.775473727628342],
            [0.42452989542549113, -6.771314466789595],
            [0.4204642256687451, -6.771979890081675],
            [0.41681239439803064, -6.769451526654962],
            [0.4175319327269063, -6.7661762640411816],
            [0.41197598204223324, -6.766122009232166],
            [0.4090331857626256, -6.760846773796282],
            [0.41243001006640717, -6.754597742901376],
            [0.4160492673469184, -6.75376478527741],
            [0.41585867009259975, -6.750668415185774],
            [0.4224231971989535, -6.743964524808724],
            [0.41919273795908885, -6.735676473165868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.65247272546014,
          "lat": 31.813291508514045
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48001"],
        "coty_name": ["Anderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anderson County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01383786"
      },
      "bbox": [
        0.4090331857626256, -7.235693417806492, 1.0916097326325336,
        -6.655824667135638
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.27093497176233194, -10.58642286028039],
              [-0.2715442726253742, -10.58924099063528],
              [-0.2777030132366955, -10.597524490167402],
              [-0.2776656810121653, -10.602245041699005],
              [-0.2834543231578027, -10.612306802728897],
              [-0.28603764437079354, -10.62189025860704],
              [-0.28627272772593243, -10.625748686093118],
              [-0.29213961253184173, -10.63226001437493],
              [-0.291605574730421, -10.635258834195566],
              [-0.3214634643491381, -10.664483905818642],
              [-0.35823649985197686, -10.702435810978997],
              [-0.3890167992088854, -10.737126498648308],
              [-0.41554648604353756, -10.769461617488481],
              [-0.42971383063183655, -10.787773324730182],
              [-0.4460120192886007, -10.811035899495351],
              [-0.4573507664612354, -10.831244110437327],
              [-0.46114973380527796, -10.839183770832275],
              [-0.4649429884135763, -10.850193781452502],
              [-0.4729806903041828, -10.842499282527154],
              [-0.4736924708328761, -10.840126903656145],
              [-0.47100777590058773, -10.835941451496549],
              [-0.46377766931459957, -10.821525837954306],
              [-0.46180940842929574, -10.815277110897688],
              [-0.4618679196886885, -10.811062126091922],
              [-0.46378977625775497, -10.803743558246486],
              [-0.4632167432014991, -10.799637852768544],
              [-0.45864997432730265, -10.796706300515389],
              [-0.45511759326627643, -10.782458198473167],
              [-0.45254575691324755, -10.778682550991261],
              [-0.4437752603979795, -10.77682325478702],
              [-0.438760257036401, -10.7713258518272],
              [-0.4312210720351121, -10.767903864139553],
              [-0.4273071954025391, -10.763477526198205],
              [-0.42034380491810175, -10.751989838566315],
              [-0.42276738110959255, -10.75008445954525],
              [-0.42678724993421646, -10.750429466829308],
              [-0.43294788604219625, -10.748814777645197],
              [-0.43980248671848005, -10.749789247390794],
              [-0.4489532622232233, -10.75552234533872],
              [-0.4502463734361718, -10.752480068159581],
              [-0.44889551269845607, -10.748433187886336],
              [-0.420018228066287, -10.743670875251144],
              [-0.41400532422940545, -10.743482025329387],
              [-0.40990848119002343, -10.737737536013361],
              [-0.40870247131013226, -10.729811536619609],
              [-0.4104725050578085, -10.717771333717115],
              [-0.40869466182837183, -10.709055209908822],
              [-0.3996285956271266, -10.688084520173208],
              [-0.39361320037536546, -10.676740659519343],
              [-0.3898726397007816, -10.671332174676099],
              [-0.38316687127508303, -10.664207537500031],
              [-0.381742756035483, -10.658777332577623],
              [-0.3742203202015195, -10.650079731643151],
              [-0.37493766653823596, -10.641688608172531],
              [-0.367588544439854, -10.643403817650325],
              [-0.36302156288818427, -10.63933912899987],
              [-0.36128480642925576, -10.623433566921888],
              [-0.3554470742172088, -10.607671644691708],
              [-0.3504531213162659, -10.60268666693041],
              [-0.3378684865190428, -10.595821074968923],
              [-0.3262681716529005, -10.592642895353055],
              [-0.3223778892048846, -10.592781597141158],
              [-0.3155220367787836, -10.590789757047807],
              [-0.3151799002895487, -10.587917246149752],
              [-0.3189442417862762, -10.585623509487965],
              [-0.32221009122509425, -10.586209860488191],
              [-0.32596827533048234, -10.583299549692843],
              [-0.32142117807228443, -10.580671408824998],
              [-0.3141653383275037, -10.569542885778805],
              [-0.3148704902562281, -10.566250888562845],
              [-0.3093809583309996, -10.563938123145661],
              [-0.3066789056864037, -10.567351996233693],
              [-0.2999981847493783, -10.572649364476982],
              [-0.2931849033557104, -10.576705760304868],
              [-0.29420706813564856, -10.582027942433596],
              [-0.2898067011657101, -10.581298639724196],
              [-0.2870833538220799, -10.586319561440993],
              [-0.2832679871970706, -10.58874557513543],
              [-0.27412201697728494, -10.583952467890757],
              [-0.27093497176233194, -10.58642286028039]
            ]
          ],
          [
            [
              [-0.4805708659389985, -10.838255939219028],
              [-0.48152607823951443, -10.837419097653955],
              [-0.4745022352813057, -10.82477611697012],
              [-0.4873451948542848, -10.789841711841683],
              [-0.48192524720564034, -10.784765341818197],
              [-0.48103292787044516, -10.778013491844076],
              [-0.4709283238671683, -10.78871035140458],
              [-0.4676047673309116, -10.811976630019936],
              [-0.4700412433102491, -10.82233170164145],
              [-0.47619967253099854, -10.835216571356945],
              [-0.4805708659389985, -10.838255939219028]
            ]
          ],
          [
            [
              [-0.23410602989319373, -10.38247187229818],
              [-0.23524724539550732, -10.389390762486213],
              [-0.24795633354061972, -10.404261414423749],
              [-0.2511576393703782, -10.410722629784248],
              [-0.2480811306141691, -10.418734651219673],
              [-0.24169255563674755, -10.424864216504641],
              [-0.25155483988411165, -10.479058930090572],
              [-0.25451822588548356, -10.481863864186462],
              [-0.25369932272748386, -10.48598436180356],
              [-0.2581658953234866, -10.490559243511287],
              [-0.26151740613670466, -10.48940151560082],
              [-0.2659787048331944, -10.495010171314977],
              [-0.26541570881932897, -10.500231097151143],
              [-0.27537159485682283, -10.509180526238774],
              [-0.2809009466656851, -10.516422306736008],
              [-0.28386392594997484, -10.518757688286335],
              [-0.2831691126384602, -10.523281309783778],
              [-0.293281839804836, -10.52586224471056],
              [-0.2992718547810237, -10.525808987857545],
              [-0.30519008024420113, -10.529350065827705],
              [-0.3082177266239811, -10.534034116002974],
              [-0.3207675830968679, -10.542864901551411],
              [-0.32070814231432976, -10.547692058723587],
              [-0.322514276346751, -10.549626657995088],
              [-0.32999866182668586, -10.551816398210253],
              [-0.3323315254217715, -10.553848752885997],
              [-0.3374686532998218, -10.563248462672934],
              [-0.33697996944655745, -10.567053132569978],
              [-0.3430110478954816, -10.570898382014176],
              [-0.3441583897277037, -10.57639242277121],
              [-0.3537403386503781, -10.58188840125425],
              [-0.35583666939264746, -10.581252039397409],
              [-0.3417717360339096, -10.562488781171819],
              [-0.3474686234691803, -10.564386942693424],
              [-0.34912817578877986, -10.562111485436388],
              [-0.3451079558215986, -10.559582166795597],
              [-0.33936844298542485, -10.55316655278794],
              [-0.3415008014922413, -10.550118337271542],
              [-0.35771334494536083, -10.567954998239955],
              [-0.3604962675102382, -10.572858017770491],
              [-0.3772294649605607, -10.574132617555383],
              [-0.38630201496087074, -10.573354101266936],
              [-0.38429088907429243, -10.565435967878699],
              [-0.3886596343016, -10.563262196061276],
              [-0.37992948998623416, -10.560550066384758],
              [-0.3761636699587107, -10.552063398542453],
              [-0.3720233071421124, -10.548099684076622],
              [-0.3738325932641641, -10.540535727856284],
              [-0.3701967928778584, -10.533741135431939],
              [-0.36875805737712475, -10.526567007949257],
              [-0.3627392354520413, -10.523750658575818],
              [-0.36003537095117066, -10.516075558554277],
              [-0.3555471843454821, -10.508521064597268],
              [-0.35272100998444955, -10.498999382168002],
              [-0.35740146398155115, -10.496798861214941],
              [-0.35726884997824465, -10.491461329555765],
              [-0.35912473342144724, -10.487952476486393],
              [-0.3673831612189947, -10.483971664108163],
              [-0.3692425843655974, -10.48087318543102],
              [-0.3672953631434848, -10.475245975917314],
              [-0.36219505777501076, -10.469341227303302],
              [-0.3617272414965983, -10.464623800517009],
              [-0.3564717236371414, -10.464160662593084],
              [-0.35492596804265486, -10.456476543011172],
              [-0.3489754018299716, -10.449347917854888],
              [-0.35039497898888355, -10.444303996203724],
              [-0.34617909995509694, -10.442599602036848],
              [-0.34222777175262026, -10.435759861507583],
              [-0.3437475988489116, -10.430201816667406],
              [-0.3565261079989388, -10.437881103108245],
              [-0.3579705148487839, -10.44587391673189],
              [-0.36250528295020984, -10.447883497023499],
              [-0.3700711764844434, -10.448528708617767],
              [-0.3762191767364806, -10.454216496258743],
              [-0.37631418776284764, -10.463556960527082],
              [-0.3810911321544197, -10.468540672773802],
              [-0.39222051964509896, -10.478387182640775],
              [-0.38611744040241935, -10.487483330160869],
              [-0.3811170425278354, -10.49163959142917],
              [-0.37249889167273764, -10.501580354669157],
              [-0.37596254134269685, -10.51182232104828],
              [-0.3854914206515192, -10.518599368230667],
              [-0.3910037707290594, -10.524987032470646],
              [-0.3965256005197698, -10.52532271772034],
              [-0.3907833671270732, -10.532407790560587],
              [-0.3909215229400749, -10.535589752529042],
              [-0.39409881752571063, -10.537919919166216],
              [-0.3967723224795637, -10.542308219009405],
              [-0.39695443040820005, -10.550112279202223],
              [-0.40113490146370573, -10.557360185503509],
              [-0.39931135276558377, -10.563951077837705],
              [-0.4031808839907969, -10.566608674361458],
              [-0.4063287468716184, -10.571377218517723],
              [-0.41176932936689215, -10.568754397221753],
              [-0.4163798595720045, -10.560917699705687],
              [-0.4212772722332131, -10.558805350865969],
              [-0.42725236195336463, -10.561404850705031],
              [-0.42899499210634423, -10.5572796986256],
              [-0.44323694604996516, -10.546799711718288],
              [-0.44132993075720256, -10.544714810926264],
              [-0.43591116059753776, -10.545943134794701],
              [-0.4297771217244333, -10.540756378916495],
              [-0.4286951623382624, -10.537299217472144],
              [-0.43762415560410406, -10.533576276070402],
              [-0.43590103680279757, -10.525271216222247],
              [-0.4372157189435728, -10.520533974203444],
              [-0.43559311930149464, -10.516238241664986],
              [-0.43661553226068334, -10.513660317562115],
              [-0.43008456294662484, -10.512188948793858],
              [-0.4267699193475744, -10.506884205998524],
              [-0.4284836553016869, -10.500192651029497],
              [-0.4280072445121668, -10.494961820626141],
              [-0.4357338260275788, -10.49469943463042],
              [-0.44542105645484387, -10.49424402336336],
              [-0.4533222568121413, -10.496050620941942],
              [-0.4547818952777182, -10.49017353682395],
              [-0.4583454004955644, -10.488444040264424],
              [-0.4676520391214051, -10.492379182682283],
              [-0.4730730991318285, -10.491545444822581],
              [-0.476555056437645, -10.489279840032463],
              [-0.477582632016685, -10.482798052586736],
              [-0.48185886365318453, -10.48317043287465],
              [-0.48726040587485603, -10.477557441475945],
              [-0.4977719512238042, -10.476549537161059],
              [-0.5018208304771892, -10.473444892558401],
              [-0.5102574905581782, -10.470720497221045],
              [-0.5063963612633443, -10.465317877782844],
              [-0.5121149779002506, -10.461275788421036],
              [-0.5158116873903398, -10.460101942673791],
              [-0.51607590755105, -10.45682490585295],
              [-0.5189175441706327, -10.455250829736306],
              [-0.5195012103312792, -10.451134563137362],
              [-0.5235754634793187, -10.450841423859512],
              [-0.5244333488568398, -10.447660278618978],
              [-0.5304205973896587, -10.444236115488987],
              [-0.529029587817728, -10.4413408269579],
              [-0.5250993380968187, -10.441298183705204],
              [-0.5233950217791078, -10.437670896799844],
              [-0.5263282959616344, -10.43356520597711],
              [-0.5263188342243338, -10.427988118261021],
              [-0.5281893327890754, -10.425086036506226],
              [-0.4930692112363297, -10.420221412959819],
              [-0.4207670756857698, -10.409864428183877],
              [-0.34846886249812925, -10.399493414613872],
              [-0.303311013171824, -10.392666691546017],
              [-0.30183070778362653, -10.392608384320464],
              [-0.23410602989319373, -10.38247187229818]
            ]
          ],
          [
            [
              [-0.6524496542034693, -10.616707587568836],
              [-0.6492948014015024, -10.6200480882873],
              [-0.6432062630865006, -10.623925987367477],
              [-0.634399540560228, -10.630872006069847],
              [-0.6292585674600081, -10.630036587250508],
              [-0.6172519688785875, -10.618441361109205],
              [-0.612122056640167, -10.619775876954549],
              [-0.5986287549444866, -10.624701377323884],
              [-0.5802159332349259, -10.634552109384527],
              [-0.5813677570303756, -10.642448619739538],
              [-0.5795487772918326, -10.64842894317393],
              [-0.5741993268969212, -10.649931777912881],
              [-0.573009672683491, -10.647378055296958],
              [-0.5651862174845883, -10.644595703674264],
              [-0.5624639291961708, -10.64575868125571],
              [-0.5642328853528153, -10.652621050039038],
              [-0.5585307559738409, -10.659674453073928],
              [-0.5451322915454302, -10.665894629915861],
              [-0.5362623898417213, -10.663739250831886],
              [-0.5326540507703238, -10.670048130248317],
              [-0.5283522836289356, -10.671331021409872],
              [-0.5306880325448555, -10.664214495126204],
              [-0.5205320926634924, -10.660016676051297],
              [-0.5181126894841894, -10.660147277647534],
              [-0.5157394123605217, -10.655346022712449],
              [-0.521481539488293, -10.651376186772724],
              [-0.5261074791375508, -10.650912464749933],
              [-0.5310705154201296, -10.652189930202773],
              [-0.5347463647428835, -10.651531092823518],
              [-0.5416194386245268, -10.645389833390182],
              [-0.5392788223794072, -10.643362337974594],
              [-0.5298928924771119, -10.641828180115857],
              [-0.5257046719410554, -10.634788943206596],
              [-0.520752528096766, -10.634331771002001],
              [-0.5208544319904678, -10.625188381430341],
              [-0.5168319320550494, -10.623180348128102],
              [-0.5127708124137609, -10.6178849523954],
              [-0.5096996909490205, -10.61617422993231],
              [-0.4978011428234079, -10.615383935110978],
              [-0.4915654787546461, -10.612988967546283],
              [-0.48711037919354516, -10.60973711779873],
              [-0.48216043063095254, -10.609395197515601],
              [-0.46935041648442233, -10.602242993483353],
              [-0.46283228172333674, -10.593275749021787],
              [-0.463028489444791, -10.582591929098411],
              [-0.46424997832847653, -10.578984660369962],
              [-0.45729076734636925, -10.577313776317332],
              [-0.4473611607954961, -10.582863087323007],
              [-0.44325412764885047, -10.582393298772452],
              [-0.4394542226062317, -10.590752958813678],
              [-0.4470867841806414, -10.596115597117828],
              [-0.45008230670173094, -10.600705052584255],
              [-0.45334731049059934, -10.613280595534317],
              [-0.4541768557989261, -10.618944740162577],
              [-0.4530078207095032, -10.627379775262511],
              [-0.4508263788545201, -10.629971504877739],
              [-0.4511529802109882, -10.640445939014729],
              [-0.444815559058507, -10.652290377244823],
              [-0.4443371896306414, -10.6618856685424],
              [-0.4511887254358104, -10.66273728217925],
              [-0.4608023377546765, -10.665716089874822],
              [-0.4653153295737408, -10.671507983175024],
              [-0.47732552392761046, -10.69679211635868],
              [-0.47946572127695486, -10.702469208668127],
              [-0.4829010515383784, -10.715501309800738],
              [-0.4833695135858918, -10.727005570213619],
              [-0.48685738061622924, -10.744477325091413],
              [-0.4895572855395416, -10.752011091818943],
              [-0.4931459529424992, -10.748846619298254],
              [-0.4901099266085214, -10.741481017913797],
              [-0.48822310986263157, -10.731308289324577],
              [-0.4913018610761933, -10.727821196564339],
              [-0.49335289143265937, -10.723030582005137],
              [-0.48900843372284625, -10.718969006243277],
              [-0.49319646656347127, -10.716785104384218],
              [-0.4999351236075862, -10.721358110626964],
              [-0.5303832728645371, -10.767682345028199],
              [-0.5378617176174744, -10.771889149106826],
              [-0.5397343166975231, -10.773946097568613],
              [-0.5385217948898829, -10.778276395128572],
              [-0.5421337558947955, -10.789083945952498],
              [-0.5442726841184796, -10.785844694561714],
              [-0.5681148521168689, -10.748556039875526],
              [-0.6285250059057834, -10.654423712577177],
              [-0.6512291175060382, -10.619234313473383],
              [-0.6524496542034693, -10.616707587568836]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.99320820331981,
          "lat": 28.125791711446947
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48007"],
        "coty_name": ["Aransas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Aransas County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01383789"
      },
      "bbox": [
        -0.6524496542034693, -10.850193781452502, -0.23410602989319373,
        -10.38247187229818
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.089650035402572, -3.4150919689215646],
            [-4.080179693386364, -3.415535327391205],
            [-3.8898450718912154, -3.4277053849721497],
            [-3.837756205131871, -3.430625784481032],
            [-3.733237277818239, -3.436758304647313],
            [-3.6555587914706043, -3.440515422879989],
            [-3.658413700692111, -3.486785342869516],
            [-3.6615476368752313, -3.543116805327821],
            [-3.6647329605203818, -3.596354909401729],
            [-3.66943536257239, -3.665817499585118],
            [-3.6745707555619034, -3.7498697901928435],
            [-3.6826011079535275, -3.8763949791735324],
            [-3.771470334545653, -3.8721362637270897],
            [-3.8325500604086304, -3.86820841803071],
            [-3.922715923509799, -3.8630458880424627],
            [-3.9626620535833332, -3.861738995369018],
            [-3.992482471883529, -3.8599876987750146],
            [-4.120755269900089, -3.852316748339607],
            [-4.120724670197042, -3.849892729579024],
            [-4.11227111413542, -3.7335538106164328],
            [-4.112016692621031, -3.724414542815607],
            [-4.107553159802291, -3.6696362519035683],
            [-4.103779918463487, -3.613266447167559],
            [-4.102744214003181, -3.60532069946682],
            [-4.089650035402572, -3.4150919689215646]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.35736718329291,
          "lat": 34.964939332671044
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48011"],
        "coty_name": ["Armstrong"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Armstrong County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01383791"
      },
      "bbox": [
        -4.120755269900089, -3.8763949791735324, -3.6555587914706043,
        -3.4150919689215646
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.534399765999676, -4.878425860582166],
            [-1.533926397972496, -4.878428852230614],
            [-1.5312040776259384, -4.769567310818753],
            [-1.5296837430228754, -4.695162955590051],
            [-1.528023753486, -4.6307108093176215],
            [-1.5241437397843594, -4.63099823156618],
            [-1.5180748314893013, -4.6257245854899836],
            [-1.5162854034572875, -4.619728486113979],
            [-1.5175862446968815, -4.613412015173394],
            [-1.513754566181616, -4.612688975973685],
            [-1.510058007203093, -4.6152809846883365],
            [-1.5068114219131776, -4.609421713361527],
            [-1.5061954323738516, -4.592527005063264],
            [-1.508479332592858, -4.591625494355861],
            [-1.503368026894825, -4.58262847557467],
            [-1.498115437085631, -4.580852129231909],
            [-1.493505437178785, -4.5846531410347735],
            [-1.4908391302238495, -4.58308694025267],
            [-1.491810094191882, -4.579448392052295],
            [-1.4959862436991673, -4.576372717649481],
            [-1.4966052361279292, -4.573157848120628],
            [-1.4919351092784143, -4.564944523936236],
            [-1.4827026356419435, -4.562227416434602],
            [-1.4801371830774677, -4.55821546130966],
            [-1.4772648310061338, -4.557364280584023],
            [-1.4457463438614644, -4.564253061444977],
            [-1.4254294987589222, -4.5812711736041605],
            [-1.4091911305460614, -4.585508609961452],
            [-1.4031390273458821, -4.5841831563538245],
            [-1.393880142736133, -4.585051450137104],
            [-1.3896328150983415, -4.587249054140605],
            [-1.3826124231184251, -4.586173020536996],
            [-1.3768558172277188, -4.583911176223481],
            [-1.3686461510018615, -4.583179348476985],
            [-1.3627455630847731, -4.592289700634734],
            [-1.356961115282541, -4.5957119170407505],
            [-1.3436192049377664, -4.601082781256997],
            [-1.336563071312845, -4.602280158500832],
            [-1.3182542177726413, -4.604288329538736],
            [-1.3059300348493912, -4.595964429328359],
            [-1.2960934453026782, -4.5824965788944665],
            [-1.292869910713662, -4.577096650847338],
            [-1.2859702931923251, -4.568482898331078],
            [-1.2797725803014692, -4.5645939948189715],
            [-1.2683583995356325, -4.565278455111499],
            [-1.2623428177907574, -4.572727116511825],
            [-1.2613151431618195, -4.577467124509586],
            [-1.2636162727704743, -4.584390342049852],
            [-1.2615056266183386, -4.588279983634723],
            [-1.2545264824422757, -4.587855726558582],
            [-1.252753246546144, -4.591645249312026],
            [-1.2536345875802863, -4.597886277670483],
            [-1.2575356869220604, -4.608641242575373],
            [-1.2653752511638106, -4.621519142209146],
            [-1.278095881199423, -4.635026938068197],
            [-1.2795008290993717, -4.638218490432976],
            [-1.27902337336067, -4.647410121288752],
            [-1.2746245390241082, -4.657399833455167],
            [-1.2621952838918902, -4.671377410125289],
            [-1.2498054352906611, -4.67860039501133],
            [-1.249893433538574, -4.683684215686976],
            [-1.2569888626307213, -4.6862680524758344],
            [-1.2615263687234555, -4.681837999215654],
            [-1.2660724462945312, -4.681446531763598],
            [-1.2684090040480678, -4.6857905990464905],
            [-1.2622075508634212, -4.696209103163337],
            [-1.2550022171390498, -4.701036026205506],
            [-1.2495319556250208, -4.709667256649103],
            [-1.2541955529550166, -4.714903714114394],
            [-1.2498511316845942, -4.718081246512002],
            [-1.2272562555600224, -4.725171345513706],
            [-1.2157247568697866, -4.7278144588819115],
            [-1.197920832991371, -4.7278440282742125],
            [-1.1865069572945461, -4.725915515363446],
            [-1.1713880447677416, -4.7223562351364246],
            [-1.1637483859615716, -4.716926765177827],
            [-1.1583406136680894, -4.716991565650859],
            [-1.1514649449752519, -4.728381278625225],
            [-1.1476661551674123, -4.731863103710902],
            [-1.1430435593220485, -4.732693075535946],
            [-1.1388150258135306, -4.731836484184153],
            [-1.1375353609200396, -4.73453111787997],
            [-1.147178673642182, -4.764356030974335],
            [-1.1501417187753702, -4.770897078136018],
            [-1.1546696882686456, -4.775359062292375],
            [-1.1604301947566196, -4.778117208570018],
            [-1.1616713818134698, -4.782347388263682],
            [-1.1593606369206941, -4.78556847642231],
            [-1.1529986220144361, -4.786595468253859],
            [-1.146442537763915, -4.784772997277115],
            [-1.1447365006293964, -4.786556270059386],
            [-1.1442911276515977, -4.793557536191623],
            [-1.148288345417261, -4.80856607349637],
            [-1.1544520624504755, -4.8155244833475885],
            [-1.1589386800508432, -4.816836700575921],
            [-1.1646409606826593, -4.810141660076877],
            [-1.1671538273896895, -4.811241272897281],
            [-1.1711302399169334, -4.82190172602405],
            [-1.1705688349113401, -4.8254307834068895],
            [-1.1658119199376233, -4.832876128739645],
            [-1.1674239120165173, -4.908860323267146],
            [-1.1700373850242476, -4.995773016707274],
            [-1.1725143873467014, -5.105997550985501],
            [-1.1741719194792442, -5.188397303334403],
            [-1.1755921657010022, -5.2569098031404575],
            [-1.235070466545421, -5.256080286306942],
            [-1.3359414424941443, -5.2542795323528235],
            [-1.4393298406230317, -5.251768897117404],
            [-1.542094662355958, -5.248792723207727],
            [-1.5405749645657414, -5.15478805680426],
            [-1.5397167091761337, -5.0962783643308125],
            [-1.5393171736902516, -5.08664908019272],
            [-1.5364806165869191, -4.969258384902676],
            [-1.5366104856663363, -4.964654573087472],
            [-1.534399765999676, -4.878425860582166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.2085238869435, "lat": 33.785511139802416 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48077"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01383824"
      },
      "bbox": [
        -1.542094662355958, -5.2569098031404575, -1.1375353609200396,
        -4.557364280584023
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6219823609011224, -11.860429457942871],
            [-1.5128534289964912, -11.863542733016176],
            [-1.4037232547860754, -11.866620124101178],
            [-1.3208324222533911, -11.86921084431668],
            [-1.3240850219729707, -12.029569679025336],
            [-1.299048201199046, -12.034000915371708],
            [-1.3062500477054677, -12.075624138853424],
            [-1.3095474714373372, -12.075394323808194],
            [-1.3105869482063606, -12.092423835246965],
            [-1.3065125970354885, -12.109837325094126],
            [-1.3248841089707075, -12.106476626741284],
            [-1.3329616948283471, -12.150245104920224],
            [-1.3367624239553875, -12.149582979137076],
            [-1.344585220362045, -12.191263260473471],
            [-1.258351907264715, -12.206458276903346],
            [-1.2583643207418884, -12.20807300628127],
            [-1.2168093601217178, -12.208552839573045],
            [-1.2173728633424334, -12.254898800544689],
            [-1.2181517737285437, -12.291358942273712],
            [-1.2204806070502017, -12.405759930510014],
            [-1.2217778107202637, -12.462112352769461],
            [-1.2220118695258027, -12.483748810219943],
            [-1.2232750821752556, -12.546737158665513],
            [-1.2233692639571256, -12.56086267350073],
            [-1.2248841929658727, -12.56142036369121],
            [-1.2299036678455382, -12.572955155852712],
            [-1.2318326095357726, -12.5724904718242],
            [-1.2373064870835775, -12.565627793251704],
            [-1.2467568833773588, -12.563348364261397],
            [-1.2477318044398285, -12.567510334617058],
            [-1.252542031426379, -12.569600671014816],
            [-1.2581869391875151, -12.568477678405026],
            [-1.267297601213561, -12.572512100632652],
            [-1.2777248678217403, -12.571432299765327],
            [-1.2837370985363517, -12.573114993641482],
            [-1.2873453025570745, -12.564750563507992],
            [-1.2910615305974058, -12.565374362641805],
            [-1.2904844401527962, -12.569693432462502],
            [-1.2871982159668534, -12.57300962444275],
            [-1.2905436463192705, -12.57609342059943],
            [-1.2935538759592053, -12.574450682140249],
            [-1.2984916697475846, -12.569227178788358],
            [-1.3036574997926158, -12.566988455222402],
            [-1.3099536755664118, -12.568666633723941],
            [-1.3118092306519156, -12.571231063797145],
            [-1.319508360334819, -12.57645140018784],
            [-1.3263423281376567, -12.570080208308271],
            [-1.329685149296993, -12.56851455344044],
            [-1.3318560530500754, -12.561238644049784],
            [-1.3369212063333995, -12.562443629627946],
            [-1.339361819633434, -12.567652637326148],
            [-1.3430930524521738, -12.568735463630428],
            [-1.345672744042026, -12.564710692635913],
            [-1.34995809670951, -12.562989405020351],
            [-1.358879193277304, -12.566741753746737],
            [-1.3616899891204137, -12.561748898105996],
            [-1.3640154696221989, -12.566887085514823],
            [-1.3691085126204199, -12.567626142537724],
            [-1.3726630513817957, -12.56101610098077],
            [-1.376103910776948, -12.561787216289918],
            [-1.3798851881899592, -12.569562236353537],
            [-1.3802772929432918, -12.575534445031309],
            [-1.3848748047262927, -12.585209954223265],
            [-1.3918675004259573, -12.582062121935309],
            [-1.3977721517427188, -12.581764606068317],
            [-1.4052737344158204, -12.579760091256487],
            [-1.4080514048212638, -12.58132081661339],
            [-1.4129587313907301, -12.587815728551638],
            [-1.418861384264905, -12.589193446318735],
            [-1.421807566944253, -12.583765999545346],
            [-1.4160329191463914, -12.582745610067938],
            [-1.4134318361778186, -12.580087153191169],
            [-1.412558651647256, -12.574765984403841],
            [-1.4135895020975746, -12.570905790784183],
            [-1.4169516448379378, -12.566540088041814],
            [-1.4181077147326655, -12.558609017581487],
            [-1.4216250027066468, -12.555737397821714],
            [-1.4265135691937143, -12.557301044864328],
            [-1.422701010293482, -12.560382346946422],
            [-1.4230400013301685, -12.562681923428542],
            [-1.4314341126779613, -12.566909482821481],
            [-1.43739536034317, -12.565714956512362],
            [-1.4443601620514082, -12.558533836281775],
            [-1.457343015024416, -12.56124213277982],
            [-1.465167092500295, -12.563507927442398],
            [-1.467489097854301, -12.558702157559326],
            [-1.4649673527753875, -12.55338093115527],
            [-1.4677605087841068, -12.551577000325075],
            [-1.471182932355083, -12.553487718279897],
            [-1.472712691912347, -12.557601619634708],
            [-1.4730057772902305, -12.563554903164494],
            [-1.4803542118814497, -12.575097228958814],
            [-1.4845477495973816, -12.57309673255119],
            [-1.484452856869601, -12.569002114414952],
            [-1.488083245144474, -12.56670125383988],
            [-1.493379384201402, -12.570807490078774],
            [-1.4962507240534488, -12.568467030763955],
            [-1.492384539704649, -12.564214064051184],
            [-1.4944761509006008, -12.560634834042613],
            [-1.501840206873797, -12.561674840991696],
            [-1.5041864693334688, -12.554665024865455],
            [-1.5083319557502912, -12.549832631051633],
            [-1.5119432651703388, -12.553029470607378],
            [-1.5114919738472652, -12.56433995082171],
            [-1.5158576571328637, -12.56046154686854],
            [-1.5201658744449604, -12.561002463942346],
            [-1.5233303714054411, -12.570418755659952],
            [-1.527181535805727, -12.569669154005927],
            [-1.5297235273889018, -12.566976017991465],
            [-1.5345005083800805, -12.557620197553359],
            [-1.542237626838931, -12.55421834933824],
            [-1.5450721982026359, -12.549621071806884],
            [-1.548505132852213, -12.547578322780703],
            [-1.5570270527306795, -12.54671770572388],
            [-1.5740341469965011, -12.55127453613994],
            [-1.5759974580326186, -12.549248214404168],
            [-1.5767622468324698, -12.544269807147357],
            [-1.5868168097824853, -12.538927662255823],
            [-1.5913702577433104, -12.53042759830421],
            [-1.5992028784796883, -12.524790662866646],
            [-1.6075049166618534, -12.521218002020776],
            [-1.6078056846136595, -12.516913242958086],
            [-1.6025853389428406, -12.516069708775582],
            [-1.5948485325363808, -12.51769585072981],
            [-1.5924998997457172, -12.516924985762783],
            [-1.5933737564662886, -12.510016429896108],
            [-1.5889726589600408, -12.507707690915852],
            [-1.5908269406914115, -12.50387367118577],
            [-1.5964667130525105, -12.50826179886383],
            [-1.6121598124093002, -12.503341942829257],
            [-1.6184639657861974, -12.505352981855859],
            [-1.6221065431335913, -12.513465974183744],
            [-1.6180390870201344, -12.518339049808066],
            [-1.6222906473406802, -12.520809439902953],
            [-1.625605995615967, -12.518856998524523],
            [-1.6290477955587026, -12.508416914347126],
            [-1.6377350078615478, -12.505430060700078],
            [-1.6408747986769743, -12.502077310634984],
            [-1.6507769769234115, -12.48599404328717],
            [-1.6497744452063876, -12.482439656951229],
            [-1.6436132462458486, -12.481797154455947],
            [-1.6441584188204836, -12.479337437066746],
            [-1.6501746291207453, -12.477932683436626],
            [-1.6533536831324556, -12.472641355151357],
            [-1.648552245486579, -12.46553700709121],
            [-1.6496629314083067, -12.45896537039753],
            [-1.6567219197833372, -12.457246345186771],
            [-1.6610323882205593, -12.45975319364141],
            [-1.6631287924537, -12.47119752762312],
            [-1.6659600210959655, -12.472554442702855],
            [-1.6697791078634943, -12.467441459943164],
            [-1.671248786544137, -12.462836338220306],
            [-1.6702025690318423, -12.456447270023327],
            [-1.6722233182435697, -12.451907835714938],
            [-1.6784308371858792, -12.455149401297396],
            [-1.6772465595773236, -12.464499629696283],
            [-1.6809549679976743, -12.466407081244055],
            [-1.6944115900147392, -12.466555853443598],
            [-1.697339315132292, -12.464818566699662],
            [-1.7015067062187734, -12.456721466024707],
            [-1.7110290226908833, -12.450014993959932],
            [-1.7104232262650914, -12.443963559626406],
            [-1.712323174285433, -12.440971476082472],
            [-1.724654972877217, -12.438647535248075],
            [-1.7300700883653168, -12.432477864916313],
            [-1.7347076931056247, -12.42924729042477],
            [-1.746377073820746, -12.42405792306819],
            [-1.7479840998167886, -12.42183235660114],
            [-1.7471358146667482, -12.417669126322902],
            [-1.743062361608881, -12.412738113136749],
            [-1.7437934466093805, -12.404467286123051],
            [-1.7465396037830947, -12.400318923626696],
            [-1.7494618947975966, -12.399532465542062],
            [-1.7583953488035033, -12.40508505533834],
            [-1.7600591390398717, -12.398366299325774],
            [-1.7639463171006091, -12.397798126688452],
            [-1.7709970206896004, -12.402560143856501],
            [-1.781176070534927, -12.40358277036811],
            [-1.7833376871087612, -12.411036265016874],
            [-1.7890754285862946, -12.40938906437031],
            [-1.7983860536798262, -12.412470059705996],
            [-1.8036034425281935, -12.413043948587255],
            [-1.8044611220873534, -12.41044896228554],
            [-1.7985883028136316, -12.400393356906942],
            [-1.808146260116157, -12.395512395868025],
            [-1.8110559959415073, -12.39522118317233],
            [-1.8175990276250387, -12.400519741274103],
            [-1.8215398009594244, -12.397404540655666],
            [-1.8210641922828803, -12.393562920751402],
            [-1.817193238626915, -12.38991584880062],
            [-1.8195259246601356, -12.386914838573754],
            [-1.8242964771979542, -12.394384797361598],
            [-1.8284916979650614, -12.396332434168887],
            [-1.8311749351327886, -12.394211501415008],
            [-1.8319004822032432, -12.390695052551637],
            [-1.8366083254693888, -12.37981255437446],
            [-1.8381610797803234, -12.377737176997005],
            [-1.8471969959264765, -12.374637028645763],
            [-1.8498113922212305, -12.37797128412639],
            [-1.844585471527686, -12.380808968868564],
            [-1.840269580463758, -12.3807486581534],
            [-1.8389311901922316, -12.38288721240549],
            [-1.840245729423986, -12.38726417633784],
            [-1.8496050335421563, -12.390511395842335],
            [-1.8511737541179143, -12.395089597098838],
            [-1.8563764945816088, -12.394334468138469],
            [-1.8555881886964258, -12.388600247862094],
            [-1.8560921791483513, -12.382999355268538],
            [-1.8584184214116308, -12.380082576974411],
            [-1.864340323738182, -12.382814440576185],
            [-1.866761988104391, -12.387353576805255],
            [-1.8697355641707025, -12.386149888434257],
            [-1.8741608107917669, -12.377582435906215],
            [-1.8693398161382375, -12.372173729834477],
            [-1.8693655093422679, -12.368085804830818],
            [-1.8750541655525823, -12.36418427809391],
            [-1.8748711046013742, -12.363490785653891],
            [-1.8442852810315047, -12.303643966758655],
            [-1.8187790315656995, -12.252937155120255],
            [-1.8182409187595316, -12.251455757823338],
            [-1.7881220521671009, -12.191384723120716],
            [-1.7788269361203972, -12.172450301835962],
            [-1.771702119365532, -12.16101360834405],
            [-1.7602476360478434, -12.137389599459421],
            [-1.7247323126570582, -12.069574126506787],
            [-1.673342794585315, -11.965042340171983],
            [-1.6219823609011224, -11.860429457942871]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.18120266711553, "lat": 26.39692044267922 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48215"],
        "coty_name": ["Hidalgo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hidalgo County"],
        "coty_fp_code": "215",
        "coty_gnis_code": "01383893"
      },
      "bbox": [
        -1.8750541655525823, -12.589193446318735, -1.2168093601217178,
        -11.860429457942871
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.17386925809868, -7.152893942261934],
            [2.1863690665868827, -7.149688231786473],
            [2.1940579597279983, -7.142335889993444],
            [2.2001943498171848, -7.137604871195865],
            [2.2065974693886523, -7.135607164567112],
            [2.2107165384701135, -7.131341013990025],
            [2.218254422447922, -7.131016118172744],
            [2.2237838325850565, -7.129765367076659],
            [2.227204559096799, -7.122125859105193],
            [2.245245496220602, -7.109213098817336],
            [2.248704767635519, -7.113123858679752],
            [2.2526329274083037, -7.113783936509326],
            [2.2573099671467944, -7.119197303129107],
            [2.2648346135769954, -7.121763600525632],
            [2.2737646265059395, -7.122446126933499],
            [2.2780601926918824, -7.127676297219526],
            [2.28247589833581, -7.127082229733478],
            [2.289036810849832, -7.128953232212829],
            [2.2899469267251313, -7.131241936013768],
            [2.300342029273213, -7.1333994511307734],
            [2.3043675243614743, -7.1401409898902495],
            [2.3071129751077097, -7.140953742662893],
            [2.314679664515795, -7.148289839037618],
            [2.3115250141562664, -7.150463351887447],
            [2.3121912641045754, -7.155568378667852],
            [2.3161037017940442, -7.15752115993902],
            [2.3129959986765796, -7.161005969136058],
            [2.318934688217441, -7.168508700204472],
            [2.32210937514365, -7.169111785710738],
            [2.323840654484938, -7.172554828488793],
            [2.331082714276658, -7.176885767393633],
            [2.332798156924565, -7.184644388155112],
            [2.3394848818184215, -7.1877496395975395],
            [2.341781005375737, -7.191113275704128],
            [2.347642582335141, -7.192930593502374],
            [2.3653083619917967, -7.193965125201176],
            [2.369718834569399, -7.187951233449686],
            [2.373642179655709, -7.188168052228988],
            [2.3799199513623255, -7.190707646141319],
            [2.3819927603426376, -7.198957658570864],
            [2.379217637163638, -7.201069606197107],
            [2.3881668755111303, -7.204098465220082],
            [2.395504280570502, -7.202782680141256],
            [2.405100425937921, -7.202083878804143],
            [2.4068162307375855, -7.2067417018774265],
            [2.400558009082745, -7.212999482229923],
            [2.3970350616548184, -7.221117466814475],
            [2.3964368755444223, -7.224843810655005],
            [2.393713220740863, -7.228198133087697],
            [2.387551094751711, -7.230223015510127],
            [2.381700145151886, -7.233829066342894],
            [2.3788757118307755, -7.231800521044983],
            [2.375546282174459, -7.2327774317773805],
            [2.378843290962305, -7.239290889279373],
            [2.3763122696925434, -7.242649839808809],
            [2.3756066954649913, -7.248761062300571],
            [2.382159205555235, -7.2514319818199695],
            [2.3911324703654033, -7.259567670092109],
            [2.3992302319639247, -7.2633380920123525],
            [2.4028462570581266, -7.259656009395811],
            [2.4070698031570212, -7.262740893376972],
            [2.4101655620893725, -7.259839906885188],
            [2.4146081400017843, -7.260981697746529],
            [2.4144312142472724, -7.263489203329449],
            [2.4103926381223992, -7.271491969004212],
            [2.4133114377304654, -7.276119631160011],
            [2.424525323567805, -7.275615237749447],
            [2.424720526969669, -7.277963255354259],
            [2.420644839534463, -7.287814600916203],
            [2.4148631707035775, -7.297424360982877],
            [2.414886709475132, -7.305410480945193],
            [2.417701935813656, -7.306883726396178],
            [2.4225836467587034, -7.306708698832049],
            [2.429268697623481, -7.3111588643988386],
            [2.435195498884284, -7.317706241317046],
            [2.4413573836760496, -7.317918395879724],
            [2.4445616894511124, -7.326663168440485],
            [2.446334426071682, -7.34272086810859],
            [2.4426930195603718, -7.346628286968842],
            [2.4455522640253387, -7.34966467569983],
            [2.4570005054090176, -7.347732465118073],
            [2.463531206951712, -7.344348058289459],
            [2.4716433837984675, -7.343215503070819],
            [2.4669898447618954, -7.351863028578519],
            [2.4656926633435314, -7.3562474215773275],
            [2.4472840174600217, -7.362256743411531],
            [2.4464016838213882, -7.364709779524749],
            [2.4473053120131536, -7.375606667845573],
            [2.4403192597038426, -7.384857746220422],
            [2.4432520228442147, -7.389064838602324],
            [2.4423010738724438, -7.393206781548354],
            [2.43731003455432, -7.395243259629052],
            [2.431826922440399, -7.405620239704011],
            [2.4327673010816766, -7.410245747006445],
            [2.4352682226061657, -7.413565164583956],
            [2.4426048523393837, -7.414115247977896],
            [2.4495374759717436, -7.417914913369588],
            [2.4563331845922587, -7.432773016001224],
            [2.4639024655959836, -7.430240533757178],
            [2.4669779000050522, -7.432747306921484],
            [2.470040282178394, -7.442764775677437],
            [2.474705400622339, -7.444527300672447],
            [2.4880980721613635, -7.441849002525389],
            [2.4902525754704263, -7.442824795238569],
            [2.491718027278379, -7.449975214136516],
            [2.4953920127943134, -7.452230965015781],
            [2.4948091417990605, -7.457547811409677],
            [2.495896411081875, -7.46198888209836],
            [2.49005822953958, -7.4641137314039145],
            [2.4943531957569016, -7.469030406410552],
            [2.494618268508484, -7.476037682544614],
            [2.492983850405342, -7.480500324454462],
            [2.4994391266327076, -7.481288134736575],
            [2.5012114692571648, -7.485362301113301],
            [2.509955277452239, -7.482075292710116],
            [2.5114022563660408, -7.485135267531739],
            [2.5095317063673046, -7.488968055112812],
            [2.5126078883911562, -7.493197285471016],
            [2.5062660395204905, -7.496141732118231],
            [2.506085023519293, -7.502498568453181],
            [2.503025491246814, -7.507819540588185],
            [2.5078054488128134, -7.513680897159478],
            [2.5082864314398168, -7.5259753636888105],
            [2.507732589434949, -7.530452124298884],
            [2.50971404749089, -7.536753952717305],
            [2.3957285176677643, -7.54736556389189],
            [2.3004179771151527, -7.555952195509179],
            [2.245155734433161, -7.560943753762467],
            [2.1825624118659768, -7.576016286005257],
            [2.1365829618182643, -7.5869134912183185],
            [2.1340424121778536, -7.585793609947202],
            [2.1327953386948892, -7.581912673550329],
            [2.128360924942517, -7.575815570069304],
            [2.127997749383973, -7.569980514594521],
            [2.1295169647988805, -7.566555260164886],
            [2.1333713911168606, -7.551786594270195],
            [2.136008163815534, -7.545288723067296],
            [2.1363222775766673, -7.538584442664169],
            [2.13592263053717, -7.513701886002277],
            [2.1352466872776326, -7.503920311674877],
            [2.138909248011043, -7.4885035723377635],
            [2.1422418083404433, -7.481501843508634],
            [2.14259867985436, -7.470247748314166],
            [2.141611766527015, -7.464776334357234],
            [2.137521891270434, -7.4588847719943425],
            [2.1375544163820708, -7.455951030906711],
            [2.1347633658373235, -7.44829368161638],
            [2.135198519580283, -7.441376217764326],
            [2.133589068242793, -7.434110236696676],
            [2.130163349722362, -7.431598271645785],
            [2.1263628575699984, -7.426278806537917],
            [2.128941241181702, -7.420275652503492],
            [2.1277505283717915, -7.415255089768344],
            [2.130563819155866, -7.407591343945044],
            [2.1285971420732945, -7.401073232271981],
            [2.129000168790046, -7.398055584325429],
            [2.134103985934253, -7.389319941518626],
            [2.130102957342847, -7.381849448551586],
            [2.1339337677430126, -7.376816012739373],
            [2.13747741317414, -7.366529251550289],
            [2.1403136586721776, -7.362009447514901],
            [2.145777778545676, -7.358251725695934],
            [2.1457522018316615, -7.350787541663877],
            [2.142383949948456, -7.340717493693343],
            [2.1382326558445235, -7.334941871006932],
            [2.135901451354986, -7.327948560133037],
            [2.126522407008386, -7.312706215146399],
            [2.1630862358722216, -7.273729250480569],
            [2.177106602063354, -7.255748337245472],
            [2.1768164748803556, -7.242067728913161],
            [2.17386925809868, -7.152893942261934]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.85169823257307, "lat": 31.34324588561106 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48403"],
        "coty_name": ["Sabine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sabine County"],
        "coty_fp_code": "403",
        "coty_gnis_code": "01383987"
      },
      "bbox": [
        2.1263628575699984, -7.5869134912183185, 2.5126078883911562,
        -7.109213098817336
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.4148978094793336, -5.289820489344408],
            [-2.3833351141010377, -5.29107429097957],
            [-2.2553148659175237, -5.295830337999176],
            [-2.1272939711101952, -5.300570947238485],
            [-1.9852562058145504, -5.305782726622934],
            [-1.9872081699735935, -5.370555202823797],
            [-1.9883857165697345, -5.417602273726948],
            [-1.991356711922333, -5.536614728350757],
            [-1.9927040095461022, -5.592512516576727],
            [-1.9950550335835644, -5.689654145024422],
            [-1.9964851551213156, -5.747090689077343],
            [-2.055616643920327, -5.7453165833743896],
            [-2.117447477381332, -5.743141570612936],
            [-2.137500643940732, -5.742424752958769],
            [-2.1419162396784768, -5.742967551474825],
            [-2.229894485307644, -5.739414221704073],
            [-2.4088073757073034, -5.73321212205183],
            [-2.4301603090441306, -5.732399602610492],
            [-2.4255050965224605, -5.597519258340726],
            [-2.417611976892559, -5.367805256515432],
            [-2.4148978094793336, -5.289820489344408]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.2123516675035, "lat": 33.17749622061745 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48447"],
        "coty_name": ["Throckmorton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Throckmorton County"],
        "coty_fp_code": "447",
        "coty_gnis_code": "01384009"
      },
      "bbox": [
        -2.4301603090441306, -5.747090689077343, -1.9852562058145504,
        -5.289820489344408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.005284366394816, 2.902989290706283],
            [-9.999736894093509, 2.9036489285749565],
            [-9.996642242858965, 2.895538715688479],
            [-9.987828544618413, 2.896340007048113],
            [-10.026520058772585, 2.6359028469490595],
            [-10.047955315600813, 2.4916283279119154],
            [-10.069407886662061, 2.347165667381023],
            [-10.079667356482238, 2.2780625830797483],
            [-10.09274737281975, 2.1899803579672574],
            [-10.136435694169915, 1.8957906395962805],
            [-10.201596826443554, 1.9055339579586605],
            [-10.411154674091046, 1.937517989320297],
            [-10.543859539249153, 1.957791068191307],
            [-10.54310140815284, 1.9626976416719661],
            [-10.739868868726099, 1.9943899758351717],
            [-10.798220102731973, 2.004094886171484],
            [-10.784540818924658, 2.090181408201599],
            [-10.810084818409052, 2.0941552946697164],
            [-10.781407821804553, 2.276199944686246],
            [-10.784766462545132, 2.2767128470660594],
            [-10.750897219480207, 2.4929042850655003],
            [-10.730066826463295, 2.6241498101403633],
            [-10.734779732953369, 2.6248949934014245],
            [-10.72791343456105, 2.66802343351293],
            [-10.694531078596155, 2.8744774051362105],
            [-10.693395481056525, 2.8808149829442655],
            [-10.694839133342388, 2.8872150517549184],
            [-10.69274994009187, 2.8913020663814653],
            [-10.691501958404865, 2.898656823497426],
            [-10.689022705573144, 2.8997971594187226],
            [-10.68508962946138, 2.9046394427100393],
            [-10.676686528931299, 2.9064801857272156],
            [-10.678232606411907, 2.9107419319530172],
            [-10.682451230042766, 2.914770708902641],
            [-10.680384703150885, 2.917903686715902],
            [-10.674900127000605, 2.917056901714284],
            [-10.667455874540991, 2.917255902470134],
            [-10.659391030244079, 2.909231761888729],
            [-10.652911147634676, 2.908707292303483],
            [-10.647315620855117, 2.9109686317575028],
            [-10.642123551586888, 2.904771224730292],
            [-10.636823355677707, 2.90193449967977],
            [-10.631765849089401, 2.8934424340552036],
            [-10.619200132602419, 2.8925867713759015],
            [-10.614811450980357, 2.8937766853876954],
            [-10.608407063686386, 2.8984867552838174],
            [-10.598726203314966, 2.9091503077540537],
            [-10.59227933126222, 2.9085447399199063],
            [-10.584419999591784, 2.913101039861886],
            [-10.584578618925505, 2.917563918206968],
            [-10.577142302617357, 2.918038458719124],
            [-10.57200345649902, 2.9220402855049556],
            [-10.566726041232583, 2.9181767554486537],
            [-10.559590155965495, 2.9191995298704585],
            [-10.555707264823242, 2.9168819332098614],
            [-10.550906293280406, 2.916476644575238],
            [-10.548470922492495, 2.91954673788302],
            [-10.54224347697604, 2.9224927304077446],
            [-10.53425569660077, 2.915605935445911],
            [-10.531644962520257, 2.9144909798211813],
            [-10.528282292111664, 2.9089123188567214],
            [-10.523119187549113, 2.907703365208729],
            [-10.517884147533652, 2.9046823425563746],
            [-10.511791887016596, 2.906527655814223],
            [-10.5033968570806, 2.9037753088938687],
            [-10.495402482725378, 2.9104539856095024],
            [-10.493762350491386, 2.915705983362864],
            [-10.49031080039883, 2.916585435560302],
            [-10.48357791673862, 2.9236582672056457],
            [-10.482428951880399, 2.926171104110555],
            [-10.475865753232402, 2.9292699685711807],
            [-10.472720544723781, 2.927781906884775],
            [-10.471514873959386, 2.924289739420323],
            [-10.463926937400979, 2.916318884330436],
            [-10.458183068093549, 2.9138078322737195],
            [-10.45456555448329, 2.9141454973557654],
            [-10.449649701658105, 2.9174830939965033],
            [-10.445323076658788, 2.9176616778009192],
            [-10.443745950810685, 2.913231177596575],
            [-10.44098496169419, 2.9107419943263535],
            [-10.436104676974463, 2.9097625036634005],
            [-10.43036017875805, 2.9104448714444486],
            [-10.422322956600285, 2.9156092288071447],
            [-10.416802409571867, 2.924489402181609],
            [-10.411982778425754, 2.92131846403091],
            [-10.407180129443667, 2.9203049405351984],
            [-10.403354001655593, 2.9110291645095545],
            [-10.401539074076558, 2.909701294960021],
            [-10.39118995362379, 2.9119053393961356],
            [-10.387512271901851, 2.9117784826028816],
            [-10.381051649742426, 2.9138078454208096],
            [-10.375869985758452, 2.918356405298233],
            [-10.37144951728386, 2.924069541377725],
            [-10.367580044374108, 2.9182198491101414],
            [-10.361864054207633, 2.914123412299962],
            [-10.358465671469697, 2.914357741801925],
            [-10.35254082379026, 2.9180448963467676],
            [-10.34887173690125, 2.9235684979112255],
            [-10.346707257008658, 2.9215772381297427],
            [-10.34054703238516, 2.9203156699246935],
            [-10.3355255568152, 2.9169269363638772],
            [-10.331316249517734, 2.9160032672389504],
            [-10.325486544271278, 2.9262137976174634],
            [-10.323128058142816, 2.928681019516249],
            [-10.314363193590749, 2.9196215528047404],
            [-10.309474137929413, 2.9188338728526237],
            [-10.302981373708738, 2.9209809690312776],
            [-10.29001646159467, 2.9187734727374623],
            [-10.280159396975868, 2.9227220828324922],
            [-10.275006715282947, 2.925813988099798],
            [-10.267941020047425, 2.931493511265866],
            [-10.26447688581199, 2.9367955539732202],
            [-10.265193536932225, 2.9438361077028032],
            [-10.25764442874825, 2.9507068590897396],
            [-10.246876253605414, 2.945127976226084],
            [-10.237750711424423, 2.9461279998497276],
            [-10.23608747112337, 2.9477136340891823],
            [-10.226538554346208, 2.9490786686466497],
            [-10.222107571373316, 2.9547876759132925],
            [-10.219265513729118, 2.9551194831066963],
            [-10.21758220662755, 2.950008933677285],
            [-10.210557697390522, 2.9488864358170366],
            [-10.203090134497023, 2.9519707730501867],
            [-10.195700867007346, 2.952989674002214],
            [-10.191596917975552, 2.9502810406276283],
            [-10.185953591709056, 2.9493653819394434],
            [-10.179366856385021, 2.9437875957369957],
            [-10.172431056232474, 2.945407986061886],
            [-10.171802431560883, 2.9420091279115663],
            [-10.167216922388624, 2.9392855666242057],
            [-10.162877855095958, 2.940458650456586],
            [-10.159098403722528, 2.9387380014718767],
            [-10.153955009855496, 2.933455435492049],
            [-10.142714473071258, 2.9344143317844535],
            [-10.139204891923841, 2.9295668433046442],
            [-10.131315170724532, 2.924922941681995],
            [-10.127990341250577, 2.9275998291205747],
            [-10.121522430666268, 2.9277860306366748],
            [-10.114280743374284, 2.922950040092909],
            [-10.11339432753881, 2.9189481972649447],
            [-10.107466493325074, 2.91539139438797],
            [-10.09847515943603, 2.9181423937415794],
            [-10.097337174896401, 2.915341651435316],
            [-10.093615816384482, 2.9134277866239295],
            [-10.08787996658026, 2.9130666842066946],
            [-10.081965077939971, 2.908528344967964],
            [-10.07071988774264, 2.9100501950861446],
            [-10.061395163206084, 2.9076214811016983],
            [-10.052488181405476, 2.9105464763023945],
            [-10.043046644980127, 2.9074470362662153],
            [-10.035591603349147, 2.9145368505723868],
            [-10.031423824849448, 2.9115815321354757],
            [-10.022779226747042, 2.9126141988648837],
            [-10.019417850174587, 2.9102528696715226],
            [-10.016525315491986, 2.9054981276977765],
            [-10.005284366394816, 2.902989290706283]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.42517248831264,
          "lat": 40.298264820888754
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49013"],
        "coty_name": ["Duchesne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Duchesne County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01448021"
      },
      "bbox": [
        -10.810084818409052, 1.8957906395962805, -9.987828544618413,
        2.9551194831066963
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.782409437827539, -0.0592891382863158],
            [12.796536619593184, -0.06866904619756933],
            [12.812603958760018, -0.06694602055085497],
            [12.815084157842668, -0.068134987782014],
            [12.818959279030931, -0.06438436294154522],
            [12.825128765743187, -0.0648065146750226],
            [12.826979713581768, -0.0717748151217902],
            [12.833204205424593, -0.07582952688164663],
            [12.846870432739706, -0.08034734541226442],
            [12.851657825712298, -0.07390370698019172],
            [12.861447063998392, -0.06687546470059579],
            [12.87312509191276, -0.0492305487820831],
            [12.885862769326621, -0.04300199482582036],
            [12.887635011860358, -0.03989631622585384],
            [12.893756638283579, -0.03605918886665437],
            [12.897853018454352, -0.03133514129094807],
            [12.89816939974665, -0.027512673403659947],
            [12.904529586341543, -0.023246880977003507],
            [12.910901900008044, -0.017680705656192536],
            [12.91759191516481, -0.010217394939504914],
            [12.922529983050927, -0.002362102846417427],
            [12.934092611650817, -0.01355986159609417],
            [12.926718177377252, -0.023905348063537932],
            [12.93255220274007, -0.03760842954728565],
            [12.991354875046298, -0.10936237080005899],
            [12.98902247449541, -0.11089037371320401],
            [12.98005022717461, -0.1246568083609165],
            [12.977582994621919, -0.13089546952824654],
            [12.973017012773639, -0.13869220296687812],
            [12.965741459999022, -0.1481153774870511],
            [12.96461942878909, -0.16467451233672314],
            [12.960412247910417, -0.17175949231416432],
            [12.958112911442772, -0.18019602016691808],
            [12.955470703935772, -0.18603779671737544],
            [12.955552493079344, -0.19148297634797024],
            [12.95019745088855, -0.21405270366959844],
            [12.947660063082086, -0.22054686409702218],
            [12.941537504732736, -0.22748519040366716],
            [12.93599725696833, -0.23582564444321677],
            [12.935144709226167, -0.23977561910088327],
            [12.930572170397237, -0.24457200345546634],
            [12.920740128768543, -0.2534000108353417],
            [12.918487348184508, -0.2566194570476279],
            [12.913637725724127, -0.2599619915436674],
            [12.910111938884539, -0.26526497750579503],
            [12.886597546483669, -0.2859958688899938],
            [12.8814363791644, -0.2911924718883647],
            [12.880307226300838, -0.29393638741657047],
            [12.840082603253288, -0.30498813792643026],
            [12.839029978739918, -0.30941076043576693],
            [12.832076689196544, -0.3170230994247907],
            [12.827439685056643, -0.320096807663889],
            [12.82240471825196, -0.32184953465255356],
            [12.814216595960188, -0.33097391671374193],
            [12.805811421525252, -0.33793425119722204],
            [12.802447632395209, -0.34492603571762037],
            [12.798182693241923, -0.34971144157011425],
            [12.79101710352595, -0.348360447575779],
            [12.758253886006102, -0.33782912962175804],
            [12.744996210599977, -0.3306272262444986],
            [12.7421603894377, -0.33411685585774437],
            [12.737021833405693, -0.34337566671456765],
            [12.72753117885341, -0.35363550677060174],
            [12.717745971766131, -0.36149213414948556],
            [12.708861720178755, -0.3676265559255443],
            [12.703089404405919, -0.37311286487530093],
            [12.693194147561126, -0.3805588853204939],
            [12.682681368305266, -0.3858077319509077],
            [12.671251414913213, -0.39654887725494586],
            [12.665787513578131, -0.3912221285205009],
            [12.661933625896511, -0.3944398683247693],
            [12.659421400136155, -0.3923893336447099],
            [12.65628459477596, -0.38289618051111135],
            [12.663434144286017, -0.3739269379869148],
            [12.621088134612792, -0.2949110761996514],
            [12.626889605830694, -0.2915352258642365],
            [12.631708070039771, -0.28447393462838194],
            [12.636030022338838, -0.2819471278656866],
            [12.641829661777228, -0.2768066908849599],
            [12.653368788260709, -0.2628739943826564],
            [12.66936113652229, -0.24953612316439194],
            [12.671309362171197, -0.24717459151021481],
            [12.683429825058266, -0.23692329564673667],
            [12.691023706150546, -0.23187439280857033],
            [12.696851528416772, -0.2248351147138369],
            [12.693201316781863, -0.2204478996200424],
            [12.709865087074018, -0.21023918677319156],
            [12.718708738281869, -0.2071347690616363],
            [12.726701250335687, -0.20054702850409323],
            [12.734791759656995, -0.19510480071461997],
            [12.741291020469967, -0.18850277744614158],
            [12.750579975593693, -0.16110780981837125],
            [12.742911618706806, -0.1593282568080656],
            [12.730714173563149, -0.17070211932127402],
            [12.71300758079983, -0.16457707408664138],
            [12.714563438252041, -0.16045071423818422],
            [12.723972352823964, -0.15468921209277736],
            [12.72522479195639, -0.15231135853551367],
            [12.709750656278919, -0.1363831412353571],
            [12.733383210868325, -0.11764857177040691],
            [12.7418992050227, -0.10935738747049675],
            [12.750320512519508, -0.10214853599822084],
            [12.7584372297625, -0.0963387610239439],
            [12.764407472248905, -0.08856485044896484],
            [12.770957526630093, -0.08250951837899488],
            [12.779802221890955, -0.06761804600717312],
            [12.782409437827539, -0.0592891382863158]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.21146009884085, "lat": 37.48166187681673 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51045"],
        "coty_name": ["Craig"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Craig County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01673664"
      },
      "bbox": [
        12.621088134612792, -0.39654887725494586, 12.991354875046298,
        -0.002362102846417427
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.074436789591894, 0.6334562433466435],
            [15.078497605915878, 0.633878634132023],
            [15.07995802259057, 0.6382697014699087],
            [15.0829697582041, 0.6392954704491346],
            [15.089491846923154, 0.6347725828781966],
            [15.087826036186485, 0.6306675136810335],
            [15.089315996578069, 0.6279521068416052],
            [15.096189615264455, 0.6266538166191022],
            [15.100802986091125, 0.628872343532975],
            [15.10221035685717, 0.6238416235261268],
            [15.099027238933532, 0.6192212241512306],
            [15.092210322127489, 0.6172720852751635],
            [15.091737384594563, 0.6125640668754864],
            [15.095926283701575, 0.6108593019680316],
            [15.09910445115602, 0.6154640348068989],
            [15.103702340138295, 0.6132805372718972],
            [15.108063734625045, 0.6133578932233682],
            [15.112385412811118, 0.6158932974399209],
            [15.116610864000148, 0.6149025145660205],
            [15.115955106465664, 0.6105033546242562],
            [15.11265126535936, 0.6088295693454331],
            [15.112239008958424, 0.6044588675895126],
            [15.114223147595336, 0.6006441521458816],
            [15.119767732200444, 0.5970171248429411],
            [15.123467002506201, 0.591090968373559],
            [15.129174367676645, 0.5905295380563504],
            [15.13181344418773, 0.5870096064953862],
            [15.132120703512083, 0.5833231851447054],
            [15.130104845318353, 0.5763171196612773],
            [15.134482504999589, 0.5748404120201404],
            [15.139989548214231, 0.5654653206941296],
            [15.137593073010706, 0.5596061102499817],
            [15.143917827223763, 0.5583187529381994],
            [15.146474278075473, 0.5649273914983376],
            [15.15239397583307, 0.5685293198914882],
            [15.15810762005793, 0.5662476126568747],
            [15.160428685378609, 0.558630321959427],
            [15.155705810117343, 0.5561435677345388],
            [15.152714412692461, 0.5565070094235338],
            [15.150336941574116, 0.5531974202403153],
            [15.15104482487933, 0.5485543413709428],
            [15.155501527280578, 0.540967505535209],
            [15.160852981673981, 0.5401155195274641],
            [15.163507752188503, 0.5379167650622088],
            [15.16750914637146, 0.5396443850031636],
            [15.172215022837486, 0.5394860482259441],
            [15.175175057200317, 0.5358874577463593],
            [15.177292835471974, 0.5371408781604028],
            [15.180603296039468, 0.5328364144096066],
            [15.181311480138348, 0.5269056367539999],
            [15.177101369236105, 0.5243008651406164],
            [15.174445573456287, 0.5181778255951516],
            [15.17294851307296, 0.5111616790306177],
            [15.179311573086368, 0.5056956128453255],
            [15.18877739531986, 0.5105126499352889],
            [15.196331930340422, 0.5115795098892657],
            [15.19806008247465, 0.5080581760419453],
            [15.201605478691548, 0.5070219876129222],
            [15.207160670181228, 0.4981206341529647],
            [15.218964644710363, 0.4910318470309725],
            [15.222131798179479, 0.48722587189582534],
            [15.227614064451952, 0.4906271323274288],
            [15.239486815043895, 0.4918619818614532],
            [15.24252265916106, 0.48584586249774553],
            [15.248156663712399, 0.4810412209652986],
            [15.252548448363745, 0.4793995859043268],
            [15.264159699650467, 0.4804799273255829],
            [15.268550145702708, 0.4839040901173147],
            [15.271997172997889, 0.48179263892474244],
            [15.274971984297252, 0.47555260454513],
            [15.276101151675224, 0.4694254058974267],
            [15.282520181077512, 0.4663224047873317],
            [15.287723306136934, 0.4667761152841877],
            [15.303099021102346, 0.4710864240394026],
            [15.309435030233747, 0.47368871003019386],
            [15.314782155554605, 0.47959298650012494],
            [15.318011744793637, 0.47836033865466066],
            [15.319426755268388, 0.4697583164894456],
            [15.324024164341228, 0.46384444040609457],
            [15.326498509316156, 0.4626756896773564],
            [15.329981645972811, 0.4572451701573665],
            [15.326548444878842, 0.4453229704818599],
            [15.327835687168914, 0.44270579913763963],
            [15.331972268845169, 0.44138083909399645],
            [15.338371885140015, 0.44272648176828744],
            [15.346771015623968, 0.4473967069317175],
            [15.353578700741938, 0.4476150231293696],
            [15.366410631296331, 0.43687335613277606],
            [15.372338378132008, 0.4338124718306389],
            [15.37691058915885, 0.4281150032862006],
            [15.375575457776234, 0.42223478238454765],
            [15.367923236671077, 0.41710289839688264],
            [15.367484611844972, 0.41337953279212086],
            [15.369669309680912, 0.41101384426255155],
            [15.381187431381417, 0.4091477771082571],
            [15.385071218745486, 0.4103831214102074],
            [15.390605656425572, 0.4150438104639356],
            [15.39393912275651, 0.4132123289882085],
            [15.39860250113815, 0.40582851417007737],
            [15.402396375199068, 0.4050066603842793],
            [15.412026268722258, 0.4069888586996115],
            [15.412697782961533, 0.4020283747401449],
            [15.408680315450423, 0.40060967083472243],
            [15.406341256505147, 0.3974411341811101],
            [15.406954894996964, 0.3939200561616291],
            [15.409704519375596, 0.39218503229611784],
            [15.416912861838219, 0.3910078343984331],
            [15.427130464198163, 0.3954816087760479],
            [15.431155923092303, 0.3942982134998714],
            [15.433285074933462, 0.3915493491050673],
            [15.433500094170602, 0.38690653781504775],
            [15.43107373036352, 0.38031572333499003],
            [15.434468648151046, 0.37560480009700103],
            [15.43905301346117, 0.37669657534476325],
            [15.443272683099016, 0.3758852994289341],
            [15.445805583419832, 0.3730781537524892],
            [15.451547043195918, 0.3633701102637575],
            [15.453237735556408, 0.35900604659057544],
            [15.452879110283552, 0.3541259167692939],
            [15.447104395022464, 0.34378165333895083],
            [15.450875960586394, 0.3346529863693578],
            [15.451715797720095, 0.32946404775391414],
            [15.448373382391267, 0.32386853856454034],
            [15.441360976813186, 0.32813214326402496],
            [15.435001097973334, 0.33495308411396374],
            [15.424692936568432, 0.3493305867842615],
            [15.421823085753768, 0.3523188892401096],
            [15.416807081041208, 0.3532366572810011],
            [15.414900735538687, 0.3513398971235944],
            [15.413041699290451, 0.34077662986961316],
            [15.401396446068736, 0.3230082388754233],
            [15.397145651157555, 0.318858673093313],
            [15.391204992604816, 0.31843440566793996],
            [15.379940178334781, 0.32306170115937066],
            [15.380087960403905, 0.330494479258637],
            [15.38466933873272, 0.33760133758204774],
            [15.386908006371907, 0.34382235561474267],
            [15.389751482168036, 0.36045981423587703],
            [15.390009968308357, 0.3686524800285134],
            [15.388129597995627, 0.3725960972867559],
            [15.384883609449306, 0.37473146692669324],
            [15.376782176493402, 0.3749762908649406],
            [15.371785301683419, 0.37216363944979913],
            [15.367361639712618, 0.3680234207772034],
            [15.370516843193906, 0.3598925524723437],
            [15.377928587148197, 0.3506450331040242],
            [15.37783174654923, 0.3454599933876049],
            [15.371085204826857, 0.3411490914781143],
            [15.36446865935547, 0.33565867971581764],
            [15.360205200246257, 0.3347725080930824],
            [15.355030806262493, 0.33713166828047425],
            [15.35484242357393, 0.34638856799192413],
            [15.353282680786641, 0.354117189820412],
            [15.349577164367595, 0.3562758293104166],
            [15.341829023426735, 0.35566924435755304],
            [15.338475919261029, 0.3543510959355105],
            [15.327521518193425, 0.34612585781677957],
            [15.324088073954098, 0.3417482506516217],
            [15.324011659845743, 0.33921537473528535],
            [15.326757286326009, 0.326861035790563],
            [15.32711196357004, 0.32097619670489996],
            [15.325536054780235, 0.3172761634474561],
            [15.320976630697558, 0.3166249975960541],
            [15.309214235878038, 0.3187384472354549],
            [15.303711591443102, 0.31875724264384386],
            [15.30121847130584, 0.32186799933050597],
            [15.3025329029364, 0.3246848223428858],
            [15.310267581365993, 0.3311437801960253],
            [15.31378595775348, 0.3370616944039633],
            [15.313705411028712, 0.3440211720473225],
            [15.310561986505775, 0.3517372825229873],
            [15.30643787939229, 0.3553398314293797],
            [15.303265500839712, 0.36175497122486894],
            [15.298830939161444, 0.36410981266230913],
            [15.293129504022232, 0.3626468939218847],
            [15.286623014897858, 0.35921500683304347],
            [15.28134987880417, 0.35508485346855945],
            [15.282857838775342, 0.3511496927157437],
            [15.290527552710431, 0.34978991522066133],
            [15.29299214099042, 0.34322569398184943],
            [15.291191042774203, 0.3408275554751778],
            [15.284019544095175, 0.3385555652624808],
            [15.27950031879642, 0.33502379256945025],
            [15.270894998780445, 0.3353763910992247],
            [15.263693624685043, 0.33760275689461283],
            [15.25735742659432, 0.3425340269083563],
            [15.256889036794927, 0.3444729756681654],
            [15.260840472217561, 0.3524741198009506],
            [15.258794639871011, 0.35381563251743076],
            [15.253482577784574, 0.35293550172561156],
            [15.243912114637189, 0.3540741930152364],
            [15.23570560431506, 0.3610527178327596],
            [15.219427680873792, 0.3662608417929143],
            [15.217849625830395, 0.35952236095198675],
            [15.211511049367259, 0.35695151481395226],
            [15.207508895423873, 0.3581261918161589],
            [15.201084381994056, 0.36277342829484294],
            [15.199439618578005, 0.36622748209930034],
            [15.199649222300886, 0.3750390692888454],
            [15.193102393523851, 0.374779319439728],
            [15.185757821374652, 0.3803946612726936],
            [15.179338178166532, 0.378677318015787],
            [15.174437836454919, 0.3786569405243621],
            [15.171432085962001, 0.3802387410841145],
            [15.165158852641849, 0.38791813263829045],
            [15.169861707973732, 0.3905094355540291],
            [15.174070887659555, 0.39000116330655216],
            [15.176595810955375, 0.3923873201389472],
            [15.173428971060556, 0.3951880290393357],
            [15.172909147841601, 0.39821885509572913],
            [15.177056313487295, 0.407663200102329],
            [15.177170137551277, 0.41416938835779615],
            [15.175523029156926, 0.4175386709775605],
            [15.172536218725773, 0.4184204380542581],
            [15.16903094930778, 0.41445866010115445],
            [15.165715073868066, 0.41343583413132395],
            [15.155452680854257, 0.41496068419126103],
            [15.154306690849987, 0.41758126894332914],
            [15.147563164240124, 0.41930705265199075],
            [15.146964375941664, 0.42221382797618934],
            [15.142734734079529, 0.423738787735035],
            [15.146097254075544, 0.41637353431515517],
            [15.145838933499034, 0.41365703264468623],
            [15.133304812210064, 0.41265080303960844],
            [15.131833224637456, 0.4073332688776821],
            [15.120748986216823, 0.4011114685719277],
            [15.116867857146117, 0.4010271010136308],
            [15.112020957354833, 0.4063694026968537],
            [15.117121984983346, 0.4178707057828943],
            [15.114914260002585, 0.42698640822191813],
            [15.112650510456914, 0.4303100037455897],
            [15.104291017088288, 0.4324308673604559],
            [15.100853321413842, 0.4308612235718306],
            [15.09929100359554, 0.4269960931946066],
            [15.100996262697, 0.42381156079487203],
            [15.100648320630194, 0.4192660218771887],
            [15.097721913520214, 0.4170081894897261],
            [15.092717855115257, 0.41727252794538716],
            [15.094597040390948, 0.42247582888538815],
            [15.09258815657957, 0.426583144502903],
            [15.089251327835909, 0.4276769041699119],
            [15.084048745114421, 0.4259514223884182],
            [15.074521271157629, 0.42087612866133994],
            [15.06890467214241, 0.42137471596089865],
            [15.071604771292268, 0.4264468037375713],
            [15.064695611295482, 0.4333003188278152],
            [15.06690609077871, 0.43524065030570686],
            [15.069529505965342, 0.44110376104446836],
            [15.07215913978927, 0.44998357060487476],
            [15.067451963166768, 0.4529550984965904],
            [15.068291396492784, 0.456078532664258],
            [15.06485504760646, 0.46142882970908056],
            [15.062134284417526, 0.45973235472808366],
            [15.058446899630145, 0.4641161277993941],
            [15.055235541846823, 0.46322801757470194],
            [15.055575845938717, 0.4569465102315612],
            [15.062226413256807, 0.4461607748029842],
            [15.058852365236822, 0.4424494666575855],
            [15.049535168373614, 0.4451422701255772],
            [15.045881000766949, 0.45071848124033925],
            [15.03969493264481, 0.4532684626523065],
            [15.037248360715255, 0.4502757860966749],
            [15.034363336357861, 0.4423303948169595],
            [15.026731184303287, 0.4421556763443883],
            [15.018771946032354, 0.4499612610076104],
            [15.017610446534254, 0.45556685841442773],
            [15.019516083614501, 0.4605926395812744],
            [15.018141094301408, 0.46593428409979015],
            [15.015231601911553, 0.46469112087676046],
            [15.00997845019765, 0.4593484490377086],
            [15.008189888607145, 0.45965207991029894],
            [15.001327704868162, 0.45603344332885104],
            [14.99746034656831, 0.4600160997683482],
            [14.996767031490409, 0.465142455232459],
            [15.001817437958644, 0.4672179256689749],
            [15.00708413625178, 0.4651575849374593],
            [15.009743206583439, 0.46891123665888124],
            [15.010333731193992, 0.47609540030396336],
            [15.007315229827011, 0.47962786275424424],
            [14.998694520467613, 0.4755176340083525],
            [14.99381425064517, 0.4769253199007364],
            [14.987271334467103, 0.47338366681480415],
            [14.98304299095294, 0.47555700698285425],
            [14.979399717026654, 0.48218241410339535],
            [14.983665251016966, 0.4879389917850732],
            [14.99019184090518, 0.48879314790612916],
            [14.990588637214172, 0.49183945595586087],
            [14.983226375954182, 0.4981413376194771],
            [14.981150852795148, 0.5092720349965878],
            [14.978868048840537, 0.5117418025409864],
            [14.969063689866621, 0.5069995127378157],
            [14.968218670051051, 0.5098367632801805],
            [14.97599923716771, 0.5209386175009254],
            [14.9774100773263, 0.5255991753798893],
            [14.992352882203036, 0.5457278768227989],
            [15.00160580275316, 0.5618473552374411],
            [15.002522321796116, 0.5698741378892594],
            [15.008164953775873, 0.5707207811422577],
            [15.011929252396172, 0.5775894186072266],
            [15.018026460420087, 0.5936346465484423],
            [15.025481546212326, 0.6038573154466348],
            [15.026404628606537, 0.6120635458013404],
            [15.024135407199507, 0.6176494161931912],
            [15.025769801337622, 0.6283611646907057],
            [15.02542371531795, 0.6324830660532968],
            [15.022768778034532, 0.6361845480246459],
            [15.024716730682043, 0.6419276902302595],
            [15.03109034313043, 0.6428430326449901],
            [15.03514842365383, 0.6398488739653675],
            [15.036909660616464, 0.6363519647181844],
            [15.040390340949838, 0.6368899763660144],
            [15.043886492474405, 0.6398739556125441],
            [15.049398301010463, 0.6382878191628563],
            [15.050836204895159, 0.6351516586169461],
            [15.047862627849172, 0.6288849361999227],
            [15.04956976206499, 0.6255503424892384],
            [15.054614295327452, 0.6233661733407022],
            [15.057632770013223, 0.6251129792288541],
            [15.055973118253835, 0.6299945214273233],
            [15.0614662495777, 0.6276844368494924],
            [15.066236318436294, 0.6319320722091937],
            [15.070974753863979, 0.631531085619651],
            [15.074436789591894, 0.6334562433466435]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.08846229322268,
          "lat": 37.706654235371175
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51101"],
        "coty_name": ["King William"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["King William County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01480138"
      },
      "bbox": [
        14.968218670051051, 0.3166249975960541, 15.453237735556408,
        0.6428430326449901
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.50946558297938, -0.49825388242571883],
            [15.50719511445765, -0.5018476448243405],
            [15.510531041352188, -0.5077213818455915],
            [15.5177154237195, -0.5035232041443028],
            [15.520997763260482, -0.5055100717750309],
            [15.51810364943626, -0.5116264734177638],
            [15.519024239007603, -0.5174598973435016],
            [15.516674669202752, -0.5191660609285789],
            [15.518224996247444, -0.5235062532591612],
            [15.521697877078617, -0.5256893451633938],
            [15.52633224635508, -0.5308924996793593],
            [15.526903797591123, -0.5342893032277402],
            [15.524176993475281, -0.5431439289956244],
            [15.527643803236726, -0.5444483263433674],
            [15.529749125154865, -0.5514560436521312],
            [15.533099525726433, -0.5547991295160646],
            [15.533006195684655, -0.5558782500856808],
            [15.509672530841208, -0.5474962894877652],
            [15.502333357049963, -0.5472706610881737],
            [15.488199078536011, -0.5440038069368295],
            [15.49704371820018, -0.536703465697232],
            [15.498119396422632, -0.5333717440280739],
            [15.496075921732835, -0.5308509268567063],
            [15.49234388828302, -0.5323991653738822],
            [15.484235805659814, -0.5331111702347148],
            [15.480160139483175, -0.5275557088693753],
            [15.48127923567894, -0.5225198855490332],
            [15.480587975368449, -0.5180008645976828],
            [15.476928014647772, -0.5168101322678958],
            [15.477361319204748, -0.5100736654891626],
            [15.487634725800312, -0.5017119325338023],
            [15.508679152908798, -0.49747119357257247],
            [15.50946558297938, -0.49825388242571883]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.93834671339586, "lat": 36.68302584186345 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51620"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Franklin city"],
        "coty_fp_code": "620",
        "coty_gnis_code": "01498424"
      },
      "bbox": [
        15.476928014647772, -0.5558782500856808, 15.533099525726433,
        -0.49747119357257247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.025060437911673, -0.25506503216480897],
            [16.03603143134974, -0.26059073131962057],
            [16.04147574903692, -0.2591309015243103],
            [16.04765355964933, -0.26267428131170045],
            [16.051433539399728, -0.2597916168519369],
            [16.05061111042733, -0.25671072370606113],
            [16.052005862427315, -0.24989996751673677],
            [16.055189157448567, -0.24596252709476293],
            [16.05915973995217, -0.23781078607746328],
            [16.0596226743336, -0.23019156448300315],
            [16.04851260184099, -0.22689096047273577],
            [16.045214233259212, -0.22469897432713956],
            [16.046605894596343, -0.22017355101867775],
            [16.046101175091078, -0.21584586174033232],
            [16.04277657350232, -0.21264703651197447],
            [16.03671485530065, -0.2044169922338845],
            [16.0386975176769, -0.19656239293004465],
            [16.045276126652794, -0.18193958517791214],
            [16.038585651252312, -0.1778171909479291],
            [16.034751307400672, -0.17243509574777377],
            [16.037173546523526, -0.1709496343464932],
            [16.037622790325674, -0.16679469348039186],
            [16.046338723295957, -0.16689174033109647],
            [16.044193954420944, -0.15801499374847078],
            [16.074738296644462, -0.15879457806337577],
            [16.088239962235996, -0.16180624922683376],
            [16.111842227893764, -0.16560524220246056],
            [16.11594813162574, -0.16577397124936002],
            [16.121119109388196, -0.16015734367001455],
            [16.13906692655196, -0.15142100767850664],
            [16.143819180469194, -0.14491378823557224],
            [16.149175204022356, -0.13591847407973637],
            [16.15141466717153, -0.13404435368368825],
            [16.16026178217033, -0.1312132292112068],
            [16.1705447873396, -0.13046451494879438],
            [16.175703369219054, -0.13111737638128804],
            [16.185929854968574, -0.13616038812953618],
            [16.190255479714626, -0.14150114506616537],
            [16.19431971779428, -0.15160358944370667],
            [16.22143960846006, -0.21093876528655026],
            [16.23293216092667, -0.23926766061272112],
            [16.256107095992178, -0.2872725922119885],
            [16.29230658231036, -0.35086082995936485],
            [16.30302077934869, -0.36800325028551345],
            [16.311588936132743, -0.3797880721362811],
            [16.329222085968535, -0.4062314005024759],
            [16.352230433724113, -0.44971533290443755],
            [16.36438119318854, -0.48163348794928973],
            [16.33546804848764, -0.48759521173847065],
            [16.263145278297007, -0.5032915870058867],
            [16.166159735002726, -0.5238960323019209],
            [16.159765297144002, -0.495302215480537],
            [16.158789693143692, -0.4863770748015648],
            [16.15713146190971, -0.47975986713081503],
            [16.142307657468272, -0.4100128209253829],
            [16.157872931027917, -0.4018555610755265],
            [16.15794383354546, -0.39882572408328315],
            [16.168010343349188, -0.3941283494840436],
            [16.172472889195713, -0.3902892703646017],
            [16.180884229172708, -0.38973820121084135],
            [16.181978743333104, -0.38114454845481993],
            [16.17860343207108, -0.3746077356988109],
            [16.174072827963816, -0.3714731078295056],
            [16.166244542337925, -0.36365081244229547],
            [16.163431341201708, -0.3573253990054302],
            [16.150714415739287, -0.3563132776700359],
            [16.10663743691423, -0.32335880823019075],
            [16.071639056045786, -0.3238541602015272],
            [16.05705895691125, -0.32075060817875206],
            [16.034672027424577, -0.27963781617708305],
            [16.024984185537388, -0.2623796511186267],
            [16.026363264010424, -0.25778247268526333],
            [16.025060437911673, -0.25506503216480897]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.04350781738697, "lat": 36.73353628293168 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51810"],
        "coty_name": ["Virginia Beach"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Virginia Beach city"],
        "coty_fp_code": "810",
        "coty_gnis_code": "01498559"
      },
      "bbox": [
        16.024984185537388, -0.5238960323019209, 16.36438119318854,
        -0.13046451494879438
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.438636545783634, 11.921124028972933],
              [-17.427677757896763, 11.927652982882117],
              [-17.421967698322394, 11.923653800377986],
              [-17.42116361551504, 11.920161198140958],
              [-17.433791207304854, 11.918119709594244],
              [-17.438636545783634, 11.921124028972933]
            ]
          ],
          [
            [
              [-18.568364385253968, 11.798026506714583],
              [-18.55988411952034, 11.801283482911748],
              [-18.560158444046074, 11.798638027970103],
              [-18.564177124899633, 11.794725070263782],
              [-18.568364385253968, 11.798026506714583]
            ]
          ],
          [
            [
              [-18.585059158182702, 12.013077507541423],
              [-18.564667768088597, 12.006979358104381],
              [-18.55563497031393, 12.005029738878454],
              [-18.54210372991755, 12.001096771496933],
              [-18.473055800777903, 11.981736191435576],
              [-18.45922268976557, 11.976363113383709],
              [-18.364846807452878, 11.947642470662359],
              [-18.25356378665404, 11.914383363556306],
              [-18.14229384344621, 11.881078524919266],
              [-18.059868879222, 11.856857236981135],
              [-17.993947168479824, 11.83704468289035],
              [-17.932177650909686, 11.81898344794501],
              [-17.870412047372213, 11.800908201620356],
              [-17.874428104595008, 11.787705523927595],
              [-17.805196774220477, 11.767618141896582],
              [-17.735970314289204, 11.747513209577214],
              [-17.648482215105357, 11.722257177495525],
              [-17.58092519610547, 11.70288400559405],
              [-17.513372763671995, 11.683494175628102],
              [-17.508687467639273, 11.696901766142402],
              [-17.505268459178406, 11.70999526343532],
              [-17.502252372172215, 11.724438759901266],
              [-17.49853932054299, 11.738271019212767],
              [-17.49019609924629, 11.765386043392212],
              [-17.485161836016548, 11.779120988775011],
              [-17.48139487495681, 11.792602040599336],
              [-17.47666329819785, 11.805795346228127],
              [-17.472775972101367, 11.81925933648888],
              [-17.467510280634, 11.832180136767283],
              [-17.46458528447816, 11.847669374926058],
              [-17.458348072814548, 11.868381245919098],
              [-17.444389029824013, 11.864551681189656],
              [-17.441082687174866, 11.856160693733727],
              [-17.431215701449865, 11.849196361971055],
              [-17.42551370506278, 11.843237988834122],
              [-17.415692865861413, 11.837236646182761],
              [-17.415283596460878, 11.82886749410632],
              [-17.413388533212014, 11.827939589379703],
              [-17.413237527844668, 11.819403970370715],
              [-17.41425769330911, 11.811222036352685],
              [-17.412740238684, 11.807413753258478],
              [-17.414773040436934, 11.805822396169226],
              [-17.417566085274153, 11.799625490256052],
              [-17.422722975236024, 11.795359917870956],
              [-17.4373763352655, 11.79135940062054],
              [-17.43741524251986, 11.786197048725315],
              [-17.431221526078453, 11.78834159786774],
              [-17.426954886120388, 11.786449775453514],
              [-17.41262507098825, 11.785863257740735],
              [-17.404846121959146, 11.789091926399905],
              [-17.402128104391753, 11.793505505017297],
              [-17.39881198844884, 11.795268680252553],
              [-17.39784608615364, 11.79986018897025],
              [-17.393258646941124, 11.80617133568783],
              [-17.387349026505422, 11.818790921438065],
              [-17.384440320423266, 11.828141259881512],
              [-17.385304216616728, 11.830629748279948],
              [-17.397081023665315, 11.839993513714871],
              [-17.397572777298578, 11.84432565415947],
              [-17.39969026836091, 11.847530230646859],
              [-17.3989867506758, 11.852113698270982],
              [-17.407298417513406, 11.863644670527675],
              [-17.41649078601774, 11.869624803752416],
              [-17.40790895988213, 11.87616778251559],
              [-17.405377960461127, 11.880166073523197],
              [-17.40424203680066, 11.887284516720989],
              [-17.40571161034633, 11.893770753356685],
              [-17.402753544000998, 11.896163022304037],
              [-17.389561820449266, 11.900627942705972],
              [-17.375908929004932, 11.907321838027372],
              [-17.366651922747447, 11.914350968689247],
              [-17.36413801916488, 11.911543990859489],
              [-17.34929109522825, 11.910230973848915],
              [-17.330134825258682, 11.910427574318922],
              [-17.31624668019822, 11.90640004797527],
              [-17.310527454666374, 11.906385752841368],
              [-17.317431326289952, 11.90028984920092],
              [-17.319293399286487, 11.895567593060603],
              [-17.319096556679355, 11.89211218974757],
              [-17.314427802775082, 11.879906988034792],
              [-17.331728961555637, 11.875834757273532],
              [-17.338559224510462, 11.874873888095475],
              [-17.349309020808352, 11.869294698754219],
              [-17.356512424401963, 11.862068282485998],
              [-17.35571789431446, 11.858780324810583],
              [-17.350488268145305, 11.850837140577289],
              [-17.35072936190809, 11.841349101797105],
              [-17.34642592307574, 11.83170152534037],
              [-17.341415539933188, 11.827483147914633],
              [-17.34595774609574, 11.824600040928075],
              [-17.34744241263823, 11.819428424370972],
              [-17.34594605815915, 11.811589641054244],
              [-17.339949563016507, 11.80526744219284],
              [-17.338107919842297, 11.798842433909964],
              [-17.332208264058227, 11.798226966758742],
              [-17.32754207082857, 11.800715110998198],
              [-17.326991906404984, 11.809114876098683],
              [-17.328781399770712, 11.815587783931703],
              [-17.32598351611301, 11.819637333496951],
              [-17.32136749159167, 11.8335213910261],
              [-17.326432065452096, 11.837927951807373],
              [-17.317834056063184, 11.844518434879065],
              [-17.315292788638388, 11.849096089685256],
              [-17.311397361483234, 11.853001802912033],
              [-17.29997459318981, 11.856025933528569],
              [-17.284484626429585, 11.857449562071569],
              [-17.27905836651373, 11.85400419627547],
              [-17.28271999156101, 11.851200731320091],
              [-17.28506877327617, 11.846448274314472],
              [-17.286698000533256, 11.836592536200005],
              [-17.285598311419125, 11.827336216689476],
              [-17.287747625193497, 11.822096199192309],
              [-17.289247560635292, 11.814069754809108],
              [-17.288946863705387, 11.810758739826557],
              [-17.291454956915583, 11.804888950128671],
              [-17.291940532470722, 11.798612612701634],
              [-17.290397027733484, 11.791513806683684],
              [-17.28619587026753, 11.785710702710581],
              [-17.291548699921638, 11.775747470256187],
              [-17.291026267105135, 11.772889382464122],
              [-17.303818843558204, 11.767690616328439],
              [-17.30629688411552, 11.76839031977863],
              [-17.308623598491508, 11.775273619069058],
              [-17.315332547580024, 11.781912799377633],
              [-17.31685667489035, 11.787932959442431],
              [-17.321950802219664, 11.790346901682174],
              [-17.329158244738498, 11.78738842189953],
              [-17.329176413850753, 11.78032032392985],
              [-17.327623169741287, 11.76350646498305],
              [-17.33004456772973, 11.753715933005934],
              [-17.322714532488618, 11.737134881205382],
              [-17.320009613997062, 11.73677804100239],
              [-17.311705704765203, 11.732856230301614],
              [-17.3100174738149, 11.728037654426918],
              [-17.310864928723586, 11.718991212179397],
              [-17.31512208989423, 11.712558405542055],
              [-17.320400109623122, 11.706830058532429],
              [-17.321470450691947, 11.702627667758616],
              [-17.321079800326338, 11.694387257164248],
              [-17.324901961879064, 11.685202615507693],
              [-17.32981879956882, 11.687836848603837],
              [-17.336799585815424, 11.68583743634671],
              [-17.33058404731173, 11.683104746050544],
              [-17.327015663130336, 11.679351809257575],
              [-17.31967348615175, 11.681135146860264],
              [-17.30959125331595, 11.690284307151396],
              [-17.3064428401631, 11.68985705187232],
              [-17.307167461244024, 11.683266857934981],
              [-17.304913233741143, 11.67914314757048],
              [-17.3082122537711, 11.674922552936616],
              [-17.30939356019876, 11.669385596274537],
              [-17.31189755372012, 11.665010173755357],
              [-17.308594628279668, 11.658094722895814],
              [-17.30964304070888, 11.655189092678867],
              [-17.304578128378736, 11.64766459162079],
              [-17.29244706982871, 11.64454622239344],
              [-17.28770011915256, 11.640277890401196],
              [-17.293694883337018, 11.637605254693613],
              [-17.296395935636188, 11.632848031529491],
              [-17.301738590258328, 11.636287969307297],
              [-17.305113337343027, 11.632515548430865],
              [-17.308187088329717, 11.626895474996404],
              [-17.311765104416036, 11.624925776877323],
              [-17.319961648768643, 11.625623132179816],
              [-17.329371450571916, 11.631021172118942],
              [-17.347198533002576, 11.63750191472785],
              [-17.345881274598675, 11.628909292254109],
              [-17.345891462264415, 11.621491467803928],
              [-17.344138328655486, 11.618837589910564],
              [-17.345677650432716, 11.612556341957994],
              [-17.353203567070313, 11.601770213664668],
              [-17.35864747345445, 11.59862601485416],
              [-17.363810709383024, 11.599278927619967],
              [-17.372230492115968, 11.593424072580696],
              [-17.374698440843616, 11.590730125654787],
              [-17.387792975471097, 11.59005510851702],
              [-17.395184942586052, 11.592282269372532],
              [-17.401233816563664, 11.58570142908917],
              [-17.400206169883848, 11.577554374347],
              [-17.405186588021472, 11.573859524800133],
              [-17.407445308347675, 11.567012968678089],
              [-17.407881938023454, 11.560938572478571],
              [-17.411149767904472, 11.558880975926836],
              [-17.411932461998273, 11.554399428169779],
              [-17.419251371609878, 11.546313711399685],
              [-17.420074513407997, 11.539978159046127],
              [-17.42321683670937, 11.535693726722496],
              [-17.427614561370987, 11.53541019619099],
              [-17.433421824200646, 11.532245808123328],
              [-17.437775437374416, 11.528160026888457],
              [-17.445697145625243, 11.51801553959415],
              [-17.446380086666935, 11.509621943442896],
              [-17.45059860096413, 11.50045117043399],
              [-17.445950180176926, 11.490233377427407],
              [-17.446804221344614, 11.48725039814718],
              [-17.45625616652364, 11.485500732591374],
              [-17.46739079128197, 11.486678408358646],
              [-17.4734816649214, 11.485220775803203],
              [-17.476320156158756, 11.486337989768076],
              [-17.48507592132593, 11.495488961972484],
              [-17.48634430603978, 11.499259547405705],
              [-17.483006178575582, 11.50090320157603],
              [-17.48024150511619, 11.505141147247425],
              [-17.479119194463024, 11.510123222723939],
              [-17.47584129933347, 11.514908892167485],
              [-17.467089702714045, 11.517281637594508],
              [-17.46516661824732, 11.520946914468981],
              [-17.465197768467807, 11.527199780814051],
              [-17.45889227690472, 11.531956694425638],
              [-17.457302196359198, 11.536200178815703],
              [-17.457678165792267, 11.542409357851717],
              [-17.455795558160336, 11.546218041275585],
              [-17.446525850188394, 11.55450316598469],
              [-17.44540487504333, 11.558136857809926],
              [-17.440301794156778, 11.565353322294209],
              [-17.440603628223215, 11.56799939053557],
              [-17.430837145862824, 11.583202470945388],
              [-17.426097019288736, 11.595271779463225],
              [-17.42614240621028, 11.597384889809767],
              [-17.42989569819582, 11.602812054921452],
              [-17.426283037862753, 11.61729422969839],
              [-17.430246566714747, 11.624915160084223],
              [-17.4301054114238, 11.633233056719238],
              [-17.434626621460897, 11.63435568464752],
              [-17.43791302234571, 11.632867178832173],
              [-17.44077894676474, 11.623185189189444],
              [-17.445345024298504, 11.618506554813539],
              [-17.44443909715443, 11.607425197446736],
              [-17.442675808976883, 11.60332003714776],
              [-17.452227331433278, 11.587334651903609],
              [-17.45713696418929, 11.584501618295496],
              [-17.467953053056906, 11.581692065912483],
              [-17.475253089523772, 11.58482470606582],
              [-17.47280152583673, 11.589139314002306],
              [-17.468759602985656, 11.599953702356924],
              [-17.465448051259482, 11.603214431028608],
              [-17.468117888540633, 11.607205918979197],
              [-17.475708813507854, 11.609849879141692],
              [-17.479462036221562, 11.60509959482819],
              [-17.481937556506224, 11.597882733667161],
              [-17.481519246987002, 11.595337844599477],
              [-17.484393702284585, 11.584513854951533],
              [-17.484926733166777, 11.575930992011894],
              [-17.478220862817214, 11.566097792654192],
              [-17.479832343549525, 11.557492710667043],
              [-17.48414085669376, 11.552567749482181],
              [-17.48522318119495, 11.545600835358451],
              [-17.48973305814248, 11.544445779512351],
              [-17.49028165174114, 11.553343341140806],
              [-17.49697460336987, 11.553953588310128],
              [-17.50219569665403, 11.542001104316832],
              [-17.50780538659667, 11.544570637053893],
              [-17.513806139918504, 11.5282999273921],
              [-17.51929212293641, 11.52224808985911],
              [-17.516255072177184, 11.505337603914391],
              [-17.51902086437951, 11.502234410981405],
              [-17.531450690367443, 11.498802888955586],
              [-17.53567929275704, 11.49417003997807],
              [-17.53979438551694, 11.492747708373438],
              [-17.543183618094403, 11.487550209626649],
              [-17.539911563774318, 11.486130950912239],
              [-17.5427042922657, 11.481248543824824],
              [-17.541372403224003, 11.475832733960694],
              [-17.545461498537318, 11.46856554681587],
              [-17.554572507410935, 11.471813298929703],
              [-17.55579112771252, 11.475848432023348],
              [-17.565943510616936, 11.47310947840816],
              [-17.568651310516806, 11.467388589590911],
              [-17.57294529460965, 11.466503786333801],
              [-17.573792467419175, 11.462524323647372],
              [-17.5834448024598, 11.460571605858206],
              [-17.58486493454263, 11.45805431635708],
              [-17.593458469068604, 11.455149178874144],
              [-17.59882116083033, 11.451807847607297],
              [-17.604973569595256, 11.452592415254907],
              [-17.606945993516256, 11.44669033957677],
              [-17.61616217579232, 11.449462077083895],
              [-17.676598820756382, 11.46705322480191],
              [-17.737039180637336, 11.484631222677288],
              [-17.797483233733672, 11.50219606505629],
              [-17.85793095833911, 11.519747746299053],
              [-17.864203310058734, 11.521036522646883],
              [-17.864850294946187, 11.518896869658386],
              [-17.948734994737684, 11.543309819543932],
              [-17.973370404918313, 11.462236595307141],
              [-18.05591116886912, 11.4863816932531],
              [-18.12514433716496, 11.506833841757606],
              [-18.196092666426964, 11.527890782094069],
              [-18.267046135396136, 11.548929588541043],
              [-18.32517023949582, 11.566772435167183],
              [-18.32064071661367, 11.580830498896125],
              [-18.362730194675866, 11.593610833519763],
              [-18.407256496930955, 11.606632602261355],
              [-18.47335132962243, 11.626506718587722],
              [-18.486715243658857, 11.630078636801567],
              [-18.492102617142624, 11.632146221201676],
              [-18.521071572831666, 11.640718795859145],
              [-18.519215380710513, 11.654607771424974],
              [-18.514169680058824, 11.688417444669698],
              [-18.512749805219034, 11.705428161841187],
              [-18.513552942321905, 11.7100620727659],
              [-18.5099797907238, 11.73789294811562],
              [-18.50919456237046, 11.771462717732911],
              [-18.512139252561305, 11.798454967659078],
              [-18.507423227548827, 11.831704270068846],
              [-18.506801711944092, 11.844877095317495],
              [-18.50797950268504, 11.853178097921095],
              [-18.516182433242257, 11.865013021773773],
              [-18.51644546443638, 11.872941919350476],
              [-18.51910283599449, 11.876800510384353],
              [-18.52310133425462, 11.876483567897871],
              [-18.52613815670233, 11.88103362519643],
              [-18.528696979752237, 11.89643363949477],
              [-18.52849214667232, 11.902499322686172],
              [-18.52637694737743, 11.91078854446157],
              [-18.524741083626118, 11.921358555701193],
              [-18.525555797015205, 11.930394235875166],
              [-18.5292423958342, 11.937217791357941],
              [-18.534478599898748, 11.940128146449014],
              [-18.53882948968179, 11.940030028819857],
              [-18.541832848095876, 11.945337742678745],
              [-18.542350510675575, 11.950854452121344],
              [-18.55367209004788, 11.956316707939102],
              [-18.55044646254121, 11.963250399923488],
              [-18.552793640399216, 11.967312060847599],
              [-18.5561972453389, 11.968552699955794],
              [-18.55609415460009, 11.97495733171197],
              [-18.55890976403931, 11.977755739455729],
              [-18.556808100505066, 11.986701375347742],
              [-18.560067603086036, 11.99230279736162],
              [-18.565012225056844, 11.992828651167738],
              [-18.566901429086936, 12.001425126782918],
              [-18.57127698714458, 12.006120999758618],
              [-18.57650834157435, 12.008456393689878],
              [-18.58291018898483, 12.003014123713527],
              [-18.585290565879784, 12.007691905262636],
              [-18.585059158182702, 12.013077507541423]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.59632646651801,
          "lat": 47.748569068919274
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53031"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01531936"
      },
      "bbox": [
        -18.585290565879784, 11.44669033957677, -17.27905836651373,
        12.013077507541423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.397388385557154, 0.1279157660295769],
            [11.40040990578739, 0.13134764231673288],
            [11.405329398563284, 0.13167723175952076],
            [11.415309492206891, 0.13516833371445272],
            [11.408808654597081, 0.1365990822166935],
            [11.407317884380687, 0.13969688658121834],
            [11.401204896250595, 0.13689893909095982],
            [11.398503168169025, 0.13854305739892947],
            [11.395375301176582, 0.13649309485459007],
            [11.391265139041549, 0.13886882309993792],
            [11.387753655985176, 0.13798515635080194],
            [11.378276315410892, 0.1394456864238105],
            [11.376712137475867, 0.142490096506619],
            [11.372254236980277, 0.14187977181833836],
            [11.364336127456582, 0.1460078387727797],
            [11.362211783174454, 0.15242701832748284],
            [11.363098998410736, 0.16071100168680327],
            [11.360350606980893, 0.16214104443270042],
            [11.364702054076028, 0.16856143688224973],
            [11.362670324831837, 0.17072786911054957],
            [11.361500270477158, 0.17604134061849713],
            [11.364098159686163, 0.17793052568159143],
            [11.365584673259251, 0.1848203967105492],
            [11.36347327252206, 0.18850935702569369],
            [11.370804752540224, 0.19821001504837082],
            [11.374373290002005, 0.20508050382513882],
            [11.374715815461798, 0.20976768897291992],
            [11.367332256107082, 0.21829062475100594],
            [11.369425143876466, 0.22403470184084767],
            [11.372182855941379, 0.2266874353518085],
            [11.370644132458198, 0.22916581462597166],
            [11.371938195134222, 0.238622723916351],
            [11.379311956111477, 0.24122348183169312],
            [11.37791715535702, 0.2483767495810418],
            [11.378862282551797, 0.2524994505038087],
            [11.384011003454493, 0.25402386239990987],
            [11.38841976577167, 0.25214348170899853],
            [11.392811730579897, 0.25377408840806837],
            [11.397325493919304, 0.2498382413249227],
            [11.402186828008372, 0.24735842894561724],
            [11.40705442060867, 0.2474630269038323],
            [11.4126464048892, 0.24961727527909086],
            [11.417528873288925, 0.2453751221959357],
            [11.422120905514905, 0.24580805900299055],
            [11.422560417813079, 0.25097405235655446],
            [11.419863528250389, 0.2527135932682791],
            [11.419406115493334, 0.25858462700360424],
            [11.412865498873279, 0.25879246568641334],
            [11.41114838171383, 0.26757185938775474],
            [11.412657892450474, 0.2713171998641987],
            [11.411494333790303, 0.27434309078760344],
            [11.423558966654541, 0.27400155744573246],
            [11.421433818907152, 0.28618423645597896],
            [11.427926714892914, 0.2866697914221327],
            [11.428813916591585, 0.28465744434197443],
            [11.437196952536635, 0.2862204491939204],
            [11.438128307923556, 0.293152489186564],
            [11.44259203594216, 0.29231908175533516],
            [11.446542629657879, 0.2940556392757263],
            [11.442823932098376, 0.29826917583978413],
            [11.435798083144745, 0.29647180997173084],
            [11.438289709278886, 0.30354088654869926],
            [11.439229985584412, 0.31193962957760774],
            [11.44277606291825, 0.31431898762290716],
            [11.440725436466623, 0.31883800415862984],
            [11.442209519435432, 0.32297876369150824],
            [11.446169052796408, 0.3233077453310471],
            [11.450528645715753, 0.32012001915984883],
            [11.454074761780943, 0.3153571769724543],
            [11.456081376219773, 0.3086496009759925],
            [11.459586967416937, 0.3017210766503044],
            [11.465055435535678, 0.30028952147073523],
            [11.468732794390704, 0.2966537816901822],
            [11.472707225147387, 0.29724559263385164],
            [11.468588897093262, 0.3059196341327474],
            [11.464905937907702, 0.30727116284259726],
            [11.462617110384054, 0.314635680112562],
            [11.464570354695814, 0.31832477249736446],
            [11.464058406694058, 0.3247208979083892],
            [11.466524619979104, 0.32424942782484506],
            [11.472164098781422, 0.3269433438935983],
            [11.47654344292365, 0.32567162773297303],
            [11.4798965093664, 0.3285498762291819],
            [11.482410284556215, 0.33353418731208545],
            [11.478504426580253, 0.3403187493417639],
            [11.481661103738558, 0.3439672051231602],
            [11.48115665601327, 0.35005002903982335],
            [11.489509488473388, 0.3514338555230869],
            [11.496445747652494, 0.3491561801552425],
            [11.505327261167219, 0.3405500500688932],
            [11.50538612379464, 0.3347878775554826],
            [11.507547858045621, 0.3278205610804027],
            [11.511465532020637, 0.324194495081273],
            [11.515894279697479, 0.3251628653048078],
            [11.5221126950109, 0.32311256675681216],
            [11.525297624846605, 0.33040005668708594],
            [11.530667284569706, 0.3319876425958193],
            [11.530850580486819, 0.3415604410992866],
            [11.527135558784462, 0.34006783642841704],
            [11.525963397076488, 0.3434721525292555],
            [11.529545836855224, 0.3492289978640752],
            [11.54057844655116, 0.3513419506154559],
            [11.541727066507637, 0.35562681740814867],
            [11.54643889353231, 0.35763808440482403],
            [11.549270491189107, 0.35695927414896816],
            [11.555135674765229, 0.34989975254501154],
            [11.557541013065002, 0.348869532299766],
            [11.56245816396907, 0.3525992400792472],
            [11.572832522931671, 0.3546580902717876],
            [11.57769757873187, 0.35739438873964857],
            [11.58354982895424, 0.3556358449570802],
            [11.59034187355517, 0.35653140985200243],
            [11.590455527331795, 0.3500452947453899],
            [11.59198609855401, 0.34587385624214645],
            [11.589185752828449, 0.3447408615532513],
            [11.588867189167413, 0.34006331074599266],
            [11.594051409274254, 0.32767072075848874],
            [11.592178694661596, 0.3203225732279163],
            [11.604065588086428, 0.31446929628306286],
            [11.605690084463927, 0.30874124257483954],
            [11.608891847492004, 0.3098694460709846],
            [11.611368242471475, 0.31683115056303796],
            [11.62192794900672, 0.31628395356108396],
            [11.62573900141653, 0.3145936398781375],
            [11.631130052052928, 0.3085857237804161],
            [11.63358641245698, 0.30289708363575024],
            [11.641845858341709, 0.29948414966073544],
            [11.64162225293353, 0.29632820617916833],
            [11.649774147399206, 0.2902517181360496],
            [11.652025433785104, 0.2865751288453148],
            [11.65546207364445, 0.2889966836688232],
            [11.660310526306343, 0.28194290408063477],
            [11.663726894386377, 0.2831848959673707],
            [11.667757963726197, 0.2869729635192516],
            [11.678915364240535, 0.28542946196080893],
            [11.684637876136824, 0.2776271510674305],
            [11.680076620479525, 0.27143579161363196],
            [11.680772074237805, 0.26722713022340755],
            [11.684833238943808, 0.2673112522880087],
            [11.69004943156526, 0.2702197687124433],
            [11.69192872448405, 0.26668309048034033],
            [11.696190436172076, 0.26857929934014346],
            [11.70428694822255, 0.26078275611191293],
            [11.702850006776197, 0.25083604203921817],
            [11.699375379700944, 0.25120173284268577],
            [11.696492034177208, 0.24574101510759785],
            [11.693753068075484, 0.24574583654625254],
            [11.692794280638376, 0.23226048823435763],
            [11.691045264123405, 0.23099520618321176],
            [11.694319763184033, 0.224616701532396],
            [11.70089268964905, 0.22503651056712887],
            [11.703991758785326, 0.2224390074204625],
            [11.710378720946839, 0.22029738132863713],
            [11.712728867485733, 0.21477355816459162],
            [11.715930210610702, 0.2158701257894535],
            [11.721483482928498, 0.2130781400301232],
            [11.72600238713161, 0.21545657004233837],
            [11.72948491242323, 0.221206873087803],
            [11.737407532571964, 0.21606789887713757],
            [11.74249434107888, 0.21573941963977186],
            [11.746984570321894, 0.20904186543866032],
            [11.744514737417335, 0.2059804573489364],
            [11.747396069683207, 0.20202671451486218],
            [11.749830370496056, 0.20220553634130378],
            [11.75188068262884, 0.19766614707585367],
            [11.756766299649945, 0.19382532291931057],
            [11.761630269214308, 0.18488182673180842],
            [11.756569381194062, 0.18142062614005575],
            [11.758433176349838, 0.17793150785531156],
            [11.756815060944316, 0.17253254878497942],
            [11.760910347136122, 0.1713654534421953],
            [11.759506690132161, 0.16572158090817682],
            [11.762899425107513, 0.163301898415443],
            [11.764235314683436, 0.15897943777985263],
            [11.769419374315712, 0.1546700266070406],
            [11.771670367889449, 0.15133887081747685],
            [11.770264764171811, 0.14560454264761458],
            [11.765761118025436, 0.14766885235894178],
            [11.759712421649281, 0.14387573233726514],
            [11.749791974674647, 0.14163271927508184],
            [11.74775221342424, 0.13641453192933348],
            [11.743355624310354, 0.13778145389301039],
            [11.738510874408524, 0.13693413410986185],
            [11.730785070756117, 0.14044625824943657],
            [11.725565187846879, 0.13433162376718344],
            [11.723568466237424, 0.12779284509439762],
            [11.71902547423294, 0.12137418097794349],
            [11.708992993516054, 0.11932434979382021],
            [11.705034282161579, 0.11268991464923628],
            [11.70654171612053, 0.10903881168795483],
            [11.698783337551747, 0.10090315445797875],
            [11.698882851291929, 0.09509527463485447],
            [11.700731656377823, 0.09282442479926283],
            [11.695349292363327, 0.08566638034021416],
            [11.699235134055685, 0.08248140707880809],
            [11.69422983998216, 0.08059141386952894],
            [11.694486277852809, 0.07685079614363155],
            [11.690750822782052, 0.07260254288122421],
            [11.694840367774495, 0.06628051495708834],
            [11.699286063798104, 0.06563290391299297],
            [11.698533684149645, 0.058673081905202464],
            [11.701369109725231, 0.05512394593762195],
            [11.70018448940034, 0.04840442632557897],
            [11.709502147708703, 0.04125076132177001],
            [11.70660474659188, 0.03539049224003427],
            [11.704534074036696, 0.03497231286821407],
            [11.70387762345943, 0.029524810730295385],
            [11.706748261888452, 0.028773112168323078],
            [11.708769871463652, 0.023430169039724925],
            [11.70460174791093, 0.0200674507052812],
            [11.702936089495413, 0.012865747286632062],
            [11.707502601629805, 0.008866398804796324],
            [11.707631298497972, 0.00285872081833428],
            [11.710621434147388, -0.0016893250761982526],
            [11.709890828311707, -0.004150838975400604],
            [11.712180143446856, -0.012381730088565995],
            [11.715450419333951, -0.016171688339281034],
            [11.715752620944619, -0.020211802143606437],
            [11.721721612356605, -0.028185496311191608],
            [11.724974812693416, -0.02411138710961778],
            [11.731279037937579, -0.02651533305950245],
            [11.736600068475802, -0.02457545023448359],
            [11.740984402572826, -0.02890879749151069],
            [11.746907308473213, -0.02779529938703133],
            [11.749796136183711, -0.030110181775188895],
            [11.747750980823469, -0.033284887229576586],
            [11.749338610303337, -0.03692341778641],
            [11.749198338731855, -0.04889836427447786],
            [11.750802175241713, -0.05212575286407586],
            [11.755899914639281, -0.056961000317002075],
            [11.749951917527945, -0.06257399186239428],
            [11.746073596100915, -0.060003171411855245],
            [11.743303442484677, -0.0610412180193423],
            [11.740539621366173, -0.06779932078118567],
            [11.736221872528803, -0.06805174000699808],
            [11.731459865012166, -0.07572860925361874],
            [11.723951234540914, -0.07943377890097676],
            [11.721679498493506, -0.08631974700483674],
            [11.718274775017283, -0.086840848936499],
            [11.711966929100548, -0.09219857793562292],
            [11.706328930241762, -0.08744205309013102],
            [11.703585789886818, -0.08244712710805782],
            [11.704797058273048, -0.0799073109668095],
            [11.697088986593597, -0.07516534553500151],
            [11.69336271777131, -0.07410004365065657],
            [11.69261115801082, -0.0712523779773699],
            [11.684105993334477, -0.07050871434930601],
            [11.679102402717316, -0.06728821558294247],
            [11.677767874197006, -0.06269070670324244],
            [11.670398040387212, -0.05952418559074421],
            [11.668213133280238, -0.06128728615284699],
            [11.662683288360366, -0.05875896786590201],
            [11.66182905703433, -0.05419031438655821],
            [11.654589307086308, -0.049267185955696],
            [11.652209658490975, -0.04871011636374597],
            [11.648990349212285, -0.0441949498805215],
            [11.650315941206879, -0.03990739798013436],
            [11.636110657452127, -0.03338594263050582],
            [11.63252485234298, -0.03321598136972755],
            [11.631741319254814, -0.03691001851612638],
            [11.62751709596387, -0.03826677512210247],
            [11.625406612723202, -0.035830545409338256],
            [11.621738849553246, -0.037204599060143645],
            [11.6208575600367, -0.04234322279356802],
            [11.616383390007726, -0.044145768378209084],
            [11.61382325679049, -0.047087620786291154],
            [11.606802197684674, -0.047743763006547896],
            [11.606553489923412, -0.05288827141753602],
            [11.602823878970291, -0.058560266544135306],
            [11.59758550047173, -0.06211139716275591],
            [11.59489851839971, -0.061088394237231544],
            [11.591504693620204, -0.06323627598648052],
            [11.590227636240789, -0.05967618780652522],
            [11.582946928951333, -0.05636054446418712],
            [11.584197280940982, -0.05259681704074061],
            [11.58275746461891, -0.048831495110502644],
            [11.576232510266795, -0.049103283979793716],
            [11.571851652512628, -0.04629303874829869],
            [11.568973584989864, -0.0387629023903334],
            [11.568660541971287, -0.031456921504377136],
            [11.56323672198849, -0.031152895604363625],
            [11.561070128761052, -0.027803504155931465],
            [11.55531840372046, -0.028467605295437685],
            [11.550412136258746, -0.022161297933822925],
            [11.544977092699929, -0.02492149245140485],
            [11.544363758953423, -0.019805638159980623],
            [11.545859738976144, -0.01661840649909604],
            [11.537114661885948, -0.012627502908433614],
            [11.536703439093515, -0.010953386905509602],
            [11.542885189045785, -0.006855573326615137],
            [11.543553607531718, -0.0018527769015427497],
            [11.546232589232288, -0.00022315672936739226],
            [11.550889492405544, 0.009773090938131938],
            [11.550648657470564, 0.019745169751656723],
            [11.545133121892285, 0.027491292523591754],
            [11.547194782691555, 0.03372579248628579],
            [11.542025695141966, 0.03498821681759968],
            [11.537729825209471, 0.034134902580067995],
            [11.536967595099696, 0.04076017969515661],
            [11.53514241530606, 0.04395715338151952],
            [11.530996222388636, 0.04578296739318409],
            [11.527402087529586, 0.050755873866742005],
            [11.529017646135223, 0.05314397713411323],
            [11.524072899885807, 0.056075177706468075],
            [11.522030802914298, 0.05495052308471201],
            [11.511840350092188, 0.0544372439974197],
            [11.511050484149143, 0.057586204686090714],
            [11.505793858155883, 0.05944931085312063],
            [11.499506081606087, 0.06342471437947456],
            [11.464082238803993, 0.059207819546873514],
            [11.453787304720386, 0.061697913104083825],
            [11.451019229768868, 0.05996731773654058],
            [11.446428199541788, 0.0599234885651926],
            [11.441710772597279, 0.05605861239520095],
            [11.43899955880158, 0.05735118795488412],
            [11.431270266054222, 0.055827288001984054],
            [11.424434075419668, 0.06070462850981143],
            [11.426443146321233, 0.0641147327778441],
            [11.430783373385077, 0.06699514430022292],
            [11.428977129543481, 0.07519475482105502],
            [11.422085500615474, 0.07641053815571519],
            [11.420378223624214, 0.08044389436037747],
            [11.411754253207613, 0.08058610332469189],
            [11.40117916118857, 0.07951956077784625],
            [11.3913427259704, 0.07243878144333392],
            [11.388547641919535, 0.07477920969497454],
            [11.380231410489657, 0.07762538624884378],
            [11.377846975833343, 0.07614767695039215],
            [11.368813792802285, 0.08011248580286358],
            [11.36625732148358, 0.08350997732475064],
            [11.366103201386007, 0.08870496394739592],
            [11.377712389528137, 0.1062187827596721],
            [11.397388385557154, 0.1279157660295769]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.71151122732701, "lat": 38.02281719923822 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54005"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01550009"
      },
      "bbox": [
        11.360350606980893, -0.09219857793562292, 11.771670367889449,
        0.35763808440482403
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.451781872381337, 1.7071456504995917],
            [13.519412796990505, 1.6798760049781056],
            [13.543096400696045, 1.6753808423673746],
            [13.564982220304952, 1.673123105479794],
            [13.591605037661907, 1.667199789744784],
            [13.65414683936698, 1.6540691623279737],
            [13.666069390675057, 1.6548218934308156],
            [13.680123403078309, 1.656476651380584],
            [13.68615357616133, 1.6565807916107604],
            [13.704386216482094, 1.6498354715451142],
            [13.707922865147209, 1.6431449106478941],
            [13.716074507259835, 1.6405832147796158],
            [13.724423249111267, 1.6422129462693347],
            [13.72864634823628, 1.6442271357654334],
            [13.735787137302243, 1.6427873134649884],
            [13.742566148158897, 1.6381223085481071],
            [13.746674682078178, 1.6456512831282233],
            [13.754586020549251, 1.6627782326449962],
            [13.787222786718607, 1.659671628802246],
            [13.797039678040225, 1.6537221207245012],
            [13.800771236396953, 1.6498204660886606],
            [13.809367713852954, 1.6438149224054281],
            [13.809206362764039, 1.6419875956385628],
            [13.816180018787806, 1.6391424483783568],
            [13.821831620371583, 1.6352339217825491],
            [13.823433623380618, 1.6315068074069996],
            [13.827013767675448, 1.6319733891369625],
            [13.827913027052299, 1.6275746396751936],
            [13.835296478680828, 1.6246500234107561],
            [13.830248788816235, 1.6167017734092706],
            [13.830796191093972, 1.6124582335599882],
            [13.827518598826744, 1.6051690846084499],
            [13.821567182740127, 1.5993993917235443],
            [13.81621067053505, 1.5923601698918564],
            [13.813952463227402, 1.5877718127573208],
            [13.807906119183434, 1.577912206313401],
            [13.806677361932138, 1.5740596471086055],
            [13.797523732760077, 1.5594980693174711],
            [13.803159263941417, 1.554700256941112],
            [13.808187724825101, 1.5537370168151075],
            [13.810461870550611, 1.551014747366988],
            [13.816305432525823, 1.5486829433560019],
            [13.810686758245804, 1.5412881733120476],
            [13.804217388272303, 1.5294896499735582],
            [13.798668484713355, 1.5171851011623974],
            [13.797751900762398, 1.5117278184209586],
            [13.792411955558876, 1.4968832788980555],
            [13.788582998857278, 1.4937396327507793],
            [13.787400938403982, 1.488447003827073],
            [13.781372537245646, 1.4926075886153183],
            [13.778067067299345, 1.498556186622123],
            [13.772771455947886, 1.4954706650739293],
            [13.769861925089145, 1.5036768994708019],
            [13.763290929852147, 1.500681678547542],
            [13.762205842489841, 1.4941924341692192],
            [13.759151767670305, 1.4854992525412938],
            [13.75272614057184, 1.4856667462201203],
            [13.749729386690879, 1.477455889122481],
            [13.748957724643173, 1.4702202269085467],
            [13.747093538983922, 1.463316782948666],
            [13.742976681640519, 1.4566087649194652],
            [13.740769809368224, 1.4482178557841354],
            [13.734915083112321, 1.4384283437570393],
            [13.729094462366048, 1.4368093126853587],
            [13.723865790217701, 1.426427165229988],
            [13.718671583937363, 1.4250907047327013],
            [13.71159346186119, 1.4131145127803475],
            [13.708636121292722, 1.4136762487712267],
            [13.707091177022258, 1.4174328051975809],
            [13.7062878643805, 1.427974914078456],
            [13.705142036947336, 1.4314620007191412],
            [13.704464887293494, 1.4420148821006447],
            [13.701979914431673, 1.4386210217174047],
            [13.690251242286308, 1.4322366419426225],
            [13.683514425237956, 1.419451149112602],
            [13.679843598936014, 1.402871487806855],
            [13.670686347356266, 1.3942282163371216],
            [13.666092651342389, 1.3919049319157268],
            [13.660699815870634, 1.3835546920345252],
            [13.659354803486446, 1.3755814373856032],
            [13.656406740250546, 1.3719768208705465],
            [13.650677318881733, 1.3520157735260208],
            [13.649773092837052, 1.345119914451345],
            [13.645397921177741, 1.3251990555437358],
            [13.639983569660536, 1.3071823934731341],
            [13.638287809477848, 1.3039083110608207],
            [13.63141557745487, 1.2857016619179389],
            [13.62119099540673, 1.2510156056598523],
            [13.510771751568264, 1.320346950756571],
            [13.506866691467069, 1.3148299819754243],
            [13.508765366257213, 1.3096974544322386],
            [13.506871239644756, 1.3057012004360813],
            [13.506141356125532, 1.2932597093909362],
            [13.502473508636156, 1.288391335990484],
            [13.497150366194644, 1.2848656139599348],
            [13.495293867975493, 1.2756062173883693],
            [13.4959766974486, 1.2700876803597396],
            [13.497954790961654, 1.2652142504536095],
            [13.495930370222363, 1.2581812859494035],
            [13.49164562927396, 1.2562798528498398],
            [13.48126808094833, 1.2555368952631991],
            [13.476032756816158, 1.2480287386823616],
            [13.475984387236434, 1.2452505423134477],
            [13.479919031791605, 1.2408307565994172],
            [13.480962171194472, 1.2354796903212624],
            [13.478151013614417, 1.233229427002882],
            [13.478636826459523, 1.2235723755678634],
            [13.410823391783374, 1.2646445236290318],
            [13.416361148370418, 1.2768348997159031],
            [13.415990110415828, 1.278757953384426],
            [13.4234687373733, 1.2891396021023604],
            [13.423571937676718, 1.291619550659977],
            [13.42988834494444, 1.3061892995385225],
            [13.43322467932165, 1.316838747536044],
            [13.439933638369748, 1.3278908839532773],
            [13.440141908014619, 1.3350051449926208],
            [13.436311262539595, 1.3380084321034715],
            [13.436806684926022, 1.3417897301356574],
            [13.433354348061894, 1.351835207079614],
            [13.437713210306418, 1.3562549371442936],
            [13.441023483265202, 1.3575222782048126],
            [13.451116929282923, 1.3780058744861334],
            [13.456277818529975, 1.3867296013845665],
            [13.457230217719163, 1.3910038536211569],
            [13.417387766530556, 1.4572768648828818],
            [13.41597464030838, 1.4605966768736387],
            [13.416939677544153, 1.4643595736142279],
            [13.414527566337572, 1.466899768815268],
            [13.413797949579777, 1.4731267518317972],
            [13.416374183930014, 1.4792304631099498],
            [13.404547300169313, 1.4941259513679839],
            [13.406658184016193, 1.5028118780515365],
            [13.408450922196481, 1.5063132722823591],
            [13.408914936762839, 1.512510683416442],
            [13.41081440006064, 1.5150346058720436],
            [13.412203567109158, 1.522370685271029],
            [13.407402903321929, 1.5295057604794495],
            [13.410665380478525, 1.5309131034798718],
            [13.41389482010798, 1.534672270127315],
            [13.415087293808753, 1.5406296734827332],
            [13.413742704072128, 1.5459252625002606],
            [13.418747633304713, 1.5498003507700209],
            [13.422445806106055, 1.5591832599051],
            [13.419838368194473, 1.5628155133907893],
            [13.42225328923831, 1.5684806310191852],
            [13.426003428142577, 1.573667669463874],
            [13.429838779871154, 1.581845363030085],
            [13.427511954354504, 1.5852201869016145],
            [13.426543760323804, 1.5924507718464211],
            [13.427827935540094, 1.5967299853946368],
            [13.431119557960493, 1.600992925843813],
            [13.432052913278087, 1.6049638895110285],
            [13.426073442192966, 1.6086313518628008],
            [13.425074034214191, 1.6124648885818393],
            [13.428234259452331, 1.6175501085138164],
            [13.432243084736536, 1.634681373659908],
            [13.435692901472494, 1.6406367269087963],
            [13.438433642100142, 1.647489769745968],
            [13.437895128109442, 1.6504690261836708],
            [13.440146013515692, 1.6574378062454131],
            [13.443054501348044, 1.6620653434337842],
            [13.441390048331908, 1.6656615133375983],
            [13.44446859765851, 1.6772359310328746],
            [13.443135315318518, 1.6793289856236668],
            [13.445936197974754, 1.6844870059394101],
            [13.44524663998924, 1.68679791477665],
            [13.449036628834396, 1.701513253533857],
            [13.451781872381337, 1.7071456504995917]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.85790880038823, "lat": 39.00751617403295 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54031"],
        "coty_name": ["Hardy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardy County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01718557"
      },
      "bbox": [
        13.404547300169313, 1.2235723755678634, 13.835296478680828,
        1.7071456504995917
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.205568308033676, 0.04795229102835166],
            [11.23355980981876, 0.06195586254722302],
            [11.253709912911322, 0.07363612714704613],
            [11.292523534748783, 0.09399126607028077],
            [11.298073029378694, 0.09391640057548903],
            [11.298574116852317, 0.09695882746392073],
            [11.312481337879806, 0.10448670479185619],
            [11.323371326294346, 0.1066085325723582],
            [11.328171953526034, 0.11036867491254358],
            [11.332719460885055, 0.10970304661351167],
            [11.333255373593527, 0.11335646743999567],
            [11.335837826765367, 0.11560943938667925],
            [11.340697892267757, 0.11446287560077818],
            [11.347041711789007, 0.1152987986853712],
            [11.354401151841927, 0.1209107485598699],
            [11.358589229151699, 0.11830673952364294],
            [11.363525261269027, 0.12062258926729093],
            [11.365952228098813, 0.1171671346890601],
            [11.369342003154355, 0.11800597105245748],
            [11.370595558291063, 0.12175338949181069],
            [11.37819675277894, 0.12304761742258737],
            [11.380272431707093, 0.12119419595738988],
            [11.397388385557154, 0.1279157660295769],
            [11.377712389528137, 0.1062187827596721],
            [11.366103201386007, 0.08870496394739592],
            [11.36625732148358, 0.08350997732475064],
            [11.368813792802285, 0.08011248580286358],
            [11.377846975833343, 0.07614767695039215],
            [11.380231410489657, 0.07762538624884378],
            [11.388547641919535, 0.07477920969497454],
            [11.3913427259704, 0.07243878144333392],
            [11.40117916118857, 0.07951956077784625],
            [11.411754253207613, 0.08058610332469189],
            [11.420378223624214, 0.08044389436037747],
            [11.422085500615474, 0.07641053815571519],
            [11.428977129543481, 0.07519475482105502],
            [11.430783373385077, 0.06699514430022292],
            [11.426443146321233, 0.0641147327778441],
            [11.424434075419668, 0.06070462850981143],
            [11.431270266054222, 0.055827288001984054],
            [11.43899955880158, 0.05735118795488412],
            [11.441710772597279, 0.05605861239520095],
            [11.446428199541788, 0.0599234885651926],
            [11.451019229768868, 0.05996731773654058],
            [11.453787304720386, 0.061697913104083825],
            [11.464082238803993, 0.059207819546873514],
            [11.499506081606087, 0.06342471437947456],
            [11.505793858155883, 0.05944931085312063],
            [11.511050484149143, 0.057586204686090714],
            [11.511840350092188, 0.0544372439974197],
            [11.522030802914298, 0.05495052308471201],
            [11.524072899885807, 0.056075177706468075],
            [11.529017646135223, 0.05314397713411323],
            [11.527402087529586, 0.050755873866742005],
            [11.530996222388636, 0.04578296739318409],
            [11.53514241530606, 0.04395715338151952],
            [11.536967595099696, 0.04076017969515661],
            [11.537729825209471, 0.034134902580067995],
            [11.542025695141966, 0.03498821681759968],
            [11.547194782691555, 0.03372579248628579],
            [11.545133121892285, 0.027491292523591754],
            [11.550648657470564, 0.019745169751656723],
            [11.550889492405544, 0.009773090938131938],
            [11.546232589232288, -0.00022315672936739226],
            [11.543553607531718, -0.0018527769015427497],
            [11.542885189045785, -0.006855573326615137],
            [11.536703439093515, -0.010953386905509602],
            [11.537114661885948, -0.012627502908433614],
            [11.545859738976144, -0.01661840649909604],
            [11.544363758953423, -0.019805638159980623],
            [11.544977092699929, -0.02492149245140485],
            [11.550412136258746, -0.022161297933822925],
            [11.55531840372046, -0.028467605295437685],
            [11.561070128761052, -0.027803504155931465],
            [11.56323672198849, -0.031152895604363625],
            [11.568660541971287, -0.031456921504377136],
            [11.568973584989864, -0.0387629023903334],
            [11.571851652512628, -0.04629303874829869],
            [11.576232510266795, -0.049103283979793716],
            [11.58275746461891, -0.048831495110502644],
            [11.584197280940982, -0.05259681704074061],
            [11.582946928951333, -0.05636054446418712],
            [11.590227636240789, -0.05967618780652522],
            [11.591504693620204, -0.06323627598648052],
            [11.59489851839971, -0.061088394237231544],
            [11.59758550047173, -0.06211139716275591],
            [11.602823878970291, -0.058560266544135306],
            [11.606553489923412, -0.05288827141753602],
            [11.606802197684674, -0.047743763006547896],
            [11.61382325679049, -0.047087620786291154],
            [11.616383390007726, -0.044145768378209084],
            [11.6208575600367, -0.04234322279356802],
            [11.621738849553246, -0.037204599060143645],
            [11.625406612723202, -0.035830545409338256],
            [11.62751709596387, -0.03826677512210247],
            [11.631741319254814, -0.03691001851612638],
            [11.63252485234298, -0.03321598136972755],
            [11.636110657452127, -0.03338594263050582],
            [11.650315941206879, -0.03990739798013436],
            [11.648990349212285, -0.0441949498805215],
            [11.652209658490975, -0.04871011636374597],
            [11.654589307086308, -0.049267185955696],
            [11.66182905703433, -0.05419031438655821],
            [11.662683288360366, -0.05875896786590201],
            [11.668213133280238, -0.06128728615284699],
            [11.670398040387212, -0.05952418559074421],
            [11.677767874197006, -0.06269070670324244],
            [11.679102402717316, -0.06728821558294247],
            [11.684105993334477, -0.07050871434930601],
            [11.679643212575144, -0.07394764785588973],
            [11.676316429232967, -0.07445500665802368],
            [11.672516413693941, -0.07860955329494478],
            [11.669088709732168, -0.07586320011859031],
            [11.664993978928429, -0.08016434633003414],
            [11.662196228392654, -0.0851870263543522],
            [11.657248185461503, -0.0844081152993258],
            [11.649678830589604, -0.08617266638346639],
            [11.647081924666649, -0.08523974213028482],
            [11.641155582570828, -0.09104348896419882],
            [11.637468626853915, -0.08762020812202384],
            [11.634229320336324, -0.09444497528018252],
            [11.62806560218826, -0.09190909602432826],
            [11.619545634942162, -0.09524459593834715],
            [11.617450904849294, -0.10179260019853585],
            [11.61293124665624, -0.10289243099343232],
            [11.610288849246691, -0.10573798135918698],
            [11.596537146290057, -0.10904592953479784],
            [11.59494278239324, -0.11367883475860552],
            [11.589163685056455, -0.11159118555930976],
            [11.585011968334413, -0.11293380379643313],
            [11.582699500724855, -0.11073010418927617],
            [11.576548577659212, -0.11666371935604294],
            [11.57546577914507, -0.12050383526805629],
            [11.569476646603938, -0.12069317118890034],
            [11.568202181907177, -0.1258896713858027],
            [11.570224005769676, -0.12721854581945097],
            [11.624435199526017, -0.16875514272012987],
            [11.61612103790376, -0.1724661521391054],
            [11.61312230483966, -0.17097976727987943],
            [11.606128843352735, -0.17765562424971032],
            [11.601270158493483, -0.18063751757451432],
            [11.60282237045787, -0.18775609632630003],
            [11.600003749557677, -0.1916547515039044],
            [11.595523588475016, -0.19243416141510353],
            [11.592706456151745, -0.19582159054493858],
            [11.588436974555627, -0.19064535150469425],
            [11.585044600616518, -0.19074918432550797],
            [11.581439405851976, -0.19731887623231217],
            [11.574929400021405, -0.2019776576301935],
            [11.571387455636714, -0.2005715145021289],
            [11.56792557414425, -0.20231894048096674],
            [11.568122855182612, -0.2067825691969363],
            [11.565472576848391, -0.2070799038262279],
            [11.56275886573487, -0.2111651655081912],
            [11.558939984640924, -0.20949377531310767],
            [11.552177046976528, -0.22143970168046484],
            [11.547748323533972, -0.22083164089010385],
            [11.544041842369142, -0.22797256315878997],
            [11.536894171088864, -0.22261480054404012],
            [11.530743751556724, -0.22012110563522233],
            [11.527683771934734, -0.214603980778049],
            [11.52322555551864, -0.21394589666988978],
            [11.517873935399312, -0.22196015784351283],
            [11.511940034054113, -0.22171163726775103],
            [11.505966516925639, -0.2164591358472205],
            [11.501290313175007, -0.2102910306987445],
            [11.496462903111803, -0.20989198326673805],
            [11.49453584821539, -0.21395850685235565],
            [11.495560922553347, -0.21921667757747215],
            [11.490523116310815, -0.22262555779715312],
            [11.484282057376511, -0.22488664681960271],
            [11.482097676874272, -0.23042060323091426],
            [11.475006590602103, -0.2322973623122221],
            [11.47174406721883, -0.23115116929999188],
            [11.469871046028597, -0.22551010121888063],
            [11.465290079840742, -0.22190599450522666],
            [11.466548118654572, -0.21865511772263255],
            [11.463071505371923, -0.21447761290893497],
            [11.458533908221236, -0.21433813332097976],
            [11.455981802848967, -0.21635253993761827],
            [11.450278169236277, -0.21474886173710162],
            [11.444665999006693, -0.2201839817760592],
            [11.444551920750634, -0.2236722567472254],
            [11.440575897933211, -0.22721320154935443],
            [11.435776721874351, -0.22487738625508022],
            [11.431781484930857, -0.2246554471138364],
            [11.430252011981763, -0.23163553695264075],
            [11.425932611434584, -0.2332848424143528],
            [11.42493811325066, -0.2361892511197329],
            [11.418865369984232, -0.23372325193424215],
            [11.413855260200181, -0.23467205928383333],
            [11.41134397586899, -0.23963916840857183],
            [11.409973897543141, -0.245355448500017],
            [11.40603720758961, -0.24553165126561569],
            [11.40682998033547, -0.24980371471842858],
            [11.410669061285757, -0.2527046445298285],
            [11.407624499743207, -0.2567195776922001],
            [11.408428174328979, -0.2611023108501025],
            [11.401936457656163, -0.26054063325518695],
            [11.40057025410451, -0.2514239101064863],
            [11.398136651109583, -0.25070591161513595],
            [11.398298042469596, -0.24243955555285315],
            [11.393507918876915, -0.24033252415706552],
            [11.391126683525012, -0.24144513799243503],
            [11.386541186246333, -0.23837431431450576],
            [11.380693100930026, -0.2392408326895918],
            [11.380583415845505, -0.23286261219983626],
            [11.378025938295272, -0.23143049382857214],
            [11.37802213672394, -0.22620544664973916],
            [11.374871661866905, -0.2230195281939681],
            [11.370992796997491, -0.2226495699166244],
            [11.36801359259281, -0.2155222379482646],
            [11.36586269465637, -0.21640914278971568],
            [11.361323553772577, -0.20797412318550743],
            [11.356850698248145, -0.20718511111432006],
            [11.354064975070397, -0.2101571219853883],
            [11.350153815123003, -0.20968481354303606],
            [11.346905928871232, -0.2064480642006925],
            [11.342850305783239, -0.20668985316393304],
            [11.336904792401791, -0.21174253704550472],
            [11.331553399124532, -0.213869331117134],
            [11.325870089374712, -0.20759094979069853],
            [11.326503470941786, -0.2005606429659485],
            [11.32251304377899, -0.19738967038494387],
            [11.323961622226161, -0.19299415451931806],
            [11.319324343846999, -0.19150670816473764],
            [11.323135668585554, -0.18774177789169258],
            [11.321828514560282, -0.18233987194136986],
            [11.316711165958484, -0.18193059949137766],
            [11.315132992973338, -0.18000434385583974],
            [11.31787672003207, -0.17599272180027584],
            [11.316652659954817, -0.1731068802758026],
            [11.310919021492525, -0.17023941307753468],
            [11.30735950628826, -0.17100665106273438],
            [11.304229612954476, -0.1664619949722501],
            [11.296742006074982, -0.17161008927288446],
            [11.29611834586566, -0.16605335323509318],
            [11.299763880560546, -0.15722167408886495],
            [11.297484698740238, -0.15504825556534396],
            [11.297977101039152, -0.15091544757515635],
            [11.302389733565688, -0.15160704726637214],
            [11.305891129461296, -0.14944192609325804],
            [11.302773485108256, -0.14653987710667382],
            [11.302337863361863, -0.14239971820181485],
            [11.30387530643915, -0.13910808736029653],
            [11.301304095263106, -0.13714728409222818],
            [11.30363657046147, -0.13409274625971696],
            [11.303307389391078, -0.12937142000214197],
            [11.29776830864426, -0.1288918428164279],
            [11.298233553511196, -0.12469151378918679],
            [11.300694278913957, -0.12229588532938833],
            [11.300020834463542, -0.11874907262638362],
            [11.296634066603009, -0.11590190326911333],
            [11.289512853597383, -0.11573441249998555],
            [11.286381254706896, -0.11297791593510284],
            [11.283105441762027, -0.1143477217938643],
            [11.28047508595258, -0.10838790026040639],
            [11.273881762716746, -0.10980306588749594],
            [11.273894314695802, -0.10410385222232058],
            [11.270818569449379, -0.09906154039350029],
            [11.271411726356728, -0.09398332989416004],
            [11.266488372454594, -0.0904065580736703],
            [11.266060566110271, -0.08708488729574201],
            [11.260006478186696, -0.08380757022229587],
            [11.263795727402709, -0.07762226842163425],
            [11.267542713131565, -0.07666257223213124],
            [11.267517986924602, -0.07373995385636041],
            [11.275182416870337, -0.06973613414632615],
            [11.27701198785916, -0.06744613169746798],
            [11.282608643399366, -0.06565928501853137],
            [11.281932214819076, -0.06082067295085027],
            [11.277187135363535, -0.058820039003472435],
            [11.272022175241291, -0.047620213925177346],
            [11.267571866960214, -0.04188194976506903],
            [11.271830550736277, -0.03775283873008235],
            [11.274932692534648, -0.03677908858273187],
            [11.271398002378637, -0.03191074748358591],
            [11.272122665001067, -0.026370014052780458],
            [11.267735356727387, -0.02042666687659822],
            [11.26363468355435, -0.018728890188816395],
            [11.254418660440768, -0.020798384185789023],
            [11.25138728755789, -0.020468814196393136],
            [11.245046691097787, -0.015611367608800436],
            [11.239099453438158, -0.015578501726821374],
            [11.235547182601625, -0.011348376113604678],
            [11.233829384307457, -0.005658157234708823],
            [11.234079245645647, -0.00023773923021427434],
            [11.227709040642145, 0.0018240498238711335],
            [11.225543045356872, 0.005195164346099609],
            [11.22552343894082, 0.011551708763239976],
            [11.221723956695206, 0.0118125921369958],
            [11.212415796769099, 0.019429920304570986],
            [11.216433154368627, 0.024544362405340876],
            [11.21323516361271, 0.029036228004579258],
            [11.20890922523628, 0.02864188859220227],
            [11.207056075542909, 0.0319121436902482],
            [11.202188031428005, 0.03539866872521579],
            [11.2064032723243, 0.04433812302091667],
            [11.205568308033676, 0.04795229102835166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.93550639817697, "lat": 37.83133274198771 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54045"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01550029"
      },
      "bbox": [
        11.202188031428005, -0.2611023108501025, 11.684105993334477,
        0.1279157660295769
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.47749511298369, -0.38405205276481036],
            [11.481525156921172, -0.3837515567261226],
            [11.484889117954125, -0.3767786850185643],
            [11.488336997610133, -0.37322860029949917],
            [11.489512445030947, -0.36715181320770346],
            [11.498833865635131, -0.3684239013553304],
            [11.502154424227635, -0.3670504567253412],
            [11.505007046261998, -0.3634250477898533],
            [11.506233072096316, -0.3547090117974002],
            [11.508432391018633, -0.3528831394600115],
            [11.513798507592872, -0.35320314000805225],
            [11.519162020559838, -0.3513789536779802],
            [11.521039354223756, -0.3458903644490987],
            [11.527795867698567, -0.33905770145235675],
            [11.532384434366348, -0.34000335812747084],
            [11.53837133587804, -0.33757353665148054],
            [11.541733599680962, -0.34146064267384674],
            [11.54625435636402, -0.34935920518612],
            [11.552727951895811, -0.34910167815267706],
            [11.555680007823721, -0.3544785000325967],
            [11.556975650675923, -0.3620432964146585],
            [11.555258952144587, -0.36383291843969434],
            [11.553963818822824, -0.3710731539008666],
            [11.557779795936705, -0.37162307796798527],
            [11.563652011561686, -0.3768672278738734],
            [11.572190639677196, -0.37394825563620737],
            [11.576397968272113, -0.37392782232725635],
            [11.580821746462256, -0.37111844822797174],
            [11.583013552332703, -0.3767101226014727],
            [11.59362479976692, -0.3779859983009757],
            [11.596333401930721, -0.3734602246479147],
            [11.600294600222153, -0.3727168137943705],
            [11.605765594297312, -0.37448117976356216],
            [11.614753831758954, -0.369165950571712],
            [11.618956600887586, -0.3736188636126495],
            [11.62151219496583, -0.37358401081764],
            [11.628391660182738, -0.37811398332126006],
            [11.634079630892739, -0.37844450725495593],
            [11.637119635909604, -0.3757694062154971],
            [11.641265962448959, -0.3766032870348742],
            [11.647586398830974, -0.37376293894323165],
            [11.651215425583478, -0.37522511262912933],
            [11.654581878868159, -0.36814383048464583],
            [11.659645954853303, -0.36747817172134517],
            [11.66710278025128, -0.3621584382172812],
            [11.662877126316962, -0.35473207990175437],
            [11.669402416793305, -0.3490435428139429],
            [11.675717229218575, -0.34981985089084283],
            [11.681777859079459, -0.3436899176687235],
            [11.68811999024749, -0.3409892660183203],
            [11.690923642810942, -0.3427077457819788],
            [11.69264694725405, -0.34724616454469065],
            [11.695680485529062, -0.34995094548360145],
            [11.699648433123823, -0.34730418311860867],
            [11.703065596006356, -0.3514824381466087],
            [11.70963773328238, -0.3497663845316889],
            [11.70786612880055, -0.3454398424301058],
            [11.711350006687345, -0.3432746848460907],
            [11.714063437508834, -0.33918388641699465],
            [11.717076393913722, -0.3386223642632162],
            [11.721675125673219, -0.3427218532989041],
            [11.722278170634738, -0.34875864361036973],
            [11.729914463035946, -0.3493299307606993],
            [11.72745097343187, -0.35297462300017585],
            [11.731482959708847, -0.3625055558274486],
            [11.738549986065182, -0.36659322475882405],
            [11.744457236577652, -0.36180095469110274],
            [11.746215009013417, -0.3658808636599134],
            [11.749171331927288, -0.36845572487682077],
            [11.754687287735056, -0.36399616421634057],
            [11.758096966656781, -0.3670121361443624],
            [11.762562365627659, -0.3631079587324581],
            [11.767911853065355, -0.36394186747325047],
            [11.771340493777585, -0.3604706137171891],
            [11.773620905689873, -0.36376925950771105],
            [11.781513259740786, -0.3630224792749792],
            [11.78696181741462, -0.36467451689831315],
            [11.793283063643893, -0.3725966611374109],
            [11.800916016326738, -0.3699446699253314],
            [11.803653138283504, -0.37134993865353466],
            [11.809861083139463, -0.36952064033471305],
            [11.816353558270169, -0.3720298809926525],
            [11.821170376407864, -0.3638146475556103],
            [11.830079852480267, -0.36434781479316586],
            [11.83343191926451, -0.36018524921019596],
            [11.840469371154958, -0.3571046005694868],
            [11.847682384277618, -0.3586551499717817],
            [11.850264713897834, -0.36262777919237044],
            [11.853915827128548, -0.3637074636254148],
            [11.850390261688533, -0.3709639996275672],
            [11.851631952862329, -0.37428105408918344],
            [11.856318402812798, -0.37813948265827885],
            [11.85934009110834, -0.3782688650002008],
            [11.863250316388703, -0.3811187468009516],
            [11.867719617664923, -0.38624234834475707],
            [11.87164314092184, -0.38790665849140915],
            [11.873900190812194, -0.3854674526077431],
            [11.873539767906914, -0.37980949610887044],
            [11.874931156014643, -0.3757138413512999],
            [11.878950117630255, -0.37650468802771053],
            [11.880227114060526, -0.38013888859886297],
            [11.885223360628414, -0.37659006222451596],
            [11.893211126745717, -0.37525797217847134],
            [11.896075134777835, -0.3691782901053988],
            [11.900889074855765, -0.37318925411148895],
            [11.906583661390084, -0.3708119700926916],
            [11.909881405030358, -0.37960048934599394],
            [11.91780494293258, -0.3873793594505972],
            [11.931071938500065, -0.38886420999997806],
            [11.93464008484095, -0.3911805048798867],
            [11.938146478187836, -0.3908187071926481],
            [11.94131848355255, -0.3937838640600541],
            [11.947567226988415, -0.3932876625448529],
            [11.953503284462116, -0.38997311009616875],
            [11.956911904360899, -0.3937633896942769],
            [11.969914690942316, -0.39855407136571386],
            [11.943765857877846, -0.49134285508592646],
            [11.940802449732686, -0.4936012311424831],
            [11.939337601583391, -0.4993044726933147],
            [11.941097590737352, -0.5020958101633394],
            [11.93874059421497, -0.5059908620937892],
            [11.93714840605732, -0.5118588045042839],
            [11.93282916007563, -0.5133215139383841],
            [11.927309675443446, -0.5114836302666215],
            [11.922053905265022, -0.5164493835429341],
            [11.919629965791977, -0.5227264838108602],
            [11.921925758346283, -0.5286415218588353],
            [11.916389927350187, -0.5353266417193191],
            [11.917738251093986, -0.5373627250245826],
            [11.914154335321994, -0.5545379106790669],
            [11.911154871630783, -0.5562197606314477],
            [11.911304391370223, -0.5622492957665638],
            [11.902856155547147, -0.565802005136564],
            [11.89521135310994, -0.5638667865159424],
            [11.893551616323903, -0.5673812028009734],
            [11.889434999133586, -0.566562841135085],
            [11.883026955532449, -0.5729663468842452],
            [11.87827924992561, -0.5752023405943921],
            [11.877959574906933, -0.5810013970616076],
            [11.867534467880617, -0.5874828701138418],
            [11.865257337103607, -0.5919260569746209],
            [11.855821134530341, -0.5935427325409136],
            [11.850767155301575, -0.5905412239199075],
            [11.847077765207272, -0.5932332972506447],
            [11.84579888779354, -0.6017146971338315],
            [11.846726950077388, -0.6068810865878106],
            [11.845787238797298, -0.6138780405042275],
            [11.837345162324382, -0.6209463165010799],
            [11.83226841581191, -0.6228461400814178],
            [11.828262072105753, -0.6259154787042078],
            [11.819807563405616, -0.6299218230971882],
            [11.814548078907475, -0.6433101556490385],
            [11.809342957517694, -0.6459254133078308],
            [11.71844009559674, -0.6650750950722253],
            [11.713864147042246, -0.6615152087383233],
            [11.712458309583614, -0.6561638100622178],
            [11.710044920334601, -0.6544804081816907],
            [11.703427474041817, -0.6550093404377769],
            [11.699731363351267, -0.6508404680865694],
            [11.685052264586027, -0.6422703544078134],
            [11.683809349985667, -0.6367908940558575],
            [11.677565323485924, -0.6314332997332632],
            [11.669925294634442, -0.6350052834482782],
            [11.66517444803888, -0.6349986213543111],
            [11.660932997416225, -0.631870562021583],
            [11.660555714216551, -0.6267472307170792],
            [11.661554985176293, -0.6200086636042038],
            [11.657455699661627, -0.6164689765373604],
            [11.65611264026997, -0.6110841080153763],
            [11.651843620236704, -0.6101625705130821],
            [11.646244419987969, -0.6060258990354533],
            [11.645564556717547, -0.6020510952324674],
            [11.642095657199368, -0.6008285735521407],
            [11.637579641265747, -0.6030386717339535],
            [11.632155205253655, -0.6032533410960816],
            [11.628129876544492, -0.6012185903327626],
            [11.6244102748258, -0.596483719790783],
            [11.619325076505882, -0.5953751413382986],
            [11.608206197957303, -0.5955175501048291],
            [11.6055348421744, -0.5987182550396296],
            [11.59644321870485, -0.6039286713276899],
            [11.59218535714577, -0.6044409039156379],
            [11.584522541893909, -0.6033180035544135],
            [11.584935982605801, -0.6004256353292216],
            [11.580491518519967, -0.5992468711665824],
            [11.574476636235186, -0.6018790519778211],
            [11.568764522452957, -0.5996196485456158],
            [11.566732979303055, -0.5865716271811142],
            [11.565230947977671, -0.580884211866097],
            [11.561478334495288, -0.5832896511798111],
            [11.556510112701954, -0.5798746132323033],
            [11.559338524810382, -0.5724304534477936],
            [11.552996656562854, -0.5681501292854162],
            [11.550876447278858, -0.5686422810657463],
            [11.547856464727182, -0.5646042437865414],
            [11.543297205047311, -0.5614356642521311],
            [11.54257317359495, -0.5585668777731142],
            [11.531090883476649, -0.5619670772576655],
            [11.529077719158938, -0.5603670413234118],
            [11.524993150080412, -0.5516512361801211],
            [11.518052148257977, -0.5499511231927945],
            [11.514994041195306, -0.5453583211096225],
            [11.510383661062294, -0.5454167240533957],
            [11.5055191474403, -0.5389176857343418],
            [11.502215796735785, -0.5384988429776547],
            [11.499497921963235, -0.5355056346248837],
            [11.500307389217543, -0.5313288524853199],
            [11.494399947434136, -0.527388061170929],
            [11.493493459018072, -0.5240460274669004],
            [11.495295291572004, -0.5210015550946587],
            [11.49109001753226, -0.5184759607302359],
            [11.490532303934094, -0.5138701139676872],
            [11.49321958932769, -0.5110887462877887],
            [11.490836760746443, -0.5061628699420427],
            [11.494333927858376, -0.5023816545822437],
            [11.494093748650084, -0.49811534463259916],
            [11.491608040124644, -0.49481380795983565],
            [11.491645546254071, -0.4910971965606526],
            [11.495606876953573, -0.48813578142483066],
            [11.49584318443105, -0.48425572284848023],
            [11.488279849143051, -0.4814654644574684],
            [11.484092914625746, -0.47728827966847304],
            [11.4799300817673, -0.468579624494241],
            [11.482911881699316, -0.4606499123244069],
            [11.47956253774611, -0.45699094547340474],
            [11.474216327337908, -0.45804168948402674],
            [11.470600968698466, -0.45299277151246314],
            [11.463014332962008, -0.4517149052298113],
            [11.455997110098538, -0.45424113229098484],
            [11.454629604260035, -0.44943919248194614],
            [11.450384407043375, -0.4454019730083978],
            [11.445058152331505, -0.4450287752303004],
            [11.441694656591114, -0.44848380040122027],
            [11.438920891165786, -0.4444591918163736],
            [11.43497780509958, -0.44274267806695683],
            [11.433314823827512, -0.43529860968363737],
            [11.431028500060652, -0.4342261674561953],
            [11.42928751898654, -0.42746942526445114],
            [11.431630732810428, -0.42396521803926535],
            [11.431205471765308, -0.4207902588483801],
            [11.436409885404307, -0.4172489513996735],
            [11.442873606499075, -0.4173891237362161],
            [11.443843353341716, -0.41408951214597844],
            [11.447689236153195, -0.4127276318115965],
            [11.451352610758896, -0.40705801603845126],
            [11.457688472012771, -0.4081407464956858],
            [11.460719049853635, -0.4074252227951672],
            [11.458888916488846, -0.39947022610956756],
            [11.460302931116932, -0.3969851355217047],
            [11.466325692440419, -0.39519076756227045],
            [11.466154176729898, -0.3894174888929058],
            [11.474019973601967, -0.38482298816061555],
            [11.47749511298369, -0.38405205276481036]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.65360725389573, "lat": 37.37844541787213 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54047"],
        "coty_name": ["McDowell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McDowell County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01689162"
      },
      "bbox": [
        11.42928751898654, -0.6650750950722253, 11.969914690942316,
        -0.33757353665148054
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.000213330250569, 2.399254611613877],
            [12.008822141814768, 2.4255221209542603],
            [12.01141325258845, 2.429986718159766],
            [12.015162396530723, 2.4282270285262686],
            [12.021123484124557, 2.4296973559019563],
            [12.022558006742894, 2.432014191213943],
            [12.026848239600733, 2.428347503762654],
            [12.02785951375703, 2.425380396701683],
            [12.056099866768562, 2.4287027699263968],
            [12.077761565549752, 2.4319512643952677],
            [12.087737965341042, 2.430475361959244],
            [12.137227556507389, 2.4240826447179096],
            [12.150685028609667, 2.342937273007941],
            [12.160658558971544, 2.281549950292263],
            [12.117268144469692, 2.279163118286848],
            [12.11171631922765, 2.2785003196884497],
            [12.058985101240362, 2.2761769922584496],
            [12.057827963916424, 2.275819066560618],
            [12.029527316262582, 2.274487851626154],
            [11.99752338413185, 2.2722651610145483],
            [11.998179952928002, 2.2765744253729054],
            [11.996740664952547, 2.2882926358253477],
            [11.993543860202333, 2.297581050264595],
            [11.989548606890105, 2.3032672655621576],
            [11.986699302907095, 2.313735383421382],
            [11.987336700169742, 2.3183327718366833],
            [11.990869379726892, 2.325441718099042],
            [12.00243619896921, 2.337938493284842],
            [12.004094979435783, 2.340965281249892],
            [12.004887737669888, 2.3526359362092655],
            [11.999678654828264, 2.3664984971602374],
            [11.99795394667312, 2.3795377080063376],
            [11.998834207570287, 2.3932442197016557],
            [12.000213330250569, 2.399254611613877]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.61891077943731, "lat": 40.09694312398999 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54069"],
        "coty_name": ["Ohio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ohio County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01717163"
      },
      "bbox": [
        11.986699302907095, 2.2722651610145483, 12.160658558971544,
        2.432014191213943
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.871319205914399, 4.73793142382602],
            [5.927908053312714, 4.742029075140254],
            [5.956631114798922, 4.743317516209683],
            [5.984694376873123, 4.744425392051748],
            [6.027683722293987, 4.7472883875203715],
            [6.06649152379124, 4.750707754133363],
            [6.10044587718307, 4.753272639463975],
            [6.1603905626789075, 4.757145859302435],
            [6.177160881735317, 4.758431282491944],
            [6.213182729238676, 4.76164356516031],
            [6.214192458061459, 4.743189921636874],
            [6.216123126570831, 4.717528807441166],
            [6.217134903601896, 4.694913006624332],
            [6.221797891411076, 4.628808725069535],
            [6.2250930737716885, 4.585941982128404],
            [6.227490104163409, 4.543156527191323],
            [6.231160878426895, 4.493310072870576],
            [6.2359019841471195, 4.436802071374298],
            [6.237663323919752, 4.412857273364723],
            [6.198659557873849, 4.409513451944939],
            [6.151854065078289, 4.4052697537322],
            [6.126745988186363, 4.402439278085164],
            [6.065977647740218, 4.397520248388595],
            [6.038711570463971, 4.396080838030221],
            [5.98042616127558, 4.391148413877938],
            [5.951760103679089, 4.388874294297419],
            [5.895034585700024, 4.384811806925715],
            [5.89284051336021, 4.407867625964566],
            [5.8896991298346535, 4.44675492452967],
            [5.885570191650542, 4.501846013916399],
            [5.884631914117355, 4.516545064415953],
            [5.8810958987743, 4.561121585736791],
            [5.880298398008144, 4.5773501417369795],
            [5.874290270637265, 4.669595672964549],
            [5.873091076672109, 4.692934097241617],
            [5.871319205914399, 4.73793142382602]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.30451446905329, "lat": 43.01822004421204 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55133"],
        "coty_name": ["Waukesha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Waukesha County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01581126"
      },
      "bbox": [
        5.871319205914399, 4.384811806925715, 6.237663323919752,
        4.76164356516031
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.799627593078929, 5.209055617054081],
            [-6.755989008790898, 5.204945186338922],
            [-6.74394347896311, 5.203507186583074],
            [-6.65413993719811, 5.194457454349448],
            [-6.517206784079088, 5.181067629834726],
            [-6.3846208679209875, 5.168437000390711],
            [-6.381230602096785, 5.168371967985132],
            [-6.346036369338844, 5.164736677691519],
            [-6.292692845605869, 5.160069927896718],
            [-6.203854726857834, 5.1517242516526185],
            [-6.115018231315839, 5.143360916184375],
            [-6.082093574312701, 5.140785650304872],
            [-6.024758830141276, 5.136184152811262],
            [-5.952702059044354, 5.129760689590224],
            [-5.954631796811264, 5.10821024499923],
            [-5.963497516092502, 5.005444303281276],
            [-5.96358818584731, 4.9990327421695815],
            [-5.9749109312137465, 4.880797871557016],
            [-5.975051116199809, 4.877896884037339],
            [-5.98529955697272, 4.76276704637116],
            [-5.987617744708616, 4.748974108688852],
            [-6.007751270043953, 4.530015282998141],
            [-6.008361447724252, 4.5264420432587755],
            [-6.011149898761747, 4.496083630536157],
            [-6.01585199519342, 4.454976994743142],
            [-6.01645813000779, 4.443316093327295],
            [-6.017630640443169, 4.436404953129743],
            [-6.017520467744962, 4.4292285210887],
            [-6.019003543213292, 4.4148815562040475],
            [-6.015390582915837, 4.4143318527179884],
            [-6.02070494711975, 4.3554149209685935],
            [-6.022933460056225, 4.328188721321147],
            [-6.030977565173371, 4.2405819696054765],
            [-6.047621897762207, 4.241782721689944],
            [-6.081463127471597, 4.244785602249828],
            [-6.087068478758581, 4.245757981341045],
            [-6.163892497246798, 4.252361007062346],
            [-6.179447896058287, 4.254204292438782],
            [-6.22310592021891, 4.256635532052034],
            [-6.2364412165104275, 4.258297954262036],
            [-6.289815843026249, 4.2621659481852445],
            [-6.31820371122621, 4.264920850193083],
            [-6.326019717791818, 4.166032313887585],
            [-6.332231080768804, 4.090308777005663],
            [-6.3334294737067784, 4.090500548735647],
            [-6.36902021482971, 4.093689869972969],
            [-6.3700935642461, 4.081687477122391],
            [-6.377115447204342, 4.082338450152411],
            [-6.378481820087577, 4.068211524021129],
            [-6.3857158584775044, 4.068886126751934],
            [-6.38872748437223, 4.040429064187786],
            [-6.3956788785898055, 4.041039273358843],
            [-6.399252648590707, 3.9982146750942236],
            [-6.399028018758307, 3.983798485405263],
            [-6.413736956862084, 3.985000314734492],
            [-6.413935472907098, 3.9596075486031457],
            [-6.4143043106250115, 3.9559118473313664],
            [-6.5180535419645755, 3.9657797697554615],
            [-6.524737138535139, 3.9656112120382616],
            [-6.524224025637141, 3.972905933065618],
            [-6.531093646341128, 3.9719936330278465],
            [-6.551230203780069, 3.976787621121007],
            [-6.577239394104397, 3.979657547430659],
            [-6.576509189969334, 3.9869252281359815],
            [-6.5870979382448835, 3.9876392257002604],
            [-6.580256875415229, 4.060608127710111],
            [-6.551783327899627, 4.057607879301229],
            [-6.548785989956913, 4.086484137923955],
            [-6.534651819104405, 4.085085605965237],
            [-6.532090115915265, 4.109378133787458],
            [-6.559452876341791, 4.112661645540745],
            [-6.635955111782641, 4.120385158266061],
            [-6.68604510068816, 4.126082389029115],
            [-6.763831030051604, 4.134281962749123],
            [-6.76502878935518, 4.134637668334344],
            [-6.817102851700525, 4.140257295350998],
            [-6.8239108388620835, 4.141669398576839],
            [-6.909176951322844, 4.151033308156371],
            [-6.910964619231034, 4.151204843442771],
            [-6.908631454375516, 4.165810221542215],
            [-6.905947034047049, 4.194136294149057],
            [-6.8844640709621725, 4.399459527914666],
            [-6.883001128135195, 4.412685002028124],
            [-6.881465009401004, 4.412622921304994],
            [-6.8803155038334785, 4.423395587297774],
            [-6.881768107845718, 4.423549683018551],
            [-6.880458820684852, 4.435817105274836],
            [-6.8791421512839515, 4.439208893914475],
            [-6.877471073734815, 4.454867794195355],
            [-6.878777819657094, 4.455006419347497],
            [-6.875140788472374, 4.495266745423684],
            [-6.871927103196414, 4.495127561924886],
            [-6.8623443113991724, 4.586540914433048],
            [-6.836996316346322, 4.8429081884970255],
            [-6.8356466409477825, 4.84256461791809],
            [-6.798940552093497, 5.186945651256193],
            [-6.802084651805711, 5.187207413373226],
            [-6.799627593078929, 5.209055617054081]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.50718264747147,
          "lat": 42.972327550659735
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56009"],
        "coty_name": ["Converse"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Converse County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01605070"
      },
      "bbox": [
        -6.910964619231034, 3.9559118473313664, -5.952702059044354,
        5.209055617054081
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.75395825791655,
          "lat": 18.179766828486503
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72001"],
        "coty_name": ["Adjuntas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Adjuntas Municipio"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01804480"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -67.12052372513386,
          "lat": 18.288134338696445
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72011"],
        "coty_name": ["Añasco"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Añasco Municipio"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01804485"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.27840510444831,
          "lat": 18.436766761444094
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72051"],
        "coty_name": ["Dorado"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Dorado Municipio"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01804505"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.8667314344166, "lat": 18.268552343049066 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72081"],
        "coty_name": ["Lares"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Lares Municipio"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01804521"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -67.32755717906863, "lat": 18.17592478489444 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72097"],
        "coty_name": ["Mayagüez"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Mayagüez Municipio"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01804529"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7100150584209572, 7.396696546065375],
            [-3.7028851055917285, 7.504109523245269],
            [-3.699851963197585, 7.506230513086351],
            [-3.6985877950460915, 7.497995457585514],
            [-3.6922109658607045, 7.497284238463311],
            [-3.6862275893548753, 7.497956031770435],
            [-3.6831087105361906, 7.503926713271135],
            [-3.6751365942141025, 7.4995133871235025],
            [-3.671544634646289, 7.50611061158754],
            [-3.6667631660394373, 7.506902430078617],
            [-3.663910711904538, 7.513364167458478],
            [-3.6581431127307056, 7.5131422604556715],
            [-3.6570914093048006, 7.508794702704951],
            [-3.6527661880406472, 7.504538917342804],
            [-3.646809092620857, 7.507319289264578],
            [-3.6418689700193565, 7.504837198427207],
            [-3.641088903435058, 7.509230107892187],
            [-3.6303902368626884, 7.503128845389672],
            [-3.62894553101634, 7.508273359753005],
            [-3.6318399830695998, 7.512010862783127],
            [-3.630115718062179, 7.51543812775061],
            [-3.6174292823539327, 7.513653672749891],
            [-3.61590677432457, 7.508686027954555],
            [-3.6108908672543745, 7.511327818197421],
            [-3.6074758369260036, 7.509625150044254],
            [-3.6025153879891647, 7.512994847319178],
            [-3.6031755178582676, 7.516003287757873],
            [-3.5983086802826376, 7.517474901267955],
            [-3.5965835444554495, 7.510234489746122],
            [-3.5991745470005614, 7.5071290769196795],
            [-3.5966447137795448, 7.504799744312615],
            [-3.597194805770354, 7.498466421684385],
            [-3.5951490498574574, 7.495691575529691],
            [-3.6019340466755803, 7.492001033297587],
            [-3.5975603534681664, 7.488477778238412],
            [-3.5951826873793706, 7.477768712070568],
            [-3.5876242029427723, 7.47698562192353],
            [-3.586476965447018, 7.48141572636858],
            [-3.583776987634241, 7.480696962026429],
            [-3.5765571183855025, 7.470976392870789],
            [-3.5726460131497175, 7.474115271293788],
            [-3.5684018836089773, 7.470684972561703],
            [-3.566353087496678, 7.4753643475309355],
            [-3.5620506659760767, 7.478434391051446],
            [-3.5603102746095696, 7.476629119292196],
            [-3.5564670006830155, 7.479295817576521],
            [-3.553067164237757, 7.477367678838446],
            [-3.5510605043203096, 7.480621636925686],
            [-3.5429194906971766, 7.471833364984949],
            [-3.5424419125560545, 7.4743873032254315],
            [-3.53563965970405, 7.481656451710494],
            [-3.5348580041330226, 7.4784129703904],
            [-3.53069673500435, 7.4806057175439555],
            [-3.531689714025538, 7.473232892726599],
            [-3.534622667075444, 7.47407063360497],
            [-3.536795540795918, 7.469625004735794],
            [-3.529560532647472, 7.468755941313612],
            [-3.524360587579021, 7.476849566830188],
            [-3.517007996853338, 7.475716939245201],
            [-3.513109329976882, 7.467906456726388],
            [-3.5098417765433956, 7.464484836347275],
            [-3.504666194369262, 7.464786913329698],
            [-3.5012826995447814, 7.461027509994064],
            [-3.4931495852007424, 7.457598593481949],
            [-3.4893430250042488, 7.46047778582197],
            [-3.4878367690458147, 7.454019693787963],
            [-3.4824034670322, 7.45356139364381],
            [-3.478343789248139, 7.450922465011179],
            [-3.4722959471439037, 7.451827121588043],
            [-3.4702480810797627, 7.449778849867729],
            [-3.466923523564418, 7.453751147566266],
            [-3.4649439179293964, 7.4509592443984225],
            [-3.460383967597202, 7.451549141064203],
            [-3.4581559082322864, 7.460822203092843],
            [-3.4602828623116317, 7.463803947031231],
            [-3.44952887392533, 7.471594518278788],
            [-3.442304066843556, 7.47041822625193],
            [-3.4416920276956278, 7.465305587531529],
            [-3.4382476075765873, 7.458625286157204],
            [-3.4352631956176496, 7.458089339077339],
            [-3.435148933078472, 7.4538228920529885],
            [-3.4309493217664455, 7.451425742101604],
            [-3.4247308274234687, 7.451881328664567],
            [-3.4245532284636093, 7.447542673267227],
            [-3.4223786670349705, 7.446441684858108],
            [-3.414499677645174, 7.451808953113863],
            [-3.4141422617887405, 7.454371727029026],
            [-3.408964893592869, 7.456925520499756],
            [-3.405884857521081, 7.45683757991147],
            [-3.406450581296094, 7.452290486299105],
            [-3.40325808052954, 7.450990132341191],
            [-3.404177886524982, 7.447003008125365],
            [-3.3973123774600893, 7.441835702794394],
            [-3.388616127649166, 7.448265473303499],
            [-3.3836307071413105, 7.448338080801305],
            [-3.382744739616062, 7.4451587746498005],
            [-3.378234012172623, 7.448024326023018],
            [-3.3802292194139225, 7.45215123139585],
            [-3.3806508381684215, 7.457388182542322],
            [-3.3749248351348284, 7.459933597033963],
            [-3.3721919641930143, 7.457077541539014],
            [-3.3658138468421823, 7.457907172507548],
            [-3.3603135442732657, 7.4535535747338875],
            [-3.3537464157100643, 7.455329536854957],
            [-3.3530360894136773, 7.4601381940423765],
            [-3.3551546594438277, 7.463815906325725],
            [-3.3560358914526476, 7.471909748832909],
            [-3.3478725287587916, 7.4763867073170704],
            [-3.34641208937087, 7.4819005152185865],
            [-3.3425462677576614, 7.481975681461196],
            [-3.334580590060005, 7.48657624190873],
            [-3.3338908502441713, 7.479128017773098],
            [-3.309341300744573, 7.483667412186365],
            [-3.3050953734593134, 7.487916238955438],
            [-3.2975842599483065, 7.485019291002043],
            [-3.2950664513639922, 7.487074112230847],
            [-3.297687144816089, 7.49075786732624],
            [-3.293679178566107, 7.492886049697647],
            [-3.2916819198197436, 7.4970096767488545],
            [-3.2848584701731456, 7.499611877879839],
            [-3.2767490938473722, 7.50470211086968],
            [-3.2738006697288715, 7.502336469821568],
            [-3.2645488535066813, 7.499844307433978],
            [-3.26342550806415, 7.495047412671067],
            [-3.2606485994564776, 7.494848232982273],
            [-3.2590035333372493, 7.500941429923156],
            [-3.254650774300561, 7.498707231077634],
            [-3.2496928335017907, 7.49990538541469],
            [-3.2490086136040874, 7.503129760151498],
            [-3.242583255876919, 7.504835333452559],
            [-3.241603814368166, 7.508020419304596],
            [-3.2460541702585544, 7.508517367064258],
            [-3.246521680319404, 7.512760493385849],
            [-3.238275513589246, 7.514863368683292],
            [-3.2337469652943462, 7.514095928771558],
            [-3.2324916408874396, 7.518514601475387],
            [-3.2243539879999936, 7.5160802069923935],
            [-3.2290480042935314, 7.52238834679709],
            [-3.222912575720177, 7.5258313388462135],
            [-3.2178721635313567, 7.5272717615871905],
            [-3.2164761517547777, 7.531407001864103],
            [-3.2138001306353443, 7.533003366147777],
            [-3.2115681688192326, 7.537749439530107],
            [-3.2138813218545805, 7.54211245347586],
            [-3.2222861460669865, 7.546843742820326],
            [-3.217490165977382, 7.548565074504966],
            [-3.2137463674820235, 7.5541555577611454],
            [-3.2123853108520533, 7.5491199889553915],
            [-3.2097725629175042, 7.548838759331158],
            [-3.208919517591611, 7.554634897894826],
            [-3.2015096006797386, 7.5555369602670215],
            [-3.202212307509918, 7.551589748191774],
            [-3.1982006781132974, 7.5497819132259485],
            [-3.1970201993031697, 7.5553103260268974],
            [-3.1940985075834223, 7.555645955379602],
            [-3.191495603294025, 7.550745779965104],
            [-3.1871792317923355, 7.55836436640712],
            [-3.179318490852119, 7.56037378679839],
            [-3.172824528688912, 7.557324598634262],
            [-3.169692377519284, 7.5619109637935065],
            [-3.164307391048851, 7.556366555928792],
            [-3.1632101192955875, 7.559273659388857],
            [-3.1574394340861875, 7.564056434002928],
            [-3.1516140597871547, 7.573884188328824],
            [-3.1435457224691112, 7.570239139188761],
            [-3.1407222687904808, 7.565076879557114],
            [-3.136854099349778, 7.5668371024102346],
            [-3.1394506029471576, 7.570737320129636],
            [-3.1401477332778285, 7.578405813029942],
            [-3.134933726840276, 7.579707542536828],
            [-3.1349096809857144, 7.582627204975164],
            [-3.1384867236836484, 7.584903765465212],
            [-3.137179388180924, 7.591217573720796],
            [-3.1393527406814896, 7.593259508595461],
            [-3.136374512326258, 7.598351002953544],
            [-3.1404800544170293, 7.600588816763664],
            [-3.1351692827063564, 7.607794556373975],
            [-3.1260156438488242, 7.610899254186612],
            [-3.123256786333165, 7.609934867269354],
            [-3.1173781659220445, 7.612084339643299],
            [-3.1185885261418633, 7.617492111450418],
            [-3.112300252515678, 7.613800900005602],
            [-3.1092855383948983, 7.615833852863024],
            [-3.104539116402795, 7.6160967283628285],
            [-3.1016062284485684, 7.617884746737411],
            [-3.101115362704186, 7.623880159990178],
            [-3.0930286824529163, 7.628330894917857],
            [-3.0893111868025205, 7.625277109739643],
            [-3.084878199422888, 7.628028497085123],
            [-3.0818647530981145, 7.627959625160317],
            [-3.0804013830876134, 7.63308862515678],
            [-3.070983386032522, 7.639902171858323],
            [-3.0701424365882746, 7.6428010046651],
            [-3.07312105355269, 7.655450645036113],
            [-3.081026454966362, 7.654668083085292],
            [-3.0778986472562884, 7.660138281068193],
            [-3.073532757072268, 7.66183166279235],
            [-3.073131385913567, 7.667962153759248],
            [-3.071356306541034, 7.66952137123533],
            [-3.0654704601836325, 7.668440604095494],
            [-3.062575685587184, 7.669985061921912],
            [-3.0601209542122025, 7.679088821338973],
            [-3.064612665100132, 7.679733522080233],
            [-3.066588849045006, 7.682100324515622],
            [-3.0645800021372924, 7.685026491944122],
            [-3.058923616502636, 7.686900394083154],
            [-3.0526543609120913, 7.684441872724011],
            [-3.0495722843631934, 7.68520739377904],
            [-3.044599635683064, 7.68159541338205],
            [-3.0372951419380465, 7.681368007658707],
            [-3.036282955649873, 7.687876533695451],
            [-3.029038753248267, 7.692064277778627],
            [-3.0246802857469914, 7.68977447553706],
            [-3.024022681334283, 7.685847613569082],
            [-3.018549584150426, 7.685580912973319],
            [-3.0148581093100444, 7.687897288911788],
            [-3.0157598208498766, 7.693614046444261],
            [-3.0158573960458073, 7.696955813516589],
            [-3.010383472580841, 7.702640049640035],
            [-3.008869908991069, 7.708238685753755],
            [-3.0013505278864527, 7.704786229332417],
            [-2.9983618479721548, 7.707637871225756],
            [-2.999116907005013, 7.715256729949841],
            [-3.0064165513987104, 7.716005563525865],
            [-3.004744336014395, 7.721572773235499],
            [-3.0081449229112223, 7.728064536414128],
            [-3.0028353310910174, 7.731539474107914],
            [-2.9991886772588243, 7.731324174473852],
            [-2.9931041648305294, 7.72324479923934],
            [-2.985405291082587, 7.726173990616754],
            [-2.9850639767546876, 7.732263864511778],
            [-2.981450573951505, 7.7366481764297745],
            [-2.977880750873286, 7.732324188170717],
            [-2.97445205263924, 7.73536037074866],
            [-2.9760023571551377, 7.740258310495625],
            [-2.9752700361442352, 7.742889849644065],
            [-2.965727292436816, 7.746085463231433],
            [-2.967590079198133, 7.753736705300408],
            [-2.9643951533909534, 7.754929314133005],
            [-2.95412812543192, 7.755351238299385],
            [-2.953328918238235, 7.763181099177095],
            [-2.9558682577284183, 7.766659126354909],
            [-2.9540044265336163, 7.773415250785342],
            [-2.949933866224075, 7.776031772507439],
            [-2.951019386747744, 7.78144038782654],
            [-2.9460430483668576, 7.780392468271842],
            [-2.9455688279165093, 7.785501911124055],
            [-2.9413444267909816, 7.78668587333675],
            [-2.940440350870421, 7.79084588735096],
            [-2.9361992799927497, 7.79582791871033],
            [-2.9362193652481334, 7.7989269907813705],
            [-2.928519306903949, 7.800949492704036],
            [-2.92096951126769, 7.7988189279982825],
            [-2.920638124757567, 7.806422588781125],
            [-2.9155732063311137, 7.807924152757036],
            [-2.9134673038876397, 7.810574173931193],
            [-2.908621457822437, 7.811385910784851],
            [-2.907855483108971, 7.803341743935954],
            [-2.911603353640928, 7.79469491822406],
            [-2.9091567860268577, 7.79208080999941],
            [-2.9018149824280517, 7.791683708133338],
            [-2.8974416338809204, 7.7953759959109235],
            [-2.8969758559664585, 7.800462792482073],
            [-2.890836428532562, 7.802009735123909],
            [-2.8911347424538896, 7.79707279783466],
            [-2.879862106230011, 7.79209793551704],
            [-2.8767171781669783, 7.793658948387334],
            [-2.8752249689223266, 7.788858113233713],
            [-2.869040178536999, 7.7896351248622855],
            [-2.8648632539916883, 7.785129894672654],
            [-2.8601379925690305, 7.78489268673644],
            [-2.858464742598975, 7.78931574994491],
            [-2.851004052597101, 7.79069337921988],
            [-2.841137865568593, 7.789518793829237],
            [-2.836300804452011, 7.790633203301979],
            [-2.83372752441725, 7.796223817669555],
            [-2.8307392534892752, 7.7965263081532585],
            [-2.828912009561452, 7.792454162104177],
            [-2.8253968439326695, 7.794561098684832],
            [-2.8217071304952683, 7.793810114308805],
            [-2.8187801446190264, 7.790881867909961],
            [-2.813659153188805, 7.79820598659576],
            [-2.8104369831260048, 7.799089435866429],
            [-2.8084207493595916, 7.793632426148905],
            [-2.8109217370761463, 7.788870382907241],
            [-2.8068441814703555, 7.787631094101922],
            [-2.8022093403457298, 7.7897790070359365],
            [-2.799934867944921, 7.787226088660681],
            [-2.801463127262443, 7.77811947843381],
            [-2.798403791899596, 7.777494853959875],
            [-2.7901710915598166, 7.78306329997605],
            [-2.791929356785428, 7.789548122856271],
            [-2.791175873163352, 7.7935220168289066],
            [-2.788656871363126, 7.795272145994959],
            [-2.786579855553032, 7.790439090133578],
            [-2.783771890759934, 7.790350866298323],
            [-2.779284169965429, 7.79397174152368],
            [-2.774937601509356, 7.805442909284735],
            [-2.771630985545039, 7.807752528941054],
            [-2.7665679615040615, 7.807903112707752],
            [-2.7608995425610723, 7.801378673224792],
            [-2.755605460340086, 7.802707006478513],
            [-2.750318096136689, 7.806523064807811],
            [-2.74440302497952, 7.806620155962218],
            [-2.733411957794645, 7.812598833683981],
            [-2.7335117472770856, 7.817633687187402],
            [-2.728851099629671, 7.816913287765715],
            [-2.7254873397534216, 7.810717161694663],
            [-2.7213639501225484, 7.8101230737625595],
            [-2.720076935705018, 7.815205002395944],
            [-2.723565432953447, 7.817450052089384],
            [-2.722177645732148, 7.82035076301197],
            [-2.7163950940937083, 7.816907546744328],
            [-2.714423049285875, 7.821857559204996],
            [-2.7075863898086365, 7.820145042858061],
            [-2.7016688116476106, 7.808090836698981],
            [-2.694260851947654, 7.786765049556865],
            [-2.6885328689146757, 7.773531883686819],
            [-2.683736845663992, 7.755296375263012],
            [-2.683396554119435, 7.749442223515219],
            [-2.6839870817715683, 7.721464072649636],
            [-2.687294735509441, 7.711824240036299],
            [-2.6918507819018216, 7.700757734635152],
            [-2.6976252925367503, 7.690342739735846],
            [-2.703908267193413, 7.682327568111029],
            [-2.707861381247439, 7.675191081750342],
            [-2.708886881380116, 7.669795406514235],
            [-2.7078835778222783, 7.666183557457463],
            [-2.6993440745776285, 7.650628765555782],
            [-2.694036785059762, 7.642751517408051],
            [-2.6939896885990238, 7.635126396974582],
            [-2.6961126305691323, 7.627543801289622],
            [-2.7029808893042055, 7.612879092448707],
            [-2.7088323291698617, 7.602463221953995],
            [-2.7144023055489654, 7.597876865756446],
            [-2.7207163711617013, 7.590850518312911],
            [-2.7240396919796517, 7.5853645792982025],
            [-2.7374208222027243, 7.56600118755408],
            [-2.740756357303523, 7.56031767090111],
            [-2.746229479535731, 7.548389406247038],
            [-2.748456648587771, 7.540220007119169],
            [-2.748655970175358, 7.531233000506387],
            [-2.747136719947536, 7.5241569729258995],
            [-2.74059274657948, 7.512657156802695],
            [-2.739455861821571, 7.506062827920487],
            [-2.739878988173113, 7.494589888277724],
            [-2.7426339365717176, 7.485209562546937],
            [-2.7427908579399314, 7.479172106867898],
            [-2.7416098401883247, 7.469204911229821],
            [-2.7377031355115635, 7.456628262928129],
            [-2.732604166218348, 7.447066451380487],
            [-2.7269107538470414, 7.439656777836462],
            [-2.7191144780256242, 7.426794085242367],
            [-2.7161021933963196, 7.422883325673848],
            [-2.7118636013770114, 7.412668905361365],
            [-2.706957584163272, 7.4047026415349295],
            [-2.7001099044887322, 7.399420087990192],
            [-2.6930029536455513, 7.396604354406299],
            [-2.6872819962391117, 7.3954411657666155],
            [-2.681235181744648, 7.384670132518083],
            [-2.674431474543472, 7.368974384005695],
            [-2.6719912136667445, 7.361556826208537],
            [-2.6729779644134517, 7.350474743999821],
            [-2.676203192519295, 7.343201301021701],
            [-2.676498798160559, 7.339067090584871],
            [-2.7569840002418537, 7.342896277174465],
            [-2.821765448063919, 7.346437504185863],
            [-2.842326966615436, 7.347082519050814],
            [-2.855772367438791, 7.347866974715406],
            [-2.939504315277773, 7.352184994459921],
            [-2.9710810498659743, 7.353702090031181],
            [-3.00243027914852, 7.355633974698778],
            [-3.0863194000679575, 7.359825710550389],
            [-3.157543761555933, 7.363712462665464],
            [-3.2046161090073326, 7.366599216246891],
            [-3.269799144476527, 7.370104289208464],
            [-3.2756882441447304, 7.370606226520126],
            [-3.3077762512846918, 7.371917131451024],
            [-3.4032511819377156, 7.377725449026281],
            [-3.4897908933178377, 7.383147042064744],
            [-3.5186905342781314, 7.384613697899198],
            [-3.6322610901108305, 7.39187051455847],
            [-3.6926602576254783, 7.395510461806366],
            [-3.7100150584209572, 7.396696546065375]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.04055677847622,
          "lat": 46.112626345843346
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38085"],
        "coty_name": ["Sioux"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sioux County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01034208"
      },
      "bbox": [
        -3.7100150584209572, 7.339067090584871, -2.6719912136667445,
        7.821857559204996
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8779014173322854, 10.307954113834606],
            [-1.778515358572495, 10.304448665676484],
            [-1.7032818490296986, 10.302046697362663],
            [-1.617107291413299, 10.299403933988343],
            [-1.5286924258064716, 10.296812886038017],
            [-1.5307776571723684, 10.24103009979222],
            [-1.5324845593021148, 10.191796104449827],
            [-1.5322905468097725, 10.191099266367482],
            [-1.5350014145358357, 10.121386365891764],
            [-1.536980416789692, 10.05098072591034],
            [-1.537530893039269, 10.02278376093651],
            [-1.5178440108513793, 10.022135702498458],
            [-1.520496701377929, 9.937452379342563],
            [-1.5232339115338815, 9.852822807211215],
            [-1.5260325781342692, 9.768119088847252],
            [-1.528912254856654, 9.683346167520382],
            [-1.5952934025871308, 9.6855815880251],
            [-1.6827579266928503, 9.688509578680566],
            [-1.769470633954094, 9.691568138531323],
            [-1.878923148640216, 9.695602346343929],
            [-1.8791168026380562, 9.698274955268404],
            [-1.8764232899466458, 9.766372274568452],
            [-1.8760058541380769, 9.780399167610806],
            [-1.8727791080664287, 9.865124717044417],
            [-1.8695714864767212, 9.949786541514241],
            [-1.8663471796406035, 10.034072072265058],
            [-1.8882782744514721, 10.034894203848314],
            [-1.8849946419889922, 10.119277925376085],
            [-1.8807640255867737, 10.23154819054286],
            [-1.8805863135316845, 10.231954212180225],
            [-1.8779014173322854, 10.307954113834606]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.24574638174316, "lat": 48.68554120771304 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38095"],
        "coty_name": ["Towner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Towner County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01034213"
      },
      "bbox": [
        -1.8882782744514721, 9.683346167520382, -1.5178440108513793,
        10.307954113834606
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.651203061963836, 1.139161765027935],
            [9.746600665920422, 1.1444603953585644],
            [9.754366119977583, 1.0760442255449922],
            [9.758782256046658, 1.0389356679053756],
            [9.762887564098765, 1.0008224642909043],
            [9.77066830904216, 0.9175152998831677],
            [9.813061620055882, 0.9218150256259274],
            [9.863388231927654, 0.9286158444173704],
            [9.898117047465018, 0.9340223603637214],
            [9.922795403286349, 0.9363029508699006],
            [9.923931305761982, 0.9148548788172721],
            [9.92727874021356, 0.8625597120449888],
            [9.932615177502404, 0.781913993348354],
            [9.93680661805019, 0.7093917222860967],
            [9.940741354496314, 0.642951114089232],
            [9.943730632078925, 0.5967752791165956],
            [9.947733507724545, 0.5519762398647938],
            [9.941288937678815, 0.5530010860386733],
            [9.9349673613765, 0.5573855986519604],
            [9.921439958590932, 0.5568797892638585],
            [9.902307580392108, 0.558646969420045],
            [9.89660973616372, 0.5610829802436138],
            [9.89407261530669, 0.5637378052461514],
            [9.888561783447882, 0.5763164184671086],
            [9.884625357868476, 0.5897573911534387],
            [9.880430759012787, 0.6001433228489649],
            [9.87424112267247, 0.6054876854520185],
            [9.86161406114725, 0.6088839192263047],
            [9.855709569334136, 0.6089705229078313],
            [9.849322909451791, 0.610314833518406],
            [9.839172614097285, 0.615556697385032],
            [9.83336899280739, 0.6208202264175025],
            [9.82644413373148, 0.6406741447065404],
            [9.82076393378435, 0.6492513076172571],
            [9.814755693126378, 0.6539356789679921],
            [9.803201498691964, 0.6581785329923601],
            [9.792116250359536, 0.6599963512426038],
            [9.77891356670915, 0.6609033175538619],
            [9.76853276527202, 0.661116066524655],
            [9.760807652711259, 0.6620600035958462],
            [9.759296888305638, 0.6649420076883767],
            [9.746253188923983, 0.672471658004446],
            [9.738599594425896, 0.6740975759021972],
            [9.73187672972334, 0.6744748275855089],
            [9.719130396095734, 0.6725680037143897],
            [9.707052873852021, 0.6657491752327688],
            [9.69911393492865, 0.6629544291867568],
            [9.686732917939302, 0.6561995658897142],
            [9.670929932601883, 0.6496309941365347],
            [9.664558832024625, 0.649643375952719],
            [9.664621573865762, 0.6505198849174103],
            [9.661402660716972, 0.7696019412260026],
            [9.660674080530223, 0.7868635809501715],
            [9.658496643555543, 0.8600867766088672],
            [9.656233639159536, 0.9742588173097271],
            [9.655433754884013, 1.0008894572602096],
            [9.655382438730157, 1.0136978621641668],
            [9.65324933399245, 1.0753158924053077],
            [9.651203061963836, 1.139161765027935]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.86731396949642, "lat": 38.9338172667006 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39015"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01074020"
      },
      "bbox": [
        9.651203061963836, 0.5519762398647938, 9.947733507724545,
        1.1444603953585644
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.525520695510671, 1.7596819748120114],
            [9.523860494545684, 1.7883218526409417],
            [9.52181771768252, 1.8288039198474946],
            [9.516474291830052, 1.9215872132426401],
            [9.543913889224386, 1.923116130292479],
            [9.546541130949555, 1.923608075265994],
            [9.603863172278045, 1.9263738604481841],
            [9.612540464599489, 1.926229866040544],
            [9.647030593557545, 1.9283113837314496],
            [9.696974317145573, 1.9310602521616396],
            [9.72642487890704, 1.9322828229578346],
            [9.785145516519341, 1.9350162183843589],
            [9.798805333272243, 1.9360105491686985],
            [9.823382677286205, 1.9367369439207194],
            [9.84484275414935, 1.9380445846444676],
            [9.911605249289718, 1.9427976896295804],
            [9.914301766829267, 1.9423449943941367],
            [9.913383742481116, 1.9333515681298628],
            [9.905536115203738, 1.8643805294337608],
            [9.902551422771204, 1.8366546821603948],
            [9.90060297193565, 1.8091748399532002],
            [9.896861198889653, 1.775675401589774],
            [9.891086794644004, 1.7175039852210545],
            [9.887842110019541, 1.6934462792436777],
            [9.84405349092339, 1.6920025825454332],
            [9.843378221764052, 1.694130330227913],
            [9.821830485600993, 1.6933736597320515],
            [9.788110522804123, 1.6917079089464646],
            [9.772210063376658, 1.6912805193688747],
            [9.772282179879076, 1.6988656756712088],
            [9.751546470171863, 1.6990172031247148],
            [9.703267765758111, 1.698911040475373],
            [9.701546653739813, 1.7239107836573233],
            [9.67284137566518, 1.7226463982797942],
            [9.614796039796504, 1.7191800676276219],
            [9.614049254652118, 1.7339438367785178],
            [9.572795412931153, 1.732061176050331],
            [9.527164361699567, 1.7303049804820851],
            [9.525520695510671, 1.7596819748120114]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.7843959671828, "lat": 39.91670831251856 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39023"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01074024"
      },
      "bbox": [
        9.516474291830052, 1.6912805193688747, 9.914301766829267,
        1.9427976896295804
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.853234194101407, 3.594612172918372],
            [10.866476554873444, 3.586742557464761],
            [10.872651166132862, 3.584693037772637],
            [10.885524389092788, 3.5840272713543158],
            [10.893094464497121, 3.5846756153193637],
            [10.92361754383828, 3.5829463709634113],
            [10.933501977254208, 3.583941795551562],
            [10.9420386494918, 3.5881745651581802],
            [10.950772972841476, 3.594131513692154],
            [10.956056898073063, 3.595714621508836],
            [10.969365461660818, 3.602143320809987],
            [10.978133234890684, 3.6038504747355833],
            [10.979488669319325, 3.6056621679542675],
            [10.985459337547956, 3.6044520289866857],
            [10.99154876214414, 3.605867151800481],
            [10.995182468290487, 3.604088632067865],
            [11.003033783590741, 3.6029238589590427],
            [11.020221593719898, 3.6014900674315564],
            [11.028534385780688, 3.606869192727177],
            [11.036311846538215, 3.6148835394948065],
            [11.044229921194955, 3.619360854650479],
            [11.053079695052942, 3.629567876418008],
            [11.053965296961309, 3.634298798988745],
            [11.0566012233084, 3.6385480727461803],
            [11.072021321254581, 3.6545442454131694],
            [11.074435003570573, 3.652100753880627],
            [11.070708117715865, 3.648053483318311],
            [11.071595951565598, 3.645430363319237],
            [11.079503519141838, 3.652829140497026],
            [11.079325382741352, 3.654826433014671],
            [11.085345582012481, 3.6599416802606584],
            [11.090497703071119, 3.6664372481970995],
            [11.091870763550023, 3.673370933659542],
            [11.094245282475065, 3.6746565563807803],
            [11.097895238613965, 3.6711608365344492],
            [11.115606738389642, 3.6907159316108036],
            [11.120559718947753, 3.6971298288304846],
            [11.122009098936685, 3.7018552257690334],
            [11.12695642858577, 3.7057765077142344],
            [11.13634684141351, 3.71984010223486],
            [11.138021983520673, 3.7207907375808],
            [11.150908440170811, 3.741972319158912],
            [11.158867286956895, 3.751481885019911],
            [11.162521621009597, 3.7543262244528783],
            [11.168814439457465, 3.7568467582763643],
            [11.180315917570512, 3.766749624248869],
            [11.186320609036926, 3.7734513957506954],
            [11.190301947514106, 3.7481207488171657],
            [11.192110796401925, 3.738669732541589],
            [11.196300072906237, 3.712624168070196],
            [11.233052528507914, 3.717966559714912],
            [11.246142312811138, 3.720193553122692],
            [11.267405177303335, 3.7232394614728426],
            [11.273002972349493, 3.6885154230820962],
            [11.283150597797821, 3.621194008911652],
            [11.286236577768555, 3.5994531345255854],
            [11.298373027025033, 3.601395883476795],
            [11.301756922677914, 3.5806874283228054],
            [11.289288761307036, 3.578597632435633],
            [11.293241850430928, 3.552252214038653],
            [11.301067064378215, 3.5030554941018335],
            [11.2952127528, 3.5024569045326426],
            [11.207179502282965, 3.4905253666000085],
            [11.20141188533204, 3.489969364059778],
            [11.148721241497478, 3.4826031190885036],
            [11.152329114453957, 3.47540085677215],
            [11.157343910235193, 3.4752607693782744],
            [11.158455014577862, 3.4689774902198103],
            [11.157057721914068, 3.460180277625453],
            [11.160789482468717, 3.4565051487511056],
            [11.161147804166774, 3.4525546669549874],
            [11.164730737111013, 3.448939336668117],
            [11.164444083103328, 3.441954885388455],
            [11.169983106825786, 3.4396986954452946],
            [11.174951371145774, 3.435300586268126],
            [11.17790885958136, 3.4256362801344005],
            [11.182257270980479, 3.424640264812822],
            [11.185488182974153, 3.4143406791316044],
            [11.181367751125096, 3.412974187598334],
            [11.16545518730152, 3.4102391037517115],
            [11.131875732327384, 3.4050639933106224],
            [11.095934082284515, 3.399256311814878],
            [11.081398769329459, 3.397136180309961],
            [11.02221401994394, 3.3874191443733825],
            [10.953888993850981, 3.3757447865353556],
            [10.943406900350594, 3.4511362612355736],
            [10.873856556044096, 3.4413717520328198],
            [10.865079916593203, 3.5068518093234755],
            [10.856390534544275, 3.567689015644669],
            [10.853234194101407, 3.594612172918372]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.65855984746382,
          "lat": 41.424308268083585
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39035"],
        "coty_name": ["Cuyahoga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cuyahoga County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01074030"
      },
      "bbox": [
        10.853234194101407, 3.3757447865353556, 11.301756922677914,
        3.7734513957506954
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.784540276697404, 0.8744785499250096],
            [10.784177747901062, 0.8836015525105001],
            [10.861899220954443, 0.8876608766065861],
            [10.876454911881595, 0.8877088934714253],
            [10.873593832905879, 0.939825545511615],
            [10.870531684277237, 0.9914102503208538],
            [10.868405072259744, 1.0295394445568742],
            [10.864282060320962, 1.0802472307106363],
            [10.926212244949452, 1.083886518254229],
            [10.95096881040932, 1.0852015593113566],
            [10.952294311377074, 1.0705830928398181],
            [10.962623157011105, 1.071652782426492],
            [11.01814824394405, 1.0762997612061527],
            [11.127768254479172, 1.0856336147511252],
            [11.131714848239156, 1.0408502242894222],
            [11.125822749572528, 1.0269826417634307],
            [11.12521475273171, 1.0215871631934879],
            [11.12575175376922, 1.013707169844561],
            [11.12035257253054, 1.0011785105532507],
            [11.115959794063382, 0.9892065220895316],
            [11.106800978433384, 0.9757187805865689],
            [11.107340753847298, 0.9609007054015976],
            [11.11064407497932, 0.9548563104096892],
            [11.114658654410322, 0.9431400231965652],
            [11.114832614685932, 0.9292617433606367],
            [11.113952482821626, 0.9179959660006423],
            [11.112328673800183, 0.9141862457987814],
            [11.103525721739372, 0.9002952059193933],
            [11.090915863673683, 0.8910437908967367],
            [11.082314552645961, 0.8875003040351971],
            [11.077065830044333, 0.8801525129451641],
            [11.070300145624268, 0.873025375081133],
            [11.065226720224013, 0.8651503097495437],
            [11.06318355373025, 0.8561865553059858],
            [11.0659985720381, 0.8428763933580358],
            [11.069714939021402, 0.8379205328562442],
            [11.07759645526573, 0.8345752887762592],
            [11.08481566979815, 0.8292860629990663],
            [11.088091268379449, 0.824373512607951],
            [11.091523670633235, 0.8133872596078486],
            [11.09590980011746, 0.8021303402723688],
            [11.099379272989925, 0.795455552599195],
            [11.104518588098776, 0.782228383985843],
            [11.103934493504791, 0.7723469943420435],
            [11.101759336072858, 0.7599879024891367],
            [11.102247109592373, 0.7529174634676792],
            [11.107907846252468, 0.7398682365088496],
            [11.109343388600983, 0.7327313206577625],
            [11.115882629304723, 0.7227700854744349],
            [11.11853546593557, 0.7169339070819852],
            [11.124592576524469, 0.7006786448187136],
            [11.12557340176144, 0.693985266622364],
            [11.123859794342655, 0.6779170992290859],
            [11.11634022056197, 0.667836260312958],
            [11.112743193661053, 0.665383386370803],
            [11.104253680579514, 0.6627369068467494],
            [11.093692234114721, 0.66115729099511],
            [11.091284089484642, 0.6605006151245827],
            [11.072019886691745, 0.6649345864205356],
            [11.059731715983547, 0.6628388912055028],
            [11.051041389951367, 0.6569831383451863],
            [11.042823424391225, 0.6444685145114418],
            [11.042666067829495, 0.6446444532434081],
            [10.985314986926317, 0.6387830379467861],
            [10.97770502403397, 0.7304045204605483],
            [10.886505814175866, 0.7236126478063202],
            [10.882308765620994, 0.7833919824561673],
            [10.867029607425184, 0.7827333092645243],
            [10.865130384697004, 0.8123450355752402],
            [10.78840942093741, 0.8083359483992263],
            [10.784540276697404, 0.8744785499250096]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.31690700614732, "lat": 38.82473499099153 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39053"],
        "coty_name": ["Gallia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gallia County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01074039"
      },
      "bbox": [
        10.784177747901062, 0.6387830379467861, 11.131714848239156,
        1.0856336147511252
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.013619605957546, 1.112922169767891],
            [9.031605492771355, 1.115555802007244],
            [9.053939033476523, 1.1174090092181412],
            [9.102885104276831, 1.1230203396651506],
            [9.14883123538552, 1.1289169809800779],
            [9.14988889221625, 1.1328947994822],
            [9.156941173138662, 1.1370194605247632],
            [9.167471853696899, 1.1374430329926408],
            [9.181181282413352, 1.1363785038380247],
            [9.208935640284384, 1.139243712185786],
            [9.224341340234982, 1.139254485644283],
            [9.23893674432775, 1.1379958540970614],
            [9.253098850409978, 1.142439226623445],
            [9.268471509341175, 1.1398238843862358],
            [9.283286721376614, 1.1430279472992333],
            [9.311432024954577, 1.1422362997371698],
            [9.340528090841056, 1.1445973486010719],
            [9.356386318206939, 1.1433105071839738],
            [9.369996710490657, 1.1428383524129198],
            [9.38440848682564, 1.14563137930778],
            [9.412710383341368, 1.1475716363954744],
            [9.428027920607022, 1.1470367649202862],
            [9.439750055186794, 1.1474491181105793],
            [9.438814191913169, 1.1395227857165808],
            [9.44448818478536, 1.1374900326964752],
            [9.444010039326873, 1.1301970611528647],
            [9.44327340563183, 1.123826036564097],
            [9.440654398692661, 1.122761594380324],
            [9.436500131425682, 1.1166298725482422],
            [9.428556299962414, 1.109033141504023],
            [9.420990016556248, 1.1049727439045514],
            [9.419311699733473, 1.1010415261644808],
            [9.419777494226892, 1.0950994375855783],
            [9.417987947414291, 1.090658170145416],
            [9.412237640430314, 1.0891913471062378],
            [9.411163677635326, 1.08613553405712],
            [9.40586463808361, 1.0808073355105243],
            [9.403763280744467, 1.07697690232284],
            [9.407134805318512, 1.0744204538637216],
            [9.409980142111973, 1.0671897264575578],
            [9.41370633868963, 1.0632961061429491],
            [9.421205463822032, 1.0645153424222071],
            [9.428222175102974, 1.0693229901830954],
            [9.432449807734642, 1.0700479539629555],
            [9.439434740436525, 1.0614959791534204],
            [9.439062515866663, 1.054373659807913],
            [9.433191968855077, 1.0453058751781392],
            [9.432647259548926, 1.0378998398278036],
            [9.42982158896756, 1.036009062282239],
            [9.425579761255705, 1.0292685022523622],
            [9.429677886277457, 1.0227462236377567],
            [9.426240438737269, 1.019746544470671],
            [9.425621554154143, 1.0145853661604807],
            [9.426958726654213, 0.9976344196680679],
            [9.427848559079198, 0.9147371096701281],
            [9.428752333684052, 0.8752618117267622],
            [9.423044358612387, 0.8800316428767818],
            [9.414893341653425, 0.8845187494717685],
            [9.40698023556442, 0.8877136408391852],
            [9.395442462935572, 0.8907672479289704],
            [9.374816877861232, 0.892096866668112],
            [9.363903892317456, 0.891978244555488],
            [9.359408076358424, 0.8907150975600018],
            [9.347669784587113, 0.8946432445331512],
            [9.34225495250292, 0.8980731513959002],
            [9.340378443290772, 0.9011997997796625],
            [9.336057549194363, 0.9156205711950293],
            [9.334861922530129, 0.9266615178955546],
            [9.33320918168909, 0.9294087437143995],
            [9.333675752150405, 0.9369916397386289],
            [9.330635225930823, 0.9447558532560203],
            [9.32583699623082, 0.9516950656921198],
            [9.321740046022406, 0.9560759889327097],
            [9.313313771745172, 0.961046187233407],
            [9.308031972270197, 0.9618254634461479],
            [9.30158504765758, 0.9607342820598131],
            [9.294225004428014, 0.9550580000034141],
            [9.289769612527435, 0.9484140399656598],
            [9.286204136224667, 0.9395397612594417],
            [9.280565664229307, 0.9329366935771595],
            [9.277687960306576, 0.93100031982101],
            [9.26778353689285, 0.9267257383192645],
            [9.263878592503707, 0.9263536041201664],
            [9.250283984116287, 0.9318237566215811],
            [9.243010365260325, 0.9311464165498884],
            [9.238443276459448, 0.9260179987265551],
            [9.234468035544127, 0.9179109586222208],
            [9.228851346928382, 0.9118429422862444],
            [9.21386389933272, 0.9059951716345218],
            [9.207264388869515, 0.9011598906691596],
            [9.202602000617354, 0.89970653889469],
            [9.19327396988393, 0.8988065024375219],
            [9.190590085794453, 0.8994020997556008],
            [9.18345981552524, 0.900984959084298],
            [9.168002487569066, 0.9142785673423077],
            [9.162279125131363, 0.9174556944875434],
            [9.15518524312892, 0.9191472766200591],
            [9.146677459139065, 0.918433539718457],
            [9.140613223567861, 0.9199436892895788],
            [9.136429994573914, 0.9232051778528851],
            [9.125347138266863, 0.936927510838128],
            [9.110515947085473, 0.9535587139049777],
            [9.104132897849107, 0.9577782094720911],
            [9.099333756164285, 0.9597479849210537],
            [9.089745290657879, 0.9616563934461148],
            [9.081984037185729, 0.9599202206820416],
            [9.073565937470798, 0.9506860872684736],
            [9.062848621776903, 0.9285773960441345],
            [9.05595606100471, 0.9225549743348268],
            [9.043483216860372, 0.9172190636035262],
            [9.041496975874667, 0.9142904329846572],
            [9.036739570403844, 0.91269942906734],
            [9.031743517890735, 0.9553111558131855],
            [9.030717426452515, 0.9658903697445564],
            [9.021935883726517, 1.0380167100807187],
            [9.019186863841234, 1.0622423474695384],
            [9.015157000370605, 1.1005689213958665],
            [9.013619605957546, 1.112922169767891]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.5427590440335, "lat": 39.19555694660492 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39061"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01074043"
      },
      "bbox": [
        9.013619605957546, 0.8752618117267622, 9.44448818478536,
        1.1475716363954744
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.444006666868257, 2.360034418243323],
            [10.518270127354198, 2.365880934254554],
            [10.512272283483744, 2.4388887289013987],
            [10.507811885564161, 2.4848836924762874],
            [10.503064542562111, 2.5449153470383634],
            [10.49599504692612, 2.542943840991],
            [10.492083345587236, 2.5707869923916427],
            [10.506412102520319, 2.5726791728411764],
            [10.56321804727825, 2.580972329149478],
            [10.591704485801507, 2.585476002063586],
            [10.635484822759722, 2.591995371984386],
            [10.691726272213483, 2.600163982816166],
            [10.719410776639133, 2.608366672177859],
            [10.766331842146405, 2.6224420434438342],
            [10.804469303033597, 2.634146432313978],
            [10.834844103728443, 2.643588752966172],
            [10.839483602493745, 2.600126841746995],
            [10.847624798536858, 2.5265807993039084],
            [10.8562101825398, 2.4453246821080765],
            [10.865185174150916, 2.359947527127945],
            [10.870673514286581, 2.308567978194558],
            [10.837640512052953, 2.3046190911629707],
            [10.806890935991746, 2.3003979239971275],
            [10.806989563749157, 2.299472947388447],
            [10.77956003966471, 2.2958775392974897],
            [10.736367616302449, 2.2913133113941764],
            [10.691350301378936, 2.2874097619520826],
            [10.659038234165212, 2.2848215506821177],
            [10.657202857498726, 2.303800495913317],
            [10.626490521932054, 2.301317375157163],
            [10.57841855562512, 2.2977423620026802],
            [10.530219419337808, 2.293844817696697],
            [10.449834845617852, 2.2869394393879228],
            [10.444006666868257, 2.360034418243323]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.42150088558937,
          "lat": 40.398767005177014
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39083"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01074054"
      },
      "bbox": [
        10.444006666868257, 2.2848215506821177, 10.870673514286581,
        2.643588752966172
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.193043885201988, 1.7577702214559707],
            [9.237763474050098, 1.7643756703709441],
            [9.319548190944047, 1.7760941080520978],
            [9.342998773969871, 1.779290565027621],
            [9.383590916670261, 1.7851352859898566],
            [9.439641179285054, 1.7927620434212082],
            [9.433907923773491, 1.7810928879063754],
            [9.438777367547624, 1.764071156726611],
            [9.444069715158484, 1.7578977667824451],
            [9.444621280331594, 1.7557952928619955],
            [9.525520695510671, 1.7596819748120114],
            [9.527164361699567, 1.7303049804820851],
            [9.527987828508254, 1.7156621007718595],
            [9.499121037628749, 1.7141922602945532],
            [9.501469108140697, 1.671227314361396],
            [9.502758035413356, 1.6554853880747897],
            [9.505108359896122, 1.6029594895182908],
            [9.506287489976469, 1.5809283858989984],
            [9.508528825865561, 1.5492505920827],
            [9.508715818415526, 1.5420101430892643],
            [9.510515683197994, 1.5119180559958625],
            [9.511473495662369, 1.5001826158610727],
            [9.513265211225912, 1.5000010540454733],
            [9.515837875623008, 1.4517840547859369],
            [9.449029776908368, 1.4492342362493098],
            [9.384477670867279, 1.4469094204588997],
            [9.324213397268572, 1.4394118614108184],
            [9.324161200868888, 1.4397734818520294],
            [9.288080336959645, 1.4353511156459868],
            [9.241522103538705, 1.4299626404088859],
            [9.237651819631889, 1.4303746096193235],
            [9.228884452853615, 1.4964228720183974],
            [9.210938248714772, 1.6276235673209998],
            [9.201058757287434, 1.6992148322940808],
            [9.194650865770155, 1.7445582190751447],
            [9.193043885201988, 1.7577702214559707]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.29065563555177, "lat": 39.75467913409296 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39113"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01074069"
      },
      "bbox": [
        9.193043885201988, 1.4299626404088859, 9.527987828508254,
        1.7927620434212082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.316827338022115, 1.8820043617068845],
            [11.30613301977338, 1.9692097504719341],
            [11.316267900516767, 1.970020302545628],
            [11.378012867654494, 1.9771850089258887],
            [11.392285367545513, 1.9787174980800228],
            [11.384644996648616, 2.0373203841671153],
            [11.471146207490548, 2.0473952748334012],
            [11.467715145605085, 2.0764093131387473],
            [11.525052545142781, 2.0832432644931176],
            [11.521146015936358, 2.11241399929987],
            [11.549909711214363, 2.116127740426704],
            [11.549398637645037, 2.119794989860416],
            [11.582762771362766, 2.1241675523582515],
            [11.635106784744993, 2.130745159723654],
            [11.639250114434164, 2.0953562502555],
            [11.645685511146239, 2.0472205006515445],
            [11.588117835500398, 2.0399127560383263],
            [11.593591042905574, 1.9983440417683613],
            [11.603365342307567, 1.920912623801058],
            [11.609131970452838, 1.8776919934285223],
            [11.638193042652933, 1.8819673419090195],
            [11.640029657328824, 1.8670234318685974],
            [11.642495920767248, 1.8537141806550257],
            [11.652091924481551, 1.7806859719395118],
            [11.653921620652632, 1.7667185834882815],
            [11.598659356165038, 1.759827834246117],
            [11.59763725894681, 1.7671766488995606],
            [11.568382050152913, 1.7633377306792657],
            [11.566121425486655, 1.7774176384582812],
            [11.551902177308868, 1.775414795881368],
            [11.549784578148648, 1.7900209457924934],
            [11.520238102691179, 1.7861357691321273],
            [11.518625741026003, 1.8004684032316849],
            [11.50254203606723, 1.7985281199206224],
            [11.511936510335689, 1.73601314600067],
            [11.473073758399693, 1.7315467900029529],
            [11.424805533686163, 1.726382049279528],
            [11.419617183549757, 1.7644756053653945],
            [11.414610097863283, 1.8034321511182778],
            [11.37132749314132, 1.7985565233351135],
            [11.360660171976107, 1.8858027933130197],
            [11.360496816505943, 1.8864401644554185],
            [11.316900336166235, 1.8814267169048875],
            [11.316827338022115, 1.8820043617068845]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.4555703662249, "lat": 39.76594574891902 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39121"],
        "coty_name": ["Noble"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Noble County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01074073"
      },
      "bbox": [
        11.30613301977338, 1.726382049279528, 11.653921620652632,
        2.130745159723654
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.368354115410158, 3.006697176946734],
            [10.39555701734998, 3.010295972587006],
            [10.438315168870542, 3.0155398905549773],
            [10.474899612257314, 3.020262067081329],
            [10.509930785603865, 3.02451780261926],
            [10.551961109580954, 3.0299506821164974],
            [10.585091208642796, 3.034725132305295],
            [10.596170555572385, 3.036310052431206],
            [10.61024744907521, 2.9460718550789773],
            [10.61065439820231, 2.9457701593023167],
            [10.614172766128801, 2.921405551203706],
            [10.620718299529269, 2.873658680002907],
            [10.619198515578645, 2.8667068594920955],
            [10.622569682310417, 2.858619984700007],
            [10.629141936277733, 2.8595648406157363],
            [10.630228613108319, 2.853289654403671],
            [10.64450247862472, 2.8552645429082557],
            [10.645410028036098, 2.8430375431163517],
            [10.649848829285746, 2.8398829216922343],
            [10.651778715411762, 2.836383233128882],
            [10.654654585788844, 2.8354145858202577],
            [10.655777037752431, 2.8293152959647636],
            [10.66372258373973, 2.775571474959481],
            [10.671873131436044, 2.7763009535373477],
            [10.692930118123627, 2.779317321050789],
            [10.708459970192761, 2.676581172276822],
            [10.719410776639133, 2.608366672177859],
            [10.691726272213483, 2.600163982816166],
            [10.635484822759722, 2.591995371984386],
            [10.591704485801507, 2.585476002063586],
            [10.56321804727825, 2.580972329149478],
            [10.506412102520319, 2.5726791728411764],
            [10.49466202855126, 2.646794618094476],
            [10.493187454376253, 2.6597593550559817],
            [10.47877438593243, 2.657677479653854],
            [10.47401097124438, 2.686702496862879],
            [10.4880598515907, 2.688390750970517],
            [10.481173538533628, 2.7314597893762955],
            [10.434920453507477, 2.726139110855672],
            [10.43486512202152, 2.726568807517338],
            [10.406523228644689, 2.7227566101766967],
            [10.395489980758452, 2.8066462433458526],
            [10.389622065589876, 2.8547420123129177],
            [10.377954900581342, 2.9417676855671213],
            [10.373422858461252, 2.9731962537241285],
            [10.368354115410158, 3.006697176946734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.53650164722805, "lat": 40.77466565888216 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39139"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richland County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01074082"
      },
      "bbox": [
        10.368354115410158, 2.5726791728411764, 10.719410776639133,
        3.036310052431206
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.230229896255933, 0.9723337844122922],
            [10.23199892808845, 0.9712092053190918],
            [10.237162651824729, 0.9726905172182057],
            [10.248087996390334, 0.968880471524727],
            [10.256203834640484, 0.9697918449613381],
            [10.256419372515955, 0.9657880319460789],
            [10.265812218710654, 0.9590167681668095],
            [10.266744575903601, 0.9565736612731595],
            [10.275837310308711, 0.9541768832520097],
            [10.27807052539924, 0.9485083807433567],
            [10.276702275660481, 0.9403007998580237],
            [10.277055210649225, 0.9338001959831012],
            [10.280010782271876, 0.9345485301369274],
            [10.282627189667494, 0.9313167186195813],
            [10.280161010454629, 0.9256600477650435],
            [10.2825398638787, 0.9227148997367325],
            [10.345952594338915, 0.9290446763826022],
            [10.351607989098925, 0.9299579981274344],
            [10.411663211768573, 0.9370365359340513],
            [10.467372744430815, 0.9430043912506294],
            [10.521990599050561, 0.9476175889002677],
            [10.59323797833757, 0.953136517580111],
            [10.634579948934045, 0.9561711017688096],
            [10.638976776691234, 0.8965406190358136],
            [10.638656765176805, 0.8794180552054323],
            [10.641699082078393, 0.8649126523063769],
            [10.699253031883805, 0.8692686627870785],
            [10.72702637384881, 0.8710099011130901],
            [10.72989544344905, 0.8263457270476381],
            [10.732321564494594, 0.7836655589159258],
            [10.73059112803492, 0.7832171696681273],
            [10.73149193150328, 0.7685594276188008],
            [10.70635269395242, 0.767052357539701],
            [10.710010435806337, 0.7073092635521241],
            [10.708147370056714, 0.6933910922548324],
            [10.663765773138794, 0.6896945841793168],
            [10.666956641578473, 0.6541559360184288],
            [10.670428192175375, 0.6505642833761135],
            [10.67748951035145, 0.6356501592737425],
            [10.693394343049874, 0.6094232703679575],
            [10.669092567069344, 0.5940800691971675],
            [10.639139471435952, 0.5748611060105717],
            [10.635657299293554, 0.5763984257743373],
            [10.618922911894645, 0.587782872871284],
            [10.61180451016016, 0.5959734642501029],
            [10.607363264945286, 0.6047013149347348],
            [10.60163441003286, 0.6207041374675525],
            [10.599191925077669, 0.6326625560657545],
            [10.597737666128738, 0.6459165042526013],
            [10.593372752812394, 0.6598866939368851],
            [10.58914751741875, 0.668370547927782],
            [10.583084246273174, 0.6765999521686301],
            [10.578379304026193, 0.680686079895672],
            [10.575290409083381, 0.6877492284310125],
            [10.574994308000072, 0.7027946798918814],
            [10.57626974651955, 0.7166314107388342],
            [10.575902017039551, 0.7265700310372571],
            [10.573273628926541, 0.737620415593471],
            [10.568962059885534, 0.7450740183764861],
            [10.56531827068792, 0.7488489699017445],
            [10.55725816260551, 0.7524185877606635],
            [10.553363887210926, 0.7523877656471959],
            [10.531696055795924, 0.742759143737343],
            [10.517752581814683, 0.7339033097398375],
            [10.506849463476316, 0.7239332781472526],
            [10.500205394258558, 0.7166971205222461],
            [10.492402208288228, 0.7127672291362238],
            [10.487232720676898, 0.7123605646886804],
            [10.476701819868804, 0.7140698521913096],
            [10.467025543169434, 0.7134327495559171],
            [10.459594790724674, 0.7111201489981427],
            [10.453046199512984, 0.706936765760717],
            [10.448523984618923, 0.6969496161523493],
            [10.446647205606089, 0.6884800710369537],
            [10.440116576365513, 0.6748579262737064],
            [10.43246734477564, 0.666824042044931],
            [10.418299642556802, 0.6568489448349769],
            [10.404629057617262, 0.6511352425206987],
            [10.398023742607355, 0.644495561647],
            [10.394585030351012, 0.6383077367463796],
            [10.391931385121179, 0.6309421712726748],
            [10.39095014784818, 0.6165869352358182],
            [10.386098515938487, 0.6021437430629791],
            [10.381031665883846, 0.5946846298192887],
            [10.373489538655848, 0.5872908420183272],
            [10.356437621481374, 0.585330733898422],
            [10.335479038589948, 0.5799954565752987],
            [10.327990411894948, 0.5811803341714392],
            [10.317095465452264, 0.58624680616174],
            [10.312024364611291, 0.5878660390846899],
            [10.301723345563463, 0.5874884560789005],
            [10.295600950223022, 0.5814039237042502],
            [10.29065652039426, 0.5800442611130415],
            [10.286714153865516, 0.5748818004506191],
            [10.285763338385692, 0.5751116862689157],
            [10.273487879187797, 0.6665361993380094],
            [10.267368036038386, 0.7125744811212156],
            [10.249908183376673, 0.839227726160348],
            [10.243020736261602, 0.8867139972016002],
            [10.230229896255933, 0.9723337844122922]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.99288469474016,
          "lat": 38.803932240540284
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39145"],
        "coty_name": ["Scioto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scioto County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01074085"
      },
      "bbox": [
        10.230229896255933, 0.5748611060105717, 10.732321564494594,
        0.9726905172182057
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.87641557775791, -2.5487602689718907],
            [-0.8048238187327253, -2.5499008887238515],
            [-0.7046165490392404, -2.5517950838513728],
            [-0.6191682894012879, -2.553218543905634],
            [-0.6193922829460533, -2.5584915891912727],
            [-0.6197454544055102, -2.601548224584709],
            [-0.6207128362842623, -2.66034270122365],
            [-0.6216862824807757, -2.734048046928712],
            [-0.6161748737772352, -2.7306267630300574],
            [-0.6102399901277926, -2.7253982538673247],
            [-0.6055112455912963, -2.714379213309252],
            [-0.6008631983117, -2.712182766171042],
            [-0.5970711705133033, -2.7082379347567618],
            [-0.585041447272289, -2.708290409430378],
            [-0.5785273675745424, -2.7101108730763936],
            [-0.5738885695622256, -2.7139207363859894],
            [-0.5682923184884003, -2.7229446719837087],
            [-0.5666694204497121, -2.727898801254856],
            [-0.5660897931615952, -2.7343006754970562],
            [-0.567245356635462, -2.739283715277102],
            [-0.5606620151519759, -2.7461353364629963],
            [-0.5331125695712665, -2.7481133585054076],
            [-0.5155857095948579, -2.756011498761211],
            [-0.5064188170597697, -2.7693797471418033],
            [-0.5052724474208058, -2.7730931745184826],
            [-0.5017250496208144, -2.7761272483104293],
            [-0.49050937555839835, -2.7799368702459235],
            [-0.47673509643054673, -2.7802590485530487],
            [-0.4653328058512804, -2.776218001783884],
            [-0.4598256338299516, -2.772988263144834],
            [-0.4529207916862362, -2.767228368771231],
            [-0.45121863498924797, -2.779576181643852],
            [-0.451706829211017, -2.8234130511291844],
            [-0.4524122249802482, -2.823396528457515],
            [-0.45284256625839425, -2.8530406612648602],
            [-0.45317536104093437, -2.9188072439673087],
            [-0.45351853841445194, -2.9335799789101786],
            [-0.454242280308407, -2.9988612151996166],
            [-0.5103053320827607, -2.9978460024030475],
            [-0.626497271624102, -2.995640632482003],
            [-0.6971608731959027, -2.994678336783468],
            [-0.7255575290219215, -2.994149754196953],
            [-0.7969833095276149, -2.9925553376114453],
            [-0.8829409806541927, -2.9909393355124543],
            [-0.8816214138182772, -2.9105679386285677],
            [-0.8802773644241694, -2.8170724245280883],
            [-0.880983547594621, -2.8170569686671287],
            [-0.8801711481951123, -2.7585318848968616],
            [-0.8786179478169859, -2.6706342108848586],
            [-0.8779840507315949, -2.6413924844823264],
            [-0.8767658290637735, -2.563618472607512],
            [-0.87641557775791, -2.5487602689718907]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.44333922575511, "lat": 35.91934266174596 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40083"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01101829"
      },
      "bbox": [
        -0.8829409806541927, -2.9988612151996166, -0.45121863498924797,
        -2.5487602689718907
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8877338303036444, -3.3822974537859873],
            [-0.8809169900412465, -3.3832709593752215],
            [-0.8725426232477829, -3.386676141439233],
            [-0.8644420273604132, -3.394256553015067],
            [-0.8610867617191845, -3.399216371858236],
            [-0.8525470054788328, -3.405909513416534],
            [-0.8449390533878212, -3.4155226484672836],
            [-0.8329232401381247, -3.4174279820101456],
            [-0.8155107265318473, -3.4187877608027035],
            [-0.8117206585637383, -3.4204298189141005],
            [-0.7989712350969557, -3.429520763924224],
            [-0.7960282965865471, -3.4332288136148876],
            [-0.7946786105232508, -3.4599004582524358],
            [-0.8019343249277446, -3.4677998302541693],
            [-0.8043917843197496, -3.4743857943494842],
            [-0.8019657559083343, -3.4785001362721983],
            [-0.7979720136469729, -3.4798707221146055],
            [-0.7965598196940886, -3.4830780372958534],
            [-0.8011525346839304, -3.4873350086000756],
            [-0.7954304049088072, -3.494700281424049],
            [-0.7953087655345105, -3.4978038195423293],
            [-0.7846815315335134, -3.508211595560185],
            [-0.7749734304507542, -3.5098806212202094],
            [-0.7682431614312593, -3.5163745795540056],
            [-0.7616728137287299, -3.5214354566353117],
            [-0.7418488671171517, -3.535430995799692],
            [-0.7183225225800591, -3.5535626862495144],
            [-0.7141593694410379, -3.5600914476726624],
            [-0.7054862522693628, -3.563546978452747],
            [-0.7021258417891496, -3.577092492917641],
            [-0.6979732962594176, -3.5804222430469923],
            [-0.6906468883465202, -3.5836965764494835],
            [-0.6858982333826855, -3.5827344529143987],
            [-0.6769929293282139, -3.586423616993026],
            [-0.6750518758284015, -3.5925605208020395],
            [-0.6746900323040492, -3.5985189874623438],
            [-0.6725169203963742, -3.599852763702302],
            [-0.6758751977317727, -3.6158410117517388],
            [-0.673087954055443, -3.6229645101598575],
            [-0.6721423720539466, -3.6334241843182125],
            [-0.6737051626466308, -3.638595805539638],
            [-0.6653164122380119, -3.6425251854017198],
            [-0.660300935456174, -3.6429607275681697],
            [-0.6504664907856701, -3.640265312667552],
            [-0.6429479508322283, -3.640868673526256],
            [-0.6398789968174169, -3.6428293143842487],
            [-0.6350011598297259, -3.648934906316255],
            [-0.6338669378952086, -3.6533310572681694],
            [-0.6353285026691, -3.6603790578286275],
            [-0.6317885149781512, -3.668717035736882],
            [-0.6323507056151126, -3.6746240330796156],
            [-0.6368163825127684, -3.6852619159662265],
            [-0.6387167310248119, -3.6921078996738186],
            [-0.6364342786588146, -3.697213612478432],
            [-0.6347193041134677, -3.7071134750228465],
            [-0.6314071887515731, -3.720104670620669],
            [-0.6292549968388953, -3.721549295046219],
            [-0.6298884675754675, -3.727722427949927],
            [-0.6264193479162412, -3.730837247891031],
            [-0.6262539712426768, -3.736028130084155],
            [-0.6314163778713581, -3.740805542826551],
            [-0.631253545263745, -3.747069212307925],
            [-0.6275885321423554, -3.751959126078759],
            [-0.6263149954394497, -3.762452323162061],
            [-0.6201497194051343, -3.7676244786980604],
            [-0.6137782458256333, -3.7715942544768795],
            [-0.610333849903846, -3.772532817688237],
            [-0.5989920813536175, -3.772914812186243],
            [-0.5962666411767836, -3.7705347479530364],
            [-0.5922820225155895, -3.762310268208219],
            [-0.5775520831639773, -3.766355463549417],
            [-0.5713558770085739, -3.764220397663622],
            [-0.5701348470591457, -3.76546255826171],
            [-0.5657439020730463, -3.776655147963652],
            [-0.5616301146898354, -3.7820155215809024],
            [-0.5551367347697779, -3.7821153481331575],
            [-0.5525162208346824, -3.778672675561758],
            [-0.5491064204131315, -3.7784224895901874],
            [-0.538186590845915, -3.7858861318653374],
            [-0.5385426477104146, -3.790325715555804],
            [-0.5327660136335074, -3.7932875758691704],
            [-0.5311212981551136, -3.7869192271307113],
            [-0.526132820840061, -3.7836490086683425],
            [-0.5217704074991565, -3.7846828778489017],
            [-0.5159393060875591, -3.7880427341230356],
            [-0.5103547821687933, -3.7883104518077952],
            [-0.5081776830803236, -3.792168077645371],
            [-0.50868049987781, -3.799999321992373],
            [-0.5014234479479416, -3.7986389547995145],
            [-0.4925814256981895, -3.7997771601486647],
            [-0.4846474124910103, -3.7977503299369024],
            [-0.4748123211168376, -3.7972623318846783],
            [-0.4649284815402085, -3.8006108887659433],
            [-0.45965433276684836, -3.804474920919989],
            [-0.45689018968982353, -3.8027276167765347],
            [-0.4588459423813319, -3.7962375406551865],
            [-0.4571427659638611, -3.794196796159343],
            [-0.4499668200700809, -3.7948141767225927],
            [-0.44407168884161474, -3.79381678253209],
            [-0.43534167969446985, -3.7962060948674257],
            [-0.43077029802984934, -3.7995648965882878],
            [-0.4278864222620809, -3.7982868900637206],
            [-0.42034871737026613, -3.797749387655862],
            [-0.4140081667034397, -3.8004541193065187],
            [-0.41045662920232723, -3.8070233890548395],
            [-0.4056571096013251, -3.809842797762046],
            [-0.3985549154339629, -3.808342280442993],
            [-0.39194777456244073, -3.808417581411278],
            [-0.38953487245820567, -3.8114611470146067],
            [-0.3784879291449509, -3.8169789026854897],
            [-0.37047547041899914, -3.817633173106595],
            [-0.3623852813024491, -3.8227322375026973],
            [-0.34977716155512656, -3.815894083750076],
            [-0.34603900453764275, -3.815268094111438],
            [-0.33571156917747424, -3.8087961536296735],
            [-0.33129619497426677, -3.8046623747505772],
            [-0.32694348444921983, -3.794861002537081],
            [-0.3226015671082546, -3.795652931242494],
            [-0.31976728905840923, -3.7896979419295547],
            [-0.3156295383722356, -3.7844513109556925],
            [-0.314053774762467, -3.7793256387046754],
            [-0.3053780268675609, -3.7718031095797007],
            [-0.2976530739807003, -3.767814686421156],
            [-0.29242530224156105, -3.7660695276081433],
            [-0.2937415149781051, -3.8764780525565974],
            [-0.295015498584073, -3.8766024316460266],
            [-0.3366777051690998, -3.875911757111261],
            [-0.38059058220350045, -3.875370406454915],
            [-0.5087577550180488, -3.8734759297218835],
            [-0.5942584157048323, -3.8723731390622675],
            [-0.6950120552144105, -3.870835780344544],
            [-0.7519757739812386, -3.8699984573383883],
            [-0.7525584835626329, -3.8701533346275148],
            [-0.8089051114373721, -3.8690946668353936],
            [-0.8935902996637345, -3.867759512036335],
            [-0.8954915218015482, -3.867668834780319],
            [-0.8953993365635129, -3.8530599464434694],
            [-0.8935258461367873, -3.7506883518765135],
            [-0.8915341706466513, -3.6410313475921425],
            [-0.8904683140827895, -3.5765098738009313],
            [-0.8892743889505607, -3.516908936237183],
            [-0.8896777449412334, -3.5169028658079484],
            [-0.8873389431050879, -3.3874281146239094],
            [-0.8877599689581706, -3.3838269673150028],
            [-0.8877338303036444, -3.3822974537859873]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.4442543205234, "lat": 35.00930184864205 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40087"],
        "coty_name": ["McClain"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McClain County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01101834"
      },
      "bbox": [
        -0.8954915218015482, -3.8766024316460266, -0.29242530224156105,
        -3.3822974537859873
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.892910836416613, -2.1787028815457274],
            [-1.8001092645501078, -2.1821398187487184],
            [-1.7961315044659223, -2.1885976815009025],
            [-1.7891807942596847, -2.204822176518506],
            [-1.7846478081976052, -2.2115480301515222],
            [-1.7818736572403295, -2.218328382077254],
            [-1.7729111288613706, -2.2289387375332277],
            [-1.7609098166731443, -2.2368417540212007],
            [-1.749291908114043, -2.2420471871132817],
            [-1.7387913899765048, -2.2441454418970603],
            [-1.72191544012411, -2.2426653452305003],
            [-1.708844522393571, -2.2463563208240833],
            [-1.7024842017668906, -2.254444945635472],
            [-1.695509201244366, -2.2703245894624606],
            [-1.6879261239089691, -2.2765393207207625],
            [-1.6729929822527367, -2.2826055628548674],
            [-1.6589964105269754, -2.2889008592144293],
            [-1.6444482221744419, -2.296777882098395],
            [-1.6295064003938275, -2.301805232522907],
            [-1.6227528615732, -2.3022093315866328],
            [-1.6115812871376105, -2.304060758182655],
            [-1.6040826955719487, -2.303071943330092],
            [-1.580413921597524, -2.2954891643813045],
            [-1.5769555513174405, -2.293837717934412],
            [-1.5711971229440385, -2.293581825745883],
            [-1.5648162490078317, -2.29512712304541],
            [-1.5562657935754527, -2.298473296293428],
            [-1.5544743548452797, -2.2325650551975125],
            [-1.4261257390066917, -2.2359293786257326],
            [-1.3050475382716236, -2.238652416418245],
            [-1.2126569566932497, -2.2410266803278587],
            [-1.2137054956438234, -2.2848121756320285],
            [-1.2154214508282042, -2.365399865279461],
            [-1.217192653630226, -2.4454540788195027],
            [-1.21695095790082, -2.4600405520678756],
            [-1.2189037583200668, -2.541740532998681],
            [-1.2546894654023548, -2.541096938642896],
            [-1.3040650229709223, -2.539797136993468],
            [-1.3894941455888925, -2.5377780514343655],
            [-1.5173625745377333, -2.5344908536437027],
            [-1.6308089768765839, -2.5310148196844584],
            [-1.6450795170918613, -2.531102706174334],
            [-1.6662214142792002, -2.530856605950343],
            [-1.716728317150385, -2.5307510669409696],
            [-1.8513519943401369, -2.5288135554990747],
            [-1.9001811971868015, -2.526948464421415],
            [-1.8975830411095123, -2.441098707865272],
            [-1.9012795843954953, -2.441032149919361],
            [-1.8992256738144524, -2.3673902986049673],
            [-1.8968155896520582, -2.292699506713423],
            [-1.893412610365655, -2.189762025615988],
            [-1.892910836416613, -2.1787028815457274]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.53592378711342,
          "lat": 36.311644165563315
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40093"],
        "coty_name": ["Major"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Major County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01101831"
      },
      "bbox": [
        -1.9012795843954953, -2.541740532998681, -1.2126569566932497,
        -2.1787028815457274
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.4592990643954156, -3.348949408627551],
            [-0.4577392165437061, -3.261216667441817],
            [-0.4367548643676042, -3.261345556323212],
            [-0.4313984433172993, -3.2619873659131806],
            [-0.36532451973284297, -3.262778979061731],
            [-0.3154015370800533, -3.263221773995197],
            [-0.2156707258304956, -3.264324335835175],
            [-0.13027615405046047, -3.2654982334855855],
            [-0.04055686979842702, -3.26636598963416],
            [-0.04062502687620923, -3.3248243894241005],
            [-0.040174501691421755, -3.3288027479358595],
            [-0.04180210563390351, -3.329591778848513],
            [-0.04546602793137028, -3.336852586789582],
            [-0.048405189989663436, -3.336409052566829],
            [-0.05032077749973276, -3.3304599216369173],
            [-0.05788222324595159, -3.3367975991621295],
            [-0.06344601012422643, -3.337784981009344],
            [-0.0653821850672632, -3.333928278022075],
            [-0.0704802185285436, -3.3340723215463974],
            [-0.07388775953647998, -3.3303975175864733],
            [-0.07941870296985722, -3.3286081551787934],
            [-0.08185687163788309, -3.325275196848654],
            [-0.08484313514844058, -3.3268735363271253],
            [-0.08767394977285049, -3.3232434756344555],
            [-0.09260085622717559, -3.3255014020959317],
            [-0.09597919443688943, -3.3202363860926485],
            [-0.10234206985573421, -3.3193558425588616],
            [-0.1036444217347178, -3.312924204878236],
            [-0.11119859095855451, -3.3133989072227137],
            [-0.11693341783858405, -3.3169354921419223],
            [-0.11788144096409375, -3.314434444006997],
            [-0.1153146052912363, -3.309681562595884],
            [-0.11802646314500265, -3.3053380312406535],
            [-0.12167590188033824, -3.3037652227858714],
            [-0.12695185775239914, -3.3053304191341244],
            [-0.1310110676384925, -3.3110998093353228],
            [-0.135198291476531, -3.3143579308696425],
            [-0.13416977137730288, -3.3199308361084894],
            [-0.13754187992494202, -3.32219394748975],
            [-0.149461010921226, -3.321180254102306],
            [-0.15214364076766504, -3.3194183456853144],
            [-0.1637448771983105, -3.323165089302551],
            [-0.16442692360507896, -3.39571362487751],
            [-0.1650640523793805, -3.4395320528924427],
            [-0.16554505210106427, -3.5556206099223293],
            [-0.1651580086973556, -3.5856826749039383],
            [-0.16565176490492067, -3.687835056764684],
            [-0.16654064830546605, -3.7900966925380515],
            [-0.16663694190357684, -3.8303183854266276],
            [-0.16708746830909235, -3.83200521584985],
            [-0.17472891894672743, -3.8327606915514147],
            [-0.17920874860827576, -3.831024086338581],
            [-0.18566155498999998, -3.825833321897657],
            [-0.18674777349618926, -3.8212718587947543],
            [-0.18618900166513144, -3.8117078265245863],
            [-0.18492201022604976, -3.807237418104976],
            [-0.1851528983852454, -3.801633383090661],
            [-0.18968775288047557, -3.794832789468291],
            [-0.19606455167988093, -3.787943698058818],
            [-0.20070130231656175, -3.7850611225624258],
            [-0.20393709892643222, -3.7852516596562964],
            [-0.21497407241297764, -3.7918830693480214],
            [-0.22020928199543835, -3.797502628659139],
            [-0.22974627081093635, -3.8024272541782476],
            [-0.23617719045887106, -3.8011004282359417],
            [-0.24197206342537303, -3.801717032176591],
            [-0.24868655164141937, -3.8050629259515216],
            [-0.2560677130762177, -3.8047712654274815],
            [-0.2597485217779478, -3.80150668921931],
            [-0.2601763723909949, -3.7983267368920295],
            [-0.2652145657104716, -3.7886458136901378],
            [-0.27031232140144645, -3.784670867099546],
            [-0.27624823720640235, -3.7719673272954997],
            [-0.27896103271392075, -3.7715528807818597],
            [-0.2848739684715619, -3.7665233547411807],
            [-0.29242530224156105, -3.7660695276081433],
            [-0.2976530739807003, -3.767814686421156],
            [-0.3053780268675609, -3.7718031095797007],
            [-0.314053774762467, -3.7793256387046754],
            [-0.3156295383722356, -3.7844513109556925],
            [-0.31976728905840923, -3.7896979419295547],
            [-0.3226015671082546, -3.795652931242494],
            [-0.32694348444921983, -3.794861002537081],
            [-0.33129619497426677, -3.8046623747505772],
            [-0.33571156917747424, -3.8087961536296735],
            [-0.34603900453764275, -3.815268094111438],
            [-0.34977716155512656, -3.815894083750076],
            [-0.3623852813024491, -3.8227322375026973],
            [-0.37047547041899914, -3.817633173106595],
            [-0.3784879291449509, -3.8169789026854897],
            [-0.38953487245820567, -3.8114611470146067],
            [-0.39194777456244073, -3.808417581411278],
            [-0.3985549154339629, -3.808342280442993],
            [-0.4056571096013251, -3.809842797762046],
            [-0.41045662920232723, -3.8070233890548395],
            [-0.4140081667034397, -3.8004541193065187],
            [-0.42034871737026613, -3.797749387655862],
            [-0.4278864222620809, -3.7982868900637206],
            [-0.43077029802984934, -3.7995648965882878],
            [-0.43534167969446985, -3.7962060948674257],
            [-0.44407168884161474, -3.79381678253209],
            [-0.4499668200700809, -3.7948141767225927],
            [-0.4571427659638611, -3.794196796159343],
            [-0.4588459423813319, -3.7962375406551865],
            [-0.45689018968982353, -3.8027276167765347],
            [-0.45965433276684836, -3.804474920919989],
            [-0.4649284815402085, -3.8006108887659433],
            [-0.46376456017696244, -3.7063443357039536],
            [-0.462615593433867, -3.625966799913453],
            [-0.46159773394486553, -3.538201106662606],
            [-0.46108855833758344, -3.523969008568317],
            [-0.46051422800953895, -3.4584275983097537],
            [-0.4601228742268824, -3.4366724190145796],
            [-0.4592990643954156, -3.348949408627551]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.94838119098739, "lat": 35.20665283812259 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40125"],
        "coty_name": ["Pottawatomie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pottawatomie County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01101850"
      },
      "bbox": [
        -0.4649284815402085, -3.8327606915514147, -0.040174501691421755,
        -3.261216667441817
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.24816551894682, 2.856851546912106],
            [13.248282509213814, 2.857864957152171],
            [13.270959796330478, 2.9518707716101833],
            [13.280637918830745, 3.0035754938634325],
            [13.292064008239556, 3.0669092647465135],
            [13.297842146309824, 3.1024305275704505],
            [13.302785276054486, 3.139371940235679],
            [13.311559945786678, 3.2016695975647647],
            [13.319426306553567, 3.1991629407192343],
            [13.316213674274545, 3.2062724332192776],
            [13.397988402526382, 3.2209517552282665],
            [13.439336325436692, 3.227301005216407],
            [13.487986128904705, 3.238914499190877],
            [13.515345711504033, 3.244257046939176],
            [13.562998409702507, 3.252681212991281],
            [13.610772322303832, 3.2613508056620653],
            [13.651157347741545, 3.2670742449481494],
            [13.621423777490392, 3.1804906804130955],
            [13.615087984738649, 3.1803096278892213],
            [13.609972131526565, 3.1815424012576425],
            [13.603304409181316, 3.180573958464473],
            [13.598525051816589, 3.176659512371979],
            [13.599964023499053, 3.1635863088290996],
            [13.597421655935797, 3.155304807195416],
            [13.606194021891953, 3.129354168363768],
            [13.60145928870995, 3.121358962870944],
            [13.59980022594135, 3.111777709364722],
            [13.587423650761524, 3.074693275085011],
            [13.583381570121679, 3.067312375964903],
            [13.575220609022317, 3.064077701327334],
            [13.566062358808017, 3.054460840400422],
            [13.561837767550202, 3.0509739804303755],
            [13.559562441202472, 3.044870913440963],
            [13.554600902086289, 3.0397344065944067],
            [13.54997866352053, 3.0257093631210727],
            [13.550465765555906, 3.0163497272915425],
            [13.549870456008076, 3.006710273699068],
            [13.551103318432329, 3.0016323773261293],
            [13.555219761076765, 2.995190720617732],
            [13.554294518489831, 2.985173057527789],
            [13.5517583327106, 2.980505597047687],
            [13.548628874768044, 2.9591336214646353],
            [13.553461502641573, 2.953082073934671],
            [13.559084183826023, 2.887399404573432],
            [13.531757266040605, 2.865902408655048],
            [13.528685386688775, 2.8549445437799252],
            [13.525890167947848, 2.840738215282478],
            [13.524371363622773, 2.836706992904649],
            [13.521898425103336, 2.8237798244128736],
            [13.515199788569529, 2.8135294236466017],
            [13.514650203545397, 2.8044192184655037],
            [13.514625773408138, 2.7904325066128792],
            [13.508190600611265, 2.7876604196303636],
            [13.518186007763823, 2.766564394117194],
            [13.510321228318585, 2.7488143520375696],
            [13.428109606982687, 2.734541927046285],
            [13.385571043023756, 2.727237398640914],
            [13.368894868627509, 2.7246306399535514],
            [13.364873012176222, 2.724711224699482],
            [13.362985331311505, 2.7217621343030474],
            [13.356592385346582, 2.721962497616259],
            [13.352328429770546, 2.725781921822306],
            [13.34474880460895, 2.7225885195344603],
            [13.341577016178158, 2.7193656095595937],
            [13.336089593207003, 2.7235923630197085],
            [13.331700325677732, 2.7343884618703345],
            [13.328787336216287, 2.736977248653781],
            [13.330084295598922, 2.7411628392794736],
            [13.327336878086335, 2.7450764602420277],
            [13.32324285846633, 2.7469150060184715],
            [13.307483429157159, 2.7472037484348237],
            [13.304947590042769, 2.747878615120001],
            [13.30280984739316, 2.7533896310796147],
            [13.262020287872806, 2.746726396136928],
            [13.23670708668348, 2.742129142711632],
            [13.206852568107731, 2.7361830176128468],
            [13.212023416812524, 2.74925585082816],
            [13.212394747316903, 2.752322096902242],
            [13.216655912373865, 2.7605794259557532],
            [13.215697699606237, 2.767003519420787],
            [13.219124857503106, 2.7719660432144697],
            [13.219623498173423, 2.7775067671242213],
            [13.222277789082883, 2.7810942102177747],
            [13.224566169241836, 2.79133742810444],
            [13.227381828122413, 2.7955133599940174],
            [13.231191122346447, 2.7975217108589185],
            [13.232132485891345, 2.808675221088186],
            [13.23711845363521, 2.814660725526081],
            [13.247741728467302, 2.8531970574106618],
            [13.24816551894682, 2.856851546912106]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.71339824776902, "lat": 40.49516257377826 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42021"],
        "coty_name": ["Cambria"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cambria County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01213662"
      },
      "bbox": [
        13.206852568107731, 2.7193656095595937, 13.651157347741545,
        3.2670742449481494
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.53004669885784, 5.452782018967352],
            [18.576673768252675, 5.440371868958107],
            [18.613712283002545, 5.406808562578172],
            [18.612807574042513, 5.4013778044085825],
            [18.60542886411059, 5.391369671759116],
            [18.60212905100565, 5.389889887565363],
            [18.60690705218177, 5.3815770507891685],
            [18.615242548232064, 5.372916880031975],
            [18.61611431233284, 5.367618948221801],
            [18.61560575696786, 5.360664071732082],
            [18.610427429247693, 5.362976403090419],
            [18.607230126422394, 5.357888200313273],
            [18.606167760506857, 5.352997939960919],
            [18.60748134687837, 5.344681682472835],
            [18.60643304047179, 5.334382914178523],
            [18.60045219628956, 5.33523683475654],
            [18.59634521837083, 5.341928145398766],
            [18.5967790063277, 5.347190287484848],
            [18.587324961237112, 5.353901002893354],
            [18.5837530555079, 5.359494477918791],
            [18.5833456270653, 5.365378224087141],
            [18.577520518704265, 5.36807331192342],
            [18.57570169431696, 5.364643562282271],
            [18.57857294239953, 5.358005944817682],
            [18.579096510289066, 5.3476934097244335],
            [18.574918711718528, 5.342319614272506],
            [18.576238687766846, 5.338061093666053],
            [18.57453666085208, 5.33359623077991],
            [18.56953336311412, 5.342000555310948],
            [18.56531968463378, 5.354613164758287],
            [18.565429940648244, 5.364162826761708],
            [18.56813249679016, 5.364646777339354],
            [18.570531845196736, 5.372364280807782],
            [18.568185717679107, 5.3866057131631875],
            [18.561014990006647, 5.390965835850884],
            [18.558161808326755, 5.38800087756169],
            [18.55356733715722, 5.393208469372795],
            [18.553631170304584, 5.399355044837859],
            [18.551875985121836, 5.401989605554951],
            [18.538697642764507, 5.402378692279986],
            [18.527905907491757, 5.398964384582222],
            [18.5241478273319, 5.408279203197174],
            [18.52139857849083, 5.409025296788225],
            [18.517163647346962, 5.413980148268458],
            [18.510967284541316, 5.415472130345279],
            [18.510730392674574, 5.421884529907776],
            [18.512104992421786, 5.423631802315274],
            [18.53004669885784, 5.452782018967352]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.28409390310613, "lat": 41.71739709141076 },
        "year": "2023",
        "ste_code": ["44"],
        "ste_name": ["Rhode Island"],
        "coty_code": ["44001"],
        "coty_name": ["Bristol"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bristol County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01219777"
      },
      "bbox": [
        18.510730392674574, 5.33359623077991, 18.61611431233284,
        5.452782018967352
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.952645570861314, -2.6918207189930423],
            [11.994418930824974, -2.6870792466532754],
            [12.103107358746263, -2.676442936999336],
            [12.174299794414745, -2.6687269399957865],
            [12.27663744734959, -2.658092309235345],
            [12.25218973708674, -2.6904303014566047],
            [12.258418738646949, -2.7551363511857008],
            [12.260998126332273, -2.78062683836667],
            [12.210703922439425, -2.787342447088183],
            [12.210315381630211, -2.7919319272440077],
            [12.203688411468681, -2.799819061739007],
            [12.200140719044215, -2.802467177199147],
            [12.199821606414044, -2.8079558659398236],
            [12.206617322041435, -2.825564880343268],
            [12.209755581135342, -2.830492252523244],
            [12.207300065138755, -2.8367556241865226],
            [12.208856095234204, -2.8429382395671294],
            [12.21659832038809, -2.8517935973830437],
            [12.214913048179328, -2.8659642132393928],
            [12.211533811877565, -2.871797467487958],
            [12.211559860113145, -2.8814321872304247],
            [12.209339526241344, -2.890819809215416],
            [12.21166915631466, -2.8951485675240156],
            [12.217051386483641, -2.897931912999363],
            [12.225552469356472, -2.8988298845798868],
            [12.226242960727813, -2.9024749136027514],
            [12.224610645414348, -2.90915533338381],
            [12.225699952486394, -2.91277870365232],
            [12.22994320125258, -2.9159423303011827],
            [12.2318306483109, -2.922476539812268],
            [12.228756067118622, -2.927346714201032],
            [12.227682886315275, -2.9373127392204377],
            [12.233391104224232, -2.943025704709366],
            [12.237187377525608, -2.9595414326966134],
            [12.24074765052598, -2.968654527094602],
            [12.24462421101275, -2.97353995674832],
            [12.247473294152996, -2.97991110982768],
            [12.254977359165848, -2.983854416334458],
            [12.25616762182953, -2.985941315191746],
            [12.254080027774895, -2.993475013062187],
            [12.246044592492142, -2.9871709619394236],
            [12.236993892843355, -2.9833934153279364],
            [12.23363063962383, -2.978567350931743],
            [12.230294743751841, -2.979748658574585],
            [12.22852435950049, -2.9745868385208483],
            [12.230044722507825, -2.969442832538114],
            [12.220231739834382, -2.9682955433044063],
            [12.21561606409208, -2.9703789784015053],
            [12.2114371131766, -2.96681345242342],
            [12.206783062107046, -2.965961668333583],
            [12.20193768174464, -2.962922842901323],
            [12.195587668576078, -2.9637295077634622],
            [12.195546663338508, -2.9673233161143435],
            [12.190054002997542, -2.9728499017078613],
            [12.186590694263801, -2.9631795188543624],
            [12.183815767606148, -2.9643921474630535],
            [12.184345824547163, -2.9695000674827075],
            [12.179998329502672, -2.973665497620636],
            [12.173862399707986, -2.9716865928790877],
            [12.169480001848903, -2.9721929622812557],
            [12.165968433501652, -2.9700209059669773],
            [12.16198895505384, -2.9715655789627027],
            [12.15953274278706, -2.968474959298754],
            [12.149095195324465, -2.965362481691915],
            [12.142205577541448, -2.9615473819225753],
            [12.1366854621015, -2.9659176775810883],
            [12.133609005123533, -2.9655586061136736],
            [12.127801477941363, -2.9738248800061227],
            [12.124302791359739, -2.975793398890842],
            [12.112405549281034, -2.979446812494719],
            [12.110161661831176, -2.9773555943824963],
            [12.100118722007348, -2.97417873880321],
            [12.101707521191138, -2.971684813668262],
            [12.09691610703809, -2.9675051553780607],
            [12.09479373350291, -2.9598522691045246],
            [12.091995742473339, -2.9559265669074395],
            [12.087936787530163, -2.9550019786047033],
            [12.079043972832869, -2.9597212432635267],
            [12.070475247743556, -2.9556672528501005],
            [12.067489175988467, -2.9592199637541965],
            [12.065663233747179, -2.95325339530433],
            [12.058211270220658, -2.949160263672862],
            [12.05467084553811, -2.955328867459808],
            [12.045803636313234, -2.9565697050298945],
            [12.042140831110453, -2.952003371547005],
            [12.036325582973483, -2.9517433004860623],
            [12.033452073976113, -2.9528603397764996],
            [12.031542832334749, -2.948799507556355],
            [12.027796719024565, -2.9482493995284345],
            [12.022997238325816, -2.9440781964524056],
            [12.016528660833997, -2.9341805308690128],
            [12.00549767903981, -2.9390369845007416],
            [12.000608977205243, -2.9390634305900756],
            [11.962776555495982, -2.8543892693295376],
            [11.953415162863209, -2.839448599668873],
            [11.942685857602648, -2.8407885407823974],
            [11.940660985053173, -2.8190909017549646],
            [11.866688250616782, -2.7009233921123132],
            [11.925274267100239, -2.694914904969115],
            [11.952645570861314, -2.6918207189930423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.62057259516516,
          "lat": 35.048073768386885
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45021"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01247987"
      },
      "bbox": [
        11.866688250616782, -2.993475013062187, 12.27663744734959,
        -2.658092309235345
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.169731184667723, -2.9198548817375456],
            [11.174892095841976, -2.919284302885039],
            [11.17930363491584, -2.913128816891755],
            [11.177962344884294, -2.9067772802827947],
            [11.180151427018401, -2.9052488621679937],
            [11.185006812723314, -2.907010521530175],
            [11.188817859110195, -2.905701974515373],
            [11.191488193161623, -2.8992087834071905],
            [11.194223406197406, -2.8959634644782333],
            [11.195890170309633, -2.8897674150302937],
            [11.205467715341063, -2.889641940756223],
            [11.215159090226186, -2.8820079104222853],
            [11.219230192706954, -2.88487571274242],
            [11.226469358269494, -2.8712032244666905],
            [11.219005565007278, -2.8655690261876163],
            [11.220203247088067, -2.861398209218013],
            [11.223973861732599, -2.8602386270248292],
            [11.223600274792798, -2.854361005493256],
            [11.22773485600559, -2.850927952124338],
            [11.2334260526296, -2.851634751984038],
            [11.234925713611869, -2.8545223361910352],
            [11.234675058064369, -2.8595581210058905],
            [11.244421387784788, -2.8585408016377554],
            [11.247874153738596, -2.8567625000836845],
            [11.252215519429093, -2.852109481818775],
            [11.251484891318349, -2.84948186821686],
            [11.256914184694821, -2.847941828382313],
            [11.257998507815582, -2.844097338620355],
            [11.263492006309912, -2.8434003193367077],
            [11.264372766824055, -2.848222693612343],
            [11.270064066320971, -2.8467463936842208],
            [11.275163166495476, -2.837396705653253],
            [11.283754148622464, -2.8316992025185397],
            [11.289652749198027, -2.8308664722715102],
            [11.29322375114486, -2.831690187227402],
            [11.297626587483013, -2.8297705024953466],
            [11.300498646067137, -2.8253681483555297],
            [11.306663398100028, -2.825700055983866],
            [11.311622813661923, -2.823038202455847],
            [11.314810802463846, -2.820954943811825],
            [11.318846288764806, -2.813963406843374],
            [11.323090441391045, -2.8140183957629077],
            [11.3269492077153, -2.8108593397489403],
            [11.324056030012931, -2.806847206960364],
            [11.325836736237322, -2.802713631592074],
            [11.335107060343615, -2.800966831222401],
            [11.339316906885989, -2.80238432485752],
            [11.341400052582012, -2.8075066869151213],
            [11.345389692867569, -2.806072192512925],
            [11.352954273091797, -2.8014440536348526],
            [11.355450529375112, -2.7966741938723088],
            [11.362121253209713, -2.7967766098835645],
            [11.365015801995948, -2.7927809374963077],
            [11.369624937448759, -2.7951473756568403],
            [11.372168743874614, -2.7931982992657214],
            [11.377172608148134, -2.7843593239235047],
            [11.385745993447792, -2.7800878503843256],
            [11.392401571854192, -2.780003395463087],
            [11.39823504471171, -2.775595372294935],
            [11.402978043112297, -2.775657728036824],
            [11.405819396257916, -2.7800495467336686],
            [11.401824473580353, -2.7865885907620016],
            [11.402645546329797, -2.789409363692213],
            [11.40768020813186, -2.786481119373159],
            [11.416436834864978, -2.785484759581415],
            [11.421663739775877, -2.777757179581131],
            [11.421815006040577, -2.772055734086004],
            [11.424822769543765, -2.7709927320350505],
            [11.423246178318665, -2.7668361283210703],
            [11.424667550497281, -2.756587325450229],
            [11.427657083687519, -2.750537865749344],
            [11.43387074940177, -2.7457052570279226],
            [11.439961157240644, -2.7428035179035195],
            [11.444837603292832, -2.733203550843575],
            [11.448738750048989, -2.7304215776458594],
            [11.454576080981823, -2.7345210959547743],
            [11.455195984022968, -2.7373799216813515],
            [11.460612211647785, -2.7463650447405294],
            [11.458326093034835, -2.7523545314229048],
            [11.459046091793077, -2.755202917418941],
            [11.464127865365182, -2.7597293481481624],
            [11.468975793815854, -2.7620618751346466],
            [11.47411622879482, -2.7579854075736714],
            [11.474243871745687, -2.752964523898076],
            [11.481570185364506, -2.749276791121573],
            [11.48873812523523, -2.747332815534058],
            [11.494575882732398, -2.7506680989951735],
            [11.497607949736475, -2.7485488629095385],
            [11.500885082116644, -2.7520391797073605],
            [11.50694373610967, -2.7531762507116326],
            [11.510893043314574, -2.7494800744430696],
            [11.512088560373872, -2.746435964468839],
            [11.518730146560832, -2.743097620353096],
            [11.527917397635044, -2.7397773484013985],
            [11.532922219128634, -2.735345267931515],
            [11.543558444622592, -2.732308454686766],
            [11.579312471703776, -2.7304533860802866],
            [11.591426725030477, -2.7294554018364727],
            [11.601766129891029, -2.8094122292666395],
            [11.614513196413357, -2.912187838059104],
            [11.622718115733228, -2.977399301079462],
            [11.625061476648883, -2.9974361835839503],
            [11.633139026921974, -3.073084146402465],
            [11.638550546702364, -3.0713753541546533],
            [11.640249864505979, -3.0741550920431706],
            [11.646519497441494, -3.078675898120529],
            [11.647159362521116, -3.0809353580178596],
            [11.660285953093222, -3.0869141312593005],
            [11.671370733863023, -3.098539274025749],
            [11.68062233273686, -3.1073568591200957],
            [11.68434408909019, -3.1135461656610466],
            [11.6889958806942, -3.1112727439197574],
            [11.691826308431125, -3.1152760358519065],
            [11.685652034132948, -3.116155345289015],
            [11.69604614188957, -3.1271680922522753],
            [11.701708196966168, -3.1292044108284482],
            [11.701166352073827, -3.1322675189401195],
            [11.703881940660214, -3.1346691681075916],
            [11.708003056273961, -3.1306092525357108],
            [11.693767062039454, -3.1914792158376577],
            [11.682015047663286, -3.244519876377984],
            [11.664702120471883, -3.336743533306127],
            [11.671443456185772, -3.390141529060517],
            [11.650475506406758, -3.412963642022992],
            [11.615905478163027, -3.4500782746282046],
            [11.611810826933132, -3.449344953442997],
            [11.61056910831598, -3.444975560718157],
            [11.605266702002526, -3.4451222998626707],
            [11.603390060033345, -3.440291502735478],
            [11.598045334636613, -3.4370682347969552],
            [11.59310183393279, -3.435583308141468],
            [11.58944157905161, -3.4379808321025984],
            [11.587128403016322, -3.430221434629259],
            [11.578668780333496, -3.426065949716646],
            [11.57067708980048, -3.4249880084865025],
            [11.569126875342148, -3.420701201027495],
            [11.564638620841626, -3.4193584452759476],
            [11.562797128069679, -3.416086545565097],
            [11.551916159230068, -3.407881915404943],
            [11.549341812943434, -3.4037666063462857],
            [11.543899103591862, -3.4000742076783683],
            [11.532918752224015, -3.400326692536619],
            [11.52679409075941, -3.3977347802952647],
            [11.519860940240902, -3.3899074200917783],
            [11.520058936893948, -3.383585264777738],
            [11.518328418495743, -3.3784032522819296],
            [11.512394078579797, -3.3738745689712912],
            [11.515393042758111, -3.37022996115712],
            [11.512391379552563, -3.3630655217779615],
            [11.509248337935116, -3.3596762744281414],
            [11.506046675439316, -3.35326016270056],
            [11.506829280986164, -3.3493408969532448],
            [11.499810204460863, -3.34400818052783],
            [11.494431853762299, -3.343664055122224],
            [11.496606234593035, -3.339608342424367],
            [11.491898253862722, -3.334892210705312],
            [11.486594357302955, -3.3314529396356334],
            [11.488473429822367, -3.3270593747341697],
            [11.483392788224068, -3.3273827311752484],
            [11.483025066401243, -3.3203165554892053],
            [11.481170955963439, -3.314885817182943],
            [11.483736929628124, -3.310857466550187],
            [11.479472898278942, -3.3080792062712323],
            [11.478310080290708, -3.302953999915295],
            [11.47601117223983, -3.3010268463216415],
            [11.476203952915057, -3.294338663977864],
            [11.471632163251252, -3.296840035312805],
            [11.469994303824034, -3.2920877520740053],
            [11.46650530199328, -3.2876888520646115],
            [11.469510769584513, -3.2811084204662926],
            [11.471649970324785, -3.279359102407331],
            [11.472261813627524, -3.2715347214605583],
            [11.471378917743088, -3.26954188908581],
            [11.465710502210474, -3.2670129379970416],
            [11.4691729819169, -3.2634439791056313],
            [11.465209623968619, -3.2591433663977836],
            [11.465771378056713, -3.2563842888678005],
            [11.46936069295945, -3.252360735217778],
            [11.46415975939539, -3.2509851470159528],
            [11.461343613251387, -3.2440742632000643],
            [11.465725784909685, -3.243521078743606],
            [11.46682391432701, -3.2377561230518914],
            [11.461366780371371, -3.236338828746218],
            [11.459263086821483, -3.231719763161494],
            [11.45963144772419, -3.2280058251052988],
            [11.45869032849669, -3.216017697990159],
            [11.4614134467707, -3.213486915328266],
            [11.457583098549575, -3.2079127811305455],
            [11.460142016605273, -3.206487622238228],
            [11.463433459170021, -3.2011780081556735],
            [11.46013415752576, -3.19664050966992],
            [11.46212525970456, -3.1942112950860384],
            [11.460293975475608, -3.190505971082138],
            [11.463816816113402, -3.1827076179480325],
            [11.462216265675034, -3.175168223914939],
            [11.45672980549852, -3.173157146013091],
            [11.455305071462188, -3.1708865438333236],
            [11.45502203614611, -3.1641051907385176],
            [11.451651237093635, -3.1598612740228686],
            [11.452176803303198, -3.156022578694548],
            [11.445188183077532, -3.155536005174561],
            [11.445649969164005, -3.1516698682192588],
            [11.442125401137684, -3.149861270117975],
            [11.43876954091898, -3.1439414964425323],
            [11.42794879802897, -3.1367656878202954],
            [11.430685495223544, -3.1316131658657484],
            [11.43396887516427, -3.1302688886697507],
            [11.435269181299022, -3.126635688579947],
            [11.431564834563266, -3.1247913876843336],
            [11.426329329999062, -3.1252337091045153],
            [11.425647092697622, -3.11898912866525],
            [11.430209959037498, -3.1154479705818794],
            [11.42308663921477, -3.114961851832651],
            [11.426238523488571, -3.1112146223081445],
            [11.424584145538658, -3.1013502422004273],
            [11.425633513399406, -3.0974893898782634],
            [11.420283573174078, -3.0947284281637946],
            [11.421158498568927, -3.0895416420715276],
            [11.41909930495502, -3.080250465422203],
            [11.415836073532642, -3.078095344203112],
            [11.418007096666079, -3.070996904014522],
            [11.410542035431776, -3.06946035178627],
            [11.409275949864544, -3.065852900323619],
            [11.41154210254121, -3.063697092053128],
            [11.410484395841662, -3.0597149949002156],
            [11.407271538026368, -3.058541169547299],
            [11.403159054301662, -3.0541528918100336],
            [11.400640335544697, -3.047031353441166],
            [11.395944673788211, -3.044519455172534],
            [11.394585737224388, -3.040848678112714],
            [11.38918725434834, -3.040372593804327],
            [11.385052241385374, -3.032671329859516],
            [11.386965584173254, -3.0256822691202703],
            [11.379829398951117, -3.0210485490891275],
            [11.378888508173873, -3.017314838199048],
            [11.379454049199273, -3.0083133162644464],
            [11.375282176397459, -3.0070390807898675],
            [11.375535232879729, -2.999710750665384],
            [11.37264906277803, -2.994327234385916],
            [11.370027628973489, -2.9951096924817926],
            [11.367915153245441, -2.98825559492582],
            [11.365422343378443, -2.9899545498041054],
            [11.360576789624048, -2.985751013699855],
            [11.35604720025343, -2.9845461440427963],
            [11.361033166338286, -2.9801465582114526],
            [11.366523935834921, -2.9779291367073872],
            [11.366212834689108, -2.974734126465747],
            [11.361122096435286, -2.964320834713678],
            [11.357461219949574, -2.9615497912552],
            [11.356308190425928, -2.958219185090026],
            [11.359346334888796, -2.948994184043419],
            [11.359017417176604, -2.9467365655187177],
            [11.352239844356646, -2.9486801872948925],
            [11.344211878682467, -2.9492881317108695],
            [11.339164490487986, -2.9528930704083423],
            [11.330846109067567, -2.953749398094976],
            [11.32798838526898, -2.9572754304568507],
            [11.315008514917153, -2.960706262787783],
            [11.312728117081582, -2.9560091311467773],
            [11.313457905255296, -2.9526329079512603],
            [11.317641837938567, -2.946966002456783],
            [11.31582831128691, -2.942893411784185],
            [11.315526160673949, -2.937557485667651],
            [11.318136784394794, -2.9353242921075404],
            [11.31378443704916, -2.929035818714478],
            [11.313677761395134, -2.9258299155854792],
            [11.306378998705854, -2.9285232538772643],
            [11.306269718714152, -2.9230184753725816],
            [11.307683829851335, -2.9196610431448398],
            [11.305388286102724, -2.9148619075349633],
            [11.308469415696925, -2.9057617947564607],
            [11.32083910115425, -2.9014119102557347],
            [11.322774019212309, -2.9019103910175126],
            [11.325098886175248, -2.8957368932544134],
            [11.32027374428995, -2.892909955100749],
            [11.30905530840009, -2.8945103693691703],
            [11.295945728255019, -2.899846441013396],
            [11.29186615608498, -2.8984861610059918],
            [11.291064792281402, -2.903544198166664],
            [11.286146312070782, -2.9042598509906163],
            [11.281498253685603, -2.907639055837589],
            [11.272244767642828, -2.90941354155763],
            [11.269442545248646, -2.913989817212134],
            [11.263541589344367, -2.91471658344055],
            [11.262096583442462, -2.912198285815087],
            [11.255982542612614, -2.909963673041836],
            [11.24936782734953, -2.911916280888934],
            [11.245378799623902, -2.915068827885533],
            [11.241732922971428, -2.913030386415683],
            [11.236616604183077, -2.916919105314058],
            [11.23065712159138, -2.9166261527100596],
            [11.218964485843559, -2.9203445692369323],
            [11.21549435422315, -2.919576215337037],
            [11.210521527170458, -2.9235038019075197],
            [11.210285538353226, -2.928042174321611],
            [11.208053967485123, -2.9301622207082185],
            [11.203354482957355, -2.9282660039754105],
            [11.19950502927987, -2.9291583515086566],
            [11.199012973470067, -2.9329655422140437],
            [11.194420093105808, -2.933218375259154],
            [11.193095637689508, -2.9364068189706],
            [11.189473183801729, -2.938310343399787],
            [11.184177632281173, -2.938749531545517],
            [11.174535966265147, -2.9297864011513797],
            [11.169731184667723, -2.9198548817375456]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.37055976821719,
          "lat": 34.894089011903034
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45045"],
        "coty_name": ["Greenville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greenville County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01245489"
      },
      "bbox": [
        11.169731184667723, -3.4500782746282046, 11.708003056273961,
        -2.7294554018364727
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5924454109628078, 6.141177327028357],
            [-0.5065683658032808, 6.139801269422957],
            [-0.4205216261663643, 6.13891049828295],
            [-0.3345533537412272, 6.136954588654558],
            [-0.29473540255258157, 6.137076513780165],
            [-0.24871715944995754, 6.137001917133589],
            [-0.16273378050911194, 6.1362362943478574],
            [-0.16308731522945033, 6.092940447885176],
            [-0.1646079517731737, 5.9664141755023365],
            [-0.16478583540912883, 5.96303851650946],
            [-0.16582891966018373, 5.876470943599713],
            [-0.25279366262411507, 5.8770444193930365],
            [-0.2810900911343632, 5.877400652986389],
            [-0.2947777392793481, 5.877120317362834],
            [-0.33825443905533, 5.877642652827097],
            [-0.38191160106900685, 5.878231963651499],
            [-0.467731784075064, 5.879620867861088],
            [-0.5750370716441688, 5.881653830671382],
            [-0.5971900195262748, 5.881949362972483],
            [-0.5957701162468955, 5.968429708669281],
            [-0.5935950889279298, 6.083648496283079],
            [-0.5924454109628078, 6.141177327028357]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.18831132578771,
          "lat": 44.673762897901575
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46057"],
        "coty_name": ["Hamlin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamlin County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01265766"
      },
      "bbox": [
        -0.5971900195262748, 5.876470943599713, -0.16273378050911194,
        6.141177327028357
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.164340583879797, 5.421912016945966],
            [-3.1519686117739485, 5.4212972935431445],
            [-3.1472387347763395, 5.507615429342998],
            [-3.142820185998504, 5.594371331868021],
            [-3.040689007178816, 5.588717538012426],
            [-3.03796642161758, 5.588386690927072],
            [-2.9709709475087736, 5.585373986456141],
            [-2.9532056111598326, 5.584116516437082],
            [-2.9362056087648036, 5.583962616849078],
            [-2.9251030122103865, 5.583022028093012],
            [-2.8385277321249807, 5.578858531500519],
            [-2.7174349731321086, 5.573329270227958],
            [-2.6599283672641074, 5.570580153377606],
            [-2.6574543988809385, 5.570637820707096],
            [-2.659463795633584, 5.527034340593211],
            [-2.659338160839935, 5.526110796290756],
            [-2.665217906043041, 5.397399765582974],
            [-2.6680148804396593, 5.336476390114441],
            [-2.6715443471938447, 5.249496593058257],
            [-2.6523257835713867, 5.248702570577527],
            [-2.6579819492516084, 5.118705136387318],
            [-2.662436762304713, 5.121994915406431],
            [-2.663581079846017, 5.129701678410087],
            [-2.6689626435858056, 5.133070106712432],
            [-2.671464056235611, 5.136780813379866],
            [-2.6751370281749947, 5.138321478938637],
            [-2.6780469145926498, 5.141737699880443],
            [-2.6815379705044773, 5.141456172699048],
            [-2.6856443662707625, 5.134556902404873],
            [-2.6849978553423743, 5.131296193223922],
            [-2.6880162503525598, 5.129241054380017],
            [-2.6926005815376994, 5.129384755229115],
            [-2.6956855188035727, 5.133552843530248],
            [-2.7021596636834118, 5.134674385067956],
            [-2.712082003972416, 5.139851979808489],
            [-2.7140344180269755, 5.138285344793219],
            [-2.7106895624153804, 5.131995734437364],
            [-2.71163460989954, 5.127381521454598],
            [-2.7158235615291133, 5.1224539041001655],
            [-2.7211851485086074, 5.127492846723037],
            [-2.7254191190436097, 5.129506904705349],
            [-2.7319412232398075, 5.137280002980173],
            [-2.734877139062796, 5.137115471636556],
            [-2.73667630263715, 5.131346896899833],
            [-2.73908343337335, 5.1280047588182445],
            [-2.7448844762933975, 5.12682795485807],
            [-2.7504157595225776, 5.131245345859417],
            [-2.7481007942296904, 5.135615706835723],
            [-2.7524632758101304, 5.137416175076072],
            [-2.7555096936443575, 5.133441771999784],
            [-2.7596474443675802, 5.134891724318799],
            [-2.762613067530602, 5.142370594383896],
            [-2.7664064046923413, 5.14461276912367],
            [-2.769731725038747, 5.139784090407543],
            [-2.7765224319577597, 5.136079337767824],
            [-2.7851202160667157, 5.1384065548015245],
            [-2.7834334685126594, 5.143152930267939],
            [-2.7834756544678743, 5.1483355463712215],
            [-2.7882358469186874, 5.154123121506046],
            [-2.7930008737037526, 5.152903439752994],
            [-2.7973778660252173, 5.14761245303935],
            [-2.8026365495220045, 5.145306418142243],
            [-2.8120892347363746, 5.146222879802029],
            [-2.8119478710398416, 5.150056087623228],
            [-2.808885780986658, 5.151811325852289],
            [-2.807992439102495, 5.156188302487544],
            [-2.809390449156049, 5.163684287405019],
            [-2.8117733056366485, 5.164822343515445],
            [-2.8164638419828756, 5.162456371865073],
            [-2.8244260723272157, 5.162632487516131],
            [-2.8260039595245456, 5.170686042360637],
            [-2.830448602343955, 5.177383328641477],
            [-2.834408043676748, 5.179370865250918],
            [-2.8375289644184085, 5.178872310168839],
            [-2.839433567348192, 5.17581524806361],
            [-2.845176490740621, 5.173554094950133],
            [-2.851611221108991, 5.169518583313091],
            [-2.8513879662543626, 5.160713681385094],
            [-2.85438386093791, 5.156332759967152],
            [-2.8576326311341833, 5.154510462903291],
            [-2.8614198484547106, 5.155675282842842],
            [-2.870214749706401, 5.150643114486046],
            [-2.871467678551576, 5.158173876679059],
            [-2.8742574677552875, 5.160943051845227],
            [-2.880451839164612, 5.161902737415215],
            [-2.88622699008572, 5.1594831195635145],
            [-2.8917737255868223, 5.154402242820388],
            [-2.8942707619277535, 5.147345797622768],
            [-2.88564380931604, 5.14831681108473],
            [-2.8830447620025885, 5.144127416460145],
            [-2.9010504286696364, 5.135968868998984],
            [-2.900904740722433, 5.126994968501516],
            [-2.903303256054632, 5.124993594497586],
            [-2.910333933479541, 5.1274921515595935],
            [-2.9162303828677425, 5.133115098966547],
            [-2.914240254148783, 5.1379029973135655],
            [-2.9179276594187984, 5.138342063397164],
            [-2.922334793049337, 5.132367664654615],
            [-2.928909670678896, 5.135021889915821],
            [-2.933791268131073, 5.129960851624132],
            [-2.9367236661366056, 5.136503400434875],
            [-2.944631690698069, 5.1361027668435835],
            [-2.945436760510459, 5.13274785933362],
            [-2.9388554695252416, 5.131293441067565],
            [-2.9373537393603772, 5.129043796214734],
            [-2.9396301854229923, 5.123741731948092],
            [-2.9431527070305643, 5.1229401263592225],
            [-2.948136435344691, 5.131750439117008],
            [-2.9490952846828686, 5.13490265694271],
            [-2.955888790845066, 5.138892297053458],
            [-2.9480339653279954, 5.143823720758728],
            [-2.946778866286088, 5.146913744173136],
            [-2.9488441156638348, 5.1498494512063475],
            [-2.9569838462561955, 5.151104173279265],
            [-2.9587961511373817, 5.147272077768403],
            [-2.9654560920331914, 5.148216635798674],
            [-2.9721792227633643, 5.141373851917571],
            [-2.975040194725745, 5.140909355813123],
            [-2.9817941978831235, 5.1428816927037575],
            [-2.979737860337539, 5.147677466775824],
            [-2.9802011099975854, 5.152060932140326],
            [-2.978709870103954, 5.157326558702249],
            [-2.980859694519447, 5.1596836507492645],
            [-2.98382887750691, 5.157568715344125],
            [-2.9914667376423725, 5.162185059670995],
            [-2.990828096172376, 5.167000568143721],
            [-2.987134263000631, 5.16453442278154],
            [-2.983774030455776, 5.168626208739189],
            [-2.98645857113644, 5.173039039539552],
            [-2.988868965303246, 5.171624312929514],
            [-2.9918363919507964, 5.175960457701144],
            [-2.9911644058004963, 5.181318759737981],
            [-2.993380411905792, 5.184885026718287],
            [-2.996990436227638, 5.1848258751904615],
            [-3.00770767543934, 5.1876367831676085],
            [-3.0132200642307185, 5.186128825607064],
            [-3.0117404344903957, 5.181405610186723],
            [-3.0144338061906293, 5.178027488759864],
            [-3.0168870709102475, 5.179274521084726],
            [-3.0155213465597592, 5.185513626844163],
            [-3.018527888401476, 5.186904940836349],
            [-3.0233416465780523, 5.199555846340286],
            [-3.0298533078965058, 5.208587537880541],
            [-3.0325230432365644, 5.208552484378777],
            [-3.034681910979772, 5.201449489493497],
            [-3.040393792005549, 5.201108492607807],
            [-3.0408426018850085, 5.206897830745096],
            [-3.0374464246594304, 5.209251423634614],
            [-3.0388081120419583, 5.214621642325011],
            [-3.038813277894252, 5.220526174442711],
            [-3.0430738673139643, 5.222139817598898],
            [-3.0457793136695117, 5.220038606459252],
            [-3.044888000128575, 5.215456351320727],
            [-3.0466763810834396, 5.212524170520058],
            [-3.050253861376136, 5.21258538693118],
            [-3.058455675278684, 5.215358454861962],
            [-3.0520181913407796, 5.218360993963537],
            [-3.0525409472135334, 5.221570747901167],
            [-3.060449642238817, 5.221493500798862],
            [-3.063464099550767, 5.223296658477612],
            [-3.065506631177471, 5.228690314551442],
            [-3.058412476871449, 5.225870238517668],
            [-3.0548825819909187, 5.228043707202608],
            [-3.0547752116299964, 5.233118278237691],
            [-3.059546359457328, 5.235634201175522],
            [-3.0628680385979883, 5.233835786499244],
            [-3.0681438532024226, 5.2361069815223065],
            [-3.0689204828129037, 5.243839076253844],
            [-3.0768686182991214, 5.253159736511393],
            [-3.0844960587331465, 5.253554491784882],
            [-3.086766155906734, 5.247179651872093],
            [-3.088325141842942, 5.239107854218273],
            [-3.0943129568365, 5.234318455623738],
            [-3.094850986694075, 5.24046479404734],
            [-3.102528181343984, 5.239502436192689],
            [-3.106390867271986, 5.241385682455025],
            [-3.108529523221853, 5.250718145599374],
            [-3.1048099332988186, 5.251860794813178],
            [-3.1024786453939335, 5.249861170202462],
            [-3.0984354111211987, 5.252360905936331],
            [-3.097866450483281, 5.2560205578618655],
            [-3.10086869988897, 5.257077793527819],
            [-3.105493478370189, 5.254858850264861],
            [-3.1107825916825487, 5.2558405290057495],
            [-3.1153381913786378, 5.258833642271283],
            [-3.112862106568049, 5.2612732101811535],
            [-3.1173748352595023, 5.266638862234206],
            [-3.115820163368758, 5.271347899717418],
            [-3.116872482131833, 5.273490220319935],
            [-3.122954403321563, 5.274467280997153],
            [-3.1346512290329738, 5.266524435283003],
            [-3.1359915651123433, 5.268612174816934],
            [-3.143432047821222, 5.267313821169973],
            [-3.1490629974312188, 5.269054345816269],
            [-3.148318584009292, 5.274311061689098],
            [-3.1438986018217494, 5.278122514655305],
            [-3.147030774900267, 5.283699567676606],
            [-3.1494552266192213, 5.282430964116088],
            [-3.1510203613679377, 5.278080702568988],
            [-3.1567111496550555, 5.279111218585973],
            [-3.161948869452968, 5.278360255460734],
            [-3.1658972106369836, 5.281506747022861],
            [-3.168305366839745, 5.279368936339036],
            [-3.1670323993581744, 5.2760837922554185],
            [-3.168414658764943, 5.272418850157289],
            [-3.172749914660733, 5.268384034629154],
            [-3.1675345573107454, 5.364662367487213],
            [-3.164340583879797, 5.421912016945966]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.6897275891944, "lat": 43.96062570937954 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46075"],
        "coty_name": ["Jones"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jones County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01266981"
      },
      "bbox": [
        -3.172749914660733, 5.118705136387318, -2.6523257835713867,
        5.594371331868021
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.349943695750672, 5.583743651092494],
            [-2.347990998348474, 5.576749672301607],
            [-2.345257226956781, 5.571306415188929],
            [-2.335830431374824, 5.555851900993336],
            [-2.3316988298232086, 5.542460752898493],
            [-2.324212691054156, 5.52871620746487],
            [-2.31953502813485, 5.521753424329604],
            [-2.3142658047870053, 5.5167048957072575],
            [-2.3023559787414443, 5.511000432263104],
            [-2.2972565397083016, 5.510073268598247],
            [-2.2795128200311114, 5.51123400142772],
            [-2.256649539019739, 5.516525028460786],
            [-2.2490082256471555, 5.5177331441543975],
            [-2.2312471060449606, 5.519534228135401],
            [-2.218291169283, 5.51610132546222],
            [-2.204567286650063, 5.507735259715764],
            [-2.189426877179862, 5.500332297415873],
            [-2.175220097050291, 5.495349645682009],
            [-2.1648850095337218, 5.490472921045493],
            [-2.158633348904983, 5.486060316945781],
            [-2.150976315222542, 5.482374090483499],
            [-2.1412766847766007, 5.479429413982585],
            [-2.133266615170104, 5.477995762172731],
            [-2.1260631679727022, 5.480031208037434],
            [-2.1206593802950584, 5.483223995071415],
            [-2.115179347620469, 5.489369905641968],
            [-2.1112276625177238, 5.497449766376765],
            [-2.1102553647670628, 5.502905291896245],
            [-2.11259618766879, 5.518489074500962],
            [-2.1175514121281114, 5.528275593236905],
            [-2.126304622544082, 5.536217511804098],
            [-2.134735357093958, 5.54214643733418],
            [-2.141702090364687, 5.5457958962504375],
            [-2.1508484419391425, 5.549289709813878],
            [-2.1706839395252735, 5.551723695059176],
            [-2.1776932615063473, 5.554050361516953],
            [-2.182684119101707, 5.559039530371324],
            [-2.1878892316853795, 5.566643474024392],
            [-2.1872447610433006, 5.575228102238111],
            [-2.180493237124278, 5.585125125779966],
            [-2.167685498335482, 5.595716553527951],
            [-2.152914034217982, 5.598202417529082],
            [-2.1415229122743384, 5.5978451022712425],
            [-2.130741511015189, 5.595500643775361],
            [-2.1172258747263006, 5.589701221089462],
            [-2.103760773047289, 5.5828732101645855],
            [-2.0917962960160668, 5.570809273199395],
            [-2.0744949542159805, 5.5489733388524245],
            [-2.0674783461274795, 5.5360165320758155],
            [-2.0677154846352757, 5.527657850984081],
            [-2.0781014750089826, 5.505686245873051],
            [-2.08370624035384, 5.487849487712166],
            [-2.084962466945105, 5.481760245700739],
            [-2.0847651654339807, 5.475647599286694],
            [-2.082616362744779, 5.470076766014419],
            [-2.075193395786678, 5.459836358671868],
            [-2.072190493297684, 5.454251824178554],
            [-2.066233214764576, 5.447168311718698],
            [-2.0591476633350934, 5.4409852077932905],
            [-2.050297822914597, 5.431911636401962],
            [-2.042508319023759, 5.430375826606238],
            [-2.0327236158349336, 5.427414368744588],
            [-2.0234286873946625, 5.42594672460765],
            [-2.0118396912384977, 5.424960040932518],
            [-1.9992197519227077, 5.421849760890994],
            [-1.9908623291212806, 5.417560158033062],
            [-1.98645913096219, 5.414338962506121],
            [-1.974297145423203, 5.40095415278624],
            [-1.9576652085432262, 5.387674512090381],
            [-1.9474543133757876, 5.3755355157322215],
            [-1.939609953222149, 5.36828124815547],
            [-1.934566782215934, 5.354222479670317],
            [-1.9354105612093622, 5.335115668428128],
            [-1.9386842900179102, 5.319386993324378],
            [-1.9433056741965489, 5.307453325588936],
            [-1.9448969792355286, 5.299935355940185],
            [-1.9477498695615971, 5.294162917645949],
            [-1.9492468815694168, 5.288064595910117],
            [-1.9487090134933749, 5.276366209248537],
            [-1.9421861648579648, 5.265347021007718],
            [-1.9260518860381637, 5.255218386397879],
            [-1.9175856428048055, 5.247164114487334],
            [-1.912456255114541, 5.238974317705245],
            [-1.9115705184802676, 5.232329237729838],
            [-1.9137820983991864, 5.227247001655731],
            [-1.9318505460890478, 5.197521715336519],
            [-1.935315466186148, 5.192347172295266],
            [-1.9432640308015023, 5.182559319692729],
            [-1.955793715171274, 5.165901097449877],
            [-1.9663134971751124, 5.159969030439475],
            [-1.9831040958999957, 5.153881577133084],
            [-1.9879799088133234, 5.149219315814463],
            [-1.989898627376562, 5.144979824725288],
            [-1.992396601020719, 5.134747498453403],
            [-1.993294457063272, 5.126664298519523],
            [-1.9954186935052713, 5.119669679367562],
            [-1.9937578236821165, 5.113351944835147],
            [-1.987889188536683, 5.103026289282893],
            [-1.9875253757645805, 5.094091314406222],
            [-1.9898760567364218, 5.08647319396128],
            [-1.988183709431224, 5.0798264643736815],
            [-1.9919241278058941, 5.075054412685761],
            [-1.9991751770038797, 5.071250163212768],
            [-2.0079099759466925, 5.069424946226063],
            [-2.020115964328421, 5.065479001927125],
            [-2.024316428742798, 5.062754115079391],
            [-2.033740035241651, 5.051823238485966],
            [-2.034072232159319, 5.0489731966457585],
            [-2.028765498641999, 5.033223923708905],
            [-2.025025942937533, 5.030360175603517],
            [-2.0157431637696654, 5.027440462556461],
            [-2.0062551987365356, 5.027119651391008],
            [-2.0005971686365998, 5.028035715941506],
            [-1.9878076000732763, 5.0316306611378305],
            [-1.9786261701915224, 5.032592012509185],
            [-1.9671898497829157, 5.03062154558256],
            [-1.9611759719800679, 5.026414469977282],
            [-1.9534925422512963, 5.015599558620775],
            [-1.948745064856892, 5.0018255259211255],
            [-1.9456542795841885, 4.988910304258665],
            [-1.9444166821204052, 4.9748940764538645],
            [-1.9447504483966362, 4.966052109887728],
            [-1.9441137312349097, 4.953774221096052],
            [-1.9423440600214932, 4.947683926475359],
            [-1.9389005513206796, 4.9433926785731614],
            [-1.9333959837097634, 4.933573889759935],
            [-1.9250876191498274, 4.926264650222138],
            [-1.923565962435915, 4.9233936981277004],
            [-1.9137951188436573, 4.913855669889421],
            [-1.9052944911744254, 4.902571820459704],
            [-1.9040966009658504, 4.897174357739029],
            [-1.9053321606323994, 4.889721208199101],
            [-1.9124421904148061, 4.876214388694957],
            [-1.9168719287578, 4.87163074267482],
            [-1.9169621488652955, 4.871446556151405],
            [-2.0013319189705143, 4.874450595452891],
            [-2.087589442450587, 4.877692244377395],
            [-2.151870212586626, 4.8801633184235325],
            [-2.148426728046329, 4.967052857793428],
            [-2.1464905525864544, 5.017810612098103],
            [-2.1453628029141942, 5.053342908356392],
            [-2.1450967995595254, 5.053984550332312],
            [-2.1436731157755586, 5.097351972859883],
            [-2.1425904496514696, 5.122688924247059],
            [-2.1482073530819865, 5.117649739023817],
            [-2.155725239425042, 5.116449980331128],
            [-2.1571026167536043, 5.119331212852147],
            [-2.1557634168672366, 5.123389834823943],
            [-2.1550748317503317, 5.1335366113202925],
            [-2.1564534512887645, 5.1396655029563245],
            [-2.1648693012241402, 5.14693238529937],
            [-2.1691894038483674, 5.147724626715825],
            [-2.173301823374315, 5.1449231517631295],
            [-2.1718201090616716, 5.136759240764765],
            [-2.1704019620168644, 5.123947354650252],
            [-2.17056031012966, 5.117419367003681],
            [-2.175176402674225, 5.1114048606978715],
            [-2.180405665654963, 5.109630264635012],
            [-2.186841846936666, 5.10975146907792],
            [-2.191186615848555, 5.115193565926157],
            [-2.1896477155441056, 5.120644273116471],
            [-2.1852090919576685, 5.126832645221436],
            [-2.183578966315395, 5.13120374124852],
            [-2.1844286277976654, 5.135897694485497],
            [-2.1870942388677452, 5.140277412314361],
            [-2.190976795889844, 5.142568438111433],
            [-2.1939633591276886, 5.141570138121921],
            [-2.1974308301572325, 5.13587945579846],
            [-2.201980405218682, 5.132498916792919],
            [-2.2049910826027506, 5.124806782389209],
            [-2.2056975328725192, 5.115789652281413],
            [-2.213266182205658, 5.10874631910924],
            [-2.218274434128068, 5.102581458324077],
            [-2.222025615998996, 5.102485925755545],
            [-2.2270647308432574, 5.106815559926679],
            [-2.2239279609610607, 5.115395303772052],
            [-2.2263175554923578, 5.1305623709582395],
            [-2.230312951481208, 5.132425756478781],
            [-2.2336988713609607, 5.131479820782294],
            [-2.2397263322781464, 5.126513201155939],
            [-2.2436103818444773, 5.120875791321113],
            [-2.243392950678381, 5.114013443296911],
            [-2.239725415978665, 5.110148096441454],
            [-2.2392962555562033, 5.104922876372668],
            [-2.23755303461724, 5.101898174390423],
            [-2.232860901518411, 5.0991249340277784],
            [-2.2314251992800522, 5.094543769490793],
            [-2.240365737825858, 5.092665081279805],
            [-2.250229705607285, 5.097779500460315],
            [-2.253640385642947, 5.095397782733674],
            [-2.2591219963314986, 5.094466816194542],
            [-2.269643069160429, 5.096831157860434],
            [-2.2695924722087444, 5.0889575496708],
            [-2.2725992146778187, 5.085881804219789],
            [-2.2788862152696963, 5.084713143652652],
            [-2.298766107146705, 5.0753997199845955],
            [-2.3013306128140596, 5.075472936585836],
            [-2.3050465038497845, 5.082160329497965],
            [-2.30922915106009, 5.0873629489538725],
            [-2.3140119703751676, 5.088186068391765],
            [-2.315699692329116, 5.086288148775743],
            [-2.309990557343857, 5.080502789882374],
            [-2.3126412567011236, 5.078050964954937],
            [-2.319417274922152, 5.078816945472425],
            [-2.3239216773356706, 5.075663782461174],
            [-2.3179967817674436, 5.072065428914503],
            [-2.3166284383351985, 5.065952682472573],
            [-2.320378556747328, 5.060232434917805],
            [-2.3239156259011153, 5.058060067625746],
            [-2.332778787589331, 5.064850486107843],
            [-2.3362480202362588, 5.066017150109526],
            [-2.3332897400419217, 5.071099912003531],
            [-2.3334415271480973, 5.074756494319816],
            [-2.337123868571643, 5.079226793866507],
            [-2.3384738763452253, 5.086450302965909],
            [-2.3417342540630477, 5.088897173648481],
            [-2.345331777258364, 5.088300460838949],
            [-2.3618701494886665, 5.075659481715782],
            [-2.3654302366643174, 5.07553578768352],
            [-2.3662092750997035, 5.080686086636508],
            [-2.368746122187476, 5.085060821190387],
            [-2.3826636653782427, 5.087940322430688],
            [-2.3832028189176815, 5.082558223920085],
            [-2.3880824370009863, 5.078588721524584],
            [-2.3940871168032043, 5.083441058694333],
            [-2.3974334907782686, 5.082636325578249],
            [-2.398308370545061, 5.079376776443487],
            [-2.402098625382976, 5.077688643316644],
            [-2.404660397416451, 5.084433775276602],
            [-2.4081703532719043, 5.089064962582855],
            [-2.4134775702584434, 5.0930287191987444],
            [-2.4155226574497624, 5.084910605304786],
            [-2.419472011932359, 5.083452403837814],
            [-2.422752447531958, 5.088037710472317],
            [-2.4202428693509708, 5.093426817498541],
            [-2.4205589709656112, 5.098108630701666],
            [-2.4242265145225996, 5.09935616145844],
            [-2.4368362301670814, 5.089843948133736],
            [-2.43898673182919, 5.0937064356341235],
            [-2.444159530218101, 5.096823904635139],
            [-2.4487103559089034, 5.095607193845822],
            [-2.4483761129931714, 5.086962483082427],
            [-2.4513984656089365, 5.084855011915962],
            [-2.455909875154966, 5.085806715428787],
            [-2.462914677071575, 5.084625194243988],
            [-2.4654015174368777, 5.08551525994334],
            [-2.4728531337660478, 5.084724277046126],
            [-2.4755535172292196, 5.07951209312311],
            [-2.4783055233146123, 5.078970145074947],
            [-2.481932324807901, 5.08253204927692],
            [-2.491291673121655, 5.08871368602155],
            [-2.495098789888655, 5.080352827500873],
            [-2.498438731953981, 5.080084346955531],
            [-2.5013938088589094, 5.083077636466897],
            [-2.503539606480753, 5.091339768164008],
            [-2.5102003715053396, 5.098363496287739],
            [-2.5160196935459123, 5.099642204599113],
            [-2.518315529481642, 5.09591916715462],
            [-2.514887041921031, 5.0922628633812],
            [-2.5161644958608673, 5.089945307817492],
            [-2.5202035165153123, 5.091822960291381],
            [-2.525710245518656, 5.097572561938906],
            [-2.5370441034300004, 5.102311537313561],
            [-2.546148586459754, 5.103291004558166],
            [-2.555412399368478, 5.1024614179088035],
            [-2.558182245404764, 5.098644354381228],
            [-2.5596324245560673, 5.092307004781291],
            [-2.5658777706710856, 5.08112529489987],
            [-2.5749877790450153, 5.091475203225288],
            [-2.5765007898782817, 5.095438292502615],
            [-2.5762883087000907, 5.10427922397265],
            [-2.5753790958263414, 5.107004435980651],
            [-2.5769453806785285, 5.112651782023932],
            [-2.5803801281458596, 5.112128248561142],
            [-2.596183234779144, 5.1021326257536845],
            [-2.5991056106926567, 5.1033083479987],
            [-2.600669405144268, 5.107642623523219],
            [-2.60555330029562, 5.108549790606253],
            [-2.610511589957029, 5.104361102362176],
            [-2.612693903900675, 5.099392314265393],
            [-2.6165151366614356, 5.096657899423602],
            [-2.6240924130136776, 5.098939991813489],
            [-2.6280594643844584, 5.106383126411437],
            [-2.6308687937616577, 5.120664801041339],
            [-2.633415583108174, 5.1239707009821505],
            [-2.636465403058574, 5.123803080076786],
            [-2.644638692213002, 5.118919330610377],
            [-2.6522486541308874, 5.117128822299811],
            [-2.6579819492516084, 5.118705136387318],
            [-2.6523257835713867, 5.248702570577527],
            [-2.6715443471938447, 5.249496593058257],
            [-2.6680148804396593, 5.336476390114441],
            [-2.665217906043041, 5.397399765582974],
            [-2.659338160839935, 5.526110796290756],
            [-2.659463795633584, 5.527034340593211],
            [-2.6574543988809385, 5.570637820707096],
            [-2.656288159022503, 5.596499903686352],
            [-2.57018803998687, 5.592673125958507],
            [-2.44113471631752, 5.5872407339347845],
            [-2.3553101359258464, 5.583750441454275],
            [-2.349943695750672, 5.583743651092494]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.84738697392379, "lat": 43.89584504439961 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46085"],
        "coty_name": ["Lyman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lyman County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01265789"
      },
      "bbox": [
        -2.6715443471938447, 4.871446556151405, -1.9040966009658504,
        5.598202417529082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.6891434623634005, -2.3503597958232922],
            [6.695278977299869, -2.346178919808089],
            [6.698180292093433, -2.3395089290841513],
            [6.702681965560869, -2.3371180541916248],
            [6.705746639444025, -2.330416978094454],
            [6.70515262614241, -2.3284308780402183],
            [6.708485682595699, -2.3225392964134826],
            [6.711671053057545, -2.3236977187557755],
            [6.715630501244287, -2.3204722203107933],
            [6.714757732530203, -2.3109518596798124],
            [6.721527636567929, -2.3049075983280307],
            [6.717026938288717, -2.300343513804708],
            [6.718213613084966, -2.296659178383335],
            [6.726219082613578, -2.289303991495712],
            [6.728945049166168, -2.2823165187996075],
            [6.7377008486310475, -2.2690724895780554],
            [6.739954884536038, -2.2667190752280972],
            [6.742040954898293, -2.2556829049729554],
            [6.7421395318833985, -2.2464234372765413],
            [6.7477039846567, -2.2456422967654146],
            [6.7521744749750106, -2.242449671948131],
            [6.7517185119474865, -2.2403702276908213],
            [6.759611825667281, -2.2403451913993977],
            [6.761289567696087, -2.2347393666857545],
            [6.764521226027434, -2.2313017064036305],
            [6.767841931574844, -2.2308887761002274],
            [6.769801464195798, -2.2193554065829213],
            [6.765614470788837, -2.2112151260873882],
            [6.767316762931618, -2.208209069772357],
            [6.770552043717795, -2.2097635748238424],
            [6.773929852140769, -2.2076926856384307],
            [6.778043646539329, -2.208427708892489],
            [6.780938389758534, -2.2042813379267185],
            [6.78079168783994, -2.2012783246126197],
            [6.776639132465739, -2.1924057973939988],
            [6.7739036877791, -2.1904576677917587],
            [6.773440296096951, -2.184800751187007],
            [6.771396534533392, -2.180880840186455],
            [6.771905380608207, -2.17327634812907],
            [6.769448204165835, -2.1689019250948856],
            [6.771263970813535, -2.165370866849586],
            [6.767079892799919, -2.1628043348800414],
            [6.763742913349466, -2.153338708490106],
            [6.760826467446644, -2.151496324474902],
            [6.762297932354909, -2.1383809679115156],
            [6.759920891978985, -2.1353356594976525],
            [6.764272140949067, -2.1322636116940967],
            [6.762675563129891, -2.124527405577127],
            [6.766627961243651, -2.1212717188601355],
            [6.763899665080408, -2.116249479530879],
            [6.764186925236811, -2.111909265303297],
            [6.761170964603459, -2.106053489086539],
            [6.763856573549616, -2.1013190860316464],
            [6.768699625020278, -2.1020167549510425],
            [6.812944339157218, -2.0976603501407953],
            [6.844809918352333, -2.0958108095610037],
            [6.845534693654096, -2.094591481422212],
            [6.851576105691628, -2.0973927643306496],
            [6.85420777042711, -2.100769374588781],
            [6.863458087656035, -2.1148567693990126],
            [6.866039118702583, -2.1261650793804705],
            [6.8719166029073895, -2.1302806767513083],
            [6.8775056703564434, -2.140389152979495],
            [6.886323382883698, -2.166891377169094],
            [6.89079759911946, -2.187899838184085],
            [6.889264560610768, -2.205215691710964],
            [6.888367647543078, -2.2093814061948827],
            [6.88774817152123, -2.2233475733320587],
            [6.888520691416442, -2.230458930880195],
            [6.891151592011233, -2.2358486567585327],
            [6.8982616470431095, -2.2453786609457698],
            [6.90026865707179, -2.2544752133409443],
            [6.906316251218762, -2.267923947097779],
            [6.914274361135871, -2.2747992188458177],
            [6.918056314346452, -2.279090959937865],
            [6.922462392085829, -2.289901650917551],
            [6.922093444922177, -2.3038791672684793],
            [6.9223929305482645, -2.3209827647000987],
            [6.920314351002183, -2.328968559860062],
            [6.909111089963076, -2.3435628898959515],
            [6.9080943791759815, -2.3501946216729204],
            [6.905968131616036, -2.3549782497549474],
            [6.900221547085543, -2.364145623291338],
            [6.895332597946307, -2.3765420357358935],
            [6.892170913024981, -2.3819774366954225],
            [6.881341109670465, -2.3963447107210243],
            [6.873581554589119, -2.409487321628984],
            [6.870836497061865, -2.417920112953121],
            [6.866063290221883, -2.4282449894377556],
            [6.865604846628041, -2.433825097793379],
            [6.867790770310215, -2.442444786897976],
            [6.869226367731635, -2.4544052466768247],
            [6.867872903291523, -2.4618122371701476],
            [6.865929438138788, -2.465312263580822],
            [6.858609366343285, -2.471622520274639],
            [6.854259170530683, -2.478634458405895],
            [6.853378507702282, -2.4893027448436547],
            [6.855378938570607, -2.4975461357262536],
            [6.8630676407798274, -2.5116075916535143],
            [6.873872222421042, -2.5165905691389745],
            [6.879004439780445, -2.517570340770334],
            [6.894852039661874, -2.518473115815371],
            [6.900965063327067, -2.51769082169336],
            [6.917046766195836, -2.514128031480363],
            [6.928610884887125, -2.5129282525062684],
            [6.932960050417677, -2.5169035213141986],
            [6.934072311746392, -2.5220080514188283],
            [6.934200421973787, -2.541539675161696],
            [6.933831476528386, -2.5476452805073233],
            [6.931570609464375, -2.56045324169244],
            [6.929926187239947, -2.5783859197245143],
            [6.9279923611239305, -2.587734303466468],
            [6.922289059486942, -2.599804278904613],
            [6.9121986658153975, -2.6144334882360205],
            [6.909352646204286, -2.6209127539232826],
            [6.908228573384882, -2.627005348835812],
            [6.907944196958332, -2.640304988524481],
            [6.896896244040493, -2.6399700950525404],
            [6.892579155715365, -2.641099363888249],
            [6.887861219395024, -2.6464565485769644],
            [6.882625095589856, -2.6445477974151115],
            [6.881565027417002, -2.641848966641169],
            [6.875360433677309, -2.643002680994798],
            [6.871022616712864, -2.6480707733669493],
            [6.862334377514479, -2.648887935383157],
            [6.862017499707732, -2.63014041649643],
            [6.8599928622055115, -2.6271682424537977],
            [6.859780379359931, -2.622650786920318],
            [6.855284635887661, -2.6164604492680046],
            [6.848109432950811, -2.6179434702982887],
            [6.840170782152036, -2.6113387763346343],
            [6.832383714440201, -2.6116323039035576],
            [6.832395432702994, -2.616984992525902],
            [6.822010710816267, -2.617854745249612],
            [6.821185516164742, -2.620535674754338],
            [6.816304550373051, -2.623917133353299],
            [6.814809221753389, -2.6208299392463186],
            [6.811328736741369, -2.6212839847495233],
            [6.77148792540773, -2.6217960144608163],
            [6.7520627525643215, -2.623426620877695],
            [6.739591342929428, -2.6238756773771894],
            [6.707847986538715, -2.62573515542584],
            [6.70584874857664, -2.5949766546273603],
            [6.699230154838037, -2.5954785646757528],
            [6.6987277644853265, -2.5862164967420362],
            [6.705252613514124, -2.5859265830172267],
            [6.699000072818472, -2.488710739656768],
            [6.6891434623634005, -2.3503597958232922]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.06829488234558, "lat": 36.06974061360214 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47005"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01639724"
      },
      "bbox": [
        6.6891434623634005, -2.648887935383157, 6.934200421973787,
        -2.094591481422212
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.320138618851797, -2.916200452360556],
            [8.32572083980987, -2.914891407187051],
            [8.325160325455599, -2.9019776693071395],
            [8.325164566524865, -2.8784900812091996],
            [8.332318281072116, -2.8784042990406222],
            [8.332511198970057, -2.871819310456936],
            [8.326039710272301, -2.868661322091424],
            [8.323264902217455, -2.861081909308879],
            [8.323472569245624, -2.8229677086116336],
            [8.327283331378368, -2.820893757476676],
            [8.32124854601678, -2.8093722220965187],
            [8.319301269229193, -2.793024740146679],
            [8.31574014834828, -2.7519376499803503],
            [8.311063715552846, -2.720531647687172],
            [8.309550351977, -2.715281827642668],
            [8.309200449804742, -2.7066496445411525],
            [8.306481865295407, -2.7028175974918436],
            [8.310749083635823, -2.699851510465267],
            [8.307439152412602, -2.695199816322585],
            [8.309953242412684, -2.690354083923259],
            [8.306586675064851, -2.6845844405009403],
            [8.305894957792182, -2.6782922453882803],
            [8.308205016944184, -2.668704905049724],
            [8.304759164357687, -2.665196828858884],
            [8.302060911863592, -2.664855283689599],
            [8.301673846213953, -2.6607547552459696],
            [8.306457858101194, -2.658264284042902],
            [8.305302730937397, -2.6526204395954585],
            [8.30218450955055, -2.6472910180499674],
            [8.300583860706016, -2.6416787031277376],
            [8.301354798567104, -2.638082104246992],
            [8.3045975935225, -2.6358828297995442],
            [8.310585857997832, -2.634838575792032],
            [8.314961810701956, -2.6277663329710714],
            [8.318573445309111, -2.618544070740977],
            [8.324065124284912, -2.623545056051322],
            [8.330440973804007, -2.6199935035581143],
            [8.336480652462948, -2.621417508243511],
            [8.337912860342751, -2.6197716202922825],
            [8.342883784757904, -2.620655010857609],
            [8.345017967535636, -2.6299704288830386],
            [8.349608160639805, -2.6307874420243897],
            [8.356271270171677, -2.634351651639122],
            [8.357842775246034, -2.6369463128191417],
            [8.362105028669557, -2.6369838474945495],
            [8.365834718780768, -2.638873190663437],
            [8.36629779459519, -2.6435770692170353],
            [8.371339335275039, -2.643624496536014],
            [8.379049067415133, -2.6481848907099192],
            [8.37917283457692, -2.652258140911305],
            [8.385873002779565, -2.6569521767971582],
            [8.393417075067282, -2.6560438209466475],
            [8.404473043745988, -2.655748797426348],
            [8.431079031490963, -2.6672674222235133],
            [8.446310011469116, -2.666668784742358],
            [8.459926745849877, -2.6671182476912585],
            [8.45996112701773, -2.6630018522092676],
            [8.4670809703665, -2.6629902340161458],
            [8.472325712637302, -2.6668176231321445],
            [8.47591193500516, -2.663515644077112],
            [8.475997795275179, -2.658182547749058],
            [8.48977462001297, -2.6584628074358143],
            [8.491192224355412, -2.653558882139065],
            [8.494630844395635, -2.6500757499713887],
            [8.500400734183987, -2.654104463979108],
            [8.505976660635984, -2.6524042381435127],
            [8.505464273677147, -2.64563890367434],
            [8.512826782980698, -2.6452110957922597],
            [8.514617195031802, -2.655184246038235],
            [8.519370287298006, -2.653957162835327],
            [8.529541636363176, -2.6722610953539156],
            [8.529056131641568, -2.67833818137485],
            [8.533435019823845, -2.678968349967171],
            [8.532950288754432, -2.683279706888405],
            [8.538590163000922, -2.6840629534621705],
            [8.539882879847632, -2.688676613292929],
            [8.542892336210326, -2.692623836635114],
            [8.546103875292776, -2.6926057387185116],
            [8.546181034603778, -2.7031781205702288],
            [8.544414457237727, -2.7086641759964833],
            [8.543985380728301, -2.7168189241664935],
            [8.552512566458535, -2.7173734328103167],
            [8.551582576280262, -2.7289705168626863],
            [8.559580844992452, -2.729248019213603],
            [8.56085495623349, -2.7347165455720246],
            [8.563743899399764, -2.7382237080366654],
            [8.570559508184958, -2.741232517214646],
            [8.578307570373935, -2.747079794101984],
            [8.584573039584303, -2.7450925119305194],
            [8.589282518243413, -2.747270861361064],
            [8.590002011214116, -2.757445049600272],
            [8.60793391529059, -2.757843089962449],
            [8.610300680640561, -2.7612544013856732],
            [8.6067586732654, -2.7638490487169984],
            [8.610756465719941, -2.7696454315480294],
            [8.613970187334361, -2.77232565023461],
            [8.612570743538562, -2.772688935742671],
            [8.61009931257209, -2.7805034412696825],
            [8.614018383382078, -2.7821597289488262],
            [8.611192299500901, -2.7858738907456444],
            [8.616353082726446, -2.7890535976593283],
            [8.615378318239651, -2.804943734980038],
            [8.61076301111989, -2.807744985403142],
            [8.612190638426615, -2.829450607191873],
            [8.612038411567669, -2.838443692006732],
            [8.612726947715915, -2.8536776012889113],
            [8.621991167016057, -2.904344591492689],
            [8.621208140224036, -2.916019207129291],
            [8.624235544268744, -2.9168006993480624],
            [8.635392533914725, -2.915624540249828],
            [8.632314194600617, -2.9286316654864017],
            [8.628693690561267, -2.9364039123957433],
            [8.629462760080877, -2.948308539098061],
            [8.612293818938712, -2.968751380974655],
            [8.614833452213338, -2.97187913170848],
            [8.61690135911931, -2.9810975500140255],
            [8.613134367250757, -2.9816760019661466],
            [8.613022682288554, -2.9928608457749615],
            [8.611355774506336, -2.998929592959377],
            [8.614182393061935, -3.00212502355633],
            [8.60969224828964, -3.0108150822443807],
            [8.604427345636102, -3.008622396195781],
            [8.599735449025717, -3.0108270893391134],
            [8.595462742936043, -3.0087330371374095],
            [8.591986582683584, -3.0019588582404158],
            [8.587513514047753, -3.0020962265094706],
            [8.584826459407767, -3.003956612891358],
            [8.580155678226737, -3.003543140189811],
            [8.582272115923445, -2.999261385832804],
            [8.581002249770842, -2.994854371432923],
            [8.57304740213821, -2.995445119786326],
            [8.57071542411907, -2.9987647327511766],
            [8.567649452528203, -2.989423596448937],
            [8.565107237087346, -2.994073199183983],
            [8.556911467122998, -2.9930942378563823],
            [8.553226004384268, -2.9874145119513136],
            [8.549217300439393, -2.98916006430928],
            [8.545461778862327, -2.99339101364111],
            [8.543529169979774, -2.991523329544061],
            [8.53595280556184, -2.992800724398282],
            [8.53383915566901, -2.9883251073868844],
            [8.516331549563814, -2.9749429472742497],
            [8.50837130828694, -2.97496049196928],
            [8.51263482682005, -2.9657190249879894],
            [8.504998978416346, -2.9666220397643204],
            [8.447456542253743, -2.9614329037524447],
            [8.405349463495874, -2.9579144825848647],
            [8.404506840948134, -2.969180470408918],
            [8.394913773502052, -2.9690843362333026],
            [8.394640729449886, -2.9641180329191146],
            [8.378250786889877, -2.9790783402007017],
            [8.38266201006978, -2.984200896951467],
            [8.376558003748508, -2.9903996794429326],
            [8.374532295516595, -2.986557704932177],
            [8.368059468254625, -2.9868536187936217],
            [8.366443035462034, -2.982460752674843],
            [8.363966613475396, -2.9815850503827472],
            [8.361252603068268, -2.977147345747333],
            [8.357620577304695, -2.978794130453855],
            [8.351056566645623, -2.978851970561608],
            [8.350998535050593, -2.98301049653999],
            [8.347526474752874, -2.9855963463684816],
            [8.341713468070482, -2.985775507429107],
            [8.341363488917468, -2.982872385467478],
            [8.333105704000214, -2.9835708662539133],
            [8.333426311001247, -2.991420387088577],
            [8.32554795804156, -2.9916039632734597],
            [8.325146811414578, -2.995594922485166],
            [8.320701458406814, -2.9910026728761356],
            [8.336670760538304, -2.980434280613995],
            [8.336656130241847, -2.97162436709867],
            [8.325041022375055, -2.970897019395166],
            [8.321430923570528, -2.963467144931911],
            [8.312513801129741, -2.963673279439833],
            [8.312563339543463, -2.9594144295240423],
            [8.324512486438808, -2.9578840047387196],
            [8.323782284442032, -2.9480342759850826],
            [8.326596709823686, -2.9480752742008645],
            [8.326364656779534, -2.943087548726024],
            [8.304783795449517, -2.943121828698848],
            [8.313869533443944, -2.9315288247268687],
            [8.318877777488986, -2.931205091434919],
            [8.31835338580136, -2.924644903416724],
            [8.325819472562863, -2.9246972182667292],
            [8.325384365875971, -2.919143704983092],
            [8.3198724472856, -2.919640220092257],
            [8.320138618851797, -2.916200452360556]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.07473659683042,
          "lat": 35.490664238665346
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47031"],
        "coty_name": ["Coffee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coffee County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01639735"
      },
      "bbox": [
        8.300583860706016, -3.0108270893391134, 8.635392533914725,
        -2.618544070740977
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.610151186326698, -1.7542393855829812],
            [10.613820248577573, -1.7545590343155815],
            [10.62244977501151, -1.7587904744522134],
            [10.627835975211783, -1.7592849047482544],
            [10.629646291831104, -1.7559860216071346],
            [10.628646506513574, -1.7528590285521575],
            [10.623057726038537, -1.7507671528917421],
            [10.623333563456141, -1.7462501935190426],
            [10.627720087724184, -1.744130557847499],
            [10.633724854938244, -1.744439072822083],
            [10.638440024484426, -1.7459396777715248],
            [10.642308760334133, -1.7429728295995246],
            [10.642312531696886, -1.7364560873052977],
            [10.64379148890059, -1.733099641500306],
            [10.65124838609931, -1.7304600327246062],
            [10.653728064617516, -1.7267641228552069],
            [10.652697749753928, -1.7227300987074847],
            [10.648596087217236, -1.7192128309550072],
            [10.649464152175248, -1.7149206465427071],
            [10.65203581284219, -1.7148777698822468],
            [10.665983147785843, -1.7232701069710343],
            [10.6703809504114, -1.7212479338764013],
            [10.67007504574641, -1.7172165039168084],
            [10.664765678209328, -1.71192925744967],
            [10.661366902709428, -1.6993577915358378],
            [10.663669599269976, -1.6939623397959347],
            [10.66748451825015, -1.6957785497503592],
            [10.673994469362267, -1.6915344825609888],
            [10.6758668713793, -1.6881235007203896],
            [10.6828371780541, -1.6902302136562952],
            [10.679817982914226, -1.6934917400382667],
            [10.679688174834839, -1.7002300263505543],
            [10.689971884248422, -1.7089131747700015],
            [10.688172528228671, -1.7140465845606092],
            [10.694239798780371, -1.7237077081415524],
            [10.695225520865993, -1.7226571821620504],
            [10.704785084493965, -1.734093907617659],
            [10.71126137735234, -1.7392117113239844],
            [10.716365675021237, -1.7399367856687165],
            [10.716693581693871, -1.7446037146980289],
            [10.722523365815336, -1.744138966044244],
            [10.726450647010685, -1.7452825483193464],
            [10.726453091787562, -1.7503187141213714],
            [10.731080055795498, -1.7508575148334067],
            [10.733679546290931, -1.7534650090612012],
            [10.733896599189663, -1.76094329927136],
            [10.742570011141309, -1.7725357527273504],
            [10.75239588140321, -1.7782989850420374],
            [10.753422315405025, -1.7824355519183854],
            [10.74772556027025, -1.787796310338835],
            [10.74591487331258, -1.793606477508582],
            [10.742061460349076, -1.796246550436977],
            [10.732894674745534, -1.807168595519247],
            [10.730123706173845, -1.8127536158834707],
            [10.724927274069415, -1.8264204752066802],
            [10.720505761217025, -1.8254842024541944],
            [10.719915217625529, -1.8304865060696465],
            [10.716188460038191, -1.833335617652925],
            [10.715432057504609, -1.8419931495498518],
            [10.70791010734514, -1.8478005334020118],
            [10.704869512175762, -1.847398356454448],
            [10.698641107462658, -1.849670041229421],
            [10.695443312874417, -1.8528542577839182],
            [10.692003408612981, -1.8518949152065256],
            [10.689725824920716, -1.8541384301677182],
            [10.680139244077694, -1.8596128984382305],
            [10.679872215195953, -1.8665719453722107],
            [10.685409867660839, -1.8734565782004649],
            [10.68900642164188, -1.8821150099730253],
            [10.692439655398816, -1.896082153088252],
            [10.695364029475563, -1.9030885668377104],
            [10.695467262940253, -1.9078257292750658],
            [10.692372211867593, -1.909987455779295],
            [10.687761807647998, -1.9103988817289708],
            [10.679358375965384, -1.9079767518541533],
            [10.6719116653535, -1.8989110934855127],
            [10.666822798107788, -1.895855704300495],
            [10.659098462966105, -1.8890315549490153],
            [10.655265922956405, -1.8887363863343045],
            [10.653143302950536, -1.8909595110110162],
            [10.653916014449655, -1.8966585720250753],
            [10.659127066098035, -1.9047076972701864],
            [10.660194818273203, -1.9119934871189728],
            [10.656314026856545, -1.9185240314637884],
            [10.641944453747085, -1.9155785731720119],
            [10.639772086145094, -1.9186201170538613],
            [10.642193881451696, -1.9239936775917892],
            [10.650981725935662, -1.935225955065426],
            [10.653537936603401, -1.940988221685343],
            [10.659216700302885, -1.947746474021154],
            [10.661030323191087, -1.9515791467213819],
            [10.661642567899447, -1.9572984856505562],
            [10.659481684799134, -1.9590582951958884],
            [10.65411026968777, -1.9559759070036824],
            [10.649405651355698, -1.9486715485892268],
            [10.646062988057212, -1.9406741880102458],
            [10.633520107214032, -1.926450303064792],
            [10.62986351778386, -1.923076239557491],
            [10.616279613241918, -1.914559170781952],
            [10.600067164438, -1.90920879347629],
            [10.569964275244471, -1.9057843602650208],
            [10.569101150373148, -1.907665945926948],
            [10.53509063448713, -1.9020382737412591],
            [10.522986813900497, -1.903859557170435],
            [10.531494909751268, -1.90954197641184],
            [10.52686806992253, -1.9099559990445993],
            [10.525989127937471, -1.9148566388672672],
            [10.521899742529701, -1.912043651335038],
            [10.521108747339685, -1.905974569914146],
            [10.518331916968247, -1.902851003484295],
            [10.506868067588474, -1.9054880667796557],
            [10.466934926925168, -1.9095869525477946],
            [10.457697718391033, -1.8910706016373915],
            [10.458303253791872, -1.8871232514168503],
            [10.455009388186198, -1.8805380660113693],
            [10.456764339866078, -1.876743612396295],
            [10.46130920025991, -1.8769540537950256],
            [10.469894328085278, -1.873575939056212],
            [10.470523474625915, -1.8673862299233086],
            [10.466515662402527, -1.8608961432563478],
            [10.465489690635549, -1.8507534681719493],
            [10.465895125355706, -1.8459163724074286],
            [10.469773634099626, -1.8411269097504412],
            [10.473723596769714, -1.8417217082742474],
            [10.475131808739443, -1.8504906800118304],
            [10.47909601844868, -1.852406425886777],
            [10.48490507094277, -1.8500056784833228],
            [10.492172856797584, -1.8409983513248485],
            [10.49120368945859, -1.8373615907242278],
            [10.486097068774548, -1.8292882945684557],
            [10.486910129931504, -1.8244983111283226],
            [10.493481237916887, -1.810901011084159],
            [10.5027140807064, -1.8051922896597157],
            [10.505580572776344, -1.7976851480304792],
            [10.508635228714242, -1.7927990996768046],
            [10.511259415159465, -1.7913292798598854],
            [10.525972872439747, -1.7892613952742287],
            [10.528344655387668, -1.7871121278799345],
            [10.525558156671766, -1.778934207449567],
            [10.526264958826145, -1.7757859856321445],
            [10.531957186455143, -1.7713602586216646],
            [10.541120393226969, -1.7735949553151233],
            [10.543613144714067, -1.7729557831935725],
            [10.548932728084553, -1.7675605652096298],
            [10.548963628413999, -1.7575803071131422],
            [10.550890643366573, -1.755022400192889],
            [10.556334065434887, -1.7554723599399653],
            [10.56005482272936, -1.759758833364818],
            [10.559677663125603, -1.7665322315985457],
            [10.562318501025894, -1.77116707748045],
            [10.566746336239783, -1.7729121920204596],
            [10.569193631443987, -1.7791008212306634],
            [10.573568303925057, -1.780445544266219],
            [10.57733285825297, -1.771889483804305],
            [10.580322918746056, -1.769550364371742],
            [10.583233981928384, -1.7713976437709018],
            [10.584460399206188, -1.7751032488818812],
            [10.583988343372058, -1.780566254646126],
            [10.586113092727773, -1.7843526057461538],
            [10.593884169871426, -1.783403977971723],
            [10.595236896558452, -1.7814912870227921],
            [10.593380298528139, -1.7701447589481831],
            [10.598671256846224, -1.7711580639822293],
            [10.602823112684133, -1.7702904065807177],
            [10.603723225004801, -1.7674214076760413],
            [10.601203585399615, -1.7595226954505556],
            [10.603906693709504, -1.7556970620051557],
            [10.610151186326698, -1.7542393855829812]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.26670377770776, "lat": 36.21708217599507 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47063"],
        "coty_name": ["Hamblen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamblen County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01648576"
      },
      "bbox": [
        10.455009388186198, -1.9590582951958884, 10.753422315405025,
        -1.6881235007203896
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.278869604964729, -5.638833557392039],
            [-4.167507414570565, -5.646214889459809],
            [-4.071736770522322, -5.650814348950694],
            [-3.9596907453298766, -5.656225732675821],
            [-3.8476442124316392, -5.661623467921],
            [-3.8482452444704944, -5.668101278213729],
            [-3.8527392532556997, -5.7496645858873245],
            [-3.8668854500396814, -5.997002047715507],
            [-3.872491396175542, -6.0971067401444845],
            [-3.8726954444986643, -6.100691809984875],
            [-3.9348819477630204, -6.09742990762853],
            [-3.936180535964144, -6.097240341128693],
            [-4.0404437864109015, -6.091100678098827],
            [-4.159675775793183, -6.083824735719875],
            [-4.238727311643742, -6.079141027405304],
            [-4.30302532172462, -6.075099107972644],
            [-4.297103775162499, -5.96929860083344],
            [-4.290585536152582, -5.848868245248189],
            [-4.286480963497763, -5.772410291062276],
            [-4.278869604964729, -5.638833557392039]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.43171678527348,
          "lat": 32.74364028232868
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48033"],
        "coty_name": ["Borden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Borden County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01383802"
      },
      "bbox": [
        -4.30302532172462, -6.100691809984875, -3.8476442124316392,
        -5.638833557392039
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8322044343130117, -8.949675895597904],
            [-1.7453444072030275, -8.873440569619198],
            [-1.6897928033095362, -8.824046933011827],
            [-1.6259707110354686, -8.764811448862234],
            [-1.546992947998606, -8.69090700851435],
            [-1.522782520956866, -8.667928046571445],
            [-1.486264892148647, -8.698846142314476],
            [-1.437138346509968, -8.74088491315109],
            [-1.3731484679542223, -8.795226809722763],
            [-1.330850422773328, -8.83088754485948],
            [-1.295954256797854, -8.860504056995607],
            [-1.2708971996949678, -8.956048314209184],
            [-1.2820945324274189, -8.964865065085423],
            [-1.313804669083138, -8.991145661575906],
            [-1.3510703429234359, -9.022510736953539],
            [-1.376924254116823, -9.034574883194418],
            [-1.44955870340697, -9.067041520654765],
            [-1.4811513385426502, -9.07929745526124],
            [-1.5074552429591543, -9.090066191670111],
            [-1.518415127072122, -9.095102608100087],
            [-1.5450940437990932, -9.106018897619931],
            [-1.5460403439711379, -9.098755754361957],
            [-1.5522110331786148, -9.098420546145759],
            [-1.5575174100367126, -9.096929134765421],
            [-1.5594943991506676, -9.094462838002094],
            [-1.5600314857784667, -9.089897292832251],
            [-1.565886595228838, -9.088891914132443],
            [-1.569195481087093, -9.087034155755054],
            [-1.57454081721612, -9.080046249554538],
            [-1.572042790444008, -9.078220942219101],
            [-1.5702942926778687, -9.072739292405705],
            [-1.5705249078661319, -9.068324884093451],
            [-1.5739463420869615, -9.062313936294697],
            [-1.5757127326984188, -9.05530549411943],
            [-1.5719216958872884, -9.049526215454609],
            [-1.5733047746966378, -9.045475523389145],
            [-1.583221245650443, -9.041685563086526],
            [-1.586681723602974, -9.035100097863936],
            [-1.5892163078808577, -9.033549551220608],
            [-1.6009113003896795, -9.037218408385602],
            [-1.602459283823976, -9.036961747182437],
            [-1.6045594885006667, -9.025904331216665],
            [-1.6065884008359905, -9.02140072865191],
            [-1.600780856216867, -9.017561441941023],
            [-1.599900559009757, -9.011237916217265],
            [-1.6032921666029072, -9.003996108332618],
            [-1.6028171233373705, -8.996909948655677],
            [-1.5980411225688331, -8.994156531660193],
            [-1.5947824271260331, -8.995590110739045],
            [-1.5869929473461994, -8.994822941451702],
            [-1.5803013935953305, -8.99706864880113],
            [-1.571653223604989, -8.993943848123042],
            [-1.5686958540910791, -8.991632696224734],
            [-1.5660260625729572, -8.979701274800474],
            [-1.5754447659644948, -8.97330032154003],
            [-1.5806459635799046, -8.96719917971832],
            [-1.5838640881062644, -8.972097791129809],
            [-1.5931359698093248, -8.980118316662548],
            [-1.5978242187074674, -8.980712458927812],
            [-1.596189264037038, -8.97477511166639],
            [-1.5962737371509887, -8.97025330793942],
            [-1.6053776086251568, -8.965533053736984],
            [-1.6087992020042294, -8.966632519777663],
            [-1.6110866020291534, -8.964067612787982],
            [-1.6181596632585356, -8.962279081282224],
            [-1.6175786119849012, -8.956968791470407],
            [-1.6219608623088893, -8.95141880195825],
            [-1.6319736363923285, -8.953349986963154],
            [-1.6366752535410583, -8.956458793466682],
            [-1.6377330427987749, -8.961187538480772],
            [-1.635257755001026, -8.970374664380156],
            [-1.6416383491767743, -8.972659752056703],
            [-1.645288650476616, -8.976254980035902],
            [-1.6427669243464418, -8.980712732423047],
            [-1.6462805141617551, -8.983674623056883],
            [-1.652721116227971, -8.983637171381485],
            [-1.6573974782031426, -8.979541632837858],
            [-1.657884543781692, -8.973104594899356],
            [-1.6560564562168154, -8.967084042345967],
            [-1.6606254787523156, -8.963477094026812],
            [-1.6646447528677946, -8.966355401826613],
            [-1.6689272272642524, -8.967470009351159],
            [-1.6728966458399983, -8.965449611498858],
            [-1.6752340992312935, -8.960832164563575],
            [-1.6782875605643206, -8.961004981216032],
            [-1.6857945297600088, -8.965186714772008],
            [-1.6881696312147592, -8.963500219353188],
            [-1.696814376104223, -8.963019880136788],
            [-1.7029842380986562, -8.959745726468192],
            [-1.7090677456511738, -8.959435341091368],
            [-1.7139905038932424, -8.956721694847525],
            [-1.725722787452562, -8.952476835104042],
            [-1.7300259190603953, -8.953928944875662],
            [-1.7348636432411373, -8.95070603512258],
            [-1.7347638385387092, -8.945208413006105],
            [-1.7431881856648508, -8.94528366956783],
            [-1.746724264413777, -8.942877415726288],
            [-1.7457918946542916, -8.940024830108191],
            [-1.748828773223546, -8.936570677029996],
            [-1.752794496987174, -8.938522083721066],
            [-1.7529894283926823, -8.941856947301892],
            [-1.7567226869455455, -8.945488239538589],
            [-1.763245741449209, -8.94487938170774],
            [-1.7648460671835318, -8.948389185989315],
            [-1.7705647808880436, -8.946583123671344],
            [-1.773958430231952, -8.952823978129016],
            [-1.7774266669911725, -8.955163129890723],
            [-1.780716007019111, -8.953775590653208],
            [-1.7821468642172509, -8.94865114075728],
            [-1.7862066761947106, -8.9504361925728],
            [-1.7924152364359842, -8.946016043538448],
            [-1.7962483903878792, -8.94860664652691],
            [-1.7933218245282225, -8.951040001549877],
            [-1.7952710653430421, -8.955872480383196],
            [-1.8074249957582689, -8.955830369644385],
            [-1.8076941908413164, -8.951661557509881],
            [-1.8171673530588968, -8.95111153461195],
            [-1.821806137969133, -8.953539493534127],
            [-1.8301015370222342, -8.954503330643234],
            [-1.8322044343130117, -8.949675895597904]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.27824216353417,
          "lat": 29.808190571172876
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48091"],
        "coty_name": ["Comal"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Comal County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01383831"
      },
      "bbox": [
        -1.8322044343130117, -9.106018897619931, -1.2708971996949678,
        -8.667928046571445
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0016105389584857, -6.626032150227195],
            [-1.935351012798814, -6.59095250486547],
            [-1.9162368937938812, -6.581622940705546],
            [-1.8843628780255919, -6.564664556423608],
            [-1.8576017541107113, -6.550186863700562],
            [-1.8524809214078546, -6.5470647771326025],
            [-1.7754187074026904, -6.506344655911185],
            [-1.7455280868428673, -6.488584672966176],
            [-1.7114795380798342, -6.469256703352813],
            [-1.682089761442723, -6.4519515705171715],
            [-1.6721861904621782, -6.4704583469478525],
            [-1.6250707031698888, -6.555827126867988],
            [-1.5832550274661308, -6.6308943677429895],
            [-1.561037639766179, -6.669986445622835],
            [-1.5545575268800902, -6.680103692465395],
            [-1.534039377149787, -6.716754443308336],
            [-1.5321548106009852, -6.720754994411279],
            [-1.501884054100506, -6.77627822640561],
            [-1.4365445431879689, -6.739050909987607],
            [-1.4018634830838645, -6.802349637862236],
            [-1.3598238709991395, -6.878934007123438],
            [-1.4314265015986192, -6.919949066351947],
            [-1.4817917363986042, -6.9488513654717865],
            [-1.5052690848286043, -6.962503065562095],
            [-1.6094408642495162, -7.021718448785764],
            [-1.6236124732812856, -7.029870099574264],
            [-1.6471889670342266, -6.9897536105355496],
            [-1.65317705794509, -6.9899484916172385],
            [-1.671375105884964, -6.992515803185467],
            [-1.729091293947114, -6.999404840841175],
            [-1.754059383277744, -7.002699646599383],
            [-1.7598564791174718, -7.003858195659465],
            [-1.7965351001948766, -7.008757531961337],
            [-1.8232665239400494, -6.958692098092447],
            [-1.8621057787033009, -6.886645516507686],
            [-1.8888665586950426, -6.836659023620557],
            [-1.8909913671915224, -6.831860186969679],
            [-1.9513003401318008, -6.720580569444213],
            [-2.0016105389584857, -6.626032150227195]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.55822055990501,
          "lat": 31.947964705256023
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48093"],
        "coty_name": ["Comanche"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Comanche County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01383832"
      },
      "bbox": [
        -2.0016105389584857, -7.029870099574264, -1.3598238709991395,
        -6.4519515705171715
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.0940379776562335, -4.292229658435438],
            [-4.041302339472493, -4.295585277253313],
            [-4.017739144368234, -4.296856466475363],
            [-3.8567590000033656, -4.305991713804419],
            [-3.7730591138606346, -4.310586580105796],
            [-3.665806797424163, -4.316130474654799],
            [-3.6688210792994833, -4.372477996197517],
            [-3.6728888998099234, -4.451290252418974],
            [-3.6783105052090668, -4.550959043513675],
            [-3.683025026444398, -4.639872062635777],
            [-3.6847119511668427, -4.666789117948609],
            [-3.6847471767975373, -4.671690532005356],
            [-3.691119019421722, -4.796422454402304],
            [-3.863496573189116, -4.787920466070406],
            [-3.8645143902356582, -4.787674351667134],
            [-3.9336831000457098, -4.784604455655926],
            [-4.012320708460852, -4.780780436932911],
            [-4.121410943712244, -4.775667043140814],
            [-4.1169106828761866, -4.695854736012979],
            [-4.110887097258885, -4.584302677194296],
            [-4.104726080177498, -4.473990449073612],
            [-4.101424683409307, -4.4153077410424455],
            [-4.0940379776562335, -4.292229658435438]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.30324077539018,
          "lat": 34.07242061125911
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48153"],
        "coty_name": ["Floyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Floyd County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01383862"
      },
      "bbox": [
        -4.121410943712244, -4.796422454402304, -3.665806797424163,
        -4.292229658435438
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5215799595263584, -9.573499667647328],
            [-2.3811439206700835, -9.578163493800073],
            [-2.376586081517666, -9.578819983759889],
            [-2.334971131186758, -9.580417573960045],
            [-2.3269909693795694, -9.58045358039772],
            [-2.2693660078184528, -9.582779092677024],
            [-2.2653788905468892, -9.582516028973213],
            [-2.2277205104670394, -9.58378250543554],
            [-2.1208147169825375, -9.587199278386363],
            [-2.077256323624624, -9.588801914128075],
            [-2.0507930181146934, -9.58955332914469],
            [-2.0479854798353863, -9.590027339004388],
            [-1.9892459701282257, -9.591566401217099],
            [-1.991617398835521, -9.679190770022542],
            [-1.9925705820953914, -9.730105312403497],
            [-1.9946273129375423, -9.831640156876912],
            [-1.998729745110726, -10.02732027076576],
            [-2.109929168293993, -10.025108222687726],
            [-2.2211282680276634, -10.022865853813956],
            [-2.3155960471184702, -10.020777022959312],
            [-2.362454587113246, -10.019346711590089],
            [-2.4421227748093064, -10.018238432669788],
            [-2.5217910423167478, -10.017114579761966],
            [-2.533474016838489, -10.01691693907001],
            [-2.531523673240533, -9.95506219702485],
            [-2.5293364920415233, -9.841271974598007],
            [-2.5273771045436773, -9.778237463664649],
            [-2.523235177921314, -9.630859976224402],
            [-2.5215799595263584, -9.573499667647328]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.10819885913578,
          "lat": 28.867786234367596
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48163"],
        "coty_name": ["Frio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Frio County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01383867"
      },
      "bbox": [
        -2.533474016838489, -10.02732027076576, -1.9892459701282257,
        -9.573499667647328
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.1415387995135635, -5.212364795109934],
            [-4.038454565078325, -5.217466607412701],
            [-3.991248626542017, -5.219768772064196],
            [-3.9849904689677986, -5.219621251045732],
            [-3.9076391366373553, -5.223715509074596],
            [-3.814508134402137, -5.228474217284251],
            [-3.712457824601933, -5.2337432899841305],
            [-3.7174186178239306, -5.32534941546052],
            [-3.7203125051069508, -5.381564869655692],
            [-3.7259855662958805, -5.490976905368178],
            [-3.7305365939912027, -5.575326975358734],
            [-3.734778727545072, -5.656922929837333],
            [-3.7351262594378487, -5.660997943791234],
            [-3.8476442124316392, -5.661623467921],
            [-3.9596907453298766, -5.656225732675821],
            [-4.071736770522322, -5.650814348950694],
            [-4.167507414570565, -5.646214889459809],
            [-4.162241562049113, -5.554080224800484],
            [-4.155473538526939, -5.441111260612586],
            [-4.150829980559612, -5.3660610820053165],
            [-4.142718905936731, -5.233813505046556],
            [-4.1415387995135635, -5.212364795109934]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.29844358437836,
          "lat": 33.17985899990062
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48169"],
        "coty_name": ["Garza"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garza County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "01383870"
      },
      "bbox": [
        -4.167507414570565, -5.661623467921, -3.712457824601933,
        -5.212364795109934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.631700114446049, -3.0010193162052254],
            [-3.5258079046792434, -3.0064495385328502],
            [-3.462335036202228, -3.0098402155691106],
            [-3.454741023779171, -3.00963894894874],
            [-3.3907729251987417, -3.0121308583256723],
            [-3.296765144103605, -3.017364774621739],
            [-3.192559259832977, -3.0230501447460023],
            [-3.1958319062021854, -3.0904489756430253],
            [-3.196430164354604, -3.111242966026754],
            [-3.1982317592253513, -3.154799904407251],
            [-3.2007768453898064, -3.212187725360647],
            [-3.205211127576014, -3.3156558655848953],
            [-3.2058167053200144, -3.331656387571076],
            [-3.2126157387366625, -3.461910583726217],
            [-3.3127160188598728, -3.4571325297672804],
            [-3.3771496325776464, -3.4537935017555026],
            [-3.4410739076759316, -3.450573442043403],
            [-3.4848946414119903, -3.448557945064734],
            [-3.562581075886382, -3.4443054310959584],
            [-3.586856329798203, -3.4434503942228374],
            [-3.6555587914706043, -3.440515422879989],
            [-3.65244186200454, -3.3811762591676886],
            [-3.6451201750624556, -3.2497462825231147],
            [-3.6411331157484104, -3.176633402081537],
            [-3.638332315689718, -3.1207921891042156],
            [-3.631700114446049, -3.0010193162052254]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.8126048996074,
          "lat": 35.401201561323155
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48179"],
        "coty_name": ["Gray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gray County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "01383875"
      },
      "bbox": [
        -3.6555587914706043, -3.461910583726217, -3.192559259832977,
        -3.0010193162052254
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.771598852045942, -8.378208268211724],
            [-2.6365396436672976, -8.38481732361999],
            [-2.532681819314218, -8.389692907361518],
            [-2.4841057207306814, -8.39192913376528],
            [-2.382005855065054, -8.396532700560273],
            [-2.3824017037966567, -8.402054749996324],
            [-2.3851871066119883, -8.494281308470804],
            [-2.386675366914932, -8.547384187703669],
            [-2.312006700737105, -8.549154180987864],
            [-2.1828624255923907, -8.551720944945414],
            [-2.0910898172129384, -8.553376177840962],
            [-2.0578051828258768, -8.554076433655247],
            [-2.0627900096807466, -8.701652348240623],
            [-2.063730540578373, -8.737465646283335],
            [-2.065881776559659, -8.838247354257062],
            [-2.066679764486946, -8.907079983453482],
            [-2.128032038239628, -8.87344833821459],
            [-2.228162033964411, -8.8184846926937],
            [-2.2858234934522828, -8.78832670778645],
            [-2.2876457697529866, -8.787624219148087],
            [-2.375331101736906, -8.775660900754449],
            [-2.4149209822754796, -8.773494562188535],
            [-2.54181721648859, -8.767589852891854],
            [-2.65574876335752, -8.762156300190066],
            [-2.732251156237066, -8.75835967040364],
            [-2.7246697779356563, -8.594880647606983],
            [-2.7831678637654096, -8.592431000369345],
            [-2.771598852045942, -8.378208268211724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.35000868340809,
          "lat": 30.061454035848687
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48265"],
        "coty_name": ["Kerr"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kerr County"],
        "coty_fp_code": "265",
        "coty_gnis_code": "01383918"
      },
      "bbox": [
        -2.7831678637654096, -8.907079983453482, -2.0578051828258768,
        -8.378208268211724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.8726954444986643, -6.100691809984875],
            [-3.872491396175542, -6.0971067401444845],
            [-3.755159061968658, -6.10315333286015],
            [-3.72543652458462, -6.104923005666135],
            [-3.646195733706327, -6.110304191464972],
            [-3.5451006293856677, -6.116454778361652],
            [-3.473480986337106, -6.120166837065997],
            [-3.4423003176063025, -6.121652378578962],
            [-3.444449712747608, -6.1616930620014285],
            [-3.4502834607236994, -6.2586725109548835],
            [-3.463310385918482, -6.487667757660276],
            [-3.4649655236043784, -6.520895547661622],
            [-3.4656276471608733, -6.522120878226387],
            [-3.46795785937562, -6.560458468580107],
            [-3.528501529547587, -6.557366909017111],
            [-3.5395163380954613, -6.556086554590056],
            [-3.599456567384266, -6.552730534313702],
            [-3.633727652528936, -6.551095481760377],
            [-3.7449279724057103, -6.545005924418824],
            [-3.747564790236767, -6.545027062708954],
            [-3.8666492383956954, -6.538406232077589],
            [-3.9045314607339785, -6.53616436374762],
            [-3.897240864053314, -6.4368790990927325],
            [-3.8954665541038622, -6.411325400925068],
            [-3.8755185896966644, -6.144243679450723],
            [-3.8743048909226863, -6.129504228606068],
            [-3.8726954444986643, -6.100691809984875]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.92113457691948,
          "lat": 32.30619732798606
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48335"],
        "coty_name": ["Mitchell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mitchell County"],
        "coty_fp_code": "335",
        "coty_gnis_code": "01383953"
      },
      "bbox": [
        -3.9045314607339785, -6.560458468580107, -3.4423003176063025,
        -6.0971067401444845
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.5225858339810556, -10.797177596688874],
              [-0.5185330569995975, -10.79331847724095],
              [-0.514665067354741, -10.787195338161402],
              [-0.5119446278979466, -10.788974160151238],
              [-0.516737406829041, -10.793030744848567],
              [-0.5201734003837554, -10.798232797400983],
              [-0.5225858339810556, -10.797177596688874]
            ]
          ],
          [
            [
              [-0.4873451948542848, -10.789841711841683],
              [-0.4745022352813057, -10.82477611697012],
              [-0.48152607823951443, -10.837419097653955],
              [-0.4805708659389985, -10.838255939219028],
              [-0.4780787478245459, -10.842699857285702],
              [-0.4816906903044701, -10.844922037500849],
              [-0.49173395437525796, -10.84666186310032],
              [-0.49656675449847887, -10.84485974805692],
              [-0.501980848732947, -10.847780910839184],
              [-0.50641351171358, -10.847833687116466],
              [-0.5183589600760673, -10.84975333640264],
              [-0.5367328687194496, -10.850980373702397],
              [-0.5368012831893005, -10.847896022658553],
              [-0.5330057576845003, -10.839407251989886],
              [-0.5298056392440388, -10.836463290064573],
              [-0.5249275559031557, -10.82552050042665],
              [-0.5148399439339343, -10.810936563217458],
              [-0.5135273482858157, -10.806943498296562],
              [-0.503492899612714, -10.814560330308165],
              [-0.4973901125038615, -10.806713712348953],
              [-0.4960724702336944, -10.802206602881377],
              [-0.49867617166997796, -10.799402240752409],
              [-0.4951632789165583, -10.796563545585379],
              [-0.4896711306572342, -10.79580172735179],
              [-0.4873451948542848, -10.789841711841683]
            ]
          ],
          [
            [
              [-0.5402951092273414, -10.794084433601617],
              [-0.5241049348938792, -10.79807510676286],
              [-0.5212921937774674, -10.800985418723464],
              [-0.5285035993126942, -10.80439679748571],
              [-0.5284445049691322, -10.799463571167868],
              [-0.5384285990458169, -10.796675074340273],
              [-0.5402951092273414, -10.794084433601617]
            ]
          ],
          [
            [
              [-0.5442726841184796, -10.785844694561714],
              [-0.5421337558947955, -10.789083945952498],
              [-0.5434973416260582, -10.79226753369977],
              [-0.5462693820599996, -10.789309120256805],
              [-0.5442726841184796, -10.785844694561714]
            ]
          ],
          [
            [
              [-0.5492417421120395, -10.835917317562407],
              [-0.5454371434359198, -10.835345733107056],
              [-0.5459113458060668, -10.839657644714087],
              [-0.5511843575421382, -10.83949277564831],
              [-0.5492417421120395, -10.835917317562407]
            ]
          ],
          [
            [
              [-0.5557914130598651, -10.80470729224897],
              [-0.5499964384970806, -10.795242595875145],
              [-0.5454867599230966, -10.796305467370358],
              [-0.5517308973306726, -10.806592104141792],
              [-0.5557914130598651, -10.80470729224897]
            ]
          ],
          [
            [
              [-0.5699272133784218, -10.867513747432117],
              [-0.5603913662134586, -10.866371934201846],
              [-0.5511009606076192, -10.867918127145114],
              [-0.553113102661978, -10.871666154478952],
              [-0.558731086740455, -10.871080094273085],
              [-0.5610696541932745, -10.868296736631468],
              [-0.5641322850031718, -10.871208359439297],
              [-0.5694073746448234, -10.870836004539106],
              [-0.5699272133784218, -10.867513747432117]
            ]
          ],
          [
            [
              [-0.5798608706176077, -10.931297928149615],
              [-0.5783137424215978, -10.9258662936586],
              [-0.5746832093298135, -10.922723393385315],
              [-0.5713054649119211, -10.922866784521691],
              [-0.5738362904084464, -10.93095915285926],
              [-0.5784106582256824, -10.93357814271876],
              [-0.5798608706176077, -10.931297928149615]
            ]
          ],
          [
            [
              [-0.593262683476842, -10.871266808652623],
              [-0.5818526841709789, -10.870378339674556],
              [-0.5818889959531092, -10.873256618758909],
              [-0.5890870039350409, -10.874916687158771],
              [-0.593262683476842, -10.871266808652623]
            ]
          ],
          [
            [
              [-0.6199377557362773, -10.877099853465134],
              [-0.605536418626593, -10.873685568241145],
              [-0.5990791220015753, -10.872947932683179],
              [-0.6058923136318017, -10.879378768170575],
              [-0.6150116326308123, -10.879941650524033],
              [-0.6199377557362773, -10.877099853465134]
            ]
          ],
          [
            [
              [-0.6448840009168286, -11.00163686871174],
              [-0.6367311294074068, -10.997375353146584],
              [-0.623750517486779, -10.998547014785364],
              [-0.6173716278058731, -11.00165143189484],
              [-0.622199770769487, -11.008644401115166],
              [-0.6321280837049519, -11.042445051572999],
              [-0.6348753372936542, -11.042241996669066],
              [-0.6286418333403044, -11.010242994767996],
              [-0.6323489007155934, -11.001630203287032],
              [-0.6369339950635491, -11.001403605582817],
              [-0.6412108938464743, -11.01277033662599],
              [-0.6448198498738563, -11.008020964687626],
              [-0.6448840009168286, -11.00163686871174]
            ]
          ],
          [
            [
              [-0.6250589495668007, -11.105450417541025],
              [-0.6423140675413854, -11.098950882453744],
              [-0.6655903261842139, -11.1054405611636],
              [-0.6632817075260617, -11.101204484136527],
              [-0.6548769957913844, -11.082279736066395],
              [-0.6456254973365902, -11.06305710609576],
              [-0.6398423838665451, -11.0497581571274],
              [-0.6354919064249819, -11.048681285038372],
              [-0.6226031943686687, -11.04987362978029],
              [-0.6170066678589075, -11.058688886221985],
              [-0.6138379205626089, -11.059037312127584],
              [-0.6127343864123234, -11.055553213077925],
              [-0.6178763077160797, -11.044275532153891],
              [-0.6178106292228973, -11.039235201901857],
              [-0.6071559888776132, -11.04132261672174],
              [-0.6048551998326448, -11.035076728482395],
              [-0.6073648014581159, -11.032884970114653],
              [-0.6052962487630906, -11.028281560567569],
              [-0.6012786017730372, -11.028331324148805],
              [-0.6020156469839562, -11.011658520391498],
              [-0.6007079868279499, -11.000360679855637],
              [-0.5944762886708582, -10.99241478964376],
              [-0.5892580623411175, -10.989392937999266],
              [-0.5788616689113513, -10.969463626197674],
              [-0.5754073144659574, -10.963643717358863],
              [-0.5750551787424196, -10.960870536873086],
              [-0.5691972647957432, -10.94859994154211],
              [-0.5667819643102928, -10.94122458300636],
              [-0.5659544713802724, -10.934139799734075],
              [-0.5602490005250362, -10.925466243390463],
              [-0.5591071699758786, -10.918488124629357],
              [-0.5540987297304091, -10.914845249605026],
              [-0.5427639912250203, -10.911894333564964],
              [-0.5359643203919783, -10.908374877754957],
              [-0.5325166914236501, -10.902656692885227],
              [-0.5314847483613477, -10.895882359582073],
              [-0.5318297589155003, -10.889400866999248],
              [-0.5306393056121501, -10.878207775908612],
              [-0.531945871058172, -10.872743477449518],
              [-0.5408331138326297, -10.865854491309063],
              [-0.5443986321587074, -10.863961989152175],
              [-0.5374974878106126, -10.86054753565435],
              [-0.5312641292947134, -10.85989997421996],
              [-0.5170850755039579, -10.856670497519804],
              [-0.5002752544470507, -10.853880033629261],
              [-0.49083903293991227, -10.849975486345095],
              [-0.4798417407890857, -10.847835190816323],
              [-0.474458982872122, -10.847688704867613],
              [-0.4639030647112838, -10.85516772164638],
              [-0.4736590603293037, -10.86417296094551],
              [-0.4886278477228339, -10.881698069396643],
              [-0.5051980504960292, -10.902226619453183],
              [-0.5210921154507036, -10.924320835396099],
              [-0.5505455483977288, -10.969365980709279],
              [-0.5625877393501695, -10.988597762877811],
              [-0.570626366299131, -11.002561844942546],
              [-0.5727894991783947, -11.00753508590682],
              [-0.5761249507522667, -11.01176293605691],
              [-0.5859955653276171, -11.028889281997134],
              [-0.6035699091355679, -11.06100778853426],
              [-0.6075489351509511, -11.069914718700517],
              [-0.6159264358338783, -11.086101666740925],
              [-0.6250589495668007, -11.105450417541025]
            ]
          ],
          [
            [
              [-0.6610976875821186, -10.814438753498141],
              [-0.6551080095561632, -10.81405515820554],
              [-0.6475170878784586, -10.817026601510532],
              [-0.6433073691264134, -10.82698003397244],
              [-0.6414881704480202, -10.827680536542157],
              [-0.6404409443502858, -10.833290499147747],
              [-0.6354678414823792, -10.846997386033218],
              [-0.6415901408987139, -10.846704579218631],
              [-0.6527881899501926, -10.82203258543098],
              [-0.6609531852251986, -10.819026831714863],
              [-0.6610976875821186, -10.814438753498141]
            ]
          ],
          [
            [
              [-1.1299313161941975, -10.687610263147745],
              [-1.1313924332226872, -10.691083097453586],
              [-1.1301372135054826, -10.693698612068768],
              [-1.1322136684608626, -10.697036477510027],
              [-1.1340307887067114, -10.703462652634053],
              [-1.1368524022663857, -10.7039172454373],
              [-1.1374499041443635, -10.70854555261736],
              [-1.1412879549632549, -10.707870593764735],
              [-1.1462208489567478, -10.709384942758062],
              [-1.1471568397515728, -10.713154812031714],
              [-1.142479125734267, -10.717995375851775],
              [-1.1406815084025184, -10.72451666349681],
              [-1.141124196952066, -10.730931140931597],
              [-1.1398672997464467, -10.736178841196342],
              [-1.1370911516666313, -10.737857846608257],
              [-1.139106751821262, -10.742335381935373],
              [-1.1384225609408827, -10.747127547395477],
              [-1.1342995222564762, -10.748067907684273],
              [-1.129303182924695, -10.744883261247825],
              [-1.1282897440785504, -10.739965021872008],
              [-1.11974370633496, -10.737593470309516],
              [-1.1168812806219444, -10.735333818329353],
              [-1.1116005953042853, -10.740523821001682],
              [-1.1108243191173575, -10.744613603821707],
              [-1.1048040615399437, -10.746492909987039],
              [-1.100681712028806, -10.744481034822279],
              [-1.0987089613908012, -10.749683944312842],
              [-1.1031267137228535, -10.754171059803],
              [-1.0976965039952586, -10.759538527306818],
              [-1.095283752560376, -10.758930467449606],
              [-1.0935578213386439, -10.753899899066376],
              [-1.086030295387554, -10.750799892029534],
              [-1.0828900334654066, -10.755148167778286],
              [-1.0782440124441135, -10.75715828870152],
              [-1.0732545289896365, -10.75749842503126],
              [-1.069879644135587, -10.76067559444945],
              [-1.0743538328200244, -10.767015829504254],
              [-1.0652881633012443, -10.76648876379158],
              [-1.0592693348613207, -10.771187489277732],
              [-1.0574369771735017, -10.769527617896438],
              [-1.0588240414535797, -10.765256828859942],
              [-1.0512273291216323, -10.760584125098745],
              [-1.0466139749045995, -10.76210636100022],
              [-1.0451451209302054, -10.764840700433885],
              [-1.0356343571835547, -10.766354321929487],
              [-1.033020589255674, -10.772570432061867],
              [-1.0369063254569402, -10.77892729574437],
              [-1.0283095158441922, -10.781329313033288],
              [-1.0231322274585004, -10.787901289711394],
              [-1.019195705663592, -10.790067734202017],
              [-1.022728752861659, -10.800277734111043],
              [-1.0134831954181773, -10.80655858283571],
              [-1.0031613698701325, -10.810634249787956],
              [-0.9962396837302565, -10.810313829151642],
              [-0.9923843764342227, -10.812352094228006],
              [-0.9900989508469014, -10.817417618467577],
              [-0.9834490734701261, -10.813019845020257],
              [-0.9800614131941455, -10.807690818784074],
              [-0.9790557690340244, -10.802133599343472],
              [-0.9804898442544594, -10.796427520343551],
              [-0.9841839789411886, -10.79007046487827],
              [-0.9796511253667054, -10.788427245936255],
              [-0.9744744313581861, -10.791647911074993],
              [-0.9685359086931717, -10.790966224654287],
              [-0.964318405863331, -10.793597690854009],
              [-0.9640617271834433, -10.799453310385143],
              [-0.965266473413163, -10.80766043277072],
              [-0.962435852916853, -10.813676761004992],
              [-0.9547725276429049, -10.817317636888088],
              [-0.9508114293672248, -10.824724704939785],
              [-0.9470402327646303, -10.827424709243548],
              [-0.9410998478487556, -10.826452622738909],
              [-0.9371907742977279, -10.823804137186768],
              [-0.9324597414318637, -10.822880193543751],
              [-0.9259095443584487, -10.824365128390822],
              [-0.9164475570161311, -10.823407144352286],
              [-0.9054242598285619, -10.825931948616024],
              [-0.9028200617242971, -10.832250188621146],
              [-0.8991061700522455, -10.836441065503726],
              [-0.8904999457822146, -10.83743818400305],
              [-0.8808722473805012, -10.837652058073472],
              [-0.8773055499985082, -10.840212495096527],
              [-0.8729319928861715, -10.841204254148764],
              [-0.8702895270607126, -10.838380627518955],
              [-0.8616392469582762, -10.84042630245671],
              [-0.8595891890592832, -10.844231890895236],
              [-0.8578589239466445, -10.850846223401103],
              [-0.8510989257469393, -10.85711811239709],
              [-0.8433401317925442, -10.860320976340244],
              [-0.8352276078374644, -10.861163998463176],
              [-0.8260144626315687, -10.859143771246426],
              [-0.8188459927917524, -10.852876600012694],
              [-0.8108254013899893, -10.85279052114377],
              [-0.805188431820872, -10.856782216323591],
              [-0.7978606346456061, -10.859468835562549],
              [-0.794201476727838, -10.863007978764783],
              [-0.7879152208535295, -10.852099160123032],
              [-0.7750948023017866, -10.848584045726719],
              [-0.7721481237098454, -10.849140104084004],
              [-0.7664027415524897, -10.845932464265537],
              [-0.7604141869588872, -10.85003303647543],
              [-0.7601819128762869, -10.853424192609609],
              [-0.7726481049459593, -10.871764693491222],
              [-0.7727311847636312, -10.880489633756497],
              [-0.7716924823177425, -10.889347615687065],
              [-0.7739955295356947, -10.901694552182462],
              [-0.7726951370280474, -10.907019839278933],
              [-0.7678610963165894, -10.915726455370589],
              [-0.7623371555112683, -10.920639185834737],
              [-0.7591594661794103, -10.927162840409572],
              [-0.7584250529634957, -10.934680095324737],
              [-0.75002294326643, -10.94518598797121],
              [-0.7460648152018635, -10.949047079896708],
              [-0.7379211267094895, -10.954831889547812],
              [-0.7352771933158739, -10.95557466016538],
              [-0.7307544214997569, -10.95988260421717],
              [-0.7067030685023761, -10.971306136639953],
              [-0.6845642942446208, -10.978481493587001],
              [-0.674751917718153, -10.979640199397133],
              [-0.6449806969023409, -10.989902505716232],
              [-0.6454484458362463, -10.993290218025177],
              [-0.6512381309660955, -10.991467747211518],
              [-0.6532112181145919, -10.992487074807464],
              [-0.657533615157142, -11.003728910560108],
              [-0.6651804427046999, -11.006303119079472],
              [-0.6637959151043415, -11.008437258173453],
              [-0.6903983076320819, -11.068013834154296],
              [-0.6904084920108651, -11.072012547771898],
              [-0.6928941920134947, -11.075785524690124],
              [-0.692058601343767, -11.084130989719045],
              [-0.6889482370681909, -11.08880215110148],
              [-0.7137994629766378, -11.111548629086666],
              [-0.7160888271657673, -11.11931277535152],
              [-0.7166066117033886, -11.119482317536956],
              [-0.7876808403271256, -11.119316636573569],
              [-0.8375605820808392, -11.118447760497112],
              [-0.8455883104487415, -11.118027411882283],
              [-0.9376262330144878, -11.116716150934291],
              [-1.0385979076329124, -11.115841141395922],
              [-1.1395695457305097, -11.114937794784689],
              [-1.1742376621677746, -11.114055936748885],
              [-1.1763682018729682, -11.107399415310791],
              [-1.1812609674703767, -11.106156485875795],
              [-1.1848896263974187, -11.098187186762136],
              [-1.1898930204011307, -11.095018024719657],
              [-1.1907375243643616, -11.092341645807332],
              [-1.19729353093877, -11.090636867152503],
              [-1.2013961738452672, -11.085586939726202],
              [-1.2046340449648003, -11.085213668447942],
              [-1.2076116021665888, -11.076378541094183],
              [-1.2056688052961277, -11.074444513473583],
              [-1.207243095185442, -11.064397006870742],
              [-1.2113832793747918, -11.059803314101678],
              [-1.216549520634044, -11.056705840454155],
              [-1.2192291030584024, -11.05225922403508],
              [-1.2235367261310555, -11.05285608871214],
              [-1.2280829442284773, -11.050610305804067],
              [-1.236519442946559, -11.050897684067783],
              [-1.2390910246377136, -11.04944853653425],
              [-1.2459051358084083, -11.04997909336907],
              [-1.2491018740348228, -11.04570186318114],
              [-1.2551680958684481, -11.040390921083894],
              [-1.2557117818397663, -11.037201991736339],
              [-1.2645048848208025, -11.036930285462708],
              [-1.2619454938989232, -11.002934446075264],
              [-1.2598292498434853, -10.978504680449756],
              [-1.254098367715773, -10.89957772907513],
              [-1.2526777793900008, -10.81832911294199],
              [-1.252449420706995, -10.79338509483744],
              [-1.2237105627143727, -10.768426267729375],
              [-1.219688976950234, -10.765598036929067],
              [-1.1692785849234038, -10.721883445813729],
              [-1.1299313161941975, -10.687610263147745]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.61368793062213,
          "lat": 27.725384095518958
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48355"],
        "coty_name": ["Nueces"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nueces County"],
        "coty_fp_code": "355",
        "coty_gnis_code": "01383963"
      },
      "bbox": [
        -1.2645048848208025, -11.119482317536956, -0.4639030647112838,
        -10.687610263147745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5835679461437127, -2.114896881134512],
            [-3.557519080947953, -2.115964194383954],
            [-3.4793788132645966, -2.1200423669765174],
            [-3.3972167427478452, -2.1241791541219506],
            [-3.326419383348514, -2.12784277376482],
            [-3.236185970415659, -2.132466849449199],
            [-3.154907530110112, -2.1365198153546534],
            [-3.160749620476183, -2.261207616543516],
            [-3.1685296546627146, -2.422670793970656],
            [-3.17674243429514, -2.5825819105096217],
            [-3.2342171504883175, -2.579486311573175],
            [-3.239702032338243, -2.579528537798066],
            [-3.4179452370072445, -2.5697825768479876],
            [-3.4965537783343135, -2.565425573835441],
            [-3.6078578795000893, -2.559693020137034],
            [-3.5977742587940416, -2.3729147315467753],
            [-3.5904848669843608, -2.241649962720106],
            [-3.5899845720400463, -2.240035265502857],
            [-3.5835679461437127, -2.114896881134512]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.81566729159553,
          "lat": 36.27835798535026
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48357"],
        "coty_name": ["Ochiltree"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ochiltree County"],
        "coty_fp_code": "357",
        "coty_gnis_code": "01383964"
      },
      "bbox": [
        -3.6078578795000893, -2.5825819105096217, -3.154907530110112,
        -2.114896881134512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.000909289919493, -5.1638789387276995],
            [-4.9228326304227945, -5.169164955934079],
            [-4.920635212783718, -5.169557065344916],
            [-4.817577266970439, -5.176227020738541],
            [-4.73639845581619, -5.181217628260271],
            [-4.636007290837641, -5.187627635954823],
            [-4.612493852468326, -5.189345421651046],
            [-4.6066695397925885, -5.1892332380059605],
            [-4.571470124523009, -5.191327415841979],
            [-4.5768880132634715, -5.275453910664343],
            [-4.585523358537392, -5.411266410200514],
            [-4.587330734562744, -5.442822493096754],
            [-4.589270323373755, -5.472376375617792],
            [-4.596061399187743, -5.5808832211715],
            [-4.5969638136167426, -5.587915068242396],
            [-4.599350078119387, -5.621207509093254],
            [-4.709489721485852, -5.614862469866761],
            [-4.732100316530531, -5.61377262046786],
            [-4.753229425145996, -5.612114227824056],
            [-4.811008030538286, -5.608267536799134],
            [-4.896734569838294, -5.602756863124479],
            [-4.897991573023618, -5.602487352137701],
            [-5.025869061960424, -5.5939125211312195],
            [-5.03104898660057, -5.593399797304769],
            [-5.021043060372228, -5.455549597570246],
            [-5.0193760300407035, -5.429400242372732],
            [-5.008916474716388, -5.282800593944293],
            [-5.00694184431031, -5.2536243324582115],
            [-5.001346002511414, -5.1773096445820554],
            [-5.000909289919493, -5.1638789387276995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.33516749636216,
          "lat": 33.173802323783526
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48445"],
        "coty_name": ["Terry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Terry County"],
        "coty_fp_code": "445",
        "coty_gnis_code": "01384008"
      },
      "bbox": [
        -5.03104898660057, -5.621207509093254, -4.571470124523009,
        -5.1638789387276995
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.13141087293662, -9.554626942006992],
            [-3.034955243687879, -9.558001472035203],
            [-2.9647550036615202, -9.560235334587396],
            [-2.963766973121628, -9.560013259731797],
            [-2.919666731557779, -9.56117005661732],
            [-2.9136533812550622, -9.561144170214506],
            [-2.815116106514919, -9.564760251026483],
            [-2.7665665566195856, -9.566096645999151],
            [-2.758279318313923, -9.566818248967133],
            [-2.7064269403869208, -9.56852027937448],
            [-2.702203085969242, -9.568394199338925],
            [-2.597161740299189, -9.571410585657473],
            [-2.596684523315714, -9.571194279615657],
            [-2.5215799595263584, -9.573499667647328],
            [-2.523235177921314, -9.630859976224402],
            [-2.5273771045436773, -9.778237463664649],
            [-2.5293364920415233, -9.841271974598007],
            [-2.531523673240533, -9.95506219702485],
            [-2.533474016838489, -10.01691693907001],
            [-2.607614890482174, -10.013442425762685],
            [-2.6168263703541594, -10.013227356366382],
            [-2.636870091389769, -10.011226294862368],
            [-2.7234666190392236, -10.007643396931183],
            [-2.860096488957187, -10.0015376733034],
            [-2.943064050518325, -9.99813972247658],
            [-2.976129060805939, -9.994028780225241],
            [-3.055423809955846, -9.990222793141793],
            [-3.152907035411817, -9.985328408444683],
            [-3.146326915934638, -9.859512415562905],
            [-3.146359137530748, -9.857386442666119],
            [-3.142642330473207, -9.782903714667462],
            [-3.1390397010593554, -9.711125223315651],
            [-3.13141087293662, -9.554626942006992]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.76052980575713, "lat": 28.8661753531479 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48507"],
        "coty_name": ["Zavala"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Zavala County"],
        "coty_fp_code": "507",
        "coty_gnis_code": "01384039"
      },
      "bbox": [
        -3.152907035411817, -10.01691693907001, -2.5215799595263584,
        -9.554626942006992
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.387432970588991, 2.0989684092219205],
            [-11.337202932229403, 2.0905896804243813],
            [-11.30208714213544, 2.0849348397331675],
            [-11.302281563306888, 2.084027453211809],
            [-11.285230686073254, 2.08123485858041],
            [-11.135815485623185, 2.0571499077860405],
            [-11.13570446231262, 2.0578328668928636],
            [-11.091154322409267, 2.050588731085896],
            [-11.10864513664793, 1.9423925792486099],
            [-11.11824688365959, 1.8842148676701957],
            [-11.119504404359231, 1.877388278017361],
            [-11.133030278179474, 1.7899506419650488],
            [-11.133535119284547, 1.7900394478445967],
            [-11.147104456830736, 1.7062190336356702],
            [-11.187226581182145, 1.7127590462320992],
            [-11.199889917094543, 1.6349992808959626],
            [-11.215018762470716, 1.5406929740422064],
            [-11.21427803634262, 1.5405962488331852],
            [-11.227690027547645, 1.4576265938430952],
            [-11.242905425544064, 1.3645517481922047],
            [-11.242601254364518, 1.364502371124493],
            [-11.256437537458266, 1.2793142213195785],
            [-11.389077471027631, 1.3011196632073847],
            [-11.521720005238736, 1.3229090970140631],
            [-11.638130273720357, 1.3432439589652554],
            [-11.676811804611637, 1.3498945921921763],
            [-11.675457526152426, 1.357116124606372],
            [-11.672098125427727, 1.36159788665984],
            [-11.796643620838315, 1.3826065548593947],
            [-11.752544432873677, 1.650534050904382],
            [-11.748624152260726, 1.6726956736290446],
            [-11.705050922644638, 1.665207472999258],
            [-11.700602882047917, 1.6945029688623983],
            [-11.672485454833676, 1.690490688733163],
            [-11.67052790942925, 1.705233238595786],
            [-11.653290402431926, 1.702281671374288],
            [-11.537938435531702, 1.6841321818412547],
            [-11.525586365985353, 1.7611757290274646],
            [-11.499454648210133, 1.7570358636725742],
            [-11.484932199662392, 1.8445289560846643],
            [-11.486787516686773, 1.844841448095354],
            [-11.471638341992305, 1.9331176033872564],
            [-11.473190843016841, 1.9333765401231422],
            [-11.46380027990253, 1.99069817676583],
            [-11.442633382594567, 1.987857051271435],
            [-11.44021051676103, 2.002924940717556],
            [-11.433225496327726, 2.001594633421073],
            [-11.432088212788878, 2.0088386418899153],
            [-11.417775531963224, 2.0066528864186512],
            [-11.416540077966074, 2.0140175345067384],
            [-11.402443401579484, 2.011782635323151],
            [-11.399965279812372, 2.0262293751236147],
            [-11.356475043024563, 2.0194824320713454],
            [-11.349288275611933, 2.0633745865438304],
            [-11.377642806227367, 2.067640514452435],
            [-11.374926890556116, 2.0821858926114367],
            [-11.389924556973616, 2.084500655567756],
            [-11.387432970588991, 2.0989684092219205]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.57634883042225,
          "lat": 39.373880424512684
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49039"],
        "coty_name": ["Sanpete"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sanpete County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01448033"
      },
      "bbox": [
        -11.796643620838315, 1.2793142213195785, -11.091154322409267,
        2.0989684092219205
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.123014885348327, 0.1183250825516254],
            [15.12331906085091, 0.12072960384522662],
            [15.120440102433314, 0.124731417164997],
            [15.12012016366897, 0.12833544631274646],
            [15.126157344005419, 0.12780512866784058],
            [15.133638177361643, 0.12271479998117824],
            [15.141440818966455, 0.11991586090680341],
            [15.145398838724383, 0.12474293427212656],
            [15.147929131097195, 0.13197637955980682],
            [15.147792353273031, 0.1351476388027164],
            [15.142780328471352, 0.1369163540048938],
            [15.141800926738766, 0.1412473587837415],
            [15.136665414609057, 0.1451233534705949],
            [15.139157896588443, 0.1505303450522706],
            [15.148837499624586, 0.19745505920274367],
            [15.157255905902982, 0.23702305956893419],
            [15.162592644144333, 0.23463155338436767],
            [15.165742464867282, 0.2287351219434807],
            [15.168186913971713, 0.23315104764934244],
            [15.173399678517148, 0.23536290332001358],
            [15.172140620535556, 0.22550564480040064],
            [15.175446798560056, 0.22412321138772154],
            [15.180708031034804, 0.22801995452301066],
            [15.183270515883073, 0.22694056005120053],
            [15.187323281717013, 0.22838151612194993],
            [15.189085714762763, 0.22053298402354685],
            [15.196450621750817, 0.22529064999301465],
            [15.19990856504954, 0.226006985564682],
            [15.204776454985069, 0.2182921274493563],
            [15.209705531979505, 0.21421241016209314],
            [15.20906019828295, 0.21161450410370117],
            [15.212569523881774, 0.20917217993611067],
            [15.216925547048378, 0.21012047664029432],
            [15.229983361456881, 0.1998147085823201],
            [15.23711764551487, 0.2024068019367726],
            [15.243436099082938, 0.20232256680682392],
            [15.24493537212116, 0.2038725596429646],
            [15.25901579135887, 0.200126095409671],
            [15.259853913459045, 0.19452228451027861],
            [15.26339030599538, 0.19789855566398015],
            [15.2694740557882, 0.19904540144235022],
            [15.276577972039613, 0.1977894984549757],
            [15.278869320402206, 0.19588949912973025],
            [15.282034939062818, 0.1991485686716027],
            [15.285629223289897, 0.19944297899803295],
            [15.28913898513835, 0.19379136809116937],
            [15.288909240076004, 0.19098896795252043],
            [15.292364526138465, 0.18741676936147025],
            [15.296777611112718, 0.18625464932813626],
            [15.300070988801929, 0.1890458537883183],
            [15.303354481186876, 0.1873123035958734],
            [15.309697678067248, 0.1931790295906351],
            [15.317555728888358, 0.19143866313936625],
            [15.320864179515775, 0.1975754069059596],
            [15.330163434826142, 0.19749079861332364],
            [15.332478436146708, 0.19475616234436832],
            [15.330981944569483, 0.18926460341521997],
            [15.334739448529158, 0.18621787557598388],
            [15.344735176408353, 0.18548065961600224],
            [15.348280113464044, 0.18634597510941703],
            [15.353801188146237, 0.1940851119370988],
            [15.357967622131788, 0.19180463930978228],
            [15.360004992306184, 0.18816406669357846],
            [15.359888451626308, 0.18413301122194645],
            [15.355342426673735, 0.17762926615001448],
            [15.35535188762977, 0.17450490610821034],
            [15.357755217877202, 0.16763302699575322],
            [15.360779187608603, 0.16803225756880544],
            [15.365858857376493, 0.17345049426595058],
            [15.365812599918081, 0.18202057841620775],
            [15.369356115777629, 0.18592954581779825],
            [15.377128170212915, 0.1833633304921917],
            [15.38071365877842, 0.18836145753581438],
            [15.381866665467513, 0.1943226849671483],
            [15.385161150456375, 0.1936972067777333],
            [15.385684374822658, 0.18224973264073396],
            [15.384611798357806, 0.18023000990369517],
            [15.377923983144425, 0.1771610573778524],
            [15.378449831945321, 0.17217442741390257],
            [15.390158369563691, 0.16776101181710026],
            [15.395579729386961, 0.16626945746185903],
            [15.395597857432968, 0.16281370302055118],
            [15.38932966685413, 0.1559280278624562],
            [15.38828694703871, 0.15339196371505517],
            [15.386418610928922, 0.14118580675622658],
            [15.392013833432308, 0.13823174531307422],
            [15.394923148135582, 0.14088618143280396],
            [15.396400898336182, 0.1469353035057368],
            [15.39976968932008, 0.15238668578463352],
            [15.403560682557444, 0.15444736331351921],
            [15.407185438789279, 0.16185383092014108],
            [15.412975442751497, 0.1636765547853579],
            [15.416910880578827, 0.15852880663628302],
            [15.414823071008035, 0.1497296038187397],
            [15.414768963067212, 0.14290761594163703],
            [15.419514750763229, 0.14112498639076224],
            [15.421023575956397, 0.13787628750192998],
            [15.420603531702715, 0.12816822597382996],
            [15.424785549121339, 0.11303621783105082],
            [15.422702389633166, 0.1045328244919209],
            [15.426522272742142, 0.09793208933137151],
            [15.431200623018839, 0.09444058853937344],
            [15.432005507592434, 0.0917171559193932],
            [15.42641485144049, 0.08018062653060373],
            [15.427181150172402, 0.07045915817597279],
            [15.428831294504253, 0.06642511469205578],
            [15.436324427496405, 0.056741152265579985],
            [15.431957777641214, 0.052398085262503884],
            [15.429587824193062, 0.047138370558452415],
            [15.4264100674579, 0.046783280187655964],
            [15.421233845437305, 0.04309655584214585],
            [15.422025676649811, 0.038080651425880574],
            [15.417181960120123, 0.0338871158463344],
            [15.409680837358298, 0.03362732002261714],
            [15.407560429784496, 0.026663687727989396],
            [15.408721053262694, 0.023779679932331134],
            [15.39596238780299, 0.025864414708280846],
            [15.390589928824152, 0.023602640026967353],
            [15.38848862364173, 0.020091084570862273],
            [15.384321659802405, 0.021971241356716156],
            [15.37086297105855, 0.02582607573216964],
            [15.363679698092056, 0.02928495135030728],
            [15.35850680410838, 0.03483572122070365],
            [15.343140346530527, 0.05551777488915262],
            [15.340523782077033, 0.06300414231723127],
            [15.340635247958156, 0.07240453558728949],
            [15.33494916259248, 0.07752757241212313],
            [15.329909346314325, 0.07917481624769236],
            [15.323211990348945, 0.07955119062291979],
            [15.307882918353952, 0.0653367612847205],
            [15.284493104391675, 0.03514187240403347],
            [15.28070932848953, 0.03545364407864076],
            [15.275767607642846, 0.03805059256729485],
            [15.263350259457562, 0.07327750258008235],
            [15.261310742952183, 0.07509946116543444],
            [15.254994693643237, 0.07291038862238489],
            [15.234868420460112, 0.05931669733741697],
            [15.226405810461186, 0.05840930173934008],
            [15.184950182089647, 0.05808267719329093],
            [15.157959007611456, 0.06072237824184355],
            [15.153230310636676, 0.05945970279947823],
            [15.146628182336864, 0.05046896937542518],
            [15.141065917810428, 0.04704895851996408],
            [15.136071257909524, 0.045622166415858464],
            [15.12640210127298, 0.04900674494218727],
            [15.118910297696509, 0.05444059261521858],
            [15.117068603167553, 0.06004515223795836],
            [15.117850363660168, 0.07409811889479914],
            [15.118998841370866, 0.07844632362240106],
            [15.1286403808768, 0.09772279755820126],
            [15.129776838527539, 0.10657216934904185],
            [15.126532322271931, 0.11483607960049858],
            [15.123014885348327, 0.1183250825516254]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.06219552492372,
          "lat": 37.356714268994764
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51036"],
        "coty_name": ["Charles City"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charles City County"],
        "coty_fp_code": "036",
        "coty_gnis_code": "01480109"
      },
      "bbox": [
        15.117068603167553, 0.020091084570862273, 15.436324427496405,
        0.23702305956893419
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.380923371468633, -0.1142646570511828],
            [14.45880713252915, -0.12237168927340283],
            [14.544876046390879, -0.13042475537985576],
            [14.554639545640054, -0.1311682484551022],
            [14.614712189179704, -0.13708856069127365],
            [14.672581309015511, -0.14334243829334806],
            [14.67913570891571, -0.14341990603910243],
            [14.714558605527584, -0.14799509713216957],
            [14.737664284129352, -0.1524765763175489],
            [14.735761928613853, -0.1557541563913161],
            [14.736336944231976, -0.16022893891120568],
            [14.73293476829769, -0.1622265608492043],
            [14.732835952675492, -0.17082361825199394],
            [14.728175258602722, -0.17788333521180205],
            [14.723100413379587, -0.1814641899846723],
            [14.720028991087132, -0.18200846578201965],
            [14.714025533336432, -0.17997499515557439],
            [14.708607867028215, -0.18244246045437282],
            [14.704775115798629, -0.18674317991658432],
            [14.697043132637823, -0.18956251750018915],
            [14.696128275847107, -0.19359689072009778],
            [14.692035404981509, -0.19827604174795072],
            [14.687902816660426, -0.20555405059678775],
            [14.675452732306463, -0.21383193069155257],
            [14.671631781720116, -0.21297498945681223],
            [14.666099140689584, -0.2164079229378769],
            [14.672340374544435, -0.2427511951543039],
            [14.700560084159308, -0.3575639528205442],
            [14.703911316647652, -0.36856905968174025],
            [14.694867285841271, -0.36986562597878614],
            [14.69309587137647, -0.3730769065957793],
            [14.689375474019284, -0.3749927468062322],
            [14.682740957670598, -0.375139655425877],
            [14.68120180573507, -0.3792003474906812],
            [14.677779428731112, -0.37849377451265587],
            [14.671430823307364, -0.37952745325138404],
            [14.668026117596177, -0.37616023269097953],
            [14.661189898881279, -0.37895867317138654],
            [14.652739812594085, -0.37588019266764244],
            [14.646288881407376, -0.37865045814876946],
            [14.643375370450306, -0.3817885327512529],
            [14.637187517138457, -0.3767883494446278],
            [14.63155067652191, -0.37084005071560155],
            [14.630646038565272, -0.3681740407087168],
            [14.62165062098123, -0.36223838670632624],
            [14.620531954415709, -0.35976449731600685],
            [14.615267755584268, -0.3577883451646049],
            [14.614927032808415, -0.3510262539790869],
            [14.61096764177131, -0.3497167873542504],
            [14.609035036550933, -0.3519161035195586],
            [14.602473890097517, -0.35418374638259076],
            [14.590680130234121, -0.36038421526914644],
            [14.588748478979713, -0.36433024890408977],
            [14.57771114605352, -0.3638980157080817],
            [14.569823588769289, -0.36517016244227646],
            [14.57138093981998, -0.36863486836324044],
            [14.56568932540169, -0.3720268559744484],
            [14.560614293432849, -0.37323140438380553],
            [14.555459500603494, -0.37209896489949457],
            [14.552608331228624, -0.375324868070047],
            [14.549387384658374, -0.37469360283875625],
            [14.54871716523998, -0.3697416406700667],
            [14.539902190713864, -0.36603984436311177],
            [14.536057474772312, -0.3661149716141061],
            [14.533423336960569, -0.3638664890995385],
            [14.529252291494908, -0.3680028265073899],
            [14.525735657346821, -0.36594587818623436],
            [14.52599984953254, -0.3610749952814861],
            [14.523787252657886, -0.3597100656689139],
            [14.51998523180091, -0.361447553727954],
            [14.516338987095141, -0.35654630225424033],
            [14.51243116690256, -0.3564247221700902],
            [14.507117806849035, -0.35397825339602085],
            [14.498053855102011, -0.35134744580067767],
            [14.488892317752759, -0.3521443125744899],
            [14.482551766356362, -0.35108881623806854],
            [14.482036519373056, -0.346554648357564],
            [14.478793986836022, -0.3474982890369101],
            [14.472743715515781, -0.3452595426166843],
            [14.473352512767645, -0.33999508510748033],
            [14.471859602470353, -0.3321183302672543],
            [14.468303770573772, -0.32898349434378377],
            [14.469201091161725, -0.3236642674565732],
            [14.465267775036292, -0.3244796360682976],
            [14.464785791145212, -0.3276275272097092],
            [14.459704135294817, -0.32722782573301806],
            [14.45567309808359, -0.3289789092511297],
            [14.451968201942835, -0.32784795866695604],
            [14.452127184824073, -0.3246905740413438],
            [14.44392459569864, -0.3256337324697988],
            [14.444201355247696, -0.3211612956958032],
            [14.439903267492975, -0.3193190995890929],
            [14.436427242469302, -0.3224232976875839],
            [14.430328610168662, -0.3185949852848046],
            [14.42507872993388, -0.3181561170255876],
            [14.42266877023707, -0.31271153154812803],
            [14.419338599506343, -0.3118607865929469],
            [14.418408031423981, -0.30634691612030196],
            [14.421594171729256, -0.30510800371168284],
            [14.420692250104572, -0.3009533852227619],
            [14.417246130473726, -0.2963388241423699],
            [14.414257413095052, -0.29704702298684516],
            [14.4112537622054, -0.2916200095462704],
            [14.407678748501919, -0.29020381553920194],
            [14.406970094489093, -0.2851340121218859],
            [14.394567698937543, -0.2157358967864167],
            [14.380923371468633, -0.1142646570511828]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.05124533458338, "lat": 37.14304494244523 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51135"],
        "coty_name": ["Nottoway"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nottoway County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01493928"
      },
      "bbox": [
        14.380923371468633, -0.3817885327512529, 14.737664284129352,
        -0.1142646570511828
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.689532220596151, 1.4634161973287818],
            [14.675019220656571, 1.4695977594001841],
            [14.672299506999007, 1.4705745368546184],
            [14.675573973524772, 1.477196346182122],
            [14.686723960899243, 1.4783721460381043],
            [14.68773398799037, 1.4693126094447078],
            [14.700357869674392, 1.4636786626199432],
            [14.701069087426093, 1.4690236227265918],
            [14.699532916765424, 1.4718993287974482],
            [14.701255687376754, 1.4772096876426437],
            [14.706865332271533, 1.4730426496519984],
            [14.710694955317969, 1.474804510174531],
            [14.71565772316616, 1.4732604603070485],
            [14.719785281881967, 1.4667356798815399],
            [14.716680776846161, 1.4657538367501328],
            [14.720369642340039, 1.4591915545779315],
            [14.716959038258407, 1.4495756847188297],
            [14.714061070309832, 1.4515356483655624],
            [14.710100588972596, 1.4497757335384505],
            [14.709422534878504, 1.4449866018708222],
            [14.707170872895189, 1.4435813371337318],
            [14.701697794204271, 1.449530160639179],
            [14.70394761434728, 1.4516243054149978],
            [14.702729164824804, 1.4571547729474739],
            [14.689532220596151, 1.4634161973287818]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.44305565015924, "lat": 38.77059343425466 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51685"],
        "coty_name": ["Manassas Park"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Manassas Park city"],
        "coty_fp_code": "685",
        "coty_gnis_code": "01498431"
      },
      "bbox": [
        14.672299506999007, 1.4435813371337318, 14.720369642340039,
        1.4783721460381043
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.055431873294868, 11.943283246985262],
              [-17.05403001751603, 11.932936297623218],
              [-17.051306394454553, 11.927468154436282],
              [-17.054460116069606, 11.920724365676918],
              [-17.060799166106737, 11.921923792371212],
              [-17.0686694877557, 11.921372203037249],
              [-17.073901653300226, 11.924466276602137],
              [-17.073612782810276, 11.9291138295259],
              [-17.075937757651964, 11.933140400896889],
              [-17.083011812628907, 11.934296095438649],
              [-17.089227282479055, 11.933185116823523],
              [-17.09289868268354, 11.930441764473972],
              [-17.092751683585245, 11.924077927400953],
              [-17.094029798912775, 11.916518058101857],
              [-17.090851800748528, 11.915413970517548],
              [-17.090670561845844, 11.910148217517648],
              [-17.102459676149603, 11.900625869305593],
              [-17.10791361600917, 11.898619368561844],
              [-17.113084976049116, 11.90094345575566],
              [-17.120056690134906, 11.896923723252327],
              [-17.123737748328967, 11.885463006556545],
              [-17.12199776507651, 11.88056395758377],
              [-17.124092735574976, 11.876573665414657],
              [-17.118922809433688, 11.870589604631983],
              [-17.119720553959123, 11.864043857798963],
              [-17.116864781078164, 11.853578409455018],
              [-17.113885819171504, 11.849664278956485],
              [-17.112254171757908, 11.836993313616578],
              [-17.107494721196808, 11.830852403168116],
              [-17.102109368635617, 11.82556719962378],
              [-17.102801357833783, 11.819197089454915],
              [-17.097148847126935, 11.81498395895067],
              [-17.083328105488675, 11.785067220855696],
              [-17.081034691878223, 11.777883449020322],
              [-17.078942786617468, 11.76257817265338],
              [-17.077015389635367, 11.758491455848045],
              [-17.076958535355477, 11.752383668150028],
              [-17.081632735232116, 11.751453863353632],
              [-17.089893340861853, 11.756807317069217],
              [-17.094678762084857, 11.765834219226216],
              [-17.09552089458177, 11.770397012536677],
              [-17.09477815894917, 11.779267894024922],
              [-17.097651384970963, 11.786915182068455],
              [-17.10192464186771, 11.793312481863088],
              [-17.105288078915656, 11.79652538653579],
              [-17.1077497668365, 11.807582841423855],
              [-17.11088164186193, 11.811001829609564],
              [-17.119211467923776, 11.814904262641305],
              [-17.121002058940338, 11.817599730277097],
              [-17.12154041771054, 11.8226383322225],
              [-17.124959047670938, 11.830407680947467],
              [-17.128648567202454, 11.84108620197018],
              [-17.1357909568346, 11.841768449652568],
              [-17.143665723241096, 11.835801804891753],
              [-17.147658563008996, 11.837188533378017],
              [-17.148205431939093, 11.841158212749542],
              [-17.156499817037247, 11.852496710263695],
              [-17.156713373465028, 11.860615898936622],
              [-17.153536256512265, 11.866226280445982],
              [-17.156434412566608, 11.881293053986402],
              [-17.154769474329644, 11.883988038078355],
              [-17.158280836980758, 11.889610468078882],
              [-17.157383580671734, 11.893710933723872],
              [-17.159197092549874, 11.903511630666475],
              [-17.155735291070894, 11.905683822618753],
              [-17.153244993329192, 11.913615791452564],
              [-17.154819282074325, 11.921413460496888],
              [-17.151742215183987, 11.93137442630203],
              [-17.146672583567366, 11.939596776490278],
              [-17.142476842354274, 11.955772601188974],
              [-17.13713160084966, 11.963961340561207],
              [-17.131014403061442, 11.963695198169471],
              [-17.124674916109157, 11.965153829267816],
              [-17.11502572105282, 11.964612269318822],
              [-17.114663064543304, 11.9612624834203],
              [-17.107935636879738, 11.95694329811234],
              [-17.104265345016348, 11.956655005978678],
              [-17.09915064598939, 11.958773355136273],
              [-17.090265851778817, 11.970780273408735],
              [-17.084862211513837, 11.969179516513485],
              [-17.08418787673731, 11.965801852385848],
              [-17.081009172775765, 11.965162239831441],
              [-17.061530945426124, 11.948921330343989],
              [-17.055431873294868, 11.943283246985262]
            ]
          ],
          [
            [
              [-17.297587391756785, 11.986700366988325],
              [-17.28973711017921, 11.995375333201892],
              [-17.282904998796234, 12.00682159558893],
              [-17.27741700527937, 12.013794183253731],
              [-17.26464354150166, 12.024593984800957],
              [-17.25883169425427, 12.02807078620774],
              [-17.255167948290996, 12.032830312525586],
              [-17.251815007631695, 12.040513109666474],
              [-17.24591593870426, 12.049473665378187],
              [-17.237488829172744, 12.053561929769092],
              [-17.23288078761064, 12.05690182910469],
              [-17.225137558043862, 12.067008525557439],
              [-17.22106009027892, 12.06809089941928],
              [-17.216616913278223, 12.072296901554376],
              [-17.21292107361574, 12.077480666334447],
              [-17.20942334006597, 12.078964709121955],
              [-17.20056125696258, 12.087497226095861],
              [-17.19438159972509, 12.095859334936247],
              [-17.18936302516235, 12.104636761977872],
              [-17.18187342454628, 12.129412349821767],
              [-17.172747761031065, 12.128207181613533],
              [-17.16798613830933, 12.1295109377491],
              [-17.15968691816504, 12.124690258838863],
              [-17.156142992335376, 12.12114174606217],
              [-17.149733629379654, 12.12604476809088],
              [-17.14371813248914, 12.128805488328846],
              [-17.139187804811417, 12.12586221648525],
              [-17.136976971332942, 12.120929090585156],
              [-17.13839123519205, 12.112839318689991],
              [-17.135850516620764, 12.109882299369113],
              [-17.132300582336935, 12.109079587171978],
              [-17.13556534762567, 12.100272925166227],
              [-17.134724964095113, 12.089268940241114],
              [-17.13564861378524, 12.086290429144977],
              [-17.143577416288057, 12.079847992241541],
              [-17.15067984285816, 12.076353401853702],
              [-17.149201611609367, 12.072914191054604],
              [-17.143825118735215, 12.070143186130633],
              [-17.132549840679854, 12.061851559541058],
              [-17.125056048511297, 12.053623538022746],
              [-17.122345104093533, 12.046713618318831],
              [-17.11767037383474, 12.04160191491744],
              [-17.114170714553754, 12.033387874643795],
              [-17.1081702840427, 12.027004537483768],
              [-17.104926008695365, 12.015637691681743],
              [-17.10637495727101, 12.006300324866668],
              [-17.11208615383645, 12.001033611297563],
              [-17.12207050696694, 11.995711503616056],
              [-17.12821340843041, 11.994350081239908],
              [-17.14191061651015, 11.997251459160726],
              [-17.145982991857895, 11.99894774491251],
              [-17.153151998035785, 12.0139058222022],
              [-17.158256637291334, 12.01844838398965],
              [-17.168140337286978, 12.021544464805473],
              [-17.18149592583243, 12.021122706902474],
              [-17.188262967982624, 12.017816574129144],
              [-17.188562402351273, 12.014695781781848],
              [-17.1860353616893, 12.011110307906957],
              [-17.190120483980593, 12.007153036997527],
              [-17.19251103776973, 12.001285995851488],
              [-17.19705768196139, 11.998258035570636],
              [-17.20070766957976, 12.002795671148359],
              [-17.202719884437887, 12.008945445125248],
              [-17.201919074627952, 12.01222884647418],
              [-17.196352239264126, 12.010820732087318],
              [-17.19281047559176, 12.012694266569904],
              [-17.19442901301524, 12.019050020766516],
              [-17.198791750608823, 12.020596966486734],
              [-17.20158940363836, 12.018993276746503],
              [-17.20890084984073, 12.017862634898913],
              [-17.21460472240021, 12.013728459219793],
              [-17.21610617866049, 12.01032382490713],
              [-17.215109322532545, 12.006373335420381],
              [-17.211524815388007, 12.000257741766625],
              [-17.215471760935547, 11.987646317558713],
              [-17.22106618866212, 11.982199027540522],
              [-17.234647516221862, 11.980120143559777],
              [-17.237282968165655, 11.982460199620071],
              [-17.243022262129724, 11.982193048433805],
              [-17.252203113451348, 11.984467456068854],
              [-17.260365540226413, 11.98482338409875],
              [-17.269349441986098, 11.983688312299615],
              [-17.27276865870247, 11.981607811520739],
              [-17.273700765917475, 11.978527760409083],
              [-17.270667245026402, 11.974156425584896],
              [-17.272019272761998, 11.970703496025173],
              [-17.269880819000576, 11.964985836967543],
              [-17.263190706976534, 11.963415950714344],
              [-17.254732378658975, 11.965022109451873],
              [-17.249329919337267, 11.96770732463466],
              [-17.24578441773859, 11.967084178223262],
              [-17.240282285553704, 11.963821077116085],
              [-17.2367711617565, 11.965501179786962],
              [-17.227519748461393, 11.96251576397523],
              [-17.21916327854399, 11.963889407084565],
              [-17.218567949546134, 11.959736259259257],
              [-17.21228441193678, 11.95475284046041],
              [-17.207517061249273, 11.956150336279066],
              [-17.202696940489137, 11.944656178081441],
              [-17.20017929660327, 11.943372845502495],
              [-17.196745358818212, 11.93689410271552],
              [-17.198628510113082, 11.932750101336522],
              [-17.196817982704793, 11.926687405642117],
              [-17.193281528655795, 11.919823622478019],
              [-17.190980149927153, 11.911031074219226],
              [-17.192727106103277, 11.903360914720786],
              [-17.19201585493984, 11.896527026236477],
              [-17.19408682275087, 11.888946051678381],
              [-17.18991562108235, 11.882174688739227],
              [-17.18866506565802, 11.876349071905016],
              [-17.19198813480011, 11.861346882020552],
              [-17.190147774807343, 11.852369502642157],
              [-17.190422395154318, 11.845819646462594],
              [-17.193262925069387, 11.841811958009723],
              [-17.20294690467699, 11.836447143730943],
              [-17.203913456968046, 11.833720673786074],
              [-17.201436254800495, 11.822617879447026],
              [-17.199482363014795, 11.80748902405073],
              [-17.19450782847636, 11.804638440007702],
              [-17.197588717941624, 11.791897420274461],
              [-17.202263089640436, 11.784387819437496],
              [-17.196795004670363, 11.77931148791667],
              [-17.19768807249172, 11.771551451241699],
              [-17.201919909817445, 11.756446812669582],
              [-17.206609659397213, 11.751904449811361],
              [-17.205471528147136, 11.747248996573175],
              [-17.199152620287908, 11.745475594465862],
              [-17.19078855991402, 11.749552498695266],
              [-17.183844170378443, 11.760768627136075],
              [-17.180664911043202, 11.76420820463015],
              [-17.181341689141217, 11.770978542978144],
              [-17.179670233512297, 11.773877293440398],
              [-17.181093911264085, 11.77812648777498],
              [-17.17820425012548, 11.783026855737242],
              [-17.179455990674317, 11.787809136133],
              [-17.176064461838894, 11.790188778440793],
              [-17.171887620382346, 11.797635227321244],
              [-17.174082243451082, 11.804089510952041],
              [-17.17547433827694, 11.813268271355891],
              [-17.17537885952306, 11.820050992605262],
              [-17.167239309861564, 11.818778861160693],
              [-17.162521915667867, 11.815405514059353],
              [-17.15660097879645, 11.813802881794523],
              [-17.153778189503637, 11.811679786959747],
              [-17.151208881266466, 11.803383011051013],
              [-17.14644318077247, 11.792838021114816],
              [-17.14413244727423, 11.791620909293076],
              [-17.137000218242584, 11.766688397060689],
              [-17.135576115959793, 11.763642127665982],
              [-17.13125445481257, 11.759712038724206],
              [-17.128418711040545, 11.75487813967824],
              [-17.125070672749604, 11.752319088380812],
              [-17.11904940756237, 11.750727642302682],
              [-17.11362605432399, 11.746501357427658],
              [-17.112605215409562, 11.74211760260539],
              [-17.105714523988347, 11.739240056433847],
              [-17.10294697169635, 11.736688947497433],
              [-17.095617254626607, 11.735075198290586],
              [-17.096947043490207, 11.720898505001854],
              [-17.100001355469036, 11.71163784428915],
              [-17.10183992146655, 11.702355469248946],
              [-17.10165089250585, 11.697218636816322],
              [-17.09492283510587, 11.684418937585905],
              [-17.096422503784982, 11.669565714944797],
              [-17.098862448494042, 11.6595815991357],
              [-17.101115095799273, 11.654592728377354],
              [-17.107396597620983, 11.647544923346674],
              [-17.110651585347625, 11.64127636175136],
              [-17.115596538743944, 11.640133841265827],
              [-17.12608755043953, 11.6317242605137],
              [-17.129056674172045, 11.618962344075873],
              [-17.133815056220087, 11.613996173859158],
              [-17.13980843220219, 11.617359666510962],
              [-17.142487087880067, 11.6248827593647],
              [-17.13772780354011, 11.631080373075678],
              [-17.138570201149445, 11.633565691679923],
              [-17.14370363804144, 11.635112484533982],
              [-17.15212585756731, 11.6282088383854],
              [-17.156807103102537, 11.628604602847274],
              [-17.163737976839776, 11.63317660946429],
              [-17.162720505577656, 11.635847803833446],
              [-17.168925353025767, 11.6502837176384],
              [-17.16745619585936, 11.655898762728972],
              [-17.162628781016178, 11.66147432737952],
              [-17.15994523756632, 11.669614297163383],
              [-17.160708584229983, 11.681253469991612],
              [-17.16405867207806, 11.69078028752941],
              [-17.167049274038927, 11.695884114003784],
              [-17.169676062207238, 11.703787239532518],
              [-17.168905731591348, 11.707442205019989],
              [-17.17430267969692, 11.711983720551673],
              [-17.179968609974527, 11.713496161349683],
              [-17.189598064020394, 11.713521056571777],
              [-17.20001418885525, 11.710444349495248],
              [-17.20364255316623, 11.705162216453477],
              [-17.206398244842216, 11.70399656648662],
              [-17.224593271972896, 11.703262160391768],
              [-17.22644567095436, 11.708984925520497],
              [-17.224553077974008, 11.713486895868073],
              [-17.217021563135127, 11.720097676259764],
              [-17.214131429122574, 11.726372916461706],
              [-17.216048530092202, 11.734264305975236],
              [-17.22240711279023, 11.742338543099269],
              [-17.235455356432677, 11.749929473236149],
              [-17.237741050654286, 11.757219027649302],
              [-17.240542777175317, 11.761049601606556],
              [-17.24089366347249, 11.766990754522592],
              [-17.246382743771907, 11.773818064444514],
              [-17.237393208724804, 11.779209175124999],
              [-17.23305111550901, 11.78643700052282],
              [-17.23139726223934, 11.795179948521326],
              [-17.23623794204098, 11.804522608366534],
              [-17.235624888467523, 11.807350245344459],
              [-17.23889929770707, 11.811208269044847],
              [-17.239262592745824, 11.814024834017438],
              [-17.236902335871562, 11.820122792795749],
              [-17.23072258830372, 11.827015439217915],
              [-17.226688104174656, 11.834579063532995],
              [-17.21871745044389, 11.846435731093585],
              [-17.21443711821375, 11.870095606388164],
              [-17.213962962726537, 11.878973860966518],
              [-17.215641296251924, 11.891278821490229],
              [-17.221521523374623, 11.898878695949296],
              [-17.226849551948387, 11.901879443903603],
              [-17.234994248142883, 11.904936540809176],
              [-17.24851963209818, 11.904745187514951],
              [-17.257563953320485, 11.901219024569768],
              [-17.259092426174824, 11.902724136144425],
              [-17.259572167094323, 11.909456275193941],
              [-17.25830881729165, 11.91630487838955],
              [-17.25829843505602, 11.922220964087543],
              [-17.26059045552355, 11.929786690391365],
              [-17.264617814478115, 11.934753282489117],
              [-17.269184447231105, 11.94438728102347],
              [-17.282628010638035, 11.954635146798376],
              [-17.284321871816513, 11.96228466121801],
              [-17.286154335889023, 11.965406215968946],
              [-17.296493787852846, 11.974074656472194],
              [-17.29852420663646, 11.983784140659566],
              [-17.297587391756785, 11.986700366988325]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.54803198999164,
          "lat": 48.16284329370142
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53029"],
        "coty_name": ["Island"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Island County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01513272"
      },
      "bbox": [
        -17.29852420663646, 11.613996173859158, -17.051306394454553,
        12.1295109377491
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.303881806925551, 0.7815650682499654],
            [12.343833338935974, 0.8427608436427996],
            [12.39305860401671, 0.9178695297489537],
            [12.416838734776013, 1.0175741119869999],
            [12.421743838321019, 1.0156678713635046],
            [12.421198406926466, 1.0125736521669964],
            [12.425455085289533, 1.0122212941384645],
            [12.428075840049953, 1.0068214910164113],
            [12.431511099218321, 1.0088653286750133],
            [12.435491845601943, 1.0068020536057192],
            [12.436999979262668, 1.011147370414886],
            [12.441575119059827, 1.013304396727187],
            [12.444472335280281, 1.010701268906343],
            [12.449016982335715, 1.0130471449370124],
            [12.452932811532563, 1.0125294426877178],
            [12.453247335175844, 1.0094368728120748],
            [12.458484071552222, 1.011679918291311],
            [12.459970899795925, 1.014869131540125],
            [12.464605703749491, 1.0154156235610785],
            [12.467735113139035, 1.0141206764207842],
            [12.47179980418143, 1.0176769745903964],
            [12.483078187338394, 1.0196996191183707],
            [12.485489395616206, 1.0228801915902288],
            [12.48854629336638, 1.0209252544013034],
            [12.497695358294306, 1.0221547562592068],
            [12.502803037525, 1.0178023489346832],
            [12.505666600827775, 1.0130106671613501],
            [12.514154089832045, 1.0142938281105178],
            [12.517130069304315, 1.011463646074008],
            [12.51566582586125, 1.0075285024469907],
            [12.516032849363405, 1.0031139962784574],
            [12.51940773613919, 0.9955204479452343],
            [12.524788468929367, 0.9926994839485185],
            [12.529490033818139, 0.9883789504217217],
            [12.528860793476358, 0.9828251751801836],
            [12.531935360623601, 0.9804947597586348],
            [12.541928464044817, 0.9824948798464892],
            [12.545427594237587, 0.985758622916504],
            [12.553737026746697, 0.9911390335031126],
            [12.55605977072208, 0.9949994197346185],
            [12.559297360537155, 0.9958754122024958],
            [12.60120581206376, 0.9313502331809929],
            [12.66092722412786, 0.8393957371553248],
            [12.640491810788633, 0.7170956015506171],
            [12.636683352159507, 0.695146738968675],
            [12.617775642467238, 0.6741021108376694],
            [12.580530622933209, 0.631831680673128],
            [12.562161193284057, 0.638582823756502],
            [12.575892471777163, 0.5185525426387397],
            [12.51037605080728, 0.5501657588546301],
            [12.458133234828331, 0.5749631696308852],
            [12.456319549957788, 0.5755939172256039],
            [12.362744801614301, 0.6194855363033863],
            [12.358940783742632, 0.6272589195399819],
            [12.351206736345379, 0.6131144020451241],
            [12.341766752566562, 0.6327687069434564],
            [12.34057022114526, 0.632774094209519],
            [12.314070617720162, 0.6665199278457222],
            [12.328215139143827, 0.6807556957747495],
            [12.289107215769933, 0.7520657593271401],
            [12.286592861597644, 0.7551226537987925],
            [12.303881806925551, 0.7815650682499654]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.42187424340021, "lat": 38.49474830359055 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54101"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01550057"
      },
      "bbox": [
        12.286592861597644, 0.5185525426387397, 12.66092722412786,
        1.0228801915902288
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.954008819959456, 4.2881043372322],
            [4.951344540436659, 4.331753613826223],
            [4.990079116437949, 4.334180581363361],
            [5.037363078505715, 4.3377195489805676],
            [5.106396197412761, 4.342100013242856],
            [5.169494402530435, 4.345466716240235],
            [5.207645565745352, 4.34779716535784],
            [5.278261111011625, 4.352480869724223],
            [5.2925142566004535, 4.353752033374882],
            [5.293273151183171, 4.34230826916182],
            [5.298542189715421, 4.267443431243972],
            [5.305720192272434, 4.180871130829907],
            [5.313425843335089, 4.081160501380421],
            [5.319887838640564, 3.997348768855447],
            [5.2938461824206815, 3.99571102311372],
            [5.205222094822162, 3.991085089840908],
            [5.174573707125783, 3.9897485655295193],
            [5.138669084862254, 3.9886510572487786],
            [5.098996148152486, 3.987023280048339],
            [5.044295700418984, 3.983828385477697],
            [5.024382809150973, 3.982461099354681],
            [4.974702941863809, 3.9794474197184595],
            [4.967551529710886, 4.089445941960447],
            [4.967186445785692, 4.092104693807571],
            [4.963385181910031, 4.157384316013191],
            [4.958026075805982, 4.229934314067496],
            [4.956729080760781, 4.244577686115869],
            [4.954008819959456, 4.2881043372322]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.6022208861189, "lat": 42.679973540157334 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55045"],
        "coty_name": ["Green"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Green County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01581082"
      },
      "bbox": [
        4.951344540436659, 3.9794474197184595, 5.319887838640564,
        4.353752033374882
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.356965647140383, 5.488720255368903],
            [5.385829919729591, 5.491147694705591],
            [5.465748400622617, 5.497152791609399],
            [5.5300450925618545, 5.501920394672204],
            [5.558858011438378, 5.503889622144978],
            [5.565822083160778, 5.416181501543163],
            [5.568137049776349, 5.388384534999925],
            [5.572360408912969, 5.329311970145038],
            [5.576476465811658, 5.278578218937632],
            [5.580612852329469, 5.224403655217048],
            [5.585214616248605, 5.155284594389146],
            [5.521443775096824, 5.149969806621175],
            [5.498446039585765, 5.148362837083937],
            [5.476946267389076, 5.146705587604688],
            [5.4368008438081645, 5.142723623201474],
            [5.41206868441783, 5.14075123176196],
            [5.4113807290189495, 5.152683076162067],
            [5.381259470421937, 5.150134402277796],
            [5.326252851112729, 5.146005614240554],
            [5.3227994319354375, 5.195046553907006],
            [5.319899672442611, 5.2333408133554435],
            [5.317973139886136, 5.262459307740185],
            [5.3191864343924635, 5.26604286048075],
            [5.324248558958131, 5.270841792241816],
            [5.330251121497832, 5.27146263862703],
            [5.3341490774313165, 5.270032646829294],
            [5.344037197266869, 5.270034004357942],
            [5.356573525421042, 5.271492085562976],
            [5.3606854818741905, 5.270424697527702],
            [5.367968823411312, 5.272722378893579],
            [5.373375379159612, 5.272132437139683],
            [5.369842995612277, 5.316582225929349],
            [5.363669302317197, 5.314563227801202],
            [5.358092105195238, 5.309925285526278],
            [5.352588986797107, 5.310460080735111],
            [5.34827710407113, 5.316520825451627],
            [5.350606812898182, 5.319969662569848],
            [5.347775827304455, 5.322862562170107],
            [5.343351000928361, 5.381226319049045],
            [5.36498480528699, 5.382731680368602],
            [5.362878075610968, 5.408198457002395],
            [5.3624156897148305, 5.423027246470537],
            [5.3616509637668806, 5.430038897101583],
            [5.357206521820066, 5.488410973353978],
            [5.356965647140383, 5.488720255368903]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.0448729456651, "lat": 43.80040019124236 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55047"],
        "coty_name": ["Green Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Green Lake County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01581083"
      },
      "bbox": [
        5.317973139886136, 5.14075123176196, 5.585214616248605,
        5.503889622144978
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.070936383394703, 6.9507706998030745],
            [5.127096104064537, 6.957492339079374],
            [5.19481362147267, 6.960848341557369],
            [5.216953521938813, 6.961735244611858],
            [5.231476459267302, 6.96320347295883],
            [5.246266642831899, 6.9640470319352845],
            [5.3208805319693555, 6.9668242130657125],
            [5.335772421049259, 6.966798113840051],
            [5.349819261156049, 6.967744869937184],
            [5.376860985149041, 6.970423138776142],
            [5.422042819759888, 6.973825025501671],
            [5.422873321996796, 6.961089550782169],
            [5.4248715101784795, 6.915719469362185],
            [5.424997076105571, 6.90179000579508],
            [5.426404211332889, 6.888023192411407],
            [5.5128995660843305, 6.894058094229232],
            [5.60006398754026, 6.901150797222159],
            [5.606760761573181, 6.803928953084591],
            [5.611986008858865, 6.728992535975076],
            [5.641404516096555, 6.731075134735411],
            [5.645834750501162, 6.654968963805388],
            [5.646081071966268, 6.644221515685015],
            [5.544567734822058, 6.636786028035529],
            [5.442628657429475, 6.629315407865677],
            [5.406124977595267, 6.626810790481437],
            [5.413252825596827, 6.538498453127076],
            [5.3846162305536245, 6.536930510682186],
            [5.3223984140777265, 6.532465004533488],
            [5.24276439623033, 6.5265130521113575],
            [5.23611313675531, 6.6151021882648475],
            [5.150426139726013, 6.609187269685643],
            [5.094203556861098, 6.605715141270556],
            [5.091743506655381, 6.6410582928982524],
            [5.08864335458932, 6.6920098447887915],
            [5.087633001658599, 6.705885834359035],
            [5.083040460405244, 6.778389106909615],
            [5.077324010243829, 6.864700102160119],
            [5.070936383394703, 6.9507706998030745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.0718878020354, "lat": 45.262312764373576 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55067"],
        "coty_name": ["Langlade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Langlade County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01581093"
      },
      "bbox": [
        5.070936383394703, 6.5265130521113575, 5.646081071966268,
        6.973825025501671
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.082292051125343, 5.9212383964391035],
            [3.134505526264067, 5.922126750533487],
            [3.1966600507601153, 5.924261167175772],
            [3.2108150718859885, 5.924933280798606],
            [3.2090640350045954, 5.978032466562018],
            [3.205058952414355, 6.069149858075777],
            [3.280775631201363, 6.07179777420801],
            [3.337286922375668, 6.074073188558296],
            [3.3769322011088305, 6.075851022879076],
            [3.4149786114657537, 6.077326092258098],
            [3.548766133622383, 6.083189524510723],
            [3.5528345188296893, 5.996591846296177],
            [3.5134872324594006, 5.99494982090092],
            [3.4880631455028333, 5.993613800773133],
            [3.3946262442718664, 5.989470964972135],
            [3.32983758687708, 5.986786216530901],
            [3.3023609111900307, 5.985831338443485],
            [3.2960654541347814, 5.980588481930412],
            [3.290642724918315, 5.979978154965783],
            [3.28432332809416, 5.974560722855578],
            [3.2814491511676827, 5.96015392995772],
            [3.2778587043172256, 5.952258743860975],
            [3.279107210473336, 5.94436950366639],
            [3.2791092672577586, 5.93510605916315],
            [3.277930130796289, 5.929979685408102],
            [3.2743339196516263, 5.922404903569482],
            [3.2736081587221744, 5.91496581542462],
            [3.2767389239000386, 5.908582405606551],
            [3.27694669607103, 5.900491869812837],
            [3.2732669412045308, 5.890797879806625],
            [3.2718385780881456, 5.88249935938647],
            [3.269251713877791, 5.876777907843019],
            [3.266989661731136, 5.861751692709601],
            [3.2679149406793337, 5.854117478113472],
            [3.2648306540613494, 5.846734915651749],
            [3.2579987803159716, 5.82458657017983],
            [3.2547910625429375, 5.820458328985061],
            [3.253258725487808, 5.811739390416129],
            [3.2549814848585306, 5.806760097203611],
            [3.2527138031636915, 5.799292542701564],
            [3.2530578627280695, 5.794502807460532],
            [3.243076431641813, 5.79836276804366],
            [3.2332445091044812, 5.800441746058904],
            [3.2233531887950346, 5.808193663854813],
            [3.212534036722344, 5.8103092684196636],
            [3.1961452042607132, 5.812179499684616],
            [3.1724510720184047, 5.8178044168918035],
            [3.158184497118737, 5.82194049761332],
            [3.145593195751448, 5.828361654464099],
            [3.138457695114488, 5.836885009163831],
            [3.1332262227849466, 5.841939908934185],
            [3.1234692669559636, 5.847172146129064],
            [3.1129587422733582, 5.855245871404218],
            [3.102382927498955, 5.866626965609311],
            [3.09383350764809, 5.881100472875928],
            [3.093174399600325, 5.884371379296663],
            [3.093023833958534, 5.897225469791879],
            [3.092139749577555, 5.900519384012494],
            [3.086604097845949, 5.909220714865779],
            [3.0839390600522116, 5.918356153149307],
            [3.082292051125343, 5.9212383964391035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.00150727091115, "lat": 44.58294475052688 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55091"],
        "coty_name": ["Pepin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pepin County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01581106"
      },
      "bbox": [
        3.082292051125343, 5.794502807460532, 3.5528345188296893,
        6.083189524510723
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.16106217115271,
          "lat": 18.173814203880077
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72041"],
        "coty_name": ["Cidra"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Cidra Municipio"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01804500"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.441450500661, "lat": 18.12332757101171 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72147"],
        "coty_name": ["Vieques"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Vieques Municipio"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01804554"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -64.92999470642827,
          "lat": 18.345262678959163
        },
        "year": "2023",
        "ste_code": ["78"],
        "ste_name": ["United States Virgin Islands"],
        "coty_code": ["78030"],
        "coty_name": ["St. Thomas"],
        "coty_area_code": "VIR",
        "coty_type": "island",
        "coty_name_long": ["St. Thomas Island"],
        "coty_fp_code": "030",
        "coty_gnis_code": "02378250"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7948331644479925, 1.899926078240064],
            [1.909264252654974, 1.903144913248134],
            [1.9579760623949924, 1.9051685117877724],
            [1.9968261133907879, 1.9068369609287636],
            [2.046134741381181, 1.9091774341921868],
            [2.139430247470023, 1.9128870946434975],
            [2.1407080289132834, 1.8591735383536223],
            [2.140838367478982, 1.8374601748911905],
            [2.1417623081414296, 1.806812676505308],
            [2.149089832414509, 1.8071509870498843],
            [2.1519692286052416, 1.7088668319518885],
            [2.152588488863404, 1.6993117120055554],
            [2.154349836185406, 1.6258209246995947],
            [2.155170325936059, 1.596949236518017],
            [2.1559003525969156, 1.5670705533892089],
            [2.1577545837161822, 1.46476024335573],
            [2.071496506608577, 1.4634266540992331],
            [1.9864750835338087, 1.462023766650068],
            [1.9004040760774104, 1.4609333902667667],
            [1.814775533254694, 1.4612597099661786],
            [1.813732168982237, 1.5346662932539823],
            [1.8133763791166126, 1.5420855161627345],
            [1.8123231051871256, 1.6227143221044233],
            [1.811913211795395, 1.711002427058981],
            [1.8114787055360833, 1.7363641669277923],
            [1.8100221374523955, 1.7979133170515524],
            [1.7972473487698393, 1.7975666653610312],
            [1.7948331644479925, 1.899926078240064]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.99205494070357, "lat": 40.35464135909456 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29081"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00758495"
      },
      "bbox": [
        1.7948331644479925, 1.4609333902667667, 2.1577545837161822,
        1.9128870946434975
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.007017012604376, -1.6593180488708628],
            [5.020272115970768, -1.6587541362407854],
            [5.01954214433824, -1.644503322659531],
            [5.033806397245486, -1.6438281424161512],
            [5.03250208871245, -1.614692622879999],
            [5.046596294425047, -1.6139319806056158],
            [5.045950943281852, -1.5995874813553337],
            [5.060414101753996, -1.5987985183151574],
            [5.059706550471389, -1.584015724132725],
            [5.0738220022332, -1.5833019043145329],
            [5.073390371383063, -1.56871026721493],
            [5.087949362083546, -1.5680240090660336],
            [5.086569146925836, -1.5337306737713854],
            [5.101475736969444, -1.5326498188247295],
            [5.1159929568988165, -1.5321493755870768],
            [5.207211516658164, -1.5275441547036708],
            [5.206175188968249, -1.512819406839402],
            [5.235112113749121, -1.5113420191153717],
            [5.230140819048906, -1.4379545873154016],
            [5.303449379667156, -1.4342904763803928],
            [5.341728263346542, -1.4319675984027678],
            [5.383371277368619, -1.4292474332757175],
            [5.383585118678879, -1.4367889361833661],
            [5.376755829035657, -1.4527080886670014],
            [5.377937081399048, -1.4587313842728031],
            [5.374848857228821, -1.460879056529055],
            [5.368868040439019, -1.4688826625033615],
            [5.369906450155364, -1.4732655045629346],
            [5.37654261015791, -1.4803931850422785],
            [5.376107096070493, -1.4843060529907388],
            [5.384271942106851, -1.4966596952628324],
            [5.383948949824009, -1.499617385845208],
            [5.387403631417698, -1.5052180895307363],
            [5.393565508182865, -1.5048425930484846],
            [5.395673508711594, -1.5110675843318526],
            [5.394555566494098, -1.517254810913867],
            [5.3995575610565485, -1.5195345505958044],
            [5.398693521516369, -1.525521004021512],
            [5.404822862997984, -1.527282184888478],
            [5.404820194977695, -1.5317017413462313],
            [5.408688254790356, -1.5379277431433975],
            [5.414346093488585, -1.5439788394844423],
            [5.413431611647035, -1.54752286791264],
            [5.419599782852224, -1.5531120553650046],
            [5.424935746429393, -1.5627401847300504],
            [5.428253809274474, -1.5671272430562255],
            [5.427060852271493, -1.5783581009425227],
            [5.430317337112024, -1.5829423345695903],
            [5.433298191622771, -1.592913757261592],
            [5.434629593773166, -1.6018168571098648],
            [5.440066190768595, -1.6064323313358388],
            [5.444221600345081, -1.605814958803464],
            [5.446917156329256, -1.6079656255576988],
            [5.449356266854681, -1.6128572031732615],
            [5.453274433570995, -1.6121863201878204],
            [5.453341204140131, -1.6174862055315495],
            [5.45850203308143, -1.624587828377804],
            [5.45634852782105, -1.6270331629642798],
            [5.459007431416643, -1.6341138629119565],
            [5.459139963238181, -1.6387528440653862],
            [5.455818776833879, -1.6427292376378038],
            [5.456296129347862, -1.6462791693245187],
            [5.454815323859735, -1.6535660946885509],
            [5.457191177555152, -1.6576968881075662],
            [5.457141770579144, -1.6608812370343577],
            [5.461264892387497, -1.6659001735202696],
            [5.457724346243504, -1.6696655167756687],
            [5.4537167417518, -1.6794443909693533],
            [5.456780213104658, -1.683613456290691],
            [5.459217905863924, -1.693856224793452],
            [5.448772210384546, -1.694784183751618],
            [5.455670641070982, -1.7679726913620826],
            [5.4604708584528145, -1.814382538442909],
            [5.4585124963092335, -1.815713900213036],
            [5.463169424696143, -1.868713662341427],
            [5.4651285192290615, -1.8979638881309473],
            [5.465602356084383, -1.8997506775264401],
            [5.467342100340004, -1.9280104456541451],
            [5.380579377131148, -1.9336318019300969],
            [5.365979173516719, -1.9347448104455347],
            [5.294394379726317, -1.938485043900327],
            [5.262694939809697, -1.9394081571661748],
            [5.236047473042841, -1.9408053329547474],
            [5.163631510089597, -1.9442645121528854],
            [5.120456242598313, -1.9464200622053243],
            [5.112184136259841, -1.9474922273194082],
            [5.112738166017129, -1.9449318397250477],
            [5.119072633649509, -1.9352398021152148],
            [5.1179918502693935, -1.9293450746535723],
            [5.112016437455114, -1.9218242710165339],
            [5.119200640611059, -1.9181764963543704],
            [5.119063089397486, -1.909909406054233],
            [5.108696637176865, -1.9006929574280351],
            [5.1082234083751885, -1.893561538216523],
            [5.111942974850963, -1.8906967360301616],
            [5.114533291357406, -1.884047590464908],
            [5.113443340160591, -1.8791155738970444],
            [5.106080449345207, -1.8780367648105727],
            [5.102785645927632, -1.8668550595528892],
            [5.1043054570423045, -1.8613497097447105],
            [5.100872246305001, -1.8618936573853133],
            [5.098801019029022, -1.8549856498652357],
            [5.092714944802446, -1.8463397555595824],
            [5.094618763107631, -1.8439328671512762],
            [5.089997509084149, -1.841115050746075],
            [5.089088921778209, -1.8379771103728968],
            [5.082577770163021, -1.8365143483308828],
            [5.085807045567791, -1.830946884457336],
            [5.083599413723976, -1.827250624485988],
            [5.078571509231085, -1.8248311608484304],
            [5.0751936925179795, -1.8170420384127646],
            [5.070366995577091, -1.8148806902037853],
            [5.072104235065949, -1.8095252627781087],
            [5.07089616438566, -1.8071009787480827],
            [5.065513602300464, -1.8099646865298011],
            [5.063573196399439, -1.806258610082958],
            [5.059194272389119, -1.8075844865749986],
            [5.0580801958187, -1.8047134866594194],
            [5.061430107260778, -1.8024455594571778],
            [5.0618449022192, -1.7924850165257624],
            [5.059250496480387, -1.7873527699701304],
            [5.059739345719739, -1.7806976938948966],
            [5.057632824144398, -1.7779387902738903],
            [5.062214805779662, -1.7751678288932258],
            [5.058093386839538, -1.7707040537823673],
            [5.054174814635699, -1.77179342636452],
            [5.0538633592170665, -1.7682141606093256],
            [5.047017556408157, -1.7655275030746207],
            [5.049119272856883, -1.7588408969314688],
            [5.0422959233807285, -1.760014627510866],
            [5.045310159501411, -1.75357083647237],
            [5.039496165234329, -1.747987794465828],
            [5.045267631016505, -1.737106499361678],
            [5.038296440189064, -1.7336007679320582],
            [5.034151894700999, -1.7303959034499068],
            [5.027724563531423, -1.7180853009335553],
            [5.022853657418555, -1.7159845231793558],
            [5.021108899739164, -1.7125576398124065],
            [5.017898851489379, -1.713987607185239],
            [5.01439459988409, -1.7119248608191933],
            [5.014065031216218, -1.7048188808967943],
            [5.015675507727219, -1.7001291642014886],
            [5.014326616091225, -1.693597426523676],
            [5.015959589314447, -1.691458230350717],
            [5.016339742441081, -1.6834851195373552],
            [5.01260371068975, -1.682184555825016],
            [5.0127873914169, -1.6780249802127638],
            [5.009059231938395, -1.6721819985953397],
            [5.006570131186502, -1.6624076609605205],
            [5.007017012604376, -1.6593180488708628]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.9443288449729, "lat": 36.855643591529955 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29207"],
        "coty_name": ["Stoddard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stoddard County"],
        "coty_fp_code": "207",
        "coty_gnis_code": "00758556"
      },
      "bbox": [
        5.006570131186502, -1.9474922273194082, 5.467342100340004,
        -1.4292474332757175
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.935603540685324, 9.828279638196465],
            [-9.872279598695794, 9.817925702987685],
            [-9.80895791158064, 9.80755843039874],
            [-9.727453041311433, 9.795226535313388],
            [-9.645951344129529, 9.782872616879468],
            [-9.649869717856932, 9.779630315900937],
            [-9.652375419555147, 9.774679601291998],
            [-9.65359482497044, 9.767384039733184],
            [-9.655627074545627, 9.765936761475745],
            [-9.661482319214393, 9.765965703283719],
            [-9.668877269257884, 9.756480082771853],
            [-9.668746197485731, 9.750803048424656],
            [-9.671810510220421, 9.747193913090493],
            [-9.6797673341445, 9.744853306996129],
            [-9.684095786696703, 9.73890372160803],
            [-9.686029090562752, 9.732241716771062],
            [-9.689648464160781, 9.725976163185836],
            [-9.697994040419866, 9.719350184559197],
            [-9.701282647432253, 9.714165451903018],
            [-9.702178420403243, 9.708530813412022],
            [-9.707428014194507, 9.704594174015009],
            [-9.707839370864235, 9.69971175026478],
            [-9.710993845469286, 9.693572413773483],
            [-9.707599475829594, 9.692775477910262],
            [-9.708050965086548, 9.68641667929111],
            [-9.705143155933742, 9.683184954585693],
            [-9.702384803737951, 9.68403317861298],
            [-9.69995233559192, 9.680547267178026],
            [-9.700480941263528, 9.67605142575796],
            [-9.69736734058017, 9.675192178299088],
            [-9.683301958520792, 9.66350700108795],
            [-9.677660293780699, 9.665345821093192],
            [-9.66782149838133, 9.66233211266874],
            [-9.664542811586163, 9.66251457577336],
            [-9.661466271278384, 9.659329867615206],
            [-9.661951844079782, 9.65590173287501],
            [-9.659682335375875, 9.651298525459646],
            [-9.651541173186128, 9.644422269099596],
            [-9.650805666548594, 9.639271790891451],
            [-9.645287260465919, 9.63975776557893],
            [-9.642983377316376, 9.637628710223925],
            [-9.643248418312828, 9.631892802078665],
            [-9.635322171154348, 9.630424909941157],
            [-9.634491132348789, 9.626715303260468],
            [-9.630549083050632, 9.629214905287622],
            [-9.625193944256814, 9.627511894059129],
            [-9.624014262034427, 9.624222115760627],
            [-9.612579380757404, 9.626332340153809],
            [-9.611452897459143, 9.620125859343787],
            [-9.607704841376604, 9.624036357900227],
            [-9.606601579397733, 9.619932871964826],
            [-9.598242215175096, 9.616354620869677],
            [-9.599772994312726, 9.614190939680814],
            [-9.599021322456272, 9.609208972380713],
            [-9.595432863420207, 9.602628566857193],
            [-9.533484558185831, 9.593814338047016],
            [-9.546163074689208, 9.516880601465685],
            [-9.459711923027264, 9.503791011110158],
            [-9.459167092613567, 9.502833698047633],
            [-9.463559561004407, 9.474798449855172],
            [-9.471885242244689, 9.419062519520242],
            [-9.558192744807032, 9.432435194809338],
            [-9.567678841233047, 9.372282486717566],
            [-9.571293158318513, 9.37292457134904],
            [-9.569567439089884, 9.383347517420095],
            [-9.580349555518948, 9.384949743323928],
            [-9.589239875909543, 9.32801108942519],
            [-9.582001776744868, 9.326856376047568],
            [-9.584305739513983, 9.312786620774688],
            [-9.57700482289692, 9.31162097890841],
            [-9.585037491981772, 9.262520521021827],
            [-9.588966049977897, 9.263119015371686],
            [-9.593697306321195, 9.229098319882768],
            [-9.601021959316183, 9.178188317609223],
            [-9.602341004671974, 9.177774885021519],
            [-9.51629971776367, 9.164468784817513],
            [-9.529241461848075, 9.081746185249985],
            [-9.526291089535842, 9.081286784791287],
            [-9.539677515548004, 8.997036905759098],
            [-9.536502451886438, 8.996546062315392],
            [-9.549833705883778, 8.912217660200515],
            [-9.561051609438561, 8.913939920840587],
            [-9.56310007214014, 8.900775891188996],
            [-9.566803595637259, 8.896636391962284],
            [-9.570738351960852, 8.897383218743528],
            [-9.580604754594953, 8.90460901934052],
            [-9.584641055563377, 8.916553185584972],
            [-9.589540739116964, 8.921095291635245],
            [-9.590651231875514, 8.926330636111517],
            [-9.59784174629683, 8.923717286078128],
            [-9.602522157093173, 8.924649857322054],
            [-9.60421501866507, 8.92159094631072],
            [-9.609117743991098, 8.923356890811606],
            [-9.608842683296409, 8.928535340220423],
            [-9.61564330229905, 8.933608857431254],
            [-9.626526390985317, 8.931318941002534],
            [-9.6301159630194, 8.936229476427325],
            [-9.624927352676448, 8.94607486295512],
            [-9.625219372425246, 8.959369457676706],
            [-9.628816879141935, 8.959065495356883],
            [-9.62829341044637, 8.964441605776045],
            [-9.625554242233521, 8.965767312667259],
            [-9.628321129893434, 8.969526454692858],
            [-9.621440529064571, 8.973472273587882],
            [-9.620623496975059, 8.975906510435308],
            [-9.625130867348796, 8.982986617315463],
            [-9.631336431860582, 8.984660368246713],
            [-9.639650335805989, 8.990326708302026],
            [-9.63779378753909, 8.99760679446756],
            [-9.64296831146213, 8.99919977346936],
            [-9.647212872941463, 8.994607438712798],
            [-9.65026628131837, 8.99586527068178],
            [-9.654625632793179, 8.99270961286196],
            [-9.661140417546282, 9.00240441744447],
            [-9.661108024206982, 9.005636704798496],
            [-9.665817537650874, 9.00748094712062],
            [-9.671705757159799, 9.006476456539067],
            [-9.674786149295015, 9.012179590272721],
            [-9.67886635022754, 9.014922479090663],
            [-9.682803000062462, 9.015655337626026],
            [-9.686464182515131, 9.018479873465887],
            [-9.685464557197397, 9.023290623619669],
            [-9.681833650352614, 9.031664357941889],
            [-9.68214163494576, 9.038009975556323],
            [-9.684029397171837, 9.041362490720518],
            [-9.692488021156352, 9.041572942100606],
            [-9.69309231157608, 9.046772217106895],
            [-9.698502861509269, 9.054222448810169],
            [-9.701077621106572, 9.055414216625053],
            [-9.702942511907885, 9.0638763647194],
            [-9.709750490389595, 9.068366476625455],
            [-9.712988423310941, 9.072237988717914],
            [-9.715255600038297, 9.080567811543206],
            [-9.722945025002877, 9.08634748068629],
            [-9.72559033393706, 9.086440689796017],
            [-9.732231723133022, 9.09000952024701],
            [-9.734296880874496, 9.093154123150464],
            [-9.740000336949938, 9.09538176166613],
            [-9.74851245544298, 9.1041526091566],
            [-9.756635361777827, 9.107815067162836],
            [-9.764324057567976, 9.105210435703304],
            [-9.76900807238103, 9.10783602134535],
            [-9.767461579106511, 9.113145177654092],
            [-9.775056507234313, 9.114152638392996],
            [-9.779536428275879, 9.112761211466195],
            [-9.785963887903202, 9.114942794674137],
            [-9.790283513020864, 9.11831380500993],
            [-9.797478637874447, 9.11925304193269],
            [-9.80119241274736, 9.117755301048645],
            [-9.806872287966227, 9.123323432398307],
            [-9.819094026158242, 9.121861368289935],
            [-9.82643807205301, 9.12794799712672],
            [-9.828807218808842, 9.132911491030432],
            [-9.831518770030765, 9.134786245014014],
            [-9.834785151244224, 9.139862900449042],
            [-9.834528476987616, 9.144804220430395],
            [-9.835886227378813, 9.14840457573718],
            [-9.8306400100698, 9.152760394036363],
            [-9.824029053782203, 9.15460600717772],
            [-9.81592536175694, 9.160788629924289],
            [-9.815676279049638, 9.167909348613007],
            [-9.817064259971632, 9.171143371839824],
            [-9.817762425446737, 9.179422179216413],
            [-9.815684542198115, 9.183452588312504],
            [-9.816409454230687, 9.18797244649022],
            [-9.810182735372466, 9.193775716548465],
            [-9.811986006555312, 9.202698299425986],
            [-9.858709625216587, 9.210044130285223],
            [-9.864397949785435, 9.211265439456644],
            [-9.87637687113607, 9.137011915246534],
            [-9.962147021813502, 9.150666232703683],
            [-9.963896238692845, 9.140274047789278],
            [-10.049840382056342, 9.153934705470258],
            [-10.135788183226463, 9.167571912314608],
            [-10.149808683666635, 9.082997633493061],
            [-10.230289877195576, 9.096210645879344],
            [-10.314035680639442, 9.11016917598542],
            [-10.31962865633886, 9.111279353817828],
            [-10.290123534263754, 9.284942403446538],
            [-10.289431386223926, 9.284826871094877],
            [-10.283568058890353, 9.319646338343329],
            [-10.34133767326698, 9.32896528097418],
            [-10.342240317284043, 9.321883985275075],
            [-10.357042045047287, 9.324237705049985],
            [-10.354597785556065, 9.338227858752388],
            [-10.370685747614436, 9.340862239261936],
            [-10.3761561212636, 9.349894671786473],
            [-10.379139408917657, 9.34785094394502],
            [-10.38420823456479, 9.350974639962232],
            [-10.389965318688786, 9.365567698188029],
            [-10.393615197302847, 9.365044080056073],
            [-10.39654411292877, 9.368139458529892],
            [-10.393166499316942, 9.377810601099753],
            [-10.395591569619443, 9.38281252094622],
            [-10.399443238738243, 9.380675662846652],
            [-10.404203031513426, 9.384346559551307],
            [-10.401247346216538, 9.393994509970346],
            [-10.41309360245133, 9.39470883767563],
            [-10.41496805827761, 9.390279545163546],
            [-10.417768793200741, 9.392436488931343],
            [-10.424819595507447, 9.394181644595784],
            [-10.423170068513583, 9.39810587493922],
            [-10.425020083509322, 9.402610229301583],
            [-10.42104263780458, 9.404111951716992],
            [-10.422060756832714, 9.408882636404305],
            [-10.425731380705322, 9.407760598841397],
            [-10.431221184378268, 9.414157100120121],
            [-10.439135328546843, 9.410017691843137],
            [-10.445210025234989, 9.410110056156029],
            [-10.43437660067848, 9.473276153211897],
            [-10.419474845683935, 9.562524420469618],
            [-10.393183371495248, 9.722895087087826],
            [-10.379139948239148, 9.722512886635407],
            [-10.374132863578131, 9.71812257177606],
            [-10.368199778731011, 9.715346656104883],
            [-10.365107555768038, 9.710614470545169],
            [-10.362244618643743, 9.709017249592796],
            [-10.358968109401408, 9.712279093934805],
            [-10.3551201382847, 9.707918586161208],
            [-10.34661351437378, 9.706513034920057],
            [-10.342263891388649, 9.709685519579352],
            [-10.337839509653625, 9.70175506619116],
            [-10.332322423982513, 9.703927573990226],
            [-10.32172781629246, 9.700687653257296],
            [-10.316291359488323, 9.694606474742773],
            [-10.313071435484654, 9.694776824616953],
            [-10.311238886515516, 9.698283678609888],
            [-10.307681924709154, 9.716568336777764],
            [-10.29603633746954, 9.78686099632985],
            [-10.293495195718442, 9.800773469089721],
            [-10.279169369313523, 9.798242835781435],
            [-10.208207279366846, 9.78648026164655],
            [-10.187158431639475, 9.782529163884341],
            [-10.179117150303933, 9.78182143278449],
            [-10.151099921885194, 9.77699611700063],
            [-10.121920089304533, 9.772408415777967],
            [-10.107972386268987, 9.85593476402538],
            [-10.0217860047784, 9.842119550774077],
            [-9.935603540685324, 9.828279638196465]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -111.3470514985814, "lat": 47.30795950347197 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30013"],
        "coty_name": ["Cascade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cascade County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01719622"
      },
      "bbox": [
        -10.445210025234989, 8.896636391962284, -9.459167092613567,
        9.85593476402538
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.466894724006442, 11.38204041142292],
            [-11.362063703887898, 11.362294069468867],
            [-11.333875298114599, 11.356457405673977],
            [-11.222282524171902, 11.335114377637257],
            [-11.145826365868489, 11.321876652720807],
            [-11.080443187876126, 11.310002525108615],
            [-11.015062816165193, 11.29811297526848],
            [-11.002678353814314, 11.295536007647431],
            [-10.89662327777017, 11.277095020128534],
            [-10.845477339612096, 11.267501449239841],
            [-10.775863225754021, 11.255265434142297],
            [-10.670392769569458, 11.237028438678035],
            [-10.564929133665556, 11.218751468048708],
            [-10.459472461037508, 11.200434541603911],
            [-10.354022894712793, 11.182077678560589],
            [-10.241672309719918, 11.163070037608069],
            [-10.255752238678582, 11.081972309021404],
            [-10.25301376031977, 11.081476565438573],
            [-10.296775941019751, 10.832150530446055],
            [-10.311313484765764, 10.74898902835858],
            [-10.308338696346457, 10.74847950861289],
            [-10.323375978788185, 10.663315864429919],
            [-10.334995233145836, 10.664480917903607],
            [-10.338920398276597, 10.665641538528059],
            [-10.341669402417084, 10.6706580212792],
            [-10.351682392495226, 10.67235685185347],
            [-10.351582972335136, 10.674046581919658],
            [-10.421258028316865, 10.685857363405319],
            [-10.501206961662751, 10.69949405824904],
            [-10.581159682922445, 10.713108413411444],
            [-10.599758383707126, 10.609819648464718],
            [-10.610430452319351, 10.550679108875087],
            [-10.613779579662582, 10.547392298027539],
            [-10.689080228508091, 10.560620577979215],
            [-10.764384376782676, 10.573829189206915],
            [-10.802831606528953, 10.58046721223291],
            [-10.922653140848828, 10.601686917867562],
            [-10.923365419728816, 10.60213545035776],
            [-11.022221202327227, 10.619930299002295],
            [-11.12108311823501, 10.63769116570077],
            [-11.123763781418303, 10.644349661042524],
            [-11.130198238324569, 10.648547780812972],
            [-11.13079401244276, 10.651461285876804],
            [-11.13527706207556, 10.653797027277328],
            [-11.133712124238093, 10.660809835414534],
            [-11.135772362759381, 10.66577982331486],
            [-11.140015731277282, 10.671227784199715],
            [-11.131876895069793, 10.677219143334362],
            [-11.12727869145683, 10.68189932280541],
            [-11.122479511339021, 10.682814161884615],
            [-11.113446892771718, 10.687363822110068],
            [-11.10358184397553, 10.694960397457765],
            [-11.098281622985256, 10.704496633614493],
            [-11.09681188224867, 10.710183330854205],
            [-11.104530531124908, 10.71799345105116],
            [-11.105244244460057, 10.729499651923685],
            [-11.102225863997685, 10.735694716633068],
            [-11.105454706949791, 10.747492500920403],
            [-11.112828517528484, 10.747877257952394],
            [-11.119998909014459, 10.746265351434074],
            [-11.123348592039582, 10.743796535641504],
            [-11.127561411319823, 10.743816293858437],
            [-11.132656978454467, 10.745664696336785],
            [-11.143664099288747, 10.751264270026144],
            [-11.14929520016008, 10.761935428980248],
            [-11.155033842281872, 10.764705166580809],
            [-11.157958385579878, 10.767640953496018],
            [-11.161123109673415, 10.775396264948364],
            [-11.164792367534027, 10.779738163714063],
            [-11.171229022776846, 10.780280744698029],
            [-11.175104079030616, 10.783894291902804],
            [-11.17722118022608, 10.788260131821122],
            [-11.181120720036676, 10.789976464241354],
            [-11.181041358594015, 10.79643745624801],
            [-11.177934741075136, 10.799072351870155],
            [-11.174478672448299, 10.805314564373662],
            [-11.168962631141092, 10.808938507572039],
            [-11.168670076408192, 10.81315916514427],
            [-11.170051000574786, 10.822036221992372],
            [-11.164333444797068, 10.83146855599152],
            [-11.168076723987179, 10.836303771187376],
            [-11.168141834224242, 10.838711341849114],
            [-11.16491004047937, 10.850721735190227],
            [-11.1638531354909, 10.85791155739172],
            [-11.160238505149549, 10.862432540628506],
            [-11.160017837713244, 10.867981251175252],
            [-11.156274413650278, 10.878816145262151],
            [-11.159337230956158, 10.884246066485787],
            [-11.166200240359663, 10.886945634851644],
            [-11.171800117410788, 10.886367873398745],
            [-11.177179839363879, 10.893047623034274],
            [-11.18229621890464, 10.895691544394687],
            [-11.184252304723188, 10.90900256984658],
            [-11.188028622030131, 10.910713857902696],
            [-11.197685858263958, 10.919130197728027],
            [-11.199406894755207, 10.925715087314149],
            [-11.201949712108206, 10.923949872495013],
            [-11.209612480506792, 10.924397795446003],
            [-11.21941344557509, 10.921424366681737],
            [-11.222582559179846, 10.927216795379634],
            [-11.228057843412662, 10.927523102698963],
            [-11.231843205727863, 10.923175402004459],
            [-11.23886032755682, 10.921058804575344],
            [-11.244146106471119, 10.924006115125795],
            [-11.246783722721686, 10.92795093541344],
            [-11.247675170068916, 10.93613552488329],
            [-11.252867058767048, 10.944954625084184],
            [-11.255351491034128, 10.947652775262796],
            [-11.26095851656436, 10.950398869368595],
            [-11.27001622114603, 10.942479611746563],
            [-11.27832429869243, 10.938863267032795],
            [-11.287549607619146, 10.948227149816661],
            [-11.290974931507213, 10.949648870443367],
            [-11.2967300177191, 10.949223292228206],
            [-11.305813222430663, 10.95291304770188],
            [-11.312569178627118, 10.959984495134115],
            [-11.315705007582542, 10.960034523489403],
            [-11.32069931810095, 10.96971401310599],
            [-11.32223292461455, 10.969835191971933],
            [-11.330147361076602, 10.976815834890063],
            [-11.33172640858685, 10.981264708985398],
            [-11.326425249514617, 10.985681337665838],
            [-11.324554216841282, 10.992622585206135],
            [-11.320810606875776, 10.996046196894927],
            [-11.323051475312385, 11.000353095387302],
            [-11.319881562583523, 11.012896124387412],
            [-11.316650129748107, 11.0151079526065],
            [-11.313709857124246, 11.022000521524223],
            [-11.303539606831999, 11.028329725742132],
            [-11.306508079065914, 11.032528801244277],
            [-11.306394081586795, 11.035227238598248],
            [-11.309010242315273, 11.042264244243848],
            [-11.309219144342947, 11.050566675586962],
            [-11.304124638658212, 11.050944179827777],
            [-11.299250859232414, 11.049372703194875],
            [-11.29526317406785, 11.049937116092071],
            [-11.28709063243949, 11.057603833120014],
            [-11.283435877713144, 11.065233236967968],
            [-11.280149806291094, 11.068364225411704],
            [-11.279614518359475, 11.071710612052819],
            [-11.283234918620058, 11.076573105070905],
            [-11.280345850885686, 11.082661394571419],
            [-11.283288722720808, 11.094831189349632],
            [-11.291044490589632, 11.098866567877648],
            [-11.29554747773818, 11.103817777354942],
            [-11.297381032995638, 11.107529156884699],
            [-11.298500127623747, 11.117062248024661],
            [-11.297366140683362, 11.119777210143896],
            [-11.303757892361784, 11.124505243563133],
            [-11.308288997338446, 11.129783114227143],
            [-11.309472657965037, 11.135409408936646],
            [-11.309316523733306, 11.141649627594939],
            [-11.311551440076348, 11.143427590473127],
            [-11.3118135179587, 11.15404166877473],
            [-11.310538602070148, 11.157381894270548],
            [-11.304222572170483, 11.159036429946896],
            [-11.300520576723416, 11.16497291307422],
            [-11.299555345349635, 11.170034187739796],
            [-11.296941981351074, 11.172108374950904],
            [-11.302542873530255, 11.17623710284817],
            [-11.308031093359622, 11.181821701454774],
            [-11.312963760278068, 11.189513940009805],
            [-11.312328679393186, 11.196417618196953],
            [-11.313929338262, 11.202113194249183],
            [-11.320471331711888, 11.200406368805574],
            [-11.325027434855887, 11.197607471739381],
            [-11.330946871445098, 11.199529498211765],
            [-11.332452534372738, 11.202777806898151],
            [-11.331884827759643, 11.20803697795564],
            [-11.337431655480486, 11.209721650595748],
            [-11.344464535482146, 11.213965938119571],
            [-11.345425593428535, 11.218148014755554],
            [-11.350571361258794, 11.215643690358528],
            [-11.355639291924087, 11.215477510760612],
            [-11.36264045668827, 11.212892670585605],
            [-11.368742150590661, 11.20877765534711],
            [-11.371173200375459, 11.204622889258914],
            [-11.379902031072678, 11.210501703832081],
            [-11.380442003085253, 11.213138822435113],
            [-11.384793731731829, 11.216640347279434],
            [-11.389493280564858, 11.217244738112516],
            [-11.39182466032193, 11.219660418722167],
            [-11.395586091597272, 11.215171245632474],
            [-11.396198213515712, 11.21175859113743],
            [-11.399698568228859, 11.207757263634855],
            [-11.402613618438574, 11.207184673020663],
            [-11.40677646537177, 11.203340018522143],
            [-11.41787689806226, 11.19988127044062],
            [-11.425182731134349, 11.195842580287303],
            [-11.4279402479325, 11.195708245881779],
            [-11.431767066603891, 11.201975876477757],
            [-11.435985314771008, 11.202933414071069],
            [-11.439557383021844, 11.200056247543],
            [-11.442123183419385, 11.206561647857226],
            [-11.45157381558477, 11.21206288174492],
            [-11.455940442245163, 11.216505645059998],
            [-11.451592180691389, 11.221416027914383],
            [-11.447489591344445, 11.220635952025516],
            [-11.44494521588988, 11.222102256533661],
            [-11.443879066039536, 11.226609940568098],
            [-11.444789272644279, 11.23504577991604],
            [-11.450637999445572, 11.24375338719259],
            [-11.4516805192437, 11.247033444180731],
            [-11.458633345977193, 11.24813423662038],
            [-11.462387445028027, 11.254752206764907],
            [-11.464869192111632, 11.264291380419944],
            [-11.480789053164903, 11.27630595749635],
            [-11.477318443923298, 11.281558096130167],
            [-11.47218317899862, 11.279608215450443],
            [-11.466547346476963, 11.279835856523192],
            [-11.452577491379074, 11.284770154832943],
            [-11.448244212959278, 11.289357329940755],
            [-11.447261626392903, 11.302224886250201],
            [-11.446008624206636, 11.305417033849947],
            [-11.448724384731326, 11.307478663217365],
            [-11.45094576879588, 11.314482920361787],
            [-11.45862633822026, 11.313920768354699],
            [-11.462403410430781, 11.315262604321918],
            [-11.465077576016643, 11.320351315143425],
            [-11.46063147705319, 11.323379107690819],
            [-11.46000761166844, 11.328452628600063],
            [-11.44706517939473, 11.337181788653563],
            [-11.443246856614584, 11.340533163190713],
            [-11.447023912607083, 11.344586086983474],
            [-11.459885409202476, 11.344918732080778],
            [-11.461902753087632, 11.346042506974518],
            [-11.461685565832344, 11.353301151059942],
            [-11.463125992655046, 11.355073571803672],
            [-11.464055607494595, 11.362751105074032],
            [-11.4616346860489, 11.368404239038039],
            [-11.46627450482413, 11.375319472608918],
            [-11.466894724006442, 11.38204041142292]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.99472099980176,
          "lat": 48.70515479678273
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30035"],
        "coty_name": ["Glacier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Glacier County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01719607"
      },
      "bbox": [
        -11.480789053164903, 10.547392298027539, -10.241672309719918,
        11.38204041142292
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.852233059044156, 10.330825117308207],
            [-9.763493291849597, 10.31659787230315],
            [-9.744022945906503, 10.434891094817692],
            [-9.724184451989226, 10.555906129105127],
            [-9.708670492258289, 10.650036647213899],
            [-9.707278001929446, 10.649815786447924],
            [-9.685452852742268, 10.781958740964535],
            [-9.67968998512604, 10.816701007869707],
            [-9.657343100521864, 10.952066547109839],
            [-9.652209809670461, 10.983058395928026],
            [-9.650010135041661, 10.982708407809028],
            [-9.636806887940693, 11.062281735295489],
            [-9.549561144277897, 11.048692506520705],
            [-9.462319614702976, 11.035076152823676],
            [-9.385324878862798, 11.023669797459782],
            [-9.290992209036068, 11.00954405035699],
            [-9.297965109746327, 10.963210610981642],
            [-9.30364255624055, 10.928577655898609],
            [-9.308832593717963, 10.929373744352752],
            [-9.361634366210229, 10.595776552564766],
            [-9.365644900510373, 10.59636980906718],
            [-9.367701735585257, 10.58354161347971],
            [-9.415970166797901, 10.278537102095603],
            [-9.418556584821788, 10.262597495822407],
            [-9.466085335371458, 10.269900774243059],
            [-9.479220445602946, 10.186671346667184],
            [-9.594400990784731, 10.20459074595565],
            [-9.709588538601407, 10.22246498194683],
            [-9.787920110333289, 10.234642946672365],
            [-9.866254829782537, 10.246800010442758],
            [-9.852233059044156, 10.330825117308207]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.02457081690652,
          "lat": 48.56171838263554
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30051"],
        "coty_name": ["Liberty"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Liberty County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01720036"
      },
      "bbox": [
        -9.866254829782537, 10.186671346667184, -9.290992209036068,
        11.062281735295489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.681610368757433, 8.666830482438332],
            [-7.665816974837367, 8.664662196695788],
            [-7.563951699683143, 8.652392584462572],
            [-7.478138399605405, 8.641933686495433],
            [-7.392327931933273, 8.631451988511762],
            [-7.391342719084575, 8.639361464155483],
            [-7.314172930565515, 8.62998646673652],
            [-7.234868826042204, 8.62074662203068],
            [-7.155566996438438, 8.611487322668367],
            [-7.0954509570979996, 8.604530827532109],
            [-6.988460814888175, 8.592580666800284],
            [-6.881474598624003, 8.58059514244586],
            [-6.883146307154368, 8.566484502808995],
            [-6.774956963352856, 8.554955999684113],
            [-6.666771361020237, 8.543391416108943],
            [-6.558589598822809, 8.531790759650889],
            [-6.450411775421382, 8.520154038053596],
            [-6.451849561769682, 8.506023101751165],
            [-6.475273206588735, 8.508471269567584],
            [-6.496983121575606, 8.305967967147126],
            [-6.507062725824651, 8.209481499592414],
            [-6.508038018690023, 8.203130294878749],
            [-6.511927560915783, 8.167477632291993],
            [-6.535808670783482, 8.16999475860064],
            [-6.55359660403264, 8.003593269543556],
            [-6.563257199943627, 7.915288667361385],
            [-6.560979023363634, 7.91504569831049],
            [-6.571479413891446, 7.8296320051967125],
            [-6.597851968386951, 7.832362488486862],
            [-6.625661724523879, 7.575545110260929],
            [-6.63518289263513, 7.48933715423407],
            [-6.664859774640875, 7.492489238530061],
            [-6.6662118128319445, 7.4781116493135125],
            [-6.666348793646874, 7.460963813971559],
            [-6.679734993115528, 7.348898964715701],
            [-6.694333102589606, 7.21859321940954],
            [-6.712641173559178, 7.061912086773212],
            [-6.743253231285853, 7.065204624536539],
            [-6.761951055829048, 6.8953138285146425],
            [-6.845382761566872, 6.904377900590732],
            [-6.8456815596444685, 6.901946512839457],
            [-6.939361520561684, 6.9124930303864724],
            [-7.033044195731622, 6.92301592012904],
            [-7.040248048625263, 6.924295221936396],
            [-7.076070723051273, 6.928321693660087],
            [-7.103748305045927, 6.93303898160027],
            [-7.0846287072982665, 7.103898222850815],
            [-7.065262822515217, 7.101511516720126],
            [-7.057466723842981, 7.0994919945269706],
            [-7.047533531151741, 7.186841264968614],
            [-7.03779887700392, 7.271726078610639],
            [-7.028497367960523, 7.352769534432695],
            [-7.021284751804297, 7.416248375094819],
            [-7.019489445770281, 7.4196564975054144],
            [-7.102060742062715, 7.42910722492402],
            [-7.101247014450543, 7.436238277469191],
            [-7.147392501214393, 7.441585925512001],
            [-7.1353399924785545, 7.5442397544830975],
            [-7.11060080958229, 7.541412043739751],
            [-7.105708035636368, 7.584219188870207],
            [-7.148578817216542, 7.589012255776478],
            [-7.144181953338031, 7.626818821148582],
            [-7.128606051110503, 7.760674085813993],
            [-7.113586966446653, 7.8888762638488945],
            [-7.159422090460374, 7.894142987022994],
            [-7.160989698585096, 7.891864037007213],
            [-7.14312469603313, 8.044000300501043],
            [-7.141101740881004, 8.062137507724485],
            [-7.144589864361528, 8.063603439512791],
            [-7.150330348038442, 8.063900272641964],
            [-7.155647435216545, 8.062814168395068],
            [-7.145310061850651, 8.14992902252451],
            [-7.231156923489086, 8.160042809478242],
            [-7.2227865465085745, 8.231111915584064],
            [-7.237083844380459, 8.232856215736838],
            [-7.235449403772232, 8.24711024243617],
            [-7.331408711153335, 8.25842753391751],
            [-7.4273712952156234, 8.26971710438884],
            [-7.523337092239056, 8.280978948376568],
            [-7.61930603849881, 8.292213060546365],
            [-7.622235284421119, 8.292571831602846],
            [-7.6333837303814365, 8.293940284873173],
            [-7.631638479296794, 8.307882252847953],
            [-7.649723394268656, 8.310080530958952],
            [-7.660388439846054, 8.31125707159426],
            [-7.651494887349941, 8.381830970197136],
            [-7.650512110667933, 8.381709675237028],
            [-7.647073889642667, 8.409780567954913],
            [-7.675982537500735, 8.41334953252136],
            [-7.6738363862537415, 8.418285658107523],
            [-7.6696179983626855, 8.418583210051928],
            [-7.6669993460185415, 8.420756185938341],
            [-7.669351663244184, 8.42448422577135],
            [-7.663277968749219, 8.425868028063187],
            [-7.65943045454396, 8.43028366025717],
            [-7.662349800356632, 8.436645673941713],
            [-7.656335240630497, 8.441601815925953],
            [-7.65409369987752, 8.446071626679199],
            [-7.653898981264776, 8.451659537384666],
            [-7.656176662850673, 8.458833350663252],
            [-7.653552728121011, 8.46366166620797],
            [-7.653389418560039, 8.46814135180334],
            [-7.648662883855064, 8.470556179625596],
            [-7.647940800494653, 8.475450354864847],
            [-7.642555236798977, 8.473617238023689],
            [-7.6392570734510725, 8.47824503979542],
            [-7.641860658676817, 8.480920354068742],
            [-7.63892783690453, 8.483572829090999],
            [-7.640355033193638, 8.486055198689753],
            [-7.635081329803457, 8.490930565802861],
            [-7.6358285959171965, 8.496784016206249],
            [-7.639328984232157, 8.499350212183675],
            [-7.638591548636151, 8.503715298635676],
            [-7.646548965235615, 8.508172820100583],
            [-7.651913802283977, 8.517503490002213],
            [-7.647905776606821, 8.520914621998108],
            [-7.652325393092376, 8.523891949528323],
            [-7.653430125645607, 8.527259840680198],
            [-7.650297656910006, 8.532524512269447],
            [-7.6532425317226345, 8.534396040006397],
            [-7.653127676982905, 8.538757761119838],
            [-7.650280734229098, 8.540818453547764],
            [-7.641592150601703, 8.540034495555199],
            [-7.638632858937639, 8.543571048167301],
            [-7.642997834771277, 8.548658572325282],
            [-7.641236719905403, 8.554734576661453],
            [-7.6458087823900005, 8.556179253328962],
            [-7.6488444479539455, 8.560486144211492],
            [-7.647637949797312, 8.563114781026842],
            [-7.64941710583543, 8.568211327760741],
            [-7.6472724959518255, 8.573484594182917],
            [-7.650115793107831, 8.577445822353747],
            [-7.654659015880883, 8.57574366854225],
            [-7.657175087042866, 8.581053521716198],
            [-7.654037445359642, 8.584894898824563],
            [-7.65578244735194, 8.588170352523486],
            [-7.664288351056337, 8.59290395932986],
            [-7.661610598080752, 8.596051281881424],
            [-7.655813849303195, 8.598889701300218],
            [-7.65661823834761, 8.602864400421733],
            [-7.652945422667521, 8.603175853324561],
            [-7.652803997207397, 8.606961830587776],
            [-7.657962016713611, 8.608227939891615],
            [-7.661141586624919, 8.607123165128595],
            [-7.661777086346776, 8.61197214352595],
            [-7.659441748849948, 8.614226563737216],
            [-7.653062119448288, 8.616150800696909],
            [-7.655520606169197, 8.618934523708793],
            [-7.656218743451165, 8.623322390978556],
            [-7.661048356887279, 8.625676569997228],
            [-7.659823782272519, 8.631712643066935],
            [-7.661714494756854, 8.637785377052243],
            [-7.666967426386296, 8.643568551614178],
            [-7.662817606918171, 8.649007842937625],
            [-7.670820440140837, 8.64941047891807],
            [-7.672196339306409, 8.651680118845368],
            [-7.6708822244107875, 8.656972718108454],
            [-7.67179440110517, 8.659474445573258],
            [-7.678071190562858, 8.659158718251089],
            [-7.681610368757433, 8.666830482438332]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.73072346321295,
          "lat": 46.22969187712697
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30087"],
        "coty_name": ["Rosebud"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rosebud County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01716795"
      },
      "bbox": [
        -7.681610368757433, 6.8953138285146425, -6.450411775421382,
        8.666830482438332
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9107952375382629, 3.4540974974449155],
            [-1.8964033744446742, 3.4537675688447607],
            [-1.8332864974457805, 3.4518006001937156],
            [-1.7481389195173294, 3.449157020129516],
            [-1.7404342099715644, 3.4488239416109656],
            [-1.6275460952339904, 3.445508832091195],
            [-1.6240096247509899, 3.4456247149078183],
            [-1.5707869730548756, 3.444015413828013],
            [-1.5730851620724806, 3.355560196637967],
            [-1.5737126097226735, 3.33922829722245],
            [-1.575504628648176, 3.26841689947058],
            [-1.5778480999756397, 3.1812991048162886],
            [-1.5797079946353532, 3.1037262568169774],
            [-1.5794757757508158, 3.0940317163242037],
            [-1.6654658659199681, 3.096561493929303],
            [-1.7303558734634628, 3.0986075604737953],
            [-1.8298012259098053, 3.101791553954429],
            [-1.843656889096583, 3.102449279147717],
            [-1.9147218702706048, 3.1047832555340755],
            [-1.921980135973512, 3.105208834414214],
            [-1.9209415359648616, 3.1337836361393125],
            [-1.9200245549993349, 3.1709426322620615],
            [-1.916493356227922, 3.2799224267033145],
            [-1.913642303494045, 3.3672286514624434],
            [-1.9107952375382629, 3.4540974974449155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.99139225146011, "lat": 41.91434214094395 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31071"],
        "coty_name": ["Garfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garfield County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00835857"
      },
      "bbox": [
        -1.921980135973512, 3.0940317163242037, -1.5707869730548756,
        3.4540974974449155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.11437373252231754, 1.839109833813542],
            [0.1960446736628618, 1.8386109768013943],
            [0.22407003330182224, 1.8386236744849143],
            [0.285555610652359, 1.838254852185689],
            [0.2933822526870305, 1.8383699137197242],
            [0.3712879310390723, 1.8385627926994277],
            [0.41324358439759257, 1.8384120537481994],
            [0.41331281637862777, 1.801890645810249],
            [0.41364572472519945, 1.750722974762784],
            [0.4138729377819069, 1.6629481486601576],
            [0.41306541873336416, 1.6629396375748733],
            [0.4130788526689879, 1.6188085523809719],
            [0.4132665957450006, 1.5751045737380152],
            [0.3724024520726374, 1.5753949962569205],
            [0.37090822667332474, 1.5755885409033987],
            [0.30280955640170887, 1.5754626027349319],
            [0.2851020988274676, 1.5752240239578197],
            [0.1986108506690131, 1.5760839513428337],
            [0.113063584724984, 1.576078079351663],
            [0.11337453020035936, 1.6563538199482362],
            [0.11392360487082258, 1.7513637482023479],
            [0.11437373252231754, 1.839109833813542]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.2651143545074, "lat": 40.39264214702376 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31097"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00835870"
      },
      "bbox": [
        0.113063584724984, 1.5751045737380152, 0.4138729377819069,
        1.839109833813542
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.2229117704502131, 2.0179100957053655],
            [-0.22112482756915064, 2.0179201700273857],
            [-0.22000997104835837, 2.105570723367951],
            [-0.21897675397059815, 2.193296757028802],
            [-0.21821472115279608, 2.280904139678255],
            [-0.21762768046816636, 2.3687250332595458],
            [-0.21580813398571536, 2.368682445159018],
            [-0.1443260320736437, 2.3678512696848104],
            [-0.024308396439871798, 2.3665852835081056],
            [0.042266151367569546, 2.3659310911171385],
            [0.11676486244940419, 2.36526787363432],
            [0.11662807044516706, 2.3360383734152768],
            [0.11609559431635137, 2.2044591736496484],
            [0.11555855564125211, 2.102154085241705],
            [0.11485553057908358, 1.9706467410009751],
            [0.11437373252231754, 1.839109833813542],
            [0.032572009051904056, 1.8403770906211805],
            [-0.05238070348133837, 1.840402243871854],
            [-0.059520480001545556, 1.8402271672276183],
            [-0.1378746080594289, 1.8408472351014782],
            [-0.2239567646272803, 1.842175249181625],
            [-0.2232103364824077, 1.8860814908226355],
            [-0.22407714891718652, 1.9299954480158077],
            [-0.2229117704502131, 2.0179100957053655]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.68775401587709, "lat": 40.78416344106471 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31109"],
        "coty_name": ["Lancaster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lancaster County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00835876"
      },
      "bbox": [
        -0.22407714891718652, 1.839109833813542, 0.11676486244940419,
        2.3687250332595458
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.13405158562748357, 3.008090318382056],
            [0.19167187055907334, 3.007528631843408],
            [0.2591257400084161, 3.0073681522782953],
            [0.34903757982904493, 3.0067702519953525],
            [0.3735222402477425, 3.006730525006108],
            [0.37405599344339474, 3.0015693527474063],
            [0.3784993718659491, 2.9948818012115117],
            [0.3897135932491259, 2.9846159836453086],
            [0.3929839974701635, 2.976267054535511],
            [0.39325222157260864, 2.9708623088015473],
            [0.39125519155548677, 2.9630840288861666],
            [0.3890457130389423, 2.9589345041330466],
            [0.37905901607549763, 2.9473413937779633],
            [0.37622868204593435, 2.9406841705321085],
            [0.37651035167467906, 2.9332803911786223],
            [0.37926503411220325, 2.925506184311375],
            [0.3825581225364847, 2.9200620428216015],
            [0.38840875962496696, 2.914730950745716],
            [0.39791487053159214, 2.910635622476676],
            [0.40181987424618765, 2.9064244558579153],
            [0.40347407481466835, 2.897300149155492],
            [0.4007897293907514, 2.8908182489113936],
            [0.3942265360415502, 2.8812030472157644],
            [0.39200571398072004, 2.8682483419010976],
            [0.3953945839670001, 2.856683701725272],
            [0.4023359752207205, 2.848689852854079],
            [0.40864758851263433, 2.8466444832359983],
            [0.4127472542401018, 2.841775967055078],
            [0.4238437354537696, 2.8314479839709104],
            [0.4279834041289946, 2.829847397243298],
            [0.4334949188156437, 2.829648551079109],
            [0.43654093057201776, 2.8316311876619125],
            [0.4419661317094484, 2.8506865696363164],
            [0.44394050341031843, 2.863151213973245],
            [0.44951731709608433, 2.867954710559377],
            [0.45343435357230233, 2.8681301604110816],
            [0.4599432664125934, 2.8660511783025013],
            [0.4637653158136409, 2.8622567123145353],
            [0.468278636308254, 2.8460846858635516],
            [0.4690655259185516, 2.834600442863485],
            [0.46658281690126807, 2.8295246040891144],
            [0.4582893904182861, 2.8201354917638435],
            [0.4518583309311416, 2.8151316730032834],
            [0.44921405163749695, 2.809050474498073],
            [0.45499952090490176, 2.798575993910812],
            [0.4602397864480645, 2.7946799957759927],
            [0.47640783457678754, 2.7921001022641843],
            [0.4834814534923265, 2.7896254559092806],
            [0.4894072720983778, 2.7857941531364707],
            [0.4957011451520711, 2.785096106355843],
            [0.5035454447398687, 2.788474277336049],
            [0.5068883384990628, 2.7885728722836416],
            [0.513617625459473, 2.7860969850820068],
            [0.5189807159530058, 2.781655705097635],
            [0.5230266187769077, 2.7737910872308174],
            [0.5228126030380092, 2.766478570278007],
            [0.5203410124814001, 2.761886151881303],
            [0.5152873374559586, 2.7559952450544074],
            [0.5134575770547014, 2.75150008486474],
            [0.5141115289243555, 2.744144598049207],
            [0.515908276607817, 2.737131121389291],
            [0.5152533781977031, 2.7280942409730877],
            [0.5107115315280746, 2.718233008048502],
            [0.5102671462171088, 2.714918458190596],
            [0.37083483172674875, 2.7150063964496476],
            [0.2833729134360686, 2.715176143585714],
            [0.25679698029125747, 2.715144109269438],
            [0.21885235349258855, 2.71536784035155],
            [0.21923612959419042, 2.7292627635946323],
            [0.2190702722626687, 2.759144572454799],
            [0.19767067993876364, 2.758871454736658],
            [0.19049714838775, 2.7593266250067425],
            [0.19065381701835035, 2.773676093746734],
            [0.1763180956555574, 2.774034863811085],
            [0.17642062704428854, 2.7886267091780392],
            [0.16214353108667634, 2.7887586049800785],
            [0.1619730722434191, 2.8034951197379927],
            [0.14764387560299141, 2.8034389204080457],
            [0.14770266595133863, 2.8180572622659734],
            [0.14058878235908137, 2.818152822734942],
            [0.1409691394471669, 2.8473437239446673],
            [0.13395747908282418, 2.847378096797118],
            [0.13385158331308758, 2.891258398307718],
            [0.1342050789380449, 2.934914194035348],
            [0.13405158562748357, 3.008090318382056]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.22200522192944, "lat": 41.53106550449832 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31177"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00835910"
      },
      "bbox": [
        0.13385158331308758, 2.714918458190596, 0.5230266187769077,
        3.008090318382056
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.521160576817646, 2.2686787872750163],
            [16.522870729865517, 2.2701128982925534],
            [16.518868093093143, 2.2753721158517997],
            [16.517241078415573, 2.2793549698629008],
            [16.512862052366344, 2.2783899656869737],
            [16.509633776304042, 2.2841733927207297],
            [16.507702399854878, 2.2901248664118516],
            [16.509449210703654, 2.293542056846367],
            [16.5054528332754, 2.3012670428301703],
            [16.503791248172924, 2.307358798271855],
            [16.505590113428358, 2.3141607893980822],
            [16.511661794160315, 2.3175620403021178],
            [16.522167720487747, 2.3282958472989237],
            [16.51650907094228, 2.4028426278636377],
            [16.521853492611278, 2.4084161145620264],
            [16.524748074854447, 2.414719029003998],
            [16.52606044903338, 2.421539530987389],
            [16.528661593082212, 2.421550189852613],
            [16.530142090808422, 2.417369844262178],
            [16.538049380831087, 2.415818862589017],
            [16.54839602891743, 2.4167697882104933],
            [16.559698918991195, 2.4095130541288152],
            [16.562958916186563, 2.411962651422801],
            [16.571384510106768, 2.4128706521943677],
            [16.577419549209193, 2.4166933273744724],
            [16.583954849120598, 2.4144874870277504],
            [16.585549942633822, 2.417461717163862],
            [16.590305008072022, 2.418322835157537],
            [16.599272886425524, 2.4139218393728687],
            [16.605078192888943, 2.4133951914864316],
            [16.608746842923395, 2.4117466510627223],
            [16.61101094606654, 2.4148632075558183],
            [16.61408723993538, 2.4153974014728754],
            [16.61657529393135, 2.4116905661048342],
            [16.624939808946515, 2.414133168213669],
            [16.62653608588505, 2.4170903017964185],
            [16.631228516613692, 2.418761221288785],
            [16.634074140064687, 2.4171439476408376],
            [16.638725745380896, 2.420077433596319],
            [16.641112026929935, 2.4164235351499843],
            [16.645627095710214, 2.4148864708746927],
            [16.649445025257418, 2.4155113041961247],
            [16.651788386833655, 2.418805833160697],
            [16.65478060312631, 2.4191861068792857],
            [16.657243227411627, 2.415070933646279],
            [16.66373092637746, 2.418279520897522],
            [16.66588824037352, 2.42201125577951],
            [16.670280232226187, 2.422762924813887],
            [16.67347640937503, 2.4265021309667936],
            [16.683621063582095, 2.429853588500748],
            [16.686912104438356, 2.4283625486609877],
            [16.688119746822192, 2.422426342542179],
            [16.692534517698757, 2.4223061756068187],
            [16.694782379767897, 2.4242098495907247],
            [16.69783908132612, 2.43068310959351],
            [16.705864707987825, 2.4321365742637653],
            [16.71258334341863, 2.4308876047342274],
            [16.71726676139219, 2.4330839892425704],
            [16.73330608166081, 2.4531238361999703],
            [16.739448542311195, 2.4540294510427825],
            [16.74882579432937, 2.4486846698180735],
            [16.75329733845906, 2.4470819933972847],
            [16.761759561039, 2.4487570403249004],
            [16.767103336306672, 2.453012699536529],
            [16.767368389835756, 2.4524008854883554],
            [16.764644847965045, 2.450784731965306],
            [16.766379693991855, 2.443505065149724],
            [16.766801941296478, 2.4365151920365222],
            [16.76148353335879, 2.4268295676904446],
            [16.750814143600525, 2.4170725343059756],
            [16.740583566679593, 2.4021613377918007],
            [16.728261818451937, 2.380610160692983],
            [16.72005573850838, 2.3590878895638516],
            [16.714667945812323, 2.34620517417804],
            [16.711647417793568, 2.330967315737342],
            [16.708371826889007, 2.3264854519146354],
            [16.70288790837248, 2.3121339203442415],
            [16.69250335648421, 2.276742441454365],
            [16.68710312540096, 2.250201165198156],
            [16.684217748601554, 2.2458009115281],
            [16.685532013350883, 2.2407476721289776],
            [16.694339060941605, 2.2357447115277314],
            [16.694343586420302, 2.2306539400012575],
            [16.677014244320425, 2.1977480721046163],
            [16.670618663032815, 2.176436297773181],
            [16.6610913699814, 2.1502618024331404],
            [16.656759937117187, 2.1462969931398823],
            [16.648742572863167, 2.148411715420658],
            [16.642066064818955, 2.13941056292621],
            [16.645923754363135, 2.1355902237353295],
            [16.648402229359302, 2.127965474772073],
            [16.652361456453605, 2.1239758263620745],
            [16.65619470059427, 2.1164699935749938],
            [16.65284773711013, 2.1086610681172466],
            [16.635443676427034, 2.0843909214873912],
            [16.6188215090916, 2.059981288927605],
            [16.611668276893433, 2.0437487568320045],
            [16.606433183113932, 2.0458070055058557],
            [16.59658079732762, 2.0424099678833953],
            [16.581534171962748, 2.0282403447950537],
            [16.57212513077954, 2.0231629540102753],
            [16.562373145307745, 2.020327772570278],
            [16.558988534626902, 2.022399687900528],
            [16.55132780672671, 2.021450875681622],
            [16.54410275153288, 2.018407161449905],
            [16.539311737284088, 2.017904642848378],
            [16.53595540303343, 2.019444981035391],
            [16.530865455544024, 2.0254960185543798],
            [16.532711962851415, 2.0484846873136915],
            [16.53039712988651, 2.0549266669791475],
            [16.5298633506234, 2.088247530718829],
            [16.531100137685836, 2.103392828504304],
            [16.53513303547236, 2.124517721989825],
            [16.549528521731215, 2.1818030138323303],
            [16.551409346900027, 2.1939909348195146],
            [16.552140007398236, 2.2090201871857014],
            [16.549860853483437, 2.222926512768702],
            [16.55127072491345, 2.2240389684075432],
            [16.54833006212294, 2.236286862642798],
            [16.55034022704235, 2.2401007781323097],
            [16.546020841536404, 2.2548441711843545],
            [16.5332976334502, 2.266953955782583],
            [16.52944804498454, 2.2685129799496018],
            [16.521160576817646, 2.2686787872750163]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.80054610547461, "lat": 39.14951279272867 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34009"],
        "coty_name": ["Cape May"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cape May County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00882274"
      },
      "bbox": [
        16.503791248172924, 2.017904642848378, 16.767368389835756,
        2.4540294510427825
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.24189406044639, 3.408610380270964],
            [16.250254616838486, 3.4082034153151106],
            [16.30465525989798, 3.4279695036896363],
            [16.287856707477953, 3.4562655787898127],
            [16.33607968562964, 3.474597007598622],
            [16.324257578468675, 3.5046448115838458],
            [16.366975684789043, 3.522062669578573],
            [16.382275080361786, 3.499608878548069],
            [16.39713330365718, 3.478359593974744],
            [16.40665373630385, 3.4848164143903575],
            [16.43062606562894, 3.495551798878445],
            [16.432047246000252, 3.4972141896617175],
            [16.44358907272464, 3.505226266848463],
            [16.468239779898024, 3.5039903922593476],
            [16.473581728838653, 3.4982510228435366],
            [16.47241952523697, 3.4940083980212235],
            [16.471147784118024, 3.4827388748559267],
            [16.47222529969022, 3.4758703314591832],
            [16.47274310225284, 3.465411079891218],
            [16.472056926767333, 3.459175861638785],
            [16.47903436656724, 3.45489488582149],
            [16.479408350187313, 3.4492083520172017],
            [16.481543356088377, 3.446055238326736],
            [16.485125960817072, 3.446563588222799],
            [16.4966620231431, 3.445467991038795],
            [16.502300978899257, 3.4396923041720857],
            [16.5051245972127, 3.441689428124811],
            [16.51297494422501, 3.4393833659949054],
            [16.513823146563087, 3.4357369125568606],
            [16.518159474707655, 3.432211858155667],
            [16.527686581284723, 3.4304199121530514],
            [16.53053664029837, 3.4279706390291245],
            [16.534678774801858, 3.427931560647419],
            [16.5369499194343, 3.424439474076101],
            [16.54164050323117, 3.423885718453598],
            [16.548262511470725, 3.4267046083614217],
            [16.5508331361427, 3.4236978888595573],
            [16.555643887360574, 3.4298998985233617],
            [16.559982617117825, 3.430680338402705],
            [16.567125691796228, 3.4255404347242706],
            [16.56956970690319, 3.426764937095216],
            [16.57651018884519, 3.4225836828194183],
            [16.580276234027053, 3.4213621152042015],
            [16.590919324341506, 3.4212787976339363],
            [16.596749418075824, 3.419343904359657],
            [16.599251531041194, 3.3986383780351326],
            [16.59975791711874, 3.394098566785112],
            [16.603251031251034, 3.3919291526319943],
            [16.604184536944093, 3.3889872270072128],
            [16.564544322274966, 3.3528083550980314],
            [16.56287069343741, 3.348252430028465],
            [16.562645268414347, 3.3430642641603323],
            [16.558012531480003, 3.3334565575496176],
            [16.556575318615057, 3.3239229520549576],
            [16.551496113196087, 3.317811274638396],
            [16.5483476365889, 3.318454582324122],
            [16.541953967297722, 3.314666845187917],
            [16.535760851349046, 3.307698226963687],
            [16.531724571053473, 3.3137208125343194],
            [16.529838087373903, 3.313896032098179],
            [16.519667266755956, 3.3070799588266673],
            [16.525901340366527, 3.2977861220862628],
            [16.531221049101188, 3.2922465887517514],
            [16.54935046452786, 3.268261413824241],
            [16.542379772464045, 3.266297879255069],
            [16.5327160939004, 3.265933249905774],
            [16.528109928734725, 3.267077758105609],
            [16.526096142424212, 3.265294813383762],
            [16.522095430851124, 3.266636915131069],
            [16.52092554607198, 3.2724948845999657],
            [16.5134966655431, 3.27127380336269],
            [16.508298497676048, 3.2755208048378175],
            [16.5011427676566, 3.2751393411099627],
            [16.497316046934717, 3.2777849768599325],
            [16.489578254864174, 3.2793498423036835],
            [16.48856640261797, 3.2819463120147394],
            [16.483484627003165, 3.2826654515166216],
            [16.47802135270012, 3.280300450675288],
            [16.478351872327995, 3.284835388673879],
            [16.469057979910218, 3.290958581662113],
            [16.464809621193528, 3.28888154232937],
            [16.459311646853894, 3.2937011977683173],
            [16.450606995807206, 3.290840301757975],
            [16.448765407318266, 3.283483644502289],
            [16.45275524821674, 3.2809371688268727],
            [16.456599330771052, 3.2714248021508214],
            [16.4529648463268, 3.2647108405568375],
            [16.453032397181023, 3.2611698776708886],
            [16.450225145939523, 3.257820386591085],
            [16.447455140187007, 3.2574949732358425],
            [16.445023277199333, 3.267569008660873],
            [16.433418372572813, 3.2792926356544365],
            [16.430213212959178, 3.281767207547123],
            [16.42435773924162, 3.283949919953067],
            [16.418231938845782, 3.284935261323084],
            [16.41459205743799, 3.287621554188455],
            [16.409431779553202, 3.296987645807919],
            [16.400975475061234, 3.306270267740881],
            [16.396308091447164, 3.3129953089680972],
            [16.387916740426462, 3.317518928239647],
            [16.375747593905853, 3.3229217028881015],
            [16.355859694237058, 3.327818763662369],
            [16.35194425827557, 3.33003150687573],
            [16.341747732424704, 3.332580033936068],
            [16.336362264735264, 3.335803719864944],
            [16.32411967056505, 3.3528650874562342],
            [16.3153621379333, 3.366250519524321],
            [16.307307734842933, 3.375402022434341],
            [16.290014905010135, 3.3870930048941985],
            [16.282092074804915, 3.3902631490498907],
            [16.272918838681587, 3.390054879242284],
            [16.264989635663632, 3.393946839319804],
            [16.245090726098955, 3.4055749083227003],
            [16.24189406044639, 3.408610380270964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.70178589996839, "lat": 40.28343635983862 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34021"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00882229"
      },
      "bbox": [
        16.24189406044639, 3.2574949732358425, 16.604184536944093,
        3.522062669578573
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.214037537714821, -4.669341086372038],
            [-8.997396406312038, -4.696142466762162],
            [-8.809081618882091, -4.717081320437573],
            [-8.615402888112737, -4.740785420981485],
            [-8.421719516456916, -4.764454195401397],
            [-8.19525721685939, -4.78944661914183],
            [-8.194751979090695, -4.785054211513965],
            [-8.111236385293973, -4.794538256144966],
            [-8.120273881963536, -4.883642493273142],
            [-8.098698766133793, -4.8860149288449435],
            [-8.123001710651517, -5.14025955264264],
            [-8.122280464399118, -5.1403450793042955],
            [-8.131340221050095, -5.223208358654733],
            [-8.221302212333484, -5.256783534830071],
            [-8.311273105914655, -5.290345476515084],
            [-8.40125297120896, -5.323894027532551],
            [-8.491241877541947, -5.357429031399946],
            [-8.610833674425391, -5.4015456015015495],
            [-8.615705768707008, -5.444849814528266],
            [-8.657324152474326, -5.439979015125902],
            [-8.790721982076885, -5.424057618230168],
            [-8.924117267086926, -5.408115353768984],
            [-8.957376292137267, -5.404133001476326],
            [-8.978351383473436, -5.577833919309258],
            [-9.11572833301715, -5.561279020748454],
            [-9.235155967092576, -5.546801506514677],
            [-9.32318473042958, -5.5187413820434035],
            [-9.327441687761189, -5.514994176506335],
            [-9.3353527801806, -5.5123994660506295],
            [-9.336647411717852, -5.50804993787962],
            [-9.334238046933335, -5.504986091949641],
            [-9.334687503739932, -5.497187671094745],
            [-9.330534057952017, -5.492689560889455],
            [-9.33094886657931, -5.4868735947645435],
            [-9.325393791052917, -5.479602233294876],
            [-9.323581209318624, -5.4733648487314595],
            [-9.323003690456162, -5.467082857194681],
            [-9.325479819773406, -5.460276469019148],
            [-9.323317167787822, -5.448548602446534],
            [-9.316111917333766, -5.444028557585742],
            [-9.314445716383808, -5.438180998489263],
            [-9.314762219672597, -5.427290641182868],
            [-9.31271259623661, -5.421590995431082],
            [-9.309569171920872, -5.420521637949163],
            [-9.309339675697794, -5.416043351267389],
            [-9.311466308506487, -5.415045385626206],
            [-9.314061676187253, -5.405285816235838],
            [-9.310514547689118, -5.397984389685682],
            [-9.311206530092448, -5.393364819699297],
            [-9.307424437142462, -5.386973081446752],
            [-9.308609909332773, -5.38228542586398],
            [-9.306987182426157, -5.378046121060364],
            [-9.306719073967173, -5.369802492589783],
            [-9.30789396100015, -5.362997420432908],
            [-9.315074624733978, -5.35776992037308],
            [-9.318603623229373, -5.357031157662234],
            [-9.322520492024243, -5.351299629756081],
            [-9.325565258439983, -5.335883740667071],
            [-9.327816885326156, -5.33368736799651],
            [-9.323167134500505, -5.318012001071365],
            [-9.321394423686964, -5.314597264798197],
            [-9.324603653865637, -5.31197950034933],
            [-9.324347635599564, -5.308578997847558],
            [-9.32854336565389, -5.298368653978731],
            [-9.330317885026256, -5.291689030603896],
            [-9.335505291962324, -5.287411134695441],
            [-9.338782402725677, -5.2867021621974635],
            [-9.341118964716577, -5.283181903303404],
            [-9.340108868408766, -5.2724055672072305],
            [-9.34111487576385, -5.266323064603038],
            [-9.339698112999011, -5.263065993119533],
            [-9.34085745368392, -5.253362813472218],
            [-9.338784490716485, -5.243533157924863],
            [-9.340572209042124, -5.239733018077833],
            [-9.336596621126528, -5.23695865717968],
            [-9.335396940261331, -5.233631954119586],
            [-9.327482055571911, -5.2262706030793895],
            [-9.327261427535685, -5.218348168876946],
            [-9.32949374930495, -5.21125449260846],
            [-9.333711967201564, -5.206306525237327],
            [-9.332916431301236, -5.19962221878303],
            [-9.328633289087987, -5.195501019927706],
            [-9.329893685535318, -5.186840764252934],
            [-9.334984608213029, -5.1839784532564845],
            [-9.337137929643882, -5.185868357414367],
            [-9.344884016387315, -5.1875010771181325],
            [-9.350163423092564, -5.180396955886547],
            [-9.351477070829496, -5.176824182940385],
            [-9.355921925638937, -5.174414280120567],
            [-9.359622815643235, -5.175842550860511],
            [-9.363659620930706, -5.175204915453724],
            [-9.368151946951574, -5.170324034170689],
            [-9.374324634725657, -5.167834130912757],
            [-9.37333231109404, -5.161981611217555],
            [-9.374734514963468, -5.157286040235649],
            [-9.380225977343548, -5.157038794831189],
            [-9.379022554001779, -5.151890183022363],
            [-9.385084831968612, -5.136115101454789],
            [-9.387952521129039, -5.133698552123381],
            [-9.391743879639346, -5.126651189842756],
            [-9.38945721337159, -5.122537562427057],
            [-9.384807811233697, -5.123685732252149],
            [-9.381247151650202, -5.114173997773119],
            [-9.382782903360834, -5.111529628819861],
            [-9.381743117094004, -5.103845572841384],
            [-9.387592584966667, -5.092725042330525],
            [-9.385695850735852, -5.0884350047459055],
            [-9.381377996456353, -5.0856766754685605],
            [-9.381949860350526, -5.0807953938744115],
            [-9.379868265153629, -5.077914317390972],
            [-9.380742524249456, -5.073822611626683],
            [-9.37489374166211, -5.07213097489454],
            [-9.366655470613257, -5.063891123815286],
            [-9.363566709641068, -5.057935498227281],
            [-9.363822328340236, -5.0538259480346905],
            [-9.372311066029868, -5.044723652410163],
            [-9.368050235613106, -5.035371727389137],
            [-9.370566132036174, -5.0285820670483785],
            [-9.372092751760162, -5.010720733639214],
            [-9.37003023804115, -5.005071943151298],
            [-9.366513744443479, -5.000068336719265],
            [-9.371867135169019, -4.996111788109173],
            [-9.370786740058238, -4.9850074816138745],
            [-9.372941189603406, -4.980150411668572],
            [-9.370074951886886, -4.972869434299696],
            [-9.371529584614404, -4.971326462391289],
            [-9.371045995013478, -4.964767382346721],
            [-9.367773569622944, -4.959503505100127],
            [-9.358921958641535, -4.959079451588239],
            [-9.357135249390124, -4.955853130766888],
            [-9.35763474462656, -4.9507538035476095],
            [-9.355917771542925, -4.948680944751677],
            [-9.362116255323892, -4.945623259679624],
            [-9.362492389357593, -4.942098580951822],
            [-9.369023790127297, -4.939214931045573],
            [-9.367825918878546, -4.933080048546551],
            [-9.37389567935637, -4.929385279674732],
            [-9.485559810692083, -4.9140507275788385],
            [-9.45047490264441, -4.638593756524574],
            [-9.423508142620626, -4.6420626799962825],
            [-9.400275996901335, -4.648602900880139],
            [-9.255818478973078, -4.664035280062576],
            [-9.241632470424124, -4.66496671018292],
            [-9.227903813877273, -4.667746338509216],
            [-9.214037537714821, -4.669341086372038]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.19240076957793,
          "lat": 33.13049802707647
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35051"],
        "coty_name": ["Sierra"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sierra County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01702370"
      },
      "bbox": [
        -9.485559810692083, -5.577833919309258, -8.098698766133793,
        -4.638593756524574
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.72242383984262, 4.5348027958607995],
            [16.721966750556295, 4.530982789966924],
            [16.722446820255755, 4.526521076191123],
            [16.72485541313869, 4.523783737854573],
            [16.733125168191343, 4.518605115841302],
            [16.740180774771986, 4.512418555239156],
            [16.755181142141637, 4.506967500583994],
            [16.756011730275596, 4.500554686955731],
            [16.750874293891165, 4.4908776763229765],
            [16.74596593386324, 4.48022255197075],
            [16.74459407758828, 4.4685412901280825],
            [16.74760476603249, 4.460679073705999],
            [16.75586811304387, 4.456532418960886],
            [16.757602472681803, 4.448885934512544],
            [16.764688367299048, 4.445184397602622],
            [16.786084448543278, 4.425439703225638],
            [16.79257083035606, 4.416847332999424],
            [16.797532333272727, 4.408818745058891],
            [16.80565455775038, 4.398243902632799],
            [16.809102305056857, 4.39244663037049],
            [16.81417833539786, 4.387550136365736],
            [16.824152709928942, 4.3817444140182555],
            [16.83050976729047, 4.374051880964115],
            [16.8335440539456, 4.367743841363454],
            [16.835679625522925, 4.35843401039016],
            [16.839438535970576, 4.3225401401686],
            [16.841154756500146, 4.311790188816049],
            [16.847576003761677, 4.287992799222629],
            [16.8529355668697, 4.27675624938565],
            [16.85556928892037, 4.268906412493847],
            [16.85854717388803, 4.254109965183086],
            [16.86001963074788, 4.236580565100936],
            [16.861613442729684, 4.228558884927271],
            [16.855250125765608, 4.227187024259033],
            [16.793775152734142, 4.2469608454644145],
            [16.696987132502056, 4.277726629370518],
            [16.623002650232728, 4.300878155983547],
            [16.599141883284616, 4.307854333418603],
            [16.580224655095414, 4.313391977008803],
            [16.607438543380916, 4.356756307720159],
            [16.655788449539276, 4.432153271962266],
            [16.69820790901486, 4.497101236751827],
            [16.72242383984262, 4.5348027958607995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.02423213239048, "lat": 41.1525286747566 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36087"],
        "coty_name": ["Rockland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockland County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00974142"
      },
      "bbox": [
        16.580224655095414, 4.227187024259033, 16.861613442729684,
        4.5348027958607995
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.0174774402241, -0.5552373504809934],
            [16.111334390076202, -0.5355375459966785],
            [16.166159735002726, -0.5238960323019209],
            [16.263145278297007, -0.5032915870058867],
            [16.33546804848764, -0.48759521173847065],
            [16.36438119318854, -0.48163348794928973],
            [16.37591037437126, -0.5129718870060265],
            [16.382644641845218, -0.5289045294962216],
            [16.415845322747913, -0.6021675039714532],
            [16.443454295410582, -0.6637242040300915],
            [16.475181784276824, -0.7262990369973211],
            [16.505737373489033, -0.7804404249568617],
            [16.489410024112374, -0.7885272788429736],
            [16.48620923525086, -0.785409131762827],
            [16.481041358641445, -0.7744817721860818],
            [16.472672594153554, -0.7694588481244313],
            [16.471324943547348, -0.7641088214516032],
            [16.47419114345923, -0.7499354957519021],
            [16.468200794428043, -0.7334213755585693],
            [16.461836543513627, -0.7277715643114369],
            [16.44538160327635, -0.7293395903142693],
            [16.437270491011077, -0.7236173657837957],
            [16.433789248078675, -0.7194615521572816],
            [16.426490770562495, -0.7065117974841789],
            [16.424792923272218, -0.7022310607228951],
            [16.427547327760582, -0.6929395215534385],
            [16.433443460151828, -0.6928542971630741],
            [16.44748641247897, -0.6990246056098907],
            [16.447159578498354, -0.6934594178250242],
            [16.441697266978647, -0.6748674304606644],
            [16.4333161343804, -0.6674825831939253],
            [16.43260649278616, -0.6632874101235489],
            [16.43376356833752, -0.6574055519443027],
            [16.428476896106023, -0.6522211119592282],
            [16.416417339873803, -0.6480010835049612],
            [16.415402818071698, -0.6464414567602046],
            [16.419419453606537, -0.6412298058439956],
            [16.417858991048817, -0.6281313663815926],
            [16.41022923401888, -0.6269096480777129],
            [16.411024551882324, -0.606297133616249],
            [16.400366528655102, -0.6040489460439314],
            [16.3935221299739, -0.5988078801447483],
            [16.390394206804746, -0.5923727579783458],
            [16.38537711047038, -0.5924645143525974],
            [16.381254540026955, -0.5958183964907623],
            [16.376293629493574, -0.5954317916750596],
            [16.37136820402182, -0.5925004885998648],
            [16.37054245003065, -0.5851893633747959],
            [16.363999769617855, -0.5736660662240286],
            [16.35895228808039, -0.5709019411667808],
            [16.353752678099674, -0.5544261402069148],
            [16.347232067735124, -0.5520211347751195],
            [16.339441884862552, -0.5536924955684813],
            [16.334892262413238, -0.5584726390853194],
            [16.332249299505893, -0.5583258957622819],
            [16.324263070108053, -0.5519994187538597],
            [16.309176365548545, -0.5543450187898992],
            [16.303386113402798, -0.5521425889018237],
            [16.294534588255637, -0.5541622852724712],
            [16.292652071124593, -0.5619086228548457],
            [16.28154523700913, -0.5564551742240108],
            [16.284818535072457, -0.5463412075825286],
            [16.28443684330055, -0.5391255618134386],
            [16.277342744729616, -0.5258534282727758],
            [16.26904875271481, -0.5250625394715723],
            [16.265684206778953, -0.5192759064331122],
            [16.26216031859166, -0.5172682574223834],
            [16.239968792105373, -0.5202305660859607],
            [16.24037092111978, -0.526649668631471],
            [16.246661176294452, -0.534375969903867],
            [16.248004605915547, -0.5415820995766029],
            [16.236666776488157, -0.550110823037879],
            [16.241469733858658, -0.5599329679975316],
            [16.247818224351427, -0.568835057315429],
            [16.25083565244268, -0.5760618635284449],
            [16.265004577591228, -0.5976835969009813],
            [16.273495061259087, -0.6073887050424391],
            [16.281240623041036, -0.6115132834908442],
            [16.29325115119421, -0.6141665210683624],
            [16.30118720070306, -0.6138575548368835],
            [16.303634855442457, -0.6100671153168602],
            [16.307127315683292, -0.6108231724512372],
            [16.31377762254823, -0.619271108573417],
            [16.32703142658427, -0.6440770369062403],
            [16.33434819094409, -0.6476409629400707],
            [16.3396565849315, -0.6435629224652806],
            [16.337797531176133, -0.6362105460550693],
            [16.33427941346868, -0.6324735802955923],
            [16.33736250676587, -0.6215631325307078],
            [16.340009457448648, -0.6180330994584338],
            [16.33868884662758, -0.6141041314860963],
            [16.34658660309021, -0.6144748783195072],
            [16.348612759308907, -0.6216273275218629],
            [16.35296987130888, -0.6302764946125711],
            [16.35317620670645, -0.6394626106203384],
            [16.360617803715016, -0.6490853519620569],
            [16.361433836446544, -0.6549424182412457],
            [16.359570164593876, -0.6712103149648441],
            [16.360966286693973, -0.6770357923269095],
            [16.367064108289377, -0.684265520522254],
            [16.369223741459756, -0.6851009758359399],
            [16.375357918466666, -0.6929656251078091],
            [16.380649933423243, -0.7015372147948709],
            [16.391795924188646, -0.7140352733941904],
            [16.402871343446698, -0.7387057053258989],
            [16.408482315801276, -0.7464560955144854],
            [16.417408784254594, -0.7470845426160131],
            [16.4229667541191, -0.7430823652209345],
            [16.427332917086726, -0.743983021001486],
            [16.430647445234793, -0.7486850388513996],
            [16.426491016011838, -0.753971056570955],
            [16.42951530905182, -0.7644406499860961],
            [16.42576864683915, -0.7680287062129993],
            [16.423476937133938, -0.7741933375139414],
            [16.42764267368333, -0.7820244017237151],
            [16.43178530309191, -0.7823208190148937],
            [16.432899338967022, -0.7915048216553946],
            [16.435895006542996, -0.793670682361707],
            [16.4354893638798, -0.7978760890399204],
            [16.441428022592802, -0.8043683762645505],
            [16.450198484674633, -0.80901617280735],
            [16.455929891540436, -0.8066921105427469],
            [16.462035599467523, -0.818461159491404],
            [16.46882964888721, -0.824556093877786],
            [16.47143566513724, -0.8305805068255385],
            [16.46958403247169, -0.8313934310677371],
            [16.463394455020993, -0.8233646719596361],
            [16.458280029083976, -0.8239993338123159],
            [16.458046645387903, -0.8316965435751665],
            [16.461992364964985, -0.8342498208218849],
            [16.464997330823675, -0.8453235664503164],
            [16.4703920146126, -0.8498482252083546],
            [16.471699846996213, -0.85376942980398],
            [16.4750610049062, -0.8570583455484683],
            [16.48020703292623, -0.8568622223940461],
            [16.48104974805986, -0.8620398862786671],
            [16.483377543101618, -0.8643278163539702],
            [16.48307561887539, -0.8734512340100524],
            [16.486234216851877, -0.8762167093479997],
            [16.490528629950123, -0.877560298737725],
            [16.502569336675485, -0.8924614110793584],
            [16.503420757416254, -0.8964002451904582],
            [16.50959117693722, -0.8971721503665324],
            [16.50904464411824, -0.9090236490590241],
            [16.510822251100805, -0.9164720957930657],
            [16.517270270763944, -0.9214167886443286],
            [16.525338127170265, -0.9336730921295372],
            [16.52291880390364, -0.9354135849341294],
            [16.520261779212852, -0.9418108471126861],
            [16.48763745551719, -0.9267803858879682],
            [16.478440496442104, -0.9218390544086936],
            [16.47329297774777, -0.9182665496232144],
            [16.454849424067586, -0.8988340947596168],
            [16.456031167835405, -0.8951496588165591],
            [16.453778788272395, -0.8900245325279432],
            [16.452951612299277, -0.8797493099127734],
            [16.45408935003732, -0.8755549736446162],
            [16.451056153275747, -0.8664839288448722],
            [16.441290967099228, -0.8547176154551784],
            [16.44081668205267, -0.8520478128765099],
            [16.436346883395917, -0.8443227530992836],
            [16.419580904226354, -0.8334685596653985],
            [16.417075785950697, -0.8334511253359211],
            [16.41271778828849, -0.8298994633464317],
            [16.413191730660696, -0.8230899947529925],
            [16.406469020468748, -0.825322684756592],
            [16.40315361792403, -0.822121852375973],
            [16.40396924616779, -0.8159463136451205],
            [16.398113131740175, -0.812072459956755],
            [16.392359693557168, -0.7982501260530814],
            [16.385530456627702, -0.7914267110907106],
            [16.364290160739834, -0.7828555200177199],
            [16.35504066274461, -0.7837860183902962],
            [16.353377123356008, -0.7793424392081861],
            [16.350486552438554, -0.777390832054847],
            [16.35210298204824, -0.7749393636552874],
            [16.357965059385887, -0.7709667802010867],
            [16.359117207061093, -0.7662320588966867],
            [16.357010793313155, -0.7615220506678558],
            [16.357583277800455, -0.7568277907116834],
            [16.350477083021236, -0.754078952948058],
            [16.34770271419712, -0.7564997403425247],
            [16.34408692865072, -0.7564394549850333],
            [16.33886597281281, -0.7503951428215243],
            [16.336585839218817, -0.7396001351842869],
            [16.330875534435442, -0.7366586517452035],
            [16.326000131423083, -0.7393339090870936],
            [16.319787995981006, -0.7411528785415723],
            [16.312119426944854, -0.7398113513039135],
            [16.309552130495483, -0.7362796903103731],
            [16.307898746778065, -0.7280228646270942],
            [16.301985680589688, -0.7239401139753299],
            [16.29797007627039, -0.7267056263356841],
            [16.29486478420873, -0.7261814087910128],
            [16.29106836779288, -0.7205821969109947],
            [16.292866184461662, -0.7164841144200186],
            [16.291542500561032, -0.7096740095020115],
            [16.28654736232083, -0.7103609646634488],
            [16.286118550590526, -0.7145694039755518],
            [16.281345841309225, -0.7180755676973348],
            [16.279721022157993, -0.7146611875194374],
            [16.282525669957295, -0.7121651644475061],
            [16.28137418516209, -0.7071987648307282],
            [16.277996862835717, -0.7061551293917139],
            [16.27415823657859, -0.7024995150825135],
            [16.26992973354509, -0.703182007026081],
            [16.26649479603183, -0.701054184208302],
            [16.26386506012176, -0.7033782119821941],
            [16.26134393968542, -0.7000864359194624],
            [16.25824268690081, -0.7027779748544961],
            [16.254108146255696, -0.7148885313201032],
            [16.24931848456162, -0.7137603964187265],
            [16.240804986725383, -0.7169214134954226],
            [16.232554599827964, -0.7145035692637814],
            [16.220341649304274, -0.7148213448202285],
            [16.21282646717055, -0.7130616116970224],
            [16.204182759169605, -0.7009610011310721],
            [16.179145909860082, -0.6821517215798092],
            [16.170688020760483, -0.6801107436235297],
            [16.164179986657363, -0.6534704962687442],
            [16.076844471338774, -0.594598307769887],
            [16.0174774402241, -0.5552373504809934]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.00789357167731, "lat": 36.4049888250134 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37053"],
        "coty_name": ["Currituck"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Currituck County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01026125"
      },
      "bbox": [
        16.0174774402241, -0.9418108471126861, 16.525338127170265,
        -0.48163348794928973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.921442644221393, -1.7297878009579066],
            [12.968135565776219, -1.697706554164323],
            [13.057426235160557, -1.682659236502041],
            [13.060121984249049, -1.6817799972515302],
            [13.0552848576112, -1.652215823735627],
            [13.10579050781809, -1.6437760318929553],
            [13.17868334591162, -1.6450690968239647],
            [13.192677104080161, -1.645486926220728],
            [13.201465989265749, -1.7108144844518303],
            [13.204993591609588, -1.7355543414399965],
            [13.211843426180309, -1.7888357297803095],
            [13.222355476850355, -1.8752460016001917],
            [13.226229901199899, -1.9064475387756377],
            [13.236649973443335, -1.9872598137980482],
            [13.2441752364027, -2.0440644882276633],
            [13.259071839165438, -2.1509236074885565],
            [13.240685773427868, -2.1542514335529055],
            [13.167258866476677, -2.167936450304241],
            [13.16669956526829, -2.1680405540220824],
            [13.164746883006131, -2.163612310875888],
            [13.164162531837714, -2.1560958483817254],
            [13.157737133923375, -2.148029026908191],
            [13.153451736682038, -2.1462543603177533],
            [13.15090774811395, -2.1433348286272613],
            [13.151645320448523, -2.1380798762308624],
            [13.147075377717893, -2.128898552486127],
            [13.14090399885423, -2.1266308727276555],
            [13.1365455783186, -2.1206248765262603],
            [13.13689856778885, -2.1098327830451895],
            [13.136345449566639, -2.1026695470746444],
            [13.133451205134756, -2.094696243967313],
            [13.129933010189207, -2.0918719374310037],
            [13.12422044875724, -2.089922131861669],
            [13.110973351305638, -2.081002688897944],
            [13.108280017160501, -2.0752453635284183],
            [13.100445111773261, -2.066384023047012],
            [13.094719951843002, -2.062510366220542],
            [13.089686578187601, -2.0607321678470107],
            [13.080815593106523, -2.0541565791092595],
            [13.077606718459489, -2.053276351295116],
            [13.065333324830185, -2.052909460865453],
            [13.06133595562225, -2.051539538284966],
            [13.056271499818793, -2.045183510648256],
            [13.050276182525652, -2.0392675426715474],
            [13.046835123733173, -2.0370999255079583],
            [13.043430012065869, -2.0323754969028824],
            [13.041236362229848, -2.023870048093675],
            [13.034230250536108, -2.018915752148053],
            [13.026524498742551, -2.0177515216135267],
            [13.020523516258413, -2.013902757950644],
            [13.01757875236549, -2.0095220728843395],
            [13.015610373716564, -2.003539583988097],
            [13.016389556267232, -1.995696630084581],
            [13.020971708036555, -1.9883640454668792],
            [13.020689079734934, -1.9838994100629626],
            [13.018777328683406, -1.9803109715769218],
            [13.012476512593498, -1.9742717668471756],
            [13.005941344533653, -1.9728328110415014],
            [12.992390259423159, -1.9788373227887424],
            [12.98407979700142, -1.9818161078380006],
            [12.980815583262183, -1.9819526291056246],
            [12.972573139686519, -1.9799117366745878],
            [12.966929421705485, -1.9809285537699473],
            [12.963294990327057, -1.97694671855075],
            [12.9591978216812, -1.9769504162504172],
            [12.952580731054729, -1.9809844380148987],
            [12.947018938581662, -1.981327893085248],
            [12.939476301994878, -1.9792210467645124],
            [12.933240224367283, -1.976417261108155],
            [12.922876020299526, -1.9729923342226254],
            [12.91383854046985, -1.9746165048978144],
            [12.90810814380502, -1.9671359797375545],
            [12.907101798228355, -1.9640126292119229],
            [12.907448024133794, -1.955706703046242],
            [12.910480556300971, -1.9511638368396598],
            [12.910865232612826, -1.9428738068408271],
            [12.905488275285492, -1.9360186599445746],
            [12.902173278594303, -1.935045325278362],
            [12.891388004945615, -1.9286516373771443],
            [12.886395703393788, -1.9233522069460522],
            [12.887195919047267, -1.91412091812604],
            [12.89217617449668, -1.910752990711288],
            [12.89350439249843, -1.9059382023610387],
            [12.891218036110443, -1.8998515630960926],
            [12.883874913883501, -1.8865081959425043],
            [12.879828995942976, -1.8826625766899328],
            [12.875955920062198, -1.8818437449693337],
            [12.872393919335984, -1.8832131891213715],
            [12.870597258148393, -1.8804576243039648],
            [12.873384584235485, -1.8731243583117079],
            [12.877322867393643, -1.8688755057099018],
            [12.87989994319615, -1.8696930272191545],
            [12.888374960770058, -1.8802128106947849],
            [12.889602116462962, -1.882877936174464],
            [12.894774338295141, -1.88380492178743],
            [12.90016382593637, -1.8783004167351853],
            [12.901353740340443, -1.87364898355858],
            [12.903481219143607, -1.872056825493081],
            [12.909731338848617, -1.8755159695350723],
            [12.912342673849151, -1.8789684594815173],
            [12.917576407850463, -1.8755869916964403],
            [12.918031385043944, -1.8708009655749331],
            [12.917182204810569, -1.8585853857407522],
            [12.920315778515713, -1.8527706576122474],
            [12.926555509896179, -1.8534728117033685],
            [12.931912278265258, -1.8582158336768426],
            [12.93737536266367, -1.8605547265184206],
            [12.942946692042668, -1.8605330578412438],
            [12.947109855929229, -1.8556772324337445],
            [12.947861314663314, -1.8472241380027943],
            [12.942462128000562, -1.8338404388756377],
            [12.938983711223047, -1.8311325299130534],
            [12.927389734075847, -1.8289794764270504],
            [12.919063215679412, -1.8245485208189536],
            [12.91902048023957, -1.8216898022866876],
            [12.922126749749742, -1.8141919457839977],
            [12.924118752208072, -1.8124534856263443],
            [12.933054769673966, -1.8096759000281621],
            [12.938288551269556, -1.8097262375285943],
            [12.948784476421563, -1.8148353826713353],
            [12.955040907004237, -1.8131936358365883],
            [12.95756571444636, -1.8049547181732148],
            [12.956188681781683, -1.8017782323312475],
            [12.95118255020651, -1.7957568242702509],
            [12.946961529066318, -1.7883738823797024],
            [12.946709783814477, -1.7826864771030881],
            [12.949518188549863, -1.774311437702009],
            [12.948410233908282, -1.768633002932096],
            [12.943564866213483, -1.7631173174657315],
            [12.941434491776048, -1.7585081760509875],
            [12.940619742843845, -1.7466916896181586],
            [12.936085078555982, -1.738154620364465],
            [12.932850810874541, -1.736064820082135],
            [12.925765884947552, -1.7350127140110185],
            [12.921442644221393, -1.7297878009579066]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.21276386964875,
          "lat": 35.793356764348296
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37057"],
        "coty_name": ["Davidson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Davidson County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01008548"
      },
      "bbox": [
        12.870597258148393, -2.1680405540220824, 13.259071839165438,
        -1.6437760318929553
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.67222748949601, -1.6904093127269049],
            [12.695739940339072, -1.6878374992167648],
            [12.747770152748714, -1.6816984607393306],
            [12.82866958400304, -1.6696587244160797],
            [12.83158011236088, -1.6717880935044596],
            [12.83642115050118, -1.6717561410008666],
            [12.83881239284318, -1.6682439721659366],
            [12.845080609408594, -1.6630215051489357],
            [12.843871248100488, -1.655179915159618],
            [12.845751577732294, -1.6517801205797025],
            [12.851715890024643, -1.6494698382135065],
            [12.855999531344755, -1.6528044875777657],
            [12.858157948601283, -1.6596051084155052],
            [12.863985281061924, -1.6675090341460106],
            [12.869028644193405, -1.6711523436226479],
            [12.874276978897116, -1.6784017210524176],
            [12.883993361398256, -1.684074290302851],
            [12.891519051468155, -1.6869585491811137],
            [12.895124644638235, -1.6894955102979738],
            [12.900658920747869, -1.7002904651642112],
            [12.901583678561314, -1.7042225638769373],
            [12.896178213166952, -1.7120143992133459],
            [12.896330256159635, -1.7166754494231293],
            [12.899334462954013, -1.7202013458608194],
            [12.90752701231235, -1.7250663688321086],
            [12.921442644221393, -1.7297878009579066],
            [12.925765884947552, -1.7350127140110185],
            [12.932850810874541, -1.736064820082135],
            [12.936085078555982, -1.738154620364465],
            [12.940619742843845, -1.7466916896181586],
            [12.941434491776048, -1.7585081760509875],
            [12.943564866213483, -1.7631173174657315],
            [12.948410233908282, -1.768633002932096],
            [12.949518188549863, -1.774311437702009],
            [12.946709783814477, -1.7826864771030881],
            [12.946961529066318, -1.7883738823797024],
            [12.95118255020651, -1.7957568242702509],
            [12.956188681781683, -1.8017782323312475],
            [12.95756571444636, -1.8049547181732148],
            [12.955040907004237, -1.8131936358365883],
            [12.948784476421563, -1.8148353826713353],
            [12.938288551269556, -1.8097262375285943],
            [12.933054769673966, -1.8096759000281621],
            [12.924118752208072, -1.8124534856263443],
            [12.922126749749742, -1.8141919457839977],
            [12.91902048023957, -1.8216898022866876],
            [12.919063215679412, -1.8245485208189536],
            [12.927389734075847, -1.8289794764270504],
            [12.938983711223047, -1.8311325299130534],
            [12.942462128000562, -1.8338404388756377],
            [12.947861314663314, -1.8472241380027943],
            [12.947109855929229, -1.8556772324337445],
            [12.942946692042668, -1.8605330578412438],
            [12.93737536266367, -1.8605547265184206],
            [12.931912278265258, -1.8582158336768426],
            [12.926555509896179, -1.8534728117033685],
            [12.920315778515713, -1.8527706576122474],
            [12.917182204810569, -1.8585853857407522],
            [12.918031385043944, -1.8708009655749331],
            [12.917576407850463, -1.8755869916964403],
            [12.912342673849151, -1.8789684594815173],
            [12.909731338848617, -1.8755159695350723],
            [12.903481219143607, -1.872056825493081],
            [12.901353740340443, -1.87364898355858],
            [12.90016382593637, -1.8783004167351853],
            [12.894774338295141, -1.88380492178743],
            [12.889602116462962, -1.882877936174464],
            [12.888374960770058, -1.8802128106947849],
            [12.87989994319615, -1.8696930272191545],
            [12.877322867393643, -1.8688755057099018],
            [12.873384584235485, -1.8731243583117079],
            [12.870597258148393, -1.8804576243039648],
            [12.872393919335984, -1.8832131891213715],
            [12.875955920062198, -1.8818437449693337],
            [12.879828995942976, -1.8826625766899328],
            [12.883874913883501, -1.8865081959425043],
            [12.891218036110443, -1.8998515630960926],
            [12.89350439249843, -1.9059382023610387],
            [12.89217617449668, -1.910752990711288],
            [12.887195919047267, -1.91412091812604],
            [12.886395703393788, -1.9233522069460522],
            [12.891388004945615, -1.9286516373771443],
            [12.902173278594303, -1.935045325278362],
            [12.905488275285492, -1.9360186599445746],
            [12.910865232612826, -1.9428738068408271],
            [12.910480556300971, -1.9511638368396598],
            [12.907448024133794, -1.955706703046242],
            [12.907101798228355, -1.9640126292119229],
            [12.90810814380502, -1.9671359797375545],
            [12.903910129757417, -1.9589926298385407],
            [12.898167243540039, -1.9542560118304193],
            [12.897180025470822, -1.9499764159487047],
            [12.893671506669499, -1.9433503513306816],
            [12.887478909488197, -1.9378132573539688],
            [12.883209915115144, -1.9369420665010106],
            [12.879313362767359, -1.9443244186145108],
            [12.876275011702086, -1.9361045839562598],
            [12.87239683202173, -1.9326121764638575],
            [12.868610241579532, -1.932044185932782],
            [12.866146294786182, -1.9346111132783002],
            [12.864336966764318, -1.9416125550670764],
            [12.857868438334803, -1.9392739872707316],
            [12.853590523538823, -1.9347119148794134],
            [12.850767229806989, -1.933648571853164],
            [12.846285938143634, -1.9356864191732368],
            [12.84134153820833, -1.9337505369485317],
            [12.840795591874821, -1.93034771132377],
            [12.833315459478133, -1.9288447833942342],
            [12.829407187416745, -1.9233900634268912],
            [12.82276286913582, -1.9223726512464558],
            [12.814741220677877, -1.9134990126166005],
            [12.810286334938247, -1.9124123252160836],
            [12.808439505439818, -1.9091130158538054],
            [12.80181135538393, -1.9075558280337195],
            [12.793301537853612, -1.903951086259463],
            [12.788890447426404, -1.907125028050204],
            [12.786543387004269, -1.9005774105597133],
            [12.782905327163295, -1.9012996419351609],
            [12.7812211073846, -1.9053725052834414],
            [12.775788233574088, -1.906750309379393],
            [12.773019969437055, -1.9051644391074258],
            [12.774246635357532, -1.900979502236237],
            [12.764262306003461, -1.8944843351456235],
            [12.762920369159856, -1.8927615217051996],
            [12.756272258178653, -1.894411924775747],
            [12.75398969038605, -1.8871786736658154],
            [12.743505231941803, -1.890113521804204],
            [12.740197456392819, -1.8889231310907855],
            [12.732488767284915, -1.8917231559761987],
            [12.722723389460828, -1.8914344607978772],
            [12.720888832131122, -1.8885577459406582],
            [12.723632156235368, -1.8825811456582848],
            [12.71842050746272, -1.8807512074730042],
            [12.71681530089241, -1.8828771022572752],
            [12.703367002042992, -1.8785004549698183],
            [12.704378091526214, -1.886527534228004],
            [12.701744636932743, -1.8865197797171898],
            [12.699145724230508, -1.8912466620960555],
            [12.692723738719339, -1.889736099577184],
            [12.683134137855816, -1.796409490162777],
            [12.67222748949601, -1.6904093127269049]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.54452761835906, "lat": 35.92911570751984 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37059"],
        "coty_name": ["Davie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Davie County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01008549"
      },
      "bbox": [
        12.67222748949601, -1.9671359797375545, 12.95756571444636,
        -1.6494698382135065
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.131256979525599, -1.249598264276079],
            [14.126242712078671, -1.2185796167785758],
            [14.112231243781316, -1.133262073986003],
            [14.099272712395665, -1.053316410889326],
            [14.08432236450517, -0.9599736734888902],
            [14.080429948067524, -0.9450124022644459],
            [14.129044877004048, -0.9359058333188465],
            [14.184442831402725, -0.9255983229853194],
            [14.230011776044465, -0.9181228159285674],
            [14.289174613444056, -0.9072634226397255],
            [14.304617385396561, -0.9043048807543077],
            [14.3350337468166, -0.8973532811875587],
            [14.34582005341199, -0.8951782104838538],
            [14.348367000528619, -0.9040050299601297],
            [14.342336239507624, -0.9049530341227077],
            [14.339670806818797, -0.9072740240743858],
            [14.33908494220852, -0.9126478382712312],
            [14.341730436546131, -0.9149349219155547],
            [14.33490753396426, -0.9183864606201662],
            [14.332144399879382, -0.9228928033365669],
            [14.327097294750386, -0.9235593901649355],
            [14.319063461117285, -0.9289146395755391],
            [14.32113910471217, -0.9331227751438049],
            [14.31849788238155, -0.942192038876997],
            [14.317608063868644, -0.949018095046833],
            [14.318651509277082, -0.9545519240054434],
            [14.321687449744003, -0.9566818330865016],
            [14.31956509431637, -0.9900843370373527],
            [14.347574979492148, -1.1338135725668448],
            [14.372049816702711, -1.2593929974330402],
            [14.380827369516169, -1.2652666046760956],
            [14.38269471632983, -1.2653736048551643],
            [14.362219415931099, -1.3662008224515856],
            [14.371807942226772, -1.4248123556347727],
            [14.365370072287933, -1.4233782622927358],
            [14.32296276375806, -1.4127662126947313],
            [14.302583799176269, -1.4069909393491622],
            [14.254373476281176, -1.3924967160382493],
            [14.236391668268263, -1.3937966660263557],
            [14.226102637398203, -1.3962271457075015],
            [14.201443384391512, -1.4059707600753655],
            [14.17736026728554, -1.4095774114201756],
            [14.171920042365649, -1.4084387544625903],
            [14.174095826472806, -1.4053036572021778],
            [14.169700581060974, -1.4035612092035272],
            [14.166661829670284, -1.3974846489845647],
            [14.162281273709024, -1.399011390847141],
            [14.15417545744497, -1.3977417325816517],
            [14.157252324054461, -1.3948557555661214],
            [14.155058225559994, -1.3901374121830397],
            [14.140985782434763, -1.3060999676849345],
            [14.131256979525599, -1.249598264276079]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.6527331862503, "lat": 36.304036444124044 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37077"],
        "coty_name": ["Granville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Granville County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01008556"
      },
      "bbox": [
        14.080429948067524, -1.4248123556347727, 14.38269471632983,
        -0.8951782104838538
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.446463692427075, -1.7715074660845989],
            [11.452633097058044, -1.768362880415566],
            [11.460039253327203, -1.7693662278064441],
            [11.468606459420469, -1.7753063336285506],
            [11.471473145298216, -1.7761106808968268],
            [11.474654540024996, -1.7733155414678783],
            [11.477669423920947, -1.7786699405599486],
            [11.48439197772052, -1.780948798200564],
            [11.487498036079572, -1.776211537533533],
            [11.496396288300975, -1.7747711770523973],
            [11.506200024212335, -1.7703071357051052],
            [11.509985699276976, -1.7751559413358495],
            [11.513771158453883, -1.7827577574440996],
            [11.518260714059968, -1.7896432084901086],
            [11.518486482327441, -1.799032815070473],
            [11.526220205857825, -1.8113147683318938],
            [11.529285629547608, -1.8129037304592588],
            [11.538681215341313, -1.8113176343061683],
            [11.545928314338402, -1.8066815261919666],
            [11.55174545452798, -1.8082725075242032],
            [11.565676018355136, -1.8061766968828081],
            [11.566339548990571, -1.8109965380557675],
            [11.571210403009257, -1.815592136220703],
            [11.570709742705846, -1.8187843239097266],
            [11.57197077403878, -1.8263452322554397],
            [11.576848339988949, -1.8305785886172488],
            [11.579319079483996, -1.8353269598540167],
            [11.578100829463894, -1.8409397709575472],
            [11.582069983894314, -1.8463653568659604],
            [11.613227350696441, -1.8990754074741705],
            [11.610431344767461, -1.9012549136312331],
            [11.60587391107787, -1.8995526456324798],
            [11.60645055935961, -1.9059974624868676],
            [11.601814731014429, -1.9092233514825276],
            [11.600126455159169, -1.9136930469945328],
            [11.60073629410082, -1.921940650381545],
            [11.612341947650895, -1.9437942014725755],
            [11.626958908963227, -1.964053794629121],
            [11.672893901891415, -1.9885454715535034],
            [11.676680906590127, -1.9980921753689944],
            [11.676885728778684, -2.0101620919218535],
            [11.678214919690479, -2.0145878155539996],
            [11.671386103840788, -2.0205151603585185],
            [11.670855721870263, -2.0240911730154902],
            [11.666266242427744, -2.0275881776089855],
            [11.661368704476773, -2.0267482764366807],
            [11.659687058738012, -2.0223634814389024],
            [11.651945617720383, -2.0184340931437195],
            [11.644545911268057, -2.0197165067317204],
            [11.641103946630793, -2.0310873804048217],
            [11.641365306215508, -2.0379632935064578],
            [11.638978345129429, -2.041100789068835],
            [11.637231250963751, -2.046850378995646],
            [11.629012939724193, -2.054315874663085],
            [11.620409321601613, -2.0577133074585996],
            [11.617033013124288, -2.057402260911746],
            [11.610736733341346, -2.0599288041484254],
            [11.609339820659423, -2.0622400133158645],
            [11.591011539198051, -2.0610376003541],
            [11.58842970333073, -2.0618897104244187],
            [11.588617248243416, -2.0709837175976045],
            [11.582594256037936, -2.0797192327229737],
            [11.57705549626163, -2.0830108037286656],
            [11.575699059373354, -2.0905556279307693],
            [11.572688345651494, -2.09247409063139],
            [11.567807520885113, -2.0918710970497063],
            [11.565511264243387, -2.09417051792357],
            [11.557079546217995, -2.093563235507748],
            [11.556150740579314, -2.088977079012966],
            [11.552926402705259, -2.081780846543063],
            [11.549655198583602, -2.077966312437345],
            [11.557268317364302, -2.0757015726929877],
            [11.55444596776329, -2.069605299819047],
            [11.554462222325656, -2.0617499143104476],
            [11.549529209667542, -2.0556094827735483],
            [11.54927470633169, -2.0439772408746277],
            [11.546095838401627, -2.0318778681865264],
            [11.542325025586841, -2.0272016140756484],
            [11.545539030946175, -2.0240114387219945],
            [11.543329754877984, -2.017217164026754],
            [11.546021349490225, -2.012468374802495],
            [11.541705460566844, -2.0076610660259515],
            [11.537566981543543, -2.00514668013323],
            [11.534111638171536, -1.9993554932503275],
            [11.537375936343645, -1.9952680887471768],
            [11.53483765007154, -1.9916452582702195],
            [11.539898102592332, -1.9871137745091985],
            [11.531967303754904, -1.9868416268152114],
            [11.528447221194462, -1.9904219883340488],
            [11.52392376690573, -1.9870979477044846],
            [11.521728359588964, -1.9891076851382037],
            [11.521291971359664, -1.9933093157157082],
            [11.515319357525465, -1.9880736679079385],
            [11.50858249776707, -1.9855244057312385],
            [11.50777503493672, -1.981240865357719],
            [11.50112285940296, -1.9773198280254158],
            [11.500356190278332, -1.974918152555558],
            [11.495611613281879, -1.9728808722277138],
            [11.498501779565535, -1.9651799855750438],
            [11.502603938472058, -1.9659542096777607],
            [11.503395956540782, -1.9629605951728004],
            [11.496727411162508, -1.9581803329228153],
            [11.497719832069262, -1.9508535358057524],
            [11.494779999139688, -1.933966596185105],
            [11.490973906523807, -1.9334261724853141],
            [11.483038828649324, -1.9224638708796629],
            [11.485615654653134, -1.9195347038297772],
            [11.48998295965254, -1.9248172222986193],
            [11.491862056109063, -1.9223242056631373],
            [11.489133443466113, -1.9134503014807187],
            [11.485633167727862, -1.9096507317559008],
            [11.48033051193542, -1.912148415780571],
            [11.476699608601377, -1.9100771679688788],
            [11.473087353034975, -1.9101988840619437],
            [11.462919938943012, -1.915934448827306],
            [11.458446578182642, -1.915928209820506],
            [11.45561221443535, -1.9207878876825346],
            [11.45557425892711, -1.9252134086142412],
            [11.446023372384861, -1.9224171434839283],
            [11.443253512550116, -1.9265145128108327],
            [11.445484489613014, -1.9332965819530739],
            [11.44819372088488, -1.9375390970816182],
            [11.447194535170826, -1.942444849694408],
            [11.442058071988166, -1.9395861057614563],
            [11.438071607001207, -1.9337576626056976],
            [11.428248984286322, -1.9311291704095075],
            [11.427446527427934, -1.9232605157005278],
            [11.430834524117726, -1.9191055136537474],
            [11.430423991163636, -1.916858463585082],
            [11.417890339004863, -1.9086621328004834],
            [11.412472816850235, -1.9077395144930258],
            [11.405401383331629, -1.9010874845970152],
            [11.402362912949794, -1.8968843835892615],
            [11.401879465882889, -1.8922738409594484],
            [11.396596176953707, -1.8975179607200137],
            [11.393362317662957, -1.898713563702692],
            [11.39192889536886, -1.9030341482247213],
            [11.394342000023208, -1.9103911606027726],
            [11.393865595823684, -1.9125038549484614],
            [11.387444154973682, -1.9138338274690843],
            [11.385159013368709, -1.9109898117364719],
            [11.372856347039288, -1.911485258254147],
            [11.370778368204906, -1.9070647401937761],
            [11.372348114423739, -1.8967858566358846],
            [11.371064822617381, -1.8889652484862933],
            [11.365966448607747, -1.876823320577017],
            [11.362900803633247, -1.8733108895123889],
            [11.360533845663172, -1.8660034974615454],
            [11.357718751148582, -1.8643749864331358],
            [11.354085086970729, -1.8587203218103685],
            [11.350329593726713, -1.8615002456368983],
            [11.348552932317265, -1.8659541842873226],
            [11.341300807945041, -1.8682243311242768],
            [11.338489972027423, -1.8733377778055122],
            [11.333784672670559, -1.8756951581849612],
            [11.329758623797364, -1.871457860133543],
            [11.32396764172956, -1.868246274689861],
            [11.31601854365879, -1.8671592682873557],
            [11.315001055588315, -1.8719206555688774],
            [11.317937475660251, -1.8747857355430653],
            [11.31460766243608, -1.8769549673098573],
            [11.308115445908706, -1.8783805159659708],
            [11.304497347434246, -1.877840363891313],
            [11.308676889685268, -1.8663998864002682],
            [11.312035206575095, -1.8616359523398762],
            [11.322186484991251, -1.8506951954678192],
            [11.329367966857154, -1.8472137411069212],
            [11.332341958966328, -1.8403634857331892],
            [11.33917139350676, -1.837297579777765],
            [11.343217224746644, -1.833692238008903],
            [11.34706047261941, -1.82804567881326],
            [11.350962824173378, -1.8259527743786679],
            [11.353692881590549, -1.8274948235953883],
            [11.361737414931191, -1.8266371527943792],
            [11.370270945111603, -1.8208618033099058],
            [11.375601571735212, -1.8185127319064907],
            [11.382315144133948, -1.8118311729760976],
            [11.386212674860877, -1.806372850600656],
            [11.396185576042187, -1.8004401326302746],
            [11.404393866220197, -1.80628206027629],
            [11.409295642130925, -1.8049580482112948],
            [11.413840174908064, -1.8067134417344102],
            [11.416179960705135, -1.8057879945393576],
            [11.41951989097797, -1.7990874238041716],
            [11.425141796805738, -1.7982691921187874],
            [11.430094509882062, -1.8004484720603358],
            [11.43391073835678, -1.7935247208183374],
            [11.437568780808434, -1.7901216719118687],
            [11.445253273064235, -1.778719030376195],
            [11.446463692427075, -1.7715074660845989]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.16357129765333, "lat": 36.01332102606381 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37121"],
        "coty_name": ["Mitchell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mitchell County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01008571"
      },
      "bbox": [
        11.304497347434246, -2.09417051792357, 11.678214919690479,
        -1.768362880415566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.336555294689174, -4.435372601765614],
            [7.387603569579166, -4.432578834766176],
            [7.448595532861783, -4.431059945409084],
            [7.465491439794013, -4.429465849912619],
            [7.515874755985963, -4.4260738043979115],
            [7.556960495033111, -4.422119012173051],
            [7.63516725933029, -4.41616755655393],
            [7.6573640173827116, -4.4141476497031045],
            [7.680986299113249, -4.412678732335091],
            [7.688137358552463, -4.416028949966824],
            [7.69092745888558, -4.419642916389138],
            [7.695850464263364, -4.4202859489531825],
            [7.697148079751848, -4.413188339932268],
            [7.702364443406433, -4.401522245384877],
            [7.709930301296455, -4.401123273045486],
            [7.716159323816138, -4.3979217660780865],
            [7.719127164605399, -4.397847871445067],
            [7.727575689411844, -4.403219146794658],
            [7.730273066468962, -4.403961027093066],
            [7.734879834963487, -4.408368179023172],
            [7.741565786882902, -4.414670871060672],
            [7.746865013236336, -4.422983937687524],
            [7.74671577296176, -4.42908767325953],
            [7.748972535639553, -4.433915733676933],
            [7.751412274766345, -4.435210633117037],
            [7.760820283724531, -4.435105362929876],
            [7.7638626752812145, -4.437398923828628],
            [7.769727295415655, -4.4391561288125665],
            [7.771430519590895, -4.442037696741664],
            [7.771047884455701, -4.447806018082183],
            [7.776498928859983, -4.453417019334048],
            [7.77780258149533, -4.462116570368983],
            [7.788684441029502, -4.468936377237518],
            [7.79549249695252, -4.477424162773403],
            [7.799639557178022, -4.4899107655168295],
            [7.7911969580881655, -4.495173335670598],
            [7.7867731307966785, -4.496208134804521],
            [7.785032757487906, -4.498780039995982],
            [7.794145725515691, -4.504399643330518],
            [7.793106598979309, -4.50697454463202],
            [7.862747456751479, -4.501593373228946],
            [7.86517395755847, -4.52389072475536],
            [7.869171870522869, -4.520073375745611],
            [7.873556033944507, -4.5212591967243325],
            [7.876153556136569, -4.5285660007234005],
            [7.877780424285111, -4.529719239522567],
            [7.8882849054798045, -4.529165946784519],
            [7.892044475040934, -4.527513765949039],
            [7.901546201015435, -4.528890937252938],
            [7.903150195524316, -4.542211989222211],
            [7.910253877065584, -4.541539334531417],
            [7.912220406342325, -4.556114606206114],
            [7.913610457669784, -4.5710437813747795],
            [7.914949147001239, -4.585557661406215],
            [7.900525737525784, -4.586496180939982],
            [7.902191246640772, -4.601214475546979],
            [7.87333921049286, -4.603167791642335],
            [7.874797471628591, -4.617820483182665],
            [7.86049048513019, -4.619016380325825],
            [7.863202991923825, -4.648158820437703],
            [7.8563424456865025, -4.648730642664234],
            [7.8578269476587, -4.663386233675703],
            [7.850383740784824, -4.6640980701267125],
            [7.855213539669783, -4.707619645138991],
            [7.840842720384454, -4.70885459795728],
            [7.8431818098526485, -4.7379840201569845],
            [7.814382233756165, -4.740172894238295],
            [7.817090491869926, -4.769177554177938],
            [7.774468218599225, -4.772807409771025],
            [7.775903649740958, -4.787583986496735],
            [7.747036707247972, -4.789875596772344],
            [7.748288842976618, -4.804393407648359],
            [7.733979413649594, -4.8056547092568715],
            [7.734212421830834, -4.815702713036069],
            [7.729585232237266, -4.82672613011476],
            [7.73055845879188, -4.833000420642806],
            [7.7374282815296365, -4.842563646544007],
            [7.744948428703446, -4.846057607356672],
            [7.747197876197113, -4.848227521127158],
            [7.746104659718462, -4.85275694207859],
            [7.73792393305177, -4.854852764565987],
            [7.73590483574677, -4.8563305111543675],
            [7.728823909841342, -4.867210570347932],
            [7.725826478207632, -4.869855591347696],
            [7.721356566209818, -4.870443694903386],
            [7.710161983932751, -4.868276955963117],
            [7.70500042156065, -4.872034514273904],
            [7.705373135449783, -4.879564608814521],
            [7.70292771425437, -4.887009425622495],
            [7.698557183412543, -4.894368110818039],
            [7.693032886592258, -4.894655451063044],
            [7.6903938483251615, -4.891880280980078],
            [7.687251206668651, -4.883759611086567],
            [7.684874727869319, -4.880977227465355],
            [7.680001186854749, -4.880181256023538],
            [7.677525664314302, -4.883321388222503],
            [7.676516369434436, -4.890069090147435],
            [7.678742854552024, -4.893973740172755],
            [7.684316911279043, -4.897310082374865],
            [7.641894884162977, -4.899946925996922],
            [7.634925239152439, -4.826798526262074],
            [7.591701411600111, -4.831062163852132],
            [7.590301152093394, -4.816444885590061],
            [7.561879113335242, -4.819147053091846],
            [7.546955137469392, -4.819963010969873],
            [7.538940929580862, -4.732994657451394],
            [7.476057826901514, -4.736121999248798],
            [7.452700634221937, -4.7377634132190325],
            [7.44912533482941, -4.706870953631234],
            [7.441952745114012, -4.638808535940713],
            [7.434278212677924, -4.56243076715807],
            [7.407281663821189, -4.563836134057084],
            [7.348148355846214, -4.565636562773851],
            [7.344407339245388, -4.522359698236152],
            [7.336555294689174, -4.435372601765614]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.2973320873929, "lat": 33.80332451946738 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01127"],
        "coty_name": ["Walker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walker County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00161589"
      },
      "bbox": [
        7.336555294689174, -4.899946925996922, 7.914949147001239,
        -4.397847871445067
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.707758356063703, 2.3431753843234104],
            [-18.701451934238786, 2.3421624494381454],
            [-18.69458926587492, 2.3439898214270913],
            [-18.69198093656409, 2.3486010468527345],
            [-18.688179642578042, 2.3497116455225626],
            [-18.684555928201767, 2.3471807619769867],
            [-18.681696913222982, 2.34175155367448],
            [-18.67770470284196, 2.3433003558738177],
            [-18.670483318906925, 2.3403221771893326],
            [-18.665978463636144, 2.3399857949017178],
            [-18.661653591227186, 2.343852094748021],
            [-18.657517887266604, 2.3421903022876163],
            [-18.651648504374535, 2.343208879740949],
            [-18.648310918394543, 2.340497881402731],
            [-18.642504064496496, 2.3417209560877663],
            [-18.63990318679754, 2.3450240248692915],
            [-18.63636871393115, 2.344442098954335],
            [-18.636679714390855, 2.3356864683903367],
            [-18.63218087442808, 2.332795413159998],
            [-18.63110476615595, 2.329661074757529],
            [-18.627087432890434, 2.3323558341159805],
            [-18.62068409209705, 2.332657053070817],
            [-18.61736570962026, 2.331636899548521],
            [-18.612190434914645, 2.3342349968222673],
            [-18.608108860534685, 2.3403656283988163],
            [-18.603508405049627, 2.3360098468053714],
            [-18.601562626579724, 2.336284608736661],
            [-18.598922925021657, 2.3308249493647173],
            [-18.595476003794264, 2.331430145106752],
            [-18.59196151983441, 2.335661724082064],
            [-18.593128675234365, 2.3404698225352853],
            [-18.591529900604122, 2.3425528060645844],
            [-18.5836175847406, 2.344780016108837],
            [-18.5832043178394, 2.3388756460648628],
            [-18.577413835341513, 2.3371060052449018],
            [-18.575048640377815, 2.344155318969304],
            [-18.571205816563467, 2.3423639854725273],
            [-18.568075125787555, 2.348549543299902],
            [-18.563563410643013, 2.3487061431482976],
            [-18.5609530634171, 2.3513075798163108],
            [-18.555615896142136, 2.352216265672359],
            [-18.554038283465854, 2.3502604645057663],
            [-18.54818063838085, 2.350634773488273],
            [-18.54411642511356, 2.3489747710125934],
            [-18.54150701103549, 2.3522745537015717],
            [-18.53886489778554, 2.3501831919670138],
            [-18.533516988588755, 2.350056644565511],
            [-18.532415330024197, 2.3478243604866784],
            [-18.525618530190478, 2.34741509135875],
            [-18.525634324842468, 2.3444828081266884],
            [-18.520635192106326, 2.344542227165103],
            [-18.51376170895463, 2.3356992565173686],
            [-18.509815581630047, 2.338274901333996],
            [-18.502228943506296, 2.334552037518451],
            [-18.495364985681817, 2.3350018964615997],
            [-18.49244882080335, 2.330288799329994],
            [-18.48746757789225, 2.3312982502632047],
            [-18.4875410694672, 2.326147275161835],
            [-18.48137382133501, 2.324359621951519],
            [-18.480258834713677, 2.3212835117424753],
            [-18.474976780264278, 2.3224205807064977],
            [-18.469252688909783, 2.3197151963971154],
            [-18.467624065760475, 2.313870771312022],
            [-18.450519442145865, 2.294750978151897],
            [-18.445235503432016, 2.2918769450187964],
            [-18.443020334696328, 2.2869000447950127],
            [-18.443036585933523, 2.2823307477267907],
            [-18.434872951722504, 2.2793772781966832],
            [-18.429996218400596, 2.276350752330089],
            [-18.42526222809966, 2.2694979771267976],
            [-18.417035355805524, 2.2649508349330882],
            [-18.41030412614036, 2.2584053896756595],
            [-18.405241866637603, 2.2583026560083237],
            [-18.393840944113705, 2.25315418599178],
            [-18.390488973842512, 2.253892379824354],
            [-18.382748476229974, 2.252564967992974],
            [-18.373773242785987, 2.248949837684637],
            [-18.36661886126958, 2.2495670284814526],
            [-18.35214404595651, 2.2520619333446557],
            [-18.344382243033962, 2.24781197951635],
            [-18.335538327232683, 2.245781118610209],
            [-18.31989112348338, 2.2431403186767316],
            [-18.31121816773755, 2.2438675654581313],
            [-18.30936753011413, 2.2454148285690185],
            [-18.302932184616967, 2.2454270233305866],
            [-18.29831099624328, 2.2478132567794398],
            [-18.289637364654915, 2.2457932240884033],
            [-18.27815378608289, 2.245112625464651],
            [-18.270136871977304, 2.247808296943032],
            [-18.26168379714391, 2.2460071567152036],
            [-18.25932478079573, 2.2430962986683114],
            [-18.250631623173206, 2.2446136756024555],
            [-18.24181662962772, 2.2431424299902374],
            [-18.23451183842067, 2.2463643800524298],
            [-18.221092357241034, 2.247538994434031],
            [-18.21870866089416, 2.2447651897223513],
            [-18.214607689986597, 2.248215344808274],
            [-18.211011459336245, 2.2492495688433065],
            [-18.20085076812228, 2.246396818961723],
            [-18.19352583134651, 2.2481409612641547],
            [-18.19126562723867, 2.2466199204328334],
            [-18.1819663176284, 2.2439276521210156],
            [-18.17625006024119, 2.2432208679640446],
            [-18.166303342885616, 2.237925120742814],
            [-18.15372628251654, 2.23880940784895],
            [-18.150835608985766, 2.2411841131173054],
            [-18.15003942932916, 2.245155034246078],
            [-18.142838306049565, 2.2432985963795877],
            [-18.13296089823993, 2.2444977012979526],
            [-18.130705999608786, 2.243586069216663],
            [-18.122648494165592, 2.2500372745670125],
            [-18.121010740852235, 2.2556697693763668],
            [-18.11685220938172, 2.2599743401105012],
            [-18.108582510405547, 2.2619872464917345],
            [-18.106746438960798, 2.2633355511685425],
            [-18.100353930285333, 2.263793721820458],
            [-18.097510055125827, 2.2625700380969853],
            [-18.092877686889207, 2.263823126538026],
            [-18.090311611834437, 2.2672421352065464],
            [-18.088973294321523, 2.275034784970188],
            [-18.085834435934, 2.275002526741247],
            [-18.081044240963383, 2.2778008446454177],
            [-18.082464424588462, 2.283505793113766],
            [-18.074623171972576, 2.2935402342429674],
            [-18.069507380863957, 2.2944983717144884],
            [-18.06951331772251, 2.2978987887791447],
            [-18.066653296646688, 2.2998016999691453],
            [-18.06105096865034, 2.2966375081632715],
            [-18.060418827603748, 2.293316193494596],
            [-18.05624679345677, 2.2933759278742314],
            [-18.054955396647625, 2.2965785338038303],
            [-18.039972882649117, 2.2974464474325575],
            [-18.033981332260645, 2.2944993351786085],
            [-18.024727763809054, 2.2929315762128573],
            [-18.013568046656328, 2.296762132979747],
            [-18.011214864924142, 2.29445047189798],
            [-18.00690382761289, 2.296629324474337],
            [-18.00095657328868, 2.303266473655363],
            [-18.00210596724223, 2.3092578518774096],
            [-17.994873378069354, 2.317910131838929],
            [-17.99002766725375, 2.318819939687891],
            [-17.981928622309912, 2.3303479921915446],
            [-17.98510431577562, 2.3386295888899338],
            [-17.98479719892769, 2.34253778963551],
            [-17.982021053819736, 2.346977551958688],
            [-17.977851402747145, 2.348942497927816],
            [-17.970978863086778, 2.354543137183614],
            [-17.96504530481572, 2.3532658307703387],
            [-17.962085073800687, 2.3504086436408906],
            [-17.96076525337515, 2.3553529933484323],
            [-17.945327779783966, 2.351209901221597],
            [-17.94707919974773, 2.344616978170816],
            [-17.94295070390469, 2.344217162129159],
            [-17.949296742292184, 2.3198431784249305],
            [-17.991827356651097, 2.1558146065981427],
            [-18.00540334570618, 2.155711501024935],
            [-18.007232843971337, 2.1573348149783325],
            [-18.01418090308501, 2.1554792144880373],
            [-18.016119205519217, 2.1574822565797462],
            [-18.01999495812553, 2.1568214494021785],
            [-18.023980129268317, 2.1523050756686004],
            [-18.034921754582747, 2.1523543365181186],
            [-18.037314949738654, 2.154393618468524],
            [-18.047340395705167, 2.1578486921246722],
            [-18.05119740408446, 2.156028377862834],
            [-18.06468416340069, 2.1583992141387807],
            [-18.067840710463106, 2.1613656837638726],
            [-18.076151689725286, 2.162757512008368],
            [-18.0939959606133, 2.173111846987631],
            [-18.1036306176665, 2.172143573296908],
            [-18.111863644456815, 2.167025249699226],
            [-18.119219634698272, 2.16804731243509],
            [-18.12436883362707, 2.16466075682381],
            [-18.13409332264639, 2.169655135831175],
            [-18.13831351451838, 2.169719911244985],
            [-18.14782228673886, 2.1627984993274296],
            [-18.154438253806113, 2.1623450311980643],
            [-18.159084641912848, 2.163385611721393],
            [-18.166066417429665, 2.167192069437039],
            [-18.175519228454625, 2.164213723049577],
            [-18.18671428675534, 2.1659921315674064],
            [-18.189699069478877, 2.164258779769439],
            [-18.197151461960317, 2.1626362438798146],
            [-18.201902398870274, 2.166220746867234],
            [-18.214036156021038, 2.167358201111247],
            [-18.2200718811084, 2.170176885158954],
            [-18.22637350514092, 2.1702795409448106],
            [-18.23439411692193, 2.1680823576858446],
            [-18.23822966701407, 2.170353161008992],
            [-18.23863323027346, 2.1745869349226328],
            [-18.24255199383305, 2.1768079126535627],
            [-18.247893781150584, 2.177520423292053],
            [-18.252995089646404, 2.1811466583128176],
            [-18.25758151451283, 2.182213637574324],
            [-18.25920218833503, 2.1876457581918887],
            [-18.264199480666367, 2.1886886259628873],
            [-18.27205675328018, 2.1843420740756376],
            [-18.282819974803584, 2.1812146812387154],
            [-18.287083519433377, 2.1767605600008015],
            [-18.287664822067097, 2.1742172548071617],
            [-18.291863887337254, 2.1717402163169557],
            [-18.295974407646675, 2.171720254358537],
            [-18.299812813161445, 2.1697194609700547],
            [-18.303425650886503, 2.173458930153269],
            [-18.310051260758595, 2.174432263337534],
            [-18.318360355431267, 2.174055683711139],
            [-18.328121058524417, 2.17876871113725],
            [-18.327948642957736, 2.1752326673262545],
            [-18.33359824454022, 2.176034538209974],
            [-18.33398929909208, 2.1716283833949053],
            [-18.3373494268389, 2.1701856782420506],
            [-18.345146491984412, 2.1636491002272615],
            [-18.348060788810578, 2.1631317463985216],
            [-18.352504113693968, 2.1590550998778104],
            [-18.35515931809019, 2.1600455129712253],
            [-18.358389078788868, 2.156673851135178],
            [-18.36408877632583, 2.157801922047115],
            [-18.367117233433998, 2.1620442187963578],
            [-18.373189682814935, 2.1620409784031147],
            [-18.38179367663722, 2.158860722489727],
            [-18.389432500424007, 2.160369447390601],
            [-18.391648752293378, 2.1587945183049415],
            [-18.39151692912104, 2.1541545949791194],
            [-18.395933614688353, 2.1488065757930195],
            [-18.401276036968312, 2.1499619771254976],
            [-18.408439875797242, 2.1494053742421237],
            [-18.416770049576343, 2.152099585824851],
            [-18.42338607899418, 2.150710498143476],
            [-18.42512356321505, 2.146839321964434],
            [-18.429583922467536, 2.1447224176168436],
            [-18.431752084855376, 2.136114248316321],
            [-18.433730913364126, 2.1350388927341992],
            [-18.433835916815298, 2.123764225861995],
            [-18.437969661201908, 2.1234024188100205],
            [-18.439109553072733, 2.117612912690832],
            [-18.44138021331545, 2.1147754518552047],
            [-18.448430421294987, 2.114215558843453],
            [-18.453624578352855, 2.1053210013590697],
            [-18.454613255418767, 2.100046692679659],
            [-18.45988358327155, 2.102040402740049],
            [-18.467587333193478, 2.0975583469768724],
            [-18.47145245278382, 2.097959862624995],
            [-18.47596224775051, 2.0959432932230944],
            [-18.483637238397666, 2.098587005225379],
            [-18.491557666537425, 2.0976277418152742],
            [-18.4979051907136, 2.0952460553315144],
            [-18.500745048479057, 2.091449762201242],
            [-18.506277800526547, 2.0904456060298746],
            [-18.51069215389326, 2.0918000315201772],
            [-18.514677113895143, 2.090979377156345],
            [-18.52297570095413, 2.091708699726198],
            [-18.537853958767766, 2.0884165709332474],
            [-18.543377426123907, 2.0896879886225936],
            [-18.556520231822354, 2.080836641321711],
            [-18.560527261610634, 2.0740992553986914],
            [-18.569696943080974, 2.0784710844690646],
            [-18.579193972359434, 2.078185642818252],
            [-18.587606951698923, 2.0814464592386144],
            [-18.594351718325782, 2.0801103100046956],
            [-18.59716527033903, 2.0842829045124582],
            [-18.6004882045138, 2.0850194077867363],
            [-18.604029477004218, 2.0789528396109684],
            [-18.60858282231001, 2.0821636376459622],
            [-18.61084997370516, 2.0808345652838645],
            [-18.61469006684513, 2.074948298895345],
            [-18.62384307955936, 2.0708095117155665],
            [-18.633433003724747, 2.068453502280588],
            [-18.63619162043737, 2.069017617605927],
            [-18.63925699550487, 2.064104208319798],
            [-18.642747774637765, 2.06176373624117],
            [-18.645668985625495, 2.0565579894500385],
            [-18.648562363401037, 2.0546554262000236],
            [-18.65879435260561, 2.054305007716063],
            [-18.666485071187484, 2.0526392232315196],
            [-18.668496678225853, 2.0511248824779655],
            [-18.669725359217995, 2.045956331362185],
            [-18.67397345655788, 2.042313024806226],
            [-18.67763294065604, 2.0413644720374933],
            [-18.682736418099783, 2.036555777876901],
            [-18.689376545203782, 2.039672446420061],
            [-18.694828828482834, 2.0483528692685806],
            [-18.69843980088177, 2.049869699990854],
            [-18.704919858605958, 2.0491429040903943],
            [-18.71230992662385, 2.045192736419342],
            [-18.715454775021144, 2.044791181782606],
            [-18.718571480661197, 2.0483279051820076],
            [-18.726208145432096, 2.053480953926674],
            [-18.73535943998336, 2.0492377775534707],
            [-18.7383267038761, 2.05062973593503],
            [-18.742450413526935, 2.049104571998123],
            [-18.748181493268593, 2.0546551521652896],
            [-18.751784276605125, 2.055233144891242],
            [-18.758069552553174, 2.06109165230314],
            [-18.75963409264336, 2.087749937931787],
            [-18.7621228030586, 2.140409449033568],
            [-18.7395715535414, 2.224424571463441],
            [-18.712579449398877, 2.324577955905394],
            [-18.707758356063703, 2.3431753843234104]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.65102423007289,
          "lat": 38.446397571721874
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06005"],
        "coty_name": ["Amador"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Amador County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01675841"
      },
      "bbox": [
        -18.7621228030586, 2.036555777876901, -17.94295070390469,
        2.3553529933484323
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.838725237332895, -0.33864370557879986],
            [-18.726511301096195, -0.2744844305231804],
            [-18.72265448373248, -0.27216971962539144],
            [-18.65480353806107, -0.2340572201725845],
            [-18.653444822330172, -0.2335025583305896],
            [-18.533630373443856, -0.1652162830730475],
            [-18.528304213026768, -0.16261368831800257],
            [-18.51059698125318, -0.15186948301650335],
            [-18.493021044521438, -0.1424299447654893],
            [-18.49292773500018, -0.14154508692203402],
            [-18.463373604525323, -0.027367136024506303],
            [-18.44407558204789, 0.05105672353231053],
            [-18.441673850923003, 0.057928885044055065],
            [-18.437981857126633, 0.07225665006350566],
            [-18.382055680147978, 0.05897111172430989],
            [-18.279117003366867, 0.0326042252886135],
            [-18.276600379389187, 0.03439455663613267],
            [-18.27621951478229, 0.0391846159864752],
            [-18.270247841138566, 0.04536492820118181],
            [-18.262280529476154, 0.04447301073136949],
            [-18.25972153736883, 0.043023350778698344],
            [-18.256840062180167, 0.04625773617862206],
            [-18.250086801365953, 0.04178985263609946],
            [-18.2426550441123, 0.04137099624205893],
            [-18.238301433157215, 0.046416348792206935],
            [-18.23567726676819, 0.047554219685600634],
            [-18.231451978300832, 0.04432174276783191],
            [-18.226946592328186, 0.04268914700679626],
            [-18.221478640515492, 0.042711874195585454],
            [-18.21618201526925, 0.04535249798751465],
            [-18.208238128118627, 0.04481699027476584],
            [-18.210389390384005, 0.04071120806816957],
            [-18.20739570708263, 0.035711482580966604],
            [-18.207232890239613, 0.03194320102128107],
            [-18.178384024228446, 0.04796536534825892],
            [-18.11798575042577, 0.0820701149816566],
            [-18.08245774910609, 0.07313529046032691],
            [-18.083632616840983, 0.07203589504869828],
            [-18.105316349729712, -0.012113351709561753],
            [-18.06377409760434, -0.023133368455207113],
            [-18.07649314184352, -0.07174388802251265],
            [-18.085653428168143, -0.10879152546041486],
            [-18.088803590656052, -0.12411638745960685],
            [-18.0961126548323, -0.15232112126107236],
            [-18.124729472418696, -0.14498225900676184],
            [-18.138309747959962, -0.1408099423985652],
            [-18.170774578366974, -0.2699647564765409],
            [-18.17639523129269, -0.26856580856139595],
            [-18.19308080465143, -0.33388454913613064],
            [-18.193222165572102, -0.3354499414406605],
            [-18.20850442872799, -0.3964536097806718],
            [-18.219453277223387, -0.43932348517120573],
            [-18.22035342304225, -0.43916044651995184],
            [-18.227664606894056, -0.4670450245624226],
            [-18.263838423651165, -0.6087107143274689],
            [-18.353406380428368, -0.5864488031846616],
            [-18.416539822280075, -0.5709255249833187],
            [-18.432733610740105, -0.56628765802061],
            [-18.521680653260184, -0.5440010382109912],
            [-18.77493513392873, -0.4781659237681048],
            [-18.790211879572805, -0.4742799984648468],
            [-18.788558569987654, -0.45973008588030495],
            [-18.789985372911275, -0.45575457798420177],
            [-18.787042076666236, -0.4490141421485858],
            [-18.787714780719323, -0.44336942182901495],
            [-18.800322526334334, -0.433608921518141],
            [-18.80513993200446, -0.4341914616621358],
            [-18.80774704153825, -0.42730843972136934],
            [-18.807272555194544, -0.4241397566359101],
            [-18.810171533263663, -0.40958148721880017],
            [-18.805908940179656, -0.40093694006177605],
            [-18.801668685955583, -0.400371248488485],
            [-18.7960464718162, -0.3946935659268149],
            [-18.791684349630238, -0.3944282804646615],
            [-18.793157201454235, -0.386077449170487],
            [-18.79049208401288, -0.38202712795711324],
            [-18.795353477463006, -0.3708461754645878],
            [-18.79789490278725, -0.3682234586469759],
            [-18.800882534617198, -0.36010446741129526],
            [-18.804299395792793, -0.3567762388496981],
            [-18.808535521586297, -0.34789461308323383],
            [-18.810761774796106, -0.3462170319406129],
            [-18.817667287911142, -0.3458861098911753],
            [-18.82317376247381, -0.34233717801001806],
            [-18.83169804984081, -0.33962391699773214],
            [-18.838725237332895, -0.33864370557879986]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.81545070617112,
          "lat": 36.07525089859745
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06031"],
        "coty_name": ["Kings"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kings County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00277280"
      },
      "bbox": [
        -18.838725237332895, -0.6087107143274689, -18.06377409760434,
        0.0820701149816566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.712076082467856, 1.8934911496177036],
            [-17.708231805123198, 1.8950155442999177],
            [-17.70458677383944, 1.899775893367758],
            [-17.70239756329004, 1.9090717850274825],
            [-17.698182983268804, 1.9137615805082575],
            [-17.699577340178877, 1.9194226371927061],
            [-17.696017733113546, 1.9224407872284648],
            [-17.6838210899185, 1.9266327073879275],
            [-17.678298112329824, 1.926133160731757],
            [-17.6793402356838, 1.9331587821396168],
            [-17.681167851991777, 1.9378389688799122],
            [-17.680497514851773, 1.9407446791179737],
            [-17.68283873931233, 1.9442360165885142],
            [-17.68201172344222, 1.9486918897913497],
            [-17.68254956318913, 1.9557574739378718],
            [-17.676570673506696, 1.9594908833418625],
            [-17.673320737577136, 1.958724145564495],
            [-17.666943038615504, 1.9606599602762147],
            [-17.663991283371256, 1.9630041112416052],
            [-17.6589761994745, 1.954990136499297],
            [-17.65488780315342, 1.951947395588735],
            [-17.64764982831574, 1.9548767295909613],
            [-17.63872473476377, 1.9563573858480012],
            [-17.633156406889157, 1.960798200337636],
            [-17.63054781827056, 1.970662024480031],
            [-17.632723060194298, 1.9722106595160305],
            [-17.63296235572791, 1.985946151321801],
            [-17.627856192936928, 1.9874347800627619],
            [-17.62472189820751, 1.991861509796157],
            [-17.619868043352625, 1.9956743309827019],
            [-17.618265556940948, 2.0057277992093243],
            [-17.618576854826863, 2.008851398303955],
            [-17.61380255792821, 2.0178506839648738],
            [-17.606228644483817, 2.0193489905890543],
            [-17.60114542689634, 2.02548388958887],
            [-17.601018245850625, 2.035218704302166],
            [-17.599040417159074, 2.0381496534977916],
            [-17.599250558593212, 2.0444711576284123],
            [-17.60657527539017, 2.0487713542243546],
            [-17.607588511244934, 2.0529717410693213],
            [-17.602579833224485, 2.063290654343192],
            [-17.604135166259585, 2.065219369742064],
            [-17.603920317137295, 2.072912694527674],
            [-17.60704365114444, 2.0745750834139876],
            [-17.606459754246217, 2.0865356071561574],
            [-17.610020421756087, 2.090366903354353],
            [-17.61203498332594, 2.099076440134375],
            [-17.614894255808913, 2.10325319922998],
            [-17.613374980289816, 2.1183633440884466],
            [-17.615432637483835, 2.12073215152926],
            [-17.61331045374209, 2.125279846063973],
            [-17.613728375625918, 2.1306644366207066],
            [-17.616292239689233, 2.1346626597959864],
            [-17.613826633724603, 2.140075741030398],
            [-17.616286986893034, 2.146629451037599],
            [-17.62273625183511, 2.14968991372168],
            [-17.62405856790166, 2.1560254353908888],
            [-17.628202084108416, 2.160247932996101],
            [-17.627001059194313, 2.1712842195664175],
            [-17.623831273672433, 2.1755772145840817],
            [-17.623335896936343, 2.1806149787012816],
            [-17.620828025378273, 2.1816769559067435],
            [-17.62057096793831, 2.187794235628107],
            [-17.61650503470541, 2.1933246879779893],
            [-17.616342701860752, 2.200023860452269],
            [-17.61077968020775, 2.2102151029398485],
            [-17.608189193744032, 2.221066145771366],
            [-17.605172671719856, 2.2193480322940102],
            [-17.596840840300917, 2.2217356460980864],
            [-17.592609747057107, 2.22862252868228],
            [-17.587983698252135, 2.231921444792508],
            [-17.586298041863827, 2.239771561518887],
            [-17.581232275979048, 2.243471377093291],
            [-17.580520945837623, 2.247021674213398],
            [-17.575449451611963, 2.250058258156451],
            [-17.572932536759332, 2.2535896676643343],
            [-17.575771650064844, 2.2611351524532313],
            [-17.522968206093633, 2.181729020122475],
            [-17.497761820913187, 2.144401005387673],
            [-17.454833062342598, 2.0782891870143896],
            [-17.4512825264136, 2.0737446873586096],
            [-17.427905713473184, 2.039447787927604],
            [-17.398552308427952, 1.994625223605738],
            [-17.381971940412658, 1.9705831800788276],
            [-17.372800543202555, 1.9560399046493329],
            [-17.32651983412916, 1.8870687692796095],
            [-17.292472185833212, 1.8360867480612393],
            [-17.28413040827628, 1.8219730972398274],
            [-17.253466993182894, 1.7768685790294692],
            [-17.236721357736698, 1.7503753346718052],
            [-17.206400420097147, 1.7067932820593867],
            [-17.190487293322086, 1.6831063319884365],
            [-17.15343251747873, 1.627120935713945],
            [-17.10258915523815, 1.5492746316968198],
            [-17.08752659545226, 1.5279908286137263],
            [-17.068527302161915, 1.4997310566157698],
            [-17.014459781859927, 1.4161563350887552],
            [-16.985023568589966, 1.3732308278474588],
            [-16.94322738779017, 1.3102562456353468],
            [-16.900150923039803, 1.245064640152401],
            [-16.795644527197098, 1.0875599625700407],
            [-16.70662616687037, 0.9538551986488893],
            [-16.677627725002367, 0.9104431610419441],
            [-16.670455973717914, 0.898701427937257],
            [-16.632170401014083, 0.8420056477863587],
            [-16.590135234360485, 0.7766804670556811],
            [-16.572466442692253, 0.7532800468470736],
            [-16.546852902737555, 0.7137501685134714],
            [-16.600880518644658, 0.7263201679661704],
            [-16.611170152754465, 0.7291394281353923],
            [-16.622553408358705, 0.7311249805849156],
            [-16.941785276447863, 0.8050874212720894],
            [-16.985126572180267, 0.815444920349246],
            [-17.024003690448403, 0.8249916565228733],
            [-17.043379248557713, 0.8293317562413647],
            [-17.06796770800829, 0.8352147815067803],
            [-17.12628456779163, 0.8499363693919865],
            [-17.153827603944038, 0.8563695569453438],
            [-17.267663255565846, 0.8841123381715056],
            [-17.268346895730954, 0.8908409337751269],
            [-17.272731635450395, 0.8966093988256886],
            [-17.27233952547149, 0.9014995552214601],
            [-17.274627740929002, 0.9043372469927741],
            [-17.277490768317985, 0.9128318035291187],
            [-17.283792946401988, 0.9149624839768855],
            [-17.28907476534121, 0.9132465039802421],
            [-17.292652828283863, 0.9159536446521723],
            [-17.29999183672518, 0.9144383572497089],
            [-17.301054075987576, 0.9127504174508456],
            [-17.307662251375568, 0.9117148291409787],
            [-17.30956643128276, 0.9145960804439753],
            [-17.31444426139554, 0.9141050360485767],
            [-17.322213741686987, 0.9107085128771976],
            [-17.326481130166076, 0.9155762310727623],
            [-17.32542786751105, 0.9194284839047124],
            [-17.325577346005367, 0.9274876354866625],
            [-17.323879158573494, 0.9303770854502149],
            [-17.32387196014445, 0.9378728366668679],
            [-17.327636687394463, 0.944618015706656],
            [-17.333700011426842, 0.946938476520202],
            [-17.33769969254837, 0.9504153028625352],
            [-17.336335180042976, 0.954654783828628],
            [-17.336865748436015, 0.9603991189191242],
            [-17.33954833384429, 0.961993435044268],
            [-17.34220993687757, 0.9679493331521467],
            [-17.349327106463033, 0.9695936920655158],
            [-17.347540187480803, 0.9745610611154751],
            [-17.35022013973397, 0.9820816063302956],
            [-17.35214621343374, 0.9841145454694639],
            [-17.355135679503707, 0.9962863920738051],
            [-17.365004904903014, 0.9972579768079285],
            [-17.367526375277947, 1.0024533365886938],
            [-17.370767632240785, 1.004394727341531],
            [-17.371730208622193, 1.0126380480649104],
            [-17.37430761772605, 1.0162879712656903],
            [-17.378458904346846, 1.0181420043694276],
            [-17.382027475300287, 1.0157984657667256],
            [-17.384522319500753, 1.0168289419182814],
            [-17.38900781393607, 1.0127347866291443],
            [-17.39509629146977, 1.0155870460331153],
            [-17.399153980246638, 1.013883617153404],
            [-17.399310515212154, 1.018497723032441],
            [-17.402636984396363, 1.0256613727219315],
            [-17.40702928798275, 1.0265367723462604],
            [-17.414978299517227, 1.0326579492485513],
            [-17.41689230574837, 1.0383301832448577],
            [-17.42227356351307, 1.0460027121056],
            [-17.426758929120147, 1.050750574645101],
            [-17.427841423566804, 1.0614180857911308],
            [-17.431588823595764, 1.070455303216707],
            [-17.424734357333726, 1.0868118419161763],
            [-17.423675317734094, 1.0965789944783204],
            [-17.431806024952376, 1.1053607343850569],
            [-17.435836309708648, 1.1160810931707683],
            [-17.435237976970807, 1.120913968781273],
            [-17.439004655937545, 1.1287624814761426],
            [-17.435765038385824, 1.1358072037737017],
            [-17.436579034122694, 1.1419558350887784],
            [-17.434944667101426, 1.1472135908269518],
            [-17.435386149619426, 1.1556601908357296],
            [-17.437691458405833, 1.1582735670764446],
            [-17.439591320072807, 1.1653652267509509],
            [-17.444547667753493, 1.1693385300612504],
            [-17.44839558236442, 1.1777266376750628],
            [-17.452022026669287, 1.1796165005931611],
            [-17.45602237134057, 1.1910315715072883],
            [-17.455574421995973, 1.19356985131521],
            [-17.458592285411143, 1.1975156305995796],
            [-17.459489487749302, 1.203423817189405],
            [-17.468361956623063, 1.2152042500535356],
            [-17.474705558074398, 1.216763193065674],
            [-17.478259249754558, 1.2199309791238644],
            [-17.48104321229242, 1.217631546117164],
            [-17.48657293200709, 1.2184911560925789],
            [-17.491828263822526, 1.2218244938661487],
            [-17.492830492802923, 1.223970064779997],
            [-17.498053377007476, 1.224845940631641],
            [-17.5001043372819, 1.2275468183772569],
            [-17.508282934377295, 1.2259884667862337],
            [-17.511853709004743, 1.229287368740678],
            [-17.516105680503113, 1.2295932376386478],
            [-17.518510238110512, 1.2316950982166963],
            [-17.524078098303463, 1.2318764236407622],
            [-17.533868818148314, 1.2212082766673995],
            [-17.536919063307714, 1.219839341085114],
            [-17.543139746427162, 1.213178914779392],
            [-17.552719851991615, 1.2189828854208224],
            [-17.552202026413973, 1.2221428414249615],
            [-17.559916825688237, 1.2323704984674781],
            [-17.565595806198637, 1.2354358354003216],
            [-17.569923529222944, 1.2315212782071345],
            [-17.57332909209547, 1.2337242455463198],
            [-17.572673165045874, 1.2399080965460216],
            [-17.574827758549905, 1.2406542323864798],
            [-17.57700914310285, 1.247753822648605],
            [-17.57064251479566, 1.24803694931436],
            [-17.564333176266267, 1.2522901068383254],
            [-17.56219102063149, 1.2618468526068478],
            [-17.55827164485244, 1.2620277953959114],
            [-17.550020890497464, 1.2721298865258213],
            [-17.543984123586608, 1.2753063873356698],
            [-17.53938366195398, 1.274991531907517],
            [-17.535596498594813, 1.2782082295876755],
            [-17.5310204756732, 1.277796926542177],
            [-17.525654703177533, 1.2854066558476127],
            [-17.521488604066036, 1.2885304057625309],
            [-17.514743997861945, 1.2884109903683751],
            [-17.511280871535327, 1.2938951025521035],
            [-17.50968088666834, 1.2986987416094389],
            [-17.510733187600714, 1.3064517900851453],
            [-17.51263638466529, 1.3075500745947086],
            [-17.518008631718065, 1.3157543407140693],
            [-17.513737639098416, 1.3212449289278911],
            [-17.506857448416156, 1.3226523327573885],
            [-17.50550730467464, 1.3241888195173186],
            [-17.50524206716445, 1.3346298707190967],
            [-17.501020630733674, 1.3366997465858559],
            [-17.499518229372505, 1.3411124902897056],
            [-17.50658343594684, 1.340895412927211],
            [-17.510035410037478, 1.3432120413007713],
            [-17.508900859404815, 1.3493789833799783],
            [-17.50653754459923, 1.3504548247745],
            [-17.502991207206414, 1.3669463065007692],
            [-17.496928052892844, 1.3751116563938268],
            [-17.494270004592185, 1.3770505866110656],
            [-17.489199177140048, 1.3770362648752206],
            [-17.489331090821477, 1.3807093947493487],
            [-17.492905759284287, 1.3828480809191301],
            [-17.494943180064805, 1.3882454429580737],
            [-17.493676084300244, 1.3936519961824594],
            [-17.500771259780457, 1.3945875199831448],
            [-17.503973180188762, 1.4037090494019133],
            [-17.51263314322542, 1.411278871863042],
            [-17.51446459337015, 1.4100709597480725],
            [-17.52126328345929, 1.41187131969266],
            [-17.5308044354452, 1.4162290129087525],
            [-17.531702196488265, 1.4181180527841184],
            [-17.527381546237223, 1.4302539068851263],
            [-17.538174491717307, 1.4405459320281453],
            [-17.54390209417748, 1.4411439139972353],
            [-17.547126033991503, 1.447569119673298],
            [-17.547587650290307, 1.4521591418146984],
            [-17.556053154409963, 1.4585431319489626],
            [-17.558380619648073, 1.4669293018734721],
            [-17.556744112302397, 1.4779668652192235],
            [-17.56091056705124, 1.4828601830486396],
            [-17.55622638069515, 1.490637255145492],
            [-17.552414931890947, 1.4933255630708988],
            [-17.55391725767725, 1.499216967193664],
            [-17.54387216438538, 1.5120420233808334],
            [-17.543854758852962, 1.5143218194297823],
            [-17.53896918444842, 1.5224274996656986],
            [-17.538057483944897, 1.5296605259105795],
            [-17.534283424698952, 1.5332939697224715],
            [-17.535695729212527, 1.5440844474463835],
            [-17.538757840401416, 1.5454895921556888],
            [-17.53483896521415, 1.550453943078421],
            [-17.534920271621424, 1.5561330621485414],
            [-17.541574357598947, 1.562147207647635],
            [-17.540044103102243, 1.5732858894682644],
            [-17.541683658536776, 1.5786560253296267],
            [-17.54647158687277, 1.5793774348711178],
            [-17.547174737848838, 1.5849118619417253],
            [-17.553380912397976, 1.6022569359039818],
            [-17.55952232063678, 1.601102141810446],
            [-17.563748364815943, 1.6096799601450504],
            [-17.568671263260686, 1.6092434422151738],
            [-17.57010678857247, 1.6147333953270329],
            [-17.574629423199845, 1.614850494090194],
            [-17.5753468419542, 1.6203977408941763],
            [-17.57867588355635, 1.6213822717397677],
            [-17.581839068845444, 1.6263229636143175],
            [-17.583816835526935, 1.6320142295245883],
            [-17.588272999557557, 1.6318117890038624],
            [-17.594082417093755, 1.635493686803243],
            [-17.600616690249478, 1.6360984718656582],
            [-17.604017810887207, 1.6377332502752577],
            [-17.605685878693137, 1.646606670079885],
            [-17.607918267631938, 1.646821584038385],
            [-17.611121425924427, 1.642191900224387],
            [-17.61694440846551, 1.6383120400029094],
            [-17.61889023272588, 1.6348774904833343],
            [-17.619393418485643, 1.6293602955710091],
            [-17.62412551753209, 1.6278251118416616],
            [-17.62447704313757, 1.634261188580867],
            [-17.629809422690958, 1.6323882756426724],
            [-17.633859076829847, 1.6336256903512083],
            [-17.636288605000775, 1.6363799745481697],
            [-17.635602594200424, 1.641676425331085],
            [-17.630545842540446, 1.6446019312009543],
            [-17.634729100622934, 1.652324109711201],
            [-17.638087209579275, 1.6553146724082723],
            [-17.63325210883506, 1.6667899750135267],
            [-17.639835574205133, 1.6713503923797057],
            [-17.64668955004794, 1.6742288064775752],
            [-17.644366152369688, 1.6853688892628242],
            [-17.648838899901445, 1.6925953741434336],
            [-17.64655168886528, 1.6979387098804521],
            [-17.65004883355549, 1.7032766404557758],
            [-17.652333538317173, 1.702663260109799],
            [-17.65608450180534, 1.6977623250970906],
            [-17.655729073916437, 1.6934365601857226],
            [-17.657388751361076, 1.6853395672847395],
            [-17.659041475855034, 1.6824856612591765],
            [-17.665806400087074, 1.6844442590253015],
            [-17.666248499723284, 1.6863600926757076],
            [-17.672500070430054, 1.6897191886355227],
            [-17.67584820856464, 1.6944057073478778],
            [-17.688239177468567, 1.697007568267332],
            [-17.687626686799177, 1.7011610607099128],
            [-17.68455273560753, 1.7055282583572553],
            [-17.693524517979803, 1.7095285751675895],
            [-17.69846555961834, 1.7100955884304925],
            [-17.69907094368752, 1.7132682804565578],
            [-17.706809473095795, 1.7159537103265183],
            [-17.706228837404193, 1.72681885104199],
            [-17.706791311520664, 1.7314032055521575],
            [-17.703766107368907, 1.7339160867002237],
            [-17.707665583080896, 1.7444694164438337],
            [-17.713083756129194, 1.7454337258863037],
            [-17.717393916821052, 1.7436623163253688],
            [-17.721179780422773, 1.7516120023179684],
            [-17.723911089375964, 1.7544078425980691],
            [-17.7297590724867, 1.7559646798625577],
            [-17.73638334773292, 1.7622238717266343],
            [-17.738971042515523, 1.767004299798489],
            [-17.73639269957534, 1.771642170256093],
            [-17.732763384759963, 1.7714762499766632],
            [-17.730755052814366, 1.7751737371500733],
            [-17.731206493685036, 1.7799680445541433],
            [-17.726705909063934, 1.7863207140039612],
            [-17.725341934757406, 1.7945937308534357],
            [-17.72113488275636, 1.7943471313316963],
            [-17.717063719050216, 1.7967051400256135],
            [-17.713003687609397, 1.7953143944716252],
            [-17.709287988323652, 1.7962321984130658],
            [-17.708005521418727, 1.801157189114888],
            [-17.71398740071997, 1.8064285477030042],
            [-17.717450403966772, 1.817705157566038],
            [-17.708750673796782, 1.8244809617034852],
            [-17.717356256515764, 1.8335840217494082],
            [-17.719747129683647, 1.8348581322570168],
            [-17.720080689896655, 1.8390174290669214],
            [-17.723044090165935, 1.8457779446904057],
            [-17.726330412062055, 1.8463955959889073],
            [-17.73124778672036, 1.8564540500847013],
            [-17.72507669827876, 1.8592772533669197],
            [-17.722754620253227, 1.8617971063826637],
            [-17.722733687902526, 1.8677919182192324],
            [-17.719268716169786, 1.8746013234015075],
            [-17.717401113940202, 1.8837634999482267],
            [-17.717573654901955, 1.8894303936049979],
            [-17.712076082467856, 1.8934911496177036]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.88682646260017,
          "lat": 37.93909813283145
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06051"],
        "coty_name": ["Mono"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mono County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00277290"
      },
      "bbox": [
        -17.738971042515523, 0.7137501685134714, -16.546852902737555,
        2.2611351524532313
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.902794238494491, 1.7149831829311335],
            [-7.872312848588222, 1.7113188451467132],
            [-7.754044230191654, 1.6980884785046997],
            [-7.720270779835222, 1.6950458456785582],
            [-7.7151466725027165, 1.6942700309970222],
            [-7.665966504956593, 1.6894976742111876],
            [-7.615535454320356, 1.6831100449097929],
            [-7.595212727538508, 1.6795513560275537],
            [-7.59453485616161, 1.6856816361096312],
            [-7.588391328432102, 1.685445163683838],
            [-7.48851537434012, 1.6743345436075672],
            [-7.487891640002489, 1.6740574153654002],
            [-7.449469106087774, 1.669680549295271],
            [-7.454573858336175, 1.6635540298827927],
            [-7.4540240059912595, 1.6607623262749973],
            [-7.44959629783292, 1.6572043325896857],
            [-7.44813563196597, 1.6532873084294497],
            [-7.4492129747234, 1.6460114059165505],
            [-7.448363437636087, 1.6393077526713267],
            [-7.449844562069899, 1.6313586509660616],
            [-7.449355486341541, 1.6262809289904931],
            [-7.454313093947986, 1.6219665031517168],
            [-7.455142167112175, 1.617618510974274],
            [-7.454650627987483, 1.610426251625901],
            [-7.451295911871651, 1.6016398011567832],
            [-7.449512345655227, 1.5937612741451261],
            [-7.451496996675579, 1.5892926704276606],
            [-7.448349860203371, 1.5833792096381636],
            [-7.445131846059277, 1.574335071275755],
            [-7.443437303238706, 1.571933056136346],
            [-7.440614622919937, 1.5533360441858717],
            [-7.4377689125798785, 1.5492720444333432],
            [-7.438155832630405, 1.5415093430104623],
            [-7.434927287968572, 1.537019771092481],
            [-7.433903043168097, 1.5316121601504893],
            [-7.430003907644344, 1.527105073864054],
            [-7.432925483965798, 1.5176786582521375],
            [-7.429797016050888, 1.5074108050031436],
            [-7.425512847429455, 1.5027511836648662],
            [-7.4218007343754095, 1.5015141558757943],
            [-7.419647449627711, 1.4955882451065896],
            [-7.416105451570571, 1.4914510643698935],
            [-7.407559167224674, 1.4901497271752933],
            [-7.40463016010648, 1.4942162644151593],
            [-7.39877194697312, 1.4954548959858127],
            [-7.3985108543345355, 1.4896410811200615],
            [-7.393990190966692, 1.4855911009661922],
            [-7.391720288501046, 1.4758078101229455],
            [-7.388039297193762, 1.4684050949887426],
            [-7.384472614463976, 1.4664339711170333],
            [-7.381717940343633, 1.4615685172902249],
            [-7.368918156079092, 1.4534695631342422],
            [-7.366475205052691, 1.4448285672337917],
            [-7.366992681289036, 1.441868365763935],
            [-7.365089219765532, 1.4363035207248647],
            [-7.355340923210849, 1.4306502051041374],
            [-7.350763673039938, 1.4350344634099537],
            [-7.345096551435225, 1.4309590819663298],
            [-7.344324386372167, 1.4277422991006374],
            [-7.347502173702927, 1.4183798172135043],
            [-7.344865400936687, 1.4156449883117992],
            [-7.342970944456515, 1.4092790209793589],
            [-7.3311757649196, 1.4091329709619766],
            [-7.3281360758366585, 1.4081506619772062],
            [-7.3304289711521395, 1.394882710299607],
            [-7.326758491719066, 1.3894843259877567],
            [-7.320920954508602, 1.3877494779655595],
            [-7.319023102942581, 1.389219197346147],
            [-7.314939133378004, 1.3876762091296242],
            [-7.314557940718527, 1.380618911393266],
            [-7.303239717947442, 1.3788324291454144],
            [-7.297663900001358, 1.3752776088084488],
            [-7.293488906195042, 1.3770793672804094],
            [-7.289548319671119, 1.3754498288058827],
            [-7.285726595796509, 1.3583632752849029],
            [-7.286922322085975, 1.3543864864612145],
            [-7.286813127245572, 1.34650109922356],
            [-7.287781062001091, 1.3367624555880606],
            [-7.290466442839833, 1.3305991628822567],
            [-7.296365085799643, 1.3266052577175387],
            [-7.3070677011476475, 1.3309035312487374],
            [-7.3113226011238615, 1.3287859744101627],
            [-7.314366869787272, 1.3245771922604728],
            [-7.316695930699531, 1.3185527045192544],
            [-7.317117226876186, 1.3120920967686278],
            [-7.319978138396165, 1.3075408439918637],
            [-7.321534400767542, 1.3007772921688334],
            [-7.31810806278315, 1.295488101909747],
            [-7.318156620305899, 1.286655713694564],
            [-7.3163040856737505, 1.2829837096453967],
            [-7.311041045316356, 1.2820858324968774],
            [-7.310472366630276, 1.2767110728147606],
            [-7.311864736384541, 1.2741915523482976],
            [-7.319078265013396, 1.273087936194492],
            [-7.321483765369542, 1.2703113384026525],
            [-7.322913195960627, 1.2649173373227216],
            [-7.322411747482116, 1.2596713877244827],
            [-7.324448897640375, 1.2562389568458898],
            [-7.327939044387856, 1.2576670068118037],
            [-7.333443593591372, 1.257434861053953],
            [-7.3360251548818045, 1.265007794966106],
            [-7.340325314116927, 1.2717027991224392],
            [-7.340910315631584, 1.2758779994714509],
            [-7.346466380481907, 1.2719364243115725],
            [-7.3497238551879, 1.272601495413428],
            [-7.352507903381654, 1.2669311601479123],
            [-7.357138250982578, 1.2610273504592266],
            [-7.356586351642696, 1.2572117647473513],
            [-7.35847411502209, 1.2486488525352362],
            [-7.353362685889544, 1.2438341142221347],
            [-7.352145690564385, 1.2407109444540159],
            [-7.3548920282618555, 1.232996995066329],
            [-7.35900365231963, 1.228838586885973],
            [-7.361517591707403, 1.2284368025935586],
            [-7.364069949768109, 1.2235808517141566],
            [-7.355136185516621, 1.2192585685088753],
            [-7.354022419639327, 1.217201222715239],
            [-7.35721363609374, 1.2126851624337465],
            [-7.360324054725326, 1.2025630099438096],
            [-7.359716912930594, 1.1990783192732972],
            [-7.361298531912909, 1.1932673348920722],
            [-7.356751660252012, 1.1891583155406606],
            [-7.352193561050231, 1.1812365884675042],
            [-7.353114635957127, 1.1784968416576005],
            [-7.348869456992175, 1.1674907144195408],
            [-7.346335921523612, 1.1659846380398553],
            [-7.3430913222954075, 1.1591272560288632],
            [-7.34702560746508, 1.154224634950405],
            [-7.351097050746885, 1.1527854433678588],
            [-7.349529383967875, 1.1485686561090722],
            [-7.350545577451509, 1.1452340261008802],
            [-7.349211158039906, 1.140807944595177],
            [-7.342179458570583, 1.1376915865361876],
            [-7.341757029025792, 1.1336036825612488],
            [-7.331184760558458, 1.121087049181634],
            [-7.330421541788995, 1.1186456387729893],
            [-7.33256363513092, 1.113594618730001],
            [-7.336802716300414, 1.110694369410336],
            [-7.33894711120824, 1.107362353879871],
            [-7.33639468767027, 1.103880296468961],
            [-7.350779468373642, 1.1054261115570012],
            [-7.352336604742677, 1.1001234429546782],
            [-7.357822587637594, 1.0993913067970977],
            [-7.362868926141947, 1.0925573328656621],
            [-7.367217630326879, 1.0914439725503686],
            [-7.373455153000552, 1.0870470265174408],
            [-7.3781576015134, 1.090501519982605],
            [-7.382124887802184, 1.0876390313584994],
            [-7.3876311678619695, 1.0875304866668878],
            [-7.3948856846327296, 1.082505366845371],
            [-7.39891457028657, 1.0819448521914972],
            [-7.406736697785527, 1.0843888846675378],
            [-7.4070218377054875, 1.0888861064557789],
            [-7.412167503702191, 1.0935303178550269],
            [-7.418707685173255, 1.0951763673986106],
            [-7.425291303266996, 1.0929462606033058],
            [-7.434793169365929, 1.0928200265112733],
            [-7.43952591714761, 1.09418344171468],
            [-7.449625923970198, 1.0898234688537545],
            [-7.457537931542639, 1.0942771828256868],
            [-7.457693997206222, 1.0963422328841543],
            [-7.463387691666629, 1.0983901855098623],
            [-7.463929380872686, 1.101567693289697],
            [-7.468043667751249, 1.10779897534296],
            [-7.469151573647956, 1.1147731001695214],
            [-7.473222454299874, 1.1156317670391143],
            [-7.477185637279528, 1.1189512784433453],
            [-7.483844839358622, 1.1212715218918812],
            [-7.487504091292476, 1.1196072684758924],
            [-7.490369873026397, 1.1146107499935254],
            [-7.501717721450248, 1.1058075206409166],
            [-7.505631036074499, 1.1042826691942575],
            [-7.553500392670858, 1.1095133838531195],
            [-7.561988881330221, 1.110966171312306],
            [-7.620854385465917, 1.1172918424153586],
            [-7.715560461135769, 1.1282240960977563],
            [-7.723563551266005, 1.1287525383570538],
            [-7.732136115373989, 1.1303641842597818],
            [-7.74503735227953, 1.1316146779099399],
            [-7.921409099658271, 1.1551116781267488],
            [-7.9567478917122285, 1.1597158146817126],
            [-7.988713627623835, 1.1635752824748626],
            [-8.027885824640997, 1.1679668157662866],
            [-8.024966712905043, 1.1939472566026847],
            [-8.012768313277116, 1.2976953412810268],
            [-8.01147854378652, 1.3108926177421238],
            [-8.004490231783535, 1.3687691644780435],
            [-7.997701746220851, 1.4276271733051995],
            [-7.990383663571937, 1.4871277268922847],
            [-7.962931862673807, 1.7222208286246512],
            [-7.902794238494491, 1.7149831829311335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.69529180859905,
          "lat": 39.627840080269664
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08037"],
        "coty_name": ["Eagle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eagle County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00198134"
      },
      "bbox": [
        -8.027885824640997, 1.0819448521914972, -7.285726595796509,
        1.7222208286246512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.499460624173555, 1.3566261385189542],
            [-9.391189701038613, 1.3417865143990921],
            [-9.366187375169877, 1.3379290823423444],
            [-9.263586231720437, 1.3243485729553857],
            [-9.261223898898248, 1.3239018196666241],
            [-9.13477425688534, 1.3069928355243452],
            [-9.101086327554858, 1.3022129171067482],
            [-9.012936898124343, 1.2903791426753126],
            [-9.010257566640199, 1.2904722732613425],
            [-8.981011475878741, 1.28633659066558],
            [-8.892166824298783, 1.2750116747736977],
            [-8.89069783339108, 1.2750788128223256],
            [-8.823857703174912, 1.2660321390621907],
            [-8.702270476320585, 1.2505637320146705],
            [-8.613772500509578, 1.2393132971728928],
            [-8.514502405123508, 1.2269586013488674],
            [-8.391908921464315, 1.2119085522049151],
            [-8.269317283882478, 1.196843392623483],
            [-8.267871192711505, 1.192909189462707],
            [-8.271161336372382, 1.178811479523549],
            [-8.276135327920406, 1.1775460555578725],
            [-8.278137228266095, 1.1723316920653375],
            [-8.282148991513665, 1.1702609653136644],
            [-8.28786601681969, 1.165014314659102],
            [-8.288809599945086, 1.16245464862918],
            [-8.298056612565045, 1.1607175900441025],
            [-8.301285826249373, 1.155919658333764],
            [-8.298683277313645, 1.1459435118976362],
            [-8.295902440288685, 1.1398205824438912],
            [-8.292549598127687, 1.136975550486871],
            [-8.287203887407184, 1.1403872930117387],
            [-8.281634684335229, 1.1378389644352003],
            [-8.283716314434933, 1.1338358177120258],
            [-8.28235508240547, 1.130695372407477],
            [-8.270269371684678, 1.1264820853563564],
            [-8.264619664013974, 1.1208653505202977],
            [-8.261007554744745, 1.1225605997127341],
            [-8.257570752321131, 1.1208123827602767],
            [-8.25323948323098, 1.1226531030411178],
            [-8.252115417331785, 1.1168275149922382],
            [-8.253453149416975, 1.1109365469169807],
            [-8.25181593695687, 1.1069309584212033],
            [-8.241359679579727, 1.1015306048944682],
            [-8.239991881770177, 1.0977753328201258],
            [-8.241657754448179, 1.0948169895844437],
            [-8.251645026614472, 1.090711988136416],
            [-8.252011706012311, 1.0874113217862718],
            [-8.254860720420703, 1.0833908849100593],
            [-8.259690779728142, 1.0805638699067135],
            [-8.26486835555554, 1.0816617597993232],
            [-8.270431981140325, 1.0845532973714276],
            [-8.275859267811589, 1.0851870100717838],
            [-8.277467907319531, 1.0874370320805897],
            [-8.282275443726565, 1.0869075086827558],
            [-8.282140630711528, 1.0808763211978558],
            [-8.283487472903454, 1.077027068502109],
            [-8.282998394250455, 1.0724811745075808],
            [-8.301060603662131, 1.0629149575345034],
            [-8.310788463123208, 1.0617962564439638],
            [-8.319254219186758, 1.0634652552836685],
            [-8.321783525462196, 1.068352767408503],
            [-8.325885608882531, 1.070544633833021],
            [-8.32961422170348, 1.0612278991707613],
            [-8.33601095491262, 1.0544967740895457],
            [-8.340342068121204, 1.0547090070827696],
            [-8.347538594640797, 1.0542003747775466],
            [-8.350895209245689, 1.0520108138721829],
            [-8.357052544508523, 1.0449144069395948],
            [-8.362547134776511, 1.043143308327077],
            [-8.363855252388964, 1.0383627244815263],
            [-8.369650595610139, 1.038417437871631],
            [-8.375859460760777, 1.03512356389806],
            [-8.376884908523298, 1.0228393610595745],
            [-8.38809334878139, 1.020284670131005],
            [-8.391049111068712, 1.0207333218907824],
            [-8.395716646390026, 1.0243252916411167],
            [-8.400580106758817, 1.0197845973660156],
            [-8.4090057015115, 1.018157614607756],
            [-8.410089586302407, 1.016313364067918],
            [-8.417913679680836, 1.0101846660281402],
            [-8.423449865554893, 1.0101515757462347],
            [-8.428666978869439, 1.0081992919676595],
            [-8.434750768829316, 1.0016886800106535],
            [-8.438368996903547, 1.0025917445212924],
            [-8.440498244202074, 0.998936742021199],
            [-8.44575423966208, 0.9975171085454029],
            [-8.450234900794122, 0.9898452027638593],
            [-8.454275952740991, 0.9914620998427327],
            [-8.463123699272261, 0.9817672151293012],
            [-8.465877816384486, 0.9816121362710716],
            [-8.468598649581061, 0.9748999182655098],
            [-8.475461653701805, 0.9693106261237758],
            [-8.474633762232742, 0.9639938267918471],
            [-8.478667533148974, 0.9613371392984714],
            [-8.482776904136122, 0.9610069772922807],
            [-8.486745952322803, 0.953835754169847],
            [-8.492170303023155, 0.9536551557893863],
            [-8.494730305749428, 0.9462878014397738],
            [-8.500459113498053, 0.9413697562787409],
            [-8.508843856733227, 0.9390356517926546],
            [-8.511655053733211, 0.9405390062902075],
            [-8.518819603974551, 0.9371415450096322],
            [-8.52244363683756, 0.9309785993882953],
            [-8.527757198374754, 0.9252550243544325],
            [-8.533273958031833, 0.9240968234496847],
            [-8.536011017926281, 0.9211923626300638],
            [-8.539841038026161, 0.9246613478648622],
            [-8.545410767066578, 0.9215269544663406],
            [-8.54686426698955, 0.9170881047613069],
            [-8.551162739367964, 0.9138999155789652],
            [-8.554998826970067, 0.91428408736013],
            [-8.555854669497034, 0.9103183199587297],
            [-8.561505296179153, 0.9083058344571168],
            [-8.563360418942603, 0.9059496344309612],
            [-8.568083869058052, 0.9055302909067915],
            [-8.573431719067198, 0.9146723564035888],
            [-8.578168429815253, 0.9195036996318044],
            [-8.580144832035487, 0.9198334727334578],
            [-8.582492216413865, 0.9248444662121426],
            [-8.589144027004265, 0.9296154023845142],
            [-8.597480951537284, 0.9331742728690469],
            [-8.603401219183176, 0.9372204840425662],
            [-8.608130215178246, 0.939083515261886],
            [-8.616496802628944, 0.9456293832338103],
            [-8.626538413189468, 0.9480502313688308],
            [-8.63052949847148, 0.9503829440317206],
            [-8.633530419411267, 0.9495018411846707],
            [-8.637455554729282, 0.945722259601005],
            [-8.63964464744799, 0.9462544184169821],
            [-8.644474809692346, 0.9426223229763372],
            [-8.647899197524245, 0.9433963525317887],
            [-8.65454920331882, 0.9398683415222161],
            [-8.664238855606607, 0.9397726360512633],
            [-8.6700191392268, 0.935425212391914],
            [-8.677270706242938, 0.9398958593150856],
            [-8.69230432251534, 0.9397938079928703],
            [-8.703549441473228, 0.9388098749273659],
            [-8.713534235495475, 0.9400288431382162],
            [-8.719681543285994, 0.9423872172600297],
            [-8.72714335078197, 0.9419750088410416],
            [-8.731871140236812, 0.9354492123444788],
            [-8.743067126973653, 0.9293036471689594],
            [-8.74629328739746, 0.9261251056791852],
            [-8.755923367580303, 0.9214492239427513],
            [-8.762008087480753, 0.9169015291525507],
            [-8.769325820514675, 0.9142024730978338],
            [-8.773068507013459, 0.9078411794292945],
            [-8.773746214668288, 0.904443980426342],
            [-8.783394999791357, 0.8998436510354831],
            [-8.7848794101995, 0.9037789350210528],
            [-8.78762668620556, 0.9030290175438632],
            [-8.79458303836498, 0.8950123165821506],
            [-8.797081139097994, 0.894157629936228],
            [-8.802213922928093, 0.8871208345130411],
            [-8.810357050434707, 0.8825999602504678],
            [-8.816903442748062, 0.8751460599720314],
            [-8.8233338918044, 0.8726118651425164],
            [-8.820996825576367, 0.8640975051909868],
            [-8.818801992360418, 0.8599412034998203],
            [-8.819734048038463, 0.8553542098486449],
            [-8.826865296173104, 0.8497351996387544],
            [-8.832961352642775, 0.8427974459913488],
            [-8.840957518433223, 0.8319914565320193],
            [-8.846848193002954, 0.826942669160303],
            [-8.8482891820777, 0.8242459047890858],
            [-8.853443747732513, 0.8201962926719689],
            [-8.858102370066469, 0.8186656128002194],
            [-8.8630346392489, 0.8231125960888613],
            [-8.865707335081648, 0.8215432348234506],
            [-8.86593008675924, 0.8179584216848014],
            [-8.869351831582765, 0.8156283063711814],
            [-8.867231070468009, 0.8060576449915612],
            [-8.872465859363286, 0.805410918455359],
            [-8.877487865693885, 0.7997424005541064],
            [-8.882822523456884, 0.8002095264419383],
            [-8.887936056289185, 0.8020807885625878],
            [-8.891664299753437, 0.7985592712738881],
            [-8.89699281757178, 0.7961927173982626],
            [-8.940101453701017, 0.7839007752478794],
            [-8.960628958813011, 0.7782778443843396],
            [-9.05954244397213, 0.7502259374288787],
            [-9.06006635489062, 0.7498974414747339],
            [-9.080977920585063, 0.5887555265613252],
            [-9.102709051094275, 0.4226581515003031],
            [-9.10336082665726, 0.4204929122690576],
            [-9.273847757867642, 0.4430275743524728],
            [-9.45007347177734, 0.4669731054193822],
            [-9.626302244904604, 0.49089603178816926],
            [-9.626296603558414, 0.49093751347017034],
            [-9.612784866006598, 0.5902883315849196],
            [-9.595564488867396, 0.7107925748177759],
            [-9.583466798577684, 0.7861420021386188],
            [-9.570026327162434, 0.8653388967945008],
            [-9.551409315622212, 0.990158952330299],
            [-9.53327536008065, 1.1161658604733782],
            [-9.499460624173555, 1.3566261385189542]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.46644747749211,
          "lat": 39.01830531493399
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08077"],
        "coty_name": ["Mesa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mesa County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00198154"
      },
      "bbox": [
        -9.626302244904604, 0.4204929122690576, -8.239991881770177,
        1.3566261385189542
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.940510946379339, 2.607055640309153],
              [15.943622298766355, 2.595474104062719],
              [15.94800009285296, 2.5845114583017774],
              [15.943787039546725, 2.582930461885571],
              [15.937849317679671, 2.5899508851429456],
              [15.933686331952083, 2.5968001670750684],
              [15.932703839724343, 2.6022107782193173],
              [15.937719421839832, 2.606452731304563],
              [15.940510946379339, 2.607055640309153]
            ]
          ],
          [
            [
              [15.932274822915524, 2.5723144534335085],
              [15.933263066204136, 2.5731305843114205],
              [15.94419966686986, 2.5673969896238655],
              [15.943858258165669, 2.5622877022767314],
              [15.937572561037229, 2.563383653455187],
              [15.932274822915524, 2.5723144534335085]
            ]
          ],
          [
            [
              [15.749965176337065, 2.661040188822219],
              [15.760996474853318, 2.663421411726063],
              [15.763423542176044, 2.6800481302952877],
              [15.768868943920143, 2.701668614558432],
              [15.773142199217661, 2.7131381884392267],
              [15.782576020147834, 2.731962005633773],
              [15.78839410828057, 2.7413412126140675],
              [15.797851378912243, 2.754331687707798],
              [15.807362570113868, 2.7651074905533823],
              [15.822431142274702, 2.7787911000521928],
              [15.83672584129515, 2.7893365045711334],
              [15.853558047882778, 2.7988105182224743],
              [15.869507486899623, 2.8056736644871765],
              [15.870772808503274, 2.8061701252820477],
              [15.880351740696725, 2.8093114427323735],
              [15.887260980625543, 2.811318042434794],
              [15.910561735835715, 2.8155816410046755],
              [15.926506894780353, 2.8171053429607564],
              [15.94172259824918, 2.8173388565991604],
              [15.955712049359866, 2.8160674660286866],
              [15.97016350678806, 2.8137646389563633],
              [15.978057287318082, 2.8118834717931063],
              [15.99956677894234, 2.8051481071562496],
              [16.003565619720938, 2.8033459683329247],
              [15.974404920384234, 2.776159081838797],
              [15.965084364936581, 2.7414134397708274],
              [15.958536143598828, 2.704168858742184],
              [15.932629929507325, 2.633099101070309],
              [15.92761633750148, 2.6317804244015166],
              [15.91529996454313, 2.6234377498116492],
              [15.903040718971887, 2.5907943438429233],
              [15.902126132234265, 2.584386789015715],
              [15.90603903051627, 2.579284692366792],
              [15.905070168525274, 2.574955050567733],
              [15.908389504456881, 2.566612146545831],
              [15.916387977359957, 2.5596346165865382],
              [15.91996128467981, 2.5605799564938634],
              [15.931219533914106, 2.5524619715685346],
              [15.944817369594155, 2.5439160380096597],
              [15.952389798784207, 2.5399033190361022],
              [15.951251781559115, 2.535803935208952],
              [15.952332159609973, 2.5175426600672397],
              [15.95446134806868, 2.5042105436361592],
              [15.95514594609272, 2.4939116973954203],
              [15.95380735935256, 2.4854589962665186],
              [15.948137146249012, 2.4709671300802776],
              [15.949370048739361, 2.4650156391358298],
              [15.947841762053406, 2.453182572667203],
              [15.950890583782394, 2.4418646338849346],
              [15.954505447796405, 2.435668087639697],
              [15.963578224498116, 2.4272960481831607],
              [15.965153552931248, 2.424639656467516],
              [15.970055662913325, 2.4231206419040983],
              [15.972381959388166, 2.416942704069667],
              [15.986137537418807, 2.4111217181829696],
              [16.00211412476765, 2.400313047443794],
              [16.005544554845514, 2.393713699729616],
              [16.018652984818296, 2.3781999721336713],
              [16.020875822219253, 2.374853387275568],
              [16.022531030274603, 2.368796245220998],
              [16.027333303084525, 2.366431998486902],
              [16.032635383658764, 2.35448806430666],
              [16.030257993481065, 2.3491479268435493],
              [16.027387922010767, 2.346061749122994],
              [16.022190956870677, 2.3446136575914642],
              [16.018315308991866, 2.3358285840061725],
              [16.013213862718494, 2.338584835197012],
              [16.011274369330536, 2.3344410931028867],
              [16.007150086286522, 2.3322188202560317],
              [16.00568901077198, 2.3276883230636085],
              [16.00253125806777, 2.3308160323821587],
              [16.001049698542015, 2.3263276821753687],
              [16.00636758873406, 2.31922762238737],
              [16.004831882392057, 2.3150391615662214],
              [16.000669505296845, 2.312687364361556],
              [15.998212207747777, 2.308855581690855],
              [15.99955437546688, 2.303757870120507],
              [15.997306376700568, 2.2928508977000015],
              [15.991042426935275, 2.286615958695104],
              [15.984720112204919, 2.2878542076121424],
              [15.974510399126418, 2.282365709462108],
              [15.968728877282683, 2.281331051789462],
              [15.964327469298519, 2.2821808414309106],
              [15.960732075838274, 2.275278695892124],
              [15.956458764908648, 2.2713770808392026],
              [15.950230745653212, 2.270092152837312],
              [15.945978464266588, 2.263398287146571],
              [15.945825860165664, 2.2607037905321388],
              [15.942290946064512, 2.2579052308703176],
              [15.937680288940376, 2.2574075893703323],
              [15.932860374264648, 2.255065538152386],
              [15.92690140191992, 2.253855797845222],
              [15.922681874533835, 2.2550027439750284],
              [15.918007202624189, 2.258729853048555],
              [15.895260993841207, 2.256150500078414],
              [15.861939320749864, 2.246311170436975],
              [15.839785628876923, 2.3248305952066595],
              [15.821105077198698, 2.3910751712638167],
              [15.792424784943462, 2.4928310532423543],
              [15.768872633440855, 2.5777025760989734],
              [15.763550088418505, 2.597965819231217],
              [15.75483725897846, 2.639225080000482],
              [15.749965176337065, 2.661040188822219]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.6527024692985, "lat": 39.576762745873985 },
        "year": "2023",
        "ste_code": ["10"],
        "ste_name": ["Delaware"],
        "coty_code": ["10003"],
        "coty_name": ["New Castle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["New Castle County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00217270"
      },
      "bbox": [
        15.749965176337065, 2.246311170436975, 16.032635383658764,
        2.8173388565991604
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.524901276710803, -8.13141345585177],
            [12.530316734414114, -8.130182516120513],
            [12.54777004771646, -8.127615137782227],
            [12.550247406306037, -8.12068878760577],
            [12.563475477440894, -8.104475218956855],
            [12.576552235885174, -8.098085981361919],
            [12.5888296077892, -8.09311379569608],
            [12.620359470059835, -8.088084370133641],
            [12.626223731690459, -8.078572427933183],
            [12.627860675391378, -8.073342773305322],
            [12.62737707068874, -8.066842512042523],
            [12.62909682012367, -8.053318282867819],
            [12.631135831993392, -8.047766978914153],
            [12.635531089023944, -8.04186915553301],
            [12.639442239256343, -8.039126003815229],
            [12.64713769315337, -8.037416567876697],
            [12.654690836056371, -8.032210973115584],
            [12.67175036579896, -8.027019870933735],
            [12.679000463591294, -8.02662663915562],
            [12.685419016353846, -8.01888272780207],
            [12.690295246186544, -8.015625517966676],
            [12.698064175908316, -8.007808612595666],
            [12.70464371902052, -7.998535053777424],
            [12.709519209917321, -7.995885557216157],
            [12.711281176484913, -7.991715017866994],
            [12.716103105511491, -7.984733575451105],
            [12.763273400076415, -7.977133095949243],
            [12.844842292705579, -7.963160655728015],
            [12.913707626797061, -7.951363798225599],
            [12.925561893330935, -7.974523772930787],
            [12.931930873455443, -7.985972845937409],
            [12.936830363354707, -7.992538278525623],
            [12.948776289658454, -8.00096862235768],
            [12.95458651219829, -8.00636815647422],
            [12.958596836414392, -8.01490939077882],
            [12.966217092441596, -8.019846721081388],
            [12.97391533035992, -8.023111575272354],
            [12.984956945151307, -8.090271931806006],
            [12.985464871536642, -8.092324115154218],
            [12.996066546681053, -8.157092970450021],
            [13.006748987134303, -8.218168150719583],
            [13.01792102233907, -8.279874736023308],
            [13.02131209156731, -8.285718784651996],
            [13.038784426197719, -8.30442675692853],
            [13.049975974385003, -8.317407931787773],
            [13.054726795223635, -8.325293237124084],
            [13.058584165074741, -8.346125966069488],
            [13.062647086222768, -8.35071178132261],
            [13.064957578436715, -8.355363150050401],
            [13.066615663217695, -8.364318216327401],
            [13.068603394672746, -8.369719953030588],
            [13.071197885670886, -8.372226926830376],
            [13.078854282862226, -8.37496301083084],
            [13.09052942368912, -8.375784273726268],
            [13.093300759047214, -8.374860934078333],
            [13.103343691693105, -8.366321581472489],
            [13.10726391091602, -8.364321370776839],
            [13.106634416161434, -8.367716407792926],
            [13.103305098571617, -8.372046276936468],
            [13.102813740542635, -8.3784814698802],
            [13.099828033934454, -8.383882262571323],
            [13.095771556210739, -8.386180795590573],
            [13.048702220973201, -8.40731284562488],
            [13.040438272375887, -8.411213120239927],
            [13.037184117564422, -8.411381222899214],
            [13.02157159764933, -8.419391474091007],
            [12.93694433575138, -8.455695846410086],
            [12.905700910271024, -8.469011303802425],
            [12.905239653754903, -8.463109263412724],
            [12.908309989420882, -8.454402391606683],
            [12.917737301521544, -8.450388324120395],
            [12.922640272476317, -8.453685664336628],
            [12.924306804875714, -8.4503595500914],
            [12.92026939667976, -8.447976284037205],
            [12.922142537683326, -8.442936723691597],
            [12.918357386354618, -8.438576986043351],
            [12.917392913750085, -8.431618405248463],
            [12.909275650609041, -8.42119267585468],
            [12.885608368279545, -8.425473644804917],
            [12.846546203195354, -8.431251810622012],
            [12.841659545192847, -8.39863712864881],
            [12.837394925783594, -8.373712625209887],
            [12.809009398175593, -8.378643680408395],
            [12.79921310283104, -8.321877610579296],
            [12.752319027156574, -8.329888856841526],
            [12.742041772777222, -8.331302450795306],
            [12.736728151600591, -8.297600567035492],
            [12.728025056550168, -8.303085079239413],
            [12.723392418019623, -8.303753305744264],
            [12.722023520456743, -8.305898490477427],
            [12.711435914167186, -8.307318818717901],
            [12.708734166410133, -8.30948507117358],
            [12.700947053953678, -8.311248514485028],
            [12.699809950164834, -8.31488465428477],
            [12.691514152386642, -8.310232056848744],
            [12.686977922599528, -8.310024463507066],
            [12.682926285510918, -8.312344328626981],
            [12.68338620463411, -8.317261806264405],
            [12.681504474721665, -8.321939961035193],
            [12.674205768165566, -8.318746251636576],
            [12.6724203800162, -8.316534772046356],
            [12.667578096476781, -8.316001127683666],
            [12.66097248312193, -8.313375300049868],
            [12.649509585091192, -8.321906651625627],
            [12.639868265918434, -8.32627017280362],
            [12.634998963182403, -8.329839081424836],
            [12.628820489117198, -8.330700248084726],
            [12.612388365924609, -8.335719742322592],
            [12.60557823885907, -8.335837658348158],
            [12.60067673496039, -8.336983273090333],
            [12.582835633884194, -8.346577102695916],
            [12.578394729498445, -8.350599250117018],
            [12.574371475919563, -8.35638112216081],
            [12.571298021701908, -8.363304682067406],
            [12.56557760377574, -8.369539976048033],
            [12.56078168218782, -8.373314397663124],
            [12.555227390534704, -8.337334519331078],
            [12.54319674064733, -8.252259162515273],
            [12.53510730771574, -8.202870899576546],
            [12.533495695531146, -8.191605693466729],
            [12.532526457421927, -8.17897371250128],
            [12.531805460242254, -8.158123203072916],
            [12.5304451487513, -8.135372844008998],
            [12.529853425685243, -8.13342606920934],
            [12.524901276710803, -8.13141345585177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.74429232194313,
          "lat": 29.608677477935323
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12107"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00306910"
      },
      "bbox": [
        12.524901276710803, -8.469011303802425, 13.10726391091602,
        -7.951363798225599
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.11122980418278, -6.678911279078787],
            [12.11519509001996, -6.677409270182396],
            [12.12147972877409, -6.680573544984717],
            [12.122674019665105, -6.68375378649322],
            [12.127222474761364, -6.683714959710577],
            [12.127990326614755, -6.68061476993041],
            [12.133784334593033, -6.6816826732033805],
            [12.135325571629775, -6.679465598552849],
            [12.14420336934215, -6.681222811903198],
            [12.149773049375959, -6.680711596278043],
            [12.15699435263363, -6.676503956332457],
            [12.16191143449875, -6.675626117773713],
            [12.168386391806836, -6.681138498373925],
            [12.170061429796446, -6.67912182513199],
            [12.176098847612227, -6.679827168630892],
            [12.189262050295753, -6.684517148993608],
            [12.191249208369756, -6.689574772035769],
            [12.195042518721559, -6.684892858166091],
            [12.199724572859894, -6.684688579921532],
            [12.199727668813583, -6.679362751820852],
            [12.204197276450394, -6.676913617905109],
            [12.205483383250435, -6.671553000711593],
            [12.211518627895432, -6.673973518288385],
            [12.217182799141295, -6.66880811034171],
            [12.219740070550223, -6.668591701900602],
            [12.227174107164377, -6.658506285332281],
            [12.225489360363024, -6.652666174092585],
            [12.229579669240872, -6.648463069193092],
            [12.228290576190266, -6.643436519444392],
            [12.224407219363451, -6.634361313767125],
            [12.22847258523849, -6.627353512743657],
            [12.236789257194049, -6.628096373259629],
            [12.24271617606392, -6.6234948211282365],
            [12.243235979313933, -6.618841464402298],
            [12.246816240686796, -6.6166305997686115],
            [12.247649499686478, -6.6128522012831725],
            [12.253195305063645, -6.610209540918292],
            [12.25720833182877, -6.610120363914868],
            [12.262251326410421, -6.606086418762481],
            [12.268475933317147, -6.604344821989382],
            [12.27324957785248, -6.604427601516267],
            [12.274768062559449, -6.607801571469664],
            [12.279142456631702, -6.603020934015343],
            [12.283308716471064, -6.601906300510563],
            [12.287641419013184, -6.603330672802192],
            [12.293926415231434, -6.602222116757327],
            [12.30308674106215, -6.60277884673522],
            [12.303845409457514, -6.599847723886373],
            [12.307389691072245, -6.59841903581833],
            [12.31109723556518, -6.600867266343863],
            [12.316742997802974, -6.59549215798863],
            [12.318458193648418, -6.598382210101856],
            [12.323652343705085, -6.595241726422808],
            [12.324459204132282, -6.593031783689142],
            [12.33083949498624, -6.593799880080784],
            [12.334770275329918, -6.592500431243849],
            [12.33718034737772, -6.589152113561708],
            [12.337507585249403, -6.583951693105443],
            [12.344065983961967, -6.580277903768122],
            [12.34550608816878, -6.5606807912546055],
            [12.336556895979633, -6.559628428774741],
            [12.330016080671031, -6.5543961281306835],
            [12.327586582122956, -6.554129029869126],
            [12.325294000823964, -6.548446930328121],
            [12.316368084930673, -6.5400518013133215],
            [12.31386179582586, -6.534158731539553],
            [12.306598658529394, -6.528049926311599],
            [12.30272658330003, -6.517693853948286],
            [12.298784268498459, -6.5160314811392945],
            [12.296491248606264, -6.5127897927906195],
            [12.296786663364701, -6.50481751502347],
            [12.294559362544474, -6.501795871958635],
            [12.304097955326803, -6.507936264873257],
            [12.373176490341034, -6.512970926472008],
            [12.397873572493992, -6.514619988947051],
            [12.408711996803914, -6.511660473577927],
            [12.4622306085887, -6.496108838762937],
            [12.498024729164207, -6.481695897154391],
            [12.53117236704615, -6.492517955227902],
            [12.536438795785624, -6.497711875709713],
            [12.56142493003402, -6.506167844389724],
            [12.560971444974957, -6.510539428562132],
            [12.564867121863049, -6.533476947196695],
            [12.56439656984982, -6.540233528271182],
            [12.562300092959664, -6.5473309606980825],
            [12.555663451832453, -6.5560303502337005],
            [12.55420772859001, -6.566581008376745],
            [12.552584053037707, -6.592394450022532],
            [12.55253755729035, -6.600467742271336],
            [12.551093438647195, -6.612564992555796],
            [12.54991541309719, -6.615674123988061],
            [12.551092171796887, -6.6369870748917466],
            [12.547103717972876, -6.662985640155663],
            [12.542123482191109, -6.667898857504553],
            [12.543800523558856, -6.674398315159971],
            [12.54867755853477, -6.675011511342697],
            [12.556369005346287, -6.6686415731801],
            [12.540450786425518, -6.688645971098853],
            [12.539295127278223, -6.694994354775982],
            [12.52928744245331, -6.691228538915716],
            [12.521165864957888, -6.702872811526031],
            [12.516934541278893, -6.707671332336812],
            [12.514705302895923, -6.7146091115343],
            [12.513842830637959, -6.720569817379259],
            [12.509872559943531, -6.726419682732933],
            [12.5085420415856, -6.731201457590363],
            [12.509143521496048, -6.738066667399286],
            [12.505836206382776, -6.743281928242362],
            [12.504324861908445, -6.74895660099734],
            [12.469740917583248, -6.753159800567137],
            [12.462579458081988, -6.752000487527757],
            [12.44489835492418, -6.758398055428825],
            [12.439756224112726, -6.7625056807328905],
            [12.43880168527719, -6.767426715183062],
            [12.435434702101395, -6.768941952618247],
            [12.436018270589289, -6.775503334052745],
            [12.433936859301168, -6.778350873348472],
            [12.436607443730372, -6.7883254431066495],
            [12.436289845620315, -6.796602020341882],
            [12.432023331722556, -6.793716843892384],
            [12.428677047071565, -6.797339377678155],
            [12.432587913277287, -6.799891617960985],
            [12.433242203172712, -6.802621738560335],
            [12.430652224663632, -6.8054242172495245],
            [12.431196818619645, -6.809851350494014],
            [12.403367867853497, -6.807646314726281],
            [12.355287300921969, -6.801794271217148],
            [12.321634965169086, -6.797983665280845],
            [12.313999468994462, -6.864726007299936],
            [12.312413288870333, -6.8651414925442],
            [12.271305989579881, -6.870882153969539],
            [12.238858373766666, -6.8375153986070005],
            [12.195836312144216, -6.807316661388109],
            [12.188119241800306, -6.756296734989417],
            [12.184899322832889, -6.7377776153518525],
            [12.182938337522145, -6.722423950852498],
            [12.16882745057279, -6.7270264017837205],
            [12.162694937214848, -6.7266804260295014],
            [12.14663854112956, -6.7166347476101915],
            [12.14492361477489, -6.716057094952835],
            [12.116141307260174, -6.710683578495448],
            [12.11122980418278, -6.678911279078787]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.9819366659723, "lat": 31.196901091883227 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13025"],
        "coty_name": ["Brantley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brantley County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00351605"
      },
      "bbox": [
        12.11122980418278, -6.870882153969539, 12.564867121863049,
        -6.481695897154391
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.519959138420521, -5.940280400758414],
            [10.520807473579252, -5.937909280982058],
            [10.516075088754944, -5.933021458666543],
            [10.51696388371964, -5.929188079258833],
            [10.52340457295301, -5.924911086471539],
            [10.524620728946099, -5.917975644408033],
            [10.528639248356955, -5.9087546542347145],
            [10.536039519294635, -5.90306402321649],
            [10.54078862969855, -5.896407221885971],
            [10.54207423567787, -5.892347399230153],
            [10.548439279699195, -5.8879559854523205],
            [10.551725077684765, -5.880791513176519],
            [10.559593122913613, -5.869041073337462],
            [10.562358464076965, -5.862458491090852],
            [10.562404491870893, -5.857476052079864],
            [10.567145211215639, -5.852742540091538],
            [10.576113660258406, -5.8493898880483535],
            [10.577680362197516, -5.844515643368309],
            [10.586656851469279, -5.840031452005827],
            [10.588074938290069, -5.8363783424303834],
            [10.592579750621773, -5.834642683600564],
            [10.594483165727087, -5.831635415467711],
            [10.600725432855073, -5.828826470100328],
            [10.606274232061775, -5.821062125666967],
            [10.614554463005543, -5.817850319835705],
            [10.613531491271429, -5.808682427492973],
            [10.615472773658816, -5.806204812053838],
            [10.627144639644811, -5.8054126645689195],
            [10.654325873979886, -5.802460302077446],
            [10.747229407648529, -5.79131988327709],
            [10.762800961240897, -5.789326471342609],
            [10.763448098402792, -5.796391376758228],
            [10.778881034105535, -5.794889939306995],
            [10.777893309804854, -5.787546318134868],
            [10.848776099926727, -5.779784167205228],
            [10.856447867211761, -5.778905610243478],
            [10.861321728993627, -5.815693240090238],
            [10.853436847364799, -5.816585412677367],
            [10.854672635592696, -5.82627000042121],
            [10.859542346204137, -5.82560878481443],
            [10.862562034774575, -5.828694427874508],
            [10.869750008635528, -5.887968798190409],
            [10.875254386703176, -5.935414167212378],
            [10.87687398976067, -5.947706294578063],
            [10.8868884640095, -6.029034992797667],
            [10.887759819177951, -6.037477040556911],
            [10.799193221228027, -6.048135053343115],
            [10.758600289457481, -6.052873573866264],
            [10.667750318525046, -6.0631778571133275],
            [10.61090231236525, -6.070511785849951],
            [10.59321503468484, -6.072650814325786],
            [10.59238380169149, -6.067428447283185],
            [10.586165433802531, -6.066377312997678],
            [10.587302298474448, -6.0612411547371154],
            [10.58528399671367, -6.058081753111164],
            [10.579336306725526, -6.061998260773288],
            [10.575942012216265, -6.061354707448376],
            [10.576279681922301, -6.043550499084865],
            [10.574928688034388, -6.040883561782835],
            [10.566829167926436, -6.035602219145186],
            [10.569233891706423, -6.030195775429538],
            [10.5699450973133, -6.024024015614936],
            [10.572038575779695, -6.020110319171229],
            [10.572563519494523, -6.015230250003876],
            [10.571001352389377, -6.010902207797532],
            [10.56518031560138, -6.012304109423151],
            [10.560171245802255, -6.005474643766302],
            [10.553799330750538, -6.007263737126294],
            [10.547337767779723, -5.993834349766976],
            [10.543254721394083, -5.990768814952335],
            [10.539559873800453, -5.989819293833056],
            [10.538995446602188, -5.985179258113684],
            [10.54116889867335, -5.979662825201321],
            [10.539438893680106, -5.977432668821817],
            [10.535470394323404, -5.978568901986857],
            [10.529491119997969, -5.974502404759692],
            [10.528705509175888, -5.969522223772457],
            [10.520606690641692, -5.9609249748327455],
            [10.518982673294595, -5.957318701640812],
            [10.519959138420521, -5.940280400758414]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.79876187944039, "lat": 32.15722616382428 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13093"],
        "coty_name": ["Dooly"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dooly County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00351608"
      },
      "bbox": [
        10.516075088754944, -6.072650814325786, 10.887759819177951,
        -5.778905610243478
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.542382125123694, -7.135895909090785],
            [11.548266722229712, -7.137525821307509],
            [11.551491491143736, -7.124923506022271],
            [11.560249760455346, -7.1213399424266],
            [11.562504551924025, -7.1217661296358346],
            [11.565992899988863, -7.117639152347417],
            [11.570866020431758, -7.109108609500011],
            [11.580430688407375, -7.1106698260339956],
            [11.691114520938301, -7.130045875458823],
            [11.690480546335378, -7.132249177100589],
            [11.69272725102693, -7.13777128113782],
            [11.696408043113212, -7.1392736237228815],
            [11.700832622915366, -7.146820838408281],
            [11.706031622227, -7.1493132186005095],
            [11.708243581634212, -7.15396956125145],
            [11.705787087067243, -7.1632987020620025],
            [11.709165591514727, -7.176963010112205],
            [11.712705396481818, -7.181300505172728],
            [11.718165220451786, -7.181403620465138],
            [11.721705392191245, -7.1848407247829575],
            [11.725206147003652, -7.184527640105075],
            [11.73126224154267, -7.194443701249545],
            [11.734669767965572, -7.197262798081534],
            [11.73530910926431, -7.204242861633677],
            [11.738053625230611, -7.209239646329273],
            [11.743042044660916, -7.211275731327609],
            [11.747301634919413, -7.215538778914381],
            [11.757006320520764, -7.2180926863714445],
            [11.76610200420492, -7.218797805529362],
            [11.77307655865662, -7.22174225810681],
            [11.77743382485728, -7.22004463668568],
            [11.785107159805522, -7.221202635363484],
            [11.7921527814976, -7.217915705524273],
            [11.80029068855052, -7.218059473484525],
            [11.80473235997212, -7.220547854417412],
            [11.8152481013392, -7.217977202651216],
            [11.821581910135436, -7.218112503341848],
            [11.831121445860264, -7.211784814009718],
            [11.836374197334536, -7.211374934077217],
            [11.84205675870458, -7.213196771733109],
            [11.851979622891873, -7.217797620125927],
            [11.8559063372722, -7.217076991864386],
            [11.862739177868304, -7.219293827379342],
            [11.86860912932744, -7.218170671994233],
            [11.87063562587536, -7.219690546438369],
            [11.878188401433148, -7.221149270721051],
            [11.884931160472457, -7.221395143837408],
            [11.894889586608542, -7.218532726630801],
            [11.908485906485621, -7.221933768844675],
            [11.913836667921661, -7.220907534194598],
            [11.922150529016637, -7.225340116017962],
            [11.926942046374725, -7.226800686610003],
            [11.929099206170225, -7.231744280999636],
            [11.935560255509731, -7.235263359560223],
            [11.937896206033622, -7.238977046767228],
            [11.936767275387677, -7.2455929670101025],
            [11.93433856359732, -7.252653020722727],
            [11.934080341052715, -7.256755269462826],
            [11.93715366155015, -7.2678714568018075],
            [11.940697887997084, -7.2700444102804616],
            [11.939679681270048, -7.273458101719472],
            [11.947911158508209, -7.338410393705546],
            [11.857333853165848, -7.345163605580611],
            [11.696120024636, -7.3562092213439065],
            [11.570561956972835, -7.365017366979985],
            [11.477988504390911, -7.371366046262535],
            [11.47347258682764, -7.3715685200711],
            [11.471584903497652, -7.350899274518248],
            [11.46526879562905, -7.300732002120995],
            [11.460931631214494, -7.274948552252028],
            [11.46188531981159, -7.268488626200971],
            [11.459707865933145, -7.261931642760594],
            [11.458953361221692, -7.253581270679624],
            [11.459982117977814, -7.247350509395971],
            [11.458635788986145, -7.245868185215853],
            [11.45848742670199, -7.238575660948457],
            [11.454092898408108, -7.227753965836461],
            [11.453336109730698, -7.222511694882321],
            [11.455379138885455, -7.2167504617029765],
            [11.454274219850316, -7.212085063307551],
            [11.45478422648764, -7.2032799423756675],
            [11.459141746915131, -7.193189231721028],
            [11.476534817219784, -7.190787113229686],
            [11.473733412644176, -7.163330137191877],
            [11.486607143935169, -7.161819108393104],
            [11.484249659123938, -7.144600327039464],
            [11.542382125123694, -7.135895909090785]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.89402947569225,
          "lat": 30.710062405275863
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13101"],
        "coty_name": ["Echols"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Echols County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00348092"
      },
      "bbox": [
        11.453336109730698, -7.3715685200711, 11.947911158508209,
        -7.109108609500011
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.494802764349654, -5.581715820807689],
              [10.497893473461119, -5.590749453830274],
              [10.491570907792596, -5.590354364999815],
              [10.454256647420985, -5.594801740742709],
              [10.453472585816323, -5.586243728232089],
              [10.494802764349654, -5.581715820807689]
            ]
          ],
          [
            [
              [10.305368348922038, -5.764591989122618],
              [10.302703592083477, -5.7412131271793],
              [10.306852941949241, -5.736376456968606],
              [10.31158330982398, -5.734608870104384],
              [10.314018490547008, -5.736157462304482],
              [10.316765589305696, -5.733722595492616],
              [10.322440027811577, -5.733354697712827],
              [10.349119630077592, -5.729991329030178],
              [10.398843707290535, -5.617990444438305],
              [10.408042322426956, -5.617039588721171],
              [10.407068197773837, -5.608687643133124],
              [10.439429953824048, -5.604574624571339],
              [10.438590819739733, -5.596888347880807],
              [10.454256647420985, -5.594801740742709],
              [10.455090095255972, -5.603489489513077],
              [10.471127003621657, -5.60129658245076],
              [10.47333151963706, -5.617188538782828],
              [10.487348340502633, -5.615724343965558],
              [10.482140484339157, -5.607821604830364],
              [10.485480634515719, -5.606621584785338],
              [10.51107924692976, -5.603707357655152],
              [10.510149600488178, -5.595505854855895],
              [10.523536050671806, -5.5939005916999704],
              [10.524669617765175, -5.602151978162432],
              [10.556847118052438, -5.598309687645249],
              [10.556305926882576, -5.592370204984946],
              [10.563702813827376, -5.591722677017956],
              [10.564047220726149, -5.598601303985621],
              [10.560764846277436, -5.619952164355158],
              [10.567570397824197, -5.619572450489802],
              [10.565919340896773, -5.605492373678223],
              [10.584552889098484, -5.60357093668389],
              [10.588046546279696, -5.605586656717823],
              [10.596634767664689, -5.6052989964197835],
              [10.605069914894388, -5.608993182776536],
              [10.610490558283987, -5.618391696834677],
              [10.6211047484879, -5.62062757357186],
              [10.62663305720892, -5.62059980901395],
              [10.630176320007049, -5.622072700948814],
              [10.632982750188958, -5.626110643113468],
              [10.637111662543552, -5.654970471005112],
              [10.645055078548852, -5.654031373884739],
              [10.652077494972067, -5.710746072140704],
              [10.635807014203653, -5.712621837755313],
              [10.6389225048398, -5.737060522173725],
              [10.647057262306264, -5.736056597382546],
              [10.654325873979886, -5.802460302077446],
              [10.627144639644811, -5.8054126645689195],
              [10.615472773658816, -5.806204812053838],
              [10.613531491271429, -5.808682427492973],
              [10.614554463005543, -5.817850319835705],
              [10.606274232061775, -5.821062125666967],
              [10.600725432855073, -5.828826470100328],
              [10.594483165727087, -5.831635415467711],
              [10.592579750621773, -5.834642683600564],
              [10.588074938290069, -5.8363783424303834],
              [10.586656851469279, -5.840031452005827],
              [10.577680362197516, -5.844515643368309],
              [10.576113660258406, -5.8493898880483535],
              [10.567145211215639, -5.852742540091538],
              [10.562404491870893, -5.857476052079864],
              [10.562358464076965, -5.862458491090852],
              [10.559593122913613, -5.869041073337462],
              [10.551725077684765, -5.880791513176519],
              [10.548439279699195, -5.8879559854523205],
              [10.54207423567787, -5.892347399230153],
              [10.54078862969855, -5.896407221885971],
              [10.536039519294635, -5.90306402321649],
              [10.528639248356955, -5.9087546542347145],
              [10.524620728946099, -5.917975644408033],
              [10.52340457295301, -5.924911086471539],
              [10.51696388371964, -5.929188079258833],
              [10.516075088754944, -5.933021458666543],
              [10.520807473579252, -5.937909280982058],
              [10.519959138420521, -5.940280400758414],
              [10.516231768405513, -5.938500677773935],
              [10.508908549158507, -5.937732578517695],
              [10.508886346377693, -5.934955197239707],
              [10.50015614448284, -5.928768727094826],
              [10.494092310099921, -5.931143185831875],
              [10.483769044936011, -5.930726613600963],
              [10.47947989395951, -5.9323743027344165],
              [10.472280989451544, -5.929144842007858],
              [10.469636681455514, -5.92635262513501],
              [10.45700965335473, -5.927132366381944],
              [10.451035796214041, -5.929589961603588],
              [10.447523035158243, -5.929325056399748],
              [10.442159729037124, -5.931203781438964],
              [10.433844162081503, -5.9327143361633645],
              [10.428659822665702, -5.937392932092037],
              [10.423865894353586, -5.895086318631948],
              [10.383933404503365, -5.898316941702495],
              [10.351613871183481, -5.900870584841712],
              [10.344450557860993, -5.837359606888365],
              [10.313689821828401, -5.840058663884996],
              [10.305368348922038, -5.764591989122618]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.04251335962827, "lat": 32.35844095870162 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13193"],
        "coty_name": ["Macon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macon County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "00346957"
      },
      "bbox": [
        10.302703592083477, -5.940280400758414, 10.654325873979886,
        -5.581715820807689
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.547936263971824, -4.127950561394945],
            [9.554790312102963, -4.127036530308317],
            [9.555555493260497, -4.134346219749936],
            [9.559149395683026, -4.13392613951881],
            [9.558842980007045, -4.130621632088626],
            [9.569445008287186, -4.129280201599993],
            [9.56908034026757, -4.125477508908749],
            [9.582542517710282, -4.1238246532292075],
            [9.698896830269259, -4.110342284343423],
            [9.699241206279945, -4.113317632932402],
            [9.699181882124774, -4.11431861538036],
            [9.704230781900156, -4.16271071509912],
            [9.707388752253616, -4.189793537569874],
            [9.711035981527898, -4.224294440543996],
            [9.713491460625585, -4.244762352006341],
            [9.727087812158862, -4.243361674442928],
            [9.729284562606527, -4.268357836033893],
            [9.733525102623277, -4.3057074897744005],
            [9.735264822628121, -4.323990229540389],
            [9.740978443905682, -4.373824275511684],
            [9.742971176338989, -4.384316656899588],
            [9.745110268561122, -4.402049690810654],
            [9.730999516110922, -4.403761831495482],
            [9.720239147644318, -4.406501466827962],
            [9.71275383511498, -4.407163739151719],
            [9.683477390213657, -4.415771960578022],
            [9.684091880177647, -4.418071017354212],
            [9.657335504631714, -4.422627316734353],
            [9.657628609412923, -4.425124064651363],
            [9.619715989307444, -4.430851740546864],
            [9.60054771819381, -4.427084232937821],
            [9.586005018633205, -4.42309580333074],
            [9.541370747594486, -4.414858098929872],
            [9.529039240694683, -4.413604675803643],
            [9.520836760718064, -4.412174017622819],
            [9.513517296536941, -4.412073996522852],
            [9.485267770268708, -4.408896307001264],
            [9.475573583515855, -4.316595883730612],
            [9.46440401002822, -4.317722741183918],
            [9.459218074370998, -4.269627020639398],
            [9.517550662973026, -4.26412939793354],
            [9.544301968508062, -4.139302280556396],
            [9.547936263971824, -4.127950561394945]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.86728721996329, "lat": 33.92055295643737 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13223"],
        "coty_name": ["Paulding"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Paulding County"],
        "coty_fp_code": "223",
        "coty_gnis_code": "00349912"
      },
      "bbox": [
        9.459218074370998, -4.430851740546864, 9.745110268561122,
        -4.110342284343423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.809907449302738, -7.126881756066698],
            [9.900182070743652, -7.119386941544136],
            [9.93625138654861, -7.115900902688986],
            [9.946685489805331, -7.11533681137765],
            [9.965083221029975, -7.1133319171293605],
            [10.063013995744736, -7.103711772653251],
            [10.06463298579881, -7.122671011817075],
            [10.055600395331746, -7.123729127639185],
            [10.056660891562656, -7.1328010971051805],
            [10.04759715336075, -7.13357916999087],
            [10.053645548313215, -7.1967776381936535],
            [10.063538940929721, -7.287963651561006],
            [10.054208450061834, -7.2890210936116],
            [10.055279955276985, -7.29787826272758],
            [10.05335382486013, -7.302574609294653],
            [10.057318216308452, -7.334653018716919],
            [10.05696148270854, -7.338711156943256],
            [10.04583390812443, -7.351827850797867],
            [10.047114512188637, -7.356783632770211],
            [10.043165658039602, -7.361254499830055],
            [10.046692032812741, -7.37055349802761],
            [10.045525896547467, -7.374495738810398],
            [10.035098479962075, -7.375320042853081],
            [10.031252113625833, -7.38067797195403],
            [10.030641541633246, -7.38757842859809],
            [10.02799235567888, -7.394576599182484],
            [10.023203711094135, -7.39493781409684],
            [10.01711849771718, -7.400356599639369],
            [10.00852563733428, -7.40066183136738],
            [10.005196192306135, -7.403854713355562],
            [10.00407253807124, -7.408191044316571],
            [10.000527435983445, -7.407404225154633],
            [9.9969236544532, -7.409026871564856],
            [9.998068037353972, -7.4142992349642265],
            [9.99632743867613, -7.417806319584855],
            [9.99048363332607, -7.418374831954194],
            [9.988475883171937, -7.420725563315216],
            [9.990971248938733, -7.428905225493991],
            [9.987032515774434, -7.431103840314346],
            [9.984808999708923, -7.434986024948504],
            [9.983309166293802, -7.449030615920408],
            [9.985775596039982, -7.455339104639701],
            [9.991031243574941, -7.4622157089429155],
            [9.992513176963932, -7.470287242027358],
            [9.991459177131954, -7.470374028573082],
            [9.985937421067685, -7.460654105052065],
            [9.980454700410686, -7.455694400989834],
            [9.972704933819433, -7.451492900844562],
            [9.96847751215355, -7.442776640337911],
            [9.960126850178332, -7.434940273880553],
            [9.956484489954988, -7.434062802157023],
            [9.951443158532769, -7.4359503868196954],
            [9.94728665237372, -7.4358329730201],
            [9.94428231721928, -7.433779757111859],
            [9.942799703124711, -7.426344513367421],
            [9.937897838799081, -7.422110041948444],
            [9.93897385144716, -7.415878800929858],
            [9.938274000607551, -7.409953757468577],
            [9.92945934858149, -7.398864056027783],
            [9.92667478313642, -7.392079267827411],
            [9.926969762886351, -7.386538745284912],
            [9.92352024914531, -7.379231015427228],
            [9.917568350775129, -7.37191182931953],
            [9.91677847335867, -7.369600513254285],
            [9.916684236056454, -7.356523160574214],
            [9.919112872656326, -7.352108141813048],
            [9.923549548563491, -7.350488853706978],
            [9.924240265639824, -7.346911077087486],
            [9.921797692320936, -7.341983663347914],
            [9.916786502818827, -7.3389613065273975],
            [9.913021927978491, -7.331887749197105],
            [9.916018580382767, -7.327334316399157],
            [9.915193903702635, -7.324726202064112],
            [9.909270783571126, -7.319805248875104],
            [9.908959894263226, -7.316436433589048],
            [9.91230981486412, -7.309037724950838],
            [9.911512683153662, -7.306486292009869],
            [9.904570617041752, -7.303325414174651],
            [9.897500731251647, -7.295232339258209],
            [9.890790691469581, -7.285793843931774],
            [9.880655613913875, -7.277251614985642],
            [9.877815682201037, -7.272872653121333],
            [9.875736351700267, -7.266903189745008],
            [9.867057642590787, -7.263399005899508],
            [9.864010447367727, -7.259445027021166],
            [9.864051254383966, -7.249523991058832],
            [9.865354540100721, -7.241560259122823],
            [9.864164090730272, -7.235086463970785],
            [9.861627135854775, -7.231072078012681],
            [9.856585620111707, -7.2284487153716475],
            [9.842457894162326, -7.225388506011801],
            [9.8401042969358, -7.21931269103246],
            [9.842164351081943, -7.211967511361797],
            [9.841503692601755, -7.201033625664517],
            [9.840603025130743, -7.1983393089815815],
            [9.842069017570712, -7.18975746454635],
            [9.841685203005337, -7.185028650876032],
            [9.836721108352078, -7.180253854642721],
            [9.835655850704628, -7.174844951338146],
            [9.831069205367552, -7.167681568405174],
            [9.830587241476227, -7.15727023427338],
            [9.826937023179031, -7.14694703102069],
            [9.820545968475908, -7.14196446844715],
            [9.80993178824995, -7.127824114477308],
            [9.809907449302738, -7.126881756066698]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.86882617902491,
          "lat": 30.938780217541332
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13253"],
        "coty_name": ["Seminole"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seminole County"],
        "coty_fp_code": "253",
        "coty_gnis_code": "00351263"
      },
      "bbox": [
        9.809907449302738, -7.470374028573082, 10.06463298579881,
        -7.103711772653251
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.908292217054116, -6.209958976109186],
            [10.967620283566943, -6.203199692329211],
            [10.963362505732665, -6.208936220304402],
            [11.019906379541986, -6.202162408235664],
            [11.02056262825072, -6.204756673120873],
            [11.01803504402704, -6.214987055587083],
            [11.024218456897806, -6.21797543276084],
            [11.025386962876077, -6.220052771864755],
            [11.024384631871945, -6.225475365059794],
            [11.025610967683615, -6.2287669159550685],
            [11.028887077062809, -6.231073146830332],
            [11.028883013123647, -6.234754378899366],
            [11.031522548147143, -6.241217830162655],
            [11.037170570430952, -6.244799550951839],
            [11.039151074943106, -6.2501750502802675],
            [11.044504456392175, -6.25232250047411],
            [11.046834434272151, -6.258412096589144],
            [11.045278986550695, -6.263929403432987],
            [11.046264847271392, -6.266536936349366],
            [11.050025018390714, -6.26772181604078],
            [11.051855868114478, -6.27889158725952],
            [11.054212944366297, -6.282537620392263],
            [11.053982106973239, -6.287770985955961],
            [11.055956230464071, -6.2932470012394415],
            [11.04770329291564, -6.304689677903062],
            [11.04980540663977, -6.317308569567313],
            [11.056466551472665, -6.322677387119051],
            [11.057697038637695, -6.328915461022417],
            [11.061095125487617, -6.336443232476862],
            [11.056696334110702, -6.341141012278959],
            [11.05534660166241, -6.346418079241747],
            [11.05635921188093, -6.350366507472177],
            [11.031041360582549, -6.352993778510249],
            [11.040328048971588, -6.428969418255868],
            [11.033396211123385, -6.42983260737108],
            [11.036062928892875, -6.455115756053485],
            [11.010139733028657, -6.457962194472535],
            [10.999909214199944, -6.457949239485131],
            [10.9734075625468, -6.460510293761322],
            [10.961776426390317, -6.463648181220693],
            [10.947714284632648, -6.462722716700803],
            [10.935988153050188, -6.46585001522952],
            [10.927947329958117, -6.466485738161971],
            [10.91104006787401, -6.468957762089402],
            [10.914400362759544, -6.497186338141685],
            [10.910051984768248, -6.494645944844783],
            [10.902611992482958, -6.50107841630063],
            [10.8953690479247, -6.495774644912648],
            [10.8930301962859, -6.486132295783381],
            [10.896672744161013, -6.481482603606124],
            [10.893544347926868, -6.47256496885767],
            [10.890352802745818, -6.472676773489208],
            [10.886332031355785, -6.467727087559041],
            [10.882517510712802, -6.468930533325724],
            [10.881214847829375, -6.472446776838885],
            [10.876493602845445, -6.471922979467128],
            [10.872717012792428, -6.467582040101552],
            [10.865598034085401, -6.465099908751941],
            [10.859737410632148, -6.452841332365234],
            [10.851161795168869, -6.453087938519028],
            [10.849019380049794, -6.451267648808108],
            [10.783248457117386, -6.458825960452061],
            [10.782644761934643, -6.456640699492116],
            [10.777940283215141, -6.417273069800874],
            [10.777214143129777, -6.413216447174629],
            [10.7651362819344, -6.322456647563495],
            [10.763308819972226, -6.322620656648063],
            [10.758748909498202, -6.282586831691717],
            [10.755085809296016, -6.280629523016771],
            [10.799324874932642, -6.274246910262027],
            [10.799852039395303, -6.273932320617041],
            [10.882162574722006, -6.263513073004954],
            [10.904354509209547, -6.260999148702761],
            [10.914491208227467, -6.259468572198403],
            [10.908292217054116, -6.209958976109186]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.62407948988746,
          "lat": 31.716430572637396
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13287"],
        "coty_name": ["Turner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Turner County"],
        "coty_fp_code": "287",
        "coty_gnis_code": "00343238"
      },
      "bbox": [
        10.755085809296016, -6.50107841630063, 11.061095125487617,
        -6.202162408235664
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.657201587419065, 3.671253656897992],
            [5.743251711247922, 3.678776979960125],
            [5.829010927546597, 3.6854524012166867],
            [5.914837968220349, 3.6921451703449697],
            [5.917296599952955, 3.663565535146939],
            [5.921912895317582, 3.6048715108756326],
            [5.911896581023805, 3.6040981594225685],
            [5.919045069405461, 3.518960924276678],
            [5.925786894383899, 3.431276320811607],
            [5.931781968202098, 3.3438381674207918],
            [5.934614986328015, 3.31155627510796],
            [5.939086680715992, 3.256352187331901],
            [5.937841976830717, 3.256238121094656],
            [5.940773397006158, 3.225006833164391],
            [5.945767878653095, 3.1679022987053735],
            [5.896894708660152, 3.163680523433938],
            [5.864333059918217, 3.1607018996708494],
            [5.786020901451999, 3.1556060977339917],
            [5.76507904978763, 3.153425866139084],
            [5.697153190317777, 3.1458828235712994],
            [5.689327477543764, 3.234534107717211],
            [5.687666977062205, 3.2437964342788],
            [5.683190363149384, 3.306256649530984],
            [5.675537200492359, 3.4099736230194417],
            [5.672311208908075, 3.449258611727208],
            [5.661948996542285, 3.5836603565888043],
            [5.664307511011524, 3.583853658724858],
            [5.657201587419065, 3.671253656897992]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.770308886483, "lat": 41.893542621881835 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17037"],
        "coty_name": ["DeKalb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeKalb County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00422190"
      },
      "bbox": [
        5.657201587419065, 3.1458828235712994, 5.945767878653095,
        3.6921451703449697
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.961274397492659, 1.576289176302445],
            [5.957781568280925, 1.6201524598772197],
            [6.001001670171907, 1.6232055655641493],
            [5.997758608110436, 1.6671817853124955],
            [6.008916171904805, 1.6895058839248835],
            [6.026416641931564, 1.7236103398682792],
            [6.0713181585089435, 1.811477974180149],
            [6.0722263293872585, 1.813807776713518],
            [6.143092446227029, 1.819099512692617],
            [6.144099688555857, 1.8197690987406803],
            [6.158473073105204, 1.8210472547905652],
            [6.162931694327857, 1.7621050121585942],
            [6.160800211739435, 1.7618840933576885],
            [6.167579119708038, 1.6796422324684277],
            [6.168518911816784, 1.666615987274335],
            [6.174649037064503, 1.592757467718976],
            [6.181961640095361, 1.504344962019916],
            [6.189330440372304, 1.4158736237431255],
            [6.19621679605666, 1.3280885652502676],
            [6.187978136693823, 1.3274516603589672],
            [6.062239413203757, 1.3179928631813513],
            [5.981133267067336, 1.3116519418626413],
            [5.976388128966336, 1.3707311912483877],
            [5.972526859982383, 1.4259525243357223],
            [5.968062540720233, 1.48816146831771],
            [5.964801163177711, 1.5272674412446499],
            [5.961274397492659, 1.576289176302445]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.5910986296404, "lat": 40.01034443997843 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17147"],
        "coty_name": ["Piatt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Piatt County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00424275"
      },
      "bbox": [
        5.957781568280925, 1.3116519418626413, 6.19621679605666,
        1.8210472547905652
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.3452012732833625, -0.12672546282438768],
            [5.3515550197937705, -0.12591305735589858],
            [5.352246075427355, -0.12099328753407707],
            [5.350618028053249, -0.11674674220422918],
            [5.35723616724598, -0.11418263683990934],
            [5.359219434460942, -0.11625993927050214],
            [5.364546328783709, -0.11401787881501743],
            [5.366233603014392, -0.10888480035106025],
            [5.371389597185308, -0.10489568763520782],
            [5.371620358333809, -0.09766956855150269],
            [5.37435515597808, -0.09484057550766534],
            [5.381528707175995, -0.09693694004303986],
            [5.38977924715658, -0.09745155562406499],
            [5.3901141626861975, -0.09454782427798039],
            [5.397643893490217, -0.09146844795908955],
            [5.402115020950661, -0.08754216988088871],
            [5.402284977337499, -0.08063965000890694],
            [5.400128405139207, -0.07560676423272404],
            [5.402740392053732, -0.07386976673484286],
            [5.404862113879247, -0.07716721779965353],
            [5.409488923594637, -0.07069877771843641],
            [5.410110963986458, -0.06564417830859795],
            [5.416422617832992, -0.062047457094038215],
            [5.421855200213651, -0.06054068179094728],
            [5.425821162373626, -0.06161006554513915],
            [5.437522865110955, -0.055359123065867745],
            [5.438582623999268, -0.051970794802587796],
            [5.446015369778842, -0.05393287069264253],
            [5.4461400130788125, -0.05907397502087656],
            [5.45401016373578, -0.05700177803921494],
            [5.4597319304940415, -0.05653724824480455],
            [5.4631338226858475, -0.05947288348770619],
            [5.468827158864933, -0.05793674540147718],
            [5.4668414384789275, -0.05409631367814417],
            [5.47276797922027, -0.052477166364365294],
            [5.475028294491741, -0.05429979241508333],
            [5.479908433596379, -0.05322101553074808],
            [5.483978107530339, -0.05791277547915002],
            [5.488690494572462, -0.059618138524415325],
            [5.492684395826299, -0.05724687656230498],
            [5.498328182062708, -0.05703670027019865],
            [5.504339429889822, -0.05824118943108906],
            [5.50781456350349, -0.05657266083342983],
            [5.516409131775254, -0.058894452819488026],
            [5.522785366586132, -0.056731212573424485],
            [5.524232644587342, -0.053381519341292816],
            [5.529556733972642, -0.05204009302089116],
            [5.5335972164845675, -0.04921590698847073],
            [5.532899078151017, -0.04649574505619862],
            [5.537145953477328, -0.040409007785398895],
            [5.540549958000926, -0.03825991672286276],
            [5.546099407227033, -0.03848773820538756],
            [5.549172826198207, -0.036842890064224434],
            [5.548510630898062, -0.033785323894956525],
            [5.553427170451721, -0.028198775025272578],
            [5.554807878338157, -0.030915020771760286],
            [5.561978204222533, -0.03274094586788477],
            [5.566211249705372, -0.03835037517572385],
            [5.569329900458457, -0.03736147897407526],
            [5.570561026207405, -0.030590271812941185],
            [5.574368695920656, -0.032275103998233856],
            [5.57990741041022, -0.030484759464987375],
            [5.586373620953999, -0.030846113793908114],
            [5.58871440345802, -0.027500455331208932],
            [5.60188209098906, -0.022988489274797023],
            [5.599260843437666, -0.01862069907738244],
            [5.604486440439721, -0.017749156783258647],
            [5.605718111012205, -0.014801352585415487],
            [5.603781557515476, -0.009184273946344291],
            [5.605344539659789, -0.0059784482978583915],
            [5.611153224599687, -0.00430737927204422],
            [5.614312927002826, -0.006544678610078451],
            [5.61746725111532, -0.012035628168651308],
            [5.633468667765075, -0.008616601647168522],
            [5.6358565680283625, -0.011937842070247753],
            [5.64287717625745, -0.008590661472370555],
            [5.645482772729127, -0.010464904057378136],
            [5.654287639915314, -0.013302372487814244],
            [5.660962256774728, -0.010451621350416095],
            [5.669663116618366, -0.011721528983631288],
            [5.671497095163647, -0.014041344766553538],
            [5.67654129933402, -0.011178154673619187],
            [5.679259079861592, -0.00795236901566944],
            [5.6864072444014475, -0.009375058739192537],
            [5.714998059277787, -0.009433584426715732],
            [5.745560659728904, -0.00882907130582242],
            [5.772617951469767, -0.00873051100010608],
            [5.774340242883035, -0.03817964114618495],
            [5.777346058682481, -0.08927383683793824],
            [5.783344694629693, -0.17636668405021175],
            [5.790842922424336, -0.30121367668702204],
            [5.762507932307804, -0.30283243407945293],
            [5.747727246595191, -0.30326909839350635],
            [5.717173013540034, -0.3051083045959978],
            [5.646645473201672, -0.3106611731013313],
            [5.617262820424997, -0.3118936441158812],
            [5.581637046330231, -0.3141085487290542],
            [5.533032893288845, -0.3159652455378084],
            [5.4971520262873925, -0.31684805811304445],
            [5.444850529608137, -0.3189332193825735],
            [5.359094991214178, -0.3245383071702974],
            [5.3544281964408045, -0.25813464149848786],
            [5.3452012732833625, -0.12672546282438768]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.41042083531251, "lat": 38.35223473584347 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17189"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "01785150"
      },
      "bbox": [
        5.3452012732833625, -0.3245383071702974, 5.790842922424336,
        -0.00430737927204422
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6245830104186828, 1.3113939468161748],
            [0.7119617327859391, 1.311525349643434],
            [0.7991405509988933, 1.3117468061249327],
            [0.8708107702237623, 1.3120077468409725],
            [0.9648193350697478, 1.312497279126912],
            [0.9656998621857332, 1.2119016653086816],
            [0.9659333941264925, 1.153117414098476],
            [0.9666868529501998, 1.0723948351942174],
            [0.9673707681670205, 0.9623436959460181],
            [0.8426715768807633, 0.9613526408127948],
            [0.796216445031535, 0.9612478683177613],
            [0.7532784830946583, 0.9609991026057727],
            [0.6637973871927214, 0.9610270151333781],
            [0.6247319889660998, 0.960794516605539],
            [0.6245989535015457, 1.0416200722893312],
            [0.6244433036418029, 1.0784299813209048],
            [0.6246879745131143, 1.1928585812416919],
            [0.6245830104186828, 1.3113939468161748]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.56419712740886, "lat": 39.82648608503186 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20013"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00484976"
      },
      "bbox": [
        0.6244433036418029, 0.960794516605539, 0.9673707681670205,
        1.312497279126912
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.231638685498368, 0.5296457960542386],
            [-3.1621461951131793, 0.5261790944024106],
            [-3.047543580209789, 0.5201101010676038],
            [-2.9482562014617657, 0.515634764847774],
            [-2.9303561803891385, 0.514559164110075],
            [-2.905585782014929, 0.5136089339208489],
            [-2.81772918398423, 0.509314970643997],
            [-2.7346546801871905, 0.5048585654605677],
            [-2.722169059606712, 0.5044214037402802],
            [-2.72895957820861, 0.3730289738559244],
            [-2.7366030374950934, 0.24117195702864624],
            [-2.7378809873336083, 0.21218271905061858],
            [-2.7458668364697627, 0.0659994724505865],
            [-2.817933399708942, 0.07001940922694036],
            [-2.9002874899942124, 0.07469643396539122],
            [-2.9732378501118606, 0.07869254289652576],
            [-2.973708323111059, 0.07890664067643932],
            [-3.016811953116007, 0.08091930665146503],
            [-3.100607127367193, 0.08517246017529773],
            [-3.158174214988562, 0.08790062634163219],
            [-3.205785817471637, 0.09025330644790905],
            [-3.253323221144003, 0.09232989167627062],
            [-3.2590685948823412, 0.09278903637796779],
            [-3.2582158153906096, 0.11107374433677658],
            [-3.253874984252695, 0.18141450432332468],
            [-3.2507975612143274, 0.23755075412740723],
            [-3.2505003300612456, 0.23999945319697596],
            [-3.2423642030122495, 0.3554342831390609],
            [-3.235908371766911, 0.4631648125525648],
            [-3.231638685498368, 0.5296457960542386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.48296467027473,
          "lat": 38.91609139558973
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20063"],
        "coty_name": ["Gove"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gove County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00485000"
      },
      "bbox": [
        -3.2590685948823412, 0.0659994724505865, -2.722169059606712,
        0.5296457960542386
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.05627288906302525, -0.6199684413608026],
            [0.09898195012798294, -0.6201334801991064],
            [0.1846273961797759, -0.6211216228372395],
            [0.18559773944436853, -0.5334331797618892],
            [0.276631759029083, -0.5335497295756121],
            [0.38292775249671673, -0.5347054931045048],
            [0.4114883840508193, -0.5347382411850613],
            [0.49576707232485123, -0.5356868298009353],
            [0.49600865202567845, -0.5505132381983524],
            [0.4956807141146491, -0.6677078393026068],
            [0.4961436742083008, -0.7706130126236947],
            [0.4961887198131484, -0.852300838699365],
            [0.4964890822330187, -0.8880888619947237],
            [0.4939280280781712, -0.8880424897699146],
            [0.4943806242509131, -0.9765729405214661],
            [0.4945331583140693, -0.9912757245978532],
            [0.4943360352602002, -1.1083756167743792],
            [0.46051713961609675, -1.1079436469979147],
            [0.4360455412215012, -1.1078971800952444],
            [0.3659580779153569, -1.106606480613271],
            [0.2878203038202967, -1.1057361683561908],
            [0.2652123563951096, -1.1057965290192555],
            [0.16932547021086083, -1.1045002913956032],
            [0.1509174597456388, -1.104669679184943],
            [0.07674044816779302, -1.103844084577276],
            [0.05163494915502262, -1.1039579490853084],
            [0.05172817674800684, -1.0892217229333816],
            [0.051419627893715264, -1.0599350646995],
            [0.05166635150431094, -1.054736685140062],
            [0.051573431560297665, -1.0232214520803795],
            [0.05198217746227237, -1.0047193760019653],
            [0.05171423229482631, -0.9967908862360216],
            [0.05235778010480394, -0.9720641733257489],
            [0.05214993028402429, -0.9653253429214173],
            [0.05220885906639943, -0.9098252832989793],
            [0.05319165340564491, -0.8250299059038659],
            [0.05478847473294672, -0.7517058277982628],
            [0.05524205771079962, -0.7178359408925199],
            [0.05627288906302525, -0.6199684413608026]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.23261100099293, "lat": 37.87781434908176 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20073"],
        "coty_name": ["Greenwood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greenwood County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00485003"
      },
      "bbox": [
        0.051419627893715264, -1.1083756167743792, 0.4964890822330187,
        -0.5334331797618892
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.43628333459181773, 0.8729156331545943],
            [0.5365648073342866, 0.872822826159432],
            [0.6248072273473296, 0.8729306656747821],
            [0.624668033404416, 0.8874832790543792],
            [0.6247319889660998, 0.960794516605539],
            [0.6637973871927214, 0.9610270151333781],
            [0.7532784830946583, 0.9609991026057727],
            [0.796216445031535, 0.9612478683177613],
            [0.7964756633310867, 0.873428746093972],
            [0.7918674438714425, 0.8734198819018911],
            [0.7921598756872156, 0.8494621872706097],
            [0.7925351262253081, 0.7252290945036511],
            [0.7780378935857709, 0.7252013473344323],
            [0.7786581136748052, 0.6593163912230242],
            [0.778895985204913, 0.5786297488074802],
            [0.7787876463588971, 0.5202759347360133],
            [0.7513347582667256, 0.5205784550116043],
            [0.6788810132566357, 0.520294441411829],
            [0.5794881846894177, 0.5201164468862465],
            [0.536464357987821, 0.5201507103470046],
            [0.4364406956964809, 0.5200438502563958],
            [0.43681892705243597, 0.5633923237027144],
            [0.43721013467411746, 0.6813615453122153],
            [0.43677552010198856, 0.7255811357101848],
            [0.4364101018700595, 0.8424608781028724],
            [0.4361026295632407, 0.8576379717961603],
            [0.43628333459181773, 0.8729156331545943]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.7936748809154, "lat": 39.41681679772895 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20085"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00485007"
      },
      "bbox": [
        0.4361026295632407, 0.5200438502563958, 0.7964756633310867,
        0.9612478683177613
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.991023101696342, 0.12467582790522026],
            [9.056934102173408, 0.17227591509661358],
            [9.069963266621228, 0.15384027635687877],
            [9.074878141297601, 0.15291675896154713],
            [9.078012770448067, 0.15634443475188894],
            [9.086651614375896, 0.15737846652754317],
            [9.09506297246048, 0.15822609332935522],
            [9.103218892766495, 0.15724080868959436],
            [9.110288189160837, 0.1596636148813633],
            [9.116224770079157, 0.15686125454258537],
            [9.120555668890251, 0.1530186027453051],
            [9.125002260097876, 0.15462777973850494],
            [9.135133538775131, 0.1555276236904254],
            [9.139573231574069, 0.15353219532578888],
            [9.14823573539071, 0.1462624059408161],
            [9.183341888729348, 0.16142447942670857],
            [9.187335058870087, 0.16488328124174143],
            [9.193586904073332, 0.12860822866911786],
            [9.196044233098092, 0.11027460020379222],
            [9.212497042423575, 0.021325067210332786],
            [9.217992683186624, 0.008885547267388095],
            [9.158193748027847, -0.03050147775916629],
            [9.116453433205988, -0.05810629280580864],
            [9.11632221045147, -0.06498100282016955],
            [9.118246186268976, -0.07550407768924991],
            [9.119928150302405, -0.07806466155822236],
            [9.119258663691806, -0.08263361886913578],
            [9.113461955759057, -0.0830116224109567],
            [9.114481265517297, -0.08754249437813781],
            [9.109768712609608, -0.09216069968342915],
            [9.108296357371948, -0.09893871315403964],
            [9.104172326059114, -0.10466264353906371],
            [9.09297390380132, -0.10710569127410406],
            [9.088806288657285, -0.10986074291856732],
            [9.08425599683205, -0.10850193600898136],
            [9.079345955774857, -0.10494719491517951],
            [9.048058378678451, -0.09823472369057101],
            [9.039681016531468, -0.08957496944987502],
            [9.019800181772933, -0.08483195032042759],
            [9.007571637714035, -0.08280118193503219],
            [8.994960338686065, -0.08482944602037139],
            [8.995025644720386, -0.08001846954640976],
            [8.99795479816578, -0.07681890480285561],
            [8.996382519432984, -0.07198649230683683],
            [9.006653702452555, -0.05133892270371632],
            [9.001778398142779, -0.04973590097659408],
            [9.006329903531348, -0.0444655999410006],
            [9.003840116362142, -0.041588177006599884],
            [9.00207410970646, -0.036499864129910284],
            [9.001186740041724, 0.014605808615865787],
            [8.99714141095062, 0.06377367153966078],
            [9.022819786754448, 0.12500993812204783],
            [8.991023101696342, 0.12467582790522026]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.87698751210758, "lat": 38.23924611449285 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21073"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00516883"
      },
      "bbox": [
        8.991023101696342, -0.10986074291856732, 9.217992683186624,
        0.17227591509661358
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.921519228633302, 0.5501723387478487],
            [8.930487225804765, 0.5562236432150409],
            [8.938057115501094, 0.5649126933238466],
            [8.943763554369077, 0.5694612738724327],
            [8.952791814869824, 0.5715764208756388],
            [8.96656066229378, 0.5717510725292215],
            [8.97784329666045, 0.5703356690316533],
            [8.98115737916435, 0.5706598221320128],
            [8.989089985631717, 0.5737138167750704],
            [8.993769254669186, 0.5772702876005463],
            [9.001924529931205, 0.5818919654392938],
            [9.010273954399448, 0.5888999628221178],
            [9.017127304358599, 0.5934522198183625],
            [9.022095374364245, 0.5951253417735888],
            [9.03007864775977, 0.5937526757139592],
            [9.041923322634462, 0.5937055340924517],
            [9.04911869935531, 0.5928205846984093],
            [9.061192404477497, 0.5896935215742731],
            [9.068248559806719, 0.5888640846741777],
            [9.074001595146587, 0.5893809354084143],
            [9.079003502916493, 0.5913720965828803],
            [9.080663299423241, 0.5963275006106877],
            [9.080318768939389, 0.5999438066866455],
            [9.075104327565365, 0.6120907876251389],
            [9.065409348800202, 0.6244812997213725],
            [9.062471202626943, 0.6310181665433379],
            [9.061797193169758, 0.6362526431349624],
            [9.065835720661534, 0.6454362164152119],
            [9.070080258529467, 0.6502321455073733],
            [9.079878413921046, 0.6588157367726992],
            [9.085554156987891, 0.6660693464185605],
            [9.090046712256868, 0.664591907280202],
            [9.09383916822434, 0.6660916458003285],
            [9.097711844475945, 0.669709754213052],
            [9.098243468784732, 0.6627860158586737],
            [9.099791663387752, 0.6576380335601147],
            [9.10368616401664, 0.6563106771901656],
            [9.108775884350019, 0.6604225534712955],
            [9.113412540609058, 0.6591980745666862],
            [9.115407222837955, 0.6541134884924769],
            [9.118517846975061, 0.6525239198186524],
            [9.12296233782042, 0.6435152341086497],
            [9.19833301470326, 0.5982625775325858],
            [9.107266473192201, 0.5751163024471408],
            [9.10873433133545, 0.5297917410252022],
            [9.10667046341148, 0.5329918897448672],
            [9.102212852281852, 0.5332557898000463],
            [9.099622654985769, 0.5248791378290169],
            [9.092391820124433, 0.5195893808563692],
            [9.088772172659825, 0.5188033967603222],
            [9.08695807132881, 0.513934349019786],
            [9.09187780422064, 0.5118959668072705],
            [9.090892666048253, 0.5092233915164345],
            [9.084443574699364, 0.5095102794198101],
            [9.081234810274498, 0.511072081361778],
            [9.075478863960896, 0.5167294958770088],
            [9.067582760672027, 0.5074100057084665],
            [9.066297814973117, 0.5007384267578061],
            [9.059169903637741, 0.5006425566977413],
            [9.055261516530758, 0.5032586753099003],
            [9.050022545882783, 0.5026958069512905],
            [9.046301577828805, 0.49998575607573253],
            [9.046154725529847, 0.49123027969268473],
            [9.039004679482145, 0.4854904330225319],
            [9.034122367268818, 0.48732226026630726],
            [9.035178801416048, 0.4780759189612947],
            [9.03225189517601, 0.47621234879844715],
            [9.029859287973887, 0.47803288279108075],
            [9.022854249757323, 0.47700363711297894],
            [9.022818712137017, 0.46771461276076975],
            [9.017084301823406, 0.46643754145720073],
            [9.010629037693185, 0.46737304936461627],
            [9.007097028022537, 0.46999310882402096],
            [9.002576220576966, 0.46248924213288395],
            [9.001428751405616, 0.4578555805544332],
            [8.977776355450677, 0.4728382958562364],
            [8.951651975394993, 0.5089819971119688],
            [8.921845273569007, 0.5494217233013438],
            [8.921519228633302, 0.5501723387478487]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.85932983396896,
          "lat": 38.756825373951344
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21077"],
        "coty_name": ["Gallatin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gallatin County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00516885"
      },
      "bbox": [
        8.921519228633302, 0.4578555805544332, 9.19833301470326,
        0.669709754213052
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.558524582696586, -0.010925974177353217],
            [10.563349482711452, -0.007826678861411472],
            [10.563459820355051, -0.0003918408360088229],
            [10.566492688257995, -0.000009449578449753416],
            [10.571362217401443, 0.00797726223621458],
            [10.572361054673161, 0.013226738662127995],
            [10.570096030274508, 0.018751781557940026],
            [10.5731299912657, 0.023004155264686636],
            [10.578208078493477, 0.02428443922379206],
            [10.583308359652099, 0.029430542836090277],
            [10.582104059903372, 0.03124011811229292],
            [10.58420681336676, 0.03639130116896374],
            [10.58885671274799, 0.03531269579995814],
            [10.592520843420402, 0.039098472217722835],
            [10.595752719469171, 0.04004187415242122],
            [10.599326931292216, 0.03774103659748141],
            [10.603744068100005, 0.03868124014017163],
            [10.608106788379947, 0.04587139996634727],
            [10.605980207193438, 0.04926480368772159],
            [10.60955146778411, 0.05096122081358917],
            [10.612557735446094, 0.05474498556615277],
            [10.610909674965255, 0.05921364732773629],
            [10.612399387867097, 0.0625329548259324],
            [10.61069075423926, 0.06816862950803201],
            [10.618509698233908, 0.07511905237744597],
            [10.620445066117556, 0.07865219323012981],
            [10.618535004102563, 0.08079271606780064],
            [10.62176667626119, 0.08544628943662337],
            [10.624277154247089, 0.08511799248634996],
            [10.626968751804448, 0.09234870703031238],
            [10.634796046247482, 0.09000491982532965],
            [10.634095848969597, 0.0943293339376569],
            [10.635599718443522, 0.09852502469433656],
            [10.640824352251606, 0.09851255393395326],
            [10.641685929980795, 0.10271312146615551],
            [10.64691995196798, 0.10811701323719168],
            [10.644187321438562, 0.11101233221800726],
            [10.643465772028518, 0.11642054656132216],
            [10.64020488812994, 0.11566624540879304],
            [10.634536642317586, 0.1267794103258822],
            [10.630224907010861, 0.1273916389134057],
            [10.629339240537567, 0.13295753421063825],
            [10.630028964912386, 0.1375388632533803],
            [10.626776841366034, 0.1398426294127544],
            [10.626104267080423, 0.1509727755604398],
            [10.618939549306775, 0.15575107479263448],
            [10.616616801492832, 0.1628214021446009],
            [10.618454064709702, 0.16573977287313207],
            [10.6111395762926, 0.1660275366274272],
            [10.610465757004839, 0.16756230387525073],
            [10.614573581279027, 0.1720855887573265],
            [10.619906988150346, 0.17292747733193262],
            [10.628016935319994, 0.17790547422986305],
            [10.630438727214653, 0.17816190596322257],
            [10.632564078828592, 0.18392942293375286],
            [10.63740912172797, 0.18784193555495698],
            [10.639207490265514, 0.1928680362563951],
            [10.648299635189202, 0.19036729602752062],
            [10.651797825452539, 0.19256644924511201],
            [10.662981400380357, 0.1901880181968757],
            [10.665516701123535, 0.19229156040769313],
            [10.67101084335418, 0.20027428884201207],
            [10.671956697337603, 0.20314566111312998],
            [10.675978884766591, 0.2071636497633432],
            [10.683878783391735, 0.2112936213207824],
            [10.690966030607036, 0.22453443151038363],
            [10.68855120911532, 0.22720710534632993],
            [10.680981815105204, 0.23146473459558914],
            [10.682379559595113, 0.23630197037857198],
            [10.687607577248556, 0.2382461069661084],
            [10.689599047197829, 0.24305635252462285],
            [10.701672928597253, 0.24703072313517072],
            [10.70156220518726, 0.2502372684705244],
            [10.707298874490089, 0.2520512222371773],
            [10.708630875081298, 0.24690998141498113],
            [10.711722089159606, 0.24584985011763258],
            [10.714430056666375, 0.24924406549614245],
            [10.719650305781235, 0.245982180836365],
            [10.7271879866896, 0.24455964196512556],
            [10.738906390071305, 0.25048097331212177],
            [10.746209938066153, 0.2498228835328427],
            [10.747108070049649, 0.2552495267328203],
            [10.755791710179741, 0.25784653774025107],
            [10.756937390703381, 0.2642484218612158],
            [10.761544063394522, 0.26547765041953875],
            [10.764681348878591, 0.2696860800510766],
            [10.768259694538239, 0.26881822179478887],
            [10.771972173756708, 0.2786178275581253],
            [10.821088858679673, 0.2906882523963951],
            [10.826486693754617, 0.2934831165517454],
            [10.832876417485162, 0.29105541026925785],
            [10.836952682498158, 0.2920482981367367],
            [10.843603012403603, 0.28744519022128495],
            [10.84616982432229, 0.2821406783795377],
            [10.84706694813617, 0.2743340571206841],
            [10.84532565980946, 0.27273258629706054],
            [10.842795284710949, 0.26072434245796533],
            [10.847094018276925, 0.25022410401292144],
            [10.85607643990247, 0.2451067704400952],
            [10.858252778054958, 0.22485186700590626],
            [10.855819388090573, 0.21472340481565472],
            [10.852634685498591, 0.19786013929675497],
            [10.846759111503887, 0.19445600407006644],
            [10.841905092613487, 0.19526138046034486],
            [10.831335789191943, 0.1944003386330535],
            [10.828516152043159, 0.19241651300411902],
            [10.827749349360607, 0.18815412440221008],
            [10.833451785007103, 0.18004213311136813],
            [10.835834867967607, 0.1668649821600503],
            [10.837220562423495, 0.1625318058164138],
            [10.839902723813427, 0.16048311123435732],
            [10.846396048617514, 0.1595321154448193],
            [10.850665885041364, 0.15724154355962874],
            [10.851908880728232, 0.14848636048060362],
            [10.856204820095034, 0.14601712924653867],
            [10.863490687456355, 0.14768470856088636],
            [10.870805139995092, 0.14370661830911885],
            [10.874921614305109, 0.13913420402913723],
            [10.88157195953625, 0.13613567168625582],
            [10.883543189942097, 0.12341428559631057],
            [10.885171680959864, 0.1199809488936198],
            [10.894076991549845, 0.11251691789887557],
            [10.900720479634645, 0.1119687069674239],
            [10.906567801320822, 0.10484189870169185],
            [10.913293931779153, 0.10372096956239678],
            [10.915825171197762, 0.09619070696480662],
            [10.91998975990032, 0.09215119634235884],
            [10.920651400822, 0.08790119336723136],
            [10.924208699664439, 0.08247371147570874],
            [10.927721621730157, 0.07966966717309507],
            [10.927797588639843, 0.07170072788934036],
            [10.931357522243514, 0.06697456697384763],
            [10.939263753832668, 0.06214141772934616],
            [10.940229175083266, 0.05529996206404815],
            [10.946518885191253, 0.04478437030291887],
            [10.950259162863013, 0.04161974906643996],
            [10.947987081376505, 0.03760463411690839],
            [10.951948253437509, 0.03622917837283194],
            [10.957199401340045, 0.03930936967244892],
            [10.962520419140299, 0.037538191608237376],
            [10.971435906137001, 0.03876260695443581],
            [10.974429801671562, 0.0358502523405776],
            [10.975058732056045, 0.030641774740870844],
            [10.97763599355645, 0.024463594710330036],
            [10.985686724406065, 0.02822521161973484],
            [10.991784779592539, 0.027130377774044652],
            [10.993337914496163, 0.019333631942419927],
            [10.990487941448347, 0.015048499381038617],
            [10.980832345805892, 0.013562159284506655],
            [10.979229436372961, 0.011725947756735291],
            [10.980591107287406, 0.0037190985348670297],
            [10.989713736578347, 0.0023509947623856927],
            [10.990813367682984, 0.000809015669936872],
            [10.984964316332217, -0.01014764846759018],
            [10.980199744227306, -0.014755235023256024],
            [10.974245004730468, -0.014256690230856484],
            [10.972536947339192, -0.015643266707598084],
            [10.96696916166833, -0.013769058227754686],
            [10.941343287856323, -0.0024576773695193874],
            [10.935186947735223, -0.00920578201946586],
            [10.931004761383132, -0.007441416496162506],
            [10.926062850150291, -0.007977059638189147],
            [10.918776054618366, -0.0164083882696926],
            [10.915018048135755, -0.012883462888081005],
            [10.912827487360882, -0.016618118676225032],
            [10.907031357681692, -0.01622941899264689],
            [10.907781227816185, -0.021871426056219997],
            [10.910474670839175, -0.02485550448623558],
            [10.9073561943518, -0.027338725283772805],
            [10.907878692327694, -0.032719291901320516],
            [10.910468969468537, -0.03626886649090226],
            [10.90802037592034, -0.04163819949781012],
            [10.902989988219975, -0.03988759009857287],
            [10.901352842054118, -0.04331971301087507],
            [10.901639508989577, -0.04963334225613943],
            [10.895727115933243, -0.050775565740535766],
            [10.895214127777843, -0.0532544120141561],
            [10.898641688745123, -0.05648974729434333],
            [10.897074104190244, -0.059733316993324764],
            [10.903165478601688, -0.06310855928266167],
            [10.900304608918825, -0.0678270695636073],
            [10.900962923245727, -0.07352693577799602],
            [10.902989009937317, -0.07448366312268687],
            [10.904628532862533, -0.08122839325093408],
            [10.90065931970242, -0.08467928345986013],
            [10.898227207444767, -0.08363829957741592],
            [10.894476907791837, -0.0859358159501233],
            [10.895324461139044, -0.08853882521401041],
            [10.893261781657149, -0.09447869937721073],
            [10.84147080488869, -0.08848900768650945],
            [10.791939320088009, -0.0709884240903996],
            [10.756001777829237, -0.05270644084002805],
            [10.711248790884106, -0.02972563415180856],
            [10.676155249394094, -0.02467027149436529],
            [10.623418702916917, -0.010202990902087485],
            [10.613618036622858, -0.010196700003736318],
            [10.613521337574964, -0.013528263576096058],
            [10.603840595167746, -0.01803325336044871],
            [10.600466138220574, -0.02153155524564813],
            [10.601230950397417, -0.0241172376949304],
            [10.596901804441659, -0.028151707627250153],
            [10.597045785413961, -0.03877929083764658],
            [10.595104405401925, -0.04387469258272565],
            [10.589806629018886, -0.048063434759774114],
            [10.590047870366442, -0.0505011398383213],
            [10.58755742921637, -0.053539355401943996],
            [10.582744530582348, -0.05153641396161042],
            [10.58188104927934, -0.047719566627366136],
            [10.577995659233016, -0.049532542652376395],
            [10.572366000243118, -0.04685751617377043],
            [10.567721022033883, -0.04312224121619451],
            [10.56872190486161, -0.03789107264524722],
            [10.561971817864947, -0.035785346452424725],
            [10.561057979716043, -0.030097756991224744],
            [10.558271671428125, -0.026898688442851332],
            [10.561832069885124, -0.018367095752002884],
            [10.5574032763165, -0.014292906294843949],
            [10.558524582696586, -0.010925974177353217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.73485267456279,
          "lat": 38.067873874104926
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21127"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00516910"
      },
      "bbox": [
        10.5574032763165, -0.09447869937721073, 10.993337914496163,
        0.2934831165517454
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.123246567352072, -0.7660612655342309],
            [7.124052456470172, -0.7645585155881026],
            [7.136438122252949, -0.7509115268851094],
            [7.139266120115493, -0.7470612328015257],
            [7.145199913308081, -0.7436966584757454],
            [7.165553290335227, -0.7385460263201394],
            [7.179600161357882, -0.7380647934907574],
            [7.1850591746606245, -0.7329827539295238],
            [7.187734616025756, -0.7237320645736487],
            [7.308118395788056, -0.7751393979844792],
            [7.393757956233244, -0.8039220993133165],
            [7.400009239288468, -0.8090398212656976],
            [7.408376808682263, -0.8128640215114037],
            [7.432275679664989, -0.8151579248037757],
            [7.434900862571166, -0.8168962780248324],
            [7.443025648139403, -0.8184375016907367],
            [7.45763078676836, -0.8160821276424696],
            [7.464432999728748, -0.814432252294542],
            [7.4664263329599265, -0.8104969491284846],
            [7.472452583755042, -0.8118078518449026],
            [7.4799167004518665, -0.8158841124858855],
            [7.484339356887767, -0.8172127041755125],
            [7.488365042955003, -0.820377794690863],
            [7.480526798563146, -0.8301885248195924],
            [7.445222834208758, -0.9054768659271629],
            [7.442097250324154, -0.9071514137452559],
            [7.438101883614704, -0.9156703982898422],
            [7.434949264885564, -0.9150836679231791],
            [7.433908807481058, -0.9092304797908496],
            [7.430954675829144, -0.9034217010664737],
            [7.428096616892191, -0.9009513506584202],
            [7.424778380845708, -0.9029879926043994],
            [7.423735512476897, -0.9065263823096171],
            [7.429706430602879, -0.9127019381654411],
            [7.432138899432235, -0.9180728711595924],
            [7.437641314891719, -0.921652111814091],
            [7.443801808697923, -0.9231603199790246],
            [7.445694039609495, -0.9250505001139551],
            [7.4488493811803504, -0.9410052440038444],
            [7.448413337217987, -0.9508453458083519],
            [7.452322421691466, -0.9584257916848399],
            [7.45235292414244, -0.9656219364245744],
            [7.453935095707185, -0.9704312382614224],
            [7.448993972521182, -0.9716637380612135],
            [7.444575749140369, -0.9758779213541332],
            [7.398355231089424, -0.9781168767860875],
            [7.371437823823047, -1.0124081512224297],
            [7.364760703379285, -1.0146585474191938],
            [7.35606756601078, -1.012438881264895],
            [7.355358975583361, -1.0137566608946251],
            [7.347770041724299, -1.0116275516658193],
            [7.337673953700951, -1.011299704979713],
            [7.302542619984008, -1.0090516379958363],
            [7.299122619796325, -1.0110526698581992],
            [7.295029963427878, -1.0066112786886714],
            [7.292215090725748, -1.0013326999724679],
            [7.289460401212411, -1.000058356043328],
            [7.283530659713637, -1.0016874645866174],
            [7.282849221622207, -1.0045633102105826],
            [7.276405958143967, -1.0047119728143943],
            [7.274594902230087, -0.9949855246091046],
            [7.269818860549898, -0.9916912629974167],
            [7.2563131486032, -0.9797142854674835],
            [7.254875246388998, -0.9772236876417633],
            [7.25496138276375, -0.9670916444065119],
            [7.251176377784592, -0.9585079997529294],
            [7.24930679956921, -0.9444248614142974],
            [7.24693029025109, -0.9392417947640329],
            [7.247183088816672, -0.933610140195497],
            [7.248967768279009, -0.927911763644706],
            [7.2488337835738, -0.923899989484585],
            [7.242250917667997, -0.9169996358422023],
            [7.245314198237974, -0.90928478470509],
            [7.2425339830030335, -0.902544630713322],
            [7.243416869947559, -0.8976148442814212],
            [7.248965968348473, -0.8899355854492986],
            [7.249029025062331, -0.88533798610283],
            [7.245366876921366, -0.8802448289758986],
            [7.244109057214, -0.8759491946781601],
            [7.239403250673758, -0.8718817137484841],
            [7.234075449507224, -0.8703028963637238],
            [7.237123487555269, -0.8650897019557644],
            [7.238527217986725, -0.8584587721272624],
            [7.237145029585282, -0.8544187248262236],
            [7.230057221375766, -0.8465285635459548],
            [7.2241979949082795, -0.8355716469664796],
            [7.219633259002812, -0.8274287757861729],
            [7.209663872171789, -0.819631700760523],
            [7.205379111198408, -0.8177496399166022],
            [7.195053885575446, -0.8181810926455969],
            [7.185590267693162, -0.8163523955691888],
            [7.167977954788085, -0.8186780422758199],
            [7.15222454767512, -0.8179843598830627],
            [7.137323491425825, -0.8120730020530648],
            [7.135364419893649, -0.8072774342619028],
            [7.121689054734345, -0.7865798712332237],
            [7.120406255576188, -0.7747080574538636],
            [7.123246567352072, -0.7660612655342309]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.26356718686874, "lat": 37.52910342838509 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21149"],
        "coty_name": ["McLean"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McLean County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00516927"
      },
      "bbox": [
        7.120406255576188, -1.0146585474191938, 7.488365042955003,
        -0.7237320645736487
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.217992683186624, 0.008885547267388095],
            [9.21930854506938, 0.004783339380572456],
            [9.214384986184076, 0.002918307979647756],
            [9.21743766989581, -0.0013807377079656754],
            [9.222044801685321, -0.0006200597723128893],
            [9.224818120619288, -0.0060291524979507825],
            [9.228899296485258, -0.010201117349267439],
            [9.234252396504932, -0.011586074448564913],
            [9.236956930538923, -0.0056676711974323266],
            [9.242811537454312, -0.005587619584486802],
            [9.244830059526974, -0.0025160442721629413],
            [9.248137428568008, -0.002435897919093676],
            [9.248938009597127, -0.006252610956502975],
            [9.246553441883334, -0.008321562642452922],
            [9.251697090166443, -0.012284059227129102],
            [9.254932278747038, -0.013333054801985513],
            [9.259045650917615, -0.009867978789172501],
            [9.252426243886035, -0.007839932950658489],
            [9.256139115690411, -0.0029502529175281945],
            [9.265684415441125, -0.005253920693491357],
            [9.270182748210154, -0.0015019620178517976],
            [9.273587759854232, -0.0006980507301771199],
            [9.280027827926618, -0.002835236588385638],
            [9.279724658484632, -0.010638935984295913],
            [9.274938771932504, -0.009132170795763252],
            [9.273706659581052, -0.012961664783181486],
            [9.274845829559215, -0.01900874890982451],
            [9.27821453405214, -0.019555659263995266],
            [9.28316503660252, -0.016031449362459038],
            [9.2865775798154, -0.0215085683027901],
            [9.278914060693724, -0.021490605230828946],
            [9.279685575431266, -0.028117768556174805],
            [9.281952979457232, -0.034928553673203806],
            [9.285335517350934, -0.03388491212989081],
            [9.286041093240595, -0.04476931212456044],
            [9.289124656554382, -0.04328340716096122],
            [9.29174013512897, -0.04745056404430278],
            [9.296773967040819, -0.05230961339946528],
            [9.297214793737938, -0.056520266113564255],
            [9.287932256920364, -0.060250957425116866],
            [9.282508453289044, -0.059078166438784656],
            [9.283216414720389, -0.0636259556811034],
            [9.286109262226146, -0.06746207193700794],
            [9.2894174187962, -0.06270689918743441],
            [9.299111502257695, -0.06739384743799932],
            [9.304864601880638, -0.0610889273432837],
            [9.296898254319617, -0.12166867552366789],
            [9.291636714625492, -0.1629225405930952],
            [9.291287685269936, -0.17729468386102493],
            [9.272782830425124, -0.3041834285092443],
            [9.269685764492015, -0.3240843313637196],
            [9.26128605413515, -0.32484125088772553],
            [9.25046436660996, -0.33166598276350767],
            [9.244055178452813, -0.33837691569633105],
            [9.232013473725175, -0.34375524679679914],
            [9.228446973406829, -0.343350103885408],
            [9.223714096626006, -0.3392810671794454],
            [9.220451692063492, -0.3346610595060535],
            [9.22144563289157, -0.32618624439832555],
            [9.228731484827033, -0.3225520633209327],
            [9.230756477219877, -0.3201688337552688],
            [9.230073764607683, -0.3162717833727233],
            [9.2239235819689, -0.309397885588354],
            [9.222986676594898, -0.30213147507081234],
            [9.219062023579593, -0.3002565166804986],
            [9.211330890144778, -0.3017503754881616],
            [9.209346947547536, -0.29792113316661073],
            [9.210394164487608, -0.2939714131342923],
            [9.213760628667089, -0.2902051488266939],
            [9.214663045609909, -0.2862653821965918],
            [9.208997855629704, -0.2842345195420238],
            [9.204971871229374, -0.2899630399778941],
            [9.20188544307465, -0.29981524102188717],
            [9.202400345781847, -0.30465964632470915],
            [9.200686862079154, -0.30697669503709374],
            [9.196415409014117, -0.3050389591360506],
            [9.194397675972352, -0.2994216917408552],
            [9.19424067057855, -0.2937346523229371],
            [9.19751267147035, -0.28593019679009907],
            [9.197391275993985, -0.27917931719935785],
            [9.193075242390938, -0.27543682851466267],
            [9.18936627558276, -0.2764615463684019],
            [9.182652865862815, -0.28288089448086234],
            [9.178146524653965, -0.28373895326024384],
            [9.172756375121073, -0.2801650153262649],
            [9.172625060112434, -0.27533022311268224],
            [9.175734069355695, -0.26922186130861653],
            [9.184033957396666, -0.26315127723329107],
            [9.192462980650578, -0.26113078125696043],
            [9.193613872161233, -0.2580709914750474],
            [9.18434092568991, -0.2507418242319556],
            [9.177734039055878, -0.25153538795450375],
            [9.174363861746023, -0.2484164630799003],
            [9.17381927367909, -0.24497270461460213],
            [9.176609123247493, -0.24118871493003088],
            [9.182727355368261, -0.2378213166697336],
            [9.191500622321858, -0.22761364822472774],
            [9.189760373889088, -0.22362005265016435],
            [9.181533331333787, -0.22291200310793574],
            [9.177351449954246, -0.2239628908303435],
            [9.17252028279152, -0.22230105699180036],
            [9.167195258277095, -0.2136820833893897],
            [9.16796325060476, -0.20659240883652372],
            [9.170957493822295, -0.19939920863058647],
            [9.17007787840748, -0.19553441415624603],
            [9.1640304019761, -0.1925660063524655],
            [9.153607209804566, -0.18951061146228357],
            [9.15276156266721, -0.18310270136623938],
            [9.156750769962663, -0.1766468204501188],
            [9.157507873695973, -0.17299952773808044],
            [9.155598578450476, -0.1662484380513724],
            [9.152389828617455, -0.1625659615532097],
            [9.142305976837477, -0.15721315842718214],
            [9.139296455362272, -0.15253365911969874],
            [9.139337598316516, -0.14943160196117342],
            [9.143246978388696, -0.14510783381642317],
            [9.154332649619308, -0.14430510651688172],
            [9.156709255769167, -0.14119864959079684],
            [9.155332050037835, -0.13580020335619303],
            [9.147807842045394, -0.13328104210607955],
            [9.141767667544947, -0.12769028795124363],
            [9.142695066825823, -0.12495751328591709],
            [9.151506882580485, -0.11536096307595645],
            [9.152290840479187, -0.11329266801010082],
            [9.149072702055927, -0.10390492775010214],
            [9.143565051284655, -0.09841030550121256],
            [9.138850677801145, -0.09753273976328555],
            [9.129564323426404, -0.1085920557949678],
            [9.124611707495346, -0.10807917473974321],
            [9.121498778546487, -0.10319996227974174],
            [9.120692586689502, -0.09196371824121222],
            [9.119258663691806, -0.08263361886913578],
            [9.119928150302405, -0.07806466155822236],
            [9.118246186268976, -0.07550407768924991],
            [9.11632221045147, -0.06498100282016955],
            [9.116453433205988, -0.05810629280580864],
            [9.158193748027847, -0.03050147775916629],
            [9.217992683186624, 0.008885547267388095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.74360111967269,
          "lat": 38.042230817442416
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21239"],
        "coty_name": ["Woodford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woodford County"],
        "coty_fp_code": "239",
        "coty_gnis_code": "00516966"
      },
      "bbox": [
        9.11632221045147, -0.34375524679679914, 9.304864601880638,
        0.008885547267388095
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6694464146709644, -6.301650945842371],
            [2.7429316151193945, -6.299471715254228],
            [2.7505626596752455, -6.2995495763661635],
            [2.7834255344952985, -6.298466458804191],
            [2.781865613703135, -6.254328407143015],
            [2.857006935369355, -6.251799328133928],
            [2.8536077584255573, -6.246738660356427],
            [2.8549318638747736, -6.242378089849125],
            [2.8529446310519657, -6.240560262255061],
            [2.8575552836193543, -6.23649157622146],
            [2.854326137383046, -6.2295644810689215],
            [2.8483974929505314, -6.220456228610985],
            [2.8468887175922886, -6.2131522509322945],
            [2.841717630590721, -6.2036944678242865],
            [2.8405595125499747, -6.1922237837026],
            [2.8387768339131982, -6.190993387405903],
            [2.836502410091162, -6.1816647465209655],
            [2.8378784872638176, -6.178434224070066],
            [2.835092266283569, -6.171690016485897],
            [2.833943284664466, -6.164631062798502],
            [2.8369573776753687, -6.157332641046733],
            [2.8353344553232365, -6.150799581909695],
            [2.831940928042373, -6.145859282596837],
            [2.831398204953552, -6.139824148527747],
            [2.8270352023512766, -6.122524101193311],
            [2.9631174400480327, -6.11825467196162],
            [3.0749740923875613, -6.1145416197068245],
            [3.0764159570049214, -6.114315470054294],
            [3.0789214960553104, -6.157202860981779],
            [3.0797750558733306, -6.189899210760313],
            [3.081975361113968, -6.245424118222658],
            [3.1679400313778134, -6.2429773277486],
            [3.172810923588874, -6.344457443024731],
            [3.1732232132348446, -6.360863609130407],
            [3.1747465654144507, -6.374168332742738],
            [3.1756613524594197, -6.413849246792149],
            [3.1779978808463643, -6.461835583544532],
            [3.170848356200841, -6.471292577326117],
            [3.170248047735877, -6.475423035896959],
            [3.167227884515897, -6.481576420523528],
            [3.1626726823958666, -6.481359590920085],
            [3.16130707299933, -6.483926611307654],
            [3.1560442642149265, -6.486193369331583],
            [3.15783393577806, -6.4930714194234955],
            [3.156283923119577, -6.504650502652704],
            [3.156736109227209, -6.513818036765924],
            [3.1588456106308436, -6.51547702986577],
            [3.1528089388253235, -6.522105520543133],
            [3.1509798946194914, -6.527745800625741],
            [3.1472597458711946, -6.528751098166725],
            [3.1421909382793825, -6.539176694922063],
            [3.1421327608953606, -6.545604693639279],
            [3.146077617520549, -6.549785355707754],
            [3.0418688511267375, -6.552681632606426],
            [2.9345314990913236, -6.5558107190352315],
            [2.891292747296026, -6.556823644649206],
            [2.8329918789029973, -6.5585074706233675],
            [2.8308022520703022, -6.548626493499749],
            [2.8266516739016523, -6.542348041297642],
            [2.829513789108538, -6.538659712340172],
            [2.8274696495170746, -6.5349175823119845],
            [2.8280948423925807, -6.528829262879551],
            [2.8203766315859298, -6.5217416357618925],
            [2.811488366994721, -6.515459529040894],
            [2.808682200584444, -6.500204334993571],
            [2.8119307785446903, -6.485373288107368],
            [2.8097690180066364, -6.478433091217688],
            [2.8107164778114475, -6.4767048310651845],
            [2.8078219258692028, -6.4717092455562195],
            [2.6887266042613764, -6.475297662917473],
            [2.688251080830166, -6.475120969813164],
            [2.6327769397807246, -6.47658358268154],
            [2.627266124684433, -6.47761918647735],
            [2.6291853141556905, -6.474279373506839],
            [2.634045935841025, -6.4743492398366085],
            [2.637377801189779, -6.468478136778881],
            [2.6427823242090205, -6.46463795994749],
            [2.6441077840269087, -6.461933199127686],
            [2.642337009901478, -6.457118034008281],
            [2.64494890642272, -6.455202691743051],
            [2.6440088002140065, -6.447537056567322],
            [2.6416619886781385, -6.441712004304519],
            [2.645650069538114, -6.4341982048888555],
            [2.6437389635987647, -6.42771855868568],
            [2.6399890545904565, -6.425835488317356],
            [2.6345237334695444, -6.428587455924466],
            [2.634288622900421, -6.417742045224076],
            [2.6273411349357194, -6.409678572225038],
            [2.6287337287767083, -6.4073874686537975],
            [2.6269446831291665, -6.403495027924646],
            [2.6299508580914064, -6.401874983244895],
            [2.631618029991843, -6.3936957411623565],
            [2.634674876207756, -6.3900102301508],
            [2.636654122216773, -6.37842584416298],
            [2.6392657426838344, -6.368712912724255],
            [2.6418502697967825, -6.3625087210951845],
            [2.647433428704761, -6.35542017758905],
            [2.6480227327166714, -6.349623555903158],
            [2.6452367896173663, -6.343762628940836],
            [2.6419959658426446, -6.342162247790793],
            [2.6329493995981794, -6.340015035147632],
            [2.626815632324778, -6.335730144357374],
            [2.623906410008185, -6.331684935140968],
            [2.6231038524822665, -6.327884837392904],
            [2.6241933381666973, -6.320965766898907],
            [2.628827485925747, -6.313361152014608],
            [2.6314055336283797, -6.311697023923567],
            [2.6363432468663213, -6.311876442557419],
            [2.6484613737802145, -6.3174048743493705],
            [2.6528620445212123, -6.317986783185105],
            [2.6564892574933476, -6.315751405266145],
            [2.661067011813376, -6.309262962787206],
            [2.6694464146709644, -6.301650945842371]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.05607888517063,
          "lat": 32.347322014163005
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22013"],
        "coty_name": ["Bienville"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Bienville Parish"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00558445"
      },
      "bbox": [
        2.6231038524822665, -6.5585074706233675, 3.1779978808463643,
        -6.114315470054294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.09341621109531, -7.638376843893672],
            [4.096976950475146, -7.638161133662367],
            [4.107534051216361, -7.642132359407097],
            [4.116096673419848, -7.647718798857354],
            [4.120270878810567, -7.649209295250099],
            [4.124787227753815, -7.648967623767528],
            [4.1287876329800985, -7.646038950838669],
            [4.1312507039449535, -7.6392269966015185],
            [4.133602161262318, -7.636761942146706],
            [4.139232378770982, -7.63513985877681],
            [4.143853613364875, -7.635617902841951],
            [4.152611198607191, -7.638881098696121],
            [4.161264569982997, -7.64350650611784],
            [4.166825521166529, -7.64895857456033],
            [4.169486981404978, -7.6551286143621295],
            [4.172883637775594, -7.659145472640983],
            [4.172930140681132, -7.661656089224015],
            [4.16922411698171, -7.669234520023762],
            [4.169059975195935, -7.674289034547192],
            [4.170409192337313, -7.683142711172942],
            [4.1715196573673206, -7.689058637076001],
            [4.175836292572891, -7.701631845673858],
            [4.180422299982004, -7.711763389417207],
            [4.187331214589352, -7.72355766180395],
            [4.181555814104853, -7.734577194003426],
            [4.177340241615208, -7.747847886796989],
            [4.175376366789024, -7.7579141265254],
            [4.176052099084184, -7.792657505403353],
            [4.176561124041637, -7.7955386123017885],
            [4.180947219672541, -7.801372948963059],
            [4.189443286873243, -7.807051237508968],
            [4.198903773500216, -7.809988554014524],
            [4.208343428590406, -7.810857144258767],
            [4.22696797339482, -7.804316330595941],
            [4.239788991480112, -7.802390575596185],
            [4.2478941971678275, -7.803041540954261],
            [4.254370032095555, -7.8068203008101],
            [4.2578202880211125, -7.812029371922823],
            [4.261190535091856, -7.812168846558108],
            [4.264859684413196, -7.808706032613352],
            [4.266717512905347, -7.7998190025059415],
            [4.263371914347455, -7.776873604927648],
            [4.258938540122588, -7.765675562976941],
            [4.254264453948109, -7.7601292297607785],
            [4.2478061039926835, -7.756172965923621],
            [4.239541262371851, -7.7541924275136465],
            [4.231948505855265, -7.754098088138345],
            [4.220858327827825, -7.752880150026029],
            [4.215121915569041, -7.7493109717045385],
            [4.213728876351283, -7.74432117185981],
            [4.21375306013356, -7.733665505318134],
            [4.223045054591593, -7.733791977096874],
            [4.253260986605964, -7.730652486458572],
            [4.260502002307584, -7.730593934837188],
            [4.2696159369992985, -7.732455465305293],
            [4.274027823301095, -7.734767511946251],
            [4.282749030881205, -7.741743480170234],
            [4.294687226918026, -7.7573024743142565],
            [4.300372516870093, -7.77185552067252],
            [4.30099116940776, -7.785556360232915],
            [4.299524479767757, -7.79556841645667],
            [4.296010127876253, -7.807232173345529],
            [4.295206804668346, -7.8134458866587435],
            [4.293289555175339, -7.817908344860287],
            [4.291067929294333, -7.828329919879966],
            [4.286455812796205, -7.845133081931966],
            [4.28390068474698, -7.856122546967359],
            [4.27789550094158, -7.8640312333685864],
            [4.269298174412679, -7.869791356230465],
            [4.252953672445915, -7.873466270040577],
            [4.246246709089302, -7.876219304809722],
            [4.239313267870659, -7.883248365527142],
            [4.236885638310373, -7.891723074903754],
            [4.238558229509604, -7.898765431186991],
            [4.253446415242122, -7.909297843613617],
            [4.2593014613001206, -7.912820116243151],
            [4.269057295885924, -7.916016275766661],
            [4.2751414804879655, -7.916606148005095],
            [4.287696911620277, -7.91379512881937],
            [4.301657812808988, -7.908195565138784],
            [4.311606080926851, -7.905481563624872],
            [4.331261541755724, -7.903506946360115],
            [4.337046077011706, -7.9039880539758425],
            [4.352627618632043, -7.908164276447016],
            [4.362785150617876, -7.907156026520208],
            [4.37140073667446, -7.903592222884999],
            [4.385760047628267, -7.896819514496318],
            [4.397739419108332, -7.888522440998653],
            [4.407420335487853, -7.8837351145467265],
            [4.4130439367964716, -7.882446770294947],
            [4.421422219287154, -7.881846648118779],
            [4.426281375172171, -7.884545586170694],
            [4.438323792774837, -7.900419997534738],
            [4.4468028754632325, -7.917440785706934],
            [4.4519754831969305, -7.9355823361813105],
            [4.453143778894589, -7.944548831147036],
            [4.455536881722748, -7.950822359131907],
            [4.459988730065324, -7.968026780001018],
            [4.4652767564817895, -7.977822310867899],
            [4.468940948428698, -7.979082168808228],
            [4.467534049261465, -7.984285120396306],
            [4.487466189343607, -7.986716698326139],
            [4.479682629150836, -8.00411752156843],
            [4.465516189673558, -8.022785627602206],
            [4.455476104468269, -8.033851867052013],
            [4.451224912959941, -8.040419175422869],
            [4.442943857201173, -8.050131837761581],
            [4.444069397195823, -8.068813603192128],
            [4.415353501386605, -8.071013851663416],
            [4.409974527159185, -8.085696432911924],
            [4.408288398582295, -8.097022227480585],
            [4.408834173214999, -8.099564899808675],
            [4.402503811768512, -8.09997995872831],
            [4.404100952340989, -8.12842451163594],
            [4.346660550429539, -8.131632513050244],
            [4.347458978922376, -8.1451115307918],
            [4.344376967537533, -8.145392681033218],
            [4.331937326999164, -8.146418073095443],
            [4.308858095794834, -8.14710416430514],
            [4.308934384037029, -8.148038074010723],
            [4.2824096014612225, -8.157037157570432],
            [4.283924441264496, -8.16253085676088],
            [4.260629013676712, -8.163880530769285],
            [4.259987783154266, -8.149644396853997],
            [4.158669549145042, -8.153460516517558],
            [4.111520128707053, -8.155176100670966],
            [4.113242633077633, -8.147062782044328],
            [4.118640407696936, -8.143979773808278],
            [4.128489462534403, -8.14438770098865],
            [4.132173842448427, -8.140371953054883],
            [4.130610619592975, -8.132303472737153],
            [4.122071446988404, -8.121494732754261],
            [4.107976787869985, -8.091359621065358],
            [4.107608409351817, -8.087140712006077],
            [4.109636683279977, -8.079683877409442],
            [4.109287110284433, -8.067922598838573],
            [4.110960136306327, -8.050355085150994],
            [4.1076765076510044, -8.041804896114607],
            [4.108077416663976, -8.036844648861257],
            [4.111173393624657, -8.031448990974464],
            [4.115440138586755, -8.028805861652927],
            [4.118553589113545, -8.021366194515794],
            [4.115683562781502, -8.01430214809375],
            [4.112716650031874, -7.995548966787459],
            [4.114174646976564, -7.991871301306469],
            [4.119476485440835, -7.989564054791306],
            [4.12396593716853, -7.985922256611166],
            [4.12417454132425, -7.981452161974432],
            [4.120567269520681, -7.9748581228496604],
            [4.12033580678518, -7.969922425576],
            [4.1218684738037785, -7.961965503806284],
            [4.12140410154837, -7.950817390845173],
            [4.118031127947137, -7.942959678197776],
            [4.109721156756636, -7.931318115985808],
            [4.104579912876685, -7.919364924039359],
            [4.099170411991707, -7.914447504933099],
            [4.09896044161676, -7.909905164260266],
            [4.100518849810507, -7.905247705122588],
            [4.100804168579147, -7.898886962115758],
            [4.099737891204466, -7.895391225708253],
            [4.093151532417559, -7.883845493943685],
            [4.090932908752283, -7.87606180027658],
            [4.087925297814482, -7.870807074952905],
            [4.080131291404359, -7.8630190011272125],
            [4.0719667303586915, -7.859464860598111],
            [4.053804060876725, -7.8467738563002625],
            [4.052758152479494, -7.843427060084962],
            [4.0532016074816735, -7.837620772569442],
            [4.058084801178632, -7.833242813244185],
            [4.060570921030182, -7.8286573115954985],
            [4.0579288320472156, -7.820295932169198],
            [4.045355321354897, -7.810313773436207],
            [4.0389877563337055, -7.80420909382079],
            [4.039300116364757, -7.797676686304333],
            [4.049324552542442, -7.796468432264074],
            [4.054016761924055, -7.794415421125937],
            [4.05579546893818, -7.782929220014772],
            [4.054535333623437, -7.774940249614045],
            [4.055173486200168, -7.759656695408856],
            [4.05395662906013, -7.745298902800456],
            [4.054862253390694, -7.733796766164695],
            [4.051663713216482, -7.718401018830872],
            [4.051788752527242, -7.708478813058211],
            [4.051123206571903, -7.701634249285899],
            [4.048302490313867, -7.690535922208072],
            [4.048008543541338, -7.684573027491083],
            [4.049473078978828, -7.681014531742683],
            [4.055407141876382, -7.675849116810035],
            [4.067537044155324, -7.672346038793411],
            [4.070685938866482, -7.669285940504055],
            [4.072454363461009, -7.664616799786646],
            [4.07360648958307, -7.655351448186433],
            [4.078995582126347, -7.648717940711333],
            [4.088727607576789, -7.643167446525539],
            [4.09341621109531, -7.638376843893672]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.60081705607246,
          "lat": 30.709471576752797
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22077"],
        "coty_name": ["Pointe Coupee"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Pointe Coupee Parish"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00559449"
      },
      "bbox": [
        4.0389877563337055, -8.163880530769285, 4.487466189343607,
        -7.63513985877681
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [19.400284150125227, 7.747865226778721],
              [19.400079194864304, 7.754815955424525],
              [19.403321422608027, 7.762989633482246],
              [19.410161246519408, 7.766838457937577],
              [19.413333425173004, 7.761540569568499],
              [19.407309143193036, 7.747504066553977],
              [19.40184755906938, 7.7450903389618535],
              [19.400284150125227, 7.747865226778721]
            ]
          ],
          [
            [
              [19.294549468759904, 7.926329106786796],
              [19.293926445447102, 7.930601704812177],
              [19.29900544265585, 7.9323366304179626],
              [19.298236945153715, 7.924376166725647],
              [19.294549468759904, 7.926329106786796]
            ]
          ],
          [
            [
              [19.28289153848729, 7.883315723781104],
              [19.286752430331056, 7.885299359347368],
              [19.288074970654396, 7.879423931117156],
              [19.28380135891811, 7.877729478357277],
              [19.28289153848729, 7.883315723781104]
            ]
          ],
          [
            [
              [19.27492440799807, 7.8749884766598806],
              [19.27334317880419, 7.889815911987859],
              [19.270331461466515, 7.89727441248409],
              [19.272109849239342, 7.905215095943203],
              [19.270205109493542, 7.907505684139969],
              [19.273186221362412, 7.910454021249304],
              [19.275861379036392, 7.904511933357885],
              [19.28088100235205, 7.903106226257761],
              [19.284507034335665, 7.897941339335103],
              [19.282236088403064, 7.895463371252946],
              [19.281109667497805, 7.889643823016034],
              [19.280954335508362, 7.8808168935687855],
              [19.27944558033824, 7.8692472632668835],
              [19.276507738921115, 7.867911458303761],
              [19.27492440799807, 7.8749884766598806]
            ]
          ],
          [
            [
              [19.21248705911413, 7.7108394559141304],
              [19.21292416160974, 7.716232902607096],
              [19.215429710483797, 7.716137314341288],
              [19.218386071145527, 7.709487857525325],
              [19.214162110929163, 7.706872874127162],
              [19.21248705911413, 7.7108394559141304]
            ]
          ],
          [
            [
              [19.197803017074424, 7.727283859702579],
              [19.197243275337616, 7.736001531681778],
              [19.200502943393523, 7.734934132045151],
              [19.200697330219086, 7.724018984506696],
              [19.197803017074424, 7.727283859702579]
            ]
          ],
          [
            [
              [19.196547402743654, 7.688397923712736],
              [19.1970689030418, 7.700800374149626],
              [19.196232242639, 7.710508384673206],
              [19.201023375966106, 7.7111509475377815],
              [19.199179459916934, 7.703349983618382],
              [19.20184800228458, 7.694690899350576],
              [19.20089592093096, 7.691133566359661],
              [19.202371968397383, 7.686968557368418],
              [19.198762214645626, 7.684404212275693],
              [19.196547402743654, 7.688397923712736]
            ]
          ],
          [
            [
              [19.17171433485406, 7.731042596949212],
              [19.171593113622684, 7.738397583634023],
              [19.174190991780655, 7.740309967059917],
              [19.177967479930665, 7.7325196125866515],
              [19.17331403792458, 7.729480852272254],
              [19.17171433485406, 7.731042596949212]
            ]
          ],
          [
            [
              [18.995625531283697, 8.026602304422054],
              [19.07009139640557, 8.030039385510985],
              [19.06900083299222, 8.033405405493586],
              [19.035238344680806, 8.1288494719816],
              [19.031439661727486, 8.181512769115447],
              [19.04318561576218, 8.182165250011291],
              [19.07019359617487, 8.182607071775504],
              [19.107119945639955, 8.183632131365341],
              [19.113985125017802, 8.192157128179437],
              [19.1129444314434, 8.196870746273508],
              [19.11955131757081, 8.207359689761741],
              [19.112677581439254, 8.269745241172522],
              [19.183113994165073, 8.274378018107905],
              [19.180310452289703, 8.266666400497257],
              [19.165333939915808, 8.26569798954882],
              [19.158467968523283, 8.252870090054525],
              [19.17389280404894, 8.226768871067483],
              [19.173974656104956, 8.203900834067285],
              [19.195230074426917, 8.173236695204368],
              [19.217385068392694, 8.171688581468977],
              [19.218093006546876, 8.16313773505251],
              [19.24279511175584, 8.164724279329102],
              [19.265385550591912, 8.175259992843865],
              [19.310065221480823, 8.108740259739905],
              [19.315016777520718, 8.07170570086804],
              [19.32001045108895, 8.074168018821478],
              [19.34390620307854, 8.047937101900398],
              [19.347064243916314, 8.036492069925913],
              [19.33443615299064, 8.039508990035616],
              [19.335030856704535, 8.033128143226584],
              [19.33754748226812, 8.028357432881178],
              [19.333344729829278, 8.024501724311696],
              [19.330324467731685, 8.023868605924354],
              [19.328887862925086, 8.017915754198885],
              [19.326961060802606, 8.016266122118761],
              [19.32616996817765, 8.010695171798957],
              [19.3289766692047, 8.004423037142384],
              [19.327359038788448, 8.002472817560019],
              [19.326123258189142, 7.994320257890106],
              [19.32920458919194, 7.984705306243515],
              [19.324324295593854, 7.980447195781765],
              [19.32015373036404, 7.986222420556893],
              [19.31492567005202, 7.988754357919888],
              [19.31274525536143, 7.9917027442633435],
              [19.308054433765133, 7.985961047692209],
              [19.307038541670817, 7.982001785896333],
              [19.301847158260443, 7.982511777252903],
              [19.303815381340335, 7.964727326392519],
              [19.29633837440326, 7.962888791661709],
              [19.29796128511182, 7.9548615102699864],
              [19.29743294690292, 7.945689483011785],
              [19.298783170710074, 7.941651126231232],
              [19.293069183696993, 7.935069224946558],
              [19.28990067424754, 7.935482843556916],
              [19.28586128729756, 7.946463523099898],
              [19.28032788235625, 7.948425829072729],
              [19.27578496052464, 7.938264347765445],
              [19.276038151748896, 7.928984284874273],
              [19.275265436723664, 7.921863514091708],
              [19.271087193551015, 7.91731274253293],
              [19.26861211827465, 7.9230672597589855],
              [19.269305279533047, 7.932023680149545],
              [19.268164754693895, 7.937182988966906],
              [19.26134103898429, 7.932589159408267],
              [19.26001010490903, 7.923719782349509],
              [19.26186228279484, 7.92084654674608],
              [19.262485414671062, 7.903541866780129],
              [19.261503171002825, 7.897680449042813],
              [19.263597359721558, 7.89235062626045],
              [19.26316557394276, 7.880365518371902],
              [19.26628657289158, 7.859070198631664],
              [19.265801442120743, 7.853481580538599],
              [19.260664877015795, 7.837493072630428],
              [19.256191773088077, 7.83237287459217],
              [19.257559061512335, 7.831033216548915],
              [19.25738270848401, 7.821163039295819],
              [19.25535197996775, 7.81091026092475],
              [19.25593317763808, 7.808302377040446],
              [19.254301682762797, 7.7877549481678],
              [19.250788953423964, 7.785045424931239],
              [19.248050729178754, 7.7793864834323285],
              [19.24550086119024, 7.784793040750076],
              [19.245444893518954, 7.792607306669084],
              [19.243345014034116, 7.794538582517054],
              [19.239053784464517, 7.8034694462777745],
              [19.23527287576309, 7.80618435369311],
              [19.233666769802635, 7.810515941925898],
              [19.23402734211982, 7.816645111683524],
              [19.22947760644516, 7.816419321289085],
              [19.228106236886187, 7.821169956399702],
              [19.22051044590509, 7.819196251093952],
              [19.21412054400532, 7.82182857758238],
              [19.210739529471688, 7.819213353298319],
              [19.21198446621117, 7.811877151734381],
              [19.21454967560276, 7.809710026412352],
              [19.218970162800996, 7.802126285702136],
              [19.220857737674535, 7.785459022735516],
              [19.2200989433, 7.781848884650742],
              [19.221700302845434, 7.7753675547144105],
              [19.219401469966726, 7.772709834280751],
              [19.215602626468627, 7.779882149703],
              [19.20751014151154, 7.781512287948082],
              [19.203259882083955, 7.777747783999932],
              [19.204501334241353, 7.764488984899747],
              [19.206023477595394, 7.757424158644254],
              [19.20207355048842, 7.756883643954684],
              [19.202478992191296, 7.753194243196785],
              [19.199628988525802, 7.745075393610072],
              [19.19124735195705, 7.744951056654138],
              [19.189677661430743, 7.745863905175549],
              [19.18757549291179, 7.756578124957499],
              [19.191885360366424, 7.757494680697201],
              [19.194630576562556, 7.7638493819787815],
              [19.19189114562036, 7.7681958229316805],
              [19.19086454250296, 7.778545866607448],
              [19.189587717808656, 7.784213502181091],
              [19.185314041838406, 7.790162593795314],
              [19.178709254476267, 7.787392653855751],
              [19.179931937066755, 7.7770532182508205],
              [19.173203189555846, 7.772670709137106],
              [19.178525614054305, 7.766083669597402],
              [19.17834131579645, 7.75727432757638],
              [19.174214272566388, 7.754335218295785],
              [19.172327958785292, 7.757463542317378],
              [19.16866845755409, 7.7588005081645255],
              [19.16542194663122, 7.7651548555691186],
              [19.1654014665624, 7.768560296376508],
              [19.16787717939973, 7.772053716566249],
              [19.165645028516558, 7.7742608758680944],
              [19.157881540639284, 7.771006142453592],
              [19.15847858737867, 7.7621327308305474],
              [19.153467549026015, 7.757806939486671],
              [19.160942263150655, 7.742431215843124],
              [19.15732557153155, 7.7438948544430435],
              [19.156397445745046, 7.738884350294554],
              [19.160130079439742, 7.733510093113831],
              [19.161694194663607, 7.726507375478724],
              [19.16345756605762, 7.7138099088587815],
              [19.166057672898408, 7.707592158825793],
              [19.164630339187646, 7.703804725645467],
              [19.159998820209996, 7.704926064238965],
              [19.155445775384297, 7.711554547780359],
              [19.1519676452131, 7.714876669750362],
              [19.15000856275511, 7.72074530323534],
              [19.1416602622806, 7.724224219050641],
              [19.138159869197324, 7.727140936432183],
              [19.135718954346412, 7.725744016261864],
              [19.133060956565597, 7.735776116787441],
              [19.128408645673886, 7.739472088633485],
              [19.129908339500275, 7.742909133578287],
              [19.12858213374421, 7.749700853991233],
              [19.12998832245875, 7.754925527496505],
              [19.12732703447443, 7.756668551346718],
              [19.128806847820194, 7.761395710292166],
              [19.126926668731787, 7.771180883817074],
              [19.12238864634449, 7.773434556985368],
              [19.118803543532014, 7.780528285203787],
              [19.118427739856585, 7.789129171058198],
              [19.114083878439562, 7.797471836314142],
              [19.11239649512658, 7.8090352057640375],
              [19.112635808350774, 7.82539599213329],
              [19.11488109112755, 7.832401148329505],
              [19.11459618812045, 7.837100446758551],
              [19.109719889405227, 7.839265923815023],
              [19.1085739261935, 7.835226623265629],
              [19.105315952625023, 7.834840733176096],
              [19.102390741941214, 7.827114485990024],
              [19.106267204584988, 7.810502609864247],
              [19.10554302076229, 7.804986562825276],
              [19.107446750038854, 7.797729531454073],
              [19.10867266700107, 7.786202413916426],
              [19.108321800913487, 7.781679183055448],
              [19.10639983763886, 7.778479988791211],
              [19.10805507861746, 7.772383733744724],
              [19.11177266149873, 7.7650611253168185],
              [19.1049105313543, 7.758939574013485],
              [19.09834674495907, 7.759640771428006],
              [19.095182233993793, 7.765727662922758],
              [19.08882316352375, 7.773141577855989],
              [19.08735840217394, 7.780914500222921],
              [19.08395582570831, 7.783154056531436],
              [19.079605502168327, 7.789169787279197],
              [19.07300932860577, 7.794363297296648],
              [19.076121056431994, 7.801851684666329],
              [19.077612995781404, 7.809871257525794],
              [19.07994169634536, 7.814374434200308],
              [19.084614226886455, 7.819282340755642],
              [19.087057748883193, 7.825492836979308],
              [19.088704500978434, 7.833627449417401],
              [19.07801715857232, 7.835014540512216],
              [19.074513979367875, 7.837494714363113],
              [19.07457178575315, 7.842531421544589],
              [19.07004265540189, 7.860769695258714],
              [19.071093895845255, 7.865073335755334],
              [19.069067533056565, 7.867039001014956],
              [19.06821197330307, 7.873382050325708],
              [19.070315650123707, 7.897334188393538],
              [19.069764515012082, 7.899163391109479],
              [19.071997878913898, 7.906304156258433],
              [19.071967178937516, 7.910916920460438],
              [19.035840358149926, 7.908735585546226],
              [19.03561866713493, 7.9095753608778105],
              [18.98847533182685, 7.9075552319076055],
              [18.988076293993753, 7.910460914448532],
              [18.991064345256824, 7.915130184382349],
              [18.997250626370533, 7.921773132936834],
              [19.000002628003372, 7.9277827161235],
              [18.999154316978835, 7.941887790108708],
              [18.996626641242266, 7.949597638818388],
              [18.997472641279092, 7.955998099424664],
              [18.993275814699455, 7.9592351667163985],
              [18.992908544060555, 7.967781254786213],
              [18.990853361210437, 7.971403587466554],
              [18.995567634850694, 7.98529535607458],
              [18.996765872040513, 8.000831484873846],
              [18.995896393428428, 8.006918161383965],
              [18.997271177560506, 8.012761619155627],
              [18.996257936048835, 8.01642014617196],
              [18.995625531283697, 8.026602304422054]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.54344329619292, "lat": 44.06668225015421 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23015"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00581293"
      },
      "bbox": [
        18.988076293993753, 7.684404212275693, 19.413333425173004,
        8.274378018107905
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.80014465655769, 1.8424037048021116],
            [15.798738696129922, 1.8480204489842176],
            [15.795267374538039, 1.8526378546892837],
            [15.798302601609015, 1.8560058168243192],
            [15.79301787503429, 1.8698420286225972],
            [15.79747119223033, 1.871995500715956],
            [15.798825767447083, 1.874724179520074],
            [15.797658450853879, 1.8809419087040935],
            [15.799940091326992, 1.8841797894828887],
            [15.794764631066796, 1.8921646400776646],
            [15.798101523702709, 1.8988163489402536],
            [15.794215793539923, 1.9009522807659782],
            [15.798126801965747, 1.9058157113823757],
            [15.798229926385481, 1.9126232707544228],
            [15.799612261092832, 1.9169267068582816],
            [15.804637518959392, 1.9218922054481413],
            [15.805203033311162, 1.92788564898828],
            [15.810787261728201, 1.9332265313732249],
            [15.811809575939751, 1.938048688202415],
            [15.814713560982806, 1.9405695280944057],
            [15.812841069143998, 1.9451505721371463],
            [15.815294035327105, 1.9467573619086325],
            [15.818947637105524, 1.945460701675316],
            [15.823074872475095, 1.9505057781458244],
            [15.82225906223232, 1.955165903025257],
            [15.824001267408944, 1.9592605541475514],
            [15.827019395025694, 1.9612555028087557],
            [15.825638111363347, 1.965696112973006],
            [15.828322930917874, 1.97275937179866],
            [15.828867817869265, 1.9775868469806566],
            [15.827777796780873, 1.981645102538075],
            [15.830653661644694, 1.9924176500439854],
            [15.835128880106643, 1.9954127314288943],
            [15.843241674660538, 2.009601436801492],
            [15.843947028590646, 2.01326856708342],
            [15.840761114655175, 2.0237908430708003],
            [15.84343867437029, 2.029391223345532],
            [15.844124900180995, 2.0395410597628945],
            [15.845930295630415, 2.048332058234577],
            [15.847610487795977, 2.048802147082355],
            [15.853347918239262, 2.0569074910901697],
            [15.86219938182742, 2.064251019969025],
            [15.86700820870348, 2.0696537705541536],
            [15.868710125480643, 2.0741855788759076],
            [15.872148218749366, 2.0761110487859704],
            [15.873668362219053, 2.0795861146877885],
            [15.884841275910977, 2.08378433959931],
            [15.8973673211433, 2.090473542485238],
            [15.904020860032801, 2.096997833371589],
            [15.911497243984076, 2.0692872004107743],
            [15.917312659690039, 2.049629112054487],
            [15.954881301976855, 1.9160010757599442],
            [15.978995920430547, 1.8302836012289663],
            [15.989861094591769, 1.7919138456863328],
            [16.023762066723176, 1.6709773638343683],
            [16.042959145686613, 1.602598651632878],
            [16.035299974794015, 1.6117211992246656],
            [16.02285917176099, 1.6198946258992075],
            [16.013622785213354, 1.627142524732743],
            [16.003843526477258, 1.6309681172464396],
            [15.990254817584777, 1.6436721510844035],
            [15.98562197019021, 1.64225906123536],
            [15.983803533567551, 1.6334534176283202],
            [15.979357078164842, 1.631266404120559],
            [15.974197689352815, 1.6309837872259916],
            [15.965394564819437, 1.6281001173603116],
            [15.959456127897676, 1.6480609785085634],
            [15.954790209948943, 1.6485477529795192],
            [15.947342394640721, 1.6468595443364473],
            [15.929612175051487, 1.6489399807457934],
            [15.925413584376527, 1.6478235275011683],
            [15.914993986419061, 1.6428768335958617],
            [15.907128555054369, 1.6340497931356772],
            [15.901325095358136, 1.6320583566882874],
            [15.89287515806134, 1.6322493241561538],
            [15.88731966311816, 1.6362131546515961],
            [15.885903861557704, 1.6348036258630463],
            [15.882535581020845, 1.6219509679924045],
            [15.879515839747555, 1.621602511521612],
            [15.87363163092279, 1.6130711105779703],
            [15.87023146959928, 1.6134849304536127],
            [15.866118051269819, 1.6063931472149262],
            [15.862731433090826, 1.6103684820167579],
            [15.859945063721375, 1.6093545444424313],
            [15.85487207612309, 1.6020457338824818],
            [15.851866133581185, 1.6035647236116577],
            [15.836051141177272, 1.6061779745130103],
            [15.832666897285822, 1.6081792436277556],
            [15.82721263908544, 1.6194393856167435],
            [15.824533962208669, 1.6205440444217787],
            [15.816814075294817, 1.616996335819228],
            [15.812209690754841, 1.6190689687638962],
            [15.811855837950835, 1.6263668005754546],
            [15.810485212355816, 1.6287750959774143],
            [15.80203348523209, 1.6364471464827959],
            [15.795398720116598, 1.639259466185231],
            [15.790596457891942, 1.6446407845968118],
            [15.791015564016078, 1.649481735709429],
            [15.793520982452849, 1.6533003238379527],
            [15.800915675376864, 1.6531892719402121],
            [15.803220646810857, 1.6545834759751517],
            [15.803266989713975, 1.6609675032561702],
            [15.797532739606229, 1.6702588126636668],
            [15.79694781534396, 1.6725747506056483],
            [15.800224172614707, 1.6782736958100628],
            [15.809707232740077, 1.6848676940908378],
            [15.814640563620214, 1.6919414878671526],
            [15.81667359423193, 1.6973881495272887],
            [15.815601500077479, 1.7005968506396285],
            [15.818360185697648, 1.703186057486985],
            [15.825984201144744, 1.702577455472893],
            [15.829636369792924, 1.7043117838620585],
            [15.836910645813122, 1.7149761168944957],
            [15.838673279319163, 1.7245359166645358],
            [15.841462807619186, 1.728295174536661],
            [15.852485514106593, 1.737970299033583],
            [15.85807611298541, 1.7398394517193276],
            [15.861301574342622, 1.7490764437614248],
            [15.856390672484329, 1.7496246390043706],
            [15.85335017810018, 1.752008095044573],
            [15.856228617641351, 1.7559060471679822],
            [15.853519842227564, 1.7589871710181524],
            [15.846392636495034, 1.7606592770672174],
            [15.84356089083691, 1.7655257414931773],
            [15.84027746320053, 1.765203680820699],
            [15.833206586563765, 1.767494791012594],
            [15.832498833509954, 1.7695880587737027],
            [15.8382634040158, 1.7748985273732503],
            [15.832236095253142, 1.7756936808935622],
            [15.828708810120098, 1.7788951030917497],
            [15.833593943159155, 1.7839807412532582],
            [15.831250808088459, 1.7892626821913709],
            [15.82661349436896, 1.7891947883641492],
            [15.821919683782449, 1.7946141768734862],
            [15.818664147384833, 1.792933307956594],
            [15.81497771240198, 1.7962062490517827],
            [15.81301186418059, 1.8005257265247088],
            [15.816865123822437, 1.802697693217801],
            [15.81710497847242, 1.8062685046819091],
            [15.813920314974077, 1.807007695686427],
            [15.809017128418008, 1.80313524213393],
            [15.80659043424752, 1.8044663421106801],
            [15.806365978986909, 1.8087416134850027],
            [15.813976674596935, 1.8105040818726654],
            [15.809699688829516, 1.8152781485610443],
            [15.806627969857704, 1.8159158171776435],
            [15.808290427911617, 1.8226962962849913],
            [15.803972334408646, 1.829008685764455],
            [15.807319925573339, 1.8319102008033488],
            [15.802842673140898, 1.8347589440019474],
            [15.80014465655769, 1.8424037048021116]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.8315621378054, "lat": 38.87173360323409 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24011"],
        "coty_name": ["Caroline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caroline County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00595737"
      },
      "bbox": [
        15.790596457891942, 1.6020457338824818, 16.042959145686613,
        2.096997833371589
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.355125405395599, 6.146460919248478],
            [2.357832558231101, 6.148110050400959],
            [2.366056726083522, 6.1481463736646],
            [2.372790927872918, 6.1503588094619825],
            [2.386189593887906, 6.158277237135533],
            [2.389241275556117, 6.162635698531979],
            [2.3951424440832447, 6.163321998625928],
            [2.409583002776064, 6.168321190968098],
            [2.4122377299053, 6.172231734265897],
            [2.4181930757467236, 6.177260863441034],
            [2.4212006347935344, 6.18174377428196],
            [2.426348776238527, 6.186351577802586],
            [2.4321994353739425, 6.189662004019848],
            [2.430569607909201, 6.195830603368827],
            [2.4373753630041053, 6.197289147320253],
            [2.4398655950931967, 6.201231441256967],
            [2.442686012436776, 6.2100112833139525],
            [2.4467905557115115, 6.217860258253858],
            [2.444729454859511, 6.223170367199043],
            [2.451682370913818, 6.229383360912269],
            [2.452998375141802, 6.232873753167911],
            [2.459286683562158, 6.238199148462806],
            [2.4561642368237, 6.243272925703091],
            [2.459207668266785, 6.246341034332921],
            [2.4660133651649985, 6.246408793414085],
            [2.469182825665849, 6.24863040271973],
            [2.476491573511637, 6.251395617079642],
            [2.4797422100749174, 6.256019638594595],
            [2.488399645667578, 6.264903185982836],
            [2.491317331725798, 6.2748740443191355],
            [2.4935484360953124, 6.27854945773719],
            [2.5165892407011117, 6.279276388060397],
            [2.5164668378915698, 6.282866137902147],
            [2.5200765623262362, 6.282925103260402],
            [2.5202035866952666, 6.2793753339315765],
            [2.5479588222546248, 6.280060402216532],
            [2.552750093365271, 6.273042057132518],
            [2.5551330960162786, 6.26593827350517],
            [2.5605851206613175, 6.258865724216648],
            [2.567861019676949, 6.255349472340447],
            [2.571191166726915, 6.25214211220875],
            [2.5739137172263225, 6.246111726139981],
            [2.5771077465362486, 6.230761568553246],
            [2.580413332563701, 6.220512943569518],
            [2.5800142457285413, 6.209749433582446],
            [2.5786678034453456, 6.1985442993347],
            [2.58442612053827, 6.1769598732253295],
            [2.5771942930029597, 6.1645286328020035],
            [2.574004079620197, 6.156062215188467],
            [2.5734111113811715, 6.1485934219546685],
            [2.5776998872096475, 6.1375762163939305],
            [2.5848921363369017, 6.133935222429357],
            [2.588602383214385, 6.134279804862452],
            [2.59273370506736, 6.137187247991763],
            [2.598875572201757, 6.137989627978029],
            [2.61478147879953, 6.1332617172950465],
            [2.6216659010261396, 6.134568170144316],
            [2.631679621774787, 6.1393900144111235],
            [2.6369521873835993, 6.1449648565308665],
            [2.6416931516957463, 6.144807279604865],
            [2.6504190246626393, 6.1390199984183536],
            [2.656271709685098, 6.138116955208538],
            [2.6655035458701026, 6.13925777449738],
            [2.6722195445360652, 6.139141660460538],
            [2.6794619037115948, 6.132743343140191],
            [2.688148357377806, 6.121381345025812],
            [2.692398284319979, 6.113497025938721],
            [2.696239336562282, 6.112436358107687],
            [2.7060565734975732, 6.113602019047281],
            [2.713649088250953, 6.116719653408794],
            [2.7226400990747313, 6.114037543747779],
            [2.7298121803337465, 6.112826907463895],
            [2.740490757026866, 6.104846388993138],
            [2.756240454227143, 6.097574073808183],
            [2.7628607165978, 6.092041281129974],
            [2.767731130653235, 6.090503006850718],
            [2.7770729892087274, 6.085871528482479],
            [2.78089048950096, 6.08252819039556],
            [2.7817890886989, 6.048935741938911],
            [2.7833576744841553, 6.005450022085651],
            [2.783789726452976, 5.998689006239399],
            [2.740818045520252, 5.997461001449322],
            [2.7437405250913813, 5.911025368143743],
            [2.737962829304234, 5.9110600666173605],
            [2.653927691236211, 5.908347256532592],
            [2.654640537560955, 5.882748592017422],
            [2.6447514023502148, 5.877297912605361],
            [2.641382409593725, 5.876196056385649],
            [2.6353451350705557, 5.877143219285179],
            [2.632056438681316, 5.8721800527469785],
            [2.6296160275979674, 5.871425711103927],
            [2.6279360958632307, 5.8788823016148095],
            [2.616301549810005, 5.878652294261717],
            [2.613969255278772, 5.880928084105095],
            [2.6078480782236944, 5.882505541999211],
            [2.5981416940898905, 5.880941717211107],
            [2.59483994647275, 5.8791419206366955],
            [2.5879162806594005, 5.879081694006326],
            [2.5845055765808, 5.877995358047929],
            [2.5781267699379398, 5.878981793115704],
            [2.5690873408826147, 5.8749974816539945],
            [2.569750605092432, 5.849001894574946],
            [2.5705198224255263, 5.834489846988564],
            [2.527363416916026, 5.833045067808368],
            [2.5062946316260253, 5.831900726527961],
            [2.4484815533951325, 5.8304274349968965],
            [2.4450578052211687, 5.830096045450716],
            [2.3982087198812336, 5.829493922887378],
            [2.396263000282709, 5.90123055557903],
            [2.3984291824870425, 5.901292236746454],
            [2.3972627865172544, 5.95176872260951],
            [2.39615419108781, 5.987791594500148],
            [2.3673860743378383, 5.986805608133578],
            [2.3662037013655683, 6.03733107263719],
            [2.3651874402038415, 6.073439129334268],
            [2.358055821241159, 6.073253317331514],
            [2.3561807910771657, 6.131240825701172],
            [2.355443761947376, 6.133869022789864],
            [2.355125405395599, 6.146460919248478]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.06544460985708, "lat": 44.67187128869412 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27037"],
        "coty_name": ["Dakota"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dakota County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00659464"
      },
      "bbox": [
        2.355125405395599, 5.829493922887378, 2.783789726452976,
        6.282925103260402
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.2459217702313263, 7.497156882144734],
            [2.2543392317319197, 7.4977700399704155],
            [2.333923139463277, 7.504616102216844],
            [2.349097641341649, 7.50548510382113],
            [2.4211976302608353, 7.506758513621995],
            [2.4507569826023827, 7.507415405921127],
            [2.507918078394822, 7.509025221158868],
            [2.508234786893611, 7.4996533616004735],
            [2.5098122975871187, 7.423040481325039],
            [2.512437626903577, 7.3339373557640455],
            [2.4515803991674208, 7.331758588952261],
            [2.454198713627527, 7.256172696291417],
            [2.456515541654934, 7.184122198176864],
            [2.459848699200783, 7.083773671887839],
            [2.4308702723334226, 7.0827779718583725],
            [2.3997973396750383, 7.0822143688028145],
            [2.337284883644279, 7.080497158545713],
            [2.287261201500958, 7.078903995965387],
            [2.2365208774223233, 7.079728153304769],
            [2.200096920046328, 7.080156385294848],
            [2.199128145868032, 7.10508401476101],
            [2.1956498444398322, 7.166189793861735],
            [2.193290703579233, 7.2228544479254255],
            [2.192364764184933, 7.252860772101269],
            [2.1905715415068356, 7.325194963827358],
            [2.2429339698055633, 7.326529450177165],
            [2.250116163476073, 7.3265095077512195],
            [2.2491212937855947, 7.35528819532432],
            [2.247813312478726, 7.412205017164908],
            [2.2459212396694372, 7.490069763330475],
            [2.2459217702313263, 7.497156882144734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.29340490145043, "lat": 45.94522139233506 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27065"],
        "coty_name": ["Kanabec"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kanabec County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00659478"
      },
      "bbox": [
        2.1905715415068356, 7.078903995965387, 2.512437626903577,
        7.509025221158868
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.544835694991669, -7.600506475366238],
            [6.554186939464271, -7.600678045070261],
            [6.588004953173213, -7.597749321336989],
            [6.581498575064216, -7.510830236928032],
            [6.650575713099162, -7.506145378844203],
            [6.741402861675402, -7.498224856917578],
            [6.759956941240138, -7.4964694870023845],
            [6.833513923443866, -7.491420068900238],
            [6.929688508062235, -7.483690073853705],
            [6.94470063026219, -7.605299952728638],
            [6.946187600555248, -7.6138155546192285],
            [6.9619295111999335, -7.743088457005351],
            [6.921298011175495, -7.746645704999987],
            [6.912788998235768, -7.747614501977983],
            [6.8829407009341645, -7.749883397176788],
            [6.7905546969141755, -7.757180497768584],
            [6.7495168407579085, -7.76052220874393],
            [6.601640954738116, -7.772208516158711],
            [6.601534893065497, -7.770411369975107],
            [6.558405356936161, -7.774083264787398],
            [6.55042611309177, -7.670185966714774],
            [6.544835694991669, -7.600506475366238]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.6439942676245, "lat": 30.862590243386595 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28039"],
        "coty_name": ["George"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["George County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00695744"
      },
      "bbox": [
        6.544835694991669, -7.774083264787398, 6.9619295111999335,
        -7.483690073853705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.042692955796538, -6.751832390872949],
            [6.064651486452581, -6.748510065461488],
            [6.085563985844688, -6.745799438151462],
            [6.113788748871731, -6.741664151685668],
            [6.167654148837739, -6.734017972543148],
            [6.179954327016847, -6.732538288446462],
            [6.201118001371971, -6.729188360741778],
            [6.237938996658111, -6.724060618928804],
            [6.2729306998979615, -6.718944372778908],
            [6.284469729619004, -6.717510250070682],
            [6.312877893060729, -6.712987685321935],
            [6.331221731553271, -6.710583369986679],
            [6.374745265026729, -6.704199422369866],
            [6.385524676285687, -6.702840223372123],
            [6.427049671785723, -6.696657109202859],
            [6.430213250041414, -6.736788616410412],
            [6.4359448599948985, -6.813564511687922],
            [6.442025552512677, -6.891957744535785],
            [6.443267858400988, -6.904746687379052],
            [6.4466717318427476, -6.954097792018869],
            [6.451097702172902, -7.012916742816612],
            [6.4560871096247565, -7.085498268136206],
            [6.348751273690823, -7.093081052863476],
            [6.284280359184458, -7.097403790773704],
            [6.243690535640809, -7.100265316757365],
            [6.167535134366281, -7.105979848456923],
            [6.154614331732674, -7.106497887149872],
            [6.1333243464316505, -7.108236705930027],
            [6.11301838345746, -7.109107583233028],
            [6.090156134393536, -7.111134098353281],
            [6.06970619775917, -7.112523323109998],
            [6.066283115111821, -7.065196934307535],
            [6.061582756308643, -7.005915820456613],
            [6.055590048157847, -6.924007838193324],
            [6.046029818946742, -6.795397899682525],
            [6.042692955796538, -6.751832390872949]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.16878369204616,
          "lat": 31.622537197354333
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28067"],
        "coty_name": ["Jones"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jones County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00695757"
      },
      "bbox": [
        6.042692955796538, -7.112523323109998, 6.4560871096247565,
        -6.696657109202859
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.099905750908007, -7.257889422347681],
            [5.117887073024566, -7.256996781294935],
            [5.179315839791118, -7.253425755262415],
            [5.265401792599079, -7.247808415633083],
            [5.344322727313891, -7.2428996960239305],
            [5.345130395308805, -7.2645302767432485],
            [5.346067195005357, -7.275843506422947],
            [5.348848803315129, -7.32136654079317],
            [5.350252450676304, -7.340752898101467],
            [5.354751528363504, -7.416299432228189],
            [5.3589944337374105, -7.478045885054908],
            [5.366207627151411, -7.59008863711887],
            [5.2913744904907265, -7.59483694474046],
            [5.272552210987832, -7.595969534666343],
            [5.263055363111245, -7.596988463916796],
            [5.210222247870812, -7.600220683426983],
            [5.120528299316876, -7.60537462165211],
            [5.120234867113831, -7.602297374594952],
            [5.114721470798498, -7.510757539023392],
            [5.111878258840523, -7.4604739008692205],
            [5.108381028634161, -7.402932173295309],
            [5.107006313573892, -7.383304607626547],
            [5.104188075696521, -7.330990213317269],
            [5.099905750908007, -7.257889422347681]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.4041713453801, "lat": 31.174837790978472 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28113"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00711758"
      },
      "bbox": [
        5.099905750908007, -7.60537462165211, 5.366207627151411,
        -7.2428996960239305
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.420010532425063, -5.112348938407224],
            [4.566357012889386, -5.1041858775206945],
            [4.6097434615531885, -5.101580917888045],
            [4.645841399504821, -5.099876157687277],
            [4.696306681155645, -5.096943191689473],
            [4.704070543000085, -5.097638150748661],
            [4.747828893582666, -5.094726038982951],
            [4.796304450609248, -5.092572265755043],
            [4.798146329049158, -5.092507227046126],
            [4.800307402004028, -5.121757657310784],
            [4.803469116026018, -5.176186296816173],
            [4.800138797447846, -5.176430520079252],
            [4.803808191813325, -5.235726169284972],
            [4.80847954362063, -5.3227929948401735],
            [4.810447421242374, -5.351911282538237],
            [4.849852744819018, -5.350066019446055],
            [4.847682235712099, -5.3535902717698685],
            [4.843680472397621, -5.355578515460214],
            [4.840511856757939, -5.353117705576344],
            [4.837591300755684, -5.356238395291137],
            [4.837069509359436, -5.361683788678644],
            [4.840043730485902, -5.367220011202928],
            [4.840326766044087, -5.370580092930719],
            [4.83787190163184, -5.387926055718739],
            [4.841052524724191, -5.3924467482236045],
            [4.844809511807691, -5.391091787285445],
            [4.84868488947571, -5.392782401922271],
            [4.854120025823079, -5.400811117308559],
            [4.863108975483147, -5.406978965347496],
            [4.868121619563783, -5.408857375152752],
            [4.875449358426826, -5.409944163836518],
            [4.88350376929877, -5.416511978874355],
            [4.88508159275411, -5.421113064301279],
            [4.883924854394174, -5.425132975335025],
            [4.879738821444799, -5.429126966220781],
            [4.879255865952825, -5.434193050548068],
            [4.881815595527769, -5.439905435938324],
            [4.881773599199106, -5.451346570587982],
            [4.878194549296467, -5.460820708245702],
            [4.880024170860948, -5.470400754531735],
            [4.8773719673122, -5.4769807917955715],
            [4.872000374434476, -5.481318524966209],
            [4.873075219735575, -5.487421999495932],
            [4.871005008288759, -5.49432729595116],
            [4.872878864502569, -5.497959897795256],
            [4.878836497410979, -5.495221337996361],
            [4.8807755143827904, -5.495913124480459],
            [4.881147601250364, -5.501940997457062],
            [4.883379467223528, -5.503835545168293],
            [4.8890622976759825, -5.50389604449171],
            [4.890190093974496, -5.514644657543961],
            [4.887141960545139, -5.520326109127342],
            [4.884893727338326, -5.521722642740004],
            [4.876442854486549, -5.518917082792134],
            [4.8715640882628595, -5.523223671174818],
            [4.814170865962931, -5.526749827268043],
            [4.739566336298458, -5.531456355030911],
            [4.737829935164736, -5.529309669567448],
            [4.694785851101225, -5.5317183515907775],
            [4.699721419635338, -5.6214500159884855],
            [4.657198737549472, -5.62348251776776],
            [4.65705049863561, -5.620856733599995],
            [4.589405017146081, -5.624227740541514],
            [4.571351104178505, -5.625544980300266],
            [4.571243591567356, -5.624651995450933],
            [4.489890231212415, -5.628658618566938],
            [4.493131741868275, -5.620005485285179],
            [4.502851949933732, -5.61303178734506],
            [4.512977092264224, -5.610085569287063],
            [4.520273232536526, -5.6041515355619715],
            [4.522549101690662, -5.5994521381380835],
            [4.523998049306086, -5.587122562051494],
            [4.525838988048083, -5.583560292996503],
            [4.524920902423301, -5.578957583847509],
            [4.5218005910043875, -5.5741413998850815],
            [4.499604908999349, -5.55721684697406],
            [4.4918813603742, -5.554415500411095],
            [4.482426122872633, -5.552817431315674],
            [4.48020860212407, -5.551620719352647],
            [4.473318333576201, -5.542264771704083],
            [4.460436493348568, -5.536698580517444],
            [4.455599339075448, -5.531849509510021],
            [4.454471346475759, -5.5183777176443485],
            [4.456135673724023, -5.512875207403826],
            [4.461599360196964, -5.5040162916865105],
            [4.468760211978355, -5.499033568935224],
            [4.480556102678721, -5.497486161886388],
            [4.488196098395871, -5.498526469604828],
            [4.494631632125042, -5.504631078989704],
            [4.496991313624659, -5.508634141280144],
            [4.515599679933746, -5.509472652469165],
            [4.527942424950092, -5.5085494497618575],
            [4.538922621443324, -5.5060621331651705],
            [4.548854861935874, -5.501262669150899],
            [4.55037688819819, -5.4993875317202665],
            [4.552872361331199, -5.482585092657237],
            [4.553353724212625, -5.466005972376144],
            [4.5521201098278326, -5.4541259076292326],
            [4.5490790318079, -5.446080194038924],
            [4.537999862095318, -5.426496185920296],
            [4.5340200643354915, -5.4177159163644095],
            [4.545753496009764, -5.414888651028612],
            [4.551064624078809, -5.4122065170795315],
            [4.552210808294313, -5.40871245706809],
            [4.558145596311449, -5.408571551346157],
            [4.559502105149033, -5.40284770665492],
            [4.562054716705516, -5.402669532706398],
            [4.5632509460429045, -5.398218243085568],
            [4.57091296864075, -5.389041333574331],
            [4.573731442357986, -5.383779944108017],
            [4.577313751836396, -5.36934083451135],
            [4.578129093360446, -5.360032908389861],
            [4.5739475755157155, -5.352060247121327],
            [4.570311636898808, -5.349620327058496],
            [4.564958979819982, -5.3484063634649015],
            [4.558057513671508, -5.348483601385161],
            [4.548727158039186, -5.352853816039247],
            [4.544691873721111, -5.357828241807353],
            [4.542920960484281, -5.36284230027281],
            [4.5402819947067785, -5.379363894807684],
            [4.536981378152698, -5.386384003946506],
            [4.535630731504106, -5.39535578766345],
            [4.532579535081125, -5.398879355539071],
            [4.524098632846556, -5.3916306201370485],
            [4.516384009182276, -5.37547729709032],
            [4.508400439984557, -5.369781749086537],
            [4.510194078599244, -5.363437744921783],
            [4.5098999290947335, -5.357909854426676],
            [4.4970174995902665, -5.3421447847598875],
            [4.4955753868595565, -5.339286570760016],
            [4.4949312285161644, -5.324485936463283],
            [4.492390107384747, -5.31048290066619],
            [4.494210688312226, -5.302264744550762],
            [4.492531180744079, -5.289806959684576],
            [4.494084065740768, -5.287255456317832],
            [4.5061362675855, -5.277960188073935],
            [4.509837702168275, -5.274046577815437],
            [4.520248949469629, -5.256113637445067],
            [4.524326673797735, -5.249831497941914],
            [4.53246179214533, -5.240353433950849],
            [4.541455239342544, -5.233416212396438],
            [4.545674984386141, -5.228338957914649],
            [4.553345497311996, -5.2169380925131605],
            [4.558018343932458, -5.206411358485802],
            [4.557147250891754, -5.18855114669576],
            [4.555503593219812, -5.184900906261686],
            [4.55128723717049, -5.181586648145501],
            [4.546180044041544, -5.179766209925629],
            [4.5370884067847195, -5.181905601623059],
            [4.532936246608307, -5.185029660504145],
            [4.5273886104756285, -5.193969811125438],
            [4.525629066936142, -5.19914908457693],
            [4.525312225849784, -5.205059334530015],
            [4.5277157602076965, -5.212548531079955],
            [4.527260002643802, -5.223943683364869],
            [4.524878862660851, -5.22970461538973],
            [4.513826092938144, -5.24441280655318],
            [4.5078786975820355, -5.2494398659534784],
            [4.49116740736537, -5.2586857497879755],
            [4.4855352352596825, -5.260272508844906],
            [4.471001301632963, -5.260062860903299],
            [4.4620297476177875, -5.257372943867343],
            [4.449934606010602, -5.251164345819982],
            [4.438178546016734, -5.242531459330325],
            [4.434395109856604, -5.237892774487408],
            [4.434410333189377, -5.2327860119386616],
            [4.436970592863144, -5.227123564420576],
            [4.441662556192729, -5.222781286841769],
            [4.447803595265284, -5.223067246617891],
            [4.453956835434057, -5.220901396849162],
            [4.4608343568043525, -5.223161134260372],
            [4.4712435157484265, -5.217435194760506],
            [4.484003063530966, -5.211751810571266],
            [4.4910612870253805, -5.2116101981235055],
            [4.4969150214920175, -5.208191014053513],
            [4.498182011494902, -5.20409102797705],
            [4.506790765391486, -5.19147236133745],
            [4.508152333956967, -5.18555671889975],
            [4.507137079040245, -5.1795357457239595],
            [4.50382792081507, -5.170262119988641],
            [4.499527178712111, -5.162802185987166],
            [4.494039498748396, -5.156630636520012],
            [4.4820193121326755, -5.148310059919686],
            [4.468852059024284, -5.1419257027027845],
            [4.463511110717629, -5.14134095940178],
            [4.460556374699771, -5.142829265369022],
            [4.4566705251254755, -5.152809837654415],
            [4.4565726028737895, -5.158452226674006],
            [4.458199472069511, -5.1671281662343125],
            [4.464241336750676, -5.18591960980877],
            [4.464399973074359, -5.187807294820893],
            [4.459234214533045, -5.195482873464453],
            [4.455060611607674, -5.19955647776222],
            [4.444632626428906, -5.204522544105708],
            [4.434704070658114, -5.207544345446573],
            [4.425913941717394, -5.207129281250678],
            [4.410958484158348, -5.203587843432587],
            [4.412158719917757, -5.198441502867553],
            [4.412956654577731, -5.185286772643186],
            [4.419557590397192, -5.179269312354623],
            [4.425934426269768, -5.176925358084313],
            [4.431509969818903, -5.172803689778622],
            [4.438170372862029, -5.1578896611884355],
            [4.441173533661945, -5.152373142177045],
            [4.451408123151349, -5.141094792111518],
            [4.448652760069097, -5.132852715249247],
            [4.431826999535097, -5.122902993233958],
            [4.423222255277807, -5.116019244092823],
            [4.420010532425063, -5.112348938407224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.94735713483546,
          "lat": 33.283937662586695
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28151"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00695796"
      },
      "bbox": [
        4.410958484158348, -5.628658618566938, 4.890190093974496,
        -5.092507227046126
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.62298587568343, -6.115003474827388],
            [7.66592696674642, -6.1106621689543585],
            [7.658879738703395, -6.043564516976354],
            [7.65649324953261, -6.012713825154326],
            [7.64890297510963, -5.936635653035089],
            [7.723816603534536, -5.929838736611918],
            [7.806957615282903, -5.920839216033182],
            [7.817420820673902, -5.9172471133992985],
            [7.904717530205675, -5.908439224034557],
            [7.907985041948312, -5.907182093264553],
            [7.910663728449732, -5.902425343730404],
            [7.910321024775701, -5.897961492340863],
            [7.91532591461454, -5.892126233668507],
            [7.915934890759629, -5.882516612503081],
            [7.917688939692342, -5.874316835802605],
            [7.920121519140256, -5.872457740465278],
            [7.923190210933276, -5.866139137539134],
            [7.922379889536783, -5.859855577586164],
            [7.930494856959032, -5.85370024292558],
            [7.931553863740684, -5.84820906682209],
            [7.929873527605725, -5.841751413839013],
            [7.930825688376176, -5.836005735704991],
            [7.926658681879316, -5.832889865046084],
            [7.927757257802422, -5.827401682206699],
            [7.926132701240033, -5.823317023398138],
            [7.937085608924853, -5.815272125573148],
            [7.94017541666179, -5.810809624273052],
            [7.9451625671434885, -5.807448167135991],
            [7.946043497031322, -5.8029584599955575],
            [7.95109367145179, -5.797902094574921],
            [7.954008492825926, -5.796963781045998],
            [7.956890679111514, -5.793247414618023],
            [7.957241590387805, -5.7867758766381625],
            [7.9520151590282095, -5.778518978737361],
            [7.949344395532869, -5.770538074189453],
            [7.9508347288421, -5.766426658337709],
            [7.949336737714232, -5.759748470866166],
            [7.950862439438665, -5.748106630887591],
            [7.95471898110373, -5.740224747315132],
            [7.9584141550549115, -5.72623543048969],
            [7.957663879039061, -5.718470729493288],
            [7.958512879819905, -5.715616084507675],
            [7.954247126195246, -5.709252828153561],
            [7.953085003294802, -5.70411930520565],
            [7.95488794866677, -5.697174358659737],
            [7.954418521750245, -5.694597508224483],
            [7.959285765127473, -5.676742129600983],
            [7.961958564704864, -5.671864028009143],
            [7.962238929107503, -5.665314993429434],
            [7.964124818715846, -5.6598109529270095],
            [7.9704995922567266, -5.725831362899703],
            [8.04979579861873, -5.717319116314396],
            [8.053786665938594, -5.717027062903713],
            [8.051590631317232, -5.725218417819822],
            [8.054552212994986, -5.729836290570743],
            [8.059067424585065, -5.733005833286739],
            [8.054677268580042, -5.736940381456694],
            [8.057458156245952, -5.740515611416334],
            [8.06276789745132, -5.75143963917011],
            [8.06151934701599, -5.755617232463938],
            [8.062437038135286, -5.760765246316309],
            [8.064595832876746, -5.762284290033327],
            [8.065802629362917, -5.772199676496694],
            [8.068539565990962, -5.775565331806474],
            [8.069659421694173, -5.782551333128926],
            [8.072287134886846, -5.7872048406072025],
            [8.073110933799128, -5.796378974991811],
            [8.077862630342016, -5.801910825491674],
            [8.075903078956284, -5.8043264960233305],
            [8.07913719935765, -5.811598285678073],
            [8.079083903259058, -5.822356112424577],
            [8.075089288259417, -5.826165034303702],
            [8.075049019350358, -5.842854761810203],
            [8.078785295913942, -5.843068830679778],
            [8.078168532362803, -5.848476441979124],
            [8.086578157564979, -5.857909828226737],
            [8.087286902543157, -5.863868914873266],
            [8.090970057669605, -5.865578936086744],
            [8.091494889016552, -5.8730055817751445],
            [8.097532956738135, -5.881488374371727],
            [8.099607594975831, -5.887474017391707],
            [8.102751761806587, -5.889635010674702],
            [8.102123430823031, -5.893914688092773],
            [8.09962769424757, -5.896542164021872],
            [8.10486171800751, -5.898723076131962],
            [8.105850799623425, -5.902680948645802],
            [8.112090517145234, -5.9076499875746],
            [8.111771027784041, -5.91270577842624],
            [8.114210506284687, -5.918395359053076],
            [8.117647998875315, -5.917582466723061],
            [8.12243217252691, -5.925092644879797],
            [8.117848109965964, -5.932434147596216],
            [8.119851713759566, -5.936576540935926],
            [8.132018122151443, -5.936534172388274],
            [8.13964842266421, -5.942370030121882],
            [8.150983161278749, -5.944876532435698],
            [8.154638190406718, -5.9495694027524815],
            [8.151947172580007, -5.952277090919496],
            [8.145060881813754, -5.953548670345799],
            [8.137951185468046, -5.958981474487363],
            [8.13791561518013, -5.9647025416114055],
            [8.140814217670187, -5.973776352636384],
            [8.14414403295617, -5.97833176874499],
            [8.150311342117051, -5.983688985101268],
            [8.156710150083452, -5.993946952232641],
            [8.167388915809545, -6.000949765446458],
            [8.17569418482657, -6.016688741498491],
            [8.176203520695589, -6.02242865790186],
            [8.174980619134251, -6.025652572217195],
            [8.170708144062402, -6.030783681994545],
            [8.155854833557914, -6.0388084199311916],
            [8.142158945705031, -6.045439211509925],
            [8.143924117613507, -6.064442996687646],
            [8.155230555852226, -6.0644190916274905],
            [8.164674951255936, -6.066704133798467],
            [8.15987262952689, -6.073220442453451],
            [8.155879789368518, -6.0740915893389555],
            [8.151445876290081, -6.080359801890541],
            [8.14708817191273, -6.081783719603581],
            [8.148461418982608, -6.084744970045536],
            [8.146193129401182, -6.08802579095318],
            [8.143456073731805, -6.087158776731846],
            [8.139787460241935, -6.090769585721793],
            [8.141099963723322, -6.094186577242879],
            [8.136698325246362, -6.098076319417804],
            [8.136343240638096, -6.104661714552763],
            [8.139102811226824, -6.108805430346742],
            [8.145157747645422, -6.113305605840609],
            [8.145312146350209, -6.11769097890616],
            [8.153200298465896, -6.1259637966467535],
            [8.155790245722555, -6.126572500285687],
            [8.15763769641363, -6.130377298440774],
            [8.16757970554456, -6.135378621604102],
            [8.177334819320624, -6.137744909737819],
            [8.18445863641598, -6.133116096325738],
            [8.185817879879796, -6.14587977404386],
            [8.176287237856265, -6.146421753001761],
            [8.136094126304782, -6.150543778121719],
            [8.103703581707117, -6.15347373145729],
            [8.106662172294426, -6.1857946758550275],
            [8.108819062804123, -6.201402301890444],
            [8.110653656245763, -6.221811608651839],
            [8.115846733028604, -6.269654060518053],
            [8.121067799150557, -6.319670128052688],
            [8.121830065014791, -6.329451538158165],
            [8.053407537259321, -6.336693664808231],
            [8.043746749364816, -6.337162764198171],
            [7.944283906109981, -6.346910859123932],
            [7.93877844050293, -6.34704029287223],
            [7.894385059619709, -6.351277244547708],
            [7.895251729129555, -6.341051097247732],
            [7.894623938130062, -6.335317355739692],
            [7.8899185477588585, -6.331629921217567],
            [7.886265059512911, -6.3315675062741175],
            [7.881447268329882, -6.328364440949678],
            [7.8801488334272625, -6.323046476638113],
            [7.8818554651246915, -6.317681492987163],
            [7.880266461937091, -6.3150686357770835],
            [7.87568036451253, -6.3159988096948005],
            [7.8744843981247525, -6.312959320076912],
            [7.868538359290779, -6.310060188783844],
            [7.867277225978687, -6.307534174260438],
            [7.863326040334354, -6.310128564630781],
            [7.852056953912339, -6.309032927758886],
            [7.842196335122554, -6.301742186513205],
            [7.842081410260868, -6.299115407877973],
            [7.838432112184674, -6.292443570762999],
            [7.839802535423862, -6.2902429892401805],
            [7.835112568703407, -6.287837885851576],
            [7.831171432152533, -6.28239522181838],
            [7.817528137092997, -6.281677511357082],
            [7.822920198206017, -6.2717757287495655],
            [7.823692119716596, -6.26347705939093],
            [7.819127256329713, -6.265561222837164],
            [7.813821859164285, -6.258887095009078],
            [7.809242159631214, -6.262270340660954],
            [7.801360169344829, -6.260227736203233],
            [7.798956185546848, -6.262918675062926],
            [7.796309715096176, -6.2556661684360995],
            [7.791249660142397, -6.250555323657798],
            [7.788328300666985, -6.242368258078558],
            [7.785907095201143, -6.241071341970267],
            [7.783047017781935, -6.245149089989949],
            [7.7793309440539735, -6.245372798416513],
            [7.777805405949589, -6.239694711448549],
            [7.769410008993236, -6.232413324409765],
            [7.7681082330027795, -6.227933562403377],
            [7.761052802299311, -6.224069972060628],
            [7.759068539451327, -6.22107891000497],
            [7.761254780087391, -6.218350387366736],
            [7.756576611815565, -6.215051550608816],
            [7.751880993390274, -6.213295244838358],
            [7.746873391129817, -6.213843724024725],
            [7.743122979985089, -6.211219387395383],
            [7.737290149790249, -6.211221125221289],
            [7.73524158212536, -6.214947933878398],
            [7.732123029462894, -6.213990606653933],
            [7.72599084282126, -6.217652837354285],
            [7.725618514280042, -6.211387428732483],
            [7.721802004224073, -6.211758200819777],
            [7.715282833829492, -6.205063739395992],
            [7.713981771872655, -6.200629035594951],
            [7.7147346574831905, -6.196629544534549],
            [7.713317306741288, -6.192871513013407],
            [7.701404255048237, -6.192700161121097],
            [7.700495998431344, -6.187976772910927],
            [7.70223444469994, -6.184049792994852],
            [7.699369097185617, -6.182099007535779],
            [7.698275664098253, -6.178334419363921],
            [7.688466256796612, -6.18068869003403],
            [7.683007033689606, -6.180743300124248],
            [7.6781785758201035, -6.1752659163780965],
            [7.67292879577513, -6.173393438063908],
            [7.670881272809558, -6.174427603449143],
            [7.666377096464308, -6.166715674340706],
            [7.660290693996733, -6.164410851946004],
            [7.657198635618815, -6.161217555539499],
            [7.657190923754894, -6.154365335373353],
            [7.650336293738214, -6.151371102989962],
            [7.642461101924774, -6.152929407400191],
            [7.639350151016556, -6.1578072149379075],
            [7.6335599880503615, -6.158511412516798],
            [7.627563555748126, -6.157440433058324],
            [7.62298587568343, -6.115003474827388]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.10648320931413, "lat": 32.3259584189334 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01047"],
        "coty_name": ["Dallas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dallas County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00161549"
      },
      "bbox": [
        7.62298587568343, -6.351277244547708, 8.185817879879796,
        -5.6598109529270095
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.824484879273454, -5.885434622895326],
            [8.829717285292498, -5.88405735403982],
            [8.836638910323865, -5.875399841875157],
            [8.842993039971649, -5.876461492186173],
            [8.846687300859712, -5.874978036464772],
            [8.85012052168206, -5.869593223663511],
            [8.849444079264936, -5.866023346360729],
            [8.845008838051879, -5.860652850836149],
            [8.843936806196448, -5.857456347739187],
            [8.845798770700037, -5.851484087523529],
            [8.84936841907781, -5.851349153003314],
            [8.849799917554764, -5.856981792262343],
            [8.853835251027693, -5.861740389499684],
            [8.858561496771411, -5.860841677066974],
            [8.86233378262492, -5.85500885777636],
            [8.856637572212653, -5.851323645062831],
            [8.858761922147034, -5.847693104842232],
            [8.862315735628613, -5.847790597985278],
            [8.870609309411943, -5.850830472784178],
            [8.874235837064186, -5.857982048794215],
            [8.880046315591036, -5.85832458038153],
            [8.889196830110304, -5.852912236451855],
            [8.897089095901569, -5.8440445761965165],
            [8.90045367824604, -5.843151429999222],
            [8.905094592526758, -5.844896410617104],
            [8.91897937056248, -5.845116130539982],
            [8.923319614692446, -5.844404231191354],
            [8.928896391471861, -5.846659204444529],
            [8.932890601133767, -5.846292366118076],
            [8.940837786866595, -5.843430775580237],
            [8.941801231722973, -5.840976303403006],
            [8.938286523162859, -5.838207238904199],
            [8.940916825041207, -5.833813970208035],
            [8.940399736647878, -5.828758302065681],
            [8.94321001497173, -5.823547827124973],
            [8.944214346897688, -5.818581631901326],
            [8.954514893150856, -5.814989757438476],
            [8.959192139309351, -5.816003476166837],
            [8.960542389146346, -5.813679275780795],
            [8.95793329852149, -5.810566788834321],
            [8.950426726564674, -5.812093997926945],
            [8.945394615117584, -5.810804658742217],
            [8.94042935763985, -5.807858884835425],
            [8.93772995214691, -5.804688976391239],
            [8.930942635032965, -5.800691798738033],
            [8.931897286082108, -5.800673851593387],
            [9.005033121554172, -5.791592963695123],
            [9.000119511908473, -5.752447943216218],
            [8.994484434883317, -5.705316076710746],
            [9.05631686157788, -5.698192308620966],
            [9.065982043258213, -5.696868001779835],
            [9.064387246838704, -5.683050815031553],
            [9.078440814594375, -5.681326621104829],
            [9.080119923395207, -5.695136720240074],
            [9.108739542327767, -5.691729795154427],
            [9.110478294393497, -5.706036155141238],
            [9.1331692591716, -5.714404974722658],
            [9.170221579125272, -5.727694909451919],
            [9.180763079301565, -5.73320524760654],
            [9.194335423013463, -5.7364712542001985],
            [9.222491251113242, -5.746889906923437],
            [9.261378469589099, -5.760972294707906],
            [9.303684840499018, -5.756132863278972],
            [9.308773582643948, -5.7862857954203415],
            [9.309306005960995, -5.791145053389676],
            [9.317193910621791, -5.842457969196791],
            [9.319330384052154, -5.859960900946818],
            [9.32693608193348, -5.934183901375839],
            [9.334945563771608, -6.0011673511219445],
            [9.337153171388746, -6.016512521034251],
            [9.202409491193286, -6.032789666507731],
            [9.154061260671213, -6.037770121916709],
            [9.049251204849524, -6.049257814156002],
            [9.034713692730021, -6.051234557913144],
            [8.98569063252514, -6.057340303994257],
            [8.977995904417913, -6.055321948742085],
            [8.971610384213058, -6.046668328537569],
            [8.96542843135776, -6.044901036133209],
            [8.963402644987301, -6.039366960782294],
            [8.963808779468819, -6.0348731358540855],
            [8.961658835856325, -6.030755544558061],
            [8.961984127646264, -6.024140792226482],
            [8.964530109764945, -6.023697149086371],
            [8.961781843487655, -6.006397586465694],
            [8.959386572743071, -6.000362130233106],
            [8.954533199512792, -5.9973870087381105],
            [8.949397153195543, -5.997115167590347],
            [8.945424392111772, -5.994885557701065],
            [8.943702455743763, -5.988909773019015],
            [8.940392635840555, -5.988661738908608],
            [8.943741055470838, -6.018654530664585],
            [8.926573460075334, -6.021082295741649],
            [8.926609227570145, -6.017789972825757],
            [8.921944921464718, -6.0129472005605304],
            [8.912028678715313, -6.010098201370167],
            [8.907363825788973, -6.0099789193689706],
            [8.9036295892314, -6.004572341042325],
            [8.899732894727858, -6.002693525345443],
            [8.898770556602024, -5.999935775781693],
            [8.8943250292404, -5.996515040405099],
            [8.893356772011037, -5.990988894011006],
            [8.89091849805722, -5.987064541756019],
            [8.891627795531717, -5.982538625056671],
            [8.88892694944597, -5.981445042108494],
            [8.888131805242208, -5.9752638701826815],
            [8.88215782594162, -5.975045079483662],
            [8.878646368954898, -5.966654364309052],
            [8.86223251318922, -5.967295103949841],
            [8.858181090231149, -5.9623729077795415],
            [8.859585454634708, -5.960677837283084],
            [8.855058486218645, -5.950773836242787],
            [8.855543449977997, -5.944594158201423],
            [8.84983038445743, -5.940615182827953],
            [8.845991492156772, -5.931827508265702],
            [8.835158414121187, -5.9187081171848215],
            [8.837263834785379, -5.914733282399683],
            [8.834350230064954, -5.907364933576891],
            [8.83621581642572, -5.899961637299981],
            [8.832571665819854, -5.895390968037775],
            [8.827831036331187, -5.895097609482204],
            [8.824484879273454, -5.885434622895326]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.6926677150458, "lat": 32.38592935402728 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01087"],
        "coty_name": ["Macon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macon County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00161569"
      },
      "bbox": [
        8.824484879273454, -6.057340303994257, 9.337153171388746,
        -5.681326621104829
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.510681977026298, 2.5696206766964087],
            [-19.505242092835445, 2.567608574885971],
            [-19.500001516124197, 2.5693755064573702],
            [-19.49749351167647, 2.567078053532276],
            [-19.483875522281956, 2.562861025515996],
            [-19.47472378221855, 2.5637829066137394],
            [-19.46610752424602, 2.5490732378358034],
            [-19.465587318603138, 2.5419599288388004],
            [-19.461400977572247, 2.53506977924147],
            [-19.453377682615827, 2.528160847128485],
            [-19.44807674105638, 2.526708567103262],
            [-19.4456782738503, 2.528665900406719],
            [-19.43908686068609, 2.5307825651281397],
            [-19.433497702861875, 2.5343802452794018],
            [-19.429385471543753, 2.5342849782187904],
            [-19.418029324376697, 2.5382772449954185],
            [-19.413962529926867, 2.5428554770896636],
            [-19.410478195400085, 2.5440222953305778],
            [-19.407173465701636, 2.547621845141483],
            [-19.390062682978403, 2.5501647669195107],
            [-19.383001183047053, 2.5547768509347963],
            [-19.37284009126869, 2.548082447456875],
            [-19.360673617531294, 2.544548289788824],
            [-19.353581275416367, 2.545502780022392],
            [-19.348296795787775, 2.5451284511332006],
            [-19.343102838805645, 2.5482769866581587],
            [-19.323740067219408, 2.543464162404251],
            [-19.313867082875987, 2.5388579815458323],
            [-19.30765258518474, 2.5337390379082003],
            [-19.303606500550945, 2.5288244947960945],
            [-19.29819849944277, 2.526836242867782],
            [-19.29026898464153, 2.521202203482681],
            [-19.28696329576659, 2.521183187424049],
            [-19.276478467944806, 2.5183303907578547],
            [-19.270527252083895, 2.5126249671303102],
            [-19.264114203528454, 2.5180030428827065],
            [-19.257264808368628, 2.518647937435086],
            [-19.256238594294715, 2.5129528312108573],
            [-19.254314923065834, 2.511034474202753],
            [-19.247000468101042, 2.5129584989201916],
            [-19.240852536793124, 2.512635398884274],
            [-19.231328010957533, 2.5170601635410166],
            [-19.219105050881687, 2.5107575846461776],
            [-19.21249094489302, 2.5118392278479185],
            [-19.209095686765377, 2.5084844950062837],
            [-19.205840650416878, 2.4992373595440944],
            [-19.201418382583576, 2.497622352253806],
            [-19.20292853571479, 2.4935579045600096],
            [-19.212890785610117, 2.459511820868289],
            [-19.211281711904284, 2.4590547910140628],
            [-19.25014209400215, 2.319687901356276],
            [-19.254502560152552, 2.3056226167362444],
            [-19.258222170944507, 2.290772435489266],
            [-19.257599167743198, 2.2898586355105834],
            [-19.200829420015143, 2.273533789774219],
            [-19.183178558507407, 2.2686063601318995],
            [-19.18806800967046, 2.266608413709132],
            [-19.187992825050422, 2.263743648467751],
            [-19.191258312345205, 2.2587197147888114],
            [-19.196667313213187, 2.2545268859127017],
            [-19.19750883613868, 2.247880639136498],
            [-19.199547619330136, 2.244891384020238],
            [-19.19788882164126, 2.237399331465662],
            [-19.20277334836589, 2.2290148238786287],
            [-19.203256194718502, 2.2162870367558916],
            [-19.20601219137631, 2.2114039963526233],
            [-19.214953546281354, 2.180355676224037],
            [-19.22113086801664, 2.1741710771435234],
            [-19.22539296158926, 2.168464149465613],
            [-19.22766591534061, 2.1625683891034693],
            [-19.231325109583103, 2.1590014090375496],
            [-19.236352179349726, 2.1581718989265815],
            [-19.244031860054655, 2.1611208666410193],
            [-19.252893196981606, 2.15902005829926],
            [-19.256617516751234, 2.1563681302564444],
            [-19.264491052073993, 2.154984840098832],
            [-19.270675619367545, 2.15539779745728],
            [-19.28888276908677, 2.1404812004982743],
            [-19.293664279943805, 2.1385513643515863],
            [-19.298725919190097, 2.126469817437465],
            [-19.30289373946221, 2.120132520989318],
            [-19.305715814346858, 2.114056138115743],
            [-19.31535545804167, 2.1021293139456754],
            [-19.322257877329847, 2.096366598695849],
            [-19.325050281535177, 2.090096720206349],
            [-19.32921853173585, 2.076957019751818],
            [-19.33240744132874, 2.072611840786861],
            [-19.335214674386346, 2.071350863801305],
            [-19.34596061701092, 2.0720480941532653],
            [-19.349169644619625, 2.073221923612138],
            [-19.356448159476447, 2.0800536994379084],
            [-19.36761570962022, 2.0762848543785357],
            [-19.377267583046013, 2.0740214750091317],
            [-19.40356392368488, 2.0655091866007016],
            [-19.40786987769013, 2.065298940310032],
            [-19.414413985433356, 2.0684437010401915],
            [-19.42578273977889, 2.0773239353545283],
            [-19.431834876223803, 2.088681200285391],
            [-19.43445297075579, 2.0906677849502353],
            [-19.439102121714456, 2.089415426263243],
            [-19.446526387797356, 2.0891213209139803],
            [-19.45008248015952, 2.0879336081128743],
            [-19.451778837444834, 2.0843656313823606],
            [-19.45365987472593, 2.0810670763767645],
            [-19.460279082526327, 2.0745659330280777],
            [-19.46517024920838, 2.0720139054198685],
            [-19.47740048710885, 2.0712160305094556],
            [-19.493312491923074, 2.073877483481153],
            [-19.504669177287617, 2.078642125522572],
            [-19.51125820593787, 2.0829146851340656],
            [-19.518658497134584, 2.0892698981098734],
            [-19.527943423247926, 2.1007586953521935],
            [-19.534368666765342, 2.106931346817655],
            [-19.54205450572221, 2.110928050620997],
            [-19.567129372042935, 2.1139592849868483],
            [-19.578236577177858, 2.1125787812151806],
            [-19.583851408719422, 2.115218138864155],
            [-19.59445621998732, 2.118190669281858],
            [-19.601970055681296, 2.122334923314821],
            [-19.60718311348808, 2.1216409581257922],
            [-19.61531986336984, 2.118203156923379],
            [-19.626013765199538, 2.116469993408676],
            [-19.63422550991059, 2.116021924124971],
            [-19.650979922239223, 2.112227108432804],
            [-19.65568468266236, 2.110136800879978],
            [-19.66892011410403, 2.109773289331804],
            [-19.675959692387057, 2.11128056381509],
            [-19.683834483029486, 2.115261982999669],
            [-19.68884939860893, 2.120160993401172],
            [-19.692252767399275, 2.132805853124169],
            [-19.696327386831932, 2.1403891459762825],
            [-19.708636488991306, 2.1481912621036496],
            [-19.727453774365078, 2.156749882611685],
            [-19.738830054271265, 2.1626855803738265],
            [-19.755831274942707, 2.1634352940987798],
            [-19.75895590287005, 2.1647596539110823],
            [-19.760943510176705, 2.172265609761966],
            [-19.762607574906642, 2.1894511545118385],
            [-19.77178669322182, 2.213411142996216],
            [-19.780405945092365, 2.2250788805654347],
            [-19.797423428063542, 2.244430019011382],
            [-19.80751653498381, 2.2549505052260406],
            [-19.82888471824995, 2.271820831061503],
            [-19.832465572059782, 2.272159356442205],
            [-19.835395225952077, 2.286458656962538],
            [-19.815483928646653, 2.280988600940883],
            [-19.751700935200716, 2.262225429918101],
            [-19.73266337377117, 2.2570365656865445],
            [-19.690896470593508, 2.2447480247628406],
            [-19.677207735703103, 2.2409212268491605],
            [-19.678608792099457, 2.2458346766366892],
            [-19.673516337040645, 2.250292967467888],
            [-19.67554337333506, 2.254717385465544],
            [-19.678902862486247, 2.2556658962463363],
            [-19.678251985197303, 2.2590965530445675],
            [-19.6835953046593, 2.2633242809218563],
            [-19.68515992871512, 2.2683860895080383],
            [-19.682353916677982, 2.273091716364506],
            [-19.682765703053192, 2.277932364657339],
            [-19.678252328187696, 2.277757145933718],
            [-19.67796524620273, 2.2815727173222964],
            [-19.673572774996966, 2.2832198032693425],
            [-19.67134061913, 2.290363234528131],
            [-19.66309323356204, 2.29663794724139],
            [-19.659984173412823, 2.2976006706122685],
            [-19.660072690032237, 2.3035784458081436],
            [-19.65736862336813, 2.3048338914299484],
            [-19.65706850958188, 2.3166681481550215],
            [-19.65843175559275, 2.324953374881065],
            [-19.662098083030212, 2.329889470854342],
            [-19.66400454402369, 2.3353013331399373],
            [-19.662282189878226, 2.33913663327434],
            [-19.65762172816234, 2.334077701693054],
            [-19.6497255174028, 2.3349833727456315],
            [-19.64782633999832, 2.3398918131659103],
            [-19.650093695209105, 2.3421535632315624],
            [-19.66087965362864, 2.3458033690659432],
            [-19.663518652650207, 2.3496985815542923],
            [-19.658657349134295, 2.3578114952501505],
            [-19.64631607813669, 2.355872556259835],
            [-19.644554686841012, 2.3532410611944803],
            [-19.6399448885004, 2.3526118140923082],
            [-19.64077631650366, 2.3602995350119347],
            [-19.643545324435106, 2.3675953857453043],
            [-19.645172840590163, 2.3769228082397027],
            [-19.639628342268846, 2.3842136938284333],
            [-19.641557499884566, 2.3879684527842198],
            [-19.638871119754782, 2.3919516326051466],
            [-19.640974782024596, 2.394914834419813],
            [-19.641160265066382, 2.399013523446218],
            [-19.63284654243248, 2.3969626891611897],
            [-19.535375276921066, 2.3696238660303113],
            [-19.536818123029075, 2.372803807752567],
            [-19.533816458207372, 2.376825339438065],
            [-19.530382008149857, 2.378443568280016],
            [-19.529454566923736, 2.386424030184913],
            [-19.531582320323384, 2.3931042194193943],
            [-19.531028201082457, 2.4024976566999814],
            [-19.529368576040323, 2.4046492047664025],
            [-19.5304821440564, 2.4110758262431125],
            [-19.529412201207542, 2.4156046079982287],
            [-19.53191175495338, 2.4188585589166633],
            [-19.533894632255905, 2.431255708883251],
            [-19.53357662896524, 2.436811394136918],
            [-19.536395139800902, 2.446007169176795],
            [-19.544484590234593, 2.4650356405210276],
            [-19.543858635148254, 2.467946217229449],
            [-19.545775683898032, 2.475082157312504],
            [-19.548044006986956, 2.475994600936633],
            [-19.550640809901065, 2.490839931876512],
            [-19.5485947300906, 2.4991929184502086],
            [-19.542403269663637, 2.5116910698440558],
            [-19.539518439831557, 2.515108741033075],
            [-19.536280229337837, 2.5216635598511523],
            [-19.531396461710695, 2.527910030281502],
            [-19.527824599295354, 2.53442224813596],
            [-19.525628582257767, 2.536210312932201],
            [-19.521195261728746, 2.5441737131998154],
            [-19.517609991404544, 2.5477905619724317],
            [-19.518124852972228, 2.5519548458742403],
            [-19.51513168341918, 2.5581268948495057],
            [-19.513204735994993, 2.5656775133688003],
            [-19.510681977026298, 2.5696206766964087]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.93286953932397,
          "lat": 38.269996917365674
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06095"],
        "coty_name": ["Solano"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Solano County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00277312"
      },
      "bbox": [
        -19.835395225952077, 2.065298940310032, -19.183178558507407,
        2.5696206766964087
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.768909341716991, 0.08342965625942356],
            [-5.726495720512996, 0.0801777420667215],
            [-5.686884438296233, 0.07736365931359213],
            [-5.63112978349875, 0.07224059565806991],
            [-5.628946098831286, 0.07139559180305162],
            [-5.556810739972203, 0.06509194641993406],
            [-5.549733697052487, 0.06489776232364947],
            [-5.510379438751017, 0.06132323024519914],
            [-5.499701446705475, 0.0609249590628923],
            [-5.478597397754567, 0.0591626813808685],
            [-5.428426930987135, 0.05546057518140263],
            [-5.428798763123735, 0.05076062410773869],
            [-5.345252780317181, 0.0426130867599837],
            [-5.346549623499233, 0.026095507819143743],
            [-5.347707018258541, 0.017354298691380263],
            [-5.360919702958834, -0.1325545649158372],
            [-5.356860886660657, -0.13283619887625203],
            [-5.358166745621659, -0.15086376606207105],
            [-5.3630270820084585, -0.21062866822460447],
            [-5.369390774954455, -0.21106205678410983],
            [-5.376290480630369, -0.30328005378822964],
            [-5.433579939692685, -0.29847974879824074],
            [-5.447527033512981, -0.29841076380708176],
            [-5.461678220272403, -0.2975427052903237],
            [-5.466290376397136, -0.356030838860361],
            [-5.508698439724857, -0.3530665807500385],
            [-5.566080640219575, -0.34822788390827275],
            [-5.568425431774659, -0.3478974813051683],
            [-5.609140304919807, -0.3452486151228171],
            [-5.6121457314391545, -0.3410831332216412],
            [-5.617068725590671, -0.33964518758336476],
            [-5.622793962726302, -0.3426850890848535],
            [-5.62892289832568, -0.3417163234737041],
            [-5.634374268111784, -0.34235025608220376],
            [-5.638754949988527, -0.3379290727785168],
            [-5.641763048800555, -0.33154094901685754],
            [-5.644827942201045, -0.32962250875984633],
            [-5.651012777602223, -0.32872823953743346],
            [-5.654788511050306, -0.3257331218560219],
            [-5.658749831651209, -0.3246577433992491],
            [-5.666339761881698, -0.32824281289657237],
            [-5.683868583196869, -0.3260143577799162],
            [-5.681719770099858, -0.32039422996192624],
            [-5.684238626575782, -0.31730355065311155],
            [-5.692313588616102, -0.31625426032140597],
            [-5.693332378447613, -0.3189274898057384],
            [-5.691781731832305, -0.3241852635355081],
            [-5.697850463785117, -0.3247133182690642],
            [-5.7010978974644475, -0.3194950069502433],
            [-5.709824147575211, -0.32485243831106275],
            [-5.717859255406614, -0.32187940581384716],
            [-5.722751099451537, -0.31790543857226145],
            [-5.7296312757891545, -0.3171285560879748],
            [-5.740526086942788, -0.3144721793736452],
            [-5.742339206297047, -0.3120608672093362],
            [-5.739781301992833, -0.3079397949785477],
            [-5.742388106468159, -0.3052468804911448],
            [-5.747414756428103, -0.30497985464818406],
            [-5.755063567764224, -0.29851854820623086],
            [-5.760212884753357, -0.30145070843077265],
            [-5.767193968586048, -0.2984240732761342],
            [-5.771194337039393, -0.301053278690809],
            [-5.777201693135724, -0.30246565393486197],
            [-5.7854055286660335, -0.30211259597233536],
            [-5.79613666550258, -0.30037974452909044],
            [-5.79830413818079, -0.29496641093980175],
            [-5.804389675014668, -0.29450723636150056],
            [-5.794735149269214, -0.17944102238845092],
            [-5.791798843790211, -0.1786537669195867],
            [-5.769357100960651, 0.08064838563644113],
            [-5.768909341716991, 0.08342965625942356]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.78447679352006,
          "lat": 38.32657924099597
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08025"],
        "coty_name": ["Crowley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crowley County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00198128"
      },
      "bbox": [
        -5.804389675014668, -0.356030838860361, -5.345252780317181,
        0.08342965625942356
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.136153439465636, -9.209195357570854],
            [12.24219026234242, -9.193783169512251],
            [12.358972110591436, -9.177056220110238],
            [12.363583002509083, -9.2052303197279],
            [12.413961265040667, -9.198003666155783],
            [12.446188390418557, -9.192505117219184],
            [12.493392113633742, -9.185677421850103],
            [12.497960385980727, -9.184305294927556],
            [12.494548501550906, -9.1895994413503],
            [12.489429429232628, -9.192451212195818],
            [12.489362791372338, -9.19692603443581],
            [12.493991164273694, -9.202269809413334],
            [12.497322533155462, -9.203814357087863],
            [12.506604932877412, -9.204954573332852],
            [12.504530887405757, -9.20828014628491],
            [12.504451101598622, -9.21413237432106],
            [12.513011446247782, -9.220469710894742],
            [12.516133126406613, -9.219291105593138],
            [12.519145792515365, -9.224008434155696],
            [12.519347612237516, -9.228596371906756],
            [12.522558320938952, -9.232183961514774],
            [12.53155123329234, -9.238183206000814],
            [12.534028261229588, -9.246184928859758],
            [12.537525779631466, -9.245208478977673],
            [12.544702075462201, -9.251640974886248],
            [12.544345012066005, -9.253146640221008],
            [12.548288201817671, -9.261659829106273],
            [12.554181248457432, -9.268067099334917],
            [12.559483096160664, -9.27059595500281],
            [12.567447843186832, -9.268389814882942],
            [12.569095588492983, -9.265590051964692],
            [12.5779151841949, -9.26757413640199],
            [12.581824737524443, -9.271209519709497],
            [12.586879476687876, -9.270264991321564],
            [12.591795485498062, -9.272166917892697],
            [12.595028989849476, -9.270494913761862],
            [12.59810570827161, -9.272924297979062],
            [12.599952871971254, -9.26881902264781],
            [12.60390819073233, -9.266073667760434],
            [12.604595651896009, -9.262786957496504],
            [12.609950981774988, -9.264093767927317],
            [12.61660011060493, -9.268444748956929],
            [12.621526503711591, -9.268131830801387],
            [12.624509029877919, -9.27295194286219],
            [12.63061628976229, -9.285823598506505],
            [12.641630029962, -9.289889628219154],
            [12.647140743375655, -9.285768142690717],
            [12.64958354591965, -9.285637258107286],
            [12.655057543036468, -9.293946911093348],
            [12.661302961325806, -9.298813702054083],
            [12.66351815439163, -9.30262193055706],
            [12.667823158410027, -9.303476802899082],
            [12.672019738287343, -9.301507782960197],
            [12.672581387714734, -9.298999594172656],
            [12.677013130065873, -9.297331432681082],
            [12.683529159041056, -9.293001541241367],
            [12.687659186520175, -9.292442661614475],
            [12.69673010168422, -9.297139238119113],
            [12.700725413096116, -9.30055876514829],
            [12.7067969828632, -9.342436781058309],
            [12.621296457852603, -9.354831527076518],
            [12.581507282275084, -9.360499029822615],
            [12.534817940244265, -9.366940273011538],
            [12.533653073210175, -9.367409081842146],
            [12.539804228020062, -9.409955965031472],
            [12.481471241876507, -9.418294273103388],
            [12.437563386317585, -9.425344890129699],
            [12.365923205754754, -9.43582332110358],
            [12.300440335335853, -9.445077331645823],
            [12.236976971620757, -9.453818468434923],
            [12.176574434913253, -9.462584543265988],
            [12.174381556621956, -9.460373502317337],
            [12.174673764989958, -9.455846170768595],
            [12.17770588318219, -9.45382495924513],
            [12.17633854856223, -9.447711970386845],
            [12.178586749734908, -9.443948340858046],
            [12.175063750891415, -9.440646728082738],
            [12.169515413843703, -9.440008140552278],
            [12.16841551987063, -9.438112011698832],
            [12.163542116686468, -9.437336354406217],
            [12.163442982466618, -9.431925794217024],
            [12.171637321095739, -9.428726691627276],
            [12.173499778079636, -9.421252539294496],
            [12.172109930749727, -9.41908358106986],
            [12.173700232353976, -9.41244009891818],
            [12.173603099138104, -9.408125823777445],
            [12.169010718435386, -9.403683260594763],
            [12.17073660410242, -9.40003431644053],
            [12.166980844644703, -9.39713898480121],
            [12.160167670051715, -9.399516078048325],
            [12.167088005586104, -9.39024808999063],
            [12.16587039925211, -9.386898596985585],
            [12.164952156785178, -9.378424321588177],
            [12.16499143540623, -9.370147331832344],
            [12.175818528455645, -9.36411647364415],
            [12.176983597265163, -9.358971753047419],
            [12.172564408294482, -9.352572364875378],
            [12.16612460424007, -9.347549003278294],
            [12.166942029730041, -9.344080189102224],
            [12.171186788407505, -9.343586828130091],
            [12.175385526333447, -9.34486961912682],
            [12.175751303831731, -9.340044657230544],
            [12.169235226379756, -9.329296144310488],
            [12.168710527540961, -9.322715485905047],
            [12.17695786290428, -9.316506905069627],
            [12.177894214170301, -9.312684554289662],
            [12.173125464130203, -9.309925920626783],
            [12.173677310765939, -9.306762830218753],
            [12.167094909031958, -9.30611673186477],
            [12.163996547667939, -9.293546657984765],
            [12.157983314045248, -9.293069205249685],
            [12.16538174967041, -9.28528392869396],
            [12.165587577805441, -9.282496989718636],
            [12.158989193442583, -9.27752375327982],
            [12.153690066049323, -9.277397105964145],
            [12.153039319387485, -9.274115769356758],
            [12.148370876085808, -9.27251528227721],
            [12.145009105969859, -9.260548355658823],
            [12.147866511253083, -9.25738474083207],
            [12.148406993820531, -9.25378184612712],
            [12.138904263213849, -9.247843474647285],
            [12.140143295251114, -9.241498843213204],
            [12.146224157782935, -9.238523547159343],
            [12.144138193718987, -9.232798035893468],
            [12.150814449907138, -9.23373388163196],
            [12.155765095397099, -9.225574296776148],
            [12.154978687480268, -9.22008219951573],
            [12.150343772142838, -9.218654112058609],
            [12.143358552139821, -9.218913562137368],
            [12.144092263108144, -9.213301900653278],
            [12.14285815165909, -9.210569414258975],
            [12.136153439465636, -9.209195357570854]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.42401167317412, "lat": 28.553665157249 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12053"],
        "coty_name": ["Hernando"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hernando County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00295751"
      },
      "bbox": [
        12.136153439465636, -9.462584543265988, 12.7067969828632,
        -9.177056220110238
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.950758048127003, -10.998543488954526],
              [13.065113555843773, -10.98223099118795],
              [13.129766715667476, -10.972904552029004],
              [13.216843373649708, -10.960327444720601],
              [13.304878036169322, -10.947225843749505],
              [13.390148285501795, -10.934463720791152],
              [13.398488985279359, -10.992443912416771],
              [13.40899717045525, -11.055429571886686],
              [13.422070943027451, -11.132422849640633],
              [13.430407911001563, -11.181020615907855],
              [13.445326817440025, -11.267569225062045],
              [13.4451365068398, -11.268128373433456],
              [13.358826967324475, -11.282559429364948],
              [13.375696805912762, -11.381886198293737],
              [13.296928848691358, -11.394246819800602],
              [13.258623385621163, -11.40051691598262],
              [13.231922532707419, -11.404491030453302],
              [13.229742569274311, -11.390870941241568],
              [13.205929980719253, -11.394418429169589],
              [13.194746838894938, -11.376269741452711],
              [13.185442190919963, -11.36413050202959],
              [13.185394194554647, -11.36244215880318],
              [13.17809940625506, -11.351045517496656],
              [13.170145567975174, -11.344021727236465],
              [13.16219777822514, -11.33832098213005],
              [13.160483815349917, -11.334866382069588],
              [13.162648302772178, -11.33168958883687],
              [13.160516949024398, -11.329022974036622],
              [13.152178875660638, -11.33027921374679],
              [13.144100886006335, -11.324107799454454],
              [13.142070719461667, -11.318535930934162],
              [13.138068200613455, -11.313417040903175],
              [13.131490609944798, -11.307966643772518],
              [13.120815872811804, -11.302383277707872],
              [13.10637683954278, -11.296231255426216],
              [13.089437060393848, -11.291297778173641],
              [13.081824160091237, -11.287855825165092],
              [13.076078672054768, -11.28213100453191],
              [13.078004118835159, -11.280248542560836],
              [13.083743536246676, -11.28528357459846],
              [13.08971425828099, -11.285197226937411],
              [13.086910906494984, -11.27744267364218],
              [13.074030900264928, -11.270015521865954],
              [13.0633857721762, -11.267187096762022],
              [13.04827459678497, -11.265551640841275],
              [13.037730725452434, -11.267876637520338],
              [13.033970115206547, -11.265643067255956],
              [13.034685500261933, -11.258927375367708],
              [13.037352954562955, -11.255054422555082],
              [13.035657861139384, -11.250415666141276],
              [13.035722006969024, -11.246275614588088],
              [13.032492820150363, -11.24023113607526],
              [13.032408611416587, -11.233210407419943],
              [13.041065475988935, -11.225744157880639],
              [13.040315615643241, -11.219606917933522],
              [13.033130450678987, -11.218990240234676],
              [13.025560134922415, -11.22557477364856],
              [13.016229749148671, -11.225465349485527],
              [13.005133290288493, -11.231684924235534],
              [13.003558785837612, -11.225421554019114],
              [13.000205568761377, -11.225489877484772],
              [13.000033115684223, -11.221874748733889],
              [12.997731664167759, -11.218800665896604],
              [12.991609630241213, -11.217320782262503],
              [12.98762907575316, -11.212176137061393],
              [12.984569535868662, -11.212272209867136],
              [12.976489345710824, -11.226207463225695],
              [12.975787247290013, -11.235934721610535],
              [12.980300224264502, -11.247208673726114],
              [12.986506521311503, -11.256773431206868],
              [12.99306417741811, -11.261473540868218],
              [12.99355782018659, -11.264749954846685],
              [12.980474633262816, -11.267819549456508],
              [12.968302565678528, -11.272591912323971],
              [12.959988226046537, -11.27926610551061],
              [12.951454729170504, -11.280498732236124],
              [12.949636371433158, -11.27342107609336],
              [12.95182114312435, -11.264937656698137],
              [12.95207794337613, -11.254010931924801],
              [12.943828010672258, -11.250805599745227],
              [12.945277479797392, -11.247669355305623],
              [12.949544917407819, -11.245797613945978],
              [12.946628289520554, -11.242243962960627],
              [12.939472487376305, -11.239301199362242],
              [12.937313321804941, -11.235010057654438],
              [12.93587203588401, -11.226848498063088],
              [12.926184896051158, -11.214228868640642],
              [12.921950127096506, -11.201868321300001],
              [12.920529271937273, -11.188056600401222],
              [12.922597551914983, -11.184954151297383],
              [12.920284972211215, -11.180989530991438],
              [12.917444046899517, -11.180685714595565],
              [12.909731860827698, -11.16226199779176],
              [12.903463862136835, -11.160811832989632],
              [12.896698215110172, -11.151745706767414],
              [12.892260387369726, -11.140881493060824],
              [12.894581651479447, -11.136154256516967],
              [12.895472092218855, -11.131134761334591],
              [12.887419263971292, -11.122248031342258],
              [12.87090695744541, -11.109677774290635],
              [12.866937619902398, -11.103114623020861],
              [12.860947535647352, -11.10209311371384],
              [12.855284637759464, -11.09969680711897],
              [12.852407938867932, -11.094119025361259],
              [12.851581369269661, -11.08712775895748],
              [12.85872887977489, -11.075644546205039],
              [12.872447883060126, -11.07199855991665],
              [12.878671971597882, -11.074249208300422],
              [12.89009718277365, -11.073735723699082],
              [12.902366495879072, -11.075364294526475],
              [12.91741533372164, -11.090820442834234],
              [12.9244235355865, -11.103888922017996],
              [12.927035046692327, -11.105389539069497],
              [12.928362104268112, -11.116220871356004],
              [12.934005636874982, -11.123562340710976],
              [12.943770727682239, -11.120895800150013],
              [12.947927690459858, -11.114018738206441],
              [12.937766309357784, -11.102519503954749],
              [12.939249557277222, -11.084192396396762],
              [12.938285770201356, -11.067342071065191],
              [12.940809007277387, -11.052818353028133],
              [12.948823972570093, -11.026166883532449],
              [12.950758048127003, -10.998543488954526]
            ]
          ],
          [
            [
              [12.828735501893727, -11.181094048133195],
              [12.831820387386825, -11.176543329361728],
              [12.837406105439646, -11.179804762010336],
              [12.84729596336779, -11.19739742423656],
              [12.857085950775101, -11.218310739010887],
              [12.859637611900677, -11.225266085074338],
              [12.865942404847745, -11.234089060099901],
              [12.868291268206676, -11.239550693867942],
              [12.87242558970726, -11.252927933920084],
              [12.881435986533077, -11.262513064959101],
              [12.88214953122438, -11.26878081125366],
              [12.886662115339671, -11.276416723685054],
              [12.885241420506476, -11.279836153643625],
              [12.893908314197605, -11.280521663634715],
              [12.894842909510071, -11.284908809958456],
              [12.899245020066523, -11.286372926961215],
              [12.90265950403603, -11.285364575701859],
              [12.903487290611933, -11.289333163153607],
              [12.908612741147357, -11.289718088259415],
              [12.91337263792708, -11.292209947987406],
              [12.92171855415863, -11.291303384079951],
              [12.928238738937301, -11.28862903337591],
              [12.940122335708157, -11.292313572353176],
              [12.971007241199004, -11.305949919953378],
              [12.979689214884191, -11.293949863999881],
              [12.988872423162837, -11.29263538730268],
              [12.99193332864017, -11.288218188710221],
              [13.013059442021737, -11.29686408087919],
              [13.021578007482201, -11.30108010761789],
              [13.031910865303493, -11.299160532775893],
              [13.036048068088965, -11.2968409272685],
              [13.037967371653753, -11.29931618504307],
              [12.997907294435036, -11.331288753464689],
              [12.987773301291053, -11.336099111934141],
              [12.980718965960994, -11.337119508728438],
              [12.966726469210935, -11.336290178370245],
              [12.939593186929047, -11.32907431072168],
              [12.917145927339869, -11.313447674363545],
              [12.893786211398133, -11.304809164691454],
              [12.885587493905334, -11.29753014903746],
              [12.8786154495723, -11.285781057274125],
              [12.8594019188545, -11.232708500348332],
              [12.856095532526885, -11.227863922238482],
              [12.855631367453206, -11.223081844811526],
              [12.850468819682682, -11.212390676304738],
              [12.841303453983933, -11.201912111067495],
              [12.83429501058218, -11.19898686796957],
              [12.829788839301228, -11.190437045100586],
              [12.828735501893727, -11.181094048133195]
            ]
          ],
          [
            [
              [12.782904469865992, -11.107838443634284],
              [12.785925877933689, -11.1034350201113],
              [12.785974699995405, -11.08774647956891],
              [12.790505738148207, -11.083335221736508],
              [12.794346460379794, -11.084459099386757],
              [12.798858222623746, -11.093012943900424],
              [12.797350049950156, -11.097410551494718],
              [12.797808899562886, -11.10340831368952],
              [12.80083704812381, -11.107785010145554],
              [12.809125629316167, -11.111199067917148],
              [12.807258233208776, -11.1189941986942],
              [12.807354443912578, -11.125462424063626],
              [12.811564717361705, -11.131970787135986],
              [12.813868783676234, -11.137286767487895],
              [12.819045640861006, -11.141564224373573],
              [12.820534789722327, -11.14867082473152],
              [12.825597384298389, -11.157984046488474],
              [12.830288388479529, -11.158985425768845],
              [12.829388084830097, -11.166016123528268],
              [12.827272946869305, -11.170199895799374],
              [12.821834285779403, -11.158227592938271],
              [12.817584689222313, -11.151362047780987],
              [12.81300214439034, -11.148912272487602],
              [12.803194135158105, -11.134925451162982],
              [12.798745890992954, -11.12754518606219],
              [12.792501534102906, -11.122986708633354],
              [12.783815747814641, -11.113981840001577],
              [12.782904469865992, -11.107838443634284]
            ]
          ],
          [
            [
              [12.75926305314631, -11.007266882239922],
              [12.765871962329456, -11.006410351896207],
              [12.786007365165865, -11.007167022931604],
              [12.794121349065037, -11.008486443269716],
              [12.804536439238827, -11.008209395385483],
              [12.808663368725831, -11.009785436153514],
              [12.818114571552151, -11.016375011285033],
              [12.82516679367591, -11.016306751562452],
              [12.822143640991953, -11.022980979543291],
              [12.817563709673081, -11.020047008814446],
              [12.808307462894374, -11.0228744508097],
              [12.798787736194374, -11.019848394008639],
              [12.782816327113382, -11.030077882964193],
              [12.78113220821018, -11.039098331742892],
              [12.781289404837331, -11.047438363388927],
              [12.779035788252733, -11.06500796218489],
              [12.781248946448299, -11.074099658118744],
              [12.778653151514103, -11.07584230292564],
              [12.776141711796958, -11.073170871131117],
              [12.775770715841457, -11.06782518134753],
              [12.770528320928454, -11.037852637966605],
              [12.76226219531869, -11.011610459308768],
              [12.75926305314631, -11.007266882239922]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.83321509454969,
          "lat": 26.578026592319066
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12071"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00295758"
      },
      "bbox": [
        12.75926305314631, -11.404491030453302, 13.445326817440025,
        -10.934463720791152
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.157420108716561, -7.571790034017461],
            [9.156371068733385, -7.567762779445399],
            [9.159859274023553, -7.563157006132468],
            [9.15986912926228, -7.557383779316475],
            [9.166140609245518, -7.550963999576562],
            [9.170650532172575, -7.548238689999882],
            [9.168117069852658, -7.543935436331596],
            [9.170002881141404, -7.535366811895498],
            [9.165725776699604, -7.533477232792314],
            [9.168135880275456, -7.529421892312799],
            [9.167564904818864, -7.527001555537246],
            [9.162680946999398, -7.5256972616363695],
            [9.166387929397056, -7.521741665696931],
            [9.162293053204174, -7.517341213839846],
            [9.162053368336348, -7.514165665831257],
            [9.164882345825058, -7.511952935796868],
            [9.162535372445923, -7.505844541477496],
            [9.164890296929887, -7.497646529178878],
            [9.1705568683412, -7.494475153354721],
            [9.172669295437968, -7.489542752167952],
            [9.167475383110844, -7.4831045756972685],
            [9.226962331859518, -7.477906984658047],
            [9.228419147586916, -7.491653475788909],
            [9.242830848535226, -7.490519481217512],
            [9.245235333856312, -7.515360391290515],
            [9.24515886156253, -7.519186825704809],
            [9.251411707866342, -7.519011415311752],
            [9.288730322544614, -7.516279649419163],
            [9.29125845857442, -7.515744560489196],
            [9.332974296309525, -7.5116592731220155],
            [9.345170727517473, -7.510877166941995],
            [9.34380127032833, -7.500421512867981],
            [9.341576408281004, -7.491320408726946],
            [9.341336514350813, -7.483421226316219],
            [9.344241568412253, -7.478588055958763],
            [9.345300327531929, -7.4720533205440045],
            [9.349666960637046, -7.462280966427139],
            [9.35280779419712, -7.457636305117542],
            [9.353008890804423, -7.448279577770438],
            [9.354495064837282, -7.439612681677879],
            [9.354298718881022, -7.434885813026019],
            [9.351935273254712, -7.423445806626318],
            [9.452196192268323, -7.413504169949184],
            [9.45664971341348, -7.45664745085274],
            [9.49965330088411, -7.452333336008385],
            [9.502189219189376, -7.477182480096964],
            [9.508504040867155, -7.53568857883982],
            [9.511320631559247, -7.565965231863491],
            [9.51517609168437, -7.610883847989505],
            [9.515040983723717, -7.611325661677871],
            [9.521748811328726, -7.667764603073771],
            [9.506970166380917, -7.669613995233093],
            [9.47770992687069, -7.6726103481513865],
            [9.482432056825369, -7.715374242309815],
            [9.483470269416015, -7.7200609966226095],
            [9.48494553701104, -7.73870110897563],
            [9.486378062719531, -7.751303365442311],
            [9.488295222136086, -7.777647954341076],
            [9.490758917393904, -7.8016121282657],
            [9.449933427429567, -7.805930946947829],
            [9.392390230141128, -7.811449796707652],
            [9.390033956052234, -7.811340650068893],
            [9.352357769158639, -7.815230723389609],
            [9.339929756164837, -7.816008766300683],
            [9.32063280432567, -7.818344369496094],
            [9.309133350029546, -7.8193470058106165],
            [9.213169771591598, -7.8287719769995014],
            [9.202390418200512, -7.828494693202664],
            [9.17771138634229, -7.831850280133812],
            [9.171812963693505, -7.835884471249205],
            [9.17001092513246, -7.8452277732224625],
            [9.165511656798538, -7.853967098287645],
            [9.158814369387132, -7.861953329212505],
            [9.154862986620639, -7.864588525232112],
            [9.144930678265187, -7.866077275262483],
            [9.142302944579978, -7.865245096154525],
            [9.139825118934441, -7.869093151991121],
            [9.135088152348276, -7.871104567809156],
            [9.128217518224115, -7.868176682537844],
            [9.126315888008643, -7.86511847642866],
            [9.122147323562611, -7.862477916627875],
            [9.11720699291529, -7.862771101322762],
            [9.115223718636047, -7.86567096137621],
            [9.106879567236584, -7.871280461517331],
            [9.102649327441167, -7.871927147570402],
            [9.096257264454685, -7.868603044468026],
            [9.085498600631151, -7.871445865122408],
            [9.085940529349795, -7.874945480530878],
            [9.082854517125824, -7.876660623393036],
            [9.076539484919254, -7.884661266868997],
            [9.0730128089811, -7.891236217032573],
            [9.063980861351835, -7.895046247294598],
            [9.061584975641935, -7.879567459626663],
            [9.064389079920604, -7.875782922892908],
            [9.065981561065584, -7.870185964581436],
            [9.068621083499622, -7.865457197257436],
            [9.065640312176425, -7.860746260973321],
            [9.069035587722972, -7.854395017983296],
            [9.074118661043148, -7.851413754866739],
            [9.077243292407728, -7.847203274319143],
            [9.081970949152973, -7.8461152255271935],
            [9.083495700807047, -7.842484542124982],
            [9.087604337619167, -7.841420187831855],
            [9.092354097835832, -7.837326582385803],
            [9.100418532111028, -7.837006537476187],
            [9.106688779017308, -7.834745420211964],
            [9.110068212230463, -7.837984128369682],
            [9.124331753094893, -7.83961693706379],
            [9.130108459010398, -7.834803669454465],
            [9.133552934755269, -7.835154682909167],
            [9.136541469838802, -7.832990188104072],
            [9.1387430154981, -7.8231100185414295],
            [9.14163200700447, -7.821151365453691],
            [9.140722585319725, -7.817608590441916],
            [9.142973325749331, -7.813550865227449],
            [9.14378481445947, -7.804978757010537],
            [9.148699277069957, -7.81021945452887],
            [9.15394007960146, -7.8081919381055265],
            [9.155622312573827, -7.799043914198198],
            [9.157905014148263, -7.792506736648916],
            [9.161303966051712, -7.786651718318568],
            [9.167064879882123, -7.7835473475084775],
            [9.167853923049915, -7.7767024849330655],
            [9.161086725440903, -7.776050397921987],
            [9.156423550909315, -7.76900663569029],
            [9.149920358951025, -7.771153642022511],
            [9.144614058782839, -7.768244510330052],
            [9.148167984750264, -7.76355831453977],
            [9.145568716239007, -7.759651423523318],
            [9.144462936925661, -7.755169861636265],
            [9.140804073424249, -7.75197508472448],
            [9.139701722363561, -7.748677380194549],
            [9.14763920202052, -7.743849249016483],
            [9.143926633974408, -7.732284967289539],
            [9.14287736491936, -7.7201293512950935],
            [9.14057885818976, -7.717405366285422],
            [9.135785244089156, -7.717705076936968],
            [9.13211449489348, -7.711576328903578],
            [9.133968342011137, -7.708510565485641],
            [9.131654448224316, -7.698910780367609],
            [9.12859064693859, -7.697061371206175],
            [9.12640892496229, -7.69176231171334],
            [9.119869337649357, -7.693994933131612],
            [9.114303739097998, -7.692515219912915],
            [9.114851006608081, -7.688447891119016],
            [9.112972176979477, -7.6866545149540855],
            [9.113806152818613, -7.682699655463737],
            [9.107731883416907, -7.683309016976985],
            [9.111227031788422, -7.675853629761246],
            [9.112437914490114, -7.665576199016537],
            [9.107448967588153, -7.662533611932675],
            [9.109760646215255, -7.660560243245598],
            [9.107819261115214, -7.654925943090203],
            [9.108280992369735, -7.649206580106569],
            [9.10410384419201, -7.643546274417707],
            [9.109832354658495, -7.640086939466928],
            [9.11122394905462, -7.634879391310437],
            [9.114736297259705, -7.631816509549224],
            [9.118640993092773, -7.631197826944264],
            [9.121683881252153, -7.626191856685214],
            [9.126576106634618, -7.622069001789886],
            [9.130603464416534, -7.620903112256576],
            [9.133315594593933, -7.615737569520297],
            [9.137040967359507, -7.616047203359415],
            [9.140459039505657, -7.612542142081304],
            [9.137157959271635, -7.609285827239265],
            [9.13839948606724, -7.607284545862998],
            [9.13772663821528, -7.601897757169265],
            [9.133498966209626, -7.597933995670549],
            [9.135150450565542, -7.5954874709553835],
            [9.140286217985457, -7.596233976227572],
            [9.143195763605789, -7.590930549370161],
            [9.140649832831961, -7.586864446462186],
            [9.144825378493268, -7.583446154593849],
            [9.146390062307452, -7.578621813757146],
            [9.152224096862854, -7.574257271259561],
            [9.157420108716561, -7.571790034017461]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.66538985308362,
          "lat": 30.610609262254236
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12133"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00295762"
      },
      "bbox": [
        9.061584975641935, -7.895046247294598, 9.521748811328726,
        -7.413504169949184
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.624150587767671, -4.486679070736425],
            [10.664832186675923, -4.4023667421142285],
            [10.677032829509777, -4.376509100371011],
            [10.709141152908366, -4.309846979923338],
            [10.719746880245172, -4.287182518176544],
            [10.724601338654198, -4.271775978133573],
            [10.728338571874788, -4.2685532067158185],
            [10.734495048514622, -4.258516241498511],
            [10.73493778994088, -4.2550075859718115],
            [10.738475728681108, -4.248019445632739],
            [10.742629136596134, -4.248624865725593],
            [10.753693812965253, -4.259382443620435],
            [10.756617965098041, -4.256351503527556],
            [10.760766415777962, -4.261435642853752],
            [10.764118604601995, -4.2697924287281666],
            [10.769014606530147, -4.273104336545035],
            [10.771396393082613, -4.277040275370746],
            [10.77224946109846, -4.281559281873155],
            [10.777900280121983, -4.286726515570477],
            [10.780286304247955, -4.286709756421819],
            [10.784094839832484, -4.2920078413296725],
            [10.783268044418008, -4.294602849156312],
            [10.788128411901534, -4.301318892499795],
            [10.790240972993905, -4.309662013469686],
            [10.793183598463083, -4.3126930689745],
            [10.793243696582936, -4.321385733211226],
            [10.795540885106217, -4.325339049143071],
            [10.798015404036036, -4.3260143622010325],
            [10.800455833579536, -4.3355971461573315],
            [10.805878636861541, -4.3390457872080965],
            [10.810221472819734, -4.338628084642325],
            [10.812651379506518, -4.341562249147749],
            [10.817909122100481, -4.340607374694766],
            [10.819407824084932, -4.343883769720893],
            [10.82376715134912, -4.346987080840811],
            [10.824265175266646, -4.349955474728736],
            [10.832881960533223, -4.352944847296227],
            [10.835916250313788, -4.356157718639566],
            [10.84015310745567, -4.357368622331891],
            [10.842536515705449, -4.36273367302663],
            [10.847084847137827, -4.369545211175666],
            [10.852730075046313, -4.373424287402845],
            [10.854957148051474, -4.379368956921263],
            [10.858486902856946, -4.3814684295182085],
            [10.858316978903803, -4.3853227843128595],
            [10.862744727431433, -4.390812039295154],
            [10.866116160359738, -4.391457150337343],
            [10.867603677641, -4.394593200884737],
            [10.870782104547198, -4.394468533675463],
            [10.87943463533762, -4.4094419066073],
            [10.879581659387759, -4.416344811792565],
            [10.883352817674352, -4.42115854340043],
            [10.885850007729887, -4.428628127408936],
            [10.888744995413786, -4.428381673999564],
            [10.893387052882828, -4.43365917912573],
            [10.895579053667053, -4.438842122854095],
            [10.89755849514395, -4.447037752432922],
            [10.89642015918636, -4.450509415913304],
            [10.906210088444197, -4.452122438655279],
            [10.907908446338029, -4.457920962084379],
            [10.912889696871524, -4.462336459251883],
            [10.916556865002118, -4.461007342114369],
            [10.917234102347093, -4.46528388450292],
            [10.920169737377982, -4.465377476367925],
            [10.922798166842908, -4.470189144041519],
            [10.925497524532219, -4.470751793388329],
            [10.932116071319335, -4.480422274113208],
            [10.93460727955852, -4.478612729815875],
            [10.938971558453902, -4.482356644312332],
            [10.9382406505319, -4.485395279903326],
            [10.946467338072356, -4.489331377435446],
            [10.950574983980358, -4.494704529971527],
            [10.954734745788121, -4.497960442575761],
            [10.959718042030847, -4.497021288618088],
            [10.964728134863089, -4.497683803431609],
            [10.96974948769271, -4.504335319496352],
            [10.970188337603833, -4.506883772193579],
            [10.964122653611247, -4.511940620346274],
            [10.962176454226409, -4.517816585753203],
            [10.963526364596332, -4.522894512915679],
            [10.961601900573458, -4.529516871129493],
            [10.961813739457899, -4.5339198414671245],
            [10.969273072290301, -4.545112696605692],
            [10.96780314696909, -4.550371245762466],
            [10.968157224749767, -4.55616070705867],
            [10.892490945914382, -4.583763394746531],
            [10.879776324619922, -4.588262796826685],
            [10.824998877329302, -4.609567910742773],
            [10.803945497920761, -4.618073177031881],
            [10.79352271956689, -4.621791912421536],
            [10.766225569902558, -4.632568766521903],
            [10.689524068123003, -4.590482129486746],
            [10.632285910744745, -4.557198292402817],
            [10.630148970627447, -4.511963556246839],
            [10.626175838015012, -4.505659045095008],
            [10.62099607398761, -4.501913591136475],
            [10.619915468943395, -4.4956936470578635],
            [10.624150587767671, -4.486679070736425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.49230502586273, "lat": 33.59091812534616 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13211"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "211",
        "coty_gnis_code": "00346008"
      },
      "bbox": [
        10.619915468943395, -4.632568766521903, 10.970188337603833,
        -4.248019445632739
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.992900388892775, -5.942686762992687],
            [10.01686569518753, -5.939720079840255],
            [10.017350395829274, -5.9472174977082215],
            [10.026135782870487, -5.9462655210518145],
            [10.027479426045042, -5.9545631807020065],
            [10.03077491455167, -5.95406773164331],
            [10.03593789992148, -5.9598331489579195],
            [10.03609586600709, -5.963138144502944],
            [10.040020299329333, -5.971613249021823],
            [10.039120195759022, -5.977641748212202],
            [10.068907429619562, -5.974622332170824],
            [10.070581757820598, -5.9915979318028185],
            [10.08645315950333, -5.98959128805908],
            [10.088052418359476, -6.005686027277554],
            [10.095936359095196, -6.004237735763128],
            [10.097202437523546, -6.012537694019805],
            [10.104645172653596, -6.011640219504128],
            [10.106905085637761, -6.028080946039894],
            [10.128976639557061, -6.02570832710909],
            [10.13407323619039, -6.024789872657286],
            [10.187177230922321, -6.018858117233052],
            [10.194191955669814, -6.085925100263828],
            [10.196908095619095, -6.110396895007772],
            [10.189695063572202, -6.111173091540774],
            [10.190614248238166, -6.118983271984396],
            [10.196951110243567, -6.185378435161714],
            [10.200778503736712, -6.2264954946846105],
            [10.194149575568396, -6.2270829972773045],
            [10.19485945484756, -6.234165792548198],
            [10.16300587350767, -6.238082698868514],
            [10.120875328297174, -6.24267675959329],
            [10.117878957202983, -6.243242784029999],
            [10.071905902092865, -6.248039878837931],
            [10.024880423780548, -6.253522181581404],
            [10.020624879426029, -6.212558863108023],
            [10.028724933119769, -6.2116318964057315],
            [10.02792955546618, -6.20345316339999],
            [10.01962793689294, -6.20451385500254],
            [10.018619305062932, -6.197175261236165],
            [10.02717329467836, -6.196218257040779],
            [10.026454717552406, -6.18894345359187],
            [10.017760223600133, -6.189941386583946],
            [10.014849715445028, -6.164025291385854],
            [10.015104167699754, -6.160385751991641],
            [10.013365963928905, -6.146090390853374],
            [10.021443503370254, -6.144724173937642],
            [10.021189700693638, -6.136556340415869],
            [10.019886784583267, -6.129009619966098],
            [10.014075979771295, -6.0754255343697166],
            [10.008466007387637, -6.022480931355407],
            [10.00085497555279, -6.0233893896180355],
            [9.999694009407289, -6.015172370792144],
            [10.007387878675932, -6.014254023348449],
            [10.006286043734708, -6.0065330848994885],
            [10.008125689085995, -6.0063133923633485],
            [10.007178656180256, -5.997768338541853],
            [10.014728435030152, -5.997067620450408],
            [10.01397127024132, -5.989405739584631],
            [10.006255850331117, -5.9901262648526234],
            [10.001342140542866, -5.949432340662575],
            [9.993833677955863, -5.9504295330398485],
            [9.992900388892775, -5.942686762992687]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.55107919856779,
          "lat": 32.046832904664356
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13307"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "307",
        "coty_gnis_code": "00352287"
      },
      "bbox": [
        9.992900388892775, -6.253522181581404, 10.200778503736712,
        -5.939720079840255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.2112003039238, 7.77733525506823],
            [-14.209171718793494, 7.776817394963681],
            [-14.115480930275785, 7.755415814687594],
            [-14.021795682027403, 7.733990135945994],
            [-14.0584610597415, 7.566351526240085],
            [-14.059367433707646, 7.563135607706514],
            [-14.056839233652715, 7.557270790150257],
            [-14.051436440575223, 7.549701845677991],
            [-14.047524013223363, 7.534101231404879],
            [-14.049306254599866, 7.522777054021216],
            [-14.054933488477952, 7.513671375975954],
            [-14.00357910186373, 7.502440331110725],
            [-14.029948182208598, 7.382391192246936],
            [-13.955731500685825, 7.3183381696269025],
            [-13.880717691181506, 7.302298751635508],
            [-13.884063462851707, 7.29746108331102],
            [-13.89106906581977, 7.283016799932145],
            [-13.896167380548336, 7.283649211085635],
            [-13.899554172005466, 7.282041649033133],
            [-13.900832578558084, 7.278025856637705],
            [-13.90246172444005, 7.267028696876741],
            [-13.905268353752883, 7.2633692507598875],
            [-13.905780432167791, 7.259081164123859],
            [-13.90817397301883, 7.255844653302494],
            [-13.908013808957115, 7.250310171566611],
            [-13.913373426186071, 7.246264976357],
            [-13.91574196011496, 7.239541340164482],
            [-13.919331055329232, 7.236484937027246],
            [-13.92245147370652, 7.231170253480034],
            [-13.921917531080634, 7.223758444800721],
            [-13.919221270057308, 7.2221714824066545],
            [-13.923205320565124, 7.216978340631942],
            [-13.922948512653324, 7.21378607499924],
            [-13.92740434483446, 7.209719807107052],
            [-13.931716251444671, 7.203567822278145],
            [-13.934636585970479, 7.19419527596371],
            [-13.940257736428933, 7.190658324207059],
            [-13.938595820857916, 7.185802991289738],
            [-13.940188527397192, 7.181199458853033],
            [-13.938328803499807, 7.178817697878393],
            [-13.93952829062733, 7.173545678265915],
            [-13.942358691859374, 7.16718219704932],
            [-13.94733095314102, 7.160204095014318],
            [-13.94562241979499, 7.156232255486196],
            [-13.945579315622007, 7.145663399771514],
            [-13.947946863363407, 7.142955557634165],
            [-13.947846935085886, 7.137132483648004],
            [-13.950356995920574, 7.133138283015952],
            [-13.951521488883403, 7.125988493382568],
            [-13.956154049732966, 7.122367475731821],
            [-13.958292886938713, 7.1158451816748585],
            [-13.95640608330858, 7.111581455338114],
            [-13.960683695966079, 7.10901747171385],
            [-13.958640529686544, 7.104875709890396],
            [-13.95775882904442, 7.096111008407359],
            [-13.960353454334577, 7.095109024354807],
            [-13.96195617333633, 7.086295144834494],
            [-13.964610075536902, 7.082144635485025],
            [-13.971079599414423, 7.080097272025495],
            [-13.970789673572746, 7.075931814389725],
            [-13.973542823095231, 7.067604881037575],
            [-13.972362463485762, 7.063573054488282],
            [-13.973194753123567, 7.059274584387762],
            [-13.976078545114206, 7.055872285296322],
            [-13.976678783674375, 7.052005533758609],
            [-13.975160632789336, 7.048664764603314],
            [-13.977477159569345, 7.04115861567551],
            [-13.984658670566494, 7.029015184816836],
            [-13.984035711077166, 7.025804083181079],
            [-14.049377585362272, 7.040209951490967],
            [-14.121937739184537, 7.056228380890687],
            [-14.197339291536968, 7.07283025452586],
            [-14.272743953741498, 7.089417659053322],
            [-14.34537541466312, 7.106270773833368],
            [-14.360389997085292, 7.109643543245944],
            [-14.356114928583613, 7.1163825420535725],
            [-14.354859582237546, 7.1274028936693625],
            [-14.357945223134505, 7.136451816764598],
            [-14.366197201121297, 7.142041731750908],
            [-14.370821294171938, 7.148462389914886],
            [-14.371092571484303, 7.151688896270763],
            [-14.377572500331041, 7.155594641529057],
            [-14.381178224141198, 7.156138735673045],
            [-14.386636210032457, 7.154856664226356],
            [-14.398496290515581, 7.160413815032498],
            [-14.402116553291076, 7.16441239627877],
            [-14.401166282552081, 7.17517824254432],
            [-14.3966581675128, 7.183841030518321],
            [-14.39594146687396, 7.187484198081649],
            [-14.39740249985379, 7.192614615086773],
            [-14.393877921951258, 7.201769916691718],
            [-14.395054791001598, 7.209341780109747],
            [-14.402117009408673, 7.213599591900505],
            [-14.423074444862312, 7.2181824542495],
            [-14.428210970109586, 7.222504554768618],
            [-14.432770057438828, 7.2236545136514305],
            [-14.441320933584922, 7.2195859704169365],
            [-14.447522140860599, 7.207675879908011],
            [-14.45182771656166, 7.2079582957353034],
            [-14.453856411844603, 7.210245828359881],
            [-14.45443246754421, 7.216872859249881],
            [-14.45846693395685, 7.224676839010109],
            [-14.464879915418987, 7.232104156396863],
            [-14.470805816106171, 7.241946932934452],
            [-14.471182346221969, 7.2534040552980965],
            [-14.47327325733671, 7.260145449531883],
            [-14.476252609564094, 7.265307906615991],
            [-14.481250375570657, 7.267168963713746],
            [-14.488490059362135, 7.265647480529875],
            [-14.497158363711963, 7.2592954002407515],
            [-14.500736644714115, 7.253486306874826],
            [-14.504694418511933, 7.250699403497314],
            [-14.50833176252825, 7.2503851244321815],
            [-14.51801957901173, 7.251772132506428],
            [-14.526958605197692, 7.255208337823241],
            [-14.543005649493573, 7.274056914374129],
            [-14.55288548821509, 7.291103777352311],
            [-14.554785615729207, 7.3009390895741415],
            [-14.552136115895395, 7.304245591850295],
            [-14.5493104840347, 7.309501715878919],
            [-14.547048664521611, 7.310967413922816],
            [-14.537910878840082, 7.312897203821796],
            [-14.526036250792782, 7.327155548940863],
            [-14.523255913326462, 7.33363340462096],
            [-14.525524615123764, 7.34411555914],
            [-14.533047511954313, 7.357375053085839],
            [-14.536898174682, 7.36075084459089],
            [-14.546513319655439, 7.376878886677561],
            [-14.548205615530213, 7.394721106639815],
            [-14.546722113878603, 7.400071094520982],
            [-14.540581299584934, 7.401869886478306],
            [-14.533810148438352, 7.406375231000597],
            [-14.520747108083052, 7.4254370534920895],
            [-14.515813231398804, 7.4456023752681855],
            [-14.515019997897202, 7.45665027255372],
            [-14.515701624655108, 7.468123470361598],
            [-14.516882420311003, 7.472199864607467],
            [-14.51669207682534, 7.477768726150413],
            [-14.514458745198107, 7.481694971115796],
            [-14.508554654161804, 7.4828387521427295],
            [-14.503505225542943, 7.481193801605962],
            [-14.496056622037505, 7.486007035030316],
            [-14.49020667979329, 7.4926997507787645],
            [-14.486603908883067, 7.498922253262116],
            [-14.486125075114844, 7.501976078602975],
            [-14.479715750803006, 7.510089905869617],
            [-14.476258212096086, 7.513082617754138],
            [-14.466168490865819, 7.5112964237352635],
            [-14.461515788151786, 7.512019972390917],
            [-14.454063492820076, 7.51710973704693],
            [-14.44528274115995, 7.529247340114003],
            [-14.441866108160529, 7.540288840300901],
            [-14.444250028727712, 7.5458229058972455],
            [-14.441502591111506, 7.551788230236751],
            [-14.438415150255482, 7.553975974201666],
            [-14.431669062008956, 7.556345076971104],
            [-14.423386830837522, 7.563243953436276],
            [-14.42153634401966, 7.5729996583087535],
            [-14.413644582739801, 7.592459109592031],
            [-14.407390635398423, 7.601472750899856],
            [-14.402380640844312, 7.602619281219083],
            [-14.392450719621035, 7.6142260969984985],
            [-14.387700070326435, 7.62469291241693],
            [-14.38777670087836, 7.6301823256862455],
            [-14.38551566630856, 7.637162798333202],
            [-14.381402227105871, 7.640387001149617],
            [-14.37326497587131, 7.643534501010019],
            [-14.37010607391709, 7.649592056942206],
            [-14.370782460905659, 7.653645687800897],
            [-14.367872545032638, 7.6611543603604995],
            [-14.363498722083666, 7.664451850552341],
            [-14.361259907630393, 7.668169378866394],
            [-14.354765254998402, 7.6698806899433665],
            [-14.35269649742606, 7.6725042385649305],
            [-14.348459409914632, 7.686841449144581],
            [-14.348511933001182, 7.692426091383307],
            [-14.345256147053272, 7.694876973901337],
            [-14.33919077414294, 7.695774680525855],
            [-14.336831279060302, 7.69874845220754],
            [-14.335343951466047, 7.70414980320729],
            [-14.332061987941474, 7.707072399302182],
            [-14.320517911662396, 7.710565813368744],
            [-14.315040185645485, 7.709022407016147],
            [-14.308456602978785, 7.71371862842492],
            [-14.298254787573471, 7.710980044022031],
            [-14.292868717875374, 7.712630694524427],
            [-14.28111858447252, 7.718970573261295],
            [-14.276721814727468, 7.722673565523588],
            [-14.27193362557706, 7.724254783939738],
            [-14.259013622298994, 7.724233785025128],
            [-14.247834660002498, 7.727755175439707],
            [-14.243584593683892, 7.734035308242786],
            [-14.243881326337098, 7.742035938005315],
            [-14.237910047025938, 7.750476920011153],
            [-14.231344818909896, 7.755123273664699],
            [-14.21670565565044, 7.772642198002316],
            [-14.213251178560528, 7.772778128328084],
            [-14.2112003039238, 7.77733525506823]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.78474014209809,
          "lat": 44.45242174608307
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16087"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00399757"
      },
      "bbox": [
        -14.554785615729207, 7.025804083181079, -13.880717691181506,
        7.77733525506823
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.5802252566465675, 1.3037071892722363],
            [4.584276900960091, 1.316843847117984],
            [4.5881316382772415, 1.321864422585681],
            [4.593110498478024, 1.3239318877642505],
            [4.6010113310119705, 1.3297710127894597],
            [4.609966732481587, 1.3430136542501723],
            [4.613041724357061, 1.3511963990505844],
            [4.612879567789387, 1.3641811620085726],
            [4.614776163080156, 1.370218348224493],
            [4.6152428786416175, 1.3757093727737006],
            [4.620291230185807, 1.3825103031653752],
            [4.622529066877899, 1.388821984680478],
            [4.6279043808520335, 1.3946752124748967],
            [4.629910181990249, 1.3983765739696714],
            [4.630165157610867, 1.4028195636661611],
            [4.628143083520308, 1.4147554744765205],
            [4.626733605321672, 1.4186929388665692],
            [4.628555891858653, 1.4247916987152327],
            [4.6333245096056395, 1.4283122970812416],
            [4.649836325836953, 1.4362464731316205],
            [4.6552946374871045, 1.4372550405985698],
            [4.658925898547712, 1.4394228078476239],
            [4.6710369419479205, 1.444615916687833],
            [4.682840003428223, 1.4539605851007888],
            [4.685436438465417, 1.4590088048966574],
            [4.6858947580092245, 1.4670168921336852],
            [4.687473318186528, 1.4734929802307715],
            [4.687792934772815, 1.481046189854228],
            [4.686414030204457, 1.4911260116697944],
            [4.686957747813079, 1.4954151640744686],
            [4.689670878872916, 1.4985705272879681],
            [4.695213522923708, 1.5018316462437602],
            [4.7109000978161655, 1.513307255701246],
            [4.713811092114929, 1.5210285629686244],
            [4.711739340556735, 1.5287254229823393],
            [4.718199583133743, 1.5407307317936283],
            [4.719713517205623, 1.5480694385821079],
            [4.724448999452732, 1.559070855954137],
            [4.7314602919854165, 1.56342028455759],
            [4.739246020424592, 1.5630450205427542],
            [4.742341051706439, 1.561207112537471],
            [4.742988069005225, 1.5576331375677774],
            [4.750088977234207, 1.5572849503399586],
            [4.75263666305806, 1.5621093185265063],
            [4.75878696524122, 1.560158268555713],
            [4.763715788813747, 1.557235337861495],
            [4.769828668745863, 1.556277275987967],
            [4.771694469319366, 1.5448559843764118],
            [4.779880974966457, 1.5337386677563265],
            [4.780815843808293, 1.5295524877538014],
            [4.779515862550016, 1.51865048061274],
            [4.784905661244819, 1.5167132825948277],
            [4.790955156834013, 1.5102311486377322],
            [4.790000786298375, 1.504713614033109],
            [4.793352679494219, 1.5052112600132486],
            [4.792885248946205, 1.5000756360043237],
            [4.79849656090742, 1.498212250393925],
            [4.807048665469133, 1.4997151103025916],
            [4.807351788534429, 1.503453424129153],
            [4.813660054833756, 1.5041547369236639],
            [4.814411828100128, 1.5019010445543104],
            [4.81938722719254, 1.5000210387472117],
            [4.824438793544722, 1.5019034476360635],
            [4.833101523033502, 1.5020629250427844],
            [4.837608941662435, 1.5010036568304612],
            [4.838265561650821, 1.4981784197746626],
            [4.8457294735216525, 1.4984919143231339],
            [4.850042411017549, 1.5040321507358854],
            [4.855587632078125, 1.5046856042786314],
            [4.855187613516407, 1.5004589448066301],
            [4.8645018771240585, 1.4994056890005294],
            [4.866042383480317, 1.5057861441539964],
            [4.872631151256482, 1.509483149853576],
            [4.876603462851318, 1.5096720169173916],
            [4.88451335204979, 1.507746998594925],
            [4.8930493340620504, 1.508682125487627],
            [4.894448676770241, 1.5138438327103847],
            [4.897267188737415, 1.5153797863311596],
            [4.902931877776637, 1.5125696148957595],
            [4.909271030830295, 1.5107313350990659],
            [4.912461843288551, 1.5175848434843697],
            [4.914495343116753, 1.5255726222018149],
            [4.91840029722433, 1.5257212763429087],
            [4.9246797336191745, 1.5306290279843013],
            [4.9270662473731255, 1.5279804794246465],
            [4.938942555814266, 1.5275750460560074],
            [4.941143656250556, 1.5312089655606012],
            [4.948748234184656, 1.5311994679097085],
            [4.949700060167055, 1.5385064838459666],
            [4.95933556361557, 1.5488904122191665],
            [4.961308337684585, 1.552965509147938],
            [4.970277964214719, 1.552315083425312],
            [4.971618677501111, 1.558016509770154],
            [4.97733951804411, 1.5622533003710193],
            [4.980426915256459, 1.5567619683328457],
            [4.984475222822314, 1.5591134960264676],
            [4.9908057444647635, 1.5587354473323092],
            [4.995412171393695, 1.5563845424695102],
            [5.004210873525253, 1.559360093354413],
            [5.00719596638042, 1.5586591644349264],
            [5.010287182109074, 1.56814298871028],
            [5.0120812130820624, 1.5643105951004304],
            [5.01468097349908, 1.52703822208938],
            [5.016534022662431, 1.4945405757013728],
            [5.02178841105431, 1.4143521417909175],
            [5.025712404411213, 1.3559468208083088],
            [5.027641286513206, 1.3266851278504894],
            [4.984943383843637, 1.3237614013127774],
            [4.927660186408391, 1.320354534613604],
            [4.898617797640264, 1.3189690792225042],
            [4.841767662324208, 1.3155409858028526],
            [4.8134670317577495, 1.314574520915739],
            [4.7846998747934695, 1.313330443509045],
            [4.726252372473417, 1.3105367636487004],
            [4.711961410585026, 1.310018527099577],
            [4.639648981150945, 1.3067359803539067],
            [4.58163834849292, 1.3035695086079044],
            [4.5802252566465675, 1.3037071892722363]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.2475235327209, "lat": 39.97349575866691 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17017"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00424210"
      },
      "bbox": [
        4.5802252566465675, 1.3035695086079044, 5.027641286513206,
        1.56814298871028
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.603704379843628, 1.0471428707185297],
            [6.646561597298176, 1.0513735111922669],
            [6.730880109577579, 1.0623193439893237],
            [6.7521944050875895, 1.0647640177372084],
            [6.811013987357214, 1.0710991729231747],
            [6.810473303696742, 1.0603721861196407],
            [6.842082186141455, 1.063203346664383],
            [6.93049624386534, 1.071334908365404],
            [6.934144119679178, 1.0325965382294524],
            [6.939844011413122, 0.9687365061383505],
            [6.942097036727281, 0.9416016359029405],
            [6.937443750705453, 0.9452670581340941],
            [6.9308688140719, 0.9447392266041431],
            [6.92852028575343, 0.9400638758925591],
            [6.928317282596248, 0.9355950076361728],
            [6.925414489376246, 0.9324380800921577],
            [6.920759730242891, 0.9303646727657423],
            [6.910313390813186, 0.9320419055052],
            [6.902458874448759, 0.9271955951300703],
            [6.899541381106989, 0.9233919867920434],
            [6.894758933185896, 0.9110082852528025],
            [6.892073279687107, 0.9072235550241001],
            [6.888718670721905, 0.8993739176923852],
            [6.8838377070746475, 0.8963984252196032],
            [6.8779497788751875, 0.8944256572286733],
            [6.877686285791865, 0.8913917208021098],
            [6.882694065290497, 0.8885299184796963],
            [6.889855196571019, 0.8915105636431168],
            [6.895426873515124, 0.8888312587365881],
            [6.896540324653118, 0.8857590966159076],
            [6.894867908803491, 0.8821917733040053],
            [6.88872667755389, 0.8746617527107243],
            [6.888308673882129, 0.8692802387137578],
            [6.890737541640093, 0.8642165440439683],
            [6.89495019038717, 0.8635346526480923],
            [6.895552027175602, 0.860625839462194],
            [6.893317525554441, 0.8504521497187763],
            [6.894699369277579, 0.8475954067082568],
            [6.899740677961417, 0.8426048719279242],
            [6.903884848342264, 0.8362422034350574],
            [6.908526875991014, 0.838846998572434],
            [6.909723798494045, 0.8425224720118806],
            [6.912995826924785, 0.8449401330411421],
            [6.918565086958913, 0.8447711436515803],
            [6.920460280410748, 0.84169563640993],
            [6.919549175400795, 0.8368636834420545],
            [6.915058033116642, 0.8332814463376409],
            [6.916754945181966, 0.8290055251873069],
            [6.920943710226901, 0.808318443484335],
            [6.919705494497411, 0.8008294921010657],
            [6.914151473334934, 0.7944106368218506],
            [6.913422560680238, 0.78861996172274],
            [6.9080600362291396, 0.7833871575368789],
            [6.901582413913697, 0.779136355554318],
            [6.900436676116746, 0.7735552197060778],
            [6.896106861060567, 0.771340672652427],
            [6.890160698504622, 0.7731598379402094],
            [6.888854140242578, 0.7718191085528474],
            [6.888654040734868, 0.7653894610099659],
            [6.890783099389692, 0.7586842702660092],
            [6.886730416430787, 0.7555189289027153],
            [6.878000642879083, 0.7542790688660471],
            [6.87517042952511, 0.7518951904840724],
            [6.874987664697913, 0.745417499844167],
            [6.884453541641475, 0.7433954171375265],
            [6.8632687349613395, 0.741860851082254],
            [6.862077107552825, 0.756266946914915],
            [6.793076353769735, 0.7504426816189196],
            [6.793183697299966, 0.757371966538981],
            [6.752668834000675, 0.7529636722588335],
            [6.687461727892383, 0.7451961777379484],
            [6.637334422036181, 0.7395779543943728],
            [6.59351177850905, 0.734901627471451],
            [6.5845516698637345, 0.8231433900375631],
            [6.57557143435791, 0.9115930313564607],
            [6.572802795272527, 0.9408680622711664],
            [6.566879735006167, 0.9993300311791669],
            [6.562785336140167, 1.0431597589565877],
            [6.603704379843628, 1.0471428707185297]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.78767997806007,
          "lat": 39.333608996059276
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17023"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00424213"
      },
      "bbox": [
        6.562785336140167, 0.734901627471451, 6.942097036727281,
        1.071334908365404
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.526226929627655, 2.089365150841768],
            [5.6279018996602, 2.0990871065895598],
            [5.626478502911679, 2.1138972219401344],
            [5.6512505712161, 2.1165378400330566],
            [5.649994351821985, 2.1292918591245127],
            [5.664384211714456, 2.1321347955528274],
            [5.692745278535985, 2.134828515081812],
            [5.689338521986829, 2.1714786102699315],
            [5.7347204107320895, 2.1759220789301326],
            [5.733208893190101, 2.190520380638198],
            [5.7265878341098855, 2.2635103913021393],
            [5.769629013632432, 2.2677536736362596],
            [5.812576758071801, 2.2719706915831708],
            [5.898453834108473, 2.2798004685317173],
            [5.9559529800008715, 2.2852264233196284],
            [6.027715010090727, 2.2917614252501113],
            [6.031759406513984, 2.2481456092960928],
            [6.035990404109198, 2.2045828099574636],
            [6.041343063534272, 2.2048870604127035],
            [6.046134592878904, 2.150600646449418],
            [6.132366741020793, 2.1582029897356367],
            [6.143034280117553, 2.0264747122310016],
            [6.149472591198796, 1.9385968083545642],
            [6.153838615876976, 1.8796685341585566],
            [6.158473073105204, 1.8210472547905652],
            [6.144099688555857, 1.8197690987406803],
            [6.143092446227029, 1.819099512692617],
            [6.0722263293872585, 1.813807776713518],
            [6.018689906184769, 1.810144752398566],
            [5.884885944960554, 1.8004971819204973],
            [5.843584814024904, 1.79738610407926],
            [5.812313528594412, 1.7947471209571508],
            [5.812282713837277, 1.7953222518724927],
            [5.768640135766263, 1.7924106045632722],
            [5.751517516172716, 1.7904885319884423],
            [5.725454611383165, 1.7887623666305974],
            [5.710762655913785, 1.7880841662463307],
            [5.697122513931938, 1.78650088367766],
            [5.639496166540836, 1.78180575579249],
            [5.639455107746668, 1.7822901370927209],
            [5.589526634026812, 1.7776727403076604],
            [5.553686498941272, 1.7745326842715297],
            [5.552234189867921, 1.788927319216495],
            [5.549690285300738, 1.8191617609410964],
            [5.543499289477541, 1.892640339478581],
            [5.541137186743417, 1.9218524452220873],
            [5.536169603638779, 1.9801466728669743],
            [5.531411382434513, 2.033807019340804],
            [5.526226929627655, 2.089365150841768]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.84735493833654, "lat": 40.49087470246973 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17113"],
        "coty_name": ["McLean"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McLean County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01784833"
      },
      "bbox": [
        5.526226929627655, 1.7745326842715297, 6.158473073105204,
        2.2917614252501113
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.684753122952277, 0.04459882244238172],
            [7.771098773826664, 0.05442580068717376],
            [7.8140938356143765, 0.05910939669559595],
            [7.862003071497603, 0.06396859908313422],
            [7.9154359779393255, 0.0684852443801174],
            [7.921412389523638, 0.06831076504230801],
            [7.972538579502523, 0.0727668129942066],
            [7.969727478160799, 0.1017191040542225],
            [8.011137831573054, 0.10577522850807514],
            [8.007627014761274, 0.09641102229095651],
            [8.00988576529905, 0.09290972135650208],
            [8.015418475163749, 0.08941241343993171],
            [8.015398633947614, 0.08384443202554744],
            [8.017052580034527, 0.081214948148972],
            [8.015425474497363, 0.0774732132962057],
            [8.010589922392134, 0.08075401968263299],
            [8.01110449241689, 0.07582676268309896],
            [8.017322051682637, 0.07476920644742328],
            [8.022089791769565, 0.07110821261151865],
            [8.018740090538603, 0.0665576039041382],
            [8.01093213210625, 0.07077302260591838],
            [8.010767406270057, 0.06285133957411876],
            [8.013083292386272, 0.05517560683066237],
            [8.01617173393361, 0.0483092492077719],
            [8.022389227892216, 0.04704782083538913],
            [8.022980766445883, 0.044547536863088606],
            [8.019894818086794, 0.03823142502791624],
            [8.01956937396242, 0.035165729519515854],
            [8.013347173047048, 0.03795274037188885],
            [8.0097175960279, 0.0440317085473646],
            [8.005348161247301, 0.042843719487095845],
            [8.003828960823098, 0.03752482195415939],
            [7.9984230475228495, 0.03132486355561197],
            [8.003174170588101, 0.03068070681891855],
            [8.006617674593883, 0.023857501938405516],
            [8.003180587765666, 0.02133321999146365],
            [8.00635871702578, 0.01088413746322594],
            [8.004033271506307, 0.008296398548874224],
            [8.006892724731683, 0.005615717217168571],
            [8.007393599233804, 0.0022746402920266607],
            [8.00353875564381, 0.0016027543986514884],
            [7.99921553008991, 0.005625591144206148],
            [7.998688290632462, 0.0010126760761900951],
            [7.9956684654394365, -0.002570716042775839],
            [8.00215736049848, -0.008644420548200448],
            [8.006568701737944, -0.010564976103672736],
            [8.005438854632695, -0.016292505144326203],
            [8.008622682512302, -0.018175543954258817],
            [8.010123614311414, -0.01298235709659547],
            [8.014583075584707, -0.00971837366679638],
            [8.020289496476927, -0.012095847590648802],
            [8.015822432145741, -0.015802546289224655],
            [8.016585827099819, -0.022393464984456622],
            [8.024120239934629, -0.020984174057250882],
            [8.026130288518898, -0.02544596315545578],
            [8.024004564459029, -0.029793261326745226],
            [8.024163715822471, -0.033307537635780995],
            [8.020565150763705, -0.03395985702427862],
            [8.017119084643955, -0.03211230446534287],
            [8.016232342045571, -0.03834901468395536],
            [8.014647361369747, -0.040340108075534],
            [8.008714420207212, -0.03327612941797883],
            [8.007209969383362, -0.03714080831128019],
            [8.01064255328583, -0.039162773323975525],
            [8.011439033512174, -0.05316880772752658],
            [8.014393997806566, -0.09240636787599897],
            [8.012058359020399, -0.09669134505518526],
            [8.007791975713221, -0.09923539629417133],
            [8.003928817257025, -0.09659836524647988],
            [8.00081226746995, -0.09700913827597507],
            [7.998655069175019, -0.1003190917641125],
            [7.999467503758792, -0.10300505446021098],
            [8.00635715646817, -0.10636241912243764],
            [8.00602292492361, -0.11013634133704865],
            [8.00222581228869, -0.1119872704317381],
            [8.002843385441837, -0.11737305432776637],
            [7.994052047732838, -0.11947013787410268],
            [7.99270152539535, -0.12192071262834094],
            [7.991454969154626, -0.13361006679254311],
            [7.987245915925025, -0.13349742173904722],
            [7.989154732183542, -0.1382010317174861],
            [7.993504895512868, -0.14051610770121084],
            [7.991700553892379, -0.14447171868276518],
            [7.988186076159582, -0.14481383140398044],
            [7.982279072826694, -0.14129120389632216],
            [7.978256684391144, -0.14221577653377054],
            [7.962869746368983, -0.12991846843748617],
            [7.954789625229761, -0.12724566336479287],
            [7.947365666077863, -0.12952561139399013],
            [7.942893787918796, -0.13399260685917208],
            [7.94029170760196, -0.141876702696413],
            [7.940702489245796, -0.14921715297756735],
            [7.94232338604136, -0.15635347604444258],
            [7.947468454916481, -0.16313468365158085],
            [7.952143069017997, -0.16535120117502342],
            [7.9588965811520485, -0.16631239393207775],
            [7.968826828400172, -0.16625494370264582],
            [7.982291247631367, -0.16912517370214195],
            [7.985711052287755, -0.1712242300417797],
            [7.988386423209079, -0.17640080409731657],
            [7.987210593895276, -0.18524346756959853],
            [7.983789639434625, -0.1921024940551555],
            [7.98054406828001, -0.19523943756076878],
            [7.975357384213363, -0.19728913444499102],
            [7.966053604343617, -0.19750450439774575],
            [7.948117645417004, -0.19712659781167385],
            [7.944806535436764, -0.1988383137617432],
            [7.939078817949496, -0.2043750688873635],
            [7.934372671147747, -0.22235099429234964],
            [7.930215664266349, -0.22563766786649594],
            [7.927593535768353, -0.22440926747481724],
            [7.916264558672003, -0.21409597084054732],
            [7.9066431020638275, -0.20675713971157747],
            [7.898562377633511, -0.20541029180680104],
            [7.890749590084312, -0.2063902305477477],
            [7.885347056330687, -0.20966690425962334],
            [7.88264927472404, -0.21334515827704154],
            [7.879978837448764, -0.1942062848703656],
            [7.874454483298273, -0.12724187529961337],
            [7.788246086515536, -0.1351583856865214],
            [7.783556348196143, -0.07595586968258285],
            [7.727517952119689, -0.08460236828912192],
            [7.699249817977464, -0.08758879859502904],
            [7.694658542852357, -0.0474846235510123],
            [7.684753122952277, 0.04459882244238172]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.45172858551481, "lat": 38.29242871958018 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18025"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00451674"
      },
      "bbox": [
        7.684753122952277, -0.22563766786649594, 8.026130288518898,
        0.10577522850807514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.4426574246612262, -1.2323304747304713],
            [-0.40687008644203854, -1.2328146521134464],
            [-0.35664270834043676, -1.2330610179083337],
            [-0.27119273627507984, -1.2341049490932732],
            [-0.19253820583007947, -1.2343244031409146],
            [-0.09827999123538393, -1.235885462963804],
            [0.035749859901132774, -1.2354933349677646],
            [0.05059950372971992, -1.2358172059459775],
            [0.05048320840158626, -1.2622380011757925],
            [0.050541552137340594, -1.32451515338787],
            [0.05027309070557919, -1.4111451245357758],
            [0.04972071000448055, -1.4547770909643292],
            [0.04929125965242982, -1.5134790651779477],
            [0.04870457891066925, -1.6161391421324125],
            [0.04802046030582264, -1.7179995906810215],
            [-0.016664392958471497, -1.7173889177256418],
            [-0.11887798166524768, -1.716312595063542],
            [-0.1293588647100197, -1.71653143591407],
            [-0.1627528074122127, -1.7160668945970696],
            [-0.1652382964735053, -1.7163691179013185],
            [-0.18705938335888558, -1.7158584715386338],
            [-0.22937361922681918, -1.7154289346652487],
            [-0.275528116830386, -1.7151539253308234],
            [-0.3510164455138082, -1.7145163170465478],
            [-0.444058004150235, -1.71326708824608],
            [-0.4437315196639274, -1.6184966704025274],
            [-0.44362961067930523, -1.568085959414118],
            [-0.4430242432250754, -1.5088547644350643],
            [-0.4432286956796548, -1.4977208266677386],
            [-0.442762616654411, -1.4871016762745066],
            [-0.4427542737906825, -1.4603491920772382],
            [-0.44308122294735314, -1.4600050343386985],
            [-0.4426350914653923, -1.3912830090378636],
            [-0.4421121781959284, -1.361957726215129],
            [-0.4416934271863346, -1.3179583723244317],
            [-0.4406930007391413, -1.3179977350685521],
            [-0.4415532408271528, -1.2672345512487901],
            [-0.4426574246612262, -1.2323304747304713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.83752766483126,
          "lat": 37.237698554757245
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20035"],
        "coty_name": ["Cowley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cowley County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00484987"
      },
      "bbox": [
        -0.444058004150235, -1.7179995906810215, 0.05059950372971992,
        -1.2323304747304713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.8432199488776435, -0.31691403390997125],
            [-3.7657043080791084, -0.3209584530453737],
            [-3.7651472680152325, -0.321104677268644],
            [-3.672674190400908, -0.32584822305210853],
            [-3.5875126930236743, -0.33030812901477474],
            [-3.519520977176675, -0.33378210219495985],
            [-3.502305441024962, -0.33466081986770807],
            [-3.508269961637501, -0.45180192313535505],
            [-3.511230502705927, -0.5102727124587525],
            [-3.5154494827556415, -0.583660959265402],
            [-3.517652815477787, -0.6241767274758662],
            [-3.526307047439024, -0.7737841580733041],
            [-3.515452591723973, -0.7742858525115767],
            [-3.5202962998487064, -0.8678405489370523],
            [-3.5219177328097784, -0.8676130781528935],
            [-3.605375227889715, -0.8633177799838324],
            [-3.862307181384222, -0.8487441049197114],
            [-3.8568706716985246, -0.75670447525713],
            [-3.8692044867528326, -0.7560178318337651],
            [-3.862121080592316, -0.6490941105439977],
            [-3.8533968896454582, -0.5066549891392823],
            [-3.847889150679777, -0.4044793056283552],
            [-3.8432199488776435, -0.31691403390997125]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.31988340600842,
          "lat": 38.000253354468626
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20093"],
        "coty_name": ["Kearny"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kearny County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00485011"
      },
      "bbox": [
        -3.8692044867528326, -0.8678405489370523, -3.502305441024962,
        -0.31691403390997125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0905678951908508, 0.7273564436610391],
            [1.1131854463904503, 0.7274418159147165],
            [1.250776121252772, 0.7284976357866],
            [1.252830411397797, 0.7287893206252553],
            [1.2549793343931173, 0.7270108781631466],
            [1.263625749640293, 0.7236288585458783],
            [1.2690052673670487, 0.7183986078612061],
            [1.2702407067757047, 0.7154262829461125],
            [1.2709208001952692, 0.7035270702645818],
            [1.2736779968357579, 0.69916444991041],
            [1.280143293476362, 0.6952462097466027],
            [1.2882260316767573, 0.6942733408828518],
            [1.2985329749326127, 0.698805340860709],
            [1.304426135466352, 0.7028434974472655],
            [1.3096561769809925, 0.7036783891132413],
            [1.3142678189385595, 0.7025884029328816],
            [1.3173196279142072, 0.6999681777793002],
            [1.320487853620406, 0.6940473949410955],
            [1.3220331557559495, 0.6857917730675227],
            [1.320356752586872, 0.6804014789237803],
            [1.3131050605781285, 0.673904126775193],
            [1.3085942789659863, 0.6729471146452771],
            [1.304288047749972, 0.6701191018385202],
            [1.2990655499347528, 0.663872722067159],
            [1.2981904522972778, 0.6578863786975109],
            [1.3004497280521459, 0.6330053904956525],
            [1.3026822960208502, 0.6212084259560454],
            [1.3068660363022488, 0.609384522635139],
            [1.3106398768258052, 0.6033871614607278],
            [1.3169869710109958, 0.5956593903899442],
            [1.3237478503792082, 0.5903437940382458],
            [1.340126966014009, 0.5831580095164188],
            [1.3484365852923652, 0.5778632680042114],
            [1.3550024800658158, 0.571821205089865],
            [1.3599744554218027, 0.5656793178617757],
            [1.363109442665782, 0.5592727513980922],
            [1.364610244462434, 0.5510530478562997],
            [1.363074094043627, 0.543231957835003],
            [1.3577490427018593, 0.5329099891149565],
            [1.3576656759764985, 0.52969440105697],
            [1.3603154777343887, 0.5249616036013713],
            [1.3664442218471873, 0.5189149442248675],
            [1.3757930071505864, 0.515719716408046],
            [1.3850099072718969, 0.5152540023140879],
            [1.3944438842104614, 0.5170376042061762],
            [1.3989339500831768, 0.5155604159470958],
            [1.4035954968837356, 0.5100230031930181],
            [1.4022855244169004, 0.5104089763464136],
            [1.336369918384244, 0.510864849877022],
            [1.3078936271738013, 0.511183998143402],
            [1.307689818981084, 0.509758099694363],
            [1.3080763474934483, 0.45085027012688783],
            [1.3078364841925931, 0.4362440833778784],
            [1.3025501817861322, 0.43615086103988154],
            [1.3026373471353065, 0.3973751987411984],
            [1.3037647125710623, 0.297583932717117],
            [1.2999487900017288, 0.29257549314037096],
            [1.2956484974256934, 0.2895579329839217],
            [1.294482897499672, 0.29477093105396335],
            [1.2979282775347003, 0.3013085917945256],
            [1.297306929435137, 0.30503336955055377],
            [1.2924100794564612, 0.30879541141029465],
            [1.2858277085317158, 0.30718135030190796],
            [1.2805119886654976, 0.30061328254759095],
            [1.2793138526901968, 0.29587451233508605],
            [1.2734317663013888, 0.28998521293123947],
            [1.2670900482306453, 0.28765155460796976],
            [1.2606690666422766, 0.28775198020954446],
            [1.2554615116556624, 0.29077402905385985],
            [1.248641162534127, 0.2979875411946213],
            [1.2367239223212174, 0.3012017384686895],
            [1.230671455015348, 0.304383189769344],
            [1.2246389549183887, 0.3062143748233925],
            [1.216655921574188, 0.30493832275084776],
            [1.2134771004140599, 0.2975480609216098],
            [1.215372424373797, 0.29342877618471436],
            [1.2147446925077972, 0.28925532002807414],
            [1.2119757988315762, 0.2836312156648907],
            [1.2066919196201003, 0.27986270033712046],
            [1.202403103942492, 0.27907816560536386],
            [1.1952903959016592, 0.28292231914246435],
            [1.1903227572311252, 0.28699843501350386],
            [1.1868603215761133, 0.29050310565266935],
            [1.180648529985785, 0.2919353101386601],
            [1.1720293816996714, 0.2889353834120322],
            [1.166914004948411, 0.2848513245426458],
            [1.16688571412711, 0.27890093818032285],
            [1.1747638756377612, 0.2715285337496638],
            [1.1764894847293823, 0.2689392881030133],
            [1.1750015868273749, 0.26434279854876186],
            [1.1682913567273694, 0.25822474600657813],
            [1.1595953729652477, 0.2606486495358429],
            [1.1562354040802583, 0.260515815409335],
            [1.1533702946448046, 0.26336640585483106],
            [1.1509970784330863, 0.27102282071861616],
            [1.1483684177320874, 0.2736880070568734],
            [1.139915136744357, 0.2742041255804646],
            [1.1374935059913538, 0.2721704859263669],
            [1.1262070356261429, 0.2735345337165409],
            [1.1209878595068519, 0.27649231004552566],
            [1.1128300373911022, 0.2830026510454552],
            [1.1072846120003477, 0.2857262618674996],
            [1.1055067581509028, 0.2799382866571896],
            [1.1068076703278744, 0.2755141571726616],
            [1.1032486538409263, 0.2703850591363119],
            [1.1000901760745965, 0.26900050809167514],
            [1.0904440717658814, 0.2683266086085325],
            [1.0890531455246606, 0.34865117460873746],
            [1.0884497259990515, 0.37793383697759153],
            [1.0876601366966796, 0.43425613714600947],
            [1.0936824069457884, 0.4342876463173525],
            [1.0934124112800956, 0.44902156877180677],
            [1.0928251178094244, 0.5076807264685287],
            [1.092303026600953, 0.5883151012841077],
            [1.0922240568850095, 0.6250991608340056],
            [1.0914794173429927, 0.6833471417078443],
            [1.0914416037018826, 0.7127533114595339],
            [1.0905678951908508, 0.7273564436610391]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.03799863170431, "lat": 39.19929706984793 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20103"],
        "coty_name": ["Leavenworth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leavenworth County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00485016"
      },
      "bbox": [
        1.0876601366966796, 0.25822474600657813, 1.4035954968837356,
        0.7287893206252553
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5221949026741757, -1.220158677206198],
            [-3.4244870466940602, -1.2253105494618302],
            [-3.3877483086703353, -1.227172322552417],
            [-3.2839015857501903, -1.2326420517815688],
            [-3.19579097248928, -1.237014970273012],
            [-3.180942093513728, -1.2377913467073345],
            [-3.183619817313652, -1.28167420228469],
            [-3.1870285003575467, -1.3400955076337018],
            [-3.1894990924275195, -1.390440924979166],
            [-3.1936276289846095, -1.4716508847228431],
            [-3.1956726091345717, -1.517403511859431],
            [-3.19709923909701, -1.5765582156818925],
            [-3.1996198485064373, -1.6286401481133599],
            [-3.2329907258841097, -1.6272558777276236],
            [-3.279604769238648, -1.6255829617776363],
            [-3.34261217050519, -1.6223901949885342],
            [-3.3753059375512597, -1.6211901274056661],
            [-3.4139799971714178, -1.6192691056965225],
            [-3.4462940808618296, -1.6180061779290753],
            [-3.499352188212645, -1.61520190363783],
            [-3.5418690028397304, -1.613202995717289],
            [-3.5356363274111575, -1.4836058867517514],
            [-3.5312500698461298, -1.3957589254250264],
            [-3.524824659925728, -1.2716913523580728],
            [-3.5221949026741757, -1.220158677206198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.85128062451889,
          "lat": 37.19329033669872
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20175"],
        "coty_name": ["Seward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seward County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00485050"
      },
      "bbox": [
        -3.5418690028397304, -1.6286401481133599, -3.180942093513728,
        -1.220158677206198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.153242954374165, 1.0219805494774408],
            [-4.096279273220225, 1.0184870917456414],
            [-3.989699302342675, 1.0119760218760994],
            [-3.8943838981457373, 1.0062331652984686],
            [-3.820295528557707, 1.0018193439344514],
            [-3.735063268330643, 0.9967298885795948],
            [-3.6685277154603737, 0.9929006322776487],
            [-3.649584232495439, 0.9918311295193522],
            [-3.6578672588028387, 0.8618657292228378],
            [-3.6607804223070093, 0.8179465070219876],
            [-3.6661063317951457, 0.7303748946164423],
            [-3.668655877136498, 0.6865756927200789],
            [-3.676402297391418, 0.5553182260607753],
            [-3.742753967202443, 0.5587564412047215],
            [-3.847871278818464, 0.564315224552839],
            [-3.8706689288093177, 0.5656378692644642],
            [-3.926626931048114, 0.5684051458253851],
            [-4.020259456807603, 0.5738359389047305],
            [-4.08394000544919, 0.5777106214714721],
            [-4.179203854447333, 0.5836176248985563],
            [-4.174117278870607, 0.67144468362787],
            [-4.16925607881352, 0.7549380954427215],
            [-4.162242097950218, 0.8760626106721703],
            [-4.157159008992807, 0.9595313009129723],
            [-4.154960938041075, 0.992511334637946],
            [-4.153242954374165, 1.0219805494774408]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.71998162650455,
          "lat": 39.35142189290401
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20181"],
        "coty_name": ["Sherman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sherman County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "00485053"
      },
      "bbox": [
        -4.179203854447333, 0.5553182260607753, -3.649584232495439,
        1.0219805494774408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.9059273763140334, -1.1979789280989308],
            [-3.8817424915788785, -1.199484289460205],
            [-3.804441809052673, -1.2039950534325268],
            [-3.795919680051907, -1.2040195194487786],
            [-3.7354541623921507, -1.2081223814291704],
            [-3.638126947503382, -1.2137434946903254],
            [-3.615044662141833, -1.215206761937688],
            [-3.583184515882541, -1.2166526719753605],
            [-3.539128031100956, -1.2193117958824227],
            [-3.5221949026741757, -1.220158677206198],
            [-3.524824659925728, -1.2716913523580728],
            [-3.5312500698461298, -1.3957589254250264],
            [-3.5356363274111575, -1.4836058867517514],
            [-3.5418690028397304, -1.613202995717289],
            [-3.656466579138274, -1.6078097687140518],
            [-3.7131374503481855, -1.6051390100261942],
            [-3.8172646483892243, -1.5999853775330177],
            [-3.8728184870842006, -1.597156342248768],
            [-3.928055808477083, -1.594144989848795],
            [-3.920695404792256, -1.4619916139216396],
            [-3.9140088303688847, -1.3446911581233292],
            [-3.9065812500368926, -1.206912802679948],
            [-3.9059273763140334, -1.1979789280989308]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.31206270309487,
          "lat": 37.19234259534993
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20189"],
        "coty_name": ["Stevens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stevens County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "00485056"
      },
      "bbox": [
        -3.928055808477083, -1.613202995717289, -3.5221949026741757,
        -1.1979789280989308
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.081051155693913, -0.7287370086543389],
            [8.113676756185574, -0.6369392229510504],
            [8.15637161345007, -0.5124869442392972],
            [8.26627499328935, -0.4810289906973287],
            [8.284643482631948, -0.420933521192393],
            [8.253546985178772, -0.29811465907342627],
            [8.269934670702185, -0.29292422575408367],
            [8.273516975103492, -0.2933715575362905],
            [8.293272284100988, -0.28872706762492745],
            [8.29516199120215, -0.29122661219879614],
            [8.300770316148455, -0.2943577402933091],
            [8.306632155500697, -0.2989380838921737],
            [8.311359631124043, -0.29983563852003153],
            [8.326062334883794, -0.2992925003993332],
            [8.328867572348715, -0.30597016429033047],
            [8.333042065096619, -0.3205945604043592],
            [8.331735318481364, -0.326002530056585],
            [8.331456860256514, -0.332801778244797],
            [8.33322774072971, -0.3412866353492446],
            [8.332503168685175, -0.34802883419240105],
            [8.336709968518663, -0.35090305701212887],
            [8.341269087977537, -0.34962754014450975],
            [8.351551941915785, -0.33997223289014517],
            [8.356618635272437, -0.34091629743085633],
            [8.36086697950218, -0.3388643181651372],
            [8.36761702727186, -0.33920094193553946],
            [8.371265384255214, -0.3410362835945948],
            [8.375931329805457, -0.34825167275368324],
            [8.37863157490532, -0.3557944470587283],
            [8.377923055525637, -0.35986881311865404],
            [8.381567215978473, -0.36396799730339185],
            [8.388570692268454, -0.3638736148885955],
            [8.393317974658641, -0.3657190611700647],
            [8.395952142724237, -0.3709011221736447],
            [8.397376972968159, -0.3836870037611846],
            [8.404864505552712, -0.387664757816974],
            [8.409613217835249, -0.39413642715087965],
            [8.405868875674466, -0.3971066811196857],
            [8.393194812491554, -0.392195066314238],
            [8.389480809240881, -0.39539274076932596],
            [8.389165149651225, -0.40107233643309753],
            [8.391334686589559, -0.4060160316345575],
            [8.400376905847153, -0.41542052787071293],
            [8.40416635403121, -0.41729845728831],
            [8.408704820175132, -0.4220887064506064],
            [8.409816988758276, -0.42538159252453017],
            [8.416415686084703, -0.42569132764739365],
            [8.420657944168454, -0.42243244475956593],
            [8.423114527400571, -0.42322816815346037],
            [8.42330680572664, -0.42787432785145124],
            [8.425932278203083, -0.4288122578350961],
            [8.429147231171351, -0.43370751008638075],
            [8.436187088283623, -0.43814644414593307],
            [8.446366805135463, -0.4380448986344023],
            [8.450034730592929, -0.44075351441432514],
            [8.455551696574835, -0.44264146549706057],
            [8.457656155290337, -0.44728305888574826],
            [8.46546872146994, -0.4513942245967523],
            [8.465901929659045, -0.4546615376943638],
            [8.470017719507736, -0.45488010896433373],
            [8.473094826180565, -0.4570067792492328],
            [8.472953233402437, -0.4619523459519787],
            [8.47671851715583, -0.4653572620081748],
            [8.474260208158803, -0.4741525296085377],
            [8.477516050832788, -0.47937287032805775],
            [8.475116533599488, -0.48538276553222715],
            [8.480419012534508, -0.48911773569737516],
            [8.483867048802347, -0.48774034308078745],
            [8.487729030363981, -0.48854634101543065],
            [8.48803131726734, -0.4916439739020928],
            [8.481105905361002, -0.49544626698663996],
            [8.483742127731084, -0.49944366811964985],
            [8.488316325276918, -0.5023024112192709],
            [8.496129137334297, -0.4996636310543355],
            [8.50021631666593, -0.5017589576759803],
            [8.498021022549914, -0.5070415433761887],
            [8.502699542264269, -0.5092848344452752],
            [8.507360895561478, -0.5063565820013677],
            [8.511695809276684, -0.5116625976196097],
            [8.514891192322448, -0.5118339290695151],
            [8.51778635565942, -0.5182958466845404],
            [8.525680243314374, -0.5149788988382086],
            [8.524495238801956, -0.5215367653442753],
            [8.52626140000093, -0.5230934506166839],
            [8.526511433353884, -0.5310470126046248],
            [8.529978300493834, -0.5331648797629733],
            [8.526112537843494, -0.5360829132052068],
            [8.529975827598157, -0.5403252366942888],
            [8.507228548894572, -0.5945182313692376],
            [8.493478570555451, -0.6267284433400105],
            [8.49048156212012, -0.6291942140168836],
            [8.476928851055728, -0.6324984893647524],
            [8.472812803586981, -0.6355841640897446],
            [8.468311172005585, -0.6410390399315942],
            [8.465490739778264, -0.6424273115031714],
            [8.467724445229539, -0.6496346625829228],
            [8.452842646154387, -0.6552519602916033],
            [8.446148983387918, -0.6618401915732387],
            [8.44894898212807, -0.6688792707358031],
            [8.452458328746387, -0.6748821184632707],
            [8.445563157404518, -0.682037122052447],
            [8.446096440871758, -0.6873713913214478],
            [8.442449392035503, -0.6919663169139244],
            [8.437879975078094, -0.7006706182091055],
            [8.438416792380407, -0.7061984419119782],
            [8.437022076960751, -0.7117348573322855],
            [8.42443916949549, -0.7178745496890283],
            [8.398702168151193, -0.7444013418535766],
            [8.398027470870534, -0.746547081581942],
            [8.395639472647725, -0.8173569978464917],
            [8.39122516636627, -0.8193198831516326],
            [8.393254489551756, -0.8321697886313453],
            [8.395826738464605, -0.8400754712649017],
            [8.395946929417656, -0.8513104293818027],
            [8.273895321496587, -0.8544644136179718],
            [8.270883268836565, -0.8518519202772524],
            [8.266391462619158, -0.8519317682768504],
            [8.25769686043256, -0.848598446327329],
            [8.260169059204676, -0.8407178193937423],
            [8.259521159224583, -0.8378802106899546],
            [8.261583518170701, -0.8328099712669107],
            [8.264984534472612, -0.8330103147028383],
            [8.267609341621222, -0.8257771903521832],
            [8.26614467093015, -0.8208537809369352],
            [8.258772916431958, -0.8154814165288953],
            [8.262353321038757, -0.8139065977850107],
            [8.264159656590872, -0.8098772522957929],
            [8.258719486825461, -0.807144773246447],
            [8.26071040407676, -0.8034971502057779],
            [8.25636800522362, -0.8022097252605817],
            [8.2549053766034, -0.7976057479525429],
            [8.221048203269818, -0.7577834278988279],
            [8.209613148523774, -0.7422145976961648],
            [8.207953523537059, -0.7455044969966551],
            [8.201706467714073, -0.7429968521330464],
            [8.195658716777004, -0.7441916757859123],
            [8.194570331099957, -0.7476145755479053],
            [8.189227884028403, -0.7474308499167605],
            [8.187805208143423, -0.752194937298399],
            [8.17732092628685, -0.7499261706700442],
            [8.173193852988435, -0.7503032344674315],
            [8.169179058007543, -0.7458566000505248],
            [8.162949090877435, -0.7522489029779468],
            [8.164413855178758, -0.7580821983752561],
            [8.162038596454769, -0.7596462394291191],
            [8.15678897492151, -0.7523821559647663],
            [8.152481663648521, -0.7541654270296783],
            [8.150709713243335, -0.7502174252736048],
            [8.146061672487383, -0.7504469607952268],
            [8.142931418618428, -0.7455623743567314],
            [8.137843137914745, -0.7441793112763727],
            [8.132479564470351, -0.738321377027132],
            [8.130883180226094, -0.7413042625538814],
            [8.125165210839354, -0.7419466059851064],
            [8.124842300306488, -0.7368100787847687],
            [8.121605415323137, -0.7369422057174622],
            [8.118908794466853, -0.7417751402541671],
            [8.116213389712525, -0.7437929956007996],
            [8.11136465704147, -0.7337259255210077],
            [8.110802098691908, -0.7290952672693399],
            [8.107416582734068, -0.7269846091318439],
            [8.10755013345613, -0.7226314027020021],
            [8.104212695763946, -0.7208536980955527],
            [8.10080388209832, -0.7222725511427819],
            [8.100404580218424, -0.725841009465036],
            [8.09592058894027, -0.7279062188697384],
            [8.094108203762739, -0.7345889807973714],
            [8.090119499740853, -0.7327456532117936],
            [8.087540151231309, -0.7370922146696374],
            [8.080828421196514, -0.7347110271661174],
            [8.081051155693913, -0.7287370086543389]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.96344296314587, "lat": 37.69790224652531 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21093"],
        "coty_name": ["Hardin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardin County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00516893"
      },
      "bbox": [
        8.080828421196514, -0.8544644136179718, 8.529978300493834,
        -0.28872706762492745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.492391856693038, -1.3089826914624247],
            [9.526200542029912, -1.2815732362098553],
            [9.609507094918877, -1.213610594861522],
            [9.624446022689288, -1.2092890876128455],
            [9.63270460366048, -1.2061093386111994],
            [9.635753603250699, -1.2040100230332897],
            [9.645789844665643, -1.1932162456470072],
            [9.649546668157745, -1.1927999334716686],
            [9.654156221731597, -1.1954365274191907],
            [9.653325681913179, -1.2007370458974547],
            [9.647793066263292, -1.2057330993300066],
            [9.647856287995717, -1.210259393057624],
            [9.651582322076827, -1.2136100173260087],
            [9.655739971789128, -1.2151061433441008],
            [9.666159220789368, -1.2142024991778038],
            [9.673131271373553, -1.2109387207472344],
            [9.682111303645488, -1.205428768660936],
            [9.691137044052292, -1.2083948415650865],
            [9.69538959013339, -1.2070250739933333],
            [9.699795373433364, -1.2028206229792222],
            [9.703430273925711, -1.2030555192047587],
            [9.704328701157303, -1.2079487663945516],
            [9.701690372400464, -1.2125980430360794],
            [9.694791746205022, -1.2180718286660996],
            [9.693120424747837, -1.2211425896522936],
            [9.693955708019816, -1.2244986206214694],
            [9.697794220982159, -1.2270176283168839],
            [9.702324082534854, -1.237238113737278],
            [9.70182646283661, -1.2391691188266636],
            [9.693963616926004, -1.2454257846211358],
            [9.693354035083672, -1.25085103605233],
            [9.690271337829467, -1.2546705073053455],
            [9.690819235550329, -1.26066979425745],
            [9.696144053929213, -1.2641924501066113],
            [9.69728972629788, -1.2719964264140926],
            [9.691042400163854, -1.280612554483501],
            [9.693057134430413, -1.28719041285277],
            [9.700412611164722, -1.291281990216641],
            [9.699190804684378, -1.295461530427134],
            [9.692693458161585, -1.296930941571198],
            [9.689640761345009, -1.3009161434323082],
            [9.688681376757868, -1.3058115547648113],
            [9.68156097464686, -1.3083879858788792],
            [9.67925938849069, -1.3127153099893576],
            [9.679637203788305, -1.3162852728311605],
            [9.683416066161366, -1.3175240872136211],
            [9.688009726047365, -1.3143347845290598],
            [9.693577365201993, -1.3155436712612096],
            [9.698877240715486, -1.314860976600791],
            [9.701019556341281, -1.31647796645175],
            [9.699452029619252, -1.3203023986944553],
            [9.693429851807657, -1.3248687639778156],
            [9.68618645667045, -1.3279009309285446],
            [9.681230532313284, -1.3322939970211238],
            [9.674369874623435, -1.3417427036304337],
            [9.674885723598761, -1.3459891730858595],
            [9.681226288036449, -1.3466158762367126],
            [9.683380309228932, -1.3491685862015173],
            [9.68043437957575, -1.3587016243474592],
            [9.682194716446055, -1.3634080006925153],
            [9.682516790827757, -1.3737068618342163],
            [9.685724292724593, -1.3772077765957846],
            [9.693076317025792, -1.3787922649588533],
            [9.69458750985493, -1.3844647462037456],
            [9.700095068805346, -1.3934691407363813],
            [9.70677705677149, -1.393101183477612],
            [9.709130431983574, -1.4141865274642456],
            [9.71350432667081, -1.435937338930329],
            [9.719001957242243, -1.4533235535637574],
            [9.72324021868037, -1.4635206287622884],
            [9.728774330173632, -1.4736325905074132],
            [9.740344233832484, -1.4896077289495027],
            [9.747033831539625, -1.497725812472205],
            [9.762536303190156, -1.513038312682733],
            [9.7770734067276, -1.5236588057959006],
            [9.790289616122488, -1.5305379611071561],
            [9.793373155090437, -1.5369286393096673],
            [9.795123095203202, -1.5368574445370395],
            [9.801364157001121, -1.5439849326577466],
            [9.802717593634684, -1.5505255754708827],
            [9.775798767946213, -1.5540732718299262],
            [9.768042501620648, -1.5551360492288884],
            [9.632029277527971, -1.5676080105057397],
            [9.586879934092911, -1.5725005236724419],
            [9.552823997822793, -1.5770396789741397],
            [9.487842462945268, -1.5815271639072501],
            [9.366192074753894, -1.5923578697922016],
            [9.432160951214998, -1.4463219208073792],
            [9.427735385352978, -1.441106272442926],
            [9.427103196363658, -1.4377685074224786],
            [9.430675512344308, -1.434132934879282],
            [9.43136771092127, -1.4268135226481784],
            [9.436376895534304, -1.4282050510993656],
            [9.436347900750564, -1.4226288133427],
            [9.440878917991256, -1.4220930285860183],
            [9.444446478802107, -1.416164847759368],
            [9.447462254239595, -1.4150051799876866],
            [9.454232135327072, -1.4155479092475336],
            [9.45506885797872, -1.4120023212265107],
            [9.459933519553312, -1.411866441590388],
            [9.46022755344324, -1.4013298325206098],
            [9.466317917366826, -1.4013318550232585],
            [9.466796349689094, -1.3957714798403589],
            [9.463995190454474, -1.3931743300080648],
            [9.46628742414485, -1.3865480070796519],
            [9.47064416457124, -1.3842489748317215],
            [9.477367741771365, -1.3848549074967116],
            [9.477049422635575, -1.3789103527559365],
            [9.483465213649346, -1.3797286365251682],
            [9.486329733088951, -1.3781177111427405],
            [9.48013492246298, -1.372226445071748],
            [9.482902525137122, -1.369608601390188],
            [9.485984600694708, -1.3723084742073017],
            [9.4916012220619, -1.3683138828987105],
            [9.497845433386154, -1.3619412706065743],
            [9.49857383313544, -1.357458203548888],
            [9.497831282268969, -1.3512118279821819],
            [9.494221875528524, -1.350585055455569],
            [9.489658996214054, -1.3459281113180124],
            [9.482419585743026, -1.3405504972352271],
            [9.485135256000321, -1.3374282334183774],
            [9.49293743559789, -1.3358942905907591],
            [9.498560432458284, -1.3314647994636586],
            [9.49799916962975, -1.3281215048703157],
            [9.488363417939688, -1.326429672266574],
            [9.484772914480535, -1.3216552214657362],
            [9.482319294880694, -1.3149012943435907],
            [9.490999185765201, -1.3134444187630372],
            [9.492391856693038, -1.3089826914624247]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.48413089735115, "lat": 36.7370832869168 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21147"],
        "coty_name": ["McCreary"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCreary County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00516926"
      },
      "bbox": [
        9.366192074753894, -1.5923578697922016, 9.802717593634684,
        -1.1927999334716686
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.495314965581022, -0.8391486376993701],
            [9.51136854499752, -0.7295662110920981],
            [9.52002101957277, -0.6763496453227382],
            [9.578026514905451, -0.6827004008551385],
            [9.580232811404787, -0.6748785369142293],
            [9.582230242252715, -0.6739624688318013],
            [9.582637947326582, -0.6686394575752412],
            [9.58574619408422, -0.6657116496439385],
            [9.58851582668623, -0.6587366181125708],
            [9.590124741452877, -0.6516103167537078],
            [9.586061503431745, -0.6481306513321885],
            [9.583203664607232, -0.6403455706931998],
            [9.588288122203863, -0.6316529766239112],
            [9.590497779180621, -0.6183594321928528],
            [9.590603543827397, -0.6135993025932979],
            [9.5929799986191, -0.612480344674062],
            [9.599140130209848, -0.6154760991113373],
            [9.6044585576456, -0.6114290174116558],
            [9.60702387840772, -0.6132001369942197],
            [9.609886279940874, -0.611186348757752],
            [9.614812831294806, -0.614955852242591],
            [9.616322994561477, -0.6197943314303233],
            [9.619089348449817, -0.6210101857807392],
            [9.623214293654259, -0.6178081745227058],
            [9.622840563834872, -0.6136340646204166],
            [9.625000435630806, -0.6110217776921746],
            [9.629473508219077, -0.6128197408188694],
            [9.627257553845146, -0.6204408418659385],
            [9.628291502549096, -0.6248517419666105],
            [9.63592395921923, -0.6242714627009168],
            [9.639836470464921, -0.6222251776548623],
            [9.646815577627907, -0.6223249786683959],
            [9.653659160665667, -0.6255351060844144],
            [9.655212197428924, -0.6295171790780756],
            [9.659632677330807, -0.6289676472285762],
            [9.665350935059411, -0.6248470432238449],
            [9.666199461587626, -0.6204131948020448],
            [9.669848550325183, -0.6183094176130943],
            [9.676726603863113, -0.6184718727707019],
            [9.680769597304444, -0.6220421256602119],
            [9.68839319146707, -0.613568531827252],
            [9.695744643034525, -0.6142268491047884],
            [9.698162345177886, -0.6156217694614798],
            [9.708208484696693, -0.615505380350613],
            [9.71015123654375, -0.6229466428762251],
            [9.705986094427292, -0.6272751198076401],
            [9.705992412457904, -0.6313171200336914],
            [9.708005489501174, -0.6400154776055197],
            [9.71107939529862, -0.6427711423906989],
            [9.708834833736182, -0.6477543677861348],
            [9.709627438717744, -0.6526537453500557],
            [9.712643230316937, -0.6549780786266571],
            [9.716422615302815, -0.6604357335436409],
            [9.720317591854268, -0.6714642475705054],
            [9.72225250435362, -0.6726736800023425],
            [9.724446339538757, -0.680654201448216],
            [9.728144097375111, -0.6812535825870241],
            [9.730252404838405, -0.6839929880025747],
            [9.729349741359556, -0.6889484223949979],
            [9.730722362586896, -0.6914866936731425],
            [9.736028774924167, -0.6951236670583546],
            [9.740145431656897, -0.7033213879467289],
            [9.74367633508213, -0.7057177268248008],
            [9.743658578172179, -0.7094076762175302],
            [9.752777734250488, -0.7172780373773887],
            [9.750546311599306, -0.724039463257888],
            [9.750786581468532, -0.7304038917423152],
            [9.747501607586182, -0.7390298866101711],
            [9.748827492552946, -0.7502974237676485],
            [9.759131721147172, -0.7571960211161837],
            [9.760523674223794, -0.7598617556908369],
            [9.769592752490501, -0.7648227058135038],
            [9.774934971177712, -0.7643349305674937],
            [9.78193996288028, -0.7706656877437037],
            [9.783800322153194, -0.7739703884229262],
            [9.773641969171987, -0.7808356278232085],
            [9.775804764887669, -0.783283406869869],
            [9.781260553143811, -0.7823303042003401],
            [9.781894092509205, -0.7881427102258077],
            [9.776391271136232, -0.7886610864022231],
            [9.7760155124464, -0.7927948462077237],
            [9.781236350146186, -0.7972167241705954],
            [9.78137388393687, -0.8032266607001826],
            [9.775301678401265, -0.802599221782964],
            [9.774489900570044, -0.8060305080944397],
            [9.778077508985263, -0.8083169508006736],
            [9.78173833038256, -0.8129752092159538],
            [9.78428106178452, -0.8192460744348221],
            [9.782210690837697, -0.8238071194892816],
            [9.777645256419586, -0.8242249679600603],
            [9.775587865647843, -0.8313575375052642],
            [9.768197110772695, -0.8312730366862299],
            [9.764228416047743, -0.8347096157429755],
            [9.75868977679757, -0.8360905468204345],
            [9.758192511658395, -0.8304413495554782],
            [9.750740785337412, -0.83293812195379],
            [9.752354412624598, -0.8374943330624833],
            [9.750023372916328, -0.8424794836351748],
            [9.746675940210409, -0.8450141421182543],
            [9.745701461967931, -0.8508338700121938],
            [9.740148277519767, -0.8525152136255746],
            [9.73694062521994, -0.8589756336650545],
            [9.725447378753326, -0.8602082420199376],
            [9.728929750363855, -0.8982583234028864],
            [9.725607370107907, -0.9022392970792326],
            [9.720883050147917, -0.9000367114943161],
            [9.718931423722871, -0.8939136063221638],
            [9.716410926149736, -0.8938192849537],
            [9.713259921820354, -0.8983816731164155],
            [9.712300717499323, -0.9042615405742477],
            [9.716170112981859, -0.9114077863601975],
            [9.712502162475932, -0.9143901781885652],
            [9.706354059833949, -0.9097215128330673],
            [9.703659006220002, -0.9040059456987798],
            [9.700799976311316, -0.905165849432798],
            [9.69914825636781, -0.9109614904895865],
            [9.699021956173294, -0.9169502002149958],
            [9.6944005214571, -0.9200418153704999],
            [9.692768441808871, -0.9231224375196312],
            [9.696772376760222, -0.9272037462284587],
            [9.690369681898293, -0.9321315950938639],
            [9.690959186891034, -0.93438516863113],
            [9.701318883610812, -0.9389403521037254],
            [9.698035918713765, -0.9446431969056903],
            [9.690085885910376, -0.9452803783427474],
            [9.685097106232071, -0.949447205310485],
            [9.688024171885374, -0.9589708728547504],
            [9.695179362410318, -0.9597399650741318],
            [9.699082142738826, -0.9637494046658966],
            [9.69707435614294, -0.9665672756265544],
            [9.690418760185823, -0.9691148976162935],
            [9.685155762835349, -0.9744334809463677],
            [9.674503373741203, -0.9776220175192984],
            [9.67414503335098, -0.9810427379040553],
            [9.678447607759944, -0.9847209138917041],
            [9.682963109761012, -0.9852219464422985],
            [9.684520664369, -0.9895652146024052],
            [9.684441227660892, -0.99605116517311],
            [9.680951825882277, -0.9871545885596927],
            [9.673998951985594, -0.9849326053515381],
            [9.619303311791336, -0.9406692285891535],
            [9.56248660348924, -0.8962629523501022],
            [9.545686513407638, -0.8836137897178551],
            [9.49758312066135, -0.8405592662464795],
            [9.495314965581022, -0.8391486376993701]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.31598907883505, "lat": 37.36517136850678 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21203"],
        "coty_name": ["Rockcastle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockcastle County"],
        "coty_fp_code": "203",
        "coty_gnis_code": "00516948"
      },
      "bbox": [
        9.495314965581022, -0.99605116517311, 9.78428106178452,
        -0.6110217776921746
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.176015518417586, 2.016332954520809],
            [15.175477688899685, 2.019277590293983],
            [15.181569199087665, 2.0248931162296793],
            [15.186936798109409, 2.0246696720746034],
            [15.193514079881197, 2.034707007295353],
            [15.197105210151069, 2.037729070538904],
            [15.201445452242702, 2.0390000140714513],
            [15.210445470940147, 2.038823006236078],
            [15.219148956259776, 2.0349130597909166],
            [15.22420469696737, 2.037083127492031],
            [15.230231482183143, 2.0515237798052586],
            [15.236056014114732, 2.049625573496036],
            [15.262918640847868, 2.027382126741776],
            [15.289956874658003, 2.0224783340398833],
            [15.300599382567539, 2.0354454604138685],
            [15.299650767202465, 2.031291883569799],
            [15.303621045075776, 2.0292008939360935],
            [15.307008914215903, 2.0242789020360155],
            [15.303008327909057, 2.0210523631960258],
            [15.303888491424903, 2.0183682576261113],
            [15.311297902433305, 2.010209703161267],
            [15.312185499899101, 2.0072045825425864],
            [15.319243135706852, 2.0038446859352277],
            [15.323368763595631, 2.003956923961424],
            [15.331262505979575, 1.9988620892692839],
            [15.33440161564953, 1.9955058734313469],
            [15.333472346500496, 1.990564690357339],
            [15.335498612679949, 1.9888960043288513],
            [15.340827347314024, 1.9897199344856402],
            [15.34439371920818, 1.992740679902427],
            [15.345137670644869, 1.9981197346396555],
            [15.348728575796162, 2.003187589666565],
            [15.351311189465864, 2.0033821007709305],
            [15.353082464234726, 1.9983967385023005],
            [15.357784110470622, 1.992779706391182],
            [15.374154654359344, 1.9846474017717841],
            [15.3849196701491, 1.980647350854053],
            [15.39285221946338, 1.9768118503245407],
            [15.393307162744948, 1.9662393018514894],
            [15.394740757796649, 1.9642512090933493],
            [15.39558326078319, 1.9558498750421847],
            [15.409503045278687, 1.930527057944978],
            [15.411086326477625, 1.9237881750432633],
            [15.410392022974536, 1.9176065456031839],
            [15.407980502495851, 1.9085656051937396],
            [15.403290931769291, 1.8972114920044298],
            [15.410295540319686, 1.8926634991496285],
            [15.425137545978227, 1.8874273387444176],
            [15.432820454486134, 1.8831969007590788],
            [15.440510244013923, 1.8738766330686658],
            [15.445034990115222, 1.8645885394314228],
            [15.437519941797369, 1.8568490605693968],
            [15.432691816159721, 1.8504183770404432],
            [15.434158061840172, 1.846111279475127],
            [15.428119358063645, 1.8424106436574514],
            [15.429921093243005, 1.8372044628066848],
            [15.425126500654573, 1.836679529342589],
            [15.426520434179707, 1.841636529616697],
            [15.425593601535507, 1.8469656140384554],
            [15.41964187475562, 1.8477219201809392],
            [15.418215096036615, 1.842473748020885],
            [15.40944301238119, 1.8388343215299903],
            [15.407377951729615, 1.8344049035551258],
            [15.4094694975742, 1.8306505974105967],
            [15.41009452223875, 1.8211350385344536],
            [15.40764336883181, 1.8174282282209522],
            [15.40549700818928, 1.8234277936208485],
            [15.402601296843475, 1.8268383122984775],
            [15.399851311278736, 1.822550999914417],
            [15.39495938269793, 1.8231511519771366],
            [15.389902762988429, 1.8209547148969347],
            [15.387637660881902, 1.8165783186060165],
            [15.393240582830488, 1.8125043867401494],
            [15.393823779037334, 1.8071263583196993],
            [15.39876326436767, 1.7970220972201505],
            [15.40657391775233, 1.7905056618618418],
            [15.410611577054302, 1.7911410536593144],
            [15.417772790045754, 1.7851096325015556],
            [15.412181163983016, 1.7765357544727012],
            [15.410525273810547, 1.7695413613343405],
            [15.416699192428004, 1.7581861755023027],
            [15.417251141786602, 1.749982758161336],
            [15.410270828283533, 1.7490106220583266],
            [15.409391893887886, 1.7528480057840752],
            [15.401778973611133, 1.756355931000587],
            [15.401175199420367, 1.7588032550865205],
            [15.391016189098387, 1.7653620024375374],
            [15.385570227872996, 1.7623228493527905],
            [15.377765113851376, 1.7548858841701778],
            [15.38053552215025, 1.74831323571367],
            [15.387168145481136, 1.7452126170533115],
            [15.390961269101686, 1.7467645283320614],
            [15.393431398147484, 1.7372586404758823],
            [15.396744797396279, 1.732690737680278],
            [15.399338075530231, 1.7259112676766104],
            [15.398892015606846, 1.7231381705159086],
            [15.38163814158226, 1.697202464607274],
            [15.379794936565574, 1.696096878829068],
            [15.37038727009905, 1.6945243420379543],
            [15.367621032555009, 1.6925193157276028],
            [15.371122578040593, 1.6833248369730005],
            [15.370890448301761, 1.6799378872540884],
            [15.3795263477315, 1.6847844961622],
            [15.38393947284328, 1.6842695376506014],
            [15.38728977616778, 1.6870656071269683],
            [15.39745535419684, 1.6823094450403786],
            [15.398737746589388, 1.689497482570631],
            [15.403065625219496, 1.6888638909549711],
            [15.405420831814743, 1.6827263240154844],
            [15.408985094220036, 1.6777155988921568],
            [15.408668155068506, 1.6735208410320876],
            [15.40632212576229, 1.6682461738912637],
            [15.40781295696671, 1.6528195047654533],
            [15.405818410721, 1.649095388919418],
            [15.402257280431341, 1.6465001985808723],
            [15.401438991344524, 1.637488051760732],
            [15.391679260570795, 1.6290682859712586],
            [15.39022052361323, 1.6254664874666558],
            [15.391584484962133, 1.6208016307863955],
            [15.384752333824592, 1.6066806378984753],
            [15.377409366398192, 1.6032579551074726],
            [15.370743895301285, 1.596215176366882],
            [15.373064812908348, 1.5877448163262162],
            [15.377771316955872, 1.5838533423152479],
            [15.378421124171878, 1.5803657592293903],
            [15.377170730346803, 1.5741749756481709],
            [15.382710652875875, 1.5656990240371131],
            [15.390533782048474, 1.5594412426961133],
            [15.401433566396992, 1.5624567227073094],
            [15.40506189631997, 1.558934135828909],
            [15.405834112432425, 1.547194937898673],
            [15.398537854003317, 1.5546854447807064],
            [15.3471999781754, 1.5437617771159602],
            [15.337907782773097, 1.5414266542644186],
            [15.331386982650635, 1.5461166788389569],
            [15.322976268082645, 1.5862410885246068],
            [15.31446981279742, 1.5838497542994772],
            [15.307449434902423, 1.585092121148509],
            [15.301623608297511, 1.5819345553643034],
            [15.300758324032513, 1.5794237206589083],
            [15.295399682130826, 1.5772546507105072],
            [15.287441094876737, 1.5666691941616304],
            [15.278266544742653, 1.5654826231194536],
            [15.279902773746464, 1.5612100025675146],
            [15.278953094280672, 1.557779462892179],
            [15.272803580664215, 1.5569335426038011],
            [15.268179336839736, 1.5606468035487457],
            [15.263788534206778, 1.5755481011156933],
            [15.253760285292724, 1.5798357170928836],
            [15.251176668858687, 1.5853336375118783],
            [15.252062596699835, 1.5892203992179668],
            [15.256413250583671, 1.5914643237158406],
            [15.258175678582491, 1.5967032523168059],
            [15.251306544958046, 1.6010667696685275],
            [15.251154248096457, 1.608363093190155],
            [15.24620679682807, 1.617453132342225],
            [15.247705962972825, 1.6212042539676765],
            [15.253635080978041, 1.6216761069335812],
            [15.256609496965154, 1.6256332438461785],
            [15.256255983868055, 1.629620554299741],
            [15.250865423392167, 1.6429931561505178],
            [15.251143904042376, 1.6537528144345108],
            [15.253734085193306, 1.6617435304762627],
            [15.252225244817515, 1.6663903909882951],
            [15.253982361070113, 1.6722600308611286],
            [15.25727170426182, 1.6751674725836043],
            [15.26036220856324, 1.6853288902158146],
            [15.259394731164285, 1.6951261447451336],
            [15.261533177524798, 1.6965581971056647],
            [15.257318174845896, 1.7011334837814989],
            [15.2565264452179, 1.7051323683587736],
            [15.259407836291182, 1.7093019279797577],
            [15.259888953378477, 1.7145606566128282],
            [15.25184687478515, 1.7192024000696529],
            [15.251450511726501, 1.7228869979486041],
            [15.246895895780124, 1.7268504143367938],
            [15.24534614256497, 1.725548162596404],
            [15.239880109529352, 1.7313942578961643],
            [15.245158238267482, 1.7340609273579972],
            [15.245428365216949, 1.7392367312156158],
            [15.23932702669544, 1.7403293718302861],
            [15.236282693076422, 1.7425670124754116],
            [15.236235729466438, 1.7472105908666595],
            [15.231607358093175, 1.753404431956785],
            [15.232240700930568, 1.7573111450091679],
            [15.230615153708694, 1.7624786814026399],
            [15.225785786527023, 1.7675575481715646],
            [15.224151337620691, 1.7737968598113203],
            [15.221773529007493, 1.7744130792197914],
            [15.21988078534282, 1.784021981229388],
            [15.221879871303424, 1.7885011537203852],
            [15.21530571237323, 1.7925039694432467],
            [15.212046588075538, 1.7963998384731175],
            [15.201437908167815, 1.8007070793673952],
            [15.19782042570893, 1.8003725507705197],
            [15.198475984220584, 1.8046953082160582],
            [15.194132219426184, 1.8067965485379935],
            [15.190938600243573, 1.8058776772003917],
            [15.186133785616263, 1.810781603757582],
            [15.180374649159987, 1.8143153182586576],
            [15.180083522005784, 1.821033275700227],
            [15.177090527088804, 1.8250474723276964],
            [15.173684603919318, 1.8262140023263898],
            [15.174703287114834, 1.829941185550872],
            [15.16677426772958, 1.8327880093371232],
            [15.164008209881153, 1.8297667153127315],
            [15.150526519510427, 1.8372326739929803],
            [15.144915163724088, 1.837053161986122],
            [15.142325957568772, 1.834852958483957],
            [15.138223024182148, 1.8356082403227498],
            [15.134195200205438, 1.8434299075656007],
            [15.130232291779667, 1.8434591505050695],
            [15.126398072170907, 1.8499423926332788],
            [15.121737018019152, 1.8474188753795928],
            [15.116496844801572, 1.8472245878744047],
            [15.10874846195191, 1.8496789855047262],
            [15.104251503220793, 1.85233083711693],
            [15.101425953033518, 1.8504732344077701],
            [15.09944327544924, 1.855919389761017],
            [15.10198588409809, 1.858852093536018],
            [15.09893594170029, 1.8653644706236994],
            [15.103396606887422, 1.8734445594964277],
            [15.101291478797364, 1.878341245147094],
            [15.094108998084616, 1.8787759298693596],
            [15.090729834403598, 1.8845659893676716],
            [15.097475016042253, 1.889525153373053],
            [15.099667512093935, 1.89340194216538],
            [15.099245014660175, 1.8990853299111936],
            [15.100874297754027, 1.9026338879488212],
            [15.108094965781374, 1.9082931826544607],
            [15.116376937382949, 1.909430623702772],
            [15.123747034907595, 1.9143467955298326],
            [15.12641598851141, 1.921671962037386],
            [15.125628851966411, 1.92925741756259],
            [15.126457081852498, 1.9355000276794252],
            [15.135624166591569, 1.9587324322616213],
            [15.144071439763632, 1.9695153403826267],
            [15.145977155557851, 1.9745344907106896],
            [15.152224227029802, 1.9753896462993374],
            [15.157809002570025, 1.9813740319812834],
            [15.163641759454201, 1.9817918428680452],
            [15.163978498771208, 1.9905643358910463],
            [15.166261025784076, 1.9914085444798668],
            [15.168182410991566, 1.9978626858890438],
            [15.167154958674946, 2.001985028495749],
            [15.169987751471204, 2.004101460654922],
            [15.172009064575365, 2.0120092401117464],
            [15.176015518417586, 2.016332954520809]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.60509947030974, "lat": 39.00641980451254 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24003"],
        "coty_name": ["Anne Arundel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anne Arundel County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01710958"
      },
      "bbox": [
        15.090729834403598, 1.5414266542644186, 15.445034990115222,
        2.0515237798052586
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.979076419717014, 5.242953251300895],
              [18.982129285043097, 5.2445190022629244],
              [18.980382581996032, 5.249851608229596],
              [18.982653204754744, 5.254558664192829],
              [18.98676185117158, 5.2561721096352665],
              [18.98851044553173, 5.259395716530374],
              [18.98870532453357, 5.264391214881722],
              [18.990421469959188, 5.266179345689408],
              [18.996864838781583, 5.267026590567886],
              [18.99941577400427, 5.278834184518694],
              [19.003816763210775, 5.28032538048579],
              [19.007952138087887, 5.284502940767674],
              [19.011161725145513, 5.294600131827017],
              [19.016852612328435, 5.300689243145622],
              [19.022471760363594, 5.301084303416214],
              [19.028061663159562, 5.312686326318077],
              [19.032601101256084, 5.320200673256191],
              [19.037928130982664, 5.322404695949881],
              [19.041747218434093, 5.317148225405893],
              [19.045230670016526, 5.318464331869922],
              [19.050767383195225, 5.3183018664797075],
              [19.05591909352682, 5.324884276861025],
              [19.059797415222775, 5.320755362416542],
              [19.056234249408224, 5.314505394955367],
              [19.05098769251176, 5.3102302458167445],
              [19.047629502659728, 5.311711464420635],
              [19.03950235306285, 5.303951010906288],
              [19.042532466442314, 5.299905929049088],
              [19.038630802467956, 5.292419273647469],
              [19.032049898262255, 5.288188606985655],
              [19.02376886663657, 5.284499320265018],
              [19.021230947215276, 5.279104118825341],
              [19.016966392002395, 5.273210997729735],
              [19.009816778397543, 5.272570876527398],
              [19.008349475195313, 5.265876253597196],
              [19.013719530596564, 5.261240427761421],
              [19.011395260120626, 5.254335301301866],
              [19.007748460121274, 5.252739324682607],
              [19.00745448531171, 5.249703971554917],
              [19.00141437160866, 5.248047012754372],
              [18.997521100952223, 5.239369136985475],
              [18.994245632945592, 5.234533052311668],
              [18.987451724481097, 5.23231287883545],
              [18.98260449894232, 5.235384723221085],
              [18.979076419717014, 5.242953251300895]
            ]
          ],
          [
            [
              [19.0136952780257, 5.0452308397538355],
              [19.02245096669236, 5.048188546734705],
              [19.025832194884487, 5.051408074308379],
              [19.035917081094958, 5.050108341444235],
              [19.036356246036572, 5.040912590014913],
              [19.020300628118815, 5.039505572249069],
              [19.015494823270373, 5.0423699518416685],
              [19.0136952780257, 5.0452308397538355]
            ]
          ],
          [
            [
              [18.9857115633869, 5.128920175215985],
              [18.987658456631564, 5.1358708917945854],
              [18.997635096927517, 5.138763631734448],
              [19.002483951365267, 5.142330257372788],
              [19.011636441900077, 5.1427816076343005],
              [19.025430857564338, 5.140302062610246],
              [19.031052367507606, 5.143224962105207],
              [19.0343407173403, 5.148349381815344],
              [19.03809198152286, 5.163619736774443],
              [19.042773505405304, 5.173460329058127],
              [19.045291363725795, 5.175597084446822],
              [19.046984164672732, 5.182496532355599],
              [19.047145128900787, 5.191641785967626],
              [19.049161607045384, 5.198712251319725],
              [19.05423909989196, 5.201280543181698],
              [19.056067268499508, 5.207729147778299],
              [19.060182935925326, 5.213200696426328],
              [19.05910535557644, 5.219784655521904],
              [19.06165517509885, 5.224365390922015],
              [19.06097704419886, 5.229200722360249],
              [19.062266745347234, 5.236730903532102],
              [19.061745995511515, 5.239798766859959],
              [19.06891822176907, 5.244691609969822],
              [19.069910156804156, 5.249635103705508],
              [19.075577636926194, 5.250409360840346],
              [19.080415296202965, 5.253561416806552],
              [19.08236130770793, 5.2631724886438205],
              [19.0815979385685, 5.268303807551686],
              [19.08431212724796, 5.273672296209401],
              [19.09161237661551, 5.276064891579169],
              [19.096430926622308, 5.278674460241276],
              [19.109035460222213, 5.2948779088643],
              [19.11877238397398, 5.3056378183491635],
              [19.122765038446293, 5.30544344176403],
              [19.12796533820925, 5.2939360315308415],
              [19.1270115541816, 5.286078539970417],
              [19.129134982656147, 5.280355313160206],
              [19.134106520146744, 5.2822676301473805],
              [19.135572579858128, 5.286930416248339],
              [19.13879244003334, 5.288549592178343],
              [19.143115436275924, 5.297580868238962],
              [19.147703290202585, 5.301901612332548],
              [19.15118048497922, 5.300685590123169],
              [19.162664669441558, 5.286993678660417],
              [19.16545341436969, 5.2778060162832094],
              [19.166891920908945, 5.265178267630491],
              [19.170527458151383, 5.258959405176265],
              [19.17666015480243, 5.252183238722572],
              [19.185067018172212, 5.247622171933843],
              [19.193147168624012, 5.245521335127175],
              [19.201394108487154, 5.246391650852332],
              [19.209942781599427, 5.245059745642213],
              [19.215453038421437, 5.237994115355232],
              [19.217985180061795, 5.2318025895633085],
              [19.22602568123033, 5.232175322114052],
              [19.229805180242536, 5.235975445158339],
              [19.23263940309233, 5.242801150280305],
              [19.236352679750947, 5.248085810295122],
              [19.232026908829813, 5.2599716801372844],
              [19.232537586857482, 5.264398282019875],
              [19.235849693291357, 5.271832985917139],
              [19.243369764326484, 5.276273841384875],
              [19.24504630012317, 5.275976940175317],
              [19.254542698670136, 5.253365646979301],
              [19.256663745240495, 5.237229959225931],
              [19.26455290610121, 5.211522226854596],
              [19.262717246442524, 5.207038204986418],
              [19.255412868537782, 5.202589151524567],
              [19.241424155978738, 5.199714753139302],
              [19.23261639719323, 5.196373461411901],
              [19.20115532147728, 5.189273795535104],
              [19.171519937819195, 5.182271092132011],
              [19.12229925457177, 5.16569975058429],
              [19.092611090821883, 5.15484295760313],
              [19.079845470807886, 5.148698036589396],
              [19.064464895871215, 5.138805386654161],
              [19.055855731832875, 5.129943535685357],
              [19.056075639332953, 5.126730951801517],
              [19.05249380670646, 5.123768883368123],
              [19.046863454554448, 5.115806424239781],
              [19.04589620257579, 5.108524689128611],
              [19.04801842107681, 5.1059812478787165],
              [19.047596637853633, 5.100394256171181],
              [19.043297466330667, 5.09640013834174],
              [19.02080402497534, 5.10407289774355],
              [19.004907486756352, 5.113304541615663],
              [18.9857115633869, 5.128920175215985]
            ]
          ],
          [
            [
              [18.95669876934452, 5.230979895102788],
              [18.95743124737389, 5.234439640703047],
              [18.96100658386387, 5.237421268023789],
              [18.968368306035018, 5.238195028171641],
              [18.969409767789628, 5.240269149999641],
              [18.980622395715866, 5.233923355550845],
              [18.98084198068667, 5.2279520376065465],
              [18.977127150619864, 5.229273365561969],
              [18.97124964993565, 5.227043659888437],
              [18.96657717038668, 5.221605313826937],
              [18.962092400736424, 5.221094157641133],
              [18.956831729303868, 5.227125693555137],
              [18.95669876934452, 5.230979895102788]
            ]
          ],
          [
            [
              [18.9171260965443, 5.197338807134797],
              [18.918018168172516, 5.201395910263531],
              [18.923096426788568, 5.200984553076149],
              [18.93201803544602, 5.203203149525904],
              [18.931964359843455, 5.208808757270453],
              [18.937186235721178, 5.21166268507003],
              [18.93962777306041, 5.215434150237029],
              [18.94270126338263, 5.216458461626592],
              [18.945382464441643, 5.225199675907847],
              [18.947588990317172, 5.22407612732519],
              [18.948848887937462, 5.216079680974783],
              [18.956101780978827, 5.209989178088291],
              [18.95353901074753, 5.2047855874296935],
              [18.948277582334555, 5.198801193566433],
              [18.94267012075379, 5.195178132917478],
              [18.93335273607443, 5.192056297860977],
              [18.929487999709192, 5.192193080176875],
              [18.92040882756753, 5.188798341820675],
              [18.917214469882282, 5.191613821517274],
              [18.9171260965443, 5.197338807134797]
            ]
          ],
          [
            [
              [18.89595142307119, 5.213421577040883],
              [18.898620182428207, 5.217072344153757],
              [18.90349465132251, 5.214725472634027],
              [18.900347402164027, 5.211648530621209],
              [18.89595142307119, 5.213421577040883]
            ]
          ],
          [
            [
              [18.888326795222984, 5.1739899209342575],
              [18.892442052158774, 5.174303791182672],
              [18.892569271706616, 5.181329821162945],
              [18.89458074047791, 5.185539627417681],
              [18.897974593488506, 5.186244327054113],
              [18.899708282402738, 5.193721197773189],
              [18.90326969519896, 5.193054225258011],
              [18.907949511571314, 5.187174724542981],
              [18.90513422381817, 5.18546174114392],
              [18.90284795776344, 5.177699698915779],
              [18.89793627136282, 5.172743953590536],
              [18.890097152509327, 5.167993728239442],
              [18.888081277491832, 5.169875465785705],
              [18.888326795222984, 5.1739899209342575]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -70.64946696368455, "lat": 41.39609450748966 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25007"],
        "coty_name": ["Dukes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dukes County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00606930"
      },
      "bbox": [
        18.888081277491832, 5.039505572249069, 19.26455290610121,
        5.324884276861025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.397116681796681, 6.202686796396319],
            [7.435285658236292, 6.2061653223398885],
            [7.489088165487944, 6.209589201687953],
            [7.549833542753906, 6.214205959890023],
            [7.5782988361519985, 6.216647376412432],
            [7.6421210952696965, 6.2229560920320255],
            [7.692569306675904, 6.228275320978225],
            [7.695947858617028, 6.196356067077671],
            [7.701145386180316, 6.1404979910970265],
            [7.705315377088888, 6.091777101444956],
            [7.707609220481183, 6.068963352372789],
            [7.710987355739072, 6.039071041859341],
            [7.715504954067032, 5.993518227557633],
            [7.718310370238959, 5.968601602475299],
            [7.721044949004698, 5.940750592347891],
            [7.722821827651177, 5.92610597854652],
            [7.727565251414825, 5.882178395206605],
            [7.656316395113369, 5.875167760482815],
            [7.63837819038712, 5.873664229742025],
            [7.588437367959087, 5.870275816003755],
            [7.5691961080459516, 5.868329846966724],
            [7.540518641514926, 5.866968231934672],
            [7.498145236733218, 5.864041697853114],
            [7.46823968023708, 5.862423902574454],
            [7.410761020696347, 5.860049151697339],
            [7.382001810399874, 5.858112960546248],
            [7.3224591310116915, 5.854613006132301],
            [7.324905580156914, 5.860802183467709],
            [7.330197056445005, 5.8694179672756475],
            [7.335152342203232, 5.878841611304468],
            [7.340828990126557, 5.895138123351338],
            [7.34372823859676, 5.907660522316896],
            [7.347250020685793, 5.928256097301042],
            [7.354026653754026, 5.936441373623344],
            [7.357605258399505, 5.942795005587453],
            [7.360213356376505, 5.9507579746962636],
            [7.3634459264455705, 5.964601686791482],
            [7.372185345838237, 5.989544346011106],
            [7.381741499463886, 6.009652774598552],
            [7.387027134856258, 6.018634519333195],
            [7.390774748851257, 6.028666481463754],
            [7.39188925633949, 6.034536229181373],
            [7.39173026269478, 6.041997086529587],
            [7.393577042211628, 6.052457786834611],
            [7.393834391308677, 6.067567404245194],
            [7.396965379928375, 6.085098236183559],
            [7.397638866370624, 6.105175993709752],
            [7.3960524601500985, 6.118857026378882],
            [7.391824541209145, 6.135335581724369],
            [7.39057529086783, 6.149048370961846],
            [7.390677497562025, 6.166656382916272],
            [7.3937278315218204, 6.172905764320046],
            [7.39438026468641, 6.179952606298006],
            [7.395957512887077, 6.185912698101056],
            [7.397116681796681, 6.202686796396319]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.05682434164807, "lat": 44.33304107739519 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26101"],
        "coty_name": ["Manistee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Manistee County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01622993"
      },
      "bbox": [
        7.3224591310116915, 5.854613006132301, 7.727565251414825,
        6.228275320978225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.57815578421586, 4.810342522990397],
            [9.612382907944227, 4.815779764720934],
            [9.68454641469524, 4.827495173811256],
            [9.77384132917425, 4.842772279994036],
            [9.800739638086132, 4.847708207977882],
            [9.830093499456128, 4.852454910554715],
            [9.844580851261474, 4.76530635260447],
            [9.85095568084412, 4.728480024601482],
            [9.86203675225304, 4.662883603860522],
            [9.876027139662483, 4.581101770672874],
            [9.87974518258309, 4.5600468836125545],
            [9.88695481007566, 4.516855308228259],
            [9.889867890052956, 4.50248215053109],
            [9.904348953900207, 4.415703322698186],
            [9.883159382614688, 4.4124591242166735],
            [9.826596953311986, 4.403115606089014],
            [9.76335431553106, 4.392287259471169],
            [9.714115587218588, 4.384139989438387],
            [9.657985420743747, 4.374571997350262],
            [9.565490212851092, 4.3582125438761095],
            [9.483925196257212, 4.343512731040269],
            [9.476096721362254, 4.3871313164797305],
            [9.465458326873685, 4.444759349473488],
            [9.456671700605655, 4.4914192569539475],
            [9.441791026292378, 4.574180723534802],
            [9.436471944873503, 4.604846427518972],
            [9.428371976952684, 4.653513584727563],
            [9.422385894708443, 4.691681365673365],
            [9.416954710082, 4.727697642085712],
            [9.413230681050392, 4.749881691586538],
            [9.408861065687725, 4.7788860837622025],
            [9.494092245994175, 4.79203881393001],
            [9.508504467869038, 4.794755177472285],
            [9.577619137221605, 4.805925018993051],
            [9.57815578421586, 4.810342522990397]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.3858090758328, "lat": 42.660378097467294 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26125"],
        "coty_name": ["Oakland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oakland County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01623005"
      },
      "bbox": [
        9.408861065687725, 4.343512731040269, 9.904348953900207,
        4.852454910554715
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.3084690121714, 5.490093665846566],
            [9.319255087466182, 5.487274809668741],
            [9.323406729950939, 5.492405452441087],
            [9.33090752523897, 5.49470222833517],
            [9.333496345795522, 5.499459134049019],
            [9.34387378400431, 5.510917940156622],
            [9.351374068262091, 5.523626963733487],
            [9.357279089455, 5.531709434731129],
            [9.371764956297975, 5.556952528631578],
            [9.37486460529078, 5.5602762080835735],
            [9.376116682587636, 5.564461578126655],
            [9.381664871285752, 5.5764645227687115],
            [9.386420662620306, 5.584347503085404],
            [9.389462803265804, 5.586683342859657],
            [9.394522125150406, 5.600001125508504],
            [9.40012453272323, 5.599418634591061],
            [9.399609975729078, 5.604289028156148],
            [9.40245336500814, 5.608560214881875],
            [9.400516872522184, 5.612766170384073],
            [9.40683114683958, 5.623647008489231],
            [9.410691133767497, 5.623080018387419],
            [9.412197601217976, 5.627215357938198],
            [9.416900160940088, 5.633847141155003],
            [9.426195184607154, 5.626129251962987],
            [9.426336313047287, 5.622742403299521],
            [9.422938331636049, 5.6214558797326175],
            [9.422417754974553, 5.614752964579355],
            [9.438838123129466, 5.616868794632595],
            [9.442893538929473, 5.622565741333541],
            [9.446637023335553, 5.630098956798516],
            [9.450603671863208, 5.6403211439807235],
            [9.455151511313247, 5.646007035685599],
            [9.45593552817417, 5.650556688293434],
            [9.464569832210254, 5.590167340459799],
            [9.586391610468645, 5.6094838753928675],
            [9.62869475481792, 5.616329601572156],
            [9.652432200636083, 5.6204313429280095],
            [9.712439259103773, 5.63128691458079],
            [9.726618683990356, 5.544935689357781],
            [9.74207678411685, 5.459323994171254],
            [9.75618661407398, 5.373673007150959],
            [9.769752840766392, 5.287681424255454],
            [9.757911990698066, 5.285753608359301],
            [9.673843677233391, 5.2718030317409],
            [9.613769420898487, 5.26203838406878],
            [9.590683039404924, 5.258418327520043],
            [9.604237661660292, 5.172303475184086],
            [9.526244899836072, 5.159524451696623],
            [9.527504284409911, 5.149935364796692],
            [9.440747537470536, 5.138152124462693],
            [9.358900582031065, 5.126136557917967],
            [9.354978177230276, 5.155053878442643],
            [9.34558520531692, 5.230023779792323],
            [9.343285927657039, 5.230129418842024],
            [9.340272119269123, 5.254231364906251],
            [9.334605091075167, 5.2958728879894315],
            [9.32320021218661, 5.381405950441522],
            [9.312615298391687, 5.460014392115303],
            [9.3084690121714, 5.490093665846566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.41671388925059, "lat": 43.46403061577816 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26157"],
        "coty_name": ["Tuscola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tuscola County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01623019"
      },
      "bbox": [
        9.3084690121714, 5.126136557917967, 9.769752840766392, 5.650556688293434
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.536809473222888, 3.9279980231741773],
            [7.541766972601006, 3.939678981080101],
            [7.557523778649486, 3.9855069169285184],
            [7.5680990348097374, 4.023015649912272],
            [7.574086530113938, 4.047949486923377],
            [7.575562870344897, 4.062919628472203],
            [7.579641040074281, 4.0852123785854175],
            [7.578516039610801, 4.09241547637789],
            [7.580989310210662, 4.097700710864112],
            [7.584898166132361, 4.110698273536886],
            [7.619392852106144, 4.1143662654259625],
            [7.661900538279305, 4.1183267587818335],
            [7.690400340215164, 4.1214018254581255],
            [7.719089913462334, 4.12417843395416],
            [7.776171094753545, 4.130176268156159],
            [7.840875154995636, 4.137425943154019],
            [7.884582110626033, 4.142942493489179],
            [7.956054561691449, 4.151163144420046],
            [7.956352979063264, 4.150206788187552],
            [7.960314982643234, 4.112122534559469],
            [7.965093047242862, 4.062259195455533],
            [7.96874640586614, 4.0259081754441866],
            [7.974099080392292, 3.9753303787561016],
            [7.979748287805746, 3.928274533080956],
            [7.987906516734799, 3.8619920321688834],
            [7.995364456850816, 3.8004253382268196],
            [7.949207039903989, 3.7954133481832826],
            [7.868904982331344, 3.787161145564155],
            [7.827446047087626, 3.78326450411195],
            [7.77745720347912, 3.7783199090330624],
            [7.742361948357318, 3.775082408357535],
            [7.6579345062784006, 3.767022985888392],
            [7.652885427470932, 3.816633948348405],
            [7.646575969522078, 3.876376707781666],
            [7.639705246285865, 3.9387554279421413],
            [7.582714260249863, 3.9330067741484984],
            [7.554330404557934, 3.929619273561396],
            [7.536809473222888, 3.9279980231741773]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.01883889071482,
          "lat": 42.251286651386984
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26159"],
        "coty_name": ["Van Buren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Van Buren County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "01623020"
      },
      "bbox": [
        7.536809473222888, 3.767022985888392, 7.995364456850816,
        4.151163144420046
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4840698124561, 8.10951118563626],
            [2.5704638795543078, 8.111789858082577],
            [2.5995371194628136, 8.113126176613452],
            [2.6580726524815126, 8.114561554785258],
            [2.7456558511619775, 8.120486116449971],
            [2.760359268251521, 8.12102791325383],
            [2.7746475070051586, 8.119652953694068],
            [2.788876677080493, 8.119560830862145],
            [2.8688115577359063, 8.121577843098464],
            [2.874834793419515, 8.12136348995493],
            [2.904446453012328, 8.122787916467589],
            [2.9190441022872515, 8.12256477927105],
            [2.9912885079144655, 8.125523159141228],
            [3.006189248177614, 8.125181878607348],
            [3.0101995620075352, 8.029346231142211],
            [3.0165996439827722, 8.02666144501984],
            [3.018524763055728, 7.988230213672524],
            [3.022966129259856, 7.868903310359259],
            [3.0230207380435137, 7.860590938234026],
            [3.0257305451532353, 7.783220495805177],
            [3.0098301739834943, 7.782820222499855],
            [2.9697726808308627, 7.781268425542963],
            [2.9688429845224746, 7.781446858825886],
            [2.8837352820833817, 7.778692408582215],
            [2.8169776945804927, 7.776348412273929],
            [2.7469364461962256, 7.7740364248538425],
            [2.676895662690076, 7.771709978912432],
            [2.6442504713959636, 7.7710826195474],
            [2.587087027065194, 7.769682241636868],
            [2.4992512715084803, 7.766983633910506],
            [2.4963228672815383, 7.853494103225762],
            [2.4936282135344827, 7.924707652290459],
            [2.493933864728943, 7.93872649991217],
            [2.4884788697397724, 7.938629374076283],
            [2.486460234175823, 7.973924942587081],
            [2.484428784911675, 8.02059263913288],
            [2.4840698124561, 8.10951118563626]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.6770275966932, "lat": 46.5923508154156 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27017"],
        "coty_name": ["Carlton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carlton County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00659454"
      },
      "bbox": [
        2.4840698124561, 7.766983633910506, 3.0257305451532353,
        8.125523159141228
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.674775935353538, -1.6741720900059505],
            [4.712779992195709, -1.672358802943964],
            [4.797783281790558, -1.6667925393245175],
            [4.875223979361994, -1.6632300192626572],
            [4.914831939498962, -1.6609825245718743],
            [4.9323667929637685, -1.659739698945768],
            [4.954217348561135, -1.6590438423913247],
            [4.966495212817889, -1.6592990095718414],
            [4.986157682739319, -1.6588210004798243],
            [5.007017012604376, -1.6593180488708628],
            [5.006570131186502, -1.6624076609605205],
            [5.009059231938395, -1.6721819985953397],
            [5.0127873914169, -1.6780249802127638],
            [5.01260371068975, -1.682184555825016],
            [5.016339742441081, -1.6834851195373552],
            [5.015959589314447, -1.691458230350717],
            [5.014326616091225, -1.693597426523676],
            [5.015675507727219, -1.7001291642014886],
            [5.014065031216218, -1.7048188808967943],
            [5.01439459988409, -1.7119248608191933],
            [5.017898851489379, -1.713987607185239],
            [5.021108899739164, -1.7125576398124065],
            [5.022853657418555, -1.7159845231793558],
            [5.027724563531423, -1.7180853009335553],
            [5.034151894700999, -1.7303959034499068],
            [5.038296440189064, -1.7336007679320582],
            [5.045267631016505, -1.737106499361678],
            [5.039496165234329, -1.747987794465828],
            [5.045310159501411, -1.75357083647237],
            [5.0422959233807285, -1.760014627510866],
            [5.049119272856883, -1.7588408969314688],
            [5.047017556408157, -1.7655275030746207],
            [5.0538633592170665, -1.7682141606093256],
            [5.054174814635699, -1.77179342636452],
            [5.058093386839538, -1.7707040537823673],
            [5.062214805779662, -1.7751678288932258],
            [5.057632824144398, -1.7779387902738903],
            [5.059739345719739, -1.7806976938948966],
            [5.059250496480387, -1.7873527699701304],
            [5.0618449022192, -1.7924850165257624],
            [5.061430107260778, -1.8024455594571778],
            [5.0580801958187, -1.8047134866594194],
            [5.059194272389119, -1.8075844865749986],
            [5.063573196399439, -1.806258610082958],
            [5.065513602300464, -1.8099646865298011],
            [5.07089616438566, -1.8071009787480827],
            [5.072104235065949, -1.8095252627781087],
            [5.070366995577091, -1.8148806902037853],
            [5.0751936925179795, -1.8170420384127646],
            [5.078571509231085, -1.8248311608484304],
            [5.083599413723976, -1.827250624485988],
            [5.085807045567791, -1.830946884457336],
            [5.082577770163021, -1.8365143483308828],
            [5.089088921778209, -1.8379771103728968],
            [5.089997509084149, -1.841115050746075],
            [5.094618763107631, -1.8439328671512762],
            [5.092714944802446, -1.8463397555595824],
            [5.098801019029022, -1.8549856498652357],
            [5.100872246305001, -1.8618936573853133],
            [5.1043054570423045, -1.8613497097447105],
            [5.102785645927632, -1.8668550595528892],
            [5.106080449345207, -1.8780367648105727],
            [5.113443340160591, -1.8791155738970444],
            [5.114533291357406, -1.884047590464908],
            [5.111942974850963, -1.8906967360301616],
            [5.1082234083751885, -1.893561538216523],
            [5.108696637176865, -1.9006929574280351],
            [5.119063089397486, -1.909909406054233],
            [5.119200640611059, -1.9181764963543704],
            [5.112016437455114, -1.9218242710165339],
            [5.1179918502693935, -1.9293450746535723],
            [5.119072633649509, -1.9352398021152148],
            [5.112738166017129, -1.9449318397250477],
            [5.112184136259841, -1.9474922273194082],
            [5.113414418603195, -1.9530147920328358],
            [5.110178411899527, -1.956528851398285],
            [5.106222807349522, -1.954559477630695],
            [5.106954279025256, -1.9614430982793036],
            [5.1024884564438535, -1.9644905836422784],
            [5.1021074271649836, -1.9602015902006205],
            [5.097159321931143, -1.9642680448300314],
            [5.098249912288606, -1.969154352251042],
            [5.102444697994303, -1.9713783375682812],
            [5.101217560290998, -1.9749604480050944],
            [5.097708096545477, -1.9739215099075442],
            [5.096590875852053, -1.9772612416462303],
            [5.0895769515369045, -1.9853789258287406],
            [5.085955865141055, -1.9956383447002792],
            [5.084914421851388, -2.0031690747302],
            [5.086607763628085, -2.0069237300609446],
            [5.090350526011566, -2.0106670314385675],
            [5.087760362904355, -2.014544466293125],
            [5.089142209839635, -2.0185435246967076],
            [5.0850214815008385, -2.0260179650792463],
            [5.08768764762432, -2.0320590676133254],
            [5.085197255589465, -2.036266759882203],
            [5.077768959128471, -2.032682753580253],
            [5.0771013648732515, -2.0395493338251143],
            [5.07341424149966, -2.0405749375462943],
            [5.06879265201955, -2.0397338264971334],
            [5.067604858147453, -2.044585128084754],
            [5.070688439082441, -2.050569895305785],
            [5.064043729955817, -2.054837844012464],
            [5.065709030748523, -2.059222146138741],
            [5.06208579864961, -2.060358445267289],
            [5.065146568092648, -2.066622688373798],
            [5.063173649264695, -2.0724786976754195],
            [5.065358984163455, -2.084648527779862],
            [5.056420135886646, -2.085225187159584],
            [4.968204392393457, -2.0900863297807803],
            [4.899766637816929, -2.0940458290809385],
            [4.780355667122403, -2.1008089978237776],
            [4.7761054529966875, -2.0066641971270944],
            [4.761583762935165, -2.0068908203231244],
            [4.757259498163826, -1.919291222177714],
            [4.728522730601979, -1.9207437838506087],
            [4.728026777934966, -1.9072049588955162],
            [4.725033126356716, -1.8496908916309822],
            [4.721717159685126, -1.788312742017512],
            [4.693899620206643, -1.789376566757864],
            [4.690936250945408, -1.7173175394351616],
            [4.676304067080036, -1.7179383852741217],
            [4.674775935353538, -1.6741720900059505]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.40647613647158,
          "lat": 36.716330471052416
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29023"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00758466"
      },
      "bbox": [
        4.674775935353538, -2.1008089978237776, 5.119200640611059,
        -1.6588210004798243
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.924515686915772, 1.4449775240646103],
            [10.918644510968292, 1.5345862552574365],
            [11.003019508748482, 1.5402109670739952],
            [11.00513845705693, 1.540477555822448],
            [10.998134378717362, 1.6315086841461757],
            [11.021236719119376, 1.633058573853874],
            [11.028019494837869, 1.633853559024297],
            [11.083339410489087, 1.6381879250229756],
            [11.090499542195223, 1.5466572414017394],
            [11.17853186201643, 1.5538869459869487],
            [11.251528854019577, 1.5605913779915332],
            [11.2614601930478, 1.4635460389767045],
            [11.264636125611553, 1.427806252321941],
            [11.27915060785714, 1.4293691519037228],
            [11.280747102669226, 1.4145498133842647],
            [11.295134822043716, 1.4159464679159033],
            [11.298234435481012, 1.3863286847750254],
            [11.37189890611449, 1.3943623328656178],
            [11.37715435719372, 1.3403089496566218],
            [11.374438518387507, 1.3358648018983033],
            [11.37276067227743, 1.3294700567824145],
            [11.372351996292316, 1.319608753737768],
            [11.369011137158875, 1.3122931288803408],
            [11.361235209677137, 1.3060963172474578],
            [11.359537260086013, 1.3016019385572117],
            [11.294760759480976, 1.2953023019701757],
            [11.202605103068299, 1.2864730918710157],
            [11.169456386496238, 1.2834506558321563],
            [11.134968711296525, 1.2800537731239676],
            [11.025281688057055, 1.2715124205654924],
            [10.966712926241442, 1.2670912839440025],
            [10.960081204452944, 1.3570577442272223],
            [10.930774599844007, 1.3549208879224541],
            [10.924515686915772, 1.4449775240646103]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.04519726313715,
          "lat": 39.333873849969386
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39009"],
        "coty_name": ["Athens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Athens County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01074018"
      },
      "bbox": [
        10.918644510968292, 1.2670912839440025, 11.37715435719372,
        1.6381879250229756
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.93712545847927, 1.8150390718932738],
            [8.932176911604737, 1.8656140503873742],
            [8.92688333593095, 1.9175321968130745],
            [8.917982079935063, 2.008657519670674],
            [8.911450691261308, 2.0735531127369504],
            [8.906432048383381, 2.121145002150761],
            [8.901198790585289, 2.1638415343631627],
            [8.971816950054915, 2.171526904619554],
            [9.040318720786438, 2.179385896029811],
            [9.054472585362328, 2.181125711735023],
            [9.0543798785499, 2.1825818881544947],
            [9.132894081290722, 2.1931026606072934],
            [9.177942887018173, 2.198638853993854],
            [9.18150598746686, 2.1696539603920675],
            [9.193750930179872, 2.0760700269663],
            [9.197639156829592, 2.050759756035047],
            [9.198743057099191, 2.0414784775057884],
            [9.199631788937538, 2.033331955534251],
            [9.197908308623507, 2.024882352201387],
            [9.20094742449581, 2.0252934017839155],
            [9.213353616939923, 1.9390394205630388],
            [9.219518662455418, 1.8954362526068949],
            [9.223095748054428, 1.8665031743733635],
            [9.225871420909172, 1.8502257845460732],
            [9.22954162326319, 1.8225025824908518],
            [9.230994474507671, 1.815472485692987],
            [9.233957908436174, 1.7911747411270267],
            [9.237763474050098, 1.7643756703709441],
            [9.193043885201988, 1.7577702214559707],
            [9.109600562517084, 1.7458891765930569],
            [9.013842157814352, 1.7342040603644486],
            [9.006225276087752, 1.7335366326655115],
            [8.946459797028396, 1.7265932295140503],
            [8.938070236313457, 1.8052500214340235],
            [8.93712545847927, 1.8150390718932738]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.61931677032307, "lat": 40.13322779787866 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39037"],
        "coty_name": ["Darke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Darke County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01074031"
      },
      "bbox": [
        8.901198790585289, 1.7265932295140503, 9.237763474050098,
        2.198638853993854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.10414940238275, 1.3237041685901192],
            [10.115628207829323, 1.3509579201137554],
            [10.129689571850298, 1.3858599506753284],
            [10.145475121855911, 1.4242719803041068],
            [10.165855990870929, 1.4733453369100689],
            [10.25072825907709, 1.4802763371751506],
            [10.283951816302466, 1.4832704107800116],
            [10.374803270618772, 1.4917620033616343],
            [10.380838355524723, 1.4929659394635044],
            [10.381618974527495, 1.4902977008225913],
            [10.386057764708474, 1.4876751453534496],
            [10.386264754583351, 1.476913111259153],
            [10.379260568522968, 1.476756040963414],
            [10.375414705053736, 1.4732796406693442],
            [10.374181851481056, 1.4648590075519727],
            [10.436359126962666, 1.4699738816762762],
            [10.486600905489402, 1.4736412945904986],
            [10.563840975302497, 1.478985965368958],
            [10.570820164296386, 1.480258781564482],
            [10.573374306025391, 1.4474446608830747],
            [10.578921178409066, 1.3793009435177126],
            [10.57961656394689, 1.3681873199869532],
            [10.586390985969077, 1.276386219609267],
            [10.587512717945627, 1.2626082343913638],
            [10.590527055479194, 1.2176610823457577],
            [10.593271213608956, 1.1770737120965191],
            [10.578530029727165, 1.1760300672582278],
            [10.536648175274602, 1.173487966763793],
            [10.447306066335416, 1.167160751386752],
            [10.356077202373568, 1.160520769169377],
            [10.215968211136815, 1.1516120271858723],
            [10.142793671473447, 1.1457510104347868],
            [10.1456654381124, 1.18242104284437],
            [10.142393235009614, 1.1816070988423608],
            [10.14297577909009, 1.1881221323122009],
            [10.141342357726275, 1.1948557140214233],
            [10.142105438049814, 1.199783846128365],
            [10.140355775106316, 1.2016779066204368],
            [10.134081411756453, 1.1980285224637794],
            [10.134570565279583, 1.195669315623528],
            [10.130328985520544, 1.1878636288309647],
            [10.124992414721929, 1.1901552498867078],
            [10.12218477049992, 1.193696479076009],
            [10.11484480171895, 1.1950021351292341],
            [10.115997111110996, 1.2043094907504828],
            [10.112628172429636, 1.2080682058054957],
            [10.103566162047121, 1.2108463785754826],
            [10.101984623472621, 1.2166798365307891],
            [10.103819914630968, 1.2205262665910213],
            [10.110872752850545, 1.2237403939707208],
            [10.109461846839897, 1.2294152252982442],
            [10.112531930894772, 1.238114948313265],
            [10.108365770001187, 1.2393405489983147],
            [10.107034977063492, 1.2421066648113264],
            [10.106815911350589, 1.2501847662243886],
            [10.104206166655985, 1.253519375498723],
            [10.10420814390963, 1.2617949044592254],
            [10.100714273320504, 1.2668382219486098],
            [10.103148272741096, 1.272664624725476],
            [10.10170669712502, 1.276587864919404],
            [10.102021157884396, 1.2846096801037858],
            [10.105039630804969, 1.2895071971127579],
            [10.10627339637001, 1.294322234163834],
            [10.101207733106596, 1.3021243821371538],
            [10.104808910532133, 1.3147943839247116],
            [10.103079883193935, 1.3209383881082037],
            [10.10414940238275, 1.3237041685901192]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.05703071824298, "lat": 39.33758723866136 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39141"],
        "coty_name": ["Ross"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ross County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01074083"
      },
      "bbox": [
        10.100714273320504, 1.1457510104347868, 10.593271213608956,
        1.4929659394635044
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.578921178409066, 1.3793009435177126],
            [10.636516621833579, 1.382304562769156],
            [10.665472117207852, 1.38477034121961],
            [10.664420398083132, 1.3992989581743738],
            [10.68389214810892, 1.4003499217878694],
            [10.75389838687696, 1.4053940523129567],
            [10.754122492497018, 1.4111349063895566],
            [10.752494932326075, 1.4320036632859203],
            [10.835995205508043, 1.4384917311547136],
            [10.877373216763912, 1.441383867013364],
            [10.924515686915772, 1.4449775240646103],
            [10.930774599844007, 1.3549208879224541],
            [10.960081204452944, 1.3570577442272223],
            [10.966712926241442, 1.2670912839440025],
            [10.937532248484898, 1.2646213809828573],
            [10.940364177079791, 1.2268610305325667],
            [10.943424054279026, 1.1892653305356689],
            [10.944310315081193, 1.1749207584988508],
            [10.95096881040932, 1.0852015593113566],
            [10.926212244949452, 1.083886518254229],
            [10.864282060320962, 1.0802472307106363],
            [10.857601311430647, 1.1840581347544843],
            [10.799943897147054, 1.1792135075835466],
            [10.768747873805532, 1.1781237831849611],
            [10.7665994177474, 1.214814010116139],
            [10.757760328655936, 1.2153262543989483],
            [10.736910085267532, 1.2153920402198555],
            [10.709149941238332, 1.2115527205881662],
            [10.677797638199136, 1.2111890397695873],
            [10.677065773412254, 1.224033860925562],
            [10.590527055479194, 1.2176610823457577],
            [10.587512717945627, 1.2626082343913638],
            [10.586390985969077, 1.276386219609267],
            [10.57961656394689, 1.3681873199869532],
            [10.578921178409066, 1.3793009435177126]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.48535384623878, "lat": 39.25098039192073 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39163"],
        "coty_name": ["Vinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vinton County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01074093"
      },
      "bbox": [
        10.578921178409066, 1.0802472307106363, 10.966712926241442,
        1.4449775240646103
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.4462940808618296, -1.6180061779290753],
            [-3.4139799971714178, -1.6192691056965225],
            [-3.3753059375512597, -1.6211901274056661],
            [-3.34261217050519, -1.6223901949885342],
            [-3.279604769238648, -1.6255829617776363],
            [-3.2329907258841097, -1.6272558777276236],
            [-3.1996198485064373, -1.6286401481133599],
            [-3.135868901033424, -1.630914719650089],
            [-3.1350172531619678, -1.6310717254547515],
            [-3.0422994416149827, -1.6349612506005964],
            [-2.912460414096512, -1.6402153951116036],
            [-2.852209137652015, -1.6425581120887136],
            [-2.7905459502801326, -1.6451805192420639],
            [-2.7698172733480213, -1.6461911173282973],
            [-2.7011464549258046, -1.6495044572804936],
            [-2.7014835832808046, -1.6540461292842479],
            [-2.703640888564548, -1.7076799829989504],
            [-2.7117931237436728, -1.877542769103933],
            [-2.7189826164720228, -2.0612914194458156],
            [-2.7222045165102426, -2.126166395330314],
            [-2.723438140318038, -2.1555663471867077],
            [-2.792065251524169, -2.1527106394831734],
            [-2.8646174799721456, -2.149554923763048],
            [-2.978313248330826, -2.144421377348521],
            [-2.986529497868491, -2.14430867733275],
            [-3.0713204597691175, -2.140323495284918],
            [-3.1358861471386774, -2.137479832571115],
            [-3.154907530110112, -2.1365198153546534],
            [-3.236185970415659, -2.132466849449199],
            [-3.326419383348514, -2.12784277376482],
            [-3.3972167427478452, -2.1241791541219506],
            [-3.4793788132645966, -2.1200423669765174],
            [-3.4705255832041604, -1.9474848893010845],
            [-3.465532763008632, -1.856013287456799],
            [-3.4608371131070736, -1.7688062836714107],
            [-3.4542097491347046, -1.7686776319044004],
            [-3.4462940808618296, -1.6180061779290753]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.47679001431176,
          "lat": 36.74964892936937
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40007"],
        "coty_name": ["Beaver"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beaver County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01101791"
      },
      "bbox": [
        -3.4793788132645966, -2.1555663471867077, -2.7011464549258046,
        -1.6180061779290753
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6537494160486044, -3.237313876529752],
            [-1.6512444801776427, -3.1494077557097704],
            [-1.5661713404754813, -3.1517489947291617],
            [-1.5505460368122532, -3.1520519439318635],
            [-1.4601684515382174, -3.154421688219371],
            [-1.446640916168897, -3.1549692941963836],
            [-1.4013659616913996, -3.1558876396882236],
            [-1.397455016388278, -3.156194229585918],
            [-1.3976246489661, -3.1627686642595427],
            [-1.396294901360281, -3.1714139774941783],
            [-1.3976918897857487, -3.2370488247327356],
            [-1.3990415420237243, -3.287981946468513],
            [-1.4000501150189506, -3.3315282626501626],
            [-1.386706851333131, -3.331760745877981],
            [-1.359004973253084, -3.332971207628926],
            [-1.3222031594348205, -3.3338062342974384],
            [-1.290612428845779, -3.33407682733589],
            [-1.2301100996488956, -3.334940234475428],
            [-1.2311899116549416, -3.4079819994043095],
            [-1.2321913128532107, -3.466256238085426],
            [-1.2331416965328, -3.5101657026410047],
            [-1.2301960665913756, -3.51022039270655],
            [-1.2325403693072219, -3.6255157194732406],
            [-1.234076302598814, -3.6277886735593823],
            [-1.2354707188107383, -3.686225559448662],
            [-1.2370934895847512, -3.761145968213661],
            [-1.2393887983833465, -3.8611090285714926],
            [-1.2999263392836973, -3.8596362195458656],
            [-1.3822294032086462, -3.85768924333336],
            [-1.4571183781792723, -3.8558620826497294],
            [-1.578370642286183, -3.852666977003407],
            [-1.6678360011245417, -3.8501538829066715],
            [-1.6673032809865238, -3.8209811673313765],
            [-1.6663322131969727, -3.7918771648472562],
            [-1.6657148008580018, -3.7626479616818043],
            [-1.663838378643385, -3.6895998155774916],
            [-1.6618078472427773, -3.6062507591897623],
            [-1.65963616029784, -3.6019823106015636],
            [-1.6592803937401848, -3.5867746471460595],
            [-1.6566861630573886, -3.4992639209887004],
            [-1.661198256926972, -3.4991205641422787],
            [-1.660952616930843, -3.4845294105825566],
            [-1.657414320589215, -3.3683766283601893],
            [-1.655535620180151, -3.3029585728093642],
            [-1.6537494160486044, -3.237313876529752]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.37513908305914,
          "lat": 35.174413232783415
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40015"],
        "coty_name": ["Caddo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caddo County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01101795"
      },
      "bbox": [
        -1.6678360011245417, -3.8611090285714926, -1.2301100996488956,
        -3.1494077557097704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9077105230919285, -3.4346178922324575],
            [0.922720791976093, -3.4287114393323286],
            [0.9272286151442074, -3.424958490829384],
            [0.9354014541226224, -3.41201888217051],
            [0.9399797980968312, -3.4068547624380208],
            [0.9471607697377514, -3.403990260711574],
            [0.954025929809323, -3.402536970265832],
            [0.9605062016733357, -3.404006024948467],
            [0.9690608193220972, -3.413517344489661],
            [0.9760476473683376, -3.418103560743262],
            [0.9849960006913209, -3.4253948271186605],
            [0.9869580781387336, -3.428402582764963],
            [0.9883863742924178, -3.439939204981307],
            [0.993881731175526, -3.4370779591375187],
            [1.0005800825885223, -3.432639009617532],
            [1.0165445609871417, -3.4278001692034032],
            [1.020525146439781, -3.4271602361252773],
            [1.0292724755154772, -3.4284056367053886],
            [1.0400818498392213, -3.4349718190253764],
            [1.0514660039761041, -3.4468258043976765],
            [1.0609123146364425, -3.460796472757781],
            [1.0651227885739631, -3.4640142027593255],
            [1.0741083974341874, -3.467929092168103],
            [1.0783116118062166, -3.4673901985408317],
            [1.0858725994415213, -3.4636873658495104],
            [1.0928944998491665, -3.457794980979313],
            [1.1034691728230246, -3.4455254063673006],
            [1.1066812709138105, -3.4398614703180095],
            [1.1086386739502443, -3.4300438185706765],
            [1.1115731942262284, -3.425546975001836],
            [1.1156777216835678, -3.423786283528142],
            [1.1206630257413162, -3.4241034372399035],
            [1.1268688722809728, -3.427758159328124],
            [1.1299690055959337, -3.4276538658875495],
            [1.1337430871050982, -3.4233825141673044],
            [1.1347554176424077, -3.4187886282688917],
            [1.1330836986156465, -3.410020637611974],
            [1.1269034329732899, -3.3956286039896697],
            [1.1247463505444408, -3.391935010799482],
            [1.1252711927766825, -3.386873851362246],
            [1.1307644751115422, -3.378088732965903],
            [1.138262455182849, -3.3754934950133975],
            [1.1446074235779775, -3.377582806649797],
            [1.1505822470586242, -3.382630785400828],
            [1.1556265119523492, -3.3798099931840766],
            [1.1579329035992687, -3.372801777048096],
            [1.1529000924929704, -3.367209046612353],
            [1.146162184367427, -3.365588165030195],
            [1.1412751134884056, -3.3605120061494205],
            [1.1444857168655829, -3.356859919113287],
            [1.1593733707242766, -3.348182948617006],
            [1.166900131087773, -3.3493231418234677],
            [1.1723418270313872, -3.3557916309751477],
            [1.174930084229362, -3.35502043494384],
            [1.179049197439073, -3.3494015092456766],
            [1.1870372464583128, -3.3334242637896567],
            [1.1894306849617275, -3.3301786496261316],
            [1.1978590006169532, -3.3242568015999354],
            [1.200676917396818, -3.323222628317078],
            [1.2042432686610764, -3.316037019569916],
            [1.2059888599915203, -3.304336093646808],
            [1.2067806158152088, -3.2943564851769853],
            [1.2115316677696712, -3.284640469572285],
            [1.2155874924654315, -3.278255918937011],
            [1.224563161315051, -3.2713178661915028],
            [1.2307481272211478, -3.268033963700393],
            [1.2360148130484891, -3.269894131020699],
            [1.2420696557918598, -3.2698330506155777],
            [1.2509904496867867, -3.2736707462969994],
            [1.252330710880009, -3.278290655681328],
            [1.2514179835418255, -3.291697094789681],
            [1.2521955503919697, -3.296624813152513],
            [1.2553203535554276, -3.301931261795298],
            [1.2662702508687287, -3.312288249525162],
            [1.2713686897491647, -3.314828547921309],
            [1.2822346410175272, -3.3183850877661705],
            [1.2918288581505777, -3.318703410747183],
            [1.2991145900090015, -3.3198796462167057],
            [1.3045915351839497, -3.318254699671308],
            [1.312921687031505, -3.3191744499846862],
            [1.3213957062938444, -3.329828672316593],
            [1.3317567160094437, -3.3334895563560862],
            [1.3387756112516789, -3.3324853994594883],
            [1.343504734735682, -3.3289867249846616],
            [1.3487031383358283, -3.3272601147067062],
            [1.3510185935334686, -3.328137939455712],
            [1.3555804895727444, -3.3342967849267096],
            [1.3588795909072864, -3.3417401042199],
            [1.358932871125279, -3.3464421496866334],
            [1.3570407722918025, -3.3530995755728155],
            [1.3508824144425426, -3.3591142410333776],
            [1.3405784786818293, -3.3678305795181194],
            [1.3374356227493114, -3.3724076122221667],
            [1.337930289663629, -3.37615565743076],
            [1.343463004215424, -3.3798825180816183],
            [1.351496108501735, -3.379731875314142],
            [1.3566929848409441, -3.3771740334883806],
            [1.3805514504517886, -3.3694304796610464],
            [1.3856665872704272, -3.365924846009565],
            [1.3935144258303922, -3.3572139687422298],
            [1.3995727777977718, -3.3546104524021665],
            [1.4036954097659662, -3.356206969173908],
            [1.408463833693967, -3.360078639813761],
            [1.4101635094350888, -3.3637178701429153],
            [1.4104863867473176, -3.3789392825448004],
            [1.4118587413426815, -3.3883754804065305],
            [1.4149303786592917, -3.396418821472252],
            [1.4174842138980022, -3.3999111501465658],
            [1.4232190905849782, -3.402403014481539],
            [1.4229891278318816, -3.407170524447473],
            [1.4242187623803892, -3.5242512213409705],
            [1.3322822690707514, -3.525060353805086],
            [1.3327929158965806, -3.5759014984880495],
            [1.3338527471238233, -3.6703795589078547],
            [1.2269763332286043, -3.6721007211421206],
            [1.130062007063146, -3.672926503298917],
            [1.077376795974318, -3.6732429532411133],
            [1.0128844021334613, -3.6733284556562174],
            [0.9917444482790709, -3.673197948806504],
            [0.990949636781943, -3.571026930826825],
            [0.9075157933550821, -3.571056432311752],
            [0.9054465728033173, -3.571201192553399],
            [0.9050625868324266, -3.5286163510126634],
            [0.908466565328797, -3.5284900767715346],
            [0.9077105230919285, -3.4346178922324575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.1166465616075, "lat": 35.22479225935629 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40061"],
        "coty_name": ["Haskell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haskell County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01101818"
      },
      "bbox": [
        0.9050625868324266, -3.6733284556562174, 1.4242187623803892,
        -3.268033963700393
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.3402401998362652, -2.2110913587893823],
            [-0.33818819143244944, -2.2289570494010107],
            [-0.33332914886562454, -2.2371211113193916],
            [-0.3269092974897378, -2.240560783697962],
            [-0.31992257983936934, -2.248084273360196],
            [-0.31851414901040953, -2.252554605857548],
            [-0.3068556408714204, -2.2586661756854993],
            [-0.29656986259085055, -2.2588406908298535],
            [-0.2853805004347413, -2.263515775850825],
            [-0.28026851882116616, -2.262808558234491],
            [-0.2736150866083995, -2.2563993487735168],
            [-0.26721398340436964, -2.2552115058710713],
            [-0.26314518903132006, -2.2513083785975874],
            [-0.2562104195994407, -2.250232661432873],
            [-0.2505457587122237, -2.2505142580047606],
            [-0.24555929186138262, -2.247257376070306],
            [-0.2403996867006655, -2.246833398416084],
            [-0.2335195116696136, -2.248485844527661],
            [-0.2276083573506143, -2.2419234677904063],
            [-0.22566920529873824, -2.238214709079234],
            [-0.21913842896903282, -2.2335184580566594],
            [-0.21464374377776785, -2.228339374793025],
            [-0.21120175738244581, -2.2204954711596097],
            [-0.20335698248051434, -2.2075644998812796],
            [-0.20311990568780328, -2.1984690711743817],
            [-0.20042079443235275, -2.194620928254122],
            [-0.1940074971835452, -2.1897326497047414],
            [-0.18934535619144877, -2.179875323813245],
            [-0.17915846389596088, -2.1722610143495573],
            [-0.1713470700186907, -2.16566249388138],
            [-0.16554880500253377, -2.163688175908651],
            [-0.15940647381702056, -2.158742129104649],
            [-0.1484308468785781, -2.1538963627856487],
            [-0.13579120666953445, -2.1568284335759187],
            [-0.13195785268538085, -2.159960947600964],
            [-0.1275881294793108, -2.1655661072696177],
            [-0.12290916225978651, -2.16955316960124],
            [-0.1193260580853819, -2.176496465999024],
            [-0.11590136641699283, -2.187889269189416],
            [-0.11490859372336089, -2.1937893907584813],
            [-0.11219782407576188, -2.199809482331892],
            [-0.11201351225738108, -2.211150863502144],
            [-0.11341271547353467, -2.2169236393922107],
            [-0.10956004248600922, -2.2233920011058705],
            [-0.10141192960921984, -2.229143773727084],
            [-0.09874320102662251, -2.2341752326036413],
            [-0.09875072708443744, -2.2428989961117853],
            [-0.10201232729109631, -2.2495789217163225],
            [-0.10368670095623198, -2.2553011565936494],
            [-0.10839295120470006, -2.266617152474271],
            [-0.10770261964911747, -2.275333766543415],
            [-0.10269517045118408, -2.283126406292978],
            [-0.09903117055963412, -2.2854354116346896],
            [-0.09575227589149142, -2.2895197470535473],
            [-0.08637476913606938, -2.2969125757755218],
            [-0.07392633172491227, -2.300719932806362],
            [-0.06368906802573968, -2.298495039515771],
            [-0.0524508043549771, -2.2973700203535192],
            [-0.042971997831408225, -2.295399422188263],
            [-0.03635233829664462, -2.299156381778014],
            [-0.03247179105910358, -2.3050907781223047],
            [-0.030726867694276717, -2.311576904630226],
            [-0.02501777755660036, -2.316273993093192],
            [-0.019781851271492994, -2.3183874351624656],
            [-0.0180559937256857, -2.3234538527411726],
            [-0.016273344086370295, -2.3396015930596805],
            [-0.0078393107673196, -2.3469025695900254],
            [-0.001345430289530313, -2.3485171318238343],
            [0.004559579259038709, -2.347709882869761],
            [0.012038519254308723, -2.3416263076922785],
            [0.016388860573893573, -2.3357464839915636],
            [0.026363986711310856, -2.3256667024329136],
            [0.032602848063520096, -2.321594155035833],
            [0.036095311151916984, -2.3221454921389597],
            [0.043832077529747236, -2.327889647652069],
            [0.04714217326987087, -2.3351318416777462],
            [0.05003097214577991, -2.3447145879197144],
            [0.046425083257324175, -2.3571624622501313],
            [0.03756996701031373, -2.3664509894498127],
            [0.027727838175499606, -2.370229803238711],
            [0.021751686041215794, -2.371078772077632],
            [0.017702339442928983, -2.37381461773075],
            [0.006888592812230866, -2.3897949766209843],
            [0.005969901974314947, -2.4068605315052065],
            [0.01355530402131135, -2.416600113333894],
            [0.0226614956559949, -2.4228782852752166],
            [0.026984704081428484, -2.424717631485458],
            [0.03545007748206532, -2.426490436637478],
            [0.04433652007940934, -2.4265511199036824],
            [0.05237286937415993, -2.4246516227497783],
            [0.059996637599967095, -2.4199392885020874],
            [0.0634437727365049, -2.4156066764858966],
            [0.06678622192444036, -2.4055800454061647],
            [0.07418947753356629, -2.3949265925659784],
            [0.07739110896786053, -2.391719553744412],
            [0.08541688393877449, -2.38926879132587],
            [0.09313298350908938, -2.3888398816795973],
            [0.09916179197181782, -2.3907601542403953],
            [0.10794300027787249, -2.4018002449144493],
            [0.11092002546324495, -2.408017769692947],
            [0.11363901660593653, -2.4181833935386368],
            [0.11405379164663439, -2.4291692447371545],
            [0.11731970015202851, -2.4375246835147952],
            [0.12209142772703273, -2.4433008666709823],
            [0.12637329186691076, -2.4460702005642845],
            [0.14322424655057153, -2.450166072870243],
            [0.15478944774131387, -2.4565977517570157],
            [0.1671157090535287, -2.4680790314028997],
            [0.17407814520379705, -2.4738803964823974],
            [0.18288723640392235, -2.4866150079186116],
            [0.1920343346201521, -2.4941672287758467],
            [0.20262208537267348, -2.4977066392498615],
            [0.22281307632015324, -2.496088205318404],
            [0.23159967806793558, -2.4974779398114753],
            [0.2500982364447086, -2.496950304270179],
            [0.25640664703599647, -2.497931833154514],
            [0.26077242488577607, -2.500686549396433],
            [0.2668354182117782, -2.509870080375687],
            [0.2696241098182488, -2.519912968347828],
            [0.26868946669925425, -2.5277398004574727],
            [0.26580344497349323, -2.533193797468808],
            [0.25765201643135166, -2.541126281968367],
            [0.2522042484814238, -2.5453646598285578],
            [0.24846287740290335, -2.5511613671107454],
            [0.2476265531970455, -2.5572696707304305],
            [0.24914609813034336, -2.562965123355676],
            [0.22547024957135117, -2.562593178061616],
            [0.1628877887058341, -2.5619207570125373],
            [0.05364495548014945, -2.5606541743210207],
            [-0.03289856848406616, -2.5601758687275185],
            [-0.0338841324866688, -2.563735022331912],
            [-0.06537215035528784, -2.5637888114643403],
            [-0.09992767115820671, -2.563571962410966],
            [-0.16335240442083157, -2.5634548902722156],
            [-0.1780593237648864, -2.563204212017903],
            [-0.1913748238647039, -2.563567711408407],
            [-0.19063634428219645, -2.5051058815838108],
            [-0.19024258650951173, -2.491971984855874],
            [-0.19058340078152503, -2.475243331729823],
            [-0.27535147394638787, -2.4744703278398106],
            [-0.275232085712904, -2.4730414255626063],
            [-0.27439187150121974, -2.3868659993290975],
            [-0.35991405881898686, -2.385976152037545],
            [-0.35894604274486297, -2.298232619008512],
            [-0.3580205684047795, -2.2108783039350404],
            [-0.3402401998362652, -2.2110913587893823]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.69923410324844, "lat": 36.31688111689476 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40117"],
        "coty_name": ["Pawnee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pawnee County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01101846"
      },
      "bbox": [
        -0.35991405881898686, -2.5637888114643403, 0.2696241098182488,
        -2.1538963627856487
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.860785011901875, 4.1025898494564075],
            [11.941875323177591, 4.115829363001802],
            [12.044870302983618, 4.132918177638262],
            [12.089017937728416, 4.1398568933225715],
            [12.132810018722644, 4.14719045686993],
            [12.16974377149105, 4.154121005170634],
            [12.304966682423949, 4.178004701384814],
            [12.412752511565616, 4.196686357384051],
            [12.472160025640527, 4.207560574135577],
            [12.522112539738755, 4.214998591571107],
            [12.53481857718716, 4.139953452864527],
            [12.546530880789666, 4.071273307674083],
            [12.548640840689156, 4.06091126275247],
            [12.559772195009197, 3.9972413722436846],
            [12.560471862981228, 3.990662622033346],
            [12.561662080268523, 3.9837322881658546],
            [12.534907861686527, 3.9794754299604143],
            [12.50685761006161, 3.974596892534939],
            [12.462888496839916, 3.967708049771918],
            [12.448071259344166, 3.9649541530555723],
            [12.44752450301796, 3.9681691356188327],
            [12.402905474570522, 3.961644451032088],
            [12.405890862172047, 3.94163743738925],
            [12.392059363613765, 3.9349956399093737],
            [12.393558512300098, 3.9243303016391318],
            [12.377774786569502, 3.9156085153188487],
            [12.381122373583786, 3.9091459631839403],
            [12.36453096506273, 3.9061921730892637],
            [12.366547080541153, 3.89432734765386],
            [12.354946264880468, 3.892353985421808],
            [12.35635485267115, 3.880329083172997],
            [12.344706837987284, 3.8784037991648668],
            [12.348331722974681, 3.866157514148963],
            [12.333679218928923, 3.863908209540002],
            [12.336578198690018, 3.8516631494640863],
            [12.324141318888737, 3.8496414595776023],
            [12.32689445432115, 3.838057528866975],
            [12.3217705386607, 3.8364062548664624],
            [12.309896285382798, 3.8344178689916597],
            [12.311505991941775, 3.821689643502116],
            [12.299494581707325, 3.8204756986822295],
            [12.30038906363955, 3.809510812597334],
            [12.270150042627044, 3.80302601070156],
            [12.208814519289529, 3.7901977734116103],
            [12.20996640244791, 3.7843931996330595],
            [12.18686913117937, 3.7810071061786767],
            [12.183066054801811, 3.780819434355606],
            [12.10698537892844, 3.770260544597426],
            [12.062241227497756, 3.763643211089494],
            [12.038395013573208, 3.760465123549043],
            [12.022315755791192, 3.75865457735878],
            [11.984679014945986, 3.753554834154881],
            [11.983144976642134, 3.758531660185128],
            [11.97372373680337, 3.757161995294402],
            [11.97449253238329, 3.752038577416447],
            [11.919740512953155, 3.745069186289046],
            [11.918057579276029, 3.7552178615919467],
            [11.911443691503921, 3.7948514575923324],
            [11.890111715684625, 3.924282420893916],
            [11.878704514123596, 3.9932986133054493],
            [11.87461647776476, 4.018883825317226],
            [11.860785011901875, 4.1025898494564075]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.10619776151982, "lat": 41.68470459292563 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42039"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01213666"
      },
      "bbox": [
        11.860785011901875, 3.745069186289046, 12.561662080268523,
        4.214998591571107
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.702364679901779, 3.3745072576032413],
            [14.701345518567239, 3.3731466894748463],
            [14.70180796598387, 3.3606289470007136],
            [14.704198223423608, 3.3505651349094],
            [14.702369023727789, 3.3382245180602816],
            [14.69869168072988, 3.3314783461833404],
            [14.686911534560869, 3.3200952266100976],
            [14.683403491637774, 3.3133423126045636],
            [14.682554884326564, 3.308545725602402],
            [14.68417510955218, 3.3022953845831067],
            [14.69514043018911, 3.2859573009178553],
            [14.697225025403487, 3.28115615339042],
            [14.697783550728435, 3.274683339659926],
            [14.696120095672555, 3.267229319031578],
            [14.698266613589448, 3.258777002139444],
            [14.705099257391726, 3.2507061884465487],
            [14.71386357592908, 3.2426292739315343],
            [14.727119622332726, 3.2381327257934767],
            [14.730978661918446, 3.232702669784232],
            [14.733737061571714, 3.2218169321211487],
            [14.734081710924304, 3.2169884100131427],
            [14.732938687583886, 3.2104274203258862],
            [14.728119323221089, 3.202587632991822],
            [14.72141942727982, 3.1973026135300264],
            [14.715581693804008, 3.1911528770867106],
            [14.710742788472837, 3.1809510188249908],
            [14.70536907988897, 3.1752458026027783],
            [14.702811169593856, 3.1676676554033594],
            [14.693496745259981, 3.1641121490580124],
            [14.69571581287354, 3.1547734988060347],
            [14.700407473560345, 3.1472552400275493],
            [14.700392086464275, 3.1420484899152155],
            [14.694960357587645, 3.1362578017569764],
            [14.691296003745402, 3.129559476900303],
            [14.691594462883607, 3.1243719607023457],
            [14.694414501197974, 3.1187872609984133],
            [14.69822938150323, 3.114940123408996],
            [14.700885247758205, 3.107222413122151],
            [14.70343208844373, 3.1040544003780295],
            [14.708513330226067, 3.102365966051945],
            [14.712833575215996, 3.0994426104353288],
            [14.720715877515453, 3.0992177270010175],
            [14.73245062869324, 3.102252049669231],
            [14.741071383240271, 3.1029550577645755],
            [14.747738059736289, 3.1060826397695425],
            [14.765319348404654, 3.109081917286501],
            [14.769896231500724, 3.10704531100356],
            [14.773909530552492, 3.1010639503491055],
            [14.776468663891043, 3.095388661127531],
            [14.785286718968685, 3.0876992743989677],
            [14.787864703354508, 3.0838506830070127],
            [14.764793033650323, 3.0672161696504525],
            [14.745772302304173, 3.056159717684152],
            [14.725683031541513, 3.0477344446930545],
            [14.713409405318703, 3.0436113330482395],
            [14.698780928144616, 3.041049342454701],
            [14.68574786474292, 3.037279680956916],
            [14.682889668709649, 3.035340374776066],
            [14.674844127382192, 3.033995100984797],
            [14.659128383225534, 3.0289378160261338],
            [14.655492053570883, 3.026403273800839],
            [14.648244378750466, 3.0236276961823076],
            [14.63879068285081, 3.021010795547297],
            [14.620905588957728, 3.011858999489471],
            [14.6034927694208, 3.0055375296954314],
            [14.581632883534452, 2.9997015912685425],
            [14.564004623100843, 2.992748547104875],
            [14.556522059305724, 2.9916215523949354],
            [14.554896088200236, 2.990007284381976],
            [14.534763553639532, 2.9816991459248725],
            [14.510274030931212, 2.967074568052131],
            [14.502474943312087, 2.9637815301532586],
            [14.49048003769192, 2.9697247901370534],
            [14.489345000365885, 2.974627773351623],
            [14.492787701981689, 2.9835483102614697],
            [14.49256944150487, 2.987477667561142],
            [14.488619577593665, 2.9865271233105504],
            [14.480720253552239, 2.9794142163960644],
            [14.472098733929535, 2.969856897418321],
            [14.468238041750382, 2.9643888437625106],
            [14.452497451746805, 2.948951868808275],
            [14.440760889539268, 2.9407125794529665],
            [14.43264217584377, 2.9373196303048132],
            [14.427428741556728, 2.936445644632479],
            [14.425012216579063, 2.9391449571991473],
            [14.426502309662133, 2.94520116694584],
            [14.431966071200186, 2.9516696068080828],
            [14.432229477911724, 2.9571032451602863],
            [14.435891469436386, 2.963553602565636],
            [14.44569643785084, 2.9759964279963405],
            [14.459766435435844, 2.9913074950045666],
            [14.462576586981807, 2.996120840326127],
            [14.463096844394643, 3.0021738591901523],
            [14.456667751204481, 3.0020212078151842],
            [14.445681055792505, 2.9945920175499388],
            [14.437569322836628, 2.987899512013242],
            [14.425119606118296, 2.9755602011250786],
            [14.417041452252183, 2.9664830201664394],
            [14.395994208251926, 2.9390401984173296],
            [14.388511515201655, 2.927577693074055],
            [14.373638908323475, 2.910286262918869],
            [14.365277177711507, 2.902664741880521],
            [14.362036566581537, 2.8980092721791606],
            [14.354644349057851, 2.8915054788692824],
            [14.35350781663541, 2.8886240499856766],
            [14.348401091437943, 2.8835872057453593],
            [14.333637941483817, 2.8806982389524505],
            [14.320023348443812, 2.865235465265292],
            [14.319003377003353, 2.8621907952801116],
            [14.313361933176703, 2.853545214822867],
            [14.311565996416322, 2.848567923574833],
            [14.304016203576062, 2.840262311851956],
            [14.294610074858761, 2.8519637549922865],
            [14.300422003366087, 2.860252625666088],
            [14.296754848229948, 2.8794660540242143],
            [14.297730760009893, 2.883023254277134],
            [14.292054969693124, 2.8865876828238846],
            [14.286886932872136, 2.885435803831458],
            [14.272163058538014, 2.867218276602629],
            [14.269891493330373, 2.867248913573706],
            [14.268500169915258, 2.872136932558617],
            [14.265478557278346, 2.870840337892232],
            [14.263026888948144, 2.8742696229920357],
            [14.262461504677665, 2.8813837663544564],
            [14.263956486391974, 2.8874349890518523],
            [14.25880192333856, 2.8956991782556387],
            [14.261332419558714, 2.9023282628220746],
            [14.257306830415779, 2.9052579699875607],
            [14.254406281435982, 2.904543823063238],
            [14.246499891642117, 2.8974996350876823],
            [14.241229773286468, 2.9021391594366084],
            [14.249689216499913, 2.9169561676520708],
            [14.24234090649712, 2.9235654127127413],
            [14.241964644258228, 2.9258041011097644],
            [14.234542762861587, 2.9339516814666338],
            [14.244089043173442, 2.953904893710102],
            [14.256808415114858, 2.9744327952803187],
            [14.268371499879455, 2.989683298898871],
            [14.276889406775025, 3.0021039176721467],
            [14.28749187303794, 3.013312222503535],
            [14.298179984118324, 3.0260055581156893],
            [14.31514713495488, 3.03775225489719],
            [14.32124608386102, 3.0394084489701285],
            [14.310890359380787, 3.061209947125404],
            [14.32555183289941, 3.076809832455612],
            [14.330832792346232, 3.0814792867966028],
            [14.336300846797736, 3.0880147391283983],
            [14.350225948589827, 3.1026168948523405],
            [14.371312147998832, 3.12233161241157],
            [14.37756752331119, 3.1270520742443937],
            [14.3823580551708, 3.1320176709924685],
            [14.392696299373066, 3.140347024696657],
            [14.407542653502913, 3.153954651746333],
            [14.441579821207622, 3.1857178116511724],
            [14.472888020192741, 3.2156888921084406],
            [14.479204723849298, 3.2186416276563463],
            [14.486800620122617, 3.225970480804193],
            [14.511709290990954, 3.244000281511052],
            [14.521791656616735, 3.252108918418729],
            [14.533523266481026, 3.2625389010024133],
            [14.544104591671863, 3.2691859602400264],
            [14.551430001592486, 3.2716899429804185],
            [14.554910214279717, 3.2742404858192544],
            [14.539071076072029, 3.2943121159745252],
            [14.550826094967588, 3.3010317279099666],
            [14.562470221802446, 3.3050597358687055],
            [14.57784672650106, 3.3110115149059007],
            [14.58422623325004, 3.314166949585014],
            [14.59315238956718, 3.316105291242479],
            [14.59509699127777, 3.3196962529853304],
            [14.600423266696705, 3.321148928083026],
            [14.60649199144824, 3.3241948086787656],
            [14.613413399917324, 3.325208479347266],
            [14.619175847414507, 3.3271727510060796],
            [14.635130128854716, 3.3345595319275882],
            [14.638711659806937, 3.3370287117532667],
            [14.645492046868931, 3.337599152459831],
            [14.652463198299587, 3.339843352229598],
            [14.668242137943365, 3.349870299123054],
            [14.676374059587253, 3.3569353517726297],
            [14.697301417318961, 3.373245227130433],
            [14.702364679901779, 3.3745072576032413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.26232224621488, "lat": 40.39840380108197 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42099"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01213682"
      },
      "bbox": [
        14.234542762861587, 2.840262311851956, 14.787864703354508,
        3.3745072576032413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.948926810977415, 4.630567512929282],
            [14.024640535073686, 4.645961624140816],
            [14.151558273837392, 4.670695788004014],
            [14.231336016588637, 4.686366706377158],
            [14.30021283496757, 4.699973105986153],
            [14.34413618440167, 4.709888988289801],
            [14.414763121055296, 4.724970593241774],
            [14.442690487561059, 4.731037039509437],
            [14.447146637174576, 4.717399814275426],
            [14.469397652287919, 4.647603872067806],
            [14.49222255851804, 4.573522273371058],
            [14.501818648219908, 4.544664151108501],
            [14.50492706085867, 4.531364397238911],
            [14.540870779748492, 4.41009735558251],
            [14.549206834367633, 4.382994803504993],
            [14.554419488809367, 4.362924154621425],
            [14.562034090616566, 4.340452292222408],
            [14.560687172229818, 4.3336430923461595],
            [14.55567484828484, 4.329678847353134],
            [14.54062168489504, 4.320251616958907],
            [14.533823727111645, 4.320143217062035],
            [14.530713498433265, 4.317803780333303],
            [14.529511403569648, 4.307361185368652],
            [14.525282502186158, 4.304351176413489],
            [14.517856732513758, 4.303185229513175],
            [14.511937235517607, 4.2976043745727965],
            [14.508335931379477, 4.2896060571541295],
            [14.50891276974602, 4.282973715411936],
            [14.472598268596284, 4.274054642393347],
            [14.340537977561764, 4.243349943073496],
            [14.266839909867016, 4.226941149141153],
            [14.264071811851176, 4.2266838616910825],
            [14.150346790929198, 4.2033271348398635],
            [14.045337343156369, 4.181385071146426],
            [14.021199088627515, 4.294203358543755],
            [14.006470892062271, 4.363015952899891],
            [13.989292736488075, 4.442755229860449],
            [13.9738604004507, 4.515756829446727],
            [13.948926810977415, 4.630567512929282]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.25422858466217, "lat": 41.77216408817529 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42117"],
        "coty_name": ["Tioga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tioga County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01209189"
      },
      "bbox": [
        13.948926810977415, 4.181385071146426, 14.562034090616566,
        4.731037039509437
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.618712769169054, -5.066478877000825],
            [12.627901613387966, -5.065163432580002],
            [12.646970661626142, -5.046263795702975],
            [12.670066671737764, -5.034724135432593],
            [12.673752650070433, -5.0167333763846536],
            [12.676279780186958, -5.010984494263647],
            [12.715106230107892, -4.96372838004456],
            [12.722578216229236, -4.954872277759533],
            [12.70192709283505, -4.9043684911741865],
            [12.707388122005021, -4.900723251485985],
            [12.71393225164863, -4.891446769953747],
            [12.721535869176348, -4.886750020960809],
            [12.727852308032064, -4.88412127977267],
            [12.731843706467133, -4.884847262224247],
            [12.7272245120603, -4.851559008302327],
            [12.72861619528341, -4.851787371235],
            [12.739027559475693, -4.84199622723115],
            [12.739513465653934, -4.836339339608478],
            [12.748548752244178, -4.8278003338092725],
            [12.776028408592103, -4.803877824877957],
            [12.841063401707462, -4.746008964131453],
            [12.844992860526636, -4.750929070930002],
            [12.848289544123045, -4.751821329597647],
            [12.853473574376928, -4.755888155474212],
            [12.857624594397244, -4.756611689282959],
            [12.859578619404791, -4.763048258138195],
            [12.866970290497736, -4.767044848828367],
            [12.86820352148075, -4.774557558537602],
            [12.870795377697814, -4.778950577542832],
            [12.878598807542794, -4.781719574300684],
            [12.885542522276515, -4.787193695056145],
            [12.8927168949457, -4.791375799258709],
            [12.896032084635786, -4.798372592719132],
            [12.901729045216802, -4.8000515261690255],
            [12.903819634643169, -4.804980787730831],
            [12.909043096929755, -4.808153654739005],
            [12.909145419646375, -4.811848380258757],
            [12.913573600827252, -4.817668953179779],
            [12.914582107942413, -4.822209879678704],
            [12.924401192185217, -4.829673913761449],
            [12.930392350217419, -4.842721960509652],
            [12.934950858818764, -4.846141888143266],
            [12.93644897827922, -4.852988397874667],
            [12.93917626418439, -4.8579666463422475],
            [12.948601012880543, -4.860373767157552],
            [12.95428441881686, -4.865794665089008],
            [12.956274181159282, -4.865907927376822],
            [12.9674645120997, -4.878802706119421],
            [12.974511043826222, -4.878745744172878],
            [12.977433449600005, -4.876975133386865],
            [12.983495903376088, -4.882250551617458],
            [12.985247383500838, -4.885169553738852],
            [12.989385828223268, -4.885555100731953],
            [12.99368361938934, -4.888929198841666],
            [12.994712466105684, -4.892700168455525],
            [12.998517461174933, -4.893032848286304],
            [13.00540836648734, -4.89842136471716],
            [13.007999505065072, -4.904428180154547],
            [13.011106777363155, -4.904413762334208],
            [13.013637387683472, -4.908135735573883],
            [13.01753172564087, -4.910122314088336],
            [13.021878633556783, -4.914280005948085],
            [13.023574237703556, -4.9215519613190395],
            [13.028202087118602, -4.930895438526356],
            [13.028919112767454, -4.935536784899046],
            [13.032697787204501, -4.939891144306218],
            [13.041218699296365, -4.946130926762784],
            [13.045801382964077, -4.953084767079999],
            [13.051056282604758, -4.955627892425167],
            [13.051566725904655, -4.958360077378545],
            [13.055446798346557, -4.961481102458351],
            [13.056189608181567, -4.965223614762736],
            [13.058907951982052, -4.9662758303186205],
            [13.060069057856845, -4.972323535905038],
            [13.064022321349952, -4.9770372226195],
            [13.067914418240937, -4.988183551910266],
            [13.073162821988513, -4.991313086670505],
            [13.076513892561325, -4.997129398213592],
            [13.07922801049551, -5.00678975993425],
            [13.08477883824408, -5.0152139145243995],
            [13.089827673062372, -5.021194934034912],
            [13.094203352013862, -5.022627009232246],
            [13.100488068763715, -5.0273618528022945],
            [13.103213581921665, -5.031507144038489],
            [13.09740672779707, -5.034620404128838],
            [13.094926999660812, -5.037402924717889],
            [13.074289619022837, -5.080168713608642],
            [13.053494105163692, -5.123440386508487],
            [13.052460058431263, -5.1220521208287595],
            [13.04305220402286, -5.119801872799382],
            [13.039602977188627, -5.120770716263959],
            [13.036071403964526, -5.117077633466108],
            [13.031575128472355, -5.115237410403212],
            [13.029158724360283, -5.112344386478696],
            [13.01593353354449, -5.111915471142565],
            [13.00885332188858, -5.109858186889849],
            [13.003683569427759, -5.11012317150873],
            [13.000331684211885, -5.106404185727376],
            [12.99860147987867, -5.101053729701714],
            [13.002745109604502, -5.094257231257637],
            [13.00781407472564, -5.090218810598925],
            [13.009096574164031, -5.076460921984649],
            [13.00771076509127, -5.07440359177246],
            [13.008104530098107, -5.06727304455327],
            [13.007155590026363, -5.064076716045401],
            [13.002781215543996, -5.061425269298572],
            [12.99920542589858, -5.062459660684684],
            [12.995366673622193, -5.058420883953207],
            [12.990877378106008, -5.059204424847361],
            [12.986733836584525, -5.053982947066845],
            [12.986189091552877, -5.050443124828438],
            [12.980121514940416, -5.042526561034406],
            [12.97813190132147, -5.041288034890935],
            [12.976535918701991, -5.034913548771815],
            [12.971582550361179, -5.031796405415441],
            [12.966656770470587, -5.0309992599342905],
            [12.959443917406002, -5.027822870455573],
            [12.951726948579978, -5.019619862450925],
            [12.942955949054115, -5.014509503255705],
            [12.939961356716037, -5.008068591451623],
            [12.929672437262163, -5.021311418084573],
            [12.880570632613438, -5.0827078079957],
            [12.852362630115643, -5.1158971943192295],
            [12.838634277361884, -5.1328926870566],
            [12.82939435803786, -5.1429090868926135],
            [12.816831575001276, -5.157516097746775],
            [12.803155618124679, -5.174164467258836],
            [12.791478604886763, -5.18278238921565],
            [12.750238351696188, -5.237242774909365],
            [12.744485309308137, -5.23867239810706],
            [12.74195065219228, -5.237740421804831],
            [12.73947640251851, -5.241813205904529],
            [12.73653704861369, -5.2399921684613595],
            [12.738085205169366, -5.236461642200318],
            [12.735424222206115, -5.232869140489605],
            [12.729629353918474, -5.23530029788637],
            [12.716213083098646, -5.239383155992819],
            [12.710343694726806, -5.238719829274931],
            [12.683800701914702, -5.2301198744812885],
            [12.686967812702683, -5.225292120428741],
            [12.682964392890753, -5.22164630492577],
            [12.678176689079061, -5.222718988021427],
            [12.671880115268337, -5.218716632793254],
            [12.672571948119302, -5.215517400246004],
            [12.669995514593237, -5.21361776400582],
            [12.666973706739892, -5.216663023332541],
            [12.662554500824715, -5.217165047859299],
            [12.654831952944116, -5.212548736759786],
            [12.649949812284449, -5.2062505416606255],
            [12.637874751375486, -5.197265431530618],
            [12.636458580904856, -5.193894681206989],
            [12.633215886743436, -5.193231815990219],
            [12.630584873622798, -5.186468193419618],
            [12.62587814681846, -5.183599029340887],
            [12.624640694687653, -5.177348239389453],
            [12.628384804357665, -5.174071276801892],
            [12.630632937781796, -5.178246632522883],
            [12.63363111688802, -5.179406397635746],
            [12.637269935140866, -5.173043526534905],
            [12.629385553216578, -5.171874646768862],
            [12.62845581294556, -5.169848729181974],
            [12.634435093049614, -5.167744349427398],
            [12.642079372982378, -5.159591507686495],
            [12.642113482296377, -5.155611544233778],
            [12.635947717958015, -5.151497065821771],
            [12.637630548594268, -5.147078268628538],
            [12.631703150555154, -5.143647462743815],
            [12.631123025140756, -5.1399202045929835],
            [12.632454544423403, -5.132768693499074],
            [12.63125793130917, -5.1292215312694065],
            [12.626685740154162, -5.126187623953722],
            [12.62648766860712, -5.120542994990165],
            [12.620803213631639, -5.1197625394123545],
            [12.619313238594328, -5.1165685418449485],
            [12.61481414849397, -5.116511388107485],
            [12.612839505881306, -5.113143545315398],
            [12.60760530300605, -5.112902176523532],
            [12.610478672221177, -5.101195368770729],
            [12.614170629010646, -5.100317524257324],
            [12.614370335401697, -5.096637930613479],
            [12.609882555468538, -5.09330924376254],
            [12.61157016877523, -5.084010643771626],
            [12.609976950866168, -5.082066054143909],
            [12.6150493312981, -5.078313841729227],
            [12.612610200940265, -5.075014237112648],
            [12.617351905730118, -5.07138668524646],
            [12.618712769169054, -5.066478877000825]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.14058566820597, "lat": 32.77635254394423 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45049"],
        "coty_name": ["Hampton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hampton County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01248004"
      },
      "bbox": [
        12.60760530300605, -5.241813205904529, 13.103213581921665,
        -4.746008964131453
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.050329849377016, -3.6209860197408474],
            [13.046151910712627, -3.6188339902979076],
            [13.046873342259664, -3.611802583051567],
            [13.059550165977036, -3.6173776066671177],
            [13.079531068307267, -3.615871061534586],
            [13.082154742353787, -3.6123475294067338],
            [13.130769775211867, -3.556307488505653],
            [13.149562697205756, -3.534324060043206],
            [13.153304825311325, -3.559508935391408],
            [13.156285310714747, -3.57724634525535],
            [13.157564652273942, -3.5901664397365445],
            [13.18468894371234, -3.5983096450434457],
            [13.221402085396651, -3.610553692442748],
            [13.224148418704521, -3.6110479361996006],
            [13.23082748810244, -3.6016656691561217],
            [13.245978234207978, -3.6081186282971713],
            [13.253473563432664, -3.6064494243041962],
            [13.292269266632529, -3.6007936835560828],
            [13.297718438062565, -3.6029181482578836],
            [13.31008780742105, -3.615299731622869],
            [13.310093250854761, -3.6160410254111164],
            [13.320772248039928, -3.637770523206374],
            [13.342478071119544, -3.638576618713539],
            [13.348272919558053, -3.6462935474876685],
            [13.35303518889341, -3.650359216251927],
            [13.354426442973839, -3.6534669990559565],
            [13.354264906316654, -3.6601960382462084],
            [13.358387671262559, -3.6656515952568056],
            [13.358576087238946, -3.6688426901604068],
            [13.36190862158637, -3.6761507211087214],
            [13.365238329085475, -3.67855042265099],
            [13.3707949062026, -3.678191657256635],
            [13.413030533998143, -3.657550629751413],
            [13.415276051719902, -3.6627046004038095],
            [13.415944166625694, -3.6733593601038264],
            [13.41938610462691, -3.678271837022411],
            [13.422716574943056, -3.686471518600435],
            [13.424408229011647, -3.6963924277954003],
            [13.426669668750398, -3.7009651113511026],
            [13.428288522319518, -3.7089496452469297],
            [13.440139193248918, -3.7015553983644636],
            [13.482184531720687, -3.663662710105933],
            [13.499423151367923, -3.6478841734946843],
            [13.508200365570739, -3.638486931135724],
            [13.543465464423978, -3.6318887180001056],
            [13.552176106521877, -3.6086052501430532],
            [13.558048706578791, -3.589296889146766],
            [13.561720644295812, -3.590698831790891],
            [13.56630708213538, -3.5961797250399177],
            [13.570978191130298, -3.5957122812618794],
            [13.577861269960358, -3.5995867536772743],
            [13.582610856646816, -3.604409739711051],
            [13.591296591093217, -3.6068792852943474],
            [13.592948715867683, -3.6088884969689556],
            [13.599073029433907, -3.6102054643382115],
            [13.601230618126745, -3.608996859794771],
            [13.606138778257177, -3.611526012432631],
            [13.614920327537025, -3.611199074861504],
            [13.619664420191002, -3.6120956594019913],
            [13.621312467025586, -3.615017068592537],
            [13.628370417654592, -3.617366386542119],
            [13.63558223063296, -3.617656762474842],
            [13.644537835881302, -3.6225109765927423],
            [13.644902915953807, -3.6263762383540237],
            [13.649993774860638, -3.6299725071672873],
            [13.65175922018567, -3.6333171020599178],
            [13.655017738570049, -3.6338573900484046],
            [13.62179326260261, -3.6633136199270497],
            [13.596256744312523, -3.6861858528899134],
            [13.57725257882279, -3.7008909302411337],
            [13.536588642865473, -3.736758412298193],
            [13.504551618882278, -3.7677899289356036],
            [13.489807212302924, -3.782668143819781],
            [13.478668527129544, -3.785346928723596],
            [13.451447681558959, -3.8085164397782494],
            [13.434956014389126, -3.823039192405465],
            [13.391590685256897, -3.866234756634438],
            [13.38201556743354, -3.8856181369585276],
            [13.300204693296422, -3.9145458630162167],
            [13.282582190497491, -3.9208963968830006],
            [13.286144522948575, -3.9416547487080273],
            [13.294080854700782, -3.9650522990028105],
            [13.295364772366119, -3.9720257853910077],
            [13.261401893379693, -3.9813601382875814],
            [13.261110075047306, -3.9719489402231454],
            [13.266315823862433, -3.9681246812021884],
            [13.259915437872646, -3.9547014009632],
            [13.24508151759738, -3.9579383822740195],
            [13.244825286773027, -3.982428003370703],
            [13.224929195647672, -3.9849454208240296],
            [13.218177962401349, -4.006891447578966],
            [13.216072967670115, -4.027075603485204],
            [13.206187665888937, -4.042950165072876],
            [13.191283699954452, -4.062100903699664],
            [13.180812042187547, -4.058884619560402],
            [13.173235896286839, -4.052197403395323],
            [13.17227570150599, -4.0476346707625686],
            [13.165017844660847, -4.04696747318661],
            [13.162148380643497, -4.044302868939591],
            [13.16522739884162, -4.038237823770181],
            [13.162604483919504, -4.031685520476247],
            [13.160066277032788, -4.030759550575722],
            [13.152924156330963, -4.032657465286539],
            [13.143502353481491, -4.031432795067736],
            [13.138806500716946, -4.029006468213849],
            [13.135020979368894, -4.022128015965312],
            [13.131982582569906, -4.019743484871865],
            [13.134613869571455, -4.015289772766931],
            [13.13278938552247, -4.012094316256218],
            [13.126644000528685, -4.012841002027405],
            [13.12071286627317, -4.007297182445768],
            [13.11403851410473, -4.005565626876158],
            [13.111815931119311, -3.9981270593465466],
            [13.100913229874601, -3.9881951831939895],
            [13.102846159513408, -3.984249932739365],
            [13.098162355282037, -3.982132091647176],
            [13.098439584432587, -3.979249465667137],
            [13.104995118521078, -3.9750676943020644],
            [13.10467988055538, -3.9697014192226234],
            [13.10695970723239, -3.9668742535576493],
            [13.110991901891355, -3.9656735965782164],
            [13.11406449653854, -3.9495982145739683],
            [13.112115911438933, -3.9448592884133333],
            [13.1176681014574, -3.9381030249806765],
            [13.114392326805461, -3.9331589193726666],
            [13.117448057356437, -3.929056807627836],
            [13.113010534728044, -3.927776529566217],
            [13.111409218232362, -3.9163647782846285],
            [13.108670857151637, -3.916221673104392],
            [13.10551847156135, -3.908339495848585],
            [13.097279741872418, -3.9022238707454147],
            [13.094524190261627, -3.8975036924564583],
            [13.094103885414018, -3.8916626775377186],
            [13.090599209075522, -3.8880144849822718],
            [13.093144072218557, -3.8836181286814573],
            [13.09024388637791, -3.8796443169173815],
            [13.083698004595567, -3.8783445767461804],
            [13.082517591568367, -3.875376724171627],
            [13.07728720444053, -3.87054650631382],
            [13.077827393541916, -3.8634489965800647],
            [13.079767384516298, -3.859116598581159],
            [13.083520684181103, -3.8584117878868565],
            [13.08068905825668, -3.8531910448831597],
            [13.081745314201685, -3.847237340262603],
            [13.080451488245082, -3.8426256339053495],
            [13.083426106901658, -3.840606342297752],
            [13.076692787035922, -3.831457989831899],
            [13.082169675773422, -3.83068724540965],
            [13.084774036326193, -3.828153640823427],
            [13.082781801301614, -3.8236117619488392],
            [13.079249657496991, -3.8245965648143216],
            [13.074871187694168, -3.820697761850183],
            [13.075082718490425, -3.8147029422506056],
            [13.065369245071961, -3.804228820589526],
            [13.067357890489681, -3.7995009698962834],
            [13.065636122298981, -3.7977950310515913],
            [13.069746873696086, -3.790717015343407],
            [13.066190409051924, -3.7887516054183963],
            [13.073233307019615, -3.784010172206614],
            [13.071255257356942, -3.7810941933624647],
            [13.07263171033452, -3.7775279207066372],
            [13.065499531708012, -3.779310702991463],
            [13.065008322773144, -3.77225529365637],
            [13.06725829460795, -3.7684042165501843],
            [13.06890377918192, -3.759564297457523],
            [13.07333520437068, -3.7570036473926582],
            [13.072456493233727, -3.7540398548444625],
            [13.065881774156518, -3.7522565564204573],
            [13.06187072419147, -3.756540207666675],
            [13.058155309510743, -3.7552716907355363],
            [13.05885855529374, -3.745768179670111],
            [13.048955137133635, -3.739685688454849],
            [13.04570546684009, -3.7343038918731435],
            [13.049179100920666, -3.7321557988431073],
            [13.046456558383117, -3.7236769007404305],
            [13.050671810175535, -3.7209383254745743],
            [13.048654556905724, -3.717720389113197],
            [13.0499855167763, -3.714407853807838],
            [13.057082299215786, -3.718304561080477],
            [13.058514011184748, -3.717363393864959],
            [13.054941850229975, -3.709608553076692],
            [13.059349061748376, -3.706949052909909],
            [13.061784906129919, -3.703613045788395],
            [13.06373326582789, -3.6947477714896597],
            [13.072153623245963, -3.6948493197140895],
            [13.068377529456823, -3.6896892321198744],
            [13.070574591144235, -3.6842041135485193],
            [13.072966602085009, -3.682175644295114],
            [13.072473041005786, -3.6787349170622132],
            [13.067064512720856, -3.676294404937665],
            [13.06576185371012, -3.6728928374311405],
            [13.061810818344854, -3.6704344444022516],
            [13.05775985220349, -3.6564888442059726],
            [13.053394910981343, -3.6574925293859053],
            [13.043268654670829, -3.654097126700557],
            [13.047644186113057, -3.64845318679664],
            [13.05101384294212, -3.641063235905908],
            [13.046704312578658, -3.639660140409868],
            [13.045477925036803, -3.644363512943857],
            [13.039610414502716, -3.644393623239785],
            [13.036529432627656, -3.640171414185346],
            [13.038818657506212, -3.6332919823806225],
            [13.045328855201307, -3.632333826653811],
            [13.04964027569457, -3.628874183916189],
            [13.051186993871394, -3.623741265627001],
            [13.050329849377016, -3.6209860197408474]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.38233137982876,
          "lat": 33.916170281532494
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45085"],
        "coty_name": ["Sumter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sumter County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01244717"
      },
      "bbox": [
        13.036529432627656, -4.062100903699664, 13.655017738570049,
        -3.534324060043206
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7680626946438687, 6.498916379046221],
            [-3.7653408728655533, 6.542106887983597],
            [-3.7570319870546602, 6.671667505152354],
            [-3.7561768168461804, 6.687021072760372],
            [-3.7511671342401973, 6.757779664358125],
            [-3.745798046690807, 6.843696544247894],
            [-3.74051619826766, 6.929492745121944],
            [-3.6301378368600954, 6.922959220598118],
            [-3.5426470418079603, 6.917574674452958],
            [-3.478549516197504, 6.913367483019869],
            [-3.4779634413510596, 6.913501086932311],
            [-3.3698371422775337, 6.907263593761311],
            [-3.375446433872978, 6.821212166199991],
            [-3.386158489388695, 6.821834916359032],
            [-3.3940443893873833, 6.685655018940202],
            [-3.393895727371161, 6.680893765640742],
            [-3.3954002580783493, 6.670989502245674],
            [-3.397166215737588, 6.63705255762826],
            [-3.401966293216656, 6.549361785443658],
            [-3.4063783419605023, 6.477273692536887],
            [-3.4165167824320797, 6.477818764337163],
            [-3.419111411674607, 6.43343305361038],
            [-3.3337343813265603, 6.428916215057819],
            [-3.3205819090059654, 6.428327388397972],
            [-3.262286020969166, 6.424589147760312],
            [-3.219888164545575, 6.422168493400738],
            [-3.161837018263717, 6.419535219554493],
            [-3.175676035793648, 6.174057995842557],
            [-3.1812712614461707, 6.173433399372338],
            [-3.185073008331638, 6.1697845180030315],
            [-3.1885860069581957, 6.156502725742233],
            [-3.195904220217296, 6.148918409425344],
            [-3.20639976927384, 6.143869413023173],
            [-3.2257660939632697, 6.132669323532543],
            [-3.244279156040969, 6.12306659714895],
            [-3.2491971766486083, 6.121760447016046],
            [-3.249410825920262, 6.1275279011234725],
            [-3.251265303787158, 6.1296363253230215],
            [-3.257134069849647, 6.130456538612811],
            [-3.270023934931043, 6.1256219684257225],
            [-3.274686785642315, 6.118703307139575],
            [-3.2801524996538642, 6.117522362557279],
            [-3.2836381539108035, 6.118445659833839],
            [-3.290719225721344, 6.122663971169596],
            [-3.2942245970712674, 6.122710738764272],
            [-3.2979126681164748, 6.119114393192265],
            [-3.3084605782398184, 6.114869051592826],
            [-3.3122950930873585, 6.116018861933149],
            [-3.312745418143225, 6.122887960947186],
            [-3.3143007537983484, 6.125609282400729],
            [-3.3184832339907944, 6.124587386308933],
            [-3.3205672847658296, 6.119333847740195],
            [-3.324809483732078, 6.118772691037111],
            [-3.3347736857410797, 6.12512810544452],
            [-3.338328558105292, 6.123829695135303],
            [-3.3362818774644567, 6.110210998150339],
            [-3.3383416558813823, 6.10821978028036],
            [-3.3464588215501605, 6.110288798678127],
            [-3.347942978073229, 6.106166586941222],
            [-3.3419696535198975, 6.098209486798735],
            [-3.341204609711902, 6.093995517768805],
            [-3.345025407811409, 6.092564390878899],
            [-3.350717663187812, 6.09546379025026],
            [-3.3541079123497166, 6.09062633228126],
            [-3.3565392410554815, 6.090791357007061],
            [-3.360214194639786, 6.094963224727087],
            [-3.3659053837376467, 6.094163880255213],
            [-3.3697328682728975, 6.089249011222038],
            [-3.3738700389131653, 6.087712555003511],
            [-3.3764486069534865, 6.082211075478575],
            [-3.3902342895704756, 6.0796429944831925],
            [-3.394518972173932, 6.082924383088957],
            [-3.4006223305000254, 6.077869971000482],
            [-3.4046807328743274, 6.0783900646486275],
            [-3.4079110059629496, 6.076860635511687],
            [-3.406863742267906, 6.071180709472772],
            [-3.416556503247263, 6.059843562957614],
            [-3.4155190858517472, 6.056677415470688],
            [-3.411519851307205, 6.055664926079088],
            [-3.4088792297186665, 6.051822168407606],
            [-3.411721691342617, 6.050193628236868],
            [-3.4142237291512845, 6.052471198870446],
            [-3.418619518368536, 6.052499243078727],
            [-3.423204730347713, 6.047826200084252],
            [-3.424565950025764, 6.042893429105548],
            [-3.4295554128078423, 6.042512912951444],
            [-3.433970254587632, 6.04447788792891],
            [-3.439896932800721, 6.040919209030368],
            [-3.4398919140981445, 6.037143902132664],
            [-3.437029735008799, 6.028973642954196],
            [-3.4379017237001346, 6.025815757063014],
            [-3.443130309711627, 6.023396004755031],
            [-3.4477462235185508, 6.028385962447405],
            [-3.4506133916346604, 6.028027251907021],
            [-3.4528081073356884, 6.024072204389239],
            [-3.4525992295042984, 6.018703165614847],
            [-3.459029381677084, 6.015793727240266],
            [-3.465106089659853, 6.011320578455201],
            [-3.46818501095837, 6.017200752991402],
            [-3.473721305645286, 6.016000248585797],
            [-3.4770223104410176, 6.0193204565572795],
            [-3.481538280250015, 6.0188142073839455],
            [-3.4817670216001804, 6.015216757825709],
            [-3.4854430995703445, 6.01431437047665],
            [-3.4891379861011553, 6.020474075847246],
            [-3.4950253698666107, 6.023147178034037],
            [-3.5001820029295767, 6.023496402707383],
            [-3.5070085637122546, 6.019843733352767],
            [-3.5182675569165154, 6.023783341747958],
            [-3.520865899411413, 6.018907193517629],
            [-3.5256902880621364, 6.020671785402739],
            [-3.5329063959439964, 6.021290497703151],
            [-3.534258388762132, 6.024584634203981],
            [-3.532174756874511, 6.027211842511705],
            [-3.5334638232635567, 6.032836770612904],
            [-3.53652878640059, 6.034447469852321],
            [-3.541994731025007, 6.02735598416488],
            [-3.545665427755367, 6.033325674718925],
            [-3.552362153911242, 6.03084124326994],
            [-3.5562223416335974, 6.036742836314626],
            [-3.558978274071007, 6.0326754505550975],
            [-3.563708547259878, 6.032743620640477],
            [-3.5672381641718487, 6.029777932846233],
            [-3.569131826532874, 6.024627952327492],
            [-3.5720516940080937, 6.020779267782001],
            [-3.577898428233293, 6.021310295109531],
            [-3.5778623530770535, 6.025027015788693],
            [-3.5855071879042626, 6.025497165707192],
            [-3.5906995717806724, 6.030320233926641],
            [-3.594954225517275, 6.030560846174125],
            [-3.5960628859865773, 6.023831590272366],
            [-3.6055618763910044, 6.017814907733298],
            [-3.609960292969813, 6.020543750750994],
            [-3.618322392965877, 6.020284704421527],
            [-3.6201041130388147, 6.016165558174365],
            [-3.616725059311341, 6.012097151738213],
            [-3.61653975606005, 6.008447678914383],
            [-3.620674509350647, 6.006845950573167],
            [-3.627465223200273, 6.001473529167247],
            [-3.632846939303175, 6.001391906059738],
            [-3.6353248416215824, 5.996916277283915],
            [-3.644175026679699, 5.99053298478063],
            [-3.646695595280438, 5.9950295525013635],
            [-3.653168135885064, 5.9979621057528485],
            [-3.657679429752246, 5.996428255488354],
            [-3.662675424458243, 5.986762613842568],
            [-3.662234049072373, 5.980697578604566],
            [-3.666658640450805, 5.977851286144414],
            [-3.6690384231854645, 5.981242637508622],
            [-3.6698968716333042, 5.986957588420084],
            [-3.6778295682308557, 5.9878769878018465],
            [-3.680128283254466, 5.985541162241797],
            [-3.68129198361476, 5.979897575503428],
            [-3.685741919689536, 5.979019876984684],
            [-3.6870624524888638, 5.983371000231817],
            [-3.691997383873059, 5.986418127150859],
            [-3.6978923249002547, 5.983985612502242],
            [-3.702616032476197, 5.988935466534558],
            [-3.70721913578747, 5.9894541077310866],
            [-3.712186086044869, 5.9917385370853316],
            [-3.7157235576794547, 5.991564858093956],
            [-3.720915800139009, 5.997244048824022],
            [-3.7259117994152735, 5.995010322878217],
            [-3.73237099292217, 5.994642481089562],
            [-3.736603531640832, 5.992323288147767],
            [-3.7417085124964107, 5.993209009152479],
            [-3.747215988255737, 5.990405096681186],
            [-3.753793908813852, 5.9924570486756075],
            [-3.756206064438294, 5.9959854612676375],
            [-3.7593546166344436, 5.994839880658489],
            [-3.762240396262438, 5.990017924398511],
            [-3.7713948246471523, 5.990384121777588],
            [-3.7776922927584486, 5.987409092352779],
            [-3.7818520706743906, 5.989429535192741],
            [-3.7854557932381034, 5.985566345196409],
            [-3.7911621663894204, 5.987919048242157],
            [-3.7971245372885214, 5.9835420505609545],
            [-3.7995156416459213, 5.9767420155259945],
            [-3.8016611031276675, 5.97550617878819],
            [-3.795823420157499, 6.067373105287541],
            [-3.79038732287588, 6.152897298925669],
            [-3.781262909819888, 6.296658682939077],
            [-3.773707355165726, 6.411945121366368],
            [-3.7680626946438687, 6.498916379046221]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.66582341980656,
          "lat": 44.98041981384558
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46137"],
        "coty_name": ["Ziebach"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ziebach County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01266993"
      },
      "bbox": [
        -3.8016611031276675, 5.97550617878819, -3.161837018263717,
        6.929492745121944
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.049144847614542, -3.1067478775866344],
            [9.074263014703941, -3.0573304678302207],
            [9.123155491936323, -2.9607630828847293],
            [9.14321237461828, -2.9218729155509533],
            [9.155371205943371, -2.8847989992190013],
            [9.173802684360679, -2.832646924924137],
            [9.175400034867035, -2.8251534122582274],
            [9.180469016480805, -2.8070137076539634],
            [9.189990658523504, -2.7780759494711442],
            [9.194957972408911, -2.7843666528685582],
            [9.206791726198544, -2.7863168095670963],
            [9.214251985398096, -2.7746876758132553],
            [9.216399523760623, -2.7794147762254164],
            [9.219838030072195, -2.7793642652276476],
            [9.219560522322693, -2.7722651893406516],
            [9.225607308039818, -2.7727083441941582],
            [9.228412015162718, -2.771114280123838],
            [9.237060101519338, -2.7728462802829332],
            [9.237721648905978, -2.7779882064437245],
            [9.243273115966948, -2.7821996025513496],
            [9.238290405768566, -2.791178554114983],
            [9.242355232866068, -2.7959280708367],
            [9.246903286982262, -2.798173156615913],
            [9.254654441993111, -2.7945179205792154],
            [9.257403504819221, -2.7917191385912785],
            [9.262086034615825, -2.794913570290646],
            [9.264605689806398, -2.7935925351407516],
            [9.269130185687972, -2.7956970789084923],
            [9.273533131455553, -2.7878925281857874],
            [9.317026270067634, -2.8106313623125607],
            [9.31202946595223, -2.812136687652819],
            [9.310336858126316, -2.8177244077029746],
            [9.311650707441656, -2.8354773096023984],
            [9.309508892434382, -2.8419130257025795],
            [9.315504806466441, -2.8456929156901425],
            [9.322568252751116, -2.847737785207474],
            [9.326691600419, -2.8357289823563145],
            [9.333325619846594, -2.837896712094136],
            [9.337435472590515, -2.8445933033309196],
            [9.342959548679188, -2.8507946442203056],
            [9.351972946894866, -2.853571968353878],
            [9.356239325331746, -2.8580461557195083],
            [9.356630862326579, -2.868749116047107],
            [9.36165363376442, -2.8759296121861766],
            [9.36255484699635, -2.8859116005161534],
            [9.367250458503207, -2.8935142169021377],
            [9.37076730983218, -2.9045930912036435],
            [9.377334985703314, -2.9145199099631225],
            [9.385769327026289, -2.9221034326998],
            [9.38766511206522, -2.925544994863838],
            [9.391528201368773, -2.930647606200501],
            [9.384730649433717, -2.9346570663636733],
            [9.383633635886454, -2.9426964991708124],
            [9.375898442348284, -2.9518135566901456],
            [9.374825216341915, -2.95518417411758],
            [9.379415355718537, -2.9601406425177443],
            [9.373831956718123, -2.9704109500805864],
            [9.369981147501319, -2.9821168493249925],
            [9.36785800937545, -2.996765174869796],
            [9.363205327782305, -3.0051150900481955],
            [9.361754797962684, -3.010861402981607],
            [9.35885367766764, -3.01606622480609],
            [9.355322742642906, -3.0151579238537596],
            [9.352644780277442, -3.0224955077554876],
            [9.352408290242378, -3.0263572269899406],
            [9.34965200176099, -3.0354761575786875],
            [9.350023070905017, -3.043750409878255],
            [9.353442967443284, -3.044725667844929],
            [9.353094840711398, -3.0556244159829404],
            [9.35193058838927, -3.061348772644146],
            [9.34704923492431, -3.068766414635981],
            [9.346733596450854, -3.0719271140578446],
            [9.34135605807466, -3.0717826099393584],
            [9.340733315174804, -3.0846895689287446],
            [9.34184756513669, -3.0927654185498925],
            [9.344473943290769, -3.0955091417689],
            [9.358045993787908, -3.1185055979723213],
            [9.361814582139361, -3.1312512920461706],
            [9.36029012232811, -3.1355303168166344],
            [9.36260726918212, -3.1392927567479325],
            [9.373205497335126, -3.1427701290225407],
            [9.368999886438822, -3.1567033469639605],
            [9.37566913540656, -3.1590101853636283],
            [9.371499659404673, -3.1728141522616014],
            [9.37878495406409, -3.182817244932785],
            [9.407622307007944, -3.1995975551785176],
            [9.402099144994333, -3.215584620009261],
            [9.398066487334532, -3.2285953876316356],
            [9.395739873118334, -3.228888070669579],
            [9.343118524891967, -3.2357633386903],
            [9.233964893317589, -3.2491205996173615],
            [9.165874069109181, -3.2578757550144926],
            [9.155794715153473, -3.259117877341463],
            [9.086259203201118, -3.2685726024257478],
            [9.06931058104359, -3.2708653695304664],
            [8.997334920000657, -3.2788132434218067],
            [8.996266489715216, -3.2749717424227827],
            [9.001468308648658, -3.2744305656085837],
            [9.01310693329358, -3.263373217877682],
            [9.020440546678136, -3.2620068496041745],
            [9.020733100259662, -3.2584585906361774],
            [9.026411478390582, -3.256047918953383],
            [9.032239416581064, -3.250798352604894],
            [9.036748809831192, -3.2433467140060546],
            [9.038308184030415, -3.236606958109113],
            [9.036790947166804, -3.229010811461042],
            [9.039403084048816, -3.2285246746531837],
            [9.04216758133507, -3.2208677712814913],
            [9.043009671520519, -3.2158005331298543],
            [9.046310572792388, -3.213534821926659],
            [9.052484468752613, -3.213202267518941],
            [9.056811082481996, -3.2153690593800905],
            [9.061179955447146, -3.21302166427171],
            [9.064557821862048, -3.2088353476866],
            [9.066240507047565, -3.2035518072843434],
            [9.067162726669828, -3.1957997162862912],
            [9.071981216005602, -3.1886767412837616],
            [9.074594118874042, -3.1826357647879524],
            [9.07569428069942, -3.1757235633416285],
            [9.076080721938187, -3.1639245205920847],
            [9.07153861287205, -3.161292501720467],
            [9.070830357432126, -3.1572249714414062],
            [9.065764981181403, -3.152583920537349],
            [9.063229466359765, -3.152138459673216],
            [9.056851345003041, -3.1478720143590366],
            [9.046815601801308, -3.149098732767691],
            [9.048336418364968, -3.1339195653420897],
            [9.051322944315206, -3.116713976282673],
            [9.049144847614542, -3.1067478775866344]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.16472552656411, "lat": 35.18078057643692 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47065"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01639749"
      },
      "bbox": [
        8.996266489715216, -3.2788132434218067, 9.407622307007944,
        -2.771114280123838
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.875847807774979, -3.111142713957884],
            [7.942484664464501, -3.1156018609699254],
            [7.958704131061792, -3.0901893381566325],
            [7.977703187941108, -3.069244946822059],
            [7.9914138310780345, -3.058779376593686],
            [7.990971110977761, -3.0537657618631124],
            [7.992769501142009, -3.052178008438075],
            [8.000446807194008, -3.0517268932187904],
            [8.010375878875248, -3.0460931366564097],
            [8.014915868793583, -3.050909630088907],
            [8.021006729933816, -3.0418069121496285],
            [8.023903856718254, -3.038706869454938],
            [8.051342873491345, -3.029862192310563],
            [8.05092020460606, -3.023005850782451],
            [8.047111467204367, -3.014102686982638],
            [8.048881532613951, -3.012085864299963],
            [8.05008663725147, -2.991579748451793],
            [8.053578325764912, -2.99171455716541],
            [8.062255441245302, -2.9842789965961236],
            [8.07986024699514, -2.9877446319663967],
            [8.086175629902447, -2.9906445056637114],
            [8.088219319716583, -2.992822313134494],
            [8.092177249781551, -2.9888620970625226],
            [8.095149626980863, -2.98886148678409],
            [8.09857037847137, -2.992142049052017],
            [8.100162151129217, -2.99595422456511],
            [8.10568843092052, -2.9995823192562603],
            [8.105997226740596, -2.9963682674569845],
            [8.110774119591982, -2.99590141371166],
            [8.110910737966815, -2.9994233630386256],
            [8.108186557197971, -3.0025900692070286],
            [8.101301246130681, -3.016370192264684],
            [8.105454425540733, -3.021621490680214],
            [8.10720301492241, -3.0263603344281864],
            [8.1105838589179, -3.02980733262049],
            [8.109872762273147, -3.0333084040553295],
            [8.113781667842739, -3.03937026159008],
            [8.123264451013842, -3.0393440129857248],
            [8.168554418867474, -3.052834286154185],
            [8.170116957551102, -3.053741237347898],
            [8.169672961087464, -3.0610147719678613],
            [8.176460730008191, -3.0605323536734996],
            [8.183286691189519, -3.0645013035180297],
            [8.182947239753132, -3.069192754162565],
            [8.18989547516302, -3.0686637006432007],
            [8.191519629735408, -3.07286867232153],
            [8.18986562892094, -3.0765030361023755],
            [8.193080319581087, -3.0793083723590358],
            [8.19969566498378, -3.077208380015742],
            [8.200233642346172, -3.0833350511185165],
            [8.208576940472478, -3.081287707090738],
            [8.212402443553122, -3.082115020509632],
            [8.212044847406641, -3.0874159097739207],
            [8.205320143674504, -3.088500290276818],
            [8.20556571566989, -3.093335158280716],
            [8.210872233355856, -3.093507808545915],
            [8.209798570729028, -3.0966839538491113],
            [8.203893001689766, -3.101583137634291],
            [8.204359741176226, -3.105397335048564],
            [8.208577319027084, -3.1070559977364223],
            [8.213036735731398, -3.1138289561016004],
            [8.217423352224959, -3.113238757618623],
            [8.215037405607132, -3.1070056222115556],
            [8.216626222644186, -3.1034199866622774],
            [8.229995850406183, -3.104733728880895],
            [8.230703047166125, -3.111695447180805],
            [8.243850392684305, -3.1345119249314415],
            [8.24404044821795, -3.1419833212849135],
            [8.24963293960325, -3.1505273898200588],
            [8.249700015360226, -3.1559873728328425],
            [8.253301950198738, -3.159367551565557],
            [8.25345798962356, -3.1632999069242755],
            [8.255598964114345, -3.166727023991856],
            [8.25353535714027, -3.1688599718816217],
            [8.256088500433549, -3.1794854272334323],
            [8.256729711022512, -3.1942800717178264],
            [8.259195480361315, -3.1974644707636712],
            [8.257932408771813, -3.202490159477938],
            [8.259518200413144, -3.20976334913017],
            [8.262261144816126, -3.2138315303554954],
            [8.2670291854066, -3.2147977713682376],
            [8.270497476174725, -3.206414820521924],
            [8.26924209924515, -3.204454082490836],
            [8.268536858428119, -3.1968029251123355],
            [8.270432575063657, -3.191772331440656],
            [8.273931785419203, -3.1912473632505898],
            [8.2750995525652, -3.200901472501656],
            [8.27902807197483, -3.2069318808935297],
            [8.285195841081833, -3.2069355645585538],
            [8.289963863567722, -3.211973931910759],
            [8.294546891226272, -3.2120422324831526],
            [8.300743935656019, -3.2072777362909664],
            [8.307574944533068, -3.2717100273622415],
            [8.308693624546779, -3.3018196312935815],
            [8.31419711692957, -3.343401563215087],
            [8.2507543874991, -3.3493296814991576],
            [8.193798654379849, -3.356052253990224],
            [8.144750096384554, -3.3609789507319974],
            [8.086856718448304, -3.366165876280951],
            [8.024784064356071, -3.371449451142215],
            [7.938375682732156, -3.380035874311116],
            [7.895801417811178, -3.3843210678238074],
            [7.889130950612466, -3.293357120820548],
            [7.881205752561696, -3.1831173337233283],
            [7.875847807774979, -3.111142713957884]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.58898420052189, "lat": 35.14053816194136 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47103"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01639766"
      },
      "bbox": [
        7.875847807774979, -3.3843210678238074, 8.31419711692957,
        -2.9842789965961236
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.152907035411817, -9.985328408444683],
            [-3.055423809955846, -9.990222793141793],
            [-2.976129060805939, -9.994028780225241],
            [-2.943064050518325, -9.99813972247658],
            [-2.860096488957187, -10.0015376733034],
            [-2.7234666190392236, -10.007643396931183],
            [-2.636870091389769, -10.011226294862368],
            [-2.6168263703541594, -10.013227356366382],
            [-2.607614890482174, -10.013442425762685],
            [-2.533474016838489, -10.01691693907001],
            [-2.5217910423167478, -10.017114579761966],
            [-2.5238151711743098, -10.064387285773197],
            [-2.5269828274899955, -10.155071336464257],
            [-2.5276314303852034, -10.155043599121145],
            [-2.529602788696829, -10.227646778969383],
            [-2.5311848740079532, -10.302700276230611],
            [-2.535954419793076, -10.445030832295542],
            [-2.64212555029142, -10.442259514711123],
            [-2.7482961685796092, -10.439459014636643],
            [-2.8544662928928703, -10.436629325672964],
            [-2.9606359414489685, -10.433770440939744],
            [-2.9611495672066326, -10.433504518138374],
            [-3.063890123991269, -10.43054898780113],
            [-3.1718001407376124, -10.426999383504189],
            [-3.1594628139176573, -10.140681712534004],
            [-3.152907035411817, -9.985328408444683]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.75664280311287,
          "lat": 28.422557579742158
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48127"],
        "coty_name": ["Dimmit"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dimmit County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01383849"
      },
      "bbox": [
        -3.1718001407376124, -10.445030832295542, -2.5217910423167478,
        -9.985328408444683
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0996762009716308, -10.028460061030078],
            [-1.044074072532304, -9.985736128579978],
            [-0.988483385499508, -9.942994432407781],
            [-0.9180608329427407, -9.888759337591745],
            [-0.8652209927789606, -9.847457132607088],
            [-0.7782159575706096, -9.780945896286186],
            [-0.7729297856642743, -9.780828523351895],
            [-0.7660394734342318, -9.789357275448634],
            [-0.7626471052544685, -9.790062063181406],
            [-0.7607499297947837, -9.786932124187896],
            [-0.74790530772852, -9.790641780120312],
            [-0.7494222556923384, -9.798738738363287],
            [-0.7402184957450092, -9.80211907332589],
            [-0.7385512165532417, -9.806923811740347],
            [-0.733921293746991, -9.805679629817396],
            [-0.7313929704017833, -9.809368517101953],
            [-0.7244878575799248, -9.808733648335135],
            [-0.724507820888385, -9.812839103946168],
            [-0.7198665144505495, -9.811420163037337],
            [-0.710999335573348, -9.810864783932223],
            [-0.7089624052285536, -9.813802078357769],
            [-0.6994773543803523, -9.821261515517698],
            [-0.6973648265644695, -9.825349739057597],
            [-0.6985903666801508, -9.831514515465367],
            [-0.6915497787925932, -9.830771620959633],
            [-0.6870367616674691, -9.828083813832395],
            [-0.6852176060228122, -9.829941765631501],
            [-0.687336841088085, -9.834100849865052],
            [-0.686558467546014, -9.83682427289384],
            [-0.6815672930777832, -9.842373627632169],
            [-0.6744458184150615, -9.845593731628465],
            [-0.6768310074466869, -9.854514125806341],
            [-0.6808411571671069, -9.855474348250892],
            [-0.6796138533174153, -9.860767374417978],
            [-0.6770969642420551, -9.86204098401634],
            [-0.670635647994687, -9.858882145106692],
            [-0.6650722722054548, -9.861212505038235],
            [-0.6627698668349519, -9.859398479298429],
            [-0.6515237760645229, -9.859141123327456],
            [-0.6476937893499852, -9.85793021869431],
            [-0.641755239845862, -9.859476903223053],
            [-0.637947922752769, -9.85831052210199],
            [-0.6365252969859702, -9.84962567341316],
            [-0.6328514423376074, -9.849414606555998],
            [-0.6232191450139339, -9.853197984820113],
            [-0.619493822545292, -9.852950598503316],
            [-0.617864311399732, -9.850513701262708],
            [-0.620591140243354, -9.845901675278283],
            [-0.620453780718059, -9.842340640459634],
            [-0.6167038061947698, -9.841981269057008],
            [-0.6118233494685792, -9.84457314368479],
            [-0.6032626785775763, -9.846740884716457],
            [-0.5981733414719206, -9.851684058756947],
            [-0.5931795752178834, -9.852376272431993],
            [-0.5849898036612263, -9.86823429608361],
            [-0.5799741373786355, -9.870327821444063],
            [-0.577047512060991, -9.874650144201743],
            [-0.5797442801117351, -9.88269439579311],
            [-0.5792084663141235, -9.886869933576518],
            [-0.5810239354353284, -9.893546369333194],
            [-0.5776543521613018, -9.897053271795619],
            [-0.574715513143753, -9.903830107166526],
            [-0.5714540116694571, -9.90872502873545],
            [-0.5688260500320755, -9.91593509145456],
            [-0.563269754117547, -9.921047128678612],
            [-0.5560197803769898, -9.923168608150974],
            [-0.5537377550018914, -9.930455077042255],
            [-0.5562427837098023, -9.933144184166503],
            [-0.5584238879957535, -9.941617576953522],
            [-0.5617857930617219, -9.947346441328138],
            [-0.5604233208916932, -9.953943477296818],
            [-0.5619000447614163, -9.958123400540138],
            [-0.5688858075987333, -9.963750510411609],
            [-0.5709373377546543, -9.968814861645312],
            [-0.5645466976953674, -9.968958512210156],
            [-0.5620540305153453, -9.977859362867331],
            [-0.5763590521744411, -10.092922959912622],
            [-0.5740347427273838, -10.099625906202444],
            [-0.570332192601203, -10.1042349004136],
            [-0.5710584059324539, -10.10810890542777],
            [-0.5670676329629437, -10.109702883378237],
            [-0.5654921964349684, -10.113758962634588],
            [-0.5669283599437905, -10.117977869026056],
            [-0.5625916258988941, -10.120808683133067],
            [-0.5661939806928866, -10.123360626564473],
            [-0.5658655337323867, -10.125880535994963],
            [-0.5610640471103256, -10.125775510416934],
            [-0.5595209619963782, -10.131422153711672],
            [-0.5518750839344972, -10.132939289043618],
            [-0.5552995884399295, -10.137393484002615],
            [-0.5603766549782823, -10.137308871389909],
            [-0.5583358524774354, -10.14124798509011],
            [-0.5600860034753966, -10.146145270746896],
            [-0.5580480340419359, -10.149267886505225],
            [-0.558772006208748, -10.150001770096365],
            [-0.6063416668694688, -10.189542703853505],
            [-0.6539205787638944, -10.229069105256725],
            [-0.7015087729987122, -10.268580910277821],
            [-0.7491062806233527, -10.308078054927801],
            [-0.7495243071094178, -10.308551029614556],
            [-0.7539105265109827, -10.306419637356093],
            [-0.7568952558697154, -10.307471204473428],
            [-0.760789597644084, -10.305912769638486],
            [-0.7604208324924937, -10.30151241141721],
            [-0.7644309586383352, -10.301059167956362],
            [-0.7672862152747546, -10.30478570210953],
            [-0.7721946409062215, -10.303168875488645],
            [-0.7721601846727402, -10.299163096663934],
            [-0.7689836422447758, -10.294183974417095],
            [-0.7712204713327382, -10.291542756475337],
            [-0.77630375561608, -10.291289287065636],
            [-0.7798043855971665, -10.289136832883486],
            [-0.7889522656263244, -10.29276981390107],
            [-0.794418946429004, -10.28532881616792],
            [-0.7981282605813902, -10.283950814968708],
            [-0.801286385139786, -10.28625770553974],
            [-0.808646257053802, -10.28816806549784],
            [-0.8101623268464669, -10.293593780038826],
            [-0.8125017864794559, -10.29333694103558],
            [-0.8143555654394887, -10.288320111915787],
            [-0.8230418261252489, -10.289005952486542],
            [-0.8273561889217553, -10.285226529079901],
            [-0.8284523366107343, -10.279821130664045],
            [-0.8325199119078173, -10.27704915678461],
            [-0.8324462806994725, -10.271580757543495],
            [-0.8359644742091145, -10.270237270726136],
            [-0.8413553479289659, -10.262822848179953],
            [-0.8454679866377418, -10.260303539856029],
            [-0.8531869104558235, -10.257774423782855],
            [-0.8619667610837709, -10.259353183678467],
            [-0.8658070833011052, -10.263611725455046],
            [-0.8743106641243985, -10.264193165463269],
            [-0.8794821853006858, -10.25550618972444],
            [-0.876347672100919, -10.250382838393662],
            [-0.8808120822507903, -10.248993944415561],
            [-0.8864684105677921, -10.249934270169284],
            [-0.889473705473119, -10.248115456898143],
            [-0.8952065251583354, -10.249414295934109],
            [-0.9005936992687309, -10.244785471699581],
            [-0.9035531136630357, -10.245597040921238],
            [-0.9057188164706177, -10.24081329635754],
            [-0.9062179450865261, -10.233297240008355],
            [-0.9035592923443102, -10.22880871974163],
            [-0.9039047493222364, -10.214736320001498],
            [-0.905835776668803, -10.20452803604644],
            [-0.9049567832085095, -10.194099226193876],
            [-0.9068522550528406, -10.192966821879578],
            [-0.9088888841086439, -10.182862556080645],
            [-0.9127420461027533, -10.180671988521812],
            [-0.9179795336561654, -10.181575073713779],
            [-0.9201885752189802, -10.177481902477751],
            [-0.9249983763005607, -10.174443229409556],
            [-0.9312290412055998, -10.174353018173347],
            [-0.9330792138161275, -10.172518373950712],
            [-0.9408068311108082, -10.171695673740258],
            [-0.946499678522491, -10.173228924587303],
            [-0.9525530550965386, -10.170412535956928],
            [-0.9543454465369798, -10.173285042056172],
            [-0.9594668628049549, -10.169861963184156],
            [-0.9684698157833251, -10.168105840307513],
            [-0.9749969146679092, -10.171397021719237],
            [-0.9777362588428857, -10.17116007425174],
            [-0.9862538143857493, -10.175010795242526],
            [-0.9927693518335117, -10.170601343691821],
            [-1.0050568187326894, -10.16533542469932],
            [-1.005370807843449, -10.16141180760895],
            [-1.0080175020332025, -10.160052738230856],
            [-1.0150048584998195, -10.160519851799599],
            [-1.0195813287605, -10.158455925363278],
            [-1.020704779549149, -10.155659389694742],
            [-1.0298919919542382, -10.154012224709486],
            [-1.0314707474150204, -10.150320431373846],
            [-1.0329290216662406, -10.14087990726762],
            [-1.0355791241247607, -10.137833966681288],
            [-1.0340037824302564, -10.135396903364441],
            [-1.0364049585684778, -10.129523857105216],
            [-1.0403621566879901, -10.127221775772613],
            [-1.03967710767418, -10.121185814267758],
            [-1.04249236804418, -10.117931043753103],
            [-1.04358869613235, -10.109689804203224],
            [-1.0464970511328504, -10.104919869820199],
            [-1.051070525457912, -10.100320471629887],
            [-1.0501262583766051, -10.095103889785511],
            [-1.0537668942502323, -10.091683189468489],
            [-1.0576812827984803, -10.083715399703403],
            [-1.0564132182582668, -10.075557975211076],
            [-1.059530951868594, -10.072940068915248],
            [-1.0591562954061073, -10.068477169074374],
            [-1.0646652457229868, -10.06613445620766],
            [-1.0684738241223457, -10.060828411296102],
            [-1.0755535204413407, -10.057201423871707],
            [-1.0783601305473283, -10.052271572204212],
            [-1.0771330256413185, -10.048926517042128],
            [-1.0795855486981825, -10.041596628639317],
            [-1.082309240742206, -10.04062603754475],
            [-1.0921247053759342, -10.031968590002379],
            [-1.09393466220512, -10.028273725761984],
            [-1.0996762009716308, -10.028460061030078]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.42650878346414,
          "lat": 28.657091668399488
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48175"],
        "coty_name": ["Goliad"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Goliad County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "01383873"
      },
      "bbox": [
        -1.0996762009716308, -10.308551029614556, -0.5518750839344972,
        -9.780828523351895
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4077639500487555, -8.355236707705801],
            [-1.367963638987828, -8.389375469074027],
            [-1.3373867523409788, -8.41530841389172],
            [-1.3173366132247035, -8.433054719718202],
            [-1.284042384455136, -8.461644485355425],
            [-1.2010500541160467, -8.532688375217552],
            [-1.1547406522080583, -8.572536448250231],
            [-1.0757981261201506, -8.640111754958905],
            [-1.0318704771802147, -8.677465156973627],
            [-1.0140189399725412, -8.692925776904609],
            [-1.0474062770681987, -8.719694678945352],
            [-1.0529681035003537, -8.721352074653096],
            [-1.0595651034585374, -8.727072416542875],
            [-1.0639670215005836, -8.7361772774792],
            [-1.0720918308372773, -8.747252338228876],
            [-1.0740498971737376, -8.751193098795268],
            [-1.0818641471266688, -8.757259469412535],
            [-1.0842924718391493, -8.760626083693367],
            [-1.0878242657825017, -8.769042948253478],
            [-1.0974343929930284, -8.772757657716229],
            [-1.1100175590353067, -8.779262547784677],
            [-1.1192285333293857, -8.78504201262581],
            [-1.1265010545904215, -8.790965201495899],
            [-1.137504099983712, -8.796969292699615],
            [-1.15546062598059, -8.810698609224433],
            [-1.1768648082815238, -8.82812221466173],
            [-1.1798634544283482, -8.84655289799379],
            [-1.182054334411586, -8.85366061818368],
            [-1.1730052003228404, -8.854859522851765],
            [-1.1705282143571951, -8.84965031455388],
            [-1.161834240255252, -8.851343511013019],
            [-1.1612264550768852, -8.853676669543313],
            [-1.2214562275207086, -8.903207311187572],
            [-1.2708971996949678, -8.956048314209184],
            [-1.295954256797854, -8.860504056995607],
            [-1.330850422773328, -8.83088754485948],
            [-1.3731484679542223, -8.795226809722763],
            [-1.437138346509968, -8.74088491315109],
            [-1.486264892148647, -8.698846142314476],
            [-1.522782520956866, -8.667928046571445],
            [-1.4872780581744536, -8.571183878071084],
            [-1.4665254311390208, -8.515246481355321],
            [-1.4386347782611952, -8.438777422599163],
            [-1.4168209599659412, -8.379181487006933],
            [-1.4077639500487555, -8.355236707705801]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.03117061419253,
          "lat": 30.057882096157318
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48209"],
        "coty_name": ["Hays"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hays County"],
        "coty_fp_code": "209",
        "coty_gnis_code": "01383890"
      },
      "bbox": [
        -1.522782520956866, -8.956048314209184, -1.0140189399725412,
        -8.355236707705801
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.21597251762105096, -5.759843970814993],
            [0.21645098226281986, -5.736739535511957],
            [0.21688183266369576, -5.676654890085293],
            [0.21712316662415224, -5.666068861282659],
            [0.2175614322876276, -5.601033757827554],
            [0.21829475853958802, -5.532946895098575],
            [0.21852319635547543, -5.471201913333903],
            [0.2186427846135704, -5.389007120227957],
            [0.25477602936087757, -5.383467466139323],
            [0.2742584157421103, -5.380207678587206],
            [0.33325479208862213, -5.370938583334253],
            [0.45372236503308677, -5.351679734276513],
            [0.470412230828523, -5.349159926327015],
            [0.5808682453999221, -5.331566227896967],
            [0.5804816791877813, -5.382709871860617],
            [0.5801585348293054, -5.3880167858884604],
            [0.5788709248299398, -5.462781142041735],
            [0.5786139176406915, -5.522193023893225],
            [0.5779159422147084, -5.612231482041165],
            [0.5778046217715997, -5.6766958125952725],
            [0.5775726412949596, -5.691918170985822],
            [0.5778094404324826, -5.742165444722099],
            [0.5783454693804667, -5.762330599491022],
            [0.5705813829679067, -5.76253062271018],
            [0.5485999689696414, -5.7621425817246035],
            [0.5093389771203064, -5.762093643950333],
            [0.48665884210549415, -5.8399836488200405],
            [0.48500347270533695, -5.8467825515493415],
            [0.48262380024898943, -5.848290559590429],
            [0.48199046998568096, -5.855843657617394],
            [0.47798532492946344, -5.856655208972159],
            [0.47809615348818524, -5.860277448607511],
            [0.47536452510615773, -5.861651118344807],
            [0.4749256992363869, -5.869029658904057],
            [0.49187952017712405, -5.887950299903573],
            [0.49840377078431564, -5.891654696684438],
            [0.4989017182618463, -5.8960649488973305],
            [0.5104407383363293, -5.896915696155717],
            [0.511272255547397, -5.900766173772126],
            [0.5180722046669795, -5.901763597799667],
            [0.5184969297520987, -5.904887671159224],
            [0.481380367170644, -5.90439212311304],
            [0.3996023969205446, -5.903607723257616],
            [0.3237209640332012, -5.901874408757172],
            [0.2737719303825061, -5.900844416926541],
            [0.25446350113401817, -5.90095523366726],
            [0.21545256455078676, -5.900010739736999],
            [0.21575474369723663, -5.843725197103848],
            [0.21597251762105096, -5.759843970814993]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.08546737526436, "lat": 33.12359705985382 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48231"],
        "coty_name": ["Hunt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hunt County"],
        "coty_fp_code": "231",
        "coty_gnis_code": "01383901"
      },
      "bbox": [
        0.21545256455078676, -5.904887671159224, 0.5808682453999221,
        -5.331566227896967
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8071248257573187, -8.606540505072866],
            [1.8108240270089526, -8.603749658866267],
            [1.8142483287526054, -8.60527436294854],
            [1.8218134935397134, -8.613842597801689],
            [1.8282289480729161, -8.61407011772286],
            [1.8338101084135239, -8.61995265242489],
            [1.838896672314807, -8.619139857280759],
            [1.846843093051798, -8.621346545833795],
            [1.847753744378999, -8.618952129301368],
            [1.8533407874360261, -8.612755632846111],
            [1.8563899472499117, -8.61465514065542],
            [1.861933192241643, -8.6104855336765],
            [1.8665738521149549, -8.609467596378241],
            [1.874716576909269, -8.615367602479063],
            [1.8798050683983, -8.615294850679161],
            [1.880782595119092, -8.612483973194005],
            [1.8897533192778535, -8.610687726654973],
            [1.8895411105557227, -8.613512335635022],
            [1.8992779235485182, -8.613554497818173],
            [1.8997557373206668, -8.610669817435527],
            [1.9048662497904336, -8.607569163832476],
            [1.9060294242827287, -8.60509725799951],
            [1.9103281974757482, -8.60641666657177],
            [1.912916107379605, -8.603516800546716],
            [1.9157432666540921, -8.604197186980947],
            [1.918849347797746, -8.599997783202737],
            [1.9246222939780953, -8.600321209139366],
            [1.9306477943019589, -8.601946859445272],
            [1.9385774856983382, -8.599699187823438],
            [1.9433724656276588, -8.588220992899577],
            [1.948874977065113, -8.585982717375753],
            [1.9520781004067465, -8.576984787242914],
            [1.9520399433761355, -8.570666047302737],
            [1.9489315994049945, -8.566092721761066],
            [1.9500947193589275, -8.561697316238742],
            [1.949256207420762, -8.557548623592567],
            [1.9524587534168936, -8.547364861487635],
            [1.9608596645138945, -8.549917661566639],
            [1.9656606516154596, -8.549828903799481],
            [1.9673371002112572, -8.545753438837748],
            [1.9755866820956798, -8.550638086059035],
            [1.978867640336746, -8.548033715475697],
            [1.9821972958842824, -8.551548427333072],
            [1.9865561188862677, -8.55168049352974],
            [1.9875327871303392, -8.547269824711078],
            [1.9905501796729852, -8.544405322108554],
            [1.9970421667709275, -8.543166317583896],
            [2.0014486801223237, -8.536771192928576],
            [2.0067666957812644, -8.534672536309994],
            [2.009426668243404, -8.53195743932318],
            [2.0089885993769543, -8.529037498604108],
            [2.0140317289740612, -8.527858704699517],
            [2.0176281896685633, -8.532101355255215],
            [2.0237421670194493, -8.530308570825598],
            [2.0269691191011106, -8.532637046307284],
            [2.0266219394804246, -8.536483940611404],
            [2.0303340024114, -8.536196985462604],
            [2.0345376350803086, -8.533564843545275],
            [2.037580303112437, -8.528285888538779],
            [2.040987090518698, -8.531187933687159],
            [2.04056225201308, -8.537134369458416],
            [2.047228313440203, -8.539699648529293],
            [2.0442664361873457, -8.542513745021962],
            [2.0538114845391577, -8.545193903583362],
            [2.0583139234678156, -8.544948999606188],
            [2.0697570336539104, -8.549774830493194],
            [2.0711270602418357, -8.546574759580622],
            [2.0794395530237364, -8.549424386115398],
            [2.086379108553752, -8.54939889009403],
            [2.0903562413409267, -8.554599266405837],
            [2.092474454424034, -8.559712037984928],
            [2.092699161694473, -8.56647422460454],
            [2.095900426220711, -8.568898232010072],
            [2.101380885613438, -8.56945977207447],
            [2.1036763126710194, -8.57149229105907],
            [2.102209542679942, -8.575379785491092],
            [2.0972640342933024, -8.576653829272509],
            [2.0997829988185734, -8.579614901544549],
            [2.1058060492588155, -8.57817977553073],
            [2.110997454565499, -8.582850387718342],
            [2.1157589789685787, -8.583349957889764],
            [2.12239759170448, -8.586881786193928],
            [2.1235330793788605, -8.591711611741957],
            [2.127189589052798, -8.59728305941988],
            [2.127192477475259, -8.601640162085465],
            [2.1235998414582693, -8.607652504710698],
            [2.1162376669161573, -8.61106705815463],
            [2.1131520543992486, -8.619125159335114],
            [2.1172933055583236, -8.624710462487862],
            [2.110782212296512, -8.62755973797366],
            [2.112457221794196, -8.631427577585262],
            [2.1237151367928826, -8.63658356665225],
            [2.131305654042187, -8.635305802612612],
            [2.140644412275726, -8.637905904697872],
            [2.1473127165131953, -8.634305692586834],
            [2.1518141734896625, -8.638768772080423],
            [2.150764825201396, -8.642354359736375],
            [2.152322397331725, -8.646579962219995],
            [2.155312253074386, -8.648994247587787],
            [2.159298940272423, -8.649408003114802],
            [2.1638912541807924, -8.645749996474823],
            [2.167062240618943, -8.645572179344157],
            [2.1689680500428676, -8.648715099291005],
            [2.1650941557614996, -8.65364565385172],
            [2.1679144753901425, -8.660517864998743],
            [2.166612586012779, -8.664207463400661],
            [2.1623733640495115, -8.668254045940376],
            [2.1619105564948398, -8.670936343233992],
            [2.1646593661302864, -8.678304514601935],
            [2.1655597396551913, -8.684125425047961],
            [2.1695847383096014, -8.686319624698578],
            [2.1740902403413065, -8.68256551006382],
            [2.177189036204123, -8.681808774974316],
            [2.1822308490059448, -8.68299154638305],
            [2.188753472589044, -8.6805797040853],
            [2.194414432260301, -8.682398261281968],
            [2.192740647862428, -8.693166152768065],
            [2.1963100562148057, -8.698238931957835],
            [2.2052962530691076, -8.689638589550656],
            [2.210172435195698, -8.69112006239095],
            [2.2081196559013647, -8.700268572896277],
            [2.20937073989754, -8.702122938592042],
            [2.2145424998612824, -8.70122236467697],
            [2.221216003843176, -8.6977172095068],
            [2.2275772764284048, -8.697269721965082],
            [2.2303239005343456, -8.698810959503167],
            [2.2332351890395636, -8.70933884204924],
            [2.2384010791227786, -8.712832478034832],
            [2.2536056025171076, -8.718800402349727],
            [2.2647878710211304, -8.713709272694425],
            [2.268454842053224, -8.713654523166882],
            [2.27207738232654, -8.71661930999567],
            [2.2739819407221673, -8.720536806485425],
            [2.2776035078306083, -8.72382294034434],
            [2.2943611148879133, -8.726692156648859],
            [2.3051551383582574, -8.727703896023453],
            [2.3152439281190524, -8.731026010254709],
            [2.3171929473929676, -8.733294493775416],
            [2.319391065258127, -8.740402678492899],
            [2.3236608470550135, -8.744202521748853],
            [2.329834831348153, -8.753057780489115],
            [2.3336282456411963, -8.763802323210687],
            [2.3348415898314556, -8.777959482660886],
            [2.3332120250096917, -8.794475911599411],
            [2.325273648083556, -8.831905503139437],
            [2.3228240941255023, -8.842073534154707],
            [2.3150062571604475, -8.849976655069513],
            [2.307440091594976, -8.855611123870501],
            [2.291830876514337, -8.864353052999803],
            [2.2832599584843924, -8.870664595976903],
            [2.26997650333117, -8.882820144385478],
            [2.264578029609178, -8.889028706808451],
            [2.2602290855561176, -8.898188645186755],
            [2.259320749027369, -8.904821636569876],
            [2.259795569891588, -8.910617764480595],
            [2.2619573407289284, -8.918006878595518],
            [2.265608538338979, -8.922389382607024],
            [2.2866634295261776, -8.935251080701452],
            [2.2907549474567057, -8.939401067806973],
            [2.29351718621719, -8.944892859975978],
            [2.291099636824818, -8.953487549659668],
            [2.293187908885784, -8.961760741525971],
            [2.2956839579050072, -8.96406272601926],
            [2.308693609115027, -8.968189087362411],
            [2.3121469068054745, -8.97037446016071],
            [2.3183177917828854, -8.981529249722426],
            [2.3409753418709767, -9.014075020085068],
            [2.338035218072432, -9.016907316370952],
            [2.341452775168882, -9.025523517476545],
            [2.3209919918919595, -9.025997617068176],
            [2.2673628037540445, -9.023702706797726],
            [2.2416531946933014, -9.023437434275635],
            [2.236059292563197, -9.024757985686584],
            [2.2308057176604796, -9.024234804331387],
            [2.213710750787382, -9.02494541604702],
            [2.1992827382518425, -9.026164415041796],
            [2.1872164098721725, -9.028212732300593],
            [2.166798429715056, -9.033225508106462],
            [2.1516528205977195, -9.0373412205208],
            [2.1177770518311894, -9.048531246522442],
            [2.09729615362664, -9.056995739901746],
            [2.0734383746251126, -9.067254813214413],
            [2.0408798213980646, -9.081855898221429],
            [1.976160075404764, -9.112036411704512],
            [1.9471928618892473, -9.125972232556478],
            [1.8951086255806284, -9.149404897452051],
            [1.895514150281303, -9.137271331701882],
            [1.8941139051623823, -9.092348476943288],
            [1.8941232713479954, -9.087530540732564],
            [1.8910218272594335, -8.985429773899288],
            [1.888605289180072, -8.908920206548807],
            [1.8861173714609296, -8.828444431261845],
            [1.8145314310648513, -8.83010472968521],
            [1.8131020384038963, -8.82760762399118],
            [1.8088865299243395, -8.686329484336808],
            [1.8069718387529572, -8.607529188973546],
            [1.8071248257573187, -8.606540505072866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.16292439829891,
          "lat": 29.884065840597838
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48245"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "245",
        "coty_gnis_code": "01383908"
      },
      "bbox": [
        1.8069718387529572, -9.149404897452051, 2.341452775168882,
        -8.527858704699517
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.617429796937336, -9.53447279168832],
            [-3.5786717383031825, -9.536365313289414],
            [-3.48114395767695, -9.540261238870425],
            [-3.383615428091443, -9.544135076274861],
            [-3.2528758125907453, -9.550438295571153],
            [-3.2507151966070214, -9.550175623998133],
            [-3.13141087293662, -9.554626942006992],
            [-3.1390397010593554, -9.711125223315651],
            [-3.142642330473207, -9.782903714667462],
            [-3.146359137530748, -9.857386442666119],
            [-3.146326915934638, -9.859512415562905],
            [-3.152907035411817, -9.985328408444683],
            [-3.1594628139176573, -10.140681712534004],
            [-3.1718001407376124, -10.426999383504189],
            [-3.25879030781974, -10.424213273965632],
            [-3.260059299438119, -10.408845996061206],
            [-3.262227936880971, -10.394522547682262],
            [-3.2643949370945724, -10.389248835478886],
            [-3.2672153020625543, -10.38616684132429],
            [-3.2747683391285864, -10.385017432722295],
            [-3.2871897496043605, -10.38640206899927],
            [-3.291893775333948, -10.384148301183941],
            [-3.2971412122445862, -10.379830308419296],
            [-3.299595030704551, -10.375511486696137],
            [-3.305360564518961, -10.369719815948264],
            [-3.313662866597646, -10.357390168867418],
            [-3.3180287687634618, -10.349353512520628],
            [-3.32353877115039, -10.346114123162714],
            [-3.3269178339501964, -10.34107003745799],
            [-3.3273823761058825, -10.33524996973233],
            [-3.320682883661216, -10.31913634414683],
            [-3.319054567176003, -10.311885305931428],
            [-3.3209253806071297, -10.303524910192754],
            [-3.3261113195137364, -10.297170566589966],
            [-3.333815467629103, -10.285847239373787],
            [-3.338230678540516, -10.28156207591871],
            [-3.3391607156856846, -10.276691618100248],
            [-3.3421584808674063, -10.274210950484864],
            [-3.3435819146160988, -10.270123695303273],
            [-3.3443236837201544, -10.262794520843567],
            [-3.346883020009805, -10.258028357223388],
            [-3.3564646337558504, -10.24458240919972],
            [-3.364771782037336, -10.234789718838071],
            [-3.369684117862877, -10.221697674755228],
            [-3.3707662089024146, -10.217175954867756],
            [-3.3654542089492376, -10.210030466617846],
            [-3.3577067206606825, -10.190663195263681],
            [-3.358543910207338, -10.178066033565923],
            [-3.36153248695334, -10.171433806208599],
            [-3.369237847805184, -10.161576912397402],
            [-3.3749458926225784, -10.156998192645094],
            [-3.383282824088308, -10.145656662400043],
            [-3.3835822176790926, -10.141511293926953],
            [-3.3779582761786524, -10.138519588805378],
            [-3.3694452764049316, -10.138572723582088],
            [-3.3621921438311166, -10.135349653095236],
            [-3.3557460289820376, -10.130252201650306],
            [-3.352650103706111, -10.124874926319203],
            [-3.353378642791818, -10.12191139021698],
            [-3.3616332777749425, -10.118558102709454],
            [-3.37177526172288, -10.116609279403887],
            [-3.3769907643373362, -10.1129048309414],
            [-3.3985651973071827, -10.106396740606375],
            [-3.400154693688428, -10.104628285583328],
            [-3.4049642835944147, -10.092009635793302],
            [-3.4096691884086074, -10.08888733339285],
            [-3.413479000037755, -10.084322614298259],
            [-3.4170956864805357, -10.074961315067332],
            [-3.4183231431964916, -10.06824902925653],
            [-3.41553317319651, -10.062755828843441],
            [-3.4122014235118905, -10.059876799021177],
            [-3.4115488880540923, -10.056873340897766],
            [-3.404789775094229, -10.045519373936239],
            [-3.404156746482594, -10.040862237522358],
            [-3.407020770874116, -10.034346708035411],
            [-3.414673247802862, -10.031882305540506],
            [-3.4234098816842855, -10.027166921625694],
            [-3.4342081576015913, -10.02263220206817],
            [-3.4353301475494358, -10.014137875094148],
            [-3.4452273911269806, -10.012020654843232],
            [-3.4472172037112476, -10.01043449992877],
            [-3.4480363705709167, -10.003068061203116],
            [-3.44662560595439, -9.997103907176047],
            [-3.445806879640333, -9.986995435501244],
            [-3.4443760411404316, -9.979768214205448],
            [-3.4482725117524966, -9.977233779070625],
            [-3.459377438371653, -9.978349098123065],
            [-3.4693235342283755, -9.972272367682812],
            [-3.473456564774415, -9.9640564046951],
            [-3.481778045399055, -9.960936560845466],
            [-3.489479027352565, -9.95900013710391],
            [-3.492095895162578, -9.952399408896664],
            [-3.498491498469192, -9.927952486638059],
            [-3.499502122992244, -9.911436180313837],
            [-3.4956430615292526, -9.906307838533493],
            [-3.4943159418925562, -9.902532604733867],
            [-3.4950721899091075, -9.898402946244609],
            [-3.493672413499602, -9.887529783460916],
            [-3.4939874257689745, -9.879063793738355],
            [-3.499728679248884, -9.877316324898642],
            [-3.5007327180605965, -9.874471126328736],
            [-3.4994835878638955, -9.86930238377033],
            [-3.505423574961048, -9.861749492630661],
            [-3.5104460185539095, -9.862963176195372],
            [-3.5147636041939094, -9.86178252520691],
            [-3.5151960325831726, -9.855736943609514],
            [-3.5127784420758736, -9.85237656728866],
            [-3.512460967172586, -9.84797992572246],
            [-3.517519595662637, -9.841504578778185],
            [-3.5176394444186503, -9.834930385262536],
            [-3.5133598356659563, -9.828463478754625],
            [-3.513996356466201, -9.819362929462587],
            [-3.5156340151967163, -9.813755632718417],
            [-3.521071659959974, -9.810960401587183],
            [-3.5237723937253542, -9.806723861637893],
            [-3.5234214323235746, -9.799534286645],
            [-3.524758606308664, -9.79369605271848],
            [-3.5297309244546486, -9.791065670874248],
            [-3.539186900400539, -9.789978113947141],
            [-3.545055618085656, -9.792243403047678],
            [-3.5486082958826306, -9.789641748208995],
            [-3.5501351640015057, -9.782298335452928],
            [-3.546167331124655, -9.770373458604398],
            [-3.5523846155650616, -9.76264590944823],
            [-3.558918050767235, -9.758167592042998],
            [-3.561277294179202, -9.755280769965818],
            [-3.5603782782970828, -9.746134883535964],
            [-3.5664637098559435, -9.744439704227629],
            [-3.5670364488828676, -9.739209833927182],
            [-3.564831470239921, -9.73685658822279],
            [-3.5596340320087507, -9.73484392803785],
            [-3.5616160969911554, -9.729348617448252],
            [-3.5678814495901774, -9.7318945632957],
            [-3.5712662339072345, -9.729838990679873],
            [-3.567977149743793, -9.717803405358216],
            [-3.5737428267174396, -9.715987614773208],
            [-3.5791426909040567, -9.716565890010685],
            [-3.5828787578604437, -9.709445114291656],
            [-3.5874369485725817, -9.70816313524335],
            [-3.590982542448914, -9.71377487952196],
            [-3.594883034148035, -9.714469482070546],
            [-3.598554608630584, -9.706216631384969],
            [-3.601126635619789, -9.704866814795553],
            [-3.600846271118498, -9.700927262445564],
            [-3.5948874169459453, -9.701149916547651],
            [-3.5927153339462254, -9.699354158390832],
            [-3.5930733660769945, -9.693695474598146],
            [-3.6000200657648898, -9.68979732368446],
            [-3.604319164337943, -9.679092024571089],
            [-3.6096502775846395, -9.675182853887005],
            [-3.609731591701465, -9.670339058524727],
            [-3.6057038908296573, -9.660487602027326],
            [-3.6079579161803492, -9.654321114413378],
            [-3.6049107283273187, -9.650815678350384],
            [-3.6045032722398322, -9.647094066926767],
            [-3.60616390401395, -9.640410601107511],
            [-3.6055665743113767, -9.635073170472166],
            [-3.603310251114376, -9.631676081266464],
            [-3.605655462483455, -9.6216589773847],
            [-3.605127881497266, -9.617619180391113],
            [-3.6087743410744313, -9.602882152276406],
            [-3.610739560418557, -9.600945156160206],
            [-3.6136239710437077, -9.586730552136224],
            [-3.615439566200089, -9.57032572134413],
            [-3.6143311744512165, -9.560452422423127],
            [-3.6148665934561595, -9.544588627969215],
            [-3.6163564870754756, -9.541934054799881],
            [-3.617429796937336, -9.53447279168832]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.31452348704427,
          "lat": 28.74261751561541
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48323"],
        "coty_name": ["Maverick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Maverick County"],
        "coty_fp_code": "323",
        "coty_gnis_code": "01383944"
      },
      "bbox": [
        -3.617429796937336, -10.426999383504189, -3.13141087293662,
        -9.53447279168832
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.047992526419169, -7.574669957744364],
            [-2.9020596342674487, -7.581469748376483],
            [-2.797835799795716, -7.585813310492168],
            [-2.667382726810996, -7.591094828525066],
            [-2.6113324449475983, -7.592949699810976],
            [-2.615775946653468, -7.6988007667067935],
            [-2.617250179949323, -7.738541013178612],
            [-2.5156690478205754, -7.74241655210399],
            [-2.5196430214372554, -7.858756158812054],
            [-2.5233576968323215, -7.970589816007843],
            [-2.549292026246525, -7.969645833834719],
            [-2.6382396321576382, -7.96609180004871],
            [-2.64460879570055, -7.966322276548656],
            [-2.7695915394811164, -7.961256097201446],
            [-2.8463534963839705, -7.958371089990586],
            [-2.9558057916125557, -7.95395800160439],
            [-3.065257223570834, -7.949523220164354],
            [-3.0549309738941575, -7.717435720113292],
            [-3.054777759961166, -7.715948092749108],
            [-3.047992526419169, -7.574669957744364]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.82059985043593,
          "lat": 30.889808493694893
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48327"],
        "coty_name": ["Menard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Menard County"],
        "coty_fp_code": "327",
        "coty_gnis_code": "01383949"
      },
      "bbox": [
        -3.065257223570834, -7.970589816007843, -2.5156690478205754,
        -7.574669957744364
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.7495243071094178, -10.308551029614556],
            [-0.7491062806233527, -10.308078054927801],
            [-0.7015087729987122, -10.268580910277821],
            [-0.6539205787638944, -10.229069105256725],
            [-0.6063416668694688, -10.189542703853505],
            [-0.558772006208748, -10.150001770096365],
            [-0.5580480340419359, -10.149267886505225],
            [-0.5536296171100634, -10.154839163392248],
            [-0.5486942063377347, -10.150062497757249],
            [-0.5425679735311606, -10.154481691914825],
            [-0.5400094659101937, -10.149136098809526],
            [-0.5354527710775844, -10.153494995705941],
            [-0.5289452038215059, -10.157546318657136],
            [-0.5223928421965995, -10.154747622268129],
            [-0.5179744742065774, -10.154194696372993],
            [-0.5135668480318206, -10.149570986023027],
            [-0.5086103996793166, -10.148525739459371],
            [-0.5058404020990549, -10.156266997786705],
            [-0.4977289508587322, -10.16486101995222],
            [-0.4904396948852925, -10.168330623043541],
            [-0.4851844241187437, -10.169620074757312],
            [-0.48462069341452874, -10.165552383708247],
            [-0.48925634531550277, -10.161720140789834],
            [-0.48676866131290897, -10.15795474306605],
            [-0.48319535716651146, -10.15898665280221],
            [-0.4800061098584699, -10.156430070478315],
            [-0.47120127181559995, -10.162661200950502],
            [-0.47053992045427634, -10.157995192800367],
            [-0.464200796100635, -10.15510816708727],
            [-0.45965382334738275, -10.155295196354178],
            [-0.4562088077857686, -10.159317374235222],
            [-0.4596270418269463, -10.16704245941288],
            [-0.4561021203616065, -10.171682010396317],
            [-0.451870630324602, -10.171497867687448],
            [-0.4476802894235791, -10.165719748230218],
            [-0.4400871684500185, -10.16375594474469],
            [-0.4406567603832947, -10.171285934686088],
            [-0.43468997328225767, -10.183396574923142],
            [-0.42517391535542587, -10.188696524451164],
            [-0.42109746667927317, -10.194573195550483],
            [-0.41226768625884347, -10.194862963769355],
            [-0.4106944757236527, -10.200417533023355],
            [-0.4013873257053896, -10.20387885214279],
            [-0.3989216149191421, -10.200679152357578],
            [-0.38983067668328447, -10.1985290318465],
            [-0.37418267556505724, -10.201251487224756],
            [-0.3679176725640742, -10.204550459763011],
            [-0.3601528397523771, -10.2068844672176],
            [-0.3512873090631115, -10.215458411166503],
            [-0.3423874847570911, -10.217202569239932],
            [-0.3378630793313179, -10.21346508915114],
            [-0.3432561097381883, -10.2068490731145],
            [-0.338647588644186, -10.201476290334108],
            [-0.33221803214404655, -10.19800752369503],
            [-0.3304522689060022, -10.194751084628184],
            [-0.3209889983358508, -10.19725558531113],
            [-0.31403164294311403, -10.198967238276534],
            [-0.3113865904833361, -10.20272576062254],
            [-0.3107239341606109, -10.208230603430177],
            [-0.3026064904472988, -10.2125410243833],
            [-0.2987099448889546, -10.213690476722412],
            [-0.29674170207492767, -10.217021918170198],
            [-0.2966775688659078, -10.224966581381866],
            [-0.2951749584230651, -10.228091358674378],
            [-0.2908576139212666, -10.229856736599126],
            [-0.28400911897918274, -10.227813197592816],
            [-0.28412120856087003, -10.23142619616958],
            [-0.2791520001146656, -10.233945762045865],
            [-0.276741823341126, -10.23884314854341],
            [-0.2764655392817922, -10.245073614987506],
            [-0.2716873887700058, -10.24936871955764],
            [-0.2678095856102069, -10.255455088126164],
            [-0.2621004591880405, -10.258253534065446],
            [-0.25833686227917324, -10.266839281077974],
            [-0.2534251639603831, -10.273366005074637],
            [-0.24957128333064094, -10.272824169219803],
            [-0.24168103443897004, -10.265231677791885],
            [-0.23941891166351695, -10.261913925011715],
            [-0.2320411008567988, -10.256945678355093],
            [-0.22746715098159148, -10.257324229124986],
            [-0.22319910553095024, -10.265492737480338],
            [-0.21573746132930022, -10.275297560681741],
            [-0.21039352960267005, -10.278388653343471],
            [-0.21256626241615928, -10.283475243802439],
            [-0.21062575057629007, -10.290828090663531],
            [-0.22295395968490866, -10.298937262891307],
            [-0.22497256458642606, -10.302203732921745],
            [-0.23009907456894582, -10.301135600411097],
            [-0.24404850078658982, -10.290044591856283],
            [-0.24767495720398724, -10.285295477686699],
            [-0.25262035529134635, -10.283121250433666],
            [-0.25808113300786784, -10.277000565077335],
            [-0.26340101242653474, -10.274288469881911],
            [-0.26738947930813994, -10.275074887777958],
            [-0.27510351222841983, -10.270700269007172],
            [-0.28341093080101387, -10.274013169263942],
            [-0.2919862438693156, -10.283682041500018],
            [-0.294240720380043, -10.289612708276056],
            [-0.29271180163279975, -10.294242053128928],
            [-0.28262267567739086, -10.302743707852954],
            [-0.27527417955146827, -10.313066886557321],
            [-0.2648859560464026, -10.323723957155739],
            [-0.2559245717526893, -10.330058520969711],
            [-0.24757935100091635, -10.334951268228508],
            [-0.24131189647560863, -10.337671216800445],
            [-0.2372278849429726, -10.337905063242827],
            [-0.23466227946592952, -10.344908111630025],
            [-0.2377813085287845, -10.354117806806636],
            [-0.23615153661674532, -10.361734533498371],
            [-0.2336928376172313, -10.379087073531606],
            [-0.23410602989319373, -10.38247187229818],
            [-0.30183070778362653, -10.392608384320464],
            [-0.303311013171824, -10.392666691546017],
            [-0.34846886249812925, -10.399493414613872],
            [-0.4207670756857698, -10.409864428183877],
            [-0.4930692112363297, -10.420221412959819],
            [-0.5281893327890754, -10.425086036506226],
            [-0.5263188342243338, -10.427988118261021],
            [-0.5263282959616344, -10.43356520597711],
            [-0.5233950217791078, -10.437670896799844],
            [-0.5250993380968187, -10.441298183705204],
            [-0.529029587817728, -10.4413408269579],
            [-0.5304205973896587, -10.444236115488987],
            [-0.5244333488568398, -10.447660278618978],
            [-0.5235754634793187, -10.450841423859512],
            [-0.5195012103312792, -10.451134563137362],
            [-0.5189175441706327, -10.455250829736306],
            [-0.51607590755105, -10.45682490585295],
            [-0.5158116873903398, -10.460101942673791],
            [-0.5121149779002506, -10.461275788421036],
            [-0.5063963612633443, -10.465317877782844],
            [-0.5102574905581782, -10.470720497221045],
            [-0.5018208304771892, -10.473444892558401],
            [-0.4977719512238042, -10.476549537161059],
            [-0.48726040587485603, -10.477557441475945],
            [-0.48185886365318453, -10.48317043287465],
            [-0.477582632016685, -10.482798052586736],
            [-0.476555056437645, -10.489279840032463],
            [-0.4730730991318285, -10.491545444822581],
            [-0.4676520391214051, -10.492379182682283],
            [-0.4583454004955644, -10.488444040264424],
            [-0.4547818952777182, -10.49017353682395],
            [-0.4533222568121413, -10.496050620941942],
            [-0.44542105645484387, -10.49424402336336],
            [-0.4357338260275788, -10.49469943463042],
            [-0.4374433508364039, -10.495763727762345],
            [-0.44333726462454526, -10.503732903523227],
            [-0.44861355098581146, -10.508436865535076],
            [-0.46150107159584797, -10.511957529147583],
            [-0.4871495219244748, -10.5218406911188],
            [-0.504695726763447, -10.530371933912324],
            [-0.5208819594915166, -10.539223582151235],
            [-0.5340385520839027, -10.549340016923685],
            [-0.5499703947491492, -10.553980163482004],
            [-0.557066570148276, -10.558208665599086],
            [-0.5662233332601451, -10.567341746353566],
            [-0.5706608146591894, -10.564088723943785],
            [-0.5764868166947894, -10.5715046550977],
            [-0.5767691393129956, -10.574531040747543],
            [-0.5855220239687301, -10.580047585115206],
            [-0.6044483208449288, -10.595939050332088],
            [-0.6141674698813864, -10.607218306755511],
            [-0.6169911259141324, -10.613962079913135],
            [-0.6172519688785875, -10.618441361109205],
            [-0.6292585674600081, -10.630036587250508],
            [-0.634399540560228, -10.630872006069847],
            [-0.6432062630865006, -10.623925987367477],
            [-0.6492948014015024, -10.6200480882873],
            [-0.6524496542034693, -10.616707587568836],
            [-0.6544592690064002, -10.610928765593297],
            [-0.652324459865124, -10.606644996141979],
            [-0.6553332689585918, -10.603811562379772],
            [-0.6636434279867771, -10.602271114950602],
            [-0.6713739932262047, -10.602380553027327],
            [-0.6727473926353175, -10.601184682833287],
            [-0.6730572968650745, -10.592627223086824],
            [-0.6753840896516228, -10.58213866765308],
            [-0.6767636680657543, -10.579238526399998],
            [-0.6811715902552195, -10.577557962963551],
            [-0.6827427879477288, -10.579944461116295],
            [-0.682899760928573, -10.586604315169671],
            [-0.6901268360886724, -10.588534406143737],
            [-0.6956536580701879, -10.584701082308738],
            [-0.7008740395211358, -10.583149640990886],
            [-0.7026910809838693, -10.579639536334978],
            [-0.700345689936589, -10.576300707136784],
            [-0.6970136053547655, -10.577361141044115],
            [-0.6945272864083848, -10.572785427444092],
            [-0.700309894144415, -10.557233514446189],
            [-0.7020416151106177, -10.55555568674908],
            [-0.7100947108345231, -10.558674622195593],
            [-0.7081683782185011, -10.56109807203256],
            [-0.7045510228570973, -10.559328720806645],
            [-0.7019963598720362, -10.561066781286499],
            [-0.7034361032444384, -10.566842610900089],
            [-0.7089001693237115, -10.573077603774742],
            [-0.7095789846275276, -10.565725706405516],
            [-0.7195214219790376, -10.562887980854752],
            [-0.7246633239506828, -10.56240314531036],
            [-0.7253659642652238, -10.571758683622846],
            [-0.7276305912830745, -10.57354490725415],
            [-0.730907406658622, -10.569308100268453],
            [-0.7359332080286047, -10.569152507873195],
            [-0.7457843079588532, -10.563668159988012],
            [-0.7524425331139284, -10.557994711583271],
            [-0.7543689756790637, -10.553868896000326],
            [-0.7568871259429257, -10.554897291269464],
            [-0.7577295639997065, -10.561193508405154],
            [-0.7596950760541284, -10.566833526908551],
            [-0.7623185493057427, -10.568011094293652],
            [-0.7660335207932407, -10.562191688175794],
            [-0.7771583196740752, -10.56087071160781],
            [-0.7797760790262324, -10.56819221879059],
            [-0.7748310028828882, -10.571723124359826],
            [-0.7756894948315971, -10.578989395853325],
            [-0.7800896234621544, -10.581327208293478],
            [-0.7797832285993433, -10.572373479212391],
            [-0.7910276064327388, -10.569347889134217],
            [-0.7949372780280445, -10.573419860073242],
            [-0.7987012959952972, -10.574014077515434],
            [-0.7996580338985891, -10.563365616191303],
            [-0.8011256998055553, -10.560163881621833],
            [-0.7956182695079914, -10.556664232086698],
            [-0.7960817816054198, -10.54922680256964],
            [-0.7992580799215697, -10.552190647949496],
            [-0.8049168266923984, -10.553624958763002],
            [-0.8090919255077412, -10.552583866788758],
            [-0.8110291728243904, -10.559272048412128],
            [-0.8169160537706969, -10.557852277405368],
            [-0.8163548398893992, -10.554237556083248],
            [-0.811913368794136, -10.548912712570088],
            [-0.8123081864376489, -10.543541904337227],
            [-0.8107656867232356, -10.540696169756098],
            [-0.8146527521262785, -10.538923928100827],
            [-0.8168370689995914, -10.543447734756448],
            [-0.8204584688311269, -10.542568184165663],
            [-0.8218142890039616, -10.537598259487881],
            [-0.8259598538530035, -10.535805897920097],
            [-0.8270812918012779, -10.531658638428363],
            [-0.8306375291878896, -10.533999379091819],
            [-0.8380655283671038, -10.536433977278412],
            [-0.8400849146162541, -10.533173638146932],
            [-0.8410233201832897, -10.527060712701985],
            [-0.839134874267341, -10.514325066827256],
            [-0.8436362724498077, -10.514662155009365],
            [-0.8471416277924813, -10.52295221402983],
            [-0.8530364669658452, -10.52350560630186],
            [-0.8584201746053386, -10.525440741377503],
            [-0.8703530784972934, -10.531927434972244],
            [-0.8761562654243307, -10.537523494253765],
            [-0.8817493051165538, -10.539346906641121],
            [-0.8840803355736389, -10.537557724352617],
            [-0.8870883759580845, -10.53021888692494],
            [-0.8900519875499388, -10.528515502065531],
            [-0.8990982510189542, -10.526008515434391],
            [-0.8621480979702004, -10.472268641095],
            [-0.8566450047471381, -10.464758778215264],
            [-0.8420785441554525, -10.442958444359128],
            [-0.7792111698279794, -10.351859187510659],
            [-0.7495243071094178, -10.308551029614556]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.16563302798008, "lat": 28.3253351799271 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48391"],
        "coty_name": ["Refugio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Refugio County"],
        "coty_fp_code": "391",
        "coty_gnis_code": "01383981"
      },
      "bbox": [
        -0.8990982510189542, -10.630872006069847, -0.21039352960267005,
        -10.148525739459371
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.6079970174368015, -2.562003930216484],
            [-3.6078578795000893, -2.559693020137034],
            [-3.4965537783343135, -2.565425573835441],
            [-3.4179452370072445, -2.5697825768479876],
            [-3.239702032338243, -2.579528537798066],
            [-3.2342171504883175, -2.579486311573175],
            [-3.17674243429514, -2.5825819105096217],
            [-3.1715417286293324, -2.5828758866205437],
            [-3.1871606384375055, -2.8913999054714083],
            [-3.187013544383017, -2.892733740378491],
            [-3.1894489119197473, -2.9437021459263573],
            [-3.191107126894376, -2.9931540884993235],
            [-3.192559259832977, -3.0230501447460023],
            [-3.296765144103605, -3.017364774621739],
            [-3.3907729251987417, -3.0121308583256723],
            [-3.454741023779171, -3.00963894894874],
            [-3.462335036202228, -3.0098402155691106],
            [-3.5258079046792434, -3.0064495385328502],
            [-3.631700114446049, -3.0010193162052254],
            [-3.631474381927535, -2.9948103228946352],
            [-3.6207635994657106, -2.7954489464385928],
            [-3.6156745958563112, -2.7024084838390845],
            [-3.6105293275886616, -2.607034538753921],
            [-3.6079970174368015, -2.562003930216484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.8135709048135,
          "lat": 35.838427918635404
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48393"],
        "coty_name": ["Roberts"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roberts County"],
        "coty_fp_code": "393",
        "coty_gnis_code": "01383982"
      },
      "bbox": [
        -3.631700114446049, -3.0230501447460023, -3.1715417286293324,
        -2.559693020137034
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9463977372337474, -7.678338971917957],
            [0.9810039237245133, -7.650291492228101],
            [0.9974787644593874, -7.636674575076791],
            [1.0506818270792897, -7.593530328594465],
            [1.0913053371240957, -7.560387086358323],
            [1.1833565603093223, -7.48554938076158],
            [1.1855173611456218, -7.484253707154455],
            [1.2087752707232629, -7.464729720540087],
            [1.3070265164585892, -7.384001640676984],
            [1.3498118283338378, -7.347805952287993],
            [1.353708400021831, -7.34998364282558],
            [1.3504267209657663, -7.358800254439706],
            [1.3517638975670454, -7.364021201478747],
            [1.3494562503415688, -7.36858883085396],
            [1.3540286104831547, -7.373231784837848],
            [1.354721247461361, -7.376379885707134],
            [1.3474229660160204, -7.382096605990592],
            [1.3474137769067602, -7.3854324310029975],
            [1.3517033321015073, -7.386670935516687],
            [1.3532850694661367, -7.392182256449562],
            [1.3578649301781798, -7.394535076280786],
            [1.3658731715593326, -7.3914517020200545],
            [1.3778181108054948, -7.394560729687767],
            [1.381665659322972, -7.39679996053287],
            [1.391933448408227, -7.397237185037268],
            [1.3927560029612271, -7.4007285908640865],
            [1.3972488949425148, -7.402776536074942],
            [1.400762197321786, -7.406922746073578],
            [1.4013154870210889, -7.412824742602897],
            [1.4029186462294956, -7.414742212030018],
            [1.4000681827607282, -7.418125212957295],
            [1.3992896344467407, -7.422098428896701],
            [1.4023239411977326, -7.427283836262851],
            [1.4016545248236312, -7.4290840128738544],
            [1.4048470392228793, -7.434438546250508],
            [1.4052927471143493, -7.442091685025138],
            [1.4121354813792155, -7.438044501460777],
            [1.41441614524877, -7.446341928184751],
            [1.4172474820792742, -7.444035858066691],
            [1.4202606479907833, -7.450068297763665],
            [1.4151925936747058, -7.45530441247914],
            [1.4107349811957843, -7.457039059177302],
            [1.407082943364189, -7.465444459422263],
            [1.4027838129800423, -7.469284395473553],
            [1.4027916529460671, -7.475706606260132],
            [1.4085162233934945, -7.479606908980085],
            [1.4143357093474482, -7.478093539134638],
            [1.4159621963742006, -7.483136442163295],
            [1.4214082077800299, -7.484441935785161],
            [1.4341053194434112, -7.500303766586328],
            [1.431311959772476, -7.500939860657462],
            [1.4330275354990503, -7.508437442427529],
            [1.4327825267926964, -7.5131344551260435],
            [1.4299705618492582, -7.524304701098331],
            [1.433022746521178, -7.531909110293882],
            [1.435875397710373, -7.534251907245824],
            [1.4349928212639438, -7.537758241950854],
            [1.43757605677694, -7.542540418215276],
            [1.4405127694735222, -7.543130111055859],
            [1.4442165114265884, -7.554097995005737],
            [1.4411037718554278, -7.565990509547909],
            [1.4436546727717265, -7.56941855663053],
            [1.4446019300027981, -7.5776381644550685],
            [1.440014380013192, -7.578179452360216],
            [1.4392835555930878, -7.582480088359011],
            [1.4427669989476588, -7.584484428561519],
            [1.446568702488317, -7.583131876100288],
            [1.4506835608117308, -7.5858255208189505],
            [1.3697179578438197, -7.690773616473513],
            [1.3030629446036475, -7.755773977961334],
            [1.221592259520116, -7.836486323042089],
            [1.1700349951571651, -7.887876414977049],
            [1.1486976460757734, -7.908963552748191],
            [1.1422429583477907, -7.901256870797002],
            [1.1345954985772069, -7.899987698446975],
            [1.1291454026887133, -7.897449508851989],
            [1.1221791813437343, -7.892709046668933],
            [1.120143076606774, -7.888195858518251],
            [1.1175259972331224, -7.875572452612527],
            [1.1116070523934918, -7.867257010548017],
            [1.1146485798206383, -7.8632583052437885],
            [1.1219885109870817, -7.847155433953575],
            [1.1157291308716464, -7.840352167935565],
            [1.1085871372290004, -7.830365852308379],
            [1.10334275033612, -7.827718288841062],
            [1.0863281250754728, -7.830688732625893],
            [1.0796042691817884, -7.8332899142961026],
            [1.0718403537297823, -7.831806801366579],
            [1.0619336205750265, -7.832413136520687],
            [1.051637493361591, -7.836893882371693],
            [1.0504373671586444, -7.839409135538689],
            [1.053435917738501, -7.844004497093281],
            [1.053120574478462, -7.848857978360253],
            [1.0488511315298208, -7.8539283868850305],
            [1.0509569424404004, -7.861509215318127],
            [1.0481254006902792, -7.865141483704206],
            [1.0445690575543045, -7.866820736212103],
            [1.0423061847930175, -7.872704665560149],
            [1.039433027869333, -7.875055306754965],
            [1.0363653823395558, -7.873672126325471],
            [1.031268681909317, -7.8631179097458785],
            [1.026441763572579, -7.859143646599632],
            [1.0240399184043507, -7.85947796947977],
            [1.0192054635502865, -7.86910220753663],
            [1.020365188740514, -7.874287748015342],
            [1.018399775466274, -7.877778803353851],
            [1.0085132789467288, -7.88010881187363],
            [1.0018905934690394, -7.878715097359325],
            [0.9899398439941834, -7.881236150038719],
            [0.9871131369330308, -7.879021177204009],
            [0.9801942050603244, -7.877277936272975],
            [0.978192417619561, -7.8703915561145665],
            [0.979595297503604, -7.865964145629598],
            [0.984018839124851, -7.860927449570967],
            [0.9839184146980486, -7.857701421977434],
            [0.9783947340665733, -7.855295340280806],
            [0.97962258781687, -7.851911874238246],
            [0.9836496555078231, -7.855045662603616],
            [0.9888705011089156, -7.856400283406985],
            [0.9941424769512702, -7.854963649920613],
            [0.9932231199969521, -7.848032217001549],
            [0.9787689400580163, -7.843278917698972],
            [0.973058232273993, -7.8372312732889835],
            [0.971720963103934, -7.82951278986035],
            [0.9660149068554866, -7.828910042003715],
            [0.9640751909643424, -7.8258507759714],
            [0.9676646005616779, -7.821692533815668],
            [0.9650133712905392, -7.817413438806228],
            [0.968304826714589, -7.807817658795585],
            [0.9640646532846768, -7.801984992138111],
            [0.9556161089216142, -7.7983057972645415],
            [0.9474991007191703, -7.79829444073914],
            [0.9474019444939747, -7.794791239164798],
            [0.9463977372337474, -7.678338971917957]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.13556328529292,
          "lat": 31.088784083992753
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48455"],
        "coty_name": ["Trinity"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trinity County"],
        "coty_fp_code": "455",
        "coty_gnis_code": "01384013"
      },
      "bbox": [
        0.9463977372337474, -7.908963552748191, 1.4506835608117308,
        -7.347805952287993
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.980854188706116, -6.8325303102904735],
            [-5.861147957079556, -6.842091988708379],
            [-5.741439930867713, -6.8516318395205555],
            [-5.6186459024965, -6.860925082384686],
            [-5.566428015502106, -6.864771352757613],
            [-5.467491484040566, -6.872209245920958],
            [-5.297021194173225, -6.884603304390227],
            [-5.294573894186679, -6.884300658866224],
            [-5.267782140480462, -6.886271147016718],
            [-5.26909567574538, -6.8993374887342],
            [-5.269880420358459, -6.913336094209188],
            [-5.277614789757138, -7.021508327676307],
            [-5.28363662300971, -7.103874700094171],
            [-5.288771467725416, -7.174597060840826],
            [-5.293445298491992, -7.241946446317892],
            [-5.300558177044443, -7.242475932491545],
            [-5.306541570023381, -7.246093258346956],
            [-5.310878207873021, -7.249987691773245],
            [-5.319089071556262, -7.252372008825756],
            [-5.323868413858675, -7.252454453477548],
            [-5.335360399699521, -7.259873690880076],
            [-5.341813252950947, -7.262703350753333],
            [-5.344427712053277, -7.26516172687657],
            [-5.3471771591754935, -7.2600389514107375],
            [-5.3477485476208955, -7.2562283259487295],
            [-5.352306857042183, -7.251332297675753],
            [-5.354729256549595, -7.245541569451977],
            [-5.359318289727406, -7.244017504322237],
            [-5.362730934474486, -7.240125872928963],
            [-5.370208332264773, -7.237276262979075],
            [-5.371074634532262, -7.23460282603127],
            [-5.374750487336201, -7.233291990779009],
            [-5.3859656900432835, -7.2239563150472],
            [-5.385226456721928, -7.218020783434259],
            [-5.381887529804456, -7.217809581543365],
            [-5.383552211891158, -7.213070783571552],
            [-5.38640538150581, -7.210946843753522],
            [-5.400349163797348, -7.206094049700732],
            [-5.403695889880293, -7.203470570586399],
            [-5.4035884989415734, -7.199293132752524],
            [-5.407889219730252, -7.193639279238755],
            [-5.413239526510987, -7.190737725203437],
            [-5.421185772144059, -7.187811649771654],
            [-5.424121655507715, -7.189155664349786],
            [-5.42848163566687, -7.186094074548218],
            [-5.430482480371427, -7.175947288493717],
            [-5.43931037233028, -7.176267268317963],
            [-5.4404916735211435, -7.17257485102384],
            [-5.45052507347145, -7.17195129037041],
            [-5.451833992826233, -7.16965826643398],
            [-5.457629074270647, -7.172748164871164],
            [-5.464275268609996, -7.165762167655291],
            [-5.469462557542394, -7.167461681143034],
            [-5.477984204800214, -7.1663708424245085],
            [-5.483990798471891, -7.162525336338578],
            [-5.484894428165936, -7.158111282687279],
            [-5.489325302990865, -7.15623497700815],
            [-5.49464386768569, -7.150074051994881],
            [-5.493931190815344, -7.143963551709966],
            [-5.497949619575583, -7.145423480850321],
            [-5.5151720042636, -7.139675837643006],
            [-5.528620200290272, -7.133835212051042],
            [-5.531798117044054, -7.134236942336035],
            [-5.541742240297599, -7.142199463194185],
            [-5.543086059960948, -7.147419262750086],
            [-5.539022853761928, -7.1496420164218755],
            [-5.542865293529752, -7.152624776911567],
            [-5.555122188141044, -7.152728533120249],
            [-5.562186674455827, -7.1510205189912215],
            [-5.567654550498516, -7.152136882436664],
            [-5.570331890929034, -7.150445052601646],
            [-5.577046468934942, -7.1519366046733],
            [-5.590862190533954, -7.149068731323326],
            [-5.594436274217716, -7.14660811049229],
            [-5.596274466590591, -7.149995590032275],
            [-5.6065934985588886, -7.147676313698576],
            [-5.6197302155295334, -7.1397862973982305],
            [-5.631524394659181, -7.139214952622128],
            [-5.639085166675947, -7.140413264677522],
            [-5.646433669255029, -7.138013141620527],
            [-5.649540756927944, -7.138138982593457],
            [-5.654287654065094, -7.13335980973196],
            [-5.662970982979826, -7.12928830075134],
            [-5.663928632407503, -7.127392124900899],
            [-5.671752811033003, -7.124064569908979],
            [-5.6765154011934005, -7.123782604271925],
            [-5.679214902392397, -7.120760567169595],
            [-5.682992732531355, -7.120707510038391],
            [-5.685510189953849, -7.118017641452918],
            [-5.688952911433825, -7.1183992331311545],
            [-5.693704433463054, -7.113689734522028],
            [-5.694335434677216, -7.108538166520509],
            [-5.698515678441619, -7.10451681688094],
            [-5.701185360248589, -7.098704732113098],
            [-5.7022613708425105, -7.093494985754048],
            [-5.701199143101498, -7.088311633498905],
            [-5.697983294089776, -7.085925229386703],
            [-5.7029312247965676, -7.078325100698712],
            [-5.7074698050961326, -7.077946210645287],
            [-5.714540055773092, -7.083508926269653],
            [-5.7166660447997675, -7.089117813604461],
            [-5.719915014451636, -7.0888134683944415],
            [-5.724473734422832, -7.083354757036399],
            [-5.7301772756755085, -7.082116494603174],
            [-5.735291110913286, -7.083764336880462],
            [-5.738392364096621, -7.081964841031209],
            [-5.745368381788838, -7.0864860942165055],
            [-5.749617825026346, -7.084408523192001],
            [-5.759783588299127, -7.088442586513075],
            [-5.770450105326421, -7.084021338694394],
            [-5.771870266874051, -7.080441230218986],
            [-5.777127931303379, -7.076729945565559],
            [-5.786648035733054, -7.081970476238404],
            [-5.793617389335904, -7.083694664948331],
            [-5.7972615994318515, -7.079966551234779],
            [-5.804751972004067, -7.081187999919527],
            [-5.807839037986924, -7.079180000560013],
            [-5.807200266568655, -7.075276533316137],
            [-5.810830840274011, -7.073168406595292],
            [-5.812402482789132, -7.067958834647492],
            [-5.814618429097102, -7.0660057959028535],
            [-5.822810133953521, -7.064728154776133],
            [-5.830309387419611, -7.066124443340326],
            [-5.835692456824822, -7.06964786403289],
            [-5.842819052973708, -7.066645228750833],
            [-5.845739266151778, -7.063458401344275],
            [-5.8501112214932816, -7.06404971689593],
            [-5.853772257346306, -7.06199906216488],
            [-5.858600533887827, -7.0667204337928],
            [-5.866006660459451, -7.067667064493613],
            [-5.868051277476739, -7.06461962861629],
            [-5.8749477844323685, -7.060698606850424],
            [-5.877282997720852, -7.054561152200764],
            [-5.883557102361338, -7.051953986817057],
            [-5.883456578380947, -7.047156883018129],
            [-5.888981002758331, -7.044457907798164],
            [-5.891356417841462, -7.036306557463484],
            [-5.893834068341289, -7.03147201977697],
            [-5.891906748648966, -7.024901673954536],
            [-5.887762575466928, -7.0224837393004504],
            [-5.885821534444858, -7.014660754574092],
            [-5.891725968444968, -7.009035690053955],
            [-5.89154448588687, -7.004452000359714],
            [-5.89485899396562, -7.004238128230854],
            [-5.896761327719173, -6.997514726738274],
            [-5.8955649395349194, -6.992568611804984],
            [-5.899596467540003, -6.988956536295848],
            [-5.901705214940872, -6.98511233221766],
            [-5.901616023793125, -6.976865169571839],
            [-5.896783468767804, -6.973715691682078],
            [-5.894456612455934, -6.9701654360127785],
            [-5.897120736064445, -6.963430279410965],
            [-5.896714444626199, -6.959014367758041],
            [-5.89260225807621, -6.951720949919341],
            [-5.892568222991276, -6.943155491775884],
            [-5.895402681930005, -6.939159768212841],
            [-5.897920980174322, -6.928028780832322],
            [-5.903526140284155, -6.923456840525036],
            [-5.9056622513986285, -6.911303940206659],
            [-5.9026147496461165, -6.908458790537375],
            [-5.896894218445292, -6.900358762405566],
            [-5.897684563678728, -6.8964177498849075],
            [-5.895106033733806, -6.89012635121464],
            [-5.897850781621158, -6.888641677940776],
            [-5.8971933373280025, -6.884963256931121],
            [-5.900002483718451, -6.882987386507108],
            [-5.898440400130873, -6.869877332682142],
            [-5.900112434377971, -6.864851366366798],
            [-5.908830433024925, -6.8576994092461225],
            [-5.913875513297151, -6.857184882153612],
            [-5.914467128757114, -6.8535856778607505],
            [-5.9127209080127034, -6.850477764926655],
            [-5.915324469105705, -6.847280961217938],
            [-5.919566957210765, -6.848041532716938],
            [-5.928097152792985, -6.844212354530739],
            [-5.934008388814925, -6.848462071504754],
            [-5.937673707715131, -6.8469648736089965],
            [-5.939110966217526, -6.851583102099361],
            [-5.945895874422002, -6.854348499970154],
            [-5.950424274564278, -6.854464715918736],
            [-5.956405967547102, -6.8515117665949115],
            [-5.957000664508644, -6.849612173574483],
            [-5.962191478592939, -6.847817723502008],
            [-5.9654502365279205, -6.844161993872205],
            [-5.967808782751245, -6.83898621783762],
            [-5.971428673835223, -6.838538272144774],
            [-5.976036122839315, -6.834270470129259],
            [-5.980854188706116, -6.8325303102904735]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.10247718781002,
          "lat": 31.509498115261753
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48475"],
        "coty_name": ["Ward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ward County"],
        "coty_fp_code": "475",
        "coty_gnis_code": "01384023"
      },
      "bbox": [
        -5.980854188706116, -7.26516172687657, -5.267782140480462,
        -6.8325303102904735
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.09525610015669472, -9.470326216067331],
            [-0.08205182726900227, -9.462381167006598],
            [-0.06366508691857437, -9.452765679036137],
            [0.027399868652131724, -9.396185604011192],
            [0.13622709023669793, -9.32808870799267],
            [0.1599746172595721, -9.314838431626475],
            [0.16109256265723065, -9.310129350160949],
            [0.1910475993897904, -9.222724317146053],
            [0.19600346597968485, -9.208643325318446],
            [0.259152543298566, -9.144442972483802],
            [0.285151386894121, -9.117728484151824],
            [0.28563465431166024, -9.116944371153895],
            [0.3113076138295826, -9.091147847677949],
            [0.3157710248432773, -9.095667764526796],
            [0.32004088152555393, -9.098357805794176],
            [0.3261481322203496, -9.095421760099013],
            [0.32884848149242935, -9.09571456934358],
            [0.33481172559351313, -9.09944463293441],
            [0.3404700275506316, -9.105191552930359],
            [0.3456589673438669, -9.104896813760515],
            [0.3500327725008769, -9.102028756481914],
            [0.35757471000131463, -9.106546370091658],
            [0.36024321632016393, -9.105598601348547],
            [0.3627121130834628, -9.101566994772586],
            [0.368446953739663, -9.102375717284488],
            [0.37125384592293814, -9.106378907538655],
            [0.3781760446977433, -9.11159608151298],
            [0.3810949353922967, -9.112222208263217],
            [0.38232944709316086, -9.12064274574519],
            [0.3864501179175063, -9.123002025978737],
            [0.390380491078968, -9.123602056391716],
            [0.39782340422595097, -9.127868575994327],
            [0.4017070012557295, -9.132094253122068],
            [0.40543477077437085, -9.133513041149433],
            [0.4095577783123402, -9.133027976766728],
            [0.4119554173003745, -9.135997963085153],
            [0.4091692211382681, -9.1407351828982],
            [0.4088684135176131, -9.148447083219514],
            [0.4115638104969595, -9.155606667928742],
            [0.41727014383020294, -9.159013601338218],
            [0.42504258932812733, -9.162242352440687],
            [0.4246788809161953, -9.16623608128969],
            [0.42731655524321116, -9.170731666473776],
            [0.4277824982941575, -9.177260013986267],
            [0.42198144869421456, -9.18561761647718],
            [0.41474242437126735, -9.18440824634073],
            [0.41627105062527975, -9.188653337815522],
            [0.4153945943784203, -9.198110416008875],
            [0.41952706287835906, -9.20053230536852],
            [0.4151935381725537, -9.20553783488526],
            [0.41755695572667917, -9.211606165868371],
            [0.42276069257205, -9.213817070021326],
            [0.42895077748148275, -9.21388600562552],
            [0.4321450596980003, -9.212726416040587],
            [0.43720107353827836, -9.215686559569923],
            [0.44257654950515973, -9.21647086595415],
            [0.4408848881531106, -9.228313359251445],
            [0.43663662726169444, -9.227708019817433],
            [0.4328230162352804, -9.231014274420204],
            [0.4226505801505971, -9.23202753301281],
            [0.41756188455867266, -9.229050946709105],
            [0.41186574135501824, -9.233381671718107],
            [0.4115391697294961, -9.239060705884873],
            [0.41348919178810856, -9.241807691496154],
            [0.4109153439917571, -9.24661164978468],
            [0.41478961307013074, -9.250829239165046],
            [0.42021460883096207, -9.25085493053103],
            [0.42196287574045765, -9.261059457136403],
            [0.4257635711697972, -9.261403712294493],
            [0.42573931120450964, -9.264886370415162],
            [0.4308193730053618, -9.265317803365242],
            [0.42988178578597724, -9.268875029624793],
            [0.43807320100799674, -9.27072529713724],
            [0.43797834770390975, -9.273263386538215],
            [0.4318728406976381, -9.277001302566442],
            [0.43300317878631867, -9.279649295125763],
            [0.4380497516637919, -9.281599889637347],
            [0.4442625294893727, -9.281158498413955],
            [0.4474973811461412, -9.2852177736097],
            [0.4528991018108255, -9.287570080806105],
            [0.45645333028771984, -9.293003425073652],
            [0.46038805339155553, -9.293609520192417],
            [0.462665147698654, -9.291463457403777],
            [0.47068757465321165, -9.288747680703537],
            [0.4741759844451112, -9.294357855411551],
            [0.4757369352367498, -9.299732203805965],
            [0.4740003117807775, -9.30362092821208],
            [0.4778578121973939, -9.307383480212335],
            [0.4793702134434596, -9.311465919532324],
            [0.48689016608999025, -9.310794260686217],
            [0.4892165595365292, -9.313769242886135],
            [0.48769816846722, -9.317826612430585],
            [0.4901518060135021, -9.322851528133592],
            [0.490298771058217, -9.329960574910778],
            [0.4924565365670055, -9.334784942074485],
            [0.4921637236528127, -9.339871418033358],
            [0.5032856549779983, -9.34239131129149],
            [0.5095091533916002, -9.348797145438208],
            [0.5126847012254251, -9.360397497077054],
            [0.5158957003247826, -9.36055239853406],
            [0.5171288242644175, -9.363793823556495],
            [0.5164817129847209, -9.368895631026854],
            [0.5121662753403335, -9.369744504750665],
            [0.5043920203089964, -9.376255349768273],
            [0.5077103367684562, -9.380263927790953],
            [0.5067830576830886, -9.38463948954338],
            [0.5123058523792272, -9.388950314641408],
            [0.5157571331364528, -9.389418681835572],
            [0.5234019071295377, -9.392616855429916],
            [0.5311014737620663, -9.391722452908141],
            [0.5340449984599215, -9.394784203210472],
            [0.5364809553785366, -9.401590766127498],
            [0.5524843268201188, -9.406492370361837],
            [0.5557958156361985, -9.405899092533383],
            [0.55729637280238, -9.409884390754092],
            [0.5543341278313381, -9.414038202705667],
            [0.553132147655683, -9.421380912098503],
            [0.5589143273478502, -9.428419897818305],
            [0.5599414394228563, -9.4329820349348],
            [0.5643851335194565, -9.441157580566117],
            [0.5641537170631722, -9.446007771198925],
            [0.5683088585062115, -9.449478123966719],
            [0.5688262469385756, -9.453429026116394],
            [0.5751881764384442, -9.453442525615127],
            [0.5780013978267907, -9.451052845764943],
            [0.5814794923910925, -9.452905507040855],
            [0.5886074980558417, -9.452209032284772],
            [0.593852978732925, -9.453835714271257],
            [0.5967139134445751, -9.457501721542494],
            [0.6017026051300111, -9.461321836949814],
            [0.5737386257866532, -9.489955915142966],
            [0.5399389770144305, -9.52482930017971],
            [0.4941611841995465, -9.571658606969784],
            [0.4775617401575139, -9.582105805639506],
            [0.42994700941635616, -9.611373305005968],
            [0.35950915916922155, -9.653311171845623],
            [0.25357643132955165, -9.716386981218017],
            [0.23796174896235064, -9.72583935936538],
            [0.23090849425524654, -9.729609469306148],
            [0.1929008407311238, -9.752017505102607],
            [0.17340178556401, -9.732730278488463],
            [0.0875861915611593, -9.649151802566779],
            [0.043251687473482354, -9.605687885905805],
            [-0.001073762416195606, -9.56220948249976],
            [-0.07187671878020024, -9.492383279269523],
            [-0.08219370413052804, -9.48365327399691],
            [-0.09525610015669472, -9.470326216067331]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.2221165179882, "lat": 29.27783612558556 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48481"],
        "coty_name": ["Wharton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wharton County"],
        "coty_fp_code": "481",
        "coty_gnis_code": "01384026"
      },
      "bbox": [
        -0.09525610015669472, -9.752017505102607, 0.6017026051300111,
        -9.091147847677949
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.68712839866775, 3.127167056713237],
            [-11.591146633729045, 3.189386043960718],
            [-11.473570716775708, 3.246671672433704],
            [-11.438193388353497, 3.2406509816899347],
            [-11.44179108796362, 3.219146503206228],
            [-11.445260415789543, 3.2127824192516337],
            [-11.448802335570571, 3.2116388437334416],
            [-11.45151517985307, 3.2072484307412736],
            [-11.451798714040647, 3.2003060852236938],
            [-11.454971325074279, 3.1973568449201983],
            [-11.450046100391965, 3.1897407018170054],
            [-11.454845072633809, 3.1748480873505915],
            [-11.447179286759141, 3.166416908535948],
            [-11.446161173661388, 3.160445806261895],
            [-11.443496097923337, 3.1559057886696618],
            [-11.441897873445637, 3.1480115830200672],
            [-11.44583832075715, 3.1418872471804344],
            [-11.445575357946298, 3.139744990816764],
            [-11.38982577225023, 3.130288654987811],
            [-11.38854305771483, 3.1322121719894382],
            [-11.38051826601045, 3.1312655463445873],
            [-11.376173811923858, 3.1356316487211457],
            [-11.37061120842857, 3.1350857560203935],
            [-11.368774957858921, 3.1371646211164177],
            [-11.36455778485314, 3.135254342868395],
            [-11.358459781056219, 3.1353138358038932],
            [-11.351658547828544, 3.136732345535104],
            [-11.347412420168679, 3.1402483529965166],
            [-11.343492542496708, 3.1411348654853786],
            [-11.338577493954883, 3.138163694165279],
            [-11.328531911892737, 3.1431818592051086],
            [-11.32570956756317, 3.143841592425005],
            [-11.320450486555385, 3.1412746358166537],
            [-11.317555436268446, 3.141629497573785],
            [-11.312462434422363, 3.1449677202020716],
            [-11.309716625911525, 3.144103260110098],
            [-11.298971387090319, 3.1479380519406175],
            [-11.29687864803759, 3.146898346284742],
            [-11.291919648410829, 3.1531380764812194],
            [-11.2858899914673, 3.153133127272724],
            [-11.282041888464583, 3.1506790134634994],
            [-11.276393854457917, 3.1449277169011465],
            [-11.27342192134735, 3.1455297367242854],
            [-11.267825427474616, 3.140428951795093],
            [-11.263907180555476, 3.1406736583117145],
            [-11.26084172401781, 3.1434983310985514],
            [-11.258053757899887, 3.148555892158266],
            [-11.25397993282075, 3.1484382787182676],
            [-11.250748650951916, 3.144880043092322],
            [-11.245575675541238, 3.1414462214312353],
            [-11.238932309208012, 3.139295595848174],
            [-11.232287831833363, 3.133001066023664],
            [-11.230534623842045, 3.1274885982064085],
            [-11.233824246375717, 3.123758710058587],
            [-11.236858114727173, 3.115297762286035],
            [-11.236019478986929, 3.112903466665474],
            [-11.230172186104651, 3.1125420405306206],
            [-11.227529518822152, 3.1088888901623366],
            [-11.227556663260351, 3.1055175538759077],
            [-11.223032032152018, 3.1047883190902543],
            [-11.223572640316105, 3.1012826912456006],
            [-11.221456566627594, 3.09880332617845],
            [-11.220584453500683, 3.0892998301548604],
            [-11.223711724297328, 3.086200578900364],
            [-11.223781469789051, 3.0792530512968734],
            [-11.228027666109368, 3.078574061060209],
            [-11.230580642711935, 3.073561479874835],
            [-11.227399443548153, 3.0666002121308256],
            [-11.23051160752432, 3.0631952158160165],
            [-11.230242862239024, 3.0600205800012095],
            [-11.233974592558555, 3.0549297637493438],
            [-11.228649792342036, 3.051829081427117],
            [-11.22612825025917, 3.0482655706940873],
            [-11.226870733848566, 3.044005923970128],
            [-11.222156697683753, 3.0400638099552424],
            [-11.218438645881026, 3.039669289528911],
            [-11.215897685942341, 3.0363909106341676],
            [-11.218266052677716, 3.032193232262102],
            [-11.214966843326538, 3.0241891066570026],
            [-11.221389657858515, 3.0187159129624312],
            [-11.219517210280303, 3.01606985642163],
            [-11.22150721748405, 3.0085821348388087],
            [-11.214969005216213, 3.005323835346323],
            [-11.216799810284552, 3.0020995757428466],
            [-11.217342342107788, 2.9969825517021746],
            [-11.212690241641011, 2.9910628625734708],
            [-11.204748999723105, 2.9779450903723665],
            [-11.204435770956625, 2.9741586589074953],
            [-11.210378056224606, 2.967928137074776],
            [-11.213553820188547, 2.9609604082014065],
            [-11.216045258966316, 2.9485037695989473],
            [-11.218558412709887, 2.9432651059632753],
            [-11.215784847293559, 2.940344557113611],
            [-11.213893860456926, 2.935543345852809],
            [-11.213105062483162, 2.9271312698016954],
            [-11.208856611506482, 2.924418530955613],
            [-11.203476889317653, 2.9190513701943237],
            [-11.202337868138265, 2.916080918796657],
            [-11.203320381676782, 2.907204952584712],
            [-11.198285956178111, 2.9019607184034757],
            [-11.198142071577932, 2.895687145458487],
            [-11.19144579142618, 2.8908216874113752],
            [-11.193401972805983, 2.8856348228588447],
            [-11.189929205423235, 2.880070094715413],
            [-11.195661446798109, 2.873057429153224],
            [-11.198138125647372, 2.8655332515979897],
            [-11.197990307537568, 2.8624966373762217],
            [-11.201818911008168, 2.8572590856148086],
            [-11.20867200920109, 2.8554403485944393],
            [-11.211215214292961, 2.857032600547877],
            [-11.222321787174897, 2.855781927784133],
            [-11.22539971289208, 2.8529965222032407],
            [-11.228380453733037, 2.8543523625450624],
            [-11.23189598285204, 2.852299244345421],
            [-11.23240586522068, 2.8472183863157747],
            [-11.23624289291675, 2.841913913536392],
            [-11.239746582232286, 2.843953132997905],
            [-11.24695190251174, 2.8444324091777307],
            [-11.259778160142103, 2.8491930136338324],
            [-11.263342926621302, 2.844332676650407],
            [-11.266617025426271, 2.8423379271000044],
            [-11.267939574002401, 2.83860494549792],
            [-11.271599656183321, 2.8342007589484934],
            [-11.275932289127844, 2.8356042521021743],
            [-11.280381532434449, 2.8341788941354533],
            [-11.283492178130723, 2.826018221020111],
            [-11.291182513220175, 2.823008400731202],
            [-11.293123980345792, 2.8194335262409775],
            [-11.30038864928621, 2.8187049841234693],
            [-11.309679432557827, 2.824764706908389],
            [-11.311954942495623, 2.823244742918408],
            [-11.321350968144396, 2.823610752556287],
            [-11.32458540076813, 2.8189873554013936],
            [-11.32812303593387, 2.8170315838599373],
            [-11.332073942130359, 2.8218948520768947],
            [-11.338681027648052, 2.8257082382890935],
            [-11.342646663552207, 2.818261470930174],
            [-11.346138936072522, 2.817384787756809],
            [-11.358682640179394, 2.8262441738808586],
            [-11.36501046125679, 2.820613163836831],
            [-11.374184817074505, 2.8181477031708493],
            [-11.377019349042758, 2.814529673987117],
            [-11.380133075376566, 2.8139936544221307],
            [-11.38429404793424, 2.8060465693217354],
            [-11.38376011678249, 2.7986606109228367],
            [-11.394408729622512, 2.795923903704439],
            [-11.398530911492584, 2.7922595380856743],
            [-11.405284636162442, 2.793170538789965],
            [-11.410073570364426, 2.791292118328401],
            [-11.413811137846322, 2.788021598196387],
            [-11.419009297001766, 2.7888985162352307],
            [-11.422472526463913, 2.781639301745416],
            [-11.427414771436942, 2.7820415647882792],
            [-11.429306487913534, 2.7844337020742174],
            [-11.43385217532089, 2.780478278659018],
            [-11.443258492453266, 2.779215772145225],
            [-11.44689991308814, 2.783274193155963],
            [-11.44772441024396, 2.7876147036190595],
            [-11.450062998725922, 2.7880891738342775],
            [-11.457371061251013, 2.7849108977283703],
            [-11.466053336692449, 2.777769099514544],
            [-11.47261904471289, 2.778084355200135],
            [-11.479248660952353, 2.7690829807196615],
            [-11.484832924941262, 2.768599990476826],
            [-11.489452829027918, 2.760365525914779],
            [-11.50001570063091, 2.7523595784333037],
            [-11.511753335378678, 2.7461559223175454],
            [-11.52407144726849, 2.740875821963552],
            [-11.528612183545386, 2.74317386173405],
            [-11.534396865906086, 2.74146386029165],
            [-11.54243969135201, 2.742787509433181],
            [-11.547853761284173, 2.7469204631182556],
            [-11.54732551354321, 2.7505666666973188],
            [-11.55227028107281, 2.7515193095157127],
            [-11.557014843864307, 2.754677806486586],
            [-11.558151571587826, 2.759995827115585],
            [-11.555885057002083, 2.763464292013304],
            [-11.5602827295131, 2.7656923362269255],
            [-11.56305251762803, 2.7644467972799],
            [-11.56622438558919, 2.768878175815525],
            [-11.567534318732498, 2.775539297105421],
            [-11.564200975600789, 2.7773092231298424],
            [-11.566717724329978, 2.780824896624401],
            [-11.571787689952924, 2.7818935435872234],
            [-11.57041777860368, 2.7850233536648634],
            [-11.57149440677986, 2.788985283470586],
            [-11.571018142455149, 2.794138553780757],
            [-11.574365892957605, 2.796664466104112],
            [-11.582348243527022, 2.789860361159183],
            [-11.592106320341037, 2.7877986720591683],
            [-11.598736835554849, 2.782178183358447],
            [-11.607619559820481, 2.783923032598722],
            [-11.609305955488907, 2.7858800548491347],
            [-11.618391922264, 2.7870037122516838],
            [-11.62444493166754, 2.785701738011255],
            [-11.63354638298034, 2.780516304210116],
            [-11.635025295168955, 2.783159286351053],
            [-11.633225927650034, 2.78916118772193],
            [-11.633689414931837, 2.7925475149812664],
            [-11.637922239217895, 2.796890318482855],
            [-11.639392410936305, 2.801557073061211],
            [-11.644016174429296, 2.8083655158278558],
            [-11.65182174891404, 2.8157448820875097],
            [-11.659567857316155, 2.8150327158327757],
            [-11.665661607044369, 2.808622638839165],
            [-11.669349213858606, 2.8105013324305825],
            [-11.674073775263713, 2.8161998111308795],
            [-11.672408003755995, 2.8201229532176977],
            [-11.675433870744657, 2.8317694427369515],
            [-11.674031109611546, 2.834919711757528],
            [-11.675903804035164, 2.8418311283203717],
            [-11.673164156051884, 2.85198463266316],
            [-11.675735173564314, 2.858659084408426],
            [-11.676941871559652, 2.864775226641989],
            [-11.67458217616724, 2.868131968374796],
            [-11.669067338051526, 2.8715184612696465],
            [-11.66774995068853, 2.8811008812087393],
            [-11.669193583662777, 2.888449283501996],
            [-11.66593948349993, 2.8953549358255177],
            [-11.662855935634802, 2.9056150798989298],
            [-11.66527971890687, 2.911934447663375],
            [-11.66315556540957, 2.9204515785526786],
            [-11.66394981271904, 2.922792814918571],
            [-11.66081172581423, 2.9266596024689155],
            [-11.661103033490548, 2.929813950614737],
            [-11.6553979204619, 2.9339638236831607],
            [-11.655278774947925, 2.945247237656521],
            [-11.652521233763029, 2.952461353435799],
            [-11.655868136300743, 2.961288428934895],
            [-11.66050453773476, 2.964257644297984],
            [-11.665415951725155, 2.976632008139646],
            [-11.661067568585942, 2.986254028459071],
            [-11.662514586785717, 2.9950054372028747],
            [-11.661719389345024, 2.9988712402047444],
            [-11.664147100217173, 3.003677315341655],
            [-11.663780032361169, 3.0099152819241235],
            [-11.661597478383664, 3.0145635194619618],
            [-11.660412000318066, 3.0225034142495146],
            [-11.661275963021424, 3.030278367823943],
            [-11.660327664631046, 3.0349689380818843],
            [-11.657817693128292, 3.037549340394722],
            [-11.654545186723803, 3.0439886178527535],
            [-11.653907312265089, 3.048296035394618],
            [-11.655276625807547, 3.060408849276747],
            [-11.657383468112716, 3.067499736181017],
            [-11.663568717809023, 3.070796625985124],
            [-11.670386749421393, 3.0795327321366974],
            [-11.68712839866775, 3.127167056713237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.92357028107554,
          "lat": 40.66731323007498
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49035"],
        "coty_name": ["Salt Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Salt Lake County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01448031"
      },
      "bbox": [
        -11.68712839866775, 2.740875821963552, -11.189929205423235,
        3.246671672433704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.942435853658115, 7.302733076970489],
            [16.945577084121567, 7.302076108481615],
            [16.9439350770168, 7.294610999117275],
            [16.948927975020318, 7.294022816205474],
            [16.947298667933744, 7.286564621577105],
            [16.961958145128346, 7.283775059786969],
            [16.96044110543513, 7.277851230182945],
            [16.96528340371713, 7.276951503719785],
            [16.963799563930056, 7.269323885481258],
            [17.010451510532732, 7.263867851540596],
            [17.011726145840495, 7.267550769683992],
            [17.070102330674136, 7.260213505543018],
            [17.092021593609164, 7.257730167345317],
            [17.11845395615918, 7.253764974696661],
            [17.20357978106393, 7.24028913438353],
            [17.20309910650832, 7.238755965340706],
            [17.28911426331441, 7.234579828410069],
            [17.29410946105752, 7.234666767264363],
            [17.35862472010947, 7.225729656147785],
            [17.397321500153428, 7.220480817599085],
            [17.394252943556825, 7.216038037682491],
            [17.390593731934217, 7.213887496206463],
            [17.38878414769414, 7.210466374790795],
            [17.385138134617424, 7.194865109905401],
            [17.383373706934908, 7.1909352759360115],
            [17.376496269353364, 7.186239871749619],
            [17.365256027997308, 7.17393643209772],
            [17.360281138103414, 7.172175902688783],
            [17.359301753600032, 7.165887274020519],
            [17.35443216541009, 7.157281190833127],
            [17.35150235006145, 7.147258398493017],
            [17.347629483062832, 7.141080661973957],
            [17.347810950283915, 7.136136250050148],
            [17.34645947506667, 7.129519071174957],
            [17.348878431896544, 7.117522800395696],
            [17.35215647630822, 7.113226608762503],
            [17.353147183935054, 7.101606001218947],
            [17.34996001887239, 7.090128792320916],
            [17.352817567932508, 7.07542939958387],
            [17.345421926589577, 7.069046960822617],
            [17.34436654385945, 7.066593973672652],
            [17.34707793153998, 7.063047032151673],
            [17.34485194074621, 7.056865284212689],
            [17.345797724669016, 7.046251634122153],
            [17.348267464986495, 7.042548655754405],
            [17.35224895118968, 7.03998018135564],
            [17.352886970422443, 7.033295274858875],
            [17.35120007815628, 7.032026383443656],
            [17.34182051070773, 7.017688574531849],
            [17.333050417359505, 7.011286749283143],
            [17.327426066504987, 7.005770338722268],
            [17.32418412434065, 6.998737620809889],
            [17.326119366762068, 6.991997722235897],
            [17.32479741450952, 6.989122920968054],
            [17.328078874132043, 6.980473045862809],
            [17.332108970659988, 6.967049689192419],
            [17.331467595931993, 6.96103436549786],
            [17.329130017966154, 6.953322294795722],
            [17.325761460909284, 6.951583257029504],
            [17.326169993430472, 6.937318595324057],
            [17.329076782712807, 6.9325222128195385],
            [17.33907425993641, 6.927010978578661],
            [17.343485278515157, 6.921058286790145],
            [17.345014632985983, 6.9164334425374365],
            [17.34619229344054, 6.908051469873552],
            [17.345711388477017, 6.901863174395987],
            [17.34212373309741, 6.8953874095991035],
            [17.342266551385045, 6.891613825965645],
            [17.34713173365361, 6.878582956509833],
            [17.346353101371996, 6.871636851625803],
            [17.346698273728983, 6.865420235390689],
            [17.348387171550304, 6.85805770523329],
            [17.34942892768224, 6.842135581103741],
            [17.350367543611654, 6.837995495399716],
            [17.352495435326283, 6.8189107711039805],
            [17.3478301865945, 6.809879868270705],
            [17.34776826133663, 6.801865239193582],
            [17.351009465863367, 6.791733213457907],
            [17.352995808183614, 6.7889851898217035],
            [17.360754025784125, 6.786157980316574],
            [17.369072329981936, 6.788012531231331],
            [17.370660767141754, 6.785446610499436],
            [17.365878948679317, 6.774761734158666],
            [17.36278595120174, 6.759466771369596],
            [17.364936357900916, 6.755888697599671],
            [17.371062621604587, 6.749920944468297],
            [17.37532919582402, 6.747580949876865],
            [17.37784829019207, 6.744024642504559],
            [17.3758652715431, 6.733641493610251],
            [17.37659316582784, 6.712712462333177],
            [17.374094817693102, 6.700222879289853],
            [17.371745586596397, 6.691463548260122],
            [17.363390291197373, 6.684255491829777],
            [17.362327227479234, 6.678244077402635],
            [17.36429285486397, 6.669814906191777],
            [17.370675289060266, 6.659884236970794],
            [17.370035011289072, 6.6599476964071025],
            [17.32467615866558, 6.650216506360025],
            [17.28890401871245, 6.642317628164049],
            [17.202442320398923, 6.608584823659793],
            [17.1963417827879, 6.6055203171470165],
            [17.141970134134553, 6.609628359985612],
            [17.093852319427874, 6.614508393795146],
            [17.083133016942238, 6.656473816670291],
            [17.04859278821477, 6.649136103729973],
            [17.039507561488808, 6.696438558674445],
            [17.046581146644154, 6.6987780533047285],
            [17.041664004139342, 6.725333197007928],
            [17.063142396739305, 6.730051873466521],
            [17.061987607257123, 6.7348067073312246],
            [17.11315536353606, 6.719385973767921],
            [17.10603660701521, 6.736246987479881],
            [17.111738980298465, 6.78458284363751],
            [17.112362002536265, 6.828998485400317],
            [17.10875484889424, 6.829117338515623],
            [17.109225856096693, 6.836547308492258],
            [17.073599713792802, 6.838642094572884],
            [17.072072650185742, 6.851332016354125],
            [17.05676887908673, 6.850664213082112],
            [17.04756148919037, 6.936031601953643],
            [17.04621321891884, 6.947282823200696],
            [17.05658579090685, 6.946083898942976],
            [17.065257680234797, 6.992858550137478],
            [17.073584824729767, 7.050130787484754],
            [16.981826558807544, 7.060403677874249],
            [16.98714995367114, 7.086649856490589],
            [16.975149580015614, 7.089169139918937],
            [16.986456126255465, 7.151270088851795],
            [16.98289410805652, 7.1520679281549056],
            [16.981869285047118, 7.155154409890026],
            [16.98308859243523, 7.16045900070576],
            [16.977060579948386, 7.161708751494206],
            [16.974656284072516, 7.165028001186381],
            [16.976157536819034, 7.16774086779836],
            [16.970636766830943, 7.173114925823537],
            [16.944696691633176, 7.176935044762583],
            [16.941735181078045, 7.166077030603421],
            [16.91444977130096, 7.169999506853622],
            [16.909554305700837, 7.187711147407621],
            [16.87678174962586, 7.15901208138706],
            [16.85783379713741, 7.14217415640871],
            [16.838859645883556, 7.179274495376102],
            [16.834419950300227, 7.175311146841014],
            [16.829910980094493, 7.1936565348431705],
            [16.850646553814876, 7.1904664693953775],
            [16.881432029893848, 7.216464025720735],
            [16.897308253151262, 7.2305713893916215],
            [16.908327511890185, 7.193566683039043],
            [16.915107572997673, 7.192769647788145],
            [16.930764002077826, 7.274774232485357],
            [16.9355894485848, 7.274204933831414],
            [16.937786089587206, 7.284570207444768],
            [16.942435853658115, 7.302733076970489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.58619024497767, "lat": 43.57986525122535 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50027"],
        "coty_name": ["Windsor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Windsor County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01461770"
      },
      "bbox": [
        16.829910980094493, 6.6055203171470165, 17.397321500153428,
        7.302733076970489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.637052683605752, -0.5983003256182637],
            [14.636501194580704, -0.5924101526956076],
            [14.6299316788516, -0.5361946733909616],
            [14.621781996335681, -0.46447686042956593],
            [14.609035036550933, -0.3519161035195586],
            [14.61096764177131, -0.3497167873542504],
            [14.614927032808415, -0.3510262539790869],
            [14.615267755584268, -0.3577883451646049],
            [14.620531954415709, -0.35976449731600685],
            [14.62165062098123, -0.36223838670632624],
            [14.630646038565272, -0.3681740407087168],
            [14.63155067652191, -0.37084005071560155],
            [14.637187517138457, -0.3767883494446278],
            [14.643375370450306, -0.3817885327512529],
            [14.646288881407376, -0.37865045814876946],
            [14.652739812594085, -0.37588019266764244],
            [14.661189898881279, -0.37895867317138654],
            [14.668026117596177, -0.37616023269097953],
            [14.671430823307364, -0.37952745325138404],
            [14.677779428731112, -0.37849377451265587],
            [14.68120180573507, -0.3792003474906812],
            [14.682740957670598, -0.375139655425877],
            [14.689375474019284, -0.3749927468062322],
            [14.69309587137647, -0.3730769065957793],
            [14.694867285841271, -0.36986562597878614],
            [14.703911316647652, -0.36856905968174025],
            [14.706535874024702, -0.36865507515887563],
            [14.70898287151665, -0.364655905713987],
            [14.71477342741866, -0.3651414577806072],
            [14.717519965558072, -0.3629381391248961],
            [14.721989939291745, -0.36405652733373756],
            [14.724646985050914, -0.36110716009366883],
            [14.729893894370958, -0.36193822252490737],
            [14.733988989003407, -0.3609986360644673],
            [14.739501729163665, -0.35435378006613855],
            [14.742827528484115, -0.35432032412434716],
            [14.747836781314406, -0.35751513653603345],
            [14.75824417548528, -0.3571295123043842],
            [14.766861063596329, -0.36199409229782625],
            [14.778549378348133, -0.3586228774857496],
            [14.785497979065005, -0.36186422512251726],
            [14.789523745393458, -0.3616487704029423],
            [14.79154829082591, -0.3649749497800778],
            [14.795484708060027, -0.3653648632986359],
            [14.797994324677767, -0.36325461106421536],
            [14.803157130174815, -0.36392436341724893],
            [14.807201788137045, -0.3692595022946054],
            [14.808608821883203, -0.3762815989084245],
            [14.81471931380982, -0.38076770300567936],
            [14.821666811052673, -0.37648053553470007],
            [14.82854402924154, -0.38379949378537437],
            [14.830053221769344, -0.3880008220883181],
            [14.838499602110964, -0.38922389671829205],
            [14.8439638190005, -0.3988443082433522],
            [14.851035757340975, -0.40339503946877775],
            [14.852788386186266, -0.40825540380734],
            [14.85233544717939, -0.41406379156838014],
            [14.855227214930931, -0.4160412017345113],
            [14.864618458289748, -0.4118544784388591],
            [14.871393122697228, -0.42065451510630353],
            [14.874272894009753, -0.4216224956829595],
            [14.878166309041031, -0.41942694993406004],
            [14.885881653281906, -0.4200866259682323],
            [14.897573367451665, -0.4278097422394043],
            [14.902167223861367, -0.42707062162358944],
            [14.931347941655138, -0.5698775014616447],
            [14.938921143195794, -0.6060555465373302],
            [14.90683740377642, -0.715109030260629],
            [14.884554671328482, -0.789560014496757],
            [14.781060044285436, -0.8103563207295728],
            [14.666706160754512, -0.8328163320152807],
            [14.65403646575636, -0.7299496200770933],
            [14.65346555169367, -0.7272611491106522],
            [14.645525016518075, -0.6680204553446752],
            [14.637052683605752, -0.5983003256182637]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.8590148414604, "lat": 36.76480886746718 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51025"],
        "coty_name": ["Brunswick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brunswick County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01493961"
      },
      "bbox": [
        14.609035036550933, -0.8328163320152807, 14.938921143195794,
        -0.3497167873542504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.390158369563691, 0.16776101181710026],
            [15.39181808124837, 0.1764400175300939],
            [15.393930896934828, 0.17353877246276278],
            [15.39849587649237, 0.17535003892710038],
            [15.397384896523814, 0.17983213247207325],
            [15.392850330018303, 0.1832569684761661],
            [15.390756659721644, 0.19043566768107456],
            [15.39356550231855, 0.19170667211807582],
            [15.391424652899925, 0.1991869639295882],
            [15.392437577288794, 0.20118134387296013],
            [15.390212265601917, 0.20612168437926823],
            [15.392478258013222, 0.21190000572940648],
            [15.387074667672358, 0.21919562593048628],
            [15.388686385202275, 0.22388527971682493],
            [15.392455536515616, 0.2251234474578891],
            [15.395311572484397, 0.23011134779971495],
            [15.39943616347787, 0.23430700116738404],
            [15.40581998109956, 0.23642666609111246],
            [15.410498671016331, 0.24319111215253564],
            [15.417856726490847, 0.24670541451352027],
            [15.422011918863449, 0.24624122554278224],
            [15.425684245052635, 0.24837991532173007],
            [15.437321385281207, 0.2526855035445554],
            [15.45068160220129, 0.25004114214503836],
            [15.460116613217002, 0.24430037058446916],
            [15.464892853757188, 0.24257825124635293],
            [15.467948286260196, 0.2457956895144962],
            [15.471627217708958, 0.2462600930605034],
            [15.478882877627667, 0.2446935520280929],
            [15.47865621236739, 0.24692203738751126],
            [15.484330133694064, 0.25152472307211576],
            [15.486388267851932, 0.2583453687740226],
            [15.483342558017588, 0.26568965200146893],
            [15.486655506610179, 0.2689342763999645],
            [15.486954785320941, 0.27418081623533797],
            [15.497265116989537, 0.28182454676626123],
            [15.507635922662809, 0.2665945692983232],
            [15.513011328065428, 0.2614327649999732],
            [15.52739423093878, 0.25114685813347365],
            [15.540220657298025, 0.24120636794257833],
            [15.56537654218317, 0.22244310086568372],
            [15.575657000638678, 0.211699365531519],
            [15.579161235493405, 0.20905810880168937],
            [15.569621337483674, 0.1942663542131705],
            [15.56279106815446, 0.1948729619556244],
            [15.558024537990761, 0.19392789667188085],
            [15.557339394743554, 0.19112578907070274],
            [15.549355167776994, 0.18880306978860928],
            [15.543574684580037, 0.18588839921612565],
            [15.53724652318738, 0.18627908940440743],
            [15.534238244689499, 0.1885282888887077],
            [15.530112965928119, 0.18754382633160988],
            [15.52821012738187, 0.1893968401916899],
            [15.522536506966114, 0.18877279089590476],
            [15.51600032437188, 0.18572263877257061],
            [15.515471673182693, 0.17772696090741671],
            [15.509767623226185, 0.168054303200972],
            [15.5134113454297, 0.16009287280517978],
            [15.513371304147826, 0.15429445972737105],
            [15.530544130076457, 0.14882573310676134],
            [15.531109378598405, 0.14070832157039273],
            [15.533986919803157, 0.13556806351463213],
            [15.536470087913056, 0.13402187203319887],
            [15.540910563879265, 0.12466920955123341],
            [15.537663995987995, 0.1283077779467824],
            [15.533253950602706, 0.12554994009675027],
            [15.531149462216971, 0.12252077771837311],
            [15.532880314147965, 0.11922407445513421],
            [15.536925146305405, 0.11787602967728864],
            [15.539044741934879, 0.11088939968973159],
            [15.541199586891413, 0.1095313831001866],
            [15.540060621979642, 0.10440475707472388],
            [15.54713559962083, 0.10375827157355046],
            [15.548312950574113, 0.10024690292961459],
            [15.538718944923026, 0.09769128062075792],
            [15.538874982715653, 0.0830748928758307],
            [15.544465906167066, 0.07518724436775075],
            [15.553527813021669, 0.06955971945320642],
            [15.56957266399003, 0.07065648507315683],
            [15.57550534739911, 0.07311915057276414],
            [15.581616278986699, 0.07290662431703024],
            [15.595008163187458, 0.07573476184170748],
            [15.600791320569622, 0.0795874895058286],
            [15.597869755379522, 0.08324293933472998],
            [15.59042751322033, 0.0880282976888584],
            [15.58636242454309, 0.08729135537835644],
            [15.585858749713788, 0.0927569156481966],
            [15.594254202577744, 0.09452191185071042],
            [15.59731231630927, 0.0931246703676537],
            [15.601045163559576, 0.08408457641247065],
            [15.606537922778712, 0.07567369219505388],
            [15.613626204532927, 0.07080920772332507],
            [15.617714592078515, 0.07175127131941626],
            [15.628527051580154, 0.07099054789223898],
            [15.633853005529602, 0.06803393001289464],
            [15.636281530587713, 0.07127354690120301],
            [15.652573910504268, 0.07722378492035643],
            [15.653857705134198, 0.07410629115874849],
            [15.657547072513845, 0.07260149796668655],
            [15.66079879232738, 0.06080898037044523],
            [15.665246137125193, 0.05472619822843404],
            [15.665514340462153, 0.051253066754718024],
            [15.668382058245546, 0.046402376398221215],
            [15.67228587442949, 0.04341522514823662],
            [15.67566442803983, 0.03601622874756128],
            [15.680298719183703, 0.034185073995356974],
            [15.679322446018377, 0.025991007975213837],
            [15.675336467682222, 0.022792463422295475],
            [15.67251204926152, 0.023543857921853515],
            [15.667325783484616, 0.019108382384217974],
            [15.661861808954674, 0.008279782275070549],
            [15.657228861120759, 0.009715391490129507],
            [15.65296700647935, 0.016875523611532425],
            [15.64789741355343, 0.02942124608088847],
            [15.643496524791997, 0.035308323460853316],
            [15.636781469114196, 0.04216900934248396],
            [15.626224653469777, 0.04953973661373504],
            [15.618437269273935, 0.052996172211755316],
            [15.610267223401065, 0.05367199030122922],
            [15.59156184185986, 0.04971680612506308],
            [15.584561962523997, 0.0488602171654932],
            [15.578456576386499, 0.04087093550850984],
            [15.557145981156701, 0.0314150214611951],
            [15.548104414480477, 0.03072600934789817],
            [15.54371926798555, 0.03158181870412797],
            [15.535818772292581, 0.030447268126570885],
            [15.535259169262874, 0.027113219740942756],
            [15.549010914275993, 0.02398502743057198],
            [15.55320067598432, 0.024553076527096585],
            [15.556294366605727, 0.021893215624549926],
            [15.552907043621513, 0.016199631088071646],
            [15.554008652488514, 0.013401491431523612],
            [15.552221916433494, 0.010181062545928475],
            [15.546990514974924, 0.006516129899376427],
            [15.541036003233621, 0.006901669707730755],
            [15.534425292222327, 0.012990336695938708],
            [15.52575882529702, 0.018613414662384482],
            [15.519855752430153, 0.02077868123248214],
            [15.511917073700147, 0.031028672805229113],
            [15.505366227511987, 0.040394619753181454],
            [15.50052572470866, 0.04301160739222731],
            [15.48073323574828, 0.04812619759382117],
            [15.473164626239633, 0.044921072472885196],
            [15.459459961191357, 0.04085283127830309],
            [15.45023096342227, 0.04062555164715994],
            [15.444463435265149, 0.03918568835366527],
            [15.439688112580622, 0.04637136598870295],
            [15.443895711422964, 0.04917966763679267],
            [15.444382337693607, 0.05288596381046198],
            [15.442229953655907, 0.05780774123923676],
            [15.438231137521962, 0.05913642494189078],
            [15.436324427496405, 0.056741152265579985],
            [15.428831294504253, 0.06642511469205578],
            [15.427181150172402, 0.07045915817597279],
            [15.42641485144049, 0.08018062653060373],
            [15.432005507592434, 0.0917171559193932],
            [15.431200623018839, 0.09444058853937344],
            [15.426522272742142, 0.09793208933137151],
            [15.422702389633166, 0.1045328244919209],
            [15.424785549121339, 0.11303621783105082],
            [15.420603531702715, 0.12816822597382996],
            [15.421023575956397, 0.13787628750192998],
            [15.419514750763229, 0.14112498639076224],
            [15.414768963067212, 0.14290761594163703],
            [15.414823071008035, 0.1497296038187397],
            [15.416910880578827, 0.15852880663628302],
            [15.412975442751497, 0.1636765547853579],
            [15.407185438789279, 0.16185383092014108],
            [15.403560682557444, 0.15444736331351921],
            [15.39976968932008, 0.15238668578463352],
            [15.396400898336182, 0.1469353035057368],
            [15.394923148135582, 0.14088618143280396],
            [15.392013833432308, 0.13823174531307422],
            [15.386418610928922, 0.14118580675622658],
            [15.38828694703871, 0.15339196371505517],
            [15.38932966685413, 0.1559280278624562],
            [15.395597857432968, 0.16281370302055118],
            [15.395579729386961, 0.16626945746185903],
            [15.390158369563691, 0.16776101181710026]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.7789248719548, "lat": 37.32904424730445 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51095"],
        "coty_name": ["James City"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["James City County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01480135"
      },
      "bbox": [
        15.386418610928922, 0.006516129899376427, 15.680298719183703,
        0.28182454676626123
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.167432618781794, -0.7687076753817077],
            [14.214559209172103, -0.6514768711634378],
            [14.245345072791276, -0.5746239325762906],
            [14.253118704000999, -0.554329343262862],
            [14.262351021504323, -0.5613475616524451],
            [14.268524220501366, -0.560475902019377],
            [14.269760889422688, -0.5625478439429316],
            [14.275715617694656, -0.5656653049550677],
            [14.2798258982396, -0.5692098173031974],
            [14.2887660756587, -0.5674216541525776],
            [14.294314148483206, -0.5693463939013027],
            [14.299153429491604, -0.5679727723064978],
            [14.303014563122987, -0.5649246810870026],
            [14.30583853204737, -0.5651721516861067],
            [14.306879084800926, -0.5717236126252844],
            [14.313875240770603, -0.5758793732663018],
            [14.316848770107189, -0.5815895270344371],
            [14.320300958745731, -0.5780768432423996],
            [14.32677053487621, -0.5751062675832858],
            [14.331098861414686, -0.5755426534052105],
            [14.334835565066895, -0.569249713455688],
            [14.340116416723385, -0.5697443397996311],
            [14.346924935280672, -0.5663805544295357],
            [14.350929929608723, -0.5701213621215803],
            [14.35513145141877, -0.5662236895292597],
            [14.362803421181907, -0.5662371841786787],
            [14.368339645531037, -0.5707662876106807],
            [14.373307211713145, -0.5782484707153202],
            [14.377532139106792, -0.5789811541881189],
            [14.381399749147382, -0.5768427638287007],
            [14.386398305625447, -0.5707058740760851],
            [14.39122326761204, -0.5718200722777599],
            [14.396360432739439, -0.5706880669658669],
            [14.399605567573644, -0.5734160992269944],
            [14.403390043001659, -0.5725392629744481],
            [14.408434647589695, -0.5745757680467705],
            [14.409807205067288, -0.5797940445137475],
            [14.41367552082734, -0.581440577976487],
            [14.418312354829323, -0.5803325988276773],
            [14.419256604183547, -0.5847387536282425],
            [14.430209160678492, -0.5919387142627555],
            [14.434254560841396, -0.5936701628785555],
            [14.440143272298025, -0.5914093515933362],
            [14.447909004413685, -0.5918039529238315],
            [14.457889565556195, -0.5952099419061047],
            [14.461856013757767, -0.5939640535045263],
            [14.464549682759444, -0.6001785863555142],
            [14.469772920494268, -0.5968370387866483],
            [14.474948322389032, -0.6003934260501363],
            [14.481204383627624, -0.5968083450601968],
            [14.489445952275542, -0.5986079704657438],
            [14.497695606749177, -0.5980316141217913],
            [14.501805812975638, -0.5988751511063771],
            [14.509372645622161, -0.5960285885635469],
            [14.51467114047666, -0.5965987958286566],
            [14.522132147738338, -0.595372962634653],
            [14.53579648655432, -0.598401016283309],
            [14.545958533469337, -0.5988258729996143],
            [14.559279086408278, -0.6025515299137536],
            [14.563658223613393, -0.6028412703895006],
            [14.570645844498856, -0.6000965323738237],
            [14.570172196296959, -0.5934140182136776],
            [14.567043392803367, -0.5907427997600129],
            [14.57211189690588, -0.5872120851772978],
            [14.577343425264608, -0.5911504244423191],
            [14.588010185583562, -0.5915597126754195],
            [14.597865457091855, -0.5964967406727788],
            [14.60675151294559, -0.5994799422962199],
            [14.613313666123226, -0.603893978691318],
            [14.618179631115883, -0.603152316496369],
            [14.620206790114642, -0.5948874339291179],
            [14.625597269902743, -0.5956915525513509],
            [14.631284564290075, -0.5987677077949247],
            [14.637052683605752, -0.5983003256182637],
            [14.645525016518075, -0.6680204553446752],
            [14.65346555169367, -0.7272611491106522],
            [14.65403646575636, -0.7299496200770933],
            [14.666706160754512, -0.8328163320152807],
            [14.598998504684625, -0.8460941851376311],
            [14.510884610918753, -0.8621841429570982],
            [14.44958777433511, -0.874361353854203],
            [14.34582005341199, -0.8951782104838538],
            [14.3350337468166, -0.8973532811875587],
            [14.304617385396561, -0.9043048807543077],
            [14.289174613444056, -0.9072634226397255],
            [14.230011776044465, -0.9181228159285674],
            [14.184442831402725, -0.9255983229853194],
            [14.129044877004048, -0.9359058333188465],
            [14.129956647113787, -0.9300262982264722],
            [14.127245476845957, -0.9286482022092377],
            [14.123618754975166, -0.9225622421349123],
            [14.125496114815173, -0.9202264728884417],
            [14.126854078122241, -0.9105299061739585],
            [14.124852995491674, -0.9077610724038221],
            [14.128251420998685, -0.9056640061765092],
            [14.129580204251125, -0.8984685332925657],
            [14.134484871029741, -0.9000621021859151],
            [14.136418305367213, -0.8953364604110787],
            [14.132854650398386, -0.8908793725436475],
            [14.13253207745962, -0.8854528218901014],
            [14.134983868084547, -0.8849733108868449],
            [14.13616773631874, -0.8808759575510317],
            [14.131784689867928, -0.877444019721224],
            [14.134872321249128, -0.8671965562650229],
            [14.133753094341415, -0.865577489059404],
            [14.131773079864, -0.8437541905919482],
            [14.128586708248951, -0.8400919558028529],
            [14.131804348324607, -0.837075794340705],
            [14.12848136379583, -0.8342208275087084],
            [14.130366447603162, -0.8278552451021349],
            [14.129356516065961, -0.8196480218516013],
            [14.133384420261951, -0.8191922799864788],
            [14.134746127290684, -0.8074886778642699],
            [14.133163956154485, -0.8010402410243843],
            [14.129698899119356, -0.7993304611373495],
            [14.13251908989455, -0.7948082808305417],
            [14.136451098563255, -0.7941018737337223],
            [14.138322999260552, -0.7895168399351],
            [14.146494247994154, -0.782406898930754],
            [14.164813394500525, -0.7764375945877494],
            [14.167848793857042, -0.7764778922045334],
            [14.176358431868083, -0.7806523632322809],
            [14.1875007197205, -0.7922801825967988],
            [14.192640418130003, -0.796154107062264],
            [14.20100173306107, -0.7981773911034393],
            [14.210313287790829, -0.8051725164923678],
            [14.217612066231371, -0.8056414799976626],
            [14.22224841141266, -0.8086111536517232],
            [14.226108333848293, -0.813115588496012],
            [14.232843014020347, -0.8175583221055741],
            [14.244146109138159, -0.8138185518276069],
            [14.24545033531604, -0.8110632019023798],
            [14.23307298204588, -0.8086626713206079],
            [14.223871137707171, -0.803481127714842],
            [14.210782503548154, -0.7976240873423016],
            [14.199837517351979, -0.7940378410582825],
            [14.192221725876122, -0.79070019638893],
            [14.187721792273027, -0.7870735140400955],
            [14.175155338392774, -0.7709260011252934],
            [14.170783291039347, -0.7681650220320194],
            [14.167432618781794, -0.7687076753817077]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.36280033126158,
          "lat": 36.680318241865734
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51117"],
        "coty_name": ["Mecklenburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mecklenburg County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01500747"
      },
      "bbox": [
        14.123618754975166, -0.9359058333188465, 14.666706160754512,
        -0.554329343262862
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.482902331414923, 11.232799387890754],
            [-15.488109275846346, 11.243568267737121],
            [-15.488542301618391, 11.246775702088193],
            [-15.48474844588361, 11.256068349751361],
            [-15.480439180510478, 11.261371465457817],
            [-15.476059229409092, 11.263898241602382],
            [-15.471871292983392, 11.270094306977967],
            [-15.469122850430075, 11.276125137391762],
            [-15.467732050197212, 11.287085467618315],
            [-15.473610254905905, 11.301921276130145],
            [-15.476946717531758, 11.315787620227212],
            [-15.476987308539195, 11.321266657518654],
            [-15.47412478173382, 11.32465627494269],
            [-15.467359023815037, 11.32791234582285],
            [-15.457381135102889, 11.329897952377642],
            [-15.450362536416538, 11.332050810893405],
            [-15.443113725634763, 11.336396297610055],
            [-15.434842263106614, 11.33834274390822],
            [-15.425913317721, 11.33774474614405],
            [-15.416503652931816, 11.341380038246799],
            [-15.412840912217671, 11.34194792499275],
            [-15.39934245668401, 11.33756029298153],
            [-15.393130581302197, 11.337250530310024],
            [-15.389996565932583, 11.338522006441554],
            [-15.386910214968543, 11.342997805441874],
            [-15.386700985735475, 11.35016441596357],
            [-15.384011494367932, 11.35252626201797],
            [-15.378946306621653, 11.351481425097289],
            [-15.368962489457163, 11.347344234212969],
            [-15.363587702680432, 11.343334311220186],
            [-15.360669804785726, 11.337876850736617],
            [-15.359155638264417, 11.329045674554184],
            [-15.357508926231608, 11.325122848661637],
            [-15.352172249481322, 11.321895029441054],
            [-15.34164947165386, 11.321423271572526],
            [-15.331869393980348, 11.32659727636019],
            [-15.32824340756579, 11.327107723231462],
            [-15.323955747255553, 11.314020285680959],
            [-15.323444437791329, 11.308061614769771],
            [-15.325726794738356, 11.30129665093131],
            [-15.331832513450099, 11.293634001396788],
            [-15.339237945205381, 11.282334106281445],
            [-15.346304716402612, 11.275651130634671],
            [-15.349684427494907, 11.271289843260469],
            [-15.349282931593688, 11.263163374103037],
            [-15.346707403592701, 11.258230238281659],
            [-15.336511985375179, 11.244145283341702],
            [-15.333812788285593, 11.237733483917635],
            [-15.330096807848518, 11.234240825113782],
            [-15.321728828086156, 11.229083574752377],
            [-15.310584466704924, 11.226142934223258],
            [-15.305672695927116, 11.228239349777466],
            [-15.298571510880327, 11.237124938764927],
            [-15.287961273215648, 11.244673066343589],
            [-15.278695684244513, 11.248539640399875],
            [-15.269444183480086, 11.251228706811698],
            [-15.260330392050449, 11.256076644492898],
            [-15.255822311241902, 11.260280476694945],
            [-15.243536356686482, 11.26567754907384],
            [-15.237586761120275, 11.265435126114733],
            [-15.232763718071057, 11.267273735419423],
            [-15.227123153773602, 11.271464479343024],
            [-15.223214158687426, 11.282699974472067],
            [-15.21778238862586, 11.285592455919623],
            [-15.211481349198516, 11.287460765152508],
            [-15.206222872272251, 11.285728097834449],
            [-15.201394615950235, 11.281225537340662],
            [-15.194116919399299, 11.278919333069542],
            [-15.189720599744954, 11.279933139372327],
            [-15.179119256442776, 11.275158927920684],
            [-15.175773112826365, 11.275397336299719],
            [-15.170570909425411, 11.271591280380976],
            [-15.165488450624652, 11.256173184878476],
            [-15.157937946029097, 11.246467539676964],
            [-15.154683111370721, 11.241331215245854],
            [-15.150892712567245, 11.239797341096118],
            [-15.130868604319652, 11.237851898630588],
            [-15.116530427560399, 11.230949867377909],
            [-15.1129391494459, 11.231561905692681],
            [-15.108129866890224, 11.23550614780272],
            [-15.101314341949939, 11.248105282959791],
            [-15.099975184214488, 11.258233548031223],
            [-15.094689024465874, 11.272921985113719],
            [-15.085646260279017, 11.280088917773483],
            [-15.07783040392387, 11.283941624063589],
            [-15.0712484579114, 11.286037307969638],
            [-15.065060058241905, 11.283020354400511],
            [-15.054819040589964, 11.271062494542768],
            [-15.049354698215168, 11.267267758403309],
            [-15.044267992554769, 11.266499100891862],
            [-15.032840804415434, 11.27051900670357],
            [-15.02892315487557, 11.273473251931001],
            [-15.020890745737827, 11.27472302872262],
            [-15.016868594764732, 11.272548500740243],
            [-15.011666333243866, 11.274089404037499],
            [-15.00462261789244, 11.27945854718019],
            [-14.998678768098861, 11.281374952101078],
            [-14.99508606224853, 11.281253145504465],
            [-14.988747255403503, 11.2786773344492],
            [-14.983312809902472, 11.281579706959644],
            [-14.979029853316705, 11.285275947181669],
            [-14.967480216540357, 11.29130129717883],
            [-14.960716180999988, 11.291444940865281],
            [-14.956122171852721, 11.29322330607159],
            [-14.950426654814029, 11.291642240166409],
            [-14.946593421207908, 11.28804633410426],
            [-14.93907054948339, 11.277758588220612],
            [-14.935078364691387, 11.27500510752928],
            [-14.927618043102576, 11.273043416058684],
            [-14.921879545710816, 11.273799223365312],
            [-14.91597259127771, 11.273097562009653],
            [-14.909038080447349, 11.268500922689316],
            [-14.895706271872735, 11.241932864546039],
            [-14.895138327666762, 11.23070193175946],
            [-14.896083192865818, 11.220937694583021],
            [-14.898414334150987, 11.212824007558192],
            [-14.899240746588184, 11.198306223210269],
            [-14.89781974135611, 11.191087243211179],
            [-14.897534860137261, 11.17722196012905],
            [-14.896096670779368, 11.17199001674581],
            [-14.889600460742878, 11.165883019377388],
            [-14.880921114001817, 11.16089683727766],
            [-14.875096733857411, 11.151982147953825],
            [-14.86971203572793, 11.14581254960313],
            [-14.8668052376732, 11.139458560723993],
            [-14.870054223448738, 11.130340058300474],
            [-14.874221267941019, 11.124936424371496],
            [-14.878583381850886, 11.121007983810989],
            [-14.879721280243654, 11.116130565552924],
            [-14.885254826187616, 11.107936721534912],
            [-14.899351566386224, 11.097449773998374],
            [-14.900906877373123, 11.090716484508924],
            [-14.906493944169872, 11.092174229856873],
            [-14.980686729918862, 11.109815189387097],
            [-14.984345693120126, 11.095592955168351],
            [-14.99848571582425, 11.099145997798946],
            [-15.005748288365352, 11.07132370069196],
            [-15.019821389231204, 11.07484106471278],
            [-15.023346580573696, 11.060915021014884],
            [-15.051688321450202, 11.067647493433933],
            [-15.055252253682845, 11.053815014039117],
            [-15.069439422501448, 11.057178824915313],
            [-15.090439910016427, 10.97496886046274],
            [-15.104560010786255, 10.978391793144796],
            [-15.111624667177775, 10.951317780851744],
            [-15.125948308673998, 10.954532088902674],
            [-15.132911756617064, 10.92693366235558],
            [-15.146943907908678, 10.93046484870908],
            [-15.150448382524194, 10.916891763188438],
            [-15.16450031974399, 10.92043224811091],
            [-15.178585605014115, 10.865675708037903],
            [-15.192639858852273, 10.868958349372367],
            [-15.203222781391483, 10.827889937122677],
            [-15.2171772534703, 10.831274389600315],
            [-15.220830388057148, 10.817732157745121],
            [-15.262527793392959, 10.828261658792064],
            [-15.265907493705235, 10.81539153538339],
            [-15.280017711927384, 10.818928234587306],
            [-15.283526113216034, 10.805422806196077],
            [-15.297299388477516, 10.808951051823986],
            [-15.300725531266464, 10.795265093114118],
            [-15.31475694373321, 10.799044693926742],
            [-15.318243094273578, 10.785664215297682],
            [-15.332041824269353, 10.78901723453252],
            [-15.335814072951921, 10.775337087795027],
            [-15.350056277438723, 10.778889027950676],
            [-15.353296865502871, 10.765190547453896],
            [-15.367234979305922, 10.768774107714984],
            [-15.38879358839639, 10.686970293977842],
            [-15.433481133332146, 10.69795667221062],
            [-15.445117110369075, 10.701160115384726],
            [-15.45971541079796, 10.704048165870555],
            [-15.530195107238901, 10.72035304750473],
            [-15.601097086425911, 10.736224651928458],
            [-15.61534927069579, 10.739929340579259],
            [-15.622601032914178, 10.712332231495036],
            [-15.636765077742833, 10.71556666806226],
            [-15.640488627715571, 10.701888099616099],
            [-15.654585579221258, 10.705424675908676],
            [-15.661869105002253, 10.678042614056134],
            [-15.67596684440517, 10.681489198542163],
            [-15.67980052142089, 10.667403943087091],
            [-15.693756126699844, 10.670273214680808],
            [-15.697503353719975, 10.657271574234603],
            [-15.711718165460999, 10.660539782553984],
            [-15.715169849311025, 10.647090853385256],
            [-15.729524067801105, 10.650291869945931],
            [-15.743660650596464, 10.595643300452384],
            [-15.742672706079382, 10.595411875333939],
            [-15.747713390999222, 10.580174589155241],
            [-15.754233423691792, 10.556703470211177],
            [-15.755906554640971, 10.556175716737382],
            [-15.758125252211611, 10.56070632280453],
            [-15.7622305047056, 10.564356675567602],
            [-15.77877473586041, 10.567778227259394],
            [-15.79090370744093, 10.568849014535957],
            [-15.798242473711644, 10.57162988232478],
            [-15.800822095277953, 10.574505165858655],
            [-15.805488474950025, 10.586052730759844],
            [-15.806653505157124, 10.591492703326502],
            [-15.806308355995442, 10.6038075573049],
            [-15.80319563543926, 10.610633546138704],
            [-15.798833670883562, 10.622280325374913],
            [-15.796466481131468, 10.624023014241562],
            [-15.7926052761892, 10.636553295569527],
            [-15.788128386537267, 10.645303776887467],
            [-15.787246389229344, 10.653443486606381],
            [-15.785439806580309, 10.659095508300839],
            [-15.786216470847235, 10.66394130524769],
            [-15.777975359501498, 10.676422976685492],
            [-15.780264302969876, 10.684740148706668],
            [-15.785711767023818, 10.68713316661848],
            [-15.78822362930191, 10.68989215947669],
            [-15.78888407545161, 10.693794386397533],
            [-15.794763689953973, 10.70699858863399],
            [-15.800659767723149, 10.71506080192473],
            [-15.810023207015085, 10.718255117396872],
            [-15.813322523712925, 10.718289590118053],
            [-15.82377524130908, 10.722427062086334],
            [-15.828726155047578, 10.727694904494674],
            [-15.831477359653732, 10.728231218690407],
            [-15.845333760092602, 10.736813947665668],
            [-15.855587844274414, 10.740580559699723],
            [-15.860715407458061, 10.743657094901087],
            [-15.867756146706427, 10.74482002098766],
            [-15.877974222068936, 10.750349621981423],
            [-15.897136472159769, 10.766846551744155],
            [-15.899457869857203, 10.774836225612308],
            [-15.898608477203037, 10.787439067035855],
            [-15.899468876974892, 10.799024803429255],
            [-15.901806091755159, 10.808569486404116],
            [-15.900833508099948, 10.821316742560363],
            [-15.90217836044419, 10.826303450938356],
            [-15.901669233732672, 10.83323512773897],
            [-15.897287184497124, 10.845754072699151],
            [-15.893808225143042, 10.85351061380167],
            [-15.888000511410118, 10.862912901652088],
            [-15.883192462198663, 10.875258134914843],
            [-15.88125079664266, 10.877369701397726],
            [-15.876034886583797, 10.889503007021053],
            [-15.866668241740948, 10.9012808306134],
            [-15.864831993626439, 10.904892292512804],
            [-15.858669847362993, 10.909846944235985],
            [-15.848686095282009, 10.914943918834258],
            [-15.837791471333803, 10.91844336261132],
            [-15.830420508118554, 10.930752125309393],
            [-15.82008173335415, 10.937246576437834],
            [-15.817008058724312, 10.94116043981425],
            [-15.814439041855277, 10.94755357079439],
            [-15.810990739226737, 10.95103069281269],
            [-15.811151012238698, 10.956639444830252],
            [-15.810049700159855, 10.962581135467413],
            [-15.806077939834204, 10.973516266901502],
            [-15.807100496605214, 10.977464691374207],
            [-15.804636605960955, 10.983814420419746],
            [-15.801078039339194, 10.989151303710816],
            [-15.794501156290213, 10.99684086600863],
            [-15.789451024695117, 10.998573404883157],
            [-15.78706226811743, 11.005849953017856],
            [-15.78341475069378, 11.010522837712779],
            [-15.773419144427653, 11.015926015139312],
            [-15.767128320367929, 11.025090013129725],
            [-15.766139744255128, 11.03064924823752],
            [-15.766228893803419, 11.044782142505634],
            [-15.769305820991747, 11.052012871211524],
            [-15.770001177889908, 11.05862174169579],
            [-15.772439625038363, 11.063449847373363],
            [-15.772478829811384, 11.067781319800883],
            [-15.768253729882431, 11.076753113873789],
            [-15.763363377282987, 11.083169389532973],
            [-15.755861129082307, 11.090458232835267],
            [-15.74280794519779, 11.09663254618962],
            [-15.72124651465293, 11.099552359380828],
            [-15.70746318270807, 11.102395494860824],
            [-15.698896226658453, 11.102642653366958],
            [-15.690456364432128, 11.098822769602132],
            [-15.684710138213703, 11.09341216831549],
            [-15.677721462340715, 11.08409587991925],
            [-15.673651197331807, 11.082743204534758],
            [-15.661117902852514, 11.083026311343573],
            [-15.657256728252017, 11.084175888924023],
            [-15.64419663130645, 11.084995261607355],
            [-15.638325144998472, 11.08659352754354],
            [-15.625821046951637, 11.086821763453703],
            [-15.619632535989062, 11.086108797973209],
            [-15.614673991808566, 11.083779462726412],
            [-15.610170960479433, 11.083889655203775],
            [-15.606665286778233, 11.085815799325223],
            [-15.6005127142165, 11.093707922455014],
            [-15.598481488189924, 11.094513596961875],
            [-15.592016198931622, 11.101457380025568],
            [-15.588240112391818, 11.109961091008564],
            [-15.58593825721555, 11.11174127655737],
            [-15.57765573068923, 11.121767777779887],
            [-15.569815478563406, 11.13950669138866],
            [-15.567294660641716, 11.140891526306872],
            [-15.549183123138397, 11.14337091979588],
            [-15.538989478117815, 11.1483279611468],
            [-15.534857638095925, 11.152677536417206],
            [-15.527655010787202, 11.162639081832856],
            [-15.526995199895188, 11.166894917623855],
            [-15.528116056369607, 11.177641604559149],
            [-15.526569892601081, 11.184442041440859],
            [-15.517446847885541, 11.191338470396685],
            [-15.505825335183959, 11.195077847538629],
            [-15.499938070196059, 11.199416455307238],
            [-15.483960744600259, 11.209536905753934],
            [-15.480361484243916, 11.213564661641106],
            [-15.480259515531122, 11.21865287565009],
            [-15.481698582891777, 11.230731738370201],
            [-15.482902331414923, 11.232799387890754]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.69180757890548,
          "lat": 47.73607560121149
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53017"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01531818"
      },
      "bbox": [
        -15.90217836044419, 10.556175716737382, -14.8668052376732,
        11.35252626201797
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.899603496900346, 11.071742058948074],
            [-14.889422297999813, 11.066715918855236],
            [-14.866564237053979, 11.065871645584519],
            [-14.850744408732673, 11.064478627688468],
            [-14.846208349132459, 11.0648304184953],
            [-14.83422011352416, 11.06739135199873],
            [-14.828167633018941, 11.067666627076145],
            [-14.816475527119882, 11.066212292784748],
            [-14.81306655839166, 11.065182644617959],
            [-14.807784152729162, 11.061137840673098],
            [-14.805821933503156, 11.056193824777328],
            [-14.807528398222434, 11.039235222430378],
            [-14.805045564076934, 11.031716631702832],
            [-14.799062038586396, 11.024315296959717],
            [-14.793235870401196, 11.020499103356427],
            [-14.781330875293179, 11.015478468695388],
            [-14.773246996173897, 11.010721777579963],
            [-14.764946109761706, 11.00437050432205],
            [-14.762633787548024, 11.000909393917597],
            [-14.75672552541869, 10.995359147274895],
            [-14.750271439515245, 10.992450670405224],
            [-14.73972605500062, 10.99180305892285],
            [-14.737285427322812, 10.992529479727596],
            [-14.734699181006325, 10.998341176449038],
            [-14.733184050714518, 11.007444647143846],
            [-14.727524364732048, 11.020496289839983],
            [-14.719222228873532, 11.025471691813689],
            [-14.712760745348396, 11.026126513358255],
            [-14.70626653050003, 11.022871150195861],
            [-14.696655041652114, 11.016959817927725],
            [-14.692531936060544, 11.005656000537922],
            [-14.685856722062756, 11.003004248150525],
            [-14.680257168912641, 11.005513625180917],
            [-14.674564390979786, 11.001820631596036],
            [-14.667036358507755, 11.00136770375252],
            [-14.662062466196144, 11.002528427301108],
            [-14.656635811787103, 10.999188142510691],
            [-14.647004496048478, 11.0002711487096],
            [-14.637750949834741, 10.99783638586877],
            [-14.634278699909077, 10.992315591162113],
            [-14.621253338771158, 10.981988447084225],
            [-14.617591522719401, 10.975575993779922],
            [-14.617697681934159, 10.971213600081974],
            [-14.621492761588051, 10.962804198404628],
            [-14.628472035600494, 10.955863364131053],
            [-14.631751766541832, 10.947968134174866],
            [-14.630025352862186, 10.94122449806303],
            [-14.625465997095324, 10.937361586844098],
            [-14.609994669287282, 10.934072313046732],
            [-14.605868879983202, 10.931680735757405],
            [-14.588426408455957, 10.930863219158535],
            [-14.581453478056924, 10.934460488038429],
            [-14.577943309982262, 10.93157119364789],
            [-14.576625610590849, 10.925796427649011],
            [-14.580729556970066, 10.911389047083041],
            [-14.580830693739612, 10.906341831415586],
            [-14.576113862756475, 10.896228844665739],
            [-14.569287039389145, 10.888936166301256],
            [-14.563461801872903, 10.886227601384968],
            [-14.560642118551373, 10.88274662056529],
            [-14.54458675230301, 10.87394196164559],
            [-14.538604112637389, 10.872210117123007],
            [-14.532317849116644, 10.873430023664483],
            [-14.527928630224991, 10.8723381398127],
            [-14.518647947713744, 10.878770728518283],
            [-14.517142520312959, 10.88448604641302],
            [-14.511287153260419, 10.900412635202146],
            [-14.504531153619192, 10.91096901657425],
            [-14.504469884668948, 10.916487661663599],
            [-14.501827873507047, 10.920314091236657],
            [-14.495857828191054, 10.926226705941676],
            [-14.49174123979132, 10.924735964068276],
            [-14.481415840970008, 10.92584540865684],
            [-14.481349411494996, 10.929277407703509],
            [-14.476894327589994, 10.936252591592694],
            [-14.466255388878938, 10.940450690524495],
            [-14.459179168690172, 10.942295203789078],
            [-14.443934061516003, 10.948695843674022],
            [-14.441617561495699, 10.951919814384269],
            [-14.433326822108048, 10.952076914549284],
            [-14.432194265594049, 10.954623120812851],
            [-14.425626716332328, 10.958379475932816],
            [-14.42014674619629, 10.957432036381656],
            [-14.417546206583022, 10.953728842710953],
            [-14.412085210840138, 10.952559350579856],
            [-14.403485587469259, 10.955045439215574],
            [-14.398495181237205, 10.954387532748099],
            [-14.396309478744222, 10.950890536613047],
            [-14.395251130151353, 10.943817668957019],
            [-14.395410739607188, 10.936801800365254],
            [-14.389458506787419, 10.933299190562893],
            [-14.389758684847516, 10.926916564961166],
            [-14.384134571458663, 10.916218169358903],
            [-14.386921485739304, 10.910666602504238],
            [-14.386703502908787, 10.907747956602613],
            [-14.37946330897571, 10.907430493797957],
            [-14.376385593877421, 10.90114841929066],
            [-14.379559977565947, 10.894496742148341],
            [-14.379411110971052, 10.889729440657767],
            [-14.37116077189282, 10.889374135407754],
            [-14.368441293724457, 10.886780671971067],
            [-14.36676314228902, 10.877034548953153],
            [-14.364017583984708, 10.866578726436455],
            [-14.362058646787405, 10.862452068410308],
            [-14.36072787164386, 10.852107875472266],
            [-14.361292001611826, 10.843834858739925],
            [-14.363142590471918, 10.840429409013167],
            [-14.363287960980283, 10.833420511084553],
            [-14.356712030218882, 10.831772909957404],
            [-14.355685657533467, 10.829407548893215],
            [-14.350631165766496, 10.826286575355608],
            [-14.353135384833408, 10.822035795538092],
            [-14.346056071271224, 10.806292130676889],
            [-14.34464246307327, 10.79645739196614],
            [-14.339082871582196, 10.795281927921696],
            [-14.335593368946922, 10.791576192098608],
            [-14.330375592964149, 10.792332288682003],
            [-14.324687328757228, 10.78692272292781],
            [-14.316223676159671, 10.792518736179339],
            [-14.313055447369454, 10.792909981055645],
            [-14.30865434622124, 10.790175713192108],
            [-14.300716900362476, 10.791795190496932],
            [-14.297712190370367, 10.795222951674074],
            [-14.294583662229716, 10.802127579502143],
            [-14.290640102514839, 10.807155543720325],
            [-14.282336407642102, 10.814191515806133],
            [-14.278058456417488, 10.815694078899128],
            [-14.271927755630633, 10.81402144029487],
            [-14.26349278034551, 10.809874054175303],
            [-14.258356041339551, 10.804528155594522],
            [-14.247070669874276, 10.799074805356259],
            [-14.245252777687718, 10.796622339511075],
            [-14.238825747589791, 10.797221046813434],
            [-14.233025369459616, 10.799610029774025],
            [-14.22779222901356, 10.804620303610166],
            [-14.215897295224835, 10.802948172263568],
            [-14.209570080587019, 10.803542314444877],
            [-14.205794588971006, 10.810425987932474],
            [-14.203584869648298, 10.811579123440442],
            [-14.19056886927362, 10.803845922179098],
            [-14.187084866143215, 10.79882207223326],
            [-14.180422083199247, 10.79529135561915],
            [-14.172504735726958, 10.789995639961681],
            [-14.169361630446465, 10.78172235177686],
            [-14.177392983405694, 10.74644872200466],
            [-14.19686162181228, 10.66363096836075],
            [-14.216055823773896, 10.58086937626676],
            [-14.217622924190598, 10.581220365659943],
            [-14.232154810128778, 10.521122066359059],
            [-14.264803485962819, 10.38622225744477],
            [-14.299008720607242, 10.244208511660522],
            [-14.390154194249652, 10.265590606281915],
            [-14.46304688888602, 10.282106141687569],
            [-14.487368980606577, 10.288563696267236],
            [-14.511747469977124, 10.294461905867024],
            [-14.611755500934857, 10.317915401583926],
            [-14.629515446772523, 10.321786689926387],
            [-14.711295551554944, 10.34104290368201],
            [-14.785897527835157, 10.359015841672464],
            [-14.855875697012081, 10.376007151102838],
            [-14.925857867054669, 10.392981880572004],
            [-14.99584400738275, 10.409940023739297],
            [-15.065834087406968, 10.426881574293327],
            [-15.041034386261126, 10.523030240269383],
            [-15.04067113114253, 10.525698410307145],
            [-15.02867339513176, 10.5720835550905],
            [-15.017149967701535, 10.615665584273655],
            [-15.00568052989262, 10.660754210228637],
            [-14.99503451164996, 10.703233380354932],
            [-14.972664914574876, 10.790275682428078],
            [-14.972207717317444, 10.791648937601764],
            [-14.95328170526947, 10.86407264762245],
            [-14.927495091507907, 10.965118048217324],
            [-14.92729015700651, 10.9655290232568],
            [-14.907700825402669, 11.041022539746907],
            [-14.899603496900346, 11.071742058948074]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.41872924067373,
          "lat": 47.576280216795304
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53043"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01514052"
      },
      "bbox": [
        -15.065834087406968, 10.244208511660522, -14.169361630446465,
        11.071742058948074
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.675977576126902, 9.806695838727471],
            [-14.67258092730687, 9.806788261730654],
            [-14.666621034094323, 9.812785444946885],
            [-14.65946576942466, 9.815573378659387],
            [-14.65650310209543, 9.811262925769817],
            [-14.653265882525764, 9.80949864911555],
            [-14.642620072316094, 9.806656072252085],
            [-14.635690126253065, 9.811933752384595],
            [-14.635000063529162, 9.81780154799818],
            [-14.631038429241817, 9.816038471780882],
            [-14.625738265090304, 9.816601893671601],
            [-14.620782232081211, 9.81524661270407],
            [-14.614475640107614, 9.815057147344154],
            [-14.607674507969202, 9.817030611829944],
            [-14.600958303580173, 9.822812200179659],
            [-14.594313132299884, 9.822132807088632],
            [-14.58989790885777, 9.827069965772834],
            [-14.580958491409596, 9.821205869752836],
            [-14.576479040642287, 9.821478000366136],
            [-14.57461133152278, 9.816917477281196],
            [-14.563478145315852, 9.811625238801785],
            [-14.560636161400753, 9.809396231682115],
            [-14.55587930251477, 9.811247330383942],
            [-14.552170919091605, 9.81944627172911],
            [-14.548683924434393, 9.823551462077557],
            [-14.541275791032424, 9.824668330821792],
            [-14.538427778177534, 9.819130304924352],
            [-14.535139393785215, 9.820256812354714],
            [-14.531697991517008, 9.825413801650491],
            [-14.53345258503869, 9.8342264290078],
            [-14.531272489837669, 9.838787662243199],
            [-14.531786237427736, 9.846986609825956],
            [-14.529951670331688, 9.84982195122844],
            [-14.526568942333231, 9.84820804708587],
            [-14.521499854087871, 9.851109657454627],
            [-14.514460325557346, 9.85343696469143],
            [-14.514881446866228, 9.856182190401096],
            [-14.51241742479253, 9.860207182146437],
            [-14.508903830223874, 9.86161335885457],
            [-14.50737245813862, 9.86743843782758],
            [-14.514666486649153, 9.8698860462728],
            [-14.514689177813993, 9.87471895200976],
            [-14.512968796360537, 9.879127728080801],
            [-14.509429975663771, 9.879801829836078],
            [-14.500224253362164, 9.885959434150914],
            [-14.498482491508199, 9.88952944657535],
            [-14.491197550895707, 9.889112323126184],
            [-14.486467837709515, 9.891971294476416],
            [-14.47306193693575, 9.93684403388598],
            [-14.467881559976522, 9.935623280796733],
            [-14.46426419074571, 9.951586464771685],
            [-14.445012767437854, 10.033348844794208],
            [-14.434708506193603, 10.075137711305334],
            [-14.42175499909238, 10.130823038410213],
            [-14.420916948761706, 10.133694812861098],
            [-14.398811029518287, 10.227899397275706],
            [-14.390154194249652, 10.265590606281915],
            [-14.299008720607242, 10.244208511660522],
            [-14.207622369204206, 10.223015191282835],
            [-14.126066419301953, 10.204338082921977],
            [-14.066250436601127, 10.190412275940423],
            [-13.968702158026534, 10.168743489131405],
            [-13.897245668375364, 10.152446268057767],
            [-13.810307082097042, 10.133003491835998],
            [-13.796275316144301, 10.130256211957494],
            [-13.777990188821239, 10.125620287421322],
            [-13.785281770844492, 10.093357655598144],
            [-13.806688641007309, 9.999460592349191],
            [-13.82377452694876, 9.92455684056673],
            [-13.853572396806129, 9.79388272612484],
            [-13.872471193276516, 9.710977718958892],
            [-13.874850292503766, 9.701085392241012],
            [-13.899771877959695, 9.590588318581467],
            [-13.917235811518388, 9.514466886238834],
            [-13.934624825991362, 9.438656021291399],
            [-13.96008214046162, 9.327536700287045],
            [-13.965110099431167, 9.331927650899031],
            [-13.971449831188144, 9.333924568018084],
            [-13.978538091549451, 9.332736582809213],
            [-13.99320570086633, 9.32627617309417],
            [-13.999916571554257, 9.328126428095523],
            [-14.003228328158954, 9.330978608074885],
            [-14.013200981118642, 9.334527562030733],
            [-14.021901395254973, 9.342418084092273],
            [-14.029691756179444, 9.347389901557406],
            [-14.03442120497029, 9.348788772820255],
            [-14.043161271939134, 9.348042082198049],
            [-14.055162208369245, 9.344977363357051],
            [-14.0597251478601, 9.344721393525013],
            [-14.069247615277376, 9.346097216452359],
            [-14.075541471618745, 9.35215793532048],
            [-14.076458025807282, 9.35988140928729],
            [-14.067412799681824, 9.37464079848351],
            [-14.071569877263586, 9.383955354281316],
            [-14.07900537388657, 9.390726927018662],
            [-14.081862935439105, 9.393114696829606],
            [-14.083645328761635, 9.397884544658455],
            [-14.083241708134768, 9.406693738578793],
            [-14.081990553336881, 9.410504790517727],
            [-14.076477281773496, 9.419013134520545],
            [-14.072703844264343, 9.42798870376671],
            [-14.075433636746412, 9.446633015387311],
            [-14.076945504828716, 9.451295565777821],
            [-14.076319959559532, 9.458821877147573],
            [-14.077987669038908, 9.473219283941871],
            [-14.081057003674994, 9.479128359054748],
            [-14.085975198247185, 9.485848827031036],
            [-14.092736522075505, 9.492321133336345],
            [-14.095319274368835, 9.496754226627901],
            [-14.098364607402264, 9.505781428183118],
            [-14.102809311990521, 9.51230095191011],
            [-14.108858577021138, 9.51696645265534],
            [-14.119181488201217, 9.519304309100542],
            [-14.126130550654183, 9.52206980360095],
            [-14.129117785790141, 9.524465879994498],
            [-14.132952512560804, 9.530197055289003],
            [-14.134819811417442, 9.541582119910716],
            [-14.136100134113564, 9.544780574244706],
            [-14.14261762298623, 9.553083108560225],
            [-14.14924385804087, 9.560263514569321],
            [-14.150642921597603, 9.564814809026007],
            [-14.150891346501865, 9.57112371064944],
            [-14.149622174711244, 9.576301459708985],
            [-14.145685656034905, 9.584167433316546],
            [-14.143505957972765, 9.592482921137597],
            [-14.147404869070856, 9.599502838280456],
            [-14.158522453556406, 9.604543913374417],
            [-14.165388587443296, 9.604648110428268],
            [-14.172855257471234, 9.610731597049135],
            [-14.17737051947182, 9.618864838181],
            [-14.179895463482314, 9.627860207785075],
            [-14.180223756408969, 9.644733955144526],
            [-14.182853349327951, 9.650909044697395],
            [-14.18539205086163, 9.654062159294357],
            [-14.19248470393594, 9.656404861168692],
            [-14.203269520842404, 9.653829377890135],
            [-14.209149136589089, 9.64967762822029],
            [-14.213386467693853, 9.642695793680836],
            [-14.21986712958854, 9.640660537716062],
            [-14.225606603835622, 9.640339603144032],
            [-14.23440760763974, 9.642753181077763],
            [-14.243005778569673, 9.647495107609084],
            [-14.246639294509235, 9.648481695414448],
            [-14.25919495824646, 9.64890580579132],
            [-14.267654168042842, 9.648310367797327],
            [-14.280693344308022, 9.648415996396501],
            [-14.289465099212485, 9.651090832689006],
            [-14.292798426034345, 9.653065310734002],
            [-14.29831869348976, 9.659145921535963],
            [-14.301910875207772, 9.667607975201092],
            [-14.303911768179422, 9.674735657353624],
            [-14.308411092238106, 9.682229394131912],
            [-14.31922056027735, 9.687504190069882],
            [-14.334084097857655, 9.690912965039029],
            [-14.340539674719869, 9.689350986345012],
            [-14.36015445709303, 9.690411475779726],
            [-14.366522562289811, 9.689470026818423],
            [-14.371685061302363, 9.691453282352574],
            [-14.379687952802193, 9.688367003222272],
            [-14.384248697521773, 9.684054031304605],
            [-14.389039200470368, 9.676235536307999],
            [-14.395049793581514, 9.660741482484523],
            [-14.398657588498573, 9.65526688263786],
            [-14.404003641836436, 9.649248458355334],
            [-14.4106888023972, 9.643787101150682],
            [-14.418993205556177, 9.638218190496627],
            [-14.42742459331802, 9.63472521284859],
            [-14.441065466851327, 9.634431931429713],
            [-14.447280724803957, 9.635675552978562],
            [-14.461958032791753, 9.641700280650202],
            [-14.467437381134244, 9.64185785125031],
            [-14.472546012752577, 9.640615331066444],
            [-14.478918798262312, 9.636434688498547],
            [-14.483260675937316, 9.630675876930715],
            [-14.48947758256066, 9.615278073902827],
            [-14.492597450058446, 9.611612327427265],
            [-14.497743221430142, 9.610313656659207],
            [-14.50941971612301, 9.612397647058838],
            [-14.523973626679654, 9.619097375061877],
            [-14.537559826989005, 9.62628403815532],
            [-14.560090673373479, 9.626261434490383],
            [-14.56961440913093, 9.62998819567115],
            [-14.577870238427838, 9.631461941154017],
            [-14.5939699320598, 9.632412446821567],
            [-14.604108239072282, 9.628864903651191],
            [-14.60980707092333, 9.62792846415019],
            [-14.61914915322841, 9.627690227452927],
            [-14.628622586156009, 9.63029440039642],
            [-14.635154672975567, 9.631276288615789],
            [-14.64094063359336, 9.628301408145276],
            [-14.645850782116135, 9.620681319738994],
            [-14.650578099826514, 9.618598801999944],
            [-14.65638172843134, 9.618310378173469],
            [-14.672721322521117, 9.623134850393912],
            [-14.683601955010932, 9.622734702205124],
            [-14.692656747000854, 9.626963483830087],
            [-14.696051648781312, 9.631383411755992],
            [-14.69780137751868, 9.6374170074726],
            [-14.702923791436369, 9.644409969493779],
            [-14.711453997271619, 9.662326029171357],
            [-14.714203039029876, 9.6643166150347],
            [-14.709201089583809, 9.670928120788957],
            [-14.708414870960711, 9.674908867596681],
            [-14.705228875801172, 9.678454697399248],
            [-14.70445081897712, 9.68302997896299],
            [-14.697636789337828, 9.682265821164126],
            [-14.695427883728897, 9.695524312878982],
            [-14.704503774681825, 9.706860004234509],
            [-14.70203197440101, 9.711718588073015],
            [-14.704782297242069, 9.714329069715227],
            [-14.707466985513017, 9.72095820927741],
            [-14.707315426392855, 9.7276119929279],
            [-14.708716834420855, 9.73120842698042],
            [-14.704954847154726, 9.736455733304116],
            [-14.702678775713197, 9.736815906476792],
            [-14.699982882119889, 9.746696963305263],
            [-14.694619615435178, 9.75082505315886],
            [-14.695789519700169, 9.761652831663278],
            [-14.701263669705044, 9.792390235397088],
            [-14.702245583485476, 9.80269869618769],
            [-14.703493666111743, 9.806844289234773],
            [-14.696302921256697, 9.810643104346225],
            [-14.692685790548238, 9.805604433198466],
            [-14.687874233848135, 9.807200626562896],
            [-14.683153491889005, 9.806292468411758],
            [-14.675977576126902, 9.806695838727471]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.52300405611676,
          "lat": 46.90117613422897
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53075"],
        "coty_name": ["Whitman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Whitman County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01533501"
      },
      "bbox": [
        -14.714203039029876, 9.32627617309417, -13.777990188821239,
        10.265590606281915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.01141325258845, 2.429986718159766],
            [12.017195108233604, 2.437876247442421],
            [12.019374574450193, 2.4456864267338037],
            [12.019650449646582, 2.4524721913780247],
            [12.01905365591156, 2.465549393136807],
            [12.019389112001294, 2.476458588339056],
            [12.023981523791827, 2.4927011551834775],
            [12.028558883880159, 2.499880561604579],
            [12.03367104518207, 2.503777120424714],
            [12.043352103784562, 2.5130149587918402],
            [12.04518797968781, 2.516786893718408],
            [12.046348111187442, 2.5242275846106366],
            [12.043786792764612, 2.5370858843097017],
            [12.044115058925815, 2.5439821735536983],
            [12.048371685060834, 2.5568302442268585],
            [12.050611797655698, 2.560464090426766],
            [12.051124313675498, 2.571373461639385],
            [12.047226968065498, 2.5811540899012666],
            [12.039220717793858, 2.5931224744659955],
            [12.036623670439534, 2.599643035510007],
            [12.036149437939432, 2.6072247414135736],
            [12.037354936825018, 2.6143656397019335],
            [12.036938502303638, 2.6220587567742575],
            [12.034495053860997, 2.627174379521403],
            [12.026309120962685, 2.6327828761938314],
            [12.017197948482396, 2.6344957619887053],
            [12.01416567249367, 2.639686245460866],
            [12.016331634287456, 2.6446746820891716],
            [12.035549145379349, 2.6498447324511023],
            [12.057215498827228, 2.6561985998032296],
            [12.068042889765234, 2.65776114759013],
            [12.098796425525542, 2.6628991706272043],
            [12.103976298817484, 2.631398402732592],
            [12.107427328791585, 2.6055454216320206],
            [12.121348985458512, 2.5208771700642236],
            [12.137227556507389, 2.4240826447179096],
            [12.087737965341042, 2.430475361959244],
            [12.077761565549752, 2.4319512643952677],
            [12.056099866768562, 2.4287027699263968],
            [12.02785951375703, 2.425380396701683],
            [12.026848239600733, 2.428347503762654],
            [12.022558006742894, 2.432014191213943],
            [12.021123484124557, 2.4296973559019563],
            [12.015162396530723, 2.4282270285262686],
            [12.01141325258845, 2.429986718159766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.57645272752335, "lat": 40.27382216880849 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54009"],
        "coty_name": ["Brooke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brooke County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01558262"
      },
      "bbox": [
        12.01141325258845, 2.4240826447179096, 12.137227556507389,
        2.6628991706272043
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.70618182417804, 1.359940345360997],
            [11.707969859865411, 1.3578676115805193],
            [11.707524213349222, 1.352629343342805],
            [11.702657609151512, 1.3460922671202946],
            [11.694722950792524, 1.3397766014833956],
            [11.695107574632834, 1.3341539851974638],
            [11.69846325560752, 1.3305854117076934],
            [11.69354241055221, 1.3284678900343365],
            [11.694120351135423, 1.324397344573777],
            [11.687961053301514, 1.3234062514080913],
            [11.688090802500296, 1.32085947543245],
            [11.693113016300671, 1.3139766845471368],
            [11.713515991096925, 1.3041392038271702],
            [11.715331546224391, 1.306977094815898],
            [11.720076640783448, 1.308436205572563],
            [11.723509297827965, 1.307099177107915],
            [11.723514002649239, 1.3018828114239698],
            [11.730695649778891, 1.2979957968857045],
            [11.734000633095032, 1.2909683846166475],
            [11.735237104915006, 1.284950167082351],
            [11.741767661198482, 1.2864277894910767],
            [11.744725340771293, 1.2856609207127812],
            [11.74712154308546, 1.2820776528291438],
            [11.746532466095776, 1.2766700955742025],
            [11.749944960194817, 1.2724058835799505],
            [11.750347597374963, 1.2632730956305656],
            [11.752605504203217, 1.2609615967071908],
            [11.754850085721241, 1.2516211564062025],
            [11.752653725466487, 1.2450212558715714],
            [11.744546454228969, 1.2416092032678885],
            [11.746463450199657, 1.2373112440375387],
            [11.750096179583181, 1.2353103118033795],
            [11.760107041590473, 1.2359136796722041],
            [11.763589399784287, 1.230300670916805],
            [11.765978298381247, 1.2214434353455657],
            [11.76307272941406, 1.2180720891588077],
            [11.766160040798066, 1.215316190480281],
            [11.774473070103944, 1.2195216784437142],
            [11.783068788062359, 1.2153504469580803],
            [11.784384744582233, 1.224343467666748],
            [11.78711060420892, 1.227324956216581],
            [11.792102426005329, 1.2297433129878537],
            [11.796712230028216, 1.2301291247641029],
            [11.800298961990714, 1.2278064136693425],
            [11.801037665980397, 1.2242368313192427],
            [11.81048663736565, 1.2275348545608662],
            [11.819435496238322, 1.2296919062755833],
            [11.824221194157738, 1.2234275004644664],
            [11.828858756384747, 1.2215736680191758],
            [11.833330302927445, 1.2215332701995383],
            [11.830393135974528, 1.2175202821036009],
            [11.790596892314662, 1.153886315828509],
            [11.764229584164546, 1.11437744346241],
            [11.766888526870277, 1.1118174859833265],
            [11.76784371500906, 1.1075313669006615],
            [11.770626704864128, 1.105003116772278],
            [11.762395397572753, 1.1011989568072056],
            [11.765959651771997, 1.0959306254618881],
            [11.763218653097184, 1.0922821628952746],
            [11.741060470266545, 1.0819167836018468],
            [11.716144733441592, 1.0653826518319667],
            [11.692971814868903, 1.0723462668748078],
            [11.658239792839572, 1.0819552196235387],
            [11.629840863010655, 1.0989376418650718],
            [11.625329347697047, 1.0967504427621488],
            [11.625128425284508, 1.0903876522976563],
            [11.62071130206454, 1.0869825384746084],
            [11.618256376399195, 1.0877318273036514],
            [11.617386540934305, 1.0825724537890626],
            [11.607466218258832, 1.0776842499321968],
            [11.602998859716603, 1.0792662235437158],
            [11.600689863813118, 1.0766670029605983],
            [11.597837804255104, 1.0776623097523512],
            [11.595110381019095, 1.0753594891748863],
            [11.595222815672399, 1.071146282631467],
            [11.592001367601979, 1.0688800197674613],
            [11.588962597832428, 1.0701564713590976],
            [11.584022094008981, 1.0685385273847736],
            [11.583900523821237, 1.072490831094544],
            [11.577607207401702, 1.0764493145597216],
            [11.579702605957271, 1.0801383518811203],
            [11.575915434409215, 1.0825422357718437],
            [11.576473666576126, 1.0850586750491025],
            [11.571483397325165, 1.0862546794078454],
            [11.563117337566375, 1.093322462054854],
            [11.559857544582053, 1.0919708888523647],
            [11.557219476359975, 1.0971202078053255],
            [11.54952215748915, 1.1054446070681412],
            [11.548814013687418, 1.1128106798927841],
            [11.556220918061582, 1.1212151439000382],
            [11.562291168091768, 1.1249137274748053],
            [11.558342400649055, 1.134657583592076],
            [11.554700825214837, 1.1367677031172674],
            [11.556090917009602, 1.1433729067290475],
            [11.555127199267467, 1.1477104645573974],
            [11.555984059628416, 1.1531186916819876],
            [11.515447415636816, 1.1677047922567405],
            [11.53313716117448, 1.1940003803819785],
            [11.572560666384526, 1.2411159602863702],
            [11.602408903249184, 1.2777838090198668],
            [11.60837297377033, 1.2840844792028132],
            [11.617610715661472, 1.2952321886927265],
            [11.631068912898526, 1.297480613184804],
            [11.641233508641434, 1.3048135312869085],
            [11.70618182417804, 1.359940345360997]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.37865142961837, "lat": 39.0224780874767 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54105"],
        "coty_name": ["Wirt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wirt County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01678877"
      },
      "bbox": [
        11.515447415636816, 1.0653826518319667, 11.833330302927445,
        1.359940345360997
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.359537260086013, 1.3016019385572117],
            [11.361235209677137, 1.3060963172474578],
            [11.369011137158875, 1.3122931288803408],
            [11.372351996292316, 1.319608753737768],
            [11.37276067227743, 1.3294700567824145],
            [11.374438518387507, 1.3358648018983033],
            [11.37715435719372, 1.3403089496566218],
            [11.387230467679727, 1.3452974092900956],
            [11.395119501680943, 1.34814218021594],
            [11.399409150411925, 1.3521233734901599],
            [11.401303983285132, 1.3563306782490587],
            [11.399415489323781, 1.3643578878110199],
            [11.395720225618778, 1.3707064709236347],
            [11.393870347293648, 1.3764365375405796],
            [11.393076982313726, 1.3847766535872397],
            [11.396942973342565, 1.3945582196224127],
            [11.400641350990291, 1.4001171203107976],
            [11.404229772288408, 1.4035363016470772],
            [11.410069061802567, 1.4066768685952986],
            [11.420508040665798, 1.4096841074667812],
            [11.430356656036034, 1.4110187336921922],
            [11.447477452776935, 1.4099998222351997],
            [11.456888482663658, 1.4138849370112843],
            [11.467335353695171, 1.4127676814998062],
            [11.475320792143778, 1.4092501342766068],
            [11.487091755411287, 1.4099550902533549],
            [11.4888319621973, 1.4132842530308056],
            [11.48958374921202, 1.419014710657408],
            [11.487032038938317, 1.43669461154631],
            [11.487078204216315, 1.4612048604260697],
            [11.485485948634059, 1.4741314520934024],
            [11.485853935756728, 1.48235535288853],
            [11.495208479631616, 1.498183553681454],
            [11.500351188711141, 1.504444223292697],
            [11.507526533259508, 1.5089916208019727],
            [11.514880486476256, 1.515674592623849],
            [11.521730202756359, 1.5230487894417737],
            [11.530772882030343, 1.5354985737519795],
            [11.534562099865557, 1.5417992308252269],
            [11.540297603250647, 1.553398751240712],
            [11.543862090150967, 1.5576275174905956],
            [11.551791856056987, 1.5644652518338016],
            [11.558884130940243, 1.5666821950705572],
            [11.567422383846601, 1.5660599085306162],
            [11.573195127131337, 1.5637860399878296],
            [11.586909473063084, 1.5549226239711045],
            [11.592469354272298, 1.5491166343450882],
            [11.599881685135415, 1.5309954543151858],
            [11.605672194795089, 1.5179343537067187],
            [11.610221298726124, 1.5117569464576988],
            [11.616117332597256, 1.5071915140035084],
            [11.620024740735618, 1.5064000241098228],
            [11.626389314777823, 1.507367040145779],
            [11.630943881115485, 1.4994606840283695],
            [11.631462841971423, 1.4945094622663604],
            [11.635505933184163, 1.4867634075683078],
            [11.642163018564387, 1.489023287033458],
            [11.640524652185311, 1.494013190980705],
            [11.645976003429194, 1.4968267720319433],
            [11.650715365357005, 1.4892221699666657],
            [11.657660966190837, 1.4939621897097575],
            [11.660407029050944, 1.4911914802016708],
            [11.663948359034467, 1.4910304773995127],
            [11.66604057462483, 1.4866833863006148],
            [11.663564398478194, 1.4824763069813784],
            [11.669015260960544, 1.4724858420965086],
            [11.668718106464766, 1.4696063660407939],
            [11.676523062819756, 1.4725953602809105],
            [11.683305027542174, 1.4708184030856135],
            [11.689419873910477, 1.4727243497517872],
            [11.699922322545344, 1.4728333173895274],
            [11.705831040450377, 1.4704655069992494],
            [11.712345831052128, 1.4734266901657302],
            [11.718236290529854, 1.4699394821384886],
            [11.71982158754879, 1.4656080116818568],
            [11.719909770433796, 1.4601518080463636],
            [11.723167696704419, 1.4580726279008642],
            [11.730115896592356, 1.4567096328365556],
            [11.733717110972716, 1.4515291009413163],
            [11.737663882557962, 1.4493937421834941],
            [11.732038776191564, 1.4478465182341786],
            [11.729509353938148, 1.4506175360587859],
            [11.722543175126395, 1.4455118652232837],
            [11.717357535859273, 1.4376901359615122],
            [11.718188019512546, 1.4322875122822711],
            [11.715079507466696, 1.4247660530379669],
            [11.71273344738308, 1.416245290779286],
            [11.714438641164818, 1.4105929954802334],
            [11.7052663741793, 1.399128828879472],
            [11.704243267401663, 1.3931029570072033],
            [11.704783983345664, 1.388128921717869],
            [11.70301072240074, 1.3793047302799462],
            [11.700827848740493, 1.3754342708220704],
            [11.707999885283034, 1.361575225881236],
            [11.70618182417804, 1.359940345360997],
            [11.641233508641434, 1.3048135312869085],
            [11.631068912898526, 1.297480613184804],
            [11.617610715661472, 1.2952321886927265],
            [11.60837297377033, 1.2840844792028132],
            [11.602408903249184, 1.2777838090198668],
            [11.572560666384526, 1.2411159602863702],
            [11.53313716117448, 1.1940003803819785],
            [11.515447415636816, 1.1677047922567405],
            [11.459957367327041, 1.1877054522095458],
            [11.441600632775245, 1.1941706790243312],
            [11.403199884495026, 1.2086341823146045],
            [11.37888049413485, 1.217605697202085],
            [11.3804587987958, 1.2292771544065317],
            [11.379527854786117, 1.2395480330016067],
            [11.376178315703969, 1.249290044122413],
            [11.372879910453596, 1.2708382950686357],
            [11.362086483509579, 1.2927506648262483],
            [11.359537260086013, 1.3016019385572117]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.51505531143685, "lat": 39.21115397869543 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54107"],
        "coty_name": ["Wood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wood County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01560558"
      },
      "bbox": [
        11.359537260086013, 1.1677047922567405, 11.737663882557962,
        1.5666821950705572
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.219779845155594, 8.005038289048334],
            [4.228029447173904, 8.002719439417813],
            [4.236274412722738, 8.008968567396847],
            [4.244836444149332, 8.012492253338424],
            [4.249603585890288, 8.012388584372955],
            [4.272626006075806, 7.998449939030817],
            [4.290496087882641, 7.989996813423599],
            [4.2982628394995075, 7.987388513079004],
            [4.311393207447987, 7.992702401520623],
            [4.313296741220715, 7.989920871020815],
            [4.314344259915545, 7.9841979561815455],
            [4.3191594522259855, 7.981694917968594],
            [4.321114756409354, 7.974964602346852],
            [4.32512631041557, 7.972034151584297],
            [4.330447037708523, 7.960705539323517],
            [4.3354512736955275, 7.962161541192418],
            [4.339204655642694, 7.965251648813462],
            [4.348015771358887, 7.970189719246841],
            [4.352409619670057, 7.970662676802657],
            [4.3548532578729855, 7.968446682384318],
            [4.359602448937115, 7.97020896322308],
            [4.362658113394132, 7.97610657887946],
            [4.363033866001841, 7.9818776581588],
            [4.368023393513622, 7.984139261333245],
            [4.371537271612874, 7.983557754709781],
            [4.37554266743767, 7.976745249983727],
            [4.379663493063239, 7.9774402532690365],
            [4.382988371567453, 7.971968262447994],
            [4.386847148010582, 7.970704709228031],
            [4.387428305051685, 7.964002670542895],
            [4.385313500190978, 7.955202703748636],
            [4.383138334502408, 7.952950042154359],
            [4.38613765380314, 7.947748863345605],
            [4.399402876270365, 7.95115745442541],
            [4.399001970260376, 7.953901267023208],
            [4.406971965728906, 7.951628227893144],
            [4.410969768035094, 7.957424889392684],
            [4.414293576163581, 7.9542998461510175],
            [4.413174442406089, 7.9485837547744005],
            [4.419246912653951, 7.941467225114331],
            [4.42038336682707, 7.937552464178856],
            [4.433571543931581, 7.9393351083456905],
            [4.440158705541661, 7.941995330420335],
            [4.443229975029341, 7.944871871320831],
            [4.445695389567397, 7.936839955726336],
            [4.449985232573416, 7.938886070107452],
            [4.454050613734317, 7.937527603299985],
            [4.458078852230341, 7.926484399805564],
            [4.462612195165976, 7.920915984635275],
            [4.462881428596901, 7.917254595501256],
            [4.4658569039937746, 7.9128286988446455],
            [4.471819778372955, 7.909640495774501],
            [4.473196076589082, 7.90292009453387],
            [4.472457602849375, 7.900433196295451],
            [4.475417088012482, 7.896320918926401],
            [4.483411545865271, 7.893878970620033],
            [4.483151569731216, 7.88834024610947],
            [4.484800122665343, 7.885875312422036],
            [4.484449856440247, 7.878485125601639],
            [4.490443686957828, 7.878569473962934],
            [4.494800664434234, 7.873548783119675],
            [4.4959762777203665, 7.866579491871767],
            [4.498856654215577, 7.861969536318025],
            [4.499146418270568, 7.853190870971072],
            [4.500194252794262, 7.84882227280828],
            [4.5030081079572755, 7.8464004682644495],
            [4.504076252171267, 7.841142077412317],
            [4.508464236762084, 7.839270806203029],
            [4.511048991871245, 7.830126324424286],
            [4.514412364396193, 7.825643444246807],
            [4.519585634061159, 7.822247558683464],
            [4.518335264961367, 7.820074137741526],
            [4.519046208086391, 7.8128873708476005],
            [4.527111994332811, 7.805238180548878],
            [4.5302093877169, 7.801109306964067],
            [4.5321798780569384, 7.7927257616886605],
            [4.529855158702232, 7.791574044303792],
            [4.53151621365149, 7.781353935681993],
            [4.530442367726775, 7.778953991260012],
            [4.621821271064976, 7.75966059179621],
            [4.664966619111791, 7.750598298363178],
            [4.666913294564472, 7.719500355411055],
            [4.668822453025335, 7.694386515624585],
            [4.674046464696944, 7.613691861251282],
            [4.674669904473181, 7.594211458976872],
            [4.676046382599134, 7.581482270206523],
            [4.680068256502261, 7.523154268904174],
            [4.681331871227134, 7.508093073555271],
            [4.685436056702134, 7.436841637960389],
            [4.638523251687085, 7.434254783861413],
            [4.635926899228101, 7.433695109388767],
            [4.605491550608076, 7.431800348650001],
            [4.51974612950005, 7.426529478244892],
            [4.426264602745442, 7.42029640792981],
            [4.426268517501509, 7.435176750975884],
            [4.4250835785019556, 7.44899326839329],
            [4.424984129530398, 7.463270117246032],
            [4.4228565268679265, 7.491584785174357],
            [4.422328939997721, 7.50595389476903],
            [4.418253505765048, 7.534168015570159],
            [4.415039516844831, 7.576901449866494],
            [4.415187323461539, 7.5916787790728035],
            [4.409172066867303, 7.591123001666304],
            [4.371390223166576, 7.589287156936497],
            [4.357021029279646, 7.5877496833393785],
            [4.32987832865813, 7.585878060542225],
            [4.325030096766091, 7.671194321815846],
            [4.237647664843996, 7.666564545576506],
            [4.236606012800207, 7.687755367663453],
            [4.235091408956805, 7.725877278292349],
            [4.2354054325826365, 7.737445807147479],
            [4.23487594808774, 7.753764597298818],
            [4.230092660462867, 7.837402938001378],
            [4.225458507805068, 7.92233794094019],
            [4.224343739785145, 7.923065862316843],
            [4.219779845155594, 8.005038289048334]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.24204516028031, "lat": 46.26228652545488 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55051"],
        "coty_name": ["Iron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iron County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01581085"
      },
      "bbox": [
        4.219779845155594, 7.42029640792981, 4.685436056702134,
        8.012492253338424
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.293273151183171, 4.34230826916182],
            [5.340432313441695, 4.346409743811842],
            [5.379630998673293, 4.349261493312199],
            [5.429516618460314, 4.353292625538262],
            [5.4655562962569535, 4.356567262582482],
            [5.52661721990683, 4.361508426294761],
            [5.551585424103891, 4.363399588921569],
            [5.595075677882232, 4.365073982051413],
            [5.638028120717425, 4.368095264112466],
            [5.6805616407006605, 4.36931542547501],
            [5.723871149687173, 4.371300506197041],
            [5.726331027916396, 4.334106515395362],
            [5.7292774407655385, 4.283245648447909],
            [5.734875779439794, 4.223159948134726],
            [5.737617245043638, 4.196121286806046],
            [5.739021632071269, 4.176700193347521],
            [5.742043692423347, 4.140758641602881],
            [5.744870241617313, 4.103679198814595],
            [5.746128714764736, 4.0839932539418475],
            [5.751013480585482, 4.020465496905626],
            [5.743644590892394, 4.01986564154483],
            [5.631114578023775, 4.014504836612266],
            [5.592853350582467, 4.012660740881042],
            [5.53549641065349, 4.008642611691469],
            [5.496006398980967, 4.006530844860217],
            [5.4655747277560485, 4.004638782309965],
            [5.422014938289979, 4.002228506703694],
            [5.404116889606898, 4.000993420864787],
            [5.3747249947238105, 3.999778606665876],
            [5.323002235882701, 3.997316071896722],
            [5.319887838640564, 3.997348768855447],
            [5.313425843335089, 4.081160501380421],
            [5.305720192272434, 4.180871130829907],
            [5.298542189715421, 4.267443431243972],
            [5.293273151183171, 4.34230826916182]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.07158204609452, "lat": 42.67121246316369 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55105"],
        "coty_name": ["Rock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rock County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01581113"
      },
      "bbox": [
        5.293273151183171, 3.997316071896722, 5.751013480585482,
        4.371300506197041
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.711381273537787, 3.4576535933130446],
            [-10.69408552071222, 3.566017583283496],
            [-10.69113098738478, 3.5829044556038103],
            [-10.668008107456599, 3.725738405839021],
            [-10.658693603422627, 3.783579308070293],
            [-10.489738189187682, 3.7567627967254906],
            [-10.32079050383549, 3.7298972856259063],
            [-10.231705256170036, 3.7161546225927964],
            [-10.142622090430967, 3.702398361291702],
            [-10.14030114252125, 3.70186110720509],
            [-10.09578668115982, 3.694788978079851],
            [-9.937843311672921, 3.6701911478781013],
            [-9.926912261881938, 3.669070361969158],
            [-9.944357758832963, 3.5566440814946603],
            [-9.953137221326696, 3.496255878046227],
            [-9.953624531091021, 3.4942249409996298],
            [-9.97942344021356, 3.3220476823975735],
            [-10.007242474967617, 3.1337723646646904],
            [-10.013437520958417, 3.091403348659782],
            [-10.067663375503251, 3.099025127996892],
            [-10.070758524146637, 3.098926857059707],
            [-10.153933148089273, 3.1102688247926493],
            [-10.16335239739199, 3.112363147647572],
            [-10.256036263351195, 3.1252436885990353],
            [-10.34855963881364, 3.1391822968128413],
            [-10.377241535326565, 3.1452218166728487],
            [-10.506837657521542, 3.165296477642414],
            [-10.53316231276618, 3.169913326128231],
            [-10.62280747701241, 3.184440520515068],
            [-10.751826998256716, 3.2055539859608855],
            [-10.72662032966022, 3.3626749712446173],
            [-10.711381273537787, 3.4576535933130446]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.54762916007998,
          "lat": 41.28764236242373
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56041"],
        "coty_name": ["Uinta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Uinta County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01605084"
      },
      "bbox": [
        -10.751826998256716, 3.091403348659782, -9.926912261881938,
        3.783579308070293
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.97652990669513,
          "lat": 18.147898197367667
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72129"],
        "coty_name": ["San Lorenzo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["San Lorenzo Municipio"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01804545"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5521807284203213, -2.160504943863495],
            [3.551590179317729, -2.119854048265811],
            [3.5511053985889243, -2.105678574765281],
            [3.5498773169600377, -2.0395193986293316],
            [3.549091496675444, -2.006618334017477],
            [3.5467023956818875, -1.8945782998721554],
            [3.546383908527352, -1.8624806832805427],
            [3.5593612798788707, -1.862170911944049],
            [3.5585898993769347, -1.818214378613535],
            [3.558203552827254, -1.7854939933984382],
            [3.5574781898089003, -1.7601579185415737],
            [3.5571507879832875, -1.7364281070616985],
            [3.555484840556328, -1.6581517233206926],
            [3.5556218817095595, -1.6542126481701875],
            [3.554232766701242, -1.5975053614912187],
            [3.639469304499424, -1.5945627849982107],
            [3.6818021865703745, -1.595398037994676],
            [3.7231874329708985, -1.5959687831013656],
            [3.782930919580227, -1.5940354213163905],
            [3.8290972511348427, -1.5921934653981726],
            [3.8691439601512405, -1.591407165879546],
            [3.8965572843508096, -1.5900324470216702],
            [3.9000523686879527, -1.6790837171172315],
            [3.9021592890393735, -1.750695765799255],
            [3.9019668734285267, -1.7516380244053316],
            [3.903162453150858, -1.7830167260100478],
            [3.9040870352627026, -1.800058137996866],
            [3.905122346469218, -1.8537189751852716],
            [3.8938405941705576, -1.8539293230057607],
            [3.8962959826188786, -1.9486883610191477],
            [3.8980647021461556, -2.0181479033736616],
            [3.899190100625063, -2.0365894112289387],
            [3.9037006111657275, -2.036531608517473],
            [3.906912119633469, -2.0993843107934005],
            [3.9085929650363544, -2.144512084199942],
            [3.865394620393409, -2.1467231711442354],
            [3.754573627449197, -2.1520545802237416],
            [3.659275022810363, -2.156494654250273],
            [3.5521807284203213, -2.160504943863495]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.88652810315943,
          "lat": 36.774016885559064
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29091"],
        "coty_name": ["Howell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howell County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00758500"
      },
      "bbox": [
        3.546383908527352, -2.160504943863495, 3.9085929650363544,
        -1.5900324470216702
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.54313555397091, -0.1238761178893973],
            [4.546628068924351, -0.10763557782213747],
            [4.5520566077654525, -0.10801067931229577],
            [4.557242117681866, -0.11156541784590379],
            [4.559642842417729, -0.11466000841045229],
            [4.556385954942689, -0.12004359131617943],
            [4.5590089266427505, -0.12110013473104797],
            [4.563638385749201, -0.11972680728429594],
            [4.566226300775191, -0.11732522737191337],
            [4.570612954212848, -0.11671338110472099],
            [4.574320602974943, -0.11841779232025905],
            [4.576301523967115, -0.1243216365470458],
            [4.580929405026319, -0.12830549668743604],
            [4.580681938256303, -0.13566890533926623],
            [4.583190709778173, -0.13576416645827044],
            [4.584586625970066, -0.13143828536214314],
            [4.588056705510803, -0.13046412355114745],
            [4.589648827391967, -0.13470150918921492],
            [4.587103500223761, -0.13791872052914536],
            [4.588753467712777, -0.1425635086637424],
            [4.599537141792751, -0.1390475964164832],
            [4.6067922005243425, -0.1312331910619828],
            [4.600859129229469, -0.10818699838847644],
            [4.604411155737125, -0.1003593501333606],
            [4.607570173508319, -0.09892330259155765],
            [4.613663711651569, -0.09865562514299056],
            [4.621349092082924, -0.10036982293002887],
            [4.625776371133614, -0.10826320127947701],
            [4.634304016218907, -0.1135917662431088],
            [4.6377018352850845, -0.11406255707656857],
            [4.645767275428296, -0.10522095848646104],
            [4.6501714453000735, -0.09067615557650983],
            [4.653425075398642, -0.08249869023767915],
            [4.714258949138632, -0.07931921531035845],
            [4.72955533424563, -0.07866004872081983],
            [4.753944488697892, -0.07711273671934922],
            [4.797234515116969, -0.0752308042196389],
            [4.795719499003809, -0.07961400728672255],
            [4.798002606075533, -0.08794800962590814],
            [4.796237565235845, -0.09275865328329468],
            [4.791306585728793, -0.09558484013147167],
            [4.786844041007775, -0.09290979908918216],
            [4.785669669237176, -0.09860186270162492],
            [4.791982358817496, -0.11363219700889102],
            [4.792802377325892, -0.11962176700314807],
            [4.797517031800865, -0.12383037189992767],
            [4.803864064640433, -0.12176093710053287],
            [4.807961289504101, -0.11719581925169752],
            [4.811249622168878, -0.12015457124792896],
            [4.811281278561706, -0.12501620677515426],
            [4.822422562133478, -0.12197893517355889],
            [4.8397772055128785, -0.11558247745246869],
            [4.851339090225556, -0.11779711296981299],
            [4.853605109544072, -0.11953943814095044],
            [4.854225549704243, -0.1248597450340384],
            [4.850693735402823, -0.13247513879016465],
            [4.846298945635079, -0.1375136457581231],
            [4.845793166083455, -0.1454380873299201],
            [4.8478940638335475, -0.15671648018481002],
            [4.847355793917164, -0.1686032010674915],
            [4.850697181173363, -0.17729496029424058],
            [4.85111442118287, -0.18240589535088222],
            [4.853504778182691, -0.18557780455818107],
            [4.848105631112614, -0.19678056928226967],
            [4.843561737549436, -0.21435288417152476],
            [4.8355386899822665, -0.2351619425953797],
            [4.833923220686725, -0.24203526263372135],
            [4.833214479240679, -0.25239526739376283],
            [4.834970423898263, -0.2715109535877468],
            [4.835324199091878, -0.28982364051456144],
            [4.8403952479311085, -0.315870266712001],
            [4.842604218805874, -0.3302147919096554],
            [4.849184655731353, -0.35142015487926814],
            [4.854217502565941, -0.3619145179609136],
            [4.870914104641868, -0.3851199333910735],
            [4.8806663043777325, -0.39297298717239154],
            [4.898038394028006, -0.398352669509214],
            [4.905886050843102, -0.40272978327938963],
            [4.918973787190335, -0.4149288062208373],
            [4.938096643429673, -0.44392209061555227],
            [4.935573839726664, -0.4456579391791221],
            [4.938861978756417, -0.45342052051499593],
            [4.933720812849285, -0.45779636378076033],
            [4.932006940976276, -0.46443715833636734],
            [4.925903086374952, -0.4650152487163404],
            [4.922855972283135, -0.46788193901242425],
            [4.917040758809229, -0.46989961235629335],
            [4.917096960350179, -0.47505750840751065],
            [4.910255311540648, -0.4820882639043313],
            [4.90897164182483, -0.4845285686882778],
            [4.900471189579481, -0.4846465812895041],
            [4.889813327275148, -0.482296018539469],
            [4.8866779220539405, -0.4803006126658578],
            [4.884256825054302, -0.48198402565576964],
            [4.880450973597394, -0.481230212051231],
            [4.8161395118107055, -0.5376887318205796],
            [4.815391800123718, -0.5373422570660455],
            [4.773209600602966, -0.5527973321474832],
            [4.688113042198471, -0.5843670101474376],
            [4.653000716790977, -0.5820694914841075],
            [4.655190719465234, -0.5768693773740097],
            [4.661688277735999, -0.5757619231268841],
            [4.664414508634327, -0.5720390755217484],
            [4.660920040868054, -0.5659069261805615],
            [4.6608860044711165, -0.5607183542061541],
            [4.6562607448099005, -0.5488993241579492],
            [4.656928794557332, -0.5461448592932557],
            [4.655887998814613, -0.5370809988036553],
            [4.657321258484721, -0.5318042168623562],
            [4.661043337436639, -0.5272319924078522],
            [4.661834203063511, -0.5185173397928107],
            [4.658894938054412, -0.5155133166261131],
            [4.6556962964110715, -0.5161396570162449],
            [4.6513401523752345, -0.5130922396276649],
            [4.645747914325461, -0.5154071167477425],
            [4.639817196067095, -0.5132258082303274],
            [4.631235569577015, -0.5093001267976461],
            [4.624597259072315, -0.508774713039311],
            [4.6221049148390385, -0.5044364799513023],
            [4.628448151176001, -0.5012406315434554],
            [4.630080350707656, -0.4980518415801988],
            [4.623786710478376, -0.49296487715153486],
            [4.620814241461231, -0.5029737579522426],
            [4.616044267772599, -0.5024821525136012],
            [4.609883267937016, -0.5043984309021136],
            [4.603445243605155, -0.5031833269052701],
            [4.604928916178894, -0.4994977837181665],
            [4.609445423949173, -0.4989969718077138],
            [4.61059977388663, -0.4961408716694301],
            [4.606104826836669, -0.48869119649616655],
            [4.59614412758973, -0.4775278008206048],
            [4.588184802956193, -0.467068765895893],
            [4.552739387256885, -0.42507606634953266],
            [4.534144122045491, -0.40369392332905424],
            [4.5236214777139745, -0.39068700925434047],
            [4.5272093756339755, -0.3482730633302067],
            [4.527213394261322, -0.3440313526056575],
            [4.535709278848681, -0.2626545823975072],
            [4.543416969205432, -0.1921417661708842],
            [4.5448753088605445, -0.1753294116438163],
            [4.54313555397091, -0.1238761178893973]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.53771767832218,
          "lat": 38.261056474373305
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29099"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00758504"
      },
      "bbox": [
        4.5236214777139745, -0.5843670101474376, 4.938861978756417,
        -0.0752308042196389
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5254847848329036, 1.6354222495471111],
            [3.57621818259336, 1.6362038754986146],
            [3.61094736375013, 1.637103915921896],
            [3.61316112599889, 1.6376743868242265],
            [3.6535889745721066, 1.6387431123506937],
            [3.6928608164415646, 1.6391021734887987],
            [3.698350511366608, 1.638862491695094],
            [3.7547202651585363, 1.6396616331383724],
            [3.765777857939828, 1.6402093630000636],
            [3.779204994820465, 1.64011390828852],
            [3.830459903763476, 1.6411939551549815],
            [3.86859017944043, 1.6423328831365749],
            [3.864333258079276, 1.636792688489646],
            [3.8622041313268407, 1.6294523933609997],
            [3.8640949137014933, 1.6249052551964172],
            [3.864453872334116, 1.617437208077517],
            [3.8628566409506395, 1.6085275560351713],
            [3.8629093966679307, 1.6022575773924472],
            [3.8650459340266674, 1.5928540001246043],
            [3.864905570331077, 1.58848613608457],
            [3.861012136165397, 1.5814235878519671],
            [3.8599426927089517, 1.5735655575501455],
            [3.861218511962758, 1.5629009751920677],
            [3.8646505839019563, 1.550162061231387],
            [3.862487311703056, 1.5393821324474748],
            [3.864477047860882, 1.5201915444577307],
            [3.8686913928895823, 1.5003271383505448],
            [3.873435320631655, 1.4832121693191063],
            [3.878524976196133, 1.4632503834704063],
            [3.8835343852312456, 1.4498380113739124],
            [3.8805433888484377, 1.4285055849962085],
            [3.8868824866677247, 1.4154224940115803],
            [3.8951846193165918, 1.4014675458094685],
            [3.9019455889699635, 1.3879870928122442],
            [3.9042790749325453, 1.3799435853058313],
            [3.9068138063289406, 1.3746023953523179],
            [3.9100553880752624, 1.3727846764881613],
            [3.914175366751072, 1.3643095512006675],
            [3.918138550197872, 1.3584107350383898],
            [3.920367253936828, 1.3526834563291577],
            [3.925070269422683, 1.3446234569990076],
            [3.9299770144224073, 1.3387773375910246],
            [3.8257632771741767, 1.335288754756096],
            [3.789662221898399, 1.3336234830033151],
            [3.7859536324804015, 1.3338828608892723],
            [3.6984276643087157, 1.330353906231873],
            [3.622595337422589, 1.3276503488170441],
            [3.537259896003982, 1.3251674668948732],
            [3.5360470608186074, 1.3571723282940225],
            [3.534661738312909, 1.4128170821739128],
            [3.531885127059009, 1.5003679035426953],
            [3.5311685116732887, 1.5303402496655045],
            [3.530777743163631, 1.5592007841751423],
            [3.5300504765687113, 1.5917933723741957],
            [3.526700336042832, 1.5918030042871536],
            [3.5254847848329036, 1.6354222495471111]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.72209305263902,
          "lat": 40.096874939616384
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29111"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00758510"
      },
      "bbox": [
        3.5254847848329036, 1.3251674668948732, 3.9299770144224073,
        1.6423328831365749
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.743163212350993, 0.7176862588500954],
            [3.742216609106267, 0.7606776219219563],
            [3.740725640264625, 0.8058105023244252],
            [3.7392706886536793, 0.879249837641266],
            [3.7359452005095597, 0.9800298696394389],
            [3.732627089462179, 0.980238808806254],
            [3.731039848632312, 1.024144450091386],
            [3.730755429002973, 1.0389445655375922],
            [3.7310775767340942, 1.045628550241444],
            [3.729985145403712, 1.0515667963415252],
            [3.729252773836164, 1.0680192415291863],
            [3.7823726562402364, 1.0698496628460916],
            [3.850237319571627, 1.0724032528449576],
            [3.979068322742386, 1.0786200882277959],
            [4.04067666556627, 1.0811084970478757],
            [4.044134513950896, 1.0759749195029316],
            [4.051000908326496, 1.0713991900522584],
            [4.059198557002044, 1.067125571915883],
            [4.064893520778404, 1.0629879821384307],
            [4.072474943020944, 1.0545079409810667],
            [4.07766756384566, 1.046714631410453],
            [4.086989200771313, 1.0389511840720436],
            [4.093291265308714, 1.028340458643759],
            [4.102832595987624, 1.0195084999361124],
            [4.112785409331229, 1.0142199423463731],
            [4.136711101811217, 1.0053185704197334],
            [4.143094594258435, 0.998646473982814],
            [4.123493145481856, 0.9978146322315464],
            [4.090920571215906, 0.9705312816902564],
            [4.089500710291059, 0.9687282228147496],
            [4.003602973939449, 0.8952101939934913],
            [3.997632683928292, 0.8918068397402241],
            [3.9652438874659715, 0.8648804114444983],
            [3.9586252106450415, 0.8598636395347043],
            [3.9471158021318447, 0.84950862708302],
            [3.9348666055631765, 0.8393586409286797],
            [3.9582275010575345, 0.7070775596969024],
            [3.938275979554393, 0.7069719487401381],
            [3.91171055147036, 0.7072503124673079],
            [3.871206445971137, 0.7068953227106108],
            [3.815534318677851, 0.7059201069928733],
            [3.74344582101566, 0.7029289791090978],
            [3.743163212350993, 0.7176862588500954]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.52204700827126, "lat": 39.52767575278965 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29173"],
        "coty_name": ["Ralls"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ralls County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00758541"
      },
      "bbox": [
        3.729252773836164, 0.7029289791090978, 4.143094594258435,
        1.0811084970478757
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.965011595353256, 0.2096840630645059],
            [4.959284970076758, 0.19717230670260663],
            [4.958718610621813, 0.1912701897807435],
            [4.9537147121427925, 0.1832751167300968],
            [4.947864621707431, 0.1789716097814435],
            [4.937811214214495, 0.1674328205027167],
            [4.9345619039731075, 0.16106376745499001],
            [4.933517289453165, 0.15280607706644747],
            [4.933821169727993, 0.1465526582994354],
            [4.936534286928691, 0.13761365901817463],
            [4.942506849814574, 0.12857022101866494],
            [4.9482712230345705, 0.12295394723375183],
            [4.955851329370354, 0.11046899686671123],
            [4.960746648213467, 0.09591029045367774],
            [4.964543500405751, 0.07862928533307567],
            [4.964534795040494, 0.06487034737514785],
            [4.96121987175742, 0.046863154059374225],
            [4.956357615242913, 0.033818694562132975],
            [4.948725493182158, 0.022932198970859217],
            [4.938360969572301, 0.012284749866983354],
            [4.932792155455626, 0.008202653360091185],
            [4.915553154014029, -0.023495259324542956],
            [4.909479740853947, -0.03675682041474942],
            [4.902306565072955, -0.034903328878191954],
            [4.898818990753908, -0.03064863738690166],
            [4.897301677374284, -0.021141063486829606],
            [4.883220807577486, -0.012984113258068334],
            [4.8772910233710585, -0.007983199564502417],
            [4.863500314419884, 0.0077794251258985325],
            [4.857214707453176, 0.022965119283362596],
            [4.863228604408884, 0.04765641455468355],
            [4.86414271544734, 0.05966487557212837],
            [4.865710943871412, 0.06336817726856458],
            [4.867200282850725, 0.07489225377610267],
            [4.8679328473189765, 0.08580850474571661],
            [4.902716351268751, 0.15184491937279485],
            [4.920465440117128, 0.16228817017408104],
            [4.9251580031813145, 0.1646221264890912],
            [4.931629930265086, 0.17110415940359022],
            [4.942766837625953, 0.18502586994358453],
            [4.9491190970650925, 0.19511373695915202],
            [4.9513386158499735, 0.20132031092330674],
            [4.9514229313597165, 0.21089222735273036],
            [4.965011595353256, 0.2096840630645059]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.24507000954559, "lat": 38.63583971757392 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29510"],
        "coty_name": ["St. Louis"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["St. Louis city"],
        "coty_fp_code": "510",
        "coty_gnis_code": "00767557"
      },
      "bbox": [
        4.857214707453176, -0.03675682041474942, 4.965011595353256,
        0.21089222735273036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.63518289263513, 7.48933715423407],
            [-6.577434619958929, 7.4832121290914335],
            [-6.504914846591234, 7.4755799191738195],
            [-6.432396667279096, 7.467932787626986],
            [-6.313215818645523, 7.455554041920471],
            [-6.263014856087097, 7.450491473884241],
            [-6.144819276309392, 7.438658428718995],
            [-6.026627742363775, 7.426785800918902],
            [-5.916177631883217, 7.41540966524951],
            [-5.795348723735435, 7.403442089196602],
            [-5.798369053740603, 7.372098624553857],
            [-5.802699729608737, 7.3231054944563745],
            [-5.819339837040623, 7.14941854209981],
            [-5.827478639363031, 7.06355987155915],
            [-5.831567652167512, 7.063944614951231],
            [-5.8401440370549595, 6.974283488009401],
            [-5.875730315522396, 6.977638160181929],
            [-5.884051614963775, 6.891638537041892],
            [-5.892340029936975, 6.8055842260749495],
            [-5.9092068232017585, 6.629466085449044],
            [-5.936166206469091, 6.632034488770491],
            [-6.001235845900673, 6.638263293955803],
            [-6.072261035538543, 6.645236085138587],
            [-6.143287549235818, 6.652195569808911],
            [-6.2335414134180684, 6.661276795770672],
            [-6.32379746858681, 6.670336521718875],
            [-6.427218950193593, 6.680772293068716],
            [-6.523952901629506, 6.690678569883938],
            [-6.5352102314776825, 6.685099155015122],
            [-6.603088205931691, 6.692187045860799],
            [-6.645973899326106, 6.696700893826201],
            [-6.770815138964442, 6.7103507446394515],
            [-6.750731346862004, 6.894100337353503],
            [-6.761951055829048, 6.8953138285146425],
            [-6.743253231285853, 7.065204624536539],
            [-6.712641173559178, 7.061912086773212],
            [-6.694333102589606, 7.21859321940954],
            [-6.679734993115528, 7.348898964715701],
            [-6.666348793646874, 7.460963813971559],
            [-6.6662118128319445, 7.4781116493135125],
            [-6.664859774640875, 7.492489238530061],
            [-6.63518289263513, 7.48933715423407]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.63018376627046,
          "lat": 45.394978127824984
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30075"],
        "coty_name": ["Powder River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Powder River County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01719584"
      },
      "bbox": [
        -6.770815138964442, 6.629466085449044, -5.795348723735435,
        7.492489238530061
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.988927099079139, 4.545178660239987],
            [-4.916047154231561, 4.539435344018847],
            [-4.858058365777025, 4.535082413133943],
            [-4.719073277746229, 4.524436129166684],
            [-4.623109631755891, 4.516997332879608],
            [-4.471905707957089, 4.505545249592367],
            [-4.485203638964493, 4.32806087497479],
            [-4.487731256993967, 4.290705746688189],
            [-4.473686602069827, 4.289805093208488],
            [-4.476110498129604, 4.254483213474969],
            [-4.476468664080028, 4.252965828992109],
            [-4.478823172167529, 4.218795988027631],
            [-4.4800624384537056, 4.204225029627523],
            [-4.485033436473, 4.129370140371987],
            [-4.48803580909829, 4.08832125786701],
            [-4.492126681531795, 4.029917152494703],
            [-4.494007317151683, 4.001173359543489],
            [-4.498427910296543, 3.9440882957668566],
            [-4.598936898254499, 3.9499519655265627],
            [-4.664663119504132, 3.9539909596932006],
            [-4.747567452314593, 3.959901730983039],
            [-4.74818475022582, 3.9600727711369075],
            [-4.847475529810951, 3.9675958112480414],
            [-4.883585124353938, 3.97039688221934],
            [-4.8933540524309835, 3.9708776600769013],
            [-4.9891864199355975, 3.9781102525246954],
            [-5.0153067774729685, 3.980152249992333],
            [-5.012970584912777, 4.00915473325526],
            [-5.009001908877503, 4.062336420797081],
            [-5.002298685975475, 4.146862380788175],
            [-5.002368028945824, 4.147971204599371],
            [-4.998371240591822, 4.20156368086399],
            [-4.993409506963384, 4.26010499506071],
            [-4.988041472515454, 4.327978162108628],
            [-5.004587942212453, 4.329286431295656],
            [-4.997766922484943, 4.423190397671976],
            [-4.9920577306599725, 4.5028506979208665],
            [-4.988927099079139, 4.545178660239987]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -103.1353880627207, "lat": 42.71974247097792 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31045"],
        "coty_name": ["Dawes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dawes County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00835844"
      },
      "bbox": [
        -5.0153067774729685, 3.9440882957668566, -4.471905707957089,
        4.545178660239987
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.274842519058915, 2.0539359645241726],
            [-2.2721214315515783, 2.0534776633456904],
            [-2.2589010936400764, 2.0545311193405844],
            [-2.2477225717548084, 2.050987134491036],
            [-2.2426036628408226, 2.047546063752543],
            [-2.2300611418815284, 2.0444495130173985],
            [-2.223305589434575, 2.044533080022512],
            [-2.211718487346887, 2.0473331732601068],
            [-2.197403744174853, 2.0462963146078335],
            [-2.1888860713188847, 2.040825271244108],
            [-2.17508499849563, 2.042242903571487],
            [-2.1661678465278023, 2.0397576441016283],
            [-2.1587252019899084, 2.0392117966202594],
            [-2.153383089069521, 2.0399651130561387],
            [-2.141197447582128, 2.0386484100322857],
            [-2.138615151024392, 2.0400088121145568],
            [-2.125543628183905, 2.0412900596702332],
            [-2.117132693668294, 2.03623205451089],
            [-2.1102398485630847, 2.03612064213085],
            [-2.105447873670749, 2.0334366867621214],
            [-2.101325783784079, 2.0300054771118226],
            [-2.095596844341877, 2.0314593247524253],
            [-2.0846738180502533, 2.0283648467827566],
            [-2.0822276911687045, 2.0284844436147584],
            [-2.074661189096144, 2.0257169178250893],
            [-2.059745105737175, 2.0287744385551845],
            [-2.056272634017214, 2.0304311396017587],
            [-2.046380968406597, 2.0300860841982873],
            [-2.041030659536062, 2.0317693651902564],
            [-2.030483178748273, 2.028817441768173],
            [-2.0200060581764943, 2.023821041194718],
            [-2.0121142947008717, 2.021899178815432],
            [-1.9994545382072153, 2.0204895076788674],
            [-1.991060834666708, 2.021280978376341],
            [-1.988155910860764, 2.022887831401668],
            [-1.9830650665737033, 2.021578711869593],
            [-1.9760872360533441, 2.0173713588344926],
            [-1.951653234209548, 2.017777112193713],
            [-1.9455767330975404, 2.0189578483246433],
            [-1.939584271119079, 2.016933615233927],
            [-1.9293582592687801, 2.017790759405447],
            [-1.9268810567020798, 2.016868735471779],
            [-1.9286123261563624, 1.968221624346185],
            [-1.9316331331560639, 1.8803223743513355],
            [-1.9347564268779238, 1.7852373636608556],
            [-1.9374519899915634, 1.7046346982704363],
            [-2.0228707116939226, 1.7074802478558866],
            [-2.108525499111581, 1.7104531694280898],
            [-2.1225837564470664, 1.7116505794647288],
            [-2.130425380728774, 1.7112867210839497],
            [-2.179483458561467, 1.7134751304054345],
            [-2.2020268534116796, 1.714195827943782],
            [-2.2514749422007165, 1.7163107677969909],
            [-2.277932337805775, 1.7172751617655133],
            [-2.286798345910538, 1.7176951199585409],
            [-2.2856717565250646, 1.7829586019900936],
            [-2.2831403709051976, 1.848739708264835],
            [-2.2820241688336163, 1.885329088238765],
            [-2.281255487839086, 1.8930766262043832],
            [-2.2758756351563294, 2.0244862626836695],
            [-2.274842519058915, 2.0539359645241726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.41455336455748, "lat": 40.51111044653864 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31137"],
        "coty_name": ["Phelps"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Phelps County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00835890"
      },
      "bbox": [
        -2.286798345910538, 1.7046346982704363, -1.9268810567020798,
        2.0545311193405844
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5957611416392, 1.6937336856413827],
            [-1.5935875062249956, 1.6936643043864172],
            [-1.5435053154288298, 1.6921508235248912],
            [-1.4218131841090484, 1.6889698883798534],
            [-1.3355969811487032, 1.6866132953093633],
            [-1.2569143416840396, 1.6847623539502514],
            [-1.2535014772841868, 1.6846927571985084],
            [-1.2564541067035386, 1.560418063496432],
            [-1.2588417180842633, 1.4655680487365474],
            [-1.2598723162174894, 1.4215590245073517],
            [-1.2608265624058221, 1.3938612884864898],
            [-1.2607623788846125, 1.3846879968940644],
            [-1.2622336008626902, 1.333940348971236],
            [-1.3516574641372912, 1.3360291838558345],
            [-1.4371035353891615, 1.3381468572272863],
            [-1.4796913481112588, 1.33922653531174],
            [-1.4907952529806652, 1.3397344369375004],
            [-1.5404885033310478, 1.3411110929224335],
            [-1.549436912209147, 1.3411099705563767],
            [-1.578104597953115, 1.3422215341784298],
            [-1.6054950400568102, 1.3426731995385888],
            [-1.6046316604616548, 1.3630891406953145],
            [-1.602718890626055, 1.4305335381756994],
            [-1.60277040454528, 1.4451207429599435],
            [-1.6018829089954774, 1.4594779328958638],
            [-1.598578174328173, 1.5766040938552783],
            [-1.597301959077656, 1.6347182756637932],
            [-1.5957611416392, 1.6937336856413827]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.49996722595236, "lat": 40.17643982543858 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31181"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "00835912"
      },
      "bbox": [
        -1.6054950400568102, 1.333940348971236, -1.2535014772841868,
        1.6937336856413827
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.681031300010808, 4.798109522578961],
            [16.680323508777807, 4.803427746411525],
            [16.676352620476496, 4.821786333326386],
            [16.673397089332017, 4.832645527424455],
            [16.672201958911813, 4.8499022750964516],
            [16.67024865523495, 4.860068105185413],
            [16.67028322832355, 4.864099492770184],
            [16.667350623404477, 4.874859626965955],
            [16.667039275564143, 4.891910030973688],
            [16.664881223679867, 4.897797311180882],
            [16.660464000420035, 4.906147009697314],
            [16.65855376112891, 4.921414667893169],
            [16.656787161692233, 4.939625122136484],
            [16.65484501900463, 4.945694435940978],
            [16.651957759989514, 4.960790243801453],
            [16.650619166752424, 4.963610304947317],
            [16.640409348379336, 4.974886022560759],
            [16.635792941486855, 4.991685460989904],
            [16.63502845074813, 5.004044955630368],
            [16.632603334980438, 5.015039812516682],
            [16.632321465709026, 5.019510535435531],
            [16.63004048777273, 5.024615038843844],
            [16.62915154835571, 5.031747383181159],
            [16.626355628047495, 5.039998026043562],
            [16.624264363852983, 5.051532205797008],
            [16.624659816704696, 5.057399126148698],
            [16.626849990024116, 5.063078115348297],
            [16.62714934247427, 5.069961627127995],
            [16.622932857444326, 5.079740863078211],
            [16.618875580269446, 5.084856174557153],
            [16.61049616378914, 5.092418411561494],
            [16.602581327364984, 5.100436672418896],
            [16.59814678804391, 5.112687590493336],
            [16.600929562630473, 5.11995581384939],
            [16.59920248237157, 5.135893896904899],
            [16.596817013602553, 5.150406533305867],
            [16.59635750476447, 5.1567456505592055],
            [16.596584580006038, 5.186139782233273],
            [16.595828701330696, 5.199843607697716],
            [16.596750469716643, 5.21425833851366],
            [16.59613903189409, 5.220001113459022],
            [16.591542837127335, 5.227509816363125],
            [16.590118983808228, 5.2334568045840975],
            [16.59065121168538, 5.240408306229099],
            [16.58928555391004, 5.245445434126232],
            [16.586901647358296, 5.262228158109402],
            [16.589041944058813, 5.266128527245],
            [16.58887569138554, 5.2733602101032755],
            [16.585533869926948, 5.276051955093801],
            [16.584821050770508, 5.279461705598304],
            [16.594341032273714, 5.279329985910206],
            [16.594392761867667, 5.283909088356255],
            [16.600293369588393, 5.283964241467205],
            [16.632380251069307, 5.276691099454491],
            [16.671954803761686, 5.267014427440382],
            [16.69409872774238, 5.2620225628704675],
            [16.722481139087428, 5.255018315351156],
            [16.758791788811276, 5.245094063644191],
            [16.787761038947597, 5.246427001136423],
            [16.810574604830663, 5.246634364256272],
            [16.875509397025652, 5.248486403215784],
            [16.897192406292795, 5.249790323298881],
            [16.890391324787277, 5.285316346633456],
            [16.88426398197324, 5.320944540667291],
            [16.901920907041287, 5.324884086481278],
            [16.908785599680986, 5.326495530562303],
            [16.91884406805214, 5.277801850167428],
            [16.926255707746787, 5.236696489705049],
            [16.932245621482036, 5.2008414479262175],
            [16.938026777407863, 5.171405045027219],
            [16.94336515701549, 5.137815086499317],
            [16.949370470775115, 5.1037205489001805],
            [16.960520052022826, 5.038750298302886],
            [16.964034506444346, 5.021210423359506],
            [16.973131628603234, 4.968304279908513],
            [16.977007195408202, 4.9477096743314934],
            [16.981753966840913, 4.9224801224831065],
            [16.986073773221555, 4.901393741387843],
            [17.001414169233936, 4.809460846525806],
            [16.96542962260436, 4.7999931294605265],
            [16.937316013638544, 4.788733756742172],
            [16.893583004339636, 4.769321575128414],
            [16.871589808843794, 4.760719505062175],
            [16.840556691659863, 4.749024226401417],
            [16.832904638851396, 4.745703723798693],
            [16.785370058432783, 4.728242256900201],
            [16.76677850314386, 4.720877941742464],
            [16.759956923110266, 4.718783686585572],
            [16.74083290513953, 4.711494340044618],
            [16.737076180536246, 4.709151564011363],
            [16.718720220882865, 4.702040998954289],
            [16.69563075264267, 4.6456475208262535],
            [16.69055540793444, 4.65063446878673],
            [16.680758857891984, 4.655866204172863],
            [16.67806949790758, 4.659729883292374],
            [16.675608490156336, 4.6782890037071825],
            [16.672965798953715, 4.68623341402198],
            [16.67226956555431, 4.701445623825295],
            [16.669057442642444, 4.7053252467795685],
            [16.666108299186423, 4.718778452473814],
            [16.665370460459407, 4.7249572088254945],
            [16.666305685905765, 4.732577314384762],
            [16.66670318194419, 4.744431477558071],
            [16.671313619407677, 4.759976069360751],
            [16.67523055431742, 4.768163168416919],
            [16.678454035757614, 4.772052987545695],
            [16.680873895558634, 4.77894939806643],
            [16.681978649862803, 4.79141343969158],
            [16.681031300010808, 4.798109522578961]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.74286928699944, "lat": 41.76516964106293 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36027"],
        "coty_name": ["Dutchess"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dutchess County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00974112"
      },
      "bbox": [
        16.584821050770508, 4.6456475208262535, 17.001414169233936,
        5.326495530562303
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.156592516790646, -2.653081901686929],
            [10.161146954917138, -2.6528047964672457],
            [10.163536003072787, -2.6553667975201143],
            [10.171665547166759, -2.664335928465796],
            [10.175854256501157, -2.666025189817304],
            [10.184210381176706, -2.663602417597421],
            [10.19404630854007, -2.6469867214740255],
            [10.198498137801835, -2.6449345781180833],
            [10.209760431523197, -2.6486319375480516],
            [10.215582622495193, -2.6461027034907016],
            [10.22033497284841, -2.645525752427679],
            [10.226897832945184, -2.647499607369558],
            [10.232161535963716, -2.652123886148625],
            [10.233284415759584, -2.656320687845168],
            [10.235831375932387, -2.6586501655001937],
            [10.245643732868754, -2.6537412712835633],
            [10.250967125456992, -2.651821032926743],
            [10.25816577128369, -2.6553344905950484],
            [10.26205311686995, -2.6525991842723156],
            [10.270221867233571, -2.6517230340289397],
            [10.27540779897136, -2.655755160488088],
            [10.280314090758779, -2.6571880852019714],
            [10.282624700929027, -2.6561790543474157],
            [10.283804501664653, -2.6507459265846034],
            [10.28291282037715, -2.6481598263130155],
            [10.286225745350464, -2.6446089958955903],
            [10.29053996651921, -2.647446763146912],
            [10.297848206074644, -2.6492211333473494],
            [10.30861481941957, -2.6541962983683582],
            [10.313919985668607, -2.653275901554113],
            [10.32309663070637, -2.6541184443685624],
            [10.329634560848323, -2.6520425061709356],
            [10.338016544331008, -2.6469007348491265],
            [10.341462608501217, -2.645949950095956],
            [10.351416041950719, -2.6491691437297593],
            [10.358012070723976, -2.649202109367228],
            [10.362243182485395, -2.646912589756493],
            [10.368430975541347, -2.648180687173347],
            [10.382063753256451, -2.6494155452273653],
            [10.385771141348991, -2.6509594323973644],
            [10.393408671612338, -2.651152574562357],
            [10.397777584757767, -2.6549636020292384],
            [10.40343673763925, -2.653282383059633],
            [10.406364931259182, -2.6571203235140493],
            [10.412108892281504, -2.6569265701213807],
            [10.413778298172147, -2.652168391325968],
            [10.41276847086309, -2.6450370906857508],
            [10.41393622931343, -2.640525207616804],
            [10.424367311220415, -2.6415852104818787],
            [10.429952227821817, -2.6450801004164077],
            [10.434319853600673, -2.6453319354997027],
            [10.438654524120157, -2.65126058656004],
            [10.442392398341507, -2.653562276536852],
            [10.450400887380614, -2.647802780899631],
            [10.453506289306855, -2.6474891792149773],
            [10.45852702953261, -2.643107335517664],
            [10.46086211253109, -2.6431557034217104],
            [10.462318658704415, -2.6531476296209395],
            [10.460328694910801, -2.659382470914846],
            [10.46333177893271, -2.659680651628933],
            [10.46407781980612, -2.6644180282468124],
            [10.46687301257713, -2.6679838270186047],
            [10.465051152201585, -2.6712366939898065],
            [10.464775468739145, -2.678224264966628],
            [10.462693944052168, -2.685927368369502],
            [10.461731944927816, -2.696236858640429],
            [10.462425239185944, -2.7020328497978046],
            [10.459376529158241, -2.708031773149636],
            [10.457094997008394, -2.709013810190925],
            [10.450770426781729, -2.72132804220033],
            [10.44872300783601, -2.7235759169358467],
            [10.447089936216457, -2.7321346157083126],
            [10.444768370182986, -2.736069648380446],
            [10.438163804300315, -2.738742494080031],
            [10.430624695720473, -2.7447867942275823],
            [10.426047021994831, -2.743824754518357],
            [10.420817772087025, -2.7479666870249555],
            [10.413962751530201, -2.750119082624889],
            [10.407906013568477, -2.7558809866318024],
            [10.407621401128104, -2.757716739792943],
            [10.400435512266371, -2.759409890664427],
            [10.396037359376992, -2.7641934747733776],
            [10.390664067275596, -2.7822675276636013],
            [10.390990134226012, -2.79181619194992],
            [10.395494473646437, -2.7944930463330326],
            [10.403519306444661, -2.8029045800096393],
            [10.405454067257272, -2.8083753601949453],
            [10.402799983663373, -2.8118016400154744],
            [10.402786702109848, -2.814933913931935],
            [10.39780241640243, -2.8260062000335933],
            [10.396686590778815, -2.831622707361013],
            [10.392681250975059, -2.8376889128663363],
            [10.391513654986758, -2.8416100730721308],
            [10.390529446967442, -2.8385294044436327],
            [10.381890684083523, -2.833485351833802],
            [10.377936659374164, -2.838498502992424],
            [10.374953075056343, -2.839051263098144],
            [10.366545721435797, -2.848379016676453],
            [10.35756655377228, -2.8493238801080496],
            [10.349798217859904, -2.852491326732432],
            [10.345655204483297, -2.849004227718409],
            [10.33972493517483, -2.848623030875172],
            [10.335147557007424, -2.8516334415721643],
            [10.326355955308983, -2.845592519940096],
            [10.322495796342015, -2.8461090271023304],
            [10.320149858460145, -2.8434138236309043],
            [10.316081566464492, -2.8422308822198428],
            [10.312145731394953, -2.8456590136405073],
            [10.305589466254789, -2.848657503171456],
            [10.30171614549134, -2.8468401997839337],
            [10.295360795105815, -2.8521513643675576],
            [10.287136420114185, -2.8473255195294436],
            [10.279460424755309, -2.850132425950609],
            [10.276233618219978, -2.8496215052187615],
            [10.272247432511522, -2.855988407318029],
            [10.264725672301573, -2.8577814307358334],
            [10.255123314122773, -2.8635274953379093],
            [10.25064605530054, -2.86992222229549],
            [10.240392867882637, -2.8765629409874123],
            [10.23332828164214, -2.8721927644500735],
            [10.231885179047053, -2.875608146457494],
            [10.219991492365581, -2.8833695299061977],
            [10.214788843900273, -2.8851373920307486],
            [10.208653472468132, -2.891023331907087],
            [10.201485994309024, -2.8923824938007217],
            [10.199657986383, -2.8953808123696683],
            [10.196040067941516, -2.894655233633975],
            [10.189673902715215, -2.8996109934693917],
            [10.183048705876557, -2.899490719449793],
            [10.175181746847061, -2.8967663099625938],
            [10.172560859516823, -2.892538285553363],
            [10.166056629565693, -2.888465973666052],
            [10.156944450220415, -2.8883606164119695],
            [10.151157181850309, -2.884806590483495],
            [10.148461614740832, -2.8796814543985803],
            [10.151867488585616, -2.871186232621031],
            [10.150779160935755, -2.8681830087581948],
            [10.147439207625615, -2.8682213880405087],
            [10.142803628011084, -2.864681351825756],
            [10.141773291514934, -2.8484842603256895],
            [10.135955395232891, -2.846133593927395],
            [10.132851175751117, -2.842909991317525],
            [10.129785298076518, -2.8361156439896367],
            [10.123854140439285, -2.8315093044857607],
            [10.127873376555074, -2.8273500959948596],
            [10.128848831078841, -2.8215391611379497],
            [10.123754274975395, -2.814160232911436],
            [10.116590903749097, -2.812323843573903],
            [10.115455041068282, -2.80657674598984],
            [10.118423011923053, -2.7905461826435567],
            [10.116492073619067, -2.7874985697801344],
            [10.112386941275817, -2.786762181189152],
            [10.113521399041646, -2.781441879131894],
            [10.109391886375612, -2.7768427719516495],
            [10.110176830729314, -2.773839721662089],
            [10.11348735892887, -2.7714690594935734],
            [10.120508108954708, -2.7689325393491444],
            [10.1258416620683, -2.7574388880820893],
            [10.131021629049197, -2.749882743982869],
            [10.129526671833217, -2.742736261074151],
            [10.12650350583267, -2.737532465353998],
            [10.128146897502939, -2.7312295458581124],
            [10.122478225642627, -2.7244307041563913],
            [10.119107050229045, -2.723537019511672],
            [10.115735002640498, -2.7187832889721513],
            [10.113755078996006, -2.71344593312241],
            [10.11497346950752, -2.7108538033308105],
            [10.12019551003773, -2.710295293918181],
            [10.130790649246212, -2.69457143039077],
            [10.13192386273034, -2.6866857600553273],
            [10.134622254537408, -2.6819710902221265],
            [10.141555509737467, -2.676737953943203],
            [10.14482217440471, -2.670766000543277],
            [10.148870402740974, -2.6691331100971967],
            [10.149373793107578, -2.662745899383807],
            [10.154315098204794, -2.6618596377298864],
            [10.156859591743165, -2.657373599443206],
            [10.156592516790646, -2.653081901686929]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.8334738234789, "lat": 35.350147756070626 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37075"],
        "coty_name": ["Graham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Graham County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01008555"
      },
      "bbox": [
        10.109391886375612, -2.8996109934693917, 10.46687301257713,
        -2.640525207616804
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.079924203043715, -1.9609567992143544],
            [15.10281126455197, -1.9576398327998554],
            [15.164585463269113, -1.9359393934016937],
            [15.165927754157952, -1.941418171486084],
            [15.169321653795738, -1.9465936224044325],
            [15.172789916310679, -1.9474009222740845],
            [15.1729455126395, -1.9507595340997892],
            [15.179162642796747, -1.9563303484527519],
            [15.18191470084128, -1.9606546487094527],
            [15.184767479376339, -1.9623931169695312],
            [15.191544034453315, -1.9597795944866958],
            [15.195365044579601, -1.9557772069154111],
            [15.200612953359418, -1.9527214580076746],
            [15.204481803562977, -1.953431749123573],
            [15.207975131975362, -1.9498890944083407],
            [15.216724309312287, -1.9490223471062922],
            [15.219224444002318, -1.9415883373657485],
            [15.222558689894361, -1.934909378751625],
            [15.23012234234963, -1.9253144724709421],
            [15.230437346776847, -1.9225978712981557],
            [15.23595020654399, -1.9195312082359257],
            [15.239762160871903, -1.923237570969966],
            [15.24588065535183, -1.9216081480866942],
            [15.251048862399701, -1.9224640735084506],
            [15.25358834178036, -1.9158657852209944],
            [15.260228450380083, -1.9142653115014034],
            [15.263224414247425, -1.9112328941969132],
            [15.26842256538739, -1.9084235770215296],
            [15.270516972316262, -1.9047580150689651],
            [15.285227486604814, -1.8929768408610101],
            [15.290045865028736, -1.8897942810327142],
            [15.291262542692909, -1.8860784054446789],
            [15.289850558714331, -1.882905207815823],
            [15.292293094388878, -1.8778978344618933],
            [15.291509001869066, -1.8728252600461182],
            [15.297309070355334, -1.8714702239004357],
            [15.297928011328741, -1.8691501294423758],
            [15.304722884825866, -1.8628443278126823],
            [15.312292368460497, -1.864532130328335],
            [15.317026044275284, -1.8696590237290482],
            [15.320331201001968, -1.8698513799831902],
            [15.326891222774481, -1.8665435097489547],
            [15.32862539748876, -1.864338086571965],
            [15.326041943458812, -1.8573292656817675],
            [15.330967056888321, -1.852390325240478],
            [15.333365471413844, -1.8528791098966466],
            [15.336728692286439, -1.8581716451549513],
            [15.336225073346492, -1.861098591643616],
            [15.338065988908953, -1.86834935935283],
            [15.34493223047738, -1.8728957133940973],
            [15.345826407053659, -1.877236440068082],
            [15.350961269391714, -1.8790849488631236],
            [15.359009605094856, -1.8850341756447628],
            [15.355240813958595, -1.8898643453721518],
            [15.360271677178286, -1.8934802408006515],
            [15.363340910199923, -1.892850102606889],
            [15.362352365736902, -1.8999966221358648],
            [15.363422646215303, -1.9026291008786933],
            [15.370821647021097, -1.9058689942275446],
            [15.37608521857767, -1.9037130363697152],
            [15.382509904480058, -1.9112148884737645],
            [15.384908961876764, -1.920768895680486],
            [15.38894600742497, -1.920944503500126],
            [15.38932831567895, -1.9175992683762269],
            [15.394991137079515, -1.916775406192548],
            [15.398667416111525, -1.9143329804736122],
            [15.402949314972293, -1.9175470894437399],
            [15.41323185413117, -1.9194001804572574],
            [15.415008211661553, -1.925319297793614],
            [15.41104589325187, -1.9225162480057687],
            [15.401077965076995, -1.9282087653853779],
            [15.400800362467924, -1.9329168303701305],
            [15.398408625193795, -1.9373742898250603],
            [15.38500106200429, -1.941233976254997],
            [15.3884240533924, -1.957846341010485],
            [15.382834480282742, -1.9601880284584436],
            [15.382725418947162, -1.9687696805013373],
            [15.37629044836515, -1.9717238076609451],
            [15.376377913876128, -1.9741545403043141],
            [15.380043317896089, -1.9795883219915098],
            [15.385993744372179, -1.9823915533841674],
            [15.386453076484813, -1.9874588557441173],
            [15.3902665971595, -1.9945021886787155],
            [15.39607097386683, -1.999318244453136],
            [15.40224569282235, -2.007150003524696],
            [15.402882474150045, -2.0137102900386643],
            [15.39955733256697, -2.020217580268329],
            [15.389666480353782, -2.0258703801361615],
            [15.376496882476506, -2.036100556083714],
            [15.37635112064618, -2.0407914999109957],
            [15.370946343220963, -2.0455101377506058],
            [15.371036372616167, -2.047628671220733],
            [15.325808763135896, -2.042137558575135],
            [15.355161463567752, -2.108472434172034],
            [15.300245320374593, -2.2234658364642415],
            [15.209100599941683, -2.3061824984439485],
            [15.194400125770363, -2.2944595490711346],
            [15.174976738498065, -2.2096594292971012],
            [15.152259730480525, -2.176114632713183],
            [15.094288988496604, -2.154211467229389],
            [15.086306343979725, -2.098659736128605],
            [15.070477343097378, -1.9884015820232033],
            [15.072663308533688, -1.9792432806235716],
            [15.07272903812936, -1.974045376164896],
            [15.074483507770738, -1.9695023165784515],
            [15.079924203043715, -1.9609567992143544]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.6412530822647, "lat": 35.2387883137748 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37107"],
        "coty_name": ["Lenoir"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lenoir County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01008568"
      },
      "bbox": [
        15.070477343097378, -2.3061824984439485, 15.415008211661553,
        -1.852390325240478
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.781060044285436, -0.8103563207295728],
            [14.884554671328482, -0.789560014496757],
            [14.898140271204092, -0.7868110483209715],
            [14.979522843167071, -0.7711288850206726],
            [15.113197651571857, -0.7451692479095163],
            [15.192651291263486, -0.7296209117850849],
            [15.251866393202851, -0.7179755930715447],
            [15.323472582710401, -0.7038278213103734],
            [15.334847787968851, -0.6999180638597761],
            [15.350625644734434, -0.6955675079522897],
            [15.354953579577684, -0.6957382625548776],
            [15.355514755459641, -0.6975501563143409],
            [15.36235742500513, -0.7007133889509883],
            [15.363949840943626, -0.6991527675246878],
            [15.368447940611048, -0.7029904189259184],
            [15.368686839265587, -0.7115913666027551],
            [15.371681299939732, -0.7142823785309338],
            [15.381588244786046, -0.7134644642933029],
            [15.385347255025152, -0.7141767043122117],
            [15.389568421835335, -0.7177900966236307],
            [15.393430503391627, -0.7122835361420834],
            [15.398062338548273, -0.7120461747804542],
            [15.3995041940657, -0.7156213950611308],
            [15.404597116570013, -0.716191842513486],
            [15.414429193931063, -0.7144909477103873],
            [15.416062133784205, -0.7123669484224228],
            [15.423117649150404, -0.7151324470137616],
            [15.425797961736341, -0.7173516698900833],
            [15.426383641059054, -0.7218252983155169],
            [15.42487405122683, -0.7243077063622911],
            [15.425786192673545, -0.7292046070188102],
            [15.43095349153562, -0.7318705803804508],
            [15.437119152281891, -0.7295349699577134],
            [15.441708943440517, -0.7344876583504684],
            [15.440433317698286, -0.7371754534702857],
            [15.442875319692336, -0.7418222186463493],
            [15.441498173537314, -0.7466847874364704],
            [15.438426528474832, -0.749095430068689],
            [15.434442752489359, -0.7491608203268985],
            [15.434007347133507, -0.7536240798097433],
            [15.430985225400324, -0.7535107152427197],
            [15.426676484826807, -0.7580741812407876],
            [15.42339049381812, -0.757155925011571],
            [15.421255007632446, -0.753834019457373],
            [15.41501347835096, -0.7547106341909013],
            [15.412880908643897, -0.7567166646014754],
            [15.40914498136381, -0.7555188081779178],
            [15.408225063165183, -0.7595890265896477],
            [15.404349157011035, -0.7602745749413947],
            [15.402218126194144, -0.7635494726647539],
            [15.40087544474445, -0.7712918403706167],
            [15.396690845019341, -0.7759268634774423],
            [15.394226716918684, -0.7814614114116977],
            [15.39632332104128, -0.7891294620468811],
            [15.401504889573983, -0.7945306331680204],
            [15.402315180471259, -0.7979115799985199],
            [15.389429121794265, -0.9249517357785312],
            [15.383169152929907, -0.9768709866441095],
            [15.379979108108516, -0.9992771158908302],
            [15.369833017934345, -1.0313535142133725],
            [15.370299411789398, -1.0343314170590365],
            [15.36511500502537, -1.0358100330801565],
            [15.358753381494957, -1.0359757018481286],
            [15.35493046102772, -1.0338107979518085],
            [15.349148474088802, -1.0343703221249896],
            [15.342233667524292, -1.037080142208368],
            [15.338949131422245, -1.0414398329164738],
            [15.333339872694502, -1.041804042409498],
            [15.321271049818343, -1.0479851217369978],
            [15.317307419020203, -1.0518038327636938],
            [15.319059404305202, -1.0569848287896317],
            [15.323228559445937, -1.0612455437443047],
            [15.322100423453167, -1.0656083171217305],
            [15.323616203711842, -1.069893700645097],
            [15.321074338759004, -1.0733383169329893],
            [15.321346676015793, -1.0780618948283107],
            [15.32541497151814, -1.0830723070129955],
            [15.324951836176204, -1.0864874026283489],
            [15.330355238042138, -1.0897126380768392],
            [15.327936050284107, -1.0928642827474537],
            [15.323177846061876, -1.0944259536141958],
            [15.31665306046636, -1.092611097512208],
            [15.312695770717154, -1.089252386525345],
            [15.312209236875015, -1.0852589801590788],
            [15.31416500621741, -1.0802028552745182],
            [15.307441964421416, -1.081024156536507],
            [15.299853025031242, -1.076631453131929],
            [15.296807037764317, -1.072146168560909],
            [15.293039028888087, -1.0721909988098202],
            [15.288932919626271, -1.0756048363028272],
            [15.279157362966822, -1.076041875016562],
            [15.2711826500612, -1.0707428360397178],
            [15.261550981806847, -1.068252811101359],
            [15.250115738199728, -1.0638600865178744],
            [15.246895256392033, -1.059794883315386],
            [15.247685488827361, -1.045701826124038],
            [15.249840857954023, -1.0375686616666304],
            [15.249198604163885, -1.029072738811143],
            [15.244609958224016, -1.0234990399007518],
            [15.237570023660089, -1.020587520043698],
            [15.22263744071065, -1.0155542648032785],
            [15.217289981551302, -1.0110022060966162],
            [15.213373176092748, -1.0011744808156084],
            [15.212762464464639, -0.9943978604698808],
            [15.209404656411385, -0.9849932485555777],
            [15.202538271249646, -0.9800376157804453],
            [15.196020948526387, -0.9726964597670814],
            [15.18813805314884, -0.9657968867062503],
            [15.185395104935889, -0.9607630674543924],
            [15.178604887592519, -0.9587651718557314],
            [15.1704333217955, -0.9627537608538294],
            [15.163178275858233, -0.9648278330141724],
            [15.155765932610834, -0.9713312019551071],
            [15.151030486040128, -0.9726823086563032],
            [15.147932720982661, -0.9755257965583988],
            [15.143296334031154, -0.9827184674363884],
            [15.134318679160094, -0.9857008418497689],
            [15.122271697103951, -0.9883657000414723],
            [15.108253510543898, -0.9948826616617755],
            [15.103932076247775, -0.9957468053956156],
            [15.095977267496119, -0.995296351614291],
            [15.082429365282529, -0.9888257410609329],
            [15.077985214023663, -0.9798394813833652],
            [15.073645609624819, -0.9740004935852741],
            [15.067315807981592, -0.9700596650778456],
            [15.066775946895975, -0.967975805885687],
            [15.068746925899836, -0.9544935074243677],
            [15.073389308596399, -0.9454030155820925],
            [15.079718429472587, -0.940241135947763],
            [15.08402967806866, -0.9326216603576156],
            [15.088201929460528, -0.9300138742309803],
            [15.089868907569029, -0.9258246088909042],
            [15.08798506489826, -0.9056412156700008],
            [15.079334066277617, -0.8866563214973034],
            [15.074826460102859, -0.8834687024620591],
            [15.060180756944032, -0.8811795205554959],
            [15.053575265559227, -0.8813044432886507],
            [15.049689719908143, -0.884212499445323],
            [15.046153320428516, -0.8818831163577932],
            [15.04353281899429, -0.8758037281597929],
            [15.039389881310566, -0.8738697634135942],
            [15.028660980296086, -0.8732077402740317],
            [15.02204056110231, -0.8669343692938459],
            [15.018270830970735, -0.8686198662795941],
            [15.010023896280984, -0.8634663871611736],
            [15.001569819880094, -0.8462737267034833],
            [14.99783463612292, -0.8398859180355851],
            [14.993069750133316, -0.8354509406533698],
            [14.989310838892454, -0.8348878949133169],
            [14.98005129511492, -0.8390455393024481],
            [14.974016558625273, -0.8394024861890163],
            [14.97097947733977, -0.8410548134425523],
            [14.964527166294653, -0.8421075095777174],
            [14.956932142187076, -0.8418491322077519],
            [14.9458171527038, -0.8402409137039791],
            [14.940700421943914, -0.8386299766829224],
            [14.92436070519817, -0.8424286164253066],
            [14.916331505407152, -0.8507785783546541],
            [14.913899204543538, -0.8521903928325413],
            [14.906091118029265, -0.8532176424686192],
            [14.900600859046342, -0.8516704774410766],
            [14.896518462954283, -0.8544541070800032],
            [14.891421922270524, -0.8537460173420772],
            [14.877780952740578, -0.8466103870676303],
            [14.87191229858869, -0.8463531799114898],
            [14.864065944590642, -0.8431022285709309],
            [14.852651535642329, -0.8417466120332282],
            [14.840549513939042, -0.8435965352034818],
            [14.820751223113586, -0.8417779765612774],
            [14.815690640708445, -0.8459569529368909],
            [14.806985101603802, -0.8449987380627546],
            [14.799995557046705, -0.8460051553167293],
            [14.795897478642102, -0.8422271216063332],
            [14.792764578986977, -0.8417066608053367],
            [14.78897419681389, -0.8503664257486883],
            [14.783047504885674, -0.8219640158614694],
            [14.781060044285436, -0.8103563207295728]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.39693321631455,
          "lat": 36.417744282411704
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37131"],
        "coty_name": ["Northampton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Northampton County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01008575"
      },
      "bbox": [
        14.781060044285436, -1.0944259536141958, 15.442875319692336,
        -0.6955675079522897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.730932498144686, -2.5959029431395697],
              [15.733706973658705, -2.5927752211963164],
              [15.747334398325517, -2.581441772414437],
              [15.763957041508212, -2.570065882827932],
              [15.76658813584876, -2.5658402067592534],
              [15.775817875986945, -2.566876962975924],
              [15.770467464100609, -2.574736358827881],
              [15.757839679895831, -2.581340192216299],
              [15.749305742279194, -2.5869120692552245],
              [15.733257848455473, -2.598812230800488],
              [15.730932498144686, -2.5959029431395697]
            ]
          ],
          [
            [
              [15.689147551178895, -2.632238794597171],
              [15.69360102838686, -2.6291782113141275],
              [15.695525335133043, -2.6261414054634944],
              [15.708595979085974, -2.6135597044168892],
              [15.712292463582957, -2.6122567101631216],
              [15.723860887166268, -2.6024641240049045],
              [15.724571624223474, -2.6052154122787403],
              [15.708899258827657, -2.617437185776194],
              [15.692152611785117, -2.6334067349123575],
              [15.689147551178895, -2.632238794597171]
            ]
          ],
          [
            [
              [15.260531819779505, -2.331317122726192],
              [15.287064223466535, -2.3152934710152606],
              [15.345147564973816, -2.311163373536112],
              [15.398506533347009, -2.308650083115936],
              [15.518908772100263, -2.347493459411218],
              [15.51725839396444, -2.3325138584372254],
              [15.52267677235552, -2.3256605006355375],
              [15.531686967109819, -2.322538499987769],
              [15.533791654280131, -2.31800455364389],
              [15.540991390188617, -2.3117723357638353],
              [15.548540421142636, -2.3145318736023555],
              [15.556710490271435, -2.315330065817982],
              [15.558989514192492, -2.3098695463647796],
              [15.563675879073665, -2.3122676381078193],
              [15.568872073171638, -2.311656112127318],
              [15.572132721155155, -2.3144959735036266],
              [15.575961566384054, -2.312497986128037],
              [15.581196866035846, -2.3151864893994865],
              [15.5945742657545, -2.3148274878795685],
              [15.597761713554808, -2.320293128017246],
              [15.600367564687673, -2.3210020537848726],
              [15.603657189851988, -2.3255161465886993],
              [15.603743944038065, -2.3296080286404086],
              [15.609060295087751, -2.327431770713374],
              [15.61118206571425, -2.3334129081846298],
              [15.615050281848676, -2.3371370055503573],
              [15.62440621953354, -2.337003343551343],
              [15.623940086188334, -2.341851115447746],
              [15.629552586799536, -2.343605552232941],
              [15.629072945582204, -2.348484812142289],
              [15.631461851728686, -2.3491427466652977],
              [15.635946937730274, -2.346084954538624],
              [15.646021489572261, -2.3590058365152595],
              [15.643733337031449, -2.360795356929843],
              [15.647051437787745, -2.3659086134281573],
              [15.653838952516589, -2.371876012125349],
              [15.653897848904492, -2.377936180604323],
              [15.659947331237936, -2.381768635517354],
              [15.664791803486585, -2.3878457952276055],
              [15.664971203349513, -2.394277395463701],
              [15.672450582401492, -2.3956905645696605],
              [15.675855407225406, -2.3935739057920986],
              [15.680176102393567, -2.3887383761874594],
              [15.683940408366958, -2.395457585989966],
              [15.680975292418886, -2.3994584318945025],
              [15.680504317715943, -2.406471532656467],
              [15.676087721075127, -2.4131364781896774],
              [15.674919523721348, -2.418409541344868],
              [15.680894104806336, -2.4204884585385815],
              [15.682563706172735, -2.4242301806297792],
              [15.694172683998229, -2.4287518189197153],
              [15.695782233315578, -2.436288826984781],
              [15.700013239681201, -2.4394775757511016],
              [15.703559261412332, -2.437660630747437],
              [15.703995582333492, -2.4416545610326215],
              [15.706914372556643, -2.4429617311084857],
              [15.709488222679399, -2.4395896411092584],
              [15.718367803809157, -2.4498287877041944],
              [15.713713736349312, -2.4511175730079193],
              [15.715257055573765, -2.4554040561005896],
              [15.720574098021105, -2.4513124871930376],
              [15.725814794503798, -2.453677708050221],
              [15.729380430876592, -2.4584661891363813],
              [15.731763155221314, -2.4529841240654924],
              [15.736476316251965, -2.4578849871987973],
              [15.740123555783004, -2.458311997993011],
              [15.742429408260616, -2.4613463749847675],
              [15.743659315672444, -2.4694246858208673],
              [15.749488191429615, -2.483408454304452],
              [15.757346859418973, -2.489501737465593],
              [15.762311387145305, -2.4948656253397186],
              [15.76545931817913, -2.4999320984454525],
              [15.770120279559222, -2.517094519655798],
              [15.768862506690057, -2.524916488139848],
              [15.765934047800975, -2.5299386808912807],
              [15.762148409280577, -2.526666958660241],
              [15.755447636476944, -2.529776562426428],
              [15.749169404696062, -2.536424412883899],
              [15.748423831223906, -2.5399031545540476],
              [15.751721760607705, -2.543353339487034],
              [15.748878164494062, -2.546470693055758],
              [15.741485037543637, -2.5485433273736247],
              [15.735913204148426, -2.5515225639318047],
              [15.738837890532006, -2.554559065725901],
              [15.738258096857907, -2.55790657591896],
              [15.731688547015924, -2.5669620024783675],
              [15.724275873453605, -2.5742274282253046],
              [15.720824265153865, -2.5788241576477153],
              [15.710663512076133, -2.586651805827796],
              [15.702633561244163, -2.5935919897438526],
              [15.699107399723518, -2.604539837309632],
              [15.6902043876679, -2.617881158398959],
              [15.68039780546112, -2.6289134598757817],
              [15.679128535810793, -2.632592297236317],
              [15.681657064760598, -2.638035946907671],
              [15.687492641004656, -2.6381445513967257],
              [15.670415024993925, -2.6570930011825875],
              [15.66448081908598, -2.664160515143601],
              [15.65633359821271, -2.675290390933872],
              [15.638168040408411, -2.697144754512061],
              [15.625417795255705, -2.7101780285847146],
              [15.617792796106032, -2.7156455939339468],
              [15.613945715753507, -2.717125582791789],
              [15.611748788175444, -2.72270576608969],
              [15.56423713564096, -2.7618355748873427],
              [15.527659092334046, -2.794789267770997],
              [15.50720337398346, -2.814274862308469],
              [15.489098938752676, -2.8336653982271023],
              [15.47484244422138, -2.8196615868663555],
              [15.464201288905421, -2.8155936014754914],
              [15.455800306362857, -2.8090518249613106],
              [15.451484874033696, -2.8118106029127112],
              [15.443614358936362, -2.812682836989602],
              [15.44010432520886, -2.8108112281622337],
              [15.43883888840617, -2.8065702819900675],
              [15.436366565830392, -2.8052276517325465],
              [15.386262580190039, -2.7151738490224764],
              [15.380250753007182, -2.7049789474331565],
              [15.351526150506608, -2.6577706600521664],
              [15.319711422655033, -2.6059775962554808],
              [15.305219864480684, -2.5826216039940384],
              [15.293861716408832, -2.5191964291309947],
              [15.292413780642143, -2.5040055707161177],
              [15.293459708705504, -2.4627157562911055],
              [15.289205316779642, -2.3774395327523163],
              [15.284093792124393, -2.360974642491513],
              [15.256857606904262, -2.3348664584299224],
              [15.260531819779505, -2.331317122726192]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.43217345218176, "lat": 34.73223214284139 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37133"],
        "coty_name": ["Onslow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Onslow County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01026341"
      },
      "bbox": [
        15.256857606904262, -2.8336653982271023, 15.775817875986945,
        -2.308650083115936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [7.2878878232225865, -7.944402146601031],
              [7.293979382432131, -7.937602601231853],
              [7.2993611557442515, -7.93008443707207],
              [7.302289020734974, -7.928285065777283],
              [7.307566592947193, -7.930155687656398],
              [7.310342752658696, -7.932951508654054],
              [7.3146884369599485, -7.956529262927261],
              [7.312033708289434, -7.958212428455198],
              [7.295511940760932, -7.949543626414253],
              [7.2878878232225865, -7.944402146601031]
            ]
          ],
          [
            [
              [7.123224871698528, -8.12902060694237],
              [7.125428523659855, -8.126800817634882],
              [7.125904020721598, -8.119925552237865],
              [7.122589409483558, -8.11758834192451],
              [7.125863842761885, -8.111421005794028],
              [7.127091588645279, -8.117357856795465],
              [7.1302095389848335, -8.12624518897603],
              [7.1306661870925945, -8.132470822218039],
              [7.129533670207267, -8.137311424824329],
              [7.125667659395956, -8.136232912303704],
              [7.123224871698528, -8.12902060694237]
            ]
          ],
          [
            [
              [7.075560911775494, -8.237494624045322],
              [7.0815434440272025, -8.234874287430856],
              [7.087678012574355, -8.235086497849126],
              [7.099133770121533, -8.233684397044833],
              [7.116532086108303, -8.228959729880243],
              [7.134039564435848, -8.223131310798879],
              [7.162570453034738, -8.214889259382495],
              [7.182006537046824, -8.207719642571863],
              [7.1901120248082995, -8.207985559729504],
              [7.194980568184189, -8.20664370089538],
              [7.215830041352343, -8.202754287679095],
              [7.222919271240685, -8.20240379493539],
              [7.233539103854541, -8.199684114586425],
              [7.241985471145301, -8.191926808891713],
              [7.246117125339017, -8.180230226998166],
              [7.251654874048384, -8.174220358663232],
              [7.27983009336693, -8.191058841460597],
              [7.291002714945477, -8.200824712154768],
              [7.2903900860672275, -8.203839898148084],
              [7.276378956570399, -8.207521328955654],
              [7.261807274910842, -8.208993321824678],
              [7.249992320156642, -8.205775690549766],
              [7.2368910724860065, -8.204750940472351],
              [7.22650457255433, -8.205270388141864],
              [7.211932214768624, -8.206701832074675],
              [7.183719380829434, -8.210951181788298],
              [7.154116316537511, -8.219803991721294],
              [7.132753358229165, -8.226655532299567],
              [7.0950824630497245, -8.237770003241845],
              [7.076476062462091, -8.238832480687174],
              [7.075560911775494, -8.237494624045322]
            ]
          ],
          [
            [
              [6.915005545175018, -7.369096921907196],
              [7.001830200255667, -7.3621204614852775],
              [7.000659976824744, -7.350541457827923],
              [6.999570457819769, -7.332887386419079],
              [7.038215928087414, -7.329929912990309],
              [7.1125036624824896, -7.323526752674755],
              [7.2268868401343695, -7.314433137493063],
              [7.2303358096003825, -7.31378518826868],
              [7.260639495620056, -7.311078360019074],
              [7.286941491435699, -7.279875601128913],
              [7.300750392149516, -7.287719668661082],
              [7.301393048752112, -7.289262816103729],
              [7.3007721541094535, -7.295195908740589],
              [7.302730372261983, -7.299074557270718],
              [7.3082115149867075, -7.303105560085646],
              [7.313507577292669, -7.3044540863966585],
              [7.319401867748015, -7.303576603563222],
              [7.325145198145842, -7.300487105295553],
              [7.329404664939234, -7.3011339086540215],
              [7.331018135729868, -7.303638668098284],
              [7.328088436895974, -7.314869976117353],
              [7.328637812726534, -7.324442298803987],
              [7.327217754368779, -7.328048359814007],
              [7.3128179302045195, -7.352696587847049],
              [7.304732942741911, -7.362043896261874],
              [7.305650244740029, -7.369069256745234],
              [7.310587884184977, -7.373727993313146],
              [7.313834906746239, -7.379342180292177],
              [7.31707921696038, -7.382222645450298],
              [7.32998006737885, -7.381564612575824],
              [7.333445089329486, -7.382851307187347],
              [7.336609052436825, -7.387513016313446],
              [7.33807687067166, -7.400549359922095],
              [7.3355929137464555, -7.405841392734793],
              [7.3283838332123, -7.4119073570772285],
              [7.325218315976828, -7.416940636679005],
              [7.32588438430669, -7.420337723824636],
              [7.33232921630934, -7.427061877420488],
              [7.33278592034308, -7.429532064514361],
              [7.33022186861326, -7.436831390453464],
              [7.325925883286169, -7.436811444311587],
              [7.321376227468931, -7.442270779572847],
              [7.327213649422092, -7.446423634532209],
              [7.329865054047394, -7.459522015890699],
              [7.327103583910489, -7.466658174542045],
              [7.327233841794151, -7.474621875582807],
              [7.32443127299196, -7.481930552562068],
              [7.3262153042359035, -7.483510222102667],
              [7.337127782753933, -7.482676252570482],
              [7.343371001446459, -7.486336260910514],
              [7.346770368651833, -7.49590216329793],
              [7.357657973952542, -7.500612546027062],
              [7.360165424271212, -7.503747081097349],
              [7.362024214056005, -7.5110777707238165],
              [7.352773925664244, -7.517458657690786],
              [7.346123563194457, -7.5188843264233345],
              [7.340942338717877, -7.52158979612575],
              [7.337906216194198, -7.525962472391009],
              [7.338351219166939, -7.536667677753535],
              [7.335241856325535, -7.544679992453036],
              [7.328072914211802, -7.549660528756535],
              [7.318739123473803, -7.561030524574903],
              [7.315946886534907, -7.566674978502511],
              [7.314171088968937, -7.575199967641255],
              [7.316072041307618, -7.5836929163418025],
              [7.31993732023841, -7.587988749784248],
              [7.332205711826019, -7.591757675203362],
              [7.343592862568888, -7.5984339651946575],
              [7.352801969363949, -7.610002336334413],
              [7.353962085093818, -7.619867519992783],
              [7.352441792672414, -7.6233888674459696],
              [7.348476276066897, -7.626100500272481],
              [7.338387368185166, -7.6276379079530505],
              [7.327394072104731, -7.6347225677888595],
              [7.318997260699005, -7.638364557595626],
              [7.315571126372101, -7.643722915811478],
              [7.317438529522065, -7.655738653978452],
              [7.31615675734228, -7.658737032515752],
              [7.310850663389077, -7.662783030782432],
              [7.3010020567559994, -7.666654565541853],
              [7.296259065916963, -7.670540688525133],
              [7.292117753705482, -7.677467488028829],
              [7.294657893604591, -7.68712635126083],
              [7.290373951739941, -7.6986808486900395],
              [7.291636174237748, -7.702576849492403],
              [7.296099820146199, -7.705584697757565],
              [7.302007493033545, -7.713087993897534],
              [7.301833486539063, -7.723868008266827],
              [7.302684845683726, -7.727932345129425],
              [7.30739363062652, -7.737060982238596],
              [7.313733422690321, -7.741657504466088],
              [7.315543076811041, -7.74517183171803],
              [7.316643137629659, -7.751390076178115],
              [7.31581024748363, -7.755873733371947],
              [7.311137960867323, -7.7666577963133765],
              [7.3088492479704135, -7.765162330403951],
              [7.30221335642956, -7.775145377167362],
              [7.300215401273921, -7.790920341418981],
              [7.295842207106601, -7.792247464899366],
              [7.291673034340494, -7.797901717422434],
              [7.288894933440157, -7.803930198504083],
              [7.283329921693336, -7.802380806840307],
              [7.27768660322332, -7.806234109173244],
              [7.272278796848922, -7.807662665249883],
              [7.26918249952884, -7.809864828536219],
              [7.2747034312627825, -7.8154249240446125],
              [7.2761494868630265, -7.819078760429127],
              [7.271961172347934, -7.826599170693165],
              [7.2731806393971, -7.83394265340174],
              [7.278524260264092, -7.840075740264394],
              [7.274550318828581, -7.844590506061735],
              [7.274868864640052, -7.848878495655274],
              [7.27369899191091, -7.856407492043601],
              [7.271220409565786, -7.86479293892904],
              [7.263446043672905, -7.874802137460176],
              [7.256924416635523, -7.881369082304918],
              [7.2537341696903015, -7.890048834546065],
              [7.25567990289435, -7.891019663489064],
              [7.260411337395557, -7.9075042294806535],
              [7.260873039246659, -7.925001021762749],
              [7.25449878910584, -7.930650436996983],
              [7.246962542553352, -7.945036970711387],
              [7.245218811877056, -7.953991688606926],
              [7.246542006800084, -7.961724118040675],
              [7.253616289464952, -7.983024537711977],
              [7.251195059816558, -7.993015534445091],
              [7.246935696494358, -8.001812343965641],
              [7.251080119066942, -8.026797447213166],
              [7.252492078321692, -8.076507848265521],
              [7.247207672547492, -8.09752187507985],
              [7.240567965067799, -8.112943520062585],
              [7.235356159410762, -8.120647399157098],
              [7.2297233680228405, -8.142098086579459],
              [7.225030610421585, -8.134546555450507],
              [7.224697345801996, -8.128941776179385],
              [7.222810800138201, -8.124983749964107],
              [7.217898379783207, -8.125882922327861],
              [7.214566230548257, -8.129057515065389],
              [7.1999791134803734, -8.13181490196059],
              [7.184954137002416, -8.140322658151598],
              [7.1812390800220225, -8.138080182592267],
              [7.182940376595053, -8.133169446089921],
              [7.1790938989736235, -8.122144209886121],
              [7.178811614415208, -8.116044405411728],
              [7.1854058156060505, -8.114047094345597],
              [7.1859444583869525, -8.106476935734989],
              [7.184926562544174, -8.103000258005181],
              [7.185180275919256, -8.096504887640089],
              [7.1772534776396455, -8.096373828826751],
              [7.170301389203966, -8.098311293766177],
              [7.166407115486789, -8.1007030666895],
              [7.159579452164017, -8.093712694183592],
              [7.15234482525555, -8.090610092409364],
              [7.143788515510364, -8.090898177009464],
              [7.138815409715362, -8.088132512104771],
              [7.12040667387329, -8.082175776297566],
              [7.114645453373586, -8.083930855552339],
              [7.101537149937603, -8.083205615346374],
              [7.097342839913729, -8.082174056187961],
              [7.096481154556277, -8.079182201614945],
              [7.08652596204908, -8.081717724844825],
              [7.083879423635962, -8.088255724284767],
              [7.084573057671163, -8.094219598898125],
              [7.0834986419193475, -8.096142916107153],
              [7.077775423679219, -8.09772496853133],
              [7.07502342571686, -8.09672083057174],
              [7.076648816349909, -8.091489413351988],
              [7.073766399720702, -8.08386499714055],
              [7.072981457349471, -8.076786549188737],
              [7.067398937920597, -8.072541866782728],
              [7.0630001585986575, -8.071466258393391],
              [7.052240144544738, -8.065390927352494],
              [7.047557686071428, -8.068517134585523],
              [7.041916329619697, -8.065909563989557],
              [7.035491752743129, -8.064867883632735],
              [7.033072350741187, -8.068428681139016],
              [7.034065698377885, -8.071179792499484],
              [7.0312742324962905, -8.083731438026781],
              [7.022327484171295, -8.086830427525138],
              [7.006155954506046, -8.104219097785652],
              [6.99513648056097, -8.01672654471387],
              [6.984594591746644, -7.932796631810803],
              [6.973562454107488, -7.840437312063755],
              [6.965219451073383, -7.7719898062476505],
              [6.9619295111999335, -7.743088457005351],
              [6.946187600555248, -7.6138155546192285],
              [6.94470063026219, -7.605299952728638],
              [6.929688508062235, -7.483690073853705],
              [6.915005545175018, -7.369096921907196]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.20581494152172, "lat": 30.78780934108646 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01097"],
        "coty_name": ["Mobile"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mobile County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00161575"
      },
      "bbox": [
        6.915005545175018, -8.238832480687174, 7.362024214056005,
        -7.279875601128913
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.15628645236416, -0.8113269728955733],
            [-11.058517023429708, -0.8260209069221396],
            [-11.038098531841463, -0.8294637247993556],
            [-10.960726737729248, -0.8405711285961532],
            [-10.953186177067096, -0.8424389541944011],
            [-10.937842315282898, -0.8504829720175557],
            [-10.785935870448025, -0.8733617362893166],
            [-10.675135333815604, -0.8898492948929988],
            [-10.587041155561684, -0.902837627965349],
            [-10.570627580384752, -0.9059079672493549],
            [-10.586549943505496, -1.0132260151579853],
            [-10.603098240644522, -1.124741733842588],
            [-10.621233761957628, -1.2469367085219327],
            [-10.643456071547595, -1.3966656066533596],
            [-10.664970475205562, -1.5416050440122013],
            [-10.680445584309629, -1.6458619176025258],
            [-10.707549485815502, -1.8284562680539322],
            [-10.715111787623128, -1.8793889575537919],
            [-10.736193076402618, -2.0213748371693336],
            [-10.753604381124825, -2.1386324887656007],
            [-10.768460422355535, -2.2386791373343473],
            [-10.63009463913441, -2.2590948709940646],
            [-10.638264070387972, -2.316169320362668],
            [-10.651272534634241, -2.4035468395036212],
            [-10.664698700112794, -2.4016749713102117],
            [-10.685653950441086, -2.5442399008289227],
            [-10.705125456580271, -2.675743527402743],
            [-10.715536217288706, -2.7480087333095202],
            [-10.714917679967042, -2.7482643305986856],
            [-10.741524426951841, -2.917661338435009],
            [-10.741065570431262, -2.9177285684566527],
            [-10.747171329484281, -2.9654163827940785],
            [-10.754654121114388, -3.0078752771845623],
            [-10.767167018536982, -3.094552015989827],
            [-10.773061451224342, -3.0937615771129545],
            [-10.778676342233135, -3.134926081235599],
            [-10.790483009769543, -3.219468596055971],
            [-10.797541103706319, -3.2682944990849285],
            [-10.822294093324777, -3.3539373933818197],
            [-10.821156477583191, -3.412327647382638],
            [-10.820020601994848, -3.441979642574959],
            [-10.82118194010119, -3.441878697319679],
            [-10.823037849240814, -3.454986672574046],
            [-10.833803746996074, -3.5266008788390892],
            [-10.842990605390286, -3.5898443627851475],
            [-10.846608830529096, -3.6129311125389947],
            [-10.857765018713646, -3.6864146685234402],
            [-10.872987602948518, -3.787547247057588],
            [-10.880942056576107, -3.7865395355682954],
            [-10.89106042155538, -3.8546909273256245],
            [-10.902336295537216, -3.9311565354622586],
            [-10.918104410403501, -4.038365074256971],
            [-10.931988461246599, -4.13267380552829],
            [-10.958500781033962, -4.1286901761305135],
            [-10.989217566479367, -4.33728772038128],
            [-10.993820089897998, -4.3352285217482365],
            [-10.993264217842029, -4.331527186647371],
            [-10.99525061215124, -4.3287608115845355],
            [-11.004698168997995, -4.326851804213163],
            [-11.008127459812108, -4.32741035616416],
            [-11.014472111784704, -4.333445495738193],
            [-11.026711827739215, -4.329077666454369],
            [-11.030886233384036, -4.330236081111831],
            [-11.036248047334148, -4.324937802960091],
            [-11.04259921815192, -4.325112823508781],
            [-11.045044845251471, -4.32229543634353],
            [-11.043886714389508, -4.318024042623386],
            [-11.046370364502335, -4.316834299601341],
            [-11.050855810523503, -4.319563917910741],
            [-11.061156677852244, -4.318166494575399],
            [-11.063023083669965, -4.315069513563291],
            [-11.07169151825328, -4.310222562283276],
            [-11.077073262772249, -4.31514715414844],
            [-11.054890760142264, -4.1660442556272494],
            [-11.046492945109101, -4.109590474828004],
            [-11.032333612299466, -4.014383291129689],
            [-11.014524336784643, -3.8946296404463334],
            [-11.071741528158942, -3.8861375866443213],
            [-11.219451841605718, -3.8640137169818103],
            [-11.33254587461579, -3.8468803946809906],
            [-11.450555571204172, -3.8288208889120776],
            [-11.624594125644585, -3.8018519411037097],
            [-11.583590317117993, -3.5402814283509474],
            [-11.525422667618168, -3.1691026171579018],
            [-11.51231530569996, -3.0854462017190287],
            [-11.475503255871775, -2.8504509198513737],
            [-11.460455654908536, -2.754383762573146],
            [-11.44225942732066, -2.638211111824818],
            [-11.420817401089181, -2.501301971900403],
            [-11.40721948957, -2.4144707085346786],
            [-11.387138240080878, -2.2862239280103234],
            [-11.36902154410192, -2.170518421380601],
            [-11.344840962317221, -2.0160659137033643],
            [-11.31923994622567, -1.8525248152678209],
            [-11.299356916539582, -1.7254989910801681],
            [-11.286948015448232, -1.646211351690576],
            [-11.266276998457235, -1.5141426035737975],
            [-11.24887516281791, -1.4029546438773577],
            [-11.227195108086308, -1.2644239208387649],
            [-11.218379495560232, -1.2081022452258319],
            [-11.179801407852125, -0.9615897279670877],
            [-11.15628645236416, -0.8113269728955733]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.32140799442365,
          "lat": 35.39964830360236
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04017"],
        "coty_name": ["Navajo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Navajo County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00042808"
      },
      "bbox": [
        -11.624594125644585, -4.33728772038128, -10.570627580384752,
        -0.8113269728955733
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.474890000429593, -4.621643470764026],
            [3.559716509244586, -4.6154320794308505],
            [3.588527711263724, -4.613643735517744],
            [3.6429000556219413, -4.610727017259692],
            [3.702647283108758, -4.608568671681972],
            [3.729444562472906, -4.6070618910597725],
            [3.789339540152792, -4.604213885235985],
            [3.793605482747267, -4.691459025314245],
            [3.7743459404238453, -4.692192062115716],
            [3.778788220562048, -4.790398188419421],
            [3.7797983518121243, -4.805407341503751],
            [3.7801515663908805, -4.819556456506826],
            [3.7827315626986366, -4.8782773307587775],
            [3.786442453343052, -4.965819373457286],
            [3.7478107751793637, -4.967572936832942],
            [3.6497881278142312, -4.970803355855066],
            [3.614434453668162, -4.9718926628668525],
            [3.530965057050455, -4.974975699396327],
            [3.493312089811434, -4.974302608960103],
            [3.4914438112441277, -4.970966260697395],
            [3.493289198369476, -4.960794955685876],
            [3.4919200345878685, -4.957259539478075],
            [3.488136126606735, -4.954268796562023],
            [3.49077768527006, -4.950170366125197],
            [3.4851296137954786, -4.945392230330181],
            [3.4862649163912187, -4.942575865859069],
            [3.483010730857888, -4.936424064509797],
            [3.4889332286659163, -4.923032193135179],
            [3.4882894964738265, -4.91630683778034],
            [3.4901671616230834, -4.910882457296566],
            [3.4926693951153203, -4.909133979380729],
            [3.493721298488822, -4.903957128462449],
            [3.489748720956748, -4.90055456162343],
            [3.489560867740562, -4.8935983397944876],
            [3.4871714961210114, -4.886843176817911],
            [3.485276773160994, -4.881767324025526],
            [3.4810412070571064, -4.877439140907824],
            [3.4854493509971007, -4.87093578132244],
            [3.4836026584231625, -4.868796920402705],
            [3.482526768535096, -4.861446314197566],
            [3.4834277234850157, -4.85864434425816],
            [3.482380121386633, -4.849313564220525],
            [3.4792018577715793, -4.8417650174180515],
            [3.477369111892104, -4.840179845219315],
            [3.4722891645506757, -4.840440790763717],
            [3.4698176018081877, -4.835419246412285],
            [3.4691838689449725, -4.829227297208091],
            [3.4618860411551236, -4.82606848581486],
            [3.458360934450016, -4.821508552392288],
            [3.4507198222773625, -4.818378843939019],
            [3.446602474158031, -4.815624998815443],
            [3.443290558197241, -4.806657045538005],
            [3.432842811215866, -4.796923088596974],
            [3.433669693064599, -4.791699842342461],
            [3.4306586427985972, -4.785052335724642],
            [3.4285477397503263, -4.78339801560124],
            [3.430040692624955, -4.7789733109749735],
            [3.428000295426197, -4.770214126930596],
            [3.4219777695303866, -4.768496197172956],
            [3.4190089244830446, -4.764654495492611],
            [3.4200674393298436, -4.762007401850496],
            [3.4161472713568215, -4.752972728407726],
            [3.4109380127522018, -4.748810937592266],
            [3.4098753508353012, -4.743763759940609],
            [3.3996239863966213, -4.738762411631522],
            [3.399090376484177, -4.7351832708344945],
            [3.394715245402942, -4.732070225469766],
            [3.391441419597779, -4.731903072351936],
            [3.3904423732380944, -4.725747809718919],
            [3.3838387040522906, -4.7238807797805835],
            [3.3822656707088767, -4.717975771930437],
            [3.3789993385190202, -4.715723843114267],
            [3.3801465705620397, -4.7127260081115745],
            [3.364006782980114, -4.713036029152946],
            [3.364134784197278, -4.628213162150733],
            [3.474890000429593, -4.621643470764026]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.1851359163941, "lat": 33.8984024944364 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05025"],
        "coty_name": ["Cleveland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cleveland County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00063760"
      },
      "bbox": [
        3.364006782980114, -4.974975699396327, 3.793605482747267,
        -4.604213885235985
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.611680393211277, -3.602770220005574],
            [3.612751961831737, -3.6020041792721202],
            [3.6240883829420505, -3.6031338205777916],
            [3.628288014721853, -3.6008390887353277],
            [3.6306013415573513, -3.6041988484969294],
            [3.636641351242507, -3.6035398508980596],
            [3.6376903283756103, -3.6013457905731423],
            [3.6436836027582205, -3.599542646780553],
            [3.647510281198916, -3.5927486289197215],
            [3.6495508289136587, -3.5938009079967026],
            [3.657278865679571, -3.5929194491521264],
            [3.6608345450545836, -3.5966763414083767],
            [3.667966575760514, -3.5999240447920795],
            [3.6739421236164307, -3.59802253524221],
            [3.675210055389214, -3.5952636601484382],
            [3.6801960878016766, -3.593249641543339],
            [3.6841945209034077, -3.5949438316286235],
            [3.69099626153752, -3.5937419741302645],
            [3.6977738460951075, -3.589381932703577],
            [3.7019284137556987, -3.597516808202218],
            [3.7041974352492275, -3.5997852353758244],
            [3.7091126171185276, -3.6013731754244236],
            [3.7118011060649225, -3.6055843473011757],
            [3.716007509362755, -3.6035947945013302],
            [3.724841281507209, -3.6066084639055553],
            [3.7335317542161572, -3.6147372444011827],
            [3.7376294385080215, -3.6125778616479525],
            [3.7439819641516268, -3.6138074618232006],
            [3.745233992884122, -3.617199922385841],
            [3.7507461204377366, -3.6191699260666494],
            [3.755361846235961, -3.6175578091067764],
            [3.759180248801263, -3.619621552778209],
            [3.761662840979912, -3.617016977417721],
            [3.7661455222965246, -3.6187094657038528],
            [3.770193672013416, -3.61694137902536],
            [3.77626550646105, -3.621287523770606],
            [3.7769478428622425, -3.624585028223279],
            [3.7833088302860833, -3.6279258095473126],
            [3.789464862876678, -3.6344827373438093],
            [3.7915942161093263, -3.631593237437304],
            [3.7975424733242864, -3.6295242650777233],
            [3.8025711394595967, -3.6337037939391323],
            [3.8064866899556558, -3.6337248761141505],
            [3.8088481091483946, -3.636804324546076],
            [3.8160870804047056, -3.635390345666556],
            [3.81658022896465, -3.6368600392000094],
            [3.826166396931279, -3.634761874042392],
            [3.8300934254181485, -3.6358774307258646],
            [3.8322848531952323, -3.632581049016818],
            [3.837659421200635, -3.633013469656959],
            [3.8395876578299735, -3.6302472147504288],
            [3.8433674557407778, -3.629286998649888],
            [3.8465416290693124, -3.6313182642057624],
            [3.852758677080114, -3.6272040446019522],
            [3.8606616288175015, -3.6269999678466007],
            [3.8633724706457286, -3.6280444118409716],
            [3.870483434393164, -3.627918519656977],
            [3.874374727760548, -3.737732460167611],
            [3.963805324655789, -3.7356711760551935],
            [3.9648090993658722, -3.7724399807788127],
            [3.9655882500513626, -3.812024340629982],
            [3.965442240246483, -3.816433480516493],
            [3.966364746470568, -3.8541385472750957],
            [3.9670308449837632, -3.896990204389116],
            [3.967783317571583, -3.929816850065178],
            [3.9693524642642024, -3.9847203922430574],
            [3.9723039816825914, -3.987251189534853],
            [3.9788854262769573, -3.9860855716345376],
            [3.980780504200277, -3.9906393168313246],
            [3.9862147724986863, -3.992606009990509],
            [3.991908827694702, -3.997787446918614],
            [3.995811399974544, -3.9981909701469855],
            [4.000098113942838, -4.002864916254404],
            [3.999849302316954, -4.006226965954245],
            [4.002792523431628, -4.010141316457955],
            [4.007099269646053, -4.012503257490231],
            [4.0110608971125945, -4.011825043655487],
            [4.016382931455243, -4.016184933958131],
            [4.020558527511118, -4.022478660875415],
            [4.022258785542938, -4.028977154438541],
            [4.019477731814464, -4.039034296740371],
            [4.014790847681558, -4.042365569031426],
            [4.01528570685204, -4.045969255950347],
            [4.0113859847916915, -4.053057624144116],
            [4.006193237094705, -4.055577755323755],
            [4.004738014908252, -4.069901977059583],
            [4.002750615646955, -4.076096977101762],
            [4.008316437378008, -4.078705345547325],
            [4.008406215423326, -4.082787294596717],
            [4.013822491341907, -4.088767312168844],
            [4.016363456391602, -4.08568061586423],
            [4.020456508758456, -4.085894122088224],
            [4.0266681561571245, -4.088469616814958],
            [4.029298180814896, -4.0925940989158],
            [4.028501188991649, -4.096930010885942],
            [4.0290560380153755, -4.108438475566859],
            [4.026064907160552, -4.113000577984319],
            [4.022308209821285, -4.11517064554727],
            [4.01849899767459, -4.121329980294952],
            [4.010282802250921, -4.127465597290179],
            [4.001633766319094, -4.137690320436734],
            [4.001219396369515, -4.141351778921386],
            [3.9975150872379244, -4.143226154562762],
            [3.996067966821703, -4.146818676686872],
            [3.997395536131088, -4.152078765311105],
            [3.9917074711925347, -4.1644689287117425],
            [3.99366306905123, -4.165894987924792],
            [3.9964430749449082, -4.174912483457011],
            [3.974326091092946, -4.175089792528583],
            [3.8853152659685035, -4.177540415231833],
            [3.797125698937981, -4.177564648959162],
            [3.738982595386364, -4.17911081709797],
            [3.7085377447954766, -4.179770898927053],
            [3.706935546557089, -4.132107217659767],
            [3.7035764427394664, -4.047421894303755],
            [3.703463722980356, -4.047012891038164],
            [3.6386501296857383, -4.048391724565573],
            [3.6375303698725876, -4.037611988490795],
            [3.6387662114752914, -4.027770521623528],
            [3.638159748943761, -4.0260881319380655],
            [3.6454090884217427, -4.0083519515269375],
            [3.6450712180618665, -3.993522747664046],
            [3.6464081154887813, -3.9834706466818277],
            [3.645796100684684, -3.9737649884327135],
            [3.6479577922008564, -3.964535322654717],
            [3.6480991048029274, -3.956424270472096],
            [3.644307252266779, -3.954793803268185],
            [3.6443200847248716, -3.9484688357819935],
            [3.65922685627628, -3.948064773838941],
            [3.6587104956871315, -3.9257694227163373],
            [3.657636812308511, -3.8317674968037028],
            [3.656609358641193, -3.8171061808939823],
            [3.656797322041246, -3.802333888560639],
            [3.6560956276649232, -3.7439176192873806],
            [3.6548893533254287, -3.7432210485385693],
            [3.653979120849859, -3.662863622012529],
            [3.6536557780640817, -3.6564550121076],
            [3.6124639442122417, -3.6574967008552726],
            [3.611680393211277, -3.602770220005574]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.88877594249615,
          "lat": 34.754230314174926
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05085"],
        "coty_name": ["Lonoke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lonoke County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00069164"
      },
      "bbox": [
        3.611680393211277, -4.179770898927053, 4.029298180814896,
        -3.589381932703577
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.8528077834545824, -5.252057129311578],
            [2.852720578325128, -5.237447569307621],
            [2.8527517806209834, -5.1498118721444035],
            [2.8531444307394285, -5.091016548837062],
            [2.8528603370292616, -5.03146726105707],
            [2.852737783745879, -4.926718556160988],
            [2.867278703209518, -4.927131168314957],
            [2.8735788491001615, -4.92135884235459],
            [2.870381125948311, -4.918583045181606],
            [2.8800164221508897, -4.914482189631553],
            [2.88216774726743, -4.91670140668681],
            [2.8911457821831843, -4.920744500916004],
            [2.891830988417198, -4.923081948217107],
            [2.89674311862371, -4.925948458952317],
            [2.903166054955351, -4.926845029986477],
            [2.905348570624762, -4.930029518196374],
            [2.9134041830768496, -4.932186891306803],
            [2.9183326234011417, -4.928801206707573],
            [2.9206152123952855, -4.929003075295548],
            [2.9313580269262416, -4.922828135499452],
            [2.93866771174822, -4.922232040188657],
            [2.944759952215848, -4.9235694050811585],
            [2.94706772526921, -4.917424762295618],
            [2.9496270785121395, -4.918028739192524],
            [2.9539900707909923, -4.912206408025175],
            [2.9661593931744727, -4.909585013988499],
            [2.9714032466854636, -4.905490785725657],
            [2.974622270005188, -4.905590935030361],
            [2.9782881427683554, -4.902957398227317],
            [2.9874871138743235, -4.899330923657517],
            [2.9884965372162853, -4.8876940501014765],
            [2.993559055980839, -4.886640611187713],
            [2.9938759942456006, -4.8800226194001235],
            [3.001609967549384, -4.879862751209565],
            [3.0044904017763012, -4.877321388646525],
            [3.009176367560929, -4.880105225694218],
            [3.010075079475935, -4.883144064349253],
            [3.0144535997325823, -4.886654531106949],
            [3.0223839850516883, -4.889946819862678],
            [3.0258327432728658, -4.8881584902522714],
            [3.040789847708215, -4.887955958499039],
            [3.090533653547391, -4.88813577911438],
            [3.138038384394592, -4.887936548477719],
            [3.1791418451706663, -4.887933959048323],
            [3.2355702802419963, -4.887391311514406],
            [3.2818145350956502, -4.887204950298864],
            [3.282074716812826, -4.938136708430904],
            [3.2823039657763373, -4.953305534044201],
            [3.281203372506577, -4.958592585516214],
            [3.2778934585149893, -4.96386315791032],
            [3.2729577260753913, -4.9647202327439555],
            [3.270936055587702, -4.975235991721881],
            [3.265942462956482, -4.984802931808505],
            [3.25721957038649, -4.987702294144953],
            [3.2548634371306977, -4.993029925260429],
            [3.248794701842935, -4.995085144214784],
            [3.244196530619167, -4.998452427281828],
            [3.2419526643058916, -5.006368826104814],
            [3.237159587544586, -5.015478115315158],
            [3.2364513204834453, -5.019961610204839],
            [3.23391129190216, -5.022479500592958],
            [3.2331930073808492, -5.028088626245227],
            [3.2295048025749313, -5.0311897705622695],
            [3.223626486855548, -5.031102730172125],
            [3.218417167098058, -5.032846087326504],
            [3.2146007812612676, -5.032114038678998],
            [3.2120679212329026, -5.034725223093239],
            [3.2047298092703156, -5.032842501100966],
            [3.201102827384511, -5.034894049392646],
            [3.1922801772110034, -5.042143856538393],
            [3.1874708193283525, -5.044129217273214],
            [3.179003034538153, -5.038772645460911],
            [3.171159654479824, -5.042102274116762],
            [3.1683348843825248, -5.046126341998891],
            [3.1700500622090084, -5.048513841051137],
            [3.169496623939615, -5.0537216692067295],
            [3.165400267611213, -5.058927448507213],
            [3.165828910380178, -5.062643909974043],
            [3.1634682305645527, -5.065380835889774],
            [3.1628700674337717, -5.074753541128803],
            [3.1658476247696004, -5.08050248033092],
            [3.1721488412067287, -5.085730637211319],
            [3.1804682611073476, -5.088643395919917],
            [3.1815937781339607, -5.0938169817873735],
            [3.1841751171093455, -5.099203255478238],
            [3.184745209469081, -5.112244608048018],
            [3.1840890450595603, -5.122421235433314],
            [3.182278230462002, -5.126988966805366],
            [3.182784580319664, -5.131460726917588],
            [3.1816481002200616, -5.137407114339363],
            [3.1786143171405783, -5.142302681805817],
            [3.1743939743707794, -5.139965872260455],
            [3.171891492882057, -5.136274255665718],
            [3.171450928117612, -5.130598922335411],
            [3.1600086351906445, -5.138423364273492],
            [3.1556963492440895, -5.149957078291217],
            [3.1516635720802575, -5.150974622970252],
            [3.1477123663548805, -5.14744108663829],
            [3.1450564303230504, -5.142960124633493],
            [3.1402532573991233, -5.142241017941755],
            [3.13227990228716, -5.150078817083595],
            [3.1315320768607173, -5.158609029753128],
            [3.1374754106186518, -5.1624962876098826],
            [3.14379233207616, -5.162567096975399],
            [3.1457851296736625, -5.164841617605252],
            [3.142232191288135, -5.1697188227732],
            [3.1437845236741193, -5.177128045747446],
            [3.139415591510881, -5.1797718273057],
            [3.1351721748783463, -5.184306612237947],
            [3.1449142688958776, -5.191910678295158],
            [3.1506055744075803, -5.191378109760801],
            [3.149902215904107, -5.194521697461683],
            [3.145945844031123, -5.194065132983699],
            [3.1424896570992056, -5.196458182645321],
            [3.142266441538603, -5.20338022952188],
            [3.1492322389331204, -5.206836221083449],
            [3.15331485584986, -5.211216577697689],
            [3.162604564407078, -5.210929874555534],
            [3.1667588210202755, -5.206163214728254],
            [3.164756430809775, -5.201205648874198],
            [3.1666170183607005, -5.199747259845935],
            [3.1720118560974835, -5.204766171255731],
            [3.1787437639218576, -5.20573114965942],
            [3.182922059623515, -5.211338918061605],
            [3.1828527103330857, -5.214642443573975],
            [3.17904592618914, -5.219951767066169],
            [3.180003350219451, -5.2269844817109865],
            [3.177539565249498, -5.2287035754173825],
            [3.177783595925115, -5.234864669281045],
            [3.1808692145130006, -5.234672357093513],
            [3.1837154394244322, -5.23732856326659],
            [3.185393762188789, -5.242780958179684],
            [3.195440170853135, -5.240019411276461],
            [3.1918696673677496, -5.248368789720266],
            [3.1937663846691935, -5.254760410214683],
            [3.193287490025002, -5.260559745883837],
            [3.194526156818012, -5.263145485465067],
            [3.199615133589963, -5.263386900607322],
            [3.2091698554887733, -5.26174644421297],
            [3.2182738523602206, -5.262558443162145],
            [3.2219605308656756, -5.261904203465337],
            [3.2271838825947325, -5.2583076798746955],
            [3.235100758857259, -5.257117563106714],
            [3.2388875258088166, -5.261362013850598],
            [3.2369478268705354, -5.269666810018354],
            [3.243384705656783, -5.266847382227196],
            [3.2460495027924354, -5.2679425107657805],
            [3.243081316627423, -5.275158878977778],
            [3.245233621532749, -5.277185968550416],
            [3.2519265741539036, -5.276844927725516],
            [3.25373221662751, -5.280475117101813],
            [3.2534749276843473, -5.286161367100308],
            [3.2509713243679643, -5.287754438322432],
            [3.2462652927895976, -5.285220535825484],
            [3.2434508091623533, -5.288625040970185],
            [3.2447765280913328, -5.294378847542288],
            [3.247980525470735, -5.296028709596515],
            [3.2527495656980894, -5.294505407392202],
            [3.256462149265694, -5.290813104118776],
            [3.2613844720188996, -5.2882966834306],
            [3.264177001738849, -5.283717527557172],
            [3.2673361795845626, -5.281885076964805],
            [3.270449294042542, -5.283150067884286],
            [3.272130681435804, -5.286942719875865],
            [3.2760776455861627, -5.289033600759562],
            [3.2818526950056435, -5.289347701127482],
            [3.28905479834771, -5.287494645966754],
            [3.2942295366682974, -5.292255441755598],
            [3.2966253173690996, -5.29963944171112],
            [3.294323482960841, -5.305664632020647],
            [3.297976826854919, -5.310702097718907],
            [3.298592952011871, -5.3156255187],
            [3.302010615795304, -5.3181442444760725],
            [3.3051279060649836, -5.317130546568895],
            [3.3072443822209956, -5.31136067102551],
            [3.310442044066325, -5.312319053185589],
            [3.3098613198350124, -5.319050954323368],
            [3.310721099140543, -5.322890081018476],
            [3.307387816945588, -5.322987868704153],
            [3.305667076193873, -5.320306150964418],
            [3.300848445233244, -5.32188042934841],
            [3.294450897282425, -5.321568870335511],
            [3.2900955888572785, -5.3174873734035435],
            [3.285645155531366, -5.319631398317952],
            [3.281943270554881, -5.326792101330448],
            [3.278000985493537, -5.329122146980163],
            [3.274761509025484, -5.326909111176636],
            [3.2728117972118036, -5.331340764625045],
            [3.2639025546662235, -5.332607410807391],
            [3.258930490333075, -5.3301481019883905],
            [3.2564099680855945, -5.326337106267376],
            [3.245391078281164, -5.323879444759601],
            [3.2438424611172034, -5.326672289928889],
            [3.2388246876926234, -5.328381113068093],
            [3.2366340713273347, -5.334884530542701],
            [3.2318710143071523, -5.336702285941228],
            [3.2276518545562802, -5.334523669875828],
            [3.2233269613555353, -5.336129008155207],
            [3.215629233433246, -5.333408960008818],
            [3.21596742847804, -5.327621587102642],
            [3.210801042635692, -5.327353731380371],
            [3.2032399035305197, -5.324655794467532],
            [3.199120465354455, -5.327578794866926],
            [3.1923431542781913, -5.323970033787577],
            [3.1881047940759215, -5.323884358844188],
            [3.1863035664172354, -5.3174464213201045],
            [3.18337586600095, -5.312354102322498],
            [3.1759777717002287, -5.311754426055581],
            [3.173445620568087, -5.3101599968987525],
            [3.1674474297849735, -5.309863657595653],
            [3.1603138540364792, -5.311634832984852],
            [3.1499862677978077, -5.307987828704405],
            [3.149323631918926, -5.311003557319548],
            [3.1441923097448803, -5.315041440954222],
            [3.1398700079454964, -5.315004190537086],
            [3.1361646067571045, -5.3212120089133474],
            [3.125475163407328, -5.322036716313912],
            [3.122277587103396, -5.324046985235328],
            [3.0851968468399344, -5.32434523953455],
            [3.0010835897414734, -5.324216408778848],
            [2.969397410751065, -5.324461799802985],
            [2.9362914389774653, -5.324530266513879],
            [2.852851574519178, -5.324900968044715],
            [2.8528077834545824, -5.252057129311578]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.88186285536962, "lat": 33.59333850922808 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05103"],
        "coty_name": ["Ouachita"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ouachita County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00069170"
      },
      "bbox": [
        2.852720578325128, -5.336702285941228, 3.310721099140543,
        -4.877321388646525
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.603134329169574, 0.898523585118904],
            [-19.5974662179806, 0.90149281565815],
            [-19.587298217551595, 0.9126693586039661],
            [-19.580617657240236, 0.9079222655865918],
            [-19.57856874750129, 0.9032527603797152],
            [-19.573688900309673, 0.8961018633076745],
            [-19.56363499043025, 0.8950400077108103],
            [-19.556947524474825, 0.8930524002885974],
            [-19.553918707432672, 0.8903318714628548],
            [-19.551942010218426, 0.8841180016092787],
            [-19.546871353682022, 0.8862134033844409],
            [-19.53836918705992, 0.8839075747066384],
            [-19.53668374898718, 0.8896853822326083],
            [-19.533396408899428, 0.8965244740355856],
            [-19.52834153666137, 0.9000859010064864],
            [-19.516560689095265, 0.9026696149695744],
            [-19.516088508629128, 0.9065846534316121],
            [-19.50959643290053, 0.9113993575985075],
            [-19.499648258769323, 0.9151083767943221],
            [-19.497909639625316, 0.9173534389623438],
            [-19.490025196604975, 0.9209056108131703],
            [-19.487276601161312, 0.9245346787379343],
            [-19.480747744659702, 0.9377181485557726],
            [-19.473461013423073, 0.9443484547305023],
            [-19.460883472296427, 0.9526735354546005],
            [-19.446559676428357, 0.9420642550143284],
            [-19.44281253084821, 0.9426290487851986],
            [-19.443603522812506, 0.9468809370644433],
            [-19.441125461790246, 0.9490577339352856],
            [-19.431987288924063, 0.9496708376819325],
            [-19.42919561163572, 0.943772256709613],
            [-19.423020621947163, 0.9374256353543727],
            [-19.421837944592077, 0.9323624323144721],
            [-19.412970953435014, 0.915869776042806],
            [-19.37640631663648, 0.9058621748277562],
            [-19.36314580957607, 0.9018619917312232],
            [-19.257922489382736, 0.8743007012029365],
            [-19.256258577326403, 0.8695228017718086],
            [-19.263828546730622, 0.8619295181377044],
            [-19.27044956289063, 0.8601372486704894],
            [-19.275538221683664, 0.8552788013532862],
            [-19.28174541900008, 0.8448344244076861],
            [-19.279780367657107, 0.8383859166284034],
            [-19.275785110711272, 0.836318608925432],
            [-19.275974013834862, 0.825905962914714],
            [-19.271824376809985, 0.8281303633463093],
            [-19.265701231268828, 0.8243998018535232],
            [-19.257249322324526, 0.8250433201578318],
            [-19.253769487197513, 0.822365288454822],
            [-19.250296964266457, 0.8220055046406111],
            [-19.247903370009123, 0.8159770469586465],
            [-19.24881038920616, 0.8097741035570768],
            [-19.251314861362726, 0.8046521053163574],
            [-19.249289155711452, 0.7978533182086794],
            [-19.24633201878299, 0.7921347612015333],
            [-19.242923193050128, 0.7908034133845887],
            [-19.241757332168007, 0.7847571723203489],
            [-19.242972001355664, 0.7831869333870058],
            [-19.2426544453377, 0.7739136732445913],
            [-19.235299526835675, 0.7678471150166063],
            [-19.236427243046514, 0.7645555780271373],
            [-19.235230472099982, 0.7557348733958039],
            [-19.232988301532927, 0.7472963902735873],
            [-19.23438246431945, 0.737584817798335],
            [-19.220016171562634, 0.7239454848159393],
            [-19.141846525588964, 0.6527659973495863],
            [-19.13659476214023, 0.6474209700475497],
            [-19.097359306359692, 0.6118037844941984],
            [-19.08905752864402, 0.5977394242741801],
            [-19.065409469477775, 0.5549934710076317],
            [-19.054163426445527, 0.5355238272563178],
            [-18.99534295357348, 0.43242056741708756],
            [-18.99435895414234, 0.43124944006023636],
            [-18.97152499626261, 0.39087352325806785],
            [-18.92009349031442, 0.3002949311181957],
            [-18.91261358340391, 0.2872720916360898],
            [-18.90757194522528, 0.2859299109132059],
            [-18.921455230046, 0.23347281853653482],
            [-18.92665816714011, 0.21466689995170166],
            [-18.941711832895052, 0.15639266630796045],
            [-18.94838423668636, 0.12991926517695515],
            [-18.951262500716453, 0.13047035107737914],
            [-18.956287673501848, 0.1276658719423824],
            [-18.96175397589704, 0.12915444569659085],
            [-18.962093697810815, 0.12638214270040632],
            [-18.967358491395167, 0.12484573804688963],
            [-18.968610488058484, 0.12635647358391558],
            [-18.977183581038524, 0.125456210163625],
            [-18.978894530707947, 0.12724443961215642],
            [-18.986407218803574, 0.1301014386052684],
            [-18.989258561489386, 0.1290343764252384],
            [-19.003391821438242, 0.12977413953601163],
            [-19.01098739064793, 0.12279647893546053],
            [-19.015960215827228, 0.12111657823419524],
            [-19.019038380189812, 0.11730010098188937],
            [-19.023676813930006, 0.11433167318734305],
            [-19.02289730329129, 0.11019747267816819],
            [-19.025783493134732, 0.10690665122985388],
            [-19.01994109733347, 0.10076331863801406],
            [-19.023566674469105, 0.09449583322699055],
            [-19.022759889609258, 0.09141671464506076],
            [-19.027510321913866, 0.08702305782232282],
            [-19.02878569615137, 0.09176935931468395],
            [-19.03311402293297, 0.09282234212788586],
            [-19.034850632172365, 0.09555451222256467],
            [-19.038254732622654, 0.10613537520374132],
            [-19.04181639438827, 0.11143900557389277],
            [-19.045187295927878, 0.11098079662935871],
            [-19.054590298435524, 0.12226402368865745],
            [-19.05937229289402, 0.13095868329889368],
            [-19.065707103973683, 0.13741948942846355],
            [-19.06890304192356, 0.1428609457288151],
            [-19.07203983072958, 0.1433728754670306],
            [-19.077190117243457, 0.13988878088102621],
            [-19.073485781699784, 0.13742864507511277],
            [-19.069335756717322, 0.13025784753599634],
            [-19.06816106997164, 0.11969940398881236],
            [-19.065786684559566, 0.1148312684042223],
            [-19.066659285373504, 0.10583993482044196],
            [-19.062417980414168, 0.09943995460519574],
            [-19.062911246387692, 0.09600305030454674],
            [-19.05960030883675, 0.08792293145444166],
            [-19.060421224361217, 0.07965563814236146],
            [-19.059618624126294, 0.0770574606696564],
            [-19.059273851237535, 0.05407766638785595],
            [-19.064003361293537, 0.033580176650595976],
            [-19.06594339566262, 0.030792501463349782],
            [-19.071745723119815, 0.026976737405547235],
            [-19.076559166491467, 0.02645987736942227],
            [-19.077402203871063, 0.029512736452311797],
            [-19.08483927249287, 0.035661075534449437],
            [-19.088361738349114, 0.036202083311454476],
            [-19.09296611898895, 0.03425914945735],
            [-19.09936030099086, 0.03458683288899397],
            [-19.106305372242943, 0.03985145166803218],
            [-19.108383099472928, 0.043472347714126364],
            [-19.108423700657813, 0.04772961758266512],
            [-19.110470503672268, 0.04993529740297593],
            [-19.110684166261077, 0.05623199230605542],
            [-19.117355389922732, 0.06654961543153086],
            [-19.118134624427295, 0.07108467976470526],
            [-19.122310125697435, 0.0738423032920042],
            [-19.12136692709168, 0.07825630893515867],
            [-19.12869280802146, 0.08070823490235512],
            [-19.132521363732884, 0.0866326756367173],
            [-19.132831540537943, 0.08992403954696525],
            [-19.136378475023225, 0.09291513576563457],
            [-19.134188249115955, 0.09577994229176086],
            [-19.135951907179248, 0.10105825617691594],
            [-19.13950607722039, 0.10219080030155221],
            [-19.140835008588088, 0.10538684113352978],
            [-19.148169100865893, 0.1136656638550487],
            [-19.150745268061833, 0.12327265410499227],
            [-19.149875018671963, 0.12938239438104912],
            [-19.152427458481785, 0.13450183863328047],
            [-19.15576415838767, 0.13622529514625165],
            [-19.156502147710082, 0.1408940346802869],
            [-19.160122803473374, 0.14201560373196814],
            [-19.164849758838407, 0.1500398619792151],
            [-19.174647045807536, 0.155590911659851],
            [-19.18162780817866, 0.1547955618432101],
            [-19.18591871778962, 0.15559242987722177],
            [-19.188888329839145, 0.16502606904384073],
            [-19.192871152755142, 0.16770357190375929],
            [-19.196423817598024, 0.1720855064535405],
            [-19.1967149229431, 0.17497183447028905],
            [-19.20221988618816, 0.17929275874681558],
            [-19.20561308522887, 0.17910710531018298],
            [-19.208342677819594, 0.17613471562357674],
            [-19.209105406507856, 0.17189230332671626],
            [-19.21543020926353, 0.17111646219146373],
            [-19.21950296890826, 0.1663404086897459],
            [-19.21883057462565, 0.1625267818226203],
            [-19.22513109652416, 0.15995874804865207],
            [-19.224366881386654, 0.15647470616052034],
            [-19.22778569225892, 0.15427521164544292],
            [-19.23767036463198, 0.15089604941282705],
            [-19.239824021668756, 0.1528002396332119],
            [-19.240488448683372, 0.15795210397010245],
            [-19.243159545442264, 0.15897330990029734],
            [-19.2491694718641, 0.17014852815204776],
            [-19.257997426315164, 0.17256752114617396],
            [-19.26162328437036, 0.1683344367955408],
            [-19.263826585389186, 0.15838107374789087],
            [-19.268991887810266, 0.15431891061666303],
            [-19.274740448645012, 0.15679279841805363],
            [-19.279095333706202, 0.1540600762980094],
            [-19.28318948655287, 0.15701948032020205],
            [-19.287333911538514, 0.1571513115684567],
            [-19.29213232686761, 0.14980715163955088],
            [-19.294291536076962, 0.15230324001779866],
            [-19.2984846670216, 0.15178069207355266],
            [-19.296946728724393, 0.16172014948999847],
            [-19.294028691258383, 0.16342165693500038],
            [-19.294773997019554, 0.16705162965636486],
            [-19.29937260426493, 0.1680353756306763],
            [-19.305517330938056, 0.16546152540794537],
            [-19.29209640467454, 0.21704780843140614],
            [-19.334441832209723, 0.2922485078679214],
            [-19.37751136461005, 0.367515102389267],
            [-19.379358752696803, 0.3742561065880708],
            [-19.378281437087026, 0.3774667392089927],
            [-19.380882528616823, 0.38118033975396126],
            [-19.382403066631326, 0.3862816354020065],
            [-19.385048648214415, 0.3894919183040079],
            [-19.386884065565162, 0.3987911377338224],
            [-19.391000683472946, 0.40053426117491175],
            [-19.3951704567067, 0.39976155712080186],
            [-19.39741053546216, 0.4038069904540389],
            [-19.39728049169391, 0.40720292702121486],
            [-19.393863423861628, 0.4125946538917025],
            [-19.395957151213835, 0.4181957578771359],
            [-19.39412427015368, 0.42044457366957355],
            [-19.397143244012074, 0.4271113102704373],
            [-19.397648341655753, 0.43332789513112285],
            [-19.40023436891448, 0.4376688228403357],
            [-19.41145953433282, 0.4382374572019864],
            [-19.418637755867493, 0.43792963103678356],
            [-19.42540766917554, 0.44074315561346933],
            [-19.43046824798754, 0.44150025353383315],
            [-19.43195607963594, 0.44503510394591744],
            [-19.439196796893764, 0.4474395726606242],
            [-19.44178259550934, 0.44587081103184123],
            [-19.445245567133487, 0.4480015465504161],
            [-19.452062117048065, 0.44410348861385845],
            [-19.453349145825385, 0.4477694622185544],
            [-19.450935832751444, 0.4534030074544751],
            [-19.446981189556446, 0.45590817534601485],
            [-19.44607712610561, 0.4605146494311311],
            [-19.437023649012925, 0.46537457445183766],
            [-19.434253942435333, 0.4680860229454736],
            [-19.43396050234469, 0.47342919595277067],
            [-19.44210955962011, 0.49407285283999014],
            [-19.444259558563214, 0.49420109660394473],
            [-19.44745882261012, 0.49855757200249395],
            [-19.452666748711703, 0.5027363704293554],
            [-19.45086514665838, 0.5085410163732418],
            [-19.451794048086956, 0.5134638563799555],
            [-19.450278710614327, 0.5178450049286473],
            [-19.45129221625861, 0.5222028996380186],
            [-19.448868244493, 0.5234519348391916],
            [-19.44235176940505, 0.5233882975043959],
            [-19.442219865027273, 0.5295021996899633],
            [-19.440303662149145, 0.533607600066301],
            [-19.43805592580296, 0.5437421040741911],
            [-19.436078406730736, 0.5473117560509584],
            [-19.429894237418985, 0.5536387803437602],
            [-19.437788921216466, 0.566605425905521],
            [-19.440370705609926, 0.575718839551724],
            [-19.4424118790132, 0.5793749660614704],
            [-19.442398160614374, 0.5836210674005153],
            [-19.440255915002254, 0.58575058177531],
            [-19.442724255152623, 0.5918069979475463],
            [-19.444636185616904, 0.5921126894078157],
            [-19.44609246298299, 0.5993255901651559],
            [-19.454206325231045, 0.6087938520784728],
            [-19.460015703919154, 0.609420543922912],
            [-19.464473779614945, 0.6079134512938958],
            [-19.46988728226386, 0.6115327242273152],
            [-19.4818882481953, 0.6153617962615867],
            [-19.486463895965382, 0.6179074467952314],
            [-19.485943493147325, 0.6224782299735191],
            [-19.48759870610549, 0.6353833676435334],
            [-19.490915741758347, 0.6363246134403546],
            [-19.498371775593082, 0.6442707519579584],
            [-19.50963891206733, 0.6415191691091505],
            [-19.51212119184853, 0.6480758888207322],
            [-19.516862234999024, 0.6527297637953724],
            [-19.518756083267416, 0.6581938315117121],
            [-19.522706087996255, 0.6572262079732853],
            [-19.52449042719264, 0.6595774272330877],
            [-19.52511959658799, 0.6706211376750386],
            [-19.5268220370767, 0.6720601818569408],
            [-19.52974077998424, 0.6888222755871309],
            [-19.52821613186743, 0.6909548057495621],
            [-19.52325626291709, 0.6893411595930434],
            [-19.521006510879197, 0.6902654130977953],
            [-19.510971837803904, 0.6884589322306071],
            [-19.501210942002427, 0.6932706723702637],
            [-19.501031062354496, 0.6978441893545966],
            [-19.504579616521518, 0.7036544136672576],
            [-19.50354840665634, 0.7108177822253696],
            [-19.50732772720953, 0.716685479954584],
            [-19.511032279184956, 0.7175905618149914],
            [-19.513293839361708, 0.7221490363814284],
            [-19.5129438928511, 0.7264552317127932],
            [-19.510316797880428, 0.729143576642707],
            [-19.512894171908385, 0.7344641790826557],
            [-19.5136965615091, 0.7392712084290611],
            [-19.52248616502711, 0.7394373717938453],
            [-19.526956856489324, 0.7376152335420126],
            [-19.533729404670545, 0.7379192215267991],
            [-19.55661051929587, 0.7814607502646816],
            [-19.57063565019002, 0.8100112304654534],
            [-19.58300057513333, 0.8336323786755904],
            [-19.59925697107611, 0.8473934467068007],
            [-19.607499923266314, 0.8784720523083921],
            [-19.60487319616555, 0.8841623039675348],
            [-19.603134329169574, 0.898523585118904]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.07495633804578,
          "lat": 36.605691415332124
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06069"],
        "coty_name": ["San Benito"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Benito County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00277299"
      },
      "bbox": [
        -19.607499923266314, 0.02645987736942227, -18.90757194522528,
        0.9526735354546005
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-6.424245470816311, 1.5989351958321991],
              [-6.422471560824546, 1.5973981608145378],
              [-6.40194667547997, 1.5953316706340008],
              [-6.40112639440392, 1.6034272310263356],
              [-6.404581728282539, 1.6065380043885948],
              [-6.403973657805771, 1.6125935655145816],
              [-6.40984112173748, 1.6099977900495819],
              [-6.419591481108385, 1.601559010821821],
              [-6.424245470816311, 1.5989351958321991]
            ]
          ],
          [
            [
              [-6.339603815043274, 1.6656297220552532],
              [-6.339947936337294, 1.6620481476310611],
              [-6.334776242020152, 1.661584793529414],
              [-6.334422777572188, 1.6651229296766394],
              [-6.339603815043274, 1.6656297220552532]
            ]
          ],
          [
            [
              [-6.477469819857731, 1.5580540385456456],
              [-6.475933260838756, 1.5731581594893955],
              [-6.468796363953665, 1.572462694957769],
              [-6.467732284212804, 1.5832865739303104],
              [-6.460622961868942, 1.5825063128692318],
              [-6.459091156616074, 1.5971098312876801],
              [-6.454511288732931, 1.596655766246697],
              [-6.453782126976688, 1.5929037177318377],
              [-6.445316899380623, 1.592204216977723],
              [-6.446037416148249, 1.5848712232154007],
              [-6.453009454490463, 1.585416933417554],
              [-6.454075803550371, 1.575133486241872],
              [-6.450220980506482, 1.5736428680508794],
              [-6.446644380289418, 1.5776316429537725],
              [-6.432749491968532, 1.5762125575733976],
              [-6.432218268769128, 1.5834887797861625],
              [-6.421297432699054, 1.582490867660586],
              [-6.420551531069566, 1.5897251706358524],
              [-6.4170537064465565, 1.589045768376687],
              [-6.416412925945483, 1.5965566037143382],
              [-6.424804680136613, 1.597487918486715],
              [-6.4283314890298335, 1.5998092072441266],
              [-6.422113418783368, 1.6009350978453727],
              [-6.419296838759936, 1.6028502432534903],
              [-6.412161201093538, 1.6095893753646793],
              [-6.399972155783804, 1.6152564724681877],
              [-6.397824088474323, 1.6379387538782393],
              [-6.363860319200878, 1.6349293003567746],
              [-6.3632497054484425, 1.6420635671007004],
              [-6.349376296493791, 1.6408459206602737],
              [-6.348664103804974, 1.6480849842611238],
              [-6.355805032289796, 1.6487594621677015],
              [-6.353188791149743, 1.6531164064893835],
              [-6.35472234065651, 1.6596900287304661],
              [-6.345304473811924, 1.6588199453121197],
              [-6.344937582528156, 1.6623416214257996],
              [-6.340054034089554, 1.6619822057602587],
              [-6.338736938840358, 1.6747253254421073],
              [-6.337526277035122, 1.6764111294615311],
              [-6.3243839230998695, 1.6754270208342428],
              [-6.3287332383361825, 1.631452157616653],
              [-6.343500293494419, 1.6328374499774434],
              [-6.349789517678041, 1.6199944555645007],
              [-6.351011421465481, 1.608643907355438],
              [-6.356015731422656, 1.6091763020061607],
              [-6.358370585024136, 1.6056971416981483],
              [-6.3515966451564045, 1.6050809014604661],
              [-6.35198864638896, 1.601359724976735],
              [-6.358756054953641, 1.6020645217287457],
              [-6.357776602228826, 1.6148253660639273],
              [-6.37170352423661, 1.6161282984006922],
              [-6.373977532736832, 1.5899928427476013],
              [-6.372147713539065, 1.5849101810579513],
              [-6.367423645188228, 1.5845574685939146],
              [-6.3677456886211345, 1.580905564362146],
              [-6.360784459103251, 1.5802110929386939],
              [-6.361098025101493, 1.576660717957056],
              [-6.375199578682866, 1.577891047205294],
              [-6.377143251877293, 1.5559620545660462],
              [-6.3914587965864715, 1.5573878257170481],
              [-6.392107398894931, 1.5501632328646682],
              [-6.406133876717262, 1.5515450146792726],
              [-6.411713402079554, 1.5502832992055848],
              [-6.414012889667291, 1.5450021378594132],
              [-6.42111300878043, 1.5456742048615362],
              [-6.42173833871758, 1.5384513165448452],
              [-6.431228342233287, 1.5393652474369144],
              [-6.436156632066451, 1.538891136217544],
              [-6.440662897862655, 1.5402203915678556],
              [-6.443009888533218, 1.5428962935926585],
              [-6.442797121588532, 1.549394618991131],
              [-6.447272717283692, 1.5529571589862907],
              [-6.44829453142544, 1.555495817293883],
              [-6.477453079995116, 1.5580534366062198],
              [-6.4789990651600196, 1.544219939433321],
              [-6.464846685517289, 1.5427450600267307],
              [-6.467222153211704, 1.5355872824879349],
              [-6.470553871953052, 1.532457216119901],
              [-6.48007947367705, 1.5333809482742615],
              [-6.493625146837065, 1.536403451894132],
              [-6.491828670581846, 1.5560093091972034],
              [-6.477469819857731, 1.5580540385456456]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.05269225550133,
          "lat": 39.95400939742177
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08014"],
        "coty_name": ["Broomfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Broomfield County"],
        "coty_fp_code": "014",
        "coty_gnis_code": "01945881"
      },
      "bbox": [
        -6.493625146837065, 1.532457216119901, -6.3243839230998695,
        1.6764111294615311
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.401134224415158, 1.2861622882306292],
            [-5.398750395597698, 1.3154802351113444],
            [-5.379328055422739, 1.5476670300355215],
            [-5.379120532102551, 1.5490489063473696],
            [-5.321558822647488, 1.5444159254732928],
            [-5.281243234828779, 1.5413501216248824],
            [-5.273742259387347, 1.540599726150768],
            [-5.202267584351646, 1.5350679076510125],
            [-5.183935840432731, 1.7735145884936878],
            [-5.182436790983256, 1.7848794213579589],
            [-5.17528008582535, 1.8679978582837533],
            [-5.173912424430353, 1.8851400995755885],
            [-5.169112517518467, 1.88492523295981],
            [-5.16454358966671, 1.9421395693056283],
            [-5.162837183598685, 1.9718438332729633],
            [-5.11896501563252, 1.9684204430792727],
            [-5.094260388854112, 1.9654246987320145],
            [-4.989597362677429, 1.95816753071375],
            [-4.933390325602865, 1.954506889997911],
            [-4.875534751843472, 1.950271111989044],
            [-4.760604384021689, 1.9430237095076177],
            [-4.647015483751041, 1.9352608289965698],
            [-4.653458825498971, 1.8474687657913873],
            [-4.663546617972358, 1.8483284676308775],
            [-4.672859886252935, 1.7159570722147237],
            [-4.6776556725489735, 1.6576649519510573],
            [-4.680803488815269, 1.6139565084058471],
            [-4.6884714140940815, 1.4974257110830396],
            [-4.696388104249418, 1.4980544666219744],
            [-4.698851929911985, 1.455405580512153],
            [-4.7062411254152785, 1.3250648701921328],
            [-4.715334171217284, 1.214117206771341],
            [-4.715275935796927, 1.2070544709307178],
            [-4.71819617786979, 1.174203143661998],
            [-4.727133411190245, 1.0604939239083633],
            [-4.774200897804481, 1.064554305158245],
            [-4.841288096311101, 1.0693142434700686],
            [-4.8987310574609975, 1.072745647412769],
            [-4.903064868234174, 1.0732175679453595],
            [-4.994653612840567, 1.0782637235836563],
            [-4.994969198686266, 1.077978830185206],
            [-4.995387738821508, 1.0783089593048305],
            [-5.0864318794428565, 1.085763568806097],
            [-5.165260079230217, 1.09157456790497],
            [-5.2363518985531154, 1.0968570979058545],
            [-5.3629806267593265, 1.1072443502506712],
            [-5.415726223308416, 1.111584642397759],
            [-5.401134224415158, 1.2861622882306292]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.20127294762774,
          "lat": 39.97102577767365
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08121"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00198176"
      },
      "bbox": [
        -5.415726223308416, 1.0604939239083633, -4.647015483751041,
        1.9718438332729633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.2842358126055, 4.737883519054653],
            [17.29334820612983, 4.731715027145358],
            [17.304024797088093, 4.734114816948096],
            [17.306789802004968, 4.727860986310792],
            [17.301517266265005, 4.707132315931273],
            [17.301877135873365, 4.6862135642429585],
            [17.290780886456275, 4.643969798142525],
            [17.320744860243195, 4.619467508011778],
            [17.333904321603665, 4.6231786333921745],
            [17.34326943708842, 4.611273364215127],
            [17.345002013860515, 4.613550746611711],
            [17.36803981442682, 4.631004404885329],
            [17.370034568789073, 4.629907760524445],
            [17.373976252184992, 4.623177351680494],
            [17.377472119631424, 4.6236900135291155],
            [17.380962408523647, 4.62137269693576],
            [17.383422977380775, 4.622873629289516],
            [17.387004972342005, 4.621179129423205],
            [17.385742338349907, 4.612400701761101],
            [17.379760697362823, 4.6043930113881775],
            [17.376261020047203, 4.592473057029866],
            [17.37688455650944, 4.588383400976091],
            [17.380089359164394, 4.581924941409805],
            [17.379746464161368, 4.577391612078344],
            [17.380947081841228, 4.571271129168187],
            [17.38285140584498, 4.567908728070536],
            [17.380978413436097, 4.5564815962845655],
            [17.378265642003804, 4.55064376786934],
            [17.378379028215015, 4.544876711476409],
            [17.381994621262542, 4.538310895673352],
            [17.392253049327415, 4.5336347755529705],
            [17.392730886873274, 4.524381365239601],
            [17.396135953616945, 4.520901697924507],
            [17.400784461746472, 4.520603695876451],
            [17.400041090181052, 4.517597338612463],
            [17.394363228204167, 4.51557050866218],
            [17.381396837187594, 4.508257796266536],
            [17.348025153474847, 4.512806454286793],
            [17.3477014974472, 4.518802299924049],
            [17.342151372585487, 4.519260178948425],
            [17.337920830258994, 4.515872751669392],
            [17.337826144339044, 4.5105375402944095],
            [17.32616408164191, 4.506460800998648],
            [17.322071230056128, 4.502002133714186],
            [17.319148306761182, 4.4947704535505775],
            [17.314912944847844, 4.498777203779384],
            [17.31170125812412, 4.487323677368825],
            [17.306030192640602, 4.486967039808247],
            [17.304361320697172, 4.470210598873401],
            [17.297830175608294, 4.465304370124261],
            [17.292362238027938, 4.456945270832446],
            [17.28242978181598, 4.457531053875935],
            [17.278700199350226, 4.461348576648039],
            [17.27235398664223, 4.46212110788218],
            [17.26439421411743, 4.456970469035082],
            [17.264175151301277, 4.466113395410541],
            [17.26046263365331, 4.472426580382887],
            [17.25957175650991, 4.476511623008155],
            [17.256001061264094, 4.476727980401018],
            [17.25367616099249, 4.482430360242032],
            [17.25188057733242, 4.482427004390379],
            [17.229301794812557, 4.506591423345574],
            [17.218956157623413, 4.518101550572077],
            [17.221518940161747, 4.523439766224092],
            [17.22071897379665, 4.527129455014066],
            [17.22130661843996, 4.53820365304172],
            [17.22306424476466, 4.541513132695986],
            [17.223183222409084, 4.547446305485611],
            [17.22034163739551, 4.5522448467159595],
            [17.213638384937042, 4.558145714761514],
            [17.20463683956429, 4.567464162446137],
            [17.17781385526717, 4.591319415987679],
            [17.204022419472786, 4.613366405154266],
            [17.218756071651583, 4.624803431307592],
            [17.205867397256704, 4.6363230682025875],
            [17.198032022167688, 4.645327668420473],
            [17.236587648088012, 4.688324694053673],
            [17.256231406420767, 4.708942917114331],
            [17.25843294168388, 4.704026285590049],
            [17.26489225044023, 4.705024280154051],
            [17.275258055225645, 4.715556010638341],
            [17.272557053075577, 4.72205883829257],
            [17.275727324950047, 4.726525411382953],
            [17.276590282037997, 4.732728374686627],
            [17.281675678914787, 4.734379048036526],
            [17.2842358126055, 4.737883519054653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.2314369395507, "lat": 41.24283935714417 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09120"],
        "coty_name": ["Greater Bridgeport"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Greater Bridgeport Planning Region"],
        "coty_fp_code": "120",
        "coty_gnis_code": "02830245"
      },
      "bbox": [
        17.17781385526717, 4.456945270832446, 17.400784461746472,
        4.737883519054653
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.089703534467304, -7.32839447660762],
            [12.227884040427663, -7.318788968278215],
            [12.2651174526958, -7.316459567042961],
            [12.263476896168305, -7.320039280557178],
            [12.258733243958444, -7.320319391990113],
            [12.25454573063203, -7.323954407913964],
            [12.250173035089835, -7.330601407721538],
            [12.251261550794519, -7.338068268640559],
            [12.247974482882102, -7.342136778022261],
            [12.247813520043852, -7.349850247239559],
            [12.252410053231793, -7.355829880351719],
            [12.257614207720849, -7.359493474164387],
            [12.259623723291766, -7.365163864097951],
            [12.259295902247253, -7.368710591928898],
            [12.265223897306026, -7.377403199285818],
            [12.271291304878313, -7.380183586867894],
            [12.28334298665687, -7.390800874132586],
            [12.288595190871506, -7.396781389775022],
            [12.290556941086077, -7.407268807465364],
            [12.288235782491721, -7.4131989237611124],
            [12.28681454439543, -7.421805066633775],
            [12.28749088646325, -7.425296975827721],
            [12.29052575469301, -7.429966283519709],
            [12.292310447688479, -7.437070919045117],
            [12.291248752720213, -7.444681266230244],
            [12.288985048390444, -7.4492896493372935],
            [12.289818503705728, -7.457430156795465],
            [12.298418049102592, -7.479536598035349],
            [12.306662723099155, -7.490402384948822],
            [12.31091296298027, -7.494550419537992],
            [12.311238243491795, -7.500316666974142],
            [12.315070403493403, -7.501952155304043],
            [12.318550234215417, -7.500875979159665],
            [12.319763648930625, -7.5041661974759855],
            [12.323722056976827, -7.508698148904214],
            [12.333620989221263, -7.516993589104293],
            [12.340848397029122, -7.517025334600989],
            [12.343657455372538, -7.5145469991269565],
            [12.355786121789981, -7.509288878752858],
            [12.378130438161913, -7.50207540903791],
            [12.387828762368809, -7.499672261795722],
            [12.397575105064533, -7.505816817743329],
            [12.409435930436109, -7.506065998434958],
            [12.420093865638627, -7.504127159751882],
            [12.435445430358198, -7.49866729913286],
            [12.445924956172824, -7.5673979272070815],
            [12.449099529025638, -7.585960046665611],
            [12.461620821697137, -7.670925478428717],
            [12.468023481517013, -7.713924460532408],
            [12.388440059157205, -7.725563335150074],
            [12.329104796103213, -7.734765822933247],
            [12.32594053553437, -7.735052360625606],
            [12.265215351397952, -7.744785433221805],
            [12.20345337323428, -7.754347916128448],
            [12.2037155509721, -7.756061775894874],
            [12.131839812600457, -7.767532314138195],
            [12.119508453508118, -7.7709268081028],
            [12.103064581857495, -7.652174598679411],
            [12.094622684903593, -7.594914165734584],
            [12.075981698321794, -7.4698909906468485],
            [12.077040370154839, -7.469740405240079],
            [12.055347805506585, -7.334256711565244],
            [12.054587332453874, -7.330845181719742],
            [12.089703534467304, -7.32839447660762]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.28459170379983, "lat": 30.33108918929295 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12003"],
        "coty_name": ["Baker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baker County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00306920"
      },
      "bbox": [
        12.054587332453874, -7.7709268081028, 12.468023481517013,
        -7.316459567042961
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.183810959436904, -7.975534128967255],
            [12.185475336031283, -7.972460851290671],
            [12.19186849437825, -7.970421840482794],
            [12.195762817341961, -7.971641069353178],
            [12.198311398256696, -7.969598010874585],
            [12.207708192119583, -7.96964287868647],
            [12.212637115872987, -7.966346001439944],
            [12.217683824447006, -7.960509980793096],
            [12.223764129397834, -7.957538387257149],
            [12.2321759484256, -7.958396278629269],
            [12.23913538512492, -7.9532102504246724],
            [12.243693012367883, -7.9384559045228436],
            [12.241987956511013, -7.933411148129835],
            [12.243635392032322, -7.928931706759096],
            [12.252433177152335, -7.928985729665715],
            [12.259277187656743, -7.9320750772192],
            [12.264806457353464, -7.932487597904933],
            [12.27446048856819, -7.929447123617924],
            [12.27642232059668, -7.9269281875029405],
            [12.278375408452197, -7.9176660306136],
            [12.28602525212416, -7.908079912958836],
            [12.291411365280647, -7.898196132121268],
            [12.295216306549596, -7.887068155758049],
            [12.297542467731086, -7.882958402267941],
            [12.297736593295397, -7.875403899099448],
            [12.300348352315076, -7.871665500676824],
            [12.304719787576582, -7.853013507052425],
            [12.311156243577273, -7.852038907119526],
            [12.31833526663033, -7.848775705343023],
            [12.32025446659633, -7.849500812640223],
            [12.333207673516837, -7.842711961837104],
            [12.338842276969272, -7.8343686297493855],
            [12.33926532208355, -7.830795187828099],
            [12.342597696868221, -7.8292705124263],
            [12.345932748568472, -7.822374450506495],
            [12.362312097796156, -7.807838305113001],
            [12.367134944789946, -7.800748665997545],
            [12.368394787915415, -7.796536598395782],
            [12.368995437025793, -7.780412784039005],
            [12.37145312626268, -7.772069765674305],
            [12.389189680767707, -7.758680766899655],
            [12.39251704895852, -7.751861071697851],
            [12.394378838015886, -7.743940540759009],
            [12.394466981762449, -7.739022708101522],
            [12.391667251123637, -7.735517945509404],
            [12.387392686146217, -7.7368278724935005],
            [12.38685105188756, -7.730921430625418],
            [12.388440059157205, -7.725563335150074],
            [12.468023481517013, -7.713924460532408],
            [12.480989524223812, -7.799510824834155],
            [12.491348191079139, -7.860341931146384],
            [12.493621163824217, -7.875762831196966],
            [12.493659871191861, -7.880007173738609],
            [12.498924050101706, -7.914546266007042],
            [12.516438509197211, -8.023265361787937],
            [12.517897303495863, -8.030932937070089],
            [12.520765943701447, -8.05198438548865],
            [12.522332442637753, -8.059843469937968],
            [12.52534594809747, -8.080513337451851],
            [12.528840883430238, -8.101903757979434],
            [12.530316734414114, -8.130182516120513],
            [12.524901276710803, -8.13141345585177],
            [12.525165535017862, -8.124396480569835],
            [12.523845634040466, -8.117077386770498],
            [12.52046423683873, -8.106055494492175],
            [12.518593782982403, -8.102709413308327],
            [12.50966233263622, -8.095315012285049],
            [12.505955751437197, -8.093114133776817],
            [12.500506924012809, -8.091949666519305],
            [12.495409106279627, -8.092651144902895],
            [12.4968085942841, -8.086652026830878],
            [12.496093062196017, -8.077777198419026],
            [12.49127403913164, -8.075717069454948],
            [12.48345031172875, -8.076458435766368],
            [12.476230016972252, -8.07331082436577],
            [12.469508956815679, -8.07456603505205],
            [12.468598156694602, -8.067060166562058],
            [12.461182012167656, -8.068258877988331],
            [12.460037568464328, -8.060821869491143],
            [12.455502694897204, -8.054327029713143],
            [12.453463829768472, -8.054667960418511],
            [12.450898007670274, -8.036617125517349],
            [12.445744653154662, -8.037378300696927],
            [12.44449434992844, -8.030401279089912],
            [12.441966997286041, -8.030782077117303],
            [12.441220189018095, -8.025743729422059],
            [12.429705926167186, -8.027472370420885],
            [12.428831903948419, -8.024762022260166],
            [12.416119807963236, -8.026592779154546],
            [12.413418058130182, -8.026166776332472],
            [12.40669883738149, -8.029730796720905],
            [12.398505080866933, -8.0272065726145],
            [12.39045114903798, -8.02095873032462],
            [12.383740480612317, -8.021810635601314],
            [12.377466092248005, -8.025440055242882],
            [12.353769486361601, -8.029059471725764],
            [12.353115707858032, -8.025465612252441],
            [12.343636290721472, -8.023417329331537],
            [12.336805187218582, -8.026710206767074],
            [12.330547280988192, -8.031140474924458],
            [12.326429349891407, -8.030784659336739],
            [12.323080934729086, -8.034747836997608],
            [12.312446161981736, -8.035867530162884],
            [12.308131946500302, -8.032973629143356],
            [12.299226841701088, -8.02974733097847],
            [12.291301820247293, -8.03017338535423],
            [12.290180446862918, -8.023572400063818],
            [12.282704929875381, -8.024611048636633],
            [12.281382328356106, -8.017145523512932],
            [12.273801032810443, -8.018605206557424],
            [12.26746136674976, -8.01248201531188],
            [12.264319050939902, -8.012150555658602],
            [12.261964510456346, -8.008806035936969],
            [12.255145465355817, -8.01188723482416],
            [12.245593412574083, -8.011337637052627],
            [12.242068535838536, -8.013000737034075],
            [12.238819191135649, -8.009677599126752],
            [12.232267722850015, -8.01262740621574],
            [12.227528299059902, -8.013015595644864],
            [12.225366794901278, -8.011367936879603],
            [12.216532372337015, -8.012113331267473],
            [12.209882301532922, -8.00836957780955],
            [12.207273783403458, -8.00926353788505],
            [12.203787771828338, -8.005798705615343],
            [12.19654589266152, -7.989455079958757],
            [12.196841959879242, -7.985582490977403],
            [12.190755673259009, -7.977058959300972],
            [12.183810959436904, -7.975534128967255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.16875345242535, "lat": 29.95003589305675 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12007"],
        "coty_name": ["Bradford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bradford County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00303634"
      },
      "bbox": [
        12.183810959436904, -8.13141345585177, 12.530316734414114,
        -7.713924460532408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.615290053240342, -9.070629299397217],
            [13.626657193453807, -9.069165868719278],
            [13.634729310281285, -9.066241077783205],
            [13.604246042959934, -8.895458125859344],
            [13.679624259537679, -8.882607281508093],
            [13.807725017881772, -8.86209219131881],
            [13.833352944295369, -8.892513275289152],
            [13.900125786024134, -8.960529516937367],
            [13.904184187041102, -8.964161548791536],
            [13.933550170846537, -8.998408401103914],
            [13.956243033891788, -9.019789324913893],
            [13.968050112875996, -9.029647216998242],
            [13.978417864936075, -9.040320251752012],
            [13.98370885257802, -9.051136011012744],
            [13.988099569109258, -9.061707197488289],
            [13.994010767338159, -9.080007169800117],
            [13.9987504103616, -9.091551339899487],
            [14.007380934874536, -9.10704501430031],
            [14.017157878557608, -9.120461582435777],
            [14.02876849619027, -9.138687811807795],
            [14.041454373015181, -9.15578772674168],
            [14.042056867282328, -9.160106408033375],
            [14.03966814778393, -9.165816222916144],
            [14.034112896251997, -9.169428260219593],
            [14.031182836054109, -9.169995862205623],
            [14.016461171627947, -9.1801076188775],
            [14.011624578486115, -9.184227025814208],
            [14.001214572007276, -9.198605249346537],
            [13.99817647486068, -9.205295099336327],
            [13.997285467281362, -9.210446523760126],
            [13.994156845018878, -9.214913563461417],
            [13.990376498090496, -9.237826056939424],
            [13.989261378464766, -9.2554448973477],
            [13.989418194469238, -9.268572208163638],
            [13.99028536790353, -9.284221794578746],
            [13.991695556913916, -9.295915361604093],
            [13.99659811623471, -9.325692711405168],
            [14.006078095216736, -9.364536260053168],
            [14.00668618707559, -9.36778057247505],
            [14.016142203721401, -9.396835725754785],
            [14.023807261052282, -9.421521981617055],
            [14.030338424162387, -9.438279627486162],
            [14.056724497151032, -9.50016996006692],
            [14.068371762029493, -9.523748003463158],
            [14.075486240006487, -9.536750100273059],
            [14.088093695049775, -9.557647124172583],
            [14.108371605167841, -9.589356091780171],
            [14.134667695459884, -9.628084854491108],
            [14.15354750836105, -9.654829133776822],
            [14.18330222160848, -9.693840187172617],
            [14.194055657163416, -9.70860160933308],
            [14.206418004310445, -9.724441391757198],
            [14.206515266887491, -9.725618597476796],
            [14.200662370161591, -9.73265449556238],
            [14.16898271724743, -9.737841054068976],
            [14.166327821363247, -9.741917155686881],
            [14.167487544963114, -9.74670641434762],
            [14.166505983495188, -9.754372746974731],
            [14.160661390329022, -9.764847536291324],
            [14.159048120591724, -9.765926718617413],
            [14.15848041589102, -9.771918444672629],
            [14.072527288863622, -9.785512476260422],
            [13.954522195850062, -9.803774187727978],
            [13.929447306031513, -9.807109428357874],
            [13.879254826646353, -9.815839441891876],
            [13.843045206589853, -9.821968713903189],
            [13.822651463683439, -9.700567530152357],
            [13.817878956382087, -9.671436761378457],
            [13.816813881291925, -9.666969542521075],
            [13.806789350264292, -9.602971193528234],
            [13.80490319247941, -9.594720051901781],
            [13.804381386654418, -9.586822819502501],
            [13.801253499023336, -9.567777985937592],
            [13.80687586928099, -9.566869726843512],
            [13.78242930571621, -9.409607121780944],
            [13.76542908274729, -9.311989872772468],
            [13.765305980144895, -9.311744243839088],
            [13.761545959723296, -9.309520280723737],
            [13.75349504823861, -9.299567819270111],
            [13.753196789153792, -9.291608386722643],
            [13.750431267444366, -9.288459683439608],
            [13.747096737927519, -9.289800212442675],
            [13.743924690657108, -9.282104034118376],
            [13.737178122499488, -9.275804709326014],
            [13.734969571484932, -9.271860377086458],
            [13.738649806870695, -9.267715743976847],
            [13.736303687974077, -9.263952582265901],
            [13.736027818876718, -9.253213375237443],
            [13.725312843751553, -9.245100751123736],
            [13.721145842801173, -9.234729798622086],
            [13.722896175212233, -9.229887949680153],
            [13.723112141216596, -9.222306038859287],
            [13.72610798937942, -9.220447836326063],
            [13.72395530795848, -9.216977064024253],
            [13.720348321247082, -9.215499427241722],
            [13.71744726530527, -9.212046114522014],
            [13.720675953664996, -9.208606345106476],
            [13.718962334755787, -9.199822911141332],
            [13.725323343865242, -9.196314838053162],
            [13.73546403023327, -9.195472853212008],
            [13.738714024014907, -9.192062446422616],
            [13.735106129951117, -9.188046054336848],
            [13.734860739816444, -9.182212021384798],
            [13.729714530560233, -9.175513414794692],
            [13.725404985520917, -9.17447532407463],
            [13.723578997078576, -9.171396949042315],
            [13.726774748516743, -9.168168639600244],
            [13.724539412825214, -9.162159409236846],
            [13.722755448010208, -9.16212770624549],
            [13.7196915218414, -9.15660555923361],
            [13.715457398280465, -9.15574459240965],
            [13.711794626815735, -9.158187715764745],
            [13.707161538074079, -9.15746728487269],
            [13.703275222227248, -9.158995687263973],
            [13.700542600007635, -9.156171794894634],
            [13.70156676297532, -9.153220690062165],
            [13.69958809800034, -9.149759734601423],
            [13.691138255853287, -9.1486901731838],
            [13.686995846332579, -9.14692451275333],
            [13.683427696477638, -9.139978224105514],
            [13.674393275550296, -9.140784128817833],
            [13.670812458033662, -9.138284609039365],
            [13.668401929279298, -9.133076321577683],
            [13.673674576623068, -9.133157078638343],
            [13.672105872168968, -9.129674489241522],
            [13.672414458693911, -9.122891505946914],
            [13.66992611507915, -9.11556700659303],
            [13.672828375454168, -9.111233630154821],
            [13.666074205574674, -9.104090139683048],
            [13.663365026868917, -9.103524864170927],
            [13.661451036256494, -9.09818532015511],
            [13.657991833544763, -9.09554402766497],
            [13.655549265679063, -9.09079047873559],
            [13.65647395279898, -9.083430073985499],
            [13.653113101373432, -9.080439652513897],
            [13.646837296438038, -9.077570390788525],
            [13.647096139132442, -9.074355229838613],
            [13.640580442498312, -9.076700479233027],
            [13.631913471821177, -9.075799563365162],
            [13.631448538386447, -9.072694479533297],
            [13.62782623308846, -9.07033199786147],
            [13.626232390930173, -9.074055609317497],
            [13.618785521159895, -9.0729044503081],
            [13.615290053240342, -9.070629299397217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.73231282335803,
          "lat": 28.293715127769254
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12009"],
        "coty_name": ["Brevard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brevard County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00295749"
      },
      "bbox": [
        13.604246042959934, -9.821968713903189, 14.206515266887491,
        -8.86209219131881
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.632889620938357, -8.297410637368776],
            [9.632863691349263, -8.294857701202286],
            [9.629034153549377, -8.267053346509991],
            [9.62223220273951, -8.223352665417758],
            [9.619119297634125, -8.195979923748103],
            [9.612333717751783, -8.126800798386],
            [9.609516886032504, -8.103497827263789],
            [9.607433623422033, -8.080025135078237],
            [9.602361269635216, -8.037664057449044],
            [9.601172880565338, -8.025065119151733],
            [9.604056464072933, -8.024333839199384],
            [9.643534186749797, -8.020736967716834],
            [9.738265450112761, -8.009932919641722],
            [9.756830560519562, -8.00768786791396],
            [9.836248170171592, -7.999625110787057],
            [9.83338728670537, -8.002307858045638],
            [9.830384789649534, -8.00787354649654],
            [9.829321997944742, -8.015034981162792],
            [9.827748548018047, -8.017550799672046],
            [9.822921597702438, -8.019306621218448],
            [9.823318317390646, -8.025042897602043],
            [9.819653926299793, -8.02889406839583],
            [9.82130180981862, -8.034428995776977],
            [9.819669740526807, -8.037922180562237],
            [9.824092349234634, -8.038672094756535],
            [9.825854348193804, -8.041223482662948],
            [9.824638499961678, -8.049933057431707],
            [9.822830720010128, -8.054687541428105],
            [9.82793612016107, -8.054878635813436],
            [9.828295094009578, -8.057164189407656],
            [9.824809816969525, -8.060346831961251],
            [9.825090612650703, -8.066015364282096],
            [9.819530710437936, -8.07233635342267],
            [9.819324643941725, -8.076718661871132],
            [9.82171267450275, -8.079364298610102],
            [9.830213375586672, -8.079204551157712],
            [9.833004389363683, -8.080403001311913],
            [9.831094598407383, -8.085047822081329],
            [9.82344376590899, -8.085448335047564],
            [9.825646630351821, -8.089764278985117],
            [9.820520880254431, -8.089558218266227],
            [9.817806079018451, -8.091029949729368],
            [9.822633124082213, -8.101551634261398],
            [9.818294226877425, -8.104578632737617],
            [9.815964728289392, -8.110397535040539],
            [9.822126213912686, -8.112430990830154],
            [9.824935007877233, -8.111703948872876],
            [9.830739761354902, -8.113440061743198],
            [9.833852238508852, -8.119410946932664],
            [9.831316884074496, -8.1271279876018],
            [9.832727292958156, -8.130175248887458],
            [9.83703225003531, -8.132807630384013],
            [9.833593049485081, -8.135810403426097],
            [9.835185689505495, -8.14665511220186],
            [9.837386166964006, -8.151364022757658],
            [9.837347807851824, -8.155880368676408],
            [9.84280179820027, -8.1559825598684],
            [9.841425031584768, -8.160708874005195],
            [9.852856682112733, -8.16844102906225],
            [9.858169557648356, -8.173558848829714],
            [9.861355784837356, -8.17091565804584],
            [9.864097794385673, -8.174986281953892],
            [9.869546109032092, -8.174239607898253],
            [9.871707501000882, -8.17984744526714],
            [9.876662854031837, -8.178879256744674],
            [9.879686740886838, -8.182079272338916],
            [9.88358854583155, -8.179122216773111],
            [9.887758894738404, -8.183123712549762],
            [9.894354386036794, -8.185009475979738],
            [9.896169025225236, -8.187554094030691],
            [9.908045972477725, -8.187062367022815],
            [9.911969944939676, -8.189253497025087],
            [9.915728211269874, -8.196245261090663],
            [9.916056279453574, -8.199051404259924],
            [9.921512003506678, -8.200964849978538],
            [9.928128728667115, -8.19812763755951],
            [9.93436641189825, -8.20051914363655],
            [9.937164225526805, -8.205478515875264],
            [9.939961345561619, -8.215848681189044],
            [9.942806037882859, -8.224732784168728],
            [9.946942601965143, -8.232918591596869],
            [9.944187074201597, -8.236812330538712],
            [9.942386071064629, -8.242309629229887],
            [9.938307460708993, -8.246981054050593],
            [9.93729553766484, -8.25099129851841],
            [9.940702666103887, -8.254311049011731],
            [9.930753963217573, -8.258128360540896],
            [9.928688486417235, -8.267704342680378],
            [9.9258633685311, -8.270164782714096],
            [9.92724206117085, -8.278129185413388],
            [9.923098674520592, -8.287126383951666],
            [9.926737902541094, -8.29545450203868],
            [9.93740306833733, -8.311417358835774],
            [9.937938396711335, -8.316393409903453],
            [9.941841888334434, -8.323084714761],
            [9.943049270469588, -8.334022279463639],
            [9.946593248184382, -8.337941145887912],
            [9.949751704563374, -8.346513147971393],
            [9.950115159205769, -8.355596681614756],
            [9.953319330356797, -8.358929996072455],
            [9.958275704521602, -8.360114517470338],
            [9.962382400709187, -8.364351539577049],
            [9.963100017785322, -8.376728483898216],
            [9.954805826392066, -8.386103509802139],
            [9.951501970222624, -8.393009808115679],
            [9.950541960463925, -8.404263882999329],
            [9.94949259604085, -8.406219653655395],
            [9.937167816523509, -8.406171131816446],
            [9.930946210272825, -8.401417247206734],
            [9.927338384817327, -8.401102361190983],
            [9.924267682450514, -8.404003318332723],
            [9.923782156854672, -8.413769064282054],
            [9.922416273626789, -8.417822038247454],
            [9.91785591604159, -8.420529921024913],
            [9.906554808873814, -8.417689548451499],
            [9.8948934971711, -8.417603813862454],
            [9.890049654544589, -8.415552922361385],
            [9.843758122952572, -8.460875767433883],
            [9.81404393494675, -8.489518329315722],
            [9.806182388674417, -8.506781654039074],
            [9.778211978806688, -8.517484568140057],
            [9.77772009871182, -8.519830001251199],
            [9.78314779041931, -8.522440371754092],
            [9.797130640007948, -8.520061234684878],
            [9.800387110659837, -8.516301095822234],
            [9.803949284410372, -8.517785913513674],
            [9.801629246328927, -8.521001608090014],
            [9.795441411806577, -8.525305674865844],
            [9.78684515620205, -8.52669268562893],
            [9.771274731851705, -8.524097399805719],
            [9.756431932659789, -8.52358237231771],
            [9.737397281789749, -8.525181412535824],
            [9.720649546972785, -8.529487770555283],
            [9.712344032559797, -8.533224923135391],
            [9.70604822178017, -8.53721607072443],
            [9.697775754339599, -8.544985662580881],
            [9.693695672886362, -8.547329186765937],
            [9.688859031022606, -8.544989187564852],
            [9.680814431871303, -8.538174172886807],
            [9.67035374002949, -8.524850693335],
            [9.657366239320263, -8.502881507482611],
            [9.644722114938293, -8.476803755716954],
            [9.637537312787305, -8.458688714649835],
            [9.630740052015835, -8.439857570474265],
            [9.625430624435214, -8.422603873408429],
            [9.620368451212565, -8.40253011464031],
            [9.618590836017505, -8.393077062036584],
            [9.618639758952396, -8.380475700747677],
            [9.620205496750721, -8.363153595896957],
            [9.623504732876501, -8.35660611048414],
            [9.63437877711657, -8.346808453388402],
            [9.636412816295453, -8.348555792478098],
            [9.631153010278483, -8.361156103410117],
            [9.631242120581868, -8.371164162878213],
            [9.624586677406075, -8.39161670462393],
            [9.625075361965687, -8.396207765659828],
            [9.62883877292877, -8.402647642314337],
            [9.627114528899208, -8.413883331089504],
            [9.628378641080431, -8.419466805560036],
            [9.633263307904736, -8.429938147275603],
            [9.636867187352399, -8.441237849327845],
            [9.638735461479257, -8.444024744477693],
            [9.636679190008053, -8.448152550882826],
            [9.639727963370353, -8.45627709139425],
            [9.645043274093535, -8.457444945159725],
            [9.648814498327853, -8.465039705228547],
            [9.652853736379765, -8.47670410186925],
            [9.654625321803032, -8.488457910243046],
            [9.661263011704948, -8.498398806083399],
            [9.666076002601171, -8.507636325583531],
            [9.672312650365136, -8.513429571364247],
            [9.67189878439481, -8.519826618427539],
            [9.67357829753442, -8.524252717393889],
            [9.680971644612413, -8.52442292807654],
            [9.682383250340465, -8.527309544304059],
            [9.681718560788413, -8.53484816125434],
            [9.684355916283202, -8.536430620361665],
            [9.690243412963367, -8.534407038630011],
            [9.69221883455111, -8.532397245309939],
            [9.69637844641284, -8.53224891547011],
            [9.702304151044492, -8.52938284314743],
            [9.708989833848904, -8.52791999709371],
            [9.711032279072269, -8.525720964446492],
            [9.717264129360073, -8.526035416636798],
            [9.724086176899801, -8.524238466200037],
            [9.726751012859594, -8.517254963113698],
            [9.727909214166212, -8.506839900273661],
            [9.72594458076446, -8.50239136275354],
            [9.725797852935694, -8.498261394292944],
            [9.728059202374462, -8.496689296009267],
            [9.728679602265066, -8.48971008569706],
            [9.727473158526674, -8.478570967655177],
            [9.724788045035755, -8.460337114713491],
            [9.724993740339698, -8.453333322091371],
            [9.722226149821617, -8.44133685754221],
            [9.723075904168706, -8.436319325581433],
            [9.722258567134348, -8.416004120172028],
            [9.722563768589113, -8.412358830551472],
            [9.719773061151527, -8.40281337352456],
            [9.711717737170469, -8.39822542610427],
            [9.708136012639537, -8.390749077985404],
            [9.706968481915613, -8.380465117017462],
            [9.703758166557314, -8.374684201701552],
            [9.696579282573705, -8.369435666434478],
            [9.6902031436447, -8.369211348081963],
            [9.68606390045802, -8.366295144657206],
            [9.679770522239318, -8.358387652820168],
            [9.678657315322214, -8.354582806220261],
            [9.671325242431948, -8.340312055735865],
            [9.657198132063414, -8.32006401019625],
            [9.636665245195841, -8.300385863295833],
            [9.632889620938357, -8.297410637368776]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.22635608686831, "lat": 29.95645709456914 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12045"],
        "coty_name": ["Gulf"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gulf County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00306917"
      },
      "bbox": [
        9.601172880565338, -8.547329186765937, 9.963100017785322,
        -7.999625110787057
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.843045206589853, -9.821968713903189],
            [13.879254826646353, -9.815839441891876],
            [13.929447306031513, -9.807109428357874],
            [13.954522195850062, -9.803774187727978],
            [14.072527288863622, -9.785512476260422],
            [14.15848041589102, -9.771918444672629],
            [14.159048120591724, -9.765926718617413],
            [14.160661390329022, -9.764847536291324],
            [14.166505983495188, -9.754372746974731],
            [14.167487544963114, -9.74670641434762],
            [14.166327821363247, -9.741917155686881],
            [14.16898271724743, -9.737841054068976],
            [14.200662370161591, -9.73265449556238],
            [14.206515266887491, -9.725618597476796],
            [14.206598336414988, -9.72662404584565],
            [14.22894478505788, -9.758791205496204],
            [14.243828757430558, -9.781275984267078],
            [14.258106116931415, -9.800372811288302],
            [14.268062503640877, -9.815010401605537],
            [14.272437343837929, -9.820216008110531],
            [14.280874787771667, -9.832435628163363],
            [14.285786179809305, -9.840744931282329],
            [14.288425576119648, -9.847142692401965],
            [14.297731168302086, -9.865947443557396],
            [14.307435625973616, -9.884291637161146],
            [14.311781241554604, -9.89443893792513],
            [14.315194414808614, -9.90047906740274],
            [14.31719614598544, -9.906356151716707],
            [14.320949674478959, -9.91335702981004],
            [14.326312385546812, -9.925633065898067],
            [14.32795231305207, -9.932969943425624],
            [14.331852603223483, -9.940655162899931],
            [14.336767021447802, -9.947497038378893],
            [14.345644721341733, -9.956572570402482],
            [14.351515134441286, -9.965098219057507],
            [14.361269772800597, -9.99077967319823],
            [14.366185137769417, -10.00157542021563],
            [14.3602456057239, -10.002309145848683],
            [14.324333632620899, -10.008055122303098],
            [14.226093274459808, -10.02302509556202],
            [14.186409899592908, -10.029150778884302],
            [14.183231354189894, -10.0300422860361],
            [14.05106900543643, -10.0509096415252],
            [13.994041601997278, -10.059843689043852],
            [13.965335462519699, -10.064594522362464],
            [13.951153260611813, -9.982987223105676],
            [13.884980583685216, -9.994360164290347],
            [13.86774532225043, -9.997115275385088],
            [13.85273076236117, -9.908546063927059],
            [13.847245195239374, -9.909567205095728],
            [13.831925357104028, -9.823738133806033],
            [13.843045206589853, -9.821968713903189]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.60641328002752,
          "lat": 27.694320782972948
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12061"],
        "coty_name": ["Indian River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Indian River County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00307624"
      },
      "bbox": [
        13.831925357104028, -10.064594522362464, 14.366185137769417,
        -9.725618597476796
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.546788827444072, -5.253672795171018],
            [10.59130469035338, -5.213306776395331],
            [10.633664815987716, -5.17515274000439],
            [10.638114875817312, -5.1719522835684515],
            [10.642018037376756, -5.1671223859445385],
            [10.671806004830307, -5.140062644742633],
            [10.66792321170709, -5.140424284939579],
            [10.667116396206865, -5.134492210572453],
            [10.683328808919347, -5.13060043783487],
            [10.688264854491605, -5.132562477310411],
            [10.692853788633435, -5.138276297762398],
            [10.692820923012903, -5.144281724019297],
            [10.69718638248301, -5.154000910646175],
            [10.698004706467554, -5.16066782232277],
            [10.700124525203206, -5.164727366947258],
            [10.709066954862717, -5.170244312876667],
            [10.71485160127343, -5.175058702312461],
            [10.726612660673297, -5.1779966926897325],
            [10.732061711835161, -5.181617602116687],
            [10.732882681033864, -5.186088686564111],
            [10.735173582266587, -5.189438855692169],
            [10.784855389212044, -5.183039451232712],
            [10.803356805460584, -5.202908837792178],
            [10.804455631521826, -5.202819575569736],
            [10.813659851026193, -5.19005544825376],
            [10.829016503450367, -5.201910865881995],
            [10.852850751462842, -5.221165671897247],
            [10.857919755135834, -5.214541315943782],
            [10.860583748003622, -5.216533473879747],
            [10.883266579731378, -5.234574967231538],
            [10.87808917974584, -5.2409480824357155],
            [10.878514352106109, -5.246709973485469],
            [10.877269692103914, -5.248993116491777],
            [10.882858210769166, -5.253740003885298],
            [10.87925455683482, -5.258674405356417],
            [10.875384748783883, -5.258797112007857],
            [10.838486722965992, -5.306301217847607],
            [10.820597411874747, -5.329644216169011],
            [10.81401499368499, -5.323718777281186],
            [10.808697390118985, -5.330454143756111],
            [10.803066570794655, -5.32655827169685],
            [10.800582248638896, -5.329079986508469],
            [10.80226713049162, -5.332945070275287],
            [10.807051158615886, -5.336627368739408],
            [10.806033787603301, -5.346550723367108],
            [10.804299581522042, -5.350084447353145],
            [10.807327199681321, -5.35635769464979],
            [10.806441507494721, -5.361684493879103],
            [10.807384670120676, -5.366126849581023],
            [10.804772149226432, -5.370696214437336],
            [10.80201007419096, -5.3690206093312405],
            [10.799012578442918, -5.37614180685823],
            [10.801780407034995, -5.378046021870148],
            [10.802965025385378, -5.3866178903876225],
            [10.80540213077722, -5.387885410851489],
            [10.80594848479176, -5.396876664612162],
            [10.811392515836179, -5.397722076452744],
            [10.814551160274316, -5.404958905302418],
            [10.809165815152552, -5.409394056066872],
            [10.806039267445176, -5.4059220856952255],
            [10.79661548186788, -5.40759508959358],
            [10.789914303596165, -5.402898080823432],
            [10.784427915171625, -5.404939033918906],
            [10.779825197995654, -5.404700287963914],
            [10.771672226511686, -5.401179598378134],
            [10.76117210988861, -5.402335099848149],
            [10.752588797149725, -5.399737009139704],
            [10.75001478665743, -5.400786274029898],
            [10.740909044971039, -5.394126441887387],
            [10.738198437698086, -5.394362953579036],
            [10.733320484135078, -5.391144857721061],
            [10.72963355417399, -5.39159249851834],
            [10.725047251259326, -5.388496699451876],
            [10.71984924342785, -5.388038893438342],
            [10.709024829050623, -5.390256758198108],
            [10.700698738916119, -5.386576921356496],
            [10.6957025074931, -5.390814510711202],
            [10.689239977377527, -5.387270468785684],
            [10.683649379774868, -5.380284984103044],
            [10.681838039989305, -5.382019334660536],
            [10.671430455524982, -5.373261053812737],
            [10.663551699014429, -5.374068243635565],
            [10.655902316589422, -5.368139807555751],
            [10.651067736758742, -5.36950519937069],
            [10.646071295309913, -5.365638950056365],
            [10.639597290499552, -5.366384388580157],
            [10.634335132189058, -5.362712169321811],
            [10.63147232567383, -5.3636938383091985],
            [10.628953730701667, -5.359566914407612],
            [10.62354494377402, -5.357385184986353],
            [10.620982956545173, -5.3532181211656855],
            [10.616399327025093, -5.352319606398698],
            [10.612554399438356, -5.347947195233283],
            [10.610137943469418, -5.341046577174533],
            [10.60524488489191, -5.336768732498313],
            [10.599326612753496, -5.329528609126732],
            [10.595697679224495, -5.327864454713141],
            [10.592751125727958, -5.321406658693027],
            [10.587172886873818, -5.315511659759554],
            [10.588407443766823, -5.311870444792102],
            [10.583660823689073, -5.309802418784977],
            [10.58277516889567, -5.304230734075376],
            [10.57850242908186, -5.300613127924423],
            [10.564495064915276, -5.293234628773832],
            [10.564693889826172, -5.288722954811204],
            [10.561714795119487, -5.283928231462704],
            [10.557573732138893, -5.282652028363925],
            [10.550363206453422, -5.2822984229478],
            [10.546788827444072, -5.253672795171018]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.69732751647825, "lat": 32.80642892197329 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13021"],
        "coty_name": ["Bibb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bibb County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01672039"
      },
      "bbox": [
        10.546788827444072, -5.409394056066872, 10.883266579731378,
        -5.13060043783487
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.257109474461922, -4.595405360283838],
            [9.297023586707729, -4.591953104574711],
            [9.3159827107164, -4.582003897508476],
            [9.323233830478511, -4.57764528358778],
            [9.339459728585169, -4.5691475643662685],
            [9.415283476134412, -4.530084339214146],
            [9.423177202031198, -4.5294223258485165],
            [9.423934889502208, -4.537779680291774],
            [9.436117674655598, -4.536403842744842],
            [9.473587413888803, -4.512596349746156],
            [9.473032098393299, -4.508343201798497],
            [9.485913822426026, -4.507197930586774],
            [9.481974518701659, -4.466314617680303],
            [9.476125109202593, -4.409567612401859],
            [9.485267770268708, -4.408896307001264],
            [9.513517296536941, -4.412073996522852],
            [9.520836760718064, -4.412174017622819],
            [9.529039240694683, -4.413604675803643],
            [9.541370747594486, -4.414858098929872],
            [9.586005018633205, -4.42309580333074],
            [9.60054771819381, -4.427084232937821],
            [9.60307979636098, -4.446239012373927],
            [9.60398188196455, -4.458716039592475],
            [9.605900361402112, -4.477120041635814],
            [9.598870167822392, -4.4775748156123605],
            [9.599767856961074, -4.486426775225005],
            [9.607540318897232, -4.485631441312549],
            [9.608484242863964, -4.493399051316945],
            [9.615021292521705, -4.557537161324377],
            [9.61557097026025, -4.567718811748575],
            [9.618506848624232, -4.602387133992244],
            [9.621506996920417, -4.63422404945577],
            [9.683697963290804, -4.626530013466633],
            [9.683414470644466, -4.623672597772666],
            [9.688113775837529, -4.623195224147243],
            [9.68844402063022, -4.626178539477117],
            [9.70100371503318, -4.624177107648209],
            [9.699076797211019, -4.6280390479761975],
            [9.690118006166719, -4.635459264678699],
            [9.688479588673577, -4.639323155886312],
            [9.688199769174545, -4.64556191034786],
            [9.68494264865522, -4.65175471764357],
            [9.685178604246198, -4.655168332635531],
            [9.69210102024513, -4.6611200739993235],
            [9.695126994652375, -4.66724819655399],
            [9.701732610166864, -4.67405602697119],
            [9.702226724741926, -4.677490584493893],
            [9.700066854209227, -4.68052126425056],
            [9.69283412150322, -4.6865452429953605],
            [9.687022700894818, -4.6873442345209675],
            [9.681614455091458, -4.686358201672359],
            [9.675008052973064, -4.688787842508581],
            [9.67405875626034, -4.690644594592475],
            [9.673983857853353, -4.700440549688444],
            [9.670828141159976, -4.708175736377869],
            [9.666078633972244, -4.710825839588377],
            [9.654322905174885, -4.712957915262775],
            [9.648184114312674, -4.721492749108291],
            [9.64172329272264, -4.72790013655484],
            [9.635677462615792, -4.731124035000289],
            [9.632232761376605, -4.736028892258973],
            [9.631290901285942, -4.740494630919016],
            [9.631930569274726, -4.748046028817257],
            [9.626840825010214, -4.750314562833912],
            [9.623604785719092, -4.756362184932246],
            [9.625079566077783, -4.759980715296729],
            [9.62376412576117, -4.763412622158354],
            [9.614929169086281, -4.76801031955486],
            [9.612631879798846, -4.7728787546717495],
            [9.606756097656667, -4.774217885255213],
            [9.600572963748885, -4.770578575989195],
            [9.597167746673591, -4.7725214658636075],
            [9.586509638448097, -4.764223191214276],
            [9.580545693531912, -4.7618136543530865],
            [9.577322993345843, -4.7590157577031045],
            [9.57245732726818, -4.7571822534017745],
            [9.569032275035635, -4.758467635697556],
            [9.567190078173866, -4.763050496103093],
            [9.571106798987605, -4.768999873941423],
            [9.570526848241755, -4.773627150374296],
            [9.562487474120047, -4.780877821497456],
            [9.5514111063067, -4.786188960038139],
            [9.548638225900378, -4.792103801715907],
            [9.465513827690783, -4.800379728178826],
            [9.398419883364422, -4.807600279172088],
            [9.341698349324636, -4.8132761772486825],
            [9.318963718524529, -4.815734886619013],
            [9.30408840833018, -4.762069277713806],
            [9.29091865585444, -4.716163233919306],
            [9.289412084717139, -4.710180922131679],
            [9.257109474461922, -4.595405360283838]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.0797564232861, "lat": 33.58277327522621 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13045"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00326650"
      },
      "bbox": [
        9.257109474461922, -4.815734886619013, 9.702226724741926,
        -4.408896307001264
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.99814647732624, -3.6781031498810366],
            [9.070000661116842, -3.6697087366300427],
            [9.124567424913364, -3.6634106139366676],
            [9.124997559987618, -3.6668168634871936],
            [9.128590566968294, -3.666396906231603],
            [9.133408217450494, -3.6695540837603966],
            [9.141018412552802, -3.6684864212092214],
            [9.139060237744005, -3.6658045438246356],
            [9.139113356758665, -3.6618287066667485],
            [9.230081362973241, -3.6519361441406373],
            [9.310675922535129, -3.6435297598402383],
            [9.338683863912452, -3.6409595833386166],
            [9.33764915591822, -3.6462426110019224],
            [9.334467062004425, -3.6550139330093314],
            [9.329185926009206, -3.6791140141812746],
            [9.314640959344159, -3.7171340014503467],
            [9.3120346456736, -3.732518373008002],
            [9.30963420992921, -3.737396896338175],
            [9.308265670746012, -3.7439049030111526],
            [9.307189002602946, -3.7611846307615053],
            [9.303334252070904, -3.7795149102384977],
            [9.29867789104916, -3.789782785284596],
            [9.297119104724704, -3.798786581301711],
            [9.279402706828918, -3.805651700403619],
            [9.278103164424378, -3.8080216850089026],
            [9.269633121165603, -3.8087301892560013],
            [9.270823268084836, -3.815458259504519],
            [9.264754881672292, -3.81817164285941],
            [9.265253170838262, -3.823453755473852],
            [9.249882951953673, -3.825213927528744],
            [9.250622688451745, -3.832472775144706],
            [9.244417332205558, -3.833246225728115],
            [9.245054492458825, -3.8397179433378787],
            [9.242511539140217, -3.8391113457559864],
            [9.233650255388543, -3.8441272130573796],
            [9.232577306108086, -3.8472912401934822],
            [9.225867646027938, -3.8499369418139477],
            [9.221218246079035, -3.8547530172531657],
            [9.207102897439063, -3.860791086860859],
            [9.203458284909864, -3.864184823702195],
            [9.18828283727105, -3.872514487992828],
            [9.17898124661463, -3.879546026679026],
            [9.176402128007048, -3.885825012107995],
            [9.172956126475986, -3.8903644095267844],
            [9.168923778494353, -3.897849453543032],
            [9.167513639086987, -3.9028428730603544],
            [9.161450542557994, -3.9122095665407737],
            [9.15938873710018, -3.9135336368512412],
            [9.155865328104424, -3.92603993870977],
            [9.153388124742207, -3.9301241348208293],
            [9.151168338151884, -3.941629557083911],
            [9.147439935567398, -3.9503408075636006],
            [9.151087945956718, -3.954470433822798],
            [9.151494747981712, -3.9570383707236987],
            [9.145677981380048, -3.967926481143651],
            [9.08476212582701, -3.9744243467488363],
            [9.07328023488033, -3.933355553634173],
            [9.031140908106742, -3.790577689550944],
            [9.018264146739114, -3.747169218341171],
            [9.016306677287334, -3.7413959029672],
            [9.01152843706526, -3.723272285161812],
            [8.99814647732624, -3.6781031498810366]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.34533992958801, "lat": 34.4749940486858 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13055"],
        "coty_name": ["Chattooga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chattooga County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00352213"
      },
      "bbox": [
        8.99814647732624, -3.9744243467488363, 9.338683863912452,
        -3.6409595833386166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.645281908250873, -4.292686568131641],
            [11.647835133776432, -4.285431713082612],
            [11.654359699024939, -4.287388403745098],
            [11.655113606839079, -4.281036698661698],
            [11.654574332008512, -4.274860368790539],
            [11.659322883178168, -4.274969016109134],
            [11.65946291603334, -4.270782357478471],
            [11.66277521627601, -4.269335420755063],
            [11.664646343344799, -4.273087044266827],
            [11.668143074651283, -4.275624731403409],
            [11.670226970010559, -4.273395112284347],
            [11.667459291529095, -4.2683233654389126],
            [11.678306230753865, -4.266013567167566],
            [11.679235766372582, -4.261510071470466],
            [11.684743019898809, -4.261844840470916],
            [11.68373197387946, -4.255201206322413],
            [11.687643944415585, -4.254632820226655],
            [11.69053591314998, -4.260340824378449],
            [11.695332410444761, -4.258327404508914],
            [11.692700120045364, -4.253722789644835],
            [11.695240803770888, -4.2510305946683005],
            [11.699250471872405, -4.253578387371106],
            [11.701038762859627, -4.251967717503958],
            [11.698302153290403, -4.239448877274557],
            [11.703844589951105, -4.2424787650123985],
            [11.706847751689166, -4.245844275988123],
            [11.709203716687535, -4.244627424882035],
            [11.710098801442356, -4.24031577411471],
            [11.715701504295325, -4.2395017985331895],
            [11.717249422054627, -4.234585146898871],
            [11.724452871474902, -4.2326988474385265],
            [11.731252099613318, -4.232149180106685],
            [11.733856198702709, -4.229383226426405],
            [11.738940051821178, -4.2299457739816235],
            [11.742802063924215, -4.234475929054362],
            [11.750173726621213, -4.23577839885582],
            [11.75273341741931, -4.235001546387827],
            [11.762444192997865, -4.2413851258324975],
            [11.768659580674766, -4.242311625938041],
            [11.769440033060484, -4.238562582353536],
            [11.778920784900013, -4.236111349015606],
            [11.786413679943573, -4.232918536418691],
            [11.790139205578674, -4.228461818533406],
            [11.798494211345503, -4.232053108802849],
            [11.80133702219751, -4.234284789606538],
            [11.809147857756395, -4.232804621401606],
            [11.814953946990677, -4.241184184916308],
            [11.81885808501485, -4.248670075637977],
            [11.828093956111696, -4.254955125728131],
            [11.829164324126609, -4.269882837450066],
            [11.83530707378686, -4.28554815477694],
            [11.85112756153372, -4.298095868285918],
            [11.854456745943386, -4.2998121874675865],
            [11.869647678118772, -4.301717818339107],
            [11.874213133553, -4.304491882351309],
            [11.879131875266689, -4.312122596028243],
            [11.884553879407203, -4.315200091690112],
            [11.892752450988603, -4.317798401132288],
            [11.898990075941072, -4.316675094786019],
            [11.90286650771605, -4.311900362337357],
            [11.906760342793703, -4.309592630003332],
            [11.914330923737309, -4.309454737325057],
            [11.921767668208814, -4.317781418037645],
            [11.926135042877299, -4.320810226278853],
            [11.931881736078097, -4.3221256324516615],
            [11.944110002931545, -4.323477739280707],
            [11.947749872104662, -4.325102083003439],
            [11.958275081122833, -4.33228985231782],
            [11.96803323338061, -4.3338399857200764],
            [11.976718697124454, -4.3418652215306],
            [11.981491620115339, -4.349492654114744],
            [11.985633278139067, -4.350424178968101],
            [11.960710517786776, -4.378657510865784],
            [11.955118273356762, -4.384189145731725],
            [11.935742311112275, -4.407474716695421],
            [11.913888199023736, -4.432890502741164],
            [11.877457246498148, -4.474450869925879],
            [11.84756251210115, -4.509885675935326],
            [11.827163987124603, -4.534539794388066],
            [11.795396946935298, -4.57131300733218],
            [11.788141025579431, -4.56564652590326],
            [11.781157880842693, -4.56229071631289],
            [11.777491245406662, -4.553265707012503],
            [11.772876421695852, -4.551696527300495],
            [11.767939179223912, -4.548374595968957],
            [11.766449581987098, -4.542733081047787],
            [11.761318570578455, -4.538112236550638],
            [11.758678736913456, -4.532191355605476],
            [11.7515533565126, -4.529365859506119],
            [11.750028191264256, -4.526050504972319],
            [11.753045860017881, -4.514704394452721],
            [11.74919246693885, -4.509290798031604],
            [11.742314277057918, -4.50614393668445],
            [11.737189393717019, -4.499341084379368],
            [11.730232034960185, -4.492039222171092],
            [11.724090749436161, -4.484201368734767],
            [11.718066515879329, -4.482718738088334],
            [11.714239656623556, -4.480197360760983],
            [11.704827665351159, -4.470135866544745],
            [11.70632812688044, -4.466772808458629],
            [11.704614278435434, -4.459648516662582],
            [11.68942100710199, -4.446739612309786],
            [11.689093976242162, -4.439127512858794],
            [11.685347662090011, -4.430970804768026],
            [11.683313361181808, -4.423323663879267],
            [11.686659794096292, -4.420873062267828],
            [11.689433083641568, -4.4149106643630835],
            [11.695685721406884, -4.407882691340698],
            [11.650347307286319, -4.394398452780818],
            [11.64966123940393, -4.392010464879481],
            [11.65067172841079, -4.383492778594988],
            [11.649816279587071, -4.37852597620891],
            [11.650913595547552, -4.374847619506024],
            [11.657995753526691, -4.366436887794016],
            [11.663618280818202, -4.349389974082756],
            [11.663221517346344, -4.343920690198814],
            [11.65594502550904, -4.343693498624088],
            [11.648554711256715, -4.337013262108817],
            [11.64510189310379, -4.335814883822341],
            [11.645276011237927, -4.328595713241578],
            [11.642685738695999, -4.321589980945781],
            [11.638650564295983, -4.316367790253615],
            [11.633901439351595, -4.314564341395821],
            [11.635102109554108, -4.309360999489321],
            [11.63367635974116, -4.306814614072831],
            [11.646064256702969, -4.295963351667752],
            [11.645281908250873, -4.292686568131641]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.26407310311397, "lat": 33.54409018466493 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13073"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00348865"
      },
      "bbox": [
        11.63367635974116, -4.57131300733218, 11.985633278139067,
        -4.228461818533406
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.623689416293118, -5.448569142568778],
            [11.631410970219354, -5.441660054654223],
            [11.642900487130339, -5.436702813321538],
            [11.644072513123799, -5.440177455415844],
            [11.659601633568215, -5.434445506396911],
            [11.662598255879406, -5.438540911917718],
            [11.662224314416077, -5.422548738651261],
            [11.66562655269139, -5.41980582924639],
            [11.67370721175715, -5.428646622762589],
            [11.690086166724655, -5.4190280510625],
            [11.686156130942212, -5.414601359437952],
            [11.679614368376573, -5.410416810207602],
            [11.673897207199955, -5.404637631430264],
            [11.670175481532507, -5.402816028905578],
            [11.665649511661968, -5.3985363445998],
            [11.660026094043111, -5.38856428477766],
            [11.6615891171849, -5.383447588343458],
            [11.658515019294402, -5.3762598426954185],
            [11.679615273219389, -5.357591304019821],
            [11.720351266275962, -5.320957770391454],
            [11.714403103691346, -5.313190776730911],
            [11.728692841483777, -5.301995686478367],
            [11.734900397536995, -5.309900050025633],
            [11.75711114040287, -5.293387651250158],
            [11.753956794026527, -5.294134410210576],
            [11.751482947515882, -5.290502144234798],
            [11.744544090578382, -5.287225501066399],
            [11.74333743146518, -5.2855207656615155],
            [11.737687484674284, -5.284227960830416],
            [11.733074737585907, -5.2818430051770395],
            [11.730549708982334, -5.273303160902795],
            [11.726708612483595, -5.267327302598665],
            [11.724854230426045, -5.262268281587179],
            [11.722060721424858, -5.2588201852877745],
            [11.742342743940291, -5.231372117395849],
            [11.756020296868295, -5.220663051372072],
            [11.754993807863691, -5.210245202110556],
            [11.765267766712816, -5.175822524784336],
            [11.768940996491427, -5.176077100137276],
            [11.777906287515973, -5.1658217773412645],
            [11.78316384082828, -5.167112879515175],
            [11.788930029173905, -5.161822958784354],
            [11.792526426008987, -5.157012901355777],
            [11.791465479435157, -5.150881878036783],
            [11.785555984415517, -5.152037442472405],
            [11.782446928479827, -5.150049785364674],
            [11.781903876532752, -5.143741080964284],
            [11.777190156220554, -5.137633416738464],
            [11.772033111451735, -5.134745405984468],
            [11.770723066040384, -5.1257755626098165],
            [11.773144074629734, -5.123015147022056],
            [11.778627192517353, -5.120438153100835],
            [11.786007819321771, -5.121435526064418],
            [11.791480048812929, -5.116207643173296],
            [11.795306298174609, -5.117755905670582],
            [11.807485748371388, -5.115538944983408],
            [11.811066143313242, -5.116191410594968],
            [11.817474172911638, -5.113527052295955],
            [11.816677531606762, -5.109292134222893],
            [11.821384878994857, -5.10220646192096],
            [11.82642546244871, -5.10201917733892],
            [11.831341740149819, -5.097832783211517],
            [11.832572048280886, -5.094468983476192],
            [11.836817151242673, -5.093687860273148],
            [11.840607439794146, -5.0902199393723615],
            [11.842836043029749, -5.08472510244598],
            [11.849067571201488, -5.08510763427183],
            [11.8519834629412, -5.088931444340357],
            [11.85647397117831, -5.094161007417172],
            [11.86624643279297, -5.095993154704034],
            [11.88523043914268, -5.094370353657456],
            [11.89138551937513, -5.098042745467598],
            [11.893294609993589, -5.093678084491323],
            [11.899269490551433, -5.094802884555418],
            [11.90345583805072, -5.093415027844388],
            [11.904828958017156, -5.096952582969793],
            [11.919135864125735, -5.1028548280583665],
            [11.922337810276257, -5.100085928233109],
            [11.938960858142543, -5.104192095099856],
            [11.941226705682437, -5.10846207010398],
            [11.94578419375495, -5.105892963543968],
            [11.951557916943605, -5.106048849171864],
            [11.955274143377043, -5.10204812144889],
            [11.960014305224892, -5.103261341930755],
            [11.963071134886182, -5.099419041590364],
            [11.969611538954059, -5.096951165995521],
            [11.97253171306554, -5.094204857841648],
            [11.97837442481187, -5.095794910570349],
            [11.983455704007186, -5.092646517522371],
            [11.984276562174074, -5.090537465624516],
            [11.989105936401218, -5.089247459085933],
            [11.995182282918666, -5.0892808983202835],
            [11.997104909040637, -5.091166201201768],
            [12.047201459621267, -5.186502230520681],
            [12.070760746205124, -5.231946019022252],
            [12.1426668069891, -5.275707876614596],
            [12.146282847434763, -5.277672481254037],
            [12.146064704689845, -5.277737106426854],
            [12.132691648557307, -5.332064547044648],
            [12.132294685605583, -5.348716375878954],
            [12.088029847892209, -5.333677257588808],
            [12.03702593389412, -5.381261077521436],
            [12.016563604413498, -5.431158655837072],
            [12.01681618482347, -5.4720885261572425],
            [12.009087821635552, -5.490510233702561],
            [11.974614440810987, -5.559396971259991],
            [11.977276636237482, -5.56418427917478],
            [11.982144971986122, -5.563267901856867],
            [11.988081749045758, -5.56643918075161],
            [11.986853754119293, -5.5700392621288985],
            [11.989803935090507, -5.575220147670305],
            [11.990787148134292, -5.579838016605032],
            [11.989634036861222, -5.584281508437686],
            [11.994471608725751, -5.587939422164197],
            [11.996220396969083, -5.591119348316849],
            [11.974491399330391, -5.608987816807964],
            [11.969220864263217, -5.6141986030364155],
            [11.960642193509807, -5.621203804062142],
            [11.924724340047014, -5.627200387912704],
            [11.919919110428946, -5.626882296998751],
            [11.90579864305458, -5.6314435086768855],
            [11.898675912040988, -5.63186913100667],
            [11.894175806871784, -5.611269256243894],
            [11.89124303864918, -5.606322219689887],
            [11.885006128207346, -5.6031723695798235],
            [11.872045662555177, -5.590786719044586],
            [11.86560596805556, -5.591290758382496],
            [11.861679102136474, -5.593918570286232],
            [11.858487300228326, -5.59132152077166],
            [11.850737866895152, -5.57822939207091],
            [11.844514159938017, -5.577623265101421],
            [11.842080101120315, -5.572832420201258],
            [11.841158217100581, -5.566752183909255],
            [11.844126706433164, -5.553872381219659],
            [11.850203483869183, -5.543312245063675],
            [11.85140937636738, -5.538285101640349],
            [11.851099753018888, -5.531395446554235],
            [11.848550077052394, -5.51872178727361],
            [11.850832711668867, -5.50364727977755],
            [11.854659810677138, -5.488439024217812],
            [11.851231438722005, -5.489159838320906],
            [11.847690193709024, -5.487286664380363],
            [11.845072856175936, -5.482300587102686],
            [11.839674482799042, -5.479180704337948],
            [11.834521504544266, -5.479060104512455],
            [11.827288158975174, -5.477093433223897],
            [11.820545705414036, -5.476648565775468],
            [11.81565897729348, -5.472099844790712],
            [11.807536089380521, -5.467883399590403],
            [11.80083232405508, -5.46563546804868],
            [11.797017721578177, -5.4665144885928],
            [11.793311741154954, -5.462891920926209],
            [11.787082390629065, -5.462999074636619],
            [11.783552755908671, -5.460466311247811],
            [11.776088942029126, -5.45749471312385],
            [11.771413237157267, -5.452034591291482],
            [11.763524532687265, -5.4493743074476795],
            [11.758142526221805, -5.4502009385534755],
            [11.756530242641746, -5.447072292966023],
            [11.748374545030039, -5.445204039984061],
            [11.744825506680396, -5.4461955959816075],
            [11.733659613841809, -5.4460698209902905],
            [11.719858783638005, -5.450491882141064],
            [11.715654240635809, -5.4496589649392115],
            [11.708482834045103, -5.450333732650921],
            [11.70019600438527, -5.448635047891038],
            [11.695235202422094, -5.4456251109161276],
            [11.675770924391962, -5.447105480900359],
            [11.664677406582355, -5.449844583506227],
            [11.648901583664722, -5.452640204151801],
            [11.643232797007867, -5.451600695775084],
            [11.636903071803182, -5.451879345384948],
            [11.629517936966142, -5.45070265172949],
            [11.623689416293118, -5.448569142568778]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.30171855158044,
          "lat": 32.589713620220046
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13107"],
        "coty_name": ["Emanuel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Emanuel County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00347508"
      },
      "bbox": [
        11.623689416293118, -5.63186913100667, 12.146282847434763,
        -5.08472510244598
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.693694616463073, -4.666871875512873],
            [11.665209858359612, -4.695988349486182],
            [11.662687464932455, -4.699055697394695],
            [11.61709957826381, -4.749747249231333],
            [11.582558466135017, -4.787461526199942],
            [11.58480690011605, -4.7912067185165945],
            [11.586064761144284, -4.798406962058075],
            [11.591510056120006, -4.799466278607526],
            [11.59413693794749, -4.803592163061325],
            [11.594637019668872, -4.809121576189341],
            [11.591636017236066, -4.812391438361127],
            [11.59121446780227, -4.817617674374699],
            [11.59431858667717, -4.826340763007522],
            [11.592942383493776, -4.827933664168479],
            [11.595753859238439, -4.8330309227468256],
            [11.591828338867249, -4.839337632288982],
            [11.584727779453884, -4.83542791170338],
            [11.578909294479741, -4.8365418777570675],
            [11.566679360000107, -4.83735007017045],
            [11.55632805899797, -4.838744069531887],
            [11.54355346574327, -4.839513096926399],
            [11.542778311254423, -4.843920046365536],
            [11.533793518993955, -4.8403355421360725],
            [11.52553243925268, -4.841220284835306],
            [11.526194323172327, -4.838699284637838],
            [11.518760402404597, -4.836091047882035],
            [11.51598815169052, -4.83378781739453],
            [11.510181299388696, -4.836142878121432],
            [11.504852213732319, -4.832951875451309],
            [11.505787637928622, -4.830431104764384],
            [11.497210674709098, -4.825162829986402],
            [11.493427435485504, -4.827643765006691],
            [11.485153680354891, -4.823007295927369],
            [11.483369599062717, -4.821105251156901],
            [11.482406634441427, -4.814716488584307],
            [11.475395261235132, -4.806919064858175],
            [11.470396356534309, -4.803441584999702],
            [11.465556826254591, -4.803340719296749],
            [11.46218206472215, -4.8013652438227945],
            [11.459065317075122, -4.803029231672544],
            [11.454899121119698, -4.802478960085998],
            [11.454877679680562, -4.791114405755992],
            [11.451834705467139, -4.788711229079628],
            [11.45053624755573, -4.784453349809561],
            [11.450931673863327, -4.777298445805524],
            [11.455457654630829, -4.774259201076478],
            [11.455149764716976, -4.768252917572004],
            [11.450739181514434, -4.767325557134205],
            [11.447323936133484, -4.76258974047382],
            [11.452138386770347, -4.759334848313381],
            [11.450103419763645, -4.754471663885567],
            [11.447350694712787, -4.75233860879289],
            [11.443804658752098, -4.752507574903642],
            [11.445652344769892, -4.745353494105805],
            [11.44144142289888, -4.744099962219566],
            [11.438679050339717, -4.739939891281939],
            [11.4376842876548, -4.733298763314357],
            [11.43036889923047, -4.72581298003545],
            [11.432248831634457, -4.723370065885538],
            [11.44095628239329, -4.720299252665768],
            [11.448361160052526, -4.720457206757185],
            [11.455289851304796, -4.715894207840251],
            [11.459549497639445, -4.710099813073103],
            [11.467260028589568, -4.704615283708624],
            [11.471460455110341, -4.700359129556162],
            [11.48293797292976, -4.699733206398216],
            [11.491146362194462, -4.696210511009595],
            [11.495934910402006, -4.690740247433657],
            [11.505310379593393, -4.677729167678745],
            [11.508370333613401, -4.675901797535398],
            [11.514294884604206, -4.665389371597983],
            [11.521829101504592, -4.661560328189619],
            [11.527126608030876, -4.656733806382489],
            [11.537554293811585, -4.656834057470107],
            [11.542265726696796, -4.652220859423091],
            [11.547656251261929, -4.650656023784203],
            [11.552232128852468, -4.647604750034965],
            [11.555830911523211, -4.639722210639191],
            [11.560112614469888, -4.637254149337384],
            [11.570224317163186, -4.636100260701126],
            [11.574212848461661, -4.632708989286331],
            [11.58118961776345, -4.629758063639504],
            [11.629820632472674, -4.645535720215699],
            [11.636335176316907, -4.646523989628503],
            [11.693694616463073, -4.666871875512873]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.61074769415339,
          "lat": 33.229288441036154
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13125"],
        "coty_name": ["Glascock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Glascock County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00345642"
      },
      "bbox": [
        11.43036889923047, -4.843920046365536, 11.693694616463073,
        -4.629758063639504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.922432413884486, -4.192910515621168],
            [10.943475997695744, -4.132844052105777],
            [10.92600174801732, -4.11533559320776],
            [10.9101842077362, -4.099019462338813],
            [10.907752858853465, -4.094746548286713],
            [10.905467145100788, -4.0870336987078515],
            [10.91284854312324, -4.082676376148678],
            [10.91512341984271, -4.077177588515497],
            [10.913899786570823, -4.070009337866659],
            [10.91144794511662, -4.066769370795667],
            [10.905317629854734, -4.063870478661888],
            [10.909962055530283, -4.059028735685962],
            [10.907567800807247, -4.04015010465727],
            [10.913593132814277, -4.041625846402867],
            [10.916397021427152, -4.040490090253818],
            [10.917208943978912, -4.040139483428135],
            [10.931902346791752, -4.023738030133429],
            [10.938407058919429, -4.027380581491169],
            [10.943295792782614, -4.0272678908053905],
            [10.94594254158545, -4.034872523014718],
            [10.953742551108467, -4.031728338871274],
            [10.968070967150902, -4.021988311805312],
            [10.971482202970574, -4.0136761628905795],
            [10.976486255892224, -4.010465174404697],
            [10.981856070996583, -4.0025950074493295],
            [10.98779539560935, -3.995489955980408],
            [11.00201373161694, -3.9882357388685508],
            [11.007832639347408, -3.983734819208193],
            [11.017764013250005, -3.9789908444371362],
            [11.032798716717137, -3.9887733042759965],
            [11.033943446548482, -3.9933002922843],
            [11.03832755973222, -3.9962681901022568],
            [11.045573852256359, -3.9931322944725447],
            [11.048967120146122, -3.9889120384391576],
            [11.061279426621406, -3.994636363995379],
            [11.065095138527745, -3.9918896077532455],
            [11.070122626895097, -3.9944586095792203],
            [11.073530582554456, -3.9986598286788113],
            [11.081562662204282, -3.997643083801864],
            [11.08493852681818, -4.000680529973992],
            [11.092266807796422, -3.989251147530089],
            [11.096903575864498, -3.9889723654125406],
            [11.098495006758078, -3.984013193589343],
            [11.106386143912982, -3.9842355759153607],
            [11.106028700444982, -3.9807669030187802],
            [11.109336520910155, -3.9797208166022178],
            [11.113831971406348, -3.981225799073007],
            [11.121403299488144, -3.9803683299530697],
            [11.126032771176366, -3.9753157902095544],
            [11.1345782559707, -3.9740907755892225],
            [11.135014579924363, -3.970554466837182],
            [11.133060523902785, -3.967772923827553],
            [11.14032823226015, -3.9652666754771233],
            [11.149398287821258, -3.966741968062257],
            [11.15249882270049, -3.9708863786503903],
            [11.154990413271713, -3.971270782082866],
            [11.159339442866866, -3.967776578518042],
            [11.161700453933523, -3.968860665982048],
            [11.169167107819401, -3.976896888683896],
            [11.172956018482719, -3.979826390449364],
            [11.169576951794834, -3.981957633561935],
            [11.171946655568998, -3.989589205757013],
            [11.174945904522561, -3.98905879026177],
            [11.183082089684847, -3.9924879056644524],
            [11.18503605088449, -3.995430702761471],
            [11.18932059979628, -3.991963247337191],
            [11.19354156689132, -3.995486648781942],
            [11.195436631634394, -3.993432733508695],
            [11.193549319796448, -3.989106968224108],
            [11.202838997116276, -3.989196531184687],
            [11.202863309438785, -3.995986899516866],
            [11.214449331557388, -3.996745929536632],
            [11.22012783645249, -3.998028596840787],
            [11.223841822285276, -3.997449074526803],
            [11.226016637808366, -4.0021910556645715],
            [11.234253245822087, -4.003534240673003],
            [11.237598303440663, -4.0064737600669],
            [11.239796089103908, -4.011963122937859],
            [11.24395902453858, -4.011218969049224],
            [11.249776997121305, -4.012075397935904],
            [11.258022378502826, -4.008742947230536],
            [11.257249697001091, -4.003163396913269],
            [11.260777626384808, -3.9999704888128984],
            [11.272087999548841, -4.0067419614708095],
            [11.277083300156898, -4.00459534337671],
            [11.280866255305252, -4.007941110717226],
            [11.287423494160281, -4.009536169214315],
            [11.29438656946979, -4.010086666340787],
            [11.305980996743335, -4.014454514483251],
            [11.310689123924755, -4.014814010969384],
            [11.310604826646362, -4.019205917892143],
            [11.308442685771924, -4.026503124966849],
            [11.305673924189263, -4.0323716646495855],
            [11.301481813221628, -4.038077263837184],
            [11.296486179854865, -4.0373471848462135],
            [11.29102983740535, -4.038923656466162],
            [11.290678362503717, -4.042920069553448],
            [11.285430051751314, -4.043782125908728],
            [11.282806124019217, -4.046846741296612],
            [11.279339163038546, -4.046757086307421],
            [11.277326716893745, -4.050207170540268],
            [11.272326169448801, -4.0497755427096],
            [11.268129270497361, -4.0522323394007165],
            [11.26016060731357, -4.052787883108111],
            [11.255471448990416, -4.065529887715095],
            [11.246992834322336, -4.069424834237765],
            [11.242765394167408, -4.074006710618141],
            [11.240022399184467, -4.074730976456128],
            [11.23876275299196, -4.081489211430297],
            [11.23374157402074, -4.085187073967134],
            [11.232984917806819, -4.0929182101939645],
            [11.23088473816675, -4.101642752852232],
            [11.227235139582014, -4.105716986626426],
            [11.226823611000556, -4.108349722175407],
            [11.221089468369366, -4.119185202578796],
            [11.215431777536422, -4.1233018846094645],
            [11.212152503234982, -4.131991040730611],
            [11.210257789905441, -4.144797563900954],
            [11.205373183548023, -4.15222448533169],
            [11.200297789143534, -4.154226267301883],
            [11.195040316675094, -4.154465583478639],
            [11.190787954881632, -4.165172393537932],
            [11.19028775879684, -4.170153410785064],
            [11.186548359056689, -4.178590853958314],
            [11.187351235552732, -4.183360705005362],
            [11.185211551485342, -4.188862332898733],
            [11.18429198825093, -4.194784031949707],
            [11.181056659600937, -4.196657361167575],
            [11.178580855511246, -4.201229156843538],
            [11.17329436056392, -4.205361848507368],
            [11.173585019880456, -4.209873289777639],
            [11.171788580653047, -4.218565797256848],
            [11.168711556994305, -4.221051399799476],
            [11.16746991056863, -4.2278226338834335],
            [11.193735017200371, -4.253514073241843],
            [11.205259362400202, -4.270664782099548],
            [11.182895025600505, -4.296574060478962],
            [11.176393409385375, -4.302031003283493],
            [11.174741056334735, -4.306558789719452],
            [11.17493630372269, -4.310984823477842],
            [11.172642640323692, -4.315454494962919],
            [11.17112753535731, -4.315146457653795],
            [11.163103940907037, -4.320528804837021],
            [11.156570881836561, -4.32007120979263],
            [11.1517741204627, -4.3175868704056395],
            [11.146678546830584, -4.3116232865233775],
            [11.143621536390286, -4.311643522747044],
            [11.139732262939003, -4.308203939060073],
            [11.136584567794744, -4.30746686293931],
            [11.133533412769598, -4.303734879333315],
            [11.125820866419637, -4.299587918360478],
            [11.071161764710412, -4.3240135838453915],
            [11.04110631489204, -4.314400718869255],
            [10.930418285477774, -4.279218595128446],
            [10.925763073233238, -4.271949926572686],
            [10.925273354291052, -4.265964647047588],
            [10.92703902852108, -4.257728378990418],
            [10.923987866764596, -4.251974228230379],
            [10.919824778060917, -4.25114833378597],
            [10.914195081204994, -4.244816358441758],
            [10.91291218166765, -4.235445103709957],
            [10.913902483831675, -4.232056446930823],
            [10.909196091549095, -4.229876764364142],
            [10.90226050897191, -4.232650178340481],
            [10.922432413884486, -4.192910515621168]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.08075770213273,
          "lat": 33.880611604466594
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13221"],
        "coty_name": ["Oglethorpe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oglethorpe County"],
        "coty_fp_code": "221",
        "coty_gnis_code": "00351262"
      },
      "bbox": [
        10.90226050897191, -4.3240135838453915, 11.310689123924755,
        -3.9652666754771233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.191116856410485, -5.145442317203235],
              [10.187740843278215, -5.1458330651294615],
              [10.18718895069992, -5.141402932175739],
              [10.19055795696048, -5.140997896509153],
              [10.191116856410485, -5.145442317203235]
            ]
          ],
          [
            [
              [10.005745506272438, -5.19746723268553],
              [10.008287740436867, -5.199067000709641],
              [10.023312046421756, -5.193016196808652],
              [10.030355515091793, -5.1798124725562324],
              [10.030328228951788, -5.176468008971009],
              [10.03382064048358, -5.173727797211527],
              [10.03380793861994, -5.1706692266170355],
              [10.10685777972037, -5.162960178619273],
              [10.174881007983652, -5.1554003130562105],
              [10.192082357707203, -5.153605469520037],
              [10.191116856410485, -5.145442317203235],
              [10.195883325408136, -5.145076919630128],
              [10.200058481066657, -5.152767503431844],
              [10.215782255583164, -5.151144618745685],
              [10.232634156230523, -5.149407233241239],
              [10.272576171628385, -5.1445991053812445],
              [10.325241185995983, -5.138460465546494],
              [10.338187395328148, -5.137375051572122],
              [10.344575615878567, -5.194544770142995],
              [10.354162084084754, -5.276780751866453],
              [10.360211796695303, -5.32511996885965],
              [10.339455892741997, -5.327439390267303],
              [10.326030683000882, -5.380662787650416],
              [10.325354969493254, -5.382151924124987],
              [10.31313455143793, -5.42908415127289],
              [10.309115326823395, -5.44344092034653],
              [10.30814976938765, -5.436920862750153],
              [10.30162546106005, -5.434339283083132],
              [10.298222679363851, -5.429018629970268],
              [10.296445999960723, -5.423769519790315],
              [10.290579206690419, -5.414608497443951],
              [10.280749369705859, -5.414304172839041],
              [10.277303244605307, -5.41607828885979],
              [10.27850684118318, -5.4087762397639025],
              [10.281721669976388, -5.403807290559889],
              [10.275576997034461, -5.398892829659409],
              [10.271295985033532, -5.400075913430597],
              [10.267365393594117, -5.408217049995246],
              [10.26281959427935, -5.411482936016813],
              [10.259285902271703, -5.4099682088340195],
              [10.254578519192378, -5.404337742799927],
              [10.253126434629358, -5.400638971623208],
              [10.239156135822954, -5.397846115866769],
              [10.234592887076134, -5.397668382947229],
              [10.232563808869738, -5.394781170237059],
              [10.227716075706438, -5.388920226570706],
              [10.222490644537125, -5.38882449551775],
              [10.217113358596581, -5.382739542135862],
              [10.20665308964226, -5.389934605023777],
              [10.199620623737303, -5.384469001566291],
              [10.195845356559014, -5.3845555752602],
              [10.190026756582935, -5.387972793107331],
              [10.186309301451352, -5.385228271093886],
              [10.180473564420643, -5.37274489323262],
              [10.175913248826808, -5.36727055575691],
              [10.172271795479574, -5.365911722624032],
              [10.169326692046143, -5.3681266149287],
              [10.172212086468889, -5.373046743515818],
              [10.168540647201205, -5.375226446505145],
              [10.164666024336396, -5.372186372460626],
              [10.160133608206836, -5.3748475509790286],
              [10.155347826914863, -5.374360709761779],
              [10.14865322697343, -5.372133234122712],
              [10.144712368980436, -5.366485715331204],
              [10.140805037625281, -5.366356865983073],
              [10.138786637769115, -5.358869500620557],
              [10.131763486668541, -5.345548750085632],
              [10.127820051853641, -5.341980448896901],
              [10.128333561191942, -5.338523825497216],
              [10.121918503793609, -5.333345551641212],
              [10.119968499311772, -5.328182183129519],
              [10.115169136958798, -5.321475995141279],
              [10.108685052264182, -5.318106539362742],
              [10.099293724431435, -5.319439460024471],
              [10.097021121370908, -5.326378965568785],
              [10.09324385320801, -5.333554787628306],
              [10.088596027472272, -5.334305851817808],
              [10.080604311486914, -5.330375880731652],
              [10.078688631882875, -5.321164799269126],
              [10.077004941544915, -5.317558657551361],
              [10.072383643007853, -5.3129962885653805],
              [10.069478449889523, -5.308389799978321],
              [10.061529071531554, -5.306267414483447],
              [10.058353091969819, -5.3106682752323735],
              [10.050127750011116, -5.306808122989785],
              [10.050245091925628, -5.301341165594395],
              [10.060484874133722, -5.2898445906788965],
              [10.059463148807746, -5.285535838005836],
              [10.05338475101328, -5.28498123012003],
              [10.040113847080528, -5.281078711581468],
              [10.033181226681636, -5.283741614195831],
              [10.030527556032323, -5.2812872351208275],
              [10.029499458316625, -5.26240885900811],
              [10.025575265158256, -5.253825926419718],
              [10.02140810010739, -5.251701566269543],
              [10.01576979676264, -5.254212978085491],
              [10.013913992639909, -5.246645184444585],
              [10.010110367231242, -5.239992806562534],
              [10.013656452320848, -5.23527660844968],
              [10.013089219285792, -5.22953210338697],
              [10.015286998920356, -5.218771607179167],
              [10.01430904912069, -5.2147733429171765],
              [10.01033045846649, -5.2083737944141],
              [10.00615255571838, -5.2068152295850405],
              [10.002844613480057, -5.207792140226449],
              [10.000409721105378, -5.204528810067849],
              [10.002100851466745, -5.198310217630692],
              [10.005745506272438, -5.19746723268553]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.29929873408855,
          "lat": 32.881327550436545
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13293"],
        "coty_name": ["Upson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Upson County"],
        "coty_fp_code": "293",
        "coty_gnis_code": "00346759"
      },
      "bbox": [
        10.000409721105378, -5.44344092034653, 10.360211796695303,
        -5.137375051572122
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.98870721482279, -3.643538264415538],
            [9.018756649801404, -3.5940599295038997],
            [9.01567132282531, -3.564370380301083],
            [9.030834746414724, -3.5382167651102296],
            [9.035183064096222, -3.5291336344245843],
            [9.036078056332034, -3.5188896014450086],
            [9.035074387895278, -3.509026500708466],
            [9.041469214963676, -3.500617012957499],
            [9.03325534321305, -3.4281702175018434],
            [9.042031788340132, -3.3832336106191376],
            [9.051645764796486, -3.3571125817964895],
            [9.052501656986767, -3.3557528164588613],
            [9.07301642507785, -3.308476903713878],
            [9.080191469126671, -3.2932873292027334],
            [9.08185093211602, -3.28795332059828],
            [9.082780774790244, -3.2793270269312935],
            [9.086249606547751, -3.273716847593128],
            [9.086259203201118, -3.2685726024257478],
            [9.155794715153473, -3.259117877341463],
            [9.165874069109181, -3.2578757550144926],
            [9.179003474478225, -3.3675796551747115],
            [9.178601140055232, -3.3682756647175753],
            [9.180977999946494, -3.388695851243182],
            [9.210102447813897, -3.3854764464081692],
            [9.231557815358924, -3.382775291995071],
            [9.237513612655224, -3.430442711480052],
            [9.240893441311044, -3.462124729754255],
            [9.274901327363812, -3.4581252352238545],
            [9.275694578417855, -3.4653946712001833],
            [9.287933485868855, -3.4642911047801386],
            [9.284264574483288, -3.473484493800819],
            [9.282825976090898, -3.4795249427904262],
            [9.278037119245125, -3.4942553169349124],
            [9.276456936688236, -3.501932293203127],
            [9.274405388088605, -3.506218753833766],
            [9.27422088833277, -3.513888919035005],
            [9.369486076491537, -3.503196936853808],
            [9.381110856805561, -3.6006235353842584],
            [9.373060038898807, -3.6015853090009253],
            [9.377046906677041, -3.6368458181145096],
            [9.37002204572458, -3.6376560086437895],
            [9.338683863912452, -3.6409595833386166],
            [9.310675922535129, -3.6435297598402383],
            [9.230081362973241, -3.6519361441406373],
            [9.139113356758665, -3.6618287066667485],
            [9.139060237744005, -3.6658045438246356],
            [9.141018412552802, -3.6684864212092214],
            [9.133408217450494, -3.6695540837603966],
            [9.128590566968294, -3.666396906231603],
            [9.124997559987618, -3.6668168634871936],
            [9.124567424913364, -3.6634106139366676],
            [9.070000661116842, -3.6697087366300427],
            [8.99814647732624, -3.6781031498810366],
            [8.98870721482279, -3.643538264415538]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.3009761516309, "lat": 34.73558617436829 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13295"],
        "coty_name": ["Walker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walker County"],
        "coty_fp_code": "295",
        "coty_gnis_code": "00354216"
      },
      "bbox": [
        8.98870721482279, -3.6781031498810366, 9.381110856805561,
        -3.2578757550144926
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.210739011472397, -5.066802406988946],
            [11.213099635943191, -5.065941368970267],
            [11.21368952643559, -5.060470759657895],
            [11.210276545566684, -5.052281122817147],
            [11.209812697102441, -5.046314581285155],
            [11.211838799921967, -5.038034479910897],
            [11.219927885285514, -5.0372829217623485],
            [11.225700695520445, -5.02525985311363],
            [11.224988765616779, -5.019946908685244],
            [11.222665822121034, -5.016357496543213],
            [11.221455966226879, -5.008152743437573],
            [11.214017738132142, -4.999132584954103],
            [11.210124077636122, -4.997031040967374],
            [11.204849517762272, -4.988692208012806],
            [11.20461230969371, -4.98587708562743],
            [11.209098237656319, -4.978701786666091],
            [11.21364737595924, -4.974082654821712],
            [11.212034680072975, -4.965659657287152],
            [11.216478420204085, -4.957887903934149],
            [11.218936878810261, -4.950240173019228],
            [11.217131036898406, -4.9410667944802595],
            [11.21013290269368, -4.931173394158094],
            [11.225201142214848, -4.928116081520369],
            [11.23519301541506, -4.928249841328844],
            [11.245218316707929, -4.926449638025061],
            [11.250678121678435, -4.922432009797556],
            [11.259286942626478, -4.91431665203178],
            [11.263138941281413, -4.904917771399599],
            [11.266171337099587, -4.900351120025561],
            [11.273678999801648, -4.893753052486219],
            [11.283136082844498, -4.894562223181124],
            [11.290225413681995, -4.892962002613661],
            [11.297743589550302, -4.886291920345561],
            [11.308748327884114, -4.8816153229018715],
            [11.317068043445378, -4.870009088581056],
            [11.32749866192175, -4.866750039237169],
            [11.336822149463542, -4.855126488952376],
            [11.33631155615138, -4.853529505954281],
            [11.34002155193781, -4.840557868370986],
            [11.342532661093054, -4.838637762285992],
            [11.34873183458975, -4.813176607256862],
            [11.348603199983737, -4.810853150709637],
            [11.351808672139532, -4.8037231558296565],
            [11.354920825218159, -4.8013634821827145],
            [11.35666627201846, -4.7938237483383315],
            [11.361856077972947, -4.790016858127158],
            [11.374564873725081, -4.785784945064691],
            [11.376987172221723, -4.782720871314418],
            [11.378683752337267, -4.776512499575087],
            [11.383783668353823, -4.7707117946931215],
            [11.388597087231497, -4.768249349392194],
            [11.392822640072485, -4.7643247789166026],
            [11.399399141583118, -4.762279503966103],
            [11.402530014650312, -4.756503199773526],
            [11.414242817423611, -4.743272571229844],
            [11.42308728639965, -4.743598927161257],
            [11.425744404206107, -4.74204158771712],
            [11.438679050339717, -4.739939891281939],
            [11.44144142289888, -4.744099962219566],
            [11.445652344769892, -4.745353494105805],
            [11.443804658752098, -4.752507574903642],
            [11.447350694712787, -4.75233860879289],
            [11.450103419763645, -4.754471663885567],
            [11.452138386770347, -4.759334848313381],
            [11.447323936133484, -4.76258974047382],
            [11.450739181514434, -4.767325557134205],
            [11.455149764716976, -4.768252917572004],
            [11.455457654630829, -4.774259201076478],
            [11.450931673863327, -4.777298445805524],
            [11.45053624755573, -4.784453349809561],
            [11.451834705467139, -4.788711229079628],
            [11.454877679680562, -4.791114405755992],
            [11.454899121119698, -4.802478960085998],
            [11.459065317075122, -4.803029231672544],
            [11.46218206472215, -4.8013652438227945],
            [11.465556826254591, -4.803340719296749],
            [11.470396356534309, -4.803441584999702],
            [11.475395261235132, -4.806919064858175],
            [11.482406634441427, -4.814716488584307],
            [11.483369599062717, -4.821105251156901],
            [11.485153680354891, -4.823007295927369],
            [11.493427435485504, -4.827643765006691],
            [11.497210674709098, -4.825162829986402],
            [11.505787637928622, -4.830431104764384],
            [11.504852213732319, -4.832951875451309],
            [11.510181299388696, -4.836142878121432],
            [11.51598815169052, -4.83378781739453],
            [11.518760402404597, -4.836091047882035],
            [11.526194323172327, -4.838699284637838],
            [11.52553243925268, -4.841220284835306],
            [11.529112044453107, -4.844987552014212],
            [11.529220071989915, -4.847544973331804],
            [11.535142427728267, -4.850873713512121],
            [11.535856480478133, -4.855959857613674],
            [11.542057938768867, -4.864309859412801],
            [11.548765133496355, -4.863906217357023],
            [11.550361235260622, -4.871479807608224],
            [11.548101068206234, -4.874159318239263],
            [11.548054442472564, -4.87995900312593],
            [11.554639765139626, -4.88748805808907],
            [11.55740429781971, -4.887586256322414],
            [11.561308360488704, -4.891607019180813],
            [11.561244402164219, -4.897440360994946],
            [11.563653455127467, -4.899578576677602],
            [11.574999958072256, -4.900297663089525],
            [11.575463784078304, -4.905684755132313],
            [11.5719929653452, -4.9101884076296765],
            [11.577055677974462, -4.910847587966896],
            [11.582002736974745, -4.915573692823344],
            [11.58412306205276, -4.914553954505325],
            [11.587800639386563, -4.921207097606542],
            [11.587500481948721, -4.923027845280328],
            [11.591516340467802, -4.927433340146711],
            [11.595589890533743, -4.924754748356292],
            [11.602803232887963, -4.928187769565388],
            [11.606865712889501, -4.927290499782791],
            [11.609264704521237, -4.932662425908971],
            [11.617350338342023, -4.936199537111535],
            [11.622829079347856, -4.936287663604412],
            [11.62606556812449, -4.940596506003135],
            [11.628644893172602, -4.940364292876378],
            [11.63273168579451, -4.934416915285655],
            [11.63617448572236, -4.9448838736270435],
            [11.651870483427333, -5.004203710504261],
            [11.67967027878551, -5.030624764144144],
            [11.680520523789706, -5.051056006657136],
            [11.680806648850119, -5.0808799679797865],
            [11.677197973825942, -5.084531451317673],
            [11.679167924177358, -5.115934762531704],
            [11.684811986119932, -5.126470151572143],
            [11.662910556250933, -5.130297154455664],
            [11.652472095829866, -5.133390212277821],
            [11.65044173523729, -5.135702303965879],
            [11.641623074987345, -5.139360656348106],
            [11.623687028015993, -5.155054370456602],
            [11.614909770557464, -5.161215035788636],
            [11.60284309318233, -5.166845887152807],
            [11.598122111590872, -5.167082744173523],
            [11.577346466999666, -5.176484875615698],
            [11.56970594145024, -5.1827202734798545],
            [11.556333016943345, -5.170534277032237],
            [11.543357020956337, -5.177824061992349],
            [11.532808937587223, -5.186787481041632],
            [11.515559223254742, -5.191934912840538],
            [11.501995341292604, -5.198686803109906],
            [11.487541029009368, -5.208174288812062],
            [11.484927979342109, -5.202354772095414],
            [11.482620517244026, -5.1919025544783715],
            [11.479973934936393, -5.185222364695906],
            [11.475289402905824, -5.181411100812505],
            [11.46941159396874, -5.179064910048661],
            [11.45804976974477, -5.1780759059853185],
            [11.458068364436658, -5.175642242603707],
            [11.453824719773554, -5.171719855927683],
            [11.341188949271393, -5.238287053942398],
            [11.33680106457859, -5.240102359208221],
            [11.330732046529207, -5.235880626465649],
            [11.328692574837362, -5.231511097346919],
            [11.327662112047218, -5.224674710149633],
            [11.328951911100486, -5.209024702403329],
            [11.32797374687564, -5.203795858151909],
            [11.329231050931824, -5.197048791921286],
            [11.322363801733319, -5.191316805883457],
            [11.316589073767105, -5.181284171930439],
            [11.311818047010263, -5.177892919948528],
            [11.315158431586935, -5.17338708093829],
            [11.309280775582845, -5.169958592584125],
            [11.311945818833951, -5.16786486190131],
            [11.30760378247627, -5.162116276277208],
            [11.302484722920646, -5.161078463517689],
            [11.303273411643245, -5.157635265258626],
            [11.292934459249796, -5.154804934522992],
            [11.290965771998854, -5.150320923801474],
            [11.287697179067564, -5.152893349183111],
            [11.28543912105646, -5.148752349802594],
            [11.274232312722374, -5.152004483453276],
            [11.27002566749986, -5.148711583928736],
            [11.264735410619178, -5.151281599523807],
            [11.261632662350959, -5.151326799899692],
            [11.258857071197722, -5.147357146716525],
            [11.25758223766932, -5.141386769578074],
            [11.254356323961895, -5.1420696296417505],
            [11.252879593375246, -5.1350231890284945],
            [11.247912301301538, -5.129864769956878],
            [11.242810358130965, -5.127039786663786],
            [11.236884328970751, -5.116504914056308],
            [11.238754291369506, -5.112564492973214],
            [11.235312741837706, -5.10976210299687],
            [11.236656171381759, -5.100169013307194],
            [11.232809947787691, -5.101747279443611],
            [11.232793605484309, -5.096867606426836],
            [11.225288826910905, -5.091278150950834],
            [11.225426890245933, -5.08697415210426],
            [11.22238134189014, -5.083875352826214],
            [11.224475747066336, -5.081038267556081],
            [11.22232534240859, -5.077131387531638],
            [11.217151304687834, -5.0795640119596195],
            [11.216803518622086, -5.0717297914030395],
            [11.211945774905486, -5.069275275008555],
            [11.210739011472397, -5.066802406988946]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.79596278333968, "lat": 32.96953939369972 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13303"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "303",
        "coty_gnis_code": "00348428"
      },
      "bbox": [
        11.20461230969371, -5.240102359208221, 11.684811986119932,
        -4.739939891281939
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.445579748004455, 6.345943780729206],
            [-11.430053382565333, 6.430850916363537],
            [-11.398130160072725, 6.424954060551518],
            [-11.282550831108303, 6.404716270653733],
            [-11.16697721258443, 6.384445661416515],
            [-11.106383121081082, 6.3738919054934495],
            [-11.05007416959459, 6.3642422152977804],
            [-11.065073137093753, 6.279220405238109],
            [-11.030456285096838, 6.2733668408833605],
            [-10.938361691308849, 6.257381192677626],
            [-10.94555300859652, 6.21454425516627],
            [-10.967853618946759, 6.086538652669531],
            [-10.972060381031818, 6.087301345686669],
            [-10.979446135540899, 6.044511267247385],
            [-10.968676137331526, 6.0369803172051],
            [-10.962547074242538, 6.04001550967235],
            [-10.956450679688727, 6.036507695431256],
            [-10.953919199266124, 6.037075853080163],
            [-10.952187633881833, 6.04195664805839],
            [-10.948661824441455, 6.043666004616967],
            [-10.942504448105455, 6.050796441300204],
            [-10.937257308556541, 6.0497788678244895],
            [-10.93745528257418, 6.045814880506723],
            [-10.933498809262254, 6.039079042056592],
            [-10.924957629742336, 6.041927343011695],
            [-10.921119563576813, 6.032914368846779],
            [-10.922773111459964, 6.028246787959425],
            [-10.912994432589675, 6.022908552511944],
            [-10.911985166262902, 6.019619894618777],
            [-10.907582090970985, 6.01570323999238],
            [-10.903967402305586, 6.014799379251733],
            [-10.903228524358774, 6.009959046085829],
            [-10.90029321902316, 6.005258975623862],
            [-10.898626059053585, 5.998493698291153],
            [-10.895847054198901, 5.994351693418628],
            [-10.888939599626157, 5.993845359252222],
            [-10.886169122670221, 5.992306102872566],
            [-10.883499010217818, 5.987907430760245],
            [-10.877428595288062, 5.989778605919899],
            [-10.876783233285384, 5.9845207058382694],
            [-10.872438380739982, 5.980516066777554],
            [-10.871919538621473, 5.976246507130475],
            [-10.860618606402662, 5.97206620345825],
            [-10.859167937240251, 5.966439047091115],
            [-10.856654477798632, 5.963877559756872],
            [-10.852659163535844, 5.955589698339621],
            [-10.850156416171936, 5.954286157020372],
            [-10.846647208424724, 5.943423986260692],
            [-10.843928247662264, 5.942464504633762],
            [-10.842089752777506, 5.93837017780123],
            [-10.837158905602175, 5.933261629479486],
            [-10.832693719145466, 5.933954590174998],
            [-10.827620842895275, 5.9309450956895535],
            [-10.823536341948241, 5.931646275725562],
            [-10.815393467683219, 5.926891721587195],
            [-10.809613678895547, 5.922284505529446],
            [-10.806920528750553, 5.915881947905825],
            [-10.804563132257305, 5.915197942444143],
            [-10.74197590603889, 5.905032355852354],
            [-10.746730825369637, 5.876983229109343],
            [-10.819443935852712, 5.888972641114912],
            [-10.873596870359764, 5.8981736135546505],
            [-11.00095427292944, 5.919010969429433],
            [-11.06377906652913, 5.9294067700851665],
            [-11.1316858000678, 5.941474185329396],
            [-11.198585612169314, 5.952722651374048],
            [-11.34120186847362, 5.977333346817146],
            [-11.38170560975227, 5.984685087166],
            [-11.46643947208293, 5.999486681737926],
            [-11.467035517015184, 5.99613536534036],
            [-11.508117510712072, 6.003347600501165],
            [-11.477298963523857, 6.175138653025072],
            [-11.475915438638152, 6.174917826713182],
            [-11.446693811574308, 6.3394321259667015],
            [-11.445579748004455, 6.345943780729206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.31129012573008,
          "lat": 43.82012004469304
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16051"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00399751"
      },
      "bbox": [
        -11.508117510712072, 5.876983229109343, -10.74197590603889,
        6.430850916363537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.498771794583682, 9.268108789752192],
            [-13.491635084715279, 9.260535190157324],
            [-13.489308873341036, 9.255521652415512],
            [-13.481798746960875, 9.249622597720615],
            [-13.480689647586988, 9.242960731602711],
            [-13.477314068026223, 9.237961195275462],
            [-13.475507587866508, 9.237985868301461],
            [-13.471817710410665, 9.232733933509163],
            [-13.470030539193495, 9.225599319320262],
            [-13.470885531984544, 9.224075168084687],
            [-13.468453304153742, 9.217751049790756],
            [-13.470401823466755, 9.210062424409937],
            [-13.46933727168732, 9.207478167807071],
            [-13.409894334894519, 9.19475594291617],
            [-13.393971715311809, 9.191485424805094],
            [-13.386584607839543, 9.178586874915782],
            [-13.387002709859386, 9.17221558466603],
            [-13.38495380384265, 9.164201021144937],
            [-13.38698684144978, 9.159325237150838],
            [-13.388136682845346, 9.150963329854315],
            [-13.384554182777102, 9.147665623621261],
            [-13.38309240014734, 9.143332296985374],
            [-13.38365871222077, 9.13290326570539],
            [-13.381902888865525, 9.12836313497364],
            [-13.378020514309878, 9.12258211231957],
            [-13.378668329202997, 9.116036200738272],
            [-13.37687587808603, 9.10864096421918],
            [-13.374466036454306, 9.103195024930097],
            [-13.371801965614694, 9.081314434446263],
            [-13.370207741713106, 9.077736315176837],
            [-13.37066941720729, 9.071152396188959],
            [-13.36380149298855, 9.056436192458023],
            [-13.358367139800409, 9.051203137399513],
            [-13.354268987781204, 9.04495279463997],
            [-13.353378959029667, 9.035315053218158],
            [-13.351608564778566, 9.032080674640268],
            [-13.345092075711742, 9.026678948529614],
            [-13.342932850000397, 9.02301576887669],
            [-13.338551212792698, 9.02189463259353],
            [-13.333405970565668, 9.018403079598656],
            [-13.326763937222378, 9.016217018831277],
            [-13.323290050837148, 9.01253461224186],
            [-13.32295392112727, 9.003750751352285],
            [-13.317245250444149, 8.998966385746648],
            [-13.310066788368543, 8.989500031714567],
            [-13.308357491623402, 8.984478626379875],
            [-13.316327461243084, 8.982625806713814],
            [-13.318023278870376, 8.981084028023561],
            [-13.328864500829527, 8.976990408355787],
            [-13.34035354991106, 8.975435375687429],
            [-13.35096849565464, 8.979293068370696],
            [-13.352825292879373, 8.977037959261757],
            [-13.361521003946095, 8.978639101883639],
            [-13.36352065742344, 8.977935761055061],
            [-13.375130305691508, 8.983347268268265],
            [-13.384674158015098, 8.985809068301705],
            [-13.387016825765576, 8.990267605025506],
            [-13.392532642624678, 8.9917888649079],
            [-13.400851093776598, 8.990111297658604],
            [-13.409356250624747, 8.984678117058],
            [-13.416544724339106, 8.97714323586205],
            [-13.421118705971423, 8.970208653644606],
            [-13.42725613269829, 8.96926212784093],
            [-13.43603814504073, 8.963699770014678],
            [-13.43831660061027, 8.95676132558166],
            [-13.437763994631778, 8.953722824278467],
            [-13.442698932163047, 8.942082828344251],
            [-13.448768131304409, 8.94006974810138],
            [-13.452004090857374, 8.941566485760365],
            [-13.457130961316146, 8.947876616110731],
            [-13.462284537571755, 8.952024245334977],
            [-13.469414342872343, 8.951267351686145],
            [-13.473666164372338, 8.953128428521405],
            [-13.476222627453563, 8.956652132746717],
            [-13.476625885302058, 8.96074479238499],
            [-13.479952520356639, 8.963893511761135],
            [-13.483144281945375, 8.963693011314275],
            [-13.48536898417391, 8.967861342411817],
            [-13.488085227529778, 8.965324195215295],
            [-13.493239565486478, 8.965706232578844],
            [-13.501840878313857, 8.97318334022315],
            [-13.505768192749807, 8.974138062836467],
            [-13.509908655211907, 8.971068389379166],
            [-13.513022293352455, 8.972111554854981],
            [-13.518100628703253, 8.969714236905311],
            [-13.525321455429442, 8.97573599882374],
            [-13.529913101837185, 8.986050890767345],
            [-13.533267419955168, 8.990554364130373],
            [-13.547296495914027, 8.995138884420083],
            [-13.557014868071885, 8.996337379392257],
            [-13.559659591329389, 8.995257508724848],
            [-13.56492666566105, 9.001856942331928],
            [-13.574358054509, 9.00310035643954],
            [-13.5757664204776, 9.005578572114736],
            [-13.58454314687003, 9.01246736892845],
            [-13.58986158485487, 9.020173746508036],
            [-13.596270178323374, 9.022030434954349],
            [-13.605670830870787, 9.018065448082071],
            [-13.6110998144321, 9.019522558834797],
            [-13.614693732797805, 9.01596808719895],
            [-13.616608048037577, 9.009301524189057],
            [-13.619607431064518, 9.004659988370166],
            [-13.620717631906754, 8.999432797200834],
            [-13.625913373555584, 8.995899112906592],
            [-13.626544264437069, 8.991753795991592],
            [-13.636449475390211, 8.981093872542656],
            [-13.637112452365884, 8.977334538028272],
            [-13.642156301644977, 8.97454228370695],
            [-13.642113486264622, 8.969501818760524],
            [-13.644766853609054, 8.965144035169441],
            [-13.642788097502981, 8.961109942786607],
            [-13.64303343518573, 8.955504602614058],
            [-13.646348195736909, 8.952063576289772],
            [-13.651133343756644, 8.952330144990107],
            [-13.652076053271081, 8.954878874434966],
            [-13.65660997729696, 8.953787373043827],
            [-13.661754384547146, 8.956572245994185],
            [-13.666899648284849, 8.963512535669766],
            [-13.669201950797412, 8.963979839343875],
            [-13.685819651191007, 8.888582013685912],
            [-13.688732429144922, 8.882864911581484],
            [-13.688665600543668, 8.876687911263533],
            [-13.696767696841828, 8.867474194930338],
            [-13.701464536076738, 8.8610957838254],
            [-13.70250638238517, 8.858032853241756],
            [-13.701426320238037, 8.850454297391224],
            [-13.70386616313994, 8.845514323353871],
            [-13.706974137035733, 8.842787927392608],
            [-13.714500891416796, 8.842053427343192],
            [-13.716071961372563, 8.846912895524902],
            [-13.722721987761728, 8.852034248769488],
            [-13.727425253791916, 8.862765292462207],
            [-13.733639537018874, 8.87114798024385],
            [-13.735767550818055, 8.877062125330653],
            [-13.739081841993569, 8.878481604569675],
            [-13.747215411955288, 8.884994057286049],
            [-13.753662151824646, 8.887418157919083],
            [-13.757698166672236, 8.886604765395981],
            [-13.760209163718265, 8.8906587637232],
            [-13.763607811000748, 8.892424283036975],
            [-13.773487845573195, 8.892912417705917],
            [-13.781131363984862, 8.889100581871459],
            [-13.783229047200916, 8.876275002672974],
            [-13.78267192109802, 8.864898383027063],
            [-13.783418871652914, 8.862006898612892],
            [-13.788048198144473, 8.855359565456851],
            [-13.795587998222814, 8.853281879267541],
            [-13.799084126906783, 8.853642680364787],
            [-13.801163399016351, 8.857042091592817],
            [-13.81387801820323, 8.864431931613902],
            [-13.820846073741524, 8.866465264496695],
            [-13.824704174602612, 8.86404488486682],
            [-13.810013740678995, 8.928865009292762],
            [-13.811832943937013, 8.929370873860867],
            [-13.797953384287554, 8.986133304375803],
            [-13.785378941480616, 9.042519396714933],
            [-13.77311912255291, 9.096555110939258],
            [-13.767761705741385, 9.095428880859854],
            [-13.759047605268517, 9.09869133017026],
            [-13.757596762390664, 9.109977618206313],
            [-13.759267775306075, 9.116768867943652],
            [-13.760143646809077, 9.13157991205169],
            [-13.761194506222509, 9.138705325041643],
            [-13.760384952161708, 9.142677940451323],
            [-13.761584203063345, 9.148426092524957],
            [-13.765507193745139, 9.15503884727627],
            [-13.765477615814204, 9.166310620021227],
            [-13.762488872961347, 9.171914433114413],
            [-13.76114662001897, 9.178312715654007],
            [-13.761605349979572, 9.182554586318053],
            [-13.712866848536724, 9.17165633341626],
            [-13.649442565018619, 9.15830593832198],
            [-13.610279221344664, 9.149714706724128],
            [-13.608892084383461, 9.158523910575212],
            [-13.609384096595866, 9.162815185504606],
            [-13.603803457227091, 9.167523444976474],
            [-13.59080127531685, 9.171111506070554],
            [-13.582959576670632, 9.168920549190378],
            [-13.57266496487134, 9.163618032039224],
            [-13.568181250866097, 9.158955896278623],
            [-13.560916192833004, 9.156410361770329],
            [-13.557720070841876, 9.15891710783613],
            [-13.555292170650224, 9.157861937866295],
            [-13.546473239465843, 9.157362186938403],
            [-13.543820088567092, 9.152999315613163],
            [-13.537453569140775, 9.149313409957834],
            [-13.534125661432867, 9.150518847081813],
            [-13.524793955913948, 9.149062239027904],
            [-13.518381564100947, 9.156954869881407],
            [-13.5183501740935, 9.163269116323841],
            [-13.51548549603046, 9.165064389196742],
            [-13.514386000279819, 9.174981261645243],
            [-13.51069924426976, 9.190542843931274],
            [-13.512108778779389, 9.193125843715158],
            [-13.510578846356943, 9.199751600938985],
            [-13.512170045465847, 9.203672296846808],
            [-13.512836844120095, 9.212158969509854],
            [-13.508698810476636, 9.219322747830963],
            [-13.522786555342153, 9.241090413953422],
            [-13.526917787101965, 9.248629027941233],
            [-13.529242079832693, 9.261068378414453],
            [-13.527917989571632, 9.269888277856104],
            [-13.529156021090113, 9.273103059314],
            [-13.526294212879275, 9.275536910030219],
            [-13.519592442013648, 9.273407733232107],
            [-13.509485444389986, 9.272862646972316],
            [-13.502667777481648, 9.270973254362495],
            [-13.498771794583682, 9.268108789752192]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.42635945783317,
          "lat": 46.237050081463074
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16061"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00395622"
      },
      "bbox": [
        -13.824704174602612, 8.842053427343192, -13.308357491623402,
        9.275536910030219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.158473073105204, 1.8210472547905652],
            [6.153838615876976, 1.8796685341585566],
            [6.149472591198796, 1.9385968083545642],
            [6.17773092538622, 1.9405280226418804],
            [6.234512375346839, 1.9449663815903167],
            [6.327217528541092, 1.9537082873832279],
            [6.407050115075323, 1.9613095096408006],
            [6.464830500053792, 1.9659107130690014],
            [6.493622088091764, 1.9684209560729473],
            [6.502806105481995, 1.9679319256191112],
            [6.517094111621733, 1.9689999829847522],
            [6.546326546076726, 1.9717924867646237],
            [6.555488196893159, 1.8855182983024523],
            [6.563926147666566, 1.7974185417954132],
            [6.55387750177951, 1.7964256064596187],
            [6.561153395129226, 1.720079398780416],
            [6.562286211757617, 1.7125514856836064],
            [6.570685974671054, 1.6247775263399022],
            [6.578592015940015, 1.5370335689739731],
            [6.58679381066276, 1.4492757774459772],
            [6.532392401427701, 1.4442964479075941],
            [6.446542193133487, 1.4379163869383982],
            [6.360501505214625, 1.4297012315505393],
            [6.27496540554887, 1.4230920040850412],
            [6.2462971660148465, 1.4205721571099847],
            [6.189330440372304, 1.4158736237431255],
            [6.181961640095361, 1.504344962019916],
            [6.174649037064503, 1.592757467718976],
            [6.168518911816784, 1.666615987274335],
            [6.167579119708038, 1.6796422324684277],
            [6.160800211739435, 1.7618840933576885],
            [6.162931694327857, 1.7621050121585942],
            [6.158473073105204, 1.8210472547905652]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.19915261888222, "lat": 40.14009287364219 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17019"],
        "coty_name": ["Champaign"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Champaign County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00424211"
      },
      "bbox": [
        6.149472591198796, 1.4158736237431255, 6.58679381066276,
        1.9717924867646237
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.621378829893063, 1.3068178910988082],
            [5.62481484404011, 1.3088955071996604],
            [5.649806659703515, 1.3106486972161218],
            [5.650066288712216, 1.3070801875752616],
            [5.657311489607982, 1.307632573960387],
            [5.658534593931879, 1.3052603420304438],
            [5.6650909966548, 1.3008908972148738],
            [5.672124797050186, 1.3014851336478133],
            [5.672390518017315, 1.297921075257248],
            [5.679598491261178, 1.2984648558481346],
            [5.692394779829733, 1.1515346820197767],
            [5.778725134183242, 1.1573280918527256],
            [5.778767098336769, 1.1568717833569142],
            [5.782715070110752, 1.1129612316931397],
            [5.789756938077801, 1.0250035652206206],
            [5.792968219191884, 0.9659253328683388],
            [5.794419499832234, 0.9363890383140064],
            [5.795554972532693, 0.9364714864326668],
            [5.798454802368512, 0.8903627623649265],
            [5.8018082398729405, 0.8466005758479762],
            [5.714169671685416, 0.8432153885772213],
            [5.671355955327514, 0.8402228272488748],
            [5.628938353890356, 0.8369205027445616],
            [5.543559395577724, 0.8309829728873929],
            [5.458572719206642, 0.8250811700342744],
            [5.415374675247417, 0.8222067024062986],
            [5.409124181742114, 0.8976519500381913],
            [5.408423043376782, 0.9104243269510767],
            [5.401258934059007, 0.9990263011893861],
            [5.397836361676397, 1.0428209221923181],
            [5.394124285142856, 1.087189015671153],
            [5.394287947905235, 1.0890644333913597],
            [5.392117905492995, 1.1162976714669954],
            [5.435184012656436, 1.1189445011943426],
            [5.431857506838682, 1.162335430011795],
            [5.47285365301926, 1.1648926557723078],
            [5.467990372302573, 1.2297000323317855],
            [5.467297866832962, 1.2437360235701502],
            [5.473062433197955, 1.2412862109451446],
            [5.472608176242169, 1.2333944013182274],
            [5.4799285294938285, 1.2264141499711998],
            [5.490028025102863, 1.2252164314637068],
            [5.49248108313397, 1.226432032028161],
            [5.498000884179401, 1.2336836819997203],
            [5.4989601524679035, 1.2378310107002615],
            [5.507599611581974, 1.2425567113248757],
            [5.515023801949982, 1.2405972595846786],
            [5.517674841374312, 1.246978328499057],
            [5.516400818144831, 1.2527125477893597],
            [5.517639983223739, 1.255960258821355],
            [5.523856501331987, 1.2553809954009723],
            [5.5401351439852045, 1.25039545654857],
            [5.5397707693403015, 1.2556531552000358],
            [5.544727701707756, 1.2590920064267768],
            [5.552182198056244, 1.259051416195718],
            [5.559046942615171, 1.2641006036834268],
            [5.5608962257040435, 1.266862174053737],
            [5.561014429389937, 1.2730672922310435],
            [5.5627592432014765, 1.2782098007349085],
            [5.5668201615542525, 1.2790874662121297],
            [5.572747122760573, 1.2833171710089173],
            [5.574068503172225, 1.2886252455727434],
            [5.5776754855004915, 1.2890182535445764],
            [5.585533043021472, 1.2969374446983197],
            [5.5878288330674595, 1.2950398470504725],
            [5.591515055227831, 1.3007873060151889],
            [5.594598001327362, 1.3139016826381513],
            [5.5986641384259075, 1.317622079546633],
            [5.607319038780493, 1.3110634966954307],
            [5.608740344243602, 1.3053311054871861],
            [5.615374887653144, 1.3076909670759027],
            [5.621378829893063, 1.3068178910988082]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.27726853627753,
          "lat": 39.545829295024994
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17021"],
        "coty_name": ["Christian"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Christian County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00424212"
      },
      "bbox": [
        5.392117905492995, 0.8222067024062986, 5.8018082398729405,
        1.317622079546633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.1413621345023515, -0.3638826467345582],
            [6.135507821529954, -0.27624791957237904],
            [6.13289929513208, -0.23138664731848121],
            [6.204166404217202, -0.2262348759880195],
            [6.2497456628060934, -0.22275796664958267],
            [6.276924299602131, -0.22113424737712306],
            [6.3039181661519965, -0.21923148420291105],
            [6.344387877115679, -0.21578651358963727],
            [6.390392947662399, -0.2124839174912462],
            [6.39275977248806, -0.24522225662474398],
            [6.399555471789488, -0.34366845019014086],
            [6.405155818784222, -0.43078910188228975],
            [6.411599429254509, -0.5161423049015771],
            [6.415257054946406, -0.5619426357250183],
            [6.41530775087412, -0.5626608555717789],
            [6.329861398156089, -0.570223598451],
            [6.31488744489652, -0.5712242209869574],
            [6.290970320491347, -0.5738186209946737],
            [6.27086079029059, -0.5751221446706225],
            [6.242901923271923, -0.5773108081818341],
            [6.242702266079681, -0.5767409661901984],
            [6.183922943465699, -0.5817864813000865],
            [6.156703591613818, -0.5838903290268699],
            [6.150551681518472, -0.500004243066561],
            [6.144892216071285, -0.41867610412788014],
            [6.1413621345023515, -0.3638826467345582]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.53910376433785, "lat": 38.08155269334007 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17065"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00424234"
      },
      "bbox": [
        6.13289929513208, -0.5838903290268699, 6.41530775087412,
        -0.2124839174912462
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.6083213132048195, 2.7696092523883107],
            [4.605008470630765, 2.8369282833599465],
            [4.602002675432319, 2.9001738220541347],
            [4.609973609109512, 2.9014477943513373],
            [4.619817776632446, 2.9075717084019397],
            [4.627888572427624, 2.9147015359511323],
            [4.633947263454358, 2.9218142748554254],
            [4.639087767367469, 2.9223609746564816],
            [4.64172933141454, 2.9245205820913336],
            [4.643839721955989, 2.9297804467613626],
            [4.646020873606153, 2.9429953698315963],
            [4.6495144998948446, 2.9493524801275934],
            [4.658054658957456, 2.955906538583834],
            [4.672263654654003, 2.961963595549801],
            [4.683536783554072, 2.9573475108334035],
            [4.687720905549337, 2.959448838657869],
            [4.69275890710269, 2.967009630142179],
            [4.698083619890281, 2.967681732258681],
            [4.704094734880248, 2.970253611588034],
            [4.7114367927610585, 2.9706950870284934],
            [4.7194852559183635, 2.9729947197493214],
            [4.725306918848898, 2.9727410579763003],
            [4.732945120000681, 2.9744337182738523],
            [4.739096953348059, 2.9768941604161236],
            [4.746338191167223, 2.9815778580811805],
            [4.7505130825731845, 2.982719587192345],
            [4.752031605856433, 2.9874416225627027],
            [4.756774169133988, 2.9911650031761967],
            [4.771616013077932, 2.994297743219956],
            [4.774418959075569, 2.997581320290705],
            [4.779362731347424, 3.0107443013321182],
            [4.781740222345786, 3.02191031460459],
            [4.782485595379086, 3.028596781548858],
            [4.781456219252394, 3.0338054189507253],
            [4.77703191778529, 3.039440386322017],
            [4.8219507710618466, 3.0422264956369673],
            [4.916137038680461, 3.0472035120588816],
            [4.995186347728842, 3.052310244292235],
            [5.0164897946805125, 3.0539216620422494],
            [5.023144229028819, 2.9882753062415173],
            [5.024451863659215, 2.988248875704396],
            [5.028049740974232, 2.936813012981397],
            [5.033385199450893, 2.8558879684749274],
            [5.038526583577852, 2.7791191998540286],
            [5.041368578484562, 2.7251024639416515],
            [5.042748072442166, 2.7030493552939547],
            [5.035175073542472, 2.7025107605521725],
            [5.040428282918574, 2.617137189682345],
            [5.015251647427512, 2.615413877861317],
            [4.953667917435468, 2.611491183904451],
            [4.882772568629709, 2.607362264330688],
            [4.855928641136298, 2.606190239930207],
            [4.7863268744875, 2.6038353621799035],
            [4.701122904113594, 2.597772861977338],
            [4.651501206816952, 2.5948380677390843],
            [4.615759046826427, 2.5929932622938887],
            [4.611799620587843, 2.6807680102493068],
            [4.6083213132048195, 2.7696092523883107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.13142689700798,
          "lat": 41.353128440688295
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17073"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00424238"
      },
      "bbox": [
        4.602002675432319, 2.5929932622938887, 5.042748072442166,
        3.0539216620422494
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.573373266915996, 1.2157037357710543],
            [4.6616214708187345, 1.2199479962330384],
            [4.66352563089426, 1.1838668205539837],
            [4.688535346460006, 1.1851007513254774],
            [4.748755441987266, 1.1885534067993488],
            [4.752669104656206, 1.1004923153819643],
            [4.779446096075181, 1.101884003076031],
            [4.780946757569072, 1.072705780265016],
            [4.8094816243065415, 1.0743199863323474],
            [4.810636208514783, 1.045198024981774],
            [4.815622045443835, 0.9572064448059657],
            [4.674755510477904, 0.9496708825853216],
            [4.602526831845374, 0.9461304626882481],
            [4.6023166400067925, 0.9518504615620487],
            [4.6068622922285964, 0.9599892343667272],
            [4.608206965135723, 0.9640835120644728],
            [4.6062246030225245, 0.9710658923425314],
            [4.603733897057746, 0.9844203185195991],
            [4.600213284444415, 0.9918708415810833],
            [4.598060838948269, 0.9992953674148652],
            [4.589803593152002, 1.0211772760564066],
            [4.584764483020766, 1.0290561978612836],
            [4.578633721499308, 1.0441766722535357],
            [4.576341590513747, 1.05277099628407],
            [4.575597102330516, 1.0616118689612848],
            [4.568962170910129, 1.073123575533906],
            [4.566835865544495, 1.07797417544946],
            [4.562082701077607, 1.0847117707252145],
            [4.5570972968878305, 1.0935035037781624],
            [4.5539034968113254, 1.0962916030219196],
            [4.548773313598547, 1.1076903817684876],
            [4.545907633044077, 1.1125016002179553],
            [4.5428576444867765, 1.1212231915734547],
            [4.542774196167664, 1.1275892049097436],
            [4.545672104470293, 1.140722442733731],
            [4.553178043875701, 1.1508383438827785],
            [4.560504361190771, 1.167666190436359],
            [4.569182827204786, 1.1936052198917648],
            [4.5682079911472195, 1.2015798684863563],
            [4.573373266915996, 1.2157037357710543]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.47474160322008, "lat": 39.64407577663513 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17171"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00424286"
      },
      "bbox": [
        4.542774196167664, 0.9461304626882481, 4.815622045443835,
        1.2199479962330384
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.966415888037449, 1.7334469782929032],
            [6.967026422504308, 1.7416538141114581],
            [6.964567076001176, 1.748127074733103],
            [6.955557429014558, 1.7525034029725806],
            [6.9476435984921725, 1.755180219733103],
            [6.943826923226731, 1.75772960022458],
            [6.941420461750591, 1.7613989054758257],
            [6.9387342311854505, 1.7696141612200444],
            [6.939622473984039, 1.7737611986908952],
            [6.94361881173412, 1.7793545757418523],
            [6.9490181411180325, 1.7905808703463018],
            [6.950539384938378, 1.7975811994759088],
            [6.9538497577294045, 1.7996711501931193],
            [6.962276837708318, 1.8024679293599217],
            [6.969873072503432, 1.8099366675906194],
            [6.987111641819615, 1.8163105243402815],
            [6.995231043096415, 1.8201436714753145],
            [6.998727776961002, 1.8259227747103828],
            [7.002553439095295, 1.8271618618021641],
            [7.005311674223337, 1.8330623017921561],
            [7.0084891339792525, 1.8341554803866715],
            [7.012775959731707, 1.840173584598199],
            [7.01545445920655, 1.8471699641481185],
            [7.021020281727743, 1.8512852861795717],
            [7.023624694921675, 1.8593486434003512],
            [7.02665091727236, 1.8630203016011675],
            [7.03409212532855, 1.8685632921547897],
            [7.037836424493081, 1.8696258548656872],
            [7.042525621829575, 1.8799715189825548],
            [7.0470133214863155, 1.8936032824212021],
            [7.050898177467914, 1.899357041950446],
            [7.058699309461456, 1.9044104144434157],
            [7.069204262330689, 1.917133944517016],
            [7.069634793630329, 1.9243463326859858],
            [7.071616734350277, 1.9271216788907553],
            [7.081529484508718, 1.9304953099687985],
            [7.09943561711366, 1.943039613205256],
            [7.103669941266791, 1.9440005183755256],
            [7.113128726216158, 1.9483290946744405],
            [7.125493192783626, 1.9580202907221507],
            [7.134117352773434, 1.9600917714162578],
            [7.137526424135942, 1.9590304148328892],
            [7.153991523828188, 1.9665139852033464],
            [7.157885073064459, 1.9713463591470348],
            [7.163374657127362, 1.974954188297298],
            [7.171651290947759, 1.9826164627605203],
            [7.173130749195678, 1.9893753870878303],
            [7.177996597369753, 1.9951741666409175],
            [7.181153346700563, 1.9954108984409575],
            [7.190949362169581, 1.8867256633492309],
            [7.195174741669851, 1.8429755556366514],
            [7.199744184410203, 1.799287710441105],
            [7.207702175357766, 1.714904042578019],
            [7.212092422757237, 1.666486373215277],
            [7.213666125058784, 1.6568431504116967],
            [7.2186082568778716, 1.6092238069407119],
            [7.221830693148506, 1.5802422599112327],
            [7.22107462166087, 1.580185389063066],
            [7.177709562306359, 1.5761699236375657],
            [7.135494068656123, 1.5724678058295585],
            [7.092204585855672, 1.5680483476427518],
            [6.975823768501868, 1.5571066825805313],
            [6.972112520494292, 1.5566593517055205],
            [6.970349791955494, 1.5604938587774932],
            [6.965349628049788, 1.5584301341807756],
            [6.960731563891591, 1.5595869177266075],
            [6.956237816377917, 1.5631770658339676],
            [6.962658701546825, 1.5746315770643153],
            [6.964005975083898, 1.5857990246348028],
            [6.963317048121107, 1.5905570924331827],
            [6.958362599074029, 1.597690760807499],
            [6.957474484205413, 1.6055494018868846],
            [6.954724433406492, 1.6213182808342599],
            [6.954251963028841, 1.6299840070865945],
            [6.956359629747246, 1.6367466975341856],
            [6.960636830850526, 1.6425023563951158],
            [6.960670647289913, 1.6454365419960393],
            [6.955649119018371, 1.648966023393992],
            [6.956565901639787, 1.6539964814248866],
            [6.962286709264978, 1.6585397467641616],
            [6.964550388986241, 1.6635747010912798],
            [6.964401066945019, 1.677554108479224],
            [6.966019629431439, 1.6918878409470188],
            [6.9643031985711925, 1.6978070635383495],
            [6.964781334379566, 1.7065146205504187],
            [6.9673703555129105, 1.7122423902316612],
            [6.96640068988658, 1.7244281272856048],
            [6.966415888037449, 1.7334469782929032]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.2419864876593, "lat": 40.12091342658934 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18045"],
        "coty_name": ["Fountain"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fountain County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00450351"
      },
      "bbox": [
        6.9387342311854505, 1.5566593517055205, 7.221830693148506,
        1.9954108984409575
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.180403628866016, 0.7845705409348797],
            [7.26615090797058, 0.7897230593124982],
            [7.323084117682553, 0.7941588757791715],
            [7.344443880299168, 0.7962704439486011],
            [7.446513787455776, 0.8057274191803901],
            [7.472078070117398, 0.8075599605893614],
            [7.482337771645143, 0.808868764194675],
            [7.493237918585397, 0.8093545859279825],
            [7.5655482792577, 0.8156424570774821],
            [7.60734461313498, 0.819177378755937],
            [7.614871726306248, 0.7471459881335836],
            [7.625028568610998, 0.6450765946292321],
            [7.63325445123059, 0.5569083784080235],
            [7.547702654864945, 0.5482110628874067],
            [7.4634629898256435, 0.5399104630852807],
            [7.421086826514466, 0.5348541712274641],
            [7.376837139309157, 0.5300133625424011],
            [7.314233406625983, 0.5255067612519301],
            [7.290378431790218, 0.5239860374134536],
            [7.290045316481815, 0.5266268828383919],
            [7.2047017384645855, 0.5192563183314668],
            [7.19816031228687, 0.59303622431177],
            [7.1869952711626395, 0.7114183712061021],
            [7.180403628866016, 0.7845705409348797]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.96204999796424,
          "lat": 39.036362821393624
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18055"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00451676"
      },
      "bbox": [
        7.180403628866016, 0.5192563183314668, 7.63325445123059,
        0.819177378755937
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.011137831573054, 0.10577522850807514],
            [8.044082751821746, 0.10857555882860467],
            [8.066180594286957, 0.11011036598815296],
            [8.111855601051982, 0.11291364448066528],
            [8.113133302857932, 0.11328852172820754],
            [8.145053246165986, 0.11543869271096233],
            [8.183170627941339, 0.11881837682219601],
            [8.187498539850658, 0.07497123972988967],
            [8.18811157851834, 0.075058104286567],
            [8.19253823271095, 0.031393668409580924],
            [8.206651728111172, 0.03269783296532611],
            [8.209780091320885, 0.0037505849177520453],
            [8.224322603393809, 0.005323172188123344],
            [8.22602558838156, -0.009530310457312285],
            [8.228180741607746, -0.009288358217358347],
            [8.229712133765684, -0.02361572281643728],
            [8.244134019629827, -0.022111430434719033],
            [8.245622194369886, -0.03681606056602082],
            [8.260084648552183, -0.03568135920790795],
            [8.266051561378315, -0.09417974177509966],
            [8.264418976683839, -0.09452553635697225],
            [8.265547402350887, -0.10801429184885813],
            [8.279506814041465, -0.10633350085988118],
            [8.31043077682283, -0.10371577945491142],
            [8.311404001085883, -0.10879177761188934],
            [8.308722735233587, -0.11540302236470239],
            [8.306910987514154, -0.1284620257035046],
            [8.3078350844647, -0.14571498955755846],
            [8.30926387115533, -0.15632130812189365],
            [8.314475492755475, -0.17884186048237635],
            [8.316408629852653, -0.19007887022846615],
            [8.316766308363773, -0.20107865058926724],
            [8.313204508369399, -0.2172325802264105],
            [8.311937530088324, -0.21882890169441063],
            [8.31119819995303, -0.23011400458515513],
            [8.311294145949978, -0.2501411164063879],
            [8.310623955773636, -0.2612562597417803],
            [8.308139398089947, -0.2701891179850603],
            [8.30443657203896, -0.2764384075242751],
            [8.296840027898272, -0.28613239730378975],
            [8.293272284100988, -0.28872706762492745],
            [8.273516975103492, -0.2933715575362905],
            [8.269934670702185, -0.29292422575408367],
            [8.253546985178772, -0.29811465907342627],
            [8.238823556967427, -0.3031762051109132],
            [8.23351960712365, -0.30578923920386547],
            [8.228624666071982, -0.3107774655975955],
            [8.227247755560787, -0.31979687369673027],
            [8.229863244960967, -0.3308218766393351],
            [8.229852925446409, -0.33651928542990384],
            [8.22740704166569, -0.3418870629567493],
            [8.22435988095352, -0.34364634010366474],
            [8.21811791343772, -0.3419376418311301],
            [8.2111747220749, -0.33538569706785726],
            [8.205009560792716, -0.3279636894827086],
            [8.200244589852003, -0.32024725306686613],
            [8.194321233942112, -0.3089043719967577],
            [8.191098154393126, -0.30403134989482233],
            [8.185250029662056, -0.30027174428236125],
            [8.170608329599695, -0.29398920850687704],
            [8.159949285602066, -0.2922452064701131],
            [8.151508036966607, -0.29236311206226406],
            [8.136452048181406, -0.295396000517637],
            [8.123446362728703, -0.3017042458371209],
            [8.114682423009066, -0.30224528244067617],
            [8.102884359601427, -0.29716563811551816],
            [8.078553431316731, -0.28776337271042934],
            [8.076176725516559, -0.2846200741366496],
            [8.067634435278823, -0.27873629816800405],
            [8.067569316712667, -0.27727609396413233],
            [8.056502440585856, -0.2732859037161489],
            [8.046265040499827, -0.26770444819919964],
            [8.039524146742057, -0.26272993118573773],
            [8.035749574450753, -0.25788067219542127],
            [8.033476525624854, -0.2525451406266445],
            [8.028730576913002, -0.2377669847524186],
            [8.025764126009427, -0.21952215863046198],
            [8.027284656610338, -0.20581214686223154],
            [8.02961419388515, -0.18965873776642278],
            [8.028735089015786, -0.18366232419557033],
            [8.026476313209283, -0.178761840637269],
            [8.013663651764661, -0.16271415261369665],
            [8.006347865319638, -0.1572414516384815],
            [7.988865533897516, -0.1500593201610412],
            [7.978256684391144, -0.14221577653377054],
            [7.982279072826694, -0.14129120389632216],
            [7.988186076159582, -0.14481383140398044],
            [7.991700553892379, -0.14447171868276518],
            [7.993504895512868, -0.14051610770121084],
            [7.989154732183542, -0.1382010317174861],
            [7.987245915925025, -0.13349742173904722],
            [7.991454969154626, -0.13361006679254311],
            [7.99270152539535, -0.12192071262834094],
            [7.994052047732838, -0.11947013787410268],
            [8.002843385441837, -0.11737305432776637],
            [8.00222581228869, -0.1119872704317381],
            [8.00602292492361, -0.11013634133704865],
            [8.00635715646817, -0.10636241912243764],
            [7.999467503758792, -0.10300505446021098],
            [7.998655069175019, -0.1003190917641125],
            [8.00081226746995, -0.09700913827597507],
            [8.003928817257025, -0.09659836524647988],
            [8.007791975713221, -0.09923539629417133],
            [8.012058359020399, -0.09669134505518526],
            [8.014393997806566, -0.09240636787599897],
            [8.011439033512174, -0.05316880772752658],
            [8.01064255328583, -0.039162773323975525],
            [8.007209969383362, -0.03714080831128019],
            [8.008714420207212, -0.03327612941797883],
            [8.014647361369747, -0.040340108075534],
            [8.016232342045571, -0.03834901468395536],
            [8.017119084643955, -0.03211230446534287],
            [8.020565150763705, -0.03395985702427862],
            [8.024163715822471, -0.033307537635780995],
            [8.024004564459029, -0.029793261326745226],
            [8.026130288518898, -0.02544596315545578],
            [8.024120239934629, -0.020984174057250882],
            [8.016585827099819, -0.022393464984456622],
            [8.015822432145741, -0.015802546289224655],
            [8.020289496476927, -0.012095847590648802],
            [8.014583075584707, -0.00971837366679638],
            [8.010123614311414, -0.01298235709659547],
            [8.008622682512302, -0.018175543954258817],
            [8.005438854632695, -0.016292505144326203],
            [8.006568701737944, -0.010564976103672736],
            [8.00215736049848, -0.008644420548200448],
            [7.9956684654394365, -0.002570716042775839],
            [7.998688290632462, 0.0010126760761900951],
            [7.99921553008991, 0.005625591144206148],
            [8.00353875564381, 0.0016027543986514884],
            [8.007393599233804, 0.0022746402920266607],
            [8.006892724731683, 0.005615717217168571],
            [8.004033271506307, 0.008296398548874224],
            [8.00635871702578, 0.01088413746322594],
            [8.003180587765666, 0.02133321999146365],
            [8.006617674593883, 0.023857501938405516],
            [8.003174170588101, 0.03068070681891855],
            [7.9984230475228495, 0.03132486355561197],
            [8.003828960823098, 0.03752482195415939],
            [8.005348161247301, 0.042843719487095845],
            [8.0097175960279, 0.0440317085473646],
            [8.013347173047048, 0.03795274037188885],
            [8.01956937396242, 0.035165729519515854],
            [8.019894818086794, 0.03823142502791624],
            [8.022980766445883, 0.044547536863088606],
            [8.022389227892216, 0.04704782083538913],
            [8.01617173393361, 0.0483092492077719],
            [8.013083292386272, 0.05517560683066237],
            [8.010767406270057, 0.06285133957411876],
            [8.01093213210625, 0.07077302260591838],
            [8.018740090538603, 0.0665576039041382],
            [8.022089791769565, 0.07110821261151865],
            [8.017322051682637, 0.07476920644742328],
            [8.01110449241689, 0.07582676268309896],
            [8.010589922392134, 0.08075401968263299],
            [8.015425474497363, 0.0774732132962057],
            [8.017052580034527, 0.081214948148972],
            [8.015398633947614, 0.08384443202554744],
            [8.015418475163749, 0.08941241343993171],
            [8.00988576529905, 0.09290972135650208],
            [8.007627014761274, 0.09641102229095651],
            [8.011137831573054, 0.10577522850807514]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.11143436647134, "lat": 38.19504705191093 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18061"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00451677"
      },
      "bbox": [
        7.978256684391144, -0.34364634010366474, 8.316766308363773,
        0.11881837682219601
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.195174741669851, 1.8429755556366514],
            [7.238016882300333, 1.8469454618866834],
            [7.322648103405245, 1.855309725838607],
            [7.408437737747178, 1.863381627249144],
            [7.494240475312798, 1.8712564761471422],
            [7.497636368600393, 1.8354034886294717],
            [7.507429428181296, 1.7370370445054586],
            [7.514230381785403, 1.6666928129129168],
            [7.515593272756788, 1.656104990496227],
            [7.523428539138318, 1.5785886544069299],
            [7.5291002592583185, 1.5204266276283966],
            [7.457830852122859, 1.5137335909051632],
            [7.395759512515526, 1.508174385204943],
            [7.392840665223138, 1.508192324549737],
            [7.3478812023498765, 1.5042318990116887],
            [7.345919514792985, 1.5038780942303562],
            [7.290956119762645, 1.4993280657629147],
            [7.2287682186676845, 1.4940244591149938],
            [7.22756342507139, 1.508574180698945],
            [7.22107462166087, 1.580185389063066],
            [7.221830693148506, 1.5802422599112327],
            [7.2186082568778716, 1.6092238069407119],
            [7.213666125058784, 1.6568431504116967],
            [7.212092422757237, 1.666486373215277],
            [7.207702175357766, 1.714904042578019],
            [7.199744184410203, 1.799287710441105],
            [7.195174741669851, 1.8429755556366514]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.89330046743972,
          "lat": 40.040400756163756
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18107"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00450374"
      },
      "bbox": [
        7.195174741669851, 1.4940244591149938, 7.5291002592583185,
        1.8712564761471422
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.553311481294944, 0.9487637408912175],
            [8.562045339681683, 0.9557871190336702],
            [8.571961394365685, 0.9645863232310781],
            [8.599303270795888, 0.9869740790977576],
            [8.634710292163803, 1.016868123889597],
            [8.65454495142706, 1.0339529941471755],
            [8.670312908121913, 1.0472319456572154],
            [8.70988746018974, 1.0810539728011088],
            [8.731203537405491, 1.0837139067100694],
            [8.738240354049148, 1.085557229366869],
            [8.774519721403736, 1.0904095320401692],
            [8.826038433270757, 1.09600006185168],
            [8.826006320930107, 1.0931137783358786],
            [8.823429117563807, 1.006483380099375],
            [8.821545363168086, 0.9290303738778157],
            [8.81942556707709, 0.8315727969810577],
            [8.818353147402279, 0.7974842691188193],
            [8.81821792755973, 0.7823283484027652],
            [8.81641469217946, 0.727031263647229],
            [8.815998866151913, 0.7082067383888088],
            [8.764820167930365, 0.7012776753662895],
            [8.766262225071568, 0.6864844459427841],
            [8.733735926672015, 0.6829853859094395],
            [8.653571667091319, 0.6735837628593774],
            [8.581240243737351, 0.6647971739774563],
            [8.571613952779243, 0.7527737451617644],
            [8.57205322211414, 0.7530502721575738],
            [8.565962636995927, 0.8114462092831881],
            [8.563241986178648, 0.8409142659117239],
            [8.56393194978064, 0.8410186431467085],
            [8.556341549727787, 0.9146822431130466],
            [8.553311481294944, 0.9487637408912175]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.26234653193353,
          "lat": 39.103495904013805
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18137"],
        "coty_name": ["Ripley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ripley County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00450385"
      },
      "bbox": [
        8.553311481294944, 0.6647971739774563, 8.826038433270757,
        1.09600006185168
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.766262225071568, 0.6864844459427841],
            [8.764820167930365, 0.7012776753662895],
            [8.815998866151913, 0.7082067383888088],
            [8.815606885786648, 0.6813494882435897],
            [8.846439887333588, 0.684708267696307],
            [8.889239235675262, 0.6896394969692696],
            [8.889528641785825, 0.6885875384839563],
            [8.915678952456547, 0.6912235573947871],
            [8.976038439281586, 0.69769201197198],
            [9.021847846265112, 0.7037747286606186],
            [9.024736394026595, 0.701523637891168],
            [9.030284094228964, 0.7006730567108006],
            [9.053516005476311, 0.7030073462545985],
            [9.064135320622327, 0.7020384133407895],
            [9.067336831459034, 0.7024809505704102],
            [9.077386898802278, 0.6995403483667345],
            [9.08903432585285, 0.6919224698223899],
            [9.091253295135147, 0.685170372969672],
            [9.091011388509243, 0.679220505764099],
            [9.088087407732742, 0.6698010774741631],
            [9.085554156987891, 0.6660693464185605],
            [9.079878413921046, 0.6588157367726992],
            [9.070080258529467, 0.6502321455073733],
            [9.065835720661534, 0.6454362164152119],
            [9.061797193169758, 0.6362526431349624],
            [9.062471202626943, 0.6310181665433379],
            [9.065409348800202, 0.6244812997213725],
            [9.075104327565365, 0.6120907876251389],
            [9.080318768939389, 0.5999438066866455],
            [9.080663299423241, 0.5963275006106877],
            [9.079003502916493, 0.5913720965828803],
            [9.074001595146587, 0.5893809354084143],
            [9.068248559806719, 0.5888640846741777],
            [9.061192404477497, 0.5896935215742731],
            [9.04911869935531, 0.5928205846984093],
            [9.041923322634462, 0.5937055340924517],
            [9.03007864775977, 0.5937526757139592],
            [9.022095374364245, 0.5951253417735888],
            [9.017127304358599, 0.5934522198183625],
            [9.010273954399448, 0.5888999628221178],
            [9.001924529931205, 0.5818919654392938],
            [8.993769254669186, 0.5772702876005463],
            [8.989089985631717, 0.5737138167750704],
            [8.98115737916435, 0.5706598221320128],
            [8.97784329666045, 0.5703356690316533],
            [8.96656066229378, 0.5717510725292215],
            [8.952791814869824, 0.5715764208756388],
            [8.943763554369077, 0.5694612738724327],
            [8.938057115501094, 0.5649126933238466],
            [8.930487225804765, 0.5562236432150409],
            [8.921519228633302, 0.5501723387478487],
            [8.90889130699289, 0.5416549259675737],
            [8.900912710878533, 0.5335930511464884],
            [8.886690606277538, 0.5252683127903108],
            [8.881391742889459, 0.5199151287613727],
            [8.868516550012433, 0.5088877639671301],
            [8.865805457039144, 0.5075977287066622],
            [8.86225158489638, 0.5013322502757682],
            [8.849551158483298, 0.487751526960974],
            [8.845052501282671, 0.4811895278283566],
            [8.841746957846595, 0.47808620945396285],
            [8.827721378709976, 0.4683622708959287],
            [8.81523575956099, 0.46263475856270353],
            [8.803310960104236, 0.46082531698792334],
            [8.79307381987081, 0.4631823078538861],
            [8.791282569538376, 0.475905334041177],
            [8.782823775356837, 0.5426725090157907],
            [8.77934954665698, 0.5692546937189411],
            [8.777026834422848, 0.5892589746529997],
            [8.775901920452034, 0.604223227630728],
            [8.766262225071568, 0.6864844459427841]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.03698644695685,
          "lat": 38.826203170836735
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18155"],
        "coty_name": ["Switzerland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Switzerland County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00450392"
      },
      "bbox": [
        8.764820167930365, 0.46082531698792334, 9.091253295135147,
        0.7082067383888088
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.655031244465157, 4.485091970446816],
            [3.6926854596203778, 4.4868723412293186],
            [3.7896724811909146, 4.491122163524285],
            [3.886982197821093, 4.495546258909882],
            [3.926594081367906, 4.496895766899505],
            [3.965710139788604, 4.49871157197582],
            [3.966050111022711, 4.491438274040217],
            [3.964742116829608, 4.48579567913238],
            [3.966010725175734, 4.480457046919315],
            [3.969664977463491, 4.45722402489408],
            [3.975303048335875, 4.438149529628854],
            [3.9845717670869325, 4.410560842018882],
            [3.9852331105419694, 4.407276348180408],
            [3.9859245676992687, 4.397328363718743],
            [3.9939629024301357, 4.382797185730792],
            [3.995047827531874, 4.375989956258827],
            [3.9929784750586212, 4.36588817463625],
            [3.992797697694515, 4.3595432492488575],
            [3.997474664770575, 4.346073500998572],
            [3.9980978221367276, 4.340134666860379],
            [3.9969802953886022, 4.329236745494542],
            [3.9992842754824958, 4.324152515796027],
            [4.00323995796062, 4.323452588288813],
            [4.018625241264393, 4.316271268682216],
            [4.022688817728718, 4.311771829970787],
            [4.031540748571291, 4.304121271019501],
            [4.033611247534472, 4.296916560643059],
            [4.033777593930225, 4.28549894263034],
            [4.034860654083336, 4.280984915636286],
            [4.039932152486227, 4.271191420938312],
            [4.038002938743635, 4.256132352926128],
            [4.038985853205679, 4.252011565689082],
            [4.041924815145665, 4.250580039614426],
            [4.047249690023371, 4.251598104495952],
            [4.050358288896139, 4.249449458696912],
            [4.050269315632482, 4.242042919096755],
            [4.051873209735334, 4.2282807666640005],
            [4.054354793455711, 4.2172988700258935],
            [4.058168382870189, 4.2049771686825785],
            [4.060023854097604, 4.191635497748292],
            [4.067199091014576, 4.1841902319813356],
            [4.066547994519951, 4.1802653751745655],
            [4.063635406685303, 4.179217188697834],
            [4.064549266650775, 4.173068671538234],
            [4.067857972301452, 4.172805226860027],
            [4.072069773481558, 4.167201596425091],
            [4.072293830615978, 4.163036604530079],
            [4.075049177232609, 4.159635067939449],
            [4.080167819739377, 4.161512917837747],
            [4.086592433859291, 4.160576631628157],
            [4.089225051559827, 4.157844383587853],
            [4.091322747266798, 4.1502070998351055],
            [4.093575723389574, 4.14776656907668],
            [4.100783259510339, 4.143459054684304],
            [4.106341400549574, 4.144309853735975],
            [4.116920604460896, 4.13841521372904],
            [4.122114773143222, 4.133684306575025],
            [4.128614085891687, 4.12418700588759],
            [4.133435428848902, 4.1207403459955705],
            [4.140246150193998, 4.119074331144444],
            [4.149806807377635, 4.113093831065875],
            [4.1612013671010795, 4.110303198746591],
            [4.172686905050235, 4.112931939096705],
            [4.178477009681959, 4.110771888679668],
            [4.190931982465306, 4.103713343560488],
            [4.192149981871725, 4.074081539126097],
            [4.141852175808444, 4.071884088712001],
            [4.106320177246389, 4.070161059431465],
            [4.020328564567127, 4.065214857003915],
            [3.9341633791876136, 4.060593714396835],
            [3.8492187019033666, 4.055783229979618],
            [3.817244466358924, 4.05365994313893],
            [3.761047340906968, 4.050611270277584],
            [3.7214316065894644, 4.049132016302727],
            [3.719695050365098, 4.048879921733255],
            [3.674100019117443, 4.046497038396159],
            [3.670838936503369, 4.126801328286468],
            [3.6686093773252253, 4.1632307264683],
            [3.665765300785712, 4.214135752635208],
            [3.6650875426203147, 4.239721161636152],
            [3.661234175493755, 4.33097092543245],
            [3.6596268311683007, 4.373845271727364],
            [3.6566622999307192, 4.447206025434831],
            [3.655031244465157, 4.485091970446816]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.3414128045317, "lat": 42.84468653327953 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19043"],
        "coty_name": ["Clayton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clayton County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00465210"
      },
      "bbox": [
        3.655031244465157, 4.046497038396159, 4.192149981871725,
        4.49871157197582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9824065182248587, 2.26162550212806],
            [3.0680402114735923, 2.264934988774814],
            [3.125533211206758, 2.2669719995641473],
            [3.2356642578163837, 2.2714309308375236],
            [3.3024998675368886, 2.274314906048819],
            [3.3269365743665493, 2.275479422338919],
            [3.3279360824498214, 2.2523836017755077],
            [3.3303534904516003, 2.2050342313808975],
            [3.3334846965234535, 2.123077759433292],
            [3.3363968828572257, 2.057091482749027],
            [3.3368425383433653, 2.0348037851459124],
            [3.3385317691035428, 1.9741582792903798],
            [3.24912835202994, 1.9685426620999893],
            [3.2100215530822935, 1.9658241867583985],
            [3.1883239514628836, 1.9642235462098598],
            [3.1326642307654633, 1.960893559056719],
            [3.109475889158148, 1.9596650244698812],
            [3.03759073061359, 1.9542453846383423],
            [2.994287641315723, 1.951391317488169],
            [2.9925778059044545, 1.9921727716194648],
            [2.9913020612331667, 2.035980893847969],
            [2.987189804086632, 2.130759017233651],
            [2.983524471726645, 2.23331201800851],
            [2.9824065182248587, 2.26162550212806]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.40973856466108, "lat": 40.74769075038394 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19051"],
        "coty_name": ["Davis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Davis County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00465214"
      },
      "bbox": [
        2.9824065182248587, 1.951391317488169, 3.3385317691035428,
        2.275479422338919
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6210422408709753, 4.576644934028374],
            [2.667816982925953, 4.577904608509398],
            [2.707341390151198, 4.579341120665217],
            [2.7758662785334973, 4.581419777135416],
            [2.8180806668354643, 4.5830849707826795],
            [2.861093678026678, 4.5842472589775625],
            [2.961407187811837, 4.588111759258915],
            [2.9629320529573544, 4.5445458345940795],
            [2.9648714671913665, 4.499284894629849],
            [2.968518808106528, 4.398233577946127],
            [2.9726717796485995, 4.281862599704447],
            [2.900486011599478, 4.279272220401369],
            [2.7798599914885624, 4.275210150706097],
            [2.716027021397277, 4.2733180882428785],
            [2.6298853507256426, 4.270750549000279],
            [2.627973474269032, 4.343602034383326],
            [2.6283475671603185, 4.358012653249137],
            [2.6275196785796338, 4.396306973446334],
            [2.624822186421417, 4.459297063287538],
            [2.6240047962921227, 4.497333005288704],
            [2.622443409735571, 4.53304413677675],
            [2.6210422408709753, 4.576644934028374]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.78901181382861, "lat": 43.05989053098856 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19067"],
        "coty_name": ["Floyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Floyd County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00465222"
      },
      "bbox": [
        2.6210422408709753, 4.270750549000279, 2.9726717796485995,
        4.588111759258915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5917839445490634, 4.594470568891055],
            [1.590914665842681, 4.666916944171736],
            [1.590361684008918, 4.699669947662846],
            [1.5899725858973532, 4.739388005761201],
            [1.588054032656571, 4.8396138349969755],
            [1.5879509105631382, 4.840170280215661],
            [1.6730482544106158, 4.841454734324407],
            [1.7286408161053846, 4.842348036055659],
            [1.839299137579028, 4.844429973138118],
            [1.9287497187635023, 4.846082155438422],
            [1.9304131814425267, 4.7758443728826965],
            [1.9321812262512974, 4.688271343333139],
            [1.9334315814978902, 4.644584834972917],
            [1.9342469935903777, 4.601256635239705],
            [1.9347005566529876, 4.587294453770214],
            [1.9358406953761735, 4.52948056671686],
            [1.9373914086473136, 4.457166865655415],
            [1.9394077676428272, 4.3395029000594825],
            [1.9395390622722812, 4.324467261044041],
            [1.9411102313235524, 4.252879745268438],
            [1.8117376952478066, 4.250774709644683],
            [1.768950075376415, 4.249834363886188],
            [1.6835745302842513, 4.248122630007993],
            [1.5976309322840991, 4.246729373608138],
            [1.5968434050401157, 4.2902769923778274],
            [1.59584797479882, 4.370069630319453],
            [1.5937550785033312, 4.49435448291988],
            [1.5917839445490634, 4.594470568891055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.20670864586369, "lat": 43.20412330067266 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19109"],
        "coty_name": ["Kossuth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kossuth County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00465243"
      },
      "bbox": [
        1.5879509105631382, 4.246729373608138, 1.9411102313235524,
        4.846082155438422
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.908175093040214, 2.8290298299485994],
            [3.9069479142074233, 2.8614200724903163],
            [3.904520976230822, 2.916676327458659],
            [3.9026718106519556, 2.9678547595834086],
            [3.9011116312434804, 3.005220594258344],
            [3.9297855705860165, 3.0063777015102047],
            [3.9730663684025624, 3.008468053238276],
            [4.058829118844679, 3.0123050019914808],
            [4.102849637993662, 3.014428213924788],
            [4.175221297636735, 3.018111372237631],
            [4.24700214644833, 3.0216740285746058],
            [4.254897437515729, 3.0218530861433153],
            [4.333028543380286, 3.025734246105308],
            [4.3359792416517875, 2.959871693620332],
            [4.33913488139697, 2.8812886779127656],
            [4.323453405146052, 2.8820211341592064],
            [4.310493492383967, 2.8813154586277236],
            [4.301016013957409, 2.881965465194564],
            [4.294252404649861, 2.881112636065919],
            [4.286217413386522, 2.878268359743782],
            [4.279240203829614, 2.8733188812529415],
            [4.2703480898417, 2.865631922293762],
            [4.255514445602691, 2.8548438896849233],
            [4.241789224619726, 2.8484992306551686],
            [4.234090989229776, 2.843869556936238],
            [4.219251272490795, 2.84586092341687],
            [4.206403039339484, 2.851114839134765],
            [4.199874570924197, 2.854735019996258],
            [4.192652871259061, 2.854236777861752],
            [4.177501023723172, 2.8456432928197377],
            [4.161333583661745, 2.8422436308240684],
            [4.154579862598302, 2.838276063800722],
            [4.14970142885857, 2.833868607612471],
            [4.147117054739241, 2.8286969121483114],
            [4.145821870003407, 2.817691386649964],
            [4.145665851951388, 2.8027984014896097],
            [4.136492910936519, 2.7860088994269803],
            [4.135607416871059, 2.7820767423549304],
            [4.133202742107109, 2.756149165888962],
            [4.133230201772971, 2.750042508268218],
            [4.083623019271537, 2.7483278927521404],
            [4.015604085050589, 2.745634502058834],
            [3.9978267938502423, 2.7451228278423105],
            [3.9438433638782118, 2.7426209112903375],
            [3.911848687476682, 2.7414041628299084],
            [3.908175093040214, 2.8290298299485994]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.11273048817512,
          "lat": 41.483915690262045
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19139"],
        "coty_name": ["Muscatine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Muscatine County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00465258"
      },
      "bbox": [
        3.9011116312434804, 2.7414041628299084, 4.33913488139697,
        3.025734246105308
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9287497187635023, 4.846082155438422],
            [2.0458740894818894, 4.848489417975948],
            [2.1613443257045892, 4.85120654988451],
            [2.2704641620939188, 4.85391182841372],
            [2.272540551461695, 4.762531119352927],
            [2.274510822403474, 4.697169354539956],
            [2.27671842975938, 4.609507064081666],
            [2.186177866094359, 4.607347142914025],
            [2.0972365304284843, 4.604909831349033],
            [2.0199040282943406, 4.603104231076753],
            [1.9342469935903777, 4.601256635239705],
            [1.9334315814978902, 4.644584834972917],
            [1.9321812262512974, 4.688271343333139],
            [1.9304131814425267, 4.7758443728826965],
            [1.9287497187635023, 4.846082155438422]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.73416105494492, "lat": 43.37758406539542 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19189"],
        "coty_name": ["Winnebago"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winnebago County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "00465283"
      },
      "bbox": [
        1.9287497187635023, 4.601256635239705, 2.27671842975938,
        4.85391182841372
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5861608072582731, 0.6179457611395877],
            [-0.584369448793322, 0.7052511102540497],
            [-0.5827371916660721, 0.7935964266682396],
            [-0.5813975047030122, 0.881360913964847],
            [-0.4955413895697008, 0.8798090771665457],
            [-0.4514600543876656, 0.8793378109101078],
            [-0.4379000314940918, 0.8789298988608947],
            [-0.38962528041703615, 0.878426054378306],
            [-0.2684227898717633, 0.8769378452743992],
            [-0.26989164187000464, 0.7908399270295289],
            [-0.2716553748466866, 0.7252326801075436],
            [-0.27274613366042244, 0.6148590150396493],
            [-0.27423170962049137, 0.527362058221167],
            [-0.27395598879012434, 0.5041610540569208],
            [-0.2748876396291482, 0.4387751556509026],
            [-0.27626848225688727, 0.4387638955802869],
            [-0.34750146359718387, 0.4402292901738864],
            [-0.4572073772871194, 0.44204646014478594],
            [-0.4589101683781965, 0.441855929425027],
            [-0.573333652787612, 0.4423232002387768],
            [-0.5897034921189517, 0.4422707875123027],
            [-0.5892534221872173, 0.4718678266692895],
            [-0.5880853076699365, 0.5301166807940205],
            [-0.5861608072582731, 0.6179457611395877]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.16518858746684, "lat": 39.349722484671 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20027"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00484983"
      },
      "bbox": [
        -0.5897034921189517, 0.4387638955802869, -0.2684227898717633,
        0.881360913964847
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1318884507187117, 1.402638427109348],
            [-3.089894075313207, 1.4005613937529178],
            [-3.0611088894080685, 1.3987934608522976],
            [-2.959224442520205, 1.3938399082818187],
            [-2.9271628346812726, 1.3922074600919683],
            [-2.8674895148832817, 1.3895110851019263],
            [-2.8046392328209677, 1.3865359807251594],
            [-2.7185007951331497, 1.382542336225281],
            [-2.7065217642349486, 1.3820347783551685],
            [-2.706991746819906, 1.3776758053476104],
            [-2.711384439174992, 1.294043746034395],
            [-2.714220267865697, 1.2357829545093955],
            [-2.714731778170894, 1.2211504694212645],
            [-2.7178500674233876, 1.1628514877837637],
            [-2.7198086714998477, 1.1208670075069866],
            [-2.7207021499639152, 1.0968950908599437],
            [-2.723592054511462, 1.0315849952418212],
            [-2.7277512506260133, 0.9438967796861014],
            [-2.7811960372247446, 0.9464977315051429],
            [-2.8135294133309867, 0.9484437081116519],
            [-2.8988711907238183, 0.9524093470535783],
            [-2.926680377297791, 0.9533647391995055],
            [-2.9365846855680844, 0.9540861376050224],
            [-3.054759741988578, 0.9601121122761007],
            [-3.1395323562708572, 0.9643451456878989],
            [-3.1552900886040747, 0.9651390769289601],
            [-3.151097992590317, 1.052555003541038],
            [-3.146315397737433, 1.1402218200933165],
            [-3.139952624052726, 1.26568771676982],
            [-3.139379660233474, 1.2735642780384349],
            [-3.134862677756303, 1.3525020962552001],
            [-3.1318884507187117, 1.402638427109348]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.45993576504574,
          "lat": 39.784733535458614
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20039"],
        "coty_name": ["Decatur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Decatur County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00484989"
      },
      "bbox": [
        -3.1552900886040747, 0.9438967796861014, -2.7065217642349486,
        1.402638427109348
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.47671851715583, -0.4653572620081748],
            [8.481566674160085, -0.4643694502929654],
            [8.4896535724261, -0.4655903969324621],
            [8.49021048514331, -0.46797986465461117],
            [8.50087403568924, -0.4603561347008595],
            [8.503852349577645, -0.45994896226182685],
            [8.507055337227623, -0.4626335514379052],
            [8.511183039687076, -0.45810908784821847],
            [8.519056312446141, -0.4527079574049613],
            [8.521572539754125, -0.4549792241053974],
            [8.524463074287226, -0.4483286256920263],
            [8.533902674921894, -0.44593936638474285],
            [8.541026189310271, -0.44083585507709305],
            [8.53997399493893, -0.437205562634006],
            [8.54779046314862, -0.4350242225341917],
            [8.554598657818602, -0.4242995453769127],
            [8.556994808955427, -0.42256820739800494],
            [8.5588983872198, -0.417534405292581],
            [8.56375653725645, -0.41661588767282376],
            [8.570694688414493, -0.40724946330814354],
            [8.569445389162386, -0.401298490872312],
            [8.567106238777733, -0.3963366732029249],
            [8.571312253568355, -0.39667558144055554],
            [8.578192218099243, -0.3929414526845584],
            [8.582554724010755, -0.3884878470135791],
            [8.585891302453186, -0.3884592433018503],
            [8.591719826763745, -0.37997112716158027],
            [8.586659551415556, -0.37029786926149083],
            [8.585811096027651, -0.3600859227561453],
            [8.584410307444017, -0.3561418915306073],
            [8.591518462154818, -0.3460202723561176],
            [8.593531219302381, -0.3467403463848226],
            [8.598623500201732, -0.34197738528049604],
            [8.598316469135323, -0.3371672925040604],
            [8.602064113925875, -0.338683349844171],
            [8.60587288904655, -0.33726862270691155],
            [8.610568322435359, -0.332418423042956],
            [8.614396538397608, -0.3195888484861953],
            [8.623310879432564, -0.31171928717558667],
            [8.626347879029737, -0.3057802018561665],
            [8.626849534613214, -0.3012127284559652],
            [8.62320620628057, -0.2961224747960306],
            [8.61804755285802, -0.29401693055279265],
            [8.650094951852452, -0.264633333254164],
            [8.672232758805798, -0.2817582484743081],
            [8.690386342473044, -0.28639967898986934],
            [8.691240002660216, -0.2876578628501146],
            [8.70273347698469, -0.29029073428206065],
            [8.70767849915396, -0.2932518153164143],
            [8.713947709209798, -0.29963918105520415],
            [8.717788271167725, -0.3015120194013385],
            [8.725326305092839, -0.3077840411273806],
            [8.74112224850034, -0.30558240419046623],
            [8.797163509760217, -0.2862278183450145],
            [8.901488729433048, -0.2554384988240476],
            [8.921678024794817, -0.3284912430534138],
            [8.923541242563173, -0.33351223894631904],
            [8.92364166210718, -0.3384364819962083],
            [8.921963970755844, -0.34079274553348626],
            [8.91829269457164, -0.3403474314871416],
            [8.916718016638779, -0.33708725416795876],
            [8.912233273218723, -0.3365630674052681],
            [8.907756477359895, -0.3400738288813916],
            [8.904440124953634, -0.3372617292654399],
            [8.900072808368964, -0.3362832949059932],
            [8.896298158303651, -0.33799128992220184],
            [8.897894253359222, -0.34119954651046147],
            [8.896332220635934, -0.34564175492063953],
            [8.891692851716693, -0.34330957387180366],
            [8.890522452471794, -0.3404998087807745],
            [8.893171550478975, -0.3363391123875525],
            [8.892035636971427, -0.3330050476835033],
            [8.886470587703547, -0.3278542716561169],
            [8.885148113700394, -0.3320676335177257],
            [8.887455456309644, -0.34476498746733314],
            [8.889898737239223, -0.3492711431974483],
            [8.890511958071484, -0.35362944960293197],
            [8.884789551585815, -0.36775634865397877],
            [8.891797890694543, -0.37198558456951486],
            [8.88924033943324, -0.376419152540041],
            [8.888167270311314, -0.38368555574684876],
            [8.884175935117138, -0.3805774791105828],
            [8.878082838809451, -0.3793877603205483],
            [8.875752667906696, -0.37630747634222683],
            [8.878779389115664, -0.3733953031378568],
            [8.878610184020802, -0.37035742729202764],
            [8.875426325449741, -0.3605436261594769],
            [8.870466070754148, -0.36956252544095436],
            [8.869018089114276, -0.37768930107463805],
            [8.86500918031094, -0.3773477326592639],
            [8.861912214406585, -0.3647684166998896],
            [8.857922082968527, -0.36556065175103736],
            [8.859087845678436, -0.3704639288867463],
            [8.854605056004011, -0.3713272105856401],
            [8.848278240906282, -0.3675864635714417],
            [8.845573271554743, -0.369588792808407],
            [8.846395935680524, -0.37616938906961433],
            [8.853907709331088, -0.3806802327766611],
            [8.857249345843796, -0.38600702326507164],
            [8.854929751062144, -0.3875206887214877],
            [8.845336567764972, -0.386849909961755],
            [8.841200788272827, -0.3918629907797896],
            [8.83825587130793, -0.39202320825895265],
            [8.83566204242519, -0.3888589212983509],
            [8.832727126527162, -0.38868243136277275],
            [8.829080645674287, -0.3840793117099801],
            [8.827973889598569, -0.3888835448756176],
            [8.831861564710936, -0.39850413379854505],
            [8.829720989031383, -0.4021470301360014],
            [8.822480332881943, -0.4073539162539423],
            [8.8163913006449, -0.4068191406474785],
            [8.814841844376739, -0.4139656881281104],
            [8.816195997663218, -0.41772712458589556],
            [8.811374865768308, -0.41935532607084103],
            [8.810452233636424, -0.42658836356922425],
            [8.806784734016299, -0.4309505663309298],
            [8.80722140719479, -0.4357801001040693],
            [8.812501249653488, -0.4388289526552287],
            [8.81394714146804, -0.44147848896756364],
            [8.81277143703449, -0.44647595837691495],
            [8.804754075347352, -0.4534835156673673],
            [8.800344672743497, -0.4547695402550483],
            [8.795488699522362, -0.45384155923379443],
            [8.791705777034856, -0.4558094263550752],
            [8.791249976520675, -0.46254317671357864],
            [8.784015319771953, -0.4625397939249816],
            [8.776970354691214, -0.4602930603312397],
            [8.77714876031883, -0.4630277990517008],
            [8.781206288224764, -0.475459347550448],
            [8.786790447102739, -0.4778581037120096],
            [8.782106999325116, -0.48692494030647077],
            [8.778681446847068, -0.4864068415936435],
            [8.769079550988623, -0.4816116011860585],
            [8.764184794859098, -0.4816785625227501],
            [8.76472579601015, -0.4879432395494718],
            [8.767975324139824, -0.49695628109249285],
            [8.767344531761779, -0.5028332626330565],
            [8.768262095890202, -0.5065488543782269],
            [8.760632859235985, -0.5078307604578014],
            [8.758031165091518, -0.5065831303629408],
            [8.754635195510291, -0.5112609650071992],
            [8.75423869844656, -0.5147896220219302],
            [8.747115503648542, -0.5179865631628984],
            [8.714203362809355, -0.5670910074372196],
            [8.695700360869342, -0.6276194373316746],
            [8.683414756871349, -0.6736105187603854],
            [8.673682746265435, -0.7052970674124908],
            [8.670607930113876, -0.7049272519999766],
            [8.6695059902575, -0.6988024509042251],
            [8.665538224804543, -0.6997320334868044],
            [8.661902463837485, -0.6978858762788345],
            [8.655349085742014, -0.6990945949036698],
            [8.650432430122066, -0.7081910654936169],
            [8.652976861214382, -0.7144818025017207],
            [8.650786496839741, -0.7212382740042546],
            [8.655178918178859, -0.7286649148251084],
            [8.646963384371727, -0.7324209535064591],
            [8.646758514626448, -0.7381637551580478],
            [8.643628120944758, -0.7404085184955278],
            [8.638088944361652, -0.736814404660028],
            [8.623500655189094, -0.7338418236145733],
            [8.619547913318629, -0.7339340847048261],
            [8.615369151749718, -0.7313652006651726],
            [8.609695000202645, -0.7231469335554336],
            [8.6081228980888, -0.7187139351529402],
            [8.603889350295884, -0.7262433921958996],
            [8.59967093270024, -0.7274009055350664],
            [8.594435947768607, -0.7220020639380508],
            [8.594361950310786, -0.7168165271766319],
            [8.597045006621874, -0.7148148765898094],
            [8.597588843688413, -0.7112904174046285],
            [8.60148560188734, -0.7073829147933113],
            [8.605614788280576, -0.7052364301563175],
            [8.607384705098823, -0.6975942638262832],
            [8.60574941542194, -0.693165125168316],
            [8.605668112652346, -0.6873270844266901],
            [8.603002422511459, -0.6764093221377051],
            [8.606994655944755, -0.6728107397048599],
            [8.609995991616067, -0.6739752747677136],
            [8.612005663688013, -0.6705413783683376],
            [8.611420064961493, -0.6668370386719404],
            [8.615100718479722, -0.6637292801790786],
            [8.60408226556065, -0.6604674623289515],
            [8.59750638596982, -0.6598494897526599],
            [8.59381059235638, -0.6542393685275286],
            [8.59456704244985, -0.6515102154874157],
            [8.601398541392681, -0.649238745298068],
            [8.611520673261305, -0.6517643098029473],
            [8.615216832789818, -0.6474926196152101],
            [8.613094550222929, -0.6457319357631812],
            [8.61604039953903, -0.6395790365909588],
            [8.620008874143794, -0.6377323423920165],
            [8.62070340394836, -0.6412459059116371],
            [8.62561606417121, -0.646652816131887],
            [8.62866582087946, -0.6463991597783277],
            [8.629460025564999, -0.6399574423280409],
            [8.624339429401997, -0.6343461341962994],
            [8.624193283438107, -0.6255201887679122],
            [8.620410054974753, -0.6245857069262911],
            [8.61501598605178, -0.6203672938626175],
            [8.611051688445468, -0.6208663568118515],
            [8.606516386000559, -0.6258519335212387],
            [8.6019637394699, -0.6262973007822961],
            [8.601701945878112, -0.6191106204616704],
            [8.603834426817771, -0.6179722410354063],
            [8.600099115236539, -0.6086133405020285],
            [8.603716243327264, -0.6066555973882989],
            [8.60230493964112, -0.6029708139487013],
            [8.604999082671812, -0.5991842826816247],
            [8.602538625868688, -0.5970532599040784],
            [8.602235256938332, -0.589342826737489],
            [8.604033176786071, -0.5810681909714072],
            [8.602840930595274, -0.5779830766093246],
            [8.60271533735212, -0.5713481343613769],
            [8.59607770211002, -0.5665544098359485],
            [8.590679672745269, -0.5656701802252974],
            [8.576730923837442, -0.5739218280815179],
            [8.575109184266946, -0.572178624212699],
            [8.57076873871701, -0.5748390418924744],
            [8.567053280152534, -0.5724381214673162],
            [8.56708490326014, -0.5685146857896276],
            [8.564735629242083, -0.5648233897655672],
            [8.558954750117685, -0.5623393356962265],
            [8.562162670774851, -0.5582432044180177],
            [8.559159553788534, -0.5535770470197178],
            [8.550274083296822, -0.5498798164324548],
            [8.547311967862079, -0.5463800014819379],
            [8.542775118116664, -0.5464883913692611],
            [8.542535706219306, -0.5432345898852567],
            [8.537732854925457, -0.5419354353851094],
            [8.533160049315907, -0.5428882442695121],
            [8.529975827598157, -0.5403252366942888],
            [8.526112537843494, -0.5360829132052068],
            [8.529978300493834, -0.5331648797629733],
            [8.526511433353884, -0.5310470126046248],
            [8.52626140000093, -0.5230934506166839],
            [8.524495238801956, -0.5215367653442753],
            [8.525680243314374, -0.5149788988382086],
            [8.51778635565942, -0.5182958466845404],
            [8.514891192322448, -0.5118339290695151],
            [8.511695809276684, -0.5116625976196097],
            [8.507360895561478, -0.5063565820013677],
            [8.502699542264269, -0.5092848344452752],
            [8.498021022549914, -0.5070415433761887],
            [8.50021631666593, -0.5017589576759803],
            [8.496129137334297, -0.4996636310543355],
            [8.488316325276918, -0.5023024112192709],
            [8.483742127731084, -0.49944366811964985],
            [8.481105905361002, -0.49544626698663996],
            [8.48803131726734, -0.4916439739020928],
            [8.487729030363981, -0.48854634101543065],
            [8.483867048802347, -0.48774034308078745],
            [8.480419012534508, -0.48911773569737516],
            [8.475116533599488, -0.48538276553222715],
            [8.477516050832788, -0.47937287032805775],
            [8.474260208158803, -0.4741525296085377],
            [8.47671851715583, -0.4653572620081748]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.46614512514627, "lat": 37.80498374957892 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21179"],
        "coty_name": ["Nelson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nelson County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00516936"
      },
      "bbox": [
        8.474260208158803, -0.7404085184955278, 8.92364166210718,
        -0.2554384988240476
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.686859267054123, 0.4970168881381038],
            [8.69064985314739, 0.4868921800563486],
            [8.752895747334433, 0.4233099864691148],
            [8.779161525898799, 0.39663257082436826],
            [8.778073515456494, 0.3902293660668477],
            [8.779311907100256, 0.3871894298229134],
            [8.78706028380164, 0.38232565685033776],
            [8.78875211767197, 0.37762708745807366],
            [8.793707779356247, 0.3720890481727759],
            [8.790560373608368, 0.3663218126949477],
            [8.794132131102117, 0.35571947456189673],
            [8.798129224006164, 0.3511190533707135],
            [8.830683750305932, 0.3601550873050608],
            [8.813153860468235, 0.33919863455649846],
            [8.776342909970962, 0.2936533007539748],
            [8.759561109290459, 0.2652768053396441],
            [8.755169059697465, 0.26092459794305756],
            [8.7477950292794, 0.2619767982294807],
            [8.740381299916937, 0.2600792482224498],
            [8.735125923569965, 0.2599323361998532],
            [8.731544526477482, 0.26140056768271247],
            [8.72910818476815, 0.2542417823456253],
            [8.727508959874333, 0.25744918815834394],
            [8.720658295037273, 0.2616533449209962],
            [8.708781994443887, 0.26232864646682563],
            [8.698596072251233, 0.26746985171043386],
            [8.694402720857925, 0.2677287723728522],
            [8.688070301442483, 0.26480383331713886],
            [8.683185314472968, 0.26750666575157567],
            [8.68126010889792, 0.27166585584925274],
            [8.676291132337349, 0.274949985318612],
            [8.667389209066108, 0.27072347080659875],
            [8.66349318522769, 0.2727468047960446],
            [8.658519100222026, 0.27278611721146206],
            [8.649867944840691, 0.2710366012284021],
            [8.642527820774639, 0.27327936267652286],
            [8.637447412245248, 0.27139093314673796],
            [8.63366381497282, 0.27613336080332895],
            [8.636866139986122, 0.27891989800547595],
            [8.641060649916634, 0.28534047749174163],
            [8.644226574349917, 0.2946305008890251],
            [8.644668087488641, 0.2997570666525055],
            [8.642720417797294, 0.31664441887793715],
            [8.639425313920691, 0.3241645518626684],
            [8.630336333411842, 0.33842030979709786],
            [8.623059260754394, 0.34983825581576533],
            [8.618954583371886, 0.3626929485966667],
            [8.616436824988911, 0.38711499992530085],
            [8.616297058207465, 0.4003997554615694],
            [8.614358440781313, 0.410771053742222],
            [8.608486332689893, 0.4210520644504535],
            [8.59894372372001, 0.432187198636665],
            [8.596832773224119, 0.44227619330633033],
            [8.59842564119492, 0.45864995963989563],
            [8.599679730326722, 0.462586332100511],
            [8.60487066332852, 0.47121045682202267],
            [8.608489759520745, 0.4803860455976866],
            [8.620569321057657, 0.48887648590508476],
            [8.627528751878206, 0.49130268503870994],
            [8.63722144001281, 0.49085154870641956],
            [8.657433965376187, 0.48786245840773734],
            [8.662843830608868, 0.4884883912316052],
            [8.675122425859763, 0.49173352707050705],
            [8.686859267054123, 0.4970168881381038]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.33753560913468, "lat": 38.61299238752662 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21223"],
        "coty_name": ["Trimble"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trimble County"],
        "coty_fp_code": "223",
        "coty_gnis_code": "00516958"
      },
      "bbox": [
        8.596832773224119, 0.2542417823456253, 8.830683750305932,
        0.4970168881381038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.57876614799901, 8.240401498094524],
            [18.599456599474667, 8.26569864041197],
            [18.608623121193087, 8.270332187197344],
            [18.646246987022874, 8.288121890612185],
            [18.69394699683547, 8.194810669785847],
            [18.679799606550542, 8.188092942638127],
            [18.68352548652763, 8.180446262709905],
            [18.675272777864294, 8.176795187469436],
            [18.67866234116591, 8.17445643023255],
            [18.70490263832658, 8.149778245942537],
            [18.707626536462225, 8.146440379596983],
            [18.712294514857987, 8.133601580044989],
            [18.73476433592979, 8.118239560721472],
            [18.737267530038658, 8.11020979171828],
            [18.75282815510353, 8.05277646864213],
            [18.75894114133371, 8.0295973360552],
            [18.767300083572888, 8.026298551147178],
            [18.774811152155475, 8.026695787227721],
            [18.77332626227613, 8.018735963096939],
            [18.822262929561166, 8.020782353389775],
            [18.82254878687797, 8.006663398284422],
            [18.8141173499021, 8.00619598892636],
            [18.81462093627532, 7.9949130578122665],
            [18.811417184932743, 7.994302036445403],
            [18.812685114553375, 7.966509187902706],
            [18.824162586321403, 7.967047951580693],
            [18.82437659294799, 7.964447827518742],
            [18.82942147329757, 7.964904893939118],
            [18.836402113260018, 7.883067113405001],
            [18.83975800272549, 7.876778237963899],
            [18.83850093112992, 7.870240827269882],
            [18.835329482284656, 7.868688336471754],
            [18.835432724761358, 7.8633544992582705],
            [18.838555190355137, 7.860854342664018],
            [18.83589712122943, 7.8578926187424285],
            [18.837186712533544, 7.8541722362002835],
            [18.841632643337643, 7.848670188086061],
            [18.84375352219723, 7.843690435573929],
            [18.841130182902628, 7.839218203063959],
            [18.83633026801648, 7.840623433420818],
            [18.837296721632615, 7.8363102176358],
            [18.83352543191491, 7.831395962823382],
            [18.838684888613393, 7.824109324674493],
            [18.846954308555397, 7.819948209811086],
            [18.8499116489551, 7.816918312533744],
            [18.83103882400615, 7.7608704327164295],
            [18.821614282089367, 7.763934355030431],
            [18.812170929598796, 7.735250088299982],
            [18.74551853068885, 7.757354451689243],
            [18.74038745453132, 7.757981486576656],
            [18.741617276461866, 7.76251717357286],
            [18.694242336421787, 7.79117927745858],
            [18.63908754638332, 7.822872264213759],
            [18.619340587572918, 7.764466148337318],
            [18.593162769014242, 7.774473707968702],
            [18.5940450356041, 7.763368948376152],
            [18.592049694809216, 7.7607752953208875],
            [18.556231842691915, 7.774400084135143],
            [18.554674475846397, 7.770492703044844],
            [18.528726518554798, 7.780805367723674],
            [18.526886385754057, 7.786272868757447],
            [18.527135229230904, 7.789756307050635],
            [18.52284161982837, 7.7971431404924525],
            [18.52172474788289, 7.807551896020225],
            [18.51574944826746, 7.812441163574444],
            [18.52142038057389, 7.8273917927601735],
            [18.52649221120963, 7.842055693067334],
            [18.53615604162154, 7.866963190992482],
            [18.543563377145706, 7.887487109673711],
            [18.555448887288378, 7.919336628393472],
            [18.56284720413082, 7.940163999617725],
            [18.579870743223363, 7.984981331883693],
            [18.58661290692863, 7.984403233317863],
            [18.586014744868155, 8.036252614365075],
            [18.58614273280665, 8.101762794336738],
            [18.586469096354204, 8.14360142223262],
            [18.563206849781807, 8.19104633774141],
            [18.570018210288627, 8.194187138805466],
            [18.559319070375516, 8.21619985408905],
            [18.57876614799901, 8.240401498094524]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -70.20642967097828, "lat": 44.16581484254531 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23001"],
        "coty_name": ["Androscoggin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Androscoggin County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00581286"
      },
      "bbox": [
        18.51574944826746, 7.735250088299982, 18.8499116489551,
        8.288121890612185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [19.111536395944967, 7.615824779904715],
              [19.115788989112954, 7.6166114957417035],
              [19.11675360759808, 7.6138603873923545],
              [19.11306169487792, 7.611224004550473],
              [19.111536395944967, 7.615824779904715]
            ]
          ],
          [
            [
              [18.82942147329757, 7.964904893939118],
              [18.90817397023166, 7.9694313218924915],
              [18.90687576421847, 7.972376937262144],
              [18.907865192954073, 7.980497154112294],
              [18.90615229518315, 7.984842376613091],
              [18.90674291091817, 7.998966430041431],
              [18.909302877045715, 8.016933669097304],
              [18.91364291671209, 8.022530726745652],
              [18.915089783778722, 8.027541827075746],
              [18.921244461591595, 8.035227898280182],
              [18.988141844580852, 8.038838420487185],
              [18.99377720843136, 8.031653696652445],
              [18.995625531283697, 8.026602304422054],
              [18.996257936048835, 8.01642014617196],
              [18.997271177560506, 8.012761619155627],
              [18.995896393428428, 8.006918161383965],
              [18.996765872040513, 8.000831484873846],
              [18.995567634850694, 7.98529535607458],
              [18.990853361210437, 7.971403587466554],
              [18.992908544060555, 7.967781254786213],
              [18.993275814699455, 7.9592351667163985],
              [18.997472641279092, 7.955998099424664],
              [18.996626641242266, 7.949597638818388],
              [18.999154316978835, 7.941887790108708],
              [19.000002628003372, 7.9277827161235],
              [18.997250626370533, 7.921773132936834],
              [18.991064345256824, 7.915130184382349],
              [18.988076293993753, 7.910460914448532],
              [18.98847533182685, 7.9075552319076055],
              [19.03561866713493, 7.9095753608778105],
              [19.035840358149926, 7.908735585546226],
              [19.071967178937516, 7.910916920460438],
              [19.071997878913898, 7.906304156258433],
              [19.069764515012082, 7.899163391109479],
              [19.070315650123707, 7.897334188393538],
              [19.06821197330307, 7.873382050325708],
              [19.069067533056565, 7.867039001014956],
              [19.071093895845255, 7.865073335755334],
              [19.07004265540189, 7.860769695258714],
              [19.07457178575315, 7.842531421544589],
              [19.074513979367875, 7.837494714363113],
              [19.07801715857232, 7.835014540512216],
              [19.088704500978434, 7.833627449417401],
              [19.087057748883193, 7.825492836979308],
              [19.084614226886455, 7.819282340755642],
              [19.07994169634536, 7.814374434200308],
              [19.077612995781404, 7.809871257525794],
              [19.076121056431994, 7.801851684666329],
              [19.07300932860577, 7.794363297296648],
              [19.079605502168327, 7.789169787279197],
              [19.08395582570831, 7.783154056531436],
              [19.08735840217394, 7.780914500222921],
              [19.08882316352375, 7.773141577855989],
              [19.095182233993793, 7.765727662922758],
              [19.09834674495907, 7.759640771428006],
              [19.1049105313543, 7.758939574013485],
              [19.11177266149873, 7.7650611253168185],
              [19.11441430993097, 7.756947213330975],
              [19.114556751625628, 7.745682059972184],
              [19.11833932982138, 7.7380570967067275],
              [19.119093673446645, 7.73170724042661],
              [19.115629413208975, 7.720236232307124],
              [19.116129481501165, 7.710844042264796],
              [19.119003933002357, 7.702711935117336],
              [19.118753519662615, 7.691881267798646],
              [19.113381289538175, 7.680949926145443],
              [19.108777697670536, 7.675928286345578],
              [19.107452937041977, 7.667864468126259],
              [19.106689874536354, 7.649045176777924],
              [19.097946644105175, 7.648558599683311],
              [19.097005346453024, 7.63941288526821],
              [19.09161024664011, 7.6375957212593235],
              [19.090283772308005, 7.643032686868378],
              [19.08720508236835, 7.641992018289306],
              [19.08306676478697, 7.637811865691672],
              [19.081631619265814, 7.633501526414099],
              [19.08470100456283, 7.631215733105912],
              [19.076833319807463, 7.62540480415178],
              [19.075773592052748, 7.622265266787887],
              [19.07038986010332, 7.621822859114968],
              [19.062321671466968, 7.614587359857503],
              [19.058861505532136, 7.608644218560674],
              [19.064991415897726, 7.598987753691819],
              [19.063364412404376, 7.592843893390324],
              [19.061480890135176, 7.5907173131827275],
              [19.058014632211993, 7.595256157519711],
              [19.052874749889444, 7.595147729219239],
              [19.05038732356257, 7.591590612747218],
              [19.047448032802844, 7.591973266242452],
              [19.047172907939323, 7.605372542457652],
              [19.043646479189633, 7.605274370374435],
              [19.040248011732693, 7.609785687659547],
              [19.039477767728723, 7.618614674646791],
              [19.04167150333234, 7.629056568659784],
              [19.03690159315864, 7.630208240224577],
              [19.031727782350767, 7.6271633320989904],
              [19.03240080155892, 7.619181544649356],
              [19.02900629945284, 7.614635515915603],
              [19.027683692298748, 7.625700548663714],
              [19.024661259114442, 7.6356900436520965],
              [19.028103397653766, 7.643016367030769],
              [19.02447059381038, 7.647419057353523],
              [19.01817974878927, 7.647580531305992],
              [19.01705098859619, 7.655012897136709],
              [19.014683848965593, 7.658964885536225],
              [19.01021860661459, 7.65587338671078],
              [19.005364921045462, 7.6549839302948826],
              [19.00243112000355, 7.665418273125457],
              [19.004693836948817, 7.676613672569937],
              [19.00653821234202, 7.6962676729322075],
              [18.99678629496877, 7.714724978557868],
              [18.993761857209392, 7.72860456524635],
              [18.986707543686116, 7.729804761330955],
              [18.97638980508741, 7.737080117008174],
              [18.974784795056117, 7.740202823174661],
              [18.973689685658552, 7.751023717869627],
              [18.974421489025822, 7.758012804544756],
              [18.978175557203866, 7.764491131105948],
              [18.97889875725058, 7.773843265332499],
              [18.981443362752803, 7.7833373180136896],
              [18.982181395420284, 7.795628039505174],
              [18.980476678986324, 7.8077531628760966],
              [18.980649713327807, 7.821402834541767],
              [18.966071511873537, 7.826470404868716],
              [18.964110921677644, 7.818906249403396],
              [18.96042282912287, 7.814521362905385],
              [18.959426583545245, 7.808319768123361],
              [18.954673736559776, 7.800577626696523],
              [18.95391401021362, 7.795933024482267],
              [18.949406389103416, 7.789227953911765],
              [18.942937908066728, 7.785456322063192],
              [18.94029137696698, 7.777798797763946],
              [18.936360756756365, 7.775665618124463],
              [18.919514547947955, 7.781882906175535],
              [18.91477500707258, 7.780521681732187],
              [18.907855174339662, 7.7732200925490496],
              [18.906348662763016, 7.770233578809203],
              [18.901843179377508, 7.77152131122259],
              [18.892656205567715, 7.780755843647137],
              [18.888970250739337, 7.782916545263356],
              [18.883346517094974, 7.782767132059098],
              [18.877122221946294, 7.789727088129011],
              [18.867598498085492, 7.79126100806418],
              [18.860327450674607, 7.801652864091089],
              [18.85808103158629, 7.806210428299675],
              [18.853795935468895, 7.810701693780063],
              [18.8499116489551, 7.816918312533744],
              [18.846954308555397, 7.819948209811086],
              [18.838684888613393, 7.824109324674493],
              [18.83352543191491, 7.831395962823382],
              [18.837296721632615, 7.8363102176358],
              [18.83633026801648, 7.840623433420818],
              [18.841130182902628, 7.839218203063959],
              [18.84375352219723, 7.843690435573929],
              [18.841632643337643, 7.848670188086061],
              [18.837186712533544, 7.8541722362002835],
              [18.83589712122943, 7.8578926187424285],
              [18.838555190355137, 7.860854342664018],
              [18.835432724761358, 7.8633544992582705],
              [18.835329482284656, 7.868688336471754],
              [18.83850093112992, 7.870240827269882],
              [18.83975800272549, 7.876778237963899],
              [18.836402113260018, 7.883067113405001],
              [18.82942147329757, 7.964904893939118]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.85457226462161, "lat": 43.95992190050968 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23023"],
        "coty_name": ["Sagadahoc"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sagadahoc County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00581297"
      },
      "bbox": [
        18.82942147329757, 7.5907173131827275, 19.119093673446645,
        8.038838420487185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.29572406044678, 4.187752706074181],
            [8.359199495489312, 4.19564627779428],
            [8.421268541197412, 4.203157615557958],
            [8.461151080981143, 4.208202509075379],
            [8.508923248349646, 4.214247081748835],
            [8.582468708873744, 4.222937196636854],
            [8.66114691705457, 4.231738081330097],
            [8.71835525587027, 4.2384029141611155],
            [8.728644421047894, 4.151684081526358],
            [8.740296486310971, 4.064467370150098],
            [8.754760207455352, 3.9774078863320512],
            [8.756054979160927, 3.9687659401567705],
            [8.766762378192793, 3.889015315467996],
            [8.680918414013743, 3.8809732090650657],
            [8.620121990679632, 3.873817847339287],
            [8.51675796371428, 3.8622294699079456],
            [8.459518330758867, 3.855307969359158],
            [8.424409141410798, 3.851296673789746],
            [8.367031379646527, 3.8442128099267268],
            [8.338969642483391, 3.8406028705001747],
            [8.327894247820526, 3.9270096101792276],
            [8.31675448531804, 4.014525487377649],
            [8.30637203028167, 4.101017874010193],
            [8.30091051978877, 4.144545167774327],
            [8.295279596466036, 4.187304552335274],
            [8.29572406044678, 4.187752706074181]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.00559779805498, "lat": 42.24653163231607 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26025"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01622955"
      },
      "bbox": [
        8.295279596466036, 3.8406028705001747, 8.766762378192793,
        4.2384029141611155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.44726272692803, 8.189261836574444],
            [7.427853976900565, 8.3711402309197],
            [7.444070923399548, 8.371584240655581],
            [7.476482816133547, 8.367286096795763],
            [7.5072171915397945, 8.366887046302343],
            [7.532013798510604, 8.369337418736855],
            [7.562918287051966, 8.375887577309486],
            [7.593323809190274, 8.377648213205443],
            [7.619264580614975, 8.37626600632342],
            [7.647807656895566, 8.378574055491402],
            [7.662857240266634, 8.380646624937492],
            [7.6785409069884984, 8.384143189608077],
            [7.691971602877063, 8.390000484777435],
            [7.713925104051535, 8.40290783526613],
            [7.725017939797533, 8.410716068322023],
            [7.739669126999082, 8.417137769713545],
            [7.763041395480733, 8.431533001779803],
            [7.76800505137783, 8.434185166264813],
            [7.790172346287277, 8.450139147902853],
            [7.801391782288597, 8.458728099781473],
            [7.814935144160577, 8.466735086365569],
            [7.836568845756088, 8.478389714067983],
            [7.849283476151675, 8.482098259871096],
            [7.859335090450222, 8.387049740628935],
            [7.870122661913329, 8.294721546860014],
            [7.873075814499996, 8.264282657810378],
            [7.887036580902831, 8.146055510120005],
            [7.896009952714849, 8.066659617501589],
            [7.8993551436773615, 8.038901238062243],
            [7.9067907412911325, 7.981837199139387],
            [7.820464157270263, 7.9722547308620975],
            [7.7484758918316565, 7.964256910627636],
            [7.676489358965926, 7.9562438052151565],
            [7.648110768805081, 7.952780109131563],
            [7.5614610300893, 7.943311402059518],
            [7.474813786391109, 7.9338205646794755],
            [7.472214647858138, 7.959532365855091],
            [7.465882408934514, 8.019395322635159],
            [7.44726272692803, 8.189261836574444]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.54445399188698, "lat": 46.47057375602117 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26095"],
        "coty_name": ["Luce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Luce County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01622990"
      },
      "bbox": [
        7.427853976900565, 7.9338205646794755, 7.9067907412911325,
        8.482098259871096
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.63265882662897, 5.634224577284736],
            [8.675464090477895, 5.6389025606485],
            [8.741268389524892, 5.646295274431118],
            [8.80364134605351, 5.6531217193049645],
            [8.80193566887585, 5.66788602799667],
            [8.915688481448305, 5.680247121851044],
            [8.944288955558504, 5.6829136107316565],
            [8.95519658203678, 5.598153198120995],
            [8.96917169367166, 5.48536054134028],
            [8.975760109832235, 5.427939864226398],
            [8.97939580564882, 5.391730634837243],
            [8.984848882949771, 5.3414480182894355],
            [8.898737971852709, 5.330221014224568],
            [8.842129754358236, 5.323421770491512],
            [8.843963221279731, 5.307994075017334],
            [8.730220378032968, 5.294283606132444],
            [8.673545762401778, 5.287302583865028],
            [8.662835955639313, 5.374300271409812],
            [8.65583224781224, 5.431808672748985],
            [8.653929801412596, 5.446093456016253],
            [8.642507515263683, 5.547422482499733],
            [8.63265882662897, 5.634224577284736]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.38813198787726,
          "lat": 43.646837904729686
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26111"],
        "coty_name": ["Midland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Midland County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01622998"
      },
      "bbox": [
        8.63265882662897, 5.287302583865028, 8.984848882949771,
        5.6829136107316565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.33066703125725827, 8.457616834093095],
            [0.41789353188249395, 8.458151436944997],
            [0.5053910204094435, 8.457845558386957],
            [0.5537714355358704, 8.456662030986289],
            [0.5971996248447282, 8.456809716329346],
            [0.6218421519117329, 8.457175367360536],
            [0.6471212356062275, 8.457170226954855],
            [0.7002172964116627, 8.458030725959308],
            [0.709762927080145, 8.45783256682147],
            [0.7266306661037972, 8.458273818305486],
            [0.770537586676128, 8.458497683742484],
            [0.8053184993492585, 8.458485331698595],
            [0.8176371947105953, 8.459027814145465],
            [0.8739768631989048, 8.458736562409989],
            [0.9294013226864895, 8.459525322348696],
            [0.9441152229919019, 8.459861556387578],
            [1.031658018656958, 8.461281476906361],
            [1.0313482722808762, 8.404122133922726],
            [1.0314441640322387, 8.37285117333625],
            [1.0317394958210782, 8.370335102967102],
            [1.0325549162454408, 8.325593288116304],
            [1.032401530043087, 8.289635994976852],
            [1.0379071770240829, 8.289747817937355],
            [1.0381690820137766, 8.247098939505875],
            [1.0387683089117117, 8.188590023973072],
            [1.03891883570339, 8.118735883518514],
            [1.0388881876152942, 8.075795589495437],
            [1.0392010940860306, 8.032847517678219],
            [0.9956545117479922, 8.032031586477693],
            [0.9812130332598185, 8.031001305613366],
            [0.9519932810493773, 8.031279040466442],
            [0.9103813100686486, 8.030949021382712],
            [0.9028670966757762, 8.030493149452369],
            [0.852216880185735, 8.02978316297917],
            [0.8459044738805355, 8.03059972947141],
            [0.8157339725099941, 8.031178887491112],
            [0.7940402845661833, 8.030577497979383],
            [0.7784114696490875, 8.029422863606548],
            [0.7206526302424451, 8.028777329781608],
            [0.6637794259525817, 8.028561854275926],
            [0.6049461155058983, 8.029381646833125],
            [0.5180953976214202, 8.029543122614882],
            [0.41976310629676256, 8.030571285830778],
            [0.3633198331072304, 8.030820430455337],
            [0.34360359295578813, 8.030660970844112],
            [0.34255796149656764, 8.095477435855436],
            [0.342086007968046, 8.116469955697866],
            [0.34372977065433225, 8.187824278648087],
            [0.3440521987916635, 8.195121281375512],
            [0.34424459352759285, 8.223037891318118],
            [0.34440666011597465, 8.286499897754883],
            [0.33106675407472785, 8.28652149104439],
            [0.3308342615028039, 8.371766586801346],
            [0.33066703125725827, 8.457616834093095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.67395724308184, "lat": 46.93463107854833 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27005"],
        "coty_name": ["Becker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Becker County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00659448"
      },
      "bbox": [
        0.33066703125725827, 8.028561854275926, 1.0392010940860306,
        8.461281476906361
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.11031630193032799, 8.4593287610569],
            [-0.05150606307216774, 8.45941928743515],
            [-0.007978360060327408, 8.459360907364399],
            [0.07814018180342999, 8.458895317683918],
            [0.1579098099451595, 8.458067078926659],
            [0.24343429755180301, 8.458020745630591],
            [0.33066703125725827, 8.457616834093095],
            [0.3308342615028039, 8.371766586801346],
            [0.33106675407472785, 8.28652149104439],
            [0.34440666011597465, 8.286499897754883],
            [0.34424459352759285, 8.223037891318118],
            [0.3440521987916635, 8.195121281375512],
            [0.34372977065433225, 8.187824278648087],
            [0.342086007968046, 8.116469955697866],
            [0.34255796149656764, 8.095477435855436],
            [0.34360359295578813, 8.030660970844112],
            [0.3440235785515679, 7.997639881278029],
            [0.3449474371527176, 7.944604265184104],
            [0.26998747694212893, 7.944909740462886],
            [0.17429394415470878, 7.945228789528795],
            [0.15728947293577306, 7.945152418481334],
            [0.08705550796368314, 7.945450081054922],
            [0.011914700483172632, 7.9458635909040884],
            [-0.07716512090896285, 7.946402470317029],
            [-0.08006181021294995, 7.945330109042527],
            [-0.0861311718376987, 7.946466093283681],
            [-0.08260175069561988, 7.950316998005521],
            [-0.08105988907185323, 7.958498622911816],
            [-0.08329637808799603, 7.96255588893122],
            [-0.08089328314409563, 7.964964017626009],
            [-0.08655960856542924, 7.969945742814067],
            [-0.08704551573470584, 7.976396399284886],
            [-0.08554872214406015, 7.97771527812523],
            [-0.08808750234879928, 7.9841718917389395],
            [-0.08296530916778282, 7.984818150950492],
            [-0.08639473418587316, 7.989936763039533],
            [-0.0865639837596901, 7.993765064114831],
            [-0.08319329189352594, 7.9949311153728075],
            [-0.07903951408828541, 7.994083738341253],
            [-0.07866007560729019, 7.999929329668905],
            [-0.07996988317986006, 8.003749986741875],
            [-0.07656839691329682, 8.009593156888217],
            [-0.07963427325605618, 8.019793044216128],
            [-0.07935949818895618, 8.023833085145931],
            [-0.07549838418124394, 8.02640812714311],
            [-0.08060123035198828, 8.032739586903709],
            [-0.07278694512153723, 8.038106714893239],
            [-0.07262321778665358, 8.044663874991622],
            [-0.0746293066126534, 8.055354970477683],
            [-0.07645220333333452, 8.05725595271618],
            [-0.07565980204616497, 8.069383307716844],
            [-0.07792620352412948, 8.072310662021623],
            [-0.07200818528001873, 8.074491522649843],
            [-0.07214444787593867, 8.07721985219884],
            [-0.07801034548598336, 8.078442449778768],
            [-0.07792568561668904, 8.080751709264417],
            [-0.07139311870047546, 8.07876426014569],
            [-0.06995347766578706, 8.081978828727443],
            [-0.07834561485529427, 8.08455240927967],
            [-0.07466507172107498, 8.090236740709276],
            [-0.07653648209563434, 8.092629878988047],
            [-0.08033242412253595, 8.0903147780839],
            [-0.08399482512995193, 8.09162325467289],
            [-0.07750138957987096, 8.0986695326896],
            [-0.08352891532800331, 8.103865197409608],
            [-0.08216141160530949, 8.108541107431643],
            [-0.08695506543333575, 8.112073852659659],
            [-0.08329295701337301, 8.114125096932765],
            [-0.084512968135372, 8.11832913366075],
            [-0.08357314630666096, 8.122432306703192],
            [-0.08771082774552756, 8.125239572311866],
            [-0.08547377721058294, 8.129081268828912],
            [-0.08600447187510446, 8.133254581719845],
            [-0.08447043505083855, 8.135904014127682],
            [-0.08075247852809024, 8.136760607730112],
            [-0.0800273329718813, 8.141290103245577],
            [-0.07680766932134374, 8.143641755498727],
            [-0.07390679116456587, 8.150309525474224],
            [-0.07664015875536065, 8.15200790057052],
            [-0.06974420532179378, 8.155303768376761],
            [-0.07308082200057649, 8.158781382838395],
            [-0.0697977100353169, 8.165458431649263],
            [-0.0699639372147944, 8.170191637385035],
            [-0.07452893088384324, 8.174566173883496],
            [-0.07228616996513201, 8.179969522949618],
            [-0.07312430820722463, 8.183541705037571],
            [-0.06910799129451485, 8.186545084177759],
            [-0.0719052692798952, 8.192780478116665],
            [-0.06465045480842874, 8.190159187736112],
            [-0.0629539995643663, 8.196158106985385],
            [-0.06720050563052155, 8.197276378007897],
            [-0.06794602905926962, 8.201348070452172],
            [-0.06439706917670393, 8.20435025023819],
            [-0.06917086504343911, 8.208035326335905],
            [-0.0670481460647217, 8.215804007420052],
            [-0.06489525346511635, 8.218940343487773],
            [-0.06161484472477355, 8.217238740186643],
            [-0.05870903816252977, 8.22637277824349],
            [-0.05314968806207768, 8.226634418405654],
            [-0.05881921889341522, 8.231998562664266],
            [-0.05295290025596262, 8.236386649120137],
            [-0.05690585303191897, 8.239571025914795],
            [-0.055784614087434826, 8.242518292493404],
            [-0.05870271522835971, 8.24638425180156],
            [-0.0679236135957874, 8.242713693041605],
            [-0.06898901963625571, 8.238288099102428],
            [-0.07472832544528846, 8.241093840105052],
            [-0.07932951404558287, 8.240443820968672],
            [-0.07808737407271131, 8.249497857501401],
            [-0.07905967894483974, 8.25620595148034],
            [-0.08351808756167955, 8.256340393156545],
            [-0.0844958360375649, 8.265957755809051],
            [-0.08685826092843077, 8.268089788863024],
            [-0.08124051655688055, 8.276883177580466],
            [-0.08557073667911647, 8.277411745972191],
            [-0.09141331145495826, 8.275457902458468],
            [-0.09806247107897739, 8.279014597848546],
            [-0.10054623607141663, 8.28237154354334],
            [-0.09820774213654768, 8.288772532062396],
            [-0.09999138215569826, 8.297217052021336],
            [-0.10241191742408498, 8.298785331164924],
            [-0.0998864124632857, 8.302480166107753],
            [-0.10129397411286563, 8.30451249239678],
            [-0.10028785196955711, 8.309150064937247],
            [-0.1047495969222433, 8.316410154767134],
            [-0.10718295683457109, 8.31550833502242],
            [-0.11014379113261011, 8.319854969029594],
            [-0.10724976345315697, 8.321112146773336],
            [-0.10525319446780464, 8.32967021491098],
            [-0.10224121689229977, 8.333965725722843],
            [-0.09437628040736432, 8.335909543119122],
            [-0.10055992663081109, 8.344333031887476],
            [-0.09529153864112092, 8.344328423361349],
            [-0.09277652560244193, 8.34872174797188],
            [-0.09971266237940823, 8.348182074414805],
            [-0.09604971118199082, 8.356214673286066],
            [-0.09835662603342925, 8.359100774777719],
            [-0.09597996398628376, 8.361874015834424],
            [-0.10084686214771318, 8.365572614399667],
            [-0.09820624717355568, 8.371070784670188],
            [-0.10028312318878004, 8.38068328926602],
            [-0.10379328031798428, 8.384606361851993],
            [-0.10163569844030994, 8.38643571971277],
            [-0.09516293403794732, 8.388308045177135],
            [-0.09763703323728656, 8.392843998408551],
            [-0.09457101625849931, 8.39815858658328],
            [-0.09539003009326577, 8.407610037572109],
            [-0.09796166846274015, 8.409504260114371],
            [-0.09441044930084158, 8.413585695447377],
            [-0.09497597282322119, 8.418493483528158],
            [-0.09898737876930674, 8.419021839408819],
            [-0.09753296557266591, 8.42303521900577],
            [-0.0993346691169835, 8.426778117037445],
            [-0.10722552918715673, 8.43301256759484],
            [-0.10074695097967024, 8.432553051964682],
            [-0.09909318487808333, 8.440376165807997],
            [-0.1033419351648488, 8.449884284311013],
            [-0.10648005020516446, 8.451439803105883],
            [-0.1027406544548527, 8.455270093575272],
            [-0.10500603893914637, 8.458465334662804],
            [-0.11031630193032799, 8.4593287610569]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.49052999353337, "lat": 46.89223393582893 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27027"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00659459"
      },
      "bbox": [
        -0.11031630193032799, 7.944604265184104, 0.3449474371527176,
        8.45941928743515
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7450773399872438, 9.31140482796301],
            [0.8643887137361527, 9.311861592151343],
            [0.9837000929081746, 9.312271757392374],
            [0.9720316657488955, 9.297313447860512],
            [0.9625506350459732, 9.273740068298455],
            [0.9549228208314949, 9.252914677118214],
            [0.9549183253202842, 9.249228614993719],
            [0.9519434797171982, 9.237134188009598],
            [0.951245765473588, 9.224246142568752],
            [0.952934362808977, 9.210774575505969],
            [0.9546669713985584, 9.204532750983457],
            [0.9601276736824391, 9.192108685187254],
            [0.9671677282171971, 9.18279727983153],
            [0.9800428888708329, 9.175081692314281],
            [0.9887551721630832, 9.171708292745707],
            [0.9980029748158259, 9.169400270200265],
            [1.0088225106844415, 9.167739477841682],
            [1.0090277970057782, 9.16084572478588],
            [1.009574731184073, 9.058200386691892],
            [1.0100908058586886, 8.972827200944554],
            [1.0164115082021354, 8.972780386131719],
            [1.0173802144321729, 8.887313872296744],
            [1.0190423667741901, 8.801754576858858],
            [1.019834345139194, 8.717086851878083],
            [1.0204885947476314, 8.654609472045511],
            [1.020923977339815, 8.631351660528484],
            [1.0298407187959684, 8.63130519863754],
            [1.0308307267967278, 8.547076825407226],
            [1.031658018656958, 8.461281476906361],
            [0.9441152229919019, 8.459861556387578],
            [0.9294013226864895, 8.459525322348696],
            [0.8739768631989048, 8.458736562409989],
            [0.8176371947105953, 8.459027814145465],
            [0.8053184993492585, 8.458485331698595],
            [0.770537586676128, 8.458497683742484],
            [0.7697986635520505, 8.544197987771428],
            [0.7696094080079485, 8.629457033051702],
            [0.7695288201926639, 8.700671946908964],
            [0.7687161293532402, 8.801129185589486],
            [0.7668197372369755, 8.80099566377642],
            [0.7668976074599085, 8.88630604838857],
            [0.7664966235983924, 8.943099253641952],
            [0.7665909328277525, 8.971478019747842],
            [0.7493348025988175, 8.971465922968209],
            [0.7491883731953967, 8.99987455188701],
            [0.7481424062111661, 9.056706811892546],
            [0.7482349473247883, 9.077631887041502],
            [0.7469663525133444, 9.155872596074486],
            [0.7459504751957247, 9.226535743049645],
            [0.7455151867355769, 9.282596942123991],
            [0.7450773399872438, 9.31140482796301]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.37899045089114, "lat": 47.57766674856342 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27029"],
        "coty_name": ["Clearwater"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clearwater County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00659460"
      },
      "bbox": [
        0.7450773399872438, 8.458485331698595, 1.031658018656958,
        9.312271757392374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.019834345139194, 8.717086851878083],
            [1.0878743862557472, 8.71712445095807],
            [1.1066797952414746, 8.71697632363212],
            [1.1793853559924319, 8.71736330679638],
            [1.194066648143274, 8.71678954156258],
            [1.2883032581062308, 8.716987077799661],
            [1.3175050158094108, 8.717857595782462],
            [1.3402190699982701, 8.717491604137413],
            [1.3691215941782404, 8.718409643101337],
            [1.3690068167915255, 8.686233979496096],
            [1.369490071961273, 8.632545605506134],
            [1.3748641869765061, 8.632562098219143],
            [1.3754684226592804, 8.582352256595957],
            [1.3760520394523417, 8.547933754255615],
            [1.3772982509021845, 8.44527667104379],
            [1.3780819565883229, 8.420266386771473],
            [1.3783374299690778, 8.37769362808239],
            [1.3790023840082242, 8.320823079721814],
            [1.3796595501456994, 8.292321443808008],
            [1.383267646393601, 8.292385539571594],
            [1.3832523899563998, 8.270719447565721],
            [1.3837364649140662, 8.236002324767725],
            [1.3837816850606883, 8.207413587340666],
            [1.384622203134844, 8.121665601411056],
            [1.297224008794176, 8.120727371299331],
            [1.2596034640419644, 8.120466931369284],
            [1.235961512376181, 8.121169123169189],
            [1.2116674513235854, 8.120797515979019],
            [1.1250555579888, 8.120373388324381],
            [1.03891883570339, 8.118735883518514],
            [1.0387683089117117, 8.188590023973072],
            [1.0381690820137766, 8.247098939505875],
            [1.0379071770240829, 8.289747817937355],
            [1.032401530043087, 8.289635994976852],
            [1.0325549162454408, 8.325593288116304],
            [1.0317394958210782, 8.370335102967102],
            [1.0314441640322387, 8.37285117333625],
            [1.0313482722808762, 8.404122133922726],
            [1.031658018656958, 8.461281476906361],
            [1.0308307267967278, 8.547076825407226],
            [1.0298407187959684, 8.63130519863754],
            [1.020923977339815, 8.631351660528484],
            [1.0204885947476314, 8.654609472045511],
            [1.019834345139194, 8.717086851878083]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.91664917716837,
          "lat": 47.108623030419125
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27057"],
        "coty_name": ["Hubbard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hubbard County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00659474"
      },
      "bbox": [
        1.019834345139194, 8.118735883518514, 1.384622203134844,
        8.718409643101337
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9155392980884579, 10.26628019401453],
            [1.025927673747486, 10.267282219469788],
            [1.0246089997452297, 10.441311808640677],
            [1.023910773336962, 10.511051627378434],
            [1.0228031475198278, 10.641303024596539],
            [1.0251918120848906, 10.637648644687811],
            [1.030454223481767, 10.635501308561139],
            [1.040664798812493, 10.627005053461017],
            [1.0476928172352482, 10.624238211635548],
            [1.0561067785311153, 10.622902735610188],
            [1.0563380914087728, 10.621445386395196],
            [1.0649554306728677, 10.619161229304549],
            [1.0857744948731887, 10.611661440890238],
            [1.0917355089441674, 10.611609276869666],
            [1.1148002860741333, 10.615086045401373],
            [1.1315181101054992, 10.627365155555028],
            [1.1411872036040427, 10.626343801330567],
            [1.1522699516870818, 10.628834671472772],
            [1.1558221760656613, 10.627412643099081],
            [1.184322835149901, 10.609795237202821],
            [1.1858195449540547, 10.608195429229227],
            [1.2048799153706202, 10.593568636673222],
            [1.2209843883997504, 10.584994968554449],
            [1.2324642546339102, 10.585048669466127],
            [1.2461519017130556, 10.582227890522212],
            [1.24096726798555, 10.57038207304168],
            [1.2403077549078634, 10.556367930919428],
            [1.2600265659451904, 10.478910688022957],
            [1.2596759240818438, 10.462980214326537],
            [1.2763999038642535, 10.392450915534353],
            [1.277120445514468, 10.388322821236732],
            [1.2926111541349514, 10.367682590389482],
            [1.3147212428266828, 10.2715199688175],
            [1.3392803827973263, 10.159032826792906],
            [1.3395250082203014, 10.14779213810933],
            [1.3340411069846976, 10.144362436326087],
            [1.3356354064464557, 10.138948809841324],
            [1.3339084049134422, 10.129224697516332],
            [1.3389917497197086, 10.116379398595281],
            [1.331477325267645, 10.112007839615067],
            [1.3282589169791517, 10.10811794423804],
            [1.3268174750504658, 10.100806101527505],
            [1.33322310933024, 10.0862186298347],
            [1.3326841792818882, 10.077028464701888],
            [1.3339337409263534, 10.066904028855767],
            [1.3340077533585677, 10.059927610229721],
            [1.338974486924429, 10.053010380250507],
            [1.3485383728069493, 10.047598012196286],
            [1.3571630175738199, 10.038928806154505],
            [1.3626189013814975, 10.034691669219962],
            [1.3671351187796947, 10.028105812449438],
            [1.3671761950848915, 10.023286586272157],
            [1.3699803879588737, 10.020574258192282],
            [1.3848629829490635, 10.01700832698952],
            [1.3905919778747098, 10.011753238099503],
            [1.3967499222669668, 10.00839779253242],
            [1.4047700384289505, 9.998317124325276],
            [1.4189642321151836, 9.996224771366613],
            [1.4273156612500455, 9.99701634909063],
            [1.4342623624079565, 9.993203497970969],
            [1.4390278944764219, 9.983979755989093],
            [1.442563436535552, 9.982660991920248],
            [1.4483795078064516, 9.983065240915844],
            [1.4589002620587432, 9.982063957145725],
            [1.4651086004309966, 9.979816623396681],
            [1.4740051150515991, 9.979869849860934],
            [1.488594475811211, 9.977796678731949],
            [1.4967516503937752, 9.974947243870515],
            [1.5058093100894199, 9.977474829041311],
            [1.5113211841184229, 9.98347448541759],
            [1.5130201861451649, 9.911906497930453],
            [1.5133189136714438, 9.892903045523251],
            [1.5139714049634312, 9.876724820103245],
            [1.5140877547937928, 9.827234858645967],
            [1.5148061276106852, 9.78182708026496],
            [1.5161933138045316, 9.738685880917373],
            [1.5165183893184122, 9.707827923127958],
            [1.5178380161876794, 9.65833090277341],
            [1.4301430140498608, 9.656848705738764],
            [1.3428505830084574, 9.655283936419263],
            [1.2554678230722192, 9.654074162868534],
            [1.1680854963935763, 9.652838903009917],
            [1.0699264100249872, 9.651403105250163],
            [0.9930993630785858, 9.650471901041971],
            [0.9926462092213874, 9.692337303059789],
            [0.9920228417229219, 9.706503072081416],
            [0.9922693800969223, 9.734618057600185],
            [0.9913510456370798, 9.804954678851049],
            [0.990992582393957, 9.820194365770051],
            [0.9410614790009292, 9.81979014384805],
            [0.9036281083253145, 9.819805934621533],
            [0.9031874644546645, 9.883232290857007],
            [0.9023187916972822, 9.988204287616135],
            [1.021413542424677, 9.98898920338581],
            [1.0710454292683906, 9.98960761493469],
            [1.0707475857385669, 10.025448944363378],
            [1.070279252262405, 10.032257818228128],
            [1.0697527615623592, 10.088341629202288],
            [1.0680161606147927, 10.19156233973738],
            [1.0610370572092416, 10.184254391155383],
            [1.0533310988522946, 10.178003086355604],
            [1.051610705670501, 10.17489861453925],
            [1.0473316648240405, 10.171812642437459],
            [1.0372000595374071, 10.166204031210382],
            [1.0304121700738673, 10.163645202959835],
            [1.021431228675377, 10.163291372128576],
            [0.9970428855845711, 10.156757368208545],
            [0.9886663113084103, 10.15594722902399],
            [0.978520979938525, 10.152915055725918],
            [0.9724594195542668, 10.152642093278983],
            [0.9596230063216082, 10.15548309096378],
            [0.9464478006299325, 10.16372299697031],
            [0.9445854532999454, 10.166197868105014],
            [0.9374704641262007, 10.168280761008962],
            [0.9355592878036106, 10.171820366722864],
            [0.928747193030031, 10.174452903643179],
            [0.9318024090447531, 10.178417583523915],
            [0.9285613949680405, 10.180711447293888],
            [0.922092225934271, 10.188075879539458],
            [0.9186534896184022, 10.193968388948397],
            [0.9140730400764703, 10.204705540992052],
            [0.9139550638899769, 10.209336579983278],
            [0.9189194810171206, 10.214965770623605],
            [0.9259768695508623, 10.215089105993838],
            [0.9251738917650785, 10.218557946505511],
            [0.9173011082608733, 10.221264750215765],
            [0.9149612159678997, 10.22847022419387],
            [0.9158827008485837, 10.232102605927196],
            [0.9120051261050064, 10.238154636832798],
            [0.9110928857535151, 10.250024978412426],
            [0.9169863382571055, 10.263776801641077],
            [0.9155392980884579, 10.26628019401453]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.90457328850387, "lat": 48.7712356650603 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27077"],
        "coty_name": ["Lake of the Woods"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake of the Woods County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00659483"
      },
      "bbox": [
        0.9023187916972822, 9.650471901041971, 1.5178380161876794,
        10.641303024596539
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3317879016416894, 5.792201252965808],
            [1.3581659984608336, 5.792213870090407],
            [1.4431493017313128, 5.793095428292178],
            [1.4796185066143015, 5.793490790150942],
            [1.5299433137660374, 5.794789963097848],
            [1.5799556920999633, 5.795562584455437],
            [1.6158020492276, 5.796416845949834],
            [1.7089933130129955, 5.798012695425556],
            [1.7649052051036094, 5.799404808180299],
            [1.7654160028962653, 5.799059406186516],
            [1.8025005198540627, 5.800063779025029],
            [1.8806712089932984, 5.801289627759261],
            [1.9338066432189975, 5.802562342281167],
            [1.9359029895132265, 5.80012032556309],
            [1.9354613671298664, 5.795534053463148],
            [1.9390369608653037, 5.790566769340983],
            [1.935424827160461, 5.7791573738321524],
            [1.9347485236386184, 5.77163992496492],
            [1.9324640479772248, 5.766536334935323],
            [1.9304503928299304, 5.758272197044291],
            [1.9258345968703616, 5.758928263338015],
            [1.921149004381868, 5.755372938489037],
            [1.9236083612586141, 5.752564598878152],
            [1.9251058609326364, 5.742792823917801],
            [1.9214237782486618, 5.7351969864725305],
            [1.9229645514619595, 5.731522387695494],
            [1.9157160617395976, 5.72992920930687],
            [1.9152947234167796, 5.7272514905934555],
            [1.9195744344870898, 5.725153198581946],
            [1.9207603067245975, 5.719498633660192],
            [1.9163395897378597, 5.716444864559427],
            [1.9164025605887778, 5.71160448148492],
            [1.919730526508137, 5.708983691096989],
            [1.9223592437873103, 5.702868569085549],
            [1.929823532201092, 5.700996678747375],
            [1.9351819753355786, 5.696231288171533],
            [1.9377867719430553, 5.69110010050909],
            [1.935514331187775, 5.685840354087022],
            [1.9318286664489877, 5.687283058234299],
            [1.928997503443594, 5.685024034077018],
            [1.9302865642271716, 5.677343491922607],
            [1.926701247981978, 5.676545652663897],
            [1.9239239676452213, 5.670582384706182],
            [1.9254236028899232, 5.666370890301656],
            [1.9235323124132937, 5.66402029794969],
            [1.9192773492185855, 5.653181432799742],
            [1.9147745720353162, 5.652835797022506],
            [1.9096639289630162, 5.646087156224727],
            [1.9043220067157627, 5.645208260369621],
            [1.8971664506513024, 5.640899156853721],
            [1.898118749459855, 5.638441223537218],
            [1.8952954740578627, 5.634482141420965],
            [1.8925221436036985, 5.624168199251241],
            [1.8878393922593169, 5.624305820247375],
            [1.8834158596650337, 5.621930103434378],
            [1.8812831271157655, 5.6101038224235245],
            [1.8761125746855143, 5.6066515405555695],
            [1.874187991732769, 5.600910195910355],
            [1.8801276696762195, 5.602516143994557],
            [1.884623179714819, 5.5975671223738575],
            [1.885780801026786, 5.592926040700758],
            [1.8809314354852404, 5.593583972208639],
            [1.8767214007138011, 5.587620046436238],
            [1.8783685322219426, 5.584588553902932],
            [1.8835462525002968, 5.584753086484751],
            [1.8795914121466177, 5.582002614044807],
            [1.8800235716460527, 5.574201432610427],
            [1.8818899818909023, 5.57184149985451],
            [1.8816501653770925, 5.566927159367884],
            [1.8757796210500173, 5.567333656751564],
            [1.874055971700983, 5.566042682795355],
            [1.8742060802171485, 5.55761896757638],
            [1.8808257321133652, 5.5539041784341965],
            [1.8851975651380315, 5.541934439425651],
            [1.8848032120305602, 5.537265985924445],
            [1.8812350107210083, 5.537147817123927],
            [1.8789885209107173, 5.534744068540424],
            [1.8787254189182283, 5.52989547276881],
            [1.8886475313861948, 5.529574573083495],
            [1.8919163057104413, 5.519449888114537],
            [1.8910875994436556, 5.514739931736114],
            [1.8827313564340094, 5.510397404601573],
            [1.874220271667907, 5.51150854005383],
            [1.8630063778992583, 5.507299204685443],
            [1.8623581760535584, 5.500741158989916],
            [1.8603059192515685, 5.499160820423445],
            [1.8542540241530707, 5.4987545865371805],
            [1.8515717892394319, 5.5014070409957645],
            [1.8497189766632207, 5.507289815300137],
            [1.8409625213270375, 5.502977197248922],
            [1.833248276262304, 5.505069484869945],
            [1.8324370985706588, 5.507799123613059],
            [1.827767028453797, 5.508376877804547],
            [1.826330578749307, 5.512552380065028],
            [1.822118932781278, 5.512185754924909],
            [1.819495542103753, 5.515061204528406],
            [1.8148784111330916, 5.516314074790214],
            [1.8156549521200254, 5.519496727934547],
            [1.8138117219059133, 5.523396554811779],
            [1.809976516747565, 5.52272050864132],
            [1.8037889272148173, 5.5235975287023065],
            [1.8037829679725192, 5.527974113802082],
            [1.797323468656494, 5.530451379777161],
            [1.7906359169523502, 5.537470099212945],
            [1.784431411491066, 5.535090561643375],
            [1.7809595018405704, 5.5371068278167765],
            [1.7692778262522655, 5.538084785470502],
            [1.7639240729791938, 5.540423440812645],
            [1.7567282149289252, 5.540962824654369],
            [1.7507397403944183, 5.545291845823332],
            [1.744525508252289, 5.544227136170482],
            [1.7428582750356094, 5.5426678423417375],
            [1.7375163013579085, 5.547828020407175],
            [1.7342070390508355, 5.547844209884279],
            [1.732261805676214, 5.554005759302198],
            [1.7258672492186822, 5.554630147035043],
            [1.7221208939399406, 5.551812627136111],
            [1.7196959210874032, 5.556016214653506],
            [1.7129975835862241, 5.556664166321955],
            [1.715245262914596, 5.562047049111988],
            [1.7111034353826975, 5.562692182693421],
            [1.709504545564449, 5.5655110020475975],
            [1.7051451953072392, 5.566461078159547],
            [1.6978232262410868, 5.565801940320912],
            [1.6923476179377377, 5.570471357234967],
            [1.6873883048589062, 5.569947815225162],
            [1.6884099335294156, 5.57455859102953],
            [1.6843131803002946, 5.580912816875029],
            [1.679127344146028, 5.579084728936175],
            [1.6777295164294923, 5.583887741984499],
            [1.6749686100473367, 5.582984905320287],
            [1.663638476334444, 5.584404196022438],
            [1.662991216969937, 5.587066826866062],
            [1.6572755687483505, 5.590562136129373],
            [1.6558243857044523, 5.59476632523833],
            [1.6509662145594524, 5.597558143256568],
            [1.6425016746334, 5.598463643641369],
            [1.6376029089131592, 5.602119307697091],
            [1.6347914743015157, 5.60101660051916],
            [1.6308585319783715, 5.604145154017774],
            [1.6261529545219071, 5.604769645384629],
            [1.6071637211807341, 5.608159605683911],
            [1.6054771835884027, 5.61086696032211],
            [1.5971791023181183, 5.613401166424732],
            [1.5982545629871054, 5.619459216563948],
            [1.5957407815636298, 5.622964570875415],
            [1.5955962887307316, 5.6264304041176],
            [1.590549997216053, 5.62958035864203],
            [1.5856117292279048, 5.630339467386592],
            [1.5738032648182505, 5.648530345214651],
            [1.5681223582750323, 5.655828871263474],
            [1.5666097495609568, 5.664035460965632],
            [1.5683398533200066, 5.6710835705864575],
            [1.5667677543516096, 5.673218076217914],
            [1.5610736002680214, 5.671550032381342],
            [1.5527687319049253, 5.67971316470103],
            [1.550728107820113, 5.6829942651179435],
            [1.5467808604852757, 5.683070110725215],
            [1.54427602813789, 5.687752260174774],
            [1.5391276236764526, 5.690992330407286],
            [1.5398254398696767, 5.697399846564025],
            [1.5346996809984896, 5.700395951543845],
            [1.5330725029638406, 5.698246576298188],
            [1.5357284735138776, 5.692776155406201],
            [1.5333684830451348, 5.690870681088121],
            [1.5204430892653478, 5.696461530739137],
            [1.516628603291566, 5.703751848185869],
            [1.4994830367404695, 5.702816198334687],
            [1.4977719515380679, 5.708485726562887],
            [1.4953623106124418, 5.709980065266482],
            [1.4895846125453935, 5.709453647858329],
            [1.4876275818351046, 5.7141575299083485],
            [1.4826684398532133, 5.713920453294961],
            [1.4767582297603379, 5.709802477108577],
            [1.4751849503507282, 5.714693035310145],
            [1.4716810800679063, 5.7118567711997414],
            [1.4668882864714539, 5.714319780965475],
            [1.4655262725098033, 5.720588715341807],
            [1.4609311017121516, 5.723481060577505],
            [1.45582675024992, 5.7222588712157165],
            [1.4506112551492807, 5.722773816744876],
            [1.446197033433649, 5.719371927317186],
            [1.4424882260198215, 5.721748427302831],
            [1.441605497804038, 5.728452599474023],
            [1.4379737569720543, 5.729191838245027],
            [1.431620168742587, 5.727969587448357],
            [1.434401947860595, 5.732603426922751],
            [1.4293917022591587, 5.734579765343096],
            [1.4238415236340753, 5.730662452511073],
            [1.4211191504207177, 5.734631523675635],
            [1.4172177658736334, 5.7361373920599315],
            [1.4166174004024983, 5.731881104680052],
            [1.4122892979872845, 5.73109619277928],
            [1.406320720361267, 5.7335129118749055],
            [1.411382142543097, 5.739555308161101],
            [1.4078290075504079, 5.744211657031871],
            [1.4029203531078225, 5.745614502325823],
            [1.3981788974137386, 5.743556596821381],
            [1.3949884797194392, 5.738702352488389],
            [1.3920112426878575, 5.743269623906765],
            [1.3976612636466064, 5.744456502014538],
            [1.4005328365340146, 5.7482287580131],
            [1.3977683791060715, 5.753841205604179],
            [1.3932558190399666, 5.753916100901608],
            [1.3905070745213963, 5.749594138038754],
            [1.3877560733326515, 5.7529930802694285],
            [1.392271141893016, 5.7581650974121015],
            [1.3936672700568782, 5.762295877214908],
            [1.384490950467791, 5.7706197448608965],
            [1.3708173213772477, 5.7698853028811445],
            [1.366540130422703, 5.777934587435277],
            [1.3542755028210187, 5.785617421868461],
            [1.3478703753988226, 5.782501029935635],
            [1.3445705953387448, 5.778804812232384],
            [1.3412389212152924, 5.778729821946684],
            [1.3404627878042714, 5.782552788733706],
            [1.3345218057378492, 5.7824056320604384],
            [1.3316990773966793, 5.78528564098832],
            [1.3317879016416894, 5.792201252965808]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.24745486377108, "lat": 44.34978238563108 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27103"],
        "coty_name": ["Nicollet"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nicollet County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00659497"
      },
      "bbox": [
        1.3316990773966793, 5.4987545865371805, 1.9390369608653037,
        5.802562342281167
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.26998747694212893, 7.944909740462886],
            [0.3449474371527176, 7.944604265184104],
            [0.3440235785515679, 7.997639881278029],
            [0.34360359295578813, 8.030660970844112],
            [0.3633198331072304, 8.030820430455337],
            [0.41976310629676256, 8.030571285830778],
            [0.5180953976214202, 8.029543122614882],
            [0.6049461155058983, 8.029381646833125],
            [0.6637794259525817, 8.028561854275926],
            [0.7206526302424451, 8.028777329781608],
            [0.7784114696490875, 8.029422863606548],
            [0.7940402845661833, 8.030577497979383],
            [0.8157339725099941, 8.031178887491112],
            [0.8459044738805355, 8.03059972947141],
            [0.852216880185735, 8.02978316297917],
            [0.9028670966757762, 8.030493149452369],
            [0.9103813100686486, 8.030949021382712],
            [0.9519932810493773, 8.031279040466442],
            [0.9812130332598185, 8.031001305613366],
            [0.9956545117479922, 8.032031586477693],
            [1.0392010940860306, 8.032847517678219],
            [1.039189289785415, 8.003960576577933],
            [1.0401891593670163, 7.946308484981686],
            [1.0455992737153232, 7.94635784624358],
            [1.0465290442370456, 7.853247372676695],
            [1.0469024993697365, 7.803223207549876],
            [1.0478911225086665, 7.68850143492259],
            [1.0481245514231616, 7.667095841270283],
            [1.0495675055545477, 7.603036625464493],
            [1.0554313975479988, 7.603029267662229],
            [1.055873033085952, 7.544456179946205],
            [1.0556896823848578, 7.530103205487256],
            [1.0569446629287385, 7.429288367396486],
            [0.9840414255774266, 7.429146844322746],
            [0.9696429397901567, 7.429307092468423],
            [0.8827981808826918, 7.429181847765606],
            [0.8212036610921828, 7.4289849308579115],
            [0.7965969656331919, 7.428785080236311],
            [0.71007383254481, 7.427768217992788],
            [0.6236539394156949, 7.427519367805674],
            [0.5369627173635211, 7.428208954200725],
            [0.4507110042338853, 7.428348134359139],
            [0.3652233416663578, 7.4283306708741526],
            [0.27944061359246053, 7.428730669172178],
            [0.2797344004759087, 7.5140937228468045],
            [0.2797989758918062, 7.56336795521976],
            [0.28020579746551466, 7.568539049204439],
            [0.28042233654692844, 7.600476570050749],
            [0.26978760254521883, 7.600530508512866],
            [0.2698221986066113, 7.629408590035051],
            [0.26966234422684826, 7.698699784376729],
            [0.2698317359595082, 7.773406463296866],
            [0.26982191139994127, 7.888097224432304],
            [0.26998747694212893, 7.944909740462886]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.7080227457234, "lat": 46.40881772562038 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27111"],
        "coty_name": ["Otter Tail"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Otter Tail County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00659501"
      },
      "bbox": [
        0.26966234422684826, 7.427519367805674, 1.0569446629287385,
        8.032847517678219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.507918078394822, 7.509025221158868],
            [2.506710252135211, 7.543294803780211],
            [2.5046521833164563, 7.608962360131359],
            [2.502730999294304, 7.680869645807373],
            [2.4992512715084803, 7.766983633910506],
            [2.587087027065194, 7.769682241636868],
            [2.6442504713959636, 7.7710826195474],
            [2.676895662690076, 7.771709978912432],
            [2.7469364461962256, 7.7740364248538425],
            [2.8169776945804927, 7.776348412273929],
            [2.8837352820833817, 7.778692408582215],
            [2.9688429845224746, 7.781446858825886],
            [2.9697726808308627, 7.781268425542963],
            [3.0098301739834943, 7.782820222499855],
            [3.0257305451532353, 7.783220495805177],
            [3.02934210808933, 7.689071413241451],
            [3.029592661520545, 7.68652651473047],
            [3.0319414472796717, 7.612131726248786],
            [3.034265284735042, 7.54889363732395],
            [3.0352555417776004, 7.526403063910387],
            [3.037070040154123, 7.483395241278018],
            [3.0382561042983802, 7.444365528315173],
            [3.0294982484433732, 7.442078639090969],
            [3.0208885860437316, 7.4386553236994715],
            [3.0150789605688266, 7.435352255955749],
            [3.0101536693031274, 7.428468271215332],
            [3.0082510659444246, 7.419170417774811],
            [3.00514247047115, 7.411996084097531],
            [3.0061825586282143, 7.403664048710991],
            [3.005499256755175, 7.397676749963796],
            [3.001840551369004, 7.392680709164636],
            [3.000422125503786, 7.3847595004136135],
            [2.9933062318454833, 7.381930171754173],
            [2.9859141231778468, 7.382734970687117],
            [2.971836751380731, 7.387497067518735],
            [2.9590589106585155, 7.3946659675688],
            [2.952095958526152, 7.3939199004958915],
            [2.9419279965882383, 7.388054141132522],
            [2.937508044797488, 7.382880695303158],
            [2.9363557611352227, 7.375885356723698],
            [2.9315838194398305, 7.367066921225439],
            [2.930650514401945, 7.359571833716784],
            [2.924509154314679, 7.35432696395392],
            [2.923531498641093, 7.348912208268495],
            [2.925723945003885, 7.346805789579876],
            [2.9235459598743154, 7.34281139590664],
            [2.917910702538436, 7.339317991534167],
            [2.909546384224389, 7.341904634064324],
            [2.9051328598246666, 7.341433569209362],
            [2.8969452775837725, 7.345529734597009],
            [2.8832334428967163, 7.3492009876490885],
            [2.87741734217132, 7.346725444699586],
            [2.872564595933683, 7.342486362221245],
            [2.8672993884598896, 7.3346646089368335],
            [2.864508390698885, 7.332450890500638],
            [2.864868995382563, 7.321613428324212],
            [2.8636207058575076, 7.316227774117998],
            [2.857157964514225, 7.315356088076377],
            [2.851341908581011, 7.312312587593391],
            [2.8477756787133117, 7.312142341323948],
            [2.8373950763039195, 7.305497283742369],
            [2.828855407247693, 7.304244172868838],
            [2.820830625329429, 7.2977287697769935],
            [2.8149575821101727, 7.29817270652931],
            [2.8105049537030014, 7.29525804911286],
            [2.805515695084901, 7.297293251186455],
            [2.8029480646100584, 7.295065885733838],
            [2.8039230649425093, 7.287245820293984],
            [2.7920885703779694, 7.286719571460509],
            [2.789758233885059, 7.285146280795102],
            [2.7785709803696648, 7.273985800216731],
            [2.7784637842405866, 7.268329046075514],
            [2.773454310115643, 7.265745236048351],
            [2.763229361436727, 7.257968003658744],
            [2.757211757360641, 7.256224084284431],
            [2.7482449905711657, 7.244914762752594],
            [2.73979170525222, 7.229061309178372],
            [2.738251421024604, 7.22429664549595],
            [2.738652083853358, 7.2201186486254185],
            [2.736845491600349, 7.208604229258006],
            [2.732679489931637, 7.202388228077334],
            [2.7301797977197184, 7.201571423018442],
            [2.7216793258019436, 7.194483957718895],
            [2.719137607170207, 7.187843358111036],
            [2.722098187642817, 7.17869564618022],
            [2.725075101147218, 7.172138974060945],
            [2.7253253179157477, 7.167543071418011],
            [2.7227045763434607, 7.16218134860047],
            [2.715773937394678, 7.155967894306617],
            [2.712860473962549, 7.150695623541537],
            [2.7109359195084015, 7.143239459103944],
            [2.7100324808958707, 7.133783677630926],
            [2.7080662128045123, 7.124921757003929],
            [2.6986359691843664, 7.114146677246498],
            [2.6959144104468384, 7.112303576280174],
            [2.694165208553428, 7.107884570688422],
            [2.691143652865213, 7.104488743297832],
            [2.686523491401706, 7.102216600153608],
            [2.680104600013542, 7.096658383788114],
            [2.6781307172268574, 7.093679755501564],
            [2.673319286777735, 7.092615639796716],
            [2.6684404481161343, 7.088843754166711],
            [2.6644245807823257, 7.0883026430464104],
            [2.660407026454902, 7.089444597091974],
            [2.586534007242439, 7.08732037888166],
            [2.5435180068608014, 7.08639817724628],
            [2.515125754808704, 7.085525055149197],
            [2.5103136849017904, 7.085638543795816],
            [2.459848699200783, 7.083773671887839],
            [2.456515541654934, 7.184122198176864],
            [2.454198713627527, 7.256172696291417],
            [2.4515803991674208, 7.331758588952261],
            [2.512437626903577, 7.3339373557640455],
            [2.5098122975871187, 7.423040481325039],
            [2.508234786893611, 7.4996533616004735],
            [2.507918078394822, 7.509025221158868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.74135407103192,
          "lat": 46.120729041627456
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27115"],
        "coty_name": ["Pine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pine County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00659503"
      },
      "bbox": [
        2.4515803991674208, 7.083773671887839, 3.0382561042983802,
        7.783220495805177
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.13797778350291023, 9.255748191175398],
            [0.1965063914181193, 9.255270768478391],
            [0.25446215730504584, 9.254960465070734],
            [0.26166443761881875, 9.254653777048157],
            [0.30618622274471147, 9.25432798366911],
            [0.36070052516874684, 9.2544536747906],
            [0.3988507229771905, 9.255063244459295],
            [0.4023542076763401, 9.254838596078216],
            [0.47138200107505335, 9.25539744010502],
            [0.48576788248489733, 9.25579230640816],
            [0.5729406365682973, 9.255948818774712],
            [0.6596210441316097, 9.255946631586136],
            [0.6598566832184527, 9.228019792093432],
            [0.6604395719927924, 9.142604313603336],
            [0.5740926443249997, 9.14203329988224],
            [0.5740044178912709, 9.056455034721427],
            [0.48607910609293525, 9.056047981920525],
            [0.4508534609092133, 9.055951320968466],
            [0.41319358172323617, 9.055569693361653],
            [0.3265913453899227, 9.055212091478523],
            [0.22554744246725386, 9.056214724133119],
            [0.22543429259786563, 9.106011174575885],
            [0.22520363851662106, 9.141503833344313],
            [0.17328405602108565, 9.14193324305883],
            [0.13770239129110043, 9.14198120405888],
            [0.13797778350291023, 9.255748191175398]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.09530113432841, "lat": 47.87169067156432 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27125"],
        "coty_name": ["Red Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Red Lake County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00659508"
      },
      "bbox": [
        0.13770239129110043, 9.055212091478523, 0.6604395719927924,
        9.255948818774712
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.6498362860984015, -6.518715354432691],
            [4.654910311695903, -6.521769814007895],
            [4.65925552350586, -6.521682489633517],
            [4.668756572337985, -6.526380112330308],
            [4.6721137118372456, -6.529592202492523],
            [4.684762551018388, -6.53424030259797],
            [4.694332749463415, -6.531849403138763],
            [4.698211199125333, -6.53513999604939],
            [4.702010123163841, -6.535603043053394],
            [4.702713620944116, -6.532395516745793],
            [4.708805229753014, -6.524799600973525],
            [4.7122500369537885, -6.528182466095939],
            [4.708812003545865, -6.530979425615166],
            [4.709892452450171, -6.535292801840809],
            [4.705535629724672, -6.540116622848889],
            [4.712558858054589, -6.539424463995195],
            [4.713685968265794, -6.546105756273773],
            [4.718697435954359, -6.547867769806355],
            [4.719986704135388, -6.54337349388366],
            [4.723031813390197, -6.539951081365482],
            [4.72581272982224, -6.542092571231414],
            [4.723726830631681, -6.549250599474227],
            [4.728433444118956, -6.549397459799821],
            [4.728625569492535, -6.5449521343775965],
            [4.732945303969882, -6.547111839863174],
            [4.747948627422673, -6.546524164024724],
            [4.750227769791065, -6.540328902158254],
            [4.743842131625452, -6.540712509626845],
            [4.749178319399604, -6.531762947011947],
            [4.746977360942187, -6.529284357909556],
            [4.741199551549294, -6.53118928761052],
            [4.73928727847507, -6.528658164583145],
            [4.7453904227712, -6.52066763157757],
            [4.744652553590084, -6.516230214088331],
            [4.74159310105858, -6.511716132808227],
            [4.742810029370339, -6.509771552237636],
            [4.747556219932337, -6.510630075573045],
            [4.7478383055834215, -6.507315200126794],
            [4.752379799439134, -6.495767501256138],
            [4.755585250492649, -6.495967638185164],
            [4.757230975804527, -6.499767881046086],
            [4.762346944022955, -6.501524815748651],
            [4.768282265591502, -6.507684539521859],
            [4.774505950375384, -6.511939367272807],
            [4.778708609468719, -6.509568277971241],
            [4.7776131555706165, -6.50630405543626],
            [4.780070499298763, -6.498563315736011],
            [4.782975320320866, -6.499390501642181],
            [4.780177162753647, -6.504410623773054],
            [4.784393620894821, -6.5059664002144935],
            [4.791105039749384, -6.503895885145694],
            [4.794656746389492, -6.501085840535357],
            [4.804431362284255, -6.496691195110946],
            [4.805821061885911, -6.486173646197313],
            [4.802810899212493, -6.4836778018643875],
            [4.798568411624664, -6.485869598422552],
            [4.793585187224013, -6.481874551029811],
            [4.803907450504363, -6.4738046758361865],
            [4.805168514066801, -6.471486362411728],
            [4.79964358835883, -6.468376856628838],
            [4.804660940459565, -6.465810964811659],
            [4.807781957580923, -6.466996699463117],
            [4.811573295954891, -6.465816745542246],
            [4.818401570379617, -6.467272706989782],
            [4.816896908940171, -6.47338897424679],
            [4.817369775729025, -6.479308087280288],
            [4.821692752091058, -6.4851036723373054],
            [4.826547721747177, -6.48639274435619],
            [4.827255923951567, -6.483878119487315],
            [4.832592232559663, -6.479757169830511],
            [4.83617207171741, -6.47224477118614],
            [4.839095418814812, -6.4704085993019085],
            [4.843383344129158, -6.475545077040117],
            [4.848936263397058, -6.4745465301198575],
            [4.847944033004552, -6.470938058119025],
            [4.852617809142314, -6.468997964346948],
            [4.862991273852864, -6.467689271441718],
            [4.866103791440045, -6.4645144606078695],
            [4.86924861847756, -6.458307082043899],
            [4.866878767068061, -6.4560793285093],
            [4.861821876816439, -6.458957529988704],
            [4.861676362389476, -6.455080656659766],
            [4.857063031612219, -6.450120582090217],
            [4.852699567071943, -6.450159759005507],
            [4.849040342020536, -6.447723733636295],
            [4.848574466799219, -6.444281283944134],
            [4.851811859967409, -6.442856392063873],
            [4.851407153087014, -6.439271518983485],
            [4.854751622781435, -6.437286474365571],
            [4.857598626439456, -6.432699680875976],
            [4.862629708955349, -6.4292786426798525],
            [4.8698973014866125, -6.429669968534594],
            [4.8702298262549935, -6.425284329031446],
            [4.876053766325604, -6.427089640057087],
            [4.878813962344328, -6.424745386520894],
            [4.877313693681196, -6.414686143226128],
            [4.879934236255697, -6.412583482328667],
            [4.8836284827288345, -6.417185263502756],
            [4.8890345611373665, -6.412284103400399],
            [4.891626267956976, -6.407932706130274],
            [4.889307186045167, -6.404744057272759],
            [4.893644266462286, -6.401055670739729],
            [4.894974236874949, -6.3944384408697],
            [4.897884176317636, -6.394624098002582],
            [4.904318038349236, -6.464751653786996],
            [4.905231025571741, -6.471951696566331],
            [4.916427914076253, -6.570393358136068],
            [4.923655694359906, -6.640696198049029],
            [4.9233037477532955, -6.656114765066891],
            [4.92402024957592, -6.678669460562227],
            [4.926068339302871, -6.713954153505427],
            [4.929075913735314, -6.77335426822763],
            [4.916197899313067, -6.7886579754277685],
            [4.914766269719925, -6.803205275841605],
            [4.915864035075474, -6.832471932235877],
            [4.817568540886293, -6.83853381245704],
            [4.817794253548041, -6.8334947697987145],
            [4.820878753865099, -6.830792704520771],
            [4.822565301587166, -6.825649801543485],
            [4.826955950644143, -6.81917026368476],
            [4.824245425421628, -6.814708715539729],
            [4.823664592242813, -6.805390439573342],
            [4.824335710182206, -6.797140108264439],
            [4.797150181821865, -6.792492503128374],
            [4.796012690454069, -6.791916150991634],
            [4.695060198751431, -6.773156808393972],
            [4.677473156823868, -6.769613452527534],
            [4.607092696397948, -6.769583741322035],
            [4.582574050552382, -6.770025089812791],
            [4.555598837762443, -6.770092979932619],
            [4.52103488705124, -6.770553241368984],
            [4.479101850574616, -6.771726816950422],
            [4.489931455073374, -6.764180967894404],
            [4.4962256947069825, -6.755634206286731],
            [4.510761801683049, -6.739569501801278],
            [4.516903565665089, -6.730570256073636],
            [4.523941253352814, -6.7292177255673415],
            [4.526601947809816, -6.724987880870192],
            [4.531568097887877, -6.722839683763425],
            [4.533141471955589, -6.718864079113869],
            [4.529746991252064, -6.715338516182667],
            [4.530281117733697, -6.70592111633144],
            [4.529340836473152, -6.704070153245005],
            [4.52398759491808, -6.705238770807811],
            [4.5221398463112905, -6.703833008808896],
            [4.524717223016256, -6.693012618974113],
            [4.524987061295564, -6.678410935971814],
            [4.533552419524544, -6.665689752216634],
            [4.544038524494297, -6.655866749025788],
            [4.5834313306591365, -6.6493676314193735],
            [4.594473419113247, -6.645505028082701],
            [4.600983952015165, -6.640674116366789],
            [4.605768982618348, -6.635131664321035],
            [4.616867504003476, -6.617898956945158],
            [4.613402578456986, -6.61659012310871],
            [4.612393833722899, -6.61150461385479],
            [4.608944863708427, -6.6036858627857224],
            [4.60567184418262, -6.600856488927102],
            [4.5992818770041195, -6.598185943542991],
            [4.557026389911946, -6.591247045371329],
            [4.547279299802703, -6.585644197267975],
            [4.542704546972767, -6.578778885076768],
            [4.542042837474968, -6.570816555691483],
            [4.546528116504399, -6.562792250729648],
            [4.552186897776678, -6.5579068327155765],
            [4.560104903285156, -6.555905103042544],
            [4.569382199977571, -6.5606311322024915],
            [4.573413705999772, -6.565123992843732],
            [4.582368607162282, -6.5782607717473836],
            [4.591711299421275, -6.585779549762082],
            [4.596021386164478, -6.587457885310073],
            [4.60987748948829, -6.587545910459258],
            [4.612432605384192, -6.5847154977166085],
            [4.6089171508893285, -6.559406328353065],
            [4.610171851610678, -6.555942766900341],
            [4.6440303601190935, -6.535097224655238],
            [4.6471664835073705, -6.532135896398875],
            [4.6503289871581845, -6.524872732404829],
            [4.6498362860984015, -6.518715354432691]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.91171078187266,
          "lat": 31.973624019773307
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28021"],
        "coty_name": ["Claiborne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Claiborne County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00695735"
      },
      "bbox": [
        4.479101850574616, -6.83853381245704, 4.929075913735314,
        -6.3944384408697
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.443047546985592, -4.43596181237178],
            [6.442126798025126, -4.4211005650239645],
            [6.470665203967734, -4.4190462416690774],
            [6.51286657516129, -4.415725004620198],
            [6.521195806648728, -4.41535562537623],
            [6.5858235638112985, -4.410268415761723],
            [6.626499504479949, -4.407005929880854],
            [6.701992279035608, -4.402645016924756],
            [6.7251902458331525, -4.400524421728146],
            [6.84030870359064, -4.3921201552317095],
            [6.864210486660235, -4.39045769070463],
            [6.863717624873123, -4.41894679955899],
            [6.863242942819726, -4.4483523561897345],
            [6.859994597426343, -4.567182978492048],
            [6.857916178003979, -4.632186568797967],
            [6.857151928151749, -4.668842231111383],
            [6.855957749670964, -4.68425021835443],
            [6.856189429845277, -4.698340630563504],
            [6.855257254799804, -4.735381387636008],
            [6.854368963903019, -4.735625641840414],
            [6.7985064377687845, -4.739976985834493],
            [6.792270900097576, -4.742986797091758],
            [6.790380152900234, -4.7456207387373786],
            [6.792351447517297, -4.752609088552541],
            [6.790771077768285, -4.756753703629285],
            [6.793198148345531, -4.759854138218692],
            [6.790266472348061, -4.764316057859647],
            [6.790305407592197, -4.767205135974374],
            [6.7841834258749305, -4.769173562896777],
            [6.77966501458108, -4.777061577727595],
            [6.780486932384654, -4.7806307038310445],
            [6.776126192585135, -4.785751456353327],
            [6.771427201571591, -4.788480317518745],
            [6.766689338966346, -4.793305412086923],
            [6.76458255246445, -4.798524238076372],
            [6.759812872970021, -4.799795858445574],
            [6.75688764578359, -4.803559519694667],
            [6.752496384860513, -4.802919441608144],
            [6.748079931488182, -4.79974374408229],
            [6.748260862888694, -4.795962409809402],
            [6.739730365591186, -4.797561863270471],
            [6.736403810209106, -4.799899818932796],
            [6.737711122533008, -4.805169164647673],
            [6.733531307987172, -4.807960703421657],
            [6.73131956296479, -4.817507005682399],
            [6.728028281410246, -4.8140844751053775],
            [6.725106435646012, -4.814011338762877],
            [6.722567483526069, -4.82199547395713],
            [6.7155580748339565, -4.8166707087887035],
            [6.709562568979062, -4.82471179403313],
            [6.70197244006479, -4.823702936077139],
            [6.697919417012581, -4.825731156014993],
            [6.693040435767145, -4.8253388873369385],
            [6.691353367595254, -4.8303937508903045],
            [6.687110449043272, -4.831690375054845],
            [6.685532726263638, -4.828039950187058],
            [6.68112009577964, -4.827434834125043],
            [6.679740299455782, -4.831757300656033],
            [6.6735464520802985, -4.828990201641727],
            [6.668838207640953, -4.830117231396558],
            [6.663174746522046, -4.835321111456498],
            [6.65770401280694, -4.83508809159814],
            [6.652159910185961, -4.8386739121517595],
            [6.644725623971836, -4.847655814925759],
            [6.644564264399456, -4.837110307657677],
            [6.653335656123539, -4.830891967748178],
            [6.653317956457679, -4.822969280969121],
            [6.661756785237914, -4.822639242175265],
            [6.6609121431707905, -4.81912278658698],
            [6.653797960209954, -4.817006660052624],
            [6.557802476871459, -4.82404655387403],
            [6.550822562157265, -4.824908768501382],
            [6.530423143050366, -4.826338594459337],
            [6.47290060905178, -4.830739867890145],
            [6.464164241173319, -4.717747237198131],
            [6.462506600929791, -4.699573727943935],
            [6.4561852610634745, -4.620527823780191],
            [6.452605804095266, -4.572566606987439],
            [6.449173905186128, -4.524547989135676],
            [6.445142705452947, -4.474745905135875],
            [6.443047546985592, -4.43596181237178]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.48047286727243,
          "lat": 33.892265232964725
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28095"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00695771"
      },
      "bbox": [
        6.442126798025126, -4.847655814925759, 6.864210486660235,
        -4.39045769070463
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.015224047587193, -1.26147474238585],
            [5.028183717180713, -1.2618697482020382],
            [5.071972258544982, -1.2609061004712978],
            [5.070321209098818, -1.2303184550996513],
            [5.068486946676325, -1.2058134743265492],
            [5.066420827621524, -1.1685756745640001],
            [5.066551142889173, -1.1664080995441468],
            [5.064031384611676, -1.1066325471389498],
            [5.06190284443629, -1.0750209311874943],
            [5.063607902128304, -1.0712974528244612],
            [5.063343598251426, -1.0296741644061111],
            [5.053402151164164, -0.9734219255845213],
            [5.0703548053625385, -0.9722655388202648],
            [5.096421298423961, -0.9699003088191778],
            [5.168132147117962, -0.9656809343904866],
            [5.175559162374498, -0.9649845436287177],
            [5.27695425198607, -0.9574282277797865],
            [5.2815100027838415, -1.0318675504645556],
            [5.2829060530343375, -1.0582687243212225],
            [5.282601502688005, -1.061107109251988],
            [5.285918258341842, -1.1108049754844342],
            [5.288598126838917, -1.155357927235812],
            [5.290926351178403, -1.1885260482399571],
            [5.293846958322343, -1.2483232529131496],
            [5.294909985530854, -1.2482717301599449],
            [5.298644044311139, -1.3106151529383807],
            [5.30005595952124, -1.3406298388941456],
            [5.297273895251198, -1.340870313839908],
            [5.303449379667156, -1.4342904763803928],
            [5.230140819048906, -1.4379545873154016],
            [5.235112113749121, -1.5113420191153717],
            [5.206175188968249, -1.512819406839402],
            [5.207211516658164, -1.5275441547036708],
            [5.1159929568988165, -1.5321493755870768],
            [5.113904593787729, -1.4871080446820975],
            [5.102262275372486, -1.4880547901547654],
            [5.067217012664026, -1.4897880681002662],
            [5.053642174426897, -1.4899680803704256],
            [5.024854555128406, -1.4919231189542257],
            [5.023548758669612, -1.4617518959350544],
            [5.023730212354599, -1.4530247311087328],
            [5.022009682229663, -1.409849391874796],
            [5.018016631719702, -1.3277490512011914],
            [5.018030838117524, -1.3223556304983446],
            [5.01669872815156, -1.2980001063510191],
            [5.015224047587193, -1.26147474238585]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.02593016439488,
          "lat": 37.322179764659374
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29017"],
        "coty_name": ["Bollinger"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bollinger County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00758463"
      },
      "bbox": [
        5.015224047587193, -1.5321493755870768, 5.303449379667156,
        -0.9574282277797865
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.524414569945995, 1.67941075188859],
            [3.5240327479773166, 1.7085540606410055],
            [3.522940182688718, 1.767095908841738],
            [3.521481462875069, 1.825757920107948],
            [3.5195593750781784, 1.884593291763849],
            [3.5162945755612287, 1.9868847595825605],
            [3.519154749453296, 1.9873179698258452],
            [3.572378552101194, 1.9915380379481555],
            [3.6050492068719153, 1.9951170525422368],
            [3.6271532436520477, 1.997009763723284],
            [3.676855849794116, 2.0017880284792073],
            [3.6842151198564266, 1.989895933105899],
            [3.6868244686837954, 1.9869891903301484],
            [3.690550352413172, 1.983641448552697],
            [3.7026463284730093, 1.977227248007027],
            [3.7085330250204454, 1.972711736603016],
            [3.7111655649304693, 1.9661465761671184],
            [3.7073220108618368, 1.9539449720892275],
            [3.708115920008755, 1.9489613226873679],
            [3.715269242414726, 1.9423650172957234],
            [3.723432591278615, 1.9406191219610904],
            [3.7360402173655247, 1.9394304476812305],
            [3.748446579986162, 1.9363172023813007],
            [3.7582645047702936, 1.9347086735600438],
            [3.7631068483342673, 1.9304749519073185],
            [3.7640725669407202, 1.9254187380163217],
            [3.763856777252536, 1.917593099797925],
            [3.7617247613479794, 1.9081631470639342],
            [3.7626830941048377, 1.9011746401062293],
            [3.7662449895061667, 1.8960118149549121],
            [3.7729425055600383, 1.8915228223100318],
            [3.7834963342668195, 1.8869213644860046],
            [3.789703398140114, 1.8793729647444792],
            [3.7953809775634255, 1.8632672549568672],
            [3.7998573772611044, 1.8580744772736197],
            [3.8082903265207486, 1.853747841274658],
            [3.8167974843846806, 1.8519056674532675],
            [3.823536579354583, 1.8515955640740784],
            [3.8349365210656288, 1.8529921029557745],
            [3.838631426900556, 1.8504699451262594],
            [3.8388639273789926, 1.842512597479025],
            [3.8320711580345272, 1.8344880618286206],
            [3.8328201083749236, 1.8304653738899601],
            [3.835708850782304, 1.8280655424854146],
            [3.842668651780519, 1.827788692196234],
            [3.8434771962229637, 1.825429392973121],
            [3.838334518812353, 1.8136531072948479],
            [3.8387395331947665, 1.8071429865671462],
            [3.840231621978402, 1.8045492653993627],
            [3.852144101178338, 1.8010835029967434],
            [3.855157891968972, 1.7979320546229158],
            [3.8606463922522822, 1.7965908332503333],
            [3.868292381557571, 1.7989119258143642],
            [3.8664156319661336, 1.788342180197429],
            [3.871753660154106, 1.7789204652030752],
            [3.8750649318131196, 1.77694073043207],
            [3.8812597363320496, 1.7783471657451235],
            [3.886312401130293, 1.7809837519218508],
            [3.8879606843159227, 1.779834844645438],
            [3.886059514767228, 1.7740139551441778],
            [3.8876951854729063, 1.7713601997667978],
            [3.896930915630054, 1.772165148397407],
            [3.9014866218560944, 1.775784553335232],
            [3.9014912057071918, 1.7788871139981073],
            [3.9042677981847436, 1.782850484781163],
            [3.9162005226508985, 1.779624036456325],
            [3.921111935953661, 1.7755932379598092],
            [3.9159786647080614, 1.7690099238117039],
            [3.9066540476677667, 1.763090869476156],
            [3.9026762690423302, 1.7594685229042966],
            [3.8975493032729585, 1.7496319528511401],
            [3.8906196820983423, 1.737936738088285],
            [3.887634469410728, 1.7297649259882317],
            [3.8859097796114037, 1.717514887494319],
            [3.884515392935164, 1.7123306728346357],
            [3.874902401957247, 1.6877289375814097],
            [3.8706089763920963, 1.6721693278150505],
            [3.870881796407222, 1.6638081114347711],
            [3.8729135126413263, 1.658746092749022],
            [3.8731686591746324, 1.6533907391112854],
            [3.86859017944043, 1.6423328831365749],
            [3.830459903763476, 1.6411939551549815],
            [3.779204994820465, 1.64011390828852],
            [3.765777857939828, 1.6402093630000636],
            [3.7547202651585363, 1.6396616331383724],
            [3.698350511366608, 1.638862491695094],
            [3.6928608164415646, 1.6391021734887987],
            [3.6535889745721066, 1.6387431123506937],
            [3.61316112599889, 1.6376743868242265],
            [3.61094736375013, 1.637103915921896],
            [3.57621818259336, 1.6362038754986146],
            [3.5254847848329036, 1.6354222495471111],
            [3.524414569945995, 1.67941075188859]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.7383667734393, "lat": 40.410327242989354 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29045"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00758477"
      },
      "bbox": [
        3.5162945755612287, 1.6354222495471111, 3.921111935953661,
        2.0017880284792073
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.06693987687601, -0.4086860070182197],
            [4.067106661096076, -0.41446882576867944],
            [4.126548240407777, -0.4115646932521084],
            [4.15427800701374, -0.4100359155869997],
            [4.22115568506534, -0.40674121173361044],
            [4.255557567233058, -0.4048032645133337],
            [4.278395248244213, -0.4037891449368927],
            [4.282535052284773, -0.48349138934446706],
            [4.283335544893734, -0.49119632520390877],
            [4.285885861967229, -0.5268646509017083],
            [4.287435984193077, -0.5584105761906232],
            [4.290370394150544, -0.608237660570586],
            [4.293307712154403, -0.6914457800109056],
            [4.294243103488297, -0.707101849082513],
            [4.295292058316007, -0.7398667280970526],
            [4.295923387890915, -0.7707116262479753],
            [4.299240444679713, -0.8719370592959939],
            [4.262829685871985, -0.8729989200153577],
            [4.2647247895389135, -0.9169954783860155],
            [4.259730354644671, -0.9171069581767921],
            [4.1651883737638125, -0.919831290683487],
            [4.136489043065414, -0.9205562536183883],
            [4.135259035886703, -0.8828053280740179],
            [4.133981473074488, -0.8325892795537417],
            [4.047585711604402, -0.8355269578149382],
            [3.9615431987543643, -0.8390843556410523],
            [3.958523846795986, -0.7538311738598054],
            [3.9561803388513352, -0.6852450387265712],
            [3.9531596939550426, -0.6144395844501743],
            [3.9505232872742395, -0.5475445700473678],
            [3.9486019760883715, -0.5014207367251614],
            [3.9472179019700553, -0.4723617784363626],
            [3.9399303062100843, -0.47254304118189905],
            [3.9364255655471756, -0.4137286880436138],
            [3.9870456184904355, -0.4114095848873895],
            [4.010486424029892, -0.41079231254325066],
            [4.02227515892401, -0.4089323408793711],
            [4.026982193083683, -0.4102309806545534],
            [4.06693987687601, -0.4086860070182197]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.30394512770104,
          "lat": 37.976359847391095
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29055"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00758482"
      },
      "bbox": [
        3.9364255655471756, -0.9205562536183883, 4.299240444679713,
        -0.4037891449368927
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9735292978758916, -1.3500547872779445],
            [1.973961574455291, -1.3210148970821358],
            [1.9741300361252372, -1.233108344605364],
            [1.9741395425344583, -1.1445940785085473],
            [1.9740519138926431, -1.1154969487150572],
            [1.9812777505196526, -1.1157077629006098],
            [2.0748232490561715, -1.1156009396679607],
            [2.160696148859287, -1.1149186014922914],
            [2.2106816692095577, -1.115307727382334],
            [2.2631046528071868, -1.1160237360010459],
            [2.303429277025962, -1.116291336967896],
            [2.3346778986238315, -1.1162917063796152],
            [2.3342105304801826, -1.2337967931539375],
            [2.3343316696356444, -1.263004174320076],
            [2.334152045233455, -1.307131917499646],
            [2.334318955881799, -1.3218248136920472],
            [2.334166467723723, -1.36607256846744],
            [2.3343583100100247, -1.3666877908443062],
            [2.3343111703136588, -1.409844185745928],
            [2.2964417046462966, -1.4098414055417858],
            [2.273135227224442, -1.4095942640662893],
            [2.247892469659207, -1.409700061861825],
            [2.1676319904808095, -1.4093578240343183],
            [2.0827160955140402, -1.4098119222241874],
            [1.9981862596879005, -1.4093399811061946],
            [1.973341515665286, -1.4090644377034978],
            [1.9735292978758916, -1.3500547872779445]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.85025172861901, "lat": 37.43206277137979 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29057"],
        "coty_name": ["Dade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dade County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00758483"
      },
      "bbox": [
        1.973341515665286, -1.409844185745928, 2.3346778986238315,
        -1.1149186014922914
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.276109963605457, -2.181706690787312],
            [5.290141299085783, -2.1821364562088683],
            [5.297159885757989, -2.181638081031875],
            [5.314369850216395, -2.1816430206014195],
            [5.329301423477737, -2.1808575611723313],
            [5.368985120110937, -2.1779475393982106],
            [5.397696145869371, -2.176205765248948],
            [5.411417820112837, -2.1758458187433094],
            [5.429989187077777, -2.17462045151465],
            [5.4308477453193795, -2.1708661848568984],
            [5.4344280095118735, -2.1713640454873175],
            [5.4374271021076765, -2.174712313872248],
            [5.442720200734642, -2.173363487675144],
            [5.4444478105546095, -2.162579427879092],
            [5.441575478592509, -2.157115248699234],
            [5.446551288912262, -2.155033760731935],
            [5.445840980377443, -2.1498478464982282],
            [5.446147876231981, -2.140763367516537],
            [5.447180100040815, -2.137034661241144],
            [5.451235560113701, -2.132796275789873],
            [5.456823266084123, -2.1307190840977466],
            [5.46120590885726, -2.130883594412249],
            [5.469001420774247, -2.1343444039656303],
            [5.47895251323275, -2.1374229747994935],
            [5.485555255565661, -2.140210045069526],
            [5.4929353957137375, -2.1498308029995723],
            [5.500952458684301, -2.1544738032768023],
            [5.514762619924868, -2.1559927415183067],
            [5.521809784015616, -2.155282388124705],
            [5.53119604697292, -2.1529406852398734],
            [5.543075955751863, -2.1465702692213138],
            [5.548188618544973, -2.1427023405843713],
            [5.553338699400772, -2.140915290962612],
            [5.568729414282299, -2.1473672677786615],
            [5.576967933578188, -2.1678176983175215],
            [5.587420116793929, -2.176824961284998],
            [5.594174111112803, -2.1802316893962717],
            [5.594375732814882, -2.1828133757511576],
            [5.601743669828119, -2.1821235461225506],
            [5.6020525991956065, -2.1893972770729637],
            [5.609288933953465, -2.1889138570449544],
            [5.6109402428503135, -2.2122445026181405],
            [5.598588820890136, -2.212135700146745],
            [5.581398178817175, -2.2086376741504288],
            [5.56630212905212, -2.2090215040120036],
            [5.558397720343885, -2.2121246354392836],
            [5.554591048046633, -2.2167854372084728],
            [5.551881580288233, -2.2235781998332858],
            [5.551962072435008, -2.2301844273464804],
            [5.559623738103991, -2.2437397429240273],
            [5.577980865380313, -2.254911141824003],
            [5.587584010100187, -2.262852369199148],
            [5.607589249732522, -2.272178801670497],
            [5.614967032851681, -2.2689410628474396],
            [5.61940972154432, -2.2717628252481483],
            [5.623031799363688, -2.2784181376808457],
            [5.624445814459654, -2.2871565425429856],
            [5.624889142454886, -2.29645325623423],
            [5.621572581641504, -2.300474978303164],
            [5.617268950121859, -2.3021192148397045],
            [5.6064657811550225, -2.2992609612238994],
            [5.600947610242076, -2.300615628271224],
            [5.594253115678757, -2.307360717837162],
            [5.583869181422427, -2.3124689951318946],
            [5.571966001977369, -2.314664708343779],
            [5.564894310948805, -2.3139630756273104],
            [5.554041110674966, -2.310614593423192],
            [5.543854036763058, -2.30647196090993],
            [5.531140154388708, -2.3046813562770536],
            [5.5109520107936225, -2.3084618871360414],
            [5.504346680602963, -2.307665030479472],
            [5.496949226540447, -2.3048621868704733],
            [5.49443778533812, -2.307227355028995],
            [5.489763214897093, -2.3183457501486213],
            [5.490047859287221, -2.321692797514984],
            [5.50088711839723, -2.3327078733400617],
            [5.511926080653077, -2.34111957271344],
            [5.524842581653358, -2.3497512157413767],
            [5.5325709041989, -2.354279090317962],
            [5.547764680374699, -2.3659772049302763],
            [5.553942306386672, -2.369170564169594],
            [5.563263841213664, -2.374019174006486],
            [5.572815288841673, -2.38225854348671],
            [5.578158792519185, -2.388591040426471],
            [5.5839438633427525, -2.397400088472754],
            [5.586055453877027, -2.4026520938939244],
            [5.5871232969967775, -2.417218743458404],
            [5.586182281477017, -2.425819890982799],
            [5.580370141073653, -2.4340143915382355],
            [5.570219270279055, -2.440411945672578],
            [5.560167206143414, -2.4481243329239377],
            [5.548633020891364, -2.4521646287073886],
            [5.530326594449882, -2.4612887115265605],
            [5.525907890380402, -2.465590327083833],
            [5.520490447879729, -2.4753931441115946],
            [5.519639915470005, -2.4857153750706646],
            [5.51902958646803, -2.506591000931702],
            [5.517963369203855, -2.524519268379417],
            [5.514726084175204, -2.538417814330081],
            [5.506656193294184, -2.5515510671815536],
            [5.504439629589271, -2.5588309308612063],
            [5.483556340515383, -2.5603852277651202],
            [5.369630889099148, -2.5690748342606335],
            [5.302636850749228, -2.573911394892949],
            [5.302678918573418, -2.57167193823625],
            [5.293943681522306, -2.439713032352028],
            [5.292618561415001, -2.4163551460857176],
            [5.285893315731861, -2.33637970185738],
            [5.281879651125406, -2.27718859198925],
            [5.281610854925627, -2.262400315205384],
            [5.276109963605457, -2.181706690787312]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.78540809397313, "lat": 36.21139921980278 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29155"],
        "coty_name": ["Pemiscot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pemiscot County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00758532"
      },
      "bbox": [
        5.276109963605457, -2.573911394892949, 5.624889142454886,
        -2.1307190840977466
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.9662805456110006, 3.2056654890922642],
            [-3.8693812967198573, 3.1995347977729143],
            [-3.8329358145885917, 3.1971619207776922],
            [-3.8305912564149502, 3.197353386743448],
            [-3.7524599270109817, 3.1929755127877657],
            [-3.71099423925942, 3.1902102272420403],
            [-3.552534829325025, 3.1816108948573523],
            [-3.5381424334080482, 3.1809331653115995],
            [-3.5433391732515402, 3.0934192651495427],
            [-3.5457132017904525, 3.0475303532290114],
            [-3.548298742329836, 3.0058409712434306],
            [-3.556103597725825, 2.8747831569499733],
            [-3.5586571225333943, 2.831558553674348],
            [-3.6563420607438313, 2.8371093720684826],
            [-3.7132354209358183, 2.8405039895414297],
            [-3.7985876388501882, 2.8454054496633474],
            [-3.8930905618985796, 2.851138080326432],
            [-3.9875943557392235, 2.8568562460192997],
            [-3.9771899638233266, 3.0255577928824398],
            [-3.976968351711831, 3.036819405231323],
            [-3.9760349757963342, 3.0426599570846338],
            [-3.9662805456110006, 3.2056654890922642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.69581025442075,
          "lat": 41.56897442500189
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31005"],
        "coty_name": ["Arthur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Arthur County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00835825"
      },
      "bbox": [
        -3.9875943557392235, 2.831558553674348, -3.5381424334080482,
        3.2056654890922642
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9027999520999714, 4.368195349764271],
            [-1.8597288325180323, 4.366704730842184],
            [-1.8351394622813155, 4.366243690035676],
            [-1.816661783942083, 4.3654685724385995],
            [-1.734040436237222, 4.362734507013244],
            [-1.6591159336116568, 4.360402633640811],
            [-1.6450963365469424, 4.359855182529204],
            [-1.573383038176305, 4.357829249333578],
            [-1.4747260382794767, 4.355295199739195],
            [-1.3532640882319567, 4.352028186162179],
            [-1.3515041194205817, 4.341421956175286],
            [-1.34794199527739, 4.331213698107286],
            [-1.3399096568956341, 4.316550363526416],
            [-1.331915592511527, 4.300309395738328],
            [-1.3255916377303365, 4.295950613227065],
            [-1.3174607372516531, 4.287457869174995],
            [-1.3167140138750648, 4.2829272112169186],
            [-1.312324018809789, 4.280381835023939],
            [-1.3058276081940485, 4.283535483913504],
            [-1.2983978656838018, 4.2837676924455295],
            [-1.2891551798640222, 4.277339600520759],
            [-1.2737799690911251, 4.269586006764066],
            [-1.2658420200066323, 4.264095485234072],
            [-1.2533799843409412, 4.258151594894593],
            [-1.242159332880356, 4.251183935822795],
            [-1.2375097540610576, 4.245859660872918],
            [-1.2359010440850595, 4.241684590208327],
            [-1.230466373730231, 4.2365029831286005],
            [-1.2188411311336225, 4.232266716072709],
            [-1.2195483427304052, 4.219546561135241],
            [-1.221577797916066, 4.134050073949913],
            [-1.2177932882920763, 4.133983498344672],
            [-1.2184365096986016, 4.110477234990412],
            [-1.2257617967419685, 4.113072765054906],
            [-1.2287406972691597, 4.115858193142129],
            [-1.2440710543830753, 4.120591109265508],
            [-1.2503964225117294, 4.120839137082907],
            [-1.2581996118244854, 4.117903505144232],
            [-1.2680949853508858, 4.119515346056907],
            [-1.2732116058433263, 4.122874877562733],
            [-1.2767568955776103, 4.122961550073867],
            [-1.2857157987387473, 4.125512986401987],
            [-1.298961045729172, 4.126992816120166],
            [-1.3082436066444167, 4.126266305428721],
            [-1.3122304266731197, 4.121092631797497],
            [-1.3164971800173757, 4.1223660680944185],
            [-1.3208219509748544, 4.121894813960665],
            [-1.3334227887964754, 4.11838024459644],
            [-1.3382515434087643, 4.119371458828299],
            [-1.3426912568303389, 4.122535978370511],
            [-1.346535815300761, 4.122850789145966],
            [-1.353663393194227, 4.125818059480788],
            [-1.3647820497392822, 4.126062486873546],
            [-1.3684935343168585, 4.127864520764672],
            [-1.3739038863787707, 4.126350222733193],
            [-1.3783514603379132, 4.129446963485768],
            [-1.382993568430974, 4.128114766963812],
            [-1.3860165580761241, 4.13107680106668],
            [-1.3954097162568204, 4.135502825340287],
            [-1.40258437601701, 4.13547330284459],
            [-1.4092749051473512, 4.133082798670723],
            [-1.4211981287843902, 4.134277366969551],
            [-1.429190384252517, 4.139239109246369],
            [-1.4350273417054016, 4.144114706455612],
            [-1.4472860478992355, 4.150414633448118],
            [-1.4536797485779587, 4.152002940999467],
            [-1.4567119306628311, 4.1561987130051845],
            [-1.4609219719740334, 4.15935127893434],
            [-1.4736716779179728, 4.165113319571509],
            [-1.4787776695153638, 4.163391118668169],
            [-1.4868163143725202, 4.159137002997042],
            [-1.4976174682543721, 4.161045946360871],
            [-1.511411789052793, 4.160480235204306],
            [-1.5218734461123913, 4.165344144200377],
            [-1.5309686602464616, 4.173619905664133],
            [-1.5365088689346873, 4.176264239949905],
            [-1.541471022629742, 4.1803375515053105],
            [-1.5506782759965687, 4.186250371240844],
            [-1.562109364666993, 4.186066995420118],
            [-1.5700618105406507, 4.183409954741602],
            [-1.5755242523865496, 4.183427603293918],
            [-1.585708208037824, 4.187121658561476],
            [-1.5907387193789437, 4.189686023821501],
            [-1.5938380465648383, 4.19345505306102],
            [-1.6061422902330267, 4.205634134117127],
            [-1.609927457272068, 4.206472667779515],
            [-1.6163091082737646, 4.203518283188254],
            [-1.6248244745442741, 4.203702633009667],
            [-1.6337766531123084, 4.202039525787687],
            [-1.6367297567604593, 4.202394749206569],
            [-1.6445985452335454, 4.206995909474821],
            [-1.6498871887381632, 4.215953180838153],
            [-1.659184602336388, 4.223171541898898],
            [-1.6688532596731966, 4.237047878665551],
            [-1.6728115471196559, 4.2409328211681],
            [-1.6776280919307334, 4.242136963188469],
            [-1.6790430964604428, 4.2464274891105305],
            [-1.6818579027456493, 4.247391519442826],
            [-1.6881064596739435, 4.256787000118248],
            [-1.6933999931072428, 4.258962328237767],
            [-1.7083397260697728, 4.259784627878847],
            [-1.7186735713482837, 4.25701413660985],
            [-1.7233924447658477, 4.251863223139285],
            [-1.7260435585801577, 4.2526111546454475],
            [-1.7336102487262643, 4.250370658141547],
            [-1.7444378883573561, 4.24117873832145],
            [-1.7610820831508016, 4.231216922477218],
            [-1.7634773475872274, 4.227571397463415],
            [-1.7710243955696732, 4.227507857087791],
            [-1.77618450188038, 4.2254612092079515],
            [-1.7857520768068806, 4.223997190207508],
            [-1.7924786251482925, 4.222171092594484],
            [-1.8104262156686344, 4.2148529592516715],
            [-1.8159999220902587, 4.210884564949322],
            [-1.827066150595338, 4.208994522020849],
            [-1.8348504257007465, 4.209111269768543],
            [-1.8439712564766664, 4.204852982457495],
            [-1.8534882498304095, 4.1972796297342265],
            [-1.8621038136933712, 4.195695668350482],
            [-1.8747653551840713, 4.191542731060833],
            [-1.8881922900677748, 4.1832160297399685],
            [-1.8989073771177767, 4.180578305134951],
            [-1.9076718655731006, 4.1773716384393245],
            [-1.9113584977858111, 4.17395607233112],
            [-1.908384402490251, 4.2719002455438035],
            [-1.9056555851316646, 4.274690172188459],
            [-1.9027999520999714, 4.368195349764271]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.76653660673952, "lat": 42.89970661249081 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31015"],
        "coty_name": ["Boyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boyd County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00835829"
      },
      "bbox": [
        -1.9113584977858111, 4.110477234990412, -1.2177932882920763,
        4.368195349764271
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9374519899915634, 1.7046346982704363],
            [-1.8522096807563244, 1.7017099252572723],
            [-1.7381586621806062, 1.6979638163044806],
            [-1.6365057084719026, 1.694862586295827],
            [-1.5957611416392, 1.6937336856413827],
            [-1.597301959077656, 1.6347182756637932],
            [-1.598578174328173, 1.5766040938552783],
            [-1.6018829089954774, 1.4594779328958638],
            [-1.60277040454528, 1.4451207429599435],
            [-1.602718890626055, 1.4305335381756994],
            [-1.6046316604616548, 1.3630891406953145],
            [-1.6054950400568102, 1.3426731995385888],
            [-1.6874983630017666, 1.3452142844183534],
            [-1.7636304952624529, 1.3473655326568237],
            [-1.8639539337519395, 1.350498283149519],
            [-1.8992224074469073, 1.351668021176932],
            [-1.9490158902136328, 1.353098492400973],
            [-1.9460873061481925, 1.4410461882724006],
            [-1.9424960749253473, 1.5506179128489785],
            [-1.9403061244811304, 1.616760243189347],
            [-1.9374519899915634, 1.7046346982704363]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.95280586358425,
          "lat": 40.176319168221724
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31061"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00835852"
      },
      "bbox": [
        -1.9490158902136328, 1.3426731995385888, -1.5957611416392,
        1.7046346982704363
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.522515291723276, 2.9684465122424597],
            [-5.516804026598618, 2.96777952175164],
            [-5.471228471335998, 2.9641529326981813],
            [-5.36121534316091, 2.9551539461475023],
            [-5.333232556813544, 2.9525516775372465],
            [-5.163332320485952, 2.9395819692245166],
            [-5.113072092499373, 2.9363115204619237],
            [-5.106843644036879, 2.935067662444014],
            [-5.0740981203543605, 2.932367904413475],
            [-5.021895020041351, 2.929207209082123],
            [-5.0275902468973905, 2.8557614307736205],
            [-5.027312532939558, 2.8402649878422848],
            [-5.029049698807642, 2.822186933030138],
            [-5.034424777791611, 2.754003120786165],
            [-5.047583182043805, 2.5807368891137834],
            [-5.0526504373935115, 2.581178182074854],
            [-5.056206586290335, 2.5355472529077927],
            [-5.066999843821619, 2.536716576949158],
            [-5.085685831710738, 2.5376181135075244],
            [-5.133986284346009, 2.5413164417795233],
            [-5.142029450509161, 2.5416692392524842],
            [-5.198971342171543, 2.5462750103555147],
            [-5.330786142125657, 2.55725142965392],
            [-5.411342174631236, 2.5634975563281133],
            [-5.439499969410966, 2.5659040680381766],
            [-5.4470764537103555, 2.5661678276211304],
            [-5.482264432809679, 2.5693188618833287],
            [-5.530516122143584, 2.57339983232322],
            [-5.534341510586038, 2.573996044143012],
            [-5.556656276441772, 2.5753996714605933],
            [-5.5551230725120915, 2.592090107871653],
            [-5.546929988731617, 2.6888487979110303],
            [-5.5435550343579525, 2.731819398069153],
            [-5.532857998999933, 2.8501473619105178],
            [-5.5324480382855405, 2.8530942842436104],
            [-5.528154881664822, 2.9056389628600066],
            [-5.522515291723276, 2.9684465122424597]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.71488666070321,
          "lat": 41.19776788546654
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31105"],
        "coty_name": ["Kimball"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kimball County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00835874"
      },
      "bbox": [
        -5.556656276441772, 2.5355472529077927, -5.021895020041351,
        2.9684465122424597
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.370675289060266, 6.659884236970794],
            [17.36429285486397, 6.669814906191777],
            [17.362327227479234, 6.678244077402635],
            [17.363390291197373, 6.684255491829777],
            [17.371745586596397, 6.691463548260122],
            [17.374094817693102, 6.700222879289853],
            [17.37659316582784, 6.712712462333177],
            [17.3758652715431, 6.733641493610251],
            [17.37784829019207, 6.744024642504559],
            [17.37532919582402, 6.747580949876865],
            [17.371062621604587, 6.749920944468297],
            [17.364936357900916, 6.755888697599671],
            [17.36278595120174, 6.759466771369596],
            [17.365878948679317, 6.774761734158666],
            [17.370660767141754, 6.785446610499436],
            [17.369072329981936, 6.788012531231331],
            [17.360754025784125, 6.786157980316574],
            [17.352995808183614, 6.7889851898217035],
            [17.351009465863367, 6.791733213457907],
            [17.34776826133663, 6.801865239193582],
            [17.3478301865945, 6.809879868270705],
            [17.352495435326283, 6.8189107711039805],
            [17.350367543611654, 6.837995495399716],
            [17.34942892768224, 6.842135581103741],
            [17.348387171550304, 6.85805770523329],
            [17.346698273728983, 6.865420235390689],
            [17.346353101371996, 6.871636851625803],
            [17.34713173365361, 6.878582956509833],
            [17.342266551385045, 6.891613825965645],
            [17.34212373309741, 6.8953874095991035],
            [17.345711388477017, 6.901863174395987],
            [17.34619229344054, 6.908051469873552],
            [17.345014632985983, 6.9164334425374365],
            [17.343485278515157, 6.921058286790145],
            [17.33907425993641, 6.927010978578661],
            [17.329076782712807, 6.9325222128195385],
            [17.326169993430472, 6.937318595324057],
            [17.325761460909284, 6.951583257029504],
            [17.329130017966154, 6.953322294795722],
            [17.331467595931993, 6.96103436549786],
            [17.332108970659988, 6.967049689192419],
            [17.328078874132043, 6.980473045862809],
            [17.32479741450952, 6.989122920968054],
            [17.326119366762068, 6.991997722235897],
            [17.32418412434065, 6.998737620809889],
            [17.327426066504987, 7.005770338722268],
            [17.333050417359505, 7.011286749283143],
            [17.34182051070773, 7.017688574531849],
            [17.35120007815628, 7.032026383443656],
            [17.352886970422443, 7.033295274858875],
            [17.393124513826795, 7.0359135290276695],
            [17.42930058244425, 7.039342947995264],
            [17.4413973396776, 7.040287693721351],
            [17.470129324413175, 7.036036476702688],
            [17.52050532356548, 7.027759339127497],
            [17.514679418669008, 7.010645523317096],
            [17.523309930175387, 7.008792913162608],
            [17.53750756608322, 7.006741648222614],
            [17.546363866122658, 7.034033741408709],
            [17.550309465012138, 7.0255688494068105],
            [17.646228885703398, 7.0345917815912316],
            [17.623861712990067, 6.9629816777987905],
            [17.620204360523864, 6.950486791867815],
            [17.616170962946807, 6.932117016341284],
            [17.585447940554157, 6.9286116844916315],
            [17.58691807700633, 6.910599917261416],
            [17.596920029774047, 6.902247742158818],
            [17.597881768147317, 6.9006466281037],
            [17.60281592432332, 6.876042967895603],
            [17.603242428839344, 6.866224855225822],
            [17.589630342117196, 6.80756085711579],
            [17.62384731533745, 6.74676640105554],
            [17.638071043752337, 6.750079645036394],
            [17.648728016179973, 6.719775506592353],
            [17.680269622944838, 6.691928367152603],
            [17.662121707826856, 6.681703244858152],
            [17.677117952755555, 6.662500636407866],
            [17.674663412251384, 6.629577512427563],
            [17.614674149361736, 6.615192339198922],
            [17.575219996556548, 6.607363832035002],
            [17.57468125670435, 6.624844180893133],
            [17.57807141875823, 6.659735197554456],
            [17.506689417831673, 6.62922316213973],
            [17.50138769747479, 6.626814504104258],
            [17.45947933335779, 6.609952776392325],
            [17.462656178946336, 6.602845850834698],
            [17.429601851744682, 6.597098146257703],
            [17.43901623952126, 6.573129665958628],
            [17.39622094124083, 6.565975205315045],
            [17.389931193358997, 6.589309065293073],
            [17.375484716720656, 6.587245576465988],
            [17.372503354009908, 6.597595275591758],
            [17.376441999894823, 6.604613110843023],
            [17.376205665520413, 6.608933537430666],
            [17.370493981043865, 6.6146557179721475],
            [17.369082557371605, 6.617715513180099],
            [17.375382132184715, 6.629871878749709],
            [17.370299010780393, 6.641472626015182],
            [17.36940734589483, 6.645157055190337],
            [17.370675289060266, 6.659884236970794]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.22216505921068,
          "lat": 43.361327220748095
        },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33019"],
        "coty_name": ["Sullivan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sullivan County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00873183"
      },
      "bbox": [
        17.32418412434065, 6.565975205315045, 17.680269622944838,
        7.040287693721351
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.973380719094727, 3.9953481769792254],
            [15.971329351679847, 3.996385732454313],
            [15.966858568499054, 3.9941781024856775],
            [15.962980712631264, 3.9953729904324002],
            [15.960414569169167, 4.000874247600585],
            [15.961466185773679, 4.004523790498536],
            [15.960903957766469, 4.015646663057374],
            [15.965022766380413, 4.0217538780802995],
            [15.973065085752589, 4.029775528844801],
            [15.973723016765826, 4.031909175737562],
            [15.984484624709646, 4.040304654216966],
            [15.991380275156155, 4.048973070320092],
            [15.995771948975083, 4.050254231324365],
            [16.0168089478385, 4.069971145659088],
            [16.020034884765334, 4.075355433486581],
            [16.02580293575373, 4.080052252601055],
            [16.024792000065162, 4.08694721521268],
            [16.029318606574883, 4.098613606843025],
            [16.030070682689583, 4.108793080940393],
            [16.034741960202332, 4.110930637865253],
            [16.0382597456065, 4.118312011961789],
            [16.04479536423114, 4.12428699204307],
            [16.049524700026332, 4.126226468895333],
            [16.05663390635122, 4.13413008845464],
            [16.057974657689726, 4.137011868045861],
            [16.05746865763584, 4.143641269818786],
            [16.083291649762927, 4.123501305702473],
            [16.132658348379426, 4.083843507479438],
            [16.15729594114407, 4.064344565866151],
            [16.192660547222662, 4.0357271938288575],
            [16.208104091134285, 4.0236678494617815],
            [16.242555030939315, 3.9962605594438956],
            [16.238957570746322, 3.9896778662387122],
            [16.230537174997053, 3.978567204111857],
            [16.2308334387551, 3.9726996272947366],
            [16.223020785729407, 3.96588200063051],
            [16.22169144718457, 3.961773766276697],
            [16.223676059688167, 3.9560291675409656],
            [16.22338959797306, 3.949164166517315],
            [16.22927442003184, 3.944559684365455],
            [16.2286290547707, 3.941658216241308],
            [16.2247668532514, 3.9399035036106134],
            [16.22552477745555, 3.9341658638643153],
            [16.223204827246906, 3.930282233471077],
            [16.2186416797083, 3.927631892033563],
            [16.21768410513449, 3.9216920793648478],
            [16.221333779810088, 3.9193283918245028],
            [16.223227692484556, 3.9155588793990734],
            [16.217832530168277, 3.9095618188744687],
            [16.215787733930387, 3.9056788603004704],
            [16.217314042645853, 3.902446060888006],
            [16.214687471058877, 3.8983924915913173],
            [16.211077919482708, 3.8864447964724143],
            [16.208246081003647, 3.8852007914712257],
            [16.207233053052196, 3.8781354465420455],
            [16.203858999978337, 3.8773975469770114],
            [16.201629010395276, 3.8740366742739596],
            [16.1971179868475, 3.8748107569504375],
            [16.196647131911234, 3.8681579389191216],
            [16.192347699516386, 3.8650249654573807],
            [16.18801787447882, 3.8599109936990854],
            [16.185261353842773, 3.860045812926191],
            [16.18192780552131, 3.855464303203542],
            [16.17857493070848, 3.85085390476803],
            [16.172678575466726, 3.845984579212671],
            [16.17501022103851, 3.8431219355747546],
            [16.176010596952736, 3.8377364357677406],
            [16.169431694689823, 3.830799293238078],
            [16.16892923904758, 3.8264495228141926],
            [16.164787166840252, 3.819541578407604],
            [16.161860717793907, 3.8167438005534127],
            [16.155117901588095, 3.798775186980875],
            [16.15212611168623, 3.7941694263955315],
            [16.149879088574234, 3.786370323439133],
            [16.145556293616526, 3.7830133061172426],
            [16.142852637625573, 3.7772906655550265],
            [16.141562198585905, 3.7678324128729908],
            [16.13999831527658, 3.7656152607390325],
            [16.132851010723297, 3.764508581431905],
            [16.132999940969558, 3.7601517325765434],
            [16.126244060749684, 3.7554376756636585],
            [16.123559701770446, 3.7520279988077876],
            [16.120193120335845, 3.7447304075325727],
            [16.11290219427462, 3.7422417037634106],
            [16.109387446415166, 3.7431151979261195],
            [16.09929429500754, 3.7294650499004285],
            [16.096613300194193, 3.728925009197969],
            [16.093011124792387, 3.723052658930174],
            [16.089096761979537, 3.7229498506271788],
            [16.082416678987837, 3.7148223027180385],
            [16.081754753611897, 3.7112819668928596],
            [16.077483266676442, 3.7091558791352144],
            [16.07216391221606, 3.702749821210139],
            [16.071182398707716, 3.6981151350953585],
            [16.064905303096403, 3.6924851476768725],
            [16.061762268179752, 3.6846485257025297],
            [16.0553410461495, 3.679777601169702],
            [16.05439333818848, 3.674243232302011],
            [16.050691915152072, 3.6707570671463223],
            [16.04151785700617, 3.665895114318909],
            [16.035962748021106, 3.660231348924773],
            [16.02962411515125, 3.657614671507209],
            [16.028243369769218, 3.6539163468766653],
            [16.02828950585022, 3.648571871838281],
            [16.024537882628202, 3.64896551329334],
            [16.02032578158985, 3.6444303275959493],
            [16.02054547537907, 3.6370164616650027],
            [16.014433383198003, 3.62765246678498],
            [16.014496535868872, 3.6232534308129165],
            [16.010468486980137, 3.6205648802449906],
            [16.011047381767597, 3.6176170439851334],
            [16.004715860355017, 3.613568412724809],
            [16.000886567285875, 3.624097461422935],
            [15.996278317523018, 3.6291629863611976],
            [15.990713387577813, 3.636804765238249],
            [15.993124181918933, 3.6395508515602644],
            [15.998276336839009, 3.6413382497962616],
            [15.998804045087395, 3.646273465480689],
            [15.99478525561486, 3.6569958546301717],
            [15.98975614045954, 3.6632957138333517],
            [15.985194557294207, 3.666218171640448],
            [15.986177781283429, 3.674916818360459],
            [15.988960503858738, 3.6825631096565634],
            [15.994020214797745, 3.687844549862498],
            [15.996432967939212, 3.695211125769253],
            [15.995236646740123, 3.7002414237845587],
            [15.98966033336374, 3.701312419557574],
            [15.985339506223802, 3.699742402440758],
            [15.980265822430253, 3.7005957375609215],
            [15.976410662826678, 3.7040696899973],
            [15.972895380809458, 3.7094761396073563],
            [15.973689286587415, 3.7238811469652005],
            [15.974934175421415, 3.7331483345387966],
            [15.979467249230746, 3.740605173528834],
            [15.978706579807557, 3.746721555170954],
            [15.98019302262197, 3.7507139982726736],
            [15.976178300945554, 3.757394250314802],
            [15.967363572330873, 3.763898563356398],
            [15.965146798733384, 3.7697552804090417],
            [15.967700160533502, 3.774651165568622],
            [15.973351675708793, 3.7795290344655608],
            [15.976357773127786, 3.785229068122172],
            [15.975812316640528, 3.7940753587670257],
            [15.97771102382912, 3.799468631199436],
            [15.983387280855277, 3.801391190635727],
            [15.994636675971876, 3.800181411572054],
            [16.00583776282622, 3.801621628939488],
            [16.007508731713898, 3.804246562489862],
            [16.01127517243043, 3.8162167907707034],
            [16.015279231105012, 3.819793781527067],
            [16.021003933065828, 3.822867885412944],
            [16.024734364107363, 3.832673165884972],
            [16.02340578114825, 3.8403996868797545],
            [16.025411416883, 3.8456239434669652],
            [16.028719308113036, 3.850178899344055],
            [16.031660677071958, 3.859659162223074],
            [16.029262039411137, 3.8649122225547687],
            [16.020818301017652, 3.8702641232909722],
            [16.018041208532253, 3.873628528621949],
            [16.01800476696732, 3.8799249521795427],
            [16.02107137378742, 3.8827792792052818],
            [16.031371267721873, 3.8857873310536775],
            [16.03620317026457, 3.8843061731409025],
            [16.04111481777538, 3.887533404095811],
            [16.039487660299834, 3.89332116129467],
            [16.042080259419723, 3.89902470522343],
            [16.046627600737114, 3.903803289499798],
            [16.046277504942246, 3.9078739813582746],
            [16.042977334962963, 3.9129029258313874],
            [16.038445178398383, 3.9160079905784992],
            [16.031713519274962, 3.9227808859432884],
            [16.024077925809216, 3.9277707316784585],
            [16.021813067946578, 3.930891906020996],
            [16.01921532244969, 3.942010817587947],
            [16.01537661257118, 3.948213467571859],
            [16.001236960281293, 3.9556372369543342],
            [15.991255892916753, 3.9659276895814384],
            [15.99005342585599, 3.9691405558166415],
            [15.984155020854553, 3.9765254652004147],
            [15.978630151218367, 3.980357364569064],
            [15.974398797530366, 3.9892125848596383],
            [15.973380719094727, 3.9953481769792254]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.99729923175131, "lat": 40.85713885067725 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34041"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00882237"
      },
      "bbox": [
        15.960414569169167, 3.613568412724809, 16.242555030939315,
        4.143641269818786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.990150709497175, -3.401881331412487],
            [-7.958934306791599, -3.4052152029472142],
            [-7.836471527930641, -3.4194333461905666],
            [-7.809422697396431, -3.4224965091784214],
            [-7.809321063869944, -3.4215992543019014],
            [-7.778214705612074, -3.424966601408969],
            [-7.769332072790234, -3.3415565978116546],
            [-7.811031793580755, -3.3372547291015797],
            [-7.8452447014344004, -3.333503100619219],
            [-7.83593456289545, -3.24675463765557],
            [-7.751981543817905, -3.2552598448517016],
            [-7.662846690063157, -3.2645718352858286],
            [-7.408336507024301, -3.2901208591142965],
            [-7.382838802414066, -3.2926991695718293],
            [-7.186922259275276, -3.312158317479031],
            [-7.0661270473866535, -3.323962710981844],
            [-7.074734328092802, -3.4110914160206667],
            [-7.089952612445517, -3.5699184269229423],
            [-7.1086435252775795, -3.759982953857153],
            [-7.126799409130062, -3.7580172310757365],
            [-7.146807110179924, -3.959525591756384],
            [-7.152665066696915, -4.017979325165258],
            [-7.156953920353157, -4.062294075173696],
            [-7.1613798498828825, -4.105188877074318],
            [-7.190692801876016, -4.102168702238851],
            [-7.2795943654267, -4.093543312805329],
            [-7.3071529095913474, -4.091019172505891],
            [-7.398147164390458, -4.081580810966613],
            [-7.59106692665958, -4.061827689019666],
            [-7.661299478398621, -4.0545873922220315],
            [-7.706436250765258, -4.049928646298149],
            [-7.804646657462877, -4.039472975941311],
            [-8.060848544644793, -4.011942344383476],
            [-8.051523076184218, -3.925025102664903],
            [-8.0516387045779, -3.9242354642859487],
            [-8.04299010289163, -3.844088152242552],
            [-8.041794234308602, -3.8320733328520644],
            [-8.0356478738593, -3.772165694381859],
            [-8.035127710190993, -3.7645337010552478],
            [-8.032714433704168, -3.7500627508418884],
            [-8.075750218149635, -3.74582904107884],
            [-8.067214814644482, -3.6585051625816662],
            [-8.062099494273141, -3.659105126142032],
            [-8.056258538124276, -3.5964054136045607],
            [-8.052683791179588, -3.5609462570457326],
            [-8.048485279402232, -3.522026673632035],
            [-8.042651394732566, -3.484255658523649],
            [-8.032278816364402, -3.3973029856172032],
            [-7.990150709497175, -3.401881331412487]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.85081148891855,
          "lat": 34.64045762297209
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35057"],
        "coty_name": ["Torrance"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Torrance County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00929112"
      },
      "bbox": [
        -8.075750218149635, -4.105188877074318, -7.0661270473866535,
        -3.24675463765557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.975715764499784, 6.34495996291049],
            [15.063855579057186, 6.337069584778795],
            [15.09096127259783, 6.334968162198952],
            [15.101913673907159, 6.333808144395562],
            [15.125785976219287, 6.330505290965679],
            [15.143967234137596, 6.32961801824359],
            [15.229281043680324, 6.415657717629199],
            [15.275489915560279, 6.4616386510826915],
            [15.325924744655799, 6.5114743243029976],
            [15.399591526090475, 6.585300588118644],
            [15.399912107134801, 6.585622223618287],
            [15.424155239122918, 6.50836305148082],
            [15.43476788157016, 6.47221246654783],
            [15.451480847518875, 6.42152947190728],
            [15.465384321841043, 6.37887634437305],
            [15.485957344658377, 6.313668464415373],
            [15.478034536257377, 6.310719449927609],
            [15.475307487887763, 6.308068216030025],
            [15.475483778526245, 6.303558590960126],
            [15.471625712796312, 6.3047505242340405],
            [15.468831254095065, 6.295580800832556],
            [15.468366666791095, 6.290529545569293],
            [15.461081142038498, 6.287947715043998],
            [15.46089210086831, 6.28093301609861],
            [15.457966291642586, 6.282629780642623],
            [15.453302454789116, 6.282413854297716],
            [15.442090648371629, 6.276471069012979],
            [15.444262759682749, 6.271223664327984],
            [15.444477839098102, 6.261827688264186],
            [15.442085777366142, 6.257879716021167],
            [15.442809189125091, 6.2527745320227375],
            [15.440687994771096, 6.244606788965532],
            [15.442517227384315, 6.235944454080069],
            [15.441146950322347, 6.229772113177452],
            [15.444900056425974, 6.227577487754059],
            [15.448550128307476, 6.227836553120888],
            [15.450422140864946, 6.22507376770887],
            [15.454461646462477, 6.2287507014741985],
            [15.462686694296403, 6.224193532794342],
            [15.47095662715903, 6.224134366576069],
            [15.473027036914683, 6.219011958616232],
            [15.486314837720489, 6.216949580784734],
            [15.490853941553935, 6.214806447721483],
            [15.49782408403071, 6.213711769961641],
            [15.502741585570307, 6.214852221175692],
            [15.508026037369255, 6.219912522285643],
            [15.511178726435856, 6.214021559191758],
            [15.513891619273764, 6.214050764929474],
            [15.490156761397081, 6.140525195424833],
            [15.484151059015073, 6.121067997342761],
            [15.474570121312098, 6.092805113154619],
            [15.461899961283876, 6.0602712759269295],
            [15.464777282190571, 6.060146094954337],
            [15.468599300455324, 6.05570891200971],
            [15.467037047231319, 6.047946962622139],
            [15.457026062021686, 6.048136699037626],
            [15.445939490254787, 6.0198912249356935],
            [15.457998227452991, 5.97977153368758],
            [15.46049353377167, 5.972552192181441],
            [15.471574143192147, 5.936162476229339],
            [15.495976754394889, 5.854912425450714],
            [15.48850787792014, 5.852552240631423],
            [15.46721198012587, 5.845690450255654],
            [15.464865453759142, 5.8387513485525],
            [15.411521532809216, 5.824066807604883],
            [15.332034248065902, 5.801078780585428],
            [15.328488871831711, 5.812341800462959],
            [15.311989111253824, 5.868170630060408],
            [15.242133744149104, 5.8515935758813],
            [15.235409949590276, 5.87526248331089],
            [15.21488994040529, 5.945298765652073],
            [15.212333554755029, 5.953422168146925],
            [15.181472940108723, 5.9445164065123235],
            [15.179601985541657, 5.946840647733699],
            [15.179128465981451, 5.95165836735314],
            [15.174868528559777, 5.956480015528738],
            [15.169805137211876, 5.960113257538189],
            [15.174045600516035, 5.969519499797913],
            [15.17150715939794, 5.971709076543864],
            [15.162407839851301, 5.971488236799373],
            [15.158662633720057, 5.976145205131142],
            [15.15084927433841, 5.9775418625522],
            [15.148326408966925, 5.979760923538339],
            [15.143972340066716, 5.978426590777874],
            [15.141405680088203, 5.980347763856663],
            [15.136964884941243, 5.9958442237574925],
            [15.138185125026112, 5.998189632063347],
            [15.12368139303952, 6.008137208142631],
            [15.124852966604498, 6.0126491285954735],
            [15.120122260024063, 6.011305158803431],
            [15.112835136670906, 6.011282662016631],
            [15.109343037267541, 6.013477080498418],
            [15.107751313222558, 6.017533840585652],
            [15.104059759051117, 6.016121750853136],
            [15.10173791658834, 6.017780261747241],
            [15.104192260429247, 6.0214286369668795],
            [15.097426469287592, 6.022976908092794],
            [15.096463281976103, 6.026535982976806],
            [15.091681447138168, 6.025629896895836],
            [15.088036836151367, 6.030978769124105],
            [15.085656699029848, 6.027477102579788],
            [15.082678007626113, 6.027874112342888],
            [15.080431537274182, 6.0342704281224],
            [15.078220550376347, 6.0361414668201006],
            [15.078822113249256, 6.04081418074014],
            [15.070968923848541, 6.039925403631436],
            [15.066510270263972, 6.043257919383664],
            [15.065039957849066, 6.047123821299627],
            [15.056139321840986, 6.047822424496605],
            [15.05388922759782, 6.049227225467806],
            [15.048462028186538, 6.041349251125297],
            [15.04469220228412, 6.041161116227752],
            [15.040091715333354, 6.043232964162913],
            [15.038009687740132, 6.045822999545679],
            [15.030787349846154, 6.049599056725381],
            [15.025608142689858, 6.050244189529817],
            [15.024281590565964, 6.0463161436322395],
            [15.018911353664405, 6.043784030530494],
            [15.018535811658367, 6.041001287005412],
            [15.01303890434908, 6.034751436331812],
            [15.006781529820623, 6.03516781588551],
            [14.997089092167105, 6.033637302919741],
            [14.990809348637985, 6.0298368409217185],
            [14.982275247770271, 6.029595815294617],
            [14.978348092119905, 6.025691022245198],
            [14.973924094985836, 6.02366513631189],
            [14.972627050054838, 6.0169908569625985],
            [14.965629457618695, 6.011834825329343],
            [14.958011563462362, 6.016101483599278],
            [14.951908608582118, 6.018036738422652],
            [14.942680408597484, 6.0923685968516725],
            [14.932454968166814, 6.1811887770076135],
            [14.914370868365946, 6.183250359860843],
            [14.923346353889814, 6.265595874943434],
            [14.931828942992727, 6.348986520021565],
            [14.975715764499784, 6.34495996291049]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.435820605479, "lat": 43.241754510993665 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36065"],
        "coty_name": ["Oneida"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oneida County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00974131"
      },
      "bbox": [
        14.914370868365946, 5.801078780585428, 15.513891619273764,
        6.585622223618287
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.72242383984262, 4.5348027958607995],
            [16.72960337474391, 4.555128601069882],
            [16.73120608354075, 4.560736919429333],
            [16.729671677758752, 4.573277280317349],
            [16.728952812270293, 4.586906358682156],
            [16.730150975656176, 4.593820129172717],
            [16.729780341802304, 4.599915397265199],
            [16.73078308663986, 4.606862562992798],
            [16.72898795068879, 4.6108414946018605],
            [16.72072020746096, 4.611849257935849],
            [16.717634282422317, 4.6144849605313185],
            [16.71558685027383, 4.620862279959831],
            [16.710375775220047, 4.628479970705424],
            [16.7052388227305, 4.633131117068425],
            [16.69563075264267, 4.6456475208262535],
            [16.718720220882865, 4.702040998954289],
            [16.737076180536246, 4.709151564011363],
            [16.74083290513953, 4.711494340044618],
            [16.759956923110266, 4.718783686585572],
            [16.76677850314386, 4.720877941742464],
            [16.785370058432783, 4.728242256900201],
            [16.832904638851396, 4.745703723798693],
            [16.840556691659863, 4.749024226401417],
            [16.871589808843794, 4.760719505062175],
            [16.893583004339636, 4.769321575128414],
            [16.937316013638544, 4.788733756742172],
            [16.96542962260436, 4.7999931294605265],
            [17.001414169233936, 4.809460846525806],
            [17.017934069959495, 4.717055270102266],
            [17.02199129888801, 4.689191764767638],
            [17.02728890668516, 4.660114350083255],
            [17.02873957059428, 4.650044714883262],
            [16.990104962872895, 4.634856592162943],
            [16.961091354340883, 4.623963582171681],
            [16.88285228236511, 4.593376455125998],
            [16.819938372714308, 4.5691437725869894],
            [16.721966750556295, 4.530982789966924],
            [16.72242383984262, 4.5348027958607995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.74948516368556, "lat": 41.42671456890355 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36079"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00974138"
      },
      "bbox": [
        16.69563075264267, 4.530982789966924, 17.02873957059428,
        4.809460846525806
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.987658036457587, 5.0773844730525],
            [16.035607614790056, 5.12550377641069],
            [16.083714184805135, 5.1734721216600565],
            [16.127302860288246, 5.217271206202145],
            [16.137900625899693, 5.245407521356152],
            [16.157627654641786, 5.248324980333456],
            [16.189633417572733, 5.2806761834606695],
            [16.220173356569315, 5.2728995279802096],
            [16.30550427827303, 5.250903826617281],
            [16.366386153348518, 5.2584548740296935],
            [16.476575501491936, 5.272408444562929],
            [16.482803941617902, 5.349873294127982],
            [16.497257555406943, 5.344760998929662],
            [16.51222797054158, 5.349539656844382],
            [16.509896685153826, 5.363027949088071],
            [16.521021983370666, 5.357781555638999],
            [16.580915125560924, 5.3304515985621235],
            [16.587161196870685, 5.330000780016239],
            [16.585212339932667, 5.323405028815574],
            [16.583430652452865, 5.311330275032975],
            [16.58447637326346, 5.296526231274865],
            [16.584821050770508, 5.279461705598304],
            [16.585533869926948, 5.276051955093801],
            [16.58887569138554, 5.2733602101032755],
            [16.589041944058813, 5.266128527245],
            [16.586901647358296, 5.262228158109402],
            [16.58928555391004, 5.245445434126232],
            [16.59065121168538, 5.240408306229099],
            [16.590118983808228, 5.2334568045840975],
            [16.591542837127335, 5.227509816363125],
            [16.59613903189409, 5.220001113459022],
            [16.596750469716643, 5.21425833851366],
            [16.595828701330696, 5.199843607697716],
            [16.596584580006038, 5.186139782233273],
            [16.59635750476447, 5.1567456505592055],
            [16.596817013602553, 5.150406533305867],
            [16.59920248237157, 5.135893896904899],
            [16.600929562630473, 5.11995581384939],
            [16.59814678804391, 5.112687590493336],
            [16.602581327364984, 5.100436672418896],
            [16.61049616378914, 5.092418411561494],
            [16.618875580269446, 5.084856174557153],
            [16.622932857444326, 5.079740863078211],
            [16.62714934247427, 5.069961627127995],
            [16.626849990024116, 5.063078115348297],
            [16.624659816704696, 5.057399126148698],
            [16.624264363852983, 5.051532205797008],
            [16.626355628047495, 5.039998026043562],
            [16.62915154835571, 5.031747383181159],
            [16.63004048777273, 5.024615038843844],
            [16.632321465709026, 5.019510535435531],
            [16.632603334980438, 5.015039812516682],
            [16.63502845074813, 5.004044955630368],
            [16.635792941486855, 4.991685460989904],
            [16.640409348379336, 4.974886022560759],
            [16.650619166752424, 4.963610304947317],
            [16.651957759989514, 4.960790243801453],
            [16.65484501900463, 4.945694435940978],
            [16.656787161692233, 4.939625122136484],
            [16.65855376112891, 4.921414667893169],
            [16.660464000420035, 4.906147009697314],
            [16.664881223679867, 4.897797311180882],
            [16.667039275564143, 4.891910030973688],
            [16.667350623404477, 4.874859626965955],
            [16.67028322832355, 4.864099492770184],
            [16.67024865523495, 4.860068105185413],
            [16.672201958911813, 4.8499022750964516],
            [16.673397089332017, 4.832645527424455],
            [16.676352620476496, 4.821786333326386],
            [16.680323508777807, 4.803427746411525],
            [16.681031300010808, 4.798109522578961],
            [16.6604914889649, 4.790323110150115],
            [16.648565763739903, 4.78617143743028],
            [16.62952297614903, 4.7787860903393975],
            [16.610462655542364, 4.771991507447913],
            [16.609330658638235, 4.777235818303124],
            [16.59441838193929, 4.794307354611405],
            [16.580364047418712, 4.783386985530579],
            [16.57551933739641, 4.789319204253388],
            [16.572044634570236, 4.790370521990504],
            [16.544200242051666, 4.792566835396313],
            [16.55768483606277, 4.7615248749378],
            [16.512407872195563, 4.762914766672991],
            [16.511622851000034, 4.759292865253918],
            [16.46196057721761, 4.762783544081684],
            [16.45750875594286, 4.786442929195968],
            [16.44668131979016, 4.787450315266058],
            [16.444356729104662, 4.782663708942067],
            [16.439854256975345, 4.778548581315251],
            [16.436296110347236, 4.777287720640404],
            [16.42925850222687, 4.7684983710611535],
            [16.427177141001255, 4.769466751405366],
            [16.42132226500207, 4.763546153350098],
            [16.422245218393293, 4.760564049728418],
            [16.415646468262047, 4.756398621857767],
            [16.41516747381061, 4.751997220064315],
            [16.41294627847463, 4.748984423655189],
            [16.4064452523408, 4.7459767061122875],
            [16.407012419838747, 4.743092544041598],
            [16.400078034038746, 4.737112330710224],
            [16.398175610037196, 4.739201358936556],
            [16.392840744221374, 4.739815931252179],
            [16.39080783924342, 4.735995064710434],
            [16.392201640568455, 4.733520350085662],
            [16.38798054868988, 4.730930096449798],
            [16.38178138176281, 4.729382328997134],
            [16.381425817659018, 4.734088372463365],
            [16.37622830065814, 4.733549492756859],
            [16.373574459397286, 4.7349224049628855],
            [16.37226857148652, 4.741202551189483],
            [16.37010099975306, 4.741703315403574],
            [16.366637493378228, 4.749748044530901],
            [16.36402006190945, 4.750249238144148],
            [16.360040286129195, 4.757024551702142],
            [16.35987652564006, 4.760530272484232],
            [16.35448875823844, 4.766869497529495],
            [16.35196555626125, 4.774311274878249],
            [16.349283547077803, 4.777440321792111],
            [16.323836613673155, 4.7877791130281775],
            [16.26808982654461, 4.812668470633822],
            [16.24290422997819, 4.8241549462715865],
            [16.196576293245503, 4.845813433087594],
            [16.202404859233923, 4.859744665671033],
            [16.21179960580402, 4.883976871892386],
            [16.23941152838264, 4.94738816457826],
            [16.25470138672783, 4.992845626251253],
            [16.254684744987028, 4.993359805770661],
            [16.153985923527753, 5.026006624604873],
            [16.133800013362677, 5.032694613279549],
            [16.074405519389977, 5.051063379351165],
            [16.01302480597345, 5.069301345190815],
            [15.987658036457587, 5.0773844730525]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.25856839592507, "lat": 41.88814632408087 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36111"],
        "coty_name": ["Ulster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ulster County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00974153"
      },
      "bbox": [
        15.987658036457587, 4.729382328997134, 16.681031300010808,
        5.363027949088071
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.7570877656873245, 8.84088975395489],
            [-4.718258548993402, 8.83730688640117],
            [-4.645627068791304, 8.831391979449908],
            [-4.64422019535441, 8.831419998811377],
            [-4.538461550768169, 8.82333703517434],
            [-4.432705669542118, 8.81521871211502],
            [-4.3714363839835215, 8.810693473919356],
            [-4.326004154381086, 8.807322017457041],
            [-4.330577765475638, 8.749309242509845],
            [-4.338042681128586, 8.650443401765395],
            [-4.344355621231566, 8.565281883641363],
            [-4.347348586889825, 8.52708640661731],
            [-4.35182004313566, 8.465890052708765],
            [-4.419618669729147, 8.470798410166948],
            [-4.487418303652051, 8.475692580678317],
            [-4.493842091564668, 8.394200652217243],
            [-4.499805673235453, 8.316523203046403],
            [-4.514368226894873, 8.131240751523045],
            [-4.561673698425375, 8.134924844975439],
            [-4.634300170721197, 8.140704226108635],
            [-4.704031929709147, 8.146052984467792],
            [-4.773764797696932, 8.15138709406744],
            [-4.772135455663736, 8.169758465873729],
            [-4.767268970630939, 8.231208610479358],
            [-4.759944017793278, 8.321852497799515],
            [-4.748827671630561, 8.456767059548506],
            [-4.746099699786129, 8.495271682143228],
            [-4.785373007189754, 8.498335839705454],
            [-4.773616951007016, 8.640776985886458],
            [-4.7632874440939545, 8.767622383093004],
            [-4.762470356249739, 8.781795518543717],
            [-4.7570877656873245, 8.84088975395489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -103.3762820163104, "lat": 47.02363482242426 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38007"],
        "coty_name": ["Billings"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Billings County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01035616"
      },
      "bbox": [
        -4.785373007189754, 8.131240751523045, -4.326004154381086,
        8.84088975395489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.086965468813101, 9.840413378618372],
            [-0.9996986711143412, 9.83787269747056],
            [-0.9130090224428277, 9.835978335143773],
            [-0.8254712577907113, 9.834025554328086],
            [-0.7382572564871224, 9.832293179187078],
            [-0.6655851617806178, 9.831072992262326],
            [-0.5781347812834151, 9.829522735346957],
            [-0.4900399941531011, 9.828037614502602],
            [-0.391266375502603, 9.826402670107843],
            [-0.3133654788815948, 9.82490266994665],
            [-0.31319682800157156, 9.825220807129213],
            [-0.3006639782244981, 9.819243415629614],
            [-0.3007533302200195, 9.814936183394881],
            [-0.30821509274860037, 9.81248657412285],
            [-0.3090662662994799, 9.807284204363512],
            [-0.3063488809846891, 9.802658273168518],
            [-0.30103496790402756, 9.80254925838422],
            [-0.29694314938879796, 9.805097055098672],
            [-0.2908636842579175, 9.804270849454035],
            [-0.2913941951038453, 9.800736825596665],
            [-0.29866531373272115, 9.794969495148619],
            [-0.30598387267048366, 9.795371371701215],
            [-0.3059864658022371, 9.785617819568051],
            [-0.30248395981850684, 9.781253150571372],
            [-0.29735836368546636, 9.77899488435653],
            [-0.2943613439436238, 9.77610839362104],
            [-0.2944084923971038, 9.77226363858782],
            [-0.2993845490347016, 9.771951566866427],
            [-0.2998432915881678, 9.768704672345894],
            [-0.30341453114735906, 9.767031061419786],
            [-0.3113582732697533, 9.765771879343447],
            [-0.3141877358455148, 9.764112360421173],
            [-0.3138059206431418, 9.760172347325627],
            [-0.3097542837243548, 9.759251529890454],
            [-0.3001551513994645, 9.761628890018628],
            [-0.29233476061400737, 9.759855963191308],
            [-0.29276315742845543, 9.755712781985672],
            [-0.2958282494192177, 9.755997533244193],
            [-0.3011174802035356, 9.758894044986],
            [-0.30533586900793847, 9.755129559603105],
            [-0.3012954518435514, 9.747868713317702],
            [-0.29550189345325467, 9.748259891861961],
            [-0.29226443567274013, 9.744790498993625],
            [-0.2928651651759665, 9.73869647399093],
            [-0.2969350826000198, 9.733704565199078],
            [-0.30556591656345594, 9.72909278217327],
            [-0.3072289001388375, 9.726332540207371],
            [-0.3045003292966375, 9.723240833428179],
            [-0.3009246138288582, 9.72370194902936],
            [-0.29647470699769335, 9.728285531045376],
            [-0.2911449325196093, 9.728023978983904],
            [-0.289391380915225, 9.724824331264347],
            [-0.2899652464776888, 9.7187232313468],
            [-0.2946189724932649, 9.716369226043216],
            [-0.29923440773544957, 9.718739301454837],
            [-0.3037410985039007, 9.71786071478242],
            [-0.302066575244649, 9.71304533073331],
            [-0.29154234472409285, 9.70874649382391],
            [-0.288675628908699, 9.703739610438067],
            [-0.29110796647377385, 9.701663767867327],
            [-0.29608813701542175, 9.706402862992704],
            [-0.30065090344747214, 9.70709884127195],
            [-0.3077580188261243, 9.70513963864048],
            [-0.31039773593014586, 9.703202670846355],
            [-0.30940439182583857, 9.698884703697567],
            [-0.30576562522988976, 9.699013058403722],
            [-0.3027722174964382, 9.703670043551707],
            [-0.2949307766339533, 9.695273714947147],
            [-0.2948635422038432, 9.692402394116106],
            [-0.3010662734052125, 9.68784990392214],
            [-0.3061610171652205, 9.682943976796208],
            [-0.30969485170118977, 9.68318918966997],
            [-0.3155376436527304, 9.681106019652347],
            [-0.31636719475936775, 9.678408202468042],
            [-0.3118705414475711, 9.677034338566036],
            [-0.31236553163825304, 9.672254076423682],
            [-0.30796404888576306, 9.668932081434475],
            [-0.3037669275770488, 9.668117747330156],
            [-0.2983282561614736, 9.670330927446582],
            [-0.2971872255557421, 9.667235576057145],
            [-0.3018163913514424, 9.66502730235587],
            [-0.2993900623720083, 9.66022178453215],
            [-0.3005270141096051, 9.657145261670868],
            [-0.3075720499977925, 9.657913285577274],
            [-0.31094295836328284, 9.656849383411432],
            [-0.311470413942416, 9.650800542460768],
            [-0.30681153332225164, 9.64776601052833],
            [-0.3037853735004163, 9.641662766321197],
            [-0.2987861836942085, 9.63954340766412],
            [-0.3016211860836216, 9.634387113074322],
            [-0.30104819372839153, 9.631614981340066],
            [-0.29301646453201347, 9.629988431434752],
            [-0.29192743811948896, 9.62571815712556],
            [-0.2973168397396589, 9.61555682617321],
            [-0.28958230234484583, 9.6150024375051],
            [-0.2864579937064262, 9.613529568665134],
            [-0.28578256385575374, 9.609814520514556],
            [-0.29744694665274307, 9.60624628018705],
            [-0.3003073798403367, 9.600099590206051],
            [-0.2974951414288505, 9.597101171018172],
            [-0.292944656462586, 9.599907604761126],
            [-0.2897742247527798, 9.597911349513366],
            [-0.2928737593236918, 9.59279136528628],
            [-0.29157081134082175, 9.590672222348799],
            [-0.2837946507610618, 9.586010642880607],
            [-0.285337531827838, 9.582220897037638],
            [-0.28887533698165146, 9.583343264817845],
            [-0.29122040750985423, 9.586682897652768],
            [-0.29399649768901415, 9.587169540791459],
            [-0.3006682050305289, 9.57945692503045],
            [-0.29900440509759696, 9.575737959899827],
            [-0.2920984955576727, 9.580341927966384],
            [-0.28997841893913995, 9.5785598784094],
            [-0.2863449407737755, 9.568363026203489],
            [-0.2891131655735868, 9.565532768455848],
            [-0.2923639245857504, 9.565007932681954],
            [-0.29234953183985646, 9.559436176022455],
            [-0.29536922277196787, 9.558821814405057],
            [-0.30243089517537725, 9.560183848216266],
            [-0.30514004734708366, 9.558868706274856],
            [-0.30484538655175025, 9.554988483908577],
            [-0.2989285114669073, 9.554992780988202],
            [-0.2916510366754939, 9.552687700708681],
            [-0.29215509589610117, 9.549323788376098],
            [-0.2958985866118076, 9.546910295079165],
            [-0.29223310930889135, 9.54254383189635],
            [-0.2924283406959172, 9.53943794188022],
            [-0.29802515715976935, 9.53939604186673],
            [-0.30550405856980073, 9.535828011422678],
            [-0.3055281506245665, 9.530992333821283],
            [-0.2996792121587767, 9.530640734141157],
            [-0.2997921361589886, 9.526758708223955],
            [-0.305531408452428, 9.524999222432564],
            [-0.3044549083022031, 9.521205542674801],
            [-0.2922372533467977, 9.51833236053796],
            [-0.28978108705465033, 9.515800961402778],
            [-0.2929027882105136, 9.513413672422862],
            [-0.29819792812235385, 9.516991014272794],
            [-0.30082179321580155, 9.517029743086196],
            [-0.3092481565178746, 9.513414088835036],
            [-0.30759524313578335, 9.5091899906532],
            [-0.30317418313317174, 9.51235776696547],
            [-0.2926315254599435, 9.507609165143284],
            [-0.2890789596616722, 9.50376493541686],
            [-0.2880111864381796, 9.500082504491136],
            [-0.29254740920911043, 9.498420940479047],
            [-0.29469734564419875, 9.504708118683299],
            [-0.29701888987034086, 9.507437694727743],
            [-0.3021236373022625, 9.507393253839346],
            [-0.3024771083500148, 9.504703862512871],
            [-0.2966777943401878, 9.501317385565157],
            [-0.29593177331044135, 9.498428271270017],
            [-0.3014371575507421, 9.496744463903106],
            [-0.3036524484600517, 9.493340879023556],
            [-0.30015370616658454, 9.487871746295285],
            [-0.3038966660806159, 9.484545786783038],
            [-0.3508987569104395, 9.485155475594688],
            [-0.3801340996232941, 9.485722085103221],
            [-0.46706729697813354, 9.487936678095558],
            [-0.5546790373901012, 9.489002903934129],
            [-0.6420043411650791, 9.490530697098853],
            [-0.729438648582272, 9.492123446164259],
            [-0.8164867673109171, 9.493784521193904],
            [-0.900288148942649, 9.495250711391437],
            [-0.9764871390269468, 9.497185771551036],
            [-0.9909269588027912, 9.497369464879272],
            [-1.0779990099437344, 9.499802862548504],
            [-1.0765196490933822, 9.563637525538898],
            [-1.075851981660482, 9.584804223449694],
            [-1.0736073913733748, 9.670213806272914],
            [-1.091397877219496, 9.670666577151145],
            [-1.0891050703402085, 9.755525735928822],
            [-1.086965468813101, 9.840413378618372]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.72128680973748,
          "lat": 48.369446047946454
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38099"],
        "coty_name": ["Walsh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walsh County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01034214"
      },
      "bbox": [
        -1.091397877219496, 9.484545786783038, -0.2837946507610618,
        9.840413378618372
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.186177763065915, 2.7122244200945955],
            [9.199052654883555, 2.7141218095975423],
            [9.251439793607444, 2.72095821316377],
            [9.272141653784661, 2.723892605682014],
            [9.272251648007225, 2.7230891346675064],
            [9.357815573927947, 2.735497539319076],
            [9.353363693370316, 2.7687498612300705],
            [9.352364279991539, 2.7792135533742997],
            [9.418640130755064, 2.78773575305065],
            [9.43735076539789, 2.7902820325679896],
            [9.435426782629717, 2.8050409604594972],
            [9.478102627927488, 2.810891107065068],
            [9.520687067878447, 2.816501896384132],
            [9.533844894037344, 2.716117481406796],
            [9.545235205190192, 2.628728312241081],
            [9.556222880278378, 2.5409930045054745],
            [9.485388759405067, 2.531457132317187],
            [9.437680983278032, 2.525157058636839],
            [9.386583406870917, 2.517823679888919],
            [9.384621449664325, 2.5326782264047183],
            [9.3419604869007, 2.526521224515207],
            [9.299040163946039, 2.5209714104719865],
            [9.295386484363222, 2.5499733335880395],
            [9.208516651917831, 2.5388537035876135],
            [9.20858022098482, 2.5383386761391082],
            [9.165701111685962, 2.5329103044732024],
            [9.149165612108131, 2.6638737516623925],
            [9.191799001113191, 2.669316704109177],
            [9.186177763065915, 2.7122244200945955]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.10578262523929,
          "lat": 40.771529373592934
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39003"],
        "coty_name": ["Allen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allen County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01074015"
      },
      "bbox": [
        9.149165612108131, 2.517823679888919, 9.556222880278378,
        2.816501896384132
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.635106784744993, 2.130745159723654],
            [11.627472063334453, 2.1899607625734907],
            [11.623877480859845, 2.219019405769852],
            [11.610377187913075, 2.3228091949196537],
            [11.607023276147501, 2.3496694055758174],
            [11.606698678907616, 2.3522912388526027],
            [11.670523478534784, 2.3606372504392095],
            [11.692125530306974, 2.3640927943172505],
            [11.69253457000408, 2.3609085391193316],
            [11.738279693840232, 2.365648557024839],
            [11.793783757496186, 2.3717368108644643],
            [11.820393473395995, 2.374871736579637],
            [11.865284118142085, 2.379784350815973],
            [11.890376792586835, 2.3826934163508837],
            [11.924313081882778, 2.3860829456026162],
            [11.927389983150157, 2.3867748173190404],
            [11.953197291813817, 2.3894527719385086],
            [11.952745649229783, 2.3942164781447266],
            [12.000213330250569, 2.399254611613877],
            [11.998834207570287, 2.3932442197016557],
            [11.99795394667312, 2.3795377080063376],
            [11.999678654828264, 2.3664984971602374],
            [12.004887737669888, 2.3526359362092655],
            [12.004094979435783, 2.340965281249892],
            [12.00243619896921, 2.337938493284842],
            [11.990869379726892, 2.325441718099042],
            [11.987336700169742, 2.3183327718366833],
            [11.986699302907095, 2.313735383421382],
            [11.989548606890105, 2.3032672655621576],
            [11.993543860202333, 2.297581050264595],
            [11.996740664952547, 2.2882926358253477],
            [11.998179952928002, 2.2765744253729054],
            [11.99752338413185, 2.2722651610145483],
            [11.995366509738894, 2.266027725217714],
            [11.996157268462461, 2.2591768843343094],
            [11.995024754285797, 2.2533385962242924],
            [11.995420009975922, 2.243612461288372],
            [11.99755635565947, 2.2349851505752243],
            [12.001225709476765, 2.223582084260265],
            [12.00247996826545, 2.2091564577570435],
            [11.998609542812353, 2.2038719303262555],
            [11.990547125169124, 2.1954255680289414],
            [11.987834724069884, 2.1891368387772263],
            [11.98809627974623, 2.1821181604824003],
            [11.993315443491413, 2.165080027289748],
            [11.998083731336871, 2.157154962444866],
            [11.999369741758679, 2.1532437602329275],
            [11.998580717644758, 2.1468558009208176],
            [11.99706092677862, 2.14505731469977],
            [11.991227958761367, 2.1448667536956085],
            [11.979080539919698, 2.1505877574290206],
            [11.969021983959987, 2.1515477231500757],
            [11.963409156524646, 2.149694981534828],
            [11.96085427570996, 2.1453770055071137],
            [11.960347687628566, 2.140571868345485],
            [11.961690248792891, 2.133547539867835],
            [11.96856369875567, 2.122788767993401],
            [11.976249287429276, 2.1150144452225557],
            [11.980820676298764, 2.1049892036320403],
            [11.979954091688317, 2.096164735961951],
            [11.975650911133181, 2.0905273472026638],
            [11.964181040001929, 2.082672454276517],
            [11.961029071188193, 2.0790491700685494],
            [11.914755315695292, 2.073632316111738],
            [11.825989979623046, 2.0652087573191977],
            [11.812606650381236, 2.063690110164259],
            [11.812383479525112, 2.065383633984964],
            [11.781155026552979, 2.0622382357787106],
            [11.730600742547471, 2.056488245494795],
            [11.728907403790105, 2.0574454914396387],
            [11.710911260929935, 2.0553617793133134],
            [11.645685511146239, 2.0472205006515445],
            [11.639250114434164, 2.0953562502555],
            [11.635106784744993, 2.130745159723654]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.98849407900988, "lat": 40.01582958975788 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39013"],
        "coty_name": ["Belmont"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Belmont County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01065575"
      },
      "bbox": [
        11.606698678907616, 2.0472205006515445, 12.004887737669888,
        2.399254611613877
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.186320609036926, 3.7734513957506954],
            [11.19949425289299, 3.7924567269733376],
            [11.213924840708009, 3.820210439346717],
            [11.218904322000228, 3.826935584407657],
            [11.224839681201882, 3.8317781565641766],
            [11.248046603521981, 3.860220653427053],
            [11.251642221913283, 3.862888432217569],
            [11.2629298770382, 3.875220598891264],
            [11.268018629785981, 3.8789323345516453],
            [11.270573467235085, 3.8834693848271957],
            [11.27512843278821, 3.885798970008035],
            [11.282819786192999, 3.8933792360936956],
            [11.28886896893335, 3.9005162716356327],
            [11.305157093773078, 3.9125720086728797],
            [11.31467455473596, 3.923819717549265],
            [11.328510037659989, 3.9243088868342877],
            [11.332241679562381, 3.925010762753498],
            [11.347329688005544, 3.9316889815690637],
            [11.353708305255584, 3.937768034265503],
            [11.359510847082818, 3.939575448510621],
            [11.373406569998213, 3.953066691924908],
            [11.374991466473453, 3.9531704361037767],
            [11.385285039585339, 3.962386055859092],
            [11.387499646074962, 3.9632379149002266],
            [11.407433549835371, 3.9803455813574047],
            [11.409178178242856, 3.982817256372644],
            [11.41909869330086, 3.989384712668809],
            [11.4220923502607, 3.9929536595354707],
            [11.429437382458413, 3.997351372974502],
            [11.433157845811916, 4.000818643811691],
            [11.43772664462578, 4.002294542781636],
            [11.441875696780716, 4.005974373603793],
            [11.448800729195273, 4.009191059216292],
            [11.462047370829408, 4.019420929922437],
            [11.469530170601708, 4.022476748580972],
            [11.477500845072548, 4.029916403193029],
            [11.480322695817618, 4.0303152015094135],
            [11.486104369875862, 4.034804903093329],
            [11.490375505965586, 4.0360614609173595],
            [11.496910391281014, 4.039699864183318],
            [11.50772236000698, 4.049188378070294],
            [11.521431357579294, 3.960303009845099],
            [11.529055960670417, 3.9119705428054607],
            [11.501836129028522, 3.907252997247397],
            [11.456462315612908, 3.899895203940058],
            [11.468532947295314, 3.827656086433899],
            [11.402746029315226, 3.817185018226912],
            [11.327028216099194, 3.8049096390922625],
            [11.33355018208375, 3.760431320841883],
            [11.337155510367845, 3.7342968326007564],
            [11.298276520204132, 3.728451737592212],
            [11.267405177303335, 3.7232394614728426],
            [11.246142312811138, 3.720193553122692],
            [11.233052528507914, 3.717966559714912],
            [11.196300072906237, 3.712624168070196],
            [11.192110796401925, 3.738669732541589],
            [11.190301947514106, 3.7481207488171657],
            [11.186320609036926, 3.7734513957506954]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.23721423233782, "lat": 41.69627537608544 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39085"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01074055"
      },
      "bbox": [
        11.186320609036926, 3.712624168070196, 11.529055960670417,
        4.049188378070294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.789607205091476, 3.4401779504137977],
            [9.845193822392103, 3.4485662853148695],
            [9.851626663990835, 3.4050912079663265],
            [9.893082570981438, 3.41107488633992],
            [9.966186900200707, 3.421414508840338],
            [9.966279729085002, 3.42085854614817],
            [9.994092593182216, 3.424508286928109],
            [10.051179216239277, 3.4317313285026514],
            [10.07236181299474, 3.4350053847825226],
            [10.072640016825753, 3.428054123285544],
            [10.078265401590428, 3.4324490301736597],
            [10.082473527146075, 3.4320236511715874],
            [10.084455215403494, 3.426340661022882],
            [10.091988610111832, 3.4248161265794743],
            [10.094838217127114, 3.421472225459061],
            [10.096878825058994, 3.4096523729829245],
            [10.103672731582249, 3.409466245809631],
            [10.104688799946455, 3.4137848323456943],
            [10.101576205633027, 3.4153324560114737],
            [10.101273390140484, 3.4183516823443414],
            [10.105947313823771, 3.4234540822916077],
            [10.107420906425473, 3.427145985280116],
            [10.112358521247739, 3.429503582724954],
            [10.111650019326145, 3.43406537891614],
            [10.1185933733331, 3.437365558745461],
            [10.123106637487263, 3.4334545470318782],
            [10.12690452599929, 3.4256571058853784],
            [10.1331069599284, 3.41946045966976],
            [10.136859518837214, 3.4113176004097654],
            [10.14231619773639, 3.4084716516191826],
            [10.148889354552944, 3.406451468962194],
            [10.151078067537842, 3.408072922452739],
            [10.157442380815294, 3.408592268487818],
            [10.161282798946148, 3.4075150823350064],
            [10.164602823049336, 3.4110453985341898],
            [10.171583578444528, 3.415509884887289],
            [10.17681598832631, 3.4219038499271814],
            [10.21676720982797, 3.4274674846970683],
            [10.233688596791128, 3.3303322122271024],
            [10.240897901525374, 3.28811523320743],
            [10.246748428738924, 3.2536842947005415],
            [10.161030968859288, 3.242514760177918],
            [10.119431373494761, 3.2366712572300638],
            [10.103967987972098, 3.235084414488045],
            [10.074646563996918, 3.2315217168120527],
            [10.031231695711414, 3.225111466767362],
            [9.989940260527474, 3.2180014041085427],
            [9.968979785089934, 3.2134792926331235],
            [9.933927116979817, 3.2088081855095263],
            [9.919492800053415, 3.207146108987842],
            [9.897446719190983, 3.2051911457936204],
            [9.818516847526483, 3.1940769028280944],
            [9.808790341429313, 3.2813951113266087],
            [9.798616076218664, 3.368099616499314],
            [9.789607205091476, 3.4401779504137977]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.14646202003922, "lat": 41.35614390910011 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39143"],
        "coty_name": ["Sandusky"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sandusky County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01074084"
      },
      "bbox": [
        9.789607205091476, 3.1940769028280944, 10.246748428738924,
        3.4485662853148695
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.177942887018173, 2.198638853993854],
            [9.17809214781404, 2.198936401001377],
            [9.17546479853559, 2.2226983189971246],
            [9.218375856817428, 2.2281025825037837],
            [9.246788841501143, 2.2319543788843195],
            [9.241322268446977, 2.2763002595722672],
            [9.233877816597802, 2.334301035318843],
            [9.299908628516386, 2.343222208994451],
            [9.322695103076548, 2.3464844876817232],
            [9.360924718324583, 2.3514201177159655],
            [9.393077489972324, 2.3558037968805334],
            [9.40719239963779, 2.357986761209232],
            [9.485572171040406, 2.3678347107977804],
            [9.497636944715929, 2.2754518124435092],
            [9.495503738993019, 2.2748714013028075],
            [9.498585198234354, 2.2532599645512446],
            [9.506192650338624, 2.197513913651663],
            [9.500681832565306, 2.201137501278631],
            [9.502906185284559, 2.1569863927447988],
            [9.508139186767513, 2.066669750748122],
            [9.422005882821782, 2.062492401360562],
            [9.3592913324493, 2.059722964428509],
            [9.35908914453602, 2.0642755764007874],
            [9.3368549036057, 2.0606031933443076],
            [9.308813614426228, 2.05645245334712],
            [9.235320945947942, 2.04623332027303],
            [9.227289909897305, 2.0455811703777926],
            [9.198743057099191, 2.0414784775057884],
            [9.197639156829592, 2.050759756035047],
            [9.193750930179872, 2.0760700269663],
            [9.18150598746686, 2.1696539603920675],
            [9.177942887018173, 2.198638853993854]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.20475031823014, "lat": 40.33153281350925 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39149"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01074087"
      },
      "bbox": [
        9.17546479853559, 2.0414784775057884, 9.508139186767513,
        2.3678347107977804
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.095934082284515, 3.399256311814878],
            [11.131875732327384, 3.4050639933106224],
            [11.16545518730152, 3.4102391037517115],
            [11.181367751125096, 3.412974187598334],
            [11.185488182974153, 3.4143406791316044],
            [11.182257270980479, 3.424640264812822],
            [11.17790885958136, 3.4256362801344005],
            [11.174951371145774, 3.435300586268126],
            [11.169983106825786, 3.4396986954452946],
            [11.164444083103328, 3.441954885388455],
            [11.164730737111013, 3.448939336668117],
            [11.161147804166774, 3.4525546669549874],
            [11.160789482468717, 3.4565051487511056],
            [11.157057721914068, 3.460180277625453],
            [11.158455014577862, 3.4689774902198103],
            [11.157343910235193, 3.4752607693782744],
            [11.152329114453957, 3.47540085677215],
            [11.148721241497478, 3.4826031190885036],
            [11.20141188533204, 3.489969364059778],
            [11.207179502282965, 3.4905253666000085],
            [11.2952127528, 3.5024569045326426],
            [11.301067064378215, 3.5030554941018335],
            [11.310929374289232, 3.4391969521408656],
            [11.317491184730022, 3.3950928891106518],
            [11.323333833156457, 3.3584319037490142],
            [11.32377898068397, 3.3541033624468617],
            [11.332688633073545, 3.2956259151489897],
            [11.33352958285996, 3.2914048725354874],
            [11.34742154723077, 3.1969334188599827],
            [11.355440258353191, 3.145086751752945],
            [11.338373623567989, 3.14237271018931],
            [11.343090204393018, 3.1045468814429418],
            [11.348020187215162, 3.060362530602199],
            [11.290778270401486, 3.0539936547036715],
            [11.239901006079304, 3.048803074145779],
            [11.188759219399762, 3.0433433729587516],
            [11.178440596570235, 3.0420425651415504],
            [11.167166415750804, 3.11625569229472],
            [11.136964357244931, 3.1117008683840095],
            [11.13186724145604, 3.148681172924044],
            [11.11940407131408, 3.233223580525335],
            [11.115784130215477, 3.258542955300551],
            [11.106766919195925, 3.324544162742622],
            [11.095934082284515, 3.399256311814878]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.53215419129974, "lat": 41.12596680023016 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39153"],
        "coty_name": ["Summit"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Summit County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01074088"
      },
      "bbox": [
        11.095934082284515, 3.0420425651415504, 11.355440258353191,
        3.5030554941018335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.45526916714393, 3.3095810088477893],
            [9.462658269950674, 3.3124199026970738],
            [9.466950439392818, 3.311325360195574],
            [9.476601381183126, 3.31225529550126],
            [9.478342290386092, 3.3149559444390446],
            [9.478973861875348, 3.3204916948288785],
            [9.481676576306885, 3.323642508907599],
            [9.489941067981592, 3.327548437112073],
            [9.493495986835882, 3.3303669685874144],
            [9.501454921734714, 3.3335574319134507],
            [9.50699516944782, 3.338559684332125],
            [9.509077793705025, 3.338810614852005],
            [9.519321946513392, 3.349295469307478],
            [9.526304323262789, 3.354782641561171],
            [9.527129354594821, 3.3576302292719507],
            [9.525674174888408, 3.3643732213652404],
            [9.53006300968957, 3.3690179221382697],
            [9.536393236811772, 3.3684519276340152],
            [9.543994268364502, 3.3700148588444665],
            [9.549794652980072, 3.375926991011315],
            [9.552606095466833, 3.3860948142952845],
            [9.557292985991221, 3.3939126823322994],
            [9.564717989179906, 3.3968594041725377],
            [9.568012915588076, 3.3992791779976472],
            [9.57145068551535, 3.4067697097449776],
            [9.569296796874095, 3.4112003030952747],
            [9.570273310701161, 3.41751209818539],
            [9.569600433517044, 3.434503551973341],
            [9.575146907896182, 3.446207708024528],
            [9.578673384197183, 3.4513321253161204],
            [9.58794128911564, 3.460963864819832],
            [9.598270254457447, 3.464735063171372],
            [9.60199345873074, 3.4694806788910433],
            [9.607451320471336, 3.4724239215347668],
            [9.61306373820462, 3.4787353343062177],
            [9.618556098370663, 3.478539367989527],
            [9.621763987286462, 3.4814943824165026],
            [9.625005477317808, 3.4893231172398194],
            [9.634410108650716, 3.491262987990588],
            [9.63643858423506, 3.4940675022434244],
            [9.636632957476046, 3.4988576389370456],
            [9.641211177245866, 3.5078755469502103],
            [9.645480812367536, 3.5112781968338687],
            [9.648629590231184, 3.52375908578068],
            [9.652506069878449, 3.528426344755303],
            [9.654453529533225, 3.5346666183044215],
            [9.659818458294932, 3.5416597920723523],
            [9.663781209345254, 3.5427187781070852],
            [9.701888682592283, 3.5479656693081814],
            [9.772823254185788, 3.5585765107068816],
            [9.787677672386161, 3.4549133735516318],
            [9.789607205091476, 3.4401779504137977],
            [9.798616076218664, 3.368099616499314],
            [9.808790341429313, 3.2813951113266087],
            [9.818516847526483, 3.1940769028280944],
            [9.829225036659627, 3.1069292567966027],
            [9.797000851392275, 3.102301770432592],
            [9.770977306905491, 3.098165866716004],
            [9.737780865184012, 3.094364629502344],
            [9.710130163417018, 3.091600106224282],
            [9.6601339485046, 3.085551298782594],
            [9.602401000434952, 3.0789226214314285],
            [9.488427706461014, 3.0635234526935253],
            [9.480293102793517, 3.1215209182795207],
            [9.476421061862387, 3.150555766221081],
            [9.466223773328798, 3.2233866042242805],
            [9.46242610093595, 3.2522827423848115],
            [9.45526916714393, 3.3095810088477893]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.62300196044566, "lat": 41.36168007257786 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39173"],
        "coty_name": ["Wood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wood County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "01074098"
      },
      "bbox": [
        9.45526916714393, 3.0635234526935253, 9.829225036659627,
        3.5585765107068816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2607181064015136, -3.5683284815958864],
            [-2.1189267715565965, -3.573337371506352],
            [-2.089298074557833, -3.5742415030198322],
            [-2.017921965827412, -3.5766519548991105],
            [-1.923663213211406, -3.5798031287131455],
            [-1.7654315334046649, -3.5846162427381283],
            [-1.7569645086932817, -3.594413506435905],
            [-1.7541240710434256, -3.5995446123141237],
            [-1.7525782230017126, -3.590477990760425],
            [-1.7504170080771924, -3.5892469079661393],
            [-1.745539776300497, -3.5902839451233803],
            [-1.743184390258348, -3.5877671365838246],
            [-1.7404032405319523, -3.590175973745477],
            [-1.7360098226755871, -3.5971272153177694],
            [-1.7319148830145983, -3.595489465816385],
            [-1.728592598091107, -3.591547538912183],
            [-1.7227220177301836, -3.5903061333512247],
            [-1.7191485987192712, -3.5934979501437443],
            [-1.7081033370923813, -3.5947309097940217],
            [-1.7049350554486287, -3.5930676830737935],
            [-1.7053777447991842, -3.5887419800320384],
            [-1.7029967785112838, -3.5837120358819385],
            [-1.6964250535894407, -3.584819701837941],
            [-1.6908281899981432, -3.5804795134047342],
            [-1.6866753638607404, -3.5791672733896616],
            [-1.6827516382181915, -3.5819301357693725],
            [-1.6854449901487636, -3.588405185139029],
            [-1.6816501511465827, -3.591764547604174],
            [-1.6780102990419348, -3.590183822755889],
            [-1.6758751480265857, -3.5802791011879633],
            [-1.6728316172314694, -3.5822103764398716],
            [-1.6688154059663394, -3.5873064093426184],
            [-1.6684670878478238, -3.593382530814648],
            [-1.6657205308072613, -3.594636579279326],
            [-1.6654482059504547, -3.6015050481838786],
            [-1.6618078472427773, -3.6062507591897623],
            [-1.663838378643385, -3.6895998155774916],
            [-1.6657148008580018, -3.7626479616818043],
            [-1.6663322131969727, -3.7918771648472562],
            [-1.6673032809865238, -3.8209811673313765],
            [-1.6678360011245417, -3.8501538829066715],
            [-1.6723445346269243, -3.8505772815667774],
            [-1.6998781818663684, -3.849227551062051],
            [-1.772435204610595, -3.8471433813337135],
            [-1.8041168534846257, -3.8460282855661236],
            [-1.8355869304729255, -3.8455768950315754],
            [-1.8373426476526247, -3.9078878877731418],
            [-1.837994760650482, -3.919184180609798],
            [-1.840933761262256, -4.020214209350099],
            [-1.843375223375317, -4.10770395564867],
            [-1.9862790849197063, -4.103380400058672],
            [-1.984827406550054, -4.0596524752877405],
            [-2.0681205646965366, -4.056905027067605],
            [-2.062871892138612, -4.049198964710719],
            [-2.0614712687959518, -4.042260040218186],
            [-2.060718659613708, -4.025989713848918],
            [-2.0593964600599777, -4.023588356061588],
            [-2.0532672848226268, -4.019475167026819],
            [-2.046650722114897, -4.021992740122001],
            [-2.038699026013032, -4.020289043023938],
            [-2.028555569235745, -4.0207540480006605],
            [-2.018066494616856, -4.018970632807564],
            [-2.017693778050239, -4.012343919308818],
            [-2.012787313471674, -4.009644601151408],
            [-2.0145702715231413, -4.004585274357795],
            [-2.019545729769945, -4.003802399799159],
            [-2.0247591395330096, -3.994298608754315],
            [-2.032242608705625, -3.994127841676701],
            [-2.0484386823512066, -3.996787632564845],
            [-2.0531273518674245, -3.9983425852662093],
            [-2.062507455405382, -3.999446885057967],
            [-2.0666187766557096, -3.9985542203729882],
            [-2.068227344119014, -3.9958057222144756],
            [-2.075144047762735, -3.9955828853231883],
            [-2.0875574687647234, -3.991813662854083],
            [-2.096633974442498, -3.992570583028423],
            [-2.103457890605372, -3.990936301038933],
            [-2.1067264092857116, -3.9885446352468046],
            [-2.111031007926147, -3.9826604211995495],
            [-2.1114441245807214, -3.9794654212626517],
            [-2.1073394187483463, -3.974461650926749],
            [-2.106863997533998, -3.9704204457930214],
            [-2.112191474781338, -3.961298457728179],
            [-2.113101477891444, -3.956749201035829],
            [-2.112025727572311, -3.950998661946593],
            [-2.117939811241502, -3.9499013144328408],
            [-2.12099192256333, -3.945811968716727],
            [-2.121172833158986, -3.9370654079707865],
            [-2.113878600842869, -3.941505252017974],
            [-2.111375117489746, -3.938384664712984],
            [-2.114006872754541, -3.9338695917224316],
            [-2.1096710514163384, -3.9314328125584392],
            [-2.1038911672359926, -3.9324557217452565],
            [-2.1035506447421963, -3.9290548691120466],
            [-2.1087111890535426, -3.927775714580618],
            [-2.1129036857828356, -3.923946591576291],
            [-2.1144721201662975, -3.9187771734964936],
            [-2.113706131476002, -3.914168428485068],
            [-2.113861136468488, -3.903971694636617],
            [-2.111396761471797, -3.899327628157206],
            [-2.1041797083678597, -3.9006762365411087],
            [-2.1010175577858816, -3.898822066928168],
            [-2.1001508499688444, -3.894562628218451],
            [-2.103784403284734, -3.887570262644872],
            [-2.101894781045312, -3.8750902138665912],
            [-2.1029744490019744, -3.8648167981215207],
            [-2.0969944670882334, -3.8666303016803147],
            [-2.095974982151933, -3.8625386759938953],
            [-2.1015189601564357, -3.8605544321858347],
            [-2.1024988827916173, -3.856739901860969],
            [-2.0998480948764153, -3.8492190896195],
            [-2.0947237798745344, -3.845516697991879],
            [-2.0970089634531446, -3.8421422298924637],
            [-2.1025749415077613, -3.844192961571411],
            [-2.1114798888721165, -3.844587092643131],
            [-2.116606744797707, -3.842985979361002],
            [-2.117882494157141, -3.8365095135461402],
            [-2.124879339025495, -3.8319873346783933],
            [-2.132044107654613, -3.8331308506374038],
            [-2.1341330900313995, -3.8347209420562165],
            [-2.1346107305530677, -3.8475708943031486],
            [-2.1415588378214823, -3.853679857341422],
            [-2.1477170034666018, -3.851121902279899],
            [-2.151151093346017, -3.852344011138731],
            [-2.1521042134676245, -3.8571319493597014],
            [-2.1500172842298824, -3.8596456209023735],
            [-2.152566933595429, -3.864172244539679],
            [-2.157463728167523, -3.8611024774365954],
            [-2.1620120496583115, -3.86178003777946],
            [-2.165830062134261, -3.864972673604096],
            [-2.1683037840094213, -3.873950852688272],
            [-2.172519141213157, -3.874155908320508],
            [-2.175970061193114, -3.87182679229142],
            [-2.1786627022134395, -3.8678653456261642],
            [-2.181075754879799, -3.8608650128830653],
            [-2.18599665127597, -3.853292528620342],
            [-2.1972643583837654, -3.848127448941579],
            [-2.203675076036352, -3.8496335807283844],
            [-2.2068402768404187, -3.839862780586136],
            [-2.211339078424813, -3.8365241838567075],
            [-2.2183011549426803, -3.836996264160964],
            [-2.226036583207554, -3.8304779860810765],
            [-2.2297618990262738, -3.821839089045886],
            [-2.234543174235322, -3.8162308398086147],
            [-2.235039238030996, -3.809727575285977],
            [-2.2328937050540407, -3.8020526622007615],
            [-2.2288074738683035, -3.7990585203844014],
            [-2.2251114243059984, -3.7988184502651348],
            [-2.217873093033831, -3.801445628336866],
            [-2.2126003086341695, -3.801692490742594],
            [-2.2138087216937965, -3.792618256218184],
            [-2.217391338194648, -3.791175283724124],
            [-2.216382503833957, -3.786993448659945],
            [-2.210894221683945, -3.7859729951479606],
            [-2.2115606430986032, -3.7828075081046397],
            [-2.216672484160413, -3.7706949577668465],
            [-2.2173436340316237, -3.763889143652504],
            [-2.2291368758217702, -3.7622794329813756],
            [-2.2310177460052985, -3.759699653612588],
            [-2.226629024792687, -3.7549213793034744],
            [-2.23491418914715, -3.7455551750810647],
            [-2.238022234815218, -3.745866611644861],
            [-2.242961452719132, -3.742159509977449],
            [-2.2411572200741006, -3.7348998378497966],
            [-2.244822656938349, -3.713890186030845],
            [-2.2477985636398206, -3.713368991602584],
            [-2.2527995263773306, -3.7152891297467416],
            [-2.2556245555072723, -3.7029209893314365],
            [-2.244857231002811, -3.6980944192738416],
            [-2.2442458812525428, -3.695295037613324],
            [-2.2456293487665744, -3.6888304810635817],
            [-2.242004744518757, -3.676210627562688],
            [-2.2389534846767836, -3.6747533390637477],
            [-2.237045641979287, -3.6676926735233017],
            [-2.2391396334030955, -3.6639495011152374],
            [-2.2430652232569344, -3.6638272148202295],
            [-2.2442573560812917, -3.6607862011319092],
            [-2.2350212812350216, -3.6559104438499928],
            [-2.2337827037352436, -3.6480858229308275],
            [-2.237077845646128, -3.644743757234363],
            [-2.2416338627948487, -3.6457154092962742],
            [-2.2490077482541793, -3.6449794592510236],
            [-2.255190100619115, -3.642087078811077],
            [-2.2546666278251544, -3.6349494352363183],
            [-2.256450477960176, -3.6328682194966766],
            [-2.2604317352614935, -3.634499586574516],
            [-2.2649549253040275, -3.634459804395472],
            [-2.2708708961282604, -3.6325202327582007],
            [-2.272804122045029, -3.624765718956628],
            [-2.266491795163674, -3.6236192817273642],
            [-2.266584806896351, -3.6198106971529973],
            [-2.2690219969672687, -3.6127342768314854],
            [-2.2699572459599837, -3.605786398229334],
            [-2.2682079862434636, -3.5983220274226775],
            [-2.274375893437599, -3.5967910622457584],
            [-2.274782922676688, -3.5929932790240655],
            [-2.2819964732279296, -3.5910488542413423],
            [-2.284583523284734, -3.5956618460597563],
            [-2.29229243632506, -3.5899154367388078],
            [-2.2914665465082114, -3.5864616680493864],
            [-2.2946964378590935, -3.584475754372449],
            [-2.2918247678332166, -3.58137304865492],
            [-2.2928019201837526, -3.577115478759022],
            [-2.298784852982892, -3.5730465318104496],
            [-2.300563506827968, -3.569156979395025],
            [-2.3004711769049964, -3.5667245277030197],
            [-2.2607181064015136, -3.5683284815958864]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.98087261914017, "lat": 34.91634928164594 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40075"],
        "coty_name": ["Kiowa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kiowa County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01101825"
      },
      "bbox": [
        -2.300563506827968, -4.10770395564867, -1.6618078472427773,
        -3.5667245277030197
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.3333352511059196, -4.66384466789722],
            [-0.3320531030479671, -4.6638767778162995],
            [-0.3313025251265665, -4.561744790523338],
            [-0.30263389840547555, -4.561966441445644],
            [-0.26654463524141414, -4.562587739491568],
            [-0.15391529565105985, -4.563483179958865],
            [-0.08628249404552865, -4.564013760269561],
            [-0.08609988293048566, -4.5674487066134715],
            [-0.08262504084298623, -4.5677693875241925],
            [-0.07501725998433802, -4.575471896113445],
            [-0.06951000843021991, -4.573915366567952],
            [-0.06448597538269975, -4.568639284932506],
            [-0.060562118592947925, -4.568628495042653],
            [-0.0590770868582735, -4.572329212700542],
            [-0.06200185050864716, -4.573795373313065],
            [-0.06272987901744699, -4.5783632158381256],
            [-0.05248005333610058, -4.583152820461194],
            [-0.04967649230393823, -4.57631121626071],
            [-0.04516105551389805, -4.575673674295159],
            [-0.04471861718510683, -4.582857042838428],
            [-0.03975743480722053, -4.584960452728005],
            [-0.03703857504727121, -4.590092929308438],
            [-0.04037271281441464, -4.5950026880795605],
            [-0.03465531993416404, -4.597155773150851],
            [-0.03147614597459854, -4.5913879685839305],
            [-0.02797391422119389, -4.596671651562654],
            [-0.02979913626007881, -4.601495811598132],
            [-0.019746682985744547, -4.6104380972559245],
            [-0.014565496244385523, -4.611892229115843],
            [-0.014212487791118203, -4.615809759855796],
            [-0.017182776300828987, -4.622792556888588],
            [-0.01582523880782151, -4.626088382537875],
            [-0.012106465566499644, -4.629314162293555],
            [-0.013984695395421139, -4.632505811868463],
            [-0.0047855452042298696, -4.642462714236561],
            [-0.0012408016109230634, -4.649027343062845],
            [-0.0038548395276694217, -4.651426285471989],
            [-0.0004413301580318324, -4.655406758785317],
            [0.00682735059657348, -4.656363428916333],
            [0.0044619827214602715, -4.659387750751418],
            [-0.00009437610604220414, -4.660359235566597],
            [0.0031220999481666773, -4.664117342594945],
            [0.006786723022258149, -4.663706928840538],
            [0.010996222549210089, -4.665857517554992],
            [0.01350656532883263, -4.674003914020721],
            [0.006606065447812577, -4.681321453217792],
            [0.004903138634511211, -4.687199595557892],
            [-0.002979388225422256, -4.689678811594313],
            [-0.004652656099610061, -4.6938937601263735],
            [-0.008705830788187046, -4.695615843456921],
            [-0.010286316414089957, -4.703839074482728],
            [-0.01328613463018774, -4.706436899481287],
            [-0.0075716912443061545, -4.709061330141794],
            [-0.012436671112459054, -4.714136351417393],
            [-0.00853101318066196, -4.721046734928506],
            [-0.012563693045308156, -4.728592847154292],
            [-0.015870951272812645, -4.730847133675267],
            [-0.021665606919690796, -4.726357008402932],
            [-0.024426154022986937, -4.720900231138016],
            [-0.03178172220699225, -4.723398721724382],
            [-0.03342557351640254, -4.729739724220262],
            [-0.043857862390916436, -4.727323168214357],
            [-0.049098015027381356, -4.7351125298422],
            [-0.041741446660291254, -4.7405836580767],
            [-0.04047228914994726, -4.747786412082914],
            [-0.0333105976826663, -4.752351613656341],
            [-0.03419502525009423, -4.757203852909164],
            [-0.030379080838972703, -4.7583154016019105],
            [-0.028686044403441874, -4.762870536950588],
            [-0.02489271250730307, -4.763706541530585],
            [-0.024897292533007816, -4.76680106992936],
            [-0.017526106473506272, -4.766929943693579],
            [-0.017283539947685875, -4.771374412070867],
            [-0.01124457912201091, -4.773518692036424],
            [-0.011928073142916567, -4.779494641581978],
            [-0.015311817694508748, -4.782998222489907],
            [-0.018653453790344283, -4.7840380161708635],
            [-0.017375769634456122, -4.787523782659557],
            [-0.020311137190516335, -4.789930435092092],
            [-0.022770312024050547, -4.786722472119423],
            [-0.027375404972418554, -4.792233942716517],
            [-0.02391004554381584, -4.7974241176812855],
            [-0.022883072790666502, -4.8020237183173755],
            [-0.02473488076852688, -4.805007081000569],
            [-0.020758537587256876, -4.811321535749144],
            [-0.014795523866262601, -4.8130457314610124],
            [-0.015267731051749226, -4.817784478317763],
            [-0.019726034894661505, -4.822399347367804],
            [-0.014788693041314192, -4.822673529123848],
            [-0.015477579204033561, -4.8282129613440095],
            [-0.02126834148289742, -4.832783342971035],
            [-0.023145163228031517, -4.836105668834057],
            [-0.019995534255047114, -4.841156582790383],
            [-0.021152125649306373, -4.843258535206604],
            [-0.024796667983944063, -4.842498175929478],
            [-0.03684282360429431, -4.843306779903455],
            [-0.05392582028556337, -4.843455108528097],
            [-0.06682894875391228, -4.831839386681672],
            [-0.07980781835422535, -4.821004719538736],
            [-0.08581128574549743, -4.820687876216924],
            [-0.09100238989240324, -4.825331711840507],
            [-0.0972946595289443, -4.841423767462305],
            [-0.09945522946674518, -4.853441657171955],
            [-0.09849586588392986, -4.863829199985979],
            [-0.10065063988302889, -4.874826543784765],
            [-0.10567520977117725, -4.887785217433719],
            [-0.1130650489889052, -4.898682234680934],
            [-0.11712112873096929, -4.902695395980822],
            [-0.12371414310567114, -4.9060470265096106],
            [-0.151479838129469, -4.911790765604972],
            [-0.16431330404762728, -4.912987135539189],
            [-0.17071224571928517, -4.909853414639236],
            [-0.17668510877276983, -4.8952519690304355],
            [-0.17699361418434545, -4.889040227210426],
            [-0.17887982643075312, -4.879210912879708],
            [-0.1820456152293456, -4.873568729413616],
            [-0.19089480840903741, -4.868123139095374],
            [-0.20611122434836612, -4.864220570233034],
            [-0.22206272301620933, -4.861885629805246],
            [-0.22840054443855756, -4.868293754723129],
            [-0.23003387707597037, -4.883840311208085],
            [-0.2336169617889794, -4.8877424209167355],
            [-0.23750497096093734, -4.889478497361806],
            [-0.24203414845685053, -4.889157927850534],
            [-0.25051299970950847, -4.883400994008804],
            [-0.2577343276849468, -4.875951141991662],
            [-0.2640346596246908, -4.86835039578225],
            [-0.2742469053901539, -4.839750423802049],
            [-0.2753925057894359, -4.83317407209816],
            [-0.27469676557541006, -4.8227758394732225],
            [-0.27695101185026816, -4.802263492516804],
            [-0.28160677147509927, -4.788674217155201],
            [-0.2865499806447767, -4.781858862599636],
            [-0.29059936621051136, -4.77796647741938],
            [-0.2953681541721596, -4.776132268693774],
            [-0.3058553134910134, -4.7812716106991395],
            [-0.30530972376536414, -4.722463545305303],
            [-0.3340218134572271, -4.722153735957467],
            [-0.3333352511059196, -4.66384466789722]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.76900457501395,
          "lat": 34.024475639781706
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40095"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01101832"
      },
      "bbox": [
        -0.3340218134572271, -4.912987135539189, 0.01350656532883263,
        -4.561744790523338
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.776251559959864, 9.92577997874028],
            [-18.70664965115966, 9.904707320822226],
            [-18.69215024953546, 9.901182750545512],
            [-18.609671813677082, 9.876423400495012],
            [-18.612692221927304, 9.866896605352517],
            [-18.6015167631537, 9.864265428335633],
            [-18.587714611868783, 9.860120391018157],
            [-18.567763742773774, 9.855628593824736],
            [-18.56169175176444, 9.853342112684361],
            [-18.509825004230464, 9.838953908882818],
            [-18.495646092645202, 9.83442016560051],
            [-18.45484539464507, 9.823063594413215],
            [-18.45363131811737, 9.827190451599398],
            [-18.371116083103416, 9.802602981854275],
            [-18.37733519115084, 9.781991160489223],
            [-18.390829810203776, 9.735552295463963],
            [-18.473667251942544, 9.759854347840928],
            [-18.482345762094827, 9.732067379365759],
            [-18.4684246253274, 9.72801137425609],
            [-18.472269384931202, 9.714611308893138],
            [-18.458644737281954, 9.710606151249547],
            [-18.46282207256383, 9.69697948601679],
            [-18.448862857032953, 9.692834118831126],
            [-18.453152896107124, 9.679243196976273],
            [-18.424398991107, 9.670401131753643],
            [-18.428608813670117, 9.657481017338233],
            [-18.414851237020798, 9.653994964586527],
            [-18.401604090224982, 9.649820178367603],
            [-18.405674311237124, 9.635851635404642],
            [-18.37829057782764, 9.627656431247534],
            [-18.382199957242204, 9.614169892425231],
            [-18.396273687252545, 9.618236564528212],
            [-18.400183205776816, 9.604677123803086],
            [-18.427770098170996, 9.612822406471581],
            [-18.43597814309023, 9.585529429480928],
            [-18.463398099472546, 9.593712194689052],
            [-18.467562737528606, 9.5800990225627],
            [-18.480929830498802, 9.583731873610496],
            [-18.484926048322425, 9.57053537745606],
            [-18.49894926761252, 9.57433981298453],
            [-18.502110836589583, 9.559028817678577],
            [-18.506369905181426, 9.545815608815143],
            [-18.519769083630173, 9.550037092182421],
            [-18.52868608365987, 9.522349125659652],
            [-18.534209288834678, 9.508688456408004],
            [-18.54873937414383, 9.512822770751736],
            [-18.553144206095617, 9.4997718771656],
            [-18.5388493143221, 9.495715530220002],
            [-18.54396821597032, 9.480807064886756],
            [-18.55509192915027, 9.43995796279079],
            [-18.564231196557387, 9.405273813233531],
            [-18.581306894895302, 9.350497886301023],
            [-18.58705381529634, 9.331300279674958],
            [-18.59980311556948, 9.290116067318204],
            [-18.613015807223903, 9.293810411556953],
            [-18.69612700043478, 9.31870245400829],
            [-18.701033965988046, 9.320714909255882],
            [-18.721556102773704, 9.326770413385846],
            [-18.728753632475343, 9.328388721862346],
            [-18.78744021290825, 9.34540800417014],
            [-18.816296816538802, 9.353999112178522],
            [-18.82011656053301, 9.340496965019595],
            [-18.8284499697218, 9.313348991051004],
            [-18.83330957484706, 9.30069504944472],
            [-18.83669037400504, 9.286207233733629],
            [-18.853077892848972, 9.233261731650567],
            [-18.856222724161054, 9.221809609226499],
            [-18.815891615117994, 9.209966036942376],
            [-18.816054304896127, 9.20944573099647],
            [-18.82540776582656, 9.179410080182404],
            [-18.86593638355535, 9.191744910137567],
            [-18.95097064040507, 9.218047723813854],
            [-18.98888697860051, 9.229427345493068],
            [-18.98914840049908, 9.228592699814474],
            [-19.002376384821186, 9.232335224199941],
            [-19.017257177601145, 9.237168261664637],
            [-19.01719834607237, 9.239492161101595],
            [-19.02201008697046, 9.24355922228917],
            [-19.016216488677188, 9.257262907482843],
            [-19.010189978702336, 9.268015866934702],
            [-19.003137257850913, 9.273452100519885],
            [-18.995994859119744, 9.277440993037706],
            [-18.989936862620436, 9.27963115412585],
            [-18.965483067718427, 9.325404068382001],
            [-18.954223669475912, 9.35016111176074],
            [-18.944420978691525, 9.376626455507127],
            [-18.94301281969994, 9.391607274978565],
            [-18.944767764717763, 9.39541812077014],
            [-18.939096551516887, 9.401479247005321],
            [-18.92140554329297, 9.442190544119123],
            [-18.915316488472655, 9.447145634168196],
            [-18.91748822410932, 9.450950548523181],
            [-18.9081074757893, 9.485222470976927],
            [-18.90821450196657, 9.505735911075995],
            [-18.911525542307487, 9.508750842799664],
            [-18.931673883515245, 9.512674442988947],
            [-18.930647256348312, 9.515385232005613],
            [-18.909652741031035, 9.51733598753769],
            [-18.903354943764114, 9.522738888090247],
            [-18.88907442684494, 9.550891554982444],
            [-18.872682884434294, 9.591893193120246],
            [-18.870070611096324, 9.603920177860223],
            [-18.86972683648224, 9.609901965333869],
            [-18.871549890732037, 9.629220642814317],
            [-18.8668429815352, 9.633779371453183],
            [-18.864352000709236, 9.64180339591344],
            [-18.868559937092922, 9.648438642665365],
            [-18.86135950152042, 9.653140555858528],
            [-18.858397659069585, 9.65216290573654],
            [-18.854460129612892, 9.6548578405479],
            [-18.84758928129011, 9.6664272090264],
            [-18.831996711345116, 9.697807898368662],
            [-18.826381655758233, 9.716149816487134],
            [-18.82935901844047, 9.723704790199214],
            [-18.822033923945227, 9.736954883750625],
            [-18.794405754225394, 9.797607809388145],
            [-18.7916903000847, 9.800044672255813],
            [-18.79188499956475, 9.806835148590546],
            [-18.783845096489657, 9.831241512099934],
            [-18.775143276551557, 9.867798871557747],
            [-18.775285159488636, 9.874237693482883],
            [-18.780622675150376, 9.884557680385669],
            [-18.78356403789204, 9.887376716299427],
            [-18.784432080042638, 9.89526953554825],
            [-18.783344400334002, 9.89979171821597],
            [-18.780264715636992, 9.901488087669293],
            [-18.782537561090894, 9.908178691696603],
            [-18.79066697335917, 9.908928769328767],
            [-18.789928805356805, 9.914400548039355],
            [-18.78569462567245, 9.918143958497891],
            [-18.782232657104004, 9.919087976232301],
            [-18.777340343288937, 9.92277078291518],
            [-18.776251559959864, 9.92577997874028]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.71256096330833,
          "lat": 45.46364170774433
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41057"],
        "coty_name": ["Tillamook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tillamook County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01135864"
      },
      "bbox": [
        -19.02201008697046, 9.179410080182404, -18.371116083103416,
        9.92577997874028
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.442690487561059, 4.731037039509437],
            [14.447207549225311, 4.732055321192163],
            [14.5709215248881, 4.7571711980119895],
            [14.651731891826405, 4.77284264301022],
            [14.709964142174817, 4.784194309446115],
            [14.779236644825733, 4.7973055031897545],
            [14.864897893795202, 4.814556779392628],
            [14.922201826165104, 4.826795298391018],
            [15.007884910379527, 4.845187532975031],
            [15.031282425044775, 4.763310695466008],
            [15.042359542684485, 4.723885442192802],
            [15.067967773595965, 4.633550713149692],
            [15.069784216160711, 4.623995262843864],
            [15.071485513972116, 4.620558010902278],
            [15.087010021475907, 4.565667365266743],
            [15.102409698329913, 4.508939017178179],
            [15.06653136470631, 4.498629385980958],
            [15.04315623038271, 4.492314536755754],
            [15.044193424866654, 4.477084124985746],
            [15.04799369021542, 4.4140207731058085],
            [15.049321143473323, 4.384211098699397],
            [14.97700401751685, 4.377427395969121],
            [14.863817490869286, 4.366167485524526],
            [14.800134882870948, 4.360143143580888],
            [14.708889897472309, 4.351630979668414],
            [14.623517904278563, 4.343655319572958],
            [14.60776769933029, 4.342709091685529],
            [14.562034090616566, 4.340452292222408],
            [14.554419488809367, 4.362924154621425],
            [14.549206834367633, 4.382994803504993],
            [14.540870779748492, 4.41009735558251],
            [14.50492706085867, 4.531364397238911],
            [14.501818648219908, 4.544664151108501],
            [14.49222255851804, 4.573522273371058],
            [14.469397652287919, 4.647603872067806],
            [14.447146637174576, 4.717399814275426],
            [14.442690487561059, 4.731037039509437]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.51535788193206, "lat": 41.78869257999462 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42015"],
        "coty_name": ["Bradford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bradford County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01213660"
      },
      "bbox": [
        14.442690487561059, 4.340452292222408, 15.102409698329913,
        4.845187532975031
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.294610074858761, 2.8519637549922865],
            [14.304016203576062, 2.840262311851956],
            [14.311565996416322, 2.848567923574833],
            [14.313361933176703, 2.853545214822867],
            [14.319003377003353, 2.8621907952801116],
            [14.320023348443812, 2.865235465265292],
            [14.333637941483817, 2.8806982389524505],
            [14.348401091437943, 2.8835872057453593],
            [14.35350781663541, 2.8886240499856766],
            [14.354644349057851, 2.8915054788692824],
            [14.362036566581537, 2.8980092721791606],
            [14.365277177711507, 2.902664741880521],
            [14.373638908323475, 2.910286262918869],
            [14.388511515201655, 2.927577693074055],
            [14.395994208251926, 2.9390401984173296],
            [14.417041452252183, 2.9664830201664394],
            [14.425119606118296, 2.9755602011250786],
            [14.437569322836628, 2.987899512013242],
            [14.445681055792505, 2.9945920175499388],
            [14.456667751204481, 3.0020212078151842],
            [14.463096844394643, 3.0021738591901523],
            [14.462576586981807, 2.996120840326127],
            [14.459766435435844, 2.9913074950045666],
            [14.44569643785084, 2.9759964279963405],
            [14.435891469436386, 2.963553602565636],
            [14.432229477911724, 2.9571032451602863],
            [14.431966071200186, 2.9516696068080828],
            [14.426502309662133, 2.94520116694584],
            [14.425012216579063, 2.9391449571991473],
            [14.427428741556728, 2.936445644632479],
            [14.43264217584377, 2.9373196303048132],
            [14.440760889539268, 2.9407125794529665],
            [14.452497451746805, 2.948951868808275],
            [14.468238041750382, 2.9643888437625106],
            [14.472098733929535, 2.969856897418321],
            [14.480720253552239, 2.9794142163960644],
            [14.488619577593665, 2.9865271233105504],
            [14.49256944150487, 2.987477667561142],
            [14.492787701981689, 2.9835483102614697],
            [14.489345000365885, 2.974627773351623],
            [14.49048003769192, 2.9697247901370534],
            [14.502474943312087, 2.9637815301532586],
            [14.510274030931212, 2.967074568052131],
            [14.534763553639532, 2.9816991459248725],
            [14.554896088200236, 2.990007284381976],
            [14.556522059305724, 2.9916215523949354],
            [14.564004623100843, 2.992748547104875],
            [14.581632883534452, 2.9997015912685425],
            [14.6034927694208, 3.0055375296954314],
            [14.620905588957728, 3.011858999489471],
            [14.63879068285081, 3.021010795547297],
            [14.648244378750466, 3.0236276961823076],
            [14.655492053570883, 3.026403273800839],
            [14.659128383225534, 3.0289378160261338],
            [14.674844127382192, 3.033995100984797],
            [14.682889668709649, 3.035340374776066],
            [14.68574786474292, 3.037279680956916],
            [14.698780928144616, 3.041049342454701],
            [14.713409405318703, 3.0436113330482395],
            [14.725683031541513, 3.0477344446930545],
            [14.745772302304173, 3.056159717684152],
            [14.764793033650323, 3.0672161696504525],
            [14.787864703354508, 3.0838506830070127],
            [14.790569830157347, 3.081327501663335],
            [14.791165114537515, 3.0732779671605157],
            [14.789625596238901, 3.067705117265343],
            [14.787464054781438, 3.054685565406686],
            [14.788775808728715, 3.0441009412769064],
            [14.79317124373671, 3.0381751794221112],
            [14.79658939086696, 3.0359909077604175],
            [14.800309323716005, 3.0274099070301888],
            [14.809233809272078, 3.018369441459658],
            [14.822231649794114, 3.0096175789539927],
            [14.83176966526871, 3.005800953877291],
            [14.84340671183646, 2.9950787529219163],
            [14.84990446468132, 2.9914371543980423],
            [14.84844748516473, 2.9873586900686426],
            [14.849934285619076, 2.9841960519756516],
            [14.84626252298024, 2.980174214748234],
            [14.841890236904408, 2.9787968589494422],
            [14.836226237716822, 2.979905576047432],
            [14.832667342027854, 2.97524017927367],
            [14.827704125393947, 2.9761858134191725],
            [14.822110831433918, 2.984067168293446],
            [14.81811227968629, 2.979590842998614],
            [14.822860244958441, 2.973901341637282],
            [14.818094904360397, 2.9677574423503286],
            [14.812565969746219, 2.9628696200093554],
            [14.810456441151176, 2.9667546131434213],
            [14.807199592489699, 2.9651384550092925],
            [14.803590328990598, 2.951701517139938],
            [14.811359701263326, 2.95477935629553],
            [14.816329144225765, 2.9505202759546845],
            [14.819043510555971, 2.9425295759740977],
            [14.815796604906103, 2.9401799343522517],
            [14.81250844904633, 2.9428404173422873],
            [14.807450177662751, 2.943875490291409],
            [14.807088962372475, 2.938991591949622],
            [14.812156244986241, 2.933115752231573],
            [14.825317432674918, 2.927857177316644],
            [14.827477280871477, 2.924739187559149],
            [14.81102305188241, 2.916624096054971],
            [14.80286944242593, 2.918043101734144],
            [14.79361437610469, 2.917772057422577],
            [14.78270314208639, 2.9123478828517557],
            [14.77802032011812, 2.9116918221779184],
            [14.774012764636394, 2.912718349700556],
            [14.772891735439043, 2.9081509668752243],
            [14.779531629287206, 2.907619690218504],
            [14.778747022847595, 2.9017999962989443],
            [14.775838832666983, 2.8999799213733626],
            [14.769424923533977, 2.9018664088434063],
            [14.757672042577456, 2.897616106597459],
            [14.753481959754193, 2.8923471593245855],
            [14.746393159181174, 2.8901961508812875],
            [14.744610155058933, 2.8872704035156542],
            [14.739688227632056, 2.888247874183826],
            [14.735521728956313, 2.882495638764834],
            [14.674547301066793, 2.7951494280633185],
            [14.659849197614534, 2.77343868619008],
            [14.646732990353097, 2.7479904575171785],
            [14.615434080976247, 2.7371863353175856],
            [14.581456691997325, 2.7223191148020502],
            [14.52680388741855, 2.6971422904456777],
            [14.49148045446051, 2.6810924707807207],
            [14.451000445991761, 2.62127782001323],
            [14.458104100502227, 2.651817112225195],
            [14.453372308424333, 2.6540120299240826],
            [14.447059729307842, 2.6619722396963827],
            [14.442723620785609, 2.663592177445593],
            [14.439180931158559, 2.6681256281106736],
            [14.433501580069054, 2.6685029154400772],
            [14.42629275301318, 2.675239382107262],
            [14.420952733202029, 2.678104037009858],
            [14.416828151704996, 2.6825347571907785],
            [14.41582416555102, 2.685622793703721],
            [14.406873700356124, 2.6956133038222996],
            [14.407057610998843, 2.6998443735372843],
            [14.397155257303345, 2.707380559372236],
            [14.395997030006624, 2.7115138498897946],
            [14.393072814960156, 2.7151888007779994],
            [14.390063702697956, 2.7136703726169724],
            [14.384843416892581, 2.7157969194629032],
            [14.38427882115751, 2.7264552390534655],
            [14.38174356002923, 2.729628443991554],
            [14.381415100868397, 2.7340459572254723],
            [14.378858022211398, 2.73673102126769],
            [14.373731465846388, 2.7352593266448375],
            [14.372475442613803, 2.7451464762737503],
            [14.369092973248769, 2.7546639955227854],
            [14.365164078876996, 2.7544397989582645],
            [14.35974022649825, 2.759284328444915],
            [14.355196429756921, 2.756721171360696],
            [14.353658787049957, 2.759569795149148],
            [14.355338107087652, 2.76583033717763],
            [14.352007418780179, 2.770580610168611],
            [14.348502076444063, 2.781117512831766],
            [14.343068022980267, 2.7868407537771755],
            [14.338085999688923, 2.7877463401335154],
            [14.331586918547634, 2.7930219593858],
            [14.325221876260105, 2.791609240358136],
            [14.323004572205779, 2.792662040672522],
            [14.321473871058751, 2.799403682424873],
            [14.319168808607344, 2.8003150670882566],
            [14.311511816702659, 2.8069025314832112],
            [14.308256532316602, 2.807588104793496],
            [14.303146620840456, 2.815313423486104],
            [14.300876799654704, 2.824037076862759],
            [14.298388510218953, 2.825931767061351],
            [14.286996999110485, 2.840258047759162],
            [14.294610074858761, 2.8519637549922865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.26537786169295,
          "lat": 40.163672943901645
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42041"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01209176"
      },
      "bbox": [
        14.286996999110485, 2.62127782001323, 14.849934285619076,
        3.0838506830070127
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.81242601017283, -3.2903455226120553],
            [13.836935492887292, -3.1977134899767328],
            [13.866299536818923, -3.086643651691641],
            [13.87043724387067, -3.070285102175072],
            [13.890438168237308, -2.9954952601270612],
            [13.90406647968841, -2.944241713356288],
            [13.991080837060224, -3.006282659325382],
            [14.040559355907924, -3.0434661106930783],
            [14.095301512155926, -3.0855353795506555],
            [14.14383268247501, -3.1209332061466304],
            [14.197345028194038, -3.1595450927373556],
            [14.26591277436081, -3.2088729176327306],
            [14.26231977165398, -3.2118646076593307],
            [14.261393255570512, -3.216409279591954],
            [14.25686053677388, -3.215492496490313],
            [14.25347127714269, -3.2182319190752997],
            [14.251000560520955, -3.231157169037141],
            [14.246736620392639, -3.2364423466676406],
            [14.242479511664298, -3.2373011236227702],
            [14.240499477144725, -3.240209076635581],
            [14.239480777631803, -3.2478139761352005],
            [14.233157552299042, -3.2600251559847555],
            [14.228129269796959, -3.2623346805009517],
            [14.225511362099489, -3.260929717212877],
            [14.185537880261107, -3.2353167328883377],
            [14.158242328466178, -3.272890876790382],
            [14.15357053086002, -3.270401342765651],
            [14.146681837650188, -3.272356808151684],
            [14.138170127714746, -3.277690040421721],
            [14.12830405473054, -3.276411244665257],
            [14.124069374934194, -3.2743053730486453],
            [14.121119212971978, -3.2759272937276482],
            [14.109279094190416, -3.26707131364705],
            [14.105336818251262, -3.268026684834496],
            [14.100273133258245, -3.265648822437593],
            [14.093259204140297, -3.2650892652944767],
            [14.089806579819163, -3.263127156938045],
            [14.082291198103155, -3.2723150897742794],
            [14.029780070322024, -3.2544885662101173],
            [14.016351334282026, -3.2520228560691486],
            [13.991580575744369, -3.256796617717703],
            [13.978786292521056, -3.26477690353974],
            [13.948488452310164, -3.2757896709694236],
            [13.945497047078677, -3.2747012497325234],
            [13.943054974241003, -3.2772310784172802],
            [13.937446904875355, -3.278659771818324],
            [13.940401967628969, -3.2878327832236907],
            [13.932466442285344, -3.2903687142770917],
            [13.927179928794745, -3.294006973125843],
            [13.92330273459671, -3.304468129326347],
            [13.91954627964358, -3.3110912140321944],
            [13.915705856934487, -3.3142228627022647],
            [13.909272531357676, -3.3144122405958076],
            [13.908496530815576, -3.321009702730559],
            [13.895277600749807, -3.3265419257400786],
            [13.890223520142206, -3.3270453848099333],
            [13.885067444101695, -3.329167848111722],
            [13.888907275157852, -3.336156126006948],
            [13.893554907727976, -3.3415201649568234],
            [13.893095132186824, -3.3448146785081354],
            [13.891412669273322, -3.3417797034678784],
            [13.885102076622884, -3.3351062463225944],
            [13.879946640573026, -3.326302501310345],
            [13.876875157901075, -3.319450495846857],
            [13.86849692406758, -3.3166694271906234],
            [13.862653727097028, -3.307558617448534],
            [13.856272879501914, -3.3042557659173406],
            [13.852626940362672, -3.3003220355625698],
            [13.845412426072846, -3.296856144222045],
            [13.839888455277203, -3.293193605913698],
            [13.826574344630869, -3.289585020545161],
            [13.819697538199582, -3.286465850472819],
            [13.816558361803267, -3.2870132299186157],
            [13.815542666235459, -3.2903558157519504],
            [13.81242601017283, -3.2903455226120553]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.37888578067856,
          "lat": 34.391487640049306
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45033"],
        "coty_name": ["Dillon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dillon County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01247993"
      },
      "bbox": [
        13.81242601017283, -3.3448146785081354, 14.26591277436081,
        -2.944241713356288
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.591426725030477, -2.7294554018364727],
            [11.623069209125852, -2.727112848066536],
            [11.653568295624412, -2.7233246251077157],
            [11.693488882361017, -2.7199257165709088],
            [11.764475508320864, -2.7116854328289954],
            [11.790369298639986, -2.7091314810015903],
            [11.825673124147245, -2.7056351535865955],
            [11.866688250616782, -2.7009233921123132],
            [11.940660985053173, -2.8190909017549646],
            [11.942685857602648, -2.8407885407823974],
            [11.953415162863209, -2.839448599668873],
            [11.962776555495982, -2.8543892693295376],
            [12.000608977205243, -2.9390634305900756],
            [12.00549767903981, -2.9390369845007416],
            [12.016528660833997, -2.9341805308690128],
            [12.022997238325816, -2.9440781964524056],
            [12.027796719024565, -2.9482493995284345],
            [12.031542832334749, -2.948799507556355],
            [12.033452073976113, -2.9528603397764996],
            [12.036325582973483, -2.9517433004860623],
            [12.017676357827181, -2.9859239615377504],
            [12.00687636601707, -3.0013139963702455],
            [11.992462769382668, -3.035414609693781],
            [11.990332706677737, -3.0551071281609765],
            [11.989523029312792, -3.074697831767424],
            [11.98828155946443, -3.0929117631319167],
            [11.986781074562234, -3.147970184076761],
            [11.985886303887728, -3.1639705936008053],
            [11.985061528075546, -3.187444476183156],
            [11.982530769821292, -3.2116636628704716],
            [11.976441154613163, -3.2323400309274017],
            [11.973120318928425, -3.2851376252558113],
            [11.967931052148607, -3.2885015727656484],
            [11.965026978138908, -3.3005750945245786],
            [11.959963169032529, -3.294568533782348],
            [11.957819619057519, -3.289355562229939],
            [11.952262862890613, -3.289826910647598],
            [11.948397539937266, -3.2887760787348155],
            [11.941892262479653, -3.2921290987227967],
            [11.94214567633805, -3.2889322649354975],
            [11.938670620587748, -3.287624248692691],
            [11.93699764910655, -3.283337973160309],
            [11.933817241397888, -3.286725303089865],
            [11.924706720785835, -3.2839593834231238],
            [11.9236944004742, -3.2793108104171966],
            [11.919871391723492, -3.2767074839404846],
            [11.915719197657845, -3.2761680975405767],
            [11.909384433146725, -3.2708029707225816],
            [11.90743606713527, -3.2643406121805816],
            [11.904809068513503, -3.2629293889592605],
            [11.897542390130422, -3.2545044828003755],
            [11.894952157325049, -3.2570840593954564],
            [11.891572586120114, -3.2477505464367087],
            [11.887615468065956, -3.2461987616716588],
            [11.884246309569948, -3.2426582939227075],
            [11.879959032284189, -3.2439295312865877],
            [11.868900690340453, -3.2440586424319116],
            [11.868648143982973, -3.2378159182555386],
            [11.867125447683813, -3.236070672632186],
            [11.853384702180477, -3.237185119234291],
            [11.850970053286305, -3.2351902189876682],
            [11.839744553606815, -3.236226541607372],
            [11.83600155254844, -3.23216975503417],
            [11.82875768247837, -3.2306407463277678],
            [11.827176326739455, -3.227369915907722],
            [11.818294955357567, -3.223055776667685],
            [11.817198602610812, -3.2202218921550148],
            [11.812975091739618, -3.221942130328582],
            [11.807689930756439, -3.219230415449408],
            [11.80595656615406, -3.214831745338204],
            [11.80151535187527, -3.213755535400903],
            [11.80022456422923, -3.2110234344171587],
            [11.792551376144324, -3.209817300156737],
            [11.791250735383043, -3.2044650985127583],
            [11.783939843069323, -3.205105692288615],
            [11.779752771143333, -3.2028918427526025],
            [11.782075130413853, -3.198448482976757],
            [11.781926823299827, -3.1909367157794586],
            [11.778561914415588, -3.1867881664129203],
            [11.77153279183163, -3.188196350840037],
            [11.7712848335487, -3.179888145373036],
            [11.768318627780756, -3.177461367638246],
            [11.762881485698008, -3.1688618507822266],
            [11.76092544705554, -3.163598417848587],
            [11.753108385867261, -3.164334596379225],
            [11.749939806206841, -3.1663515603177],
            [11.74696890236174, -3.161454910677897],
            [11.742910958825908, -3.1581935458106627],
            [11.740293397092874, -3.162712949258941],
            [11.737782297212501, -3.163183667025849],
            [11.7321531307092, -3.1550227079711983],
            [11.72978255892417, -3.1539573006094948],
            [11.722159211984442, -3.141581298915412],
            [11.718031847977368, -3.141492854147786],
            [11.717195227592976, -3.1364225050793686],
            [11.708003056273961, -3.1306092525357108],
            [11.703881940660214, -3.1346691681075916],
            [11.701166352073827, -3.1322675189401195],
            [11.701708196966168, -3.1292044108284482],
            [11.69604614188957, -3.1271680922522753],
            [11.685652034132948, -3.116155345289015],
            [11.691826308431125, -3.1152760358519065],
            [11.6889958806942, -3.1112727439197574],
            [11.68434408909019, -3.1135461656610466],
            [11.68062233273686, -3.1073568591200957],
            [11.671370733863023, -3.098539274025749],
            [11.660285953093222, -3.0869141312593005],
            [11.647159362521116, -3.0809353580178596],
            [11.646519497441494, -3.078675898120529],
            [11.640249864505979, -3.0741550920431706],
            [11.638550546702364, -3.0713753541546533],
            [11.633139026921974, -3.073084146402465],
            [11.625061476648883, -2.9974361835839503],
            [11.622718115733228, -2.977399301079462],
            [11.614513196413357, -2.912187838059104],
            [11.601766129891029, -2.8094122292666395],
            [11.591426725030477, -2.7294554018364727]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.99077885113923,
          "lat": 34.930923885283214
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45083"],
        "coty_name": ["Spartanburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spartanburg County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01248592"
      },
      "bbox": [
        11.591426725030477, -3.3005750945245786, 12.036325582973483,
        -2.7009233921123132
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.432972564874115, 7.287165971235719],
            [-1.3640822662044874, 7.2847880303282615],
            [-1.2817142258965823, 7.281622319678486],
            [-1.2173548501936537, 7.279219662222955],
            [-1.122537728026313, 7.27670909169587],
            [-1.0580297254466973, 7.2750781417473185],
            [-0.9344446906564982, 7.272284266435693],
            [-0.9140335644187116, 7.271702708052723],
            [-0.9158309269054234, 7.186012162407447],
            [-0.917312881657642, 7.128667123684518],
            [-0.9198942856907157, 7.013593614960775],
            [-0.9218314031847467, 6.927253919916619],
            [-0.9238511574261039, 6.840851348114395],
            [-0.9260222425496475, 6.75443941352672],
            [-0.9278997732310511, 6.6824455471716515],
            [-0.9303942138585195, 6.581624404680974],
            [-1.0168211347109317, 6.583645124469133],
            [-1.0818751947218, 6.585490477101154],
            [-1.1616278039318761, 6.5878436159302325],
            [-1.234125427745559, 6.589950791927254],
            [-1.2920211423793782, 6.591802304970409],
            [-1.3211056364872247, 6.593043736401809],
            [-1.3646423543510484, 6.594568540542081],
            [-1.4482323139989797, 6.597642453316964],
            [-1.451552466277863, 6.597768694679605],
            [-1.4492409451844606, 6.670200458189099],
            [-1.4463558222353208, 6.770335863911308],
            [-1.443966457321365, 6.856768641282531],
            [-1.4413834558226941, 6.94275246372461],
            [-1.443361813392192, 6.942818683892637],
            [-1.4407687110563703, 7.029007843318133],
            [-1.4396323927184729, 7.072177904714861],
            [-1.435647240146834, 7.201491191398417],
            [-1.432972564874115, 7.287165971235719]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.35159897768769,
          "lat": 45.589789078034606
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46013"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01265785"
      },
      "bbox": [
        -1.451552466277863, 6.581624404680974, -0.9140335644187116,
        7.287165971235719
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.131026307445941, 7.501735889876537],
            [-5.0260338133898745, 7.493058710847798],
            [-4.921043968381471, 7.484350011955672],
            [-4.864133106098174, 7.479743266263336],
            [-4.806044624937852, 7.475168089525384],
            [-4.79330543372866, 7.474009216945373],
            [-4.690999468171985, 7.4661361972121325],
            [-4.666140943350875, 7.46375111888466],
            [-4.661732076962905, 7.463763956176019],
            [-4.6027013284802925, 7.459243023274717],
            [-4.517399155360332, 7.4529589595134755],
            [-4.438615591989238, 7.447134514793574],
            [-4.402154223408948, 7.444291684756747],
            [-4.3652349745489465, 7.441528250135048],
            [-4.374800718839239, 7.317863613277989],
            [-4.380971152247773, 7.231819470139326],
            [-4.386582061692537, 7.230522209441815],
            [-4.392630237917856, 7.147500611079157],
            [-4.399520048460163, 7.061363494408117],
            [-4.403736132260718, 7.004146177190169],
            [-4.405511096663815, 6.9749846756990195],
            [-4.407639496276772, 6.944411212407212],
            [-4.41194487649001, 6.889302389881036],
            [-4.416353192949627, 6.889656021245347],
            [-4.42294184557536, 6.8036038009426045],
            [-4.4253672035205565, 6.763798548625738],
            [-4.426728019159943, 6.754645307811737],
            [-4.429337840733747, 6.717754236019257],
            [-4.45966666046561, 6.719644028768212],
            [-4.459772819677598, 6.7201152270019495],
            [-4.5345276832108325, 6.725824944395743],
            [-4.609283726455686, 6.731519692984485],
            [-4.6840409273783585, 6.737199471488206],
            [-4.758799263938051, 6.74286427870664],
            [-4.801221998612129, 6.746286103752515],
            [-4.815938874527422, 6.746953913702421],
            [-4.896347042217135, 6.753550190866604],
            [-4.976756678121971, 6.76012913126723],
            [-5.057167754799814, 6.766690733176786],
            [-5.137580244798289, 6.773234994974804],
            [-5.16141505515039, 6.775016366616824],
            [-5.189214905096545, 6.77745491789973],
            [-5.178966820331904, 6.8992850585928025],
            [-5.1755613336562964, 6.937139115999535],
            [-5.17414053890202, 6.9562128219922545],
            [-5.168573087568616, 7.0247237428914255],
            [-5.166862254823573, 7.052550947295631],
            [-5.165366985177654, 7.064952673896709],
            [-5.161310507585421, 7.11893167967082],
            [-5.145543324027559, 7.308769559680804],
            [-5.135393746316046, 7.439154266429731],
            [-5.131026307445941, 7.501735889876537]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.49582935614806,
          "lat": 45.58032975232715
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46063"],
        "coty_name": ["Harding"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harding County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01265792"
      },
      "bbox": [
        -5.189214905096545, 6.717754236019257, -4.3652349745489465,
        7.501735889876537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9140335644187116, 7.271702708052723],
            [-0.8469501020965572, 7.27005301916031],
            [-0.7735960350117022, 7.268410680591494],
            [-0.6740450669094472, 7.2665599207599065],
            [-0.5666244819745044, 7.264638931019307],
            [-0.4791310466106111, 7.263280795045988],
            [-0.3915455591918164, 7.26216866017695],
            [-0.3925469746059638, 7.1756712722543545],
            [-0.3935771862080178, 7.060785777055759],
            [-0.3944942882162268, 6.974668107642524],
            [-0.39556330673944806, 6.888336818941358],
            [-0.4389667857128947, 6.889108752351357],
            [-0.4534771398394895, 6.889594597775598],
            [-0.4918727708368802, 6.89020638860931],
            [-0.497565291243934, 6.918981328566406],
            [-0.5607106963062987, 6.920034072101479],
            [-0.6511833357331238, 6.9213989125012105],
            [-0.6688876891997234, 6.921899313510015],
            [-0.7482907530132983, 6.92332524291281],
            [-0.8352689737268961, 6.925079076030341],
            [-0.9218314031847467, 6.927253919916619],
            [-0.9198942856907157, 7.013593614960775],
            [-0.917312881657642, 7.128667123684518],
            [-0.9158309269054234, 7.186012162407447],
            [-0.9140335644187116, 7.271702708052723]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.59865566387397, "lat": 45.75856098197819 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46091"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01265759"
      },
      "bbox": [
        -0.9218314031847467, 6.888336818941358, -0.3915455591918164,
        7.271702708052723
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5326389538748577, 6.640264339039248],
            [-2.461709596823792, 6.637015268272253],
            [-2.3907808964326884, 6.633752740492424],
            [-2.3185421712314307, 6.630788445632879],
            [-2.278594606804658, 6.628710187571948],
            [-2.275194010571864, 6.628730805673009],
            [-2.1896934308371323, 6.6250411025537845],
            [-2.145181754145119, 6.62318067119024],
            [-2.116280338079328, 6.62183720245852],
            [-2.0498245761815714, 6.619050727219634],
            [-2.0507857348895704, 6.600437829464941],
            [-2.0529908757675157, 6.532373213280638],
            [-2.056567229296332, 6.433999588021489],
            [-2.056787007496356, 6.431625394219901],
            [-2.059300589479595, 6.359722292973862],
            [-2.0620339755477968, 6.287635826266622],
            [-2.062477881180554, 6.272985558703042],
            [-2.13424037015335, 6.2759455004877465],
            [-2.162993494244606, 6.2771945649751615],
            [-2.1915595715213474, 6.2781785232585845],
            [-2.2357442956566995, 6.279959139357919],
            [-2.3219033358815895, 6.283547896990014],
            [-2.422643360642308, 6.2878979206673735],
            [-2.502185930090532, 6.2915843986285305],
            [-2.581729300249387, 6.295254501474637],
            [-2.6109903006832114, 6.29674834534186],
            [-2.650413029194933, 6.297956177676025],
            [-2.6547876956032757, 6.311351680108631],
            [-2.6569657547905856, 6.324019428198792],
            [-2.6577721260298266, 6.349581492248669],
            [-2.6603385010587193, 6.373560366306306],
            [-2.6596514261577844, 6.390362057939532],
            [-2.655047555246973, 6.400911801263081],
            [-2.647675872417486, 6.411533774221729],
            [-2.6353391764326637, 6.4251009714221565],
            [-2.6303017947527967, 6.42790754817117],
            [-2.6251590990785165, 6.4287136324315],
            [-2.6150013044404186, 6.427255140289489],
            [-2.603284690615913, 6.4223687397749405],
            [-2.5822180282794926, 6.412345249344501],
            [-2.563737389451868, 6.410347915314078],
            [-2.5570740628596114, 6.413983493917503],
            [-2.555018948890527, 6.423152255087905],
            [-2.5572675300308347, 6.4289269400882105],
            [-2.5709103669625772, 6.44216188319631],
            [-2.5779045719194724, 6.4507737647987575],
            [-2.580719352039565, 6.455760606197701],
            [-2.5852239298768267, 6.470776973898865],
            [-2.5865047911013717, 6.482992136080823],
            [-2.585199964499607, 6.495841355206619],
            [-2.568553710533549, 6.52062543443389],
            [-2.558969591834035, 6.533526543049623],
            [-2.5497965641208307, 6.553538659373495],
            [-2.547720627395187, 6.562651853905294],
            [-2.5462750261277036, 6.5782462811758],
            [-2.544924300329768, 6.5868684063573655],
            [-2.5452039626588707, 6.592534708739759],
            [-2.5344350487712974, 6.617947438392627],
            [-2.530945067337628, 6.631963334723199],
            [-2.5326389538748577, 6.640264339039248]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.95721662273738, "lat": 45.0645199492132 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46107"],
        "coty_name": ["Potter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Potter County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01265761"
      },
      "bbox": [
        -2.6603385010587193, 6.272985558703042, -2.0498245761815714,
        6.640264339039248
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.605978887794004, -3.183499219236142],
            [5.612840376269855, -3.1771382985138215],
            [5.617936639547563, -3.174851782274054],
            [5.6184958061241135, -3.169698620531875],
            [5.625601774499822, -3.1687475083682206],
            [5.632263334402112, -3.1628139194577467],
            [5.637339357479239, -3.161817634573129],
            [5.642903625520174, -3.159158502394398],
            [5.646932353300986, -3.1608411439103534],
            [5.650154638702684, -3.1572794891692704],
            [5.652597798876904, -3.1597141565895677],
            [5.658126387256389, -3.1580760339337144],
            [5.660199642436277, -3.154846112370164],
            [5.669549181031159, -3.1535641526230163],
            [5.671107760804086, -3.151394622337644],
            [5.678354794722955, -3.149389927850224],
            [5.711032078423753, -3.14779915475118],
            [5.713406534536341, -3.148260727742193],
            [5.7319873893632, -3.1474748120205143],
            [5.760781332790935, -3.146427259588885],
            [5.760765175647042, -3.1475037677051207],
            [5.834303294517353, -3.1440039016368564],
            [5.8342802031214696, -3.1431098009081953],
            [5.914940883298674, -3.139533377085628],
            [5.966319441083563, -3.13699635425831],
            [5.968371369503634, -3.190258227887196],
            [5.972628537132343, -3.283948321898087],
            [5.976041682890315, -3.3580587620885853],
            [5.979596297624909, -3.4368317215611977],
            [5.9812077562666905, -3.4797397233010194],
            [5.983800402242607, -3.5422468502892053],
            [5.968271712355204, -3.5431090988176708],
            [5.858732677163797, -3.55145797464716],
            [5.792091456615612, -3.556460664433564],
            [5.749984265769624, -3.559133673403552],
            [5.730274303305297, -3.5596943438108557],
            [5.622537635230394, -3.566429618902783],
            [5.620220616787393, -3.516575364882346],
            [5.61928567188928, -3.4796232493396455],
            [5.614501755184974, -3.3624308623089423],
            [5.612024180628965, -3.328223870098218],
            [5.612454093577943, -3.327519868658383],
            [5.611050214964957, -3.2936940793404124],
            [5.610067344854035, -3.263948436323581],
            [5.607526450606593, -3.2422127180711287],
            [5.605978887794004, -3.183499219236142]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.41413117080954, "lat": 35.1970189993318 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47047"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01639742"
      },
      "bbox": [
        5.605978887794004, -3.566429618902783, 5.983800402242607,
        -3.13699635425831
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.613970187334361, -2.77232565023461],
            [8.615809128329442, -2.7672024674439313],
            [8.622787922054814, -2.77450113594999],
            [8.62917986956733, -2.7754980106052187],
            [8.630411209463766, -2.774240220999636],
            [8.65023720043605, -2.777355346757129],
            [8.661493974783395, -2.787022783388961],
            [8.66539440363085, -2.7853682744866624],
            [8.662919899570845, -2.777851875127528],
            [8.71292164112257, -2.7616238523977374],
            [8.717298566001235, -2.760999533937983],
            [8.752780447132766, -2.7527538263880293],
            [8.829372136578288, -2.7413546028855444],
            [8.844532991573576, -2.7500311572914082],
            [8.849018792211497, -2.7547577256918823],
            [8.855848206917159, -2.757884985099638],
            [8.862501432321618, -2.763949014612166],
            [8.872411254706746, -2.7684198858014897],
            [8.887702740730923, -2.7764800918804924],
            [8.890966553814048, -2.7797515529837433],
            [8.891492117507525, -2.7857626287702315],
            [8.890063734191216, -2.8058973753963534],
            [8.89130207611493, -2.8081706074545396],
            [8.897807286149362, -2.8353669990022246],
            [8.911230704076345, -2.8439579652818314],
            [8.912753808531114, -2.8414233092881593],
            [8.918282173660465, -2.8436787575277997],
            [8.918871726959495, -2.8572501615549433],
            [8.940902341511084, -2.8561322427527553],
            [8.93738745169762, -2.863845875191311],
            [8.935727473299798, -2.8714904348231984],
            [8.935927767168119, -2.8768777783898734],
            [8.940550157671248, -2.879299154802533],
            [8.93384174068257, -2.8867468521878923],
            [8.929366815729525, -2.897586769789186],
            [8.929543493486962, -2.9068934669023374],
            [8.919673370650303, -2.9147499730539344],
            [8.914642318951643, -2.917722716057406],
            [8.913093318463329, -2.9235592605018406],
            [8.908147220416067, -2.9232499892406136],
            [8.902537876239979, -2.926121429703562],
            [8.896870330174595, -2.9397969267649744],
            [8.891965891448942, -2.9497496606394322],
            [8.890771777069494, -2.9504903558628217],
            [8.833864180288193, -2.9719450610898295],
            [8.824075906470316, -2.9747256173445313],
            [8.819263113555056, -2.975001868686361],
            [8.815485188948204, -2.9720769518885892],
            [8.80869948762367, -2.976039830930284],
            [8.807164197979816, -2.978768120454419],
            [8.801774321403569, -2.982322707407358],
            [8.802836075013836, -2.985955620471757],
            [8.793996964825213, -2.9903979680370676],
            [8.789574863539135, -2.994621401317766],
            [8.787139606051475, -2.992501753599719],
            [8.776969360180368, -2.9904947949991576],
            [8.773942237254543, -2.993101466651163],
            [8.7921394695173, -3.041784318654667],
            [8.757288674937849, -3.069843418483749],
            [8.749285080562611, -3.0701022160092375],
            [8.73004089610165, -3.0693009085770133],
            [8.720251795745487, -3.066410982994395],
            [8.688102445254808, -3.0500149567007013],
            [8.683484326594321, -3.0529795025206927],
            [8.669952081693868, -3.0530916972618294],
            [8.664985811347966, -3.0569990296599743],
            [8.660451457594494, -3.0642616452074543],
            [8.65521125570388, -3.0693016698041644],
            [8.649393828484337, -3.0732703052357753],
            [8.635768757151528, -3.050394215557724],
            [8.629819418735254, -3.0416871307633846],
            [8.615617296226262, -3.023344642059738],
            [8.60969224828964, -3.0108150822443807],
            [8.614182393061935, -3.00212502355633],
            [8.611355774506336, -2.998929592959377],
            [8.613022682288554, -2.9928608457749615],
            [8.613134367250757, -2.9816760019661466],
            [8.61690135911931, -2.9810975500140255],
            [8.614833452213338, -2.97187913170848],
            [8.612293818938712, -2.968751380974655],
            [8.629462760080877, -2.948308539098061],
            [8.628693690561267, -2.9364039123957433],
            [8.632314194600617, -2.9286316654864017],
            [8.635392533914725, -2.915624540249828],
            [8.624235544268744, -2.9168006993480624],
            [8.621208140224036, -2.916019207129291],
            [8.621991167016057, -2.904344591492689],
            [8.612726947715915, -2.8536776012889113],
            [8.612038411567669, -2.838443692006732],
            [8.612190638426615, -2.829450607191873],
            [8.61076301111989, -2.807744985403142],
            [8.615378318239651, -2.804943734980038],
            [8.616353082726446, -2.7890535976593283],
            [8.611192299500901, -2.7858738907456444],
            [8.614018383382078, -2.7821597289488262],
            [8.61009931257209, -2.7805034412696825],
            [8.612570743538562, -2.772688935742671],
            [8.613970187334361, -2.77232565023461]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.7225434289822, "lat": 35.388352096363676 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47061"],
        "coty_name": ["Grundy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grundy County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01639748"
      },
      "bbox": [
        8.60969224828964, -3.0732703052357753, 8.940902341511084,
        -2.7413546028855444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.629365856906331, -3.102856206305706],
            [6.628583952223102, -3.086698066691711],
            [6.633765793295684, -3.086331697825943],
            [6.63344788263799, -3.0802244782277],
            [6.635983907037447, -3.076308037422018],
            [6.627954143380556, -3.074789347643741],
            [6.627693663646405, -3.06460729632682],
            [6.717096709969542, -3.0598624686664007],
            [6.7200758860743965, -3.0572772427559856],
            [6.723429533192542, -3.057168114450783],
            [6.723270971223481, -3.052522194915916],
            [6.724481646554436, -3.0556366868214933],
            [6.730886794812889, -3.055767076617558],
            [6.7317476985312386, -3.0609367654171877],
            [6.736293659393592, -3.0605193019456958],
            [6.73882636718578, -3.0636658571625923],
            [6.745062633941112, -3.063959563191421],
            [6.749980111909321, -3.0664493330679963],
            [6.752387689060056, -3.071996326753119],
            [6.751193113657186, -3.075922292554932],
            [6.753645689631325, -3.078958692829349],
            [6.760501018882845, -3.0802142867556226],
            [6.7623479358011265, -3.0854582518525056],
            [6.760474248821065, -3.0906075557683383],
            [6.7632852594243404, -3.093418101780615],
            [6.76837043863888, -3.0882068539152234],
            [6.776941430922645, -3.0842911077565893],
            [6.787420666372013, -3.0785763107556927],
            [6.790587887035784, -3.0783442576192077],
            [6.80718100202714, -3.083852714927131],
            [6.820450304915732, -3.0842697791115974],
            [6.828806069479413, -3.081690107395935],
            [6.8349986794884545, -3.076375913869175],
            [6.842058347038363, -3.0671312920059917],
            [6.84817869575179, -3.0602588458240816],
            [6.864560049558632, -3.046758601479104],
            [6.868444916481051, -3.046802947950305],
            [6.880319800300467, -3.054363314114304],
            [6.895654238563206, -3.065090213560354],
            [6.900510351024555, -3.0691328265060793],
            [6.902501444604138, -3.0919335613905425],
            [6.908859713460563, -3.0946241905447667],
            [6.910769427894863, -3.09811816951233],
            [6.915142160176918, -3.1019184465277907],
            [6.915610963449879, -3.1042627790484283],
            [6.920017529924953, -3.1093407830138955],
            [6.916664737773534, -3.1220764098076255],
            [6.912038591990508, -3.1263402417287227],
            [6.911023676960992, -3.1302517501969835],
            [6.914032847133865, -3.1323581540660506],
            [6.912752898877438, -3.1446396299038093],
            [6.915669404546184, -3.147026683328183],
            [6.916174433945479, -3.1517918118737596],
            [6.91368623627769, -3.1567590306130073],
            [6.915904210035737, -3.162207944807832],
            [6.920442132741212, -3.159228421017359],
            [6.9244095552892375, -3.159773921008613],
            [6.930176057189987, -3.1576566946014393],
            [6.933569943032719, -3.1607893078210765],
            [6.941066332955327, -3.1638192263171834],
            [6.94347318613272, -3.1631985547060957],
            [6.948771696840391, -3.238643036354954],
            [6.955755276104891, -3.334583004518615],
            [6.964551295330243, -3.4446183269564847],
            [6.965409293491189, -3.4542130696456046],
            [6.953171725334941, -3.455185738540186],
            [6.788762571932351, -3.466745045054992],
            [6.792130435242689, -3.478987803252178],
            [6.745153286999387, -3.4830029296300027],
            [6.65979561359013, -3.489782926357316],
            [6.646048663324087, -3.490865957211846],
            [6.645993174588711, -3.4863499703771983],
            [6.643733265965893, -3.4357443138773953],
            [6.640572521763845, -3.3607766259188967],
            [6.63460144094375, -3.2360953457700776],
            [6.634665917891571, -3.2274329545319786],
            [6.63288751110902, -3.193532754131539],
            [6.6267076763507315, -3.1938835827760905],
            [6.626051560329425, -3.180827222265055],
            [6.627467780147827, -3.179265466040571],
            [6.626583779837891, -3.1690161081462977],
            [6.632236631654433, -3.168595312746255],
            [6.630365235968458, -3.1230711955306574],
            [6.629365856906331, -3.102856206305706]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.18449618510412, "lat": 35.1986992237407 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47071"],
        "coty_name": ["Hardin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardin County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01639751"
      },
      "bbox": [
        6.626051560329425, -3.490865957211846, 6.965409293491189,
        -3.046758601479104
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.824167637241088, -2.5228195871644874],
              [9.818949080262467, -2.515351478838255],
              [9.823369916238052, -2.51141508347902],
              [9.829417538943966, -2.518470061954981],
              [9.824167637241088, -2.5228195871644874]
            ]
          ],
          [
            [
              [9.68809082334159, -2.553978299109144],
              [9.689139168533927, -2.564860318817859],
              [9.686304304482961, -2.5611463752122834],
              [9.674565904790352, -2.5626036424264047],
              [9.67361185101804, -2.5549178616711505],
              [9.68809082334159, -2.553978299109144]
            ]
          ],
          [
            [
              [9.667730737389936, -2.503803934008974],
              [9.663748110650632, -2.50152993877626],
              [9.663553239016506, -2.497782049778549],
              [9.667108014760391, -2.4974056439590857],
              [9.667730737389936, -2.503803934008974]
            ]
          ],
          [
            [
              [9.667730737389936, -2.503803934008974],
              [9.674923565830914, -2.5030171908136816],
              [9.674324244633686, -2.496763294464756],
              [9.68139306931652, -2.495921823835862],
              [9.68060117676559, -2.4887752049787735],
              [9.672524197969182, -2.489481894905922],
              [9.672717123402094, -2.4821732572869664],
              [9.676233887818206, -2.4817430535404728],
              [9.675860484084325, -2.478107033691406],
              [9.679237014351187, -2.4777251445365396],
              [9.678241332875563, -2.467406112753713],
              [9.681114236469822, -2.459962015155918],
              [9.685705179895324, -2.454928340526031],
              [9.69848238552788, -2.453463849823694],
              [9.716625233501613, -2.4257362916810985],
              [9.729897535328025, -2.4058994297857415],
              [9.732242339323353, -2.4104338807572914],
              [9.736898828445499, -2.414026812771099],
              [9.741960641812053, -2.4158168323098996],
              [9.744916993593984, -2.4147689467998847],
              [9.748651792023514, -2.4098766508096494],
              [9.749353761074188, -2.4050117016335006],
              [9.748482998714481, -2.3944719721395904],
              [9.749549924597293, -2.3907507150050202],
              [9.753465191869925, -2.3857260514316425],
              [9.761148629818047, -2.384180971928689],
              [9.764419987949562, -2.384892533807438],
              [9.776651535436722, -2.3911121455922304],
              [9.781732120781761, -2.3808392899059196],
              [9.774837303985734, -2.3769353198595904],
              [9.783015354891083, -2.3676513633264955],
              [9.778530705920534, -2.3622662440661957],
              [9.779989288602465, -2.360772654459803],
              [9.778005569530233, -2.3531025009954343],
              [9.777743982284063, -2.3411125682914875],
              [9.780857792312302, -2.3378501134653513],
              [9.783191262368668, -2.3318865318384456],
              [9.788442597354024, -2.3318547844911253],
              [9.801457137193292, -2.3230313193282455],
              [9.805369554103882, -2.3230341493397724],
              [9.8082858672721, -2.3145724429710492],
              [9.806221957069903, -2.3042299360002096],
              [9.807000166508116, -2.276861980149657],
              [9.80805063726244, -2.26071231625744],
              [9.810540778225377, -2.263990925559071],
              [9.817459019075386, -2.266248551009392],
              [9.825284944797438, -2.2633110065336735],
              [9.838147079275165, -2.2667304128798587],
              [9.845599875414688, -2.2741870175345276],
              [9.850623579782654, -2.2713976197466526],
              [9.850275422426934, -2.2675540753499956],
              [9.843059217793993, -2.254985916701052],
              [9.843226261066764, -2.248113425353052],
              [9.845685123338868, -2.24581936740084],
              [9.849055790681737, -2.2464170296018096],
              [9.854265457039926, -2.25118253954009],
              [9.858340934917894, -2.2532776793475806],
              [9.860595305860071, -2.250113240806972],
              [9.86249762546339, -2.250919875649051],
              [9.880907040426045, -2.267995379618574],
              [9.913145147513168, -2.297366815607768],
              [9.915930203969706, -2.2996200565076768],
              [9.94994679269565, -2.330624949519608],
              [9.94945940074481, -2.332365651159917],
              [9.944379634847861, -2.3336988240704453],
              [9.944115010824028, -2.3383137932254425],
              [9.946547534633135, -2.340003475286386],
              [9.948031970643957, -2.351917294337567],
              [9.947809618211425, -2.35832036808617],
              [9.944397680362957, -2.365647246745836],
              [9.943496446295802, -2.3703597865380304],
              [9.956529380741413, -2.3720260552228525],
              [9.96683866664802, -2.3785114151753413],
              [9.965627352333778, -2.3823465377807613],
              [9.959662856127519, -2.3897057835047435],
              [9.956072206616088, -2.3960807120609275],
              [9.95394601442372, -2.4060317891955836],
              [9.955686798394057, -2.412546678882482],
              [9.955807070243816, -2.425410134377552],
              [9.96774164663576, -2.4414648719379093],
              [9.967572776968538, -2.449677231552824],
              [9.96912783275351, -2.453670744447647],
              [9.975850582806814, -2.4624166229622926],
              [9.981428726992608, -2.4665300586698917],
              [9.9860098145679, -2.4659602493316495],
              [9.992287816592043, -2.4698044264364185],
              [9.993995718973807, -2.473833212747687],
              [9.990841734121208, -2.4762850518215953],
              [9.994632777436404, -2.4869544212536048],
              [9.987012541889149, -2.493792001843238],
              [9.98733143416835, -2.499612213252517],
              [9.983398352784029, -2.5085809086237925],
              [9.97899192009003, -2.512688222267341],
              [9.95848299551326, -2.528421636711093],
              [9.956209908453982, -2.5291980507839593],
              [9.951801481162326, -2.521933986071788],
              [9.929124666817847, -2.5277247863598085],
              [9.924427673260226, -2.522668243483762],
              [9.917583740767519, -2.522770598437617],
              [9.91194123280645, -2.5267589305046685],
              [9.906132673346796, -2.5286788916902188],
              [9.902354331926437, -2.5265697601408936],
              [9.901676001930191, -2.5215972893266376],
              [9.90283713666877, -2.515894680666787],
              [9.90513976874079, -2.5134004504218392],
              [9.90297208937839, -2.5089652756765495],
              [9.900501411167143, -2.5104726288181842],
              [9.89911255752329, -2.5145914065270696],
              [9.894754100445594, -2.5117128458737183],
              [9.878333270387271, -2.513459087833966],
              [9.877337011664492, -2.507717288397841],
              [9.864854469913531, -2.507427093458208],
              [9.86583558281257, -2.5001171354477396],
              [9.869283970849777, -2.499591079140249],
              [9.868795339254316, -2.494980914032481],
              [9.861765612185925, -2.4958471722103703],
              [9.861435076652523, -2.493099700594176],
              [9.854108694746547, -2.4938810662989934],
              [9.846770426828847, -2.4923746685211783],
              [9.84520171112535, -2.4804429861980535],
              [9.838146529850581, -2.4812148953854436],
              [9.838672217865787, -2.488509282739943],
              [9.814113318281656, -2.4913277443092112],
              [9.815025101909303, -2.4985754477046846],
              [9.818903748724912, -2.5016735943214723],
              [9.811741885877575, -2.502501635418645],
              [9.812602960506533, -2.509768663974257],
              [9.805408589993688, -2.510819392095909],
              [9.805833541679602, -2.514397189627587],
              [9.799143816432982, -2.5181224534062245],
              [9.784841731025708, -2.520266704858363],
              [9.78365463069883, -2.5094565691850517],
              [9.776756103788896, -2.5101057439552297],
              [9.779734520204821, -2.5061800889357833],
              [9.775007865406025, -2.4956601155738753],
              [9.771649596387533, -2.4949785053379645],
              [9.767672374244585, -2.500005222816752],
              [9.761131183037433, -2.4978285901821837],
              [9.760611060770202, -2.4912134121415024],
              [9.752740313020476, -2.49194802661131],
              [9.749412103585476, -2.4932503892071596],
              [9.751545214558014, -2.4981938250792313],
              [9.734410547058802, -2.500478005652906],
              [9.735234588299756, -2.507163602139966],
              [9.731976456361785, -2.508163027554962],
              [9.711730233757015, -2.510741766195369],
              [9.711608328322544, -2.513669120196635],
              [9.705022964777564, -2.514533648014386],
              [9.7047191584856, -2.5115920635021216],
              [9.700732722309658, -2.510128646639762],
              [9.700153791901172, -2.5046654196884472],
              [9.696814166868963, -2.504948144543903],
              [9.698363353328189, -2.5198219921638176],
              [9.68427618648265, -2.521165625520386],
              [9.6848707414808, -2.528618133822107],
              [9.691938624303972, -2.527710171560136],
              [9.69242959127023, -2.5322628568463377],
              [9.696862329226324, -2.534574328270331],
              [9.697811542596652, -2.5418587811272206],
              [9.704623958628229, -2.5410407197875364],
              [9.70207607046447, -2.55121938178585],
              [9.694913484350135, -2.552268453693103],
              [9.691415185875487, -2.547923313681646],
              [9.684634244558314, -2.548750514580479],
              [9.684049878935314, -2.544833752090622],
              [9.677459752265884, -2.5441679100960495],
              [9.675853410467518, -2.5401575708870516],
              [9.66515874056087, -2.533703247086435],
              [9.664395228430093, -2.5382949057306705],
              [9.657432491837694, -2.5390585165059334],
              [9.658362974007249, -2.546380781613482],
              [9.65110136533387, -2.5471341466850292],
              [9.650696748558756, -2.5436626868994545],
              [9.636816293375048, -2.545493936745524],
              [9.635304748648588, -2.534163964986352],
              [9.634485863497147, -2.526969227868889],
              [9.64160309354157, -2.5260792696033305],
              [9.640646588473333, -2.5188320065689607],
              [9.658440751167129, -2.5167477076037454],
              [9.657992227671206, -2.5131656441395394],
              [9.661588136367671, -2.5127348566105288],
              [9.661193806153294, -2.509065998447513],
              [9.667994001487878, -2.5084422107513076],
              [9.667730737389936, -2.503803934008974]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.31172140475891,
          "lat": 35.734789329106796
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47105"],
        "coty_name": ["Loudon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Loudon County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01639767"
      },
      "bbox": [
        9.634485863497147, -2.564860318817859, 9.994632777436404,
        -2.24581936740084
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.232222577793891, -1.8355489243639627],
            [8.23669350811629, -1.8315273377677654],
            [8.236744407430965, -1.8243474811409173],
            [8.238649056287962, -1.8241245265743482],
            [8.238115149294808, -1.8164784975253585],
            [8.239633793294518, -1.8150009893863293],
            [8.239151851407119, -1.7968576084113885],
            [8.23621986185581, -1.7928318851326064],
            [8.230579758475754, -1.7938207079470778],
            [8.231568222134772, -1.7719941552489689],
            [8.234195449653859, -1.7061330480905947],
            [8.233956945066641, -1.6958138461933843],
            [8.23459774690345, -1.6807933546532998],
            [8.332871011733475, -1.6765917441801195],
            [8.37211147862975, -1.676005590232404],
            [8.419618096169078, -1.6728661798111142],
            [8.429889865797657, -1.6721834280397143],
            [8.498447276766893, -1.6694314253685407],
            [8.531568758765196, -1.667503147705949],
            [8.555780302356192, -1.6645226349777849],
            [8.56602029456761, -1.66400075805306],
            [8.56720821177095, -1.6705190569649193],
            [8.560714722686143, -1.6730011702042482],
            [8.560758566279576, -1.6823463739521634],
            [8.55921092113661, -1.731639133622353],
            [8.558868669737006, -1.7351784177185923],
            [8.559364915622904, -1.7716183623868689],
            [8.559259847205558, -1.788926900922271],
            [8.557514427597102, -1.878048103231723],
            [8.538763020258994, -1.8768131382167452],
            [8.517693379966953, -1.878473761120389],
            [8.501169794502593, -1.8775069834668152],
            [8.50149240301849, -1.8802963936409913],
            [8.496843574773214, -1.880531189302236],
            [8.49662659099349, -1.8778735882199218],
            [8.466031587161323, -1.8771190576687922],
            [8.462784518110855, -1.8797689089727032],
            [8.460127760008275, -1.8772078595768704],
            [8.445555659849061, -1.8771117454407722],
            [8.436406530940367, -1.8765094486354792],
            [8.417057700864957, -1.8755687046706595],
            [8.356675927931398, -1.8749735628293844],
            [8.32070897415387, -1.8742921312568073],
            [8.28439146066147, -1.8739517126562493],
            [8.277428636766542, -1.8646112811680817],
            [8.270087849568352, -1.8523910702345996],
            [8.263111042641809, -1.837172553676087],
            [8.232103383069207, -1.8366435269879202],
            [8.232222577793891, -1.8355489243639627]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.007223959189, "lat": 36.531993994796665 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47111"],
        "coty_name": ["Macon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macon County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01639768"
      },
      "bbox": [
        8.230579758475754, -1.880531189302236, 8.56720821177095,
        -1.66400075805306
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6201193103328129, -7.681538523503276],
            [-1.5343091837604055, -7.682945052471808],
            [-1.4526991099078659, -7.683983495951199],
            [-1.3631748901743737, -7.685036985499202],
            [-1.3296381840030238, -7.68518952918868],
            [-1.244773197702437, -7.686030337866654],
            [-1.242066581882809, -7.685871977128879],
            [-1.1690746435580968, -7.686440901837641],
            [-1.1482935265638203, -7.72000554447942],
            [-1.138243568399588, -7.740122949926141],
            [-1.128781539620588, -7.757023218460314],
            [-1.1102156520576487, -7.792658337038303],
            [-1.1016335110629072, -7.812497046700948],
            [-1.1002077937844672, -7.817599357890078],
            [-1.1409783857249383, -7.857500124914028],
            [-1.1447529641118461, -7.860963410840987],
            [-1.1975470724611539, -7.9129299410734175],
            [-1.2179393073189706, -7.933275542405295],
            [-1.2282305601087178, -7.954009640030297],
            [-1.2494166363102215, -7.9976088728684935],
            [-1.2959788273352122, -8.091989257168363],
            [-1.3558224934965015, -8.213701192220896],
            [-1.3619106517848623, -8.226615073043495],
            [-1.361949638776113, -8.2289136803445],
            [-1.3538591060730403, -8.228246005502253],
            [-1.3510184354492476, -8.223018087752086],
            [-1.3469327368570734, -8.218712097431414],
            [-1.3398741181054932, -8.21617023196632],
            [-1.340487802197802, -8.246344916179595],
            [-1.3653634215539219, -8.286899272371503],
            [-1.4711890260501164, -8.252051681688885],
            [-1.4718980597070834, -8.251475623287067],
            [-1.531714614466687, -8.231776726200946],
            [-1.5578774261125272, -8.222986592870683],
            [-1.557327293406426, -8.196816686993785],
            [-1.5575155720222398, -8.19203362986047],
            [-1.5569561299738337, -8.151195165250636],
            [-1.5671347842738497, -8.13792448354721],
            [-1.572236217367765, -8.13497411966565],
            [-1.577089016248908, -8.135394049486322],
            [-1.5817970913945207, -8.138173396050053],
            [-1.5894821695086796, -8.141147325036362],
            [-1.595877940213155, -8.14466382727621],
            [-1.600491285678245, -8.144662602955881],
            [-1.6048710229367187, -8.138892910511444],
            [-1.607300419281221, -8.133896352743223],
            [-1.6092637519683457, -8.12477947737722],
            [-1.6080818425038055, -8.120907536833334],
            [-1.5993159144552982, -8.115701106829974],
            [-1.5977226082678626, -8.109184000930028],
            [-1.6057935456228396, -8.095110777150644],
            [-1.6114951687747563, -8.081550202366268],
            [-1.6120759099722992, -8.075846229827917],
            [-1.6107763955834893, -8.070219265559135],
            [-1.6118767987208649, -8.063023641212917],
            [-1.619837972141347, -8.054828432912933],
            [-1.6198701050207476, -8.048123875271758],
            [-1.6240476592348347, -8.045953876330087],
            [-1.6290333040313143, -8.046124183843363],
            [-1.6312264831259708, -8.042253736189645],
            [-1.6286772356849342, -8.035434707951698],
            [-1.6210132453268533, -8.033789240837763],
            [-1.6122730900184776, -8.03486898474209],
            [-1.6066845517673851, -8.033381319767084],
            [-1.6018561218190424, -8.034389291395268],
            [-1.5976284138379062, -8.032172799674813],
            [-1.5969067102546275, -8.028780120430909],
            [-1.6013272798275429, -8.014997022794716],
            [-1.6065126572192423, -8.007646458819302],
            [-1.606414093244227, -8.005108722249917],
            [-1.6020695797637006, -7.999248587682553],
            [-1.6007434589629483, -7.993186279969345],
            [-1.5958076684140472, -7.988047471107983],
            [-1.5877197737595554, -7.98885236872649],
            [-1.58137632133229, -7.979974739649796],
            [-1.5694516764779236, -7.9701856462916565],
            [-1.5691533211720228, -7.9677725891327515],
            [-1.5721547185880456, -7.96407112400987],
            [-1.575834968797651, -7.963185355075725],
            [-1.580344326829741, -7.96429606121675],
            [-1.5884492503426917, -7.963750559447298],
            [-1.5934168052576887, -7.959920676674512],
            [-1.6056675009515, -7.957888024758795],
            [-1.6124202491544797, -7.959201742927827],
            [-1.6160691282685025, -7.958052712662608],
            [-1.6179919296659524, -7.955277539442483],
            [-1.6188984258319887, -7.94861147135943],
            [-1.615889205824106, -7.941865538065489],
            [-1.6123142558207362, -7.936766673304496],
            [-1.6120867666518404, -7.933790353568755],
            [-1.6198622917700154, -7.92340542275604],
            [-1.6196690797581854, -7.9193114630650365],
            [-1.6135821046638885, -7.914277799851929],
            [-1.6055250936066274, -7.915859967303409],
            [-1.6028997323311798, -7.915209757198855],
            [-1.6003699266240186, -7.91116044532012],
            [-1.5987813358059608, -7.901387716810189],
            [-1.5944251038780801, -7.892626804779359],
            [-1.5923038388793458, -7.89172115367106],
            [-1.58303962709725, -7.892414481586927],
            [-1.5776808542487644, -7.8890018602866965],
            [-1.572095470880572, -7.881686745264208],
            [-1.5713458301687082, -7.876356815984471],
            [-1.5751095916630247, -7.872972630222244],
            [-1.5854966695820052, -7.86798641195648],
            [-1.595173349902229, -7.866886861308224],
            [-1.5986737848056272, -7.874016800119135],
            [-1.6018067041292465, -7.87537384826376],
            [-1.6096207990086169, -7.8752932147917445],
            [-1.6100416494073873, -7.87107656563609],
            [-1.6075368345154466, -7.85956760785345],
            [-1.6070850453828696, -7.851385924560034],
            [-1.6095356642105911, -7.846288838628493],
            [-1.6172667600694728, -7.840881974332692],
            [-1.6225639632909963, -7.839619587769269],
            [-1.6315852013606484, -7.839368948015024],
            [-1.6351060558249955, -7.837567707993348],
            [-1.6391183638048215, -7.830918843878712],
            [-1.6382002274706033, -7.826770283342905],
            [-1.632096562633481, -7.820621418410807],
            [-1.6313683743728395, -7.803160364818234],
            [-1.6280963054698878, -7.788917872275204],
            [-1.6246610826765022, -7.784605954139588],
            [-1.6188354336971433, -7.783522495625144],
            [-1.60797134805552, -7.786625561646047],
            [-1.6033952734200865, -7.78148569646025],
            [-1.600827352924673, -7.769061208449192],
            [-1.6020611745624038, -7.766305371660748],
            [-1.6093697459018639, -7.7626167477147945],
            [-1.6241159127718412, -7.760981069423201],
            [-1.6284388473294582, -7.758773291406716],
            [-1.6329821051833298, -7.746087203810134],
            [-1.6329564033280204, -7.741785025675815],
            [-1.6244103797628342, -7.731058859062285],
            [-1.6231343134494334, -7.72652876132809],
            [-1.626596446938178, -7.717915603753592],
            [-1.6323707889093886, -7.711134058720784],
            [-1.6373602728944598, -7.702877504204893],
            [-1.6352715653396042, -7.69754951098889],
            [-1.6254509348329895, -7.692934022378501],
            [-1.6200794538277314, -7.686036378094613],
            [-1.6201193103328129, -7.681538523503276]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.18232680187715,
          "lat": 30.788394847749483
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48053"],
        "coty_name": ["Burnet"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burnet County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01383812"
      },
      "bbox": [
        -1.6391183638048215, -8.286899272371503, -1.1002077937844672,
        -7.681538523503276
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.365966236346856, -4.954618668556399],
            [-5.360787184907047, -4.895725740038314],
            [-5.359113235082264, -4.874720317117041],
            [-5.356650210840658, -4.852843284663803],
            [-5.351010510722928, -4.78748254793605],
            [-5.349954251334393, -4.77900123250131],
            [-5.342662776108159, -4.700615205799001],
            [-5.20256315581393, -4.710716636756634],
            [-5.147171683843014, -4.71462083958047],
            [-5.008923548906538, -4.7242822815097725],
            [-4.987377815322324, -4.725660478755564],
            [-4.989727064649318, -4.80099349517682],
            [-4.9899338728014, -4.802152339033915],
            [-4.992641379336899, -4.894356191806631],
            [-4.992980768556484, -4.909704887906226],
            [-4.99637905034022, -5.023552802373102],
            [-4.997598902527985, -5.05236006993439],
            [-5.000909289919493, -5.1638789387276995],
            [-5.128885486254914, -5.155173865312464],
            [-5.185880099772262, -5.151047925094878],
            [-5.382909612164221, -5.136581486729395],
            [-5.365966236346856, -4.954618668556399]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.82851228948432,
          "lat": 33.60418348939309
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48079"],
        "coty_name": ["Cochran"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cochran County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01383825"
      },
      "bbox": [
        -5.382909612164221, -5.1638789387276995, -4.987377815322324,
        -4.700615205799001
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9468112233298072, -9.596412068562122],
            [-0.8966108796290798, -9.555311498990047],
            [-0.802824528289951, -9.479399392955328],
            [-0.7396308340067149, -9.42889819219366],
            [-0.6603005949169748, -9.365162326669996],
            [-0.6170713140268885, -9.330434409692227],
            [-0.5849588942760926, -9.369217436426819],
            [-0.5060291299171862, -9.46418388916879],
            [-0.4566568880097308, -9.526332686541613],
            [-0.4072701792317256, -9.58845581235252],
            [-0.39010688298610935, -9.609524455140456],
            [-0.4261396077210147, -9.638487084825682],
            [-0.43389898430058405, -9.644482154549804],
            [-0.44021687284391325, -9.64812104955379],
            [-0.5215743303744009, -9.713839146882336],
            [-0.5770315785157298, -9.758247408304616],
            [-0.6325004358832392, -9.802637680804773],
            [-0.6815672930777832, -9.842373627632169],
            [-0.686558467546014, -9.83682427289384],
            [-0.687336841088085, -9.834100849865052],
            [-0.6852176060228122, -9.829941765631501],
            [-0.6870367616674691, -9.828083813832395],
            [-0.6915497787925932, -9.830771620959633],
            [-0.6985903666801508, -9.831514515465367],
            [-0.6973648265644695, -9.825349739057597],
            [-0.6994773543803523, -9.821261515517698],
            [-0.7089624052285536, -9.813802078357769],
            [-0.710999335573348, -9.810864783932223],
            [-0.7198665144505495, -9.811420163037337],
            [-0.724507820888385, -9.812839103946168],
            [-0.7244878575799248, -9.808733648335135],
            [-0.7313929704017833, -9.809368517101953],
            [-0.733921293746991, -9.805679629817396],
            [-0.7385512165532417, -9.806923811740347],
            [-0.7402184957450092, -9.80211907332589],
            [-0.7494222556923384, -9.798738738363287],
            [-0.74790530772852, -9.790641780120312],
            [-0.7607499297947837, -9.786932124187896],
            [-0.7626471052544685, -9.790062063181406],
            [-0.7660394734342318, -9.789357275448634],
            [-0.7729297856642743, -9.780828523351895],
            [-0.7782159575706096, -9.780945896286186],
            [-0.8652209927789606, -9.847457132607088],
            [-0.9180608329427407, -9.888759337591745],
            [-0.9506875761418612, -9.847886790311222],
            [-1.0055104461633075, -9.77948370322716],
            [-1.0603149778447496, -9.711048583547578],
            [-1.072478562431693, -9.695651303005578],
            [-1.0467024994807825, -9.674960388372943],
            [-0.9845667461352399, -9.625578294903786],
            [-0.9619367096612254, -9.6073914289737],
            [-0.9573033227898202, -9.605067676803346],
            [-0.9468112233298072, -9.596412068562122]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.35673774092811,
          "lat": 29.082054707941115
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48123"],
        "coty_name": ["DeWitt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeWitt County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01383844"
      },
      "bbox": [
        -1.072478562431693, -9.888759337591745, -0.39010688298610935,
        -9.330434409692227
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.30302532172462, -6.075099107972644],
            [-4.238727311643742, -6.079141027405304],
            [-4.159675775793183, -6.083824735719875],
            [-4.0404437864109015, -6.091100678098827],
            [-3.936180535964144, -6.097240341128693],
            [-3.9348819477630204, -6.09742990762853],
            [-3.8726954444986643, -6.100691809984875],
            [-3.8743048909226863, -6.129504228606068],
            [-3.8755185896966644, -6.144243679450723],
            [-3.8954665541038622, -6.411325400925068],
            [-3.897240864053314, -6.4368790990927325],
            [-3.9045314607339785, -6.53616436374762],
            [-3.9720630326136948, -6.532544855059834],
            [-3.9784394049892713, -6.532132366706323],
            [-4.092048405706196, -6.525736791733757],
            [-4.205656403712421, -6.519323492265589],
            [-4.221543767110254, -6.518414515993016],
            [-4.334623279012353, -6.511358105491547],
            [-4.326774726278136, -6.4031958665486455],
            [-4.32281720650077, -6.3502300754385645],
            [-4.319181203586095, -6.299625691424963],
            [-4.30302532172462, -6.075099107972644]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.43558609198578,
          "lat": 32.306164631913276
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48227"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "227",
        "coty_gnis_code": "01383899"
      },
      "bbox": [
        -4.334623279012353, -6.53616436374762, -3.8726954444986643,
        -6.075099107972644
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.077024619331361, -7.216226981910087],
            [-2.064941445300126, -7.207270348798433],
            [-2.052705132282563, -7.200949274372327],
            [-2.0347903435191057, -7.189646710346467],
            [-1.9306320267247075, -7.120191182412999],
            [-1.8935988082580915, -7.095509915170597],
            [-1.8744210124382839, -7.019121981019338],
            [-1.7965351001948766, -7.008757531961337],
            [-1.7598564791174718, -7.003858195659465],
            [-1.754059383277744, -7.002699646599383],
            [-1.729091293947114, -6.999404840841175],
            [-1.671375105884964, -6.992515803185467],
            [-1.65317705794509, -6.9899484916172385],
            [-1.6471889670342266, -6.9897536105355496],
            [-1.6236124732812856, -7.029870099574264],
            [-1.5897884349651517, -7.087171805098248],
            [-1.558211388003397, -7.142519057224972],
            [-1.5403145335340256, -7.173502751774293],
            [-1.5272776810910842, -7.196610733459525],
            [-1.4668317495657066, -7.300406086357384],
            [-1.463338222251546, -7.3063420616185955],
            [-1.501211070275909, -7.332217996630552],
            [-1.580338908319723, -7.385268509063618],
            [-1.6914820308843463, -7.460290698044473],
            [-1.719740393723106, -7.479171075945969],
            [-1.719792730058578, -7.47385663663822],
            [-1.7215442364005888, -7.46699660854695],
            [-1.7242044745069427, -7.464753461478151],
            [-1.7296615992006998, -7.455305058912019],
            [-1.7333358108006462, -7.444024489829177],
            [-1.7407110817390454, -7.441629601872226],
            [-1.7444637706108825, -7.443188590642381],
            [-1.746080416987499, -7.447902126264084],
            [-1.7456342844811819, -7.454105814539588],
            [-1.7490441359076758, -7.455043707610631],
            [-1.7569824466155566, -7.447443956289118],
            [-1.7617738140724775, -7.445629127596896],
            [-1.7722242255331309, -7.438576209482095],
            [-1.7744342769516273, -7.434082644718819],
            [-1.7730135832198348, -7.427221606028436],
            [-1.7688270831595045, -7.423447662510559],
            [-1.761841359656678, -7.427115961944273],
            [-1.7537886135858562, -7.424874248186093],
            [-1.7487007842967628, -7.4225095677133055],
            [-1.74842490338761, -7.417262465580164],
            [-1.746251029058623, -7.403408851837961],
            [-1.7444716161108358, -7.397828692302442],
            [-1.7376887980657656, -7.39010349522413],
            [-1.7380446881075913, -7.384085873003312],
            [-1.742290437850911, -7.382495472585152],
            [-1.7454215780760585, -7.3856347999322995],
            [-1.7453982202718836, -7.388557798924681],
            [-1.7518141821216608, -7.395433128963126],
            [-1.7550705667510296, -7.396880903215002],
            [-1.769651565155099, -7.39924585383441],
            [-1.7754816833077849, -7.3983004177815115],
            [-1.7754696326056765, -7.393141190676264],
            [-1.7703244575390698, -7.3909962187656175],
            [-1.766184227768115, -7.38388673234425],
            [-1.7743393009315718, -7.382542118353884],
            [-1.77666309902428, -7.383525798848921],
            [-1.7828147815997097, -7.391124039202973],
            [-1.7865625646561425, -7.394105338160552],
            [-1.7908668212719598, -7.39048661091252],
            [-1.790222389370987, -7.384645688307955],
            [-1.7865297846291284, -7.382316124786464],
            [-1.782493500589514, -7.376493821371121],
            [-1.7867996326078752, -7.372819217167435],
            [-1.7884122692864997, -7.367552832194272],
            [-1.7839165713312226, -7.362418114498359],
            [-1.780940269680227, -7.361916586742423],
            [-1.7790603955614528, -7.355634920468582],
            [-1.7893140911203835, -7.3486341159005],
            [-1.7916123536806126, -7.351217539217861],
            [-1.7942361243592098, -7.347795806222748],
            [-1.7906079595797713, -7.343104092201301],
            [-1.7913553291519524, -7.339480269859499],
            [-1.796246653028991, -7.339414469648121],
            [-1.801696562480577, -7.344027497982432],
            [-1.807379939485531, -7.346614950679979],
            [-1.8077381986612386, -7.352650862010058],
            [-1.8121491224546744, -7.3548212505695485],
            [-1.8187127717244063, -7.361261001288658],
            [-1.8253074166230172, -7.363322642725096],
            [-1.8295873165974488, -7.3671238389254405],
            [-1.835857502103532, -7.36775877979574],
            [-1.8387666651935286, -7.360059659925268],
            [-1.843029560662137, -7.35996800888142],
            [-1.8444572348482797, -7.3578741734594155],
            [-1.8437634615312721, -7.35118971518321],
            [-1.839690068134893, -7.351313906449956],
            [-1.836981520303289, -7.3493488782761105],
            [-1.8351930666136436, -7.341594559428647],
            [-1.8370440569643869, -7.337739919006102],
            [-1.8360917105612746, -7.3268831382634625],
            [-1.831852288526364, -7.322415253887673],
            [-1.826261535996603, -7.319945195678297],
            [-1.8285019180841207, -7.313082462770046],
            [-1.8276932230069742, -7.303188666605295],
            [-1.8287616027156033, -7.300096699127904],
            [-1.8370769500226063, -7.2995912635041105],
            [-1.8471203697615093, -7.30282202926168],
            [-1.8518837008647515, -7.29945945564175],
            [-1.8560065871102012, -7.29476010299254],
            [-1.8531151382383229, -7.2909217456441455],
            [-1.851533572894548, -7.281694733550319],
            [-1.8551279272481531, -7.277658604158137],
            [-1.8633482804981996, -7.276130015850353],
            [-1.8674069985361044, -7.278232374993922],
            [-1.8628096447138334, -7.285839012729371],
            [-1.862599904195551, -7.289335446491872],
            [-1.8658388176915255, -7.298732745419033],
            [-1.8703055066603422, -7.302272420044679],
            [-1.8751600144737235, -7.302443923510877],
            [-1.87913706118437, -7.305479183667544],
            [-1.879021855245708, -7.309976696950759],
            [-1.8758841431139701, -7.3183608108834655],
            [-1.8857502799757482, -7.330350440520029],
            [-1.8899168685067451, -7.3295220473293075],
            [-1.8924185453506288, -7.325466815865531],
            [-1.8975132668910357, -7.328021417702057],
            [-1.8999957666894602, -7.326071005200768],
            [-1.8964730816713893, -7.317781809941348],
            [-1.8952473174275162, -7.3096986296999225],
            [-1.8952028997739463, -7.30252624692635],
            [-1.8935582461493687, -7.294622034540364],
            [-1.897073643887841, -7.291446169800778],
            [-1.9059330774863688, -7.297261158813047],
            [-1.9093470629881413, -7.297191626797144],
            [-1.9160080073980388, -7.294292796615011],
            [-1.9208654075700187, -7.297798471413964],
            [-1.928211505228757, -7.29979637838503],
            [-1.9309554856660673, -7.297512347747919],
            [-1.9285033016735385, -7.290880504404712],
            [-1.9324721311919426, -7.287984563530447],
            [-1.939415074468033, -7.29260924884786],
            [-1.943765022210384, -7.293998862730024],
            [-1.9558147461168238, -7.2932422697961865],
            [-1.9625679216587102, -7.290105689423203],
            [-1.960803291714884, -7.283202034896583],
            [-1.9661684337129743, -7.268547237878454],
            [-1.9716436738262229, -7.262838471336354],
            [-1.9771044943514717, -7.258913963644657],
            [-1.9881498547813043, -7.259961815729382],
            [-1.9899639677812881, -7.262947775333655],
            [-1.9972643382104505, -7.2689988223653],
            [-2.002363049895003, -7.266399705440378],
            [-2.0121131821069165, -7.2678053338333],
            [-2.015161102853452, -7.266191280794018],
            [-2.022182888311518, -7.267822214206688],
            [-2.0288849254593537, -7.264688230266657],
            [-2.03058703836076, -7.25509657231806],
            [-2.0306081608447113, -7.2457025092608704],
            [-2.033863077641418, -7.243295108797306],
            [-2.039324403693291, -7.243055555495237],
            [-2.0427287224129427, -7.244291866291346],
            [-2.047294109804667, -7.2487164007309275],
            [-2.045379301828852, -7.253838827438328],
            [-2.051796386436929, -7.260887897604923],
            [-2.054843853970665, -7.265915570520785],
            [-2.0580904606974513, -7.2628331676790845],
            [-2.0572559889938153, -7.2564488002007845],
            [-2.0544230007609308, -7.254613609310593],
            [-2.054853426025969, -7.248618295281247],
            [-2.0577926859860267, -7.246598335068755],
            [-2.064947225885895, -7.245048173109405],
            [-2.072445779423408, -7.238557538113278],
            [-2.0804793826550108, -7.233454231499575],
            [-2.0800831833441933, -7.229171036825353],
            [-2.0732244621880995, -7.221469452355945],
            [-2.073538670425743, -7.218323770359382],
            [-2.077024619331361, -7.216226981910087]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.59543662447982,
          "lat": 31.495155757041644
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48333"],
        "coty_name": ["Mills"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mills County"],
        "coty_fp_code": "333",
        "coty_gnis_code": "01383952"
      },
      "bbox": [
        -2.0804793826550108, -7.479171075945969, -1.463338222251546,
        -6.9897536105355496
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.1658119199376233, -4.832876128739645],
            [-1.1577039220125223, -4.8405275420045335],
            [-1.1500771802351653, -4.8439487018987935],
            [-1.1441416427303572, -4.844828416479206],
            [-1.1371213687779362, -4.843544988410722],
            [-1.132201762815818, -4.84428863865407],
            [-1.1067492897058, -4.86053727963283],
            [-1.0996672809179535, -4.866246538209016],
            [-1.0885855097473884, -4.870103515316742],
            [-1.0838732779266307, -4.874338738223896],
            [-1.0790018023641443, -4.875674352065491],
            [-1.0743106525348425, -4.8753727141123955],
            [-1.060809382273698, -4.870693232551211],
            [-1.0556121641797436, -4.868261865759067],
            [-1.0482418673767655, -4.86756766278457],
            [-1.045308617570164, -4.863485680713424],
            [-1.035387948503945, -4.855528215180037],
            [-1.0353864018229182, -4.846308504262045],
            [-1.0330135619494374, -4.8433517213380055],
            [-1.0298033093356627, -4.844344525791189],
            [-1.0257673275639594, -4.849192177463885],
            [-1.0216871990990388, -4.845685092511562],
            [-1.0205849349058438, -4.8393454534904174],
            [-1.0208788444345256, -4.831359802118534],
            [-1.0173074168723457, -4.826374797162641],
            [-1.0115762604122764, -4.827460575180134],
            [-1.0094265895766201, -4.834019191136419],
            [-1.006713931955934, -4.835258781284716],
            [-1.002807456118394, -4.83055857548002],
            [-1.002852506167948, -4.821076398738161],
            [-1.0074170464139656, -4.812545702392188],
            [-1.0065473074754567, -4.80897634535178],
            [-1.0020461563559644, -4.806142533376061],
            [-0.9986365864729986, -4.807820692550757],
            [-0.9963571446264756, -4.811609395747292],
            [-0.989028311824362, -4.8118868561466535],
            [-0.9853430594701417, -4.8073571598220335],
            [-0.9855820990023227, -4.800936469754421],
            [-0.9878047248267897, -4.795236152773617],
            [-0.9878264976756798, -4.791671049807765],
            [-0.9796991683433295, -4.789156854768807],
            [-0.9677711903037406, -4.789001658627344],
            [-0.9626708510897031, -4.789827496410528],
            [-0.956845922679699, -4.785561021011036],
            [-0.9497133871104807, -4.779041179583578],
            [-0.9437454659376234, -4.771786757077046],
            [-0.9390468987688001, -4.763496849663686],
            [-0.9336607189602575, -4.749538787329558],
            [-0.9295873621534131, -4.743216141911583],
            [-0.9253494739080365, -4.740370878819227],
            [-0.9118933559562736, -4.735824592182807],
            [-0.9034424788087821, -4.736526649408723],
            [-0.8991223607158108, -4.737937477638548],
            [-0.880807893172628, -4.746519413650486],
            [-0.8733263214667115, -4.752077113733166],
            [-0.8660111275857265, -4.758521918388053],
            [-0.8607177605609587, -4.760080564175118],
            [-0.8541584875868106, -4.767659126620262],
            [-0.8529956391755287, -4.772029727154471],
            [-0.8455884119484822, -4.774381851736034],
            [-0.8443136823829877, -4.776634339164892],
            [-0.8487322435609098, -4.783874804213348],
            [-0.8499586827551121, -4.789558757566412],
            [-0.8466251060639536, -4.797318000417174],
            [-0.8469243249090319, -4.80037048543691],
            [-0.8515594564831167, -4.808297560028738],
            [-0.851100500779694, -4.814790503256396],
            [-0.8467578741279231, -4.819046947214754],
            [-0.8454722887922705, -4.824771313947301],
            [-0.8388087071806974, -4.8291421389179225],
            [-0.8317520113834835, -4.829683504529225],
            [-0.8285962860854094, -4.82760394549095],
            [-0.8221864703139008, -4.829506500815126],
            [-0.8200629679348165, -4.832041008604223],
            [-0.8145057328243434, -4.8312802121804035],
            [-0.8076177855493357, -4.8280365630027315],
            [-0.7988635659820422, -4.822868475589408],
            [-0.7926466897350432, -4.81777328218753],
            [-0.7724926397894973, -4.8101691033582314],
            [-0.7674733772821787, -4.810634496449924],
            [-0.7586167745103438, -4.814283089926311],
            [-0.7628720414397268, -5.032609977162938],
            [-0.7639394983083742, -5.08200229212922],
            [-0.7664878446073212, -5.189427493861221],
            [-0.7687070505128218, -5.297840104348768],
            [-0.7811593106057975, -5.297388415157246],
            [-0.8705969614445951, -5.295856056256953],
            [-0.9845446331913231, -5.293949021369555],
            [-1.0610703945596123, -5.292621091122736],
            [-1.0942782361002608, -5.291787413699804],
            [-1.1259662773096375, -5.291274195606035],
            [-1.1763317259906347, -5.290371212833997],
            [-1.1755921657010022, -5.2569098031404575],
            [-1.1741719194792442, -5.188397303334403],
            [-1.1725143873467014, -5.105997550985501],
            [-1.1700373850242476, -4.995773016707274],
            [-1.1674239120165173, -4.908860323267146],
            [-1.1658119199376233, -4.832876128739645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.7246405042727, "lat": 33.675713042842546 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48337"],
        "coty_name": ["Montague"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montague County"],
        "coty_fp_code": "337",
        "coty_gnis_code": "01383954"
      },
      "bbox": [
        -1.1763317259906347, -5.297840104348768, -0.7586167745103438,
        -4.735824592182807
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.221991131703112, 1.564794200311516],
            [-10.221982054617172, 1.5647928516573777],
            [-10.168564702241941, 1.5568785169773076],
            [-10.169667626235494, 1.549422715386081],
            [-10.038856187766804, 1.5305807163153626],
            [-9.908047300263247, 1.51172087807745],
            [-9.71842493144246, 1.484832611155764],
            [-9.52880783369397, 1.457906886690098],
            [-9.52677843307263, 1.4593603753616968],
            [-9.525820950344839, 1.4649012465745508],
            [-9.519308342127722, 1.465889031134655],
            [-9.518287191546264, 1.4735176964419097],
            [-9.512653474811746, 1.4790247540169408],
            [-9.509967440750648, 1.4860956423095073],
            [-9.506854553855257, 1.4826500142988117],
            [-9.50221270060805, 1.4818209273163325],
            [-9.498367886814941, 1.4898614346905241],
            [-9.495522492433645, 1.487526076544168],
            [-9.485977532129997, 1.4903962502251116],
            [-9.481808287540483, 1.4876710011759766],
            [-9.499460624173555, 1.3566261385189542],
            [-9.53327536008065, 1.1161658604733782],
            [-9.551409315622212, 0.990158952330299],
            [-9.570026327162434, 0.8653388967945008],
            [-9.583466798577684, 0.7861420021386188],
            [-9.595564488867396, 0.7107925748177759],
            [-9.612784866006598, 0.5902883315849196],
            [-9.626296603558414, 0.49093751347017034],
            [-9.832441416112086, 0.5196725758452075],
            [-9.93180275437008, 0.5337579309727318],
            [-10.080655385144588, 0.555107827671706],
            [-10.22376272157223, 0.5761258346799474],
            [-10.366872240698948, 0.5971288892069269],
            [-10.370107941372806, 0.6003191821631042],
            [-10.37495852859332, 0.6020430408886388],
            [-10.380374941922563, 0.6066863496410738],
            [-10.380912276680485, 0.60958182341301],
            [-10.378982591325627, 0.6153134837746729],
            [-10.37443945716562, 0.6170578107700317],
            [-10.370772694485963, 0.6165460389092582],
            [-10.363158883270595, 0.6100772394318886],
            [-10.357730773871092, 0.6096341544366577],
            [-10.355186735848456, 0.6123003140129939],
            [-10.354243271079671, 0.6191903890337216],
            [-10.352500074038364, 0.6203851271671589],
            [-10.344367185121687, 0.6162707952075575],
            [-10.338988009288938, 0.6190516751513929],
            [-10.33971929105296, 0.6231349674883867],
            [-10.343809595095628, 0.6291906135676376],
            [-10.345618439589746, 0.6338718400607357],
            [-10.345395010620965, 0.6380146505308668],
            [-10.33969769449199, 0.6456180595374],
            [-10.333241346208357, 0.6492089004694391],
            [-10.330174347182348, 0.6523849486981373],
            [-10.328831330363496, 0.6566332042857083],
            [-10.330429796053403, 0.660529517337704],
            [-10.333425239497352, 0.6626528269335051],
            [-10.337685811578476, 0.6622365354007042],
            [-10.346049485522375, 0.6571001726625871],
            [-10.34938454430558, 0.6569839753746243],
            [-10.351577513950975, 0.6595176579981988],
            [-10.352448593928187, 0.6710032695759328],
            [-10.356441811781188, 0.6741436041723704],
            [-10.362051406231512, 0.6698930857494267],
            [-10.366543292933686, 0.6708225868511695],
            [-10.369340649221886, 0.6770197245890465],
            [-10.37858412757037, 0.6787901119980247],
            [-10.380299768282505, 0.6828513880291565],
            [-10.37331942572055, 0.6917657310969956],
            [-10.357709652925747, 0.7025497987376816],
            [-10.352251487742118, 0.697018160197005],
            [-10.348273914532957, 0.6860509106332491],
            [-10.3419543327589, 0.6823644534175268],
            [-10.33623278376656, 0.6828554533873191],
            [-10.331990161941219, 0.6858486119867497],
            [-10.329463315806105, 0.6924484909624362],
            [-10.329907465858948, 0.6968912682743844],
            [-10.328411090869414, 0.7019362839573174],
            [-10.329330673455136, 0.7107397010034271],
            [-10.333080090297972, 0.7160148992532964],
            [-10.337620041373421, 0.7192600953766735],
            [-10.341436803064616, 0.71892049385027],
            [-10.346226516235738, 0.7084547312557289],
            [-10.351630952016126, 0.7057709559992037],
            [-10.360104573274715, 0.7075200127899997],
            [-10.371790972978175, 0.7053375603066812],
            [-10.3783073398994, 0.7073689513564545],
            [-10.381078703251102, 0.7099727055172019],
            [-10.383090328455546, 0.7178533506179896],
            [-10.379628920653012, 0.7212767124162859],
            [-10.376865534141503, 0.7210057165762322],
            [-10.368102468543253, 0.7152159166452396],
            [-10.362620002688203, 0.7159932861054875],
            [-10.361756153582363, 0.7219231535989361],
            [-10.364610714416159, 0.7285892013503052],
            [-10.365300195932603, 0.7341123033958772],
            [-10.362091946189556, 0.7409200912969992],
            [-10.352803563021912, 0.7495150360207181],
            [-10.352449625092277, 0.754900036476894],
            [-10.354592187979295, 0.7573522137848925],
            [-10.360156953525394, 0.7580701855320781],
            [-10.361655722577067, 0.749506362884964],
            [-10.365135822390895, 0.7461649078079895],
            [-10.369620058398946, 0.7477015293755009],
            [-10.371103664970162, 0.7513841414558116],
            [-10.366844965000546, 0.7571582759859915],
            [-10.366118583917544, 0.7603911512395582],
            [-10.368716008215667, 0.7629248553587717],
            [-10.374501503098298, 0.7592975739787343],
            [-10.378545286492614, 0.7588745707948787],
            [-10.380261469341171, 0.7639804708990621],
            [-10.376829148748138, 0.7667689012520473],
            [-10.37479870129693, 0.7720275547420835],
            [-10.376448700515835, 0.7749491534586638],
            [-10.379992971118094, 0.7750133208605934],
            [-10.390834214548327, 0.7693885076036272],
            [-10.394910622639316, 0.7708864634112012],
            [-10.393848692149897, 0.7745039854256814],
            [-10.387499145135635, 0.7810314647080916],
            [-10.389600707765654, 0.7866505694497667],
            [-10.394674599984366, 0.7939521219214163],
            [-10.39609949773204, 0.7990763752779586],
            [-10.393274283022883, 0.8029142077260559],
            [-10.388825092616901, 0.804400468097761],
            [-10.383108590924742, 0.8100056530529444],
            [-10.382254130050399, 0.8156232868161446],
            [-10.385501050701764, 0.8190572726320191],
            [-10.39168497296365, 0.8195298541508932],
            [-10.396245138539483, 0.8185300792350866],
            [-10.40305846068273, 0.8136115710242856],
            [-10.409177421955302, 0.81358888092411],
            [-10.410755524868636, 0.8161128708899873],
            [-10.407378874883294, 0.8202484151474985],
            [-10.400348350175864, 0.8191813572091706],
            [-10.397838671776032, 0.8205864555081528],
            [-10.39734165508387, 0.8250906700054325],
            [-10.399901330188769, 0.8324693661013889],
            [-10.399267336682781, 0.8395582947839414],
            [-10.392994285746253, 0.8457151245813611],
            [-10.388721277580075, 0.852453974069746],
            [-10.386040406917715, 0.854568663967717],
            [-10.38057460703315, 0.8557131420192525],
            [-10.373692902593447, 0.8553277807549101],
            [-10.372019028385893, 0.8580403101385795],
            [-10.376990864825549, 0.8748743693279633],
            [-10.38933691375885, 0.8847653140957874],
            [-10.394492664681033, 0.8925260743740744],
            [-10.397095359720028, 0.8989803149933903],
            [-10.394527343385972, 0.9029284248151702],
            [-10.385481570559762, 0.9047399350828786],
            [-10.382600640205455, 0.9073155169011397],
            [-10.382549641200237, 0.9167268357825074],
            [-10.3860301833071, 0.9252473263974682],
            [-10.393205119715464, 0.9276927885812207],
            [-10.39435582435787, 0.9313725685529253],
            [-10.390582449324272, 0.9342418438739094],
            [-10.39036661159735, 0.9398321792548556],
            [-10.393883412776088, 0.9420715027846801],
            [-10.40160603294484, 0.9437966567820633],
            [-10.408279564955334, 0.9496764280927197],
            [-10.408058151127708, 0.9532386525657994],
            [-10.402563883038795, 0.9621355054704905],
            [-10.399216259354876, 0.9661704262281801],
            [-10.397447708005524, 0.9730644673917154],
            [-10.398197199867349, 0.9773661978498336],
            [-10.40336842130371, 0.9788690810089529],
            [-10.410209192582291, 0.9737443445874502],
            [-10.414454281850139, 0.9735379937986925],
            [-10.417532226447205, 0.9779996445647019],
            [-10.414705642499925, 0.9852083207848907],
            [-10.414745089486898, 0.9910320629449315],
            [-10.411645529341593, 0.9996983291156213],
            [-10.411359054275831, 1.003190502695122],
            [-10.41519475867151, 1.0131212560971823],
            [-10.418159903358417, 1.0170210708252296],
            [-10.423447047161256, 1.0209790035000514],
            [-10.420636505756896, 1.0259427191914998],
            [-10.421458987708908, 1.0332867792935951],
            [-10.416274724793661, 1.040464331675381],
            [-10.409935209402358, 1.0392122028865274],
            [-10.401505253129674, 1.0359402517783456],
            [-10.393585500818961, 1.0337676531710973],
            [-10.389941987733195, 1.0337799958202394],
            [-10.385801707261637, 1.0427907410556794],
            [-10.388891696692772, 1.05412699412869],
            [-10.395213926434694, 1.0586515915141343],
            [-10.396911761884665, 1.0612948681788998],
            [-10.39338914736444, 1.0659460416339417],
            [-10.387699462801717, 1.0667498051509723],
            [-10.383688954474943, 1.0691856070390822],
            [-10.383045490434062, 1.0718370808467574],
            [-10.39124545609697, 1.0824898324635392],
            [-10.391627540058838, 1.0865240479866614],
            [-10.38900179962349, 1.0901807076431838],
            [-10.367617839266037, 1.0870490969494326],
            [-10.367045816278532, 1.0906156264003315],
            [-10.35633987014418, 1.0890011660533272],
            [-10.356866557987422, 1.0854166243817884],
            [-10.349865203426244, 1.083549742002425],
            [-10.329136857770333, 1.0804470866755937],
            [-10.331316536979193, 1.0659369979266728],
            [-10.31712651096025, 1.0638268641882571],
            [-10.318210604974064, 1.0565744782051751],
            [-10.31111709532412, 1.055522738719588],
            [-10.31219531634606, 1.0482735243912193],
            [-10.283845752508112, 1.0440395251801509],
            [-10.281685911526216, 1.0585527439584665],
            [-10.29586116152248, 1.0606627718966088],
            [-10.293684723783965, 1.0751580681510282],
            [-10.307868292548102, 1.077271134431316],
            [-10.305701139629116, 1.0917890915149482],
            [-10.319885490002276, 1.0939295970934282],
            [-10.320968191458636, 1.0866444856155955],
            [-10.348781278791769, 1.0908030567072702],
            [-10.346468620930384, 1.1061953212575362],
            [-10.375065824298087, 1.1105342919539605],
            [-10.376144594965135, 1.1031843416255054],
            [-10.381413600234426, 1.103993163408091],
            [-10.388131099097096, 1.1079001439843834],
            [-10.387451790695941, 1.1128122088740935],
            [-10.381994538683898, 1.110771185268025],
            [-10.377802933629386, 1.1133808137501322],
            [-10.379408976757325, 1.1190568676745802],
            [-10.385541187018916, 1.120583478329747],
            [-10.387708541765504, 1.127408629929438],
            [-10.378722086737042, 1.129804269203593],
            [-10.376212627848707, 1.1342582499136216],
            [-10.380949346201188, 1.1392389374772274],
            [-10.385598657408993, 1.1419204582403768],
            [-10.387568546091455, 1.146388743947271],
            [-10.386358344819804, 1.1488437437613486],
            [-10.380295721749052, 1.1512467240053312],
            [-10.370106399535466, 1.1702284925540836],
            [-10.369185292605675, 1.1794491687793018],
            [-10.372173934339056, 1.1871562190429217],
            [-10.367879048953563, 1.1906105644333933],
            [-10.369414027090102, 1.1945905797532597],
            [-10.36714378633802, 1.1977655586264095],
            [-10.357955899967346, 1.198401022637282],
            [-10.35159653196427, 1.200530444803204],
            [-10.348326516993708, 1.2038124169028697],
            [-10.348151959315079, 1.2080994860172438],
            [-10.339843711951245, 1.2206106896996647],
            [-10.341775487606244, 1.2223243315609598],
            [-10.342727293203886, 1.2285505410139077],
            [-10.338861138020176, 1.2364025020816585],
            [-10.331437790954148, 1.2387015403885837],
            [-10.328858139850144, 1.2411634805710925],
            [-10.33050960765529, 1.2481409455393002],
            [-10.33442916041402, 1.2497810876221038],
            [-10.337256339696344, 1.253161486109226],
            [-10.336669744287297, 1.2562773758953785],
            [-10.339109392172228, 1.2596601466359263],
            [-10.33581098814945, 1.2655617592927144],
            [-10.329405544659187, 1.2674024545131637],
            [-10.323465383349822, 1.272850384611279],
            [-10.326916415135171, 1.2847115342401094],
            [-10.324062980008375, 1.2900205285355812],
            [-10.319664331110962, 1.294291456957216],
            [-10.313044765039306, 1.2969675297018282],
            [-10.30573863417921, 1.295371917871886],
            [-10.299413620596827, 1.3024107332792438],
            [-10.297672018556108, 1.3082790007093619],
            [-10.300079178067675, 1.3198948765471634],
            [-10.29934354417316, 1.32684578899567],
            [-10.294798936608242, 1.3303651425158836],
            [-10.291908819941606, 1.3289321446179074],
            [-10.290241415534183, 1.324511990855687],
            [-10.286656779095344, 1.3237910703625178],
            [-10.280722089234091, 1.3280225119703852],
            [-10.280245934606766, 1.3326394495584235],
            [-10.282449504876558, 1.3393963491655514],
            [-10.281927651527234, 1.3434023555129342],
            [-10.28446850571222, 1.349821839195113],
            [-10.28113627047506, 1.3570621708837254],
            [-10.280637287959848, 1.3660582764803788],
            [-10.289598023541899, 1.3730338445769317],
            [-10.291188660368787, 1.3787813838784262],
            [-10.289403951780551, 1.3831142228501319],
            [-10.286990825647905, 1.3840227198430746],
            [-10.286174594840519, 1.389758164520908],
            [-10.280723308630382, 1.394647457758654],
            [-10.268871041801525, 1.3982173433397838],
            [-10.265924859244198, 1.4000673991528314],
            [-10.265737049018526, 1.4034770303312807],
            [-10.268770972693392, 1.4072265473156758],
            [-10.273341339496751, 1.4073256685579085],
            [-10.274284190512455, 1.411875166133282],
            [-10.268371784164056, 1.4180849359693006],
            [-10.270114306028594, 1.425559410117918],
            [-10.26816064981689, 1.4301324091243544],
            [-10.265083443130267, 1.4255794916640223],
            [-10.261136230421961, 1.4248469817799696],
            [-10.259139667574336, 1.4291556090803739],
            [-10.251241797682962, 1.4350197927633417],
            [-10.248176847031221, 1.4445252106630508],
            [-10.245472496619742, 1.447684954973885],
            [-10.238650878992882, 1.4471373795155158],
            [-10.236966815033307, 1.450303056646774],
            [-10.238360124858762, 1.4539004185820896],
            [-10.2337682458679, 1.4578349638484287],
            [-10.237068342258802, 1.4658067845200622],
            [-10.2370308247419, 1.4725879687201244],
            [-10.231499558081584, 1.4740005595227341],
            [-10.22927707797545, 1.4799755587944636],
            [-10.231483295604951, 1.4852228277019746],
            [-10.228103851646258, 1.4925154278179669],
            [-10.22796150379565, 1.4950509682535293],
            [-10.220225360428344, 1.5041309770466056],
            [-10.219913550789814, 1.511110801141288],
            [-10.222748930307466, 1.5154544189302037],
            [-10.22850361960673, 1.5187413491513095],
            [-10.225743884824766, 1.5232028381795868],
            [-10.224763330590513, 1.5323695350406028],
            [-10.226353857031524, 1.5349532981607155],
            [-10.225222286054072, 1.5409461093220953],
            [-10.221990154942986, 1.546961453003527],
            [-10.217785848001327, 1.550883947723095],
            [-10.221686240004791, 1.5550970871539607],
            [-10.223312359993843, 1.5622625849229161],
            [-10.221991131703112, 1.564794200311516]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.56982188511539,
          "lat": 38.98196130024986
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49019"],
        "coty_name": ["Grand"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grand County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01448024"
      },
      "bbox": [
        -10.423447047161256, 0.49093751347017034, -9.481808287540483,
        1.564794200311516
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.427789203394525, 0.057495428880078844],
            [14.431783943806925, 0.05657487841975077],
            [14.43553414574343, 0.049421951400922384],
            [14.441204012832483, 0.0499215618286899],
            [14.4491317222546, 0.05600487035911643],
            [14.45315241950842, 0.05556935798218697],
            [14.453587740431523, 0.04944238305971256],
            [14.456172620957261, 0.04839514311951466],
            [14.4584771148822, 0.05309745533370786],
            [14.458206316298734, 0.06428577664381441],
            [14.461686212846114, 0.06662605411660402],
            [14.47216894227373, 0.06362589810639721],
            [14.475003126513508, 0.06528128233182166],
            [14.479202800817474, 0.06452156448600019],
            [14.484043700286977, 0.07049904191601801],
            [14.483320756435125, 0.0770227261910266],
            [14.4877667512763, 0.08339712881829621],
            [14.487549196929143, 0.0863523792849978],
            [14.4945454024196, 0.08966181331708231],
            [14.498601853859524, 0.08839688830915277],
            [14.504235743507945, 0.08965370672428458],
            [14.508899402644593, 0.09289356435709713],
            [14.513279842832842, 0.09108791317057356],
            [14.511871597008854, 0.10244036781049885],
            [14.512225668791563, 0.10845806808480098],
            [14.511039257571241, 0.11119808176385242],
            [14.521838399099526, 0.12003769646047176],
            [14.530064423721743, 0.11282286273494209],
            [14.534013505026037, 0.11044224404661754],
            [14.541478226039315, 0.11090394384472985],
            [14.548440342332302, 0.11259220076899076],
            [14.55564234934556, 0.11064503443620809],
            [14.558418656028307, 0.11186331387069115],
            [14.564522138057491, 0.10933565684155995],
            [14.572634408347982, 0.10882463571266682],
            [14.574107218723666, 0.10680556586816316],
            [14.578699925844555, 0.10954017450649498],
            [14.582463430114185, 0.11537532324900843],
            [14.591872260905433, 0.1096009815655363],
            [14.599049371055179, 0.1104603285459607],
            [14.603175451127193, 0.11240328887981135],
            [14.608059879423942, 0.10904738982276697],
            [14.609427032576217, 0.10472232241323626],
            [14.6083941381239, 0.09423614355363695],
            [14.612599245850596, 0.0874214503962877],
            [14.618520100877584, 0.08849765919398282],
            [14.624651105294845, 0.09735797046980153],
            [14.63233435049552, 0.09882811951494323],
            [14.633398741050094, 0.09578789956717244],
            [14.632685860407491, 0.08886964362623143],
            [14.638508460434117, 0.0791348215538953],
            [14.64525861594657, 0.07559805796726918],
            [14.644835416014388, 0.06615721764826098],
            [14.64853521170882, 0.062477536054191575],
            [14.646492959480451, 0.05815516223874943],
            [14.635041963441346, 0.060002696874229045],
            [14.633278626000697, 0.05711587136244522],
            [14.637600294003343, 0.04727920239816042],
            [14.639291754838547, 0.04122435405716169],
            [14.643782329372538, 0.03631888888424047],
            [14.639800099375327, 0.033727528577364496],
            [14.639553374177707, 0.02810684080754523],
            [14.637377792389561, 0.024481290604082565],
            [14.639499430233775, 0.019290037137813375],
            [14.641345493351116, 0.010814310026360624],
            [14.641204378108934, 0.007463223277132763],
            [14.644854980612319, 0.004195148971911552],
            [14.65481517861819, 0.0059326269306804146],
            [14.662140519099076, 0.0016382119485391887],
            [14.66422964159137, -0.00722857495855681],
            [14.666133304878324, -0.009464668542777133],
            [14.677622575917479, -0.014159341483135569],
            [14.693018138382302, -0.011469307298596968],
            [14.708344990656013, -0.012383122291495161],
            [14.710284354654574, -0.013681618628241276],
            [14.709570502787143, -0.019014347302582606],
            [14.712157644334752, -0.02229582270235182],
            [14.709327067699762, -0.028347484547685556],
            [14.703946526794843, -0.03274030811984065],
            [14.707777498142239, -0.043140246751563104],
            [14.716196828476122, -0.04680529906815165],
            [14.72254938455239, -0.04666563027088135],
            [14.726247777973969, -0.04782220913439409],
            [14.740396721248764, -0.05691500621724529],
            [14.743418960356644, -0.06650428156039852],
            [14.747693450693605, -0.07014752781279933],
            [14.751893976968548, -0.07141234470211075],
            [14.763171317837783, -0.07115293854125139],
            [14.767511126455021, -0.06668784679246859],
            [14.766782195461458, -0.05259664338502489],
            [14.772415042161626, -0.04986271920179336],
            [14.778015958628867, -0.051381113663685744],
            [14.780634322242834, -0.04922007790823824],
            [14.779337098264254, -0.043165543134232556],
            [14.779265282521894, -0.0371181927642986],
            [14.784379541979993, -0.032825706216924225],
            [14.790796957798706, -0.03564062055506901],
            [14.795040598674273, -0.043482773187130695],
            [14.800533633656903, -0.04884456559410118],
            [14.804623553596677, -0.04703543997325668],
            [14.806347837350547, -0.04302719874981611],
            [14.806390342197592, -0.03710324355362644],
            [14.811306086771978, -0.03511596510619669],
            [14.817811339156846, -0.03413685645199519],
            [14.820807437923575, -0.03837898239437041],
            [14.824284288573011, -0.047024233964157364],
            [14.829706791922002, -0.052515425032526736],
            [14.832891221294576, -0.05710322289902676],
            [14.836144145657475, -0.05869999753621096],
            [14.836011260628707, -0.06319642611739616],
            [14.839319982757345, -0.06809211019840396],
            [14.835969979087807, -0.06912769088015576],
            [14.83379013585933, -0.07340579336075194],
            [14.835288013691438, -0.0779342883700092],
            [14.831529633959113, -0.07934054480287893],
            [14.832573236225626, -0.08446812771390408],
            [14.822002305352687, -0.08653166574619232],
            [14.822658029242008, -0.09031829455048705],
            [14.818456136705182, -0.09374858071338875],
            [14.815046360362375, -0.09298497012310698],
            [14.813422957039089, -0.0967080278492596],
            [14.813805843332686, -0.10101801842904856],
            [14.817166277926606, -0.10271728763778742],
            [14.814301257807644, -0.10785331417871784],
            [14.805446930645232, -0.10811193848603284],
            [14.802201124150468, -0.11302216242252691],
            [14.798389165439739, -0.11421247938814423],
            [14.795994199179656, -0.11839174247340915],
            [14.790565352997996, -0.12336636200180984],
            [14.787621489615292, -0.13248281360856815],
            [14.782138427171184, -0.13562570715437028],
            [14.774992216245248, -0.14508755618553512],
            [14.767567332421848, -0.1470328115260945],
            [14.762249680928694, -0.1457474947510366],
            [14.745640203768064, -0.14636265214717334],
            [14.73775446099995, -0.14992885612264986],
            [14.737664284129352, -0.1524765763175489],
            [14.714558605527584, -0.14799509713216957],
            [14.67913570891571, -0.14341990603910243],
            [14.672581309015511, -0.14334243829334806],
            [14.614712189179704, -0.13708856069127365],
            [14.554639545640054, -0.1311682484551022],
            [14.544876046390879, -0.13042475537985576],
            [14.45880713252915, -0.12237168927340283],
            [14.380923371468633, -0.1142646570511828],
            [14.364489758378719, -0.043501623221991595],
            [14.365263341665237, -0.04177268945374314],
            [14.359984899041601, -0.03834569673119455],
            [14.364514990500323, -0.02762427903231918],
            [14.37011174703657, -0.02424069380663934],
            [14.372083507796768, -0.021431840171439925],
            [14.373868008163267, -0.00820745264609345],
            [14.377203132530099, -0.004534834418446194],
            [14.379925953912306, 0.0024906440577923575],
            [14.37891628180342, 0.008437071295621342],
            [14.380888053865155, 0.01185897456240353],
            [14.379302621808433, 0.019140313562929803],
            [14.384433557797715, 0.02169447050140548],
            [14.389351942413768, 0.020032850012256735],
            [14.390888399877605, 0.028860003476162393],
            [14.388981650800028, 0.034267358030867806],
            [14.388798371630637, 0.0396726989011143],
            [14.392673914070244, 0.04078712594573398],
            [14.39967344702368, 0.039664085534649125],
            [14.404479290179868, 0.04463333288030982],
            [14.40838534213772, 0.052882580420918264],
            [14.41455885681132, 0.05276975592472556],
            [14.421658381917569, 0.0614482271599574],
            [14.427789203394525, 0.057495428880078844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.97617080919962, "lat": 37.33597578533221 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51007"],
        "coty_name": ["Amelia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Amelia County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01497770"
      },
      "bbox": [
        14.359984899041601, -0.1524765763175489, 14.839319982757345,
        0.12003769646047176
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.12560858995307, -0.32721028762134174],
            [13.127138709753547, -0.323180554329318],
            [13.126718868681227, -0.3184158600964341],
            [13.134388927687798, -0.30970692276716855],
            [13.149675897937797, -0.2965212486762767],
            [13.155121614960223, -0.2872400136917254],
            [13.160291450611965, -0.284595976582467],
            [13.164396530416138, -0.2795610411071705],
            [13.165307993777052, -0.2740564691446429],
            [13.164290645107704, -0.2695603938140279],
            [13.165152480539819, -0.25910195874466435],
            [13.169957496343619, -0.2533217217771147],
            [13.169938087600777, -0.2499477769578858],
            [13.166641176816972, -0.2459419611410334],
            [13.160776287387558, -0.24646171929854593],
            [13.156283274644714, -0.2487110517808063],
            [13.144557162700183, -0.2387782971927092],
            [13.143948108123332, -0.23471906389999636],
            [13.140674574336332, -0.23380682108975442],
            [13.135300480885418, -0.22892778033150127],
            [13.145854523520837, -0.22175125743675647],
            [13.152804514639362, -0.22065303200229433],
            [13.160775682387607, -0.21265533457756086],
            [13.168247111263524, -0.20695701602319205],
            [13.17076243663147, -0.20288345769235322],
            [13.176547415059776, -0.19955611553854724],
            [13.178859248528326, -0.1926808498582944],
            [13.182542038601396, -0.19115549439857496],
            [13.188498948280808, -0.1846646303123738],
            [13.190305218211584, -0.18086731635085088],
            [13.196247671979124, -0.1760597012740169],
            [13.203080989861668, -0.16711295791764721],
            [13.206034907192107, -0.16433492618262743],
            [13.20631583047302, -0.15925144627389967],
            [13.209592737579726, -0.15802828745399447],
            [13.218998001499424, -0.13996080988622667],
            [13.22697570993298, -0.13369529307896347],
            [13.227523597353075, -0.13120719870135605],
            [13.237342194864613, -0.12994116252709517],
            [13.241713439740085, -0.1271693459894721],
            [13.246344099834765, -0.1294921108872971],
            [13.258851626613632, -0.13845131591298154],
            [13.261576815303233, -0.1478804755549887],
            [13.265595512489279, -0.15170575820645327],
            [13.270867908229187, -0.1542909025852828],
            [13.278608425077058, -0.14842056364876877],
            [13.290943205756856, -0.1508343376095116],
            [13.298375046007873, -0.15435853193434487],
            [13.306342074487434, -0.14987953423777825],
            [13.307278493255637, -0.14589785180522735],
            [13.30397776553253, -0.13841383015696013],
            [13.30592341863897, -0.1277397765505121],
            [13.308673721546747, -0.12027803350263754],
            [13.311377392521221, -0.11725868414690725],
            [13.312027227712198, -0.11215000789891609],
            [13.31483188969285, -0.1089170186737855],
            [13.317023320699027, -0.1023538830619852],
            [13.31938126083307, -0.09938421011459292],
            [13.32860020889135, -0.10741370378006701],
            [13.332870623869155, -0.10033454234440982],
            [13.333233386930374, -0.09462154795220387],
            [13.335479333049234, -0.09006850326298002],
            [13.345897364802154, -0.08497520224711884],
            [13.348135127024674, -0.07624436637805859],
            [13.352666050103986, -0.07422317552915333],
            [13.354771708994676, -0.07072309494420546],
            [13.353097884577029, -0.062290020210814714],
            [13.357312379014855, -0.058010960139997875],
            [13.357557723809515, -0.05469133683029128],
            [13.366752670871392, -0.0446217923267291],
            [13.369837984055602, -0.03983761611640657],
            [13.372707550318827, -0.038279699265962884],
            [13.376120775580901, -0.03942205120049502],
            [13.381135652372253, -0.03664509198838527],
            [13.384091797441782, -0.028784366537908997],
            [13.383761605575598, -0.025587109142150063],
            [13.390600713609805, -0.023227767200739595],
            [13.396498102283456, -0.01970363362419539],
            [13.396835401857238, -0.015312242874393079],
            [13.400271239205315, -0.01028302201740131],
            [13.39595398612847, -0.005039756273896387],
            [13.393636615576085, -0.007226606391067541],
            [13.388010453210116, -0.006021387112883784],
            [13.387664463031543, -0.001749268470895216],
            [13.384947715217198, 0.004386086994304522],
            [13.37754193581314, 0.01374785926938394],
            [13.378211404183556, 0.016695414396615996],
            [13.37604541164443, 0.020161490757271146],
            [13.380771420680421, 0.026696425656469902],
            [13.38367828488808, 0.03423129360885756],
            [13.390321937952693, 0.034179460660225765],
            [13.392969237659196, 0.02939477317759563],
            [13.392986819070945, 0.022825411235477634],
            [13.397478290978848, 0.019816376930903074],
            [13.404068333216237, 0.02078350466263477],
            [13.408087228206785, 0.026285430086146255],
            [13.41704226718534, 0.029103245263360823],
            [13.42065976783746, 0.02722512521009708],
            [13.424487345038328, 0.021508147264612646],
            [13.429502523508749, 0.019063880771259076],
            [13.43407970991849, 0.019273279109130213],
            [13.438705306813343, 0.015533280977268776],
            [13.440203283479146, 0.006508402350378752],
            [13.447328621471856, -0.0003530621863922844],
            [13.450382860285359, -0.004690283535923858],
            [13.451172675388015, -0.00922575225521451],
            [13.45498405689692, -0.016228558588167515],
            [13.4556783082978, -0.021873041367859294],
            [13.461138517159076, -0.029930605040238797],
            [13.469816533959445, -0.03845535341597978],
            [13.473618501474393, -0.044597920467963605],
            [13.483441139888717, -0.05238059915036487],
            [13.49350837926519, -0.05504051290539728],
            [13.50428552619563, -0.05523295025473992],
            [13.513834612130086, -0.05904374800667016],
            [13.5180697052566, -0.062323459714634356],
            [13.523686610976423, -0.06255355059756564],
            [13.528901260469787, -0.056267155337661],
            [13.53584947933125, -0.0540094007395942],
            [13.540476580501029, -0.04969410162227987],
            [13.544553756270364, -0.05122718381129172],
            [13.546381384771957, -0.06038112917480763],
            [13.550229808858623, -0.06353938409068655],
            [13.561746353646473, -0.04918015476435196],
            [13.571850896104504, -0.04673068679245755],
            [13.57817662330663, -0.04748253305424949],
            [13.57893319116597, -0.0501396276624665],
            [13.576024106082482, -0.0535563079843428],
            [13.575693054993117, -0.05871633211692488],
            [13.582370389716448, -0.06352161778749381],
            [13.584628897410187, -0.06742879398716063],
            [13.590783492475337, -0.0733854130752606],
            [13.60664282732309, -0.07285019198744597],
            [13.60866008925575, -0.07439861821074319],
            [13.611248055878976, -0.0817289888644579],
            [13.603836839719293, -0.07960283749009572],
            [13.593101549131886, -0.0829665834096341],
            [13.589057723128922, -0.08634510507240503],
            [13.587173570151222, -0.09093714437592085],
            [13.581911944609294, -0.09640539306310245],
            [13.57997070157, -0.09251842640962724],
            [13.576750761865235, -0.09422187328643097],
            [13.576844191721246, -0.0983470458422731],
            [13.569250059757655, -0.10466480994220667],
            [13.567485663001696, -0.1085495291546773],
            [13.55866953675274, -0.10989161703444748],
            [13.5552867603125, -0.10781362732596124],
            [13.551774393991057, -0.11025295471864774],
            [13.553509547724056, -0.11892890869798656],
            [13.550092226927935, -0.1225080479630685],
            [13.553384485906815, -0.12750602756388582],
            [13.563897234968161, -0.1253726484095688],
            [13.567227921245864, -0.12684325899455473],
            [13.568759003072948, -0.13214410948139305],
            [13.576382988820697, -0.13582830940394822],
            [13.569191147335655, -0.151194813917573],
            [13.571078188310024, -0.1532260549043111],
            [13.58754680860622, -0.1589917497231818],
            [13.578698672876701, -0.18881238992044272],
            [13.574804452697041, -0.20106375791532088],
            [13.564058624458376, -0.24000503640563878],
            [13.558891184859748, -0.25595314456634916],
            [13.552937396338184, -0.27821780057206896],
            [13.539280579806354, -0.32777106423195856],
            [13.535352903946361, -0.34104211866528894],
            [13.529656326576436, -0.3625358602000601],
            [13.50540634249244, -0.4487845192109196],
            [13.483973787696764, -0.5247126881285764],
            [13.47663329855283, -0.5262275952839978],
            [13.470576056347687, -0.5241280368394924],
            [13.455274887289448, -0.521170035775669],
            [13.448890730641955, -0.5224743223032817],
            [13.44555600586367, -0.5277001407213083],
            [13.447300489569942, -0.5313355338130172],
            [13.455176077958212, -0.5382381073305242],
            [13.457077841244114, -0.542112282538758],
            [13.45528294790168, -0.5478481369504288],
            [13.4561071526956, -0.550704943728894],
            [13.463821820323899, -0.5545250521753922],
            [13.477252560325693, -0.5623988312839256],
            [13.478219995925912, -0.5656270814950614],
            [13.475384916696344, -0.5683448533569241],
            [13.468792797038425, -0.5702863750826876],
            [13.464429643486447, -0.5788588179292687],
            [13.460093915172209, -0.5784770215203178],
            [13.455518819333543, -0.5721782220530347],
            [13.449160722057014, -0.5655831356908522],
            [13.44060289552793, -0.5615259600058293],
            [13.434420481916291, -0.5574320409906343],
            [13.429123785710415, -0.5560670143916652],
            [13.42168016490654, -0.5557868501511163],
            [13.414331439939923, -0.5520433173389944],
            [13.407568861609253, -0.546585394542337],
            [13.40733107969686, -0.5505434589486727],
            [13.40355269954527, -0.5530480716018507],
            [13.395265483649373, -0.552534662205223],
            [13.393586954257175, -0.5552047719525246],
            [13.395495710928758, -0.5604019543216905],
            [13.393100809244304, -0.5623402979800045],
            [13.387074637597687, -0.5617670638877311],
            [13.381088488770498, -0.5624931522573519],
            [13.368623060747893, -0.5589207634214362],
            [13.363462600206315, -0.5573369813440572],
            [13.368526610282688, -0.5502639077803559],
            [13.364951843459798, -0.5453332373323648],
            [13.35611441183042, -0.5374024023717426],
            [13.352306598519533, -0.5355517053078171],
            [13.340250094884631, -0.5265525876433895],
            [13.340167821722025, -0.5219099719357406],
            [13.34573878610706, -0.5225850691530685],
            [13.348088406483514, -0.5206222081762193],
            [13.347277016310237, -0.5172574173162535],
            [13.34336301388018, -0.5127131412149828],
            [13.340567111174023, -0.5117978684835972],
            [13.334792208977445, -0.5136135574713072],
            [13.327149845203552, -0.5094733275548908],
            [13.321486275313307, -0.5047056543464792],
            [13.319157461272246, -0.49863253331783114],
            [13.316322964381058, -0.4961378084097632],
            [13.311559451954084, -0.4893675091338028],
            [13.30952188047055, -0.4825621282561208],
            [13.298114560426418, -0.47337680114734815],
            [13.296038194346862, -0.4672594787745679],
            [13.290565445490106, -0.4624140502728907],
            [13.283742168601663, -0.45791632027248086],
            [13.281107383620334, -0.4577593961037643],
            [13.27867181053125, -0.46409763831109235],
            [13.276773163516767, -0.46468498421257676],
            [13.267668267019, -0.45351680132025085],
            [13.26371409527366, -0.4550634639559253],
            [13.268712096299442, -0.4599629921937261],
            [13.269936715028045, -0.4626898088254938],
            [13.265364038781152, -0.46696384697393606],
            [13.261211592479361, -0.46250179766012567],
            [13.260691493461232, -0.4597984427553225],
            [13.256371573820164, -0.45325941785494706],
            [13.257394832204296, -0.44923652788095236],
            [13.248350599159664, -0.4363838689423184],
            [13.246492602868903, -0.42895847313852625],
            [13.242872480694725, -0.4269337431461263],
            [13.23942351940969, -0.428471872166243],
            [13.235610694317014, -0.4335935385771098],
            [13.229911269907255, -0.43228518635983154],
            [13.21579746557043, -0.4340080175087699],
            [13.212064585469138, -0.4284930375093059],
            [13.20528200296061, -0.4275942347583202],
            [13.198929661313668, -0.4239464710091868],
            [13.194499196042464, -0.4136494143031632],
            [13.198461499342585, -0.4111324118387006],
            [13.196723161384021, -0.4061552945043384],
            [13.192229247140716, -0.4025721513090038],
            [13.191425554901198, -0.3956428812197162],
            [13.18825233270839, -0.3946681188350758],
            [13.183271004601982, -0.39554667733368265],
            [13.180112136644809, -0.39804144582920425],
            [13.179791263849937, -0.4091539649433292],
            [13.175725818500135, -0.4147275418536096],
            [13.1722154549013, -0.4142413735954218],
            [13.170192463730674, -0.41091531315699886],
            [13.16259243130242, -0.4060483195888738],
            [13.159613970025386, -0.4068932793509338],
            [13.154361315160216, -0.41417350592269025],
            [13.15278905531266, -0.41813386588763723],
            [13.145188305969716, -0.4189287419989395],
            [13.140418420310965, -0.41282082091261885],
            [13.140146389141165, -0.4107181332825834],
            [13.14298614921067, -0.40523328731921665],
            [13.141373627332763, -0.4004767277954119],
            [13.137676811842036, -0.3948546120006231],
            [13.13697140586277, -0.3887447024805216],
            [13.130215693872739, -0.37904115968011787],
            [13.13035695305426, -0.376582747239006],
            [13.124325674381014, -0.37066096896923156],
            [13.129081615212048, -0.3631645417069284],
            [13.130654042175216, -0.3579812519108432],
            [13.127669444756755, -0.35445375226645043],
            [13.12789208599797, -0.3490604951587034],
            [13.12578494042717, -0.34177412459213175],
            [13.132760228243898, -0.3374491809385689],
            [13.131886351252055, -0.33259646508542745],
            [13.12560858995307, -0.32721028762134174]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.5242068025283, "lat": 37.31511061264917 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51019"],
        "coty_name": ["Bedford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bedford County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01674818"
      },
      "bbox": [
        13.124325674381014, -0.5788588179292687, 13.611248055878976,
        0.03423129360885756
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.70176364958982, 0.6615761468736716],
            [14.711775490134936, 0.6766443972557916],
            [14.732415613930435, 0.7150939067786511],
            [14.744198513462894, 0.7365200708341055],
            [14.767045477110461, 0.7790791778453198],
            [14.79680382047322, 0.8350040967016884],
            [14.826740250124642, 0.8904326425479453],
            [14.831727622050636, 0.9016675129823098],
            [14.84156634197728, 0.9202604876395181],
            [14.854317053081175, 0.9465711100708635],
            [14.859880813973176, 0.9560782116430824],
            [14.864363014446061, 0.9529494649635064],
            [14.868247665747415, 0.9534646942483201],
            [14.87466127006693, 0.9626707168032005],
            [14.881326571827042, 0.9665570564457516],
            [14.888675858755173, 0.9610432638168008],
            [14.893426359850011, 0.9612637606705902],
            [14.899583172873934, 0.9602089770517416],
            [14.908653316942836, 0.9535897979506726],
            [14.915733978481903, 0.9623010695274653],
            [14.919296494297045, 0.9635260186259538],
            [14.922448306616372, 0.9604480775629471],
            [14.921354536312155, 0.9496266277413972],
            [14.924571440125176, 0.9454291098548411],
            [14.93282538053426, 0.9477961207319902],
            [14.934865888927071, 0.9510861139290574],
            [14.93486954966548, 0.9562337568123318],
            [14.931709369115183, 0.9661048795571104],
            [14.932735238190016, 0.972487110304565],
            [14.935280266259088, 0.9744365306464394],
            [14.94033987013254, 0.9745200835117486],
            [14.948674706571394, 0.9784501789243233],
            [14.950965394528325, 0.9784960849708818],
            [14.954868043465526, 0.9738715256151378],
            [14.964317059687982, 0.9761573729149453],
            [14.97180390942682, 0.9738897705429186],
            [14.972693230625119, 0.969649330635022],
            [14.970144345446679, 0.9662458558638969],
            [14.958222879614118, 0.9615325241729993],
            [14.953616007126058, 0.9573004147889493],
            [14.954958344081437, 0.9537600143779258],
            [14.963216396098607, 0.944599294850138],
            [14.964833688707898, 0.940083212230605],
            [14.963118819249605, 0.936754341168757],
            [14.958795637828047, 0.9238433395503677],
            [14.960180644912601, 0.9169135564472025],
            [14.972378767033288, 0.9158510183443073],
            [14.978680012569704, 0.9192737817472191],
            [14.978837792977341, 0.9212617862217234],
            [14.9749693669321, 0.9279006609402263],
            [14.978685022163072, 0.9319391141653752],
            [14.983973076060883, 0.9324826325715367],
            [14.9886855541218, 0.9307488382666729],
            [14.993690912281853, 0.9255738549294034],
            [15.006238408529153, 0.9188201927452493],
            [15.012897596615106, 0.9125709044377487],
            [15.026875653908832, 0.9065856419362136],
            [15.032972867245537, 0.9066768015805081],
            [15.039063971672546, 0.9123285124581594],
            [15.04279756123995, 0.9139025424862366],
            [15.051820319565769, 0.9112886248074085],
            [15.057310212429877, 0.9108477586219943],
            [15.06414725851738, 0.9068675860868775],
            [15.067251126862141, 0.9013125435754759],
            [15.073080081148444, 0.8991899650803703],
            [15.07768484719573, 0.8842298558383739],
            [15.08357686217391, 0.8828043749727049],
            [15.085775224293434, 0.8787595356521752],
            [15.0778984845856, 0.8701509845751454],
            [15.075132827152366, 0.8713359531235598],
            [15.066052874022985, 0.8705317263894388],
            [15.0629700721909, 0.8674800528899977],
            [15.060071779867716, 0.8690734971622811],
            [15.057177328116902, 0.866040421326959],
            [15.06011345418325, 0.860713809606955],
            [15.058849645259562, 0.853556258625214],
            [15.062741664541615, 0.8476987668980341],
            [15.061816929437153, 0.8395876658307585],
            [15.056662521392804, 0.8374168576932194],
            [15.056725592983312, 0.8319288368803864],
            [15.051540068810194, 0.8303413592846667],
            [15.04576414353471, 0.8212052645562039],
            [15.051948427494304, 0.8126012445422063],
            [15.05688199141369, 0.8076557357899936],
            [15.065677358349324, 0.8064535664844042],
            [15.068531880400382, 0.8002452342511376],
            [15.066916622519887, 0.795171652824729],
            [15.071175782914715, 0.7921304177819017],
            [15.078327010825209, 0.7949699566137582],
            [15.08372142835588, 0.793248376569527],
            [15.09182996724778, 0.7831753638773754],
            [15.088797900105634, 0.7764224281721891],
            [15.08755192340613, 0.7688569133876691],
            [15.089482628302957, 0.7646362053155185],
            [15.095183710040278, 0.765297223755973],
            [15.09722312506671, 0.7631481744530766],
            [15.101259271309921, 0.767157825039582],
            [15.1104200604291, 0.7639557908972414],
            [15.12091607275896, 0.7684505975113621],
            [15.125174912551813, 0.7642919335606836],
            [15.128131117235982, 0.7588272019076252],
            [15.13293241073745, 0.7576181565429572],
            [15.137168076811207, 0.7522551835557033],
            [15.1345344805279, 0.7477022962712147],
            [15.138490848099082, 0.7433779280482229],
            [15.138722299491713, 0.7409647560997533],
            [15.144815386961701, 0.7298888090972295],
            [15.145101232021474, 0.7229850067596736],
            [15.142724366518522, 0.7261508650777176],
            [15.1363455672205, 0.7252645763347075],
            [15.134068774920594, 0.721489516050051],
            [15.13021818731816, 0.7189691477339539],
            [15.122526163489848, 0.7181006342013309],
            [15.118389210814033, 0.7232052953183008],
            [15.115884318641477, 0.7241756991903181],
            [15.10419083618399, 0.7205749343310263],
            [15.083568345314307, 0.7180393142569446],
            [15.080432427675738, 0.7128856963231641],
            [15.071072030148423, 0.7074226501929859],
            [15.065546197576566, 0.6977396377103338],
            [15.062514379929144, 0.6907182775301989],
            [15.065519734895354, 0.6884025521421042],
            [15.062602382771097, 0.682347611915924],
            [15.069036812049227, 0.6707886528021263],
            [15.068246231111255, 0.6659183187534862],
            [15.069126427291204, 0.6607333346880209],
            [15.066717350392155, 0.6520883188598147],
            [15.076334583207828, 0.6480392534016914],
            [15.074324393175386, 0.6428623274464422],
            [15.071381718635303, 0.6461010761548455],
            [15.068325673863358, 0.6418969024170513],
            [15.068898828503297, 0.6393135813287616],
            [15.074593701289217, 0.6394548993455138],
            [15.074436789591894, 0.6334562433466435],
            [15.070974753863979, 0.631531085619651],
            [15.066236318436294, 0.6319320722091937],
            [15.0614662495777, 0.6276844368494924],
            [15.055973118253835, 0.6299945214273233],
            [15.057632770013223, 0.6251129792288541],
            [15.054614295327452, 0.6233661733407022],
            [15.04956976206499, 0.6255503424892384],
            [15.047862627849172, 0.6288849361999227],
            [15.050836204895159, 0.6351516586169461],
            [15.049398301010463, 0.6382878191628563],
            [15.043886492474405, 0.6398739556125441],
            [15.040390340949838, 0.6368899763660144],
            [15.036909660616464, 0.6363519647181844],
            [15.03514842365383, 0.6398488739653675],
            [15.03109034313043, 0.6428430326449901],
            [15.024716730682043, 0.6419276902302595],
            [15.022768778034532, 0.6361845480246459],
            [15.02542371531795, 0.6324830660532968],
            [15.025769801337622, 0.6283611646907057],
            [15.024135407199507, 0.6176494161931912],
            [15.026404628606537, 0.6120635458013404],
            [15.025481546212326, 0.6038573154466348],
            [15.018026460420087, 0.5936346465484423],
            [15.011929252396172, 0.5775894186072266],
            [15.008164953775873, 0.5707207811422577],
            [15.002522321796116, 0.5698741378892594],
            [15.00160580275316, 0.5618473552374411],
            [14.992352882203036, 0.5457278768227989],
            [14.9774100773263, 0.5255991753798893],
            [14.97599923716771, 0.5209386175009254],
            [14.968218670051051, 0.5098367632801805],
            [14.969063689866621, 0.5069995127378157],
            [14.964262192311644, 0.5072794218030224],
            [14.96190845541731, 0.5115145379120999],
            [14.958142279540715, 0.5127695967460901],
            [14.952340925718492, 0.5083144773989996],
            [14.952503055372027, 0.5054856739619831],
            [14.949422847178328, 0.5009639871408923],
            [14.950592641843945, 0.4974756389778221],
            [14.9489797184179, 0.4897080608019368],
            [14.938669521979305, 0.4901164183976893],
            [14.932203583665942, 0.4872487463587105],
            [14.924174200108297, 0.4899252122446261],
            [14.924845474886753, 0.4947627246417854],
            [14.933276144110032, 0.49502169051675543],
            [14.93453938276667, 0.4975308341631717],
            [14.927984656055287, 0.5004024296654256],
            [14.928084357569748, 0.5124079918945968],
            [14.922218205104038, 0.5146339713502724],
            [14.920306537320565, 0.5115137358559012],
            [14.913894309107281, 0.5124760867586622],
            [14.909312182204665, 0.5155523361596057],
            [14.906033793848671, 0.5145676064598451],
            [14.905497600323317, 0.5204092441715719],
            [14.907581311505481, 0.5225604807416173],
            [14.9123510156238, 0.5238170842633482],
            [14.913639807640443, 0.5273387230734597],
            [14.911783591865108, 0.5303320043371519],
            [14.905140795936415, 0.531054535926606],
            [14.900926518665496, 0.5301367861224935],
            [14.897419245820767, 0.53425592288767],
            [14.897973063834682, 0.5378705532611937],
            [14.895752747803815, 0.5410359563382148],
            [14.896670107447168, 0.5449963487365755],
            [14.89427962967469, 0.5463760847315287],
            [14.895041041501582, 0.5527627082367021],
            [14.89222286235526, 0.5609113231649961],
            [14.89530041652514, 0.5702372703067405],
            [14.889574767126518, 0.5733315015406051],
            [14.888316172142018, 0.5769847295859856],
            [14.88478759788876, 0.5785839998736058],
            [14.880259111020509, 0.5882666841562324],
            [14.875539886805612, 0.5903872770122088],
            [14.871709193570977, 0.5962102583172997],
            [14.866522249733777, 0.5935204262715781],
            [14.864538148943462, 0.5900691948068059],
            [14.859934766936728, 0.5871607524802244],
            [14.853148909375333, 0.5866738229486658],
            [14.84881899625472, 0.580275413339831],
            [14.844006573027967, 0.5790797326426655],
            [14.840574559582787, 0.5829282106442967],
            [14.836564093100717, 0.5835523678166088],
            [14.8339739287761, 0.5917014603017151],
            [14.825866218757854, 0.594451442009705],
            [14.816441162012309, 0.5952177792200137],
            [14.812808297547987, 0.5970608132252295],
            [14.808987037859143, 0.6021344763785605],
            [14.805224306034075, 0.6043731304978427],
            [14.802221545347042, 0.6093940421395337],
            [14.796407518134357, 0.6086235740093345],
            [14.790223629193903, 0.6019571084673506],
            [14.780202817067211, 0.6071796971517126],
            [14.781601713436633, 0.6108485370734961],
            [14.786761232421616, 0.6118884800080123],
            [14.778500544437843, 0.6201831411151661],
            [14.77391217358048, 0.6198331797372806],
            [14.769297521325777, 0.6265665117857083],
            [14.770363895318896, 0.6295688463561303],
            [14.766913597908983, 0.6322489990534911],
            [14.763900108373514, 0.6369527333952947],
            [14.758495217048587, 0.6391310359158259],
            [14.756732072059206, 0.6363132314935933],
            [14.756491196092083, 0.6310456899422403],
            [14.75012159313726, 0.6284315144592652],
            [14.741521131365692, 0.6321493118206373],
            [14.735016848402372, 0.6308035061904236],
            [14.733472679262887, 0.6257059621599788],
            [14.730023950590256, 0.624231923788697],
            [14.727835841408293, 0.6275220170164989],
            [14.729638278502163, 0.6347464077488271],
            [14.725642372240143, 0.636494994914885],
            [14.72293943062162, 0.6409087523961384],
            [14.718597862976727, 0.6380461795490618],
            [14.71427450848567, 0.637853412994206],
            [14.714534151818325, 0.6439038533422219],
            [14.708704286724295, 0.6497093247026924],
            [14.703172650042264, 0.6505544641551507],
            [14.70176364958982, 0.6615761468736716]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.34715283937842,
          "lat": 38.026727453238905
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51033"],
        "coty_name": ["Caroline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caroline County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01480107"
      },
      "bbox": [
        14.70176364958982, 0.4872487463587105, 15.145101232021474,
        0.9784960849708818
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.501255670291384, -0.8718324535487912],
            [12.51168586921581, -0.8665877848432658],
            [12.535927121976355, -0.8518786704074619],
            [12.539559143134372, -0.8485157956495732],
            [12.543913999645302, -0.8484012495959228],
            [12.54552413514664, -0.8439868764622186],
            [12.544071407728955, -0.8357295936388585],
            [12.550749802693081, -0.8314317762001299],
            [12.559326392140944, -0.827166875878236],
            [12.559086661458263, -0.8233200561750946],
            [12.561416508963294, -0.8188972806101387],
            [12.567963955221208, -0.8120278439217258],
            [12.57520522383528, -0.8100148033881055],
            [12.57595672975707, -0.8057105891880569],
            [12.642729687171288, -0.8853026292595066],
            [12.709798648061483, -0.9647383651365938],
            [12.712387819897296, -0.9675155196927362],
            [12.74526843750658, -1.006137056681714],
            [12.75282220431606, -1.0083306570312387],
            [12.754784141071019, -1.0130292960597502],
            [12.75242890782044, -1.015423169309545],
            [12.750981061464794, -1.022044004954099],
            [12.75184903610779, -1.0261384191038236],
            [12.75009539826052, -1.0326121075179737],
            [12.74968964076292, -1.0418763236672002],
            [12.744229754779777, -1.0477268551749492],
            [12.736097223207024, -1.0516661082408234],
            [12.733272082114775, -1.0560442963098162],
            [12.733684351104424, -1.0602004014089896],
            [12.73613712618219, -1.0638026482338172],
            [12.731094624082338, -1.0660168409116557],
            [12.72481074069511, -1.062812580221527],
            [12.721255782061178, -1.0679208608920752],
            [12.70777834626266, -1.0783970768487214],
            [12.703018919740822, -1.0780319187055194],
            [12.69929820550081, -1.082511305218115],
            [12.68894892520531, -1.0831595802184704],
            [12.688385012814775, -1.078735000993091],
            [12.685393313814368, -1.073889148936934],
            [12.681014755879978, -1.0753361870142002],
            [12.671033562684343, -1.0717527026720997],
            [12.663568817265467, -1.0672294622283778],
            [12.654477951137874, -1.0681675539059647],
            [12.650517745834993, -1.0701273975647965],
            [12.65359053148967, -1.0736886171765725],
            [12.649206328070317, -1.0806260862878414],
            [12.645088881459117, -1.0821212837230967],
            [12.647226019214598, -1.0892251302920688],
            [12.64694601354717, -1.0956908808953185],
            [12.642720356996628, -1.102405249780512],
            [12.640459473017998, -1.1080262849692908],
            [12.636254792904813, -1.1149421555329981],
            [12.639256870362665, -1.1214088183154503],
            [12.63737146873892, -1.1274274378087945],
            [12.635451522381503, -1.1290262751121374],
            [12.6379186978873, -1.1377933848298716],
            [12.640579701478158, -1.1432888457207149],
            [12.646682942158693, -1.1453597365703205],
            [12.64866980744244, -1.1553627557189248],
            [12.650933877803146, -1.1598479002147544],
            [12.650473493071232, -1.1672886360759935],
            [12.654117083246923, -1.170559504051927],
            [12.653943404436935, -1.1754233394609792],
            [12.621299284313114, -1.1793671300633068],
            [12.580367575411735, -1.1828536392124342],
            [12.560320516632668, -1.1860737807327257],
            [12.526632163880379, -1.1936119878745903],
            [12.502784886360613, -1.196943373013825],
            [12.476320305714355, -1.2029249889942657],
            [12.439468798565775, -1.1619940093187588],
            [12.422497681519918, -1.1440883346444393],
            [12.401903885502938, -1.1217210332304404],
            [12.413599970887557, -1.0982527179277966],
            [12.417819868501715, -1.093419701285823],
            [12.424143917125447, -1.0752530592033458],
            [12.418017975935584, -1.0733343184627822],
            [12.414573462666937, -1.0763820734305252],
            [12.412669454402614, -1.0732615307462112],
            [12.40372136502338, -1.0777846414846488],
            [12.405117494975597, -1.0804939624547383],
            [12.40287243237036, -1.084144246436446],
            [12.397765805569492, -1.0769145184707885],
            [12.393333463061515, -1.0790816794721139],
            [12.393279587036039, -1.0893435389498185],
            [12.394644282349104, -1.09269795290371],
            [12.39249229808405, -1.0947136262132593],
            [12.38814719637034, -1.091142807295954],
            [12.383880647240987, -1.098131119181411],
            [12.384299917094802, -1.102715204135842],
            [12.32837902547627, -1.040988953471593],
            [12.276535981232863, -0.9820326452924565],
            [12.284751475833117, -0.9724759061481897],
            [12.291553849927984, -0.9746755027252695],
            [12.335949321647671, -0.9539222003323674],
            [12.418414783523982, -0.9158045908109245],
            [12.420656039223887, -0.9169228591974954],
            [12.42574027438963, -0.9155921271137115],
            [12.439985842463326, -0.9085194966503342],
            [12.442752822463468, -0.9088428447020002],
            [12.448886352732867, -0.9066440233539927],
            [12.45471316593788, -0.9002003392765966],
            [12.461304483012604, -0.8942574759001594],
            [12.501255670291384, -0.8718324535487912]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.73388452305895, "lat": 36.73157960040789 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51035"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01480108"
      },
      "bbox": [
        12.276535981232863, -1.2029249889942657, 12.754784141071019,
        -0.8057105891880569
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.64853521170882, 0.062477536054191575],
            [14.65403014290116, 0.05991122699239698],
            [14.657811540060576, 0.06487362819708282],
            [14.659997265989857, 0.06452396931858517],
            [14.664662714054614, 0.07015977744132718],
            [14.66972276872701, 0.0707739724892225],
            [14.682536847733113, 0.07702326260802345],
            [14.684184396900013, 0.08625410687933815],
            [14.683565222627154, 0.0890768686521969],
            [14.686950332552135, 0.09719339406505231],
            [14.686762200006713, 0.10348791977505717],
            [14.685032228256189, 0.11122080597865759],
            [14.715409046354479, 0.15301839705691278],
            [14.768725352409877, 0.22592091056394917],
            [14.77450631192622, 0.2335345040627309],
            [14.774549891887595, 0.2367696611356251],
            [14.779636404591868, 0.23349499742410826],
            [14.791298796373182, 0.2347552987278697],
            [14.798228039026169, 0.23415746066213644],
            [14.805125764978103, 0.23552765013099486],
            [14.814296168154488, 0.23577980389001696],
            [14.822322866154275, 0.23764766873441395],
            [14.82394942550572, 0.2277864443588539],
            [14.819980192462632, 0.2262920142913956],
            [14.825483853425174, 0.21788452162520752],
            [14.82869148902111, 0.2161612028880002],
            [14.83990044691503, 0.2168899553237579],
            [14.848707101368708, 0.22179590493841267],
            [14.85469474741085, 0.22816202681833064],
            [14.858164857938185, 0.23030230557351788],
            [14.866555842269731, 0.21788078764421537],
            [14.87844975888173, 0.22408834693851082],
            [14.883726094862855, 0.20200042127275752],
            [14.900601486097838, 0.1708992933412679],
            [14.907335600398438, 0.1636888390221755],
            [14.91320615063916, 0.16110882558049175],
            [14.917381915392843, 0.16101920572766476],
            [14.921977174240336, 0.15503367123861697],
            [14.929097790384347, 0.16170626615894815],
            [14.934889753138158, 0.16143121548905484],
            [14.938991129584686, 0.16612254436690657],
            [14.940981086685364, 0.16499634148539252],
            [14.945037044779776, 0.16771315721464464],
            [14.954011928767226, 0.1648148915185785],
            [14.958722839116266, 0.16633416022457417],
            [14.96480513864549, 0.1645706916617735],
            [14.97813251109038, 0.15696316241051267],
            [14.974924150016305, 0.14505108235416778],
            [14.974781531019328, 0.14048639576191962],
            [14.977591494835586, 0.134851907724696],
            [14.984858321301168, 0.13128474136954144],
            [14.99360433383626, 0.13484861157878497],
            [14.994287492505773, 0.13189881517207153],
            [14.997603390136781, 0.1304281499615424],
            [15.000825620006395, 0.13316796297614208],
            [15.007130441845886, 0.11753933957482819],
            [15.015831576441585, 0.11296702133292921],
            [15.016863050883597, 0.11054962657554543],
            [15.016284034186171, 0.10235758842122938],
            [15.019027797562897, 0.10007195535722418],
            [15.02577646076506, 0.09864405664220664],
            [15.026465535300627, 0.10753044825597513],
            [15.02880992606232, 0.10991182461634123],
            [15.032091779436715, 0.10938995398482741],
            [15.037336844792936, 0.10615014002853676],
            [15.039333491154188, 0.10322768353058233],
            [15.040580195208868, 0.0961215405221507],
            [15.046869962113561, 0.09950786810567461],
            [15.060085301337468, 0.10109942492275523],
            [15.06562985877217, 0.10267957810064846],
            [15.070096570812538, 0.10588442345323916],
            [15.071973831120598, 0.10900834787254685],
            [15.07468795574678, 0.11944875926309309],
            [15.07455104787279, 0.12558791921667356],
            [15.073154991113011, 0.13104480472755717],
            [15.076195769674182, 0.1336296654647365],
            [15.081466451949707, 0.13185588877362628],
            [15.08333835533193, 0.12554044438618686],
            [15.083565999146769, 0.12083707590444062],
            [15.080110133347109, 0.10961505190916894],
            [15.080111304151187, 0.1064965297515394],
            [15.076997707542215, 0.10016177791709331],
            [15.079077812550478, 0.09285813025093805],
            [15.084946763457909, 0.08658020968637041],
            [15.095342964803528, 0.08339525502120956],
            [15.100556632003116, 0.08292045465119699],
            [15.110978487471076, 0.08632435441581197],
            [15.113828002634715, 0.09456665913481452],
            [15.111043143469402, 0.10500788964199115],
            [15.111671991495932, 0.10992060975035405],
            [15.116611188006141, 0.11461007454536008],
            [15.122069159974659, 0.11540413092243183],
            [15.123014885348327, 0.1183250825516254],
            [15.126532322271931, 0.11483607960049858],
            [15.129776838527539, 0.10657216934904185],
            [15.1286403808768, 0.09772279755820126],
            [15.118998841370866, 0.07844632362240106],
            [15.117850363660168, 0.07409811889479914],
            [15.117068603167553, 0.06004515223795836],
            [15.118910297696509, 0.05444059261521858],
            [15.116425343433095, 0.05420811280250117],
            [15.11019271657814, 0.050476559751119664],
            [15.110134268866211, 0.044715220015317955],
            [15.106787634908404, 0.046864776826500865],
            [15.10312525177264, 0.04304746309140526],
            [15.095054612382555, 0.04053252462215342],
            [15.084252659449453, 0.034736911776859385],
            [15.080412289656936, 0.03415453531642184],
            [15.070233645820851, 0.03679390043877106],
            [15.067589450492369, 0.03824979640619268],
            [15.060902956898545, 0.03517402767250388],
            [15.057780939762052, 0.03135880756504551],
            [15.058274550473104, 0.024802106798577757],
            [15.06003569217664, 0.01923858773061673],
            [15.059962833655618, 0.003954391259367662],
            [15.05810923398218, -0.0023767729923466112],
            [15.05256973674216, -0.008336226901773333],
            [15.049886533354826, -0.014699907283442958],
            [15.04931065865037, -0.026558308227033797],
            [15.051873429426063, -0.03705656300487964],
            [15.04757343473488, -0.044027904458805056],
            [15.038845834898911, -0.04660109881496596],
            [15.033711349364697, -0.04662564775110261],
            [15.032555372464671, -0.048611951768839486],
            [15.03442110615379, -0.045352615715529905],
            [15.038526364567927, -0.045338561718129056],
            [15.045703307108392, -0.0420806537621275],
            [15.04902532761645, -0.03691253868478411],
            [15.045543198243555, -0.01491244527616152],
            [15.04704350188502, -0.007424916634858505],
            [15.052868143062062, -0.0022936282333849345],
            [15.055716122713884, 0.0021192449395231647],
            [15.05264888602849, 0.006827307890336484],
            [15.05252988262181, 0.0099096416947266],
            [15.04885169859288, 0.013598718651078106],
            [15.044707966309124, 0.01515609226105198],
            [15.042910898448978, 0.001989711786499399],
            [15.033781862082291, 0.003121577878516744],
            [15.03174425001286, -0.0020683746392753657],
            [15.026258717354109, -0.0026001224100470482],
            [15.024669139823954, -0.006175346092683085],
            [15.028877496073598, -0.01377201059132686],
            [15.023405027786609, -0.012581697883416313],
            [15.020578844782758, -0.006792414152224669],
            [15.01690272565931, -0.004686831516994611],
            [15.014705412058461, -0.0059178007027324035],
            [15.007284890913667, -0.005954317971367589],
            [15.006609388221344, -0.011444812220243076],
            [15.010244842229946, -0.014831231169080476],
            [15.003585337758418, -0.016061900377075878],
            [15.008453359759681, -0.02065897091556677],
            [15.013142983738701, -0.026584029543920248],
            [15.015454228141097, -0.022605945181318678],
            [15.019621909186228, -0.026877963933903643],
            [15.019778291442234, -0.0410523254179403],
            [15.022620788627723, -0.04646483915166674],
            [15.02344428369965, -0.05467667760575076],
            [15.01459369486591, -0.06114959318420868],
            [15.012007880930675, -0.06535867871501264],
            [15.001524390806901, -0.06945383378184555],
            [14.99682082257303, -0.07075008485000772],
            [14.986329861076353, -0.07018384274883273],
            [14.976336008972456, -0.07291865064862273],
            [14.971143260913328, -0.07310040778961666],
            [14.96082204710951, -0.0762547091527482],
            [14.95918519176698, -0.07876851614736906],
            [14.954125620769284, -0.0808864268137082],
            [14.950244952532318, -0.0847013889278528],
            [14.944537094613583, -0.08679493907149384],
            [14.94060231004293, -0.08179205913131485],
            [14.932255279373551, -0.07975156166939523],
            [14.923545647808009, -0.08084924223099968],
            [14.913596012413889, -0.08411387450979295],
            [14.910804649709439, -0.07942440605440103],
            [14.906955421787607, -0.07888803489025235],
            [14.905857356085669, -0.07303954590876645],
            [14.899841412353469, -0.07573148098705097],
            [14.896887618730187, -0.07477291993653416],
            [14.894726892470418, -0.07003956729325911],
            [14.891376738026956, -0.06744430284486315],
            [14.886851547222216, -0.06792874956944733],
            [14.884962335726966, -0.06530494164245086],
            [14.87710129108322, -0.062380646445733975],
            [14.872983033129257, -0.05272223148102085],
            [14.86384555958005, -0.04734710119863716],
            [14.86093596423509, -0.04885956024462018],
            [14.859264163025976, -0.05246106914734042],
            [14.855833097467224, -0.05303411078237984],
            [14.84918291959192, -0.05147128324909261],
            [14.8427381711507, -0.058580422851950815],
            [14.836144145657475, -0.05869999753621096],
            [14.832891221294576, -0.05710322289902676],
            [14.829706791922002, -0.052515425032526736],
            [14.824284288573011, -0.047024233964157364],
            [14.820807437923575, -0.03837898239437041],
            [14.817811339156846, -0.03413685645199519],
            [14.811306086771978, -0.03511596510619669],
            [14.806390342197592, -0.03710324355362644],
            [14.806347837350547, -0.04302719874981611],
            [14.804623553596677, -0.04703543997325668],
            [14.800533633656903, -0.04884456559410118],
            [14.795040598674273, -0.043482773187130695],
            [14.790796957798706, -0.03564062055506901],
            [14.784379541979993, -0.032825706216924225],
            [14.779265282521894, -0.0371181927642986],
            [14.779337098264254, -0.043165543134232556],
            [14.780634322242834, -0.04922007790823824],
            [14.778015958628867, -0.051381113663685744],
            [14.772415042161626, -0.04986271920179336],
            [14.766782195461458, -0.05259664338502489],
            [14.767511126455021, -0.06668784679246859],
            [14.763171317837783, -0.07115293854125139],
            [14.751893976968548, -0.07141234470211075],
            [14.747693450693605, -0.07014752781279933],
            [14.743418960356644, -0.06650428156039852],
            [14.740396721248764, -0.05691500621724529],
            [14.726247777973969, -0.04782220913439409],
            [14.72254938455239, -0.04666563027088135],
            [14.716196828476122, -0.04680529906815165],
            [14.707777498142239, -0.043140246751563104],
            [14.703946526794843, -0.03274030811984065],
            [14.709327067699762, -0.028347484547685556],
            [14.712157644334752, -0.02229582270235182],
            [14.709570502787143, -0.019014347302582606],
            [14.710284354654574, -0.013681618628241276],
            [14.708344990656013, -0.012383122291495161],
            [14.693018138382302, -0.011469307298596968],
            [14.677622575917479, -0.014159341483135569],
            [14.666133304878324, -0.009464668542777133],
            [14.66422964159137, -0.00722857495855681],
            [14.662140519099076, 0.0016382119485391887],
            [14.65481517861819, 0.0059326269306804146],
            [14.644854980612319, 0.004195148971911552],
            [14.641204378108934, 0.007463223277132763],
            [14.641345493351116, 0.010814310026360624],
            [14.639499430233775, 0.019290037137813375],
            [14.637377792389561, 0.024481290604082565],
            [14.639553374177707, 0.02810684080754523],
            [14.639800099375327, 0.033727528577364496],
            [14.643782329372538, 0.03631888888424047],
            [14.639291754838547, 0.04122435405716169],
            [14.637600294003343, 0.04727920239816042],
            [14.633278626000697, 0.05711587136244522],
            [14.635041963441346, 0.060002696874229045],
            [14.646492959480451, 0.05815516223874943],
            [14.64853521170882, 0.062477536054191575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.58687229649954, "lat": 37.37854134636625 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51041"],
        "coty_name": ["Chesterfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chesterfield County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01480111"
      },
      "bbox": [
        14.633278626000697, -0.08679493907149384, 15.129776838527539,
        0.23764766873441395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.213362111185964, -0.6377204602682236],
            [11.223992364644017, -0.6320475201327238],
            [11.228379187168251, -0.6364751206828055],
            [11.232836509169507, -0.6376762612337975],
            [11.23573985886688, -0.6421834055977592],
            [11.243617091982129, -0.6455947246646961],
            [11.244951361826862, -0.650075775550857],
            [11.249950692976912, -0.6553040496070004],
            [11.256958485083782, -0.6556338088572873],
            [11.262421673385703, -0.6632661815804217],
            [11.281460337056181, -0.7193583593211543],
            [11.309958552347645, -0.7608340072871023],
            [11.313390402063453, -0.7647231371152411],
            [11.31708057283623, -0.7714294074533969],
            [11.319733102194597, -0.7675528603873477],
            [11.321782187742325, -0.771505131080238],
            [11.325193361521524, -0.7743897490164332],
            [11.327631767992129, -0.7806287956526144],
            [11.33190454295277, -0.7817156953288468],
            [11.337261174967074, -0.7878752791610336],
            [11.337740291139742, -0.7909775568502642],
            [11.343546455494781, -0.7947628192425568],
            [11.342696300313563, -0.8028332841752146],
            [11.345389684995146, -0.8044927864818898],
            [11.34725887910965, -0.809322990332623],
            [11.352944853599421, -0.8096743084857735],
            [11.35721181617746, -0.8114517262623848],
            [11.357021114535796, -0.8162522154183723],
            [11.35465345506624, -0.8193065515054885],
            [11.35685905741897, -0.821520935712844],
            [11.361660556294975, -0.8310454303519449],
            [11.360972772977798, -0.8336177601728492],
            [11.365487047463901, -0.8361617007156702],
            [11.366728202287355, -0.8395531085460716],
            [11.372621522105183, -0.8446158219887885],
            [11.374743971405358, -0.8557360798737349],
            [11.379915683311868, -0.8560389265021997],
            [11.38177462942096, -0.8608843747673476],
            [11.379586736671197, -0.8625761590260471],
            [11.382661922774313, -0.8696042398032212],
            [11.374284643733963, -0.8796240454229369],
            [11.369205957812564, -0.8818109923190437],
            [11.366215205505567, -0.885389337058361],
            [11.363918404919781, -0.882416993377524],
            [11.359153994885595, -0.8823510762284988],
            [11.351076316044397, -0.8897636139329411],
            [11.349363046440729, -0.898423101158998],
            [11.340391426091397, -0.8986022307958704],
            [11.339038644796535, -0.8956146313640659],
            [11.315542075248837, -0.9248720328625049],
            [11.311435756971413, -0.9288091469036924],
            [11.308644965343946, -0.9294037381075071],
            [11.307212117840503, -0.9340607958024811],
            [11.30331011168113, -0.9387479990264868],
            [11.296801283126902, -0.9443888400970089],
            [11.293836420126585, -0.944631670747402],
            [11.28776524090784, -0.9402661729053093],
            [11.282298646271975, -0.9340127691031632],
            [11.278687021626112, -0.937323924724791],
            [11.274733485432458, -0.9382075788518194],
            [11.268703456777745, -0.9458552131438429],
            [11.244915395542735, -0.9705741853573536],
            [11.230524860457642, -0.9857339219926384],
            [11.223221529211358, -0.9872201253560942],
            [11.220057780115251, -0.9897407310212242],
            [11.216818281695375, -0.9830481585866995],
            [11.215765797988205, -0.9770525324089507],
            [11.209226020486401, -0.9707414477570957],
            [11.204486929189352, -0.9725739093625786],
            [11.202576211997675, -0.969808959043678],
            [11.203565974167777, -0.9665306792956019],
            [11.196435757556074, -0.9684485359211344],
            [11.191137195532939, -0.9669428609545607],
            [11.185367746145022, -0.9636758658326491],
            [11.182651409390468, -0.9639283747565537],
            [11.128558573064353, -0.9353345526424723],
            [11.121233776742747, -0.9353642295325472],
            [11.119102856315738, -0.9316134003116319],
            [11.119104623169155, -0.9238651455754346],
            [11.112699965575699, -0.9189444910795678],
            [11.106262775414221, -0.9166807101432148],
            [11.10299993502417, -0.91092123656281],
            [11.103838026712912, -0.9052553289026841],
            [11.099501116225891, -0.8972976054989438],
            [11.057291103150455, -0.845327116673655],
            [11.051974981412062, -0.8410815397627096],
            [11.034869927545124, -0.7642760016571866],
            [11.03736379701558, -0.7622494220518236],
            [11.041128717868421, -0.7631285763153818],
            [11.04415132581986, -0.7591690614521587],
            [11.051370592386041, -0.755454267467199],
            [11.05078742169968, -0.7525451189211089],
            [11.056097165743179, -0.7488705908160609],
            [11.059783901036237, -0.7504361176194927],
            [11.06726767605086, -0.7432293603417434],
            [11.067923547690254, -0.7392568665792483],
            [11.074361259257776, -0.7339335078310465],
            [11.08039595842894, -0.7350673419997681],
            [11.083338700359276, -0.7318790764631479],
            [11.083460352277715, -0.7283886937397428],
            [11.100682513258477, -0.7186917594266473],
            [11.105410261443769, -0.7180177816758299],
            [11.110731927361286, -0.7115216347773075],
            [11.124477707223615, -0.7066248341863566],
            [11.13391720423382, -0.7006179422706381],
            [11.159797563896737, -0.6878892285216139],
            [11.165053228750388, -0.6873900468059263],
            [11.173809592184544, -0.6815197641122166],
            [11.180863564246451, -0.6796792442681123],
            [11.184023475203666, -0.677327927845774],
            [11.189933108839229, -0.6692991056972346],
            [11.189123905292636, -0.6625022291795669],
            [11.193116880483675, -0.6630965997286221],
            [11.19694827965275, -0.6600178826201838],
            [11.202228578713338, -0.6582644792242146],
            [11.206014653496755, -0.6532839056799826],
            [11.207232983938058, -0.6456033375570169],
            [11.213362111185964, -0.6377204602682236]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.35036105349437,
          "lat": 37.125773162158026
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51051"],
        "coty_name": ["Dickenson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickenson County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01497376"
      },
      "bbox": [
        11.034869927545124, -0.9897407310212242, 11.382661922774313,
        -0.6320475201327238
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.049067835103138, -0.11378926004348741],
            [15.05920779105169, -0.10735595659392348],
            [15.06457843540339, -0.10072816780892456],
            [15.065333464954508, -0.10528180448914262],
            [15.069072572036037, -0.10407731068340832],
            [15.074313429705656, -0.10454062287152784],
            [15.075061301406315, -0.10768224301407216],
            [15.085958057596242, -0.10481400110918256],
            [15.089853022606661, -0.1023090926083778],
            [15.087859803741026, -0.09376929932102078],
            [15.091324424627423, -0.0916524166928654],
            [15.090347789488721, -0.08557688933866725],
            [15.097562272654327, -0.07672692616271541],
            [15.0876357031166, -0.06583058326601571],
            [15.081613693878312, -0.06600270845886222],
            [15.08000531104982, -0.05879057465826432],
            [15.07572386254914, -0.05876349589180994],
            [15.075322140454578, -0.053607293892320884],
            [15.064632807605216, -0.04285237111764395],
            [15.065057192345929, -0.04079248345666427],
            [15.057563051257285, -0.037314721994703856],
            [15.051873429426063, -0.03705656300487964],
            [15.04931065865037, -0.026558308227033797],
            [15.049886533354826, -0.014699907283442958],
            [15.05256973674216, -0.008336226901773333],
            [15.05810923398218, -0.0023767729923466112],
            [15.059962833655618, 0.003954391259367662],
            [15.06003569217664, 0.01923858773061673],
            [15.058274550473104, 0.024802106798577757],
            [15.057780939762052, 0.03135880756504551],
            [15.060902956898545, 0.03517402767250388],
            [15.067589450492369, 0.03824979640619268],
            [15.070233645820851, 0.03679390043877106],
            [15.06977612702198, 0.03111240738716625],
            [15.071293080427417, 0.026627777592600297],
            [15.074663554944383, 0.02301330813785399],
            [15.077825389006437, 0.02314106916108661],
            [15.078111219831278, 0.018334281493034357],
            [15.08014795122142, 0.017295129734967964],
            [15.080047297676419, 0.009989887486883816],
            [15.083288383357532, 0.0021214330985634177],
            [15.084009330775947, -0.0027727460609499096],
            [15.087868802884646, -0.0062566651738060015],
            [15.084221506984804, -0.012928324920325963],
            [15.08849771324912, -0.013219038796334768],
            [15.089897248147311, -0.00834442212061276],
            [15.093168110772346, -0.008704216036405338],
            [15.098770242969431, -0.005714570767965543],
            [15.100322892677987, -0.010164074597937112],
            [15.10377933239165, -0.009037802918938844],
            [15.10729419124764, 0.0004268722762101281],
            [15.110472601787698, 0.0032835380167184148],
            [15.117599067246914, 0.006481060266514729],
            [15.12292826788791, 0.014067462047511055],
            [15.12711960057106, 0.017012971703120976],
            [15.134227414359238, 0.01840983243349105],
            [15.133129485867993, 0.023459552813875063],
            [15.138378246368687, 0.030300480015623917],
            [15.136863544506458, 0.03324863843485712],
            [15.129572419338228, 0.03815765298548377],
            [15.126693237239005, 0.03872144462502209],
            [15.117691783928779, 0.04977891107432549],
            [15.114570959107455, 0.046977186689224515],
            [15.112607414130428, 0.04204551096045269],
            [15.110134268866211, 0.044715220015317955],
            [15.11019271657814, 0.050476559751119664],
            [15.116425343433095, 0.05420811280250117],
            [15.118910297696509, 0.05444059261521858],
            [15.12640210127298, 0.04900674494218727],
            [15.136071257909524, 0.045622166415858464],
            [15.141065917810428, 0.04704895851996408],
            [15.146628182336864, 0.05046896937542518],
            [15.153230310636676, 0.05945970279947823],
            [15.157959007611456, 0.06072237824184355],
            [15.184950182089647, 0.05808267719329093],
            [15.226405810461186, 0.05840930173934008],
            [15.234868420460112, 0.05931669733741697],
            [15.254994693643237, 0.07291038862238489],
            [15.261310742952183, 0.07509946116543444],
            [15.263350259457562, 0.07327750258008235],
            [15.275767607642846, 0.03805059256729485],
            [15.28070932848953, 0.03545364407864076],
            [15.284493104391675, 0.03514187240403347],
            [15.307882918353952, 0.0653367612847205],
            [15.323211990348945, 0.07955119062291979],
            [15.329909346314325, 0.07917481624769236],
            [15.33494916259248, 0.07752757241212313],
            [15.340635247958156, 0.07240453558728949],
            [15.340523782077033, 0.06300414231723127],
            [15.343140346530527, 0.05551777488915262],
            [15.35850680410838, 0.03483572122070365],
            [15.363679698092056, 0.02928495135030728],
            [15.349822780213538, 0.014130603803428421],
            [15.34301733583587, 0.014990335303333989],
            [15.342912156867998, 0.008762706247639949],
            [15.336011402721214, 0.0075855814541776045],
            [15.335626566947571, 0.0021153810586602177],
            [15.333642627825773, -0.006585790213957839],
            [15.34051668430107, -0.01259432559105653],
            [15.336895730410651, -0.01894422685534887],
            [15.332029670327556, -0.02029785689954893],
            [15.333296298216096, -0.025781892439326482],
            [15.326205548414391, -0.028111591734714787],
            [15.323084361399438, -0.027020312558473304],
            [15.317251114226055, -0.028496291908845867],
            [15.316514729289556, -0.031199933482347664],
            [15.32010258502454, -0.03491062185146462],
            [15.319611049609595, -0.03741232949745594],
            [15.30874090965923, -0.041163175285371625],
            [15.305326639122791, -0.043526637775672554],
            [15.298737671345203, -0.050232883760804564],
            [15.299149974022571, -0.0564919870447794],
            [15.296495469079119, -0.062498406314907315],
            [15.290415806308411, -0.06736393122421229],
            [15.268778510017675, -0.10359069094081444],
            [15.248623025181889, -0.1325526610825972],
            [15.249430910787364, -0.13436054707348896],
            [15.236824218354537, -0.1438912005452906],
            [15.226160682078635, -0.1534990203042761],
            [15.221256771609667, -0.15966016434469973],
            [15.212400721167388, -0.16827878918895914],
            [15.145756019937071, -0.2319030144057158],
            [15.103100576506971, -0.27252797975549425],
            [15.095633999413463, -0.2802686524383891],
            [15.084538798677297, -0.28984455862190067],
            [15.079132799871491, -0.2469130062910017],
            [15.073045562593002, -0.2252847375948813],
            [15.063175772314455, -0.1713840262971481],
            [15.054112398055397, -0.12995624109914478],
            [15.049067835103138, -0.11378926004348741]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.22423102772021, "lat": 37.18648221324521 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51149"],
        "coty_name": ["Prince George"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prince George County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01480160"
      },
      "bbox": [
        15.049067835103138, -0.28984455862190067, 15.363679698092056,
        0.07955119062291979
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.635352167685623, -0.9557982012302768],
            [11.7064218718731, -1.023630842956099],
            [11.760474839434412, -1.0756171166561366],
            [11.764168929101897, -1.0790125319110497],
            [11.769309294850657, -1.0881480182469196],
            [11.777472504716712, -1.1012047449769824],
            [11.794421446800254, -1.1300325658155435],
            [11.832542634140603, -1.1935266490368257],
            [11.85095717843027, -1.2244001054150262],
            [11.860680030208897, -1.2187494616107608],
            [11.861774572997193, -1.2296861367449765],
            [11.859940750506214, -1.2404333362040505],
            [11.851821531892412, -1.244068562038887],
            [11.847628106077165, -1.2477613045538865],
            [11.83241059136937, -1.2497666616476628],
            [11.76156085151573, -1.2600406596208367],
            [11.69068273284338, -1.2688469285556638],
            [11.614977264733234, -1.2781399077131737],
            [11.609209292864897, -1.3014502808149806],
            [11.546184449981784, -1.310624233913799],
            [11.442802094309622, -1.3255552123102945],
            [11.453180228837802, -1.3055402040073094],
            [11.46492636942233, -1.290015240836147],
            [11.469041931251487, -1.2859725226591872],
            [11.461867577160637, -1.2789238783641304],
            [11.466040220173257, -1.2710072507716705],
            [11.468704396957778, -1.269019438928987],
            [11.467291433246526, -1.2644385666599136],
            [11.462151989873366, -1.2669732480262952],
            [11.456667503953959, -1.2610732958122377],
            [11.453743839905126, -1.2594128881991062],
            [11.457044341351406, -1.2547711482129538],
            [11.454741463591846, -1.2490437241114705],
            [11.449788831652135, -1.2464430988978643],
            [11.445524201513324, -1.2465037724247396],
            [11.441012203420732, -1.24973251568821],
            [11.449463195470447, -1.2593699331696384],
            [11.449055908643956, -1.264672536211455],
            [11.453706829691042, -1.2706761448966426],
            [11.460967156234036, -1.2783136443079819],
            [11.45451604691633, -1.2840255802274034],
            [11.446630592633138, -1.2849701781112326],
            [11.443768067701717, -1.2864077299428844],
            [11.440624427478944, -1.281682925072007],
            [11.427572422871576, -1.2913490527713811],
            [11.428456459946052, -1.2949815935612057],
            [11.42030583207263, -1.2956071446300668],
            [11.411308659183005, -1.297440094403354],
            [11.407723956994044, -1.301363695048768],
            [11.40299755118508, -1.3044829858375362],
            [11.39017500571869, -1.3163415309195015],
            [11.37979009329379, -1.3242593497910455],
            [11.374412772907114, -1.3270307844897717],
            [11.373250356022403, -1.3304040443654817],
            [11.36878313090005, -1.3353362256943726],
            [11.325746942006635, -1.3416275478608122],
            [11.319493887790056, -1.3323370659415983],
            [11.311504678443182, -1.3192567053580913],
            [11.285560332085254, -1.2471347620257394],
            [11.279500497130417, -1.232816833218576],
            [11.283062638550748, -1.2270893312238966],
            [11.289241103696865, -1.2193311648041063],
            [11.301136169631585, -1.20736791904061],
            [11.30738435412092, -1.204011995073894],
            [11.313613879338204, -1.1982958765896252],
            [11.324328444286422, -1.1911965156468411],
            [11.328050923607886, -1.187616290164284],
            [11.334509982985233, -1.1838301935772673],
            [11.337068440848725, -1.183836058147975],
            [11.339533420370309, -1.1790897315829831],
            [11.344277362350683, -1.1779363669499794],
            [11.346356074526124, -1.1739661802429484],
            [11.349908682676144, -1.1731911113507871],
            [11.355980755874945, -1.1668498233023799],
            [11.363447216501026, -1.16350641620208],
            [11.373164199074695, -1.1558485429008871],
            [11.37616069166274, -1.155678750761537],
            [11.379008788887953, -1.1524506710829012],
            [11.384882306367388, -1.1509016956201246],
            [11.390860970398602, -1.1462946222850723],
            [11.39798770596528, -1.144245745303421],
            [11.418379960955228, -1.1325549513256252],
            [11.421505095724383, -1.132232722792656],
            [11.428690809599384, -1.1278243060215365],
            [11.429745222126234, -1.1255083504440282],
            [11.435083729374629, -1.1231868176965218],
            [11.438457661757905, -1.11988874244872],
            [11.443303512996538, -1.1195276261261766],
            [11.445702443058956, -1.1175593008273432],
            [11.437727557470001, -1.1091502186512188],
            [11.432563703582126, -1.0993322565507289],
            [11.432968936670324, -1.0908621190192134],
            [11.435946431713447, -1.087218131718169],
            [11.43703210997118, -1.0808771194936466],
            [11.44144055972312, -1.0763017801412875],
            [11.445446034030743, -1.0698763431235216],
            [11.452238770141859, -1.0623815368835692],
            [11.45704375395718, -1.0581780949969415],
            [11.467455143330811, -1.0529619704561513],
            [11.470752231431684, -1.0524189446575176],
            [11.484279281822326, -1.0452806818632907],
            [11.492098326026285, -1.0401460013972468],
            [11.494463280531894, -1.0399428763845007],
            [11.515757777743415, -1.0290127782113754],
            [11.520792101657541, -1.027994290922099],
            [11.521866324298639, -1.0260692774772802],
            [11.531172636996805, -1.0212928111034971],
            [11.530566935728954, -1.024024063332727],
            [11.535385084695744, -1.0314993451264012],
            [11.539118816581057, -1.0297053862476837],
            [11.544267290171472, -1.029323564042755],
            [11.549762015338226, -1.034383805946172],
            [11.553953435083786, -1.0315636500984144],
            [11.559702569463424, -1.0328774757369004],
            [11.568175811516621, -1.0244429380899163],
            [11.572482726319395, -1.0228709832954255],
            [11.589412709012263, -1.0095697970303257],
            [11.60354509820907, -1.0008807082789128],
            [11.62065106215222, -0.9800794110998061],
            [11.631066827923238, -0.9608564506557742],
            [11.635352167685623, -0.9557982012302768]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.95988614947396, "lat": 36.72443834833566 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51191"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "01498359"
      },
      "bbox": [
        11.279500497130417, -1.3416275478608122, 11.861774572997193,
        -0.9557982012302768
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.06761947709889, 12.34879079940146],
              [-17.062607433134758, 12.35121127373234],
              [-17.059168358308444, 12.35502821617004],
              [-17.058574242021606, 12.342425432026985],
              [-17.06761947709889, 12.34879079940146]
            ]
          ],
          [
            [
              [-17.08761045987412, 12.415595552642065],
              [-17.082610932311507, 12.410721507130646],
              [-17.076194195572835, 12.410652276615894],
              [-17.072151000398744, 12.405890257829528],
              [-17.061990678398118, 12.41012884883249],
              [-17.062481892214794, 12.395904600249665],
              [-17.070527028669858, 12.392349083173597],
              [-17.07464333517853, 12.393505484407635],
              [-17.078859047507933, 12.397686165716951],
              [-17.08761045987412, 12.415595552642065]
            ]
          ],
          [
            [
              [-17.128353619195337, 12.446491499170545],
              [-17.11986374855468, 12.459163246966165],
              [-17.116644856945246, 12.45921745466698],
              [-17.11276307814651, 12.454133213647154],
              [-17.10901286884429, 12.44492613585438],
              [-17.10524056188248, 12.443089826481271],
              [-17.10804435534776, 12.43996948242887],
              [-17.10510327180165, 12.435173727733583],
              [-17.10474922492743, 12.42763435213095],
              [-17.106153210533254, 12.424911193626782],
              [-17.099876007854427, 12.415420457843236],
              [-17.10102200724191, 12.413685680057545],
              [-17.101139386583558, 12.404425688461309],
              [-17.09699133641241, 12.400577810335536],
              [-17.093461743522624, 12.399111456455207],
              [-17.089776048386796, 12.395189162395104],
              [-17.081772084167106, 12.380451119138344],
              [-17.080904646209504, 12.374857730438492],
              [-17.078314165467955, 12.37119264726299],
              [-17.078604837926875, 12.350921244741887],
              [-17.080393381982677, 12.341342500034692],
              [-17.086230241624587, 12.351661007917594],
              [-17.09443381401555, 12.356747764976816],
              [-17.10011607088861, 12.368307040427716],
              [-17.09996862987268, 12.371442466864584],
              [-17.102796659943923, 12.37376012553638],
              [-17.10371361785745, 12.3780896869544],
              [-17.111042331511037, 12.39053806654337],
              [-17.112287825112787, 12.398009917369672],
              [-17.111597846011698, 12.400792064789343],
              [-17.113771644750525, 12.4086123963293],
              [-17.11312736619151, 12.415315104955763],
              [-17.114342330337543, 12.42231506060137],
              [-17.118971472389862, 12.42580033145017],
              [-17.119518583315433, 12.42930739477991],
              [-17.13021763053853, 12.432136591834169],
              [-17.128903687245753, 12.435417510664704],
              [-17.130436654894243, 12.438788597846173],
              [-17.1280147399328, 12.44276790208219],
              [-17.128353619195337, 12.446491499170545]
            ]
          ],
          [
            [
              [-15.857477729634432, 12.37033403489378],
              [-15.860500155281507, 12.368564560479168],
              [-15.858902473559516, 12.364265135472204],
              [-15.868950617421467, 12.355309082917488],
              [-15.8717458378511, 12.353644037429278],
              [-15.882759881218123, 12.35464207078737],
              [-15.885754494462649, 12.352694022597394],
              [-15.883471805653905, 12.348547426804663],
              [-15.885497060499233, 12.345944905225403],
              [-15.881072813050412, 12.339004125930565],
              [-15.874143314726897, 12.334681995915734],
              [-15.872012364467729, 12.33059538223313],
              [-15.867148316114045, 12.328546503449324],
              [-15.863026846357597, 12.321545387083301],
              [-15.86268866001078, 12.31079338440459],
              [-15.859299686598254, 12.308753128549869],
              [-15.852365180999337, 12.30993126819281],
              [-15.850886474860308, 12.312718023348218],
              [-15.847336910158104, 12.313434689479385],
              [-15.844341280217353, 12.317360809778679],
              [-15.836947789149905, 12.31837729475917],
              [-15.83568390865236, 12.323134752589487],
              [-15.82971149523848, 12.322263152907585],
              [-15.826994382378063, 12.319881635499275],
              [-15.819340603763735, 12.316943696105863],
              [-15.815833180791653, 12.31373554607042],
              [-15.813873386744106, 12.30721212303924],
              [-15.811293379764782, 12.302396945451209],
              [-15.811176784249993, 12.294315564349976],
              [-15.812976966968243, 12.290768627002954],
              [-15.816003629825081, 12.288985527843588],
              [-15.823914355698383, 12.288784644568553],
              [-15.826023980426257, 12.286134480834544],
              [-15.827669493067768, 12.279044237213718],
              [-15.826387564460621, 12.273464782916633],
              [-15.829451397770795, 12.271168781203325],
              [-15.83018558995776, 12.26732838848924],
              [-15.826090508004567, 12.261490120078294],
              [-15.829962692420565, 12.256146730363472],
              [-15.829737775388324, 12.250718885710057],
              [-15.835428818518595, 12.246243727681605],
              [-15.834700516817465, 12.240643189357046],
              [-15.82511300804451, 12.228587164626262],
              [-15.817395932011392, 12.22410560112916],
              [-15.819472509880061, 12.218441357555434],
              [-15.817247337372313, 12.21471284468531],
              [-15.82334508745862, 12.205763496222552],
              [-15.826149765007873, 12.20340175127889],
              [-15.825243856908413, 12.196629196249736],
              [-15.82858893788099, 12.188333541618505],
              [-15.832736369951421, 12.185810112206639],
              [-15.835254130710213, 12.175700469004212],
              [-15.83285294692298, 12.167532114528866],
              [-15.836090993162287, 12.160450432105076],
              [-15.834871431874419, 12.15679296952755],
              [-15.837298858913652, 12.15141868922287],
              [-15.834250220744266, 12.137526943329767],
              [-15.824597476193462, 12.133439611329193],
              [-15.821555069712472, 12.118117223806314],
              [-15.817543431188987, 12.116181307267343],
              [-15.817181459716792, 12.111690302814187],
              [-15.818784565245185, 12.108026919345491],
              [-15.81272666654077, 12.097735511028853],
              [-15.813469429900945, 12.093777131318204],
              [-15.810850969026008, 12.091266434338028],
              [-15.807227216226611, 12.090723577732627],
              [-15.804502631258574, 12.083734125404378],
              [-15.801743509457582, 12.080574122484984],
              [-15.80553038407077, 12.076255924835838],
              [-15.81233979120852, 12.079014237317896],
              [-15.817863111180497, 12.077685552037368],
              [-15.821874728409094, 12.071547153532789],
              [-15.822583837918794, 12.065025670347861],
              [-15.821769555803714, 12.062265635689029],
              [-15.823286001671852, 12.057453387395395],
              [-15.827721449037298, 12.056618519134586],
              [-15.834373242477069, 12.060790042742221],
              [-15.839421822351701, 12.062369942803647],
              [-15.84727193980352, 12.055357256974913],
              [-15.849498656111804, 12.05035614746195],
              [-15.85497792370421, 12.043972256694332],
              [-15.856654313410415, 12.034433275813452],
              [-15.859037313807791, 12.034421862882008],
              [-15.866391461416613, 12.038635734180628],
              [-15.870581330811904, 12.036209408641353],
              [-15.87893027607104, 12.0349750112281],
              [-15.880879057639444, 12.033210415262046],
              [-15.981822208620903, 12.059605309990271],
              [-15.985949179357108, 12.04456172743491],
              [-16.0487087918511, 12.06162516652265],
              [-16.11147247683947, 12.07867382425065],
              [-16.174240204851955, 12.095707693903378],
              [-16.237011946412267, 12.11272676875831],
              [-16.29978767203978, 12.129731042086602],
              [-16.36256735225134, 12.1467205071533],
              [-16.425350957562987, 12.163695157217933],
              [-16.488138458491708, 12.180654985534876],
              [-16.520156161240422, 12.189780305592732],
              [-16.63686092333635, 12.22272785263185],
              [-16.665644138370087, 12.230206167333463],
              [-16.684542049782273, 12.236076840446698],
              [-16.74893366367149, 12.253961280823503],
              [-16.784010012773795, 12.263937858028449],
              [-16.85422643009549, 12.283525545124803],
              [-16.861173251830458, 12.28501551467846],
              [-16.898199361327567, 12.295414807211529],
              [-16.91716490078555, 12.300369729302684],
              [-17.002130158399282, 12.324395230676048],
              [-17.003782069151764, 12.331079742423764],
              [-17.00850451448926, 12.337496091825303],
              [-17.010542421860304, 12.345807964006092],
              [-17.00593518429742, 12.345854826948099],
              [-16.99604817251911, 12.348611430280462],
              [-16.99328486372883, 12.360298306912169],
              [-16.99458561148743, 12.375007107442771],
              [-16.99371958325726, 12.379650842294168],
              [-16.999972128238134, 12.377458979999142],
              [-16.99969172647119, 12.36997242917042],
              [-17.00181454190637, 12.369047923131854],
              [-17.004056227675086, 12.381349471375668],
              [-17.002506632347913, 12.38359149741474],
              [-17.003200819168622, 12.39271534001589],
              [-17.00214187097941, 12.396502874500255],
              [-16.996878690910005, 12.40038682353898],
              [-16.993433594889826, 12.39863560195603],
              [-16.990764259296085, 12.404255775861403],
              [-16.985355940496603, 12.407557937528974],
              [-16.977284952202744, 12.414905912230216],
              [-16.978565418641946, 12.418412433004171],
              [-16.975335471067975, 12.419870847624589],
              [-16.974398102666143, 12.42286381138128],
              [-16.976433620901393, 12.42568632193313],
              [-16.983711484807476, 12.428979395921896],
              [-16.986838289720758, 12.432371628142503],
              [-16.986340047864196, 12.438322139862343],
              [-16.993921229711017, 12.445697455941595],
              [-16.996694246805568, 12.454206077559828],
              [-17.013786749139054, 12.461401596780266],
              [-17.018463869894923, 12.458849068939939],
              [-17.026909226892705, 12.457598359722969],
              [-17.029983057251265, 12.459988057234073],
              [-17.037420655893907, 12.456613882240838],
              [-17.04669083838185, 12.454809293168985],
              [-17.049556726004752, 12.449680363309135],
              [-17.064246124732776, 12.4415442013563],
              [-17.07267945718717, 12.434920118168323],
              [-17.074160681578377, 12.43209913042462],
              [-17.081387841499325, 12.425506639077255],
              [-17.08417012226321, 12.419986355728806],
              [-17.087537729308178, 12.419199964101608],
              [-17.090288920471288, 12.424701062028033],
              [-17.091616770406027, 12.436418785919729],
              [-17.096682896977097, 12.439033338146837],
              [-17.09636076733154, 12.443266491159182],
              [-17.088298183740232, 12.452110077162748],
              [-17.083044326557022, 12.456174706428268],
              [-17.075316307891182, 12.466417837057953],
              [-17.068804740481145, 12.472297388587029],
              [-17.065653275463685, 12.47898483455376],
              [-17.0653656104985, 12.482392223790919],
              [-17.07001684946604, 12.484878221855343],
              [-17.076689452710568, 12.492819642109412],
              [-17.07980865282079, 12.498865821049595],
              [-17.07994162059686, 12.502276814252408],
              [-17.083584922893845, 12.50587542389098],
              [-17.09135385478187, 12.505489878450131],
              [-17.0942405008947, 12.51037263897526],
              [-17.09908039691056, 12.509282579542095],
              [-17.09991094772327, 12.494442979917594],
              [-17.105480955007526, 12.495700134337692],
              [-17.104856702187675, 12.499986179961999],
              [-17.096327621694915, 12.524066916091774],
              [-17.0940181978325, 12.538056539485476],
              [-17.09333641797851, 12.552707070906637],
              [-17.0953732302764, 12.558969060007858],
              [-17.098248918543906, 12.562232620386482],
              [-17.108736491333154, 12.571453784248835],
              [-17.112365861051764, 12.58032719643326],
              [-17.126800348381394, 12.600177460209334],
              [-17.12944402916373, 12.608816108166993],
              [-17.12294770094817, 12.608698960718687],
              [-17.116948251317787, 12.610955185872063],
              [-17.111260252210915, 12.61561326301794],
              [-17.101622196559088, 12.616720585295212],
              [-17.097645721241168, 12.618216967676304],
              [-17.094041672272176, 12.621558768039371],
              [-17.09112352993029, 12.626400612128897],
              [-17.089298718854277, 12.635423013471044],
              [-17.089842183472722, 12.639677373203702],
              [-17.092890187366283, 12.644392469458703],
              [-17.1012866334412, 12.650643592495557],
              [-17.115186953975957, 12.643705861715194],
              [-17.118611080956647, 12.64527150022995],
              [-17.132767209697683, 12.656061810222145],
              [-17.133860832186283, 12.662240841227215],
              [-17.127474365845057, 12.671531644713076],
              [-17.119907697505887, 12.675860729300048],
              [-17.110215135812087, 12.683012440173528],
              [-17.10925132137488, 12.685498937881274],
              [-17.090421486041173, 12.69624228261985],
              [-17.08516159221807, 12.69539342481384],
              [-17.07606048421551, 12.698415914110083],
              [-17.076940843174295, 12.703790183968788],
              [-16.979661751532735, 12.6763536235126],
              [-16.916530512410933, 12.65867709377887],
              [-16.853403457993103, 12.640985175192156],
              [-16.753157466294322, 12.613472610833432],
              [-16.655635270863257, 12.586230179755418],
              [-16.560962971836847, 12.558239048369332],
              [-16.49790021596786, 12.539722448699427],
              [-16.434842302259316, 12.521190445369873],
              [-16.332928917584333, 12.494846335881803],
              [-16.231024900060806, 12.468462646278509],
              [-16.20640042082842, 12.462139670572117],
              [-16.17394485686966, 12.454465087558924],
              [-16.1175105977693, 12.438683721293721],
              [-16.112175963105486, 12.438102642225124],
              [-16.099905189205252, 12.435076423385055],
              [-16.033382200007942, 12.417706218860841],
              [-15.991086764973442, 12.405749515144686],
              [-15.939191110870391, 12.391836293908481],
              [-15.857477729634432, 12.37033403489378]
            ]
          ],
          [
            [
              [-17.28912975309653, 12.763659578120047],
              [-17.253918917701345, 12.753786610875007],
              [-17.25394856829026, 12.749217782084864],
              [-17.252069714447767, 12.73505781059986],
              [-17.253596972072817, 12.731224483313046],
              [-17.25248837692598, 12.727604213985583],
              [-17.256022417054712, 12.726269938234143],
              [-17.264361419546507, 12.731824945173178],
              [-17.285103056045568, 12.734305056740164],
              [-17.293434920832272, 12.734252737864912],
              [-17.290155246973793, 12.74414243922838],
              [-17.28912975309653, 12.763659578120047]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.71972123901402,
          "lat": 48.825921324133546
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53073"],
        "coty_name": ["Whatcom"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Whatcom County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01529224"
      },
      "bbox": [
        -17.293434920832272, 12.033210415262046, -15.801743509457582,
        12.763659578120047
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.488560887867848, 0.7553880147679757],
            [11.496033659346695, 0.7469904105012395],
            [11.537890075610104, 0.7021840181796607],
            [11.544872931582267, 0.7000125746503086],
            [11.545247640710055, 0.6956135571700159],
            [11.548098304578339, 0.6908460394994683],
            [11.586460933703641, 0.7198837994863628],
            [11.623877595767985, 0.7620597085130603],
            [11.639665412689805, 0.7338053352818231],
            [11.672721867754225, 0.7017296647151141],
            [11.676836088272866, 0.7059300359112052],
            [11.767129149509584, 0.7111910035592784],
            [11.803229092160826, 0.710164627584219],
            [11.827628741060407, 0.7007182510325519],
            [11.867163000277577, 0.7171330384143887],
            [11.888063169657853, 0.7161145158173295],
            [11.86289528462432, 0.6890056664345785],
            [11.82801970231398, 0.6498855712889429],
            [11.851936441885503, 0.5900849271876702],
            [11.86568529609956, 0.5567113204550447],
            [11.866284732791225, 0.5542152567851905],
            [11.9007431707393, 0.4483563891586745],
            [11.900619568241787, 0.44813056451107314],
            [11.849547170543334, 0.35541543931028907],
            [11.843981476789853, 0.3575349840110225],
            [11.838468087191723, 0.3556457472012958],
            [11.839229658147298, 0.3500678948353211],
            [11.841377789341122, 0.34785749835044233],
            [11.838658413954125, 0.3356298399989419],
            [11.837188239592386, 0.2881354121064414],
            [11.832584948476072, 0.16837834570041763],
            [11.831547910473924, 0.136485650473798],
            [11.818864862178067, 0.13268002515306423],
            [11.813154236233718, 0.13639423680656512],
            [11.805022914278585, 0.13687317872291768],
            [11.803341365168059, 0.13089085621570123],
            [11.798851125363054, 0.12978788446251513],
            [11.79379032611657, 0.13339954185686181],
            [11.7913523983215, 0.13281851835409483],
            [11.789037339161577, 0.1288846235659192],
            [11.784501251433023, 0.1306364875740841],
            [11.782017994786898, 0.13444246450769506],
            [11.777728041609498, 0.13459781654123462],
            [11.774812991466705, 0.13762209514901896],
            [11.769598135075782, 0.137124325751017],
            [11.771127431953015, 0.14205924090787328],
            [11.770264764171811, 0.14560454264761458],
            [11.771670367889449, 0.15133887081747685],
            [11.769419374315712, 0.1546700266070406],
            [11.764235314683436, 0.15897943777985263],
            [11.762899425107513, 0.163301898415443],
            [11.759506690132161, 0.16572158090817682],
            [11.760910347136122, 0.1713654534421953],
            [11.756815060944316, 0.17253254878497942],
            [11.758433176349838, 0.17793150785531156],
            [11.756569381194062, 0.18142062614005575],
            [11.761630269214308, 0.18488182673180842],
            [11.756766299649945, 0.19382532291931057],
            [11.75188068262884, 0.19766614707585367],
            [11.749830370496056, 0.20220553634130378],
            [11.747396069683207, 0.20202671451486218],
            [11.744514737417335, 0.2059804573489364],
            [11.746984570321894, 0.20904186543866032],
            [11.74249434107888, 0.21573941963977186],
            [11.737407532571964, 0.21606789887713757],
            [11.72948491242323, 0.221206873087803],
            [11.72600238713161, 0.21545657004233837],
            [11.721483482928498, 0.2130781400301232],
            [11.715930210610702, 0.2158701257894535],
            [11.712728867485733, 0.21477355816459162],
            [11.710378720946839, 0.22029738132863713],
            [11.703991758785326, 0.2224390074204625],
            [11.70089268964905, 0.22503651056712887],
            [11.694319763184033, 0.224616701532396],
            [11.691045264123405, 0.23099520618321176],
            [11.692794280638376, 0.23226048823435763],
            [11.693753068075484, 0.24574583654625254],
            [11.696492034177208, 0.24574101510759785],
            [11.699375379700944, 0.25120173284268577],
            [11.702850006776197, 0.25083604203921817],
            [11.70428694822255, 0.26078275611191293],
            [11.696190436172076, 0.26857929934014346],
            [11.69192872448405, 0.26668309048034033],
            [11.69004943156526, 0.2702197687124433],
            [11.684833238943808, 0.2673112522880087],
            [11.680772074237805, 0.26722713022340755],
            [11.680076620479525, 0.27143579161363196],
            [11.684637876136824, 0.2776271510674305],
            [11.678915364240535, 0.28542946196080893],
            [11.667757963726197, 0.2869729635192516],
            [11.663726894386377, 0.2831848959673707],
            [11.660310526306343, 0.28194290408063477],
            [11.65546207364445, 0.2889966836688232],
            [11.652025433785104, 0.2865751288453148],
            [11.649774147399206, 0.2902517181360496],
            [11.64162225293353, 0.29632820617916833],
            [11.641845858341709, 0.29948414966073544],
            [11.63358641245698, 0.30289708363575024],
            [11.631130052052928, 0.3085857237804161],
            [11.62573900141653, 0.3145936398781375],
            [11.62192794900672, 0.31628395356108396],
            [11.611368242471475, 0.31683115056303796],
            [11.608891847492004, 0.3098694460709846],
            [11.605690084463927, 0.30874124257483954],
            [11.604065588086428, 0.31446929628306286],
            [11.592178694661596, 0.3203225732279163],
            [11.594051409274254, 0.32767072075848874],
            [11.588867189167413, 0.34006331074599266],
            [11.589185752828449, 0.3447408615532513],
            [11.59198609855401, 0.34587385624214645],
            [11.590455527331795, 0.3500452947453899],
            [11.59034187355517, 0.35653140985200243],
            [11.58354982895424, 0.3556358449570802],
            [11.57769757873187, 0.35739438873964857],
            [11.572832522931671, 0.3546580902717876],
            [11.56245816396907, 0.3525992400792472],
            [11.557541013065002, 0.348869532299766],
            [11.555135674765229, 0.34989975254501154],
            [11.549270491189107, 0.35695927414896816],
            [11.54643889353231, 0.35763808440482403],
            [11.541727066507637, 0.35562681740814867],
            [11.54057844655116, 0.3513419506154559],
            [11.529545836855224, 0.3492289978640752],
            [11.525963397076488, 0.3434721525292555],
            [11.527135558784462, 0.34006783642841704],
            [11.530850580486819, 0.3415604410992866],
            [11.530667284569706, 0.3319876425958193],
            [11.525297624846605, 0.33040005668708594],
            [11.5221126950109, 0.32311256675681216],
            [11.515894279697479, 0.3251628653048078],
            [11.511465532020637, 0.324194495081273],
            [11.507547858045621, 0.3278205610804027],
            [11.50538612379464, 0.3347878775554826],
            [11.505327261167219, 0.3405500500688932],
            [11.496445747652494, 0.3491561801552425],
            [11.489509488473388, 0.3514338555230869],
            [11.48115665601327, 0.35005002903982335],
            [11.481661103738558, 0.3439672051231602],
            [11.478504426580253, 0.3403187493417639],
            [11.482410284556215, 0.33353418731208545],
            [11.4798965093664, 0.3285498762291819],
            [11.47654344292365, 0.32567162773297303],
            [11.472164098781422, 0.3269433438935983],
            [11.466524619979104, 0.32424942782484506],
            [11.464058406694058, 0.3247208979083892],
            [11.464570354695814, 0.31832477249736446],
            [11.462617110384054, 0.314635680112562],
            [11.464905937907702, 0.30727116284259726],
            [11.468588897093262, 0.3059196341327474],
            [11.472707225147387, 0.29724559263385164],
            [11.468732794390704, 0.2966537816901822],
            [11.465055435535678, 0.30028952147073523],
            [11.459586967416937, 0.3017210766503044],
            [11.456081376219773, 0.3086496009759925],
            [11.454074761780943, 0.3153571769724543],
            [11.450528645715753, 0.32012001915984883],
            [11.446169052796408, 0.3233077453310471],
            [11.446989825565629, 0.3276921501589364],
            [11.442534153117183, 0.3319898193526728],
            [11.444421255122526, 0.33662823387026114],
            [11.456762437100345, 0.3344725070973749],
            [11.453119632848722, 0.33923692816531764],
            [11.457020850173318, 0.3408383751441192],
            [11.463286378471, 0.33662176711036507],
            [11.468647978069553, 0.33849459123623943],
            [11.468163388827156, 0.34086225511771373],
            [11.461404763545954, 0.3443292885978929],
            [11.462324086405376, 0.3504648355677759],
            [11.45971628721513, 0.35225987364935707],
            [11.457802586082424, 0.35662135487031305],
            [11.463661311248224, 0.36638578706716896],
            [11.456684851746902, 0.3733338649655992],
            [11.460611376223438, 0.37665615776997535],
            [11.46172910586251, 0.38153904730688915],
            [11.456823455227086, 0.385741259051197],
            [11.457836142767075, 0.38762752928080635],
            [11.453650036614713, 0.4019861890339811],
            [11.455088071520576, 0.4033788856190888],
            [11.453998131589504, 0.41104097695948344],
            [11.449018490019029, 0.41689258640566024],
            [11.448121423772298, 0.42477971436867806],
            [11.441802962053968, 0.43209671571625474],
            [11.431409231585722, 0.43643187843824505],
            [11.42504806181694, 0.43191520469737055],
            [11.423174661735114, 0.42705958308359443],
            [11.42049942840981, 0.425404301030474],
            [11.390206777846922, 0.4223160291893974],
            [11.365977443019776, 0.4297698397148834],
            [11.366044960411209, 0.4598269629480771],
            [11.366591697742745, 0.5043667010708076],
            [11.380867177677041, 0.5166298034062903],
            [11.40102929854298, 0.533372966271041],
            [11.405794561571895, 0.53800555993546],
            [11.41068898915964, 0.5382050941461803],
            [11.411323738460244, 0.5418934991598992],
            [11.421315107764745, 0.5443468962690129],
            [11.42320626325159, 0.5503604287805915],
            [11.427711365673517, 0.5508294408387711],
            [11.45377882340903, 0.5669548039971708],
            [11.492097451876177, 0.5939021127916015],
            [11.491874710184584, 0.6009271337092742],
            [11.488383535773979, 0.6012811372063198],
            [11.484414208202761, 0.6119221532924098],
            [11.481065560826984, 0.6165625289558285],
            [11.478447029281687, 0.6248416343464095],
            [11.480040289402467, 0.6286884545627525],
            [11.47567120516456, 0.6290887736990407],
            [11.469727073952647, 0.6342326338869806],
            [11.472347633300348, 0.6374584119828944],
            [11.469895985287467, 0.6413226860778669],
            [11.464322631620664, 0.643517508044998],
            [11.461067975213, 0.6462486968121496],
            [11.459752490156244, 0.6575615494276632],
            [11.460724545156218, 0.6661605044048574],
            [11.458494882106773, 0.668791192183744],
            [11.460543545913575, 0.672745162663437],
            [11.46068013986425, 0.6767605695857765],
            [11.458101742886907, 0.6783674127566638],
            [11.459235083466062, 0.6822239631521275],
            [11.453440625515878, 0.7003838928490201],
            [11.44992764615176, 0.7039389544414268],
            [11.452467447284091, 0.7084693319422877],
            [11.45244106821828, 0.7137589234235763],
            [11.457242573124864, 0.7177091213946407],
            [11.460048674662582, 0.7233962570881908],
            [11.465218548890103, 0.7231762222409094],
            [11.46831840931079, 0.7214741132498909],
            [11.475833899323222, 0.7328294372244232],
            [11.482084891757752, 0.7459171653389641],
            [11.488560887867848, 0.7553880147679757]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.52804034447016, "lat": 38.33655530631006 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54039"],
        "coty_name": ["Kanawha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kanawha County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01550026"
      },
      "bbox": [
        11.365977443019776, 0.1288846235659192, 11.9007431707393,
        0.7620597085130603
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.550034802884403, 7.548037121104734],
            [3.564367602795994, 7.5493025081599585],
            [3.5789931044829015, 7.549028562758923],
            [3.5935834187309874, 7.550208332429358],
            [3.6367004621660377, 7.55183478591243],
            [3.674484706211421, 7.553542448705555],
            [3.723083479485802, 7.556009173420936],
            [3.7377870278920047, 7.557722578277461],
            [3.7524963881955724, 7.558152682065647],
            [3.7668908282832483, 7.559316361732848],
            [3.810487969481825, 7.560851778264702],
            [3.8454748992547714, 7.560836762881445],
            [3.9431019968132115, 7.565084153320701],
            [3.9554813199261147, 7.5662289066452235],
            [3.984548359597137, 7.567230624556071],
            [3.987025641747742, 7.517454170955641],
            [3.9878414837294622, 7.5100630724040665],
            [3.989366286483755, 7.4753529207945855],
            [3.991361044171273, 7.44740332368933],
            [3.992069837518625, 7.427808912208354],
            [3.9918542336891205, 7.409849311260452],
            [3.993371130984978, 7.395794072291865],
            [3.9947190255539904, 7.395699905896908],
            [4.080266217793134, 7.40061473185405],
            [4.16581469324742, 7.405508665375216],
            [4.166877330317011, 7.363311205965737],
            [4.171466133896627, 7.300065336824157],
            [4.170959643621501, 7.293586487248622],
            [4.172872916077946, 7.2702433008758796],
            [4.1746810600004425, 7.237070722061113],
            [4.178659724558325, 7.173436815321413],
            [4.178626852675202, 7.165637463001156],
            [4.179606517719946, 7.151776400230976],
            [4.182022708970484, 7.10903180852368],
            [4.183770434426221, 7.065715213611977],
            [4.0969475006344, 7.061142284056972],
            [4.011160331015876, 7.057165423235882],
            [3.9244905838885678, 7.0523918379662085],
            [3.8815063091941013, 7.050316001555937],
            [3.8371296001143484, 7.047630412870551],
            [3.7797314103334494, 7.045286202438355],
            [3.751187280686439, 7.0438079503068876],
            [3.6982036315553257, 7.040784427703593],
            [3.66633797835175, 7.0384668390235925],
            [3.5819891790422798, 7.034302820616423],
            [3.579923018037536, 7.072217151114774],
            [3.57528742082631, 7.162016919665662],
            [3.5738473860532936, 7.208123677294124],
            [3.5709846584795546, 7.250289091266658],
            [3.56862822847184, 7.301479938501219],
            [3.5670451289026492, 7.322996288118985],
            [3.565173580408431, 7.361953339331229],
            [3.5647708802633957, 7.375834238666484],
            [3.5577863280350743, 7.37625700351162],
            [3.5545230755912334, 7.462345298723603],
            [3.550034802884403, 7.548037121104734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.14454853598623, "lat": 45.87999177708105 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55113"],
        "coty_name": ["Sawyer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sawyer County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01581116"
      },
      "bbox": [
        3.550034802884403, 7.034302820616423, 4.183770434426221,
        7.567230624556071
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.638829044107582, 6.000112220347232],
            [3.6534315001360995, 6.000883266213662],
            [3.7250470979745343, 6.004021005659471],
            [3.7709044165505596, 6.006212929962311],
            [3.8109822964588793, 6.0089917439039935],
            [3.85940904628068, 6.011636032413517],
            [3.896707760262945, 6.013465230132183],
            [3.8990421458932696, 5.966790560563363],
            [3.900877422147852, 5.926703296323595],
            [3.9030725729550237, 5.897190683475461],
            [3.906203648553164, 5.839792853748632],
            [3.9078419040541146, 5.7961552100588],
            [3.911226493626497, 5.7213506423116005],
            [3.9139368201309974, 5.672365332732994],
            [3.9145784236372188, 5.665246462619818],
            [3.9231188702878463, 5.665817598660506],
            [3.9257348288796243, 5.627127431828827],
            [3.9284453026647634, 5.576906019281631],
            [3.9328719090616895, 5.498421810618791],
            [3.928233733096083, 5.501116725306996],
            [3.9223506471985323, 5.5010004270841435],
            [3.9210063931594763, 5.506026028120772],
            [3.9182372658175684, 5.5060908550154855],
            [3.91455224138848, 5.502643041820675],
            [3.907514631354276, 5.502781698637619],
            [3.903997689463747, 5.504442584742175],
            [3.8993905388987975, 5.50444457034053],
            [3.899039242289104, 5.4945115707460355],
            [3.8979509632606018, 5.492382495472272],
            [3.8931144664889605, 5.490629138419236],
            [3.893170296622037, 5.485356037656162],
            [3.888810052662223, 5.483274831052167],
            [3.8869995692827923, 5.4804175110111055],
            [3.8877740846169093, 5.474746167202272],
            [3.8841943191684654, 5.469378599226081],
            [3.878566161264854, 5.473653950829641],
            [3.8749814065983896, 5.474173930621969],
            [3.8708790495412813, 5.472187750818175],
            [3.8656743041304362, 5.472884467401754],
            [3.8618028115236482, 5.475961353729904],
            [3.8595691095639957, 5.481753286352119],
            [3.8506730129988336, 5.486894272074989],
            [3.8486790417760504, 5.483148856342155],
            [3.844329716094607, 5.481341134167603],
            [3.8392649623845982, 5.474426466371257],
            [3.830957028356892, 5.47692878449014],
            [3.822392242172372, 5.478106224631287],
            [3.816471349327435, 5.473142529657857],
            [3.816123898956586, 5.4665373144813],
            [3.8129052219112833, 5.461088356301695],
            [3.8069991549499815, 5.45765234184638],
            [3.8056797601618273, 5.454673135034821],
            [3.809195401117807, 5.450388188727511],
            [3.8060690430675366, 5.448197645349417],
            [3.8023910034285167, 5.449743203190696],
            [3.8006340739297717, 5.44544731531807],
            [3.8021177107508217, 5.440755541962269],
            [3.7987398662016796, 5.430025486196486],
            [3.7993127693111197, 5.426259242881491],
            [3.8032946001087637, 5.4258505359995635],
            [3.803343222209852, 5.419655791840706],
            [3.810891250578779, 5.4125593030037455],
            [3.809739689835185, 5.407907101083104],
            [3.81093349605874, 5.40431205611619],
            [3.81477963341769, 5.403657160667821],
            [3.8155619861900343, 5.397330751061027],
            [3.748471359495327, 5.393798856158732],
            [3.7420975826518044, 5.393629941514317],
            [3.738277767971073, 5.403016502988552],
            [3.736243073422885, 5.405859102787608],
            [3.730280662293437, 5.410249465655888],
            [3.7179935752227067, 5.414464809161074],
            [3.713469271547282, 5.416990331133909],
            [3.7098999984163514, 5.4172598193068096],
            [3.7010890779522647, 5.415506477604009],
            [3.6907742078959425, 5.419410820930782],
            [3.6817839621059876, 5.4254324527863815],
            [3.6693619197003287, 5.427302110519478],
            [3.653068838942, 5.4273328388925215],
            [3.644352779523588, 5.430016160831369],
            [3.646247093660641, 5.434531164111287],
            [3.642278348972353, 5.436314738883065],
            [3.6350702284707417, 5.442099664997049],
            [3.635004715814687, 5.449146477067616],
            [3.6390416979793367, 5.456052668430515],
            [3.642961668115133, 5.4577241393318685],
            [3.643133404579414, 5.467085732337312],
            [3.648718126201842, 5.472741170522019],
            [3.6486393380612325, 5.477795595583252],
            [3.652375544342095, 5.481752982078491],
            [3.6528978391934106, 5.48680431872837],
            [3.655857743329524, 5.4962013021261615],
            [3.6586735365769987, 5.501227722197337],
            [3.657323812472547, 5.504805277246261],
            [3.653782629084759, 5.5066525077133495],
            [3.6478790289912952, 5.512803142735256],
            [3.6485102774764178, 5.515827208589161],
            [3.6457008640421735, 5.520590456307315],
            [3.6454393730542867, 5.526040359533911],
            [3.6470259638532436, 5.528470928724085],
            [3.642988947786795, 5.537115925534419],
            [3.6400094446422666, 5.538909722406825],
            [3.639091461036125, 5.546057238391089],
            [3.633819862935263, 5.552735182017876],
            [3.6279602266305555, 5.55539026398235],
            [3.621641948639011, 5.556320097864524],
            [3.6155496524562, 5.5587484646176755],
            [3.6124078778806137, 5.563600683794724],
            [3.6116678184085833, 5.567163251627892],
            [3.6045010847731542, 5.566513967293139],
            [3.5995427968357268, 5.571422887505944],
            [3.598953014158493, 5.576080916488618],
            [3.6016063554878945, 5.577304504880726],
            [3.605537280638635, 5.582676336231605],
            [3.608518132686967, 5.583789326343209],
            [3.6094538355583157, 5.5907854240167625],
            [3.6076944719087987, 5.596685485705945],
            [3.6020836014368207, 5.601496485454416],
            [3.604676572554812, 5.606793262947675],
            [3.6057058960715804, 5.613925922153287],
            [3.612253102106349, 5.618778523434338],
            [3.616175944694022, 5.619010821500467],
            [3.620060015450504, 5.621525270326251],
            [3.6237000082726585, 5.626314296041309],
            [3.6262746247836977, 5.622969705019641],
            [3.6316924130547625, 5.628480308795335],
            [3.636371755241628, 5.628582058682121],
            [3.6400421360402806, 5.636385508629507],
            [3.6440658208988244, 5.638963726264142],
            [3.6487291763428655, 5.639799162992638],
            [3.648103095887766, 5.643156799123146],
            [3.6502047952014767, 5.649689945702792],
            [3.654848013996968, 5.651916957383165],
            [3.654746892545135, 5.659193338315366],
            [3.6496092473238737, 5.77768930470736],
            [3.6493656667568137, 5.779730507585851],
            [3.646314305287066, 5.839634168012174],
            [3.6430471426345266, 5.913716049471442],
            [3.638829044107582, 6.000112220347232]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.3584606304134, "lat": 44.303977437450094 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55121"],
        "coty_name": ["Trempealeau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trempealeau County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01581120"
      },
      "bbox": [
        3.598953014158493, 5.393629941514317, 3.9328719090616895,
        6.013465230132183
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.539053463147091, 5.762155103589821],
            [5.564955782322523, 5.764064450882377],
            [5.59561303111176, 5.766622506931893],
            [5.615933667639764, 5.768607960513416],
            [5.64361380228831, 5.770718135443144],
            [5.719721666368226, 5.776564519405862],
            [5.725867252635277, 5.777412081348836],
            [5.773415513010645, 5.781133412924186],
            [5.796623455656352, 5.783268554536024],
            [5.853838565733704, 5.787886217426442],
            [5.859872429408771, 5.788616012477043],
            [5.882559028573592, 5.790135597809408],
            [5.883402582155032, 5.7809385455337425],
            [5.885686594086213, 5.747213406964155],
            [5.889360319269803, 5.701739410958498],
            [5.893178071831316, 5.656969931428636],
            [5.893857206234982, 5.645061163943413],
            [5.904260535472512, 5.527296554474222],
            [5.906981586713951, 5.485630067410584],
            [5.911315598069598, 5.440640846454189],
            [5.846701856737979, 5.436150873567114],
            [5.810450188033664, 5.4334185879334935],
            [5.74862249941298, 5.429515505028951],
            [5.674591456888411, 5.424052901407196],
            [5.6005613414325826, 5.418577491884362],
            [5.565822083160778, 5.416181501543163],
            [5.558858011438378, 5.503889622144978],
            [5.554340761025779, 5.562180169257165],
            [5.54963703391491, 5.630904286759796],
            [5.545453162762949, 5.6811516259946595],
            [5.544284723859501, 5.6972369847201625],
            [5.539053463147091, 5.762155103589821]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.64465003547996, "lat": 44.06887224658327 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55139"],
        "coty_name": ["Winnebago"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winnebago County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01581129"
      },
      "bbox": [
        5.539053463147091, 5.416181501543163, 5.911315598069598,
        5.790135597809408
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.4952273870169, "lat": 18.051113725188017 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72075"],
        "coty_name": ["Juana Díaz"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Juana Díaz Municipio"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01804518"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.85166201603376, -4.795696933324813],
            [8.85356824698998, -4.7941157547805675],
            [8.892328179295138, -4.747834105060115],
            [8.891434100155255, -4.733424005433457],
            [8.934178871529504, -4.72896747604653],
            [8.932328882142933, -4.698398748579334],
            [8.930908965437903, -4.684970054727484],
            [8.945593263888016, -4.683964520691318],
            [8.943701615629404, -4.66992401729954],
            [8.972541670979155, -4.667435083781331],
            [8.970319235407164, -4.65265153516082],
            [8.983324052307703, -4.651779151896373],
            [8.999049636454467, -4.650156961816118],
            [8.998065013826398, -4.639195707659208],
            [9.001577712988826, -4.638969572879879],
            [9.004561546023655, -4.635052415944271],
            [9.003891759030138, -4.62781107646341],
            [9.010795523801649, -4.626668413444537],
            [8.99762719344892, -4.502678012383074],
            [9.011393056305561, -4.501003935699973],
            [9.010099417151546, -4.486561548033645],
            [9.02440777690313, -4.485187204136182],
            [9.022867389455966, -4.4706166450495495],
            [9.037167162483092, -4.469301181937625],
            [9.032982000353824, -4.425479739880021],
            [8.990364994455398, -4.4295597101498],
            [8.987228670230037, -4.400148145721979],
            [9.016114088920693, -4.398080349519395],
            [9.014510362535683, -4.383214407335374],
            [9.071396905187632, -4.377567473281923],
            [9.0675632356389, -4.3251602967072875],
            [9.09550599703224, -4.321091875644386],
            [9.09432741960041, -4.306549167445051],
            [9.151307814925659, -4.300061642520059],
            [9.15105750874942, -4.296474411605176],
            [9.165478085640101, -4.294964563131962],
            [9.165227132220853, -4.29129645998539],
            [9.172434635825658, -4.290567607445541],
            [9.189555898149212, -4.35174632000757],
            [9.202094912399442, -4.396508194522014],
            [9.230423459722989, -4.500404009863391],
            [9.257109474461922, -4.595405360283838],
            [9.289412084717139, -4.710180922131679],
            [9.29091865585444, -4.716163233919306],
            [9.30408840833018, -4.762069277713806],
            [9.301514090688206, -4.763677022681993],
            [9.29394195903992, -4.757775251954422],
            [9.28992763437182, -4.758133845272894],
            [9.281259739528382, -4.756426887183706],
            [9.269108500661229, -4.751132090750749],
            [9.26765951720812, -4.748020695774534],
            [9.26455874412203, -4.747998868680786],
            [9.261093011954786, -4.750760573988406],
            [9.26339500592914, -4.756993737201307],
            [9.242695824689877, -4.759018720602149],
            [9.143904470652947, -4.768090570104886],
            [9.11832364023867, -4.7709410783740855],
            [9.039945757392601, -4.778759464432545],
            [9.02355913043228, -4.7800307945748335],
            [8.993129988252582, -4.782597226413176],
            [8.922868877367334, -4.788209327647626],
            [8.924336791664583, -4.8033075490853925],
            [8.910272218114013, -4.804658811568897],
            [8.911778108846182, -4.818917659957868],
            [8.825242463120432, -4.82809632712437],
            [8.824545607020783, -4.82076282940943],
            [8.839061378911802, -4.819227770733386],
            [8.838087682523646, -4.804379251588561],
            [8.85198645638406, -4.802825482674115],
            [8.85166201603376, -4.795696933324813]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.51882098244232, "lat": 33.67451090497394 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01029"],
        "coty_name": ["Cleburne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cleburne County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00161540"
      },
      "bbox": [
        8.824545607020783, -4.82809632712437, 9.30408840833018,
        -4.290567607445541
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.453267251285776, -6.927187882131571],
            [9.489264959919517, -6.9235853891093315],
            [9.539825478197992, -6.920084560576735],
            [9.569708345932082, -6.918377398642044],
            [9.612987371343065, -6.914914147325118],
            [9.6556638855269, -6.911785823818749],
            [9.689113016786349, -6.9076318195045046],
            [9.732917199491638, -6.901974018228901],
            [9.7334116430466, -6.906555058490624],
            [9.732691048376395, -6.915690933677572],
            [9.730440486166946, -6.921301924437919],
            [9.726044294912978, -6.927343621572027],
            [9.716846888860596, -6.930833768290591],
            [9.713720518577025, -6.935603218544658],
            [9.716558506636355, -6.940148662047037],
            [9.716344185963322, -6.948329652482672],
            [9.718380876676099, -6.954435357042369],
            [9.720940556474076, -6.9575652560355445],
            [9.726540420181868, -6.969699725048677],
            [9.732197757492925, -6.9784228394426835],
            [9.734748785769122, -6.985022213407404],
            [9.733808203922214, -6.991285795301148],
            [9.734755325146018, -6.999423710304593],
            [9.728748329672246, -7.008725138812452],
            [9.728567162012212, -7.015819495569467],
            [9.730143743683437, -7.024848072582566],
            [9.734968782524657, -7.026017906658634],
            [9.738497463500602, -7.0302067126628245],
            [9.738741063901125, -7.044877201264703],
            [9.746201337005408, -7.04923338729827],
            [9.753499463644182, -7.049062708963895],
            [9.75970218900793, -7.051061747991925],
            [9.76611395514133, -7.058593492200165],
            [9.772040112615969, -7.064113497358803],
            [9.775497913644312, -7.072006085047713],
            [9.782463215049713, -7.084644456891065],
            [9.786496014551613, -7.086087748543699],
            [9.800078479458259, -7.095275130881158],
            [9.803318138496023, -7.102541564904462],
            [9.806452148116474, -7.106597796383242],
            [9.810947042952744, -7.118089745633111],
            [9.809907449302738, -7.126881756066698],
            [9.80993178824995, -7.127824114477308],
            [9.820545968475908, -7.14196446844715],
            [9.826937023179031, -7.14694703102069],
            [9.830587241476227, -7.15727023427338],
            [9.831069205367552, -7.167681568405174],
            [9.835655850704628, -7.174844951338146],
            [9.836721108352078, -7.180253854642721],
            [9.841685203005337, -7.185028650876032],
            [9.842069017570712, -7.18975746454635],
            [9.840603025130743, -7.1983393089815815],
            [9.798520445174468, -7.20327809832982],
            [9.718923437138578, -7.212265084558058],
            [9.713488531194793, -7.212744128680402],
            [9.635869953032927, -7.221483692615826],
            [9.496967475123606, -7.239575306315386],
            [9.428521414273298, -7.248401005222135],
            [9.428227986048876, -7.24250033730703],
            [9.422630596908022, -7.177440611923381],
            [9.416794796509054, -7.120594803914365],
            [9.408214938615718, -7.047517340495284],
            [9.377421492976387, -7.0527796707737815],
            [9.360821006585587, -7.055222713184752],
            [9.324059944255561, -7.061770471471197],
            [9.261519267504445, -7.068483049729359],
            [9.218436625234986, -7.072934202490972],
            [9.221210958493307, -7.065900676114136],
            [9.225434587624205, -7.06294257077425],
            [9.23122747274899, -7.056784430258287],
            [9.232244781059865, -7.053139357838726],
            [9.229770769664402, -7.046842131602804],
            [9.232979397031674, -7.045255196984204],
            [9.232029956260726, -7.0407665981250585],
            [9.234102058479984, -7.037582269943333],
            [9.231992536750294, -7.030481926037644],
            [9.239709851444335, -7.027656656302486],
            [9.245667443942766, -7.014892893149322],
            [9.241714744415745, -7.009921435874526],
            [9.244785755892554, -7.007706288127718],
            [9.247899678640454, -7.001721931847531],
            [9.248049403057886, -6.997458280816296],
            [9.252855389564697, -6.993357240300068],
            [9.25516845294109, -6.993612466556157],
            [9.264074495939527, -6.98980141130629],
            [9.265878683147086, -6.990616603691483],
            [9.273239174794053, -6.9864691943360056],
            [9.277407611111737, -6.988840929012928],
            [9.286443578878073, -6.986246666819702],
            [9.288980363802532, -6.987509739111006],
            [9.295258937123094, -6.9864100997566485],
            [9.300974481954158, -6.9866339926934735],
            [9.31297828800068, -6.990785996318764],
            [9.316623297523831, -6.993142808146393],
            [9.323806596862898, -6.991967262429694],
            [9.336075483249585, -6.993976563345997],
            [9.3460316628407, -6.996974024688856],
            [9.351134217090989, -6.999699783658754],
            [9.360888169342454, -6.999228294531689],
            [9.36303969828018, -7.000900206070599],
            [9.369452879901452, -6.998151704251688],
            [9.376941983989928, -6.998481205281175],
            [9.383066274215416, -6.999896183166267],
            [9.387798236567788, -7.003177628309967],
            [9.3936319989846, -7.001688539425374],
            [9.402754419625884, -7.002013197166712],
            [9.39882237796139, -6.961156468941939],
            [9.456789512088424, -6.955652962429328],
            [9.45419655520919, -6.937872661956514],
            [9.453267251285776, -6.927187882131571]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.30253583124914, "lat": 31.15320945354656 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01069"],
        "coty_name": ["Houston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Houston County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00161560"
      },
      "bbox": [
        9.218436625234986, -7.248401005222135, 9.842069017570712,
        -6.901974018228901
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.592316130852224, -3.405677125077994],
            [7.690211512419223, -3.39891482935159],
            [7.754081243745214, -3.394435579669561],
            [7.763115021549604, -3.3936210780619414],
            [7.87488962389003, -3.3861429682696884],
            [7.895801417811178, -3.3843210678238074],
            [7.938375682732156, -3.380035874311116],
            [7.941252243535777, -3.4093960643019052],
            [7.948848570011397, -3.4921847293968815],
            [7.957936321890519, -3.599703432932079],
            [7.9618330621108075, -3.6436757224642347],
            [7.9666733584311515, -3.6959795665819652],
            [7.972306889082108, -3.7683679300432464],
            [7.976215369778751, -3.8223969157742212],
            [7.9603320875655905, -3.8204814811964587],
            [7.944056118876851, -3.82117887684093],
            [7.936212042669696, -3.8203625292268546],
            [7.915753307449458, -3.810907905298063],
            [7.8864019963105845, -3.803890755402505],
            [7.8778441392338605, -3.8024075067169583],
            [7.864406940667209, -3.796879686310743],
            [7.833513189156807, -3.7792110598565927],
            [7.821699027612276, -3.7742351526490525],
            [7.804647795714978, -3.7615354411483373],
            [7.78833119297126, -3.7540014775238126],
            [7.782385863156182, -3.7504903756168537],
            [7.773265907065223, -3.7424270055918862],
            [7.767140652741675, -3.740077796278068],
            [7.76046642069965, -3.7410299339282616],
            [7.755588408631031, -3.7434958188027214],
            [7.75189981875886, -3.7424669827849355],
            [7.739201029812118, -3.7333878198530743],
            [7.724729887587655, -3.7264022458182717],
            [7.716953369376792, -3.7200983010467428],
            [7.713168003026056, -3.715610524151244],
            [7.707279815301675, -3.711351886731072],
            [7.689626748148366, -3.6972848399643623],
            [7.685844154768111, -3.692763150549682],
            [7.682028832025715, -3.6826132095081383],
            [7.676274039612645, -3.6757829633111108],
            [7.662495914925659, -3.6671451414268463],
            [7.655219522483889, -3.663962984544664],
            [7.6479557797843105, -3.6594621561080727],
            [7.635396611512461, -3.6545518606610305],
            [7.626145641487341, -3.6541819901400885],
            [7.612894550912352, -3.6457133308408882],
            [7.604528482403193, -3.642905385530097],
            [7.598817140469685, -3.642619508581548],
            [7.582510375883355, -3.6458589133854193],
            [7.574205217399623, -3.650350652234859],
            [7.5707511255482745, -3.648459342937065],
            [7.569099925962772, -3.6436381996654763],
            [7.5618151673768885, -3.6402493637378206],
            [7.558524514966065, -3.636697303632857],
            [7.558234041540115, -3.631285028303471],
            [7.563013710458712, -3.6261981622445165],
            [7.575345693554291, -3.6203542221390266],
            [7.588614410275471, -3.6082788672088584],
            [7.593878484035302, -3.6026132470260297],
            [7.6001149191325235, -3.5972918735305837],
            [7.605960660413785, -3.5891021916300017],
            [7.604105556081373, -3.569278142027315],
            [7.6014493149610995, -3.526172132528332],
            [7.600350088547584, -3.505272863041406],
            [7.595644911590606, -3.4460568268118217],
            [7.5953777604509884, -3.445307117792766],
            [7.592316130852224, -3.405677125077994]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.9814265692659, "lat": 34.81007991295747 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01083"],
        "coty_name": ["Limestone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Limestone County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00161567"
      },
      "bbox": [
        7.558234041540115, -3.8223969157742212, 7.976215369778751,
        -3.380035874311116
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.170708144062402, -6.030783681994545],
            [8.167086357361125, -6.035154640196986],
            [8.166415021466001, -6.03879416423529],
            [8.168724758248825, -6.056885116730698],
            [8.172699134426422, -6.061561167915114],
            [8.177370792278401, -6.06351721624247],
            [8.187756444041938, -6.061452262333876],
            [8.193195607498572, -6.0549214372521725],
            [8.205636083172722, -6.027484035970236],
            [8.196829585940812, -6.000337264669125],
            [8.195184447902292, -5.998800671448562],
            [8.195105450899254, -5.9895817818565655],
            [8.193322849606414, -5.980305423627118],
            [8.193744737381449, -5.976630656421251],
            [8.198993585422352, -5.973454058212462],
            [8.203571489628954, -5.974190130962647],
            [8.208807896567786, -5.9769770158747875],
            [8.2140867599241, -5.977929877610518],
            [8.220299705503297, -5.977461465739253],
            [8.22658100264184, -5.974192776325303],
            [8.234273184038637, -5.9661070884729535],
            [8.237850432995577, -5.960289919653006],
            [8.243023537924845, -5.959469658722032],
            [8.245774165969184, -5.961209266495478],
            [8.246513136364094, -5.967982887085015],
            [8.245187071169335, -5.972982199519689],
            [8.247063595492534, -5.983603366435617],
            [8.247843675723233, -5.991908655683761],
            [8.251330281061831, -5.995889073670704],
            [8.252848184034017, -6.000635915784476],
            [8.25538146284292, -6.002518842203186],
            [8.267714614617757, -6.004503177316015],
            [8.27709230857245, -6.007463883874736],
            [8.283123739092982, -6.005242352721324],
            [8.291613132578192, -5.994647385470505],
            [8.300469912516466, -5.982656434979112],
            [8.30149304827897, -5.9779942940353],
            [8.299070822104168, -5.970191405758349],
            [8.299857015968952, -5.962487531851881],
            [8.301601267777928, -5.959263596619042],
            [8.306402209063307, -5.95579872423777],
            [8.320309237423475, -5.953956365962196],
            [8.324818701805858, -5.949615485430711],
            [8.328968525909307, -5.950141412989857],
            [8.333127456745165, -5.955789330643685],
            [8.334166260260204, -5.96145611798394],
            [8.3326806308319, -5.975714891198567],
            [8.334725651698575, -5.981178680801036],
            [8.352314590278926, -5.99242711566881],
            [8.356220033201732, -5.991257668428442],
            [8.35759228036925, -5.98547095090674],
            [8.362209397117873, -5.97770929461498],
            [8.367521232535944, -5.976117716845563],
            [8.37167468027416, -5.976785884896615],
            [8.381970658424533, -5.981768130237076],
            [8.391184388892118, -5.980644311951359],
            [8.396238434633359, -5.985895591488923],
            [8.400815548123965, -6.003846875840309],
            [8.40291152634184, -6.0075956360715885],
            [8.407076996206374, -6.00968067640517],
            [8.417354682788423, -6.00709295705072],
            [8.436409539344382, -6.0010702561808325],
            [8.438684593452571, -6.0068523105668294],
            [8.44317431053049, -6.002490191387366],
            [8.444527804606198, -6.006133326804764],
            [8.448621415815222, -6.00399803749747],
            [8.448293705190373, -6.0112557217214775],
            [8.452845466819413, -6.0127653200635045],
            [8.45743211574973, -6.018084545494326],
            [8.454336492237598, -6.023145876079474],
            [8.453237319832274, -6.02886353735123],
            [8.449438499343957, -6.031847502670772],
            [8.450348277107256, -6.038010281600484],
            [8.446497658245029, -6.039214715118182],
            [8.445490646534584, -6.043184499210602],
            [8.44921509977551, -6.043180349137373],
            [8.44935883681058, -6.047130652831855],
            [8.447496465268358, -6.051292267658052],
            [8.452449083948355, -6.062489242256017],
            [8.456199148141904, -6.063021800592906],
            [8.453224793443484, -6.067758570214647],
            [8.458876393007579, -6.068267829203539],
            [8.459904239636241, -6.070683750943179],
            [8.465787179467021, -6.072916505153246],
            [8.471062031476729, -6.069264154618437],
            [8.475489032670934, -6.067844309940922],
            [8.484572646788019, -6.072915792022201],
            [8.48472031550276, -6.077465161414224],
            [8.491132195275087, -6.078388270163633],
            [8.500049849653957, -6.083042666739573],
            [8.503352357354903, -6.082066876556829],
            [8.507906594994626, -6.085061083302597],
            [8.507827549866269, -6.090562413375062],
            [8.514914029337644, -6.0911677366787895],
            [8.520129911022725, -6.093282918988239],
            [8.52061628409779, -6.0988397647503065],
            [8.52578986848585, -6.142886339069227],
            [8.530722092389711, -6.189356776851862],
            [8.536772118324691, -6.239333042679522],
            [8.539888982409984, -6.270773057406208],
            [8.541823702262281, -6.285509641332573],
            [8.542620713172587, -6.292382782614111],
            [8.550708275324853, -6.291401494426839],
            [8.551540615328793, -6.2983311476498525],
            [8.543424647912133, -6.299315293294396],
            [8.551696178179183, -6.37180321968767],
            [8.543839195851954, -6.371520911040478],
            [8.515324140774007, -6.374599464861414],
            [8.47837889911071, -6.3786275384209],
            [8.471937395657124, -6.379958245378849],
            [8.376418873399038, -6.389108867172833],
            [8.262012809322984, -6.40219875066216],
            [8.213898543589691, -6.407264711261506],
            [8.199190284077895, -6.4078508861576395],
            [8.171564198936021, -6.410775496540545],
            [8.163513329912108, -6.338084466845652],
            [8.16409221922, -6.325026011713756],
            [8.152319619671646, -6.325909454499159],
            [8.121830065014791, -6.329451538158165],
            [8.121067799150557, -6.319670128052688],
            [8.115846733028604, -6.269654060518053],
            [8.110653656245763, -6.221811608651839],
            [8.108819062804123, -6.201402301890444],
            [8.106662172294426, -6.1857946758550275],
            [8.103703581707117, -6.15347373145729],
            [8.136094126304782, -6.150543778121719],
            [8.176287237856265, -6.146421753001761],
            [8.185817879879796, -6.14587977404386],
            [8.18445863641598, -6.133116096325738],
            [8.177334819320624, -6.137744909737819],
            [8.16757970554456, -6.135378621604102],
            [8.15763769641363, -6.130377298440774],
            [8.155790245722555, -6.126572500285687],
            [8.153200298465896, -6.1259637966467535],
            [8.145312146350209, -6.11769097890616],
            [8.145157747645422, -6.113305605840609],
            [8.139102811226824, -6.108805430346742],
            [8.136343240638096, -6.104661714552763],
            [8.136698325246362, -6.098076319417804],
            [8.141099963723322, -6.094186577242879],
            [8.139787460241935, -6.090769585721793],
            [8.143456073731805, -6.087158776731846],
            [8.146193129401182, -6.08802579095318],
            [8.148461418982608, -6.084744970045536],
            [8.14708817191273, -6.081783719603581],
            [8.151445876290081, -6.080359801890541],
            [8.155879789368518, -6.0740915893389555],
            [8.15987262952689, -6.073220442453451],
            [8.164674951255936, -6.066704133798467],
            [8.155230555852226, -6.0644190916274905],
            [8.143924117613507, -6.064442996687646],
            [8.142158945705031, -6.045439211509925],
            [8.155854833557914, -6.0388084199311916],
            [8.170708144062402, -6.030783681994545]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.65007314467351, "lat": 32.15475133643851 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01085"],
        "coty_name": ["Lowndes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lowndes County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00161568"
      },
      "bbox": [
        8.103703581707117, -6.410775496540545, 8.551696178179183,
        -5.949615485430711
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.317193910621791, -5.842457969196791],
            [9.377281576100962, -5.835180481875336],
            [9.403778633856856, -5.831786438690938],
            [9.394183279384235, -5.774678950372558],
            [9.47654302204059, -5.763864565033691],
            [9.577790110387223, -5.750865999485667],
            [9.62254773444872, -5.744372153863642],
            [9.617127896288922, -5.708533908085296],
            [9.635077099270434, -5.7062394215450585],
            [9.666986935672801, -5.701757253881775],
            [9.66846377248542, -5.707483321361576],
            [9.67082190947661, -5.710850068530258],
            [9.670897863663022, -5.71747560809781],
            [9.674755737209782, -5.725188460114961],
            [9.675677095656205, -5.735960535209637],
            [9.673804212762153, -5.741616437756371],
            [9.674911504819224, -5.749645923845484],
            [9.67994021714416, -5.760143296999589],
            [9.688619120152616, -5.764275047229208],
            [9.698948690876467, -5.765897955522473],
            [9.703823691580425, -5.772886400209599],
            [9.70845248773561, -5.783527790077147],
            [9.708316991931737, -5.785255659891116],
            [9.702045866784088, -5.7923280370287324],
            [9.6961723783518, -5.797037280187501],
            [9.695876684238181, -5.806549057236512],
            [9.697195836757286, -5.809151493859314],
            [9.70278179804797, -5.813418415074941],
            [9.707309775061862, -5.815116876712972],
            [9.705078587100052, -5.817802575775526],
            [9.69959383927006, -5.818541092287205],
            [9.695255751985647, -5.81777083897719],
            [9.693337149882874, -5.820103734719156],
            [9.691837166031466, -5.825900449186586],
            [9.694168025580131, -5.829401679337427],
            [9.704620917607578, -5.828656770091456],
            [9.706422582886015, -5.830638068761923],
            [9.704809937998977, -5.833966795480162],
            [9.696789138698074, -5.835959546810776],
            [9.6953950269462, -5.840003766269009],
            [9.69847344115828, -5.844222726216185],
            [9.696227564444092, -5.850588725800787],
            [9.682977693194392, -5.866078787509962],
            [9.68103278994006, -5.874880590394597],
            [9.682826466163698, -5.883044681167708],
            [9.687928851880736, -5.888844772783416],
            [9.698562494670846, -5.890331825395746],
            [9.743178467691676, -5.903889306809355],
            [9.74753971885309, -5.905846598228164],
            [9.758177191211477, -5.917622742009222],
            [9.768968375723475, -5.924805863233296],
            [9.775277295824406, -5.927291680971974],
            [9.784610573880107, -5.934158567322857],
            [9.789265281375155, -5.938583096588554],
            [9.786887683086553, -5.9415174603021175],
            [9.779335301215026, -5.943252682316415],
            [9.777906481050453, -5.950049261396471],
            [9.773176780891044, -5.953122454403165],
            [9.767052187742594, -5.953115493325265],
            [9.762091815348183, -5.951908510387387],
            [9.761767203175662, -5.957153525943659],
            [9.765129733338568, -5.958371511006217],
            [9.767498177338446, -5.956183051747899],
            [9.771562875748852, -5.958326590929548],
            [9.769349564987328, -5.9654283860233726],
            [9.764412446340078, -5.971739021033381],
            [9.76521272729952, -5.977787650353943],
            [9.759860036045403, -5.984147886688922],
            [9.75229664520061, -5.986134766630025],
            [9.743768589065924, -5.986562196661981],
            [9.733809416077928, -5.988181375728267],
            [9.728641999274423, -5.9874723970885375],
            [9.72484078285578, -5.989020212328247],
            [9.71998521480729, -5.9953205379201036],
            [9.719289116978876, -6.000230914847524],
            [9.72444929231249, -6.003759281730327],
            [9.73079466823455, -6.002218554634782],
            [9.734144769643628, -6.004045074003796],
            [9.735818337951304, -6.00747394292573],
            [9.733800628802284, -6.011228343457251],
            [9.726609526672524, -6.015685009977775],
            [9.708820516987373, -6.024486912916122],
            [9.698622224787593, -6.028633258345944],
            [9.685352010684161, -6.046062379998419],
            [9.68028479879097, -6.056462728355709],
            [9.67203048411749, -6.07008047983016],
            [9.661913984740016, -6.079031308063273],
            [9.659550387457582, -6.082856334163729],
            [9.667594729088023, -6.100859214441369],
            [9.66934773760609, -6.106680256986392],
            [9.674310432249152, -6.1185043897173745],
            [9.678674428535654, -6.126547264929644],
            [9.677654143987937, -6.1291995253261495],
            [9.672931583384356, -6.1335078576253865],
            [9.671481696290435, -6.139875634472673],
            [9.673418293177887, -6.143906545486348],
            [9.672615150541697, -6.151195440352316],
            [9.631666987206756, -6.156412499558156],
            [9.631002811994051, -6.1492331742305],
            [9.623981401237529, -6.150215667077704],
            [9.624649639838546, -6.157362314954122],
            [9.572357306213682, -6.163666260983395],
            [9.564660837579702, -6.164890074085636],
            [9.559012854279022, -6.162629441377557],
            [9.557598415844717, -6.157675494036364],
            [9.554687770964339, -6.156186762071811],
            [9.55711238697531, -6.151855770750959],
            [9.55272182928912, -6.1484150865461284],
            [9.553417013947344, -6.14591858177171],
            [9.543566260948051, -6.142061185165641],
            [9.53903358147829, -6.134995315523243],
            [9.530805763297698, -6.134916820021204],
            [9.523114975778117, -6.127795317611179],
            [9.52399736936849, -6.125736364515902],
            [9.52081053363092, -6.119853570584632],
            [9.520913178687021, -6.117170762726853],
            [9.51688551987755, -6.115692402300209],
            [9.516898835197377, -6.112131609874902],
            [9.507510365523464, -6.1136053482392185],
            [9.507083177780064, -6.109348090974366],
            [9.514728702845556, -6.108241434880326],
            [9.512923112115406, -6.105275478023739],
            [9.502430953328547, -6.1025146113413555],
            [9.496517798400731, -6.097642560197487],
            [9.49278180345946, -6.0908749310682095],
            [9.49395181608147, -6.085860754393354],
            [9.366475028312362, -6.10175478883526],
            [9.352086008932467, -6.103454805637753],
            [9.337153171388746, -6.016512521034251],
            [9.334945563771608, -6.0011673511219445],
            [9.32693608193348, -5.934183901375839],
            [9.319330384052154, -5.859960900946818],
            [9.317193910621791, -5.842457969196791]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.1849339763763, "lat": 32.28837028575913 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01113"],
        "coty_name": ["Russell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Russell County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00161583"
      },
      "bbox": [
        9.317193910621791, -6.164890074085636, 9.789265281375155,
        -5.701757253881775
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-13.734622580043428, -11.000634238617124],
              [-13.733628238790894, -10.99927995262544],
              [-13.734568687708006, -10.997371051144594],
              [-13.733113156599337, -10.996153298208116],
              [-13.732457016137769, -10.999813311232748],
              [-13.734622580043428, -11.000634238617124]
            ]
          ],
          [
            [
              [-13.743223244741154, -10.995425966757995],
              [-13.74283795566237, -10.992666060742982],
              [-13.741465015873276, -10.994192045696876],
              [-13.739810881394082, -10.996936689225002],
              [-13.740473536702519, -10.997445398140565],
              [-13.743072775732442, -10.995920005381997],
              [-13.743223244741154, -10.995425966757995]
            ]
          ],
          [
            [
              [-13.749191246919956, -11.001931360252808],
              [-13.747651933720787, -11.00251248231683],
              [-13.746141405962227, -11.004044666356448],
              [-13.746683280557844, -11.005100857679485],
              [-13.748394114282924, -11.003806751296544],
              [-13.749191246919956, -11.001931360252808]
            ]
          ],
          [
            [
              [-13.731365962942542, -11.037159742288145],
              [-13.730504988005116, -11.039200224057653],
              [-13.730415812061423, -11.040840053320359],
              [-13.729078309647047, -11.04373464931686],
              [-13.72847797322276, -11.045855683204389],
              [-13.728673713490311, -11.047309292853397],
              [-13.727352855423224, -11.049399818711532],
              [-13.725613553234954, -11.050466532236104],
              [-13.72521439620036, -11.051926498621786],
              [-13.723409762202309, -11.055002742868488],
              [-13.724028562523497, -11.056717227323741],
              [-13.721947409776478, -11.058901931216429],
              [-13.720031159658992, -11.059195916058037],
              [-13.718946456962929, -11.058110753998914],
              [-13.71674187565729, -11.057552617002992],
              [-13.715577707630867, -11.056578912537923],
              [-13.71341542614087, -11.05603288393044],
              [-13.711740245956047, -11.055088479941213],
              [-13.707983282871506, -11.051545391208393],
              [-13.708224779293126, -11.050308725145142],
              [-13.70461434389735, -11.049423805998734],
              [-13.703959325995257, -11.048283235539403],
              [-13.704665891472953, -11.047319170254351],
              [-13.706293391632977, -11.046627371092816],
              [-13.70489648957391, -11.045673653814058],
              [-13.702828618415335, -11.04794918880141],
              [-13.700839296659442, -11.04609799595659],
              [-13.701283415402635, -11.044651204168348],
              [-13.702940202686298, -11.042525735008603],
              [-13.70233299850479, -11.041083702561611],
              [-13.700730103699856, -11.040654583763017],
              [-13.700325298310103, -11.041526739753944],
              [-13.698891916925344, -11.041733867124288],
              [-13.69603330397498, -11.043458134613692],
              [-13.691804966181223, -11.044731299369435],
              [-13.688711037363534, -11.044986757904422],
              [-13.684033555360298, -11.0440038466783],
              [-13.68243426554408, -11.042670821944968],
              [-13.679111455417537, -11.041592299953441],
              [-13.676903100044091, -11.04237916592668],
              [-13.674321185847127, -11.041564567414518],
              [-13.670950754800385, -11.042410715074759],
              [-13.66743519481236, -11.04357440095296],
              [-13.664157937098299, -11.045441030001703],
              [-13.661859451689686, -11.045476970020019],
              [-13.660670376986443, -11.044443793628313],
              [-13.656923860362486, -11.045310806352203],
              [-13.656261046352279, -11.045970845104707],
              [-13.654045192710969, -11.044855299329049],
              [-13.652791823500909, -11.041677555717877],
              [-13.650518965199392, -11.040453496139035],
              [-13.646784877194404, -11.040688415865588],
              [-13.64675929721142, -11.03959602267754],
              [-13.645849351690085, -11.037379071412529],
              [-13.643307077376756, -11.036434123983552],
              [-13.641910320201847, -11.036510932711977],
              [-13.639786895217947, -11.035690831106017],
              [-13.638060123645396, -11.034041048583443],
              [-13.636833648380582, -11.031818188493425],
              [-13.636087720324777, -11.031277138700515],
              [-13.634425648830186, -11.03249331241264],
              [-13.632446509603204, -11.032528860275473],
              [-13.630207410223766, -11.03207891184476],
              [-13.629894365878808, -11.032823821594175],
              [-13.630277764320368, -11.032546872703906],
              [-13.66823020479934, -11.059587848374433],
              [-13.668248052520891, -11.061835480517555],
              [-13.668960878947301, -11.063429873627186],
              [-13.670907205630787, -11.065934731676773],
              [-13.671802450557534, -11.066619914726878],
              [-13.674553092062366, -11.067662039873001],
              [-13.675701646657771, -11.06921162462656],
              [-13.678854500693399, -11.069824188066429],
              [-13.682352818124398, -11.071742329920658],
              [-13.684380218077898, -11.071967287090265],
              [-13.685824384372006, -11.071202878201953],
              [-13.687819016111995, -11.071420479140782],
              [-13.688318093080747, -11.073411171642551],
              [-13.687922802123415, -11.074806330751906],
              [-13.68872588776357, -11.07710779854032],
              [-13.690003138703238, -11.077950914282638],
              [-13.69093095523795, -11.079392915252189],
              [-13.688750453999107, -11.082061425300788],
              [-13.686892186690178, -11.082537958322453],
              [-13.68655725138267, -11.085947622246938],
              [-13.68720370993767, -11.086720677790456],
              [-13.690309001720012, -11.088009949605908],
              [-13.69269788463712, -11.086708351927442],
              [-13.694286022055222, -11.087339460963308],
              [-13.697693837768899, -11.08762995893441],
              [-13.699965491352007, -11.088385502093836],
              [-13.701086586564521, -11.090306335033725],
              [-13.702152954254506, -11.094587500405668],
              [-13.702267741170557, -11.096440426787682],
              [-13.703334746542465, -11.098086435506774],
              [-13.703727094840515, -11.099776638916225],
              [-13.70469891099126, -11.101069258715388],
              [-13.706145074757782, -11.099951517034295],
              [-13.708085442514982, -11.10130248755531],
              [-13.709306949916213, -11.101546380312183],
              [-13.71154383972079, -11.098554626334565],
              [-13.713707206215101, -11.096673014919647],
              [-13.714533218526817, -11.096855908763406],
              [-13.716368385669533, -11.0945951800992],
              [-13.719713375228816, -11.093067114385073],
              [-13.720316999754429, -11.091992386910633],
              [-13.724404903540561, -11.089585198730227],
              [-13.72562300475757, -11.089389333498689],
              [-13.727565701581828, -11.08763962167866],
              [-13.727640303519113, -11.083449061672415],
              [-13.728618639979747, -11.082335267609167],
              [-13.730038822485142, -11.083491173949762],
              [-13.730860762804896, -11.080478228821768],
              [-13.730634991074709, -11.077293596691186],
              [-13.731103518375035, -11.075261319145596],
              [-13.73231837292535, -11.073058591950529],
              [-13.732927955102486, -11.070147510186231],
              [-13.73262380730393, -11.06962248281664],
              [-13.734485008222075, -11.066425111664806],
              [-13.734327551582009, -11.065580576853604],
              [-13.73500539059869, -11.063244447501475],
              [-13.73605386260323, -11.061036064252864],
              [-13.734623260845082, -11.059295675686691],
              [-13.734122135459353, -11.055626073967572],
              [-13.735040207617818, -11.053438865306637],
              [-13.733071136146995, -11.052036479448208],
              [-13.73287307611173, -11.051017627860514],
              [-13.731365962942542, -11.037159742288145]
            ]
          ],
          [
            [
              [-13.793627935574246, -10.96605917856216],
              [-13.793481683238594, -10.963765368550954],
              [-13.792853551899864, -10.962565425997662],
              [-13.788851785740041, -10.966103109848893],
              [-13.787244251940521, -10.969544784932],
              [-13.78551109554497, -10.970053282517487],
              [-13.783300129534053, -10.971998490723944],
              [-13.781360544762853, -10.974191744648357],
              [-13.779099323996247, -10.975258282338444],
              [-13.777064738943547, -10.977802491287079],
              [-13.774551665150724, -10.980311822559518],
              [-13.772943290723255, -10.982281907354292],
              [-13.771809405520322, -10.984238055195162],
              [-13.76827662314736, -10.9883179397981],
              [-13.765291526140116, -10.992296751925796],
              [-13.763243988029593, -10.994106100054784],
              [-13.767443107696193, -10.99609552610768],
              [-13.768284265616353, -10.996861256318352],
              [-13.769277537140223, -10.99530902455213],
              [-13.773010493340417, -10.991182021561675],
              [-13.774044572944215, -10.98960014864064],
              [-13.776909376066254, -10.986594345907722],
              [-13.777139367448937, -10.985826082748517],
              [-13.780083956096274, -10.983625759366017],
              [-13.780966358659313, -10.981582138938842],
              [-13.78200136185572, -10.980222763685228],
              [-13.78467812757496, -10.978166182624909],
              [-13.784940110962593, -10.97596200591978],
              [-13.78580318231424, -10.974640976970058],
              [-13.786150291243503, -10.972846876762528],
              [-13.787773904760124, -10.972813281852176],
              [-13.789885846987014, -10.971464596372098],
              [-13.790162920322828, -10.970608201283989],
              [-13.792638732953176, -10.96795461560233],
              [-13.793627935574246, -10.96605917856216]
            ]
          ],
          [
            [
              [-13.80568257126426, -10.933510454674954],
              [-13.804012579694744, -10.933293396574228],
              [-13.800571965889867, -10.936038316440385],
              [-13.799098312357067, -10.935766217400042],
              [-13.796939040271312, -10.937769291836236],
              [-13.796574704373556, -10.938978375169883],
              [-13.798973042818231, -10.940076026309562],
              [-13.800682954665717, -10.938365791727149],
              [-13.802907134592195, -10.935244980227187],
              [-13.80568257126426, -10.933510454674954]
            ]
          ],
          [
            [
              [-13.804675399067897, -10.974304963818295],
              [-13.802795527474887, -10.973940375740245],
              [-13.801444142021628, -10.974979269757382],
              [-13.801562576280645, -10.976845535895624],
              [-13.804036138190105, -10.975683798178729],
              [-13.804675399067897, -10.974304963818295]
            ]
          ],
          [
            [
              [-13.816186793770203, -10.95842515313727],
              [-13.816133754079663, -10.9571648209598],
              [-13.813384773670512, -10.95830723849532],
              [-13.812461344556748, -10.959762004772262],
              [-13.810281246621814, -10.961065617277782],
              [-13.808793662987604, -10.961408269156157],
              [-13.806578817674202, -10.960200443116998],
              [-13.803821421414806, -10.960506032568075],
              [-13.803893338688804, -10.962222867508999],
              [-13.802457489832836, -10.965200259683112],
              [-13.80091104716261, -10.966137231034052],
              [-13.79968088435704, -10.965870291923506],
              [-13.797297937013735, -10.966430639020734],
              [-13.795773480334008, -10.9680438649742],
              [-13.795746626750228, -10.968884724261759],
              [-13.798534300199803, -10.970138874864226],
              [-13.802960252274246, -10.96909697633518],
              [-13.804352571754686, -10.96927594474036],
              [-13.806710712846968, -10.968796196622364],
              [-13.80903095247919, -10.967233946664042],
              [-13.811573378045164, -10.964173887740131],
              [-13.814238206705207, -10.961908112532369],
              [-13.81586241463873, -10.959570549473858],
              [-13.816186793770203, -10.95842515313727]
            ]
          ],
          [
            [
              [-13.820166180386865, -10.953469153889035],
              [-13.817024484838528, -10.955121987562205],
              [-13.818204305378929, -10.955786911940402],
              [-13.8194748477809, -10.954809948924254],
              [-13.820166180386865, -10.953469153889035]
            ]
          ],
          [
            [
              [-13.886185051632067, -10.81426754325868],
              [-13.848687268281717, -10.804146382481646],
              [-13.84767028064398, -10.80397840213191],
              [-13.845466995976434, -10.805341323555439],
              [-13.766296269611574, -10.78311592648038],
              [-13.740398916687838, -10.775719501131716],
              [-13.738280328151673, -10.774610069132946],
              [-13.73675851965074, -10.775181273609908],
              [-13.736738045402353, -10.788654011239672],
              [-13.716824682837643, -10.805178224743674],
              [-13.657779814739634, -10.821127256702598],
              [-13.631069720577479, -10.8266080117301],
              [-13.606135368660803, -10.848757505824763],
              [-13.59565133011673, -10.858037212393178],
              [-13.560305916011261, -10.879292453447453],
              [-13.547897769067507, -10.885502932484956],
              [-13.519052477631307, -10.899867393593977],
              [-13.529121600463926, -10.918537705556362],
              [-13.49693970323704, -10.948737514985362],
              [-13.478456293344669, -10.960720586792405],
              [-13.453430956536183, -10.979373709259615],
              [-13.453895217580175, -10.980658544428252],
              [-13.494175337177882, -11.09157427298814],
              [-13.49536066652795, -11.088106086522806],
              [-13.498794008333165, -11.082784898383471],
              [-13.49927525442317, -11.081155144410754],
              [-13.49893166696777, -11.079359750171436],
              [-13.501376669455908, -11.076517355305379],
              [-13.5022734297263, -11.076887809095318],
              [-13.502994068836102, -11.079803754144152],
              [-13.503390069002018, -11.083440585133744],
              [-13.501236568686672, -11.087242909835892],
              [-13.500943435760515, -11.090438847602542],
              [-13.500297263782532, -11.093297167958204],
              [-13.498968502784779, -11.096263550385832],
              [-13.497749251469894, -11.098031325328071],
              [-13.498545032395757, -11.100151928940722],
              [-13.49994112978164, -11.100129497874727],
              [-13.505005331959609, -11.096770575560578],
              [-13.507872987344317, -11.093186527798432],
              [-13.50850714032662, -11.095666483333332],
              [-13.507952905872044, -11.097959854114759],
              [-13.506551413242203, -11.100584839774985],
              [-13.504367193388605, -11.103195744113778],
              [-13.50250985443013, -11.104217872393102],
              [-13.500672877651134, -11.105749089217797],
              [-13.499884945294827, -11.107041344950876],
              [-13.507243269561531, -11.12684210250153],
              [-13.507175712118181, -11.12706773517211],
              [-13.510070969415002, -11.12677053903679],
              [-13.51356067215679, -11.124419745440749],
              [-13.517533138931359, -11.118973075013795],
              [-13.519976642531638, -11.1171212802082],
              [-13.520188706060617, -11.11531524312386],
              [-13.520970503811338, -11.113455164556422],
              [-13.522569402499872, -11.112944058757169],
              [-13.523931169277153, -11.111583274033572],
              [-13.524907594985088, -11.109692564109844],
              [-13.526554028225663, -11.109607070556555],
              [-13.527533760252556, -11.108859354074323],
              [-13.529327054850153, -11.10658212253062],
              [-13.53066778855759, -11.103983618522719],
              [-13.531505365788325, -11.103100930250518],
              [-13.533423071789814, -11.102596983797298],
              [-13.535305220488743, -11.099892533363144],
              [-13.53766291326737, -11.098483573873134],
              [-13.538178204810674, -11.097266010505335],
              [-13.540050329028958, -11.095744824660336],
              [-13.54131581560302, -11.095541862605142],
              [-13.542791306660474, -11.094536989427745],
              [-13.54394071144266, -11.092384107463534],
              [-13.547572965193524, -11.089536831343644],
              [-13.549093803550823, -11.088819808433767],
              [-13.55174991225183, -11.082881571448672],
              [-13.551424788941313, -11.081658308201666],
              [-13.548873201750844, -11.078962092321454],
              [-13.549760172392157, -11.076838025898304],
              [-13.549508084776757, -11.076107761399726],
              [-13.546695123809837, -11.071783583834907],
              [-13.545202080538079, -11.070686783590611],
              [-13.543082962633372, -11.067803824574998],
              [-13.540797374218908, -11.064004856111472],
              [-13.539943410682016, -11.063650251169934],
              [-13.537835732981653, -11.06594629933677],
              [-13.535698218403454, -11.068983493568956],
              [-13.534549316617873, -11.07213418861832],
              [-13.532611282581989, -11.072855836130133],
              [-13.530936229185462, -11.075343916559723],
              [-13.528901142462228, -11.077083410945708],
              [-13.52725279860205, -11.076755937780483],
              [-13.526051548980073, -11.077477635925646],
              [-13.523247030472891, -11.077156251941048],
              [-13.522616744202796, -11.075958519410719],
              [-13.52373229719924, -11.072203406141828],
              [-13.526194695244934, -11.070142133823824],
              [-13.528542793079867, -11.066611396449508],
              [-13.528334938839173, -11.064202449290102],
              [-13.532144094282106, -11.060238696531131],
              [-13.534377012666623, -11.058882329880522],
              [-13.53656942132955, -11.055784678172902],
              [-13.538580100500074, -11.0545419515009],
              [-13.5420060182563, -11.05405436743223],
              [-13.543357473586447, -11.052738271297585],
              [-13.544417708480808, -11.048254081520051],
              [-13.546096639822764, -11.045455843066124],
              [-13.548497037511163, -11.044424975053069],
              [-13.55157469318133, -11.048462630176124],
              [-13.55397485192914, -11.050019556746452],
              [-13.552297560478385, -11.051956453655452],
              [-13.551131476637185, -11.057186625832953],
              [-13.545843571376178, -11.060330920704228],
              [-13.547248779590952, -11.06299215317289],
              [-13.551895384921675, -11.067333330367738],
              [-13.554153627176103, -11.070938656759688],
              [-13.555417922417156, -11.070008008565862],
              [-13.55878527774768, -11.074908356461432],
              [-13.560061027414552, -11.077846840341508],
              [-13.561848288586189, -11.078167344715935],
              [-13.564237534882096, -11.077898560406986],
              [-13.568147576400607, -11.076321465178468],
              [-13.572320042657072, -11.073187975307988],
              [-13.57536110463624, -11.071360601169662],
              [-13.578762394138007, -11.068113230934495],
              [-13.580217460848663, -11.068602875203656],
              [-13.583707532812717, -11.06571660930276],
              [-13.583851768095057, -11.06453464193835],
              [-13.586718962954665, -11.064046886781066],
              [-13.588217734631742, -11.062506421892294],
              [-13.590153814472476, -11.061325977613972],
              [-13.591701273655126, -11.058757188439934],
              [-13.59254236653284, -11.059149274537432],
              [-13.593879719817705, -11.057242934684753],
              [-13.596430276901646, -11.057021199802714],
              [-13.59837386321512, -11.057702720263956],
              [-13.59943922501374, -11.054036123578879],
              [-13.60479752913693, -11.047234388660046],
              [-13.605771352364277, -11.045310090253357],
              [-13.606765674253463, -11.040992259136372],
              [-13.609679453372047, -11.039748866891356],
              [-13.610260619579533, -11.038340769577788],
              [-13.610104484213009, -11.036799396308922],
              [-13.607926456795663, -11.036002368694243],
              [-13.60802916548469, -11.034223114379369],
              [-13.609515564537032, -11.033724124608298],
              [-13.610950842036814, -11.032078301132104],
              [-13.613230376140534, -11.027024963299903],
              [-13.613494321407211, -11.02502448257043],
              [-13.61569073506561, -11.023430218456083],
              [-13.617678172085302, -11.018427854266852],
              [-13.617047061944083, -11.016654557989925],
              [-13.617510156042837, -11.01562023055454],
              [-13.617915790648775, -11.012445170125021],
              [-13.619901885559601, -11.009479606238877],
              [-13.618283706045439, -11.00808504480427],
              [-13.61713387967875, -11.005206790847444],
              [-13.615988481843024, -11.003910540184064],
              [-13.616268462565962, -11.002008735276844],
              [-13.617122544261024, -11.001184879926575],
              [-13.617022248086293, -10.999619539257878],
              [-13.618681614744157, -10.996242406481837],
              [-13.619089053695658, -10.994516385280445],
              [-13.620321204546253, -10.991913126300167],
              [-13.622569156163248, -10.990431011518128],
              [-13.624014899940441, -10.988886138450766],
              [-13.626014692254275, -10.987464298084639],
              [-13.625021741450043, -10.986125874245744],
              [-13.622718093588013, -10.98547109307978],
              [-13.617706972776016, -10.981106107313378],
              [-13.616775258446069, -10.9800110983014],
              [-13.613968390700517, -10.978208758771716],
              [-13.612389725966716, -10.97569882629049],
              [-13.612809383297613, -10.97235585537235],
              [-13.611143310719452, -10.970991114226802],
              [-13.609958881594828, -10.968826950751666],
              [-13.612902053748215, -10.967022153902802],
              [-13.614313873194687, -10.96515538430363],
              [-13.618180380639197, -10.963452496601073],
              [-13.619219510484482, -10.962328361185493],
              [-13.618827380006367, -10.959822816359727],
              [-13.619596826267864, -10.955375945390834],
              [-13.620567778859073, -10.955042153623495],
              [-13.623578665099359, -10.95200053702302],
              [-13.626745941989915, -10.946444446990489],
              [-13.627253861906269, -10.943542146995776],
              [-13.629299653678618, -10.942682131645945],
              [-13.631600558211066, -10.945045447854216],
              [-13.63117640309905, -10.947253748152727],
              [-13.630249016517235, -10.949759332816582],
              [-13.630488354403347, -10.950731556076242],
              [-13.630095373181613, -10.953130075113917],
              [-13.6300588303713, -10.956852447857301],
              [-13.629626109135215, -10.957935610663554],
              [-13.6295968310018, -10.960626468010263],
              [-13.62891520248702, -10.96235424368812],
              [-13.627483491847109, -10.96862640558856],
              [-13.62781954978068, -10.969584138363366],
              [-13.629561405270156, -10.970563717777331],
              [-13.632822573094883, -10.974390370320414],
              [-13.632991766381592, -10.976260750575664],
              [-13.634534756847813, -10.978958471287843],
              [-13.63706402552186, -10.981485846157705],
              [-13.639273425427575, -10.982289932192929],
              [-13.639190407135745, -10.98357087707538],
              [-13.637563606594814, -10.984250074422539],
              [-13.63818275020747, -10.986780147210478],
              [-13.637734890874741, -10.989078149177578],
              [-13.63823215127179, -10.990400040447591],
              [-13.637126304451028, -10.99159799550048],
              [-13.636692640617818, -10.993269781295972],
              [-13.635274242734793, -10.993426687829466],
              [-13.63226490180923, -10.994734918466442],
              [-13.628314018642964, -10.997271531528561],
              [-13.62659217184467, -10.998824756032004],
              [-13.625940235916417, -11.000025606923368],
              [-13.62525986148322, -11.003203964386515],
              [-13.627884535909342, -11.00517281943986],
              [-13.629900017851792, -11.005738123063288],
              [-13.63045680730205, -11.007892463643108],
              [-13.63041236234262, -11.01036207542348],
              [-13.629827166343068, -11.013390364765955],
              [-13.629462062326613, -11.017028271378582],
              [-13.632151493321135, -11.016034852028712],
              [-13.633358173473098, -11.016851364052567],
              [-13.63686220467792, -11.016464828479803],
              [-13.639070623646509, -11.0181696168962],
              [-13.642019560241124, -11.019555158742016],
              [-13.648129812847145, -11.02369728218347],
              [-13.649128348960863, -11.02620976524237],
              [-13.65165550391734, -11.027194683135322],
              [-13.653481599781392, -11.027451801409704],
              [-13.654931852580816, -11.027094616171286],
              [-13.658040746730528, -11.027530875248006],
              [-13.65889696230961, -11.028212348579904],
              [-13.660603165780097, -11.0276667933329],
              [-13.662638526793273, -11.028321382352356],
              [-13.665467341370398, -11.027927536280702],
              [-13.671260118180482, -11.026172050800257],
              [-13.672390612939465, -11.025597986392912],
              [-13.676594725134285, -11.024553286754728],
              [-13.680365215504414, -11.025496992146696],
              [-13.68366155534481, -11.024134659785254],
              [-13.686027114858089, -11.024748679969358],
              [-13.687403160597592, -11.023986235446412],
              [-13.69131482923395, -11.025058932980427],
              [-13.692613952475103, -11.026616370472363],
              [-13.69284296494668, -11.028416507457878],
              [-13.694058605484647, -11.028442115716274],
              [-13.69427279188747, -11.030736695756982],
              [-13.6976604944926, -11.030693988882229],
              [-13.700643763633979, -11.030168884559867],
              [-13.702785186569562, -11.030627550314545],
              [-13.710205007340742, -11.030527800627695],
              [-13.710771983777367, -11.029560539270163],
              [-13.715043497533161, -11.027669590096677],
              [-13.717842889260195, -11.027009678399851],
              [-13.719272211988626, -11.02699482308376],
              [-13.720109203325078, -11.025112385608923],
              [-13.722022975611312, -11.02347155344463],
              [-13.72319838346926, -11.023052736232517],
              [-13.725789900594021, -11.02053205107273],
              [-13.729374227245193, -11.018484013423429],
              [-13.731211961048464, -11.015742466585117],
              [-13.73331144898799, -11.013483173655992],
              [-13.734987169700437, -11.012313035912598],
              [-13.734872668407087, -11.010302523905446],
              [-13.732790392615811, -11.009376108286503],
              [-13.732917981923425, -11.007616837324928],
              [-13.731719878500789, -11.00766854839815],
              [-13.730000920696497, -11.004512708918547],
              [-13.72823813658481, -11.003140110404841],
              [-13.724919804496851, -11.001353901986691],
              [-13.723309915971397, -11.000968684890749],
              [-13.722323924879207, -10.999734422583133],
              [-13.72350931355574, -10.997793751013923],
              [-13.724708967435346, -10.994914625374065],
              [-13.725844209741702, -10.994620777979376],
              [-13.730174330104875, -10.996093681032276],
              [-13.731623699454364, -10.99463200543479],
              [-13.733307828687504, -10.988196594801519],
              [-13.73438253998793, -10.986008736210874],
              [-13.734443287102009, -10.984770656036677],
              [-13.735747551137413, -10.982284714864512],
              [-13.736905266841323, -10.98235674484482],
              [-13.738605756803556, -10.984516092511138],
              [-13.742878476176577, -10.985682565810949],
              [-13.742681322863444, -10.98871964532648],
              [-13.744780383757124, -10.98763098301903],
              [-13.745333744323409, -10.988645000624409],
              [-13.746582608182809, -10.9880134814351],
              [-13.748610416945649, -10.988609338076957],
              [-13.749404498257519, -10.990286478228535],
              [-13.75072352876934, -10.989909687778042],
              [-13.753753795038907, -10.987915959692252],
              [-13.755508796567357, -10.988445511354684],
              [-13.75897105368214, -10.986861403706033],
              [-13.759643789271978, -10.98594816650654],
              [-13.758158424443405, -10.985071401866001],
              [-13.755347933995589, -10.985622664975585],
              [-13.754756424805464, -10.98388331733921],
              [-13.757533434195123, -10.982047717028147],
              [-13.758010692832826, -10.981112237512411],
              [-13.75950918485579, -10.980836650877974],
              [-13.760845231109613, -10.97804526212536],
              [-13.759731283981646, -10.97716727279705],
              [-13.758739253925016, -10.979310028000189],
              [-13.758019152017667, -10.979143898790758],
              [-13.759467548557073, -10.975269621045284],
              [-13.760299841433792, -10.973722537260889],
              [-13.761423133903872, -10.974498652078724],
              [-13.763273773606718, -10.970340813240352],
              [-13.764180124327178, -10.969442595604562],
              [-13.766706919905932, -10.964545243639217],
              [-13.768803788179655, -10.96193775461799],
              [-13.768891290944199, -10.958834668479021],
              [-13.770884761926613, -10.957629513023743],
              [-13.772748432294636, -10.95491188022638],
              [-13.771506134129092, -10.953342515150334],
              [-13.773204090784459, -10.952811280116375],
              [-13.773793299125979, -10.951911126300658],
              [-13.77536688829278, -10.952236804953575],
              [-13.775823206999108, -10.951476568065491],
              [-13.777960512730532, -10.950983863421083],
              [-13.78028744210612, -10.949117249908713],
              [-13.782172694777064, -10.950202663428724],
              [-13.783106078723737, -10.948086324347466],
              [-13.782131187642886, -10.94414205375847],
              [-13.783518984347264, -10.942538679999148],
              [-13.786512613799855, -10.941893976666906],
              [-13.788133050300486, -10.941161455867316],
              [-13.789577427225753, -10.939217781784821],
              [-13.793952365902493, -10.935184955395126],
              [-13.796119503168429, -10.9327840166544],
              [-13.798207566693051, -10.931764429045057],
              [-13.801499361323186, -10.92824311936214],
              [-13.802633533182481, -10.926123044278036],
              [-13.803792431467683, -10.926013932375666],
              [-13.804845337223897, -10.92476116281499],
              [-13.807072282792015, -10.923047821753038],
              [-13.808536318626677, -10.923671851088145],
              [-13.811263826472226, -10.921004392351657],
              [-13.812201765755393, -10.917815047014864],
              [-13.814005538418717, -10.917541535753385],
              [-13.81663701393228, -10.914216884285814],
              [-13.816617204286885, -10.913000706856282],
              [-13.818332721685445, -10.912073934971133],
              [-13.82502993896885, -10.90360676959657],
              [-13.825014608698554, -10.902532894793408],
              [-13.823792323766275, -10.901522751733815],
              [-13.821262420861872, -10.90216783992657],
              [-13.820394927614563, -10.900717417335395],
              [-13.818823350148657, -10.901461789489646],
              [-13.816249850984976, -10.899140622076184],
              [-13.81477795620506, -10.899223389605813],
              [-13.81327334274676, -10.89869814006089],
              [-13.817865697412476, -10.89403386300428],
              [-13.819708303950442, -10.892870689829751],
              [-13.821422280314586, -10.888661630237477],
              [-13.821060108593375, -10.886392774052654],
              [-13.82183287129435, -10.885222975298465],
              [-13.820138528809112, -10.88244303170971],
              [-13.820748630127987, -10.880712239405009],
              [-13.822538177535584, -10.879319774156476],
              [-13.822107929397989, -10.87529688026073],
              [-13.824022620439633, -10.871463305150794],
              [-13.824391436453041, -10.869044261058818],
              [-13.825940861684641, -10.866125982121718],
              [-13.827130289600865, -10.865895012631917],
              [-13.829482547745327, -10.86626616942188],
              [-13.830000948532025, -10.86468916582326],
              [-13.83493341836786, -10.860935986201046],
              [-13.836073144480098, -10.860867244403572],
              [-13.837888671962737, -10.859887424502435],
              [-13.838134443298221, -10.858321063579098],
              [-13.836224348909841, -10.854095939011184],
              [-13.83493543466259, -10.852129846098684],
              [-13.8359010829694, -10.850551671664121],
              [-13.838725920484338, -10.851834702911031],
              [-13.840716567947954, -10.853887289207048],
              [-13.840865388211123, -10.857836015624542],
              [-13.840323102627046, -10.86013390101224],
              [-13.839140950337331, -10.862346872239565],
              [-13.838680928631048, -10.864096469969102],
              [-13.8373147044838, -10.865387925225686],
              [-13.83927582486559, -10.86661056320643],
              [-13.83896049072637, -10.868109259225768],
              [-13.837423722101919, -10.870205746421194],
              [-13.838354917175925, -10.870736743580652],
              [-13.842281888121068, -10.867711869267762],
              [-13.843825535075279, -10.86824622532157],
              [-13.841866170740719, -10.870779797280163],
              [-13.840171416557565, -10.87486951930424],
              [-13.838041668689414, -10.876853283703948],
              [-13.837942956470405, -10.879049588047694],
              [-13.839975102908777, -10.880839935706867],
              [-13.836085227714985, -10.886257122253747],
              [-13.836848992964029, -10.886695643556152],
              [-13.839355482068273, -10.88431860938542],
              [-13.84041292850265, -10.883780913179837],
              [-13.841877091520573, -10.882031191209515],
              [-13.842532667016194, -10.88208708399306],
              [-13.844470785963889, -10.879499349836845],
              [-13.846688074991583, -10.878675645392063],
              [-13.847692900315932, -10.877503872926065],
              [-13.847658520275138, -10.876474724321495],
              [-13.848672020979956, -10.874728943239523],
              [-13.850208592267895, -10.873931460417689],
              [-13.852005526916647, -10.871659047047801],
              [-13.851955208410603, -10.870626432514719],
              [-13.85452404381098, -10.869131394800634],
              [-13.857045387489059, -10.866160099678181],
              [-13.85868212580196, -10.865170101754197],
              [-13.861867438533684, -10.862281107554145],
              [-13.862960380427413, -10.862064304527099],
              [-13.864719482362869, -10.860358244740542],
              [-13.865702703800169, -10.86015579211661],
              [-13.868969590801262, -10.855831365471905],
              [-13.869898828719368, -10.853755972233646],
              [-13.871163073585262, -10.852315476903277],
              [-13.870321501096688, -10.850829360840526],
              [-13.870608229845576, -10.845656703439142],
              [-13.871703894129611, -10.844072725677945],
              [-13.871889794282733, -10.842846043636198],
              [-13.874394354339769, -10.83937135222958],
              [-13.874413267708709, -10.837655907045395],
              [-13.876404644303404, -10.835756311250607],
              [-13.876529882384473, -10.834733586703946],
              [-13.878551790893464, -10.832578458349992],
              [-13.880270630796398, -10.829940439416],
              [-13.881228550179495, -10.82915999480216],
              [-13.882657325981825, -10.826751063943771],
              [-13.884017336149517, -10.823292588831217],
              [-13.883967149560824, -10.821083834736585],
              [-13.885411353396801, -10.817488386878402],
              [-13.886185051632067, -10.81426754325868]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -134.17321508652276,
          "lat": 58.45461263004152
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02110"],
        "coty_name": ["Juneau"],
        "coty_area_code": "USA",
        "coty_type": "city and borough",
        "coty_name_long": ["Juneau City and Borough"],
        "coty_fp_code": "110",
        "coty_gnis_code": "01419971"
      },
      "bbox": [
        -13.886185051632067, -11.12706773517211, -13.453430956536183,
        -10.774610069132946
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5642308322079228, -2.2149504691715425],
            [1.6109097879725103, -2.214175026485112],
            [1.6426121190487257, -2.213972659914814],
            [1.7686206682903076, -2.211516787747053],
            [1.841693346576116, -2.2105942568410217],
            [1.9680992153863486, -2.208838738620227],
            [1.9948336274963112, -2.208158617982089],
            [2.0886954859050073, -2.2062156840250617],
            [2.162333814476749, -2.204527315472288],
            [2.1637883354874567, -2.27462382174949],
            [2.1643956804255895, -2.3100012680399358],
            [2.16288394047734, -2.3179499717314784],
            [2.159907367333097, -2.3105971661169646],
            [2.1525446483781536, -2.3102741967277503],
            [2.150724782055622, -2.312433392206308],
            [2.152415276650232, -2.319064557414863],
            [2.1492939879225954, -2.3216481411860035],
            [2.1473068894401597, -2.3296503308854546],
            [2.149773037520686, -2.332380049333346],
            [2.1523213339022056, -2.3285168722217207],
            [2.156486808579927, -2.336271061421951],
            [2.1634084288817186, -2.332362266237588],
            [2.1650866634321257, -2.347119714634558],
            [2.166338969391174, -2.3484445034691084],
            [2.1655201570229505, -2.356008098124689],
            [2.1669424943484774, -2.356972929093499],
            [2.1683444333833126, -2.3653653025206323],
            [2.170754524697264, -2.36825088525991],
            [2.1748064716858413, -2.367728863783835],
            [2.182896694249274, -2.3777332459310703],
            [2.1861683072710276, -2.3797735794836385],
            [2.1932581609462467, -2.3813001346227196],
            [2.193784088566576, -2.3912936441685684],
            [2.1978875946923906, -2.3919283846585926],
            [2.2025634047003204, -2.395091004032124],
            [2.2039504907068412, -2.3917553497893222],
            [2.2078870364151646, -2.3909931378084717],
            [2.2078814209158963, -2.3974456557159414],
            [2.164836812721026, -2.3976031469720995],
            [2.1648435143891724, -2.4107828582240214],
            [2.165776778928328, -2.4707470535626284],
            [2.151369248958641, -2.4707697689021977],
            [2.1379955009999696, -2.4704754727613696],
            [2.106250120774258, -2.470775797943077],
            [2.10746168824503, -2.4747541027901385],
            [2.102980829345144, -2.475238211707476],
            [2.098470703976215, -2.4739211735934985],
            [2.0963216356804457, -2.4769409651019636],
            [2.095956689474414, -2.4852058257445955],
            [2.090632690408137, -2.483681876090554],
            [2.0876960255502626, -2.480111432024543],
            [2.0842452088378995, -2.4788768288540837],
            [2.0817185790687947, -2.4826294568167326],
            [2.0818184130148625, -2.4917345633267636],
            [2.08363800644601, -2.4989994805486795],
            [2.0834793880792817, -2.5034056040319257],
            [2.0800784289108525, -2.5030180356464196],
            [2.077553512952199, -2.4969743977093217],
            [2.073248433499651, -2.496314213375986],
            [2.0661234219996363, -2.498260108562522],
            [2.0631167891788946, -2.4960045376037363],
            [2.060664886880046, -2.491455624186757],
            [2.056665456130843, -2.493106974840037],
            [2.054328858819994, -2.4914805289346633],
            [2.0541983446947487, -2.4871611758481036],
            [2.0582191354465724, -2.484523018916509],
            [2.0634859622233175, -2.484353857704758],
            [2.064316348674343, -2.480745527791707],
            [2.060337297153795, -2.4774471443285644],
            [2.051486953435054, -2.4794178784679906],
            [2.042599020767313, -2.4845192277253916],
            [2.0409467043930616, -2.4904037170887117],
            [2.0441449002212884, -2.49360935190725],
            [2.047857538745001, -2.4916872646674677],
            [2.0513550323623053, -2.495615612116157],
            [2.048384670100747, -2.5002003316717527],
            [2.0377477627120038, -2.5005231531234835],
            [2.016527399673541, -2.5001122438388985],
            [1.9521509407876874, -2.4999271600138853],
            [1.891961221620961, -2.499137038418767],
            [1.8671040653452615, -2.4991359582775377],
            [1.795608269584132, -2.4984522421094284],
            [1.7948585145155704, -2.5717654460402124],
            [1.7519411802239764, -2.5717849231087317],
            [1.7516358580463596, -2.615481982964835],
            [1.6956017104479406, -2.6153390809951222],
            [1.67987908938642, -2.6149907791817526],
            [1.622692738101908, -2.614798626450414],
            [1.613246050815706, -2.5546724724678302],
            [1.6057640904372632, -2.505361120757124],
            [1.592480239428368, -2.4157268496953335],
            [1.5860509791040935, -2.36965240217155],
            [1.578362923218654, -2.3128956611492226],
            [1.5753394996612762, -2.2929370990251527],
            [1.567827561976075, -2.238269310331657],
            [1.5642308322079228, -2.2149504691715425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.25614214008375, "lat": 36.33870616850017 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05007"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00069896"
      },
      "bbox": [
        1.5642308322079228, -2.615481982964835, 2.2078870364151646,
        -2.204527315472288
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.020262242267793, -4.541094446215802],
            [3.0624566350950637, -4.541743923280554],
            [3.0763622164131985, -4.543068007473659],
            [3.1909768287716354, -4.541415937154045],
            [3.2774673741085256, -4.540658607884077],
            [3.320689909361996, -4.540592254074422],
            [3.3428070644460033, -4.541398046151646],
            [3.3438832027269414, -4.54975117002831],
            [3.35157822658737, -4.552409894756664],
            [3.3588154078386037, -4.551056864443821],
            [3.3628390394310164, -4.548525508653176],
            [3.367152113240494, -4.551772355510767],
            [3.3703290672590973, -4.551663476840037],
            [3.371843333187317, -4.556197097425361],
            [3.3769425876046992, -4.556401509383123],
            [3.3814583166317105, -4.560792981387345],
            [3.3863047387698364, -4.557868921760713],
            [3.3950237726905987, -4.5577911558432245],
            [3.3998848342988377, -4.562044007990927],
            [3.403459045788753, -4.563036705072821],
            [3.406115517851283, -4.566237019645397],
            [3.416714635046458, -4.568464519693962],
            [3.4192704758436427, -4.574103771407698],
            [3.4192808013776976, -4.578790598254455],
            [3.4231642319700395, -4.576902908776184],
            [3.4347782426514977, -4.5859489876748105],
            [3.436775105503298, -4.590277856097902],
            [3.4421877101229836, -4.595481950405704],
            [3.4449084042587286, -4.603830702619603],
            [3.445150090015829, -4.60833554343559],
            [3.4595958308382873, -4.6145196725468995],
            [3.4657253742307983, -4.610882660787926],
            [3.467661130355187, -4.613888149181155],
            [3.4746582223766396, -4.617715365968835],
            [3.474890000429593, -4.621643470764026],
            [3.364134784197278, -4.628213162150733],
            [3.364006782980114, -4.713036029152946],
            [3.3801465705620397, -4.7127260081115745],
            [3.3789993385190202, -4.715723843114267],
            [3.3822656707088767, -4.717975771930437],
            [3.3838387040522906, -4.7238807797805835],
            [3.3904423732380944, -4.725747809718919],
            [3.391441419597779, -4.731903072351936],
            [3.394715245402942, -4.732070225469766],
            [3.399090376484177, -4.7351832708344945],
            [3.3996239863966213, -4.738762411631522],
            [3.4098753508353012, -4.743763759940609],
            [3.4109380127522018, -4.748810937592266],
            [3.4161472713568215, -4.752972728407726],
            [3.4200674393298436, -4.762007401850496],
            [3.4190089244830446, -4.764654495492611],
            [3.4219777695303866, -4.768496197172956],
            [3.428000295426197, -4.770214126930596],
            [3.430040692624955, -4.7789733109749735],
            [3.4285477397503263, -4.78339801560124],
            [3.4306586427985972, -4.785052335724642],
            [3.433669693064599, -4.791699842342461],
            [3.432842811215866, -4.796923088596974],
            [3.443290558197241, -4.806657045538005],
            [3.446602474158031, -4.815624998815443],
            [3.4507198222773625, -4.818378843939019],
            [3.458360934450016, -4.821508552392288],
            [3.4618860411551236, -4.82606848581486],
            [3.4691838689449725, -4.829227297208091],
            [3.4698176018081877, -4.835419246412285],
            [3.4722891645506757, -4.840440790763717],
            [3.477369111892104, -4.840179845219315],
            [3.4792018577715793, -4.8417650174180515],
            [3.482380121386633, -4.849313564220525],
            [3.4834277234850157, -4.85864434425816],
            [3.482526768535096, -4.861446314197566],
            [3.4836026584231625, -4.868796920402705],
            [3.4854493509971007, -4.87093578132244],
            [3.4810412070571064, -4.877439140907824],
            [3.485276773160994, -4.881767324025526],
            [3.4871714961210114, -4.886843176817911],
            [3.450451794775546, -4.8864254113773695],
            [3.3659899374899727, -4.886927398956859],
            [3.2818145350956502, -4.887204950298864],
            [3.2355702802419963, -4.887391311514406],
            [3.1791418451706663, -4.887933959048323],
            [3.138038384394592, -4.887936548477719],
            [3.090533653547391, -4.88813577911438],
            [3.040789847708215, -4.887955958499039],
            [3.0258327432728658, -4.8881584902522714],
            [3.0202567622536636, -4.882196089117815],
            [3.023911564338111, -4.875377839972588],
            [3.029464282365716, -4.874436609665475],
            [3.0292975442222247, -4.872049892731052],
            [3.0251621689774204, -4.86624244348969],
            [3.0367498147183607, -4.860737115298635],
            [3.038341007625685, -4.8579553146627665],
            [3.038581271853451, -4.8527360507284305],
            [3.0353912510361067, -4.8510548020497595],
            [3.033447414335442, -4.843653158964093],
            [3.027648127411767, -4.839281827476882],
            [3.0242061043886554, -4.841583535504945],
            [3.017302231402994, -4.840306675554985],
            [3.013651368264928, -4.834562812376313],
            [3.0180829835574765, -4.83014629300665],
            [3.013984402507178, -4.826082130775333],
            [3.0130927491827597, -4.820195204054898],
            [3.0153013717134307, -4.8189754718121565],
            [3.015031104718271, -4.814695425050202],
            [3.0085840863550155, -4.807910764057971],
            [3.0071853697868813, -4.804304951495594],
            [3.0095549797243932, -4.800250580676772],
            [3.0152368077080567, -4.7970930102631035],
            [3.0227210870032963, -4.795524611926042],
            [3.0214309962744, -4.792280008395916],
            [3.010740547707843, -4.79023681365694],
            [3.0087559953498197, -4.786807573103769],
            [3.0111262782510124, -4.784332999599801],
            [3.009277967460788, -4.779772251865515],
            [3.0008572861106533, -4.773771650180765],
            [3.001026253463579, -4.7693925017989836],
            [3.004081515909601, -4.769262555551918],
            [3.00520156403423, -4.765149901548364],
            [2.9998933625401687, -4.762911682706997],
            [2.999141730221785, -4.7670093660886765],
            [2.9953336805839545, -4.769683763723774],
            [2.9892618787375924, -4.767527736042935],
            [2.9872878216125303, -4.760457002133004],
            [2.992001134475913, -4.7539233868489195],
            [2.990697583017869, -4.750027456486149],
            [2.986579770144562, -4.751130346650334],
            [2.9839484104438796, -4.749392594868249],
            [2.984723254356253, -4.743244786199086],
            [2.9817927763772976, -4.7380014588855],
            [2.9837894514922185, -4.731714802404999],
            [2.9798294047660536, -4.73035505439437],
            [2.9743834416516997, -4.7364737869556075],
            [2.971666642169872, -4.7293957806994085],
            [2.966364409750771, -4.7289020354423155],
            [2.9644945488662042, -4.7255017341514405],
            [2.970725349832581, -4.72202475866239],
            [2.974049893585573, -4.712778124523313],
            [3.0202575422503157, -4.714345002072085],
            [3.020157534516171, -4.598852681869268],
            [3.019980419503499, -4.58445395411518],
            [3.020262242267793, -4.541094446215802]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.65431315249242, "lat": 33.96990665766794 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05039"],
        "coty_name": ["Dallas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dallas County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00066849"
      },
      "bbox": [
        2.9644945488662042, -4.8881584902522714, 3.4871714961210114,
        -4.540592254074422
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.795557084721673, -2.78767309025478],
            [3.869171402834807, -2.7081921972501495],
            [3.903650667411381, -2.7077192740937117],
            [3.925627238181956, -2.707435125446109],
            [3.9256365408919875, -2.708433758285033],
            [4.025317986391655, -2.70570085002828],
            [4.087621299370293, -2.704664598557648],
            [4.102100942061662, -2.703487574720233],
            [4.102994708533656, -2.7481546020544325],
            [4.130911623514398, -2.7476090753455775],
            [4.1890865957159065, -2.7459058252194004],
            [4.277177568110387, -2.7414050188985413],
            [4.316489616121401, -2.7402200662528364],
            [4.31659483982695, -2.7466341022586804],
            [4.311604867340631, -2.7457655842595408],
            [4.306881181633323, -2.7476529094536426],
            [4.310373926683289, -2.7549710649833568],
            [4.307233356468265, -2.7556632497175433],
            [4.305874535153029, -2.749543595383177],
            [4.302921665289075, -2.748581992131509],
            [4.301168591662845, -2.7526509099917207],
            [4.30428611574486, -2.757814108553427],
            [4.304857813823989, -2.762946888418552],
            [4.308718467806284, -2.7669390198806947],
            [4.306238641726467, -2.7730388914926793],
            [4.301795971110006, -2.7740769198107302],
            [4.299922860342355, -2.7797372217360294],
            [4.303466576159274, -2.781947974157202],
            [4.2944651157669, -2.7887262573047416],
            [4.292833295972028, -2.7952380211269148],
            [4.288140020014508, -2.7991307288276284],
            [4.285047858267949, -2.7976203255372982],
            [4.280295093976385, -2.797976138510577],
            [4.279807301900353, -2.802496612463869],
            [4.285886155101014, -2.8039233716189043],
            [4.2921547600268815, -2.8093124349523846],
            [4.287215963760484, -2.8110575591445763],
            [4.289382656756383, -2.815418833208843],
            [4.29362897182485, -2.8155773824944546],
            [4.293187874728248, -2.8194788902572543],
            [4.283554634588034, -2.8196403915115913],
            [4.280027334584614, -2.820940973560248],
            [4.277357935211962, -2.82440160743531],
            [4.2745333662304805, -2.824813052013698],
            [4.271508531916565, -2.8222482030720664],
            [4.2707072365237675, -2.829448274514713],
            [4.278423120802756, -2.829365059258286],
            [4.281834870570764, -2.833458368357377],
            [4.275122214783628, -2.8357978067291696],
            [4.269117663608761, -2.8408180098684386],
            [4.265893831863864, -2.8416435601846173],
            [4.2627514360941605, -2.845718408369459],
            [4.25816704737807, -2.8412880232864874],
            [4.255275999411165, -2.842253007384527],
            [4.255210886065278, -2.8484018993897733],
            [4.249990085957322, -2.852295684411671],
            [4.253208255096506, -2.858824608729662],
            [4.247480313422037, -2.8630924204656014],
            [4.249635719153645, -2.867444905045709],
            [4.24788291301828, -2.8693380052064943],
            [4.241205831955727, -2.868397876906352],
            [4.233160915630648, -2.869323859562441],
            [4.230901553737626, -2.871596724187442],
            [4.232950528212312, -2.8789749991135456],
            [4.226394939236656, -2.880768203423654],
            [4.227389474683149, -2.887002674397297],
            [4.221517669335018, -2.8887001808958903],
            [4.219715398830302, -2.892718992193315],
            [4.215838680939905, -2.896334035269113],
            [4.219842516962897, -2.9005156396812475],
            [4.220960826244423, -2.9062959040410696],
            [4.216516112618492, -2.9122958373680023],
            [4.217902043084214, -2.9177067255072924],
            [4.213319421134096, -2.924051105745323],
            [4.210069421812688, -2.924096351766736],
            [4.209683156929485, -2.9179533466205707],
            [4.204813954363201, -2.918139224664413],
            [4.20564131916343, -2.924052803950932],
            [4.20078792388099, -2.928450123393982],
            [4.202278736792467, -2.93292976095342],
            [4.199362158089506, -2.9361879380864684],
            [4.200874731858281, -2.9434804644215946],
            [4.204807815147471, -2.9454030032284266],
            [4.2074464487576595, -2.9490897831756047],
            [4.20768916739753, -2.957404699344978],
            [4.203026010743035, -2.959675800939691],
            [4.211763953198315, -2.9665277314228358],
            [4.2082158188787435, -2.971212286278307],
            [4.209271431111007, -2.9729131127697954],
            [4.214958341841491, -2.9722683558402334],
            [4.216285571129971, -2.9748829683665226],
            [4.214046997475297, -2.9808574589186065],
            [4.2143170424817225, -2.984729493748179],
            [4.217075227520629, -2.9869601615140953],
            [4.221832810788342, -2.987954570624632],
            [4.229439043136429, -2.9913812975312037],
            [4.2291211022826705, -2.9993227507658182],
            [4.224179313569358, -2.999598919315316],
            [4.217843170695525, -2.997823503880072],
            [4.212731941686424, -3.0006899541652907],
            [4.206781415930108, -3.0005573648415984],
            [4.202332275603171, -2.9967977954774105],
            [4.199460281718806, -2.9960612800347883],
            [4.19217152120352, -2.9987319185822434],
            [4.197178357055022, -3.1130678346386786],
            [4.112207422355229, -3.1163172549382394],
            [4.065096787133745, -3.1168939709372414],
            [4.0258298024901835, -3.1172220830669075],
            [3.972673116656625, -3.117694891860293],
            [3.923728772950829, -3.1189363673349324],
            [3.902220810372249, -3.119134203471871],
            [3.8552612352271636, -3.121176805522637],
            [3.8549642762177316, -3.1062917618058727],
            [3.853327655605224, -3.051372995550033],
            [3.8528340997563526, -3.0244904874592238],
            [3.8524028910553985, -3.016952945286295],
            [3.8514883710453836, -2.9725343968840408],
            [3.850488690818608, -2.9421524347067316],
            [3.8467761518360297, -2.9423277939491026],
            [3.8369926906214005, -2.950037833301676],
            [3.812578931893296, -2.950645278321677],
            [3.8114897756886483, -2.906473377863733],
            [3.8063864763790947, -2.8995988142005347],
            [3.800284947050769, -2.8938216438369415],
            [3.7944868641200613, -2.8917643261006445],
            [3.787795004467119, -2.8864587737757375],
            [3.7868778381889796, -2.883289643232467],
            [3.7868247029022357, -2.8740209513975072],
            [3.783583066473656, -2.866268776372063],
            [3.7822973796991715, -2.853482078911906],
            [3.7807766261959412, -2.8456003510762105],
            [3.7822163567450837, -2.838819780522661],
            [3.785293303386187, -2.8322635302124026],
            [3.7877022909683036, -2.8298746178983043],
            [3.7931053225102525, -2.8213814656183893],
            [3.796202477841919, -2.8108969424355865],
            [3.7949310986610065, -2.798684826913306],
            [3.795557084721673, -2.78767309025478]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.56975540784296,
          "lat": 35.741561045196576
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05063"],
        "coty_name": ["Independence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Independence County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00069163"
      },
      "bbox": [
        3.7807766261959412, -3.121176805522637, 4.31659483982695,
        -2.703487574720233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5328019692234127, -2.4011909680462193],
            [3.6109957782472777, -2.4002711536418397],
            [3.6891623165834297, -2.399199342273157],
            [3.7602592484643274, -2.396899734932583],
            [3.7888205892547666, -2.3965516642793068],
            [3.8310842334578834, -2.395591400993571],
            [3.861179637892364, -2.3945009556701184],
            [3.904666937928355, -2.3933853811295234],
            [3.906146279293103, -2.4378104299632266],
            [3.9204952332314233, -2.4376837901175534],
            [3.921871613016145, -2.481838599023953],
            [3.9178999363353957, -2.482041392355073],
            [3.918198624308481, -2.4977135581788605],
            [3.919623253612209, -2.532563322011419],
            [3.9229396442359814, -2.625149496059237],
            [3.919212551499521, -2.62521573592463],
            [3.919345654556581, -2.6289550530560075],
            [3.9156146513662775, -2.629168636969439],
            [3.9159004043090953, -2.636503010775417],
            [3.923268918445949, -2.636350391433965],
            [3.923616343462843, -2.6474927648371898],
            [3.901720409956153, -2.6480772430547113],
            [3.9028343492472994, -2.673189383304141],
            [3.903650667411381, -2.7077192740937117],
            [3.869171402834807, -2.7081921972501495],
            [3.795557084721673, -2.78767309025478],
            [3.7928455386430886, -2.7804189162652904],
            [3.7872922505316993, -2.774677746055868],
            [3.781469181379211, -2.7732562040969624],
            [3.77155950797625, -2.7757779144141645],
            [3.7637775138831175, -2.7759493105145814],
            [3.758317248579468, -2.7743579822145534],
            [3.7510437415281497, -2.7667028588185842],
            [3.744744298016354, -2.76288058914826],
            [3.736604223108079, -2.7549313878478183],
            [3.730554161383354, -2.751226403875174],
            [3.723851956926298, -2.7456156123953304],
            [3.711848791204008, -2.7308939520076754],
            [3.7096892650942337, -2.726544278887924],
            [3.7007696510673704, -2.7198179788989423],
            [3.6973109590148123, -2.7184875216859457],
            [3.6901685839350162, -2.7181422444822316],
            [3.683303210172665, -2.7210769614527006],
            [3.6808770071012398, -2.723953057607393],
            [3.6773933924679674, -2.7312112169553804],
            [3.6729181558351347, -2.736834948567949],
            [3.6682754874393657, -2.7409014981988618],
            [3.6593841786281343, -2.744182259713833],
            [3.654761139540216, -2.7425364593824075],
            [3.6513467164970783, -2.739578706173969],
            [3.6498407818164256, -2.735624980411229],
            [3.6495771153842536, -2.728233255178847],
            [3.6472310761921714, -2.720755868610875],
            [3.6402925851606183, -2.7160336038280106],
            [3.633423867953927, -2.7176482188745483],
            [3.6267113536122526, -2.725344806266828],
            [3.6192162278024194, -2.730952244427606],
            [3.613860912735513, -2.7335698320083965],
            [3.597409711374015, -2.7366799640631005],
            [3.5873256020380206, -2.7335431497818083],
            [3.5824703655674215, -2.7284227556499494],
            [3.580826528720431, -2.7240466153354665],
            [3.5813270135506974, -2.718311525205017],
            [3.5833680643290013, -2.711581100680498],
            [3.585282356137069, -2.709694712522155],
            [3.5936518373893214, -2.705340999745565],
            [3.6020387081543133, -2.6967609802849646],
            [3.6037795128412835, -2.6876396462109664],
            [3.602424181273863, -2.6785619484881433],
            [3.5992678964201015, -2.6724440394553857],
            [3.5942450599311684, -2.665096986430394],
            [3.59160489038631, -2.662858401067643],
            [3.5891998222576644, -2.656050260094151],
            [3.589094283024357, -2.6515704176275032],
            [3.5932040277874915, -2.6434332554048265],
            [3.5966796103488736, -2.640733448466326],
            [3.603487478197645, -2.6385419967845096],
            [3.6082619742378186, -2.6393571603484434],
            [3.6156621325533482, -2.6374358079820417],
            [3.6207236989895293, -2.6338629425459863],
            [3.6223497211017985, -2.629240511897006],
            [3.6213660800997536, -2.6247898196306663],
            [3.609440534747009, -2.61251214403138],
            [3.606301711083758, -2.60741455402374],
            [3.6007339849561477, -2.603512826515005],
            [3.5967830651833017, -2.6027259244388565],
            [3.5914852510694733, -2.603743960419166],
            [3.585722143508374, -2.603351805476068],
            [3.577710480085692, -2.5995738302368747],
            [3.5712156646288005, -2.5917461208734056],
            [3.56604879953469, -2.5825518555789193],
            [3.558411922137913, -2.564626660801738],
            [3.556691023474904, -2.55709469280733],
            [3.5515922453512347, -2.548672460570078],
            [3.5447441475352583, -2.5467753404007123],
            [3.5414838937197217, -2.547739856610037],
            [3.536182667987541, -2.5534782286473723],
            [3.53128703357657, -2.557397482191752],
            [3.523490874396866, -2.5620950540217926],
            [3.5200708276125288, -2.5621961631100905],
            [3.512203514369989, -2.5578041491762202],
            [3.510384335655192, -2.5493013662550985],
            [3.51181166915512, -2.54588778033683],
            [3.511310025932004, -2.538339234071107],
            [3.5070844252294258, -2.5316239143410897],
            [3.5048219070917384, -2.5305790945267415],
            [3.491402187128739, -2.531785527261203],
            [3.4908039110568745, -2.4898313474324234],
            [3.5339744782833913, -2.4893848153130733],
            [3.5334112163049975, -2.4676532337404455],
            [3.5328019692234127, -2.4011909680462193]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.91340061616452, "lat": 36.09485319852742 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05065"],
        "coty_name": ["Izard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Izard County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00066860"
      },
      "bbox": [
        3.4908039110568745, -2.78767309025478, 3.923616343462843,
        -2.3933853811295234
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1520284786265793, -4.05154004127384],
            [2.1935719509793317, -4.051037795334382],
            [2.1931744309717263, -4.025722263224674],
            [2.2003753476804517, -4.025613923141109],
            [2.2001413916072425, -4.003731160858398],
            [2.2433758528061096, -4.00404622141757],
            [2.2433311399128124, -3.99672276792182],
            [2.2723934510918586, -3.996486899896273],
            [2.2722508264198416, -3.9820691939831696],
            [2.3008503981379604, -3.981684416629559],
            [2.300936751020799, -3.96711386792862],
            [2.3296907282686834, -3.967058800023382],
            [2.4150927809762552, -3.9661721260812444],
            [2.4438853731296883, -3.9656189724144],
            [2.5015410392393047, -3.964851075313198],
            [2.5579360081821587, -3.9637584000304305],
            [2.5868450845134037, -3.963051439820331],
            [2.588824695937282, -4.021533806967837],
            [2.5820587040707736, -4.021706548250792],
            [2.5824332039555165, -4.060566927257539],
            [2.5833915768799782, -4.109584645963526],
            [2.5843303823550365, -4.183719357125967],
            [2.5842477437081475, -4.193899254664702],
            [2.5851309199658945, -4.249553920068445],
            [2.5859304013347035, -4.311066984757237],
            [2.5867244265000853, -4.369341154925516],
            [2.5291139498337953, -4.369507377813363],
            [2.4682898671186337, -4.36916276918985],
            [2.413962546859388, -4.368489127543729],
            [2.386655651206385, -4.368909232415491],
            [2.327418989826553, -4.368093125367198],
            [2.2546738954147694, -4.368963683772672],
            [2.2398527590419666, -4.369884378953289],
            [2.1546857581911523, -4.369072615692465],
            [2.1541875943480377, -4.325877490606175],
            [2.1532779125505326, -4.280305020083369],
            [2.1528973325122562, -4.196931607395383],
            [2.1522624625043867, -4.137706620665498],
            [2.1520284786265793, -4.05154004127384]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.65956050561866, "lat": 34.53889673489467 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05097"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00069168"
      },
      "bbox": [
        2.1520284786265793, -4.369884378953289, 2.588824695937282,
        -3.963051439820331
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.2241737872297, 5.003936862958094],
            [-18.137021670755715, 4.980945454506917],
            [-18.08487913521984, 4.966720809638327],
            [-17.96440881939219, 4.934194340162173],
            [-17.900471459407726, 4.916836672158956],
            [-17.828158214293016, 4.897593739927994],
            [-17.715389859573385, 4.86772109302387],
            [-17.71139073916753, 4.867111867868838],
            [-17.59635698914858, 4.836775388340918],
            [-17.481328875657972, 4.806416380285407],
            [-17.414136553970458, 4.788917799434124],
            [-17.363596781839117, 4.775859716046731],
            [-17.265595054938863, 4.750308415848243],
            [-17.263133998680175, 4.749787601865479],
            [-17.30378306752922, 4.591978860039381],
            [-17.34107716246633, 4.447161032138295],
            [-17.371479586704037, 4.32703985802393],
            [-17.378074862024775, 4.298712397946405],
            [-17.432613471296893, 4.083048362535021],
            [-17.457294266064054, 3.9879935741551145],
            [-17.492640307530067, 3.851700128578866],
            [-17.527634801210368, 3.7191965698382647],
            [-17.541510954102723, 3.6660287539416525],
            [-17.570829493692116, 3.553654257967657],
            [-17.59887290853684, 3.451539980115678],
            [-17.63256800935863, 3.3260066292912214],
            [-17.6432713197631, 3.328701225914939],
            [-17.646660984592714, 3.315382215270914],
            [-17.728007948363214, 3.3365747166654796],
            [-17.743895948057677, 3.3394111210234465],
            [-17.736183470593815, 3.3673388385670857],
            [-17.722369315477952, 3.3635022558913614],
            [-17.718524693832297, 3.377906967575937],
            [-17.71220519334457, 3.3764089229642735],
            [-17.708870342088545, 3.390679882832294],
            [-17.702228713081336, 3.3891188287372778],
            [-17.698744629515026, 3.4038691445559284],
            [-17.692950250151505, 3.4163132674616516],
            [-17.684670788744153, 3.4497408936050724],
            [-17.671116059041154, 3.501259843665413],
            [-17.664680271985215, 3.4995459691067863],
            [-17.657467757223422, 3.5279825514040577],
            [-17.664321115496104, 3.5297919483829574],
            [-17.65685244760214, 3.558177437450794],
            [-17.66994192472421, 3.5616082321367193],
            [-17.66796498106167, 3.569627009873213],
            [-17.674622552481157, 3.571359599241144],
            [-17.67275182585772, 3.578453636504825],
            [-17.679550038936334, 3.5802431007166535],
            [-17.677735245821992, 3.5872911711983746],
            [-17.68460386601281, 3.5891328785814727],
            [-17.682999099974708, 3.595150980040332],
            [-17.689820786125207, 3.597049899719853],
            [-17.685800629320244, 3.6117425229596214],
            [-17.693024490472002, 3.6137297978060654],
            [-17.68915994809508, 3.627749533571592],
            [-17.696053675992044, 3.6297424004216956],
            [-17.692309122836722, 3.644201822762142],
            [-17.70607156250743, 3.6479042941737863],
            [-17.698720536496346, 3.6764467022329055],
            [-17.70569522401138, 3.6782795521124507],
            [-17.702569476039063, 3.691589467871372],
            [-17.70109864075723, 3.691164614381625],
            [-17.693780781192956, 3.7201899497731494],
            [-17.707888651437166, 3.723237940187814],
            [-17.721161429659375, 3.727098678110286],
            [-17.715463993021647, 3.748592841452051],
            [-17.729319865028664, 3.7520575406988375],
            [-17.727930828787038, 3.760146814515589],
            [-17.734501491126434, 3.7607554066249373],
            [-17.7552597439686, 3.766210984707613],
            [-17.78295356959337, 3.7738492411723117],
            [-17.78114143911729, 3.78098731480511],
            [-17.795188815443566, 3.784615524642327],
            [-17.793239610770055, 3.79141058586285],
            [-17.807169830688487, 3.7950318918572146],
            [-17.804135374962968, 3.8057354874569227],
            [-17.818176266212237, 3.8094989838265954],
            [-17.8164159878711, 3.8160381838893023],
            [-17.823524530681798, 3.817888956243624],
            [-17.819476121447618, 3.8322444160547153],
            [-17.826563926140086, 3.8340103107642447],
            [-17.82442954603717, 3.8411173457024193],
            [-17.838646117417888, 3.84497229478646],
            [-17.836899794881376, 3.851887391794894],
            [-17.84374780971343, 3.8539007384175394],
            [-17.839580813894294, 3.8679044650906236],
            [-17.84607333502679, 3.869606519912356],
            [-17.842508071077965, 3.883656371970492],
            [-17.863369513976323, 3.889185249787606],
            [-17.859387655829412, 3.903114754978083],
            [-17.8663864523413, 3.905067079450316],
            [-17.862407935835556, 3.9191146446585683],
            [-17.876292095858005, 3.922669896955113],
            [-17.872737090541314, 3.936566059246908],
            [-17.886508456340348, 3.9404536752628716],
            [-17.88467864742971, 3.947265489854181],
            [-17.89852858942416, 3.9509892983598585],
            [-17.89668644854576, 3.9581256769703126],
            [-17.917111622551555, 3.9637203617014287],
            [-17.9116001759358, 3.9847901945512505],
            [-17.94512723879729, 3.9939370295792362],
            [-17.943140707533743, 4.001017033081414],
            [-17.957597511712628, 4.005017694512163],
            [-17.955605608397182, 4.01199719572855],
            [-17.962400105168992, 4.013855729208895],
            [-17.960906090916783, 4.0209627256626],
            [-17.980479721596147, 4.027056971467138],
            [-18.01494861016751, 4.036099443167317],
            [-18.013117828074552, 4.043420155515946],
            [-18.04072227058613, 4.050840180650204],
            [-18.042575980878144, 4.043738065774774],
            [-18.04943804401308, 4.0455217634306155],
            [-18.05137784705333, 4.038492458768673],
            [-18.06826995981886, 4.042471298912132],
            [-18.073757740423854, 4.01975388006478],
            [-18.08735526558582, 4.023484917497296],
            [-18.089470658565343, 4.016647922533323],
            [-18.103210056343, 4.020313463606259],
            [-18.107180732110077, 4.006195943962839],
            [-18.11411989858001, 4.007899395102922],
            [-18.116047637327533, 4.0009881933301115],
            [-18.12307102079166, 4.002824281452349],
            [-18.124852758201925, 3.99595217319169],
            [-18.13853482992059, 3.9994364488877396],
            [-18.149597011053668, 3.9583731237224447],
            [-18.163373607742297, 3.962069115179153],
            [-18.16525713859939, 3.95497139623103],
            [-18.193044548443723, 3.962214963796523],
            [-18.188868535783925, 3.976229801106848],
            [-18.202807846883164, 3.9800145240462026],
            [-18.19835703378736, 3.9937352549353924],
            [-18.24036500194045, 4.005181688537949],
            [-18.23683633928347, 4.018791599544628],
            [-18.26434491837467, 4.026035605792324],
            [-18.25864530547401, 4.04710123642053],
            [-18.273247811896663, 4.05097257912853],
            [-18.27107018629381, 4.058043129247322],
            [-18.257517818131728, 4.107491157188904],
            [-18.223199124223374, 4.235654415332282],
            [-18.2702578936247, 4.2483442925203025],
            [-18.278539620823928, 4.250140670279886],
            [-18.320603546283557, 4.261895437448543],
            [-18.334395502207787, 4.265179384785704],
            [-18.391812776536202, 4.280478792465651],
            [-18.403358937073808, 4.282901947602919],
            [-18.417457380016845, 4.287026031552231],
            [-18.40275462019976, 4.337462816763071],
            [-18.40005994626149, 4.336745064704977],
            [-18.388324454662072, 4.379074887686613],
            [-18.376793585524403, 4.421459454126147],
            [-18.35748843588703, 4.489217818277672],
            [-18.329047503640304, 4.590717757815464],
            [-18.294898207898537, 4.715765213340612],
            [-18.289461098762416, 4.73218781417071],
            [-18.298529880960956, 4.734142254462481],
            [-18.29355373660856, 4.749039367619122],
            [-18.260455404529047, 4.869714022382165],
            [-18.243870540596877, 4.932087552089034],
            [-18.2241737872297, 5.003936862958094]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.59432185392694,
          "lat": 40.67359588408972
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06035"],
        "coty_name": ["Lassen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lassen County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01693324"
      },
      "bbox": [
        -18.417457380016845, 3.315382215270914, -17.263133998680175,
        5.003936862958094
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.867128320647936, 2.8966893712400266],
            [-18.86132394953893, 2.8978176761490735],
            [-18.851902489626813, 2.9023901020874927],
            [-18.85046221652532, 2.905408677172452],
            [-18.839876029623095, 2.9081008051134276],
            [-18.83941876891821, 2.9113452018652994],
            [-18.83259010844314, 2.9129250398142705],
            [-18.827318815522005, 2.9185058627051665],
            [-18.82125023073842, 2.9210435717527163],
            [-18.81771331699187, 2.920974792772343],
            [-18.816269496532854, 2.9180844286060177],
            [-18.80799968481227, 2.9202605863142708],
            [-18.797188888681195, 2.9218458884466174],
            [-18.792775715427254, 2.9248505777448326],
            [-18.784821812953357, 2.924024357659027],
            [-18.782808182598146, 2.9280231826110668],
            [-18.77572315034392, 2.929792519113584],
            [-18.770361805672806, 2.9288254040658406],
            [-18.770109389804915, 2.9244329277555257],
            [-18.764763206754875, 2.919118593880671],
            [-18.76390313381186, 2.910768083228239],
            [-18.756573422202486, 2.906419785169321],
            [-18.752587741898136, 2.904541213877839],
            [-18.74764023373463, 2.899559829985384],
            [-18.735355559265518, 2.891761321626763],
            [-18.731228209702646, 2.885750391282536],
            [-18.724828624480313, 2.8874763408526336],
            [-18.722885821804965, 2.8852778739155007],
            [-18.719704419700008, 2.872724204002909],
            [-18.71330827965789, 2.8719893947479687],
            [-18.70794615691739, 2.869417611801534],
            [-18.706133322354415, 2.872773221653782],
            [-18.7012101171639, 2.873544486189937],
            [-18.693519882644534, 2.866406569045569],
            [-18.685987817214627, 2.87198329848646],
            [-18.682324293638725, 2.869320078215687],
            [-18.67366096139061, 2.87128139389502],
            [-18.671984112480896, 2.8728124221159645],
            [-18.66431747503461, 2.873202609602325],
            [-18.66132200654111, 2.877896620675959],
            [-18.65682016426815, 2.8783541528651466],
            [-18.651790890656088, 2.8810511656305855],
            [-18.64812420525726, 2.8767488086294284],
            [-18.64248389144825, 2.87321270911187],
            [-18.64318395556597, 2.8650237754694987],
            [-18.63873558816953, 2.8577311047525966],
            [-18.634193360896653, 2.8560942755936516],
            [-18.63301508519417, 2.8494120766669058],
            [-18.62688379859042, 2.848966822484325],
            [-18.625674525474547, 2.846737017254343],
            [-18.62096360141203, 2.8485759334610083],
            [-18.615580264467866, 2.8421789731867326],
            [-18.615325344155064, 2.839145710575843],
            [-18.607713587539653, 2.835315424906012],
            [-18.60123475135148, 2.8387626215223345],
            [-18.594046940602528, 2.837402483106914],
            [-18.5914462725249, 2.8387790218327855],
            [-18.58537883121296, 2.8383097153126706],
            [-18.580979381457997, 2.8410506070650734],
            [-18.580626614586066, 2.844355207943401],
            [-18.57382678961889, 2.849985113861293],
            [-18.569543361672228, 2.8597748265043563],
            [-18.563639119948483, 2.859244249628176],
            [-18.561471173167437, 2.86482761658012],
            [-18.556414290306364, 2.865715088085566],
            [-18.55453085722118, 2.8697939081657577],
            [-18.5505832155195, 2.8689040601549416],
            [-18.547262837299034, 2.877579739032814],
            [-18.54376764975419, 2.878171529095442],
            [-18.54238317564137, 2.882862854596372],
            [-18.537903566521383, 2.8823692815296753],
            [-18.53809809508308, 2.886424231993201],
            [-18.53165448408415, 2.889735383692925],
            [-18.53373919283064, 2.8946002221677816],
            [-18.527697852554912, 2.896625599162062],
            [-18.521111105588915, 2.913378206212136],
            [-18.52168178976368, 2.9211489323608464],
            [-18.51374851471577, 2.9199284091389126],
            [-18.510294803236423, 2.9225213549162805],
            [-18.506893743523182, 2.927785837082493],
            [-18.50226281538923, 2.9290938199644745],
            [-18.499021374370134, 2.9345631140668638],
            [-18.490416111112715, 2.936965733417607],
            [-18.48407749145177, 2.94191093421031],
            [-18.47903479368756, 2.9471425140972802],
            [-18.47491928140508, 2.946734800414441],
            [-18.471536769284995, 2.9513951376823973],
            [-18.467105501396272, 2.951846856774567],
            [-18.45976737831384, 2.9547558082009466],
            [-18.456875305296997, 2.9588683073765103],
            [-18.44726930539571, 2.9577902299934236],
            [-18.444561664459396, 2.960656931500352],
            [-18.445921039146516, 2.96413288251802],
            [-18.43566031533791, 2.9679204288175094],
            [-18.422272445959948, 2.966120903019492],
            [-18.41338386061347, 2.9664507544998346],
            [-18.41245834267793, 2.9708980470962363],
            [-18.404355536280217, 2.976288067056738],
            [-18.400848055191084, 2.980535585427814],
            [-18.399724633110043, 2.9842911130439878],
            [-18.395546569837947, 2.9911491969922914],
            [-18.392506648418067, 2.993533537703015],
            [-18.387016735813802, 2.99346618174451],
            [-18.3777697793803, 2.996058973335228],
            [-18.371650319294677, 3.0002806983495995],
            [-18.367437157456397, 3.0009436953454776],
            [-18.361844350059254, 3.004020861144998],
            [-18.351784416885717, 3.004820460099261],
            [-18.346769096067277, 3.0084396371894386],
            [-18.34026329785795, 3.009889885356208],
            [-18.33124437139271, 3.015913186248906],
            [-18.323081498833357, 3.0203246135698865],
            [-18.31945440701611, 3.020236122665821],
            [-18.3145451292186, 3.025761952047261],
            [-18.30840604046647, 3.025576914252685],
            [-18.301269310859045, 3.030241247992875],
            [-18.298686880467827, 3.0341321685139597],
            [-18.28319481847758, 3.0411697068504093],
            [-18.2809429010263, 3.043149911445599],
            [-18.270403027060627, 3.0447000370413617],
            [-18.26676378233942, 3.0440378368525587],
            [-18.258969702201558, 3.04956198711243],
            [-18.25151317192527, 3.0497739504350228],
            [-18.242237950433843, 3.0525217204189503],
            [-18.237665617768037, 3.051652970451665],
            [-18.233335012877433, 3.0537607995737335],
            [-18.23182998247529, 3.050978353023657],
            [-18.22683538350881, 3.0517193293353477],
            [-18.225060975110157, 3.0492244806466053],
            [-18.2162446842208, 3.050356110453231],
            [-18.21310475062198, 3.0533884754760305],
            [-18.105694237443625, 3.0256745210108438],
            [-18.067898158764898, 3.0162438664803513],
            [-18.058232080436454, 3.013620690108515],
            [-17.973101408287537, 2.9915705161421227],
            [-17.885587651645995, 2.968553614926976],
            [-17.835161557400024, 2.95548234785811],
            [-17.738653946894697, 2.9307981931242177],
            [-17.749934295867654, 2.8875752724139256],
            [-17.761261340008925, 2.8415689218983595],
            [-17.775377619643695, 2.7831283088362944],
            [-17.787906387302733, 2.731251945942628],
            [-17.79860793895503, 2.686935417456622],
            [-17.903779771961347, 2.7139157179717284],
            [-17.90552952534314, 2.7069853082769506],
            [-17.91251064426727, 2.7089326955715056],
            [-17.916163125899715, 2.694748795006251],
            [-17.925093443472957, 2.697045556722808],
            [-17.926995399415727, 2.6899304586547768],
            [-17.94082227464978, 2.6934034563504703],
            [-17.943343784315076, 2.6863846806221376],
            [-17.984863839467224, 2.697060855439265],
            [-17.986891541996684, 2.690062926885707],
            [-17.994524490336993, 2.6931550227923435],
            [-18.00106061310269, 2.6935377703081196],
            [-18.03855470709927, 2.7032929396017407],
            [-18.052507617167908, 2.7058965749896986],
            [-18.11409036426471, 2.7262280527057263],
            [-18.130808339465126, 2.73238685918091],
            [-18.137455373600343, 2.728516334010217],
            [-18.140899686653285, 2.724017415928453],
            [-18.14295838064661, 2.7167069809387354],
            [-18.146436355758052, 2.7140919178819396],
            [-18.14964620521326, 2.7073195868350544],
            [-18.153151248396963, 2.7035343766804334],
            [-18.1531974727131, 2.6963205717512047],
            [-18.16001122793646, 2.695047621190858],
            [-18.166540992534845, 2.685181014010218],
            [-18.17010978018723, 2.683513274051969],
            [-18.173470504136368, 2.6782585036931286],
            [-18.176587907600155, 2.677903138387285],
            [-18.181054408750313, 2.674530965464229],
            [-18.186556966975267, 2.674515727595472],
            [-18.18933272490759, 2.6685461504463057],
            [-18.19234072706446, 2.6677327873739705],
            [-18.19562760421889, 2.6607577671105065],
            [-18.20359495930944, 2.660425572358627],
            [-18.206479392212234, 2.6553567279984036],
            [-18.21116591735243, 2.6554773758950163],
            [-18.213107425158572, 2.6529014093895698],
            [-18.22115200652061, 2.654126633758043],
            [-18.22417994857047, 2.6562288294408467],
            [-18.230939832033773, 2.6522032384702006],
            [-18.236767641169752, 2.655326192601661],
            [-18.238874415000524, 2.654977637591343],
            [-18.240954247755667, 2.6492975692673757],
            [-18.24549281599572, 2.6503837313875187],
            [-18.249999948014402, 2.6459129745276986],
            [-18.25630552167336, 2.645992167007509],
            [-18.262140653847062, 2.648322098984568],
            [-18.26642168927875, 2.6517400622509464],
            [-18.2667366099186, 2.6556135470463156],
            [-18.270525565010473, 2.66084761658358],
            [-18.268369437950728, 2.663490008192392],
            [-18.268883029467258, 2.6678813577196103],
            [-18.27328533335495, 2.669761953730397],
            [-18.272944506733612, 2.673821074765496],
            [-18.27579685129932, 2.6753421811846385],
            [-18.280866623332837, 2.6739548093590937],
            [-18.282521643991974, 2.675458927074341],
            [-18.283295859801697, 2.6816129121835903],
            [-18.284861829842686, 2.684263170448213],
            [-18.291915464102363, 2.6861519972947336],
            [-18.29764696238103, 2.690986488603048],
            [-18.30158850707854, 2.689017054496824],
            [-18.306598779233372, 2.691388808414512],
            [-18.311833824882726, 2.6974350559459266],
            [-18.314465951355047, 2.6975974551682005],
            [-18.31463958798365, 2.703146682936087],
            [-18.317428643395278, 2.7043463124621256],
            [-18.31969121004878, 2.708138267542548],
            [-18.325473254135964, 2.7111985369072102],
            [-18.325864205763697, 2.7155659845463544],
            [-18.33067675927633, 2.721300874021754],
            [-18.32921421167557, 2.728946697208324],
            [-18.326531969197443, 2.731611624965679],
            [-18.32821741840372, 2.738042364286002],
            [-18.32634976249725, 2.743386060776036],
            [-18.32863872352805, 2.744758513120876],
            [-18.332829052936432, 2.7416228230129587],
            [-18.339813777525254, 2.7394443459770716],
            [-18.343201809692854, 2.7394989858819874],
            [-18.347147185520278, 2.7453047932778176],
            [-18.350589478156554, 2.747168173122278],
            [-18.3533278939354, 2.7549945373226237],
            [-18.352425137723486, 2.7608637172257637],
            [-18.355968284804742, 2.7667085725911287],
            [-18.361668058877125, 2.764650084138835],
            [-18.365616554082987, 2.7665677227794165],
            [-18.366456972250127, 2.770273942417783],
            [-18.375882452254228, 2.7758018638609965],
            [-18.382145742834354, 2.77159050258346],
            [-18.38542052060157, 2.7776770323944513],
            [-18.39361313843289, 2.7769018690275007],
            [-18.3996665960714, 2.7737474005323275],
            [-18.402644480040507, 2.7745496000372283],
            [-18.409009209452606, 2.772511021129072],
            [-18.410528948587196, 2.7781896205002847],
            [-18.418499935067317, 2.7793036728190255],
            [-18.422271519018047, 2.774720414665191],
            [-18.429668144203887, 2.7745747458993586],
            [-18.43478611990094, 2.770300168796333],
            [-18.436356645195062, 2.7634561205779526],
            [-18.439381657009505, 2.7617930486280446],
            [-18.44213396068192, 2.756105960197499],
            [-18.445631704161123, 2.756956772657701],
            [-18.446008370250635, 2.7608782180698896],
            [-18.452167780845052, 2.763947023221703],
            [-18.456077619832524, 2.7608224639465444],
            [-18.459346689416734, 2.755437681479149],
            [-18.45869324304428, 2.747667974911044],
            [-18.46362873687883, 2.745955618185564],
            [-18.465656683754275, 2.7419198363494104],
            [-18.472365053962918, 2.7457351137169796],
            [-18.478157667199397, 2.7502311593291533],
            [-18.481373246523855, 2.7507784543088323],
            [-18.483427178662875, 2.7537149555251226],
            [-18.487256414612183, 2.7553268251018728],
            [-18.495938559964028, 2.7511636581823575],
            [-18.505781462253776, 2.7557418074098714],
            [-18.513296686954277, 2.764661521637317],
            [-18.51782277206578, 2.7661237884860252],
            [-18.520112804128306, 2.7686896612750145],
            [-18.52355650356067, 2.767955261674677],
            [-18.523502760602288, 2.7619897702332055],
            [-18.52571323682567, 2.7521999174320158],
            [-18.52902748731183, 2.7417369912998275],
            [-18.53286187942623, 2.7426039034086016],
            [-18.53811596088649, 2.7473295611004094],
            [-18.542650210982025, 2.7488204133971217],
            [-18.550481924948862, 2.7441072321239166],
            [-18.55364416139424, 2.745486119755296],
            [-18.55753768662828, 2.7436841869910764],
            [-18.57121171171438, 2.744084281663013],
            [-18.571551571305744, 2.7404188933852605],
            [-18.580435443552453, 2.736757576423333],
            [-18.5891542707938, 2.737861457308394],
            [-18.593630213419182, 2.740730012480821],
            [-18.599266497290337, 2.7389018300588206],
            [-18.606108311960835, 2.7384254757837563],
            [-18.60812012452627, 2.7419683982413514],
            [-18.611463566180902, 2.74130650008213],
            [-18.614114799758653, 2.736064697817912],
            [-18.62367410662471, 2.7299217691722797],
            [-18.624641695485487, 2.72666850064778],
            [-18.621440892401946, 2.7242482268419304],
            [-18.61962357668299, 2.719096392514629],
            [-18.621605892213992, 2.717574804025391],
            [-18.634814990337965, 2.7146516751830108],
            [-18.63267216279605, 2.70849122064809],
            [-18.632301189780744, 2.699031099339023],
            [-18.63412970129769, 2.6960474161311825],
            [-18.640879993506918, 2.6925365501447547],
            [-18.640007749642475, 2.6832689800698923],
            [-18.641714703713188, 2.679403174703942],
            [-18.645199579784318, 2.6781741191595114],
            [-18.653444557799595, 2.678191694535877],
            [-18.662378773143832, 2.6724932421753307],
            [-18.66690973884698, 2.671726013149957],
            [-18.66956377831726, 2.665993021438918],
            [-18.666409477972834, 2.6609132207385704],
            [-18.669214054915045, 2.6547620794677624],
            [-18.676567261519672, 2.654036081451835],
            [-18.681679358231218, 2.6570310441711396],
            [-18.681504965350786, 2.648558287100489],
            [-18.684865557290262, 2.6414655375336182],
            [-18.68777550039406, 2.6386290414360754],
            [-18.688642449193985, 2.632351578845912],
            [-18.691151419046832, 2.6284068057743144],
            [-18.700710802249944, 2.618709024426125],
            [-18.705718792195903, 2.6166070194455124],
            [-18.708478904004807, 2.6124481720928427],
            [-18.709262340309934, 2.6042992721530718],
            [-18.71325229562211, 2.5998814139407225],
            [-18.71455827911261, 2.5962865911111255],
            [-18.723755680224492, 2.5829137558424686],
            [-18.72800344653805, 2.5818441032016266],
            [-18.731871700792993, 2.5672776341050256],
            [-18.73403345413819, 2.5631774666372666],
            [-18.739344979534035, 2.564517381749706],
            [-18.74323375069938, 2.565001282947103],
            [-18.80090177546094, 2.5862867480568816],
            [-18.859055399127946, 2.608202412226698],
            [-18.874814997381353, 2.613837371102181],
            [-18.921952767167856, 2.631626461217991],
            [-18.988852678270764, 2.656206284678038],
            [-18.98440306615044, 2.6725120391179047],
            [-18.97334536639548, 2.67009004490466],
            [-18.961649222837227, 2.7121291956228455],
            [-18.948330107862144, 2.76165720957566],
            [-18.93432941666981, 2.8110498485029236],
            [-18.92647971814554, 2.8392716668157636],
            [-18.885583970535848, 2.8283010882735486],
            [-18.867128320647936, 2.8966893712400266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.71766088847143,
          "lat": 39.06338387798758
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06061"],
        "coty_name": ["Placer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Placer County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00277295"
      },
      "bbox": [
        -18.988852678270764, 2.5631774666372666, -17.738653946894697,
        3.0537607995737335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-6.333624156068414, 1.296533343386921],
              [-6.3360041891389765, 1.302269266896893],
              [-6.329864844079948, 1.3024857510454573],
              [-6.326550211523483, 1.299505156544011],
              [-6.326219617387166, 1.2898331417304756],
              [-6.323997146318175, 1.2892815465086962],
              [-6.324662970474734, 1.2823262820411525],
              [-6.330371050572434, 1.2870482572012314],
              [-6.33066075764326, 1.2937741568547871],
              [-6.333624156068414, 1.296533343386921]
            ]
          ],
          [
            [
              [-6.341189255217115, 1.3321317679851148],
              [-6.3404953587257395, 1.3394276467712443],
              [-6.333636765696495, 1.3388033569647257],
              [-6.330498186630337, 1.334049198728078],
              [-6.332488943831898, 1.3276700419929697],
              [-6.332376892801906, 1.32402495028627],
              [-6.341815989797179, 1.3248497737810243],
              [-6.341189255217115, 1.3321317679851148]
            ]
          ],
          [
            [
              [-6.43476754182399, 1.2569342792193425],
              [-6.434417114880531, 1.2603363382652122],
              [-6.43403423008046, 1.2639978411606998],
              [-6.433891137334859, 1.2656314753599258],
              [-6.4336655435740076, 1.2676150704366727],
              [-6.426628311808333, 1.266894553787653],
              [-6.426972730243716, 1.2634635566368022],
              [-6.415723143208008, 1.2621405857245755],
              [-6.412365469265656, 1.2655238244939861],
              [-6.4193364533871575, 1.2679436984090648],
              [-6.418780355893552, 1.2733808859754683],
              [-6.4152056285421235, 1.273021977206466],
              [-6.414839778260427, 1.2767073660489987],
              [-6.418254333995682, 1.2785188327570516],
              [-6.417303800482919, 1.288124147427038],
              [-6.415436108577724, 1.2914068421674545],
              [-6.4081487830682455, 1.2908282950343974],
              [-6.4077795877315324, 1.294535604717286],
              [-6.402325356425992, 1.29402874917909],
              [-6.400508726101616, 1.3122800300626818],
              [-6.3951762913672905, 1.311715235058329],
              [-6.3936034743550145, 1.3096723005163078],
              [-6.394470916762348, 1.3005721882178398],
              [-6.398636132745926, 1.2936769081916415],
              [-6.393668083580308, 1.2931814574184601],
              [-6.392462777778416, 1.2992775490048682],
              [-6.3899092065148695, 1.3001672594241378],
              [-6.369513934125642, 1.2981888979486562],
              [-6.366135442919058, 1.295999028297486],
              [-6.366635925798303, 1.2905505984200736],
              [-6.3594370533955775, 1.2909938723679235],
              [-6.359928310192939, 1.2861395349564952],
              [-6.355603003006923, 1.2857227135001814],
              [-6.356861415047289, 1.282095320145867],
              [-6.339176999509951, 1.2804845277296955],
              [-6.339989767764811, 1.2732450544621432],
              [-6.332838457208377, 1.2725948489916823],
              [-6.32650462497522, 1.2647214527517694],
              [-6.3280200578976, 1.250079812941729],
              [-6.306634173332495, 1.2481185902808223],
              [-6.305128468805303, 1.2629973512526005],
              [-6.301269059185954, 1.2650296836620967],
              [-6.300017003291602, 1.2768184114552272],
              [-6.2966079358570095, 1.2748866016065024],
              [-6.2973078462033625, 1.2683885039062803],
              [-6.291509250864732, 1.2699519032058215],
              [-6.28152934285999, 1.276187482385946],
              [-6.275684425749335, 1.2786365479438717],
              [-6.275544539783433, 1.280774129353875],
              [-6.28133446385776, 1.2824519903308187],
              [-6.288850040748715, 1.2831231478171357],
              [-6.287644348577465, 1.293690705306162],
              [-6.290943931753744, 1.2979692913932652],
              [-6.294291190560381, 1.2982846427227666],
              [-6.295818619343805, 1.2876215980296375],
              [-6.298325066605997, 1.28767795936274],
              [-6.302385736708717, 1.2916716603972325],
              [-6.306580374684034, 1.2890416027664418],
              [-6.309422273739813, 1.2924278505462228],
              [-6.316389129161733, 1.2931183901177377],
              [-6.315300626439596, 1.3041386855834047],
              [-6.308548386702974, 1.3033598454623938],
              [-6.307842362460439, 1.3069483500504113],
              [-6.30424603143327, 1.3066059351569854],
              [-6.303919219353245, 1.3102523061103342],
              [-6.307508824188265, 1.3105991577265916],
              [-6.3068711150030525, 1.3176531540769731],
              [-6.310422149512451, 1.3182519701102575],
              [-6.310771904122831, 1.3146016968584056],
              [-6.314339754696574, 1.3149499063398022],
              [-6.313497218531943, 1.324175851969688],
              [-6.3070178677122914, 1.3216033804519938],
              [-6.285159372939249, 1.3195171066186104],
              [-6.288555675284659, 1.321677349187841],
              [-6.2844817287750745, 1.3267993770971434],
              [-6.2838035157913685, 1.3340795162091421],
              [-6.287417889431906, 1.3335268201271862],
              [-6.286643168381939, 1.3415640578574388],
              [-6.290098312928472, 1.3434431335990025],
              [-6.289538738810273, 1.349334682842081],
              [-6.294607139231112, 1.3491851136699342],
              [-6.296542665156753, 1.354669952258078],
              [-6.295233046371611, 1.3646442698974388],
              [-6.174600214372975, 1.353552011013769],
              [-6.138716139344379, 1.3499826419013499],
              [-6.124748369474624, 1.349193804852168],
              [-6.119387837110165, 1.3479961097026305],
              [-6.103951382701706, 1.346308269111031],
              [-6.097995051211244, 1.346349789689791],
              [-6.0660505807371266, 1.3430041619419884],
              [-6.009216571791895, 1.3364788672489418],
              [-5.923607833647305, 1.3286349688235193],
              [-5.8823212659043005, 1.3252014443560196],
              [-5.850220879977344, 1.3228238733670452],
              [-5.783066131840092, 1.3173212357929267],
              [-5.697010907229041, 1.3107617349267515],
              [-5.606931680809271, 1.303554692950619],
              [-5.60287166860739, 1.3033490000294965],
              [-5.401134224415158, 1.2861622882306292],
              [-5.415726223308416, 1.111584642397759],
              [-5.42126703259828, 1.11207151401302],
              [-5.62241149582219, 1.128741380832241],
              [-5.64966166888061, 1.1306734431272396],
              [-5.77136168518484, 1.1403307613207738],
              [-5.914235877010092, 1.1518040564049752],
              [-5.964141525178453, 1.15550828583074],
              [-6.043326651285662, 1.163681601747592],
              [-6.098865658078727, 1.1699494609626808],
              [-6.140938365469188, 1.173779517404745],
              [-6.198495807372839, 1.1790392990195755],
              [-6.290926050451204, 1.187759638549222],
              [-6.321088838636116, 1.1905257193993628],
              [-6.429957743145962, 1.2010493651164966],
              [-6.436395434798682, 1.2015603032018194],
              [-6.4405007558588965, 1.2019523720055099],
              [-6.43476754182399, 1.2569342792193425]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.3392735616364,
          "lat": 39.649743265205984
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08005"],
        "coty_name": ["Arapahoe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Arapahoe County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00198118"
      },
      "bbox": [
        -6.4405007558588965, 1.111584642397759, -5.401134224415158,
        1.3646442698974388
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.919050324051826, -0.8391381110107472],
            [-7.894411036102252, -0.8422530239170857],
            [-7.869223092794132, -0.846039907766778],
            [-7.848858995822722, -0.8479131898278467],
            [-7.798245771323373, -0.8541200016646173],
            [-7.770415562587362, -0.857798729978512],
            [-7.7706625368580875, -0.8600417920007165],
            [-7.663269706339057, -0.8701403731556552],
            [-7.6627505544379115, -0.8699594582749921],
            [-7.589815842051265, -0.8782051988943181],
            [-7.526757479401094, -0.8850445745948785],
            [-7.476746519393459, -0.8902407003250152],
            [-7.419605382638259, -0.8965702492475972],
            [-7.423951040566881, -0.9406806459551951],
            [-7.381480801231193, -0.945864849180148],
            [-7.345206303230651, -0.9494182774645611],
            [-7.336657926532802, -0.9504802668256065],
            [-7.277258420262104, -0.9567747675032083],
            [-7.192558396493509, -0.9650028523689594],
            [-7.198265796107061, -0.970424178914089],
            [-7.1971176000164006, -0.9734390608264045],
            [-7.201653063158203, -0.9769407043208344],
            [-7.199166273628505, -0.9823374996120448],
            [-7.2006350695727175, -0.9877158162982899],
            [-7.197953443731674, -0.9906022685658498],
            [-7.198961040322769, -0.9945462190061894],
            [-7.196178162697637, -1.0000067370327095],
            [-7.191271675833505, -1.0200426040756143],
            [-7.186817550586172, -1.0182957935096426],
            [-7.186396853633591, -1.024414301432781],
            [-7.181440372200036, -1.0327947500853796],
            [-7.1816738375775575, -1.0381325226612041],
            [-7.186912318705883, -1.037150280198002],
            [-7.185823513755269, -1.0491090376423093],
            [-7.190678710132314, -1.051929224846621],
            [-7.193705363844951, -1.0566572987179226],
            [-7.198617618918742, -1.0590073629504504],
            [-7.198285675122857, -1.0650253838692685],
            [-7.20260121288179, -1.0668986788984383],
            [-7.205988709952519, -1.0742736758327793],
            [-7.202601975894568, -1.0815731142195149],
            [-7.20398610213356, -1.088548262347918],
            [-7.208253858301886, -1.0917070739494001],
            [-7.206739699002292, -1.1008730965504947],
            [-7.2087906506525075, -1.1040701244506845],
            [-7.205591804026841, -1.1092736591333383],
            [-7.204082818310887, -1.115508965465305],
            [-7.204700735975133, -1.1220725871211514],
            [-7.203054695772302, -1.1237559729921147],
            [-7.205904437583173, -1.128147687329413],
            [-7.205119833569177, -1.1333585111063988],
            [-7.201742785104659, -1.1351486982114376],
            [-7.200144968275751, -1.1429709523608098],
            [-7.201492286336021, -1.147552641205365],
            [-7.206738614711827, -1.1524024336160996],
            [-7.2080891803198135, -1.1578057291282062],
            [-7.204253175345012, -1.1641733403264916],
            [-7.203910844001293, -1.1673738019245596],
            [-7.206711819926422, -1.1735414272592763],
            [-7.215194594471059, -1.1791612824510347],
            [-7.2197930954073835, -1.1873042162287286],
            [-7.2196359097558425, -1.193826564239297],
            [-7.222191825834714, -1.2026067813760548],
            [-7.222411037385686, -1.210202600183389],
            [-7.219342919132214, -1.2178605608760595],
            [-7.21686537397078, -1.2211080669543706],
            [-7.223462144843057, -1.2301687285044747],
            [-7.224253943430148, -1.233563006469825],
            [-7.229129237317195, -1.238586864016565],
            [-7.232098828504153, -1.2437265864985447],
            [-7.237079211134727, -1.2480328694902967],
            [-7.240937738137271, -1.254912448476842],
            [-7.244011734645081, -1.2564546249839534],
            [-7.240075470742657, -1.2656721639215858],
            [-7.245754420196312, -1.2737359128262495],
            [-7.246558887407804, -1.2793216948068098],
            [-7.243401634580951, -1.2810182688003695],
            [-7.245627478149153, -1.284652139510611],
            [-7.243456590331897, -1.2864286167913253],
            [-7.240585457535542, -1.2956303795877573],
            [-7.233312324143794, -1.2945568696041025],
            [-7.231433061546079, -1.2992559111215929],
            [-7.232191662491805, -1.304739821264707],
            [-7.230067908023099, -1.3088520125854906],
            [-7.2247599976663075, -1.3105699281642305],
            [-7.216182776807337, -1.309470413091827],
            [-7.212936149118369, -1.3140686931462446],
            [-7.215398565574594, -1.316532371342681],
            [-7.213020765417209, -1.3208851230929952],
            [-7.213171324921715, -1.3241787122273736],
            [-7.210066128678054, -1.3254308784213313],
            [-7.210287255460195, -1.3294935541745416],
            [-7.4288075441795245, -1.307188716191141],
            [-7.436805633426262, -1.3064177198718745],
            [-7.510567977818927, -1.2991849775330495],
            [-7.590435192052807, -1.291270192932592],
            [-7.627542595293818, -1.2870950671167243],
            [-7.662663202925339, -1.2836899533768924],
            [-7.7018345666129955, -1.2790764343004235],
            [-7.8065612551499886, -1.2679596584500767],
            [-7.814252648758097, -1.2455355621655868],
            [-7.878893687598728, -1.1112624319645887],
            [-7.879176573062098, -1.0555758131176405],
            [-7.938850836363233, -1.0147422942462283],
            [-7.919050324051826, -0.8391381110107472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.19162147094599,
          "lat": 37.20070661800612
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08021"],
        "coty_name": ["Conejos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Conejos County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00198126"
      },
      "bbox": [
        -7.938850836363233, -1.3294935541745416, -7.181440372200036,
        -0.8391381110107472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [17.225367107602377, 4.4104338330536175],
              [17.23331728217706, 4.406708377113118],
              [17.22999513688905, 4.404390568979845],
              [17.221383147279177, 4.409321711119426],
              [17.225367107602377, 4.4104338330536175]
            ]
          ],
          [
            [
              [17.20873608012274, 4.384102452761328],
              [17.211701184474464, 4.390918236904492],
              [17.21653111125129, 4.390970088681078],
              [17.214467284227087, 4.384372959200681],
              [17.21252002288884, 4.3818187656924925],
              [17.20873608012274, 4.384102452761328]
            ]
          ],
          [
            [
              [17.195432563461495, 4.366978575673635],
              [17.202290024599296, 4.377115002128643],
              [17.205825760101533, 4.378267282890365],
              [17.206644198039008, 4.369464511282193],
              [17.2009925845572, 4.367355297621875],
              [17.193106651001628, 4.3598278528414625],
              [17.195432563461495, 4.366978575673635]
            ]
          ],
          [
            [
              [17.057278993352746, 4.258047308145383],
              [17.061297258693834, 4.263133282390444],
              [17.063204057125052, 4.26128759075329],
              [17.057278993352746, 4.258047308145383]
            ]
          ],
          [
            [
              [17.042623066955077, 4.2703581240250985],
              [17.044231427320764, 4.272636770849148],
              [17.049566413273, 4.268083307506577],
              [17.047814748711957, 4.264603886184234],
              [17.042623066955077, 4.2703581240250985]
            ]
          ],
          [
            [
              [17.02873957059428, 4.650044714883262],
              [17.02728890668516, 4.660114350083255],
              [17.02199129888801, 4.689191764767638],
              [17.017934069959495, 4.717055270102266],
              [17.001414169233936, 4.809460846525806],
              [16.986073773221555, 4.901393741387843],
              [16.981753966840913, 4.9224801224831065],
              [16.977007195408202, 4.9477096743314934],
              [16.985382443764717, 4.948759218588062],
              [16.98665525262523, 4.952473664687055],
              [17.07115541952774, 4.987526005231296],
              [17.07509482550253, 4.976413186063439],
              [17.080011345973404, 4.964522905060092],
              [17.086255607998908, 4.962212664184512],
              [17.096506182579976, 4.9556378119657865],
              [17.102366339838973, 4.939963174762807],
              [17.116256548121832, 4.907380753465449],
              [17.12723905138472, 4.879737435099288],
              [17.132574245866394, 4.864204326363774],
              [17.13965511262801, 4.8496028050129265],
              [17.146976640297233, 4.830410806030948],
              [17.151071835516944, 4.822014136211037],
              [17.159133676305263, 4.824774028057495],
              [17.156364389966726, 4.811198686126658],
              [17.15853255819656, 4.80848305544563],
              [17.15875261451745, 4.802616407569808],
              [17.164390191169073, 4.796921652213787],
              [17.17387872109537, 4.79075517709629],
              [17.177251857613555, 4.79398782129953],
              [17.181429598473187, 4.793926414981558],
              [17.183628473048813, 4.788936239785502],
              [17.18395011436952, 4.779852023659162],
              [17.187342971891006, 4.7734530317767545],
              [17.19093445210624, 4.77271103572066],
              [17.19467238964655, 4.776678140524185],
              [17.201015604833934, 4.780616658084919],
              [17.204544473923793, 4.780450449154579],
              [17.21095168805002, 4.773671013204437],
              [17.213687850088917, 4.767608091454907],
              [17.21586934338284, 4.765511391986972],
              [17.2208940048916, 4.766029816374044],
              [17.224120030647832, 4.770866816950811],
              [17.227898564922437, 4.773980635368743],
              [17.230918727948414, 4.770762961985194],
              [17.232447838216043, 4.764692999952754],
              [17.237938954691412, 4.76221615746582],
              [17.24376155729397, 4.767930302588129],
              [17.25001561370804, 4.768172177862108],
              [17.256148468937965, 4.763152229595227],
              [17.259678428634587, 4.761710686045991],
              [17.269769433248953, 4.754711167579227],
              [17.27473115463228, 4.754783549713627],
              [17.27959276776734, 4.751833065086177],
              [17.27950830666243, 4.742505793820004],
              [17.2842358126055, 4.737883519054653],
              [17.281675678914787, 4.734379048036526],
              [17.276590282037997, 4.732728374686627],
              [17.275727324950047, 4.726525411382953],
              [17.272557053075577, 4.72205883829257],
              [17.275258055225645, 4.715556010638341],
              [17.26489225044023, 4.705024280154051],
              [17.25843294168388, 4.704026285590049],
              [17.256231406420767, 4.708942917114331],
              [17.236587648088012, 4.688324694053673],
              [17.198032022167688, 4.645327668420473],
              [17.205867397256704, 4.6363230682025875],
              [17.218756071651583, 4.624803431307592],
              [17.204022419472786, 4.613366405154266],
              [17.17781385526717, 4.591319415987679],
              [17.20463683956429, 4.567464162446137],
              [17.213638384937042, 4.558145714761514],
              [17.22034163739551, 4.5522448467159595],
              [17.223183222409084, 4.547446305485611],
              [17.22306424476466, 4.541513132695986],
              [17.22130661843996, 4.53820365304172],
              [17.22071897379665, 4.527129455014066],
              [17.221518940161747, 4.523439766224092],
              [17.218956157623413, 4.518101550572077],
              [17.229301794812557, 4.506591423345574],
              [17.25188057733242, 4.482427004390379],
              [17.25367616099249, 4.482430360242032],
              [17.256001061264094, 4.476727980401018],
              [17.25957175650991, 4.476511623008155],
              [17.26046263365331, 4.472426580382887],
              [17.264175151301277, 4.466113395410541],
              [17.26439421411743, 4.456970469035082],
              [17.265585307517355, 4.452522994926181],
              [17.259256965208852, 4.445397562844794],
              [17.25550016971176, 4.4465188613139786],
              [17.250598225233038, 4.443773971282508],
              [17.244748432997362, 4.436904934640217],
              [17.240153391275562, 4.437616998045545],
              [17.23131055951838, 4.429905171930835],
              [17.23075987204755, 4.424841689472755],
              [17.21811783152446, 4.427556331783464],
              [17.219611030270663, 4.422174737970262],
              [17.22253282749879, 4.418434948021149],
              [17.220196393713007, 4.41601686072928],
              [17.210362286810174, 4.413480579338035],
              [17.213785196464137, 4.409193391236095],
              [17.20773560686917, 4.408642721336562],
              [17.205382368922706, 4.404307620094287],
              [17.206122893943697, 4.398715815588494],
              [17.20236618350306, 4.39762264029748],
              [17.19827952471446, 4.400896672916913],
              [17.195547132489434, 4.395123709058036],
              [17.19753533276175, 4.385149657792865],
              [17.194253507702296, 4.3843569555623425],
              [17.183092452119325, 4.365940297481768],
              [17.17756139250964, 4.36466278239174],
              [17.17335279418771, 4.366127008890756],
              [17.164269586599573, 4.362158163792197],
              [17.159088657853776, 4.365261901452855],
              [17.1561096790289, 4.3638522652388705],
              [17.15642647506577, 4.357749882779085],
              [17.154740575418984, 4.352334830272021],
              [17.15824022447275, 4.351042000522165],
              [17.154832101942343, 4.3468265954607155],
              [17.154322389063417, 4.339119428078958],
              [17.149325005878197, 4.34788038774376],
              [17.144257063861993, 4.344498885708778],
              [17.14080496654062, 4.3477171772871355],
              [17.1362939202522, 4.345261502738127],
              [17.133303119568904, 4.3404931822520805],
              [17.132872026192068, 4.335944452518229],
              [17.12576550294048, 4.335671330329615],
              [17.122154958746517, 4.331466235406967],
              [17.126891680581863, 4.327138910231422],
              [17.128021760139035, 4.320101724584391],
              [17.126249198886597, 4.31526474035845],
              [17.123484770392274, 4.314260200634439],
              [17.11974935903562, 4.316188224880523],
              [17.119001745384047, 4.322550937870023],
              [17.114514186054592, 4.324724450491693],
              [17.109034655656842, 4.31711888301507],
              [17.10784769875102, 4.313775928137969],
              [17.104552356248497, 4.314489659170735],
              [17.101794131069752, 4.310146193004446],
              [17.102117944793015, 4.306482343442815],
              [17.098710885232393, 4.305291611495318],
              [17.095954916478778, 4.298529138485012],
              [17.09640114501373, 4.289018563237251],
              [17.08645057763628, 4.285909241662457],
              [17.084539854891496, 4.290174171438387],
              [17.077026219864564, 4.295559896341347],
              [17.074357742345605, 4.298624750989802],
              [17.06857415139757, 4.296266703945813],
              [17.062208604087125, 4.288277151674947],
              [17.05531861922732, 4.284218393516864],
              [17.05485511642509, 4.279287970902553],
              [17.04523189205998, 4.278340537471124],
              [17.038867820451443, 4.268662608897529],
              [17.036578550532678, 4.260295742129941],
              [17.03466443577536, 4.261070048342278],
              [17.031014612976822, 4.272220271070445],
              [17.032003656790202, 4.28421029889332],
              [17.024565711815963, 4.291372151704411],
              [16.992471837603574, 4.323825475431256],
              [16.96940316922573, 4.347581266745385],
              [16.958410835479782, 4.358503898064173],
              [17.012865370873484, 4.413661890742038],
              [17.05920566639018, 4.459565680700876],
              [17.09339747701563, 4.494285789966145],
              [17.10999921259019, 4.510629640258678],
              [17.07373550521143, 4.547351129436457],
              [17.04098690174082, 4.579490184692928],
              [17.03958708031421, 4.591737841261897],
              [17.037154084282417, 4.599765771228818],
              [17.035144192448954, 4.609995968675279],
              [17.02873957059428, 4.650044714883262]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.4474735307174, "lat": 41.32276117702924 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09190"],
        "coty_name": ["Western Connecticut"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Western Connecticut Planning Region"],
        "coty_fp_code": "190",
        "coty_gnis_code": "02830254"
      },
      "bbox": [
        16.958410835479782, 4.258047308145383, 17.2842358126055,
        4.987526005231296
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.049352597889806, -9.115091810814578],
              [12.062226824920822, -9.11081942282514],
              [12.073160086704146, -9.115108640141424],
              [12.079915067335286, -9.121083573043705],
              [12.074185495580643, -9.128236489305502],
              [12.071033322802142, -9.138980755629545],
              [12.060323832917335, -9.130839307614586],
              [12.060156207248294, -9.122925317874271],
              [12.05681000543162, -9.117168606568612],
              [12.050616235190214, -9.116575218929906],
              [12.049352597889806, -9.115091810814578]
            ]
          ],
          [
            [
              [12.207636700900222, -8.849768094768642],
              [12.216355827465428, -8.850270826420923],
              [12.221441222758346, -8.85287375454082],
              [12.227448543619813, -8.848666813775717],
              [12.231654437475473, -8.850888795903858],
              [12.24030969015181, -8.848219323528506],
              [12.243432527251459, -8.843360636276312],
              [12.24684377191643, -8.840703522428425],
              [12.247871177599436, -8.83751285035794],
              [12.252933461831972, -8.835765621246889],
              [12.261028624969995, -8.835896216132625],
              [12.263742554121919, -8.840119979843095],
              [12.266562441411857, -8.83827763537393],
              [12.270130167331386, -8.84115070215536],
              [12.27462440828653, -8.840805963754784],
              [12.278977325840561, -8.844467831744845],
              [12.281172162024944, -8.844147620470377],
              [12.290239956620221, -8.84743032462643],
              [12.2931324333609, -8.849651358329474],
              [12.295891120209143, -8.85439915787337],
              [12.302323651009177, -8.857395545368377],
              [12.302799877699542, -8.859756954392921],
              [12.31110907295363, -8.861362305687054],
              [12.313834490069052, -8.866449150842476],
              [12.320936555678458, -8.86329533964839],
              [12.321800621415955, -8.861352609509042],
              [12.327316191085995, -8.861486124774387],
              [12.33107753970303, -8.860046228980485],
              [12.333711401351193, -8.862131211709793],
              [12.331949770077225, -8.865426397885164],
              [12.335976709685756, -8.868328012310705],
              [12.342591352765309, -8.867313867267717],
              [12.354161951907365, -8.87135799962754],
              [12.36022307250842, -8.870245947635222],
              [12.363536879054994, -8.873293952235604],
              [12.365694762713511, -8.878406380019266],
              [12.373995741522862, -8.879621042598528],
              [12.380294631049079, -8.882847126331447],
              [12.384051092358101, -8.881640074962586],
              [12.38830648883696, -8.885276373616607],
              [12.392914838460984, -8.88616173677701],
              [12.39544649972336, -8.88881081328293],
              [12.406619783006075, -8.892721345723675],
              [12.410913032426743, -8.896042950140412],
              [12.41368903481592, -8.904703690167429],
              [12.414342360492888, -8.906567296950229],
              [12.42052952180709, -8.911554155478152],
              [12.422926282784609, -8.911483744607917],
              [12.428078994362856, -8.914642227599337],
              [12.430997588739027, -8.9209882968033],
              [12.430502406930168, -8.924221766314796],
              [12.43606632521893, -8.926219039841463],
              [12.438255126914735, -8.932691228874964],
              [12.442700706798965, -8.937645931708474],
              [12.445609577784149, -8.942560792801801],
              [12.445839434990246, -8.945652049787677],
              [12.450655910179572, -8.949087479718616],
              [12.452859953739598, -8.957627934725323],
              [12.455810022461002, -8.96164201475759],
              [12.463674966310387, -8.967364834006993],
              [12.466916608740526, -8.967964386652925],
              [12.47768854361818, -8.974509870137657],
              [12.485691422747182, -8.977681940016007],
              [12.48957412538958, -8.983897768115867],
              [12.489207361778824, -8.98717102256219],
              [12.492204703897453, -8.988359013107244],
              [12.493501250578708, -8.992734192735758],
              [12.497785612102007, -8.996104726326811],
              [12.506630658138334, -8.998662072988706],
              [12.510939603003056, -9.00120912167704],
              [12.516900900023641, -9.007151360298101],
              [12.522091658803433, -9.009097166237],
              [12.524350873064405, -9.014034272920862],
              [12.537443634892508, -9.020030413682372],
              [12.541200078203763, -9.020006719574159],
              [12.545649863572251, -9.023876028305976],
              [12.54620261783952, -9.028567775430153],
              [12.551182659786546, -9.041481354644507],
              [12.560412495742796, -9.046723948668971],
              [12.560428627453133, -9.053223661337919],
              [12.549870259700244, -9.06159534654262],
              [12.547195856232301, -9.068496280286512],
              [12.547802672439484, -9.072938000225498],
              [12.553615500487677, -9.075443449936573],
              [12.55341992360732, -9.080827944484117],
              [12.548794507755126, -9.08601365638942],
              [12.543391495752275, -9.085702324410608],
              [12.540707791862703, -9.088836578880937],
              [12.53451561175189, -9.089878933183899],
              [12.531027042565949, -9.093466622373011],
              [12.52954916212452, -9.100286528966349],
              [12.520990890258549, -9.107867889871143],
              [12.515670271307975, -9.113598052826198],
              [12.515292523599024, -9.118996329940252],
              [12.511395577569603, -9.124678074461153],
              [12.508254050620604, -9.12691115003009],
              [12.50284392340875, -9.134052863167868],
              [12.502093205878092, -9.140596535729635],
              [12.502891505810386, -9.145597644109914],
              [12.505657203504628, -9.149482098652667],
              [12.502654210202614, -9.159054796222874],
              [12.50265780193597, -9.161733986294177],
              [12.498471905466976, -9.169207553122373],
              [12.499564694305233, -9.179533462527724],
              [12.497960385980727, -9.184305294927556],
              [12.493392113633742, -9.185677421850103],
              [12.446188390418557, -9.192505117219184],
              [12.413961265040667, -9.198003666155783],
              [12.363583002509083, -9.2052303197279],
              [12.358972110591436, -9.177056220110238],
              [12.24219026234242, -9.193783169512251],
              [12.136153439465636, -9.209195357570854],
              [12.13513051722587, -9.20521421552144],
              [12.12077591822356, -9.203718055239651],
              [12.11619542313214, -9.198088369658464],
              [12.107014460215682, -9.192946655468488],
              [12.093173448392157, -9.195632545710316],
              [12.092580379710787, -9.190803208795852],
              [12.096383426328035, -9.18197888109583],
              [12.101969664154307, -9.179750876841235],
              [12.104026522821407, -9.1719981795522],
              [12.109543151840873, -9.1737201668367],
              [12.113884437884943, -9.173116322612994],
              [12.11675664440279, -9.16960462953752],
              [12.108396794795253, -9.159775107374665],
              [12.106767763573107, -9.150639912789167],
              [12.106431543219578, -9.13973882351643],
              [12.105331600001453, -9.133863717330623],
              [12.10021688193324, -9.13122447146382],
              [12.107816805348646, -9.118794218246286],
              [12.107765410035032, -9.115484353656344],
              [12.101400607156206, -9.112222585220485],
              [12.10008446052338, -9.116505148458334],
              [12.09378995394169, -9.112036474478483],
              [12.087921817922043, -9.110778342589724],
              [12.085342446659245, -9.104501515358193],
              [12.078504652497802, -9.102341099975128],
              [12.070790770960887, -9.096985527465561],
              [12.068502218098933, -9.09274136235125],
              [12.062211396566475, -9.089349872757948],
              [12.062497367600884, -9.07824187626738],
              [12.069821989680372, -9.073900030365593],
              [12.067115970845098, -9.065885793988947],
              [12.062635281721972, -9.062011814063437],
              [12.064260262061874, -9.055609649675443],
              [12.065145430737333, -9.042686631991362],
              [12.07951248727932, -9.03650834188064],
              [12.08782292559333, -9.032318225656464],
              [12.096257521100759, -9.024175713607981],
              [12.095878081220421, -9.014582155315772],
              [12.094244526897954, -9.004421649795477],
              [12.087573441536398, -9.00054511321859],
              [12.09029146008626, -8.998134738291752],
              [12.086968229135643, -8.994825960812143],
              [12.081376475143724, -8.99249606037223],
              [12.085103054975002, -8.986174938755688],
              [12.084526061156408, -8.98065963893014],
              [12.072717832138782, -8.977163791904305],
              [12.057205486089916, -8.961858346682721],
              [12.0543775038111, -8.953562457048816],
              [12.047791914894889, -8.950125846433957],
              [12.037703784314143, -8.947942694380208],
              [12.036667819683636, -8.940111692085464],
              [12.029722553808599, -8.936886918813794],
              [12.027761362492774, -8.938116228708799],
              [12.023810466872236, -8.9341640972145],
              [12.028026347037073, -8.931569210051146],
              [12.0209579876289, -8.928122399074496],
              [12.024473899202933, -8.922145236324768],
              [12.023115180792255, -8.918404536899784],
              [12.028954490957709, -8.914416447855977],
              [12.035288149750704, -8.906165862981334],
              [12.040333514730122, -8.90298232084151],
              [12.045125057487192, -8.902347985210449],
              [12.045607673718633, -8.899340070475702],
              [12.051029121347312, -8.890357919812972],
              [12.056698245046437, -8.884873671205394],
              [12.061975652043877, -8.884206514635347],
              [12.073467053401224, -8.880644680052649],
              [12.075525260347487, -8.879136063738558],
              [12.081435998694676, -8.881699524977224],
              [12.087228187911855, -8.881195231738369],
              [12.08903919121129, -8.884993440581393],
              [12.10309247205232, -8.885641300818017],
              [12.10922540156502, -8.88532718224127],
              [12.121784403891674, -8.888342606735947],
              [12.128995413449589, -8.889100351850908],
              [12.130989793439426, -8.89130023216835],
              [12.138209224279251, -8.891779942247739],
              [12.140886466302979, -8.893602910131612],
              [12.145858519953169, -8.893922210343394],
              [12.15018434418348, -8.89214789272596],
              [12.15439275850136, -8.888559684249225],
              [12.155207051768581, -8.885511940290527],
              [12.153679447470797, -8.880841733355199],
              [12.15604184147729, -8.873899358757006],
              [12.159443870119842, -8.871315734670745],
              [12.168419603037924, -8.872105573539564],
              [12.174143288809956, -8.871219989165171],
              [12.177236322231245, -8.866480715750061],
              [12.184384026927429, -8.861992607482176],
              [12.190900323291688, -8.863341166436404],
              [12.199208639459219, -8.854008300683283],
              [12.205843315504461, -8.852618130965158],
              [12.207636700900222, -8.849768094768642]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.47944700357105,
          "lat": 28.848935292641627
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12017"],
        "coty_name": ["Citrus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Citrus County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00295752"
      },
      "bbox": [
        12.0209579876289, -9.209195357570854, 12.560428627453133,
        -8.835765621246889
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.217506821098114, -8.960097663291222],
            [13.217230535665788, -8.953114491365726],
            [13.2140206891604, -8.943653212699704],
            [13.211275714690371, -8.940182375209957],
            [13.208760805052298, -8.931876735871189],
            [13.20967759659166, -8.922366787697568],
            [13.216408195162762, -8.911157168217667],
            [13.223219021622594, -8.904227215491131],
            [13.226235577633759, -8.90233022328169],
            [13.229113744189364, -8.894994791778435],
            [13.234861827454152, -8.89113877387099],
            [13.236567913324945, -8.88477571001262],
            [13.240179255967393, -8.880047272097485],
            [13.238765701556996, -8.876656742851283],
            [13.239813292235432, -8.872639392996396],
            [13.24352813548204, -8.871299204250315],
            [13.246001585875648, -8.867858771654472],
            [13.244582127731611, -8.86246010554512],
            [13.251053713516232, -8.868225144558195],
            [13.24844078623142, -8.873641044477134],
            [13.249797843900957, -8.876132626219633],
            [13.260013298571495, -8.876977446416396],
            [13.258179354297674, -8.881572004332579],
            [13.258325880259555, -8.886196961603817],
            [13.255350709611859, -8.88968941782177],
            [13.257120021025678, -8.891909832320867],
            [13.266377626376986, -8.892069391672022],
            [13.271520279985458, -8.890449041689745],
            [13.27953152645541, -8.895862247399846],
            [13.287971785196518, -8.897335151831452],
            [13.291710679854662, -8.899848000650058],
            [13.301156403875718, -8.898360602042269],
            [13.374203938434908, -8.889191138088885],
            [13.377498873414192, -8.894263598317862],
            [13.376795077618, -8.899641569514763],
            [13.379832766328391, -8.900414263036467],
            [13.385470081556921, -8.905448923707526],
            [13.385360139469295, -8.909479676009322],
            [13.388940594948952, -8.915106133840583],
            [13.394246426452598, -8.916729939196028],
            [13.398554918219947, -8.92088224678871],
            [13.406995861556418, -8.924197606034234],
            [13.409669101113154, -8.920417242296487],
            [13.412708846167662, -8.921842441295357],
            [13.415570061613213, -8.918184384171541],
            [13.419094014903594, -8.918670559396606],
            [13.423120789613645, -8.928116060321571],
            [13.428288637812415, -8.927152454049894],
            [13.430269683651794, -8.92925771192333],
            [13.434055677746676, -8.922854499088244],
            [13.440574604784572, -8.919508369157434],
            [13.446987416557095, -8.918079230509344],
            [13.456715813993256, -8.917475189524135],
            [13.458300875411696, -8.915023608259016],
            [13.455324066257173, -8.911605071416789],
            [13.462882503321687, -8.908366496971231],
            [13.46073928847466, -8.901176307658082],
            [13.464994906594718, -8.89685211982282],
            [13.465926780194604, -8.893241604815127],
            [13.462105447395917, -8.886531248595912],
            [13.46820603655669, -8.880550578163056],
            [13.478756212930064, -8.876842907618492],
            [13.48181237728682, -8.880488535595743],
            [13.4882063433865, -8.881806991135834],
            [13.491329381460263, -8.878762282809094],
            [13.498483892643822, -8.8863370784394],
            [13.503103060851313, -8.884640081013787],
            [13.505904090271654, -8.881804989899724],
            [13.509138941583842, -8.88575733636256],
            [13.514410024217513, -8.886802125662948],
            [13.515960572553057, -8.889467748428139],
            [13.515936980007185, -8.896502366909072],
            [13.52437311918925, -8.903266960185752],
            [13.526907633835943, -8.907359006788216],
            [13.53299290417491, -8.923271380015562],
            [13.528317873537231, -8.93554961658855],
            [13.529716691291707, -8.947305244921548],
            [13.533452356209349, -8.951594660478243],
            [13.550377140123391, -8.964297261686111],
            [13.550427526584237, -8.967362339616718],
            [13.554283916769524, -8.967990704797145],
            [13.554809407376496, -8.973103713101205],
            [13.558153562924277, -8.974234531976537],
            [13.557818047082783, -8.980620467681353],
            [13.560356005231311, -8.984371341285241],
            [13.571775019773872, -8.989489765271344],
            [13.577210994263849, -8.996728249245976],
            [13.575027498920415, -9.00155207233952],
            [13.574480291751582, -9.007282751660439],
            [13.576125409894768, -9.015648617531005],
            [13.58598708294906, -9.020261724897953],
            [13.590021531503512, -9.024248277071289],
            [13.589859922829163, -9.02896571202228],
            [13.593071542916217, -9.035390756449347],
            [13.596022423950568, -9.038597917033846],
            [13.598749190842053, -9.045231428484575],
            [13.594388956793793, -9.050634006690345],
            [13.599204652816812, -9.054789372412918],
            [13.603155944679965, -9.055976685802944],
            [13.603465615687412, -9.05945075827539],
            [13.607879163288281, -9.063160815095847],
            [13.611369032659265, -9.05950048743595],
            [13.614726328282657, -9.065428070719921],
            [13.612244543187018, -9.066994947153109],
            [13.615290053240342, -9.070629299397217],
            [13.608204137519888, -9.071568916257425],
            [13.545408824712785, -9.081910192426882],
            [13.519079741330044, -9.085970684393894],
            [13.452717142083776, -9.096994346261152],
            [13.437506091248883, -9.09931208649943],
            [13.37649784243503, -9.109339865636224],
            [13.31966760341084, -9.119078705631283],
            [13.314683676633987, -9.090797215030156],
            [13.285921084409525, -9.095512660890277],
            [13.28573600156209, -9.094459991470028],
            [13.239254730333844, -9.101924046911089],
            [13.200538118127152, -9.107689118857103],
            [13.189601620719975, -9.036486258588594],
            [13.19080649187765, -9.035252452561624],
            [13.200935606163867, -9.034328634237283],
            [13.205043227181855, -9.032305961861695],
            [13.214828411518535, -9.01220774577132],
            [13.217289628546233, -9.01024281459017],
            [13.218936115727455, -8.990744003918802],
            [13.220521520848589, -8.989439240345925],
            [13.2203850853509, -8.981502847346011],
            [13.218490649208931, -8.97595807635481],
            [13.218802578421435, -8.968406651084004],
            [13.217506821098114, -8.960097663291222]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.23625999430016,
          "lat": 28.716964469338826
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12117"],
        "coty_name": ["Seminole"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seminole County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00303665"
      },
      "bbox": [
        13.189601620719975, -9.119078705631283, 13.615290053240342,
        -8.86246010554512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.294454049373895, -4.949120713587623],
            [12.281673141095684, -5.00998225758554],
            [12.281416137318919, -5.012756418665739],
            [12.27666964807532, -5.0345726920431835],
            [12.261630493179767, -5.107856053722529],
            [12.245646330693807, -5.187739244054214],
            [12.248010653704663, -5.194169988350565],
            [12.248515643099765, -5.202618121697706],
            [12.252505327177714, -5.207749610608078],
            [12.257370174679686, -5.210381161969721],
            [12.260501658548412, -5.2104362650866385],
            [12.262337072646623, -5.2137497566365125],
            [12.266858073803192, -5.213795631495888],
            [12.268738148134151, -5.216251508208725],
            [12.272719991519008, -5.216166951797259],
            [12.212055123759642, -5.245968733504091],
            [12.146282847434763, -5.277672481254037],
            [12.1426668069891, -5.275707876614596],
            [12.070760746205124, -5.231946019022252],
            [12.047201459621267, -5.186502230520681],
            [11.997104909040637, -5.091166201201768],
            [11.993629003622864, -5.0845673829052425],
            [12.00427616361755, -5.0182830503752385],
            [12.034420596847689, -4.980318698402322],
            [12.094543607570643, -4.967568058438963],
            [12.12977511097688, -4.9599419996312815],
            [12.136467084347457, -4.958199987631743],
            [12.213239382543453, -4.916213070510722],
            [12.217470711724776, -4.9191828758666025],
            [12.224805557010278, -4.919889177243909],
            [12.229899275556628, -4.922952483667477],
            [12.233874975544882, -4.922276716070759],
            [12.2389580430874, -4.924129629302262],
            [12.24230374023098, -4.920942306648112],
            [12.246931318081375, -4.919506251943408],
            [12.250102723560202, -4.922224671409637],
            [12.250827936711477, -4.927203225594016],
            [12.258645708347698, -4.929480603119453],
            [12.259306237200075, -4.9278446777598015],
            [12.267535951847686, -4.92891488624728],
            [12.272017817372491, -4.932230731417987],
            [12.274591461264851, -4.931136836642008],
            [12.28433067435097, -4.936489264788628],
            [12.288822996911293, -4.941219969710713],
            [12.290288480906385, -4.94724979936836],
            [12.294454049373895, -4.949120713587623]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.96354745424802,
          "lat": 32.792450362058496
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13165"],
        "coty_name": ["Jenkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jenkins County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00342985"
      },
      "bbox": [
        11.993629003622864, -5.277672481254037, 12.294454049373895,
        -4.916213070510722
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.133242426340344, -5.443640090185057],
            [11.187152223471116, -5.40159102123383],
            [11.235330240573433, -5.364445474809172],
            [11.275249676427071, -5.334301521219844],
            [11.33984906641345, -5.290083707837113],
            [11.416954421702288, -5.271916436717049],
            [11.484775749035329, -5.291883087630113],
            [11.48242396497069, -5.30032867059091],
            [11.481606687939413, -5.306793478922915],
            [11.481207474997984, -5.319149144129641],
            [11.592386867349328, -5.352202308271423],
            [11.599903645551569, -5.440430023617069],
            [11.612322518018281, -5.445615911662496],
            [11.623689416293118, -5.448569142568778],
            [11.616639550469367, -5.455039948347445],
            [11.623851664640975, -5.460551064367615],
            [11.633101743838314, -5.46401538486068],
            [11.636126354890267, -5.463446710513033],
            [11.638843964728647, -5.468140970088085],
            [11.633224172266393, -5.474865120703364],
            [11.630500339991688, -5.491680262196077],
            [11.629359878848165, -5.493536066708841],
            [11.61823890710673, -5.502355525830788],
            [11.616404062050538, -5.501434848228448],
            [11.60823846546159, -5.502326595166498],
            [11.599265595985832, -5.504787371621771],
            [11.596809614649352, -5.510895548469266],
            [11.593496535075383, -5.511809128200326],
            [11.593477890866204, -5.515628377674701],
            [11.59795699438833, -5.5216426650989865],
            [11.591989693073142, -5.530335971234063],
            [11.589837509677043, -5.535092823952772],
            [11.592264983284267, -5.542422508909508],
            [11.595973583134906, -5.548516234565458],
            [11.59402598276658, -5.552122388457979],
            [11.597044929178708, -5.558786584603819],
            [11.594610966925783, -5.562200058988178],
            [11.593966328643058, -5.568617677788987],
            [11.59115844838398, -5.572982676612254],
            [11.586623549547937, -5.576190788338334],
            [11.582529938502667, -5.592385285681364],
            [11.585805318858032, -5.594847028883051],
            [11.58236945437655, -5.59796730023198],
            [11.580859685808079, -5.6051091612067],
            [11.578343466248478, -5.6096695552550875],
            [11.57933361986247, -5.6142112035967875],
            [11.576033634249788, -5.627510377484064],
            [11.573853577913725, -5.631899898980609],
            [11.569779140144075, -5.634907183959283],
            [11.565444319024738, -5.642046221497394],
            [11.569419047221768, -5.641625401122911],
            [11.571619490097328, -5.639361036399411],
            [11.576219174920121, -5.647138861693023],
            [11.579354523784929, -5.645453861362515],
            [11.580319067529095, -5.650884572992079],
            [11.583994465027342, -5.653491283213081],
            [11.583612162993093, -5.658201997774751],
            [11.590505403958696, -5.658613637715631],
            [11.570488924794496, -5.684604513687673],
            [11.561912288385544, -5.69666007192079],
            [11.56839859684744, -5.701698234962979],
            [11.563567994405545, -5.707941670330615],
            [11.557145769155877, -5.703274046620592],
            [11.492903208100412, -5.788238533740573],
            [11.487025286295225, -5.783654595173462],
            [11.481837649114787, -5.789680913898931],
            [11.475547474660525, -5.784720121222373],
            [11.470575637832615, -5.789624380900262],
            [11.468510630566971, -5.7879894125537],
            [11.422830757023815, -5.824336837857873],
            [11.413769453659738, -5.830701755922626],
            [11.388729898531583, -5.85014368985629],
            [11.360957053464976, -5.80596061628388],
            [11.297775679136983, -5.705149822276772],
            [11.245762530146731, -5.62203181356829],
            [11.22778144228392, -5.593633854733484],
            [11.163582886234154, -5.491388205215756],
            [11.133242426340344, -5.443640090185057]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.92216902937311, "lat": 32.46361613267968 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13175"],
        "coty_name": ["Laurens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Laurens County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00346568"
      },
      "bbox": [
        11.133242426340344, -5.85014368985629, 11.638843964728647,
        -5.271916436717049
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.491570907792596, -5.590354364999815],
            [10.497893473461119, -5.590749453830274],
            [10.494802764349654, -5.581715820807689],
            [10.531058277268444, -5.543708618809385],
            [10.5321241298398, -5.553974877416363],
            [10.54025215663677, -5.553017351039456],
            [10.5379903157315, -5.536200372957438],
            [10.5490105895931, -5.524276408335219],
            [10.548719931435302, -5.5169997925981615],
            [10.55675509537612, -5.516280930130378],
            [10.593178929028843, -5.477236280922698],
            [10.600320635809634, -5.470094658467112],
            [10.63280317906632, -5.435257777191949],
            [10.640289907902156, -5.427506167559271],
            [10.670531021746392, -5.395082963339227],
            [10.672377985191803, -5.394650065087073],
            [10.725172807041922, -5.389057073970816],
            [10.725647368694055, -5.398439831684522],
            [10.724170468144532, -5.4025644600086045],
            [10.720894367071795, -5.406709885798063],
            [10.723710568366718, -5.429935683490352],
            [10.708241048194008, -5.431811628167466],
            [10.709927264083477, -5.44770421390193],
            [10.717957263665943, -5.447159626731727],
            [10.721049399603826, -5.47133315991677],
            [10.726021398352556, -5.470757518941281],
            [10.725373764316707, -5.478300194386798],
            [10.722318618633357, -5.4841622345302055],
            [10.72337176704214, -5.497809177991628],
            [10.730313653438609, -5.549766049912065],
            [10.728964769000244, -5.560677655946087],
            [10.720741218995832, -5.5597298747072506],
            [10.719279597671491, -5.556223628229267],
            [10.714841485940655, -5.554988101874033],
            [10.711376728483899, -5.552170283707784],
            [10.706572437100544, -5.5511834506253575],
            [10.707307424846837, -5.561974798862862],
            [10.709507381721645, -5.579211422087729],
            [10.685349497731789, -5.58202238430061],
            [10.684478235816918, -5.574665561987392],
            [10.67667369000402, -5.575770507780148],
            [10.678406276511675, -5.592015046093195],
            [10.670131375682626, -5.593040313750848],
            [10.676499322180065, -5.642247846866471],
            [10.660355862539813, -5.644602638513192],
            [10.661260912599246, -5.6513814240703475],
            [10.652597828732414, -5.653226553691022],
            [10.650110449448286, -5.6349723465361485],
            [10.641297599248814, -5.632503404660298],
            [10.6372893189758, -5.63287126095844],
            [10.632982750188958, -5.626110643113468],
            [10.630176320007049, -5.622072700948814],
            [10.62663305720892, -5.62059980901395],
            [10.6211047484879, -5.62062757357186],
            [10.610490558283987, -5.618391696834677],
            [10.605069914894388, -5.608993182776536],
            [10.596634767664689, -5.6052989964197835],
            [10.588046546279696, -5.605586656717823],
            [10.584552889098484, -5.60357093668389],
            [10.565919340896773, -5.605492373678223],
            [10.567570397824197, -5.619572450489802],
            [10.560764846277436, -5.619952164355158],
            [10.564047220726149, -5.598601303985621],
            [10.563702813827376, -5.591722677017956],
            [10.556305926882576, -5.592370204984946],
            [10.556847118052438, -5.598309687645249],
            [10.524669617765175, -5.602151978162432],
            [10.523536050671806, -5.5939005916999704],
            [10.510149600488178, -5.595505854855895],
            [10.51107924692976, -5.603707357655152],
            [10.485480634515719, -5.606621584785338],
            [10.486085572804107, -5.6011632679909304],
            [10.487999689132634, -5.597735892492964],
            [10.490866256565315, -5.597300489102957],
            [10.491570907792596, -5.590354364999815]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.82689149586011,
          "lat": 32.568779182943665
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13225"],
        "coty_name": ["Peach"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Peach County"],
        "coty_fp_code": "225",
        "coty_gnis_code": "00343153"
      },
      "bbox": [
        10.485480634515719, -5.653226553691022, 10.730313653438609,
        -5.389057073970816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.132366741020793, 2.1582029897356367],
            [6.216593544988957, 2.164980055840963],
            [6.244142211852705, 2.167328169120575],
            [6.300713207440307, 2.1726503962896073],
            [6.295031653217018, 2.2296303111657902],
            [6.294500969146738, 2.2295788101543352],
            [6.285359519174412, 2.3168893628475478],
            [6.279378132645658, 2.3752127000052807],
            [6.2761883908413365, 2.404221536130583],
            [6.260524588495152, 2.549861821239515],
            [6.274655286994159, 2.5521088528741434],
            [6.289223853815443, 2.5532636966831963],
            [6.346320433538796, 2.5601726619031986],
            [6.352107809090178, 2.5014694615161344],
            [6.367629187835248, 2.354595385739384],
            [6.37059711963001, 2.3252379035557427],
            [6.380208775761883, 2.2383263107720586],
            [6.380830801155099, 2.238395140750794],
            [6.39178252775486, 2.136627359322863],
            [6.396738939015411, 2.0781820139151534],
            [6.399391351575548, 2.048938541361079],
            [6.485753952106875, 2.05696742301599],
            [6.493372574916331, 2.0545262361666636],
            [6.5367311892548265, 2.0585243310570056],
            [6.541061222767896, 2.022779083807143],
            [6.546834240115113, 1.9718356615539956],
            [6.546326546076726, 1.9717924867646237],
            [6.517094111621733, 1.9689999829847522],
            [6.502806105481995, 1.9679319256191112],
            [6.493622088091764, 1.9684209560729473],
            [6.464830500053792, 1.9659107130690014],
            [6.407050115075323, 1.9613095096408006],
            [6.327217528541092, 1.9537082873832279],
            [6.234512375346839, 1.9449663815903167],
            [6.17773092538622, 1.9405280226418804],
            [6.149472591198796, 1.9385968083545642],
            [6.143034280117553, 2.0264747122310016],
            [6.132366741020793, 2.1582029897356367]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.22331052272776, "lat": 40.59718486870942 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17053"],
        "coty_name": ["Ford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ford County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00424228"
      },
      "bbox": [
        6.132366741020793, 1.9385968083545642, 6.546834240115113,
        2.5601726619031986
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.697153190317777, 3.1458828235712994],
            [5.76507904978763, 3.153425866139084],
            [5.786020901451999, 3.1556060977339917],
            [5.864333059918217, 3.1607018996708494],
            [5.896894708660152, 3.163680523433938],
            [5.945767878653095, 3.1679022987053735],
            [5.953790660885482, 3.0920339918711517],
            [5.962286392779385, 3.0114457787405877],
            [5.964077503551906, 2.993444887015452],
            [5.967506910731501, 2.956731556612165],
            [5.972716013539522, 2.9058380582429564],
            [5.979639378689574, 2.8476005486524145],
            [5.984482109586897, 2.8040245536409594],
            [5.990729356987326, 2.738196029019329],
            [5.998685320053413, 2.6438682318597806],
            [5.914845973306359, 2.636296205377613],
            [5.871196279477127, 2.6324889121168815],
            [5.800536814186271, 2.6265897707234607],
            [5.742049681651384, 2.621880627110596],
            [5.746426872281761, 2.565722339100675],
            [5.752061159421241, 2.487266608611951],
            [5.755018167176303, 2.442885192187341],
            [5.668243087127312, 2.4344674509829654],
            [5.6621479187848385, 2.522457016341554],
            [5.6551247101704005, 2.613374332011117],
            [5.655291371391732, 2.6143509512214425],
            [5.605755370403626, 2.610177507097502],
            [5.5697430658950795, 2.6073545275815926],
            [5.563058675677508, 2.696033606787429],
            [5.556256811122118, 2.784117030651005],
            [5.553711448032183, 2.8143555336147217],
            [5.54540849767227, 2.912910144101279],
            [5.539270714531513, 2.986357490428506],
            [5.531671682733302, 3.0903754897026183],
            [5.528096688349386, 3.133866388558076],
            [5.570553353790047, 3.1358498341321503],
            [5.613428077668376, 3.13808417719238],
            [5.697153190317777, 3.1458828235712994]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.88594170006947, "lat": 41.34398680020171 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17099"],
        "coty_name": ["LaSalle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["LaSalle County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00422247"
      },
      "bbox": [
        5.528096688349386, 2.4344674509829654, 5.998685320053413,
        3.1679022987053735
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9925376942042092, 1.1533508799606103],
            [4.009602103009892, 1.1540915900710822],
            [4.068189962738741, 1.1557765931208104],
            [4.15803713918163, 1.1599459773542669],
            [4.175313102614275, 1.1611691258894667],
            [4.189628389849385, 1.161677964415049],
            [4.264215871955458, 1.1653121336607275],
            [4.334282533110872, 1.1692966507004139],
            [4.331259212119852, 1.2215228507558478],
            [4.3290107579431485, 1.257662215422546],
            [4.3462495303721225, 1.2546774431611678],
            [4.418312343321322, 1.2585036446505675],
            [4.45185667689902, 1.2597783823872226],
            [4.506635576643083, 1.2624605736576586],
            [4.535466862295255, 1.2636075164792049],
            [4.591595940711954, 1.266165648077632],
            [4.5955960052837215, 1.2605335955717072],
            [4.595670922558501, 1.2541919007871225],
            [4.588727378271409, 1.24568335194152],
            [4.582418265358664, 1.231970293033068],
            [4.574543485550281, 1.2206124989102451],
            [4.573373266915996, 1.2157037357710543],
            [4.5682079911472195, 1.2015798684863563],
            [4.569182827204786, 1.1936052198917648],
            [4.560504361190771, 1.167666190436359],
            [4.553178043875701, 1.1508383438827785],
            [4.545672104470293, 1.140722442733731],
            [4.542774196167664, 1.1275892049097436],
            [4.5428576444867765, 1.1212231915734547],
            [4.545907633044077, 1.1125016002179553],
            [4.548773313598547, 1.1076903817684876],
            [4.5539034968113254, 1.0962916030219196],
            [4.5570972968878305, 1.0935035037781624],
            [4.562082701077607, 1.0847117707252145],
            [4.566835865544495, 1.07797417544946],
            [4.568962170910129, 1.073123575533906],
            [4.575597102330516, 1.0616118689612848],
            [4.576341590513747, 1.05277099628407],
            [4.578633721499308, 1.0441766722535357],
            [4.584764483020766, 1.0290561978612836],
            [4.589803593152002, 1.0211772760564066],
            [4.598060838948269, 0.9992953674148652],
            [4.600213284444415, 0.9918708415810833],
            [4.603733897057746, 0.9844203185195991],
            [4.6062246030225245, 0.9710658923425314],
            [4.608206965135723, 0.9640835120644728],
            [4.6068622922285964, 0.9599892343667272],
            [4.6023166400067925, 0.9518504615620487],
            [4.602526831845374, 0.9461304626882481],
            [4.6031422378158116, 0.9423897331458798],
            [4.6023071284145, 0.9345972510058919],
            [4.599668857277793, 0.9277553221806313],
            [4.598384556368636, 0.9203082461727597],
            [4.596851617398323, 0.917446845552316],
            [4.596101073241915, 0.9106347410451143],
            [4.5881734165850885, 0.8917124659218182],
            [4.585591071835721, 0.8866332660829045],
            [4.58373804893489, 0.8800760691747402],
            [4.583614445775506, 0.8650854116022629],
            [4.581060214184773, 0.8527561670352689],
            [4.580841656972266, 0.8459742017432524],
            [4.5825982425311675, 0.835828389209365],
            [4.5828713487750505, 0.8289862591827496],
            [4.584785469971563, 0.8174227383210095],
            [4.528442727656004, 0.8152150376015459],
            [4.479850735247557, 0.8147023465353939],
            [4.470701689588213, 0.8147693508239753],
            [4.410984398531938, 0.8122736551572106],
            [4.3593756521942515, 0.8098752889859768],
            [4.357230811437468, 0.8091457295743766],
            [4.337675523227268, 0.8079412951531604],
            [4.33438574519621, 0.8123120724254996],
            [4.328439266770775, 0.8155515535798585],
            [4.321358202266695, 0.8166853585008226],
            [4.309614347295508, 0.8212662915450418],
            [4.305455107238508, 0.8252369475224715],
            [4.301211171149613, 0.8272080464904884],
            [4.2928489173064825, 0.8292906620033139],
            [4.285035049885979, 0.8335731741513787],
            [4.269229293763653, 0.843953575884544],
            [4.257515702028131, 0.8531873020418123],
            [4.245500152891925, 0.8663932246593541],
            [4.240273095189803, 0.8729312825321542],
            [4.237725245416913, 0.8781170922345396],
            [4.235205921775918, 0.898726529284713],
            [4.226376265874543, 0.9065577241707945],
            [4.22271665976891, 0.9113031301502633],
            [4.217246616716481, 0.9205332583760129],
            [4.211594905407006, 0.9325042287634652],
            [4.205429138993838, 0.9417060653818944],
            [4.194624252444855, 0.9435779594216491],
            [4.185156207108724, 0.9442324940856421],
            [4.168464133612021, 0.9469867464639655],
            [4.164254136597618, 0.9492477559209468],
            [4.156090766013974, 0.959258846421345],
            [4.152114462009739, 0.9654857404649102],
            [4.148787054022906, 0.9824667927511886],
            [4.145907088324053, 0.9938548423657213],
            [4.143094594258435, 0.998646473982814],
            [4.136711101811217, 1.0053185704197334],
            [4.112785409331229, 1.0142199423463731],
            [4.102832595987624, 1.0195084999361124],
            [4.093291265308714, 1.028340458643759],
            [4.086989200771313, 1.0389511840720436],
            [4.07766756384566, 1.046714631410453],
            [4.072474943020944, 1.0545079409810667],
            [4.064893520778404, 1.0629879821384307],
            [4.059198557002044, 1.067125571915883],
            [4.051000908326496, 1.0713991900522584],
            [4.044134513950896, 1.0759749195029316],
            [4.04067666556627, 1.0811084970478757],
            [4.0318162260946995, 1.088461394409217],
            [4.02092810735706, 1.0958488336812071],
            [4.010056560396761, 1.1043772287686977],
            [4.004095926602615, 1.1100231907216398],
            [3.991998558012821, 1.1233243819747525],
            [3.9901098076535493, 1.1267633730166162],
            [3.989537175103496, 1.1393825809380622],
            [3.9925376942042092, 1.1533508799606103]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.88636531396855, "lat": 39.62250291496018 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17149"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01784941"
      },
      "bbox": [
        3.989537175103496, 0.8079412951531604, 4.608206965135723,
        1.266165648077632
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.714169671685416, 0.8432153885772213],
            [5.8018082398729405, 0.8466005758479762],
            [5.798454802368512, 0.8903627623649265],
            [5.795554972532693, 0.9364714864326668],
            [5.794419499832234, 0.9363890383140064],
            [5.792968219191884, 0.9659253328683388],
            [5.789756938077801, 1.0250035652206206],
            [5.782715070110752, 1.1129612316931397],
            [5.778767098336769, 1.1568717833569142],
            [5.829413156056035, 1.1598550349909393],
            [5.858442274203717, 1.1612528646665554],
            [5.871163326401809, 1.1624732205279944],
            [5.898738375642503, 1.1645193330141106],
            [5.942460679086786, 1.1681165092150325],
            [5.949188022237989, 1.094763758204072],
            [6.018992446565269, 1.0991710742598066],
            [6.023927236542511, 1.0407141382142966],
            [6.049126021447341, 1.0422521266915286],
            [6.081400639352834, 1.044895048754497],
            [6.082741236880474, 1.0305615838896802],
            [6.097068010352397, 1.031471849238635],
            [6.098328378567688, 1.016797956006464],
            [6.1128521247546646, 1.0176201523850226],
            [6.114015262284699, 1.0029628273633595],
            [6.128230016227164, 1.0040290372717282],
            [6.1307495890096915, 0.9744556571248719],
            [6.160138363439813, 0.9768238224402694],
            [6.217552370191354, 0.9807457201678154],
            [6.218821178364892, 0.9662542681736461],
            [6.223098335836714, 0.9077516719727027],
            [6.224309883240733, 0.8893271541358563],
            [6.230974617498485, 0.8055516867383481],
            [6.235781523145957, 0.7472618061814426],
            [6.151010738798238, 0.7408722917992692],
            [6.115607421095504, 0.7385405752670731],
            [6.075076913201422, 0.7356481471889055],
            [6.050907692272158, 0.7336689632956704],
            [5.980466070349201, 0.7285622418489519],
            [5.9798124384691915, 0.7286463043386724],
            [5.8939661117893865, 0.7224723446770259],
            [5.847809758259488, 0.7185940343778077],
            [5.810399457092624, 0.715190091070216],
            [5.753634864878436, 0.712580946754979],
            [5.724056487082039, 0.710693365233258],
            [5.723978023251971, 0.711225131656787],
            [5.714169671685416, 0.8432153885772213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.80552902343243, "lat": 39.39113507677753 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17173"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "01785051"
      },
      "bbox": [
        5.714169671685416, 0.710693365233258, 6.235781523145957,
        1.1681165092150325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.190246938942494, 3.2815011719313265],
            [6.235351266692281, 3.28586655049281],
            [6.273614155206323, 3.2898173638448966],
            [6.360373022341233, 3.299846174553243],
            [6.365075099053587, 3.256177709968618],
            [6.369716264212603, 3.212415064015748],
            [6.390704330381662, 3.2146979938432274],
            [6.455057590004381, 3.2220816583755063],
            [6.464407503973352, 3.134914356727501],
            [6.550512662645434, 3.144041976167199],
            [6.552760082822137, 3.123803555878311],
            [6.553898327247513, 3.1251987906637733],
            [6.560065784009774, 3.0552830496627714],
            [6.6031232432716145, 3.058882110659265],
            [6.665122035514926, 3.0643572586998316],
            [6.7322130041168755, 3.0706026890010047],
            [6.755997958770866, 3.072941189770175],
            [6.758140814457939, 3.0483636376870322],
            [6.766141082082156, 2.953199646067215],
            [6.770695267892451, 2.9002053432774897],
            [6.698710397442855, 2.8929174575629863],
            [6.58161061463896, 2.8813679028013595],
            [6.4958690716471414, 2.8724613248389406],
            [6.409416572977851, 2.8632200902435927],
            [6.418340254076641, 2.7761275715573004],
            [6.331398320325618, 2.7672285726041133],
            [6.274467197989074, 2.7608675107813947],
            [6.245866875994295, 2.757843359076788],
            [6.236294588696024, 2.8478565259051583],
            [6.227817003070512, 2.932258116566991],
            [6.218388306927072, 3.019725229480694],
            [6.209029158628669, 3.106249243133508],
            [6.19908880144233, 3.1929440570658096],
            [6.19642508901716, 3.2178459132900366],
            [6.190246938942494, 3.2815011719313265]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.97864511118625,
          "lat": 41.445033012258506
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17197"],
        "coty_name": ["Will"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Will County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "01785190"
      },
      "bbox": [
        6.190246938942494, 2.757843359076788, 6.770695267892451,
        3.299846174553243
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.813577232507439, -0.6548250823627078],
            [5.849464242144816, -0.652029609510678],
            [5.900261106682292, -0.6485203057465287],
            [5.92691793132232, -0.646405134920154],
            [5.973111847155238, -0.6430886241948305],
            [6.044962163389492, -0.6370223213044979],
            [6.059835400757206, -0.6356656304619477],
            [6.116656023354018, -0.6310081672285425],
            [6.137621459342884, -0.6291322086542487],
            [6.159951979765992, -0.6275332136862429],
            [6.168224235019037, -0.7403344771527315],
            [6.169868111672265, -0.7609586344960927],
            [6.172975496288871, -0.8051137154219753],
            [6.178289018582188, -0.8844967036758288],
            [6.1790050751490835, -0.8936063134664923],
            [6.136079484948388, -0.8957963768647641],
            [6.092570138725781, -0.8987814331289128],
            [6.078834370768144, -0.9030286304496722],
            [6.049178066007229, -0.9057842470267515],
            [6.007138416794793, -0.9087593787460092],
            [5.990997865259895, -0.9108708089725431],
            [5.918780174447917, -0.9158833315789698],
            [5.889914879587838, -0.9171776038705075],
            [5.834294994870374, -0.9182823661485535],
            [5.830698302091977, -0.9185844709940229],
            [5.825168933266881, -0.831350742701966],
            [5.819303778845281, -0.7391295599496625],
            [5.813577232507439, -0.6548250823627078]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.92993549167068, "lat": 37.730264462986 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17199"],
        "coty_name": ["Williamson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Williamson County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "01785215"
      },
      "bbox": [
        5.813577232507439, -0.9185844709940229, 6.1790050751490835,
        -0.6275332136862429
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.37135985932431, 0.13609016771179472],
            [7.3737227788569735, 0.13471943285676252],
            [7.378364682540295, 0.12441811791413503],
            [7.381297374683134, 0.12283049363924838],
            [7.385923734773441, 0.12488478435982572],
            [7.389336264619346, 0.1314477737335639],
            [7.392781613879288, 0.13422171457644455],
            [7.401854025332381, 0.13641339489529647],
            [7.408300782887452, 0.13216930504531355],
            [7.412503185271622, 0.13303501779766683],
            [7.41744539682853, 0.1376642153573841],
            [7.4241022119601086, 0.13457230741968462],
            [7.427708674830231, 0.1358590748305933],
            [7.43201257521124, 0.1401426883638423],
            [7.440710152859186, 0.13280647402875598],
            [7.447875568731353, 0.13040907046193817],
            [7.452363269785222, 0.13314225942440922],
            [7.462041437526036, 0.1332670253062453],
            [7.462918170543003, 0.12300418695464588],
            [7.466052714994301, 0.12069040183877008],
            [7.469887761094673, 0.12084365617063632],
            [7.475535795331781, 0.12601917415014044],
            [7.4747346819185365, 0.13017964600243587],
            [7.477104919069018, 0.13554111338587724],
            [7.479730383428276, 0.1369131845621035],
            [7.4865678031526235, 0.13755863595528445],
            [7.488688560338423, 0.13224347030525543],
            [7.492026163106254, 0.1295890729416786],
            [7.49617200167754, 0.12895084258731776],
            [7.5008494799788625, 0.13395429493364028],
            [7.505192534904338, 0.13521827831474392],
            [7.511613061069892, 0.13075995624074005],
            [7.5149962304051225, 0.12976441485459414],
            [7.522510959275563, 0.1304214783808203],
            [7.523894399892404, 0.13703088539172167],
            [7.528692778902502, 0.14279359023226662],
            [7.539034553672842, 0.14640618606338102],
            [7.547332354302876, 0.15335823882338448],
            [7.552813724699678, 0.16203440911611472],
            [7.551415660408601, 0.16521452370772557],
            [7.585628201741423, 0.16805420925187764],
            [7.671022980528244, 0.17678810112612853],
            [7.678963717453548, 0.0997576930632332],
            [7.684753122952277, 0.04459882244238172],
            [7.694658542852357, -0.0474846235510123],
            [7.699249817977464, -0.08758879859502904],
            [7.701136915739653, -0.10264777438596054],
            [7.676741818239933, -0.10502049816503442],
            [7.637914526550706, -0.10834848448283939],
            [7.613447989488463, -0.11016928176596245],
            [7.618250203126439, -0.15431318140451034],
            [7.560572333276261, -0.16006658512195954],
            [7.531038036791596, -0.16377912931643893],
            [7.516068202536235, -0.16630512442759646],
            [7.501484044998546, -0.16780005743485615],
            [7.443343233824484, -0.17267509771289336],
            [7.400206016455342, -0.17650694187852484],
            [7.397538150269244, -0.14757230547061956],
            [7.393225592497867, -0.10236436664338006],
            [7.391242309006416, -0.0758584609091567],
            [7.386554218163404, -0.02631060148862689],
            [7.382280723039297, 0.01393767947407878],
            [7.379434842289052, 0.04318870629269483],
            [7.375508081856181, 0.08710632894777533],
            [7.375722971403433, 0.08766919796998882],
            [7.37135985932431, 0.13609016771179472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.8798244354347, "lat": 38.364271896496085 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18037"],
        "coty_name": ["Dubois"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dubois County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00451675"
      },
      "bbox": [
        7.37135985932431, -0.17650694187852484, 7.701136915739653,
        0.17678810112612853
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.884453541641475, 0.7433954171375265],
            [6.874987664697913, 0.745417499844167],
            [6.87517042952511, 0.7518951904840724],
            [6.878000642879083, 0.7542790688660471],
            [6.886730416430787, 0.7555189289027153],
            [6.890783099389692, 0.7586842702660092],
            [6.888654040734868, 0.7653894610099659],
            [6.888854140242578, 0.7718191085528474],
            [6.890160698504622, 0.7731598379402094],
            [6.896106861060567, 0.771340672652427],
            [6.900436676116746, 0.7735552197060778],
            [6.901582413913697, 0.779136355554318],
            [6.9080600362291396, 0.7833871575368789],
            [6.913422560680238, 0.78861996172274],
            [6.914151473334934, 0.7944106368218506],
            [6.919705494497411, 0.8008294921010657],
            [6.920943710226901, 0.808318443484335],
            [6.916754945181966, 0.8290055251873069],
            [6.915058033116642, 0.8332814463376409],
            [6.919549175400795, 0.8368636834420545],
            [6.920460280410748, 0.84169563640993],
            [6.918565086958913, 0.8447711436515803],
            [6.912995826924785, 0.8449401330411421],
            [6.909723798494045, 0.8425224720118806],
            [6.908526875991014, 0.838846998572434],
            [6.903884848342264, 0.8362422034350574],
            [6.899740677961417, 0.8426048719279242],
            [6.894699369277579, 0.8475954067082568],
            [6.925548360493507, 0.8502333435186614],
            [7.016317681680268, 0.8583302269068874],
            [7.064527788476249, 0.8623514898551454],
            [7.087814141534214, 0.8646892474714678],
            [7.172566757468181, 0.8723390260479374],
            [7.180403628866016, 0.7845705409348797],
            [7.1869952711626395, 0.7114183712061021],
            [7.19816031228687, 0.59303622431177],
            [7.2047017384645855, 0.5192563183314668],
            [7.205254842075272, 0.5129368349252594],
            [7.150449273031041, 0.5081046318816412],
            [7.118343989609731, 0.505005827425538],
            [7.063608258240714, 0.5004221405437334],
            [7.045803616974831, 0.49909861973566244],
            [6.9891483613201455, 0.4941026876207253],
            [6.984408154565788, 0.5005782969373509],
            [6.985435305908793, 0.5051353004813067],
            [6.983718910761028, 0.5098910526734795],
            [6.984719465697311, 0.5129261845894181],
            [6.990103496225078, 0.5152829584561219],
            [6.989714481256192, 0.519950550518672],
            [6.990909274780283, 0.5252788481553596],
            [6.986265049642183, 0.5320339906741375],
            [6.992206169815782, 0.5427670768515815],
            [6.991356483233279, 0.5486381377920484],
            [6.985435345425611, 0.5520037340414214],
            [6.981738703318888, 0.5557297641201563],
            [6.9775363556883345, 0.5635443541075735],
            [6.967282479871848, 0.5663407253044996],
            [6.962728394834564, 0.5688912744485946],
            [6.953081341346177, 0.5709327291951599],
            [6.940140207661391, 0.5751993615096316],
            [6.938364239866063, 0.5781208310980835],
            [6.942117854908073, 0.5801571992104161],
            [6.9486480796089, 0.5780681603348111],
            [6.951977659737899, 0.5820438378092861],
            [6.9467724051916075, 0.5827148241231245],
            [6.94011767941574, 0.5850969925948963],
            [6.9369291727111735, 0.590829262123261],
            [6.940300069601572, 0.5974849029770066],
            [6.9424567310313545, 0.6085512573217927],
            [6.941989334392283, 0.6122517935862495],
            [6.9370612413585295, 0.62291931012047],
            [6.932582364690883, 0.627908433589368],
            [6.932387906233379, 0.6304888906277714],
            [6.937525654953502, 0.6391713874971574],
            [6.936853968368082, 0.6464396415031733],
            [6.931775920145023, 0.6504601407036017],
            [6.927507216088141, 0.6564146388775642],
            [6.920936174660779, 0.6611363365026196],
            [6.917321861891005, 0.6666912028125005],
            [6.912861117807282, 0.6687556688328745],
            [6.905527941147358, 0.6679330598995048],
            [6.901374894262098, 0.668915641340538],
            [6.897043328521221, 0.6741372851433998],
            [6.8971913470727255, 0.67762256589637],
            [6.9005824578484125, 0.6822286883524645],
            [6.900417255160975, 0.6891909024067303],
            [6.897589604132235, 0.6905918167805042],
            [6.886608691285332, 0.6902542313371812],
            [6.881981045918678, 0.690845220100074],
            [6.877498527063138, 0.6889683508118849],
            [6.8710170503018375, 0.6908367795785121],
            [6.868936078291292, 0.6947904578922739],
            [6.871524951424064, 0.7006105542597453],
            [6.878915032226423, 0.6993392155404549],
            [6.88293103304849, 0.7035313459477113],
            [6.8831935018555575, 0.7075768978217608],
            [6.878719352033761, 0.7076646718788373],
            [6.876480128579159, 0.7133330763087128],
            [6.866894103631386, 0.7162597002828991],
            [6.863882112624907, 0.7197585043312339],
            [6.867416972462372, 0.7281729340211056],
            [6.867965711443627, 0.7349189486068957],
            [6.874692452854487, 0.7420937926669834],
            [6.878341555449512, 0.7420872269771808],
            [6.880983425299566, 0.7389212519623973],
            [6.88525137602458, 0.7398026724946097],
            [6.884453541641475, 0.7433954171375265]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.41472097112776, "lat": 39.08879058251453 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18153"],
        "coty_name": ["Sullivan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sullivan County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00450391"
      },
      "bbox": [
        6.863882112624907, 0.4941026876207253, 7.205254842075272,
        0.8723390260479374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.818620630522312, 2.065308491236437],
            [7.815731406695458, 2.094660116772743],
            [7.8597237496298575, 2.0998597709706774],
            [7.945253307104803, 2.110286893876593],
            [8.016055828406838, 2.118926841004786],
            [8.101088035082828, 2.1286450661145775],
            [8.104017114494479, 2.1000388566939496],
            [8.112599037474594, 2.027267777643593],
            [8.113366375203833, 2.0273498977553124],
            [8.11749946882593, 1.9839315421673769],
            [8.121312144303326, 1.9466790711991124],
            [8.121437825211688, 1.9402281370799905],
            [8.042849544661172, 1.9311945410066473],
            [7.92118683475734, 1.9173288556258],
            [7.835126495749868, 1.9070232219454977],
            [7.831943176490741, 1.9412615039186925],
            [7.8292559246779465, 1.965050464318694],
            [7.818620630522312, 2.065308491236437]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.05184331356298,
          "lat": 40.311339653196555
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18159"],
        "coty_name": ["Tipton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tipton County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00450394"
      },
      "bbox": [
        7.815731406695458, 1.9070232219454977, 8.121437825211688,
        2.1286450661145775
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8884306417504977, 3.268176586520416],
            [3.884396885451223, 3.3559130373936967],
            [3.9125287611662865, 3.3570615570401734],
            [3.970525104288154, 3.3599551502114986],
            [4.056790517037742, 3.3638866427748892],
            [4.143225181191837, 3.3681798787550656],
            [4.171592752845192, 3.3697629113703815],
            [4.229147665128145, 3.372382133967582],
            [4.2340309387754385, 3.284506968276928],
            [4.238679237503182, 3.196795822640561],
            [4.242861754633724, 3.109163324563515],
            [4.24700214644833, 3.0216740285746058],
            [4.175221297636735, 3.018111372237631],
            [4.102849637993662, 3.014428213924788],
            [4.058829118844679, 3.0123050019914808],
            [3.9730663684025624, 3.008468053238276],
            [3.9297855705860165, 3.0063777015102047],
            [3.9011116312434804, 3.005220594258344],
            [3.898298742470994, 3.063597430297026],
            [3.8971079303054106, 3.0928741833552005],
            [3.892880624654972, 3.180638103129368],
            [3.8884306417504977, 3.268176586520416]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.13241099659524, "lat": 41.77232794415853 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19031"],
        "coty_name": ["Cedar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cedar County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00465205"
      },
      "bbox": [
        3.884396885451223, 3.005220594258344, 4.24700214644833,
        3.372382133967582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1292796506680403, 2.8823872528121366],
            [3.2142909181663324, 2.885888949968249],
            [3.2684074441662614, 2.888128059536308],
            [3.374329783217133, 2.8928501614892244],
            [3.475187292735222, 2.897493129861229],
            [3.47724753322677, 2.847522398576654],
            [3.47844199117686, 2.810873188793853],
            [3.479210371810961, 2.796288011591896],
            [3.481965528139773, 2.7233034431268406],
            [3.48704355099966, 2.636651875425657],
            [3.4886412054314353, 2.6071301571028656],
            [3.490460854868407, 2.5482883084928947],
            [3.476141160080879, 2.5478625973881543],
            [3.4328929373291888, 2.5458266225280246],
            [3.402613744665353, 2.5442096770174714],
            [3.3156080746021064, 2.540124596464166],
            [3.2005191951137553, 2.5350833771355106],
            [3.143818337194333, 2.5327055174077926],
            [3.1433768430847575, 2.5475972732970575],
            [3.1418968337448288, 2.5764167483879707],
            [3.140276668837178, 2.6212060175908083],
            [3.1388801002936795, 2.6502383117720028],
            [3.1351347262397846, 2.740713364826545],
            [3.130211603497724, 2.857487479629529],
            [3.1292796506680403, 2.8823872528121366]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.17864229346166, "lat": 41.33645158023499 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19107"],
        "coty_name": ["Keokuk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Keokuk County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00465242"
      },
      "bbox": [
        3.1292796506680403, 2.5327055174077926, 3.490460854868407,
        2.897493129861229
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.126822499258076, 1.4600188352959906],
            [-4.015025063391492, 1.453065003156427],
            [-3.9672043223892195, 1.449725348705754],
            [-3.897092213559689, 1.445372063542426],
            [-3.805103999949397, 1.4397711982961063],
            [-3.732542367790358, 1.4354806684539736],
            [-3.6414144512393576, 1.4300000632976437],
            [-3.6417000398719965, 1.4276240262894926],
            [-3.6685277154603737, 0.9929006322776487],
            [-3.735063268330643, 0.9967298885795948],
            [-3.820295528557707, 1.0018193439344514],
            [-3.8943838981457373, 1.0062331652984686],
            [-3.989699302342675, 1.0119760218760994],
            [-4.096279273220225, 1.0184870917456414],
            [-4.153242954374165, 1.0219805494774408],
            [-4.152897677225161, 1.0279029195450224],
            [-4.148744384338328, 1.1004387588694535],
            [-4.147999964412116, 1.108242460185999],
            [-4.146978075261659, 1.1302035309202931],
            [-4.142958912933265, 1.1968867307996027],
            [-4.136782532312921, 1.2992978949229268],
            [-4.136532180492734, 1.3056858477867548],
            [-4.126822499258076, 1.4600188352959906]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.73190723170242,
          "lat": 39.78584471734834
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20023"],
        "coty_name": ["Cheyenne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cheyenne County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00484981"
      },
      "bbox": [
        -4.153242954374165, 0.9929006322776487, -3.6414144512393576,
        1.4600188352959906
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.502305441024962, -0.33466081986770807],
            [-3.3480232483357963, -0.3421428037945889],
            [-3.331832012654227, -0.3431026596629491],
            [-3.1773073572083916, -0.35183480176356585],
            [-3.1346381341675924, -0.3541597984040935],
            [-3.0339187285795903, -0.35944776211940316],
            [-3.0061737927827, -0.36104625162588566],
            [-2.9070304768517867, -0.36618962198813804],
            [-2.879098149582819, -0.3679660945065951],
            [-2.8729422410909256, -0.36795042133342276],
            [-2.835414793793041, -0.3697733951769937],
            [-2.8220129959473037, -0.37042462255272746],
            [-2.825774633918424, -0.4799185390498367],
            [-2.8285615055012614, -0.5460633420890842],
            [-2.833330449606326, -0.6339590582949409],
            [-2.961456569690808, -0.6282539914929739],
            [-3.003966652205164, -0.6264898378954613],
            [-3.05163837249495, -0.6236862067152225],
            [-3.1743204855016374, -0.6164680781918026],
            [-3.1802270107352864, -0.7263207002016157],
            [-3.183710806009539, -0.7916109792742567],
            [-3.1732295645641972, -0.7922453711966194],
            [-3.1781898099820416, -0.8854494168432576],
            [-3.2635032726226507, -0.8808899356122061],
            [-3.292100646346901, -0.8794891827438948],
            [-3.4062528405699775, -0.8734171842169223],
            [-3.449004185955187, -0.8712460486415077],
            [-3.5202962998487064, -0.8678405489370523],
            [-3.515452591723973, -0.7742858525115767],
            [-3.526307047439024, -0.7737841580733041],
            [-3.517652815477787, -0.6241767274758662],
            [-3.5154494827556415, -0.583660959265402],
            [-3.511230502705927, -0.5102727124587525],
            [-3.508269961637501, -0.45180192313535505],
            [-3.502305441024962, -0.33466081986770807]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.73700212493148,
          "lat": 38.044283722021994
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20055"],
        "coty_name": ["Finney"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Finney County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00485326"
      },
      "bbox": [
        -3.526307047439024, -0.8854494168432576, -2.8220129959473037,
        -0.33466081986770807
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.72910818476815, 0.2542417823456253],
            [8.731544526477482, 0.26140056768271247],
            [8.735125923569965, 0.2599323361998532],
            [8.740381299916937, 0.2600792482224498],
            [8.7477950292794, 0.2619767982294807],
            [8.755169059697465, 0.26092459794305756],
            [8.759561109290459, 0.2652768053396441],
            [8.776342909970962, 0.2936533007539748],
            [8.813153860468235, 0.33919863455649846],
            [8.830683750305932, 0.3601550873050608],
            [8.901415217747891, 0.37986297658015816],
            [8.902558950265306, 0.3608654804820966],
            [8.910860306638979, 0.35068995830301386],
            [8.91670054973491, 0.34900778340916216],
            [8.921195805806283, 0.3537053958524563],
            [8.9286442799317, 0.3596570533916997],
            [8.931694269716816, 0.3595955729378479],
            [8.937302716534663, 0.3565728410665012],
            [8.955858276268104, 0.3498649028230794],
            [8.961721948023836, 0.34331554410784043],
            [8.961890854686464, 0.3414128842989712],
            [8.955540845486999, 0.3371589302467129],
            [8.954832908492731, 0.32562136131941377],
            [8.947849407796612, 0.310636431578474],
            [8.945789452077193, 0.2975049466631425],
            [8.946906518422736, 0.2941884336225025],
            [8.950969232621224, 0.2915815352998455],
            [8.956130791137717, 0.2925911292131363],
            [8.962906293545785, 0.3027017033883315],
            [8.9713304746617, 0.3078813504377883],
            [8.979429377391822, 0.30917951930785587],
            [8.984254312661308, 0.30763093551050347],
            [8.98611154197785, 0.30445187316673344],
            [8.979044640121407, 0.29298128665786005],
            [8.976636471590405, 0.2853593421155142],
            [8.977897764628413, 0.2794615113048779],
            [8.980195231988443, 0.2774293384987197],
            [8.988178325760607, 0.2760399507636635],
            [8.99659467585036, 0.2729268998126341],
            [9.006360061483596, 0.26681655948573946],
            [9.010987092717764, 0.2585760857237112],
            [9.012185563713912, 0.25056566317524775],
            [9.010138951237593, 0.24545805543687912],
            [9.009572092576452, 0.23833340677399695],
            [9.00572437773248, 0.2295470727340578],
            [9.011328142965867, 0.2229198059409808],
            [9.017316063445069, 0.2198400504438542],
            [9.025280661079117, 0.2224146124987933],
            [9.02613612934208, 0.22660159783741962],
            [9.023448438463447, 0.24519413825999817],
            [9.024402385198053, 0.250070742434965],
            [9.02917867809948, 0.2576362616963828],
            [9.033765830227361, 0.26076058702906085],
            [9.040067209808647, 0.25873935334522125],
            [9.044926313431787, 0.2522275817643394],
            [9.045402040886906, 0.24671696811102645],
            [9.035777535626746, 0.23888957186114318],
            [9.032853725386786, 0.2319227080782532],
            [9.0360861071749, 0.22711395721884142],
            [9.042518586096161, 0.22748392529977418],
            [9.047658841102775, 0.22495179979740274],
            [9.059084219392927, 0.22338206624947865],
            [9.070179660812437, 0.21989430640654642],
            [9.072114617848834, 0.21609340913910724],
            [9.0683346298646, 0.20754285758213198],
            [9.067437693629644, 0.20112260736465987],
            [9.063451318373865, 0.19312470143618343],
            [9.061882816103447, 0.18782448263223686],
            [9.06231352686169, 0.1771069494694844],
            [9.06604426415844, 0.17382459732718444],
            [9.080601604533532, 0.17304277963124765],
            [9.086892638657742, 0.1694981243610258],
            [9.088670724613355, 0.1629448681238408],
            [9.086651614375896, 0.15737846652754317],
            [9.078012770448067, 0.15634443475188894],
            [9.074878141297601, 0.15291675896154713],
            [9.069963266621228, 0.15384027635687877],
            [9.056934102173408, 0.17227591509661358],
            [8.991023101696342, 0.12467582790522026],
            [8.851164874449676, 0.12296249069083633],
            [8.768212173044631, 0.12194330685993206],
            [8.756787013261444, 0.1367689203327938],
            [8.730574262544886, 0.1644592592943267],
            [8.721015490294867, 0.20304820435495527],
            [8.708137223872878, 0.2182911282388678],
            [8.728334170887518, 0.25365646422707],
            [8.72910818476815, 0.2542417823456253]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.11898309618473,
          "lat": 38.448481417012985
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21103"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00516898"
      },
      "bbox": [
        8.708137223872878, 0.12194330685993206, 9.088670724613355,
        0.37986297658015816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.654156221731597, -1.1954365274191907],
            [9.659736502555532, -1.1903841161594106],
            [9.66307717889658, -1.18182556189738],
            [9.660086226243218, -1.1703792994251283],
            [9.657078034164407, -1.1667190390103117],
            [9.658726661207853, -1.163552080452503],
            [9.664375924455026, -1.1627287571967544],
            [9.668334877582167, -1.160699657558518],
            [9.673066112954853, -1.154268422846499],
            [9.6813875678343, -1.1514620319823954],
            [9.683284396178626, -1.1433507261617468],
            [9.680147998556178, -1.1399990648233953],
            [9.672137672144174, -1.1360853651629264],
            [9.668955025235181, -1.1325783132359573],
            [9.666730488006618, -1.1277944184032642],
            [9.668995914479934, -1.12357033644695],
            [9.675615261339807, -1.1223819321752928],
            [9.679133122614383, -1.1274534415317747],
            [9.684008217240605, -1.1244108137576518],
            [9.684751106750562, -1.1177458617617961],
            [9.687570225214209, -1.110963466832082],
            [9.684812243727714, -1.1086495911476597],
            [9.681533799286477, -1.1121491831214214],
            [9.676317889585983, -1.110222166222385],
            [9.67481219654968, -1.1043151573403698],
            [9.675930873314122, -1.0993107022937905],
            [9.673728580966115, -1.0928509058464946],
            [9.667204453695916, -1.0892876136180545],
            [9.66721411296769, -1.0832076543170348],
            [9.671404449577286, -1.080266250546457],
            [9.673646346888797, -1.0732675711482613],
            [9.677749850542638, -1.0723281525147634],
            [9.682176715191353, -1.069086182108303],
            [9.68267551465217, -1.0615742389881129],
            [9.684903305829764, -1.0602203694175993],
            [9.690608986042195, -1.0608722648490736],
            [9.69555312057801, -1.0582163425449422],
            [9.693214995605194, -1.05315206911907],
            [9.697605466669621, -1.0451291853616071],
            [9.688282936530287, -1.0376553749648927],
            [9.686135994505495, -1.0346811527244955],
            [9.68925843688425, -1.0325204577115654],
            [9.69485846982935, -1.0328359507619014],
            [9.696293649479623, -1.0272156220523045],
            [9.68916615116331, -1.0242532779300588],
            [9.684463696934428, -1.0271904661554478],
            [9.681896603865374, -1.0263535582956826],
            [9.686932062514174, -1.0183061982298456],
            [9.683951529962188, -1.0126701907590325],
            [9.684100079210411, -1.0077668065054606],
            [9.681721152856019, -1.0039280604444814],
            [9.684441227660892, -0.99605116517311],
            [9.684520664369, -0.9895652146024052],
            [9.682963109761012, -0.9852219464422985],
            [9.678447607759944, -0.9847209138917041],
            [9.67414503335098, -0.9810427379040553],
            [9.674503373741203, -0.9776220175192984],
            [9.685155762835349, -0.9744334809463677],
            [9.690418760185823, -0.9691148976162935],
            [9.69707435614294, -0.9665672756265544],
            [9.699082142738826, -0.9637494046658966],
            [9.695179362410318, -0.9597399650741318],
            [9.688024171885374, -0.9589708728547504],
            [9.685097106232071, -0.949447205310485],
            [9.690085885910376, -0.9452803783427474],
            [9.698035918713765, -0.9446431969056903],
            [9.701318883610812, -0.9389403521037254],
            [9.690959186891034, -0.93438516863113],
            [9.690369681898293, -0.9321315950938639],
            [9.696772376760222, -0.9272037462284587],
            [9.692768441808871, -0.9231224375196312],
            [9.6944005214571, -0.9200418153704999],
            [9.699021956173294, -0.9169502002149958],
            [9.69914825636781, -0.9109614904895865],
            [9.700799976311316, -0.905165849432798],
            [9.703659006220002, -0.9040059456987798],
            [9.706354059833949, -0.9097215128330673],
            [9.712502162475932, -0.9143901781885652],
            [9.716170112981859, -0.9114077863601975],
            [9.712300717499323, -0.9042615405742477],
            [9.713259921820354, -0.8983816731164155],
            [9.716410926149736, -0.8938192849537],
            [9.718931423722871, -0.8939136063221638],
            [9.720883050147917, -0.9000367114943161],
            [9.725607370107907, -0.9022392970792326],
            [9.728929750363855, -0.8982583234028864],
            [9.725447378753326, -0.8602082420199376],
            [9.73694062521994, -0.8589756336650545],
            [9.740148277519767, -0.8525152136255746],
            [9.745701461967931, -0.8508338700121938],
            [9.746675940210409, -0.8450141421182543],
            [9.750023372916328, -0.8424794836351748],
            [9.752354412624598, -0.8374943330624833],
            [9.750740785337412, -0.83293812195379],
            [9.758192511658395, -0.8304413495554782],
            [9.75868977679757, -0.8360905468204345],
            [9.764228416047743, -0.8347096157429755],
            [9.768197110772695, -0.8312730366862299],
            [9.775587865647843, -0.8313575375052642],
            [9.777645256419586, -0.8242249679600603],
            [9.782210690837697, -0.8238071194892816],
            [9.78428106178452, -0.8192460744348221],
            [9.78173833038256, -0.8129752092159538],
            [9.783801883628794, -0.805821128831818],
            [9.788180924519805, -0.8019744617482545],
            [9.787303937456468, -0.7979673495806585],
            [9.78986364314928, -0.7958091590941891],
            [9.79445290502094, -0.7951075038930692],
            [9.799105583626314, -0.8009195286726352],
            [9.804191294282196, -0.80324035341353],
            [9.803662281750093, -0.8065816015817461],
            [9.80654517205049, -0.8107016647824778],
            [9.806294704188705, -0.813853207672162],
            [9.813607772375756, -0.8126073929166707],
            [9.816007069591569, -0.8162853292850066],
            [9.81132533153748, -0.8173549415187841],
            [9.807157233643666, -0.8216750531377506],
            [9.813892370873015, -0.8258659287611108],
            [9.819516976711096, -0.8320889378143443],
            [9.82779443140472, -0.8349193213168183],
            [9.833915977473664, -0.838966173277351],
            [9.835114962122411, -0.8422007038664027],
            [9.840293672065108, -0.8408207987564844],
            [9.84420615600394, -0.8422320682529553],
            [9.84691891022669, -0.8394064430549347],
            [9.856239160317427, -0.8420157306351785],
            [9.85119532525199, -0.8487194724450211],
            [9.852142199770022, -0.8538246062243368],
            [9.860176617979288, -0.8571557700478035],
            [9.86113272276191, -0.8559154311647353],
            [9.893549053455846, -0.8664588511176402],
            [9.942300539309471, -0.8630998086910896],
            [9.950529998367696, -0.9084115424079366],
            [9.949742901044079, -0.9128009380481392],
            [9.945780952426999, -0.9137600462704442],
            [9.94405847567471, -0.9188812576207019],
            [9.945163701452934, -0.9254984699046171],
            [9.942215026065702, -0.9267688423233309],
            [9.941385027509963, -0.9334005308002283],
            [9.932195507114539, -0.9414912569548856],
            [9.933201421327023, -0.9488630184835642],
            [9.936870554033808, -0.9499877957145074],
            [9.951229652578235, -0.9623258787940892],
            [9.961037459737307, -0.9749106932499225],
            [9.96634425280247, -0.9842097191372214],
            [9.9649890212759, -0.9897503836912325],
            [9.967571920410968, -0.9936261710017732],
            [9.974375874822607, -1.0002594851400128],
            [9.97932702700974, -1.0016452607714186],
            [9.982282936427575, -0.9983098198521853],
            [9.986624702226152, -0.9976132495384101],
            [9.991403030548186, -0.9994010027874501],
            [9.999994254021008, -0.9916793846346298],
            [10.004603334154577, -0.9892690692793887],
            [10.008911147444993, -0.9935700099745846],
            [10.008027920188054, -0.9987540683982592],
            [10.0159074047089, -0.9987748416695884],
            [10.021324172900476, -1.0021145929974378],
            [10.021665206579549, -1.009157090040715],
            [10.026258368541193, -1.0143865647132622],
            [10.024282599643174, -1.0190912280309938],
            [10.01948518255676, -1.0263542693853458],
            [10.017668942918785, -1.024379551569401],
            [10.013988021884561, -1.029982362554626],
            [10.009780278671059, -1.0307089124431885],
            [10.008602053914107, -1.0331825060818702],
            [10.012227847702093, -1.0407728421375595],
            [10.012847190325994, -1.046250682583247],
            [10.017938842293255, -1.0442209277187624],
            [10.023399450502769, -1.0484081437021942],
            [10.024054466218676, -1.0517612830233019],
            [10.022161943090666, -1.053425929571612],
            [10.021395825467211, -1.058423917217299],
            [10.01501379376078, -1.0652287276291155],
            [10.010178494862785, -1.0647927353095252],
            [10.008345510139355, -1.0681775002947655],
            [10.004402662127132, -1.0713508558443698],
            [10.000099355624613, -1.077707811408646],
            [9.991172195227154, -1.074708047753535],
            [9.986422937791566, -1.0754135973388055],
            [9.986199196906941, -1.0867125044250794],
            [9.983520178527087, -1.1032922163443923],
            [9.981067502089994, -1.105594871431236],
            [9.98123580135405, -1.112078513822049],
            [9.984211793958284, -1.1164075833649207],
            [9.981074352831936, -1.117460316450587],
            [9.976585126155213, -1.12405052022416],
            [9.969644718460977, -1.1272911485564006],
            [9.965106647243168, -1.1383184977120975],
            [9.958496464126258, -1.1377566554822192],
            [9.954528144144096, -1.1393392125648278],
            [9.94992728993957, -1.1386899311189598],
            [9.946630121492355, -1.13468141670993],
            [9.94194659284803, -1.1384107919896829],
            [9.93112443545161, -1.1383499802427584],
            [9.924437303835223, -1.1334458277087356],
            [9.9199232399857, -1.1377871951063514],
            [9.916475008388067, -1.1366611642394506],
            [9.913110954154329, -1.1328817187962983],
            [9.910624218336242, -1.136214715042059],
            [9.906232106187456, -1.134238025169989],
            [9.902174219351027, -1.139581758385697],
            [9.900330546521113, -1.1470638612512394],
            [9.890590924906869, -1.1487700799304446],
            [9.888446896470638, -1.1522012755167381],
            [9.884680569715185, -1.1495398876209706],
            [9.880223330487, -1.1515106775651243],
            [9.87385499341847, -1.1574766734951236],
            [9.872893543464896, -1.1627981985368507],
            [9.867129459499278, -1.1663307823888274],
            [9.863618851708456, -1.1728247633290774],
            [9.855979733518325, -1.1754945895437328],
            [9.855415389592265, -1.1695535791364435],
            [9.851629355578332, -1.1702913218347268],
            [9.846757780630751, -1.1684671271451774],
            [9.839175043857553, -1.1629257946432088],
            [9.835368290577936, -1.1619082885424565],
            [9.829011412468855, -1.1640105199428892],
            [9.828190701336586, -1.1730522988999648],
            [9.825314739761142, -1.176435671888592],
            [9.82160191850577, -1.1777720576290527],
            [9.820658294459063, -1.1717993205156196],
            [9.821143179545155, -1.166686231113801],
            [9.816008407698774, -1.1671090095254404],
            [9.816553944329694, -1.1793070665502805],
            [9.811683540502615, -1.181509243697423],
            [9.808341298849703, -1.184979701995906],
            [9.810475743200062, -1.187895796134705],
            [9.807216207732008, -1.1920363898920736],
            [9.800899572975212, -1.1966578002259949],
            [9.794021642362747, -1.1984666696960082],
            [9.791437666663226, -1.192945055745308],
            [9.78742163124485, -1.1908026684237745],
            [9.782456067615364, -1.1919454566648258],
            [9.780017379800233, -1.1940269836991706],
            [9.776424432188405, -1.1883745130180736],
            [9.77213070728822, -1.1933422334444679],
            [9.76556698791483, -1.1879100964220344],
            [9.764603600998056, -1.183712810174754],
            [9.760497940089605, -1.1813829471292332],
            [9.759198309245944, -1.184951600119016],
            [9.759976963755811, -1.1960506219262412],
            [9.755017216586086, -1.1991266103014284],
            [9.749868839201724, -1.1959767882072811],
            [9.750210751606977, -1.192583473089392],
            [9.74269109784261, -1.1882531269316783],
            [9.73827318443536, -1.190784618871094],
            [9.734888679023545, -1.1849703940031557],
            [9.730403772152096, -1.18242772712394],
            [9.732747298018666, -1.178799287166277],
            [9.733175896714918, -1.1737443538523553],
            [9.726783438724274, -1.1788946111281053],
            [9.727984708811041, -1.1833362452571774],
            [9.725221704624422, -1.1853676214442062],
            [9.718164932443191, -1.1851217200812034],
            [9.717707216075707, -1.1906590966164092],
            [9.711531763253232, -1.191710048825848],
            [9.708234008233692, -1.1986496815239807],
            [9.703430273925711, -1.2030555192047587],
            [9.699795373433364, -1.2028206229792222],
            [9.69538959013339, -1.2070250739933333],
            [9.691137044052292, -1.2083948415650865],
            [9.682111303645488, -1.205428768660936],
            [9.673131271373553, -1.2109387207472344],
            [9.666159220789368, -1.2142024991778038],
            [9.655739971789128, -1.2151061433441008],
            [9.651582322076827, -1.2136100173260087],
            [9.647856287995717, -1.210259393057624],
            [9.647793066263292, -1.2057330993300066],
            [9.653325681913179, -1.2007370458974547],
            [9.654156221731597, -1.1954365274191907]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.11776565809406,
          "lat": 37.110727048348615
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21125"],
        "coty_name": ["Laurel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Laurel County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00516909"
      },
      "bbox": [
        9.647793066263292, -1.2151061433441008, 10.026258368541193,
        -0.7951075038930692
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3228240941255023, -8.842073534154707],
            [2.3362510060856896, -8.824101840232975],
            [2.3429170049578185, -8.812571163270759],
            [2.35229842515738, -8.79211390380546],
            [2.3542820635685953, -8.786227392861726],
            [2.356387486424364, -8.771931305311218],
            [2.3610631328572325, -8.752604955492524],
            [2.3646903930682446, -8.744589462040903],
            [2.3730083209066457, -8.730369518688304],
            [2.3756587681373182, -8.720586601667508],
            [2.3782916445201434, -8.71655117883729],
            [2.385151592541301, -8.71214683351909],
            [2.3914519362700917, -8.710957790476675],
            [2.39402431957064, -8.705186922237823],
            [2.4009539279932874, -8.69597659593806],
            [2.4051263218424768, -8.691572308157532],
            [2.4136108847962414, -8.687670525803592],
            [2.4183229729302074, -8.682551844613018],
            [2.4186152416401403, -8.67399174830854],
            [2.4199843164351567, -8.669350152199726],
            [2.4334810271388347, -8.653996911914422],
            [2.522637096398152, -8.65214714080243],
            [2.5984571809273316, -8.65053672277313],
            [2.6891269565977627, -8.647867409386365],
            [2.7797961833545517, -8.645181522260577],
            [2.8097617977940534, -8.645020041360722],
            [2.8728579867314252, -8.64298955809119],
            [2.9459016682126355, -8.640030205697503],
            [2.946392374558542, -8.65421468058899],
            [3.0383595619719017, -8.651094050904252],
            [3.0602873318043624, -8.650623599720014],
            [3.1063378391123084, -8.649249934693602],
            [3.1713759934777896, -8.646731999343483],
            [3.204138013620366, -8.645859850910762],
            [3.2450700877370604, -8.644102494143082],
            [3.2670586757640274, -8.642947488661918],
            [3.2845064536139117, -8.644329729266282],
            [3.3892012132429334, -8.639911702013977],
            [3.3903048761858403, -8.654355329639191],
            [3.3911954695176707, -8.675176885633585],
            [3.3909710271835567, -8.678436775492353],
            [3.3923991441714842, -8.71205700319975],
            [3.392878468580859, -8.716513274402452],
            [3.394685042908434, -8.757638128603148],
            [3.399545966820121, -8.901939842481088],
            [3.405275006344376, -9.086943079116864],
            [3.3977785479992644, -9.084729768627886],
            [3.3965592289165696, -9.07956428258324],
            [3.387474061508548, -9.077023270532502],
            [3.383768308558019, -9.077459131313422],
            [3.3825537708443587, -9.081075201774716],
            [3.374043236969558, -9.080146343041536],
            [3.373568689550786, -9.078427419672774],
            [3.366116100782259, -9.078175469843247],
            [3.3522066381266122, -9.073653330532046],
            [3.337092330689653, -9.067127350967997],
            [3.327928725298312, -9.065195278732315],
            [3.3086165338084603, -9.05972786794234],
            [3.2952198510937722, -9.05487315313235],
            [3.280597169601051, -9.047402675675094],
            [3.2762181588083563, -9.043262351720312],
            [3.2677376770489666, -9.043036276993353],
            [3.2628305936313535, -9.041567867957124],
            [3.2483132496989917, -9.033987045057417],
            [3.243923703262656, -9.03249924932257],
            [3.2221040896036772, -9.022707731855329],
            [3.2107654169748017, -9.017261829063301],
            [3.198216904368496, -9.012671433615454],
            [3.172850755268574, -9.00145304468558],
            [3.1242150602133223, -8.979338350735736],
            [3.113344537892391, -8.975193302167849],
            [3.0970173940796366, -8.968259772019715],
            [3.083139577952312, -8.96359439300285],
            [3.0732693692672517, -8.9615561883384],
            [3.060307074877214, -8.961362190987213],
            [3.0568875366200037, -8.955944170462256],
            [3.039886324980516, -8.950246113823054],
            [3.0103229882675975, -8.941970158480368],
            [2.9989205575861675, -8.940277340717905],
            [2.9899772663246975, -8.937997312086098],
            [2.950495511647057, -8.928879213908255],
            [2.912418383235601, -8.920310213609381],
            [2.88060793618802, -8.916159730388653],
            [2.8614723574275356, -8.914712322993278],
            [2.8482838587399457, -8.914869837782653],
            [2.819916528301774, -8.918218412458613],
            [2.8044391896467435, -8.921781006048828],
            [2.788279915184575, -8.926517596611486],
            [2.765647959139531, -8.932245509838477],
            [2.748396366396246, -8.931291803702932],
            [2.7273008747813865, -8.929316590437061],
            [2.7047906998771056, -8.928393544819551],
            [2.685226457726962, -8.928189964700968],
            [2.6569501475008734, -8.928618661358737],
            [2.6385092259697682, -8.929638293700165],
            [2.6233947692808144, -8.931356859400731],
            [2.602748459748249, -8.934540600225366],
            [2.571738672957219, -8.939817688500364],
            [2.5537791628801223, -8.943329528643021],
            [2.5153634225768196, -8.948500541540438],
            [2.474975731888219, -8.955772392573639],
            [2.4497913208294744, -8.961188992674568],
            [2.425227902714252, -8.967463025261157],
            [2.402824539727054, -8.97548842948064],
            [2.39051303776724, -8.980713999525996],
            [2.376303004411881, -8.988388978552214],
            [2.371165190097902, -8.990392443832384],
            [2.361126118322543, -8.996123693890903],
            [2.345419172284083, -9.008291137938656],
            [2.3409753418709767, -9.014075020085068],
            [2.3183177917828854, -8.981529249722426],
            [2.3121469068054745, -8.97037446016071],
            [2.308693609115027, -8.968189087362411],
            [2.2956839579050072, -8.96406272601926],
            [2.293187908885784, -8.961760741525971],
            [2.291099636824818, -8.953487549659668],
            [2.29351718621719, -8.944892859975978],
            [2.2907549474567057, -8.939401067806973],
            [2.2866634295261776, -8.935251080701452],
            [2.265608538338979, -8.922389382607024],
            [2.2619573407289284, -8.918006878595518],
            [2.259795569891588, -8.910617764480595],
            [2.259320749027369, -8.904821636569876],
            [2.2602290855561176, -8.898188645186755],
            [2.264578029609178, -8.889028706808451],
            [2.26997650333117, -8.882820144385478],
            [2.2832599584843924, -8.870664595976903],
            [2.291830876514337, -8.864353052999803],
            [2.307440091594976, -8.855611123870501],
            [2.3150062571604475, -8.849976655069513],
            [2.3228240941255023, -8.842073534154707]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.19373279705717,
          "lat": 29.875429658607814
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22023"],
        "coty_name": ["Cameron"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Cameron Parish"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00558488"
      },
      "bbox": [
        2.259320749027369, -9.086943079116864, 3.405275006344376,
        -8.639911702013977
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.649431121156811, -6.512508215744361],
              [4.642534908512698, -6.513079301706451],
              [4.630408490768517, -6.50982429685256],
              [4.63102292968569, -6.489878993291239],
              [4.63298047155209, -6.483777767478725],
              [4.631594229645563, -6.476649609938137],
              [4.626212670523218, -6.470528086310934],
              [4.623129440797458, -6.463188253671032],
              [4.623127379230787, -6.4534876866716955],
              [4.630069734077798, -6.455628608164275],
              [4.637338153142359, -6.459152123302788],
              [4.652097774671201, -6.470384754803063],
              [4.659253496237957, -6.471711996234776],
              [4.670713511383526, -6.469913515371945],
              [4.6705437965343215, -6.485822808021555],
              [4.668936100009971, -6.492106744653405],
              [4.664856751209292, -6.5011183971670805],
              [4.658356972014462, -6.5090567777839965],
              [4.649431121156811, -6.512508215744361]
            ]
          ],
          [
            [
              [4.260677049244938, -6.246748209513133],
              [4.256524656766914, -6.244086937801298],
              [4.251641738996226, -6.238886317451598],
              [4.253238410580257, -6.233377345956898],
              [4.25073547584122, -6.228085999269041],
              [4.250859306443926, -6.2179481253956945],
              [4.254026881489421, -6.213968656630207],
              [4.259598328769589, -6.215745488948162],
              [4.259880460505552, -6.2110767246298195],
              [4.256859597088016, -6.206337101594336],
              [4.259501559060893, -6.20274938399025],
              [4.259663020383306, -6.199509237464641],
              [4.256653792746154, -6.188900171351097],
              [4.253970699247169, -6.183616694190952],
              [4.2509213781187, -6.181135704545615],
              [4.252238638042786, -6.177348281152008],
              [4.249558970953701, -6.175917630646309],
              [4.249974972582643, -6.170899657449446],
              [4.248696278706881, -6.165549325347977],
              [4.251907427141069, -6.161544063335972],
              [4.249299002562786, -6.157816889069293],
              [4.251605028163423, -6.155276618359748],
              [4.248726363019362, -6.149844522983459],
              [4.252572962666888, -6.14986881709227],
              [4.255433728378566, -6.14249347457373],
              [4.25795808949105, -6.1327183470702025],
              [4.260919458848618, -6.129740075010281],
              [4.262056607871384, -6.1251174451679695],
              [4.259571842173506, -6.121472397780264],
              [4.2609109179986895, -6.117719007884457],
              [4.270158428648334, -6.113902166969119],
              [4.396521825292331, -6.107680546070668],
              [4.457329434817612, -6.105036721943653],
              [4.5418241680763405, -6.100459130696992],
              [4.543956445072291, -6.094294678357923],
              [4.562094893860617, -6.082148839260531],
              [4.561929661912129, -6.0751047491231],
              [4.593227199832439, -6.0731590710609975],
              [4.585018047752925, -6.079688488946981],
              [4.589730330044005, -6.0891827493887325],
              [4.601724603272693, -6.09884696718759],
              [4.610820106224204, -6.103941384343037],
              [4.63871662987995, -6.112374753509865],
              [4.648502497408027, -6.116517671276607],
              [4.659135800785893, -6.123730910177734],
              [4.664641743643075, -6.131221875076334],
              [4.666099091958757, -6.139609740049433],
              [4.663728088619367, -6.144377710830618],
              [4.656862699697483, -6.149877560680541],
              [4.652713428626044, -6.15057026698973],
              [4.635879430017876, -6.148345471842622],
              [4.62387866293993, -6.143763770086198],
              [4.6171607116745035, -6.139007521374034],
              [4.612648157254792, -6.134636012043945],
              [4.603961571457253, -6.122848893905875],
              [4.594803993253465, -6.107492230090087],
              [4.590885991253226, -6.102391574111281],
              [4.574229746627836, -6.087567377309915],
              [4.570993703733645, -6.092115357758009],
              [4.57132508212248, -6.099646173818091],
              [4.569118079061661, -6.111389175189632],
              [4.564913195774495, -6.122282852373621],
              [4.557534945656559, -6.137472978209277],
              [4.55729574504792, -6.142591050704304],
              [4.558999274931132, -6.154416243517482],
              [4.5656053548560775, -6.165190189103987],
              [4.577606514933741, -6.177887676106399],
              [4.589352216906044, -6.185592148178999],
              [4.599350423667358, -6.190382033946219],
              [4.614200783119681, -6.196319865198817],
              [4.6339893737624385, -6.200197353705846],
              [4.636708270751041, -6.199154934602555],
              [4.644612099352647, -6.192837046391487],
              [4.654133527557267, -6.186935124259579],
              [4.658787432006855, -6.182262941372862],
              [4.663034503353357, -6.181354720664082],
              [4.671877811103828, -6.1826656102568185],
              [4.676072811281001, -6.184492341901777],
              [4.6839807256928845, -6.1916261505089505],
              [4.686905926610063, -6.197099848340496],
              [4.687758750629719, -6.209908782118027],
              [4.686637381911783, -6.212718552017368],
              [4.681358836092334, -6.219280477626731],
              [4.676307874899371, -6.22330758138306],
              [4.665339920538462, -6.228268167829986],
              [4.6659664788364354, -6.2353256531403325],
              [4.6643671814993715, -6.244133988241341],
              [4.661042033500594, -6.250730460706988],
              [4.65848382657982, -6.264375090137786],
              [4.659639683656235, -6.270318229924692],
              [4.662727514005876, -6.274610000016541],
              [4.668358426020915, -6.277965781914902],
              [4.6743137358132305, -6.2799421384124],
              [4.70155406482429, -6.284413301603919],
              [4.711284598012256, -6.283801710938213],
              [4.718121135822838, -6.284429241895379],
              [4.729795427264316, -6.286705543909241],
              [4.737326842840272, -6.28892571144964],
              [4.748775727696096, -6.27339765935522],
              [4.752683920980338, -6.256956388422064],
              [4.755151144276543, -6.254155116019393],
              [4.764020795434576, -6.252376890430237],
              [4.766364876662534, -6.254367021635834],
              [4.76169261827289, -6.269512093708309],
              [4.747586782770054, -6.297460229715216],
              [4.74752732596633, -6.304461294405419],
              [4.744651071420308, -6.312509052011012],
              [4.736071020911365, -6.324888678745067],
              [4.7218070661540334, -6.338893064315981],
              [4.710549005875373, -6.346349881841726],
              [4.707610745185378, -6.346792352177616],
              [4.704043940278851, -6.343937180814872],
              [4.6961349478126495, -6.333717701477598],
              [4.6898092512695, -6.333425538603953],
              [4.686039350481157, -6.33467143993675],
              [4.682487942114377, -6.3399007974119135],
              [4.6802991269575696, -6.351477517609461],
              [4.68172860498073, -6.36106696385743],
              [4.684786532027641, -6.365950565668815],
              [4.692173775524347, -6.37307526643263],
              [4.6940820859224655, -6.378198923066874],
              [4.688658080443968, -6.382914018349644],
              [4.685408775907553, -6.387577442225222],
              [4.683666912330091, -6.399903025334283],
              [4.68423140924254, -6.420604112095982],
              [4.680297513261677, -6.430160582972396],
              [4.675638892820943, -6.439584424331276],
              [4.670601111179668, -6.4391680061298056],
              [4.669296837721006, -6.436175705649753],
              [4.66670216955005, -6.419651979618694],
              [4.667491483434161, -6.409074055926885],
              [4.661696828103206, -6.406276043358164],
              [4.651168553269545, -6.396823334209179],
              [4.640128769551812, -6.391996122163389],
              [4.636137478128448, -6.391403194703212],
              [4.629898227470072, -6.392927262899287],
              [4.626872551269273, -6.39628501590093],
              [4.625042527410661, -6.406381530805111],
              [4.618551578104452, -6.416019489868998],
              [4.610012773437805, -6.409058676826169],
              [4.606598852637915, -6.408234461740331],
              [4.5994021052400305, -6.409205195488972],
              [4.592477074915777, -6.412161760890652],
              [4.585810863414939, -6.418505075266821],
              [4.579503851876365, -6.428529845190835],
              [4.572215219122703, -6.430384812281032],
              [4.566292569871393, -6.426250573511069],
              [4.568404464163851, -6.424206482506504],
              [4.565682811052929, -6.416880100516061],
              [4.566789627687591, -6.407265678191846],
              [4.565097854568277, -6.403618175425226],
              [4.5672517702691255, -6.398128931120231],
              [4.556140267946498, -6.388524817145679],
              [4.551366771983379, -6.388439681088936],
              [4.544472563099617, -6.389937383975697],
              [4.53452486857258, -6.394354909329628],
              [4.514484140244185, -6.3945403355539225],
              [4.49877195981257, -6.401264016187008],
              [4.488272604558866, -6.408229617196881],
              [4.482633643038157, -6.41389760535707],
              [4.478478667860173, -6.419697982872124],
              [4.473223438754387, -6.432010465344045],
              [4.467381056406262, -6.430373418829594],
              [4.460866133855289, -6.425232063467622],
              [4.457282954409774, -6.42042660200403],
              [4.45475128067249, -6.420790344578713],
              [4.44899442173848, -6.417087466740856],
              [4.44480392272295, -6.418716253220746],
              [4.443374708232451, -6.414159463306035],
              [4.440738509585097, -6.41275272732231],
              [4.437498287140205, -6.415638302061221],
              [4.436602073395339, -6.419989073160711],
              [4.433556677658483, -6.423139793284524],
              [4.425924416403952, -6.4249113958071415],
              [4.4200223634372255, -6.424949012103878],
              [4.410489047837257, -6.432357941715985],
              [4.407015957871788, -6.43239032900256],
              [4.403028697039704, -6.437601917390998],
              [4.400810074988047, -6.442711625201202],
              [4.255991980009703, -6.449339467442127],
              [4.250440189880842, -6.449066093815818],
              [4.220375428306092, -6.450149971006561],
              [4.217863441955771, -6.446643671038505],
              [4.212686150539456, -6.44857897271178],
              [4.2104891882153295, -6.446275622291919],
              [4.216208351303466, -6.435587900555407],
              [4.219489683327845, -6.432938868389766],
              [4.22543874572049, -6.431952822768101],
              [4.228101810741838, -6.433066131955291],
              [4.23282724731252, -6.43021289805822],
              [4.23681119304855, -6.42272024142013],
              [4.2368192375298275, -6.418067884876161],
              [4.240689632554396, -6.409113950979119],
              [4.238433655968654, -6.407019832672119],
              [4.236026023269878, -6.413271051496377],
              [4.233208487575241, -6.417090261602801],
              [4.228012412751191, -6.419576723733448],
              [4.216764850006499, -6.417968589831907],
              [4.2132324826240595, -6.4162534241828055],
              [4.200190369538033, -6.404507515693017],
              [4.203779417509102, -6.3973082572249815],
              [4.2117846123543545, -6.395654243167845],
              [4.218060586838741, -6.399715599986287],
              [4.221078362158028, -6.404414832658065],
              [4.226015910767604, -6.4041508679990775],
              [4.22835460546336, -6.4008411894738115],
              [4.2263973759831215, -6.39302726178201],
              [4.227004995756106, -6.376982954372095],
              [4.22187290469164, -6.362971806208238],
              [4.221609385249107, -6.3588123078312275],
              [4.22351272055982, -6.353431096697441],
              [4.228273611928234, -6.351834775471659],
              [4.235388757858258, -6.354437646916883],
              [4.242031031185416, -6.360498872352598],
              [4.243433968999152, -6.357981342400304],
              [4.243706989611204, -6.347864093613357],
              [4.241970569499754, -6.338940370158419],
              [4.2440733200895595, -6.337306961528596],
              [4.251777348163758, -6.337167966530907],
              [4.258969339812194, -6.334716721817747],
              [4.268991286824164, -6.334444467228002],
              [4.268944786223852, -6.331124603014102],
              [4.264937174955791, -6.3190241790626045],
              [4.266888575151016, -6.314378039402439],
              [4.265300549862022, -6.310649776473329],
              [4.26233144461063, -6.3093487677085305],
              [4.252042086251079, -6.313483457907786],
              [4.248418368469322, -6.31413457352477],
              [4.243493874242576, -6.310408100219659],
              [4.243270798858993, -6.305445640068723],
              [4.248146290493126, -6.29718852538919],
              [4.250962099433145, -6.295312925846506],
              [4.255180362364242, -6.2862876722515315],
              [4.257395614462785, -6.286549142504939],
              [4.257426735009471, -6.291910178456901],
              [4.259696065665803, -6.297145268971353],
              [4.263202029352204, -6.300092723258564],
              [4.2721334462051965, -6.300744864302458],
              [4.274583543149073, -6.299756180469333],
              [4.282978543790877, -6.2930762440965955],
              [4.284439464014973, -6.289477025268524],
              [4.283249314555545, -6.282704324606211],
              [4.279491067800087, -6.279148246910958],
              [4.269233928971806, -6.273187070609839],
              [4.26224343365669, -6.267101925936582],
              [4.2583685916082334, -6.255964932831779],
              [4.254229708455947, -6.254876896576926],
              [4.255213724684773, -6.250315704889341],
              [4.261166201619827, -6.249482736162121],
              [4.260677049244938, -6.246748209513133]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.24272312153242, "lat": 32.36447020181397 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22065"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Madison Parish"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00558088"
      },
      "bbox": [
        4.200190369538033, -6.513079301706451, 4.766364876662534,
        -6.0731590710609975
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.672661900483988, 2.2859291275949682],
            [15.680204656045301, 2.2801893158065307],
            [15.683140230482692, 2.2798726263737707],
            [15.686165563280769, 2.2826274841194327],
            [15.688129014886597, 2.287411470057346],
            [15.692629091578043, 2.2903055450359897],
            [15.697967465773463, 2.2913213362719724],
            [15.704123225418039, 2.2904781962731917],
            [15.707929714401143, 2.2872428306981702],
            [15.712228727917669, 2.2873408717333237],
            [15.717302834136783, 2.2922638851164368],
            [15.721478993229672, 2.292631256879935],
            [15.725127663994082, 2.2895485156195576],
            [15.73108409667011, 2.2901400477829017],
            [15.736746575528374, 2.289205106317759],
            [15.745482841114347, 2.2924924235552595],
            [15.754694767673218, 2.2892821073957883],
            [15.756179764088962, 2.293195461104958],
            [15.766309399043271, 2.2989679088828336],
            [15.771275877931417, 2.2998258160919023],
            [15.776121776152193, 2.2977227300128154],
            [15.784525110218649, 2.306150118240226],
            [15.792239205478142, 2.3111069447009776],
            [15.796324719259404, 2.3194570680157534],
            [15.807311612038102, 2.3201070198479323],
            [15.810399819722468, 2.3177285972072252],
            [15.813412911853185, 2.3195369412686375],
            [15.81811936279198, 2.3198480405558053],
            [15.818698987680994, 2.322556929958809],
            [15.825919731991766, 2.3247534371544027],
            [15.828028939427767, 2.327026867205069],
            [15.832219485962055, 2.3247674811207664],
            [15.834875057010763, 2.3258216942749583],
            [15.839785628876923, 2.3248305952066595],
            [15.861939320749864, 2.246311170436975],
            [15.875872763175444, 2.196945630775693],
            [15.866700853473763, 2.1964766648669802],
            [15.854727875843622, 2.1914642361172207],
            [15.846243375189102, 2.185673761962158],
            [15.838965230164897, 2.184768060946873],
            [15.835402736245205, 2.1872675777651476],
            [15.827764647918166, 2.186701284735328],
            [15.815334713345242, 2.191762444243427],
            [15.811088608514728, 2.1920600814548266],
            [15.807032535851723, 2.194258374055541],
            [15.799422452455042, 2.194914415239448],
            [15.7899839002973, 2.1936985093058676],
            [15.785506602135683, 2.185900347711991],
            [15.786505591260028, 2.1815375752788975],
            [15.781664174255788, 2.1822807560957456],
            [15.777952799570723, 2.1790827089345326],
            [15.775008095925184, 2.182280742969049],
            [15.770814366739737, 2.1809359182890597],
            [15.772041183743134, 2.1764796152148196],
            [15.75527849191192, 2.1681298718638637],
            [15.748161084068535, 2.167017363474798],
            [15.738926873369488, 2.1596704729531484],
            [15.735850374061101, 2.1596381471837165],
            [15.732264769360741, 2.1622671575381407],
            [15.726969501219532, 2.159240972746292],
            [15.721756557438773, 2.1596023435274967],
            [15.71500175288203, 2.162663430824974],
            [15.71017613333777, 2.16001545744352],
            [15.704271782530142, 2.1600879112884113],
            [15.703425629060705, 2.152905495775441],
            [15.695452853624344, 2.1499404850577286],
            [15.686510179104797, 2.149523880380923],
            [15.68143828575115, 2.135943587237345],
            [15.67586670412634, 2.133497350321285],
            [15.657934042360734, 2.1133354697946074],
            [15.656384864500914, 2.110077333796181],
            [15.654779704920593, 2.100796758481418],
            [15.652528982671361, 2.0936255795666843],
            [15.657418752923336, 2.0867210099739992],
            [15.6661203413966, 2.0870336865322145],
            [15.671586628162592, 2.085721729695194],
            [15.677575227660894, 2.0812595212017717],
            [15.678891234693577, 2.076157019938458],
            [15.677743836718582, 2.07184713057145],
            [15.673623891157908, 2.0667279242007788],
            [15.664057243234275, 2.0576957555760758],
            [15.657286161088523, 2.05443796570379],
            [15.65380797031241, 2.051329011856078],
            [15.652302015009946, 2.047483137143746],
            [15.65890569927019, 2.0424420469311197],
            [15.661282731375927, 2.0386779398887653],
            [15.66013084420499, 2.0349979295182012],
            [15.652794714537716, 2.030467617615161],
            [15.647233646653719, 2.0249454085922345],
            [15.634161280834556, 2.001791840601288],
            [15.630274014639854, 1.9986453233695656],
            [15.621660924855663, 1.996329097135225],
            [15.615916693408474, 1.9983100138502468],
            [15.613595764576898, 1.9958956499683638],
            [15.6082374412356, 1.9973298288519532],
            [15.60067145067597, 1.9913082788414527],
            [15.600561006806801, 1.9832019036251283],
            [15.596908719743023, 1.982809565685674],
            [15.59568202218992, 1.9870199886175848],
            [15.59704325184394, 1.9963212340182646],
            [15.594118865074721, 1.9981178384622778],
            [15.583100518242665, 1.9935440423423394],
            [15.585762914681604, 1.9805293705366653],
            [15.580452405720518, 1.9733703434785927],
            [15.578675408791224, 1.9727111949713851],
            [15.57260027078346, 1.9780301336025587],
            [15.568206435215027, 1.9767277313230935],
            [15.56906339611008, 1.9724442160607276],
            [15.573736679428784, 1.9668535582726148],
            [15.573052587918863, 1.9640389868291286],
            [15.5746014604264, 1.95816378364905],
            [15.57345469103466, 1.9531393466099927],
            [15.570766263641937, 1.949829374636395],
            [15.57478061460965, 1.9397336762559296],
            [15.57480358839442, 1.9361185609123697],
            [15.57155668813331, 1.9329547616956806],
            [15.576966889549539, 1.926402274933003],
            [15.576071298425259, 1.9214855125780799],
            [15.581812198997886, 1.9142768277983695],
            [15.581292816351501, 1.9080780017466883],
            [15.586898586334616, 1.9012977117087493],
            [15.590217215102413, 1.8959558780211079],
            [15.586555871853893, 1.8947647704113384],
            [15.584922862136597, 1.8899468160160473],
            [15.580056933299355, 1.8901663685317913],
            [15.578335590277167, 1.8933354030007208],
            [15.573100168914413, 1.8940363479795912],
            [15.569192057128529, 1.8967172658615654],
            [15.566378241563726, 1.8960906937468174],
            [15.562843878926271, 1.900437883751704],
            [15.555985829584627, 1.9046330580783994],
            [15.555061781674507, 1.9156503442370012],
            [15.556759412882398, 1.9219102956001444],
            [15.5614214894564, 1.9247395463245325],
            [15.564833815858034, 1.9284708319925086],
            [15.561972575898753, 1.9313838888971147],
            [15.5580054635414, 1.9381538028765206],
            [15.552983842568308, 1.9595855414425332],
            [15.546234967239368, 1.9757418428705094],
            [15.53922701930902, 1.9835989238319223],
            [15.533816158831858, 1.9925507988759212],
            [15.53528582216332, 1.9962562504941206],
            [15.533158133132698, 2.004716200437156],
            [15.529777632393222, 2.0049586381199926],
            [15.522944572085319, 2.00781176575173],
            [15.514948723081913, 2.0146461297428675],
            [15.50644824303897, 2.0151573112644363],
            [15.504349277435388, 2.0203062320318357],
            [15.503521456443922, 2.0344053341468245],
            [15.506430991964685, 2.050517980929737],
            [15.512217813554003, 2.063152798653432],
            [15.514235867784707, 2.0714338525633593],
            [15.516943827357956, 2.094544289502128],
            [15.521377626787505, 2.1081276234867876],
            [15.523111181989675, 2.1197993045110146],
            [15.523472843059666, 2.1337356376084484],
            [15.527772292874513, 2.14532933683776],
            [15.5293795988274, 2.1474215286379956],
            [15.534903344303377, 2.147375325491397],
            [15.536131812007325, 2.150942641409133],
            [15.534555517591965, 2.155334300670674],
            [15.535620435206075, 2.159273335681447],
            [15.542780335976596, 2.1621431595033473],
            [15.545320596730589, 2.1668283958686234],
            [15.546051557707205, 2.1727882815058552],
            [15.549144458907117, 2.1739722839739146],
            [15.554471003990331, 2.1716847030575765],
            [15.556881089918228, 2.174375518368839],
            [15.556422549931408, 2.1787362709121862],
            [15.552355758039727, 2.18166954932033],
            [15.547183985408488, 2.182382277120491],
            [15.548206439521252, 2.186655031324045],
            [15.545088566611279, 2.1922804524625654],
            [15.539396857324618, 2.1935146358760513],
            [15.538293169127801, 2.200367124312187],
            [15.54487898382786, 2.206085225656111],
            [15.546990077097021, 2.215363384808479],
            [15.554249027598898, 2.22083329612188],
            [15.565169912328939, 2.2215887856002463],
            [15.568181674254772, 2.2159283350619905],
            [15.570466068657778, 2.2196358622152546],
            [15.574522615085295, 2.2220114428828652],
            [15.573111824870276, 2.2295536718682607],
            [15.569482811727154, 2.2328298883085584],
            [15.568926216418463, 2.2366623985495644],
            [15.571222565319845, 2.2417801617032964],
            [15.578415663900419, 2.248370577343985],
            [15.581469488125299, 2.252397628187144],
            [15.583459941050009, 2.2645056559637053],
            [15.602342513099671, 2.2665724338172453],
            [15.619628767616781, 2.2719173297476796],
            [15.629249714443572, 2.272574503150658],
            [15.642604329762747, 2.2720873052491495],
            [15.65120608389869, 2.2682292078619515],
            [15.658789432809803, 2.274712505417738],
            [15.665440262161633, 2.2770463299474066],
            [15.671352416713964, 2.282983878763684],
            [15.672661900483988, 2.2859291275949682]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.03897247514881, "lat": 39.25554019310589 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24029"],
        "coty_name": ["Kent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kent County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00593907"
      },
      "bbox": [
        15.503521456443922, 1.8899468160160473, 15.875872763175444,
        2.327026867205069
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.052704363176726, 1.2127362262461419],
              [16.054869886252238, 1.2238013785228172],
              [16.06553894865659, 1.227517452743973],
              [16.06900691505889, 1.2309302253693215],
              [16.071396893431892, 1.2380848414883525],
              [16.070511229666554, 1.2455667421537187],
              [16.07520638154723, 1.2486606048705158],
              [16.082093422557296, 1.249609338200152],
              [16.083809932899296, 1.2464799821358534],
              [16.09402574038671, 1.2459051609679257],
              [16.097718459935358, 1.2505046187540962],
              [16.103422799492737, 1.2483493987281737],
              [16.104734932170146, 1.2441431660241473],
              [16.111530849794498, 1.2370721829253015],
              [16.11628444647513, 1.2380586591237426],
              [16.119383951975312, 1.2361983999133441],
              [16.12255192851008, 1.2385833454151534],
              [16.128241383269884, 1.2383881845437206],
              [16.13162449066312, 1.2411849154873345],
              [16.128565439886064, 1.2480524076196393],
              [16.13366745375047, 1.262027037907375],
              [16.132164477849166, 1.265106933532273],
              [16.13589787932596, 1.269055604566209],
              [16.141992300841178, 1.2710305241604611],
              [16.14890129569913, 1.2779332282464297],
              [16.15386718755772, 1.2753838951397853],
              [16.158974113951235, 1.2754648707099852],
              [16.165294384380385, 1.271530678810472],
              [16.173490544031296, 1.2730923990879963],
              [16.18040256999451, 1.267678270781626],
              [16.19115281433195, 1.266234215781289],
              [16.194284876615036, 1.2611757131057535],
              [16.195065400544028, 1.2557248438891677],
              [16.201368477608803, 1.2488443361841286],
              [16.20276604382364, 1.23828193017311],
              [16.21136750430788, 1.2290207102001562],
              [16.216959109273994, 1.2239375770634633],
              [16.2186744492006, 1.220030567711344],
              [16.22270171153123, 1.216260906026097],
              [16.231191721380867, 1.2144477279967691],
              [16.233702187157323, 1.2059247277659637],
              [16.235955916104245, 1.2036492049370335],
              [16.240958413907567, 1.2019974984168718],
              [16.24852283306603, 1.195107139107251],
              [16.25155705014913, 1.189485668983319],
              [16.2593565759734, 1.1848898172052023],
              [16.263478085912787, 1.1787972005243972],
              [16.262970753632043, 1.173281425703962],
              [16.264617579847258, 1.1696088092323245],
              [16.26250576182052, 1.1620507141941447],
              [16.25577596370373, 1.1558972467564668],
              [16.249308731244795, 1.1469487297108927],
              [16.2473779769331, 1.1396873608338796],
              [16.248308820277263, 1.1359016010959742],
              [16.254008858520915, 1.1280113728220411],
              [16.256237833001443, 1.129586100313051],
              [16.264560521257987, 1.125486001328372],
              [16.270899062478815, 1.1206182610845152],
              [16.272585076012994, 1.1154400707354382],
              [16.277174010662993, 1.112930073565011],
              [16.277870099783815, 1.108658942843267],
              [16.280770916106313, 1.1081922886471773],
              [16.280770461621874, 1.099121348072671],
              [16.283566330734676, 1.0934085485983287],
              [16.28655515327878, 1.0915939063404771],
              [16.28338577984435, 1.0880786855919873],
              [16.278074439323493, 1.0849224501873562],
              [16.27397551018762, 1.0849613134783902],
              [16.27055119430643, 1.0869851708016975],
              [16.265253101303948, 1.0844870200647996],
              [16.26427145879583, 1.0781311054577896],
              [16.26629344183877, 1.0743116304469613],
              [16.2647201605765, 1.068386723220097],
              [16.260117759520035, 1.063896773666767],
              [16.25440568709309, 1.0623439373156986],
              [16.246168010539073, 1.062010179652709],
              [16.24142707782552, 1.0660538432392173],
              [16.237589770792372, 1.0665941709639386],
              [16.23172507021214, 1.0626166744957004],
              [16.23127085687554, 1.0596399684388333],
              [16.234439224863983, 1.0549886821514132],
              [16.233544504496887, 1.047667000755608],
              [16.231684358965794, 1.0439626043624903],
              [16.224956956125116, 1.0407995672788888],
              [16.221478523322933, 1.037846989309097],
              [16.22301059326329, 1.0350866451389364],
              [16.221553373916915, 1.0311510639785963],
              [16.21589092839566, 1.0311801107615408],
              [16.211775012623708, 1.036663484609308],
              [16.206647561583623, 1.0356077886239097],
              [16.20489175840426, 1.0307409373967766],
              [16.20465859505109, 1.024529112715227],
              [16.208239627018656, 1.0176416843651013],
              [16.211829714889564, 1.0135894312513776],
              [16.218565562015282, 1.0105094627328226],
              [16.22138723941622, 1.0062428810239656],
              [16.225887411863788, 1.009641585929932],
              [16.23292880256071, 1.0056630151202062],
              [16.23374443881466, 1.0007679936311658],
              [16.23711590366319, 0.9960024227957844],
              [16.24085783012722, 0.9984888614686954],
              [16.24420375242907, 0.9972457485587203],
              [16.24496159153346, 0.9884827064999494],
              [16.243460592026274, 0.9837355661074115],
              [16.242839013121625, 0.9781088759455115],
              [16.23882942772716, 0.9749639576060183],
              [16.238710306421858, 0.9711809001855596],
              [16.243544147929892, 0.9667986051293197],
              [16.24151960087189, 0.9645207515126061],
              [16.237922672658172, 0.9673712285577405],
              [16.234046114397216, 0.9628400634103238],
              [16.23316066795938, 0.9562534518126236],
              [16.231133183951425, 0.9527044303573903],
              [16.22767419701208, 0.9510896269521577],
              [16.225162484190907, 0.9438635986674875],
              [16.218127437475573, 0.9453562618792649],
              [16.21328377926204, 0.9486241657988386],
              [16.208914989266024, 0.9491044463549841],
              [16.19890868579563, 0.9458684361102555],
              [16.19381928213039, 0.9482833639850532],
              [16.188945752060132, 0.9488763878290013],
              [16.177630514273027, 0.9529076014188559],
              [16.177148873328516, 0.9634485909339169],
              [16.174601095083784, 0.9633799800494084],
              [16.169760248889457, 0.9568154428440657],
              [16.172152916433923, 0.9536568876040439],
              [16.173375485812503, 0.9448592541153341],
              [16.170206044616574, 0.9399845772581233],
              [16.166348902110144, 0.9376710392351516],
              [16.164534056638406, 0.9345942006767318],
              [16.160783280084143, 0.9390975581918217],
              [16.159301645481424, 0.945067279284611],
              [16.161268635007453, 0.9478163996192609],
              [16.158095962277862, 0.9545802264519158],
              [16.150665803940125, 0.9555850738745674],
              [16.15430315937604, 0.9501798914365024],
              [16.152221524010727, 0.9460632224080944],
              [16.148503412130502, 0.9440864929662601],
              [16.155496157993483, 0.9394049418352561],
              [16.152851557433177, 0.9378989474178032],
              [16.14634706960085, 0.9384663756650287],
              [16.135258837476165, 0.9377617707422452],
              [16.12644195319093, 0.9360349458965398],
              [16.122173089745818, 0.9271997575758478],
              [16.116417160110196, 0.9194345288403634],
              [16.114845441045304, 0.9160131703454372],
              [16.110728394735926, 0.9146365749637853],
              [16.106454832971924, 0.9181668827787974],
              [16.107236489699538, 0.9211418411067707],
              [16.105341513787025, 0.9250879755804877],
              [16.10098969607173, 0.9250215364216023],
              [16.10002048299243, 0.91939304713891],
              [16.09828381038724, 0.9177607120844556],
              [16.09834571732841, 0.9095471473364954],
              [16.10544300884536, 0.9044342351062161],
              [16.106716084597466, 0.899337578367922],
              [16.1052766981161, 0.8966609468240119],
              [16.09851449546598, 0.8948525998607504],
              [16.09768863851981, 0.8866234450300186],
              [16.086640849155884, 0.877573514496759],
              [16.082349705591767, 0.8749428362369035],
              [16.07927865966973, 0.8698007770506089],
              [16.07086066840405, 0.8672769248112097],
              [16.066771217408053, 0.8648601107935951],
              [16.062114056280603, 0.8593018218738857],
              [16.055179492387484, 0.8631113704718704],
              [16.04965483827357, 0.8717257239704499],
              [16.0523976469387, 0.8746899391102064],
              [16.050018218468985, 0.8858271635020837],
              [16.050504750276357, 0.8909992673794249],
              [16.04948372797539, 0.8999310403057084],
              [16.05944041611022, 0.898464841552533],
              [16.063693693428508, 0.8989917514298595],
              [16.06841608917735, 0.9017494014061297],
              [16.07104764906676, 0.9062833629773467],
              [16.067853095556465, 0.9096613766053729],
              [16.06589373677428, 0.9152394849307731],
              [16.066663135300047, 0.9240163594613495],
              [16.061273196539705, 0.9270173085659696],
              [16.057255639610784, 0.9236377619966909],
              [16.054649851841525, 0.9176598506200999],
              [16.044412091187795, 0.9229106018929758],
              [16.04250026925204, 0.9198872354969119],
              [16.038501832756968, 0.9194077369743555],
              [16.043552207908427, 0.9339547606807234],
              [16.043880014807907, 0.9425080203784738],
              [16.046124794306994, 0.9477470840706367],
              [16.04693861124568, 0.9546027705894781],
              [16.04943060972506, 0.9612935539055333],
              [16.051617791373452, 0.9745555261662081],
              [16.045597408929773, 0.9762675937949667],
              [16.046856571019212, 0.9833275659428649],
              [16.053317070913053, 0.988234385205238],
              [16.056148885034517, 0.989244245614941],
              [16.06191009273431, 0.9883346271650331],
              [16.06923498689207, 0.9803763803033133],
              [16.072832332062017, 0.9865650107410459],
              [16.07503798357148, 0.9873302606282423],
              [16.07718595973662, 0.9932060667812614],
              [16.07593238910738, 0.9960355790736396],
              [16.078327451423494, 1.0013470877896418],
              [16.0810494633432, 1.0028012520390055],
              [16.08444809707474, 1.000861746500492],
              [16.089166451151343, 1.0053587413280534],
              [16.09272159820402, 1.0117319841220014],
              [16.099285164650535, 1.013824602505724],
              [16.10219986776995, 1.01745015623202],
              [16.10327688826081, 1.0229980886942045],
              [16.109422187600934, 1.027901056097995],
              [16.108953485963948, 1.0305061545406995],
              [16.11156052877129, 1.0368672542587725],
              [16.11184900622829, 1.0407949098822908],
              [16.10861309569677, 1.0426090469206086],
              [16.10527278885607, 1.0414041805586296],
              [16.100870739239607, 1.0481830691543317],
              [16.098008122344314, 1.0447637609491862],
              [16.1006608385918, 1.0333544962039638],
              [16.09692528939129, 1.03090483638395],
              [16.090580124899436, 1.031758554814271],
              [16.091283074868393, 1.0263057080941478],
              [16.094851365045052, 1.0251419533327024],
              [16.094612523562912, 1.0214184441385044],
              [16.086944144584173, 1.0200546379580218],
              [16.07909162337408, 1.0231407805201274],
              [16.079632547817305, 1.024952299395142],
              [16.074398425639796, 1.027690193082226],
              [16.073759776595114, 1.0234976282457282],
              [16.068672904685098, 1.021648812810738],
              [16.059126342831313, 1.0244772994323847],
              [16.054364963957294, 1.0203799373812281],
              [16.050841633205835, 1.019139522611143],
              [16.048466119817526, 1.015440340232659],
              [16.050565036253516, 1.0101000589650684],
              [16.041529165509285, 1.0072181646645604],
              [16.03878686474118, 1.0092600951089163],
              [16.039258669962024, 1.0170347593790858],
              [16.034548718849678, 1.0230748862544299],
              [16.033564559085665, 1.0272111432691309],
              [16.03601195808228, 1.0286067586179986],
              [16.042419682400663, 1.0292119875494905],
              [16.039433137503593, 1.0364909325071072],
              [16.04028418248308, 1.042662852233663],
              [16.036340808865535, 1.043925803298279],
              [16.037221983832787, 1.0476152338266147],
              [16.041801747293054, 1.0461763230205987],
              [16.043438121303257, 1.0545518377440106],
              [16.048472228944444, 1.0592177738054112],
              [16.051711167822642, 1.0650592685767892],
              [16.05541428909717, 1.0665196584040406],
              [16.052243540195523, 1.0786900327783204],
              [16.055278128155592, 1.0803649905737667],
              [16.05875890377598, 1.0875708908852162],
              [16.06575196527023, 1.0809804699333063],
              [16.067539085715914, 1.0845519764792824],
              [16.066147356772795, 1.0870520056418898],
              [16.06915039266117, 1.0906925632626052],
              [16.072827806559197, 1.0903266537087417],
              [16.076828461333893, 1.086265833924146],
              [16.081991387960702, 1.0948133148761414],
              [16.08828900570107, 1.0981041057002305],
              [16.08597336646288, 1.1061958758638453],
              [16.07950676333375, 1.1032560134931289],
              [16.078677956222883, 1.1009535816692395],
              [16.072179930239795, 1.0977174942242174],
              [16.068557205689924, 1.1000255393063323],
              [16.059841951401662, 1.1026830445064237],
              [16.053903495342897, 1.1025623175207644],
              [16.0508841834657, 1.1047108199220164],
              [16.0484086179453, 1.103019895372247],
              [16.045840921170797, 1.0964820286506178],
              [16.03948780501917, 1.0947571784192722],
              [16.03676737672154, 1.0911850677755461],
              [16.03298495545766, 1.0893592748556662],
              [16.023433948198807, 1.0888628521980375],
              [16.027366898233794, 1.0817884672330806],
              [16.017929537432938, 1.0824874282712762],
              [16.019042945099525, 1.0855056637219376],
              [16.01519701788084, 1.0932691891244917],
              [16.012052174991407, 1.09336598959064],
              [16.004952274995272, 1.0911657873025564],
              [15.999967754342519, 1.0874893188804184],
              [15.998126840570624, 1.0837164632997167],
              [16.001105202528862, 1.0817503253023826],
              [15.99770393725811, 1.0786990144375475],
              [15.995602589869073, 1.0834081770268735],
              [15.987987271071598, 1.0841041724036105],
              [15.984264373397604, 1.087884379444741],
              [15.980359843458881, 1.0888811443324886],
              [15.975487106010673, 1.086002902159884],
              [15.9791027434614, 1.0797335517928763],
              [15.986424376125612, 1.0756083702970038],
              [15.988407343171183, 1.0703635468872632],
              [15.983111458703117, 1.064570162083244],
              [15.97951026544794, 1.0637013210203312],
              [15.977387665324013, 1.0605576997068895],
              [15.980747069416614, 1.0541103982158686],
              [15.979257468389783, 1.050063642760744],
              [15.976415425268025, 1.047652990490465],
              [15.973611661359604, 1.048767564472538],
              [15.970269475313758, 1.0540478735618954],
              [15.971133697973578, 1.0594937770852726],
              [15.961933889729, 1.063846319769967],
              [15.957494529700364, 1.069650940542613],
              [15.958941961516327, 1.0796570837149615],
              [15.958319861868107, 1.0862518164420192],
              [15.958616549949408, 1.0954417774051277],
              [15.959773439722218, 1.1048841103609797],
              [15.956060619914279, 1.1081418034751433],
              [15.954966963651117, 1.1113934384579929],
              [15.96006498347335, 1.1217499291678439],
              [15.963831145028337, 1.125084351234768],
              [15.9731300234452, 1.1278506234245849],
              [15.981034832460775, 1.1339518147912468],
              [15.982750459292516, 1.136787771144602],
              [15.992634381729285, 1.142353848777742],
              [15.997839044391817, 1.1471445835816807],
              [16.0013407475551, 1.1437021142550148],
              [16.006863690613958, 1.1433820963024064],
              [16.01670210150692, 1.1481469305120744],
              [16.031734006143513, 1.1632959180037827],
              [16.033486392666465, 1.1696518489910566],
              [16.03658128725886, 1.171089845080551],
              [16.040360813353107, 1.1689151459451974],
              [16.04589764231821, 1.1805218446369579],
              [16.043638885819334, 1.184856085277178],
              [16.040110513664118, 1.1823606604713224],
              [16.03214261763974, 1.1824753741908645],
              [16.024561990166394, 1.1812294882457048],
              [16.020936503184945, 1.1754683867045694],
              [16.017319923323257, 1.177353618329887],
              [16.01334015084448, 1.1766937476854489],
              [16.012064379008105, 1.1799862947601427],
              [16.014714200855618, 1.1839300915742206],
              [16.027514289424676, 1.1982525928696905],
              [16.028362619442166, 1.2004594604651322],
              [16.03299201312851, 1.202227028296419],
              [16.036603158464644, 1.2060899487367087],
              [16.03863758821747, 1.2049854021755728],
              [16.043889894380897, 1.2073713512628763],
              [16.05200017359027, 1.2092163912794374],
              [16.052704363176726, 1.2127362262461419]
            ]
          ],
          [
            [
              [15.970127637938052, 0.8827301716042092],
              [15.933748077041924, 0.875501546873165],
              [15.929920303076974, 0.8742523110628564],
              [15.926654437820144, 0.8886560263277403],
              [15.9243740481608, 0.8951696723530026],
              [15.92425762164551, 0.8989594709362341],
              [15.921248291059023, 0.9034192994286032],
              [15.919603542722918, 0.9097565706530436],
              [15.920665566270278, 0.9133854737114783],
              [15.918013945493573, 0.9237285078453255],
              [15.919351012445892, 0.9289397996206405],
              [15.916614652921384, 0.9321146043267052],
              [15.915449804416218, 0.9392054679884738],
              [15.917646064580385, 0.952543887518399],
              [15.922094588544821, 0.9529521265183791],
              [15.926255992002774, 0.9580195104015178],
              [15.931153513982604, 0.9621272138286705],
              [15.937262558330854, 0.9647862722517375],
              [15.942323924783143, 0.9627114977016298],
              [15.943245696117165, 0.9586824942058797],
              [15.948309396040884, 0.9518385514081418],
              [15.955196823689809, 0.9502173164252786],
              [15.956615193837994, 0.952453128305748],
              [15.961485200072843, 0.951565069715669],
              [15.96024100251381, 0.9486229664389192],
              [15.969824386824511, 0.9357382041409735],
              [15.966835403086138, 0.9341855101981469],
              [15.967679314654296, 0.927748561781533],
              [15.971724190282613, 0.9192699599620405],
              [15.965997722200148, 0.9200026821898853],
              [15.963998716944365, 0.9139071828260542],
              [15.965504450784122, 0.9116641686349902],
              [15.966101222922891, 0.904934881894852],
              [15.964208602629947, 0.8960579863798273],
              [15.970634529136838, 0.8925976549203141],
              [15.970127637938052, 0.8827301716042092]
            ]
          ],
          [
            [
              [15.894465723717728, 1.0119380012407901],
              [15.900305997154828, 1.0116376369108182],
              [15.903026942578514, 1.0086444394159901],
              [15.910916243375045, 1.0120643684195203],
              [15.909206707542937, 1.0165272417872377],
              [15.909423442975358, 1.0221729681091554],
              [15.903799401045296, 1.021457297285719],
              [15.896169729262159, 1.0271962822989027],
              [15.900704725739699, 1.0284247334138894],
              [15.900449660144341, 1.0340647517107666],
              [15.898972764817577, 1.0365497173336435],
              [15.90305179239826, 1.040507839875608],
              [15.906169404865068, 1.0409794191592863],
              [15.910425207719474, 1.0441065119736204],
              [15.910688030439855, 1.051304507676616],
              [15.91368926272713, 1.054909732237013],
              [15.918545819844516, 1.0532029808847434],
              [15.919895337924073, 1.0447920130589154],
              [15.91488629953076, 1.039170422302829],
              [15.916057654391768, 1.0288012138074873],
              [15.921999458837886, 1.027231874807397],
              [15.927816227808572, 1.020704412842331],
              [15.930205046616026, 1.0166789173335018],
              [15.931356404677405, 1.0098649989661557],
              [15.934305073644998, 1.0042121648420448],
              [15.93074745233613, 0.9967874513816173],
              [15.927547412940198, 0.9972484818728861],
              [15.927771793004478, 1.0009810263490253],
              [15.919790644817528, 1.00642456289324],
              [15.91183049804278, 1.002892642084984],
              [15.916553559521807, 0.9998434382203266],
              [15.914814772680858, 0.9971808313492939],
              [15.906049695852781, 1.0016677809780674],
              [15.89749464848689, 1.0075763466924534],
              [15.893648473548474, 1.008798129895106],
              [15.894465723717728, 1.0119380012407901]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.75188170338855,
          "lat": 38.115812726827095
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24039"],
        "coty_name": ["Somerset"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Somerset County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00596907"
      },
      "bbox": [
        15.893648473548474, 0.8593018218738857, 16.28655515327878,
        1.2779332282464297
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.210987550683099, 6.763205894582746],
            [2.253411969800977, 6.763268013481489],
            [2.325089808359733, 6.7650398731298536],
            [2.4036398300687702, 6.767503839860499],
            [2.454543242770508, 6.769403267164015],
            [2.4690637443065513, 6.769271952605125],
            [2.50341260097644, 6.7704388178455535],
            [2.510478731166135, 6.769607456261622],
            [2.5226421675943644, 6.769904821676329],
            [2.5551802598001316, 6.770036007442359],
            [2.5571417224866018, 6.733518755672077],
            [2.55740948553508, 6.700885915895226],
            [2.558575467671461, 6.6702038259202885],
            [2.5588687840833653, 6.655996022337723],
            [2.5608683206045955, 6.59337274724842],
            [2.5621741130648976, 6.534101035273199],
            [2.563539884481058, 6.483996832065587],
            [2.5350581648790267, 6.483358213507009],
            [2.488181879981658, 6.481954665179903],
            [2.417553988910087, 6.480270095146894],
            [2.4184426137379234, 6.449094468508031],
            [2.4206896275173935, 6.391922835804252],
            [2.380839556476425, 6.390474215579804],
            [2.3824390342432062, 6.398681953240084],
            [2.3812338843551326, 6.406212452685287],
            [2.378909113875619, 6.413412316670694],
            [2.379540798873942, 6.419867846562912],
            [2.381640561210261, 6.426678436048654],
            [2.3826599137153175, 6.435116180462276],
            [2.381778382907815, 6.438773372122279],
            [2.382469663024697, 6.457872191111173],
            [2.3810094182372454, 6.46054529841694],
            [2.3703466089158556, 6.46975679841601],
            [2.3685651082680876, 6.481287549616671],
            [2.3656047998913268, 6.486178885738939],
            [2.3603769611392407, 6.491982413544489],
            [2.3579322954831725, 6.497716103250771],
            [2.3494568419650577, 6.501146601760683],
            [2.344273613832997, 6.506535291496161],
            [2.3330429298399986, 6.513324011037546],
            [2.327283271924614, 6.5231433963873515],
            [2.3237575484392865, 6.5277900364628865],
            [2.3119679248566425, 6.531145080912661],
            [2.2974473780203652, 6.543339227288656],
            [2.2856677837926234, 6.549824970649531],
            [2.283347478982987, 6.552249822825118],
            [2.2761683587707116, 6.565417667253509],
            [2.270255296612723, 6.569098726642493],
            [2.2639102510697, 6.567335476928991],
            [2.2578673789773784, 6.570277140177426],
            [2.2531749037481323, 6.570809626290316],
            [2.248099802063874, 6.575131363299909],
            [2.2439311907031425, 6.576335726174306],
            [2.235894300669263, 6.575157986438165],
            [2.2332520186867937, 6.575791587509169],
            [2.22498908789992, 6.584113478887978],
            [2.2224722938627632, 6.59031366206925],
            [2.2139284278476583, 6.595180343437843],
            [2.213579197451313, 6.59617361821831],
            [2.2133650017061393, 6.648521725917992],
            [2.2119459700888315, 6.734230214405106],
            [2.210987550683099, 6.763205894582746]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.24645167605563,
          "lat": 45.273277410579624
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27003"],
        "coty_name": ["Anoka"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anoka County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00659447"
      },
      "bbox": [
        2.210987550683099, 6.390474215579804, 2.563539884481058,
        6.7704388178455535
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.297224008794176, 8.120727371299331],
            [1.384622203134844, 8.121665601411056],
            [1.3837816850606883, 8.207413587340666],
            [1.3837364649140662, 8.236002324767725],
            [1.3832523899563998, 8.270719447565721],
            [1.383267646393601, 8.292385539571594],
            [1.3796595501456994, 8.292321443808008],
            [1.3790023840082242, 8.320823079721814],
            [1.3783374299690778, 8.37769362808239],
            [1.3780819565883229, 8.420266386771473],
            [1.3772982509021845, 8.44527667104379],
            [1.3760520394523417, 8.547933754255615],
            [1.3754684226592804, 8.582352256595957],
            [1.3748641869765061, 8.632562098219143],
            [1.369490071961273, 8.632545605506134],
            [1.3690068167915255, 8.686233979496096],
            [1.3691215941782404, 8.718409643101337],
            [1.3978091637887409, 8.718860840775191],
            [1.4199125371379866, 8.719638819706837],
            [1.453686746555852, 8.720338358904113],
            [1.4917510990338472, 8.721861455099422],
            [1.5418965846361705, 8.72267603940383],
            [1.5420428348032666, 8.739238913016647],
            [1.5414673296184722, 8.755121115928354],
            [1.5449374914657985, 8.755496654484242],
            [1.5500304456830583, 8.749727919587698],
            [1.5467189979474023, 8.74731915967906],
            [1.5474700642536134, 8.74425166308197],
            [1.5535302917749807, 8.744145008447598],
            [1.557830286234291, 8.73854400509938],
            [1.562812431844193, 8.73837596839355],
            [1.5648015328774882, 8.742891439501918],
            [1.567725547338528, 8.742877824331625],
            [1.5710262138667386, 8.738136165910708],
            [1.575401615746489, 8.736494902565983],
            [1.584152564131934, 8.735924934517147],
            [1.596378734130337, 8.729931686635648],
            [1.602315292180688, 8.727644122781612],
            [1.6062373448215939, 8.727988564951076],
            [1.6223029614588818, 8.737266115159267],
            [1.6829775404172966, 8.765647940300791],
            [1.7436647824863236, 8.794013225748357],
            [1.7592810286450984, 8.791598032138534],
            [1.769812058168829, 8.782481017649154],
            [1.7739837521423634, 8.775206987677125],
            [1.782948160544076, 8.752963859823318],
            [1.790110039854082, 8.744662094932613],
            [1.7964371037562192, 8.736254207664471],
            [1.8001166490406504, 8.730196822493543],
            [1.8047266142079414, 8.727770664114413],
            [1.8064468590960956, 8.724427584383823],
            [1.801074457788259, 8.719074053546262],
            [1.7974998485510634, 8.718205144124576],
            [1.7969233720975581, 8.709590659895365],
            [1.7991225030720501, 8.700211620004747],
            [1.7969376179726593, 8.694947323487028],
            [1.7973516909064218, 8.68933283040251],
            [1.8002724388220146, 8.685666251165255],
            [1.7994038975132016, 8.682158221521298],
            [1.8021688770961446, 8.680453265181907],
            [1.8021709125143366, 8.677031684879232],
            [1.8090452286201406, 8.674323893110786],
            [1.8081295841912706, 8.668788557332133],
            [1.8141194621618597, 8.667249490166702],
            [1.8167107771100353, 8.664683193347575],
            [1.8265881804352453, 8.662316293758275],
            [1.830437927239388, 8.660583732393741],
            [1.8319972478763875, 8.657861705327743],
            [1.8445076117197539, 8.655862080653849],
            [1.847001659288049, 8.651375646433083],
            [1.8457528272754586, 8.648392995117202],
            [1.849417359810401, 8.645515019116937],
            [1.8549771412619978, 8.643491475546952],
            [1.8588913702393204, 8.635882090704126],
            [1.865701969448022, 8.63596844495359],
            [1.8682561709603458, 8.632572934976874],
            [1.8709475221724396, 8.62465331958179],
            [1.8759455145126218, 8.626073526823951],
            [1.8803957479047984, 8.624678878707908],
            [1.8807391511153615, 8.620717620065657],
            [1.8847254529585613, 8.6218383836718],
            [1.8856545141751129, 8.618735452260522],
            [1.8917084341038584, 8.622065861489363],
            [1.8948045844398524, 8.6214017893579],
            [1.900211833421197, 8.626374726718245],
            [1.899734001409645, 8.630711391434794],
            [1.9025630474998503, 8.63497100652283],
            [1.9016134472072548, 8.644458925419665],
            [1.9052386831701622, 8.642787496014792],
            [1.9044259180436671, 8.639841605658072],
            [1.906987413967927, 8.636785049849438],
            [1.9150507838517874, 8.636125402705707],
            [1.9178589825150336, 8.638304583757895],
            [1.925701499241655, 8.639282385298342],
            [1.9266029571692302, 8.633942787025864],
            [1.9298078083587897, 8.634453926294018],
            [1.9337573556127623, 8.630389999909125],
            [1.9344203149685326, 8.627063600692432],
            [1.9390310991347568, 8.628947021007544],
            [1.9474314086998823, 8.628352954560508],
            [1.9468152015712004, 8.624209037376492],
            [1.9504065538581954, 8.621573408409018],
            [1.9515659114342965, 8.625643228087966],
            [1.9574971515989694, 8.624417199697978],
            [1.9637442142469914, 8.629030092560672],
            [1.9681772248674898, 8.62964401068841],
            [1.97708006748282, 8.626791820330489],
            [1.98165741873913, 8.626441403327293],
            [1.9816023190869287, 8.619351069569127],
            [1.97328926605654, 8.62071577662203],
            [1.9735929679625415, 8.615354453412165],
            [1.9754794296672937, 8.612491942379869],
            [1.98088009949031, 8.59979823447931],
            [1.9754815598984972, 8.597242297033588],
            [1.9746517629020865, 8.591129180761303],
            [1.9720580398956862, 8.581994940314997],
            [1.9620532486921185, 8.573154866058454],
            [1.9623053958038028, 8.565080643270173],
            [1.9580549051250737, 8.561215042719656],
            [1.9595850882054717, 8.554687312768749],
            [1.963209855445629, 8.555743996950095],
            [1.963776824321798, 8.548581203489066],
            [1.9656719394101072, 8.543247942569636],
            [1.9685253209333244, 8.540174826572198],
            [1.9759155026084547, 8.538114288962642],
            [1.9814945552532701, 8.532068142256287],
            [1.9838948424410743, 8.534303070883135],
            [1.9851287784775344, 8.473691951291599],
            [1.986086734053377, 8.434220219399755],
            [1.9866599122169741, 8.400588203241485],
            [1.9872019470641715, 8.356276631140146],
            [1.9872602229853087, 8.347762593822544],
            [1.988744039241633, 8.302432955688749],
            [1.9906117889816974, 8.217374664199836],
            [1.9919772774118727, 8.132126531272055],
            [1.9047957140004512, 8.130709715594328],
            [1.8684297861164558, 8.12995388171171],
            [1.8319468929854075, 8.129431666630285],
            [1.8175471529327751, 8.128681876377662],
            [1.728793878312015, 8.12834717179721],
            [1.671834010084906, 8.127712360887784],
            [1.6661022729752386, 8.127426177884063],
            [1.6024337942703732, 8.126853620869849],
            [1.6022044706502128, 8.110053117291946],
            [1.6029495860451046, 8.06405267293008],
            [1.6020720270639282, 8.040988271955284],
            [1.6025600786841254, 7.998027360044574],
            [1.6035353634212246, 7.969347939125804],
            [1.6037497326787764, 7.955116252470206],
            [1.6137064705746078, 7.9549895751407425],
            [1.6137697717250563, 7.941624829499029],
            [1.6156005192831295, 7.8858731823316806],
            [1.6162664192471052, 7.8541337381358165],
            [1.6174542071559426, 7.810849530563258],
            [1.6184098294166496, 7.7822677238935904],
            [1.6198033600570416, 7.732432371166102],
            [1.6199749255588034, 7.709953426364648],
            [1.6211657707549771, 7.668448793495152],
            [1.622216371215711, 7.617864914241485],
            [1.6187691657438237, 7.607665932233797],
            [1.6129506907388447, 7.611254276243432],
            [1.612460022128308, 7.605715792905565],
            [1.609198626253292, 7.604582326966351],
            [1.606219526767327, 7.60773866248249],
            [1.610721042090114, 7.615683319226332],
            [1.606023743565785, 7.623113029122561],
            [1.5989203986625926, 7.6275415681532515],
            [1.5920013872257173, 7.624612930611804],
            [1.58520123711816, 7.635441602343543],
            [1.5803790308970764, 7.630722163524594],
            [1.5776587477427555, 7.633229938690872],
            [1.5805594773914922, 7.6362405360873264],
            [1.578935847144841, 7.63950337645824],
            [1.5741264770889705, 7.640001269758007],
            [1.5716738057822368, 7.642200147814961],
            [1.571246770645994, 7.646835817096965],
            [1.5631774715226605, 7.651733946199715],
            [1.5552381974034526, 7.654190683214364],
            [1.5547102474030081, 7.657193933871757],
            [1.5501724054916646, 7.658771784485842],
            [1.547162544110149, 7.656851770032375],
            [1.5412723045123589, 7.658088784254027],
            [1.5341736076700563, 7.654142286621956],
            [1.5312855577008055, 7.657468594721076],
            [1.5285806600010656, 7.656253412774766],
            [1.5246688384435532, 7.6486242863078955],
            [1.5206291118642203, 7.646606864290644],
            [1.5152131956070896, 7.647390052838662],
            [1.5133971074091304, 7.641756432384048],
            [1.509135392606565, 7.639803383162993],
            [1.5038714588460758, 7.641018113148729],
            [1.4967883612080566, 7.6385865977301926],
            [1.4952040877752404, 7.635168059061321],
            [1.4903826638141104, 7.634485145728023],
            [1.478362993996542, 7.62834802229232],
            [1.4711758349259672, 7.630175902569005],
            [1.4674121040868724, 7.632864144532456],
            [1.4634392133087395, 7.632412592848654],
            [1.4598699259405121, 7.637588248163657],
            [1.451684209085488, 7.640942811607066],
            [1.4428461932377097, 7.649155713368505],
            [1.4366960712498058, 7.651444359043675],
            [1.4321492403890834, 7.651806016625827],
            [1.4275523624971274, 7.653964883530313],
            [1.4243575118303733, 7.649551038954989],
            [1.4205363517633363, 7.651976757781997],
            [1.4169986124940195, 7.651040879858264],
            [1.4152565559350032, 7.654710007813852],
            [1.406801891871675, 7.6654873417095315],
            [1.402243303937577, 7.66554729617976],
            [1.3955007825844379, 7.672500716760993],
            [1.3919768002898716, 7.675854327383499],
            [1.387600298660422, 7.675815987175648],
            [1.3865418795898905, 7.682630786152914],
            [1.384314657057479, 7.684284449000977],
            [1.3812798848938252, 7.6817263764117625],
            [1.3797845663320756, 7.674243419340387],
            [1.3721725997146963, 7.674510509031851],
            [1.3675849136430742, 7.673078558603568],
            [1.3613203742921953, 7.673340546555175],
            [1.3530050599399694, 7.67545307020987],
            [1.3474967143582324, 7.675445716824938],
            [1.3411789617635261, 7.687085894641693],
            [1.3412791591063398, 7.691461660478304],
            [1.3415603509600011, 7.699191818060393],
            [1.3433316303889473, 7.70397988676236],
            [1.340716001587977, 7.70667149796616],
            [1.3344404406545487, 7.702630911283593],
            [1.3308918857111491, 7.707204610184751],
            [1.328726559823142, 7.70285863363244],
            [1.326242055486845, 7.702638466471336],
            [1.324746575677188, 7.706980234556133],
            [1.3174860187452804, 7.712525526387068],
            [1.319371302752046, 7.716109164736523],
            [1.3145203597182458, 7.719038682884139],
            [1.31250853137038, 7.714220066437714],
            [1.3079704197698485, 7.716344583598604],
            [1.3068565899678661, 7.81988176635017],
            [1.3057328919917373, 7.8641697794811725],
            [1.30500603008233, 7.90630224821653],
            [1.3039826230588956, 7.9489449870968105],
            [1.3002783806395346, 7.949345182169686],
            [1.2986686020751, 8.034709261649441],
            [1.297224008794176, 8.120727371299331]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.32536563599872,
          "lat": 46.949601984603625
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27021"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00659456"
      },
      "bbox": [
        1.297224008794176, 7.604582326966351, 1.9919772774118727,
        8.794013225748357
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2684350369327837, 5.494944178138131],
            [3.265120105237136, 5.581027567786081],
            [3.3499174943361676, 5.584692856102231],
            [3.379057139136161, 5.585765575296637],
            [3.4053255092274384, 5.587100611935901],
            [3.422743268511654, 5.587704418005036],
            [3.43283769445874, 5.580022714537239],
            [3.4442554354306463, 5.573996241310639],
            [3.4533518201128106, 5.5602862014224375],
            [3.46017045537385, 5.5556145946808995],
            [3.468528940449784, 5.551057325411905],
            [3.484679281918622, 5.544977228952378],
            [3.497853703872048, 5.534830559955495],
            [3.5014969872806634, 5.532975304416417],
            [3.5166588955145697, 5.5317665585000055],
            [3.5250960158011573, 5.528098718220515],
            [3.5315494371015053, 5.520017694614508],
            [3.533779578469121, 5.510569099183739],
            [3.5345201987001644, 5.503580748147969],
            [3.543470730119304, 5.498648842923018],
            [3.5533759908367517, 5.497926597583943],
            [3.5642372046441433, 5.487984219816398],
            [3.570181166036443, 5.475494254347912],
            [3.581286680635796, 5.46457952669037],
            [3.585985972053421, 5.4652972056237585],
            [3.5936378236075814, 5.458169250444665],
            [3.6027926553683467, 5.454380151943998],
            [3.608738350090885, 5.450412338792868],
            [3.6116197982532916, 5.446868729846131],
            [3.6162698368080726, 5.438366145215305],
            [3.620406349037072, 5.434963632636243],
            [3.6273664830092156, 5.431293919747972],
            [3.644352779523588, 5.430016160831369],
            [3.653068838942, 5.4273328388925215],
            [3.6693619197003287, 5.427302110519478],
            [3.6817839621059876, 5.4254324527863815],
            [3.6907742078959425, 5.419410820930782],
            [3.7010890779522647, 5.415506477604009],
            [3.7098999984163514, 5.4172598193068096],
            [3.713469271547282, 5.416990331133909],
            [3.7179935752227067, 5.414464809161074],
            [3.730280662293437, 5.410249465655888],
            [3.736243073422885, 5.405859102787608],
            [3.738277767971073, 5.403016502988552],
            [3.7420975826518044, 5.393629941514317],
            [3.751717700045183, 5.383176314146882],
            [3.7568183003139706, 5.373935357547242],
            [3.764863201387878, 5.3698010201892945],
            [3.7717774084259412, 5.364962458694812],
            [3.7878031085984927, 5.346373378542883],
            [3.7892809689925278, 5.338118970609363],
            [3.793906357815223, 5.329005768596543],
            [3.80110666264235, 5.324085947393523],
            [3.8054373333543756, 5.315023586596152],
            [3.8086916778230693, 5.3101457871908595],
            [3.816068212934758, 5.30627445437735],
            [3.8217170575211914, 5.301603448417808],
            [3.825844276098481, 5.295117580604436],
            [3.8296556775033492, 5.280865462447206],
            [3.8404845136486427, 5.269171518284853],
            [3.8447209933027313, 5.2669462742523105],
            [3.849927421544077, 5.261530078502435],
            [3.7943947464100263, 5.258806585974316],
            [3.76479860568859, 5.257175353227763],
            [3.7006872233084884, 5.254175084134652],
            [3.643942042812657, 5.251615636180149],
            [3.5940220859303853, 5.249223740059553],
            [3.5297080219777732, 5.246315519997562],
            [3.514209106935613, 5.245539415142865],
            [3.48289440012242, 5.2444971668363145],
            [3.425851252710729, 5.241635250989612],
            [3.3436661209791954, 5.238448735602898],
            [3.2794360182480276, 5.2357614198254305],
            [3.275107772459962, 5.343827796936769],
            [3.272328552248402, 5.408732021178187],
            [3.268638619074877, 5.493989864993306],
            [3.2684350369327837, 5.494944178138131]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.77920214267687,
          "lat": 43.986847833639054
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27169"],
        "coty_name": ["Winona"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winona County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00659529"
      },
      "bbox": [
        3.265120105237136, 5.2357614198254305, 3.849927421544077,
        5.587704418005036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.0285001903999955, -6.104556230796978],
            [5.034412634322991, -6.101308236510673],
            [5.038314464063224, -6.106207257922187],
            [5.043056771536208, -6.104152269414719],
            [5.046565984763018, -6.100230557508943],
            [5.052846330924482, -6.1053692724976205],
            [5.056264459862954, -6.101404278602565],
            [5.0543476524310345, -6.096932010185073],
            [5.056505179263604, -6.094380332298609],
            [5.053037292521295, -6.091877979990379],
            [5.059414753514099, -6.087528489881601],
            [5.070407383046507, -6.086657926512681],
            [5.0734748411169655, -6.0821230812478175],
            [5.079468539389448, -6.077286020989368],
            [5.078389944765502, -6.075365927764693],
            [5.082746855253922, -6.071128740651162],
            [5.082989889097104, -6.068403096516908],
            [5.086732652664501, -6.0645295937432],
            [5.095342730470818, -6.064921997474463],
            [5.095396737796163, -6.059335189533982],
            [5.100402039389767, -6.060273302122368],
            [5.100436933645717, -6.054352903125919],
            [5.101929170680793, -6.0487766316098535],
            [5.105957271913862, -6.050681697100299],
            [5.109131920623755, -6.049073797311476],
            [5.107821821187816, -6.041418991542568],
            [5.1115037777293555, -6.03345488079784],
            [5.115949014877441, -6.105023102172384],
            [5.116660132142885, -6.1186894051247505],
            [5.159443313726199, -6.116855033594859],
            [5.206632759283683, -6.113992559131626],
            [5.210138836863138, -6.114095228659195],
            [5.2483299627419875, -6.111677070811798],
            [5.289390586026068, -6.10932407423636],
            [5.294608962108747, -6.196580486655778],
            [5.301312815104571, -6.196297240536939],
            [5.367989778737607, -6.1919688244704885],
            [5.381014917406258, -6.191944718418933],
            [5.443894447372682, -6.188011167599769],
            [5.441355718905237, -6.189292641947581],
            [5.4437331900469035, -6.193408411900838],
            [5.442541870761611, -6.1957939352903875],
            [5.434426108598862, -6.20049102265442],
            [5.435541443673623, -6.194222551475014],
            [5.430926448841429, -6.1930074925886895],
            [5.4316941776757846, -6.197265368316726],
            [5.429135915474284, -6.198027825448675],
            [5.4280264743280915, -6.202761472657852],
            [5.419828671014474, -6.199902896147314],
            [5.419868155234671, -6.207312314020912],
            [5.415641914974806, -6.206977678553761],
            [5.419142914425499, -6.213167534196015],
            [5.414177932571178, -6.218133942935616],
            [5.417339195396245, -6.2224670172346155],
            [5.412758455439268, -6.229890805801815],
            [5.408391048968678, -6.226947876529786],
            [5.406974972320596, -6.235363534652417],
            [5.410194758466782, -6.241049843471149],
            [5.410124580417548, -6.245266737762776],
            [5.405030813430456, -6.243917586373815],
            [5.40346298878606, -6.250115129117024],
            [5.39672251947834, -6.256630803140857],
            [5.3940889651800825, -6.2609689782691085],
            [5.387771152915393, -6.26496152686554],
            [5.384573896329587, -6.270175841531573],
            [5.381319724651882, -6.2661042044803725],
            [5.376088158835943, -6.268084765050036],
            [5.374701896317314, -6.275573504981926],
            [5.376653887902387, -6.28126282122191],
            [5.373460413337845, -6.281461305342083],
            [5.368367340445156, -6.286080756513059],
            [5.3789053615286315, -6.299946273505355],
            [5.373822953792552, -6.2981560663944105],
            [5.371212320792252, -6.306326460541891],
            [5.362718181789186, -6.305228633212586],
            [5.360212651272807, -6.302352269601768],
            [5.355493364740067, -6.306072721237075],
            [5.356591664948444, -6.309903899876384],
            [5.355931856925542, -6.316950390807555],
            [5.350399718338083, -6.319942040143015],
            [5.349987505080316, -6.3271342877002965],
            [5.353305767373712, -6.327769097139772],
            [5.351522640693189, -6.332749423568709],
            [5.3448044519964695, -6.331718715145278],
            [5.34235153075195, -6.337110798921404],
            [5.338877229212018, -6.338123561273752],
            [5.335931621833074, -6.342407155664095],
            [5.336298869250197, -6.348386348100875],
            [5.341202138073826, -6.349891342256055],
            [5.341648606430517, -6.353067091058316],
            [5.337672396202188, -6.353674802442188],
            [5.3390481235096345, -6.3574326809827335],
            [5.337364406481396, -6.3630025620067086],
            [5.345013016202233, -6.368524217580793],
            [5.348532970555107, -6.367943956639178],
            [5.354535118091605, -6.375256156328568],
            [5.352003031470761, -6.378640871225478],
            [5.35053463981554, -6.3838412523480015],
            [5.351993881138491, -6.39051372880977],
            [5.358850623152759, -6.391398347557864],
            [5.351820268087129, -6.398240063082698],
            [5.348850265476938, -6.394950080135197],
            [5.3466521551308235, -6.398129907771135],
            [5.347737738291042, -6.400816948461435],
            [5.346130325767622, -6.405869138177528],
            [5.341617420144829, -6.407093796660822],
            [5.337321308607266, -6.405572149860071],
            [5.334164717171649, -6.4145504564195805],
            [5.324353426991454, -6.417461785839574],
            [5.322731665986078, -6.416300005511681],
            [5.317739141565174, -6.421918991398584],
            [5.314383615991042, -6.417677700225685],
            [5.309570513091935, -6.418021995872109],
            [5.307166116199789, -6.424756985732478],
            [5.311053949115586, -6.44084521996495],
            [5.301527738484846, -6.44405227016186],
            [5.305099103317982, -6.447608371414833],
            [5.308665181332048, -6.444861279866692],
            [5.31072169419347, -6.447029595534261],
            [5.3090389204895265, -6.455718416261157],
            [5.307632856383344, -6.458640500955577],
            [5.308487922099811, -6.462972116719272],
            [5.312965037653805, -6.468556096350039],
            [5.3138744602433725, -6.474062762014107],
            [5.31119506481328, -6.479559499838204],
            [5.305847182431244, -6.483866098599738],
            [5.310726338916828, -6.492566814734128],
            [5.314045523872037, -6.492381852591743],
            [5.318232305180705, -6.494469285639322],
            [5.315015360486935, -6.498764715714331],
            [5.312170577777278, -6.4952278225186255],
            [5.309764621581386, -6.496971289496896],
            [5.31053949181098, -6.5018663258050315],
            [5.3156019273531125, -6.50404216053447],
            [5.3176358575464535, -6.50126664657843],
            [5.325714961638234, -6.4996686523787615],
            [5.3258282506866985, -6.502996962958162],
            [5.320381052302452, -6.505695593249021],
            [5.323856642096611, -6.509329062431256],
            [5.327556511247719, -6.5174501364600905],
            [5.327306866206598, -6.526001546123887],
            [5.322137715637034, -6.526530660729595],
            [5.321333106559478, -6.530658198735542],
            [5.32728152622833, -6.538124926319668],
            [5.3255537025566, -6.54128988257177],
            [5.327234927140625, -6.5452631667411865],
            [5.278323574866191, -6.548314733820642],
            [5.130733989571758, -6.556947000090965],
            [5.0875198028419515, -6.559080960863126],
            [5.027048233272548, -6.562736003283468],
            [4.997775105331992, -6.564150791895684],
            [4.969518549648779, -6.565836030327069],
            [4.9695930477596555, -6.567314688451862],
            [4.916427914076253, -6.570393358136068],
            [4.905231025571741, -6.471951696566331],
            [4.904318038349236, -6.464751653786996],
            [4.897884176317636, -6.394624098002582],
            [4.900230517777154, -6.3895522881097895],
            [4.898613485594129, -6.387794658116407],
            [4.8984142593125455, -6.378166833671164],
            [4.901214610109931, -6.377487949131571],
            [4.906832615533736, -6.371745564512709],
            [4.906928881658276, -6.368408404848392],
            [4.902603325531421, -6.362649142345434],
            [4.897926876553408, -6.359449425015685],
            [4.9035676849568075, -6.356785444282049],
            [4.905075977098295, -6.348421992898617],
            [4.902619998362256, -6.342183721166557],
            [4.906817228968074, -6.343247447390538],
            [4.908039494386296, -6.339413353172997],
            [4.912531715401493, -6.336485814389226],
            [4.912646873484839, -6.328372861384435],
            [4.918859505280935, -6.321168439015794],
            [4.919042127546786, -6.314810593309119],
            [4.9169958009879835, -6.309786233987589],
            [4.91419119818098, -6.307929234015691],
            [4.911959595394345, -6.303271203806939],
            [4.914225324553884, -6.301981674794647],
            [4.913408369386745, -6.295931063103332],
            [4.911862619406153, -6.2941742480967315],
            [4.916571228860404, -6.287580820634507],
            [4.9091172887384324, -6.279041444582224],
            [4.911109794689733, -6.271619536570802],
            [4.9142945861367355, -6.271771210866205],
            [4.918749910370623, -6.269370960746267],
            [4.919370476823729, -6.265468939521042],
            [4.924050606525007, -6.266758277227079],
            [4.928565440933485, -6.2651698663636415],
            [4.95572348906146, -6.272046505970084],
            [4.96425504355479, -6.272570269807002],
            [4.972184042921919, -6.276555172495419],
            [4.975959318815031, -6.27583145833744],
            [4.975650399200652, -6.269931299798956],
            [4.97338194236662, -6.265919919775766],
            [4.971409665651405, -6.254047065338023],
            [4.968014541247158, -6.247672203655571],
            [4.967106822401392, -6.24127955515012],
            [4.969324545257458, -6.238599302525304],
            [4.974288966319226, -6.237396219015771],
            [4.978056820828992, -6.230314807457227],
            [4.975021051062558, -6.227159063955225],
            [4.977494967354933, -6.2244990434099385],
            [4.9808373964297985, -6.217733425385029],
            [4.981650601004382, -6.2132175085234875],
            [4.983833052837148, -6.210340290710526],
            [4.982454918801124, -6.205437197273719],
            [4.985266132431156, -6.204740013773072],
            [4.98497886699692, -6.200296936276581],
            [4.989417738636084, -6.198859962736282],
            [4.994585592662572, -6.189544938838395],
            [4.994044239593168, -6.178980268294275],
            [4.998411554098227, -6.172764514516078],
            [5.000658024837641, -6.173911967137207],
            [5.005335377957438, -6.168440130782703],
            [4.9949272427535965, -6.1638387390947615],
            [4.994565849184275, -6.156877857189336],
            [4.991445763276537, -6.156126056913403],
            [4.992202680997307, -6.1438374858008675],
            [4.988728472063205, -6.137396601408587],
            [4.987927568856863, -6.133175814588803],
            [4.9904807772338975, -6.130085276439392],
            [4.99306068091683, -6.131311328974751],
            [4.999343983872731, -6.125168219064473],
            [4.9989314977217045, -6.1207560852126965],
            [5.001397908209001, -6.116708515405132],
            [5.005421375954154, -6.11943571618937],
            [5.007701316192658, -6.1151461183780125],
            [5.006414648942989, -6.111610728033744],
            [5.0156336082054365, -6.1115276168535395],
            [5.027257356807994, -6.107184054737931],
            [5.0285001903999955, -6.104556230796978]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.44299284610663,
          "lat": 32.266647218125186
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28049"],
        "coty_name": ["Hinds"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hinds County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00695748"
      },
      "bbox": [
        4.897884176317636, -6.570393358136068, 5.443894447372682,
        -6.03345488079784
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.284280359184458, -7.097403790773704],
            [6.348751273690823, -7.093081052863476],
            [6.4560871096247565, -7.085498268136206],
            [6.465908695860406, -7.084842626783606],
            [6.542320888524834, -7.078842150425065],
            [6.546947914353296, -7.138309751490042],
            [6.556021617868287, -7.253003149814568],
            [6.560904925593306, -7.317404450691461],
            [6.564751512691645, -7.365575520086791],
            [6.564915106575302, -7.371615361099376],
            [6.568470986764287, -7.414340187915015],
            [6.5758507114329, -7.510827160979327],
            [6.581498575064216, -7.510830236928032],
            [6.588004953173213, -7.597749321336989],
            [6.554186939464271, -7.600678045070261],
            [6.544835694991669, -7.600506475366238],
            [6.448124159577839, -7.6080238817178],
            [6.3514112476905105, -7.615524816315893],
            [6.329108094126677, -7.617165576161891],
            [6.322184368364809, -7.527388986580638],
            [6.315558558197934, -7.527853794814304],
            [6.31110648288409, -7.463013138115841],
            [6.299870629332086, -7.305673901599666],
            [6.297522867029595, -7.277308816960708],
            [6.294078845017263, -7.2287147519772965],
            [6.289339966730896, -7.167757257922042],
            [6.288589668659055, -7.1558939120009715],
            [6.284280359184458, -7.097403790773704]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.9923717354028, "lat": 31.172029309383877 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28111"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00695778"
      },
      "bbox": [
        6.284280359184458, -7.617165576161891, 6.588004953173213,
        -7.078842150425065
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.186164230617006, 0.9261874922714117],
            [1.1847559882397591, 0.9325658273708395],
            [1.1860307188804784, 0.9413492534541745],
            [1.1888914494622091, 0.9489767082656754],
            [1.1926126147374674, 0.955568276820631],
            [1.1967582512727157, 0.9609279384484011],
            [1.197933870918663, 0.9642361155255299],
            [1.2052944311512275, 0.9769763076316755],
            [1.2123292265919259, 0.9845322658326652],
            [1.2193864676537107, 0.9875282974954706],
            [1.2311706640249247, 0.988464561018839],
            [1.2383303500259188, 0.9898325693961041],
            [1.2442576841607944, 0.9934487333608966],
            [1.248020908325693, 0.9985759852756417],
            [1.249730184195325, 1.0051990126409864],
            [1.2499744145992788, 1.019783124144919],
            [1.2478017176331027, 1.035648797568046],
            [1.2482034571684597, 1.0447108325742411],
            [1.2520158820813774, 1.051760154879233],
            [1.2595850001504483, 1.0585278896040198],
            [1.2645831625032213, 1.0584861113887025],
            [1.2718688421879423, 1.0545151079478619],
            [1.2789600719051737, 1.0483294284499325],
            [1.2879348795337486, 1.0417944128430519],
            [1.2999597939237983, 1.0372979018863784],
            [1.3082327921076131, 1.0380922678930182],
            [1.3140019859495815, 1.04007728806267],
            [1.3204343465886417, 1.0438872091692164],
            [1.324575635179099, 1.048074115891808],
            [1.3299596112956154, 1.0566157222096555],
            [1.3324962168985457, 1.0674446277440977],
            [1.331392341109034, 1.0769178517792417],
            [1.3264149085606771, 1.0855373922800549],
            [1.3233526920463805, 1.0868129012782184],
            [1.315547080754295, 1.084968684001779],
            [1.3021599914966075, 1.0747205282559826],
            [1.2967832705126319, 1.0728015493304344],
            [1.2921772641561318, 1.072667961893596],
            [1.2887346912442936, 1.0742433544354983],
            [1.2814820037160644, 1.0797640660322],
            [1.2752837026536876, 1.0869119584041325],
            [1.2740668053860107, 1.092210609200766],
            [1.276310040635014, 1.0996793738250297],
            [1.2816917780671977, 1.1032438115995615],
            [1.306524153156476, 1.1048850605016542],
            [1.3132477747400386, 1.1081284125620725],
            [1.3156102854368446, 1.1112886208111181],
            [1.3189886333489378, 1.120971960499847],
            [1.3186353811955864, 1.1350797614318262],
            [1.3727396153418923, 1.1361863604396296],
            [1.4450067100256572, 1.1365644587211798],
            [1.5269618376914484, 1.1368608156043634],
            [1.5284770540179455, 1.063502401879155],
            [1.530514682117439, 0.9318800942860009],
            [1.5313358474690397, 0.918093175647046],
            [1.5324945759488344, 0.8445099957092228],
            [1.411074321292068, 0.8441903281340878],
            [1.318312494554594, 0.8439388887821491],
            [1.2323623605792644, 0.8436960126155886],
            [1.150302639981585, 0.8430050901184704],
            [1.1491710139714197, 0.8430872619758811],
            [1.1441845165834454, 0.8520619991778355],
            [1.1408258105837683, 0.8637955663710952],
            [1.1411435292729415, 0.8690390321106011],
            [1.1452986333521902, 0.8839252307709026],
            [1.1484880364742402, 0.8879319995040488],
            [1.1541813032246593, 0.8908473736727069],
            [1.1589271728435309, 0.8913065010851379],
            [1.1687625414940397, 0.88709760574284],
            [1.1780507599183707, 0.88754269860284],
            [1.1838359696402863, 0.8910840719466347],
            [1.1895629100862206, 0.9002411985596561],
            [1.1911192478419148, 0.9058423576467999],
            [1.191603152766994, 0.9123966550686861],
            [1.190436829064551, 0.9171105548184052],
            [1.186164230617006, 0.9261874922714117]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.80586962521537,
          "lat": 39.659772172387626
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29021"],
        "coty_name": ["Buchanan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buchanan County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00758465"
      },
      "bbox": [
        1.1408258105837683, 0.8430050901184704, 1.5324945759488344,
        1.1368608156043634
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.7007538379466276, 8.555203799482637],
            [-0.6137263783614049, 8.552773404055186],
            [-0.5484127774751937, 8.55197419671126],
            [-0.5271099157272124, 8.551450300291648],
            [-0.42626651479363414, 8.549655559536895],
            [-0.3573021097710845, 8.548832863389126],
            [-0.2883378782388404, 8.547995328686918],
            [-0.1800669117425541, 8.546857297369234],
            [-0.11452310318752573, 8.545209215166372],
            [-0.10510559858515238, 8.545595077588336],
            [-0.10213597459686422, 8.541674467578249],
            [-0.10404714145765999, 8.538798256195596],
            [-0.10795914490342076, 8.542428203420794],
            [-0.11164010336909726, 8.53888505538437],
            [-0.10580129765812342, 8.536629866359693],
            [-0.1043929369101471, 8.53351828235015],
            [-0.1062207709862968, 8.530067798081054],
            [-0.10540695322415815, 8.526585472279253],
            [-0.10702054043407738, 8.52229587931922],
            [-0.10338824383218895, 8.519018166619912],
            [-0.10731569558687674, 8.51644732429166],
            [-0.10572046729012333, 8.510795607435176],
            [-0.10885478252533708, 8.504468611314989],
            [-0.10226126285804844, 8.500895278920087],
            [-0.10075509427458981, 8.497217523344746],
            [-0.10510694965824802, 8.495850147418832],
            [-0.10463368849086285, 8.491734463965047],
            [-0.09858651133432426, 8.493871510095396],
            [-0.09756599585001767, 8.492513890673608],
            [-0.10100520445368791, 8.485711211556776],
            [-0.09892108835221203, 8.482351904723195],
            [-0.0997648387445595, 8.475052261316456],
            [-0.09595263974046961, 8.473399035368187],
            [-0.0996333042790177, 8.469709995553476],
            [-0.10013606452649185, 8.463590678650542],
            [-0.10780316959394608, 8.462336348438896],
            [-0.11031630193032799, 8.4593287610569],
            [-0.10500603893914637, 8.458465334662804],
            [-0.1027406544548527, 8.455270093575272],
            [-0.10648005020516446, 8.451439803105883],
            [-0.1033419351648488, 8.449884284311013],
            [-0.09909318487808333, 8.440376165807997],
            [-0.10074695097967024, 8.432553051964682],
            [-0.10722552918715673, 8.43301256759484],
            [-0.0993346691169835, 8.426778117037445],
            [-0.09753296557266591, 8.42303521900577],
            [-0.09898737876930674, 8.419021839408819],
            [-0.09497597282322119, 8.418493483528158],
            [-0.09441044930084158, 8.413585695447377],
            [-0.09796166846274015, 8.409504260114371],
            [-0.09539003009326577, 8.407610037572109],
            [-0.09457101625849931, 8.39815858658328],
            [-0.09763703323728656, 8.392843998408551],
            [-0.09516293403794732, 8.388308045177135],
            [-0.10163569844030994, 8.38643571971277],
            [-0.10379328031798428, 8.384606361851993],
            [-0.10028312318878004, 8.38068328926602],
            [-0.09820624717355568, 8.371070784670188],
            [-0.10084686214771318, 8.365572614399667],
            [-0.09597996398628376, 8.361874015834424],
            [-0.09835662603342925, 8.359100774777719],
            [-0.09604971118199082, 8.356214673286066],
            [-0.09971266237940823, 8.348182074414805],
            [-0.09277652560244193, 8.34872174797188],
            [-0.09529153864112092, 8.344328423361349],
            [-0.10055992663081109, 8.344333031887476],
            [-0.09437628040736432, 8.335909543119122],
            [-0.10224121689229977, 8.333965725722843],
            [-0.10525319446780464, 8.32967021491098],
            [-0.10724976345315697, 8.321112146773336],
            [-0.11014379113261011, 8.319854969029594],
            [-0.10718295683457109, 8.31550833502242],
            [-0.1047495969222433, 8.316410154767134],
            [-0.10028785196955711, 8.309150064937247],
            [-0.10129397411286563, 8.30451249239678],
            [-0.0998864124632857, 8.302480166107753],
            [-0.10241191742408498, 8.298785331164924],
            [-0.09999138215569826, 8.297217052021336],
            [-0.09820774213654768, 8.288772532062396],
            [-0.10054623607141663, 8.28237154354334],
            [-0.09806247107897739, 8.279014597848546],
            [-0.09141331145495826, 8.275457902458468],
            [-0.08557073667911647, 8.277411745972191],
            [-0.08124051655688055, 8.276883177580466],
            [-0.08685826092843077, 8.268089788863024],
            [-0.0844958360375649, 8.265957755809051],
            [-0.08351808756167955, 8.256340393156545],
            [-0.07905967894483974, 8.25620595148034],
            [-0.07808737407271131, 8.249497857501401],
            [-0.07932951404558287, 8.240443820968672],
            [-0.07472832544528846, 8.241093840105052],
            [-0.06898901963625571, 8.238288099102428],
            [-0.0679236135957874, 8.242713693041605],
            [-0.05870271522835971, 8.24638425180156],
            [-0.055784614087434826, 8.242518292493404],
            [-0.05690585303191897, 8.239571025914795],
            [-0.05295290025596262, 8.236386649120137],
            [-0.05881921889341522, 8.231998562664266],
            [-0.05314968806207768, 8.226634418405654],
            [-0.05870903816252977, 8.22637277824349],
            [-0.06161484472477355, 8.217238740186643],
            [-0.06489525346511635, 8.218940343487773],
            [-0.0670481460647217, 8.215804007420052],
            [-0.06917086504343911, 8.208035326335905],
            [-0.06439706917670393, 8.20435025023819],
            [-0.06794602905926962, 8.201348070452172],
            [-0.06720050563052155, 8.197276378007897],
            [-0.0629539995643663, 8.196158106985385],
            [-0.06465045480842874, 8.190159187736112],
            [-0.0719052692798952, 8.192780478116665],
            [-0.06910799129451485, 8.186545084177759],
            [-0.07312430820722463, 8.183541705037571],
            [-0.07228616996513201, 8.179969522949618],
            [-0.07452893088384324, 8.174566173883496],
            [-0.0699639372147944, 8.170191637385035],
            [-0.0697977100353169, 8.165458431649263],
            [-0.07308082200057649, 8.158781382838395],
            [-0.06974420532179378, 8.155303768376761],
            [-0.07664015875536065, 8.15200790057052],
            [-0.07390679116456587, 8.150309525474224],
            [-0.07680766932134374, 8.143641755498727],
            [-0.0800273329718813, 8.141290103245577],
            [-0.08075247852809024, 8.136760607730112],
            [-0.08447043505083855, 8.135904014127682],
            [-0.08600447187510446, 8.133254581719845],
            [-0.08547377721058294, 8.129081268828912],
            [-0.08771082774552756, 8.125239572311866],
            [-0.08357314630666096, 8.122432306703192],
            [-0.084512968135372, 8.11832913366075],
            [-0.08329295701337301, 8.114125096932765],
            [-0.08695506543333575, 8.112073852659659],
            [-0.08216141160530949, 8.108541107431643],
            [-0.08352891532800331, 8.103865197409608],
            [-0.07750138957987096, 8.0986695326896],
            [-0.08399482512995193, 8.09162325467289],
            [-0.08033242412253595, 8.0903147780839],
            [-0.07653648209563434, 8.092629878988047],
            [-0.07466507172107498, 8.090236740709276],
            [-0.07834561485529427, 8.08455240927967],
            [-0.06995347766578706, 8.081978828727443],
            [-0.07139311870047546, 8.07876426014569],
            [-0.07792568561668904, 8.080751709264417],
            [-0.07801034548598336, 8.078442449778768],
            [-0.07214444787593867, 8.07721985219884],
            [-0.07200818528001873, 8.074491522649843],
            [-0.07792620352412948, 8.072310662021623],
            [-0.07565980204616497, 8.069383307716844],
            [-0.07645220333333452, 8.05725595271618],
            [-0.0746293066126534, 8.055354970477683],
            [-0.07262321778665358, 8.044663874991622],
            [-0.07278694512153723, 8.038106714893239],
            [-0.08060123035198828, 8.032739586903709],
            [-0.07549838418124394, 8.02640812714311],
            [-0.07935949818895618, 8.023833085145931],
            [-0.07963427325605618, 8.019793044216128],
            [-0.07656839691329682, 8.009593156888217],
            [-0.07996988317986006, 8.003749986741875],
            [-0.07866007560729019, 7.999929329668905],
            [-0.07903951408828541, 7.994083738341253],
            [-0.08319329189352594, 7.9949311153728075],
            [-0.0865639837596901, 7.993765064114831],
            [-0.08639473418587316, 7.989936763039533],
            [-0.08296530916778282, 7.984818150950492],
            [-0.08808750234879928, 7.9841718917389395],
            [-0.08554872214406015, 7.97771527812523],
            [-0.08704551573470584, 7.976396399284886],
            [-0.08655960856542924, 7.969945742814067],
            [-0.08089328314409563, 7.964964017626009],
            [-0.08329637808799603, 7.96255588893122],
            [-0.08105988907185323, 7.958498622911816],
            [-0.08260175069561988, 7.950316998005521],
            [-0.0861311718376987, 7.946466093283681],
            [-0.0871321686582089, 7.946328337557597],
            [-0.1745687187095816, 7.947194563472335],
            [-0.24758098192431094, 7.9475991695268835],
            [-0.3334317900006315, 7.948241888966871],
            [-0.41817682161870556, 7.949094844447122],
            [-0.4980619544934431, 7.950288607299699],
            [-0.5920539689898872, 7.951841171843567],
            [-0.6951693653434579, 7.95394236242239],
            [-0.6934680116061623, 8.039777104503235],
            [-0.6918956781684742, 8.125552584056042],
            [-0.689687265672537, 8.237950478351602],
            [-0.6886844276124008, 8.297569224966242],
            [-0.7055861357297197, 8.29794318064304],
            [-0.7037695934930267, 8.368092021487511],
            [-0.7025954444597402, 8.44081316514046],
            [-0.7011352073602826, 8.525539232325956],
            [-0.7007538379466276, 8.555203799482637]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.2478411589843, "lat": 46.93307135636033 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38017"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01034226"
      },
      "bbox": [
        -0.7055861357297197, 7.946328337557597, -0.05295290025596262,
        8.555203799482637
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.7657325454610544, 9.178765424571242],
            [-1.707705869000105, 9.176994403516373],
            [-1.7056586778162681, 9.177138822809479],
            [-1.6681588377729928, 9.176128858015943],
            [-1.667148226012662, 9.175877181796583],
            [-1.631842393253064, 9.175026688923209],
            [-1.6209526822255784, 9.17390359784379],
            [-1.5698000485875587, 9.171947925249352],
            [-1.5349381482377074, 9.171437375286239],
            [-1.4898453969212606, 9.17045724396291],
            [-1.4868463615878924, 9.170202632549413],
            [-1.4166298258707977, 9.16848491444933],
            [-1.3295568853500872, 9.165807927931077],
            [-1.3084362117560693, 9.165367591124754],
            [-1.2570967588705315, 9.163873315729132],
            [-1.2566457763463503, 9.16271576086883],
            [-1.244097094731957, 9.162439182263649],
            [-1.2449100473467245, 9.129450113002619],
            [-1.2430976411488057, 9.124326878942787],
            [-1.2438845809557988, 9.093495535907495],
            [-1.246133960898906, 9.091151402628112],
            [-1.2473410720562448, 9.048596813758165],
            [-1.2486003097721425, 8.991979568932088],
            [-1.23150816092532, 8.991626338185013],
            [-1.2320984066350733, 8.964372987410211],
            [-1.2336682121596985, 8.908083027297055],
            [-1.3356009552076906, 8.910838708691575],
            [-1.4072835286097198, 8.913161570575797],
            [-1.5084272056672008, 8.915862248698808],
            [-1.5373001493856695, 8.916896813549268],
            [-1.5799826910017716, 8.91817073924819],
            [-1.6667254508180331, 8.921360790550581],
            [-1.7533482552163229, 8.924025906867566],
            [-1.7503759496918458, 9.007721654267549],
            [-1.7717960688865364, 9.008486729145881],
            [-1.768679113449045, 9.093667951582322],
            [-1.768581545418731, 9.101147669061966],
            [-1.7657325454610544, 9.178765424571242]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.9016745124214, "lat": 47.717594963720884 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38027"],
        "coty_name": ["Eddy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eddy County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01034222"
      },
      "bbox": [
        -1.7717960688865364, 8.908083027297055, -1.23150816092532,
        9.178765424571242
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.0289071350034, 1.854652679429541],
            [11.0717037503112, 1.8579534934945043],
            [11.07156143129525, 1.8590174614239243],
            [11.114013824587246, 1.8619918295255642],
            [11.141859026564983, 1.8654325272610341],
            [11.166732850854487, 1.8678658930996694],
            [11.277047154909312, 1.8780753793596359],
            [11.316827338022115, 1.8820043617068845],
            [11.316900336166235, 1.8814267169048875],
            [11.360496816505943, 1.8864401644554185],
            [11.360660171976107, 1.8858027933130197],
            [11.37132749314132, 1.7985565233351135],
            [11.414610097863283, 1.8034321511182778],
            [11.419617183549757, 1.7644756053653945],
            [11.424805533686163, 1.726382049279528],
            [11.348232903360794, 1.7183132900730151],
            [11.344635676989375, 1.7145196547597386],
            [11.334056020929742, 1.7117981912726483],
            [11.329916747471414, 1.7091601335069324],
            [11.328869963055118, 1.703774910478326],
            [11.330917383334816, 1.6943587816399914],
            [11.33104754517985, 1.6872739668459553],
            [11.328607038027094, 1.6715842641486303],
            [11.332204015572094, 1.6596785371258638],
            [11.332010264878065, 1.655712145824338],
            [11.345045000733087, 1.6571140252488452],
            [11.350030461691581, 1.6066223478344706],
            [11.331688573743081, 1.6044438415585103],
            [11.310093069235807, 1.6026240358892099],
            [11.309214673108107, 1.6084205058812047],
            [11.291847662166118, 1.606709360555583],
            [11.29160812454869, 1.6098366483218256],
            [11.261368689764383, 1.6068182846358556],
            [11.266138302663462, 1.5617188271889586],
            [11.251528854019577, 1.5605913779915332],
            [11.17853186201643, 1.5538869459869487],
            [11.090499542195223, 1.5466572414017394],
            [11.083339410489087, 1.6381879250229756],
            [11.089416221591343, 1.6384662129276428],
            [11.086637365076015, 1.6677803105458207],
            [11.08593615228906, 1.681431690136303],
            [11.082329036346216, 1.7255851570758325],
            [11.075240347263772, 1.8143106289720627],
            [11.032582117280365, 1.8110543721402372],
            [11.0289071350034, 1.854652679429541]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.85267625965683, "lat": 39.62036919680103 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39115"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01074070"
      },
      "bbox": [
        11.0289071350034, 1.5466572414017394, 11.424805533686163,
        1.8864401644554185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.28561844397095, 3.5042826748475315],
              [10.291732867723605, 3.5114375922486247],
              [10.294369622692072, 3.508887118231725],
              [10.293934791022737, 3.502604514379585],
              [10.291499715784855, 3.498905863647889],
              [10.287454492166274, 3.4972173435075256],
              [10.28561844397095, 3.5042826748475315]
            ]
          ],
          [
            [
              [10.214680946029107, 3.6951628670722867],
              [10.226471103253699, 3.699751611020921],
              [10.225026379049432, 3.69600872546688],
              [10.21577980860735, 3.6938197222261575],
              [10.214680946029107, 3.6951628670722867]
            ]
          ],
          [
            [
              [10.197810812760936, 3.68328702384558],
              [10.20680901180581, 3.6916369247305543],
              [10.213370217013585, 3.6897526985260125],
              [10.214583213792924, 3.6820528011754363],
              [10.212148286372509, 3.6780979952315582],
              [10.214131668860375, 3.6726941998683507],
              [10.208285260463718, 3.6708771883897575],
              [10.205817245949026, 3.6783252666275583],
              [10.203497496871893, 3.681628470011226],
              [10.198578897141044, 3.6808358636579137],
              [10.197810812760936, 3.68328702384558]
            ]
          ],
          [
            [
              [10.186703446961108, 3.708317437209667],
              [10.188135471565696, 3.7130441120533577],
              [10.191291541259487, 3.7159449904990156],
              [10.192267226643915, 3.720887377163004],
              [10.195921785938486, 3.7231615250348886],
              [10.201149508091046, 3.7227924395946346],
              [10.203333304402925, 3.719609789356871],
              [10.203504144352623, 3.71224740002409],
              [10.20625003546154, 3.708653725428357],
              [10.20165387387758, 3.706762538311253],
              [10.196204582471768, 3.7061558216083132],
              [10.186703446961108, 3.708317437209667]
            ]
          ],
          [
            [
              [10.189577069062535, 3.6430185862342817],
              [10.195263422589779, 3.654617948325177],
              [10.200391430988045, 3.6579266358283444],
              [10.201927679285228, 3.652678369926428],
              [10.205787232515364, 3.6523904034663883],
              [10.211697229537872, 3.6545458718341934],
              [10.215498684223519, 3.664705803962437],
              [10.222374733237563, 3.6669147835401916],
              [10.222541294906945, 3.661045247171679],
              [10.21194582841698, 3.652132641946793],
              [10.212473722830614, 3.645374220954284],
              [10.205747982877343, 3.6379981494858153],
              [10.203839597328065, 3.6326528021936557],
              [10.198376336282745, 3.6273275852481355],
              [10.193712943765318, 3.625892065240829],
              [10.195569791509003, 3.638879160132669],
              [10.189577069062535, 3.6430185862342817]
            ]
          ],
          [
            [
              [9.772823254185788, 3.5585765107068816],
              [9.806196414315284, 3.564379314750103],
              [9.858131458076956, 3.5726528784911586],
              [9.95342924773503, 3.587056069856322],
              [9.966305196246527, 3.584178214001968],
              [9.97962674093457, 3.582382616429051],
              [9.984633583999663, 3.5831759949884963],
              [10.003454795729018, 3.5833031779181814],
              [10.017110843298058, 3.578606249590597],
              [10.025962784596667, 3.5738542586696567],
              [10.03587443441107, 3.5658443831529736],
              [10.036993549839998, 3.5608010398409453],
              [10.045161858009749, 3.554229516038407],
              [10.049797618674711, 3.5480948013130083],
              [10.058057784870025, 3.5393155105449376],
              [10.07980411233945, 3.5257740915610616],
              [10.089018205054348, 3.5209709073452333],
              [10.089434516997065, 3.5197406918441265],
              [10.102744042857053, 3.5128821243553188],
              [10.11402373634676, 3.5081098325950593],
              [10.123841481750448, 3.505829375210144],
              [10.138788825788888, 3.5043149846706294],
              [10.140643115966505, 3.5025715819543204],
              [10.147217627329994, 3.5029028893743557],
              [10.15835912247293, 3.5061349977949163],
              [10.170085099215946, 3.511698233994853],
              [10.174076938880287, 3.5142771884577133],
              [10.181548946297164, 3.5211978713476717],
              [10.187060365198414, 3.5281580751571466],
              [10.191116476800326, 3.5358560083127326],
              [10.190778212423403, 3.539547044393138],
              [10.193599390307016, 3.542691826825392],
              [10.193432410452703, 3.5513417905815516],
              [10.196638407905517, 3.5596926126045236],
              [10.192779584570237, 3.559931210468781],
              [10.19124168176702, 3.563444237114842],
              [10.192393446981457, 3.5676984649572496],
              [10.187794032291333, 3.5715914088452543],
              [10.191687955268263, 3.579183304967493],
              [10.195591433118189, 3.581786048157994],
              [10.205218996557148, 3.584795372889233],
              [10.210247807977625, 3.5791965439529982],
              [10.216665368524408, 3.5705651568675285],
              [10.229770948025541, 3.560907394413404],
              [10.239908435013765, 3.5484991202143585],
              [10.247213211111514, 3.5436174880102755],
              [10.256051029592337, 3.544366984919539],
              [10.27239409692171, 3.5528023471113808],
              [10.283175278970603, 3.5515007273237336],
              [10.295138203071279, 3.551900222020619],
              [10.30011703019517, 3.5475959598578313],
              [10.30287935734386, 3.538420961460862],
              [10.30207877821635, 3.5347392477267072],
              [10.29681697420668, 3.527100639272909],
              [10.304918809368244, 3.5117025119187595],
              [10.301730927007622, 3.5096083126506628],
              [10.300705537301216, 3.515495018585923],
              [10.298193741928532, 3.5192562752871672],
              [10.294814572823897, 3.521143687986216],
              [10.286482059226373, 3.519522047638771],
              [10.279202315116214, 3.5192707998176216],
              [10.27464819150281, 3.516716355458348],
              [10.267452942662912, 3.5080407424367226],
              [10.261832756830444, 3.5073431042064347],
              [10.260780570929022, 3.5091674687882386],
              [10.255470134929856, 3.51024841652572],
              [10.249080596365333, 3.5097743728624886],
              [10.243697153158832, 3.506751847759473],
              [10.236867121515663, 3.507531728199425],
              [10.230812136156118, 3.5029825356851854],
              [10.228485614445097, 3.498698360110648],
              [10.227952689197659, 3.491030086703499],
              [10.225851543564762, 3.4894719221725627],
              [10.220721089049272, 3.4948230268129015],
              [10.215111776250307, 3.4978377990995377],
              [10.209384701346215, 3.499162835197024],
              [10.202601834423358, 3.4957998563417183],
              [10.198963771266703, 3.4903932022575797],
              [10.195097595206573, 3.487674863698364],
              [10.18274490486013, 3.481956697029002],
              [10.16577568330087, 3.4799646986023323],
              [10.152307617605269, 3.4773851806456113],
              [10.14547292058989, 3.474587684690953],
              [10.131774277952934, 3.474520164122904],
              [10.126489231559358, 3.4739418640200053],
              [10.120847953324647, 3.4652743825347416],
              [10.121372752142776, 3.46211843489021],
              [10.118087508638682, 3.4511445304521042],
              [10.112908275074684, 3.4511527548780916],
              [10.10691238744312, 3.4472897409928382],
              [10.105526854600384, 3.4425945465333667],
              [10.099001951986155, 3.4438893149896534],
              [10.097260777273227, 3.4487609973280167],
              [10.092469191143152, 3.4497541274225583],
              [10.08116169364915, 3.446350482877546],
              [10.07989990022104, 3.4439029000811727],
              [10.07120162318893, 3.4421270335946628],
              [10.07236181299474, 3.4350053847825226],
              [10.051179216239277, 3.4317313285026514],
              [9.994092593182216, 3.424508286928109],
              [9.966279729085002, 3.42085854614817],
              [9.966186900200707, 3.421414508840338],
              [9.893082570981438, 3.41107488633992],
              [9.851626663990835, 3.4050912079663265],
              [9.845193822392103, 3.4485662853148695],
              [9.789607205091476, 3.4401779504137977],
              [9.787677672386161, 3.4549133735516318],
              [9.772823254185788, 3.5585765107068816]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.1438607103925, "lat": 41.53779756763504 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39123"],
        "coty_name": ["Ottawa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ottawa County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01074074"
      },
      "bbox": [
        9.772823254185788, 3.4050912079663265, 10.304918809368244,
        3.7231615250348886
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.15486678424914, 6.848003799124539],
            [-19.152789446914998, 6.8550458600545605],
            [-19.139299885012605, 6.851129801769534],
            [-19.136924258601343, 6.857909612507818],
            [-19.130255932773096, 6.856039112212391],
            [-19.12819678326096, 6.862973735258106],
            [-19.121245179523264, 6.860965016227424],
            [-19.11916518105717, 6.867862156365189],
            [-19.112240680236788, 6.865790318978096],
            [-19.11047934969259, 6.871637226047253],
            [-19.090536793053364, 6.865772831158317],
            [-19.085548461416774, 6.883174357628411],
            [-19.057852503540115, 6.875015910009136],
            [-19.058877630929512, 6.871638156699511],
            [-18.986798153466914, 6.85061625830081],
            [-18.984734030648752, 6.85757824744168],
            [-18.97137561922793, 6.853838932754444],
            [-18.97049212413423, 6.855052060223136],
            [-18.956801456527398, 6.851081118207713],
            [-18.95501782017526, 6.858025378310983],
            [-18.94141699837283, 6.853505010632745],
            [-18.939391778070867, 6.860428098890372],
            [-18.925738263862524, 6.856584237517727],
            [-18.870597350789705, 6.840384618305783],
            [-18.86912379560204, 6.847409614102735],
            [-18.855606826826744, 6.8423575066025295],
            [-18.8419413810822, 6.838275460814632],
            [-18.828820834500924, 6.832119487775784],
            [-18.824787442911525, 6.8460372810720145],
            [-18.818260863700846, 6.844151411061982],
            [-18.813901455686203, 6.857593193794675],
            [-18.806990691727805, 6.85559250959994],
            [-18.80097263012973, 6.876703686391697],
            [-18.78759552121111, 6.872746075596045],
            [-18.7890985660387, 6.867466167431381],
            [-18.775238850556033, 6.863801220381535],
            [-18.771256780457453, 6.877383443019131],
            [-18.75750560887201, 6.8734502798030475],
            [-18.753447213112246, 6.887294794085669],
            [-18.739692056390012, 6.883341806365974],
            [-18.735661479851913, 6.897228980334275],
            [-18.721776255430544, 6.893285553316738],
            [-18.717730776489333, 6.907171960742341],
            [-18.690070394258065, 6.899324991539221],
            [-18.68574292474698, 6.91455577437167],
            [-18.674489867413545, 6.911156264637651],
            [-18.65981053002225, 6.905803462607147],
            [-18.655503311019018, 6.92055216548432],
            [-18.641505130947348, 6.916276134188248],
            [-18.637628440800004, 6.929558644794293],
            [-18.623796117119074, 6.925657220882364],
            [-18.619756959499572, 6.9395617225820585],
            [-18.591784497323562, 6.932196861880455],
            [-18.54955235033358, 6.920316951128878],
            [-18.545535066233125, 6.934232647352892],
            [-18.531733052360842, 6.930366878247809],
            [-18.52774873435365, 6.9442943661809835],
            [-18.51398378832118, 6.940397604828253],
            [-18.509965704047353, 6.954324194136731],
            [-18.496132253960784, 6.950426756907263],
            [-18.492463068708734, 6.963062640582626],
            [-18.409743835468387, 6.939565828262912],
            [-18.43322357211692, 6.857374552290437],
            [-18.43398353489615, 6.8575866190225945],
            [-18.489625130299896, 6.661990941443485],
            [-18.554501330078907, 6.4382020509104985],
            [-18.556707287768624, 6.438824251623998],
            [-18.57926853464954, 6.359498248636642],
            [-18.607287551486188, 6.260017398138803],
            [-18.6310867481077, 6.177420757075827],
            [-18.651944033083904, 6.104396859462023],
            [-18.653720095058837, 6.104885686825738],
            [-18.659364120150943, 6.083424103663112],
            [-18.686303410955936, 5.9901471192129705],
            [-18.748912674609276, 6.009296014935259],
            [-18.77626936713304, 6.015901950669151],
            [-18.830740402200767, 6.031112094609824],
            [-18.87033470974607, 6.041765408164323],
            [-18.93185720395023, 6.056757407656165],
            [-18.98764323190909, 6.071888262758918],
            [-19.059098261111362, 6.092369309248073],
            [-19.113114629515408, 6.107589538734919],
            [-19.222441030710122, 6.138556042019366],
            [-19.235323469801738, 6.14411487193153],
            [-19.248039859722688, 6.148071394419523],
            [-19.27847605680371, 6.160173029967067],
            [-19.292867598515915, 6.165000059504424],
            [-19.32074373130648, 6.170042656373816],
            [-19.354672666605797, 6.178033845077837],
            [-19.354309479465634, 6.178969792983734],
            [-19.327537122729076, 6.269176360537479],
            [-19.319329756046223, 6.297234705307002],
            [-19.317894480289937, 6.297087788514858],
            [-19.272181404314765, 6.453197178946633],
            [-19.25338164999453, 6.51531458225502],
            [-19.23232657220646, 6.585980678062915],
            [-19.197798798365508, 6.703438899537919],
            [-19.17652378407841, 6.774770702582727],
            [-19.15486678424914, 6.848003799124539]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.72847235662024,
          "lat": 42.43217598196934
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41029"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01135853"
      },
      "bbox": [
        -19.354672666605797, 5.9901471192129705, -18.409743835468387,
        6.963062640582626
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.097719837094573, 9.663842846535541],
            [-18.05365165680994, 9.651142006001729],
            [-18.00098716869371, 9.635604551264674],
            [-17.998797726653507, 9.642881790423795],
            [-17.98373897894312, 9.638510313199992],
            [-17.99870428990056, 9.613094455588755],
            [-18.005381524104784, 9.595302498506006],
            [-18.004667614472947, 9.57119385217085],
            [-17.99101085245258, 9.553961201194223],
            [-17.976204838132066, 9.542869173655424],
            [-17.964735953252635, 9.526575347376491],
            [-17.95583584850878, 9.517169651713804],
            [-17.93722161690795, 9.50336456203097],
            [-17.910027461141077, 9.493494031936045],
            [-17.896789861353714, 9.48594772055713],
            [-17.876396094848246, 9.472816722741344],
            [-17.861890716674008, 9.461394416525225],
            [-17.84250204230698, 9.44940260230314],
            [-17.832024595859032, 9.441341445085902],
            [-17.82106470724589, 9.42697529228932],
            [-17.81184310094287, 9.420552439366729],
            [-17.79190060543109, 9.419089352818725],
            [-17.777278178905593, 9.422061052118242],
            [-17.769151493913952, 9.421212154790009],
            [-17.752413469097228, 9.409844071468305],
            [-17.743866420868912, 9.385703433891214],
            [-17.720490833850548, 9.374329922209],
            [-17.70140660548278, 9.369294077298111],
            [-17.688346733448014, 9.369672770289267],
            [-17.652075346647713, 9.376321254273384],
            [-17.63625685952603, 9.385803327558477],
            [-17.605473664074704, 9.3842076082372],
            [-17.587184106996308, 9.375942264277873],
            [-17.57941589409585, 9.375941692348354],
            [-17.533769380640553, 9.389909081881635],
            [-17.51755818054276, 9.391188176774572],
            [-17.50462850525403, 9.388404925951322],
            [-17.48885811572064, 9.391089864187222],
            [-17.4730385020401, 9.396929042164418],
            [-17.464870787341578, 9.405706977577227],
            [-17.461871660759808, 9.406303864177355],
            [-17.450842444639488, 9.40245688228408],
            [-17.440661271706883, 9.404759520450092],
            [-17.451016497881067, 9.368290490410079],
            [-17.448123448001297, 9.364290446252706],
            [-17.447542343391312, 9.357638513182957],
            [-17.450295542466325, 9.354108506819875],
            [-17.450559775402333, 9.350673227616376],
            [-17.455352788699926, 9.343596320402247],
            [-17.454218147582996, 9.34017225420705],
            [-17.45121030181083, 9.338107012202695],
            [-17.45619160921733, 9.329157542052704],
            [-17.453560155731136, 9.318978062798346],
            [-17.451479494722257, 9.317570264796853],
            [-17.45210783412457, 9.312691931266816],
            [-17.45843956405727, 9.30808859180463],
            [-17.468333446105444, 9.307418337359744],
            [-17.46542516194178, 9.303062407589039],
            [-17.4648469774587, 9.2968269919589],
            [-17.46602759220265, 9.29232883955952],
            [-17.46399931813425, 9.283662185055965],
            [-17.46487028767144, 9.279981028828862],
            [-17.458255909318297, 9.270533022953545],
            [-17.455020852391986, 9.26847702750721],
            [-17.450188294918988, 9.26803950034736],
            [-17.44462456525103, 9.269197058455518],
            [-17.44147487667521, 9.266640731249195],
            [-17.44214367123925, 9.261304168854439],
            [-17.439061138077477, 9.253383926675474],
            [-17.43906673608005, 9.250674149018316],
            [-17.443157798802478, 9.245320520333443],
            [-17.442032243781263, 9.241457758584348],
            [-17.436106225623202, 9.236879989255923],
            [-17.434755923911222, 9.225938936039665],
            [-17.430117108446563, 9.223054555431245],
            [-17.426693940108667, 9.214782582391893],
            [-17.42195818406787, 9.207545615951169],
            [-17.423947547110743, 9.206607685778458],
            [-17.53282060411719, 9.236654360811256],
            [-17.532505088044083, 9.237762432806996],
            [-17.546681674192996, 9.241821975120315],
            [-17.602158435810953, 9.25623583092867],
            [-17.62934463021, 9.264534394076092],
            [-17.6296873580522, 9.263337576486755],
            [-17.64342276489545, 9.2679716167537],
            [-17.712738713363958, 9.28743081444101],
            [-17.727950457498466, 9.292158598261475],
            [-17.775259717277983, 9.305560573981836],
            [-17.795049210114716, 9.310804552458587],
            [-17.82352160699642, 9.319180291819182],
            [-17.84358044905652, 9.32423767539967],
            [-17.879176344046, 9.334261808954958],
            [-17.90662866503918, 9.342402763738669],
            [-17.92062104505953, 9.34606408986993],
            [-17.93451297482048, 9.350467088057352],
            [-17.97666850740787, 9.362389966806154],
            [-17.977220483046153, 9.359660227887996],
            [-17.99075613784356, 9.362631628343895],
            [-17.988455695160283, 9.349574211665773],
            [-17.98561293177627, 9.346960981761985],
            [-17.98588725220898, 9.342521213456399],
            [-17.99017707809291, 9.340119955591348],
            [-17.989444642302345, 9.336480497532023],
            [-18.0533234983887, 9.355257304340345],
            [-18.04130677281957, 9.39615010233527],
            [-18.02947622661178, 9.437002751466412],
            [-18.043329228522953, 9.441008839166912],
            [-18.03933174395518, 9.454510370428409],
            [-18.052624912948932, 9.458469448407358],
            [-18.048978422146053, 9.472232161063053],
            [-18.054047848398024, 9.47465548349695],
            [-18.054541900647955, 9.48131127207788],
            [-18.06085035429365, 9.483105667881556],
            [-18.058873135896782, 9.489957667400944],
            [-18.07264056870254, 9.494027329578378],
            [-18.06883502355066, 9.507805756685284],
            [-18.082711445704167, 9.51177102977541],
            [-18.078634269909703, 9.525306184458426],
            [-18.092565654707855, 9.529338455609823],
            [-18.088499377725515, 9.542904172265608],
            [-18.102218625537652, 9.546964899171048],
            [-18.098195390787822, 9.560301420295096],
            [-18.112324578636745, 9.564658246518496],
            [-18.108342900087344, 9.578365713033364],
            [-18.121785083723942, 9.582310804288529],
            [-18.097719837094573, 9.663842846535541]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.41479270306493,
          "lat": 45.54679275137029
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41051"],
        "coty_name": ["Multnomah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Multnomah County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01135861"
      },
      "bbox": [
        -18.121785083723942, 9.206607685778458, -17.42195818406787,
        9.663842846535541
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.880351740696725, 2.8093114427323735],
              [15.870772808503274, 2.8061701252820477],
              [15.872451921299785, 2.812429898313195],
              [15.874231330024912, 2.8139834381427065],
              [15.880351740696725, 2.8093114427323735]
            ]
          ],
          [
            [
              [15.598800321461095, 3.0563094332924843],
              [15.610157807951586, 3.0713124945420653],
              [15.615150081103458, 3.0770245154993288],
              [15.630674333099368, 3.0967704379956227],
              [15.678233144570392, 3.1554777467053086],
              [15.686422778109335, 3.1652553075757286],
              [15.707171183433653, 3.1876552151575472],
              [15.713216898429346, 3.1833858721331247],
              [15.716586308143206, 3.1842438291667143],
              [15.721780912248336, 3.1911304508172353],
              [15.72550396475712, 3.1944253276458667],
              [15.730047652575484, 3.1959150079110925],
              [15.73744310158853, 3.1935012017991653],
              [15.74106746459754, 3.195167338139682],
              [15.749993018716706, 3.191985792710194],
              [15.75453044255577, 3.191622997493428],
              [15.766776269918456, 3.1884430030427287],
              [15.770325288732963, 3.1838852838481304],
              [15.773623620748115, 3.182629222670831],
              [15.778299281040443, 3.1855137442641444],
              [15.77862620306983, 3.190473234011797],
              [15.775150095519626, 3.1930410158043867],
              [15.774831365498223, 3.1964350019492267],
              [15.778534528241781, 3.1992184320557375],
              [15.781990819293206, 3.198727272819364],
              [15.79366199015638, 3.1781768922669524],
              [15.799871219894648, 3.1719711088488745],
              [15.80231023945205, 3.167039363942313],
              [15.808443723029635, 3.1616546819728377],
              [15.813340435577164, 3.161667200464441],
              [15.815736839867812, 3.165366930046455],
              [15.814976035320784, 3.1700529076835986],
              [15.812337383630265, 3.1737250724828847],
              [15.813035943865723, 3.1776825380745626],
              [15.817242507386926, 3.1766458400756554],
              [15.819888830711273, 3.173230216241579],
              [15.82755626699069, 3.15988201122915],
              [15.836541517318011, 3.1478269930862535],
              [15.846857085113328, 3.142584042288474],
              [15.850922794254293, 3.133033868472673],
              [15.852701067680991, 3.1241296696950243],
              [15.857502285533887, 3.1226240201797197],
              [15.859379536290707, 3.125787126756838],
              [15.860895572765612, 3.1349390894775615],
              [15.863651130243476, 3.137392957547768],
              [15.867549091683387, 3.1378689763309398],
              [15.870061935212858, 3.136056684463788],
              [15.869784875887499, 3.129455770291927],
              [15.866515725635136, 3.1230627601847103],
              [15.86648953330531, 3.117839012423859],
              [15.872051731735182, 3.1109100328138286],
              [15.882212571669967, 3.10679870968996],
              [15.89147698022858, 3.109139379686822],
              [15.897325674880697, 3.1130013236819267],
              [15.90586248756961, 3.110716944575344],
              [15.906693842341177, 3.1050295140665756],
              [15.902308853152743, 3.101060469029507],
              [15.901725168566529, 3.095969700490923],
              [15.904441496425157, 3.0919526786064617],
              [15.910942684186544, 3.088893133015362],
              [15.911307393898246, 3.0830082987986573],
              [15.916709189731563, 3.0806860144024184],
              [15.918348923444189, 3.0747752384578004],
              [15.928383161168966, 3.0837294790282117],
              [15.931527247952639, 3.079520019509901],
              [15.943009255450473, 3.0899108308004224],
              [15.948739697064719, 3.0831594592038254],
              [15.957851905653719, 3.0738210245469935],
              [15.971226935366825, 3.058735517063333],
              [15.987969913641276, 3.074164322518628],
              [15.993613409366365, 3.068378304826229],
              [15.958826166307873, 3.0362116504212002],
              [15.969848516043792, 3.023752040630471],
              [15.940524457993398, 2.982462940869302],
              [15.94841108900452, 2.984315815172253],
              [15.955006684469184, 2.980730031547417],
              [15.955532559531909, 2.9768398036869326],
              [15.938803275233498, 2.9605382153912307],
              [15.913131227151464, 2.9359939235153263],
              [15.89925367521314, 2.9223911821349833],
              [15.903541442224798, 2.9179963741566346],
              [15.904940451337179, 2.9133590937834857],
              [15.901418357282868, 2.9099386860934993],
              [15.896916057344626, 2.909422250228246],
              [15.904011262608806, 2.9017829375532944],
              [15.899232785996743, 2.899687377732515],
              [15.893191860284563, 2.9064183444891407],
              [15.888865783649573, 2.902641540645654],
              [15.88844746574587, 2.898650334038751],
              [15.89093303027191, 2.894050945252971],
              [15.8857743806762, 2.8893281979976075],
              [15.889893147697906, 2.8848623220307417],
              [15.881786169955458, 2.8761320357928906],
              [15.872740284368598, 2.8673633753385226],
              [15.873006057161412, 2.8630428136736894],
              [15.876166591076085, 2.859587544914035],
              [15.85923408135185, 2.841792758778532],
              [15.863797147673685, 2.8376404812792906],
              [15.86282546880606, 2.8307177282700526],
              [15.860421665805228, 2.823449134620859],
              [15.862978863683342, 2.8217021436358363],
              [15.868345973156423, 2.821153218012095],
              [15.867856354155595, 2.8131683779278434],
              [15.866524568238791, 2.8090073346568905],
              [15.869507486899623, 2.8056736644871765],
              [15.853558047882778, 2.7988105182224743],
              [15.83672584129515, 2.7893365045711334],
              [15.822431142274702, 2.7787911000521928],
              [15.807362570113868, 2.7651074905533823],
              [15.797851378912243, 2.754331687707798],
              [15.78839410828057, 2.7413412126140675],
              [15.782576020147834, 2.731962005633773],
              [15.773142199217661, 2.7131381884392267],
              [15.768868943920143, 2.701668614558432],
              [15.763423542176044, 2.6800481302952877],
              [15.760996474853318, 2.663421411726063],
              [15.749965176337065, 2.661040188822219],
              [15.741863449565562, 2.6589662760871158],
              [15.685560385596903, 2.6467598855525623],
              [15.593594699610316, 2.6268509760656067],
              [15.571950979589639, 2.622500989098248],
              [15.491533206790272, 2.605128652985319],
              [15.491289973402703, 2.6107482640638824],
              [15.496212146445322, 2.612310903158579],
              [15.501084113576203, 2.609061072700666],
              [15.503664950943516, 2.6116749702034037],
              [15.501186317271161, 2.6157217041097107],
              [15.50010392545635, 2.622208406993846],
              [15.504645645329981, 2.6239560235221697],
              [15.50888999385447, 2.622497079292529],
              [15.508267374171378, 2.6158557835177114],
              [15.513673795876327, 2.612323256850429],
              [15.51615474901671, 2.6131487212443423],
              [15.521046636382106, 2.623735420796557],
              [15.517610706413523, 2.626821818243328],
              [15.512686609049304, 2.628506007912162],
              [15.515864545834182, 2.632506866754253],
              [15.51882300760482, 2.632845371151004],
              [15.524112992115585, 2.6396505719340007],
              [15.524417228607048, 2.644568131891964],
              [15.52144056001318, 2.6468631749534213],
              [15.523230795836, 2.6528725366439696],
              [15.527149859095312, 2.654181529232219],
              [15.534819929160957, 2.653911219462453],
              [15.53690907118189, 2.6590270990794256],
              [15.533965071903314, 2.664361123390476],
              [15.536247843958819, 2.669720210756707],
              [15.536812468831695, 2.6748396758137734],
              [15.542480736755493, 2.6800895227688493],
              [15.542191869389127, 2.6856521274805183],
              [15.545982261034021, 2.6944033866220605],
              [15.541795796698182, 2.697678679957505],
              [15.547027748818156, 2.6995563445163446],
              [15.548192945369719, 2.7064150367688478],
              [15.547346730020733, 2.710040545848476],
              [15.550581753291215, 2.711144989042183],
              [15.549233447139729, 2.716308680758612],
              [15.544118366690089, 2.721188575887196],
              [15.545942992875855, 2.7243303859670465],
              [15.550843700802162, 2.723482831636628],
              [15.552575670608295, 2.730703599406892],
              [15.557159760376406, 2.7323826000911287],
              [15.554756072770456, 2.7387683838572605],
              [15.551120621683003, 2.745058584787198],
              [15.549959786098379, 2.753569703444052],
              [15.558720381143674, 2.75383036791673],
              [15.55966989820168, 2.756087247026537],
              [15.557657462303219, 2.768695503642346],
              [15.55761456854266, 2.775152442857351],
              [15.562079990361948, 2.7752268115680248],
              [15.568045537203167, 2.773109541609796],
              [15.570096063016896, 2.7774024854872703],
              [15.568201165348702, 2.78291482291088],
              [15.56442444274873, 2.786172100398097],
              [15.564088794870107, 2.791698666916518],
              [15.566415673690232, 2.7969380018350103],
              [15.565149897311178, 2.7993292716752554],
              [15.56014395654452, 2.8026127190271333],
              [15.55473436734566, 2.8126884052653067],
              [15.555270292311443, 2.8197024946869185],
              [15.552453739721631, 2.8247467922890874],
              [15.55519990723822, 2.832487034806783],
              [15.55808136251838, 2.833923560391413],
              [15.56205842223377, 2.8385647442572357],
              [15.555545264553963, 2.8434440826524194],
              [15.551611365347473, 2.850821179039062],
              [15.547910787855383, 2.8550766594175023],
              [15.551777193342007, 2.8683875045060803],
              [15.550675045471309, 2.8709319547533227],
              [15.55701273127693, 2.8931770606241236],
              [15.57357451978639, 2.948206508436945],
              [15.572579669753074, 2.9584033084009858],
              [15.567414017834244, 2.97563599267797],
              [15.564694021378328, 2.988633290571971],
              [15.553110663194763, 3.0178253973603635],
              [15.587752567935588, 3.0461306624527777],
              [15.598800321461095, 3.0563094332924843]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.74829890330051, "lat": 39.97310460793875 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42029"],
        "coty_name": ["Chester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chester County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01209174"
      },
      "bbox": [
        15.491289973402703, 2.605128652985319, 15.993613409366365,
        3.1992184320557375
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.040461027743326, 4.075208528978541],
            [13.143003178313677, 4.093156387147012],
            [13.143135775581229, 4.094786685528632],
            [13.191924777526637, 4.104599674238908],
            [13.244589188117514, 4.114101793247684],
            [13.383584588891402, 4.146451794532186],
            [13.38962836344314, 4.117773755224741],
            [13.435240610477699, 4.1258041011004405],
            [13.445053500889713, 4.081908764027592],
            [13.447483509140254, 4.068862865957873],
            [13.446203296129623, 4.068719027689527],
            [13.451524965844234, 4.040303690476773],
            [13.458488900445932, 3.9992158775262125],
            [13.459671801823681, 3.999312904504468],
            [13.472064116691522, 3.9313768923233487],
            [13.505164470831083, 3.9374010508682775],
            [13.593583379918321, 3.953837220344989],
            [13.60845471693906, 3.8736073981161505],
            [13.62291401129907, 3.8761592031390286],
            [13.638753212564522, 3.784016462094147],
            [13.560459763018269, 3.77512052627586],
            [13.422475237349385, 3.759681641708591],
            [13.333927667353258, 3.751022735282467],
            [13.339635189823396, 3.714923370126389],
            [13.296762726892458, 3.691080253851629],
            [13.29172483395386, 3.71918843143146],
            [13.270987964291345, 3.7158238707698388],
            [13.266148358080887, 3.7387139598328516],
            [13.267269085058672, 3.748118701859881],
            [13.245780580023919, 3.756274409470126],
            [13.202766874298996, 3.7722218285926075],
            [13.162310798107102, 3.7875884115229863],
            [13.085122780270321, 3.816425693494952],
            [13.083297728392887, 3.825627466489222],
            [13.08010747727727, 3.8233448319777072],
            [13.07492533393146, 3.8286201101375243],
            [13.071578878189301, 3.827586168013628],
            [13.067785838561912, 3.8190079288368577],
            [13.059468893244553, 3.818388421838333],
            [13.055937826210286, 3.81358557214261],
            [13.053035702323621, 3.8074175369341754],
            [13.049138955756314, 3.8070766299588605],
            [13.045516435227764, 3.804222218293918],
            [13.044388174731537, 3.7966880909454175],
            [13.035498613875252, 3.802633985867295],
            [13.029007683101868, 3.8016370036891534],
            [13.018979459968872, 3.7932156596263376],
            [13.009679820275549, 3.7905577427452477],
            [13.001388569651992, 3.7933459941717023],
            [12.9975085171601, 3.7909611613644767],
            [12.991920591470342, 3.7779633913489774],
            [12.989414634027112, 3.7772123832107725],
            [12.984638094700806, 3.8040570862903738],
            [12.975784026341428, 3.8591960385902073],
            [12.996620827626396, 3.862842805992522],
            [12.99245557477444, 3.8927590419635827],
            [13.056284316935242, 3.9027810671961034],
            [13.05894204178947, 3.888139734523832],
            [13.071879713023007, 3.890578106788098],
            [13.056247172604472, 3.9781100782170675],
            [13.047614937427609, 4.030549458268185],
            [13.040461027743326, 4.075208528978541]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.64911017268636,
          "lat": 41.425135912198776
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42047"],
        "coty_name": ["Elk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elk County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01213668"
      },
      "bbox": [
        12.975784026341428, 3.691080253851629, 13.638753212564522,
        4.146451794532186
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.072972187229315, 2.4619755123005658],
            [13.076701038210707, 2.463998136799582],
            [13.07874648771358, 2.4709874083019985],
            [13.082792037167058, 2.473664677661215],
            [13.081599437822211, 2.478959831375154],
            [13.085599464242195, 2.4885800294643086],
            [13.088316633937671, 2.490577348210945],
            [13.086523876580161, 2.4990147462590704],
            [13.088248647912222, 2.5038267659758193],
            [13.09223202338822, 2.506178434913473],
            [13.092773772191089, 2.514661110998042],
            [13.099016111790021, 2.5211443981931847],
            [13.101797382110302, 2.5201648389663784],
            [13.10581265611617, 2.525253098613903],
            [13.112934128820543, 2.5282715084037815],
            [13.114908826698125, 2.5346865123668256],
            [13.11470110559526, 2.543421089434511],
            [13.121136005488784, 2.5508822762971852],
            [13.125718235584705, 2.5493003099546203],
            [13.131816804438461, 2.5523280358736296],
            [13.133618665700075, 2.5474014639181966],
            [13.137020080415523, 2.544595531348639],
            [13.14180650517983, 2.5452987053049996],
            [13.143924213771653, 2.5516841618292037],
            [13.14808197200883, 2.5574348018854662],
            [13.148554150303413, 2.563158735311546],
            [13.151408533125638, 2.565771423772756],
            [13.151204723125293, 2.5768931761187215],
            [13.153089700945683, 2.5815825211871406],
            [13.151759146379803, 2.584403402284149],
            [13.150707204817348, 2.59216697914449],
            [13.151890393886866, 2.595268442292242],
            [13.150811985009646, 2.599434869987737],
            [13.159266452305992, 2.600161127178198],
            [13.16550290241341, 2.604282261883286],
            [13.16349616006059, 2.6139084798975967],
            [13.160795323590028, 2.6191164867780095],
            [13.162755778018331, 2.6209749287229327],
            [13.167460445534239, 2.620418769572928],
            [13.170600878674964, 2.6232364301682387],
            [13.172624776034105, 2.6277721947095207],
            [13.171127447597483, 2.6293164053738636],
            [13.172631169608481, 2.6369386249164455],
            [13.169737356848223, 2.643016788925017],
            [13.172388189343453, 2.6463050023969505],
            [13.176527456190186, 2.6476770103960128],
            [13.176822500716284, 2.654391335851559],
            [13.181064353955843, 2.657986869721355],
            [13.181295498195059, 2.660857787310821],
            [13.18570936413096, 2.672733258650052],
            [13.183622399396526, 2.6770046655107467],
            [13.186994105949266, 2.6801537319303423],
            [13.18845624511059, 2.6874483771396616],
            [13.191898829307776, 2.6900032384041856],
            [13.193408515924418, 2.6981421907707683],
            [13.195611065442328, 2.6996624258093878],
            [13.194165684662972, 2.7063210181941764],
            [13.195923126754508, 2.709073081600879],
            [13.197094339400513, 2.7158579028628624],
            [13.200205637627723, 2.722299402908357],
            [13.20600524569261, 2.72671797445864],
            [13.207530786665103, 2.7298977092714374],
            [13.206852568107731, 2.7361830176128468],
            [13.23670708668348, 2.742129142711632],
            [13.262020287872806, 2.746726396136928],
            [13.30280984739316, 2.7533896310796147],
            [13.304947590042769, 2.747878615120001],
            [13.307483429157159, 2.7472037484348237],
            [13.32324285846633, 2.7469150060184715],
            [13.327336878086335, 2.7450764602420277],
            [13.330084295598922, 2.7411628392794736],
            [13.328787336216287, 2.736977248653781],
            [13.331700325677732, 2.7343884618703345],
            [13.336089593207003, 2.7235923630197085],
            [13.341577016178158, 2.7193656095595937],
            [13.34474880460895, 2.7225885195344603],
            [13.352328429770546, 2.725781921822306],
            [13.356592385346582, 2.721962497616259],
            [13.362985331311505, 2.7217621343030474],
            [13.364873012176222, 2.724711224699482],
            [13.368894868627509, 2.7246306399535514],
            [13.385571043023756, 2.727237398640914],
            [13.428109606982687, 2.734541927046285],
            [13.510321228318585, 2.7488143520375696],
            [13.510231785156867, 2.736365558602242],
            [13.50230292679465, 2.714513811441626],
            [13.495228592642196, 2.662217936664932],
            [13.492584518494244, 2.6446510346807885],
            [13.48130108123602, 2.5654916956631593],
            [13.471250634157789, 2.5691279822758557],
            [13.46616459227858, 2.549837599752958],
            [13.473986883329383, 2.5079314295414883],
            [13.475088770515862, 2.507897554329017],
            [13.477893309828636, 2.4945195855762266],
            [13.495746218696713, 2.4055372193883406],
            [13.496389027950789, 2.401505237583173],
            [13.504706356679726, 2.361723156081942],
            [13.505144565407518, 2.3583885076403237],
            [13.513135228362843, 2.3190630089015514],
            [13.510914126460893, 2.289845871232444],
            [13.50867265165114, 2.2830785780700307],
            [13.498445236411477, 2.231961300417544],
            [13.495880783046513, 2.2247326421915057],
            [13.493117446043144, 2.212306949207511],
            [13.403149177694658, 2.195765519311987],
            [13.315299272783127, 2.179988683787675],
            [13.193306679823745, 2.1574181593528117],
            [13.130817354447363, 2.1459401603927604],
            [13.055304504942592, 2.132145438293504],
            [13.056564259890694, 2.1381519342226456],
            [13.053180400256988, 2.14329051878586],
            [13.049783394629051, 2.14412521072781],
            [13.042892972564985, 2.14239823234897],
            [13.039796258986186, 2.143286303082483],
            [13.03955249549289, 2.1494897559915467],
            [13.04259553953424, 2.151972041555682],
            [13.050271079147253, 2.1536327907058967],
            [13.049494260734857, 2.157592518303713],
            [13.043973516445215, 2.1644302569437595],
            [13.044264016136577, 2.1679359915154874],
            [13.052857918438463, 2.173139066929328],
            [13.057328764601417, 2.1810975381432147],
            [13.05537382097422, 2.1851563784524433],
            [13.045982682607669, 2.188415036526962],
            [13.042418747406712, 2.192395025520092],
            [13.043902480287013, 2.19450019116996],
            [13.050551798261552, 2.1936251447510244],
            [13.052215617856083, 2.1951478115771756],
            [13.052556282469931, 2.201967400835492],
            [13.06073464491306, 2.1990077286590424],
            [13.071537229279008, 2.1965127328573435],
            [13.074308572762357, 2.2000753917492832],
            [13.07210565388524, 2.203782689426799],
            [13.065958091258846, 2.2026959564293036],
            [13.06365267853178, 2.2039272538336157],
            [13.060384438925894, 2.2092900358965357],
            [13.058960025000141, 2.2147542675577343],
            [13.061692100183434, 2.2206845150462486],
            [13.057969675390327, 2.2341283296852943],
            [13.052396658119804, 2.2398313942598476],
            [13.04362873637663, 2.239450768469479],
            [13.043377387476209, 2.2476995493525274],
            [13.036713585050636, 2.249925560198153],
            [13.032991327325, 2.253201344491804],
            [13.019890969858306, 2.256853746107327],
            [13.01328111358076, 2.2602748352125666],
            [13.019164783762596, 2.3091955919555947],
            [13.024836989120157, 2.3257175228513263],
            [13.021221583778766, 2.328978966153215],
            [13.026037034571583, 2.3349382098992346],
            [13.026003930967907, 2.3380718591446366],
            [13.028784341632734, 2.3442712731341784],
            [13.028133281060944, 2.347756602492538],
            [13.03221031258519, 2.3483443962294417],
            [13.041033322437121, 2.3720642059740173],
            [13.047913674593227, 2.3918548897055625],
            [13.04686621622036, 2.397560470368821],
            [13.049953194021398, 2.398063688625205],
            [13.057891742043417, 2.4214661926206738],
            [13.069999023762861, 2.45283337050305],
            [13.072972187229315, 2.4619755123005658]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.02834894979385,
          "lat": 39.972531209136214
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42111"],
        "coty_name": ["Somerset"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Somerset County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01209188"
      },
      "bbox": [
        13.01328111358076, 2.132145438293504, 13.513135228362843,
        2.7533896310796147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.585265642082735, 5.33186651672253],
              [18.585856598352386, 5.334095155104821],
              [18.591872917363297, 5.335417129690711],
              [18.593922952088736, 5.332160729806989],
              [18.59508431059829, 5.3266360501506735],
              [18.58873724493881, 5.324931530948599],
              [18.585265642082735, 5.33186651672253]
            ]
          ],
          [
            [
              [18.571843270479615, 5.215539664693729],
              [18.574131878336864, 5.214988905996506],
              [18.576294794943593, 5.208482424613423],
              [18.573749054680306, 5.208387928503008],
              [18.571843270479615, 5.215539664693729]
            ]
          ],
          [
            [
              [18.537611815158495, 5.321224483875918],
              [18.53972419255012, 5.323418314672392],
              [18.542856392901715, 5.330285771031433],
              [18.53634655423706, 5.332448755263379],
              [18.538450431984867, 5.3379108514358915],
              [18.546485743170656, 5.334474053965876],
              [18.54603723552742, 5.331301811891483],
              [18.549794966154643, 5.323679781998888],
              [18.545439039665787, 5.318166902625045],
              [18.550883142064762, 5.313934008533374],
              [18.56103844149568, 5.311054970063371],
              [18.56807550144133, 5.312589316358549],
              [18.571190347349077, 5.309813292431698],
              [18.57585994320334, 5.309302880062649],
              [18.580714706579617, 5.302841204493764],
              [18.58515222467383, 5.290264102297734],
              [18.58381071658518, 5.288817825427747],
              [18.583573461318828, 5.281413840972707],
              [18.580864401627245, 5.265876267414823],
              [18.575295743147947, 5.259678193190304],
              [18.571190058552506, 5.2603937351379955],
              [18.566339985235512, 5.264904499191892],
              [18.563278846624208, 5.273220705900944],
              [18.562755212687353, 5.284679302605331],
              [18.565224952756758, 5.295978275392985],
              [18.563903357742127, 5.303957467418424],
              [18.553586895522212, 5.308648850723937],
              [18.543331530795594, 5.308665656111423],
              [18.539725089471386, 5.3149113859325805],
              [18.537611815158495, 5.321224483875918]
            ]
          ],
          [
            [
              [18.643791199106325, 5.378040989551329],
              [18.658824101877617, 5.378210514586552],
              [18.659611068890683, 5.374993390994894],
              [18.682637754394925, 5.375614254482243],
              [18.69263776486263, 5.375482933498569],
              [18.693147837745073, 5.374208649719036],
              [18.698893293921703, 5.344229175650155],
              [18.69664287642146, 5.338946384026715],
              [18.697933566423814, 5.331171775727744],
              [18.701453057438027, 5.32071210620319],
              [18.704334516640106, 5.318840999496337],
              [18.7114371412628, 5.31008517777842],
              [18.736119538310273, 5.243794209586983],
              [18.743876597347192, 5.2201933146006025],
              [18.737963786026064, 5.217406659399292],
              [18.73309066935306, 5.213673910671303],
              [18.73110023273248, 5.208982238302858],
              [18.73423246363111, 5.203072287750002],
              [18.727765744264612, 5.193425424541839],
              [18.72167902467265, 5.191976210848559],
              [18.720039181724943, 5.187127004009149],
              [18.717074774833268, 5.1859915607027025],
              [18.71578760776461, 5.182507060848755],
              [18.71872983853111, 5.176091599433769],
              [18.706367782744483, 5.171588548999211],
              [18.70184739741188, 5.166345572942586],
              [18.698552317398256, 5.17037274198424],
              [18.697785402064007, 5.173950312598417],
              [18.7003704290581, 5.176516218674799],
              [18.698650967897905, 5.184161016059955],
              [18.699003927239833, 5.1883189499390765],
              [18.697332315069197, 5.1941177430567205],
              [18.688762778875667, 5.199612941281659],
              [18.68498069854621, 5.205478810114135],
              [18.68180634132728, 5.205498055236112],
              [18.681882846716572, 5.2212616222060015],
              [18.67779182452026, 5.2250901569044395],
              [18.676673206322086, 5.229196859141984],
              [18.672750133944156, 5.233904117967114],
              [18.67204046415818, 5.246096270539647],
              [18.66998284944796, 5.248320372283851],
              [18.662442140144957, 5.250169520969041],
              [18.661534212620225, 5.259916354034287],
              [18.66285955867568, 5.261747505750346],
              [18.661514521291537, 5.274692989918708],
              [18.65909208131669, 5.284584025023381],
              [18.65408238774879, 5.285835433908695],
              [18.653311013853667, 5.288031462560576],
              [18.6577878844681, 5.297896830984567],
              [18.657406321378737, 5.302041772426666],
              [18.654437804226866, 5.303585125416578],
              [18.648496179970884, 5.3117799304742865],
              [18.645586816443974, 5.324980672236487],
              [18.642589142670428, 5.326221449009457],
              [18.636944855392883, 5.3220181496748955],
              [18.6284784635723, 5.318192817852755],
              [18.626008065913826, 5.315311937954477],
              [18.62894634854845, 5.30334093433248],
              [18.63216636215578, 5.284012426324413],
              [18.640831359505555, 5.273081715980704],
              [18.643276093179097, 5.263580644757426],
              [18.643497327252778, 5.257171590835944],
              [18.64839990713019, 5.25182354110437],
              [18.648305083800516, 5.2440393967960235],
              [18.650317603375907, 5.241248262795153],
              [18.65056620004154, 5.235252126474715],
              [18.65276657983421, 5.232394473750992],
              [18.658738604876834, 5.229575654543005],
              [18.65944781976142, 5.222750153622905],
              [18.65851269176829, 5.214721353966218],
              [18.65549209776574, 5.205088781712225],
              [18.656488502720098, 5.201357574075112],
              [18.6541635644665, 5.1930138235875365],
              [18.654242762714926, 5.18890611860821],
              [18.658104817556204, 5.185201999549601],
              [18.66301220271111, 5.186477753286142],
              [18.663346528286894, 5.1766321353911735],
              [18.658749465611084, 5.1728597419538715],
              [18.658815871586498, 5.179727710660235],
              [18.652440169072673, 5.183892906340025],
              [18.647531317785504, 5.184664759661456],
              [18.6406690876566, 5.183149064707079],
              [18.640704430874237, 5.179506596957928],
              [18.636323749689055, 5.173505175101953],
              [18.630110159309027, 5.180424799340418],
              [18.623743637128747, 5.178297591508433],
              [18.620184697615674, 5.174164446378927],
              [18.62209839105414, 5.169521002063568],
              [18.6246290418007, 5.159078288894517],
              [18.62183019288624, 5.1564125417313935],
              [18.620907949357523, 5.15246883500065],
              [18.62281142279133, 5.1488516260553805],
              [18.622996941697753, 5.1434521211867],
              [18.619721603444624, 5.1390765164937315],
              [18.618105028897556, 5.142784377137733],
              [18.612556894082456, 5.141957871771516],
              [18.610179807162154, 5.1455444869097535],
              [18.6076288019487, 5.145228899136838],
              [18.602458570515676, 5.13283910037962],
              [18.594525840849084, 5.13542773448452],
              [18.588851465007526, 5.129486355070371],
              [18.586812159225317, 5.129764851937596],
              [18.58256301438097, 5.138116455811402],
              [18.579065978696214, 5.139357942756839],
              [18.579564039835986, 5.14247401915957],
              [18.584419547648363, 5.148559637294141],
              [18.587568800508727, 5.150788586040797],
              [18.592855947679908, 5.164019596263978],
              [18.59531528187552, 5.160743402154393],
              [18.59636987958949, 5.15213585025499],
              [18.60372354600118, 5.160506060884367],
              [18.608315070583465, 5.163513435235812],
              [18.604563670682875, 5.1731177825350665],
              [18.600273866628058, 5.175495996241256],
              [18.596963881498446, 5.1870206246044335],
              [18.59330056374714, 5.1872665785229595],
              [18.59033484919634, 5.19005542615103],
              [18.5893635080481, 5.20137566327959],
              [18.591343819336345, 5.2055950933262585],
              [18.59431757281111, 5.203351745402849],
              [18.598774336691843, 5.204863292203042],
              [18.600436141538736, 5.2082231316302225],
              [18.59606989823091, 5.216231520406213],
              [18.595802777872755, 5.221423356416224],
              [18.598373900211083, 5.225076745687356],
              [18.5946620356066, 5.231926687425675],
              [18.59623382912712, 5.245846416935558],
              [18.599377665613872, 5.254153795038102],
              [18.599923533895055, 5.258754864061952],
              [18.603737731245797, 5.261694353405142],
              [18.605237307703, 5.2684451908294125],
              [18.600794306520914, 5.270708097042849],
              [18.601022173846914, 5.2808025775881],
              [18.604206837181852, 5.282148908731504],
              [18.605710362941966, 5.297224624504473],
              [18.604364197176235, 5.305226901907223],
              [18.601199672643208, 5.308959554563722],
              [18.602439877525395, 5.314003933148754],
              [18.60715840069831, 5.316564061386272],
              [18.60933177207804, 5.319353911553586],
              [18.609349826225433, 5.325433472843504],
              [18.6134986919752, 5.332296199562841],
              [18.61666841140861, 5.334210733662103],
              [18.624021256432435, 5.334686797297635],
              [18.62579614151271, 5.340321358451981],
              [18.629767144194428, 5.345248601720933],
              [18.630135622907723, 5.352722404861658],
              [18.63248800721689, 5.352793851622241],
              [18.63814492662228, 5.3391747508169685],
              [18.641551057119948, 5.340079768965943],
              [18.640630016939912, 5.354404836090787],
              [18.643791199106325, 5.378040989551329]
            ]
          ],
          [
            [
              [18.524719248945406, 5.331558870862578],
              [18.529145368736536, 5.3331633986065645],
              [18.53522657438526, 5.331388994356572],
              [18.534603234725086, 5.3252282397110635],
              [18.5304128081507, 5.323139753038363],
              [18.524719248945406, 5.331558870862578]
            ]
          ],
          [
            [
              [18.53670097248267, 5.271562802894666],
              [18.539777356379844, 5.279468933411273],
              [18.5421046759217, 5.276809443705831],
              [18.539152469936955, 5.270463938369901],
              [18.53670097248267, 5.271562802894666]
            ]
          ],
          [
            [
              [18.55221248738239, 5.1314340855864184],
              [18.555007931346776, 5.138692253427237],
              [18.551048507283447, 5.144442918531895],
              [18.550387062404912, 5.1496179463323015],
              [18.54768975806599, 5.157278486183517],
              [18.54463833211535, 5.159955192121899],
              [18.544757221059506, 5.162732790265524],
              [18.550118625484387, 5.1629901520528545],
              [18.555624275790276, 5.166466339781294],
              [18.55415627263846, 5.173594223094267],
              [18.55641070842458, 5.178236443179843],
              [18.55057372516348, 5.182763836958657],
              [18.54524040518756, 5.185287620491497],
              [18.54334168908963, 5.18793574104756],
              [18.54187559718105, 5.194668080769683],
              [18.541667170561748, 5.204972230645707],
              [18.54275092701644, 5.210023412568369],
              [18.540329402503463, 5.216439960106303],
              [18.539048064207392, 5.2274218674788075],
              [18.540721897281554, 5.229991699467289],
              [18.540116381524903, 5.239160525782511],
              [18.542588977558722, 5.245462539642028],
              [18.54485269827692, 5.246837653658964],
              [18.550414734984777, 5.245084863498389],
              [18.55682340435489, 5.231669824273062],
              [18.5586378771684, 5.223307644012634],
              [18.557217572171965, 5.216297252215119],
              [18.563500087323597, 5.20235764562086],
              [18.56440984704884, 5.1876973163037565],
              [18.570735018892346, 5.185919615499165],
              [18.57120293105492, 5.180407071281041],
              [18.567280581377332, 5.174746336587692],
              [18.56792287217103, 5.170725157640949],
              [18.576016744686935, 5.16071996670568],
              [18.580573029869495, 5.15917702685836],
              [18.578098160159968, 5.15505277878455],
              [18.57430653271781, 5.15339709526645],
              [18.568642071883527, 5.152989603570538],
              [18.565719265865667, 5.149470443969647],
              [18.562602300992786, 5.156889287526531],
              [18.559321033664155, 5.162238831595884],
              [18.555602858489586, 5.160100979300393],
              [18.55907812816987, 5.151332320087993],
              [18.564008761050545, 5.141934053728575],
              [18.562935315304273, 5.137552236658726],
              [18.559312466822576, 5.138092656955909],
              [18.561127237664135, 5.127662073672057],
              [18.557766034095916, 5.123632190232687],
              [18.553592969147985, 5.12560423412027],
              [18.55221248738239, 5.1314340855864184]
            ]
          ],
          [
            [
              [18.539339229001914, 5.166741620890822],
              [18.53991254535911, 5.175253731115814],
              [18.54426195507454, 5.173730312920958],
              [18.54083685132307, 5.166481325732857],
              [18.539339229001914, 5.166741620890822]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.23584832605668, "lat": 41.55679895206029 },
        "year": "2023",
        "ste_code": ["44"],
        "ste_name": ["Rhode Island"],
        "coty_code": ["44005"],
        "coty_name": ["Newport"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newport County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01219779"
      },
      "bbox": [
        18.524719248945406, 5.123632190232687, 18.743876597347192,
        5.378210514586552
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.56848550332258, -4.149164379160016],
            [13.58308057787937, -4.09344126240494],
            [13.59279056788512, -4.057764837325016],
            [13.606176529699196, -4.001045465976224],
            [13.60938128508075, -3.9905436483232517],
            [13.619095677579368, -3.9459628125527124],
            [13.622007460110057, -3.928624839280878],
            [13.627390704332607, -3.924789182899174],
            [13.627751149846095, -3.9219259404373],
            [13.631340650940661, -3.914846985286529],
            [13.63155716610144, -3.91168186590622],
            [13.634460945058004, -3.909048129980555],
            [13.60933835739692, -3.866097790374442],
            [13.615183184616338, -3.8587519695451107],
            [13.64377298995716, -3.8171133334884617],
            [13.652952705733284, -3.8150132584950955],
            [13.666083368205367, -3.804713233638333],
            [13.687016729992465, -3.7332222774691495],
            [13.694640279454816, -3.7328601771443726],
            [13.70274659974087, -3.7239090331638565],
            [13.710263661988993, -3.7300181033486175],
            [13.720554454046178, -3.7301789212673713],
            [13.758245268720867, -3.771692113126547],
            [13.803008306545337, -3.7645062816563994],
            [13.809279668233717, -3.77284974845384],
            [13.818030900873154, -3.7805191334329304],
            [13.821520467314695, -3.7822295840951945],
            [13.8280546013423, -3.780305106002803],
            [13.8334500287147, -3.7808209612485375],
            [13.842176153451392, -3.7792184712865455],
            [13.850613558867707, -3.7860076052038005],
            [13.853217913648272, -3.786585506778923],
            [13.859222731051041, -3.776193876362611],
            [13.863950973864, -3.773793162512177],
            [13.869202125754363, -3.7751987132140203],
            [13.87809370360001, -3.7723054587015166],
            [13.88107326425937, -3.7723980886375537],
            [13.893348470883286, -3.7662442551757143],
            [13.893301439580634, -3.7706099626085616],
            [13.895773068194353, -3.7756986151898007],
            [13.92342040875988, -3.7786267413239587],
            [14.013967480336573, -3.7887736335148166],
            [14.015296465926737, -3.786687861613075],
            [14.031337072010736, -3.777169438272225],
            [14.035912184358848, -3.778407422301283],
            [14.039637369680174, -3.7766121965378163],
            [14.043578838594943, -3.777756777084724],
            [14.050986949333549, -3.772882742625757],
            [14.057053339535525, -3.7720043566619363],
            [14.062279623166102, -3.7624060050295305],
            [14.068842851721175, -3.7584477313723905],
            [14.072992874610454, -3.753838457660808],
            [14.07977546956381, -3.75047323950173],
            [14.088564321225657, -3.749886642559921],
            [14.09161322027476, -3.744628850936071],
            [14.095892455703867, -3.7417967530544476],
            [14.09899989998693, -3.736879265777629],
            [14.096587721065594, -3.732582294274133],
            [14.098912443013328, -3.72974207662789],
            [14.104209170818617, -3.7303302552941973],
            [14.111056601405167, -3.727761744183244],
            [14.116754663866326, -3.73047101176252],
            [14.124218637949788, -3.7287908659815527],
            [14.126670409103706, -3.7319838905501466],
            [14.131914727094202, -3.734419101522328],
            [14.132253765700284, -3.7373165763609286],
            [14.135998723296794, -3.7393059506594195],
            [14.142188472071087, -3.738501738004151],
            [14.144235298439051, -3.7404275585128883],
            [14.149702277040431, -3.7406325980363397],
            [14.150700650222515, -3.7447007224040725],
            [14.154363650883663, -3.7485995489531816],
            [14.152372663679015, -3.7507587002561626],
            [14.155889427682737, -3.7535124162238884],
            [14.158997718528932, -3.7586341518449737],
            [14.15444743569575, -3.7619270293230413],
            [14.146985139966295, -3.7636418327051713],
            [14.14308710270583, -3.7668308225747373],
            [14.141329112605916, -3.7720544779152347],
            [14.13932863095571, -3.7871657571142534],
            [14.131397649470246, -3.8041081286080844],
            [14.12182777935504, -3.821450689796473],
            [14.109666994610867, -3.8364446796411786],
            [14.09955439534107, -3.862982578992626],
            [14.096240313660102, -3.8846130937122285],
            [14.098505640203523, -3.9024195409264095],
            [14.096055570137635, -3.9167802526213453],
            [14.09333755236055, -3.9241640011805328],
            [14.091326993443484, -3.938228933292004],
            [14.089184148339376, -3.9586259544006626],
            [14.097818949638919, -3.97456076486896],
            [14.099743030906925, -3.976409891586771],
            [14.098643234357642, -3.9808874759709396],
            [14.085030296575955, -3.997341446876012],
            [14.083784095507793, -3.9981934762168043],
            [14.066208254833022, -4.023028472769676],
            [14.061070989246309, -4.040262080669574],
            [14.058982736026602, -4.0439786805095155],
            [14.053157872030798, -4.049412386601275],
            [14.028491824571091, -4.070286267005072],
            [14.023651424263571, -4.077241704416714],
            [14.0245372023529, -4.080845637223363],
            [14.01992240788643, -4.088236276496454],
            [13.995276405838988, -4.130473360287456],
            [13.994757570903461, -4.132269131913824],
            [13.994275670892126, -4.153066306018921],
            [13.989452472903768, -4.1572411356120345],
            [13.98482550693434, -4.170334153458283],
            [13.975598658556926, -4.188755171284658],
            [13.972580936526676, -4.204855321208446],
            [13.971418277558804, -4.207389884838746],
            [13.957826811798599, -4.22145978308588],
            [13.954756465638383, -4.2289285211655905],
            [13.947799575372052, -4.241085622469085],
            [13.942506854340268, -4.248456757408556],
            [13.94248452753812, -4.265944031084471],
            [13.944144704154914, -4.268868615946936],
            [13.950775725766205, -4.27451990835369],
            [13.94817090185989, -4.279898012554608],
            [13.944227621874978, -4.27903021861747],
            [13.931557049208653, -4.273498015890143],
            [13.92776160774405, -4.2705039900865644],
            [13.921932489739334, -4.270796382160661],
            [13.918736383348419, -4.26837401907344],
            [13.911311379478775, -4.272317629668968],
            [13.904471294411255, -4.269945622859906],
            [13.900522492421864, -4.272797561250646],
            [13.892728664386933, -4.271776944930342],
            [13.889353251827972, -4.267125697547823],
            [13.88428160097984, -4.265030239571764],
            [13.878924132726922, -4.266127755544243],
            [13.879771350877599, -4.26161730187036],
            [13.873795019639077, -4.26152612014425],
            [13.872762137299855, -4.254899101552996],
            [13.867021302361506, -4.253478157407854],
            [13.866187455245852, -4.248388840256813],
            [13.861897353206128, -4.2425917443894665],
            [13.855842946723897, -4.240591331497738],
            [13.852470000960345, -4.236271380041697],
            [13.851766327029216, -4.232047904551107],
            [13.847183508615595, -4.228960603332663],
            [13.843761535834398, -4.2283920072738335],
            [13.840034174571205, -4.224425865145689],
            [13.834066727287858, -4.231026427877505],
            [13.830278848134418, -4.231287229070714],
            [13.823017662961467, -4.222616554310727],
            [13.801496558623255, -4.216121535079113],
            [13.798798577143218, -4.210781362925744],
            [13.794090231475804, -4.208931332333095],
            [13.786073046860142, -4.207953801448449],
            [13.785313245833413, -4.204597416807189],
            [13.780199237885968, -4.203269401029237],
            [13.77959146443187, -4.196647120519847],
            [13.776175327499038, -4.193053040532485],
            [13.772552491019537, -4.1929428811116445],
            [13.768774785036253, -4.189522393434156],
            [13.763827274925424, -4.189835867467019],
            [13.763047308351599, -4.185862248774189],
            [13.76805423328185, -4.185592626983744],
            [13.770340750189934, -4.183806047975543],
            [13.76971013315152, -4.1785995127197415],
            [13.762959668861349, -4.178908404927742],
            [13.758548674116545, -4.172009303152088],
            [13.754328271636643, -4.169091703466689],
            [13.749494591339024, -4.167708037307821],
            [13.74527996908771, -4.163242406349183],
            [13.736640220170129, -4.162081547803083],
            [13.731796748413641, -4.1634402388890805],
            [13.72614166864873, -4.155773597073227],
            [13.721818945072952, -4.155090918727298],
            [13.712632491734226, -4.149913888481597],
            [13.708021680596437, -4.145058565701518],
            [13.703031624377592, -4.146987717872619],
            [13.702284894924235, -4.14287238841508],
            [13.69274919773151, -4.138307984697905],
            [13.690882976585106, -4.134079281189272],
            [13.68386362432112, -4.132136448235452],
            [13.680162001149514, -4.128490412820521],
            [13.673728078199737, -4.1272450441619455],
            [13.671418770242159, -4.131019602933216],
            [13.665551027781579, -4.129920939419037],
            [13.662569094544157, -4.132211832889679],
            [13.658095829672657, -4.1306834819399105],
            [13.656866358156732, -4.126378797378978],
            [13.652924142374182, -4.124760129405361],
            [13.649764752522517, -4.126571252905878],
            [13.653300399031744, -4.131112584243308],
            [13.651755184156404, -4.137197748563412],
            [13.64808652121173, -4.136895531175707],
            [13.646192534087554, -4.130283904637735],
            [13.640217592862731, -4.128613785998084],
            [13.633847251911424, -4.132741580969732],
            [13.630385234412396, -4.129138598367369],
            [13.62677106027602, -4.134623736936754],
            [13.623870925478228, -4.134950353378521],
            [13.622879473403875, -4.131001482929061],
            [13.62000074749027, -4.130346404236075],
            [13.618077175988434, -4.135869051221661],
            [13.61615735245388, -4.136987177563019],
            [13.610204970900787, -4.132467929426263],
            [13.597307807119511, -4.1353032838342],
            [13.589794852981646, -4.135100291379289],
            [13.582946451673449, -4.137726295533961],
            [13.58188158058625, -4.143756682068401],
            [13.575729308036793, -4.141538285818152],
            [13.575202810472453, -4.146000781055957],
            [13.571044461369087, -4.146063740928814],
            [13.56848550332258, -4.149164379160016]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.72769042169196, "lat": 33.61991970417499 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45089"],
        "coty_name": ["Williamsburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Williamsburg County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01248018"
      },
      "bbox": [
        13.56848550332258, -4.279898012554608, 14.158997718528932,
        -3.7239090331638565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4571714516725818, 5.990863189615764],
            [-1.371267647716869, 5.987864549250241],
            [-1.2851300898878646, 5.985129315379411],
            [-1.1989139184886763, 5.982618285401762],
            [-1.0985388050021285, 5.979924248792149],
            [-1.026626097935006, 5.97787751100626],
            [-0.9405019938127048, 5.9756502836782115],
            [-0.854209834232984, 5.973496285838413],
            [-0.8559403463892233, 5.887004501486225],
            [-0.8536352462209338, 5.886951773346127],
            [-0.853774411223485, 5.886454806154129],
            [-0.8557881566957313, 5.78372618040382],
            [-0.8574229448630076, 5.701771233449286],
            [-0.8591862043576521, 5.625055405778749],
            [-0.8609132379824084, 5.538611028324979],
            [-0.9442307880885231, 5.53969522668667],
            [-1.0112167131673386, 5.542144185287275],
            [-1.0640124187535844, 5.543565675392121],
            [-1.115292858229125, 5.545421446047868],
            [-1.1589801098455752, 5.546406630956209],
            [-1.2025805447885147, 5.547552525986597],
            [-1.2924550928037437, 5.549777992252905],
            [-1.3793010756667108, 5.552176887741146],
            [-1.4658643569168588, 5.554531585188374],
            [-1.4660539205567469, 5.556605701007835],
            [-1.4638871645993372, 5.6415465719081945],
            [-1.459904385707585, 5.785639867949752],
            [-1.4565009273610414, 5.904208868430965],
            [-1.4596159984224977, 5.904288053002657],
            [-1.4571714516725818, 5.990863189615764]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.27812505149731,
          "lat": 44.414469731375775
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46005"],
        "coty_name": ["Beadle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beadle County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01266986"
      },
      "bbox": [
        -1.4660539205567469, 5.538611028324979, -0.8536352462209338,
        5.990863189615764
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.350132289871462, -1.5412283096950383],
            [11.359198685069337, -1.5412735136351303],
            [11.384564223763332, -1.512128090310069],
            [11.394051524437153, -1.5094844652916297],
            [11.401016099471674, -1.517713638700414],
            [11.406707049436497, -1.5186172187550746],
            [11.427185402741582, -1.5253141423659675],
            [11.433330960216454, -1.5238027201532924],
            [11.437751935836513, -1.5242778987808974],
            [11.44510902720955, -1.517285836827177],
            [11.449130696322689, -1.5111894338293526],
            [11.45392889127535, -1.5059977836204126],
            [11.457703200417063, -1.5037106657999222],
            [11.463571748101108, -1.4970363604595833],
            [11.466742972176613, -1.4950411350713437],
            [11.473089391113804, -1.487785702160107],
            [11.47569120549479, -1.4830166307814479],
            [11.480264076263472, -1.4781627731482965],
            [11.486499175931622, -1.4751888095714831],
            [11.486784424536372, -1.4710790209584326],
            [11.49119603203585, -1.4669446437737834],
            [11.494198121230713, -1.465913296981222],
            [11.496109756792958, -1.4593167960577142],
            [11.499372859853269, -1.455664978749678],
            [11.508942378304143, -1.4532503330030955],
            [11.516053043899113, -1.4546338234101734],
            [11.518714180984055, -1.4513839754181932],
            [11.523887839082763, -1.448784309969353],
            [11.532125719698954, -1.436958412883649],
            [11.533096959237565, -1.4293677808587213],
            [11.543054961560376, -1.4215704994892049],
            [11.549367483547876, -1.4212476076513028],
            [11.553562070267926, -1.4169539256902504],
            [11.565871787439484, -1.4147211338207233],
            [11.570498743370209, -1.4111784119935606],
            [11.574099095783199, -1.4102403566251984],
            [11.573644533936834, -1.4070317310804843],
            [11.570628454179705, -1.4039153500769481],
            [11.576430227316344, -1.3974430811344545],
            [11.5800741669444, -1.3910865339825078],
            [11.582857456855486, -1.393019926761263],
            [11.582043599092009, -1.3994665944200753],
            [11.590815018412766, -1.405244576531119],
            [11.596364915326811, -1.4115751309470443],
            [11.607558016218979, -1.4189708867086326],
            [11.608799270988717, -1.4217369521774077],
            [11.613464646891446, -1.42361996205344],
            [11.611030345572448, -1.430246984830278],
            [11.603664810230951, -1.4362155488971957],
            [11.593988727746064, -1.4560080949722936],
            [11.593935381621622, -1.459085929604399],
            [11.586839737435586, -1.4658475644325066],
            [11.585780345607777, -1.475708013266893],
            [11.57994730808581, -1.4786401684921626],
            [11.579293460196867, -1.4845521874971144],
            [11.574927716697177, -1.4931566858787366],
            [11.568151089308548, -1.5018117227301946],
            [11.566213908017806, -1.5083213785153038],
            [11.563931314287995, -1.5114136064514594],
            [11.562077181168993, -1.5174006512428133],
            [11.557928951528584, -1.5242369593562566],
            [11.553598913621904, -1.5287545973358434],
            [11.551334407655817, -1.533067626234051],
            [11.544495342108874, -1.5424425314038375],
            [11.552223172741778, -1.5450740162671688],
            [11.55843252065085, -1.545074162642491],
            [11.561458063186674, -1.5494047379085607],
            [11.557892684093648, -1.5534164965976494],
            [11.562274740081552, -1.5576036072445834],
            [11.564337734109694, -1.5558479390546305],
            [11.568946781384465, -1.5601970029816377],
            [11.567544712007283, -1.5624945806891413],
            [11.574121108241648, -1.5654995762697852],
            [11.574130310982975, -1.569373465086283],
            [11.58042528122847, -1.5753778909780507],
            [11.582966511104747, -1.5718392414049385],
            [11.590703609071934, -1.5723237898224407],
            [11.594354505144432, -1.5697422681654036],
            [11.59915123005374, -1.5728041761880198],
            [11.597726187392722, -1.5772979812447971],
            [11.599349553273088, -1.5837439511112728],
            [11.607643311359613, -1.5868232098089896],
            [11.607081352222318, -1.5937974350353827],
            [11.613852412432776, -1.596896093998666],
            [11.615918884695995, -1.599748479181985],
            [11.615050712026193, -1.604481152868219],
            [11.617855206092106, -1.6086479617924283],
            [11.618590624903991, -1.6124385743624754],
            [11.62492829637303, -1.6141125166822545],
            [11.6268647477959, -1.6164168120630276],
            [11.628328116571447, -1.6221128624947332],
            [11.63329984229015, -1.6236669038627574],
            [11.63853962021641, -1.6238250292656433],
            [11.64119979741477, -1.6259744301687074],
            [11.643172752680426, -1.6332735997713086],
            [11.644982612109603, -1.6353178755108104],
            [11.65008442968035, -1.6334974252855397],
            [11.65247129583794, -1.630958866695181],
            [11.659125248473003, -1.630069863348903],
            [11.655787635195063, -1.6395196092768825],
            [11.643183550195069, -1.6698934109801895],
            [11.605061417897003, -1.7754136789303328],
            [11.604271352695749, -1.7815477420218564],
            [11.601363728487554, -1.7859553683724803],
            [11.59746021394759, -1.785818899629974],
            [11.592075232667103, -1.7822309106325034],
            [11.583793003579778, -1.782027089362687],
            [11.583188937370636, -1.78833711611095],
            [11.5801138179017, -1.79654162739688],
            [11.575683708359962, -1.7983183384965042],
            [11.565676018355136, -1.8061766968828081],
            [11.55174545452798, -1.8082725075242032],
            [11.545928314338402, -1.8066815261919666],
            [11.538681215341313, -1.8113176343061683],
            [11.529285629547608, -1.8129037304592588],
            [11.526220205857825, -1.8113147683318938],
            [11.518486482327441, -1.799032815070473],
            [11.518260714059968, -1.7896432084901086],
            [11.513771158453883, -1.7827577574440996],
            [11.509985699276976, -1.7751559413358495],
            [11.506200024212335, -1.7703071357051052],
            [11.496396288300975, -1.7747711770523973],
            [11.487498036079572, -1.776211537533533],
            [11.48439197772052, -1.780948798200564],
            [11.477669423920947, -1.7786699405599486],
            [11.474654540024996, -1.7733155414678783],
            [11.471473145298216, -1.7761106808968268],
            [11.468606459420469, -1.7753063336285506],
            [11.460039253327203, -1.7693662278064441],
            [11.452633097058044, -1.768362880415566],
            [11.446463692427075, -1.7715074660845989],
            [11.440531354140923, -1.7513697786327356],
            [11.438428138823337, -1.7502491575990904],
            [11.437963858304345, -1.7443013386531503],
            [11.436104675473183, -1.7387618746822617],
            [11.422824482875898, -1.7269343532381234],
            [11.419093691892428, -1.724623003475537],
            [11.415937726497033, -1.7256943433474712],
            [11.409830894546518, -1.7239885002580728],
            [11.402397565393771, -1.7236883951005606],
            [11.40495202575856, -1.720156236621323],
            [11.405584306094386, -1.7150684040480328],
            [11.410536788822935, -1.70747675770044],
            [11.407880945999691, -1.703111051382097],
            [11.40821280530779, -1.6992912944538483],
            [11.388938128641747, -1.6916948248207417],
            [11.383123603920529, -1.684099629725257],
            [11.354278861358742, -1.679453775442841],
            [11.342842404773034, -1.6885214597947638],
            [11.338868042613106, -1.6893717332150295],
            [11.339055266590204, -1.6833001593797632],
            [11.335812794252494, -1.6784260771638264],
            [11.33868578635965, -1.6723319118279585],
            [11.344080173812259, -1.6476454564564782],
            [11.349544866346305, -1.6020893794245434],
            [11.351447679449118, -1.5880425406436829],
            [11.353724350439148, -1.5665710262020405],
            [11.350132289871462, -1.5412283096950383]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.12743263029873,
          "lat": 36.292770709677676
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47019"],
        "coty_name": ["Carter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carter County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01639730"
      },
      "bbox": [
        11.335812794252494, -1.8129037304592588, 11.659125248473003,
        -1.3910865339825078
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.8040985319283, -2.6597163077329364],
            [5.853900831342416, -2.6505854537729405],
            [5.862284405763285, -2.622756239834557],
            [5.875778265216123, -2.617855773964109],
            [5.885870373290407, -2.606328132895101],
            [5.89529288584238, -2.5935325407276673],
            [5.902592406707884, -2.5811751385576533],
            [5.911732641439472, -2.5617173142305347],
            [5.91736588721073, -2.541333394277256],
            [5.918828848485727, -2.531480684595994],
            [5.923304479554554, -2.5360077471768547],
            [5.923220405001903, -2.5433446054960984],
            [5.927923959209307, -2.544905330859389],
            [5.928362030711761, -2.5480772952527215],
            [5.932902526388626, -2.549477595623722],
            [5.937848060363116, -2.5534494501820895],
            [5.940513307823538, -2.5515806254324476],
            [5.946602337056546, -2.5556819061948635],
            [5.950308951698472, -2.554641409976653],
            [5.953522889588457, -2.560243335491854],
            [5.957418491192601, -2.559067570763826],
            [5.963436636495909, -2.560535317504415],
            [5.964337209405189, -2.5703615881349995],
            [5.968634795279007, -2.589131727874344],
            [5.975865548950624, -2.6070137658292722],
            [5.971845085696041, -2.6134484137652905],
            [5.972421700229949, -2.618550686444506],
            [5.974945885366138, -2.6208809136583726],
            [5.972728944045746, -2.6244214040757603],
            [5.973394709786128, -2.6285104071690513],
            [5.98124268635057, -2.638466622807291],
            [5.985260361687827, -2.6419760548968854],
            [5.986766946199527, -2.6483994790391474],
            [5.991560079582365, -2.6547694394833745],
            [5.989813077229417, -2.6564304958665717],
            [5.992055314682913, -2.665091747120822],
            [5.995821423144168, -2.6657604673021846],
            [6.004199884094942, -2.6651487588919367],
            [6.008040228113384, -2.6637960245714614],
            [6.017979907899425, -2.6683888744915625],
            [6.022534630394171, -2.6677646736090908],
            [6.027651375546712, -2.669792886029716],
            [6.029666110888409, -2.674204360006864],
            [6.032967852175806, -2.676556808474412],
            [6.035785906050879, -2.6745910868530327],
            [6.042995347094966, -2.673856466759419],
            [6.044932468799465, -2.6756381594340843],
            [6.04971580035713, -2.674611523680275],
            [6.054404380514332, -2.671114068805336],
            [6.059454984812922, -2.6701672520801645],
            [6.063040835384605, -2.6678559846980794],
            [6.063957980729418, -2.6752584491663685],
            [6.066247765586561, -2.6825195261485226],
            [6.0764560619898855, -2.682298195179192],
            [6.076956851251911, -2.688876982863271],
            [6.087371068275924, -2.68832170233338],
            [6.087605501105909, -2.6915470540404822],
            [6.092060581641799, -2.692659672913265],
            [6.099763499721799, -2.691991534621213],
            [6.099611334139095, -2.6893180725263903],
            [6.108391976415347, -2.6871754258463474],
            [6.109569439859639, -2.692316193528873],
            [6.12130196904984, -2.6989891664850356],
            [6.124932286197851, -2.704551096578742],
            [6.132319279133219, -2.7029116029211933],
            [6.133517489313407, -2.705312165391079],
            [6.137777405646284, -2.706776355179014],
            [6.138518075435717, -2.709414060582514],
            [6.143684578646441, -2.710840788534984],
            [6.1507039763224585, -2.7158458125294134],
            [6.152023424599, -2.7190709766818775],
            [6.155791046253759, -2.7255855745134454],
            [6.161170764153759, -2.7251131426041613],
            [6.164634959877523, -2.7283486780528756],
            [6.171667862303357, -2.731213991513338],
            [6.1354992057994275, -2.7777690832743898],
            [6.077385990104914, -2.8522053648476917],
            [6.072635278846739, -2.850570578464047],
            [6.07176486960096, -2.8483516694989053],
            [6.0667311796528445, -2.8485936556027593],
            [6.065605283854306, -2.845729497489395],
            [6.057630162046929, -2.8462087477046607],
            [6.044159538154895, -2.8429122892101293],
            [6.040640226753176, -2.838716921175084],
            [6.041900677145121, -2.834999114568921],
            [6.036786247181812, -2.8333170047803873],
            [6.03177681012965, -2.833090155005891],
            [6.025435499427331, -2.8297616622112534],
            [6.013563069546717, -2.828841654948776],
            [6.010878374169474, -2.826291105821792],
            [6.007488628857987, -2.8293070299182155],
            [6.003807627087894, -2.826911417302363],
            [5.998245889926365, -2.8294892288743987],
            [5.98815987480069, -2.81940905371684],
            [5.976446726230624, -2.810271660609674],
            [5.96472795396052, -2.8028033261200376],
            [5.950044128376343, -2.795317016099368],
            [5.9367306227384296, -2.7899902822537355],
            [5.924576694161527, -2.786366966304138],
            [5.908885114092789, -2.7838218162289152],
            [5.895310069419801, -2.7826598813746117],
            [5.870439739977714, -2.782380343012239],
            [5.867976765191166, -2.7767799677726437],
            [5.864270191131053, -2.774882957912713],
            [5.855986056248119, -2.7649739739438197],
            [5.851211046095375, -2.766735984312843],
            [5.848075574792675, -2.764774662154008],
            [5.839971964599592, -2.7652166494685995],
            [5.838455935265673, -2.7664500978008877],
            [5.829487639337434, -2.759393659042708],
            [5.824252210553972, -2.753106735795282],
            [5.820127655822002, -2.7528618618067062],
            [5.815720861315009, -2.74886552608224],
            [5.812914863036332, -2.750271828972276],
            [5.807003475996131, -2.7445303338886955],
            [5.809581413134358, -2.74229950046355],
            [5.805637082829555, -2.7343727905840582],
            [5.798010774686345, -2.7274936301750734],
            [5.797985463050065, -2.724110281388126],
            [5.7933848986528105, -2.719550249454782],
            [5.7938119070897, -2.71367672292077],
            [5.796070124445605, -2.7105156379763673],
            [5.795323394736493, -2.7058588857185324],
            [5.797664881519676, -2.7014782412284086],
            [5.7985631095441414, -2.6925965256029922],
            [5.802107944950203, -2.6893339428003813],
            [5.8048159144234, -2.6836054436257046],
            [5.804359714603161, -2.680479423214488],
            [5.8080307112200344, -2.6781878612189867],
            [5.80598018859229, -2.674954301462853],
            [5.807046562802304, -2.6694861258908986],
            [5.804364000874458, -2.663610689303754],
            [5.8040985319283, -2.6597163077329364]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.1395591000254, "lat": 35.81350719718805 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47033"],
        "coty_name": ["Crockett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crockett County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01648574"
      },
      "bbox": [
        5.7933848986528105, -2.8522053648476917, 6.171667862303357,
        -2.531480684595994
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.483556340515383, -2.5603852277651202],
            [5.504439629589271, -2.5588309308612063],
            [5.506656193294184, -2.5515510671815536],
            [5.514726084175204, -2.538417814330081],
            [5.517963369203855, -2.524519268379417],
            [5.51902958646803, -2.506591000931702],
            [5.519639915470005, -2.4857153750706646],
            [5.520490447879729, -2.4753931441115946],
            [5.525907890380402, -2.465590327083833],
            [5.530326594449882, -2.4612887115265605],
            [5.548633020891364, -2.4521646287073886],
            [5.560167206143414, -2.4481243329239377],
            [5.570219270279055, -2.440411945672578],
            [5.580370141073653, -2.4340143915382355],
            [5.586182281477017, -2.425819890982799],
            [5.5871232969967775, -2.417218743458404],
            [5.586055453877027, -2.4026520938939244],
            [5.5839438633427525, -2.397400088472754],
            [5.578158792519185, -2.388591040426471],
            [5.572815288841673, -2.38225854348671],
            [5.563263841213664, -2.374019174006486],
            [5.553942306386672, -2.369170564169594],
            [5.55741833224921, -2.368745296229107],
            [5.666415291385835, -2.3593576277717463],
            [5.667956584753821, -2.35118097289574],
            [5.666820841020962, -2.3475620080305415],
            [5.668194238301899, -2.343396894038222],
            [5.668915884409067, -2.3337972730994943],
            [5.67242648775545, -2.333419820602703],
            [5.784706609464943, -2.3293278377985525],
            [5.841165599547811, -2.327076060274957],
            [5.858517997942544, -2.3261016632439917],
            [5.931432445679763, -2.323397069749315],
            [5.933357761517661, -2.394297928732295],
            [5.934367522872053, -2.4162613392170993],
            [5.936420901689627, -2.4169151577625394],
            [5.936298163916595, -2.424664570745814],
            [5.9346676673399905, -2.4247466493314613],
            [5.936140824232487, -2.4710347157031887],
            [5.936885613308251, -2.503465104851065],
            [5.932638272686567, -2.5035564002838235],
            [5.929821658076275, -2.506479332143588],
            [5.923311996061706, -2.5093539912581684],
            [5.911448988584535, -2.512391368670317],
            [5.906277984575955, -2.5157629663948295],
            [5.905856070812588, -2.5217573705694507],
            [5.913328200879217, -2.524276210609533],
            [5.918828848485727, -2.531480684595994],
            [5.91736588721073, -2.541333394277256],
            [5.911732641439472, -2.5617173142305347],
            [5.902592406707884, -2.5811751385576533],
            [5.89529288584238, -2.5935325407276673],
            [5.885870373290407, -2.606328132895101],
            [5.875778265216123, -2.617855773964109],
            [5.862284405763285, -2.622756239834557],
            [5.853900831342416, -2.6505854537729405],
            [5.8040985319283, -2.6597163077329364],
            [5.800883204356412, -2.656287293133125],
            [5.797897550773273, -2.6494292865413183],
            [5.7982162430507325, -2.645656633831445],
            [5.794111671813551, -2.643488159573074],
            [5.792914750610652, -2.636722000441974],
            [5.788053670039115, -2.6343342824818055],
            [5.781671944661023, -2.6328942840016327],
            [5.778966337796532, -2.6271761132693667],
            [5.775042029141618, -2.6265857952171254],
            [5.768277809063081, -2.6220597280422373],
            [5.770334144971252, -2.6167309986583303],
            [5.764329944486964, -2.6159707621763517],
            [5.756590359888527, -2.6026726705602967],
            [5.7533299242691625, -2.6060402682797936],
            [5.748372049151672, -2.5995759597182304],
            [5.748138434950407, -2.5972576223841557],
            [5.680871760638272, -2.6007607705272773],
            [5.682363741117668, -2.60478364879005],
            [5.6805011723581975, -2.6108341497662315],
            [5.682329033650793, -2.614324656385358],
            [5.680200113694643, -2.616499690507519],
            [5.674082317733607, -2.6170225851879487],
            [5.669732088070972, -2.6251062022307616],
            [5.667537997792466, -2.6220396508270816],
            [5.669549873590467, -2.618418868043593],
            [5.668734175761242, -2.6150337575126255],
            [5.662804592168516, -2.62176166006856],
            [5.656931225139552, -2.616275091040801],
            [5.651391899099341, -2.6210887893422283],
            [5.6450140493697685, -2.6208206483606524],
            [5.637262214849302, -2.6160788613517534],
            [5.6338958052429104, -2.617740374316895],
            [5.6279056598896275, -2.6144958706501944],
            [5.624829540107804, -2.621285751730607],
            [5.619756164855899, -2.627107195696018],
            [5.61451493611371, -2.6230581704839344],
            [5.611903103658883, -2.628782244552246],
            [5.604827562723891, -2.6252031392017625],
            [5.59851233597758, -2.6310350916659497],
            [5.588859235354044, -2.6350661404439393],
            [5.584013758272152, -2.6358921586730304],
            [5.576835539454035, -2.635457858449318],
            [5.570087269901276, -2.6321072883380827],
            [5.565377198028584, -2.633390876210166],
            [5.563041359309064, -2.638431624550478],
            [5.565146588973066, -2.6430052432510998],
            [5.565381833535154, -2.6480091695596224],
            [5.563507525157462, -2.6506312650067443],
            [5.559925058943644, -2.6360110763410134],
            [5.5547005099553965, -2.6295704538148175],
            [5.551520691405194, -2.627236672032033],
            [5.5426083035690255, -2.623223999439436],
            [5.533583233679671, -2.616903974640801],
            [5.516618874645466, -2.608796303489419],
            [5.501526847568865, -2.6006217660114594],
            [5.497713044889378, -2.597529549806322],
            [5.494865193944066, -2.5931204024447694],
            [5.4921103690063875, -2.5800355151414047],
            [5.492449175231355, -2.5716689053229933],
            [5.485402678854276, -2.5644962023750155],
            [5.483556340515383, -2.5603852277651202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.4136974076156, "lat": 36.05917721154662 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47045"],
        "coty_name": ["Dyer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dyer County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01639741"
      },
      "bbox": [
        5.483556340515383, -2.6597163077329364, 5.936885613308251,
        -2.323397069749315
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.079812283066126, -1.928311863815187],
            [10.086468037432285, -1.934988701047212],
            [10.09705595373118, -1.9433973572948782],
            [10.11027558115573, -1.9420824753409782],
            [10.112059022545747, -1.9500992373739843],
            [10.115307380518523, -1.945995119251154],
            [10.111974353671782, -1.9418988060267828],
            [10.195206514281333, -1.9339612797895738],
            [10.248401117150612, -1.9287990402447073],
            [10.250763415811164, -1.9346540371670078],
            [10.257825549064536, -1.9404950693574827],
            [10.257316013427067, -1.950224993417847],
            [10.261284207726124, -1.9553046253236135],
            [10.269003180097675, -1.9625406195571014],
            [10.27401835575479, -1.962471706380068],
            [10.274223186296311, -1.9659738915407077],
            [10.27690319113071, -1.969785978528417],
            [10.279737576996002, -1.967151985170005],
            [10.284600741507758, -1.9685639826246306],
            [10.285585265341439, -1.9781902590998897],
            [10.291400022722103, -1.976889172595795],
            [10.292606724807653, -1.9863999807178034],
            [10.297446275597068, -1.9863129238357706],
            [10.302319788154444, -1.9894244740253566],
            [10.310726040486424, -2.000389113985509],
            [10.311119479625726, -2.0060862796810035],
            [10.305181496040241, -2.005607179754809],
            [10.290366065737304, -1.9945050449467514],
            [10.28394244498524, -1.9937204134240623],
            [10.27716847616597, -1.9965939121653014],
            [10.275831236716717, -1.999582298082581],
            [10.276563209549956, -2.0040289441066803],
            [10.280503954521956, -2.0090767014595796],
            [10.286287252285483, -2.0188505758473854],
            [10.292651723694638, -2.024898780414692],
            [10.294226616756456, -2.028214312199647],
            [10.292481574474996, -2.0312366170124205],
            [10.300317415612795, -2.0310069812347535],
            [10.300799606435927, -2.0339245592230197],
            [10.311762512255719, -2.0339578566431666],
            [10.312223539153404, -2.038133395541983],
            [10.309199710789379, -2.0392660245726715],
            [10.311980526180719, -2.048799844446984],
            [10.311870203171017, -2.057867129511932],
            [10.317250317548904, -2.0686313689792835],
            [10.319309915226922, -2.0781235230533297],
            [10.323730772119532, -2.0863260655491445],
            [10.32714248941447, -2.0946081627720092],
            [10.335855353777495, -2.095385253775051],
            [10.336543585652358, -2.0986082702290108],
            [10.329647183860024, -2.099997720044856],
            [10.335530013117507, -2.1134190165829705],
            [10.330072615007527, -2.119718251816193],
            [10.325877543706206, -2.1270759179565846],
            [10.319595106104803, -2.1348709513076476],
            [10.31369369278699, -2.1379300322199626],
            [10.312805238603667, -2.1423020899351832],
            [10.317076171961922, -2.1485276830693287],
            [10.313254044740871, -2.150181722690797],
            [10.308260123939428, -2.1446755211277972],
            [10.305380949716108, -2.150071201644858],
            [10.302077899855494, -2.1515503356814816],
            [10.297932823941329, -2.1567796481024337],
            [10.288271393577238, -2.1650874382065246],
            [10.280159971135756, -2.1738811144853836],
            [10.275951293414293, -2.177077004412344],
            [10.273667272441868, -2.17328292727253],
            [10.26458888174076, -2.1772149137955408],
            [10.26071600341152, -2.181295828392614],
            [10.253743840885816, -2.185142817576802],
            [10.25356069060615, -2.188827307622838],
            [10.249055911277328, -2.192436967382454],
            [10.24708016916677, -2.1965808150364663],
            [10.24647215154953, -2.201589118752359],
            [10.243117544318604, -2.2060898564991485],
            [10.23542548229159, -2.212663231823237],
            [10.22258469595938, -2.2232017514876565],
            [10.222710108775079, -2.2265450424706628],
            [10.214169390530937, -2.2359651072961904],
            [10.210485858402297, -2.2411385206931835],
            [10.201286077914379, -2.257926024395597],
            [10.1942192821677, -2.2647244549644565],
            [10.166298280708627, -2.2649260165601297],
            [10.159832958530426, -2.261767323004756],
            [10.153996799380074, -2.262561619015288],
            [10.150424125656045, -2.264755761596398],
            [10.15001380951545, -2.2569274439170632],
            [10.125952187797985, -2.2450260900987797],
            [10.122622688218364, -2.247016185851306],
            [10.119439145938994, -2.2449821756485293],
            [10.115379784761329, -2.2390390378869376],
            [10.107088566752445, -2.243135480575647],
            [10.104071736118659, -2.243280534056395],
            [10.101870346822173, -2.2499212051974475],
            [10.09910053186276, -2.2505774411640957],
            [10.094201193131678, -2.25485374508028],
            [10.088583575407666, -2.2501098010009652],
            [10.086816184032712, -2.24541734594833],
            [10.082972088728686, -2.2417041980287595],
            [10.07845402643331, -2.240370729126564],
            [10.076887649609448, -2.236929328365562],
            [10.072442324214387, -2.2375217722883263],
            [10.070353970860197, -2.2426160883175417],
            [10.066316087085212, -2.2465353086824256],
            [10.059403454599627, -2.2470451879152824],
            [10.054697261106835, -2.2456731841552764],
            [10.050235153294471, -2.248467038956306],
            [10.05208892444794, -2.2525890480881885],
            [10.059487412136795, -2.25360305547938],
            [10.066233745224709, -2.257747455272316],
            [10.069781321128168, -2.2645544721851394],
            [10.071036977780452, -2.272168260875274],
            [10.069602813277067, -2.2775299228482444],
            [10.064527969035208, -2.2829308695827395],
            [10.061293561766867, -2.2834959717693253],
            [10.057296774465998, -2.281655992173438],
            [10.054321229367698, -2.274967322012786],
            [10.051052995993539, -2.271952372622738],
            [10.044269734026594, -2.270929747299561],
            [10.03637559676766, -2.2744591042907025],
            [10.035390275764138, -2.2813649687482527],
            [10.03798573233343, -2.287443522206674],
            [10.03848529880225, -2.291853548748245],
            [10.035371307393834, -2.298733269206206],
            [10.032770545024936, -2.2993380052058683],
            [10.024568652482758, -2.2959698638764103],
            [10.021968396347843, -2.2903195220903783],
            [10.021204216609444, -2.2837617312859915],
            [10.013310604945783, -2.277923574996239],
            [10.005494446152252, -2.280477163480105],
            [9.994888223157025, -2.2870994857306113],
            [9.992365205139343, -2.289533649603341],
            [9.98505881833375, -2.3001613265810823],
            [9.979355852065941, -2.3017878577858926],
            [9.977254166071635, -2.297525100340235],
            [9.979806151073166, -2.29232157711128],
            [9.979034446212973, -2.288733364650442],
            [9.974623725780818, -2.2868111807680043],
            [9.972683923506308, -2.283755653206722],
            [9.969156590360864, -2.2829724076799565],
            [9.960308630388823, -2.285806011418539],
            [9.959715797791581, -2.290584567566183],
            [9.967971713795972, -2.2960866277227616],
            [9.971339872139307, -2.300091186841189],
            [9.97115776737408, -2.30301850064616],
            [9.96666775091272, -2.3114593084282364],
            [9.966649154383948, -2.3165692428613327],
            [9.972178744945653, -2.3285922609710763],
            [9.971454320481124, -2.3346990724185464],
            [9.969419504453912, -2.338151068295922],
            [9.961947914138856, -2.342285882672277],
            [9.955969884980723, -2.3416216058564108],
            [9.953179215586081, -2.3352080691638233],
            [9.94945940074481, -2.332365651159917],
            [9.94994679269565, -2.330624949519608],
            [9.915930203969706, -2.2996200565076768],
            [9.913145147513168, -2.297366815607768],
            [9.880907040426045, -2.267995379618574],
            [9.86249762546339, -2.250919875649051],
            [9.860595305860071, -2.250113240806972],
            [9.85590579136158, -2.24498081584572],
            [9.85241738157134, -2.23768829180254],
            [9.854892343363058, -2.233607423007248],
            [9.864601553783517, -2.230168458319091],
            [9.866207751609888, -2.225591268794551],
            [9.862276973820741, -2.217977892758957],
            [9.856023098718513, -2.2157965710629135],
            [9.848085277752721, -2.211266702709101],
            [9.848467064657195, -2.2055956854089884],
            [9.853722116748967, -2.2035123339261786],
            [9.862449774860792, -2.206190582324959],
            [9.868520502368023, -2.212544403169323],
            [9.873868502939338, -2.215701100463774],
            [9.878220078211298, -2.2126237035935845],
            [9.874363104298443, -2.2036367313190253],
            [9.875060573682589, -2.200024633830653],
            [9.872940303658641, -2.196667209616789],
            [9.86787623514346, -2.194769970763321],
            [9.868794290545244, -2.1901040787326416],
            [9.871340757219786, -2.1890559598141994],
            [9.877847899693949, -2.1914310489082296],
            [9.882633304786287, -2.1951967047759844],
            [9.887968936405677, -2.197107995831316],
            [9.89350068965531, -2.19428296104204],
            [9.892400587489533, -2.188061977704095],
            [9.886772408946943, -2.1821283241661624],
            [9.889235693343688, -2.1758538267596745],
            [9.888998121398826, -2.16897239472761],
            [9.890562038478643, -2.166273360854107],
            [9.901931754719518, -2.1634089512506454],
            [9.90475755530402, -2.1565344278163368],
            [9.902813921762132, -2.14997938659824],
            [9.904901242488778, -2.1444489869854406],
            [9.911367798954446, -2.146228482516877],
            [9.929887617782079, -2.1469943552645003],
            [9.932793464277422, -2.145244314545018],
            [9.939277894876312, -2.148592756938464],
            [9.943234324542951, -2.145254150048576],
            [9.948033310916967, -2.144600863597644],
            [9.948400935249843, -2.1410418815351315],
            [9.95412932633626, -2.13960788602529],
            [9.954935440579979, -2.1369696213580673],
            [9.9618171597088, -2.131763414715979],
            [9.966182988898954, -2.132662597699109],
            [9.973590602499605, -2.1231776191626897],
            [9.97509781243865, -2.119166933167256],
            [9.981066885008607, -2.115355170448088],
            [9.987487169119484, -2.1125249615308404],
            [9.993393560645757, -2.1048894660068216],
            [9.997553376993757, -2.1014942172282978],
            [9.998519219509287, -2.09679872014387],
            [10.00300322505655, -2.093999591311229],
            [10.006084031027099, -2.0902600007784673],
            [9.982605192979717, -2.068870125516299],
            [9.973811849374039, -2.0611783374788746],
            [9.97703992191758, -2.052573915697311],
            [9.980485546461113, -2.053669045174834],
            [9.984972418704443, -2.047547792485243],
            [9.989148727280625, -2.044655604570174],
            [9.994884702162068, -2.033343432918835],
            [10.003106551075797, -2.0248795323705995],
            [10.007440109739072, -2.0214272996713993],
            [10.01065788741031, -2.0139115891499024],
            [10.013762725991882, -2.0126395308323928],
            [10.018866159569969, -2.007134862883778],
            [10.019958985363287, -1.999492784014901],
            [10.024599563214869, -1.9937969474387431],
            [10.027733732219325, -1.9937050190527155],
            [10.027902715074262, -1.9867703627236666],
            [10.032478773140074, -1.9872123665746615],
            [10.040271131156079, -1.9797317696294858],
            [10.03913114326838, -1.9761537443629429],
            [10.043884522533803, -1.9689318725038707],
            [10.047324788795805, -1.965697698230172],
            [10.053007493796562, -1.9577559749965145],
            [10.055955142283564, -1.954940789942303],
            [10.054721823659216, -1.9503181400142167],
            [10.059850619145442, -1.9500727919531138],
            [10.060397811422307, -1.9461389267870342],
            [10.064425619519898, -1.9410503315234104],
            [10.06863858046567, -1.9386835920993009],
            [10.072240491126662, -1.9340554291089347],
            [10.075706011775909, -1.9334105409694569],
            [10.077668972695973, -1.928584053810284],
            [10.079812283066126, -1.928311863815187]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.93699214658646, "lat": 35.99325526492511 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47093"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01639761"
      },
      "bbox": [
        9.848085277752721, -2.342285882672277, 10.336543585652358,
        -1.928311863815187
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.427811837143219, -2.753048219992948],
            [7.431243429875705, -2.7543826226702617],
            [7.435958506755445, -2.7524337690314526],
            [7.439119628484896, -2.753373535699831],
            [7.4417622507267795, -2.7499791834453617],
            [7.443864329794896, -2.7390007091263806],
            [7.442354117436077, -2.7364081473253186],
            [7.449462087456, -2.7295156325773897],
            [7.450472187173756, -2.7236305284420728],
            [7.453171336101041, -2.7231666170386086],
            [7.458042204161635, -2.719543872167197],
            [7.459986969068585, -2.7135231518973972],
            [7.464272026226331, -2.711457750757879],
            [7.483142745197106, -2.710875928522975],
            [7.487334218647525, -2.70970246885404],
            [7.49091274891161, -2.7055252638362974],
            [7.494256304269303, -2.6991071151824553],
            [7.4944456432668485, -2.696302914905033],
            [7.49154203503856, -2.690808846367915],
            [7.483705694025797, -2.6888817774584512],
            [7.483991798450882, -2.6862387382837447],
            [7.492496607621963, -2.6856878404175735],
            [7.497895919342039, -2.68418865144086],
            [7.500775515710936, -2.6809831871542875],
            [7.505980196259579, -2.679489197013036],
            [7.507458547307712, -2.653620420882408],
            [7.508116772190081, -2.6264920252228277],
            [7.509503860138069, -2.5516413666694646],
            [7.534106224770447, -2.5587786354967927],
            [7.557420666629784, -2.565920066572055],
            [7.655091087347891, -2.5947527285950827],
            [7.658153855917917, -2.5928563460663328],
            [7.6606274496567055, -2.596375289587451],
            [7.6751634314527175, -2.600607724568408],
            [7.679063943478588, -2.6053407888259557],
            [7.690713103150441, -2.6057124332035646],
            [7.713449937401761, -2.612458309691171],
            [7.71718348880615, -2.611922522991387],
            [7.718889840647042, -2.6072252827249733],
            [7.718010069828856, -2.6006751232764937],
            [7.72752254960775, -2.601024936798051],
            [7.727096026486893, -2.6093118450552257],
            [7.7335323127442575, -2.6095574049928967],
            [7.734933714930372, -2.6024350685108155],
            [7.745432502662349, -2.6029062233372198],
            [7.742677366575294, -2.615457616188505],
            [7.739379447630212, -2.619812309415819],
            [7.747282209904879, -2.6238934558788145],
            [7.758256503540828, -2.626532376459158],
            [7.788553700353438, -2.636552943200036],
            [7.809417696072324, -2.6410708639700675],
            [7.813426908221612, -2.6435197951837424],
            [7.81722049293619, -2.6496108217775185],
            [7.821039971580025, -2.649147906076137],
            [7.83553258208272, -2.649818077160555],
            [7.8355260797562565, -2.6514016114968078],
            [7.844585013867333, -2.651735835688901],
            [7.8455100666280675, -2.656226851726693],
            [7.849299931972092, -2.6593495103916966],
            [7.8570419414845345, -2.659654020567966],
            [7.85700665403671, -2.663157488226176],
            [7.869862884179605, -2.663319871190612],
            [7.861153764214658, -2.667924067535373],
            [7.861897058974885, -2.6692231630950713],
            [7.8593885056579875, -2.6796455478881707],
            [7.854641594783469, -2.679535822792822],
            [7.853569518817001, -2.672173008207158],
            [7.846948414566024, -2.6758558806085415],
            [7.845876024524884, -2.772643550631225],
            [7.843416237179024, -2.7776282314056604],
            [7.834717311140728, -2.783246885384152],
            [7.834792000514079, -2.7916232709563484],
            [7.845621651411098, -2.7917280868329137],
            [7.844384741477488, -2.799947754307738],
            [7.839057019583885, -2.7990906543954805],
            [7.8415216222270985, -2.8075883295038317],
            [7.836555034673271, -2.8076134356568643],
            [7.836320651271548, -2.8153602258111654],
            [7.83914597142867, -2.8153597666664822],
            [7.840075396035883, -2.82398934051353],
            [7.833317011475278, -2.85021665094329],
            [7.818116733272088, -2.874994993429577],
            [7.816821057709338, -2.874142745223532],
            [7.816916784918236, -2.856574172158403],
            [7.812841119134265, -2.856505644223167],
            [7.812713269398127, -2.8682430807202883],
            [7.811251450780408, -2.874731017586296],
            [7.811447222132008, -2.8840468756457915],
            [7.800728939937206, -2.8983425106773852],
            [7.779102936246081, -2.9180266725680344],
            [7.783679177251663, -2.92345969362872],
            [7.781887928250266, -2.926768970669936],
            [7.77335991395506, -2.9269163951878907],
            [7.76998188751596, -2.923554745538522],
            [7.755761419845966, -2.9326044073184985],
            [7.755895559780418, -2.9450411761666024],
            [7.754400462546385, -2.967605304702903],
            [7.754971764057728, -2.971555772500739],
            [7.748923367895649, -2.973132707377853],
            [7.745419561897144, -2.9704298769326747],
            [7.733240107677318, -2.968652683081489],
            [7.734302927758698, -2.9772555540078978],
            [7.724552806611696, -2.9779807067175152],
            [7.722177903374331, -2.9752618963125164],
            [7.715844499288234, -2.9753643295273418],
            [7.7088592064266255, -2.9730433909249556],
            [7.706543271042561, -2.965081197366823],
            [7.702582303567686, -2.96446416510473],
            [7.7011057316229525, -2.960083994126414],
            [7.697221226467658, -2.9576681385358117],
            [7.690637968293173, -2.9622320927425094],
            [7.685353894739208, -2.9626226467740313],
            [7.680794276454629, -2.960731203802765],
            [7.673931431812481, -2.960723369040526],
            [7.667394535353076, -2.9571806284889925],
            [7.662953053802592, -2.9526194863494117],
            [7.6577379274574175, -2.9528630681782095],
            [7.654977195908811, -2.950903233486341],
            [7.650149673708326, -2.950644353932058],
            [7.6449776276511745, -2.952920203788763],
            [7.638337884837719, -2.949560872249728],
            [7.63662994495491, -2.9449028596400413],
            [7.632045815178783, -2.9468049748304717],
            [7.6281623762039725, -2.943768419412198],
            [7.625318370184658, -2.9446752933908846],
            [7.622029720138589, -2.9409988463752663],
            [7.616630931544322, -2.9421251856006205],
            [7.611820927145384, -2.944482348595849],
            [7.608682077929177, -2.9496289721937115],
            [7.599521028564773, -2.951948221973087],
            [7.5958966144604965, -2.9569704456513173],
            [7.592274693594876, -2.9643084776966986],
            [7.587722117560736, -2.963161923218258],
            [7.566185339674532, -2.9712563641394514],
            [7.555234001771643, -2.969939518364773],
            [7.54610559239149, -2.96552716931743],
            [7.53872717153003, -2.9641808797469165],
            [7.539792514624722, -2.9708699149641666],
            [7.538422274157334, -2.975416331143371],
            [7.520259997044284, -2.972673321743884],
            [7.4831084224141335, -2.967562266810699],
            [7.483442612183553, -2.9649535614126186],
            [7.4834899786851805, -2.957957658040741],
            [7.486634091767032, -2.958008115092206],
            [7.486564660169949, -2.9497651217499863],
            [7.4926446392357695, -2.9499616319385122],
            [7.493353616487962, -2.9384383712460744],
            [7.495358313597135, -2.9381306822502182],
            [7.495757410437386, -2.924635123916195],
            [7.491709961639347, -2.9245042413581674],
            [7.491585507501924, -2.919643472545298],
            [7.493368167366802, -2.9159734382346114],
            [7.487593235254998, -2.9117744852058314],
            [7.490689831588409, -2.9067644148570624],
            [7.497580769481207, -2.9069332854760868],
            [7.497965222131917, -2.9017189213937877],
            [7.491185346174853, -2.9013699146733716],
            [7.487643439396519, -2.903670620830298],
            [7.486214556772818, -2.887619249515531],
            [7.483357135181599, -2.877700578582222],
            [7.482013841121388, -2.8775294580279134],
            [7.481337847971484, -2.8665086030936195],
            [7.477589552925554, -2.866549119166611],
            [7.47764871524312, -2.860908061127554],
            [7.455186259543306, -2.8618745942604273],
            [7.455761693546774, -2.843107804333791],
            [7.449963271398195, -2.842114246889287],
            [7.44549773877634, -2.843031497107327],
            [7.44526580864921, -2.839130315468618],
            [7.4364438049644885, -2.839658772348518],
            [7.435240350307684, -2.827983253486446],
            [7.424158239651, -2.828766253726748],
            [7.421370672616295, -2.816357462406062],
            [7.4203259518565865, -2.803119683112228],
            [7.420634827775449, -2.7954114227103997],
            [7.426323555053739, -2.7908437243298843],
            [7.42861775951241, -2.7831221050599515],
            [7.43219513712664, -2.78216408874918],
            [7.431763379813664, -2.778241325565365],
            [7.435240693130435, -2.7771030169455506],
            [7.434085960885801, -2.7697728436407374],
            [7.434185008472578, -2.7553092391669183],
            [7.4276862824834895, -2.7554057001260928],
            [7.427811837143219, -2.753048219992948]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.07698362689491, "lat": 35.61692098945989 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47119"],
        "coty_name": ["Maury"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Maury County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01639772"
      },
      "bbox": [
        7.4203259518565865, -2.9779807067175152, 7.869862884179605,
        -2.5516413666694646
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.7913243241615708, -11.386773375715864],
            [-1.6614287370275422, -11.391282611343547],
            [-1.5315309754743223, -11.395743380885484],
            [-1.4536312551747501, -11.398210300070359],
            [-1.3757308155054508, -11.400659790372648],
            [-1.332733360903088, -11.402032922031923],
            [-1.3113964576053168, -11.40247658056186],
            [-1.3122910198757014, -11.45236069029734],
            [-1.3130911167396881, -11.49021833780228],
            [-1.316493298183342, -11.655850045443767],
            [-1.3166323194498442, -11.657322050794587],
            [-1.3208324222533911, -11.86921084431668],
            [-1.4037232547860754, -11.866620124101178],
            [-1.5128534289964912, -11.863542733016176],
            [-1.6219823609011224, -11.860429457942871],
            [-1.7135762997357518, -11.857750795297198],
            [-1.7101957798365404, -11.769344421383721],
            [-1.709912328064233, -11.766908605450636],
            [-1.7024554692598106, -11.593577147788851],
            [-1.7460544658428274, -11.59303851781684],
            [-1.7444666758476408, -11.508031788788449],
            [-1.7673951237751884, -11.507390807605345],
            [-1.765000801348534, -11.416844405059202],
            [-1.7681045301672533, -11.414910887291988],
            [-1.776512694302881, -11.413041143042996],
            [-1.7798365850301665, -11.407941058317636],
            [-1.7806546809077854, -11.40182804764161],
            [-1.7836033911253937, -11.400281038537555],
            [-1.7881999051067539, -11.401405057076147],
            [-1.7907155703462647, -11.397576356963867],
            [-1.7952132954041022, -11.39852120464206],
            [-1.7990064962311685, -11.396670747364759],
            [-1.8010838204258601, -11.389703013927408],
            [-1.8032619236554703, -11.386416926887607],
            [-1.7913243241615708, -11.386773375715864]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.21874540072398,
          "lat": 27.031578870285415
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48047"],
        "coty_name": ["Brooks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brooks County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01383809"
      },
      "bbox": [
        -1.8032619236554703, -11.86921084431668, -1.3113964576053168,
        -11.386416926887607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.849384536493172, -3.8064915606547163],
            [-4.724009068441713, -3.8159062798146532],
            [-4.5596703777270235, -3.8261461836108195],
            [-4.559618543789991, -3.825337938885201],
            [-4.42914203898749, -3.8330480553320534],
            [-4.4210414686012935, -3.833421158924118],
            [-4.427395187253563, -3.934993380351779],
            [-4.434808989905094, -4.052514100846948],
            [-4.4411770983013295, -4.155573305205719],
            [-4.448323054707809, -4.270162520649849],
            [-4.523880890359155, -4.26527067083033],
            [-4.583754007078543, -4.261662031465071],
            [-4.591850755986268, -4.261301429102595],
            [-4.642112054334348, -4.257538371896967],
            [-4.684764601759514, -4.254816901654391],
            [-4.806433820728479, -4.246617979543653],
            [-4.879757410026338, -4.241780346235965],
            [-4.874389317884475, -4.162607711237253],
            [-4.867554884771336, -4.062874433369434],
            [-4.866555515560126, -4.054178967010931],
            [-4.857856821392557, -3.9287922102796036],
            [-4.849384536493172, -3.8064915606547163]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.26167597241125,
          "lat": 34.52987731394532
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48069"],
        "coty_name": ["Castro"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Castro County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01383820"
      },
      "bbox": [
        -4.879757410026338, -4.270162520649849, -4.4210414686012935,
        -3.8064915606547163
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.02945549364354311, -8.765877817442803],
            [-0.00021450019478662868, -8.819650302973038],
            [0.027356570732525384, -8.844467014897733],
            [0.043415758724912205, -8.859431621292819],
            [0.04904117487310619, -8.857712459458483],
            [0.05381641913376183, -8.86027946189728],
            [0.057366494253260375, -8.865313300973675],
            [0.06073592175280944, -8.865965483574582],
            [0.06464200735581109, -8.87205565243351],
            [0.07379909490768768, -8.870375488889385],
            [0.07903334973551887, -8.87314474385562],
            [0.08694728588646448, -8.878813029099387],
            [0.0879485420241804, -8.885524298972108],
            [0.09262622201725247, -8.885779581668983],
            [0.0981963353099184, -8.89268076370434],
            [0.09774993000966088, -8.895760583814866],
            [0.10325717068898585, -8.898514332922279],
            [0.10596341715665644, -8.901924047880929],
            [0.11050217324740388, -8.902656219119988],
            [0.11252120462469262, -8.90107299954532],
            [0.11993487047882519, -8.904036252760015],
            [0.12253254562780776, -8.902531312117247],
            [0.12665264390058673, -8.905169971900706],
            [0.134890294339952, -8.901402470067817],
            [0.14602283702468302, -8.905130337319934],
            [0.1484069774199783, -8.907828482340143],
            [0.15343627417545708, -8.907654561183879],
            [0.15841580728949964, -8.899476021290514],
            [0.16512108454456859, -8.896727056835331],
            [0.16700920897485735, -8.902184345063864],
            [0.17122765882190874, -8.905590317794687],
            [0.1768619704859238, -8.912288054044323],
            [0.17474336678295016, -8.927790446525826],
            [0.17875983254477698, -8.927927828855413],
            [0.1849858540959098, -8.934436502689136],
            [0.18788494595810634, -8.93527746548155],
            [0.1908225476479765, -8.940949159455522],
            [0.19046446147026339, -8.946854997710176],
            [0.1866918363260071, -8.952019948856261],
            [0.19124010511740958, -8.955099976991605],
            [0.19134346108055153, -8.96336416659105],
            [0.19332753171936698, -8.969933225470365],
            [0.1965964552055198, -8.972182301146944],
            [0.20343351198019435, -8.974455272177478],
            [0.20585705466948248, -8.976366261640413],
            [0.20665693940636928, -8.982192677538455],
            [0.20484765105348404, -8.988727342259711],
            [0.2109348118031303, -8.9909754400883],
            [0.21197051213921822, -8.998458307377453],
            [0.21732851879608356, -8.99815510166224],
            [0.22025343314333456, -8.999647935478142],
            [0.22463017554214637, -9.006908767718294],
            [0.22925818214955343, -9.009182754139752],
            [0.22770331440384478, -9.014924302556489],
            [0.2289281005482653, -9.01980104136973],
            [0.225984916391286, -9.02188744440914],
            [0.2230936620919765, -9.026624828519898],
            [0.22660724152934167, -9.028814500669169],
            [0.228378518479152, -9.035441239551858],
            [0.23248510099204642, -9.038463138284106],
            [0.23631316825014934, -9.046485108774453],
            [0.2356430918244723, -9.050691915880916],
            [0.2381196229190663, -9.05589113848749],
            [0.2407747926704943, -9.058139808634824],
            [0.2454782512926689, -9.0591183798292],
            [0.25086559399054803, -9.062028743543712],
            [0.25604493999976874, -9.06728633244075],
            [0.259826586539682, -9.064424930484869],
            [0.2685794600510515, -9.060354049897557],
            [0.2738599215283462, -9.063293286465044],
            [0.2784376718643725, -9.06446430029842],
            [0.28226239410899195, -9.068763919525319],
            [0.29047525595810786, -9.06873491379494],
            [0.2986867639044743, -9.077524353290544],
            [0.3005491243437239, -9.08247780273426],
            [0.30663663083668946, -9.084129157348018],
            [0.3113076138295826, -9.091147847677949],
            [0.28563465431166024, -9.116944371153895],
            [0.285151386894121, -9.117728484151824],
            [0.259152543298566, -9.144442972483802],
            [0.19600346597968485, -9.208643325318446],
            [0.1910475993897904, -9.222724317146053],
            [0.16109256265723065, -9.310129350160949],
            [0.1599746172595721, -9.314838431626475],
            [0.13622709023669793, -9.32808870799267],
            [0.027399868652131724, -9.396185604011192],
            [-0.06366508691857437, -9.452765679036137],
            [-0.08205182726900227, -9.462381167006598],
            [-0.09525610015669472, -9.470326216067331],
            [-0.11099042051810952, -9.454375156045487],
            [-0.025109723399635367, -9.384350576952341],
            [-0.0800320268204128, -9.319358188740411],
            [-0.13493799801168269, -9.254337537858344],
            [-0.15158116396013263, -9.233421153232154],
            [-0.22591311831205657, -9.144173515200857],
            [-0.2604197757009006, -9.144390660457596],
            [-0.26552402512875944, -9.138240559282785],
            [-0.2628475199718185, -9.128657930751594],
            [-0.26069799785517356, -9.125585434350645],
            [-0.2643469553954029, -9.121221160418601],
            [-0.2646333477268952, -9.117759034205198],
            [-0.2701054569259979, -9.112528072662624],
            [-0.2688096436251955, -9.105585227881289],
            [-0.27270057319568924, -9.104585102778703],
            [-0.27582330825817836, -9.10015929895359],
            [-0.2828861960108176, -9.097268699991556],
            [-0.2828049966266842, -9.094949229041484],
            [-0.28841436005104043, -9.091512959837301],
            [-0.287895817134103, -9.088995852211742],
            [-0.29591249938804504, -9.0889234218461],
            [-0.21319622907643065, -8.994400660398384],
            [-0.19077395593393995, -8.968482521464413],
            [-0.18719757441102827, -8.965256787867958],
            [-0.15812750989871754, -8.931958059594395],
            [-0.15647072940029327, -8.929535622092537],
            [-0.1195099330339143, -8.882416942908748],
            [-0.10049407069699387, -8.857181371695988],
            [-0.09533798095169847, -8.85081098110838],
            [-0.02945549364354311, -8.765877817442803]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.52627875991833, "lat": 29.6207993612978 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48089"],
        "coty_name": ["Colorado"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colorado County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01383830"
      },
      "bbox": [
        -0.29591249938804504, -9.470326216067331, 0.3113076138295826,
        -8.765877817442803
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.147253733251473, -6.18485410784624],
            [-2.1319658092123728, -6.18539386229014],
            [-2.05253225236558, -6.188005860101191],
            [-2.0517477007017892, -6.1877114120174666],
            [-1.995418318756966, -6.18944902693765],
            [-1.8800377112852027, -6.192713959082205],
            [-1.8421846385876244, -6.193407123506913],
            [-1.8207579616603284, -6.194392906668596],
            [-1.6962810311041778, -6.197927860068083],
            [-1.6931282983772475, -6.197914766847044],
            [-1.6327501617496378, -6.201390226054345],
            [-1.6116081125794812, -6.202289538073736],
            [-1.6129489372222907, -6.255125739069973],
            [-1.6144780546412911, -6.307034780337403],
            [-1.6153110320173873, -6.341830063264117],
            [-1.6167962584376727, -6.416046621031936],
            [-1.638680333163683, -6.427925784686804],
            [-1.682089761442723, -6.4519515705171715],
            [-1.7114795380798342, -6.469256703352813],
            [-1.7455280868428673, -6.488584672966176],
            [-1.7754187074026904, -6.506344655911185],
            [-1.8524809214078546, -6.5470647771326025],
            [-1.8576017541107113, -6.550186863700562],
            [-1.8843628780255919, -6.564664556423608],
            [-1.9162368937938812, -6.581622940705546],
            [-1.935351012798814, -6.59095250486547],
            [-2.0016105389584857, -6.626032150227195],
            [-2.0625291972098574, -6.622856277108056],
            [-2.0656310342575845, -6.6233882380246545],
            [-2.165271830282442, -6.619297140505751],
            [-2.163563264865998, -6.574250209523273],
            [-2.1637155811563074, -6.5735270013296505],
            [-2.1609568649733246, -6.514610936281483],
            [-2.158546439322057, -6.450009632732288],
            [-2.1586971533138963, -6.448812448048469],
            [-2.153447613862087, -6.324746271302066],
            [-2.1509427884309615, -6.27284039395354],
            [-2.1481957206063274, -6.2042866639650605],
            [-2.1475329967194683, -6.199534090521981],
            [-2.147253733251473, -6.18485410784624]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.83229297216843,
          "lat": 32.327078789341186
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48133"],
        "coty_name": ["Eastland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eastland County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01383852"
      },
      "bbox": [
        -2.165271830282442, -6.626032150227195, -1.6116081125794812,
        -6.18485410784624
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.1448320714169376, -5.342743581429484],
            [0.14563626652747658, -5.287790504141087],
            [0.1467104229142245, -5.2402003223977465],
            [0.14753339920153513, -5.141628162140821],
            [0.14809587793496892, -5.12130698423155],
            [0.1504607139623175, -5.013809002511217],
            [0.15852894766948517, -5.02287853693035],
            [0.16370141417960943, -5.038710325416689],
            [0.1645373800872063, -5.047976189678756],
            [0.16968438694473553, -5.052673969090586],
            [0.17599308449286816, -5.0534758097539845],
            [0.1845048461743432, -5.051149674129994],
            [0.18959290552819208, -5.0464309183895635],
            [0.19849595939563536, -5.044804907889479],
            [0.2019602323799909, -5.040906538190016],
            [0.20774774234550908, -5.029395114946854],
            [0.21019763434655023, -5.019872998192541],
            [0.2105822406398751, -5.013052149933422],
            [0.20995423360490648, -5.004803054268956],
            [0.21362139990665568, -4.988887045993526],
            [0.21901633085666763, -4.973940955542951],
            [0.22135656476914597, -4.970315470200731],
            [0.2258630180294741, -4.96851083273197],
            [0.23444901400876061, -4.969282928230566],
            [0.24620357538575574, -4.972336872871766],
            [0.25281426633381954, -4.977761751279646],
            [0.258858269739304, -4.980881518051691],
            [0.27468604321356116, -4.991924210446128],
            [0.28170279081353555, -4.992573924248177],
            [0.2987351511527699, -4.987868077882497],
            [0.30975984093052567, -4.983617606633261],
            [0.31677935774000837, -4.979473573686009],
            [0.3239003873525059, -4.96983984562632],
            [0.32945755735983995, -4.951145479057839],
            [0.330713600908998, -4.944176760441474],
            [0.33084213728551226, -4.934088783701758],
            [0.33244323455047997, -4.929658481687585],
            [0.3301743273449708, -4.9266578236946685],
            [0.3260038319960218, -4.928725139606931],
            [0.32371867052336356, -4.934944556000734],
            [0.3231931546541134, -4.940483516670217],
            [0.3192572063663051, -4.937898138599853],
            [0.3161273224270719, -4.929259226393378],
            [0.31867040511100775, -4.925175156196078],
            [0.3278160883647426, -4.922009941475843],
            [0.3345400809827736, -4.921593717157933],
            [0.33939662673610926, -4.9228420486735835],
            [0.3410273424143911, -4.920626549183979],
            [0.33870725959200254, -4.907827145245279],
            [0.3416519885441344, -4.901957162691584],
            [0.34921079755174544, -4.900603498696247],
            [0.36236615205904904, -4.899813572999392],
            [0.3663063353143792, -4.901906253221088],
            [0.37304128039380663, -4.9074225691187445],
            [0.381807080696022, -4.909365279387997],
            [0.3833860583936713, -4.907103604592258],
            [0.383234779320218, -4.901874213231249],
            [0.38008215166787085, -4.893064363363912],
            [0.3812195618129349, -4.891798865011003],
            [0.3939713594394464, -4.893131108906559],
            [0.41103534815713005, -4.898296466395984],
            [0.42347428805950116, -4.903377529873013],
            [0.43307633447835653, -4.898587178875743],
            [0.43787605679552855, -4.892562595873896],
            [0.439473342671653, -4.883430114919066],
            [0.4440329114042296, -4.882709694591822],
            [0.44763035283047303, -4.886293882877031],
            [0.4445783186081805, -4.897352245126762],
            [0.44758067789280936, -4.8992730130994975],
            [0.4593737848178667, -4.894317217324105],
            [0.465099479904036, -4.888752668935879],
            [0.4682529890119958, -4.878297518529301],
            [0.46263885401998395, -4.876258995859649],
            [0.4600806530093165, -4.869989340584123],
            [0.46093296063938044, -4.867377522934829],
            [0.46487988184938944, -4.867491996834785],
            [0.4726488764675483, -4.871145277417267],
            [0.4767186674391248, -4.875347514982552],
            [0.4767214510331826, -4.887130576077357],
            [0.48669278734486415, -4.883407423251437],
            [0.5027695785972285, -4.88140763860269],
            [0.5096665606184416, -4.879944452825655],
            [0.5121523370277506, -4.878128164574003],
            [0.5159676433263669, -4.869095773877653],
            [0.5194061678868138, -4.856437473518066],
            [0.5248937542208028, -4.854649604899328],
            [0.5413514790050923, -4.865623780726773],
            [0.5506486665491203, -4.872282205614914],
            [0.5571367109686701, -4.874880564030571],
            [0.5668646848250034, -4.88380085992979],
            [0.5734598753142809, -4.88824955076047],
            [0.5828497044343873, -4.890460161416179],
            [0.5904021236888151, -4.899700887359894],
            [0.5864142670067584, -4.903461797144681],
            [0.5832707537584089, -4.9118574386804745],
            [0.5837481097149856, -4.916080145270635],
            [0.5833378053188355, -4.973450720837707],
            [0.5829010708942043, -5.115383317797589],
            [0.5820594058569811, -5.115384584543653],
            [0.5823402199960634, -5.143027076487539],
            [0.5820631883123688, -5.24496720487683],
            [0.5816062163970891, -5.279238380551387],
            [0.5808682453999221, -5.331566227896967],
            [0.470412230828523, -5.349159926327015],
            [0.45372236503308677, -5.351679734276513],
            [0.33325479208862213, -5.370938583334253],
            [0.2742584157421103, -5.380207678587206],
            [0.25477602936087757, -5.383467466139323],
            [0.2186427846135704, -5.389007120227957],
            [0.18834211561240288, -5.393448146762463],
            [0.14468982669105743, -5.399585955920272],
            [0.1448320714169376, -5.342743581429484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.1068561131701, "lat": 33.593829678847364 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48147"],
        "coty_name": ["Fannin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fannin County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01383859"
      },
      "bbox": [
        0.14468982669105743, -5.399585955920272, 0.5904021236888151,
        -4.854649604899328
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.1403329594650709, -9.329660162960792],
            [-1.1015944607654085, -9.275226097195091],
            [-1.062865161106052, -9.220773402202923],
            [-1.0563184272090667, -9.209289273470032],
            [-1.0393897350684884, -9.185221347378844],
            [-0.9805873817317612, -9.100445948009078],
            [-0.9550585603129877, -9.063388345239957],
            [-0.9508378837805849, -9.070927902585527],
            [-0.9454598691180205, -9.070382477223305],
            [-0.9415025937395717, -9.068318062979587],
            [-0.9404975806168203, -9.072274889489474],
            [-0.9428460004912284, -9.07773816677575],
            [-0.9367843494352006, -9.076524007040137],
            [-0.9305001725658566, -9.077023200688311],
            [-0.9319311308312342, -9.073093076868561],
            [-0.9296174073815775, -9.071795974010133],
            [-0.9252966558753267, -9.078418779502044],
            [-0.9245593376331271, -9.082787643215427],
            [-0.8488596262384654, -9.036955400797897],
            [-0.7597468818835161, -8.983080194253844],
            [-0.6793106308338321, -8.934401917364374],
            [-0.6405648198469877, -8.968956236394531],
            [-0.6386338623853478, -8.970231091660786],
            [-0.5602713809004838, -9.039456279807043],
            [-0.5184839510110545, -9.076144467158054],
            [-0.5292015748158568, -9.09102789246443],
            [-0.5342537232767525, -9.094882331236347],
            [-0.583194551182252, -9.13727249849006],
            [-0.5831660988385106, -9.158303922114769],
            [-0.5825924446223372, -9.209444088965753],
            [-0.6071017193405175, -9.296270940791972],
            [-0.6170713140268885, -9.330434409692227],
            [-0.6603005949169748, -9.365162326669996],
            [-0.7396308340067149, -9.42889819219366],
            [-0.802824528289951, -9.479399392955328],
            [-0.8966108796290798, -9.555311498990047],
            [-0.9468112233298072, -9.596412068562122],
            [-0.9572506334150236, -9.584833685000238],
            [-1.0014283925903145, -9.534591267315434],
            [-1.0455956106075923, -9.484331297458574],
            [-1.0706153429230452, -9.455792782158253],
            [-1.096163951252944, -9.424597415009153],
            [-1.1568347103550094, -9.352924658711958],
            [-1.1403329594650709, -9.329660162960792]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.4925489508059, "lat": 29.456681369272918 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48177"],
        "coty_name": ["Gonzales"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gonzales County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "01383874"
      },
      "bbox": [
        -1.1568347103550094, -9.596412068562122, -0.5184839510110545,
        -8.934401917364374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5217910423167478, -10.017114579761966],
            [-2.4421227748093064, -10.018238432669788],
            [-2.362454587113246, -10.019346711590089],
            [-2.3155960471184702, -10.020777022959312],
            [-2.2211282680276634, -10.022865853813956],
            [-2.109929168293993, -10.025108222687726],
            [-1.998729745110726, -10.02732027076576],
            [-1.9987412202910864, -10.027497899227004],
            [-2.000089291027363, -10.049102894441983],
            [-2.0037560682125273, -10.198776286522733],
            [-2.004779999291779, -10.226809853616325],
            [-2.0107299111480232, -10.41709348253421],
            [-2.010468119649396, -10.428826212406019],
            [-2.0162083080300266, -10.561304970599117],
            [-2.0182660451205883, -10.605909682782798],
            [-2.1553605073259585, -10.607651271649166],
            [-2.1626776392006644, -10.607556410461656],
            [-2.249118584174164, -10.609521483277781],
            [-2.3355609847970427, -10.611466811540698],
            [-2.4220048510871925, -10.613392381574686],
            [-2.508450193057021, -10.615298179494472],
            [-2.5375233999189426, -10.61579797827843],
            [-2.5363105457642576, -10.468130357227633],
            [-2.535954419793076, -10.445030832295542],
            [-2.5311848740079532, -10.302700276230611],
            [-2.529602788696829, -10.227646778969383],
            [-2.5276314303852034, -10.155043599121145],
            [-2.5269828274899955, -10.155071336464257],
            [-2.5238151711743098, -10.064387285773197],
            [-2.5217910423167478, -10.017114579761966]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.0996358712431, "lat": 28.345172994352396 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48283"],
        "coty_name": ["La Salle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["La Salle County"],
        "coty_fp_code": "283",
        "coty_gnis_code": "01383924"
      },
      "bbox": [
        -2.5375233999189426, -10.61579797827843, -1.998729745110726,
        -10.017114579761966
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.0872871091083156, -8.474101481071848],
            [2.1699189019423692, -8.472016263533218],
            [2.1896210065885957, -8.471605286330966],
            [2.273664965594832, -8.469242438900414],
            [2.3188909580688777, -8.467672457436624],
            [2.404482571456532, -8.465131219893033],
            [2.433350309101688, -8.463969407932705],
            [2.442901009318642, -8.464194704810664],
            [2.4418053432298312, -8.468384846073032],
            [2.4432632038488715, -8.474556229142038],
            [2.439584841488368, -8.474171347330195],
            [2.4362781481351594, -8.482783721358064],
            [2.437450431406934, -8.488152059489618],
            [2.4313846822181695, -8.489557625957726],
            [2.4317706509146664, -8.499273374820437],
            [2.4373113539054687, -8.514355847766137],
            [2.4411665329006302, -8.510907374305006],
            [2.4438424445201856, -8.51464596973363],
            [2.4377824147711773, -8.517500087100958],
            [2.4404806776981616, -8.524279568275434],
            [2.445795264602302, -8.53340751137854],
            [2.4475765824869966, -8.542513325774806],
            [2.4430097150850703, -8.551146358464853],
            [2.4440470534934913, -8.55971157043302],
            [2.449402336281516, -8.554337714737189],
            [2.4527857327231595, -8.555365091073536],
            [2.45524408864758, -8.564308979319174],
            [2.4597406045779615, -8.566318626877427],
            [2.4561561938177583, -8.571516633737279],
            [2.4513895840646955, -8.568257379376746],
            [2.4492685439001964, -8.568778633506371],
            [2.448407622287906, -8.576211841887309],
            [2.449060040853489, -8.5844811432641],
            [2.4447286923339373, -8.585195706259617],
            [2.4474721096013643, -8.589580017594555],
            [2.4484230320629243, -8.593978305284477],
            [2.4458424934922087, -8.596448499987293],
            [2.4406725422448026, -8.597460111118371],
            [2.4381824602576034, -8.605013152248839],
            [2.430447920002731, -8.612816968193224],
            [2.4308263398394176, -8.623655123900464],
            [2.4273627447572754, -8.623632122395602],
            [2.4254896761217326, -8.618990632387307],
            [2.421723898260549, -8.620945099387633],
            [2.4241024694006397, -8.625047907483653],
            [2.4282708069643504, -8.627934880644393],
            [2.4374074259660152, -8.637415077696044],
            [2.446294519055207, -8.638996621335565],
            [2.451214157198916, -8.642488134034744],
            [2.452344343905857, -8.646833473766957],
            [2.4485372810900756, -8.651834416703855],
            [2.4425276756385754, -8.65189260753613],
            [2.4397653588163397, -8.640760176541432],
            [2.4349012551239997, -8.642736191329117],
            [2.4348871060710384, -8.65041780158249],
            [2.4334810271388347, -8.653996911914422],
            [2.4199843164351567, -8.669350152199726],
            [2.4186152416401403, -8.67399174830854],
            [2.4183229729302074, -8.682551844613018],
            [2.4136108847962414, -8.687670525803592],
            [2.4051263218424768, -8.691572308157532],
            [2.4009539279932874, -8.69597659593806],
            [2.39402431957064, -8.705186922237823],
            [2.3914519362700917, -8.710957790476675],
            [2.385151592541301, -8.71214683351909],
            [2.3782916445201434, -8.71655117883729],
            [2.3756587681373182, -8.720586601667508],
            [2.3730083209066457, -8.730369518688304],
            [2.3646903930682446, -8.744589462040903],
            [2.3610631328572325, -8.752604955492524],
            [2.356387486424364, -8.771931305311218],
            [2.3542820635685953, -8.786227392861726],
            [2.35229842515738, -8.79211390380546],
            [2.3429170049578185, -8.812571163270759],
            [2.3362510060856896, -8.824101840232975],
            [2.3228240941255023, -8.842073534154707],
            [2.325273648083556, -8.831905503139437],
            [2.3332120250096917, -8.794475911599411],
            [2.3348415898314556, -8.777959482660886],
            [2.3336282456411963, -8.763802323210687],
            [2.329834831348153, -8.753057780489115],
            [2.3236608470550135, -8.744202521748853],
            [2.319391065258127, -8.740402678492899],
            [2.3171929473929676, -8.733294493775416],
            [2.3152439281190524, -8.731026010254709],
            [2.3051551383582574, -8.727703896023453],
            [2.2943611148879133, -8.726692156648859],
            [2.2776035078306083, -8.72382294034434],
            [2.2739819407221673, -8.720536806485425],
            [2.27207738232654, -8.71661930999567],
            [2.268454842053224, -8.713654523166882],
            [2.2647878710211304, -8.713709272694425],
            [2.2536056025171076, -8.718800402349727],
            [2.2384010791227786, -8.712832478034832],
            [2.2332351890395636, -8.70933884204924],
            [2.2303239005343456, -8.698810959503167],
            [2.2275772764284048, -8.697269721965082],
            [2.221216003843176, -8.6977172095068],
            [2.2145424998612824, -8.70122236467697],
            [2.20937073989754, -8.702122938592042],
            [2.2081196559013647, -8.700268572896277],
            [2.210172435195698, -8.69112006239095],
            [2.2052962530691076, -8.689638589550656],
            [2.1963100562148057, -8.698238931957835],
            [2.192740647862428, -8.693166152768065],
            [2.194414432260301, -8.682398261281968],
            [2.188753472589044, -8.6805797040853],
            [2.1822308490059448, -8.68299154638305],
            [2.177189036204123, -8.681808774974316],
            [2.1740902403413065, -8.68256551006382],
            [2.1695847383096014, -8.686319624698578],
            [2.1655597396551913, -8.684125425047961],
            [2.1646593661302864, -8.678304514601935],
            [2.1619105564948398, -8.670936343233992],
            [2.1623733640495115, -8.668254045940376],
            [2.166612586012779, -8.664207463400661],
            [2.1679144753901425, -8.660517864998743],
            [2.1650941557614996, -8.65364565385172],
            [2.1689680500428676, -8.648715099291005],
            [2.167062240618943, -8.645572179344157],
            [2.1638912541807924, -8.645749996474823],
            [2.159298940272423, -8.649408003114802],
            [2.155312253074386, -8.648994247587787],
            [2.152322397331725, -8.646579962219995],
            [2.150764825201396, -8.642354359736375],
            [2.1518141734896625, -8.638768772080423],
            [2.1473127165131953, -8.634305692586834],
            [2.140644412275726, -8.637905904697872],
            [2.131305654042187, -8.635305802612612],
            [2.1237151367928826, -8.63658356665225],
            [2.112457221794196, -8.631427577585262],
            [2.110782212296512, -8.62755973797366],
            [2.1172933055583236, -8.624710462487862],
            [2.1131520543992486, -8.619125159335114],
            [2.1162376669161573, -8.61106705815463],
            [2.1235998414582693, -8.607652504710698],
            [2.127192477475259, -8.601640162085465],
            [2.127189589052798, -8.59728305941988],
            [2.1235330793788605, -8.591711611741957],
            [2.12239759170448, -8.586881786193928],
            [2.1157589789685787, -8.583349957889764],
            [2.110997454565499, -8.582850387718342],
            [2.1058060492588155, -8.57817977553073],
            [2.0997829988185734, -8.579614901544549],
            [2.0972640342933024, -8.576653829272509],
            [2.102209542679942, -8.575379785491092],
            [2.1036763126710194, -8.57149229105907],
            [2.101380885613438, -8.56945977207447],
            [2.095900426220711, -8.568898232010072],
            [2.092699161694473, -8.56647422460454],
            [2.092474454424034, -8.559712037984928],
            [2.0903562413409267, -8.554599266405837],
            [2.095094764858955, -8.54730342760606],
            [2.0910987687035827, -8.54240954260829],
            [2.093093331754923, -8.539830671182791],
            [2.094481485879038, -8.527365857972912],
            [2.0988726857301065, -8.524994081509735],
            [2.1038836607270186, -8.526859495178359],
            [2.1039880276103426, -8.522885095099628],
            [2.1075697503306134, -8.517908578956142],
            [2.10782371285929, -8.512041842821658],
            [2.1005546285200696, -8.503412143066056],
            [2.098761766788235, -8.50442237329268],
            [2.0937076792931895, -8.501668658336154],
            [2.0888569645518493, -8.496643828026409],
            [2.0877388165929474, -8.49045175951111],
            [2.088705302247817, -8.487182095615191],
            [2.087202000976153, -8.481569985168864],
            [2.088411309766762, -8.476473303985793],
            [2.0872871091083156, -8.474101481071848]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.89382775294897, "lat": 30.12132337511354 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48361"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "361",
        "coty_gnis_code": "01383966"
      },
      "bbox": [
        2.087202000976153, -8.842073534154707, 2.4597406045779615,
        -8.463969407932705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.117447477381332, -5.743141570612936],
            [-2.055616643920327, -5.7453165833743896],
            [-1.9964851551213156, -5.747090689077343],
            [-1.9403305674230609, -5.748489599627395],
            [-1.8493061804038375, -5.751387370003862],
            [-1.7934424806982239, -5.753603628832373],
            [-1.6837736773314629, -5.758712188831383],
            [-1.686463957085673, -5.855828595863494],
            [-1.689509314933416, -5.962024561150007],
            [-1.6901254142038156, -5.9793189105621805],
            [-1.6930977675441075, -6.089149849939357],
            [-1.6962810311041778, -6.197927860068083],
            [-1.8207579616603284, -6.194392906668596],
            [-1.8421846385876244, -6.193407123506913],
            [-1.8800377112852027, -6.192713959082205],
            [-1.995418318756966, -6.18944902693765],
            [-2.0517477007017892, -6.1877114120174666],
            [-2.05253225236558, -6.188005860101191],
            [-2.1319658092123728, -6.18539386229014],
            [-2.1280915069566024, -6.068049510267379],
            [-2.12462387098693, -5.964085377074571],
            [-2.123700009881753, -5.9405070892720575],
            [-2.121414623108436, -5.867525684678376],
            [-2.117447477381332, -5.743141570612936]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.83617333543812,
          "lat": 32.735871558599676
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48429"],
        "coty_name": ["Stephens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stephens County"],
        "coty_fp_code": "429",
        "coty_gnis_code": "01384000"
      },
      "bbox": [
        -2.1319658092123728, -6.197927860068083, -1.6837736773314629,
        -5.743141570612936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.691688043877072, -7.669705544150335],
            [1.6950248261774465, -7.671609256242184],
            [1.6982282926869574, -7.671048955730044],
            [1.699773335680726, -7.674055289258533],
            [1.7030556697988204, -7.672844337634255],
            [1.7040248938615363, -7.669346596485694],
            [1.7084541189672906, -7.674991674938889],
            [1.718324138205588, -7.673744345814091],
            [1.7310461683894316, -7.679253693372527],
            [1.7378889015818115, -7.68460605947921],
            [1.748551914808573, -7.685732015352562],
            [1.7528529346711277, -7.684296331359444],
            [1.7527329126346078, -7.688960269870487],
            [1.7567136373895273, -7.688211498154407],
            [1.7582871675874225, -7.693096182796396],
            [1.7574346288870324, -7.696127108539516],
            [1.7636136283581294, -7.699383746835442],
            [1.7694169916308258, -7.700837434101701],
            [1.775715789879347, -7.694517022421438],
            [1.7810110228931713, -7.693797723614096],
            [1.7865000032187077, -7.695566480270656],
            [1.791609216727022, -7.692531954601657],
            [1.7943239328509715, -7.69690723333726],
            [1.7909951124433279, -7.704295449587857],
            [1.787724043492517, -7.7081172987612705],
            [1.7873911451957996, -7.717435858175242],
            [1.7853358644148247, -7.7206581740815],
            [1.7894295382924308, -7.7235206962858385],
            [1.7930819889713658, -7.721540911857328],
            [1.8015276063703105, -7.719712476247451],
            [1.7999768692514557, -7.712940874884782],
            [1.8071953362111528, -7.7104020645365745],
            [1.8088086583305796, -7.7054464882695175],
            [1.813677941847877, -7.704467655919885],
            [1.8187066737462665, -7.699975370947133],
            [1.8268334918862295, -7.699009388775131],
            [1.8308399849644628, -7.701239247637802],
            [1.8330839995794943, -7.697444639063852],
            [1.8369524173040648, -7.697585686128833],
            [1.8423400531611138, -7.700027463747235],
            [1.842371733342258, -7.696790750295695],
            [1.8473521465595506, -7.697753697577165],
            [1.848179840369113, -7.693820457515866],
            [1.8558413292573424, -7.6952416191187245],
            [1.8613516289216487, -7.692472286084236],
            [1.8704758926509395, -7.690619899824602],
            [1.8697589927918825, -7.686311133868782],
            [1.8741550939039924, -7.687484355217266],
            [1.8779234295341412, -7.685790756115605],
            [1.8826245107692654, -7.688120563401498],
            [1.8847044872506207, -7.69139738659134],
            [1.8839496322958718, -7.695192594456497],
            [1.8946101429817979, -7.705171982252617],
            [1.9031500963780947, -7.70165798268185],
            [1.9170335752231613, -7.690243545085725],
            [1.916337108040478, -7.683231306544387],
            [1.9223579698496274, -7.682013665210964],
            [1.9273297352237537, -7.684320230332782],
            [1.930459896003725, -7.688497898750815],
            [1.9275893798122183, -7.697462760822477],
            [1.9321059064874706, -7.7060853335639745],
            [1.9387548282419, -7.707721654556207],
            [1.9417561933631489, -7.7049941525343195],
            [1.9510413536711708, -7.70436281135361],
            [1.956803023825211, -7.705093148252832],
            [1.9628438483081463, -7.712590428205065],
            [1.9690428389140275, -7.710620630017451],
            [1.9668100638269792, -7.715570878152247],
            [1.9677931790773286, -7.7208457355487],
            [1.9717415031948635, -7.726990490657411],
            [1.9737205656076642, -7.7329316313788325],
            [1.9728477056829605, -7.737620910096352],
            [1.9667947207899978, -7.734562997107977],
            [1.9646693534351285, -7.740780122267157],
            [1.9686499734370368, -7.749667451347421],
            [1.9682077648807956, -7.752950857561088],
            [1.9647356549248802, -7.754925973526476],
            [1.965589103348997, -7.7601576243468005],
            [1.9697548257380388, -7.763344433745032],
            [1.9788290868580072, -7.7654663685949],
            [1.974049460251531, -7.770513349904848],
            [1.978693114502276, -7.771691982705948],
            [1.976135736822854, -7.775909692295734],
            [1.9810413702893024, -7.7833021591097316],
            [1.9859458350375139, -7.788187620446061],
            [1.9923068014146612, -7.7880683371811035],
            [1.9944468970261282, -7.784824178379033],
            [2.0000616927433854, -7.788019863882661],
            [1.998114772884595, -7.792910306222918],
            [2.003274412654229, -7.793471562894207],
            [1.9962726575466232, -7.800713512191023],
            [1.9995301618207575, -7.805496400023985],
            [1.9969519997968839, -7.8132553319686835],
            [1.9940148456074682, -7.811920878938774],
            [1.9916351217435135, -7.814752717835781],
            [1.990080474399917, -7.821170396592948],
            [1.9962324744602693, -7.823738793983118],
            [2.003857625553586, -7.830331375412326],
            [1.9996616725588567, -7.835954711237193],
            [2.0076555423786178, -7.841167499541447],
            [2.009509312632674, -7.84459046810997],
            [2.0055276790305174, -7.848460967720122],
            [2.009080297866697, -7.852437148536891],
            [2.009671676986475, -7.858452092128042],
            [2.00409677583366, -7.8580193405868215],
            [2.0071603583216078, -7.862372232334644],
            [2.0062017039744044, -7.868290873336195],
            [2.0072279187977724, -7.871219367339262],
            [2.011597081675581, -7.876458344525833],
            [2.010224113231039, -7.880416414699583],
            [2.013578863170769, -7.885020487000537],
            [2.0187962851582615, -7.885290455775631],
            [2.017079678851867, -7.890384532899199],
            [2.0215740994049116, -7.891515389073683],
            [2.0203377798742737, -7.894998911088943],
            [2.0224025038200626, -7.899276112095347],
            [2.0156768003703522, -7.8974156365259605],
            [2.0146453239386557, -7.903550418434483],
            [2.0182054055224636, -7.905191747251001],
            [2.0185602405329073, -7.908843585757409],
            [2.021845935955942, -7.911386906328446],
            [2.020937899465172, -7.917245896439592],
            [2.023696877603911, -7.92039899175327],
            [2.021548026781332, -7.923637174415622],
            [2.026304043467368, -7.92746837772769],
            [2.032737042386934, -7.927752083911131],
            [2.0367540161883264, -7.930645185156114],
            [2.0424980328550646, -7.9314369478581375],
            [2.048548299892607, -7.930668942614182],
            [2.056094905592581, -7.937898986332803],
            [2.0578992817088326, -7.943077454313783],
            [2.055242114717409, -7.94718915193794],
            [2.0598147300487195, -7.949786102719049],
            [2.063868071343578, -7.955789512430975],
            [2.058432773050406, -7.96277956564418],
            [2.0600414697167047, -7.967567958167617],
            [2.066074746145995, -7.968403026929524],
            [2.0677675701206177, -7.9755401401126935],
            [2.062992087123739, -7.980960901107378],
            [2.0600806395086284, -7.98991400349612],
            [2.066081576413623, -7.995212177964182],
            [2.0673418997732287, -8.001494007780938],
            [2.0622838999554025, -8.003516769854045],
            [2.060937546897419, -8.005825695486717],
            [2.06819904763206, -8.014107416496387],
            [2.072484763404355, -8.017294369370369],
            [2.073717952779967, -8.02101541930021],
            [2.0725143848640313, -8.026398436616335],
            [2.0731057397656905, -8.030325492129856],
            [2.0714577832538943, -8.035636537621516],
            [2.081027500623499, -8.034816679208465],
            [2.086856093436519, -8.031056309841302],
            [2.0927873010853606, -8.031514006012715],
            [2.096128635289646, -8.030082665395973],
            [2.1009451507897823, -8.030956029001949],
            [2.102674808415185, -8.033655875464465],
            [2.1010261498217555, -8.03676840844985],
            [2.1031515697344934, -8.045724800861425],
            [2.109069629983888, -8.052341653355843],
            [2.105663750018038, -8.059919628258369],
            [2.1079840220841133, -8.06186967549827],
            [2.1116236865377878, -8.05788861722969],
            [2.113807509496122, -8.052486106646102],
            [2.116344889414555, -8.051038424526613],
            [2.120215583065727, -8.055475658765152],
            [2.1233553656400144, -8.055443219029003],
            [2.1287522394836467, -8.061894196464774],
            [2.1320093793507056, -8.063624090146511],
            [2.1345830118573756, -8.069691848940826],
            [2.1336834288377626, -8.072060734552727],
            [2.13660419352879, -8.0794920021952],
            [2.1325789812330433, -8.084875223021177],
            [2.1309304735365577, -8.092902918215938],
            [2.1270470645963453, -8.093714909372398],
            [2.125821481525389, -8.097125262232113],
            [2.1208917959099343, -8.097346629876204],
            [2.1156733774646357, -8.10028809451695],
            [2.1151917011622254, -8.102476355516396],
            [2.120534342343907, -8.104997318879084],
            [2.12021985537048, -8.109554282998843],
            [2.1172159778281374, -8.111000120406311],
            [2.112652161839258, -8.11025289635113],
            [2.111079564094888, -8.11248369305887],
            [2.1138194561445123, -8.115682220399556],
            [2.1130897067113845, -8.120157923988693],
            [2.1095621247778986, -8.119913824450679],
            [2.1075080692858785, -8.122432938081197],
            [2.1105193039290455, -8.126123228832313],
            [2.1067051203628258, -8.128736934424554],
            [2.1072140668657298, -8.132894868155525],
            [2.101539775291349, -8.133913830328815],
            [2.10023725002064, -8.142773723039403],
            [2.1056197627584132, -8.14288206511734],
            [2.1064375105325257, -8.149845829614382],
            [2.101210845607101, -8.150921246736013],
            [2.107640646611503, -8.158302018685152],
            [2.106537288896377, -8.162871561451453],
            [2.108879245822014, -8.166125108413961],
            [2.1084532573609995, -8.17065917544676],
            [2.1150201950360867, -8.17059248119767],
            [2.1217129833695125, -8.176577213764599],
            [2.119179155801719, -8.181370750945852],
            [2.1250209921981593, -8.185547439412382],
            [2.1239499981819225, -8.18915462913747],
            [2.1211031141318295, -8.191482859994716],
            [2.02296855149498, -8.192948021606782],
            [1.9557425586825243, -8.193916042413944],
            [1.8604050553470648, -8.195478493795218],
            [1.8104413751932225, -8.196122454807535],
            [1.7562639674591713, -8.19703737711445],
            [1.7528275454001412, -8.197280605955532],
            [1.713703531382038, -8.197722738813857],
            [1.6926037719288738, -8.101847926693848],
            [1.6927346403074437, -8.10057364642426],
            [1.668474825301575, -7.989829107721516],
            [1.6618539951899722, -7.958553679707745],
            [1.6392682043445845, -7.853114002810814],
            [1.627173164234465, -7.796272769281158],
            [1.6126598621667605, -7.729731430255878],
            [1.6103429551496384, -7.717557638604109],
            [1.691688043877072, -7.669705544150335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.37656526676962,
          "lat": 30.771213954692453
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48457"],
        "coty_name": ["Tyler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tyler County"],
        "coty_fp_code": "457",
        "coty_gnis_code": "01384014"
      },
      "bbox": [
        1.6103429551496384, -8.197722738813857, 2.13660419352879,
        -7.669346596485694
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.78227503183799, 7.467528641870084],
            [16.78824217509876, 7.531829144267704],
            [16.793814416090648, 7.589915130140085],
            [16.785615817925358, 7.590417010044274],
            [16.795711191528337, 7.681334778090809],
            [16.804894892398462, 7.679563198861199],
            [16.80890090151271, 7.679775722467227],
            [16.817465482797772, 7.678339555150886],
            [16.822034009071313, 7.679754540286994],
            [16.831186183983075, 7.712279892833817],
            [16.801687296948757, 7.720235089703922],
            [16.80516766387738, 7.733351912171094],
            [16.814132429589968, 7.772888351809392],
            [16.84348280764179, 7.7708437920400595],
            [16.87931202831528, 7.761578552398756],
            [16.93116289587874, 7.746986039309345],
            [16.950030517313127, 7.829193461742648],
            [16.95077413748133, 7.83491707535272],
            [17.03595460339518, 7.799417536658918],
            [17.035720274120475, 7.8012564994411555],
            [17.038663226873602, 7.813201862936031],
            [17.038322510130538, 7.815540734220395],
            [17.044967472470343, 7.83984637474697],
            [17.055041283593027, 7.882061519455901],
            [17.056815394216823, 7.888693569588225],
            [17.14169124755239, 7.8674888229026205],
            [17.148286823473203, 7.865719925776583],
            [17.221947179696276, 7.84715406166901],
            [17.22662043866776, 7.841417623718237],
            [17.225807598784574, 7.837215288952274],
            [17.22996113099745, 7.835262720376744],
            [17.2109182247136, 7.757717202274289],
            [17.18893190089263, 7.709499810294911],
            [17.195625918596814, 7.683953255168791],
            [17.18897613721353, 7.656927074457822],
            [17.188069007779927, 7.655364940857522],
            [17.176361957862408, 7.608995103956741],
            [17.13734867392157, 7.616517610131062],
            [17.13841218257817, 7.59843673842551],
            [17.143242564518943, 7.523632411290605],
            [17.133690131925963, 7.525899048579431],
            [17.083047670524184, 7.532419947517964],
            [17.054197716941644, 7.536346937980262],
            [17.053223441052086, 7.527763972412559],
            [17.036229260958873, 7.529144023796823],
            [17.024419513561366, 7.4519148222850795],
            [17.020323894269474, 7.452409862594321],
            [17.005367530918917, 7.370205748250662],
            [16.96000514269131, 7.376220700048738],
            [16.878565010566323, 7.387734086033986],
            [16.84184886577681, 7.392210490555151],
            [16.82846626301226, 7.387102030787466],
            [16.81949312193353, 7.40830810727722],
            [16.797622201275264, 7.465233757032749],
            [16.7945161876359, 7.471979219008677],
            [16.78227503183799, 7.467528641870084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.6147643603098, "lat": 44.273567522262816 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50023"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01461768"
      },
      "bbox": [
        16.78227503183799, 7.370205748250662, 17.22996113099745,
        7.888693569588225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.066462314835409, -0.5772730707336866],
            [12.081024203467987, -0.5666710473470038],
            [12.09941198130791, -0.5484862168403428],
            [12.107302803205114, -0.5422347078593605],
            [12.113189388820556, -0.5387518899912608],
            [12.125487422342555, -0.5329479257793219],
            [12.147222313685106, -0.5199796948410735],
            [12.160404870252178, -0.5136613881089321],
            [12.168538677724504, -0.5105745922984],
            [12.20405012971003, -0.4989659036742577],
            [12.215302947251061, -0.4931996035248666],
            [12.225485210027738, -0.4896076172160047],
            [12.23461589340481, -0.4846048930758311],
            [12.246958923893668, -0.47984359370117663],
            [12.245942742043166, -0.48640209148318947],
            [12.248040989148322, -0.4894214445634638],
            [12.244764525043335, -0.4920057927199953],
            [12.235981054205514, -0.5043374223366004],
            [12.224072134177714, -0.510983986687907],
            [12.255402921138996, -0.5318296900836116],
            [12.33314685030762, -0.5917414047562591],
            [12.340340359846218, -0.5828961086023834],
            [12.348556441511155, -0.5745534367165342],
            [12.358604600574807, -0.5885523566675176],
            [12.353072021698159, -0.5927837902701579],
            [12.3493718908925, -0.5970223149024001],
            [12.34453695586965, -0.5984198403796905],
            [12.368963911460808, -0.6186069111309516],
            [12.35618223861286, -0.6304307903674384],
            [12.346938493877316, -0.6428073170276308],
            [12.335306152292908, -0.6519562313792558],
            [12.323406945725527, -0.6579737552407084],
            [12.314890388870117, -0.6604003421418735],
            [12.335552496770037, -0.6997714968953405],
            [12.329088426689808, -0.7022486713837106],
            [12.319542992638317, -0.7091450944973049],
            [12.316452652318052, -0.7096931774121177],
            [12.293649385030072, -0.7231637731094047],
            [12.286496576592596, -0.72830454194352],
            [12.253992436628527, -0.7381150006359014],
            [12.246232541216465, -0.7410956662715728],
            [12.240352842365022, -0.7466158918094963],
            [12.228224560978823, -0.7517350062687532],
            [12.221440288603194, -0.7557612272754],
            [12.210956271714114, -0.7596997543873267],
            [12.201254817046175, -0.766996434716415],
            [12.186182639722578, -0.7753881507813039],
            [12.17636220804193, -0.7663910406692511],
            [12.170676314662636, -0.7619975978609616],
            [12.16305000203804, -0.7667190293726199],
            [12.15614030782223, -0.7730120427112535],
            [12.149676329674893, -0.7777705023798089],
            [12.14545069094258, -0.7797222393427928],
            [12.135384986072756, -0.7808494655976855],
            [12.129795652834085, -0.7777472202361854],
            [12.123387704391742, -0.7705360197926022],
            [12.114179550186256, -0.7664497408528816],
            [12.107182488307922, -0.7643212360149968],
            [12.0960779605615, -0.7637832892750871],
            [12.086924225061376, -0.7742325577850131],
            [12.079929813094417, -0.7796161982728762],
            [12.070989759236777, -0.7837141856696819],
            [12.064094100687546, -0.7922401574786553],
            [12.058036178773536, -0.7974023626449191],
            [12.052278039069298, -0.8001056633753217],
            [12.038668697308875, -0.8177029561441215],
            [12.032826942777218, -0.8240600123242527],
            [12.030492922019961, -0.8296343956747448],
            [12.024976492180258, -0.8369299579867524],
            [12.018511840536988, -0.8498896080856357],
            [12.01646230485767, -0.8511277774617341],
            [12.012152027033913, -0.8589495299884362],
            [12.006517820970824, -0.8628897580879396],
            [11.99718445047853, -0.8615800862614246],
            [11.99333091292458, -0.8661623531916653],
            [11.98995064710816, -0.8777968265371406],
            [11.936219921230473, -0.8271717048246154],
            [11.912363483567345, -0.8050409573241545],
            [11.915445027781601, -0.8008668820949238],
            [11.923495017743885, -0.7980713522152305],
            [11.92825874764486, -0.7978039741266404],
            [11.939499636236402, -0.7909179003012573],
            [11.942824394278333, -0.787268693097622],
            [11.958143388216145, -0.775211582243482],
            [11.965527975633467, -0.7766424675362144],
            [11.97277035572581, -0.7750174237637283],
            [11.975443753487442, -0.7767270154228398],
            [11.977875192540703, -0.7733696912613385],
            [11.983342687042883, -0.7710962162251485],
            [11.990290647909058, -0.769596782311362],
            [12.000773073548526, -0.7641051784163331],
            [12.00703884846054, -0.7596938435889614],
            [12.013316255015376, -0.7568668779079402],
            [12.022035272568388, -0.7504475985554461],
            [12.02512339077062, -0.7462155244798532],
            [12.039800138104797, -0.736458854935039],
            [12.048503478268199, -0.7297142459776431],
            [12.05353909802323, -0.7242720909296309],
            [12.054232754697248, -0.7154592446518049],
            [12.056745335794771, -0.7100368035806349],
            [12.05698978244667, -0.7015422982435745],
            [12.053455733568944, -0.6924028590914466],
            [12.048677107684039, -0.6894921515029709],
            [12.044449109080459, -0.6897203062729965],
            [12.036799133671533, -0.6882178753301543],
            [12.028970582205902, -0.6895067168980823],
            [12.019358055558293, -0.686194441465083],
            [12.014692432560835, -0.6870511627810061],
            [12.010484571109918, -0.683808249873131],
            [12.001087087656774, -0.685509164117701],
            [11.99570754655823, -0.6759358808818229],
            [12.009119337255164, -0.6633133403313154],
            [12.015203882661153, -0.6596033198820783],
            [12.02627722549535, -0.6541693788244757],
            [12.045913971252812, -0.643704528582528],
            [12.023014920553342, -0.6036282946996963],
            [12.03203222532085, -0.6004115965493118],
            [12.039976418085828, -0.5985080820689129],
            [12.053779232721972, -0.590309332948939],
            [12.066462314835409, -0.5772730707336866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.13024564634698, "lat": 37.13397075271287 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51021"],
        "coty_name": ["Bland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bland County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01494613"
      },
      "bbox": [
        11.912363483567345, -0.8777968265371406, 12.368963911460808,
        -0.47984359370117663
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.689532220596151, 1.4634161973287818],
              [14.702729164824804, 1.4571547729474739],
              [14.70394761434728, 1.4516243054149978],
              [14.701697794204271, 1.449530160639179],
              [14.707170872895189, 1.4435813371337318],
              [14.709422534878504, 1.4449866018708222],
              [14.710100588972596, 1.4497757335384505],
              [14.714061070309832, 1.4515356483655624],
              [14.716959038258407, 1.4495756847188297],
              [14.720369642340039, 1.4591915545779315],
              [14.716680776846161, 1.4657538367501328],
              [14.719785281881967, 1.4667356798815399],
              [14.71565772316616, 1.4732604603070485],
              [14.710694955317969, 1.474804510174531],
              [14.706865332271533, 1.4730426496519984],
              [14.701255687376754, 1.4772096876426437],
              [14.699532916765424, 1.4718993287974482],
              [14.701069087426093, 1.4690236227265918],
              [14.700357869674392, 1.4636786626199432],
              [14.68773398799037, 1.4693126094447078],
              [14.686723960899243, 1.4783721460381043],
              [14.675573973524772, 1.477196346182122],
              [14.672299506999007, 1.4705745368546184],
              [14.675019220656571, 1.4695977594001841],
              [14.670350502907253, 1.4620661925780818],
              [14.668101475753897, 1.4558877920168614],
              [14.66194022267961, 1.4560608773081138],
              [14.659428588939136, 1.4461602977928472],
              [14.65352951171944, 1.4306183542101318],
              [14.6539917343854, 1.4274418776078157],
              [14.647282035286741, 1.4227123820278973],
              [14.650383031967973, 1.4176335512654215],
              [14.645673895533493, 1.4145225167775617],
              [14.651376847945182, 1.4011182634870303],
              [14.654663795799241, 1.3986449214031762],
              [14.659089523210675, 1.3996346929120096],
              [14.666443528929978, 1.3907362032377488],
              [14.667423121505214, 1.400601474610422],
              [14.661389512788176, 1.405363567513203],
              [14.66209532592626, 1.4073123341476714],
              [14.65617602876649, 1.4144356978067696],
              [14.654000804518413, 1.4188654128197171],
              [14.659211988053391, 1.424735515659217],
              [14.665545826034151, 1.42248554090423],
              [14.665991483268717, 1.420097969773834],
              [14.672011060020123, 1.411736758211879],
              [14.677212655225953, 1.4203957032072032],
              [14.688811508240793, 1.4173290138453734],
              [14.700212492564491, 1.4281186414954639],
              [14.701528620750864, 1.4308214150410912],
              [14.70119388084985, 1.441580769041405],
              [14.70016302635066, 1.4461564617957798],
              [14.70005494887882, 1.4537327714591837],
              [14.69238431354077, 1.4574213363580633],
              [14.688519591858624, 1.4609495067826979],
              [14.689532220596151, 1.4634161973287818]
            ]
          ],
          [
            [
              [14.507684101266364, 1.6029070224888835],
              [14.521225838838715, 1.604570859987426],
              [14.527149962685872, 1.5987168381578876],
              [14.532559659844601, 1.596632443461017],
              [14.538411293348775, 1.5964820071082446],
              [14.543050486562036, 1.591121908810265],
              [14.545505596553342, 1.5844445320759397],
              [14.54960040601826, 1.5796032858915097],
              [14.553116513544497, 1.5793017101722644],
              [14.558461152690619, 1.571844341162954],
              [14.564444708970132, 1.5691459464598134],
              [14.564701826842908, 1.5667587280616082],
              [14.56941189751514, 1.5661457357048945],
              [14.574095328662986, 1.5627846180642353],
              [14.578869176434836, 1.5639815924005689],
              [14.58767890342525, 1.5604920177620656],
              [14.593391426652847, 1.5640292299247605],
              [14.59641164275881, 1.5626260888706585],
              [14.599469052047002, 1.5562445606684723],
              [14.598809646328977, 1.5513945687577504],
              [14.60234466619152, 1.544540069459262],
              [14.600243104874881, 1.5409557705581005],
              [14.60405219889812, 1.53983425538083],
              [14.602113012053152, 1.532609547049456],
              [14.609664139400403, 1.5278517802282252],
              [14.616347708723906, 1.526201355084552],
              [14.616501940407144, 1.52148325272482],
              [14.618728055430436, 1.5184214688588962],
              [14.623191959598165, 1.5168934770447928],
              [14.62893524612431, 1.5183323300663898],
              [14.636272554147823, 1.52395057665295],
              [14.639573345684148, 1.5199013978935583],
              [14.637536892512317, 1.5129193554639924],
              [14.644846780189809, 1.5094582791320075],
              [14.643953578479673, 1.5049738047429817],
              [14.645842803720221, 1.4999428879286896],
              [14.649110224769293, 1.4983264712959337],
              [14.65724544395071, 1.49721917854123],
              [14.659464423710425, 1.4919931029459055],
              [14.657137636889587, 1.4859314219079331],
              [14.658778063039342, 1.4834225052719279],
              [14.682213658932847, 1.4858132490305669],
              [14.689674277540758, 1.4881533718558442],
              [14.691972395430097, 1.4963891341729763],
              [14.69521911158635, 1.496779875676938],
              [14.698930070968363, 1.4927013420614192],
              [14.706131561892306, 1.4817516194595235],
              [14.707258669456557, 1.4747811809449838],
              [14.709568975929669, 1.4764688488071087],
              [14.724544221512314, 1.4697163728123752],
              [14.722945982277238, 1.4651254316861617],
              [14.726189655483672, 1.4608130840866973],
              [14.723142729965588, 1.4586847830843916],
              [14.724685688998887, 1.4558281541466542],
              [14.73253304078298, 1.453030612268005],
              [14.730050836220201, 1.4458976362101787],
              [14.732952171977361, 1.4439326537787778],
              [14.736902962596215, 1.4521367762945934],
              [14.740429730655421, 1.4496868362960953],
              [14.74761936070484, 1.4506254502109903],
              [14.747543457707588, 1.4447375024670843],
              [14.755518928546529, 1.4406933440794325],
              [14.759482081808374, 1.4332633289999874],
              [14.75828923277323, 1.4275950548571836],
              [14.760543351337105, 1.4215259703690153],
              [14.765224616208764, 1.4166414022788982],
              [14.769017117205435, 1.4152782555915813],
              [14.77036906005427, 1.4194985229661645],
              [14.772843597823698, 1.4213071550186864],
              [14.774504027573684, 1.4302796725445936],
              [14.776631178640127, 1.4324147135627006],
              [14.782695534831447, 1.429264263395095],
              [14.79334723795751, 1.4295911200746654],
              [14.795592724228273, 1.428933405353277],
              [14.796489382528113, 1.4233595215560844],
              [14.799028092492481, 1.4221838300566765],
              [14.804526669891036, 1.4246159393012219],
              [14.806608391596786, 1.4218941976448294],
              [14.802786221474914, 1.4156992003919715],
              [14.804966053316072, 1.4134703409242233],
              [14.813653642836107, 1.4156186213910005],
              [14.817303234639285, 1.4220990501149877],
              [14.820931336349242, 1.4229052130182975],
              [14.82408325337602, 1.420143855645918],
              [14.827871618674463, 1.4193096820194608],
              [14.839112054431116, 1.4144076486035926],
              [14.84480815551468, 1.4133073531468956],
              [14.852980106937933, 1.4081725317988565],
              [14.858834466763419, 1.406218459914513],
              [14.864690130281781, 1.4009750757955337],
              [14.866734766447593, 1.3975943646286915],
              [14.872046755552137, 1.3957849192157705],
              [14.881757676672933, 1.3874018085305797],
              [14.883127586224672, 1.3828429878135247],
              [14.887992366174034, 1.3796117726911468],
              [14.89236276581543, 1.3737030011833848],
              [14.890627311710187, 1.3650416880457183],
              [14.886436099663232, 1.3628331089803045],
              [14.882708495059235, 1.3644461943704032],
              [14.877216353881646, 1.359606258650186],
              [14.876853762169727, 1.352739486209049],
              [14.881300553711737, 1.3454955667462989],
              [14.88050586703382, 1.330329378598201],
              [14.877287104688053, 1.3267224970086866],
              [14.876941552270898, 1.322350393927917],
              [14.885817650005283, 1.3154126311885905],
              [14.88024940399761, 1.3104879312693107],
              [14.878936987133633, 1.3066031312281445],
              [14.87412329150215, 1.30734862243551],
              [14.873962710843553, 1.3024421777921238],
              [14.88032413911596, 1.288282089037106],
              [14.884027276761866, 1.2847669563110014],
              [14.881422177149634, 1.2796089253219782],
              [14.874144984984895, 1.2727473773701354],
              [14.871945953780864, 1.2678634368379087],
              [14.873656130896139, 1.2604839213784091],
              [14.872628512219226, 1.2544728633344289],
              [14.869789710070155, 1.2529121217561996],
              [14.86825379190175, 1.2474380690175866],
              [14.871396729418862, 1.2462727007414771],
              [14.867133249319261, 1.2345805324670205],
              [14.862282482209844, 1.2326561990460005],
              [14.861690192703309, 1.2291532408930201],
              [14.863434874682182, 1.2231239941518246],
              [14.85748564303259, 1.2231584000155828],
              [14.854138637822876, 1.2204288118474351],
              [14.854410032745252, 1.2174050021064116],
              [14.847445901433902, 1.2197333604099232],
              [14.841200913975554, 1.2202465243700797],
              [14.835546927615072, 1.2233975498991494],
              [14.834407652032894, 1.226510087364574],
              [14.830287667863148, 1.2256474840855127],
              [14.810400662316699, 1.2286413123724609],
              [14.805509429440246, 1.2268910386063834],
              [14.800556000966456, 1.2324837111717049],
              [14.795568983516505, 1.2314643465169541],
              [14.796023314209727, 1.234905632252242],
              [14.790102898686541, 1.2371626620444782],
              [14.78688363895323, 1.2399144654705672],
              [14.783106199853602, 1.2469945907532194],
              [14.774955401653841, 1.2532769725678476],
              [14.767087859565734, 1.256806504429168],
              [14.761856798003286, 1.2579266823255821],
              [14.757045434835828, 1.262760978849667],
              [14.7514815366094, 1.263405276282446],
              [14.74531236558963, 1.2691199213598732],
              [14.738423846320822, 1.2708274970573887],
              [14.734444854148427, 1.2757192892748734],
              [14.723345810965265, 1.270842710501292],
              [14.715514526670106, 1.2803953652968385],
              [14.710986723652265, 1.2824075635718581],
              [14.704729488506254, 1.2811637358022703],
              [14.69993599448954, 1.2785390911180656],
              [14.696926568237693, 1.2736601725708196],
              [14.696067922158871, 1.2671433387380662],
              [14.676579641883535, 1.2388573546627326],
              [14.675313009642743, 1.2393016228796214],
              [14.626158167653687, 1.3021025529660837],
              [14.560069443238408, 1.3865299921493572],
              [14.489216302912824, 1.477037333268454],
              [14.483242474806266, 1.4844862770210583],
              [14.481138300661364, 1.4954786627102745],
              [14.489280917487587, 1.4969906379122138],
              [14.49020719395949, 1.5058503787600033],
              [14.489136080871514, 1.5147959681929162],
              [14.48841044830021, 1.529731030831291],
              [14.490124365895392, 1.5422499134630072],
              [14.498165489776497, 1.5502258503473028],
              [14.50510180066959, 1.5757472926225375],
              [14.505837768329098, 1.5932272694233007],
              [14.507377278442682, 1.5949491942139096],
              [14.507684101266364, 1.6029070224888835]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.48092799173327, "lat": 38.70290739134218 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51153"],
        "coty_name": ["Prince William"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prince William County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01480161"
      },
      "bbox": [
        14.481138300661364, 1.2174050021064116, 14.89236276581543,
        1.604570859987426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.990094462433984, -0.35137510058352317],
            [12.993255749121746, -0.3558171357446131],
            [12.994312090152349, -0.36622999803675166],
            [12.992342270250628, -0.3695026856972394],
            [12.995036824072063, -0.3780807198083194],
            [13.001282837902123, -0.3781644393507875],
            [13.00260033747235, -0.38750975944549215],
            [13.000891154081451, -0.3885824265132274],
            [13.000479818094746, -0.39476252990958327],
            [12.995462250749068, -0.3950712704307728],
            [12.995053327898594, -0.3979663314893536],
            [12.989040314705973, -0.3981004026661045],
            [12.98364578024157, -0.40014671112401845],
            [12.980862035586231, -0.40417430651711933],
            [12.980469865788368, -0.4088093928389705],
            [12.977059130782086, -0.41107908491771017],
            [12.974054950847602, -0.410094760030451],
            [12.965169225601944, -0.4047130657628511],
            [12.958123090880012, -0.40930519265225274],
            [12.956136266115726, -0.40408562963289246],
            [12.951204276196, -0.402483345249322],
            [12.952613312287435, -0.3968523662294173],
            [12.949537990735656, -0.39575737442202585],
            [12.943038050868376, -0.38604090947887765],
            [12.938950313947887, -0.38649400482453816],
            [12.93086010961529, -0.39234959906905337],
            [12.926671813940649, -0.3921369432995935],
            [12.91943271474818, -0.38380529554653914],
            [12.927756320852689, -0.37909013802503433],
            [12.925569244216241, -0.376258185231728],
            [12.929524099982949, -0.3736500414874936],
            [12.93395025239238, -0.37594811819210655],
            [12.944520609568608, -0.3697473317000803],
            [12.958557026698633, -0.35400746459572935],
            [12.968704074664982, -0.34538127419253684],
            [12.975692580450206, -0.34159036427831035],
            [12.979897514755635, -0.33797792090908196],
            [12.98448448129792, -0.34548032479910273],
            [12.985202259289789, -0.3494521959496862],
            [12.990094462433984, -0.35137510058352317]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.0553020772392, "lat": 37.286218916319854 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51775"],
        "coty_name": ["Salem"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Salem city"],
        "coty_fp_code": "775",
        "coty_gnis_code": "01789074"
      },
      "bbox": [
        12.91943271474818, -0.41107908491771017, 13.00260033747235,
        -0.33797792090908196
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.543337811742367, -0.5569637952847899],
            [15.56114463774256, -0.5323593967251851],
            [15.587732214405184, -0.4951272466306683],
            [15.59544316679852, -0.4827680151346686],
            [15.609352724462006, -0.4657792223538479],
            [15.633025833857722, -0.43351990435932],
            [15.642034419218321, -0.41986468724015524],
            [15.685865656077214, -0.35456986944265284],
            [15.722370548569447, -0.3008531399251527],
            [15.770993716813797, -0.2302687919107403],
            [15.774048675208881, -0.2284636852957614],
            [15.776684266394685, -0.2300506809296897],
            [15.776880922054286, -0.23383052487294745],
            [15.78252096979886, -0.23739481270963064],
            [15.791194758967324, -0.22975226721772127],
            [15.796844498648367, -0.22586045999240492],
            [15.799297783060227, -0.21722981277694156],
            [15.803992437669326, -0.21699980228794952],
            [15.810249254484756, -0.22024599348681406],
            [15.81263075542487, -0.22294190600629243],
            [15.813852619708824, -0.2412822738050758],
            [15.807203874760596, -0.24720137804364106],
            [15.810612382913382, -0.25756897338975165],
            [15.81901427836027, -0.2586626551500023],
            [15.820857214256126, -0.2550434779609096],
            [15.824216960578484, -0.2531666915803793],
            [15.83859635291041, -0.24866812027704915],
            [15.839074535311156, -0.2455216592596968],
            [15.837392618937557, -0.23998432161515582],
            [15.840293004867767, -0.22857014618226806],
            [15.84419841577497, -0.22476809237778322],
            [15.85257630972365, -0.2246526308310214],
            [15.87287559561918, -0.22765628885041117],
            [15.875443019251069, -0.23019754989186333],
            [15.873925372656112, -0.23420872772238277],
            [15.877598722630395, -0.23952944024886058],
            [15.876768511125675, -0.24701119771185137],
            [15.872619557879693, -0.25169204826119784],
            [15.86887536697947, -0.2606324578313067],
            [15.8577296383661, -0.2875082320208289],
            [15.858243735883896, -0.28842715760997895],
            [15.853530855743385, -0.30472157055073257],
            [15.850715137135301, -0.31754804882401255],
            [15.857629551323233, -0.38684672257269764],
            [15.878658712751243, -0.5840862474563279],
            [15.839748873207375, -0.59260734285268],
            [15.813200914631038, -0.5976704659491351],
            [15.686253533598716, -0.6236193751033184],
            [15.67753009117721, -0.626033696329663],
            [15.63273979415984, -0.6349852309404855],
            [15.547598331292933, -0.6508322070743178],
            [15.546255419990484, -0.6486269196747875],
            [15.540955243306788, -0.6483702828883069],
            [15.534367547738768, -0.645822428173705],
            [15.536358399240848, -0.6425094298344678],
            [15.53500407402047, -0.6361908764476265],
            [15.540517574553819, -0.6256967012574142],
            [15.54524908386741, -0.6255557903688617],
            [15.547151822393937, -0.6230318020758925],
            [15.544516549919416, -0.6129994429100771],
            [15.544591875242663, -0.6104116752520732],
            [15.540083319882237, -0.6002496065777616],
            [15.542180678397719, -0.5939431684433537],
            [15.542202777501803, -0.590094898294177],
            [15.537652316016635, -0.5858815600463039],
            [15.540376655669059, -0.5824422721599511],
            [15.549925187593491, -0.574514665547875],
            [15.55094555707779, -0.5694304674596333],
            [15.546987982208252, -0.5648104825512523],
            [15.545225011018633, -0.5586346893698424],
            [15.543337811742367, -0.5569637952847899]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.6398023758885, "lat": 36.6952953375284 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51800"],
        "coty_name": ["Suffolk"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Suffolk city"],
        "coty_fp_code": "800",
        "coty_gnis_code": "01498560"
      },
      "bbox": [
        15.534367547738768, -0.6508322070743178, 15.878658712751243,
        -0.21699980228794952
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.560884110319398, 12.045592250054662],
            [-14.45343879028212, 12.020087798911982],
            [-14.34600355947601, 11.994540238113961],
            [-14.256188931318377, 11.973429788402488],
            [-14.148082543624152, 11.948198000191578],
            [-14.147233040494026, 11.944544284397184],
            [-14.14964104564336, 11.942032711170501],
            [-14.15553328623365, 11.946588658576099],
            [-14.16336041542658, 11.948778223300991],
            [-14.163321368423686, 11.946340645539042],
            [-14.156558943476691, 11.937285323901554],
            [-14.162497985470532, 11.937266897840853],
            [-14.167437494155633, 11.92594885135835],
            [-14.170619251799023, 11.92374168870883],
            [-14.166256000383367, 11.920646829856823],
            [-14.16299320781913, 11.914593716539038],
            [-14.170014430500423, 11.90648656976633],
            [-14.178269748644281, 11.892334980397779],
            [-14.177699337410738, 11.883909301396267],
            [-14.175240041699091, 11.877005899312664],
            [-14.170104396582778, 11.868291516321372],
            [-14.167442585428002, 11.867307043396773],
            [-14.174433512466893, 11.856088709285387],
            [-14.178917692754307, 11.855448364121914],
            [-14.179865988978221, 11.851074028725826],
            [-14.184819353972912, 11.845223027403817],
            [-14.184118922643384, 11.84250900154842],
            [-14.186206172038723, 11.837615175371992],
            [-14.185620964977621, 11.829632871082921],
            [-14.17923775455023, 11.823154235625802],
            [-14.183365174000814, 11.814493064204873],
            [-14.180070529012601, 11.807712313080842],
            [-14.183383026846212, 11.797725530384225],
            [-14.178229541421521, 11.793914486255856],
            [-14.173598372360106, 11.792379328735793],
            [-14.173110066125082, 11.786337971738472],
            [-14.170445380831877, 11.782091351270934],
            [-14.170394763327831, 11.768723351991968],
            [-14.168229972893528, 11.76260762256322],
            [-14.16888157662566, 11.753862241354673],
            [-14.17140461812169, 11.749328256083144],
            [-14.170056258085737, 11.745141382834975],
            [-14.16464380481037, 11.74107131392593],
            [-14.164483843338349, 11.733795363642066],
            [-14.160376484984033, 11.73174690879899],
            [-14.157860620966026, 11.734380590166907],
            [-14.151318775298888, 11.736031743489669],
            [-14.149768011345001, 11.728777375886228],
            [-14.150671017131343, 11.726046481711771],
            [-14.157284094115022, 11.72821149852689],
            [-14.159138237528387, 11.725800964037095],
            [-14.16000475793426, 11.718326071260181],
            [-14.155591031241183, 11.715242857255616],
            [-14.15596832252464, 11.712660208747506],
            [-14.160119424308656, 11.712502792577526],
            [-14.162302579730781, 11.709954401855189],
            [-14.158254879264824, 11.70534516801728],
            [-14.156665749719004, 11.70117452816624],
            [-14.157828259184583, 11.697371921626923],
            [-14.162826096411843, 11.697396001181048],
            [-14.163121986656275, 11.692746237470622],
            [-14.161315161090604, 11.689121614053633],
            [-14.156953062112034, 11.689037421655351],
            [-14.15729377947066, 11.68594721970473],
            [-14.1641789100318, 11.680875319530582],
            [-14.164699246681108, 11.677936033269663],
            [-14.161816711583405, 11.67148880814932],
            [-14.164013496169266, 11.66612395440777],
            [-14.163476361433663, 11.661398175697702],
            [-14.166648482779705, 11.656090065623033],
            [-14.166486318030277, 11.637770057756061],
            [-14.170286223464675, 11.634096788125422],
            [-14.17012841333291, 11.628760022802602],
            [-14.16671805554267, 11.62530244577582],
            [-14.167819405695331, 11.616547058986045],
            [-14.167376868970125, 11.607711623227194],
            [-14.168797847815727, 11.600594501469049],
            [-14.171654502407987, 11.596182027989068],
            [-14.17698711146204, 11.595153284196845],
            [-14.179818439084952, 11.58869437168268],
            [-14.182259392893554, 11.588413627131455],
            [-14.182628992751619, 11.581289151404453],
            [-14.189254139486524, 11.575428707188603],
            [-14.193751195247199, 11.565350563360001],
            [-14.193897055093556, 11.561259604654573],
            [-14.196441593114294, 11.5516939544376],
            [-14.196433946888499, 11.54574878407768],
            [-14.203904804470316, 11.537740988035841],
            [-14.208887774787556, 11.529729606394179],
            [-14.213652211708593, 11.516644644802433],
            [-14.216899283575623, 11.512304308803868],
            [-14.218273287427952, 11.503384406241366],
            [-14.21797947532997, 11.497863470454107],
            [-14.220363549653255, 11.493689529736832],
            [-14.22485142314531, 11.489716658656242],
            [-14.231396198410271, 11.490169630567133],
            [-14.239934718603088, 11.4946519449235],
            [-14.246845311330684, 11.489995286267304],
            [-14.252396432494088, 11.474436592421357],
            [-14.261474447881476, 11.458305804122404],
            [-14.275336003107867, 11.450268505123397],
            [-14.279386497219306, 11.444930567231996],
            [-14.281938781363033, 11.439241889630408],
            [-14.283573641876817, 11.431943509844874],
            [-14.279428986739376, 11.423196668939394],
            [-14.281722287901273, 11.41545246853907],
            [-14.281442701782824, 11.407805963396909],
            [-14.285715782474448, 11.39794566910033],
            [-14.2872683048548, 11.392603131171041],
            [-14.286755430035024, 11.38619790123357],
            [-14.282435902126082, 11.373317194357758],
            [-14.282004942243029, 11.369125686013744],
            [-14.282937733577976, 11.36016281497771],
            [-14.28160582081736, 11.354563452243752],
            [-14.28260319768013, 11.345614701474876],
            [-14.286912746504294, 11.32555888666389],
            [-14.289015431915564, 11.319161588856021],
            [-14.28838913907623, 11.309696189705459],
            [-14.289721544177048, 11.303153491472575],
            [-14.286969993692606, 11.295424252977687],
            [-14.286165274596494, 11.287349665644014],
            [-14.282914765549208, 11.283098204240295],
            [-14.281337406304832, 11.277638955471218],
            [-14.282009890552855, 11.264177189234902],
            [-14.281479870347134, 11.259816983240285],
            [-14.279308021108614, 11.256439602586823],
            [-14.278166928482722, 11.249376645282322],
            [-14.281000247676554, 11.241875062132236],
            [-14.288641733601379, 11.228908351293711],
            [-14.29460905408077, 11.222806540072348],
            [-14.303390897056447, 11.217359383054891],
            [-14.32332961832364, 11.207521124238506],
            [-14.32685690444571, 11.204947078885208],
            [-14.324447307232521, 11.19948912700435],
            [-14.32580678081502, 11.189314759184905],
            [-14.329802495677166, 11.187948686347498],
            [-14.332990726498737, 11.18449569790296],
            [-14.335235654709637, 11.173526268090217],
            [-14.335565436128336, 11.161610264926132],
            [-14.336859207150537, 11.153416540132154],
            [-14.340782979695087, 11.144936384667906],
            [-14.34687525835693, 11.138360383770928],
            [-14.35212607572052, 11.13668730177539],
            [-14.361144943611375, 11.138594125465307],
            [-14.369851556145834, 11.137230040565006],
            [-14.375763264933719, 11.139401329454696],
            [-14.381958179535921, 11.138120169668385],
            [-14.385081679182095, 11.134636804083833],
            [-14.38783971845336, 11.124114458905966],
            [-14.387005767861146, 11.1173445742642],
            [-14.382404523497161, 11.113768071864147],
            [-14.37947351302671, 11.109582557134225],
            [-14.379070650860182, 11.092986584895238],
            [-14.3847653012067, 11.081516312101165],
            [-14.38573277034399, 11.071540172888241],
            [-14.390643454718921, 11.065585573230845],
            [-14.396038380654783, 11.063346504635964],
            [-14.39915956736699, 11.064477066351019],
            [-14.403190389860065, 11.070116340242011],
            [-14.409637218300041, 11.068575861945012],
            [-14.41023151099623, 11.063264791627494],
            [-14.415280845953127, 11.05606063360371],
            [-14.41914333210493, 11.05463341049474],
            [-14.434851296404142, 11.059274819277087],
            [-14.4455358578266, 11.061905325911336],
            [-14.458990631163275, 11.073183560936734],
            [-14.463805989047165, 11.075046863026696],
            [-14.471806816330506, 11.075862665964753],
            [-14.480302571873853, 11.071045012918416],
            [-14.487767533299374, 11.069567907827292],
            [-14.500631962757218, 11.064891015033998],
            [-14.505662567035507, 11.060772047705862],
            [-14.505620520561328, 11.057258998488626],
            [-14.500079728520745, 11.044742910612191],
            [-14.496628732472601, 11.03842470910168],
            [-14.494050829665657, 11.031511364541357],
            [-14.4942716145039, 11.01723506259596],
            [-14.484627878572088, 11.004142614424586],
            [-14.483081861173394, 11.00079955275522],
            [-14.489676155064105, 10.98413201405433],
            [-14.497722722606262, 10.961722142022422],
            [-14.496853489408219, 10.94847478621228],
            [-14.493884252898193, 10.931634495910691],
            [-14.495857828191054, 10.926226705941676],
            [-14.501827873507047, 10.920314091236657],
            [-14.504469884668948, 10.916487661663599],
            [-14.504531153619192, 10.91096901657425],
            [-14.511287153260419, 10.900412635202146],
            [-14.517142520312959, 10.88448604641302],
            [-14.518647947713744, 10.878770728518283],
            [-14.527928630224991, 10.8723381398127],
            [-14.532317849116644, 10.873430023664483],
            [-14.538604112637389, 10.872210117123007],
            [-14.54458675230301, 10.87394196164559],
            [-14.560642118551373, 10.88274662056529],
            [-14.563461801872903, 10.886227601384968],
            [-14.569287039389145, 10.888936166301256],
            [-14.576113862756475, 10.896228844665739],
            [-14.580830693739612, 10.906341831415586],
            [-14.580729556970066, 10.911389047083041],
            [-14.576625610590849, 10.925796427649011],
            [-14.577943309982262, 10.93157119364789],
            [-14.581453478056924, 10.934460488038429],
            [-14.588426408455957, 10.930863219158535],
            [-14.605868879983202, 10.931680735757405],
            [-14.609994669287282, 10.934072313046732],
            [-14.625465997095324, 10.937361586844098],
            [-14.630025352862186, 10.94122449806303],
            [-14.631751766541832, 10.947968134174866],
            [-14.628472035600494, 10.955863364131053],
            [-14.621492761588051, 10.962804198404628],
            [-14.617697681934159, 10.971213600081974],
            [-14.617591522719401, 10.975575993779922],
            [-14.621253338771158, 10.981988447084225],
            [-14.634278699909077, 10.992315591162113],
            [-14.637750949834741, 10.99783638586877],
            [-14.647004496048478, 11.0002711487096],
            [-14.656635811787103, 10.999188142510691],
            [-14.662062466196144, 11.002528427301108],
            [-14.667036358507755, 11.00136770375252],
            [-14.674564390979786, 11.001820631596036],
            [-14.680257168912641, 11.005513625180917],
            [-14.685856722062756, 11.003004248150525],
            [-14.692531936060544, 11.005656000537922],
            [-14.696655041652114, 11.016959817927725],
            [-14.70626653050003, 11.022871150195861],
            [-14.712760745348396, 11.026126513358255],
            [-14.719222228873532, 11.025471691813689],
            [-14.727524364732048, 11.020496289839983],
            [-14.733184050714518, 11.007444647143846],
            [-14.734699181006325, 10.998341176449038],
            [-14.737285427322812, 10.992529479727596],
            [-14.73972605500062, 10.99180305892285],
            [-14.750271439515245, 10.992450670405224],
            [-14.75672552541869, 10.995359147274895],
            [-14.762633787548024, 11.000909393917597],
            [-14.764946109761706, 11.00437050432205],
            [-14.773246996173897, 11.010721777579963],
            [-14.781330875293179, 11.015478468695388],
            [-14.793235870401196, 11.020499103356427],
            [-14.799062038586396, 11.024315296959717],
            [-14.805045564076934, 11.031716631702832],
            [-14.807528398222434, 11.039235222430378],
            [-14.805821933503156, 11.056193824777328],
            [-14.807784152729162, 11.061137840673098],
            [-14.81306655839166, 11.065182644617959],
            [-14.816475527119882, 11.066212292784748],
            [-14.814983555403334, 11.071385802209328],
            [-14.811110658868598, 11.070506171504416],
            [-14.790553450259642, 11.152322309678793],
            [-14.758953389680446, 11.278724563917716],
            [-14.729371752378968, 11.39762679119545],
            [-14.72887477224553, 11.397532373123417],
            [-14.708141824119545, 11.479058015016685],
            [-14.687639423442265, 11.559217792158275],
            [-14.704270886992854, 11.563410313204935],
            [-14.66789261233355, 11.709502822321866],
            [-14.663794507625868, 11.725254916916773],
            [-14.642619911600516, 11.720214185656168],
            [-14.610199051525653, 11.849621960664878],
            [-14.576374979732883, 11.98436905681167],
            [-14.560884110319398, 12.045592250054662]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.51661366138688,
          "lat": 48.470313371011265
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53019"],
        "coty_name": ["Ferry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ferry County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01531821"
      },
      "bbox": [
        -14.816475527119882, 10.872210117123007, -14.147233040494026,
        12.045592250054662
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.65167970570155, 11.834670788820125],
            [-13.56745696702846, 11.815473279495265],
            [-13.455165777218534, 11.789409549061402],
            [-13.394364304951525, 11.776285390775541],
            [-13.42114946871368, 11.65898421082036],
            [-13.427459547762068, 11.632338398597694],
            [-13.44906761116855, 11.541078523095774],
            [-13.469477155857456, 11.45318622005038],
            [-13.477862240846825, 11.419128204281826],
            [-13.50471709452705, 11.304881233975491],
            [-13.532598221191245, 11.18260862860391],
            [-13.558274382943969, 11.077651913643145],
            [-13.570276376188222, 11.02858507399421],
            [-13.576146425014482, 11.006028910587178],
            [-13.578292986043271, 10.996476780902686],
            [-13.58999015307666, 10.950134544048002],
            [-13.607658336219677, 10.874772233938943],
            [-13.694430628586776, 10.894337863292572],
            [-13.781652811655956, 10.914349461256524],
            [-13.867179615890805, 10.934427488071286],
            [-13.86056060656785, 10.96223748692765],
            [-13.848201283153132, 11.017505274994608],
            [-13.890680333616945, 11.027107639945552],
            [-13.881966536453827, 11.06353010570618],
            [-13.8773999041981, 11.083998240249462],
            [-13.870885410492187, 11.111114992584628],
            [-13.869975695681234, 11.110913520652087],
            [-13.866234094389105, 11.124782824073115],
            [-13.85494498915083, 11.172508047878555],
            [-13.850678143009704, 11.191849646140879],
            [-13.831305924641109, 11.273164003540012],
            [-13.831672110164172, 11.273245660130224],
            [-13.82089502855018, 11.318735722272613],
            [-13.811890700684396, 11.357627770524447],
            [-13.812310335771292, 11.357719475463849],
            [-13.792719154144146, 11.440530161306254],
            [-13.773298703717542, 11.520231139159426],
            [-13.84309457076439, 11.53595560404118],
            [-13.857493658371986, 11.538943569271352],
            [-13.838248892783485, 11.620874145912524],
            [-13.79554109738172, 11.611526466242593],
            [-13.792276720963864, 11.625977945953574],
            [-13.774734456582806, 11.699931559742273],
            [-13.732265327419189, 11.690573224850585],
            [-13.713448371010998, 11.771968879746732],
            [-13.668992538806092, 11.761978295449754],
            [-13.65167970570155, 11.834670788820125]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.27398955532507,
          "lat": 48.53230923314138
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53051"],
        "coty_name": ["Pend Oreille"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pend Oreille County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01529157"
      },
      "bbox": [
        -13.890680333616945, 10.874772233938943, -13.394364304951525,
        11.834670788820125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.315521632323732, 1.9196010789268843],
            [12.32421653205765, 1.916211675356602],
            [12.325885564803938, 1.9179505307389877],
            [12.332296422154, 1.9164219662412056],
            [12.337304578923964, 1.91934171011178],
            [12.341511418312749, 1.913409012763021],
            [12.344179640969934, 1.9127269031988667],
            [12.344754407466572, 1.9077357267381794],
            [12.355985842248327, 1.9002381218571471],
            [12.359792394301474, 1.9019964573575683],
            [12.362557799648009, 1.9006929019749497],
            [12.370841501525483, 1.9027082485427451],
            [12.432456986642986, 1.9120766758271188],
            [12.468893903035404, 1.9180493581823925],
            [12.502352538684491, 1.9232464656626505],
            [12.503235517807697, 1.919335697929392],
            [12.508514653201386, 1.9203629763785857],
            [12.513223903658531, 1.9105876455518924],
            [12.520246878660997, 1.91009229187915],
            [12.519507321354055, 1.9046151156864175],
            [12.52297499189866, 1.9019846600286736],
            [12.528101896603522, 1.8959364614908973],
            [12.530726553297187, 1.897347616437452],
            [12.53466563577631, 1.8946312732389725],
            [12.540213621536775, 1.895267016241855],
            [12.54085204682062, 1.8901557727705536],
            [12.54685930460449, 1.8889418463222125],
            [12.547017352352116, 1.886410674313113],
            [12.55344356144373, 1.8829913843954955],
            [12.600116912787927, 1.8502417485048923],
            [12.604584064850854, 1.8440841406886976],
            [12.599235040640725, 1.843539206693103],
            [12.60577820692841, 1.8352158479332172],
            [12.609905072651529, 1.8338573212334504],
            [12.614015452815242, 1.8352602347176308],
            [12.624619619027772, 1.8324907524282092],
            [12.624265561161916, 1.8252128766168347],
            [12.62968123710265, 1.822441684773496],
            [12.630646723357474, 1.8187494597037137],
            [12.641303549645032, 1.8206524053154582],
            [12.64703027941853, 1.8165074726382562],
            [12.64743901429237, 1.8132436339123086],
            [12.65703693390805, 1.8101258149419743],
            [12.659890556810304, 1.8042596409474643],
            [12.664223330656599, 1.8034524608378075],
            [12.666988284394769, 1.8002282787053792],
            [12.690698053110168, 1.7935075217546423],
            [12.642069242769313, 1.7493056798579067],
            [12.634370772304557, 1.7317101077898125],
            [12.590262478092974, 1.7089101852270554],
            [12.580481037047903, 1.7219206956169428],
            [12.577456080960753, 1.7244462399910103],
            [12.57317466477043, 1.7250458038651018],
            [12.57069870692855, 1.7295767397560504],
            [12.566399528651552, 1.727897844052598],
            [12.564593701609265, 1.7209828876302156],
            [12.560639630246866, 1.7190402835181204],
            [12.506549280205649, 1.7011994679826854],
            [12.505713093406081, 1.7015564539974806],
            [12.49698194513731, 1.7056930548995677],
            [12.444450163369766, 1.7290260966460627],
            [12.436847751405404, 1.730629792097119],
            [12.43408365456008, 1.733168000983175],
            [12.429766169803864, 1.7288327731806492],
            [12.426091645373322, 1.7303161805646279],
            [12.352401570027059, 1.7349938416379642],
            [12.332021606144663, 1.7359749709432608],
            [12.323818728916361, 1.7369105697114902],
            [12.269047365559434, 1.7403973150585825],
            [12.268479777984002, 1.7511277785027117],
            [12.27009697518826, 1.7537764783848888],
            [12.274551214649806, 1.7559198118739228],
            [12.277888272116417, 1.7541593062638803],
            [12.283126947526018, 1.759838646387729],
            [12.28081914456816, 1.7659109214484099],
            [12.28340995806768, 1.7774982821561873],
            [12.278524001454526, 1.7795982888117992],
            [12.27163530032968, 1.7868485979686002],
            [12.265039796502496, 1.8008675569724086],
            [12.265029074972182, 1.8041940897747013],
            [12.262708150507052, 1.8098397606609375],
            [12.256223289187425, 1.8160568948856528],
            [12.256881164014368, 1.8186763645634803],
            [12.254293137963598, 1.8265408517700965],
            [12.250680968294898, 1.8327767538374862],
            [12.254873636380152, 1.8408834890621435],
            [12.252447505444579, 1.845548541111016],
            [12.256314722731414, 1.8475161846539458],
            [12.260789761670525, 1.8554101968108072],
            [12.25856620331029, 1.8587177923471376],
            [12.260091171681678, 1.8636517820202005],
            [12.2585492404656, 1.8665378457538848],
            [12.260461346523009, 1.8699804359979373],
            [12.272536877001366, 1.8752923622526416],
            [12.27586535415686, 1.8726950259378616],
            [12.281961865478575, 1.8739471523501667],
            [12.282283857004158, 1.8822917837190776],
            [12.279444345576826, 1.8864060559883316],
            [12.281495759362624, 1.8894265783127944],
            [12.28487849881565, 1.8886587449040695],
            [12.288142534855517, 1.8917028028530514],
            [12.289675252215966, 1.8983251427850245],
            [12.281171629396791, 1.9060958884437915],
            [12.285376517091057, 1.9112788390611237],
            [12.287020242916467, 1.916710808881721],
            [12.296570864001836, 1.9213339989760805],
            [12.302724658901509, 1.9215857264032352],
            [12.310517080674686, 1.9130913559640201],
            [12.314031122838124, 1.9151464960285962],
            [12.315521632323732, 1.9196010789268843]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.24336386807829, "lat": 39.50996402757609 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54049"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01718173"
      },
      "bbox": [
        12.250680968294898, 1.7011994679826854, 12.690698053110168,
        1.9232464656626505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9277884534630396, 4.840554438330911],
            [3.9986953539925234, 4.844387263610908],
            [4.010637233288233, 4.845276097939267],
            [4.055302984539064, 4.847634639483659],
            [4.09932323972516, 4.850384177675131],
            [4.15775225877293, 4.853382109798287],
            [4.208054885563112, 4.856120643377211],
            [4.2439139795160905, 4.857278164387901],
            [4.258912572715656, 4.859618515765637],
            [4.28338050860821, 4.859849718791011],
            [4.300780004585308, 4.859652131909766],
            [4.315380988289087, 4.8611925292827545],
            [4.317772804087959, 4.817966085407273],
            [4.319676408800025, 4.81773764989424],
            [4.323097778420078, 4.75957127603504],
            [4.325522082497939, 4.7101458199722765],
            [4.326470481301066, 4.685581377378203],
            [4.330822355919884, 4.610036753645709],
            [4.3221325598571845, 4.611320099472404],
            [4.314039727546472, 4.610298423387133],
            [4.308311009857567, 4.6051801063926],
            [4.308678151941659, 4.597705547638099],
            [4.301487726840292, 4.590665669127133],
            [4.293973738945615, 4.586154803534168],
            [4.2889405465242385, 4.5807141561790194],
            [4.285404726291218, 4.574529601052626],
            [4.2837653542524965, 4.566626232944779],
            [4.278689647171551, 4.558780885662263],
            [4.273051778745879, 4.558872404755634],
            [4.264023814066383, 4.549919035842441],
            [4.25560103034706, 4.5484437014169075],
            [4.247118757735697, 4.544888420985113],
            [4.242940892413363, 4.544096790809514],
            [4.2379165160364085, 4.541239675463429],
            [4.232403329353439, 4.5357786507122215],
            [4.2313210178816965, 4.529706130574727],
            [4.224510686635332, 4.52359678106083],
            [4.222393135373022, 4.520113937447298],
            [4.216400386240203, 4.517079220636466],
            [4.211107404263681, 4.517052169205467],
            [4.206319732137108, 4.508681176194511],
            [4.1998362447151605, 4.506935326023271],
            [4.196854327497789, 4.504920261932839],
            [4.187259295993845, 4.502380344243121],
            [4.179569165315766, 4.5028440989945855],
            [4.17298836566967, 4.499350950681878],
            [4.1686934456402005, 4.498458245200191],
            [4.164734650311895, 4.4941045670247535],
            [4.155999242878636, 4.491016767434968],
            [4.144517368174712, 4.493029836874157],
            [4.1387249817727465, 4.489253702430181],
            [4.13515759603366, 4.48236477226132],
            [4.130266026419295, 4.470607302687916],
            [4.123017328248422, 4.464793661212253],
            [4.121306660717214, 4.461551040505041],
            [4.113828334476922, 4.455560520570968],
            [4.107535814557093, 4.45168015511483],
            [4.098828343523805, 4.4503769935072715],
            [4.094122056493094, 4.44730600388609],
            [4.089062088097867, 4.437715421548556],
            [4.081494465250452, 4.431689455949425],
            [4.073685585874119, 4.428002952078286],
            [4.066928544327746, 4.427664005510442],
            [4.06024418239273, 4.4246800961393635],
            [4.057233480544981, 4.416911787400831],
            [4.051530975142619, 4.4145991133794436],
            [4.042720077406626, 4.416518519515964],
            [4.040968827141603, 4.41546021170163],
            [4.032699376207835, 4.416119769134381],
            [4.024838499324888, 4.421302943311082],
            [3.9993991734028635, 4.418785497833329],
            [3.9934946516847285, 4.413740748887067],
            [3.9906100447166786, 4.412613940158765],
            [3.9852331105419694, 4.407276348180408],
            [3.9845717670869325, 4.410560842018882],
            [3.975303048335875, 4.438149529628854],
            [3.969664977463491, 4.45722402489408],
            [3.966010725175734, 4.480457046919315],
            [3.964742116829608, 4.48579567913238],
            [3.966050111022711, 4.491438274040217],
            [3.965710139788604, 4.49871157197582],
            [3.9659820578869245, 4.5223340666116325],
            [3.9633806280490127, 4.537217317440512],
            [3.96271560992577, 4.547361153597211],
            [3.9643625016941573, 4.553254664081995],
            [3.967762047284341, 4.556155345422076],
            [3.977750514890249, 4.56224269732573],
            [3.984513394084496, 4.572079435881403],
            [3.9864216336447815, 4.576198394495659],
            [3.9890818705743856, 4.589960152041456],
            [3.9920979604627838, 4.594540981744009],
            [3.9984632731132264, 4.608392455099052],
            [3.9985573675540538, 4.614065986390447],
            [4.001667765287336, 4.621077757610824],
            [4.009446105756714, 4.62770906922166],
            [4.0290670833390205, 4.650470806926574],
            [4.0403898391606115, 4.666010200434333],
            [4.043192313618133, 4.676992601701091],
            [4.040066486938258, 4.6828332496567695],
            [4.0341607059151965, 4.6828484001657396],
            [4.032101676006859, 4.684604660223014],
            [4.032288406230293, 4.693905951105893],
            [4.021148443803267, 4.7138707932764525],
            [4.004411173013478, 4.734848915050221],
            [3.9879345185630863, 4.746746520033049],
            [3.981815801404388, 4.749850750872081],
            [3.96893290373547, 4.754277896323273],
            [3.9568744812739904, 4.75982406011695],
            [3.9493510090735393, 4.764416021899368],
            [3.9442798314523233, 4.765840402990931],
            [3.9342067299213963, 4.766837616388744],
            [3.9305840713614315, 4.770085705629238],
            [3.924019340657423, 4.783142064142642],
            [3.9248244359184254, 4.7874168466344775],
            [3.9298425200085476, 4.792561140833708],
            [3.934231377603913, 4.807680384118317],
            [3.934878932613338, 4.813226378255368],
            [3.932148554779872, 4.826274773692398],
            [3.9320560652367678, 4.830495868083614],
            [3.9277884534630396, 4.840554438330911]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.93106119619742, "lat": 43.23949582108719 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55023"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01581071"
      },
      "bbox": [
        3.924019340657423, 4.407276348180408, 4.330822355919884,
        4.8611925292827545
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9852331105419694, 4.407276348180408],
            [3.9906100447166786, 4.412613940158765],
            [3.9934946516847285, 4.413740748887067],
            [3.9993991734028635, 4.418785497833329],
            [4.024838499324888, 4.421302943311082],
            [4.032699376207835, 4.416119769134381],
            [4.040968827141603, 4.41546021170163],
            [4.042720077406626, 4.416518519515964],
            [4.051530975142619, 4.4145991133794436],
            [4.057233480544981, 4.416911787400831],
            [4.06024418239273, 4.4246800961393635],
            [4.066928544327746, 4.427664005510442],
            [4.073685585874119, 4.428002952078286],
            [4.081494465250452, 4.431689455949425],
            [4.089062088097867, 4.437715421548556],
            [4.094122056493094, 4.44730600388609],
            [4.098828343523805, 4.4503769935072715],
            [4.107535814557093, 4.45168015511483],
            [4.113828334476922, 4.455560520570968],
            [4.121306660717214, 4.461551040505041],
            [4.123017328248422, 4.464793661212253],
            [4.130266026419295, 4.470607302687916],
            [4.13515759603366, 4.48236477226132],
            [4.1387249817727465, 4.489253702430181],
            [4.144517368174712, 4.493029836874157],
            [4.155999242878636, 4.491016767434968],
            [4.164734650311895, 4.4941045670247535],
            [4.1686934456402005, 4.498458245200191],
            [4.17298836566967, 4.499350950681878],
            [4.179569165315766, 4.5028440989945855],
            [4.187259295993845, 4.502380344243121],
            [4.196854327497789, 4.504920261932839],
            [4.1998362447151605, 4.506935326023271],
            [4.206319732137108, 4.508681176194511],
            [4.211107404263681, 4.517052169205467],
            [4.216400386240203, 4.517079220636466],
            [4.222393135373022, 4.520113937447298],
            [4.224510686635332, 4.52359678106083],
            [4.2313210178816965, 4.529706130574727],
            [4.232403329353439, 4.5357786507122215],
            [4.2379165160364085, 4.541239675463429],
            [4.242940892413363, 4.544096790809514],
            [4.247118757735697, 4.544888420985113],
            [4.25560103034706, 4.5484437014169075],
            [4.264023814066383, 4.549919035842441],
            [4.273051778745879, 4.558872404755634],
            [4.278689647171551, 4.558780885662263],
            [4.2837653542524965, 4.566626232944779],
            [4.285404726291218, 4.574529601052626],
            [4.2889405465242385, 4.5807141561790194],
            [4.293973738945615, 4.586154803534168],
            [4.301487726840292, 4.590665669127133],
            [4.308678151941659, 4.597705547638099],
            [4.308311009857567, 4.6051801063926],
            [4.314039727546472, 4.610298423387133],
            [4.3221325598571845, 4.611320099472404],
            [4.330822355919884, 4.610036753645709],
            [4.338218955733773, 4.610507493264275],
            [4.349442806980947, 4.618636012044983],
            [4.353754182607465, 4.618853643317881],
            [4.363968036858485, 4.624338351032281],
            [4.372187041573149, 4.626009384471022],
            [4.385580535602176, 4.642139626840524],
            [4.390204674376112, 4.644990638802209],
            [4.403710097605982, 4.64902266928971],
            [4.407513628784741, 4.649453618795339],
            [4.416449439931198, 4.654705492514281],
            [4.419947612618882, 4.654696159266132],
            [4.424687198008311, 4.651992423208249],
            [4.4348132944603185, 4.651012658794306],
            [4.4451989515651515, 4.653801714168868],
            [4.452355913804767, 4.651454035374538],
            [4.460195546440885, 4.6511868870120825],
            [4.46463972600068, 4.649474250917162],
            [4.475259933119101, 4.648444664006903],
            [4.484081801983709, 4.649352304833442],
            [4.493959584131053, 4.647320840608749],
            [4.5007316817423755, 4.6490303097503505],
            [4.5024092335866115, 4.624112599133457],
            [4.505533762247031, 4.5663761240104925],
            [4.511605709253507, 4.479418429259163],
            [4.513459550254736, 4.4505368304543005],
            [4.516441667464533, 4.399467268390863],
            [4.520618823258293, 4.340710202284009],
            [4.52341219334573, 4.294286684691264],
            [4.525717193807661, 4.260762822219859],
            [4.527819151302744, 4.231809298275148],
            [4.535038557077644, 4.11510090666482],
            [4.53752851652264, 4.071470274676811],
            [4.540643796916766, 4.0201383189419175],
            [4.544131832376999, 3.9544195179305963],
            [4.496319476805739, 3.952203373290105],
            [4.4494169017248195, 3.949388727757112],
            [4.404138694351501, 3.947384445463459],
            [4.385750629327054, 3.946753194607181],
            [4.39036987645043, 3.953980149277714],
            [4.390186761395203, 3.957291269946674],
            [4.3854065987229705, 3.9679946844185765],
            [4.383101731937818, 3.978157554432355],
            [4.38065611855543, 3.982542739671318],
            [4.375155001708993, 3.98780597245545],
            [4.371048349397514, 3.9956191684105846],
            [4.368723864444179, 4.005642716981564],
            [4.354921757883071, 4.018446822310281],
            [4.348791916830914, 4.028430486544873],
            [4.347626608261507, 4.035829058260535],
            [4.3423845965108585, 4.050928848500358],
            [4.337487137886971, 4.058649868162975],
            [4.3351413100928315, 4.066857750831702],
            [4.330073848027983, 4.071925678368402],
            [4.321778596865963, 4.076169410456324],
            [4.313655794629907, 4.078412209334765],
            [4.304380555145973, 4.080033388665898],
            [4.285209606468988, 4.084890654448231],
            [4.271403425814344, 4.086590918224918],
            [4.264883522995127, 4.08812787739911],
            [4.223898431868165, 4.094995630741899],
            [4.213011208120218, 4.098333445672755],
            [4.1979914787758945, 4.101285980442968],
            [4.190931982465306, 4.103713343560488],
            [4.178477009681959, 4.110771888679668],
            [4.172686905050235, 4.112931939096705],
            [4.1612013671010795, 4.110303198746591],
            [4.149806807377635, 4.113093831065875],
            [4.140246150193998, 4.119074331144444],
            [4.133435428848902, 4.1207403459955705],
            [4.128614085891687, 4.12418700588759],
            [4.122114773143222, 4.133684306575025],
            [4.116920604460896, 4.13841521372904],
            [4.106341400549574, 4.144309853735975],
            [4.100783259510339, 4.143459054684304],
            [4.093575723389574, 4.14776656907668],
            [4.091322747266798, 4.1502070998351055],
            [4.089225051559827, 4.157844383587853],
            [4.086592433859291, 4.160576631628157],
            [4.080167819739377, 4.161512917837747],
            [4.075049177232609, 4.159635067939449],
            [4.072293830615978, 4.163036604530079],
            [4.072069773481558, 4.167201596425091],
            [4.067857972301452, 4.172805226860027],
            [4.064549266650775, 4.173068671538234],
            [4.063635406685303, 4.179217188697834],
            [4.066547994519951, 4.1802653751745655],
            [4.067199091014576, 4.1841902319813356],
            [4.060023854097604, 4.191635497748292],
            [4.058168382870189, 4.2049771686825785],
            [4.054354793455711, 4.2172988700258935],
            [4.051873209735334, 4.2282807666640005],
            [4.050269315632482, 4.242042919096755],
            [4.050358288896139, 4.249449458696912],
            [4.047249690023371, 4.251598104495952],
            [4.041924815145665, 4.250580039614426],
            [4.038985853205679, 4.252011565689082],
            [4.038002938743635, 4.256132352926128],
            [4.039932152486227, 4.271191420938312],
            [4.034860654083336, 4.280984915636286],
            [4.033777593930225, 4.28549894263034],
            [4.033611247534472, 4.296916560643059],
            [4.031540748571291, 4.304121271019501],
            [4.022688817728718, 4.311771829970787],
            [4.018625241264393, 4.316271268682216],
            [4.00323995796062, 4.323452588288813],
            [3.9992842754824958, 4.324152515796027],
            [3.9969802953886022, 4.329236745494542],
            [3.9980978221367276, 4.340134666860379],
            [3.997474664770575, 4.346073500998572],
            [3.992797697694515, 4.3595432492488575],
            [3.9929784750586212, 4.36588817463625],
            [3.995047827531874, 4.375989956258827],
            [3.9939629024301357, 4.382797185730792],
            [3.9859245676992687, 4.397328363718743],
            [3.9852331105419694, 4.407276348180408]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.70619987806438, "lat": 42.86749883914524 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55043"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01581081"
      },
      "bbox": [
        3.9852331105419694, 3.946753194607181, 4.544131832376999,
        4.654705492514281
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.525717193807661, 4.260762822219859],
            [4.563382339023799, 4.263441332958576],
            [4.6546484641281785, 4.2703001446010225],
            [4.693532518399646, 4.2727544595893],
            [4.770317491196824, 4.2765299668996315],
            [4.7992341883274765, 4.27850203971745],
            [4.810818649410921, 4.278931535040005],
            [4.828735507289458, 4.28027474573298],
            [4.872027932160296, 4.282428532645046],
            [4.927324809540237, 4.285862335135504],
            [4.954008819959456, 4.2881043372322],
            [4.956729080760781, 4.244577686115869],
            [4.958026075805982, 4.229934314067496],
            [4.963385181910031, 4.157384316013191],
            [4.967186445785692, 4.092104693807571],
            [4.967551529710886, 4.089445941960447],
            [4.974702941863809, 3.9794474197184595],
            [4.9097161594812695, 3.9755145206577724],
            [4.888654485504942, 3.9740110975493192],
            [4.856389487810362, 3.973264440714247],
            [4.801944723596657, 3.9712211378898066],
            [4.786372268999952, 3.9698606482693584],
            [4.735639724358197, 3.967119993919511],
            [4.705176636783515, 3.9647303172026684],
            [4.672618293690969, 3.962528147489869],
            [4.633722069257277, 3.960136587592871],
            [4.59073120776115, 3.957152999928944],
            [4.559096463000489, 3.9551282184293055],
            [4.544131832376999, 3.9544195179305963],
            [4.540643796916766, 4.0201383189419175],
            [4.53752851652264, 4.071470274676811],
            [4.535038557077644, 4.11510090666482],
            [4.527819151302744, 4.231809298275148],
            [4.525717193807661, 4.260762822219859]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.13172212318575, "lat": 42.66048270293598 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55065"],
        "coty_name": ["Lafayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lafayette County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01581092"
      },
      "bbox": [
        4.525717193807661, 3.9544195179305963, 4.974702941863809,
        4.2881043372322
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.565475421097508, 5.006998339532692],
            [4.593951042741577, 5.0087854302195085],
            [4.623184301050059, 5.011243801734146],
            [4.651182983032881, 5.013176227168925],
            [4.651812911786896, 5.00049549125782],
            [4.656690413578552, 4.925658768027933],
            [4.66193441818088, 4.838413025188519],
            [4.6639178972359945, 4.813418090364378],
            [4.66483981357166, 4.790127253354704],
            [4.666341843441983, 4.77060171035075],
            [4.669606650834623, 4.70721178191259],
            [4.674581394032506, 4.6248537199146424],
            [4.67381109878951, 4.622753790846029],
            [4.655435797328639, 4.630439877203187],
            [4.649608560802737, 4.634139886441133],
            [4.637405944510595, 4.645349498843664],
            [4.630305090546257, 4.648117596462536],
            [4.623365208536779, 4.653129409779494],
            [4.617369018052229, 4.6517776399881035],
            [4.610783019331816, 4.648678567547215],
            [4.606128531655516, 4.650546117903569],
            [4.604855495206587, 4.655300700768515],
            [4.599758236916485, 4.660833674244631],
            [4.594401923923509, 4.661999381414579],
            [4.586467156515994, 4.659795603027398],
            [4.578699209617189, 4.659889098676515],
            [4.568490563701382, 4.661805466545417],
            [4.556080326901618, 4.660961129507618],
            [4.55371543914944, 4.659619571716215],
            [4.543054455700455, 4.657058635182085],
            [4.531535673951031, 4.653188219833974],
            [4.526403009447283, 4.652659116222298],
            [4.515295363820113, 4.649085638362691],
            [4.507503850395445, 4.650253689656502],
            [4.5007316817423755, 4.6490303097503505],
            [4.493959584131053, 4.647320840608749],
            [4.484081801983709, 4.649352304833442],
            [4.475259933119101, 4.648444664006903],
            [4.46463972600068, 4.649474250917162],
            [4.460195546440885, 4.6511868870120825],
            [4.452355913804767, 4.651454035374538],
            [4.4451989515651515, 4.653801714168868],
            [4.4348132944603185, 4.651012658794306],
            [4.424687198008311, 4.651992423208249],
            [4.419947612618882, 4.654696159266132],
            [4.416449439931198, 4.654705492514281],
            [4.407513628784741, 4.649453618795339],
            [4.403710097605982, 4.64902266928971],
            [4.390204674376112, 4.644990638802209],
            [4.385580535602176, 4.642139626840524],
            [4.372187041573149, 4.626009384471022],
            [4.363968036858485, 4.624338351032281],
            [4.353754182607465, 4.618853643317881],
            [4.349442806980947, 4.618636012044983],
            [4.338218955733773, 4.610507493264275],
            [4.330822355919884, 4.610036753645709],
            [4.326470481301066, 4.685581377378203],
            [4.325522082497939, 4.7101458199722765],
            [4.323097778420078, 4.75957127603504],
            [4.319676408800025, 4.81773764989424],
            [4.317772804087959, 4.817966085407273],
            [4.315380988289087, 4.8611925292827545],
            [4.3130028170647705, 4.90445552760809],
            [4.308563262872092, 4.953296896355297],
            [4.305839604965898, 4.990852759718327],
            [4.410023622341277, 4.996749685156885],
            [4.446154645058131, 4.999374481985073],
            [4.526394468683594, 5.004791685142476],
            [4.565475421097508, 5.006998339532692]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.42946435556243, "lat": 43.37563532753602 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55103"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richland County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01581112"
      },
      "bbox": [
        4.305839604965898, 4.610036753645709, 4.674581394032506,
        5.013176227168925
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5819891790422798, 7.034302820616423],
            [3.66633797835175, 7.0384668390235925],
            [3.6982036315553257, 7.040784427703593],
            [3.751187280686439, 7.0438079503068876],
            [3.7797314103334494, 7.045286202438355],
            [3.8371296001143484, 7.047630412870551],
            [3.8815063091941013, 7.050316001555937],
            [3.9244905838885678, 7.0523918379662085],
            [4.011160331015876, 7.057165423235882],
            [4.0969475006344, 7.061142284056972],
            [4.183770434426221, 7.065715213611977],
            [4.186131293850556, 7.0145731948951795],
            [4.188968959485075, 6.962633532458647],
            [4.191369530471636, 6.929758664350164],
            [4.1924006275111365, 6.922438567498101],
            [4.198322387811591, 6.807674281004103],
            [4.111653739112947, 6.803145972858768],
            [4.097311470775084, 6.802681272297973],
            [4.068691556822421, 6.8012442902991666],
            [4.025364274286063, 6.799707878257845],
            [4.030109708241462, 6.713114531329013],
            [3.950930627945064, 6.708741657602223],
            [3.89986403663401, 6.7063725873747835],
            [3.813023289707011, 6.701865786492891],
            [3.7253921582790253, 6.697232126290882],
            [3.6836395023888917, 6.695515202419435],
            [3.6404152962985687, 6.69306523930048],
            [3.5974691850321516, 6.69170468013588],
            [3.597036475402883, 6.70609924965134],
            [3.591813452499953, 6.813674384793537],
            [3.591175485976477, 6.837594027277745],
            [3.589995335072977, 6.863394159533675],
            [3.586402772444838, 6.949220468741302],
            [3.585809095835101, 6.965531985471738],
            [3.5819891790422798, 7.034302820616423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.13315284322343, "lat": 45.47515838876862 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55107"],
        "coty_name": ["Rusk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rusk County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01581114"
      },
      "bbox": [
        3.5819891790422798, 6.69170468013588, 4.198322387811591,
        7.065715213611977
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.723871149687173, 4.371300506197041],
            [5.727754878961383, 4.371727236797949],
            [5.781263330406695, 4.3756213259971934],
            [5.845919707032641, 4.380439247498705],
            [5.895034585700024, 4.384811806925715],
            [5.951760103679089, 4.388874294297419],
            [5.98042616127558, 4.391148413877938],
            [6.038711570463971, 4.396080838030221],
            [6.065977647740218, 4.397520248388595],
            [6.067252068885205, 4.376974714331286],
            [6.071802995611693, 4.310836263067262],
            [6.077403774912421, 4.253130857534233],
            [6.080440484884064, 4.224217611397263],
            [6.080860037502163, 4.215040103091215],
            [6.085151223682826, 4.166282647639188],
            [6.095470056078049, 4.050256931797395],
            [6.016304318794681, 4.043744611744654],
            [5.981042599290867, 4.040933928142193],
            [5.947779634142451, 4.038571486346149],
            [5.851543209743163, 4.031215503809351],
            [5.801423424050136, 4.025886483980116],
            [5.759214224762542, 4.021133991544124],
            [5.751013480585482, 4.020465496905626],
            [5.746128714764736, 4.0839932539418475],
            [5.744870241617313, 4.103679198814595],
            [5.742043692423347, 4.140758641602881],
            [5.739021632071269, 4.176700193347521],
            [5.737617245043638, 4.196121286806046],
            [5.734875779439794, 4.223159948134726],
            [5.7292774407655385, 4.283245648447909],
            [5.726331027916396, 4.334106515395362],
            [5.723871149687173, 4.371300506197041]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.54197020228183,
          "lat": 42.668486829284376
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55127"],
        "coty_name": ["Walworth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walworth County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01581123"
      },
      "bbox": [
        5.723871149687173, 4.020465496905626, 6.095470056078049,
        4.397520248388595
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.9413266412249275, 5.0924724868225235],
            [6.027250439213576, 5.098693762913505],
            [6.113653607994577, 5.105852759316272],
            [6.157981211636698, 5.108936700865265],
            [6.200237739608334, 5.112452570181029],
            [6.2097799377120095, 4.995560120414778],
            [6.2152946631065, 4.93846403005565],
            [6.199165915369154, 4.936520201724203],
            [6.203812700978815, 4.877191784082441],
            [6.209133128845224, 4.805051352990202],
            [6.213182729238676, 4.76164356516031],
            [6.177160881735317, 4.758431282491944],
            [6.1603905626789075, 4.757145859302435],
            [6.10044587718307, 4.753272639463975],
            [6.06649152379124, 4.750707754133363],
            [6.027683722293987, 4.7472883875203715],
            [5.984694376873123, 4.744425392051748],
            [5.956631114798922, 4.743317516209683],
            [5.951483663503963, 4.801420584380434],
            [5.948757550300748, 4.830340262033917],
            [5.945650706718621, 4.873650642765352],
            [5.94225042405089, 4.918475142989087],
            [5.954441270860909, 4.919342704608526],
            [5.948105183830825, 5.005917590604737],
            [5.944309086055626, 5.054884921713592],
            [5.941773257533132, 5.0843830572748105],
            [5.9413266412249275, 5.0924724868225235]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.23072405722716,
          "lat": 43.368472607620824
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55131"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01581125"
      },
      "bbox": [
        5.9413266412249275, 4.743317516209683, 6.2152946631065,
        5.112452570181029
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.149471810684, "lat": 18.10297600020095 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72035"],
        "coty_name": ["Cayey"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Cayey Municipio"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01804497"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.75428113764853, "lat": 18.23081932189339 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72103"],
        "coty_name": ["Naguabo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Naguabo Municipio"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01804532"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.94334925647225,
          "lat": 18.083623039161633
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72121"],
        "coty_name": ["Sabana Grande"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Sabana Grande Municipio"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01804541"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.06064732012037,
          "lat": 18.386931539975187
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72127"],
        "coty_name": ["San Juan"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["San Juan Municipio"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01804544"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.663702093115211, -0.8749394161269655],
            [2.66478367959666, -0.7723806888394813],
            [2.7324648364028152, -0.7717483464520775],
            [2.7509009152354436, -0.7713988218821319],
            [2.771966161086878, -0.7718540329061898],
            [2.821506363288232, -0.7724509885650535],
            [2.9206525782377866, -0.7729365350458054],
            [2.920932447307408, -0.8459865597873859],
            [2.921680409872415, -0.8837547137709143],
            [2.9225159077809213, -0.904994927427732],
            [2.922936007242284, -0.9491487925931396],
            [2.9336148581114196, -0.9489971810899522],
            [2.9336959515737075, -0.9943133923596581],
            [2.934102973170922, -1.0459600323692844],
            [2.934341913137885, -1.0478169386293068],
            [2.9350293116120074, -1.117854420850481],
            [2.9359021190140644, -1.1884057394253833],
            [2.9351734058021144, -1.1885288573215256],
            [2.853999603087929, -1.189301947385919],
            [2.836542941453599, -1.1898769382152186],
            [2.764490786530115, -1.1903754371331674],
            [2.7653327345448977, -1.2635319132214098],
            [2.7291737374317933, -1.2639973287845743],
            [2.698524563476437, -1.263731274453758],
            [2.67948506567363, -1.2638890975042487],
            [2.6791183171716546, -1.2339152950554364],
            [2.6783124017292224, -1.1464751793029793],
            [2.678324175101337, -1.1050059884974663],
            [2.678075279719275, -1.1028124459386583],
            [2.677744037329288, -1.0442488001480208],
            [2.677762801002212, -1.0202069248724148],
            [2.677456399637195, -1.0144119793863453],
            [2.6774184099830287, -0.9483504387628177],
            [2.663162011565928, -0.9484175938195506],
            [2.663702093115211, -0.8749394161269655]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.02367081525279, "lat": 37.68043142342992 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29059"],
        "coty_name": ["Dallas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dallas County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00758484"
      },
      "bbox": [
        2.663162011565928, -1.2639973287845743, 2.9359021190140644,
        -0.7713988218821319
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9977409679533678, -1.6536198454222693],
            [1.9978580835397695, -1.5656983253246421],
            [1.99820099656073, -1.4479783061294376],
            [1.9981862596879005, -1.4093399811061946],
            [2.0827160955140402, -1.4098119222241874],
            [2.1676319904808095, -1.4093578240343183],
            [2.247892469659207, -1.409700061861825],
            [2.273135227224442, -1.4095942640662893],
            [2.2964417046462966, -1.4098414055417858],
            [2.3343111703136588, -1.409844185745928],
            [2.3506690899727882, -1.4099679939991223],
            [2.351185965198278, -1.4488006383780987],
            [2.3513959826146085, -1.491945498558679],
            [2.3523292039665096, -1.5950363156609608],
            [2.3534571570594554, -1.6763256801578352],
            [2.353958401177456, -1.6983218901303616],
            [2.3551168578955877, -1.7719679551231875],
            [2.2694426030896726, -1.7712233251602605],
            [2.1836759749095838, -1.771770372511061],
            [2.097530112465866, -1.7718453713102784],
            [2.068894882463805, -1.771434918666898],
            [1.9973464377548011, -1.771079565249968],
            [1.9972811228777942, -1.7499448262671793],
            [1.9977409679533678, -1.6536198454222693]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.83297017615601, "lat": 37.10637539146503 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29109"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00758509"
      },
      "bbox": [
        1.9972811228777942, -1.7719679551231875, 2.3551168578955877,
        -1.4093399811061946
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.139430247470023, 1.9128870946434975],
            [2.1632078624400553, 1.9133807139159187],
            [2.2026627578170115, 1.9146882976968225],
            [2.2283357995545727, 1.9157975954479307],
            [2.3030410294189423, 1.9195771516645355],
            [2.327703846165428, 1.9204632337150522],
            [2.3897069367945685, 1.9215349323702333],
            [2.4404103524136342, 1.9233390984759569],
            [2.4405559124369485, 1.8954262511318285],
            [2.44308639783528, 1.8147044257404383],
            [2.4490263848832883, 1.814103109214807],
            [2.4515326376073174, 1.7246011929763203],
            [2.452890946763005, 1.6657890783711964],
            [2.4545827452702778, 1.606964661393974],
            [2.419193161875063, 1.6053969098403527],
            [2.3548512501140597, 1.6030639584192785],
            [2.3540731875959877, 1.60267422921548],
            [2.3006221296492297, 1.6015376997916189],
            [2.2605703366406753, 1.6001198398000593],
            [2.2595824562440647, 1.5996603241004623],
            [2.2390853755668267, 1.599224844562938],
            [2.197256338375393, 1.597656180008844],
            [2.155170325936059, 1.596949236518017],
            [2.154349836185406, 1.6258209246995947],
            [2.152588488863404, 1.6993117120055554],
            [2.1519692286052416, 1.7088668319518885],
            [2.149089832414509, 1.8071509870498843],
            [2.1417623081414296, 1.806812676505308],
            [2.140838367478982, 1.8374601748911905],
            [2.1407080289132834, 1.8591735383536223],
            [2.139430247470023, 1.9128870946434975]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.56856215869745,
          "lat": 40.422317914219725
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29129"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00758519"
      },
      "bbox": [
        2.139430247470023, 1.596949236518017, 2.4545827452702778,
        1.9233390984759569
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4404103524136342, 1.9233390984759569],
            [2.4831366186716535, 1.9248713895796228],
            [2.526027431852093, 1.9262214660684207],
            [2.6198975216765437, 1.93106253822557],
            [2.6488400099141467, 1.933110344514288],
            [2.6576922110201373, 1.9337735234562516],
            [2.7658882915504903, 1.9405412291577646],
            [2.7945164426154716, 1.9415859889247162],
            [2.8128348178307756, 1.9426701737503989],
            [2.9044394738805783, 1.9463080639753436],
            [2.936626347711642, 1.9480751236720035],
            [2.933664497211953, 1.941157694812171],
            [2.939997069394891, 1.9417719767438],
            [2.946217720766172, 1.9397501374910764],
            [2.9472723464981376, 1.93673932581092],
            [2.9467046164494493, 1.9296795750583038],
            [2.954267053930501, 1.930036156205154],
            [2.9542335087832603, 1.9264569218619572],
            [2.9361380415802665, 1.9201704165520361],
            [2.935496156053524, 1.9165469637590227],
            [2.9406177137943863, 1.9155477738649789],
            [2.952173671938448, 1.919368304137516],
            [2.9551467116448746, 1.9236480260209625],
            [2.958081119049285, 1.9231500120848561],
            [2.9613993628610653, 1.9193668228695777],
            [2.9604617563818545, 1.9112547907204398],
            [2.9528440968412237, 1.9072953442909473],
            [2.951677324707415, 1.901207082239753],
            [2.9460156308661847, 1.891106166665868],
            [2.950251653955901, 1.8863382038583727],
            [2.9595566337100085, 1.8827375830660709],
            [2.9686535158276297, 1.8825245527753307],
            [2.9720436061371744, 1.8786724369540175],
            [2.9668145947646156, 1.8749575486138192],
            [2.962893618868618, 1.8778219108061134],
            [2.9618087312724106, 1.8739292976675779],
            [2.962999611151137, 1.8702542688574753],
            [2.9629725789922152, 1.8638814341258305],
            [2.9678027400307707, 1.8544104395878156],
            [2.962197447496841, 1.8478669219483106],
            [2.9541213335466145, 1.8454156646555617],
            [2.952905135084529, 1.837501117698313],
            [2.9482090370182124, 1.8321191755410802],
            [2.9514676622004634, 1.8274762952671832],
            [2.950237415228724, 1.823878239475531],
            [2.9515344212053756, 1.821037782352095],
            [2.945583681925478, 1.8185906994427885],
            [2.9456926461098627, 1.8141623323989897],
            [2.9484079447405587, 1.8134482622733197],
            [2.951475374695446, 1.8071833201818044],
            [2.9456141749458036, 1.8034469043554728],
            [2.9462080142594322, 1.7993802894577844],
            [2.9508850608346218, 1.797534605920905],
            [2.954657144694083, 1.7911326484588554],
            [2.9525879625360334, 1.7863046026550067],
            [2.9582996410902447, 1.7806864206473954],
            [2.966253341835594, 1.7763464879037374],
            [2.9697723230971853, 1.7765369696742255],
            [2.972251728711869, 1.7715444470893529],
            [2.975825028249121, 1.7682752829382289],
            [2.9722432463123503, 1.759446343376859],
            [2.9785698651546255, 1.756964744567378],
            [2.9799111585382434, 1.7548181959055513],
            [2.9742616839807465, 1.7501876833971022],
            [2.9726124343734432, 1.7534092697281476],
            [2.9649965390719704, 1.7520344302775948],
            [2.966029898947137, 1.7418421064499972],
            [2.964563165543373, 1.7378890838666265],
            [2.968155824257145, 1.7337320742145468],
            [2.9657737759396423, 1.7248259707535336],
            [2.9682884885284215, 1.7195072197415506],
            [2.966672121949896, 1.7084823970205987],
            [2.968948156440571, 1.7029362448625995],
            [2.968181593451299, 1.700882271915159],
            [2.92333242025776, 1.6983377592225344],
            [2.838749616093096, 1.6957471002067324],
            [2.837547822546875, 1.7392531734958907],
            [2.7628014053860497, 1.735860784639924],
            [2.751518874424637, 1.735551630366457],
            [2.6650131098700443, 1.7343146896204396],
            [2.599958920745097, 1.7314224077632991],
            [2.580300798678801, 1.7307511166999066],
            [2.4946294590002402, 1.726317305434873],
            [2.4515326376073174, 1.7246011929763203],
            [2.4490263848832883, 1.814103109214807],
            [2.44308639783528, 1.8147044257404383],
            [2.4405559124369485, 1.8954262511318285],
            [2.4404103524136342, 1.9233390984759569]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.01616135678863, "lat": 40.47891127218997 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29171"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00758540"
      },
      "bbox": [
        2.4404103524136342, 1.6957471002067324, 2.9799111585382434,
        1.9480751236720035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6008605370741678, -1.8723685262874623],
            [2.73031038174927, -1.8714973143110025],
            [2.8070716612537123, -1.8710579058254384],
            [2.8565185767789947, -1.8706764637180402],
            [2.9141861861447116, -1.8705944799555925],
            [2.9569710527755895, -1.870428100850184],
            [3.0287900737069964, -1.869892021940513],
            [3.0294455741863637, -1.9205707406292398],
            [3.0307385384104966, -1.9936339002366952],
            [3.0316142276167626, -2.058239384648696],
            [3.033443277537629, -2.1809970735778603],
            [2.9806775277727535, -2.182460100860655],
            [2.9684345008596584, -2.1829633311674224],
            [2.936610033620041, -2.184143662421095],
            [2.797749767129029, -2.188148695895679],
            [2.7519850919357904, -2.189948530349887],
            [2.6189279720286973, -2.193357147308276],
            [2.6012508204953066, -2.193792387163512],
            [2.6008959208407822, -2.134082229420346],
            [2.6003975826844288, -2.078147187702431],
            [2.6000125092363264, -2.050890344960169],
            [2.5998652630015964, -2.0176990510508412],
            [2.5993158904661815, -1.9878359266007966],
            [2.599220627924959, -1.9601061306146605],
            [2.6006874188561184, -1.9600777309545216],
            [2.600912981448865, -1.9159344131484926],
            [2.6008605370741678, -1.8723685262874623]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.04113308720109, "lat": 36.65475816277468 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29213"],
        "coty_name": ["Taney"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taney County"],
        "coty_fp_code": "213",
        "coty_gnis_code": "00758559"
      },
      "bbox": [
        2.599220627924959, -2.193792387163512, 3.033443277537629,
        -1.869892021940513
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.951108298523955, 8.571002714381581],
            [-10.948341739618305, 8.582483199833115],
            [-10.949632322653082, 8.593391883795423],
            [-10.95519339595935, 8.602584741700696],
            [-10.95198208768985, 8.608059213546507],
            [-10.952143777550514, 8.610400043930548],
            [-10.94233488328714, 8.61119451853481],
            [-10.937691139324471, 8.617034791357666],
            [-10.93175497740315, 8.621119082994394],
            [-10.93040744791678, 8.624688327508673],
            [-10.922828952363071, 8.631265346434004],
            [-10.92144771771863, 8.63528018797938],
            [-10.91725398857639, 8.630010579343034],
            [-10.912627632898577, 8.62888290926807],
            [-10.908471392502182, 8.63057383251506],
            [-10.902721761586534, 8.627072059421817],
            [-10.899244084384518, 8.632359771178876],
            [-10.896997742005425, 8.637960981098054],
            [-10.8915470676673, 8.637254553692221],
            [-10.888569850206542, 8.634401812149099],
            [-10.880118288304944, 8.63386546146804],
            [-10.876126912290477, 8.621130586615068],
            [-10.868937954105798, 8.619956323860695],
            [-10.86493850001671, 8.624437403246572],
            [-10.86499138150653, 8.633689712221283],
            [-10.863462686851802, 8.64010123104847],
            [-10.860148996986217, 8.64135758991439],
            [-10.85299931025435, 8.639351589811946],
            [-10.848934108687255, 8.643150599279206],
            [-10.844896654708359, 8.644368733826868],
            [-10.845299620951481, 8.651810985782724],
            [-10.842981272923673, 8.655566057473546],
            [-10.834745681505701, 8.656687760775448],
            [-10.83584174471205, 8.662019705457945],
            [-10.828300174745111, 8.665657837085439],
            [-10.824765635815925, 8.670027020911002],
            [-10.822037264831033, 8.669953225886008],
            [-10.818342865714795, 8.666840700239856],
            [-10.81291536880775, 8.664757177763722],
            [-10.804488390105615, 8.66704218101719],
            [-10.792401535768718, 8.661974780909622],
            [-10.7884164602921, 8.6622739595777],
            [-10.78338186022139, 8.66790835567346],
            [-10.782687077370852, 8.67132366007668],
            [-10.779579755829984, 8.673238964413923],
            [-10.776096986207168, 8.679171669932508],
            [-10.76979608303986, 8.682006164950092],
            [-10.765630673516814, 8.685334293086948],
            [-10.757165623704644, 8.690254953920324],
            [-10.755360100450932, 8.692730086789805],
            [-10.752422614003507, 8.69397978663121],
            [-10.750589940462657, 8.690895490139349],
            [-10.745236047318693, 8.69196786554564],
            [-10.739203406802336, 8.690672421209944],
            [-10.738991719672939, 8.687417622777794],
            [-10.73390673069708, 8.687243307278422],
            [-10.728800187195455, 8.681974227023566],
            [-10.724659930732733, 8.684296264837508],
            [-10.717185676869319, 8.686178230124577],
            [-10.714734375240054, 8.688027741647089],
            [-10.708885723378783, 8.686112298434132],
            [-10.698753329723486, 8.692640551900293],
            [-10.695949681468063, 8.692787913263881],
            [-10.691278917138284, 8.696786606562267],
            [-10.685480155245926, 8.71005658237218],
            [-10.680912651628079, 8.70751255108984],
            [-10.673942139259694, 8.709535002764104],
            [-10.66623495413108, 8.707221163046997],
            [-10.657913813218638, 8.711287874220343],
            [-10.657041963559626, 8.714746158759429],
            [-10.657831883434238, 8.725899114714679],
            [-10.661269405037551, 8.72909437828442],
            [-10.661832117475972, 8.732345105583336],
            [-10.668308412950553, 8.73369231079903],
            [-10.672280620894236, 8.73729314330269],
            [-10.669530250843717, 8.742644220565348],
            [-10.6706702310004, 8.756863466919501],
            [-10.666892028536376, 8.754703768842148],
            [-10.66352554887606, 8.756173975471334],
            [-10.655501770095094, 8.755641827774182],
            [-10.650422165025748, 8.759111148379375],
            [-10.63597001253352, 8.761941701535639],
            [-10.633093827539764, 8.761895706587335],
            [-10.624533419417016, 8.767638394175773],
            [-10.617011650563056, 8.768087418909936],
            [-10.610370751384943, 8.761608638708061],
            [-10.606028106330841, 8.763816798566559],
            [-10.603770704985083, 8.761761433784867],
            [-10.5909128944801, 8.759594675151202],
            [-10.585536994358208, 8.759409322153886],
            [-10.57736016841907, 8.762074355381678],
            [-10.5749315974233, 8.764861210813665],
            [-10.569665184029198, 8.76371395191456],
            [-10.56468053815947, 8.768600836950458],
            [-10.556763833230333, 8.771733447420582],
            [-10.554919002343658, 8.771345725134092],
            [-10.546266525928555, 8.779172609172143],
            [-10.542394883477714, 8.786248200889558],
            [-10.54094974378963, 8.792958369511453],
            [-10.542551051563079, 8.80040677249558],
            [-10.53898813901835, 8.803608368967273],
            [-10.511139964155811, 8.799323306028068],
            [-10.461482130209246, 8.79123244431228],
            [-10.446635147475988, 8.788633085544557],
            [-10.37479738279332, 8.776851441811518],
            [-10.38851550762602, 8.695491422281382],
            [-10.3874540485523, 8.695338501730001],
            [-10.416421364780144, 8.524548689739488],
            [-10.445197221580926, 8.355278101340456],
            [-10.443836860526384, 8.355064499976873],
            [-10.453116214836818, 8.29926135349178],
            [-10.458197912398528, 8.270833339085174],
            [-10.373182281817202, 8.256165289035383],
            [-10.380262640940344, 8.213519364450391],
            [-10.394300820676046, 8.130025899944016],
            [-10.401538929269266, 8.085639235484797],
            [-10.408265917399467, 8.04576745230569],
            [-10.409837083235093, 8.041160453336625],
            [-10.41569017296408, 8.037994676884924],
            [-10.424514919178268, 8.036492484094804],
            [-10.428029033777698, 8.03119279946737],
            [-10.432183053814333, 8.030369519422141],
            [-10.43405516436289, 8.024867164933712],
            [-10.43681469120889, 8.022792939087541],
            [-10.439603017992953, 8.017871909290433],
            [-10.44571090623898, 8.014068632877917],
            [-10.460899744402255, 8.014301593438459],
            [-10.46372711850572, 8.019139774327414],
            [-10.467955751735795, 8.019784244474986],
            [-10.472273346347391, 8.024334788561497],
            [-10.47899047444179, 8.028094440441524],
            [-10.48517576445867, 8.024794976341406],
            [-10.492144112094262, 8.02467539594571],
            [-10.503191227873042, 8.02035000935814],
            [-10.506437655304705, 8.023495415444573],
            [-10.512033956245284, 8.024675876898744],
            [-10.513966350083656, 8.027952472970696],
            [-10.514536856067883, 8.03401931291181],
            [-10.513436143987947, 8.039218337722309],
            [-10.515246422644902, 8.04284369011574],
            [-10.522608033086486, 8.044154260780138],
            [-10.525168192489469, 8.045854243757953],
            [-10.530415793947128, 8.052626225857558],
            [-10.536149375282243, 8.054712683910845],
            [-10.54932969015591, 8.054620539331294],
            [-10.55151684968782, 8.05639184343183],
            [-10.556717093049517, 8.054856952226226],
            [-10.559331010774436, 8.059438500731847],
            [-10.56057748909992, 8.066252526701657],
            [-10.563153892283962, 8.068541663538399],
            [-10.569686710594594, 8.06903830862354],
            [-10.578777768526693, 8.068516856940414],
            [-10.583258376976579, 8.073210068963181],
            [-10.578972796098878, 8.079621524528385],
            [-10.584259178101666, 8.085466696187547],
            [-10.584239003928374, 8.090951394900264],
            [-10.587845822203944, 8.094276713749922],
            [-10.588145787523324, 8.097896957782078],
            [-10.598164756401754, 8.096560303175208],
            [-10.599928775762123, 8.100497331946322],
            [-10.604546127429316, 8.100079932230742],
            [-10.60805887757285, 8.095966482668251],
            [-10.612511728876852, 8.09953157150575],
            [-10.62891519536741, 8.095507301757772],
            [-10.630447397494812, 8.097282734963056],
            [-10.644168824635077, 8.102134181925141],
            [-10.643635823062564, 8.107411680792001],
            [-10.649666867391252, 8.11097837752855],
            [-10.65354464380775, 8.111979766161838],
            [-10.661245487606562, 8.110300188184688],
            [-10.663370728835899, 8.113176698789891],
            [-10.667195861605405, 8.109545037734723],
            [-10.66970743234739, 8.111556957269519],
            [-10.678277093033438, 8.107168405457761],
            [-10.686690876508457, 8.111437146654257],
            [-10.694485615697971, 8.108233845896915],
            [-10.700466260273336, 8.110139504863307],
            [-10.706055154548453, 8.101300248167046],
            [-10.708756378811337, 8.100869500971871],
            [-10.712923227372217, 8.104248280089717],
            [-10.718128536175982, 8.097849054579601],
            [-10.723053137227772, 8.098973698539362],
            [-10.722872567115758, 8.08953517314072],
            [-10.727240472209163, 8.078232790876333],
            [-10.723817340980787, 8.071136074292523],
            [-10.727315364977164, 8.067125258492572],
            [-10.730438842489443, 8.065756874919863],
            [-10.733971266149128, 8.061190917217651],
            [-10.737235514364151, 8.060558235140736],
            [-10.738422570784463, 8.055339454632303],
            [-10.745321460609878, 8.049743786254883],
            [-10.746412844380597, 8.040319447169358],
            [-10.752386437348365, 8.0362250070086],
            [-10.763013188117698, 8.026827666950327],
            [-10.76759666692987, 8.025664174762932],
            [-10.772207183123754, 8.022876045056204],
            [-10.778452606458096, 8.024771020873631],
            [-10.784082601010688, 8.022273561902173],
            [-10.787254952251445, 8.02395342127535],
            [-10.79214821638984, 8.031328439665739],
            [-10.797834614322891, 8.03721952676398],
            [-10.801109755347152, 8.043433689254476],
            [-10.807273021792005, 8.04411685082821],
            [-10.811739405781179, 8.046977713948856],
            [-10.814639001824554, 8.050775085803942],
            [-10.821501101915489, 8.05383506656693],
            [-10.826801160435176, 8.052519221301933],
            [-10.832136280355465, 8.058575360327428],
            [-10.83351206858895, 8.069810538376911],
            [-10.837279402612403, 8.075061554835862],
            [-10.843836370189504, 8.075951517699917],
            [-10.847625681802606, 8.08071400475253],
            [-10.918253013109492, 8.130092386020268],
            [-10.92192445402258, 8.134063072979329],
            [-10.926197619266729, 8.136315756091571],
            [-10.931043692583799, 8.142946425995973],
            [-10.933404890810278, 8.144629387453936],
            [-10.933355083874082, 8.151951192429927],
            [-10.934444006963927, 8.154982352341893],
            [-10.929879445627963, 8.15933518596532],
            [-10.929188299362362, 8.163868435946993],
            [-10.922690061887357, 8.167868183900072],
            [-10.922748337151496, 8.170311349902601],
            [-10.91752690744, 8.173161715126925],
            [-10.915646469950218, 8.177297570087912],
            [-10.915964574289394, 8.181615118595886],
            [-10.910609215279019, 8.185184178771436],
            [-10.912390221827502, 8.19657041764053],
            [-10.911602430939453, 8.199279583142893],
            [-10.915664247183024, 8.2020903072359],
            [-10.914577127641666, 8.206360392886026],
            [-10.918061110954737, 8.208699187890028],
            [-10.916033931852354, 8.21603804399027],
            [-10.912971624131455, 8.219853305390806],
            [-10.91401701408003, 8.222641832809321],
            [-10.921995621881965, 8.228770584799168],
            [-10.922392110974355, 8.237135509388876],
            [-10.923546246156848, 8.239871635575605],
            [-10.918691219942184, 8.243548723568829],
            [-10.919672574725205, 8.251104007705704],
            [-10.916070487052606, 8.256683989151167],
            [-10.918560442280688, 8.260220499344936],
            [-10.920202602161549, 8.266724659897458],
            [-10.919275639525361, 8.273276080169325],
            [-10.919728748554144, 8.287920689511521],
            [-10.918671395279869, 8.300945859273488],
            [-10.916197058871946, 8.306315688218982],
            [-10.910540015350904, 8.311818251113626],
            [-10.91166767248147, 8.319666930647966],
            [-10.913866731719445, 8.323480261608344],
            [-10.912133658400798, 8.327341793939357],
            [-10.914071987395596, 8.332193102848896],
            [-10.917596702247808, 8.332098711832085],
            [-10.92283685523794, 8.336439437725994],
            [-10.924663285767993, 8.339649984554889],
            [-10.931214681091758, 8.34025593607394],
            [-10.931738130238324, 8.34340048139508],
            [-10.929749178803952, 8.348809523284398],
            [-10.932252302401007, 8.353124248572144],
            [-10.927107055135773, 8.357245140887171],
            [-10.926513647035007, 8.361619907850306],
            [-10.921865057224649, 8.367289852337327],
            [-10.921481138985298, 8.369958872646981],
            [-10.917737511950588, 8.374712455923653],
            [-10.922738197012993, 8.382343410970046],
            [-10.917903440429885, 8.391763319511856],
            [-10.92061569864487, 8.396901102457928],
            [-10.926964079501348, 8.401137999708542],
            [-10.931218844544972, 8.408658957839473],
            [-10.938207792502629, 8.414765586894879],
            [-10.939491091350698, 8.41847913758983],
            [-10.937253139578448, 8.423609758707547],
            [-10.945305795362728, 8.428753795896752],
            [-10.944111570208198, 8.431773501459734],
            [-10.94701943619352, 8.44146310547805],
            [-10.94093480176025, 8.451356899858956],
            [-10.938304612638689, 8.460508841762287],
            [-10.939992936688284, 8.46891262737803],
            [-10.928855777758498, 8.484449373696641],
            [-10.935293960852858, 8.487005893100246],
            [-10.942965569585727, 8.488532643680927],
            [-10.947134935179688, 8.484383342866195],
            [-10.957680153985564, 8.481141325151656],
            [-10.961977048632244, 8.48627983923145],
            [-10.965313477136892, 8.48313101493275],
            [-10.975278247331518, 8.486019901484399],
            [-10.97877469834351, 8.488803151189758],
            [-10.97750278222883, 8.493941745350348],
            [-10.977366078865867, 8.50347738982896],
            [-10.978781355660015, 8.508553751992292],
            [-10.975435214891728, 8.511393008245275],
            [-10.970676730732256, 8.5202926937876],
            [-10.972980740175597, 8.5297591322815],
            [-10.9820986134859, 8.538490648926956],
            [-10.980171018264542, 8.542462211843114],
            [-10.982993239795473, 8.54565299036815],
            [-10.981338637136963, 8.548745120770688],
            [-10.97478059428571, 8.548518219690118],
            [-10.969634528600121, 8.550187240560456],
            [-10.963666091664901, 8.555115854891406],
            [-10.95887721404374, 8.56261647313134],
            [-10.953387389941632, 8.566680896981637],
            [-10.951108298523955, 8.571002714381581]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.09372861505553,
          "lat": 46.148406025761744
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30043"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01720045"
      },
      "bbox": [
        -10.982993239795473, 8.014068632877917, -10.373182281817202,
        8.803608368967273
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.943222819687305, 10.25264646766412],
            [-10.941804666412295, 10.247057084465853],
            [-10.94239948691662, 10.239979267258592],
            [-10.941566028726987, 10.237135025945344],
            [-10.94235055138525, 10.225193780341037],
            [-10.943727964084212, 10.217913648539035],
            [-10.942891946247297, 10.210625828731896],
            [-10.934433437456574, 10.206705961146552],
            [-10.930756357911562, 10.20175837901391],
            [-10.93067751148026, 10.186356244710817],
            [-10.932830365174015, 10.18394594645626],
            [-10.92997643346338, 10.171575561935576],
            [-10.930660521095387, 10.168217666605294],
            [-10.92574577222949, 10.158904916432096],
            [-10.921700684077948, 10.155775450567926],
            [-10.921603674846457, 10.151515590952801],
            [-10.923260786571998, 10.144531372941202],
            [-10.919627937588476, 10.138293983759505],
            [-10.920197045864088, 10.134868282498818],
            [-10.918340059193012, 10.128512525107872],
            [-10.92011483562122, 10.124133771437242],
            [-10.918154897878026, 10.121486798410613],
            [-10.921766221230284, 10.115661103622955],
            [-10.920726141187306, 10.112026320483329],
            [-10.923593885392924, 10.103627350711278],
            [-10.924259793359164, 10.096373812752473],
            [-10.926588644593838, 10.094994230216738],
            [-10.927452620837494, 10.088862506467926],
            [-10.929894288064528, 10.087887127737945],
            [-10.931405328197945, 10.082935125293218],
            [-10.930678347408447, 10.075877553603535],
            [-10.933085491437787, 10.06694794238807],
            [-10.938413255930774, 10.06084822599508],
            [-10.938412698731995, 10.05561147605205],
            [-10.933843437588012, 10.051582171887551],
            [-10.93212999670009, 10.046371546351969],
            [-10.933138765634595, 10.039906799798116],
            [-10.929332216240033, 10.036923567564253],
            [-10.92985145087348, 10.033363407926153],
            [-10.927161445901037, 10.029735688045356],
            [-10.927584851316398, 10.025873331332736],
            [-10.932002590220565, 10.019906826767452],
            [-10.93075859304089, 10.013494088650086],
            [-10.933487714291427, 10.009878512467116],
            [-10.934485160484723, 10.00544069898849],
            [-10.941237184032088, 9.997451810305233],
            [-10.937432972683757, 9.989345582087811],
            [-10.938159739639985, 9.984866146675866],
            [-10.934683599979433, 9.980389743421746],
            [-10.933823529524892, 9.976876188929074],
            [-10.929449486337674, 9.975509094809237],
            [-10.931622056418798, 9.969417992883704],
            [-10.929530696521153, 9.963739905989403],
            [-10.923850421583566, 9.955922786029586],
            [-10.924810771585294, 9.95309550013939],
            [-10.922712514342045, 9.950223400434018],
            [-10.925099282914468, 9.947831960687957],
            [-10.919749042609178, 9.944592856946956],
            [-10.919634757636684, 9.94021296956687],
            [-10.915012317464926, 9.936064341695209],
            [-10.916399278656492, 9.930439758880562],
            [-10.915091183854186, 9.92554760775547],
            [-10.908236855138757, 9.923207766110464],
            [-10.906596498929268, 9.917912224938808],
            [-10.902659628685697, 9.915299646444348],
            [-10.899238837182455, 9.907757072895901],
            [-10.892816486883406, 9.899850672850553],
            [-10.888899254329841, 9.899119998505382],
            [-10.885502981137352, 9.902207500542726],
            [-10.881569254308205, 9.900637478608068],
            [-10.876825328446538, 9.892633649444024],
            [-10.870868075858793, 9.887699784923651],
            [-10.862823483638232, 9.885655999116741],
            [-10.854148909804515, 9.887975285120827],
            [-10.85157645484155, 9.892988115274246],
            [-10.849101481687336, 9.891381055116199],
            [-10.841153117956408, 9.892045177391152],
            [-10.833854022536562, 9.898974468335414],
            [-10.825596056260155, 9.89655401850235],
            [-10.82118306529894, 9.896361773700544],
            [-10.817078583215313, 9.899688872201216],
            [-10.810041619098131, 9.899930562940632],
            [-10.803702545490664, 9.891621136116767],
            [-10.793771178752397, 9.897155978251948],
            [-10.789720686355107, 9.892296410614561],
            [-10.785603804288826, 9.896099004918845],
            [-10.775912661530192, 9.892375887557979],
            [-10.773141353690347, 9.893692239581123],
            [-10.770223979497946, 9.897899327308778],
            [-10.763136870139137, 9.89734735567806],
            [-10.760736259714621, 9.902024093419477],
            [-10.752956720648172, 9.903143804504747],
            [-10.748056220694092, 9.901776727759097],
            [-10.745016754815234, 9.898509229657195],
            [-10.740827161624072, 9.900046029478702],
            [-10.733784478473062, 9.899267466787553],
            [-10.729363390558113, 9.896625148247724],
            [-10.721085488530486, 9.898192572906556],
            [-10.719493282105507, 9.901314697190333],
            [-10.716505215134768, 9.900745764043673],
            [-10.71623933874998, 9.905463722821526],
            [-10.712505921459867, 9.906469221126233],
            [-10.708607652034198, 9.911934933653095],
            [-10.704049825777608, 9.910382290980618],
            [-10.702836396059608, 9.905658668924719],
            [-10.694343303290287, 9.89957030527605],
            [-10.688287123875979, 9.899400466892235],
            [-10.687642612198852, 9.895538345490765],
            [-10.690614008314059, 9.890373555917506],
            [-10.686401110832175, 9.887281728360719],
            [-10.68819284343397, 9.87907043789776],
            [-10.683944924925736, 9.874788528060456],
            [-10.678864679735257, 9.875883443451269],
            [-10.678094187803381, 9.871308823104986],
            [-10.67527726653767, 9.867773428990157],
            [-10.670171818406665, 9.868955186203385],
            [-10.667580220644078, 9.866944226608362],
            [-10.661516719700627, 9.866450351654866],
            [-10.655607632302885, 9.861762761527247],
            [-10.650142122699268, 9.860666814658762],
            [-10.644506531642227, 9.856299636093908],
            [-10.642353017471066, 9.856770223822412],
            [-10.639490552624718, 9.852802555267225],
            [-10.633499220789627, 9.853219957498357],
            [-10.63374585270726, 9.850572284807447],
            [-10.629227411726303, 9.846343085114661],
            [-10.6276936693374, 9.842901438058885],
            [-10.629738018146824, 9.836514340825612],
            [-10.62806641649581, 9.83215169098154],
            [-10.629950862157788, 9.830369420228683],
            [-10.627788038456142, 9.824110972043238],
            [-10.623063116948815, 9.823783889330768],
            [-10.622592163057767, 9.819724835099926],
            [-10.624671216944916, 9.816344207339059],
            [-10.622514049086922, 9.811000682153738],
            [-10.624723118185774, 9.805716462408016],
            [-10.627989923018395, 9.8011941176955],
            [-10.626666242422575, 9.79872094030667],
            [-10.61974409751122, 9.797943460858553],
            [-10.61142813600499, 9.795391379017397],
            [-10.609499267489275, 9.790890022692873],
            [-10.605734923466029, 9.789157382992256],
            [-10.593463762808815, 9.790751974667542],
            [-10.585791799556985, 9.790335697246645],
            [-10.585278467442155, 9.786682705533716],
            [-10.587693786659393, 9.782302686216882],
            [-10.587082359987601, 9.77879069586258],
            [-10.580481396131873, 9.779899066162404],
            [-10.577795029749714, 9.782798165617395],
            [-10.5740308953477, 9.780072902145017],
            [-10.570701448126695, 9.779817822241796],
            [-10.569852229226214, 9.775061188139874],
            [-10.566501189653714, 9.77148881567117],
            [-10.566072612002774, 9.764262012922986],
            [-10.55624222187771, 9.75681039992653],
            [-10.555468663532872, 9.751509957227299],
            [-10.551046209101063, 9.746695144661476],
            [-10.551938192941607, 9.741181622799303],
            [-10.549183166170932, 9.738952853173458],
            [-10.543411106379482, 9.740470537741182],
            [-10.52980747543094, 9.74009694263981],
            [-10.522420549199953, 9.734629822261487],
            [-10.517526604246099, 9.736800886650135],
            [-10.512907419472366, 9.734760834583156],
            [-10.508676153439835, 9.735164980466402],
            [-10.50649201876466, 9.729923853177668],
            [-10.500885505555553, 9.727501455668449],
            [-10.496545953010251, 9.731132542750274],
            [-10.494019324088974, 9.730052117254527],
            [-10.487604076418643, 9.73167119640271],
            [-10.48466732551576, 9.734594604968105],
            [-10.480307187427186, 9.735232042087473],
            [-10.477029329378464, 9.730492721621768],
            [-10.472902002598923, 9.73153974846755],
            [-10.46958239325146, 9.729202323501498],
            [-10.459320832964664, 9.734722807906612],
            [-10.45713646715384, 9.732333637525743],
            [-10.450818122571363, 9.73000613245321],
            [-10.448991719948156, 9.72781682434589],
            [-10.44361385283293, 9.72718297590619],
            [-10.443474758235583, 9.723418739905982],
            [-10.437763786012868, 9.723212074175926],
            [-10.43369789778484, 9.720442762434805],
            [-10.432601471648423, 9.723930011506889],
            [-10.429105816246047, 9.725187579345917],
            [-10.426016702425345, 9.723510438229258],
            [-10.421869145978285, 9.72400279458882],
            [-10.421160194760581, 9.72644060573959],
            [-10.415627946600315, 9.726918603458492],
            [-10.41117467505165, 9.721830470597748],
            [-10.403470566520458, 9.725524441128295],
            [-10.399019717215372, 9.722513992045837],
            [-10.393183371495248, 9.722895087087826],
            [-10.419474845683935, 9.562524420469618],
            [-10.43437660067848, 9.473276153211897],
            [-10.445210025234989, 9.410110056156029],
            [-10.439135328546843, 9.410017691843137],
            [-10.431221184378268, 9.414157100120121],
            [-10.425731380705322, 9.407760598841397],
            [-10.422060756832714, 9.408882636404305],
            [-10.42104263780458, 9.404111951716992],
            [-10.425020083509322, 9.402610229301583],
            [-10.423170068513583, 9.39810587493922],
            [-10.424819595507447, 9.394181644595784],
            [-10.417768793200741, 9.392436488931343],
            [-10.41496805827761, 9.390279545163546],
            [-10.41309360245133, 9.39470883767563],
            [-10.401247346216538, 9.393994509970346],
            [-10.404203031513426, 9.384346559551307],
            [-10.399443238738243, 9.380675662846652],
            [-10.395591569619443, 9.38281252094622],
            [-10.393166499316942, 9.377810601099753],
            [-10.39654411292877, 9.368139458529892],
            [-10.393615197302847, 9.365044080056073],
            [-10.389965318688786, 9.365567698188029],
            [-10.38420823456479, 9.350974639962232],
            [-10.379139408917657, 9.34785094394502],
            [-10.3761561212636, 9.349894671786473],
            [-10.370685747614436, 9.340862239261936],
            [-10.354597785556065, 9.338227858752388],
            [-10.357042045047287, 9.324237705049985],
            [-10.342240317284043, 9.321883985275075],
            [-10.34133767326698, 9.32896528097418],
            [-10.283568058890353, 9.319646338343329],
            [-10.289431386223926, 9.284826871094877],
            [-10.290123534263754, 9.284942403446538],
            [-10.31962865633886, 9.111279353817828],
            [-10.314035680639442, 9.11016917598542],
            [-10.230289877195576, 9.096210645879344],
            [-10.225706815251487, 9.090068528457667],
            [-10.215946924254748, 9.084634717595689],
            [-10.208806239844224, 9.08223474993739],
            [-10.202978679450244, 9.075130989221778],
            [-10.200263087189722, 9.070202378619214],
            [-10.19637290790436, 9.06869376755814],
            [-10.201492913238166, 9.060336585318115],
            [-10.203086992629897, 9.055866728331754],
            [-10.20817903491811, 9.05517018623857],
            [-10.21034960612169, 9.052267979244116],
            [-10.214783007360799, 9.051820866675914],
            [-10.218643204577166, 9.049050071492031],
            [-10.227356351720543, 9.047850756695516],
            [-10.227737063908897, 9.040984476177146],
            [-10.224626424114952, 9.036048861285627],
            [-10.225112377615964, 9.033120625088438],
            [-10.229648285385242, 9.031995051813842],
            [-10.23031608563691, 9.028048673055968],
            [-10.23333551141764, 9.026868939981709],
            [-10.230941409130574, 9.015281952050104],
            [-10.222800505481429, 9.014322263678748],
            [-10.217757452881152, 9.007461575871101],
            [-10.218100356039034, 9.002266826186522],
            [-10.209920212069706, 8.989716517153926],
            [-10.20591085235471, 8.986639425460185],
            [-10.20162382066215, 8.987470078509954],
            [-10.198385348868337, 8.983244121363775],
            [-10.194805795534606, 8.985365554845494],
            [-10.18897913650799, 8.986450034933682],
            [-10.18355613071134, 8.983941356591297],
            [-10.181519018078381, 8.981133985653848],
            [-10.176742650983517, 8.978399381006744],
            [-10.171765197534958, 8.977245770082565],
            [-10.167481888301992, 8.978003499192948],
            [-10.16278765431324, 8.976471960368515],
            [-10.156258395652866, 8.980214874387414],
            [-10.154977506266816, 8.987854259052288],
            [-10.14520945358042, 8.985439445901559],
            [-10.143222680052668, 8.982991718392912],
            [-10.14808245355279, 8.977980158665103],
            [-10.14363270941166, 8.968515061049763],
            [-10.140473784513405, 8.958772131382615],
            [-10.142071193981018, 8.94337654114874],
            [-10.143181634512418, 8.938607534813658],
            [-10.146365989832436, 8.93203517492043],
            [-10.154163906999099, 8.930373805720189],
            [-10.159366412673505, 8.933187985197192],
            [-10.162136711048367, 8.936831404891421],
            [-10.171179302955563, 8.938905414893219],
            [-10.176898985149425, 8.943673415905117],
            [-10.18023482852311, 8.944420777653265],
            [-10.183601552619082, 8.942494401836958],
            [-10.188934524371891, 8.942868839406339],
            [-10.191040697954733, 8.946326471250082],
            [-10.189653409384658, 8.949462162028167],
            [-10.191007898711048, 8.95363279074887],
            [-10.197055886650467, 8.95502638439571],
            [-10.203538920395058, 8.960652627660735],
            [-10.21092759633181, 8.957250004072948],
            [-10.214496112579496, 8.958863114132688],
            [-10.220656012681424, 8.954404528621495],
            [-10.22342698877322, 8.946874589681881],
            [-10.226541173391768, 8.941027489903528],
            [-10.232154093356373, 8.93906410114822],
            [-10.235085751119758, 8.930390728629385],
            [-10.24223181105531, 8.927966785022434],
            [-10.246108461286935, 8.924060263137978],
            [-10.258606681638526, 8.849317848882315],
            [-10.259372891463594, 8.849444565296318],
            [-10.271947547379844, 8.772809829814504],
            [-10.269936968333564, 8.768117992266014],
            [-10.270169602266922, 8.763553475921135],
            [-10.268562594781503, 8.759843503018914],
            [-10.317486883238955, 8.767412059798115],
            [-10.331812180639409, 8.770009163509211],
            [-10.360269175828737, 8.77420612393617],
            [-10.37479738279332, 8.776851441811518],
            [-10.446635147475988, 8.788633085544557],
            [-10.461482130209246, 8.79123244431228],
            [-10.511139964155811, 8.799323306028068],
            [-10.53898813901835, 8.803608368967273],
            [-10.542551051563079, 8.80040677249558],
            [-10.54094974378963, 8.792958369511453],
            [-10.542394883477714, 8.786248200889558],
            [-10.546266525928555, 8.779172609172143],
            [-10.554919002343658, 8.771345725134092],
            [-10.556763833230333, 8.771733447420582],
            [-10.56468053815947, 8.768600836950458],
            [-10.569665184029198, 8.76371395191456],
            [-10.5749315974233, 8.764861210813665],
            [-10.57736016841907, 8.762074355381678],
            [-10.585536994358208, 8.759409322153886],
            [-10.5909128944801, 8.759594675151202],
            [-10.603770704985083, 8.761761433784867],
            [-10.606028106330841, 8.763816798566559],
            [-10.610370751384943, 8.761608638708061],
            [-10.617011650563056, 8.768087418909936],
            [-10.624533419417016, 8.767638394175773],
            [-10.633093827539764, 8.761895706587335],
            [-10.63597001253352, 8.761941701535639],
            [-10.650422165025748, 8.759111148379375],
            [-10.655501770095094, 8.755641827774182],
            [-10.66352554887606, 8.756173975471334],
            [-10.666892028536376, 8.754703768842148],
            [-10.6706702310004, 8.756863466919501],
            [-10.669530250843717, 8.742644220565348],
            [-10.672280620894236, 8.73729314330269],
            [-10.668308412950553, 8.73369231079903],
            [-10.661832117475972, 8.732345105583336],
            [-10.661269405037551, 8.72909437828442],
            [-10.657831883434238, 8.725899114714679],
            [-10.657041963559626, 8.714746158759429],
            [-10.657913813218638, 8.711287874220343],
            [-10.66623495413108, 8.707221163046997],
            [-10.673942139259694, 8.709535002764104],
            [-10.680912651628079, 8.70751255108984],
            [-10.685480155245926, 8.71005658237218],
            [-10.691278917138284, 8.696786606562267],
            [-10.695949681468063, 8.692787913263881],
            [-10.698753329723486, 8.692640551900293],
            [-10.708885723378783, 8.686112298434132],
            [-10.714734375240054, 8.688027741647089],
            [-10.717185676869319, 8.686178230124577],
            [-10.724659930732733, 8.684296264837508],
            [-10.728800187195455, 8.681974227023566],
            [-10.73390673069708, 8.687243307278422],
            [-10.738991719672939, 8.687417622777794],
            [-10.739203406802336, 8.690672421209944],
            [-10.745236047318693, 8.69196786554564],
            [-10.750589940462657, 8.690895490139349],
            [-10.752422614003507, 8.69397978663121],
            [-10.755360100450932, 8.692730086789805],
            [-10.759366206244238, 8.694724252191202],
            [-10.759985327664252, 8.703299637910147],
            [-10.762056526146448, 8.70602285149852],
            [-10.759435080376965, 8.709674311614934],
            [-10.758622351357378, 8.715673616664498],
            [-10.746324166047028, 8.720120966022986],
            [-10.748446620053913, 8.723609543704285],
            [-10.747195318059722, 8.72914704903006],
            [-10.74445745299318, 8.731142874963332],
            [-10.744603022895967, 8.73713139458765],
            [-10.742238213609305, 8.746646611117956],
            [-10.744107928819279, 8.750486473444461],
            [-10.73772337831418, 8.758437485883178],
            [-10.739168064118557, 8.762405232495947],
            [-10.736578943376424, 8.769568477849104],
            [-10.737254059577626, 8.7788743080969],
            [-10.73382417928033, 8.784516922027557],
            [-10.72804377321405, 8.786503395612304],
            [-10.728232211271632, 8.793315048031902],
            [-10.725170305157821, 8.797539528394953],
            [-10.728696143423614, 8.809947960380477],
            [-10.731633574176543, 8.816852531262914],
            [-10.730233763961065, 8.824375919222968],
            [-10.730278333690027, 8.83416465487785],
            [-10.733002164722086, 8.838751833073115],
            [-10.733348146915668, 8.842723736141583],
            [-10.727183365188411, 8.847716509654981],
            [-10.724238188913871, 8.853700449768162],
            [-10.718947768291939, 8.856788027595973],
            [-10.718323098267282, 8.864151356311774],
            [-10.712250758207832, 8.869264007248738],
            [-10.714344349742872, 8.878755745405604],
            [-10.713357778331773, 8.891924165461417],
            [-10.719165377193109, 8.89918187635851],
            [-10.71656190478854, 8.900992492600986],
            [-10.71691678287512, 8.906941827876816],
            [-10.720354426827154, 8.910573154262735],
            [-10.720403240749778, 8.91794764898407],
            [-10.722383316941, 8.921800959318647],
            [-10.783283191690645, 8.932347963422007],
            [-10.775978086190126, 8.97454757076647],
            [-10.86056297048127, 8.98915208215269],
            [-10.848207975717251, 9.059221581851967],
            [-10.837428617299786, 9.119731255150455],
            [-10.927070082464848, 9.13526766145832],
            [-10.927511787078426, 9.13281039954359],
            [-11.01366174651483, 9.14799265151084],
            [-10.999005614337788, 9.228560182691155],
            [-10.991056642949392, 9.274668760096597],
            [-10.953345261903836, 9.48193494808401],
            [-11.03861086665347, 9.497145222312467],
            [-11.123880686792656, 9.512331937520475],
            [-11.123446834369792, 9.514680253173808],
            [-11.129921830584571, 9.515842562091315],
            [-11.075169493350248, 9.81387415931228],
            [-11.078764889738208, 9.808185043972555],
            [-11.082632653567847, 9.808626047970398],
            [-11.089912930538304, 9.813492527806323],
            [-11.09487820965424, 9.812921656786449],
            [-11.098345757592783, 9.810091413227122],
            [-11.101968123907378, 9.814001699597906],
            [-11.105371403100227, 9.815071446533313],
            [-11.108271827107503, 9.820289733795056],
            [-11.111882138921398, 9.82224985979413],
            [-11.112944736905721, 9.83076195218271],
            [-11.110175958726053, 9.832532138738593],
            [-11.11001721602026, 9.839741917823599],
            [-11.113092810831077, 9.847664028419896],
            [-11.109015443817679, 9.851717427889225],
            [-11.110696808054874, 9.85554628348661],
            [-11.11027571322812, 9.873109525978672],
            [-11.107468853561555, 9.875952493696252],
            [-11.106617861771015, 9.888526139698111],
            [-11.101781833933126, 9.890210001914706],
            [-11.099771481638262, 9.89973462543665],
            [-11.100655128328931, 9.902487175425906],
            [-11.105022227788721, 9.906074624324823],
            [-11.10545386990553, 9.917862499962332],
            [-11.112100869465749, 9.924419632875738],
            [-11.113098797541037, 9.927025559197222],
            [-11.113750231867808, 9.934062395537264],
            [-11.112241942371623, 9.938805552275014],
            [-11.10561853311065, 9.947891219307843],
            [-11.102928547654244, 9.949875251199044],
            [-11.104200225623782, 9.953679237220918],
            [-11.107260656188519, 9.955670631561185],
            [-11.107352894933515, 9.960663755865363],
            [-11.105742274517244, 9.967179296372972],
            [-11.101654454057872, 9.968476425079169],
            [-11.097472266467763, 9.967661007695993],
            [-11.09314269934207, 9.974255973958941],
            [-11.09081304126424, 9.988191051341008],
            [-11.095001970026722, 9.991267959760135],
            [-11.09714424597795, 9.999514461716112],
            [-11.100036564284757, 10.005179867642223],
            [-11.099966424654173, 10.015553193885301],
            [-11.104198936283478, 10.025126680415696],
            [-11.103490049228347, 10.037883452184433],
            [-11.10499872972661, 10.042264972009896],
            [-11.105255840047935, 10.049144275964947],
            [-11.10362304701779, 10.056998126001565],
            [-11.102298586519346, 10.058806976750756],
            [-11.095487961111658, 10.059999503891607],
            [-11.091271542806629, 10.062714752201645],
            [-11.085342779342458, 10.069721856190322],
            [-11.082073862201856, 10.070835964348406],
            [-11.075654475132549, 10.067734820650085],
            [-11.072076172147574, 10.06487253535824],
            [-11.05559399604279, 10.06475947862306],
            [-11.053199111796065, 10.063471344096891],
            [-11.043362440624028, 10.068003475224106],
            [-11.042343903790677, 10.073646483157349],
            [-11.042771454005116, 10.079755552893003],
            [-11.040933138497447, 10.081317983095522],
            [-11.042394742531128, 10.086163517095345],
            [-11.039064384204318, 10.08966996021766],
            [-11.03361107826517, 10.089653272629448],
            [-11.029006595907585, 10.091557621282867],
            [-11.0290133412136, 10.095398506146848],
            [-11.023589992691063, 10.102454060955626],
            [-11.025331112584135, 10.109753566917076],
            [-11.024512010307568, 10.115759168307772],
            [-11.019048732430266, 10.12140445758495],
            [-11.020808180301113, 10.12710758902957],
            [-11.018175864825418, 10.135096976455392],
            [-11.021525593173774, 10.14288387139414],
            [-11.018272794599946, 10.147514969532653],
            [-11.018021392093171, 10.151062981475542],
            [-11.011758867574972, 10.154292593014297],
            [-11.009457432796452, 10.165324484987924],
            [-11.010781126408267, 10.16924263777393],
            [-11.006703194477879, 10.181504469357924],
            [-11.010302742319316, 10.18864052946141],
            [-11.007499691059493, 10.196356609466724],
            [-11.010909323378948, 10.19809415500774],
            [-11.013882346373416, 10.20256943428307],
            [-11.021291816629722, 10.206265144940678],
            [-11.025086065943393, 10.20991028705781],
            [-11.023189370445559, 10.214370244173526],
            [-11.023804423887649, 10.219837140410323],
            [-11.018545649144674, 10.223118809455277],
            [-11.017261031684672, 10.230394777059399],
            [-11.012292675428984, 10.232232094807063],
            [-11.000644116043471, 10.234307018355535],
            [-10.988491611857373, 10.234121077039164],
            [-10.986829073814585, 10.232320390495591],
            [-10.972798785889294, 10.231303445538193],
            [-10.971923827014233, 10.234141723289596],
            [-10.964725084884162, 10.244137129078863],
            [-10.961228569947274, 10.245353767517788],
            [-10.954021595049511, 10.244812254712476],
            [-10.952706643994203, 10.24667333582254],
            [-10.94595688048039, 10.249280005455786],
            [-10.943222819687305, 10.25264646766412]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -112.39038736175259, "lat": 47.1224273203696 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30049"],
        "coty_name": ["Lewis and Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis and Clark County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00793926"
      },
      "bbox": [
        -11.129921830584571, 8.681974227023566, -10.140473784513405,
        10.25264646766412
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.749442362043077, 8.300047917276371],
            [-9.714864788840217, 8.294804655739647],
            [-9.606884872337805, 8.277686741180908],
            [-9.49278919945854, 8.260099478821443],
            [-9.493957563839293, 8.252585890929574],
            [-9.406601308460987, 8.239465877583601],
            [-9.414143018162335, 8.190083956819443],
            [-9.421592042876817, 8.191209719503613],
            [-9.434923774383051, 8.103976299183419],
            [-9.452298871047475, 7.9911689397096],
            [-9.473715673339633, 7.850166509666143],
            [-9.424212604339239, 7.842670676026802],
            [-9.430992087796945, 7.794766263102088],
            [-9.435132056865037, 7.770681153480155],
            [-9.437862874553524, 7.7500100139318375],
            [-9.439586364341267, 7.729432550928566],
            [-9.44660730927294, 7.684290444123468],
            [-9.461254599436463, 7.5863522851453284],
            [-9.46274445104517, 7.58287807768934],
            [-9.488180523219174, 7.415113839200114],
            [-9.494321526631477, 7.415987911698754],
            [-9.520548183244845, 7.242632689766596],
            [-9.406634843682367, 7.225687475683977],
            [-9.31400946203216, 7.21213188265863],
            [-9.221387495543649, 7.19855293608622],
            [-9.222085826778022, 7.193848192837498],
            [-9.245864727604461, 7.031559371986253],
            [-9.264712855845099, 7.035271077254399],
            [-9.366591731235713, 7.050290687899535],
            [-9.460334365955456, 7.064315940003274],
            [-9.515396190140608, 7.065896914407765],
            [-9.542189163838868, 7.069703047851841],
            [-9.586249846965135, 7.076914903445543],
            [-9.614126079913653, 7.083439994173625],
            [-9.671342462016028, 7.091906392499655],
            [-9.699187851365464, 7.090288757096232],
            [-9.728865541987334, 7.093991184240547],
            [-9.791002784111896, 7.10310950575381],
            [-9.880003726127113, 7.116505903548283],
            [-9.938411368329165, 7.1343299780456855],
            [-10.00816253065303, 7.145222779505354],
            [-10.07791571755218, 7.156102499536067],
            [-10.116225224486602, 7.162299677319227],
            [-10.101657009657815, 7.253190086058927],
            [-10.101634681473266, 7.26033958986955],
            [-10.089620005057322, 7.334476774756064],
            [-10.0840497848867, 7.333647282473949],
            [-10.070103115143985, 7.418616365727028],
            [-10.056147721813446, 7.50508637522347],
            [-9.972726672941436, 7.491824882414748],
            [-9.958788897970583, 7.57735786473102],
            [-9.959861554265366, 7.577526145530961],
            [-9.94650326721857, 7.661954296909663],
            [-9.904305055132026, 7.655366780169521],
            [-9.893464940423518, 7.719647562033128],
            [-9.864737867173044, 7.714677943692149],
            [-9.864548054516973, 7.715865853040759],
            [-9.85016926454342, 7.712932191956724],
            [-9.84658295436708, 7.735161461804304],
            [-9.844998523863158, 7.748657780921562],
            [-9.836211870431395, 7.806019497042411],
            [-9.833641025816199, 7.819421516703141],
            [-9.827045598948033, 7.861897723016401],
            [-9.820192451579175, 7.9043631984340355],
            [-9.816150457858912, 7.903723989251262],
            [-9.79715197669226, 8.019562592010823],
            [-9.791595665057093, 8.059422067538836],
            [-9.789339328207845, 8.074098440035188],
            [-9.786871635696833, 8.101903874003016],
            [-9.78238130073091, 8.13093677488943],
            [-9.776587384801038, 8.158508964907206],
            [-9.762060551912143, 8.251166105416115],
            [-9.757444247781065, 8.250429520336379],
            [-9.749442362043077, 8.300047917276371]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.52667417904712,
          "lat": 45.48840594273868
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30067"],
        "coty_name": ["Park"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Park County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01720027"
      },
      "bbox": [
        -10.116225224486602, 7.031559371986253, -9.221387495543649,
        8.300047917276371
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0983110466293335, 2.4119614849767625],
            [-2.0060495616283887, 2.409171976621484],
            [-1.935014808782968, 2.4068018453119713],
            [-1.8778757589873587, 2.4047865730967404],
            [-1.869595367210444, 2.404701881220501],
            [-1.7426230787347117, 2.400461848280415],
            [-1.6435639602480072, 2.3974678293147487],
            [-1.5918406489099077, 2.3956890725463205],
            [-1.5719880347180533, 2.395152342934995],
            [-1.5738376405577146, 2.32275183291788],
            [-1.574388866103663, 2.308097037893526],
            [-1.5769505857919255, 2.2205708770077672],
            [-1.5793543011252114, 2.1328966739762114],
            [-1.5816211342214999, 2.0448414677943108],
            [-1.5838620668969026, 2.0448935448523464],
            [-1.5841068895100212, 2.035705106718273],
            [-1.5911903083107148, 2.0335013888831663],
            [-1.5958263272517264, 2.03503953561555],
            [-1.602537685035301, 2.0351828395646785],
            [-1.6077356705881907, 2.033258019266129],
            [-1.6107980967124909, 2.0306261614227634],
            [-1.6227876454843804, 2.0296430576481024],
            [-1.6273376263747827, 2.027354813778918],
            [-1.6344323375168794, 2.0280729919573335],
            [-1.6398346379013378, 2.026617291084869],
            [-1.6440724141863194, 2.023235814773221],
            [-1.651025092012774, 2.0228179619766333],
            [-1.6545034819312217, 2.02368232942527],
            [-1.6613573276310265, 2.022847072822883],
            [-1.6665286110521775, 2.0184539042542946],
            [-1.6726815911962527, 2.0183360045769323],
            [-1.6791547436661436, 2.0135429141672656],
            [-1.6919973454693886, 2.00815248400256],
            [-1.700193881636133, 2.009388416214624],
            [-1.703406677673341, 2.007110752143245],
            [-1.7099474309118077, 2.006159636729623],
            [-1.7117361474047665, 2.0038844222988903],
            [-1.7175567913576884, 2.0038580491012032],
            [-1.7217937781358117, 2.00241922104981],
            [-1.7312424488112235, 2.0038886170599173],
            [-1.7344173764691542, 2.0032015405947075],
            [-1.7404107436702037, 2.005142873501321],
            [-1.7448273395828962, 2.003921715187628],
            [-1.7513651416138625, 2.0044345895641458],
            [-1.7538440756070515, 2.0057872026019923],
            [-1.7609032615506184, 2.0060317188973094],
            [-1.7648011281329368, 2.0075549465226277],
            [-1.7724864197665526, 2.008346576707362],
            [-1.7894215048344166, 2.0039536546226526],
            [-1.7945353212727337, 2.0056832607795494],
            [-1.7982619476806692, 2.005087026184505],
            [-1.811385307499254, 2.005568982951235],
            [-1.817697625281732, 2.0052174495103583],
            [-1.82374422086003, 2.008159939838909],
            [-1.8322921998070985, 2.007177301788773],
            [-1.8365290800487466, 2.0089977679323385],
            [-1.8419326935125446, 2.0086806696581667],
            [-1.8548726243247957, 2.0109044691371096],
            [-1.8632506824567072, 2.0098352995892936],
            [-1.8670417003609527, 2.0107656410300194],
            [-1.8791337835657547, 2.009492729911032],
            [-1.8962692550532803, 2.0126423100396726],
            [-1.9028202760063624, 2.0128397104927815],
            [-1.911580977480599, 2.015902831939768],
            [-1.9203730079462682, 2.0145817880274963],
            [-1.9268810567020798, 2.016868735471779],
            [-1.9293582592687801, 2.017790759405447],
            [-1.939584271119079, 2.016933615233927],
            [-1.9455767330975404, 2.0189578483246433],
            [-1.951653234209548, 2.017777112193713],
            [-1.9760872360533441, 2.0173713588344926],
            [-1.9830650665737033, 2.021578711869593],
            [-1.988155910860764, 2.022887831401668],
            [-1.991060834666708, 2.021280978376341],
            [-1.9994545382072153, 2.0204895076788674],
            [-2.0121142947008717, 2.021899178815432],
            [-2.0200060581764943, 2.023821041194718],
            [-2.030483178748273, 2.028817441768173],
            [-2.041030659536062, 2.0317693651902564],
            [-2.046380968406597, 2.0300860841982873],
            [-2.056272634017214, 2.0304311396017587],
            [-2.059745105737175, 2.0287744385551845],
            [-2.074661189096144, 2.0257169178250893],
            [-2.0822276911687045, 2.0284844436147584],
            [-2.0846738180502533, 2.0283648467827566],
            [-2.095596844341877, 2.0314593247524253],
            [-2.101325783784079, 2.0300054771118226],
            [-2.105447873670749, 2.0334366867621214],
            [-2.103721998896483, 2.062537020013404],
            [-2.111335574995125, 2.0628433179928307],
            [-2.1083620429612564, 2.150308531840436],
            [-2.1061947387952498, 2.2010955877112086],
            [-2.1044341317255726, 2.2373814561529652],
            [-2.101417480341498, 2.3141398766584382],
            [-2.0983110466293335, 2.4119614849767625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.07497732951174, "lat": 40.85515144095341 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31019"],
        "coty_name": ["Buffalo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buffalo County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00835831"
      },
      "bbox": [
        -2.111335574995125, 2.00241922104981, -1.5719880347180533,
        2.4119614849767625
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.0012834820780124288, 3.8538823264088857],
            [0.005266350378499618, 3.843068676713385],
            [0.0158153245591771, 3.835481054888788],
            [0.021680343360863132, 3.8338088703800954],
            [0.030730746389881308, 3.8347060776966746],
            [0.035707055553366396, 3.8371094585083902],
            [0.044426154803187276, 3.844992277587753],
            [0.04781833738120521, 3.8471208138278143],
            [0.055245560096835025, 3.8495902539279765],
            [0.06182601773427439, 3.849719720852641],
            [0.0696887293486129, 3.8472489049534384],
            [0.07437394601389288, 3.8442493704710956],
            [0.079088136831482, 3.8392667838685544],
            [0.08232402298620295, 3.833753283267842],
            [0.085776964127211, 3.823199686202415],
            [0.09108730922984844, 3.815560296227759],
            [0.09639028943447953, 3.8115735670941624],
            [0.10504074000538462, 3.8088804380727357],
            [0.11524952431595231, 3.808752401422278],
            [0.12686986859489582, 3.815609383539929],
            [0.1373248837675174, 3.819284287914901],
            [0.16376133404181387, 3.816117906765625],
            [0.1734924171610186, 3.812562034616949],
            [0.18085391701839082, 3.802891253195955],
            [0.18424661661678093, 3.790022120787624],
            [0.18508514076570456, 3.7797750538031227],
            [0.1846247245120239, 3.7746549299093317],
            [0.18194836422741617, 3.76552631517208],
            [0.1795082287178049, 3.7607153500729398],
            [0.16166834630190263, 3.7390956042268226],
            [0.15890694100754804, 3.7284607063254738],
            [0.15926491941625204, 3.721576675299118],
            [0.16348843720906459, 3.7095539610749375],
            [0.16399124084846067, 3.7041285371217425],
            [0.15695552033270854, 3.6866883654362246],
            [0.15702033348637323, 3.6794040357746343],
            [0.15984159791788002, 3.6712988423352453],
            [0.1641455244202646, 3.6652677670773626],
            [0.17273062952792934, 3.6586503070437457],
            [0.18159622345475884, 3.653607929836296],
            [0.18807472290799315, 3.6460121206943366],
            [0.19196626034145928, 3.638501116672355],
            [0.19301189707563354, 3.631207103304332],
            [0.19300488364822815, 3.6193777363764172],
            [0.19493773404316148, 3.6133690469260364],
            [0.2017995371880492, 3.6039165961248942],
            [0.10743640520943297, 3.6047592791654837],
            [0.09596437753103622, 3.6053009079315412],
            [0.05892656001127003, 3.6058409248524717],
            [0.0015782887278459029, 3.6060946416145474],
            [-0.07030361736511886, 3.606983013853576],
            [-0.06922845060285343, 3.6804320732357607],
            [-0.06891175654877402, 3.760510864094357],
            [-0.0686985201185532, 3.7670978775515156],
            [-0.06562293496480899, 3.7671317460517946],
            [-0.06521927907542106, 3.8073520109836307],
            [-0.06516142097915685, 3.8546888293656774],
            [0.0012834820780124288, 3.8538823264088857]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.56452468983647, "lat": 42.39117856237071 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31043"],
        "coty_name": ["Dakota"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dakota County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00835843"
      },
      "bbox": [
        -0.07030361736511886, 3.6039165961248942, 0.2017995371880492,
        3.8546888293656774
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.818412965649006, -1.369342474181656],
            [-6.766854837337173, -1.3741684298891101],
            [-6.739885136192615, -1.3766785843471137],
            [-6.66803871802045, -1.3862944332760028],
            [-6.645407195430993, -1.3879043989663464],
            [-6.452282887857225, -1.405787574346482],
            [-6.365373820397578, -1.4138511608283093],
            [-6.350004598344923, -1.4150269785008813],
            [-6.349154299249158, -1.414315783822781],
            [-6.266253749140408, -1.4224298126443413],
            [-6.199080295153653, -1.4285455039830843],
            [-6.12411375218037, -1.435298967181331],
            [-6.054436429031441, -1.4402697696471807],
            [-6.026430989935079, -1.4424644776069346],
            [-5.863036259101317, -1.4550594123417042],
            [-5.8711868428048675, -1.5524943879440167],
            [-5.875070382359318, -1.5959762154781465],
            [-5.881101497846693, -1.6672924447580952],
            [-5.885551412182745, -1.7220043601455601],
            [-5.888087862913362, -1.755363266877929],
            [-5.889582574073942, -1.7552350569958637],
            [-5.89093218281084, -1.7742045780437268],
            [-5.89992583790296, -1.8860485103897608],
            [-5.909608740883094, -2.0032377297484922],
            [-5.91812061247873, -2.1054334108547956],
            [-5.918668162745938, -2.105431739894683],
            [-5.923637245894323, -2.1642030847057883],
            [-5.924589528507146, -2.173942912571486],
            [-5.929915831063925, -2.23735387329372],
            [-6.001145643659988, -2.2313670212412196],
            [-6.2700763915604725, -2.2074501475026973],
            [-6.5119297934571, -2.185417389514172],
            [-6.526116654538658, -2.184892753956718],
            [-6.611880517051159, -2.176949799364929],
            [-6.607734369728454, -2.133217481229404],
            [-6.626265506010366, -2.131456499168632],
            [-6.84646984325329, -2.1108660158591848],
            [-6.883231031431096, -2.107002313302879],
            [-6.959167442407502, -2.0988063312552745],
            [-6.986123766759178, -2.096438828942454],
            [-6.973697986063529, -2.0822825846571447],
            [-6.9760077906213525, -2.065635343259637],
            [-6.977740271928462, -2.0571102083426],
            [-6.975431327318842, -2.0436996694745053],
            [-6.972108049493629, -2.035811991457608],
            [-6.972355595445636, -2.0271520219142753],
            [-6.968879020395964, -2.021713121832375],
            [-6.968591450012279, -2.0185097565262753],
            [-6.970746521740727, -2.01273139103603],
            [-6.9677681360273676, -2.009169417959552],
            [-6.967804555213101, -1.9962865631149536],
            [-6.968608098627211, -1.9910526552850276],
            [-6.972444738179063, -1.9892525732388484],
            [-6.971047233388905, -1.9848669096431764],
            [-6.966941569822711, -1.9828290628992162],
            [-6.963338824028561, -1.9786045678562132],
            [-6.9607514822258025, -1.970438966895296],
            [-6.961996263058345, -1.9659766371207335],
            [-6.961151178292619, -1.9596264871336937],
            [-6.963388707508753, -1.9548514487552375],
            [-6.960979393586476, -1.9504657724360999],
            [-6.9635278581225935, -1.9460777319077576],
            [-6.970004693308129, -1.9423113029711885],
            [-6.96581769824321, -1.9315882459260998],
            [-6.967864138451736, -1.9227551076327674],
            [-6.964396255996685, -1.9190648016831795],
            [-6.966605447050695, -1.9119268569417744],
            [-6.969373773836876, -1.9109474064860072],
            [-6.975759424076847, -1.9116194811769047],
            [-6.979877376198981, -1.9068363656230973],
            [-6.979168896354071, -1.904074625035124],
            [-6.973370005632945, -1.9011824913082467],
            [-6.967533251369508, -1.8889612345495705],
            [-6.964124459518848, -1.8871397050515146],
            [-6.96285042724691, -1.8804146369742976],
            [-6.960089310519222, -1.8773074477760427],
            [-6.960293038167711, -1.8743005611849466],
            [-6.952850232085948, -1.8715466546409159],
            [-6.948727933844279, -1.872203617119177],
            [-6.945489673708933, -1.8674507692618216],
            [-6.950314558288111, -1.8623683017203538],
            [-6.95097043619685, -1.8584581940865132],
            [-6.95876777926395, -1.8524052214726507],
            [-6.9590191653904725, -1.8475797169438624],
            [-6.963498549130193, -1.845950005570401],
            [-6.963271777756053, -1.8391366611671232],
            [-6.964553103152326, -1.8246543601982952],
            [-6.970812884307292, -1.8188312282221106],
            [-6.971556413498351, -1.8149200776716041],
            [-6.975839492845992, -1.8145538773357832],
            [-6.979210262086748, -1.8124352527410212],
            [-6.97982486328448, -1.809117686592264],
            [-6.9852628386561495, -1.8047664448375231],
            [-6.986207320595587, -1.8019900413332377],
            [-6.983916048475042, -1.7982388960047406],
            [-6.979694688760917, -1.8002300064060148],
            [-6.973243413931812, -1.79761469437176],
            [-6.968150467115541, -1.7975669927364024],
            [-6.962809045220302, -1.7947023755005427],
            [-6.964224040308211, -1.7915036899705812],
            [-6.962421077524158, -1.7838994317719017],
            [-6.9650933132957356, -1.7810501569754702],
            [-6.964655266320156, -1.7766319192992712],
            [-6.966386887327075, -1.7732943609593965],
            [-6.966829009524763, -1.7659277341373552],
            [-6.970519187761824, -1.7579938282322225],
            [-6.973351591093989, -1.756809465010092],
            [-6.976509437623186, -1.751243710760002],
            [-6.9783055124289755, -1.7456562964578397],
            [-6.976649165854243, -1.743291140302515],
            [-6.97664129211796, -1.737981465212418],
            [-6.971973006765878, -1.7357264446465208],
            [-6.972860768745198, -1.7319902179096867],
            [-6.969301930681847, -1.7274999707460157],
            [-6.963345245794711, -1.725017891266519],
            [-6.959803835083448, -1.7253522804460066],
            [-6.95704767248156, -1.722637961986767],
            [-6.956978608774894, -1.719083532129744],
            [-6.959893377558899, -1.716492016843064],
            [-6.959173523007275, -1.7127705927485966],
            [-6.965334505562336, -1.7008454654731384],
            [-6.961395860756034, -1.6968102026930763],
            [-6.961476664632116, -1.6921994285213124],
            [-6.965689439624296, -1.6852283253692506],
            [-6.968525430782095, -1.6828022170453343],
            [-6.967877628632175, -1.673609741970947],
            [-6.963246239410846, -1.6712443149204521],
            [-6.963121362503683, -1.6671972811336897],
            [-6.958664384022226, -1.662674661347861],
            [-6.951740872229853, -1.6584317505293713],
            [-6.944825120109672, -1.6586585436483288],
            [-6.93777037326347, -1.6545683437540275],
            [-6.931357421560867, -1.659797445750474],
            [-6.927659199070365, -1.659576171687361],
            [-6.92711941270479, -1.6542466886965426],
            [-6.922087524040339, -1.6439701934542976],
            [-6.9178800982542645, -1.6412391035087865],
            [-6.918265685218443, -1.6353521410822227],
            [-6.905478411987556, -1.6322421088567083],
            [-6.898538426447493, -1.6325808519312257],
            [-6.896171856131082, -1.636421689059483],
            [-6.896488400960879, -1.6395199702059606],
            [-6.893107378274341, -1.6427897597927945],
            [-6.889768941854757, -1.6400714885073227],
            [-6.885551761437462, -1.6419656095465707],
            [-6.883515399870405, -1.6453345618963793],
            [-6.878809073782263, -1.642916901945682],
            [-6.873114277860723, -1.6434083313825925],
            [-6.867312739843701, -1.6458454383232146],
            [-6.8628751831406465, -1.6418918069828994],
            [-6.852954231247432, -1.6411855637808643],
            [-6.851117489534071, -1.6355158320002694],
            [-6.846964974383172, -1.6313287882730203],
            [-6.848381226580772, -1.6268734328645889],
            [-6.8445723328711265, -1.6098249145974473],
            [-6.8457639198511675, -1.5979049935107406],
            [-6.845136402025158, -1.5936322222889034],
            [-6.850046582678542, -1.5783412557769592],
            [-6.850091037824304, -1.573656161004151],
            [-6.842777763850885, -1.563916820937402],
            [-6.841944851868132, -1.5602257014899132],
            [-6.846976684943043, -1.5571204713207532],
            [-6.846532809218685, -1.5523632195175565],
            [-6.841621832072246, -1.5455271821212992],
            [-6.838424682777646, -1.542727310430254],
            [-6.837848760354473, -1.5341071478114692],
            [-6.836433424982598, -1.53189127039033],
            [-6.840327566250163, -1.52228829037988],
            [-6.839827800863889, -1.516800132421771],
            [-6.834681716193515, -1.5045663655651151],
            [-6.831773074477563, -1.4961749806630402],
            [-6.831539490843221, -1.492091686837674],
            [-6.825359322290983, -1.4824252021760222],
            [-6.823143232910315, -1.4756566372112132],
            [-6.8175098186460055, -1.466640219143583],
            [-6.814942163130022, -1.459257581975325],
            [-6.812993476927991, -1.4578648394322071],
            [-6.810122091389709, -1.4508137469370916],
            [-6.816898548827738, -1.448117288598299],
            [-6.8189239535949095, -1.4458009744377405],
            [-6.819376364468816, -1.438764688897188],
            [-6.818710637305021, -1.4330164770671006],
            [-6.824770236817098, -1.4304841048471433],
            [-6.824263793136055, -1.426180723691743],
            [-6.827002778683421, -1.4190819256719605],
            [-6.828566790154891, -1.4179601462465228],
            [-6.82863168849675, -1.4095333409609574],
            [-6.833948151285926, -1.401123241372755],
            [-6.832426917000356, -1.394328482613555],
            [-6.8338859849901095, -1.39009105086621],
            [-6.832037487343966, -1.3814235123897194],
            [-6.826947178105909, -1.3778941575152368],
            [-6.821573798574469, -1.3776150868145505],
            [-6.817765543550356, -1.37162779205572],
            [-6.818412965649006, -1.369342474181656]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.64688165511348,
          "lat": 36.60614838434299
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35007"],
        "coty_name": ["Colfax"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colfax County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00929117"
      },
      "bbox": [
        -6.986207320595587, -2.23735387329372, -5.863036259101317,
        -1.369342474181656
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.978351383473436, -5.577833919309258],
            [-8.957376292137267, -5.404133001476326],
            [-8.924117267086926, -5.408115353768984],
            [-8.790721982076885, -5.424057618230168],
            [-8.657324152474326, -5.439979015125902],
            [-8.615705768707008, -5.444849814528266],
            [-8.610833674425391, -5.4015456015015495],
            [-8.491241877541947, -5.357429031399946],
            [-8.40125297120896, -5.323894027532551],
            [-8.311273105914655, -5.290345476515084],
            [-8.221302212333484, -5.256783534830071],
            [-8.131340221050095, -5.223208358654733],
            [-8.141815568911174, -5.317222104064309],
            [-8.171589525866041, -5.3143128165444296],
            [-8.176677530161761, -5.3617721409037316],
            [-8.215201703172275, -5.709060454795299],
            [-8.220286540776884, -5.75376961282405],
            [-8.2329900217716, -5.8699991809307255],
            [-8.235690089043846, -5.893811491094674],
            [-8.258737320279318, -6.099117003581301],
            [-8.268148637863755, -6.18631533500928],
            [-8.2769290669185, -6.265828154652152],
            [-8.29125658696532, -6.263957894814737],
            [-8.360397173608686, -6.256787829741029],
            [-8.43465150506255, -6.248928698764394],
            [-8.459969624042532, -6.246073183961552],
            [-8.479420372635152, -6.244190793943796],
            [-8.480872772936582, -6.249820254463108],
            [-8.484747032334804, -6.253141095376408],
            [-8.491267195752503, -6.2536094046895805],
            [-8.496180260010217, -6.257171534551871],
            [-8.499330726922505, -6.262217850256454],
            [-8.498600017502989, -6.265845383080547],
            [-8.492451745297519, -6.272122123157144],
            [-8.489454691018567, -6.273027515495627],
            [-8.486479060580645, -6.271128392678697],
            [-8.483568435895316, -6.272791760567539],
            [-8.483394968261422, -6.277457267312211],
            [-8.485226908207313, -6.280822700145842],
            [-8.488716542256546, -6.282794126771981],
            [-8.49013913747753, -6.289190855646427],
            [-8.488389414684809, -6.29103421238301],
            [-8.483751041596937, -6.288419087469438],
            [-8.481229337997545, -6.288708272504515],
            [-8.48327951637955, -6.296078099514725],
            [-8.489921556213773, -6.298280774209471],
            [-8.490166241118997, -6.30895277344013],
            [-8.493049827115811, -6.3134645587513445],
            [-8.497154946765244, -6.316506390208796],
            [-8.496576372130995, -6.319541356444705],
            [-8.492412577387379, -6.3182766325419255],
            [-8.48286231539839, -6.324699314802454],
            [-8.485185175785936, -6.326450078473809],
            [-8.495572612667786, -6.331095466934858],
            [-8.50232878903109, -6.332790047489411],
            [-8.508933552257439, -6.337269265320831],
            [-8.513494595648876, -6.342715965193525],
            [-8.513768854338611, -6.346514550034231],
            [-8.508129601189594, -6.350355966077318],
            [-8.502451601514654, -6.3562669406299435],
            [-8.501497989011149, -6.359080109696695],
            [-8.507301842328632, -6.367714629339769],
            [-8.509111139428047, -6.375794139132698],
            [-8.502923546743013, -6.382153127641498],
            [-8.501689215954055, -6.386627816263615],
            [-8.493436427796459, -6.397378995136577],
            [-8.486068814534573, -6.398385615889349],
            [-8.483087943189352, -6.400626131135901],
            [-8.483540660650648, -6.405397482172116],
            [-8.487640494432595, -6.416686695314349],
            [-8.485828471090079, -6.419789361927124],
            [-8.478360196175325, -6.4207439201311045],
            [-8.473812873690694, -6.424056986310708],
            [-8.466038500402359, -6.436672354269584],
            [-8.460764015685621, -6.437458762052129],
            [-8.456971379259326, -6.4347660196076335],
            [-8.453938664422845, -6.437314019475258],
            [-8.441076255622429, -6.442554817419057],
            [-8.4374062534834, -6.448142350655162],
            [-8.432540646268032, -6.45223486310305],
            [-8.430930377167728, -6.459141538096462],
            [-8.426681737042866, -6.462411035429417],
            [-8.42786534994199, -6.46827646016047],
            [-8.430686498721657, -6.467205424770211],
            [-8.489636501975522, -6.4607298673545],
            [-8.614756277819195, -6.446840488620605],
            [-8.614734510072868, -6.446650077193911],
            [-8.716895992099733, -6.435099434442298],
            [-8.819055732524001, -6.4235331524731025],
            [-8.824973891893498, -6.423026492156208],
            [-8.949446451091616, -6.408336757780963],
            [-9.073916250019852, -6.3936237660253585],
            [-9.03933669888058, -6.100157773248884],
            [-9.0399754127654, -6.097324495478888],
            [-9.029400561399875, -6.010653355647341],
            [-9.02317435381016, -5.960630531018764],
            [-9.020570717609184, -5.937925663985535],
            [-8.990396467218806, -5.689309157309311],
            [-8.987186794060749, -5.66452319389295],
            [-8.9878040980821, -5.664452848816675],
            [-8.978351383473436, -5.577833919309258]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.83278388311152,
          "lat": 32.35264937102172
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35013"],
        "coty_name": ["Doña Ana"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Doña Ana County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00929109"
      },
      "bbox": [
        -9.073916250019852, -6.46827646016047, -8.131340221050095,
        -5.223208358654733
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.947361304456647, -5.87822804926503],
            [-6.939553044180548, -5.878954135751216],
            [-6.937653171241084, -5.858662375342506],
            [-6.897690597278698, -5.437779620449696],
            [-6.690760931520717, -5.456121217419547],
            [-6.656120866808756, -5.45905549203258],
            [-6.499513159890739, -5.472357557074265],
            [-6.492723079219753, -5.4730922592460605],
            [-6.2879396684224815, -5.489864735204462],
            [-6.240921553016098, -5.493838754626826],
            [-6.044458407683845, -5.510481319695866],
            [-6.060518870127744, -5.704959308322886],
            [-6.0704656035382785, -5.827020773909388],
            [-6.080793436383061, -5.952158878331111],
            [-6.0045179028756674, -5.958397697245175],
            [-6.007375893234714, -5.994196059262357],
            [-6.016553130250335, -6.105418214550525],
            [-6.025158398791728, -6.210281740537617],
            [-6.0470727745254, -6.478455138627785],
            [-6.068469262368261, -6.4767313533149995],
            [-6.175397422574997, -6.46762228569231],
            [-6.263493528689474, -6.460733518986479],
            [-6.300794644969867, -6.457720659158645],
            [-6.429073674895255, -6.446706272256011],
            [-6.557350694036456, -6.43566863431937],
            [-6.727260627794966, -6.420609637971063],
            [-6.840456679809125, -6.410108673333124],
            [-6.9144853769642, -6.403232240146385],
            [-6.914934050608677, -6.405952743410937],
            [-6.929515928717852, -6.404900625011126],
            [-6.980365928997684, -6.39767889335434],
            [-6.992837139441498, -6.396451616899237],
            [-6.975163971713507, -6.206717762104886],
            [-6.969074233163218, -6.144389283194465],
            [-6.9721257414193785, -6.14411400210271],
            [-6.947361304456647, -5.87822804926503]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.30437496553161,
          "lat": 32.471413371617196
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35015"],
        "coty_name": ["Eddy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eddy County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00936829"
      },
      "bbox": [
        -6.992837139441498, -6.478455138627785, -6.0045179028756674,
        -5.437779620449696
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.14348159130948, -2.487141222761626],
            [13.146745829469223, -2.4805194352687447],
            [13.151767169675537, -2.4767919067753703],
            [13.151958416126357, -2.4726126723440025],
            [13.159918158212937, -2.4689394367104645],
            [13.162116750500806, -2.4750144511104906],
            [13.174424686910958, -2.491115300240855],
            [13.173586987777393, -2.4965705713389372],
            [13.179629012758312, -2.5058545170848117],
            [13.184602045090944, -2.509758559541328],
            [13.19147254639795, -2.5194620368672274],
            [13.20112352365344, -2.518746442534248],
            [13.205705828650212, -2.516736346992107],
            [13.205322914268546, -2.5094425813493326],
            [13.209631573881985, -2.50563564076185],
            [13.213993599261872, -2.5063502009511764],
            [13.215879762652847, -2.511956377519381],
            [13.219059939828538, -2.515558314416228],
            [13.224127807563109, -2.516443179440091],
            [13.232989166514782, -2.520689323090284],
            [13.240841451989992, -2.520139971669657],
            [13.24439924531323, -2.515761270684162],
            [13.238904157440771, -2.510628008743318],
            [13.23638675560335, -2.505872078555143],
            [13.2377035439809, -2.50297764863778],
            [13.24242456638704, -2.4991534226599237],
            [13.242392314273808, -2.4940135750521875],
            [13.245185893521398, -2.4913376511611856],
            [13.249745848710111, -2.4924450661619204],
            [13.256330877582455, -2.496486795266715],
            [13.260545095672487, -2.4963784807418334],
            [13.263569664094534, -2.489597611915332],
            [13.267315464205419, -2.4887164405569075],
            [13.268349112152764, -2.4853895550258085],
            [13.263857738898931, -2.4793764342445774],
            [13.26291477967589, -2.4754432164094515],
            [13.267608431718935, -2.4696428199655163],
            [13.273203987875881, -2.4668377830870636],
            [13.278580071566997, -2.4696996559165605],
            [13.281499586757395, -2.4843791993457156],
            [13.287418744689885, -2.4904020881676825],
            [13.2954372900033, -2.494135632954006],
            [13.302128867322681, -2.499630673646326],
            [13.310683211759304, -2.508251676619424],
            [13.313291284823865, -2.512424399679927],
            [13.316004602140348, -2.5228799368453383],
            [13.321678520821447, -2.531832318331108],
            [13.322510612696744, -2.539304461373352],
            [13.32765230342457, -2.5435727151265852],
            [13.347260166658346, -2.548083334696903],
            [13.35685863683179, -2.5548236876003187],
            [13.364164839691986, -2.55801890701942],
            [13.370090226070836, -2.5574668739557023],
            [13.382784226578325, -2.5591996378186592],
            [13.388890826262578, -2.5583752177528396],
            [13.393433352443296, -2.5543143801646058],
            [13.395708439853871, -2.550316630830487],
            [13.396112215989517, -2.545039282452551],
            [13.399051842563749, -2.5393961388066053],
            [13.404044736600888, -2.534748652250614],
            [13.411690516871966, -2.5257464388975963],
            [13.4207398476312, -2.519223049497143],
            [13.431097489711055, -2.517095804927512],
            [13.438983363644672, -2.5193460640845564],
            [13.44212476826858, -2.5277497350560973],
            [13.449578952088304, -2.534119892584184],
            [13.452765485752733, -2.541168144577362],
            [13.454199815254789, -2.5534783999482054],
            [13.45546164277185, -2.558823868604518],
            [13.460329980306712, -2.5665832908213764],
            [13.464714687174748, -2.569502079855276],
            [13.480889571145179, -2.5764117216196647],
            [13.487131826235123, -2.5811451307526188],
            [13.489828660938729, -2.5851253144246384],
            [13.490016698474449, -2.5925288563355324],
            [13.484368765462484, -2.598530427043566],
            [13.47960582155101, -2.6049811444698183],
            [13.479085798493081, -2.614671249555645],
            [13.47602804867265, -2.622795457067423],
            [13.477717417225437, -2.6269694438232527],
            [13.484250352522528, -2.6310321004406303],
            [13.495288919143817, -2.6391348592795927],
            [13.500880725036323, -2.642185939457537],
            [13.507103951811068, -2.6438314568661814],
            [13.510820811890715, -2.649011090712583],
            [13.509845910353535, -2.6624361716932636],
            [13.507822053020703, -2.670348291537455],
            [13.50839937553557, -2.6762042211911554],
            [13.514451411220428, -2.6859625287835494],
            [13.522029914390941, -2.692862886261019],
            [13.53323024376873, -2.7118218238281986],
            [13.534816784753577, -2.71625958269361],
            [13.53470265371796, -2.7248419141973312],
            [13.531142446145038, -2.7317016780680796],
            [13.52740539077565, -2.7423390314996863],
            [13.522705599333289, -2.7505867051963073],
            [13.518895581619258, -2.7550189240104603],
            [13.516343530520913, -2.7602576118777735],
            [13.511182272799793, -2.7656540693211658],
            [13.506095432013318, -2.767807097645203],
            [13.502041850237541, -2.7712322522649866],
            [13.500127154902888, -2.775550754330047],
            [13.497672640388881, -2.789640196517727],
            [13.497066623275689, -2.804711182786089],
            [13.497521732734851, -2.8123960355496185],
            [13.491756989267605, -2.8237669144413484],
            [13.488658493842973, -2.8265484950476276],
            [13.485984803646824, -2.8269309295638982],
            [13.407981571536645, -2.838040413359173],
            [13.324373989994006, -2.8500308194543846],
            [13.241483747276227, -2.861772108990545],
            [13.171548393108944, -2.872258573939346],
            [13.164758980361873, -2.779069283606843],
            [13.159750152321235, -2.710310794784676],
            [13.151920024146104, -2.602894700807753],
            [13.14348159130948, -2.487141222761626]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.10275339038019, "lat": 34.97382102713596 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37007"],
        "coty_name": ["Anson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anson County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01008534"
      },
      "bbox": [
        13.14348159130948, -2.872258573939346, 13.534816784753577,
        -2.4668377830870636
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.305745806246629, -2.653293876848475],
            [14.362688038609697, -2.6271318201989153],
            [14.487896432429036, -2.60395881669832],
            [14.597711016282105, -2.5834220528853846],
            [14.612681229603941, -2.585979474768695],
            [14.619322121180652, -2.577926427788953],
            [14.627922147270832, -2.5726282121037265],
            [14.62771711198044, -2.574476065595258],
            [14.63177002101989, -2.5819954884844782],
            [14.631231292546214, -2.5853789921803028],
            [14.636154766889433, -2.588241711539338],
            [14.639412693895904, -2.5921511047138073],
            [14.641498028803223, -2.589966410485832],
            [14.648098076198606, -2.593347285977355],
            [14.65289184120819, -2.5944440496519636],
            [14.65731526570503, -2.5980474891883465],
            [14.65590680593067, -2.6011383591984236],
            [14.66219761237964, -2.60137453881276],
            [14.664391343783134, -2.6062665061783785],
            [14.664377079652592, -2.610351774026369],
            [14.6717796040881, -2.608186985747626],
            [14.672859445111937, -2.612394034881312],
            [14.677826579591093, -2.6182694425666293],
            [14.678711211784568, -2.6231410066270344],
            [14.685600793161436, -2.627507399757612],
            [14.684436539502007, -2.629299824724486],
            [14.687472366096745, -2.6353221259511637],
            [14.693663227287159, -2.636337344087286],
            [14.69421531268904, -2.64189391397645],
            [14.700028595896955, -2.6443052835109047],
            [14.704388811200282, -2.6509342127837177],
            [14.708584692551078, -2.649440724430474],
            [14.71271102764915, -2.650017728331238],
            [14.714034745599585, -2.653666329242375],
            [14.722369689305072, -2.66182803894139],
            [14.72692880826556, -2.6618520348760235],
            [14.732335621569494, -2.66722832504431],
            [14.730628169815628, -2.6703333121052286],
            [14.735552006061308, -2.6741397127288744],
            [14.733085563062577, -2.680651675851054],
            [14.743100382862004, -2.686207781946353],
            [14.74526580166626, -2.6897945855942984],
            [14.7436287394895, -2.693365076487031],
            [14.74819217925685, -2.6958826186011677],
            [14.74908012492477, -2.700059119772999],
            [14.757016873204044, -2.704147333070341],
            [14.753569413667584, -2.7076863378532705],
            [14.760615406124824, -2.714932422481775],
            [14.764671169993766, -2.7159088921046597],
            [14.76772272138611, -2.713859914977634],
            [14.770606086584245, -2.7160182313807235],
            [14.774841871623341, -2.7135161949778683],
            [14.778145822253528, -2.7163649433314205],
            [14.778920050308214, -2.724768191760178],
            [14.782496584443914, -2.724303826304799],
            [14.785195776647376, -2.7273796176913017],
            [14.790604490039433, -2.730161654919766],
            [14.79621856352739, -2.731180085088036],
            [14.799974838484644, -2.734544627240686],
            [14.79918807245023, -2.738295592006346],
            [14.799918158839441, -2.745825665360182],
            [14.80329410083811, -2.747317592392287],
            [14.802503595066069, -2.751561071915671],
            [14.806537578410742, -2.751604218383984],
            [14.809275801745407, -2.7547898369255353],
            [14.813124067622251, -2.755819596508095],
            [14.814752449215042, -2.759401294895691],
            [14.811947359672173, -2.7626874092329587],
            [14.814072669991173, -2.766372401105513],
            [14.808599041789707, -2.7693679113350287],
            [14.816126047226781, -2.773415593942186],
            [14.816403070447588, -2.7805652382324895],
            [14.819283311924723, -2.7863317310528735],
            [14.823655274790601, -2.78492738011133],
            [14.82495476485841, -2.7898628542709383],
            [14.828835782429866, -2.7950155319416763],
            [14.833200611797135, -2.7970008152862365],
            [14.83844061049949, -2.795239704228769],
            [14.842205810568279, -2.8008727440758614],
            [14.851181759680886, -2.80546351738928],
            [14.854988759767432, -2.8116364168957304],
            [14.857513130574564, -2.8116299629185217],
            [14.860462479471597, -2.8080058851835856],
            [14.86496337033864, -2.81500880806037],
            [14.867799735865173, -2.8163348157357624],
            [14.86875067499046, -2.8197861235887687],
            [14.874632048719297, -2.823370948804404],
            [14.877314594758614, -2.8273305992898625],
            [14.871592838657016, -2.8339825639910923],
            [14.876713841882635, -2.8360783570517296],
            [14.873187798175767, -2.8451707174487995],
            [14.865280318727871, -2.853824107211467],
            [14.867825701405133, -2.8594789121534627],
            [14.871779984915742, -2.861520483138475],
            [14.875280446579113, -2.866716299087751],
            [14.875512124951696, -2.8711226340968903],
            [14.881853875995825, -2.869185667997303],
            [14.881916889934775, -2.872940402738776],
            [14.884530525303749, -2.881209035051299],
            [14.887530555678717, -2.8841831096689345],
            [14.894033161846314, -2.887881300397096],
            [14.895512186155614, -2.886649171776789],
            [14.901531978187982, -2.890517893611882],
            [14.903260643169988, -2.893640377242654],
            [14.91047922071223, -2.894150734982431],
            [14.915673855901902, -2.8930777405804555],
            [14.919923890545729, -2.895972287532473],
            [14.925599511678842, -2.8943055903962494],
            [14.931515628581671, -2.9046065122816294],
            [14.943476102502586, -2.9062107416557335],
            [14.944641971375987, -2.90972091888634],
            [14.955858626928096, -2.9115329489221264],
            [14.904232336468286, -2.9888003355088055],
            [14.848814987307657, -3.0309568455243343],
            [14.846616507312904, -3.0322648308705844],
            [14.82101074442461, -3.031762331673812],
            [14.815555815346192, -3.033667365438136],
            [14.796271278461976, -3.038500709259991],
            [14.776244456500276, -3.0347071086218214],
            [14.756077896674983, -3.0391973078401318],
            [14.661648513453105, -3.012345258403632],
            [14.637897145486534, -3.008334775034314],
            [14.6274919714955, -3.0082023437423207],
            [14.616831250759475, -2.999801938546198],
            [14.60731164542507, -2.9970412514090783],
            [14.600836935004873, -2.9937858977938556],
            [14.58898122320092, -2.9912876702049225],
            [14.578611856226187, -2.9868205348905477],
            [14.576725452000062, -2.987216452456665],
            [14.572357813347988, -2.993345702218447],
            [14.56982114438897, -2.988219787523568],
            [14.565924720211854, -2.9880992861193096],
            [14.562156805662504, -2.9858144417693175],
            [14.56027640883231, -2.9810495571937343],
            [14.557945265577796, -2.98122905322342],
            [14.541439521785378, -2.9856769856683547],
            [14.486420116731392, -2.999398912699697],
            [14.434908317085508, -3.012098199933552],
            [14.430628903709652, -3.012043806604891],
            [14.42386686280195, -3.0081776861872775],
            [14.417933930027827, -3.0079073083478782],
            [14.412456332831983, -3.0038983450224603],
            [14.406193215881448, -3.00438824086856],
            [14.403542249958042, -2.997266880244864],
            [14.400059158664902, -2.994928324522579],
            [14.395552024198931, -2.9957169151758305],
            [14.394805278698172, -2.9934327404734598],
            [14.397617755144232, -2.981776103893791],
            [14.402009170819488, -2.9775637683742904],
            [14.40706409248409, -2.9758489576728135],
            [14.410187750050575, -2.973247446824914],
            [14.411058438943007, -2.9690311170921757],
            [14.404485630123883, -2.9641120175479156],
            [14.399293950953645, -2.9625616225484466],
            [14.40151608245785, -2.959844100710776],
            [14.398339578693488, -2.954928109400104],
            [14.400625567545726, -2.950806065856439],
            [14.397118696261805, -2.9449257519800227],
            [14.393207239396112, -2.942327330019924],
            [14.390923422585594, -2.935358261963179],
            [14.392192629607083, -2.93044195990374],
            [14.389927032979797, -2.927729972068422],
            [14.39120794874611, -2.9224788409038736],
            [14.386861263865974, -2.919923629640108],
            [14.387169719150394, -2.9166006487937035],
            [14.390974704488519, -2.9163898439840574],
            [14.390196421800946, -2.9073030141625718],
            [14.391996284455914, -2.903297815172724],
            [14.39588324838346, -2.902657207142168],
            [14.399034257254984, -2.8990748907434853],
            [14.397537914725515, -2.889891318737786],
            [14.400674089488328, -2.8874035599052243],
            [14.402593602276847, -2.8805591250533373],
            [14.40053853906016, -2.878488571725034],
            [14.402523156523658, -2.8748942393925776],
            [14.403225551048253, -2.8673615263936285],
            [14.39943800585836, -2.8615463360617523],
            [14.398551355748797, -2.855157987764853],
            [14.401840758914338, -2.846054738771642],
            [14.400309217408743, -2.8439449626724276],
            [14.403493184280043, -2.8326842190166],
            [14.405949083846286, -2.8292509374915715],
            [14.406077646607715, -2.8249310398885417],
            [14.409776509464336, -2.822418179478964],
            [14.405632616234353, -2.819997169876215],
            [14.403391256698361, -2.815031845683649],
            [14.403910378563362, -2.8104317002616455],
            [14.406894207729856, -2.806232192298985],
            [14.410158270943365, -2.8052409205280298],
            [14.40865921655679, -2.800259793558072],
            [14.411115927852627, -2.798651126604537],
            [14.409456096833539, -2.7900485361230407],
            [14.409183412392977, -2.7836290331912035],
            [14.403407639943113, -2.779720682640904],
            [14.397556919920323, -2.771005640472823],
            [14.39266526875215, -2.766000494605225],
            [14.387443279759758, -2.763313863273215],
            [14.378302067789251, -2.760191980237906],
            [14.371824892596198, -2.7546609570183804],
            [14.369721153406442, -2.7499531448154246],
            [14.361882764200416, -2.744976658091713],
            [14.358179165403815, -2.733021891928707],
            [14.35145511883573, -2.7245398556335125],
            [14.351318369675377, -2.7220615622669455],
            [14.347339766160829, -2.7148309796504573],
            [14.348286845805243, -2.712351894208921],
            [14.341481749140161, -2.706939966894646],
            [14.341599545545442, -2.7046988908070317],
            [14.3342022912394, -2.696500905046427],
            [14.332861862740636, -2.6922911281036956],
            [14.325693067007956, -2.683828739682883],
            [14.325795767848248, -2.681122499822064],
            [14.321225235440235, -2.674303475089558],
            [14.317273349674348, -2.6731800151301055],
            [14.313268288257596, -2.6668700774890515],
            [14.309402690011428, -2.66336349577591],
            [14.307469221348216, -2.6555301647651333],
            [14.305745806246629, -2.653293876848475]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.56378920945363, "lat": 34.61466419658946 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37017"],
        "coty_name": ["Bladen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bladen County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01026336"
      },
      "bbox": [
        14.305745806246629, -3.0391973078401318, 14.955858626928096,
        -2.5726282121037265
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.458531060471632, -2.20479636596481],
            [14.463542945351671, -2.1953274910339533],
            [14.469927305060654, -2.1893642946666567],
            [14.469172023136801, -2.1840573281414173],
            [14.479311340593986, -2.172663686277533],
            [14.479479129140078, -2.1670933485913744],
            [14.4766401281234, -2.162004945193427],
            [14.477024556782938, -2.1544884877554686],
            [14.475220234954115, -2.1528879915867596],
            [14.477036076668682, -2.1476028225308057],
            [14.481786221208242, -2.148977431118176],
            [14.484476132980497, -2.146614035525996],
            [14.485382471764964, -2.142076317069811],
            [14.494382661581104, -2.135436940974279],
            [14.495825570472848, -2.132446035948611],
            [14.500844172006504, -2.1304085539726203],
            [14.508202328794805, -2.123118116364202],
            [14.519974138622942, -2.134656135494831],
            [14.524967084122213, -2.141918971712413],
            [14.537305068263416, -2.1533363598896003],
            [14.554920545358815, -2.1688464519492854],
            [14.58902426850126, -2.167325915487883],
            [14.620291782522358, -2.1655373355605962],
            [14.62994488292751, -2.1552309099032096],
            [14.694981483351523, -2.1184777831515453],
            [14.697849370998417, -2.1172066584699847],
            [14.75738701878794, -2.1691816625283797],
            [14.828596868558174, -2.177935133605962],
            [14.830092416338571, -2.1926380945950035],
            [14.83301847651179, -2.213278377810508],
            [14.84028711398888, -2.2445145012071874],
            [14.838365231853684, -2.2678506959269247],
            [14.841479115250198, -2.289157683465627],
            [14.853634461836537, -2.3009248216147133],
            [14.874709351954994, -2.385417308853512],
            [14.897152619002297, -2.4745227802490986],
            [14.891520544588749, -2.5606604801311863],
            [14.889729756171329, -2.5796972012090036],
            [14.886201008950211, -2.6415508161311814],
            [14.928407185020387, -2.6537185905846874],
            [14.94289980770931, -2.6630129341725612],
            [14.947995376385995, -2.6609126681662767],
            [14.953537894928903, -2.6551794749646938],
            [14.957704794456538, -2.6483242081578533],
            [14.96088277506784, -2.6626647018617158],
            [14.931727247849517, -2.697038114769199],
            [14.899701022207877, -2.7781073807157677],
            [14.876713841882635, -2.8360783570517296],
            [14.871592838657016, -2.8339825639910923],
            [14.877314594758614, -2.8273305992898625],
            [14.874632048719297, -2.823370948804404],
            [14.86875067499046, -2.8197861235887687],
            [14.867799735865173, -2.8163348157357624],
            [14.86496337033864, -2.81500880806037],
            [14.860462479471597, -2.8080058851835856],
            [14.857513130574564, -2.8116299629185217],
            [14.854988759767432, -2.8116364168957304],
            [14.851181759680886, -2.80546351738928],
            [14.842205810568279, -2.8008727440758614],
            [14.83844061049949, -2.795239704228769],
            [14.833200611797135, -2.7970008152862365],
            [14.828835782429866, -2.7950155319416763],
            [14.82495476485841, -2.7898628542709383],
            [14.823655274790601, -2.78492738011133],
            [14.819283311924723, -2.7863317310528735],
            [14.816403070447588, -2.7805652382324895],
            [14.816126047226781, -2.773415593942186],
            [14.808599041789707, -2.7693679113350287],
            [14.814072669991173, -2.766372401105513],
            [14.811947359672173, -2.7626874092329587],
            [14.814752449215042, -2.759401294895691],
            [14.813124067622251, -2.755819596508095],
            [14.809275801745407, -2.7547898369255353],
            [14.806537578410742, -2.751604218383984],
            [14.802503595066069, -2.751561071915671],
            [14.80329410083811, -2.747317592392287],
            [14.799918158839441, -2.745825665360182],
            [14.79918807245023, -2.738295592006346],
            [14.799974838484644, -2.734544627240686],
            [14.79621856352739, -2.731180085088036],
            [14.790604490039433, -2.730161654919766],
            [14.785195776647376, -2.7273796176913017],
            [14.782496584443914, -2.724303826304799],
            [14.778920050308214, -2.724768191760178],
            [14.778145822253528, -2.7163649433314205],
            [14.774841871623341, -2.7135161949778683],
            [14.770606086584245, -2.7160182313807235],
            [14.76772272138611, -2.713859914977634],
            [14.764671169993766, -2.7159088921046597],
            [14.760615406124824, -2.714932422481775],
            [14.753569413667584, -2.7076863378532705],
            [14.757016873204044, -2.704147333070341],
            [14.74908012492477, -2.700059119772999],
            [14.74819217925685, -2.6958826186011677],
            [14.7436287394895, -2.693365076487031],
            [14.74526580166626, -2.6897945855942984],
            [14.743100382862004, -2.686207781946353],
            [14.733085563062577, -2.680651675851054],
            [14.735552006061308, -2.6741397127288744],
            [14.730628169815628, -2.6703333121052286],
            [14.732335621569494, -2.66722832504431],
            [14.72692880826556, -2.6618520348760235],
            [14.722369689305072, -2.66182803894139],
            [14.714034745599585, -2.653666329242375],
            [14.71271102764915, -2.650017728331238],
            [14.708584692551078, -2.649440724430474],
            [14.704388811200282, -2.6509342127837177],
            [14.700028595896955, -2.6443052835109047],
            [14.69421531268904, -2.64189391397645],
            [14.693663227287159, -2.636337344087286],
            [14.687472366096745, -2.6353221259511637],
            [14.684436539502007, -2.629299824724486],
            [14.685600793161436, -2.627507399757612],
            [14.678711211784568, -2.6231410066270344],
            [14.677826579591093, -2.6182694425666293],
            [14.672859445111937, -2.612394034881312],
            [14.6717796040881, -2.608186985747626],
            [14.664377079652592, -2.610351774026369],
            [14.664391343783134, -2.6062665061783785],
            [14.66219761237964, -2.60137453881276],
            [14.65590680593067, -2.6011383591984236],
            [14.65731526570503, -2.5980474891883465],
            [14.65289184120819, -2.5944440496519636],
            [14.648098076198606, -2.593347285977355],
            [14.641498028803223, -2.589966410485832],
            [14.639412693895904, -2.5921511047138073],
            [14.636154766889433, -2.588241711539338],
            [14.631231292546214, -2.5853789921803028],
            [14.63177002101989, -2.5819954884844782],
            [14.62771711198044, -2.574476065595258],
            [14.627922147270832, -2.5726282121037265],
            [14.626966893150456, -2.569773760718121],
            [14.620586419756544, -2.5679717378546267],
            [14.620085710094779, -2.5654497421903866],
            [14.610819798463435, -2.5625841017917135],
            [14.608631236901543, -2.5528030420126044],
            [14.606067501336282, -2.5492472470773513],
            [14.601620815053181, -2.5502990985064278],
            [14.597915225926718, -2.5488827822162556],
            [14.596067026107535, -2.5429004472187464],
            [14.588804362122081, -2.541495805163247],
            [14.579382908781815, -2.536076684786222],
            [14.578014818575339, -2.531957057777166],
            [14.580028797453496, -2.5253826814011746],
            [14.575344877094444, -2.520660929175066],
            [14.57006663804575, -2.523226379032125],
            [14.562475861137969, -2.5214060570917027],
            [14.55865069247389, -2.514585536121138],
            [14.554313980092351, -2.5138203781773782],
            [14.551427493824566, -2.5096733013365022],
            [14.550609899226421, -2.5037943498905553],
            [14.541393744160443, -2.5041865419032088],
            [14.534502684560499, -2.4993723755167507],
            [14.530835886525722, -2.4949315625500796],
            [14.519770906323403, -2.4928517564479464],
            [14.51397287414967, -2.4853614419088763],
            [14.508648971947048, -2.483480329826516],
            [14.500939017056043, -2.478021898307936],
            [14.495320782430422, -2.4722299693289314],
            [14.490670640835566, -2.46933709892778],
            [14.492280035677583, -2.4650981692305134],
            [14.481130825648226, -2.460393847134876],
            [14.479802367522714, -2.4440936572997174],
            [14.474413399765101, -2.4382274831318798],
            [14.47465683152796, -2.43595185152859],
            [14.471148293254318, -2.432697936031128],
            [14.472776777728585, -2.4268673459755146],
            [14.466564504276365, -2.4199198712944314],
            [14.467336784516977, -2.417794675054329],
            [14.462052763559281, -2.4120867625422027],
            [14.46464459716975, -2.4049093318317984],
            [14.461154052962007, -2.399170898113521],
            [14.457133379402675, -2.39554261689177],
            [14.457297990128264, -2.3922731007500078],
            [14.453790613518155, -2.3885664664557686],
            [14.454662875433476, -2.3862783552479274],
            [14.452731339298989, -2.3778051264737288],
            [14.445238860831466, -2.3746296448276674],
            [14.443885554285984, -2.3645689223115993],
            [14.449509061673925, -2.363841197620918],
            [14.453474594032421, -2.360755295881075],
            [14.4517225673603, -2.3566993492508894],
            [14.455339823168096, -2.3540258721683394],
            [14.456795860032424, -2.3508479204591373],
            [14.453904805077162, -2.3433054906693327],
            [14.456392561669334, -2.3411024217712195],
            [14.462041040127792, -2.3400716399747203],
            [14.464630536209393, -2.3367385143752153],
            [14.462051422813195, -2.3318739337050913],
            [14.457613995227756, -2.3359343045389234],
            [14.453630203443538, -2.334774177918058],
            [14.455387699210403, -2.3288973839964555],
            [14.459659480020058, -2.324915771171374],
            [14.461838122926588, -2.3206304268073277],
            [14.463851131939197, -2.3120534966794746],
            [14.461982276089408, -2.3109841279499683],
            [14.45975460910468, -2.303884780683455],
            [14.460881944969625, -2.301689359609004],
            [14.45703573447417, -2.298198156171236],
            [14.457420748098114, -2.2961520660688204],
            [14.462127007525865, -2.293743798490366],
            [14.460973411858705, -2.287924993395119],
            [14.455595424193348, -2.2860110736756543],
            [14.45750027213472, -2.2816355007258426],
            [14.460477719073172, -2.2821609498380533],
            [14.461127284390265, -2.2777863677864016],
            [14.457213180072538, -2.275595112671058],
            [14.452904295922632, -2.2710976186785685],
            [14.45123363317225, -2.267431156606689],
            [14.453623715341296, -2.261089174960092],
            [14.449967267069864, -2.260986159228114],
            [14.444209902100408, -2.257707813351319],
            [14.447039386909987, -2.25299046619174],
            [14.451219349448518, -2.2551965521712622],
            [14.454751572975287, -2.251208035071842],
            [14.457358979443958, -2.2512041752254492],
            [14.460403554760818, -2.247231552455076],
            [14.455272510605162, -2.244221681414578],
            [14.45159981970543, -2.2388778741094897],
            [14.453048688200473, -2.234879216568923],
            [14.4576428559, -2.2304767950006474],
            [14.460566866727564, -2.221089149363703],
            [14.459157543143641, -2.216629096620346],
            [14.46119321029389, -2.2124169721595286],
            [14.458531060471632, -2.20479636596481]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.37145547568342, "lat": 34.991592739158 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37163"],
        "coty_name": ["Sampson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sampson County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01026131"
      },
      "bbox": [
        14.443885554285984, -2.8360783570517296, 14.96088277506784,
        -2.1172066584699847
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.666706160754512, -0.8328163320152807],
            [14.781060044285436, -0.8103563207295728],
            [14.783047504885674, -0.8219640158614694],
            [14.78897419681389, -0.8503664257486883],
            [14.786804290076407, -0.864469132742978],
            [14.787165208827979, -0.8818852266994234],
            [14.791115416562624, -0.9131239812149249],
            [14.7876444858265, -0.9154032149342619],
            [14.78590315275451, -0.9210723174520492],
            [14.7874673393424, -0.9254182940950189],
            [14.794387181085147, -0.9312594242721877],
            [14.80251046196156, -0.9729742150231112],
            [14.799031145446914, -1.0086907837413934],
            [14.796692890805389, -1.0300298991452508],
            [14.794667119658095, -1.0607376688985095],
            [14.793653329580103, -1.0652573249660078],
            [14.782722714252749, -1.1004535557444823],
            [14.779562875174687, -1.109701730387954],
            [14.762586580485657, -1.1654379872853693],
            [14.760437241837991, -1.1634350301783611],
            [14.75445911589766, -1.1632451531949766],
            [14.749657488302867, -1.165024375001363],
            [14.74704275749869, -1.1613788575734116],
            [14.74238095584172, -1.1606731236384844],
            [14.741099477688255, -1.1648000921425665],
            [14.737013444280613, -1.162386157550416],
            [14.73152897964486, -1.1621987598747088],
            [14.730036353784337, -1.1584831738042711],
            [14.72131817116291, -1.1646513733040036],
            [14.713173143038908, -1.1606772742987548],
            [14.709169295929785, -1.1615278929642492],
            [14.705404748982463, -1.167345255152444],
            [14.700490688303917, -1.1670436874185663],
            [14.698047018856705, -1.171612009828808],
            [14.69194744580462, -1.1711321648086606],
            [14.685579054193607, -1.1735611032489983],
            [14.680106945872028, -1.1734559304616168],
            [14.67801688028005, -1.1674270690474198],
            [14.675486096086571, -1.1681473099816475],
            [14.671818175451111, -1.162272880927765],
            [14.664551090535625, -1.1598138362083488],
            [14.661886627265568, -1.1503672986562403],
            [14.657921517186322, -1.1465902074624492],
            [14.655263405902344, -1.1410799473534754],
            [14.65094646359199, -1.1405798028812903],
            [14.647772572930657, -1.1427539334257917],
            [14.644714036207578, -1.1423059528414974],
            [14.636585258438792, -1.1465458999072304],
            [14.633307421565203, -1.145949067171818],
            [14.627817133703573, -1.14097288976425],
            [14.622077591374152, -1.138076594581829],
            [14.610746889453518, -1.1481259272646576],
            [14.606852215629905, -1.1496982509939755],
            [14.603480509139853, -1.1473419974801773],
            [14.593626171982164, -1.1464024597862152],
            [14.588969365892781, -1.1478613630621055],
            [14.58100774546455, -1.1446145318062286],
            [14.576902301700763, -1.1460258908631753],
            [14.574679215729116, -1.144662253938938],
            [14.567887778261344, -1.145360822785302],
            [14.514770588469004, -1.147218075469725],
            [14.51654785737759, -1.1394728525668842],
            [14.52254753979545, -1.1270570282318095],
            [14.522866917785734, -1.121014562695359],
            [14.53068725266985, -1.1031990263586542],
            [14.489428166175584, -0.9867799855705283],
            [14.44958777433511, -0.874361353854203],
            [14.510884610918753, -0.8621841429570982],
            [14.598998504684625, -0.8460941851376311],
            [14.666706160754512, -0.8328163320152807]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.10665389404343, "lat": 36.39650147314663 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37185"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "01008593"
      },
      "bbox": [
        14.44958777433511, -1.1735611032489983, 14.80251046196156,
        -0.8103563207295728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.051489938759936, 2.685906669290247],
            [-4.046742548512774, 2.7587595048287175],
            [-4.040931562243924, 2.8456342565191792],
            [-4.040092625628741, 2.8603330143744343],
            [-3.9875943557392235, 2.8568562460192997],
            [-3.8930905618985796, 2.851138080326432],
            [-3.7985876388501882, 2.8454054496633474],
            [-3.7132354209358183, 2.8405039895414297],
            [-3.6563420607438313, 2.8371093720684826],
            [-3.5586571225333943, 2.831558553674348],
            [-3.5284162157250614, 2.8298831193151606],
            [-3.4564573118517257, 2.8253330963164154],
            [-3.4610902622952975, 2.741393798137775],
            [-3.4614310101280736, 2.738243329963446],
            [-3.4671527878473944, 2.636560091007437],
            [-3.4689341733855907, 2.6092498752199718],
            [-3.4721470376721246, 2.55397342560944],
            [-3.4724577875336697, 2.545781483873563],
            [-3.4763849620975305, 2.475922834438157],
            [-3.461285080158551, 2.475079982155024],
            [-3.463563328780151, 2.4313839840670908],
            [-3.549165815377342, 2.4362201974307345],
            [-3.592247297933789, 2.43733540102255],
            [-3.608037996196144, 2.4387315858515017],
            [-3.6344803586213215, 2.440291551966684],
            [-3.662984860908147, 2.4415471674076796],
            [-3.6990012309657225, 2.44360998999451],
            [-3.7348634606944144, 2.445909074382151],
            [-3.7781723981865234, 2.4491356130110153],
            [-3.785167570257765, 2.4492910652984627],
            [-3.8640260278566116, 2.4537959741995286],
            [-3.892035911636759, 2.4552175228746203],
            [-3.920688103515568, 2.4572549732846998],
            [-4.048756299630577, 2.4653003009349774],
            [-4.062596329128302, 2.466932580043449],
            [-4.0598365557700005, 2.5107276673740797],
            [-4.062612053156523, 2.510925714643732],
            [-4.060047444835114, 2.5547086297049653],
            [-4.051489938759936, 2.685906669290247]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.66149255670355,
          "lat": 41.19884680932594
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31101"],
        "coty_name": ["Keith"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Keith County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00835872"
      },
      "bbox": [
        -4.062612053156523, 2.4313839840670908, -3.4564573118517257,
        2.8603330143744343
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.252751762256486, 3.4646587267939797],
            [-2.234653170383463, 3.4638935202712293],
            [-2.2263205603341443, 3.4638982691768],
            [-2.081110603292856, 3.4588079733299884],
            [-2.0107084134974897, 3.4565509634413707],
            [-2.0105029179997445, 3.4563566321042076],
            [-1.9195542198887232, 3.4544740738020185],
            [-1.9107952375382629, 3.4540974974449155],
            [-1.913642303494045, 3.3672286514624434],
            [-1.916493356227922, 3.2799224267033145],
            [-1.9200245549993349, 3.1709426322620615],
            [-1.9209415359648616, 3.1337836361393125],
            [-1.921980135973512, 3.105208834414214],
            [-1.9673256452056802, 3.1074091767527174],
            [-1.9916842153341539, 3.1080797731567977],
            [-2.0388150767368884, 3.1099817801178506],
            [-2.170825986120919, 3.1140338744204237],
            [-2.266165495631819, 3.1172361202026737],
            [-2.2625144218625013, 3.20526357319225],
            [-2.2603466847235705, 3.2561238980891303],
            [-2.2557473488456137, 3.3792195179229334],
            [-2.252751762256486, 3.4646587267939797]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.45439511284859, "lat": 41.91385408541987 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31115"],
        "coty_name": ["Loup"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Loup County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00835879"
      },
      "bbox": [
        -2.266165495631819, 3.105208834414214, -1.9107952375382629,
        3.4646587267939797
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.881262315249259, 3.7783017203906035],
            [-0.7957261569609172, 3.776980803205383],
            [-0.6979064009025822, 3.7756124987519364],
            [-0.6826043701933231, 3.775625806144201],
            [-0.6252876899592741, 3.77473856322139],
            [-0.5389869689129085, 3.7736439194486757],
            [-0.5403441163964889, 3.686355012667146],
            [-0.541758159733683, 3.5989526350652805],
            [-0.5430183554227243, 3.5190205591880153],
            [-0.5432258865950511, 3.5116230637130657],
            [-0.5442879797316201, 3.438598222221125],
            [-0.5446256965067543, 3.424176053434084],
            [-0.6877772938528715, 3.4259111501527064],
            [-0.689246471682843, 3.4257593447115844],
            [-0.8023182327664976, 3.4276534911617342],
            [-0.8868085482094634, 3.428863205828475],
            [-0.8881001100078585, 3.4287754780215485],
            [-0.8881911142732817, 3.429367398102784],
            [-0.8862887845011012, 3.5380324763639015],
            [-0.8851485123140694, 3.596326569491757],
            [-0.882958023307864, 3.6907568491555054],
            [-0.881262315249259, 3.7783017203906035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.60129703513643, "lat": 42.26434320071018 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31139"],
        "coty_name": ["Pierce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pierce County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00835891"
      },
      "bbox": [
        -0.8881911142732817, 3.424176053434084, -0.5389869689129085,
        3.7783017203906035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.41902148141272, 4.188881028717365],
            [-5.41562199630612, 4.227160630645238],
            [-5.40692803365175, 4.331651547327991],
            [-5.38610727169448, 4.577472383580555],
            [-5.341118356292819, 4.574788809950294],
            [-5.3231389703517085, 4.57329784826666],
            [-5.293238108118626, 4.570005624824257],
            [-5.213953933417598, 4.563809313659681],
            [-5.212761399791492, 4.563810923548373],
            [-5.141138381094347, 4.557567979934311],
            [-5.096040143018974, 4.554353921128693],
            [-5.071027170723168, 4.55161231829379],
            [-4.988927099079139, 4.545178660239987],
            [-4.9920577306599725, 4.5028506979208665],
            [-4.997766922484943, 4.423190397671976],
            [-5.004587942212453, 4.329286431295656],
            [-4.988041472515454, 4.327978162108628],
            [-4.993409506963384, 4.26010499506071],
            [-4.998371240591822, 4.20156368086399],
            [-5.002368028945824, 4.147971204599371],
            [-5.002298685975475, 4.146862380788175],
            [-5.009001908877503, 4.062336420797081],
            [-5.012970584912777, 4.00915473325526],
            [-5.0153067774729685, 3.980152249992333],
            [-4.9891864199355975, 3.9781102525246954],
            [-5.000491759470575, 3.8340826205325023],
            [-5.006030851589688, 3.7613832101139746],
            [-5.009647639299276, 3.718476179826643],
            [-5.016361902848401, 3.6310276930024012],
            [-4.98514906642063, 3.628290524922953],
            [-4.99028595515605, 3.5585688883236495],
            [-4.99190463260439, 3.541234242580234],
            [-5.034987467161118, 3.5452685060933464],
            [-5.122910024666325, 3.551230911055995],
            [-5.1890436172495695, 3.555535020118241],
            [-5.2812484774822215, 3.5620881855246873],
            [-5.324453379987495, 3.5648007761433345],
            [-5.338846239460603, 3.5659586510710226],
            [-5.463529600848609, 3.577779106743769],
            [-5.470941054522105, 3.578368502623251],
            [-5.469363069870845, 3.5984413622168447],
            [-5.4636804520335485, 3.6658582047996404],
            [-5.460362479125146, 3.7017688517833744],
            [-5.459609381875169, 3.7141000288596167],
            [-5.456619254704621, 3.7471481370494306],
            [-5.450096484101656, 3.8269373607506783],
            [-5.4489103266844205, 3.837878975578938],
            [-5.4287862402935705, 4.077087981855903],
            [-5.41902148141272, 4.188881028717365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.75888252785798,
          "lat": 42.48766429635672
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31165"],
        "coty_name": ["Sioux"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sioux County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00835904"
      },
      "bbox": [
        -5.470941054522105, 3.541234242580234, -4.98514906642063,
        4.577472383580555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5707869730548756, 3.444015413828013],
            [-1.5355162206989137, 3.442995150995714],
            [-1.4536419282097697, 3.440826886858449],
            [-1.3607844117897303, 3.438403350237387],
            [-1.2886193231582082, 3.4365965818387174],
            [-1.2314908881028441, 3.4353314507545205],
            [-1.2276933270860837, 3.435259888303958],
            [-1.2295573489061258, 3.362438244882715],
            [-1.232044386295385, 3.260453580088288],
            [-1.2343809715022056, 3.1731196542105806],
            [-1.236389101491184, 3.0857203634046524],
            [-1.3108986610284525, 3.087368088826339],
            [-1.378852724358027, 3.088645163411973],
            [-1.4176660837931767, 3.0896385094720293],
            [-1.5743619302756096, 3.0938735565700424],
            [-1.5794757757508158, 3.0940317163242037],
            [-1.5797079946353532, 3.1037262568169774],
            [-1.5778480999756397, 3.1812991048162886],
            [-1.575504628648176, 3.26841689947058],
            [-1.5737126097226735, 3.33922829722245],
            [-1.5730851620724806, 3.355560196637967],
            [-1.5707869730548756, 3.444015413828013]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.52818871585833,
          "lat": 41.914757144982424
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31183"],
        "coty_name": ["Wheeler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wheeler County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00835913"
      },
      "bbox": [
        -1.5797079946353532, 3.0857203634046524, -1.2276933270860837,
        3.444015413828013
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.775377619643695, 2.7831283088362944],
            [-17.77295496959567, 2.782588556614699],
            [-17.6833889677714, 2.7593865842740355],
            [-17.68204441907507, 2.764664879357749],
            [-17.66807624145483, 2.7613328481333332],
            [-17.66474953597679, 2.7755664078040847],
            [-17.657839881988497, 2.7739174061448972],
            [-17.65601414639777, 2.7810148830500614],
            [-17.649008571372605, 2.7793566226837063],
            [-17.647134964648135, 2.7868134176136725],
            [-17.634322080137746, 2.783579698428482],
            [-17.63253775555355, 2.7905856558999425],
            [-17.62568458299885, 2.7888706013807063],
            [-17.619380643555864, 2.788719485608949],
            [-17.611798930240035, 2.785336425219447],
            [-17.610000732339792, 2.7923710692379435],
            [-17.589178431142223, 2.787103892942266],
            [-17.585544262358688, 2.8013164020737045],
            [-17.571624302542865, 2.797828639890698],
            [-17.56794994781723, 2.811974488248473],
            [-17.561309632435357, 2.809948956555002],
            [-17.540623861071236, 2.804907548326894],
            [-17.537010243970197, 2.810843099583107],
            [-17.536570441261414, 2.810913271115685],
            [-17.52478904041598, 2.7644013452511738],
            [-17.502789404417083, 2.744074310287775],
            [-17.45247905338121, 2.7311619267692273],
            [-17.438608960223082, 2.7271555316928993],
            [-17.438136757942583, 2.722374856714521],
            [-17.44196092797575, 2.71143603203872],
            [-17.443407884706573, 2.710311170096515],
            [-17.449783724582247, 2.699586766895995],
            [-17.454871973930388, 2.693243070260142],
            [-17.45823984186744, 2.6910843299594416],
            [-17.45682688739739, 2.6878004933011064],
            [-17.458425224879935, 2.6823425899637185],
            [-17.45750462083935, 2.6772212615766056],
            [-17.45270605592444, 2.6703391541993],
            [-17.4539971759182, 2.6661568869715415],
            [-17.45488558831145, 2.6523736278697956],
            [-17.457385849745148, 2.6449296524548145],
            [-17.45765615165843, 2.63669299996428],
            [-17.454497694400107, 2.632422057234678],
            [-17.45541708312291, 2.6245211173450675],
            [-17.457135771251668, 2.6193158008915725],
            [-17.45772419213402, 2.6189776293450855],
            [-17.538193148344746, 2.6396946812525615],
            [-17.55215261034305, 2.6418880146686274],
            [-17.565887482639027, 2.6455870568716318],
            [-17.607787256989518, 2.6561477954684496],
            [-17.60419135857179, 2.6704504297892293],
            [-17.610915946135286, 2.6721465820141783],
            [-17.607293808090876, 2.6863163180436733],
            [-17.639246772367564, 2.694280426377172],
            [-17.69931233514473, 2.7086645529128486],
            [-17.728198901095556, 2.715945198049914],
            [-17.787906387302733, 2.731251945942628],
            [-17.775377619643695, 2.7831283088362944]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.74757852312494,
          "lat": 39.15113195149387
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32510"],
        "coty_name": ["Carson City"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Carson City"],
        "coty_fp_code": "510",
        "coty_gnis_code": "00863219"
      },
      "bbox": [
        -17.787906387302733, 2.6189776293450855, -17.438136757942583,
        2.811974488248473
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.52164771465059, 3.8149161977871215],
            [16.52653589012212, 3.816644174229148],
            [16.52718813250726, 3.8225646175506465],
            [16.525642484594083, 3.8281185518796876],
            [16.533651362460486, 3.834406653006178],
            [16.536841344221273, 3.8391363535355314],
            [16.542434071567076, 3.8502172250623037],
            [16.547546200805144, 3.853995308557057],
            [16.548448982272095, 3.85858682381442],
            [16.551864389828836, 3.85978657274427],
            [16.55192339048041, 3.863120769480141],
            [16.554935349098606, 3.8686895568049326],
            [16.559381403712116, 3.868765238984045],
            [16.562927376987233, 3.8708468610473585],
            [16.561327934176816, 3.877647773942229],
            [16.56629736569236, 3.8778696126473196],
            [16.570010157811044, 3.8844615519240264],
            [16.5675476747572, 3.886721834601579],
            [16.573620253982668, 3.8899806529955314],
            [16.57202171175448, 3.8948376583880537],
            [16.58222328589976, 3.8934098079063006],
            [16.591054752445455, 3.8895085383297068],
            [16.59765716811372, 3.885061299849184],
            [16.610935317261923, 3.8805298013825755],
            [16.61704426582964, 3.8842111104953676],
            [16.623263409765315, 3.881058053058864],
            [16.62758734052285, 3.8804702731943053],
            [16.632143120051598, 3.883495491427647],
            [16.63360079402294, 3.8887634086215406],
            [16.639354680768243, 3.892361532931233],
            [16.66269770599092, 3.8887572908454113],
            [16.689028332867913, 3.888600401293979],
            [16.697046914866903, 3.883819483913481],
            [16.702137059983897, 3.87446561094524],
            [16.708480765202264, 3.8719138794309473],
            [16.731882199370816, 3.879236206159338],
            [16.734618240725915, 3.881470184477094],
            [16.740847729964738, 3.8785741010060177],
            [16.74378395950406, 3.87922333657858],
            [16.752679746556158, 3.8746694803329045],
            [16.757560030137753, 3.870023894383175],
            [16.753110771058537, 3.854597681659964],
            [16.746938496776714, 3.8560174881755422],
            [16.73974785461874, 3.843823395491484],
            [16.73328410580264, 3.837369464455987],
            [16.730011500653635, 3.835843740205596],
            [16.719987055855594, 3.819849195003362],
            [16.719066620128547, 3.8120097579851957],
            [16.72198722290532, 3.80486948392807],
            [16.723975887020433, 3.7920043746774748],
            [16.72861117662276, 3.7887927978588336],
            [16.72912325078076, 3.7842486807503493],
            [16.727336037218958, 3.7802633960759153],
            [16.72166181451817, 3.7835341569973426],
            [16.719921507177393, 3.7877798345073623],
            [16.708174244308733, 3.78091697745336],
            [16.703007164384623, 3.7835348242975995],
            [16.69875377619715, 3.779395750870139],
            [16.690705128399244, 3.7788621888778358],
            [16.68689919164493, 3.7795362591697033],
            [16.686663455849818, 3.7743526179737232],
            [16.66494725097193, 3.763769326572332],
            [16.656866582977997, 3.768271028056884],
            [16.6523604699504, 3.769774516342078],
            [16.652275468497944, 3.7781214940034165],
            [16.542288219223867, 3.739406303481977],
            [16.53683565176253, 3.7416502914238126],
            [16.54255787299287, 3.747955211730964],
            [16.54498929611203, 3.748507660295959],
            [16.547674858219388, 3.754357952441574],
            [16.552845965944144, 3.75620893262573],
            [16.556481136375357, 3.7632381168196356],
            [16.558728227441037, 3.7645885093028513],
            [16.561126439394535, 3.7696564609142884],
            [16.560702923966144, 3.7740378967747104],
            [16.563875327718627, 3.777166821400367],
            [16.56467144330592, 3.7816021915707805],
            [16.56326264915391, 3.790569036225695],
            [16.566740676292206, 3.795186986062931],
            [16.56823526464811, 3.8080152925508095],
            [16.56717931073216, 3.815879391780262],
            [16.56401248480393, 3.8187165833285532],
            [16.555458168731317, 3.8063979875180007],
            [16.54650288739365, 3.8118226172208667],
            [16.542327395459616, 3.8093071874275046],
            [16.53839617860717, 3.8023976630972482],
            [16.533501967241637, 3.7976527180800983],
            [16.52164771465059, 3.8149161977871215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.30998964525223, "lat": 40.66009746717585 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34039"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00882235"
      },
      "bbox": [
        16.52164771465059, 3.739406303481977, 16.757560030137753,
        3.8948376583880537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.053786665938594, -5.717027062903713],
            [8.05625573299985, -5.716604525713534],
            [8.13834034555859, -5.712991740695725],
            [8.17580541563881, -5.708766206064328],
            [8.224139811815462, -5.703046037023283],
            [8.219135822332552, -5.659320418810822],
            [8.293357417517688, -5.651343099133498],
            [8.29705250353121, -5.651112908356277],
            [8.351784947476713, -5.645024251087335],
            [8.376770181828222, -5.642416416192034],
            [8.44745098207548, -5.634185888366557],
            [8.46960279515645, -5.632789881278031],
            [8.477087065556933, -5.703975466025286],
            [8.479674636228504, -5.72744391714834],
            [8.488495712429323, -5.811120575750162],
            [8.490869071548591, -5.835440976742061],
            [8.492389710513539, -5.84739488343104],
            [8.501349348003545, -5.928731647510955],
            [8.49049587837655, -5.937362483283529],
            [8.474341491334936, -5.941594332257196],
            [8.466892502541645, -5.937348952136546],
            [8.46201891187325, -5.936909637895295],
            [8.460142672743492, -5.939367138722974],
            [8.462703174523664, -5.946841877951334],
            [8.46058078305915, -5.954508084087352],
            [8.461675528254425, -5.964680030246787],
            [8.45682466311129, -5.970088189479677],
            [8.45118216668722, -5.9795155399563695],
            [8.442857995567577, -5.97785514203407],
            [8.438486087858065, -5.980875436960552],
            [8.438033926882985, -5.983674101176977],
            [8.44128727225101, -5.992289069550972],
            [8.441115831143525, -5.998254160050894],
            [8.436409539344382, -6.0010702561808325],
            [8.417354682788423, -6.00709295705072],
            [8.407076996206374, -6.00968067640517],
            [8.40291152634184, -6.0075956360715885],
            [8.400815548123965, -6.003846875840309],
            [8.396238434633359, -5.985895591488923],
            [8.391184388892118, -5.980644311951359],
            [8.381970658424533, -5.981768130237076],
            [8.37167468027416, -5.976785884896615],
            [8.367521232535944, -5.976117716845563],
            [8.362209397117873, -5.97770929461498],
            [8.35759228036925, -5.98547095090674],
            [8.356220033201732, -5.991257668428442],
            [8.352314590278926, -5.99242711566881],
            [8.334725651698575, -5.981178680801036],
            [8.3326806308319, -5.975714891198567],
            [8.334166260260204, -5.96145611798394],
            [8.333127456745165, -5.955789330643685],
            [8.328968525909307, -5.950141412989857],
            [8.324818701805858, -5.949615485430711],
            [8.320309237423475, -5.953956365962196],
            [8.306402209063307, -5.95579872423777],
            [8.301601267777928, -5.959263596619042],
            [8.299857015968952, -5.962487531851881],
            [8.299070822104168, -5.970191405758349],
            [8.30149304827897, -5.9779942940353],
            [8.300469912516466, -5.982656434979112],
            [8.291613132578192, -5.994647385470505],
            [8.283123739092982, -6.005242352721324],
            [8.27709230857245, -6.007463883874736],
            [8.267714614617757, -6.004503177316015],
            [8.25538146284292, -6.002518842203186],
            [8.252848184034017, -6.000635915784476],
            [8.251330281061831, -5.995889073670704],
            [8.247843675723233, -5.991908655683761],
            [8.247063595492534, -5.983603366435617],
            [8.245187071169335, -5.972982199519689],
            [8.246513136364094, -5.967982887085015],
            [8.245774165969184, -5.961209266495478],
            [8.243023537924845, -5.959469658722032],
            [8.237850432995577, -5.960289919653006],
            [8.234273184038637, -5.9661070884729535],
            [8.22658100264184, -5.974192776325303],
            [8.220299705503297, -5.977461465739253],
            [8.2140867599241, -5.977929877610518],
            [8.208807896567786, -5.9769770158747875],
            [8.203571489628954, -5.974190130962647],
            [8.198993585422352, -5.973454058212462],
            [8.193744737381449, -5.976630656421251],
            [8.193322849606414, -5.980305423627118],
            [8.195105450899254, -5.9895817818565655],
            [8.195184447902292, -5.998800671448562],
            [8.196829585940812, -6.000337264669125],
            [8.205636083172722, -6.027484035970236],
            [8.193195607498572, -6.0549214372521725],
            [8.187756444041938, -6.061452262333876],
            [8.177370792278401, -6.06351721624247],
            [8.172699134426422, -6.061561167915114],
            [8.168724758248825, -6.056885116730698],
            [8.166415021466001, -6.03879416423529],
            [8.167086357361125, -6.035154640196986],
            [8.170708144062402, -6.030783681994545],
            [8.174980619134251, -6.025652572217195],
            [8.176203520695589, -6.02242865790186],
            [8.17569418482657, -6.016688741498491],
            [8.167388915809545, -6.000949765446458],
            [8.156710150083452, -5.993946952232641],
            [8.150311342117051, -5.983688985101268],
            [8.14414403295617, -5.97833176874499],
            [8.140814217670187, -5.973776352636384],
            [8.13791561518013, -5.9647025416114055],
            [8.137951185468046, -5.958981474487363],
            [8.145060881813754, -5.953548670345799],
            [8.151947172580007, -5.952277090919496],
            [8.154638190406718, -5.9495694027524815],
            [8.150983161278749, -5.944876532435698],
            [8.13964842266421, -5.942370030121882],
            [8.132018122151443, -5.936534172388274],
            [8.119851713759566, -5.936576540935926],
            [8.117848109965964, -5.932434147596216],
            [8.12243217252691, -5.925092644879797],
            [8.117647998875315, -5.917582466723061],
            [8.114210506284687, -5.918395359053076],
            [8.111771027784041, -5.91270577842624],
            [8.112090517145234, -5.9076499875746],
            [8.105850799623425, -5.902680948645802],
            [8.10486171800751, -5.898723076131962],
            [8.09962769424757, -5.896542164021872],
            [8.102123430823031, -5.893914688092773],
            [8.102751761806587, -5.889635010674702],
            [8.099607594975831, -5.887474017391707],
            [8.097532956738135, -5.881488374371727],
            [8.091494889016552, -5.8730055817751445],
            [8.090970057669605, -5.865578936086744],
            [8.087286902543157, -5.863868914873266],
            [8.086578157564979, -5.857909828226737],
            [8.078168532362803, -5.848476441979124],
            [8.078785295913942, -5.843068830679778],
            [8.075049019350358, -5.842854761810203],
            [8.075089288259417, -5.826165034303702],
            [8.079083903259058, -5.822356112424577],
            [8.07913719935765, -5.811598285678073],
            [8.075903078956284, -5.8043264960233305],
            [8.077862630342016, -5.801910825491674],
            [8.073110933799128, -5.796378974991811],
            [8.072287134886846, -5.7872048406072025],
            [8.069659421694173, -5.782551333128926],
            [8.068539565990962, -5.775565331806474],
            [8.065802629362917, -5.772199676496694],
            [8.064595832876746, -5.762284290033327],
            [8.062437038135286, -5.760765246316309],
            [8.06151934701599, -5.755617232463938],
            [8.06276789745132, -5.75143963917011],
            [8.057458156245952, -5.740515611416334],
            [8.054677268580042, -5.736940381456694],
            [8.059067424585065, -5.733005833286739],
            [8.054552212994986, -5.729836290570743],
            [8.051590631317232, -5.725218417819822],
            [8.053786665938594, -5.717027062903713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.64273442675476, "lat": 32.53492727525607 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01001"],
        "coty_name": ["Autauga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Autauga County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00161526"
      },
      "bbox": [
        8.051590631317232, -6.06351721624247, 8.501349348003545,
        -5.632789881278031
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.8180258561115785, -6.597460257144682],
            [6.8187465623019365, -6.5580393114052145],
            [6.821726266323471, -6.45110123032887],
            [6.824878307969032, -6.317509966838827],
            [6.826667990946857, -6.2623956713042155],
            [6.827399197393819, -6.239795353314662],
            [6.828435940357588, -6.181027235985083],
            [6.954140408819987, -6.171959436469843],
            [7.033928336175529, -6.165042616180358],
            [7.0456632333502585, -6.164135340305522],
            [7.079290776812758, -6.160751115033249],
            [7.239496010555736, -6.145408871622038],
            [7.241373610511321, -6.1479052876209925],
            [7.239677068346473, -6.158743076953472],
            [7.243453989878231, -6.1678755171365935],
            [7.243271071545651, -6.170224125327015],
            [7.239477265086464, -6.173705727154229],
            [7.234193430099418, -6.17484857589625],
            [7.230132475340923, -6.173906798105095],
            [7.229764781196988, -6.170068123158023],
            [7.23461511755922, -6.162725099153879],
            [7.2351485379540845, -6.154714444894411],
            [7.23071916992554, -6.151633124868162],
            [7.225226490772003, -6.153119228973784],
            [7.223356000972251, -6.155918283621183],
            [7.2181242975413245, -6.15970595295585],
            [7.211333094442636, -6.16125135388239],
            [7.209353104001979, -6.160316774195101],
            [7.204592797713415, -6.153070144563984],
            [7.202026036749699, -6.151305059917433],
            [7.197143474387804, -6.154163247390156],
            [7.192380438402536, -6.163822734624022],
            [7.189969662815002, -6.165591949698139],
            [7.182531035124107, -6.163662558261352],
            [7.177517739760951, -6.165989667382165],
            [7.17674931087689, -6.168123279295021],
            [7.180142620284523, -6.177377287707094],
            [7.178086445893615, -6.178946782625722],
            [7.1701189975612545, -6.176152898142662],
            [7.167508469393778, -6.176877889228717],
            [7.16782621440191, -6.19036193634713],
            [7.169415846113935, -6.193066167769445],
            [7.177617164107962, -6.19963646495148],
            [7.17934583669193, -6.212120817403819],
            [7.1748584338565955, -6.221711671541188],
            [7.175183081632374, -6.226680467703209],
            [7.180217853849548, -6.234769477842334],
            [7.182813557729159, -6.24170570636788],
            [7.182558936033266, -6.247718405111413],
            [7.180217086874284, -6.255010770318239],
            [7.179957657025084, -6.259735116561362],
            [7.184634054108172, -6.269123455702175],
            [7.186058739456034, -6.275531289468698],
            [7.182804401666909, -6.297735526783583],
            [7.179139298907042, -6.3130349454126415],
            [7.176684336631155, -6.317509848825351],
            [7.165338702881019, -6.317669866179726],
            [7.162418273078918, -6.3233308422367065],
            [7.161540566365328, -6.341944522750792],
            [7.1562452353853025, -6.3552099419360255],
            [7.155208155884315, -6.3618574270093005],
            [7.156585148537164, -6.364824743722169],
            [7.161340399631923, -6.369700399675392],
            [7.1634868753438905, -6.376517186892514],
            [7.162199944807928, -6.381597581506514],
            [7.1550521051344536, -6.386482598656945],
            [7.150725410197714, -6.391899803577534],
            [7.1461044382548, -6.401146248688218],
            [7.14309824898129, -6.403023594813778],
            [7.136369468130211, -6.3980296653629445],
            [7.13043877093059, -6.394931158192893],
            [7.124708606698504, -6.395163772102796],
            [7.121176828538072, -6.396678019034719],
            [7.106867173643211, -6.4096777970050995],
            [7.104318254295332, -6.41286554063164],
            [7.103865873197995, -6.416867025734999],
            [7.1088513395611574, -6.4264283133322095],
            [7.109031864773255, -6.43644437240474],
            [7.107487651274364, -6.450944926194035],
            [7.111605423329011, -6.461204876369078],
            [7.1204258404100225, -6.46989216083435],
            [7.128273730485775, -6.473012475972139],
            [7.1315046106324855, -6.468951705346464],
            [7.128348971426478, -6.463815023292424],
            [7.129611884227746, -6.458903250471054],
            [7.134573548237927, -6.4613534085227196],
            [7.137423510522313, -6.466930057103427],
            [7.146668621371273, -6.4743880968435406],
            [7.153262217866506, -6.480899315356319],
            [7.1469270803700855, -6.485586359920262],
            [7.1458472218816755, -6.489205454783241],
            [7.14701032182345, -6.494401422275644],
            [7.152069155266638, -6.502513408639246],
            [7.151602988813669, -6.505572467184756],
            [7.145731878376049, -6.511188969838809],
            [7.143457973481959, -6.51099401559706],
            [7.138646873759763, -6.5040593283640495],
            [7.135439727594876, -6.501808803896368],
            [7.129266229683386, -6.501040023996718],
            [7.109677846110553, -6.517447942508243],
            [7.108907928116493, -6.520097813370758],
            [7.114130152985295, -6.528071544204541],
            [7.123026511532711, -6.524405439639603],
            [7.126627701276457, -6.526327210524649],
            [7.132133696854913, -6.533392828386564],
            [7.137407531215411, -6.542246045869757],
            [7.140092108662854, -6.54330361058614],
            [7.149759322957883, -6.533923644519131],
            [7.15598702250437, -6.526985618368162],
            [7.16093119478124, -6.5292700842331515],
            [7.166673301323706, -6.534650112462827],
            [7.1676086107828185, -6.539468360941783],
            [7.16427212179924, -6.542921218392824],
            [7.156865591108426, -6.540581253568877],
            [7.149407967373301, -6.542647022694068],
            [7.144088800288035, -6.551389643899767],
            [7.140554219359417, -6.554439034447578],
            [7.132040891444657, -6.556723675364864],
            [7.126632374421242, -6.5566634157749935],
            [7.120158146488599, -6.560218270400234],
            [7.111608972519949, -6.56059370058577],
            [7.106694364091712, -6.563086249026453],
            [7.105367141328006, -6.570483522246735],
            [7.1039332630966605, -6.584022136890792],
            [7.100263424322283, -6.59763197923137],
            [7.099489907773537, -6.604313631845815],
            [7.096690298988278, -6.608950904835166],
            [7.089867665312028, -6.612401741500701],
            [7.086050610269805, -6.6174955345447835],
            [7.084771038692805, -6.622173434497636],
            [7.084623886817206, -6.629123185528078],
            [7.0769553742460625, -6.6457035203481984],
            [7.070696704429276, -6.650964874522085],
            [7.071251085767408, -6.6565077909619],
            [7.0772553845595585, -6.667650659866143],
            [7.086104446654785, -6.680892777551406],
            [7.089177728396596, -6.696010149346255],
            [7.093638107431208, -6.703130244844188],
            [7.1032107103653725, -6.71181458289434],
            [7.108232583983936, -6.715590383685407],
            [7.111958772191502, -6.7166008897424305],
            [7.116338415011263, -6.714093150704099],
            [7.124923214037227, -6.705924141571532],
            [7.13321597908625, -6.703496742963576],
            [7.1393527044355025, -6.704708240227861],
            [7.151025944629375, -6.727038684685544],
            [7.153777863548796, -6.749367695901106],
            [7.158517023785374, -6.764671896061038],
            [7.002738924041908, -6.778266032390119],
            [6.895529409483903, -6.78701287303169],
            [6.890864919581111, -6.7877150642381165],
            [6.841025010442146, -6.791700751265694],
            [6.838513160430415, -6.767527828180872],
            [6.830066825841119, -6.69974145475727],
            [6.823223673924455, -6.640002361531909],
            [6.820005247889477, -6.616027602983867],
            [6.8180258561115785, -6.597460257144682]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.26317321902226, "lat": 32.01977681116097 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01023"],
        "coty_name": ["Choctaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Choctaw County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00161537"
      },
      "bbox": [
        6.8180258561115785, -6.791700751265694, 7.243453989878231,
        -6.145408871622038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.570627580384752, -0.9059079672493549],
            [-10.472731531033427, -0.9198332359432482],
            [-10.34289971227334, -0.9389380239355103],
            [-10.277076215640994, -0.9485355120568365],
            [-10.17492078271948, -0.9623955104160725],
            [-10.086601359866538, -0.974922446864434],
            [-9.998501109624032, -0.9872341828429833],
            [-9.92886168981683, -0.9969812304625701],
            [-9.822358383519017, -1.011957823660947],
            [-9.839722017547011, -1.1364306847160826],
            [-9.854292096483833, -1.2418952602492161],
            [-9.887338230325641, -1.4810814449120027],
            [-9.902223761731115, -1.5877541251550327],
            [-9.915414173091197, -1.6819113829585886],
            [-9.936017786782543, -1.828970656370649],
            [-9.944596999624972, -1.8936998524233786],
            [-9.960578936348764, -2.007911671977885],
            [-9.977592270249964, -2.1306952455917916],
            [-9.98782069141684, -2.2042454710324333],
            [-10.003235368523328, -2.315080303546561],
            [-10.014476336783357, -2.395906363342901],
            [-10.029289875331507, -2.5015729948036562],
            [-10.049480446590534, -2.646114848484998],
            [-10.064588828462691, -2.7595703230917983],
            [-10.076010042035977, -2.8425490420739465],
            [-10.09617983698568, -2.9890764570272124],
            [-10.10445448991683, -3.0491844879940375],
            [-10.122744058142024, -3.1800845389447563],
            [-10.124361409711893, -3.1944366309518104],
            [-10.12671408057465, -3.20859037063916],
            [-10.128127277128716, -3.223208681989411],
            [-10.130696103689495, -3.237479201332402],
            [-10.141001259186295, -3.3117986783033304],
            [-10.157203945374619, -3.4286384161786323],
            [-10.171214466390543, -3.5293086352425007],
            [-10.183878432423443, -3.619951729964119],
            [-10.214554255937534, -3.839469110684387],
            [-10.22563865120182, -3.9187727565204287],
            [-10.237781221287975, -4.005636678560503],
            [-10.254541094735462, -4.13013808255927],
            [-10.268425693256706, -4.227257759797019],
            [-10.410620266364361, -4.2071380338024635],
            [-10.514829311336323, -4.192189226549038],
            [-10.516145362706075, -4.19641109688182],
            [-10.520757032285367, -4.198940444327014],
            [-10.52132778474349, -4.203811149971587],
            [-10.530079702895009, -4.216397812995062],
            [-10.530410757756592, -4.222948761949068],
            [-10.533408011104603, -4.229821277113303],
            [-10.528262401458214, -4.234310327600947],
            [-10.525155967947622, -4.241551777582954],
            [-10.532527160429124, -4.240653868519782],
            [-10.539272159918191, -4.245277401913061],
            [-10.546808835728791, -4.241936211742743],
            [-10.5601889816271, -4.248041910163079],
            [-10.563852560279207, -4.2513909324349495],
            [-10.566420187810612, -4.246369798098974],
            [-10.569132719882925, -4.249991205270206],
            [-10.575397883577358, -4.248843181516465],
            [-10.576899048863265, -4.2541110964278905],
            [-10.581380675370601, -4.25297181169606],
            [-10.583456807985549, -4.24981038417433],
            [-10.590635612098476, -4.249423410801752],
            [-10.600211626740968, -4.246129537456035],
            [-10.601575767132767, -4.2479832999155605],
            [-10.61122369640281, -4.254680827790255],
            [-10.613072517676038, -4.257430400769246],
            [-10.618893486222388, -4.260357874122124],
            [-10.619731140681145, -4.26403940786313],
            [-10.624388542730808, -4.262158446464255],
            [-10.627434135464208, -4.25862446332675],
            [-10.629548488889316, -4.259784581631878],
            [-10.630753507195504, -4.264804800069118],
            [-10.635575422918867, -4.264282655546682],
            [-10.638915458172551, -4.277838822132917],
            [-10.640479169216587, -4.2813091574074695],
            [-10.638196900688703, -4.285276465958981],
            [-10.63833268990035, -4.2908300424545525],
            [-10.64469067219676, -4.297201807191154],
            [-10.650227571924711, -4.297762190008593],
            [-10.652683646706897, -4.2998987422071835],
            [-10.656455078736995, -4.299306239027594],
            [-10.659100053996793, -4.301739314385025],
            [-10.659512762361931, -4.305949628923874],
            [-10.662689725873715, -4.307863354854127],
            [-10.6733706306674, -4.309131885812682],
            [-10.67326298620987, -4.315279126859879],
            [-10.675138411442832, -4.31567279746864],
            [-10.683727795996145, -4.325679614421091],
            [-10.681883075978455, -4.330280219597834],
            [-10.689354622155307, -4.327786020603388],
            [-10.691799483230595, -4.322750323441121],
            [-10.695114680545014, -4.327064782025184],
            [-10.701902035812706, -4.32444496970442],
            [-10.706142562329918, -4.325249143035221],
            [-10.70876898648755, -4.31854109611951],
            [-10.716441442689526, -4.321418952735366],
            [-10.719650012409293, -4.3215241418306345],
            [-10.72748324196536, -4.328445433660432],
            [-10.732144119953329, -4.328966790254973],
            [-10.734923143722213, -4.324982321914731],
            [-10.74268525245173, -4.327245293135613],
            [-10.748608844201193, -4.3278420037165946],
            [-10.750401962867524, -4.331784783278055],
            [-10.748997678171445, -4.338179739564289],
            [-10.756679161573787, -4.345799957041907],
            [-10.760695211046539, -4.34548617081988],
            [-10.764156005613593, -4.35357268267507],
            [-10.767074956678117, -4.352986282064588],
            [-10.767771792724348, -4.347973363117627],
            [-10.777286123184691, -4.351187378181305],
            [-10.783432853153677, -4.348865030536467],
            [-10.79112172644113, -4.350509152501298],
            [-10.797780409574152, -4.349198473587435],
            [-10.79862230795084, -4.354117685123262],
            [-10.801762481103458, -4.352624453045947],
            [-10.811481637619236, -4.357727768334231],
            [-10.812907765361585, -4.36195568595742],
            [-10.808383315090644, -4.364384821998063],
            [-10.810547765771396, -4.371963840942267],
            [-10.805717613877897, -4.374037076608002],
            [-10.805633181981563, -4.376755150242203],
            [-10.810399177637807, -4.376869541065562],
            [-10.816237303969475, -4.373480567426873],
            [-10.817773165814874, -4.379416216283928],
            [-10.823342606227886, -4.386151629609594],
            [-10.827916218652545, -4.386938132734762],
            [-10.828941851219815, -4.389113194479021],
            [-10.83361800977134, -4.3890678195174],
            [-10.835985040293712, -4.392263167987316],
            [-10.838792479059505, -4.3921226676921785],
            [-10.839857717437486, -4.387640201461869],
            [-10.843266085128155, -4.39052938315571],
            [-10.845356346485346, -4.3955248890210665],
            [-10.850324134696159, -4.394606403222225],
            [-10.849201402389625, -4.401016905601513],
            [-10.853154103235342, -4.401263987441902],
            [-10.859902972809914, -4.404334930536912],
            [-10.86484223998978, -4.40294694354764],
            [-10.863070546185048, -4.4089525822439395],
            [-10.870116916025642, -4.410407991437364],
            [-10.873064157683023, -4.412416286333968],
            [-10.877731714846659, -4.41912079711172],
            [-10.877823662193105, -4.4295371301953885],
            [-10.881137224918751, -4.431623847926511],
            [-10.882088945228055, -4.436689216992163],
            [-10.888425319139198, -4.4397427952954605],
            [-10.895818604663967, -4.439046725710289],
            [-10.8966464532179, -4.442514812196197],
            [-10.900814712265555, -4.444027066118272],
            [-10.908092968124532, -4.441363169853895],
            [-10.914378667671881, -4.440897584664817],
            [-10.91405292094232, -4.43568542974318],
            [-10.920180908723848, -4.431222412776942],
            [-10.923647299690497, -4.432239172577765],
            [-10.925582526220296, -4.42733546585699],
            [-10.929670280922252, -4.427709410419009],
            [-10.931579826125127, -4.429929955680224],
            [-10.936329873290463, -4.430571229337723],
            [-10.93714253651961, -4.427987052770946],
            [-10.932415520370135, -4.422351415175335],
            [-10.928286939136616, -4.414572496767609],
            [-10.928933477646552, -4.410132318179325],
            [-10.934156589058151, -4.408907564764998],
            [-10.939729215755507, -4.401174734623215],
            [-10.939083073011085, -4.396451111916372],
            [-10.93697552882739, -4.392527345615177],
            [-10.941954072466114, -4.390631282773062],
            [-10.939269424300717, -4.385576116744391],
            [-10.946420764088352, -4.3768827776175865],
            [-10.948155573953109, -4.381745866522199],
            [-10.95372061414377, -4.380139648047504],
            [-10.958059263056208, -4.372202264560918],
            [-10.961446029284737, -4.370351815790135],
            [-10.955143029401162, -4.36260620904891],
            [-10.961863457344569, -4.364294889492181],
            [-10.963277014654665, -4.360669832147243],
            [-10.970996777240755, -4.351576181525165],
            [-10.97091058265586, -4.345883865309788],
            [-10.978541034753096, -4.3428074808484345],
            [-10.980221419811283, -4.33953744728363],
            [-10.983743336937659, -4.337680012513749],
            [-10.989217566479367, -4.33728772038128],
            [-10.958500781033962, -4.1286901761305135],
            [-10.931988461246599, -4.13267380552829],
            [-10.918104410403501, -4.038365074256971],
            [-10.902336295537216, -3.9311565354622586],
            [-10.89106042155538, -3.8546909273256245],
            [-10.880942056576107, -3.7865395355682954],
            [-10.872987602948518, -3.787547247057588],
            [-10.857765018713646, -3.6864146685234402],
            [-10.846608830529096, -3.6129311125389947],
            [-10.842990605390286, -3.5898443627851475],
            [-10.833803746996074, -3.5266008788390892],
            [-10.823037849240814, -3.454986672574046],
            [-10.82118194010119, -3.441878697319679],
            [-10.820020601994848, -3.441979642574959],
            [-10.821156477583191, -3.412327647382638],
            [-10.822294093324777, -3.3539373933818197],
            [-10.797541103706319, -3.2682944990849285],
            [-10.790483009769543, -3.219468596055971],
            [-10.778676342233135, -3.134926081235599],
            [-10.773061451224342, -3.0937615771129545],
            [-10.767167018536982, -3.094552015989827],
            [-10.754654121114388, -3.0078752771845623],
            [-10.747171329484281, -2.9654163827940785],
            [-10.741065570431262, -2.9177285684566527],
            [-10.741524426951841, -2.917661338435009],
            [-10.714917679967042, -2.7482643305986856],
            [-10.715536217288706, -2.7480087333095202],
            [-10.705125456580271, -2.675743527402743],
            [-10.685653950441086, -2.5442399008289227],
            [-10.664698700112794, -2.4016749713102117],
            [-10.651272534634241, -2.4035468395036212],
            [-10.638264070387972, -2.316169320362668],
            [-10.63009463913441, -2.2590948709940646],
            [-10.768460422355535, -2.2386791373343473],
            [-10.753604381124825, -2.1386324887656007],
            [-10.736193076402618, -2.0213748371693336],
            [-10.715111787623128, -1.8793889575537919],
            [-10.707549485815502, -1.8284562680539322],
            [-10.680445584309629, -1.6458619176025258],
            [-10.664970475205562, -1.5416050440122013],
            [-10.643456071547595, -1.3966656066533596],
            [-10.621233761957628, -1.2469367085219327],
            [-10.603098240644522, -1.124741733842588],
            [-10.586549943505496, -1.0132260151579853],
            [-10.570627580384752, -0.9059079672493549]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.48882064715036,
          "lat": 35.39553150137288
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04001"],
        "coty_name": ["Apache"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Apache County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00025441"
      },
      "bbox": [
        -10.989217566479367, -4.444027066118272, -9.822358383519017,
        -0.9059079672493549
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.023061409699565, -1.9132211137780173],
            [-16.995118606591564, -1.9199608358225724],
            [-16.958856384472398, -1.7618064642035294],
            [-16.956832637968525, -1.7543973858733288],
            [-16.94550966650663, -1.7033862753995233],
            [-16.93337305591033, -1.649411686070617],
            [-16.931458087653425, -1.6498074319884959],
            [-16.924637246961375, -1.619186844376775],
            [-16.91235952588605, -1.5660667116668532],
            [-16.897447061183104, -1.502678118305044],
            [-16.89160099078452, -1.4762759409531214],
            [-16.87372920258425, -1.39940439410398],
            [-16.86469846653981, -1.3574523505626637],
            [-16.862615099396944, -1.3469565147766853],
            [-16.85850386217652, -1.3334307469445843],
            [-16.85700858529193, -1.3182740364352528],
            [-16.853116696565742, -1.3017089978865823],
            [-16.850408694026505, -1.302337081178289],
            [-16.846631913312955, -1.287940044818932],
            [-16.82460808164407, -1.1914700321972773],
            [-16.82816591995102, -1.1906420092158954],
            [-16.821723858494078, -1.1620806375275143],
            [-16.817894105497814, -1.1475859281102676],
            [-16.808250042539477, -1.1055889098348073],
            [-16.794083943241592, -1.1080771736477506],
            [-16.78746841964291, -1.0794985080270056],
            [-16.815419065944734, -1.072938166023757],
            [-16.80875255650796, -1.0443590185247422],
            [-16.794789127441756, -1.0476233430138164],
            [-16.774854319764774, -0.9616910262578816],
            [-16.608545471393185, -1.001730753163666],
            [-16.567086874097345, -1.011669959596232],
            [-16.48957915128287, -1.029463064060494],
            [-16.376884343710536, -1.054399822367158],
            [-16.370476892591174, -1.056274644503476],
            [-16.2179833170753, -1.0904038415205457],
            [-15.714975167275961, -1.2031774660107057],
            [-15.6924324479192, -1.2079482809785125],
            [-15.659295778843811, -1.2153639920030956],
            [-15.548769088420027, -1.2389555336788085],
            [-15.538700847352265, -1.2405967026035256],
            [-15.285814315169267, -1.294674976816958],
            [-15.282479550127222, -1.2794199496816336],
            [-15.213882551305627, -1.2937967212608668],
            [-15.213380053418623, -1.2933924084519708],
            [-15.200416723648686, -1.3123786877374666],
            [-15.199578164882334, -1.3144437238590745],
            [-15.15213524861628, -1.3861707246562538],
            [-15.121498089559221, -1.4323882376127925],
            [-15.066210428330317, -1.5143325448694098],
            [-15.061116099408773, -1.5229850506468638],
            [-15.03901526617628, -1.5561940611758762],
            [-14.977344755766865, -1.6483394384825747],
            [-14.910357907249384, -1.749356559715874],
            [-14.907403092648455, -1.7549027753296282],
            [-14.871716912282206, -1.8090401836509495],
            [-14.859307626511551, -1.8261165553192231],
            [-14.83362226399363, -1.865072824667007],
            [-14.802733349000764, -1.910526078386655],
            [-14.758931362151806, -1.9764192072026208],
            [-14.696852717382981, -2.0689251316913855],
            [-14.67145398533461, -2.1068961834177538],
            [-14.626808474972037, -2.17464744751381],
            [-14.573320821003112, -2.2553274498737936],
            [-14.572069763683478, -2.265883024562385],
            [-14.574606807734163, -2.2767162660446996],
            [-14.580656805724884, -2.287568329520222],
            [-14.582925197253708, -2.297538049583939],
            [-14.5815977169728, -2.312295687061361],
            [-14.582754724646767, -2.3183597084954073],
            [-14.586285022458178, -2.3259355492933356],
            [-14.588961319280742, -2.3350593899105583],
            [-14.588662150599882, -2.3447529443290818],
            [-14.589822743163223, -2.349236976282049],
            [-14.595821847012436, -2.3604470608368917],
            [-14.598757211905623, -2.36961036078878],
            [-14.599589606413335, -2.380438996554515],
            [-14.597702811308432, -2.3897000909477075],
            [-14.590941413001088, -2.400778107773618],
            [-14.579903394672659, -2.410464120246651],
            [-14.572041630447533, -2.420669482798724],
            [-14.568726998034679, -2.426955107511587],
            [-14.56603526246191, -2.4373034621799863],
            [-14.564420879219032, -2.4487302752329927],
            [-14.564787854760198, -2.4584698071740436],
            [-14.564187120190345, -2.470349725874871],
            [-14.55831457346409, -2.4925033983669387],
            [-14.554908356489399, -2.500345160655224],
            [-14.54692528595785, -2.511945812650044],
            [-14.539607690827355, -2.5198455066711074],
            [-14.531966299976931, -2.535806469456806],
            [-14.517079617561285, -2.5477633137780074],
            [-14.513777295913593, -2.5516044089013215],
            [-14.512610213828477, -2.5602753937424274],
            [-14.509239869315904, -2.563109990336254],
            [-14.502069944033751, -2.5650819440431776],
            [-14.499265214237855, -2.572194506565307],
            [-14.499967918720484, -2.5779972518581875],
            [-14.499752940615322, -2.588904785623961],
            [-14.498349488638125, -2.5947260766132794],
            [-14.494625314725432, -2.604653505464493],
            [-14.494883196287386, -2.6103595093466576],
            [-14.493479062771483, -2.6171258320747017],
            [-14.499375614383407, -2.62101682377043],
            [-14.499974902870566, -2.6247237700107373],
            [-14.494929716924652, -2.6306859720044824],
            [-14.491657278751752, -2.6363386224016003],
            [-14.490082965912736, -2.6451690459789585],
            [-14.492373304021486, -2.6516077068398887],
            [-14.49210038241483, -2.6620011445660943],
            [-14.485342062932306, -2.67032080042622],
            [-14.482594207522277, -2.675158020244231],
            [-14.484269623729402, -2.683158053638431],
            [-14.487418322021256, -2.6857333963204293],
            [-14.494989571667682, -2.686742000868969],
            [-14.494226665991446, -2.6912279163438484],
            [-14.48691209712598, -2.70483548479356],
            [-14.475313850684529, -2.718473109405281],
            [-14.467957187883895, -2.7472660546695344],
            [-14.463498072377606, -2.7617426261888642],
            [-14.463958675713313, -2.7751996923149034],
            [-14.46566788757822, -2.78433885520582],
            [-14.471298648547496, -2.7950685931451726],
            [-14.473172303124565, -2.8017343707541453],
            [-14.474117503724585, -2.812855976079416],
            [-14.477147427314408, -2.819935545588419],
            [-14.481711303234245, -2.827644371035951],
            [-14.482116125146943, -2.8317818769276224],
            [-14.477276971336863, -2.840459019788874],
            [-14.473822050420567, -2.8446617447964657],
            [-14.465379129838038, -2.8454554234960527],
            [-14.459073578523565, -2.844665321880772],
            [-14.447979159746177, -2.8450896614008845],
            [-14.442435512213509, -2.8476117463576838],
            [-14.439576042465953, -2.8530350314867703],
            [-14.437485394112224, -2.8616942813105646],
            [-14.432077431708413, -2.864205228088707],
            [-14.419332712614565, -2.875944455223687],
            [-14.415413929993106, -2.8822646273163155],
            [-14.414046893022066, -2.8864108489702978],
            [-14.414918941033017, -2.8929100006040036],
            [-14.412054199035838, -2.899379286691889],
            [-14.407098690587212, -2.9025924709524973],
            [-14.397112903686098, -2.9052118557534574],
            [-14.39476131641312, -2.906855452741098],
            [-14.387618808234471, -2.919758858869092],
            [-14.382463331002954, -2.925314110500832],
            [-14.375363186368778, -2.93591814564555],
            [-14.373164478974326, -2.9442959454776316],
            [-14.370862168684933, -2.947810484203611],
            [-14.361610798751277, -2.953147453047657],
            [-14.350328740027956, -2.956447153707624],
            [-14.344590919365423, -2.962938733206778],
            [-14.340471249916414, -2.9655188344258296],
            [-14.334491390608541, -2.971883850969271],
            [-14.329851379141356, -2.982821199353353],
            [-14.324664407131504, -3.0060201191363434],
            [-14.313853274549201, -3.020350440819472],
            [-14.312236559970387, -3.0234188861312297],
            [-14.314656231958725, -3.030523429147558],
            [-14.314721789415435, -3.0458981487351435],
            [-14.316252012331395, -3.04951353758829],
            [-14.31595829978619, -3.0578248216870243],
            [-14.31428614860155, -3.064538292273452],
            [-14.318625066390997, -3.068666610204178],
            [-14.325804446209743, -3.0655009914261115],
            [-14.332957417999955, -3.065487627098483],
            [-14.3419051860755, -3.063031641539902],
            [-14.342374116427425, -3.0687326742652887],
            [-14.345231981401815, -3.0719752809658343],
            [-14.35217185769584, -3.0730367858664063],
            [-14.356357422346923, -3.079745449761254],
            [-14.368432915369867, -3.0867492663259917],
            [-14.392431641570669, -3.104553997478243],
            [-14.399553393274008, -3.1070896962811543],
            [-14.402194608020844, -3.11002406840259],
            [-14.402966511176158, -3.117950054473482],
            [-14.40561904758766, -3.1225919483892834],
            [-14.408151598156014, -3.1240875069889906],
            [-14.417723085702232, -3.126019702204293],
            [-14.421219928094938, -3.1290386736782834],
            [-14.430352394607835, -3.13320534683086],
            [-14.442433059941825, -3.134570686308512],
            [-14.447700615965799, -3.131558125929227],
            [-14.457704892836222, -3.1312744412265023],
            [-14.462879999906427, -3.1341673306468616],
            [-14.48274916987089, -3.152800468437791],
            [-14.494268235288013, -3.158774672601701],
            [-14.5040940753173, -3.1596513283686214],
            [-14.513637619818649, -3.1573555129065465],
            [-14.521124626497748, -3.1600244906455965],
            [-14.525698194542601, -3.166156221421016],
            [-14.53159941650992, -3.1701316455443243],
            [-14.542350264250425, -3.17068266648314],
            [-14.552629990799925, -3.174725296388512],
            [-14.561023550628361, -3.171474968552519],
            [-14.569665938877124, -3.1714446371347607],
            [-14.573538758553752, -3.1731416070453955],
            [-14.58386794085994, -3.181979652568481],
            [-14.586192338309045, -3.185886741100242],
            [-14.592206205001803, -3.1902524719186522],
            [-14.594698936862313, -3.1976093468849096],
            [-14.631611576058463, -3.1902762656450308],
            [-14.77203263126872, -3.16251270559966],
            [-14.912450844033192, -3.13473396077698],
            [-14.991294606749227, -3.1187993642098264],
            [-15.124136026551783, -3.091797054697569],
            [-15.159399589265476, -3.0846800737598423],
            [-15.204804138108498, -3.075732574556408],
            [-15.205181698264703, -3.0773613579342136],
            [-15.304703342877545, -3.0568645574214357],
            [-15.313716072763691, -3.0999376735453557],
            [-15.568107970726723, -3.0459458270792994],
            [-15.66096817578652, -3.0263628514349525],
            [-15.6634089426776, -3.026000131967893],
            [-15.851841017338094, -2.9868920612071213],
            [-15.901425317805698, -2.9764480471608765],
            [-16.021762695236347, -2.9513261705005505],
            [-16.021547412379032, -2.950633429976443],
            [-16.105737821629287, -2.932369848656197],
            [-16.106297827691147, -2.9341616949342124],
            [-16.232374220286967, -2.9063938279627672],
            [-16.276143441677906, -2.8968266521317894],
            [-16.359211453142034, -2.8789281111336535],
            [-16.3590701591296, -2.878177075072952],
            [-16.442527508031596, -2.8592307178849143],
            [-16.52706253084661, -2.8404588398878463],
            [-16.61096522001242, -2.8214709816365384],
            [-16.617374843446513, -2.8501497499228154],
            [-16.663735801374692, -2.8399786761935366],
            [-16.68458786607007, -2.8356997795633334],
            [-16.701610137075996, -2.831302969669329],
            [-16.717542822359984, -2.8285119512908192],
            [-16.743635731587162, -2.8229411611540782],
            [-16.75745833068023, -2.819253010606731],
            [-16.771640594910465, -2.8169728776270064],
            [-16.785276445315482, -2.8130976357569124],
            [-16.813080670698042, -2.8069512491086335],
            [-16.854977273497713, -2.7973893782066885],
            [-16.85203128987681, -2.783839596490163],
            [-16.88801582011812, -2.7748946776576124],
            [-16.90854345989228, -2.7707028376562697],
            [-16.9153897635907, -2.7680612950759964],
            [-16.971922579925625, -2.7550640957468637],
            [-16.96834108947222, -2.744061084854982],
            [-16.96861203243764, -2.740874981022019],
            [-16.999648285007837, -2.733331222618166],
            [-17.016684078889305, -2.729510617553422],
            [-17.0314556809718, -2.7267537421414376],
            [-17.06856894456542, -2.718389256567484],
            [-17.11536828519952, -2.707628748172711],
            [-17.125623991976063, -2.751776714278392],
            [-17.17154479069947, -2.7583367927741866],
            [-17.182152823143284, -2.804114849738679],
            [-17.217808972739633, -2.7958657803417273],
            [-17.225667253736475, -2.831540708544466],
            [-17.2428452594216, -2.827560501816427],
            [-17.24049807061807, -2.8302624337152524],
            [-17.238731555669236, -2.837052302345435],
            [-17.242697803806003, -2.840166672465143],
            [-17.241544278553423, -2.842892380818956],
            [-17.244271315720837, -2.8455914992091733],
            [-17.24781692489611, -2.8379707927709537],
            [-17.283084455237887, -2.795989037448712],
            [-17.282841550650392, -2.794993744074231],
            [-17.293025710074343, -2.7822109452311103],
            [-17.315541738619803, -2.751312946708593],
            [-17.322068376984628, -2.741978251659473],
            [-17.318883589113224, -2.7279293273610206],
            [-17.3258803462311, -2.7261189565614274],
            [-17.32429630669842, -2.7190029826932385],
            [-17.30371876414874, -2.6937530746436398],
            [-17.28956452026001, -2.6969780609676657],
            [-17.287694322756362, -2.6906981999162043],
            [-17.28536675870164, -2.6785130438215647],
            [-17.261014167624865, -2.689299189772909],
            [-17.255787185379496, -2.6876033152168852],
            [-17.24991355753094, -2.672415739477278],
            [-17.234657868363133, -2.6454686730513934],
            [-17.218279283493576, -2.6199279165726614],
            [-17.194461934032468, -2.581189939319307],
            [-17.18635787432671, -2.564771712051912],
            [-17.182383600469226, -2.5593208019796636],
            [-17.127747110292642, -2.4405335322886335],
            [-17.1102228137983, -2.3328917463161654],
            [-17.101376853927132, -2.2787131916978556],
            [-17.07774883726514, -2.174280197342192],
            [-17.083093191430137, -2.1730269010452874],
            [-17.052946548278015, -2.0432321118654455],
            [-17.023061409699565, -1.9132211137780173]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.17845605486984,
          "lat": 34.84138264319763
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06071"],
        "coty_name": ["San Bernardino"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Bernardino County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00277300"
      },
      "bbox": [
        -17.3258803462311, -3.1976093468849096, -14.312236559970387,
        -0.9616910262578816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.645312268198026, -10.869216072528163],
            [12.654274639269461, -10.867848189604162],
            [12.693656903249869, -10.862758940009629],
            [12.751705129107341, -10.854832782523747],
            [12.739449893115818, -10.770022711263628],
            [12.827293843693488, -10.75769312278911],
            [12.88728714793551, -10.749550492347213],
            [12.914857433416715, -10.745632716973853],
            [12.972531692545436, -10.737654052652255],
            [12.980240207325165, -10.733024806919616],
            [13.002152924427596, -10.73002205550805],
            [13.085050782191658, -10.718390990411487],
            [13.167945787055285, -10.7067390231986],
            [13.260574945712545, -10.692958751904246],
            [13.35320017277083, -10.67915230106145],
            [13.353304820320115, -10.679282788633184],
            [13.3655199526855, -10.765076205765387],
            [13.377792348869432, -10.85000366884463],
            [13.390148285501795, -10.934463720791152],
            [13.304878036169322, -10.947225843749505],
            [13.216843373649708, -10.960327444720601],
            [13.129766715667476, -10.972904552029004],
            [13.065113555843773, -10.98223099118795],
            [12.950758048127003, -10.998543488954526],
            [12.953151580134517, -10.992880790307552],
            [12.952047993869213, -10.982501338550678],
            [12.955530474099884, -10.97670824767094],
            [12.954517330058415, -10.969798995558431],
            [12.953849459232423, -10.954765107304299],
            [12.94640095809601, -10.93750394016501],
            [12.947138833749428, -10.923839555978079],
            [12.944822736980182, -10.90619974101468],
            [12.934430794100402, -10.892507915007197],
            [12.929243204002672, -10.890221014688583],
            [12.909818679356876, -10.888019117487438],
            [12.902922155031249, -10.880987170959248],
            [12.896773196720652, -10.864289658110755],
            [12.899804394524818, -10.855424022892343],
            [12.903981259769173, -10.850219957021233],
            [12.911401860787809, -10.85081798323447],
            [12.920939977076484, -10.847693463977969],
            [12.930874157650882, -10.838378441984075],
            [12.931555014914391, -10.83430799005396],
            [12.923749894174804, -10.825407714781187],
            [12.918463494377216, -10.82178537504719],
            [12.90652785399595, -10.818852187337601],
            [12.898969331535742, -10.820101020838772],
            [12.8926321214287, -10.826082334600132],
            [12.889131575469733, -10.827064380135093],
            [12.886342549599213, -10.82170763023385],
            [12.875399270577155, -10.820389665040842],
            [12.874368485178579, -10.818078246839372],
            [12.869811972833897, -10.820203645636026],
            [12.875171522090856, -10.831294665511287],
            [12.86783288280953, -10.837796950260277],
            [12.866994930993597, -10.843666596290918],
            [12.861995406986555, -10.850405955880886],
            [12.86054470006611, -10.85528246499929],
            [12.856066605414211, -10.86088344210545],
            [12.844499663043464, -10.861622847089265],
            [12.839720712163322, -10.857431449703645],
            [12.832264021134927, -10.854131218989037],
            [12.83050062447637, -10.850378863978474],
            [12.824526094293383, -10.847895220674717],
            [12.817362189077304, -10.854777119149198],
            [12.82112512686078, -10.868447027000506],
            [12.833827340384941, -10.888564299359219],
            [12.855538590047143, -10.92995939202812],
            [12.872326221961949, -10.991721698052151],
            [12.872126817424272, -10.997604753305884],
            [12.867743332630349, -10.997658895831524],
            [12.859028776399517, -11.00388196073811],
            [12.850949648911232, -11.01340762445297],
            [12.839097672421358, -11.015017812566882],
            [12.83409296642242, -11.013320970465259],
            [12.82832416281796, -11.013731610837928],
            [12.82516679367591, -11.016306751562452],
            [12.818114571552151, -11.016375011285033],
            [12.808663368725831, -11.009785436153514],
            [12.804536439238827, -11.008209395385483],
            [12.794121349065037, -11.008486443269716],
            [12.786007365165865, -11.007167022931604],
            [12.765871962329456, -11.006410351896207],
            [12.75926305314631, -11.007266882239922],
            [12.75677261208237, -11.003659605574118],
            [12.74774785034618, -10.994439084949981],
            [12.745523108142365, -10.989740475154367],
            [12.747160636373904, -10.987866351619926],
            [12.746194853520716, -10.983048038587656],
            [12.738406551881441, -10.973665987763995],
            [12.72546832666701, -10.960781390147563],
            [12.698984579777354, -10.929187200985291],
            [12.690216122146184, -10.923654990623618],
            [12.681706327257556, -10.914686494729798],
            [12.671601492771556, -10.902609576429743],
            [12.650107698003806, -10.87581972760756],
            [12.645312268198026, -10.869216072528163]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.91135677458666,
          "lat": 26.905759004133568
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12015"],
        "coty_name": ["Charlotte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charlotte County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00295742"
      },
      "bbox": [
        12.645312268198026, -11.016375011285033, 13.390148285501795,
        -10.67915230106145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.205929980719253, -11.394418429169589],
            [13.229742569274311, -11.390870941241568],
            [13.231922532707419, -11.404491030453302],
            [13.258623385621163, -11.40051691598262],
            [13.296928848691358, -11.394246819800602],
            [13.375696805912762, -11.381886198293737],
            [13.358826967324475, -11.282559429364948],
            [13.4451365068398, -11.268128373433456],
            [13.445326817440025, -11.267569225062045],
            [13.430407911001563, -11.181020615907855],
            [13.517217694990702, -11.167435537890894],
            [13.530281217924601, -11.163849543269702],
            [13.587954485018201, -11.154504084279958],
            [13.69002441619233, -11.13794926135955],
            [13.704339142678135, -11.228784669756195],
            [13.733603208133916, -11.391243764795881],
            [13.80549628489851, -11.378750103397325],
            [13.877386068814824, -11.366239267485025],
            [13.978533619157531, -11.34882484547848],
            [14.079674810299654, -11.331376453606946],
            [14.093737397462677, -11.414256051215759],
            [14.127031181626807, -11.580520869294423],
            [14.129696745910044, -11.59888519611273],
            [14.156671744491167, -11.764887328638743],
            [14.156876476306325, -11.765625009808026],
            [14.070105016761103, -11.779437059627009],
            [13.983329312197576, -11.793223207847863],
            [13.896549355121278, -11.806983457806554],
            [13.809765138006615, -11.82071781264709],
            [13.772453938208937, -11.826507514321143],
            [13.751599995274523, -11.830203938996815],
            [13.636785216061211, -11.847421509480187],
            [13.621094957879995, -11.849882579616708],
            [13.625368222236775, -11.841672438123261],
            [13.62106879490018, -11.838537255264123],
            [13.613242607452998, -11.837661615483528],
            [13.609963964441821, -11.834176824838627],
            [13.60077701428685, -11.83476545509762],
            [13.59630722507635, -11.826844935969424],
            [13.589813752103385, -11.823969790541469],
            [13.584620570290676, -11.823429065552872],
            [13.579484891072452, -11.827980494119187],
            [13.575435225465556, -11.822370178128349],
            [13.568036308349232, -11.821174364972391],
            [13.561945146977159, -11.82442462067086],
            [13.562203866077802, -11.813238797343159],
            [13.555445105290083, -11.807749650914863],
            [13.544228477539079, -11.816299809720903],
            [13.538752787164812, -11.808575986453086],
            [13.530342572127662, -11.806480205404068],
            [13.528421193739506, -11.812195085542283],
            [13.523466432437136, -11.809790808048657],
            [13.519521434857193, -11.804324872453199],
            [13.513898163010936, -11.805889586021495],
            [13.509106093235363, -11.794976480507488],
            [13.503909799144107, -11.79313290788512],
            [13.486623239893522, -11.783266124561328],
            [13.470980566501996, -11.786993776335102],
            [13.457903789610732, -11.781171334140987],
            [13.454453209313481, -11.774967122507093],
            [13.451073503757707, -11.775470833937321],
            [13.441829021541576, -11.78615097728051],
            [13.433882185989093, -11.797476609184562],
            [13.427882474332774, -11.802057671992397],
            [13.42590306730494, -11.80759597835265],
            [13.430444585299734, -11.811534011883978],
            [13.432413817347582, -11.816573150232102],
            [13.431140362640786, -11.826277582851557],
            [13.42769984853522, -11.832964653678875],
            [13.42774989825537, -11.837913802705039],
            [13.421616021923896, -11.836958234786508],
            [13.416540045536951, -11.832314299841823],
            [13.388657337077147, -11.792461129067688],
            [13.383940465794362, -11.788775269245756],
            [13.382820811165645, -11.78316324355584],
            [13.372252440353567, -11.783279374767679],
            [13.37105001006543, -11.774589607727547],
            [13.366768899067367, -11.762415792741487],
            [13.359148167524497, -11.754128603015783],
            [13.344852432694374, -11.746429420182311],
            [13.341802496117461, -11.740799805571767],
            [13.343578936347884, -11.73676388372673],
            [13.349714315866816, -11.727050615265387],
            [13.35521888008513, -11.72455809307671],
            [13.353369951388368, -11.721058062403786],
            [13.347991062345262, -11.718709294847361],
            [13.34241499336792, -11.707016272783036],
            [13.339081384805546, -11.705756750314919],
            [13.333567266018008, -11.701378988113724],
            [13.328377534749459, -11.694936177364559],
            [13.314780334095508, -11.670497285637314],
            [13.301103352198025, -11.651908528188292],
            [13.280536893494414, -11.618233540794241],
            [13.265217124653201, -11.560745320554023],
            [13.256960429032816, -11.54141228785425],
            [13.249979318204153, -11.509039634829238],
            [13.242162910677777, -11.481136331734817],
            [13.222501099471202, -11.427238636073186],
            [13.207413286747542, -11.396824925816176],
            [13.205929980719253, -11.394418429169589]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.34741170414856,
          "lat": 26.110839576882725
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12021"],
        "coty_name": ["Collier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Collier County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00295754"
      },
      "bbox": [
        13.205929980719253, -11.849882579616708, 14.156876476306325,
        -11.13794926135955
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.59321503468484, -6.072650814325786],
            [10.61090231236525, -6.070511785849951],
            [10.667750318525046, -6.0631778571133275],
            [10.758600289457481, -6.052873573866264],
            [10.799193221228027, -6.048135053343115],
            [10.887759819177951, -6.037477040556911],
            [10.892469174137638, -6.077270499894927],
            [10.897295226624902, -6.120579669214137],
            [10.897681520259194, -6.121849195800528],
            [10.908292217054116, -6.209958976109186],
            [10.914491208227467, -6.259468572198403],
            [10.904354509209547, -6.260999148702761],
            [10.882162574722006, -6.263513073004954],
            [10.799852039395303, -6.273932320617041],
            [10.799324874932642, -6.274246910262027],
            [10.755085809296016, -6.280629523016771],
            [10.74739626814368, -6.279360398490658],
            [10.744169890736252, -6.274846903886713],
            [10.738437525955915, -6.273863761472906],
            [10.733171193347983, -6.276877696447658],
            [10.725319150290522, -6.270529283480495],
            [10.725341091115158, -6.266601183158984],
            [10.717514600861858, -6.2617628504559715],
            [10.717071686234636, -6.269236150761598],
            [10.708865416552637, -6.270151725904487],
            [10.7064137607103, -6.253380368368446],
            [10.695067768452004, -6.254940321364005],
            [10.693660154767272, -6.2538644535843275],
            [10.68614397789515, -6.255805377939787],
            [10.675627602707317, -6.253031556289643],
            [10.67045955728213, -6.25406594299763],
            [10.665988721694639, -6.253297865839247],
            [10.657902492445137, -6.249746547071492],
            [10.647094475959747, -6.249319666268063],
            [10.644760145106153, -6.252243530333353],
            [10.636624685072436, -6.254120472698285],
            [10.634719805382167, -6.251333977510833],
            [10.635699270604269, -6.241027938392961],
            [10.642782995556331, -6.236289301929829],
            [10.643067769681563, -6.232309670405486],
            [10.640687145564966, -6.226495725823255],
            [10.634973167669276, -6.217615045570267],
            [10.638780655153775, -6.211620448850832],
            [10.634869944100627, -6.205132313548465],
            [10.634473911567301, -6.200190525046371],
            [10.64107285113403, -6.188383484384155],
            [10.641105902404165, -6.181529053463203],
            [10.642189938868396, -6.174709085411294],
            [10.640675046856925, -6.170238182726286],
            [10.634301637288495, -6.161660355447466],
            [10.633417066346086, -6.157352831954136],
            [10.634208007721055, -6.150917050278436],
            [10.628629594414932, -6.143199192448178],
            [10.625225767740774, -6.14021922497202],
            [10.626537452047044, -6.136518846300981],
            [10.615484673939807, -6.119428318270579],
            [10.613332785903937, -6.1181370960915675],
            [10.610859040363923, -6.111992810519237],
            [10.611461660019556, -6.104934584955768],
            [10.608317131603233, -6.1054208779420795],
            [10.604839180091378, -6.099681495696228],
            [10.604332534596276, -6.086570072042556],
            [10.599622963259321, -6.082484105744197],
            [10.596440227912355, -6.081688633099675],
            [10.59321503468484, -6.072650814325786]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.76806480625496, "lat": 31.9228901347562 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13081"],
        "coty_name": ["Crisp"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crisp County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00351607"
      },
      "bbox": [
        10.59321503468484, -6.280629523016771, 10.914491208227467,
        -6.037477040556911
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.334863228526446, -4.59571327363985],
            [10.35787659481994, -4.554827800705391],
            [10.358962066136053, -4.5631632415202],
            [10.365023028700056, -4.562461554354201],
            [10.363848750027735, -4.553852990831367],
            [10.358032643956976, -4.554553070569725],
            [10.398076367456278, -4.483356940200921],
            [10.411700280556767, -4.459355582626216],
            [10.41208442257934, -4.450754993326788],
            [10.414526407364038, -4.445487880919358],
            [10.415609757601047, -4.435900925820513],
            [10.4136529241373, -4.428481670210837],
            [10.417738841408244, -4.419519027103451],
            [10.415444159245034, -4.417372575601184],
            [10.409266092667695, -4.399648740463003],
            [10.41115940848121, -4.398511592638679],
            [10.415919622059354, -4.400559682059357],
            [10.418784586799328, -4.395890626004191],
            [10.415435836850715, -4.3921228954767875],
            [10.412736913651415, -4.381803557115232],
            [10.414106753110575, -4.377775461011072],
            [10.412207814879489, -4.372292821778716],
            [10.4137628880841, -4.369659536785847],
            [10.41345448881023, -4.364670676519465],
            [10.470508824149551, -4.397396605956774],
            [10.5542816799485, -4.445679454440379],
            [10.573991813956452, -4.443852718514356],
            [10.612801589074094, -4.467831925471072],
            [10.607338543189304, -4.476182501519741],
            [10.624150587767671, -4.486679070736425],
            [10.619915468943395, -4.4956936470578635],
            [10.62099607398761, -4.501913591136475],
            [10.626175838015012, -4.505659045095008],
            [10.630148970627447, -4.511963556246839],
            [10.632285910744745, -4.557198292402817],
            [10.629494804162917, -4.5734092175858825],
            [10.633443821468717, -4.581421561974538],
            [10.635758204076453, -4.588929328385664],
            [10.643563202938772, -4.595206128871681],
            [10.640927479337266, -4.599174454329423],
            [10.635009651525335, -4.600856263946454],
            [10.62479570227144, -4.591542993049637],
            [10.62412325548283, -4.590039060401554],
            [10.616704874371507, -4.584940206038316],
            [10.611629669567398, -4.591383837360895],
            [10.61867471705507, -4.597128702940635],
            [10.593430157353298, -4.608146878290573],
            [10.568680511063954, -4.640051789883582],
            [10.552483467412731, -4.648335904712275],
            [10.540520183086533, -4.6554830069933955],
            [10.540268757259783, -4.660061738942202],
            [10.537352398648595, -4.662135532026035],
            [10.533739002443602, -4.660526508430376],
            [10.529926046450038, -4.661405837373751],
            [10.525208161358213, -4.672162322807893],
            [10.524054602770605, -4.679497249869348],
            [10.526658296615613, -4.683321607898555],
            [10.512776133852176, -4.685461163986516],
            [10.513821403428041, -4.692377119640646],
            [10.520498313089973, -4.69138959349748],
            [10.520788292760589, -4.694224778876544],
            [10.515232612904581, -4.695060497621847],
            [10.517954129107867, -4.699099540837179],
            [10.52512408430636, -4.702960489757916],
            [10.52681138866585, -4.705712436308329],
            [10.522015457321451, -4.709285857967013],
            [10.516876095513876, -4.719052933618129],
            [10.515598394780307, -4.724394350796677],
            [10.51055116926412, -4.73097410574868],
            [10.50405314962622, -4.733564068805684],
            [10.500567055118982, -4.729444665424291],
            [10.500734295360223, -4.724438990076727],
            [10.494385536909693, -4.724930265315372],
            [10.490351361089685, -4.720242149659717],
            [10.488367234587551, -4.713808795761658],
            [10.47664947681703, -4.711027194550893],
            [10.474067692949113, -4.708618218984541],
            [10.472617916467017, -4.697868261897348],
            [10.469736324942547, -4.695372944889218],
            [10.462858660477899, -4.692777122810722],
            [10.4605101010904, -4.688993439723428],
            [10.457042190245472, -4.689517415778456],
            [10.457544508013045, -4.680998748662907],
            [10.453544909136138, -4.680176044997633],
            [10.453707519561274, -4.676316938067304],
            [10.4497479305561, -4.673790314612277],
            [10.449046338590643, -4.668976918440645],
            [10.444296800489102, -4.664389608848345],
            [10.444260871404117, -4.657526519900164],
            [10.436215957865237, -4.654405415921661],
            [10.430218516908417, -4.642831008408625],
            [10.424056447620282, -4.639461187106597],
            [10.420385960179132, -4.634014870991616],
            [10.420923741226611, -4.629354032258834],
            [10.418245691193668, -4.62571596199592],
            [10.413553376711038, -4.628297158938819],
            [10.405712429864412, -4.6263836800645],
            [10.400086236404174, -4.627505181539496],
            [10.3950041906835, -4.625458262151186],
            [10.391839643637358, -4.627766514727739],
            [10.387854911275982, -4.627238362816126],
            [10.385908642227571, -4.624519429522751],
            [10.37756142673292, -4.6223669015963615],
            [10.365306344740967, -4.6255679174210185],
            [10.36239418649146, -4.620616267578524],
            [10.353463012589392, -4.623669561745799],
            [10.353288003895582, -4.627495665408665],
            [10.346226531359411, -4.624754729431018],
            [10.349037385102127, -4.622120733829361],
            [10.3494262912011, -4.618847325777334],
            [10.34606572661915, -4.616421333233598],
            [10.344280174447055, -4.6114432694387295],
            [10.338222703286336, -4.611628432349928],
            [10.33788029940783, -4.6026226336248035],
            [10.33092961573596, -4.605879247478104],
            [10.326934180503368, -4.603721659700741],
            [10.332370551855346, -4.59917197155419],
            [10.334863228526446, -4.59571327363985]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.85013037097438, "lat": 33.55505241049125 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13217"],
        "coty_name": ["Newton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newton County"],
        "coty_fp_code": "217",
        "coty_gnis_code": "01673547"
      },
      "bbox": [
        10.326934180503368, -4.733564068805684, 10.643563202938772,
        -4.364670676519465
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.027865041115536, -12.236470911473386],
            [-8.02064409392097, -12.230450752250151],
            [-8.0220387022698, -12.219744544728902],
            [-8.0184330351924, -12.216911167704634],
            [-8.017248437089044, -12.20960612623456],
            [-8.018474107711588, -12.206099489525302],
            [-8.017148557416323, -12.196150709812883],
            [-8.01486888905549, -12.191332583798882],
            [-8.009075508877366, -12.186474258735],
            [-8.004977957092787, -12.185285220800989],
            [-8.006831039281549, -12.181163137436194],
            [-8.002689777396682, -12.17836440647574],
            [-7.995411597526319, -12.175781912576355],
            [-7.990817726780901, -12.172663658854932],
            [-7.982651349990331, -12.162713802857796],
            [-7.977222184131571, -12.15895293826765],
            [-7.9765332105914855, -12.155356136499627],
            [-7.971727903342183, -12.154285582298844],
            [-7.9677010571000535, -12.147425657607622],
            [-7.9683563679456055, -12.143843664947983],
            [-7.961152237630959, -12.138942382740073],
            [-7.9581749357282, -12.138290730771358],
            [-7.957865428719282, -12.1345432350538],
            [-7.953115860969699, -12.130111037214387],
            [-7.951661232035786, -12.126437944038441],
            [-7.9454577655568235, -12.121704636338313],
            [-7.934499210923725, -12.117503783344267],
            [-7.91934058280386, -12.116325520360991],
            [-7.916664155551761, -12.119385887158028],
            [-7.911578679875226, -12.120067779120195],
            [-7.897462658508152, -12.112604858260926],
            [-7.899317072196109, -12.104533002316444],
            [-7.898614289317512, -12.099634816299881],
            [-7.894855537272206, -12.09564770340328],
            [-7.891304372728242, -12.094960669977349],
            [-7.888379406530875, -12.08635432518936],
            [-7.884647009685762, -12.085280566531823],
            [-7.881918835828581, -12.082245570934319],
            [-7.880919266027028, -12.077338130055038],
            [-7.882378860606495, -12.07373303829032],
            [-7.877688118637993, -12.070471450390148],
            [-7.877896283987743, -12.066263756450715],
            [-7.875439848753484, -12.062018514702551],
            [-7.8682040378780105, -12.059085058873551],
            [-7.865750725684952, -12.055891119175193],
            [-7.867921959389995, -12.05269244706431],
            [-7.868117479420004, -12.042863886106502],
            [-7.859930259397789, -12.03614802013702],
            [-7.8560338189686965, -12.036933320466073],
            [-7.85653417134883, -12.030137481827479],
            [-7.849809908795788, -12.024713757168497],
            [-7.842340101703252, -12.019822539516992],
            [-7.838340744762799, -12.009298930113193],
            [-7.832638798081467, -12.003956989145621],
            [-7.827484448995045, -12.003281383615034],
            [-7.822346193811105, -11.999340094367264],
            [-7.813331709497688, -11.998469690440121],
            [-7.8121474966656494, -11.986221235399288],
            [-7.807981894175459, -11.981986654703348],
            [-7.8096742171383475, -11.972510779536263],
            [-7.8065444553771925, -11.95766070853993],
            [-7.804703169406902, -11.95448889830489],
            [-7.804787932188053, -11.946096027169586],
            [-7.810572310665048, -11.94447589910284],
            [-7.8085812983910134, -11.93965629181192],
            [-7.819178478582668, -11.927015018380196],
            [-7.819896202365445, -11.924160584342786],
            [-7.823979736434983, -11.921288895744233],
            [-7.824604700033142, -11.918084118446735],
            [-7.835173733223039, -11.907278897847174],
            [-7.8391554584555765, -11.90057212150703],
            [-7.844073977260473, -11.898701715893917],
            [-7.84523580252137, -11.894728154754242],
            [-7.850136205262826, -11.888894491835215],
            [-7.858274503768946, -11.872903645108728],
            [-7.862143793991611, -11.86977678867935],
            [-7.861507157218497, -11.864335185552736],
            [-7.869637839393547, -11.850976163336615],
            [-7.870884629554212, -11.838730933971515],
            [-7.874059039283143, -11.833540179270214],
            [-7.873219839105601, -11.828034128019299],
            [-7.877869310584694, -11.807617623411092],
            [-7.8797496029320415, -11.792836905215095],
            [-7.882178873269578, -11.782205083817407],
            [-7.879385693349405, -11.772458748306],
            [-7.88076707838577, -11.765421369036583],
            [-7.877117604954264, -11.754158224677802],
            [-7.8776168238827315, -11.749069624943363],
            [-7.870972542204915, -11.738140566325667],
            [-7.868087432248816, -11.735957263293175],
            [-7.866580742341569, -11.729581953649035],
            [-7.861905624351249, -11.722927874004434],
            [-7.856244211322257, -11.718803170911325],
            [-7.848397325046034, -11.71482288644347],
            [-7.84134448848137, -11.714057137389563],
            [-7.831923828641076, -11.711870084973734],
            [-7.828927386952289, -11.714779644677341],
            [-7.819039445333744, -11.712800617228899],
            [-7.812915532603618, -11.71612206332205],
            [-7.810242445280912, -11.718934365138827],
            [-7.8057694423554125, -11.720575470156353],
            [-7.801698141783873, -11.719942899189215],
            [-7.798433512146243, -11.721879852178454],
            [-7.790972450739834, -11.723324802113904],
            [-7.784909659806616, -11.727515393202387],
            [-7.781773895140311, -11.731018367550307],
            [-7.7768098613392755, -11.729854842734568],
            [-7.766860804533122, -11.73438766022355],
            [-7.7640354402880964, -11.736966669419889],
            [-7.759812180618954, -11.735963229587016],
            [-7.7569952064267325, -11.732589572739176],
            [-7.750849533622249, -11.736790590398833],
            [-7.748369310548877, -11.740039810369618],
            [-7.743666256949509, -11.740017472363219],
            [-7.739724182419206, -11.742539201075859],
            [-7.735788086798951, -11.747807090173751],
            [-7.7314127278827, -11.749117755159316],
            [-7.7245690676260255, -11.755507133780734],
            [-7.7188975448645225, -11.758150743119522],
            [-7.719210379554396, -11.76317956723542],
            [-7.721802838553644, -11.76730794149606],
            [-7.713074616713623, -11.776060459728313],
            [-7.695046371909975, -11.78674652694383],
            [-7.675574999761124, -11.797670504133771],
            [-7.655975241151917, -11.805640467457739],
            [-7.643835496215672, -11.811075929325552],
            [-7.632972266411675, -11.820710910372913],
            [-7.631441998781696, -11.828570326064547],
            [-7.62737382938941, -11.831420749592498],
            [-7.614592920920465, -11.833093550441735],
            [-7.607618336269188, -11.838277434567068],
            [-7.602348845611269, -11.837535886281943],
            [-7.593070917952438, -11.850594681719386],
            [-7.584589756520836, -11.855766787092263],
            [-7.573848851158436, -11.85420452794598],
            [-7.563422272685178, -11.847827323835283],
            [-7.553574417935944, -11.845815800897782],
            [-7.530274249678498, -11.853982928377127],
            [-7.516430187250999, -11.859245288167088],
            [-7.49760125989267, -11.862063809918087],
            [-7.467424262088555, -11.872806198217665],
            [-7.44183956309444, -11.880788504938906],
            [-7.417940580420258, -11.891802806909114],
            [-7.408010791369535, -11.897052381293872],
            [-7.404655438548888, -11.901512453052709],
            [-7.396785359802923, -11.905598670612978],
            [-7.374762560687421, -11.914384129779535],
            [-7.359468156684647, -11.922559019653042],
            [-7.354487610466256, -11.922726364038693],
            [-7.350021143518251, -11.927284745965368],
            [-7.340022343133597, -11.932951958491028],
            [-7.310035855064002, -11.946682111185568],
            [-7.3028894595666145, -11.949713329582922],
            [-7.292799874227826, -11.951679217809415],
            [-7.281842202421069, -11.958029560780936],
            [-7.272579109198922, -11.965847684879256],
            [-7.265625408074866, -11.969361458829756],
            [-7.262227411677492, -11.974797376746274],
            [-7.255740273157733, -11.975755679582377],
            [-7.253019722249576, -11.98219687176009],
            [-7.245839567658319, -11.984807983427563],
            [-7.229525823146745, -11.994021663521327],
            [-7.218431326587596, -12.002617169051032],
            [-7.213741739316776, -12.008495474439787],
            [-7.213008240214978, -12.0128748562117],
            [-7.20588614530588, -12.013660780459912],
            [-7.19513735685257, -12.020402891014204],
            [-7.193591750098852, -12.022757275148972],
            [-7.1819208677187625, -12.031488089308711],
            [-7.16984033517289, -12.043693322637667],
            [-7.161148314126844, -12.049893741309765],
            [-7.1531411851599165, -12.060226557481254],
            [-7.145882944415753, -12.066113011107921],
            [-7.1397264363598705, -12.078037018446757],
            [-7.139722881169898, -12.083025152398378],
            [-7.130884801058187, -12.087276206501803],
            [-7.1316477626744925, -12.089718768041276],
            [-7.1265036573170795, -12.096027957248426],
            [-7.114747452925224, -12.100788249326135],
            [-7.110756855299937, -12.105875726285829],
            [-7.108987195622615, -12.111793957291605],
            [-7.105706705559705, -12.112490985150398],
            [-7.103337368757731, -12.117198430737927],
            [-7.1066592066348635, -12.121214843715244],
            [-7.104700431658655, -12.128748006241656],
            [-7.109401776343109, -12.14556283159792],
            [-7.114267747953332, -12.154749355194621],
            [-7.111089596359392, -12.159518876095285],
            [-7.108433766115777, -12.160415323888701],
            [-7.1095992210632275, -12.166518210219122],
            [-7.1116523885698655, -12.169382100010525],
            [-7.11112118795394, -12.174774897919951],
            [-7.107897086827447, -12.17983033987506],
            [-7.109064977589739, -12.18957395163693],
            [-7.111039080120237, -12.193049007165815],
            [-7.110368245822909, -12.197308487445776],
            [-7.112052839876108, -12.209645146105789],
            [-7.111243042606596, -12.227510585975946],
            [-7.108453516121488, -12.23392976835511],
            [-7.103532204892291, -12.237916238553414],
            [-7.092762085036413, -12.237400597768117],
            [-7.0925584873994625, -12.234783348044978],
            [-7.086604003110535, -12.232888352753893],
            [-7.083575145283059, -12.235371590986047],
            [-7.076894418001619, -12.229246778075515],
            [-7.0697552732850895, -12.22913900395303],
            [-7.065041169089178, -12.223245737955157],
            [-7.055620014977472, -12.222996726167088],
            [-7.053350694740912, -12.225772747249048],
            [-7.049983502846831, -12.22574735104397],
            [-7.046148022330307, -12.228334158716732],
            [-7.041191287078265, -12.226196187107934],
            [-7.040128541585667, -12.223275182680707],
            [-7.0295820674492235, -12.225237877907745],
            [-7.027448846008407, -12.226895309759325],
            [-7.019572525761365, -12.237688761649778],
            [-7.013919759724403, -12.252206665928442],
            [-7.011082549689298, -12.25609324579587],
            [-7.008135570248376, -12.266189253535545],
            [-7.005176764457164, -12.271180411649699],
            [-7.006013194584268, -12.278817397048822],
            [-7.009355041941869, -12.286637267147977],
            [-7.009564805858791, -12.300900012550935],
            [-7.005793469205614, -12.30691133792953],
            [-7.008232788157939, -12.310501203883726],
            [-7.008970335459847, -12.315089986354195],
            [-7.007424799864166, -12.320590397829456],
            [-7.002045761807718, -12.326415681825997],
            [-6.991335262122723, -12.330857119225243],
            [-6.987023208424308, -12.335404531718686],
            [-6.98233851299245, -12.333866939584773],
            [-6.977595726689548, -12.334234057825965],
            [-6.973560220335819, -12.336936578690365],
            [-6.9736105413551215, -12.339777305678751],
            [-6.976402361175017, -12.34598340893538],
            [-6.975257191671473, -12.352890060366798],
            [-6.968093025839478, -12.358110047114385],
            [-6.955229779079069, -12.36564179284527],
            [-6.951011388128196, -12.37387467378287],
            [-6.94188408552067, -12.377095097659232],
            [-6.936430633971768, -12.384685613390486],
            [-6.932943447119136, -12.388099720378735],
            [-6.91942573747629, -12.393800755625678],
            [-6.915086121628242, -12.398846852016195],
            [-6.906429137099075, -12.399930853580887],
            [-6.898960161299083, -12.4066322197764],
            [-6.883118637300508, -12.40902708154086],
            [-6.866350925043263, -12.419986748121408],
            [-6.85934954480741, -12.420108856690442],
            [-6.846333566045577, -12.427885201495465],
            [-6.8421111060645545, -12.434944751963148],
            [-6.841917079458579, -12.438310853833542],
            [-6.8465370372217835, -12.442196370117212],
            [-6.846006036867121, -12.447564829207755],
            [-6.851270023133453, -12.464627973642012],
            [-6.853319115657672, -12.467363047972986],
            [-6.854352290855683, -12.4746189343442],
            [-6.860477010140652, -12.482107898393009],
            [-6.864786961515734, -12.485030985808601],
            [-6.868349913947166, -12.491472972865399],
            [-6.896256165310762, -12.516610311050401],
            [-6.9044719024200925, -12.520883752952253],
            [-6.909920540891268, -12.526923253370128],
            [-6.915736658362823, -12.529686989980863],
            [-6.918982248218685, -12.536779487205783],
            [-6.937774926632383, -12.545730611124403],
            [-6.951613938836252, -12.557407165797821],
            [-6.956069061810112, -12.557267174762908],
            [-6.9611299126938855, -12.567686475326713],
            [-6.975092179686492, -12.579045762377948],
            [-6.99077214464836, -12.593098698334815],
            [-6.996639351593631, -12.601294257993754],
            [-7.027643646456667, -12.617778524184708],
            [-7.034575752163743, -12.618874881817758],
            [-7.039458412612994, -12.623156611802111],
            [-7.061243106613223, -12.630414770801384],
            [-7.06892504989689, -12.63657132280235],
            [-7.081560043662153, -12.639621710022567],
            [-7.090305281815142, -12.639276384710318],
            [-7.106578852974758, -12.65307156144844],
            [-7.115500233484989, -12.655738640320877],
            [-7.12897914648855, -12.664617937215194],
            [-7.13636728388254, -12.67097136409453],
            [-7.14548220646631, -12.676349735169062],
            [-7.157337096433294, -12.67708432115802],
            [-7.171207081748834, -12.68501460362903],
            [-7.17677388005143, -12.685951197840025],
            [-7.183302361904981, -12.684904676551882],
            [-7.188009635816365, -12.6862935031817],
            [-7.197322850638795, -12.687156405169347],
            [-7.201821273588045, -12.690092243151657],
            [-7.204100482992901, -12.69414963868106],
            [-7.209653795937832, -12.692284847323453],
            [-7.219081924615721, -12.69392060607228],
            [-7.232632421309663, -12.6898836367274],
            [-7.235145902704391, -12.690345532093557],
            [-7.242907938542495, -12.688106539376419],
            [-7.244246878161368, -12.68501225772421],
            [-7.25263200769048, -12.68225537373586],
            [-7.258269723204028, -12.683096192420011],
            [-7.264461103762731, -12.680534497887287],
            [-7.267498446546892, -12.68170919968277],
            [-7.270998305071056, -12.679919876896111],
            [-7.28295473624842, -12.684921543060927],
            [-7.292558975847773, -12.685738004684312],
            [-7.299997743410582, -12.687220427022938],
            [-7.3107227901289615, -12.695629347751536],
            [-7.316544671122813, -12.703301369399988],
            [-7.323168846254437, -12.70824014927011],
            [-7.338364801579917, -12.715661915693985],
            [-7.34295066599675, -12.719448238635964],
            [-7.350580391111039, -12.735584054667516],
            [-7.360883359799107, -12.743448105870606],
            [-7.375930097841858, -12.749896684487444],
            [-7.387483018257449, -12.75130053903412],
            [-7.395107826793562, -12.75531065299154],
            [-7.399736362633483, -12.761408417591095],
            [-7.407249166160193, -12.76244109372857],
            [-7.414415499061561, -12.764983923965744],
            [-7.417464375576406, -12.769250691297433],
            [-7.423382076667146, -12.773377949487466],
            [-7.428876961121822, -12.782155613373103],
            [-7.441183301414802, -12.791438744965273],
            [-7.443893257160321, -12.796453298330038],
            [-7.44768732501025, -12.7999209386036],
            [-7.460699453516054, -12.804927783201828],
            [-7.465960962563304, -12.804418426488],
            [-7.479612506239192, -12.810544211832262],
            [-7.49605248415448, -12.814017632042686],
            [-7.504287979826367, -12.819762521628695],
            [-7.503940243740116, -12.826940554965116],
            [-7.508720737852653, -12.82984919052514],
            [-7.511177413079822, -12.83510446201635],
            [-7.516069459594576, -12.835207978640907],
            [-7.519194921433649, -12.836912992799832],
            [-7.525877342571599, -12.845530549693178],
            [-7.533927355108295, -12.857396781489165],
            [-7.5351731207206, -12.861972377572997],
            [-7.541170840529168, -12.862373456525543],
            [-7.546529250800128, -12.86983445226712],
            [-7.5450215362425945, -12.87461947264939],
            [-7.543384292702305, -12.895166942153443],
            [-7.545371849987297, -12.901225206420692],
            [-7.549694898093761, -12.90907388960562],
            [-7.555935759148242, -12.917623681560352],
            [-7.559310385603771, -12.920212717310722],
            [-7.566031162703673, -12.922623342823936],
            [-7.569958733403687, -12.9280961387281],
            [-7.574505902621699, -12.941573585741175],
            [-7.582818780475849, -12.950340513234206],
            [-7.582756949752685, -12.967337608033189],
            [-7.5857965071267826, -12.970395082919737],
            [-7.587843338434404, -12.976496148005923],
            [-7.594416969628489, -12.97608364296721],
            [-7.597606171854569, -12.9788537461264],
            [-7.60084860074737, -12.97616053389632],
            [-7.6071465341203215, -12.977287240047357],
            [-7.609183847375222, -12.982136908861214],
            [-7.60974100867552, -12.98707894606803],
            [-7.614473845856124, -12.996366024571579],
            [-7.619041539213165, -12.999217844095881],
            [-7.619389656339205, -13.002936751957309],
            [-7.6245462866036515, -13.007965693035079],
            [-7.631989074377559, -13.010942031695693],
            [-7.635383488036095, -13.016746589885035],
            [-7.640252499738221, -13.021467152686487],
            [-7.648813550897984, -13.026280326398446],
            [-7.653750860619217, -13.027349179362385],
            [-7.6575403790805545, -13.031521025969356],
            [-7.666740387160403, -13.033361106522525],
            [-7.667944707422807, -13.026001515328742],
            [-7.6668835898749235, -13.019539008597727],
            [-7.667989422439959, -13.010184499673379],
            [-7.671902805695569, -13.005043436433954],
            [-7.680289452578299, -12.998468217495137],
            [-7.688660915144883, -12.994725405679356],
            [-7.690188122744824, -12.990877643367092],
            [-7.697362701414637, -12.984928029555013],
            [-7.701512567730075, -12.984253714795484],
            [-7.70569627452155, -12.979003234804585],
            [-7.716344846569252, -12.97563134235176],
            [-7.722483056052077, -12.975473103834851],
            [-7.735229393840532, -12.969640331771759],
            [-7.739447770985947, -12.968636860198096],
            [-7.743189624753583, -12.96305855339476],
            [-7.755041971123536, -12.956371070470313],
            [-7.7648154084808185, -12.948545721123848],
            [-7.7684780886052085, -12.947378613393605],
            [-7.779217437670556, -12.936857132277181],
            [-7.785187610995823, -12.936756893016888],
            [-7.811630419963525, -12.929012412389584],
            [-7.819897424665061, -12.92781236598828],
            [-7.826082765773064, -12.928028300371608],
            [-7.829880789308466, -12.92468336611074],
            [-7.8361468901903, -12.922961274872659],
            [-7.841848985223731, -12.917997583988507],
            [-7.853743899619832, -12.914400030831716],
            [-7.855611722674912, -12.911382039790627],
            [-7.855547129750442, -12.901719965705256],
            [-7.857328626846057, -12.896383809444993],
            [-7.8638125128333805, -12.88849582387968],
            [-7.870621857319742, -12.878003100888167],
            [-7.879688090392705, -12.869400325534805],
            [-7.883821527136058, -12.853690618456339],
            [-7.890734447416918, -12.835474350360586],
            [-7.889504046197619, -12.822979968434616],
            [-7.890715793545448, -12.81642976258627],
            [-7.884132509001213, -12.805033850246202],
            [-7.883280816491385, -12.79999890064208],
            [-7.887426174480029, -12.798615661060632],
            [-7.889152339558664, -12.794778642241015],
            [-7.885040760390996, -12.786052297929318],
            [-7.881819481879575, -12.7830939213551],
            [-7.881020568574179, -12.775114904194789],
            [-7.88363308357552, -12.770721817326686],
            [-7.881334577064358, -12.765439133941351],
            [-7.8791364833746185, -12.750022957639997],
            [-7.873144248054717, -12.742483011228979],
            [-7.87496997502529, -12.737487842828973],
            [-7.875971851351734, -12.730025667883513],
            [-7.8746074612899175, -12.720973726938636],
            [-7.871394659357327, -12.713333015608148],
            [-7.8745879421695655, -12.706296315335338],
            [-7.873417879627908, -12.697419980695726],
            [-7.870093447602379, -12.691354380552932],
            [-7.866109001279136, -12.6780056521234],
            [-7.86590726740932, -12.670179348553816],
            [-7.863473780998444, -12.665776847707493],
            [-7.864419423625229, -12.661400308193995],
            [-7.863164857821186, -12.658462922184833],
            [-7.864805144125893, -12.65444069059585],
            [-7.862686176344485, -12.648491547265527],
            [-7.8626281082228635, -12.642208406080746],
            [-7.865469861040444, -12.63706577691679],
            [-7.864535318239493, -12.6315352106229],
            [-7.860322200907788, -12.62648033752207],
            [-7.860421844119313, -12.61730425733315],
            [-7.861851837731203, -12.61075740450397],
            [-7.873406881570449, -12.579231119344762],
            [-7.8848960059541, -12.56123889126879],
            [-7.884492562502522, -12.557914173998316],
            [-7.87929844129376, -12.547777224260487],
            [-7.888300213816516, -12.537976724288312],
            [-7.887143106657675, -12.533153163537655],
            [-7.89101105880246, -12.532516813124754],
            [-7.895044356690296, -12.522931824228605],
            [-7.893970296824365, -12.513320734293675],
            [-7.895895178500293, -12.510033576261206],
            [-7.895593523122877, -12.506110143724518],
            [-7.90114562587273, -12.500645914478442],
            [-7.8961819342315644, -12.494195870242047],
            [-7.893645884007265, -12.484514972208265],
            [-7.897796540359245, -12.478630969419559],
            [-7.906482444978928, -12.477584630901495],
            [-7.910197182945108, -12.48095927912581],
            [-7.913796327708601, -12.47706802323858],
            [-7.918973827603258, -12.477009056536337],
            [-7.922679328582519, -12.473627366085449],
            [-7.920610486817024, -12.465024326994424],
            [-7.924098174605659, -12.455837729475371],
            [-7.929526776666828, -12.446913817377258],
            [-7.932001937254032, -12.446051102405754],
            [-7.932067261263783, -12.441032184393203],
            [-7.928072771057102, -12.436151909671537],
            [-7.928002080440607, -12.428873972829823],
            [-7.933095156572507, -12.411143308107984],
            [-7.938317491190785, -12.408119570876357],
            [-7.935801478903834, -12.400025222310036],
            [-7.9395362949245225, -12.394230549412452],
            [-7.939662142833263, -12.38504297861975],
            [-7.938174051630812, -12.382272088573698],
            [-7.942901467733643, -12.375359114802173],
            [-7.943488689214245, -12.368590449997438],
            [-7.947709841323873, -12.363379695588362],
            [-7.945231197547977, -12.359566608281728],
            [-7.956739367899922, -12.346875559431076],
            [-7.956434894663332, -12.340660220806036],
            [-7.961899282500073, -12.33197848943516],
            [-7.961906144456482, -12.328173961951663],
            [-7.966034674365632, -12.325278453942124],
            [-7.970875201500844, -12.327147647713613],
            [-7.983635591290199, -12.319538147355916],
            [-7.985948040838592, -12.31714484801253],
            [-7.992855221241082, -12.317372332155987],
            [-7.997553693464516, -12.314728705640103],
            [-8.00084051631737, -12.308991997578053],
            [-7.999632511056196, -12.304817557823847],
            [-7.999518276443027, -12.29822752983826],
            [-7.996604737652078, -12.296909508997578],
            [-7.995629389224767, -12.289298266656836],
            [-8.00091247352292, -12.286024442127852],
            [-8.0034578981582, -12.2816260331022],
            [-8.002625856671282, -12.278681159983147],
            [-8.007303081649182, -12.27347518315822],
            [-8.012235489582295, -12.273104574003682],
            [-8.01566171480175, -12.267220699700987],
            [-8.01671900056207, -12.261886304211954],
            [-8.017145928569743, -12.252190259509366],
            [-8.020008076862085, -12.248017623772595],
            [-8.028563969977641, -12.238946845502468],
            [-8.027865041115536, -12.236470911473386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -155.5183057478321, "lat": 19.59836555354384 },
        "year": "2023",
        "ste_code": ["15"],
        "ste_name": ["Hawaii"],
        "coty_code": ["15001"],
        "coty_name": ["Hawaii"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hawaii County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00365280"
      },
      "bbox": [
        -8.028563969977641, -13.033361106522525, -6.841917079458579,
        -11.711870084973734
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.329958889763494, 4.612543787509166],
            [-11.32639161286325, 4.612095576680435],
            [-11.26912989618243, 4.602319272323866],
            [-11.226789477683894, 4.5953319892138325],
            [-11.231736404732139, 4.566585075069656],
            [-11.168573559478231, 4.555711317380983],
            [-11.158862150335782, 4.61330262793407],
            [-11.155175276776001, 4.62748834883032],
            [-11.140755337795222, 4.71375552439118],
            [-11.126524728187954, 4.711327148094468],
            [-11.096229368851077, 4.706139483139372],
            [-11.027251638133727, 4.694720917937915],
            [-11.02455956647242, 4.69988876594571],
            [-11.025234808498446, 4.705058983071222],
            [-11.021483881337112, 4.708482112323301],
            [-11.0086662783916, 4.706281984138783],
            [-11.009182437843371, 4.702586636900677],
            [-11.00569799047231, 4.702029580579757],
            [-11.007507654660671, 4.691160639407932],
            [-10.92964179993011, 4.678385240651266],
            [-10.926684883179096, 4.67726765811331],
            [-10.930459458979378, 4.674110122290731],
            [-10.931146210941609, 4.670904445009816],
            [-10.929085590028405, 4.668109497018289],
            [-10.930673694415765, 4.652869009305628],
            [-10.920252283387486, 4.653982621311164],
            [-10.9196460455201, 4.646774516502242],
            [-10.917928592503664, 4.643064352334718],
            [-10.920809407575817, 4.63606391165241],
            [-10.916758544235167, 4.627009377059983],
            [-10.910159515711118, 4.626153959427268],
            [-10.906045360407767, 4.621392423476226],
            [-10.906589442177221, 4.61406845827658],
            [-10.903165172984266, 4.609173572628889],
            [-10.909207058634822, 4.606013839878087],
            [-10.916144985693059, 4.598728617289905],
            [-10.920369178189308, 4.596490510556385],
            [-10.917932221582534, 4.593493473973525],
            [-10.92563411807905, 4.58854249459085],
            [-10.934211139778046, 4.586327016102296],
            [-10.935243519469973, 4.581938668958101],
            [-10.931624869876272, 4.570911210398766],
            [-10.93567475949191, 4.565111139958009],
            [-10.935051789019884, 4.555727760037429],
            [-10.93804655108462, 4.555063155861585],
            [-10.93839780593519, 4.549550943094739],
            [-10.93436353102126, 4.54609235910932],
            [-10.933770187413261, 4.5412645249594],
            [-10.924753845482345, 4.537757418281345],
            [-10.92637273296559, 4.532979805240147],
            [-10.93791238685369, 4.527681858569441],
            [-10.945968158708284, 4.525369927163858],
            [-10.95093240119299, 4.519347935520046],
            [-10.952657450971598, 4.513933691708944],
            [-10.961592670978671, 4.5150970406539015],
            [-10.965667047393351, 4.51109045889512],
            [-10.966796822879843, 4.506089580910558],
            [-10.965863844559644, 4.502354194289458],
            [-10.967626691963519, 4.498468092568745],
            [-10.967979590110112, 4.49324808836691],
            [-10.97061201035885, 4.487801415682716],
            [-10.972982431922187, 4.48580531689289],
            [-10.980380213708314, 4.474717207950519],
            [-10.980697016819146, 4.467767145057442],
            [-10.982852692515833, 4.457963675545719],
            [-10.976733259868421, 4.450504683754817],
            [-10.976778664905805, 4.439710821518205],
            [-10.978269030431527, 4.428229461624509],
            [-10.976007766379476, 4.419633522165444],
            [-10.968894779192896, 4.413623034891759],
            [-10.965042047134464, 4.406022514151958],
            [-10.962926355556595, 4.4051167575168755],
            [-10.968197346422281, 4.395487667501457],
            [-10.968182201873523, 4.38778146449716],
            [-10.97122406924547, 4.383661232463668],
            [-10.972517427781401, 4.377328896811896],
            [-10.978417837507187, 4.372039055968492],
            [-10.97864934341279, 4.363982143412155],
            [-10.976986337669835, 4.358826380516369],
            [-10.9711094472866, 4.356154678713682],
            [-10.966637972561752, 4.356949709100728],
            [-10.961514826175131, 4.346838336699155],
            [-10.957623774143098, 4.344287716832793],
            [-10.951011104472174, 4.344745292255158],
            [-10.947401501280071, 4.34131858095361],
            [-10.945547097218732, 4.336470168112997],
            [-10.940495506465448, 4.334317869115936],
            [-10.933294635866849, 4.334120738049944],
            [-10.926248925139603, 4.3281398089414305],
            [-10.922698459142177, 4.323751376736049],
            [-10.924857747268039, 4.316776456051604],
            [-10.921459217248344, 4.311734219993012],
            [-10.92510080697666, 4.301746649858523],
            [-10.92213695442098, 4.295169681396762],
            [-10.922702948937584, 4.290414938404284],
            [-10.925731675671901, 4.2889295733418775],
            [-10.925242236883056, 4.277148519838492],
            [-10.928052570058062, 4.272090272352776],
            [-10.927202905013045, 4.262727037256759],
            [-10.928539618520588, 4.254493912622223],
            [-11.005430354109292, 4.266947534147751],
            [-11.10543132401479, 4.283551601176585],
            [-11.174013740736545, 4.294354990980208],
            [-11.239688385910833, 4.305326688442387],
            [-11.29580574777543, 4.314573498267951],
            [-11.366656777512896, 4.326010560288405],
            [-11.346243745504637, 4.443906245092898],
            [-11.337286017696472, 4.496372913982048],
            [-11.309030524860338, 4.491288345832847],
            [-11.297907008403664, 4.559263221848494],
            [-11.30029077476091, 4.559688278965506],
            [-11.301038567381879, 4.564306562084658],
            [-11.30563824174864, 4.568419058075113],
            [-11.308764276593736, 4.5802089436740125],
            [-11.312020217034716, 4.587189081912564],
            [-11.312344136942384, 4.593972886957239],
            [-11.317974333205111, 4.593155279581585],
            [-11.323334331958337, 4.595241474559844],
            [-11.32534832366885, 4.607596737130573],
            [-11.329958889763494, 4.612543787509166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.81321828263302,
          "lat": 42.18108640388174
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16041"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00395585"
      },
      "bbox": [
        -11.366656777512896, 4.254493912622223, -10.903165172984266,
        4.71375552439118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.811212144139703, -0.3889647497435944],
            [5.869485732224174, -0.3847543855856624],
            [5.88043994476494, -0.383624631525651],
            [5.965700813020188, -0.37689057563022815],
            [6.007927773766452, -0.3730706236148592],
            [6.026194410999935, -0.3712197256133614],
            [6.054962426943969, -0.36929176691792465],
            [6.1413621345023515, -0.3638826467345582],
            [6.144892216071285, -0.41867610412788014],
            [6.150551681518472, -0.500004243066561],
            [6.156703591613818, -0.5838903290268699],
            [6.159951979765992, -0.6275332136862429],
            [6.137621459342884, -0.6291322086542487],
            [6.116656023354018, -0.6310081672285425],
            [6.059835400757206, -0.6356656304619477],
            [6.044962163389492, -0.6370223213044979],
            [5.973111847155238, -0.6430886241948305],
            [5.92691793132232, -0.646405134920154],
            [5.900261106682292, -0.6485203057465287],
            [5.849464242144816, -0.652029609510678],
            [5.813577232507439, -0.6548250823627078],
            [5.810649232837082, -0.6098158675454037],
            [5.807431231482773, -0.5659782989331744],
            [5.786578465822352, -0.5673641774033373],
            [5.785915007710697, -0.5651380621763598],
            [5.791360486901603, -0.5626780434418042],
            [5.7961899880933965, -0.5618645986003469],
            [5.7983005313049185, -0.5593880645516989],
            [5.79888544203989, -0.55473139130201],
            [5.802823744442309, -0.5484732101687726],
            [5.80309786713, -0.5385723432377203],
            [5.808783893930332, -0.5299106783036841],
            [5.811664898765304, -0.5148837101327502],
            [5.807515800379335, -0.5066731541465049],
            [5.811326347880552, -0.5018266719537274],
            [5.810859341564659, -0.498948704798928],
            [5.813985745167032, -0.49682835569446665],
            [5.811811662451981, -0.48976092827556994],
            [5.804635714863059, -0.48388003059159956],
            [5.8075145388339715, -0.4820855737562974],
            [5.811969478419474, -0.4744820947043576],
            [5.814612896511871, -0.4618925690851454],
            [5.8185516556914525, -0.46108190123342163],
            [5.824592178034574, -0.45434667358087943],
            [5.825419044702592, -0.44956970711281014],
            [5.820095640964151, -0.443681583835249],
            [5.822261066572263, -0.43536429233625623],
            [5.8201375020819555, -0.4335196850873638],
            [5.820820145155471, -0.4293100580191499],
            [5.82494145314021, -0.4277334303096257],
            [5.821864029130739, -0.4230037636077869],
            [5.824647839708507, -0.4193473404763558],
            [5.8223833345550045, -0.4169663261761621],
            [5.814985765104703, -0.41523466177192747],
            [5.813844601253815, -0.41306058174602084],
            [5.8088563991346565, -0.4124406206512948],
            [5.80958708634449, -0.40849188577942813],
            [5.812662425019586, -0.40454752438075037],
            [5.810244647674287, -0.39703814822978234],
            [5.811212144139703, -0.3889647497435944]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.92412989268665,
          "lat": 37.992295984879966
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17055"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00424229"
      },
      "bbox": [
        5.785915007710697, -0.6548250823627078, 6.159951979765992,
        -0.3638826467345582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.553711448032183, 2.8143555336147217],
            [5.556256811122118, 2.784117030651005],
            [5.563058675677508, 2.696033606787429],
            [5.5697430658950795, 2.6073545275815926],
            [5.48261150303653, 2.601017290234881],
            [5.423486761063788, 2.596816051971545],
            [5.428540620671014, 2.602044150040957],
            [5.435025091605913, 2.605227400750689],
            [5.439347324415176, 2.6114762351029506],
            [5.440689758132505, 2.6180360806652887],
            [5.439911230039791, 2.633875674064094],
            [5.442115506061903, 2.6426270486102816],
            [5.426552941595601, 2.641504560203876],
            [5.3401198760133175, 2.6361365617128283],
            [5.337848552582546, 2.6652232372408595],
            [5.333995191799252, 2.721865695382854],
            [5.383681969224456, 2.7249642515932297],
            [5.415664043759473, 2.726688879899782],
            [5.4201626121429625, 2.7534947145043636],
            [5.4253034584519435, 2.7690505241554777],
            [5.426508622605199, 2.778656958963135],
            [5.422330643564068, 2.786685746146094],
            [5.422275068928495, 2.7900508583709716],
            [5.426803334806937, 2.7958053831853213],
            [5.449073946432906, 2.8036470684579506],
            [5.457780073457902, 2.8082872507524486],
            [5.464536628221907, 2.810212948334363],
            [5.47472707671591, 2.8204568460789803],
            [5.481911768042085, 2.8216778301583765],
            [5.489342196485162, 2.818964600511092],
            [5.496587005577773, 2.817867915712586],
            [5.508051248429672, 2.814024584969066],
            [5.516212710980111, 2.8137148712488673],
            [5.524247556488288, 2.8143296699731275],
            [5.541145006246069, 2.8124237563550287],
            [5.551782559933136, 2.8131407454239437],
            [5.553711448032183, 2.8143555336147217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.28577073627278, "lat": 41.20444374286698 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17155"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00424279"
      },
      "bbox": [
        5.333995191799252, 2.596816051971545, 5.5697430658950795,
        2.8216778301583765
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.118645310781721, -0.011441131902142016],
            [6.115099678758643, 0.03377632312942504],
            [6.108869734320075, 0.12062739397855614],
            [6.196676712760163, 0.12870217182500057],
            [6.212459101205433, 0.1295913566969843],
            [6.270519433399325, 0.1320958091389693],
            [6.285162506570925, 0.13236549884199247],
            [6.3241102397228115, 0.13428890181076017],
            [6.367080062793954, 0.13708554061172035],
            [6.449656832405826, 0.1406402139299884],
            [6.452316730914395, 0.14122721401472393],
            [6.462417826887099, 0.14206715961031918],
            [6.53404143232219, 0.14641335872235128],
            [6.536755388487194, 0.11730550801788543],
            [6.543814260168219, 0.029964112591198903],
            [6.5446085561727605, 0.01522242639382345],
            [6.545738891318436, 0.009295350845687217],
            [6.546324950291994, -0.0007236838675971911],
            [6.551126788874675, -0.06304197166701007],
            [6.5551625391883706, -0.11769605284915688],
            [6.558099583970209, -0.1596145116369423],
            [6.56043491418628, -0.1977588421049191],
            [6.533670008204968, -0.19951338051681244],
            [6.474962013006009, -0.20394681241798046],
            [6.4325879068512695, -0.20852412177031246],
            [6.390392947662399, -0.2124839174912462],
            [6.344387877115679, -0.21578651358963727],
            [6.3039181661519965, -0.21923148420291105],
            [6.276924299602131, -0.22113424737712306],
            [6.2497456628060934, -0.22275796664958267],
            [6.204166404217202, -0.2262348759880195],
            [6.13289929513208, -0.23138664731848121],
            [6.130320092330482, -0.18921920281082158],
            [6.130560308376414, -0.1890184182726199],
            [6.128041076818709, -0.1445747718963204],
            [6.125739879397052, -0.11523937006372932],
            [6.12394634029571, -0.08520769112407359],
            [6.118645310781721, -0.011441131902142016]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.4255646035933, "lat": 38.42957753579806 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17191"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "00424296"
      },
      "bbox": [
        6.108869734320075, -0.23138664731848121, 6.56043491418628,
        0.14641335872235128
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.624176505044666, 1.291746075739189],
            [8.666929000649983, 1.2968205639448034],
            [8.751956532021111, 1.3075036864495695],
            [8.755424556822858, 1.3081133404852756],
            [8.823013045118723, 1.3152504951913502],
            [8.833354512671086, 1.3163608217633385],
            [8.833297794547223, 1.3145824584079477],
            [8.890853498999494, 1.321124676357432],
            [8.90447072874077, 1.3228971901943065],
            [8.96552524581601, 1.3288391282843992],
            [8.991034458565995, 1.3305806916247418],
            [8.995918472456845, 1.2868663097200062],
            [9.004723046361786, 1.1999503561004565],
            [9.013619605957546, 1.112922169767891],
            [8.994647225701415, 1.111092509168205],
            [8.94766734268647, 1.1061018259680258],
            [8.930206714687603, 1.1039146540204243],
            [8.874006221601421, 1.098230535849338],
            [8.826006320930107, 1.0931137783358786],
            [8.826038433270757, 1.09600006185168],
            [8.774519721403736, 1.0904095320401692],
            [8.738240354049148, 1.085557229366869],
            [8.731203537405491, 1.0837139067100694],
            [8.70988746018974, 1.0810539728011088],
            [8.670312908121913, 1.0472319456572154],
            [8.65454495142706, 1.0339529941471755],
            [8.649115385996998, 1.0827242091409013],
            [8.648447647950155, 1.085852476944638],
            [8.644786573426407, 1.1177216056311365],
            [8.640495022962133, 1.1586043004678463],
            [8.636835714086384, 1.1862830371813706],
            [8.632772429459086, 1.2193878999098757],
            [8.623797955683486, 1.29170023515655],
            [8.624176505044666, 1.291746075739189]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.06022090817657, "lat": 39.41488830267621 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18047"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00450352"
      },
      "bbox": [
        8.623797955683486, 1.0339529941471755, 9.013619605957546,
        1.3305806916247418
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1824361759276787, 3.6773950063119685],
            [3.257599739199655, 3.680231264823667],
            [3.2685975823942224, 3.680752020376487],
            [3.3542541635107233, 3.6840175255994785],
            [3.408001708741027, 3.686650424002948],
            [3.427436382466314, 3.6871045583948954],
            [3.468470763859077, 3.6895107288142794],
            [3.52570831293775, 3.6931305470348685],
            [3.5284303638838237, 3.6057227865559405],
            [3.5293490804768037, 3.569825805576515],
            [3.5308768074314214, 3.5178872898541904],
            [3.5325686160736596, 3.475587175973175],
            [3.534206258807058, 3.4298419971352634],
            [3.538610366397109, 3.3566287789557863],
            [3.5434521846173928, 3.279601037084033],
            [3.5448000470462038, 3.2540724795953273],
            [3.4877221319455614, 3.2513480511641717],
            [3.4303011963496943, 3.2494618622238023],
            [3.420088622872928, 3.249318650014644],
            [3.379942211475337, 3.2478899391137555],
            [3.372583700831747, 3.2478780803574088],
            [3.326277271794475, 3.2456990788942615],
            [3.2823362279019244, 3.2438094550481535],
            [3.250141260717004, 3.2426643710798326],
            [3.243252635113125, 3.242720897963071],
            [3.1999447329749744, 3.240742792571311],
            [3.198243658461137, 3.2853475126144733],
            [3.1960645047716625, 3.3570881868821356],
            [3.195170992668736, 3.3715363928492],
            [3.190733829871844, 3.4584532857814803],
            [3.1873131420172993, 3.542431419597313],
            [3.1857977974618175, 3.5902893706817944],
            [3.1824361759276787, 3.6773950063119685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.06574586341449, "lat": 42.08018990285273 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19011"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00465195"
      },
      "bbox": [
        3.1824361759276787, 3.240742792571311, 3.5448000470462038,
        3.6931305470348685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9821218437582075, 4.016350509559311],
            [3.020887262509912, 4.017695500880112],
            [3.1191819189673398, 4.021427195317327],
            [3.1983289247008484, 4.024394298976923],
            [3.2791682369474646, 4.027569181358622],
            [3.3023680272520246, 4.028316652417779],
            [3.327548954277465, 4.029446683623654],
            [3.3302825035289136, 3.956573269655855],
            [3.3301952484260866, 3.9530319273045174],
            [3.3317968629933734, 3.9133321709005853],
            [3.332186398233371, 3.9098843878539724],
            [3.3349175046638693, 3.8550527622145645],
            [3.347554985235452, 3.8556032017367894],
            [3.350668439244221, 3.7716962045656652],
            [3.3542541635107233, 3.6840175255994785],
            [3.2685975823942224, 3.680752020376487],
            [3.257599739199655, 3.680231264823667],
            [3.1824361759276787, 3.6773950063119685],
            [3.0956958077137773, 3.673831966201429],
            [3.010124087896604, 3.6703790195407535],
            [3.006671679371617, 3.757727035034881],
            [3.0034193268922307, 3.8436041610517035],
            [2.988539848183869, 3.8430731588166633],
            [2.9854155326914817, 3.9296212636142442],
            [2.984915527803566, 3.936847365999719],
            [2.9830689475390875, 3.995050297949719],
            [2.9821218437582075, 4.016350509559311]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.30882100656001,
          "lat": 42.470087365945695
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19013"],
        "coty_name": ["Black Hawk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Black Hawk County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00465196"
      },
      "bbox": [
        2.9821218437582075, 3.6703790195407535, 3.3542541635107233,
        4.029446683623654
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9726717796485995, 4.281862599704447],
            [2.9889096773755233, 4.28258830925395],
            [3.058624546409878, 4.284952524414933],
            [3.1306860807355297, 4.287709926146468],
            [3.187744583867595, 4.2897998816563545],
            [3.284909349036622, 4.293478334311817],
            [3.316631253057237, 4.295058013149393],
            [3.317800542374651, 4.264623148633974],
            [3.3186110885050066, 4.250017823837814],
            [3.3195366700643127, 4.219245565262843],
            [3.320305415092499, 4.206270130588845],
            [3.3230872213980445, 4.135480135620047],
            [3.3239159892303327, 4.117384128846036],
            [3.327548954277465, 4.029446683623654],
            [3.3023680272520246, 4.028316652417779],
            [3.2791682369474646, 4.027569181358622],
            [3.1983289247008484, 4.024394298976923],
            [3.1191819189673398, 4.021427195317327],
            [3.020887262509912, 4.017695500880112],
            [2.9821218437582075, 4.016350509559311],
            [2.980592275299831, 4.060048890892781],
            [2.979696097456411, 4.076896447855563],
            [2.978430138415367, 4.118969217814555],
            [2.9757693555705913, 4.192802292830405],
            [2.9726717796485995, 4.281862599704447]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.31807027712429,
          "lat": 42.774588532332785
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19017"],
        "coty_name": ["Bremer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bremer County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00465198"
      },
      "bbox": [
        2.9726717796485995, 4.016350509559311, 3.327548954277465,
        4.295058013149393
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9071309603758816, 4.5868911989449455],
            [0.9932200651526383, 4.587649635721203],
            [1.121467237420646, 4.588813679584],
            [1.2508327803424368, 4.589784675759584],
            [1.2520158416936686, 4.503309046772097],
            [1.2529198164612387, 4.417446176348826],
            [1.2537092063590152, 4.329939610913868],
            [1.2546796888705478, 4.2436054281907065],
            [1.15312362744245, 4.2424982675533185],
            [1.1111321194749093, 4.242304498178286],
            [1.0437660987880613, 4.2416385853374186],
            [0.9960095038613388, 4.241412367071672],
            [0.9092906098575911, 4.240726251990105],
            [0.9083139709930215, 4.327230134652331],
            [0.9082194808294759, 4.429930604452313],
            [0.908096995461817, 4.473503430102629],
            [0.9074329540053255, 4.5301416433577115],
            [0.9071309603758816, 4.5868911989449455]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.15092819086215,
          "lat": 43.082555874773114
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19041"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00465625"
      },
      "bbox": [
        0.9071309603758816, 4.240726251990105, 1.2546796888705478,
        4.589784675759584
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.795605016945903, 0.0766680666437403],
            [9.839145616377351, 0.1364526695973123],
            [9.880997972158742, 0.1939912712357498],
            [9.882136684374823, 0.19445326201689409],
            [9.887363391417988, 0.20045217271870525],
            [9.891193324956955, 0.20140208015305366],
            [9.901216210556566, 0.20083857615355535],
            [9.90324391922037, 0.1989912386997819],
            [9.902856882659924, 0.19474558157744842],
            [9.907962259510377, 0.19333564804901562],
            [9.908999533832368, 0.18708245536903598],
            [9.911511407737509, 0.18321044983274115],
            [9.920253166972843, 0.1813690923006968],
            [9.922174129368122, 0.1858760744875519],
            [9.923915377725569, 0.19527471402164098],
            [9.931581378022052, 0.1986231481671965],
            [9.93350689807481, 0.19774385199834404],
            [9.937134771470689, 0.19200893779459016],
            [9.940221839097646, 0.19054381229804063],
            [9.944242020257999, 0.1989856587881584],
            [9.94855211730171, 0.2013366579961708],
            [9.951021116514575, 0.19934294005378103],
            [9.951872362556845, 0.19420418029136616],
            [9.953982261888038, 0.19145124824693693],
            [9.964099648891949, 0.19257713344071858],
            [9.96676490932602, 0.19550000600526182],
            [9.967130228488706, 0.199958506832431],
            [9.969617487802047, 0.20235338036361986],
            [9.975012518016783, 0.20306179790148293],
            [9.978548357949116, 0.20041011105987358],
            [9.979703484910726, 0.19543919234193866],
            [9.977737466516803, 0.1930984177965932],
            [9.973330507320556, 0.19248962285170815],
            [9.971607333217943, 0.1875687032381995],
            [9.970760990699409, 0.17657563399983225],
            [9.97147015601789, 0.17375029837986544],
            [9.976448373123391, 0.17173047694287416],
            [9.979164705923672, 0.1778089146932509],
            [9.981578583689467, 0.17882399440803304],
            [9.991905084946486, 0.17934216828087876],
            [9.996560697096724, 0.17441211198915466],
            [9.995553700771522, 0.17019362508236488],
            [9.991034086847545, 0.1677434729754103],
            [9.989029317723714, 0.1624433302534232],
            [9.997066706521519, 0.1550749823973798],
            [10.003539967555746, 0.1583387165252015],
            [10.007446787870707, 0.16354688676405524],
            [10.007464464900982, 0.17320909371527918],
            [10.011036975901725, 0.17405833348391112],
            [10.014212718528846, 0.16583860076183987],
            [10.008539484086722, 0.16014231647251054],
            [10.006821996579456, 0.15628019231005136],
            [10.011388819530488, 0.14748376607070324],
            [10.011188453898935, 0.14217351881858925],
            [10.008710852098686, 0.13966863437992744],
            [10.008337216846018, 0.12933993923331763],
            [10.010026049113034, 0.12528685163278025],
            [10.007150895100393, 0.11933117470019068],
            [10.008794439907403, 0.11337092743969254],
            [10.011235798785957, 0.11052573951731622],
            [10.017814089023664, 0.1118151154806551],
            [10.012206762608512, 0.12212165561845635],
            [10.016137176260516, 0.12434534368763234],
            [10.018213973201357, 0.12771370948281607],
            [10.021435132385664, 0.12665278918216347],
            [10.024628444311299, 0.1198957373190205],
            [10.030786673376884, 0.11240318917565598],
            [10.034459319941817, 0.11704341700459027],
            [10.040894204343793, 0.117366087196863],
            [10.045198081401296, 0.10992873914447195],
            [10.050303083836203, 0.09936992470970234],
            [10.05109580039388, 0.09353215507728527],
            [10.054167998802667, 0.08846789958190451],
            [10.059148916950798, 0.09656072176368576],
            [10.060760761826607, 0.10619705360614373],
            [10.066452413262683, 0.1013181629417646],
            [10.070100903035328, 0.0998048097519527],
            [10.073824285146811, 0.09575531542746724],
            [10.076899421428648, 0.09821954940732343],
            [10.081017410200085, 0.09835088967473861],
            [10.077200565660934, 0.10744136868191087],
            [10.083668702264752, 0.10885157278338732],
            [10.095014329864624, 0.09555616248805464],
            [10.09678937634357, 0.09221535240902055],
            [10.093222854542374, 0.09069608239922647],
            [10.091573965108472, 0.08548915654828258],
            [10.08769619620593, 0.08613027780568583],
            [10.078456641969002, 0.07858724315159192],
            [10.077776452611882, 0.07309117934467624],
            [10.081955108805648, 0.06988776535953811],
            [10.07892452137603, 0.06637826102299511],
            [10.082131189072816, 0.06256879983319234],
            [10.084459998889963, 0.053987977603707],
            [10.096948283837168, 0.04999262289696907],
            [10.098401385471792, 0.05373069821602483],
            [10.102017481802397, 0.05684330421004959],
            [10.10359360306498, 0.060299271746587335],
            [10.104862285988084, 0.06915571337078286],
            [10.109731726784574, 0.06922623142167632],
            [10.111458345017333, 0.07171122592491863],
            [10.118124295725849, 0.07154184823274587],
            [10.12637166674569, 0.0679002793795414],
            [10.12873842108678, 0.06240116273570011],
            [10.131815041491306, 0.06485160419328605],
            [10.134374312459272, 0.05912332445578916],
            [10.131363045211343, 0.05140230510097339],
            [10.133572338152394, 0.04911943730480562],
            [10.12884849047567, 0.04239733058429363],
            [10.132763570112132, 0.03917480253044595],
            [10.138396667199048, 0.04284929335707763],
            [10.14213224930814, 0.04384177667400556],
            [10.147387079186165, 0.04870474834456834],
            [10.154473306141655, 0.04907658314475946],
            [10.159191837591914, 0.0461702120050809],
            [10.159807035639195, 0.043136609861506275],
            [10.163823156523918, 0.03884101919296299],
            [10.159502372121482, 0.037480884352995104],
            [10.158313439259269, 0.030841598040450318],
            [10.154158620993222, 0.028088954953624966],
            [10.15079059680067, 0.023475547133162335],
            [10.153333738543912, 0.021365466046959113],
            [10.156201097477178, 0.02267891300921533],
            [10.162995192314288, 0.019175634873363333],
            [10.160916736493173, 0.015024409742187968],
            [10.166734350953865, 0.00791494193352846],
            [10.167923518918597, 0.00269893331578874],
            [10.172304587407897, 0.0015961283435494305],
            [10.173277098320145, 0.006160709600673708],
            [10.172975658655238, 0.017814501615666556],
            [10.176869487458339, 0.019938809267821867],
            [10.181256540776712, 0.01754989067169549],
            [10.185186093249024, 0.019902468714990393],
            [10.187046867170569, 0.01843139285705418],
            [10.194803793960839, 0.016771614677780624],
            [10.197564201786257, 0.02049287519716049],
            [10.201348613098718, 0.017313134624594904],
            [10.205172424655643, 0.02009289033808523],
            [10.207739658532189, 0.01574859437055037],
            [10.209048684911528, 0.00862653132930422],
            [10.2087124867748, 0.00407124016702036],
            [10.204904111126647, 0.0013107676082234],
            [10.202099528962217, 0.004650903785008628],
            [10.195857272987807, 0.003407976038135999],
            [10.19432122436243, -0.0007702778827637702],
            [10.19130751313318, -0.0022430662594539],
            [10.191232801948244, -0.007737313509674639],
            [10.1875994066733, -0.008066537189221202],
            [10.183837416925819, -0.013493494166871796],
            [10.184112957742427, -0.017015095244320266],
            [10.182586301021008, -0.01884174801097555],
            [10.124158334446491, -0.016505888268526003],
            [10.123153461303595, -0.02431453728408823],
            [10.126889471130008, -0.02872342999875375],
            [10.1284554548576, -0.036032138607193544],
            [10.126375310253618, -0.041211842524306486],
            [10.128568900077235, -0.04953092283595211],
            [10.130427182892078, -0.05201314936788553],
            [10.127826432057, -0.05620610801046081],
            [10.12842126514132, -0.062359181522345375],
            [10.126082854024201, -0.06430735899887961],
            [10.121128288429228, -0.06268298886830759],
            [10.111287037913721, -0.06565959253960803],
            [10.105223920582615, -0.06589272276446047],
            [10.104021001456763, -0.07183026494593521],
            [10.098647960970332, -0.066546986932341],
            [10.09549641384506, -0.06593330475616518],
            [10.089387486740902, -0.05739521043462064],
            [10.082190695497422, -0.05461987375105775],
            [10.074744579403106, -0.05747781815126297],
            [10.072121322512674, -0.05643974966559264],
            [10.068317373736276, -0.05931582567832858],
            [10.06298603328216, -0.0557083838119957],
            [10.055797297563288, -0.060511481854346225],
            [10.054665119169876, -0.06498527558039469],
            [10.049024281805817, -0.06977705948703822],
            [10.044141973815503, -0.07096327868511138],
            [10.041948979325223, -0.07485701769485299],
            [10.028957127049143, -0.07596055276329221],
            [10.02448973684824, -0.07963315994028033],
            [10.02137493350571, -0.08656037931172265],
            [10.013265741649889, -0.08383484431161309],
            [10.002903927782064, -0.08502685226594457],
            [9.997947704469777, -0.08890969793313944],
            [10.00018860196114, -0.09105183564303684],
            [9.99723068244825, -0.09636883249182594],
            [9.995459828011136, -0.09622666468444886],
            [9.992147267085619, -0.101295058627546],
            [9.9893570606505, -0.09535443128286566],
            [9.99143013577482, -0.08873705640847343],
            [9.990320361391491, -0.08750717881600982],
            [9.95110048779931, -0.05654590198115974],
            [9.931231137948545, -0.018983407722528593],
            [9.882131476118225, 0.026249616747147667],
            [9.877300735923214, 0.03049663532392722],
            [9.837065897657387, 0.03703240740965795],
            [9.833079087969246, 0.03533552423830878],
            [9.82789939841753, 0.037376512786624114],
            [9.828035519930609, 0.03982384151450094],
            [9.820274088041053, 0.03993984530565917],
            [9.821845904455493, 0.043460861285316885],
            [9.816583631139798, 0.04590529951385276],
            [9.817474458236997, 0.05104356466920145],
            [9.810149936763207, 0.04365160338494353],
            [9.804758323872358, 0.04479161987343907],
            [9.801025127189833, 0.04971695924285583],
            [9.807384438352537, 0.051009653378604636],
            [9.808139484839728, 0.05629943601017367],
            [9.80278465608018, 0.05669494112162935],
            [9.796804176477012, 0.05950626077084349],
            [9.80154963727758, 0.06284915231845781],
            [9.801656720050484, 0.06653455084188663],
            [9.796186179620253, 0.06698289407032852],
            [9.798600620044684, 0.07146763541329554],
            [9.80228855734456, 0.07276749366442137],
            [9.801189552124038, 0.07647756882356263],
            [9.795605016945903, 0.0766680666437403]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.74262159001469, "lat": 38.14491892561613 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21011"],
        "coty_name": ["Bath"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bath County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00516852"
      },
      "bbox": [
        9.795605016945903, -0.101295058627546, 10.209048684911528,
        0.20306179790148293
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.671034601564275, -1.5957546159433766],
            [6.690226320291186, -1.5879615141281596],
            [6.6985436753161025, -1.58352811758906],
            [6.770596958522195, -1.5499079931167177],
            [6.782076845474359, -1.5458519302130356],
            [6.789503059590613, -1.5423283406977224],
            [6.8736020082099225, -1.4845641888578796],
            [6.884385671664114, -1.4836697565361774],
            [6.889816396007783, -1.4850603431087914],
            [6.893424505481616, -1.4891921921329776],
            [6.900106767256988, -1.491846413799775],
            [6.971516815110774, -1.461342963099577],
            [6.993946607465598, -1.4316646759572074],
            [7.055132356559254, -1.4624857663245776],
            [7.053288905813408, -1.5513092534242212],
            [7.056300347067228, -1.6026913923919586],
            [7.062658740978158, -1.6751383219771137],
            [7.0569819178649835, -1.7959651085987056],
            [7.017015505374185, -1.8003862042529593],
            [6.931398758644581, -1.8107298053150933],
            [6.9316456992703595, -1.779864704971663],
            [6.91371834299114, -1.7799971818146827],
            [6.802086579418662, -1.777391786471079],
            [6.7758985800443305, -1.7786222622566568],
            [6.7554952046045, -1.780193727200703],
            [6.75346336678544, -1.7706747153292384],
            [6.74740436634572, -1.7559437289156226],
            [6.740115217277254, -1.7434697786628073],
            [6.726734275382796, -1.728061643431656],
            [6.717814581906869, -1.713430856550966],
            [6.714078655757999, -1.7049870857466045],
            [6.713831428262266, -1.6982157450911657],
            [6.710846742964371, -1.6940840359800124],
            [6.703698789885182, -1.678580364073164],
            [6.700484899480254, -1.662963328997324],
            [6.698140973815151, -1.655207254555506],
            [6.686125964502181, -1.627611005792166],
            [6.680093350035663, -1.6160685235163368],
            [6.677705176282722, -1.6091266090139653],
            [6.671034601564275, -1.5957546159433766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.87336154396881,
          "lat": 36.806350534441066
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21221"],
        "coty_name": ["Trigg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trigg County"],
        "coty_fp_code": "221",
        "coty_gnis_code": "00516957"
      },
      "bbox": [
        6.671034601564275, -1.8107298053150933, 7.062658740978158,
        -1.4316646759572074
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.6712505209802666, -8.521317336709837],
            [3.6762535463461634, -8.5233288413227],
            [3.6807004538366974, -8.516433828426594],
            [3.6896638170439653, -8.50675300725037],
            [3.691879237908515, -8.501477962842621],
            [3.695926229719183, -8.500263663943718],
            [3.6994076640047497, -8.497198841183708],
            [3.698373766941067, -8.49235444202676],
            [3.7028359243739644, -8.482408354304644],
            [3.7002086415005087, -8.478307919528374],
            [3.7017242920769937, -8.473522135818923],
            [3.6985456738165285, -8.464990870578152],
            [3.7010746141722537, -8.460845315551039],
            [3.7004690465357895, -8.457142337911677],
            [3.7121139695390224, -8.448114697629167],
            [3.719249174432344, -8.446492158471651],
            [3.725203512790041, -8.446642614761119],
            [3.7287586059722515, -8.444955879060503],
            [3.7326258068386515, -8.440692682503165],
            [3.731737466283317, -8.425324419614505],
            [3.761166381913, -8.42496689650257],
            [3.759832049965114, -8.396120693961588],
            [3.77447691930216, -8.395734557892702],
            [3.773698805213614, -8.381255441206076],
            [3.7886756462285174, -8.380758187025936],
            [3.7880473342249865, -8.36662916564786],
            [3.827206439703752, -8.334234615903233],
            [3.8312338500367886, -8.334531007441283],
            [3.8319879422845378, -8.330208783343926],
            [3.83525681702261, -8.324346461499413],
            [3.8336637033511085, -8.321350865439562],
            [3.8355099822906893, -8.318107857600795],
            [3.83413021792279, -8.313090490623914],
            [3.8354522089523417, -8.311153535421912],
            [3.8361917470362186, -8.30339158732978],
            [3.8498582605784515, -8.296590030564056],
            [3.8589131632643574, -8.284960714137487],
            [3.8637130908474075, -8.283695689064855],
            [3.8685813031050227, -8.284609552840147],
            [3.872691545994342, -8.289070938518984],
            [3.8719670117818055, -8.29409273634032],
            [3.874894753226794, -8.294861968065076],
            [3.8774343341500708, -8.299567333909158],
            [3.886249776935269, -8.300860733377256],
            [3.887751370175243, -8.295418791500426],
            [3.8905608483897667, -8.295201142815046],
            [3.8938651003278766, -8.290306304080245],
            [3.897615764767771, -8.290924495084093],
            [3.9068529492156547, -8.296609672606255],
            [3.907488296297291, -8.293308840811799],
            [3.913173154249673, -8.290601065594148],
            [3.9172636326043526, -8.292107133968848],
            [3.9261672451601757, -8.29471132628422],
            [3.926312115236675, -8.297331699762028],
            [3.9477012522966524, -8.299373821899865],
            [3.950800040079961, -8.31077056147652],
            [3.945210702064477, -8.31432593046661],
            [3.9480861423225857, -8.320312440110238],
            [3.9470676509526097, -8.325540174081569],
            [3.940277054838986, -8.330771548140468],
            [3.9385029725151885, -8.335028684167348],
            [3.94266693302416, -8.34614994602798],
            [3.9485947856684116, -8.351446683023706],
            [3.955408122687216, -8.381548935056667],
            [3.932860745678892, -8.398147878562456],
            [3.9396423548984694, -8.39985980661606],
            [3.940624681564375, -8.40659913224974],
            [3.9393215945550852, -8.410330167727613],
            [3.9442287020554816, -8.417875140704156],
            [3.948507695935082, -8.421154126936147],
            [3.9550584776724014, -8.419078282892684],
            [3.962400093503477, -8.421148424277147],
            [3.9615752451463515, -8.426041427616065],
            [3.962163566735115, -8.431668915071665],
            [3.9544744414270347, -8.433579960485671],
            [3.9504383859960672, -8.446144756310055],
            [3.9408726642887624, -8.446646006050067],
            [3.9341334099568344, -8.44778829127123],
            [3.9325888476142166, -8.449959002258359],
            [3.9317065106135685, -8.46314914420129],
            [3.933203244801227, -8.467018606395214],
            [3.9326841148280414, -8.476023669129985],
            [3.9377398069235077, -8.480920558797065],
            [3.948269558223862, -8.47959715459501],
            [3.9552659466372675, -8.475839698031645],
            [3.9568485731209884, -8.47092392042491],
            [3.9670646734744186, -8.474289842701927],
            [3.972935514359808, -8.474076139921117],
            [3.98187597639077, -8.468844899981054],
            [3.987470365676498, -8.473647732119632],
            [3.9869919552600166, -8.475680689920424],
            [3.9957113821820998, -8.48847440839639],
            [3.9924538514489383, -8.496065182134254],
            [3.9957033956417347, -8.501028170694237],
            [3.998059025791234, -8.500920837764012],
            [3.9748967843067047, -8.536497770286447],
            [3.962198019052518, -8.583550091958415],
            [3.9520733629067912, -8.61944182118445],
            [3.9492383235120982, -8.618379889254566],
            [3.922182012778097, -8.60807176289556],
            [3.9000519370838127, -8.600339957687869],
            [3.87047171176969, -8.588754578269379],
            [3.862845936357016, -8.586542492752717],
            [3.8584769935631087, -8.580225123165695],
            [3.8558709841625176, -8.574063230121373],
            [3.8545390329301017, -8.565784891916039],
            [3.8520789179737016, -8.562975923624718],
            [3.8522911467588656, -8.559878392186924],
            [3.8482750943955155, -8.554341127970106],
            [3.8435112540630203, -8.552696016136139],
            [3.8396946982346316, -8.543743836580326],
            [3.8430050726305343, -8.536539746789387],
            [3.8402568356826365, -8.533611987104083],
            [3.8371827656442448, -8.535607266276482],
            [3.829112187400736, -8.538156119951505],
            [3.820529251264218, -8.542687162349663],
            [3.8144615584092296, -8.541026688028811],
            [3.8076203724688136, -8.547188510938607],
            [3.7419769725494456, -8.523213718591816],
            [3.7363857394846067, -8.522950895403879],
            [3.7320075702859654, -8.526259388246297],
            [3.726230316227768, -8.526897169942378],
            [3.7213924904247624, -8.529815772188192],
            [3.7190670752151758, -8.527545351556306],
            [3.714712284123828, -8.527513000103207],
            [3.7096530679759425, -8.524715125740554],
            [3.6973601216613234, -8.528581855741878],
            [3.6938017194655735, -8.528514378543656],
            [3.6903039925051986, -8.523605963931328],
            [3.6836754536585046, -8.524850712632151],
            [3.681505345851323, -8.527639571215465],
            [3.675782702682666, -8.526999181889034],
            [3.6712505209802666, -8.521317336709837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.06389270008391, "lat": 30.20686874943418 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22055"],
        "coty_name": ["Lafayette"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Lafayette Parish"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00558059"
      },
      "bbox": [
        3.6712505209802666, -8.61944182118445, 3.998059025791234,
        -8.283695689064855
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.638436461906428, -8.637118916527836],
              [6.641405654057379, -8.63744785592027],
              [6.644690164811461, -8.647764589121826],
              [6.6419334185233865, -8.647308837391144],
              [6.638436461906428, -8.637118916527836]
            ]
          ],
          [
            [
              [6.621959981848986, -8.45205892826995],
              [6.635912406293357, -8.465716173192833],
              [6.6499221748768464, -8.486145248937312],
              [6.65744427906143, -8.499452802278814],
              [6.667838588001647, -8.526832702968532],
              [6.67673755164388, -8.562113319241075],
              [6.67917369241706, -8.606733921398925],
              [6.675095537685171, -8.648732586965941],
              [6.671497793611738, -8.671850471349675],
              [6.662023973544234, -8.697367811664975],
              [6.6457316545435905, -8.735028178329948],
              [6.639674193026439, -8.737944556901171],
              [6.646760086536266, -8.716391109509368],
              [6.646948084374557, -8.703933988204431],
              [6.654901982286374, -8.685930248289576],
              [6.660102923169607, -8.679606469938507],
              [6.662450713404374, -8.670642735644094],
              [6.666049707036321, -8.641342680863286],
              [6.665305141188266, -8.637670431165096],
              [6.659370374755903, -8.63331871342064],
              [6.668672285817397, -8.617710974158278],
              [6.668063643580746, -8.576194866427421],
              [6.65835768076427, -8.552937882830673],
              [6.655889717778141, -8.535801712447508],
              [6.658263936009728, -8.530294391660496],
              [6.657778220520414, -8.523934242669707],
              [6.65334384132958, -8.514669872438585],
              [6.651525775010391, -8.503079968489605],
              [6.643716257226372, -8.486071020797118],
              [6.63486841743509, -8.47233601789564],
              [6.623018022380827, -8.457356855685997],
              [6.612196424948476, -8.448821684366086],
              [6.621959981848986, -8.45205892826995]
            ]
          ],
          [
            [
              [6.299885316551189, -8.695336815749949],
              [6.310802154655366, -8.693454114390889],
              [6.314411424516613, -8.695227275298954],
              [6.311713487442335, -8.698834486578253],
              [6.299472557546842, -8.698132616729259],
              [6.299885316551189, -8.695336815749949]
            ]
          ],
          [
            [
              [6.260260639436571, -8.526700248919289],
              [6.265644435194233, -8.52703837023221],
              [6.2641111570986014, -8.531538311764526],
              [6.261165442664764, -8.532152169140844],
              [6.260260639436571, -8.526700248919289]
            ]
          ],
          [
            [
              [6.234848109691613, -8.576587252413924],
              [6.23583352940646, -8.573044901487554],
              [6.241584922519525, -8.575607527844596],
              [6.2419265556945716, -8.578955340391108],
              [6.238426975547558, -8.581957249278954],
              [6.235803647567854, -8.581323136458648],
              [6.234848109691613, -8.576587252413924]
            ]
          ],
          [
            [
              [6.2204507358408465, -8.540810461137148],
              [6.221320790379667, -8.535643175492703],
              [6.2237677081132246, -8.535268848446924],
              [6.224208019219004, -8.541469569192992],
              [6.2204507358408465, -8.540810461137148]
            ]
          ],
          [
            [
              [6.2145264938824765, -8.471451187493248],
              [6.219661655837763, -8.469335543674347],
              [6.225971100361496, -8.468614094738518],
              [6.229861963536804, -8.465238118522704],
              [6.234292414796627, -8.464151355127095],
              [6.245991980576158, -8.437096034847725],
              [6.262202706129929, -8.425847619962575],
              [6.278488021078111, -8.415624677887227],
              [6.293428801679157, -8.40395521384177],
              [6.304055981236104, -8.396597952250124],
              [6.32176440779675, -8.382311091604558],
              [6.329033959219937, -8.3756540331459],
              [6.33378894168079, -8.365983069720807],
              [6.3379736734267444, -8.360913201649481],
              [6.342414241518411, -8.365324956309893],
              [6.338515949573426, -8.373413020657509],
              [6.330823164288642, -8.378757205626915],
              [6.320870316102285, -8.39181063813688],
              [6.316610085776423, -8.40131542052212],
              [6.308920940513451, -8.404712900304594],
              [6.297017406006317, -8.424488777226914],
              [6.302725977772385, -8.429756392160037],
              [6.309226553750875, -8.425372509047389],
              [6.311196483580412, -8.428986932926579],
              [6.3119171414997615, -8.437965045758224],
              [6.315612186794396, -8.443579225442818],
              [6.318303277688307, -8.45199848870913],
              [6.3300407624543915, -8.452023012094001],
              [6.343345148336299, -8.454315638218445],
              [6.34901740403663, -8.457279739143681],
              [6.357783813463322, -8.45780727796987],
              [6.356980095862895, -8.459877008992006],
              [6.361185120407027, -8.476841176279251],
              [6.352839634194743, -8.487949948547968],
              [6.349398764692847, -8.489182118870856],
              [6.3363061344187335, -8.487284496639775],
              [6.3281388436923365, -8.495077703298886],
              [6.330726053282499, -8.512000868640742],
              [6.33987979208534, -8.519978282332527],
              [6.328285564151187, -8.528646078240927],
              [6.315862769523102, -8.522665227281351],
              [6.319822381038357, -8.51582487214521],
              [6.31634938903404, -8.501974052819802],
              [6.306180949929728, -8.490537158417123],
              [6.3035787297702575, -8.479180251076876],
              [6.304047821067802, -8.471385805677121],
              [6.2989530156026445, -8.466434325949685],
              [6.291004112491646, -8.464748033794695],
              [6.286258963936919, -8.476110284898205],
              [6.278892425164871, -8.482550102400886],
              [6.273604099926313, -8.489252338484388],
              [6.274284933098327, -8.503109498208138],
              [6.26889923833056, -8.498364912723027],
              [6.268903162668878, -8.489786200670329],
              [6.26290124077738, -8.48652949540897],
              [6.2449188936300315, -8.48860366388512],
              [6.241510805422165, -8.484143035607165],
              [6.231029686148423, -8.481605161152501],
              [6.227595019858732, -8.491239548303843],
              [6.223950075842098, -8.495022671888325],
              [6.217115735799351, -8.485701083645642],
              [6.21673006639109, -8.477493679903706],
              [6.2145264938824765, -8.471451187493248]
            ]
          ],
          [
            [
              [6.215869949546386, -8.554714524149793],
              [6.218830058504728, -8.54848179458668],
              [6.221850748160203, -8.553277563574985],
              [6.219480865905446, -8.55620066008115],
              [6.215869949546386, -8.554714524149793]
            ]
          ],
          [
            [
              [6.207821030857553, -8.602676394351652],
              [6.209823753917248, -8.595998870928721],
              [6.214764908287831, -8.601684777098887],
              [6.215112657577857, -8.605134973768386],
              [6.212144561576783, -8.60983654816987],
              [6.208654719473923, -8.61007806754987],
              [6.206509970349002, -8.607467522880526],
              [6.207821030857553, -8.602676394351652]
            ]
          ],
          [
            [
              [6.199104272348789, -8.57712424055211],
              [6.203210402014128, -8.575409622833217],
              [6.204150949133876, -8.568295774949428],
              [6.200191845000038, -8.558966405167194],
              [6.199040334125514, -8.554347476387287],
              [6.20086220613332, -8.550952816727666],
              [6.212232768271981, -8.55721419071582],
              [6.20345537341825, -8.557004195412555],
              [6.202456513149789, -8.55891200949323],
              [6.206572150904843, -8.566085204238764],
              [6.211676759780592, -8.568285849714306],
              [6.2115206101142535, -8.570441901888215],
              [6.205200010785882, -8.57874571763971],
              [6.202500984810839, -8.579954339171092],
              [6.199104272348789, -8.57712424055211]
            ]
          ],
          [
            [
              [6.184171239537956, -8.523301570245062],
              [6.1852199183803735, -8.517714120180845],
              [6.188752412777365, -8.521045182619563],
              [6.198528086474243, -8.522309986981611],
              [6.196661702353362, -8.52652494999143],
              [6.189852814090662, -8.524951917815669],
              [6.187071996216805, -8.527901849847213],
              [6.184171239537956, -8.523301570245062]
            ]
          ],
          [
            [
              [6.124113193777322, -8.402213556392951],
              [6.122467402113266, -8.393203421831503],
              [6.133042626006307, -8.39242014857787],
              [6.135209667889145, -8.38823398262448],
              [6.143534959987748, -8.392442584665972],
              [6.1389416484559485, -8.403339141982489],
              [6.1348141405800956, -8.408057591910145],
              [6.126292772262239, -8.409665605348698],
              [6.119587713206457, -8.407392358898566],
              [6.124113193777322, -8.402213556392951]
            ]
          ],
          [
            [
              [5.771705619325551, -8.557993312374952],
              [5.777517031000838, -8.57640346500964],
              [5.786413333757976, -8.601989941426783],
              [5.789269540539243, -8.607793253293941],
              [5.7957193218916485, -8.615009990636382],
              [5.811231253976026, -8.623486654236526],
              [5.8211973863637265, -8.624229811079474],
              [5.8295974220034354, -8.623708361957966],
              [5.836442584518448, -8.621993430968152],
              [5.860820700234893, -8.61267786114523],
              [5.871535460532917, -8.606986935324915],
              [5.872552385344458, -8.607262882132222],
              [5.887258981847299, -8.594355406636645],
              [5.895865504097277, -8.59914896950173],
              [5.900579915041509, -8.603883107199028],
              [5.888575441465399, -8.611069661572856],
              [5.882687958888026, -8.615749618189792],
              [5.877169565974743, -8.616475504538606],
              [5.873663874182166, -8.621794759453005],
              [5.875041175465528, -8.635144050464126],
              [5.877101017126397, -8.644237459482403],
              [5.882779797314839, -8.64965849606411],
              [5.892947429604028, -8.65517259865137],
              [5.899400207569893, -8.660495136571129],
              [5.90818760939847, -8.670584326461867],
              [5.913598070556321, -8.675130950116374],
              [5.928444767653496, -8.68082323237876],
              [5.942725942801298, -8.680529617979204],
              [5.948812207353741, -8.68426487623327],
              [5.962177656921802, -8.684028383723916],
              [5.97525127529521, -8.682124468527583],
              [5.9931041953679145, -8.674434093692764],
              [6.007345121440777, -8.663764530642617],
              [6.011476197357756, -8.654161107095916],
              [6.008332577023301, -8.626310861349765],
              [6.016544476079868, -8.613690181942724],
              [6.016706098373144, -8.608276419127696],
              [6.015677464661567, -8.597437699007415],
              [6.020487386722419, -8.586003410915245],
              [6.024285827660885, -8.581387990756562],
              [6.022383341069604, -8.571926954606475],
              [6.023130752556998, -8.567352840341377],
              [6.019320376283968, -8.559623264656995],
              [6.013979454836166, -8.553316279510488],
              [6.0171138741414225, -8.547445018220191],
              [6.0309799734136, -8.544108472024938],
              [6.037799443247679, -8.536583602314403],
              [6.05198065023271, -8.525898690259465],
              [6.074384871597862, -8.511469935485161],
              [6.0787586306360355, -8.50570846333568],
              [6.087208889317936, -8.501698785138347],
              [6.088758032969367, -8.497305121200288],
              [6.085648194337724, -8.494152469367696],
              [6.081121063361447, -8.479184057686927],
              [6.08404804104439, -8.475109519000082],
              [6.084083510083984, -8.468972718707105],
              [6.090493951983777, -8.460449464179275],
              [6.094224712659693, -8.464497261875655],
              [6.109396192100256, -8.471810169969975],
              [6.1160684350584855, -8.478517132950463],
              [6.119571875549826, -8.47631966954113],
              [6.126047932404819, -8.475770227928992],
              [6.138363119833892, -8.48405599996032],
              [6.128835593257731, -8.49008358246562],
              [6.130067708078958, -8.495920935106184],
              [6.1342617243352855, -8.499922881162512],
              [6.140159203448931, -8.501766345266402],
              [6.146315914162518, -8.498485074865393],
              [6.152351623372288, -8.490940552784878],
              [6.163681702691622, -8.485015557179521],
              [6.173344244123462, -8.481348760973859],
              [6.181937095771664, -8.480673940458427],
              [6.188863104366199, -8.482486810527442],
              [6.184730624174014, -8.485222984842721],
              [6.182876592298154, -8.491069379747934],
              [6.1900425541607955, -8.495482022239091],
              [6.18842790588521, -8.499672021883889],
              [6.182105217604296, -8.497657762409824],
              [6.175895464773098, -8.50304962294442],
              [6.171920265538538, -8.502240565479108],
              [6.162250188056883, -8.505356357914243],
              [6.160343380570818, -8.510235535317738],
              [6.164958111565014, -8.514565166106609],
              [6.164012610701675, -8.518715153679365],
              [6.166259294670574, -8.524280133478142],
              [6.170823541302489, -8.527643093524041],
              [6.169511092884505, -8.532431440895396],
              [6.164536761750844, -8.529096662915599],
              [6.160091573433276, -8.524499573572816],
              [6.159363512758995, -8.514132841119729],
              [6.155418623502642, -8.511251615975967],
              [6.152057530355256, -8.51279631162434],
              [6.149331242211494, -8.518117291914796],
              [6.147272689526809, -8.518026178670354],
              [6.14474356380163, -8.508395898126095],
              [6.140910438098635, -8.50661590667069],
              [6.135869451796512, -8.508186658075486],
              [6.13379898422929, -8.510983153848365],
              [6.12878596796959, -8.51295940821464],
              [6.125173396541697, -8.517291049569751],
              [6.126948916594417, -8.522071393174407],
              [6.137699487345553, -8.522562164079797],
              [6.1375304974504905, -8.526046167837622],
              [6.125888747044406, -8.524595029719922],
              [6.121660133942847, -8.528968295199615],
              [6.119031135083124, -8.538544182200019],
              [6.123021088875571, -8.54256087597379],
              [6.132010494717855, -8.538474939610417],
              [6.1405336998486595, -8.544008801321858],
              [6.138325342113358, -8.55213796192569],
              [6.1411943738446855, -8.560726153693713],
              [6.1483700581713885, -8.563094491275649],
              [6.150196494926498, -8.56562554118067],
              [6.150977129246612, -8.570884334580203],
              [6.1571283109817045, -8.573323062532921],
              [6.162383300073112, -8.568875498326197],
              [6.175771281736654, -8.56910702890008],
              [6.187777185071859, -8.572235775517113],
              [6.188118547007063, -8.575463698124805],
              [6.183506007384283, -8.576003964689955],
              [6.175917823126682, -8.573666078439507],
              [6.173741406816964, -8.577901683942073],
              [6.179493077824468, -8.583432018300718],
              [6.181817056533481, -8.58715423575417],
              [6.189640872135557, -8.589884020252576],
              [6.192830607722391, -8.61147193184951],
              [6.195996170262635, -8.624390570961806],
              [6.199436316117007, -8.629262669597335],
              [6.202121690577632, -8.638070044772565],
              [6.211040198375981, -8.638679502674457],
              [6.217010381336923, -8.626820163415532],
              [6.21473412314476, -8.617987362442452],
              [6.223069799350618, -8.617407709722928],
              [6.224966952299936, -8.620873173850585],
              [6.231935709881531, -8.621370555214249],
              [6.237501709510492, -8.609919523348337],
              [6.245383834521351, -8.606211286613082],
              [6.252779273811124, -8.592013478003244],
              [6.259928046624031, -8.574133999791316],
              [6.265807938907896, -8.566367356946769],
              [6.271128487997897, -8.552717721827122],
              [6.2775292073466895, -8.54805676673862],
              [6.2795945070970305, -8.542354510695874],
              [6.277141107803417, -8.53575409609814],
              [6.278522614900748, -8.531855131086253],
              [6.284614291480862, -8.534157125205718],
              [6.292690035734138, -8.534080258272049],
              [6.300250930025555, -8.526847224067804],
              [6.30173894346303, -8.531482678690866],
              [6.298268538313305, -8.542841447392396],
              [6.299964303812591, -8.548434539293956],
              [6.303073301678793, -8.550021944974738],
              [6.3193925889363305, -8.5521416871612],
              [6.321650011887368, -8.55531281818782],
              [6.314745298781236, -8.575925588243813],
              [6.313073704882988, -8.58577354319083],
              [6.318314807212325, -8.59196367070438],
              [6.309444505034229, -8.591915064172872],
              [6.298563692528576, -8.595133247425862],
              [6.2919327160493275, -8.594768576733758],
              [6.277628898682514, -8.597980075928087],
              [6.272412811033216, -8.60291498004478],
              [6.264500142335188, -8.607199505894032],
              [6.262541442216907, -8.611266982763095],
              [6.262495148416807, -8.616890279803183],
              [6.257012874737504, -8.616518947542373],
              [6.252282441598297, -8.619628509302478],
              [6.248358909924961, -8.624806426791656],
              [6.244914553140348, -8.63516046048916],
              [6.241575366417133, -8.638524350966602],
              [6.232898982164034, -8.64190671572199],
              [6.227027503558616, -8.645258206465732],
              [6.229885008185807, -8.650619434097091],
              [6.233671236558761, -8.655098678353653],
              [6.240316719676186, -8.653328686821752],
              [6.252496016894801, -8.645510042599092],
              [6.266499077579629, -8.646168850671572],
              [6.2718121412611465, -8.645747997341822],
              [6.297315325138632, -8.639282094864173],
              [6.3139780280026905, -8.63722645679501],
              [6.31523101171379, -8.643550355464377],
              [6.312365274278379, -8.646403641874874],
              [6.304207518593052, -8.648372173118567],
              [6.300616074173193, -8.656097610570301],
              [6.2952141892615785, -8.656526480049209],
              [6.290949254048746, -8.663757824612672],
              [6.290628003909285, -8.671619768459042],
              [6.2860851416636505, -8.675077174450848],
              [6.277796556887002, -8.673939597061674],
              [6.270489403035101, -8.661856376076527],
              [6.265078523990974, -8.66010777694157],
              [6.25931467030113, -8.660347302507867],
              [6.259837243589666, -8.667670201055106],
              [6.252330245381969, -8.673590714194855],
              [6.263501902955207, -8.681971835584068],
              [6.265821217443517, -8.689006940221727],
              [6.258743505092689, -8.68475624429358],
              [6.24965098196817, -8.68931575055346],
              [6.251900526931537, -8.695375030752567],
              [6.256709065874558, -8.699449065964096],
              [6.256773539091751, -8.702218205677232],
              [6.2507427251000465, -8.702325779478231],
              [6.246458543002514, -8.700170524433574],
              [6.243718384636081, -8.703468818977834],
              [6.234747387970816, -8.691169777522976],
              [6.239907072265995, -8.68704897999471],
              [6.240673688307923, -8.683887696237932],
              [6.230358696422405, -8.678225134294047],
              [6.211212986356737, -8.683429732546731],
              [6.194036876936209, -8.690223380436155],
              [6.19254932605174, -8.694905294371786],
              [6.1989061589033465, -8.707716850238569],
              [6.206875184361544, -8.703567400093792],
              [6.213383912987155, -8.702136906218364],
              [6.215425078510545, -8.705829272430819],
              [6.221914185164808, -8.708252823911408],
              [6.225019402868222, -8.707196882219229],
              [6.229139602323868, -8.712276784096685],
              [6.2221420732304615, -8.713798769760627],
              [6.217694773962556, -8.71868750802709],
              [6.219855867702752, -8.728189332305606],
              [6.2307090803700005, -8.729727950420875],
              [6.235379171985035, -8.734966249231315],
              [6.234366421236377, -8.737000584596203],
              [6.238661185582186, -8.741610235377033],
              [6.245251417169661, -8.74360734014048],
              [6.249095172344663, -8.741866884975819],
              [6.2543948538614735, -8.741988967431368],
              [6.2627429131372025, -8.736172598939216],
              [6.266292082434123, -8.728549364966936],
              [6.270114869104955, -8.72592179043993],
              [6.275690731595231, -8.725151632512562],
              [6.278407587784207, -8.73850776787543],
              [6.277001418173328, -8.74869405022665],
              [6.279011044507392, -8.756837836573107],
              [6.284076426853644, -8.760034859459253],
              [6.276159919786791, -8.763586006739452],
              [6.267805685683234, -8.76577796958789],
              [6.265776787301369, -8.762467572487743],
              [6.259011636872029, -8.762232090809592],
              [6.250230731729305, -8.752444643365525],
              [6.242174777643548, -8.746600017587634],
              [6.232449984967807, -8.744801237215443],
              [6.223730871909448, -8.744633974398576],
              [6.218007064566676, -8.74676001122483],
              [6.212467711634793, -8.75101821060284],
              [6.206741287611455, -8.745399916689818],
              [6.204199649974956, -8.740559796459147],
              [6.197363281529981, -8.73880844993649],
              [6.187921371999227, -8.740174409160325],
              [6.183409018866039, -8.74486669123044],
              [6.182820385129815, -8.750501433076652],
              [6.183409462065996, -8.760814373920615],
              [6.175090211795768, -8.771303361061072],
              [6.1708044158874475, -8.778727195739267],
              [6.160126562281937, -8.791037357419214],
              [6.16530771105692, -8.800120184325069],
              [6.162404084904564, -8.804484469884164],
              [6.162519154693094, -8.81878126720719],
              [6.184415113834791, -8.835359843035334],
              [6.193275756851177, -8.833405275680532],
              [6.201371200650868, -8.844708639944077],
              [6.201555575571979, -8.848421710093017],
              [6.187427321915874, -8.847592862304726],
              [6.18018815549707, -8.843506926691507],
              [6.168785287358452, -8.833185242460639],
              [6.162732401805762, -8.842410675118936],
              [6.167971492890784, -8.852080780242506],
              [6.155952220015232, -8.849585251992188],
              [6.15422181494461, -8.860342866319522],
              [6.158327778440096, -8.867659741094572],
              [6.163321715908088, -8.874453805018346],
              [6.153369899849386, -8.879577919055983],
              [6.144746096031711, -8.881123982550179],
              [6.136120150657146, -8.880892989443652],
              [6.132804428950991, -8.871422509404757],
              [6.129778480903343, -8.860102825695817],
              [6.136825483397975, -8.85301679569509],
              [6.133273886297239, -8.845435842531733],
              [6.1311063252636036, -8.834388332775045],
              [6.122933315686014, -8.827609111361317],
              [6.114470929233664, -8.814765952482782],
              [6.108600913168465, -8.811236665835128],
              [6.1038986416115995, -8.817476374334866],
              [6.099839784479596, -8.812932970705381],
              [6.090723537685375, -8.808682583913738],
              [6.079605646729135, -8.810578590078343],
              [6.081877605662689, -8.817134264541123],
              [6.086540289710848, -8.834330190379715],
              [6.094521230032648, -8.838225354726667],
              [6.096830755652357, -8.843651706539198],
              [6.086557439814953, -8.844148386924005],
              [6.084026757134399, -8.848247701471868],
              [6.082586428050243, -8.853745638518319],
              [6.083092697562397, -8.861076824592757],
              [6.090499498069886, -8.862868727508756],
              [6.092515034438974, -8.866911546059224],
              [6.076801572322779, -8.86346435868165],
              [6.0779330592655825, -8.870262702515474],
              [6.086161795812054, -8.87674692644155],
              [6.096008375895216, -8.878517359892989],
              [6.099701482696043, -8.888280233542392],
              [6.107164460921129, -8.899922178910874],
              [6.10256684815202, -8.899113983515734],
              [6.100594501095927, -8.895944583724807],
              [6.096764983057467, -8.893376213664126],
              [6.0903295482528375, -8.886592144990386],
              [6.081073750042021, -8.884768819197868],
              [6.074198878791893, -8.885619593149581],
              [6.066215070476013, -8.884502909696051],
              [6.061640932845035, -8.880850796293222],
              [6.055317980029995, -8.877988168182455],
              [6.050509818248474, -8.878985128738233],
              [6.043895462928559, -8.8739330124327],
              [6.040131889996123, -8.872676079370747],
              [6.036088302734004, -8.873557696540281],
              [6.028472152094828, -8.871835489842352],
              [6.025416929013112, -8.869320023833478],
              [6.018381423840693, -8.866018649111899],
              [6.011644486445276, -8.866283045016113],
              [5.998294563450972, -8.8642430838158],
              [5.993229284596771, -8.861819240909346],
              [5.9831356971941725, -8.850971369442272],
              [5.974438140171249, -8.843069198577506],
              [5.9635419067943065, -8.835978860994674],
              [5.957852946555444, -8.833822728360516],
              [5.953454548106617, -8.834115629517465],
              [5.942639810636321, -8.830137107184456],
              [5.939327435158721, -8.825777334185084],
              [5.934221601704223, -8.808897599714744],
              [5.928557899729027, -8.803593494988856],
              [5.921860172429056, -8.795077629174921],
              [5.909146574503702, -8.79136152168393],
              [5.8965133289500296, -8.790987715933708],
              [5.886816113957738, -8.79309441766672],
              [5.875606288848549, -8.792442391773498],
              [5.867413041537563, -8.796120714431154],
              [5.857922837855451, -8.796013658821392],
              [5.847116884043766, -8.791987296766928],
              [5.846010953328131, -8.78595856253571],
              [5.8502467694401235, -8.7794375141372],
              [5.841673248478424, -8.770432581620838],
              [5.834431371356675, -8.761190896695307],
              [5.828184119634572, -8.755579953317007],
              [5.819801478163076, -8.753090130324622],
              [5.809943619673766, -8.754321664010739],
              [5.7852438165796025, -8.76403532838777],
              [5.780440814750249, -8.764347241280175],
              [5.776516012473417, -8.762205542627342],
              [5.771987249170745, -8.755802030786644],
              [5.771579740486149, -8.752555535460749],
              [5.767040118019731, -8.750433694506096],
              [5.767532615122997, -8.74288087333924],
              [5.761659265934825, -8.737442129185508],
              [5.751404067929123, -8.726355297263183],
              [5.744210670482309, -8.70967109830241],
              [5.7364031266158895, -8.692982390469437],
              [5.740512370247913, -8.688700767902162],
              [5.742495575225704, -8.683586272989084],
              [5.741566786366346, -8.67324734175986],
              [5.736580612205372, -8.663138662835431],
              [5.724425220327953, -8.646286897656783],
              [5.717334535427679, -8.640729685227711],
              [5.708616965283045, -8.638553690380768],
              [5.689614464619679, -8.640435433961228],
              [5.68172576325386, -8.640082533341252],
              [5.669182714447915, -8.635930484856157],
              [5.661447565802742, -8.631960699992312],
              [5.643801697385929, -8.621357236198355],
              [5.653650730014088, -8.593249531259382],
              [5.656436028152961, -8.594119681384774],
              [5.658939447339184, -8.586047648569416],
              [5.660246064220389, -8.577179306667484],
              [5.665945614030698, -8.579280037903539],
              [5.672286083977142, -8.572112947999138],
              [5.681633518347582, -8.575477387218351],
              [5.6857862912102535, -8.578927733674853],
              [5.689177689869935, -8.577752184164808],
              [5.692589350470516, -8.58340508923717],
              [5.699136507487257, -8.581766470473996],
              [5.703848234403563, -8.583703766567123],
              [5.7056420189090975, -8.579284875885595],
              [5.71099305700286, -8.575674554303692],
              [5.713620713177815, -8.575551031283952],
              [5.721173091541618, -8.56898066155951],
              [5.72500598674159, -8.563568762685627],
              [5.73323015369302, -8.55971191574335],
              [5.739370749939856, -8.561028900794923],
              [5.741744774269813, -8.559304650905819],
              [5.750179703684985, -8.564592541411272],
              [5.750559110505941, -8.569710630340888],
              [5.753954043336507, -8.574522360075958],
              [5.75871887002597, -8.573439838442724],
              [5.762133801180535, -8.567792010675836],
              [5.764993110710209, -8.567845484582802],
              [5.766562200424203, -8.571213080890157],
              [5.769869410679219, -8.572001565075613],
              [5.77308461253119, -8.568189202898438],
              [5.767281315345862, -8.562875335885959],
              [5.771705619325551, -8.557993312374952]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.55522481402251, "lat": 29.86913683601707 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22087"],
        "coty_name": ["St. Bernard"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Bernard Parish"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01629542"
      },
      "bbox": [
        5.643801697385929, -8.899922178910874, 6.67917369241706,
        -8.360913201649481
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.646246987022874, 8.288121890612185],
            [18.70643087171314, 8.302732643137551],
            [18.704989368954752, 8.306506598498135],
            [18.70219861852528, 8.307268175087312],
            [18.70552189978307, 8.319595655234854],
            [18.704913024404725, 8.32584995813696],
            [18.69923453845842, 8.33052259638444],
            [18.674049422892583, 8.339179364254552],
            [18.67326693830491, 8.344633638060541],
            [18.676090609707863, 8.349721521427748],
            [18.678019106105406, 8.356862471359042],
            [18.677079970393326, 8.360946502514729],
            [18.679431797126497, 8.3648451103519],
            [18.683182147076177, 8.384656382410023],
            [18.682255175960904, 8.390956318292357],
            [18.683134367420827, 8.397613502048623],
            [18.67990953791772, 8.401973592551473],
            [18.74304011312459, 8.405046173907746],
            [18.752721160350884, 8.438057669336422],
            [18.748986579030888, 8.443948571813017],
            [18.78522392745785, 8.461677811508741],
            [18.798848293602216, 8.468821337212397],
            [18.820140034428057, 8.460779664682848],
            [18.826337494303147, 8.457617433650247],
            [18.82579416494293, 8.454943527778445],
            [18.8304203299454, 8.451790280204909],
            [18.831887340858597, 8.443067919116462],
            [18.834100790201163, 8.440254791601253],
            [18.833592687268883, 8.437120612599712],
            [18.852221489465556, 8.438228816473908],
            [18.851393835040664, 8.455290295295836],
            [18.85507754158186, 8.470873193450444],
            [18.878493509135144, 8.471634952525358],
            [18.881183191452518, 8.46789542563827],
            [18.936755086430956, 8.471297170105704],
            [18.980117420646003, 8.474089558597427],
            [18.984124156985878, 8.479046205625316],
            [18.987607208293216, 8.48150700728978],
            [18.98808945238224, 8.488668689134517],
            [18.982079420707578, 8.499814601440685],
            [18.982306277842167, 8.506437643358137],
            [18.985586913626612, 8.521197388681038],
            [18.98465876351357, 8.526609694517159],
            [18.97866970894724, 8.530340185900622],
            [18.972321646416813, 8.535993825451506],
            [18.96615172165804, 8.539425354733911],
            [18.959965881010422, 8.544456211700126],
            [18.95074181069092, 8.547258402031895],
            [18.94466666228208, 8.55506300527735],
            [18.9383114368888, 8.560387797480264],
            [18.93418600292761, 8.57153753332421],
            [18.93150092389045, 8.575128234452933],
            [18.927619638239502, 8.58616966939916],
            [18.946573057779975, 8.59588493645388],
            [19.02424842588272, 8.633959312227041],
            [19.033701760540456, 8.634462954394978],
            [19.034381544136597, 8.624948623327647],
            [19.038454682332993, 8.625323705045416],
            [19.039769234396505, 8.610146922149355],
            [19.036177468421076, 8.608265536881303],
            [19.04159620758695, 8.59394542279714],
            [19.065063072187257, 8.596169398529726],
            [19.065032399479012, 8.5877436401253],
            [19.06382046602557, 8.584896867254805],
            [19.059728526129078, 8.584795062510702],
            [19.057674800354423, 8.576786249914733],
            [19.060005668463262, 8.568625564060415],
            [19.107900664078112, 8.575336739804252],
            [19.109232002548143, 8.55994126175031],
            [19.116425345877232, 8.485665938286495],
            [19.148575577038105, 8.48810689670846],
            [19.15283409183526, 8.443387096979773],
            [19.15349098331345, 8.439661088427924],
            [19.15670920635634, 8.400125351547965],
            [19.12096235718934, 8.39694683421939],
            [19.112677581439254, 8.269745241172522],
            [19.11955131757081, 8.207359689761741],
            [19.1129444314434, 8.196870746273508],
            [19.113985125017802, 8.192157128179437],
            [19.107119945639955, 8.183632131365341],
            [19.07019359617487, 8.182607071775504],
            [19.04318561576218, 8.182165250011291],
            [19.031439661727486, 8.181512769115447],
            [19.035238344680806, 8.1288494719816],
            [19.06900083299222, 8.033405405493586],
            [19.07009139640557, 8.030039385510985],
            [18.995625531283697, 8.026602304422054],
            [18.99377720843136, 8.031653696652445],
            [18.988141844580852, 8.038838420487185],
            [18.921244461591595, 8.035227898280182],
            [18.915089783778722, 8.027541827075746],
            [18.91364291671209, 8.022530726745652],
            [18.909302877045715, 8.016933669097304],
            [18.90674291091817, 7.998966430041431],
            [18.90615229518315, 7.984842376613091],
            [18.907865192954073, 7.980497154112294],
            [18.90687576421847, 7.972376937262144],
            [18.90817397023166, 7.9694313218924915],
            [18.82942147329757, 7.964904893939118],
            [18.82437659294799, 7.964447827518742],
            [18.824162586321403, 7.967047951580693],
            [18.812685114553375, 7.966509187902706],
            [18.811417184932743, 7.994302036445403],
            [18.81462093627532, 7.9949130578122665],
            [18.8141173499021, 8.00619598892636],
            [18.82254878687797, 8.006663398284422],
            [18.822262929561166, 8.020782353389775],
            [18.77332626227613, 8.018735963096939],
            [18.774811152155475, 8.026695787227721],
            [18.767300083572888, 8.026298551147178],
            [18.75894114133371, 8.0295973360552],
            [18.75282815510353, 8.05277646864213],
            [18.737267530038658, 8.11020979171828],
            [18.73476433592979, 8.118239560721472],
            [18.712294514857987, 8.133601580044989],
            [18.707626536462225, 8.146440379596983],
            [18.70490263832658, 8.149778245942537],
            [18.67866234116591, 8.17445643023255],
            [18.675272777864294, 8.176795187469436],
            [18.68352548652763, 8.180446262709905],
            [18.679799606550542, 8.188092942638127],
            [18.69394699683547, 8.194810669785847],
            [18.646246987022874, 8.288121890612185]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.76730046492965, "lat": 44.40908923592768 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23011"],
        "coty_name": ["Kennebec"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kennebec County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00581291"
      },
      "bbox": [
        18.646246987022874, 7.964447827518742, 19.15670920635634,
        8.634462954394978
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.482620520181717, 2.1424555925791493],
              [15.483475648198722, 2.1471615216378006],
              [15.482512398222193, 2.1515568936314806],
              [15.483679140308707, 2.159157386203845],
              [15.487823688139763, 2.1620032810297145],
              [15.490570473955271, 2.157772209208592],
              [15.485596823938987, 2.150766919198643],
              [15.487068699526862, 2.1485055271127655],
              [15.482620520181717, 2.1424555925791493]
            ]
          ],
          [
            [
              [15.41388313617986, 2.588461842281145],
              [15.418764253058281, 2.58949075683619],
              [15.424267932797807, 2.578101498136708],
              [15.429297911002449, 2.572749229549471],
              [15.441392008129261, 2.5582974752662304],
              [15.464391956557236, 2.545738123344174],
              [15.466937677168996, 2.5432871902235834],
              [15.480739121865586, 2.535410884715113],
              [15.487061128614272, 2.530036247156996],
              [15.50404975093144, 2.5024883023817206],
              [15.51417814661405, 2.498140567553618],
              [15.560113337042136, 2.4545132457982612],
              [15.562641146697665, 2.4526520644553176],
              [15.573201146537244, 2.4390574725899437],
              [15.568045029353186, 2.4361321358180805],
              [15.565056195294897, 2.4317306849560225],
              [15.559733052901707, 2.4292494537724427],
              [15.559706770927573, 2.4215770238086565],
              [15.556387750983573, 2.4127890491931434],
              [15.554281964900305, 2.399791272225511],
              [15.554887536833357, 2.3963430645722785],
              [15.552465871977402, 2.3855951246303184],
              [15.549577244085295, 2.3775764842757723],
              [15.546305988273843, 2.3746125380909455],
              [15.551687489521926, 2.3702694606328394],
              [15.556131742993001, 2.371212070886003],
              [15.558415390690083, 2.376704457382261],
              [15.565502752888442, 2.370548598892413],
              [15.570813659077205, 2.3689168340002844],
              [15.581688311859143, 2.3730250200746634],
              [15.585053038805203, 2.370784794145664],
              [15.590738902290632, 2.372048124128639],
              [15.594272469776495, 2.365196585001119],
              [15.600023032388474, 2.357282145601719],
              [15.60496426463619, 2.349136872239514],
              [15.601063187503993, 2.345084458982597],
              [15.591908048310069, 2.332766126377003],
              [15.584093438557032, 2.339778997519662],
              [15.576227826940556, 2.336121512577607],
              [15.5763715700407, 2.328380235383248],
              [15.574955683393064, 2.3255667531316795],
              [15.567140551707034, 2.318125747205624],
              [15.564685304826444, 2.311018111708041],
              [15.55873210184853, 2.303520681563095],
              [15.556013371444685, 2.29864883845441],
              [15.55008010329324, 2.2932384628816584],
              [15.549688732824912, 2.2914284802374296],
              [15.54019384357169, 2.290449070144746],
              [15.532280545527726, 2.2711734489859463],
              [15.532365535446964, 2.26397094640422],
              [15.530242648688532, 2.258751328019316],
              [15.524575988588728, 2.2609929001996845],
              [15.519652145827001, 2.2464448546095825],
              [15.515454996944035, 2.241568242668248],
              [15.503504719286461, 2.231197635106684],
              [15.500881544557865, 2.22399025629546],
              [15.495347292712609, 2.22498813154781],
              [15.48881600368053, 2.233302119682992],
              [15.481168023215266, 2.231599678019198],
              [15.477441555891874, 2.2397763507728983],
              [15.482192402872565, 2.2410618276707295],
              [15.475076394321762, 2.2482830304340706],
              [15.477671489563317, 2.2492090905671236],
              [15.480548297699812, 2.2544357684013296],
              [15.475671291459944, 2.258862612480309],
              [15.477025058821452, 2.2626693645953986],
              [15.478642234063438, 2.2750633270457445],
              [15.477114709173817, 2.2783381399566234],
              [15.480131964421584, 2.282097709414587],
              [15.480568386477028, 2.285313307436895],
              [15.484328199590378, 2.2908389256254966],
              [15.48685121932132, 2.2991316886450317],
              [15.481909484686415, 2.302726314439966],
              [15.475015744261757, 2.3094094020934963],
              [15.473911139349713, 2.3168399007767513],
              [15.475637776774327, 2.3284608350123808],
              [15.47358320072569, 2.3311489913219674],
              [15.466797889096558, 2.331610161214594],
              [15.465886828952963, 2.3253651810425295],
              [15.46166536657568, 2.3185166018434296],
              [15.46162417876239, 2.3112231620075043],
              [15.46781785806811, 2.304769952927425],
              [15.46632635168552, 2.3003880306546867],
              [15.467624905923515, 2.296876355448433],
              [15.466569264041743, 2.285581682796586],
              [15.467118467693554, 2.280776090283378],
              [15.461405403096501, 2.275691931694534],
              [15.458272534201656, 2.2698267615149383],
              [15.459030395905005, 2.2666731745154562],
              [15.463446224944404, 2.259839394265972],
              [15.458000026130229, 2.246858060996531],
              [15.461118003249863, 2.2446720963075277],
              [15.458346153729702, 2.2372718666715445],
              [15.455667707556977, 2.2371815893684985],
              [15.452004594778245, 2.233380548400393],
              [15.455319821531868, 2.2300059229190405],
              [15.457781460488267, 2.2315648443638247],
              [15.463635198021787, 2.2280606449363667],
              [15.47008022124047, 2.2270491989335803],
              [15.469642439275244, 2.2238313879765],
              [15.472153516418025, 2.218039575500654],
              [15.477879521278181, 2.2160926932746836],
              [15.47879833412725, 2.210410968390578],
              [15.48084278774925, 2.207336374296698],
              [15.476695374663652, 2.2028104664180974],
              [15.475216514090405, 2.197724943247266],
              [15.468610259939881, 2.188556467334325],
              [15.469995168942669, 2.182061363839488],
              [15.468420675033878, 2.1763859008419346],
              [15.470277721103304, 2.1657405736126982],
              [15.466098678688384, 2.1651008364007884],
              [15.458631459315608, 2.165737108184271],
              [15.461690251096515, 2.1743715551537957],
              [15.460730866160615, 2.181780884783947],
              [15.456172051277878, 2.18894679975757],
              [15.451363498437775, 2.1922244996475775],
              [15.44907809262743, 2.2030835044340566],
              [15.450557608517695, 2.2123998618148493],
              [15.448173858004218, 2.2143346942273823],
              [15.438202640218114, 2.215172390597542],
              [15.434471646448142, 2.2181419570582586],
              [15.437118133656524, 2.2205923398406284],
              [15.439549248376904, 2.232467533788368],
              [15.438620513573087, 2.2390900533617337],
              [15.433449435381846, 2.246431351656715],
              [15.429614815694674, 2.2487502029661237],
              [15.420584417855165, 2.248368494431662],
              [15.416430448822512, 2.24513026382923],
              [15.411228651826862, 2.2468786470825104],
              [15.39417338988195, 2.2470901521771194],
              [15.394756713874916, 2.2426916820720555],
              [15.393713623052495, 2.2431041600552155],
              [15.38994899319941, 2.2525704562289763],
              [15.385176831770343, 2.255646108452204],
              [15.380789969736801, 2.2556479591675602],
              [15.379947721467397, 2.265971391501698],
              [15.3766528904245, 2.2713858261062727],
              [15.370433565192448, 2.273798389908795],
              [15.368972580890382, 2.2783188008033792],
              [15.370092853180717, 2.285431154185655],
              [15.368211615217286, 2.287160417264998],
              [15.36719798578522, 2.2943610207429694],
              [15.363080713775332, 2.298608929028396],
              [15.358126917780849, 2.3010589319691808],
              [15.358441179222902, 2.307242794569536],
              [15.355762985548237, 2.30668470613964],
              [15.353706700933046, 2.311226827378932],
              [15.350045486065834, 2.314345182392548],
              [15.346309279649406, 2.314356572015553],
              [15.34442305863869, 2.317746188285925],
              [15.336214827018436, 2.3219942476427122],
              [15.328975513651468, 2.320363836947602],
              [15.325488862322596, 2.3224540775285947],
              [15.320693844592848, 2.3288163996412963],
              [15.317797184305917, 2.32818410333742],
              [15.316586328420644, 2.3321054789254663],
              [15.318138263819764, 2.3354039917059803],
              [15.318909204674773, 2.3422767062100553],
              [15.314684414151715, 2.3464396754976757],
              [15.312078257856244, 2.3411027378369327],
              [15.309512347271196, 2.3415885659789306],
              [15.302515837509114, 2.345799430170324],
              [15.29865465031907, 2.34336250280901],
              [15.293517908494309, 2.343089477108069],
              [15.29290568712702, 2.3460527817030723],
              [15.285325949258475, 2.3478366762523475],
              [15.284029729509442, 2.3495633824666835],
              [15.2735920272793, 2.3511426749210624],
              [15.268305661337855, 2.3547621648099],
              [15.262631245348084, 2.355552662713605],
              [15.261236290434345, 2.35270565738801],
              [15.256446554084802, 2.353307681726939],
              [15.252332757243696, 2.3519757177335405],
              [15.249956786629085, 2.356071352836428],
              [15.24695393981859, 2.355582425367375],
              [15.243538239845273, 2.362632910618065],
              [15.237724372526257, 2.364769290298852],
              [15.235412902373888, 2.3680008429493005],
              [15.232215724718651, 2.3677666925943317],
              [15.230705199611187, 2.3792187851789963],
              [15.228525840362078, 2.3851116723128474],
              [15.22561753576994, 2.384778983993765],
              [15.22431258603237, 2.3882534736750514],
              [15.22090504500167, 2.391284478805961],
              [15.219052321391317, 2.397009249964432],
              [15.21143270037736, 2.4090260017430776],
              [15.207128853688625, 2.4093850043060905],
              [15.200796348672643, 2.4165448982472415],
              [15.193064663439026, 2.4322911216515366],
              [15.190352728420406, 2.4430923739253596],
              [15.177116241108449, 2.500870709850928],
              [15.176561739432167, 2.5016590040545506],
              [15.168016835693777, 2.5369866567577724],
              [15.207065763690856, 2.5451901689604233],
              [15.280422560496442, 2.5603631602710295],
              [15.41388313617986, 2.588461842281145]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.31702155796513, "lat": 39.5611239734182 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24025"],
        "coty_name": ["Harford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harford County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01698178"
      },
      "bbox": [
        15.168016835693777, 2.1424555925791493, 15.60496426463619,
        2.58949075683619
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [19.02794881427485, 5.525534470416581],
            [19.027814930722688, 5.53632478892433],
            [19.03118256183762, 5.54310336250567],
            [19.03000256476431, 5.547046571507405],
            [19.03288579000236, 5.555326614165823],
            [19.035921707879307, 5.55881546425939],
            [19.031838870224657, 5.561460889735829],
            [19.03025112779823, 5.5652440209683744],
            [19.02342906373577, 5.571396689905688],
            [19.04144245547935, 5.588559669560586],
            [19.065080634814777, 5.607451794634328],
            [19.078667910636092, 5.636309471006145],
            [19.083590847758984, 5.631351186458382],
            [19.09816293800318, 5.620941845296221],
            [19.117895982003553, 5.6131179706184],
            [19.119395197854576, 5.6090008855361635],
            [19.138745678262552, 5.60148787420386],
            [19.171934376058903, 5.597394822245859],
            [19.173333998773924, 5.59652144386384],
            [19.19514649402072, 5.596324099023836],
            [19.213531185432053, 5.5983173984782555],
            [19.27165440979492, 5.609785141662208],
            [19.277463019883825, 5.608858618960745],
            [19.288470780576016, 5.60547328782569],
            [19.28969524696898, 5.603408762285828],
            [19.284724508084683, 5.600914545488762],
            [19.278332393633935, 5.606213229852321],
            [19.275625378874, 5.60501457526508],
            [19.275785354522444, 5.6014908159457155],
            [19.268021279344865, 5.601576504943709],
            [19.256238215870294, 5.599785106943477],
            [19.245990279144376, 5.599997969562881],
            [19.240342518483192, 5.597370671600344],
            [19.223685674406642, 5.595074056147625],
            [19.21666052696878, 5.593141423455576],
            [19.20928040867689, 5.592883508413277],
            [19.209362960074206, 5.5890312806857505],
            [19.206386698416026, 5.586331301738731],
            [19.202390584678817, 5.586118241970025],
            [19.202990570984333, 5.581191178687504],
            [19.211114188953477, 5.578773025936996],
            [19.213329962959293, 5.580268535914495],
            [19.22985297897016, 5.574846042603401],
            [19.231903744691557, 5.572198747833325],
            [19.231478633913405, 5.56820529352063],
            [19.236137442373778, 5.566828168930912],
            [19.247350224092777, 5.568696965082379],
            [19.256338506875135, 5.573831490696859],
            [19.254484095064196, 5.5785270313876465],
            [19.25517812937355, 5.581156086855809],
            [19.26100451776349, 5.581100265708202],
            [19.270303454870643, 5.584328085430728],
            [19.275066649650192, 5.583759621624159],
            [19.27891682335085, 5.587258866079511],
            [19.290754411920048, 5.589639824819956],
            [19.296722328788235, 5.594349473524776],
            [19.30493283164879, 5.593617759448672],
            [19.30723949891276, 5.592039660425493],
            [19.311194963717842, 5.592947719933559],
            [19.31146626209586, 5.5971281919623905],
            [19.315868460175825, 5.601415369725263],
            [19.317885618242954, 5.610116568477492],
            [19.312611350230842, 5.613935105248276],
            [19.315767931289265, 5.619505584350331],
            [19.32607072852743, 5.633740100222482],
            [19.342773363385895, 5.6477330814766615],
            [19.34704016259646, 5.647456430604379],
            [19.369485385280974, 5.660344474550949],
            [19.374623551734498, 5.664986819048439],
            [19.38890306199354, 5.6676714564204165],
            [19.40529498496032, 5.680251425262543],
            [19.413957499094085, 5.685172094265174],
            [19.420390797290597, 5.691101533477521],
            [19.42622095130138, 5.692629098386531],
            [19.450487827515754, 5.7145068178250265],
            [19.454702339008723, 5.724716734427527],
            [19.458432248630366, 5.730696320869194],
            [19.459619387473662, 5.739079107906115],
            [19.457549989979846, 5.742480285605181],
            [19.456687281073755, 5.7479900455919815],
            [19.450914197274564, 5.768197455295988],
            [19.437407432301885, 5.803771993491898],
            [19.438278805007332, 5.809530407146882],
            [19.440881831992353, 5.815475544180454],
            [19.438017444528057, 5.818190766196476],
            [19.426604652754968, 5.81626872919134],
            [19.421208871580266, 5.819774894314437],
            [19.422328832282755, 5.824047127141291],
            [19.4274516418956, 5.826581360418508],
            [19.426321259486834, 5.831236446821594],
            [19.42110642249605, 5.831442705676558],
            [19.416099903954084, 5.834330912209357],
            [19.408920530103572, 5.8414264363832675],
            [19.408096856329614, 5.845115736126164],
            [19.409998621204426, 5.8509779633953825],
            [19.397283616196447, 5.848181121229222],
            [19.39077342088925, 5.844149156694376],
            [19.387239950678786, 5.838565008012319],
            [19.39076097584391, 5.836416609245829],
            [19.390874504059962, 5.832927020061847],
            [19.38756949623497, 5.8263389103597],
            [19.390794520364324, 5.814732279988952],
            [19.389391299141437, 5.810819250726753],
            [19.39394176430483, 5.801775720168967],
            [19.392449978069774, 5.799878568911525],
            [19.385549827214234, 5.813420094350602],
            [19.37431469761551, 5.850734460935685],
            [19.37074787970372, 5.854640232815871],
            [19.359175758696235, 5.8952595835745685],
            [19.34745999427876, 5.91961219255085],
            [19.339851113371378, 5.9308671677874205],
            [19.333425283801198, 5.937334735571542],
            [19.32165305325538, 5.945263044984056],
            [19.308826874489164, 5.950089704544025],
            [19.288164514199003, 5.9539874583978],
            [19.282930830971832, 5.9540726963772626],
            [19.273451469977232, 5.94866517200058],
            [19.268178115699758, 5.943755892674756],
            [19.26386181740205, 5.93635268454057],
            [19.261400465951695, 5.924254193830944],
            [19.26186472171023, 5.921189528542345],
            [19.255107938383105, 5.915463453955875],
            [19.263648873485042, 5.91030066605155],
            [19.26906445863962, 5.910535918931398],
            [19.281146955687053, 5.917844449416486],
            [19.276713434569626, 5.91018201792377],
            [19.272191100560658, 5.906897236814416],
            [19.264804355599203, 5.907014442956386],
            [19.253605704385212, 5.913028434983131],
            [19.249117446095077, 5.917385597090217],
            [19.24245404496675, 5.925642039643586],
            [19.233228760760316, 5.9314953910212935],
            [19.22417642342986, 5.935799305072346],
            [19.22083847557351, 5.934970367126702],
            [19.218675020901106, 5.937661786824319],
            [19.22139298622272, 5.947919812956254],
            [19.228698764220326, 5.955889093313342],
            [19.24110611345311, 5.962751073944091],
            [19.25348017782528, 5.966631024760602],
            [19.275170929766432, 5.9687852652834525],
            [19.309525320365097, 5.966891333466],
            [19.336718970784226, 5.960949971226376],
            [19.357706221415658, 5.9519231676548685],
            [19.381629249037264, 5.935050129687633],
            [19.40459341599951, 5.912306433148875],
            [19.433857820561883, 5.878725016426623],
            [19.456613877458985, 5.845642238596089],
            [19.49130251845568, 5.786142349395454],
            [19.500240479437522, 5.765291921683161],
            [19.50623465566567, 5.753136209772995],
            [19.531536839524243, 5.689141329197234],
            [19.540673384612916, 5.657537560416201],
            [19.54373327955028, 5.641203260801188],
            [19.544991713889885, 5.62768866868998],
            [19.541646040290892, 5.612327554158586],
            [19.543994731348207, 5.603367324555772],
            [19.54256403888612, 5.59871170406939],
            [19.54218937804164, 5.58715567432682],
            [19.542682811121306, 5.580586242530142],
            [19.541854606337907, 5.575939781910446],
            [19.543730396889636, 5.566640049966724],
            [19.539296067686628, 5.556640877685903],
            [19.53304392583112, 5.55459591386739],
            [19.528870122718686, 5.54991250491221],
            [19.52890997907944, 5.535482343144405],
            [19.531764576949758, 5.522761210048769],
            [19.539870869458554, 5.497156961063975],
            [19.539146257547635, 5.4894364902134205],
            [19.536471254790214, 5.483315286395432],
            [19.53253681122054, 5.480362938552205],
            [19.526347799843506, 5.482156197520578],
            [19.52271192590686, 5.4885535951225615],
            [19.524393076080138, 5.496248754743438],
            [19.529217909503846, 5.505849134959929],
            [19.529940963959923, 5.516880371505483],
            [19.528397248713606, 5.529389747448671],
            [19.523772515768083, 5.543304655355134],
            [19.526106011727226, 5.55417038938471],
            [19.52407432101474, 5.56041935491937],
            [19.526818098548127, 5.572767314379316],
            [19.525732953734547, 5.580877316186426],
            [19.52781099412787, 5.588327799333959],
            [19.521820800523546, 5.595277668348641],
            [19.51374607725857, 5.597681989744024],
            [19.503424345100576, 5.604142002958895],
            [19.49462447138095, 5.606262047486824],
            [19.48937834362042, 5.605205931404132],
            [19.479723767170114, 5.598110181464324],
            [19.471843361896873, 5.59555544828865],
            [19.461823426160162, 5.590098959283003],
            [19.457225351111408, 5.588404551591991],
            [19.455230748567384, 5.585673664772935],
            [19.447462679694986, 5.5851735160772025],
            [19.438301118708146, 5.581435500331832],
            [19.42081016779761, 5.568959838116707],
            [19.40477920356051, 5.559216985340435],
            [19.392087653499143, 5.557148437643553],
            [19.384738245523764, 5.555294789906979],
            [19.36665608076219, 5.546029310634429],
            [19.365666805552976, 5.541839979370627],
            [19.359623109581566, 5.538449287084383],
            [19.352183885112392, 5.53010824361472],
            [19.335690971906224, 5.517228065071878],
            [19.33039597000222, 5.507664742251759],
            [19.331811866973563, 5.5047698922334005],
            [19.33062312058929, 5.497489926485486],
            [19.326872232829835, 5.494860769486207],
            [19.324900185664436, 5.495959529025556],
            [19.32154937572862, 5.502177571901755],
            [19.319800704365136, 5.5099872314157725],
            [19.314010591212185, 5.51586640784085],
            [19.308559556831327, 5.516648806810125],
            [19.301893113920997, 5.514882324995825],
            [19.29574755328155, 5.510338815094286],
            [19.29625203025929, 5.5074077151813725],
            [19.28892971106921, 5.503200209953957],
            [19.285926009967685, 5.500332050777254],
            [19.281017705100204, 5.504244953743838],
            [19.273964124145227, 5.506536491203675],
            [19.267669900370016, 5.506633834575889],
            [19.25841466767504, 5.502366774110311],
            [19.253153585654566, 5.497153516838625],
            [19.25107502958639, 5.492056881051497],
            [19.251999755702112, 5.489137464670349],
            [19.25043512496245, 5.480607718741186],
            [19.245001219943287, 5.474402007185921],
            [19.23100896945167, 5.465374164739139],
            [19.225061285496402, 5.4647420904180946],
            [19.21269071838462, 5.458612612604232],
            [19.20506310190396, 5.457153947442044],
            [19.20290013586905, 5.45003042622978],
            [19.202926597433724, 5.442506579699998],
            [19.20017088563087, 5.438866485648244],
            [19.200887950694188, 5.434848063251248],
            [19.196834631896692, 5.420031046910308],
            [19.18967434989236, 5.40421114049887],
            [19.184143312129038, 5.398265579827375],
            [19.17923716958527, 5.394633049786782],
            [19.159233326799555, 5.38595597224018],
            [19.155323277006378, 5.382552167082423],
            [19.146809970108833, 5.384943363058217],
            [19.141037951092915, 5.383527523059798],
            [19.13264478185417, 5.378029945562853],
            [19.122950608134047, 5.373861800454341],
            [19.118788868416758, 5.369993442033904],
            [19.11427443528902, 5.369999917907654],
            [19.109065662865206, 5.36823409435002],
            [19.104116765717, 5.363747576714667],
            [19.09725469869194, 5.362820974809391],
            [19.082375374414493, 5.353843386194339],
            [19.076762829746574, 5.346182064504362],
            [19.07279587162081, 5.331235531280818],
            [19.07211652212222, 5.326634241173342],
            [19.066827755613424, 5.3284974462445165],
            [19.06290927932727, 5.32743211368521],
            [19.057990488636804, 5.332018517954273],
            [19.054639651769453, 5.328886272334317],
            [19.04974605603671, 5.327372640396163],
            [19.047287228591976, 5.329665779841702],
            [19.046455639824565, 5.334960458878782],
            [19.048211370613817, 5.338983935501062],
            [19.05418961198564, 5.33653750951067],
            [19.059112573439577, 5.341946391241644],
            [19.05834913838324, 5.349079675920522],
            [19.063063179932374, 5.353925725854965],
            [19.064447832599992, 5.3611054009592625],
            [19.06167559106407, 5.368226702216175],
            [19.060691019666194, 5.375927652755502],
            [19.06382676653926, 5.377453505350421],
            [19.063106431708686, 5.381483184769612],
            [19.066758266978415, 5.385092418987244],
            [19.066734840889204, 5.39022378082181],
            [19.064427638554175, 5.395566668487234],
            [19.051093701630126, 5.414968035938087],
            [19.05010422442548, 5.419871397550982],
            [19.05289985084597, 5.424082233779512],
            [19.051765336680177, 5.430235493005091],
            [19.054846943581975, 5.4361693800690425],
            [19.05230033764569, 5.440441858429971],
            [19.04723028057021, 5.4449241405175135],
            [19.050475297178288, 5.44636641437765],
            [19.04616771590603, 5.450537165812878],
            [19.042853015439483, 5.450632706060923],
            [19.04146140785645, 5.45489900379954],
            [19.045591080387876, 5.456656627319298],
            [19.0480524814213, 5.4595868622890045],
            [19.052871056248947, 5.460917922809994],
            [19.057342298968067, 5.466034448551955],
            [19.060098666603825, 5.471550565972657],
            [19.050385125021002, 5.475591018575558],
            [19.04822656341553, 5.475071104723761],
            [19.045075174521042, 5.469738309657644],
            [19.041505324064225, 5.468767087924514],
            [19.03608855330853, 5.471024375935832],
            [19.033728234030903, 5.47458924418414],
            [19.036545117739237, 5.478721986990475],
            [19.040708084819965, 5.48072470367891],
            [19.044908669639174, 5.479992987165266],
            [19.047738087596436, 5.481892195046921],
            [19.04649574727034, 5.486904685470269],
            [19.042746699992172, 5.490467571433903],
            [19.036038204530612, 5.4900864927844415],
            [19.027343882504997, 5.487814494249225],
            [19.026334492044626, 5.490608109460546],
            [19.032208430570762, 5.501939929458809],
            [19.0380996856244, 5.50649230698281],
            [19.04188571113778, 5.507183727433764],
            [19.04839444682934, 5.513347352128742],
            [19.04537887787515, 5.5158470982353025],
            [19.04454136829347, 5.519439939881931],
            [19.04099746836526, 5.524294188775533],
            [19.035478595080118, 5.523966843404002],
            [19.02794881427485, 5.525534470416581]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -70.29038464152745, "lat": 41.72435540669958 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25001"],
        "coty_name": ["Barnstable"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barnstable County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00606927"
      },
      "bbox": [
        19.02342906373577, 5.326634241173342, 19.544991713889885,
        5.9687852652834525
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.947866508616169, 7.469062686962534],
            [5.945686805441628, 7.489590667738956],
            [5.9347215196565255, 7.618685545100942],
            [5.920605733275194, 7.789422439087333],
            [6.035962003300507, 7.7991482538360755],
            [6.093820936568685, 7.8041474640421615],
            [6.137014770848008, 7.807736466532605],
            [6.1804447769524895, 7.8115369249908095],
            [6.266896117305147, 7.818889316901721],
            [6.274525225305964, 7.733289311770913],
            [6.281645047237884, 7.647672024330354],
            [6.289001570576624, 7.561984129856306],
            [6.296458547168722, 7.475991372177841],
            [6.241248593433548, 7.471169910853049],
            [6.251915309376936, 7.343272192513759],
            [6.254015385825209, 7.325981423859521],
            [6.256432525136853, 7.297551224038694],
            [6.2279678062428, 7.29493032733809],
            [6.1532826891178525, 7.2883712289219],
            [6.152489892438685, 7.28817130178997],
            [6.145908229906131, 7.292004828247522],
            [6.1388847861405935, 7.3015507478511505],
            [6.139679014813682, 7.309456825173185],
            [6.13519315644065, 7.313510984268448],
            [6.131473768611245, 7.314151676706816],
            [6.126594794303751, 7.318118096789689],
            [6.112661248730922, 7.315596995183836],
            [6.108943132217131, 7.320918279873603],
            [6.105434136386778, 7.318187094150942],
            [6.0993452245980215, 7.320097217881168],
            [6.097063452178893, 7.317750773875911],
            [6.091816454563816, 7.3206647586459095],
            [6.0882139083288145, 7.31810270753485],
            [6.080050713849095, 7.316031821771092],
            [6.0743607594736595, 7.3172536479133825],
            [6.0681207551895175, 7.3165357949879795],
            [6.065183927590895, 7.32205907854969],
            [6.061177395531086, 7.324008237418736],
            [6.051178199334454, 7.326428725886977],
            [6.048531474886541, 7.32953785612824],
            [6.054423453963893, 7.334042007478889],
            [6.052706038451683, 7.339832559388272],
            [6.048150419801355, 7.34952618725252],
            [6.0441738061305275, 7.35171705680338],
            [6.0349425570626725, 7.347542490309031],
            [6.027587801971718, 7.347189556513108],
            [6.021157711894063, 7.343406018462314],
            [6.012427850896417, 7.34311217584702],
            [6.011518964195718, 7.337176968406212],
            [6.005566682394538, 7.3339349329985515],
            [6.000286491572268, 7.333245207183096],
            [5.9917974013522945, 7.33176215531792],
            [5.987610492452212, 7.333074836375307],
            [5.986009324268337, 7.33557056857036],
            [5.974982708396613, 7.336059045245951],
            [5.968111249713378, 7.341162446750434],
            [5.963572610411861, 7.35282377860156],
            [5.958172712083245, 7.352988825680274],
            [5.9483992558438405, 7.357363074326961],
            [5.942972083112289, 7.3666018348173825],
            [5.944350582382089, 7.3707906418257],
            [5.958252558003756, 7.387910801904617],
            [5.961644058986411, 7.390055739961759],
            [5.966656632905188, 7.399486639452962],
            [5.972783152015926, 7.405677553672158],
            [5.976359847333361, 7.415003823439153],
            [5.979965082960254, 7.414190065911271],
            [5.980676552825656, 7.418621886853389],
            [5.983531873283189, 7.425240270820583],
            [5.979704252105549, 7.426283810705023],
            [5.973456947693526, 7.430393477540029],
            [5.965462213511801, 7.428930093584083],
            [5.961466758734355, 7.432220992144882],
            [5.960248822332885, 7.440785477574389],
            [5.956521971068724, 7.447983611746929],
            [5.956962698629621, 7.453417592894292],
            [5.959113954324045, 7.458907208731825],
            [5.963215666473266, 7.462042660293001],
            [5.963492038473178, 7.4645251496606555],
            [5.95752659334265, 7.470024752226333],
            [5.947866508616169, 7.469062686962534]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.87031493176882, "lat": 46.00916419860158 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26043"],
        "coty_name": ["Dickinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickinson County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01622964"
      },
      "bbox": [
        5.920605733275194, 7.28817130178997, 6.296458547168722,
        7.818889316901721
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.03470806696006, 6.265059872243543],
            [8.10578755837921, 6.2727944030313365],
            [8.181320741039489, 6.280223311599993],
            [8.190517173979808, 6.281461885029993],
            [8.205280963943862, 6.282537902549765],
            [8.26704538073521, 6.289652003232513],
            [8.376207649331667, 6.302950216574007],
            [8.383218992492738, 6.214371551656919],
            [8.390796408993785, 6.154598593203167],
            [8.400617611390643, 6.085337333297869],
            [8.405408492727988, 6.043047050710783],
            [8.416702601678761, 5.9565752491941995],
            [8.397361083777541, 5.954348362873812],
            [8.345267808437937, 5.9489603992429645],
            [8.298757124457232, 5.944730208961642],
            [8.248978546540062, 5.940007505128559],
            [8.164326758578756, 5.93101183155194],
            [8.07373348177638, 5.92072638897401],
            [8.073149191779848, 5.9209491185571475],
            [8.06935358985865, 5.952483244305258],
            [8.065464214933987, 5.981907451454807],
            [8.059094362987654, 6.035986563615306],
            [8.041351213886028, 6.178615166707124],
            [8.03470806696006, 6.265059872243543]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.09474370585805, "lat": 44.33740204889769 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26113"],
        "coty_name": ["Missaukee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Missaukee County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01622999"
      },
      "bbox": [
        8.03470806696006, 5.92072638897401, 8.416702601678761, 6.302950216574007
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.672558735306868, 6.683356718560307],
            [8.712170648063434, 6.6881931255411455],
            [8.756344360072637, 6.694353742639318],
            [8.840990803155323, 6.704006012027411],
            [8.92648013228205, 6.715538906242104],
            [9.011691595382606, 6.727241231656815],
            [9.011712723637444, 6.727066403779766],
            [9.019716438336767, 6.666945698407187],
            [9.022756922725875, 6.641260188228052],
            [9.028890059395367, 6.593599905836531],
            [9.037148641996552, 6.532999446077312],
            [9.045706717727015, 6.469403497266631],
            [9.057271251423307, 6.384101854577924],
            [8.972177430963695, 6.373204020832743],
            [8.939880495667122, 6.368630971666542],
            [8.887053227349778, 6.361782611607876],
            [8.844604044891007, 6.355971681267443],
            [8.715868654584462, 6.339739687568188],
            [8.70432092709739, 6.430291469328704],
            [8.702924748701799, 6.442169608358544],
            [8.688292416236548, 6.554711793081464],
            [8.683060695124956, 6.5982785281171425],
            [8.672558735306868, 6.683356718560307]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.1297746099374, "lat": 44.68176389295927 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26135"],
        "coty_name": ["Oscoda"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oscoda County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01623010"
      },
      "bbox": [
        8.672558735306868, 6.339739687568188, 9.057271251423307,
        6.727241231656815
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.692569306675904, 6.228275320978225],
            [7.735410190411249, 6.23288413724938],
            [7.806947634666088, 6.240059761257504],
            [7.877171671661516, 6.247416353242166],
            [7.9028034050660585, 6.2502412285537226],
            [7.999044294497652, 6.261148440935781],
            [8.03470806696006, 6.265059872243543],
            [8.041351213886028, 6.178615166707124],
            [8.059094362987654, 6.035986563615306],
            [8.065464214933987, 5.981907451454807],
            [8.06935358985865, 5.952483244305258],
            [8.073149191779848, 5.9209491185571475],
            [8.06464939365856, 5.919649476170878],
            [8.03688902948112, 5.916840416428472],
            [7.9099030713556955, 5.902591851656483],
            [7.879946485656563, 5.899680083177646],
            [7.876160345181131, 5.899033783493509],
            [7.799711931538037, 5.890291969239278],
            [7.768264314101143, 5.887075161146469],
            [7.727565251414825, 5.882178395206605],
            [7.722821827651177, 5.92610597854652],
            [7.721044949004698, 5.940750592347891],
            [7.718310370238959, 5.968601602475299],
            [7.715504954067032, 5.993518227557633],
            [7.710987355739072, 6.039071041859341],
            [7.707609220481183, 6.068963352372789],
            [7.705315377088888, 6.091777101444956],
            [7.701145386180316, 6.1404979910970265],
            [7.695947858617028, 6.196356067077671],
            [7.692569306675904, 6.228275320978225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.57846147550468, "lat": 44.33832919404034 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26165"],
        "coty_name": ["Wexford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wexford County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "01623023"
      },
      "bbox": [
        7.692569306675904, 5.882178395206605, 8.073149191779848,
        6.265059872243543
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.847830335186745, 5.52754217086067],
            [0.9128533716839102, 5.527702473240631],
            [1.0140329698635018, 5.528003015176109],
            [1.0790367967640635, 5.528633077566783],
            [1.1006542361900549, 5.528536834504751],
            [1.1062143537879443, 5.528483104740684],
            [1.1075950679868838, 5.441698445044777],
            [1.1935245341542904, 5.442253668250488],
            [1.2498626693882675, 5.4429916177973405],
            [1.2796238492792404, 5.443518388789068],
            [1.2807622734872313, 5.385662404578965],
            [1.2822732620189243, 5.255922295196337],
            [1.283051575858747, 5.183777629012912],
            [1.207811094753102, 5.182596644324089],
            [1.1574346216849154, 5.182275322818587],
            [1.0810324959659754, 5.181472745055826],
            [1.0522839444048322, 5.180974914996492],
            [1.0234055607517354, 5.1810390310949925],
            [0.9839611507063671, 5.1808403320253005],
            [0.8832925907839512, 5.179986308013927],
            [0.8570207090126011, 5.179869546646525],
            [0.8498916640887578, 5.179787022477253],
            [0.849404126869408, 5.22277909680671],
            [0.8494917768972899, 5.266740204181306],
            [0.8489359224301067, 5.353724461864404],
            [0.8484899682243939, 5.440525014921465],
            [0.847830335186745, 5.52754217086067]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.18120117606544, "lat": 44.00711406681054 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27033"],
        "coty_name": ["Cottonwood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cottonwood County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00659462"
      },
      "bbox": [
        0.847830335186745, 5.179787022477253, 1.283051575858747,
        5.528633077566783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.2786598431295033, 7.3425943314669295],
            [0.27944061359246053, 7.428730669172178],
            [0.3652233416663578, 7.4283306708741526],
            [0.4507110042338853, 7.428348134359139],
            [0.5369627173635211, 7.428208954200725],
            [0.6236539394156949, 7.427519367805674],
            [0.6237803330341742, 7.365251076179997],
            [0.6242065881094296, 7.255431638072505],
            [0.6317681891186769, 7.255462142744199],
            [0.6322574607735503, 7.140864430502536],
            [0.6323436500054188, 7.083230576613104],
            [0.5173951105480439, 7.082700396228916],
            [0.4595956624396829, 7.082535209270833],
            [0.37288612823360495, 7.082790174219991],
            [0.35324815344460947, 7.083037902646842],
            [0.28638806686071566, 7.08314214314632],
            [0.28664297134877953, 7.169495113185318],
            [0.2867335527447851, 7.234155802335693],
            [0.28709649762779127, 7.256431573967838],
            [0.2784029122121237, 7.256516585769368],
            [0.27835020959163864, 7.299471651756325],
            [0.2786598431295033, 7.3425943314669295]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.01215745940449, "lat": 45.9340408913411 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27051"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00659471"
      },
      "bbox": [
        0.27835020959163864, 7.082535209270833, 0.6323436500054188,
        7.428730669172178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.6955626202333152, 6.31884618125885],
            [1.781589907220944, 6.319812051585145],
            [1.8387496390484048, 6.320794335745228],
            [1.8677898479878332, 6.32145754158882],
            [1.8685146022689456, 6.27824960782685],
            [1.8692879286040758, 6.2491596089477275],
            [1.8699121536910845, 6.235094180696468],
            [1.871285438118685, 6.235089892041853],
            [1.871930446356143, 6.1984905737306075],
            [1.8731369979782848, 6.142618683862914],
            [1.8744976176758856, 6.061374381222969],
            [1.7896536292097998, 6.0595635146463485],
            [1.7213354802591967, 6.058808377575261],
            [1.7017873498037126, 6.0583886331367784],
            [1.7026686826784636, 5.98458349144206],
            [1.7029423396363106, 5.971147833667519],
            [1.6813223245434235, 5.970942812497407],
            [1.6167602028303518, 5.969768009303106],
            [1.5303443435149282, 5.967826068613434],
            [1.5294128431137135, 6.026078510037598],
            [1.5287930127687424, 6.054767389081312],
            [1.5276235127155664, 6.1422542084247445],
            [1.526620883692501, 6.193073964652182],
            [1.5262633923175293, 6.229221858379006],
            [1.5229648269091323, 6.229131268553664],
            [1.5224465504453402, 6.281576950238726],
            [1.5219444847775845, 6.3162202689489675],
            [1.5657915039463355, 6.3163521160882015],
            [1.60893686961727, 6.3166578024961595],
            [1.6598154128376759, 6.3180762237204595],
            [1.6955626202333152, 6.31884618125885]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.2724262360216, "lat": 44.823568200439276 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27085"],
        "coty_name": ["McLeod"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McLeod County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00659491"
      },
      "bbox": [
        1.5219444847775845, 5.967826068613434, 1.8744976176758856,
        6.32145754158882
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9952704413075301, 6.221943378505999],
            [1.046379206253862, 6.222321606302917],
            [1.0875017635320452, 6.222919438616948],
            [1.1543115553058976, 6.223652362363121],
            [1.1739769569575353, 6.22409801953371],
            [1.2557451388875867, 6.225476294661706],
            [1.3421373981112195, 6.226343229753461],
            [1.42894091266486, 6.227286591528809],
            [1.4938907151710537, 6.228463986288822],
            [1.5229648269091323, 6.229131268553664],
            [1.5262633923175293, 6.229221858379006],
            [1.526620883692501, 6.193073964652182],
            [1.5276235127155664, 6.1422542084247445],
            [1.5287930127687424, 6.054767389081312],
            [1.4356174878729895, 6.052860897484713],
            [1.4370957702600777, 5.965802160933829],
            [1.438281863007572, 5.879107211012293],
            [1.441795509411235, 5.879139761671496],
            [1.4431493017313128, 5.793095428292178],
            [1.3581659984608336, 5.792213870090407],
            [1.3317879016416894, 5.792201252965808],
            [1.3250113461200408, 5.791765928737771],
            [1.3226665677807992, 5.7963072425993],
            [1.3106771086655549, 5.806556423288511],
            [1.3097784695634611, 5.816660070977901],
            [1.3066964185615308, 5.8145908716908705],
            [1.3045589770928274, 5.818191303859881],
            [1.3007416975761936, 5.820581051793376],
            [1.2973678794051686, 5.819020428808145],
            [1.2948747262860738, 5.823989244621159],
            [1.2848307441903586, 5.827393184355372],
            [1.2788710857583012, 5.8249445248265355],
            [1.2759169990223798, 5.829561258505065],
            [1.2706454799753386, 5.832912676117576],
            [1.2649444380551327, 5.834081035286522],
            [1.2650564134702882, 5.840209410972656],
            [1.262193774739718, 5.8431908138263235],
            [1.2615007589076082, 5.849196795563332],
            [1.256731982234724, 5.851244387122447],
            [1.2552257705209369, 5.847950526942547],
            [1.251740952085086, 5.852859862297125],
            [1.2472872631446732, 5.855140120980182],
            [1.2445649348737535, 5.851612130411831],
            [1.2359084273694445, 5.850053099543192],
            [1.2316389437867774, 5.850748735807228],
            [1.2303382448745053, 5.854341407716825],
            [1.2241808630604192, 5.858731221972768],
            [1.2212650635198163, 5.856752896262955],
            [1.2154735898343514, 5.859722385712316],
            [1.2127884160153692, 5.86339069543683],
            [1.207744067581359, 5.862681047835283],
            [1.20503184526952, 5.866336351586193],
            [1.1970727143418944, 5.867119591836532],
            [1.197991948635666, 5.872612438346172],
            [1.1959481387102804, 5.87399948155827],
            [1.1926528234204359, 5.870613296132641],
            [1.1911351440483025, 5.874245948091336],
            [1.185920136492362, 5.873462322325366],
            [1.1827799883347474, 5.876661042665379],
            [1.1754347296875474, 5.881056200474604],
            [1.1640524446403189, 5.876024614801493],
            [1.1625982977961915, 5.884648444408344],
            [1.15686082598822, 5.879839996669062],
            [1.1568446863850537, 5.885748217970736],
            [1.1533514986018951, 5.883985533273868],
            [1.1507415269388177, 5.89046167292473],
            [1.1455690897670217, 5.891311978626634],
            [1.1439202128477637, 5.889593289289078],
            [1.139321069037383, 5.891262502607553],
            [1.1382968403980702, 5.8947902114894815],
            [1.132836056719119, 5.895381340464888],
            [1.1333821393386274, 5.8996434748240185],
            [1.1289789233394623, 5.90107493547389],
            [1.1262117450278775, 5.904986455674847],
            [1.1205255350784717, 5.9067788337613],
            [1.1160046977594449, 5.901956157198178],
            [1.1132531630666398, 5.904479378041292],
            [1.1052455409948017, 5.904546837440289],
            [1.103988398619143, 5.906473321025838],
            [1.101543374436032, 5.9180232385339115],
            [1.0925547836638876, 5.92187467264315],
            [1.0903834727629154, 5.9273491245211085],
            [1.084542709940793, 5.930187735429547],
            [1.0799191991229906, 5.92886547450791],
            [1.0792681471692753, 5.933390852407593],
            [1.0699405920079967, 5.939832000330443],
            [1.0668782241742407, 5.947591721383327],
            [1.0625577420121053, 5.948148616694761],
            [1.0595417479432576, 5.952020947733182],
            [1.055545241540622, 5.953812275461641],
            [1.050216338910612, 5.9511711101358005],
            [1.0472889465314041, 5.954997840514142],
            [1.0414868837483995, 5.956476401359865],
            [1.0405946416842105, 5.960227979390053],
            [1.036870714326993, 5.961400619903732],
            [1.0333936030064352, 5.96764342933322],
            [1.0269497148970042, 5.972755106453763],
            [1.0242740457684443, 5.973489516571089],
            [1.0225961781127453, 5.978457610814944],
            [1.0190604819990534, 5.977205529181999],
            [1.0152035566508084, 5.983666005154409],
            [1.0127874984408252, 5.9834530363302285],
            [1.0078559904559798, 5.987574705343186],
            [1.0028012489494371, 5.996154945841765],
            [0.9969713342812898, 5.998678331841987],
            [0.9915155350572373, 5.992944508358966],
            [0.9828788681635082, 5.990595377157345],
            [0.9675033351217693, 5.992696127101397],
            [0.9650240052428006, 5.995563209260457],
            [0.9587857984261741, 5.999365597519744],
            [0.9517154422033915, 6.0073255197022055],
            [0.9513105844121638, 6.01421031592278],
            [0.9527228461857716, 6.018548746322757],
            [0.9503720071912432, 6.022697570762799],
            [0.9457018534627645, 6.024262717877529],
            [0.9412590344713964, 6.022825113409147],
            [0.9350915740721617, 6.025795584496356],
            [0.9299604662687984, 6.026811476915286],
            [0.9218020780656518, 6.026966137001942],
            [0.9175955432306703, 6.029352491423689],
            [0.9050532213278649, 6.033666403305528],
            [0.8995939932409893, 6.040150270553363],
            [0.8919965627249371, 6.044138624370753],
            [0.8882571342333947, 6.049590699355782],
            [0.8912084914599303, 6.054390206047805],
            [0.8835465653804445, 6.061088091479158],
            [0.8772336611641459, 6.065066757700652],
            [0.8734128681616729, 6.062413065135563],
            [0.8724222351706135, 6.06650524612491],
            [0.8694020353214785, 6.069666536029128],
            [0.8666473637573744, 6.069743758518214],
            [0.8599239249801414, 6.073807123118617],
            [0.8478975969087255, 6.071094534448594],
            [0.8446666357062909, 6.074412087271641],
            [0.8439150951492692, 6.078931238441223],
            [0.8405434277018117, 6.079265101803713],
            [0.8381807007363619, 6.0833588212378436],
            [0.8342544383372256, 6.086232486923471],
            [0.8302897206747822, 6.082596330331189],
            [0.8291923703798654, 6.1841828206925005],
            [0.8295163202873701, 6.194824220322379],
            [0.8295038383216481, 6.220248154846955],
            [0.9156358976932211, 6.221208989058489],
            [0.9952704413075301, 6.221943378505999]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.94715980340833, "lat": 44.72679080764708 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27129"],
        "coty_name": ["Renville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Renville County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00659510"
      },
      "bbox": [
        0.8291923703798654, 5.791765928737771, 1.5287930127687424,
        6.229221858379006
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.900771695296502, -4.086232455124028],
            [4.9583548539685935, -4.122799437361811],
            [4.964170905473499, -4.126939966879151],
            [5.044071866275937, -4.17881981042198],
            [5.045753927544003, -4.179927314973611],
            [5.045126562539408, -4.195347190099709],
            [5.049085812685386, -4.26807492731996],
            [5.050578099234336, -4.282880659123104],
            [5.054101016719249, -4.341632275744956],
            [5.025573801401862, -4.343266028778865],
            [5.011842601706953, -4.343222981245],
            [5.01456204550036, -4.387605451250052],
            [5.018129384256977, -4.452293990581731],
            [5.022649207714024, -4.533284223943116],
            [5.026201419161595, -4.59328847098265],
            [5.027301097446542, -4.606278833703184],
            [5.027753130488202, -4.62076217692636],
            [4.885247578244398, -4.627496066471686],
            [4.881802032881397, -4.627276020972396],
            [4.858402022807272, -4.6285367596337865],
            [4.85564546774861, -4.628692337711319],
            [4.851243552094197, -4.540895966355091],
            [4.848955795640561, -4.4969949568388685],
            [4.820426846468255, -4.498042186240769],
            [4.762534305296343, -4.501150346923104],
            [4.748696392177395, -4.500696395789666],
            [4.60512704076182, -4.509051571154442],
            [4.603366975539632, -4.506781356720308],
            [4.6009343577954285, -4.498791567300084],
            [4.602637479722208, -4.4937014863627285],
            [4.619961444349175, -4.478808372797478],
            [4.630874735983002, -4.471725018861532],
            [4.640907883756947, -4.461459284552124],
            [4.6462456705204875, -4.462357056113798],
            [4.653964895260509, -4.465343365205865],
            [4.6646773568628666, -4.474871953085983],
            [4.670988578452804, -4.47821495425317],
            [4.676094229727586, -4.4827039772432515],
            [4.682977414029078, -4.485682166836734],
            [4.693992875079705, -4.487404037674398],
            [4.703016826197125, -4.485917231272546],
            [4.707678972244711, -4.483715453972613],
            [4.7137545770206115, -4.479118408673898],
            [4.718941282244976, -4.47297543911632],
            [4.722705083246739, -4.4667093034845875],
            [4.725101606923614, -4.4606240740612915],
            [4.725119227288572, -4.454949141701883],
            [4.72340916563158, -4.446572022633079],
            [4.720116422582664, -4.4418319734062965],
            [4.716551507261559, -4.439756006042653],
            [4.706769977608013, -4.438515797610289],
            [4.698777195058561, -4.439935528900775],
            [4.691357000747316, -4.4380743485734975],
            [4.685332779621851, -4.437615209984178],
            [4.680088523596334, -4.438832152489878],
            [4.672976805436821, -4.442300629527317],
            [4.666489829250534, -4.439838463648449],
            [4.658397224689818, -4.44351227191633],
            [4.64094613792011, -4.434730297312341],
            [4.635659436246891, -4.4313350854791915],
            [4.625942615274609, -4.420520332314238],
            [4.617982635967379, -4.410011283852964],
            [4.616031744682202, -4.403154738835674],
            [4.615057283548826, -4.3953183517370125],
            [4.616086864899872, -4.38999365811412],
            [4.621078414804544, -4.382991806795533],
            [4.6257734739159115, -4.380740078923627],
            [4.634615144574011, -4.380870008570564],
            [4.639663764249961, -4.382159946623994],
            [4.641531711466933, -4.385503672840807],
            [4.645585553171648, -4.396697254215832],
            [4.648657770011682, -4.40037773618192],
            [4.661655680583211, -4.409162400493219],
            [4.665485001993685, -4.410956972876482],
            [4.675524106559597, -4.413076872809564],
            [4.682358063319863, -4.413139760854988],
            [4.690226973699974, -4.417932947231341],
            [4.695951264233269, -4.407533902638132],
            [4.696858669949382, -4.40361948137544],
            [4.694992932549271, -4.396871549404016],
            [4.693900595882872, -4.3856324945097285],
            [4.694462330065544, -4.37901337184451],
            [4.697298030083385, -4.364711753190969],
            [4.697585100241031, -4.349157897551688],
            [4.7006182326738255, -4.344465224614938],
            [4.70808643900777, -4.341713277396748],
            [4.711054007676041, -4.341808450828292],
            [4.727008384057031, -4.345533968574259],
            [4.737907513642749, -4.349446766487389],
            [4.7535131166736315, -4.35069401422772],
            [4.757702649832054, -4.349235687274814],
            [4.7636225983920015, -4.345012556378139],
            [4.76844775163571, -4.33955291498713],
            [4.775005314071631, -4.329614675664453],
            [4.776614895301304, -4.316157528070528],
            [4.775064842142012, -4.306673562928547],
            [4.769335126239033, -4.297701111517072],
            [4.758362490252005, -4.285099242454063],
            [4.749866402092305, -4.277416971901279],
            [4.746661449564708, -4.272287016748724],
            [4.745196691087232, -4.264616096989142],
            [4.745629249781806, -4.26162160325176],
            [4.74929470188955, -4.256143024680194],
            [4.754884890051513, -4.252093462051643],
            [4.761108602332827, -4.250989420334748],
            [4.785319702800308, -4.257042967581486],
            [4.789213845517823, -4.257300096147074],
            [4.801149286036869, -4.254438022905789],
            [4.8190244124823876, -4.244779867414086],
            [4.821110864936722, -4.246237820421048],
            [4.817701477745863, -4.2634978996512265],
            [4.810267107706392, -4.277991689580522],
            [4.809023505479985, -4.287058741656265],
            [4.809879084097171, -4.294168431733281],
            [4.8160918950442655, -4.300666123233771],
            [4.822714982213404, -4.3030544029219175],
            [4.829878169322612, -4.302664760007548],
            [4.836246672800799, -4.299914117011197],
            [4.8390563483407245, -4.292877953419625],
            [4.835905083095799, -4.279435189200237],
            [4.829898631982624, -4.266876765592287],
            [4.829549255274419, -4.259596451718515],
            [4.8379980068166715, -4.242988122776445],
            [4.8351665509571635, -4.239261794122822],
            [4.8405535826257005, -4.231865348846761],
            [4.848834607470264, -4.225245887756581],
            [4.857022440199483, -4.223557193199472],
            [4.863942000887385, -4.223782829334567],
            [4.871151304749615, -4.2225556736957985],
            [4.877085336867889, -4.219226259173335],
            [4.883362041562845, -4.213906410786237],
            [4.892360661244268, -4.202334313278922],
            [4.896090534516403, -4.191357888680937],
            [4.898084254562553, -4.18005390955008],
            [4.8935290848996305, -4.170485011282806],
            [4.888805289004702, -4.156557810445276],
            [4.882839217849645, -4.134248203504879],
            [4.881780221764812, -4.127405784030994],
            [4.882440160782598, -4.120919829774968],
            [4.890281796134515, -4.095264146158943],
            [4.895306485204375, -4.08878475861654],
            [4.900771695296502, -4.086232455124028]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.6017253627279, "lat": 34.23001239186544 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28027"],
        "coty_name": ["Coahoma"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coahoma County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00695738"
      },
      "bbox": [
        4.6009343577954285, -4.628692337711319, 5.054101016719249,
        -4.086232455124028
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.557142517839648, -4.033188076576448],
            [6.635876185197228, -4.026951233641457],
            [6.693386393513707, -4.0231471649873995],
            [6.730844398314478, -4.021088308710012],
            [6.846907283722235, -4.011780726440135],
            [6.871818122600952, -4.00994521157489],
            [6.8708522708188475, -4.09085227765162],
            [6.869470260706748, -4.153557644481408],
            [6.869064155523362, -4.181022353567878],
            [6.867109965487471, -4.254710783726701],
            [6.867669030916599, -4.270974998973344],
            [6.866380132300105, -4.285858661583906],
            [6.866415573042794, -4.3007509753531865],
            [6.864721556079743, -4.360782928478702],
            [6.864210486660235, -4.39045769070463],
            [6.84030870359064, -4.3921201552317095],
            [6.7251902458331525, -4.400524421728146],
            [6.701992279035608, -4.402645016924756],
            [6.626499504479949, -4.407005929880854],
            [6.5858235638112985, -4.410268415761723],
            [6.582180112593655, -4.368845819167426],
            [6.578411168470371, -4.318804512167114],
            [6.576363969069087, -4.3003971390908005],
            [6.569927328806791, -4.222275775589524],
            [6.5653290544236, -4.1637756594076585],
            [6.567120112779164, -4.160778503366193],
            [6.56291060947436, -4.10850649105615],
            [6.557142517839648, -4.033188076576448]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.36128584385001,
          "lat": 34.279980111219814
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28057"],
        "coty_name": ["Itawamba"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Itawamba County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00695752"
      },
      "bbox": [
        6.557142517839648, -4.410268415761723, 6.871818122600952,
        -4.00994521157489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.821112309286178, -4.8360547229885755],
            [5.914607996314256, -4.8297231006202095],
            [6.047790001013584, -4.8202223701536715],
            [6.080739113068936, -4.817581637353791],
            [6.079671433252398, -4.801110531723688],
            [6.166715238996206, -4.794302663443066],
            [6.209119487958808, -4.790913886304249],
            [6.210311910399711, -4.8095481637450055],
            [6.213140989762172, -4.846889123701496],
            [6.2151509226921755, -4.878441211725576],
            [6.216981354719274, -4.895015138076692],
            [6.229950221701674, -4.894102571665876],
            [6.235304568797948, -4.967414690452392],
            [6.185856193728032, -4.970921553548863],
            [6.1778319361389435, -4.971682384428497],
            [6.179790825979254, -5.000546849668647],
            [6.14958910916598, -5.003128078487931],
            [6.103434644734566, -5.006409926636979],
            [6.101518854637158, -5.0086138961614255],
            [6.0917053384139335, -5.009676687088521],
            [6.081347791319865, -5.015677932887971],
            [6.071165490059383, -5.014306422476739],
            [6.067999277484231, -5.015787852021492],
            [6.06483329932251, -5.022336806864847],
            [6.056318469299928, -5.023127707885678],
            [6.0541219106030155, -5.026419265643711],
            [6.050902450182722, -5.026863834883065],
            [6.037968588613322, -5.025367324474254],
            [6.034086412289001, -5.027635067315262],
            [6.030048558869777, -5.033432286872522],
            [6.020873042132803, -5.035861823391601],
            [6.018879966150067, -5.037905956788559],
            [6.0126969270171315, -5.038027811353815],
            [6.008599440121237, -5.043457777338872],
            [6.004992672739257, -5.042101516648276],
            [5.99944446950293, -5.047489081797479],
            [5.991355445390084, -5.050920589258468],
            [5.9905928969081605, -5.055332056563729],
            [5.98627788633057, -5.058350395033701],
            [5.981845796852533, -5.065268938301843],
            [5.977777265900699, -5.074953807080999],
            [5.975298985617298, -5.07894579885332],
            [5.964525577998273, -5.080294304700046],
            [5.957520077373988, -5.076868520313349],
            [5.95353253793346, -5.081592260068256],
            [5.953833516368561, -5.08609468556476],
            [5.9504155790559565, -5.085970609890553],
            [5.947937624001126, -5.089138067289611],
            [5.943272087232042, -5.090649734316056],
            [5.900946324842876, -5.09384747114177],
            [5.846787336520315, -5.097500094005086],
            [5.839652663611051, -5.098284264200786],
            [5.833211244229358, -5.003488980455669],
            [5.830222258358992, -4.960359943247831],
            [5.824369004609374, -4.880309671534366],
            [5.821112309286178, -4.8360547229885755]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.28477971822598,
          "lat": 33.613110170151366
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28155"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00695798"
      },
      "bbox": [
        5.821112309286178, -5.098284264200786, 6.235304568797948,
        -4.790913886304249
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.746629799949061, -0.9449703084736917],
            [4.760981075827108, -0.9451300138661215],
            [4.810434480176214, -0.9421696908573599],
            [4.912959143968745, -0.9371536725657997],
            [4.92195788814232, -0.9364885918832865],
            [4.965451397683166, -0.9341610859561146],
            [4.993772926393851, -0.9328669325666621],
            [5.050644385620672, -0.9288958161567302],
            [5.051975647287997, -0.9572112084761548],
            [5.053402151164164, -0.9734219255845213],
            [5.063343598251426, -1.0296741644061111],
            [5.063607902128304, -1.0712974528244612],
            [5.06190284443629, -1.0750209311874943],
            [5.064031384611676, -1.1066325471389498],
            [5.066551142889173, -1.1664080995441468],
            [5.066420827621524, -1.1685756745640001],
            [5.068486946676325, -1.2058134743265492],
            [5.070321209098818, -1.2303184550996513],
            [5.071972258544982, -1.2609061004712978],
            [5.028183717180713, -1.2618697482020382],
            [5.015224047587193, -1.26147474238585],
            [5.000441780807176, -1.261010159188018],
            [4.930041425522561, -1.2661574699569456],
            [4.914153705121581, -1.267955669128837],
            [4.84149508556123, -1.270669898773415],
            [4.7835859054423, -1.2738104435069506],
            [4.753981877799087, -1.2742696056695877],
            [4.751097694401922, -1.208983153754985],
            [4.748070794415587, -1.1450071301440685],
            [4.7452584062223, -1.0811259743755135],
            [4.742554304471154, -1.0356445731451656],
            [4.739549366856924, -0.9911211011376767],
            [4.748388997561184, -0.990788940516546],
            [4.749159712049633, -0.9895967267695891],
            [4.746629799949061, -0.9449703084736917]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.3450208002062, "lat": 37.478047758551824 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29123"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00758515"
      },
      "bbox": [
        4.739549366856924, -1.2742696056695877, 5.071972258544982,
        -0.9288958161567302
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8204113299029516, 0.43817791617465673],
            [3.819670836608874, 0.5278850668808956],
            [3.8611707171979592, 0.5286543191275578],
            [3.8760430635147527, 0.5287553823672185],
            [3.9308148493552384, 0.5300560359657227],
            [3.956712745199804, 0.530124430249114],
            [3.9891679319987974, 0.5305136278514918],
            [4.0294119198366, 0.5317939259625644],
            [4.0538341195225485, 0.5320197064267398],
            [4.103475489414026, 0.5334028133645048],
            [4.1049638035868545, 0.4780605073999277],
            [4.105198568326202, 0.46290853911754914],
            [4.106442285550263, 0.42959412566532756],
            [4.10776033489852, 0.3849377702924385],
            [4.108692646385802, 0.3555430819170309],
            [4.110080572618226, 0.3483540407632193],
            [4.111168680783668, 0.31040320717884773],
            [4.112939326277256, 0.26588344311565604],
            [4.114756618170455, 0.23473200507261016],
            [4.100529913280055, 0.23365201073476516],
            [4.086249343626784, 0.23379838156417687],
            [4.086175544636206, 0.23535256524279968],
            [4.077042247089202, 0.2343382218638678],
            [4.037725309132336, 0.23162019104173906],
            [3.9984204048224923, 0.23050695765637796],
            [3.9985254760857845, 0.21597676066698268],
            [3.9992710495897694, 0.20557043630519806],
            [4.002156408771975, 0.12401284923962973],
            [4.002852704649933, 0.09372340244314911],
            [3.984195188825455, 0.09222324737286228],
            [3.9729459480409415, 0.0887406152118799],
            [3.9690063758485223, 0.09040423597938596],
            [3.9615030836531724, 0.08955990573925977],
            [3.9559473272591057, 0.09344085454993943],
            [3.951378826483647, 0.09482576635652253],
            [3.9471857854568393, 0.09360254213587646],
            [3.9427383276710564, 0.09053075318241231],
            [3.938518679623407, 0.08367019359955212],
            [3.9387442652849525, 0.07572029831347779],
            [3.923528739221986, 0.06816895801625318],
            [3.9066241917110642, 0.05589174180895701],
            [3.8966947434024615, 0.05517700259454056],
            [3.882757593240815, 0.058780104319605044],
            [3.8736668292296783, 0.05971374466116215],
            [3.858705089791817, 0.06708146270311868],
            [3.851092377248105, 0.07316150294042581],
            [3.843842037006171, 0.07707965831263001],
            [3.8319623082079795, 0.07962847817188055],
            [3.8267314241418275, 0.07898828276103202],
            [3.826719481626994, 0.09190768872899285],
            [3.825478769149126, 0.10645571269725151],
            [3.8258544807644594, 0.12614482223085063],
            [3.8252497624872226, 0.14562311395847166],
            [3.824201219708823, 0.19691096129010477],
            [3.8237545873999976, 0.24069451612143875],
            [3.822067912911624, 0.31724072882518206],
            [3.821789688607758, 0.36286146279995996],
            [3.8216105576559447, 0.3634222576418088],
            [3.8204113299029516, 0.43817791617465673]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.47022261282885, "lat": 38.9414302279736 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29139"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00758524"
      },
      "bbox": [
        3.819670836608874, 0.05517700259454056, 4.114756618170455,
        0.5334028133645048
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.391059949319757, -0.1214185205957744],
            [2.391636248862118, -0.041022284332968416],
            [2.3900967363772327, -0.0410101247730801],
            [2.3901539517866914, -0.03179755484678905],
            [2.391357572945523, 0.0032145164353770193],
            [2.391842004324614, 0.032773240210396015],
            [2.393505440061996, 0.09743745855751369],
            [2.3948325577679905, 0.18032003087403325],
            [2.3957895983030735, 0.22510893498737303],
            [2.3915541188904, 0.2251407406187904],
            [2.391810680115507, 0.2545693434276663],
            [2.3921215076406375, 0.2691287548395498],
            [2.534993565549098, 0.26625209834715036],
            [2.5637506282767397, 0.2660574214878216],
            [2.5677487072672682, 0.2665823327426257],
            [2.6482253541592313, 0.26549857132630045],
            [2.6482842906066213, 0.26610639673405084],
            [2.6782779352604256, 0.2655945877423497],
            [2.6930842482369863, 0.2662299300321987],
            [2.7209736850424266, 0.26560789282289815],
            [2.7359436315609407, 0.2642548409185548],
            [2.736208550771838, 0.25428075442576364],
            [2.7360750184181533, 0.21067201791522266],
            [2.736302794901873, 0.1520150110085679],
            [2.736152943539932, 0.13198839054057937],
            [2.7361079839073863, 0.04704590953297268],
            [2.735955378554537, 0.026692351448133922],
            [2.7357019264486024, 0.018861351367744302],
            [2.7357959056438115, -0.01769382646575868],
            [2.735521783017489, -0.04630503741720767],
            [2.735382612990824, -0.1380768345113464],
            [2.730372699387573, -0.13790701104199302],
            [2.6485201621657914, -0.13658900767779786],
            [2.5624166621739906, -0.13776430400467293],
            [2.5621711201311212, -0.16713422707961267],
            [2.477122507298249, -0.16644225353315018],
            [2.4551719308072086, -0.16614123417213997],
            [2.3908893555181367, -0.16559933270319924],
            [2.391059949319757, -0.1214185205957744]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.28509885373057,
          "lat": 38.728285449400666
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29159"],
        "coty_name": ["Pettis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pettis County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00758534"
      },
      "bbox": [
        2.3900967363772327, -0.16713422707961267, 2.736302794901873,
        0.2691287548395498
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.936626347711642, 1.9480751236720035],
            [2.9576128844316267, 1.949050480666634],
            [2.994287641315723, 1.951391317488169],
            [3.03759073061359, 1.9542453846383423],
            [3.109475889158148, 1.9596650244698812],
            [3.1326642307654633, 1.960893559056719],
            [3.1883239514628836, 1.9642235462098598],
            [3.2100215530822935, 1.9658241867583985],
            [3.2103440129269925, 1.9609767552619795],
            [3.212243913299014, 1.8998571228623626],
            [3.214234465752293, 1.8447222271575254],
            [3.220359955189474, 1.7131902847705063],
            [3.179546319274201, 1.7114568253373774],
            [3.151305603426219, 1.7098812218931487],
            [3.136866414432272, 1.708719401120711],
            [3.095247387089104, 1.706884907021185],
            [3.057126238029743, 1.7048264887071065],
            [3.0096807138866124, 1.7025569680902124],
            [2.968181593451299, 1.700882271915159],
            [2.968948156440571, 1.7029362448625995],
            [2.966672121949896, 1.7084823970205987],
            [2.9682884885284215, 1.7195072197415506],
            [2.9657737759396423, 1.7248259707535336],
            [2.968155824257145, 1.7337320742145468],
            [2.964563165543373, 1.7378890838666265],
            [2.966029898947137, 1.7418421064499972],
            [2.9649965390719704, 1.7520344302775948],
            [2.9726124343734432, 1.7534092697281476],
            [2.9742616839807465, 1.7501876833971022],
            [2.9799111585382434, 1.7548181959055513],
            [2.9785698651546255, 1.756964744567378],
            [2.9722432463123503, 1.759446343376859],
            [2.975825028249121, 1.7682752829382289],
            [2.972251728711869, 1.7715444470893529],
            [2.9697723230971853, 1.7765369696742255],
            [2.966253341835594, 1.7763464879037374],
            [2.9582996410902447, 1.7806864206473954],
            [2.9525879625360334, 1.7863046026550067],
            [2.954657144694083, 1.7911326484588554],
            [2.9508850608346218, 1.797534605920905],
            [2.9462080142594322, 1.7993802894577844],
            [2.9456141749458036, 1.8034469043554728],
            [2.951475374695446, 1.8071833201818044],
            [2.9484079447405587, 1.8134482622733197],
            [2.9456926461098627, 1.8141623323989897],
            [2.945583681925478, 1.8185906994427885],
            [2.9515344212053756, 1.821037782352095],
            [2.950237415228724, 1.823878239475531],
            [2.9514676622004634, 1.8274762952671832],
            [2.9482090370182124, 1.8321191755410802],
            [2.952905135084529, 1.837501117698313],
            [2.9541213335466145, 1.8454156646555617],
            [2.962197447496841, 1.8478669219483106],
            [2.9678027400307707, 1.8544104395878156],
            [2.9629725789922152, 1.8638814341258305],
            [2.962999611151137, 1.8702542688574753],
            [2.9618087312724106, 1.8739292976675779],
            [2.962893618868618, 1.8778219108061134],
            [2.9668145947646156, 1.8749575486138192],
            [2.9720436061371744, 1.8786724369540175],
            [2.9686535158276297, 1.8825245527753307],
            [2.9595566337100085, 1.8827375830660709],
            [2.950251653955901, 1.8863382038583727],
            [2.9460156308661847, 1.891106166665868],
            [2.951677324707415, 1.901207082239753],
            [2.9528440968412237, 1.9072953442909473],
            [2.9604617563818545, 1.9112547907204398],
            [2.9613993628610653, 1.9193668228695777],
            [2.958081119049285, 1.9231500120848561],
            [2.9551467116448746, 1.9236480260209625],
            [2.952173671938448, 1.919368304137516],
            [2.9406177137943863, 1.9155477738649789],
            [2.935496156053524, 1.9165469637590227],
            [2.9361380415802665, 1.9201704165520361],
            [2.9542335087832603, 1.9264569218619572],
            [2.954267053930501, 1.930036156205154],
            [2.9467046164494493, 1.9296795750583038],
            [2.9472723464981376, 1.93673932581092],
            [2.946217720766172, 1.9397501374910764],
            [2.939997069394891, 1.9417719767438],
            [2.933664497211953, 1.941157694812171],
            [2.936626347711642, 1.9480751236720035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.5209560910347, "lat": 40.470252354210466 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29197"],
        "coty_name": ["Schuyler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schuyler County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "00758551"
      },
      "bbox": [
        2.933664497211953, 1.700882271915159, 3.220359955189474,
        1.9658241867583985
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.176871720510908, 9.431710184340387],
            [-9.147977931136364, 9.427618389400164],
            [-9.143111384869174, 9.429409838910255],
            [-9.141757464638335, 9.427237282900277],
            [-9.135132471972685, 9.42972070254164],
            [-9.125435499812598, 9.436399034832794],
            [-9.122067138469113, 9.435533305412592],
            [-9.11639399353988, 9.441176466821986],
            [-9.113511090404982, 9.43719973005263],
            [-9.110855643141925, 9.440735269469434],
            [-9.105412210651968, 9.443276463495872],
            [-9.095370694183268, 9.443983256191233],
            [-9.091932619735168, 9.44668913906017],
            [-9.088061332241846, 9.447418275327086],
            [-9.082443194449915, 9.451195014093052],
            [-9.080537002043172, 9.455709582845692],
            [-9.073462978702747, 9.457648966578962],
            [-9.071567779971625, 9.460311773251586],
            [-9.063908488124161, 9.460831951108823],
            [-9.061056307820436, 9.464424597903909],
            [-9.053938174169648, 9.46620954823742],
            [-9.049738284317, 9.470180314878942],
            [-9.04564411999064, 9.47025149224872],
            [-9.04476755729262, 9.474400758124776],
            [-9.03709008878449, 9.472695407316671],
            [-9.036357976355946, 9.47003255391391],
            [-9.029943404401696, 9.47098945410124],
            [-9.026433984209362, 9.467862617306812],
            [-9.023727977870797, 9.472448721859422],
            [-9.017461838216251, 9.469582938128646],
            [-9.005257241103104, 9.48020310637169],
            [-9.003269510451126, 9.477169312005186],
            [-9.000170868293466, 9.479511801256107],
            [-8.997305806846597, 9.478621960560453],
            [-8.996140054635301, 9.482543587395003],
            [-8.99227353216384, 9.485151662925043],
            [-8.988398585295062, 9.485094686454623],
            [-8.984317221526803, 9.487346828682375],
            [-8.98125465097555, 9.48600688512257],
            [-8.976142431725, 9.489849790374551],
            [-8.97536695017476, 9.496162912765095],
            [-8.96973273812499, 9.497118627013403],
            [-8.965101981107717, 9.495644343423544],
            [-8.96448902257643, 9.498961667270915],
            [-8.96035755039705, 9.49932846638791],
            [-8.95620468464789, 9.503577142537809],
            [-8.947142543428436, 9.506316356171025],
            [-8.944810352555432, 9.503319318208403],
            [-8.937908863552844, 9.502982231770916],
            [-8.92948371980543, 9.504498921727896],
            [-8.921380990813075, 9.51490709729899],
            [-8.918895099755774, 9.517049565015594],
            [-8.91548112382508, 9.515503553307864],
            [-8.909379813864087, 9.523582462916346],
            [-8.911008445995757, 9.527506706937059],
            [-8.908993631444195, 9.532201776196477],
            [-8.908783901883293, 9.537367795810429],
            [-8.910893616721161, 9.539587054092394],
            [-8.907605110073659, 9.549613135558765],
            [-8.909755806461563, 9.554647936538798],
            [-8.907156612875093, 9.558180367870074],
            [-8.909906279182595, 9.561018711511654],
            [-8.908550415932352, 9.564760606258131],
            [-8.90573584898717, 9.564992781640914],
            [-8.903178784855207, 9.569223080024203],
            [-8.90516263802988, 9.572989697880363],
            [-8.901106428637638, 9.573725352258682],
            [-8.903721509993108, 9.57867595913016],
            [-8.898729797312143, 9.582746692192647],
            [-8.9005603657544, 9.585364294454763],
            [-8.895454646573555, 9.591257478642142],
            [-8.892863732270275, 9.596715466647879],
            [-8.893075432095191, 9.601338339798515],
            [-8.888936073121606, 9.602942061349204],
            [-8.893618658702344, 9.606792835746301],
            [-8.886131563117452, 9.619063467175492],
            [-8.890344605250409, 9.625333661604474],
            [-8.88696666336191, 9.627414172171035],
            [-8.884998576010211, 9.637409458797565],
            [-8.888314014916947, 9.643583884520964],
            [-8.88775907885293, 9.646784522322005],
            [-8.88298634047628, 9.649039042209601],
            [-8.884405256427605, 9.66575087694835],
            [-8.882438575167622, 9.66765581609028],
            [-8.882735576505794, 9.675855871401074],
            [-8.878427069854444, 9.67762799711266],
            [-8.875197545169225, 9.683930153714542],
            [-8.871074966180883, 9.682940098639717],
            [-8.864887505431836, 9.678604859120169],
            [-8.85555144545226, 9.677902387983927],
            [-8.845583538943547, 9.67178594552179],
            [-8.83590317061961, 9.67208826027663],
            [-8.83034470336178, 9.669155589450877],
            [-8.825964291681602, 9.663899109667517],
            [-8.82165250075592, 9.664028589058303],
            [-8.80611086948281, 9.660535801976279],
            [-8.802605607899341, 9.662053120828087],
            [-8.796842538676993, 9.667729472391615],
            [-8.786182575169027, 9.673502296231801],
            [-8.782055424646245, 9.678794088147074],
            [-8.780477819805107, 9.682754444475654],
            [-8.773381779906243, 9.686985984740334],
            [-8.76586253515378, 9.687741316544889],
            [-8.751388886379052, 9.685470871460415],
            [-8.740361375932878, 9.687803472268705],
            [-8.730641183946508, 9.683635058590644],
            [-8.727911723445034, 9.67948875362945],
            [-8.7243697692884, 9.678358431605576],
            [-8.720097487099853, 9.680523822748725],
            [-8.716163729467544, 9.685142949000863],
            [-8.70881565100515, 9.689649238152118],
            [-8.703090694304278, 9.690763972696454],
            [-8.698208368515685, 9.687769353479574],
            [-8.686031906622748, 9.684869368090249],
            [-8.68353109967145, 9.681261977416941],
            [-8.6768377448842, 9.678212539500315],
            [-8.665199532887707, 9.683605873879435],
            [-8.662171395766581, 9.6837111761588],
            [-8.657421462165615, 9.681051910911235],
            [-8.654366061882445, 9.674970325675954],
            [-8.64726619429493, 9.671143144299018],
            [-8.643454561498029, 9.66566915349747],
            [-8.639611819147627, 9.66394866212768],
            [-8.634956979204938, 9.664999856446578],
            [-8.63157593232488, 9.663776845553699],
            [-8.628692801420016, 9.65781052840691],
            [-8.622733061619707, 9.655626408421417],
            [-8.618950986731182, 9.657202838971335],
            [-8.610277066964406, 9.65585078621009],
            [-8.607012110055098, 9.650375681090333],
            [-8.603428954126192, 9.649379944410725],
            [-8.5935413698264, 9.652407556162172],
            [-8.587668586980737, 9.657384091601829],
            [-8.578266865766123, 9.661807995667775],
            [-8.576624058811136, 9.66628327532476],
            [-8.573656023551445, 9.667734515924955],
            [-8.564505463329626, 9.666334698336764],
            [-8.548439218131948, 9.671973581077518],
            [-8.543151148778303, 9.672220105407051],
            [-8.537956593913776, 9.674359757417731],
            [-8.527020975604165, 9.674313662063476],
            [-8.522665366988086, 9.675893111274826],
            [-8.517066002743558, 9.682888140555127],
            [-8.513136133801307, 9.68630872433071],
            [-8.50406973160917, 9.68758883787254],
            [-8.500137539273334, 9.690214206585171],
            [-8.499407484680884, 9.700378598305198],
            [-8.495847299544968, 9.704441537531613],
            [-8.491918247788261, 9.706066524338151],
            [-8.486138236313021, 9.704423162399697],
            [-8.479196338789935, 9.705091339368478],
            [-8.474040477758683, 9.70354731178807],
            [-8.462014952095418, 9.703593534358086],
            [-8.453261792722154, 9.700952922251973],
            [-8.448829684572749, 9.697060900744521],
            [-8.441867714395476, 9.697210710153835],
            [-8.436002736794325, 9.696035440865263],
            [-8.429033739745524, 9.692240179547971],
            [-8.42285660595381, 9.687756349496285],
            [-8.421162254595483, 9.684058953711405],
            [-8.41745409879969, 9.682525984258872],
            [-8.39878591940796, 9.681260286040505],
            [-8.394577764156761, 9.683634227354473],
            [-8.385534432399313, 9.686509916181137],
            [-8.379814774837554, 9.687026146958882],
            [-8.374214874863398, 9.689616689786401],
            [-8.364266985423631, 9.691405243768312],
            [-8.358170882021593, 9.694726175573685],
            [-8.351233175668476, 9.694459211654749],
            [-8.338141329785357, 9.684996294050173],
            [-8.33313188159243, 9.683153946979084],
            [-8.325185890794247, 9.6841067989699],
            [-8.317548199766236, 9.688971858665196],
            [-8.312410078985815, 9.68885381737725],
            [-8.307256086262301, 9.690503728794946],
            [-8.30012163263542, 9.688450797850384],
            [-8.295375431744587, 9.688649907698332],
            [-8.289578468057908, 9.686478220366206],
            [-8.284760974340728, 9.67875724405506],
            [-8.28134336733389, 9.676628856727131],
            [-8.269908155939559, 9.674293141318126],
            [-8.267626714320262, 9.672397014992647],
            [-8.268378772996718, 9.66746189822693],
            [-8.274137692615334, 9.662496787461734],
            [-8.27441460194821, 9.656209178496272],
            [-8.265170466262855, 9.645513454633923],
            [-8.261657886844448, 9.642308428642593],
            [-8.259690401334337, 9.638019935328897],
            [-8.261561349207414, 9.63470440066633],
            [-8.267814307923679, 9.630962638912864],
            [-8.273750170290482, 9.629538439805744],
            [-8.27877824225321, 9.626802622920705],
            [-8.282182835661276, 9.621701817319662],
            [-8.28195064395758, 9.618301552477359],
            [-8.278970928888599, 9.613585434221338],
            [-8.274311418790715, 9.612632991093815],
            [-8.26902841091061, 9.616240095473335],
            [-8.261847535639882, 9.61746946384691],
            [-8.249115867321983, 9.616211227128503],
            [-8.242983143498796, 9.61399974170348],
            [-8.22497736619154, 9.60187262203128],
            [-8.22199473884257, 9.598938260814734],
            [-8.216260033976036, 9.596900412838028],
            [-8.210744912289728, 9.593148839286544],
            [-8.208159883872504, 9.58991273783464],
            [-8.199604684422651, 9.583113109879802],
            [-8.196262942518091, 9.578857339335311],
            [-8.193814445453503, 9.571370782112632],
            [-8.189845134853194, 9.565744830099804],
            [-8.185221383629601, 9.56249683953658],
            [-8.178086386304775, 9.553580325753682],
            [-8.17725058733236, 9.547025281458106],
            [-8.179557592126562, 9.541632435502521],
            [-8.184509168040751, 9.535503433873494],
            [-8.183033601135339, 9.528357068353133],
            [-8.174593771274703, 9.516964717891673],
            [-8.171325942107073, 9.514943831675085],
            [-8.163937960598368, 9.513883514127674],
            [-8.159510499622062, 9.516332131258597],
            [-8.151785032517067, 9.515679909381632],
            [-8.144610798246003, 9.517286871513278],
            [-8.142610118329127, 9.516073350225417],
            [-8.135663863738397, 9.507946620443423],
            [-8.134939660434695, 9.499911460705457],
            [-8.129914707504781, 9.495534699002748],
            [-8.126511021166454, 9.494767178106294],
            [-8.118956368147332, 9.495330769640484],
            [-8.114593704051451, 9.49013865816244],
            [-8.110640405375301, 9.48280674916483],
            [-8.105793577554008, 9.482409897798762],
            [-8.100552724187951, 9.483870840069379],
            [-8.08372126484377, 9.479220787013997],
            [-8.07410947899018, 9.480565173750334],
            [-8.069364161020752, 9.482076978612781],
            [-8.065585790548491, 9.480668491441756],
            [-8.062639939939125, 9.47757303839837],
            [-8.060236967745206, 9.472581362319284],
            [-8.051142810345754, 9.470921718655465],
            [-8.047925031229168, 9.465743398995224],
            [-8.045376972201577, 9.464251589512044],
            [-8.028327767217277, 9.466579135231822],
            [-8.02198028293945, 9.46558988763916],
            [-8.01802678784303, 9.467011491666868],
            [-8.013339205899008, 9.471538120904087],
            [-8.00490329242989, 9.464412428400308],
            [-8.00173159532981, 9.458206134780333],
            [-8.004394870792439, 9.453892208398942],
            [-8.0039337680976, 9.450638787530403],
            [-7.997735397545022, 9.4483333823667],
            [-7.991321799947607, 9.448567153142607],
            [-7.981877442074762, 9.444244083620585],
            [-7.974950922974887, 9.448559470293786],
            [-7.971175222982219, 9.45231961555152],
            [-7.97023053300746, 9.456743461848696],
            [-7.966836081568559, 9.460160829949823],
            [-7.962737759714398, 9.460271350085561],
            [-7.955750773260334, 9.456580060477787],
            [-7.955539055395549, 9.451522782793077],
            [-7.957797570759558, 9.448558959271598],
            [-7.956732884307288, 9.445757452965465],
            [-7.952190802541269, 9.444636171256976],
            [-7.946959363954084, 9.44614338013683],
            [-7.945414121375607, 9.43883077329246],
            [-7.947978162796393, 9.434070771313184],
            [-7.951558514008687, 9.431229376194135],
            [-7.949053996887621, 9.42723685375661],
            [-7.940912041920175, 9.426332582962734],
            [-7.9358387853159, 9.429948787884815],
            [-7.935415277580557, 9.433980400595543],
            [-7.931523133751021, 9.435281993051653],
            [-7.922411469452496, 9.430961647010985],
            [-7.918432869410047, 9.425243268700351],
            [-7.919987723400359, 9.420336784757191],
            [-7.918554094952305, 9.416231901954935],
            [-7.911289096826036, 9.413780500971175],
            [-7.903683740539348, 9.416881772116602],
            [-7.900812667717362, 9.410968204483023],
            [-7.901365828165919, 9.403969010698516],
            [-7.896694584245602, 9.402558474929],
            [-7.891561203301002, 9.402662217790025],
            [-7.884774106817017, 9.40511032083665],
            [-7.883366848935536, 9.410678111375057],
            [-7.887793264465353, 9.414903339629486],
            [-7.887678708380444, 9.417301880228534],
            [-7.881219153774879, 9.419159564590421],
            [-7.87612427384744, 9.418528082032974],
            [-7.874139056463729, 9.416480297178726],
            [-7.880952970665414, 9.365388315299642],
            [-7.8825326137430025, 9.365591391218912],
            [-7.893466845830741, 9.282492786202356],
            [-7.910256176095149, 9.15556250621997],
            [-7.924671872405307, 9.15742559353416],
            [-7.925599951900952, 9.150390748767995],
            [-8.011774534979232, 9.161588937835488],
            [-8.01191997877014, 9.16049002014536],
            [-8.097534777092825, 9.171376802880303],
            [-8.102499902336662, 9.135998517552204],
            [-8.189090901596769, 9.14765455253652],
            [-8.200697734209973, 9.063003057059367],
            [-8.212061934502286, 9.064570437870856],
            [-8.223902147993716, 8.981677299346089],
            [-8.137201096366981, 8.970098954892203],
            [-8.1453282050479, 8.911441839742658],
            [-8.173087600552769, 8.715472867615867],
            [-8.18640929768727, 8.717262573542943],
            [-8.19847359151561, 8.632014980365737],
            [-8.262850143748222, 8.640997570458444],
            [-8.327228587916462, 8.649967354222756],
            [-8.391608903518627, 8.658924329392152],
            [-8.455991070044309, 8.667868493723915],
            [-8.520731509162644, 8.677076389191193],
            [-8.585473878052797, 8.686271316710037],
            [-8.657124030818226, 8.69619271833877],
            [-8.714491403969292, 8.704231829454049],
            [-8.722536091907166, 8.64793575215921],
            [-8.829479703671218, 8.662907646295329],
            [-8.897491352877525, 8.672674262766737],
            [-8.965505069735064, 8.682426610433371],
            [-8.965432693228422, 8.682917861238868],
            [-8.958267704362964, 8.731876777012541],
            [-8.965470924349237, 8.732825558337726],
            [-8.960471915348288, 8.768075275513855],
            [-8.981542979654858, 8.770986802597282],
            [-8.979558706034517, 8.785110157104812],
            [-8.986770083461655, 8.786134828844961],
            [-8.985793542669988, 8.793200273312387],
            [-9.007334614219618, 8.796276572297401],
            [-9.006300900779278, 8.80331747627244],
            [-9.009888569850443, 8.803838148824818],
            [-9.006851458196623, 8.824988155382158],
            [-8.981872652004116, 8.821441911665323],
            [-8.97976988349321, 8.828259554198164],
            [-8.975744012528006, 8.856463942452375],
            [-8.972152033945815, 8.85595212349012],
            [-8.970111893293495, 8.870055005465092],
            [-8.959350578210328, 8.868516946962123],
            [-8.957337177130196, 8.882609566385538],
            [-8.943017166853615, 8.880563792076515],
            [-8.930524360190384, 8.966880518650438],
            [-8.92064611104656, 9.034514956346673],
            [-8.902212921307266, 9.162424306011923],
            [-8.980290096622582, 9.173338954083642],
            [-8.974319686122572, 9.215703151028276],
            [-9.06049566555553, 9.22810026246818],
            [-9.054337216971803, 9.270282314973871],
            [-9.140353583812562, 9.28271527432908],
            [-9.127697058252302, 9.367265321085432],
            [-9.185235139853463, 9.37554583300701],
            [-9.176871720510908, 9.431710184340387]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -109.2244751948433, "lat": 47.26358268056769 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30027"],
        "coty_name": ["Fergus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fergus County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01719614"
      },
      "bbox": [
        -9.185235139853463, 8.632014980365737, -7.874139056463729,
        9.706066524338151
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.91851754627406, 10.896238778004571],
            [-12.915434057582866, 10.893543182307116],
            [-12.899349973812594, 10.88234895422767],
            [-12.901329030624261, 10.879402985631822],
            [-12.898906568990652, 10.874713910012858],
            [-12.89985688182676, 10.870508834475398],
            [-12.906879105652616, 10.864271334728995],
            [-12.907258714775574, 10.860881603442463],
            [-12.904578391977894, 10.857736087287044],
            [-12.907245177856275, 10.853690791301075],
            [-12.907792399256747, 10.847617708081716],
            [-12.903262468101776, 10.841659077501806],
            [-12.90406639178353, 10.837012099505541],
            [-12.898231800242273, 10.832738877090076],
            [-12.89430418155314, 10.833621180836166],
            [-12.88865734314259, 10.8312586550675],
            [-12.885203701784267, 10.831797908374986],
            [-12.883936391335654, 10.82845363860957],
            [-12.878994010040858, 10.826987199030253],
            [-12.872043570740926, 10.8197217461856],
            [-12.867752650741597, 10.827483232771907],
            [-12.856791076821786, 10.840946775623907],
            [-12.855553054499374, 10.846424996378186],
            [-12.85141676509429, 10.850261002255218],
            [-12.841697736885518, 10.845919009105364],
            [-12.83303160404333, 10.844971753483225],
            [-12.82572141955619, 10.854737270823712],
            [-12.816914165576575, 10.855853797970802],
            [-12.812197518750889, 10.860466549174236],
            [-12.804764548904044, 10.861317774791495],
            [-12.80133482612442, 10.858756731965212],
            [-12.795017250491275, 10.860109035574565],
            [-12.792697898126589, 10.864518485498365],
            [-12.788216816448136, 10.862455599902649],
            [-12.784961712765517, 10.86443119399198],
            [-12.78111603618175, 10.862048456228578],
            [-12.77648669144583, 10.86175309893087],
            [-12.7733586705999, 10.867236015773818],
            [-12.763797658104414, 10.867215324966473],
            [-12.7622727599585, 10.869246838971312],
            [-12.75348835446872, 10.868413181719841],
            [-12.743174110920597, 10.879668899793328],
            [-12.738416452401145, 10.882088981283378],
            [-12.73266704157756, 10.891411427046567],
            [-12.73319532875383, 10.893775138401532],
            [-12.727144063802854, 10.898992578441353],
            [-12.723908707134466, 10.898835109804994],
            [-12.718087220417097, 10.902020589947558],
            [-12.712595001268673, 10.900708215873276],
            [-12.7079608241268, 10.898085604823992],
            [-12.703838896029925, 10.898352097787534],
            [-12.704748912041858, 10.894011792859795],
            [-12.70067794313699, 10.888862651149427],
            [-12.69386241190651, 10.885623020118807],
            [-12.6931019056395, 10.882919577417999],
            [-12.688823086073096, 10.880486299511052],
            [-12.687722483196808, 10.874139219149763],
            [-12.68357298572445, 10.869529706622759],
            [-12.68482141644127, 10.86491836182114],
            [-12.682893649405498, 10.855538247622825],
            [-12.68028131790975, 10.85347456945414],
            [-12.67801652613519, 10.846018428747211],
            [-12.672739673399304, 10.83537009655323],
            [-12.675842141362361, 10.830525336999504],
            [-12.676335488053935, 10.82423216064967],
            [-12.682753942285467, 10.824715025240035],
            [-12.684446009329998, 10.820950539297236],
            [-12.690317051983023, 10.813772529749542],
            [-12.694269505788741, 10.811049491485086],
            [-12.693665712490914, 10.807818231880692],
            [-12.694948200717047, 10.800749589225655],
            [-12.693360420617543, 10.798457988480756],
            [-12.685395902308906, 10.797476587266774],
            [-12.681978172158928, 10.791760690769268],
            [-12.68153230769888, 10.785847994035466],
            [-12.678548994706839, 10.783706663617824],
            [-12.67527870076113, 10.777150814781782],
            [-12.676030359215403, 10.772311379462813],
            [-12.669933033724718, 10.76292134189145],
            [-12.674458134251587, 10.753951527176765],
            [-12.670206372487716, 10.743047462805203],
            [-12.670154382415348, 10.735946625269692],
            [-12.672958241199813, 10.724998004472521],
            [-12.670267004348323, 10.71769315990214],
            [-12.673845448417982, 10.711489940725894],
            [-12.677156335419577, 10.71107103035008],
            [-12.67627817270075, 10.705020642104346],
            [-12.670550055795921, 10.699662676291897],
            [-12.666178173924214, 10.691817114263506],
            [-12.660926601331404, 10.68738724888775],
            [-12.660993479017083, 10.683914037169746],
            [-12.664671879745347, 10.677325082099777],
            [-12.662728472976559, 10.672209662219046],
            [-12.659642050841583, 10.668429160210831],
            [-12.660724572429329, 10.66288151315268],
            [-12.658394644567586, 10.657679496684407],
            [-12.655333997774553, 10.65713011004055],
            [-12.65230987264235, 10.647442721322664],
            [-12.646303376766353, 10.642999207760868],
            [-12.641947798050543, 10.643718986232356],
            [-12.640674537562134, 10.638639789200193],
            [-12.634342679330583, 10.632093619496706],
            [-12.63272576464982, 10.624004605700806],
            [-12.630707371444114, 10.620745991860222],
            [-12.62990682444668, 10.612613883554022],
            [-12.6312801773864, 10.60144252811116],
            [-12.636696494578183, 10.59072060871014],
            [-12.641296470931808, 10.583570557853475],
            [-12.641264479767608, 10.579997247360266],
            [-12.6451122504919, 10.577898889083553],
            [-12.651053346593699, 10.568042085859414],
            [-12.651219063868052, 10.561422669778409],
            [-12.646329384398197, 10.556501578718906],
            [-12.64551104054195, 10.55285995476973],
            [-12.647476115888209, 10.547172889142425],
            [-12.64327150804517, 10.541990903037002],
            [-12.636954970672749, 10.537118667833264],
            [-12.636147549834703, 10.53182425455388],
            [-12.632484126388329, 10.529824471925613],
            [-12.6264172202345, 10.530504109239779],
            [-12.619059663449635, 10.528496259266822],
            [-12.614270445015526, 10.529610752983615],
            [-12.608139401726273, 10.533442842661097],
            [-12.603520509946758, 10.53208136242388],
            [-12.598789326669394, 10.528384145075892],
            [-12.596031844979017, 10.531931154289161],
            [-12.59172623256703, 10.534025417501674],
            [-12.575978906219818, 10.52301657613341],
            [-12.571698293672489, 10.520630771501963],
            [-12.568450320119764, 10.523171358456707],
            [-12.565764750299836, 10.536616776570437],
            [-12.562396814703343, 10.541425420331972],
            [-12.547615901729454, 10.54075518356644],
            [-12.548036062320127, 10.536387881483346],
            [-12.552051577705836, 10.527040106010427],
            [-12.552137075957145, 10.51809504372757],
            [-12.541698937476406, 10.50775096209291],
            [-12.530401098094403, 10.509406239024385],
            [-12.528304048027184, 10.512471349718801],
            [-12.518298028275577, 10.511052189989117],
            [-12.515242262288567, 10.51379146024453],
            [-12.508161597609288, 10.51437874866488],
            [-12.504036255697148, 10.513335039690206],
            [-12.499653490999744, 10.516232987956649],
            [-12.497234416954193, 10.516036496808004],
            [-12.49304193176715, 10.508036537555943],
            [-12.487512995308757, 10.505001689868404],
            [-12.485327427619769, 10.497145521873266],
            [-12.484854890198019, 10.490402753008123],
            [-12.47855854583141, 10.481090004908303],
            [-12.469733873620765, 10.484557534107507],
            [-12.467956230107767, 10.488539590918048],
            [-12.463466530488917, 10.491246467609677],
            [-12.455995963439069, 10.491407513877615],
            [-12.454526997000436, 10.496485506843312],
            [-12.45189794380539, 10.500239665353362],
            [-12.448330487244114, 10.499313363323528],
            [-12.443509362562295, 10.495474552526087],
            [-12.442492455571884, 10.493049743428427],
            [-12.437614455176277, 10.490766344601354],
            [-12.43154640071006, 10.49491121533667],
            [-12.42752528566011, 10.495465973517422],
            [-12.42248328451318, 10.498654066170948],
            [-12.419775072603851, 10.4949243381201],
            [-12.408848877013032, 10.4958971352427],
            [-12.40930253538117, 10.499200397748286],
            [-12.40319602549757, 10.507465872639129],
            [-12.400435127345496, 10.519693989678457],
            [-12.398840773401117, 10.522397522556007],
            [-12.401234605899763, 10.527891091117421],
            [-12.400611348000528, 10.533236460379747],
            [-12.394383608590736, 10.533396268120924],
            [-12.391849087452519, 10.539180169025586],
            [-12.391012508994175, 10.544662261993656],
            [-12.38758283451811, 10.546934658289574],
            [-12.384915612119356, 10.54422294176823],
            [-12.383817327610629, 10.534927239788237],
            [-12.382357370281625, 10.53252981430419],
            [-12.375680670474804, 10.533262041787276],
            [-12.370613020533252, 10.545966971852371],
            [-12.36637952225013, 10.546834911464398],
            [-12.363779273178453, 10.551456036930896],
            [-12.371070968076559, 10.564159358872264],
            [-12.369301800748632, 10.56936944402354],
            [-12.368454162194686, 10.576066794615159],
            [-12.369153555391405, 10.585877204602193],
            [-12.314697608205913, 10.574841406937505],
            [-12.274083212159463, 10.56678661489523],
            [-12.27694069907821, 10.552950422279107],
            [-12.262892285118962, 10.550154121070948],
            [-12.28849314155938, 10.425543466712746],
            [-12.20352096948504, 10.40867409218624],
            [-12.202941084999082, 10.41152376800329],
            [-12.11792424935209, 10.394751145538617],
            [-12.032912312013407, 10.377953788018706],
            [-12.049379472048356, 10.295836904697463],
            [-12.058030545074516, 10.25426081999441],
            [-12.044486843305076, 10.251553883707317],
            [-12.05892931953014, 10.178806724865296],
            [-12.071929140470047, 10.112798703687421],
            [-11.972437767734188, 10.093703268868312],
            [-11.916384986384971, 10.083086861249308],
            [-11.91548892815497, 10.073304690518697],
            [-11.913279368933138, 10.069703725586052],
            [-11.910026662308955, 10.073878929868926],
            [-11.903737566609225, 10.076865358254542],
            [-11.8987476683078, 10.07352571035786],
            [-11.89826873346478, 10.069796732016293],
            [-11.904093528857743, 10.066427328085936],
            [-11.912454053831551, 10.065275935538814],
            [-11.913918638235867, 10.06287806276194],
            [-11.915169188421627, 10.050181143297845],
            [-11.909851562114131, 10.047309614234274],
            [-11.908728952432869, 10.042120583851228],
            [-11.912501084475581, 10.035161595966725],
            [-11.917202933730824, 10.031614613160315],
            [-11.923237966717368, 10.029173580882944],
            [-11.93243675807936, 10.027887461191565],
            [-11.936171877455271, 10.026117866708251],
            [-11.940965478876084, 10.019483241394957],
            [-11.941143437231588, 10.006800574709647],
            [-11.947425066574334, 9.995626119057267],
            [-11.951523877788924, 9.986095200133521],
            [-11.958213443390655, 9.980301274840606],
            [-11.96095359413709, 9.97160639293087],
            [-11.955684849269439, 9.968905883686329],
            [-11.95276467252341, 9.969437883678255],
            [-11.945900647039279, 9.978004345976576],
            [-11.936479571526931, 9.981849474408481],
            [-11.93323224616, 9.981486528450905],
            [-11.924606237016329, 9.977859378072303],
            [-11.92233723501782, 9.978505802818916],
            [-11.914770838325856, 9.976280349956038],
            [-11.907120505652752, 9.976681892899986],
            [-11.900674178970327, 9.973046153774055],
            [-11.89879546939009, 9.964302248916422],
            [-11.896174561852463, 9.955953097578547],
            [-11.896039031030215, 9.949262165492682],
            [-11.897672664320499, 9.946271921284067],
            [-11.905230385126627, 9.941659236981693],
            [-11.912610206776188, 9.942769174228534],
            [-11.917485102888838, 9.948991236699891],
            [-11.921856732927044, 9.951428098506755],
            [-11.925965413610504, 9.950358214401122],
            [-11.929187358626976, 9.935733795631482],
            [-11.933270113850282, 9.93048884994323],
            [-11.940752420861267, 9.926678087820916],
            [-11.94277873751329, 9.922930568258346],
            [-11.944166985060193, 9.915072961895557],
            [-11.944056752870573, 9.909684825749897],
            [-11.948544990365171, 9.895511465829362],
            [-11.956515931325328, 9.884908996423484],
            [-11.958674692715727, 9.879549564394651],
            [-11.953517953272751, 9.872034586829614],
            [-11.950798810038371, 9.86520263129052],
            [-11.945878989884934, 9.860819164918075],
            [-11.943743654101675, 9.855247248025513],
            [-11.944012551172378, 9.851987857106694],
            [-11.947670427965162, 9.847787562643711],
            [-11.946530893251797, 9.843871816205507],
            [-11.931877688255994, 9.847123280552157],
            [-11.924360940995477, 9.842294531896753],
            [-11.922001971256208, 9.838594372586916],
            [-11.868964262687392, 9.828478197379408],
            [-11.864813054875107, 9.827513331255075],
            [-11.87915123866726, 9.75483118320721],
            [-11.897782483606669, 9.66026176839757],
            [-11.887015436710866, 9.658185580197582],
            [-11.895355855752829, 9.616123120662332],
            [-11.900084258843851, 9.617553009703343],
            [-11.904267801408938, 9.616826785364603],
            [-11.909526120109689, 9.611473041000934],
            [-11.914074132508256, 9.609227138428894],
            [-11.92105237663312, 9.61521792665829],
            [-11.928927749557706, 9.618657361969877],
            [-11.935103356795336, 9.613102162359825],
            [-11.94385092009427, 9.607942235819852],
            [-11.950275469099477, 9.609527155466047],
            [-11.956009115272565, 9.61215144273318],
            [-11.968095245130874, 9.620003109634482],
            [-11.973193023033383, 9.629119846785702],
            [-11.980218683263193, 9.63135430594526],
            [-11.98522819562191, 9.640469959598189],
            [-11.99073674874309, 9.642469739488304],
            [-12.000089125308882, 9.65470035754626],
            [-12.00484466684658, 9.656831200483108],
            [-12.003029535104274, 9.659163414498227],
            [-12.00017991287382, 9.667062949678],
            [-11.993788454581454, 9.667115313950925],
            [-11.990627887948577, 9.668636807103125],
            [-11.9947649751305, 9.673206750366283],
            [-11.9944619377855, 9.679762844292103],
            [-11.997738254109658, 9.686728784759918],
            [-12.002428256320218, 9.685559811508812],
            [-12.008312407094929, 9.688111540597996],
            [-12.016084857033698, 9.689121966864978],
            [-12.019478257112024, 9.694882890207866],
            [-12.024248064097737, 9.69888859479366],
            [-12.029213014120591, 9.700437536218624],
            [-12.034671332780649, 9.708624667757224],
            [-12.040412617807277, 9.7158478411753],
            [-12.04696589461734, 9.71658668241081],
            [-12.048753633263214, 9.718624322327575],
            [-12.055942198594053, 9.719161409871361],
            [-12.059805141446905, 9.717657858884344],
            [-12.06314177961909, 9.725287639161504],
            [-12.068947290904262, 9.73061676947373],
            [-12.073527231470061, 9.730482217023651],
            [-12.07684255944623, 9.732877116756757],
            [-12.083675686379642, 9.734339699506044],
            [-12.087539844476392, 9.738484392687747],
            [-12.089154135612699, 9.74243488228906],
            [-12.093951180791414, 9.743440149634685],
            [-12.099052745909955, 9.74722066232913],
            [-12.10213859006673, 9.753012315883652],
            [-12.105252430323056, 9.755034911547938],
            [-12.107262683429814, 9.759094828954261],
            [-12.114780080309284, 9.760301689215282],
            [-12.117548570894822, 9.770349258069096],
            [-12.117151995403677, 9.772340034537013],
            [-12.123277798262372, 9.773658680601681],
            [-12.12554839363574, 9.776862712851269],
            [-12.136484695355545, 9.781170865943489],
            [-12.144967540944569, 9.783127570429468],
            [-12.149975601137733, 9.787460698088061],
            [-12.159426339903638, 9.791304015464497],
            [-12.164909528214285, 9.795174838500472],
            [-12.168180139397304, 9.799023792107798],
            [-12.172891162744238, 9.798303330925922],
            [-12.179861857674956, 9.802647598855353],
            [-12.184050340900615, 9.803993682114124],
            [-12.187278988561408, 9.80318067034399],
            [-12.193855512166737, 9.807515292933738],
            [-12.201224805714746, 9.809517384854876],
            [-12.20437355814715, 9.811988718952515],
            [-12.210818845697174, 9.807628812360901],
            [-12.215799143049558, 9.80182330048043],
            [-12.218610936573926, 9.800726921350545],
            [-12.22267252949852, 9.795952050973414],
            [-12.22719136984838, 9.796343599311518],
            [-12.231984830772706, 9.802533492461544],
            [-12.240053912971844, 9.807433731521167],
            [-12.24954396927438, 9.810353545189116],
            [-12.256684242638471, 9.807883954272942],
            [-12.27060222121954, 9.814543968365633],
            [-12.27264592168732, 9.819479318022951],
            [-12.279025810963892, 9.821270397433395],
            [-12.309225227689002, 9.827171831212276],
            [-12.303613049966847, 9.855137739230097],
            [-12.34612850461305, 9.863594067524051],
            [-12.343255683377464, 9.877525446224297],
            [-12.38531264550646, 9.886034916180378],
            [-12.373257479707725, 9.945006654083109],
            [-12.377725339981826, 9.950287420519754],
            [-12.378161628377866, 9.959169919413082],
            [-12.375815405527355, 9.966834030959205],
            [-12.377589950524344, 9.968599146390066],
            [-12.391566750160045, 9.97232812670925],
            [-12.398044823118592, 9.976554132759027],
            [-12.399573352415427, 9.980053766319712],
            [-12.399030542660695, 9.984997465794578],
            [-12.404388823038433, 9.991554466579027],
            [-12.408444869606686, 9.99233818997491],
            [-12.419361180991444, 9.989509110137222],
            [-12.41842209645963, 9.995267394989728],
            [-12.42063999572042, 9.997097545271787],
            [-12.430164075406783, 9.999358696181634],
            [-12.438561724546632, 10.006461777905614],
            [-12.442057632965799, 10.01178410295745],
            [-12.447482910384048, 10.014125518326766],
            [-12.450435017714721, 10.013958567915687],
            [-12.465686803319533, 10.009374532877365],
            [-12.467323020007393, 10.010414406259168],
            [-12.47581285823215, 10.020810931005004],
            [-12.48200226464402, 10.025596569543508],
            [-12.48628488934088, 10.0369152661035],
            [-12.48430746131515, 10.04091817949163],
            [-12.491843889558432, 10.046230529388355],
            [-12.494673241122825, 10.049374169340954],
            [-12.500644498239325, 10.052763402033149],
            [-12.505976045180361, 10.05853224728307],
            [-12.512261488511852, 10.061921093271557],
            [-12.518331169326895, 10.062397531222983],
            [-12.525954764548562, 10.067877712873546],
            [-12.531257788241817, 10.073575209206313],
            [-12.530390439930851, 10.078426796440631],
            [-12.538900642829807, 10.08449625200742],
            [-12.547238296686777, 10.086296307823707],
            [-12.548377536669754, 10.088056907592302],
            [-12.555235472247242, 10.090181939879912],
            [-12.559665386507628, 10.095196848687781],
            [-12.570662493880123, 10.091197389673095],
            [-12.576095619670596, 10.087422393725372],
            [-12.578621968193145, 10.083565514214024],
            [-12.58545651579346, 10.085759975240729],
            [-12.590738625560194, 10.085616224657972],
            [-12.598585830392357, 10.088506199197507],
            [-12.603182373837589, 10.088032422670642],
            [-12.605550881393071, 10.093468579167322],
            [-12.609131596915939, 10.098436932829635],
            [-12.615357747043165, 10.102881656623923],
            [-12.620718042596279, 10.104464698916052],
            [-12.625363718401704, 10.103788937276118],
            [-12.63483478013191, 10.108891414871831],
            [-12.639659714551618, 10.109432023749813],
            [-12.647664831359284, 10.105718236737154],
            [-12.65757511025031, 10.10366767268742],
            [-12.65980669748114, 10.104886415569496],
            [-12.669923772876157, 10.10067360254584],
            [-12.671899091398704, 10.096835594793113],
            [-12.674619368993822, 10.097994844510945],
            [-12.678707205695256, 10.104008982891905],
            [-12.683656746181002, 10.102934540769414],
            [-12.688996851942672, 10.104053646431344],
            [-12.693194241921635, 10.107218583065352],
            [-12.697486807518791, 10.108010190382991],
            [-12.700539544112056, 10.111463950003875],
            [-12.700556722420856, 10.11614071019403],
            [-12.705292079483034, 10.12391891734627],
            [-12.705914340637745, 10.128269772437545],
            [-12.709044885017384, 10.133022650011153],
            [-12.715556423901763, 10.13682133837259],
            [-12.720591115352432, 10.135982564634759],
            [-12.718979479816408, 10.127814582557686],
            [-12.726051826669279, 10.119467961912644],
            [-12.732176108722664, 10.118252577530109],
            [-12.739279094408898, 10.119418189324282],
            [-12.752109027761877, 10.118609738562267],
            [-12.758749691036588, 10.120924678123236],
            [-12.772166881274863, 10.123832781472252],
            [-12.777050134174035, 10.127067161397692],
            [-12.781862601851657, 10.12818158758267],
            [-12.784074577140428, 10.133654514365144],
            [-12.784458043641491, 10.138829430467904],
            [-12.792734871764758, 10.135550069610236],
            [-12.795253926497296, 10.137903633118654],
            [-12.802134206253568, 10.13773430164821],
            [-12.80463754055097, 10.136334091561656],
            [-12.813246911770822, 10.138114021971148],
            [-12.813356238910963, 10.143308884271292],
            [-12.816177700443589, 10.149551727398121],
            [-12.82089658599677, 10.148024470119546],
            [-12.829119637559291, 10.148369632257625],
            [-12.82840844124772, 10.164067626128833],
            [-12.833807655333523, 10.166662995419456],
            [-12.838032659026721, 10.180799211410307],
            [-12.839334679263892, 10.182296019968055],
            [-12.83787991546913, 10.188493183771925],
            [-12.82657537508311, 10.190460758639212],
            [-12.829717263867293, 10.1977347427523],
            [-12.832663009868414, 10.199012033754757],
            [-12.836123328531903, 10.197219558253257],
            [-12.843050930855561, 10.199923640333049],
            [-12.848130491746947, 10.203145723445527],
            [-12.850115996043282, 10.206996672472812],
            [-12.854875106655955, 10.206983375832094],
            [-12.861034826930387, 10.21199243767266],
            [-12.862313612484842, 10.218565835953749],
            [-12.860550600192017, 10.22249636992535],
            [-12.852554368011841, 10.227228679396001],
            [-12.84776985615349, 10.231702309931885],
            [-12.841711461814945, 10.235307517631565],
            [-12.835490644224432, 10.236330996602119],
            [-12.833677636582223, 10.240555575361356],
            [-12.823011390800074, 10.240124791802288],
            [-12.821297551524182, 10.246119904311524],
            [-12.81465783335319, 10.249246582755802],
            [-12.807939523276978, 10.25455770108569],
            [-12.809851799045605, 10.257177425055835],
            [-12.810072038690741, 10.261491558917415],
            [-12.812124400188987, 10.263548052609664],
            [-12.81153010374226, 10.271467522624606],
            [-12.806277991244391, 10.275478047004048],
            [-12.806191429933772, 10.282313499308774],
            [-12.812881556804752, 10.294751782227213],
            [-12.815494248729744, 10.295708036287516],
            [-12.826263827908397, 10.305012289833838],
            [-12.827775900663351, 10.3177137639989],
            [-12.822854855821838, 10.323930313147185],
            [-12.822335664346038, 10.329686097362973],
            [-12.817364598820491, 10.334014061680357],
            [-12.81680407374005, 10.342365247625105],
            [-12.810496701287882, 10.35405214867841],
            [-12.814283133429313, 10.365295796319902],
            [-12.829625790390343, 10.382409035694486],
            [-12.832929069199698, 10.381499629395057],
            [-12.839683669515782, 10.383240190233915],
            [-12.842761748835757, 10.389897761584342],
            [-12.844039425342606, 10.396180295977558],
            [-12.842214490241057, 10.402427817644726],
            [-12.83921632768557, 10.407661954548988],
            [-12.841287184292318, 10.413976782053867],
            [-12.845806693722203, 10.41848336224932],
            [-12.847129427630684, 10.423931228883717],
            [-12.851307259070744, 10.425916438224352],
            [-12.85887877542308, 10.425333945982755],
            [-12.866434611690336, 10.423202213709677],
            [-12.870298057912793, 10.42760913304386],
            [-12.87144253939786, 10.433565467289588],
            [-12.869596798805514, 10.442024035907215],
            [-12.870982495382984, 10.452071119814835],
            [-12.874578322636678, 10.457681411536043],
            [-12.871824788160241, 10.465026502859853],
            [-12.872465451654156, 10.472166623159412],
            [-12.870725332257647, 10.475050295982474],
            [-12.87010064366795, 10.482153692165337],
            [-12.866880334759246, 10.485683380515468],
            [-12.869297834717727, 10.492690964290158],
            [-12.868410057052975, 10.49641809889102],
            [-12.872967039531646, 10.503058516324721],
            [-12.879817171958244, 10.508366203163028],
            [-12.881012630785666, 10.51692711828692],
            [-12.884227265063982, 10.523704935715635],
            [-12.898342032637608, 10.520370861617677],
            [-12.90124974419031, 10.524256042295708],
            [-12.90017961363413, 10.528124793611056],
            [-12.9020373601357, 10.531037476467686],
            [-12.907654122980698, 10.532849097937929],
            [-12.907223238412307, 10.536499199681652],
            [-12.912204300504191, 10.551926709317357],
            [-12.914471132332356, 10.554717775421858],
            [-12.91416650629714, 10.560005378765704],
            [-12.91720785993811, 10.566594520067607],
            [-12.91875812863261, 10.567276103559301],
            [-12.922179824001894, 10.576176728605331],
            [-12.925901420927943, 10.580938101104996],
            [-12.931014957845958, 10.583618197193637],
            [-12.92667373131878, 10.593869149135099],
            [-12.928385238399525, 10.59762192848575],
            [-12.934430364696185, 10.599156588030159],
            [-12.937202503292704, 10.601498858119832],
            [-12.937054204050114, 10.607863888070382],
            [-12.94216973798226, 10.61240493627229],
            [-12.94161122582102, 10.619185017149993],
            [-12.943379112421619, 10.625659534889172],
            [-12.947118753693175, 10.63053516615152],
            [-12.946190587817881, 10.637774199203282],
            [-12.951711736813417, 10.651351760888788],
            [-12.955903601348972, 10.657619492303084],
            [-12.956782560899585, 10.661766479854085],
            [-12.96224874360621, 10.661687849153944],
            [-12.96816044944941, 10.668860660079464],
            [-12.951210694365278, 10.746657050339637],
            [-12.937387538620252, 10.80942803395174],
            [-12.91851754627406, 10.896238778004571]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.13333636403169,
          "lat": 47.67482255147623
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30089"],
        "coty_name": ["Sanders"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sanders County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01719578"
      },
      "bbox": [
        -12.96816044944941, 9.607942235819852, -11.864813054875107,
        10.902020589947558
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.544168800038942, 10.546916816198776],
            [-5.48396067907211, 10.54120628752459],
            [-5.423753828450328, 10.535483119890914],
            [-5.3482822414765145, 10.528805680297609],
            [-5.272812387166984, 10.52210840161842],
            [-5.204153306213432, 10.516178768073381],
            [-5.108266573362873, 10.507849457629913],
            [-5.0463345377645, 10.502546528605084],
            [-4.961473913854218, 10.49544749891862],
            [-4.876615406855657, 10.488323418964386],
            [-4.877519723267879, 10.47585526220561],
            [-4.880903343777825, 10.439701622626465],
            [-4.887768629607052, 10.358453524260288],
            [-4.8894667416146484, 10.340695202060454],
            [-4.8974769189566745, 10.243509053857254],
            [-4.905307126280266, 10.149198526532292],
            [-4.906442846433892, 10.133658451760127],
            [-4.909778323417601, 10.099870093006622],
            [-4.9102430821538645, 10.092627414727234],
            [-4.914456344202568, 10.042265890828633],
            [-4.915433278593126, 10.02882826948576],
            [-4.917960941379184, 10.003718590343258],
            [-4.918120655516769, 9.997975189517724],
            [-4.92384088857678, 9.926950717391074],
            [-4.926467674971928, 9.896075836445027],
            [-4.99625415315458, 9.902004591283555],
            [-5.068675563132005, 9.908218380394336],
            [-5.150075822081753, 9.915374096920212],
            [-5.231478112165592, 9.922507449866544],
            [-5.231928055760896, 9.922402276661872],
            [-5.3145096317682485, 9.929755524424351],
            [-5.306680195425799, 10.014220869737901],
            [-5.393308578142637, 10.022247539425985],
            [-5.385409390727873, 10.106244663779272],
            [-5.442379202006688, 10.111497689043112],
            [-5.5290681283762435, 10.119536722705918],
            [-5.52091917267279, 10.203746830695215],
            [-5.564312655972343, 10.207843841599509],
            [-5.539618403220626, 10.459931622745232],
            [-5.552577629675061, 10.46115824943174],
            [-5.544168800038942, 10.546916816198776]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.50467675051148,
          "lat": 48.72123801021696
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30091"],
        "coty_name": ["Sheridan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sheridan County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01677577"
      },
      "bbox": [
        -5.564312655972343, 9.896075836445027, -4.876615406855657,
        10.546916816198776
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2485120615751872, 2.035466723360534],
            [-1.1808327344005467, 2.033931735678796],
            [-1.09284510828203, 2.0319723278212463],
            [-1.0088223533504195, 2.0303167943205715],
            [-0.9085392050031429, 2.0283966279700594],
            [-0.9078308478434189, 2.0283648844048003],
            [-0.9101692798192568, 1.8968927086584695],
            [-0.9124816378602139, 1.7653178149759794],
            [-0.9140672590242117, 1.6775612143985672],
            [-0.9496839182812826, 1.6781454834382463],
            [-1.0011424115036376, 1.6792282102081495],
            [-1.0831590697200624, 1.6811206569949784],
            [-1.1875631255969246, 1.683208636534304],
            [-1.2535014772841868, 1.6846927571985084],
            [-1.2569143416840396, 1.6847623539502514],
            [-1.2560952625259585, 1.7243604492265259],
            [-1.2555486616806553, 1.7358161874612712],
            [-1.2528221876489587, 1.8598380583769636],
            [-1.2507579750819373, 1.947772094090502],
            [-1.2485120615751872, 2.035466723360534]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.05127988455123, "lat": 40.52442201677628 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31035"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00835839"
      },
      "bbox": [
        -1.2569143416840396, 1.6775612143985672, -0.9078308478434189,
        2.035466723360534
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.46378354257383314, 3.073236768373625],
            [-0.3777811782405075, 3.072149474101024],
            [-0.29159632192582347, 3.0710756314211842],
            [-0.20718195416166515, 3.0700032824172374],
            [-0.20838149790567903, 2.9528819300331692],
            [-0.20888262542647948, 2.8945494203325737],
            [-0.20963199462632345, 2.8214848777324137],
            [-0.20992303560846087, 2.7818753615792233],
            [-0.2211203909449033, 2.7816657482082614],
            [-0.23225621656896261, 2.77722216264989],
            [-0.24635630187173874, 2.769267354589872],
            [-0.25379160678919205, 2.7675735538794144],
            [-0.2739595118111562, 2.7521000182791724],
            [-0.27932491152601313, 2.745769273915445],
            [-0.2844690092867548, 2.742788053986126],
            [-0.2920443492090956, 2.739834104297258],
            [-0.29753984791645466, 2.739070445225883],
            [-0.32264035079243003, 2.7388373745113714],
            [-0.33140874374012563, 2.733415077263154],
            [-0.34154889326513416, 2.7261477866305612],
            [-0.34844619900762225, 2.719354008100452],
            [-0.35305518881339504, 2.7180125593674065],
            [-0.3598370812423202, 2.7144503889868092],
            [-0.37042054500973337, 2.714574252834598],
            [-0.3770346368289105, 2.7130183584594123],
            [-0.3867172419378973, 2.7091488550652434],
            [-0.3955208259530178, 2.7095108523882407],
            [-0.39980061762938685, 2.7085550403431564],
            [-0.411462823337728, 2.7041894522920216],
            [-0.4189659742716521, 2.7063033418141957],
            [-0.4289608531028054, 2.713224914043462],
            [-0.43198346533149506, 2.713389941016529],
            [-0.44902427936208233, 2.7112333380194786],
            [-0.46936310087602856, 2.7121065226988357],
            [-0.46849890138270384, 2.723155421002902],
            [-0.46782219860775026, 2.7669432578848485],
            [-0.4673131039805814, 2.810657008741277],
            [-0.46598175808100334, 2.9128447783683393],
            [-0.46511295569177874, 2.985815933071868],
            [-0.46378354257383314, 3.073236768373625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.08645120891296, "lat": 41.57404073523436 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31037"],
        "coty_name": ["Colfax"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colfax County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00835840"
      },
      "bbox": [
        -0.46936310087602856, 2.7041894522920216, -0.20718195416166515,
        3.073236768373625
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5283290857605154, 2.0793275080110263],
            [-2.521423013330612, 2.0787459833586137],
            [-2.4990862383572314, 2.0780691545111387],
            [-2.446819526724003, 2.0759606010205918],
            [-2.4436414910423836, 2.0760248592636157],
            [-2.3587731788423545, 2.0724121257189236],
            [-2.3161774515843714, 2.0707215746240455],
            [-2.312467583087595, 2.069886332675873],
            [-2.3068923300847546, 2.0655382049038526],
            [-2.3023069039301625, 2.064807740944651],
            [-2.2927131950024644, 2.0599935677339563],
            [-2.290872938736936, 2.0573836603792373],
            [-2.282741740867785, 2.0565370178196],
            [-2.274842519058915, 2.0539359645241726],
            [-2.2758756351563294, 2.0244862626836695],
            [-2.281255487839086, 1.8930766262043832],
            [-2.2820241688336163, 1.885329088238765],
            [-2.2831403709051976, 1.848739708264835],
            [-2.2856717565250646, 1.7829586019900936],
            [-2.286798345910538, 1.7176951199585409],
            [-2.3500703084948587, 1.7201871809652247],
            [-2.3920072907688916, 1.7216367337923868],
            [-2.4784862808655497, 1.7252046891119281],
            [-2.505578379503792, 1.726495140210023],
            [-2.5426438104762914, 1.7279858677233846],
            [-2.628384615408858, 1.7316453072700901],
            [-2.628158125134156, 1.7392805054341542],
            [-2.624810312489246, 1.8197165345871071],
            [-2.6102319006631913, 1.818937418643916],
            [-2.538970985942594, 1.8157007247061099],
            [-2.5356343970461253, 1.9035040167128063],
            [-2.532053467415793, 1.9913073950203302],
            [-2.5311591614490423, 2.0057160337428064],
            [-2.5283290857605154, 2.0793275080110263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.83067617361051, "lat": 40.51482147485367 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31073"],
        "coty_name": ["Gosper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gosper County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00835858"
      },
      "bbox": [
        -2.628384615408858, 1.7176951199585409, -2.274842519058915,
        2.0793275080110263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9147218702706048, 3.1047832555340755],
            [-1.843656889096583, 3.102449279147717],
            [-1.8298012259098053, 3.101791553954429],
            [-1.7303558734634628, 3.0986075604737953],
            [-1.6654658659199681, 3.096561493929303],
            [-1.5794757757508158, 3.0940317163242037],
            [-1.5743619302756096, 3.0938735565700424],
            [-1.5753764049085102, 3.0504915272216278],
            [-1.576559431934729, 3.007092173008568],
            [-1.5789590107793352, 2.9055687538428616],
            [-1.5809738662291086, 2.832654309229124],
            [-1.5826506326339889, 2.784153736964279],
            [-1.5825392180575388, 2.781501882284226],
            [-1.5839690114951563, 2.7455083655349086],
            [-1.5957622139518415, 2.7462261429501016],
            [-1.6211647977231618, 2.746890154848625],
            [-1.6705466431233567, 2.748505780982898],
            [-1.6981674274829215, 2.7491515515121216],
            [-1.7984022851147923, 2.752245473950932],
            [-1.9200061072860368, 2.7560830432354058],
            [-1.9268495369064988, 2.7564095333422074],
            [-1.9230612980510644, 2.8636758142810064],
            [-1.9231647202364646, 2.8643329053757083],
            [-1.9185467503837186, 2.992597505740668],
            [-1.9173052594560682, 3.0323795073743542],
            [-1.9147218702706048, 3.1047832555340755]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.98188535559541, "lat": 41.56728926538221 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31175"],
        "coty_name": ["Valley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Valley County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00835909"
      },
      "bbox": [
        -1.9268495369064988, 2.7455083655349086, -1.5743619302756096,
        3.1047832555340755
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.275607576043281, -5.231517142815771],
            [-7.103129784152822, -5.248783220865428],
            [-7.096495981035088, -5.24775459452749],
            [-7.018280643762646, -5.254182582982443],
            [-7.017879026383765, -5.24971216485573],
            [-6.93415199269014, -5.257566798188705],
            [-6.92643202596444, -5.1756946876673],
            [-6.925121391546254, -5.175817339516651],
            [-6.91711298438633, -5.091003747388645],
            [-6.901657440391426, -5.092526191434039],
            [-6.89798607833458, -5.0510869373135465],
            [-6.893404602196546, -5.005216709511722],
            [-6.8990052036702965, -4.9997288718774655],
            [-6.8911218237447285, -4.9173732334655185],
            [-6.885969921066611, -4.864284223117536],
            [-6.8802104235652495, -4.803492156228119],
            [-6.858003011247475, -4.576110673952675],
            [-6.8606583946207635, -4.573671676926582],
            [-6.852644584839049, -4.486306826903684],
            [-6.838955246346983, -4.350570344263377],
            [-6.834826249133632, -4.3097609018990815],
            [-6.819928141617215, -4.31080646513034],
            [-6.747377592074992, -4.318644647190799],
            [-6.755252895864513, -4.406231926720253],
            [-6.576273227535166, -4.425161863949404],
            [-6.371537906079336, -4.445044579023719],
            [-6.239485000519093, -4.456950776113575],
            [-6.231355152459191, -4.369124333698967],
            [-6.1028366195675385, -4.380961327215443],
            [-6.059774699422927, -4.3843988771499145],
            [-5.974365344629459, -4.392046606609898],
            [-5.996377440731047, -4.6549903236860946],
            [-5.975683454913704, -4.656690225451907],
            [-5.893563022469699, -4.66303610804045],
            [-5.903896405105284, -4.778948002331941],
            [-5.908100205104852, -4.826370069913976],
            [-5.776657959511232, -4.8361247947134265],
            [-5.736192581724998, -4.839063083002835],
            [-5.743425198490577, -4.926212787142712],
            [-5.786294980691896, -4.923006238078044],
            [-5.917222888642498, -4.912892408153469],
            [-5.931938392849587, -5.086948309116501],
            [-5.969107189395645, -5.084037825920916],
            [-5.975919803515677, -5.167377482131398],
            [-5.984503454147734, -5.271318994047543],
            [-5.990128453633236, -5.339607917734254],
            [-5.997382693344729, -5.426566623987669],
            [-6.004484490506369, -5.5135992970875165],
            [-6.044458407683845, -5.510481319695866],
            [-6.240921553016098, -5.493838754626826],
            [-6.2879396684224815, -5.489864735204462],
            [-6.492723079219753, -5.4730922592460605],
            [-6.499513159890739, -5.472357557074265],
            [-6.656120866808756, -5.45905549203258],
            [-6.690760931520717, -5.456121217419547],
            [-6.897690597278698, -5.437779620449696],
            [-6.937653171241084, -5.858662375342506],
            [-6.939553044180548, -5.878954135751216],
            [-6.947361304456647, -5.87822804926503],
            [-7.071624512370288, -5.86640590062057],
            [-7.1958858721694225, -5.854564499687543],
            [-7.19606642603685, -5.856424557177761],
            [-7.366928777271394, -5.839905138415067],
            [-7.35795923613309, -5.754361084304129],
            [-7.356740438015946, -5.754453651926904],
            [-7.34272099443939, -5.610948134020969],
            [-7.332828876128197, -5.521731698038842],
            [-7.33108921799119, -5.493546140846389],
            [-7.321875924053391, -5.398450146993264],
            [-7.291607661979111, -5.401325550449877],
            [-7.287754394841479, -5.360812006832508],
            [-7.275607576043281, -5.231517142815771]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.46692062127147,
          "lat": 33.363287697302404
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35005"],
        "coty_name": ["Chaves"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chaves County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01702364"
      },
      "bbox": [
        -7.366928777271394, -5.878954135751216, -5.736192581724998,
        -4.3097609018990815
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.925246434460895, 5.578713824282713],
            [15.942963118838133, 5.631052618518492],
            [15.958583808495195, 5.698219334468181],
            [15.951024370170025, 5.718107223599631],
            [15.915601864787353, 5.791845359280967],
            [15.904553713479006, 5.813201637731066],
            [15.90107622090489, 5.826662519887973],
            [15.896888045247287, 5.854088571528615],
            [15.900557413788782, 5.89322845903898],
            [15.938737828135478, 5.891719031133082],
            [15.965294358561945, 5.890891325372883],
            [15.99838286423163, 5.882751562039918],
            [16.050771385100315, 5.869445696964906],
            [16.140951640917656, 5.900933038197382],
            [16.16593154145817, 5.907092105461727],
            [16.18159809416619, 5.9237937348983145],
            [16.18876072963115, 5.923367022717691],
            [16.18998717519157, 5.9195715335016335],
            [16.194586510910018, 5.916890278483979],
            [16.195164093740136, 5.914644694340638],
            [16.192629459122518, 5.905258906845047],
            [16.193467358599438, 5.901580701449189],
            [16.196950980533934, 5.896078276260387],
            [16.193940731677383, 5.886444243383703],
            [16.190568066168723, 5.8837819626322565],
            [16.185975319719823, 5.884569115491592],
            [16.17385685077058, 5.881063382818338],
            [16.16967366262708, 5.879147718799558],
            [16.162210097408796, 5.87374957754604],
            [16.163076290343547, 5.868869356372473],
            [16.188842097093936, 5.846294920504502],
            [16.19385620192797, 5.847527327295193],
            [16.193972100867835, 5.842136819203451],
            [16.215631235075048, 5.849812308944845],
            [16.215989997739662, 5.852019592780445],
            [16.244250297689348, 5.850254519885012],
            [16.2569647632247, 5.854922798700321],
            [16.255824188990353, 5.872627886917147],
            [16.269838711374618, 5.862760471581684],
            [16.272311360508397, 5.836774157847275],
            [16.276929652638863, 5.820317383428883],
            [16.27765271285273, 5.813409148547044],
            [16.275639914696583, 5.791310102158015],
            [16.27063144913189, 5.770289461683473],
            [16.27181882368217, 5.762268904756077],
            [16.266112383349316, 5.749050398485279],
            [16.263820030490702, 5.7418961200866665],
            [16.261315250841104, 5.737659702752683],
            [16.259524518095517, 5.731045592639023],
            [16.260424374634624, 5.725091887214536],
            [16.252868622648407, 5.713341289303959],
            [16.253154144063856, 5.70048984297667],
            [16.254312188055312, 5.697669778277961],
            [16.25315178468376, 5.687820031845261],
            [16.257177066279755, 5.681612503758925],
            [16.26704349277845, 5.668655063640956],
            [16.27008712060075, 5.666659925312475],
            [16.274633931852428, 5.649355999299263],
            [16.275720360975217, 5.640026606151339],
            [16.27536373608913, 5.6349540092444625],
            [16.271732365320734, 5.6249359829557966],
            [16.27110018206886, 5.610984565651897],
            [16.269485790985364, 5.608703450135247],
            [16.26948293603081, 5.583182826964199],
            [16.266454543699975, 5.55651838051213],
            [16.270322563160033, 5.544042691743382],
            [16.276624739707657, 5.546614045862855],
            [16.290582362433998, 5.517910903523977],
            [16.288458992864413, 5.519468829918362],
            [16.27996456978166, 5.517498706143308],
            [16.276404880251782, 5.511951014373988],
            [16.274824273179906, 5.5052005616746875],
            [16.27089297324087, 5.499141273435099],
            [16.265973000568447, 5.496368596794285],
            [16.25968664799425, 5.49434694375347],
            [16.25475175328052, 5.494609465969194],
            [16.24888913386692, 5.4904165906543785],
            [16.246624199435633, 5.487087770755149],
            [16.242442681067057, 5.489121884477181],
            [16.23723212624899, 5.487739930181695],
            [16.234558817583213, 5.484592962075469],
            [16.226009667709434, 5.483754423246258],
            [16.222982910178143, 5.4801880169098975],
            [16.213019622421918, 5.487110347746353],
            [16.20136652477681, 5.490068827676613],
            [16.198064506466846, 5.489832291598494],
            [16.19528036572007, 5.492500355285389],
            [16.15345879279374, 5.463485975785925],
            [16.127043698718303, 5.470956382184539],
            [16.012396708538716, 5.502537788383994],
            [15.925246434460895, 5.578713824282713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.44211130913774,
          "lat": 42.588207958661485
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36095"],
        "coty_name": ["Schoharie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schoharie County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00974145"
      },
      "bbox": [
        15.896888045247287, 5.463485975785925, 16.290582362433998,
        5.9237937348983145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6282519782506613, 7.977165384829711],
            [-1.6269411556782154, 7.977431012490593],
            [-1.5147587091073709, 7.97415452121672],
            [-1.390779540167058, 7.970739498336937],
            [-1.3036193543293573, 7.968384201309186],
            [-1.216652880486679, 7.9663176548312915],
            [-1.1105944312961078, 7.963801507556369],
            [-1.0239150527817256, 7.961677574605336],
            [-0.9375488314333787, 7.959424215201725],
            [-0.9391446143451917, 7.8733744429240975],
            [-0.9429532844325352, 7.7303051886446905],
            [-0.9438409248675139, 7.701838658135954],
            [-0.9440219312408192, 7.6873123826787415],
            [-0.9454562263189413, 7.6156303102665515],
            [-1.0121172377573502, 7.617171375859741],
            [-1.0886109885092896, 7.619021390598468],
            [-1.1770228110157566, 7.621296519678787],
            [-1.2108101319675644, 7.622028221652831],
            [-1.2696751148984742, 7.623569512884582],
            [-1.380581241339871, 7.626298326108507],
            [-1.458503340425153, 7.6286470544501315],
            [-1.4811942450866007, 7.629443413765656],
            [-1.5162267641172364, 7.630301811973337],
            [-1.6143833551362603, 7.633533152536893],
            [-1.6161173124354231, 7.633489503540138],
            [-1.6397758341106208, 7.634208176260762],
            [-1.63708427281937, 7.720417638032066],
            [-1.6333786686645617, 7.828540096524453],
            [-1.6309540537408733, 7.8918481022727045],
            [-1.6282519782506613, 7.977165384829711]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.53544980653625, "lat": 46.45689022059837 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38045"],
        "coty_name": ["LaMoure"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["LaMoure County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01035621"
      },
      "bbox": [
        -1.6397758341106208, 7.6156303102665515, -0.9375488314333787,
        7.977431012490593
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9375488314333787, 7.959424215201725],
            [-0.85147200545326, 7.957322079761235],
            [-0.7650014355311883, 7.95539582693914],
            [-0.6951693653434579, 7.95394236242239],
            [-0.5920539689898872, 7.951841171843567],
            [-0.4980619544934431, 7.950288607299699],
            [-0.41817682161870556, 7.949094844447122],
            [-0.41926331950376217, 7.863910124420765],
            [-0.42094293417166406, 7.76368055206339],
            [-0.42116689472122165, 7.741716223656001],
            [-0.4221744435802248, 7.692890728196577],
            [-0.4226299954997578, 7.649357532966665],
            [-0.42326393335765844, 7.606341472304923],
            [-0.5103650371208314, 7.607586621881574],
            [-0.6121644978075234, 7.609194391898779],
            [-0.6847003396353226, 7.610301329699445],
            [-0.7717801430069283, 7.6120225707723845],
            [-0.8586910396449837, 7.613518372967098],
            [-0.9261762287100685, 7.615193306408325],
            [-0.9454562263189413, 7.6156303102665515],
            [-0.9440219312408192, 7.6873123826787415],
            [-0.9438409248675139, 7.701838658135954],
            [-0.9429532844325352, 7.7303051886446905],
            [-0.9391446143451917, 7.8733744429240975],
            [-0.9375488314333787, 7.959424215201725]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.65742446703048, "lat": 46.45614769087155 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38073"],
        "coty_name": ["Ransom"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ransom County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01035301"
      },
      "bbox": [
        -0.9454562263189413, 7.606341472304923, -0.41817682161870556,
        7.959424215201725
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.10661951815812014, -3.4410076858949266],
            [0.13531268204210373, -3.4410739241240003],
            [0.23548605754454252, -3.4415687628958676],
            [0.3215548864761585, -3.441795826627422],
            [0.4101426265015608, -3.442101727864445],
            [0.4787000387152201, -3.4421783304035403],
            [0.47880782257194304, -3.5297041904063327],
            [0.47740564363454446, -3.5298141936509717],
            [0.477457745033723, -3.5812082589736107],
            [0.45960587390394697, -3.5841539886937586],
            [0.4537761849102877, -3.587888320313141],
            [0.4526829354547364, -3.591183084780511],
            [0.45654001806870503, -3.610900241707844],
            [0.45533691912107194, -3.615694792637953],
            [0.4524911393346538, -3.6165802774960856],
            [0.4424581667568309, -3.612525402407367],
            [0.43943739526732706, -3.6127741603135877],
            [0.4297899954826379, -3.6288646070715838],
            [0.41917917809208294, -3.6359548299039997],
            [0.4143011497393895, -3.641711630994543],
            [0.41286780289933867, -3.64524081741713],
            [0.4115614603528089, -3.662287244354903],
            [0.4075454588905978, -3.6769285912998626],
            [0.4042933312225483, -3.6801228770444916],
            [0.39166986052302594, -3.683669169393217],
            [0.39134371002126245, -3.7828983863710373],
            [0.3914764535555669, -3.7852110192291],
            [0.3913102360624152, -3.8800405619663985],
            [0.3889754070565768, -3.8802395686597593],
            [0.388789525413217, -3.967820927164412],
            [0.2540178105963978, -3.9682175715758716],
            [0.22516945661059248, -3.968108105980122],
            [0.1325905014066569, -3.967302576314728],
            [0.1331422161726909, -3.881695598940517],
            [0.1335930393684383, -3.7994230218392673],
            [0.13078176813415765, -3.8041817864410983],
            [0.1298386018297956, -3.8115335868398166],
            [0.1272961059851299, -3.818084403240822],
            [0.11836337883997328, -3.830051557338751],
            [0.10950418997104333, -3.831427314888625],
            [0.10819263107339194, -3.8289117699633057],
            [0.10382602470497027, -3.8272574805530444],
            [0.08942176409664851, -3.8170251123114123],
            [0.085066292353624, -3.818287922820625],
            [0.07500673618463469, -3.817102022362819],
            [0.06465789438609888, -3.8228524491517963],
            [0.06540414071006932, -3.7114442396978684],
            [0.06601241168639843, -3.6162626381961913],
            [0.10585389078085788, -3.616544111862528],
            [0.10621780755382504, -3.5580046295123955],
            [0.10661951815812014, -3.4410076858949266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.25018383582967, "lat": 35.04835390021018 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40063"],
        "coty_name": ["Hughes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hughes County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01101819"
      },
      "bbox": [
        0.06465789438609888, -3.9682175715758716, 0.47880782257194304,
        -3.4410076858949266
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.3008897452600614, -4.401401989322817],
            [-0.25803924414383594, -4.401391707632703],
            [-0.2569316483914458, -4.300118381009353],
            [-0.256246341135826, -4.227432162329649],
            [-0.21255808459754502, -4.227814641050667],
            [-0.15549767017118957, -4.228404726824991],
            [-0.05043755719698604, -4.22942536174916],
            [0.0437463053498285, -4.23028764552597],
            [0.043294153742710624, -4.316564491876916],
            [0.09202440716855426, -4.3168300342920745],
            [0.09297544409380648, -4.318009598754928],
            [0.13060229734671366, -4.318171333212725],
            [0.13043430982560777, -4.366049819758577],
            [0.12970121262616052, -4.493182396780125],
            [0.12911154574546868, -4.580504106695438],
            [0.09102421117354179, -4.580300915839026],
            [0.09086948125829489, -4.623741944178497],
            [-0.015930762211785687, -4.622945875921092],
            [-0.017182776300828987, -4.622792556888588],
            [-0.014212487791118203, -4.615809759855796],
            [-0.014565496244385523, -4.611892229115843],
            [-0.019746682985744547, -4.6104380972559245],
            [-0.02979913626007881, -4.601495811598132],
            [-0.02797391422119389, -4.596671651562654],
            [-0.03147614597459854, -4.5913879685839305],
            [-0.03465531993416404, -4.597155773150851],
            [-0.04037271281441464, -4.5950026880795605],
            [-0.03703857504727121, -4.590092929308438],
            [-0.03975743480722053, -4.584960452728005],
            [-0.04471861718510683, -4.582857042838428],
            [-0.04516105551389805, -4.575673674295159],
            [-0.04967649230393823, -4.57631121626071],
            [-0.05248005333610058, -4.583152820461194],
            [-0.06272987901744699, -4.5783632158381256],
            [-0.06200185050864716, -4.573795373313065],
            [-0.0590770868582735, -4.572329212700542],
            [-0.060562118592947925, -4.568628495042653],
            [-0.06448597538269975, -4.568639284932506],
            [-0.06951000843021991, -4.573915366567952],
            [-0.07501725998433802, -4.575471896113445],
            [-0.08262504084298623, -4.5677693875241925],
            [-0.08609988293048566, -4.5674487066134715],
            [-0.08628249404552865, -4.564013760269561],
            [-0.15391529565105985, -4.563483179958865],
            [-0.26654463524141414, -4.562587739491568],
            [-0.30263389840547555, -4.561966441445644],
            [-0.30183672129546674, -4.488717313794279],
            [-0.3008897452600614, -4.401401989322817]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.66058631237271, "lat": 34.31651476954691 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40069"],
        "coty_name": ["Johnston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnston County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01101822"
      },
      "bbox": [
        -0.30263389840547555, -4.623741944178497, 0.13060229734671366,
        -4.227432162329649
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8192353955976907, -4.657266931805101],
            [-0.7417617035768282, -4.65845660434954],
            [-0.6001166169272842, -4.66061858978826],
            [-0.4956817521895418, -4.6620608608121685],
            [-0.40393448893631834, -4.6631703112482725],
            [-0.3333352511059196, -4.66384466789722],
            [-0.3340218134572271, -4.722153735957467],
            [-0.30530972376536414, -4.722463545305303],
            [-0.3058553134910134, -4.7812716106991395],
            [-0.31399142425070525, -4.786354073949798],
            [-0.32037933006719266, -4.7909442803561495],
            [-0.33712557855189995, -4.799597666319569],
            [-0.34074228328489875, -4.797896041209564],
            [-0.343056815613303, -4.793720650890182],
            [-0.3439768398190412, -4.786108592014046],
            [-0.3425284160671105, -4.780129246242789],
            [-0.3441536857915942, -4.7788594625338945],
            [-0.3495678254918364, -4.780517511745298],
            [-0.3558001656633549, -4.7878516097816775],
            [-0.35653003496860525, -4.793440513866708],
            [-0.35567714686091945, -4.803181393328526],
            [-0.3506494936130883, -4.8168548149110295],
            [-0.34765676471621343, -4.8305415621696115],
            [-0.3468924490401635, -4.844520971178073],
            [-0.350411207139758, -4.849439813891042],
            [-0.35802253690489994, -4.864414605236644],
            [-0.3686655219657555, -4.875600790114407],
            [-0.3783568738511068, -4.888931493071442],
            [-0.3928071078358508, -4.8969210794767575],
            [-0.3987850240193981, -4.895554862758691],
            [-0.40268580992079306, -4.888477489846473],
            [-0.406611106251252, -4.879226259158918],
            [-0.4098684546805849, -4.876516964925526],
            [-0.41664114409782166, -4.874372534977707],
            [-0.42288470118398863, -4.876113280185228],
            [-0.4325275672664839, -4.881236863982544],
            [-0.43529121686163297, -4.889845039962841],
            [-0.4295468558334709, -4.894312093753429],
            [-0.41804608808620924, -4.895489824463359],
            [-0.4088888224997799, -4.898249941694646],
            [-0.40453550430623975, -4.901188951994025],
            [-0.40152366830839276, -4.905327483246655],
            [-0.40069599166708325, -4.917720587097092],
            [-0.41265802520012296, -4.918970351464572],
            [-0.42585669714921287, -4.922157535752392],
            [-0.4336629199710442, -4.926092714383004],
            [-0.43710907711644387, -4.930720484383538],
            [-0.43936687666644314, -4.936280054788995],
            [-0.43877232841642416, -4.945801522312684],
            [-0.4339411494030577, -4.9608639189554244],
            [-0.4318664629491268, -4.969505367543714],
            [-0.43157535325583507, -4.981917703180227],
            [-0.43292112899049184, -4.991148928213757],
            [-0.4370489099039564, -4.999950752267414],
            [-0.4421549347529457, -5.007223663197869],
            [-0.4483016069960081, -5.012371785012247],
            [-0.45556305500143174, -5.016104541199032],
            [-0.46618523020326946, -5.017849309634427],
            [-0.47560115483103715, -5.016008654294749],
            [-0.48535741428125995, -5.012577284600046],
            [-0.4966242055514524, -5.005060146210775],
            [-0.5039881117561404, -4.996718221399728],
            [-0.5117257733710231, -4.9782329014383695],
            [-0.5146041969583489, -4.97856549777908],
            [-0.5207159987612878, -4.972803076813485],
            [-0.5164038289004469, -4.964163765566707],
            [-0.5187988267076147, -4.952149684700317],
            [-0.5266424916273573, -4.940583643736965],
            [-0.5308188054033479, -4.9307852221145305],
            [-0.5300296367298329, -4.918428463045193],
            [-0.5287702991534214, -4.911823713566369],
            [-0.525555252277705, -4.906346585696477],
            [-0.5205491369337325, -4.902409388843837],
            [-0.5103900240073158, -4.902467608704895],
            [-0.5023074077333431, -4.898592360600659],
            [-0.49828478818461414, -4.89356252548986],
            [-0.49803850549303463, -4.886623265153487],
            [-0.5081769050541116, -4.8413857236611975],
            [-0.5128896533190455, -4.832843996958248],
            [-0.5297546467892246, -4.818998619175145],
            [-0.5336688071530674, -4.817157897513485],
            [-0.5465367845922138, -4.818421149828459],
            [-0.5594710821324866, -4.826652094321013],
            [-0.5629168735847604, -4.832563685975354],
            [-0.5657463926333478, -4.85786880493354],
            [-0.5700181212074066, -4.867628699297604],
            [-0.5720150094649384, -4.869647292063879],
            [-0.5790009865878137, -4.870431317467933],
            [-0.5833654987866301, -4.874581482115157],
            [-0.5877289143776834, -4.874576453066203],
            [-0.587447077896571, -4.86950370153306],
            [-0.5961400354471801, -4.864065444153643],
            [-0.6120302732469971, -4.845870585785309],
            [-0.6157731327655191, -4.843714008732132],
            [-0.6158063585603446, -4.85785176632486],
            [-0.6195913779123611, -4.865288732723665],
            [-0.6227739394242122, -4.867120060548437],
            [-0.6275610416820446, -4.873212504921255],
            [-0.631552509151963, -4.87672270891109],
            [-0.6363795194189873, -4.874851385080301],
            [-0.6352646484823117, -4.867923212120665],
            [-0.6268782298361822, -4.853672244923708],
            [-0.628748283780804, -4.848196983992929],
            [-0.6342183474811811, -4.8477543220678045],
            [-0.6371395907758028, -4.852818418309492],
            [-0.6400909074470864, -4.869948678445634],
            [-0.6478806201997932, -4.888095967248726],
            [-0.6564682405602151, -4.901884910811864],
            [-0.6623255122589277, -4.908079946140605],
            [-0.6685182376997372, -4.912316304132816],
            [-0.6994066530048015, -4.912476948435013],
            [-0.7126799251317331, -4.911724483042338],
            [-0.7272089241124445, -4.907114305384991],
            [-0.7344446725829482, -4.9022233285874925],
            [-0.7393074484567339, -4.896081046865715],
            [-0.7423198592683089, -4.888816352928839],
            [-0.7410689837867087, -4.881017530091754],
            [-0.737793746343059, -4.875480113024259],
            [-0.7324831277602122, -4.85969551863227],
            [-0.7317439462887229, -4.839158041676712],
            [-0.7393121380761162, -4.82644248000465],
            [-0.7586167745103438, -4.814283089926311],
            [-0.7674733772821787, -4.810634496449924],
            [-0.7724926397894973, -4.8101691033582314],
            [-0.7926466897350432, -4.81777328218753],
            [-0.7988635659820422, -4.822868475589408],
            [-0.8076177855493357, -4.8280365630027315],
            [-0.8145057328243434, -4.8312802121804035],
            [-0.8200629679348165, -4.832041008604223],
            [-0.8221864703139008, -4.829506500815126],
            [-0.8206631262845947, -4.744808342348813],
            [-0.8009773515053128, -4.745215428382468],
            [-0.8053661659215039, -4.741026212826762],
            [-0.8077702457320189, -4.741376940980034],
            [-0.8110382044211658, -4.735114657952929],
            [-0.8155799198692985, -4.730531601978469],
            [-0.8168101290188626, -4.7267706149133915],
            [-0.8204546684102415, -4.725716807753608],
            [-0.8192353955976907, -4.657266931805101]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.24413962315873, "lat": 33.94991435106336 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40085"],
        "coty_name": ["Love"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Love County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01101830"
      },
      "bbox": [
        -0.8221864703139008, -5.017849309634427, -0.30530972376536414,
        -4.657266931805101
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.295015498584073, -3.8766024316460266],
            [-0.2937415149781051, -3.8764780525565974],
            [-0.29242530224156105, -3.7660695276081433],
            [-0.2848739684715619, -3.7665233547411807],
            [-0.27896103271392075, -3.7715528807818597],
            [-0.27624823720640235, -3.7719673272954997],
            [-0.27031232140144645, -3.784670867099546],
            [-0.2652145657104716, -3.7886458136901378],
            [-0.2601763723909949, -3.7983267368920295],
            [-0.2597485217779478, -3.80150668921931],
            [-0.2560677130762177, -3.8047712654274815],
            [-0.24868655164141937, -3.8050629259515216],
            [-0.24197206342537303, -3.801717032176591],
            [-0.23617719045887106, -3.8011004282359417],
            [-0.22974627081093635, -3.8024272541782476],
            [-0.22020928199543835, -3.797502628659139],
            [-0.21497407241297764, -3.7918830693480214],
            [-0.20393709892643222, -3.7852516596562964],
            [-0.20070130231656175, -3.7850611225624258],
            [-0.19606455167988093, -3.787943698058818],
            [-0.18968775288047557, -3.794832789468291],
            [-0.1851528983852454, -3.801633383090661],
            [-0.18492201022604976, -3.807237418104976],
            [-0.18618900166513144, -3.8117078265245863],
            [-0.18674777349618926, -3.8212718587947543],
            [-0.18566155498999998, -3.825833321897657],
            [-0.17920874860827576, -3.831024086338581],
            [-0.17472891894672743, -3.8327606915514147],
            [-0.16708746830909235, -3.83200521584985],
            [-0.15485980949120082, -3.831216314223055],
            [-0.15069051090833702, -3.8322869355001203],
            [-0.14529795908371257, -3.841914908358505],
            [-0.14406399828882613, -3.8504774317379886],
            [-0.1400131235325906, -3.8629859010597016],
            [-0.13325386402593975, -3.8727971046085243],
            [-0.12977054239914915, -3.8749387974686655],
            [-0.12448768492538476, -3.875783990538037],
            [-0.11592517386540518, -3.872931652507612],
            [-0.10104087464228766, -3.864173192646974],
            [-0.10163862146681144, -3.862027689834234],
            [-0.09792198931543593, -3.857653668842173],
            [-0.09465956611500831, -3.849438512630538],
            [-0.09448468620742621, -3.8440454808062627],
            [-0.09678303940771243, -3.836948095772095],
            [-0.10200770455398366, -3.828829011412674],
            [-0.10834155936703628, -3.8230559020463724],
            [-0.11434389587210081, -3.8205862434986666],
            [-0.11476313768736304, -3.815987477651365],
            [-0.11064087328436074, -3.808268779423029],
            [-0.10489920561321447, -3.8019815511861457],
            [-0.09876289146705883, -3.7989661974363167],
            [-0.09194232765956231, -3.799296205717636],
            [-0.07905640315261694, -3.802861363880157],
            [-0.0745299821294133, -3.806616249045429],
            [-0.07123101279673325, -3.8115699062972754],
            [-0.06731904980908975, -3.8222662982462814],
            [-0.06160744674059884, -3.8313574556109344],
            [-0.05739237369980634, -3.8332977754711757],
            [-0.0512168904763418, -3.8342446820363176],
            [-0.04202438740300373, -3.8339027492085602],
            [-0.03493927831251843, -3.8324393321381667],
            [-0.02075407424175488, -3.8269950347566604],
            [-0.005481776163882389, -3.816422760054561],
            [0.005092380180025264, -3.8157817158223675],
            [0.010928147948952048, -3.81893546672559],
            [0.012190445839600654, -3.8256847221231203],
            [0.011647099009070508, -3.8351401627192865],
            [0.016714048339172602, -3.84620974281866],
            [0.021405054696343417, -3.853295121008239],
            [0.02947453251658439, -3.8613026549847267],
            [0.033690408288933854, -3.863940186867112],
            [0.03946927170937169, -3.8636691824574356],
            [0.04313885332831794, -3.8619797078110607],
            [0.04672983322268678, -3.858095166921821],
            [0.0520052636119269, -3.847036202313187],
            [0.056841357463621324, -3.8400384382048784],
            [0.05876071816581583, -3.830771130936323],
            [0.06465789438609888, -3.8228524491517963],
            [0.07500673618463469, -3.817102022362819],
            [0.085066292353624, -3.818287922820625],
            [0.08942176409664851, -3.8170251123114123],
            [0.10382602470497027, -3.8272574805530444],
            [0.10819263107339194, -3.8289117699633057],
            [0.10950418997104333, -3.831427314888625],
            [0.11836337883997328, -3.830051557338751],
            [0.1272961059851299, -3.818084403240822],
            [0.1298386018297956, -3.8115335868398166],
            [0.13078176813415765, -3.8041817864410983],
            [0.1335930393684383, -3.7994230218392673],
            [0.1331422161726909, -3.881695598940517],
            [0.1325905014066569, -3.967302576314728],
            [0.13226781770148371, -4.03914412325927],
            [0.1323167779717077, -4.055116976093927],
            [0.04601624361284946, -4.05465875856874],
            [0.045610846077591895, -4.142390636062536],
            [0.045127044544229424, -4.230128185834697],
            [0.0437463053498285, -4.23028764552597],
            [-0.05043755719698604, -4.22942536174916],
            [-0.15549767017118957, -4.228404726824991],
            [-0.21255808459754502, -4.227814641050667],
            [-0.2116307343828284, -4.140185777563959],
            [-0.2975890128895359, -4.139350917062381],
            [-0.29718192172372027, -4.095557710962035],
            [-0.29591917920345234, -3.9640227428587944],
            [-0.295015498584073, -3.8766024316460266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.68437888297639,
          "lat": 34.728055418673414
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40123"],
        "coty_name": ["Pontotoc"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pontotoc County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01101849"
      },
      "bbox": [
        -0.2975890128895359, -4.23028764552597, 0.1335930393684383,
        -3.7660695276081433
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6133202571788673, -2.2992933542688188],
            [0.6130926907481903, -2.228055406320715],
            [0.6131643839585782, -2.2115448400926563],
            [0.6129782844615679, -2.1238081566971143],
            [0.6152017770644757, -2.1238037367267735],
            [0.6576326982228204, -2.123743184025214],
            [0.7977757009181262, -2.1232268434403583],
            [0.9157768523719464, -2.1226045601987034],
            [0.9978434480044241, -2.121978747114157],
            [0.9986261099311491, -2.2101360941255703],
            [0.9130879603743957, -2.210772683478519],
            [0.9139351178983306, -2.344864919069254],
            [0.9147250365784905, -2.473855756613121],
            [0.9123721856659718, -2.4738676644111655],
            [0.9114693062243697, -2.5173361930152143],
            [0.9122033797363761, -2.6493785596289485],
            [0.8068569404245519, -2.6499116937018807],
            [0.8005467226698574, -2.644864351292415],
            [0.8012833075304868, -2.6410549486355683],
            [0.8072720657602489, -2.6428924351323335],
            [0.8126163603674352, -2.6405078304997294],
            [0.8187524323992851, -2.642633110266465],
            [0.8219451305998756, -2.633504525259664],
            [0.8147614924072519, -2.6257843830296816],
            [0.8092850068165457, -2.6175163314185963],
            [0.8073669582704939, -2.6111092692177063],
            [0.8095563511577119, -2.5953557053536938],
            [0.8028581841864657, -2.591164014650514],
            [0.7940141382910629, -2.590684621362525],
            [0.789940956605407, -2.5924768232649753],
            [0.7879361386168302, -2.5953974001757834],
            [0.7800499910762076, -2.591368072009991],
            [0.7752985079693603, -2.5825819785016115],
            [0.7707560603599996, -2.578136550462836],
            [0.7693873610795308, -2.5744001198216337],
            [0.7688708210408536, -2.5621195097414056],
            [0.7255479880455528, -2.562461386384601],
            [0.703994743496818, -2.5624649267318085],
            [0.6971222969043965, -2.5629904898477194],
            [0.6825767465798507, -2.5624801240879957],
            [0.6543865064504649, -2.562252456693358],
            [0.611394370681867, -2.5624690220863675],
            [0.61132215399366, -2.502302667715971],
            [0.6115831105572184, -2.4951281791235673],
            [0.611271940950975, -2.4748387923241664],
            [0.6138908561177846, -2.4748336636569572],
            [0.6137547067544638, -2.4455880117779096],
            [0.6134466446795519, -2.32854918100451],
            [0.6278047142968485, -2.328590088031143],
            [0.6276455257969906, -2.299263739279984],
            [0.6133202571788673, -2.2992933542688188]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.60433166833458,
          "lat": 36.371529107920566
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40131"],
        "coty_name": ["Rogers"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rogers County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01101853"
      },
      "bbox": [
        0.611271940950975, -2.6499116937018807, 0.9986261099311491,
        -2.121978747114157
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.440661271706883, 9.404759520450092],
            [-17.42998321881668, 9.407176378791027],
            [-17.42294609693085, 9.413027815813214],
            [-17.42127494255298, 9.421481733091738],
            [-17.391856276614952, 9.436472750707114],
            [-17.350633867020264, 9.438937695419522],
            [-17.3027368700728, 9.412782170469342],
            [-17.283846195596492, 9.408399728992336],
            [-17.25484349630095, 9.410983216522602],
            [-17.22990729839733, 9.403743297367427],
            [-17.158048595735032, 9.406569801393138],
            [-17.152138888907867, 9.403289092332853],
            [-17.136689806400256, 9.394949106263187],
            [-17.117387647805185, 9.36979887160421],
            [-17.103889493208356, 9.361989302928055],
            [-17.146941308834506, 9.205311107555834],
            [-17.150540392010416, 9.19260515320402],
            [-17.17854166854641, 9.200407382203128],
            [-17.182115246485616, 9.1864827929751],
            [-17.188228111295963, 9.16530793847648],
            [-17.200520314194673, 9.120251320621685],
            [-17.20901843586055, 9.089914001122072],
            [-17.22409205859308, 9.03479504960378],
            [-17.231250243234246, 9.005701288161408],
            [-17.237374753045188, 8.985567949391811],
            [-17.242912646773256, 8.964968653495355],
            [-17.247640193619528, 8.951303278900808],
            [-17.33782903163779, 8.975074478397918],
            [-17.352116747940716, 8.979673795022547],
            [-17.393212591708636, 8.990767323664674],
            [-17.390644519245793, 8.996155375251904],
            [-17.385650472235902, 9.002769366025518],
            [-17.384415882006987, 9.006517152051423],
            [-17.379074576378915, 9.011385882556246],
            [-17.377563771799423, 9.01554704115055],
            [-17.37346657938277, 9.018287902446279],
            [-17.370933870126592, 9.024928643626199],
            [-17.374841642806867, 9.034049769823099],
            [-17.373184910121285, 9.045232697183309],
            [-17.374454096187762, 9.050674595608344],
            [-17.377070747274747, 9.054036970276526],
            [-17.378203705931607, 9.061870383593519],
            [-17.37696221450002, 9.06968709704734],
            [-17.373653575416654, 9.078820744302604],
            [-17.37017335981773, 9.085203782482884],
            [-17.368861321301996, 9.09224259641197],
            [-17.363469887721664, 9.099555513162718],
            [-17.363686168372276, 9.10634679178452],
            [-17.365769373740637, 9.112056177444373],
            [-17.36780851147, 9.112690282951043],
            [-17.37460429255301, 9.120476629068925],
            [-17.375691229962342, 9.125128373034896],
            [-17.388545469877286, 9.132354450314992],
            [-17.39891590033007, 9.140921229107803],
            [-17.408456414423856, 9.143363267765384],
            [-17.412288564969373, 9.154144829428997],
            [-17.416257201679894, 9.158320071528678],
            [-17.41507557646246, 9.167275559470552],
            [-17.417468861131468, 9.171567528961155],
            [-17.42046860363193, 9.180213083642332],
            [-17.41919509496667, 9.187197240894942],
            [-17.41716023073394, 9.188427426059004],
            [-17.417252757711342, 9.193245068491535],
            [-17.415234222231398, 9.19849698245569],
            [-17.417623427560017, 9.20004420080924],
            [-17.42195818406787, 9.207545615951169],
            [-17.426693940108667, 9.214782582391893],
            [-17.430117108446563, 9.223054555431245],
            [-17.434755923911222, 9.225938936039665],
            [-17.436106225623202, 9.236879989255923],
            [-17.442032243781263, 9.241457758584348],
            [-17.443157798802478, 9.245320520333443],
            [-17.43906673608005, 9.250674149018316],
            [-17.439061138077477, 9.253383926675474],
            [-17.44214367123925, 9.261304168854439],
            [-17.44147487667521, 9.266640731249195],
            [-17.44462456525103, 9.269197058455518],
            [-17.450188294918988, 9.26803950034736],
            [-17.455020852391986, 9.26847702750721],
            [-17.458255909318297, 9.270533022953545],
            [-17.46487028767144, 9.279981028828862],
            [-17.46399931813425, 9.283662185055965],
            [-17.46602759220265, 9.29232883955952],
            [-17.4648469774587, 9.2968269919589],
            [-17.46542516194178, 9.303062407589039],
            [-17.468333446105444, 9.307418337359744],
            [-17.45843956405727, 9.30808859180463],
            [-17.45210783412457, 9.312691931266816],
            [-17.451479494722257, 9.317570264796853],
            [-17.453560155731136, 9.318978062798346],
            [-17.45619160921733, 9.329157542052704],
            [-17.45121030181083, 9.338107012202695],
            [-17.454218147582996, 9.34017225420705],
            [-17.455352788699926, 9.343596320402247],
            [-17.450559775402333, 9.350673227616376],
            [-17.450295542466325, 9.354108506819875],
            [-17.447542343391312, 9.357638513182957],
            [-17.448123448001297, 9.364290446252706],
            [-17.451016497881067, 9.368290490410079],
            [-17.440661271706883, 9.404759520450092]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.65110925764928,
          "lat": 45.51901880728261
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41027"],
        "coty_name": ["Hood River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hood River County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01155131"
      },
      "bbox": [
        -17.468333446105444, 8.951303278900808, -17.103889493208356,
        9.438937695419522
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.798899842148536, 3.735693048827152],
            [13.801188634967833, 3.7364546197472324],
            [13.806546214041724, 3.733795300853823],
            [13.814253255901944, 3.738199059370943],
            [13.816585813113385, 3.73742487940416],
            [13.819700100502011, 3.730926760775316],
            [13.822172215756032, 3.72960164401638],
            [13.825941293164385, 3.731899801227282],
            [13.827161556341219, 3.738375481029007],
            [13.824722322760378, 3.745266647865291],
            [13.82569884419232, 3.750455129021479],
            [13.83249646369645, 3.750411820176511],
            [13.834710195796346, 3.752981491289699],
            [13.835338489635497, 3.759695337491365],
            [13.843003721648392, 3.7640160090172765],
            [13.843595330095617, 3.769551125474129],
            [13.8395266822119, 3.7798127438941598],
            [13.837031534660612, 3.7947962911002677],
            [13.841449730831345, 3.8011697328262195],
            [13.844497191182713, 3.809858823974333],
            [13.847311895637324, 3.810326768365635],
            [13.851674233359446, 3.807439072800065],
            [13.859665001230935, 3.8045112983056666],
            [13.863019858094486, 3.8075162544550785],
            [13.862449981091377, 3.810633449252027],
            [13.858475412288138, 3.817876478853285],
            [13.859861361164699, 3.821513416000262],
            [13.869032881234384, 3.8237139556285857],
            [13.87103470507955, 3.826978871901002],
            [13.873549049891626, 3.8390632513202556],
            [13.882611333777957, 3.8531996663797843],
            [13.897503095825348, 3.778470502223273],
            [13.976376167617705, 3.7939198227918056],
            [13.983425355805148, 3.759403860425268],
            [13.991045817257342, 3.7654754257685172],
            [14.02177599107215, 3.730079463303351],
            [14.028567196363252, 3.7330835639506255],
            [14.03285130368277, 3.737463766541899],
            [14.037617120389354, 3.734315336252132],
            [14.043240519651473, 3.732908143245282],
            [14.045437501948912, 3.7339675784958333],
            [14.046505651055675, 3.7398802485645266],
            [14.049689785084821, 3.743318063968727],
            [14.059065771161418, 3.738697846079576],
            [14.063068242585212, 3.7380920085916287],
            [14.067347099270304, 3.7420585466908034],
            [14.076718155538272, 3.7397119348578025],
            [14.081839182747832, 3.7445703784395588],
            [14.08466484071033, 3.742820974771528],
            [14.086942595555946, 3.737434379704951],
            [14.092196777559733, 3.735586720392046],
            [14.095986013587511, 3.7361332272270813],
            [14.105075725981518, 3.7349416067952728],
            [14.108191777113266, 3.7354885516053975],
            [14.111377360075089, 3.7334678318440435],
            [14.11632550678941, 3.7330361641874505],
            [14.117326937146855, 3.731080986513465],
            [14.124504599071075, 3.7291232616386263],
            [14.138327869022623, 3.7235594421695657],
            [14.144622098613297, 3.718520736570535],
            [14.150584076143659, 3.7150598529867667],
            [14.156049307218327, 3.7177370953459112],
            [14.161263485648906, 3.715091207154286],
            [14.166768609154515, 3.7086667017084807],
            [14.155343127122993, 3.6956439124600045],
            [14.175777816033484, 3.673549701881691],
            [14.224330284535268, 3.622698118282689],
            [14.272274177514726, 3.6439506631229652],
            [14.305577632170033, 3.6544691987359936],
            [14.343473415267129, 3.6710921722531733],
            [14.475820445448694, 3.756164705724518],
            [14.476376226989231, 3.7547542869075734],
            [14.44214254002816, 3.696437179504394],
            [14.403315885653436, 3.603510551610536],
            [14.353213479794274, 3.52913476416379],
            [14.345790008897186, 3.5259784328231722],
            [14.319375168158528, 3.5082103862840976],
            [14.302805939728525, 3.495521869915023],
            [14.25543467555585, 3.4554602342354745],
            [14.228094581878777, 3.4333008920689987],
            [14.215405429418293, 3.4223398758668635],
            [14.20119324779703, 3.411259967444999],
            [14.179819225513832, 3.3978601677642506],
            [14.160706405978296, 3.38659776689094],
            [14.155154343063547, 3.3781500320627327],
            [14.142432184885374, 3.3674797840551625],
            [14.123818758435238, 3.3482700802460426],
            [14.115352990703958, 3.359762011322922],
            [14.080089721054966, 3.34480631304816],
            [14.033902522440131, 3.360550034445948],
            [14.011025306098396, 3.3430937058657926],
            [13.987950582494515, 3.323658989257778],
            [13.981350449164017, 3.3167806210266724],
            [13.95577130918541, 3.2922002406169977],
            [13.916936941574749, 3.2987512341678764],
            [13.902942702149787, 3.3014212502247138],
            [13.82006007595285, 3.3152020838744276],
            [13.819598742838247, 3.3149544895529295],
            [13.807564449734702, 3.316654907139497],
            [13.755432555781711, 3.3038846852016017],
            [13.735826480519881, 3.2989236254292997],
            [13.655672263807203, 3.278261216310408],
            [13.640519111481025, 3.2750564286616033],
            [13.635688602367464, 3.2771385978280687],
            [13.62517484396242, 3.2940194435710715],
            [13.629991436177356, 3.3015816428399116],
            [13.631259487920353, 3.305452976753105],
            [13.635155293995743, 3.309615060318751],
            [13.640191280141673, 3.3116011576052933],
            [13.639462860425072, 3.3147090327492346],
            [13.642467293488984, 3.324466038291293],
            [13.644765394558794, 3.3257597899439677],
            [13.644216262574913, 3.3423398553764376],
            [13.649236750583341, 3.3462961334619066],
            [13.651838888893318, 3.351678502702496],
            [13.656247501895896, 3.3551035587137363],
            [13.661060573340107, 3.356134992994082],
            [13.66162808533639, 3.3617061140116107],
            [13.66395958497138, 3.3640170998929406],
            [13.664798940548883, 3.369213178687594],
            [13.668669517122378, 3.3739589886046444],
            [13.666956478290423, 3.380660401964335],
            [13.66508413049326, 3.382438064898101],
            [13.669821279470218, 3.387861246771193],
            [13.671790424153127, 3.3929452076542006],
            [13.670472757873368, 3.3970285435757726],
            [13.674887039992159, 3.402265445923503],
            [13.681459658129466, 3.402520632424083],
            [13.686012917842977, 3.4001584901863557],
            [13.691650679260425, 3.409147272028112],
            [13.696104125792555, 3.4090362150129736],
            [13.699884638525717, 3.411416064699523],
            [13.70103006641924, 3.4146871652198927],
            [13.698879522249744, 3.417084459926247],
            [13.697418190418716, 3.425432782958005],
            [13.706426781746377, 3.4313166656931764],
            [13.703963444903106, 3.433754012775448],
            [13.699446330825843, 3.4332488654460747],
            [13.696432948090449, 3.4355303697868327],
            [13.701429601204238, 3.43860297645901],
            [13.709350542933736, 3.438728574929734],
            [13.709692148075924, 3.4453845219932004],
            [13.714029775359796, 3.448020244722828],
            [13.713959701085184, 3.451150081737845],
            [13.706369975860063, 3.4580862564292087],
            [13.707286906499005, 3.466102469887573],
            [13.712367394560681, 3.4736493457695],
            [13.716892209852622, 3.4781576772621765],
            [13.72360521492803, 3.4778053370445092],
            [13.726981824687654, 3.4827252799994306],
            [13.730914713038349, 3.4821766062877564],
            [13.738171736829866, 3.4884976306678346],
            [13.738889364921386, 3.495446300737991],
            [13.7426851112634, 3.4984283911983955],
            [13.742015966281775, 3.502757047487561],
            [13.745577294154128, 3.5033488937890116],
            [13.747513697284083, 3.509230665798953],
            [13.752396606410107, 3.5108817650376927],
            [13.745218169617472, 3.521800045845816],
            [13.741406307866537, 3.5182818963667253],
            [13.739492901014227, 3.526313536700128],
            [13.745872126848946, 3.5285429463035083],
            [13.756639183146028, 3.5252393456842857],
            [13.757051726383294, 3.518481249733651],
            [13.761794370624871, 3.5199046894073507],
            [13.761465394565628, 3.527278017626707],
            [13.763104881946957, 3.5332208129292746],
            [13.767697181550812, 3.5333162010690353],
            [13.764076445017302, 3.5266661700605764],
            [13.769192762927554, 3.52284291384201],
            [13.767403687672362, 3.5188405557892373],
            [13.772899029040978, 3.517747998828371],
            [13.776488110880152, 3.519911292475566],
            [13.778230807906052, 3.515043857730882],
            [13.784556855423087, 3.5193926081905875],
            [13.784757624350664, 3.5243578935934394],
            [13.788966627323664, 3.5247330692983043],
            [13.792218461243596, 3.527473501025443],
            [13.795646269400901, 3.526944349782709],
            [13.798809559800848, 3.531667260768384],
            [13.804626265791129, 3.533395599981424],
            [13.806686145066168, 3.5376404068934777],
            [13.800361921413597, 3.5455620143495095],
            [13.796858301704965, 3.5475486135714975],
            [13.792708071639387, 3.546931862405784],
            [13.795381831103162, 3.5531730653129294],
            [13.793116774623236, 3.5576556101214254],
            [13.797607928848423, 3.5584593302662366],
            [13.79864881856319, 3.563352985583496],
            [13.79379821117808, 3.5717054641487826],
            [13.797691551973184, 3.571310576238899],
            [13.803087351767303, 3.572930489199464],
            [13.806424950079426, 3.577365410130892],
            [13.81098287232435, 3.578495422372633],
            [13.807536916186672, 3.583410000915075],
            [13.81418361213, 3.586236547738367],
            [13.81335322341662, 3.58957494956787],
            [13.807963303123657, 3.5936678570493648],
            [13.803586489443276, 3.592393100107681],
            [13.801939439534022, 3.5939776428934627],
            [13.802461059451973, 3.598984364905352],
            [13.796283606699586, 3.600574526513078],
            [13.791218955740769, 3.6082870754615217],
            [13.793545220568605, 3.6126475852632436],
            [13.798943698311337, 3.6118750742727594],
            [13.801046645265957, 3.6154096515136938],
            [13.80693959249392, 3.618328936517451],
            [13.806515500339236, 3.6201105570683954],
            [13.800261646177033, 3.625640786659505],
            [13.80278010047608, 3.6311621422779967],
            [13.800139045167807, 3.633113203518386],
            [13.796467284593621, 3.629062509956509],
            [13.7926828274623, 3.630352381697714],
            [13.789229032723032, 3.637618199215695],
            [13.780488897222872, 3.63337974397696],
            [13.778189425367929, 3.6352653569660633],
            [13.78012754517728, 3.6450972528600807],
            [13.772272487662528, 3.645910198533162],
            [13.772900297980213, 3.6548992376635994],
            [13.767682335811587, 3.6605408908331376],
            [13.757029903682358, 3.678458440913066],
            [13.752092743176057, 3.685846794253394],
            [13.75357705490416, 3.6897115879537523],
            [13.759294863863083, 3.695556223925066],
            [13.763796036594316, 3.6942441940123847],
            [13.765141842500219, 3.6911059620525566],
            [13.768558572051864, 3.6914345239750057],
            [13.770403992328674, 3.7019328699439344],
            [13.775296475547592, 3.702067561530915],
            [13.778776338077671, 3.69954287513548],
            [13.782073581866747, 3.7024786852689795],
            [13.779888864852053, 3.706848776785817],
            [13.782807513618181, 3.7108463759591173],
            [13.788027999940285, 3.7103746915106406],
            [13.790350764751093, 3.714164854968619],
            [13.789206855393761, 3.722640613154651],
            [13.789785707379817, 3.725467298730277],
            [13.796378083917377, 3.727944713804009],
            [13.798899842148536, 3.735693048827152]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.81992899653824, "lat": 40.91892786022244 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42027"],
        "coty_name": ["Centre"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Centre County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01214720"
      },
      "bbox": [
        13.62517484396242, 3.2750564286616033, 14.476376226989231,
        3.8531996663797843
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.476274779966584, 4.79926156479024],
              [18.477551357055034, 4.802048563954329],
              [18.476053885806238, 4.807609301638124],
              [18.476147380246903, 4.821930000063539],
              [18.48122202654165, 4.826421958411326],
              [18.484019287991867, 4.8389637030939525],
              [18.488709491711404, 4.84727141380561],
              [18.489427473553466, 4.855404581713233],
              [18.486306384413755, 4.8690088778627585],
              [18.490538221184767, 4.8705657185287485],
              [18.49642242660255, 4.870938664756255],
              [18.503189797325497, 4.864839291821492],
              [18.505428120316445, 4.861603751243485],
              [18.505538095710445, 4.856811207589322],
              [18.50332388934064, 4.8482188742008026],
              [18.50286776927319, 4.835226242230785],
              [18.506309871091016, 4.827264902370474],
              [18.512895318899933, 4.822076758656431],
              [18.515162083604416, 4.823091514625148],
              [18.52004203235068, 4.8174775027674315],
              [18.52469702024034, 4.81675024442913],
              [18.52603283632696, 4.813370220283091],
              [18.525696096482584, 4.805348596629218],
              [18.513287248240847, 4.797240098595945],
              [18.504481309252984, 4.793490907483905],
              [18.502708529068833, 4.794555764988326],
              [18.493881395388236, 4.789385720766176],
              [18.489183243167734, 4.788772462334206],
              [18.479037354605236, 4.793361561151893],
              [18.476274779966584, 4.79926156479024]
            ]
          ],
          [
            [
              [18.257004923044498, 4.908302539355107],
              [18.26208101074154, 4.914197562720151],
              [18.26386802612457, 4.919785585297964],
              [18.270573569725002, 4.928171099440544],
              [18.27383304785745, 4.935655662094203],
              [18.27019754174814, 4.94392992325668],
              [18.266449737211392, 4.945317871743632],
              [18.263218420992217, 4.951305156898561],
              [18.26203421707378, 4.95655343111516],
              [18.265003476021185, 4.962924717710872],
              [18.263041710483574, 4.967315814139002],
              [18.263710531989428, 4.97075812054426],
              [18.260713647505774, 4.973712904884109],
              [18.26013087980494, 4.978529392009897],
              [18.255285907511997, 4.980842854141247],
              [18.251224957597717, 4.984734018815766],
              [18.250950569088587, 4.988678808344139],
              [18.247605390498435, 4.994659835110515],
              [18.24876499801884, 5.0014840183544695],
              [18.2528924504783, 5.001995399265367],
              [18.25883226338232, 5.007323110131318],
              [18.260835902305182, 5.012144206905627],
              [18.266180513979954, 5.013551752769231],
              [18.275412719798904, 5.011941195937126],
              [18.277821841186967, 5.013773436997032],
              [18.25817527904876, 5.101048853052154],
              [18.23806994653754, 5.19031487769427],
              [18.258269255123267, 5.196792142091402],
              [18.33510387348938, 5.217468522457142],
              [18.341860537412508, 5.221576655379185],
              [18.412330957593866, 5.241073594557636],
              [18.429652875268836, 5.246261376967576],
              [18.45550646862727, 5.253022234345973],
              [18.452102979460086, 5.262902888366812],
              [18.449456225793003, 5.26539755242064],
              [18.45150671491919, 5.273752120652463],
              [18.45358823095491, 5.274942387982484],
              [18.458099965108673, 5.281187903619288],
              [18.456456793178408, 5.283870149546055],
              [18.46456589127368, 5.292092322805453],
              [18.472313931925235, 5.285318840439044],
              [18.473397910722507, 5.289674079833625],
              [18.471933186551098, 5.2927682801104385],
              [18.47548302888433, 5.300494332334258],
              [18.47445402026199, 5.3028624942679],
              [18.479999744225566, 5.310034915246919],
              [18.482957759723167, 5.31003125823423],
              [18.48572817603242, 5.314205104196942],
              [18.489972530082646, 5.316427230590081],
              [18.49649649276732, 5.3169928368390895],
              [18.502756820436954, 5.297352080477335],
              [18.50740170427829, 5.292496528545721],
              [18.504901169272614, 5.28612078205891],
              [18.51098301394216, 5.281084373856596],
              [18.51058159286699, 5.277106065579052],
              [18.50530912338993, 5.274978522646625],
              [18.50333208461179, 5.2680017941421635],
              [18.505803000544876, 5.266254183764142],
              [18.513392551301948, 5.268637402552076],
              [18.516796742191605, 5.255378909445742],
              [18.512314461326262, 5.25136587416349],
              [18.506361959561282, 5.248954643416088],
              [18.493686800803236, 5.241108046373171],
              [18.491236061338732, 5.244153811745557],
              [18.48777043461313, 5.241396367350443],
              [18.490013229495162, 5.232944248170176],
              [18.496991598702984, 5.230720466181256],
              [18.493342347544008, 5.227115259150334],
              [18.495818989877627, 5.22337962417917],
              [18.501970420932174, 5.222733013941375],
              [18.508221558712005, 5.217987003469665],
              [18.50732817254586, 5.212175438794432],
              [18.515943260636615, 5.20266346015212],
              [18.520510987731033, 5.201280921772168],
              [18.52122385350474, 5.19722078825756],
              [18.52369798170945, 5.1954715163155605],
              [18.52760580593586, 5.182429135082033],
              [18.52750037085498, 5.1640524270735995],
              [18.532210984973755, 5.14966922326088],
              [18.534259467376092, 5.148644318227045],
              [18.536366547119524, 5.13941796804372],
              [18.529760604931607, 5.137561375618099],
              [18.528016491699255, 5.135125169450027],
              [18.530988935267136, 5.12604961335039],
              [18.533978147525595, 5.124432256344113],
              [18.535065773062822, 5.119840776974335],
              [18.532899543288863, 5.118137412729245],
              [18.53374581471857, 5.112405555632871],
              [18.53017277958848, 5.105601278622021],
              [18.526888394826663, 5.104470810674208],
              [18.52321013380224, 5.100471865935991],
              [18.519663890121656, 5.093835353193282],
              [18.523274932085304, 5.083192647363233],
              [18.525881164243913, 5.07968247977192],
              [18.527729183138767, 5.071753901414971],
              [18.52657217907617, 5.066721763993612],
              [18.523162990801975, 5.061830296363398],
              [18.5235637948425, 5.056200778254012],
              [18.520340710494487, 5.053139308657754],
              [18.518003634672073, 5.044719348232405],
              [18.51498763581505, 5.0291171358881295],
              [18.520364850632188, 5.018491047644893],
              [18.513811392362275, 5.018975445703721],
              [18.513491560152072, 5.020945369762981],
              [18.505714311648582, 5.026125209404146],
              [18.50090263238451, 5.027865476676242],
              [18.48789664227873, 5.026863423891776],
              [18.47970922861589, 5.024684400122306],
              [18.476423712695002, 5.0205377541913485],
              [18.46582612435478, 5.018895599089624],
              [18.442585901672285, 5.006235089472353],
              [18.437097399690323, 5.0017595125825975],
              [18.421988407464493, 4.9955533880230965],
              [18.411273104245232, 4.9880547752201005],
              [18.408210298678288, 4.984111807416531],
              [18.404884368019015, 4.983480178506166],
              [18.375581323109724, 4.962511350747844],
              [18.369841386753947, 4.959101106912187],
              [18.365434530813435, 4.951006685803509],
              [18.358417095830156, 4.9458628681147765],
              [18.352227405467865, 4.945290242945116],
              [18.347694723084977, 4.943645230836245],
              [18.337033901862718, 4.937194360827081],
              [18.334188063034112, 4.933659919234832],
              [18.326644833918287, 4.934908125224892],
              [18.317639816183572, 4.932034294967275],
              [18.289585652799722, 4.916726940998608],
              [18.27747225655816, 4.908808586689233],
              [18.27011006497819, 4.903000155920007],
              [18.262755344424868, 4.895336303441538],
              [18.25802393899512, 4.897716128689914],
              [18.257004923044498, 4.908302539355107]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.6227341005762, "lat": 41.46966040763446 },
        "year": "2023",
        "ste_code": ["44"],
        "ste_name": ["Rhode Island"],
        "coty_code": ["44009"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01219782"
      },
      "bbox": [
        18.23806994653754, 4.788772462334206, 18.536366547119524,
        5.3169928368390895
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.977479346260818, -2.9008033568929847],
            [13.027261914544168, -2.892864051928598],
            [13.033743547554092, -2.8922711657405324],
            [13.066065509555969, -2.8873599931135314],
            [13.10787374079587, -2.881750258128065],
            [13.171548393108944, -2.872258573939346],
            [13.241483747276227, -2.861772108990545],
            [13.324373989994006, -2.8500308194543846],
            [13.407981571536645, -2.838040413359173],
            [13.485984803646824, -2.8269309295638982],
            [13.48401109225091, -2.832736367928213],
            [13.484397554028552, -2.8364436552806054],
            [13.48899852536224, -2.8506281629987487],
            [13.494341377477369, -2.863051078521804],
            [13.497407192362267, -2.867206455801953],
            [13.505038237959594, -2.870718740811363],
            [13.51167577601287, -2.875699552493787],
            [13.516716541627801, -2.877780274201089],
            [13.525697740221716, -2.884556407599226],
            [13.528584232618808, -2.8878341605985804],
            [13.535531230292149, -2.900053087720427],
            [13.543015122709713, -2.90893479728064],
            [13.54860052915003, -2.920068601703961],
            [13.55021432912411, -2.926780552838136],
            [13.5523609967458, -2.9308205947060624],
            [13.565200061977915, -2.945022047535075],
            [13.572796787100884, -2.9506576804188973],
            [13.581557676833844, -2.9506988203924975],
            [13.583996582497312, -2.952440413779629],
            [13.591971813790348, -2.961455566561782],
            [13.595602461513337, -2.9614936204967477],
            [13.60264538438534, -2.9581268949345287],
            [13.607006074406153, -2.960779201953653],
            [13.610838797830938, -2.9647909353749653],
            [13.619021638283, -2.9655486517461593],
            [13.62197710566159, -2.9674681025258742],
            [13.61784054011235, -2.973818898019565],
            [13.619324403787822, -2.976725941842042],
            [13.628679045020236, -2.9810810754214905],
            [13.6299593712941, -2.9893070487599895],
            [13.634592764262935, -2.993250572104849],
            [13.641197199022598, -2.9962579821718505],
            [13.642152906802915, -2.998810108551536],
            [13.63780912112084, -3.0046199442813664],
            [13.630191400700495, -3.0070611525665116],
            [13.625447804642796, -3.004156942084037],
            [13.622070098979414, -3.0048651726475732],
            [13.620285988992903, -3.009164179425502],
            [13.619072089904542, -3.016260293042681],
            [13.621764099126326, -3.0303919853381522],
            [13.620508801900018, -3.037050496054642],
            [13.616611475727414, -3.043075597589443],
            [13.61570329880541, -3.0684713714910106],
            [13.613167776496535, -3.0753241717326207],
            [13.614442358050335, -3.083151281369376],
            [13.61373853857794, -3.0857060555704776],
            [13.608257048919914, -3.0833623649048967],
            [13.602511002402718, -3.086446420843277],
            [13.600314353124501, -3.0891363082096968],
            [13.60057566379105, -3.094526240858655],
            [13.596891243053404, -3.095996012023889],
            [13.59203934026362, -3.1012422195881397],
            [13.588942061347103, -3.109095310650266],
            [13.590579315500277, -3.113361902449038],
            [13.584968914604026, -3.1178179037785596],
            [13.582183014265556, -3.1226083243101983],
            [13.583709978837145, -3.127201174488471],
            [13.576394730979017, -3.1337829266300035],
            [13.570590977544155, -3.135264984642743],
            [13.5692664757317, -3.1370087878631736],
            [13.562926041282436, -3.1380028820383155],
            [13.558902131391225, -3.135236250836697],
            [13.554014364252257, -3.1339576731234775],
            [13.547496142073381, -3.133967886274572],
            [13.542007652843823, -3.1377436351989973],
            [13.535320344765157, -3.141015522467238],
            [13.531896409065503, -3.1445345370421003],
            [13.528442637089265, -3.145331062884509],
            [13.524832938034471, -3.143835071687445],
            [13.518733672554802, -3.147738334012802],
            [13.512112045965887, -3.1482419097889762],
            [13.508298579211944, -3.14374425125876],
            [13.50241436041078, -3.1393074098864435],
            [13.496812854853646, -3.1366324871345426],
            [13.4882213696821, -3.1406748693375395],
            [13.485661936773111, -3.1440968514812506],
            [13.481109172361359, -3.1443497827502735],
            [13.475591200279993, -3.1477127247402157],
            [13.47359950329931, -3.151551404853475],
            [13.463054928466976, -3.15773884603474],
            [13.458801137576978, -3.1578794620376947],
            [13.451268839721266, -3.1537489438291115],
            [13.446760701544905, -3.1543087082975116],
            [13.441513357192594, -3.158732766835785],
            [13.420178980693835, -3.178498458534012],
            [13.409691387282443, -3.188921041885756],
            [13.384026540305937, -3.211327924588184],
            [13.300192673652319, -3.2865604933115216],
            [13.271720484118312, -3.3126868876943587],
            [13.270725207068352, -3.308618872093149],
            [13.273550546440399, -3.3006334187280593],
            [13.269575662698449, -3.2961016363990447],
            [13.271424355893078, -3.292407555896253],
            [13.269633185697884, -3.285008248188814],
            [13.265940381630818, -3.2833818695132924],
            [13.261130729442998, -3.2851539941381462],
            [13.257957508911462, -3.2803953791705354],
            [13.254856295710216, -3.2797341614686863],
            [13.254428179191533, -3.27294533426382],
            [13.252716049981965, -3.270269498005204],
            [13.246062330558864, -3.2672556659283933],
            [13.243702555740013, -3.2591494674934047],
            [13.23985461056987, -3.2568499861181137],
            [13.235062739433777, -3.2561661885866577],
            [13.229519875961865, -3.2470745629663047],
            [13.228720106283989, -3.2424009997068466],
            [13.230465047669608, -3.235192541649313],
            [13.226790833238702, -3.2346726199192064],
            [13.227552538406576, -3.230565921516647],
            [13.223747131136449, -3.225933474167425],
            [13.22267241595228, -3.2117195297130183],
            [13.220537072665001, -3.212233453776763],
            [13.221230356545343, -3.204116843129482],
            [13.219009433995693, -3.1999524368855004],
            [13.219589056589705, -3.1944033715962363],
            [13.21845359360865, -3.1873270128118043],
            [13.212586098015894, -3.1795530117989994],
            [13.214340671328372, -3.1760187740715904],
            [13.209703157653426, -3.175712525906876],
            [13.206229957344899, -3.172619930982419],
            [13.20369217673622, -3.17444220190693],
            [13.194797612550438, -3.1681194318042647],
            [13.192304318840897, -3.1646015076737966],
            [13.191020533243682, -3.1578360487273445],
            [13.184140509847738, -3.1524433755649586],
            [13.177767630317785, -3.1463039088056464],
            [13.174279879665663, -3.144648185637288],
            [13.170355079728793, -3.1342597557584084],
            [13.171266679883516, -3.12823934555633],
            [13.16830610688801, -3.1258940461815596],
            [13.166973187981764, -3.1200137256984317],
            [13.162536640073583, -3.1190525117763634],
            [13.160551045528582, -3.1138505726573102],
            [13.160696714121746, -3.1102712657674676],
            [13.157891700682608, -3.101010851295075],
            [13.151449297824904, -3.094673856767658],
            [13.146676179861997, -3.095803428255167],
            [13.144034142423365, -3.0905678094577707],
            [13.135615576638672, -3.0871617303057293],
            [13.13651532818653, -3.0833108142579855],
            [13.134038048882026, -3.0819233217216504],
            [13.12775034952281, -3.0809623294036608],
            [13.124383100469384, -3.0773021380519174],
            [13.129250385725049, -3.07368358722545],
            [13.127443721123054, -3.069715584910792],
            [13.121639357762687, -3.067016132579903],
            [13.116246030064218, -3.062335080695058],
            [13.111924906273584, -3.062613699223524],
            [13.108075886622142, -3.05834258945801],
            [13.107197770005879, -3.053131120811629],
            [13.108019409240136, -3.046043076363149],
            [13.109971873420276, -3.043995179770609],
            [13.107756329615999, -3.0400819690606404],
            [13.103608848517148, -3.0401775745993413],
            [13.101014039277644, -3.0373778837012018],
            [13.095808463235464, -3.036288370020191],
            [13.094929527495593, -3.0342780593269727],
            [13.088424570195343, -3.031336915493587],
            [13.090253418094768, -3.026866805633485],
            [13.081618793769131, -3.027081502331717],
            [13.080359601601849, -3.021545719533418],
            [13.073630228462289, -3.0198425954546706],
            [13.066850199401701, -3.0096467774309863],
            [13.066381141973947, -3.0068747995193723],
            [13.059857456999906, -3.0024652201052797],
            [13.054378860662363, -3.001978470750337],
            [13.05497874366635, -2.99488852904056],
            [13.052892164147837, -2.9935284824460866],
            [13.053674204626333, -2.9887515406809784],
            [13.052466075083325, -2.9860744614184767],
            [13.047589650501513, -2.9836249509517256],
            [13.042901662111456, -2.979118523153121],
            [13.039006247903975, -2.9733733729335574],
            [13.039544934846012, -2.970155990680796],
            [13.033089727589799, -2.9651117926144166],
            [13.028801262742084, -2.9564304268767723],
            [13.023581862498919, -2.953014449408004],
            [13.021654798264388, -2.9494527970529734],
            [13.021948991738661, -2.9440314424455423],
            [13.010719695196128, -2.942712347401651],
            [13.010181178018161, -2.938594101777796],
            [13.006080918029431, -2.9377050833960694],
            [13.006281419999643, -2.9320909849438337],
            [13.001974394004433, -2.9329195561135855],
            [12.996733673321339, -2.9318078042247047],
            [12.994199207653846, -2.9258499518783205],
            [12.99000261004652, -2.9257801414892413],
            [12.986733549100933, -2.9191290430386045],
            [12.982680641772676, -2.916246311613407],
            [12.980427074809763, -2.910820705855992],
            [12.976038100534458, -2.90381365093293],
            [12.977479346260818, -2.9008033568929847]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.15879239899569, "lat": 34.639794015595 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45025"],
        "coty_name": ["Chesterfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chesterfield County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01247989"
      },
      "bbox": [
        12.976038100534458, -3.3126868876943587, 13.642152906802915,
        -2.8269309295638982
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.158997718528932, -3.7586341518449737],
            [14.16706003113959, -3.7652766749839857],
            [14.169818632381807, -3.770650821355227],
            [14.177918326365118, -3.778612818910672],
            [14.181585429654167, -3.780720282577911],
            [14.18410645646743, -3.78451704210261],
            [14.184557939661888, -3.7936477338406025],
            [14.191503334802636, -3.796252755641061],
            [14.18820335196977, -3.8019355548591225],
            [14.188654665221248, -3.8053374142549847],
            [14.192267671149594, -3.81026525140656],
            [14.194833581863003, -3.8158624180013234],
            [14.19792181059218, -3.8169735616114115],
            [14.20574853797367, -3.8096044757054153],
            [14.208407611230317, -3.8142549017837437],
            [14.204766663074473, -3.8174467814708417],
            [14.205631468296811, -3.822873845830443],
            [14.209993343988964, -3.8200164710848705],
            [14.213549148921278, -3.820016149451711],
            [14.214229235277275, -3.824258199579764],
            [14.22049246290439, -3.8264727921250157],
            [14.22715145512288, -3.824593694328621],
            [14.230708921417651, -3.8216207827290085],
            [14.233737001891301, -3.8253719505804384],
            [14.229588686703131, -3.826821800942028],
            [14.228665197517882, -3.830907764496509],
            [14.231331427911325, -3.8320957838848297],
            [14.241017557587965, -3.8315088387600538],
            [14.245183136960952, -3.8265059551664096],
            [14.253750739714572, -3.8222881441189402],
            [14.254619709758611, -3.8183929916046955],
            [14.258681588053722, -3.8207067273483757],
            [14.265095428872312, -3.8182093964191663],
            [14.268728337853632, -3.819521044004341],
            [14.275117906914067, -3.8136428143514127],
            [14.2802594540662, -3.8155812661054958],
            [14.285491999609711, -3.815460282904987],
            [14.287253270566454, -3.818086244414692],
            [14.285084401903884, -3.8224365435531618],
            [14.289529764435207, -3.824895843594582],
            [14.296565175848038, -3.826002188403117],
            [14.300641730918189, -3.830200101381331],
            [14.304085847791773, -3.8290151395591407],
            [14.311124467934848, -3.8362249454055495],
            [14.312025516399837, -3.85117956230747],
            [14.314733462611812, -3.855160953269194],
            [14.323164710194625, -3.853249181270128],
            [14.326408179576601, -3.847339756184994],
            [14.329083481972738, -3.8531295945178767],
            [14.332644023800361, -3.8578635069000877],
            [14.339562482731248, -3.860324872453245],
            [14.337390334490237, -3.865976568665397],
            [14.33148887664405, -3.8612422009989844],
            [14.330463398994784, -3.864076973630584],
            [14.332384415381378, -3.868041415076714],
            [14.336024605572813, -3.87056188039034],
            [14.336460737146204, -3.878004646417723],
            [14.339439497880171, -3.8804779664402065],
            [14.33915732964503, -3.8837247969671767],
            [14.344283897852309, -3.885556243063851],
            [14.346649499432166, -3.8935935304170672],
            [14.346580482426639, -3.8978709596489676],
            [14.34937060841059, -3.899103714714594],
            [14.34828066907016, -3.9027360214964566],
            [14.358258358779059, -3.9063072108505357],
            [14.360984365297119, -3.9050571835274277],
            [14.361689923581523, -3.8947854276457305],
            [14.365889560453546, -3.896224370704874],
            [14.369898954997112, -3.9043339322709265],
            [14.369009772976584, -3.9084053055356747],
            [14.370902764669733, -3.916907378789948],
            [14.368834211811413, -3.9235879283589212],
            [14.371286223402523, -3.932035418614967],
            [14.382434219808266, -3.930099305730673],
            [14.383436624316776, -3.9315935826497292],
            [14.429629121400044, -3.9224750964771906],
            [14.452185127882862, -3.9177876683055675],
            [14.446094340956586, -3.931083336511341],
            [14.442104317214547, -3.942597622707912],
            [14.439912378485031, -3.9538087630414944],
            [14.436078659730434, -3.962237162927169],
            [14.430998661145612, -3.961816328108146],
            [14.427396520214655, -3.9768250898787065],
            [14.413483077963878, -3.997516765643662],
            [14.400630713821288, -4.017920368463149],
            [14.390992277219867, -4.042767587760109],
            [14.387242051411523, -4.057418236185098],
            [14.383467474495127, -4.066439536042548],
            [14.37335656381498, -4.104240264644461],
            [14.369664204066167, -4.120086158911562],
            [14.36806886506397, -4.131328483979606],
            [14.36821582149462, -4.158038604038476],
            [14.36643707352226, -4.17395565109674],
            [14.364029775967587, -4.180063186455185],
            [14.359579224535286, -4.180726135458084],
            [14.356685568565162, -4.183469299042198],
            [14.35736953798129, -4.187380389599962],
            [14.363922212906276, -4.192964318031368],
            [14.36653359207837, -4.199127100069323],
            [14.365058050110514, -4.2029859756851495],
            [14.363082636470322, -4.21691111731872],
            [14.362361736713176, -4.235355207370698],
            [14.363267228899122, -4.258770415445374],
            [14.365935267125836, -4.274800853012374],
            [14.374669500984178, -4.300668743931111],
            [14.37104546471076, -4.315712899499313],
            [14.372137921297496, -4.321805224817557],
            [14.36965636081464, -4.331476159612505],
            [14.36842942706834, -4.340314389303486],
            [14.366613851989856, -4.344188015044347],
            [14.346214569890572, -4.3682061540236665],
            [14.337806350358413, -4.382143838822032],
            [14.331824654630203, -4.395007529662792],
            [14.314273316602476, -4.4047162190678435],
            [14.309570078181833, -4.408371596124305],
            [14.31305407438736, -4.393954863623728],
            [14.311755650111126, -4.38833947616858],
            [14.30812970566404, -4.385302797345942],
            [14.301362029501293, -4.382812677379442],
            [14.29148329370906, -4.381209483684511],
            [14.286293861353908, -4.3831293597426555],
            [14.275868306016658, -4.385123234638549],
            [14.269533775683515, -4.384962413428163],
            [14.256973524451974, -4.381071164452392],
            [14.248962511502063, -4.381116273223316],
            [14.242531961203685, -4.383015837186502],
            [14.238441045283409, -4.381683051090531],
            [14.232357677309734, -4.377430957338205],
            [14.226752722748886, -4.376634720333697],
            [14.220447201228438, -4.373452383162472],
            [14.210956001039264, -4.366284208382484],
            [14.20148696734599, -4.365016160970921],
            [14.192594126936106, -4.360735010687886],
            [14.188346861637799, -4.356875441802613],
            [14.184197806424738, -4.349878745108225],
            [14.18149134810554, -4.347161500875817],
            [14.173763812475164, -4.344688534644814],
            [14.170668965024197, -4.342263423150958],
            [14.168855034785977, -4.338402449772608],
            [14.164882948781317, -4.337764945126757],
            [14.159493948329326, -4.334483605897017],
            [14.152479152227382, -4.337532821640524],
            [14.14696854694952, -4.33582522260289],
            [14.144283461359755, -4.3327586643949605],
            [14.146280981173058, -4.326440206563724],
            [14.142397912423847, -4.323253459008643],
            [14.13883442684565, -4.317747955672036],
            [14.133707119861759, -4.322398205434052],
            [14.127344743703711, -4.325313692234319],
            [14.12650783920309, -4.323038820708766],
            [14.130167417871679, -4.3179379674906855],
            [14.126911172612619, -4.315889192740255],
            [14.12251727215206, -4.32074854970359],
            [14.118347865855915, -4.319597200717651],
            [14.12160293216688, -4.3125577890308815],
            [14.117404839739368, -4.310599191109494],
            [14.116213564720704, -4.316319247342067],
            [14.113753680533112, -4.3204889227907355],
            [14.109837791758737, -4.321999537940751],
            [14.095335423334557, -4.316966439508052],
            [14.089769438171453, -4.315762208626534],
            [14.084160577814197, -4.316449364076698],
            [14.073576702918709, -4.314494718435467],
            [14.071677526579425, -4.311467279500261],
            [14.065496838825998, -4.311155411903076],
            [14.063351058130463, -4.309777855651899],
            [14.059174168932277, -4.301345816746086],
            [14.055059637223163, -4.305754018538579],
            [14.050426894313947, -4.305585010126171],
            [14.052078496160101, -4.298904766824029],
            [14.047650417292395, -4.295666268838929],
            [14.034496000757144, -4.295642460236739],
            [14.019237560742589, -4.293714997377463],
            [14.010211822307399, -4.295252963904402],
            [14.004296157928282, -4.290344873480693],
            [13.997908732465403, -4.2876642707671975],
            [13.98788668986715, -4.285262216533186],
            [13.973740673677355, -4.284422507880989],
            [13.95975062142815, -4.284641551829118],
            [13.955520438025461, -4.282181444655143],
            [13.94817090185989, -4.279898012554608],
            [13.950775725766205, -4.27451990835369],
            [13.944144704154914, -4.268868615946936],
            [13.94248452753812, -4.265944031084471],
            [13.942506854340268, -4.248456757408556],
            [13.947799575372052, -4.241085622469085],
            [13.954756465638383, -4.2289285211655905],
            [13.957826811798599, -4.22145978308588],
            [13.971418277558804, -4.207389884838746],
            [13.972580936526676, -4.204855321208446],
            [13.975598658556926, -4.188755171284658],
            [13.98482550693434, -4.170334153458283],
            [13.989452472903768, -4.1572411356120345],
            [13.994275670892126, -4.153066306018921],
            [13.994757570903461, -4.132269131913824],
            [13.995276405838988, -4.130473360287456],
            [14.01992240788643, -4.088236276496454],
            [14.0245372023529, -4.080845637223363],
            [14.023651424263571, -4.077241704416714],
            [14.028491824571091, -4.070286267005072],
            [14.053157872030798, -4.049412386601275],
            [14.058982736026602, -4.0439786805095155],
            [14.061070989246309, -4.040262080669574],
            [14.066208254833022, -4.023028472769676],
            [14.083784095507793, -3.9981934762168043],
            [14.085030296575955, -3.997341446876012],
            [14.098643234357642, -3.9808874759709396],
            [14.099743030906925, -3.976409891586771],
            [14.097818949638919, -3.97456076486896],
            [14.089184148339376, -3.9586259544006626],
            [14.091326993443484, -3.938228933292004],
            [14.09333755236055, -3.9241640011805328],
            [14.096055570137635, -3.9167802526213453],
            [14.098505640203523, -3.9024195409264095],
            [14.096240313660102, -3.8846130937122285],
            [14.09955439534107, -3.862982578992626],
            [14.109666994610867, -3.8364446796411786],
            [14.12182777935504, -3.821450689796473],
            [14.131397649470246, -3.8041081286080844],
            [14.13932863095571, -3.7871657571142534],
            [14.141329112605916, -3.7720544779152347],
            [14.14308710270583, -3.7668308225747373],
            [14.146985139966295, -3.7636418327051713],
            [14.15444743569575, -3.7619270293230413],
            [14.158997718528932, -3.7586341518449737]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.3326471694539, "lat": 33.434270907700956 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45043"],
        "coty_name": ["Georgetown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Georgetown County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01248002"
      },
      "bbox": [
        13.94248452753812, -4.408371596124305, 14.452185127882862,
        -3.7586341518449737
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.489601577255736, 4.857642252551885],
            [-1.4683515581870712, 4.856825264283973],
            [-1.3828131293952368, 4.854209398303692],
            [-1.2970886757621751, 4.851606014353671],
            [-1.2116059589971635, 4.849647063324724],
            [-1.1759483640393575, 4.848800642530865],
            [-1.1485808243610185, 4.847476400167083],
            [-1.1260917065490845, 4.846883342282855],
            [-1.0630362365481956, 4.845837743351931],
            [-1.0622182530142572, 4.831942886165547],
            [-1.0630471146951377, 4.774520845218558],
            [-1.0640470920111498, 4.673508878643885],
            [-1.064811521643256, 4.600896272112216],
            [-1.0659584974457827, 4.543891691916441],
            [-1.1084109569121068, 4.563570228536585],
            [-1.1506853231039547, 4.582490315990251],
            [-1.1689737631448642, 4.59046080849735],
            [-1.2353565623249934, 4.620582831815749],
            [-1.2506384466590548, 4.6273060477954555],
            [-1.3213993043594296, 4.6604127309548256],
            [-1.3638255311070413, 4.679932414330477],
            [-1.4046573382957732, 4.699176932313525],
            [-1.406315655780521, 4.699608621222699],
            [-1.4334128573025537, 4.712139405767416],
            [-1.475065644523447, 4.730858203776682],
            [-1.4751091082420873, 4.72876047068397],
            [-1.494074011505154, 4.728307423281737],
            [-1.492701566885328, 4.786106693561491],
            [-1.489601577255736, 4.857642252551885]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.36606331951191,
          "lat": 43.386921242655355
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46043"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01266978"
      },
      "bbox": [
        -1.494074011505154, 4.543891691916441, -1.0622182530142572,
        4.857642252551885
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.3152853482771225, 4.8232649412011765],
            [-3.2644519749002083, 4.820440404427211],
            [-3.1798825192223537, 4.815849595875461],
            [-3.1413097887236314, 4.814221079586706],
            [-3.098124636350821, 4.8119544101133],
            [-3.03021138209537, 4.808689828824638],
            [-2.970308077288875, 4.805672593795327],
            [-2.8369410754155187, 4.799702137786462],
            [-2.725709897659185, 4.7943909347666995],
            [-2.668313283005662, 4.79159351852767],
            [-2.6185838948964983, 4.789759930636733],
            [-2.582711162335815, 4.788240735962333],
            [-2.588575995740496, 4.654269006287245],
            [-2.594219087427565, 4.526225349254389],
            [-2.583097288315813, 4.525730352562626],
            [-2.586671801549383, 4.442881186554006],
            [-2.5888035534246074, 4.395430687556932],
            [-2.698605215690079, 4.4005557713682855],
            [-2.7880824528883883, 4.405249320199809],
            [-2.8328417272947526, 4.407093492893726],
            [-2.846510737921243, 4.407448416700922],
            [-2.899027988419633, 4.409841209578923],
            [-2.9036388610405046, 4.4095713990145295],
            [-2.9880126729228906, 4.413811816160736],
            [-3.0748760194663682, 4.418285012889661],
            [-3.0897316759059814, 4.418659305448088],
            [-3.140919054503653, 4.421219890364201],
            [-3.171484934555088, 4.422550896450455],
            [-3.2024882177874177, 4.4246173667131625],
            [-3.336748808254025, 4.431772394303199],
            [-3.3279783823443503, 4.590872916445835],
            [-3.3239459608689135, 4.663408161368577],
            [-3.3176774617536346, 4.779450637924841],
            [-3.3152853482771225, 4.8232649412011765]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.71838758520225,
          "lat": 43.19338370265452
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46121"],
        "coty_name": ["Todd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Todd County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01266989"
      },
      "bbox": [
        -3.336748808254025, 4.395430687556932, -2.582711162335815,
        4.8232649412011765
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.38766511206522, -2.925544994863838],
            [9.391474845593514, -2.91500364109635],
            [9.398805940650206, -2.917090089227463],
            [9.40378676968918, -2.920665856256494],
            [9.43284712745936, -2.878206213319858],
            [9.439188480802095, -2.857375603066362],
            [9.433216665769475, -2.855744450011011],
            [9.434687387673375, -2.8488748946921705],
            [9.440316855871927, -2.8501463926481194],
            [9.449562675086604, -2.855037277612661],
            [9.459093600739557, -2.8582692875329827],
            [9.468623365235384, -2.8629714413886562],
            [9.473967553048423, -2.8705675519822904],
            [9.480798459050442, -2.876093765425008],
            [9.486904590086683, -2.8764303180423436],
            [9.49318154408059, -2.87183365218244],
            [9.497350440752433, -2.8736907781188075],
            [9.499352464183005, -2.881616385488446],
            [9.502990731725177, -2.8832376884572173],
            [9.516205842763394, -2.884242736204192],
            [9.520821236583489, -2.889888062886055],
            [9.528315348306478, -2.8936263626279626],
            [9.534533436735655, -2.898349387700528],
            [9.538380480618708, -2.90338079260909],
            [9.545610072073526, -2.90730013473249],
            [9.548261590534535, -2.9069851637052833],
            [9.557728860101113, -2.9023116943593865],
            [9.562420589685978, -2.9013476729904917],
            [9.565044849858976, -2.90286065236933],
            [9.56758200520751, -2.9077321792906266],
            [9.567700972962282, -2.913501322849415],
            [9.565657032095528, -2.9161786618003385],
            [9.560444945366596, -2.9181928666329826],
            [9.55320936285985, -2.917050389904133],
            [9.546898151405252, -2.918801622484385],
            [9.546087833911573, -2.923646017656339],
            [9.550506841943504, -2.9257732005633477],
            [9.556897421245079, -2.937314240315229],
            [9.565132020960878, -2.9381155083634205],
            [9.575747583254689, -2.9296888005476833],
            [9.580224535684808, -2.9289524167340595],
            [9.586233322171578, -2.9314827445339753],
            [9.591484844073097, -2.936538054892756],
            [9.58919722720677, -2.9410509735076116],
            [9.581075678149206, -2.941028072428038],
            [9.580013353182629, -2.942577106106555],
            [9.582947111583724, -2.9474981670246785],
            [9.586358056283155, -2.9469068781241887],
            [9.588298617109974, -2.9492250939381495],
            [9.587402783606862, -2.952296496918912],
            [9.58134077125778, -2.9549021172320535],
            [9.579361108468321, -2.9577575463473553],
            [9.582069858357439, -2.962069248415017],
            [9.595097150966593, -2.961244288396149],
            [9.59210781044429, -2.97106057866896],
            [9.593376953974333, -2.97715060887714],
            [9.597711952975253, -2.989262201119246],
            [9.597153513665049, -2.9975452899342803],
            [9.595246196081607, -3.00548288176632],
            [9.599354219698709, -3.0159491788471215],
            [9.59963269172549, -3.0189593412741877],
            [9.585781918531772, -3.063716972286011],
            [9.571545218241631, -3.108484965486859],
            [9.58186343718661, -3.111986158471023],
            [9.573840514957878, -3.1358345773706824],
            [9.573136482389868, -3.1391118624978995],
            [9.568917291325782, -3.1702785328634384],
            [9.561616136363899, -3.1968117139827115],
            [9.560310753532915, -3.209417135717603],
            [9.532402233762628, -3.2129131831321103],
            [9.515154316595007, -3.214545688280072],
            [9.49136838049157, -3.2175614229344527],
            [9.428429791624438, -3.22480692539148],
            [9.398066487334532, -3.2285953876316356],
            [9.402099144994333, -3.215584620009261],
            [9.407622307007944, -3.1995975551785176],
            [9.37878495406409, -3.182817244932785],
            [9.371499659404673, -3.1728141522616014],
            [9.37566913540656, -3.1590101853636283],
            [9.368999886438822, -3.1567033469639605],
            [9.373205497335126, -3.1427701290225407],
            [9.36260726918212, -3.1392927567479325],
            [9.36029012232811, -3.1355303168166344],
            [9.361814582139361, -3.1312512920461706],
            [9.358045993787908, -3.1185055979723213],
            [9.344473943290769, -3.0955091417689],
            [9.34184756513669, -3.0927654185498925],
            [9.340733315174804, -3.0846895689287446],
            [9.34135605807466, -3.0717826099393584],
            [9.346733596450854, -3.0719271140578446],
            [9.34704923492431, -3.068766414635981],
            [9.35193058838927, -3.061348772644146],
            [9.353094840711398, -3.0556244159829404],
            [9.353442967443284, -3.044725667844929],
            [9.350023070905017, -3.043750409878255],
            [9.34965200176099, -3.0354761575786875],
            [9.352408290242378, -3.0263572269899406],
            [9.352644780277442, -3.0224955077554876],
            [9.355322742642906, -3.0151579238537596],
            [9.35885367766764, -3.01606622480609],
            [9.361754797962684, -3.010861402981607],
            [9.363205327782305, -3.0051150900481955],
            [9.36785800937545, -2.996765174869796],
            [9.369981147501319, -2.9821168493249925],
            [9.373831956718123, -2.9704109500805864],
            [9.379415355718537, -2.9601406425177443],
            [9.374825216341915, -2.95518417411758],
            [9.375898442348284, -2.9518135566901456],
            [9.383633635886454, -2.9426964991708124],
            [9.384730649433717, -2.9346570663636733],
            [9.391528201368773, -2.930647606200501],
            [9.38766511206522, -2.925544994863838]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.85960908337587, "lat": 35.15414119593499 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47011"],
        "coty_name": ["Bradley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bradley County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01639727"
      },
      "bbox": [
        9.340733315174804, -3.2285953876316356, 9.59963269172549,
        -2.8488748946921705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.775798767946213, -1.5540732718299262],
            [9.802717593634684, -1.5505255754708827],
            [9.881485337598436, -1.541460247991401],
            [9.992097044328535, -1.5293450901225556],
            [9.996680336613615, -1.5331141259528958],
            [9.996232551865472, -1.5437683085411003],
            [9.997870275831472, -1.5482479405963465],
            [9.998053739661977, -1.5574362234017218],
            [10.004000718953934, -1.5624159331069079],
            [10.002953305682473, -1.5675185270789],
            [10.02351299637716, -1.6074012301887313],
            [10.049029095552253, -1.653807675671466],
            [10.05389428258455, -1.6533517116683003],
            [10.054748284533241, -1.6576983594981776],
            [10.052355132653025, -1.660343459478215],
            [10.058420323590951, -1.671979965269516],
            [10.061753956102127, -1.6758492178357407],
            [10.064321583021666, -1.6831080249845387],
            [10.068275823339295, -1.6849629594248912],
            [10.073121968838583, -1.685157466207048],
            [10.07600485085273, -1.6819405421455413],
            [10.079688455855237, -1.6830970797610765],
            [10.082711567327612, -1.687114127442686],
            [10.078498850813013, -1.6908787830430922],
            [10.08055185327131, -1.692345563588966],
            [10.079109524162623, -1.7006040490532293],
            [10.082600211088964, -1.705206251526873],
            [10.079927519883418, -1.7119567501509527],
            [10.074411284709702, -1.717849778030633],
            [10.070287734995818, -1.7245816162449925],
            [10.066648950116454, -1.7250462634940813],
            [10.061461792628556, -1.720318167280121],
            [10.055388782701057, -1.7199739672298866],
            [10.045081716216988, -1.714167418318278],
            [10.042385006875778, -1.7226483358256925],
            [10.042595021175568, -1.7261816809970436],
            [10.04512902382064, -1.7315550804223458],
            [10.0419465154439, -1.736232425869509],
            [10.046438250078603, -1.7399324680164505],
            [10.049868643597613, -1.7453949687764214],
            [10.04790314639439, -1.7520533967931973],
            [10.039534767417958, -1.7576958845400297],
            [10.045421458948692, -1.7590825448896903],
            [10.037192881702152, -1.7626725881416305],
            [10.043490914118722, -1.7698046784776604],
            [10.04267604616066, -1.7722477493204227],
            [10.037117055336862, -1.7709208102679745],
            [10.036347525814504, -1.7749853737778658],
            [10.038709926251043, -1.7840574245179104],
            [10.037961014903315, -1.7889177210304188],
            [10.039087532544903, -1.8053527524857218],
            [10.03890157022098, -1.8114787555381884],
            [10.035902087429506, -1.812572005763846],
            [10.039933377152249, -1.8195856797239631],
            [10.03388410244067, -1.8296095543540725],
            [10.032804422481583, -1.8375777539687812],
            [10.02697899833917, -1.8360800648864284],
            [10.022033522963019, -1.8390427267492673],
            [10.022168044924298, -1.8489260293416367],
            [10.019479209290186, -1.8505576259669143],
            [10.01402099768719, -1.8494191009782524],
            [10.008217141893764, -1.8512731657854788],
            [10.00560852809214, -1.8503832114626002],
            [10.001234279300968, -1.843818381971305],
            [10.001180038425124, -1.8389438575983585],
            [9.998500418506465, -1.8260615070793802],
            [9.994916719639017, -1.822548890341285],
            [9.990601638680372, -1.8227907397851901],
            [9.989454677481906, -1.8251731160841753],
            [9.993770147046835, -1.8300171267049317],
            [9.99244561582952, -1.8360830143097815],
            [9.988059437425848, -1.8421291439197136],
            [9.989459507703017, -1.8493757392080274],
            [9.986967754230475, -1.853860088375142],
            [9.979834161662657, -1.8623880627889213],
            [9.978509934831198, -1.8703853012018046],
            [9.980144147896942, -1.8756701390860515],
            [9.975843548908875, -1.8798737120208702],
            [9.969166263965185, -1.8755381817899721],
            [9.965503519032596, -1.8802626399281266],
            [9.966340624614125, -1.8862581946203516],
            [9.970496891079334, -1.8891914495978452],
            [9.97270246711284, -1.8938958325295423],
            [9.97255187280529, -1.8971687155021553],
            [9.96742215033595, -1.9005609148739815],
            [9.960046585511392, -1.899285730240158],
            [9.95556313894868, -1.9004278175597034],
            [9.955458563625244, -1.9074345462178146],
            [9.94731742832848, -1.9064008679263105],
            [9.944901891055885, -1.8989221365720088],
            [9.939997226517503, -1.897708508562734],
            [9.930666566582097, -1.899083988011879],
            [9.925365331443466, -1.8986655431714365],
            [9.914816044184267, -1.899853375869467],
            [9.907920358195705, -1.898174557028075],
            [9.899227208615853, -1.899120589639791],
            [9.891314754403615, -1.8974058994297351],
            [9.881783697260163, -1.8991053827070554],
            [9.845769452574528, -1.898307660877935],
            [9.845434439477952, -1.9007892625562384],
            [9.847266745406287, -1.910320874625784],
            [9.846749584287263, -1.9178065124784722],
            [9.850432306802645, -1.9234479196582248],
            [9.850263745706474, -1.9266203761583127],
            [9.845582948301935, -1.9291342544042158],
            [9.845007265241374, -1.9355087009646652],
            [9.849412292604587, -1.9417719015013797],
            [9.850044563206064, -1.9474887635811908],
            [9.849219394516732, -1.9518610165199646],
            [9.851989642638069, -1.955989296499778],
            [9.85138086296985, -1.9614528224688803],
            [9.843212472346464, -1.967042950335821],
            [9.834378057026859, -1.9627527751109048],
            [9.832568626975604, -1.9592162686979253],
            [9.82792690714382, -1.9562345619015724],
            [9.823798978561557, -1.9586780995905402],
            [9.820008353211664, -1.9534556883750864],
            [9.817024868501134, -1.951487580842013],
            [9.813844027696081, -1.9459860124414894],
            [9.804488903278855, -1.941350684262029],
            [9.79909041624897, -1.9341917728499678],
            [9.79388955980582, -1.9305658806319568],
            [9.790134229443042, -1.9295055250793591],
            [9.784156701908278, -1.9352251631760102],
            [9.773915567680186, -1.9390309471876574],
            [9.775830768828474, -1.942094022218354],
            [9.768487067545449, -1.9452911777184536],
            [9.765675626275415, -1.9434016702564239],
            [9.754928212604566, -1.9398471033578488],
            [9.746312016095256, -1.9418225290306774],
            [9.740174911406285, -1.9443052764843907],
            [9.734092565943566, -1.9406823601978491],
            [9.7331917893271, -1.933373282824157],
            [9.735810237198187, -1.928477601714525],
            [9.72908803724364, -1.9196476664827768],
            [9.729542593062753, -1.9115620456974607],
            [9.726704878657609, -1.905506120682699],
            [9.726061539547585, -1.8976569143074413],
            [9.729073449100262, -1.8913914169332782],
            [9.734247862845077, -1.8883157921915057],
            [9.735585080364727, -1.8847969756616156],
            [9.742238357986725, -1.8800140463990278],
            [9.745806172968159, -1.8795747944607848],
            [9.748244179594424, -1.877034163356965],
            [9.757315465331512, -1.8756062063795036],
            [9.75723567856503, -1.8723651986728886],
            [9.75965312674443, -1.86850921497932],
            [9.747262901444433, -1.7890233426123603],
            [9.751181799279484, -1.7901665804397138],
            [9.752636704482814, -1.7863272378646098],
            [9.745894833798902, -1.780550782682807],
            [9.747956442813901, -1.778364946406078],
            [9.745098802079047, -1.774752512400606],
            [9.743303802064561, -1.7654174973743646],
            [9.746039384445952, -1.7628435331816983],
            [9.750477155661974, -1.761686047797915],
            [9.7555069182976, -1.7665419299735827],
            [9.759898831633311, -1.7690739519390777],
            [9.76142460521022, -1.7667454053517035],
            [9.752384921549057, -1.7594315190615566],
            [9.748250990548916, -1.7533415352993729],
            [9.747029634222052, -1.7496512854920077],
            [9.738683016859273, -1.7419312855748503],
            [9.731769077352139, -1.7387817819106879],
            [9.727768039889337, -1.7162188208710774],
            [9.729469670640308, -1.7134461593784174],
            [9.726144201313351, -1.7042980236673024],
            [9.72360301571175, -1.7009743309932572],
            [9.717972125444309, -1.698796466037193],
            [9.719228520457492, -1.6905490284099913],
            [9.72355474182424, -1.6883855286865035],
            [9.728273030378265, -1.688478304308293],
            [9.727331905510438, -1.6821493749781693],
            [9.730025188350703, -1.677814617716763],
            [9.728295507579224, -1.6733244799424816],
            [9.729661715468414, -1.668917338811084],
            [9.727710401296738, -1.665602382684059],
            [9.730155631751915, -1.6601745481699475],
            [9.725541247160843, -1.6553750233806577],
            [9.732979070532378, -1.6492612944158078],
            [9.731459355225613, -1.6434498849487298],
            [9.735501648292976, -1.6430528295711713],
            [9.745600691966514, -1.645567957937692],
            [9.75082539769492, -1.6437021864358656],
            [9.759754438417577, -1.6425979418990828],
            [9.766843191921657, -1.644770968347219],
            [9.769431338213396, -1.6436370025306573],
            [9.777806613558738, -1.6354813194312425],
            [9.783941376060305, -1.635441416086958],
            [9.786873823860121, -1.6320127306759686],
            [9.787038421486738, -1.6238573652777337],
            [9.784686104073566, -1.6191717273378121],
            [9.790436790419283, -1.6151021151788874],
            [9.791044723989824, -1.610959055004604],
            [9.788374456079879, -1.5997987301426793],
            [9.790262796695428, -1.5969202505010074],
            [9.78748707363367, -1.589432766745066],
            [9.78874855006243, -1.5802245055870265],
            [9.777050654877259, -1.5796469775084603],
            [9.777933101024852, -1.573841778744248],
            [9.775798767946213, -1.5540732718299262]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.14937769208133, "lat": 36.40354734277392 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47013"],
        "coty_name": ["Campbell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Campbell County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01639728"
      },
      "bbox": [
        9.717972125444309, -1.967042950335821, 10.082711567327612,
        -1.5293450901225556
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.3105465146993085, -2.438673813532386],
            [6.321276745300336, -2.434073693329369],
            [6.324404878257255, -2.4385455052148632],
            [6.332722178812293, -2.4340995000010714],
            [6.3414620634646175, -2.4347223828782982],
            [6.336015441266881, -2.3814926538799583],
            [6.368466959387513, -2.379820767444301],
            [6.410823008382602, -2.377384870723768],
            [6.434514552501951, -2.3757524633119615],
            [6.433138416314132, -2.3388287649251094],
            [6.462691937732201, -2.337501012340016],
            [6.478736291398707, -2.336359003880454],
            [6.478823876240561, -2.337360705509304],
            [6.5572262217127255, -2.332255595654121],
            [6.56090589211123, -2.332222971700576],
            [6.61339478025957, -2.328618003621101],
            [6.687708271385087, -2.3244880162412165],
            [6.6891434623634005, -2.3503597958232922],
            [6.699000072818472, -2.488710739656768],
            [6.705252613514124, -2.5859265830172267],
            [6.6987277644853265, -2.5862164967420362],
            [6.699230154838037, -2.5954785646757528],
            [6.70584874857664, -2.5949766546273603],
            [6.707847986538715, -2.62573515542584],
            [6.739591342929428, -2.6238756773771894],
            [6.740946392593154, -2.653154760338839],
            [6.671855937344819, -2.656751900047361],
            [6.666567242032487, -2.6571350681193717],
            [6.55919411565139, -2.662881888744995],
            [6.485962075950751, -2.666631174154018],
            [6.4830995831920335, -2.667205181318439],
            [6.428046695552687, -2.6701522778040245],
            [6.426221980659639, -2.6724427445516796],
            [6.426871889445026, -2.6799815573449193],
            [6.420499161774626, -2.6787821536923833],
            [6.412857840261243, -2.684647906466114],
            [6.409246527313283, -2.690047907122317],
            [6.408322678456223, -2.694554650273453],
            [6.405545534804668, -2.6951219945944533],
            [6.406183987041553, -2.7079201108950937],
            [6.400538570855934, -2.7081687631485543],
            [6.370109411206562, -2.7096835163084387],
            [6.320303593900206, -2.7126332358572776],
            [6.3189540161715145, -2.6785899882302004],
            [6.31882736492591, -2.6620953526686573],
            [6.318232588329134, -2.654580293918283],
            [6.318657130560113, -2.640669545152136],
            [6.31778215510619, -2.627907921664948],
            [6.315187472815057, -2.5424043920619597],
            [6.31298724692673, -2.5018784122642925],
            [6.3131061000221536, -2.5001035534667517],
            [6.311288003147109, -2.4614522679729434],
            [6.3105465146993085, -2.438673813532386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.45028632897228,
          "lat": 35.973147748212774
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47017"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01639729"
      },
      "bbox": [
        6.3105465146993085, -2.7126332358572776, 6.740946392593154,
        -2.3244880162412165
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.25155483988411165, -10.479058930090572],
              [-0.24169255563674755, -10.424864216504641],
              [-0.24075076957305194, -10.431678894149687],
              [-0.23827098653773612, -10.43631817337647],
              [-0.23348028770299598, -10.441944996864347],
              [-0.23055253217325453, -10.454755433216352],
              [-0.2292030170790286, -10.45661370280759],
              [-0.22257868503521722, -10.45553862161556],
              [-0.22939443221668268, -10.462470650793032],
              [-0.22845311631376614, -10.46739829285358],
              [-0.23015879687323332, -10.47046502333095],
              [-0.24408254079027844, -10.477536279053599],
              [-0.24722603896510267, -10.476586631526862],
              [-0.25155483988411165, -10.479058930090572]
            ]
          ],
          [
            [
              [-0.1016082783424173, -9.997655450963727],
              [-0.0937887563741392, -9.996178575058984],
              [-0.08526650045098057, -9.99270890174352],
              [-0.0736851596055444, -9.989005099670045],
              [-0.06318453939742355, -9.987213933737982],
              [-0.058374386079990036, -9.985669734786006],
              [-0.05049864721986071, -9.985565489325879],
              [-0.046273290657257556, -9.990860424827355],
              [-0.04556410790706968, -9.997784489831163],
              [-0.043802473879826706, -10.003632292601564],
              [-0.045881135362741625, -10.011938897439842],
              [-0.04213075750338997, -10.012139267161299],
              [-0.04117973137576517, -10.004526762718154],
              [-0.030812479545396457, -10.005098036862178],
              [0.045914736207312644, -10.003774788225417],
              [0.043633599734130044, -10.007906859142235],
              [0.0872994332050055, -10.007140730255765],
              [0.08718364604952987, -9.997116390322107],
              [0.09430782806633517, -9.99725586319908],
              [0.10565056393628335, -9.981203538348218],
              [0.11276608835205694, -9.980994395706295],
              [0.11212218090914623, -10.020658677727011],
              [0.10843181543627659, -10.020647231632738],
              [0.10822023488124431, -10.035847482866687],
              [0.17935781442589221, -10.034948140941086],
              [0.17994245484539778, -10.0670397761871],
              [0.15345779677224575, -10.197999131944258],
              [0.14562965372181308, -10.236069463439591],
              [0.1300525954023004, -10.314481521710713],
              [0.11938818993682097, -10.323233731664358],
              [0.1202030299968922, -10.32985541829437],
              [0.11037441051018429, -10.347410431727633],
              [0.09940641232069813, -10.361422089390244],
              [0.08729224934716483, -10.37316995824819],
              [0.07280381837628894, -10.385967778212951],
              [0.06445393380458574, -10.390991451194978],
              [0.05058671904306909, -10.397595220530969],
              [0.028989233378889024, -10.406905632827804],
              [0.0050517069221609956, -10.41862779300862],
              [-0.031429979339040987, -10.43802743626382],
              [-0.05130698849864661, -10.449873870420548],
              [-0.09480964549868778, -10.478044751811906],
              [-0.11643498624880493, -10.492986199198034],
              [-0.14927075344481547, -10.516728694629041],
              [-0.1771015506563493, -10.537944953280652],
              [-0.20165548097982355, -10.55737503038709],
              [-0.23269467903732188, -10.583207237195412],
              [-0.2557561361210345, -10.602718109849386],
              [-0.291605574730421, -10.635258834195566],
              [-0.29213961253184173, -10.63226001437493],
              [-0.28627272772593243, -10.625748686093118],
              [-0.28603764437079354, -10.62189025860704],
              [-0.2834543231578027, -10.612306802728897],
              [-0.2776656810121653, -10.602245041699005],
              [-0.2777030132366955, -10.597524490167402],
              [-0.2715442726253742, -10.58924099063528],
              [-0.27093497176233194, -10.58642286028039],
              [-0.26683928136315543, -10.585204434083778],
              [-0.2537873639504095, -10.574347762158586],
              [-0.2523658750178583, -10.571234899783956],
              [-0.2532806810486152, -10.564900105597841],
              [-0.24680784244756593, -10.562426929990911],
              [-0.2457128055571183, -10.557302149354165],
              [-0.24652705779070405, -10.553843979057817],
              [-0.25146168147511294, -10.55345398365808],
              [-0.25800602811031603, -10.556480003901223],
              [-0.2602850578712874, -10.55255851930913],
              [-0.2585254674527816, -10.543742608135508],
              [-0.25859660915761384, -10.539839497923397],
              [-0.26174864818189486, -10.535020177658645],
              [-0.2609391655387479, -10.530465263810052],
              [-0.25891254461346297, -10.527925884667743],
              [-0.2586652666631447, -10.523615408233317],
              [-0.25456769961328995, -10.523752854227864],
              [-0.24865473361843943, -10.520516880182797],
              [-0.24218457344564742, -10.513485840117067],
              [-0.2383804253959359, -10.511052944053596],
              [-0.23153775310249422, -10.509466046267944],
              [-0.21828484120350827, -10.51113235894929],
              [-0.196081016644474, -10.510825386943866],
              [-0.18642778705506238, -10.509479043237729],
              [-0.18367163823867275, -10.512603301913297],
              [-0.1731840860492578, -10.513590743591566],
              [-0.1704609531866552, -10.511077180628883],
              [-0.1694557811787448, -10.506593273003874],
              [-0.16235419652484778, -10.50327161123904],
              [-0.15701341661094348, -10.502435210589086],
              [-0.1529620141328616, -10.497851410791114],
              [-0.1562674874457558, -10.490333085793123],
              [-0.15727674866214025, -10.48478194166462],
              [-0.14601982196043056, -10.48239938702313],
              [-0.13189864557451725, -10.476031424194206],
              [-0.12191272255733034, -10.474766144421661],
              [-0.11789871015315008, -10.471508193280634],
              [-0.12186832203270352, -10.468504465833961],
              [-0.11891981732374181, -10.463173287125109],
              [-0.11341328357517609, -10.465238286390244],
              [-0.11332843207672524, -10.458659834759821],
              [-0.11085045894123145, -10.45796862249739],
              [-0.10916188448268985, -10.449301320105738],
              [-0.09803347811219414, -10.442288679810423],
              [-0.09195378403722256, -10.439654379042787],
              [-0.08061977702212317, -10.43881641928994],
              [-0.08256141254730061, -10.434808966824113],
              [-0.08794327456810475, -10.432786600853074],
              [-0.07888192603416314, -10.43057840261383],
              [-0.07725432057220702, -10.428869636067368],
              [-0.0681379720049811, -10.425551450193524],
              [-0.06259727453163579, -10.42482576715112],
              [-0.060069229344382184, -10.421581485440408],
              [-0.0617465457101658, -10.418552536473344],
              [-0.0692735380470039, -10.420038721245707],
              [-0.07176133982973666, -10.417983248497707],
              [-0.06929504118356777, -10.409829047938311],
              [-0.06519761613811775, -10.409135637850104],
              [-0.05024621222905854, -10.401119737877222],
              [-0.04447979336693071, -10.401872240077033],
              [-0.02947021056634495, -10.401139383015424],
              [-0.021587970281888552, -10.399029713595386],
              [-0.01958534460827536, -10.397501172101677],
              [-0.01755347254520704, -10.390944839943547],
              [-0.014276787302278274, -10.386756239302771],
              [-0.007643394092131274, -10.382585049825064],
              [0.0001320412027612829, -10.38037055192775],
              [0.03782800686202667, -10.373589617736334],
              [0.050743382545401894, -10.370881880242186],
              [0.06628942761829192, -10.36623617410301],
              [0.07491413647466584, -10.361145181240133],
              [0.0739088751662092, -10.35200786583468],
              [0.08109147446108611, -10.3408566137606],
              [0.07671157042989103, -10.335809344295438],
              [0.0712662080766016, -10.334347989827872],
              [0.05336114571909787, -10.337729188462033],
              [0.047861246200790915, -10.339264548223415],
              [0.05040986869003811, -10.332812930799168],
              [0.06428919851898655, -10.32456915476207],
              [0.0666340655338613, -10.316474856191997],
              [0.06906280633027997, -10.312690475584839],
              [0.09280425232964172, -10.300999460783318],
              [0.0966184132551543, -10.2916809098183],
              [0.09338336827587647, -10.288692177899074],
              [0.06436709193130052, -10.286817027491754],
              [0.05732569353690921, -10.291092251452504],
              [0.05279757686741279, -10.295378954394897],
              [0.04113000676303099, -10.302297575428593],
              [0.012519944820788846, -10.321232569000259],
              [0.0020086326145730728, -10.326306243279284],
              [-0.02152437097265965, -10.334793500116094],
              [-0.028357898967539718, -10.337833270897333],
              [-0.04192749636903788, -10.34503794198918],
              [-0.05256691862082561, -10.352773037637961],
              [-0.0672306621585409, -10.36622741977632],
              [-0.08412809499628807, -10.383668112531947],
              [-0.08813378049850872, -10.386515382229838],
              [-0.08085565606842111, -10.396517068091295],
              [-0.08401762983552406, -10.39854874713415],
              [-0.08967565199816561, -10.397383285729479],
              [-0.08930957331350425, -10.389791804589233],
              [-0.09451635341386833, -10.384010779325658],
              [-0.11602921971593609, -10.384791292141125],
              [-0.12286294643750664, -10.386899629845008],
              [-0.12353398561261021, -10.392744048338274],
              [-0.14041171664462, -10.38786496489993],
              [-0.14343994169467125, -10.374440905256893],
              [-0.15860077481075252, -10.354039904943589],
              [-0.16002549594204962, -10.348257637276681],
              [-0.15452940803183937, -10.342551141958374],
              [-0.1532006486092927, -10.333121802315802],
              [-0.15322735441924684, -10.322656713794446],
              [-0.15519216786286952, -10.31905099304496],
              [-0.16240219979496803, -10.313670827322936],
              [-0.1592020656622864, -10.310858255123083],
              [-0.15821602726169198, -10.303263891641251],
              [-0.15900274951766036, -10.29929825103667],
              [-0.16446431495827674, -10.295827149473814],
              [-0.17735799426327925, -10.294474863999946],
              [-0.17959938544267798, -10.295572860894762],
              [-0.19627076822133696, -10.291043587147541],
              [-0.1997670722037379, -10.282707302730488],
              [-0.19987941949002866, -10.270704327700965],
              [-0.20090110471073427, -10.267413993507637],
              [-0.20515998597946233, -10.262969374347236],
              [-0.2203766198809042, -10.25351512092641],
              [-0.2269366292442825, -10.24884633641002],
              [-0.2350193383798553, -10.238626521728685],
              [-0.2355218778714323, -10.236160172737572],
              [-0.23500245014033797, -10.224267147628145],
              [-0.24106318011995456, -10.222781733996124],
              [-0.25441677617617264, -10.229233485403872],
              [-0.261579307298883, -10.233993281752554],
              [-0.26538601415231033, -10.238063514445127],
              [-0.2639985013424907, -10.246999231681007],
              [-0.2574569873869474, -10.244867678446646],
              [-0.25070884363977164, -10.248444953459307],
              [-0.24271905954898623, -10.245023675979851],
              [-0.24154531775410548, -10.242470159407741],
              [-0.2356045434045296, -10.245903132194737],
              [-0.23303483604012734, -10.251668037427754],
              [-0.22746715098159148, -10.257324229124986],
              [-0.2320411008567988, -10.256945678355093],
              [-0.23941891166351695, -10.261913925011715],
              [-0.24168103443897004, -10.265231677791885],
              [-0.24957128333064094, -10.272824169219803],
              [-0.2534251639603831, -10.273366005074637],
              [-0.25833686227917324, -10.266839281077974],
              [-0.2621004591880405, -10.258253534065446],
              [-0.2678095856102069, -10.255455088126164],
              [-0.2716873887700058, -10.24936871955764],
              [-0.2764655392817922, -10.245073614987506],
              [-0.276741823341126, -10.23884314854341],
              [-0.2791520001146656, -10.233945762045865],
              [-0.28412120856087003, -10.23142619616958],
              [-0.28400911897918274, -10.227813197592816],
              [-0.2908576139212666, -10.229856736599126],
              [-0.2951749584230651, -10.228091358674378],
              [-0.2966775688659078, -10.224966581381866],
              [-0.29674170207492767, -10.217021918170198],
              [-0.2987099448889546, -10.213690476722412],
              [-0.3026064904472988, -10.2125410243833],
              [-0.3107239341606109, -10.208230603430177],
              [-0.3113865904833361, -10.20272576062254],
              [-0.31403164294311403, -10.198967238276534],
              [-0.3209889983358508, -10.19725558531113],
              [-0.32279194568534486, -10.190509320183061],
              [-0.3279470992186195, -10.186760236388661],
              [-0.3262144646734626, -10.183977528793886],
              [-0.32916201121616195, -10.177378094268121],
              [-0.3338298854437417, -10.172710710598338],
              [-0.329942207969756, -10.168053515737375],
              [-0.328972191573897, -10.162414201928106],
              [-0.32428587750773974, -10.156286703334441],
              [-0.3257988559142803, -10.153029401263],
              [-0.3301349388816691, -10.150505940423042],
              [-0.3268916223215256, -10.145169165108483],
              [-0.3317334614833139, -10.138369806165736],
              [-0.33565267761336676, -10.137520662171976],
              [-0.33359796934070035, -10.1339407608249],
              [-0.33644731309804665, -10.132611406433846],
              [-0.3385781385443975, -10.136496046888887],
              [-0.34321622345773956, -10.134381400344918],
              [-0.3440127270436548, -10.13186495821685],
              [-0.3510320979147807, -10.121756185506708],
              [-0.3549276465562675, -10.118801981429252],
              [-0.2870827867418876, -10.071804402163181],
              [-0.21630558500141775, -10.051728616118808],
              [-0.17166717982994734, -10.03878323404395],
              [-0.1212154367960435, -10.003813890465723],
              [-0.11610924194377846, -10.00781441291421],
              [-0.1016082783424173, -9.997655450963727]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.60173474965224, "lat": 28.50750861077133 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48057"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01383814"
      },
      "bbox": [
        -0.3549276465562675, -10.635258834195566, 0.17994245484539778,
        -9.980994395706295
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.7586167745103438, -4.814283089926311],
            [-0.7393121380761162, -4.82644248000465],
            [-0.7317439462887229, -4.839158041676712],
            [-0.7324831277602122, -4.85969551863227],
            [-0.737793746343059, -4.875480113024259],
            [-0.7410689837867087, -4.881017530091754],
            [-0.7423198592683089, -4.888816352928839],
            [-0.7393074484567339, -4.896081046865715],
            [-0.7344446725829482, -4.9022233285874925],
            [-0.7272089241124445, -4.907114305384991],
            [-0.7126799251317331, -4.911724483042338],
            [-0.6994066530048015, -4.912476948435013],
            [-0.6685182376997372, -4.912316304132816],
            [-0.6623255122589277, -4.908079946140605],
            [-0.6564682405602151, -4.901884910811864],
            [-0.6478806201997932, -4.888095967248726],
            [-0.6400909074470864, -4.869948678445634],
            [-0.6371395907758028, -4.852818418309492],
            [-0.6342183474811811, -4.8477543220678045],
            [-0.628748283780804, -4.848196983992929],
            [-0.6268782298361822, -4.853672244923708],
            [-0.6352646484823117, -4.867923212120665],
            [-0.6363795194189873, -4.874851385080301],
            [-0.631552509151963, -4.87672270891109],
            [-0.6275610416820446, -4.873212504921255],
            [-0.6227739394242122, -4.867120060548437],
            [-0.6195913779123611, -4.865288732723665],
            [-0.6158063585603446, -4.85785176632486],
            [-0.6157731327655191, -4.843714008732132],
            [-0.6120302732469971, -4.845870585785309],
            [-0.5961400354471801, -4.864065444153643],
            [-0.587447077896571, -4.86950370153306],
            [-0.5877289143776834, -4.874576453066203],
            [-0.5833654987866301, -4.874581482115157],
            [-0.5790009865878137, -4.870431317467933],
            [-0.5720150094649384, -4.869647292063879],
            [-0.5700181212074066, -4.867628699297604],
            [-0.5657463926333478, -4.85786880493354],
            [-0.5629168735847604, -4.832563685975354],
            [-0.5594710821324866, -4.826652094321013],
            [-0.5465367845922138, -4.818421149828459],
            [-0.5336688071530674, -4.817157897513485],
            [-0.5297546467892246, -4.818998619175145],
            [-0.5128896533190455, -4.832843996958248],
            [-0.5081769050541116, -4.8413857236611975],
            [-0.49803850549303463, -4.886623265153487],
            [-0.49828478818461414, -4.89356252548986],
            [-0.5023074077333431, -4.898592360600659],
            [-0.5103900240073158, -4.902467608704895],
            [-0.5205491369337325, -4.902409388843837],
            [-0.525555252277705, -4.906346585696477],
            [-0.5287702991534214, -4.911823713566369],
            [-0.5300296367298329, -4.918428463045193],
            [-0.5308188054033479, -4.9307852221145305],
            [-0.5266424916273573, -4.940583643736965],
            [-0.5187988267076147, -4.952149684700317],
            [-0.5164038289004469, -4.964163765566707],
            [-0.5207159987612878, -4.972803076813485],
            [-0.5146041969583489, -4.97856549777908],
            [-0.5117257733710231, -4.9782329014383695],
            [-0.5039881117561404, -4.996718221399728],
            [-0.4966242055514524, -5.005060146210775],
            [-0.48535741428125995, -5.012577284600046],
            [-0.47560115483103715, -5.016008654294749],
            [-0.46618523020326946, -5.017849309634427],
            [-0.45556305500143174, -5.016104541199032],
            [-0.4483016069960081, -5.012371785012247],
            [-0.4421549347529457, -5.007223663197869],
            [-0.4370489099039564, -4.999950752267414],
            [-0.43292112899049184, -4.991148928213757],
            [-0.43157535325583507, -4.981917703180227],
            [-0.4318664629491268, -4.969505367543714],
            [-0.4339411494030577, -4.9608639189554244],
            [-0.43877232841642416, -4.945801522312684],
            [-0.43936687666644314, -4.936280054788995],
            [-0.43710907711644387, -4.930720484383538],
            [-0.4336629199710442, -4.926092714383004],
            [-0.42585669714921287, -4.922157535752392],
            [-0.41265802520012296, -4.918970351464572],
            [-0.40069599166708325, -4.917720587097092],
            [-0.40152366830839276, -4.905327483246655],
            [-0.40453550430623975, -4.901188951994025],
            [-0.4088888224997799, -4.898249941694646],
            [-0.41804608808620924, -4.895489824463359],
            [-0.4295468558334709, -4.894312093753429],
            [-0.43529121686163297, -4.889845039962841],
            [-0.4325275672664839, -4.881236863982544],
            [-0.42288470118398863, -4.876113280185228],
            [-0.41664114409782166, -4.874372534977707],
            [-0.4098684546805849, -4.876516964925526],
            [-0.406611106251252, -4.879226259158918],
            [-0.40268580992079306, -4.888477489846473],
            [-0.3987850240193981, -4.895554862758691],
            [-0.3928071078358508, -4.8969210794767575],
            [-0.3783568738511068, -4.888931493071442],
            [-0.3686655219657555, -4.875600790114407],
            [-0.35802253690489994, -4.864414605236644],
            [-0.350411207139758, -4.849439813891042],
            [-0.3468924490401635, -4.844520971178073],
            [-0.34765676471621343, -4.8305415621696115],
            [-0.3506494936130883, -4.8168548149110295],
            [-0.35567714686091945, -4.803181393328526],
            [-0.35653003496860525, -4.793440513866708],
            [-0.3558001656633549, -4.7878516097816775],
            [-0.3495678254918364, -4.780517511745298],
            [-0.3441536857915942, -4.7788594625338945],
            [-0.3425284160671105, -4.780129246242789],
            [-0.3439768398190412, -4.786108592014046],
            [-0.343056815613303, -4.793720650890182],
            [-0.34074228328489875, -4.797896041209564],
            [-0.33712557855189995, -4.799597666319569],
            [-0.32037933006719266, -4.7909442803561495],
            [-0.31399142425070525, -4.786354073949798],
            [-0.3155812416763886, -4.938126197953607],
            [-0.3157979577383236, -5.016376223777595],
            [-0.31638124762897085, -5.130768317999371],
            [-0.3176975479131248, -5.253281514230631],
            [-0.31870231823606876, -5.320887177069872],
            [-0.38351697342395247, -5.317671124724054],
            [-0.45782719264718647, -5.31369932416919],
            [-0.5475697488697542, -5.309558103316714],
            [-0.6163250913200775, -5.305984263747686],
            [-0.6825926287291164, -5.302374621345655],
            [-0.6824905793349808, -5.299929539289827],
            [-0.7687070505128218, -5.297840104348768],
            [-0.7664878446073212, -5.189427493861221],
            [-0.7639394983083742, -5.08200229212922],
            [-0.7628720414397268, -5.032609977162938],
            [-0.7586167745103438, -4.814283089926311]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.2125876118251, "lat": 33.639249701643344 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48097"],
        "coty_name": ["Cooke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cooke County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01383834"
      },
      "bbox": [
        -0.7687070505128218, -5.320887177069872, -0.31399142425070525,
        -4.7788594625338945
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.421618174809894, -5.5651511514174645],
            [-5.368233402814036, -5.568677068603821],
            [-5.365339001542913, -5.5692209795461025],
            [-5.2469820683105945, -5.578209694679719],
            [-5.198122802354384, -5.581826238322375],
            [-5.168687230201297, -5.5837664613111775],
            [-5.03104898660057, -5.593399797304769],
            [-5.025869061960424, -5.5939125211312195],
            [-4.897991573023618, -5.602487352137701],
            [-4.896734569838294, -5.602756863124479],
            [-4.811008030538286, -5.608267536799134],
            [-4.753229425145996, -5.612114227824056],
            [-4.732100316530531, -5.61377262046786],
            [-4.709489721485852, -5.614862469866761],
            [-4.710345164303283, -5.629745630340637],
            [-4.716515860489319, -5.755078299118613],
            [-4.720145373029584, -5.814521791360511],
            [-4.723397387263106, -5.871283077157687],
            [-4.733232040669349, -6.050256692103914],
            [-4.740206569817512, -6.049830167228904],
            [-4.874472220083576, -6.040851836950853],
            [-4.877757505500935, -6.040895027431478],
            [-4.959602062356346, -6.035571581478904],
            [-4.962124781750885, -6.034993442935843],
            [-4.981013118821184, -6.034054115033404],
            [-5.076908203598467, -6.027296927475496],
            [-5.236960669976122, -6.015896550241915],
            [-5.3970108692620045, -6.004464500510978],
            [-5.400535111826968, -6.004485745086568],
            [-5.454289322077781, -6.001206821668548],
            [-5.446744981140841, -5.899108655229186],
            [-5.444958499613782, -5.8772866035691],
            [-5.442445253150781, -5.841124172482838],
            [-5.435326439382098, -5.7466578145608915],
            [-5.431483826070722, -5.696523663410827],
            [-5.428569983659001, -5.655763599092008],
            [-5.425959875538643, -5.624160510792812],
            [-5.421618174809894, -5.5651511514174645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.63518758118106,
          "lat": 32.74074873980269
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48165"],
        "coty_name": ["Gaines"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gaines County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "01383868"
      },
      "bbox": [
        -5.454289322077781, -6.050256692103914, -4.709489721485852,
        -5.5651511514174645
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.176834020137501, -7.716316060396256],
            [-7.060862620082237, -7.656876366771625],
            [-6.944917946243461, -7.597394598972705],
            [-6.82899978601322, -7.537871228558863],
            [-6.713107926069528, -7.4783067266891505],
            [-6.627004010443321, -7.4349104857096],
            [-6.540914169567597, -7.391492329770183],
            [-6.442743412186868, -7.340874480923579],
            [-6.415641522851968, -7.365584150739584],
            [-6.337067632952275, -7.4363060785446695],
            [-6.25847200663691, -7.5069985881876145],
            [-6.179854466637432, -7.577661361771022],
            [-6.1012148360832565, -7.648294081419177],
            [-6.029874858313747, -7.712681796381014],
            [-5.971836470539567, -7.767332621756938],
            [-5.913785101933905, -7.821965491091961],
            [-6.021528700975369, -7.896034462160011],
            [-6.129302606830249, -7.970055267792439],
            [-6.131464433258225, -7.9717547937590245],
            [-6.1688143858805695, -7.9973322456167795],
            [-6.172217466903495, -7.999329763898503],
            [-6.2431216497721875, -8.04809911721504],
            [-6.329213790744824, -8.041377077292601],
            [-6.4088591443957945, -8.016192364757616],
            [-6.412778417098382, -8.014481975201162],
            [-6.497772749904652, -7.987049721562871],
            [-6.614514738022873, -7.948880967426379],
            [-6.731240865339827, -7.9106814518248525],
            [-6.847951215261946, -7.872451335119135],
            [-6.964645871039277, -7.834190776870988],
            [-7.097793209796178, -7.790043086807251],
            [-7.230920091086779, -7.745856051005591],
            [-7.233731154670362, -7.745307684371865],
            [-7.176834020137501, -7.716316060396256]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.13996314011656,
          "lat": 30.715375284424248
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48243"],
        "coty_name": ["Jeff Davis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jeff Davis County"],
        "coty_fp_code": "243",
        "coty_gnis_code": "01383907"
      },
      "bbox": [
        -7.233731154670362, -8.04809911721504, -5.913785101933905,
        -7.340874480923579
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.8305453826055906, -4.834870707665961],
            [-2.6975077837674895, -4.840866716807632],
            [-2.6993295182245967, -4.84617102809509],
            [-2.6954863867099923, -4.8538207735035135],
            [-2.697245555485259, -4.85617205668113],
            [-2.6939510310944685, -4.8588138632820455],
            [-2.6894034417077965, -4.855494528850442],
            [-2.6859067516948003, -4.856670422113654],
            [-2.677586463730096, -4.849646970292456],
            [-2.6726413950552566, -4.853346372674627],
            [-2.667002319964831, -4.860331792719287],
            [-2.6636578978776444, -4.860890845514494],
            [-2.660867398207739, -4.858504536520636],
            [-2.65507447998044, -4.8602705296377104],
            [-2.650952131235661, -4.857304853950642],
            [-2.6475619393860272, -4.857521490097419],
            [-2.6444797295671787, -4.861077919533306],
            [-2.640141892410492, -4.856170416373562],
            [-2.633502272585132, -4.855385598361975],
            [-2.631791723983871, -4.858057733281199],
            [-2.6325291165938336, -4.867428951183449],
            [-2.6313264683658124, -4.871926229378738],
            [-2.6353862418212417, -4.872154035863396],
            [-2.6350146947636612, -4.875957605277871],
            [-2.6265689997342654, -4.876343250106308],
            [-2.6246835758516407, -4.870358286097159],
            [-2.6218295368005493, -4.867613570102344],
            [-2.6184065496491327, -4.868661934651094],
            [-2.6149882174102914, -4.874497327287001],
            [-2.608427147624337, -4.880267482893887],
            [-2.605045814601782, -4.8798731883063],
            [-2.604774104506344, -4.872898730658253],
            [-2.607052448316463, -4.86851360158599],
            [-2.6031803821713395, -4.865994815968888],
            [-2.6001628690762737, -4.868712095920236],
            [-2.5942167855946585, -4.8700696286417555],
            [-2.5975879807717206, -4.879353308670899],
            [-2.595779024079897, -4.883119087893541],
            [-2.59177814298368, -4.880037324528045],
            [-2.587081855262591, -4.879959528833147],
            [-2.587830927554997, -4.8747514834981365],
            [-2.5866842681291096, -4.869892160606468],
            [-2.5868523647821484, -4.862578004242179],
            [-2.58236620937057, -4.853731514305944],
            [-2.5745744886406983, -4.853890452581561],
            [-2.568066790836321, -4.857169320611354],
            [-2.5629570977237144, -4.863076771115143],
            [-2.561268140508027, -4.86830780005563],
            [-2.5581287924550495, -4.873607529733535],
            [-2.5532953331290447, -4.871610479928979],
            [-2.547192828439864, -4.863905147140829],
            [-2.544517671201567, -4.864884468067222],
            [-2.5372916601179134, -4.86417426656022],
            [-2.532304198654162, -4.868260811481205],
            [-2.532367378560697, -4.874121366741999],
            [-2.533853507757624, -4.879761866064351],
            [-2.5314581410122328, -4.881295499544453],
            [-2.5257586878755185, -4.879223321966185],
            [-2.516238898929786, -4.884665007174517],
            [-2.5128585125641583, -4.888502281345258],
            [-2.5046386471664173, -4.887165785073194],
            [-2.505830361449256, -4.8961632377076025],
            [-2.491123036699281, -4.900153084810605],
            [-2.4876546319814437, -4.891795452084538],
            [-2.486715270965034, -4.881948548139918],
            [-2.483394459038926, -4.884903464321977],
            [-2.4829017301492873, -4.89278018995162],
            [-2.479246643610418, -4.8927975352760855],
            [-2.4751106232919717, -4.895281317807988],
            [-2.4717853975546715, -4.889099097084346],
            [-2.4681806362473955, -4.886801985197739],
            [-2.4660625170798665, -4.890370118059596],
            [-2.4612766525370664, -4.889904473535436],
            [-2.4577472705284764, -4.892525481073041],
            [-2.4620227311771172, -4.903007583509264],
            [-2.457594912731846, -4.905819564881264],
            [-2.4487553926497845, -4.902403249250985],
            [-2.4455530318378553, -4.902015583729533],
            [-2.441582601462925, -4.90508290993333],
            [-2.4423550724995082, -4.911307203511026],
            [-2.441370851496184, -4.917125269692977],
            [-2.4387464245718418, -4.918125993015292],
            [-2.4340551912621695, -4.9143952781088585],
            [-2.4271180623085025, -4.9162322527078794],
            [-2.4266276798147035, -4.921769757425227],
            [-2.42229422134657, -4.922412893250152],
            [-2.417970282621799, -4.920114957359979],
            [-2.411879950992091, -4.937056402219394],
            [-2.409589252746315, -4.9382417002222825],
            [-2.4062225653943474, -4.9342221549209775],
            [-2.4046635936276757, -4.937451323750031],
            [-2.407054224337452, -4.9435018619715505],
            [-2.404275976523736, -4.95414105237643],
            [-2.406628694051081, -5.022258212435102],
            [-2.409259593170473, -5.108819921692038],
            [-2.4133432665073786, -5.237281821558728],
            [-2.4132009581347797, -5.240226894146776],
            [-2.4148978094793336, -5.289820489344408],
            [-2.4821335951856454, -5.287600593756701],
            [-2.61984201051841, -5.28271246394091],
            [-2.687200432454708, -5.280450674830513],
            [-2.8445936088846047, -5.2746366862631575],
            [-2.8415087141917197, -5.175351242137215],
            [-2.8372778919733013, -5.049555485084626],
            [-2.837357093787677, -5.046393244374449],
            [-2.8344506613317466, -4.957066778976464],
            [-2.8305453826055906, -4.834870707665961]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.74142728409021, "lat": 33.60606025573217 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48275"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "275",
        "coty_gnis_code": "01383923"
      },
      "bbox": [
        -2.8445936088846047, -5.289820489344408, -2.404275976523736,
        -4.834870707665961
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.14458300948217578, -6.923941212603657],
            [-0.023652658639140123, -6.9365668123593105],
            [0.04045396027665982, -6.94325698925665],
            [0.043453342428858795, -6.943778147047301],
            [0.07213028098020652, -6.99346708380276],
            [0.10661212896401748, -7.053671452525955],
            [0.14551866266344715, -7.121433472386726],
            [0.14737038094618843, -7.1243134139597215],
            [0.17718161914975794, -7.176529667713832],
            [0.21353802906180697, -7.239936499088426],
            [0.2503744999142482, -7.302768589526504],
            [0.25451465233613135, -7.311848168001639],
            [0.2625620521763206, -7.326029621551566],
            [0.19140365121482852, -7.363868846415436],
            [0.1893717253651449, -7.367805081025976],
            [0.19239016153563715, -7.3714615268472174],
            [0.19394957141633704, -7.376986384012491],
            [0.19220191037787962, -7.381836207829879],
            [0.13780403849635733, -7.412917554827846],
            [0.058600025817604935, -7.458018082887526],
            [0.0036555575531278103, -7.489466687930409],
            [-0.01595147896186399, -7.499798921111607],
            [-0.04491241979827729, -7.516269424708343],
            [-0.07839662836961997, -7.457463985170452],
            [-0.1321772452896146, -7.3630733201203995],
            [-0.1630450119279801, -7.307879114718308],
            [-0.18006632512470566, -7.277958523267347],
            [-0.21643261890966156, -7.215010342488742],
            [-0.24409759137818238, -7.1678677287083845],
            [-0.27725999007946195, -7.110656002326463],
            [-0.28656842868742366, -7.095143123693918],
            [-0.32589155347766996, -7.0280619028472255],
            [-0.27863692697088444, -7.001256535806752],
            [-0.27619270191422607, -6.9995751215668776],
            [-0.2461624776439973, -6.982555259631095],
            [-0.17320290797286006, -6.9408966422259155],
            [-0.16588030350028266, -6.936281207821631],
            [-0.14458300948217578, -6.923941212603657]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.58049922395718,
          "lat": 31.545450465184643
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48293"],
        "coty_name": ["Limestone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Limestone County"],
        "coty_fp_code": "293",
        "coty_gnis_code": "01383932"
      },
      "bbox": [
        -0.32589155347766996, -7.516269424708343, 0.2625620521763206,
        -6.923941212603657
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8029939635961544, -6.054454145894215],
            [0.8055038158256844, -6.059025673118641],
            [0.8115787218934969, -6.059578630830684],
            [0.8131617476671532, -6.067496654800195],
            [0.8190710738770223, -6.065497160509997],
            [0.8244664189274584, -6.068845789822022],
            [0.8310496061245451, -6.076296430124145],
            [0.8315295570047045, -6.079076772981337],
            [0.8372344735649621, -6.080671649617669],
            [0.8469184585671625, -6.086335871879567],
            [0.8473916732612822, -6.094504875242086],
            [0.8545434795849939, -6.095182365788835],
            [0.862003638926961, -6.097551911540217],
            [0.8679315062712553, -6.106023199938917],
            [0.8702411229011834, -6.107405644998025],
            [0.8717973392821947, -6.1130282382457235],
            [0.8688711564665424, -6.116370355952272],
            [0.8732846808551091, -6.120834178923812],
            [0.8805422583194822, -6.120902723916451],
            [0.8899589441912225, -6.123491275546554],
            [0.890348639398008, -6.12664933432157],
            [0.8970597136708582, -6.129438383112675],
            [0.9031814706672198, -6.1299370290962925],
            [0.9025529605040373, -6.132893541883354],
            [0.9084145555568457, -6.135333233437669],
            [0.9111076570644447, -6.132412188646251],
            [0.9151984116974065, -6.131255201090698],
            [0.9185035223155291, -6.133465539707381],
            [0.9264863564245697, -6.134739817357782],
            [0.9297072332004491, -6.128254984097401],
            [0.9344793616178209, -6.130638139707967],
            [0.936730207631182, -6.134061946059109],
            [0.9416771887385713, -6.134236570769997],
            [0.9497539330470448, -6.1316298972900505],
            [0.9504408113913194, -6.135456793906762],
            [0.9557230466809993, -6.133893486956649],
            [0.9573087987908873, -6.136075756958734],
            [0.9617232572271974, -6.1357194181650225],
            [0.9689934067837365, -6.138566890723426],
            [0.9768038245640106, -6.140036224572556],
            [0.9814650850225153, -6.142044211000863],
            [0.9879528390559007, -6.140649007019544],
            [0.9873851833067784, -6.137778716478456],
            [0.9910169613460672, -6.135739861238481],
            [0.9963524994278268, -6.137105561902937],
            [0.9982815767372117, -6.133761655471722],
            [1.0052316400684749, -6.135072977122076],
            [1.0078339646256809, -6.132864288966639],
            [1.013050965467401, -6.13656473438953],
            [1.0171129941052317, -6.137102769413356],
            [1.023111008121941, -6.136004075514028],
            [1.0277736911393076, -6.140543400463522],
            [1.0312231187871954, -6.140767027553302],
            [1.034187751348486, -6.144620936832112],
            [1.0375547596410943, -6.143847888058443],
            [1.0391076052325394, -6.146694703483283],
            [1.0442883148027564, -6.1435213542081115],
            [1.0452082215751137, -6.147870611749744],
            [1.0490217008192564, -6.1496927831471675],
            [1.0522031710788262, -6.148630495256295],
            [1.0527853496713122, -6.153126069643734],
            [1.058831473648084, -6.154871294843587],
            [1.0583417272476778, -6.159160707603799],
            [1.065935367536656, -6.159939921879269],
            [1.0684839660212626, -6.168139101127968],
            [1.0717826726044901, -6.166020307289582],
            [1.0789681603286951, -6.167333325633966],
            [1.08049401234179, -6.164635808368892],
            [1.0885483216575862, -6.164336402976247],
            [1.0914014767639029, -6.161802271580108],
            [1.0953787846856282, -6.170285326961205],
            [1.1020671475612942, -6.1789593675215055],
            [1.110479959802197, -6.179386834634696],
            [1.1141224719229317, -6.176245713001745],
            [1.1184506602144333, -6.1763024475027395],
            [1.1215166895518063, -6.173830595095752],
            [1.1222740864547922, -6.170382708497289],
            [1.1270033009892553, -6.170831645436209],
            [1.130488559800355, -6.167648986939347],
            [1.1322999347616542, -6.175552136806195],
            [1.1285626537261422, -6.179495787553465],
            [1.1333343381643637, -6.185592240050491],
            [1.1434073547964518, -6.192725320384444],
            [1.142618566663877, -6.196440370605169],
            [1.1481338207576106, -6.198312111053622],
            [1.150060407394298, -6.197462785907427],
            [1.1494162249744753, -6.19238417542896],
            [1.1524889888678942, -6.189277309308841],
            [1.1548036242727802, -6.183748168396727],
            [1.1578977028401038, -6.190498439257979],
            [1.163395742013487, -6.194789913327906],
            [1.168104189194697, -6.1886566358346995],
            [1.1657735236878437, -6.1851985894738055],
            [1.1683386758878598, -6.174692326816485],
            [1.1731353540376077, -6.1689515173034515],
            [1.1794415824576023, -6.169269390153524],
            [1.180818458446712, -6.175197527150133],
            [1.1838861119153041, -6.1792925600374335],
            [1.1832766784273636, -6.183797479645417],
            [1.1847512951311279, -6.18898749554632],
            [1.1884000126707104, -6.19091328312147],
            [1.1991125035570178, -6.189014956766448],
            [1.2013811470021145, -6.1958140232013665],
            [1.205814433898782, -6.193448476443534],
            [1.2074181052414081, -6.187834459442492],
            [1.2153277973454741, -6.187619675215356],
            [1.2188829071408123, -6.186247433471873],
            [1.219717746558483, -6.1825610373261215],
            [1.2227148421085228, -6.1812388577069814],
            [1.2288644926491046, -6.182484207886293],
            [1.2311094054690184, -6.1855493458736985],
            [1.2356648751904307, -6.185375603508092],
            [1.2319002341226724, -6.192074832943396],
            [1.2316707216335492, -6.195982404951427],
            [1.2380967261982534, -6.199124015998997],
            [1.246752734465021, -6.200684613136903],
            [1.2527470659870263, -6.19961100260477],
            [1.2643480307920865, -6.2000408489701835],
            [1.265804701738125, -6.20571821904158],
            [1.267910730262731, -6.205881078954363],
            [1.281227292954699, -6.201032237847012],
            [1.2784700754070495, -6.197375954006497],
            [1.279644356354674, -6.192230818159154],
            [1.2843479809896265, -6.191275920066164],
            [1.2856588584804713, -6.194573984333622],
            [1.289023674353815, -6.194810358456142],
            [1.2876719193905821, -6.200167380115756],
            [1.2891645463468564, -6.204789171698734],
            [1.2875533861367583, -6.211018496722759],
            [1.283342001822748, -6.215898602591729],
            [1.2875785742074064, -6.219568300214888],
            [1.2949610159048066, -6.221073705612482],
            [1.298196306529159, -6.216944068071755],
            [1.3034157826469017, -6.215884792761744],
            [1.3089661949433198, -6.208133096161111],
            [1.3104313565372527, -6.203466523383808],
            [1.31297961941773, -6.2004560934511135],
            [1.3141025639006905, -6.287647146592629],
            [1.3139717753422342, -6.2935297052577095],
            [1.3152125440046536, -6.366765346697081],
            [1.3160435022183232, -6.366773522259787],
            [1.315657826515901, -6.373575474524433],
            [1.3172828331824875, -6.481040483366675],
            [1.3172613018817525, -6.490000306774629],
            [1.3186590001008656, -6.599308444606198],
            [1.2966302601131023, -6.599579010647351],
            [1.2910936690433825, -6.600222106282836],
            [1.2378204003647997, -6.600747303358136],
            [1.1613666545409203, -6.601871551010771],
            [1.1141703626646802, -6.602799336156356],
            [1.0175607155112225, -6.604298710340471],
            [0.9643966143668027, -6.604873058598428],
            [0.9187932866418571, -6.604983644207374],
            [0.9109250223857858, -6.597121416003028],
            [0.903563733219569, -6.594435262855061],
            [0.9019257117377153, -6.588724208805135],
            [0.9055306839160088, -6.5783295921077904],
            [0.9068956957002086, -6.571772038239779],
            [0.9088876611166199, -6.571645232209131],
            [0.9109697016086286, -6.5602825570285885],
            [0.91405261980055, -6.560137570375035],
            [0.9170813689085866, -6.557287714854266],
            [0.9115821362704838, -6.552700150215653],
            [0.9114391533978907, -6.550186547363318],
            [0.9156443281885616, -6.546240637670291],
            [0.9141905947737146, -6.543619486111128],
            [0.9161674578679049, -6.538893986326175],
            [0.9111112107866048, -6.535303231550872],
            [0.909737735301124, -6.528620968509742],
            [0.9054791259303994, -6.529651081041571],
            [0.902339015351995, -6.528524793139098],
            [0.9026690213145141, -6.523197140468711],
            [0.8961020130842081, -6.515445941015618],
            [0.8958658024696298, -6.509771558063343],
            [0.894201334336056, -6.508241448793803],
            [0.8992027538767862, -6.499977962278398],
            [0.9041110545652082, -6.498328280665015],
            [0.9117005781831822, -6.494110557375969],
            [0.9099916927549869, -6.491560183053137],
            [0.9096238919125456, -6.47864667096972],
            [0.9202280843759139, -6.467612863621206],
            [0.923357028620629, -6.4606378479061135],
            [0.9251181678318657, -6.445728890566974],
            [0.9287576468715679, -6.444892789030948],
            [0.927589745663266, -6.440442191433717],
            [0.9229529188348442, -6.434972451970533],
            [0.9233254780604924, -6.423951329494505],
            [0.9196215229035691, -6.4214528741300345],
            [0.9214431552200583, -6.418537329651808],
            [0.9197040755184778, -6.411530866144645],
            [0.9231632512043341, -6.406815526229855],
            [0.9220409589993683, -6.4029844355894205],
            [0.923875169856912, -6.394935125073309],
            [0.9276445344789966, -6.393858379142815],
            [0.9265649115457074, -6.385535760774241],
            [0.926293358091783, -6.380896207441746],
            [0.9233728334635476, -6.378283134595313],
            [0.9203526337464014, -6.372622953862862],
            [0.9173127643747356, -6.373734295584637],
            [0.9086469474263908, -6.372083114426564],
            [0.9058187583911714, -6.367635259088682],
            [0.8985555493799824, -6.360253624098243],
            [0.8950477222406614, -6.354826616091798],
            [0.8888801578612764, -6.351364064718714],
            [0.8860239917772231, -6.343050078682787],
            [0.8818928533634318, -6.339344280016036],
            [0.8821881843559847, -6.331813814535124],
            [0.8795326798758478, -6.330442522042294],
            [0.8777838187504616, -6.326287262653552],
            [0.872248310577194, -6.3245017783262965],
            [0.8693193616122535, -6.320472173313638],
            [0.8631610068501999, -6.319083929944459],
            [0.8593022320904365, -6.312967763900703],
            [0.854284217798961, -6.308941726294292],
            [0.8506041179569344, -6.308239966965985],
            [0.8489694598864804, -6.301782515057168],
            [0.8450530784980526, -6.299516486534637],
            [0.8390792642510291, -6.290932272185736],
            [0.8390866969867554, -6.288070717624131],
            [0.8328210375062114, -6.285688008615564],
            [0.8320718914022963, -6.283752422921542],
            [0.8261740284738777, -6.279836218826899],
            [0.8221332952853508, -6.279932332530899],
            [0.804084978306039, -6.2616022976996675],
            [0.803693361856871, -6.155567753175833],
            [0.8032899877265977, -6.085603770536999],
            [0.8029939635961544, -6.054454145894215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.26918325729798, "lat": 32.3749498482151 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48423"],
        "coty_name": ["Smith"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Smith County"],
        "coty_fp_code": "423",
        "coty_gnis_code": "01383997"
      },
      "bbox": [
        0.8029939635961544, -6.604983644207374, 1.3186590001008656,
        -6.054454145894215
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1712405715570577, -5.8362869219489015],
            [1.1790123141910605, -5.83641476686691],
            [1.29069252159179, -5.835029163181417],
            [1.3053682064306396, -5.834996695340755],
            [1.357404579464978, -5.834346233374144],
            [1.3812558586292452, -5.8341903953694185],
            [1.4389721740710595, -5.832961619982837],
            [1.4995924565217715, -5.8314671549554085],
            [1.5006407539194395, -5.8316707561122785],
            [1.531808960599046, -5.830408316161044],
            [1.530421444567494, -5.834067768290457],
            [1.54163786481759, -5.838732958806698],
            [1.5445916242449447, -5.845020517000482],
            [1.5421428413761726, -5.852660379359783],
            [1.5438900580850925, -5.85559667828384],
            [1.5421843606855294, -5.8596687517841755],
            [1.5437665670084018, -5.873413505514155],
            [1.5471034929526477, -5.87210907089479],
            [1.5507225532221565, -5.875536079116079],
            [1.549083063020646, -5.884370461478312],
            [1.5501203487715527, -5.889659071534138],
            [1.5600700177078304, -5.891822991136669],
            [1.5607951657705643, -5.894424305212454],
            [1.566098700150053, -5.8982035351842095],
            [1.5674012832133517, -5.896505080727808],
            [1.5724961443849998, -5.899666222151279],
            [1.5478174106985305, -5.914258120060818],
            [1.5481925204766365, -5.941700876441756],
            [1.5492200956992463, -6.018060075028275],
            [1.550420574879706, -6.082618038011164],
            [1.5428793488857608, -6.07696860995642],
            [1.5397903181260348, -6.077390323642584],
            [1.5355154016872696, -6.080616546580697],
            [1.5285071107564498, -6.079700869747881],
            [1.5250940925271839, -6.077201552346046],
            [1.520878261169832, -6.071737850457971],
            [1.5123291372030827, -6.0691165896599095],
            [1.5121590013093347, -6.074909459383721],
            [1.502852312778182, -6.075664065204916],
            [1.4905259635324477, -6.091757070939935],
            [1.4893441691197657, -6.0942417467998915],
            [1.4522318852157114, -6.145228635416619],
            [1.423097986576731, -6.157505042763009],
            [1.4081169433096712, -6.164541895419183],
            [1.3942149869766738, -6.170060320259293],
            [1.383850864299379, -6.174820711333725],
            [1.347058711596819, -6.190156212129234],
            [1.3253234473540807, -6.200141366424104],
            [1.3234272818848614, -6.201548489233987],
            [1.317167727273725, -6.200039666625761],
            [1.31297961941773, -6.2004560934511135],
            [1.3104313565372527, -6.203466523383808],
            [1.3089661949433198, -6.208133096161111],
            [1.3034157826469017, -6.215884792761744],
            [1.298196306529159, -6.216944068071755],
            [1.2949610159048066, -6.221073705612482],
            [1.2875785742074064, -6.219568300214888],
            [1.283342001822748, -6.215898602591729],
            [1.2875533861367583, -6.211018496722759],
            [1.2891645463468564, -6.204789171698734],
            [1.2876719193905821, -6.200167380115756],
            [1.289023674353815, -6.194810358456142],
            [1.2856588584804713, -6.194573984333622],
            [1.2843479809896265, -6.191275920066164],
            [1.279644356354674, -6.192230818159154],
            [1.2784700754070495, -6.197375954006497],
            [1.281227292954699, -6.201032237847012],
            [1.267910730262731, -6.205881078954363],
            [1.265804701738125, -6.20571821904158],
            [1.2643480307920865, -6.2000408489701835],
            [1.2527470659870263, -6.19961100260477],
            [1.246752734465021, -6.200684613136903],
            [1.2380967261982534, -6.199124015998997],
            [1.2316707216335492, -6.195982404951427],
            [1.2319002341226724, -6.192074832943396],
            [1.2356648751904307, -6.185375603508092],
            [1.2311094054690184, -6.1855493458736985],
            [1.2288644926491046, -6.182484207886293],
            [1.2227148421085228, -6.1812388577069814],
            [1.219717746558483, -6.1825610373261215],
            [1.2188829071408123, -6.186247433471873],
            [1.2153277973454741, -6.187619675215356],
            [1.2074181052414081, -6.187834459442492],
            [1.205814433898782, -6.193448476443534],
            [1.2013811470021145, -6.1958140232013665],
            [1.1991125035570178, -6.189014956766448],
            [1.1884000126707104, -6.19091328312147],
            [1.1847512951311279, -6.18898749554632],
            [1.1832766784273636, -6.183797479645417],
            [1.1838861119153041, -6.1792925600374335],
            [1.180818458446712, -6.175197527150133],
            [1.1794415824576023, -6.169269390153524],
            [1.1731353540376077, -6.1689515173034515],
            [1.1731773817023368, -6.131945885543438],
            [1.172453301505987, -6.010379652255526],
            [1.1719127518928378, -5.925674113460061],
            [1.1714329528357847, -5.873750662836282],
            [1.1712405715570577, -5.8362869219489015]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.94145525888034, "lat": 32.73622115771518 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48459"],
        "coty_name": ["Upshur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Upshur County"],
        "coty_fp_code": "459",
        "coty_gnis_code": "01384015"
      },
      "bbox": [
        1.1712405715570577, -6.221073705612482, 1.5724961443849998,
        -5.830408316161044
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6815672930777832, -9.842373627632169],
            [-0.6325004358832392, -9.802637680804773],
            [-0.5770315785157298, -9.758247408304616],
            [-0.5215743303744009, -9.713839146882336],
            [-0.44021687284391325, -9.64812104955379],
            [-0.43389898430058405, -9.644482154549804],
            [-0.4261396077210147, -9.638487084825682],
            [-0.39010688298610935, -9.609524455140456],
            [-0.35746212735395333, -9.65003994280877],
            [-0.2704873429214517, -9.6881830601865],
            [-0.2674736515181868, -9.69233415198965],
            [-0.26466497154777396, -9.69219990250047],
            [-0.26075302343090445, -9.701551496946474],
            [-0.2601978916321998, -9.70591030717496],
            [-0.2562288991104799, -9.712988096798275],
            [-0.25567514356531446, -9.716442767461148],
            [-0.2508478191326384, -9.720296942895772],
            [-0.25223300108497604, -9.722179464257472],
            [-0.24668445720818336, -9.732309658534344],
            [-0.24751337979076404, -9.735686313427857],
            [-0.24565038693500124, -9.739334616176942],
            [-0.24187374076981805, -9.740697214543221],
            [-0.24504232312456162, -9.748136505287839],
            [-0.24393087292853302, -9.756694134393559],
            [-0.24101360433369282, -9.759876293891773],
            [-0.24135205608220228, -9.767248946877183],
            [-0.23777227793497496, -9.7729403246211],
            [-0.2387851997378297, -9.776516571105454],
            [-0.23705130319382645, -9.77932719040663],
            [-0.23146464428206256, -9.7826448857278],
            [-0.23197946074989031, -9.78672213883909],
            [-0.23012500911510234, -9.788699850833018],
            [-0.23012415143116619, -9.793886421263512],
            [-0.22617939552598354, -9.79434878344482],
            [-0.22328121820864213, -9.797123068304243],
            [-0.216448822316588, -9.796300467900155],
            [-0.21432820567650307, -9.799129170027726],
            [-0.21317884396808895, -9.806227879011086],
            [-0.2053545989056824, -9.80683435919144],
            [-0.20496956141771372, -9.812407231628184],
            [-0.20118438166308034, -9.815594880990107],
            [-0.19365516794142107, -9.817253785019293],
            [-0.18830355757249642, -9.82101283306052],
            [-0.18522464197190108, -9.818284231352678],
            [-0.17953106394937288, -9.823105089204496],
            [-0.17765121202276393, -9.83118991247668],
            [-0.1785918779739458, -9.834858779909892],
            [-0.1764152481621544, -9.840584947754323],
            [-0.17243753586601765, -9.842890703999927],
            [-0.16956866394334894, -9.849922300219689],
            [-0.16465896347141062, -9.852820907669713],
            [-0.16386315012757594, -9.856229867912214],
            [-0.16037626793392593, -9.86024597527698],
            [-0.15661590188662858, -9.85806401139823],
            [-0.15266371627650252, -9.86068422128234],
            [-0.15476865610500545, -9.86436591587977],
            [-0.16214634270870001, -9.868750402377204],
            [-0.16471666750251104, -9.872745993392005],
            [-0.16494953813140106, -9.876463703361912],
            [-0.16125673516227404, -9.880277306203599],
            [-0.16757180992936074, -9.882146655972033],
            [-0.16624557907573523, -9.887926702045617],
            [-0.17075798417189159, -9.88989963087506],
            [-0.16777332274139437, -9.893866288748757],
            [-0.16180489546338842, -9.895575851148841],
            [-0.1568503663909217, -9.895611329862572],
            [-0.15562381702828446, -9.899609770864346],
            [-0.1565447784534775, -9.906746659107036],
            [-0.15237693695229068, -9.911239376620022],
            [-0.14860350213034904, -9.913474736968212],
            [-0.1464764867062838, -9.919123540534898],
            [-0.14915864547706162, -9.92376776898482],
            [-0.14769604719645785, -9.92966027970926],
            [-0.1502236460623427, -9.931895002930352],
            [-0.1467958406613197, -9.937890942389187],
            [-0.14008302067410142, -9.937848583236372],
            [-0.13808938147145364, -9.939935716067069],
            [-0.1414922010946551, -9.943088703017455],
            [-0.13884610195385938, -9.946622018457822],
            [-0.12989815583367753, -9.946754016263366],
            [-0.12467708249544569, -9.949237922487484],
            [-0.12639045276227043, -9.957938951100381],
            [-0.11919730253945944, -9.965687555403074],
            [-0.11959062316919229, -9.969625574488283],
            [-0.12342619556244067, -9.972421848856937],
            [-0.11909782365414238, -9.976807196823103],
            [-0.1153796539888353, -9.985824485102656],
            [-0.11511790264799765, -9.990075251828056],
            [-0.10796341220716364, -9.989158396844251],
            [-0.10731911907379135, -9.994681765956445],
            [-0.1016082783424173, -9.997655450963727],
            [-0.11610924194377846, -10.00781441291421],
            [-0.1212154367960435, -10.003813890465723],
            [-0.17166717982994734, -10.03878323404395],
            [-0.21630558500141775, -10.051728616118808],
            [-0.2870827867418876, -10.071804402163181],
            [-0.3549276465562675, -10.118801981429252],
            [-0.3510320979147807, -10.121756185506708],
            [-0.3440127270436548, -10.13186495821685],
            [-0.34321622345773956, -10.134381400344918],
            [-0.3385781385443975, -10.136496046888887],
            [-0.33644731309804665, -10.132611406433846],
            [-0.33359796934070035, -10.1339407608249],
            [-0.33565267761336676, -10.137520662171976],
            [-0.3317334614833139, -10.138369806165736],
            [-0.3268916223215256, -10.145169165108483],
            [-0.3301349388816691, -10.150505940423042],
            [-0.3257988559142803, -10.153029401263],
            [-0.32428587750773974, -10.156286703334441],
            [-0.328972191573897, -10.162414201928106],
            [-0.329942207969756, -10.168053515737375],
            [-0.3338298854437417, -10.172710710598338],
            [-0.32916201121616195, -10.177378094268121],
            [-0.3262144646734626, -10.183977528793886],
            [-0.3279470992186195, -10.186760236388661],
            [-0.32279194568534486, -10.190509320183061],
            [-0.3209889983358508, -10.19725558531113],
            [-0.3304522689060022, -10.194751084628184],
            [-0.33221803214404655, -10.19800752369503],
            [-0.338647588644186, -10.201476290334108],
            [-0.3432561097381883, -10.2068490731145],
            [-0.3378630793313179, -10.21346508915114],
            [-0.3423874847570911, -10.217202569239932],
            [-0.3512873090631115, -10.215458411166503],
            [-0.3601528397523771, -10.2068844672176],
            [-0.3679176725640742, -10.204550459763011],
            [-0.37418267556505724, -10.201251487224756],
            [-0.38983067668328447, -10.1985290318465],
            [-0.3989216149191421, -10.200679152357578],
            [-0.4013873257053896, -10.20387885214279],
            [-0.4106944757236527, -10.200417533023355],
            [-0.41226768625884347, -10.194862963769355],
            [-0.42109746667927317, -10.194573195550483],
            [-0.42517391535542587, -10.188696524451164],
            [-0.43468997328225767, -10.183396574923142],
            [-0.4406567603832947, -10.171285934686088],
            [-0.4400871684500185, -10.16375594474469],
            [-0.4476802894235791, -10.165719748230218],
            [-0.451870630324602, -10.171497867687448],
            [-0.4561021203616065, -10.171682010396317],
            [-0.4596270418269463, -10.16704245941288],
            [-0.4562088077857686, -10.159317374235222],
            [-0.45965382334738275, -10.155295196354178],
            [-0.464200796100635, -10.15510816708727],
            [-0.47053992045427634, -10.157995192800367],
            [-0.47120127181559995, -10.162661200950502],
            [-0.4800061098584699, -10.156430070478315],
            [-0.48319535716651146, -10.15898665280221],
            [-0.48676866131290897, -10.15795474306605],
            [-0.48925634531550277, -10.161720140789834],
            [-0.48462069341452874, -10.165552383708247],
            [-0.4851844241187437, -10.169620074757312],
            [-0.4904396948852925, -10.168330623043541],
            [-0.4977289508587322, -10.16486101995222],
            [-0.5058404020990549, -10.156266997786705],
            [-0.5086103996793166, -10.148525739459371],
            [-0.5135668480318206, -10.149570986023027],
            [-0.5179744742065774, -10.154194696372993],
            [-0.5223928421965995, -10.154747622268129],
            [-0.5289452038215059, -10.157546318657136],
            [-0.5354527710775844, -10.153494995705941],
            [-0.5400094659101937, -10.149136098809526],
            [-0.5425679735311606, -10.154481691914825],
            [-0.5486942063377347, -10.150062497757249],
            [-0.5536296171100634, -10.154839163392248],
            [-0.5580480340419359, -10.149267886505225],
            [-0.5600860034753966, -10.146145270746896],
            [-0.5583358524774354, -10.14124798509011],
            [-0.5603766549782823, -10.137308871389909],
            [-0.5552995884399295, -10.137393484002615],
            [-0.5518750839344972, -10.132939289043618],
            [-0.5595209619963782, -10.131422153711672],
            [-0.5610640471103256, -10.125775510416934],
            [-0.5658655337323867, -10.125880535994963],
            [-0.5661939806928866, -10.123360626564473],
            [-0.5625916258988941, -10.120808683133067],
            [-0.5669283599437905, -10.117977869026056],
            [-0.5654921964349684, -10.113758962634588],
            [-0.5670676329629437, -10.109702883378237],
            [-0.5710584059324539, -10.10810890542777],
            [-0.570332192601203, -10.1042349004136],
            [-0.5740347427273838, -10.099625906202444],
            [-0.5763590521744411, -10.092922959912622],
            [-0.5620540305153453, -9.977859362867331],
            [-0.5645466976953674, -9.968958512210156],
            [-0.5709373377546543, -9.968814861645312],
            [-0.5688858075987333, -9.963750510411609],
            [-0.5619000447614163, -9.958123400540138],
            [-0.5604233208916932, -9.953943477296818],
            [-0.5617857930617219, -9.947346441328138],
            [-0.5584238879957535, -9.941617576953522],
            [-0.5562427837098023, -9.933144184166503],
            [-0.5537377550018914, -9.930455077042255],
            [-0.5560197803769898, -9.923168608150974],
            [-0.563269754117547, -9.921047128678612],
            [-0.5688260500320755, -9.91593509145456],
            [-0.5714540116694571, -9.90872502873545],
            [-0.574715513143753, -9.903830107166526],
            [-0.5776543521613018, -9.897053271795619],
            [-0.5810239354353284, -9.893546369333194],
            [-0.5792084663141235, -9.886869933576518],
            [-0.5797442801117351, -9.88269439579311],
            [-0.577047512060991, -9.874650144201743],
            [-0.5799741373786355, -9.870327821444063],
            [-0.5849898036612263, -9.86823429608361],
            [-0.5931795752178834, -9.852376272431993],
            [-0.5981733414719206, -9.851684058756947],
            [-0.6032626785775763, -9.846740884716457],
            [-0.6118233494685792, -9.84457314368479],
            [-0.6167038061947698, -9.841981269057008],
            [-0.620453780718059, -9.842340640459634],
            [-0.620591140243354, -9.845901675278283],
            [-0.617864311399732, -9.850513701262708],
            [-0.619493822545292, -9.852950598503316],
            [-0.6232191450139339, -9.853197984820113],
            [-0.6328514423376074, -9.849414606555998],
            [-0.6365252969859702, -9.84962567341316],
            [-0.637947922752769, -9.85831052210199],
            [-0.641755239845862, -9.859476903223053],
            [-0.6476937893499852, -9.85793021869431],
            [-0.6515237760645229, -9.859141123327456],
            [-0.6627698668349519, -9.859398479298429],
            [-0.6650722722054548, -9.861212505038235],
            [-0.670635647994687, -9.858882145106692],
            [-0.6770969642420551, -9.86204098401634],
            [-0.6796138533174153, -9.860767374417978],
            [-0.6808411571671069, -9.855474348250892],
            [-0.6768310074466869, -9.854514125806341],
            [-0.6744458184150615, -9.845593731628465],
            [-0.6815672930777832, -9.842373627632169]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.97155901890143,
          "lat": 28.796321958401606
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48469"],
        "coty_name": ["Victoria"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Victoria County"],
        "coty_fp_code": "469",
        "coty_gnis_code": "01384020"
      },
      "bbox": [
        -0.6815672930777832, -10.217202569239932, -0.1016082783424173,
        -9.609524455140456
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.713569477583268, -6.504582711640043],
            [-5.664024272583212, -6.508264402975421],
            [-5.577761019246926, -6.514770259994884],
            [-5.493003085156609, -6.5210569575272626],
            [-5.486479352041963, -6.4348999438197945],
            [-5.320113147774251, -6.4469430058522885],
            [-5.265516393910966, -6.450842623440753],
            [-5.263534375589211, -6.452343341606733],
            [-5.278899099745776, -6.6736373795496196],
            [-5.294573894186679, -6.884300658866224],
            [-5.297021194173225, -6.884603304390227],
            [-5.467491484040566, -6.872209245920958],
            [-5.566428015502106, -6.864771352757613],
            [-5.6186459024965, -6.860925082384686],
            [-5.741439930867713, -6.8516318395205555],
            [-5.731080665546681, -6.721907493924224],
            [-5.7139181401913355, -6.504799274617141],
            [-5.713569477583268, -6.504582711640043]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.04834210646585,
          "lat": 31.85006466051147
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48495"],
        "coty_name": ["Winkler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winkler County"],
        "coty_fp_code": "495",
        "coty_gnis_code": "01384033"
      },
      "bbox": [
        -5.741439930867713, -6.884603304390227, -5.263534375589211,
        -6.4348999438197945
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.59369933138028, 7.003159998060776],
            [16.683380065828555, 7.036473089848232],
            [16.699922307924336, 7.042791653456804],
            [16.674287310295778, 7.108905209644645],
            [16.71794624624464, 7.121944047418678],
            [16.716899620211063, 7.124405622822734],
            [16.751362176531003, 7.1347770119958795],
            [16.80390629437974, 7.150141334822969],
            [16.80231988177821, 7.147160687284463],
            [16.807167659415896, 7.146243066119322],
            [16.822930463452696, 7.11184783863781],
            [16.83988281025179, 7.126005854245075],
            [16.85783379713741, 7.14217415640871],
            [16.87678174962586, 7.15901208138706],
            [16.909554305700837, 7.187711147407621],
            [16.91444977130096, 7.169999506853622],
            [16.941735181078045, 7.166077030603421],
            [16.944696691633176, 7.176935044762583],
            [16.970636766830943, 7.173114925823537],
            [16.976157536819034, 7.16774086779836],
            [16.974656284072516, 7.165028001186381],
            [16.977060579948386, 7.161708751494206],
            [16.98308859243523, 7.16045900070576],
            [16.981869285047118, 7.155154409890026],
            [16.98289410805652, 7.1520679281549056],
            [16.986456126255465, 7.151270088851795],
            [16.975149580015614, 7.089169139918937],
            [16.98714995367114, 7.086649856490589],
            [16.981826558807544, 7.060403677874249],
            [17.073584824729767, 7.050130787484754],
            [17.065257680234797, 6.992858550137478],
            [17.05658579090685, 6.946083898942976],
            [17.04621321891884, 6.947282823200696],
            [17.04756148919037, 6.936031601953643],
            [17.05676887908673, 6.850664213082112],
            [17.072072650185742, 6.851332016354125],
            [17.073599713792802, 6.838642094572884],
            [17.109225856096693, 6.836547308492258],
            [17.10875484889424, 6.829117338515623],
            [17.112362002536265, 6.828998485400317],
            [17.111738980298465, 6.78458284363751],
            [17.10603660701521, 6.736246987479881],
            [17.11315536353606, 6.719385973767921],
            [17.061987607257123, 6.7348067073312246],
            [17.063142396739305, 6.730051873466521],
            [17.041664004139342, 6.725333197007928],
            [17.046581146644154, 6.6987780533047285],
            [17.039507561488808, 6.696438558674445],
            [17.04859278821477, 6.649136103729973],
            [16.972757782556855, 6.634210973035732],
            [16.975623904317203, 6.620920514768113],
            [16.964023988421257, 6.618244015088537],
            [16.963911237121376, 6.632910124840257],
            [16.921794340637, 6.624703865380957],
            [16.889644890650107, 6.616713500684305],
            [16.83515232056202, 6.6080016599420235],
            [16.773948626256562, 6.596342179664074],
            [16.76185066950733, 6.651470038893507],
            [16.741096456938198, 6.748595087794954],
            [16.72902252212076, 6.802496564461824],
            [16.731612366226187, 6.806859906853383],
            [16.730194411185124, 6.81217084999777],
            [16.72535875282296, 6.818114392509677],
            [16.722497473851654, 6.819037122150619],
            [16.720637798569985, 6.825769546646813],
            [16.72105885140044, 6.829395266081179],
            [16.717569727623104, 6.831623781384871],
            [16.71141640135401, 6.8384471116806855],
            [16.702212308188347, 6.843429297114064],
            [16.69442316584913, 6.843872345041787],
            [16.68959289919088, 6.847868217120653],
            [16.68372950415458, 6.845676054739974],
            [16.68205453938489, 6.84703353688995],
            [16.68298509814788, 6.852256546519554],
            [16.6792628567249, 6.853634237902754],
            [16.68059808884964, 6.859330606413973],
            [16.678930415098772, 6.869183446001416],
            [16.673099086359223, 6.875448846232547],
            [16.671327859532834, 6.875819175844064],
            [16.666852080162126, 6.8886523019677695],
            [16.6630724568772, 6.891488900226955],
            [16.660938382305083, 6.88696663726033],
            [16.655295033191457, 6.888929498383815],
            [16.650799584304323, 6.888125046611558],
            [16.648539618728282, 6.885818369355685],
            [16.638363045185468, 6.883523440795761],
            [16.635397865679327, 6.879153821005882],
            [16.62710784697662, 6.879777664624228],
            [16.617926124682658, 6.875190259959729],
            [16.62058077900183, 6.872076200743007],
            [16.617844907421148, 6.864749978176316],
            [16.621968557207193, 6.858988997534412],
            [16.620341821479375, 6.850959900802734],
            [16.616229450422814, 6.848731764751945],
            [16.618515724407974, 6.8447638471047725],
            [16.615720683259227, 6.842334830144198],
            [16.61965231507192, 6.837955341026439],
            [16.61833462418196, 6.834765449193218],
            [16.621191943767187, 6.831276555746947],
            [16.620914837026735, 6.827431969326622],
            [16.617219040259183, 6.825691220350334],
            [16.616792318635316, 6.820695017926607],
            [16.612908672769596, 6.817861491649658],
            [16.606911773478046, 6.819614321571975],
            [16.59741726060036, 6.824053630047696],
            [16.594135662475413, 6.82712214808332],
            [16.58775569245817, 6.828159143945575],
            [16.585026985136583, 6.834212443344764],
            [16.588177619257053, 6.847787178303024],
            [16.584505890170202, 6.856481105550419],
            [16.586680263322243, 6.865448361323094],
            [16.58568810905929, 6.868020164985181],
            [16.576346278765474, 6.87716641946652],
            [16.57542900039547, 6.885328075966356],
            [16.57957241659738, 6.891743068252808],
            [16.58076761803837, 6.896718954527515],
            [16.580083064706137, 6.902462620741637],
            [16.581967536039876, 6.914435552923905],
            [16.581569696946286, 6.929990219163398],
            [16.579463049508547, 6.933251275472516],
            [16.580556823065915, 6.938375645244459],
            [16.584960839322505, 6.945686480682538],
            [16.585300160608057, 6.950159501257497],
            [16.587573297663596, 6.958764027876185],
            [16.591748309504766, 6.966309473908166],
            [16.59494078548293, 6.974891457579431],
            [16.592436704807394, 6.984793508564059],
            [16.591073917792837, 6.993391597557522],
            [16.59369933138028, 7.003159998060776]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.03634225308211,
          "lat": 43.580147129724146
        },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50021"],
        "coty_name": ["Rutland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rutland County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01461767"
      },
      "bbox": [
        16.57542900039547, 6.596342179664074, 17.11315536353606,
        7.187711147407621
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.676579641883535, 1.2388573546627326],
            [14.696067922158871, 1.2671433387380662],
            [14.696926568237693, 1.2736601725708196],
            [14.69993599448954, 1.2785390911180656],
            [14.704729488506254, 1.2811637358022703],
            [14.710986723652265, 1.2824075635718581],
            [14.715514526670106, 1.2803953652968385],
            [14.723345810965265, 1.270842710501292],
            [14.734444854148427, 1.2757192892748734],
            [14.738423846320822, 1.2708274970573887],
            [14.74531236558963, 1.2691199213598732],
            [14.7514815366094, 1.263405276282446],
            [14.757045434835828, 1.262760978849667],
            [14.761856798003286, 1.2579266823255821],
            [14.767087859565734, 1.256806504429168],
            [14.774955401653841, 1.2532769725678476],
            [14.783106199853602, 1.2469945907532194],
            [14.78688363895323, 1.2399144654705672],
            [14.790102898686541, 1.2371626620444782],
            [14.796023314209727, 1.234905632252242],
            [14.795568983516505, 1.2314643465169541],
            [14.800556000966456, 1.2324837111717049],
            [14.805509429440246, 1.2268910386063834],
            [14.810400662316699, 1.2286413123724609],
            [14.830287667863148, 1.2256474840855127],
            [14.834407652032894, 1.226510087364574],
            [14.835546927615072, 1.2233975498991494],
            [14.841200913975554, 1.2202465243700797],
            [14.847445901433902, 1.2197333604099232],
            [14.854410032745252, 1.2174050021064116],
            [14.854138637822876, 1.2204288118474351],
            [14.85748564303259, 1.2231584000155828],
            [14.863434874682182, 1.2231239941518246],
            [14.861690192703309, 1.2291532408930201],
            [14.864853937434226, 1.225260802430713],
            [14.86097338608322, 1.216404542894469],
            [14.857718774534087, 1.213055014003277],
            [14.855278053915338, 1.1963941084991194],
            [14.85579591797154, 1.1944332992681725],
            [14.85276124262841, 1.1816988845283756],
            [14.854173126931817, 1.168747180244322],
            [14.854610035454554, 1.1578423561277462],
            [14.857886794249824, 1.1532456327396363],
            [14.860264820319916, 1.144667461284559],
            [14.861680040126094, 1.142974770056113],
            [14.865215700639517, 1.1333999670303725],
            [14.875516770626698, 1.114724712141444],
            [14.871181847504475, 1.1116131612909899],
            [14.873666243351966, 1.1053825598621416],
            [14.873296088317865, 1.0997746114721765],
            [14.878002230732827, 1.0966372323273241],
            [14.89216458167434, 1.0893486800801586],
            [14.8951145270122, 1.085033297113716],
            [14.90024262206496, 1.080334881781312],
            [14.903149890243547, 1.069922676016523],
            [14.886858754820329, 1.0628488987789653],
            [14.877683002777951, 1.0611854386335289],
            [14.87898697619697, 1.0541359456365385],
            [14.874562393414083, 1.0514054303552884],
            [14.873315334932096, 1.0487535645687518],
            [14.876490512500448, 1.0438799532498384],
            [14.878868273297039, 1.0344344590587449],
            [14.874465009937023, 1.0263903829897616],
            [14.876188104130838, 1.0224095354161236],
            [14.87493388812293, 1.0167112499980584],
            [14.872390792907272, 1.0167891475534385],
            [14.873623641806049, 1.006393135851923],
            [14.875181184962317, 1.0041406286928116],
            [14.875307633469632, 0.9962062123207006],
            [14.872263533787812, 0.9849536350312217],
            [14.876185438800691, 0.9818740108999853],
            [14.876167083994009, 0.974643755564177],
            [14.879187873677154, 0.9744352407752491],
            [14.883529711864202, 0.9711377098225891],
            [14.89073470758308, 0.9687466796273557],
            [14.893426359850011, 0.9612637606705902],
            [14.888675858755173, 0.9610432638168008],
            [14.881326571827042, 0.9665570564457516],
            [14.87466127006693, 0.9626707168032005],
            [14.868247665747415, 0.9534646942483201],
            [14.864363014446061, 0.9529494649635064],
            [14.859880813973176, 0.9560782116430824],
            [14.854186581002526, 0.9584210320320221],
            [14.851004918158733, 0.956647076891884],
            [14.849263525519556, 0.952664874718417],
            [14.844395934919506, 0.9519896929059934],
            [14.831527945790274, 0.9582015127375024],
            [14.822007777068347, 0.9586141349063634],
            [14.819612915211444, 0.9598392802142116],
            [14.814853565469663, 0.9678383401174152],
            [14.807549285891286, 0.9699880232461339],
            [14.80351509137234, 0.9740664764876873],
            [14.801636783337443, 0.9792661707770095],
            [14.793818168039055, 0.9821426428498692],
            [14.784011251896812, 0.9974196832543893],
            [14.77624407893525, 1.0062366378575218],
            [14.771960930685902, 1.0128634448118805],
            [14.765650508659995, 1.0140473761485647],
            [14.763242095249378, 1.0091179634603495],
            [14.759433707559895, 1.0090169113647671],
            [14.753865241319478, 1.0123302876251958],
            [14.746474219617765, 1.0148020401371178],
            [14.742480390925792, 1.015054226619773],
            [14.735997427068764, 1.0126614245382008],
            [14.7323298549404, 1.009421030026206],
            [14.728608306189878, 1.0085884774931912],
            [14.725734416147755, 1.0058031680652757],
            [14.728622174641185, 0.9949246398036177],
            [14.72561140064298, 0.9939657705995519],
            [14.719455036574635, 0.9953610457591533],
            [14.714414350157384, 0.9998748255577746],
            [14.710940620851073, 1.0074473594247852],
            [14.699490687860214, 1.0141612942735612],
            [14.692445117559686, 1.0143063595337858],
            [14.689500059129953, 1.0184024871685804],
            [14.690870615620831, 1.0229097749413736],
            [14.687326103594593, 1.026339767471345],
            [14.67682367291903, 1.0231004215972106],
            [14.671204241256023, 1.0109027762459388],
            [14.668069703770222, 1.0069464718157697],
            [14.665378709036256, 1.006710193137409],
            [14.661882884895517, 1.0097845716961156],
            [14.66282292810809, 1.0222738752292158],
            [14.655956117829481, 1.0294728641306627],
            [14.652477027469153, 1.0357832552509414],
            [14.646788089153732, 1.03884917808104],
            [14.644604010558364, 1.0482425322448405],
            [14.642397136271914, 1.0512384087747555],
            [14.641921391068252, 1.0555495610654875],
            [14.638840566367872, 1.060626394314373],
            [14.63174658531121, 1.0615651093538465],
            [14.62896041090562, 1.0677028684027163],
            [14.628673511840024, 1.0759766537751656],
            [14.626215812883094, 1.0784257249286155],
            [14.625318684058406, 1.0881201155731053],
            [14.627707224575637, 1.0916572995722809],
            [14.625273217320535, 1.0971735418434685],
            [14.626832217946308, 1.1025432036340208],
            [14.625181487134563, 1.1076077658393604],
            [14.620668396887346, 1.110276969529964],
            [14.623101261299981, 1.1149636630582755],
            [14.622962686885732, 1.1208467230870265],
            [14.619589217587949, 1.1243262711584823],
            [14.617045267760309, 1.1291646093334475],
            [14.616065645405191, 1.1347431242707544],
            [14.61991335880303, 1.138218062832743],
            [14.622020357202942, 1.1442947377667816],
            [14.659873293139647, 1.2052304631466044],
            [14.676579641883535, 1.2388573546627326]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.45793664549166, "lat": 38.42072738548577 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51179"],
        "coty_name": ["Stafford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stafford County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "01480173"
      },
      "bbox": [
        14.616065645405191, 0.9519896929059934, 14.903149890243547,
        1.2824075635718581
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.938784941403561, 1.5863305385705837],
            [14.94190973206406, 1.585923940124804],
            [14.947821800197785, 1.5808371872599456],
            [14.959383743275987, 1.573914802871334],
            [14.960568923270962, 1.577145858177658],
            [14.95956107518092, 1.5854567590352016],
            [14.957657604740758, 1.5906670121884774],
            [14.962705920906709, 1.5906151272761724],
            [14.971945890262901, 1.5934810235254828],
            [14.974057019772623, 1.5949470646337403],
            [14.983143295774898, 1.5920923537296052],
            [14.986578318512436, 1.5937170244750356],
            [14.98969551917532, 1.5926371508204882],
            [14.99036198275536, 1.5877398627800294],
            [14.995172440334915, 1.5861376155823976],
            [14.996725408691573, 1.5827444258668968],
            [14.99740968817381, 1.5754695951573008],
            [15.00017323209599, 1.5685871791643622],
            [15.001683055516242, 1.555120345033705],
            [15.003435884670454, 1.546033719265387],
            [15.003660393764475, 1.5396022440728372],
            [14.986934336153725, 1.5453005473997663],
            [14.984302502244018, 1.5470902550027528],
            [14.972497968190426, 1.5492246928232953],
            [14.955593102629113, 1.5484808378921573],
            [14.952025870872136, 1.5478436321734228],
            [14.927559744806391, 1.5374565248453986],
            [14.920982372326968, 1.5460386991876338],
            [14.919698432218679, 1.552375863810428],
            [14.923196139399387, 1.5606017276268829],
            [14.919335403075959, 1.5653882233632301],
            [14.92522953477495, 1.5731890233249852],
            [14.928729110477207, 1.5821756191267393],
            [14.93137587047758, 1.581797996905703],
            [14.938784941403561, 1.5863305385705837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.08603046388615, "lat": 38.81845988411259 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51510"],
        "coty_name": ["Alexandria"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Alexandria city"],
        "coty_fp_code": "510",
        "coty_gnis_code": "01498415"
      },
      "bbox": [
        14.919335403075959, 1.5374565248453986, 15.003660393764475,
        1.5949470646337403
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.012608230891683, -0.6023908596028125],
            [15.01275130590777, -0.5986044007528566],
            [15.016053110974248, -0.5962529448753325],
            [15.016245520297069, -0.5907755709933791],
            [15.02607781898446, -0.5916289209339729],
            [15.02886595563217, -0.587290147991462],
            [15.035634424174832, -0.5880389671557685],
            [15.043471991630089, -0.5862791222611791],
            [15.046308611919672, -0.5778449960955944],
            [15.052489735477838, -0.5808285855191571],
            [15.050235520915166, -0.5876326615251986],
            [15.049428561475692, -0.5987549901171022],
            [15.055840801485997, -0.594819668499324],
            [15.057704594091945, -0.6063152330719088],
            [15.059682182126522, -0.6064462066923337],
            [15.059101473410141, -0.6138929252905636],
            [15.050187814326161, -0.6132306730298467],
            [15.049362194249262, -0.6197972206511703],
            [15.045241679824704, -0.6264463351172783],
            [15.042702187184796, -0.6249922273045673],
            [15.03629258597188, -0.6262038346242622],
            [15.030900934903991, -0.6308630537861202],
            [15.023835238897234, -0.6291910669928309],
            [15.0206132022122, -0.617628354646907],
            [15.015140527069205, -0.6042484073215942],
            [15.012608230891683, -0.6023908596028125]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.53569674155618,
          "lat": 36.695186899006316
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51595"],
        "coty_name": ["Emporia"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Emporia city"],
        "coty_fp_code": "595",
        "coty_gnis_code": "01498422"
      },
      "bbox": [
        15.012608230891683, -0.6308630537861202, 15.059682182126522,
        -0.5778449960955944
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.81960279266801, 0.03193260292946001],
            [15.824015461095108, 0.033366882935706714],
            [15.828515161260205, 0.03133113468147246],
            [15.839233852431159, 0.031659117999093454],
            [15.842507183509614, 0.027261723416533636],
            [15.848626745868863, 0.02799787229304076],
            [15.85041524976389, 0.03219081044267884],
            [15.845598732028131, 0.033978471097769754],
            [15.84396591120741, 0.03744218877801651],
            [15.848328378246483, 0.04374251605722057],
            [15.851972731009644, 0.04487152871321872],
            [15.853376236780147, 0.047669636050776634],
            [15.861816186417894, 0.0497923215436602],
            [15.869356781876103, 0.04118299594191088],
            [15.87166692257614, 0.03342942172851773],
            [15.879308331448803, 0.028473513782697392],
            [15.888660249267746, 0.0271626039950159],
            [15.893284874520353, 0.024414634088876414],
            [15.897079956740878, 0.02499752786176207],
            [15.906040918142041, 0.019280037577479158],
            [15.907969539521403, 0.01968560303197174],
            [15.912119839440926, 0.013476088628055306],
            [15.909341160928413, 0.008144306520412007],
            [15.909368031174287, 0.0034572914427546757],
            [15.914725754122589, 0.00008869508239387168],
            [15.91179154533584, -0.007246765769759487],
            [15.904181004915067, -0.010130207185598403],
            [15.899619990377024, -0.010011457393919558],
            [15.879800477637394, -0.020569385511073082],
            [15.872877967684568, -0.011807693494129287],
            [15.858817549839985, -0.008255812437422475],
            [15.853036547478197, -0.01433323287406419],
            [15.847957222096712, -0.011460276294654292],
            [15.844824468067548, -0.016449996976177706],
            [15.838133884276179, -0.01864253857848709],
            [15.824350862343659, 0.0011113801485249251],
            [15.821203505631509, 0.0018046511228449133],
            [15.821272672452173, 0.006226980868191621],
            [15.818033423837775, 0.009216969644870067],
            [15.817421526314826, 0.019030207507891344],
            [15.814872793274445, 0.02666220108954457],
            [15.81960279266801, 0.03193260292946001]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.35684326859067, "lat": 37.13094299399731 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51735"],
        "coty_name": ["Poquoson"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Poquoson city"],
        "coty_fp_code": "735",
        "coty_gnis_code": "01498436"
      },
      "bbox": [
        15.814872793274445, -0.020569385511073082, 15.914725754122589,
        0.0497923215436602
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.814397588737716, 9.97226136890587],
            [-15.809912835128625, 9.969443889902408],
            [-15.789970707725466, 9.963236285578061],
            [-15.78048953647561, 9.961468858243757],
            [-15.768219760382785, 9.962239382553594],
            [-15.740216763616631, 9.960532561425223],
            [-15.730424327698838, 9.958571579751599],
            [-15.724521296511377, 9.95939458112515],
            [-15.717111310930777, 9.961958636147141],
            [-15.70621379452925, 9.964429674829352],
            [-15.700539437766311, 9.964392147881446],
            [-15.688095503177871, 9.960662013724273],
            [-15.68112565101397, 9.957177835828803],
            [-15.675278676061824, 9.952118285438697],
            [-15.667997506105253, 9.947641163240101],
            [-15.663241208654107, 9.946175993360285],
            [-15.655766202248522, 9.9455865997299],
            [-15.6444540690773, 9.946142055360891],
            [-15.639037089175314, 9.94773897364704],
            [-15.625074178885468, 9.95409944232024],
            [-15.609005111238242, 9.9628429590936],
            [-15.59170100255779, 9.976967849232025],
            [-15.584767892711852, 9.981426853722176],
            [-15.571832522344659, 9.99083769191035],
            [-15.567922262614548, 9.992829562506214],
            [-15.559404928784728, 10.002367383916127],
            [-15.551455317452223, 10.006942010551766],
            [-15.54797861731383, 10.006126821496258],
            [-15.541854861264712, 10.00158652445324],
            [-15.533813328747511, 9.990443043633315],
            [-15.532176086388306, 9.984964299276443],
            [-15.524441108662202, 9.96913554603486],
            [-15.517919063933416, 9.959707077187726],
            [-15.517061393676457, 9.956503650694714],
            [-15.520943726869529, 9.950384138151028],
            [-15.524216334089207, 9.948146594957613],
            [-15.524813762469629, 9.94303461462567],
            [-15.517740704924215, 9.934416313317815],
            [-15.512193942058872, 9.929259397664385],
            [-15.504084172209794, 9.923692686800873],
            [-15.500606264162538, 9.91840680824196],
            [-15.499151607710425, 9.912226287430789],
            [-15.49962244686529, 9.905810843431567],
            [-15.50256004512908, 9.89693565758075],
            [-15.504451367022561, 9.885998765632255],
            [-15.503937081110859, 9.88020495149633],
            [-15.501279674849618, 9.873739678694287],
            [-15.492158959895292, 9.856798801697643],
            [-15.487060707445616, 9.84421399303397],
            [-15.48439525668016, 9.839932167912941],
            [-15.476047682025268, 9.830195253472276],
            [-15.467577416551888, 9.823022481200866],
            [-15.4645873643647, 9.819009763349891],
            [-15.459791089962867, 9.807624383657851],
            [-15.455982938768582, 9.79269950332769],
            [-15.43927041395802, 9.774373978646057],
            [-15.436974731026321, 9.769736585275306],
            [-15.435945778044038, 9.744410034609587],
            [-15.437707955936267, 9.734514522562048],
            [-15.443076731204085, 9.72808313972213],
            [-15.443332979300282, 9.719680750811547],
            [-15.444677420480293, 9.714096684572851],
            [-15.448632122555201, 9.704146304170338],
            [-15.450316482177447, 9.692276622651503],
            [-15.450178513179742, 9.68629318647542],
            [-15.458077207950279, 9.666780647491215],
            [-15.463179313656747, 9.65662024787905],
            [-15.464596626760216, 9.645783792638998],
            [-15.467670357718397, 9.635368726718402],
            [-15.471945925632237, 9.62932775139118],
            [-15.472839704023144, 9.625564398071077],
            [-15.473347991165172, 9.60790669364851],
            [-15.470507349549973, 9.599762335835992],
            [-15.4708525429712, 9.589165128579822],
            [-15.473411009195527, 9.569399029330572],
            [-15.476795361641853, 9.562412593833807],
            [-15.481773937921872, 9.556105374116722],
            [-15.487949449239867, 9.550083715606892],
            [-15.490775426741614, 9.54602370236361],
            [-15.494027482707267, 9.536954151565526],
            [-15.493765527520418, 9.533072207039112],
            [-15.490938389921864, 9.527675991603235],
            [-15.482965290727758, 9.522672249188824],
            [-15.477345461785442, 9.515939275519205],
            [-15.47328807305521, 9.506742155894264],
            [-15.464980214813952, 9.49043597167309],
            [-15.461081589157223, 9.485833601070022],
            [-15.450775234092623, 9.480730045209238],
            [-15.442490177353013, 9.474394976562374],
            [-15.433357016004178, 9.470251895816402],
            [-15.426273695736878, 9.468714123308171],
            [-15.41148343873976, 9.462647557744885],
            [-15.403763798497364, 9.457805569394814],
            [-15.396727820532089, 9.451579162833593],
            [-15.390004117494579, 9.443664300431742],
            [-15.380845628460738, 9.436166525905636],
            [-15.373909070338561, 9.429416622934577],
            [-15.36457174717163, 9.42157870721457],
            [-15.362407211156913, 9.418393411849053],
            [-15.354836223701362, 9.408876518948457],
            [-15.3479705658767, 9.398171398285744],
            [-15.346048017679834, 9.392667244042498],
            [-15.339056006981526, 9.37899691638821],
            [-15.332712815577404, 9.364388576793795],
            [-15.327715082590652, 9.347225883556193],
            [-15.328999442946515, 9.339384296690014],
            [-15.331236588916154, 9.335890837624927],
            [-15.328605810767467, 9.315084476795521],
            [-15.32463266911476, 9.297828339348067],
            [-15.323822728433475, 9.289045524035604],
            [-15.326984702578272, 9.277853381469804],
            [-15.332603018492618, 9.267860170408568],
            [-15.33437271269823, 9.260365354102731],
            [-15.333574219479164, 9.255093881241153],
            [-15.333682952528335, 9.246378888103346],
            [-15.334707130195413, 9.24354739868215],
            [-15.350069489409268, 9.23952026131073],
            [-15.371956948223605, 9.225008677915897],
            [-15.391296977907942, 9.208886062729135],
            [-15.406222029760867, 9.20223323236999],
            [-15.432012536114572, 9.197758043157483],
            [-15.457263263641334, 9.187902676032763],
            [-15.481874375302063, 9.183886849675437],
            [-15.512455266326414, 9.186048367321698],
            [-15.529984582714185, 9.190626190789537],
            [-15.549229062515979, 9.200293100421524],
            [-15.568705228149337, 9.212407457641095],
            [-15.614490191376388, 9.216856687573937],
            [-15.645597235243681, 9.212785759216793],
            [-15.69218116005161, 9.22093020931879],
            [-15.704629286925805, 9.223112279940683],
            [-15.732704995890018, 9.218865769784308],
            [-15.75700084411686, 9.22725768769174],
            [-15.784577865296155, 9.251278981883958],
            [-15.805574320148233, 9.250555284096345],
            [-15.82442236734502, 9.241094322236153],
            [-15.867816211835086, 9.202359113298357],
            [-15.940223714142139, 9.209089512720539],
            [-15.959823162022454, 9.216022194532261],
            [-16.00702087097825, 9.216159421391845],
            [-16.00301108520493, 9.230520909900608],
            [-15.977558786278546, 9.327448864214952],
            [-15.959177660850855, 9.397212014082053],
            [-15.954517580615358, 9.411371265924588],
            [-15.932954438761316, 9.493645713020761],
            [-15.918838699995103, 9.550953184976677],
            [-15.911906727044936, 9.577156834030534],
            [-15.916618087883244, 9.578377202744646],
            [-15.912869409379134, 9.59223470639125],
            [-15.895008307886245, 9.661761448935943],
            [-15.891285203839303, 9.675800750377139],
            [-15.842075182842626, 9.867216282674717],
            [-15.830750081711505, 9.909982452784668],
            [-15.832429684599068, 9.910379679876213],
            [-15.827728218753933, 9.923940978591576],
            [-15.814397588737716, 9.97226136890587]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.51122962186551,
          "lat": 46.23978798292587
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53005"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01513302"
      },
      "bbox": [
        -16.00702087097825, 9.183886849675437, -15.323822728433475,
        10.006942010551766
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.177679087542284, 11.49876295675675],
              [-17.138729593265047, 11.487741242380094],
              [-17.055517226167257, 11.463313721948504],
              [-16.985626758978665, 11.443349516039156],
              [-16.977413305509174, 11.441339889961187],
              [-16.956476463749013, 11.435111535143166],
              [-16.915544393050126, 11.42351096937251],
              [-16.899685460240192, 11.419995467900058],
              [-16.870295656287613, 11.412748287142948],
              [-16.816494859621127, 11.398397759941686],
              [-16.80254445756431, 11.394214209340317],
              [-16.760970828291207, 11.382986015674886],
              [-16.753621796833084, 11.381646401030451],
              [-16.73338198096242, 11.375491565584872],
              [-16.703105080944912, 11.367361094544458],
              [-16.6494625327324, 11.352668920437763],
              [-16.620502063955335, 11.345644030180152],
              [-16.593987350180203, 11.338470666803786],
              [-16.564896712957033, 11.331239609648794],
              [-16.5643254314763, 11.333255691532461],
              [-16.479649037696657, 11.309883188895132],
              [-16.394979766623702, 11.286484975831327],
              [-16.394700577299748, 11.287376898861002],
              [-16.34479198830556, 11.27393991550997],
              [-16.34605218988124, 11.270145765627193],
              [-16.341694777802584, 11.25983342730854],
              [-16.344931388530515, 11.252277880894283],
              [-16.342473801966754, 11.250001059196627],
              [-16.33715127827088, 11.25079402214246],
              [-16.333982660162388, 11.249138893456855],
              [-16.334296044559878, 11.237032336394288],
              [-16.33048880990922, 11.233303922075239],
              [-16.32907871887061, 11.22868188570994],
              [-16.3347550692558, 11.223233538981415],
              [-16.336882261054164, 11.218994895248633],
              [-16.336371116230904, 11.214022439292338],
              [-16.33356353059471, 11.210523387123525],
              [-16.328537024423838, 11.206811877410015],
              [-16.327205295654064, 11.20237556607],
              [-16.328285162883958, 11.198299522372489],
              [-16.331041942252668, 11.195968979768141],
              [-16.338964032597143, 11.193749126825859],
              [-16.34449920507606, 11.196403880969912],
              [-16.350313955566627, 11.19013748570291],
              [-16.359478268853618, 11.185922039199317],
              [-16.361869490601606, 11.186569665878574],
              [-16.372026843612982, 11.184299114955518],
              [-16.37359943477695, 11.180984869478566],
              [-16.37801172766407, 11.178092660484854],
              [-16.37765192721533, 11.165023369012172],
              [-16.380859925137973, 11.159650930316221],
              [-16.385126260176985, 11.157839849311479],
              [-16.389137189263305, 11.150187264608443],
              [-16.38634480846373, 11.142211841072491],
              [-16.388720238859342, 11.136771762534842],
              [-16.387925729264197, 11.131421278304936],
              [-16.38419123880062, 11.130063092912948],
              [-16.382282834270974, 11.124088766032921],
              [-16.383227231519434, 11.120750493932874],
              [-16.387869293171132, 11.119707417376578],
              [-16.389060941693767, 11.115827889432838],
              [-16.388054017507603, 11.108096146886474],
              [-16.38622576631919, 11.103151996466154],
              [-16.388489160514162, 11.101235686159477],
              [-16.392162757228483, 11.100577370248766],
              [-16.394335986270498, 11.09676003032535],
              [-16.405619825836315, 11.103919161980137],
              [-16.40822044925498, 11.101260864893494],
              [-16.413520652538885, 11.105967013333231],
              [-16.428823435815683, 11.10465235022755],
              [-16.4288961935596, 11.100583577602075],
              [-16.431039406932783, 11.098505919109352],
              [-16.430108757365453, 11.094029523063806],
              [-16.433172319693018, 11.089286863264217],
              [-16.437181876508525, 11.086362483765969],
              [-16.43767210465832, 11.08365470560699],
              [-16.441815501082335, 11.082992218365826],
              [-16.44489271153514, 11.087394497537131],
              [-16.449692327300856, 11.086064891687975],
              [-16.458931940964813, 11.088350330919184],
              [-16.463460441688532, 11.093374002549144],
              [-16.472315650913053, 11.091544616300732],
              [-16.476387520174796, 11.087417248084016],
              [-16.479159463336426, 11.078180361253649],
              [-16.482034365403862, 11.07296835335501],
              [-16.4876621341217, 11.072845805872928],
              [-16.48922460536041, 11.066022268466048],
              [-16.500301632697692, 11.062131246963663],
              [-16.505910902718696, 11.057896968341819],
              [-16.516226251706975, 11.060201318962351],
              [-16.522119694180734, 11.055772012890557],
              [-16.526290487813643, 11.048485568172852],
              [-16.530685517581095, 11.042700139860251],
              [-16.537392693168854, 11.038409681670709],
              [-16.541769458487693, 11.029683467421243],
              [-16.54779075253641, 11.02821809058327],
              [-16.548965078344583, 11.025111370429224],
              [-16.558460280685036, 11.026006580855196],
              [-16.56392970877031, 11.023148839411412],
              [-16.56763225826641, 11.026858990284943],
              [-16.576619880640244, 11.018092745699583],
              [-16.58373899415253, 11.020107473260804],
              [-16.592788184933983, 11.01746760286125],
              [-16.59990805395307, 11.013306287780107],
              [-16.600784960222516, 11.00980791096599],
              [-16.606446612333038, 11.005456364520139],
              [-16.605613146788404, 10.998901032696784],
              [-16.609063053870162, 10.995616931130456],
              [-16.619774482063498, 10.996155374909845],
              [-16.62595075091807, 10.993684508356212],
              [-16.629268847013783, 10.989527829898103],
              [-16.63182542668952, 10.988925527489132],
              [-16.636745292592046, 10.990760762260798],
              [-16.640501787814244, 10.990035449371693],
              [-16.642272545579694, 10.986209250274529],
              [-16.639200850856273, 10.981683987351643],
              [-16.64159928171672, 10.975110525624924],
              [-16.646654105349313, 10.974224546863798],
              [-16.650202253268844, 10.970793305527515],
              [-16.647025864359392, 10.966738007262041],
              [-16.64784198410045, 10.96062035885158],
              [-16.650824635137496, 10.958924670326683],
              [-16.658188967267492, 10.959596653068749],
              [-16.66026089251295, 10.954576632823244],
              [-16.66084120317392, 10.949249906767184],
              [-16.670770501036714, 10.948828381808722],
              [-16.673901403362336, 10.950918835752875],
              [-16.677633330818246, 10.949401450210393],
              [-16.679955849983948, 10.94599721886621],
              [-16.679016187027212, 10.938157906872494],
              [-16.68207260378777, 10.934239574874432],
              [-16.672008188137184, 10.920742649245714],
              [-16.668089156874366, 10.919693326466001],
              [-16.665163330244713, 10.9091050665337],
              [-16.667181827681993, 10.905244996844074],
              [-16.67024165324886, 10.905018006620901],
              [-16.674650377730938, 10.899397144449182],
              [-16.674764152011576, 10.895139317415438],
              [-16.6808701901553, 10.889838565103112],
              [-16.681155918060373, 10.887253749343072],
              [-16.674496549644363, 10.882309567727757],
              [-16.6772774396763, 10.871956139238943],
              [-16.675100730690215, 10.866211149174951],
              [-16.6702111373804, 10.862746464026458],
              [-16.66929033116762, 10.866026404541133],
              [-16.665776699120663, 10.867874531302819],
              [-16.664487732538653, 10.864240106949188],
              [-16.65949100670758, 10.861419862176149],
              [-16.653068163079865, 10.859901485646555],
              [-16.651717742107884, 10.85688269883796],
              [-16.648071460750284, 10.854949962216516],
              [-16.643723215597817, 10.854988498170906],
              [-16.64045418749711, 10.852764762916879],
              [-16.63488659504469, 10.857216596561077],
              [-16.63047323965527, 10.856091377717165],
              [-16.631757452008213, 10.851736498160808],
              [-16.628121942063952, 10.84827713460646],
              [-16.621656808459402, 10.845340559726845],
              [-16.620374049448316, 10.843593224256823],
              [-16.62227346879561, 10.8231452651893],
              [-16.62024026706794, 10.82088572628035],
              [-16.62285117570335, 10.816779259594583],
              [-16.625642434733827, 10.815905746209467],
              [-16.62835345399568, 10.811244785680119],
              [-16.63219912166371, 10.811794544156605],
              [-16.63752882197051, 10.809088026590134],
              [-16.64292916431659, 10.80898825730136],
              [-16.64395222769954, 10.802488596267727],
              [-16.650729409488743, 10.7966464998462],
              [-16.65099575796987, 10.794397582329319],
              [-16.64008954955129, 10.785517100289441],
              [-16.63270431335036, 10.784034966524297],
              [-16.626808490950076, 10.779172229408218],
              [-16.62293825602333, 10.774277788747952],
              [-16.6198134821611, 10.76396807451651],
              [-16.622318914762015, 10.761268581117612],
              [-16.62067289869892, 10.754047994696215],
              [-16.621882501788587, 10.74925971202069],
              [-16.63330236188847, 10.737393355473946],
              [-16.632299022525583, 10.72980562365755],
              [-16.62842511858523, 10.724966080910473],
              [-16.62646294926858, 10.711118046189378],
              [-16.629914130939227, 10.70794007589449],
              [-16.632707760589955, 10.702750839151891],
              [-16.64207619800396, 10.700095902625723],
              [-16.64502271871703, 10.70235631536277],
              [-16.65515411274624, 10.702445138330447],
              [-16.656541754663717, 10.705159456546005],
              [-16.663582930291767, 10.709618316223263],
              [-16.665625431799224, 10.713199828720619],
              [-16.67241433175538, 10.716258464865236],
              [-16.679183670242644, 10.714375137090487],
              [-16.68457022863845, 10.714960418779617],
              [-16.69033686228832, 10.712743600665538],
              [-16.6940934682816, 10.712967346171212],
              [-16.695764050964154, 10.70927120674491],
              [-16.6996566578897, 10.707565395243673],
              [-16.7027396702963, 10.704152847296843],
              [-16.707254484434255, 10.70164660738137],
              [-16.706840793350853, 10.689713397795366],
              [-16.70607124765183, 10.684719392352227],
              [-16.708976146709855, 10.682317723240258],
              [-16.702840902935275, 10.674122103180883],
              [-16.697026310866907, 10.675554227602376],
              [-16.696556418126367, 10.667743332892162],
              [-16.696805412727297, 10.667559859711668],
              [-16.704500179400107, 10.671279550002385],
              [-16.71418338016125, 10.673633420428159],
              [-16.717023688604055, 10.676497646833846],
              [-16.721205237430485, 10.675283358055914],
              [-16.72863811670721, 10.676225565891407],
              [-16.73833537073629, 10.675853358864885],
              [-16.742630481090732, 10.681078222435499],
              [-16.74559707025273, 10.682831246964927],
              [-16.747242585119647, 10.686636320759057],
              [-16.751294652016423, 10.691227482695291],
              [-16.75579362010653, 10.69975096610627],
              [-16.75735104667892, 10.707804071525931],
              [-16.76037108781808, 10.710189880729654],
              [-16.762005142197893, 10.715062790843776],
              [-16.76674205639711, 10.716147409170677],
              [-16.772134180865905, 10.719744458945085],
              [-16.77273743574934, 10.7235138879738],
              [-16.778063169421667, 10.725123610359242],
              [-16.786947437779368, 10.729715901592712],
              [-16.79000310247234, 10.728579461555313],
              [-16.795083975747193, 10.730475300407628],
              [-16.802724168402936, 10.731715811617844],
              [-16.806972355588982, 10.730110976029204],
              [-16.814256611518015, 10.731737084848056],
              [-16.81747212044528, 10.73350773965755],
              [-16.821776854868453, 10.733142046476683],
              [-16.829070898139705, 10.738739701714643],
              [-16.83086630945845, 10.74859247804056],
              [-16.83480534095344, 10.756676045728097],
              [-16.83478338321726, 10.761343608705468],
              [-16.841082624939478, 10.771449921800656],
              [-16.844860306961273, 10.774747851416508],
              [-16.849236665351327, 10.775728486361434],
              [-16.852762011739433, 10.779004069799864],
              [-16.85614613038474, 10.779296900626392],
              [-16.859883462714965, 10.783996404577385],
              [-16.865339998546144, 10.786448135415542],
              [-16.869045599674312, 10.783709999545325],
              [-16.873470427934617, 10.783962302563962],
              [-16.880885305299532, 10.780760187605583],
              [-16.89406422741221, 10.786591220606208],
              [-16.904011770654346, 10.78854366419384],
              [-16.908331191759025, 10.796617345469263],
              [-16.913836813703472, 10.800777642978641],
              [-16.915451359254757, 10.804827366424497],
              [-16.920637118694003, 10.80405240155697],
              [-16.927274277290653, 10.811202272142033],
              [-16.93310550937506, 10.810874354024625],
              [-16.935493367653745, 10.812856033665367],
              [-16.936987855732017, 10.817569468579208],
              [-16.939784242363846, 10.819637573627302],
              [-16.94816235449076, 10.822881305636681],
              [-16.954176812663814, 10.820490840417433],
              [-16.957225293211934, 10.817303796013933],
              [-16.96026791827166, 10.81669860201853],
              [-16.96420439347036, 10.812881141815877],
              [-16.967478335688646, 10.813533348818126],
              [-16.974230877856126, 10.809168957012906],
              [-16.977797812330547, 10.808812309309426],
              [-16.978668775154333, 10.80588257476734],
              [-16.984601292205088, 10.802730582644484],
              [-16.988993273463294, 10.804802843312428],
              [-16.990127868720453, 10.80787110372152],
              [-16.99803263010206, 10.810388029805763],
              [-16.997015205124413, 10.813352652315926],
              [-17.00023690339962, 10.816246471800788],
              [-17.005740274381512, 10.815830718501362],
              [-17.007490348790352, 10.819403987967005],
              [-17.01308356670863, 10.820087962716602],
              [-17.022441445474325, 10.82549168326992],
              [-17.028248136248354, 10.822223863256712],
              [-17.034638901867613, 10.823324538973186],
              [-17.041944030964736, 10.822693400511096],
              [-17.04269604009948, 10.81996855476562],
              [-17.049088502336527, 10.815031164529913],
              [-17.05432319748889, 10.818245200737715],
              [-17.057484783093347, 10.824819768962792],
              [-17.055585235192524, 10.829739413089754],
              [-17.056058943542563, 10.833483129023495],
              [-17.059650057409176, 10.837234078242629],
              [-17.067308338091866, 10.83857849359233],
              [-17.068259279023838, 10.843126481125568],
              [-17.07237919943638, 10.848243564156865],
              [-17.079606829957235, 10.848816658243386],
              [-17.078735027348646, 10.858046847886078],
              [-17.083758299329084, 10.857022048070489],
              [-17.090163318012674, 10.864727684811323],
              [-17.097025475712293, 10.864513408386994],
              [-17.103081578086503, 10.867232316853608],
              [-17.10617861521237, 10.86605330262156],
              [-17.114670711265326, 10.866766579241],
              [-17.119189769381386, 10.87665664295832],
              [-17.12214754002163, 10.884800399874825],
              [-17.1296922995078, 10.888935201278601],
              [-17.134701055222887, 10.895303489707013],
              [-17.13846198394241, 10.896926042016913],
              [-17.138200334303296, 10.900468275173845],
              [-17.141436356251326, 10.903152434095885],
              [-17.145091214582763, 10.917356206129456],
              [-17.147174961562612, 10.92126417250955],
              [-17.145346606761347, 10.929762125455905],
              [-17.143127605795133, 10.935415119511296],
              [-17.14912668727273, 10.93810978580248],
              [-17.145623686755844, 10.942860065162344],
              [-17.14597022358326, 10.944940462267349],
              [-17.151760717889893, 10.95068027621383],
              [-17.153177113919398, 10.953947802608853],
              [-17.150608925561755, 10.961030804992722],
              [-17.154483814948687, 10.965170028653938],
              [-17.1826447130218, 10.972755131357973],
              [-17.21083241587432, 10.980842875146706],
              [-17.251217193470772, 10.991721921233276],
              [-17.279843440275002, 11.000104549662627],
              [-17.278283793216236, 11.0052673769004],
              [-17.317174831485847, 11.074211876061225],
              [-17.306718496904324, 11.073523917010679],
              [-17.301166594250155, 11.076369767715919],
              [-17.29738420308455, 11.076795965146108],
              [-17.293578260118064, 11.072953569611068],
              [-17.288448121017613, 11.073578677892991],
              [-17.285147119134898, 11.078176910994356],
              [-17.27770492366338, 11.079017646719363],
              [-17.258362681440858, 11.079162673441099],
              [-17.25097152497941, 11.081411968671864],
              [-17.24849909738478, 11.083611885212642],
              [-17.241884304249268, 11.107425582227167],
              [-17.23941621854695, 11.120832479920756],
              [-17.237400583805353, 11.124123385343742],
              [-17.2392111307054, 11.129552332083271],
              [-17.239028767210232, 11.14171315524258],
              [-17.245372015624614, 11.15108769184642],
              [-17.245491556415484, 11.158377160707321],
              [-17.243391673375523, 11.165616378440689],
              [-17.24388365261945, 11.171458144260807],
              [-17.242947118379536, 11.176769062489646],
              [-17.246266636927498, 11.178316456420257],
              [-17.24918522668878, 11.184289395335101],
              [-17.25893199083675, 11.18995278893116],
              [-17.250447012223034, 11.192922581044968],
              [-17.24668235150675, 11.195348570766294],
              [-17.24577689890302, 11.203754684039808],
              [-17.243488232481393, 11.20816375790532],
              [-17.236257605205132, 11.214937154467627],
              [-17.23541371341052, 11.218607241669119],
              [-17.237999282844143, 11.22649006145393],
              [-17.24714290211826, 11.239056109124801],
              [-17.249907447199615, 11.24739151161586],
              [-17.2509534020487, 11.255541111403],
              [-17.247871708671834, 11.257401038627306],
              [-17.245760883899912, 11.261570030939136],
              [-17.24905856495893, 11.267647314573239],
              [-17.2446816929266, 11.272067798279586],
              [-17.243635048938067, 11.282251755998757],
              [-17.24174500309176, 11.286079449202512],
              [-17.24241368712907, 11.293561239610579],
              [-17.244724952618878, 11.30352608599942],
              [-17.24413629516206, 11.305792511883316],
              [-17.249581388602195, 11.314507718955003],
              [-17.234824971227194, 11.318381668154064],
              [-17.22201292064371, 11.326750893571056],
              [-17.218976332372463, 11.324079574365918],
              [-17.219578754373543, 11.320638579652005],
              [-17.21722961576827, 11.314741444988915],
              [-17.208921429323635, 11.31102482144201],
              [-17.203926134312454, 11.31320222870688],
              [-17.19437318662798, 11.314476873252378],
              [-17.189992122444202, 11.321247225180654],
              [-17.190814005666155, 11.33160889127183],
              [-17.20053433261453, 11.345683652464595],
              [-17.202920306114713, 11.351251133071703],
              [-17.211464121348882, 11.354788608838374],
              [-17.21011669177251, 11.36003635445559],
              [-17.21575867998684, 11.359666895243812],
              [-17.22277327871242, 11.365644132204457],
              [-17.227969735471998, 11.373016157500633],
              [-17.22906042917286, 11.378058452611338],
              [-17.22769637615847, 11.381700208394633],
              [-17.228762651841866, 11.3865846055736],
              [-17.232662653529424, 11.393719666644976],
              [-17.236529845347086, 11.39763663568803],
              [-17.22825721798753, 11.398348280823067],
              [-17.220342328197987, 11.402119680597378],
              [-17.21569707196594, 11.401955333486029],
              [-17.214786296079886, 11.406236316600497],
              [-17.20739865425043, 11.417525909158439],
              [-17.207982965568178, 11.421332677194545],
              [-17.2048778021641, 11.425221196960617],
              [-17.19142663407957, 11.428367236474566],
              [-17.186782070925318, 11.431701492342343],
              [-17.18643783782587, 11.434580244734695],
              [-17.18216198660012, 11.437899033423687],
              [-17.18040901570939, 11.44355216985924],
              [-17.17655730850184, 11.449183662977235],
              [-17.176163830111975, 11.458402556650253],
              [-17.177707407772363, 11.468332756429646],
              [-17.173214424284794, 11.477890743629029],
              [-17.17646742225105, 11.48486820321687],
              [-17.178735248316972, 11.493290024791627],
              [-17.177679087542284, 11.49876295675675]
            ]
          ],
          [
            [
              [-17.377508398018282, 11.130280440451847],
              [-17.37404623608652, 11.137052921960226],
              [-17.36944040996516, 11.137928409082695],
              [-17.366112320312375, 11.145763950294546],
              [-17.369485082160402, 11.16189511946912],
              [-17.367102814464232, 11.167608174096209],
              [-17.361653604731075, 11.174870955259522],
              [-17.354993856979217, 11.179891481500986],
              [-17.35149542061759, 11.188329772962023],
              [-17.3449665099467, 11.212418352685967],
              [-17.33835983988804, 11.22294714691664],
              [-17.332227941146346, 11.228169168497823],
              [-17.32705250428434, 11.234779010637459],
              [-17.31519123854829, 11.238766124790596],
              [-17.308831608619442, 11.250941054166468],
              [-17.30355449988808, 11.263830001738457],
              [-17.29855650841236, 11.261413759059032],
              [-17.28979777367275, 11.252262232639485],
              [-17.295268566518395, 11.248472511269128],
              [-17.29932214893184, 11.2380933460885],
              [-17.29343193994861, 11.227721982859064],
              [-17.293224663241514, 11.22251438203298],
              [-17.287473557785397, 11.214066877215211],
              [-17.297362592220605, 11.203690402755562],
              [-17.29627990951757, 11.198758866257313],
              [-17.297559009290115, 11.192109266880289],
              [-17.299539659412545, 11.188388460391579],
              [-17.299315833173914, 11.180714992231172],
              [-17.296879919058753, 11.17335249573937],
              [-17.297941158484786, 11.17145234319682],
              [-17.305244246383424, 11.168933910379197],
              [-17.304859370808778, 11.164384354001244],
              [-17.306366209013767, 11.159531048755698],
              [-17.301052000114286, 11.152672558964749],
              [-17.280691529102462, 11.14408071502202],
              [-17.26953655074634, 11.13025390237129],
              [-17.273637516486808, 11.127964271449997],
              [-17.28899976077531, 11.128443048383662],
              [-17.292437751898174, 11.126408931219277],
              [-17.302345291029926, 11.125402847797124],
              [-17.305555666795996, 11.122407714893018],
              [-17.31151543153422, 11.122196204285338],
              [-17.31788608731976, 11.12034029351846],
              [-17.32771779080105, 11.112326092735085],
              [-17.334569271661394, 11.102427205198435],
              [-17.337074884141728, 11.102347559601704],
              [-17.34451224727362, 11.106520943926725],
              [-17.34776837435689, 11.109903289822238],
              [-17.347602125480243, 11.113941569970265],
              [-17.343688632882124, 11.121011822503295],
              [-17.33934902969485, 11.126654462816312],
              [-17.335972442093553, 11.128456459186408],
              [-17.33232665297817, 11.13399225424006],
              [-17.328579720168165, 11.12951266008588],
              [-17.326023947191718, 11.12961266417073],
              [-17.31567897832918, 11.139119626583327],
              [-17.30868514064483, 11.14058832920081],
              [-17.31081992120915, 11.147714129304063],
              [-17.308496778551746, 11.15685328498264],
              [-17.31451387540332, 11.156418842747161],
              [-17.32258265348224, 11.15819106940066],
              [-17.325887677315237, 11.15667055386596],
              [-17.32823127307411, 11.153248452442796],
              [-17.324979813231106, 11.15054125162159],
              [-17.31920476688214, 11.150717295968212],
              [-17.316116793386367, 11.143976050741403],
              [-17.322077727541696, 11.13911777780601],
              [-17.329762908422015, 11.14568013942044],
              [-17.335236527946495, 11.147017863753875],
              [-17.344350296779655, 11.1424270413897],
              [-17.350779238709883, 11.129045796772175],
              [-17.35278079895677, 11.121603709176036],
              [-17.35567956441462, 11.116862505395385],
              [-17.361205994886063, 11.101614787990721],
              [-17.363791007212324, 11.09735102447814],
              [-17.371399115930256, 11.09992155906583],
              [-17.373183102528913, 11.102495137740028],
              [-17.379811165618616, 11.104964963738253],
              [-17.381596517811005, 11.109836821289123],
              [-17.382543365949743, 11.118136307665834],
              [-17.377508398018282, 11.130280440451847]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.80525635086182,
          "lat": 47.49026915334113
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53033"],
        "coty_name": ["King"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["King County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01531933"
      },
      "bbox": [
        -17.382543365949743, 10.667559859711668, -16.327205295654064,
        11.49876295675675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.89835481480061, 0.44838085052062976],
            [10.913519198852443, 0.457996075222827],
            [10.93323439519609, 0.4675534784975082],
            [10.942580667842227, 0.47124088930263136],
            [10.951888792875488, 0.47574022708812685],
            [10.97320181096008, 0.48825802153002956],
            [10.9855417684244, 0.48494346584696296],
            [10.991601586516207, 0.486254087439216],
            [11.00765605119406, 0.4924621989471403],
            [11.022289823444762, 0.49697794293180775],
            [11.029686415459413, 0.501672724594479],
            [11.033859575080697, 0.5071419502538126],
            [11.0371319483894, 0.5163988724373698],
            [11.038857649199413, 0.5270642635641178],
            [11.039199969004724, 0.5425081973089645],
            [11.042217381979386, 0.5563486186074309],
            [11.041929841307994, 0.5645468799659737],
            [11.03931112081997, 0.5777358787880246],
            [11.03935700449634, 0.5833541778189164],
            [11.042657634425362, 0.5994438721324052],
            [11.041333818758673, 0.621494218959464],
            [11.039074607300881, 0.633817826197693],
            [11.040152395662862, 0.6404021959519233],
            [11.042823424391225, 0.6444685145114418],
            [11.051041389951367, 0.6569831383451863],
            [11.059731715983547, 0.6628388912055028],
            [11.072019886691745, 0.6649345864205356],
            [11.091284089484642, 0.6605006151245827],
            [11.093692234114721, 0.66115729099511],
            [11.120397609745071, 0.642567687310611],
            [11.187353204294451, 0.596382155452722],
            [11.236458927214755, 0.5625856502588662],
            [11.250565126102892, 0.49231919547801456],
            [11.257381906757185, 0.4634888375772034],
            [11.25422647480649, 0.461682104054779],
            [11.24660857885949, 0.4617180362822246],
            [11.243253138496131, 0.4636875006317575],
            [11.240552018298901, 0.45972741899860103],
            [11.23807578972612, 0.45986715521599725],
            [11.232363351043146, 0.4535686684786362],
            [11.227525347450863, 0.4530175085033735],
            [11.225464793906202, 0.45106636704765246],
            [11.219943992169638, 0.4508662246870661],
            [11.215878779243457, 0.4444384451280441],
            [11.212521951691585, 0.4413405227362138],
            [11.208752496363623, 0.431997991309069],
            [11.209465699331474, 0.4273804051322568],
            [11.205340347049223, 0.42537934821501067],
            [11.201238016037781, 0.4270061891198827],
            [11.199376326238417, 0.42319093555185683],
            [11.195978734281846, 0.4238530707999416],
            [11.192111583768853, 0.42044456392504104],
            [11.186775074063, 0.42098871428884327],
            [11.179813304219264, 0.4173522425566947],
            [11.176998945593697, 0.41431753688520884],
            [11.171221059896538, 0.4112802194219487],
            [11.167805702773334, 0.410778657958749],
            [11.162204903642257, 0.4141189590824078],
            [11.159319334527405, 0.40319602318603176],
            [11.15555202017834, 0.4011597057113993],
            [11.150668172670532, 0.3958109399514218],
            [11.149456487440569, 0.38820431674239403],
            [11.15122627593425, 0.3830941602595723],
            [11.140661709428823, 0.38138556927938594],
            [11.141488713791192, 0.3750588470600321],
            [11.144115104198733, 0.3724729276561692],
            [11.144196860175846, 0.36355540904831474],
            [11.145296029208104, 0.35821035998311646],
            [11.14231780752539, 0.35481883990377777],
            [11.141694406854038, 0.3513744040067692],
            [11.138499262159597, 0.35008936339631],
            [11.133384720249506, 0.34432605412189393],
            [11.129101480382019, 0.3421765379189391],
            [11.128205173527148, 0.33915377291127613],
            [11.12324534294319, 0.3385275068460891],
            [11.121402462675146, 0.335296475294959],
            [11.121603456181491, 0.3307745078837566],
            [11.119702345739404, 0.3289545299896721],
            [11.120270592227271, 0.32476364958645987],
            [11.122576135333832, 0.32288216291338145],
            [11.12057642320621, 0.315809804520771],
            [11.117606818689358, 0.31812221989277195],
            [11.112529613490539, 0.31139999176840133],
            [11.112909558969381, 0.3051459080241839],
            [11.116106093644834, 0.30068253811977036],
            [11.113109788380893, 0.2992024065668511],
            [11.111261496648122, 0.29383017698977576],
            [11.108532468068082, 0.29575150457694693],
            [11.103311322297664, 0.29153588388278256],
            [11.100924959781784, 0.29420526670632213],
            [11.09765804211572, 0.29323751772012685],
            [11.093016229580135, 0.2969823869052223],
            [11.091053005506879, 0.29542781462149226],
            [11.083312488235993, 0.30066291603090856],
            [11.08147451301337, 0.30648678624211634],
            [11.077041878348178, 0.30888833659115406],
            [11.071508200448369, 0.3155843026903098],
            [11.072483879439185, 0.3229040610174656],
            [11.068242397803935, 0.32728459955907657],
            [11.069816305060865, 0.3319462980503414],
            [11.06875172142347, 0.3343846295746409],
            [11.071123742792528, 0.34262831317890313],
            [11.070782034233192, 0.345817368056297],
            [11.07373216339967, 0.3480851442889943],
            [11.070310218080008, 0.355256643689369],
            [11.071891406264328, 0.3592971343616515],
            [11.076145778863657, 0.3607931867501191],
            [11.076773325675795, 0.3640484778183854],
            [11.080742946840143, 0.365810637069644],
            [11.087154865205257, 0.36394025914046063],
            [11.091664415627193, 0.3671733417477199],
            [11.088626070391296, 0.3741580826550144],
            [11.084542974830544, 0.376687011747194],
            [11.080394021465972, 0.37588827174986356],
            [11.081957512952187, 0.3812632593157334],
            [11.07362042347777, 0.38304307960920597],
            [11.070435953447856, 0.385965348007579],
            [11.071597606238504, 0.3883134726903191],
            [11.061806574256808, 0.38859368738838346],
            [11.056807682077181, 0.3849782239295512],
            [11.053112819476187, 0.38525386644658866],
            [11.048953681657503, 0.38090466352687363],
            [11.049897225404013, 0.3723420755807686],
            [11.048001938152293, 0.36844443487231293],
            [11.039405493434236, 0.3609619950050181],
            [11.031801804640331, 0.3649208955419543],
            [10.965011083564182, 0.4066805190885227],
            [10.93829341505973, 0.42314286277876934],
            [10.89835481480061, 0.44838085052062976]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.24173947676228, "lat": 38.42025235981044 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54011"],
        "coty_name": ["Cabell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cabell County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01550012"
      },
      "bbox": [
        10.89835481480061, 0.29153588388278256, 11.257381906757185,
        0.6649345864205356
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.831547910473924, 0.136485650473798],
            [11.832584948476072, 0.16837834570041763],
            [11.837188239592386, 0.2881354121064414],
            [11.838658413954125, 0.3356298399989419],
            [11.841377789341122, 0.34785749835044233],
            [11.839229658147298, 0.3500678948353211],
            [11.838468087191723, 0.3556457472012958],
            [11.843981476789853, 0.3575349840110225],
            [11.849547170543334, 0.35541543931028907],
            [11.900619568241787, 0.44813056451107314],
            [11.905209586951376, 0.4488333537482393],
            [11.909592873526654, 0.4475364603921347],
            [11.911034563538847, 0.44027854708997466],
            [11.915792411590118, 0.4414508161578176],
            [11.919091740965104, 0.43832751056537067],
            [11.923927845838751, 0.4368304697886844],
            [11.933063600145923, 0.43876055465862884],
            [11.934497204910544, 0.4350166710822017],
            [11.934415323620424, 0.42975907862892215],
            [11.939968739775036, 0.4266655061701177],
            [11.93423191683485, 0.4227407120531489],
            [11.934515437026478, 0.4193211243036202],
            [11.946111815816852, 0.42452770270671225],
            [11.953031589937058, 0.42381787897317147],
            [11.962547265221286, 0.41957153391317026],
            [11.967212104982512, 0.420654656119554],
            [11.972200533858071, 0.4310128068763601],
            [11.980505583742552, 0.43176799081608963],
            [11.985839162762304, 0.4281440043930847],
            [11.98987870179077, 0.4227325684563022],
            [11.996826814336513, 0.41866269743773143],
            [12.00172290930222, 0.41231965326908393],
            [12.00741849937245, 0.4110419619827134],
            [12.014737235364077, 0.4061374572929309],
            [12.023099753808843, 0.40668320703474764],
            [12.024428914000449, 0.4021722896303178],
            [12.027232582925105, 0.40062239053429627],
            [12.034406394981639, 0.40020212886490336],
            [12.036877896501384, 0.4019451810711095],
            [12.037284438546953, 0.4067994565518839],
            [12.033267352161387, 0.40949815122313604],
            [12.03254927908463, 0.41332057492091695],
            [12.036649715095914, 0.41670293620320337],
            [12.042567885374565, 0.41636898601725686],
            [12.047524448832966, 0.4199235522104993],
            [12.04545713184818, 0.4234614305693407],
            [12.040453499484068, 0.4249910411601704],
            [12.04073783833741, 0.4286185855399054],
            [12.048567104392596, 0.4302752131327142],
            [12.054628101150023, 0.4366148973465647],
            [12.05470192274616, 0.44304643684844164],
            [12.052478674680444, 0.44589884380308975],
            [12.05591345167169, 0.4485063317660439],
            [12.061599499035658, 0.4454872450151136],
            [12.062920161726009, 0.4403864511035132],
            [12.060098141416146, 0.43442932984500077],
            [12.058926185112497, 0.428465451325796],
            [12.061830432949186, 0.4268398119249316],
            [12.066604116383969, 0.4269160826980782],
            [12.071678200583634, 0.42302110361870393],
            [12.073067607788014, 0.41589552692801723],
            [12.077670697600428, 0.41500869304157323],
            [12.081947137512044, 0.4175834241066717],
            [12.078021198071756, 0.42341293744373976],
            [12.077498018970648, 0.4273071731969261],
            [12.079321239619098, 0.43324939656837225],
            [12.089170326218028, 0.43624202776874715],
            [12.097723792807752, 0.43738134320976113],
            [12.110180523713916, 0.4316273653763022],
            [12.113372352707781, 0.42544793396125463],
            [12.114077002090447, 0.42018578459495914],
            [12.116489895478344, 0.41799793617952075],
            [12.120805256439267, 0.42067439137358187],
            [12.129539740748044, 0.4163342690287644],
            [12.132586389533193, 0.41345453156216616],
            [12.130795623915077, 0.40919163453518215],
            [12.131926436483946, 0.40290128494033],
            [12.134438054363937, 0.3988684881807583],
            [12.130086085530982, 0.39661093006065545],
            [12.134318208071395, 0.39222087895227914],
            [12.13230158245438, 0.38714069347306973],
            [12.137704998056137, 0.3832547767175143],
            [12.13799400390084, 0.3804437969803874],
            [12.14320163931399, 0.37406238690720806],
            [12.15231957552961, 0.37274054891184116],
            [12.15968058494995, 0.36435844765239345],
            [12.168184745623611, 0.36737948651944485],
            [12.168119324911732, 0.35696544577509387],
            [12.172787133249296, 0.35335943488676097],
            [12.176919405522668, 0.34774622444605396],
            [12.181507122157678, 0.3551554537094768],
            [12.182042542060135, 0.3593351215580718],
            [12.186490454998742, 0.3635837704750822],
            [12.190118413266628, 0.35868088733413395],
            [12.187861147913168, 0.353025298026007],
            [12.18739157572783, 0.34846543426146354],
            [12.1896198059417, 0.3440324067761945],
            [12.195722760312227, 0.3414339478546663],
            [12.197843136441932, 0.3367475035398998],
            [12.194580219377823, 0.3310889102802144],
            [12.195447033972593, 0.3233090606648804],
            [12.19433615746222, 0.3207868130156614],
            [12.196922424658524, 0.31707397202269666],
            [12.195886469415028, 0.30983162367328765],
            [12.189393409840541, 0.30587275877249465],
            [12.194059755573925, 0.3038155791134145],
            [12.201205722529501, 0.29829770048501],
            [12.203900067513128, 0.29361125137835625],
            [12.214132815518802, 0.2880609233996349],
            [12.218440416074452, 0.2870846806019639],
            [12.228237480832775, 0.28794325267895393],
            [12.23502225217881, 0.2857400069955485],
            [12.239148009969123, 0.2875033459678955],
            [12.238715084768028, 0.2907823403021966],
            [12.242658633486887, 0.29737395690912494],
            [12.249027331285347, 0.3004503637507948],
            [12.255291073121882, 0.29909486226463255],
            [12.260348962517984, 0.30204596639780135],
            [12.264334485177798, 0.29941353379656455],
            [12.260102480949751, 0.29487590629753885],
            [12.254542082936593, 0.29156468738512475],
            [12.254615675765686, 0.28806922841157817],
            [12.257274495417848, 0.2834908973109528],
            [12.249740881632544, 0.27845174764523106],
            [12.244668542776218, 0.27770251542796215],
            [12.245474084015498, 0.2727968723177897],
            [12.247773071154311, 0.2696607777461507],
            [12.24759605633681, 0.2662017408243631],
            [12.251868949814492, 0.26248651904930276],
            [12.258004781895002, 0.26486089488385733],
            [12.269776206507448, 0.2648888729331791],
            [12.272410433064389, 0.2635084449210007],
            [12.27419637488379, 0.25598489021599113],
            [12.281736883017016, 0.24999866428067855],
            [12.284215997349449, 0.24606899161035883],
            [12.282443389967797, 0.23512840520599496],
            [12.28423976168837, 0.2318842820929925],
            [12.288441255801201, 0.22907044261271745],
            [12.298418876878713, 0.22816281135038546],
            [12.299604424707688, 0.2264579152432944],
            [12.274249786302423, 0.18606732077483876],
            [12.335604223537347, 0.11000979631827779],
            [12.290705657522146, 0.10662220885344618],
            [12.226377729107657, 0.0632576304653368],
            [12.191454114309199, 0.03981501077938717],
            [12.187542922193147, 0.04148817715075433],
            [12.179281361191466, 0.04766505693238742],
            [12.17450999602924, 0.04957681803059791],
            [12.16386286844129, 0.04969722165105663],
            [12.153737041835015, 0.045925445783748645],
            [12.14629070099378, 0.04507037360129258],
            [12.134763006231326, 0.04148836452645422],
            [12.125853619049854, 0.03998670900020986],
            [12.116120752303706, 0.04275513555689498],
            [12.104388919522492, 0.04107296673037119],
            [12.100694015938595, 0.04471497726842561],
            [12.100059396865412, 0.049552737372348735],
            [12.106175820158994, 0.058553875247415454],
            [12.104492050201536, 0.06532126200698864],
            [12.102427668462783, 0.06574944964344338],
            [12.095709765989385, 0.06129609927471048],
            [12.08505225974638, 0.05804054087788444],
            [12.076489567892084, 0.052909669550472195],
            [12.073894508529925, 0.05235911133231318],
            [12.066002301136846, 0.05628239355466312],
            [12.064927214183136, 0.060870539918076366],
            [12.079349191228252, 0.06445406006118734],
            [12.086180002468359, 0.0654812708757965],
            [12.087061959927704, 0.07189242268682029],
            [12.083499052710415, 0.08065664603529092],
            [12.04764926347778, 0.0783285614149348],
            [11.991017185963017, 0.0729968052481372],
            [11.932017371376977, 0.06836408438189931],
            [11.910024846502889, 0.06719664604919245],
            [11.905318970747247, 0.07070017413711448],
            [11.906558206981133, 0.07867410104672469],
            [11.908284951904259, 0.08301722301983624],
            [11.903037302440268, 0.09172011886226629],
            [11.89843324182835, 0.11062212993318746],
            [11.90204916004238, 0.11646983778691887],
            [11.90070683651329, 0.1213011583536315],
            [11.890353185422583, 0.1256169486931894],
            [11.883844659819012, 0.1270916572688036],
            [11.879366035142564, 0.12675304522196884],
            [11.87492103607858, 0.13067239265854882],
            [11.872869642908652, 0.13440020944418035],
            [11.872299211261236, 0.14033088991276088],
            [11.868084483002528, 0.14037421288157997],
            [11.864897607204522, 0.1427247390254026],
            [11.86143895376612, 0.14149409057290557],
            [11.853803621074828, 0.14757350617817813],
            [11.85110282823009, 0.144135153778158],
            [11.845414139778939, 0.14089422874811558],
            [11.842141507547495, 0.14200702022943565],
            [11.83978995191861, 0.1391139076067942],
            [11.835983036279314, 0.1389811476733525],
            [11.831547910473924, 0.136485650473798]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.08117509786284, "lat": 38.02877465255297 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54019"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01560095"
      },
      "bbox": [
        11.831547910473924, 0.03981501077938717, 12.335604223537347,
        0.4488333537482393
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.934558758643403, 1.216047208207741],
            [11.936989646306403, 1.217393892887558],
            [11.942761496338994, 1.2159189315069798],
            [11.946834530980988, 1.2192245545713467],
            [11.954752292075606, 1.2184391033619317],
            [11.956208284181052, 1.2215325814562488],
            [11.961125932115657, 1.2220001338948336],
            [11.962999711642288, 1.227513213960723],
            [11.966124214993258, 1.2325192147054413],
            [11.97229081392406, 1.2340594174113593],
            [11.971078846221369, 1.238769554950526],
            [11.975745400448163, 1.2420081627670234],
            [11.979848962353875, 1.2416329671612878],
            [11.984045349805863, 1.246497086454641],
            [11.982112267607095, 1.2499012761649437],
            [11.985843778815783, 1.253275741473893],
            [11.988512131936167, 1.2526895424553004],
            [11.996163387605092, 1.2570786531747609],
            [11.998398847414933, 1.2600013687756866],
            [12.0045113038117, 1.2631818228260665],
            [12.00880655114701, 1.2623943733321839],
            [12.010702791854692, 1.2644537313682667],
            [12.016278896142909, 1.2636906090279874],
            [12.019228096086481, 1.2680715207781366],
            [12.021440744353857, 1.26736456180241],
            [12.026724758094792, 1.2754705529743646],
            [12.030230765202175, 1.2783823009949458],
            [12.029191813247767, 1.2830613460365263],
            [12.03118134970536, 1.286844528729823],
            [12.038482871549029, 1.2880557739232155],
            [12.040900979195808, 1.2929599548414497],
            [12.043833316382976, 1.2938719449187734],
            [12.042363978980914, 1.2979655842108253],
            [12.050825995677092, 1.3001158160746],
            [12.054408978380529, 1.2982365612068685],
            [12.057186193114791, 1.3014305599279508],
            [12.057064537243557, 1.3043971812426263],
            [12.06149323311556, 1.3080018755875864],
            [12.058724771528254, 1.3118629971207407],
            [12.067386814114753, 1.3141978716243186],
            [12.069236572202533, 1.3121582827997866],
            [12.073817642368669, 1.3127111343667965],
            [12.076272806625473, 1.3166445173598067],
            [12.075179637852836, 1.3194344244930059],
            [12.077706761236055, 1.3234213895414089],
            [12.080876784300687, 1.3248559188697213],
            [12.084641238609573, 1.3238815548956728],
            [12.08425619225742, 1.3285612503812956],
            [12.089476205370005, 1.3327085412728914],
            [12.086216685828623, 1.3423364270216973],
            [12.136131692581081, 1.3406236561319564],
            [12.152653479167865, 1.3390412201339297],
            [12.154198212129621, 1.3268658956798225],
            [12.175592290897315, 1.2534362939616823],
            [12.191315058067861, 1.2393095527042508],
            [12.276798959645811, 1.1633828527286105],
            [12.273539894311781, 1.1615913700616185],
            [12.266330331689986, 1.1600501527531086],
            [12.265114568674727, 1.154629135483488],
            [12.25854644779192, 1.153676257976137],
            [12.257319536616167, 1.1482853599374747],
            [12.252899592564079, 1.144808286115126],
            [12.253153461071706, 1.1397304920168925],
            [12.248297243395186, 1.1404017570739708],
            [12.24353551720525, 1.1430494019910573],
            [12.238850205313971, 1.14077993958311],
            [12.239424026568114, 1.1355681874236243],
            [12.23604995195963, 1.1335175695818687],
            [12.233255670318977, 1.1344835134046376],
            [12.229878661028344, 1.1440799232050807],
            [12.218883255808505, 1.1338238435471024],
            [12.214587271704984, 1.1288068927843375],
            [12.20804668758809, 1.1264919751549598],
            [12.148993312862254, 1.0642822283899784],
            [12.108395874421328, 1.0216332037825218],
            [12.052639976484373, 0.9661213246444157],
            [12.017894220382312, 0.9311371130184767],
            [12.014644355927766, 0.9346955240098265],
            [12.013350918491788, 0.9401337754662239],
            [12.010650325203818, 0.941047091560419],
            [12.010456889096778, 0.945091226023646],
            [12.005630184912334, 0.949680779042836],
            [12.003704318885742, 0.9589971377781376],
            [12.00167250849175, 0.9618756068512841],
            [11.997381746253755, 0.9615282567862831],
            [11.99618821393511, 0.965176032372156],
            [11.99300383755425, 0.9653575797717514],
            [11.989069955763977, 0.9683447943306769],
            [11.984319298884888, 0.9648429631171491],
            [11.984459367200333, 0.970057217235065],
            [11.970448952299808, 0.9695147810296816],
            [11.970392001166031, 0.972813632722469],
            [11.962902331210948, 0.9763825689059272],
            [11.964488404489337, 0.9816501196813469],
            [11.959503956093235, 0.9809453309165488],
            [11.956974547022234, 0.9849355405654704],
            [11.955010573678283, 0.9957066039486147],
            [11.951203756409043, 0.9976421676776247],
            [11.958337948048904, 1.0019421348045874],
            [11.963197836000138, 1.0066373627971559],
            [11.963523956080524, 1.011228672303444],
            [11.967711774797714, 1.0113322533711542],
            [11.968757151198, 1.0197412709880744],
            [11.971079852315885, 1.02469576812855],
            [11.973834261468616, 1.0248225863543219],
            [11.976959183026652, 1.029234238471373],
            [11.980673408413491, 1.0317801664006947],
            [11.979847469000719, 1.0379017884674258],
            [11.978079666335036, 1.040814151016221],
            [11.980802460836076, 1.0465973658476688],
            [11.977712640950696, 1.0502736459045985],
            [11.979990233241418, 1.054629599757992],
            [11.983960994924733, 1.0567168295453786],
            [11.977522267447021, 1.0854012135142022],
            [11.97161797683095, 1.110269467318062],
            [11.96770496604648, 1.1201010398400848],
            [11.968885501923632, 1.1243743821381864],
            [11.964971015850377, 1.1257952921045158],
            [11.96350996982456, 1.1320435280082137],
            [11.964908206771979, 1.134971476682814],
            [11.969020097771308, 1.137500018738549],
            [11.967480310887616, 1.140759105303437],
            [11.970385329792387, 1.1428341687107066],
            [11.968790950977896, 1.149646774847474],
            [11.966906625896188, 1.1495616978231489],
            [11.96513552788229, 1.1553444713644538],
            [11.966582294718913, 1.1581831258267838],
            [11.962427745022591, 1.1622263192392344],
            [11.959968294925808, 1.1667987780167663],
            [11.965182886571482, 1.171245445205943],
            [11.957661391205928, 1.1790962486220928],
            [11.956566780492382, 1.1825027376249015],
            [11.952239804116154, 1.184919134501523],
            [11.946813385545605, 1.1899779892034335],
            [11.940148567813505, 1.190947343983051],
            [11.935202506929658, 1.1991748755415077],
            [11.934776525948834, 1.2029226555703239],
            [11.937646262526862, 1.20537125341388],
            [11.936978354981944, 1.2086636096860552],
            [11.931670228705322, 1.2131357791880033],
            [11.934558758643403, 1.216047208207741]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.85705184674526, "lat": 38.92411005963424 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54021"],
        "coty_name": ["Gilmer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gilmer County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01689673"
      },
      "bbox": [
        11.931670228705322, 0.9311371130184767, 12.276798959645811,
        1.3423364270216973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.131714848239156, 1.0408502242894222],
            [11.133847752573619, 1.0475507383080793],
            [11.134200502504429, 1.0541352696554156],
            [11.136587907393741, 1.059587032379312],
            [11.143226003145466, 1.0657698310897623],
            [11.150663176270488, 1.0707447815006172],
            [11.162437229104391, 1.0821779278285277],
            [11.165541646686513, 1.092229002738743],
            [11.166362777048207, 1.105616179440191],
            [11.168598695503452, 1.1131787832503965],
            [11.172755821754876, 1.1169960908302665],
            [11.179342920815879, 1.1203949313970931],
            [11.188300536843467, 1.1221711735392599],
            [11.195016024656972, 1.1211871828759077],
            [11.201372447024067, 1.116619523151027],
            [11.20894278259023, 1.1070278399122238],
            [11.212419182542865, 1.100910630015307],
            [11.215186723404521, 1.091339761769726],
            [11.219119607447325, 1.0888440278978586],
            [11.22645379784132, 1.0902158812907683],
            [11.232595014492663, 1.0934480851408446],
            [11.238423974822334, 1.0951371756138844],
            [11.246154000404578, 1.0934949546952237],
            [11.253573727712014, 1.0888484252657915],
            [11.26013026255591, 1.0794655229104972],
            [11.26811326182212, 1.06951802621277],
            [11.274335503600856, 1.057941439233328],
            [11.280141038307548, 1.0495394372160636],
            [11.285848727867982, 1.042643909976062],
            [11.288671993011762, 1.0348306412957762],
            [11.288168452324651, 1.0304704015461994],
            [11.28296987217222, 1.0215260344091526],
            [11.28050418782038, 1.0192807726492894],
            [11.271396683463601, 1.0033736697125986],
            [11.27099992082621, 0.9972515629319421],
            [11.272617259870877, 0.993645743228125],
            [11.282149586720736, 0.9875840865884674],
            [11.288546521088595, 0.9826086842828002],
            [11.287422490564119, 0.9798992017842337],
            [11.295223191020385, 0.9681559321877263],
            [11.32488732093862, 0.9351072782418022],
            [11.362740925787424, 0.8925271175673467],
            [11.399906092380595, 0.8509194047467971],
            [11.38567398426702, 0.8300496296346549],
            [11.421848808453317, 0.800866071400326],
            [11.349448866608373, 0.777082438448512],
            [11.345395880536014, 0.7759794201948785],
            [11.28546337547228, 0.756453286369458],
            [11.23970000962033, 0.7190196238324125],
            [11.209537177238394, 0.6948045630577768],
            [11.226076797707574, 0.6139589980406823],
            [11.236458927214755, 0.5625856502588662],
            [11.187353204294451, 0.596382155452722],
            [11.120397609745071, 0.642567687310611],
            [11.093692234114721, 0.66115729099511],
            [11.104253680579514, 0.6627369068467494],
            [11.112743193661053, 0.665383386370803],
            [11.11634022056197, 0.667836260312958],
            [11.123859794342655, 0.6779170992290859],
            [11.12557340176144, 0.693985266622364],
            [11.124592576524469, 0.7006786448187136],
            [11.11853546593557, 0.7169339070819852],
            [11.115882629304723, 0.7227700854744349],
            [11.109343388600983, 0.7327313206577625],
            [11.107907846252468, 0.7398682365088496],
            [11.102247109592373, 0.7529174634676792],
            [11.101759336072858, 0.7599879024891367],
            [11.103934493504791, 0.7723469943420435],
            [11.104518588098776, 0.782228383985843],
            [11.099379272989925, 0.795455552599195],
            [11.09590980011746, 0.8021303402723688],
            [11.091523670633235, 0.8133872596078486],
            [11.088091268379449, 0.824373512607951],
            [11.08481566979815, 0.8292860629990663],
            [11.07759645526573, 0.8345752887762592],
            [11.069714939021402, 0.8379205328562442],
            [11.0659985720381, 0.8428763933580358],
            [11.06318355373025, 0.8561865553059858],
            [11.065226720224013, 0.8651503097495437],
            [11.070300145624268, 0.873025375081133],
            [11.077065830044333, 0.8801525129451641],
            [11.082314552645961, 0.8875003040351971],
            [11.090915863673683, 0.8910437908967367],
            [11.103525721739372, 0.9002952059193933],
            [11.112328673800183, 0.9141862457987814],
            [11.113952482821626, 0.9179959660006423],
            [11.114832614685932, 0.9292617433606367],
            [11.114658654410322, 0.9431400231965652],
            [11.11064407497932, 0.9548563104096892],
            [11.107340753847298, 0.9609007054015976],
            [11.106800978433384, 0.9757187805865689],
            [11.115959794063382, 0.9892065220895316],
            [11.12035257253054, 1.0011785105532507],
            [11.12575175376922, 1.013707169844561],
            [11.12521475273171, 1.0215871631934879],
            [11.125822749572528, 1.0269826417634307],
            [11.131714848239156, 1.0408502242894222]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.02658077549717,
          "lat": 38.769716489302915
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54053"],
        "coty_name": ["Mason"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mason County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01560254"
      },
      "bbox": [
        11.06318355373025, 0.5625856502588662, 11.421848808453317,
        1.1221711735392599
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.476031230865749, 1.4005512198927546],
            [12.515534976239158, 1.4040266959215395],
            [12.519829966687162, 1.41736891099666],
            [12.52847339153852, 1.4200926365850635],
            [12.529909917349238, 1.418694763745033],
            [12.539285910021396, 1.4140554429917194],
            [12.545905785591563, 1.4055787928871655],
            [12.553159463053401, 1.408024267014677],
            [12.579106575717939, 1.4011487495885722],
            [12.593957779561643, 1.3873091343139445],
            [12.602096950990996, 1.3735469819649533],
            [12.617643514572963, 1.3566705479908752],
            [12.663785532508827, 1.364713379019095],
            [12.668601758982874, 1.3616372086158781],
            [12.671701484201183, 1.3649658371072273],
            [12.674107861740092, 1.3629439471820592],
            [12.675124690847346, 1.3545188320356054],
            [12.67256031865891, 1.3498096173717702],
            [12.678346127971702, 1.3438881453415379],
            [12.683390447182898, 1.3431986680423105],
            [12.685630315290231, 1.3403686451789754],
            [12.678551040368024, 1.333744761519102],
            [12.678897959682763, 1.33085817373228],
            [12.682339900428104, 1.3294713027859824],
            [12.685907354214999, 1.3252075434291894],
            [12.682935517607984, 1.3230211298938972],
            [12.683747470067573, 1.318634620976941],
            [12.682980154506671, 1.3127756936282404],
            [12.685376460634814, 1.3040013191997317],
            [12.678990705312982, 1.3029038747190476],
            [12.677652325981173, 1.2960393267360617],
            [12.671383868552173, 1.2911849021365713],
            [12.674637146642644, 1.2891297053831499],
            [12.679160846990598, 1.2891774028794354],
            [12.679703093530835, 1.2856747198743959],
            [12.674214908876785, 1.2803901571215508],
            [12.673912183977606, 1.277987392349792],
            [12.66772637602254, 1.276701962532999],
            [12.665469833842735, 1.2720433997941936],
            [12.668163653721844, 1.2710859136860602],
            [12.665977677837656, 1.2663041451635193],
            [12.662710882904344, 1.2642769859796965],
            [12.665773224363006, 1.2597493907103523],
            [12.659426231760646, 1.2510289762042563],
            [12.665961151556566, 1.2493092678850695],
            [12.667599304290155, 1.245692723861193],
            [12.665655878535278, 1.2343898159140543],
            [12.660451264696546, 1.2320950847259196],
            [12.659145056736048, 1.229888524746539],
            [12.659753492554454, 1.2226848202243565],
            [12.655436651885795, 1.21960784210779],
            [12.673287856241311, 1.1641418761947544],
            [12.668102072479423, 1.0663006098533434],
            [12.584334050950787, 1.0501148197343997],
            [12.559297360537155, 0.9958754122024958],
            [12.55605977072208, 0.9949994197346185],
            [12.553737026746697, 0.9911390335031126],
            [12.545427594237587, 0.985758622916504],
            [12.541928464044817, 0.9824948798464892],
            [12.531935360623601, 0.9804947597586348],
            [12.528860793476358, 0.9828251751801836],
            [12.529490033818139, 0.9883789504217217],
            [12.524788468929367, 0.9926994839485185],
            [12.51940773613919, 0.9955204479452343],
            [12.516032849363405, 1.0031139962784574],
            [12.51566582586125, 1.0075285024469907],
            [12.517130069304315, 1.011463646074008],
            [12.514154089832045, 1.0142938281105178],
            [12.505666600827775, 1.0130106671613501],
            [12.502803037525, 1.0178023489346832],
            [12.497695358294306, 1.0221547562592068],
            [12.48854629336638, 1.0209252544013034],
            [12.485489395616206, 1.0228801915902288],
            [12.483078187338394, 1.0196996191183707],
            [12.47179980418143, 1.0176769745903964],
            [12.467735113139035, 1.0141206764207842],
            [12.448454900354648, 1.0526342431225348],
            [12.448052703665317, 1.1615266332796905],
            [12.450897322921108, 1.1687997640318788],
            [12.448473507990407, 1.1717757358711196],
            [12.45140457546416, 1.1751503205749874],
            [12.460714050043306, 1.17570603624061],
            [12.459409183295113, 1.1836133316476847],
            [12.462731537292767, 1.1875947666289213],
            [12.463286731233895, 1.1932423404521426],
            [12.46154506961576, 1.196475350691605],
            [12.466433666013765, 1.1987595251905094],
            [12.465935446829404, 1.2024823961672262],
            [12.470760535930504, 1.2068940632624636],
            [12.468754903703577, 1.2115586196649788],
            [12.46952085571019, 1.2146575133265574],
            [12.474478994871431, 1.2230620952533595],
            [12.474677411360451, 1.2294293104375755],
            [12.47074678107245, 1.2309043884775281],
            [12.471935797894005, 1.235076480825234],
            [12.476108267177825, 1.2404456398764616],
            [12.478866135330794, 1.2485258909564865],
            [12.48362404960542, 1.249413736277143],
            [12.486917290853157, 1.253929293357736],
            [12.48522412066888, 1.2558168712650746],
            [12.48336650027586, 1.2643040560637964],
            [12.478179515315672, 1.268297433755899],
            [12.467815266236657, 1.2894181624621073],
            [12.477550264386357, 1.3082851163989961],
            [12.479165190559067, 1.356840247403024],
            [12.479391002221334, 1.357735364583337],
            [12.476031230865749, 1.4005512198927546]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.2334289108241, "lat": 38.89780921206721 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54097"],
        "coty_name": ["Upshur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Upshur County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01696800"
      },
      "bbox": [
        12.448052703665317, 0.9804947597586348, 12.685907354214999,
        1.4200926365850635
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.644233442745834, 6.83791539142072],
            [4.640881932918876, 6.888071505569977],
            [4.632584211505431, 7.009495499771037],
            [4.656988411320683, 7.010957343443955],
            [4.71889490803329, 7.014955074632526],
            [4.7905024987693965, 7.019925173454747],
            [4.86253585447413, 7.024646155947833],
            [4.891906582634978, 7.026769257807957],
            [4.9639924537906115, 7.031726688582977],
            [5.062441431177329, 7.037924363619819],
            [5.062766606647495, 7.0315338436221815],
            [5.066033198383617, 6.995107535961109],
            [5.067303955008408, 6.988072279506148],
            [5.070157398069814, 6.961648225156353],
            [5.070936383394703, 6.9507706998030745],
            [5.077324010243829, 6.864700102160119],
            [5.083040460405244, 6.778389106909615],
            [5.087633001658599, 6.705885834359035],
            [5.08864335458932, 6.6920098447887915],
            [5.091743506655381, 6.6410582928982524],
            [5.094203556861098, 6.605715141270556],
            [5.047728294274611, 6.602884708119992],
            [4.978559579024763, 6.598462364439033],
            [4.948500545497031, 6.596637692507038],
            [4.833385592079361, 6.58909748373583],
            [4.799782972134832, 6.587089545190609],
            [4.715356314693595, 6.581774014328083],
            [4.659641749931652, 6.578329536410362],
            [4.652910591067642, 6.665474965626003],
            [4.650959825980177, 6.689695628823465],
            [4.644124000681057, 6.796548621377893],
            [4.643967161131031, 6.807956267455877],
            [4.6449542616242745, 6.824219673608708],
            [4.644233442745834, 6.83791539142072]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.73459639599339, "lat": 45.33743159144155 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55069"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01581094"
      },
      "bbox": [
        4.632584211505431, 6.578329536410362, 5.094203556861098,
        7.037924363619819
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.827673151381704, 6.154843402683045],
            [4.911386083896572, 6.160183123355495],
            [4.971764082157131, 6.164566563359628],
            [4.995305472855631, 6.1663965070092415],
            [5.078941079585637, 6.17241349503785],
            [5.109755319478577, 6.173195021227821],
            [5.173998141390052, 6.1750869121862575],
            [5.181187829118109, 6.1750035267224215],
            [5.267636288615279, 6.1810711041326405],
            [5.2730597249950275, 6.106300873714683],
            [5.27750161224866, 6.0495855290705824],
            [5.282058757515902, 5.983639135889221],
            [5.287393912704952, 5.905441436932022],
            [5.296195185328999, 5.776403441978896],
            [5.298156671684351, 5.745383251442096],
            [5.282334871959934, 5.7445601844803535],
            [5.195186238959236, 5.738675008351082],
            [5.181306234146985, 5.737640344591567],
            [5.114728652385834, 5.7331977505838525],
            [5.084748871404525, 5.731616737203076],
            [5.03214150200159, 5.729338653750868],
            [4.941686429005908, 5.725280879397493],
            [4.940884849585667, 5.739711914690214],
            [4.934404150360505, 5.835974305698125],
            [4.931671572536785, 5.872046253741639],
            [4.929153946515579, 5.900806200860548],
            [4.924823041917391, 5.95847808657649],
            [4.9228469528973475, 5.987492162325527],
            [4.839196672827354, 5.982355533478148],
            [4.836057678551823, 6.028818677982966],
            [4.833492063739649, 6.062885847553436],
            [4.830503006966812, 6.107748056207897],
            [4.827673151381704, 6.154843402683045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.50142262838345,
          "lat": 44.476020333357255
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55097"],
        "coty_name": ["Portage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Portage County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01581109"
      },
      "bbox": [
        4.827673151381704, 5.725280879397493, 5.298156671684351,
        6.1810711041326405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.858465341958809, 4.22518762344488],
            [-5.836540662426793, 4.22298171577014],
            [-5.82662883728418, 4.221609279580634],
            [-5.702093339877525, 4.211325026280913],
            [-5.694523330765151, 4.21099572412777],
            [-5.65428312439193, 4.208112279568894],
            [-5.643013696038163, 4.207690409439579],
            [-5.5425667126028415, 4.199572858702659],
            [-5.419328303652183, 4.188766653974675],
            [-5.41902148141272, 4.188881028717365],
            [-5.4287862402935705, 4.077087981855903],
            [-5.4489103266844205, 3.837878975578938],
            [-5.450096484101656, 3.8269373607506783],
            [-5.456619254704621, 3.7471481370494306],
            [-5.459609381875169, 3.7141000288596167],
            [-5.460362479125146, 3.7017688517833744],
            [-5.4636804520335485, 3.6658582047996404],
            [-5.469363069870845, 3.5984413622168447],
            [-5.470941054522105, 3.578368502623251],
            [-5.481088001073683, 3.4619246288133323],
            [-5.4874898895009645, 3.3855816777637986],
            [-5.496940738084436, 3.2738847251393453],
            [-5.503433757689663, 3.1988247982468336],
            [-5.5081139673190815, 3.1399934151641316],
            [-5.602478105884692, 3.1480531394587032],
            [-5.603435129594887, 3.148034602077291],
            [-5.6787665605765, 3.1548538355506697],
            [-5.8131371405722945, 3.1666732895329344],
            [-5.837395768914943, 3.1685899571043716],
            [-5.856942162362253, 3.1708554828670312],
            [-5.90745604426083, 3.1754144732407634],
            [-5.952159970967806, 3.1798064867049676],
            [-5.946074947329453, 3.250288443571232],
            [-5.944354342346074, 3.2679880408227335],
            [-5.940404884495302, 3.3109151338690275],
            [-5.929678284827144, 3.4283561992574922],
            [-5.925951305681419, 3.4722782032344295],
            [-5.918534893924048, 3.554124798693581],
            [-5.916847285435211, 3.571000276565709],
            [-5.912892423056756, 3.615454708547947],
            [-5.911037229010166, 3.6320408848760013],
            [-5.901737229967298, 3.738747148924973],
            [-5.901398126136852, 3.7405536379835653],
            [-5.8960712478258195, 3.8049161686861916],
            [-5.8939627926377245, 3.832508264982274],
            [-5.890843051205292, 3.8605932945154886],
            [-5.890018254329858, 3.871291749154202],
            [-5.879669331509257, 3.9905303997392014],
            [-5.87383453363876, 4.050704747181885],
            [-5.873902571374793, 4.051674752744096],
            [-5.86610672002948, 4.138033623105488],
            [-5.858465341958809, 4.22518762344488]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.35332129394385,
          "lat": 42.08788642220162
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56015"],
        "coty_name": ["Goshen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Goshen County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01605073"
      },
      "bbox": [
        -5.952159970967806, 3.1399934151641316, -5.41902148141272,
        4.22518762344488
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.1682490824565, "lat": 18.34980592756154 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72021"],
        "coty_name": ["Bayamón"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Bayamón Municipio"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01804490"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.38893734516803,
          "lat": 17.995173586656357
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72133"],
        "coty_name": ["Santa Isabel"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Santa Isabel Municipio"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01804547"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.987606793348872, -3.016532323427761],
            [14.991137541766143, -3.013951830739296],
            [14.992400428290273, -3.00746646221076],
            [14.995976804139826, -3.004782679976492],
            [15.001709330702045, -3.0061965613259947],
            [15.004420439081313, -3.004682778566931],
            [15.0030464746585, -3.0004353819833773],
            [15.00629369131173, -2.998127015407538],
            [15.010222453882186, -3.002346059302542],
            [15.019024526953855, -2.999301268329978],
            [15.026676964816271, -3.0058303177631913],
            [15.033067088496407, -3.0074233395656402],
            [15.03593183171643, -3.0093804711143393],
            [15.042175225617893, -3.0072094063251966],
            [15.044434125127582, -3.0104723000575357],
            [15.051073007602284, -3.0102530996544106],
            [15.053593029420718, -3.007120015638332],
            [15.059839254655705, -3.012049285716989],
            [15.060281174501482, -3.01572268884248],
            [15.058201805300412, -3.0202987484783157],
            [15.060972258593283, -3.022139861468897],
            [15.06916051435483, -3.019582747953492],
            [15.074132802737083, -3.0196252476431487],
            [15.07383742589229, -3.013412230332853],
            [15.07957995562367, -3.0177466108479902],
            [15.080180208311958, -3.0212360918508234],
            [15.084384200439844, -3.020217430015149],
            [15.085174778824442, -3.0248787386155738],
            [15.089242182605645, -3.024543820159015],
            [15.092551280855131, -3.021726021726352],
            [15.095324833002024, -3.023367702118599],
            [15.098931176909012, -3.0212009220031493],
            [15.102321478181214, -3.0230780758253886],
            [15.103625516606337, -3.0273050969122974],
            [15.103209496201297, -3.032795424174508],
            [15.107178863945478, -3.033725538257201],
            [15.113192819976257, -3.02742704521981],
            [15.116245188745772, -3.026777594138829],
            [15.120311385105097, -3.0296725598773566],
            [15.120224726115449, -3.033673602416162],
            [15.116194118271816, -3.0375764520993442],
            [15.11569617182284, -3.0428980640522343],
            [15.117108141662392, -3.047649379319483],
            [15.116631255315554, -3.0577821100273668],
            [15.119511118643594, -3.060612998716488],
            [15.124611520895176, -3.0589200197790984],
            [15.127833557663113, -3.061787665682912],
            [15.128868996104195, -3.0680444043568436],
            [15.134810436748081, -3.0629116848406315],
            [15.140395304519947, -3.0646091613663384],
            [15.140112504718696, -3.068352491622571],
            [15.134111977378, -3.071448382618031],
            [15.133776896200494, -3.0762263110838575],
            [15.141839330040543, -3.075605005305038],
            [15.145113428482956, -3.0774373399361243],
            [15.145125135219187, -3.083583574697918],
            [15.148392210748163, -3.0862379720431368],
            [15.153682294349869, -3.084209891420944],
            [15.15862851259765, -3.0942503094412763],
            [15.164057409635927, -3.0903483933255216],
            [15.16701005734138, -3.0944017968773996],
            [15.164235470286256, -3.09863116064028],
            [15.169263962772837, -3.1000535011402857],
            [15.176425647250255, -3.106048629032911],
            [15.178716264231994, -3.137435872202193],
            [15.182957032561648, -3.1429148698296374],
            [15.18441124438693, -3.1475573587899177],
            [15.184445407046438, -3.155561579855002],
            [15.186356814699908, -3.1663634233094133],
            [15.1905353968715, -3.1746439513472566],
            [15.194321378287558, -3.1855559554570854],
            [15.203527904833328, -3.1984118074442938],
            [15.213537115163202, -3.213323554967456],
            [15.222710796376289, -3.249975216761701],
            [15.230409875566167, -3.2756108051023505],
            [15.234290840564238, -3.2979177331340046],
            [15.236062049357143, -3.3173202124585446],
            [15.236748206299657, -3.3351274504909045],
            [15.236014571020455, -3.338347374432682],
            [15.23698694821429, -3.350379283129319],
            [15.236603916092509, -3.354163712561922],
            [15.233045981626095, -3.364846270996295],
            [15.250129609616232, -3.404616375146921],
            [15.245815625552561, -3.4228339338579366],
            [15.243484701794237, -3.4402960447148354],
            [15.244026309505218, -3.4584769645996727],
            [15.246014789710928, -3.4831570293947265],
            [15.247693169341394, -3.493242275419796],
            [15.245983133362648, -3.4944251250784326],
            [15.23805266026771, -3.490845270163802],
            [15.216713256615765, -3.4869477532140754],
            [15.208101133137932, -3.483443440053506],
            [15.204969220807742, -3.479898937104373],
            [15.203827445038103, -3.475974791778538],
            [15.206530339551385, -3.4732155898810553],
            [15.20792877992003, -3.4660194862387694],
            [15.213505669668988, -3.460035504955522],
            [15.215458969694215, -3.4534934418059238],
            [15.215735629724765, -3.4455591179333505],
            [15.21332810640483, -3.4391072640390092],
            [15.207157090809455, -3.437026157143928],
            [15.200731315915988, -3.436376717867156],
            [15.194082805704987, -3.4394166257467513],
            [15.190741460385329, -3.4435326616962203],
            [15.191482976518374, -3.4500258190136046],
            [15.194646807276118, -3.4531101109310516],
            [15.193821966452703, -3.457049014388663],
            [15.19041337334403, -3.458011769109188],
            [15.183842706915838, -3.457009592975815],
            [15.15846737672638, -3.454646105275407],
            [15.146745031608006, -3.4526657667078116],
            [15.10558385464601, -3.4516133310041734],
            [15.091795396343395, -3.4523189891835933],
            [15.058409864450265, -3.456506191169595],
            [15.016509633003949, -3.4658764592753952],
            [15.012105479911101, -3.462688859376823],
            [15.00803524841161, -3.4627755216814937],
            [15.00156399326096, -3.4667301498310295],
            [14.947881817774746, -3.482085511721351],
            [14.920347847050543, -3.49126490935245],
            [14.909333273518225, -3.4963825957008368],
            [14.902478289197788, -3.4980278004849117],
            [14.896521380380461, -3.4981762592226873],
            [14.891196304786488, -3.500585766180238],
            [14.888474075840522, -3.5041223878036325],
            [14.879970155664227, -3.508976265189644],
            [14.861283734323358, -3.518488599327769],
            [14.79953013690012, -3.55364908531003],
            [14.77602893412056, -3.5724128118874607],
            [14.769818767471937, -3.569706734684254],
            [14.703391568171813, -3.5216188308018186],
            [14.670231636862276, -3.498267431330278],
            [14.67405309890977, -3.491898311476285],
            [14.672478576413333, -3.48798544001064],
            [14.674347223222254, -3.483437865825877],
            [14.670383918606175, -3.4817037730647082],
            [14.66798361800752, -3.4770000669671464],
            [14.677231500124579, -3.4711226644688984],
            [14.682450414538538, -3.465805263036252],
            [14.68299577227716, -3.45941683202871],
            [14.679211118882112, -3.453690184592752],
            [14.677741909541936, -3.449199256805557],
            [14.674429107377833, -3.4440787614975057],
            [14.667929226701803, -3.438146676592209],
            [14.666058187003745, -3.431598123406398],
            [14.672400660593121, -3.4253706751080766],
            [14.676591852134207, -3.4199629418149042],
            [14.680092152947335, -3.420980058460794],
            [14.682454748179444, -3.419138525686815],
            [14.682751230693688, -3.4151447557180497],
            [14.693519191326233, -3.4118158573566735],
            [14.696484064587052, -3.4077941428133007],
            [14.70326033730939, -3.4074681449824604],
            [14.705062722539152, -3.403333583899463],
            [14.70845753344136, -3.3997850802628564],
            [14.705862067287617, -3.3980280077351406],
            [14.71078980086657, -3.394525122586119],
            [14.7076321201468, -3.3907893559803086],
            [14.706159840706727, -3.3850578345244733],
            [14.710233914984569, -3.3782067973754133],
            [14.714568759185264, -3.3785787896666855],
            [14.721572142533159, -3.3757104355053906],
            [14.721448732675265, -3.371357678646393],
            [14.723670982922098, -3.370082502309339],
            [14.72179815906168, -3.363634213937886],
            [14.724837343272519, -3.362639322907007],
            [14.724948140347044, -3.357385632277005],
            [14.723348827885449, -3.3530790523252585],
            [14.718955900961726, -3.3550061639405517],
            [14.71653892646846, -3.353310506644834],
            [14.71696720449646, -3.348656866136868],
            [14.720154465643292, -3.3460743339424464],
            [14.716084807676337, -3.33870266407874],
            [14.719669297735113, -3.3346764257662627],
            [14.72529714737798, -3.3336792882264725],
            [14.725394950179664, -3.326971619239904],
            [14.718919688665306, -3.3231082634301248],
            [14.721551575951123, -3.317825722239146],
            [14.715653886569585, -3.313509245517237],
            [14.71968059862783, -3.309254280853932],
            [14.718775741696694, -3.3045064616711413],
            [14.723690021679836, -3.302358141226064],
            [14.723086043968651, -3.296746083531169],
            [14.719399576032764, -3.2919972401879654],
            [14.71962518636775, -3.2860572718417855],
            [14.718300500843618, -3.2833507623466063],
            [14.721046252234348, -3.2803211736042255],
            [14.724805206900054, -3.2816725135074565],
            [14.726389223500941, -3.27442315340199],
            [14.733078464802471, -3.272165371477488],
            [14.737385019385178, -3.2655980240351705],
            [14.73880106956917, -3.2588733737898647],
            [14.744443382414104, -3.2544569540803643],
            [14.754041375593179, -3.254321264387018],
            [14.756586443229239, -3.2575230524104044],
            [14.761134239808905, -3.257894901672374],
            [14.763715975364912, -3.2615369212105585],
            [14.773696572459077, -3.2638874608231143],
            [14.779628710566588, -3.2627273329498734],
            [14.787201047522446, -3.266425523563891],
            [14.80155685117477, -3.26734308229412],
            [14.80647656307647, -3.27033490636465],
            [14.814438434619971, -3.2715302795782946],
            [14.819610517284868, -3.2699287499554006],
            [14.820154116306318, -3.265423910314933],
            [14.828200147790625, -3.253268939345984],
            [14.828574866840095, -3.249890590476133],
            [14.835150411183115, -3.2387305911675544],
            [14.835612669688627, -3.235056187411711],
            [14.839668524445898, -3.230583352714194],
            [14.840021793215413, -3.2280163657261127],
            [14.847956296074129, -3.21839021739114],
            [14.84969272512311, -3.2150131972820124],
            [14.852569099083496, -3.214894056336953],
            [14.852904184846983, -3.2103410665581356],
            [14.848729429053346, -3.2064876403289815],
            [14.845299502539921, -3.1991437186776523],
            [14.939677509860342, -3.169718974064385],
            [14.942047325981402, -3.1626236509252954],
            [14.97052620212716, -3.0713521028413933],
            [14.987606793348872, -3.016532323427761]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.23832697207737, "lat": 34.07153449617084 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37019"],
        "coty_name": ["Brunswick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brunswick County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01026340"
      },
      "bbox": [
        14.666058187003745, -3.5724128118874607, 15.250129609616232,
        -2.998127015407538
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.96673502458747, -1.4708014325655097],
            [14.970809548021379, -1.4502890390370307],
            [14.984115185911833, -1.3467542177233003],
            [14.984562741788292, -1.3239882852384668],
            [14.986295038953235, -1.3156398329277206],
            [14.997573938214238, -1.2655217057842656],
            [15.013469311907459, -1.2120250244187014],
            [15.0145576390112, -1.2063086172077884],
            [15.01450536415895, -1.1994356960187516],
            [15.011639825108254, -1.179103878242817],
            [15.012500120163313, -1.1712797361055753],
            [15.014363605450956, -1.1676408434268286],
            [15.01964771383185, -1.1688827939556543],
            [15.023339825585886, -1.1658914836039018],
            [15.032368025171323, -1.1667959337740896],
            [15.035700223904145, -1.168845515705305],
            [15.033010583972628, -1.1737979159667642],
            [15.036629061592354, -1.1748785915318662],
            [15.039349568644479, -1.1792200611145338],
            [15.04300760881681, -1.1770919790360537],
            [15.050739055332226, -1.1753214807535117],
            [15.055089246995367, -1.1770264567614288],
            [15.059653890157646, -1.1742369861773236],
            [15.06305090570077, -1.1786152522656537],
            [15.066858438852258, -1.1793687147179739],
            [15.067451831416756, -1.1833759547155103],
            [15.071573115764512, -1.183697683537806],
            [15.073986936531567, -1.1875471617008095],
            [15.07488777001578, -1.1944648667475304],
            [15.078981312571791, -1.1977233284228608],
            [15.082744424962792, -1.1964694724342326],
            [15.088302341109168, -1.1981030160050925],
            [15.095169427376785, -1.1957942539824553],
            [15.096438187254163, -1.1986963705718057],
            [15.11408899089927, -1.2011587209965315],
            [15.118618266166374, -1.2039761963723803],
            [15.122658922859825, -1.202575384463916],
            [15.129600419104712, -1.2021452006513833],
            [15.132559338917758, -1.2044733510873138],
            [15.13587508654531, -1.2031946585770872],
            [15.139536844526104, -1.1989579659729412],
            [15.144458103115255, -1.1996628305001165],
            [15.155913046603597, -1.2041791849804617],
            [15.157229444405273, -1.2159673591141722],
            [15.16483586050635, -1.2223639419042396],
            [15.159188928862585, -1.2315183677802573],
            [15.156244899954155, -1.2347928718840466],
            [15.16749285327267, -1.2464112662854454],
            [15.171265707509951, -1.2465562817872662],
            [15.172933731832508, -1.251560331607808],
            [15.178610161563832, -1.2551283179015629],
            [15.212054198224372, -1.247506761885192],
            [15.219125813417499, -1.252439284125526],
            [15.230275046717626, -1.252475127053352],
            [15.236789109950557, -1.2564035572479242],
            [15.243239897610081, -1.2583815141900296],
            [15.244836879790293, -1.260243203309851],
            [15.242728002998701, -1.264936061908936],
            [15.248054692498929, -1.2656877677872655],
            [15.255296882618051, -1.2723828879572696],
            [15.260968949468023, -1.2729800986390125],
            [15.270211784837448, -1.2676668503197852],
            [15.275267522243103, -1.268752294509719],
            [15.271320798097115, -1.2759920477531796],
            [15.342219758105848, -1.3580257006598295],
            [15.346539408850939, -1.3879591006600758],
            [15.344181402072717, -1.3963843095548292],
            [15.346278994825655, -1.4090453778739576],
            [15.35288855123867, -1.4444024191583944],
            [15.318817006832635, -1.436936774899232],
            [15.31864622037068, -1.4408398554745525],
            [15.314877812152584, -1.4458119243244811],
            [15.304787886061492, -1.4465646109001935],
            [15.302044169647456, -1.450231384289943],
            [15.302975362304064, -1.4553938354407132],
            [15.301062590440315, -1.4631998512085556],
            [15.296757306090267, -1.469601305990973],
            [15.284051293023575, -1.4704590242770654],
            [15.280797398089343, -1.4695022114322709],
            [15.277647107163807, -1.4720674571924997],
            [15.276340265917602, -1.4794490058595424],
            [15.260339554885421, -1.4813801571383913],
            [15.233418781526654, -1.5275701835154643],
            [15.21329204359327, -1.5472166427024727],
            [15.189433461377451, -1.5733751246773269],
            [15.146082644818973, -1.6217880233579909],
            [15.132662338296205, -1.6361385772708616],
            [15.122253855152534, -1.623608674791868],
            [15.080169712063826, -1.59101443254333],
            [15.037741897882338, -1.5077254248545067],
            [15.037681911456934, -1.5038225775023784],
            [15.035107468981693, -1.498046711856067],
            [14.985817151815427, -1.477115733204672],
            [14.974337353965756, -1.475453488090435],
            [14.96673502458747, -1.4708014325655097]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.597041197897, "lat": 35.91291317737833 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37065"],
        "coty_name": ["Edgecombe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edgecombe County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01008551"
      },
      "bbox": [
        14.96673502458747, -1.6361385772708616, 15.35288855123867,
        -1.1658914836039018
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.012746575099895, -2.713978349546192],
            [11.015149544632164, -2.714083334846096],
            [11.016438995493575, -2.7091928340247],
            [11.021069335849639, -2.7059608277294216],
            [11.028054360123301, -2.698196623621307],
            [11.036589546898089, -2.6954498064771237],
            [11.04095782989126, -2.692375761081876],
            [11.045241435295257, -2.686540798223293],
            [11.050139886666875, -2.6846530313237187],
            [11.057437440780198, -2.685016768910059],
            [11.069592442155654, -2.6786361724416468],
            [11.080574770516376, -2.6775487973131753],
            [11.082399554929149, -2.672545052745453],
            [11.084780644776828, -2.6719477058463923],
            [11.08560942576164, -2.6632659735156743],
            [11.090246334136564, -2.6602853485341202],
            [11.09234737942147, -2.6542881135789784],
            [11.090530050003075, -2.6499077877449637],
            [11.097888252163816, -2.6449289766005193],
            [11.100169313464223, -2.639206283992584],
            [11.10000870368765, -2.6356957134939094],
            [11.102297578385782, -2.6333572124884626],
            [11.102820624534194, -2.6275012219858023],
            [11.105829488827661, -2.624338448747099],
            [11.105638656769178, -2.6182777888393742],
            [11.106983634127749, -2.6103650656186046],
            [11.111139567377055, -2.6074811589729694],
            [11.110912565957538, -2.6045566454760194],
            [11.114386724104136, -2.6009160305859185],
            [11.11645764462935, -2.5959287587178044],
            [11.123387432928729, -2.592557063399651],
            [11.126371850327553, -2.5859698226080208],
            [11.131651287021542, -2.583768691546],
            [11.133507937598687, -2.5805031220721912],
            [11.137022553522089, -2.5793427382974112],
            [11.133337878642768, -2.574623086877605],
            [11.135216475245374, -2.563696720698159],
            [11.208604179068123, -2.630225341097926],
            [11.226690208306227, -2.646525360472453],
            [11.247531892053722, -2.66372131388195],
            [11.250517141813212, -2.669595793934526],
            [11.249922963189919, -2.6756724829653935],
            [11.255333970709028, -2.6837060945023037],
            [11.262241671260194, -2.682954794668177],
            [11.261471775680308, -2.71169587851015],
            [11.264885438528868, -2.7097927145787075],
            [11.271129822373796, -2.711473658212732],
            [11.276633812770662, -2.748500082841584],
            [11.295573601557985, -2.806240414033765],
            [11.300300866712778, -2.809714334803892],
            [11.301262939068774, -2.8159305986885332],
            [11.3057437901708, -2.8169654554546537],
            [11.311622813661923, -2.823038202455847],
            [11.306663398100028, -2.825700055983866],
            [11.300498646067137, -2.8253681483555297],
            [11.297626587483013, -2.8297705024953466],
            [11.29322375114486, -2.831690187227402],
            [11.289652749198027, -2.8308664722715102],
            [11.283754148622464, -2.8316992025185397],
            [11.275163166495476, -2.837396705653253],
            [11.270064066320971, -2.8467463936842208],
            [11.264372766824055, -2.848222693612343],
            [11.263492006309912, -2.8434003193367077],
            [11.257998507815582, -2.844097338620355],
            [11.256914184694821, -2.847941828382313],
            [11.251484891318349, -2.84948186821686],
            [11.252215519429093, -2.852109481818775],
            [11.247874153738596, -2.8567625000836845],
            [11.244421387784788, -2.8585408016377554],
            [11.234675058064369, -2.8595581210058905],
            [11.234925713611869, -2.8545223361910352],
            [11.2334260526296, -2.851634751984038],
            [11.22773485600559, -2.850927952124338],
            [11.223600274792798, -2.854361005493256],
            [11.223973861732599, -2.8602386270248292],
            [11.220203247088067, -2.861398209218013],
            [11.219005565007278, -2.8655690261876163],
            [11.226469358269494, -2.8712032244666905],
            [11.219230192706954, -2.88487571274242],
            [11.215159090226186, -2.8820079104222853],
            [11.205467715341063, -2.889641940756223],
            [11.195890170309633, -2.8897674150302937],
            [11.194223406197406, -2.8959634644782333],
            [11.191488193161623, -2.8992087834071905],
            [11.188817859110195, -2.905701974515373],
            [11.185006812723314, -2.907010521530175],
            [11.180151427018401, -2.9052488621679937],
            [11.177962344884294, -2.9067772802827947],
            [11.17930363491584, -2.913128816891755],
            [11.174892095841976, -2.919284302885039],
            [11.169731184667723, -2.9198548817375456],
            [11.16532962669671, -2.923209549984035],
            [11.159625212252534, -2.925363334304369],
            [11.155556795700596, -2.923212397781987],
            [11.157818105340674, -2.91265574271365],
            [11.158037408055595, -2.908084521988427],
            [11.151878015212663, -2.9046218176247596],
            [11.148275425719776, -2.9057111857622524],
            [11.131555518072078, -2.914428986633748],
            [11.064155512982786, -2.946928380308666],
            [10.978701098204478, -2.9875736615025903],
            [10.97309800789526, -2.9814237502579357],
            [10.969917711425035, -2.9798523679383138],
            [10.953048733357019, -2.9761055505006695],
            [10.951370494566142, -2.970498808514433],
            [10.947290388997851, -2.9677190547973384],
            [10.944488066498705, -2.9690341529274336],
            [10.937774321424198, -2.966389886341791],
            [10.941853235052651, -2.958889633510518],
            [10.941789875104048, -2.9542520349538517],
            [10.944224072980633, -2.949604780905542],
            [10.942765500320887, -2.9421751496403474],
            [10.948612991959019, -2.9383959380062836],
            [10.949182959901185, -2.9352970758924104],
            [10.9594441434928, -2.9210703076506306],
            [10.984395232902987, -2.8813802482892354],
            [10.98860265085697, -2.8817213421281935],
            [10.990075939077185, -2.878537868395028],
            [10.98744351174476, -2.871640509630285],
            [10.984718720478813, -2.8690818050789386],
            [10.984431556447328, -2.8640305404451887],
            [10.981012639741598, -2.862600490161797],
            [10.977096019263387, -2.864211276338432],
            [10.97255307395963, -2.8604074190672835],
            [10.969572602867336, -2.8546871828036116],
            [10.96974431923784, -2.850786993409594],
            [10.981527447674566, -2.8448142084024015],
            [10.981198724971955, -2.8431377206172446],
            [10.97463247285679, -2.838786714347172],
            [10.976399838428232, -2.835416297081891],
            [10.97550516531665, -2.8308877131418693],
            [10.973141924148395, -2.828478212861461],
            [10.9741915823715, -2.8254861858509956],
            [10.987771492561986, -2.8165437450595494],
            [10.988028730778327, -2.8115034101815626],
            [10.991327597959689, -2.8093257903043987],
            [10.993159051127257, -2.8045849461653374],
            [10.992248825868119, -2.794646445344502],
            [10.996437091175522, -2.791823993739425],
            [11.00255273984121, -2.7856563754937826],
            [11.010381436798923, -2.7821960412532944],
            [11.012580804718219, -2.778007617340333],
            [11.012743773015622, -2.7740385104745666],
            [11.01522539473159, -2.769312469844128],
            [11.013711661215082, -2.7654906611820373],
            [11.016022465962243, -2.759960095531612],
            [11.014517251724016, -2.753746648612778],
            [11.016908029486913, -2.7402277243962025],
            [11.017030600219023, -2.734841773361657],
            [11.012852365903775, -2.722666452743731],
            [11.012746575099895, -2.713978349546192]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.79816294674094,
          "lat": 35.202122081096576
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37175"],
        "coty_name": ["Transylvania"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Transylvania County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "01008589"
      },
      "bbox": [
        10.937774321424198, -2.9875736615025903, 11.311622813661923,
        -2.563696720698159
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.373127133029291, -3.862068977178835],
            [7.380459874329156, -3.8601000052622303],
            [7.381230376435985, -3.8508421289756636],
            [7.387013758755452, -3.849227826422618],
            [7.389772375249109, -3.8415522158060114],
            [7.385481266497436, -3.8385473464404383],
            [7.38724564788665, -3.8335075781522767],
            [7.383456355725955, -3.8331937129840226],
            [7.382637369843037, -3.8296663636714348],
            [7.384503692679663, -3.8255264276638044],
            [7.388600764903942, -3.8223161479369763],
            [7.390001636776323, -3.8163218211111167],
            [7.389340388798835, -3.8105936231778936],
            [7.393133332253483, -3.8023428030872877],
            [7.396650419087965, -3.8019502125585616],
            [7.402074689109531, -3.796097959965731],
            [7.404909153945221, -3.7893835093125223],
            [7.409191030798058, -3.7879277945777377],
            [7.4086290297224, -3.7850186594990447],
            [7.404676366795021, -3.7830317699051106],
            [7.403216978311082, -3.7776788085437905],
            [7.408171172869, -3.7736910421306797],
            [7.422209111503175, -3.777502139287903],
            [7.426474890685127, -3.773293184749198],
            [7.430893484093526, -3.774259268197134],
            [7.434204233230636, -3.7688993447711017],
            [7.431508032360531, -3.764276205137871],
            [7.4347824395500925, -3.761590269202056],
            [7.430199275876554, -3.7569763718999534],
            [7.430485685998778, -3.7527613729198044],
            [7.4337321890829555, -3.7474190514321837],
            [7.4277607649701896, -3.7421874966073223],
            [7.424396354403806, -3.736890686021843],
            [7.4243120776061575, -3.7306389516597083],
            [7.425462621917834, -3.726863224123699],
            [7.429361329466881, -3.7240462326278085],
            [7.435258633527538, -3.722427888062444],
            [7.436912099520186, -3.7185721865503076],
            [7.443867002232237, -3.712730759636178],
            [7.44349242959523, -3.7087426019210405],
            [7.438068625046156, -3.7043239471263036],
            [7.437270259017101, -3.699394952705659],
            [7.434696042241451, -3.694511875307426],
            [7.436713113906869, -3.691020171340157],
            [7.437023495291183, -3.684264368649763],
            [7.443047308475492, -3.6819374855595206],
            [7.441970608484093, -3.676550474000822],
            [7.439171593136953, -3.669446635075206],
            [7.445328740192563, -3.663399233406017],
            [7.447648980781198, -3.658071899688497],
            [7.4473392755098695, -3.6534600731902693],
            [7.4378547871728795, -3.6482006484092344],
            [7.431894252093135, -3.6481705734591667],
            [7.4336471313361665, -3.6424824398617637],
            [7.43741360635497, -3.634742100967892],
            [7.434569681551745, -3.627020251456092],
            [7.435889250914871, -3.6211263291558873],
            [7.440389697932523, -3.621361592351838],
            [7.446718038129905, -3.619420488234278],
            [7.462404783999271, -3.616946629761355],
            [7.471914261436599, -3.61396724233995],
            [7.48106211193561, -3.6120128388439148],
            [7.502945435788974, -3.618610001009957],
            [7.512993404007867, -3.628232626977818],
            [7.544720329379752, -3.660954466340925],
            [7.5602268495337395, -3.6575635440771554],
            [7.574205217399623, -3.650350652234859],
            [7.582510375883355, -3.6458589133854193],
            [7.598817140469685, -3.642619508581548],
            [7.604528482403193, -3.642905385530097],
            [7.612894550912352, -3.6457133308408882],
            [7.626145641487341, -3.6541819901400885],
            [7.635396611512461, -3.6545518606610305],
            [7.6479557797843105, -3.6594621561080727],
            [7.655219522483889, -3.663962984544664],
            [7.662495914925659, -3.6671451414268463],
            [7.676274039612645, -3.6757829633111108],
            [7.682028832025715, -3.6826132095081383],
            [7.685844154768111, -3.692763150549682],
            [7.689626748148366, -3.6972848399643623],
            [7.707279815301675, -3.711351886731072],
            [7.715867592815135, -3.8099725599171443],
            [7.717963162944129, -3.8368303092535885],
            [7.723340316318568, -3.8988500491218545],
            [7.729236887246513, -3.982299918565668],
            [7.73218023435647, -4.020470220972642],
            [7.7382369907288355, -4.0844803043036455],
            [7.739765178179593, -4.0989785977860835],
            [7.713727570165222, -4.101557970751061],
            [7.621038182861107, -4.1101055085336275],
            [7.571862491052573, -4.114024866322201],
            [7.523916838333127, -4.117327848005699],
            [7.422414115078676, -4.122827887529744],
            [7.396631508196834, -4.124973631758633],
            [7.3840327465060955, -3.9932095926311995],
            [7.381556206616485, -3.960277215615485],
            [7.38115401774318, -3.958546150954173],
            [7.379127593726022, -3.93096210898594],
            [7.373127133029291, -3.862068977178835]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.31103276805553, "lat": 34.52170244078124 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01079"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00161565"
      },
      "bbox": [
        7.373127133029291, -4.124973631758633, 7.739765178179593,
        -3.6120128388439148
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.730859050265105, -6.350875772458338],
            [8.78660666986258, -6.34481566689693],
            [8.789349013408343, -6.344050483699134],
            [8.888615846307141, -6.333641909876998],
            [8.895180788728362, -6.332685702885251],
            [8.885283809473123, -6.249867994100102],
            [8.888894294170948, -6.249588217209792],
            [8.889257123631825, -6.253064779660638],
            [8.89639936593204, -6.252312119058912],
            [8.896010660759618, -6.248738826355003],
            [8.902813586620162, -6.2478373994622896],
            [8.902491324110684, -6.244667912361015],
            [8.923998565714829, -6.242276149523662],
            [8.92373981416314, -6.2386769841188325],
            [8.920094477328927, -6.239072559580723],
            [8.919628852767582, -6.235504215154527],
            [8.926536828623268, -6.234634751300713],
            [8.927330155557716, -6.24190348463497],
            [8.956264568554724, -6.23866242214479],
            [8.95730117989623, -6.2459835998357045],
            [8.972236016277225, -6.244404393718018],
            [8.979293530588253, -6.302215927207725],
            [8.982372274374171, -6.301992659985736],
            [8.983110187709356, -6.309121835117186],
            [8.987113371327716, -6.3086184986943925],
            [8.988587696998488, -6.3231245501141835],
            [9.067755000291863, -6.314677573771311],
            [9.07253781494497, -6.366589576722942],
            [9.076276019646842, -6.401034865005509],
            [9.188365332686377, -6.389026929882666],
            [9.187501420878085, -6.391973967525497],
            [9.181702178308678, -6.400070128241816],
            [9.178758838098437, -6.408418303192519],
            [9.176002847628666, -6.410350934410916],
            [9.174609063733252, -6.418669185063347],
            [9.17963120731336, -6.424499438788712],
            [9.184384622676152, -6.435165324640283],
            [9.182317827711936, -6.441508568355875],
            [9.182781322793721, -6.445737814722142],
            [9.180717270255164, -6.45065364175453],
            [9.18333844912521, -6.454609718326035],
            [9.182201995868597, -6.457946889411011],
            [9.182687141947754, -6.463622353170638],
            [9.18631894726744, -6.470290936048394],
            [9.18645867125654, -6.474485559979631],
            [9.194032666540753, -6.486733894795956],
            [9.19162188319838, -6.489292422622631],
            [9.192877859102094, -6.4963774675142005],
            [9.189957022059758, -6.5086776146167225],
            [9.184324624180263, -6.513749071023113],
            [9.170885938782275, -6.5238985768909625],
            [9.166102365991591, -6.533187590959357],
            [9.164635081994234, -6.540753647693067],
            [9.166856321718697, -6.5478938677649206],
            [9.16464328987003, -6.550962330767686],
            [9.166129213930967, -6.553929244375286],
            [9.163561838186583, -6.56095609137815],
            [9.166607411335136, -6.563536673626379],
            [9.162166630497671, -6.568787429451443],
            [9.161067277748888, -6.57508118940137],
            [9.157509294491446, -6.575328662379046],
            [9.155747856818051, -6.580505374461343],
            [9.158736291910593, -6.5824359477304455],
            [9.160134406424993, -6.597008719091173],
            [9.16244290926189, -6.605078454573704],
            [9.160384190070587, -6.6087825572279275],
            [9.163065717754762, -6.612387599828308],
            [9.162968247677165, -6.617850722445241],
            [9.161000046439897, -6.622800109885338],
            [9.155708899752794, -6.629922653473029],
            [9.154580343953322, -6.641529448248099],
            [9.149535154797471, -6.6507834512628845],
            [9.140602942103296, -6.65740603363199],
            [9.106136235411796, -6.661189863589041],
            [9.030402274067894, -6.6686817279714425],
            [8.990039282615697, -6.672536593851881],
            [8.928235383406237, -6.678697069747381],
            [8.924806861193208, -6.679301317648295],
            [8.879314033485267, -6.684332818416294],
            [8.823871917224139, -6.690722422117831],
            [8.805308686008516, -6.693070147735791],
            [8.790962904981832, -6.694731889474897],
            [8.77695565775278, -6.6973257576692795],
            [8.775798969250348, -6.691815852137459],
            [8.776575065835784, -6.685556287820341],
            [8.784512935858748, -6.678506295504725],
            [8.78346558336129, -6.673696763992034],
            [8.789506945801593, -6.671071107355657],
            [8.789079450951242, -6.667815039655096],
            [8.791261534975355, -6.664639612198625],
            [8.788629389150417, -6.659242318221301],
            [8.789131577825119, -6.651928915692592],
            [8.799577297646678, -6.6482767933302025],
            [8.798581710242864, -6.636941564875046],
            [8.793980820001442, -6.59642140606796],
            [8.78763416213426, -6.536094538637941],
            [8.78524798938531, -6.521407646685014],
            [8.74234144440507, -6.526333276818449],
            [8.740515973986364, -6.509052174878697],
            [8.745536052530634, -6.504377917770472],
            [8.744255485269276, -6.497566232546202],
            [8.748243877021144, -6.492092576391142],
            [8.751825948125777, -6.483275757837025],
            [8.74858255224784, -6.478551276579279],
            [8.749885136164194, -6.469341542648486],
            [8.748688641215267, -6.465197805200719],
            [8.749244627350757, -6.458320488839935],
            [8.748564387442661, -6.451547244724412],
            [8.750859226379337, -6.448859076633733],
            [8.748440496959386, -6.445593671927109],
            [8.750830526586626, -6.4399921565895974],
            [8.750827068757834, -6.429284638801558],
            [8.753290555503522, -6.426868793786657],
            [8.753898269641265, -6.422850618374298],
            [8.750881056044436, -6.414621165824171],
            [8.749452537289045, -6.396819351700903],
            [8.746535867668868, -6.390764992397221],
            [8.748760585028432, -6.389605131426728],
            [8.748358306973877, -6.38506819054694],
            [8.74374306731932, -6.380172396172642],
            [8.743994268954681, -6.3771108799412985],
            [8.741037579495883, -6.372170383690072],
            [8.740728026279909, -6.367233093310069],
            [8.736580336548359, -6.358535925827695],
            [8.735946224204772, -6.354213100899018],
            [8.730859050265105, -6.350875772458338]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.94093898047527,
          "lat": 31.802730322347106
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01109"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00161581"
      },
      "bbox": [
        8.730859050265105, -6.6973257576692795, 9.194032666540753,
        -6.234634751300713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9747963337673786, -3.5219239071811064],
            [2.9801149006526937, -3.52220587926517],
            [2.987298195089969, -3.5210474603464137],
            [2.9970435491995024, -3.5177996439616614],
            [3.003934169749817, -3.5165364372926082],
            [3.0117764301579406, -3.516836815168461],
            [3.0102603894063398, -3.458783835782544],
            [3.0091804159062194, -3.4081561230995296],
            [3.007939006396827, -3.3566101538190156],
            [3.0072348929866193, -3.312938268075213],
            [3.005471569804097, -3.225723273535144],
            [3.091150093581211, -3.224823701150191],
            [3.158204306129418, -3.2243068200954594],
            [3.1676271978543804, -3.22395047329427],
            [3.206107211376107, -3.2235638812155942],
            [3.277245456950258, -3.223192325203998],
            [3.30529330474066, -3.222674841142726],
            [3.3058314901393597, -3.2366963395538204],
            [3.3061874879239346, -3.2662164038825194],
            [3.3069224730586946, -3.291166305582138],
            [3.307098188896947, -3.310441442621051],
            [3.306737649983099, -3.324492025514637],
            [3.3071235526303537, -3.3536628035224565],
            [3.307996613038523, -3.398805456086414],
            [3.3078061330565536, -3.4040655953062866],
            [3.304415182243965, -3.406226290729521],
            [3.3004812960252226, -3.406170785449975],
            [3.2987718278525913, -3.4107773528216128],
            [3.3006818969706098, -3.412779788482024],
            [3.2905086680704896, -3.4224364029180405],
            [3.2877716407117727, -3.4217982035560097],
            [3.28460961648644, -3.424228634010655],
            [3.2883198631157056, -3.431368796855526],
            [3.2927286946538943, -3.432385931675474],
            [3.2937572767548633, -3.4358063235325194],
            [3.291911288750135, -3.440961578369402],
            [3.286867497836975, -3.441241287774716],
            [3.2848915156317244, -3.44759406234151],
            [3.2796080750007173, -3.449216105737699],
            [3.2788979588232294, -3.4517711036260152],
            [3.273514063678662, -3.45258526934383],
            [3.2720961745046506, -3.458039589291118],
            [3.2736540277222352, -3.4618125697355495],
            [3.27735486493216, -3.462201473281449],
            [3.277534526117254, -3.466905268004213],
            [3.2759670546919804, -3.4724153532639743],
            [3.278223901976064, -3.475874494347134],
            [3.276159732162592, -3.4797351556713028],
            [3.274852864119487, -3.4857544402553726],
            [3.276995260269711, -3.4878293575045776],
            [3.275963125323069, -3.491922260740324],
            [3.2798071301974385, -3.4917537360026523],
            [3.2797482673288196, -3.495079659265915],
            [3.290141326723685, -3.5001408972427757],
            [3.29571901354734, -3.505374714874728],
            [3.2955532658781492, -3.5117017808919546],
            [3.2942553446346325, -3.5158075497730064],
            [3.298519157738545, -3.517466409063825],
            [3.2965538325478656, -3.5209579689413686],
            [3.2970157970550114, -3.5333780094630103],
            [3.292987842515891, -3.5369581803510663],
            [3.29592452345062, -3.541318374240047],
            [3.2909572290766946, -3.5468126812933214],
            [3.288148495625215, -3.552334389747296],
            [3.2839780813685615, -3.5670446506691347],
            [3.2740408370667966, -3.567241933047191],
            [3.2662654305950385, -3.5561292671514346],
            [3.2577707374569784, -3.5648095787958805],
            [3.257475709579481, -3.569196227668209],
            [3.252649332755454, -3.5676471984968305],
            [3.24809112548271, -3.5680072064867896],
            [3.242163033749595, -3.571016234875545],
            [3.2341298830985608, -3.581181879314678],
            [3.2287097347307836, -3.5918814356515165],
            [3.224988419208407, -3.596870773897153],
            [3.2196267405264445, -3.601408751235057],
            [3.2117565761467595, -3.604880273796524],
            [3.2000712988071647, -3.6083482355527057],
            [3.1898580128078966, -3.6100088121206295],
            [3.182711653499512, -3.6082422400822614],
            [3.1830680574006363, -3.6031440765068377],
            [3.1867108220605007, -3.599545686203273],
            [3.196921282664473, -3.5945776535202363],
            [3.203074095793255, -3.5888265626852562],
            [3.2043404395781274, -3.584934749251713],
            [3.2033372885314315, -3.575756495313028],
            [3.1965000227055564, -3.5699378186338855],
            [3.1930188639967487, -3.570010632949944],
            [3.184310074236102, -3.5748530426466942],
            [3.175301075544463, -3.5850667596499264],
            [3.171624334310302, -3.593018347195436],
            [3.161292428482733, -3.606454185191311],
            [3.1583093117168897, -3.60908549515734],
            [3.1434310695809344, -3.6135877878576195],
            [3.133348639804127, -3.615105341948736],
            [3.1276628806679323, -3.6129991879228625],
            [3.125599622752947, -3.6157142584882744],
            [3.0998741504818104, -3.6160718897966238],
            [3.0424014583530816, -3.617433092037422],
            [3.006734632933181, -3.617589419956623],
            [2.9710351854935597, -3.6180858684234227],
            [2.92810878999599, -3.618406997897554],
            [2.9279559936789425, -3.618908384106962],
            [2.8834100474501567, -3.619510119825413],
            [2.8646054357412507, -3.619214742569674],
            [2.87056232826286, -3.6114065532560535],
            [2.874983442525693, -3.6083953290048396],
            [2.876530393913364, -3.6046921529030755],
            [2.874422716251522, -3.5965145750425176],
            [2.8685933442065923, -3.595008392447534],
            [2.8650805595484994, -3.592445771392399],
            [2.863417379261938, -3.587725598324654],
            [2.8680997795978938, -3.583973260610774],
            [2.8762495325283535, -3.583504467627929],
            [2.8813957779152077, -3.5768290362979274],
            [2.8865518327940745, -3.580715234967888],
            [2.899588431842112, -3.5781002231255035],
            [2.903998702910712, -3.5800065234313947],
            [2.911845641912259, -3.5771242474698335],
            [2.913849207711843, -3.5709721375720767],
            [2.916010419515918, -3.5687813058314095],
            [2.912711967732086, -3.5631348287064433],
            [2.9186257224775223, -3.5587125440021525],
            [2.9222545670208784, -3.557736837371487],
            [2.9311635830686837, -3.5532855118293196],
            [2.936852465035517, -3.5432151070933333],
            [2.9454769352387564, -3.5362820531054435],
            [2.950428457827368, -3.5287320692428974],
            [2.955390215255262, -3.5245789783824177],
            [2.9616739041622426, -3.5231206155388346],
            [2.9747963337673786, -3.5219239071811064]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.70147452733104,
          "lat": 35.262398596823246
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05029"],
        "coty_name": ["Conway"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Conway County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00066846"
      },
      "bbox": [
        2.863417379261938, -3.619510119825413, 3.307996613038523,
        -3.222674841142726
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.0828087337429153, -5.172619597878362],
            [2.0998236760946805, -5.1669820332262715],
            [2.104808779861346, -5.16374063598579],
            [2.1094900916910078, -5.159019490734981],
            [2.1145430399665335, -5.158057258411556],
            [2.118167272081462, -5.159005654067731],
            [2.122000326900622, -5.162267875152029],
            [2.1233805272240156, -5.168540856565994],
            [2.1202549846376013, -5.176010824546672],
            [2.1224387976518786, -5.182504463594545],
            [2.1257380379763275, -5.186338268979363],
            [2.1319866210026293, -5.188222797163883],
            [2.1370436309346257, -5.182140176845822],
            [2.1406759120010914, -5.169170560720007],
            [2.138116160205451, -5.162956999788287],
            [2.1326956518579565, -5.16104632802494],
            [2.131753992191801, -5.158491017673894],
            [2.134398059573622, -5.153363877012089],
            [2.140109369797681, -5.150170923495751],
            [2.1481129535806556, -5.15023529639851],
            [2.151779295716517, -5.154705595339853],
            [2.1526682912508037, -5.158128605883682],
            [2.1533716503046327, -5.169746576501855],
            [2.1574454597428976, -5.172487239521296],
            [2.16354878907231, -5.171236543800411],
            [2.1656402185674986, -5.169012588446948],
            [2.16659888643422, -5.160036403107736],
            [2.1713937472935196, -5.1466180018853525],
            [2.174816389182622, -5.142078399098975],
            [2.17881748802232, -5.140809711575401],
            [2.18580030361384, -5.142765515431535],
            [2.1918062232058615, -5.15203268069775],
            [2.1952153649860793, -5.152723443086802],
            [2.198423106232433, -5.150782980139919],
            [2.1991458906961263, -5.145682630566756],
            [2.195631000822154, -5.140461608813879],
            [2.191160956831712, -5.1389914621537836],
            [2.1875210297399494, -5.135681983040479],
            [2.1873094298011035, -5.13272290210772],
            [2.195755676941822, -5.1263887495333496],
            [2.2008210518837092, -5.12891509426665],
            [2.2029248688978766, -5.1350931945402785],
            [2.2013058605788944, -5.139203177273039],
            [2.203071433800617, -5.141131702257382],
            [2.207573085133193, -5.137131628553165],
            [2.2173747318257044, -5.130520448079794],
            [2.222050730467191, -5.122555422743591],
            [2.2221415372125595, -5.119637721801379],
            [2.2255330182583757, -5.114299532237953],
            [2.2331681106508263, -5.11009817177165],
            [2.24546319157714, -5.113455620529816],
            [2.253017699259173, -5.117390371576847],
            [2.257594399421423, -5.117157013052085],
            [2.2610365299379005, -5.114419783733244],
            [2.261462763953679, -5.110252128528955],
            [2.266112961407206, -5.106045217082447],
            [2.2686514554136927, -5.107661820440913],
            [2.271678473457354, -5.112876268342875],
            [2.272830725905915, -5.121786727676511],
            [2.2700845716155675, -5.132095612305935],
            [2.2609585415761537, -5.144175938426188],
            [2.261897636607365, -5.1493946210443875],
            [2.268271509510798, -5.151938900691358],
            [2.278638739134879, -5.151751380411719],
            [2.2831373078055357, -5.155014747221771],
            [2.2836684305794885, -5.161272769465005],
            [2.2765862642027694, -5.171308376634189],
            [2.2762203805236374, -5.173812737509316],
            [2.2795918160991557, -5.178082104757644],
            [2.2841737941755142, -5.178706926120699],
            [2.2888720937123765, -5.173839327955808],
            [2.293367875474082, -5.163517532621347],
            [2.297608505336395, -5.163522475835069],
            [2.29925796387585, -5.1669382537618915],
            [2.2984079333293512, -5.171005986895598],
            [2.2957268271932145, -5.174129018111007],
            [2.2883471687359607, -5.178633679021273],
            [2.2868790487631507, -5.181041116795391],
            [2.287868589511548, -5.187412470965167],
            [2.293508291682494, -5.190791054440225],
            [2.2999434977030186, -5.191628807789729],
            [2.3047707966260624, -5.18943688771751],
            [2.3085357966793794, -5.186131881683919],
            [2.3103919001779882, -5.1917062143545625],
            [2.3042298818478417, -5.194185379668325],
            [2.301313863135589, -5.19791072367522],
            [2.3025638283401224, -5.202653516865976],
            [2.3070236341694543, -5.209525224660094],
            [2.308070197039753, -5.220525739878538],
            [2.3180941717934296, -5.220214891322575],
            [2.3226336986249763, -5.214774819845464],
            [2.316148949097878, -5.208467165765028],
            [2.3143287137377135, -5.203917566568222],
            [2.3167884554434264, -5.197057668025804],
            [2.3280252665765024, -5.1844021843005335],
            [2.3315226096106123, -5.186275744722132],
            [2.3329847889453172, -5.190297972650604],
            [2.327073881148795, -5.203547741919771],
            [2.328270348491302, -5.207678447215859],
            [2.3357825210511, -5.215728257658538],
            [2.339612685065467, -5.224830656373062],
            [2.3521231216138556, -5.236406849480017],
            [2.351344325282456, -5.240020326821466],
            [2.3434942238775887, -5.246784198435784],
            [2.3400392933157073, -5.254491052642507],
            [2.33849708161636, -5.261077062335348],
            [2.3391833772671764, -5.263851022240336],
            [2.3470492419447124, -5.269764994914575],
            [2.347167482703397, -5.274790893676363],
            [2.341564284708416, -5.275743542090497],
            [2.3376002013509605, -5.273729429289951],
            [2.3324743852317567, -5.274435437667346],
            [2.3311938876861, -5.277158529502559],
            [2.337446737784654, -5.288677374468572],
            [2.3399355664974686, -5.291827593197378],
            [2.344252536893913, -5.290157571240291],
            [2.3507467353861617, -5.279263843043181],
            [2.3553004191288314, -5.277581471726237],
            [2.357543967204169, -5.279346067961914],
            [2.3580180011746648, -5.285928834320745],
            [2.352378923624054, -5.290894616548782],
            [2.3469020947136294, -5.292460324661565],
            [2.344032022989967, -5.294688792549968],
            [2.3436613983741323, -5.299012921264037],
            [2.345563934283271, -5.3017927212203535],
            [2.352237962756742, -5.30608028832252],
            [2.3568995722601165, -5.314096795381348],
            [2.357660710194413, -5.31968728872832],
            [2.3604853226311002, -5.322929862179551],
            [2.368799773891251, -5.326924793157693],
            [2.371690226366743, -5.330491230827873],
            [2.3666498406830554, -5.333975867175694],
            [2.3570557971824484, -5.33184345863504],
            [2.3543104243443636, -5.3323432866967275],
            [2.351629874124881, -5.336572724052147],
            [2.355974787905217, -5.343569372463552],
            [2.3599168909190453, -5.345780307817686],
            [2.367750301852704, -5.3455842493909485],
            [2.3712399680163827, -5.343158851569323],
            [2.374396590294757, -5.333164501803698],
            [2.381957541908519, -5.329339527166156],
            [2.392181347827032, -5.336721140616658],
            [2.394573677400475, -5.339945838989942],
            [2.393108978658505, -5.34259672207588],
            [2.386749586144156, -5.3456814771185766],
            [2.3809272600706035, -5.344006759597574],
            [2.3747449046142073, -5.346002289090402],
            [2.3726247815617727, -5.3485512312572085],
            [2.3729166626954945, -5.3547168855132865],
            [2.3709423144533504, -5.359793990749761],
            [2.365012804987324, -5.365162562190038],
            [2.3641591695618946, -5.374431555221503],
            [2.367765857561089, -5.379269868076353],
            [2.371415097179891, -5.377984904120785],
            [2.3801577321708622, -5.377601366051604],
            [2.387448829813878, -5.378752081882118],
            [2.3978511825796716, -5.383435675648988],
            [2.401464096777526, -5.388188009716105],
            [2.3996755761128905, -5.392853754506135],
            [2.395994552967284, -5.396030617370252],
            [2.38350393268284, -5.397302810658824],
            [2.3798779001607495, -5.399501027161727],
            [2.3788320474801568, -5.403053350235728],
            [2.384045697292764, -5.413787747314979],
            [2.384368931009648, -5.4216737588255075],
            [2.3825644507306842, -5.4301815444004395],
            [2.3823903234760353, -5.440225477900711],
            [2.3797766343528775, -5.441609931023397],
            [2.368370011350708, -5.440340065712627],
            [2.3628936134064378, -5.435134398468988],
            [2.356108159475547, -5.430620187955695],
            [2.3511151310602045, -5.435652335478306],
            [2.3491286739885937, -5.443526711018918],
            [2.3525913936210125, -5.44982571725761],
            [2.366077327209911, -5.459452126147032],
            [2.3672671381983834, -5.465967119509874],
            [2.3629493663756485, -5.4750417538374885],
            [2.3527908465169913, -5.484046731276703],
            [2.3507385163439922, -5.491584788715368],
            [2.354536333832346, -5.496626048885844],
            [2.362232611574724, -5.494947831091936],
            [2.3698191708147665, -5.490060131513313],
            [2.3747661811470393, -5.489699545083125],
            [2.3746328065496605, -5.49269261550295],
            [2.3657247367379277, -5.498689879079738],
            [2.355269543684713, -5.502464823621771],
            [2.3461243439551756, -5.511094171904949],
            [2.342436667027799, -5.518320380084679],
            [2.3449489059616644, -5.5237519214364585],
            [2.3541891616664348, -5.530627813179296],
            [2.352984401485522, -5.534447702822384],
            [2.3496680117549134, -5.536543916959938],
            [2.3396161843826806, -5.5385028029053345],
            [2.3302492728136066, -5.538955111386284],
            [2.3276330074321074, -5.541846625287606],
            [2.327799813779063, -5.549410732717657],
            [2.332313649020565, -5.553345108888026],
            [2.3422882005623054, -5.552174759593459],
            [2.3458925971415945, -5.5533179722288475],
            [2.348500416441292, -5.558485045083904],
            [2.347572170938517, -5.5627659211871965],
            [2.341200393637276, -5.564698515110562],
            [2.3347792833320415, -5.561246628272485],
            [2.3316240893880757, -5.556920773207087],
            [2.326186752992785, -5.553725568538609],
            [2.31869109244143, -5.552965093827029],
            [2.314650017994788, -5.555409314204516],
            [2.3127347604530994, -5.560919283608209],
            [2.3130349947312103, -5.567674200944097],
            [2.3160517995172345, -5.578801628238504],
            [2.3143284053047584, -5.580745630547704],
            [2.3091741091737683, -5.578336476142146],
            [2.3050382895805246, -5.573139776538372],
            [2.3041426617715057, -5.56238651373237],
            [2.3003402606498335, -5.558665689326844],
            [2.2934728407489895, -5.558130809328557],
            [2.2864454926647753, -5.5633618888828025],
            [2.284032303543572, -5.567726060114214],
            [2.2842043622916077, -5.576455808761762],
            [2.2834702845224917, -5.584291272918478],
            [2.2804695041329173, -5.585158551413094],
            [2.275435861440811, -5.5835791575452145],
            [2.2662889335760434, -5.572803272927659],
            [2.2607586071310144, -5.573144040958343],
            [2.2564272505414382, -5.576223928585939],
            [2.253409904800846, -5.581408199210611],
            [2.2543705924617337, -5.596235759681217],
            [2.2531513729623702, -5.59953357400191],
            [2.248599748813634, -5.60490710909521],
            [2.2476792751709036, -5.6088422606878625],
            [2.2497328180411817, -5.616837350110911],
            [2.245702585234353, -5.621467327362617],
            [2.2420722890847755, -5.623072483248775],
            [2.2425087082558033, -5.627574075440092],
            [2.2514539262860334, -5.6363909192832065],
            [2.2641827078497716, -5.643740474963474],
            [2.265433127813271, -5.650162707289228],
            [2.261899060487246, -5.6640129535758925],
            [2.264385532271786, -5.666669396593478],
            [2.272230843994948, -5.66963179668],
            [2.2781953982861456, -5.670487644248826],
            [2.2807715522739436, -5.672592548961268],
            [2.2806152055269755, -5.679177355073059],
            [2.27541758001408, -5.683983827630519],
            [2.2735195062347437, -5.688662790538804],
            [2.2780356987979946, -5.6916941251462605],
            [2.284278453242677, -5.692108427989729],
            [2.2901786264379917, -5.694384176600435],
            [2.2906709527656717, -5.701582799392507],
            [2.284456668415284, -5.701732201672718],
            [2.198135723361512, -5.703742297720631],
            [2.0942305385462805, -5.706011006132126],
            [2.0929218374589094, -5.645671544767428],
            [2.0927855999602607, -5.632408797941081],
            [2.091471895539537, -5.581591528604094],
            [2.09151095763117, -5.564742451829376],
            [2.0904888642300192, -5.52230073946031],
            [2.0898118447060114, -5.483071797667512],
            [2.0889860794815487, -5.453601059841812],
            [2.087057651568523, -5.365910792200888],
            [2.0859832487978753, -5.304299696920689],
            [2.0841906778908488, -5.233327700724877],
            [2.08437259427663, -5.231308979311551],
            [2.0828087337429153, -5.172619597878362]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.8920944284163, "lat": 33.312335212938 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05091"],
        "coty_name": ["Miller"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miller County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00069166"
      },
      "bbox": [
        2.0828087337429153, -5.706011006132126, 2.401464096777526,
        -5.106045217082447
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.870483434393164, -3.627918519656977],
            [3.87016718821289, -3.6180242048456495],
            [3.873487280509107, -3.6159330959633054],
            [3.881868582563096, -3.6173923508603294],
            [3.8872131576820332, -3.6144774912734348],
            [3.8896732533390423, -3.610548651829157],
            [3.895214243614113, -3.610268377736549],
            [3.8996173982783513, -3.6071253787724964],
            [3.9033483451024447, -3.6090520659560874],
            [3.9070418566990655, -3.608486438725443],
            [3.916829563187681, -3.6093431526112214],
            [3.9297169115014032, -3.601660078543598],
            [3.9349287219484435, -3.5968704450180664],
            [3.9376274576943966, -3.5976781110736424],
            [3.9455282439815393, -3.5924925736774105],
            [3.9475492068425972, -3.594765356250449],
            [3.9509431151812784, -3.591749392964185],
            [3.95458792742045, -3.5933359843570303],
            [3.9629675196106646, -3.5944026381582668],
            [3.961311956321358, -3.597299088252962],
            [3.9641679728848342, -3.6013221837315257],
            [3.9672384107218845, -3.6003606865571833],
            [3.969273459262988, -3.603547205221115],
            [3.9725933474483917, -3.6032261232311256],
            [3.97533025785745, -3.599248442791501],
            [3.9824100288783186, -3.599086349054825],
            [3.98824703720629, -3.60159018700862],
            [3.998363968346439, -3.61006765643752],
            [3.9970796564295097, -3.612411767660608],
            [4.002267800048593, -3.6256694384326718],
            [4.016087172031707, -3.627722448598959],
            [4.024279055148636, -3.6306109870538847],
            [4.02885473240467, -3.6292462116400106],
            [4.032543031713767, -3.6250332712418576],
            [4.04526978192978, -3.623809377003692],
            [4.047012887940942, -3.6253377415539574],
            [4.044790095009432, -3.558712356512856],
            [4.141165649175711, -3.5562890384218413],
            [4.1392541329223205, -3.562020922080732],
            [4.1472333616918435, -3.5652031336403898],
            [4.151756630477545, -3.572443943208857],
            [4.157507877503591, -3.576192091859902],
            [4.156164304218888, -3.5785803679997206],
            [4.148478766436711, -3.581971002684058],
            [4.143410641096738, -3.581783440665032],
            [4.135766191877636, -3.578462999756647],
            [4.132787767256589, -3.5809285798905854],
            [4.131437623689395, -3.5853765690840076],
            [4.134176061613717, -3.5899637826042183],
            [4.138574328202671, -3.5903219218803932],
            [4.14626267221184, -3.5937518347998085],
            [4.158530199751081, -3.58813591267613],
            [4.161560985785625, -3.584014066787158],
            [4.164174062386589, -3.5849278854710516],
            [4.162073447576778, -3.5928116580645253],
            [4.225235614432155, -3.5900362596337376],
            [4.226702411631477, -3.6350324631565605],
            [4.225126988260733, -3.635072908931533],
            [4.228135752027637, -3.7302516778457138],
            [4.228947167601791, -3.742089924123152],
            [4.225669680709399, -3.7441857930998506],
            [4.2224980159248915, -3.7435641614441972],
            [4.2188516393543445, -3.7389152477266294],
            [4.214221608553283, -3.741628390072153],
            [4.216974139151736, -3.7479066545442463],
            [4.225909845254509, -3.7467362036921648],
            [4.230310543841621, -3.7553890852625993],
            [4.23648720833895, -3.7623854056481587],
            [4.245532828744479, -3.7676039158223316],
            [4.248945004789037, -3.7652035348464987],
            [4.249799918891038, -3.7706353244339677],
            [4.243203877283275, -3.7752383903651947],
            [4.238077289614757, -3.7730343814438787],
            [4.2335239631629, -3.7758827047729118],
            [4.237095889848642, -3.780940323618178],
            [4.235149779218747, -3.7859363242897675],
            [4.23715020371448, -3.7889225769890356],
            [4.238527436389637, -3.7966165707351904],
            [4.236784608053798, -3.7998637574747054],
            [4.227941164769597, -3.801231047942384],
            [4.225092597822009, -3.809350956739007],
            [4.226258303588401, -3.814802619615814],
            [4.230859957364908, -3.8185942702906783],
            [4.232105988136961, -3.8609899082324204],
            [4.2329774148125585, -3.9063742035644298],
            [4.234631156275953, -3.949066509843773],
            [4.235277089937396, -3.9784016936222297],
            [4.176358406672515, -3.97966393219312],
            [4.177319799715527, -3.9942300205357877],
            [4.178439830521923, -4.038364309909238],
            [4.207518064463196, -4.037525347170279],
            [4.207943153539454, -4.052363020439983],
            [4.2370539963266705, -4.051918473245664],
            [4.237810873278997, -4.0814702550785125],
            [4.149601587235044, -4.083558054184551],
            [4.060863094558588, -4.085258180414664],
            [4.063727075158979, -4.173241940580676],
            [4.047364408303642, -4.1749762480549855],
            [4.020369929414119, -4.175491648999386],
            [4.005708752764909, -4.1747802846260855],
            [3.9964430749449082, -4.174912483457011],
            [3.99366306905123, -4.165894987924792],
            [3.9917074711925347, -4.1644689287117425],
            [3.997395536131088, -4.152078765311105],
            [3.996067966821703, -4.146818676686872],
            [3.9975150872379244, -4.143226154562762],
            [4.001219396369515, -4.141351778921386],
            [4.001633766319094, -4.137690320436734],
            [4.010282802250921, -4.127465597290179],
            [4.01849899767459, -4.121329980294952],
            [4.022308209821285, -4.11517064554727],
            [4.026064907160552, -4.113000577984319],
            [4.0290560380153755, -4.108438475566859],
            [4.028501188991649, -4.096930010885942],
            [4.029298180814896, -4.0925940989158],
            [4.0266681561571245, -4.088469616814958],
            [4.020456508758456, -4.085894122088224],
            [4.016363456391602, -4.08568061586423],
            [4.013822491341907, -4.088767312168844],
            [4.008406215423326, -4.082787294596717],
            [4.008316437378008, -4.078705345547325],
            [4.002750615646955, -4.076096977101762],
            [4.004738014908252, -4.069901977059583],
            [4.006193237094705, -4.055577755323755],
            [4.0113859847916915, -4.053057624144116],
            [4.01528570685204, -4.045969255950347],
            [4.014790847681558, -4.042365569031426],
            [4.019477731814464, -4.039034296740371],
            [4.022258785542938, -4.028977154438541],
            [4.020558527511118, -4.022478660875415],
            [4.016382931455243, -4.016184933958131],
            [4.0110608971125945, -4.011825043655487],
            [4.007099269646053, -4.012503257490231],
            [4.002792523431628, -4.010141316457955],
            [3.999849302316954, -4.006226965954245],
            [4.000098113942838, -4.002864916254404],
            [3.995811399974544, -3.9981909701469855],
            [3.991908827694702, -3.997787446918614],
            [3.9862147724986863, -3.992606009990509],
            [3.980780504200277, -3.9906393168313246],
            [3.9788854262769573, -3.9860855716345376],
            [3.9723039816825914, -3.987251189534853],
            [3.9693524642642024, -3.9847203922430574],
            [3.967783317571583, -3.929816850065178],
            [3.9670308449837632, -3.896990204389116],
            [3.966364746470568, -3.8541385472750957],
            [3.965442240246483, -3.816433480516493],
            [3.9655882500513626, -3.812024340629982],
            [3.9648090993658722, -3.7724399807788127],
            [3.963805324655789, -3.7356711760551935],
            [3.874374727760548, -3.737732460167611],
            [3.870483434393164, -3.627918519656977]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.5528265176102, "lat": 34.82973526685225 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05117"],
        "coty_name": ["Prairie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prairie County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00069176"
      },
      "bbox": [
        3.87016718821289, -4.175491648999386, 4.249799918891038,
        -3.5562890384218413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.77493513392873, -0.4781659237681048],
            [-18.521680653260184, -0.5440010382109912],
            [-18.432733610740105, -0.56628765802061],
            [-18.416539822280075, -0.5709255249833187],
            [-18.353406380428368, -0.5864488031846616],
            [-18.263838423651165, -0.6087107143274689],
            [-18.177829674872612, -0.6302212659612216],
            [-18.067169103090333, -0.6576964842890758],
            [-17.990507786791408, -0.676620743606448],
            [-17.933715976728248, -0.6905226694478294],
            [-17.829886071030074, -0.7162064413438095],
            [-17.780407839496633, -0.7286370492572098],
            [-17.68990748153463, -0.7511775494762926],
            [-17.64529861471996, -0.7620697451552525],
            [-17.595235961349648, -0.7745002645715636],
            [-17.509087772861005, -0.7956356338414002],
            [-17.413228207689468, -0.8160282407516097],
            [-17.38113807760638, -0.8243550782762051],
            [-17.345012756017734, -0.834598361427687],
            [-17.215378229927566, -0.8654453720752693],
            [-17.108522585698438, -0.8896205200483555],
            [-17.069345519258032, -0.9015002197446348],
            [-17.003284272046063, -0.9193746995098607],
            [-17.001688925828503, -0.9076506429772727],
            [-16.92817569553233, -0.9249602541070582],
            [-16.92108104035555, -0.9270982810099642],
            [-16.774769947984662, -0.9612983508373399],
            [-16.774854319764774, -0.9616910262578816],
            [-16.794789127441756, -1.0476233430138164],
            [-16.80875255650796, -1.0443590185247422],
            [-16.815419065944734, -1.072938166023757],
            [-16.78746841964291, -1.0794985080270056],
            [-16.794083943241592, -1.1080771736477506],
            [-16.808250042539477, -1.1055889098348073],
            [-16.817894105497814, -1.1475859281102676],
            [-16.821723858494078, -1.1620806375275143],
            [-16.82816591995102, -1.1906420092158954],
            [-16.82460808164407, -1.1914700321972773],
            [-16.846631913312955, -1.287940044818932],
            [-16.850408694026505, -1.302337081178289],
            [-16.853116696565742, -1.3017089978865823],
            [-16.85700858529193, -1.3182740364352528],
            [-16.85850386217652, -1.3334307469445843],
            [-16.862615099396944, -1.3469565147766853],
            [-16.86469846653981, -1.3574523505626637],
            [-16.87372920258425, -1.39940439410398],
            [-16.89160099078452, -1.4762759409531214],
            [-16.897447061183104, -1.502678118305044],
            [-16.91235952588605, -1.5660667116668532],
            [-16.924637246961375, -1.619186844376775],
            [-16.931458087653425, -1.6498074319884959],
            [-16.93337305591033, -1.649411686070617],
            [-16.94550966650663, -1.7033862753995233],
            [-16.956832637968525, -1.7543973858733288],
            [-16.958856384472398, -1.7618064642035294],
            [-16.995118606591564, -1.9199608358225724],
            [-17.023061409699565, -1.9132211137780173],
            [-17.10765465727283, -1.8927557131136663],
            [-17.220687208427982, -1.8670996131064834],
            [-17.30529698545959, -1.8475965879577685],
            [-17.42199934171502, -1.8216877698066771],
            [-17.461537784674295, -1.8126761627725299],
            [-17.51730173970013, -1.7994174337113775],
            [-17.54575609435862, -1.793007326531224],
            [-17.72076000632627, -1.7523035251921604],
            [-17.752933329967455, -1.7446641004646775],
            [-17.83467571253882, -1.72499973691432],
            [-17.95006822444364, -1.6974471513670022],
            [-17.963799590615473, -1.6938961926856944],
            [-17.96734192573608, -1.7079775357211284],
            [-17.98523950281963, -1.7036675489454356],
            [-17.9882893008396, -1.6982955068911925],
            [-17.98870897676692, -1.692276573148359],
            [-17.98464105673396, -1.6886199542285465],
            [-17.99585140991569, -1.6857342605351353],
            [-17.991649616679172, -1.7171933594131519],
            [-18.040718399364295, -1.704008235314653],
            [-18.068572411892056, -1.6970777340602428],
            [-18.063208195101996, -1.675659564407069],
            [-18.099263405428157, -1.666027355933216],
            [-18.158847177026644, -1.6507839178592187],
            [-18.21607790441273, -1.6358684337731664],
            [-18.27167779580575, -1.6212580260296985],
            [-18.261149203845463, -1.5789246562772032],
            [-18.28859212214932, -1.572400047324761],
            [-18.2842368946314, -1.5576974172033013],
            [-18.34664667375247, -1.542020970040162],
            [-18.3463628671315, -1.5409031632135108],
            [-18.367059973078433, -1.5353888812540597],
            [-18.366554655857268, -1.529630736985466],
            [-18.36193133737418, -1.5087923243093568],
            [-18.40915535906521, -1.4965537370411237],
            [-18.431818588568447, -1.490630448786399],
            [-18.423668032112744, -1.4547221231569485],
            [-18.388645924299247, -1.3192456905491434],
            [-18.402794777908802, -1.3156677028519612],
            [-18.3989764988799, -1.30106570683386],
            [-18.456055152263357, -1.2906128256055713],
            [-18.426981302919234, -1.2019649398716117],
            [-18.44064669540593, -1.198393323034648],
            [-18.517392530613037, -1.1843852058955235],
            [-18.49503776885015, -1.098854249277353],
            [-18.606788766611356, -1.0692520550291338],
            [-18.58481566531682, -0.98403746836184],
            [-18.626096133371615, -0.9731847445388166],
            [-18.64048884210464, -0.969579892572322],
            [-18.62150831235562, -0.8976154897761135],
            [-18.618170567047706, -0.8836519122917611],
            [-18.70654143400941, -0.8605646211026632],
            [-18.702801557875457, -0.8460999045999079],
            [-18.702533809992357, -0.8311373417212162],
            [-18.716307489272538, -0.8274473670681018],
            [-18.712004161116056, -0.8133902296453434],
            [-18.72648354335087, -0.8095455158744764],
            [-18.722865791365823, -0.7950621221208242],
            [-18.73686935337062, -0.7914905575076648],
            [-18.733195837694932, -0.776999451593429],
            [-18.74727999589743, -0.7734896411018704],
            [-18.743657664000178, -0.7602345496524427],
            [-18.757736351314826, -0.7567202151678304],
            [-18.735025919918122, -0.6709239891923212],
            [-18.819100338131747, -0.6491083881916172],
            [-18.790501427737148, -0.5396701119720356],
            [-18.77493513392873, -0.4781659237681048]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.73006688890698,
          "lat": 35.34264675146148
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06029"],
        "coty_name": ["Kern"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kern County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "02054176"
      },
      "bbox": [
        -18.819100338131747, -1.9199608358225724, -16.774769947984662,
        -0.4781659237681048
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.792061902960317, 3.7685412339901525],
            [-19.784324156455874, 3.766939350298573],
            [-19.75045107397382, 3.7560170006235],
            [-19.73944969506313, 3.754657853373533],
            [-19.72291802818141, 3.7481136098486916],
            [-19.709466010650093, 3.743961413165004],
            [-19.695379720499627, 3.7417260472124356],
            [-19.682108748624774, 3.7373308043717683],
            [-19.692458417616805, 3.701938176373668],
            [-19.702996205226846, 3.667694491574437],
            [-19.703863991330625, 3.653389215852229],
            [-19.70662035765679, 3.6418754328122467],
            [-19.716281036755422, 3.6109608009384844],
            [-19.727354112992856, 3.597874399330455],
            [-19.739943910887302, 3.5470082447397484],
            [-19.77387895581625, 3.556500304127168],
            [-19.770327308988815, 3.551657073751359],
            [-19.76813997145455, 3.546354385935623],
            [-19.763896570097668, 3.544182728143154],
            [-19.75921169359849, 3.546839867036842],
            [-19.754228654399785, 3.5431662367673438],
            [-19.753196692530686, 3.5375276179920045],
            [-19.747437944703343, 3.5332952126257267],
            [-19.748728411615033, 3.523985678789404],
            [-19.752508230872333, 3.522265264891259],
            [-19.759883478524586, 3.5140411211207607],
            [-19.770618301790925, 3.5133576650759064],
            [-19.772435598809388, 3.5057751387939704],
            [-19.77603066634889, 3.5027527862005763],
            [-19.777657828707454, 3.4972907831517275],
            [-19.781189906368557, 3.496721707803969],
            [-19.782754662287065, 3.4919161318275593],
            [-19.786404575526618, 3.4862589204254895],
            [-19.783613599562514, 3.482786166562708],
            [-19.782924521402208, 3.4731534710235326],
            [-19.779091365480213, 3.4646187572551006],
            [-19.78096221714049, 3.4550465121502096],
            [-19.77587795127335, 3.448092802273165],
            [-19.770174557384593, 3.4421904731125954],
            [-19.768153952525353, 3.438362138254629],
            [-19.76381649531722, 3.4387486074916698],
            [-19.76063397305031, 3.4308545206049157],
            [-19.757032546642762, 3.425729768113279],
            [-19.755724829732163, 3.419133870616017],
            [-19.751457338540654, 3.4156322858461783],
            [-19.74683858660041, 3.4091024593283947],
            [-19.742861270299723, 3.405381034148595],
            [-19.741295385685152, 3.398341230916778],
            [-19.737605661663817, 3.394737719396848],
            [-19.73934046049732, 3.390868596796306],
            [-19.736270148314865, 3.38529238314668],
            [-19.739933355917316, 3.3829494166593173],
            [-19.734503021237508, 3.378583141539964],
            [-19.73205176580553, 3.370927302101839],
            [-19.72630886592917, 3.3662088274798734],
            [-19.72183835577742, 3.3641871818665323],
            [-19.711246918805728, 3.3675090084994896],
            [-19.708008313428927, 3.369934416489183],
            [-19.69890574194597, 3.3673050629886454],
            [-19.69259208688971, 3.3609116410901927],
            [-19.691746573032095, 3.3578868105726243],
            [-19.686161622168548, 3.3542160232447267],
            [-19.67997583019873, 3.352578709278755],
            [-19.679021216147817, 3.350352353593269],
            [-19.672743512147417, 3.348379017273641],
            [-19.67026282457581, 3.345960675946951],
            [-19.667954629077, 3.3386163971946217],
            [-19.663524166384246, 3.3367311576848997],
            [-19.652402237562637, 3.3367346472999317],
            [-19.643596975266274, 3.334393779452875],
            [-19.640552582995184, 3.3365230729160484],
            [-19.633039607676242, 3.336084136738173],
            [-19.623710134661515, 3.331115272614365],
            [-19.625681370222072, 3.3257701690305286],
            [-19.62624345852092, 3.317992315739868],
            [-19.623851371958814, 3.311347087482231],
            [-19.616355181707053, 3.3100116521671046],
            [-19.614836916910203, 3.3016510214684005],
            [-19.616624188751654, 3.296466904444176],
            [-19.605431513901898, 3.2889212104966474],
            [-19.605079102147844, 3.2848347923324077],
            [-19.607153152498878, 3.282172945079967],
            [-19.6123933720166, 3.279353333786299],
            [-19.611460554477784, 3.2705311741322523],
            [-19.612640390549885, 3.262667699234247],
            [-19.61152211704085, 3.259994786331768],
            [-19.617890582192018, 3.2552106204352715],
            [-19.622303216841, 3.25982174793656],
            [-19.626553781663816, 3.2587946191504917],
            [-19.631242382174786, 3.253980045314483],
            [-19.633660876258045, 3.247498691545377],
            [-19.637560465245343, 3.242665228046387],
            [-19.634274367720135, 3.2354362632076383],
            [-19.637959040863407, 3.228874102772643],
            [-19.635319229790003, 3.2195893065307986],
            [-19.63642382516275, 3.205621355678241],
            [-19.637425999510533, 3.2022274411844913],
            [-19.642044274086693, 3.1980506121390357],
            [-19.64237389397401, 3.1909509193667556],
            [-19.64000845436973, 3.1866200528226893],
            [-19.64518146622223, 3.1844060575751874],
            [-19.64824700110821, 3.1811874398553868],
            [-19.649357752127667, 3.1746494298900223],
            [-19.642321777337028, 3.1723677945649764],
            [-19.631720364213564, 3.1642659319798994],
            [-19.63455959874656, 3.1617936178938106],
            [-19.631555369173757, 3.155972530125334],
            [-19.62879516986727, 3.1540964743886697],
            [-19.62461038824254, 3.1462656815070287],
            [-19.62111743640224, 3.1376796284808783],
            [-19.61820194891475, 3.1325884225345524],
            [-19.61569495400317, 3.1330887581256706],
            [-19.608879062327794, 3.1289557853141647],
            [-19.600852103205654, 3.12644956555126],
            [-19.59905980072574, 3.1231074081259953],
            [-19.6009301148066, 3.112985601970411],
            [-19.60392732082611, 3.111464744330655],
            [-19.605858785822157, 3.10472655932593],
            [-19.610837504746844, 3.099197151645492],
            [-19.6138134759333, 3.0975991189580707],
            [-19.614957553365855, 3.0864678971847934],
            [-19.61009971814126, 3.079615494001912],
            [-19.60993404753907, 3.07571015516174],
            [-19.61358895683469, 3.07009158274697],
            [-19.60887809803817, 3.060718076753873],
            [-19.604390680866665, 3.059722537775598],
            [-19.597651208486887, 3.0488985275990945],
            [-19.5931977717707, 3.0399817440468664],
            [-19.589384098272248, 3.0380752334762477],
            [-19.583078301335917, 3.0288183849158905],
            [-19.579272845657755, 3.024449353840868],
            [-19.57328507601801, 3.0210383202085236],
            [-19.57315909865779, 3.0179625400886905],
            [-19.58367677672488, 3.021977373249996],
            [-19.620126364301466, 3.032414595016585],
            [-19.626374782096747, 3.027131747678809],
            [-19.63382278972429, 3.017846950059695],
            [-19.63939866737037, 3.015342386269811],
            [-19.640303409687444, 3.0125804323702794],
            [-19.636539139542272, 3.007531720162907],
            [-19.635350020959216, 2.9991234751570555],
            [-19.632705910134074, 2.9920791970903293],
            [-19.634164610330394, 2.9893071585063646],
            [-19.62872051727691, 2.981148096893553],
            [-19.62887059975949, 2.977701411963952],
            [-19.626267099545878, 2.974058018157032],
            [-19.63069993455888, 2.9711584380664524],
            [-19.637317544353213, 2.9644311818947346],
            [-19.633795104808268, 2.9462743245795435],
            [-19.631783150893146, 2.9415778283180862],
            [-19.629072454611478, 2.9394443943356885],
            [-19.626293943728744, 2.930542630999036],
            [-19.628167278703433, 2.9281292963664027],
            [-19.6276868945286, 2.920747468366509],
            [-19.631581748553035, 2.9127690760250196],
            [-19.636182811114473, 2.907968375313229],
            [-19.64354582471472, 2.910357462432928],
            [-19.648527553688517, 2.9143405647307605],
            [-19.655230018490208, 2.909898952901397],
            [-19.659034990373748, 2.905819330825883],
            [-19.663338851908698, 2.898692972862332],
            [-19.66209507065649, 2.8969061976784354],
            [-19.665189164277496, 2.8888048852041313],
            [-19.665457047408086, 2.8842964701980023],
            [-19.672489711811785, 2.882617224028123],
            [-19.68560245303566, 2.870409052486494],
            [-19.72553055736492, 2.8326469095793474],
            [-19.856237813412402, 2.8329951475569364],
            [-19.854254672740193, 2.836226265535887],
            [-19.857761345068305, 2.8454111622992375],
            [-19.857481426636365, 2.8485713367660854],
            [-19.860587674901666, 2.8534269749376384],
            [-19.858756135667484, 2.8566112121407294],
            [-19.859095690424645, 2.8615949987047222],
            [-19.861006144521504, 2.86394096190965],
            [-19.861058086417582, 2.8715276216653347],
            [-19.866410057835694, 2.8739411862424533],
            [-19.872725227734104, 2.8746352179679353],
            [-19.877401528444935, 2.878531346547976],
            [-19.8801619909613, 2.8771261918229385],
            [-19.883021866276025, 2.8797463395522516],
            [-19.893338581753387, 2.8858243402051817],
            [-19.8953863938358, 2.8938369662922065],
            [-19.89405582539743, 2.895636683498129],
            [-19.89507047941248, 2.9051317590495715],
            [-19.90118903624385, 2.9102709009054553],
            [-19.899796926702713, 2.9205166792486863],
            [-19.89598722683913, 2.9238003773094023],
            [-19.89693702573892, 2.928652480215091],
            [-19.902379780738787, 2.933141918386346],
            [-19.90251677464158, 2.943228264633191],
            [-19.904589024426066, 2.9517894562953715],
            [-19.908229280527443, 2.956825242741915],
            [-19.90687416489518, 2.959989272969288],
            [-19.908410972436304, 2.9645987494653396],
            [-19.91074979962453, 2.9657807791891675],
            [-19.91365076533208, 2.9723440461162616],
            [-19.908939732892765, 2.9830054856147648],
            [-19.909440176606555, 2.988337241316044],
            [-19.916416039956083, 2.994799073192742],
            [-19.916413278288225, 2.9970109574905175],
            [-19.920849812744315, 3.004663087456559],
            [-19.922172803891193, 3.0102161005870824],
            [-19.92391745684416, 3.0109480791599466],
            [-19.926398001515086, 3.0170142895180967],
            [-19.930664706341766, 3.018768454385865],
            [-19.933691348744176, 3.0228872902638257],
            [-19.935124945148292, 3.028991444563603],
            [-19.938078527361917, 3.031030959542118],
            [-19.944751043184898, 3.0326099005890583],
            [-19.94678420902009, 3.0350553656746597],
            [-19.94599921540311, 3.039932182998341],
            [-19.949661050643545, 3.04236841975882],
            [-19.947692786403838, 3.047314201388782],
            [-19.950527677666543, 3.04845091271181],
            [-19.948189050478874, 3.055941164127213],
            [-19.962027755941715, 3.0600259394222027],
            [-19.959690387723803, 3.0677799315929866],
            [-19.973435128218192, 3.0715799830277213],
            [-19.970809968432516, 3.0786005428291836],
            [-19.98471942280228, 3.082497316031948],
            [-19.98195953636076, 3.0897883133965283],
            [-19.99597786862282, 3.0938517908497913],
            [-19.991286030568837, 3.1079155989537983],
            [-20.004312397879144, 3.111328299635038],
            [-20.002541847959396, 3.1174898005838223],
            [-20.019078644446004, 3.12218195649884],
            [-20.03064720087246, 3.1242868441204443],
            [-20.028830426564088, 3.133763646656679],
            [-20.02367227958511, 3.1487429462802905],
            [-20.033136847624906, 3.1515698615417596],
            [-20.029911661402124, 3.1579377121601793],
            [-20.037055696457276, 3.160221314316742],
            [-20.033780326330536, 3.1671466829228425],
            [-20.031935007411164, 3.1732671058485655],
            [-20.038852419061953, 3.1754779770215107],
            [-20.028405534935096, 3.2104565899299313],
            [-20.035214177600313, 3.2125545045434634],
            [-20.031145082121032, 3.226358141997369],
            [-20.048019491319316, 3.23066779332342],
            [-20.049025000031126, 3.2272581252739196],
            [-20.055969748391682, 3.229051627131852],
            [-20.054968924805056, 3.232600230877791],
            [-20.061926423339692, 3.234609273755566],
            [-20.059103519839425, 3.244185752979322],
            [-20.06597266208909, 3.2461917776185376],
            [-20.064080945922157, 3.253201194766978],
            [-20.070922164566156, 3.2553027159226424],
            [-20.06905734376338, 3.2622148971107543],
            [-20.075795916785392, 3.2643932336917563],
            [-20.067555425369076, 3.292232126532282],
            [-20.074245612801516, 3.294291934681468],
            [-20.070089452509777, 3.3081988725716247],
            [-20.083860695987937, 3.312330821717802],
            [-20.08171496263242, 3.3193704462731812],
            [-20.08852171174646, 3.32157144329201],
            [-20.086980846182332, 3.3300798035122345],
            [-20.082790870788987, 3.3443668637193755],
            [-20.076004099101294, 3.3423817195469576],
            [-20.07195112138578, 3.356739038536403],
            [-20.07371102981573, 3.3572369398023136],
            [-20.069224457365188, 3.3714902520536993],
            [-20.065614553627622, 3.384606045682905],
            [-20.05858547886267, 3.38291612339188],
            [-20.048418334311666, 3.416752496293941],
            [-20.024919766559314, 3.4095730900546783],
            [-20.022613222934986, 3.416352678374675],
            [-20.01926842351941, 3.415482213590431],
            [-20.015334666931544, 3.426722732375391],
            [-20.01145830536866, 3.4254873434152215],
            [-20.008874668348504, 3.4323969737450706],
            [-20.005660970474064, 3.4313552162953815],
            [-20.00295829536912, 3.438124036597194],
            [-19.9995581880605, 3.4374470160100308],
            [-19.997541705512845, 3.4437881469449527],
            [-19.995331792676033, 3.443143498258305],
            [-19.993128617550582, 3.449850075920381],
            [-19.98693008073366, 3.448357306834872],
            [-19.982774787915954, 3.463102277703124],
            [-19.96968836085827, 3.459010596444463],
            [-19.96353331553767, 3.479086905203723],
            [-19.970074066595615, 3.4816544125058564],
            [-19.96485328592641, 3.50196769249823],
            [-19.976022385555392, 3.5050132517209662],
            [-19.963693647877264, 3.547395986590404],
            [-19.970314170467994, 3.549327149160031],
            [-19.96613432371861, 3.5636428224310803],
            [-19.97285385123496, 3.56518467256668],
            [-19.965154223383333, 3.5920152822084632],
            [-19.97296222253467, 3.5945033041758703],
            [-19.968044043867017, 3.608288562767743],
            [-19.97507062904188, 3.6104452586324607],
            [-19.9662903209376, 3.6382170034778736],
            [-19.980071742092736, 3.642348039823661],
            [-19.97542807420889, 3.6560022953248015],
            [-19.9717270585838, 3.670245575556333],
            [-19.96823101163369, 3.6691190431581835],
            [-19.965838260286922, 3.685424780672894],
            [-19.958480581166263, 3.6830653063184657],
            [-19.944124307046767, 3.7324616579348673],
            [-19.930328899725968, 3.728482070879348],
            [-19.928212097080667, 3.735856187057718],
            [-19.9142615562221, 3.7317293693823705],
            [-19.91199078149827, 3.739003944411489],
            [-19.904183599898165, 3.7372448529896416],
            [-19.89104270887611, 3.732040658139837],
            [-19.84768954401946, 3.7178561165932376],
            [-19.843647518878537, 3.731702058310658],
            [-19.832840076446878, 3.7276145828229588],
            [-19.817944948287167, 3.723146039453885],
            [-19.810095154745223, 3.7201769254569177],
            [-19.807658967101045, 3.726990441551181],
            [-19.79659994220026, 3.754158312428392],
            [-19.792061902960317, 3.7685412339901525]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.7533462170542,
          "lat": 39.100048518835735
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06033"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00277281"
      },
      "bbox": [
        -20.08852171174646, 2.8326469095793474, -19.57315909865779,
        3.7685412339901525
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-19.90356529938085, 1.9646655161060036],
              [-19.8998779701478, 1.9655445208791662],
              [-19.896621731386716, 1.9635556974253296],
              [-19.89460328581145, 1.9539673293958935],
              [-19.89669802738904, 1.9505485908772502],
              [-19.89382207868061, 1.9449116764504435],
              [-19.897301598406035, 1.9393443080650232],
              [-19.90200571177254, 1.940053329113315],
              [-19.905286628691446, 1.9448058698999349],
              [-19.903111505859183, 1.9479655278850825],
              [-19.905516230474685, 1.9614820153963657],
              [-19.90356529938085, 1.9646655161060036]
            ]
          ],
          [
            [
              [-19.94920194662777, 1.8494293145342313],
              [-19.98526069000517, 1.8597583530729134],
              [-20.03138560860325, 1.8727541922327986],
              [-20.03010449615867, 1.8887628878632512],
              [-20.02025116486741, 1.9458858467277067],
              [-20.01126907486943, 1.95117071089448],
              [-20.002025781236235, 1.9481241334962056],
              [-19.995933759378307, 1.9492161979158267],
              [-19.98884378687183, 1.9583833240730886],
              [-19.985284609088172, 1.9647767972393602],
              [-19.979610819547997, 1.9633619174747368],
              [-19.97549600488266, 1.9580955946367622],
              [-19.94166705176817, 1.9525293757188924],
              [-19.93349432871072, 1.9505663134846596],
              [-19.92859916575662, 1.9436286949248258],
              [-19.92260786710167, 1.9263792366048873],
              [-19.92593196036312, 1.9147222349680728],
              [-19.926306692466273, 1.9064061113196895],
              [-19.92893884220982, 1.9018424474919473],
              [-19.926291227957943, 1.898092220457587],
              [-19.927108420639314, 1.8925015925994733],
              [-19.924411159845047, 1.8883407433614137],
              [-19.92515233657592, 1.884826298023593],
              [-19.92110111193576, 1.8749198517977923],
              [-19.92581985381118, 1.8756250156896008],
              [-19.92843185545951, 1.8722601341073408],
              [-19.91788906533459, 1.8618443220407161],
              [-19.922982702460164, 1.8564506065117732],
              [-19.92540435003978, 1.85117493285965],
              [-19.93414936626571, 1.8619695777804777],
              [-19.93810895261357, 1.8593537558053845],
              [-19.933952825809282, 1.8531979543865442],
              [-19.938450059523458, 1.8490969059770952],
              [-19.938552627568885, 1.8468110065041177],
              [-19.947411440514486, 1.8504802463388599],
              [-19.94920194662777, 1.8494293145342313]
            ]
          ],
          [
            [
              [-20.41853392346303, 1.9764896170833204],
              [-20.414323313660848, 1.9737758573923112],
              [-20.413239226659783, 1.976820692024235],
              [-20.40956143660032, 1.9781191696108607],
              [-20.40795601972851, 1.9703353042140057],
              [-20.41232563194845, 1.966666902534834],
              [-20.41499616835434, 1.970808642936184],
              [-20.41876942804218, 1.9725031194129368],
              [-20.41853392346303, 1.9764896170833204]
            ]
          ],
          [
            [
              [-19.880897885575667, 1.9126866366418784],
              [-19.879768047480056, 1.906388136410378],
              [-19.882605790387498, 1.9078893827215717],
              [-19.880897885575667, 1.9126866366418784]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.44487503940881,
          "lat": 37.75550705355813
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06075"],
        "coty_name": ["San Francisco"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Francisco County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00277302"
      },
      "bbox": [
        -20.41876942804218, 1.8468110065041177, -19.879768047480056,
        1.9781191696108607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.12010312557125, 0.10224259515520481],
            [-17.113837949722758, 0.09685929229600698],
            [-17.109460866247435, 0.08480610759563684],
            [-17.1076284412966, 0.08291384508251284],
            [-17.107683371991286, 0.07347985727875636],
            [-17.109368996908113, 0.058934275874651706],
            [-17.115265414100918, 0.0568165261774445],
            [-17.120752862164014, 0.052317227937591956],
            [-17.125014455753263, 0.05157333557215215],
            [-17.130309815072597, 0.053672895245318514],
            [-17.13696797526538, 0.051195142372837794],
            [-17.136292505555325, 0.04711396797748593],
            [-17.128814582479325, 0.04116783154816553],
            [-17.126191631341577, 0.032337903792349146],
            [-17.127061880174256, 0.028705213847041427],
            [-17.12109610706114, 0.027691560229609096],
            [-17.11637974933568, 0.0252127156983475],
            [-17.11437610979065, 0.01967956757572237],
            [-17.120383290726934, 0.015997686339996087],
            [-17.123850010665688, 0.01039142520715276],
            [-17.11778305533453, 0.001256999104160763],
            [-17.115753177663752, -0.00016308797999037928],
            [-17.11429167926558, -0.010789756122312064],
            [-17.117074393251723, -0.020712238635620703],
            [-17.109990967862903, -0.024586565143705785],
            [-17.11008298682319, -0.02736725849036487],
            [-17.104550603277325, -0.03294594731065706],
            [-17.10516910320922, -0.03861094913728338],
            [-17.103100434114562, -0.04055861838063179],
            [-17.10329621272558, -0.04445621316647058],
            [-17.09934595587499, -0.04913693091181996],
            [-17.09204291857562, -0.0500510970326371],
            [-17.08831616925135, -0.05841418655711145],
            [-17.092118459013495, -0.06269599586622812],
            [-17.101002730646517, -0.06223472633521973],
            [-17.101871243524677, -0.06929298085791975],
            [-17.10679491814493, -0.07278639701654883],
            [-17.108326399748947, -0.07543055501277486],
            [-17.105726794160287, -0.07926940898950374],
            [-17.108723889288612, -0.08291275098685459],
            [-17.10971629939196, -0.09357421853680707],
            [-17.101923433345377, -0.09896465468394473],
            [-17.09951915313723, -0.1043131685502508],
            [-17.091854443023472, -0.10510482806300667],
            [-17.088434067851466, -0.11443153943624138],
            [-17.083760871880813, -0.11679168006524873],
            [-17.083330035956852, -0.12665013465766511],
            [-17.08677349779456, -0.1331976000875411],
            [-17.08463555387582, -0.13796252871138961],
            [-17.07802665478966, -0.1373586572225066],
            [-17.081707008705784, -0.15142578214496139],
            [-17.08149597128054, -0.15500459277606304],
            [-17.08540960205393, -0.16009096062779274],
            [-17.081925860212024, -0.16745936793150734],
            [-17.08580411209584, -0.16964841606661132],
            [-17.09437932990122, -0.17196278069801002],
            [-17.09611415024765, -0.17580411669492052],
            [-17.08963790765198, -0.18264095090965154],
            [-17.08589321749861, -0.19235446892165314],
            [-17.086478206724433, -0.19480947972939425],
            [-17.079493226120174, -0.20020936233579897],
            [-17.079008967488438, -0.2033341090262875],
            [-17.075780908197718, -0.2073186781456103],
            [-17.076488748313885, -0.21545181336977667],
            [-17.074144745249818, -0.22005683436361578],
            [-17.075678991964907, -0.22581400144207478],
            [-17.07947284626096, -0.22729754164748006],
            [-17.077223364714012, -0.23437048590791898],
            [-17.07228333443157, -0.23461227164584808],
            [-17.06554998351418, -0.2410911203867033],
            [-17.062245547577238, -0.24063183842305452],
            [-17.05839262843223, -0.24268934498331063],
            [-17.050924943986285, -0.24436058644592476],
            [-17.047363917459776, -0.24282029946729222],
            [-17.04200509514415, -0.2433670258350385],
            [-17.035745490621874, -0.2418446488791068],
            [-17.034856766006577, -0.24776212573084067],
            [-17.030243674942202, -0.25145095605465434],
            [-17.028631976615323, -0.25536097824518345],
            [-17.024336326645294, -0.2597001698078615],
            [-17.024795003018045, -0.26301506552284587],
            [-17.029576837382592, -0.27350047019252366],
            [-17.035296002253276, -0.27722710317993926],
            [-17.041689371739825, -0.27757707557830685],
            [-17.047121492982612, -0.2793998552181886],
            [-17.05042870115578, -0.28297207556684084],
            [-17.045610748921703, -0.28650249625894986],
            [-17.045101717718584, -0.29471594138465823],
            [-17.041012250809402, -0.29579039172016897],
            [-17.038700402613124, -0.29882899814569325],
            [-17.037553100822432, -0.30470359575850375],
            [-17.030079300694226, -0.30741013512713183],
            [-17.029994184365382, -0.31396514932014413],
            [-17.028628139517885, -0.31615643607749055],
            [-17.026857883193625, -0.32944007208530424],
            [-17.015367107980737, -0.33423758094225897],
            [-17.011895126372178, -0.33723831986697117],
            [-17.014641671267157, -0.3436418674670021],
            [-17.014344384351734, -0.3503512703339852],
            [-17.015766518801883, -0.354282117729836],
            [-17.022290495197826, -0.3560730454419555],
            [-17.02890186644268, -0.361089752428906],
            [-17.027806634447554, -0.365191663042583],
            [-17.028184720576103, -0.37103576618607936],
            [-17.032080226953305, -0.3730723391355479],
            [-17.037583183778555, -0.3719206078328271],
            [-17.038521657654467, -0.37761017167775857],
            [-17.042857231862467, -0.38004618188396894],
            [-17.04490560116999, -0.39102879965733006],
            [-17.047458613508525, -0.39375555923983196],
            [-17.048208980555824, -0.3975985279233576],
            [-17.044640921764568, -0.4004745623670199],
            [-17.04259967072604, -0.40773646399524965],
            [-17.044655420430367, -0.4156932494127415],
            [-17.04777192370069, -0.42269734294317063],
            [-17.045721615256863, -0.43119457394343264],
            [-17.045826311460218, -0.4392598211105653],
            [-17.04187266910639, -0.44683516968190695],
            [-17.043595585200052, -0.45202844515356405],
            [-17.046867844487373, -0.45405398946901504],
            [-17.046259136310237, -0.4577249853200315],
            [-17.04728956742184, -0.463808347671817],
            [-17.045075537083203, -0.4718011228156998],
            [-17.040304061570932, -0.4769762142394002],
            [-17.03903619373413, -0.48515830694955303],
            [-17.035255307892694, -0.48584568447142606],
            [-17.032320130773947, -0.48871834485412424],
            [-17.02764536239761, -0.4960473168028001],
            [-17.02676281644778, -0.49926384621118414],
            [-17.027275013270053, -0.5073363476746195],
            [-17.022070810574732, -0.5131301949449404],
            [-17.020921329092886, -0.5176541365020577],
            [-17.025369914050398, -0.5250034021864493],
            [-17.023567069004507, -0.5288510102935637],
            [-17.024602249466636, -0.5346216370841427],
            [-17.026512998474338, -0.5374888044239008],
            [-17.03087016423817, -0.5385330782100104],
            [-17.036641417827752, -0.5417318753526836],
            [-17.039275411049687, -0.545568669168246],
            [-17.03848209573941, -0.5512531156961591],
            [-17.039994633213873, -0.5555625298735266],
            [-17.038284156718035, -0.5598043616814745],
            [-17.038166470504677, -0.5662623035898915],
            [-17.039165855413437, -0.5753589482090532],
            [-17.042232315602604, -0.5765007467990912],
            [-17.041664786786377, -0.5814056058652077],
            [-17.04495949408087, -0.5915161652891557],
            [-17.04193797703375, -0.5964825173733073],
            [-17.03863049529913, -0.594671575725521],
            [-17.035472481912926, -0.601847602506978],
            [-17.035200163599114, -0.6111416243569501],
            [-17.03705682956261, -0.6141241801477842],
            [-17.040672422432202, -0.6276847305136047],
            [-17.0362079606471, -0.6401464007845357],
            [-17.04027857919578, -0.6472736048567868],
            [-17.037030050281945, -0.654781176406345],
            [-17.036672454051892, -0.6661675123230159],
            [-17.037703348279006, -0.6691387058146855],
            [-17.038295061707284, -0.6807165442576393],
            [-17.032770941377464, -0.6862716873701127],
            [-17.028203807629787, -0.6889045565441193],
            [-17.023961628129, -0.6951299622252392],
            [-17.024385275639442, -0.7018329794640269],
            [-17.021383369589337, -0.7046009918183862],
            [-17.020707782736558, -0.7110217768988998],
            [-17.023572115443464, -0.7173462915899534],
            [-17.026702100757593, -0.7153527393758486],
            [-17.030860561279347, -0.723137730880454],
            [-17.037419749364865, -0.7306601512083475],
            [-17.03777762829579, -0.7372385832263901],
            [-17.033301494714713, -0.7382423592340714],
            [-17.03342272087309, -0.7444244068546381],
            [-17.03191066702536, -0.7469872635091704],
            [-17.02681440480842, -0.7481418858306931],
            [-17.0208752988955, -0.7523997773179835],
            [-17.02023518664246, -0.7576338740535326],
            [-17.017979082445084, -0.7630629329087466],
            [-17.0192564135863, -0.7648148692239597],
            [-17.01809695808811, -0.7708947574302696],
            [-17.023871123315462, -0.7788924986414067],
            [-17.02583897597475, -0.7801064224783979],
            [-17.026889818385346, -0.7881746235029965],
            [-17.02462402178178, -0.7908698877507386],
            [-17.027375300337187, -0.7970290627158148],
            [-17.02457899134705, -0.8012653320623669],
            [-17.02818100554324, -0.8087885417845436],
            [-17.032390861668812, -0.8115343649938753],
            [-17.033232681925604, -0.8158426871327292],
            [-17.02971326486674, -0.8216705627465702],
            [-17.03014330270293, -0.8298991062088548],
            [-17.037815951795615, -0.8292210448832349],
            [-17.039377833353228, -0.8249260166282321],
            [-17.04316572933453, -0.8248929271058432],
            [-17.047417836325895, -0.8289562912277116],
            [-17.050225881680227, -0.8295353695310208],
            [-17.052867393450114, -0.837060420057767],
            [-17.052322581271138, -0.8408951840523644],
            [-17.054681989397086, -0.8486235120145458],
            [-17.05558223963133, -0.8558580775991792],
            [-17.058573160996172, -0.8624660302437954],
            [-17.054079685193855, -0.8689937518986195],
            [-17.056116747817835, -0.8721234485210141],
            [-17.062539590448203, -0.8739238188617916],
            [-17.063985515049325, -0.8809238500733834],
            [-17.067633537903088, -0.885885886488561],
            [-17.066490473386192, -0.8919038772340676],
            [-17.06887180602239, -0.895001975322092],
            [-17.069345519258032, -0.9015002197446348],
            [-17.108522585698438, -0.8896205200483555],
            [-17.215378229927566, -0.8654453720752693],
            [-17.345012756017734, -0.834598361427687],
            [-17.38113807760638, -0.8243550782762051],
            [-17.413228207689468, -0.8160282407516097],
            [-17.509087772861005, -0.7956356338414002],
            [-17.595235961349648, -0.7745002645715636],
            [-17.64529861471996, -0.7620697451552525],
            [-17.68990748153463, -0.7511775494762926],
            [-17.780407839496633, -0.7286370492572098],
            [-17.829886071030074, -0.7162064413438095],
            [-17.933715976728248, -0.6905226694478294],
            [-17.990507786791408, -0.676620743606448],
            [-18.067169103090333, -0.6576964842890758],
            [-18.177829674872612, -0.6302212659612216],
            [-18.263838423651165, -0.6087107143274689],
            [-18.227664606894056, -0.4670450245624226],
            [-18.22035342304225, -0.43916044651995184],
            [-18.219453277223387, -0.43932348517120573],
            [-18.20850442872799, -0.3964536097806718],
            [-18.193222165572102, -0.3354499414406605],
            [-18.19308080465143, -0.33388454913613064],
            [-18.17639523129269, -0.26856580856139595],
            [-18.170774578366974, -0.2699647564765409],
            [-18.138309747959962, -0.1408099423985652],
            [-18.124729472418696, -0.14498225900676184],
            [-18.0961126548323, -0.15232112126107236],
            [-18.088803590656052, -0.12411638745960685],
            [-18.085653428168143, -0.10879152546041486],
            [-18.07649314184352, -0.07174388802251265],
            [-18.06377409760434, -0.023133368455207113],
            [-18.105316349729712, -0.012113351709561753],
            [-18.083632616840983, 0.07203589504869828],
            [-18.08245774910609, 0.07313529046032691],
            [-18.11798575042577, 0.0820701149816566],
            [-18.108839347713104, 0.08726784080095448],
            [-18.098829400648878, 0.09394004235079154],
            [-18.082935813298192, 0.10378934224857506],
            [-18.065350901283452, 0.11401235607257938],
            [-18.047888802623238, 0.12473683780570123],
            [-18.03691532638548, 0.13226900790447427],
            [-18.014147877859834, 0.1458034383451258],
            [-17.972965940203164, 0.1354174071344837],
            [-17.890134172353886, 0.11308367811111049],
            [-17.8684739851061, 0.19807976284508633],
            [-17.8127711805937, 0.18423848972091067],
            [-17.79910189486404, 0.1799563851582058],
            [-17.768801298246814, 0.17141264085632402],
            [-17.75875297304509, 0.16898322754615755],
            [-17.728738781680374, 0.16097059974071706],
            [-17.702524426657558, 0.15353201404413352],
            [-17.68941557878134, 0.15106470643793593],
            [-17.645488553544702, 0.13925882786530208],
            [-17.622667824900596, 0.1334118568818813],
            [-17.600435771910952, 0.21579454197114506],
            [-17.559248627148158, 0.20518393091888898],
            [-17.42249127440314, 0.1698470955974819],
            [-17.27147908721937, 0.13284022945703394],
            [-17.270499795413972, 0.13842852179843915],
            [-17.12010312557125, 0.10224259515520481]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.80042535535668,
          "lat": 36.22016164222605
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06107"],
        "coty_name": ["Tulare"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tulare County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00277318"
      },
      "bbox": [
        -18.263838423651165, -0.9015002197446348, -17.011895126372178,
        0.21579454197114506
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-6.341189255217115, 1.3321317679851148],
              [-6.341815989797179, 1.3248497737810243],
              [-6.332376892801906, 1.32402495028627],
              [-6.332488943831898, 1.3276700419929697],
              [-6.330498186630337, 1.334049198728078],
              [-6.333636765696495, 1.3388033569647257],
              [-6.3404953587257395, 1.3394276467712443],
              [-6.341189255217115, 1.3321317679851148]
            ]
          ],
          [
            [
              [-6.333624156068414, 1.296533343386921],
              [-6.33066075764326, 1.2937741568547871],
              [-6.330371050572434, 1.2870482572012314],
              [-6.324662970474734, 1.2823262820411525],
              [-6.323997146318175, 1.2892815465086962],
              [-6.326219617387166, 1.2898331417304756],
              [-6.326550211523483, 1.299505156544011],
              [-6.329864844079948, 1.3024857510454573],
              [-6.3360041891389765, 1.302269266896893],
              [-6.333624156068414, 1.296533343386921]
            ]
          ],
          [
            [
              [-6.418223801898571, 1.4278762247424706],
              [-6.347700249336871, 1.4211366043940268],
              [-6.3437619845422555, 1.4244129237752667],
              [-6.332419150136816, 1.423317884099217],
              [-6.332310871809333, 1.419652152246256],
              [-6.322566970012058, 1.4187946727138567],
              [-6.3232314480056795, 1.4114834284507656],
              [-6.305359218780985, 1.4099140416008713],
              [-6.304082471425736, 1.4244917193057844],
              [-6.289622788260367, 1.4230651371670902],
              [-6.288205153175245, 1.4376192500073601],
              [-6.274311477621602, 1.436350900853725],
              [-6.275645987545966, 1.4218214233043482],
              [-6.247700949356294, 1.4188819191777238],
              [-6.218701167462458, 1.416381456817373],
              [-6.214614190832248, 1.4601317824076807],
              [-6.1929939005679095, 1.458116074145082],
              [-6.192630439780962, 1.4617321235747165],
              [-6.168920329756035, 1.4594007961964133],
              [-6.1637765442718235, 1.5104801049908962],
              [-6.143294390830819, 1.5084125792879488],
              [-6.142185991594512, 1.5194317161743998],
              [-6.133832128123574, 1.518589380284026],
              [-6.13309248304383, 1.5259444611001125],
              [-6.123668118158169, 1.5249169714081714],
              [-6.12437516762672, 1.5178820661212422],
              [-6.087526716259081, 1.514150531373253],
              [-6.0882043053520665, 1.5067623311264444],
              [-6.064483386160888, 1.5043506786162204],
              [-6.0662736913565904, 1.4865511519062022],
              [-6.070316852112971, 1.4869574895883921],
              [-6.071149056305384, 1.4786936572984628],
              [-6.0816593699412245, 1.4797557114861462],
              [-6.086793079439857, 1.4287545652890514],
              [-6.11374820451597, 1.4314007270121576],
              [-6.11467157287381, 1.4217526808780268],
              [-6.122802433916609, 1.4225724320103459],
              [-6.12181860844759, 1.432326390793226],
              [-6.19480828766618, 1.4396959136343463],
              [-6.197241298076515, 1.4145791285364209],
              [-6.175859128863878, 1.412615100430503],
              [-6.178831976212872, 1.383270315577594],
              [-6.201451108617736, 1.385334608487514],
              [-6.20121853307821, 1.3877247726712172],
              [-6.206993130035711, 1.388189970222765],
              [-6.206529662054985, 1.3931214171200164],
              [-6.213652381507234, 1.3938558351818833],
              [-6.214008702475504, 1.3901517286179434],
              [-6.235469910723208, 1.3921713145495547],
              [-6.249371700739623, 1.3930095878738984],
              [-6.249794273287453, 1.389787929587256],
              [-6.257025498346243, 1.38844814197987],
              [-6.2711332581164525, 1.3911956647501977],
              [-6.2720725558698405, 1.3806893305175096],
              [-6.266067308130753, 1.3783976549034223],
              [-6.265268159376533, 1.3765678597101425],
              [-6.29026883368775, 1.378869969304302],
              [-6.291128815460129, 1.3716294691879916],
              [-6.294557909300102, 1.3719903073003052],
              [-6.295233046371611, 1.3646442698974388],
              [-6.296542665156753, 1.354669952258078],
              [-6.294607139231112, 1.3491851136699342],
              [-6.289538738810273, 1.349334682842081],
              [-6.290098312928472, 1.3434431335990025],
              [-6.286643168381939, 1.3415640578574388],
              [-6.287417889431906, 1.3335268201271862],
              [-6.2838035157913685, 1.3340795162091421],
              [-6.2844817287750745, 1.3267993770971434],
              [-6.288555675284659, 1.321677349187841],
              [-6.285159372939249, 1.3195171066186104],
              [-6.3070178677122914, 1.3216033804519938],
              [-6.313497218531943, 1.324175851969688],
              [-6.314339754696574, 1.3149499063398022],
              [-6.310771904122831, 1.3146016968584056],
              [-6.310422149512451, 1.3182519701102575],
              [-6.3068711150030525, 1.3176531540769731],
              [-6.307508824188265, 1.3105991577265916],
              [-6.303919219353245, 1.3102523061103342],
              [-6.30424603143327, 1.3066059351569854],
              [-6.307842362460439, 1.3069483500504113],
              [-6.308548386702974, 1.3033598454623938],
              [-6.315300626439596, 1.3041386855834047],
              [-6.316389129161733, 1.2931183901177377],
              [-6.309422273739813, 1.2924278505462228],
              [-6.306580374684034, 1.2890416027664418],
              [-6.302385736708717, 1.2916716603972325],
              [-6.298325066605997, 1.28767795936274],
              [-6.295818619343805, 1.2876215980296375],
              [-6.294291190560381, 1.2982846427227666],
              [-6.290943931753744, 1.2979692913932652],
              [-6.287644348577465, 1.293690705306162],
              [-6.288850040748715, 1.2831231478171357],
              [-6.28133446385776, 1.2824519903308187],
              [-6.275544539783433, 1.280774129353875],
              [-6.275684425749335, 1.2786365479438717],
              [-6.28152934285999, 1.276187482385946],
              [-6.291509250864732, 1.2699519032058215],
              [-6.2973078462033625, 1.2683885039062803],
              [-6.2966079358570095, 1.2748866016065024],
              [-6.300017003291602, 1.2768184114552272],
              [-6.301269059185954, 1.2650296836620967],
              [-6.305128468805303, 1.2629973512526005],
              [-6.306634173332495, 1.2481185902808223],
              [-6.3280200578976, 1.250079812941729],
              [-6.32650462497522, 1.2647214527517694],
              [-6.332838457208377, 1.2725948489916823],
              [-6.339989767764811, 1.2732450544621432],
              [-6.339176999509951, 1.2804845277296955],
              [-6.356861415047289, 1.282095320145867],
              [-6.355603003006923, 1.2857227135001814],
              [-6.359928310192939, 1.2861395349564952],
              [-6.3594370533955775, 1.2909938723679235],
              [-6.366635925798303, 1.2905505984200736],
              [-6.366135442919058, 1.295999028297486],
              [-6.369513934125642, 1.2981888979486562],
              [-6.3899092065148695, 1.3001672594241378],
              [-6.392462777778416, 1.2992775490048682],
              [-6.393668083580308, 1.2931814574184601],
              [-6.398636132745926, 1.2936769081916415],
              [-6.394470916762348, 1.3005721882178398],
              [-6.3936034743550145, 1.3096723005163078],
              [-6.3951762913672905, 1.311715235058329],
              [-6.400508726101616, 1.3122800300626818],
              [-6.402325356425992, 1.29402874917909],
              [-6.4077795877315324, 1.294535604717286],
              [-6.4081487830682455, 1.2908282950343974],
              [-6.415436108577724, 1.2914068421674545],
              [-6.417303800482919, 1.288124147427038],
              [-6.418254333995682, 1.2785188327570516],
              [-6.414839778260427, 1.2767073660489987],
              [-6.4152056285421235, 1.273021977206466],
              [-6.418780355893552, 1.2733808859754683],
              [-6.4193364533871575, 1.2679436984090648],
              [-6.412365469265656, 1.2655238244939861],
              [-6.415723143208008, 1.2621405857245755],
              [-6.426972730243716, 1.2634635566368022],
              [-6.426628311808333, 1.266894553787653],
              [-6.4336655435740076, 1.2676150704366727],
              [-6.432916343508805, 1.2749091858463937],
              [-6.437248576403162, 1.2753129952833142],
              [-6.437950461975965, 1.2719486326348854],
              [-6.433891137334859, 1.2656314753599258],
              [-6.43403423008046, 1.2639978411606998],
              [-6.434417114880531, 1.2603363382652122],
              [-6.43476754182399, 1.2569342792193425],
              [-6.437386759370066, 1.2559426951452834],
              [-6.438970140965597, 1.250792153202027],
              [-6.468417153389, 1.2537189943573237],
              [-6.468063429834241, 1.2575860655895459],
              [-6.443817946682155, 1.2554860043653102],
              [-6.444357322552671, 1.2577404647363328],
              [-6.451612277847171, 1.2619525380715662],
              [-6.454234673614845, 1.2675117221130106],
              [-6.463115305616689, 1.2630276479911429],
              [-6.475454491218555, 1.2642325997014874],
              [-6.477016495354034, 1.2672892356455436],
              [-6.476207734069796, 1.2753085466074239],
              [-6.461949756642723, 1.273950637889368],
              [-6.461596963860086, 1.2776028087010194],
              [-6.450737539858564, 1.2765782072244882],
              [-6.446445979829965, 1.2833445451191603],
              [-6.439726598383352, 1.2828811202342942],
              [-6.4393576067137, 1.2865296810196296],
              [-6.444425333763892, 1.2873844666682808],
              [-6.442252351936764, 1.2905522317001168],
              [-6.44502765168497, 1.297538736391783],
              [-6.448660594411, 1.2972387970576036],
              [-6.4520232328099745, 1.3003425592870417],
              [-6.451165729545893, 1.308448188387081],
              [-6.44429058105597, 1.3053872873096808],
              [-6.4300655842487116, 1.3040494293058646],
              [-6.429365602573146, 1.3113338049202994],
              [-6.436481801828455, 1.3119844856555376],
              [-6.432121525608587, 1.3189310802611869],
              [-6.4286464570764705, 1.3186183268652105],
              [-6.4188735350264485, 1.4205736976413128],
              [-6.426050952219077, 1.4213102721279176],
              [-6.426679134920852, 1.4287015511931578],
              [-6.418223801898571, 1.4278762247424706]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.8757998559582,
          "lat": 39.761771221352475
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08031"],
        "coty_name": ["Denver"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Denver County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00198131"
      },
      "bbox": [
        -6.477016495354034, 1.2481185902808223, -6.064483386160888,
        1.5259444611001125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.381359885475707, 2.2119980690546406],
            [-9.363338628674226, 2.2095821969311964],
            [-9.232085202640112, 2.1918203964796383],
            [-9.100834741206498, 2.174036510207811],
            [-8.969587254687356, 2.15623054077658],
            [-8.838342753201236, 2.138402492234689],
            [-8.755578636961028, 2.1274819694147937],
            [-8.637084773835308, 2.1124063773450334],
            [-8.586451354360669, 2.1064804178223784],
            [-8.474014200928604, 2.092471847984601],
            [-8.447713558428172, 2.089393390913212],
            [-8.416174001593737, 2.085330745093525],
            [-8.416039463781111, 2.086417502872389],
            [-8.401699762911804, 2.084363740983071],
            [-8.333042579889774, 2.075894114617187],
            [-8.33290646551142, 2.0767134866346018],
            [-8.301553787872573, 2.0722253294677233],
            [-8.295044516374151, 2.0708833868900416],
            [-8.222747943794195, 2.059405719581299],
            [-8.214509754422762, 2.0578804357069598],
            [-8.172198282097222, 2.053224006329736],
            [-8.171854438784342, 2.056153356023649],
            [-8.050233901801997, 2.042575035104346],
            [-7.928615439765347, 2.028977860632031],
            [-7.913855911702615, 2.0272260511797295],
            [-7.913580233557641, 2.0281338820357604],
            [-7.898981733085267, 2.0256984391998705],
            [-7.870078177879855, 2.022332819189655],
            [-7.870016495912362, 2.0217256421533953],
            [-7.87728844481648, 1.9625512075199625],
            [-7.876753868982131, 1.9624604516401638],
            [-7.885172126037474, 1.8882271153919452],
            [-7.990482851477939, 1.9002767067937831],
            [-8.095795127291007, 1.9123126186348471],
            [-8.106301383602467, 1.8251933954052484],
            [-8.107922947156597, 1.8253903647776928],
            [-8.118195817788735, 1.736411356808314],
            [-8.203062757587755, 1.749413771194946],
            [-8.213961781512978, 1.6599415014133838],
            [-8.299142061729778, 1.6699847241963583],
            [-8.324657850586743, 1.673770363085043],
            [-8.411981543191342, 1.685900100878575],
            [-8.482820507652551, 1.6895479546156762],
            [-8.54959533744846, 1.697804347260672],
            [-8.597060800409302, 1.7038232183669466],
            [-8.61156724388214, 1.5902320757284514],
            [-8.613599333491578, 1.5731727740858559],
            [-8.618340991514597, 1.5735873921793782],
            [-8.660557808715144, 1.5790771950766678],
            [-8.670097163833953, 1.5810999222475133],
            [-8.684787622606066, 1.5822759181340447],
            [-8.698669780833647, 1.584742322251422],
            [-8.824755097813346, 1.6008262219694978],
            [-8.824933077741987, 1.5995449900769336],
            [-9.000824351005878, 1.6227618636241319],
            [-9.079550715332575, 1.6326844915389658],
            [-9.085258676550675, 1.5891918803506384],
            [-9.197641702510607, 1.6043869343746693],
            [-9.310026591981805, 1.6195680969510649],
            [-9.31467011286558, 1.6209828026142623],
            [-9.327998268784473, 1.6218831321479799],
            [-9.343102334584264, 1.6240842535637472],
            [-9.341698392973337, 1.6342285250846305],
            [-9.459074018911512, 1.6503271842902765],
            [-9.429118939720349, 1.8646374205922518],
            [-9.403903278523817, 2.0484419524975856],
            [-9.388184833088985, 2.1624617934500416],
            [-9.381359885475707, 2.2119980690546406]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.21707529871085,
          "lat": 39.97984337056586
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08103"],
        "coty_name": ["Rio Blanco"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rio Blanco County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00198167"
      },
      "bbox": [
        -9.459074018911512, 1.5731727740858559, -7.870016495912362,
        2.2119980690546406
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-6.339603815043274, 1.6656297220552532],
              [-6.334422777572188, 1.6651229296766394],
              [-6.334776242020152, 1.661584793529414],
              [-6.339947936337294, 1.6620481476310611],
              [-6.339603815043274, 1.6656297220552532]
            ]
          ],
          [
            [
              [-6.220535746314002, 2.6314978097201194],
              [-6.154886238636301, 2.62530309182903],
              [-6.1355671374760625, 2.6247386442670964],
              [-6.021001766054384, 2.6158757099714456],
              [-5.887604787161485, 2.6046847200818934],
              [-5.865661957523721, 2.602364174275008],
              [-5.793775888602429, 2.596056895800268],
              [-5.677027237787765, 2.5859697081892836],
              [-5.609091871367918, 2.5800907441235066],
              [-5.556656276441772, 2.5753996714605933],
              [-5.534341510586038, 2.573996044143012],
              [-5.530516122143584, 2.57339983232322],
              [-5.482264432809679, 2.5693188618833287],
              [-5.4470764537103555, 2.5661678276211304],
              [-5.439499969410966, 2.5659040680381766],
              [-5.411342174631236, 2.5634975563281133],
              [-5.330786142125657, 2.55725142965392],
              [-5.198971342171543, 2.5462750103555147],
              [-5.2005063378614365, 2.5229657241479035],
              [-5.202132202782118, 2.508150947979281],
              [-5.204959718063595, 2.469429918166971],
              [-5.205320842015557, 2.467281757451933],
              [-5.2121470249695765, 2.377791377349071],
              [-5.223422003923354, 2.2453323332634585],
              [-5.227972890626688, 2.245659246168137],
              [-5.236129616175452, 2.1539798471938183],
              [-5.24343553616359, 2.066256878265002],
              [-5.329234904288201, 2.071782651945235],
              [-5.3433942227491436, 2.073304548189677],
              [-5.495751352874425, 2.087392883373914],
              [-5.596007367111337, 2.0963071727717373],
              [-5.668295415285039, 2.102488458474947],
              [-5.6750449030402565, 2.015483757609668],
              [-5.674911158700944, 2.015304294006819],
              [-5.683131096908075, 1.9284262384740636],
              [-5.685429700803578, 1.9277401779159564],
              [-5.693703023605209, 1.8269713461468988],
              [-5.695350033628812, 1.8088275839128254],
              [-5.69953873980111, 1.7575876323075201],
              [-5.706034160413315, 1.6852154580418903],
              [-5.715502615664899, 1.5766465954633058],
              [-5.844623483822522, 1.5877415037661367],
              [-5.972191352528588, 1.5989197929979306],
              [-6.056951630989772, 1.6064735193809785],
              [-6.1849662323692955, 1.6181224730946773],
              [-6.257470513888434, 1.624784807260094],
              [-6.3287332383361825, 1.631452157616653],
              [-6.3243839230998695, 1.6754270208342428],
              [-6.337526277035122, 1.6764111294615311],
              [-6.338736938840358, 1.6747253254421073],
              [-6.340054034089554, 1.6619822057602587],
              [-6.344937582528156, 1.6623416214257996],
              [-6.345304473811924, 1.6588199453121197],
              [-6.35472234065651, 1.6596900287304661],
              [-6.353188791149743, 1.6531164064893835],
              [-6.355805032289796, 1.6487594621677015],
              [-6.348664103804974, 1.6480849842611238],
              [-6.349376296493791, 1.6408459206602737],
              [-6.3632497054484425, 1.6420635671007004],
              [-6.363860319200878, 1.6349293003567746],
              [-6.397824088474323, 1.6379387538782393],
              [-6.399861437095678, 1.638124228271589],
              [-6.386518065026961, 1.7766905246850828],
              [-6.382186977204692, 1.8204375212053951],
              [-6.3744316076203535, 1.9006826922629634],
              [-6.367422286260164, 1.9743540384515266],
              [-6.367261070217068, 1.9886184452642304],
              [-6.283678764936816, 1.9804994285465307],
              [-6.276662025364183, 2.045763370659249],
              [-6.270241771844498, 2.1110845946453525],
              [-6.266242927072829, 2.154721296777249],
              [-6.2549502471013305, 2.2711079489726216],
              [-6.253298418727623, 2.2855722962609155],
              [-6.248917235639745, 2.3289668894242452],
              [-6.249239956855288, 2.329011492878705],
              [-6.240861745644697, 2.416063577580544],
              [-6.23519966820568, 2.477056700264746],
              [-6.231050912148575, 2.5179609841163604],
              [-6.220535746314002, 2.6314978097201194]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.39245541524555,
          "lat": 40.55482430193815
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08123"],
        "coty_name": ["Weld"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Weld County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00198177"
      },
      "bbox": [
        -6.399861437095678, 1.5766465954633058, -5.198971342171543,
        2.6314978097201194
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.063980861351835, -7.895046247294598],
            [9.0730128089811, -7.891236217032573],
            [9.076539484919254, -7.884661266868997],
            [9.082854517125824, -7.876660623393036],
            [9.085940529349795, -7.874945480530878],
            [9.085498600631151, -7.871445865122408],
            [9.096257264454685, -7.868603044468026],
            [9.102649327441167, -7.871927147570402],
            [9.106879567236584, -7.871280461517331],
            [9.115223718636047, -7.86567096137621],
            [9.11720699291529, -7.862771101322762],
            [9.122147323562611, -7.862477916627875],
            [9.126315888008643, -7.86511847642866],
            [9.128217518224115, -7.868176682537844],
            [9.135088152348276, -7.871104567809156],
            [9.139825118934441, -7.869093151991121],
            [9.142302944579978, -7.865245096154525],
            [9.144930678265187, -7.866077275262483],
            [9.154862986620639, -7.864588525232112],
            [9.158814369387132, -7.861953329212505],
            [9.165511656798538, -7.853967098287645],
            [9.17001092513246, -7.8452277732224625],
            [9.171812963693505, -7.835884471249205],
            [9.17771138634229, -7.831850280133812],
            [9.202390418200512, -7.828494693202664],
            [9.213169771591598, -7.8287719769995014],
            [9.309133350029546, -7.8193470058106165],
            [9.32063280432567, -7.818344369496094],
            [9.339929756164837, -7.816008766300683],
            [9.352357769158639, -7.815230723389609],
            [9.390033956052234, -7.811340650068893],
            [9.392390230141128, -7.811449796707652],
            [9.449933427429567, -7.805930946947829],
            [9.490758917393904, -7.8016121282657],
            [9.488295222136086, -7.777647954341076],
            [9.486378062719531, -7.751303365442311],
            [9.48494553701104, -7.73870110897563],
            [9.483470269416015, -7.7200609966226095],
            [9.482432056825369, -7.715374242309815],
            [9.47770992687069, -7.6726103481513865],
            [9.506970166380917, -7.669613995233093],
            [9.521748811328726, -7.667764603073771],
            [9.565228638410344, -7.663646634251491],
            [9.566991212775523, -7.67816602137313],
            [9.567158818980932, -7.6853312989006195],
            [9.570779858872955, -7.721376629826108],
            [9.57747979453274, -7.793483404105278],
            [9.578608816794898, -7.80363482735198],
            [9.577986717828876, -7.807243985590017],
            [9.589280053770018, -7.910056887837091],
            [9.590085237226806, -7.9217365375134845],
            [9.594773254603439, -7.960982444743021],
            [9.595834784726684, -7.977734370536271],
            [9.601172880565338, -8.025065119151733],
            [9.602361269635216, -8.037664057449044],
            [9.607433623422033, -8.080025135078237],
            [9.609516886032504, -8.103497827263789],
            [9.612333717751783, -8.126800798386],
            [9.619119297634125, -8.195979923748103],
            [9.62223220273951, -8.223352665417758],
            [9.629034153549377, -8.267053346509991],
            [9.632863691349263, -8.294857701202286],
            [9.632889620938357, -8.297410637368776],
            [9.617224546666169, -8.285061882480855],
            [9.603026228087163, -8.277984153737389],
            [9.595923338913709, -8.275926901507479],
            [9.587030294519423, -8.275500012721174],
            [9.572106253770583, -8.271870094856974],
            [9.563018720057034, -8.272050180951638],
            [9.558407024355983, -8.273379228896973],
            [9.54949003652134, -8.273231078493758],
            [9.538607371136568, -8.269398945380267],
            [9.524421322555737, -8.261926093062625],
            [9.518414320923014, -8.257249416032895],
            [9.509012253033891, -8.248121938890845],
            [9.502690851145728, -8.238760703858281],
            [9.49637936954207, -8.233193476913986],
            [9.489466124189931, -8.232410388268793],
            [9.481193054238199, -8.226852035546342],
            [9.454619165244077, -8.203946996459045],
            [9.447822407577993, -8.197361871635295],
            [9.440996004240482, -8.192669506832704],
            [9.42119921810603, -8.183206500512293],
            [9.388667982517454, -8.17086532801667],
            [9.361189170100873, -8.161008593109143],
            [9.346346300298523, -8.154920553987516],
            [9.329848542835705, -8.145360697492817],
            [9.31898938290631, -8.138397655660013],
            [9.29910129447152, -8.122293730313038],
            [9.275103394605013, -8.105166177571691],
            [9.24199760901868, -8.086731434979127],
            [9.18059102634823, -8.056055914087338],
            [9.14014685921737, -8.038335682948462],
            [9.117417165951492, -8.029352365848078],
            [9.100354188328355, -8.023121640090228],
            [9.073897361034424, -8.013905877567739],
            [9.070745185974546, -7.973773799065073],
            [9.070260558975903, -7.970384911386651],
            [9.06425156956394, -7.8970316817700965],
            [9.063980861351835, -7.895046247294598]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.62022904861246,
          "lat": 30.265203039435036
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12005"],
        "coty_name": ["Bay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bay County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00295738"
      },
      "bbox": [
        9.063980861351835, -8.297410637368776, 9.632889620938357,
        -7.663646634251491
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [11.764325837425295, -8.830838615389258],
              [11.76542849361248, -8.8282055692441],
              [11.769864383591882, -8.828431839943274],
              [11.773693011547712, -8.83087202322007],
              [11.774202989205953, -8.835498628237213],
              [11.772206628125774, -8.837206637173514],
              [11.76480548853688, -8.834291413227529],
              [11.764325837425295, -8.830838615389258]
            ]
          ],
          [
            [
              [11.767824483502551, -8.856023090136164],
              [11.775690372604732, -8.858267038628016],
              [11.77294013149151, -8.861123361781578],
              [11.767529385966261, -8.859338388966506],
              [11.767824483502551, -8.856023090136164]
            ]
          ],
          [
            [
              [11.731598718370648, -8.85889782844965],
              [11.736733357011035, -8.857062633523295],
              [11.743747280354269, -8.856387657431744],
              [11.745756390250223, -8.858947496331377],
              [11.741587447263456, -8.8635091775499],
              [11.7368204653667, -8.86319652108788],
              [11.731598718370648, -8.85889782844965]
            ]
          ],
          [
            [
              [11.712397364794718, -8.831452396155834],
              [11.716298933204211, -8.827821382753925],
              [11.72214728733774, -8.832987413412672],
              [11.720689143424122, -8.841880693787765],
              [11.716902020686458, -8.843861983225807],
              [11.71600949333119, -8.836343673008388],
              [11.7123968898712, -8.83469702889167],
              [11.712397364794718, -8.831452396155834]
            ]
          ],
          [
            [
              [11.784655430201084, -8.363247358171998],
              [11.79502421462969, -8.362179479600323],
              [11.85414823545436, -8.353589207211721],
              [11.855204232832332, -8.360509511402155],
              [11.89488625191659, -8.355065599949802],
              [11.919869197958178, -8.350796991863248],
              [11.927112165592234, -8.349940405339577],
              [11.928016537541744, -8.357041492485184],
              [11.94192509443057, -8.355079794846132],
              [11.944391430225307, -8.369938478769402],
              [12.030319102025224, -8.35562725218646],
              [12.034378550187677, -8.3842299596949],
              [12.051651115958903, -8.381380476790667],
              [12.091915188950908, -8.37393746255118],
              [12.119171413515824, -8.370345363101158],
              [12.120373114956656, -8.373224255183143],
              [12.123691720091154, -8.395315928336634],
              [12.124993077471194, -8.406860949291657],
              [12.127972791758307, -8.426614797437784],
              [12.177238875112367, -8.421036286071223],
              [12.18029609469212, -8.420910511142052],
              [12.179359187639838, -8.413920381056077],
              [12.204964818704449, -8.410721739906748],
              [12.221211894800163, -8.408100149753114],
              [12.256653126205423, -8.403396760575587],
              [12.26435941664829, -8.458290912005037],
              [12.265584735205662, -8.458135357371386],
              [12.271279843344308, -8.497634790661392],
              [12.279978606713689, -8.554718029507068],
              [12.28209173748992, -8.569474915137533],
              [12.287784499245342, -8.604933134609192],
              [12.29625770294659, -8.655200294180199],
              [12.297967268531927, -8.66661254613421],
              [12.266200139197775, -8.67152212665981],
              [12.202651787544172, -8.681030348122952],
              [12.184310779659892, -8.68365830976705],
              [12.190579113635097, -8.72551020049803],
              [12.193489654330005, -8.746774592584378],
              [12.195221522574304, -8.765549523339788],
              [12.206882343865612, -8.840965426894007],
              [12.207636700900222, -8.849768094768642],
              [12.205843315504461, -8.852618130965158],
              [12.199208639459219, -8.854008300683283],
              [12.190900323291688, -8.863341166436404],
              [12.184384026927429, -8.861992607482176],
              [12.177236322231245, -8.866480715750061],
              [12.174143288809956, -8.871219989165171],
              [12.168419603037924, -8.872105573539564],
              [12.159443870119842, -8.871315734670745],
              [12.15604184147729, -8.873899358757006],
              [12.153679447470797, -8.880841733355199],
              [12.155207051768581, -8.885511940290527],
              [12.15439275850136, -8.888559684249225],
              [12.15018434418348, -8.89214789272596],
              [12.145858519953169, -8.893922210343394],
              [12.140886466302979, -8.893602910131612],
              [12.138209224279251, -8.891779942247739],
              [12.130989793439426, -8.89130023216835],
              [12.128995413449589, -8.889100351850908],
              [12.121784403891674, -8.888342606735947],
              [12.10922540156502, -8.88532718224127],
              [12.10309247205232, -8.885641300818017],
              [12.08903919121129, -8.884993440581393],
              [12.087228187911855, -8.881195231738369],
              [12.081435998694676, -8.881699524977224],
              [12.075525260347487, -8.879136063738558],
              [12.073467053401224, -8.880644680052649],
              [12.061975652043877, -8.884206514635347],
              [12.056698245046437, -8.884873671205394],
              [12.051029121347312, -8.890357919812972],
              [12.045607673718633, -8.899340070475702],
              [12.045125057487192, -8.902347985210449],
              [12.040333514730122, -8.90298232084151],
              [12.035288149750704, -8.906165862981334],
              [12.028954490957709, -8.914416447855977],
              [12.023115180792255, -8.918404536899784],
              [12.024473899202933, -8.922145236324768],
              [12.0209579876289, -8.928122399074496],
              [12.015927757372868, -8.921550453249578],
              [12.019024630435084, -8.91423409036899],
              [12.018228354664613, -8.901816383872454],
              [12.021351599381676, -8.894103755870711],
              [12.016976800576977, -8.887077084093168],
              [12.010847974046456, -8.870530639646445],
              [12.008590916777138, -8.86794387579029],
              [12.002090829133135, -8.868015610048374],
              [11.996653770778343, -8.866696908468498],
              [11.98679594929742, -8.868267510024614],
              [11.972986159024572, -8.87307453525986],
              [11.97175986595553, -8.870344630468894],
              [11.98882094968853, -8.860325980436764],
              [11.98945239739408, -8.85588994917913],
              [11.985223232156013, -8.854197161772706],
              [11.974478149011942, -8.85226911288202],
              [11.967546424113754, -8.855397076443769],
              [11.96113376308284, -8.856074653317922],
              [11.959513289673314, -8.853101756949222],
              [11.96095337714682, -8.84885340465779],
              [11.96000632327637, -8.842151323791056],
              [11.955165252626614, -8.842736358752193],
              [11.955229073947121, -8.838048705359602],
              [11.950546633515627, -8.831724784128857],
              [11.957299020847517, -8.827672427695083],
              [11.958839671899305, -8.822996927606903],
              [11.963020748004505, -8.820412138689358],
              [11.967046931346202, -8.811783192088978],
              [11.965598499848397, -8.807590679991433],
              [11.960031643361317, -8.803789246051025],
              [11.961821084621429, -8.799318967377259],
              [11.960038711039095, -8.793155277756728],
              [11.960952542510082, -8.789636182427316],
              [11.960338641078904, -8.782797346538104],
              [11.95718549329062, -8.781462901570467],
              [11.957553207761304, -8.777284159614597],
              [11.953452815749385, -8.773503808557276],
              [11.950209826081615, -8.768363470069625],
              [11.944478568649227, -8.769361599073193],
              [11.943435183212465, -8.773851938446882],
              [11.939372935029455, -8.773923482671199],
              [11.933673753773519, -8.77820373639452],
              [11.92686587385349, -8.77529379012828],
              [11.911917732937622, -8.773865191406346],
              [11.903295995078308, -8.775967770709169],
              [11.89654284470884, -8.778829751170951],
              [11.886861445641369, -8.777839753666214],
              [11.869247101694146, -8.777250022141207],
              [11.864895990480745, -8.77531271750226],
              [11.85511606599338, -8.7741860913952],
              [11.84689754374018, -8.777182662465258],
              [11.835743344705117, -8.77877694404141],
              [11.809894407482671, -8.77922456042428],
              [11.78876507556087, -8.778897707762882],
              [11.789316565872392, -8.789595589536308],
              [11.787071750709297, -8.795881695923185],
              [11.77840520380264, -8.799844705490163],
              [11.776348003010252, -8.804170943559866],
              [11.776316198304784, -8.809968137368996],
              [11.779556171327371, -8.813666248201535],
              [11.774140277257137, -8.815436409355344],
              [11.763251528589594, -8.82288904429076],
              [11.756692613354684, -8.819666467131121],
              [11.751641387992388, -8.824074409417602],
              [11.751793707455434, -8.828192554917532],
              [11.747945469228853, -8.831659693532968],
              [11.744587108203005, -8.828963419037144],
              [11.742085807453215, -8.820196403774721],
              [11.742087192262755, -8.81300365140129],
              [11.738405344433884, -8.811798891557245],
              [11.73587192320368, -8.817727825938189],
              [11.731299091004814, -8.807614933588704],
              [11.731832263055137, -8.796138811452622],
              [11.728244469712159, -8.782350963511542],
              [11.72214484221819, -8.776143773920914],
              [11.716068480015595, -8.76600836627669],
              [11.708219429085192, -8.754532623294773],
              [11.70577026257196, -8.747984878627985],
              [11.705605381224698, -8.739776384097086],
              [11.70945155562023, -8.729577732478676],
              [11.707648044945763, -8.724893195157296],
              [11.712834324023701, -8.715569237784912],
              [11.709648605774532, -8.70866530689823],
              [11.697975966964478, -8.699103982798466],
              [11.692243972190528, -8.69719288913337],
              [11.690097419580603, -8.694344647757346],
              [11.684825509286854, -8.695811183101206],
              [11.674958477068953, -8.690808276072906],
              [11.6646982916465, -8.691285815989609],
              [11.662046460672615, -8.687766064632424],
              [11.653161099004793, -8.68764421569227],
              [11.64047960273809, -8.681461575262773],
              [11.6375041726812, -8.682345215069724],
              [11.632645155427483, -8.688762722200954],
              [11.62760161033167, -8.68655556852477],
              [11.629370114734531, -8.68575156508079],
              [11.633448916072547, -8.67216243011559],
              [11.639287361226815, -8.66819539999823],
              [11.642505115783456, -8.661905690672713],
              [11.643633141108074, -8.651835679413413],
              [11.646503338249362, -8.648719686853907],
              [11.655356979006676, -8.65060342960924],
              [11.656424721490085, -8.651950648971786],
              [11.664751088066213, -8.653075658832696],
              [11.67030107483255, -8.65134189682695],
              [11.670332153009896, -8.644811773638668],
              [11.676597275528993, -8.643212382044297],
              [11.67999658430543, -8.631357525724514],
              [11.687818942160375, -8.634402572975475],
              [11.6939326566353, -8.626489905504815],
              [11.705194926748268, -8.620880315327637],
              [11.711354451313465, -8.61455553542266],
              [11.710150531988322, -8.611500258507128],
              [11.70278532056481, -8.61236974545804],
              [11.701546712850742, -8.60800615806801],
              [11.707315850942285, -8.602770604607425],
              [11.70786460510498, -8.600290885517492],
              [11.704108108379982, -8.596560366301592],
              [11.704464004803068, -8.591023752847928],
              [11.710604866261624, -8.585840795900058],
              [11.717597597318802, -8.58409080968349],
              [11.727392425708965, -8.573727923165835],
              [11.72900419009405, -8.569977733756344],
              [11.727815346781316, -8.566350174251532],
              [11.730010450589345, -8.563394781997216],
              [11.735209033279961, -8.563870314537837],
              [11.737081843826763, -8.561376574273076],
              [11.733644992179165, -8.555428732031253],
              [11.73560780603343, -8.54643779922339],
              [11.731941845529878, -8.544914889470531],
              [11.73151794934295, -8.541413571952882],
              [11.738718049381168, -8.541822479874439],
              [11.739789127034504, -8.537608891683986],
              [11.734806061657372, -8.533857812058013],
              [11.734217021809751, -8.529890686627153],
              [11.740279298766302, -8.520509824888276],
              [11.739415904747055, -8.514508578775795],
              [11.747326364382026, -8.50282054804981],
              [11.747554125258265, -8.497199358692116],
              [11.75020149539759, -8.495386473239101],
              [11.75679516718444, -8.494728035039737],
              [11.76055085738399, -8.48657020161954],
              [11.757693228270147, -8.479293332196429],
              [11.760744276509845, -8.472153331373935],
              [11.757355021320247, -8.462831755621583],
              [11.757044750475384, -8.454803425685903],
              [11.755847091302337, -8.447254222201199],
              [11.756323073703001, -8.441062283077239],
              [11.758318393032603, -8.43953402471511],
              [11.76431330364727, -8.4398666596146],
              [11.766449748334816, -8.434533254181948],
              [11.764789518879716, -8.431225739113627],
              [11.759300950454609, -8.428409472395883],
              [11.756410930815436, -8.423194301235467],
              [11.757538618260945, -8.417454980158794],
              [11.76332972219441, -8.4126351053189],
              [11.770873723344078, -8.403039891268053],
              [11.778504892721001, -8.399135639284648],
              [11.780115412792053, -8.393983339250747],
              [11.778287671327224, -8.389383874245684],
              [11.780274930705147, -8.378837738667013],
              [11.780510916821028, -8.369778187808905],
              [11.78490142561633, -8.367229577099534],
              [11.784655430201084, -8.363247358171998]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.74335477660829,
          "lat": 29.318452918986107
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12075"],
        "coty_name": ["Levy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Levy County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00295724"
      },
      "bbox": [
        11.62760161033167, -8.928122399074496, 12.297967268531927,
        -8.349940405339577
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.52553243925268, -4.841220284835306],
            [11.533793518993955, -4.8403355421360725],
            [11.542778311254423, -4.843920046365536],
            [11.54355346574327, -4.839513096926399],
            [11.55632805899797, -4.838744069531887],
            [11.566679360000107, -4.83735007017045],
            [11.578909294479741, -4.8365418777570675],
            [11.584727779453884, -4.83542791170338],
            [11.591828338867249, -4.839337632288982],
            [11.595753859238439, -4.8330309227468256],
            [11.592942383493776, -4.827933664168479],
            [11.59431858667717, -4.826340763007522],
            [11.59121446780227, -4.817617674374699],
            [11.591636017236066, -4.812391438361127],
            [11.594637019668872, -4.809121576189341],
            [11.59413693794749, -4.803592163061325],
            [11.591510056120006, -4.799466278607526],
            [11.586064761144284, -4.798406962058075],
            [11.58480690011605, -4.7912067185165945],
            [11.582558466135017, -4.787461526199942],
            [11.61709957826381, -4.749747249231333],
            [11.662687464932455, -4.699055697394695],
            [11.665209858359612, -4.695988349486182],
            [11.693694616463073, -4.666871875512873],
            [11.727898916926497, -4.624174242528181],
            [11.737817007061688, -4.623991577434522],
            [11.749321524756823, -4.620471592466497],
            [11.752787630412282, -4.620376724776],
            [11.756223353587584, -4.618950771429163],
            [11.762198963446899, -4.619433589188992],
            [11.771362299678357, -4.622076902218107],
            [11.783196300597545, -4.628381001914925],
            [11.789450409217002, -4.63046826490785],
            [11.799150080781663, -4.638030739327799],
            [11.802834016652634, -4.64320711258072],
            [11.805233414689221, -4.649044723945925],
            [11.817290270516898, -4.6519051683666355],
            [11.820615850179355, -4.654319070854306],
            [11.829880699091891, -4.654777757288249],
            [11.834354307724121, -4.6558870187267996],
            [11.8414248518365, -4.661239580981978],
            [11.842255657853526, -4.66392652489127],
            [11.84673339490622, -4.666672028641033],
            [11.856712068834733, -4.681641641832005],
            [11.856681686218588, -4.685572812213718],
            [11.863926593634535, -4.686523240100053],
            [11.864072093797086, -4.690047616341533],
            [11.857723965397867, -4.7133200333946],
            [11.852843117740226, -4.740741900288954],
            [11.851019917564441, -4.747978610655448],
            [11.847018891245753, -4.768512443712011],
            [11.841544085133133, -4.812280647950361],
            [11.841303343164236, -4.838248917764661],
            [11.840079817720836, -4.860655735390294],
            [11.846394690734632, -4.885526500091215],
            [11.855644422128384, -4.913723179614957],
            [11.867390546562326, -4.960526157951158],
            [11.873704656603772, -4.982460749377247],
            [11.865064237800206, -5.033689723412925],
            [11.8519834629412, -5.088931444340357],
            [11.849067571201488, -5.08510763427183],
            [11.842836043029749, -5.08472510244598],
            [11.840607439794146, -5.0902199393723615],
            [11.836817151242673, -5.093687860273148],
            [11.832572048280886, -5.094468983476192],
            [11.831341740149819, -5.097832783211517],
            [11.82642546244871, -5.10201917733892],
            [11.821384878994857, -5.10220646192096],
            [11.816677531606762, -5.109292134222893],
            [11.817474172911638, -5.113527052295955],
            [11.811066143313242, -5.116191410594968],
            [11.807485748371388, -5.115538944983408],
            [11.795306298174609, -5.117755905670582],
            [11.791480048812929, -5.116207643173296],
            [11.786007819321771, -5.121435526064418],
            [11.778627192517353, -5.120438153100835],
            [11.773144074629734, -5.123015147022056],
            [11.770723066040384, -5.1257755626098165],
            [11.772033111451735, -5.134745405984468],
            [11.777190156220554, -5.137633416738464],
            [11.781903876532752, -5.143741080964284],
            [11.782446928479827, -5.150049785364674],
            [11.785555984415517, -5.152037442472405],
            [11.791465479435157, -5.150881878036783],
            [11.792526426008987, -5.157012901355777],
            [11.788930029173905, -5.161822958784354],
            [11.78316384082828, -5.167112879515175],
            [11.777906287515973, -5.1658217773412645],
            [11.768940996491427, -5.176077100137276],
            [11.765267766712816, -5.175822524784336],
            [11.749742358120496, -5.174442816412463],
            [11.744474458990208, -5.172758330744646],
            [11.73072979458219, -5.165272463222362],
            [11.71578962550277, -5.151214797236884],
            [11.703440098895271, -5.145519635747948],
            [11.696510018061979, -5.139784363156124],
            [11.684811986119932, -5.126470151572143],
            [11.679167924177358, -5.115934762531704],
            [11.677197973825942, -5.084531451317673],
            [11.680806648850119, -5.0808799679797865],
            [11.680520523789706, -5.051056006657136],
            [11.67967027878551, -5.030624764144144],
            [11.651870483427333, -5.004203710504261],
            [11.63617448572236, -4.9448838736270435],
            [11.63273168579451, -4.934416915285655],
            [11.628644893172602, -4.940364292876378],
            [11.62606556812449, -4.940596506003135],
            [11.622829079347856, -4.936287663604412],
            [11.617350338342023, -4.936199537111535],
            [11.609264704521237, -4.932662425908971],
            [11.606865712889501, -4.927290499782791],
            [11.602803232887963, -4.928187769565388],
            [11.595589890533743, -4.924754748356292],
            [11.591516340467802, -4.927433340146711],
            [11.587500481948721, -4.923027845280328],
            [11.587800639386563, -4.921207097606542],
            [11.58412306205276, -4.914553954505325],
            [11.582002736974745, -4.915573692823344],
            [11.577055677974462, -4.910847587966896],
            [11.5719929653452, -4.9101884076296765],
            [11.575463784078304, -4.905684755132313],
            [11.574999958072256, -4.900297663089525],
            [11.563653455127467, -4.899578576677602],
            [11.561244402164219, -4.897440360994946],
            [11.561308360488704, -4.891607019180813],
            [11.55740429781971, -4.887586256322414],
            [11.554639765139626, -4.88748805808907],
            [11.548054442472564, -4.87995900312593],
            [11.548101068206234, -4.874159318239263],
            [11.550361235260622, -4.871479807608224],
            [11.548765133496355, -4.863906217357023],
            [11.542057938768867, -4.864309859412801],
            [11.535856480478133, -4.855959857613674],
            [11.535142427728267, -4.850873713512121],
            [11.529220071989915, -4.847544973331804],
            [11.529112044453107, -4.844987552014212],
            [11.52553243925268, -4.841220284835306]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.41817786563534,
          "lat": 33.054885992759544
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13163"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00345714"
      },
      "bbox": [
        11.52553243925268, -5.176077100137276, 11.873704656603772,
        -4.618950771429163
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.94532187907387, -6.469867598599539],
              [12.946689004452498, -6.46632975464206],
              [12.952259237576232, -6.466165744183175],
              [12.952228667694587, -6.472646363375748],
              [12.945644067258165, -6.4719179988094355],
              [12.94532187907387, -6.469867598599539]
            ]
          ],
          [
            [
              [12.58758327719205, -6.291729225047928],
              [12.620071109363431, -6.274065508842819],
              [12.663424873361217, -6.242015999565155],
              [12.671682060731905, -6.216465655795935],
              [12.679366547519145, -6.1913752932939605],
              [12.680179228238076, -6.190086865375654],
              [12.695110937163522, -6.144130230348054],
              [12.706843632539627, -6.111096855147757],
              [12.721260796322786, -6.110581503784413],
              [12.72953678270763, -6.1130914376559495],
              [12.734082571770157, -6.118575176035906],
              [12.735184400731816, -6.123021608168682],
              [12.729891407597247, -6.126723410211984],
              [12.730863117572806, -6.1295741804949975],
              [12.736873660765236, -6.134501726526662],
              [12.739421717761275, -6.140343667988918],
              [12.743177486519269, -6.14570424578671],
              [12.747755334200951, -6.14812995071075],
              [12.753468304620174, -6.149103212844693],
              [12.755883647017644, -6.15109252197026],
              [12.76111500242274, -6.1591999855881845],
              [12.764044890440685, -6.161417154049279],
              [12.769267960353725, -6.159483357348196],
              [12.770408963290766, -6.152685624375102],
              [12.776081516213393, -6.148505927542379],
              [12.782354457701999, -6.152106873462876],
              [12.784503394567356, -6.150774045167267],
              [12.795469550925208, -6.154375252920974],
              [12.799365895145336, -6.1534882551443255],
              [12.799838170916201, -6.150474380825359],
              [12.805573094955928, -6.149611955012038],
              [12.80803619289911, -6.1446239531524025],
              [12.810811330994783, -6.142733028626205],
              [12.81382381044657, -6.143963913312264],
              [12.820299141825313, -6.140186265072056],
              [12.82481088643977, -6.140508390158933],
              [12.827814699230585, -6.1378761896532295],
              [12.83762627855326, -6.139450457296654],
              [12.841848154922877, -6.1431065010359],
              [12.845654131363245, -6.139203721560791],
              [12.852053880616142, -6.135295479147595],
              [12.856517592273793, -6.129248913426073],
              [12.861447565850836, -6.127913630367839],
              [12.866117651720627, -6.130109741267668],
              [12.872948303741643, -6.134889194368067],
              [12.880361373864252, -6.13517182439531],
              [12.891188408905135, -6.130688622679363],
              [12.90083906805377, -6.129064641438367],
              [12.906997652773242, -6.130184456106085],
              [12.91831690094735, -6.136431469371435],
              [12.929221352592347, -6.137563202767976],
              [12.943269226586828, -6.144470554030937],
              [12.946550494352138, -6.148069282790289],
              [12.949711091669153, -6.1546780424114225],
              [12.960414870236376, -6.158928623122705],
              [12.967642010091199, -6.163009246972757],
              [12.97293455573029, -6.168278695658434],
              [12.975190707292226, -6.1721515269690235],
              [12.976205471918375, -6.190002153351581],
              [12.973370665407037, -6.190292725527657],
              [12.968651649454436, -6.201858376402962],
              [12.959626319666368, -6.214681530889847],
              [12.939920215051266, -6.223916029779071],
              [12.928021611965303, -6.222102588601896],
              [12.924708887393555, -6.228282163561393],
              [12.91046379122142, -6.232384060630615],
              [12.901161592727732, -6.245159710681164],
              [12.894563077999782, -6.249960715422953],
              [12.89899163500695, -6.261364117398654],
              [12.914240377776064, -6.255220707359226],
              [12.917758303343623, -6.248817655288011],
              [12.924169172231204, -6.247965261903678],
              [12.92834127756835, -6.24920796572739],
              [12.92613676204491, -6.2628996827880234],
              [12.915557860276175, -6.270937431313755],
              [12.912446237912045, -6.276582737752253],
              [12.916511666923038, -6.282885739685508],
              [12.925828956196884, -6.281978481720884],
              [12.930072873649006, -6.282552472293331],
              [12.938143631885675, -6.271281036570062],
              [12.942550193839036, -6.257265826690274],
              [12.94688077332206, -6.2461908937228925],
              [12.954046347019004, -6.247306751070751],
              [12.966469084553971, -6.244189915202579],
              [12.973060210711036, -6.235158444774665],
              [12.97789141933313, -6.233435652077589],
              [12.988911886588715, -6.239643908763497],
              [12.994831100247055, -6.245522572823581],
              [12.996982446745985, -6.25140879141746],
              [12.990321431852713, -6.265283619083154],
              [12.982277549814642, -6.29731224182346],
              [12.954815873722653, -6.352430168939655],
              [12.94783209613481, -6.3720541326396924],
              [12.946837968902742, -6.383170873027415],
              [12.942752453360606, -6.394466284832829],
              [12.923421695001531, -6.412016133943987],
              [12.927716253266968, -6.4185209456437855],
              [12.933334318164816, -6.429534439048676],
              [12.939476478128162, -6.452029708166226],
              [12.937999612465862, -6.468361866609423],
              [12.944095567218733, -6.484716102385135],
              [12.938450630638158, -6.4871744639051965],
              [12.931865451020922, -6.487561192316479],
              [12.925311515869877, -6.483921813154387],
              [12.920628560057995, -6.4801759937148935],
              [12.915503805185214, -6.474323351345863],
              [12.911709421906403, -6.473811403391058],
              [12.9003565642047, -6.478331247475914],
              [12.897167317603108, -6.47341170073629],
              [12.894789972485095, -6.472417600283025],
              [12.879499584922902, -6.474122573864116],
              [12.868450988125002, -6.470873669064481],
              [12.856759765002591, -6.474284969918328],
              [12.851378201258692, -6.479892952826319],
              [12.847631003830228, -6.486252910212556],
              [12.845593265061927, -6.491988231023077],
              [12.843697822583328, -6.501166455884864],
              [12.839163599274386, -6.503160292644799],
              [12.836029409847875, -6.501098389628221],
              [12.835736462309828, -6.498121411394611],
              [12.840990222812934, -6.486237231491211],
              [12.838196984554228, -6.483618364283734],
              [12.834076832448632, -6.485227614643755],
              [12.833367648279948, -6.488772494415325],
              [12.82791966878106, -6.488776213461399],
              [12.820862329680487, -6.485465787866139],
              [12.812867473901244, -6.484913105213579],
              [12.810984053391724, -6.482476688967453],
              [12.811115451076544, -6.468993450066163],
              [12.808580352865665, -6.466844586382601],
              [12.804430862693502, -6.467916119742931],
              [12.80135197635471, -6.4715729998524765],
              [12.796433133801088, -6.474252416303894],
              [12.791032182307411, -6.4702255174063295],
              [12.78365974451634, -6.4662802232661125],
              [12.778203455563512, -6.470490866175032],
              [12.776134799863517, -6.4644393472783035],
              [12.773381960708322, -6.468971482671597],
              [12.769703756981698, -6.467744144688664],
              [12.76685491580619, -6.462754220672371],
              [12.764112119105274, -6.463578274780173],
              [12.760396538610648, -6.458542031960189],
              [12.757386294128272, -6.458404775175059],
              [12.747794710634324, -6.4521447510680625],
              [12.739302722007864, -6.452860000814035],
              [12.734056752284975, -6.450232713277815],
              [12.728789518287801, -6.444233036298349],
              [12.721796356848074, -6.443805808375974],
              [12.7198527598793, -6.4418074221894],
              [12.719102809723003, -6.435543342407058],
              [12.712215092500418, -6.434900528404117],
              [12.709609521712137, -6.42847895512489],
              [12.706197879106387, -6.42670378611214],
              [12.699624064138698, -6.427833618079966],
              [12.691749636808735, -6.423457368857298],
              [12.680571863484548, -6.418168701500192],
              [12.67734199114852, -6.412232482280462],
              [12.674098002593905, -6.4093165020962815],
              [12.669666726333544, -6.409092392524447],
              [12.670521759147746, -6.404025902888874],
              [12.663810037925556, -6.40343233349017],
              [12.660280664523686, -6.398782039384085],
              [12.653894098610182, -6.395860742087235],
              [12.65193709887881, -6.389780725572121],
              [12.647571184288735, -6.38796226299025],
              [12.649961262139879, -6.383324965016649],
              [12.644068820967188, -6.376000543424543],
              [12.64035408480737, -6.376923898596014],
              [12.633040352729378, -6.373668239309309],
              [12.63320338893858, -6.371312283556559],
              [12.638476405824145, -6.36535922722457],
              [12.638306128233884, -6.359219508450038],
              [12.640998115734165, -6.354673400798454],
              [12.634495981585347, -6.344771656575386],
              [12.629415369970292, -6.339821665850412],
              [12.621699814471866, -6.341954073299983],
              [12.6139950264298, -6.338301786827384],
              [12.60757067606943, -6.33277768582942],
              [12.608670567083747, -6.327802865453813],
              [12.599012443485911, -6.322806514148282],
              [12.595900843592327, -6.3185308333102785],
              [12.596219319173827, -6.312859497455695],
              [12.597867205510614, -6.309372281123338],
              [12.596202953148909, -6.3066733752096304],
              [12.598082103100262, -6.302128545725826],
              [12.596025729799933, -6.299863364252753],
              [12.590075711600484, -6.301738714538254],
              [12.584586915329211, -6.297419825850349],
              [12.584190388545395, -6.293242118389645],
              [12.58758327719205, -6.291729225047928]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.410301078294, "lat": 31.496367752650546 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13191"],
        "coty_name": ["McIntosh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McIntosh County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "00356886"
      },
      "bbox": [
        12.584190388545395, -6.503160292644799, 12.996982446745985,
        -6.110581503784413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.772528437410784, -3.858502378353614],
            [10.773997110197447, -3.8552363934502942],
            [10.78166863413744, -3.8504365704243866],
            [10.787648518327973, -3.8482015836562113],
            [10.793510993417453, -3.847620094121054],
            [10.8012281297537, -3.8404725565530367],
            [10.801735422304557, -3.8358822529125733],
            [10.805406014765707, -3.8335053580362315],
            [10.804721567068189, -3.829438228505801],
            [10.807383856110137, -3.827236339330481],
            [10.80970209375407, -3.8266355701179053],
            [10.81349850963557, -3.818694789550021],
            [10.81462839722042, -3.813516606204564],
            [10.819236231818657, -3.8118555928980236],
            [10.821853450268101, -3.8088696673587266],
            [10.825907969773194, -3.799234248309865],
            [10.82902982929455, -3.798942214086273],
            [10.832263110041854, -3.7949134170324523],
            [10.83690008729657, -3.7920702040013854],
            [10.83652631209688, -3.787417293932865],
            [10.840872439813698, -3.78715650744766],
            [10.848807179863652, -3.7802630315451644],
            [10.85584385390382, -3.784323276701439],
            [10.859335938210023, -3.790276525587758],
            [10.86692403268672, -3.7879624779794705],
            [10.870835342211357, -3.793206496236208],
            [10.88576193030432, -3.7925452001291573],
            [10.890214303526635, -3.7945688469582417],
            [10.90101751603579, -3.7957587431428355],
            [10.89887388483594, -3.792145937220436],
            [10.908689755439537, -3.7912403951365143],
            [10.910809508675401, -3.792761716425433],
            [10.917126600789306, -3.7893812059258156],
            [10.9190592070172, -3.7916633218485507],
            [10.923578026278012, -3.7910377300702054],
            [10.928006799277062, -3.786072498428155],
            [10.934370929926818, -3.7864328424755342],
            [10.947197801314298, -3.7919277134624507],
            [10.953786517344069, -3.792544359448099],
            [10.997284697600884, -3.751105992686625],
            [10.996817741145936, -3.7627457026435187],
            [11.032826410501299, -3.7969336019982816],
            [11.032139241941904, -3.803253145785424],
            [11.029241837437926, -3.8097696118461992],
            [11.025983808639316, -3.812974618076233],
            [11.021492386464052, -3.8199129027980416],
            [11.022406398007186, -3.825402654518654],
            [11.025973914461574, -3.831818451439933],
            [11.019817312550733, -3.8500163838951784],
            [11.019529093009156, -3.8526149975085433],
            [11.026173660906878, -3.859773235047184],
            [11.035856549365223, -3.862513152087766],
            [11.043922222910286, -3.866785900668875],
            [11.049441917441746, -3.864336432881402],
            [11.05719062457162, -3.871217700353196],
            [11.055683912545934, -3.8729103178065643],
            [11.058285067159703, -3.8778967948512513],
            [11.062815320945294, -3.8804903783633944],
            [11.065737328834295, -3.88444635112625],
            [11.069932650232438, -3.8875420245460077],
            [11.068506702565335, -3.8901918765320715],
            [11.07131543902233, -3.895714724969271],
            [11.081227566356679, -3.8982791897103293],
            [11.086120670428853, -3.9015839687394633],
            [11.085367681332263, -3.905284526868198],
            [11.08817053054126, -3.910982130118058],
            [11.083978318118325, -3.916893942985383],
            [11.08695268957271, -3.9179539344300656],
            [11.1009109606831, -3.9312074152763596],
            [11.106668087782692, -3.935914640178418],
            [11.112081619927153, -3.9333056611399417],
            [11.115056948743232, -3.9405656580041617],
            [11.12497289470486, -3.945221166917016],
            [11.127030762470538, -3.948645231666076],
            [11.126785761890709, -3.9527855178401943],
            [11.130655975443265, -3.958639270626994],
            [11.13592428703964, -3.9617211780116826],
            [11.138300993402643, -3.960112716057581],
            [11.14032823226015, -3.9652666754771233],
            [11.133060523902785, -3.967772923827553],
            [11.135014579924363, -3.970554466837182],
            [11.1345782559707, -3.9740907755892225],
            [11.126032771176366, -3.9753157902095544],
            [11.121403299488144, -3.9803683299530697],
            [11.113831971406348, -3.981225799073007],
            [11.109336520910155, -3.9797208166022178],
            [11.106028700444982, -3.9807669030187802],
            [11.106386143912982, -3.9842355759153607],
            [11.098495006758078, -3.984013193589343],
            [11.096903575864498, -3.9889723654125406],
            [11.092266807796422, -3.989251147530089],
            [11.08493852681818, -4.000680529973992],
            [11.081562662204282, -3.997643083801864],
            [11.073530582554456, -3.9986598286788113],
            [11.070122626895097, -3.9944586095792203],
            [11.065095138527745, -3.9918896077532455],
            [11.061279426621406, -3.994636363995379],
            [11.048967120146122, -3.9889120384391576],
            [11.045573852256359, -3.9931322944725447],
            [11.03832755973222, -3.9962681901022568],
            [11.033943446548482, -3.9933002922843],
            [11.032798716717137, -3.9887733042759965],
            [11.017764013250005, -3.9789908444371362],
            [11.007832639347408, -3.983734819208193],
            [11.00201373161694, -3.9882357388685508],
            [10.98779539560935, -3.995489955980408],
            [10.981856070996583, -4.0025950074493295],
            [10.976486255892224, -4.010465174404697],
            [10.971482202970574, -4.0136761628905795],
            [10.968070967150902, -4.021988311805312],
            [10.953742551108467, -4.031728338871274],
            [10.94594254158545, -4.034872523014718],
            [10.943295792782614, -4.0272678908053905],
            [10.938407058919429, -4.027380581491169],
            [10.931902346791752, -4.023738030133429],
            [10.917208943978912, -4.040139483428135],
            [10.916397021427152, -4.040490090253818],
            [10.91145894642766, -4.034011525109207],
            [10.908977266113677, -4.035895886401118],
            [10.901312767195211, -4.035703923035565],
            [10.898062826922319, -4.038368550373894],
            [10.892491581071107, -4.035526546872113],
            [10.885985824017027, -4.035391534012355],
            [10.881022712105517, -4.03139525728672],
            [10.860898059366436, -4.019812570392839],
            [10.845792015791577, -4.01610750720558],
            [10.828461646607595, -4.010501049014474],
            [10.80919798852354, -4.005003572908255],
            [10.805765883842005, -4.002653746047089],
            [10.807056292381489, -3.997996538718963],
            [10.806325741444628, -3.9864913807280935],
            [10.810426059104964, -3.9850525880954595],
            [10.811018083881788, -3.9787042250681957],
            [10.805532466304433, -3.9747670939837896],
            [10.810808157013444, -3.970400836868908],
            [10.81000393709606, -3.9627627140883543],
            [10.813926803788725, -3.952696910177649],
            [10.81328803889751, -3.9505721044502358],
            [10.816072371411394, -3.944161882217321],
            [10.815736179714824, -3.941703559679205],
            [10.820308597846838, -3.9346009799582533],
            [10.817190275063641, -3.915244419502576],
            [10.812355923591408, -3.9017599423483236],
            [10.811015174721616, -3.893088564827832],
            [10.808390908976323, -3.887645653049274],
            [10.794723561406734, -3.882119022616716],
            [10.788342580811905, -3.8720798108452446],
            [10.781168105568954, -3.8697870940884647],
            [10.775535109793607, -3.8610441156753947],
            [10.772528437410784, -3.858502378353614]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.20899252739363,
          "lat": 34.127753018155666
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13195"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "01688004"
      },
      "bbox": [
        10.772528437410784, -4.040490090253818, 11.14032823226015,
        -3.751105992686625
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.84451736125056, -5.577715812137254],
            [11.840002397392611, -5.594945360588358],
            [11.828342798397726, -5.641243344291466],
            [11.83441251248154, -5.6928447806932025],
            [11.837308989566951, -5.71593733016822],
            [11.836798777049133, -5.786377763250743],
            [11.836778340848195, -5.844901997779667],
            [11.837593507271285, -5.910678902327139],
            [11.836759211970401, -5.942284065810356],
            [11.83778398843001, -5.967390139240761],
            [11.830124541981677, -5.9690599818095],
            [11.827896558205351, -5.9710749649981345],
            [11.825300100397952, -5.977640429834476],
            [11.835019352805942, -5.979425153779934],
            [11.839575421127849, -5.977978986325239],
            [11.842207819272447, -5.980892927691658],
            [11.839513570412716, -5.98478449383939],
            [11.831185987789796, -5.988879012465145],
            [11.82327305355887, -5.988485318928046],
            [11.810980859901541, -5.982353741549569],
            [11.801419792414253, -5.982698805968284],
            [11.797101143605778, -5.980854734636202],
            [11.793297884699326, -5.985637654499577],
            [11.788620818137398, -5.984517235906189],
            [11.791270201655617, -5.976396568744583],
            [11.788911097387562, -5.970154751898071],
            [11.782141698995545, -5.962548305328539],
            [11.775779865181748, -5.965104104727932],
            [11.77442884818214, -5.95897943174215],
            [11.771639924627928, -5.9550367949752285],
            [11.765950572643867, -5.956389348488854],
            [11.760901474267005, -5.951315660464133],
            [11.753690249498826, -5.9477324937380756],
            [11.744091124360237, -5.941676807537552],
            [11.741463092970754, -5.940989151358709],
            [11.735291744696381, -5.936023966115595],
            [11.736239901984698, -5.931906691848126],
            [11.732084404954799, -5.930772214128375],
            [11.731780983233886, -5.923587056182385],
            [11.733635135631445, -5.920952916959791],
            [11.725855711253844, -5.917687860745476],
            [11.722812769229625, -5.91371869277259],
            [11.726491663704078, -5.911208774902322],
            [11.727353695361545, -5.904494682562668],
            [11.720647734328061, -5.900900945726648],
            [11.71962520394308, -5.894870575144789],
            [11.71561999717643, -5.892169478898107],
            [11.717021403460855, -5.886226113815326],
            [11.71552462148127, -5.881330529529462],
            [11.71841929784418, -5.879442028203973],
            [11.71262059590785, -5.874178848636666],
            [11.708420689898645, -5.874251082616135],
            [11.705308124750587, -5.869910110197623],
            [11.709584375986756, -5.867369690085758],
            [11.712908807758778, -5.868541588943677],
            [11.713607230026772, -5.863686414589106],
            [11.709564427033127, -5.8529144957465835],
            [11.70971400417977, -5.8475427641497175],
            [11.702801121266353, -5.844223057521921],
            [11.699933925728839, -5.840754774229027],
            [11.70004674978559, -5.836347373868047],
            [11.697561800565227, -5.834718423961614],
            [11.695654757869105, -5.828396245735252],
            [11.692851031212413, -5.826761575541685],
            [11.691838464202242, -5.823205290863592],
            [11.695122284019545, -5.8222417424936594],
            [11.696260202387988, -5.817868354429346],
            [11.700007012100349, -5.811363833329158],
            [11.699628668232542, -5.808039143256485],
            [11.703202464955648, -5.803717734640155],
            [11.702164027742128, -5.792151123025613],
            [11.690227713320603, -5.786538281794024],
            [11.691545001786151, -5.7810705458995955],
            [11.68757449872353, -5.778159872016144],
            [11.69019037092024, -5.773152353704237],
            [11.684317780202345, -5.773832451234933],
            [11.685634363605018, -5.769316108595207],
            [11.681138755625668, -5.760660392348403],
            [11.682132229862102, -5.753188554710742],
            [11.68551190149741, -5.749587156705134],
            [11.674801775442946, -5.736449857631866],
            [11.676966547802046, -5.7315671055450785],
            [11.674678350372961, -5.7240992789083736],
            [11.667037846922014, -5.720615385169627],
            [11.66410067223304, -5.715144668864019],
            [11.660277650023831, -5.713698700957248],
            [11.660483342291826, -5.708533040355567],
            [11.66313908048776, -5.706921814957256],
            [11.662083663466015, -5.70068084854136],
            [11.665859121608888, -5.6994715028765555],
            [11.667195193319964, -5.688400025029285],
            [11.662625881842073, -5.683251590882273],
            [11.656457388313406, -5.682027565745365],
            [11.655259988251629, -5.676380901495441],
            [11.657228789028073, -5.674414628112161],
            [11.653087583261883, -5.670076205775767],
            [11.65780153857374, -5.667868036288789],
            [11.656777964731964, -5.663301966346902],
            [11.653424223071449, -5.664555958170888],
            [11.647496305978034, -5.6624609635668754],
            [11.64667297809233, -5.65860110983573],
            [11.650819800121115, -5.651491889882672],
            [11.650848334434269, -5.647910139161453],
            [11.745912181626602, -5.613503736815278],
            [11.84451736125056, -5.577715812137254]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.53475111125042,
          "lat": 32.173367283482605
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13209"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "209",
        "coty_gnis_code": "00352276"
      },
      "bbox": [
        11.64667297809233, -5.988879012465145, 11.84451736125056,
        -5.577715812137254
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.611547875506872, -4.175043450487683],
            [10.664807458837751, -4.128362279158909],
            [10.693240022276942, -4.103826002847755],
            [10.721548632690283, -4.135282947412362],
            [10.731283468015107, -4.13491714364488],
            [10.734654378965384, -4.13233038327166],
            [10.741861720967083, -4.132580696334875],
            [10.748816646376437, -4.1340243653654865],
            [10.753701541851326, -4.131174703713164],
            [10.756163545162886, -4.135751115420423],
            [10.76080960341659, -4.1347531647497044],
            [10.765977360066813, -4.136239299291542],
            [10.77232570531791, -4.1343542978520125],
            [10.775613142280442, -4.1358618826139155],
            [10.782186785718494, -4.135847902808525],
            [10.785122526479617, -4.132398090547746],
            [10.792619259727193, -4.130081211973677],
            [10.798993661502049, -4.137865536569094],
            [10.806875499251879, -4.139458887813155],
            [10.810613995124898, -4.143622948690488],
            [10.817504034999741, -4.1462869229766435],
            [10.819158278507045, -4.1516574844856216],
            [10.821635414665844, -4.153678620784375],
            [10.828353829745181, -4.154125260340865],
            [10.827059969939397, -4.1575364062106335],
            [10.832182796256589, -4.159335652002603],
            [10.837766565674656, -4.166111311906794],
            [10.843324475412363, -4.163143177957333],
            [10.84848536374047, -4.170314147089741],
            [10.849132840573269, -4.173777776859355],
            [10.855527374367835, -4.174903148356991],
            [10.85598596469598, -4.172087656187275],
            [10.860921641918736, -4.170038720080385],
            [10.862853568965233, -4.173230374591551],
            [10.868197851047105, -4.1740550797951155],
            [10.87747173156053, -4.177726566557038],
            [10.880444620873003, -4.18086677305605],
            [10.880891604721288, -4.184140115806468],
            [10.878537612114709, -4.186833242173148],
            [10.87994205795613, -4.190887751984831],
            [10.88583188816365, -4.191149799203949],
            [10.891083839573492, -4.189329491927703],
            [10.90094034324449, -4.193355294383544],
            [10.910849736080685, -4.191041996264392],
            [10.922432413884486, -4.192910515621168],
            [10.90226050897191, -4.232650178340481],
            [10.909196091549095, -4.229876764364142],
            [10.913902483831675, -4.232056446930823],
            [10.91291218166765, -4.235445103709957],
            [10.914195081204994, -4.244816358441758],
            [10.919824778060917, -4.25114833378597],
            [10.923987866764596, -4.251974228230379],
            [10.92703902852108, -4.257728378990418],
            [10.925273354291052, -4.265964647047588],
            [10.925763073233238, -4.271949926572686],
            [10.930418285477774, -4.279218595128446],
            [10.927591139413668, -4.288697593717285],
            [10.922878831774643, -4.291822074247979],
            [10.923536776789534, -4.296792178672137],
            [10.919931975849362, -4.299517450079235],
            [10.91982330639019, -4.3046976754612905],
            [10.92494599100026, -4.307813209952107],
            [10.835916250313788, -4.356157718639566],
            [10.832881960533223, -4.352944847296227],
            [10.824265175266646, -4.349955474728736],
            [10.82376715134912, -4.346987080840811],
            [10.819407824084932, -4.343883769720893],
            [10.817909122100481, -4.340607374694766],
            [10.812651379506518, -4.341562249147749],
            [10.810221472819734, -4.338628084642325],
            [10.805878636861541, -4.3390457872080965],
            [10.800455833579536, -4.3355971461573315],
            [10.798015404036036, -4.3260143622010325],
            [10.795540885106217, -4.325339049143071],
            [10.793243696582936, -4.321385733211226],
            [10.793183598463083, -4.3126930689745],
            [10.790240972993905, -4.309662013469686],
            [10.788128411901534, -4.301318892499795],
            [10.783268044418008, -4.294602849156312],
            [10.784094839832484, -4.2920078413296725],
            [10.780286304247955, -4.286709756421819],
            [10.777900280121983, -4.286726515570477],
            [10.77224946109846, -4.281559281873155],
            [10.771396393082613, -4.277040275370746],
            [10.769014606530147, -4.273104336545035],
            [10.764118604601995, -4.2697924287281666],
            [10.760766415777962, -4.261435642853752],
            [10.756617965098041, -4.256351503527556],
            [10.753693812965253, -4.259382443620435],
            [10.742629136596134, -4.248624865725593],
            [10.738475728681108, -4.248019445632739],
            [10.735313978687952, -4.250790230770803],
            [10.72661530230021, -4.247648982689507],
            [10.718984396026283, -4.247107318519016],
            [10.715511592061103, -4.24311586731541],
            [10.702762737582699, -4.236632066757101],
            [10.696683669248713, -4.232165586462938],
            [10.689561818933155, -4.22940112421369],
            [10.685240914798369, -4.225411328831468],
            [10.680967241370393, -4.226385405774107],
            [10.678185003603563, -4.224291994338527],
            [10.677285395435934, -4.218912733909726],
            [10.669925292381386, -4.211578406827483],
            [10.66341848771613, -4.210575419984461],
            [10.665368732289835, -4.207084430153216],
            [10.66507972815693, -4.197663728094374],
            [10.667606122682908, -4.192392538346664],
            [10.666313680577165, -4.190777347691635],
            [10.660936200441418, -4.193648374679345],
            [10.656063258468231, -4.192903158488029],
            [10.652912063750444, -4.194687659512341],
            [10.643846212091722, -4.1960153135839],
            [10.640516274140028, -4.194449271321279],
            [10.631159748692443, -4.19403608865866],
            [10.62776752026464, -4.192739110213125],
            [10.625618954509248, -4.18249010693832],
            [10.619918893300557, -4.175959175630237],
            [10.617951026563052, -4.172072314930988],
            [10.613573666826559, -4.176199023678723],
            [10.611547875506872, -4.175043450487683]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.43708483501078, "lat": 33.83504444007883 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13219"],
        "coty_name": ["Oconee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oconee County"],
        "coty_fp_code": "219",
        "coty_gnis_code": "00356774"
      },
      "bbox": [
        10.611547875506872, -4.356157718639566, 10.930418285477774,
        -4.103826002847755
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.394364304951525, 11.776285390775541],
            [-13.305099705652431, 11.757071225760964],
            [-13.215841246485475, 11.737827718687045],
            [-13.215840499029014, 11.73797810896115],
            [-13.145497767918602, 11.722754841296261],
            [-13.075158972354972, 11.707513361950403],
            [-12.995399833769772, 11.690632253102159],
            [-12.968399366554626, 11.685283971614684],
            [-12.912816647694932, 11.673628278863866],
            [-12.834523700454785, 11.65722811485032],
            [-12.75623540445918, 11.6408054740257],
            [-12.756033191784057, 11.640698765202629],
            [-12.799352625964639, 11.442468199108323],
            [-12.829575753214423, 11.304051501713987],
            [-12.859326784841429, 11.168011024129141],
            [-12.972093853730549, 11.191807033556033],
            [-13.072521198876878, 11.212346519182097],
            [-13.120876990530506, 11.222739304826884],
            [-13.204998744630414, 11.240495070215374],
            [-13.271725218517167, 11.254106316530876],
            [-13.288016647289604, 11.25788638860232],
            [-13.34090008256666, 11.269511060234095],
            [-13.331948067505163, 11.307288385038468],
            [-13.30358663009524, 11.434007349647276],
            [-13.304750485002934, 11.434258898414429],
            [-13.301394955550787, 11.445790253946765],
            [-13.26665421918461, 11.597847734790065],
            [-13.34705444417811, 11.61510487802556],
            [-13.427459547762068, 11.632338398597694],
            [-13.42114946871368, 11.65898421082036],
            [-13.394364304951525, 11.776285390775541]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -116.462875677103, "lat": 48.766867134000684 },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16021"],
        "coty_name": ["Boundary"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boundary County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00395159"
      },
      "bbox": [
        -13.427459547762068, 11.168011024129141, -12.756033191784057,
        11.776285390775541
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.522942638638678, 9.43658113702022],
            [-13.48045496236734, 9.4273020459614],
            [-13.437978789949758, 9.417168979266512],
            [-13.420691767231014, 9.49556501449837],
            [-13.37305624118643, 9.711562029569782],
            [-13.288843076800736, 9.693667065416776],
            [-13.204634741344808, 9.675749065209633],
            [-13.120431283876412, 9.6578080375763],
            [-13.036232753434655, 9.63984399121764],
            [-12.958247535384366, 9.623326271708333],
            [-12.909767770937252, 9.613281925822074],
            [-12.908317713190451, 9.612481777059736],
            [-12.794650730084278, 9.589347174198512],
            [-12.680992108529832, 9.566170819810969],
            [-12.56734196869715, 9.542952733861199],
            [-12.45370043070102, 9.519692936551204],
            [-12.455321327884292, 9.517550368893506],
            [-12.450494091691167, 9.51282228756047],
            [-12.443773756793872, 9.508904581246837],
            [-12.440172557442564, 9.503845543424186],
            [-12.433636800943987, 9.501550610613158],
            [-12.432695844537118, 9.495090010488967],
            [-12.438097547455797, 9.493562362343733],
            [-12.440390015028692, 9.488205881258038],
            [-12.442162832267032, 9.488056918005285],
            [-12.445543571403281, 9.482461128535686],
            [-12.445890301878132, 9.477716762849981],
            [-12.444587094921147, 9.472634679848388],
            [-12.446147369310157, 9.462010187152964],
            [-12.453819846641844, 9.455125690873976],
            [-12.456063041395183, 9.455325091310325],
            [-12.460509759309318, 9.449095862484505],
            [-12.45719265697654, 9.443917931452477],
            [-12.4542233376325, 9.443766351619777],
            [-12.448601269214128, 9.440588208774454],
            [-12.446966712769306, 9.432839401909206],
            [-12.450701849077662, 9.429681242943397],
            [-12.450303590999557, 9.419633154407137],
            [-12.448619828671912, 9.412676563991003],
            [-12.43981314415565, 9.406190317849315],
            [-12.435252852078548, 9.405521098576152],
            [-12.433263911791098, 9.399954578037592],
            [-12.43699749050409, 9.392930190077756],
            [-12.436426093658488, 9.384736915838012],
            [-12.43336738174808, 9.385231708347643],
            [-12.429446167275206, 9.391195879844977],
            [-12.420716836268227, 9.391868847114832],
            [-12.414078323028901, 9.393228399466045],
            [-12.411522443078907, 9.389823489117633],
            [-12.412325997118687, 9.384030887439227],
            [-12.409709620174484, 9.378394672702328],
            [-12.405528123233616, 9.372809035452068],
            [-12.398855589994778, 9.368184531598251],
            [-12.395903117960618, 9.3579871906414],
            [-12.389329589421228, 9.355099587243062],
            [-12.381456360522382, 9.3543724461361],
            [-12.376754413740782, 9.347093922688465],
            [-12.369653774729665, 9.348930991987483],
            [-12.367791511134447, 9.347331974048913],
            [-12.367709387997131, 9.338073181935213],
            [-12.36176824593704, 9.33343200483405],
            [-12.362279747778993, 9.330982699365116],
            [-12.35730875875097, 9.325581184735483],
            [-12.360979994953428, 9.317200930460881],
            [-12.360038739879293, 9.313456971386138],
            [-12.36508028614626, 9.303828618298713],
            [-12.368256870471296, 9.301169202130444],
            [-12.371079819059666, 9.301496196780619],
            [-12.375393713171832, 9.297165523774412],
            [-12.37643834328536, 9.29033264260751],
            [-12.381814689206816, 9.284167044768276],
            [-12.376602965125347, 9.277689698396049],
            [-12.370359743836822, 9.274743672216438],
            [-12.371630196563116, 9.269907091837826],
            [-12.370646837205912, 9.266991114046835],
            [-12.360724298757832, 9.264993524744126],
            [-12.34920740246797, 9.277548472375035],
            [-12.33949095298157, 9.278269723602278],
            [-12.333715428202167, 9.276591731832518],
            [-12.328587748122176, 9.278856956244427],
            [-12.325577970443065, 9.284341559303922],
            [-12.325218203037407, 9.288128786267592],
            [-12.318135758595634, 9.293280997531562],
            [-12.317838073304669, 9.297168396152632],
            [-12.31447367992643, 9.299340716756271],
            [-12.310443789636462, 9.294627514524356],
            [-12.304971285449351, 9.295833517264427],
            [-12.300611705824828, 9.292942381586691],
            [-12.293177699333476, 9.293738505626726],
            [-12.289993810384702, 9.288530274674976],
            [-12.284945255956664, 9.28648200976924],
            [-12.282793380679617, 9.283472528083697],
            [-12.282877006550745, 9.27542490199586],
            [-12.280900472390568, 9.274698434255594],
            [-12.276670235943124, 9.266928620732394],
            [-12.271527281035628, 9.262131182334063],
            [-12.270162165481548, 9.2561882697332],
            [-12.274385500306838, 9.246328832371102],
            [-12.274446466746346, 9.242497605501276],
            [-12.281794637136983, 9.236225839883344],
            [-12.289351486344591, 9.232938397337664],
            [-12.290753658343286, 9.226530790158499],
            [-12.285143625940313, 9.225257296005902],
            [-12.285327042540143, 9.222911589259809],
            [-12.290653708567028, 9.219946665261256],
            [-12.289204615105504, 9.213138889712123],
            [-12.279526115374752, 9.20974373815252],
            [-12.275735951976278, 9.205686864841802],
            [-12.275239568106242, 9.198344771353508],
            [-12.279152328659526, 9.195292905219612],
            [-12.278552601204899, 9.190574896982188],
            [-12.27317847095095, 9.186276046487352],
            [-12.269471463402967, 9.185855403524565],
            [-12.266290854054565, 9.182875549369992],
            [-12.266450978853925, 9.182578465015979],
            [-12.354441151807386, 9.181053716098418],
            [-12.442425601795758, 9.179504238864757],
            [-12.511811480187516, 9.178263508719915],
            [-12.581193780396461, 9.177007419509385],
            [-12.650572494838402, 9.175735981071169],
            [-12.7199476161543, 9.174449203394854],
            [-12.789319137210247, 9.173147096622888],
            [-12.85868705109737, 9.171829671051539],
            [-12.928051351131739, 9.170496937132173],
            [-12.99741203085426, 9.169148905472206],
            [-12.999151642062573, 9.168510027874381],
            [-12.999310455269157, 9.162488111207745],
            [-13.003045469175367, 9.15915607795542],
            [-13.006117855662039, 9.15371045812859],
            [-13.006630167539871, 9.150203367015532],
            [-13.010005194621757, 9.145784787779974],
            [-13.00829442315075, 9.143611025290252],
            [-13.008661646776, 9.134943291593299],
            [-13.017655340860184, 9.135098704359224],
            [-13.02040721262633, 9.132419099056024],
            [-13.022693903037986, 9.121641830077222],
            [-13.02857957760084, 9.119281223507844],
            [-13.030590174111543, 9.116667299451914],
            [-13.035246572228413, 9.11551430683964],
            [-13.041853375167015, 9.111333807989215],
            [-13.041728150836452, 9.109208843120026],
            [-13.048924952972472, 9.0999524234901],
            [-13.054648005008994, 9.098348307466448],
            [-13.05659477380153, 9.099951904794315],
            [-13.06101506898785, 9.098497542361484],
            [-13.067880067958574, 9.089569277832668],
            [-13.07387770703716, 9.092439715100046],
            [-13.080891669120133, 9.087886925429515],
            [-13.082599206961103, 9.084347745582559],
            [-13.086354041871576, 9.082698762126372],
            [-13.09068389312169, 9.077715965395015],
            [-13.0897741840408, 9.071775007992215],
            [-13.093200923214837, 9.07008701938788],
            [-13.092016792523824, 9.06650566933415],
            [-13.094957591886546, 9.06261864013316],
            [-13.09368250100286, 9.055437346086428],
            [-13.097659912138566, 9.04711342600766],
            [-13.103594224416131, 9.044507370947311],
            [-13.102566463634998, 9.040568236254087],
            [-13.103673857689119, 9.03651558613204],
            [-13.108361026290204, 9.036489376272094],
            [-13.112447651654731, 9.029062501286337],
            [-13.11582912032864, 9.028576497455129],
            [-13.116396671850017, 9.018822370842127],
            [-13.114760105026345, 9.015412228331625],
            [-13.119714431669744, 9.01124270003754],
            [-13.124950070399404, 9.008837898004481],
            [-13.122660688825995, 9.005434337353686],
            [-13.128371182541267, 9.00339740546478],
            [-13.13119069752711, 9.004031384893793],
            [-13.137073357630381, 9.00124838585596],
            [-13.13731652269024, 8.995635710152321],
            [-13.141216965795186, 8.99141102314068],
            [-13.146936200347069, 8.99405152675184],
            [-13.151749625965195, 8.992458353091695],
            [-13.15693568719878, 8.998068729990193],
            [-13.164667406741685, 8.995392715462275],
            [-13.169980512443829, 9.0040376153535],
            [-13.17341672729655, 9.002618542307813],
            [-13.178326960027652, 9.006727757205807],
            [-13.17942379367371, 9.010878569067208],
            [-13.18265724373298, 9.010613286161151],
            [-13.185279666679007, 9.015928567080385],
            [-13.191563296691271, 9.015453117272695],
            [-13.19628071279013, 9.016571074262545],
            [-13.200581559626022, 9.020982644692392],
            [-13.210446714064942, 9.02334183371627],
            [-13.21389910083404, 9.028028777327767],
            [-13.218886182081018, 9.031454466683295],
            [-13.22899365403609, 9.032893495456516],
            [-13.234067467083392, 9.03463123252309],
            [-13.23892130738143, 9.03338362358566],
            [-13.243913503914435, 9.038232949851261],
            [-13.25335165409648, 9.039246037788303],
            [-13.257666728661418, 9.037547914013318],
            [-13.259456185976445, 9.04037667896766],
            [-13.265162736829705, 9.04438999278943],
            [-13.271050985488145, 9.045865125717322],
            [-13.271349216841664, 9.051246206763471],
            [-13.282353317637822, 9.060178778560296],
            [-13.282390522929013, 9.063293470349665],
            [-13.285948463452396, 9.066064883760111],
            [-13.286177193248294, 9.068993276152687],
            [-13.289254328870749, 9.072083521604823],
            [-13.296419858899725, 9.089746203508792],
            [-13.298682576166096, 9.093383093583496],
            [-13.29820589284875, 9.098326901682293],
            [-13.302254079183317, 9.09994377674005],
            [-13.300694467472775, 9.105007102959055],
            [-13.304671672518996, 9.109005435994598],
            [-13.308667132969408, 9.115386985146259],
            [-13.313429602587103, 9.117841691569026],
            [-13.31798037586072, 9.122483004998893],
            [-13.322864871312978, 9.12490388401173],
            [-13.329797030264356, 9.125321345388215],
            [-13.332693030188036, 9.124130830784775],
            [-13.340418182375474, 9.128368811342098],
            [-13.344479286623162, 9.131615131619753],
            [-13.347681682462657, 9.132172449828284],
            [-13.355860870767888, 9.124756262568116],
            [-13.362072476747143, 9.125329346194848],
            [-13.365022442459574, 9.131946608288159],
            [-13.367575762435132, 9.134733339287877],
            [-13.36783189119441, 9.139889935914356],
            [-13.3704461918916, 9.142628275419892],
            [-13.380793986150593, 9.147833900194195],
            [-13.384554182777102, 9.147665623621261],
            [-13.388136682845346, 9.150963329854315],
            [-13.38698684144978, 9.159325237150838],
            [-13.38495380384265, 9.164201021144937],
            [-13.387002709859386, 9.17221558466603],
            [-13.386584607839543, 9.178586874915782],
            [-13.393971715311809, 9.191485424805094],
            [-13.409894334894519, 9.19475594291617],
            [-13.46933727168732, 9.207478167807071],
            [-13.470401823466755, 9.210062424409937],
            [-13.468453304153742, 9.217751049790756],
            [-13.470885531984544, 9.224075168084687],
            [-13.470030539193495, 9.225599319320262],
            [-13.471817710410665, 9.232733933509163],
            [-13.475507587866508, 9.237985868301461],
            [-13.477314068026223, 9.237961195275462],
            [-13.480689647586988, 9.242960731602711],
            [-13.481798746960875, 9.249622597720615],
            [-13.489308873341036, 9.255521652415512],
            [-13.491635084715279, 9.260535190157324],
            [-13.498771794583682, 9.268108789752192],
            [-13.49178076230866, 9.300413148388573],
            [-13.495263919047757, 9.299847314072968],
            [-13.505612622399765, 9.303970786266238],
            [-13.515746999030526, 9.302738863371866],
            [-13.53147979329581, 9.305812899814464],
            [-13.54041559154137, 9.30989876540931],
            [-13.544553074975816, 9.309705154413663],
            [-13.549315946221913, 9.30306994227756],
            [-13.53532289436413, 9.366228665436514],
            [-13.538227635957796, 9.366933672389907],
            [-13.522942638638678, 9.43658113702022]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.65666229103358,
          "lat": 46.673650515878414
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16035"],
        "coty_name": ["Clearwater"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clearwater County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00395697"
      },
      "bbox": [
        -13.549315946221913, 8.99141102314068, -12.266290854054565,
        9.711562029569782
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.820068405955944, 5.538692273337421],
            [-11.830327813742745, 5.481743622693638],
            [-11.864471439435146, 5.29450269632094],
            [-11.779010443772139, 5.279217095558936],
            [-11.777905909737132, 5.279175274195095],
            [-11.727317284314786, 5.270124354268179],
            [-11.727388647823481, 5.274191583136493],
            [-11.723758543504289, 5.275931175158293],
            [-11.724387411093794, 5.2787983033937165],
            [-11.721338961061893, 5.28402434217276],
            [-11.717120541123624, 5.2880023928849145],
            [-11.709019244553408, 5.281357529709894],
            [-11.705258226132685, 5.285641359361336],
            [-11.699383016237656, 5.28987814111526],
            [-11.699398123226139, 5.293699804445658],
            [-11.695533975997757, 5.294964436491308],
            [-11.695831123231365, 5.297976506803222],
            [-11.69409388035982, 5.308505805033585],
            [-11.691566188225123, 5.315243526589764],
            [-11.680771301950287, 5.318701691250702],
            [-11.676944482661984, 5.322598821226845],
            [-11.676646642328672, 5.326448777113246],
            [-11.678578011553531, 5.333766025886629],
            [-11.670658116617494, 5.340210792674429],
            [-11.664386954171343, 5.348762762493064],
            [-11.663662329820735, 5.34398941889621],
            [-11.656012690059526, 5.339663880912457],
            [-11.653591361664173, 5.333320799217805],
            [-11.66017999838945, 5.327438695865476],
            [-11.656016775787378, 5.32450927211577],
            [-11.659215597936097, 5.321133677693917],
            [-11.663720296603032, 5.325289438757363],
            [-11.665641364398779, 5.318614864266427],
            [-11.66859004970007, 5.316224511292452],
            [-11.669250555371887, 5.3106740060035325],
            [-11.66496054216403, 5.311671188315686],
            [-11.662967983883554, 5.309308175878071],
            [-11.664203556831628, 5.304961084527158],
            [-11.663150740864156, 5.301634514340015],
            [-11.659172327019366, 5.3021737093912655],
            [-11.659040909775591, 5.307852603650239],
            [-11.654064641412266, 5.310626858951877],
            [-11.64392254052063, 5.3113154842272206],
            [-11.640989215340277, 5.314918792250797],
            [-11.638197068965706, 5.314142195975759],
            [-11.634194799702735, 5.317406110187248],
            [-11.634213553155524, 5.323495388522912],
            [-11.629167110032462, 5.3285263669712135],
            [-11.624587733971495, 5.328484940894469],
            [-11.61889418970001, 5.330498610214068],
            [-11.61546951965643, 5.327067744149282],
            [-11.610554632516692, 5.327629031986012],
            [-11.60727453757687, 5.326258051551842],
            [-11.601022201125897, 5.3273284436927915],
            [-11.598607731276356, 5.326127834030649],
            [-11.594248834194381, 5.327406541903832],
            [-11.589626288128597, 5.325819192564718],
            [-11.57769248097615, 5.333843741490528],
            [-11.572999203892513, 5.3345857818783395],
            [-11.567721706121269, 5.34123361763563],
            [-11.55632961811376, 5.338326004449706],
            [-11.550028866220643, 5.345506628846666],
            [-11.551232875983379, 5.348398189476137],
            [-11.547481331530689, 5.350286159520678],
            [-11.542465551691222, 5.346644192779956],
            [-11.537991667652742, 5.347743999270771],
            [-11.538879492557184, 5.340828659016378],
            [-11.532303304237102, 5.338069766136703],
            [-11.531104330075745, 5.332954963008143],
            [-11.524324731844182, 5.331705652026023],
            [-11.520041405770883, 5.326452323692661],
            [-11.517942262660751, 5.314631481635114],
            [-11.521017512158291, 5.307865737140512],
            [-11.51693962670786, 5.303127438985271],
            [-11.511584317434362, 5.299827276983328],
            [-11.510989145997852, 5.293309443078144],
            [-11.508216989404275, 5.2887747543834385],
            [-11.504972785401932, 5.286625359363612],
            [-11.507008603443284, 5.283415491791188],
            [-11.505085928241064, 5.2780462249881115],
            [-11.503159726903505, 5.278122326658774],
            [-11.513898113986553, 5.217032539899311],
            [-11.514941317228828, 5.21719355416649],
            [-11.524757207246887, 5.160723031257314],
            [-11.51075408792682, 5.158177533550009],
            [-11.520553304768915, 5.101179621984623],
            [-11.492400978375775, 5.0962201484284115],
            [-11.498508233575043, 5.060452792145561],
            [-11.48441286799893, 5.058019842605912],
            [-11.487867156137813, 5.036538534499776],
            [-11.47383111234044, 5.034147337770114],
            [-11.478838549294748, 5.0056219413393235],
            [-11.451197017327809, 5.000862797286759],
            [-11.454954956288871, 4.979355371508979],
            [-11.461997016748164, 4.980462933766788],
            [-11.466609127719511, 4.955755481272125],
            [-11.468295279988451, 4.944708967869876],
            [-11.465865133546709, 4.944267990105731],
            [-11.468742809654778, 4.928105488630052],
            [-11.47222172198181, 4.928690824598809],
            [-11.472861908766125, 4.925156614206029],
            [-11.490544960531814, 4.928235900064322],
            [-11.492444168717789, 4.917457387893459],
            [-11.495520345634992, 4.918021651146116],
            [-11.504893211201432, 4.864419880730611],
            [-11.561416568987207, 4.874199274590557],
            [-11.576325034639131, 4.788252869710481],
            [-11.600727262662968, 4.79263935768879],
            [-11.689082313839515, 4.808224489238843],
            [-11.7044294059151, 4.722000918940114],
            [-11.789308919983851, 4.737012433503753],
            [-11.789451755029443, 4.736226649968026],
            [-11.872110609836641, 4.750702853845285],
            [-11.954771740866303, 4.765165680243651],
            [-11.956005385951457, 4.765392038030675],
            [-11.924703157936538, 4.937482359986327],
            [-11.92562840764235, 4.93765515785355],
            [-11.918140652467777, 4.979404184624831],
            [-11.91014736304212, 5.022669206714324],
            [-12.034336369344873, 5.046644090990495],
            [-12.027141727844823, 5.0838582507986985],
            [-12.034028565419483, 5.086881639287379],
            [-12.040697394647049, 5.093065280134995],
            [-12.048627181331376, 5.093319514763166],
            [-12.059763731235897, 5.090641448751665],
            [-12.069356747181015, 5.090920250125627],
            [-12.071950012470346, 5.089970395191957],
            [-12.06277499443263, 5.13929329966021],
            [-12.020908496758016, 5.131815017269101],
            [-12.005368593685832, 5.217493720344394],
            [-12.04707883723414, 5.224951770987068],
            [-12.031537930488799, 5.309637807295351],
            [-12.0363352201305, 5.310564815893753],
            [-11.988488443514608, 5.569241285026233],
            [-11.904277035641037, 5.553974561471205],
            [-11.820068405955944, 5.538692273337421]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.84069223327597,
          "lat": 42.69364257627209
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16077"],
        "coty_name": ["Power"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Power County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00394951"
      },
      "bbox": [
        -12.071950012470346, 4.722000918940114, -11.451197017327809,
        5.569241285026233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.639496166540836, 1.78180575579249],
            [5.697122513931938, 1.78650088367766],
            [5.710762655913785, 1.7880841662463307],
            [5.725454611383165, 1.7887623666305974],
            [5.751517516172716, 1.7904885319884423],
            [5.768640135766263, 1.7924106045632722],
            [5.812282713837277, 1.7953222518724927],
            [5.812313528594412, 1.7947471209571508],
            [5.843584814024904, 1.79738610407926],
            [5.884885944960554, 1.8004971819204973],
            [6.018689906184769, 1.810144752398566],
            [6.0722263293872585, 1.813807776713518],
            [6.0713181585089435, 1.811477974180149],
            [6.026416641931564, 1.7236103398682792],
            [6.008916171904805, 1.6895058839248835],
            [5.997758608110436, 1.6671817853124955],
            [6.001001670171907, 1.6232055655641493],
            [5.957781568280925, 1.6201524598772197],
            [5.961274397492659, 1.576289176302445],
            [5.917267715052045, 1.5730809875427583],
            [5.830512050530058, 1.5643836184832793],
            [5.747027438404134, 1.5548202911632352],
            [5.65946899739682, 1.5474423699856619],
            [5.652192111494064, 1.635412115840255],
            [5.645594876316543, 1.709592823250548],
            [5.639496166540836, 1.78180575579249]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.90409218108208, "lat": 40.17461317603701 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17039"],
        "coty_name": ["De Witt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["De Witt County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00426598"
      },
      "bbox": [
        5.639496166540836, 1.5474423699856619, 6.0722263293872585,
        1.813807776713518
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.167627426457318, 3.5437051484837014],
            [6.25429426986842, 3.552708659895764],
            [6.3373242976187765, 3.5639332777612367],
            [6.375465601668459, 3.5674908843652573],
            [6.4188100278141995, 3.572186658552217],
            [6.422089077002329, 3.5364276093825624],
            [6.428222728481151, 3.4608055534532216],
            [6.430253726711193, 3.43968277232649],
            [6.43222582355134, 3.425805973827403],
            [6.4324268499384, 3.4186265341901665],
            [6.433679712454516, 3.411263969763499],
            [6.436973477303744, 3.383784797336173],
            [6.447111756324579, 3.2947657923681635],
            [6.4421036313032225, 3.294140717132941],
            [6.439703205649072, 3.29067389925362],
            [6.432748634062522, 3.2848668801983725],
            [6.427755221885381, 3.2791078254778343],
            [6.42796838813314, 3.275476555235422],
            [6.424151823657514, 3.2711450978675107],
            [6.418746122606399, 3.2686588795891645],
            [6.410960999758277, 3.261558194259785],
            [6.399627274039007, 3.260027028121809],
            [6.365075099053587, 3.256177709968618],
            [6.360373022341233, 3.299846174553243],
            [6.273614155206323, 3.2898173638448966],
            [6.235351266692281, 3.28586655049281],
            [6.190246938942494, 3.2815011719313265],
            [6.189747407203623, 3.281456440351097],
            [6.186690695874231, 3.317328806229663],
            [6.182228036846631, 3.3660252365711343],
            [6.180569381393734, 3.385902022307975],
            [6.175107220445952, 3.4564144652272466],
            [6.167627426457318, 3.5437051484837014]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.08560026018105,
          "lat": 41.851958779839606
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17043"],
        "coty_name": ["DuPage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DuPage County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00422191"
      },
      "bbox": [
        6.167627426457318, 3.256177709968618, 6.447111756324579,
        3.572186658552217
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.796807362185515, 2.6116570071108325],
            [6.80289676765583, 2.546041631182134],
            [6.807500219379835, 2.495319451244261],
            [6.8071698325496355, 2.495075510121813],
            [6.811260946742422, 2.454426829111442],
            [6.8154469274900285, 2.407552179162864],
            [6.821581650204397, 2.3372665500251255],
            [6.8283089763637665, 2.260590252987532],
            [6.835674086756643, 2.17842306940538],
            [6.843405378832722, 2.09063368589357],
            [6.74875346232944, 2.0791749467469223],
            [6.721313626433422, 2.0765127218343626],
            [6.665576590177765, 2.071894558878195],
            [6.579404039812128, 2.0626703511723417],
            [6.5367311892548265, 2.0585243310570056],
            [6.493372574916331, 2.0545262361666636],
            [6.485753952106875, 2.05696742301599],
            [6.399391351575548, 2.048938541361079],
            [6.396738939015411, 2.0781820139151534],
            [6.39178252775486, 2.136627359322863],
            [6.380830801155099, 2.238395140750794],
            [6.380208775761883, 2.2383263107720586],
            [6.37059711963001, 2.3252379035557427],
            [6.367629187835248, 2.354595385739384],
            [6.352107809090178, 2.5014694615161344],
            [6.346320433538796, 2.5601726619031986],
            [6.431978846547441, 2.5695620283417866],
            [6.443040810463026, 2.5706307770166488],
            [6.516142722054722, 2.579676514248514],
            [6.582814840556911, 2.587170947757915],
            [6.584085182314864, 2.5876485477641897],
            [6.6145285997409955, 2.590614197562306],
            [6.686411091924876, 2.599061474908777],
            [6.700744775921355, 2.6010261964844545],
            [6.729722049734291, 2.6038724434605625],
            [6.796807362185515, 2.6116570071108325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.82433935727641, "lat": 40.7472433984368 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17075"],
        "coty_name": ["Iroquois"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iroquois County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00424239"
      },
      "bbox": [
        6.346320433538796, 2.048938541361079, 6.843405378832722,
        2.6116570071108325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.461030858019655, -0.5849595853958774],
            [5.547245812503212, -0.5806969656132777],
            [5.591537859868537, -0.5783745391188502],
            [5.632988784132263, -0.5764466589342863],
            [5.705213960775076, -0.5728475804058116],
            [5.764323802858221, -0.5690692895113748],
            [5.786578465822352, -0.5673641774033373],
            [5.807431231482773, -0.5659782989331744],
            [5.810649232837082, -0.6098158675454037],
            [5.813577232507439, -0.6548250823627078],
            [5.819303778845281, -0.7391295599496625],
            [5.825168933266881, -0.831350742701966],
            [5.830698302091977, -0.9185844709940229],
            [5.786501071758623, -0.9226954199220712],
            [5.77913911744527, -0.9239698686138733],
            [5.762003997314315, -0.9251081963045479],
            [5.698601215027412, -0.9285611234223814],
            [5.661606357149094, -0.9312531728450162],
            [5.625694998431378, -0.9335914527693949],
            [5.596240467311779, -0.9352779446323422],
            [5.600537772074664, -0.9371128230510761],
            [5.599800489155745, -0.9437604381309999],
            [5.595972100396443, -0.949149707562439],
            [5.5977189627742865, -0.9553941204660121],
            [5.594021161653403, -0.9617083357916423],
            [5.5922066928206835, -0.9674806678042865],
            [5.589415244730774, -0.9718567689304811],
            [5.582403462021604, -0.9746881960291783],
            [5.574928423051043, -0.9697388067026689],
            [5.572076251773009, -0.9703566103870286],
            [5.566908409848209, -0.96802412095357],
            [5.5616092362365235, -0.9680987984781526],
            [5.558993458485408, -0.9658146218964938],
            [5.559284749337833, -0.9601769075480476],
            [5.553610822507004, -0.9596745559238729],
            [5.546708867370121, -0.9666545169555305],
            [5.544688089971918, -0.9670899233089623],
            [5.5444096958665785, -0.9602080846777132],
            [5.547737101012722, -0.9543813605646877],
            [5.5532390774922495, -0.9543665979251241],
            [5.565645824288284, -0.9575966363916922],
            [5.571849952027098, -0.9564252085246483],
            [5.578167556899011, -0.9508986939111114],
            [5.579055329977065, -0.9464443501206394],
            [5.5766023563155, -0.9378657388692875],
            [5.570242234006886, -0.9299146138296333],
            [5.552751687198615, -0.9130045932415143],
            [5.549188705689756, -0.9064625264179049],
            [5.544857388004585, -0.9020110701660083],
            [5.542910304420612, -0.8973156193116805],
            [5.5440652515689495, -0.8928464724485764],
            [5.542583740144598, -0.8822867676991877],
            [5.54229821462962, -0.8702770225314799],
            [5.544613169868653, -0.8569519418732957],
            [5.544324693680973, -0.8523768976836246],
            [5.540170591241429, -0.8453364778107006],
            [5.532708984729085, -0.8400983545206593],
            [5.528125463758552, -0.8384950696454982],
            [5.522428186932144, -0.8381544843382531],
            [5.5000804494767905, -0.8334637574222945],
            [5.4946277765234095, -0.8319346016984545],
            [5.486681795629054, -0.8282257821478001],
            [5.48334659479893, -0.8241511318803398],
            [5.474991306237651, -0.8091544829408184],
            [5.465003897166478, -0.8029480147066725],
            [5.459487417189908, -0.8006212844441181],
            [5.457666009724119, -0.7932853048472619],
            [5.45243717172182, -0.7942439626431277],
            [5.44536046255671, -0.7980970687261462],
            [5.432753936185155, -0.7992290463542367],
            [5.425631889734995, -0.7974667453816218],
            [5.419796911666993, -0.7934188848276716],
            [5.417388481635456, -0.786102127266558],
            [5.421609234003092, -0.769377774851472],
            [5.421530794260942, -0.7586924111501353],
            [5.413380970920176, -0.7454470811345032],
            [5.409448395969543, -0.7425890379278478],
            [5.4032186305140115, -0.7230976499600257],
            [5.409673457752754, -0.719930170745899],
            [5.415329422665482, -0.7119669534397565],
            [5.418093524948636, -0.706173885690603],
            [5.4196648843499835, -0.6929907858196949],
            [5.418706410201521, -0.6888155452153314],
            [5.419833884559584, -0.6855543981477488],
            [5.441281855979064, -0.6336272877232837],
            [5.461030858019655, -0.5849595853958774]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.38213393508849, "lat": 37.78512533901665 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17077"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00424240"
      },
      "bbox": [
        5.4032186305140115, -0.9746881960291783, 5.830698302091977,
        -0.5659782989331744
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.167652368957967, 3.3840396330179456],
            [5.203150725210426, 3.386814475879518],
            [5.237358570488834, 3.3897513935669386],
            [5.2521820314824215, 3.3903085951891967],
            [5.277689151813082, 3.3923920504993696],
            [5.280015506260092, 3.399394045046489],
            [5.2833553179381765, 3.401654160639492],
            [5.288405064380724, 3.4023226509580207],
            [5.295757019308895, 3.401085875699062],
            [5.301881089563713, 3.401427174693936],
            [5.310805399460856, 3.3995031157158806],
            [5.315511917185608, 3.4003494157657825],
            [5.319919158458808, 3.398390500646698],
            [5.320473373478122, 3.3927452487347134],
            [5.314937657155094, 3.389301373274454],
            [5.313833797448251, 3.38629103165897],
            [5.320008797566371, 3.383379703421583],
            [5.326892708456571, 3.378783278508149],
            [5.329463685331901, 3.380900739250793],
            [5.3283557173119185, 3.3866801120843575],
            [5.33762392293901, 3.396862162650349],
            [5.365841333226457, 3.398608712988909],
            [5.3667305810017, 3.3839564878678394],
            [5.423643261326137, 3.387855133461135],
            [5.443915855335909, 3.3898853498684787],
            [5.521211340168041, 3.3967150137205873],
            [5.561596383776188, 3.399860706138861],
            [5.5638249658093075, 3.400231316713912],
            [5.60302986605926, 3.4034180784969634],
            [5.622514969486673, 3.405304489754441],
            [5.675537200492359, 3.4099736230194417],
            [5.683190363149384, 3.306256649530984],
            [5.687666977062205, 3.2437964342788],
            [5.689327477543764, 3.234534107717211],
            [5.697153190317777, 3.1458828235712994],
            [5.613428077668376, 3.13808417719238],
            [5.570553353790047, 3.1358498341321503],
            [5.528096688349386, 3.133866388558076],
            [5.531671682733302, 3.0903754897026183],
            [5.465060310197185, 3.08552985590321],
            [5.4434978941849135, 3.0838344813230285],
            [5.358210608849916, 3.0777489759526446],
            [5.275447739250442, 3.07219057553223],
            [5.187418166180279, 3.066119468222543],
            [5.180920170077837, 3.1530231717067627],
            [5.17575464310489, 3.239960223876289],
            [5.170845679411647, 3.3258048664463074],
            [5.167652368957967, 3.3840396330179456]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.30029793945043,
          "lat": 41.746102794727804
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17103"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00424253"
      },
      "bbox": [
        5.167652368957967, 3.066119468222543, 5.697153190317777,
        3.4099736230194417
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.5449306768199955, -0.9730873178283598],
            [5.544688089971918, -0.9670899233089623],
            [5.546708867370121, -0.9666545169555305],
            [5.553610822507004, -0.9596745559238729],
            [5.559284749337833, -0.9601769075480476],
            [5.558993458485408, -0.9658146218964938],
            [5.5616092362365235, -0.9680987984781526],
            [5.566908409848209, -0.96802412095357],
            [5.572076251773009, -0.9703566103870286],
            [5.574928423051043, -0.9697388067026689],
            [5.582403462021604, -0.9746881960291783],
            [5.589415244730774, -0.9718567689304811],
            [5.5922066928206835, -0.9674806678042865],
            [5.594021161653403, -0.9617083357916423],
            [5.5977189627742865, -0.9553941204660121],
            [5.595972100396443, -0.949149707562439],
            [5.599800489155745, -0.9437604381309999],
            [5.600537772074664, -0.9371128230510761],
            [5.596240467311779, -0.9352779446323422],
            [5.625694998431378, -0.9335914527693949],
            [5.661606357149094, -0.9312531728450162],
            [5.698601215027412, -0.9285611234223814],
            [5.762003997314315, -0.9251081963045479],
            [5.77913911744527, -0.9239698686138733],
            [5.786501071758623, -0.9226954199220712],
            [5.830698302091977, -0.9185844709940229],
            [5.834294994870374, -0.9182823661485535],
            [5.889914879587838, -0.9171776038705075],
            [5.918780174447917, -0.9158833315789698],
            [5.924019122699633, -1.0054587928083851],
            [5.925456538321136, -1.034824897036152],
            [5.930027816950577, -1.103422052383178],
            [5.932054711269817, -1.1301065563542712],
            [5.935823286524666, -1.1847839838414091],
            [5.8926220179747215, -1.184048864534612],
            [5.848164022594723, -1.1866772691866705],
            [5.79646929886485, -1.1892720490813775],
            [5.775381127009528, -1.1907216020079128],
            [5.758304543737502, -1.1916692910720226],
            [5.729172594880831, -1.19490432513484],
            [5.714435791083861, -1.195147595403842],
            [5.687078530472302, -1.1978455487240052],
            [5.648379384273302, -1.2002085217270424],
            [5.588524301874601, -1.204536746292461],
            [5.597660640813726, -1.2002507601016015],
            [5.6131722592301925, -1.1980513519023255],
            [5.61871897898622, -1.1964623895700053],
            [5.627488161119565, -1.191843021497356],
            [5.629822370149722, -1.189035250435314],
            [5.632840258017334, -1.1796153513212277],
            [5.635966363170453, -1.1547345782000542],
            [5.636239528104631, -1.1474919823321321],
            [5.634471103169864, -1.1380369357510185],
            [5.631022136739136, -1.1278127407883782],
            [5.6232443862678005, -1.1087424054401214],
            [5.618099242997723, -1.0986208154690522],
            [5.608418651484181, -1.0862657754839473],
            [5.591413204240719, -1.0708363931448095],
            [5.5876820646462715, -1.0661189686659713],
            [5.573161006138278, -1.0442244263996985],
            [5.567986303595877, -1.0335077930624414],
            [5.5654415293510535, -1.0255800011002716],
            [5.558993504651768, -1.0145168728691445],
            [5.551177407437126, -1.0036803109537837],
            [5.5462824100342685, -0.9855485353861981],
            [5.5449306768199955, -0.9730873178283598]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.25515017015067, "lat": 37.47129261796873 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17181"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "01785113"
      },
      "bbox": [
        5.544688089971918, -1.204536746292461, 5.935823286524666,
        -0.9158833315789698
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.394654995833674, 2.3229868415491803],
            [8.479438013710803, 2.332886438990444],
            [8.513624768681034, 2.3365313695883088],
            [8.578610358978633, 2.34403752605988],
            [8.583410348635804, 2.3017557128770867],
            [8.586439211793248, 2.2783627322716073],
            [8.58886236912714, 2.2561883320086404],
            [8.584642881635917, 2.2555835518197256],
            [8.594281385946266, 2.1707525131227685],
            [8.595854490945733, 2.1552051751484287],
            [8.58606608805362, 2.153940095245107],
            [8.585423488080378, 2.154050607681653],
            [8.50225043504066, 2.143625276162845],
            [8.487841399967627, 2.14220863682409],
            [8.417709519977414, 2.13468474311709],
            [8.417660211127586, 2.135078931633406],
            [8.412518823553366, 2.1778763783881887],
            [8.405337552870098, 2.235305153100985],
            [8.394654995833674, 2.3229868415491803]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.32483947112338, "lat": 40.47362831243479 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18009"],
        "coty_name": ["Blackford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blackford County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00450404"
      },
      "bbox": [
        8.394654995833674, 2.13468474311709, 8.595854490945733, 2.34403752605988
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.497636368600393, 1.8354034886294717],
            [7.512375412338116, 1.837199356557399],
            [7.555689409733266, 1.840942134632317],
            [7.584096203552209, 1.8429739358981125],
            [7.669605056306625, 1.8508528334666412],
            [7.696711763541304, 1.853544823231281],
            [7.74619632467987, 1.8593933414622292],
            [7.7675851219667305, 1.862644466629567],
            [7.806957643443542, 1.867723212767584],
            [7.808837131135823, 1.8676695702545543],
            [7.8390361449285955, 1.8718859306847089],
            [7.8429172988594456, 1.8371526974609846],
            [7.851091605104926, 1.7616403074637388],
            [7.858840059913795, 1.68938290406442],
            [7.8609978735937505, 1.6676211835585693],
            [7.866609880385625, 1.6164471524068094],
            [7.852257857093467, 1.6140048504014766],
            [7.802144517916353, 1.6077746406185622],
            [7.799627897182697, 1.6076597186233865],
            [7.724494259764257, 1.5995131600541732],
            [7.694629575256043, 1.59561279288739],
            [7.666369369723224, 1.592909754774077],
            [7.613362899246508, 1.5873959649666471],
            [7.583204302122732, 1.5843932143003752],
            [7.552014624108387, 1.5817253143891714],
            [7.523428539138318, 1.5785886544069299],
            [7.515593272756788, 1.656104990496227],
            [7.514230381785403, 1.6666928129129168],
            [7.507429428181296, 1.7370370445054586],
            [7.497636368600393, 1.8354034886294717]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.46868219359577, "lat": 40.05081084575818 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18011"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00450405"
      },
      "bbox": [
        7.497636368600393, 1.5785886544069299, 7.866609880385625,
        1.8718859306847089
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.349895958244803, 1.083164179172783],
            [8.390910572704177, 1.087802586075424],
            [8.387966874995156, 1.1171255591394518],
            [8.382831184618194, 1.164028571894942],
            [8.382223154352925, 1.176799453552662],
            [8.38062976675097, 1.190793320209615],
            [8.394455114819793, 1.1929130051845906],
            [8.423551991843732, 1.1959703296345525],
            [8.423690824206227, 1.1951083569423255],
            [8.473543845518433, 1.2010363799114059],
            [8.509334080739006, 1.204990551691598],
            [8.509643453686179, 1.2054951614655396],
            [8.573056642843868, 1.2124807474520651],
            [8.632772429459086, 1.2193878999098757],
            [8.636835714086384, 1.1862830371813706],
            [8.640495022962133, 1.1586043004678463],
            [8.644786573426407, 1.1177216056311365],
            [8.648447647950155, 1.085852476944638],
            [8.649115385996998, 1.0827242091409013],
            [8.65454495142706, 1.0339529941471755],
            [8.634710292163803, 1.016868123889597],
            [8.599303270795888, 0.9869740790977576],
            [8.571961394365685, 0.9645863232310781],
            [8.562045339681683, 0.9557871190336702],
            [8.553311481294944, 0.9487637408912175],
            [8.53873284472022, 0.9366804816260974],
            [8.512042127964719, 0.9150706731026356],
            [8.471334032512125, 0.8810175643438035],
            [8.463927549608995, 0.8750132001797449],
            [8.45811485877084, 0.8739472978068542],
            [8.419282318705289, 0.8687419500055578],
            [8.41594588679619, 0.8686902063037865],
            [8.372133559028692, 0.8630240708879438],
            [8.365757812889125, 0.917921045610978],
            [8.357953670652316, 0.9940493563310465],
            [8.353067853556544, 1.045832195129542],
            [8.349895958244803, 1.083164179172783]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.5011255761763, "lat": 39.30699943369188 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18031"],
        "coty_name": ["Decatur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Decatur County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00450345"
      },
      "bbox": [
        8.349895958244803, 0.8630240708879438, 8.65454495142706,
        1.2193878999098757
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.808196477377203, 3.46835917858653],
            [7.82406542232844, 3.4700066229212254],
            [7.8607394265543045, 3.4732968824466575],
            [7.948610794844585, 3.482032624981139],
            [8.0080603667277, 3.488088052687704],
            [8.104916122587463, 3.498630065069532],
            [8.111665143421284, 3.4436298847957594],
            [8.115305400506214, 3.4153668766920116],
            [8.123405311894942, 3.350340871121413],
            [8.127180339051169, 3.321388315891039],
            [8.134403792660468, 3.2633033230109074],
            [8.139947488914899, 3.220744223467483],
            [8.14478968728649, 3.17689092000147],
            [8.109203277140995, 3.1727170394872597],
            [8.045089052261247, 3.1646483023647756],
            [7.998475950689319, 3.1591390767609946],
            [7.963687348206, 3.1562342848426033],
            [7.901931243489508, 3.1493381686209085],
            [7.844819780981766, 3.143746459309218],
            [7.843960698579529, 3.153183980259139],
            [7.840096045365942, 3.1871053082301706],
            [7.835652631915859, 3.2294464587758918],
            [7.8280094618908365, 3.294466295795465],
            [7.82565402826779, 3.316905463892499],
            [7.820846791817196, 3.358599641901965],
            [7.820951367833052, 3.35949859214265],
            [7.816123959419336, 3.400053991637726],
            [7.815504475904068, 3.403749041144909],
            [7.808196477377203, 3.46835917858653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.85872360231953, "lat": 41.59738372038563 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18039"],
        "coty_name": ["Elkhart"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elkhart County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00450348"
      },
      "bbox": [
        7.808196477377203, 3.143746459309218, 8.14478968728649,
        3.498630065069532
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.27671842975938, 4.609507064081666],
            [2.337854108069502, 4.611136916679618],
            [2.3673037998310145, 4.611796997502488],
            [2.372742780441889, 4.612333992292344],
            [2.4054391329004985, 4.612739345507939],
            [2.490552032861899, 4.615039395894233],
            [2.5346312718409663, 4.616396211248374],
            [2.6196608186625796, 4.619431354644233],
            [2.6210422408709753, 4.576644934028374],
            [2.622443409735571, 4.53304413677675],
            [2.6240047962921227, 4.497333005288704],
            [2.624822186421417, 4.459297063287538],
            [2.6275196785796338, 4.396306973446334],
            [2.6283475671603185, 4.358012653249137],
            [2.627973474269032, 4.343602034383326],
            [2.6298853507256426, 4.270750549000279],
            [2.557948327734041, 4.268487588642008],
            [2.5570515592682597, 4.268578927862914],
            [2.4575270257787714, 4.265761850140176],
            [2.392845303171013, 4.264101832486522],
            [2.2851870191090238, 4.261811121278876],
            [2.2831147249325716, 4.363291081014281],
            [2.280318439151152, 4.472849205627371],
            [2.27671842975938, 4.609507064081666]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.26082102538061,
          "lat": 43.081550191289985
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19033"],
        "coty_name": ["Cerro Gordo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cerro Gordo County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00465206"
      },
      "bbox": [
        2.27671842975938, 4.261811121278876, 2.6298853507256426,
        4.619431354644233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9466772159844414, 2.4923957608085416],
            [2.0187175084103144, 2.4937076010590093],
            [2.0328258849472864, 2.494093415444611],
            [2.0589288312729144, 2.496112471613264],
            [2.100261895524008, 2.5002010962020624],
            [2.1145420481152923, 2.5014110844510715],
            [2.1958945335283695, 2.5030171117885134],
            [2.258493545882186, 2.5044112443095456],
            [2.2874905950241473, 2.504871870702017],
            [2.2879139976380576, 2.4974169672633137],
            [2.290122571791832, 2.4166988932130833],
            [2.292476144670545, 2.339315035574347],
            [2.2932775759263286, 2.2986830535834084],
            [2.2950651480658695, 2.2400512091310105],
            [2.237570438064472, 2.239496196034358],
            [2.215955221419487, 2.2391227889735363],
            [2.1668503329686177, 2.23785790396341],
            [2.1223247647236483, 2.236885481440688],
            [2.0304842612506966, 2.2321396321603677],
            [1.9516884038349598, 2.230781832937118],
            [1.9494993776107055, 2.3324776105916345],
            [1.9496337377902617, 2.3345018664547403],
            [1.9483307844769135, 2.4052563137670346],
            [1.947400916815149, 2.448969140789449],
            [1.9466772159844414, 2.4923957608085416]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.78517587751625,
          "lat": 41.029010389469185
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19039"],
        "coty_name": ["Clarke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarke County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00465209"
      },
      "bbox": [
        1.9466772159844414, 2.230781832937118, 2.2950651480658695,
        2.504871870702017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.563792652864076, 4.587890337766177],
            [0.649679682545006, 4.5886442034399195],
            [0.7215356875556386, 4.589213611763854],
            [0.7359182963605563, 4.589207661804539],
            [0.8067003595420817, 4.587216373594012],
            [0.8218509397547511, 4.586924537553836],
            [0.9071309603758816, 4.5868911989449455],
            [0.9074329540053255, 4.5301416433577115],
            [0.908096995461817, 4.473503430102629],
            [0.9082194808294759, 4.429930604452313],
            [0.9083139709930215, 4.327230134652331],
            [0.9092906098575911, 4.240726251990105],
            [0.7813039643997136, 4.240227240164038],
            [0.7382570650088297, 4.2402542542739505],
            [0.6807512368165682, 4.239560159712183],
            [0.6235118383857865, 4.239173098816873],
            [0.5661492634906407, 4.238569276505625],
            [0.5653770088510975, 4.370075391801195],
            [0.565226276204874, 4.413645905088185],
            [0.5646181267261627, 4.457336152809206],
            [0.5641725237494972, 4.501470640124413],
            [0.563749494231123, 4.51597927719178],
            [0.5635954643878572, 4.545098758371792],
            [0.563792652864076, 4.587890337766177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.62492099733295, "lat": 43.08376511930734 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19141"],
        "coty_name": ["O'Brien"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["O'Brien County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00465259"
      },
      "bbox": [
        0.5635954643878572, 4.238569276505625, 0.9092906098575911,
        4.589213611763854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.796216445031535, 0.9612478683177613],
            [0.8426715768807633, 0.9613526408127948],
            [0.9673707681670205, 0.9623436959460181],
            [1.0957315074622538, 0.9632792856899962],
            [1.0989948658371067, 0.9630998970663319],
            [1.130977038693452, 0.9635668115577573],
            [1.1386526876979115, 0.9633007603771151],
            [1.139389493223507, 0.9542242194703993],
            [1.145039554302479, 0.9472525339138785],
            [1.15068094983944, 0.9460613111348882],
            [1.1527088394202838, 0.9387723341963474],
            [1.1500399010941738, 0.9343848927522215],
            [1.1520625255437287, 0.9314549130072833],
            [1.1605142496327232, 0.9314023802171473],
            [1.161707801497123, 0.925696198865044],
            [1.186164230617006, 0.9261874922714117],
            [1.190436829064551, 0.9171105548184052],
            [1.191603152766994, 0.9123966550686861],
            [1.1911192478419148, 0.9058423576467999],
            [1.1895629100862206, 0.9002411985596561],
            [1.1838359696402863, 0.8910840719466347],
            [1.1780507599183707, 0.88754269860284],
            [1.1687625414940397, 0.88709760574284],
            [1.1589271728435309, 0.8913065010851379],
            [1.1541813032246593, 0.8908473736727069],
            [1.1484880364742402, 0.8879319995040488],
            [1.1452986333521902, 0.8839252307709026],
            [1.1411435292729415, 0.8690390321106011],
            [1.1408258105837683, 0.8637955663710952],
            [1.1441845165834454, 0.8520619991778355],
            [1.1491710139714197, 0.8430872619758811],
            [1.1570395243250613, 0.833970673134524],
            [1.1688069331067261, 0.823294748677786],
            [1.1826217355675848, 0.8159516299954113],
            [1.1882508062590063, 0.809802835313955],
            [1.1900896345104124, 0.8041877698206585],
            [1.1923595399195872, 0.7845836620421329],
            [1.1973047129406682, 0.7759685950959669],
            [1.2029988412156005, 0.7704633688303409],
            [1.2165303335985187, 0.7624591898944387],
            [1.231920698157645, 0.7579414532086657],
            [1.236222418286702, 0.7559863270340819],
            [1.242424289335977, 0.7503592400845761],
            [1.2450307188255596, 0.7460354853047965],
            [1.2468113812639137, 0.7364244931535524],
            [1.2496617049551806, 0.7314120030374841],
            [1.252830411397797, 0.7287893206252553],
            [1.250776121252772, 0.7284976357866],
            [1.1131854463904503, 0.7274418159147165],
            [1.0905678951908508, 0.7273564436610391],
            [1.0563334713750687, 0.7270644292070242],
            [0.9799838771821789, 0.7272052249760871],
            [0.9628407339851678, 0.7270118853281642],
            [0.9341620760693581, 0.727366850951652],
            [0.876931485352374, 0.7275461446872331],
            [0.7925351262253081, 0.7252290945036511],
            [0.7921598756872156, 0.8494621872706097],
            [0.7918674438714425, 0.8734198819018911],
            [0.7964756633310867, 0.873428746093972],
            [0.796216445031535, 0.9612478683177613]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.31344745804618, "lat": 39.5317530978967 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20005"],
        "coty_name": ["Atchison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Atchison County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00484972"
      },
      "bbox": [
        0.7918674438714425, 0.7252290945036511, 1.252830411397797,
        0.9635668115577573
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9036723519764756, -1.2054861547352849],
            [-1.799113204432182, -1.208958774174556],
            [-1.7311253460224394, -1.210741328355127],
            [-1.6702498873528355, -1.2122499816509014],
            [-1.6670678076376648, -1.2119752205571026],
            [-1.60236900152478, -1.2143202176966748],
            [-1.473176249446173, -1.2172934242604319],
            [-1.4756787910208433, -1.3050146488302667],
            [-1.3851010072664982, -1.3073391013830502],
            [-1.3863405871662757, -1.3655422032950475],
            [-1.387965388295722, -1.4536515642390087],
            [-1.3886110796529945, -1.4829237740935408],
            [-1.3895660884103234, -1.5411547058980835],
            [-1.3919515549097214, -1.6584779289903873],
            [-1.3926391388593338, -1.696992514955731],
            [-1.4415260559116152, -1.6952132086799063],
            [-1.5487884446850195, -1.6919307311075726],
            [-1.6830842192240065, -1.688151383151602],
            [-1.7203012040052064, -1.6867108574161602],
            [-1.7442933338419653, -1.6861816612700755],
            [-1.805576025609537, -1.6843254214081393],
            [-1.9090216299155904, -1.680904969774108],
            [-1.9056140429101462, -1.5554800632719266],
            [-1.9058329569748866, -1.5542572798866425],
            [-1.9041041127426162, -1.498523075805539],
            [-1.902523605415322, -1.429412469489733],
            [-1.9027154134062, -1.4281197389831837],
            [-1.8994603429477674, -1.3423647155116796],
            [-1.898520574407763, -1.307294537144906],
            [-1.8975380309406145, -1.2926711303269154],
            [-1.9055652219765111, -1.2924505269428896],
            [-1.904269968507622, -1.2452426901022657],
            [-1.904444135761882, -1.2400414261510933],
            [-1.9036723519764756, -1.2054861547352849]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.68481910765257, "lat": 37.22886468493797 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20007"],
        "coty_name": ["Barber"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barber County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00484973"
      },
      "bbox": [
        -1.9090216299155904, -1.696992514955731, -1.3851010072664982,
        -1.2054861547352849
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1779294429669855, -0.9749991730576941],
            [1.1778393852755968, -0.9457896490884975],
            [1.177193101209623, -0.8869359874155803],
            [1.1836462059024786, -0.8867697831483796],
            [1.1827606847844299, -0.8281021745888784],
            [1.182931308789892, -0.7548915895692363],
            [1.182845382274361, -0.6959477369723801],
            [1.1829318258092911, -0.6667393736923161],
            [1.2672397691031292, -0.666008806394005],
            [1.280814800244052, -0.666369369926603],
            [1.3097927765875395, -0.665568676067943],
            [1.3236590641272754, -0.6656615756020435],
            [1.4105297973058712, -0.6642787792616894],
            [1.4382988363188862, -0.6643894862701307],
            [1.4526454089189071, -0.6639005676954478],
            [1.4670557964814368, -0.6640432027384827],
            [1.523241674684776, -0.6635855920754312],
            [1.544725174396295, -0.6630013911058943],
            [1.5452018866953035, -0.7080295647861191],
            [1.5450731030830736, -0.7127404045115842],
            [1.5455977382507373, -0.7565976824392857],
            [1.5455466016088446, -0.823279079307552],
            [1.545687140939183, -0.9296720771630366],
            [1.5462341643391688, -0.9809553260005194],
            [1.5471436966995895, -1.030492163396008],
            [1.451427166892226, -1.0308909689063361],
            [1.4226632375216672, -1.0311506283341159],
            [1.378353919077126, -1.031864271891031],
            [1.3499330512183314, -1.0318311267453844],
            [1.3359072837295127, -1.0314766336196295],
            [1.3209410615241735, -1.0319360855012443],
            [1.2213141376288539, -1.0327007147895528],
            [1.1928199018446564, -1.0334706714162183],
            [1.1785458404303355, -1.033513065578124],
            [1.1779294429669855, -0.9749991730576941]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.84937131728327, "lat": 37.85523702048746 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20011"],
        "coty_name": ["Bourbon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bourbon County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00484975"
      },
      "bbox": [
        1.177193101209623, -1.033513065578124, 1.5471436966995895,
        -0.6630013911058943
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.14789735439524943, 1.3147338524526675],
            [-0.06348798057212397, 1.3139374733150617],
            [-0.008711950295315407, 1.313473506465764],
            [0.00043455707620530077, 1.3131347371868856],
            [0.030415437104055816, 1.3131603524105184],
            [0.11174288187901157, 1.3125940130214555],
            [0.23255555313087561, 1.311763563476781],
            [0.2821599042098261, 1.3116842188856839],
            [0.2818809936266291, 1.2413738649614083],
            [0.2813789111624815, 1.121810038541937],
            [0.2811790718175558, 1.048900064168314],
            [0.28089820037748053, 0.9611097304557678],
            [0.2812387000137848, 0.8732609616558975],
            [0.1956101005081327, 0.8734601230496188],
            [0.08216753997579754, 0.8738274820487116],
            [0.034710237411293594, 0.8743811090387442],
            [0.020443961465085987, 0.8743749793706994],
            [-0.034429205605996445, 0.8749680003337645],
            [-0.1522115942622962, 0.8758496497264913],
            [-0.15167827968647873, 0.9343705758317871],
            [-0.15103335826834105, 1.0220349863312543],
            [-0.15080310482949777, 1.029857372874243],
            [-0.15015572637612665, 1.1099995403848184],
            [-0.14954614004512515, 1.1543949713743378],
            [-0.14878783674077242, 1.2274718548871202],
            [-0.14789735439524943, 1.3147338524526675]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.52292266398906, "lat": 39.78357173193528 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20117"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00485023"
      },
      "bbox": [
        -0.1522115942622962, 0.8732609616558975, 0.2821599042098261,
        1.3147338524526675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4356343273006935, 0.8991680664643313],
            [-1.3509454855066003, 0.8968948836191988],
            [-1.2377452505499444, 0.8941596115770694],
            [-1.1835083335797214, 0.8926498498125828],
            [-1.0975358144878025, 0.8907514629016694],
            [-1.0115007421325775, 0.8887305938707394],
            [-1.0089185762275057, 0.8886720971534512],
            [-1.0111086651735224, 0.8018628405564796],
            [-1.0132691709862174, 0.7137309585917111],
            [-1.0140655857764247, 0.6548849840959933],
            [-1.0147408688879296, 0.6257737311415489],
            [-1.0156527896132646, 0.6108812244705578],
            [-1.0172708370394747, 0.5962381963247484],
            [-1.0174495358422817, 0.567367234025034],
            [-1.0179250175356864, 0.5572231663483556],
            [-1.0170239216598969, 0.5378504142529875],
            [-1.0413807060324742, 0.5378482344425853],
            [-1.081280858447755, 0.5391279822527255],
            [-1.1890829766015296, 0.5414311432316505],
            [-1.25997780001825, 0.5432644067944169],
            [-1.2746606603274828, 0.5438401821390796],
            [-1.3608382386383249, 0.5457699502037938],
            [-1.4469407034090602, 0.54836013142484],
            [-1.444559945971245, 0.6362187091046464],
            [-1.4420156297681734, 0.7238076918203321],
            [-1.440517622839754, 0.7692634300904836],
            [-1.4387991521963914, 0.8111487272439781],
            [-1.4356343273006935, 0.8991680664643313]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.20936987006505,
          "lat": 39.393263584373386
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20123"],
        "coty_name": ["Mitchell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mitchell County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00485026"
      },
      "bbox": [
        -1.4469407034090602, 0.5378482344425853, -1.0089185762275057,
        0.8991680664643313
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.002560858719469, 1.3277252514661213],
            [-0.9188296066337726, 1.3260235623718557],
            [-0.8851743554570384, 1.3255531671865362],
            [-0.880336634816931, 1.3252711653259925],
            [-0.8032736327756533, 1.3238573081904599],
            [-0.6834666479880754, 1.3217937563465365],
            [-0.5755496678444934, 1.3203210182940965],
            [-0.5771989235956752, 1.2031227924171006],
            [-0.5773481763443788, 1.1730208107198883],
            [-0.5789468550555128, 1.0493992564205432],
            [-0.5802058956717061, 0.969183102448584],
            [-0.6944050080752542, 0.9704703213781215],
            [-0.7564350123791709, 0.9712455379297094],
            [-0.8379151429563283, 0.9729453266776408],
            [-0.8985461548343926, 0.9741491512200416],
            [-0.9732623364001046, 0.9754211127093554],
            [-0.9778810796619987, 0.9757671877652621],
            [-1.00944301015406, 0.9763562895508494],
            [-1.0084431000076064, 1.0640424862961249],
            [-1.0073531714392374, 1.1516059627497828],
            [-1.0042822149104436, 1.239347961410652],
            [-1.0029272915969263, 1.3135680052796128],
            [-1.002560858719469, 1.3277252514661213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.65061819894565,
          "lat": 39.827761523091105
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20157"],
        "coty_name": ["Republic"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Republic County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00485042"
      },
      "bbox": [
        -1.00944301015406, 0.969183102448584, -0.5755496678444934,
        1.3277252514661213
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.039087968506681, -0.8069237199480642],
            [9.041532894003304, -0.8065590649310187],
            [9.048370920938535, -0.8011961779059266],
            [9.05322299076005, -0.8021486066164909],
            [9.057920350933694, -0.8058538399073715],
            [9.06029339569112, -0.8046014044726789],
            [9.061325951253197, -0.7988162873159429],
            [9.057894495974978, -0.7566276454068321],
            [9.052696969781104, -0.7175051920446021],
            [9.050444520987027, -0.6718843207583068],
            [9.059655212512396, -0.6654345313974408],
            [9.063061750059726, -0.6656523871381894],
            [9.070461009450645, -0.6634294896933699],
            [9.077508709811076, -0.6672157435542229],
            [9.079125986519642, -0.6652031237118324],
            [9.081038182188777, -0.6801302608974411],
            [9.122467708587259, -0.6759692726004419],
            [9.16240081896166, -0.6721689134392812],
            [9.199998431430174, -0.6512462621956416],
            [9.194813895615775, -0.6720126201085358],
            [9.199411254804573, -0.716665745809272],
            [9.199662875314672, -0.733632150706541],
            [9.211685214938594, -0.7730939445537571],
            [9.248038724919002, -0.7971436616706771],
            [9.258760220404298, -0.8047315008162399],
            [9.308733708598558, -0.8234015076340966],
            [9.319661170702245, -0.8285208904442327],
            [9.339924349692115, -0.8873243393880713],
            [9.3360071318838, -0.8888503567374407],
            [9.334776078601546, -0.8936664052932489],
            [9.327515758511554, -0.9020676011691974],
            [9.328837566640916, -0.9057799406512567],
            [9.329723190227417, -0.914459388476516],
            [9.332466643268292, -0.9168339292819],
            [9.332210049096085, -0.9201263607954905],
            [9.334640209147302, -0.9283968924069271],
            [9.334141637996876, -0.9307125702701942],
            [9.337878583550733, -0.9355470753406795],
            [9.335094881189164, -0.9389984985731413],
            [9.336852738379235, -0.943113236117432],
            [9.33502485334599, -0.9452152514048354],
            [9.335864858394794, -0.9503484117319319],
            [9.273984312026819, -1.0220469289266916],
            [9.208972235804206, -1.0894126917827411],
            [9.197917006937839, -1.0998727869295677],
            [9.168811762311933, -1.1083680797157731],
            [9.154960347759648, -1.0991388355814677],
            [9.089325467560778, -1.0324811608998474],
            [9.080208187608521, -1.0228292876072327],
            [9.070442668316845, -0.9624929967531896],
            [9.024331373541372, -0.9423537293827595],
            [8.994095449282078, -0.923123052130336],
            [8.979526653662605, -0.9187293530031546],
            [8.985297952037419, -0.9092545179699031],
            [8.986979776667734, -0.8967701876402677],
            [8.989056861529773, -0.8906021845401686],
            [8.991858981376636, -0.8889343000889007],
            [8.994333849018076, -0.8731267091195677],
            [8.99769981821658, -0.8711387068255244],
            [8.99978189707297, -0.8608515059253916],
            [8.997446553087602, -0.8540380849771038],
            [8.996828336385544, -0.8465447157973387],
            [8.99763103879454, -0.8415823859833578],
            [9.00054401715811, -0.8389336350928188],
            [9.007113591150777, -0.8399835687440607],
            [9.01203168123597, -0.8333494033617588],
            [9.01565400180302, -0.8262267109103181],
            [9.023793726923202, -0.8231417084388769],
            [9.027450462420694, -0.824958305457379],
            [9.033763483163302, -0.8208356135006594],
            [9.034425242058429, -0.8126810623267257],
            [9.039087968506681, -0.8069237199480642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.9283459014738, "lat": 37.32235037402805 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21045"],
        "coty_name": ["Casey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Casey County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00516869"
      },
      "bbox": [
        8.979526653662605, -1.1083680797157731, 9.339924349692115,
        -0.6512462621956416
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.661616223766178, -0.2930558066903058],
            [10.667815635350559, -0.29217692744700824],
            [10.671746415262799, -0.2885746610040868],
            [10.67600270289606, -0.29176854308528505],
            [10.681784236574066, -0.2938038636054473],
            [10.684798110657898, -0.29613674288600694],
            [10.691855040815843, -0.2985175986230311],
            [10.694176634235754, -0.30194014598563396],
            [10.696307817134038, -0.2963830037132262],
            [10.700701249697628, -0.29543487254410244],
            [10.704905745650043, -0.28774426500434314],
            [10.711251551022704, -0.28314357316300687],
            [10.714096986412008, -0.27272724634111273],
            [10.71683458060559, -0.2703503734641842],
            [10.720642723195704, -0.2732544900166862],
            [10.73365903626683, -0.2696196469603206],
            [10.777787476114028, -0.2465954067773911],
            [10.786118481976523, -0.24950575052492724],
            [10.792866081865515, -0.24869507633935783],
            [10.794255732105468, -0.24096893543830203],
            [10.79381110121591, -0.233984207171715],
            [10.800148270561314, -0.2376913842524189],
            [10.802681711297573, -0.2371799940800003],
            [10.807423286786765, -0.24024473972851818],
            [10.813604023181112, -0.23992255956036132],
            [10.815557504927137, -0.2425095475964635],
            [10.825800052375179, -0.2367780801623878],
            [10.828486386627628, -0.241199265147863],
            [10.834195596001495, -0.24021461215404855],
            [10.838720289742447, -0.2447133442613508],
            [10.844570320594944, -0.2464778206212089],
            [10.84827399269061, -0.24482208970515912],
            [10.857398440480896, -0.24633731973032705],
            [10.85610791689424, -0.25021504898034613],
            [10.859019612890759, -0.2527629183532085],
            [10.861473755806104, -0.2514489796136511],
            [10.868788580083281, -0.2547428526493274],
            [10.872981079128758, -0.2522560945255372],
            [10.875487748427322, -0.25369493807895344],
            [10.882848975578925, -0.25163393646858073],
            [10.890617175920992, -0.2529882450669471],
            [10.893823267944581, -0.25665493067523226],
            [10.89730533510452, -0.25954713049468464],
            [10.90022698204081, -0.2587919036731521],
            [10.903957072594007, -0.2633376591613429],
            [10.907661768970696, -0.2648302686054109],
            [10.91077315602115, -0.2697959059114355],
            [10.91426664194221, -0.26736095558350925],
            [10.930063709896302, -0.2721055549186639],
            [10.936959578432091, -0.27865556207105335],
            [10.947255911023573, -0.2752922154789972],
            [10.949146490512874, -0.28169702178671113],
            [10.95299962588422, -0.27932022165079845],
            [10.957184753945432, -0.27947241322671645],
            [10.958714905876738, -0.28348859369317214],
            [10.95782669241674, -0.2868146717990929],
            [10.954002003728606, -0.28854811125917806],
            [10.945143945646388, -0.29029206293821974],
            [10.944244895503676, -0.29330731031345586],
            [10.938674807916508, -0.2903748283071716],
            [10.932935730417366, -0.29339686859157116],
            [10.93141851597658, -0.2988372896282566],
            [10.924413337737056, -0.2991957159818059],
            [10.921220206575885, -0.3036261225608742],
            [10.923828206770994, -0.30811618132837065],
            [10.92377601355702, -0.3128069745401672],
            [10.932420768590317, -0.3131075486269443],
            [10.93282907641788, -0.3196454106779163],
            [10.930739761605247, -0.3234554423650209],
            [10.937826537180337, -0.3299257787967906],
            [10.937381607550604, -0.36325233527336204],
            [10.936653235953028, -0.44673200542501007],
            [10.93466914766253, -0.4540980577955186],
            [10.937035612911718, -0.45784424306667393],
            [10.936627779579016, -0.46451270856572835],
            [10.937758478592956, -0.4708581435805225],
            [10.943160700765501, -0.46883409228902695],
            [10.947122741868426, -0.4700112440036837],
            [10.951750612258293, -0.466573658488538],
            [10.958003472042195, -0.46931506577661636],
            [10.959800975133353, -0.47372079067203754],
            [10.957162336768096, -0.47797497056500066],
            [10.962186778266556, -0.4809496509752535],
            [10.96690425116611, -0.48948222599194163],
            [10.968186701522646, -0.496934998651737],
            [10.970514717227077, -0.49782716288255613],
            [10.973361044841818, -0.503511554732854],
            [10.971148999677427, -0.5074607290412746],
            [10.972233687806375, -0.5113178775739637],
            [10.970183580734307, -0.5140955704426372],
            [10.973172463150606, -0.524454296628704],
            [10.971242390732, -0.5271577890206676],
            [10.970966570438229, -0.5316854463497708],
            [10.9661515267456, -0.5324914204085116],
            [10.964095199781005, -0.535483856026783],
            [10.966595518287706, -0.5389708471199671],
            [10.96706673676733, -0.5430181001299978],
            [10.964018444700272, -0.5477942419683014],
            [10.963172618620826, -0.5538589550464303],
            [10.965929629198476, -0.556885339602392],
            [10.965810053487232, -0.5625094473441896],
            [10.959845212935745, -0.5652554101984717],
            [10.960886591331894, -0.5740170346790212],
            [10.957421931011027, -0.5748447295773841],
            [10.95482568715833, -0.5813693123415972],
            [10.957909647840717, -0.5859773437672349],
            [10.951339074713504, -0.5946964840378108],
            [10.94806223247919, -0.5966106105686965],
            [10.943637484115914, -0.5950647299053282],
            [10.936040929394547, -0.597916788902358],
            [10.931874058144945, -0.5978889188662125],
            [10.92936713941871, -0.6035500353143269],
            [10.925372292477018, -0.6062436351382128],
            [10.92355117453735, -0.6095457800719325],
            [10.92595040435919, -0.6123732481046962],
            [10.926736979633166, -0.6186508389553326],
            [10.932113207050637, -0.6205967168747893],
            [10.937231947878363, -0.626544484825306],
            [10.932938799825903, -0.6335165008342192],
            [10.929704387196745, -0.636725692077885],
            [10.932217852876986, -0.6418191027726426],
            [10.92987671765634, -0.6522461200655814],
            [10.93078133300285, -0.6557679684965612],
            [10.92756539938805, -0.6586663133037344],
            [10.926841488774672, -0.6673422467027852],
            [10.927632309696962, -0.6734008823777158],
            [10.921279377063938, -0.675137505545926],
            [10.918431682521954, -0.6730296735938129],
            [10.913796785416435, -0.6764291360068008],
            [10.911256057474231, -0.676339571902011],
            [10.906565646004523, -0.683747486575367],
            [10.908158316909416, -0.6874631346086074],
            [10.908196694516617, -0.6927905476359931],
            [10.900685194102, -0.6991400430057084],
            [10.898290966914352, -0.6959286108717594],
            [10.888569482014098, -0.6973131455745154],
            [10.885995917136697, -0.6929571107883967],
            [10.887395178029612, -0.6847054305427558],
            [10.885704049106081, -0.6816110230115977],
            [10.882070808032255, -0.6810653045741104],
            [10.875760489391702, -0.6856416608890967],
            [10.872339511425722, -0.6816387877690295],
            [10.865085148914988, -0.6809806071285676],
            [10.865162817721227, -0.6738815393632709],
            [10.867117693694418, -0.6717729947619033],
            [10.863142048933714, -0.6629882839618357],
            [10.86043936954889, -0.6623834987619952],
            [10.860077761410684, -0.6554184166682825],
            [10.857642631108714, -0.645824030114954],
            [10.854955004758366, -0.6455259575159612],
            [10.849532852714107, -0.637952991559338],
            [10.85060292561575, -0.6332760362472816],
            [10.84906110782315, -0.6292802386682527],
            [10.852719692744104, -0.6256300309338935],
            [10.852476470592238, -0.6206201807046475],
            [10.856331359202555, -0.6180678169216177],
            [10.853992367438382, -0.6156083093315369],
            [10.8516640346293, -0.6092350282795108],
            [10.850984304623086, -0.6037938886779428],
            [10.852175267204752, -0.5992618967837833],
            [10.851163594542781, -0.5942985936683158],
            [10.852817708907903, -0.5889705066909221],
            [10.847640880958142, -0.5863675790181732],
            [10.843992188558758, -0.5788201671623261],
            [10.847547853064508, -0.5758102697556656],
            [10.84022032725442, -0.5700388506215769],
            [10.840249570574633, -0.564650190546846],
            [10.836403006579543, -0.5629175931962953],
            [10.834533068798274, -0.5655430285621189],
            [10.828194845919121, -0.5667824569821357],
            [10.825013501518452, -0.5627936280731315],
            [10.815027065134776, -0.5676287190297907],
            [10.815201812753152, -0.5757444574886244],
            [10.811437074643413, -0.5759974809913794],
            [10.805246918284544, -0.5838400772226414],
            [10.801231270794046, -0.5847953623367589],
            [10.793268833546753, -0.5820884667492252],
            [10.789532011084152, -0.5854806036136102],
            [10.785400310030022, -0.583638396292862],
            [10.786088451144092, -0.5761684140571042],
            [10.783081277929735, -0.5752174041608902],
            [10.78325212376175, -0.5681039800698804],
            [10.785817555299431, -0.5659744164426824],
            [10.785434961197206, -0.5612381045476189],
            [10.789876270812401, -0.5583186381168549],
            [10.784795984431826, -0.5484762271434811],
            [10.787455900984469, -0.5460967793529918],
            [10.7837834500497, -0.5384049046666346],
            [10.783919505099094, -0.5346004416806397],
            [10.781190739313772, -0.5306551465399347],
            [10.704231127269827, -0.5271314099341962],
            [10.705314266682326, -0.5212821135698458],
            [10.708134372026358, -0.5165215315911947],
            [10.712036635273154, -0.5182695968368424],
            [10.71701171343848, -0.5145923439247727],
            [10.715132050089938, -0.5069830069070685],
            [10.717200877361282, -0.5019671800121165],
            [10.720528866367955, -0.49742090769109243],
            [10.724997288332524, -0.495718434482226],
            [10.723283600509196, -0.49017497174882474],
            [10.727145452490195, -0.4850658703644351],
            [10.724593459789872, -0.4825217598513979],
            [10.725745508807584, -0.47743082552917454],
            [10.724657528746807, -0.4718086939778288],
            [10.734621420411095, -0.46739834392961144],
            [10.734242091408321, -0.46261977737894566],
            [10.728880362589207, -0.4623266982627744],
            [10.724976354178358, -0.4598388965108282],
            [10.724949922845147, -0.44906893640073103],
            [10.722530876015362, -0.44777259422313737],
            [10.722964917882676, -0.4392243247343362],
            [10.716962224058223, -0.4375995132349214],
            [10.710918964201813, -0.4283432355687355],
            [10.714339104987145, -0.42432521911716664],
            [10.713674488610595, -0.4161832933634436],
            [10.706970207602941, -0.4107181885666923],
            [10.70753810037766, -0.40576545642057327],
            [10.703615980782688, -0.39911811685303095],
            [10.702290705970277, -0.38672085691964336],
            [10.704496877791518, -0.3840253459262247],
            [10.70426564528933, -0.37823020567910554],
            [10.700024127651139, -0.3748220909431374],
            [10.700286802983578, -0.3659816767642914],
            [10.693212616399146, -0.3600300130518586],
            [10.695628780956039, -0.356776470360823],
            [10.692301924903575, -0.3527672706855495],
            [10.687060304565573, -0.3531254228613035],
            [10.684003088645186, -0.350715794292662],
            [10.67238376605235, -0.343947247998892],
            [10.670611036709964, -0.3403706634699065],
            [10.667014805308689, -0.3404530522146208],
            [10.666952059959716, -0.3354666392770537],
            [10.662960240186063, -0.3320152719888439],
            [10.66269759135109, -0.31179090412687516],
            [10.661616223766178, -0.2930558066903058]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.74568613356745, "lat": 37.55715927302829 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21071"],
        "coty_name": ["Floyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Floyd County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00516882"
      },
      "bbox": [
        10.661616223766178, -0.6991400430057084, 10.973361044841818,
        -0.233984207171715
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.900595864168853, -1.0865900264281303],
            [6.948123788302751, -1.0498354003935353],
            [7.015148669434365, -0.9974247939410834],
            [7.063073254400796, -0.9595544630806028],
            [7.135115541832945, -0.9276914576741704],
            [7.136546143974151, -0.9255924847790818],
            [7.2241979949082795, -0.8355716469664796],
            [7.230057221375766, -0.8465285635459548],
            [7.237145029585282, -0.8544187248262236],
            [7.238527217986725, -0.8584587721272624],
            [7.237123487555269, -0.8650897019557644],
            [7.234075449507224, -0.8703028963637238],
            [7.239403250673758, -0.8718817137484841],
            [7.244109057214, -0.8759491946781601],
            [7.245366876921366, -0.8802448289758986],
            [7.249029025062331, -0.88533798610283],
            [7.248965968348473, -0.8899355854492986],
            [7.243416869947559, -0.8976148442814212],
            [7.2425339830030335, -0.902544630713322],
            [7.245314198237974, -0.90928478470509],
            [7.242250917667997, -0.9169996358422023],
            [7.2488337835738, -0.923899989484585],
            [7.248967768279009, -0.927911763644706],
            [7.247183088816672, -0.933610140195497],
            [7.24693029025109, -0.9392417947640329],
            [7.24930679956921, -0.9444248614142974],
            [7.251176377784592, -0.9585079997529294],
            [7.25496138276375, -0.9670916444065119],
            [7.254875246388998, -0.9772236876417633],
            [7.2563131486032, -0.9797142854674835],
            [7.269818860549898, -0.9916912629974167],
            [7.274594902230087, -0.9949855246091046],
            [7.276405958143967, -1.0047119728143943],
            [7.282849221622207, -1.0045633102105826],
            [7.283530659713637, -1.0016874645866174],
            [7.289460401212411, -1.000058356043328],
            [7.292215090725748, -1.0013326999724679],
            [7.295029963427878, -1.0066112786886714],
            [7.299122619796325, -1.0110526698581992],
            [7.302542619984008, -1.0090516379958363],
            [7.303440377872002, -1.0137587419486518],
            [7.301880688021911, -1.0161861991180232],
            [7.297047009309783, -1.0182083777314914],
            [7.292959457057816, -1.0251722901514626],
            [7.295194210473497, -1.027910612123605],
            [7.300189781018158, -1.0266199711090178],
            [7.301875780422213, -1.0329498900488456],
            [7.299810163499184, -1.0359164019729865],
            [7.2967247290606085, -1.0354968315384532],
            [7.29266937398219, -1.0384803065231014],
            [7.287411486854009, -1.0516552266613035],
            [7.289828501668663, -1.0548859729726439],
            [7.286120391102862, -1.059164232294101],
            [7.279944300777928, -1.0595366991329227],
            [7.274564492458752, -1.0682139953969447],
            [7.27601679551578, -1.0741195025790493],
            [7.274672326383518, -1.0798709680339196],
            [7.271333871040066, -1.079242186236325],
            [7.272266815575911, -1.0857152163816959],
            [7.275387848651423, -1.0894569287733469],
            [7.271498314953149, -1.0949915925549938],
            [7.263560701657058, -1.0946828132926252],
            [7.262652488135198, -1.0911859901084149],
            [7.258515818238487, -1.0929438254076191],
            [7.256797269533637, -1.0891872618089615],
            [7.253786521287745, -1.0877989245901376],
            [7.245795237783392, -1.095014282271111],
            [7.246203454297634, -1.1021088932369862],
            [7.2484729963122385, -1.1027022953874437],
            [7.25146569280185, -1.1075889542872266],
            [7.248301964878963, -1.1103493558248099],
            [7.245247726781284, -1.1154728089242407],
            [7.242822814696728, -1.1168894496699968],
            [7.248377822936298, -1.1215899306137402],
            [7.243613787530284, -1.1287481755468272],
            [7.241991918296066, -1.134426437361548],
            [7.244064306899672, -1.1409804007108837],
            [7.241697984635602, -1.1468316572863884],
            [7.243438942968305, -1.1527334858252594],
            [7.255103955882147, -1.156677576378002],
            [7.261427157418501, -1.1570091831366534],
            [7.258783811489096, -1.160439088714191],
            [7.261974342962324, -1.1650124064829164],
            [7.25991053999868, -1.1681158199351325],
            [7.269810116540503, -1.1694277928198196],
            [7.270237795378268, -1.1760692844877476],
            [7.275870353140114, -1.1786332006797613],
            [7.2781437300235, -1.1819545320903806],
            [7.278565848196498, -1.186421032771861],
            [7.281765071979073, -1.1890373529849543],
            [7.2800210920460975, -1.1930771471998938],
            [7.284394732656865, -1.1957057776269977],
            [7.2874929363829075, -1.1948803624204256],
            [7.292075989060459, -1.1996375538322552],
            [7.293192741940342, -1.2044155662791776],
            [7.30824013980165, -1.2062180948376988],
            [7.311390234334136, -1.208173781101461],
            [7.308553290704362, -1.213227873791867],
            [7.307298449387576, -1.2180517141940028],
            [7.3090879574957315, -1.2233112688262586],
            [7.301308829438131, -1.2325208200135747],
            [7.301123724006359, -1.2385917235950192],
            [7.296415186327322, -1.239827359902092],
            [7.294207976054473, -1.243318668590063],
            [7.29451751421839, -1.2476564171254894],
            [7.287123204419583, -1.247991387655858],
            [7.286042587982199, -1.2494281351731682],
            [7.280212608352506, -1.2468086106812164],
            [7.274184065063021, -1.2497678330913322],
            [7.275304458126807, -1.2623072955903305],
            [7.273653765413369, -1.267582832532392],
            [7.268191603094803, -1.2703235163641997],
            [7.264495474808885, -1.2742228850962445],
            [7.200641137012383, -1.2849489615220167],
            [7.178207527595142, -1.2888887567597578],
            [7.173868190411522, -1.2903678764118136],
            [7.16946322251076, -1.297832401388645],
            [7.165150102353218, -1.3008400172914127],
            [7.159674344641099, -1.302910591234799],
            [7.159403653977734, -1.3070496526271553],
            [7.156948034383463, -1.3109920453760309],
            [7.151500008278849, -1.3131344414694963],
            [7.12844672493142, -1.3068048509049042],
            [7.069608632634634, -1.2901133393733115],
            [7.046720204278638, -1.2801173560806036],
            [7.032169107111513, -1.278727035571541],
            [7.022523314155902, -1.2800745396848354],
            [7.022721156179585, -1.2780314698469668],
            [7.017429817575301, -1.2737884909559813],
            [7.014599527517034, -1.2751614058232537],
            [7.007723064988981, -1.271926150007953],
            [7.006288507538705, -1.2654882514225738],
            [7.001229133947645, -1.263693478766652],
            [6.993931775603507, -1.2527336917161958],
            [6.989314824339269, -1.256596548599792],
            [6.984748519172377, -1.2526337323205299],
            [6.981877818886024, -1.2542369814222112],
            [6.980776080823603, -1.24935354664347],
            [6.978104663069418, -1.2448866379737042],
            [6.974526689201325, -1.2421899051986134],
            [6.968213189881795, -1.244332729764383],
            [6.966421068388329, -1.2407951488051772],
            [6.9643079619015, -1.2244009726639067],
            [6.956904908089731, -1.2262983187864287],
            [6.957541388419744, -1.2302304212061803],
            [6.9529931264471205, -1.2398852988228601],
            [6.9442750285900186, -1.2373609076290302],
            [6.944945300585915, -1.2323933051897265],
            [6.941175607886998, -1.2292709614704478],
            [6.947421970260002, -1.2261836528973655],
            [6.954399994732085, -1.220871796043522],
            [6.953438295730432, -1.2183146309679163],
            [6.948243909280636, -1.2178446521799249],
            [6.945353675684957, -1.2210543944986574],
            [6.942546003728218, -1.2165060141136366],
            [6.937430718126192, -1.2115496105719537],
            [6.932928405590322, -1.2155410135318505],
            [6.931598326400268, -1.211856314132609],
            [6.932446431652874, -1.2069645844735688],
            [6.930080857878342, -1.2037870236305812],
            [6.924212776264637, -1.2033535447031716],
            [6.917394547511344, -1.1940168175682389],
            [6.922156838499772, -1.1909360036446623],
            [6.921256943983088, -1.1879891112525736],
            [6.923873411121085, -1.1814964286019076],
            [6.9296854455438766, -1.1812293758115067],
            [6.927678979695697, -1.1771836535512625],
            [6.923892022818962, -1.178476143733968],
            [6.921262506764156, -1.1754356983938743],
            [6.920160716593596, -1.1684904595073804],
            [6.922750872595227, -1.1671770463108597],
            [6.920225015733668, -1.159453137115701],
            [6.922618848823644, -1.153738548593396],
            [6.920250726838796, -1.1499174990651808],
            [6.921543658127269, -1.1469196401127841],
            [6.918173671955038, -1.1436635270115734],
            [6.915976921377628, -1.145172874279482],
            [6.91065167894606, -1.143810182136939],
            [6.910416074227311, -1.1371597968234288],
            [6.913921594712112, -1.1326099279932809],
            [6.912448163690015, -1.1258577506382048],
            [6.9164333661404145, -1.120419047311015],
            [6.917148280060062, -1.1171063728948984],
            [6.911454794092026, -1.1184661706244279],
            [6.908750029138114, -1.115937555310023],
            [6.906426675029145, -1.119906879316952],
            [6.898098715215973, -1.1199548895711737],
            [6.897665384123508, -1.1215933231969444],
            [6.900735298799447, -1.1287308274309662],
            [6.900344842687073, -1.1335595607874323],
            [6.896467545762032, -1.1343580686043218],
            [6.891914813032223, -1.1320084489936826],
            [6.889456227422863, -1.1284973429250693],
            [6.885154342039785, -1.1292740932805652],
            [6.87997584780408, -1.1241728377258924],
            [6.873308856743193, -1.1213433285598977],
            [6.873853546986321, -1.1182819566738682],
            [6.877225975171078, -1.1138658810484012],
            [6.883944701763169, -1.107800737416664],
            [6.885575167758431, -1.0987725005246658],
            [6.88939574114191, -1.096200881574946],
            [6.894302360273906, -1.0960808956868089],
            [6.893793172283155, -1.0924960400425525],
            [6.900188018652453, -1.0947695140156994],
            [6.900595864168853, -1.0865900264281303]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.54082132361714,
          "lat": 37.308825737219784
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21107"],
        "coty_name": ["Hopkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hopkins County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00516900"
      },
      "bbox": [
        6.873308856743193, -1.3131344414694963, 7.311390234334136,
        -0.8355716469664796
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.302542619984008, -1.0090516379958363],
            [7.337673953700951, -1.011299704979713],
            [7.347770041724299, -1.0116275516658193],
            [7.355358975583361, -1.0137566608946251],
            [7.35606756601078, -1.012438881264895],
            [7.364760703379285, -1.0146585474191938],
            [7.371437823823047, -1.0124081512224297],
            [7.398355231089424, -0.9781168767860875],
            [7.444575749140369, -0.9758779213541332],
            [7.448993972521182, -0.9716637380612135],
            [7.453935095707185, -0.9704312382614224],
            [7.45554341225733, -0.9744744513942278],
            [7.456240084050042, -0.982318865169518],
            [7.458132183210178, -0.9898755315020006],
            [7.456654712480143, -0.9982232375242794],
            [7.462017798647066, -1.008137023919604],
            [7.4613635574844075, -1.0104101861922343],
            [7.450274450979339, -1.0205685602670291],
            [7.440373327017124, -1.0277166267910092],
            [7.439880219405555, -1.0332811647121956],
            [7.431671009171014, -1.048333805420014],
            [7.432389803221823, -1.054099174498624],
            [7.434870879143429, -1.0569750744745665],
            [7.438986679111514, -1.0556580999272693],
            [7.445746175004797, -1.0626282753254614],
            [7.452672220500159, -1.063585367577468],
            [7.460013704200274, -1.0585098810387148],
            [7.461932361294716, -1.0543486128522168],
            [7.462712179739945, -1.0480602836901083],
            [7.467045709251781, -1.0382416690140446],
            [7.467327826409083, -1.0308652185646237],
            [7.4689828401211305, -1.0260083922172285],
            [7.481131481060332, -1.0140852190953673],
            [7.495872269083682, -1.0137141504906464],
            [7.504960785350618, -1.0156321973123692],
            [7.513169921934964, -1.0183260805819958],
            [7.519894202071394, -1.022414273152477],
            [7.525438011675455, -1.0274707803024088],
            [7.529381894588692, -1.0346187363666408],
            [7.535279678572588, -1.042429955318501],
            [7.540421499770881, -1.0463847893356089],
            [7.544048243307457, -1.052153581211522],
            [7.549735703458925, -1.0541230416861342],
            [7.552264125767328, -1.05761671780151],
            [7.552595340722068, -1.0619876622669957],
            [7.550776287515176, -1.0682577166635732],
            [7.552094414062876, -1.076109658167325],
            [7.5573719004164355, -1.0831955197909744],
            [7.5594267874260925, -1.091995450684938],
            [7.558144658847546, -1.1041390350757423],
            [7.559662194145278, -1.1089132061562104],
            [7.562390898006087, -1.1111564221364594],
            [7.569513452088196, -1.119809280292948],
            [7.573878720648163, -1.1201671006352873],
            [7.575844976738466, -1.1162344088011087],
            [7.57950237051991, -1.115921077437153],
            [7.582650479090385, -1.11890654389992],
            [7.584286996193637, -1.1265420851224284],
            [7.5887188179380685, -1.1297202006801694],
            [7.590429248781435, -1.1354368969996738],
            [7.593758460884736, -1.1380426251483644],
            [7.598161374867293, -1.1380588440935755],
            [7.6009311198810305, -1.1349299403304494],
            [7.6090120873070175, -1.1327386299512379],
            [7.615916351229329, -1.1401002779805365],
            [7.612553538639158, -1.1438981335976843],
            [7.613681724750377, -1.1488254177311663],
            [7.620761361102814, -1.1498140570807733],
            [7.624990507033611, -1.152466095732276],
            [7.6306267125454985, -1.1602606473787782],
            [7.627610256418259, -1.161159771911099],
            [7.625611777465034, -1.1652683283354228],
            [7.626707575859226, -1.170690438251603],
            [7.6297349982188924, -1.1762962859994723],
            [7.630791626151405, -1.1808864196630786],
            [7.624630661635728, -1.1804107279691805],
            [7.6258115010615395, -1.1838703576596334],
            [7.632447601193896, -1.1884229634090422],
            [7.637954622233052, -1.1845614152202402],
            [7.6400137809090385, -1.186910124094262],
            [7.637089385528448, -1.1950875078988612],
            [7.6329026891995655, -1.1963049847667429],
            [7.629615047421253, -1.195171323204561],
            [7.622024052782643, -1.1960211215667855],
            [7.6178787994989765, -1.1979122247818497],
            [7.618027610237145, -1.2050395546835997],
            [7.616124652473651, -1.2120287017868254],
            [7.6139556581107275, -1.2146388524771319],
            [7.6148841552960125, -1.223720692212234],
            [7.617511858125209, -1.2301663548062252],
            [7.612774637892911, -1.2347513303897555],
            [7.607927063647002, -1.2365637939226264],
            [7.611706184572483, -1.2397790834707982],
            [7.618176770878092, -1.2318915886728703],
            [7.627383059548166, -1.2380707500699955],
            [7.625838374057788, -1.2484300243271842],
            [7.632461138255334, -1.2471144788725814],
            [7.632869187753203, -1.2433413095581876],
            [7.637113417895362, -1.242017185448154],
            [7.640031463072094, -1.2469851429608547],
            [7.638110806844063, -1.2498408006116946],
            [7.641101098706951, -1.2548890020540195],
            [7.645316142951851, -1.2577272659507233],
            [7.648026526223478, -1.256772076712213],
            [7.652011787571957, -1.2622394416979883],
            [7.646507598466742, -1.2625191463814383],
            [7.641026140250988, -1.2611026718377805],
            [7.63914370640621, -1.2643937397653808],
            [7.639674145929953, -1.2681731494522794],
            [7.6422924922481315, -1.271210524304603],
            [7.643856707350973, -1.2813201263049916],
            [7.64571602799887, -1.284481010127095],
            [7.642044482003783, -1.2862980003169122],
            [7.638089142401024, -1.2861361295123874],
            [7.63814077681115, -1.289707914439529],
            [7.632723602551096, -1.2907568881150449],
            [7.627721489107301, -1.2944722838568539],
            [7.623514425880479, -1.2950243176412979],
            [7.609389999598887, -1.2997705114334492],
            [7.608175920054694, -1.3032785287360773],
            [7.611328365270892, -1.3074654911869232],
            [7.5833479423004615, -1.3054628509947854],
            [7.564292946136702, -1.3115160317162593],
            [7.524153148102758, -1.3238189139164616],
            [7.474617559764466, -1.3449906565351903],
            [7.434778044197768, -1.3503906906717948],
            [7.370961568230672, -1.3588628776657017],
            [7.369741890437318, -1.3503487064438084],
            [7.368154623160256, -1.34901109354893],
            [7.362925265353093, -1.3502597906616058],
            [7.361727287394703, -1.346187656034673],
            [7.367270015081077, -1.3462989002811778],
            [7.3725657987465585, -1.344672708917185],
            [7.370797695198795, -1.3409128193023734],
            [7.372715733781038, -1.334818563305214],
            [7.369416318011573, -1.333372472369461],
            [7.367925830612915, -1.328971555784192],
            [7.363980414198588, -1.3249674142046701],
            [7.360833526405367, -1.3275162196930932],
            [7.354818374930884, -1.3305460733317236],
            [7.348797458007495, -1.329312263109588],
            [7.343719309507471, -1.3244889274186316],
            [7.342572320357903, -1.3206125626278558],
            [7.338594050022085, -1.314487541473508],
            [7.3433922289414655, -1.3122875421792382],
            [7.338888586549972, -1.3056746035112952],
            [7.340110252275483, -1.3043295971936193],
            [7.337229991757351, -1.2986205412954683],
            [7.337901048930493, -1.2935155767520425],
            [7.330110804162907, -1.2894760236379947],
            [7.3268933822531395, -1.2903066746746377],
            [7.3253781958751585, -1.294466123248373],
            [7.321084543136073, -1.293528008803943],
            [7.31498007639388, -1.2898614939097168],
            [7.306092840991411, -1.277354376076042],
            [7.29797084235941, -1.271891528056661],
            [7.299749465505806, -1.2697714392773305],
            [7.2966174028953, -1.2508481894140848],
            [7.29451751421839, -1.2476564171254894],
            [7.294207976054473, -1.243318668590063],
            [7.296415186327322, -1.239827359902092],
            [7.301123724006359, -1.2385917235950192],
            [7.301308829438131, -1.2325208200135747],
            [7.3090879574957315, -1.2233112688262586],
            [7.307298449387576, -1.2180517141940028],
            [7.308553290704362, -1.213227873791867],
            [7.311390234334136, -1.208173781101461],
            [7.30824013980165, -1.2062180948376988],
            [7.293192741940342, -1.2044155662791776],
            [7.292075989060459, -1.1996375538322552],
            [7.2874929363829075, -1.1948803624204256],
            [7.284394732656865, -1.1957057776269977],
            [7.2800210920460975, -1.1930771471998938],
            [7.281765071979073, -1.1890373529849543],
            [7.278565848196498, -1.186421032771861],
            [7.2781437300235, -1.1819545320903806],
            [7.275870353140114, -1.1786332006797613],
            [7.270237795378268, -1.1760692844877476],
            [7.269810116540503, -1.1694277928198196],
            [7.25991053999868, -1.1681158199351325],
            [7.261974342962324, -1.1650124064829164],
            [7.258783811489096, -1.160439088714191],
            [7.261427157418501, -1.1570091831366534],
            [7.255103955882147, -1.156677576378002],
            [7.243438942968305, -1.1527334858252594],
            [7.241697984635602, -1.1468316572863884],
            [7.244064306899672, -1.1409804007108837],
            [7.241991918296066, -1.134426437361548],
            [7.243613787530284, -1.1287481755468272],
            [7.248377822936298, -1.1215899306137402],
            [7.242822814696728, -1.1168894496699968],
            [7.245247726781284, -1.1154728089242407],
            [7.248301964878963, -1.1103493558248099],
            [7.25146569280185, -1.1075889542872266],
            [7.2484729963122385, -1.1027022953874437],
            [7.246203454297634, -1.1021088932369862],
            [7.245795237783392, -1.095014282271111],
            [7.253786521287745, -1.0877989245901376],
            [7.256797269533637, -1.0891872618089615],
            [7.258515818238487, -1.0929438254076191],
            [7.262652488135198, -1.0911859901084149],
            [7.263560701657058, -1.0946828132926252],
            [7.271498314953149, -1.0949915925549938],
            [7.275387848651423, -1.0894569287733469],
            [7.272266815575911, -1.0857152163816959],
            [7.271333871040066, -1.079242186236325],
            [7.274672326383518, -1.0798709680339196],
            [7.27601679551578, -1.0741195025790493],
            [7.274564492458752, -1.0682139953969447],
            [7.279944300777928, -1.0595366991329227],
            [7.286120391102862, -1.059164232294101],
            [7.289828501668663, -1.0548859729726439],
            [7.287411486854009, -1.0516552266613035],
            [7.29266937398219, -1.0384803065231014],
            [7.2967247290606085, -1.0354968315384532],
            [7.299810163499184, -1.0359164019729865],
            [7.301875780422213, -1.0329498900488456],
            [7.300189781018158, -1.0266199711090178],
            [7.295194210473497, -1.027910612123605],
            [7.292959457057816, -1.0251722901514626],
            [7.297047009309783, -1.0182083777314914],
            [7.301880688021911, -1.0161861991180232],
            [7.303440377872002, -1.0137587419486518],
            [7.302542619984008, -1.0090516379958363]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.14197742706989, "lat": 37.21579113002404 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21177"],
        "coty_name": ["Muhlenberg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Muhlenberg County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00516935"
      },
      "bbox": [
        7.241697984635602, -1.3588628776657017, 7.652011787571957,
        -0.9704312382614224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.971195040602028, -1.3112054799811597],
            [8.981749911574324, -1.2541636985470788],
            [8.983587122338529, -1.2368550302997257],
            [8.998324082858314, -1.2136035791389692],
            [9.010562879119531, -1.1967861762147802],
            [9.031504049135572, -1.1534972916338908],
            [9.053467660503342, -1.1093408926604367],
            [9.060010733647049, -1.097335354327396],
            [9.089325467560778, -1.0324811608998474],
            [9.154960347759648, -1.0991388355814677],
            [9.168811762311933, -1.1083680797157731],
            [9.197917006937839, -1.0998727869295677],
            [9.208972235804206, -1.0894126917827411],
            [9.209199355708451, -1.1035423085376896],
            [9.207758596818026, -1.1188715664195716],
            [9.213439394934065, -1.1591352037687812],
            [9.251067493393757, -1.194526024882266],
            [9.274311190431998, -1.2023664896119601],
            [9.223767189686566, -1.2613314391529313],
            [9.218631234203908, -1.2563240527054087],
            [9.211724428469516, -1.2511588345355498],
            [9.205577313796672, -1.24871130869071],
            [9.198049862627991, -1.2481300715785446],
            [9.194061778550003, -1.2494772639791856],
            [9.189126647721624, -1.2552002361554349],
            [9.187975560380803, -1.261473052000347],
            [9.187569660735715, -1.273215869573446],
            [9.188445373460327, -1.284852698901812],
            [9.185490299633962, -1.2953906269818014],
            [9.179656210262738, -1.300804587678665],
            [9.173647014716265, -1.30389493945677],
            [9.143890638860602, -1.3297298721877637],
            [9.110812270951701, -1.3625864862000723],
            [9.07184150743537, -1.3989905753751564],
            [9.004600516783851, -1.3592277808066724],
            [8.999578455745546, -1.3586639301908594],
            [8.990545929547924, -1.3544311917481298],
            [8.986935431688185, -1.351506254018186],
            [8.979466710762127, -1.348507319223767],
            [8.976124211100576, -1.348560517172578],
            [8.973003634771478, -1.3526732227590674],
            [8.974680916999885, -1.3570712445199247],
            [8.98560528176286, -1.3641858461110925],
            [8.992125667230736, -1.3718903633995],
            [8.994151135157637, -1.3770356996329838],
            [8.992341703903609, -1.3805232062877717],
            [8.983477474505746, -1.384815854040555],
            [8.975698002217522, -1.3835684631471206],
            [8.971492510790297, -1.381502796723885],
            [8.967332261180896, -1.376331385957244],
            [8.967090765642029, -1.3674365083168143],
            [8.964168391037951, -1.3602043348015562],
            [8.940515237224252, -1.342287924499173],
            [8.971195040602028, -1.3112054799811597]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.05864534413016,
          "lat": 36.991097428745476
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21207"],
        "coty_name": ["Russell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Russell County"],
        "coty_fp_code": "207",
        "coty_gnis_code": "00516950"
      },
      "bbox": [
        8.940515237224252, -1.3989905753751564, 9.274311190431998,
        -1.0324811608998474
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.284456668415284, -5.701732201672718],
            [2.2906709527656717, -5.701582799392507],
            [2.3605256909218264, -5.69986987795275],
            [2.4541699803356076, -5.6980601274114075],
            [2.5290345697001992, -5.6965162599512675],
            [2.5298632930794644, -5.69957812249718],
            [2.533658827078943, -5.701531955313936],
            [2.532403606373749, -5.706075223888254],
            [2.533353618692456, -5.712506320813021],
            [2.530374755966051, -5.714565026694559],
            [2.528833189362986, -5.72120991090507],
            [2.5258935547166876, -5.723605915705133],
            [2.526594143419603, -5.728742102514825],
            [2.5220195472296174, -5.732213908815127],
            [2.52201406751586, -5.736761285849086],
            [2.5258543815046988, -5.738105180492572],
            [2.5257477903028662, -5.742095220234596],
            [2.522270677862684, -5.747767906819775],
            [2.527409665075276, -5.747915303360986],
            [2.5316322589146236, -5.750072250676871],
            [2.5325029112134803, -5.76157323359927],
            [2.5383393530288245, -5.767741884233216],
            [2.5412730119611653, -5.779156352173309],
            [2.546463941883334, -5.780304659674575],
            [2.5520505077041555, -5.788067810714482],
            [2.5502153383202724, -5.790836778989322],
            [2.554710333909008, -5.793085286656657],
            [2.560807682015031, -5.78776165445963],
            [2.5649408854031446, -5.787105956277312],
            [2.5688423654536856, -5.7963402586825925],
            [2.574566885965203, -5.796379067283671],
            [2.572526630587659, -5.8052223759192945],
            [2.5747533221924894, -5.809705669609021],
            [2.567269485450284, -5.8082102550092065],
            [2.564428895615101, -5.812404811588089],
            [2.5673275923902503, -5.818996339599471],
            [2.569449228101139, -5.828581071025914],
            [2.571929112399235, -5.829369637079356],
            [2.5789807755698426, -5.834816144294645],
            [2.5805157527230884, -5.845502071507743],
            [2.5915178884182786, -5.843479019338329],
            [2.586738266009508, -5.851034748898758],
            [2.5874781893459127, -5.854043791317641],
            [2.591499647833204, -5.8578543921483135],
            [2.5874050009396665, -5.862000441315587],
            [2.5805000412131123, -5.863814979909658],
            [2.5781621680980393, -5.865689164511996],
            [2.581614633412022, -5.873227569186382],
            [2.5881010019272104, -5.880660890567414],
            [2.586589360297441, -5.886118297080724],
            [2.588590840453839, -5.887871047190507],
            [2.587483989316848, -5.895645125770438],
            [2.5845002095321266, -5.896991880316011],
            [2.5847730677530634, -5.902016088705692],
            [2.579803964658824, -5.903821815473671],
            [2.585795924938994, -5.907705000816841],
            [2.58333566991701, -5.912849720201069],
            [2.582922756064636, -5.917302281061489],
            [2.5785989536227025, -5.919770376263774],
            [2.574170069992331, -5.926636392697254],
            [2.5746408655313595, -5.931083347703194],
            [2.582227063921388, -5.94166279326547],
            [2.5786143905217718, -5.952942957863624],
            [2.599397935165367, -5.952222650176157],
            [2.6020741928847033, -6.069567463569836],
            [2.603421486965761, -6.14230949166085],
            [2.604383330727064, -6.178480124461369],
            [2.605152432666426, -6.215619530375508],
            [2.609545138447397, -6.215666065518225],
            [2.6100637388991372, -6.229823472822245],
            [2.611331591909815, -6.285859963435091],
            [2.6120048776793774, -6.3029311006436295],
            [2.6694464146709644, -6.301650945842371],
            [2.661067011813376, -6.309262962787206],
            [2.6564892574933476, -6.315751405266145],
            [2.6528620445212123, -6.317986783185105],
            [2.6484613737802145, -6.3174048743493705],
            [2.6363432468663213, -6.311876442557419],
            [2.6314055336283797, -6.311697023923567],
            [2.628827485925747, -6.313361152014608],
            [2.6241933381666973, -6.320965766898907],
            [2.6231038524822665, -6.327884837392904],
            [2.623906410008185, -6.331684935140968],
            [2.626815632324778, -6.335730144357374],
            [2.6329493995981794, -6.340015035147632],
            [2.6419959658426446, -6.342162247790793],
            [2.6452367896173663, -6.343762628940836],
            [2.6480227327166714, -6.349623555903158],
            [2.647433428704761, -6.35542017758905],
            [2.6418502697967825, -6.3625087210951845],
            [2.6392657426838344, -6.368712912724255],
            [2.636654122216773, -6.37842584416298],
            [2.634674876207756, -6.3900102301508],
            [2.631618029991843, -6.3936957411623565],
            [2.6299508580914064, -6.401874983244895],
            [2.6269446831291665, -6.403495027924646],
            [2.6287337287767083, -6.4073874686537975],
            [2.6273411349357194, -6.409678572225038],
            [2.634288622900421, -6.417742045224076],
            [2.6345237334695444, -6.428587455924466],
            [2.6399890545904565, -6.425835488317356],
            [2.6437389635987647, -6.42771855868568],
            [2.645650069538114, -6.4341982048888555],
            [2.6416619886781385, -6.441712004304519],
            [2.6440088002140065, -6.447537056567322],
            [2.64494890642272, -6.455202691743051],
            [2.642337009901478, -6.457118034008281],
            [2.6441077840269087, -6.461933199127686],
            [2.6427823242090205, -6.46463795994749],
            [2.637377801189779, -6.468478136778881],
            [2.634045935841025, -6.4743492398366085],
            [2.6291853141556905, -6.474279373506839],
            [2.627266124684433, -6.47761918647735],
            [2.6015213959796752, -6.47843218854664],
            [2.592896851656225, -6.476629635755701],
            [2.5895673299415853, -6.474164881051947],
            [2.5936047899956636, -6.468938459377084],
            [2.5984917180428604, -6.466653738480156],
            [2.596945758013969, -6.462774981236087],
            [2.5910769467563375, -6.465441319661501],
            [2.58764808893933, -6.463806345428636],
            [2.584587422381201, -6.4589031656155464],
            [2.5783938638034627, -6.457024868536566],
            [2.5796285705552435, -6.464264466498515],
            [2.5843069881835476, -6.467407561050055],
            [2.583595953529899, -6.471987436292028],
            [2.575247970623252, -6.470696246202052],
            [2.5750982721454627, -6.466362841168875],
            [2.572534219276213, -6.456110556856099],
            [2.5738513123763775, -6.451837381990716],
            [2.572995825714867, -6.448776229836602],
            [2.5661999170626086, -6.4447953712377615],
            [2.5585732529974434, -6.4424982874489505],
            [2.5570915311761238, -6.440039752309342],
            [2.5602586380093513, -6.433132273729948],
            [2.5502925090613995, -6.442475738056629],
            [2.545469526298625, -6.441764361579015],
            [2.5471099311127685, -6.4363339171185885],
            [2.5531353003579684, -6.4260638610329055],
            [2.5534974502033907, -6.417803114931669],
            [2.5500132759253686, -6.416226725255786],
            [2.540362798338481, -6.4189439225378635],
            [2.536339576351759, -6.424322100159087],
            [2.5327145297850904, -6.42550270133309],
            [2.5241625153238405, -6.42419139360858],
            [2.520926733154888, -6.422025825931121],
            [2.5333124523034822, -6.420429833113602],
            [2.532645084111584, -6.413477714827353],
            [2.534208385015295, -6.410533374245034],
            [2.5413721595665786, -6.407149596847518],
            [2.5415115103901185, -6.401999232156536],
            [2.532387335149375, -6.397069756052538],
            [2.530053829568452, -6.399621264070436],
            [2.5294724516150833, -6.40765616292375],
            [2.5260388832277068, -6.407634400097359],
            [2.52527962807963, -6.401326883320501],
            [2.5207409093440205, -6.39518800411709],
            [2.5120590880046003, -6.395618620874346],
            [2.51053251175905, -6.392636330416923],
            [2.5131803217554096, -6.389249804655021],
            [2.516636716208487, -6.389568343856847],
            [2.521299316116178, -6.393276844771098],
            [2.525036845395464, -6.393435915119273],
            [2.5272200834426197, -6.388113965101956],
            [2.5230052461567043, -6.3875994433326895],
            [2.518217281519928, -6.384397894634631],
            [2.5167720914712963, -6.379558547190966],
            [2.5179004712014637, -6.375050126543525],
            [2.5167923775696828, -6.37026997053759],
            [2.5117282446225144, -6.372895922754796],
            [2.511631914554794, -6.383007877338037],
            [2.5105638227273905, -6.384363342111642],
            [2.4986038761168414, -6.388812703028401],
            [2.4945241951263593, -6.38611253799644],
            [2.496513916237124, -6.382553230875476],
            [2.5025506989116044, -6.378083677714513],
            [2.5021718664006127, -6.374986972906124],
            [2.496036052239549, -6.3797498944924405],
            [2.492071423857947, -6.379227421347372],
            [2.495333784270075, -6.374780378910541],
            [2.492957433294149, -6.368540756328932],
            [2.489933764740154, -6.367614592057535],
            [2.4792197727377654, -6.3683688532221465],
            [2.4732245030787596, -6.367558540112622],
            [2.467540364078905, -6.368777958780864],
            [2.4625760661109903, -6.366311979465062],
            [2.462486695854537, -6.361596603976837],
            [2.4670400313311647, -6.362311761961645],
            [2.4680916569807305, -6.357460907862],
            [2.4713906157228114, -6.349299311425756],
            [2.476326086499932, -6.3417480568802675],
            [2.4755983859283517, -6.337308164695742],
            [2.472169645613048, -6.338380587053177],
            [2.468945469950002, -6.34276233204812],
            [2.4659269081626696, -6.351842595087906],
            [2.462650360503376, -6.354915796248461],
            [2.458390600678911, -6.3554294999049326],
            [2.455908065667521, -6.351349075310792],
            [2.4535265127034163, -6.342105312327699],
            [2.4532290847620066, -6.332927533749043],
            [2.4544209382773525, -6.327891967755994],
            [2.4583914065120847, -6.3202102388113675],
            [2.4562073569094625, -6.317772358118608],
            [2.4509566307221684, -6.319022113596489],
            [2.45040840823086, -6.323930898091871],
            [2.4408904190359113, -6.338462126160569],
            [2.4373567840159476, -6.335235450024927],
            [2.4384462402960034, -6.329824851055205],
            [2.4431652557021435, -6.325379327987244],
            [2.447169233282992, -6.324374851808273],
            [2.4384911982509747, -6.315166187697874],
            [2.434087684527279, -6.313057156744341],
            [2.426060510212856, -6.311813282098199],
            [2.4217783562842534, -6.314189072914967],
            [2.4225348656553916, -6.320298426075485],
            [2.427550501435327, -6.326329569716948],
            [2.426063457314005, -6.330333362123116],
            [2.422133968190628, -6.330156413065831],
            [2.4122353482167727, -6.327823275318857],
            [2.407213790162245, -6.323115870049413],
            [2.4052171174304724, -6.317871157108555],
            [2.406002617306081, -6.311599364370999],
            [2.4095558220547, -6.307435671370921],
            [2.4153143929364838, -6.304990601825639],
            [2.4261901827016037, -6.304020637079804],
            [2.4226491902908696, -6.300513238845517],
            [2.4171065237407032, -6.302018917299455],
            [2.4084889351177017, -6.30112553332374],
            [2.4038552169095504, -6.298945376544028],
            [2.401473242026333, -6.295290014642757],
            [2.407238313441085, -6.2929322272100165],
            [2.410916022143959, -6.2849531453916105],
            [2.415186379632768, -6.287404756983559],
            [2.4147339920641238, -6.294612822236852],
            [2.415764493550372, -6.29690310263488],
            [2.422376729237579, -6.29563731060118],
            [2.426521081585121, -6.29167211554165],
            [2.4243523816163948, -6.2869313805370375],
            [2.4201261480511937, -6.2847481051510705],
            [2.4157738795121677, -6.2777437777373954],
            [2.4066229386668634, -6.27621929299214],
            [2.399638136245297, -6.270765337501088],
            [2.4000918089178103, -6.267892955426339],
            [2.4066112004094937, -6.259849721091597],
            [2.408264519502024, -6.2540575392588265],
            [2.403204905157821, -6.255558847770029],
            [2.400731628092114, -6.245507969640338],
            [2.3934720888442924, -6.241397469036992],
            [2.39203189943087, -6.237425507174267],
            [2.3947272850909678, -6.234191909779819],
            [2.395982195338678, -6.228430073530157],
            [2.3922177711721977, -6.224101946823715],
            [2.3879737748263943, -6.225330871556778],
            [2.382519385273836, -6.2302153144231776],
            [2.3780355773542468, -6.230879458349095],
            [2.3777450511491987, -6.227258635441816],
            [2.383362454859558, -6.2250134435107505],
            [2.388090876938033, -6.221171242783513],
            [2.3856057900934338, -6.218193957794438],
            [2.3776137713862693, -6.216407222819482],
            [2.3627116050160026, -6.206964759171419],
            [2.3563236295241694, -6.205573850059315],
            [2.3545612614461633, -6.203567425649655],
            [2.3552112000097005, -6.190674620623839],
            [2.351065225027445, -6.186952139656698],
            [2.3485476308134876, -6.191666686126641],
            [2.3442724928639906, -6.1897680220236575],
            [2.3358153454831587, -6.182859578942951],
            [2.335444421203401, -6.178270844007551],
            [2.3444425814235372, -6.1828055410971645],
            [2.3508810989088054, -6.173667251883958],
            [2.3557067203792434, -6.174244507239998],
            [2.357969288374185, -6.177837435196093],
            [2.3597395135940866, -6.186670340600547],
            [2.3669421755440987, -6.186218555539335],
            [2.3677012114678413, -6.184793410969221],
            [2.3630714646678306, -6.179338799311177],
            [2.3574682875642123, -6.168950235998805],
            [2.351716295672013, -6.170753225779547],
            [2.3415533946077103, -6.172003228424643],
            [2.3383703100022677, -6.170709618426953],
            [2.335605648643696, -6.167002791614363],
            [2.335615116896005, -6.1610207135444135],
            [2.3389035970800824, -6.157686269775103],
            [2.3499246709665167, -6.153161719589357],
            [2.3547174071608876, -6.1494320038745185],
            [2.3599476877160286, -6.13991430835062],
            [2.360267661475097, -6.133681227809749],
            [2.3572873819457127, -6.129046553002362],
            [2.349205712002477, -6.128613132143027],
            [2.3427316378629466, -6.1326383422760395],
            [2.332755770538189, -6.129254933430971],
            [2.332354087261739, -6.124735101559534],
            [2.3399533837419644, -6.122941901215921],
            [2.345762120752839, -6.120245805208933],
            [2.3524078049517434, -6.124584571547416],
            [2.355744626906874, -6.123401462967062],
            [2.3567969690029997, -6.120105632217234],
            [2.353589719008498, -6.1170594798828795],
            [2.34159448832051, -6.115830334558616],
            [2.340710261951955, -6.111048564692584],
            [2.344247845798518, -6.105781801712965],
            [2.346487268324533, -6.099206849381598],
            [2.3464240061232764, -6.089825780771212],
            [2.3449097915936092, -6.0896883280764325],
            [2.341683952091404, -6.083425544665012],
            [2.3386166355482336, -6.082310992401229],
            [2.32991183003158, -6.083937104700551],
            [2.3226511883978334, -6.083166751816936],
            [2.3166717637080625, -6.079381833535737],
            [2.3166624673458083, -6.074587988829196],
            [2.321300574503566, -6.0747605426323945],
            [2.3277184231250003, -6.080203665045452],
            [2.33170359325173, -6.081187165857049],
            [2.3351917692906032, -6.079176825610842],
            [2.3293931718802368, -6.071890016946195],
            [2.324557222364879, -6.06444217774115],
            [2.3247097719783443, -6.0608198934774],
            [2.328936282508985, -6.057559880546063],
            [2.3358938405693137, -6.057823521748187],
            [2.3405087641758575, -6.055222098676727],
            [2.3422580050554145, -6.049986340898836],
            [2.3401496996351345, -6.044748017702219],
            [2.3373457488756233, -6.042850699642761],
            [2.32947686323348, -6.04296666501675],
            [2.325276439452911, -6.046055181836208],
            [2.3209813398712287, -6.052219231026142],
            [2.31836928435688, -6.053996727534738],
            [2.314927773660121, -6.050887840123546],
            [2.3143274626888126, -6.042514294166014],
            [2.3176981620928263, -6.018386160340412],
            [2.3187286310084283, -6.008454907487937],
            [2.3175793723416547, -5.999694682223248],
            [2.314241389333648, -5.996121535306183],
            [2.307075203265626, -5.994062628200402],
            [2.3013026099702745, -5.994900087745532],
            [2.2974571257506256, -5.997461142776061],
            [2.2928199083353364, -6.00309116501914],
            [2.2916460110119075, -6.006811467569571],
            [2.2873817763539424, -6.010517227453174],
            [2.2831741872006575, -6.008449734783225],
            [2.2817025110315865, -6.00492190129691],
            [2.284776923832364, -5.995691720482623],
            [2.2831045071214624, -5.987871301682381],
            [2.283823061465705, -5.986311827679831],
            [2.2981872668490357, -5.972269039906063],
            [2.3082881941830826, -5.963753902403974],
            [2.314666408336764, -5.952355104861804],
            [2.3161550839354588, -5.937544826991577],
            [2.312475193343766, -5.926434002714537],
            [2.309278642220584, -5.922732471653336],
            [2.3024838553637346, -5.921512005296336],
            [2.299095300938638, -5.923975216294975],
            [2.2925903911525474, -5.9327063414464885],
            [2.2899053764043975, -5.937794271890217],
            [2.285543230217766, -5.938975881868127],
            [2.2824987893678177, -5.935310008958558],
            [2.281640659798802, -5.929005889181206],
            [2.2841263452346756, -5.922948741960601],
            [2.2875408615581976, -5.920145254883865],
            [2.3007688975029073, -5.914650964622672],
            [2.3036304438326884, -5.912471012772892],
            [2.3082826255306825, -5.903675100963137],
            [2.3101519840708313, -5.897752959363017],
            [2.3125250869552665, -5.88488673752124],
            [2.3130798941628763, -5.875658004062863],
            [2.3127591366638707, -5.863322791311087],
            [2.311137305174042, -5.8594349367399605],
            [2.3062806987209803, -5.861916982049841],
            [2.3026303508447445, -5.872095453793291],
            [2.3010069004556097, -5.874078990435182],
            [2.2961490082775486, -5.87335583345494],
            [2.288213874483208, -5.869654495787456],
            [2.289135606467063, -5.86704054424039],
            [2.29796501451787, -5.86075114869762],
            [2.300076616248718, -5.852696397173054],
            [2.2991064359563342, -5.84961413032074],
            [2.2937961861913694, -5.846386271635517],
            [2.2884443405557593, -5.846322716037084],
            [2.28281207603073, -5.836993192766917],
            [2.282051023835977, -5.831067357366413],
            [2.281957297610466, -5.819359985297118],
            [2.2857266488473607, -5.810688977669399],
            [2.289117550133575, -5.80510123458073],
            [2.2925130958409117, -5.797216083634433],
            [2.297015708820505, -5.789140885536808],
            [2.295137781566785, -5.785521088845037],
            [2.2866716904703432, -5.778613500433431],
            [2.2786647229131134, -5.7749530010080345],
            [2.265769187029907, -5.7753259192855],
            [2.2607471786119477, -5.772499279980354],
            [2.2616481292690316, -5.768880886408436],
            [2.271309615546722, -5.7648367513271],
            [2.2731817818086157, -5.757845236580905],
            [2.27567295479393, -5.75465202346866],
            [2.2848827941496372, -5.75668318192657],
            [2.2885686347087337, -5.759293713815222],
            [2.29452720687193, -5.758334746475014],
            [2.297098280218206, -5.755277216146552],
            [2.2973385696424073, -5.750119097918769],
            [2.2932496260945725, -5.747166640435487],
            [2.2862562930838823, -5.752350461282744],
            [2.2790549237841566, -5.754117321758568],
            [2.282888338004038, -5.74539407083765],
            [2.282623783063546, -5.740868325604842],
            [2.280226046042954, -5.731985500844057],
            [2.2850712003155706, -5.72918464463269],
            [2.2884642461219165, -5.723633434645088],
            [2.287843590489588, -5.719582292176021],
            [2.2821816006326157, -5.716290472577908],
            [2.27757459259787, -5.711626038228759],
            [2.2777328312496143, -5.70781934125258],
            [2.2806595136536036, -5.707038417237612],
            [2.284456668415284, -5.701732201672718]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.60490314253605, "lat": 32.6783318292506 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22015"],
        "coty_name": ["Bossier"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Bossier Parish"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00558453"
      },
      "bbox": [
        2.2607471786119477, -6.47843218854664, 2.6694464146709644,
        -5.6965162599512675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.8788034201493575, -7.897664137065652],
            [4.885128058597665, -7.89612566414455],
            [4.886713213960876, -7.892179685528813],
            [4.882237469971227, -7.883280824061348],
            [4.879958908563916, -7.876437456168245],
            [4.877632381294244, -7.873727963407606],
            [4.878554338556073, -7.868539322234608],
            [4.877333978302839, -7.85547570964558],
            [4.881078119005647, -7.853004520877968],
            [4.880431535498599, -7.8470184409073545],
            [4.883028580248975, -7.844468500070385],
            [4.879867036230003, -7.840196192384051],
            [4.8812016633992625, -7.83619316005469],
            [4.879334522812205, -7.833768930376858],
            [4.878319347153731, -7.824655642680162],
            [4.884507118658655, -7.8208546560037435],
            [4.881206001210673, -7.817231185730146],
            [4.880168270248305, -7.809039728676822],
            [4.88121748043921, -7.806319968098669],
            [4.8857150033307555, -7.804071009767829],
            [4.884675150374099, -7.797176624544534],
            [4.881516135283105, -7.79726919541169],
            [4.880172835428468, -7.7935448788440045],
            [4.876579274102166, -7.792372219322325],
            [4.8765836544135945, -7.789134430902117],
            [4.872027724616508, -7.787578532970066],
            [4.873544928215286, -7.78382257210049],
            [4.872746470131116, -7.779953228914601],
            [4.878281471493443, -7.7794475417088815],
            [4.878561348133462, -7.770884312470322],
            [4.874079363006124, -7.7696906425193175],
            [4.874740555773661, -7.763089742699137],
            [4.867936807605111, -7.763138042460588],
            [4.863872243350031, -7.756724110271051],
            [4.86705327209326, -7.7524724410012515],
            [4.860152266032733, -7.749106170550149],
            [4.861369038073897, -7.74555299844789],
            [4.864653213825407, -7.745671309943002],
            [4.866644185775873, -7.741813706795133],
            [4.866747660262801, -7.736655201519443],
            [4.868628355149478, -7.733216313534052],
            [4.872613931009792, -7.731409702937051],
            [4.8699428893662535, -7.728080084288547],
            [4.868921868321049, -7.722813520977764],
            [4.863991555480931, -7.718807837419024],
            [4.864151673499422, -7.713494508085623],
            [4.861782300314457, -7.711388327860173],
            [4.863915538311383, -7.707798249268288],
            [4.861336195494277, -7.699967292568158],
            [4.8628428483873085, -7.696329070469227],
            [4.858338949451802, -7.692240056117243],
            [4.8603143862514475, -7.690080612302885],
            [4.856612743061683, -7.684033220319095],
            [4.858408589520403, -7.680674950942441],
            [4.854527961689692, -7.677567382665896],
            [4.856485570561196, -7.67179441064064],
            [4.861808210916512, -7.66924902769762],
            [4.861446964014355, -7.66516412306129],
            [4.86916483007362, -7.655694157503845],
            [4.8679655404870426, -7.654573019697492],
            [4.8697986207675115, -7.64694809254376],
            [4.869874764559857, -7.634263242786123],
            [4.873459599035319, -7.625790495985802],
            [4.883171502475499, -7.6189018314463075],
            [4.940374866190779, -7.615570410099193],
            [4.961130992736869, -7.61479953549221],
            [5.103823460509701, -7.6063141374955725],
            [5.108007660153526, -7.678191369816289],
            [5.110278768113174, -7.712609031534948],
            [5.113843463790684, -7.77988539965498],
            [5.118607906453716, -7.856202721990279],
            [5.119506023530815, -7.866338341208372],
            [5.12423928843327, -7.939360977676724],
            [5.123916591644339, -7.953188627294286],
            [5.066113591670388, -7.956589323265865],
            [4.9415256951294495, -7.963611699825963],
            [4.829532034695018, -7.969969943444874],
            [4.828303137650797, -7.967288349080904],
            [4.830849548789075, -7.963999709797657],
            [4.837137384342088, -7.963672535796563],
            [4.8382504314295165, -7.957811286734228],
            [4.842302677840383, -7.954651780416769],
            [4.840633650981783, -7.950721006360921],
            [4.845683979715016, -7.944763943726494],
            [4.849550414977012, -7.943497899695411],
            [4.856663965639708, -7.937756948818846],
            [4.854823041323907, -7.9356161414010575],
            [4.8568700439716155, -7.931525545777868],
            [4.860411669321001, -7.930886757642673],
            [4.861457678801641, -7.92694195583334],
            [4.869915550630328, -7.921965651159133],
            [4.876482836392957, -7.921433335531581],
            [4.877559683869875, -7.911541898395662],
            [4.8797115996347955, -7.91252015067292],
            [4.883351298003611, -7.908767415141787],
            [4.8803118431793315, -7.904082915507742],
            [4.8788034201493575, -7.897664137065652]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.71033360694534,
          "lat": 30.821969910356724
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22091"],
        "coty_name": ["St. Helena"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Helena Parish"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01629457"
      },
      "bbox": [
        4.828303137650797, -7.969969943444874, 5.12423928843327,
        -7.6063141374955725
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.814982124113975, -8.549112281231086],
            [4.838282535879006, -8.529318197146445],
            [4.836921977007851, -8.526105776931875],
            [4.8388033887733295, -8.520764844250287],
            [4.855103866061077, -8.505346389921348],
            [4.854082271033826, -8.500987329157336],
            [4.893482369273653, -8.49023308105674],
            [4.986964621601451, -8.46379725843724],
            [5.086962912996042, -8.43558595383482],
            [5.082897786756924, -8.481239111264602],
            [5.080900280761242, -8.505450451152042],
            [5.0662317830970505, -8.508496652290251],
            [5.076998088793617, -8.550839852323707],
            [5.06962192246089, -8.554434724327733],
            [5.059283509974275, -8.561958943154009],
            [5.053972699722172, -8.566850686730954],
            [5.071267084454352, -8.608686945996851],
            [5.066715794176651, -8.612792667016866],
            [5.0680947033308765, -8.614476801870556],
            [5.068491226440351, -8.620856622053418],
            [5.075803276756345, -8.620109875013922],
            [5.0771544222236535, -8.634539901707207],
            [5.069712385588233, -8.635142208282133],
            [5.0707600585133505, -8.649514734333165],
            [5.078036213303469, -8.648960303541598],
            [5.081245933319984, -8.692484432214297],
            [5.090316844106389, -8.7102505676096],
            [5.086471578609965, -8.709306081246554],
            [5.080055235384289, -8.71067417673888],
            [5.073470791928749, -8.707506991546348],
            [5.0690444431033646, -8.708119852745815],
            [5.066009857475364, -8.702655706877803],
            [5.062155271800004, -8.70199301361809],
            [5.060346957939351, -8.69646565553668],
            [5.053773961636686, -8.701019304674457],
            [5.051033876935275, -8.69835141790743],
            [5.043331567885159, -8.701595087201028],
            [5.0441725424219195, -8.70466408047367],
            [5.037115501579163, -8.705807542574362],
            [5.036370972220726, -8.700255012942565],
            [5.031487199860144, -8.695919756098863],
            [5.025425666315774, -8.698188750942272],
            [5.017226859404308, -8.699180171574433],
            [5.008719023525448, -8.696277651262022],
            [5.000995196168101, -8.691668730696001],
            [4.997618819612597, -8.691686455137967],
            [4.990558536049332, -8.688770467863744],
            [4.985910470280386, -8.688048372937452],
            [4.982660485334083, -8.683708461480622],
            [4.9765692017468925, -8.684349525722512],
            [4.97763583969804, -8.69827217333904],
            [4.890999086910184, -8.705146649943103],
            [4.888886477585624, -8.67523722889932],
            [4.866890951156965, -8.676975110740317],
            [4.864547539655923, -8.634061787587816],
            [4.834775391112072, -8.636196678196297],
            [4.831615398846451, -8.578763236260146],
            [4.816963543385556, -8.579789770551717],
            [4.814982124113975, -8.549112281231086]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.79308773256082,
          "lat": 30.026975672914954
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22093"],
        "coty_name": ["St. James"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. James Parish"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01629464"
      },
      "bbox": [
        4.814982124113975, -8.71067417673888, 5.090316844106389,
        -8.43558595383482
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.657624984765704, 6.019513826005409],
              [18.6588547775841, 6.021825512038309],
              [18.663659315712643, 6.023713418886005],
              [18.66675225209971, 6.02901221225674],
              [18.6655920640492, 6.034485002997679],
              [18.669467196184254, 6.036790764125741],
              [18.6724764035534, 6.033329686289341],
              [18.668234278835598, 6.024644084238007],
              [18.668640324325217, 6.017482553444681],
              [18.664246841098176, 6.019005523493682],
              [18.660077861101158, 6.016252248992163],
              [18.657624984765704, 6.019513826005409]
            ]
          ],
          [
            [
              [18.694553365187122, 6.003494266085441],
              [18.70463710005435, 6.001155318286168],
              [18.704218434634456, 5.997054582570167],
              [18.708472914317422, 5.995513527741704],
              [18.711598696210306, 5.99195437107333],
              [18.71663534768735, 5.9895535843717695],
              [18.720505705226078, 5.993570242375928],
              [18.719862383840848, 6.00215806629625],
              [18.71701725245931, 6.003570497259575],
              [18.71174431400121, 6.0116390708797045],
              [18.70438969903607, 6.018051163579971],
              [18.694847889297403, 6.019851256624139],
              [18.694630101033066, 6.022161507959801],
              [18.700304827015, 6.02242441886255],
              [18.70785201043493, 6.02062458256362],
              [18.712265491571706, 6.022359983628578],
              [18.706303559983684, 6.03096859930859],
              [18.702450478626073, 6.034490088443109],
              [18.700772976756102, 6.039327061442124],
              [18.687910990050863, 6.040060738070183],
              [18.684051840490145, 6.036288586303944],
              [18.67945807912776, 6.038585090409795],
              [18.673903316419644, 6.0370251972234845],
              [18.67287340557624, 6.039483098498633],
              [18.683729183252407, 6.045359966884361],
              [18.692535839491, 6.045700489392254],
              [18.695882556079955, 6.051319353759603],
              [18.700711315366735, 6.052524179395369],
              [18.70428969296897, 6.043396106394782],
              [18.715588047772897, 6.030885102043855],
              [18.72457227472318, 6.02324022897983],
              [18.734198696500133, 6.017851723563222],
              [18.748623107680974, 6.020862610648617],
              [18.753566051396078, 6.020650820812318],
              [18.752329308864518, 6.018691997506929],
              [18.745688143668712, 6.017208050249136],
              [18.743541586125573, 6.012817021634859],
              [18.740851804741535, 6.011507926524369],
              [18.739975611879004, 6.002676205792439],
              [18.741000644610605, 5.997963703281129],
              [18.747816285229867, 5.9956667514024895],
              [18.740122437741384, 5.9897142361456615],
              [18.756028579215897, 5.9665201314202045],
              [18.769065988793063, 5.957240955363489],
              [18.790145385219184, 5.985782000493009],
              [18.78788953145779, 5.9953296511093885],
              [18.79163691701596, 6.00032141264676],
              [18.787512470517484, 6.002464907078209],
              [18.78701114397405, 6.009309138776912],
              [18.788755900827073, 6.012290493043599],
              [18.79235131969326, 6.013506062093272],
              [18.792638497111273, 6.019042308119273],
              [18.797894988128345, 6.021011354082499],
              [18.80158629493931, 6.0174452708893496],
              [18.801838062776802, 6.010996152619809],
              [18.80547405284674, 6.00905240675409],
              [18.80748640710468, 6.003157096407203],
              [18.82015481396763, 5.992867467883483],
              [18.82647384927558, 5.992298028299061],
              [18.834862772671812, 5.985562653539898],
              [18.841536508265087, 5.984276674012763],
              [18.844231945077993, 5.98607183996193],
              [18.84905459644884, 5.982652349749606],
              [18.849253099162897, 5.9738508540396476],
              [18.850737158868156, 5.968280899549363],
              [18.850180408355353, 5.962637317908468],
              [18.855171186311, 5.955407023523082],
              [18.85756298506027, 5.947957974664786],
              [18.86476589628992, 5.944049917577575],
              [18.887624901661386, 5.918990830873006],
              [18.909366879084036, 5.899260263195545],
              [18.93148562773782, 5.884811950735037],
              [18.93455936280945, 5.878322397058993],
              [18.9296470913341, 5.8715369520408105],
              [18.93114346709616, 5.863750056615156],
              [18.93936412756488, 5.847685939426453],
              [18.952071497621752, 5.835795346757195],
              [18.96198045116837, 5.829187028796612],
              [18.971609882134256, 5.820018592993698],
              [18.98390008908469, 5.811744616348135],
              [18.98111550095324, 5.808486706598746],
              [18.971855936370762, 5.8106067645434125],
              [18.966997500913077, 5.804641025316542],
              [18.9627882495201, 5.793857946793782],
              [18.957376443791905, 5.793456924331196],
              [18.952714212615785, 5.804685078787616],
              [18.952519589906633, 5.8096917096270095],
              [18.956251274037918, 5.811990477106052],
              [18.957788770417, 5.805071124523012],
              [18.961973514418162, 5.802561417990234],
              [18.964781368132318, 5.808074608266936],
              [18.970523988020375, 5.814957103277473],
              [18.966297327030354, 5.820410989502341],
              [18.939868918325566, 5.842707171704531],
              [18.935125618496347, 5.841783341044563],
              [18.93255551836978, 5.8367229008316786],
              [18.92687178973525, 5.834261596108742],
              [18.924397699813866, 5.829385551581021],
              [18.92692789237589, 5.813740269816274],
              [18.93228986843281, 5.8057764581673466],
              [18.931056979343808, 5.800732446365292],
              [18.92606317728889, 5.797012459622746],
              [18.918445959317985, 5.802478647280444],
              [18.911878220911095, 5.8013008313435055],
              [18.901734156953495, 5.7925675380279165],
              [18.905408638185044, 5.785211936017489],
              [18.90765124608064, 5.787050783729714],
              [18.912875354170186, 5.7858993736981414],
              [18.916573583947887, 5.77531908655326],
              [18.923804664102953, 5.771251828748858],
              [18.931231877286894, 5.771031581436898],
              [18.936682325682924, 5.76538696943183],
              [18.948310662627332, 5.755847604085144],
              [18.95835404452449, 5.7507119770988],
              [18.963769534456937, 5.748878531997504],
              [18.96875774422038, 5.750304586526399],
              [18.97516241265322, 5.748573657070885],
              [18.9760972624611, 5.749882513448357],
              [18.967817155850277, 5.7573251504444665],
              [18.956315594572196, 5.770721449884459],
              [18.95199846198922, 5.774399051107429],
              [18.954154207862263, 5.776713574480758],
              [18.9577786034843, 5.77414316168854],
              [18.973618448946326, 5.755414614305289],
              [18.981698271366277, 5.747264345040217],
              [18.98776726143056, 5.745947923992371],
              [18.99356520559848, 5.748042973141293],
              [18.998870002901846, 5.756834751543582],
              [19.008606372649115, 5.761810303193034],
              [19.0226602543031, 5.754723944605031],
              [19.02480872811969, 5.751910000014878],
              [19.035846496835603, 5.748077996403766],
              [19.0431291527548, 5.7465723403960975],
              [19.0488997592836, 5.742605936889473],
              [19.043951284094163, 5.736894972814921],
              [19.0445056221912, 5.732040233104825],
              [19.046819569583175, 5.727708452500487],
              [19.061389615377742, 5.713406071871511],
              [19.061756826452246, 5.709608734518268],
              [19.064172261127375, 5.705113260462025],
              [19.068944170261386, 5.690445239199409],
              [19.074260593872143, 5.684869116859424],
              [19.07410059786207, 5.666043664284754],
              [19.073052655730926, 5.659517096713165],
              [19.06982049086798, 5.655104006618298],
              [19.07085115013178, 5.648298986473492],
              [19.074693832937033, 5.640312649142106],
              [19.078667910636092, 5.636309471006145],
              [19.065080634814777, 5.607451794634328],
              [19.04144245547935, 5.588559669560586],
              [19.02342906373577, 5.571396689905688],
              [19.03025112779823, 5.5652440209683744],
              [19.031838870224657, 5.561460889735829],
              [19.035921707879307, 5.55881546425939],
              [19.03288579000236, 5.555326614165823],
              [19.03000256476431, 5.547046571507405],
              [19.03118256183762, 5.54310336250567],
              [19.027814930722688, 5.53632478892433],
              [19.02794881427485, 5.525534470416581],
              [19.023740014181783, 5.524831908405646],
              [19.023775747770628, 5.520045992646905],
              [19.018854379772936, 5.510037631280762],
              [19.012760003998682, 5.494133646411528],
              [19.010936736567658, 5.494972079223679],
              [19.019683060548974, 5.5189029386080435],
              [19.018869637368866, 5.5207754848667685],
              [19.013361949482427, 5.520109888347432],
              [19.00723805261308, 5.524382392024368],
              [18.999502812550134, 5.528017866198835],
              [18.994840999532254, 5.526382738063712],
              [18.994036092036158, 5.522660140370762],
              [18.98629342340793, 5.5262740640385974],
              [18.979839696519374, 5.524293983029432],
              [18.977867773367564, 5.525811774225709],
              [18.97253781393417, 5.525860562999898],
              [18.969064665404144, 5.528393197243619],
              [18.96443578130191, 5.524010721215382],
              [18.96972957913464, 5.520121447400506],
              [18.970800833195504, 5.515851163159078],
              [18.96547633583632, 5.514048980380386],
              [18.97326342799348, 5.505863058630768],
              [18.978553530214928, 5.50453704625444],
              [18.981466643795894, 5.501913714544543],
              [18.981295546296398, 5.496361297540714],
              [18.974665617650384, 5.496749199888177],
              [18.971643314647885, 5.494453776544844],
              [18.976393597030317, 5.489101766054632],
              [18.981045570064968, 5.488236567258516],
              [18.981411702434144, 5.484361930530069],
              [18.98620216226515, 5.4761508288041885],
              [18.9835792034237, 5.472305264717002],
              [18.98143795581193, 5.475340000967778],
              [18.974050886032277, 5.4802694350061785],
              [18.965793896834622, 5.481800567835568],
              [18.96075054166252, 5.486890911178671],
              [18.95766271106131, 5.4855014902490815],
              [18.953854793545027, 5.481227325026284],
              [18.95703751871168, 5.477768519732831],
              [18.96200032543696, 5.468964891543856],
              [18.96758309275396, 5.464573212332616],
              [18.966969163624615, 5.462035858331709],
              [18.96207801693702, 5.464003906598696],
              [18.96013625349766, 5.466431031026388],
              [18.95532269954309, 5.467341479381151],
              [18.95239862586735, 5.4626749134265316],
              [18.960128219824536, 5.454433694253971],
              [18.95676303001617, 5.452045468516453],
              [18.960569611766633, 5.448639728954869],
              [18.963584349940454, 5.440793049947785],
              [18.959803756393356, 5.439579174009591],
              [18.96114809317631, 5.435327812016615],
              [18.958038893728393, 5.4346711335158835],
              [18.957921508432502, 5.427050048930602],
              [18.953790575178427, 5.429973580621874],
              [18.95009174790908, 5.434921534465941],
              [18.939333267474154, 5.434583983223339],
              [18.936800931915865, 5.431509672971522],
              [18.93043232365487, 5.434771897337211],
              [18.92496667727531, 5.436063645076205],
              [18.91688905527389, 5.430189837218391],
              [18.91724402132955, 5.424195259483993],
              [18.932619802619325, 5.420219290941285],
              [18.93828727080852, 5.411976447937461],
              [18.938271645488296, 5.409643868542038],
              [18.932898605597654, 5.403368728300819],
              [18.92797785217879, 5.400541465528359],
              [18.923764698776377, 5.403616196110132],
              [18.920435454107096, 5.399754866394509],
              [18.915076863117473, 5.398201123083045],
              [18.908391940151578, 5.400507395653562],
              [18.902648752366403, 5.415771904158736],
              [18.84274777553199, 5.519706163093827],
              [18.830469984232817, 5.514082302473711],
              [18.809337691696445, 5.542928938675843],
              [18.73789254728541, 5.510926978792992],
              [18.740839748656914, 5.5331902640829105],
              [18.720698169409424, 5.545404616633951],
              [18.74176042171242, 5.582709980242598],
              [18.747146968351394, 5.591459497919183],
              [18.751645242176828, 5.595975996734422],
              [18.75397029109407, 5.600371858288761],
              [18.747769408780897, 5.613524541434434],
              [18.732531774861048, 5.641267883037131],
              [18.72888250243895, 5.643741272155523],
              [18.72659703217403, 5.649844048394937],
              [18.722637524710905, 5.649903904310259],
              [18.720888687582917, 5.656108880040368],
              [18.72158544057462, 5.658311497023237],
              [18.706928494470937, 5.66998150530862],
              [18.67898250802041, 5.682674950872982],
              [18.673157491219932, 5.68483038241018],
              [18.664679471229803, 5.702926347537321],
              [18.636200446142357, 5.764821552932182],
              [18.616482775073187, 5.807103638853544],
              [18.66423761194599, 5.852018190813467],
              [18.66390733469613, 5.8527368116784295],
              [18.710909453190673, 5.896755505771534],
              [18.700370994265036, 5.963983371681461],
              [18.69395562063976, 5.963073648444376],
              [18.69384388649911, 5.966570307939533],
              [18.689460804201914, 5.973171997725199],
              [18.683587795189887, 5.979372392931623],
              [18.6805846924715, 5.987220991142639],
              [18.690706105216304, 5.993005978710359],
              [18.68830732643947, 6.000968796863313],
              [18.694553365187122, 6.003494266085441]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -70.81147001304522, "lat": 41.95100652825298 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25023"],
        "coty_name": ["Plymouth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Plymouth County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00606938"
      },
      "bbox": [
        18.616482775073187, 5.398201123083045, 19.078667910636092,
        6.052524179395369
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.870646779977694, 5.126394278587764],
            [9.90826581856195, 5.133019967214327],
            [9.985993326566811, 5.146514686133891],
            [10.017528091841523, 5.152153166842827],
            [10.080758268305804, 5.163823931104952],
            [10.12293494726228, 5.171471829570044],
            [10.22269289345894, 5.190592320571129],
            [10.225001438592715, 5.183560628352611],
            [10.232912568781021, 5.166563117984056],
            [10.239125438446209, 5.141590841287959],
            [10.242289907582657, 5.1365765543860835],
            [10.244646234413418, 5.126510494495839],
            [10.253005684041046, 5.116871451470125],
            [10.257547338937215, 5.1132726978749155],
            [10.265874403754273, 5.0960558895087935],
            [10.2712473306661, 5.088625274106103],
            [10.28707447038884, 5.064537479570337],
            [10.29961844989641, 5.048116719869365],
            [10.304337953288325, 5.037114596098851],
            [10.30686051535931, 5.034462316661802],
            [10.304044021066984, 5.028244692011699],
            [10.304163953517024, 5.024624631438569],
            [10.308708416895252, 5.0159729539268145],
            [10.31480304250046, 5.009454275648977],
            [10.313924870723172, 4.998929837213321],
            [10.307469725850767, 4.983215327164015],
            [10.29615065442473, 4.96717271452027],
            [10.291618444451517, 4.955350982137558],
            [10.28912382528225, 4.9290252671868195],
            [10.286919481235369, 4.914944130647652],
            [10.287694543430089, 4.908942363710323],
            [10.29218592299603, 4.886993624154907],
            [10.29276564351277, 4.8794326147185965],
            [10.292152675641908, 4.864388055427234],
            [10.289506300885833, 4.852268412847386],
            [10.28902553272705, 4.835449521587151],
            [10.290285994735328, 4.831687474527813],
            [10.299774460459977, 4.814043435404731],
            [10.305931894330842, 4.79746242099558],
            [10.306453047214362, 4.790093439575067],
            [10.29915966974531, 4.760760859750989],
            [10.301016687763804, 4.745345479350378],
            [10.295783195242052, 4.727221475297819],
            [10.289048542235227, 4.689517216059125],
            [10.293657522295014, 4.662566177558812],
            [10.29058359960083, 4.638416440460235],
            [10.28698159635197, 4.6295608825076116],
            [10.272434366407317, 4.613506849665872],
            [10.2690288581177, 4.605683100687262],
            [10.253449763790279, 4.583922660832237],
            [10.25183676719031, 4.572280640376904],
            [10.247691860264423, 4.568529442479969],
            [10.236906791098162, 4.564216065633048],
            [10.234327487318522, 4.564706476923237],
            [10.227759196490235, 4.569560246078967],
            [10.222167976587071, 4.571218196538613],
            [10.215406526436915, 4.569927340042006],
            [10.208982623139635, 4.566507588123937],
            [10.196843113434921, 4.551570630479315],
            [10.194151503976093, 4.543512118147051],
            [10.187411674477726, 4.530936884482179],
            [10.184472921531022, 4.538784824628772],
            [10.18520478134238, 4.544111426573595],
            [10.191068025315708, 4.547437659228037],
            [10.194706393863077, 4.556313077894364],
            [10.203214447855514, 4.564664086596762],
            [10.204774671393743, 4.571004136275199],
            [10.200479423362781, 4.575895750584682],
            [10.193735960148196, 4.5788481251806985],
            [10.18995970344755, 4.5763653349044935],
            [10.184140391069363, 4.570315102989217],
            [10.179649220704917, 4.563564683993479],
            [10.177101986769612, 4.5679061391577],
            [10.174477477835289, 4.567224262310572],
            [10.175073997722897, 4.573657746759918],
            [10.179273544895759, 4.578495683712083],
            [10.178600651261664, 4.582869451527589],
            [10.182245153328145, 4.588045864852994],
            [10.185763301755827, 4.586148137011048],
            [10.18723890451294, 4.590610426548872],
            [10.191655018041729, 4.591674815616301],
            [10.192932090931405, 4.601250212882324],
            [10.190323475781808, 4.606022664937501],
            [10.1843347796716, 4.602432447514493],
            [10.178235099602094, 4.605828695190768],
            [10.171974310987332, 4.596706143535071],
            [10.162438663431598, 4.592041215082248],
            [10.154507926169003, 4.595884482861587],
            [10.152153613674008, 4.602664801631728],
            [10.159776105746813, 4.61263060767399],
            [10.16973794943099, 4.613759453167005],
            [10.174509233203159, 4.6203667721125505],
            [10.176279285840234, 4.624601418885023],
            [10.172016293501772, 4.626489567327575],
            [10.169898852171578, 4.630613031171076],
            [10.16494504963155, 4.631938480662493],
            [10.16485653493672, 4.6340681911829975],
            [10.175406295087825, 4.635107672912061],
            [10.182905286540901, 4.633594250189089],
            [10.182388051053055, 4.641580791156926],
            [10.17845112867082, 4.646186087335486],
            [10.179829097948364, 4.649207832745877],
            [10.18395884134384, 4.64531044498621],
            [10.186613079010538, 4.657581976057786],
            [10.188307977835988, 4.661097206204878],
            [10.19162610182376, 4.6599706141626145],
            [10.1968505965705, 4.655926560445388],
            [10.199862799218694, 4.652012296024053],
            [10.205402421265962, 4.654932027176569],
            [10.207934226098047, 4.660632250611903],
            [10.209152057468103, 4.669480245511501],
            [10.207273490321462, 4.678780058159686],
            [10.201048270284192, 4.685948903910622],
            [10.197544981674408, 4.687693809468075],
            [10.188392939081655, 4.6860721117723285],
            [10.185004302487702, 4.682563462286749],
            [10.17937328133307, 4.688237626165038],
            [10.167692551546375, 4.695131735108662],
            [10.159160987070548, 4.696957020398325],
            [10.148042439684016, 4.694901186963428],
            [10.14525270049558, 4.691612579660977],
            [10.130345230397227, 4.703449297506082],
            [10.13262315117651, 4.706402225955991],
            [10.125247424891034, 4.708423602727387],
            [10.116267732434071, 4.759806619776821],
            [10.099430305096835, 4.854950439278057],
            [10.091419872715143, 4.8975121204917365],
            [10.062800485050596, 4.892108116345927],
            [10.048007207506485, 4.889623130850627],
            [9.957649730021771, 4.875985667555481],
            [9.91545381471091, 4.869274871854534],
            [9.900314113637195, 4.956864695218633],
            [9.901180943338607, 4.957027163951],
            [9.892514008228748, 5.007001044195263],
            [9.877153275519044, 5.091873331144357],
            [9.870646779977694, 5.126394278587764]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.68056034679016,
          "lat": 42.934025827053254
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26147"],
        "coty_name": ["St. Clair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Clair County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01625033"
      },
      "bbox": [
        9.870646779977694, 4.530936884482179, 10.31480304250046,
        5.190592320571129
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.200096920046328, 7.080156385294848],
            [2.2365208774223233, 7.079728153304769],
            [2.287261201500958, 7.078903995965387],
            [2.337284883644279, 7.080497158545713],
            [2.3997973396750383, 7.0822143688028145],
            [2.4308702723334226, 7.0827779718583725],
            [2.459848699200783, 7.083773671887839],
            [2.460864645860658, 7.055146933490494],
            [2.464015589774361, 6.942617027658248],
            [2.4649081016187435, 6.91265369398872],
            [2.505789045465829, 6.913718106851775],
            [2.5489327411494505, 6.914556091789475],
            [2.5503052463269844, 6.863309919408004],
            [2.5518517702900336, 6.82818407028633],
            [2.5551802598001316, 6.770036007442359],
            [2.5226421675943644, 6.769904821676329],
            [2.510478731166135, 6.769607456261622],
            [2.50341260097644, 6.7704388178455535],
            [2.4690637443065513, 6.769271952605125],
            [2.454543242770508, 6.769403267164015],
            [2.4036398300687702, 6.767503839860499],
            [2.325089808359733, 6.7650398731298536],
            [2.253411969800977, 6.763268013481489],
            [2.210987550683099, 6.763205894582746],
            [2.2099831983895273, 6.791639870179764],
            [2.2076976002767776, 6.870394823357046],
            [2.206772216010143, 6.906101271476263],
            [2.2053475182651687, 6.935120068412311],
            [2.2030479892683577, 6.991760050123988],
            [2.2023237212007203, 7.022432039356165],
            [2.2020317083758085, 7.048928393609142],
            [2.201418161243125, 7.0645819580078815],
            [2.200096920046328, 7.080156385294848]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.2951763081654, "lat": 45.56150777942734 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27059"],
        "coty_name": ["Isanti"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Isanti County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00659475"
      },
      "bbox": [
        2.200096920046328, 6.763205894582746, 2.5551802598001316,
        7.083773671887839
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.542320888524834, -7.078842150425065],
            [6.557096057786299, -7.077395703010224],
            [6.620024879690001, -7.073151817250048],
            [6.622138984832752, -7.07273166943716],
            [6.669744843335541, -7.068728896733018],
            [6.677790110816552, -7.068360115850327],
            [6.735791243115159, -7.0636806028330374],
            [6.797134634014198, -7.058489675760569],
            [6.796274287707448, -7.0573156578050416],
            [6.8744583690089565, -7.0511557701210315],
            [6.884518614290922, -7.130167570621891],
            [6.898211389682095, -7.232286923174318],
            [6.898500748997005, -7.238014506993156],
            [6.915005545175018, -7.369096921907196],
            [6.929688508062235, -7.483690073853705],
            [6.833513923443866, -7.491420068900238],
            [6.759956941240138, -7.4964694870023845],
            [6.741402861675402, -7.498224856917578],
            [6.650575713099162, -7.506145378844203],
            [6.581498575064216, -7.510830236928032],
            [6.5758507114329, -7.510827160979327],
            [6.568470986764287, -7.414340187915015],
            [6.564915106575302, -7.371615361099376],
            [6.564751512691645, -7.365575520086791],
            [6.560904925593306, -7.317404450691461],
            [6.556021617868287, -7.253003149814568],
            [6.546947914353296, -7.138309751490042],
            [6.542320888524834, -7.078842150425065]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.63916082733425,
          "lat": 31.214225989369087
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28041"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00695745"
      },
      "bbox": [
        6.542320888524834, -7.510830236928032, 6.929688508062235,
        -7.0511557701210315
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.744265151090563, -7.900217324618261],
            [5.742319763071452, -7.897153861209854],
            [5.739338561783306, -7.896074711941672],
            [5.746912825508441, -7.875154294512434],
            [5.748003372480612, -7.874494035306297],
            [5.747141604363888, -7.866201303629335],
            [5.744953002005083, -7.8618827720219855],
            [5.740310435475056, -7.863698840660396],
            [5.738119341340926, -7.8590598167963535],
            [5.745711102534938, -7.849743374254467],
            [5.751005985346357, -7.849278156605032],
            [5.752150085199131, -7.8405378476435414],
            [5.744341752363787, -7.83787256502436],
            [5.743986247082126, -7.831465877202465],
            [5.746447161184199, -7.829007369244411],
            [5.751976196208706, -7.829420696928822],
            [5.7604028703659615, -7.8277765008876505],
            [5.758414389981871, -7.824554507811191],
            [5.753572292465849, -7.823465304673229],
            [5.752656438703773, -7.818322615141403],
            [5.755015238515132, -7.810881371663179],
            [5.7493373231815, -7.8145420407258],
            [5.746210611433357, -7.810088953874113],
            [5.751140188244455, -7.809698783558016],
            [5.7515975762134355, -7.806735841597275],
            [5.745863067511768, -7.801634379592098],
            [5.748711438476972, -7.797244197331489],
            [5.749256594468716, -7.7911576298333545],
            [5.7465678044698905, -7.786326510864867],
            [5.748355785672137, -7.782653386291273],
            [5.751731728853362, -7.786205806304179],
            [5.756015291367691, -7.78120879351289],
            [5.753466553343486, -7.774591589330649],
            [5.755188092547876, -7.770452472373494],
            [5.759743309700926, -7.771599015647985],
            [5.761673566927419, -7.776795620010407],
            [5.766191827808279, -7.775874430196338],
            [5.767556478261321, -7.772321614621777],
            [5.7615774478127495, -7.767285158473888],
            [5.7671358030852575, -7.762430696225752],
            [5.767171730966641, -7.758024715339481],
            [5.77292200874477, -7.752854516961685],
            [5.770547207611543, -7.7496040835087205],
            [5.7710465771685575, -7.743913263243421],
            [5.776981740200021, -7.743994769267548],
            [5.7822719909584475, -7.748057670243342],
            [5.785122801694813, -7.745868330383539],
            [5.780366288347965, -7.739985632880682],
            [5.783154949088849, -7.73662632902143],
            [5.777016292784923, -7.732298689844492],
            [5.777217632935868, -7.726458409305154],
            [5.7790556530329615, -7.720235994569058],
            [5.774398835044965, -7.714290171766398],
            [5.776863203776195, -7.7131385588829415],
            [5.781294559363216, -7.717981603402847],
            [5.785129363223944, -7.717727677670861],
            [5.781059305798277, -7.710514168267132],
            [5.785760414772361, -7.708161450509868],
            [5.789358131818884, -7.710463134944424],
            [5.791841992265779, -7.708884535018373],
            [5.794456673122112, -7.699571215487911],
            [5.794049308561689, -7.697074081911203],
            [5.785245781001222, -7.690656061500965],
            [5.784113956526986, -7.688962786265493],
            [5.785506447928894, -7.682993174807976],
            [5.791478508729814, -7.681443583349388],
            [5.787508426376093, -7.667152039578318],
            [5.79014624998297, -7.664462476314505],
            [5.79851801318968, -7.666989268936339],
            [5.801645270786148, -7.662041211146388],
            [5.798632668143751, -7.657110738512321],
            [5.795272713132611, -7.655819543517345],
            [5.794503126441137, -7.651711924360833],
            [5.800091843884683, -7.648272765405224],
            [5.806496630221407, -7.649910001751501],
            [5.810611197502528, -7.643661494494099],
            [5.81006395665808, -7.640227600267563],
            [5.805246636097004, -7.6397153065873304],
            [5.803379965150862, -7.634944871634246],
            [5.806228948342618, -7.630117636979877],
            [5.80499186248931, -7.627262536305496],
            [5.799825797179948, -7.623833829515657],
            [5.799140438083661, -7.619938381273235],
            [5.803000567980282, -7.61177519469205],
            [5.81523410439384, -7.595897410611055],
            [5.821759254906159, -7.595525032698558],
            [5.821162615969189, -7.590957853522743],
            [5.814372825886357, -7.58810925908833],
            [5.814295386577325, -7.584707621941424],
            [5.81878877675873, -7.5825781112046995],
            [5.820278416085138, -7.568906869738835],
            [5.8145605452460085, -7.567016268743787],
            [5.813169172428398, -7.5630087405961515],
            [5.817890851264538, -7.5626657693946155],
            [5.819303776484411, -7.56003148895388],
            [5.8824771137398875, -7.555666738220139],
            [5.907175570827788, -7.55402677744058],
            [5.969640233716522, -7.550425215765346],
            [5.9685361913724915, -7.536504022134697],
            [6.011736308603122, -7.533515814358643],
            [6.012686746919715, -7.54796873394833],
            [6.034395457191389, -7.546589745080887],
            [6.035595685347664, -7.5649087952344996],
            [6.064967452020764, -7.562918699875344],
            [6.078845941683951, -7.562397230846554],
            [6.0773790142625, -7.534925929247126],
            [6.14202047148951, -7.530204596350372],
            [6.142660998982486, -7.539457741641694],
            [6.149707146704182, -7.5389777869640495],
            [6.156015794426198, -7.62935485625776],
            [6.159609618061155, -7.6811981728479415],
            [6.164325428139808, -7.752250084445818],
            [6.173871759112406, -7.889232065350867],
            [6.121838822740906, -7.892839193825467],
            [6.042237900511549, -7.897921384748204],
            [6.038024310739483, -7.897921742880938],
            [6.000197574310876, -7.9004744110548195],
            [6.00486338767965, -7.9625130597122435],
            [6.008721207934833, -8.023996283994345],
            [6.008904935796039, -8.03072142871466],
            [5.964838015408733, -8.033471995793498],
            [5.965941933686265, -8.047899401827305],
            [5.940794598745661, -8.049750911559387],
            [5.921883466998937, -8.05058292397179],
            [5.92491336681506, -8.093980563045763],
            [5.8881345537669425, -8.096026123188828],
            [5.882646781496431, -8.092419210681918],
            [5.877430163278028, -8.090926757175229],
            [5.873741185882127, -8.083975639392657],
            [5.869932412225092, -8.078754149804498],
            [5.864499579060674, -8.079166173403731],
            [5.860912428219497, -8.074062905999218],
            [5.859240361106159, -8.068761381143965],
            [5.856076827392591, -8.06569321722514],
            [5.840462220145072, -8.061330661206224],
            [5.8366473993616665, -8.056306547355504],
            [5.831082535029223, -8.056794708839105],
            [5.826013504483315, -8.053695355979817],
            [5.825299088335771, -8.04666183417499],
            [5.823656475732946, -8.044084867116098],
            [5.817217534357928, -8.04524061626106],
            [5.814137715284817, -8.032713090576216],
            [5.8094595622570955, -8.022048893757013],
            [5.805488886574488, -8.01683984275144],
            [5.797783157341466, -8.017221244765656],
            [5.792862502990958, -8.013741917945403],
            [5.794644128467359, -8.010403239707351],
            [5.791856063854871, -8.005581187135535],
            [5.784688433494013, -8.004703289918927],
            [5.783572174286277, -8.002112005005127],
            [5.7864638019939525, -7.9988278771413635],
            [5.789662248746736, -8.000587219379845],
            [5.794351590004553, -8.000630680726978],
            [5.797611388385801, -7.992776868670216],
            [5.7951765749405, -7.991615804074946],
            [5.786377195150072, -7.993208001285045],
            [5.7811501439561885, -7.995344231604173],
            [5.7773162185803795, -7.982910410090841],
            [5.772365491617899, -7.978811750956675],
            [5.775180024936746, -7.9756460250891665],
            [5.774508595373561, -7.971971210238374],
            [5.7689289621319615, -7.9711227246370795],
            [5.767660260992644, -7.967129217600189],
            [5.772389045027578, -7.965031624875406],
            [5.764888021009643, -7.959492322117192],
            [5.771448593396993, -7.95756705607856],
            [5.769280950821047, -7.955251849236498],
            [5.763876042248013, -7.95553772693665],
            [5.765257849840271, -7.94592750668819],
            [5.756766374218653, -7.947076454984369],
            [5.757220474552719, -7.942498940568077],
            [5.76291150096716, -7.941553330610808],
            [5.764854497864765, -7.935904695758043],
            [5.76499537390132, -7.931465472199238],
            [5.770061819746976, -7.927171950476834],
            [5.768244075106239, -7.924881615324233],
            [5.764296677125078, -7.926084413578341],
            [5.7616402702616165, -7.92465488128441],
            [5.759322146637155, -7.919429744319841],
            [5.759701277315171, -7.915276335172477],
            [5.75208825226834, -7.907714413271083],
            [5.749716603982554, -7.908083913547204],
            [5.73589729587818, -7.905090349832013],
            [5.738215325311584, -7.9009586663882025],
            [5.741093038860567, -7.902398704886419],
            [5.744265151090563, -7.900217324618261]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.5896036460716, "lat": 30.76888233312385 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28109"],
        "coty_name": ["Pearl River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pearl River County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00695777"
      },
      "bbox": [
        5.73589729587818, -8.096026123188828, 6.173871759112406,
        -7.530204596350372
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.389370857731074, -3.9138251411704803],
            [6.4037372336913725, -3.9127372417368056],
            [6.399202575784657, -3.855793426812584],
            [6.3968447285360845, -3.8337500086508003],
            [6.394199021511818, -3.7957132888870597],
            [6.3925665546846915, -3.779243250384323],
            [6.3907849606072675, -3.7519823743121226],
            [6.418489318354423, -3.749840150626311],
            [6.497708545306587, -3.7444314427776737],
            [6.533611499228853, -3.7416139736027616],
            [6.621277313418967, -3.7350313439120213],
            [6.677643157321219, -3.730662484330637],
            [6.691556223489308, -3.729794956846782],
            [6.692775241544468, -3.744315772160687],
            [6.707093957175261, -3.743315085171056],
            [6.716838531101012, -3.8591647311976427],
            [6.720029459073896, -3.9040694743796234],
            [6.7258743956311475, -3.966284124366936],
            [6.730844398314478, -4.021088308710012],
            [6.693386393513707, -4.0231471649873995],
            [6.635876185197228, -4.026951233641457],
            [6.557142517839648, -4.033188076576448],
            [6.554552193429987, -4.002749918407859],
            [6.5539411249319155, -3.9891403738280875],
            [6.520183122723042, -3.9921109142344804],
            [6.499763500121484, -3.9931159903369906],
            [6.488528894166251, -3.994180209874125],
            [6.3952769698916, -4.00170767633349],
            [6.389370857731074, -3.9138251411704803]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.52005742845164, "lat": 34.61828152055011 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28117"],
        "coty_name": ["Prentiss"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prentiss County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00695779"
      },
      "bbox": [
        6.389370857731074, -4.033188076576448, 6.730844398314478,
        -3.729794956846782
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.963854486602637, -0.2415799066660489],
            [1.9640068548269354, -0.22266077485081073],
            [1.9618320976154275, -0.22250302719357515],
            [1.9618625473279467, -0.18919114576635584],
            [1.9624632890213207, -0.1201146602873991],
            [2.065957506240166, -0.1209173111482119],
            [2.1192751715265956, -0.12097626474517016],
            [2.1905327077171375, -0.12077977753251302],
            [2.2189623266702627, -0.12092926331694072],
            [2.2192474282244903, -0.12054167228073279],
            [2.2624828554925025, -0.12069232312825547],
            [2.306804652660337, -0.12067523459271602],
            [2.351784733984458, -0.1212034619742609],
            [2.391059949319757, -0.1214185205957744],
            [2.3908893555181367, -0.16559933270319924],
            [2.390960509737103, -0.17652189509991462],
            [2.390608147001366, -0.2241482110254407],
            [2.392993162004811, -0.22415853124062135],
            [2.393232950404332, -0.23186455108712972],
            [2.392773160119464, -0.27579585224238395],
            [2.3922926056800513, -0.3054879942187589],
            [2.3910838795290754, -0.40798498832888774],
            [2.3906000953603272, -0.47395784272466035],
            [2.37810975203853, -0.47464493889901727],
            [2.36418436148565, -0.4620585514968255],
            [2.3581546278661842, -0.4612789659760832],
            [2.3544828307392627, -0.4630436985432337],
            [2.353597189711494, -0.4666370905563903],
            [2.359556657136467, -0.4759836113328911],
            [2.3644266780613603, -0.4808394539688698],
            [2.350110978763302, -0.48121211610454995],
            [2.3186886170415044, -0.48049090830970065],
            [2.2090042542995527, -0.47957339358827233],
            [2.1331168951203714, -0.47855107585885387],
            [2.0663796698978425, -0.47758952988508313],
            [1.9809495769569967, -0.47666186938209],
            [1.9612431723257897, -0.47654145756272104],
            [1.961512705395307, -0.4325196728562254],
            [1.9633340892727866, -0.300804113259532],
            [1.963854486602637, -0.2415799066660489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.79276764875661, "lat": 38.38518839517312 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29083"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00758496"
      },
      "bbox": [
        1.9612431723257897, -0.48121211610454995, 2.393232950404332,
        -0.1201146602873991
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.622595337422589, 1.3276503488170441],
            [3.6984276643087157, 1.330353906231873],
            [3.7859536324804015, 1.3338828608892723],
            [3.789662221898399, 1.3336234830033151],
            [3.8257632771741767, 1.335288754756096],
            [3.9299770144224073, 1.3387773375910246],
            [3.9350705316485426, 1.334439600865672],
            [3.9409291544009393, 1.3268753424692183],
            [3.9430607674832325, 1.3216690162030593],
            [3.943752350665945, 1.3160548626491386],
            [3.942533286904108, 1.3086616588964484],
            [3.936747333737665, 1.3011748009193351],
            [3.9263798042098275, 1.2863875228330233],
            [3.9238463585193624, 1.2704756551526808],
            [3.9253197648831155, 1.2629126100437955],
            [3.9343749605048726, 1.2382102560392778],
            [3.9397123627064157, 1.2306793657950725],
            [3.951496466695175, 1.223350569079324],
            [3.957968249658468, 1.2201154085826136],
            [3.9645912188841814, 1.2150313255539653],
            [3.980186760131076, 1.2058387669633521],
            [3.988327019108823, 1.1952538752833277],
            [3.992139148133816, 1.1877628786859848],
            [3.9938121534190403, 1.1800402118050144],
            [3.991731652360498, 1.1741891678879985],
            [3.991636934340961, 1.1596041029562503],
            [3.9925376942042092, 1.1533508799606103],
            [3.989537175103496, 1.1393825809380622],
            [3.9901098076535493, 1.1267633730166162],
            [3.991998558012821, 1.1233243819747525],
            [4.004095926602615, 1.1100231907216398],
            [4.010056560396761, 1.1043772287686977],
            [4.02092810735706, 1.0958488336812071],
            [4.0318162260946995, 1.088461394409217],
            [4.04067666556627, 1.0811084970478757],
            [3.979068322742386, 1.0786200882277959],
            [3.850237319571627, 1.0724032528449576],
            [3.7823726562402364, 1.0698496628460916],
            [3.729252773836164, 1.0680192415291863],
            [3.729985145403712, 1.0515667963415252],
            [3.7310775767340942, 1.045628550241444],
            [3.730755429002973, 1.0389445655375922],
            [3.716005821056376, 1.0379989383749848],
            [3.694208418545616, 1.0375801197433903],
            [3.660357099815601, 1.0365530680746409],
            [3.6305195889915782, 1.035370732827367],
            [3.6302309313270635, 1.0418140168470509],
            [3.6271943342971436, 1.1412113061629772],
            [3.6260191474554047, 1.196762505337288],
            [3.6251887385225636, 1.223597199873282],
            [3.6235353229280336, 1.298690300287662],
            [3.622595337422589, 1.3276503488170441]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.62242570082815, "lat": 39.80591636148688 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29127"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00758517"
      },
      "bbox": [
        3.622595337422589, 1.035370732827367, 4.04067666556627,
        1.3387773375910246
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0812519323639607, -0.2268377958987826],
            [3.178271039010174, -0.2264093846016134],
            [3.1821482868332094, -0.22616438895346275],
            [3.253335421093132, -0.22602793837665633],
            [3.2527228784367965, -0.3109205947809057],
            [3.3155393501053427, -0.31267227476525555],
            [3.3350083345353254, -0.3125406009826119],
            [3.338745944943986, -0.3097504152029764],
            [3.345670201698272, -0.3098844532601534],
            [3.353838463369188, -0.31401136523542295],
            [3.361842899912967, -0.3198607983092117],
            [3.37627224272404, -0.3249740385240911],
            [3.3894263515363563, -0.31936534673474704],
            [3.3945730305445485, -0.31392018579751885],
            [3.3955459054258337, -0.31105290248136597],
            [3.4189953826427093, -0.3103163203425757],
            [3.419814435548109, -0.35404139168331433],
            [3.4210003809058156, -0.3988704951805437],
            [3.4234636284799618, -0.48597913958525646],
            [3.436235781934804, -0.485770008855923],
            [3.4391184533784274, -0.6282666703429919],
            [3.4389965330139143, -0.6320935771707851],
            [3.409411603168181, -0.6326187699242198],
            [3.3529263365305066, -0.6333795353229636],
            [3.352912820192156, -0.632872775178928],
            [3.3001298342356646, -0.6338571203128731],
            [3.298066194785727, -0.6332792597581529],
            [3.287548267767976, -0.6340860541715105],
            [3.2665994499449615, -0.6339235001419968],
            [3.1810339549749256, -0.6359416344488847],
            [3.1808046144960596, -0.6211975589395222],
            [3.166509828232035, -0.6211839046204441],
            [3.166247542680407, -0.6067027596840988],
            [3.1515637682006954, -0.6068965429871617],
            [3.15127783296253, -0.592568853065925],
            [3.1370867853467983, -0.5927793735344791],
            [3.1364858641897633, -0.5631964587458995],
            [3.122224682786195, -0.5635079122033647],
            [3.121929551979324, -0.5488653048821012],
            [3.1148604482651865, -0.5489996335214331],
            [3.114128286841695, -0.5325438079692539],
            [3.1141120974683445, -0.5196907517612747],
            [3.107159048598033, -0.5198314026501432],
            [3.1065278068854743, -0.48869345083618865],
            [3.077996272030156, -0.4888002401280446],
            [3.0774748339441147, -0.4469865036853242],
            [3.0679341996793137, -0.44861762833799107],
            [3.0638803392979064, -0.4478701845199919],
            [3.0498764266601173, -0.4481604521873969],
            [3.041663993411748, -0.4422839233116958],
            [3.03376807743233, -0.43942670593892597],
            [3.0341232484662672, -0.3869444344726916],
            [3.0340276174532623, -0.31166194580948064],
            [3.07756711817137, -0.3105261655965332],
            [3.077368327796117, -0.2267937745826202],
            [3.0812519323639607, -0.2268377958987826]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.42836418755036, "lat": 38.21448811715578 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29131"],
        "coty_name": ["Miller"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miller County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00758520"
      },
      "bbox": [
        3.03376807743233, -0.6359416344488847, 3.4391184533784274,
        -0.22602793837665633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.735382612990824, -0.1380768345113464],
            [2.735521783017489, -0.04630503741720767],
            [2.7357959056438115, -0.01769382646575868],
            [2.7357019264486024, 0.018861351367744302],
            [2.735955378554537, 0.026692351448133922],
            [2.7513248814237468, 0.02610072399669438],
            [2.820761236681739, 0.02224423317374496],
            [2.8921687585428875, 0.02226137638618721],
            [2.906334520175094, 0.02296557618529653],
            [2.9076875623084564, -0.06507008133060545],
            [3.002459883464143, -0.153183743010798],
            [3.0112973426956526, -0.16158485349115598],
            [3.0812519323639607, -0.2268377958987826],
            [3.077368327796117, -0.2267937745826202],
            [3.07756711817137, -0.3105261655965332],
            [3.0340276174532623, -0.31166194580948064],
            [3.0341232484662672, -0.3869444344726916],
            [3.03376807743233, -0.43942670593892597],
            [3.024911424759513, -0.43771340145916704],
            [3.0161839036032383, -0.4419558749079926],
            [3.006166785008952, -0.44082904005675166],
            [2.998934572047492, -0.4438338091239144],
            [2.992591026345154, -0.4453646323830966],
            [2.9873671079051607, -0.4506910456801385],
            [2.9858658967698783, -0.45732486036597003],
            [2.9832870696360265, -0.46154825193315946],
            [2.981624170766374, -0.46745494802589094],
            [2.981502771391969, -0.47397393885865546],
            [2.9013438614045697, -0.4727996805901363],
            [2.826878339533173, -0.4713892636644514],
            [2.8292116260502396, -0.46646419811992823],
            [2.831647204584246, -0.4646697246426536],
            [2.8411456980390697, -0.4622432257582504],
            [2.848439536897265, -0.45665365449900175],
            [2.85037309619579, -0.45143866804241684],
            [2.8502427314933194, -0.4474016363496947],
            [2.8455468841512763, -0.4425076365528427],
            [2.834684444815474, -0.4387298299007441],
            [2.827741656272476, -0.4399120385061804],
            [2.825383518110217, -0.44288800618755825],
            [2.8207593586443798, -0.45340633256520146],
            [2.8167948805513565, -0.46539452001888615],
            [2.8139777992875774, -0.4712902872352779],
            [2.8062302079260726, -0.48099146492073125],
            [2.798292117140087, -0.4833924051026681],
            [2.7936273809891667, -0.48378705120562804],
            [2.7851045415051394, -0.47872082649802145],
            [2.780719927749402, -0.47142270704116884],
            [2.782296244827132, -0.46515502088733746],
            [2.788315138182685, -0.45948320142893073],
            [2.792589318085166, -0.4587990723035939],
            [2.8008777188545606, -0.4592850920286313],
            [2.8093885844730893, -0.4576011036551569],
            [2.810647438675999, -0.4531158588555992],
            [2.8080758440824725, -0.4481460091875231],
            [2.795761660715279, -0.4484123256494274],
            [2.7928877834200514, -0.44672989758319404],
            [2.7888336362693944, -0.4378599631213253],
            [2.7859996461112897, -0.427994756359445],
            [2.780426969371366, -0.42140990055746647],
            [2.7691110221446116, -0.4127501765055014],
            [2.76291837909696, -0.4047569195912584],
            [2.7560693291427634, -0.4000063266944133],
            [2.7516848207345666, -0.3984813910128246],
            [2.744064534365213, -0.39969297182701086],
            [2.7394275554125067, -0.40319208578279253],
            [2.735614201994383, -0.40771118964547837],
            [2.7357670214530265, -0.3967229104136034],
            [2.73608723772089, -0.30857057034402513],
            [2.7370808739999752, -0.2353383480058343],
            [2.736974239437725, -0.22664935787222665],
            [2.734422778490739, -0.22672701730216205],
            [2.735382612990824, -0.1380768345113464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.88599676694085, "lat": 38.42372593273974 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29141"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00758525"
      },
      "bbox": [
        2.734422778490739, -0.48378705120562804, 3.0812519323639607,
        0.026692351448133922
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.263999357418592, -1.027336981212582],
            [4.306655426715948, -1.0254823979956413],
            [4.321970971417797, -1.02249485918026],
            [4.384672276632649, -1.006743501765818],
            [4.3950477218769395, -1.004601090288735],
            [4.4780913977438095, -1.001222561419565],
            [4.513524693757127, -0.9992939631659032],
            [4.548514049628199, -0.9980957975850264],
            [4.565942582985661, -0.9962347523846322],
            [4.5677110057678885, -1.0503010866868119],
            [4.569792419666113, -1.0948097755323865],
            [4.570993415637174, -1.1243993165275006],
            [4.5731656970438355, -1.1707436846788994],
            [4.575340790688208, -1.2276232679517987],
            [4.593642298867619, -1.2274862889315696],
            [4.595653254828502, -1.2860638965046032],
            [4.594881241466543, -1.2861682334975304],
            [4.596292691977537, -1.3311584538964676],
            [4.610541857980989, -1.329432722686156],
            [4.612443875404899, -1.3737507515101213],
            [4.613794804904531, -1.373630369479573],
            [4.614419137491173, -1.3909082395411148],
            [4.614382620612362, -1.4203098840101502],
            [4.61505668545452, -1.4349609999411708],
            [4.600285085834979, -1.4354656815786384],
            [4.601166669104671, -1.4647173600503276],
            [4.583647734639527, -1.465790595280583],
            [4.584691505975211, -1.482091927847208],
            [4.588075182877666, -1.5538064039583228],
            [4.511426194112355, -1.556312089136421],
            [4.486089835326762, -1.5572781801511895],
            [4.441952381662519, -1.5583998448577727],
            [4.4403247298853845, -1.5142386161973023],
            [4.4115730342350385, -1.5154654491168662],
            [4.411506428476406, -1.5126842904808833],
            [4.397655724198083, -1.5181899395654666],
            [4.395983484460073, -1.488589448282493],
            [4.395602136058159, -1.4699817411501783],
            [4.381605156941537, -1.474047213781932],
            [4.380691837025915, -1.4446183904975527],
            [4.352115682950251, -1.4528092446793839],
            [4.351662499433395, -1.437811608995278],
            [4.337473053058756, -1.4419771702981874],
            [4.336436486625908, -1.4127040220044704],
            [4.3215245512741856, -1.4134190350027767],
            [4.321657570249973, -1.4175017865560247],
            [4.306876426730746, -1.4179796739664063],
            [4.305353050764059, -1.3770374182878546],
            [4.307027371066965, -1.3769737119171477],
            [4.306292511390012, -1.3623922739943888],
            [4.2777916209408, -1.3633103753890512],
            [4.2755179484828645, -1.3049221372515623],
            [4.261588532030849, -1.3059593514541887],
            [4.26075589740068, -1.2910931629020872],
            [4.258324415231995, -1.2328015933971113],
            [4.256943853073907, -1.2028745034370156],
            [4.228280108399992, -1.2038478257347256],
            [4.225852935169014, -1.1436581267595731],
            [4.224564450383456, -1.11645955428833],
            [4.143386576060418, -1.1172524129146268],
            [4.140416076971994, -1.028754962236104],
            [4.164669241814332, -1.0281181404870092],
            [4.192833403407408, -1.028665734957882],
            [4.22135711636743, -1.0287731457082658],
            [4.245722037501257, -1.0276837764578968],
            [4.263999357418592, -1.027336981212582]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.96908483659402, "lat": 37.36232426553246 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29179"],
        "coty_name": ["Reynolds"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Reynolds County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00758544"
      },
      "bbox": [
        4.140416076971994, -1.5583998448577727, 4.61505668545452,
        -0.9962347523846322
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.049379472048356, 10.295836904697463],
            [-11.964915903774886, 10.279485693046665],
            [-11.948638840023378, 10.361371040775543],
            [-11.958383667516362, 10.363272177561937],
            [-11.94180687104449, 10.446158089710304],
            [-11.859598843094263, 10.430318009698667],
            [-11.82888537181739, 10.42461598982334],
            [-11.740053568252662, 10.407659801341763],
            [-11.737894807433666, 10.407388607270205],
            [-11.641082400048134, 10.38916515265713],
            [-11.642183196880898, 10.398278272537953],
            [-11.63766159821541, 10.408206749454601],
            [-11.636702935550604, 10.41315701181663],
            [-11.638420094831755, 10.422488356942614],
            [-11.64332713238237, 10.427445483183213],
            [-11.650823322256938, 10.422199594191792],
            [-11.65257474968692, 10.431714567762722],
            [-11.652554245118454, 10.435850376458342],
            [-11.654842590752382, 10.442951679642082],
            [-11.656063428350345, 10.452189488410433],
            [-11.637521440166424, 10.448528522762423],
            [-11.634610445968406, 10.462225876149514],
            [-11.620321771125921, 10.459527485350925],
            [-11.618120447612608, 10.473319857837483],
            [-11.560733147389618, 10.46246286260826],
            [-11.522390055428533, 10.455564631416719],
            [-11.524230489520125, 10.451745316515701],
            [-11.519380559685041, 10.444818887918839],
            [-11.517261083633214, 10.445527980311859],
            [-11.512371932565854, 10.443318737195696],
            [-11.51588975850543, 10.437031266914582],
            [-11.510509979126931, 10.427159017701543],
            [-11.511742786006895, 10.421134219343944],
            [-11.5151715863265, 10.421021027190351],
            [-11.516689540397234, 10.417010119039661],
            [-11.516147693161386, 10.410121680757523],
            [-11.513586531410466, 10.403789639534839],
            [-11.513427586440223, 10.398500453048628],
            [-11.508086449286028, 10.387750208144887],
            [-11.50926220597408, 10.38326709160782],
            [-11.507979244083133, 10.379740434809017],
            [-11.502183402803412, 10.37683452967289],
            [-11.499215646610523, 10.380920683877463],
            [-11.494286801255921, 10.377637244999168],
            [-11.48827066040254, 10.380967181044701],
            [-11.485236084873426, 10.376978427742914],
            [-11.482074652496474, 10.376861572236896],
            [-11.482368256158928, 10.372382392582653],
            [-11.478549265231285, 10.368167234335097],
            [-11.47827941901456, 10.365155783107795],
            [-11.474619825374324, 10.364141244169483],
            [-11.47061893457618, 10.359191578825113],
            [-11.469046897109715, 10.353428156029448],
            [-11.465390142337371, 10.351663014856998],
            [-11.468016011900795, 10.344691684881415],
            [-11.465980121935619, 10.341541934432492],
            [-11.459928539172187, 10.344512536041702],
            [-11.453657676762493, 10.34274454223085],
            [-11.449627073789392, 10.343752041013069],
            [-11.447059102949714, 10.336522911149613],
            [-11.445074820737215, 10.335182024474165],
            [-11.440541220233543, 10.32344347156832],
            [-11.441795069697637, 10.313516911542052],
            [-11.437256355940622, 10.305476408970472],
            [-11.430733911167723, 10.304739148782755],
            [-11.426228379696193, 10.302243975084998],
            [-11.424128350379869, 10.303061459958473],
            [-11.422970284916628, 10.294840192875832],
            [-11.419775756638815, 10.291561427616758],
            [-11.417620479695323, 10.286902902969205],
            [-11.410132112540218, 10.280209083530636],
            [-11.408212267318094, 10.273085114898448],
            [-11.408133936880544, 10.266477501468335],
            [-11.411381685548825, 10.254802351866346],
            [-11.417650684973076, 10.251258381293086],
            [-11.419196487503383, 10.246052168005013],
            [-11.417658302232914, 10.240371182163296],
            [-11.418193805720486, 10.228485878229137],
            [-11.416485087490697, 10.226047105413473],
            [-11.422058350214977, 10.21932161398168],
            [-11.423893170846645, 10.213428285926554],
            [-11.423272286642321, 10.207510396056781],
            [-11.421315067114607, 10.205352230841752],
            [-11.423933845686552, 10.19927540364801],
            [-11.429199509244606, 10.19972358025055],
            [-11.433303388582228, 10.193882938466636],
            [-11.43478047351053, 10.183662886441663],
            [-11.431236272194871, 10.181814608965055],
            [-11.429985917155253, 10.171396892048621],
            [-11.419748336884844, 10.16021645375763],
            [-11.417386932966034, 10.150854226518975],
            [-11.421085985463408, 10.142606181771338],
            [-11.426014493693987, 10.138361483465024],
            [-11.430965730558297, 10.137169700349801],
            [-11.432472444400055, 10.133813281863587],
            [-11.431341321733587, 10.124078835697523],
            [-11.426370910453116, 10.119688816187397],
            [-11.421138864150526, 10.108180322014036],
            [-11.416931158434165, 10.105533082525614],
            [-11.41225099766451, 10.105652982780802],
            [-11.405219801409721, 10.107678053801664],
            [-11.396876653899461, 10.10392293856705],
            [-11.39836041728026, 10.098347410307735],
            [-11.397732592677645, 10.093846021462662],
            [-11.399706444591398, 10.08516208804147],
            [-11.397744770509957, 10.080238279065705],
            [-11.400005360332944, 10.066419332633245],
            [-11.405742304786086, 10.056466219040367],
            [-11.40888290380758, 10.048193189909766],
            [-11.416829093468852, 10.048343729848929],
            [-11.420849511314474, 10.045901670006616],
            [-11.425127397373693, 10.035752950263147],
            [-11.425663627567632, 10.024397853810255],
            [-11.43092649802473, 10.016211759892277],
            [-11.429174204462532, 10.010985172278373],
            [-11.432045334205371, 10.007299296850844],
            [-11.434028610360036, 10.00010150836923],
            [-11.439201393045403, 9.99095196703069],
            [-11.520153201529318, 10.006187182163318],
            [-11.618589886255588, 10.024575974396283],
            [-11.649097940884266, 10.030068313144374],
            [-11.647762098345774, 10.026772819334317],
            [-11.63706907014259, 10.026318936654354],
            [-11.63643124339165, 10.02147311648598],
            [-11.63870013954892, 10.018184356252208],
            [-11.638168335468121, 10.01449145522793],
            [-11.640951354680896, 10.009354274111528],
            [-11.642398129177593, 10.003967655119432],
            [-11.63909426671, 9.993837328986114],
            [-11.64012474604603, 9.988876825735069],
            [-11.638393764522545, 9.986089374094052],
            [-11.639013377139339, 9.977797289682993],
            [-11.64163437015535, 9.973862299256183],
            [-11.645934368475968, 9.972633588120827],
            [-11.647581081503587, 9.96995183348933],
            [-11.64401029745283, 9.965713317337183],
            [-11.645294503216325, 9.96030342074738],
            [-11.649841004037912, 9.951103221578471],
            [-11.642101772397316, 9.944601479520136],
            [-11.640773133984101, 9.940248152084843],
            [-11.644473788221108, 9.93073395323266],
            [-11.653278503542337, 9.929383745413519],
            [-11.655461199667267, 9.931922514839195],
            [-11.664894109923273, 9.92626968085387],
            [-11.663787889309706, 9.921100005350791],
            [-11.667622534979342, 9.913701913186049],
            [-11.673837523346752, 9.911224430259967],
            [-11.670281334427997, 9.906459873225447],
            [-11.666753725789686, 9.905341511876836],
            [-11.663385861119977, 9.900365614978798],
            [-11.663366002939581, 9.89319996756262],
            [-11.664740168481597, 9.891156121257628],
            [-11.660963798724213, 9.887649164458034],
            [-11.656956801376598, 9.885860251103914],
            [-11.653657761826794, 9.881058061608382],
            [-11.647394892770672, 9.877943919892637],
            [-11.646503535905056, 9.871934735912669],
            [-11.643881061010443, 9.868282669461124],
            [-11.644119813937529, 9.863444323656669],
            [-11.641771172982912, 9.86101389744211],
            [-11.642204056396027, 9.853072774501497],
            [-11.644881018434884, 9.84673969209775],
            [-11.642906567482584, 9.840587110075134],
            [-11.643082080179395, 9.836735007108057],
            [-11.639441350414609, 9.82986687273814],
            [-11.637903448122705, 9.822260527894667],
            [-11.635962471506534, 9.82032827629748],
            [-11.637065637942461, 9.81330856431447],
            [-11.64158104952419, 9.805840512435108],
            [-11.643045106042015, 9.800777388922368],
            [-11.650268266530059, 9.799779171633473],
            [-11.65271147824972, 9.791505022603628],
            [-11.656780769590775, 9.791693458525586],
            [-11.654836007978927, 9.787016165672139],
            [-11.65465461044995, 9.77346635462058],
            [-11.65307738988979, 9.77024209954437],
            [-11.658257225140147, 9.761897313568848],
            [-11.660042789900306, 9.751342917673654],
            [-11.670387285473224, 9.748168905902848],
            [-11.669323061342086, 9.744026548233453],
            [-11.662366136629856, 9.74089668620443],
            [-11.65934299723218, 9.741043563970937],
            [-11.6565964607112, 9.736965840291315],
            [-11.654774736659013, 9.7310015895398],
            [-11.656299491404152, 9.726729380083203],
            [-11.655026320985696, 9.720365882177626],
            [-11.65099724841909, 9.720356648150725],
            [-11.645303102589482, 9.715394455004274],
            [-11.64452074311558, 9.709430280737097],
            [-11.640478111290085, 9.706704521700102],
            [-11.639257811617755, 9.701174047922683],
            [-11.634344749964065, 9.699920015232678],
            [-11.630586448575526, 9.701854644705366],
            [-11.62646539413088, 9.701303142338645],
            [-11.627521542123755, 9.69578476869226],
            [-11.625391436776734, 9.695402315426671],
            [-11.641708381468849, 9.611636432819404],
            [-11.716962855257263, 9.625770590085972],
            [-11.725023448051575, 9.583917693166557],
            [-11.774442423833976, 9.593107547479713],
            [-11.814675192636347, 9.600841500277607],
            [-11.854279047429594, 9.608169815449093],
            [-11.895355855752829, 9.616123120662332],
            [-11.887015436710866, 9.658185580197582],
            [-11.897782483606669, 9.66026176839757],
            [-11.87915123866726, 9.75483118320721],
            [-11.864813054875107, 9.827513331255075],
            [-11.868964262687392, 9.828478197379408],
            [-11.922001971256208, 9.838594372586916],
            [-11.924360940995477, 9.842294531896753],
            [-11.931877688255994, 9.847123280552157],
            [-11.946530893251797, 9.843871816205507],
            [-11.947670427965162, 9.847787562643711],
            [-11.944012551172378, 9.851987857106694],
            [-11.943743654101675, 9.855247248025513],
            [-11.945878989884934, 9.860819164918075],
            [-11.950798810038371, 9.86520263129052],
            [-11.953517953272751, 9.872034586829614],
            [-11.958674692715727, 9.879549564394651],
            [-11.956515931325328, 9.884908996423484],
            [-11.948544990365171, 9.895511465829362],
            [-11.944056752870573, 9.909684825749897],
            [-11.944166985060193, 9.915072961895557],
            [-11.94277873751329, 9.922930568258346],
            [-11.940752420861267, 9.926678087820916],
            [-11.933270113850282, 9.93048884994323],
            [-11.929187358626976, 9.935733795631482],
            [-11.925965413610504, 9.950358214401122],
            [-11.921856732927044, 9.951428098506755],
            [-11.917485102888838, 9.948991236699891],
            [-11.912610206776188, 9.942769174228534],
            [-11.905230385126627, 9.941659236981693],
            [-11.897672664320499, 9.946271921284067],
            [-11.896039031030215, 9.949262165492682],
            [-11.896174561852463, 9.955953097578547],
            [-11.89879546939009, 9.964302248916422],
            [-11.900674178970327, 9.973046153774055],
            [-11.907120505652752, 9.976681892899986],
            [-11.914770838325856, 9.976280349956038],
            [-11.92233723501782, 9.978505802818916],
            [-11.924606237016329, 9.977859378072303],
            [-11.93323224616, 9.981486528450905],
            [-11.936479571526931, 9.981849474408481],
            [-11.945900647039279, 9.978004345976576],
            [-11.95276467252341, 9.969437883678255],
            [-11.955684849269439, 9.968905883686329],
            [-11.96095359413709, 9.97160639293087],
            [-11.958213443390655, 9.980301274840606],
            [-11.951523877788924, 9.986095200133521],
            [-11.947425066574334, 9.995626119057267],
            [-11.941143437231588, 10.006800574709647],
            [-11.940965478876084, 10.019483241394957],
            [-11.936171877455271, 10.026117866708251],
            [-11.93243675807936, 10.027887461191565],
            [-11.923237966717368, 10.029173580882944],
            [-11.917202933730824, 10.031614613160315],
            [-11.912501084475581, 10.035161595966725],
            [-11.908728952432869, 10.042120583851228],
            [-11.909851562114131, 10.047309614234274],
            [-11.915169188421627, 10.050181143297845],
            [-11.913918638235867, 10.06287806276194],
            [-11.912454053831551, 10.065275935538814],
            [-11.904093528857743, 10.066427328085936],
            [-11.89826873346478, 10.069796732016293],
            [-11.8987476683078, 10.07352571035786],
            [-11.903737566609225, 10.076865358254542],
            [-11.910026662308955, 10.073878929868926],
            [-11.913279368933138, 10.069703725586052],
            [-11.91548892815497, 10.073304690518697],
            [-11.916384986384971, 10.083086861249308],
            [-11.972437767734188, 10.093703268868312],
            [-12.071929140470047, 10.112798703687421],
            [-12.05892931953014, 10.178806724865296],
            [-12.044486843305076, 10.251553883707317],
            [-12.058030545074516, 10.25426081999441],
            [-12.049379472048356, 10.295836904697463]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.0894157347761,
          "lat": 47.645895310958096
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30047"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01796943"
      },
      "bbox": [
        -12.071929140470047, 9.583917693166557, -11.396876653899461,
        10.473319857837483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.098560391318629, 1.8997814604213785],
            [-4.093460525062668, 1.9803643969737248],
            [-4.092476446724796, 1.9982275546478367],
            [-4.085319278136795, 2.107777310663284],
            [-4.081981378916376, 2.1588681966171275],
            [-3.979679280995197, 2.153647193841678],
            [-3.9508245347928366, 2.1516249430599994],
            [-3.845354310170701, 2.146179759884371],
            [-3.7641040071649803, 2.1419318177626896],
            [-3.6653927309458116, 2.1345875866379833],
            [-3.6232482117029297, 2.1316348849383933],
            [-3.5521845148605515, 2.127644643292366],
            [-3.556598432506506, 2.039329100199094],
            [-3.561308692398349, 1.9532936823817593],
            [-3.5611829847739065, 1.9448045227494228],
            [-3.563966167379112, 1.894067448748897],
            [-3.5699539770434003, 1.7776008192585389],
            [-3.655417374329572, 1.7822104230970033],
            [-3.7700875420640227, 1.7885407321256799],
            [-3.827309709420237, 1.79179891233776],
            [-3.8980328563279296, 1.7960442062129636],
            [-3.9377344517870356, 1.7982088605996414],
            [-4.047994239688882, 1.8049124406384198],
            [-4.104455112933718, 1.8084204232785104],
            [-4.103942760342029, 1.8193560805257407],
            [-4.101653325044522, 1.8525647399247096],
            [-4.101642363041024, 1.8559144698855305],
            [-4.098560391318629, 1.8997814604213785]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.6979865374391, "lat": 40.52417367747994 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31029"],
        "coty_name": ["Chase"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chase County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00835836"
      },
      "bbox": [
        -4.104455112933718, 1.7776008192585389, -3.5521845148605515,
        2.1588681966171275
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.104455112933718, 1.8084204232785104],
            [-4.047994239688882, 1.8049124406384198],
            [-3.9377344517870356, 1.7982088605996414],
            [-3.8980328563279296, 1.7960442062129636],
            [-3.827309709420237, 1.79179891233776],
            [-3.7700875420640227, 1.7885407321256799],
            [-3.655417374329572, 1.7822104230970033],
            [-3.5699539770434003, 1.7776008192585389],
            [-3.5552901740349077, 1.776887627987021],
            [-3.5577559158741887, 1.755717623598256],
            [-3.5599901463159767, 1.7190982768418184],
            [-3.5641530803476775, 1.6456524866708901],
            [-3.5660956332313205, 1.6068569500891112],
            [-3.5665702973702897, 1.6015465849921666],
            [-3.5709731602823767, 1.513914873246975],
            [-3.5738916702783348, 1.4518666377846696],
            [-3.5754567463542752, 1.4266072794563898],
            [-3.6414144512393576, 1.4300000632976437],
            [-3.732542367790358, 1.4354806684539736],
            [-3.805103999949397, 1.4397711982961063],
            [-3.897092213559689, 1.445372063542426],
            [-3.9672043223892195, 1.449725348705754],
            [-4.015025063391492, 1.453065003156427],
            [-4.126822499258076, 1.4600188352959906],
            [-4.117688383290835, 1.6062847851201676],
            [-4.112417472973172, 1.6876438435638774],
            [-4.1049663755436905, 1.7975067964893765],
            [-4.104455112933718, 1.8084204232785104]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.68794411883059,
          "lat": 40.176194065891615
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31057"],
        "coty_name": ["Dundy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dundy County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00835850"
      },
      "bbox": [
        -4.126822499258076, 1.4266072794563898, -3.5552901740349077,
        1.8084204232785104
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7061745926834173, 1.73381007319564],
            [-2.628384615408858, 1.7316453072700901],
            [-2.5426438104762914, 1.7279858677233846],
            [-2.505578379503792, 1.726495140210023],
            [-2.4784862808655497, 1.7252046891119281],
            [-2.3920072907688916, 1.7216367337923868],
            [-2.3500703084948587, 1.7201871809652247],
            [-2.286798345910538, 1.7176951199585409],
            [-2.277932337805775, 1.7172751617655133],
            [-2.2821239151360726, 1.6120768304835174],
            [-2.2822122385273786, 1.603568611007252],
            [-2.2842053747431095, 1.5406302027574255],
            [-2.2849456235400405, 1.526121970157253],
            [-2.2860544842120913, 1.4900910004584325],
            [-2.2876256591887683, 1.4531323142522412],
            [-2.2879762833413473, 1.434647387835162],
            [-2.2897181131635413, 1.3651893887571895],
            [-2.3795069679229925, 1.368627314445953],
            [-2.3872679053661754, 1.3684511276735574],
            [-2.401519036065571, 1.3693239284942125],
            [-2.430169813620717, 1.3702186758749442],
            [-2.518928219854864, 1.3739526352195486],
            [-2.5323657615262563, 1.3748096329876813],
            [-2.5648080157307747, 1.3758519797933138],
            [-2.632901893578551, 1.3787880031409068],
            [-2.7065217642349486, 1.3820347783551685],
            [-2.7185007951331497, 1.382542336225281],
            [-2.7169480335974043, 1.4117677745564523],
            [-2.7146812112807597, 1.4695934852049817],
            [-2.7136948985847065, 1.4992934438457053],
            [-2.7137100418408475, 1.5069698857037765],
            [-2.711966802631522, 1.5431181903246025],
            [-2.7115559814183054, 1.557960065217329],
            [-2.7075961442674052, 1.6596163489100104],
            [-2.7061745926834173, 1.73381007319564]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.9123123772399, "lat": 40.17643731196353 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31065"],
        "coty_name": ["Furnas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Furnas County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00835854"
      },
      "bbox": [
        -2.7185007951331497, 1.3651893887571895, -2.277932337805775,
        1.73381007319564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.41324358439759257, 1.8384120537481994],
            [0.49161818938278734, 1.838350280553754],
            [0.541255087317799, 1.8382113501383974],
            [0.6270978722178698, 1.8384967839669792],
            [0.6519364308823618, 1.838446807771465],
            [0.6822850357690751, 1.8393828903479632],
            [0.6833341222830278, 1.8371205730778246],
            [0.6918880980065623, 1.844130375836676],
            [0.6935005817792839, 1.848820787620618],
            [0.6918072651629559, 1.8527081418491587],
            [0.6922390840771597, 1.8609285149607246],
            [0.6941036160081335, 1.8728363390526157],
            [0.6993921452896861, 1.8766060400459565],
            [0.7057052905437579, 1.8785386183403177],
            [0.710949796466817, 1.8786230696999582],
            [0.7156914432078094, 1.872650927400427],
            [0.7182681059946715, 1.8658778615428184],
            [0.7229874293927007, 1.8625172842892643],
            [0.7257200793611711, 1.853962412582397],
            [0.7232027455468375, 1.8392763829284275],
            [0.7186941764866784, 1.8329606603027442],
            [0.713959288558183, 1.830575580857294],
            [0.6958176942823829, 1.8236311413052966],
            [0.6898831221722344, 1.8207305435000283],
            [0.6929362167037939, 1.8144647483899812],
            [0.6938727492224883, 1.8089736231206728],
            [0.692389910647049, 1.7940934948540341],
            [0.6951524788636128, 1.7845707815482827],
            [0.7017862283084878, 1.7785123071340774],
            [0.7113279021378655, 1.771818028856643],
            [0.7161210950339166, 1.7662757519792256],
            [0.721603173435057, 1.7569155672502557],
            [0.7235605545680615, 1.7497188878310996],
            [0.7230858924832606, 1.7436961845688883],
            [0.7192272040470026, 1.7307568755658973],
            [0.7210111034237816, 1.723445308714628],
            [0.7283909597552531, 1.7108256610186747],
            [0.7325659079323931, 1.701462816292197],
            [0.7339477568673364, 1.692789390009291],
            [0.7337780887551317, 1.6843036633497426],
            [0.7379059868044017, 1.6757786574677453],
            [0.7453919738917534, 1.6671751107621022],
            [0.747982024994372, 1.6608994503867494],
            [0.7487784399646834, 1.6551431251518034],
            [0.7469158887605598, 1.64851195067202],
            [0.7404353554330364, 1.6434532543746079],
            [0.7297772973981332, 1.6396401647235361],
            [0.7254070509978865, 1.6366247973364176],
            [0.7223826136342079, 1.6297619665936554],
            [0.722730056905336, 1.6247891639963008],
            [0.7271449575386275, 1.6205976121174122],
            [0.7318182457314256, 1.6196154332145676],
            [0.7386275748105708, 1.6216400742914443],
            [0.7485074437630846, 1.6265134478797727],
            [0.758155493528625, 1.6280661303583408],
            [0.767077557793489, 1.6239067418657158],
            [0.7735245813258907, 1.6172678070894733],
            [0.7798733382700641, 1.613645528689572],
            [0.7901913013275751, 1.6132367977145998],
            [0.7973186538055266, 1.6098858350382248],
            [0.8014529062310387, 1.6052496448868951],
            [0.8032361970536512, 1.6000024253495058],
            [0.8028648006374676, 1.5950728043632787],
            [0.7992938425335011, 1.5846676922310572],
            [0.800425923196658, 1.5783177071911836],
            [0.8022110484990981, 1.5757482809431884],
            [0.7574489174417212, 1.5753538375483647],
            [0.7120958889546573, 1.575599447570905],
            [0.5980994373096634, 1.5748039035059198],
            [0.5407376250046346, 1.5743070936771177],
            [0.45604373546397997, 1.574526498615888],
            [0.4132665957450006, 1.5751045737380152],
            [0.4130788526689879, 1.6188085523809719],
            [0.41306541873336416, 1.6629396375748733],
            [0.4138729377819069, 1.6629481486601576],
            [0.41364572472519945, 1.750722974762784],
            [0.41331281637862777, 1.801890645810249],
            [0.41324358439759257, 1.8384120537481994]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.84984551113237,
          "lat": 40.387646091789186
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31127"],
        "coty_name": ["Nemaha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nemaha County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00835885"
      },
      "bbox": [
        0.41306541873336416, 1.5743070936771177, 0.8032361970536512,
        1.8786230696999582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.22081315853741, 4.111533345786742],
            [-2.2166157884715747, 4.113672005859029],
            [-2.2076467895342575, 4.115246786069209],
            [-2.1988204415436634, 4.11276826858539],
            [-2.1893413289224926, 4.1086632827180605],
            [-2.182923212339451, 4.103233004631609],
            [-2.1793827436310176, 4.10206701164212],
            [-2.16578795697584, 4.099759060072791],
            [-2.1579456609428695, 4.099829462097151],
            [-2.1510314212667856, 4.10208661111706],
            [-2.14304160207812, 4.101894053166516],
            [-2.131636574610826, 4.099184906349504],
            [-2.125114940022587, 4.095214257959339],
            [-2.119023455793966, 4.094345060194076],
            [-2.1107064639068347, 4.097426758526364],
            [-2.099500926686857, 4.103923413242297],
            [-2.0903803510357086, 4.107020928782025],
            [-2.0813801327938877, 4.106613561244906],
            [-2.0693220391323925, 4.113293380616449],
            [-2.067468122228093, 4.115842539442691],
            [-2.063050298195228, 4.126428474317578],
            [-2.055544289315943, 4.127742429438837],
            [-2.0499264795854897, 4.127010907750554],
            [-2.0444188216423074, 4.127750734864519],
            [-2.039704601102191, 4.135668279153905],
            [-2.027823837703229, 4.145711072399955],
            [-2.0164364851517, 4.14458084979606],
            [-2.005861052186897, 4.149923833777128],
            [-2.000297397747082, 4.1548856296629335],
            [-1.9903334929752423, 4.154724749214284],
            [-1.985164712460621, 4.152314641132814],
            [-1.9757781260937415, 4.151220458401386],
            [-1.970071210805824, 4.151985116703058],
            [-1.9562139519433963, 4.1608455753802325],
            [-1.948738963470017, 4.163151571043619],
            [-1.9430743809596591, 4.1668913263912355],
            [-1.9329744851599455, 4.166589335084152],
            [-1.930590508605409, 4.165119777920707],
            [-1.9247330726257217, 4.164909118196528],
            [-1.9184827846255537, 4.167773370573938],
            [-1.9113584977858111, 4.17395607233112],
            [-1.9119636383836258, 4.1522519994909155],
            [-1.9039168262077224, 4.15182073467904],
            [-1.9069859869548673, 4.064584134732251],
            [-1.9094843181036831, 3.993861499362574],
            [-1.9093623194166458, 3.988193757604778],
            [-1.9123142650227476, 3.8900458203974013],
            [-1.913063644988211, 3.874750285025832],
            [-1.9136875644479632, 3.846653461849057],
            [-1.914980003712491, 3.802809108149679],
            [-1.907269223361264, 3.8024312215105063],
            [-1.9088474018128325, 3.759570294999436],
            [-1.9134242875542058, 3.6285062852420027],
            [-1.9156340240908785, 3.5692715383209657],
            [-1.9195542198887232, 3.4544740738020185],
            [-2.0105029179997445, 3.4563566321042076],
            [-2.0107084134974897, 3.4565509634413707],
            [-2.081110603292856, 3.4588079733299884],
            [-2.2263205603341443, 3.4638982691768],
            [-2.234653170383463, 3.4638935202712293],
            [-2.231495614271596, 3.551363363025003],
            [-2.2283879583731445, 3.6387567050704197],
            [-2.225064632088222, 3.7404297928480736],
            [-2.222964404513336, 3.7907785021696143],
            [-2.222244060857696, 3.813535394017521],
            [-2.2310396452585577, 3.8141055874025374],
            [-2.227416602270821, 3.9155150511705057],
            [-2.225540205166419, 3.9717004291084654],
            [-2.2256442150991784, 3.9752657269928044],
            [-2.223781625791094, 4.0245880035408],
            [-2.22081315853741, 4.111533345786742]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.44990580918667,
          "lat": 42.421294791639866
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31149"],
        "coty_name": ["Rock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rock County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00835896"
      },
      "bbox": [
        -2.234653170383463, 3.4544740738020185, -1.9039168262077224,
        4.17395607233112
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.106050526638178, 3.5050223779400165],
            [-2.9950173456431335, 3.498807720820673],
            [-2.9520882131057355, 3.496271680756598],
            [-2.8558582565713904, 3.4915733626637246],
            [-2.7596291403978475, 3.4868581775302347],
            [-2.6803036443266643, 3.482600496838964],
            [-2.6812771276517, 3.468432770955828],
            [-2.6874832352287457, 3.3017142741342416],
            [-2.6886922715870076, 3.2702536395441117],
            [-2.690602813592067, 3.2356680327895444],
            [-2.6943708885901914, 3.134660688186018],
            [-2.728668044829975, 3.1361616967087786],
            [-2.7661351102464753, 3.138011048085375],
            [-2.8532328709695234, 3.1421170820046815],
            [-2.9403312465423417, 3.146210071618212],
            [-2.9433539474448893, 3.146539558914039],
            [-3.0242835282453124, 3.1501313055811457],
            [-3.0491061256527727, 3.1512374057528394],
            [-3.052203379276988, 3.1517757430008584],
            [-3.12118857952651, 3.1556481841748147],
            [-3.1164634388970605, 3.2664296310492764],
            [-3.111261717318341, 3.3895606088407293],
            [-3.110507552648489, 3.4170791549628126],
            [-3.106050526638178, 3.5050223779400165]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.55581325995165,
          "lat": 41.91363527112275
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31171"],
        "coty_name": ["Thomas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Thomas County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00835907"
      },
      "bbox": [
        -3.12118857952651, 3.134660688186018, -2.6803036443266643,
        3.5050223779400165
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.833416884735943, 7.7862940874801145],
            [17.847293400664054, 7.792514102967293],
            [17.863845590435663, 7.760009754557463],
            [17.886370793171647, 7.752548633143861],
            [17.906437565884268, 7.7142471995360955],
            [17.914271905534164, 7.683985865891318],
            [17.921225549581425, 7.679331015194],
            [17.92786923439488, 7.68709246303797],
            [17.93636770619784, 7.689494770512337],
            [17.931038089651196, 7.735054190796246],
            [17.928592738567296, 7.734276279163025],
            [17.938337599979175, 7.846897312562513],
            [18.046545872987057, 7.866485875353953],
            [18.06537252811647, 7.87363301702992],
            [18.084744856555453, 7.87876445929813],
            [18.075114595247676, 7.914709268820301],
            [18.071247477410395, 7.922768665868124],
            [18.09447030572751, 7.930097437817771],
            [18.102323575848406, 7.905375676100456],
            [18.105916722623245, 7.892613641159705],
            [18.150677748774733, 7.7475149846596985],
            [18.16622309233168, 7.698284942791584],
            [18.202684430204577, 7.579413107430111],
            [18.208044776802673, 7.560203099287568],
            [18.22481801716214, 7.505928963575067],
            [18.237734548501866, 7.460835007630151],
            [18.250838438128326, 7.423944128674498],
            [18.26270906907363, 7.387986796701492],
            [18.266484245426337, 7.374469591609861],
            [18.290657244093794, 7.302646420907007],
            [18.30707098346144, 7.250460540010267],
            [18.3103408114705, 7.249891179128785],
            [18.3165465477131, 7.245470102369875],
            [18.321548125692765, 7.243529332208598],
            [18.323586933338174, 7.238348475489721],
            [18.327338560480392, 7.2360361762537275],
            [18.32727238386033, 7.229160387279027],
            [18.324509532438253, 7.224542870979764],
            [18.32206641751223, 7.224306635637071],
            [18.31860622103846, 7.217720773097873],
            [18.305003948189775, 7.1849007037617],
            [18.29397768694708, 7.15680861145469],
            [18.2721955989554, 7.1994201892343215],
            [18.268912421921318, 7.193355270108181],
            [18.266307249823846, 7.197708480385947],
            [18.263366735770695, 7.191767310841296],
            [18.25975259079497, 7.194331531840368],
            [18.256129725258432, 7.189310152078825],
            [18.252215297173098, 7.191425253355934],
            [18.245526585117837, 7.168431427330832],
            [18.24072876839039, 7.173351690753062],
            [18.239474036357684, 7.1674901897787855],
            [18.23578813052436, 7.17099761663323],
            [18.233453576017315, 7.1654156005662015],
            [18.22894988773145, 7.169760473276986],
            [18.22693208796311, 7.163507646878716],
            [18.198383207701273, 7.224100514227297],
            [18.187589652518046, 7.195267148311412],
            [18.182870594662287, 7.1850810146449025],
            [18.151995550129417, 7.197704356663995],
            [18.15062752723229, 7.19042429092261],
            [18.147622424317667, 7.187661183227225],
            [18.130917915026806, 7.197750629767899],
            [18.108083383169838, 7.198628973988809],
            [18.044871404361565, 7.232244563481661],
            [18.04315209495362, 7.231524636753895],
            [18.037951880681568, 7.235778868936946],
            [18.021460148147078, 7.2450360141788845],
            [17.931456188885605, 7.294846777717112],
            [17.868746686438715, 7.331251599371573],
            [17.855247662428418, 7.364283955097457],
            [17.851337790256, 7.362815511677038],
            [17.81208280680015, 7.452567193669692],
            [17.938253569459345, 7.507675583901593],
            [17.946867630425277, 7.511290627592345],
            [17.91266202701709, 7.590424849390851],
            [17.90442927541922, 7.609943471985117],
            [17.90759097397109, 7.618083484562518],
            [17.91713788855302, 7.655678522624029],
            [17.91812899328826, 7.661096404994546],
            [17.904572717343285, 7.657225956133362],
            [17.886457226529185, 7.682663641502754],
            [17.88842197050153, 7.689552709325857],
            [17.884596448179206, 7.703773810216115],
            [17.867916808385726, 7.736763373108123],
            [17.846774224197812, 7.743825983002012],
            [17.826413724576454, 7.783157000737076],
            [17.833416884735943, 7.7862940874801145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.20311502373121, "lat": 43.87380687312587 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33003"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00873175"
      },
      "bbox": [
        17.81208280680015, 7.15680861145469, 18.327338560480392,
        7.930097437817771
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.469669051446356, 4.350049934406317],
            [16.488600856266185, 4.342622165761066],
            [16.524257425474094, 4.330795696351163],
            [16.572917569497598, 4.315532594425661],
            [16.580224655095414, 4.313391977008803],
            [16.599141883284616, 4.307854333418603],
            [16.587300375369438, 4.230039797725599],
            [16.581243624947405, 4.184361149421911],
            [16.588354582907748, 4.1798693195720436],
            [16.604423061648575, 4.163061536419516],
            [16.624390184062577, 4.156559954336122],
            [16.664289343518817, 4.161476225448382],
            [16.663350946731942, 4.168319662616562],
            [16.688692063299705, 4.156100478176709],
            [16.689025214121585, 4.131378972044481],
            [16.692633054334298, 4.130374388496676],
            [16.69608425300904, 4.126494783276476],
            [16.696140055181555, 4.119842039270764],
            [16.700196991496224, 4.114213451442846],
            [16.705143005780158, 4.114577497560394],
            [16.707789794305175, 4.112905682108433],
            [16.706518032191635, 4.1050643108242335],
            [16.70950082462951, 4.098298436202922],
            [16.708971593524776, 4.094736772565535],
            [16.71061951032498, 4.089663034424801],
            [16.71431010186931, 4.087919909427758],
            [16.715369417538287, 4.078426350342867],
            [16.722589316747353, 4.075806611698634],
            [16.72803947582776, 4.071125716403374],
            [16.733789915043726, 4.062335984976792],
            [16.73690878478688, 4.060831689859403],
            [16.738318794603547, 4.057111318768908],
            [16.73724755031527, 4.05274852562305],
            [16.73304487277652, 4.0562869794272585],
            [16.728150555807744, 4.052975016465946],
            [16.73102181800662, 4.046856065097444],
            [16.730459218758035, 4.03400771643649],
            [16.733929008957798, 4.028972761086123],
            [16.7343497130176, 4.018485429822914],
            [16.730410045310993, 4.014593029594856],
            [16.672318340429943, 4.039384952815556],
            [16.635984968989334, 4.055083935280321],
            [16.626384779373755, 4.054018128610461],
            [16.62165458324982, 4.054818789922568],
            [16.616621893622256, 4.057734885417162],
            [16.613522898129474, 4.064425603367678],
            [16.608989230573048, 4.066252570382957],
            [16.608424931872552, 4.072181748380559],
            [16.605761484973147, 4.074979875338005],
            [16.610468456610963, 4.077341644266803],
            [16.609767744573308, 4.079774243126483],
            [16.605066488890657, 4.084038691551172],
            [16.596737431699147, 4.083608667310033],
            [16.59338797594699, 4.089237409972199],
            [16.59059916178164, 4.09055163862125],
            [16.589193699514343, 4.094159058946805],
            [16.591625572920414, 4.097394494785928],
            [16.59301678723937, 4.106322188202947],
            [16.591746121697405, 4.121888452807004],
            [16.588917966172335, 4.124015183060905],
            [16.588086183571544, 4.131505698731129],
            [16.58485796464602, 4.137021424682964],
            [16.586105607504663, 4.141643467408901],
            [16.58072634792852, 4.143818586391416],
            [16.571627848132863, 4.142574287698661],
            [16.570703509832867, 4.146445640183863],
            [16.573068602420776, 4.151511069187182],
            [16.570227159141186, 4.154001455463016],
            [16.569545622978943, 4.157661577209172],
            [16.564220473673874, 4.161116796979505],
            [16.558534820966873, 4.1589363355103774],
            [16.5532133673327, 4.161792186847277],
            [16.54537352979106, 4.1584718547731985],
            [16.534155940468867, 4.160916305249478],
            [16.527595513783112, 4.157522393312869],
            [16.525321010422285, 4.1638676510268535],
            [16.521536675189598, 4.166364340788324],
            [16.516647117307137, 4.165168276519228],
            [16.509767716481605, 4.161095417935216],
            [16.50599092750134, 4.162735739300251],
            [16.501673318184334, 4.161762657142231],
            [16.49733212505637, 4.159017256803368],
            [16.494716754632382, 4.162338211318639],
            [16.488202523646624, 4.162369241974984],
            [16.482163692796163, 4.1678848938949695],
            [16.474764582722138, 4.17009201442453],
            [16.46869464151758, 4.1684001783833855],
            [16.466957271201622, 4.16076488317224],
            [16.462083984301668, 4.158969629840488],
            [16.46247215599035, 4.165602474225788],
            [16.46474952595145, 4.1718344201609625],
            [16.46371320237279, 4.1767705576698795],
            [16.459621593188338, 4.1770099284473705],
            [16.452025220835793, 4.182425400125703],
            [16.450121642083047, 4.1876757004798275],
            [16.445551475678624, 4.190674471417031],
            [16.439253469333572, 4.186722936750549],
            [16.43568028915409, 4.185910422362819],
            [16.43021663165252, 4.180262230479785],
            [16.425994141986166, 4.17943518476996],
            [16.420509756850763, 4.172878200522079],
            [16.41955957991287, 4.169081217271654],
            [16.413372909604174, 4.163401826828988],
            [16.4116430461432, 4.16341644849175],
            [16.408492316888726, 4.169432593635177],
            [16.409295967693232, 4.176114863395127],
            [16.408821216587555, 4.187941563758592],
            [16.409783419886868, 4.191203382471197],
            [16.41298869709551, 4.193955692488504],
            [16.4109478270393, 4.200757475963682],
            [16.411408567891407, 4.2058564034119055],
            [16.407626525169068, 4.206426240855896],
            [16.397486494506975, 4.212075418634267],
            [16.407922835014816, 4.233575156741658],
            [16.41137278393682, 4.2398052887459015],
            [16.44024178899306, 4.2989408171738015],
            [16.45723909668333, 4.328923698686774],
            [16.469669051446356, 4.350049934406317]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.30091188931175,
          "lat": 41.034358068473246
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34031"],
        "coty_name": ["Passaic"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Passaic County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00882232"
      },
      "bbox": [
        16.397486494506975, 4.014593029594856, 16.738318794603547,
        4.350049934406317
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.846707489249521, -3.875199633171619],
            [-5.846665615429802, -3.8747276922930074],
            [-5.820577696963148, -3.8769793161579633],
            [-5.813194012531491, -3.7893288986329097],
            [-5.75590180511275, -3.794516833349358],
            [-5.642467182478313, -3.80404401410369],
            [-5.635535834438633, -3.716599071472481],
            [-5.550003261727681, -3.723754024102759],
            [-5.542778319969375, -3.6361907972500127],
            [-5.457245122857884, -3.643236618397205],
            [-5.450222724726033, -3.553749927095874],
            [-5.254439233341931, -3.5685356120350944],
            [-5.258489853698454, -3.6233380046070303],
            [-5.262381589116484, -3.6728048862942138],
            [-5.270052286213107, -3.776046320012268],
            [-5.275785535690646, -3.852467294450726],
            [-5.277509236540184, -3.8705865511304998],
            [-5.279822061195952, -3.9040212942805375],
            [-5.2871478446966735, -3.998999243959871],
            [-5.291975124539865, -4.061573718455434],
            [-5.297789923963394, -4.1394716244836856],
            [-5.298465073021847, -4.144879541839831],
            [-5.303477909700239, -4.211850567607836],
            [-5.304196879580819, -4.221978601328367],
            [-5.429516936225948, -4.212122769818846],
            [-5.529467795232845, -4.204355142568783],
            [-5.637536097216773, -4.1959719675152085],
            [-5.6545621745791035, -4.194583575295613],
            [-5.872986379837336, -4.177359324333549],
            [-5.865595603916932, -4.090122737369504],
            [-5.854648855570067, -3.9587510999482114],
            [-5.846707489249521, -3.875199633171619]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.34699565142014,
          "lat": 34.57423633173229
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35009"],
        "coty_name": ["Curry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Curry County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00933053"
      },
      "bbox": [
        -5.872986379837336, -4.221978601328367, -5.254439233341931,
        -3.553749927095874
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.854192299309982, 3.919970666160149],
              [16.85504623408854, 3.9194918601961612],
              [16.852075078913945, 3.9054889146214684],
              [16.8506698694551, 3.905659030488094],
              [16.854192299309982, 3.919970666160149]
            ]
          ],
          [
            [
              [16.841637561476716, 4.01768220366323],
              [16.850663097860256, 4.049998935219695],
              [16.852611213214338, 4.075477485943749],
              [16.85929473750707, 4.1091981014845365],
              [16.874394371672803, 4.1059122859393895],
              [16.876304717081286, 4.110184564163126],
              [16.88004528969545, 4.10808151359062],
              [16.880906274212304, 4.104759021943436],
              [16.87805484273929, 4.0932768669888535],
              [16.875276956209156, 4.0865825865920495],
              [16.871922091932625, 4.07422741929471],
              [16.870909118396906, 4.061266004681848],
              [16.87491039187095, 4.0480676591948095],
              [16.877269720891373, 4.037626296663903],
              [16.88255106628406, 4.032353269600896],
              [16.885670178399362, 4.0329517120118],
              [16.888692325724627, 4.03048911001282],
              [16.894857742651194, 4.028577323097729],
              [16.897698985160275, 4.023625167918746],
              [16.894177697900634, 4.016111201148451],
              [16.886741637465832, 4.006115922579654],
              [16.882996635189826, 4.007166835717352],
              [16.881324647706553, 4.00366388638265],
              [16.884096313504738, 3.999560960876048],
              [16.88054713520128, 3.9950364225514554],
              [16.871469329054328, 3.967965626284576],
              [16.872057889312874, 3.9619013359750754],
              [16.875737470746486, 3.949404648931707],
              [16.873034085212492, 3.94113804743448],
              [16.873153268820925, 3.931691774557471],
              [16.870871765802995, 3.9332698679536757],
              [16.865802331901378, 3.92793696807103],
              [16.857178358119413, 3.9260835881216383],
              [16.85447281942334, 3.921110844740856],
              [16.851594212601615, 3.925604572912507],
              [16.84373474482838, 3.91771447866552],
              [16.840809553133074, 3.9182738396689687],
              [16.837563290739816, 3.9225166324465275],
              [16.83678331395986, 3.9327225702900157],
              [16.83157027190263, 3.9348958022093887],
              [16.829565057711246, 3.9733535029158413],
              [16.841637561476716, 4.01768220366323]
            ]
          ],
          [
            [
              [16.8370657927038, 3.9014793365741407],
              [16.84039994055509, 3.9095662089912713],
              [16.846416329236753, 3.9081855492975026],
              [16.846097647356427, 3.9052924899071564],
              [16.838821986036923, 3.899437596858171],
              [16.8370657927038, 3.9014793365741407]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.96670468672357,
          "lat": 40.779399563793454
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36061"],
        "coty_name": ["New York"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["New York County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00974129"
      },
      "bbox": [
        16.829565057711246, 3.899437596858171, 16.897698985160275,
        4.110184564163126
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.529223792644302, 7.039440823923486],
            [16.569160004100308, 7.053953741718329],
            [16.573532601612982, 7.045049805044073],
            [16.585243476318265, 7.039098095303555],
            [16.589716105458585, 7.035788905350227],
            [16.59384779886077, 7.027337645188328],
            [16.59789161853208, 7.02340826927932],
            [16.596935478439434, 7.015206888130045],
            [16.59369933138028, 7.003159998060776],
            [16.591073917792837, 6.993391597557522],
            [16.592436704807394, 6.984793508564059],
            [16.59494078548293, 6.974891457579431],
            [16.591748309504766, 6.966309473908166],
            [16.587573297663596, 6.958764027876185],
            [16.585300160608057, 6.950159501257497],
            [16.584960839322505, 6.945686480682538],
            [16.580556823065915, 6.938375645244459],
            [16.579463049508547, 6.933251275472516],
            [16.581569696946286, 6.929990219163398],
            [16.581967536039876, 6.914435552923905],
            [16.580083064706137, 6.902462620741637],
            [16.58076761803837, 6.896718954527515],
            [16.57957241659738, 6.891743068252808],
            [16.57542900039547, 6.885328075966356],
            [16.576346278765474, 6.87716641946652],
            [16.58568810905929, 6.868020164985181],
            [16.586680263322243, 6.865448361323094],
            [16.584505890170202, 6.856481105550419],
            [16.588177619257053, 6.847787178303024],
            [16.585026985136583, 6.834212443344764],
            [16.58775569245817, 6.828159143945575],
            [16.594135662475413, 6.82712214808332],
            [16.59741726060036, 6.824053630047696],
            [16.606911773478046, 6.819614321571975],
            [16.612908672769596, 6.817861491649658],
            [16.616792318635316, 6.820695017926607],
            [16.617219040259183, 6.825691220350334],
            [16.620914837026735, 6.827431969326622],
            [16.621191943767187, 6.831276555746947],
            [16.61833462418196, 6.834765449193218],
            [16.61965231507192, 6.837955341026439],
            [16.615720683259227, 6.842334830144198],
            [16.618515724407974, 6.8447638471047725],
            [16.616229450422814, 6.848731764751945],
            [16.620341821479375, 6.850959900802734],
            [16.621968557207193, 6.858988997534412],
            [16.617844907421148, 6.864749978176316],
            [16.62058077900183, 6.872076200743007],
            [16.617926124682658, 6.875190259959729],
            [16.62710784697662, 6.879777664624228],
            [16.635397865679327, 6.879153821005882],
            [16.638363045185468, 6.883523440795761],
            [16.648539618728282, 6.885818369355685],
            [16.650799584304323, 6.888125046611558],
            [16.655295033191457, 6.888929498383815],
            [16.660938382305083, 6.88696663726033],
            [16.6630724568772, 6.891488900226955],
            [16.666852080162126, 6.8886523019677695],
            [16.671327859532834, 6.875819175844064],
            [16.673099086359223, 6.875448846232547],
            [16.678930415098772, 6.869183446001416],
            [16.68059808884964, 6.859330606413973],
            [16.6792628567249, 6.853634237902754],
            [16.68298509814788, 6.852256546519554],
            [16.68205453938489, 6.84703353688995],
            [16.68372950415458, 6.845676054739974],
            [16.68959289919088, 6.847868217120653],
            [16.69442316584913, 6.843872345041787],
            [16.702212308188347, 6.843429297114064],
            [16.71141640135401, 6.8384471116806855],
            [16.717569727623104, 6.831623781384871],
            [16.72105885140044, 6.829395266081179],
            [16.720637798569985, 6.825769546646813],
            [16.722497473851654, 6.819037122150619],
            [16.72535875282296, 6.818114392509677],
            [16.730194411185124, 6.81217084999777],
            [16.731612366226187, 6.806859906853383],
            [16.72902252212076, 6.802496564461824],
            [16.741096456938198, 6.748595087794954],
            [16.76185066950733, 6.651470038893507],
            [16.773948626256562, 6.596342179664074],
            [16.785721437317196, 6.542417792007646],
            [16.791148069455218, 6.513558521185435],
            [16.818157764203956, 6.382661412481758],
            [16.829552150200094, 6.323399764474288],
            [16.848339800768446, 6.233019813707802],
            [16.781921201673658, 6.217367283357057],
            [16.773389713591726, 6.214990290559287],
            [16.77309798061102, 6.218852894990872],
            [16.76619495121468, 6.217882834345818],
            [16.762898758844067, 6.221562197058874],
            [16.758555092887626, 6.221031790315499],
            [16.747615936217993, 6.222814827649615],
            [16.742151265645397, 6.218948110488788],
            [16.736921068832462, 6.221404683430096],
            [16.73251923110949, 6.220063712908624],
            [16.7283232450262, 6.214366087854243],
            [16.72278515709672, 6.210497953215433],
            [16.7234170696296, 6.203824110670927],
            [16.601097505550584, 6.17108196059214],
            [16.593364638874053, 6.169308200245977],
            [16.59487566057572, 6.172844486495758],
            [16.5953723642556, 6.179014798588088],
            [16.5939571317827, 6.187813617196522],
            [16.58952180806552, 6.1976419685124045],
            [16.59040190840239, 6.20032745084905],
            [16.601750532866976, 6.212488716191182],
            [16.60240802930981, 6.215225127528672],
            [16.600533948711302, 6.226028204631253],
            [16.600732620218714, 6.232843301086193],
            [16.60475541683203, 6.239965666902174],
            [16.605815246920553, 6.24737176774055],
            [16.605673478856374, 6.2564985110615385],
            [16.603128073366957, 6.2648556569779865],
            [16.60385330393448, 6.276017627824031],
            [16.60301493226239, 6.283090954410425],
            [16.605852780910162, 6.286711781518302],
            [16.606526522223614, 6.293117265155834],
            [16.60146886252892, 6.302217422332501],
            [16.60087669578271, 6.306514174097606],
            [16.60287833722571, 6.31459627894067],
            [16.602296855802162, 6.318127647452374],
            [16.59877630912124, 6.3241212516036285],
            [16.59989685725398, 6.334577205820354],
            [16.595611503594167, 6.343746191816343],
            [16.595022215702958, 6.348114923950051],
            [16.592820953078274, 6.351828152041596],
            [16.585810841794657, 6.35497227365148],
            [16.58408438264954, 6.359163715394464],
            [16.580982892749724, 6.361869676888469],
            [16.578457333264442, 6.369475973316635],
            [16.580610537723313, 6.378655504033273],
            [16.582747310655137, 6.384263496366228],
            [16.581808114782355, 6.387686876376151],
            [16.57182718629342, 6.39972916292434],
            [16.574562833564425, 6.406929273858712],
            [16.575234631655217, 6.412890589888188],
            [16.57260710423302, 6.41961206323888],
            [16.569421644699766, 6.422423533108173],
            [16.569041346823465, 6.4317309678418635],
            [16.57024430568917, 6.43883771799503],
            [16.566299073006167, 6.448159209253798],
            [16.561185192216563, 6.455705664727819],
            [16.555022450823436, 6.459096234219373],
            [16.549889515677574, 6.466894956656868],
            [16.54935121996938, 6.470352291803523],
            [16.55372483467572, 6.480699073259632],
            [16.552714378859747, 6.486840373791116],
            [16.550453028411166, 6.490410968136746],
            [16.544321134414098, 6.4944966479940565],
            [16.541049561714587, 6.4934273791393995],
            [16.538974158081324, 6.504153478573215],
            [16.540000774683005, 6.508867948170856],
            [16.540529075316986, 6.520259985312732],
            [16.541998358597745, 6.526216845651171],
            [16.53658656189163, 6.530455202752352],
            [16.53230826750641, 6.540987832950997],
            [16.491167460919335, 6.645842641088176],
            [16.470198208874894, 6.699876685204333],
            [16.465430844672245, 6.7072333380244435],
            [16.462241666588326, 6.7091160888736345],
            [16.464031612514383, 6.713078114162077],
            [16.462096195764133, 6.720138145077771],
            [16.462585498275942, 6.731199157558734],
            [16.465323275230343, 6.734713810735422],
            [16.469183185539467, 6.734765430791832],
            [16.467288419061784, 6.742521916255714],
            [16.466708908169732, 6.751063486473349],
            [16.46857021542429, 6.756384401550335],
            [16.469995435564993, 6.767921056498086],
            [16.463862995127766, 6.771744755037116],
            [16.468391177339537, 6.783108381968839],
            [16.472780360151475, 6.78367282660535],
            [16.4787803027819, 6.786998802141944],
            [16.479103844867737, 6.789162632407732],
            [16.483610796477606, 6.7930736722453435],
            [16.481193627507793, 6.798714558796462],
            [16.486007894467132, 6.803181331190973],
            [16.487767914467067, 6.81027984292151],
            [16.48974217806529, 6.812857364843],
            [16.489347113933366, 6.818498431782077],
            [16.494188472197525, 6.826929039940568],
            [16.494187541452266, 6.832249663668173],
            [16.496450178524967, 6.834681942853317],
            [16.500565741898875, 6.8500215513405545],
            [16.506233153384322, 6.858616779993369],
            [16.506713766575835, 6.862097247994365],
            [16.510318772282808, 6.864687159996063],
            [16.515448819292626, 6.8658216149296205],
            [16.51567207551598, 6.871146449932023],
            [16.520746500778976, 6.873688786309471],
            [16.520388656982167, 6.876720373961922],
            [16.525232361955034, 6.884944936554069],
            [16.52546790965655, 6.888256048552011],
            [16.522996147724974, 6.898466662361918],
            [16.52000714443597, 6.90041531315271],
            [16.522332759929714, 6.903688452871503],
            [16.52458249620929, 6.911260529907964],
            [16.523324924337963, 6.923653409055533],
            [16.52433202094707, 6.930840172190793],
            [16.526827194217194, 6.931926524579274],
            [16.526049646052538, 6.93615731769213],
            [16.52840946952715, 6.94002653610234],
            [16.52614065196799, 6.943936531267505],
            [16.527570499592176, 6.950483965730267],
            [16.525961055869587, 6.953260738676041],
            [16.529396612068055, 6.9590902846514275],
            [16.53013903709955, 6.966883792849271],
            [16.52811533211521, 6.968768211979275],
            [16.528781986941574, 6.974861517811588],
            [16.525247273711347, 6.982532914966689],
            [16.525261300829136, 6.985229027118427],
            [16.521889353140054, 6.991783532846531],
            [16.52539185832879, 6.995413825248882],
            [16.524907146629968, 6.998835065110098],
            [16.521952522149547, 7.001980518297926],
            [16.51358363188584, 7.002872978925132],
            [16.513157582499282, 7.008197719690295],
            [16.516559689402186, 7.013819120180995],
            [16.519134809591716, 7.014720828737728],
            [16.522737242483984, 7.021656906736247],
            [16.524979029258944, 7.028703364330574],
            [16.53083663967929, 7.037502846130929],
            [16.529223792644302, 7.039440823923486]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.430761533405, "lat": 43.31365775226576 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36115"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00974155"
      },
      "bbox": [
        16.462096195764133, 6.169308200245977, 16.848339800768446,
        7.053953741718329
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.304497347434246, -1.877840363891313],
            [11.308115445908706, -1.8783805159659708],
            [11.31460766243608, -1.8769549673098573],
            [11.317937475660251, -1.8747857355430653],
            [11.315001055588315, -1.8719206555688774],
            [11.31601854365879, -1.8671592682873557],
            [11.32396764172956, -1.868246274689861],
            [11.329758623797364, -1.871457860133543],
            [11.333784672670559, -1.8756951581849612],
            [11.338489972027423, -1.8733377778055122],
            [11.341300807945041, -1.8682243311242768],
            [11.348552932317265, -1.8659541842873226],
            [11.350329593726713, -1.8615002456368983],
            [11.354085086970729, -1.8587203218103685],
            [11.357718751148582, -1.8643749864331358],
            [11.360533845663172, -1.8660034974615454],
            [11.362900803633247, -1.8733108895123889],
            [11.365966448607747, -1.876823320577017],
            [11.371064822617381, -1.8889652484862933],
            [11.372348114423739, -1.8967858566358846],
            [11.370778368204906, -1.9070647401937761],
            [11.372856347039288, -1.911485258254147],
            [11.385159013368709, -1.9109898117364719],
            [11.387444154973682, -1.9138338274690843],
            [11.393865595823684, -1.9125038549484614],
            [11.394342000023208, -1.9103911606027726],
            [11.39192889536886, -1.9030341482247213],
            [11.393362317662957, -1.898713563702692],
            [11.396596176953707, -1.8975179607200137],
            [11.401879465882889, -1.8922738409594484],
            [11.402362912949794, -1.8968843835892615],
            [11.405401383331629, -1.9010874845970152],
            [11.412472816850235, -1.9077395144930258],
            [11.417890339004863, -1.9086621328004834],
            [11.430423991163636, -1.916858463585082],
            [11.430834524117726, -1.9191055136537474],
            [11.427446527427934, -1.9232605157005278],
            [11.428248984286322, -1.9311291704095075],
            [11.438071607001207, -1.9337576626056976],
            [11.442058071988166, -1.9395861057614563],
            [11.447194535170826, -1.942444849694408],
            [11.44819372088488, -1.9375390970816182],
            [11.445484489613014, -1.9332965819530739],
            [11.443253512550116, -1.9265145128108327],
            [11.446023372384861, -1.9224171434839283],
            [11.45557425892711, -1.9252134086142412],
            [11.45561221443535, -1.9207878876825346],
            [11.458446578182642, -1.915928209820506],
            [11.462919938943012, -1.915934448827306],
            [11.473087353034975, -1.9101988840619437],
            [11.476699608601377, -1.9100771679688788],
            [11.48033051193542, -1.912148415780571],
            [11.485633167727862, -1.9096507317559008],
            [11.489133443466113, -1.9134503014807187],
            [11.491862056109063, -1.9223242056631373],
            [11.48998295965254, -1.9248172222986193],
            [11.485615654653134, -1.9195347038297772],
            [11.483038828649324, -1.9224638708796629],
            [11.490973906523807, -1.9334261724853141],
            [11.494779999139688, -1.933966596185105],
            [11.497719832069262, -1.9508535358057524],
            [11.496727411162508, -1.9581803329228153],
            [11.503395956540782, -1.9629605951728004],
            [11.502603938472058, -1.9659542096777607],
            [11.498501779565535, -1.9651799855750438],
            [11.495611613281879, -1.9728808722277138],
            [11.500356190278332, -1.974918152555558],
            [11.50112285940296, -1.9773198280254158],
            [11.50777503493672, -1.981240865357719],
            [11.50858249776707, -1.9855244057312385],
            [11.515319357525465, -1.9880736679079385],
            [11.521291971359664, -1.9933093157157082],
            [11.521728359588964, -1.9891076851382037],
            [11.52392376690573, -1.9870979477044846],
            [11.528447221194462, -1.9904219883340488],
            [11.531967303754904, -1.9868416268152114],
            [11.539898102592332, -1.9871137745091985],
            [11.53483765007154, -1.9916452582702195],
            [11.537375936343645, -1.9952680887471768],
            [11.534111638171536, -1.9993554932503275],
            [11.537566981543543, -2.00514668013323],
            [11.541705460566844, -2.0076610660259515],
            [11.546021349490225, -2.012468374802495],
            [11.543329754877984, -2.017217164026754],
            [11.545539030946175, -2.0240114387219945],
            [11.542325025586841, -2.0272016140756484],
            [11.546095838401627, -2.0318778681865264],
            [11.54927470633169, -2.0439772408746277],
            [11.549529209667542, -2.0556094827735483],
            [11.554462222325656, -2.0617499143104476],
            [11.55444596776329, -2.069605299819047],
            [11.557268317364302, -2.0757015726929877],
            [11.549655198583602, -2.077966312437345],
            [11.552926402705259, -2.081780846543063],
            [11.556150740579314, -2.088977079012966],
            [11.557079546217995, -2.093563235507748],
            [11.565511264243387, -2.09417051792357],
            [11.565564806358056, -2.096462231228172],
            [11.560932994702583, -2.105577919500534],
            [11.555515276814788, -2.1083950650493257],
            [11.556907613234312, -2.1150872301958343],
            [11.553067034003762, -2.1157666851305192],
            [11.549313766269682, -2.1186846652943783],
            [11.547323465137191, -2.1251101596962716],
            [11.543157118202812, -2.1322782445056827],
            [11.54466164385783, -2.136376280798428],
            [11.552201496944878, -2.140644802604281],
            [11.551238015626833, -2.1462602108138578],
            [11.548613894178793, -2.148506805166236],
            [11.544921274952694, -2.1589450200392064],
            [11.54591108037292, -2.160429733939948],
            [11.541175157122245, -2.1658113013981204],
            [11.535329127359553, -2.1702276729756],
            [11.532096106305572, -2.184310960481445],
            [11.530414630494286, -2.1892059643457724],
            [11.527444227870387, -2.1883071538226306],
            [11.52004603848686, -2.196424741900483],
            [11.518932210197281, -2.199482559565573],
            [11.509078634184917, -2.2071418853710147],
            [11.508143198657445, -2.209287857466138],
            [11.502743978282732, -2.2117086216399855],
            [11.498541001354257, -2.216071120864946],
            [11.494770082933767, -2.217500893179016],
            [11.493564761660608, -2.221390651035971],
            [11.48818657700177, -2.2246548894732174],
            [11.485181319711286, -2.2322575586258506],
            [11.477687947676298, -2.232302040710547],
            [11.473464720508987, -2.229061368179563],
            [11.46994848908791, -2.2292738311646754],
            [11.468067082661264, -2.219390475811],
            [11.464691599599782, -2.2164144392020027],
            [11.459455166714383, -2.209310775831988],
            [11.453590495812435, -2.2056747596202673],
            [11.448475631528705, -2.2059869526247597],
            [11.441166140512825, -2.204166504313076],
            [11.435728737354692, -2.204522582014595],
            [11.427873786574619, -2.1989917133872026],
            [11.423118815612098, -2.1925641671006963],
            [11.415939763907966, -2.1912963028398864],
            [11.414129032410218, -2.1826062394354677],
            [11.41095480268485, -2.175456216894378],
            [11.411097712911735, -2.1728811435934663],
            [11.405217070061918, -2.1660499755923186],
            [11.404854703750498, -2.161061798341313],
            [11.40176108749363, -2.1558682997247005],
            [11.40307462529149, -2.1499510214254154],
            [11.406598524119628, -2.145010064327871],
            [11.40579681123212, -2.1394525105637845],
            [11.400152485808972, -2.1376989076281094],
            [11.395950980723551, -2.130724234279309],
            [11.387708244376887, -2.1266206733724204],
            [11.384062812142465, -2.1226780213240155],
            [11.381334467048143, -2.122539000706258],
            [11.375305409610721, -2.127373662950825],
            [11.36779076264325, -2.122271564580738],
            [11.357438559752325, -2.1293366307049757],
            [11.352365212572847, -2.1310462537362516],
            [11.347503851292998, -2.131089738050437],
            [11.34300929951408, -2.130043985830276],
            [11.343528649009212, -2.1229136779055238],
            [11.339780930988306, -2.1208444050318573],
            [11.335113053904003, -2.107240211390375],
            [11.336355272105632, -2.10309612572281],
            [11.335105400594376, -2.1001977917961105],
            [11.334520812394837, -2.091122007712559],
            [11.328470741507658, -2.090316667819769],
            [11.327391169610591, -2.086073262018462],
            [11.328246733773645, -2.081673988324783],
            [11.32112548764441, -2.075964334769925],
            [11.314386316631207, -2.0736553458016327],
            [11.310539812762928, -2.068574039913591],
            [11.311043450249059, -2.065611157246837],
            [11.304361219211838, -2.057128958686511],
            [11.299723585995288, -2.0547170936903116],
            [11.297713380567515, -2.0559875465448334],
            [11.291699337141983, -2.055717603657152],
            [11.28160858060032, -2.047766952168859],
            [11.275457731327219, -2.0488888399527667],
            [11.272819696969709, -2.0511195704816503],
            [11.26567583628817, -2.0489929990037994],
            [11.268452125562995, -2.0414263931018293],
            [11.26760079434314, -2.037411590463722],
            [11.261189978806653, -2.0344106796636288],
            [11.259975916322821, -2.029410467630552],
            [11.262078550267693, -2.0281888585024936],
            [11.2655030582182, -2.0217489903198],
            [11.266182920064788, -2.016315862381243],
            [11.272034390606912, -2.0094314571942182],
            [11.266720613104937, -2.00446661235558],
            [11.257593142203179, -2.0025695295530372],
            [11.257380001645485, -1.9979670819575683],
            [11.253081018755935, -1.9941656459754487],
            [11.247692918123718, -1.982894710284878],
            [11.251160083887374, -1.9774172943999342],
            [11.262670576615248, -1.9642521494804204],
            [11.263194836722608, -1.9601450991910108],
            [11.269296787422133, -1.9569432350060114],
            [11.276022782417382, -1.9494581999325682],
            [11.278930633780408, -1.947715713851317],
            [11.304497347434246, -1.877840363891313]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.30759959868227, "lat": 35.89893251546113 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37199"],
        "coty_name": ["Yancey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yancey County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "01008598"
      },
      "bbox": [
        11.247692918123718, -2.232302040710547, 11.565564806358056,
        -1.8587203218103685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.102754061112613, 7.8317398840300365],
            [-5.035138445604757, 7.826299123831747],
            [-4.934386009009495, 7.817748486977473],
            [-4.847841554723062, 7.810752646026221],
            [-4.721932443983058, 7.800777334567615],
            [-4.664662855409462, 7.796242881602913],
            [-4.567445534062407, 7.78866012733191],
            [-4.501987707015059, 7.783779594209361],
            [-4.415305725229279, 7.7773523302796495],
            [-4.37752628206303, 7.775333881681328],
            [-4.383091444139896, 7.701479123527795],
            [-4.389499765697552, 7.615877283638182],
            [-4.390427246853287, 7.601949046636455],
            [-4.401227383273899, 7.45909277669072],
            [-4.402154223408948, 7.444291684756747],
            [-4.438615591989238, 7.447134514793574],
            [-4.517399155360332, 7.4529589595134755],
            [-4.6027013284802925, 7.459243023274717],
            [-4.661732076962905, 7.463763956176019],
            [-4.666140943350875, 7.46375111888466],
            [-4.690999468171985, 7.4661361972121325],
            [-4.79330543372866, 7.474009216945373],
            [-4.806044624937852, 7.475168089525384],
            [-4.864133106098174, 7.479743266263336],
            [-4.921043968381471, 7.484350011955672],
            [-5.0260338133898745, 7.493058710847798],
            [-5.131026307445941, 7.501735889876537],
            [-5.127347619893428, 7.555964166628073],
            [-5.116164584418011, 7.677920801819705],
            [-5.115714310795587, 7.678931337546151],
            [-5.108952698862603, 7.758662204911881],
            [-5.102754061112613, 7.8317398840300365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.52064088620634,
          "lat": 46.112596296133596
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38011"],
        "coty_name": ["Bowman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bowman County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01035619"
      },
      "bbox": [
        -5.131026307445941, 7.444291684756747, -4.37752628206303,
        7.8317398840300365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.35182004313566, 8.465890052708765],
            [-4.228315034831715, 8.45710112823655],
            [-4.185730821896428, 8.454216199351036],
            [-4.1290011353756375, 8.450613271182872],
            [-4.068343309226835, 8.446304733304299],
            [-4.0661545902460885, 8.44630281722998],
            [-4.004958562683662, 8.442076141706929],
            [-4.003049182647883, 8.47051900849918],
            [-3.9326723198306204, 8.465945783101445],
            [-3.900537225869036, 8.463665397190107],
            [-3.8082447080364115, 8.457651040141839],
            [-3.7428292482037775, 8.453403558675006],
            [-3.744759820967107, 8.425029907550195],
            [-3.7112708565259114, 8.422798948927884],
            [-3.712205424561722, 8.422081766460328],
            [-3.717360032213906, 8.340358149167207],
            [-3.721286633045893, 8.277551386483568],
            [-3.721273906307591, 8.275499319427364],
            [-3.7283245873380455, 8.163618890061162],
            [-3.730176988312607, 8.134027867668902],
            [-3.7342117232044, 8.078243923341313],
            [-3.7913535849588995, 8.081899860408585],
            [-3.8844687269310967, 8.087360406050882],
            [-3.9444059755706213, 8.09094882930924],
            [-4.0373366848499055, 8.09712173797121],
            [-4.119066941424464, 8.102806435726684],
            [-4.21896959791747, 8.109931420370463],
            [-4.268752585224349, 8.113603110857218],
            [-4.305320937654855, 8.116050305489182],
            [-4.375921815153234, 8.121010599483226],
            [-4.441744427657703, 8.12578724675159],
            [-4.475149617959101, 8.128423298372327],
            [-4.514368226894873, 8.131240751523045],
            [-4.499805673235453, 8.316523203046403],
            [-4.493842091564668, 8.394200652217243],
            [-4.487418303652051, 8.475692580678317],
            [-4.419618669729147, 8.470798410166948],
            [-4.35182004313566, 8.465890052708765]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.65506949591918,
          "lat": 46.81067075255252
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38089"],
        "coty_name": ["Stark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stark County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01035618"
      },
      "bbox": [
        -4.514368226894873, 8.078243923341313, -3.7112708565259114,
        8.475692580678317
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.529055960670417, 3.9119705428054607],
            [11.521431357579294, 3.960303009845099],
            [11.50772236000698, 4.049188378070294],
            [11.513073342384141, 4.050931281374596],
            [11.527029817956398, 4.056982992056011],
            [11.539301610862335, 4.060999061567036],
            [11.542909344815435, 4.0638222307731215],
            [11.552220087672419, 4.065231431729064],
            [11.560051461239013, 4.069381215857665],
            [11.571401348125352, 4.072675287307805],
            [11.579466828980795, 4.076384561208545],
            [11.588249897792569, 4.083194216419084],
            [11.593182867786686, 4.085987082886436],
            [11.60019125185698, 4.091637321406421],
            [11.605858795019461, 4.0940888863984215],
            [11.61273126086993, 4.0986543714652965],
            [11.61744567376786, 4.10368849629336],
            [11.630397622055725, 4.10979422948721],
            [11.63694111969994, 4.1148509697428945],
            [11.641215020417677, 4.1199179334065175],
            [11.645803631940224, 4.128815311472681],
            [11.653625637291825, 4.130671512014526],
            [11.658598305529951, 4.132865434224786],
            [11.66031419511119, 4.1284850301135805],
            [11.66609444725603, 4.130651855499303],
            [11.682958672034005, 4.14190240039733],
            [11.695043869326872, 4.1451958733844165],
            [11.708962786962108, 4.1514710490239235],
            [11.71548499278643, 4.156697608190057],
            [11.717758381803097, 4.156789991508784],
            [11.728087720726611, 4.163803041387892],
            [11.732215532925578, 4.1652204966019735],
            [11.738569374113379, 4.169243642726228],
            [11.747765423033599, 4.176771227062139],
            [11.752883000560015, 4.17915081638277],
            [11.76430166078154, 4.182580134227758],
            [11.776647291365654, 4.189799121484315],
            [11.788413430989419, 4.197519466974921],
            [11.797876809744766, 4.201976491012563],
            [11.812626151472019, 4.212522411728137],
            [11.817486010867025, 4.217357914070474],
            [11.82938054803078, 4.222920736691053],
            [11.83985974464064, 4.229066116558844],
            [11.860785011901875, 4.1025898494564075],
            [11.87461647776476, 4.018883825317226],
            [11.878704514123596, 3.9932986133054493],
            [11.890111715684625, 3.924282420893916],
            [11.911443691503921, 3.7948514575923324],
            [11.918057579276029, 3.7552178615919467],
            [11.845380775062122, 3.7423952434594394],
            [11.775754168442, 3.732374238492348],
            [11.718521443547942, 3.7239279712220945],
            [11.649892546543377, 3.7135089691578234],
            [11.562702148593289, 3.7000481535600405],
            [11.551794666673175, 3.7698219631549312],
            [11.54070416645266, 3.8396283914127176],
            [11.529055960670417, 3.9119705428054607]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.74818365718863, "lat": 41.70720664983436 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39007"],
        "coty_name": ["Ashtabula"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ashtabula County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01074017"
      },
      "bbox": [
        11.50772236000698, 3.7000481535600405, 11.918057579276029,
        4.229066116558844
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.620887341491404, 1.4560837630195906],
            [9.62853525670329, 1.4561410165939144],
            [9.662568519588605, 1.4581318354916906],
            [9.711486194570083, 1.45981425190142],
            [9.73176097656928, 1.461141598718395],
            [9.772932182228416, 1.4629902438479767],
            [9.78257301689907, 1.4631107094403475],
            [9.805742246798285, 1.4644966226758052],
            [9.855754662477834, 1.4668478599767822],
            [9.890874460165607, 1.4688549073758224],
            [9.927633518571863, 1.4704502127918389],
            [9.930077042577533, 1.429909208392242],
            [9.930236005589018, 1.4243016301834737],
            [9.936008925670945, 1.3393535288580698],
            [9.938372641339889, 1.3030921415711276],
            [9.907262229388586, 1.272086562330402],
            [9.86379564698924, 1.2274515853326273],
            [9.846328275813736, 1.2090980754670277],
            [9.806126505503851, 1.1679559884694335],
            [9.805165454176171, 1.1597510014056263],
            [9.802052973142123, 1.1538929297489806],
            [9.800706941186169, 1.1449055491776223],
            [9.795988543233722, 1.1404282037303977],
            [9.797587986950932, 1.1349769906470104],
            [9.793879354381826, 1.1332375860147004],
            [9.79318309875797, 1.1274026952639995],
            [9.785367019726824, 1.1245246090976402],
            [9.772377360351356, 1.1233192628630362],
            [9.77060418504167, 1.145898536711828],
            [9.746600665920422, 1.1444603953585644],
            [9.651203061963836, 1.139161765027935],
            [9.637732906993186, 1.1384858400917088],
            [9.636039741289245, 1.1721434350814117],
            [9.633112228562961, 1.2356301131164624],
            [9.63020856408989, 1.288467387126674],
            [9.628568725823024, 1.32083706630792],
            [9.620887341491404, 1.4560837630195906]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.80838556272045, "lat": 39.41494869158466 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39027"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01074026"
      },
      "bbox": [
        9.620887341491404, 1.1233192628630362, 9.938372641339889,
        1.4704502127918389
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.562702148593289, 3.7000481535600405],
            [11.649892546543377, 3.7135089691578234],
            [11.718521443547942, 3.7239279712220945],
            [11.775754168442, 3.732374238492348],
            [11.845380775062122, 3.7423952434594394],
            [11.918057579276029, 3.7552178615919467],
            [11.919740512953155, 3.745069186289046],
            [11.928667984162825, 3.6918470987025604],
            [11.943889808390812, 3.5977964616778855],
            [11.950053630775733, 3.562889392533264],
            [11.955987402947697, 3.525925056358338],
            [11.959389051425998, 3.5066560439783636],
            [11.971751344515628, 3.4294983034980846],
            [11.977946062565136, 3.391775014075635],
            [11.90639975790554, 3.380192126048272],
            [11.845212268191426, 3.3707767996673437],
            [11.728486935061968, 3.352508001334549],
            [11.648087031574708, 3.339428716881325],
            [11.62149354085039, 3.335215450550093],
            [11.610305508252043, 3.403248090412519],
            [11.599252385026842, 3.4719493954235774],
            [11.592996453758989, 3.5097261446933135],
            [11.586983035083497, 3.5474435105781064],
            [11.574683821267156, 3.6245395347385547],
            [11.569312922104979, 3.657646093252356],
            [11.562702148593289, 3.7000481535600405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.76124239234117, "lat": 41.31702262542249 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39155"],
        "coty_name": ["Trumbull"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trumbull County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "01074089"
      },
      "bbox": [
        11.562702148593289, 3.335215450550093, 11.977946062565136,
        3.7552178615919467
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.248437526666808, -2.867784078180365],
            [-2.235086669447422, -2.868311180054127],
            [-2.1209435399727194, -2.872048950814284],
            [-2.0780315811383656, -2.873415511542532],
            [-1.9556533647218615, -2.877498240128002],
            [-1.8524363212874968, -2.880535346174106],
            [-1.8217580366300588, -2.88120772131259],
            [-1.810839212730188, -2.881780456956743],
            [-1.724292752581656, -2.8846667589883723],
            [-1.7129412382086393, -2.884656088369956],
            [-1.651001102808676, -2.8864330520546404],
            [-1.653065816504792, -2.954522833926743],
            [-1.6536465288148052, -2.9818413727857482],
            [-1.6551548372407112, -3.030498821758246],
            [-1.6584683957612123, -3.1492143297637427],
            [-1.6512444801776427, -3.1494077557097704],
            [-1.6537494160486044, -3.237313876529752],
            [-1.6626234408451441, -3.2367997014530063],
            [-1.7390374241122422, -3.234688843198165],
            [-1.824554571276001, -3.2315560621793837],
            [-1.938066452508607, -3.2279917967406373],
            [-2.080394810058285, -3.223351790573922],
            [-2.1519811430893037, -3.220773751982074],
            [-2.2515078969855415, -3.21739711263464],
            [-2.249894681008745, -3.1736414610146726],
            [-2.2483522710973602, -3.130422474074103],
            [-2.2587654016683416, -3.1300324125860906],
            [-2.256072263321023, -3.056824708038289],
            [-2.251622141299313, -2.940370808889463],
            [-2.248437526666808, -2.867784078180365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.001546249016, "lat": 35.638843622891265 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40039"],
        "coty_name": ["Custer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Custer County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01101807"
      },
      "bbox": [
        -2.2587654016683416, -3.237313876529752, -1.651001102808676,
        -2.867784078180365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6515770942804552, -2.8712198245533664],
            [0.6797464347722999, -2.870932729088481],
            [0.7444916387236217, -2.8705721317748045],
            [0.7439587801312169, -2.8735242713135305],
            [0.7464447889517355, -2.8798780766322465],
            [0.7455768566129187, -2.885185886535947],
            [0.7472898355149303, -2.8881034668283725],
            [0.7536827043376998, -2.8944937141528717],
            [0.7532677154240786, -2.9058026818042486],
            [0.7517985925811108, -2.9120932809030435],
            [0.7550277073915767, -2.9225183765323743],
            [0.7532781576550736, -2.9367143200278107],
            [0.7544791954404229, -2.940126277905517],
            [0.7598922914512288, -2.9452967675156114],
            [0.7680196537280708, -2.9501063820879794],
            [0.7777892420344121, -2.9512571211046223],
            [0.7837493203477639, -2.949592728205955],
            [0.790550794859572, -2.960115619648478],
            [0.7932916731188665, -2.962309912648921],
            [0.7977151102849308, -2.962161738540867],
            [0.8036077576812227, -2.956092066973359],
            [0.8108108865061177, -2.9445788110760156],
            [0.8149439476352965, -2.9395581456735806],
            [0.8203931760299694, -2.9386843472793283],
            [0.822626412895281, -2.940258200692311],
            [0.8271657215388337, -2.9383864067374112],
            [0.8298066847255282, -2.9391306908191894],
            [0.8346662465888378, -2.9367147030733975],
            [0.8489745541932054, -2.935019362758349],
            [0.867563562371241, -2.927616659967765],
            [0.8836124080005353, -2.9227933548003753],
            [0.8948696157380208, -2.9222348620899066],
            [0.9032023282697028, -2.924502474245765],
            [0.9087355960332169, -2.9269467676218155],
            [0.9248303096684403, -2.928421662575135],
            [0.9296933094819683, -2.9271626176769203],
            [0.944997111321852, -2.9195089349099757],
            [0.9484044810821247, -2.916960701924423],
            [0.9533165766401422, -2.9158852631838363],
            [0.9598315665688212, -2.9123137122553064],
            [0.9669619124513024, -2.9110022387950303],
            [0.9748886266102677, -2.9066157777798867],
            [0.9776679420242551, -2.9038637606797066],
            [0.9841008116222086, -2.9090612539352305],
            [0.9887320927578145, -2.910291464024051],
            [0.9905280948432845, -2.9126244444417586],
            [0.9959392657753101, -2.912943765074012],
            [1.0538133948422828, -2.912531185233067],
            [1.1077916522373448, -2.9123959700074513],
            [1.1651216099896633, -2.912106314834804],
            [1.165877610435854, -2.9910793142466994],
            [1.1666934894370058, -3.087408681448004],
            [1.1665447663110367, -3.106103131943843],
            [1.1669867156923497, -3.124023842377389],
            [1.1674210923401465, -3.1750264907639707],
            [1.1634049570727183, -3.1750752959715514],
            [1.1636583096956814, -3.2010179485102896],
            [1.1675207676698767, -3.2057769949297863],
            [1.1699203684189385, -3.215096742167831],
            [1.1730716324885677, -3.2214415460568144],
            [1.183840780378641, -3.2340354435504777],
            [1.1931915175291126, -3.2414007740933126],
            [1.1962352674064036, -3.247415987515445],
            [1.1996892800114123, -3.2623924176125865],
            [1.2057991453232804, -3.268075430232216],
            [1.2087083400477336, -3.2683494821693277],
            [1.2180950025649977, -3.262214952177631],
            [1.2213952053360806, -3.261880284774645],
            [1.2307481272211478, -3.268033963700393],
            [1.224563161315051, -3.2713178661915028],
            [1.2155874924654315, -3.278255918937011],
            [1.2115316677696712, -3.284640469572285],
            [1.2067806158152088, -3.2943564851769853],
            [1.2059888599915203, -3.304336093646808],
            [1.2042432686610764, -3.316037019569916],
            [1.200676917396818, -3.323222628317078],
            [1.1978590006169532, -3.3242568015999354],
            [1.1894306849617275, -3.3301786496261316],
            [1.1870372464583128, -3.3334242637896567],
            [1.179049197439073, -3.3494015092456766],
            [1.174930084229362, -3.35502043494384],
            [1.1723418270313872, -3.3557916309751477],
            [1.166900131087773, -3.3493231418234677],
            [1.1593733707242766, -3.348182948617006],
            [1.1444857168655829, -3.356859919113287],
            [1.1412751134884056, -3.3605120061494205],
            [1.146162184367427, -3.365588165030195],
            [1.1529000924929704, -3.367209046612353],
            [1.1579329035992687, -3.372801777048096],
            [1.1556265119523492, -3.3798099931840766],
            [1.1505822470586242, -3.382630785400828],
            [1.1446074235779775, -3.377582806649797],
            [1.138262455182849, -3.3754934950133975],
            [1.1307644751115422, -3.378088732965903],
            [1.1252711927766825, -3.386873851362246],
            [1.1247463505444408, -3.391935010799482],
            [1.1269034329732899, -3.3956286039896697],
            [1.1330836986156465, -3.410020637611974],
            [1.1347554176424077, -3.4187886282688917],
            [1.1337430871050982, -3.4233825141673044],
            [1.1299690055959337, -3.4276538658875495],
            [1.1268688722809728, -3.427758159328124],
            [1.1206630257413162, -3.4241034372399035],
            [1.1156777216835678, -3.423786283528142],
            [1.1115731942262284, -3.425546975001836],
            [1.1086386739502443, -3.4300438185706765],
            [1.1066812709138105, -3.4398614703180095],
            [1.1034691728230246, -3.4455254063673006],
            [1.0928944998491665, -3.457794980979313],
            [1.0858725994415213, -3.4636873658495104],
            [1.0783116118062166, -3.4673901985408317],
            [1.0741083974341874, -3.467929092168103],
            [1.0651227885739631, -3.4640142027593255],
            [1.0609123146364425, -3.460796472757781],
            [1.0514660039761041, -3.4468258043976765],
            [1.0400818498392213, -3.4349718190253764],
            [1.0292724755154772, -3.4284056367053886],
            [1.020525146439781, -3.4271602361252773],
            [1.0165445609871417, -3.4278001692034032],
            [1.0005800825885223, -3.432639009617532],
            [0.993881731175526, -3.4370779591375187],
            [0.9931009123372915, -3.3240168441738915],
            [0.9924270112298433, -3.2372957597455527],
            [0.992055684175846, -3.17650343150651],
            [0.9272292430445659, -3.1769444319768514],
            [0.8202237174214612, -3.177546224308654],
            [0.6951994323806152, -3.1779857730754197],
            [0.6949506386050198, -3.163432936332668],
            [0.6949251659401084, -3.0915707301933066],
            [0.6947988686388982, -3.0897574689754133],
            [0.6945659875941884, -3.0025994615531144],
            [0.6517797730782893, -3.002773933526617],
            [0.6515770942804552, -2.8712198245533664]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.37945750309524, "lat": 35.61611364884642 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40101"],
        "coty_name": ["Muskogee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Muskogee County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01101838"
      },
      "bbox": [
        0.6515770942804552, -3.467929092168103, 1.2307481272211478,
        -2.8705721317748045
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.220483858941428, 8.053135741450005],
            [-17.199351148144935, 8.047301577194352],
            [-17.138590379011042, 8.030912214025062],
            [-17.11643059870364, 8.113647684535236],
            [-17.005120660878465, 8.084103449678395],
            [-16.983229671159467, 8.166958037447223],
            [-16.904110867130598, 8.14624372687377],
            [-16.824996344223262, 8.12551225116038],
            [-16.69378468123374, 8.092313176528894],
            [-16.67991680183484, 8.088681669030002],
            [-16.702578577679073, 8.00489294024152],
            [-16.70160725596304, 8.004640582365706],
            [-16.712128411415193, 7.965757913557608],
            [-16.69838082361237, 7.963144166325074],
            [-16.621486527987944, 7.9436620596305065],
            [-16.54459604124433, 7.924164041274941],
            [-16.51526990926684, 7.917100430853318],
            [-16.460285532304372, 7.903608705627935],
            [-16.47196869222654, 7.85622170048684],
            [-16.458252185677562, 7.852115965290801],
            [-16.437526298115486, 7.846682108339265],
            [-16.4303948272661, 7.845363624933048],
            [-16.38820317876987, 7.834732895686441],
            [-16.40870900536075, 7.754849832167186],
            [-16.32449688372914, 7.733755158280154],
            [-16.240289243517786, 7.712641718417828],
            [-16.26136598964814, 7.628951055855663],
            [-16.262643187231692, 7.62927382815514],
            [-16.32748920273291, 7.377331900836929],
            [-16.409603526611274, 7.398254892027261],
            [-16.475988681016556, 7.146658331516585],
            [-16.55954896859078, 7.168149653549964],
            [-16.678304958558197, 7.1982339922651315],
            [-16.797069324517707, 7.228283426610458],
            [-16.81054086136607, 7.233196002736574],
            [-16.78902588200316, 7.316711281241489],
            [-16.81677395989974, 7.324153890064181],
            [-16.87226809301628, 7.338445310766945],
            [-16.850565188681013, 7.4222865361144015],
            [-16.978814697394757, 7.4553946714464665],
            [-17.107074369089293, 7.488461089931685],
            [-17.0851319421418, 7.571214577395788],
            [-17.202281630235703, 7.604381960325045],
            [-17.249320065397665, 7.618443529480765],
            [-17.226938858719883, 7.701869393554931],
            [-17.2046285472114, 7.784873464268423],
            [-17.2833222922891, 7.8101279417804506],
            [-17.262388357321186, 7.887258061805229],
            [-17.266241242987785, 7.888323232556106],
            [-17.23745627664095, 7.992439328015476],
            [-17.220483858941428, 8.053135741450005]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.35659459101403,
          "lat": 44.142195682600466
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41013"],
        "coty_name": ["Crook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crook County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01155128"
      },
      "bbox": [
        -17.2833222922891, 7.146658331516585, -16.240289243517786,
        8.166958037447223
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.58010342719072, 7.352311572335831],
            [-17.45547150487718, 7.31923898764695],
            [-17.33084920805071, 7.286127958469092],
            [-17.331373727224385, 7.284149732217743],
            [-17.25952159189944, 7.265177871143234],
            [-17.17343452562263, 7.2426760536379335],
            [-17.087351980958157, 7.2201559597744716],
            [-17.001273980559944, 7.19761759605927],
            [-16.915200547028803, 7.175060969224175],
            [-16.916306973330183, 7.170756877953723],
            [-16.809956427074678, 7.1433444727131],
            [-16.695325256684146, 7.113680737783358],
            [-16.58070211910334, 7.083984727283796],
            [-16.584314737145057, 7.065949153379634],
            [-16.59039189577916, 7.04215977299876],
            [-16.644946601574755, 6.835381303708113],
            [-16.689010334824882, 6.666483737611117],
            [-16.714064355141982, 6.672825052722851],
            [-16.764328977715834, 6.4767963179157215],
            [-16.778974742136278, 6.419213051661178],
            [-16.78735438240057, 6.421432166667855],
            [-16.828280665831286, 6.263216817728114],
            [-16.830350171223554, 6.25620830881495],
            [-16.746247019312836, 6.234929280873149],
            [-16.662147592251028, 6.213634795359465],
            [-16.66150076462416, 6.215727028147038],
            [-16.54098594402551, 6.185538972658823],
            [-16.42047870642978, 6.155319234862081],
            [-16.441685564862592, 6.070740732383036],
            [-16.483584329742108, 5.900892081744548],
            [-16.548810066018394, 5.6414943522184515],
            [-16.5690644935598, 5.560943153285254],
            [-16.56611256871326, 5.560205053511516],
            [-16.60159666902098, 5.421436605259312],
            [-16.661785975091536, 5.437627228487091],
            [-16.762232059795892, 5.4633954447565465],
            [-16.862682995359172, 5.489143960516239],
            [-16.908385981089673, 5.502049951097944],
            [-16.950499479519586, 5.512509036108186],
            [-16.967579741596992, 5.51724179077904],
            [-16.96992398248974, 5.517383123241515],
            [-17.049443134764008, 5.536202357866974],
            [-17.058519470490573, 5.537740661654423],
            [-17.122087576064988, 5.553999657228429],
            [-17.193507793212262, 5.572038983905649],
            [-17.26250064029525, 5.588197104122395],
            [-17.292182178919486, 5.596305752366129],
            [-17.29277824810738, 5.5958838866022],
            [-17.40859041555332, 5.627215129470037],
            [-17.499262971175444, 5.650452409731392],
            [-17.545553136156137, 5.663234959345956],
            [-17.620496556750798, 5.683340436667757],
            [-17.687349717581696, 5.701082049897043],
            [-17.574458215802057, 6.121820931528268],
            [-17.560170437283393, 6.174658079167193],
            [-17.560493911495637, 6.178158511362003],
            [-17.495974934110485, 6.419982136226694],
            [-17.494254437023926, 6.42729874217859],
            [-17.505578287955597, 6.429892740939168],
            [-17.574318281800576, 6.448123786016231],
            [-17.573614557281022, 6.450690307315421],
            [-17.6687847945807, 6.476664203011046],
            [-17.745504763150468, 6.497336764726044],
            [-17.822228050455177, 6.517996290120049],
            [-17.798866693223278, 6.602056252443522],
            [-17.7993231164132, 6.602180132260049],
            [-17.776883971560885, 6.685244157397626],
            [-17.777410764210778, 6.685387119667499],
            [-17.730977379392247, 6.84870476982336],
            [-17.72516495930554, 6.869640116758615],
            [-17.65969877557032, 7.105354473545742],
            [-17.648514841832583, 7.1022303075105215],
            [-17.61784602667052, 7.214215307747911],
            [-17.58010342719072, 7.352311572335831]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.38736654634556,
          "lat": 42.79349467012862
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41037"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01135854"
      },
      "bbox": [
        -17.822228050455177, 5.421436605259312, -16.42047870642978,
        7.352311572335831
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.371116083103416, 9.802602981854275],
            [-18.343773324571334, 9.795272638074186],
            [-18.260085153188353, 9.770646483856359],
            [-18.205966981763627, 9.755207131845946],
            [-18.149768132705344, 9.737991589593033],
            [-18.158191612082828, 9.71195519644756],
            [-18.14430712007954, 9.707994954862235],
            [-18.130544490336053, 9.703394708518355],
            [-18.13458565829022, 9.689805564313273],
            [-18.093586669749453, 9.677232855168146],
            [-18.097719837094573, 9.663842846535541],
            [-18.121785083723942, 9.582310804288529],
            [-18.108342900087344, 9.578365713033364],
            [-18.112324578636745, 9.564658246518496],
            [-18.098195390787822, 9.560301420295096],
            [-18.102218625537652, 9.546964899171048],
            [-18.088499377725515, 9.542904172265608],
            [-18.092565654707855, 9.529338455609823],
            [-18.078634269909703, 9.525306184458426],
            [-18.082711445704167, 9.51177102977541],
            [-18.06883502355066, 9.507805756685284],
            [-18.07264056870254, 9.494027329578378],
            [-18.058873135896782, 9.489957667400944],
            [-18.06085035429365, 9.483105667881556],
            [-18.054541900647955, 9.48131127207788],
            [-18.054047848398024, 9.47465548349695],
            [-18.048978422146053, 9.472232161063053],
            [-18.052624912948932, 9.458469448407358],
            [-18.03933174395518, 9.454510370428409],
            [-18.043329228522953, 9.441008839166912],
            [-18.02947622661178, 9.437002751466412],
            [-18.04130677281957, 9.39615010233527],
            [-18.0533234983887, 9.355257304340345],
            [-18.05756234823407, 9.34163280440726],
            [-18.081455228146563, 9.259264779246202],
            [-18.123203103798698, 9.27088597595712],
            [-18.119394281504075, 9.284073151744575],
            [-18.120323994238447, 9.284972225943525],
            [-18.146935724447825, 9.292253341233096],
            [-18.154961005370854, 9.26498562805323],
            [-18.169354323092826, 9.269267462047688],
            [-18.196972117767068, 9.27732582035037],
            [-18.188900586861788, 9.304528893058302],
            [-18.23026153665159, 9.316694666787283],
            [-18.226299708490387, 9.330275749506805],
            [-18.24043258127239, 9.334679781508118],
            [-18.23639888640268, 9.348296479470726],
            [-18.249812117123565, 9.353065899094577],
            [-18.245484527394986, 9.36678678279709],
            [-18.259642497567608, 9.370854526551852],
            [-18.25560346067078, 9.38415759535012],
            [-18.26948615169789, 9.38792176232602],
            [-18.283080300748324, 9.392212415153676],
            [-18.290487251256998, 9.393771630507283],
            [-18.311327004991632, 9.399660210825107],
            [-18.307261457919743, 9.413471140074462],
            [-18.320709038084317, 9.417342957749526],
            [-18.31713601552822, 9.431241737760683],
            [-18.36676862612662, 9.445888581000293],
            [-18.452805897214873, 9.470813364385213],
            [-18.5388493143221, 9.495715530220002],
            [-18.553144206095617, 9.4997718771656],
            [-18.54873937414383, 9.512822770751736],
            [-18.534209288834678, 9.508688456408004],
            [-18.52868608365987, 9.522349125659652],
            [-18.519769083630173, 9.550037092182421],
            [-18.506369905181426, 9.545815608815143],
            [-18.502110836589583, 9.559028817678577],
            [-18.49894926761252, 9.57433981298453],
            [-18.484926048322425, 9.57053537745606],
            [-18.480929830498802, 9.583731873610496],
            [-18.467562737528606, 9.5800990225627],
            [-18.463398099472546, 9.593712194689052],
            [-18.43597814309023, 9.585529429480928],
            [-18.427770098170996, 9.612822406471581],
            [-18.400183205776816, 9.604677123803086],
            [-18.396273687252545, 9.618236564528212],
            [-18.382199957242204, 9.614169892425231],
            [-18.37829057782764, 9.627656431247534],
            [-18.405674311237124, 9.635851635404642],
            [-18.401604090224982, 9.649820178367603],
            [-18.414851237020798, 9.653994964586527],
            [-18.428608813670117, 9.657481017338233],
            [-18.424398991107, 9.670401131753643],
            [-18.453152896107124, 9.679243196976273],
            [-18.448862857032953, 9.692834118831126],
            [-18.46282207256383, 9.69697948601679],
            [-18.458644737281954, 9.710606151249547],
            [-18.472269384931202, 9.714611308893138],
            [-18.4684246253274, 9.72801137425609],
            [-18.482345762094827, 9.732067379365759],
            [-18.473667251942544, 9.759854347840928],
            [-18.390829810203776, 9.735552295463963],
            [-18.37733519115084, 9.781991160489223],
            [-18.371116083103416, 9.802602981854275]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.09837316940632,
          "lat": 45.56007045651428
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41067"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01155137"
      },
      "bbox": [
        -18.553144206095617, 9.259264779246202, -18.02947622661178,
        9.802602981854275
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.651157347741545, 3.2670742449481494],
            [13.640519111481025, 3.2750564286616033],
            [13.655672263807203, 3.278261216310408],
            [13.735826480519881, 3.2989236254292997],
            [13.755432555781711, 3.3038846852016017],
            [13.807564449734702, 3.316654907139497],
            [13.819598742838247, 3.3149544895529295],
            [13.812585575095726, 3.305360511349986],
            [13.805751390165069, 3.2971010808503474],
            [13.794585658075261, 3.28828933724153],
            [13.794950739950943, 3.283464482105407],
            [13.789339223888378, 3.2829364465765996],
            [13.78508902248704, 3.2812114575695874],
            [13.777086281222568, 3.2728335166866103],
            [13.76935578724399, 3.2625486398290042],
            [13.7656271020918, 3.26356286499009],
            [13.762511606339016, 3.259798398286401],
            [13.755887815714377, 3.2452244865566593],
            [13.75388422462402, 3.236301305232242],
            [13.761712135822036, 3.2284182674474557],
            [13.769214802921537, 3.219304644354615],
            [13.776452681795538, 3.2130911313056374],
            [13.779029078838963, 3.208214861587903],
            [13.779210571830443, 3.2043305999273954],
            [13.784306918973357, 3.2037515435765545],
            [13.785960055766111, 3.1995789738273746],
            [13.794790850355023, 3.1952209910276306],
            [13.798773031913282, 3.1971246052608855],
            [13.800424613871789, 3.1935371586981485],
            [13.80554327511928, 3.18827273758337],
            [13.802756380961554, 3.1817106990108694],
            [13.796674836619465, 3.1631705654021394],
            [13.800794615031261, 3.1613163379244895],
            [13.803226177560775, 3.1526132602635517],
            [13.794077604036872, 3.1249014724573394],
            [13.801304910272433, 3.1188872984449545],
            [13.805349376730923, 3.1119231613955103],
            [13.811881833970762, 3.1069538522535547],
            [13.813581621081672, 3.1040177016829094],
            [13.817345766454647, 3.1046736127342944],
            [13.821641838206306, 3.1025280522811634],
            [13.823092737929946, 3.107496819295792],
            [13.831162311458971, 3.1137488886596323],
            [13.831338184872525, 3.1192510874985855],
            [13.834277792520979, 3.122917639724598],
            [13.833377795642837, 3.1276650350288864],
            [13.835851559565986, 3.1313673287456885],
            [13.837134272005182, 3.144061700967723],
            [13.83925035249351, 3.1457133988092583],
            [13.842930095366347, 3.1439138669280107],
            [13.838266034491705, 3.125231184817192],
            [13.838665273887907, 3.120787520216668],
            [13.83563972595189, 3.106949921085602],
            [13.8357207330038, 3.0988202579122364],
            [13.83763176365028, 3.0837979248619445],
            [13.83781424718309, 3.0701390556521395],
            [13.83958135500988, 3.0618725753300637],
            [13.843070774514171, 3.061582170022297],
            [13.85090029434862, 3.07392237355892],
            [13.854044876141334, 3.07309234901673],
            [13.856056294853724, 3.0694990007957785],
            [13.858070814392466, 3.0586483019720627],
            [13.856644557569753, 3.0494068840523294],
            [13.846806776925547, 3.0097414462546044],
            [13.845419654153963, 3.0068234061494397],
            [13.836408909685074, 2.979324772781067],
            [13.831876062254747, 2.9694768404450183],
            [13.829693153876924, 2.9600444854587757],
            [13.821151819364133, 2.9338125914360185],
            [13.82036212521954, 2.9258572737752266],
            [13.818214274630686, 2.919455103129846],
            [13.813457722357468, 2.9114114057920273],
            [13.807607094049517, 2.897176794075718],
            [13.80095710648385, 2.8738138711310275],
            [13.798297633988707, 2.858536736840681],
            [13.797022461849474, 2.8549099966203055],
            [13.79434953343095, 2.8373189394595904],
            [13.791684873315534, 2.8253154755393366],
            [13.786004084917323, 2.809281797169897],
            [13.785355438053237, 2.7988982126688806],
            [13.770887148741354, 2.8023609666156015],
            [13.756380637487284, 2.8090379682858404],
            [13.71595277090355, 2.8210976590339465],
            [13.690311894176027, 2.8294997670711206],
            [13.665992252409579, 2.83823522507673],
            [13.665938435702158, 2.8310367506553327],
            [13.664730929029465, 2.8124617603691155],
            [13.666772863333868, 2.8010992939236186],
            [13.667720562001652, 2.7899752899910117],
            [13.666610225852839, 2.7789858473573728],
            [13.657000729504897, 2.784930711912557],
            [13.615697015431733, 2.813494104259641],
            [13.596835233277288, 2.815690394773382],
            [13.578593580549205, 2.8208115558911167],
            [13.524371363622773, 2.836706992904649],
            [13.525890167947848, 2.840738215282478],
            [13.528685386688775, 2.8549445437799252],
            [13.531757266040605, 2.865902408655048],
            [13.559084183826023, 2.887399404573432],
            [13.553461502641573, 2.953082073934671],
            [13.548628874768044, 2.9591336214646353],
            [13.5517583327106, 2.980505597047687],
            [13.554294518489831, 2.985173057527789],
            [13.555219761076765, 2.995190720617732],
            [13.551103318432329, 3.0016323773261293],
            [13.549870456008076, 3.006710273699068],
            [13.550465765555906, 3.0163497272915425],
            [13.54997866352053, 3.0257093631210727],
            [13.554600902086289, 3.0397344065944067],
            [13.559562441202472, 3.044870913440963],
            [13.561837767550202, 3.0509739804303755],
            [13.566062358808017, 3.054460840400422],
            [13.575220609022317, 3.064077701327334],
            [13.583381570121679, 3.067312375964903],
            [13.587423650761524, 3.074693275085011],
            [13.59980022594135, 3.111777709364722],
            [13.60145928870995, 3.121358962870944],
            [13.606194021891953, 3.129354168363768],
            [13.597421655935797, 3.155304807195416],
            [13.599964023499053, 3.1635863088290996],
            [13.598525051816589, 3.176659512371979],
            [13.603304409181316, 3.180573958464473],
            [13.609972131526565, 3.1815424012576425],
            [13.615087984738649, 3.1803096278892213],
            [13.621423777490392, 3.1804906804130955],
            [13.651157347741545, 3.2670742449481494]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.34830785964205,
          "lat": 40.481064247095766
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42013"],
        "coty_name": ["Blair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blair County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01213659"
      },
      "bbox": [
        13.524371363622773, 2.7789858473573728, 13.858070814392466,
        3.316654907139497
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.826247822932704, 3.39563241815415],
            [15.840178530548338, 3.423624711264945],
            [15.865952584896498, 3.47602888582671],
            [15.883497628391886, 3.49913989111812],
            [15.908272242072426, 3.532857990646981],
            [15.911387777987718, 3.53662689083931],
            [15.911793704428348, 3.536417383785029],
            [15.926219879684796, 3.555937576067405],
            [15.93536876469241, 3.5676169097046495],
            [15.95700676876169, 3.593057178459378],
            [15.970754925418184, 3.6051133133355187],
            [15.996278317523018, 3.6291629863611976],
            [16.000886567285875, 3.624097461422935],
            [16.004715860355017, 3.613568412724809],
            [16.00545490431065, 3.608778069379431],
            [16.003691102522716, 3.6033349906944463],
            [16.005384543445896, 3.5978489002367358],
            [16.012257754557055, 3.592310516684357],
            [16.021626383561326, 3.5898436450210904],
            [16.03096533117361, 3.5909915412174644],
            [16.03395693436682, 3.5928842992307675],
            [16.040372930456073, 3.602425129884274],
            [16.047611647993346, 3.6066966534806],
            [16.06246389464338, 3.607405973235367],
            [16.07612101386142, 3.6048808386342834],
            [16.08027054141702, 3.602288908065174],
            [16.096456708756076, 3.5892877293916414],
            [16.105063559664515, 3.5849448917093696],
            [16.10794465439464, 3.579717257776229],
            [16.111197888418328, 3.5697308957793927],
            [16.11210313938781, 3.563069075923306],
            [16.11637136796684, 3.547523071166359],
            [16.118443434240273, 3.5437063325198355],
            [16.12264328404724, 3.5263635507008346],
            [16.12263707221782, 3.521366087502903],
            [16.120833038793744, 3.517737468229409],
            [16.123190106867906, 3.509637025229445],
            [16.122206391084724, 3.5022964786898974],
            [16.1228111267398, 3.499086337902318],
            [16.12755511602877, 3.491902800187649],
            [16.133234520251197, 3.4789639536903225],
            [16.136618132450504, 3.4688241969783356],
            [16.139617466613572, 3.4645589067597875],
            [16.149864396905027, 3.4626245154813597],
            [16.160249614924254, 3.456791390067625],
            [16.16793482300402, 3.4558173257511386],
            [16.187284629923088, 3.467453351034556],
            [16.193178758459666, 3.4669639772963925],
            [16.196335414915115, 3.4647429845374305],
            [16.203571565617345, 3.4621557190465313],
            [16.210609397288458, 3.460922084577318],
            [16.21451312403888, 3.4577907758331388],
            [16.226200637783435, 3.440477889535325],
            [16.232517713930537, 3.4303753434536066],
            [16.236473029556517, 3.4221017173444435],
            [16.239060283386745, 3.4138466464051915],
            [16.24189406044639, 3.408610380270964],
            [16.245090726098955, 3.4055749083227003],
            [16.264989635663632, 3.393946839319804],
            [16.272918838681587, 3.390054879242284],
            [16.282092074804915, 3.3902631490498907],
            [16.290014905010135, 3.3870930048941985],
            [16.307307734842933, 3.375402022434341],
            [16.3153621379333, 3.366250519524321],
            [16.32411967056505, 3.3528650874562342],
            [16.336362264735264, 3.335803719864944],
            [16.341747732424704, 3.332580033936068],
            [16.35194425827557, 3.33003150687573],
            [16.355859694237058, 3.327818763662369],
            [16.375747593905853, 3.3229217028881015],
            [16.387916740426462, 3.317518928239647],
            [16.396308091447164, 3.3129953089680972],
            [16.400975475061234, 3.306270267740881],
            [16.409431779553202, 3.296987645807919],
            [16.41459205743799, 3.287621554188455],
            [16.418231938845782, 3.284935261323084],
            [16.42435773924162, 3.283949919953067],
            [16.430213212959178, 3.281767207547123],
            [16.433418372572813, 3.2792926356544365],
            [16.445023277199333, 3.267569008660873],
            [16.447455140187007, 3.2574949732358425],
            [16.446676565775213, 3.2533086002611262],
            [16.43716665879399, 3.239833325112766],
            [16.434558022071467, 3.2381322920192135],
            [16.427978991139497, 3.2372729939728697],
            [16.42395229174719, 3.2353290657852116],
            [16.41720943791496, 3.228746274354373],
            [16.409747899336317, 3.2184433841080873],
            [16.40495973369376, 3.2169449817802023],
            [16.395628767733996, 3.217310626326675],
            [16.383063749749365, 3.2195590797370808],
            [16.378526532223823, 3.217606910210518],
            [16.3764151882818, 3.2142596156665597],
            [16.37402811991794, 3.201226560009949],
            [16.374342697609666, 3.192969499745572],
            [16.372867263064986, 3.1895368779714106],
            [16.36229475546349, 3.1792556457585754],
            [16.360310691652217, 3.1701716941503677],
            [16.355840576393685, 3.1660851278587656],
            [16.350281980526855, 3.163518651573011],
            [16.327187594014042, 3.1475162563824464],
            [16.31814670251958, 3.1467133562192364],
            [16.31006237529066, 3.142214399202687],
            [16.28824241889454, 3.120686040568076],
            [16.28419854081896, 3.1151006239360255],
            [16.274663717739898, 3.1208736249747466],
            [16.276571720128285, 3.125948331589013],
            [16.27494466833988, 3.131448095047273],
            [16.279809931072162, 3.1389508637547143],
            [16.279987824739234, 3.1428708963247685],
            [16.285272000120617, 3.145207406386341],
            [16.287599478538944, 3.151305324288289],
            [16.287073696171163, 3.16420003402285],
            [16.28214650232077, 3.165882200859975],
            [16.281247064868577, 3.1715068087635503],
            [16.277301581765684, 3.1750930733312552],
            [16.277233346400955, 3.1825143184906546],
            [16.275448603029435, 3.1856183426958804],
            [16.27157268687316, 3.1835383996391515],
            [16.26868498132643, 3.1856677888657225],
            [16.26363026526405, 3.1845245954215975],
            [16.260230004551033, 3.187673033651047],
            [16.255639498837287, 3.189120127182951],
            [16.248694781796782, 3.189365085488934],
            [16.233743573623418, 3.1965205956333245],
            [16.133962832778057, 3.244385691262047],
            [16.108658601033444, 3.2569456598210373],
            [16.078801064425086, 3.2721393071934135],
            [16.0604057767404, 3.2811454654144447],
            [16.023068687430076, 3.2987819272707055],
            [15.999816452488881, 3.3100093151370626],
            [15.97101189367839, 3.32436547110066],
            [15.879783672939233, 3.369465922688458],
            [15.876658589889134, 3.3716042411589946],
            [15.826247822932704, 3.39563241815415]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.1068766267586, "lat": 40.3369488803772 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42017"],
        "coty_name": ["Bucks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bucks County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01209173"
      },
      "bbox": [
        15.826247822932704, 3.1151006239360255, 16.447455140187007,
        3.6291629863611976
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.024512726779598, 2.3108346037806475],
            [14.041934765481022, 2.3408240317846527],
            [14.044527631748865, 2.353229285100457],
            [14.04988548257506, 2.364931592656379],
            [14.05319004411702, 2.374801834705388],
            [14.05804321919559, 2.3867146588675383],
            [14.05818834848508, 2.3887947470896935],
            [14.062668429407463, 2.3977630572680373],
            [14.068335340603292, 2.4062370611275727],
            [14.070747570025404, 2.411421430090963],
            [14.076887548798762, 2.427895684457198],
            [14.086692964671148, 2.465912376007253],
            [14.088889799648015, 2.4765913819090137],
            [14.091351443573608, 2.5056445976200785],
            [14.092482749933893, 2.508017721182039],
            [14.093434780013146, 2.518675639458074],
            [14.094939615088004, 2.527742574642657],
            [14.092519984613588, 2.5339975657597624],
            [14.093893416080503, 2.5389931175899996],
            [14.097664175539663, 2.5431124149484683],
            [14.102070686307522, 2.558336392966199],
            [14.100670618786754, 2.5705719920486034],
            [14.101872151186354, 2.575208265398142],
            [14.101670241286127, 2.582564362576469],
            [14.104655971875932, 2.589885469937839],
            [14.10496109480064, 2.595220039529202],
            [14.107155204105, 2.604186724963386],
            [14.104802554236166, 2.6117398235027136],
            [14.10785864770957, 2.6224430412100586],
            [14.112731891446389, 2.6320281908614405],
            [14.112589446024218, 2.63615960919369],
            [14.118958697708074, 2.6479757984249046],
            [14.122423773842375, 2.660826393472281],
            [14.127451583730483, 2.6717559135057023],
            [14.135190432264116, 2.680339576828759],
            [14.13831620398398, 2.684678733068451],
            [14.151782741844624, 2.740210316103013],
            [14.157797353670064, 2.757468999462612],
            [14.158598143175908, 2.764012611414443],
            [14.161814226205282, 2.779207879044794],
            [14.165685305107514, 2.7942827632801253],
            [14.179369149556447, 2.835242851945328],
            [14.19576297108946, 2.8725869036414826],
            [14.20328787760142, 2.887107045488951],
            [14.210015684110783, 2.8949736903095404],
            [14.212859068620016, 2.9004917528479726],
            [14.216407257384752, 2.903469729259752],
            [14.21900838597098, 2.906233736633067],
            [14.22721081997562, 2.918641051951579],
            [14.232492219353023, 2.928289224445267],
            [14.234542762861587, 2.9339516814666338],
            [14.241964644258228, 2.9258041011097644],
            [14.24234090649712, 2.9235654127127413],
            [14.249689216499913, 2.9169561676520708],
            [14.241229773286468, 2.9021391594366084],
            [14.246499891642117, 2.8974996350876823],
            [14.254406281435982, 2.904543823063238],
            [14.257306830415779, 2.9052579699875607],
            [14.261332419558714, 2.9023282628220746],
            [14.25880192333856, 2.8956991782556387],
            [14.263956486391974, 2.8874349890518523],
            [14.262461504677665, 2.8813837663544564],
            [14.263026888948144, 2.8742696229920357],
            [14.265478557278346, 2.870840337892232],
            [14.268500169915258, 2.872136932558617],
            [14.269891493330373, 2.867248913573706],
            [14.272163058538014, 2.867218276602629],
            [14.286886932872136, 2.885435803831458],
            [14.292054969693124, 2.8865876828238846],
            [14.297730760009893, 2.883023254277134],
            [14.296754848229948, 2.8794660540242143],
            [14.300422003366087, 2.860252625666088],
            [14.294610074858761, 2.8519637549922865],
            [14.286996999110485, 2.840258047759162],
            [14.298388510218953, 2.825931767061351],
            [14.300876799654704, 2.824037076862759],
            [14.303146620840456, 2.815313423486104],
            [14.308256532316602, 2.807588104793496],
            [14.311511816702659, 2.8069025314832112],
            [14.319168808607344, 2.8003150670882566],
            [14.321473871058751, 2.799403682424873],
            [14.323004572205779, 2.792662040672522],
            [14.325221876260105, 2.791609240358136],
            [14.331586918547634, 2.7930219593858],
            [14.338085999688923, 2.7877463401335154],
            [14.343068022980267, 2.7868407537771755],
            [14.348502076444063, 2.781117512831766],
            [14.352007418780179, 2.770580610168611],
            [14.355338107087652, 2.76583033717763],
            [14.353658787049957, 2.759569795149148],
            [14.355196429756921, 2.756721171360696],
            [14.35974022649825, 2.759284328444915],
            [14.365164078876996, 2.7544397989582645],
            [14.369092973248769, 2.7546639955227854],
            [14.372475442613803, 2.7451464762737503],
            [14.373731465846388, 2.7352593266448375],
            [14.378858022211398, 2.73673102126769],
            [14.381415100868397, 2.7340459572254723],
            [14.38174356002923, 2.729628443991554],
            [14.38427882115751, 2.7264552390534655],
            [14.384843416892581, 2.7157969194629032],
            [14.390063702697956, 2.7136703726169724],
            [14.393072814960156, 2.7151888007779994],
            [14.395997030006624, 2.7115138498897946],
            [14.397155257303345, 2.707380559372236],
            [14.407057610998843, 2.6998443735372843],
            [14.406873700356124, 2.6956133038222996],
            [14.41582416555102, 2.685622793703721],
            [14.416828151704996, 2.6825347571907785],
            [14.420952733202029, 2.678104037009858],
            [14.42629275301318, 2.675239382107262],
            [14.433501580069054, 2.6685029154400772],
            [14.439180931158559, 2.6681256281106736],
            [14.442723620785609, 2.663592177445593],
            [14.447059729307842, 2.6619722396963827],
            [14.453372308424333, 2.6540120299240826],
            [14.458104100502227, 2.651817112225195],
            [14.451000445991761, 2.62127782001323],
            [14.457555485238732, 2.5938920727230133],
            [14.471308897981789, 2.5386389625225902],
            [14.481071323979972, 2.500183748688497],
            [14.491333410274283, 2.454718567157864],
            [14.500516176447823, 2.416602993753968],
            [14.503741401767966, 2.4014036088502153],
            [14.49625722005113, 2.3999274248985003],
            [14.417504202898744, 2.3847440500388624],
            [14.346210798427688, 2.371254362701285],
            [14.305414346467852, 2.3634380451801733],
            [14.192489334234475, 2.3429245105773986],
            [14.102023216825446, 2.3255933011399543],
            [14.024512726779598, 2.3108346037806475]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.72123599280664, "lat": 39.9274064925402 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42055"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01213670"
      },
      "bbox": [
        14.024512726779598, 2.3108346037806475, 14.503741401767966,
        2.9339516814666338
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.271985946203273, -3.314752410075794],
            [13.271720484118312, -3.3126868876943587],
            [13.300192673652319, -3.2865604933115216],
            [13.384026540305937, -3.211327924588184],
            [13.409691387282443, -3.188921041885756],
            [13.420178980693835, -3.178498458534012],
            [13.441513357192594, -3.158732766835785],
            [13.446760701544905, -3.1543087082975116],
            [13.451268839721266, -3.1537489438291115],
            [13.458801137576978, -3.1578794620376947],
            [13.463054928466976, -3.15773884603474],
            [13.47359950329931, -3.151551404853475],
            [13.475591200279993, -3.1477127247402157],
            [13.481109172361359, -3.1443497827502735],
            [13.485661936773111, -3.1440968514812506],
            [13.4882213696821, -3.1406748693375395],
            [13.496812854853646, -3.1366324871345426],
            [13.50241436041078, -3.1393074098864435],
            [13.508298579211944, -3.14374425125876],
            [13.512112045965887, -3.1482419097889762],
            [13.518733672554802, -3.147738334012802],
            [13.524832938034471, -3.143835071687445],
            [13.528442637089265, -3.145331062884509],
            [13.531896409065503, -3.1445345370421003],
            [13.535320344765157, -3.141015522467238],
            [13.542007652843823, -3.1377436351989973],
            [13.547496142073381, -3.133967886274572],
            [13.554014364252257, -3.1339576731234775],
            [13.558902131391225, -3.135236250836697],
            [13.562926041282436, -3.1380028820383155],
            [13.5692664757317, -3.1370087878631736],
            [13.570590977544155, -3.135264984642743],
            [13.576394730979017, -3.1337829266300035],
            [13.583709978837145, -3.127201174488471],
            [13.582183014265556, -3.1226083243101983],
            [13.584968914604026, -3.1178179037785596],
            [13.590579315500277, -3.113361902449038],
            [13.588942061347103, -3.109095310650266],
            [13.59203934026362, -3.1012422195881397],
            [13.596891243053404, -3.095996012023889],
            [13.60057566379105, -3.094526240858655],
            [13.600314353124501, -3.0891363082096968],
            [13.602511002402718, -3.086446420843277],
            [13.608257048919914, -3.0833623649048967],
            [13.61373853857794, -3.0857060555704776],
            [13.612189736086586, -3.089894937544125],
            [13.612862200063946, -3.0930715584401542],
            [13.61631875065485, -3.0971607052463885],
            [13.61643828066584, -3.1003136489578216],
            [13.61406879008104, -3.104535933638116],
            [13.614699387782114, -3.107671640846082],
            [13.62124423326924, -3.113938497539623],
            [13.631830188257489, -3.118077135627873],
            [13.638090665830898, -3.1283524815390003],
            [13.643119804230649, -3.1288367230438663],
            [13.645004602194444, -3.1222987484650093],
            [13.647655763486277, -3.121050456914848],
            [13.653509991020515, -3.1265022263363567],
            [13.656159186440757, -3.1261507942019353],
            [13.654743512609972, -3.1207387408567557],
            [13.657479646896501, -3.113079267307043],
            [13.66108890198083, -3.112106833368357],
            [13.668069596425019, -3.112791781666925],
            [13.66568083162772, -3.1007319402600784],
            [13.669201563355378, -3.0962684645261556],
            [13.669203999403113, -3.0900746375518535],
            [13.678146250186638, -3.0923563093690567],
            [13.680943007485617, -3.0974599073056397],
            [13.67935757705501, -3.1028039984524987],
            [13.689794441390214, -3.1070385318704474],
            [13.696980695982882, -3.105244990595977],
            [13.702031608887308, -3.1063661579542123],
            [13.708318140570942, -3.114274281189775],
            [13.70783397234173, -3.1186697955953355],
            [13.70266018681391, -3.12463284287791],
            [13.70173292005466, -3.128403887836526],
            [13.704697892135103, -3.1341497777408733],
            [13.702100586309827, -3.1378494210045034],
            [13.697985533265642, -3.136415390863752],
            [13.689704159845313, -3.1379743823315263],
            [13.687715393194729, -3.1416981947096185],
            [13.68866653369294, -3.1488558269024596],
            [13.692228278044919, -3.1550189246920537],
            [13.693798139565954, -3.160765378547459],
            [13.694008056119413, -3.1690657861676983],
            [13.698172156518366, -3.1711454052631907],
            [13.708059210218135, -3.1783188595853553],
            [13.71259042482468, -3.1834292751707793],
            [13.715965932677841, -3.18553183330864],
            [13.720648396992306, -3.182491560208457],
            [13.723294824877774, -3.184142651714124],
            [13.721908163785534, -3.1929710555388175],
            [13.726771266458565, -3.19748007161374],
            [13.727858059827541, -3.2011725448342663],
            [13.724489155973812, -3.2040239278564195],
            [13.725208663082677, -3.208963553044695],
            [13.72974846033309, -3.206227565627016],
            [13.730571087469105, -3.1981952903364044],
            [13.733139355672709, -3.1973980582314354],
            [13.738417873300206, -3.1996641908326313],
            [13.738981910243341, -3.193427999422727],
            [13.742093037910095, -3.1924568844915924],
            [13.744948286575603, -3.1958995703572146],
            [13.753474710854183, -3.1958776225525365],
            [13.754639765347166, -3.197046718470182],
            [13.75471862053924, -3.204228035149116],
            [13.750192479483799, -3.207422898821828],
            [13.752936957552045, -3.2108262633727387],
            [13.752759604312446, -3.215127421900028],
            [13.754992074490614, -3.2163793948292474],
            [13.762462633094596, -3.2169573201184716],
            [13.766729048639439, -3.2202376697234696],
            [13.76650465534192, -3.2275274599072095],
            [13.76058588573281, -3.2368927926982844],
            [13.757344129183638, -3.2347237706526877],
            [13.753525018347021, -3.2377418506517546],
            [13.754449189018228, -3.240619427189097],
            [13.759812169528868, -3.242126308356569],
            [13.763584126390205, -3.2476576440020057],
            [13.767311036436283, -3.2509598888388567],
            [13.771120711679206, -3.2584024254497646],
            [13.778760211225984, -3.2661505415241083],
            [13.785248891066315, -3.2687743453909612],
            [13.788032709635814, -3.2744902102825315],
            [13.787265269374641, -3.2817897936317104],
            [13.791631857181478, -3.2826393275671353],
            [13.791520507309334, -3.2866233396708533],
            [13.787375374933191, -3.2848958856401365],
            [13.781303361338642, -3.2895960631418775],
            [13.777097480457673, -3.3019963766918337],
            [13.777185969320016, -3.3068686470091757],
            [13.772617292909638, -3.3110979173248913],
            [13.769479023221395, -3.311266208401498],
            [13.761890236166233, -3.3080193150099104],
            [13.746293930630783, -3.3078403097322426],
            [13.741639431722152, -3.306682533383315],
            [13.738809586243514, -3.30411892451297],
            [13.73525437316555, -3.306568637426594],
            [13.724322509971483, -3.3539669933148755],
            [13.724962944727453, -3.35729022175021],
            [13.719430098736845, -3.359468698023133],
            [13.709476759486975, -3.3582218315981023],
            [13.698173417540271, -3.359757263467189],
            [13.693836603243376, -3.359274828206693],
            [13.686944795001722, -3.356218544650437],
            [13.68436496364521, -3.3564157929381766],
            [13.67837877372857, -3.3600105662981767],
            [13.676455011596897, -3.3641804208187662],
            [13.671476990097483, -3.368434382390365],
            [13.604947724067872, -3.441192572648828],
            [13.562739170333488, -3.4873478224240815],
            [13.495437545316209, -3.560811524447115],
            [13.489887089291956, -3.5618363404352023],
            [13.487514726404394, -3.5589431753288414],
            [13.483043009864389, -3.5578760313224267],
            [13.477851671699346, -3.550130726166765],
            [13.474613958296837, -3.5521496236301795],
            [13.471894227186551, -3.5491045069428115],
            [13.47105034214825, -3.5453442611023007],
            [13.467293593629757, -3.5444373231812336],
            [13.461370830083167, -3.538871682996012],
            [13.452981430249322, -3.5355458026795503],
            [13.447613144980387, -3.534607430515118],
            [13.447201906174644, -3.532316398134667],
            [13.439703128580128, -3.529676748186521],
            [13.438432428972531, -3.5270947269909807],
            [13.43400990876692, -3.5243705838810753],
            [13.432221382058007, -3.5197407136699326],
            [13.42751076671404, -3.5150634747537945],
            [13.425980154043186, -3.51564714784204],
            [13.421093814207191, -3.5114203665655954],
            [13.420589014688582, -3.507602686434608],
            [13.417197561594607, -3.505718354974418],
            [13.41536223454208, -3.5006757262061994],
            [13.41093707537713, -3.4980998289883476],
            [13.422371944904851, -3.4826090793993907],
            [13.442130421210454, -3.4567479548876916],
            [13.437636722966216, -3.425271484646529],
            [13.423308433320287, -3.404749774091532],
            [13.424229847455484, -3.4021786993155585],
            [13.410826823818281, -3.3850720292879704],
            [13.412680761912256, -3.3796474932691694],
            [13.409113460844974, -3.372999291982408],
            [13.398661774783495, -3.36895611527507],
            [13.393251234923984, -3.364884190206947],
            [13.391839734367126, -3.36208286800525],
            [13.38563271518021, -3.3590105229588216],
            [13.381772800745525, -3.355427430727868],
            [13.381077396726527, -3.349676398982251],
            [13.377008467106705, -3.347705588642714],
            [13.374835953868597, -3.34476234909839],
            [13.372732835955212, -3.338534228003979],
            [13.370112267390128, -3.3369843014108915],
            [13.361673786617294, -3.297654955232116],
            [13.355008377822417, -3.2970044932922593],
            [13.350225162279326, -3.299076712889904],
            [13.342716668050898, -3.328532376711391],
            [13.315312144530578, -3.348010840745498],
            [13.31246583329183, -3.3416101629637476],
            [13.304816432604719, -3.333176147927901],
            [13.300065486050084, -3.3334283876561583],
            [13.298115035500485, -3.3297108219957905],
            [13.294037477993324, -3.3309725739601346],
            [13.291310828367429, -3.3265896159009105],
            [13.28375288613574, -3.3249952472928106],
            [13.281682374941965, -3.325783083424182],
            [13.27907866290546, -3.3214496853171975],
            [13.271985946203273, -3.314752410075794]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.95767242584944, "lat": 34.33254093462014 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45031"],
        "coty_name": ["Darlington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Darlington County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01247992"
      },
      "bbox": [
        13.271720484118312, -3.5618363404352023, 13.791631857181478,
        -3.0833623649048967
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0431052505249023, 4.514814435194102],
            [-0.9806726988413764, 4.513685713507244],
            [-0.9412255567801804, 4.513237909218971],
            [-0.8952905396694778, 4.512402136649981],
            [-0.8100058220584331, 4.511434274361919],
            [-0.7242153493434118, 4.509042380208573],
            [-0.7252789334050683, 4.407895121507891],
            [-0.7256299823404425, 4.335762181701077],
            [-0.7264977331248919, 4.281257969153175],
            [-0.7281936467677365, 4.190895834820908],
            [-0.7446624504825601, 4.184335056774935],
            [-0.7523053682444614, 4.182868146509681],
            [-0.7655896294468029, 4.1825040119511225],
            [-0.7761508353410006, 4.18405827966916],
            [-0.7902383432552993, 4.187965318547322],
            [-0.8119858621410367, 4.190422215243499],
            [-0.8224778711162336, 4.190221429153658],
            [-0.8295531580514774, 4.191029067411021],
            [-0.8396919280825177, 4.19483158254696],
            [-0.8489909960205619, 4.199650077307563],
            [-0.8603809403298406, 4.203656813294558],
            [-0.8685667614845487, 4.210852478718341],
            [-0.880808118860169, 4.210021965249008],
            [-0.8957850338573234, 4.205423538262557],
            [-0.9028981222205545, 4.201413472989035],
            [-0.904192221035398, 4.197094554872118],
            [-0.9034836962176658, 4.190389316713215],
            [-0.9058431019494407, 4.186370198524769],
            [-0.9066651629091572, 4.1780804636293905],
            [-0.9104822044866314, 4.168960688744961],
            [-0.9133574747225629, 4.160006818987023],
            [-0.9177182089908992, 4.154505158358365],
            [-0.9257133620264437, 4.141809971878723],
            [-0.9338778877630488, 4.1329711475049935],
            [-0.9379114215580389, 4.1314979025360925],
            [-0.9465273548537115, 4.121487141280074],
            [-0.949316050165827, 4.119086028253538],
            [-0.9592407555679088, 4.113131477978134],
            [-0.9679394315337676, 4.112395792495175],
            [-0.9792546377000563, 4.113849108103646],
            [-0.9902405315278786, 4.109248635628423],
            [-0.9960007280803335, 4.107507622115047],
            [-0.9999148528260663, 4.108504213064938],
            [-1.0052860180330405, 4.106742721684922],
            [-1.02128833341529, 4.108995597638496],
            [-1.028249324970729, 4.112982491866251],
            [-1.0332936054385513, 4.113833608897184],
            [-1.0391990124438304, 4.117978493399148],
            [-1.0412600647415065, 4.126400106029196],
            [-1.0444446485063092, 4.1301221638104835],
            [-1.0554617353206852, 4.139979251431082],
            [-1.063951445060349, 4.145149967484202],
            [-1.0732620790175282, 4.1567191845135945],
            [-1.0885899634257352, 4.167691995653674],
            [-1.0947989293422853, 4.179370872504363],
            [-1.1012129323179165, 4.186634496581254],
            [-1.1057094389497593, 4.185975807532993],
            [-1.1063176906606076, 4.19386095261922],
            [-1.1114636879118542, 4.19769711348164],
            [-1.1038115204833108, 4.200297341499257],
            [-1.0997920729128188, 4.200665271688263],
            [-1.0944183886101588, 4.205611549293718],
            [-1.096288705744671, 4.208041562352659],
            [-1.0952111341547732, 4.211505038074956],
            [-1.0914867079224273, 4.212819180217601],
            [-1.088821471896103, 4.216338454694251],
            [-1.083634564573729, 4.215119986135017],
            [-1.0809241323138374, 4.217814786729309],
            [-1.0793410496584566, 4.222969769170435],
            [-1.0763020073050893, 4.227218512016439],
            [-1.0763458336299707, 4.2356410887329785],
            [-1.0747419502285698, 4.23751073400503],
            [-1.0748368127304466, 4.242538178525286],
            [-1.076989482638121, 4.243594204999081],
            [-1.0774824340648124, 4.250099142881343],
            [-1.0815785841891918, 4.252481616877007],
            [-1.0823318651497105, 4.257454305482288],
            [-1.0743535780556885, 4.259576347874675],
            [-1.0738357179944475, 4.2667005829143845],
            [-1.069922048559855, 4.272650047026686],
            [-1.07469200170509, 4.2752996762670294],
            [-1.0727121179338277, 4.278790901794743],
            [-1.0734982530441441, 4.282202947078621],
            [-1.0675383846988944, 4.284300080686976],
            [-1.0710328371819713, 4.289331726533446],
            [-1.0653031983972427, 4.304716936683947],
            [-1.0628893297196833, 4.30521543831552],
            [-1.0623409344784254, 4.316901877955005],
            [-1.0587779291735318, 4.320220777150105],
            [-1.0595131916664393, 4.324985170573086],
            [-1.064487198725223, 4.32871746537866],
            [-1.0649225879100213, 4.335169219795225],
            [-1.0683680802485098, 4.338917154717996],
            [-1.0686638331699627, 4.345116926887255],
            [-1.0729792862034304, 4.347922421543261],
            [-1.0716782020855509, 4.359821286860957],
            [-1.0687495177451236, 4.36317632252646],
            [-1.070843472633545, 4.366960410823976],
            [-1.0601956502053929, 4.378106825958804],
            [-1.064653249501102, 4.383730630615165],
            [-1.0654718500688887, 4.390904769801119],
            [-1.0644254478596684, 4.395239822675439],
            [-1.0645700346139988, 4.403201042869671],
            [-1.0683029055810382, 4.411904173935327],
            [-1.067605299673524, 4.425258974125829],
            [-1.0662515965719987, 4.4301602674471825],
            [-1.0684290105565415, 4.434312371138703],
            [-1.0661079449036193, 4.440934727204727],
            [-1.066820356183003, 4.448816148038031],
            [-1.0631241488491856, 4.45946639373116],
            [-1.0578130774873635, 4.4616904490083495],
            [-1.0555943861771437, 4.465701117037059],
            [-1.0549704324893938, 4.481884462336085],
            [-1.0525282976256634, 4.492012267563366],
            [-1.052672494344857, 4.499198132414694],
            [-1.0431052505249023, 4.514814435194102]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.88467992354262, "lat": 42.98845914006507 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46009"],
        "coty_name": ["Bon Homme"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bon Homme County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01266997"
      },
      "bbox": [
        -1.1114636879118542, 4.106742721684922, -0.7242153493434118,
        4.514814435194102
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.172749914660733, 5.268384034629154],
            [-3.168414658764943, 5.272418850157289],
            [-3.1670323993581744, 5.2760837922554185],
            [-3.168305366839745, 5.279368936339036],
            [-3.1658972106369836, 5.281506747022861],
            [-3.161948869452968, 5.278360255460734],
            [-3.1567111496550555, 5.279111218585973],
            [-3.1510203613679377, 5.278080702568988],
            [-3.1494552266192213, 5.282430964116088],
            [-3.147030774900267, 5.283699567676606],
            [-3.1438986018217494, 5.278122514655305],
            [-3.148318584009292, 5.274311061689098],
            [-3.1490629974312188, 5.269054345816269],
            [-3.143432047821222, 5.267313821169973],
            [-3.1359915651123433, 5.268612174816934],
            [-3.1346512290329738, 5.266524435283003],
            [-3.122954403321563, 5.274467280997153],
            [-3.116872482131833, 5.273490220319935],
            [-3.115820163368758, 5.271347899717418],
            [-3.1173748352595023, 5.266638862234206],
            [-3.112862106568049, 5.2612732101811535],
            [-3.1153381913786378, 5.258833642271283],
            [-3.1107825916825487, 5.2558405290057495],
            [-3.105493478370189, 5.254858850264861],
            [-3.10086869988897, 5.257077793527819],
            [-3.097866450483281, 5.2560205578618655],
            [-3.0984354111211987, 5.252360905936331],
            [-3.1024786453939335, 5.249861170202462],
            [-3.1048099332988186, 5.251860794813178],
            [-3.108529523221853, 5.250718145599374],
            [-3.106390867271986, 5.241385682455025],
            [-3.102528181343984, 5.239502436192689],
            [-3.094850986694075, 5.24046479404734],
            [-3.0943129568365, 5.234318455623738],
            [-3.088325141842942, 5.239107854218273],
            [-3.086766155906734, 5.247179651872093],
            [-3.0844960587331465, 5.253554491784882],
            [-3.0768686182991214, 5.253159736511393],
            [-3.0689204828129037, 5.243839076253844],
            [-3.0681438532024226, 5.2361069815223065],
            [-3.0628680385979883, 5.233835786499244],
            [-3.059546359457328, 5.235634201175522],
            [-3.0547752116299964, 5.233118278237691],
            [-3.0548825819909187, 5.228043707202608],
            [-3.058412476871449, 5.225870238517668],
            [-3.065506631177471, 5.228690314551442],
            [-3.063464099550767, 5.223296658477612],
            [-3.060449642238817, 5.221493500798862],
            [-3.0525409472135334, 5.221570747901167],
            [-3.0520181913407796, 5.218360993963537],
            [-3.058455675278684, 5.215358454861962],
            [-3.050253861376136, 5.21258538693118],
            [-3.0466763810834396, 5.212524170520058],
            [-3.044888000128575, 5.215456351320727],
            [-3.0457793136695117, 5.220038606459252],
            [-3.0430738673139643, 5.222139817598898],
            [-3.038813277894252, 5.220526174442711],
            [-3.0388081120419583, 5.214621642325011],
            [-3.0374464246594304, 5.209251423634614],
            [-3.0408426018850085, 5.206897830745096],
            [-3.040393792005549, 5.201108492607807],
            [-3.034681910979772, 5.201449489493497],
            [-3.0325230432365644, 5.208552484378777],
            [-3.0298533078965058, 5.208587537880541],
            [-3.0233416465780523, 5.199555846340286],
            [-3.018527888401476, 5.186904940836349],
            [-3.0155213465597592, 5.185513626844163],
            [-3.0168870709102475, 5.179274521084726],
            [-3.0144338061906293, 5.178027488759864],
            [-3.0117404344903957, 5.181405610186723],
            [-3.0132200642307185, 5.186128825607064],
            [-3.00770767543934, 5.1876367831676085],
            [-2.996990436227638, 5.1848258751904615],
            [-2.993380411905792, 5.184885026718287],
            [-2.9911644058004963, 5.181318759737981],
            [-2.9918363919507964, 5.175960457701144],
            [-2.988868965303246, 5.171624312929514],
            [-2.98645857113644, 5.173039039539552],
            [-2.983774030455776, 5.168626208739189],
            [-2.987134263000631, 5.16453442278154],
            [-2.990828096172376, 5.167000568143721],
            [-2.9914667376423725, 5.162185059670995],
            [-2.98382887750691, 5.157568715344125],
            [-2.980859694519447, 5.1596836507492645],
            [-2.978709870103954, 5.157326558702249],
            [-2.9802011099975854, 5.152060932140326],
            [-2.979737860337539, 5.147677466775824],
            [-2.9817941978831235, 5.1428816927037575],
            [-2.975040194725745, 5.140909355813123],
            [-2.9721792227633643, 5.141373851917571],
            [-2.9654560920331914, 5.148216635798674],
            [-2.9587961511373817, 5.147272077768403],
            [-2.9569838462561955, 5.151104173279265],
            [-2.9488441156638348, 5.1498494512063475],
            [-2.946778866286088, 5.146913744173136],
            [-2.9480339653279954, 5.143823720758728],
            [-2.955888790845066, 5.138892297053458],
            [-2.9490952846828686, 5.13490265694271],
            [-2.948136435344691, 5.131750439117008],
            [-2.9431527070305643, 5.1229401263592225],
            [-2.9396301854229923, 5.123741731948092],
            [-2.9373537393603772, 5.129043796214734],
            [-2.9388554695252416, 5.131293441067565],
            [-2.945436760510459, 5.13274785933362],
            [-2.944631690698069, 5.1361027668435835],
            [-2.9367236661366056, 5.136503400434875],
            [-2.933791268131073, 5.129960851624132],
            [-2.928909670678896, 5.135021889915821],
            [-2.922334793049337, 5.132367664654615],
            [-2.9179276594187984, 5.138342063397164],
            [-2.914240254148783, 5.1379029973135655],
            [-2.9162303828677425, 5.133115098966547],
            [-2.910333933479541, 5.1274921515595935],
            [-2.903303256054632, 5.124993594497586],
            [-2.900904740722433, 5.126994968501516],
            [-2.9010504286696364, 5.135968868998984],
            [-2.8830447620025885, 5.144127416460145],
            [-2.88564380931604, 5.14831681108473],
            [-2.8942707619277535, 5.147345797622768],
            [-2.8917737255868223, 5.154402242820388],
            [-2.88622699008572, 5.1594831195635145],
            [-2.880451839164612, 5.161902737415215],
            [-2.8742574677552875, 5.160943051845227],
            [-2.871467678551576, 5.158173876679059],
            [-2.870214749706401, 5.150643114486046],
            [-2.8614198484547106, 5.155675282842842],
            [-2.8576326311341833, 5.154510462903291],
            [-2.85438386093791, 5.156332759967152],
            [-2.8513879662543626, 5.160713681385094],
            [-2.851611221108991, 5.169518583313091],
            [-2.845176490740621, 5.173554094950133],
            [-2.839433567348192, 5.17581524806361],
            [-2.8375289644184085, 5.178872310168839],
            [-2.834408043676748, 5.179370865250918],
            [-2.830448602343955, 5.177383328641477],
            [-2.8260039595245456, 5.170686042360637],
            [-2.8244260723272157, 5.162632487516131],
            [-2.8164638419828756, 5.162456371865073],
            [-2.8117733056366485, 5.164822343515445],
            [-2.809390449156049, 5.163684287405019],
            [-2.807992439102495, 5.156188302487544],
            [-2.808885780986658, 5.151811325852289],
            [-2.8119478710398416, 5.150056087623228],
            [-2.8120892347363746, 5.146222879802029],
            [-2.8026365495220045, 5.145306418142243],
            [-2.7973778660252173, 5.14761245303935],
            [-2.7930008737037526, 5.152903439752994],
            [-2.7882358469186874, 5.154123121506046],
            [-2.7834756544678743, 5.1483355463712215],
            [-2.7834334685126594, 5.143152930267939],
            [-2.7851202160667157, 5.1384065548015245],
            [-2.7765224319577597, 5.136079337767824],
            [-2.769731725038747, 5.139784090407543],
            [-2.7664064046923413, 5.14461276912367],
            [-2.762613067530602, 5.142370594383896],
            [-2.7596474443675802, 5.134891724318799],
            [-2.7555096936443575, 5.133441771999784],
            [-2.7524632758101304, 5.137416175076072],
            [-2.7481007942296904, 5.135615706835723],
            [-2.7504157595225776, 5.131245345859417],
            [-2.7448844762933975, 5.12682795485807],
            [-2.73908343337335, 5.1280047588182445],
            [-2.73667630263715, 5.131346896899833],
            [-2.734877139062796, 5.137115471636556],
            [-2.7319412232398075, 5.137280002980173],
            [-2.7254191190436097, 5.129506904705349],
            [-2.7211851485086074, 5.127492846723037],
            [-2.7158235615291133, 5.1224539041001655],
            [-2.71163460989954, 5.127381521454598],
            [-2.7106895624153804, 5.131995734437364],
            [-2.7140344180269755, 5.138285344793219],
            [-2.712082003972416, 5.139851979808489],
            [-2.7021596636834118, 5.134674385067956],
            [-2.6956855188035727, 5.133552843530248],
            [-2.6926005815376994, 5.129384755229115],
            [-2.6880162503525598, 5.129241054380017],
            [-2.6849978553423743, 5.131296193223922],
            [-2.6856443662707625, 5.134556902404873],
            [-2.6815379705044773, 5.141456172699048],
            [-2.6780469145926498, 5.141737699880443],
            [-2.6751370281749947, 5.138321478938637],
            [-2.671464056235611, 5.136780813379866],
            [-2.6689626435858056, 5.133070106712432],
            [-2.663581079846017, 5.129701678410087],
            [-2.662436762304713, 5.121994915406431],
            [-2.6579819492516084, 5.118705136387318],
            [-2.6522486541308874, 5.117128822299811],
            [-2.644638692213002, 5.118919330610377],
            [-2.636465403058574, 5.123803080076786],
            [-2.633415583108174, 5.1239707009821505],
            [-2.6308687937616577, 5.120664801041339],
            [-2.6280594643844584, 5.106383126411437],
            [-2.6240924130136776, 5.098939991813489],
            [-2.6165151366614356, 5.096657899423602],
            [-2.612693903900675, 5.099392314265393],
            [-2.610511589957029, 5.104361102362176],
            [-2.60555330029562, 5.108549790606253],
            [-2.600669405144268, 5.107642623523219],
            [-2.5991056106926567, 5.1033083479987],
            [-2.596183234779144, 5.1021326257536845],
            [-2.5803801281458596, 5.112128248561142],
            [-2.584225751423281, 5.028181931778163],
            [-2.5849907664409724, 5.006410506409567],
            [-2.586932718399967, 4.962638542377466],
            [-2.5887021427561008, 4.926923639047143],
            [-2.5894941862327134, 4.905215901918769],
            [-2.591028952869688, 4.876334746090532],
            [-2.5791108581226676, 4.875156463548348],
            [-2.5809506992415523, 4.82823537619687],
            [-2.582711162335815, 4.788240735962333],
            [-2.6185838948964983, 4.789759930636733],
            [-2.668313283005662, 4.79159351852767],
            [-2.725709897659185, 4.7943909347666995],
            [-2.8369410754155187, 4.799702137786462],
            [-2.970308077288875, 4.805672593795327],
            [-3.03021138209537, 4.808689828824638],
            [-3.098124636350821, 4.8119544101133],
            [-3.1413097887236314, 4.814221079586706],
            [-3.1798825192223537, 4.815849595875461],
            [-3.2644519749002083, 4.820440404427211],
            [-3.3152853482771225, 4.8232649412011765],
            [-3.3129999285214646, 4.8666906133892756],
            [-3.309703859657688, 4.924941842581905],
            [-3.305743218569489, 4.997004334745841],
            [-3.2997716228715426, 5.102119447821331],
            [-3.2931318502565197, 5.222723463565359],
            [-3.2928434199575762, 5.2293461098765],
            [-3.2843226745406433, 5.232072879790614],
            [-3.2852670843613696, 5.236014963485182],
            [-3.2782442629094004, 5.239301000642856],
            [-3.275978724812563, 5.244926048074725],
            [-3.2718038328587644, 5.245072726785328],
            [-3.2694061132678582, 5.242888247277185],
            [-3.2682040157467336, 5.236652387799572],
            [-3.265824925986826, 5.234920626073838],
            [-3.259017936054999, 5.238385564132903],
            [-3.25740178686226, 5.250185531310296],
            [-3.254238906721457, 5.250352197633379],
            [-3.2503869934202587, 5.24668167693708],
            [-3.2493991227691605, 5.2538234595305795],
            [-3.245483254893448, 5.255434592796465],
            [-3.2430563211078023, 5.2610824944129835],
            [-3.2393488569238893, 5.2577479668429765],
            [-3.2374564105214314, 5.25329613977722],
            [-3.239583040839058, 5.247593605434401],
            [-3.229871288244023, 5.250319356069375],
            [-3.225976108447926, 5.253835133520312],
            [-3.2235802374935196, 5.260597712806372],
            [-3.228598538691646, 5.2626343014459875],
            [-3.2292779581570734, 5.264972774792249],
            [-3.2255455212271076, 5.271439663684863],
            [-3.2182107243445928, 5.270246884142482],
            [-3.2159831515488646, 5.273939670236513],
            [-3.209206621487471, 5.270343976569517],
            [-3.2036655858865632, 5.265680748970064],
            [-3.2008458228530654, 5.266962498790336],
            [-3.2010631957910958, 5.2703861886310035],
            [-3.2037818195458803, 5.275129162449621],
            [-3.2002408607639814, 5.27639827036965],
            [-3.197408715713997, 5.2727166518211],
            [-3.18912808409672, 5.2775094163609175],
            [-3.1861640091808274, 5.2737301660096305],
            [-3.18715342389967, 5.269390797752738],
            [-3.1815745966688067, 5.269934542306109],
            [-3.172749914660733, 5.268384034629154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.76001258939921,
          "lat": 43.58127444989171
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46095"],
        "coty_name": ["Mellette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mellette County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01267177"
      },
      "bbox": [
        -3.3152853482771225, 4.788240735962333, -2.5791108581226676,
        5.283699567676606
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.2903179262235085, 5.714476878259264],
            [-5.173139946597301, 5.704710117987192],
            [-5.055964757760299, 5.694910317103327],
            [-4.958751772128464, 5.686851155877604],
            [-4.861056602341642, 5.6792444311239745],
            [-4.8103486969060185, 5.675172562718895],
            [-4.804512054647654, 5.674951170481611],
            [-4.754964233995038, 5.671108640441066],
            [-4.732337985162009, 5.669546015510091],
            [-4.675057714142118, 5.664980217421777],
            [-4.560048905427778, 5.656341322444483],
            [-4.48829422504168, 5.650924602592083],
            [-4.416181754635345, 5.6458385058999925],
            [-4.301977592910691, 5.637427721956064],
            [-4.244901116793989, 5.633315736676421],
            [-4.158647148754336, 5.627298527322248],
            [-4.101815282610453, 5.623544679557847],
            [-4.104866501312392, 5.6265593335900865],
            [-4.106769648136181, 5.632519392692036],
            [-4.109141491742681, 5.635163375415514],
            [-4.107636739007986, 5.640003038775648],
            [-4.111923892839217, 5.639846471365399],
            [-4.110525301093313, 5.645200480574682],
            [-4.105480624207021, 5.645299295759428],
            [-4.101456290007923, 5.643367369211877],
            [-4.099488895986904, 5.64866834114186],
            [-4.098850965587548, 5.658015845987806],
            [-4.101438757937261, 5.6614382985730725],
            [-4.1052498069065315, 5.660621123364051],
            [-4.1084652090246205, 5.662187731626963],
            [-4.103165577440555, 5.677126491083686],
            [-4.103822363775853, 5.6795809153246655],
            [-4.101489768192046, 5.686347336502862],
            [-4.098189017030934, 5.689371855284329],
            [-4.093977892417938, 5.690390539913907],
            [-4.088938706509884, 5.689866345020879],
            [-4.086123977192714, 5.691770270843051],
            [-4.086188147833295, 5.70173735237766],
            [-4.0852577303733275, 5.7040762763177355],
            [-4.073595127075429, 5.712084752397827],
            [-4.074322039885968, 5.715174429494371],
            [-4.078649599775202, 5.722329721758272],
            [-4.078505965125159, 5.726435638604542],
            [-4.074198272733482, 5.72900228514834],
            [-4.076030870577752, 5.740393125070594],
            [-4.072555605040704, 5.747135342808421],
            [-4.076174454761782, 5.753593317839528],
            [-4.078111804859539, 5.759344960587409],
            [-4.075386616360568, 5.770502384824125],
            [-4.071703116676674, 5.774747444094109],
            [-4.0715489991042935, 5.779625901891472],
            [-4.067720772438397, 5.784076341163273],
            [-4.064677192147655, 5.782960511879294],
            [-4.062013856124062, 5.787058696402057],
            [-4.0639703753410465, 5.790651255914618],
            [-4.061811923188136, 5.798931170681763],
            [-4.058692801370708, 5.801672781606712],
            [-4.060655623397732, 5.807037518140992],
            [-4.056462312002933, 5.809366633177531],
            [-4.056218255091982, 5.820639218369177],
            [-4.051815571111142, 5.822609513095916],
            [-4.054744487442177, 5.829066752237876],
            [-4.050190038780113, 5.831826880310477],
            [-4.0450080746510535, 5.837494288409704],
            [-4.042685904731465, 5.846344022144245],
            [-4.040137103965146, 5.847363855230466],
            [-4.032440197536919, 5.842648838242138],
            [-4.0278055289673524, 5.8462647145214595],
            [-4.027844185886186, 5.851119381551797],
            [-4.023382826545392, 5.853199152762596],
            [-4.022046600686743, 5.857210043161911],
            [-4.024047289091196, 5.863031831673211],
            [-4.02116665395576, 5.866952563159953],
            [-4.025523259803088, 5.869892605024611],
            [-4.023975453324955, 5.8736292666714975],
            [-4.0230227310296796, 5.885835497105834],
            [-4.025141709345836, 5.887163107559687],
            [-4.022484901192945, 5.897954566931471],
            [-4.027869341179953, 5.902880699724171],
            [-4.024177825846038, 5.907021813722056],
            [-4.024568419007111, 5.911388764843053],
            [-4.021809565088179, 5.911789191253141],
            [-4.018827822356416, 5.908706541156799],
            [-4.014889308467772, 5.909618129620152],
            [-4.01396843523477, 5.91268298974682],
            [-4.0079003778342015, 5.918401180915956],
            [-4.006324992090557, 5.925687725436122],
            [-4.000565843832069, 5.927364660636508],
            [-3.9957416973160496, 5.922959726372912],
            [-3.986361541088912, 5.922515107313768],
            [-3.9804172457535176, 5.924387499871273],
            [-3.973977805153275, 5.924472969816043],
            [-3.9681010479303636, 5.926542688587637],
            [-3.9628987490376995, 5.926580039175822],
            [-3.9616527399086596, 5.923877281571631],
            [-3.963694399236828, 5.917983695458384],
            [-3.960842468605961, 5.91537006144314],
            [-3.9557604935426753, 5.914141539090763],
            [-3.946345921471751, 5.907143703752609],
            [-3.9478699479318986, 5.901986318709306],
            [-3.941340012641691, 5.900019160386468],
            [-3.934535833746319, 5.899609107874754],
            [-3.927281520535866, 5.900408012026516],
            [-3.922285936591472, 5.899386524655755],
            [-3.9191034043844923, 5.901543836959106],
            [-3.915521851572745, 5.908971668339488],
            [-3.9191821399868334, 5.913386517897091],
            [-3.91481154024848, 5.916332664100404],
            [-3.908017684475413, 5.914816486923519],
            [-3.9000811365556056, 5.909094929984921],
            [-3.893720828834222, 5.907932890009202],
            [-3.886123266373422, 5.9051470642968695],
            [-3.8815167102733414, 5.90685097423895],
            [-3.87968412036239, 5.915328579743684],
            [-3.8717676649633526, 5.923017358835837],
            [-3.8664969531000604, 5.921781549994919],
            [-3.863862296111094, 5.922812756951519],
            [-3.8643615959086697, 5.9272416317277825],
            [-3.86063703061054, 5.930801635678762],
            [-3.8573698862050527, 5.931692802988125],
            [-3.8554927871772593, 5.935370615728097],
            [-3.858038876699019, 5.939030132406714],
            [-3.857601612952763, 5.9424996907604815],
            [-3.8480686021230874, 5.947688920335294],
            [-3.843742056580851, 5.94731425032753],
            [-3.8418780093437386, 5.9496939846837185],
            [-3.841360236630152, 5.956655457918862],
            [-3.8373288649631934, 5.960596296587348],
            [-3.833765513111954, 5.96648724547292],
            [-3.828542924674961, 5.969285879077778],
            [-3.8141320101736316, 5.970196054990095],
            [-3.810151451988519, 5.969673432561253],
            [-3.8038564840907596, 5.9726460605508676],
            [-3.8021592224002956, 5.974801194824724],
            [-3.8071594084015183, 5.892860213265454],
            [-3.8126570772201056, 5.808467527301096],
            [-3.817119376604097, 5.808701358302472],
            [-3.8283178196790235, 5.63552575758466],
            [-3.8313461410596523, 5.590760061469345],
            [-3.8311908798680467, 5.589684630274192],
            [-3.83395887470848, 5.547183327286371],
            [-3.8393276484611487, 5.4606936844021465],
            [-3.847779004433284, 5.461188629247026],
            [-3.8494761891106974, 5.437659369116384],
            [-3.853584406219191, 5.374544935604891],
            [-3.8588451236175394, 5.288199393152898],
            [-3.863335407127399, 5.217248414981678],
            [-3.8638553131325164, 5.215366380184986],
            [-3.8657563523412186, 5.1759786683555475],
            [-3.8700742756174233, 5.1782448151785685],
            [-3.8721074782869893, 5.174499974344632],
            [-3.877167544175124, 5.170698164682909],
            [-3.8794823356183747, 5.166992273315507],
            [-3.87746519406314, 5.157400452975828],
            [-3.8796360090641104, 5.156463506235155],
            [-3.8843700664882546, 5.1641861488723855],
            [-3.8869035847283895, 5.164051201315598],
            [-3.891094335279062, 5.158156418780781],
            [-3.9039247042637695, 5.159543756189734],
            [-3.914021036840051, 5.1638478992862185],
            [-3.922575932185601, 5.164809585721553],
            [-3.921886344048979, 5.159157722239082],
            [-3.924734833879537, 5.156238860402794],
            [-3.9315792908082376, 5.157333743129017],
            [-3.933905670353471, 5.163981788920661],
            [-3.9302987435052827, 5.169313153316822],
            [-3.929799771647762, 5.173273156970118],
            [-3.932597923088977, 5.17697742784164],
            [-3.9336662021146704, 5.181884711320714],
            [-3.936586402844436, 5.181253284837528],
            [-3.9404391840960034, 5.176514570748747],
            [-3.9453799539386702, 5.177667037490198],
            [-3.952647525262487, 5.173834141664148],
            [-3.9585805172036213, 5.176491755757998],
            [-3.9613472575630375, 5.179623962826604],
            [-3.964675590441609, 5.178448751437853],
            [-3.9650298888218276, 5.171380510514669],
            [-3.9673072938055793, 5.170087364098053],
            [-3.973909714862861, 5.17111979044026],
            [-3.9728857642477386, 5.165947749097089],
            [-3.979421487795733, 5.162341599135517],
            [-3.9866760971221824, 5.1625374423573875],
            [-4.1108213838205705, 5.170668979272575],
            [-4.21056936115219, 5.177441530985174],
            [-4.2914472818050555, 5.182947952513795],
            [-4.4349827053760205, 5.19318526747505],
            [-4.439597281896541, 5.194831854059312],
            [-4.440093599395845, 5.197207769771082],
            [-4.435065895397296, 5.203068117892744],
            [-4.42811596269609, 5.203931332873523],
            [-4.429652260838251, 5.21223499669641],
            [-4.428985748902102, 5.215488188083452],
            [-4.422927787279628, 5.218125998616447],
            [-4.419603864698366, 5.226462489602309],
            [-4.409877347792368, 5.225306673628576],
            [-4.409076457766219, 5.230728888423203],
            [-4.406031148596446, 5.230821137907752],
            [-4.403947995085774, 5.234420704736036],
            [-4.4056642219635895, 5.237358879009112],
            [-4.401607736878395, 5.24291145816141],
            [-4.394672301251004, 5.244033232437886],
            [-4.39074503113349, 5.249309670371013],
            [-4.389593921385825, 5.254305690299424],
            [-4.385653534464882, 5.258708077446567],
            [-4.3784369148496385, 5.262234263155871],
            [-4.375093088160896, 5.265759003818258],
            [-4.378507421892071, 5.27156777716256],
            [-4.37331555005293, 5.276154609443396],
            [-4.368606004636136, 5.276942696479973],
            [-4.354701053674487, 5.289683646735052],
            [-4.352807615501417, 5.29261944709874],
            [-4.353375000596781, 5.296637470932937],
            [-4.3453823309622335, 5.2977031249632835],
            [-4.34764044592407, 5.302190609157157],
            [-4.348232839733462, 5.311760567301799],
            [-4.345974247506504, 5.3227633141337645],
            [-4.341422273716958, 5.333072385565549],
            [-4.337526750955906, 5.338642280501079],
            [-4.336943039753026, 5.341739919371929],
            [-4.340268131284015, 5.344137894300002],
            [-4.340558869092472, 5.347240751192235],
            [-4.335268986748024, 5.351564125213831],
            [-4.335350579484693, 5.354572021948471],
            [-4.352584880457343, 5.355776485131532],
            [-4.4584695353423776, 5.363994806879753],
            [-4.515773475640273, 5.3683930498611145],
            [-4.616393700722887, 5.376023049544959],
            [-4.7091452137553995, 5.3828462188003465],
            [-4.801651520516564, 5.3896797100233105],
            [-4.831292493723388, 5.3922087617612915],
            [-4.973430821855849, 5.402553846993671],
            [-5.043602981575759, 5.4076225828945885],
            [-5.1221660274303185, 5.413561332752421],
            [-5.144349878987415, 5.4153250071270955],
            [-5.229822904994059, 5.421801839079397],
            [-5.315297123431519, 5.428261669156212],
            [-5.307841624656563, 5.512057117556423],
            [-5.2996564270887, 5.605113843687786],
            [-5.2903179262235085, 5.714476878259264]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.82378278584343,
          "lat": 44.00372703508633
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46103"],
        "coty_name": ["Pennington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pennington County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01266995"
      },
      "bbox": [
        -5.315297123431519, 5.156238860402794, -3.8021592224002956,
        5.974801194824724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.239846156294107, -3.0858704072138115],
            [6.26066039831428, -3.0846780738763826],
            [6.278573943820336, -3.0728682613842477],
            [6.368555807185537, -3.0140830733369914],
            [6.398300410892692, -2.964377840087629],
            [6.411903624596366, -2.9298777108877037],
            [6.410897484155892, -2.9108246453320494],
            [6.415045794126924, -2.9128913437885],
            [6.421885247076455, -2.90629009901088],
            [6.425677242775012, -2.9053375222065654],
            [6.431169006698342, -2.9094455144493927],
            [6.436835468241402, -2.9091900945037454],
            [6.439139080006922, -2.907162395403209],
            [6.449577994888373, -2.908818339941341],
            [6.453466569108842, -2.9180527055937193],
            [6.458479720462218, -2.9280558088404387],
            [6.4693066426834775, -2.9457136863497975],
            [6.48284347668274, -2.9620560952049875],
            [6.492146283206858, -2.9710218795867838],
            [6.503926488974002, -2.9804127089413446],
            [6.534368557651083, -2.9943259783077503],
            [6.557201945796519, -2.9981479824632706],
            [6.5725144882456945, -2.998151786611446],
            [6.577435088401517, -2.9994045592989265],
            [6.579316519550899, -3.004437522132723],
            [6.5888131195185995, -3.001409243652501],
            [6.609198520186506, -2.991155554721017],
            [6.619158493426865, -2.9906697323054425],
            [6.627693663646405, -3.06460729632682],
            [6.627954143380556, -3.074789347643741],
            [6.635983907037447, -3.076308037422018],
            [6.63344788263799, -3.0802244782277],
            [6.633765793295684, -3.086331697825943],
            [6.628583952223102, -3.086698066691711],
            [6.629365856906331, -3.102856206305706],
            [6.622583414418764, -3.1036772001536117],
            [6.623375114420485, -3.1095793454429184],
            [6.612628875152932, -3.110180049579221],
            [6.612533216702175, -3.1042624737297713],
            [6.601240780461504, -3.105026717601848],
            [6.575410451813246, -3.1054163566182065],
            [6.528619875852875, -3.1066101902404664],
            [6.512133584592375, -3.1082337231608554],
            [6.510759051704211, -3.1143465759170246],
            [6.501243401682202, -3.114739613903421],
            [6.500624415628127, -3.10895372591576],
            [6.464786777478607, -3.114618195751093],
            [6.469268426087059, -3.119940074861378],
            [6.470236223121989, -3.1268636597307498],
            [6.462895700493545, -3.122038363461921],
            [6.4607508728294345, -3.1151269076569617],
            [6.445735521432921, -3.1214528333122225],
            [6.432917158820483, -3.1292071378549373],
            [6.406573841012319, -3.1407217979383564],
            [6.399788201738687, -3.1506988791997834],
            [6.390398326374375, -3.1628544074726355],
            [6.391734791586036, -3.1687361763113473],
            [6.392344763448922, -3.177582586647725],
            [6.389733986985388, -3.1777862194023507],
            [6.3902267650081255, -3.1841492279309644],
            [6.393005518325864, -3.1825404750849855],
            [6.399339717124099, -3.1819882997911497],
            [6.399578387962163, -3.1850653168515346],
            [6.394773945389145, -3.187040971990111],
            [6.3950243924704555, -3.1905656064684083],
            [6.384801459680244, -3.1913759708447467],
            [6.384298352161388, -3.184799662274064],
            [6.382220976865532, -3.1805015939141885],
            [6.375340546485531, -3.1866649437891015],
            [6.371639969146827, -3.194644768290778],
            [6.365376991236931, -3.217128574085052],
            [6.361633081536948, -3.2398314883486967],
            [6.361281802411692, -3.2483202684745387],
            [6.35409075029362, -3.2486304932681587],
            [6.351890138593835, -3.2594698359502887],
            [6.301833831273002, -3.263251622018057],
            [6.301449403157091, -3.2627990401695275],
            [6.284992140774864, -3.187435432915911],
            [6.284725869480538, -3.1821543004274844],
            [6.281587021350574, -3.1728299877822943],
            [6.261958133795982, -3.148293092797938],
            [6.256070790863038, -3.1420037612417837],
            [6.2427935183712995, -3.129472315474519],
            [6.239846156294107, -3.0858704072138115]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.61353163401823,
          "lat": 35.421761533891505
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47023"],
        "coty_name": ["Chester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chester County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01639732"
      },
      "bbox": [
        6.239846156294107, -3.263251622018057, 6.635983907037447,
        -2.9053375222065654
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.555234001771643, -2.969939518364773],
            [7.566185339674532, -2.9712563641394514],
            [7.587722117560736, -2.963161923218258],
            [7.592274693594876, -2.9643084776966986],
            [7.5958966144604965, -2.9569704456513173],
            [7.599521028564773, -2.951948221973087],
            [7.608682077929177, -2.9496289721937115],
            [7.611820927145384, -2.944482348595849],
            [7.616630931544322, -2.9421251856006205],
            [7.622029720138589, -2.9409988463752663],
            [7.625318370184658, -2.9446752933908846],
            [7.6281623762039725, -2.943768419412198],
            [7.632045815178783, -2.9468049748304717],
            [7.63662994495491, -2.9449028596400413],
            [7.638337884837719, -2.949560872249728],
            [7.6449776276511745, -2.952920203788763],
            [7.650149673708326, -2.950644353932058],
            [7.654977195908811, -2.950903233486341],
            [7.6577379274574175, -2.9528630681782095],
            [7.662953053802592, -2.9526194863494117],
            [7.667394535353076, -2.9571806284889925],
            [7.673931431812481, -2.960723369040526],
            [7.680794276454629, -2.960731203802765],
            [7.685353894739208, -2.9626226467740313],
            [7.690637968293173, -2.9622320927425094],
            [7.697221226467658, -2.9576681385358117],
            [7.7011057316229525, -2.960083994126414],
            [7.702582303567686, -2.96446416510473],
            [7.706543271042561, -2.965081197366823],
            [7.7088592064266255, -2.9730433909249556],
            [7.715844499288234, -2.9753643295273418],
            [7.722177903374331, -2.9752618963125164],
            [7.724552806611696, -2.9779807067175152],
            [7.734302927758698, -2.9772555540078978],
            [7.733240107677318, -2.968652683081489],
            [7.745419561897144, -2.9704298769326747],
            [7.748923367895649, -2.973132707377853],
            [7.754971764057728, -2.971555772500739],
            [7.754400462546385, -2.967605304702903],
            [7.757168357327632, -2.9649904313580517],
            [7.768803354447006, -2.9697196111751096],
            [7.776068113385051, -2.9743890851916985],
            [7.778678392993374, -2.970293571006172],
            [7.785844410391237, -2.9747712142969363],
            [7.784024628443702, -2.979499847047291],
            [7.784396190771476, -2.9935326230469745],
            [7.785721702469599, -2.993810701278816],
            [7.7857433157747735, -3.0050417916098837],
            [7.788335269230966, -3.0100566874019186],
            [7.788698955301358, -3.0189280615966583],
            [7.794091646899481, -3.017818004168805],
            [7.793365280629351, -3.029508929348056],
            [7.803108598284352, -3.030662802889961],
            [7.801595664086947, -3.0339876048029595],
            [7.801043376884202, -3.040922360504877],
            [7.8091111987630635, -3.042881728393923],
            [7.8096076527230585, -3.055683820226012],
            [7.804920754570972, -3.055931612513732],
            [7.802783204381995, -3.059112674763671],
            [7.804265346039741, -3.0629033337996883],
            [7.808027632354402, -3.066667750190577],
            [7.811235679174615, -3.0641318234557713],
            [7.822774164860453, -3.064138881968336],
            [7.822793907638716, -3.0693984244919403],
            [7.82487920115135, -3.0727735729612498],
            [7.84301564977659, -3.072615333861931],
            [7.843519032211375, -3.0772140590387673],
            [7.847309217130937, -3.078183890494947],
            [7.846159080570116, -3.07077939004604],
            [7.849401949033244, -3.0677789801370507],
            [7.849158274766353, -3.0612555430273227],
            [7.85653361014968, -3.055107550244017],
            [7.8590275589079575, -3.05657020727624],
            [7.859095906835308, -3.0666133900284986],
            [7.8639490105157615, -3.066962655374421],
            [7.8634378797715865, -3.070345717552197],
            [7.867608944980361, -3.0722675716184162],
            [7.870035554690772, -3.080534322268608],
            [7.8728009146366675, -3.0813813326984896],
            [7.875847807774979, -3.111142713957884],
            [7.881205752561696, -3.1831173337233283],
            [7.889130950612466, -3.293357120820548],
            [7.895801417811178, -3.3843210678238074],
            [7.87488962389003, -3.3861429682696884],
            [7.763115021549604, -3.3936210780619414],
            [7.754081243745214, -3.394435579669561],
            [7.690211512419223, -3.39891482935159],
            [7.592316130852224, -3.405677125077994],
            [7.581536298149538, -3.406368311999101],
            [7.581767283337066, -3.403563105573853],
            [7.576399375743043, -3.3567354338395514],
            [7.577482898904431, -3.3097439861584963],
            [7.581748377949775, -3.3096283835495544],
            [7.582144855737948, -3.300530609942879],
            [7.577628085977497, -3.3003206373965717],
            [7.578136303368417, -3.28131065938041],
            [7.5875240106066055, -3.282120021252681],
            [7.588423498657834, -3.2705306013136926],
            [7.581201889767072, -3.2700417257949925],
            [7.58270932547894, -3.251525571643918],
            [7.587850196541235, -3.2517267153971208],
            [7.588189416288179, -3.2438397338067406],
            [7.5867805165837146, -3.240725780319442],
            [7.582278596768261, -3.238389002829173],
            [7.573457569785289, -3.2390582190289288],
            [7.57362295494543, -3.236289879795657],
            [7.568658263147929, -3.236105971299246],
            [7.5673665757642175, -3.2317277290805464],
            [7.568847403867449, -3.2225598405204985],
            [7.569046481677135, -3.205961897111948],
            [7.565941963380722, -3.2053135131423796],
            [7.566044075350465, -3.2011884475647996],
            [7.573173756232157, -3.201249789378133],
            [7.573761508668203, -3.1949049947526045],
            [7.5670285624009335, -3.195010357972759],
            [7.5673251203318745, -3.1866988784969905],
            [7.569101504976609, -3.182765643059059],
            [7.568972413404492, -3.1767156420627782],
            [7.56433165709441, -3.177159260505869],
            [7.564312789248055, -3.1585469767943675],
            [7.561868815159074, -3.1176283097477646],
            [7.547960142793929, -3.1178572379472915],
            [7.547804944630624, -3.1127791765107786],
            [7.555269434366545, -3.1123532870312576],
            [7.555280202893072, -3.108728675767459],
            [7.561193059166058, -3.108440597629112],
            [7.557372043803741, -3.0577179777577426],
            [7.554808770320746, -3.0320223982570806],
            [7.5532995872384525, -3.0226373266491082],
            [7.553003088303823, -3.0118022579770845],
            [7.553392553294285, -2.9966386646250474],
            [7.555234001771643, -2.969939518364773]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.0347572127473, "lat": 35.2021070231522 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47055"],
        "coty_name": ["Giles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Giles County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01639746"
      },
      "bbox": [
        7.547804944630624, -3.406368311999101, 7.895801417811178,
        -2.9409988463752663
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.311119479625726, -2.0060862796810035],
            [10.315191228312209, -2.0038746676909596],
            [10.316883057109056, -2.0003030620763793],
            [10.315607525979077, -1.9946253171673645],
            [10.308618226550044, -1.9876593491351067],
            [10.29946794075955, -1.967796731713873],
            [10.299940321047622, -1.9623557716935593],
            [10.305647112524001, -1.959934198012682],
            [10.30657071642361, -1.9647639089342572],
            [10.311715071968528, -1.9642077365175608],
            [10.31148096547316, -1.95962988473033],
            [10.3179466188642, -1.9598611519174032],
            [10.317845284018743, -1.9627839152676783],
            [10.322286635538827, -1.970719817942253],
            [10.321283962628552, -1.975502931244851],
            [10.318083320225206, -1.9796594294439551],
            [10.321192401437603, -1.9850459539546976],
            [10.326492495363029, -1.9871685379384227],
            [10.329714724628746, -1.9868909306594806],
            [10.33743641783436, -1.9826605397432087],
            [10.338580732609111, -1.976653079543002],
            [10.337116922397767, -1.959568084595721],
            [10.327481687218343, -1.955114742613793],
            [10.326370671447025, -1.9512994464525546],
            [10.326299317522047, -1.942152601634733],
            [10.328049252234248, -1.9382613061307041],
            [10.331471255845692, -1.9397467825813135],
            [10.333688194663775, -1.943729735609125],
            [10.337140289579756, -1.9423624075991712],
            [10.340632319111842, -1.937994493302785],
            [10.34250883130662, -1.9384904666332763],
            [10.345781511158085, -1.9455966443695865],
            [10.349589276790335, -1.95017662109283],
            [10.351574353300418, -1.9463363032651346],
            [10.3467399246979, -1.9410841156244654],
            [10.348618308596711, -1.9394340141661854],
            [10.353751937217647, -1.941800184223248],
            [10.356821989532857, -1.936750117640123],
            [10.354021564532644, -1.9289586470198408],
            [10.354350032508302, -1.9192123493257494],
            [10.35547502249707, -1.915240248305258],
            [10.360640955294738, -1.9121867351037931],
            [10.362899688964365, -1.9152255008801322],
            [10.362710370110522, -1.9217355858912482],
            [10.364909198716012, -1.9239112271566419],
            [10.36999058161173, -1.922174662790565],
            [10.36936307299899, -1.9172796602718156],
            [10.366934465345825, -1.911662717778932],
            [10.369558370054685, -1.9090165716181144],
            [10.378102471716142, -1.9108403710267887],
            [10.381632525846769, -1.90946044394766],
            [10.382692179922568, -1.9021985571164517],
            [10.37774100247051, -1.8933869184335992],
            [10.376224914786507, -1.8861584246571357],
            [10.379374452091428, -1.8838211023334608],
            [10.382684901213374, -1.8874455243400576],
            [10.383581218183437, -1.8930257229343403],
            [10.385575308666176, -1.8959176409041052],
            [10.39187831783691, -1.8947816400302024],
            [10.39519622867124, -1.8924113300544934],
            [10.399596329691537, -1.8915263059187009],
            [10.402463241092853, -1.8936923006163369],
            [10.403756925336708, -1.9022726614840126],
            [10.406298694217728, -1.9070812273430138],
            [10.410806504992255, -1.9096136491230737],
            [10.413368606223939, -1.907443039708614],
            [10.41440826604944, -1.8967975104491448],
            [10.416168163228384, -1.89300473485018],
            [10.418859097810085, -1.8927847996486589],
            [10.427901521423227, -1.9006976888612797],
            [10.438382362425937, -1.902379981306066],
            [10.445703121014828, -1.9003935760481694],
            [10.457697718391033, -1.8910706016373915],
            [10.466934926925168, -1.9095869525477946],
            [10.506868067588474, -1.9054880667796557],
            [10.518331916968247, -1.902851003484295],
            [10.521108747339685, -1.905974569914146],
            [10.521899742529701, -1.912043651335038],
            [10.525989127937471, -1.9148566388672672],
            [10.52686806992253, -1.9099559990445993],
            [10.531494909751268, -1.90954197641184],
            [10.522986813900497, -1.903859557170435],
            [10.53509063448713, -1.9020382737412591],
            [10.569101150373148, -1.907665945926948],
            [10.569964275244471, -1.9057843602650208],
            [10.600067164438, -1.90920879347629],
            [10.616279613241918, -1.914559170781952],
            [10.62986351778386, -1.923076239557491],
            [10.633520107214032, -1.926450303064792],
            [10.646062988057212, -1.9406741880102458],
            [10.649405651355698, -1.9486715485892268],
            [10.65411026968777, -1.9559759070036824],
            [10.648928117664637, -1.9529093723234479],
            [10.644128613275651, -1.953862432523081],
            [10.640274235455454, -1.9570288201854078],
            [10.639186585806653, -1.960941591594072],
            [10.64345249223444, -1.9680002428142027],
            [10.64910935431455, -1.9799602803399403],
            [10.653501686686138, -1.9843539532036532],
            [10.653717767712529, -1.990127547272532],
            [10.64993382717114, -1.996235267434804],
            [10.642074567841961, -1.9991007875430415],
            [10.639750175255353, -2.010026705714478],
            [10.644010881233534, -2.019425803285132],
            [10.643330857509087, -2.0281685935609883],
            [10.646475223060316, -2.0412811097400034],
            [10.645532969197276, -2.045369211139363],
            [10.640603254133739, -2.046780424175645],
            [10.636125729677026, -2.0443047471442615],
            [10.631142533048077, -2.0378941368524552],
            [10.63071495177642, -2.1372463723084234],
            [10.62859452342923, -2.146246913806333],
            [10.622492714817492, -2.148442202310087],
            [10.619071411030271, -2.1532952852775566],
            [10.615578063715308, -2.149218681048859],
            [10.608030076309785, -2.143004478039686],
            [10.601462686021213, -2.139617240567824],
            [10.595395218149761, -2.140109550424292],
            [10.589530798745503, -2.1366435111982796],
            [10.58200207737821, -2.1340631318457897],
            [10.576855205279866, -2.135379196520181],
            [10.574525255553466, -2.138277128266122],
            [10.568357805946208, -2.1414139068742495],
            [10.561591868327529, -2.140760565827608],
            [10.555697834073301, -2.1437050789760868],
            [10.55292168366658, -2.142880859978204],
            [10.551157025545415, -2.1379658232678147],
            [10.552654316419806, -2.1350230754537836],
            [10.552413320869258, -2.1292729470980074],
            [10.550287442516902, -2.126367707882156],
            [10.544003633933372, -2.1255347426755935],
            [10.540060336994395, -2.130565452975185],
            [10.530260411286685, -2.1270842568671595],
            [10.52067690606356, -2.1366245612062182],
            [10.516209793321835, -2.1386640256215603],
            [10.51233401277723, -2.133892564398082],
            [10.508403663646, -2.1344227021926203],
            [10.506682359375962, -2.1408725412048075],
            [10.500995566487825, -2.1399007775173984],
            [10.496572314960435, -2.1420542479972493],
            [10.49464778493354, -2.1364545388809146],
            [10.491082006319814, -2.142176821450952],
            [10.484904526133064, -2.143665769175123],
            [10.482165282336211, -2.1366701511586292],
            [10.477242986346333, -2.1394918410846624],
            [10.47382713868213, -2.1364229315767758],
            [10.473300341192962, -2.1330886487751077],
            [10.465051690554686, -2.131220302363957],
            [10.456445597893127, -2.1310189128578814],
            [10.455748412009791, -2.127706076341628],
            [10.446759289017091, -2.1201940671148045],
            [10.447623621348617, -2.115275202346089],
            [10.442530672061492, -2.1085087951386954],
            [10.438834867997961, -2.1071265900099214],
            [10.382629077106047, -2.073581993661805],
            [10.367247482539437, -2.064770380738888],
            [10.362594537594086, -2.067515185815518],
            [10.359687512860274, -2.0626052115296662],
            [10.357748315271802, -2.062338296277632],
            [10.325436510081905, -2.042331960107089],
            [10.32389866890143, -2.0493347729804325],
            [10.318835672176656, -2.0499403968496055],
            [10.311980526180719, -2.048799844446984],
            [10.309199710789379, -2.0392660245726715],
            [10.312223539153404, -2.038133395541983],
            [10.311762512255719, -2.0339578566431666],
            [10.300799606435927, -2.0339245592230197],
            [10.300317415612795, -2.0310069812347535],
            [10.292481574474996, -2.0312366170124205],
            [10.294226616756456, -2.028214312199647],
            [10.292651723694638, -2.024898780414692],
            [10.286287252285483, -2.0188505758473854],
            [10.280503954521956, -2.0090767014595796],
            [10.276563209549956, -2.0040289441066803],
            [10.275831236716717, -1.999582298082581],
            [10.27716847616597, -1.9965939121653014],
            [10.28394244498524, -1.9937204134240623],
            [10.290366065737304, -1.9945050449467514],
            [10.305181496040241, -2.005607179754809],
            [10.311119479625726, -2.0060862796810035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.44625957775222, "lat": 36.05101606492865 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47089"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01639759"
      },
      "bbox": [
        10.275831236716717, -2.1532952852775566, 10.65411026968777,
        -1.8838211023334608
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.606977865125314, -2.5373435384073217],
            [9.635304748648588, -2.534163964986352],
            [9.636816293375048, -2.545493936745524],
            [9.650696748558756, -2.5436626868994545],
            [9.65110136533387, -2.5471341466850292],
            [9.658362974007249, -2.546380781613482],
            [9.657432491837694, -2.5390585165059334],
            [9.664395228430093, -2.5382949057306705],
            [9.66515874056087, -2.533703247086435],
            [9.675853410467518, -2.5401575708870516],
            [9.677459752265884, -2.5441679100960495],
            [9.684049878935314, -2.544833752090622],
            [9.684634244558314, -2.548750514580479],
            [9.687537509356076, -2.5503451728018356],
            [9.68809082334159, -2.553978299109144],
            [9.67361185101804, -2.5549178616711505],
            [9.674565904790352, -2.5626036424264047],
            [9.686304304482961, -2.5611463752122834],
            [9.689139168533927, -2.564860318817859],
            [9.691835987156198, -2.5865135170488895],
            [9.706109250414137, -2.5847635919861434],
            [9.70704203441996, -2.5921835293542546],
            [9.711981596937077, -2.599356422138753],
            [9.735581237973243, -2.640898004070909],
            [9.748740563495227, -2.663413852608695],
            [9.761011889709218, -2.688888801649816],
            [9.770419209036067, -2.7022364218156416],
            [9.769271040629738, -2.705197032847891],
            [9.76352206573635, -2.7059918272859966],
            [9.764164942954192, -2.710585705965224],
            [9.771494489925466, -2.709430475327378],
            [9.779626925603358, -2.7184877032868653],
            [9.780349784865631, -2.723960063507439],
            [9.777256713205244, -2.7245784487089715],
            [9.780727386150106, -2.741560095363785],
            [9.786322035918777, -2.7409172283819885],
            [9.789175211227734, -2.7449239322298724],
            [9.790162662130722, -2.7513363130302526],
            [9.786552425745393, -2.7519145828921068],
            [9.787073621749837, -2.755505718615574],
            [9.790669874986897, -2.7549646893404622],
            [9.791466449223613, -2.7614662888465022],
            [9.801130975994873, -2.7612883862007456],
            [9.80560880560008, -2.7632855438041846],
            [9.812171536732032, -2.817406272655976],
            [9.819152591784508, -2.8165493585308337],
            [9.820537526262195, -2.83049437505636],
            [9.812887572055246, -2.831229082396431],
            [9.77985072613244, -2.8469853082267402],
            [9.771188632223101, -2.8572026614067325],
            [9.764274673794604, -2.862809937691679],
            [9.759403730863358, -2.8693057430738675],
            [9.757747093600736, -2.873619883709825],
            [9.750145757739856, -2.8846587746900267],
            [9.7434738554878, -2.8948062246358797],
            [9.737603019879353, -2.9015064495174605],
            [9.735907957664857, -2.905670051297971],
            [9.648472586379382, -2.914800306739698],
            [9.614459030266062, -2.9186748542351015],
            [9.612744572783704, -2.921446059393171],
            [9.608516014693977, -2.9339570432153095],
            [9.60136331255554, -2.9349284860358056],
            [9.602237265922067, -2.9419395748667383],
            [9.594835907572397, -2.9427330338097675],
            [9.588298617109974, -2.9492250939381495],
            [9.586358056283155, -2.9469068781241887],
            [9.582947111583724, -2.9474981670246785],
            [9.580013353182629, -2.942577106106555],
            [9.581075678149206, -2.941028072428038],
            [9.58919722720677, -2.9410509735076116],
            [9.591484844073097, -2.936538054892756],
            [9.586233322171578, -2.9314827445339753],
            [9.580224535684808, -2.9289524167340595],
            [9.575747583254689, -2.9296888005476833],
            [9.565132020960878, -2.9381155083634205],
            [9.556897421245079, -2.937314240315229],
            [9.550506841943504, -2.9257732005633477],
            [9.546087833911573, -2.923646017656339],
            [9.546898151405252, -2.918801622484385],
            [9.55320936285985, -2.917050389904133],
            [9.560444945366596, -2.9181928666329826],
            [9.565657032095528, -2.9161786618003385],
            [9.567700972962282, -2.913501322849415],
            [9.56758200520751, -2.9077321792906266],
            [9.565044849858976, -2.90286065236933],
            [9.562420589685978, -2.9013476729904917],
            [9.557728860101113, -2.9023116943593865],
            [9.548261590534535, -2.9069851637052833],
            [9.545610072073526, -2.90730013473249],
            [9.538380480618708, -2.90338079260909],
            [9.534533436735655, -2.898349387700528],
            [9.528315348306478, -2.8936263626279626],
            [9.520821236583489, -2.889888062886055],
            [9.516205842763394, -2.884242736204192],
            [9.502990731725177, -2.8832376884572173],
            [9.499352464183005, -2.881616385488446],
            [9.497350440752433, -2.8736907781188075],
            [9.49318154408059, -2.87183365218244],
            [9.486904590086683, -2.8764303180423436],
            [9.480798459050442, -2.876093765425008],
            [9.473967553048423, -2.8705675519822904],
            [9.468623365235384, -2.8629714413886562],
            [9.459093600739557, -2.8582692875329827],
            [9.449562675086604, -2.855037277612661],
            [9.451724602883493, -2.8490639647039617],
            [9.453293732478503, -2.837758643383851],
            [9.452763221480257, -2.834261912523001],
            [9.454868106164373, -2.8306771890210465],
            [9.458394084411616, -2.819189599926302],
            [9.466349367612802, -2.797869879864818],
            [9.47219399108839, -2.7936280722641986],
            [9.476181739591533, -2.7840250940359916],
            [9.47110766580868, -2.7817686232888086],
            [9.472034209585312, -2.775788146289528],
            [9.475899151973405, -2.7637649083466256],
            [9.483589054198951, -2.763465219509078],
            [9.485909146032176, -2.761770285673231],
            [9.486337646086826, -2.757152146829548],
            [9.482630587512316, -2.75606824141221],
            [9.481740754685486, -2.7513025048054285],
            [9.485129393936107, -2.7503945213923364],
            [9.484040171642764, -2.746047084676734],
            [9.485510678644427, -2.74262891045083],
            [9.488985114979918, -2.7431404077356794],
            [9.491164876647685, -2.7409543725602914],
            [9.49409086750475, -2.7334038644877046],
            [9.498848208233445, -2.733753865529155],
            [9.502160781537594, -2.731534716979763],
            [9.50602612241604, -2.7243775489713085],
            [9.505346780817533, -2.715931184215629],
            [9.507275396192176, -2.711642979925705],
            [9.513428116469811, -2.70939070943696],
            [9.51623234275503, -2.698807264368176],
            [9.520301720990231, -2.694068386409267],
            [9.519412200269093, -2.687968726182048],
            [9.52112964610925, -2.6834978417846567],
            [9.524829304531485, -2.682724226797549],
            [9.531924580202448, -2.672230034135036],
            [9.53772638012293, -2.670784337134542],
            [9.543480820390227, -2.658956115396001],
            [9.546463160208647, -2.656070208945771],
            [9.546693529095636, -2.6528108603133296],
            [9.549839060716135, -2.649057728761919],
            [9.55031724367185, -2.6430697055965897],
            [9.551926737157764, -2.6383474554662234],
            [9.556864850147258, -2.6310078231349956],
            [9.55630857314207, -2.6282583506168384],
            [9.559980987546476, -2.625128812810926],
            [9.561032622753984, -2.608852567745899],
            [9.56541922853695, -2.6086055051341894],
            [9.576305115408372, -2.597228970026174],
            [9.576080411724696, -2.5913221043466357],
            [9.581391592757953, -2.588418222489732],
            [9.581480445011188, -2.5829508367660527],
            [9.588215451176053, -2.568646247018589],
            [9.591614750618776, -2.5579469132110777],
            [9.59456544905692, -2.5575878215173833],
            [9.597199366864407, -2.553657310944856],
            [9.599783822561152, -2.546196310668481],
            [9.59963679079919, -2.5429314905415352],
            [9.606977865125314, -2.5373435384073217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.61741240008416, "lat": 35.42473957085378 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47107"],
        "coty_name": ["McMinn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McMinn County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01639773"
      },
      "bbox": [
        9.449562675086604, -2.9492250939381495, 9.820537526262195,
        -2.533703247086435
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.161543059185876, -1.9318231267757282],
            [11.168332440258506, -1.9134651825852573],
            [11.176432871563515, -1.8904281318900173],
            [11.15974154389931, -1.874643529605761],
            [11.205687535415889, -1.814359565919261],
            [11.236432280991362, -1.803083644057875],
            [11.273026215605793, -1.7987840283546357],
            [11.277486347958142, -1.7980131355917743],
            [11.279911241284921, -1.7942055810646838],
            [11.281405231165783, -1.7881751884848107],
            [11.288329637460295, -1.7879952777685666],
            [11.291223864110302, -1.7822789204813698],
            [11.288525432507614, -1.7764494973207112],
            [11.289195429129732, -1.7715625659488137],
            [11.294873360796329, -1.7610624144141311],
            [11.299816826955794, -1.7578024801117171],
            [11.29906048315854, -1.7542418595379248],
            [11.308081395826068, -1.746214706880883],
            [11.31407995001669, -1.7430053657542395],
            [11.31627252965536, -1.7386116635295923],
            [11.320774405387294, -1.7362291652196313],
            [11.322457483613329, -1.7332155565707947],
            [11.320230442071868, -1.7283320072528623],
            [11.323181764035143, -1.7228416177816104],
            [11.329629986099995, -1.7138905736099788],
            [11.326913645365154, -1.7027216560278668],
            [11.334261681624245, -1.6920187341835042],
            [11.338868042613106, -1.6893717332150295],
            [11.342842404773034, -1.6885214597947638],
            [11.354278861358742, -1.679453775442841],
            [11.383123603920529, -1.684099629725257],
            [11.388938128641747, -1.6916948248207417],
            [11.40821280530779, -1.6992912944538483],
            [11.407880945999691, -1.703111051382097],
            [11.410536788822935, -1.70747675770044],
            [11.405584306094386, -1.7150684040480328],
            [11.40495202575856, -1.720156236621323],
            [11.402397565393771, -1.7236883951005606],
            [11.409830894546518, -1.7239885002580728],
            [11.415937726497033, -1.7256943433474712],
            [11.419093691892428, -1.724623003475537],
            [11.422824482875898, -1.7269343532381234],
            [11.436104675473183, -1.7387618746822617],
            [11.437963858304345, -1.7443013386531503],
            [11.438428138823337, -1.7502491575990904],
            [11.440531354140923, -1.7513697786327356],
            [11.446463692427075, -1.7715074660845989],
            [11.445253273064235, -1.778719030376195],
            [11.437568780808434, -1.7901216719118687],
            [11.43391073835678, -1.7935247208183374],
            [11.430094509882062, -1.8004484720603358],
            [11.425141796805738, -1.7982691921187874],
            [11.41951989097797, -1.7990874238041716],
            [11.416179960705135, -1.8057879945393576],
            [11.413840174908064, -1.8067134417344102],
            [11.409295642130925, -1.8049580482112948],
            [11.404393866220197, -1.80628206027629],
            [11.396185576042187, -1.8004401326302746],
            [11.386212674860877, -1.806372850600656],
            [11.382315144133948, -1.8118311729760976],
            [11.375601571735212, -1.8185127319064907],
            [11.370270945111603, -1.8208618033099058],
            [11.361737414931191, -1.8266371527943792],
            [11.353692881590549, -1.8274948235953883],
            [11.350962824173378, -1.8259527743786679],
            [11.34706047261941, -1.82804567881326],
            [11.343217224746644, -1.833692238008903],
            [11.33917139350676, -1.837297579777765],
            [11.332341958966328, -1.8403634857331892],
            [11.329367966857154, -1.8472137411069212],
            [11.322186484991251, -1.8506951954678192],
            [11.312035206575095, -1.8616359523398762],
            [11.308676889685268, -1.8663998864002682],
            [11.304497347434246, -1.877840363891313],
            [11.278930633780408, -1.947715713851317],
            [11.276022782417382, -1.9494581999325682],
            [11.269296787422133, -1.9569432350060114],
            [11.263194836722608, -1.9601450991910108],
            [11.262670576615248, -1.9642521494804204],
            [11.251160083887374, -1.9774172943999342],
            [11.247692918123718, -1.982894710284878],
            [11.242308953043016, -1.9857090445229522],
            [11.239214086986568, -1.985851319507096],
            [11.234606260914132, -1.989078496381494],
            [11.227965179581973, -1.991297235882802],
            [11.225537643627604, -1.993987686933521],
            [11.219694392491848, -1.9967490257413718],
            [11.21449257583853, -2.001278884761452],
            [11.209464331063787, -2.0125636628926156],
            [11.201583473280607, -2.012002642635035],
            [11.193771823087756, -2.009340490453186],
            [11.192243339012434, -2.0045239300435123],
            [11.189442596904215, -2.003535269972999],
            [11.180611953831104, -2.0039455804348725],
            [11.174197505390621, -2.006647656295539],
            [11.165450910503312, -2.005052645439444],
            [11.164457462376044, -1.9980287386997826],
            [11.166330157466376, -1.987571808732111],
            [11.167908135250025, -1.984421196451557],
            [11.165073346528583, -1.9798811328306671],
            [11.160394094338736, -1.979201651758222],
            [11.157477259558968, -1.9726690995350755],
            [11.157806254394416, -1.96813994553317],
            [11.16158129782096, -1.963936336164067],
            [11.160747051902229, -1.9569231399696354],
            [11.164662385961671, -1.9537191423771654],
            [11.163308319883413, -1.9504472551508443],
            [11.164628410209785, -1.947203640617581],
            [11.172277059741093, -1.9383763909635747],
            [11.170785058548976, -1.9347166045377262],
            [11.162969404408255, -1.9355198599957124],
            [11.161543059185876, -1.9318231267757282]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.43226973642422, "lat": 36.11075312404798 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47171"],
        "coty_name": ["Unicoi"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Unicoi County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "01648582"
      },
      "bbox": [
        11.157477259558968, -2.0125636628926156, 11.446463692427075,
        -1.679453775442841
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.691119019421722, -4.796422454402304],
            [-3.6218133949101285, -4.799670338317255],
            [-3.5970210797725746, -4.800707813704551],
            [-3.4288882729610743, -4.808351766845715],
            [-3.260754611070187, -4.815973073136383],
            [-3.2728259344431114, -5.081692930692614],
            [-3.275978593005826, -5.149245989771609],
            [-3.275897187215574, -5.15233226517051],
            [-3.280679890039239, -5.254722858386963],
            [-3.326994323474414, -5.251878115588698],
            [-3.473528097163651, -5.244931883882251],
            [-3.586543445189314, -5.239589707839552],
            [-3.681798942959816, -5.235392604944786],
            [-3.712457824601933, -5.2337432899841305],
            [-3.7009253464422347, -4.999164686558117],
            [-3.691119019421722, -4.796422454402304]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.77891849214939,
          "lat": 33.616448059758525
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48125"],
        "coty_name": ["Dickens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickens County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01383848"
      },
      "bbox": [
        -3.712457824601933, -5.254722858386963, -3.260754611070187,
        -4.796422454402304
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.31297961941773, -6.2004560934511135],
            [1.317167727273725, -6.200039666625761],
            [1.3234272818848614, -6.201548489233987],
            [1.3253234473540807, -6.200141366424104],
            [1.347058711596819, -6.190156212129234],
            [1.383850864299379, -6.174820711333725],
            [1.3942149869766738, -6.170060320259293],
            [1.4081169433096712, -6.164541895419183],
            [1.423097986576731, -6.157505042763009],
            [1.4522318852157114, -6.145228635416619],
            [1.4893441691197657, -6.0942417467998915],
            [1.4905259635324477, -6.091757070939935],
            [1.502852312778182, -6.075664065204916],
            [1.5121590013093347, -6.074909459383721],
            [1.5123291372030827, -6.0691165896599095],
            [1.520878261169832, -6.071737850457971],
            [1.5250940925271839, -6.077201552346046],
            [1.5285071107564498, -6.079700869747881],
            [1.5355154016872696, -6.080616546580697],
            [1.5397903181260348, -6.077390323642584],
            [1.5428793488857608, -6.07696860995642],
            [1.550420574879706, -6.082618038011164],
            [1.5518762598302525, -6.196383522087727],
            [1.5528032851649396, -6.267090433063828],
            [1.5528252349931733, -6.2823701113967],
            [1.553421160294493, -6.312973542078996],
            [1.5609331692663047, -6.307214124779512],
            [1.5631005337484565, -6.308824636349143],
            [1.5681969216135643, -6.307395360515842],
            [1.5786593708915508, -6.31258898286224],
            [1.5753030483856574, -6.315733899057225],
            [1.5770786046971776, -6.320917477826092],
            [1.582598824660821, -6.325267271036719],
            [1.5883363022491, -6.323811878476131],
            [1.5943228437042587, -6.331478378996135],
            [1.6046997152041935, -6.335925886282089],
            [1.621875127277, -6.33524925637186],
            [1.6248501657974632, -6.336184711330075],
            [1.6324543424349458, -6.3357845662890675],
            [1.6394941963714051, -6.333692961868136],
            [1.6422340618163336, -6.3351249329739945],
            [1.6469279788390883, -6.341200229698221],
            [1.6490112417301934, -6.3420029998799725],
            [1.6568803445864795, -6.338353600191878],
            [1.6468344694684238, -6.367827168789791],
            [1.6444765053990469, -6.3673532165178655],
            [1.639294715407873, -6.373461917231825],
            [1.6347498426168987, -6.373357412690687],
            [1.6284197585407119, -6.370527527154415],
            [1.617048625400329, -6.368139388507432],
            [1.6075805567914867, -6.363432149170019],
            [1.5952346992283786, -6.365623588687409],
            [1.5870699750531565, -6.363669623105664],
            [1.5380385182654392, -6.364607120801128],
            [1.498913202059134, -6.364992920288553],
            [1.4405855697842855, -6.365343641220325],
            [1.4116450645238376, -6.365840237974088],
            [1.3912780941557876, -6.367143199163522],
            [1.3522781957892107, -6.366817592639288],
            [1.3160435022183232, -6.366773522259787],
            [1.3152125440046536, -6.366765346697081],
            [1.3139717753422342, -6.2935297052577095],
            [1.3141025639006905, -6.287647146592629],
            [1.31297961941773, -6.2004560934511135]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.81704300804178, "lat": 32.48044289870816 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48183"],
        "coty_name": ["Gregg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gregg County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "01383877"
      },
      "bbox": [
        1.31297961941773, -6.373461917231825, 1.6568803445864795,
        -6.0691165896599095
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [1.3594468254118184, -9.038339255661898],
              [1.3529601098327406, -9.042638264981116],
              [1.351725225316448, -9.035797417028128],
              [1.3549142148398612, -9.034845570732328],
              [1.3594468254118184, -9.038339255661898]
            ]
          ],
          [
            [
              [1.338891388298047, -9.02287632774019],
              [1.344462504029599, -9.022715024972223],
              [1.3528644715136247, -9.026706905264666],
              [1.3552697700348493, -9.029638619492834],
              [1.3536570219480062, -9.033124926621372],
              [1.3498345470538455, -9.032757476241523],
              [1.3454678719324988, -9.02984538307464],
              [1.338891388298047, -9.02287632774019]
            ]
          ],
          [
            [
              [0.6336909506638903, -8.639921973053037],
              [0.64639638139314, -8.637958741293662],
              [0.6487682997402755, -8.636017206510182],
              [0.6515110736528043, -8.63905307163709],
              [0.6561181749547648, -8.640311593131317],
              [0.6586222824211484, -8.638788225683918],
              [0.6615355009173091, -8.64242715803324],
              [0.6669576127526868, -8.641507325096505],
              [0.6703424046184491, -8.643491636306155],
              [0.6716670141211544, -8.639706914007517],
              [0.6801330705977048, -8.634530772800334],
              [0.6877506707066805, -8.633825544164365],
              [0.693171403234611, -8.636392488926525],
              [0.6991008158019915, -8.633968388864247],
              [0.7030376678084004, -8.630184458376158],
              [0.7080036184434173, -8.630565984687495],
              [0.7098672184425062, -8.627664851451774],
              [0.7182182764320982, -8.627490199912044],
              [0.7218474700158917, -8.631396267076656],
              [0.7308756817203629, -8.631029159430133],
              [0.7352831940974357, -8.623009967642936],
              [0.7405904846123816, -8.62399926252957],
              [0.7479253007021204, -8.628577868963905],
              [0.7509153601936734, -8.62750139134466],
              [0.7511931661937582, -8.624213709096502],
              [0.7554884123719237, -8.621674257182324],
              [0.756073092386093, -8.61849428978419],
              [0.7614285734394449, -8.620854249091886],
              [0.7638865968489672, -8.61620422976836],
              [0.7693964753683226, -8.610906257586654],
              [0.7754038681838942, -8.6075880338837],
              [0.7773064322778188, -8.603680976833196],
              [0.7844153610829351, -8.602179588199013],
              [0.7889825844965248, -8.602750924583502],
              [0.7873822111373904, -8.59802847483193],
              [0.7891519377129442, -8.594363075612675],
              [0.7975536661651061, -8.594559426311346],
              [0.8069880283007085, -8.597119027475127],
              [0.8113758974278833, -8.59637501551929],
              [0.8194723253398722, -8.592077229602328],
              [0.8227754492457738, -8.58341299152284],
              [0.8258841009670995, -8.58008929533292],
              [0.8285756040683434, -8.579876498665804],
              [0.8351356124891407, -8.576258906305481],
              [0.8350852980069987, -8.572623042149415],
              [0.8391508360664637, -8.569360735529697],
              [0.8434329251820862, -8.571670296308223],
              [0.8455630097884632, -8.569467144035597],
              [0.8452997924182939, -8.564535891642814],
              [0.8509945432963978, -8.559479882540368],
              [0.8567366028819923, -8.56095119008086],
              [0.8583192408059082, -8.559566189027544],
              [0.8699147068951408, -8.564128907322255],
              [0.8747697491144762, -8.568467097317717],
              [0.8744162280478617, -8.571119730667197],
              [0.8785805452555767, -8.576184820477629],
              [0.8874433085778732, -8.581467337388787],
              [0.8895367526392589, -8.58397763386081],
              [0.8956727055769617, -8.587115469916489],
              [0.8972937106609178, -8.594233111576168],
              [0.8992415285637265, -8.597654682859451],
              [0.897577672401843, -8.603570337244205],
              [0.8987707737870366, -8.609414439627525],
              [0.9027936518174183, -8.614360339837878],
              [0.903178453416719, -8.618418407053294],
              [0.9061890185605286, -8.621383345912518],
              [0.9093135338318351, -8.621299321114074],
              [0.9175570774588943, -8.625856179608594],
              [0.9297300295562893, -8.623411807992259],
              [0.9356789324494255, -8.62435633143733],
              [0.9373052329395772, -8.620843463606846],
              [0.9413125375505276, -8.61926619708415],
              [0.9459120032542915, -8.61995837098553],
              [0.9502403684653992, -8.618793619646372],
              [0.9513573277798192, -8.616327847539317],
              [0.9611427061389185, -8.61346602625468],
              [0.9656650061654642, -8.623778590585049],
              [0.9729820067827851, -8.630766870357006],
              [0.9711389180834203, -8.633530231015174],
              [0.9740881316183538, -8.636007815762643],
              [0.9802751990974629, -8.636938723052545],
              [0.9835499976588417, -8.642695481225077],
              [0.9895060513735953, -8.645757383586103],
              [0.9954067834554549, -8.64069704451515],
              [1.0001840014813876, -8.640958359580237],
              [1.0045221095006163, -8.642756624852463],
              [1.0049798534447492, -8.648029796302717],
              [1.0123702170965228, -8.651616152282184],
              [1.0259208779647142, -8.651753242500394],
              [1.0315159863789112, -8.659729026059727],
              [1.0358420149943477, -8.66190073024289],
              [1.037462235548141, -8.66512526247107],
              [1.0434920428174883, -8.665403123951839],
              [1.0455047798491064, -8.669787709320632],
              [1.0518153917599238, -8.675005920790442],
              [1.0551123961111857, -8.673878941686505],
              [1.0607075534018813, -8.681969721764998],
              [1.0579604386466146, -8.691521260796442],
              [1.0595498069792626, -8.694584809409617],
              [1.0642343483885048, -8.697638852627252],
              [1.066532770387894, -8.695394496014016],
              [1.0714725745622877, -8.695997858526328],
              [1.075149317048657, -8.699402037193197],
              [1.0836756552668323, -8.696688609016352],
              [1.0941432836472997, -8.694812668475384],
              [1.1000735324027076, -8.695094083574858],
              [1.1216671554654603, -8.675131636654573],
              [1.1587647800968075, -8.639935433078684],
              [1.2137323465563268, -8.588647444413619],
              [1.2435678942263408, -8.560078102883443],
              [1.2644087821007368, -8.622760495730828],
              [1.2650044012117936, -8.62340321684955],
              [1.2894811449167218, -8.696259185634242],
              [1.301913052680697, -8.731646527036801],
              [1.3056906187142985, -8.728229159855593],
              [1.309896620670969, -8.728018261733332],
              [1.3290512028269281, -8.733349671384588],
              [1.3331288046028187, -8.745057250268344],
              [1.333012705373589, -8.74666236120422],
              [1.3416259487986595, -8.75180604124231],
              [1.3423396228543973, -8.756261745380344],
              [1.3446826562687917, -8.759473282267262],
              [1.3455774885970189, -8.768560022361559],
              [1.3399625448980923, -8.771315260578962],
              [1.3363905712880033, -8.783300560536526],
              [1.3340348963868789, -8.786704541517738],
              [1.332891005384451, -8.793898355100808],
              [1.3357433550641171, -8.796173404070752],
              [1.3308248961618119, -8.804119491533926],
              [1.332756106785549, -8.80574632546131],
              [1.3402839146193124, -8.818892142008949],
              [1.3433570064417442, -8.829226261266248],
              [1.3421146673018796, -8.832904762265633],
              [1.3460954177199858, -8.839066820013871],
              [1.3506179164252028, -8.846228530003236],
              [1.3500127503692247, -8.85494267206844],
              [1.3538944085796436, -8.859817213102657],
              [1.3598180568565565, -8.864824789292568],
              [1.3703425923187706, -8.867242510932426],
              [1.3758072792927991, -8.871836479118201],
              [1.377334810607579, -8.876811408661602],
              [1.3872498968819225, -8.888049640144759],
              [1.3940739198289451, -8.888567045289117],
              [1.407141636820856, -8.893209784561543],
              [1.4098787116390379, -8.896500950375026],
              [1.4077780994980573, -8.903761174769551],
              [1.4100961979342337, -8.90693134511706],
              [1.406748110667723, -8.91305056853068],
              [1.403542361708678, -8.915392275301985],
              [1.402958381329298, -8.918517995211316],
              [1.3977158424430285, -8.91948342296321],
              [1.3981660030263263, -8.925156947476246],
              [1.4008517335235413, -8.928072815093625],
              [1.4023022531421552, -8.932618759743042],
              [1.4004813399384075, -8.940585098902009],
              [1.4005125823419557, -8.946166842197542],
              [1.4056292490588354, -8.952248691721929],
              [1.4014184712592614, -8.956809374952455],
              [1.4026603328483904, -8.96029644269375],
              [1.402208905037944, -8.965170436577452],
              [1.3978510069666303, -8.966058462919111],
              [1.3923367474433415, -8.971321835268947],
              [1.393790299407337, -8.982421538840269],
              [1.3881928141534114, -8.988580513742386],
              [1.3825131849764114, -8.996459375477107],
              [1.37919933319998, -9.004834399233648],
              [1.3826225027074113, -9.007770296835378],
              [1.388242271479123, -9.005792178786296],
              [1.389490056679775, -9.014450617351185],
              [1.3918491370777764, -9.01636319918657],
              [1.3968103216119434, -9.017041142636456],
              [1.392857567130529, -9.023327211104304],
              [1.3968100445265035, -9.023842438089055],
              [1.3980891625668106, -9.021499149151548],
              [1.4050864988381777, -9.022138970545452],
              [1.404702722664573, -9.02439718628003],
              [1.4001107666436465, -9.027333044929813],
              [1.401694061769805, -9.033617263887098],
              [1.3949411215650844, -9.039782131595578],
              [1.3924291386843686, -9.046673577986857],
              [1.3898117451385412, -9.041925841901158],
              [1.3872596554933065, -9.040132160027495],
              [1.3875441955248033, -9.027996612492073],
              [1.3817640664374393, -9.02304668487886],
              [1.3615223508151815, -9.020744959704718],
              [1.354529161357044, -9.018528342725865],
              [1.3506429834135727, -9.012245535206715],
              [1.34215450979237, -9.012242335401625],
              [1.3406457998144958, -9.00806833056714],
              [1.3381716014254568, -9.007992484167758],
              [1.3339425457895473, -9.01260200127985],
              [1.3288228250834535, -9.0093388825401],
              [1.3201991606296835, -9.015355717040878],
              [1.3148392821278923, -9.017240529290254],
              [1.3154855558220522, -9.020425597529904],
              [1.3201813794145312, -9.02250401954712],
              [1.3313769522571441, -9.024586060525818],
              [1.3406766068139608, -9.03530149692684],
              [1.3428904528656964, -9.039665132045736],
              [1.3471166287667231, -9.039110744172065],
              [1.3477167670227639, -9.044077102390743],
              [1.3314384890738897, -9.056230840511],
              [1.3223539350656748, -9.0710780663955],
              [1.3190270105066875, -9.081331433390094],
              [1.3194879970105136, -9.088247272118243],
              [1.3253419372899653, -9.09691210886093],
              [1.3424871919630252, -9.110586419635663],
              [1.3480459524763266, -9.11867505116909],
              [1.3442360622432932, -9.122982770201395],
              [1.3435689054664328, -9.125933853074425],
              [1.3388115241843772, -9.129505494056252],
              [1.3384131704770845, -9.131519382657947],
              [1.3296905023371342, -9.140355847466818],
              [1.323360198483744, -9.151263869249116],
              [1.3176270047644512, -9.164870223292544],
              [1.3152811415237988, -9.16820979522272],
              [1.3186891241339718, -9.170980920268711],
              [1.3134848118994689, -9.170291676388064],
              [1.3085983203865998, -9.172104569848495],
              [1.3078204307917771, -9.167627732072262],
              [1.2970755108060708, -9.16536165569092],
              [1.2900814296873744, -9.161599819092919],
              [1.2775698253324268, -9.161359984022775],
              [1.2740487098261326, -9.162736033897252],
              [1.271687620709491, -9.169453393925757],
              [1.2693872590630206, -9.171875860804796],
              [1.263234620706512, -9.174459506533129],
              [1.2652456403303578, -9.182232324360571],
              [1.2647936246702933, -9.185285452964417],
              [1.2587787156837735, -9.185334865222115],
              [1.2547254479732086, -9.188587857774184],
              [1.2519026272183404, -9.184768967876542],
              [1.249375793810318, -9.186094952680069],
              [1.2523515665105573, -9.194225819676626],
              [1.249135994860894, -9.199603907772412],
              [1.2456999348064721, -9.198724838891481],
              [1.2416044706198373, -9.203153129037736],
              [1.2435704259120954, -9.208633525926015],
              [1.2399541061374235, -9.210338395204847],
              [1.2355341297590503, -9.209166975030586],
              [1.2308924165111896, -9.213002299172146],
              [1.2277957651258615, -9.209648563358453],
              [1.2221018102542198, -9.211648963344023],
              [1.221311306200772, -9.214902868416099],
              [1.2174948513811767, -9.213674720616376],
              [1.210692667224417, -9.213798810896785],
              [1.2045145638854136, -9.221413114112742],
              [1.2011192978967993, -9.219794572616058],
              [1.1976983462359574, -9.221984412372533],
              [1.191425193976297, -9.222166455416158],
              [1.188490923488371, -9.214602851201725],
              [1.1857888325453718, -9.21345344607917],
              [1.1875465378130667, -9.209587365026366],
              [1.1862849527852868, -9.205591286837773],
              [1.1822283735253947, -9.20534482324457],
              [1.1727377878289056, -9.19904634518436],
              [1.1712486402101656, -9.193690347219677],
              [1.1679349569866146, -9.190121689608192],
              [1.169916772809634, -9.185473681784313],
              [1.1649455753166433, -9.18436722660085],
              [1.166416357810678, -9.18048170277364],
              [1.162068156164112, -9.179042031452854],
              [1.1601034673539041, -9.176553540768554],
              [1.1618747466270207, -9.171686974987793],
              [1.1596080696890387, -9.168853344005228],
              [1.1615502594661051, -9.163952590268476],
              [1.1589426363315518, -9.159663262313632],
              [1.1546815036196167, -9.16353264020763],
              [1.1518962593937976, -9.162166304197516],
              [1.1453276217538622, -9.165580141165668],
              [1.1436568170948567, -9.162040087152278],
              [1.1346649016493515, -9.161469822889313],
              [1.1302526129104045, -9.164340874099045],
              [1.1266945760340368, -9.160195372088701],
              [1.1233282148956474, -9.161858095180538],
              [1.1230564064013087, -9.165247990215562],
              [1.112637071633827, -9.167639854850702],
              [1.1117490544904083, -9.164361710201597],
              [1.1138531051683889, -9.160874690601329],
              [1.1075077061182086, -9.147457000204419],
              [1.10809678844584, -9.143759278570531],
              [1.1061620629977107, -9.140893612571102],
              [1.1052629602890833, -9.134921064175728],
              [1.1056752163650152, -9.12897086839508],
              [1.1015596065406603, -9.127542709517392],
              [1.0925768462880867, -9.127394413259577],
              [1.087207731467086, -9.124575544020281],
              [1.082666480794468, -9.124034479752021],
              [1.077859723132683, -9.125862359181939],
              [1.0638084007186583, -9.12742492068385],
              [1.0594811685358225, -9.124521744728959],
              [1.0527619189518014, -9.12583637737111],
              [1.0442131890180204, -9.123714543959183],
              [1.0397604070967221, -9.128756269103407],
              [1.037025410295121, -9.129884079052118],
              [1.03197084628491, -9.137017966789724],
              [1.0263349518032368, -9.137150842218277],
              [1.0229508039366095, -9.135861103689008],
              [1.0195568107137714, -9.137704701196252],
              [1.0130444300256658, -9.137967911310675],
              [1.0061010786524096, -9.134487735001606],
              [0.9957319580015537, -9.137135677154301],
              [0.9912815301787316, -9.141097090387932],
              [0.9885840657271341, -9.140114697842638],
              [0.9820816358356234, -9.141027181442254],
              [0.9705494813028818, -9.139655064775075],
              [0.9643264372076256, -9.142620440620796],
              [0.9287780808308904, -9.123778937457445],
              [0.8412591656635893, -9.078429378753267],
              [0.8064411515988462, -9.060297303813556],
              [0.7657558586109858, -9.034412810623342],
              [0.7501880668746199, -9.024787824889867],
              [0.6977263416806376, -8.99167757368001],
              [0.6615351231319984, -8.968045544642186],
              [0.6146750037641687, -8.938181826350585],
              [0.6024838512532759, -8.898935791038522],
              [0.5877661643200831, -8.85323677827348],
              [0.577222322522923, -8.819379510390096],
              [0.5595672247982444, -8.763761942304425],
              [0.557011656472537, -8.753321329458664],
              [0.5482243591372783, -8.726996996161693],
              [0.5319737678402399, -8.676212045922632],
              [0.5315951105672219, -8.665871355737693],
              [0.5284988646373205, -8.665995569401662],
              [0.4976420331215154, -8.567497612044152],
              [0.5018856365381594, -8.569624784804988],
              [0.5053218266273999, -8.574454433617035],
              [0.5093914544876206, -8.57636735628324],
              [0.5115407445435778, -8.58244392589807],
              [0.5150707613675344, -8.585027148459634],
              [0.5250053994882544, -8.586533373686734],
              [0.531121346097724, -8.59395764290727],
              [0.5405423131365228, -8.602429679524398],
              [0.5459772816207707, -8.604428389705008],
              [0.5481249591460062, -8.607266732779891],
              [0.5539695751903461, -8.608207081582],
              [0.5593071654267656, -8.611261346613043],
              [0.5647079841381583, -8.61065300986492],
              [0.5726373296051578, -8.608255981714532],
              [0.5736329888812367, -8.611856457740528],
              [0.5817237519217977, -8.617799359958383],
              [0.5820039032921688, -8.623305324816641],
              [0.5871304822245491, -8.626018325597812],
              [0.5873795136192346, -8.628419612260636],
              [0.5928508813917476, -8.628120239044797],
              [0.5996212349074915, -8.635294459205497],
              [0.5979079184983658, -8.641157536337754],
              [0.6042432303886658, -8.646754775304323],
              [0.6073428505400632, -8.645105287992246],
              [0.6119642613858765, -8.648241013632914],
              [0.6199298826441344, -8.646887125828012],
              [0.6229425206872596, -8.644669027706763],
              [0.6282823769161655, -8.644666542611215],
              [0.6283690212783676, -8.641793706567817],
              [0.6336909506638903, -8.639921973053037]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.393769187766, "lat": 29.857800589806427 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48201"],
        "coty_name": ["Harris"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harris County"],
        "coty_fp_code": "201",
        "coty_gnis_code": "01383886"
      },
      "bbox": [
        0.4976420331215154, -9.222166455416158, 1.4100961979342337,
        -8.559479882540368
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.95862954802789, -6.298716321352866],
            [-7.8768990508674435, -6.307480438322443],
            [-7.864790909863241, -6.308868267285372],
            [-7.837807758456237, -6.311281927080422],
            [-7.7509082650282455, -6.320366190750254],
            [-7.734884540210316, -6.3226487564267915],
            [-7.626568852459522, -6.333993998031215],
            [-7.518251339520916, -6.345322562731393],
            [-7.4486696019536955, -6.352322016474289],
            [-7.349390813651889, -6.362040640385677],
            [-7.250110648675626, -6.371745282159311],
            [-7.185458663792875, -6.377844341629774],
            [-7.052145858525018, -6.390588315961066],
            [-7.0624049035726495, -6.5051722618744385],
            [-7.063105380984636, -6.505092729943594],
            [-7.073560635319881, -6.625733838327809],
            [-7.076167493797058, -6.661780572277619],
            [-7.076061759415171, -6.670039672573775],
            [-7.080288899053069, -6.728468988465773],
            [-7.123302663998263, -7.224484886916887],
            [-7.13419578015685, -7.342106207132258],
            [-7.138185900926113, -7.3839372014091404],
            [-7.138851282618913, -7.399115454742118],
            [-7.1424553250561775, -7.442598706649114],
            [-7.152491635315767, -7.546620588804646],
            [-7.159991571284314, -7.545861471759217],
            [-7.168414618499531, -7.630072677011013],
            [-7.168525416370475, -7.632953833026957],
            [-7.176834020137501, -7.716316060396256],
            [-7.233731154670362, -7.745307684371865],
            [-7.2366051383104395, -7.739076765690932],
            [-7.235729876262131, -7.731749023222512],
            [-7.236519307637722, -7.72426763602901],
            [-7.235923441220431, -7.711528044461587],
            [-7.241602598802233, -7.708869784778978],
            [-7.2420326105715995, -7.705251096227177],
            [-7.245267161107713, -7.70456562007266],
            [-7.247810902413648, -7.7007289232016],
            [-7.247713429815177, -7.69236680360052],
            [-7.251771097127471, -7.6865130691724675],
            [-7.263994908255878, -7.690317425090903],
            [-7.27294725039641, -7.690227755887915],
            [-7.276110375830898, -7.684032975669048],
            [-7.279160899394725, -7.681695780192598],
            [-7.285668540680596, -7.682150113073587],
            [-7.283639500266676, -7.686663322935015],
            [-7.287376997811529, -7.689086048056723],
            [-7.293259422207179, -7.686633011986378],
            [-7.2937219903971435, -7.681144166243509],
            [-7.298683821061563, -7.682231907771372],
            [-7.299448751863425, -7.6797731644930325],
            [-7.29738795983576, -7.674214881468634],
            [-7.303056114940114, -7.665907568550706],
            [-7.308527558947798, -7.665793600711185],
            [-7.312065783925858, -7.659230496090149],
            [-7.3181171691754665, -7.656076360284723],
            [-7.317053555723833, -7.652590129758457],
            [-7.32026092428943, -7.649368587970966],
            [-7.326402094364101, -7.649481114156269],
            [-7.327042089587647, -7.64413680775765],
            [-7.331912349588049, -7.641770520828205],
            [-7.329976440966321, -7.63616019765911],
            [-7.33416707142442, -7.635158086126479],
            [-7.336439920889682, -7.631773037807123],
            [-7.334222429461106, -7.625996733867349],
            [-7.334494809550741, -7.621870786240572],
            [-7.336916176494757, -7.619009435344411],
            [-7.340001249145736, -7.6217181873473505],
            [-7.343000245599779, -7.619210859027951],
            [-7.341834024921063, -7.614571062850145],
            [-7.349198899538457, -7.615486418399562],
            [-7.349539894646901, -7.613820556705667],
            [-7.359778650359809, -7.609957824590675],
            [-7.361589698382341, -7.607464364158596],
            [-7.369281011318033, -7.610475264682827],
            [-7.3725955041332965, -7.607682827305024],
            [-7.37725603393638, -7.607656595999667],
            [-7.372904329072119, -7.599934464476849],
            [-7.370738810251661, -7.592233174404124],
            [-7.376340032012094, -7.590562179611133],
            [-7.379057001564379, -7.584446501604219],
            [-7.380906357825935, -7.584915162466327],
            [-7.386110105984522, -7.592692395445953],
            [-7.388545742184147, -7.5919593551501725],
            [-7.392396284935075, -7.583382835151639],
            [-7.394708687592191, -7.581806648248814],
            [-7.394967973291208, -7.574801849816364],
            [-7.3988932802514205, -7.573164294454522],
            [-7.402356372114664, -7.566604958686158],
            [-7.40687635761296, -7.570999221509291],
            [-7.408729682656549, -7.570146744042886],
            [-7.416734791786386, -7.575617829805377],
            [-7.422484160812383, -7.571621356126985],
            [-7.42339142962679, -7.567884893894478],
            [-7.420304817817549, -7.563703727113996],
            [-7.417113971637992, -7.564248049031422],
            [-7.413609974505736, -7.559931075565776],
            [-7.419712622638969, -7.551205583431442],
            [-7.425088266665932, -7.555807240594686],
            [-7.429079120321972, -7.557048860879827],
            [-7.430443578921968, -7.552295167381326],
            [-7.440633819836291, -7.55295727923395],
            [-7.443160517420261, -7.555078847884344],
            [-7.448015147835207, -7.555263283781541],
            [-7.450669175275508, -7.558351022326495],
            [-7.455138276444932, -7.5590138013807415],
            [-7.46082163836721, -7.550632091798588],
            [-7.4607684143507145, -7.546323659114976],
            [-7.462692912272429, -7.543655115291966],
            [-7.469690960590802, -7.54410874359937],
            [-7.471384440596432, -7.536474360428348],
            [-7.4735150836460615, -7.533790378605865],
            [-7.477827324293964, -7.533685055264662],
            [-7.478995944583486, -7.527663317497749],
            [-7.481276946651051, -7.524912435152638],
            [-7.48821174912099, -7.525894961681916],
            [-7.48903011581453, -7.531135260235909],
            [-7.494655023791899, -7.5398658592079695],
            [-7.49624165431317, -7.534694203126991],
            [-7.50391312191772, -7.538014897465408],
            [-7.505143385883833, -7.5367173104365355],
            [-7.502249321920706, -7.530455970116487],
            [-7.504929039913382, -7.521469382447665],
            [-7.508507395704387, -7.520242256468218],
            [-7.5134837774440255, -7.521594543549946],
            [-7.511542431389308, -7.516794428918636],
            [-7.5188958721040455, -7.514083356248399],
            [-7.519998254186186, -7.506988818718847],
            [-7.525491028813162, -7.506314928584385],
            [-7.531170913607382, -7.510804129937365],
            [-7.533135997858785, -7.508193232711424],
            [-7.532195349976857, -7.503517062180968],
            [-7.5370248642453515, -7.499504593729691],
            [-7.538006029030994, -7.495166520438334],
            [-7.543438482677899, -7.497483417361241],
            [-7.551884816032879, -7.495350144045377],
            [-7.559323670805804, -7.490016916836722],
            [-7.566924533240962, -7.493802763242007],
            [-7.571751192094585, -7.487838898744341],
            [-7.569204182440151, -7.484781368967196],
            [-7.5657870098482585, -7.483703673841237],
            [-7.563683693261, -7.476194042495487],
            [-7.563049742944593, -7.466845049356457],
            [-7.5684992623277765, -7.4658674104432405],
            [-7.571383870277595, -7.46277472406393],
            [-7.566798450817108, -7.458909244470543],
            [-7.566798853336579, -7.453842989889983],
            [-7.570393289374923, -7.450647328265973],
            [-7.573903634875033, -7.452924825840836],
            [-7.576762656450554, -7.448219381908323],
            [-7.577625216573011, -7.442291421150892],
            [-7.588133248363995, -7.440055114207239],
            [-7.58990795997188, -7.435969507187404],
            [-7.600868342576293, -7.430295827632646],
            [-7.604005008208345, -7.419672658926808],
            [-7.607736760801391, -7.423039465122666],
            [-7.610190933971401, -7.4192275957129485],
            [-7.607263781436822, -7.417193496858916],
            [-7.607294655178364, -7.414117073157151],
            [-7.6206145459320025, -7.412073468654593],
            [-7.620385301882329, -7.407982216168506],
            [-7.622814121583511, -7.403648392556827],
            [-7.627095231381838, -7.403169850980149],
            [-7.628611122078704, -7.398626417806082],
            [-7.636449980797131, -7.392784328403315],
            [-7.6406824787777765, -7.386183178207262],
            [-7.645034687800895, -7.384486950346458],
            [-7.640236523994646, -7.378369282099679],
            [-7.644420378054744, -7.369328012348124],
            [-7.647288431377402, -7.367035276864288],
            [-7.649989858500743, -7.368217034528328],
            [-7.656449229457869, -7.368003752309033],
            [-7.661778288174014, -7.357570197043629],
            [-7.666404401992488, -7.354645410951159],
            [-7.669972847650549, -7.348428494188473],
            [-7.67473985339131, -7.346526823860597],
            [-7.679630329497284, -7.347026123903912],
            [-7.68983125281317, -7.3418127294737054],
            [-7.6953518990925485, -7.332655046158033],
            [-7.696573049739003, -7.327743103447257],
            [-7.699732548460021, -7.321559852112681],
            [-7.698040919666724, -7.314563503628499],
            [-7.700248355023261, -7.310775273304264],
            [-7.704339502815068, -7.309826095600937],
            [-7.7074636635315406, -7.302140432765626],
            [-7.705018205324415, -7.293836151334666],
            [-7.707413555811172, -7.272661970346541],
            [-7.710172835794923, -7.268160140442883],
            [-7.715960321248857, -7.26328682914942],
            [-7.717363202223238, -7.253059292402237],
            [-7.720454854758278, -7.245047174257314],
            [-7.722563182961931, -7.242429331587094],
            [-7.739239420710076, -7.227229771388609],
            [-7.749926906268293, -7.227049770612071],
            [-7.752099272279166, -7.225102674624532],
            [-7.754135441100452, -7.210356310963167],
            [-7.755718044626651, -7.208201393188803],
            [-7.772205358774889, -7.199326509572318],
            [-7.780648931898875, -7.195542208335317],
            [-7.805115280717793, -7.182708213810111],
            [-7.810362738727552, -7.1779794809787685],
            [-7.812333817202503, -7.169178762175217],
            [-7.829459283856797, -7.1522053280749835],
            [-7.831791032786102, -7.1509885245448785],
            [-7.848120841019839, -7.150554852338634],
            [-7.853157616870968, -7.149283851109133],
            [-7.856085650060831, -7.146961370379404],
            [-7.857527542855479, -7.13717818967533],
            [-7.860198149146036, -7.130756943649826],
            [-7.859058988392718, -7.122248461212092],
            [-7.862470597583647, -7.114194193606021],
            [-7.8703607125087665, -7.110121574671447],
            [-7.8881474003158285, -7.079821509031056],
            [-7.900787989060309, -7.062369143266937],
            [-7.9114036209300265, -7.0427930155468905],
            [-7.913630923708472, -7.035073800057338],
            [-7.917013341269388, -7.031360729570331],
            [-7.924755714684809, -7.01783409317204],
            [-7.929514705236026, -7.014662752392202],
            [-7.943016136343535, -7.0147424937903065],
            [-7.94762753171139, -7.011151622248901],
            [-7.951914053269449, -6.996819300520767],
            [-7.955797185095227, -6.990620865285976],
            [-7.967157717167105, -6.990232482940206],
            [-7.97589502219793, -6.988183478445422],
            [-7.98030098651109, -6.982101312532153],
            [-7.9860108747711065, -6.960334773633563],
            [-7.982916208658659, -6.949791012734751],
            [-7.982951320290351, -6.947292831566472],
            [-7.988453709589505, -6.935155595733887],
            [-8.002131818757848, -6.932536938762969],
            [-8.011192233384074, -6.921638234211139],
            [-8.022754260285312, -6.909027342077177],
            [-7.982750381981829, -6.876914913332475],
            [-7.986318779218092, -6.876549440671676],
            [-7.981151984000636, -6.82201119759011],
            [-8.009872647405182, -6.819031881420013],
            [-8.007111474086335, -6.797551956233849],
            [-7.996887622234615, -6.691755949727874],
            [-7.989924699131855, -6.619273659354057],
            [-7.983258092661745, -6.551264846747684],
            [-7.983351179472239, -6.549312532003649],
            [-7.975346637723686, -6.470617962779653],
            [-7.968232205213569, -6.398865063603116],
            [-7.958698846697635, -6.300942610354702],
            [-7.95862954802789, -6.298716321352866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.38647766105787,
          "lat": 31.456258569996603
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48229"],
        "coty_name": ["Hudspeth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hudspeth County"],
        "coty_fp_code": "229",
        "coty_gnis_code": "01383900"
      },
      "bbox": [
        -8.022754260285312, -7.745307684371865, -7.052145858525018,
        -6.298716321352866
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.6358568479219913, -10.851623665182572],
              [-0.6320792613071416, -10.851858783969192],
              [-0.6283148361406763, -10.856125989017722],
              [-0.6317948619736523, -10.858622199004973],
              [-0.6372167517516681, -10.854002048114932],
              [-0.6358568479219913, -10.851623665182572]
            ]
          ],
          [
            [
              [-1.1434881137917159, -10.509823690717875],
              [-1.1174171937896276, -10.515728186350287],
              [-0.9985270610577405, -10.542918185212176],
              [-0.9231515599185856, -10.5599117243985],
              [-0.8990982510189542, -10.526008515434391],
              [-0.8900519875499388, -10.528515502065531],
              [-0.8870883759580845, -10.53021888692494],
              [-0.8840803355736389, -10.537557724352617],
              [-0.8817493051165538, -10.539346906641121],
              [-0.8761562654243307, -10.537523494253765],
              [-0.8703530784972934, -10.531927434972244],
              [-0.8584201746053386, -10.525440741377503],
              [-0.8530364669658452, -10.52350560630186],
              [-0.8471416277924813, -10.52295221402983],
              [-0.8436362724498077, -10.514662155009365],
              [-0.839134874267341, -10.514325066827256],
              [-0.8410233201832897, -10.527060712701985],
              [-0.8400849146162541, -10.533173638146932],
              [-0.8380655283671038, -10.536433977278412],
              [-0.8306375291878896, -10.533999379091819],
              [-0.8270812918012779, -10.531658638428363],
              [-0.8259598538530035, -10.535805897920097],
              [-0.8218142890039616, -10.537598259487881],
              [-0.8204584688311269, -10.542568184165663],
              [-0.8168370689995914, -10.543447734756448],
              [-0.8146527521262785, -10.538923928100827],
              [-0.8107656867232356, -10.540696169756098],
              [-0.8123081864376489, -10.543541904337227],
              [-0.811913368794136, -10.548912712570088],
              [-0.8163548398893992, -10.554237556083248],
              [-0.8169160537706969, -10.557852277405368],
              [-0.8110291728243904, -10.559272048412128],
              [-0.8090919255077412, -10.552583866788758],
              [-0.8049168266923984, -10.553624958763002],
              [-0.7992580799215697, -10.552190647949496],
              [-0.7960817816054198, -10.54922680256964],
              [-0.7956182695079914, -10.556664232086698],
              [-0.8011256998055553, -10.560163881621833],
              [-0.7996580338985891, -10.563365616191303],
              [-0.7987012959952972, -10.574014077515434],
              [-0.7949372780280445, -10.573419860073242],
              [-0.7910276064327388, -10.569347889134217],
              [-0.7797832285993433, -10.572373479212391],
              [-0.7800896234621544, -10.581327208293478],
              [-0.7756894948315971, -10.578989395853325],
              [-0.7748310028828882, -10.571723124359826],
              [-0.7797760790262324, -10.56819221879059],
              [-0.7771583196740752, -10.56087071160781],
              [-0.7660335207932407, -10.562191688175794],
              [-0.7623185493057427, -10.568011094293652],
              [-0.7596950760541284, -10.566833526908551],
              [-0.7577295639997065, -10.561193508405154],
              [-0.7568871259429257, -10.554897291269464],
              [-0.7543689756790637, -10.553868896000326],
              [-0.7524425331139284, -10.557994711583271],
              [-0.7457843079588532, -10.563668159988012],
              [-0.7359332080286047, -10.569152507873195],
              [-0.730907406658622, -10.569308100268453],
              [-0.7276305912830745, -10.57354490725415],
              [-0.7253659642652238, -10.571758683622846],
              [-0.7246633239506828, -10.56240314531036],
              [-0.7195214219790376, -10.562887980854752],
              [-0.7095789846275276, -10.565725706405516],
              [-0.7089001693237115, -10.573077603774742],
              [-0.7034361032444384, -10.566842610900089],
              [-0.7019963598720362, -10.561066781286499],
              [-0.7045510228570973, -10.559328720806645],
              [-0.7081683782185011, -10.56109807203256],
              [-0.7100947108345231, -10.558674622195593],
              [-0.7020416151106177, -10.55555568674908],
              [-0.700309894144415, -10.557233514446189],
              [-0.6945272864083848, -10.572785427444092],
              [-0.6970136053547655, -10.577361141044115],
              [-0.700345689936589, -10.576300707136784],
              [-0.7026910809838693, -10.579639536334978],
              [-0.7008740395211358, -10.583149640990886],
              [-0.6956536580701879, -10.584701082308738],
              [-0.6901268360886724, -10.588534406143737],
              [-0.682899760928573, -10.586604315169671],
              [-0.6827427879477288, -10.579944461116295],
              [-0.6811715902552195, -10.577557962963551],
              [-0.6767636680657543, -10.579238526399998],
              [-0.6753840896516228, -10.58213866765308],
              [-0.6730572968650745, -10.592627223086824],
              [-0.6727473926353175, -10.601184682833287],
              [-0.6713739932262047, -10.602380553027327],
              [-0.6636434279867771, -10.602271114950602],
              [-0.6553332689585918, -10.603811562379772],
              [-0.652324459865124, -10.606644996141979],
              [-0.6544592690064002, -10.610928765593297],
              [-0.6524496542034693, -10.616707587568836],
              [-0.6512291175060382, -10.619234313473383],
              [-0.6285250059057834, -10.654423712577177],
              [-0.5681148521168689, -10.748556039875526],
              [-0.5442726841184796, -10.785844694561714],
              [-0.5462693820599996, -10.789309120256805],
              [-0.5434973416260582, -10.79226753369977],
              [-0.5454867599230966, -10.796305467370358],
              [-0.5499964384970806, -10.795242595875145],
              [-0.5557914130598651, -10.80470729224897],
              [-0.5642527206291301, -10.817294732162658],
              [-0.5677724582113656, -10.820560718729244],
              [-0.5874683780118941, -10.85569927018619],
              [-0.593438144727666, -10.864622789885887],
              [-0.6027390284258252, -10.866456428853187],
              [-0.6159168571346897, -10.864953694115783],
              [-0.6210036448096864, -10.863127876297288],
              [-0.626005400521111, -10.857080739299368],
              [-0.6220774538421531, -10.855280589416411],
              [-0.6197806772811371, -10.8494653588653],
              [-0.6237767896978285, -10.843495097853712],
              [-0.6200008511565073, -10.838951743041514],
              [-0.6207934950219747, -10.837508022159236],
              [-0.6276735926300506, -10.840206392300493],
              [-0.6322024415452125, -10.837609890704007],
              [-0.6355664945460229, -10.830477513602933],
              [-0.637763306437253, -10.828793892563931],
              [-0.6419126501321543, -10.815856268024518],
              [-0.6449887239911027, -10.812202985683902],
              [-0.6574645195693923, -10.807511356228925],
              [-0.6664435282425609, -10.806593172335115],
              [-0.6798454068092913, -10.808383558146096],
              [-0.6976414925029462, -10.813378825091085],
              [-0.7122390402350379, -10.819422959375128],
              [-0.7345408208006453, -10.83098325084655],
              [-0.7382905619459934, -10.83533073577753],
              [-0.7426586419866147, -10.834070958438373],
              [-0.7390095747079017, -10.830188927474063],
              [-0.7321321129191962, -10.825547389663635],
              [-0.7243315637490001, -10.81856275365545],
              [-0.7171410117041919, -10.813560036282045],
              [-0.7232770332764239, -10.803877852813681],
              [-0.729680974781168, -10.803654023864386],
              [-0.7369839394034067, -10.804783236108372],
              [-0.7488866999744513, -10.808151479156471],
              [-0.7510396897845616, -10.809663233915007],
              [-0.7590415938505221, -10.811907918392388],
              [-0.78053972538052, -10.810120481276885],
              [-0.7869470301236824, -10.812264324942918],
              [-0.7928480640680389, -10.81553156634233],
              [-0.8000267094351677, -10.815939929227369],
              [-0.8077150050362548, -10.814330271433205],
              [-0.8162474125209837, -10.81446574333714],
              [-0.8214847165017646, -10.81639836577185],
              [-0.824915374811668, -10.814867427341118],
              [-0.8289097443447648, -10.808005529726637],
              [-0.833268003050483, -10.810201246412285],
              [-0.8291725314266885, -10.818076558942055],
              [-0.8346202782939336, -10.822414211059666],
              [-0.8380304962155222, -10.817942726433913],
              [-0.8416893157910846, -10.822512520292587],
              [-0.8509069796940797, -10.825045092666722],
              [-0.8546839405077402, -10.823753337241408],
              [-0.851399427039095, -10.816196869851641],
              [-0.8592467429870245, -10.805590164381785],
              [-0.8611945795941862, -10.801417735731388],
              [-0.8641757423397918, -10.80387003797221],
              [-0.8718326216165667, -10.807327982637641],
              [-0.8789031532159239, -10.813502968359865],
              [-0.8821413938853019, -10.813471840443038],
              [-0.8859683196762322, -10.823860290660509],
              [-0.8811080231238804, -10.833307161141148],
              [-0.8747760746131814, -10.832684977037331],
              [-0.8654420677665743, -10.835232927977273],
              [-0.8591523241565924, -10.839311128089484],
              [-0.8570817692026492, -10.841810458518617],
              [-0.8595891890592832, -10.844231890895236],
              [-0.8616392469582762, -10.84042630245671],
              [-0.8702895270607126, -10.838380627518955],
              [-0.8729319928861715, -10.841204254148764],
              [-0.8773055499985082, -10.840212495096527],
              [-0.8808722473805012, -10.837652058073472],
              [-0.8904999457822146, -10.83743818400305],
              [-0.8991061700522455, -10.836441065503726],
              [-0.9028200617242971, -10.832250188621146],
              [-0.9054242598285619, -10.825931948616024],
              [-0.9164475570161311, -10.823407144352286],
              [-0.9259095443584487, -10.824365128390822],
              [-0.9324597414318637, -10.822880193543751],
              [-0.9371907742977279, -10.823804137186768],
              [-0.9410998478487556, -10.826452622738909],
              [-0.9470402327646303, -10.827424709243548],
              [-0.9508114293672248, -10.824724704939785],
              [-0.9547725276429049, -10.817317636888088],
              [-0.962435852916853, -10.813676761004992],
              [-0.965266473413163, -10.80766043277072],
              [-0.9640617271834433, -10.799453310385143],
              [-0.964318405863331, -10.793597690854009],
              [-0.9685359086931717, -10.790966224654287],
              [-0.9744744313581861, -10.791647911074993],
              [-0.9796511253667054, -10.788427245936255],
              [-0.9841839789411886, -10.79007046487827],
              [-0.9804898442544594, -10.796427520343551],
              [-0.9790557690340244, -10.802133599343472],
              [-0.9800614131941455, -10.807690818784074],
              [-0.9834490734701261, -10.813019845020257],
              [-0.9900989508469014, -10.817417618467577],
              [-0.9923843764342227, -10.812352094228006],
              [-0.9962396837302565, -10.810313829151642],
              [-1.0031613698701325, -10.810634249787956],
              [-1.0134831954181773, -10.80655858283571],
              [-1.022728752861659, -10.800277734111043],
              [-1.019195705663592, -10.790067734202017],
              [-1.0231322274585004, -10.787901289711394],
              [-1.0283095158441922, -10.781329313033288],
              [-1.0369063254569402, -10.77892729574437],
              [-1.033020589255674, -10.772570432061867],
              [-1.0356343571835547, -10.766354321929487],
              [-1.0451451209302054, -10.764840700433885],
              [-1.0466139749045995, -10.76210636100022],
              [-1.0512273291216323, -10.760584125098745],
              [-1.0588240414535797, -10.765256828859942],
              [-1.0574369771735017, -10.769527617896438],
              [-1.0592693348613207, -10.771187489277732],
              [-1.0652881633012443, -10.76648876379158],
              [-1.0743538328200244, -10.767015829504254],
              [-1.069879644135587, -10.76067559444945],
              [-1.0732545289896365, -10.75749842503126],
              [-1.0782440124441135, -10.75715828870152],
              [-1.0828900334654066, -10.755148167778286],
              [-1.086030295387554, -10.750799892029534],
              [-1.0935578213386439, -10.753899899066376],
              [-1.095283752560376, -10.758930467449606],
              [-1.0976965039952586, -10.759538527306818],
              [-1.1031267137228535, -10.754171059803],
              [-1.0987089613908012, -10.749683944312842],
              [-1.100681712028806, -10.744481034822279],
              [-1.1048040615399437, -10.746492909987039],
              [-1.1108243191173575, -10.744613603821707],
              [-1.1116005953042853, -10.740523821001682],
              [-1.1168812806219444, -10.735333818329353],
              [-1.11974370633496, -10.737593470309516],
              [-1.1282897440785504, -10.739965021872008],
              [-1.129303182924695, -10.744883261247825],
              [-1.1342995222564762, -10.748067907684273],
              [-1.1384225609408827, -10.747127547395477],
              [-1.139106751821262, -10.742335381935373],
              [-1.1370911516666313, -10.737857846608257],
              [-1.1398672997464467, -10.736178841196342],
              [-1.141124196952066, -10.730931140931597],
              [-1.1406815084025184, -10.72451666349681],
              [-1.142479125734267, -10.717995375851775],
              [-1.1471568397515728, -10.713154812031714],
              [-1.1462208489567478, -10.709384942758062],
              [-1.1412879549632549, -10.707870593764735],
              [-1.1374499041443635, -10.70854555261736],
              [-1.1368524022663857, -10.7039172454373],
              [-1.1340307887067114, -10.703462652634053],
              [-1.1322136684608626, -10.697036477510027],
              [-1.1301372135054826, -10.693698612068768],
              [-1.1313924332226872, -10.691083097453586],
              [-1.1299313161941975, -10.687610263147745],
              [-1.127386051573934, -10.680340002708821],
              [-1.1280556811784692, -10.67299695897198],
              [-1.1239266106279138, -10.668955177377283],
              [-1.122195144872559, -10.664656213927147],
              [-1.1251434162709535, -10.659091150393207],
              [-1.1270929722511869, -10.6527969880093],
              [-1.1318702830519638, -10.647990727172814],
              [-1.131668591394826, -10.645755243840158],
              [-1.1355423269274194, -10.642722756439106],
              [-1.1408486714744805, -10.642457946193753],
              [-1.1440656470726838, -10.645172716538328],
              [-1.1510842032639539, -10.644347131422402],
              [-1.155450329021814, -10.64695749234231],
              [-1.160883470040797, -10.646369719212716],
              [-1.1649753667074163, -10.648798658830737],
              [-1.1673556443037503, -10.647217432256236],
              [-1.1769609348318282, -10.64661078783981],
              [-1.1786875247835416, -10.64491439938116],
              [-1.184071040131133, -10.64500493599198],
              [-1.1880809904314225, -10.641611819785458],
              [-1.1902047148319876, -10.642072375845064],
              [-1.1964493635659144, -10.63308312336424],
              [-1.2037044385885933, -10.626220711801334],
              [-1.2044295777323355, -10.623135269744768],
              [-1.2081593124366705, -10.6228842072487],
              [-1.2106159339036544, -10.619725626957752],
              [-1.2144099753212276, -10.621822373860988],
              [-1.2194880244263095, -10.615196734587805],
              [-1.2192355762895384, -10.607318502050857],
              [-1.2142109249159085, -10.607430873285132],
              [-1.217347809762685, -10.601792274423742],
              [-1.2224189797936695, -10.59598887537529],
              [-1.2252550719492126, -10.5953940248192],
              [-1.2255934040195293, -10.590893657762075],
              [-1.2242769935291438, -10.585953515188402],
              [-1.2208090161192975, -10.584326609463929],
              [-1.2161094215673809, -10.58429161989396],
              [-1.2170302650039981, -10.579467938589378],
              [-1.2157520514460503, -10.57036262691188],
              [-1.221092651766471, -10.5697078219486],
              [-1.1932680070713242, -10.548418574175585],
              [-1.1619618184918794, -10.523844434574253],
              [-1.1434881137917159, -10.509823690717875]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.5187464502511, "lat": 28.009234991547267 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48409"],
        "coty_name": ["San Patricio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Patricio County"],
        "coty_fp_code": "409",
        "coty_gnis_code": "01383990"
      },
      "bbox": [
        -1.2255934040195293, -10.866456428853187, -0.5434973416260582,
        -10.509823690717875
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8232269673463071, -5.73738664393325],
            [-0.7989333080285592, -5.737957948249504],
            [-0.7612855883150168, -5.73943142843237],
            [-0.7414836916355427, -5.740608891502746],
            [-0.7018232788752848, -5.74170514040879],
            [-0.5604061690664861, -5.744464097016858],
            [-0.48441827049257513, -5.74594806590942],
            [-0.3956021951760086, -5.747643164826462],
            [-0.39855471058007214, -5.859107887697325],
            [-0.40117333891616225, -5.9575485914054],
            [-0.4016382647241891, -5.980388189069566],
            [-0.4046292732157197, -6.0991261121825975],
            [-0.40685006492764925, -6.188808718068363],
            [-0.4473831644128209, -6.18772813991472],
            [-0.4579117617193328, -6.187114783456401],
            [-0.48328288625641647, -6.186799929024869],
            [-0.522784239354394, -6.185485393005271],
            [-0.5305166745632565, -6.184934859189943],
            [-0.5466871068193869, -6.184757559989974],
            [-0.5929327435210417, -6.183284075872303],
            [-0.6644356099746958, -6.1813452030094975],
            [-0.6693641637517495, -6.180921674131923],
            [-0.708869735051758, -6.180076215383123],
            [-0.7703165481492121, -6.177673347718881],
            [-0.7962431401893564, -6.176858793899873],
            [-0.8357624509589413, -6.176275492946309],
            [-0.8345448714373211, -6.1219866126691835],
            [-0.8343699077847526, -6.120614230117176],
            [-0.832852629703886, -6.050611317107412],
            [-0.8320854733569968, -6.028979442500321],
            [-0.8289812496499401, -5.909759997461784],
            [-0.827688617463485, -5.867933414889286],
            [-0.8273731052669171, -5.8649285370624575],
            [-0.8243338656632709, -5.77860978716888],
            [-0.8232269673463071, -5.73738664393325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.29111704752414, "lat": 32.77192972193189 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48439"],
        "coty_name": ["Tarrant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tarrant County"],
        "coty_fp_code": "439",
        "coty_gnis_code": "01384005"
      },
      "bbox": [
        -0.8357624509589413, -6.188808718068363, -0.3956021951760086,
        -5.73738664393325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.848339800768446, 6.233019813707802],
            [16.829552150200094, 6.323399764474288],
            [16.818157764203956, 6.382661412481758],
            [16.791148069455218, 6.513558521185435],
            [16.785721437317196, 6.542417792007646],
            [16.773948626256562, 6.596342179664074],
            [16.83515232056202, 6.6080016599420235],
            [16.889644890650107, 6.616713500684305],
            [16.921794340637, 6.624703865380957],
            [16.963911237121376, 6.632910124840257],
            [16.964023988421257, 6.618244015088537],
            [16.975623904317203, 6.620920514768113],
            [16.972757782556855, 6.634210973035732],
            [17.04859278821477, 6.649136103729973],
            [17.083133016942238, 6.656473816670291],
            [17.093852319427874, 6.614508393795146],
            [17.07215856371566, 6.616187656632773],
            [17.08374831239081, 6.5593580744164734],
            [17.076261375898763, 6.557904376305501],
            [17.087924203057636, 6.498735821950887],
            [17.094079261381076, 6.468354491536226],
            [17.072740334339922, 6.4638312362127746],
            [17.036717082313647, 6.457884164847624],
            [17.002908337301072, 6.450831877724619],
            [17.002382197837647, 6.449424787771532],
            [17.00657734526535, 6.428987995681647],
            [17.009310310698876, 6.4075600823208125],
            [17.022566487601768, 6.357744397906394],
            [17.020757874486193, 6.35742222108852],
            [17.039653984110217, 6.266181588683515],
            [17.040584591354364, 6.266601362789155],
            [17.10001641414556, 6.277807814411836],
            [17.103309136781977, 6.2659691479272865],
            [17.11545091472957, 6.208388283040113],
            [17.121063768323502, 6.182440374687638],
            [17.12319600623364, 6.176307903886835],
            [17.141074096909044, 6.093941587081962],
            [17.074748820262887, 6.079683743329353],
            [16.989354265792787, 6.061250362451748],
            [16.902060924292833, 6.042522196775324],
            [16.893911768776178, 6.040627719186864],
            [16.870302813781333, 6.092463025852894],
            [16.87211084292984, 6.099199357373017],
            [16.87255658167878, 6.105305027487333],
            [16.86871488308419, 6.110835119326239],
            [16.866579156434458, 6.124681058401],
            [16.87149820224348, 6.125169840636767],
            [16.85832403752625, 6.187686188104525],
            [16.848339800768446, 6.233019813707802]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.09315990576141, "lat": 43.0354213716822 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50003"],
        "coty_name": ["Bennington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bennington County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01461758"
      },
      "bbox": [
        16.773948626256562, 6.040627719186864, 17.141074096909044,
        6.656473816670291
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.842226229116342, 0.03822621091507992],
            [13.847700578515974, 0.042355637838788235],
            [13.85185216722437, 0.04239203444504114],
            [13.860298088818848, 0.03766814416599477],
            [13.867339311671023, 0.03669702672157326],
            [13.872987014525117, 0.03721707756676787],
            [13.877313448950249, 0.03975244803960745],
            [13.87787863794241, 0.04714401516758342],
            [13.874323145513669, 0.054809210095589846],
            [13.984698989629823, -0.0234576340009604],
            [13.992585274580225, -0.0295065887369855],
            [13.99376241047442, -0.03484978898612777],
            [14.006547906918858, -0.04776010420654317],
            [14.021957638342043, -0.05180108879583876],
            [14.025722461957658, -0.04987851580721674],
            [14.032379741906112, -0.054511191489006336],
            [14.038200001014209, -0.052682962911839624],
            [14.045902183568375, -0.053898316601970364],
            [14.047399704097193, -0.0571243043779744],
            [14.044667009974518, -0.06653726595769462],
            [14.049431449146798, -0.07118575863422232],
            [14.048587064347332, -0.0772945348737866],
            [14.055024246005813, -0.0798932235119708],
            [14.055829601975313, -0.08462309578042485],
            [14.061722679065225, -0.07888595980790787],
            [14.065833397537999, -0.07839373903249194],
            [14.065290699259373, -0.07280811475576618],
            [14.071643117131844, -0.072272557057649],
            [14.080959035833478, -0.06588039204292018],
            [14.084112692819046, -0.1131592226961701],
            [14.085374077441863, -0.11538417216451625],
            [14.09067349719601, -0.11853525870402905],
            [14.086688716549812, -0.12360065165369986],
            [14.086625681349934, -0.12640454633835227],
            [14.080723853161619, -0.1300765244236084],
            [14.081209549450259, -0.1338221668837324],
            [14.079220545708727, -0.13791374030503856],
            [14.069682434092426, -0.14593956649718343],
            [14.06748738677665, -0.1502566306989659],
            [14.0649431220415, -0.16293405142893425],
            [14.062008895088326, -0.16975623657630245],
            [14.056500751270358, -0.17767253208330777],
            [14.052962360484022, -0.18515901777818763],
            [14.050961737597731, -0.1917300213051077],
            [14.048452553292448, -0.19529891460588497],
            [14.043622015302807, -0.20572018995600466],
            [14.040373496960921, -0.21626310930254122],
            [14.041857312046893, -0.22311019945376084],
            [14.040848908692928, -0.22651179477380365],
            [14.033757676950803, -0.23055736650450123],
            [14.032068066740614, -0.233875755871494],
            [14.02117293647631, -0.24234908001652042],
            [14.017980841075389, -0.24162204947402344],
            [14.012914943450859, -0.24366131023898335],
            [14.010673353634488, -0.24770362414486113],
            [14.009865946416992, -0.25615763167051736],
            [14.004687036667939, -0.2624240186623129],
            [13.999100238413266, -0.259036533297803],
            [13.989797215095042, -0.26440489281408314],
            [13.980512270176082, -0.2581713649342779],
            [13.97703485537309, -0.25791475877503767],
            [13.970209095072649, -0.2596666422252718],
            [13.967294547880199, -0.2627884864108178],
            [13.961095905335307, -0.2727106382187781],
            [13.953660100561514, -0.2889597083178739],
            [13.95118872361422, -0.29112594952797544],
            [13.938127920285012, -0.2899115077328836],
            [13.927672916436148, -0.2886420984174877],
            [13.911423850957089, -0.28753512726455827],
            [13.90983567622233, -0.282839564589065],
            [13.911223058989629, -0.28027514449431795],
            [13.910543547606334, -0.2731691526576885],
            [13.90391829633592, -0.2622811961328948],
            [13.901512570416472, -0.26053663121984516],
            [13.89098861613822, -0.25928171798509636],
            [13.889398993426589, -0.2578223303051941],
            [13.877147031096918, -0.2566113965455457],
            [13.8668540548021, -0.26389114747237225],
            [13.86476988586952, -0.26299639943433445],
            [13.859093990313875, -0.2660014566766719],
            [13.855182713218683, -0.2634022907380536],
            [13.853756940089102, -0.2595582503164898],
            [13.85288188440233, -0.24924102757760855],
            [13.850229486012287, -0.244058811544468],
            [13.849387146806617, -0.23942116874595548],
            [13.845841752202569, -0.23312130989707652],
            [13.840626137076825, -0.22993962100280432],
            [13.833372228441693, -0.22722602354206792],
            [13.830148638765088, -0.22021874194607743],
            [13.825039948022251, -0.22106119725480397],
            [13.817704164856798, -0.19713489318293603],
            [13.744697934569542, -0.09527844823931078],
            [13.74807116093812, -0.09331891234789616],
            [13.749648052574436, -0.08838776778788791],
            [13.749605223419316, -0.07923417030878672],
            [13.752476273919429, -0.07580936016114037],
            [13.759990540483523, -0.07081633668275897],
            [13.764630730002686, -0.06185999819733521],
            [13.767077357366354, -0.06018076392435877],
            [13.772848557824808, -0.05010865588060673],
            [13.781520410137526, -0.040442061607626305],
            [13.79568411257918, -0.032343621439241695],
            [13.797786097116289, -0.02917796052045385],
            [13.797894578967925, -0.022945136256669798],
            [13.793961990768004, -0.016441842530140964],
            [13.786940363981271, -0.013339402717657012],
            [13.789195427265852, -0.0103647525296836],
            [13.799827588388286, -0.013840033258340281],
            [13.808176162499434, -0.013681994271290486],
            [13.814776994975198, -0.006128745955533967],
            [13.81906355857503, -0.003811098471314371],
            [13.821667575112725, 0.0007677932046689522],
            [13.827127767520343, 0.0058653908519377095],
            [13.828597943064072, 0.012699671883382698],
            [13.821596706647709, 0.02353921790105826],
            [13.824057805829481, 0.02624497327148125],
            [13.827962726877631, 0.027160825567853708],
            [13.834546383323845, 0.026511803119769674],
            [13.842226229116342, 0.03822621091507992]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.81260701901948, "lat": 37.37233292343239 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51011"],
        "coty_name": ["Appomattox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Appomattox County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01497238"
      },
      "bbox": [
        13.744697934569542, -0.29112594952797544, 14.09067349719601,
        0.054809210095589846
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.546095969122213, -0.4902876651078854],
            [12.551352089950768, -0.4855613173174775],
            [12.561970776950231, -0.48028978144979806],
            [12.575164514772219, -0.4714208140942169],
            [12.585307032003577, -0.46747067826410466],
            [12.601545039995662, -0.4602048501052982],
            [12.623625035319213, -0.4460901308156745],
            [12.631676406908555, -0.4387723743012011],
            [12.638864631844392, -0.4337416655465702],
            [12.649885294290014, -0.4200712082623772],
            [12.657169469409274, -0.41294897466847896],
            [12.666240136287303, -0.4017112395968686],
            [12.671251414913213, -0.39654887725494586],
            [12.682681368305266, -0.3858077319509077],
            [12.693194147561126, -0.3805588853204939],
            [12.703089404405919, -0.37311286487530093],
            [12.708861720178755, -0.3676265559255443],
            [12.717745971766131, -0.36149213414948556],
            [12.72753117885341, -0.35363550677060174],
            [12.737021833405693, -0.34337566671456765],
            [12.7421603894377, -0.33411685585774437],
            [12.744996210599977, -0.3306272262444986],
            [12.758253886006102, -0.33782912962175804],
            [12.79101710352595, -0.348360447575779],
            [12.798182693241923, -0.34971144157011425],
            [12.8066820378432, -0.382176248440536],
            [12.825454270728217, -0.40176924028918665],
            [12.859808904876378, -0.4369520098401088],
            [12.861388249910206, -0.44173457726394166],
            [12.868353412516672, -0.4449857398803388],
            [12.87144416804947, -0.44869030451429043],
            [12.872678388678187, -0.453684270598905],
            [12.898682213272918, -0.5462658183276047],
            [12.901625012450161, -0.5659327140417764],
            [12.874484877313964, -0.5850219073357604],
            [12.86535216805316, -0.5897040946696569],
            [12.825156101396686, -0.6141272278111687],
            [12.81287502088336, -0.6332315761286151],
            [12.785701326478918, -0.6742543636990467],
            [12.784606735068026, -0.6794646372793841],
            [12.777347301835364, -0.6820584369324688],
            [12.77191480872215, -0.6828150959178394],
            [12.768506604428215, -0.6818302608432998],
            [12.762419292424173, -0.6861376975035551],
            [12.752132808352647, -0.6847442519592684],
            [12.748260572681353, -0.6904905579365397],
            [12.741390026491855, -0.6938910949987147],
            [12.736959801483845, -0.6894656620176273],
            [12.73292803106089, -0.6875079452130262],
            [12.73168698627189, -0.6941470968822973],
            [12.73725411367231, -0.6996648905040931],
            [12.737032550886077, -0.7063472156914173],
            [12.730103789923374, -0.7082384050706723],
            [12.72824877507762, -0.7058200277602935],
            [12.727576355962487, -0.7000480722531505],
            [12.723217815959714, -0.6962015646420516],
            [12.71803583264565, -0.6955414621281799],
            [12.716987095911788, -0.7011659444707462],
            [12.713219648977018, -0.7060810371540888],
            [12.710673799138931, -0.7034796611491257],
            [12.708788389835282, -0.6950673737830281],
            [12.703690267129568, -0.6930089930950897],
            [12.702976001810013, -0.6975137107879128],
            [12.705382444182025, -0.7005066768409521],
            [12.703696941178778, -0.7028478051683512],
            [12.696663967296997, -0.7047162355701906],
            [12.698894373630885, -0.7124300867054798],
            [12.696077047956118, -0.7163400386868928],
            [12.692010217238058, -0.7142293645577078],
            [12.689943129813456, -0.7160302585650454],
            [12.692652815299642, -0.7224301243064928],
            [12.687990502562133, -0.7240958815036709],
            [12.683947828021656, -0.7201512574754865],
            [12.680539904581012, -0.7197026425706029],
            [12.683260338700446, -0.7303391027121942],
            [12.677405765579621, -0.7321635981377301],
            [12.67354740209958, -0.7320005416071534],
            [12.667877947836715, -0.7294636892007491],
            [12.663616012760388, -0.7233697131176426],
            [12.662409730527434, -0.7186281778629925],
            [12.655441858395283, -0.7115238597833917],
            [12.65049095597978, -0.714619074994758],
            [12.655122893144522, -0.7176139873397884],
            [12.655806905734583, -0.7203173165374658],
            [12.653389613368661, -0.726771626818219],
            [12.650052406103521, -0.7285128414263128],
            [12.648260839888097, -0.7329446537231867],
            [12.640550721499897, -0.7365349027046628],
            [12.637675532438026, -0.7415400675463432],
            [12.624339476593306, -0.7177669250347138],
            [12.621243030023397, -0.7012511485831536],
            [12.620471466389596, -0.6936961456589763],
            [12.614185675389335, -0.6880598095049861],
            [12.610377677866607, -0.6816519581079742],
            [12.611811140365834, -0.6784091911015314],
            [12.61798380260935, -0.6781618104286796],
            [12.623262900185884, -0.6823453295817282],
            [12.62445007920474, -0.6865991779165981],
            [12.62868484219125, -0.6855208726216039],
            [12.627299385879725, -0.676803919559235],
            [12.619697720622522, -0.6749465092239785],
            [12.620957476444444, -0.6703793741818199],
            [12.623612458462532, -0.6689044272919125],
            [12.619517022047395, -0.6633155532227432],
            [12.614383388203018, -0.6617262826561897],
            [12.609110099883178, -0.6462922379644118],
            [12.605805723042076, -0.6544466838627998],
            [12.597570341471435, -0.6519413591050818],
            [12.592022710740753, -0.6415719050173201],
            [12.593139392803467, -0.6377182707785283],
            [12.598007226477955, -0.6371463820981104],
            [12.609038842948895, -0.628218028887936],
            [12.606399448499305, -0.6244803474843942],
            [12.610934203231228, -0.6208271411524952],
            [12.61103043341315, -0.6180365804994665],
            [12.607115157142438, -0.6127401488357305],
            [12.610735928550117, -0.6088478380394889],
            [12.618912635279628, -0.6093717196438607],
            [12.625523290808315, -0.6122483943036012],
            [12.628874177172209, -0.6001012191315596],
            [12.632871974551373, -0.598093807245393],
            [12.632917723096343, -0.5949879938579591],
            [12.637322859370142, -0.5929829208387829],
            [12.635734015269593, -0.5903319868515781],
            [12.640553311260279, -0.5864975901527023],
            [12.63792357386301, -0.5821637534993117],
            [12.636435227548786, -0.5748201221460887],
            [12.63074262607134, -0.5764659611667989],
            [12.625925579870175, -0.5764541784721071],
            [12.626491174994516, -0.5881957444234809],
            [12.624325111907842, -0.5910736804289837],
            [12.625400904145748, -0.5882898869094072],
            [12.6249663967078, -0.5794296634605604],
            [12.620991248186758, -0.5707641300872012],
            [12.617658880832886, -0.5681577643975587],
            [12.611124694867033, -0.570583900734325],
            [12.604852237064327, -0.5713641929255405],
            [12.597798415758314, -0.5598989046906953],
            [12.590240667049157, -0.5554538060042731],
            [12.59072073897549, -0.5478140097213515],
            [12.594205444426455, -0.5433180469914687],
            [12.595816543654696, -0.5382859369622034],
            [12.59987760708535, -0.5349986082116929],
            [12.608622482983272, -0.5315368496093433],
            [12.615951128629511, -0.5331474627474433],
            [12.623551154960442, -0.5303251492928502],
            [12.624880466809918, -0.5234708907658243],
            [12.622847849185186, -0.5196403390787637],
            [12.618148214980067, -0.5172753298857008],
            [12.607821065552445, -0.5200855902482268],
            [12.603927179653981, -0.5228744323505286],
            [12.595329768978848, -0.5262686453382155],
            [12.586575076190567, -0.5319159764973534],
            [12.578704192089337, -0.5423284544745459],
            [12.576760022077224, -0.5463780717899741],
            [12.572531977479947, -0.549508058840165],
            [12.56809028561679, -0.5477116237321781],
            [12.562399149724422, -0.5416308746450307],
            [12.558888772674909, -0.5342992031497564],
            [12.555021278294232, -0.5297871441267872],
            [12.547276819160235, -0.5245966401915227],
            [12.54494377161927, -0.5206019228693932],
            [12.544557620881891, -0.5134767885798938],
            [12.542191769951712, -0.5092254802871103],
            [12.542045546072837, -0.5027967462826602],
            [12.546830933122994, -0.4963747693629541],
            [12.546095969122213, -0.4902876651078854]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.38717675392456, "lat": 37.17432572010145 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51121"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01674630"
      },
      "bbox": [
        12.542045546072837, -0.7415400675463432, 12.901625012450161,
        -0.3306272262444986
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.153650272850932, 0.8462295593244946],
            [14.161029951479323, 0.8426911457894289],
            [14.171462859014184, 0.8403871574906759],
            [14.173254344169518, 0.8349803493117294],
            [14.170787744059677, 0.8321925871418977],
            [14.170059825717557, 0.8276132153612743],
            [14.175320693444883, 0.8265171092036128],
            [14.179966165436827, 0.8200142650321656],
            [14.187010196588734, 0.8190788078926239],
            [14.190504023327586, 0.813466546652852],
            [14.194903671559349, 0.8155783259941791],
            [14.199606073707352, 0.8155650223289138],
            [14.205104633292844, 0.8126577658552375],
            [14.213387771260214, 0.8137727442612118],
            [14.213943504430688, 0.8266062888836382],
            [14.227322297710034, 0.8308717360640864],
            [14.232634808760098, 0.8333512864359763],
            [14.234493472924491, 0.8382974632198845],
            [14.237817852923932, 0.8426543334109666],
            [14.241655364711054, 0.8438920257873205],
            [14.241439423011691, 0.8526246768459206],
            [14.235038244756506, 0.8544030743795011],
            [14.23590972314766, 0.8568550012861443],
            [14.249584009680554, 0.8606103179107577],
            [14.253809561441631, 0.8581547921181112],
            [14.259121928796551, 0.8590611656188097],
            [14.2528806546463, 0.8666936838105284],
            [14.255359962809276, 0.875100963982675],
            [14.258653114819314, 0.8777904579359939],
            [14.260718984795693, 0.8760843817467706],
            [14.261095747209794, 0.8712638006282349],
            [14.264952514886307, 0.8724172808087802],
            [14.266099127704857, 0.8761204954489185],
            [14.278355607000739, 0.8807687129546817],
            [14.27965861878947, 0.8856408822963082],
            [14.285683758776045, 0.887711031789329],
            [14.290301826519018, 0.8982555212054376],
            [14.292632755850203, 0.8987901240438658],
            [14.295834397964759, 0.9051399155733603],
            [14.29391239239912, 0.9106066724989867],
            [14.294796543950271, 0.9126407805844273],
            [14.2996430345166, 0.9137035945906323],
            [14.302897652121214, 0.9189385000872693],
            [14.307575360940431, 0.9200632677202907],
            [14.315968399511933, 0.9145984177616411],
            [14.31795602194187, 0.9188830228484604],
            [14.32115308325692, 0.9203385829583786],
            [14.324616212440393, 0.924975225993953],
            [14.329400862023505, 0.9213398693557772],
            [14.336390722448717, 0.9209152610855366],
            [14.340801427518313, 0.9249620367809479],
            [14.337803019395615, 0.9299704429856476],
            [14.340527157178803, 0.9358617329517404],
            [14.34026551968929, 0.9383035147572412],
            [14.350503318894056, 0.9442948505129156],
            [14.35154258012014, 0.9473959450863373],
            [14.357383051334208, 0.9563122716948647],
            [14.364348831816654, 0.9651088933367293],
            [14.37087976653281, 0.9638117218746027],
            [14.378614983678306, 0.9655209962653571],
            [14.379174208113893, 0.9686139024483358],
            [14.376767491819802, 0.974815024798438],
            [14.378479893676802, 0.9776871847667589],
            [14.384133279546168, 0.9770669610793952],
            [14.39034559006219, 0.9745270628801797],
            [14.394152602154097, 0.9812977644584968],
            [14.400918403745463, 0.9856138856257272],
            [14.415084909344, 0.9900316719780489],
            [14.422826023271156, 0.9982661964814904],
            [14.422950890894105, 1.0094309018880077],
            [14.424719316662177, 1.0121221059293224],
            [14.429320086204292, 1.0131567919299986],
            [14.434007274929497, 1.0189404073344213],
            [14.438448027207416, 1.0192621433671745],
            [14.440262606483046, 1.0169459052729781],
            [14.441944480532845, 1.010659678423215],
            [14.449001682580043, 1.011647163512608],
            [14.464421276086476, 1.0182303323672888],
            [14.468736780980986, 1.0186386746643696],
            [14.474987825160014, 1.0153606117732545],
            [14.477375203507743, 1.0166429536570623],
            [14.47882476973791, 1.0208794397432002],
            [14.484775509253915, 1.022080214956153],
            [14.494671845951757, 1.0202322353661113],
            [14.497418098211128, 1.0213873591883234],
            [14.5049720051283, 1.0200793871757858],
            [14.512291033027749, 1.0155856940324228],
            [14.517959915556094, 1.0148935142083895],
            [14.523314491526085, 1.0109565815292743],
            [14.528408255840246, 1.013266754785728],
            [14.52655502352325, 1.0179394323868605],
            [14.524062126441052, 1.0175563983739573],
            [14.51627583303117, 1.0224479576937735],
            [14.518175252460413, 1.0261568683241276],
            [14.518748043512877, 1.0324706813172622],
            [14.522697377203922, 1.0386180787059858],
            [14.525752649158258, 1.0411663276114484],
            [14.532295193120914, 1.0400651320537566],
            [14.535551379155253, 1.0368993800876727],
            [14.541923124580798, 1.0353101012363848],
            [14.545441927043099, 1.0363808244815753],
            [14.54779296860956, 1.0320953026270183],
            [14.544079260776895, 1.029015943674185],
            [14.548332059653701, 1.0274163490450483],
            [14.553085630627693, 1.0298989902288727],
            [14.557444053999848, 1.0298025975331926],
            [14.564222229268767, 1.0265773584299014],
            [14.571788919339205, 1.0257361914158787],
            [14.57671440675833, 1.0238658335103608],
            [14.583878177023303, 1.0194190689480065],
            [14.582870433651204, 1.0154167089783261],
            [14.57712693447021, 1.0060759270317081],
            [14.579849211037411, 1.0033896619409384],
            [14.57571941617555, 0.9982805460892741],
            [14.579485348082562, 0.9925449311848209],
            [14.57443466521629, 0.9886041616909435],
            [14.572696145592584, 0.9791810499724384],
            [14.563923338567394, 0.9744469869093377],
            [14.564667298661588, 0.9664771764178408],
            [14.561866489003734, 0.9594534911531657],
            [14.553525438868427, 0.9460100090278808],
            [14.54928785785995, 0.9372321058964552],
            [14.545775258927774, 0.9371064784013254],
            [14.54779429341326, 0.9293319250658625],
            [14.540415952086466, 0.9254138109184942],
            [14.534633740908154, 0.9142569477476798],
            [14.537214308323362, 0.9105735052799726],
            [14.53484849387395, 0.9056900563073572],
            [14.526395539171215, 0.8977879554948434],
            [14.517770931480301, 0.883900216163254],
            [14.513947994571778, 0.8712086023701769],
            [14.508326739720397, 0.8714609181276984],
            [14.506627020982203, 0.8682515023714383],
            [14.507425749125835, 0.8637914851260238],
            [14.50274835325915, 0.8559862722096714],
            [14.499643644500697, 0.8538177469888529],
            [14.499780557733024, 0.8469035569476212],
            [14.495566029608105, 0.8434625915100926],
            [14.497044262966975, 0.8403617401027604],
            [14.495046175976073, 0.8373183402437471],
            [14.48499146355301, 0.8369530361642413],
            [14.486958149168702, 0.8333684064399747],
            [14.486075387586249, 0.8223570315067469],
            [14.48257688967731, 0.8196806405416721],
            [14.477596406667914, 0.8082029524276999],
            [14.475548778815122, 0.8079797738257088],
            [14.469178917701313, 0.7964253804166037],
            [14.469328472086962, 0.7906062219250791],
            [14.466125936651261, 0.7910287223198536],
            [14.461175422696117, 0.7821788694184907],
            [14.457634000125914, 0.7828738014962824],
            [14.455140696854604, 0.7657492571079879],
            [14.451108370487109, 0.7642196148410854],
            [14.444558776648453, 0.7533386040337926],
            [14.443776886420732, 0.7445912302557504],
            [14.443091873301807, 0.7423979462911647],
            [14.432467249480373, 0.7410905101600695],
            [14.42692140101786, 0.7437207747087532],
            [14.418431149230631, 0.7391741668666776],
            [14.415344698672017, 0.7399751464098326],
            [14.4094971957361, 0.7460772967572156],
            [14.403787627289468, 0.7493469515093191],
            [14.398442942117809, 0.753930887778022],
            [14.39147317744902, 0.7552911678812883],
            [14.39005457835517, 0.7539204151368574],
            [14.38246146200028, 0.7555815639428259],
            [14.381306507455811, 0.7496269484289013],
            [14.376462008875176, 0.7518642320760889],
            [14.374404987190744, 0.7477902605945428],
            [14.370685417340002, 0.7458060950744618],
            [14.363629741063228, 0.7455210978448195],
            [14.354617801044945, 0.7486985121378851],
            [14.344782354579333, 0.7489317878099738],
            [14.340654059577924, 0.7469863542413969],
            [14.33555218536981, 0.7517673768067316],
            [14.332560956644604, 0.7506406716015787],
            [14.32623872305449, 0.7545007106835688],
            [14.322374473751422, 0.7530887409209515],
            [14.319258967519799, 0.7542033793130354],
            [14.312161216354252, 0.7478012020979519],
            [14.31311678017174, 0.7451194947865938],
            [14.311424109369197, 0.7411276053477928],
            [14.301956182438012, 0.7366622173419821],
            [14.297235802458736, 0.7357570117984417],
            [14.293196137407675, 0.738188399585199],
            [14.288479631461346, 0.7385106719386927],
            [14.285291759926691, 0.7335272928957998],
            [14.28176508599332, 0.7309002438955579],
            [14.276525806902994, 0.7307519669448406],
            [14.27199753857133, 0.7255734318499075],
            [14.270265554043652, 0.7213699650081642],
            [14.26248442743557, 0.7202542803058771],
            [14.258603253028852, 0.7170824239513057],
            [14.240942304531076, 0.7172904174575881],
            [14.166063997542715, 0.7357365678848979],
            [14.128950108429155, 0.7441065227973974],
            [14.10889945042039, 0.7468755600371203],
            [14.115380960886354, 0.7636599232921556],
            [14.153971565342463, 0.8458976276388502],
            [14.153650272850932, 0.8462295593244946]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.01402723328295,
          "lat": 38.246136900141884
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51137"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01494761"
      },
      "bbox": [
        14.10889945042039, 0.7170824239513057, 14.583878177023303,
        1.0411663276114484
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [13.341866158959293, 0.198270360566054],
              [13.34741236788872, 0.19309363719393247],
              [13.344760716092528, 0.18564712096952438],
              [13.3465574366443, 0.18148958430644196],
              [13.349947312539038, 0.1789902161159072],
              [13.360681733452388, 0.19001036229440343],
              [13.36586110735774, 0.19692570400377313],
              [13.367260252893168, 0.20157502811151734],
              [13.371246077309463, 0.20426950490363877],
              [13.372643137454485, 0.20736725847567222],
              [13.365713973564263, 0.21075959248243908],
              [13.359074416653314, 0.21087311337004847],
              [13.351955427620478, 0.2060991852197744],
              [13.346863800238769, 0.20709319451952457],
              [13.341866158959293, 0.198270360566054]
            ]
          ],
          [
            [
              [13.41177539114486, 0.1644499689019899],
              [13.416885595423242, 0.16376139098264966],
              [13.416109900170131, 0.1585472416881319],
              [13.417192349959288, 0.1524350004621098],
              [13.422765431843638, 0.1533851373263554],
              [13.41887039910053, 0.14307371944898],
              [13.421423420469221, 0.13629740773668356],
              [13.417535355614977, 0.13077333766187801],
              [13.422827496169425, 0.1271727933331895],
              [13.426888818557117, 0.12131939804676636],
              [13.434115536096378, 0.12969253726055172],
              [13.437356186595473, 0.14364555580581295],
              [13.44449279496081, 0.1591769468477334],
              [13.446567766071784, 0.1667713958810282],
              [13.449256764704336, 0.16854919016498535],
              [13.447330445294122, 0.17416528448983584],
              [13.449540536127474, 0.17515682060722443],
              [13.446989418685385, 0.19060795199335692],
              [13.444482648387506, 0.18853830557710494],
              [13.43746356601663, 0.1912280232270276],
              [13.43416670492606, 0.18313342471577448],
              [13.427711287369789, 0.1816680174211133],
              [13.424042722775551, 0.1768484124053441],
              [13.423527333654597, 0.1708463622402185],
              [13.41981127429406, 0.171193273088391],
              [13.411871607993753, 0.16772688815392103],
              [13.41177539114486, 0.1644499689019899]
            ]
          ],
          [
            [
              [13.181819289168399, 0.14744470553441566],
              [13.183232245453254, 0.15364352859715144],
              [13.186154880550394, 0.1575821303011514],
              [13.190777446392467, 0.17620815999492276],
              [13.19020784150508, 0.17809761139181388],
              [13.195394290105115, 0.19235977083323072],
              [13.197591668632093, 0.20286312923821148],
              [13.200987445692409, 0.20344528899203923],
              [13.204509064304045, 0.21497169349739098],
              [13.207865709119334, 0.22026549989404223],
              [13.208329212547332, 0.22870089329277404],
              [13.21053044367146, 0.23604276820974973],
              [13.210736838884294, 0.24380212480597674],
              [13.215271962299074, 0.24906503764448779],
              [13.21710963470158, 0.25473885536932195],
              [13.21249460745922, 0.2573062714973948],
              [13.209159879910272, 0.2573170058665696],
              [13.197084372194906, 0.26470069924750983],
              [13.19461752444289, 0.26175015016468106],
              [13.191355139931453, 0.2629262847226586],
              [13.188484902433302, 0.25994889679500655],
              [13.183048255638903, 0.26188104201842666],
              [13.189917554236876, 0.2831767367763916],
              [13.192553405804585, 0.29515802905642374],
              [13.192329492139866, 0.2999867189469459],
              [13.195265527806647, 0.3057496638774114],
              [13.197385292950564, 0.31407568518343426],
              [13.202051972838191, 0.32779829669212784],
              [13.206442870318375, 0.33197249379582466],
              [13.20957770285707, 0.337314960841874],
              [13.214825060643973, 0.3428814926824965],
              [13.219800032081569, 0.35013644347568745],
              [13.23472983849997, 0.3786206970768039],
              [13.239162829011205, 0.3880003656027696],
              [13.243226990332067, 0.4031080103612929],
              [13.247858558318814, 0.4048389211255642],
              [13.247354906014108, 0.410514161781366],
              [13.252478596559792, 0.42430957138486947],
              [13.260100242872644, 0.44007605761352764],
              [13.248876928131278, 0.44420367315946363],
              [13.253106512275028, 0.45320727756729356],
              [13.257945828350229, 0.45624498404058367],
              [13.26468187811539, 0.4709677132379782],
              [13.265920128564286, 0.4762863210570131],
              [13.273107016626128, 0.49443385813669755],
              [13.32596669883562, 0.46688296762125303],
              [13.399459450191141, 0.42867094272829703],
              [13.438009553874315, 0.41017810292059076],
              [13.532889957562434, 0.3642138506667611],
              [13.557465516044921, 0.3448209613277461],
              [13.562531703686782, 0.34082775906717744],
              [13.562940526220006, 0.3356248676962992],
              [13.5650922531183, 0.3316103146367124],
              [13.567881645320513, 0.3312042425778724],
              [13.569507203259649, 0.3257094844112608],
              [13.566813723377555, 0.3220373638176772],
              [13.56943328854016, 0.31734647334734284],
              [13.572764586626024, 0.31602502163429863],
              [13.573686074711665, 0.31191626674380807],
              [13.568266250277961, 0.3032796649935105],
              [13.56879741546816, 0.30042538996886065],
              [13.565638253476877, 0.2919284977476196],
              [13.56915433088866, 0.2891850952286097],
              [13.56756744399127, 0.2761051249592618],
              [13.569625765919897, 0.273881312818009],
              [13.565482640417526, 0.2696484620452888],
              [13.564774429320897, 0.26204314155727393],
              [13.561760752801545, 0.25541023780167915],
              [13.563274901210038, 0.25307857908420667],
              [13.556468763616545, 0.24638714155176766],
              [13.549766915551553, 0.2441672382043594],
              [13.544014923166287, 0.2367670998034399],
              [13.541101580825963, 0.23760692877126283],
              [13.53607735544599, 0.23628510252630255],
              [13.532207031822455, 0.24071490707070656],
              [13.527996534152036, 0.24214018712161084],
              [13.528074087278085, 0.24750955267091096],
              [13.524390416426623, 0.24826990778397848],
              [13.521679287984485, 0.25249450636843807],
              [13.5169291445424, 0.2538629796437933],
              [13.51420191912659, 0.2572540274252524],
              [13.509497354622948, 0.2514940192696209],
              [13.50467872773098, 0.24766400347446033],
              [13.49962063056854, 0.23736473679992587],
              [13.498987490725472, 0.2342867414832465],
              [13.495464229079886, 0.23163697964631572],
              [13.491964135379241, 0.23433736483557266],
              [13.48793112803827, 0.22409971181658367],
              [13.487452280074473, 0.21930062367679146],
              [13.484474678764792, 0.21045830989537748],
              [13.478399198071983, 0.19845151620104273],
              [13.476181232784294, 0.18994281743700547],
              [13.473932666850315, 0.1855210568260929],
              [13.47290003378407, 0.17714208228874664],
              [13.470244866497213, 0.16767936617293255],
              [13.472156676802786, 0.16507314827184724],
              [13.469354633771216, 0.16036891147182908],
              [13.465213026619734, 0.14575298742603734],
              [13.46849228656981, 0.1396632165490779],
              [13.466090312876076, 0.13274739705811978],
              [13.465470497905327, 0.12508111747308187],
              [13.461711625650246, 0.1212253067791695],
              [13.453921240040945, 0.10855286256487026],
              [13.454222250344083, 0.10150438584306196],
              [13.452580416498103, 0.09581941469635595],
              [13.453496118068342, 0.09000891012919551],
              [13.444090131206135, 0.08338799553383436],
              [13.44327917658192, 0.07740847063495873],
              [13.44042092724135, 0.07238674431457974],
              [13.433145264861473, 0.07012638631036013],
              [13.429524866646123, 0.06744806999468962],
              [13.42542894211144, 0.05979567243863384],
              [13.420230344165743, 0.05224845871645848],
              [13.41587878718158, 0.04784339092349456],
              [13.41209605264191, 0.04804049850976704],
              [13.402187043984988, 0.04509576188831595],
              [13.398763170717064, 0.034079836239268475],
              [13.390321937952693, 0.034179460660225765],
              [13.38367828488808, 0.03423129360885756],
              [13.380771420680421, 0.026696425656469902],
              [13.37604541164443, 0.020161490757271146],
              [13.378211404183556, 0.016695414396615996],
              [13.37754193581314, 0.01374785926938394],
              [13.384947715217198, 0.004386086994304522],
              [13.387664463031543, -0.001749268470895216],
              [13.388010453210116, -0.006021387112883784],
              [13.393636615576085, -0.007226606391067541],
              [13.39595398612847, -0.005039756273896387],
              [13.400271239205315, -0.01028302201740131],
              [13.396835401857238, -0.015312242874393079],
              [13.396498102283456, -0.01970363362419539],
              [13.390600713609805, -0.023227767200739595],
              [13.383761605575598, -0.025587109142150063],
              [13.384091797441782, -0.028784366537908997],
              [13.381135652372253, -0.03664509198838527],
              [13.376120775580901, -0.03942205120049502],
              [13.372707550318827, -0.038279699265962884],
              [13.369837984055602, -0.03983761611640657],
              [13.366752670871392, -0.0446217923267291],
              [13.357557723809515, -0.05469133683029128],
              [13.357312379014855, -0.058010960139997875],
              [13.287665715323156, -0.021041325717302748],
              [13.28829944158602, -0.01969243307788957],
              [13.287962243822825, -0.005238244632171789],
              [13.257632455041024, 0.010628887437936326],
              [13.19205514069607, 0.04536754065050396],
              [13.197104659360383, 0.0530802807958935],
              [13.198942752699367, 0.059415331849443365],
              [13.198194990238198, 0.0698175153932732],
              [13.198635562418795, 0.0799329647249233],
              [13.191234003677213, 0.08318703988520036],
              [13.175439826669292, 0.11728698802946372],
              [13.179985386409843, 0.12390249325475967],
              [13.18187679194601, 0.1330773839183777],
              [13.181819289168399, 0.14744470553441566]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.44727127333763,
          "lat": 37.814445439361755
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51163"],
        "coty_name": ["Rockbridge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockbridge County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01480166"
      },
      "bbox": [
        13.175439826669292, -0.058010960139997875, 13.573686074711665,
        0.49443385813669755
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.070233645820851, 0.03679390043877106],
            [15.080412289656936, 0.03415453531642184],
            [15.084252659449453, 0.034736911776859385],
            [15.095054612382555, 0.04053252462215342],
            [15.10312525177264, 0.04304746309140526],
            [15.106787634908404, 0.046864776826500865],
            [15.110134268866211, 0.044715220015317955],
            [15.112607414130428, 0.04204551096045269],
            [15.114570959107455, 0.046977186689224515],
            [15.117691783928779, 0.04977891107432549],
            [15.126693237239005, 0.03872144462502209],
            [15.129572419338228, 0.03815765298548377],
            [15.136863544506458, 0.03324863843485712],
            [15.138378246368687, 0.030300480015623917],
            [15.133129485867993, 0.023459552813875063],
            [15.134227414359238, 0.01840983243349105],
            [15.12711960057106, 0.017012971703120976],
            [15.12292826788791, 0.014067462047511055],
            [15.117599067246914, 0.006481060266514729],
            [15.110472601787698, 0.0032835380167184148],
            [15.10729419124764, 0.0004268722762101281],
            [15.10377933239165, -0.009037802918938844],
            [15.100322892677987, -0.010164074597937112],
            [15.098770242969431, -0.005714570767965543],
            [15.093168110772346, -0.008704216036405338],
            [15.089897248147311, -0.00834442212061276],
            [15.08849771324912, -0.013219038796334768],
            [15.084221506984804, -0.012928324920325963],
            [15.087868802884646, -0.0062566651738060015],
            [15.084009330775947, -0.0027727460609499096],
            [15.083288383357532, 0.0021214330985634177],
            [15.080047297676419, 0.009989887486883816],
            [15.08014795122142, 0.017295129734967964],
            [15.078111219831278, 0.018334281493034357],
            [15.077825389006437, 0.02314106916108661],
            [15.074663554944383, 0.02301330813785399],
            [15.071293080427417, 0.026627777592600297],
            [15.06977612702198, 0.03111240738716625],
            [15.070233645820851, 0.03679390043877106]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.29849039124302,
          "lat": 37.291526698500135
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51670"],
        "coty_name": ["Hopewell"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Hopewell city"],
        "coty_fp_code": "670",
        "coty_gnis_code": "01498428"
      },
      "bbox": [
        15.06977612702198, -0.013219038796334768, 15.138378246368687,
        0.04977891107432549
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.624325111907842, -0.5910736804289837],
            [12.626491174994516, -0.5881957444234809],
            [12.625925579870175, -0.5764541784721071],
            [12.63074262607134, -0.5764659611667989],
            [12.636435227548786, -0.5748201221460887],
            [12.63792357386301, -0.5821637534993117],
            [12.640553311260279, -0.5864975901527023],
            [12.635734015269593, -0.5903319868515781],
            [12.637322859370142, -0.5929829208387829],
            [12.632917723096343, -0.5949879938579591],
            [12.632871974551373, -0.598093807245393],
            [12.628874177172209, -0.6001012191315596],
            [12.625523290808315, -0.6122483943036012],
            [12.618912635279628, -0.6093717196438607],
            [12.610735928550117, -0.6088478380394889],
            [12.607115157142438, -0.6127401488357305],
            [12.61103043341315, -0.6180365804994665],
            [12.610934203231228, -0.6208271411524952],
            [12.606399448499305, -0.6244803474843942],
            [12.609038842948895, -0.628218028887936],
            [12.598007226477955, -0.6371463820981104],
            [12.593139392803467, -0.6377182707785283],
            [12.592022710740753, -0.6415719050173201],
            [12.587196935004746, -0.6352204364616956],
            [12.582264367711574, -0.6305456607914974],
            [12.575592139992576, -0.6174599794526314],
            [12.574784992617888, -0.6081100671917063],
            [12.576124424978532, -0.605086773488161],
            [12.589584358226729, -0.5905967025200447],
            [12.603613979989463, -0.5812852964003759],
            [12.607385361266601, -0.5808438645211752],
            [12.624325111907842, -0.5910736804289837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.5588830990828, "lat": 37.12286389184015 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51750"],
        "coty_name": ["Radford"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Radford city"],
        "coty_fp_code": "750",
        "coty_gnis_code": "01498438"
      },
      "bbox": [
        12.574784992617888, -0.6415719050173201, 12.640553311260279,
        -0.5748201221460887
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.822322866154275, 0.23764766873441395],
            [14.83003763573021, 0.24197334619520974],
            [14.835109161121068, 0.24348420357597778],
            [14.849566302355122, 0.2428100958666401],
            [14.858199164370012, 0.24919144693890166],
            [14.872206300305567, 0.25102375033260277],
            [14.873508332377911, 0.26055289082506367],
            [14.866574455509799, 0.2591769148454567],
            [14.863963911058516, 0.2630896964778994],
            [14.860404900594304, 0.26056081472316195],
            [14.856024233495052, 0.26153841917043785],
            [14.85598955460607, 0.26456239664972964],
            [14.86081808459059, 0.27313593367925615],
            [14.863970984842867, 0.27509106115074294],
            [14.86458190327566, 0.2830329212743415],
            [14.878119717138485, 0.27528394189525973],
            [14.880427567509539, 0.27662674077176996],
            [14.89206963260121, 0.2715806460065418],
            [14.896240721973099, 0.2789789208198025],
            [14.906039723246888, 0.2720110016792526],
            [14.91252034592549, 0.27906343334680217],
            [14.906608468124736, 0.2866916048835655],
            [14.904628440390168, 0.29227781694979815],
            [14.905361519417594, 0.29802488423410345],
            [14.913512944596807, 0.3002427227224114],
            [14.91414624230384, 0.2979232068192705],
            [14.922748372533912, 0.3003824222053171],
            [14.921935779032642, 0.3047446980007003],
            [14.927014023421753, 0.30669553802816796],
            [14.933468725996546, 0.30264095731816915],
            [14.933912895029799, 0.29904473266524095],
            [14.93708109414063, 0.2968293526829049],
            [14.936743107754571, 0.29079424177485574],
            [14.94457265791455, 0.2885171796558534],
            [14.953324483531917, 0.2907212215432877],
            [14.957863074885696, 0.2892833690513209],
            [14.958670882841018, 0.2856376314798907],
            [14.962951967890564, 0.2789678950849115],
            [14.96239722736881, 0.2751603005984898],
            [14.959870278214478, 0.27268325048579944],
            [14.96236578097898, 0.26911446523776467],
            [14.96610231530761, 0.26794722703046914],
            [14.964524940110753, 0.2621664109430958],
            [14.97464386427266, 0.26119872224563756],
            [14.977688233818995, 0.2585687970597594],
            [14.981699841273626, 0.25008578580864294],
            [14.98807398336675, 0.24916145788074354],
            [14.988899106328237, 0.2428878513444797],
            [14.984679826277894, 0.2432667188212084],
            [14.983393572417079, 0.23742681948461852],
            [14.990187202742792, 0.23093796578960274],
            [14.986135226478533, 0.22604836114687754],
            [14.98756690387001, 0.2179524960516158],
            [14.982145471728066, 0.22031698531172073],
            [14.975335175150594, 0.22135142333766517],
            [14.972593351863365, 0.22760751460205755],
            [14.9677362219891, 0.22655992713577894],
            [14.969271394314932, 0.21846915594797878],
            [14.96907342065866, 0.21249336844555303],
            [14.966996096782271, 0.2047990442058238],
            [14.968690909018814, 0.20083070725036445],
            [14.972769938940926, 0.18038341481000453],
            [14.979599240216801, 0.1627866239593866],
            [14.97813251109038, 0.15696316241051267],
            [14.96480513864549, 0.1645706916617735],
            [14.958722839116266, 0.16633416022457417],
            [14.954011928767226, 0.1648148915185785],
            [14.945037044779776, 0.16771315721464464],
            [14.940981086685364, 0.16499634148539252],
            [14.938991129584686, 0.16612254436690657],
            [14.934889753138158, 0.16143121548905484],
            [14.929097790384347, 0.16170626615894815],
            [14.921977174240336, 0.15503367123861697],
            [14.917381915392843, 0.16101920572766476],
            [14.91320615063916, 0.16110882558049175],
            [14.907335600398438, 0.1636888390221755],
            [14.900601486097838, 0.1708992933412679],
            [14.883726094862855, 0.20200042127275752],
            [14.87844975888173, 0.22408834693851082],
            [14.866555842269731, 0.21788078764421537],
            [14.858164857938185, 0.23030230557351788],
            [14.85469474741085, 0.22816202681833064],
            [14.848707101368708, 0.22179590493841267],
            [14.83990044691503, 0.2168899553237579],
            [14.82869148902111, 0.2161612028880002],
            [14.825483853425174, 0.21788452162520752],
            [14.819980192462632, 0.2262920142913956],
            [14.82394942550572, 0.2277864443588539],
            [14.822322866154275, 0.23764766873441395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.47568482302192,
          "lat": 37.529480435965674
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51760"],
        "coty_name": ["Richmond"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Richmond city"],
        "coty_fp_code": "760",
        "coty_gnis_code": "01789073"
      },
      "bbox": [
        14.819980192462632, 0.15503367123861697, 14.990187202742792,
        0.30669553802816796
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.79724640676823, 1.6522635627031141],
            [11.801223236858169, 1.6615928036706695],
            [11.80820287085418, 1.684045149186601],
            [11.813756004355215, 1.6949338684365998],
            [11.823443963915182, 1.709424602902353],
            [11.826487467035745, 1.7163738198334173],
            [11.833130883242124, 1.7243245388095687],
            [11.838430314374774, 1.7318719638772109],
            [11.842667645437913, 1.7396846162044461],
            [11.846749983503027, 1.7441605750763387],
            [11.85237388025305, 1.7503280335133315],
            [11.855978695300669, 1.758155772613651],
            [11.865812964453921, 1.7704298975837218],
            [11.875758397541507, 1.7806495652801617],
            [11.879301304835538, 1.787352444208865],
            [11.890298743810128, 1.8022476124143734],
            [11.907718429315548, 1.822189355216731],
            [11.917245388090096, 1.8162926801393633],
            [11.955489322160119, 1.8026375320743027],
            [11.977534772511005, 1.8283874309413655],
            [11.98205099008193, 1.8281352511163365],
            [11.983791097276526, 1.8242734207747655],
            [11.98112372952953, 1.8194804510343765],
            [11.98203297843681, 1.816010258408771],
            [11.986815041034532, 1.8113190902223124],
            [11.991704329274468, 1.8107410251368325],
            [11.99685348830684, 1.8058130180422034],
            [12.000470993976185, 1.8057829804848993],
            [11.99957605301696, 1.7995024794554815],
            [12.000214208178186, 1.7951609173423615],
            [12.002711526674931, 1.7922681549481654],
            [12.006816568444851, 1.7918047979635363],
            [12.005958019239229, 1.786781808831261],
            [12.010208779939658, 1.7853446347234663],
            [12.011991433262287, 1.7893944694452135],
            [12.015935473075865, 1.7936014755135656],
            [12.01901579364832, 1.79319035466688],
            [12.021856659481765, 1.7882942255021796],
            [12.027403521966395, 1.7881584028968502],
            [12.032908017764374, 1.7855981440698543],
            [12.040563373681758, 1.7788477249094017],
            [12.038178888161337, 1.776023313116986],
            [12.038935773066902, 1.7716925861515367],
            [12.051960956988312, 1.7663044173345697],
            [12.055709799346193, 1.76178561817018],
            [12.060658922365818, 1.7628687108112089],
            [12.0651850881293, 1.7573976436167578],
            [12.075830662774143, 1.7530539451909466],
            [12.076452588319363, 1.7471221179197516],
            [12.078216812479415, 1.7423982988330453],
            [12.0818784919601, 1.740512473228187],
            [12.084378835435615, 1.7326973462452047],
            [12.087885701891931, 1.731994811140337],
            [12.090793807759242, 1.7340870925745955],
            [12.096521201835852, 1.728711638884379],
            [12.096323288519097, 1.7240879548565569],
            [12.1005128404021, 1.71893457019986],
            [12.104344700561077, 1.7199106628424758],
            [12.110628454836535, 1.7189879212182975],
            [12.118281008887713, 1.720089112305987],
            [12.119977108508527, 1.7175615936393682],
            [12.12406772014728, 1.7176096362657844],
            [12.126565026670619, 1.721156767382286],
            [12.127199781498472, 1.7258130096144129],
            [12.133298740909137, 1.7263996858878177],
            [12.135162778277843, 1.7241716947989756],
            [12.138567865523145, 1.7138015039574894],
            [12.142476795900128, 1.7177087441460999],
            [12.14656333676606, 1.716856732990574],
            [12.149301845417533, 1.7212772528881353],
            [12.154712114628133, 1.718988177542469],
            [12.158897148652933, 1.7190923986553215],
            [12.161247062338424, 1.7142676033977584],
            [12.16460877790766, 1.7137635639307816],
            [12.166252949058237, 1.7104360234015437],
            [12.171879518585785, 1.709362015114611],
            [12.178186272618898, 1.705852666429427],
            [12.17819365010176, 1.7043601755653048],
            [12.168853334556832, 1.6973597976975905],
            [12.164943276830945, 1.7002035111304648],
            [12.162404148992113, 1.694819047693441],
            [12.156837507613053, 1.6948558201600514],
            [12.150750262476011, 1.6894492498561506],
            [12.150742654174472, 1.6836289324088323],
            [12.138989117113477, 1.678133748060781],
            [12.137778923639578, 1.6760283634603965],
            [12.13254682201913, 1.6784125400259118],
            [12.127575329826374, 1.673545406354035],
            [12.121746185880784, 1.6783184829274465],
            [12.112037847587702, 1.6735281104544215],
            [12.10893546697011, 1.6729943105467684],
            [12.100520141534513, 1.6371841902948356],
            [12.036195924632155, 1.573310705411674],
            [11.999164405117067, 1.517351727151824],
            [11.997490278121361, 1.52214060070314],
            [11.998431274233498, 1.528000702261282],
            [12.000638092627447, 1.5313542747879445],
            [11.996837017157258, 1.5360228301807768],
            [11.993823463143153, 1.5375645126649118],
            [11.99388724632015, 1.544444950599637],
            [11.991422371349094, 1.5476730711640738],
            [11.993145212363812, 1.5533046755147175],
            [11.996378587063843, 1.5541040710901415],
            [11.994466581160152, 1.5646618341752463],
            [11.997021865999193, 1.5695041561393472],
            [11.992366392983827, 1.5746956852152212],
            [11.994505822955345, 1.5775682355491243],
            [11.99365680413822, 1.5819790935208689],
            [11.990414686152336, 1.5835002552160542],
            [11.986555999450756, 1.5885232502411466],
            [11.97865022363462, 1.5953896129897935],
            [11.97520864962329, 1.5943918469455287],
            [11.972178709583117, 1.5983369803372807],
            [11.96963801191889, 1.5951822325874216],
            [11.961362900630961, 1.603350106531004],
            [11.954303001976001, 1.6036713424375253],
            [11.951203625413426, 1.6065820105194408],
            [11.947631759663185, 1.603401313772472],
            [11.946667066748148, 1.5970197007118019],
            [11.944813714812584, 1.5946144734590395],
            [11.945012470774053, 1.5898677734855544],
            [11.947582773425653, 1.5871338449926842],
            [11.948036390604488, 1.579177072126068],
            [11.945201663473714, 1.5754348365375994],
            [11.946074947092885, 1.572930565017918],
            [11.944842496517085, 1.5654342052689183],
            [11.942037212144646, 1.5606667810108037],
            [11.938964073378804, 1.558303241173395],
            [11.939673169492137, 1.5546199545798636],
            [11.935859966870273, 1.5534884693250213],
            [11.93063727087573, 1.5573594981176806],
            [11.915993256720363, 1.5581870449563886],
            [11.916056860297463, 1.554886336645212],
            [11.911671410049594, 1.5511625288108983],
            [11.906312333947215, 1.551149809943523],
            [11.902117130997588, 1.553139363162909],
            [11.900032126875148, 1.5593935129211418],
            [11.884891254139907, 1.6180427654875746],
            [11.874030451285089, 1.6481698053835534],
            [11.868922305378213, 1.6680081142556604],
            [11.866230487439394, 1.6721455661116666],
            [11.863011773839032, 1.6736891752624092],
            [11.855090168691017, 1.672501688851888],
            [11.844603409846867, 1.6782356617043157],
            [11.83977688719143, 1.6780654778078776],
            [11.841354538453645, 1.6743168066145344],
            [11.84665079492108, 1.6699753956397443],
            [11.844988249870168, 1.6655089123973088],
            [11.837297255072553, 1.666776190122094],
            [11.827865848556385, 1.6671119355714943],
            [11.823144978708465, 1.663282999765507],
            [11.819864157109178, 1.6563987314026243],
            [11.816911505327031, 1.6548031554317058],
            [11.810333854455335, 1.6598840428406572],
            [11.80732981625702, 1.6597946891644695],
            [11.80044042102143, 1.6515490818364398],
            [11.79724640676823, 1.6522635627031141]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.88487288730367, "lat": 39.46521579341283 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54095"],
        "coty_name": ["Tyler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tyler County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01678706"
      },
      "bbox": [
        11.79724640676823, 1.517351727151824, 12.17819365010176,
        1.8283874309413655
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.152428757960113, 7.017786745809572],
            [3.2387085038695087, 7.021493438638384],
            [3.252728308517129, 7.022043491092358],
            [3.324530341365024, 7.024080481276684],
            [3.3673248379615868, 7.025926640927205],
            [3.4124554164567824, 7.027669740914337],
            [3.4843388087312923, 7.0310140902170035],
            [3.5140513767796877, 7.031691625074567],
            [3.5428741154306036, 7.033203462324921],
            [3.5620497700795997, 7.033451033558697],
            [3.5819891790422798, 7.034302820616423],
            [3.585809095835101, 6.965531985471738],
            [3.586402772444838, 6.949220468741302],
            [3.589995335072977, 6.863394159533675],
            [3.591175485976477, 6.837594027277745],
            [3.591813452499953, 6.813674384793537],
            [3.597036475402883, 6.70609924965134],
            [3.5974691850321516, 6.69170468013588],
            [3.5996529385155944, 6.643476647751879],
            [3.600848593787599, 6.606605302407044],
            [3.586096610871227, 6.606421699964851],
            [3.5462453587548723, 6.605228092392068],
            [3.5139927042824746, 6.604057803645453],
            [3.455777305717397, 6.601847004885405],
            [3.399774733354449, 6.599088559704907],
            [3.3878517425413337, 6.598901754568687],
            [3.3439460749859906, 6.597003202726307],
            [3.2765415263300848, 6.594631606793042],
            [3.251447780047418, 6.593522733337623],
            [3.1687221089990443, 6.590848200410024],
            [3.166061306657225, 6.655375359455146],
            [3.1650638037418344, 6.675612833887108],
            [3.1630110387849792, 6.72643500842954],
            [3.1615941369352845, 6.77138823447655],
            [3.15879913787539, 6.839542680705267],
            [3.1577873589542, 6.868654232998251],
            [3.156590170325509, 6.914519231104621],
            [3.155351558519811, 6.9464766528019375],
            [3.1525937137013713, 7.010463391472067],
            [3.152428757960113, 7.017786745809572]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.84832428512408,
          "lat": 45.423691241735625
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55005"],
        "coty_name": ["Barron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barron County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01581062"
      },
      "bbox": [
        3.152428757960113, 6.590848200410024, 3.600848593787599,
        7.034302820616423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.7420975826518044, 5.393629941514317],
            [3.748471359495327, 5.393798856158732],
            [3.8155619861900343, 5.397330751061027],
            [3.81477963341769, 5.403657160667821],
            [3.81093349605874, 5.40431205611619],
            [3.809739689835185, 5.407907101083104],
            [3.810891250578779, 5.4125593030037455],
            [3.803343222209852, 5.419655791840706],
            [3.8032946001087637, 5.4258505359995635],
            [3.7993127693111197, 5.426259242881491],
            [3.7987398662016796, 5.430025486196486],
            [3.8021177107508217, 5.440755541962269],
            [3.8006340739297717, 5.44544731531807],
            [3.8023910034285167, 5.449743203190696],
            [3.8060690430675366, 5.448197645349417],
            [3.809195401117807, 5.450388188727511],
            [3.8056797601618273, 5.454673135034821],
            [3.8069991549499815, 5.45765234184638],
            [3.8129052219112833, 5.461088356301695],
            [3.816123898956586, 5.4665373144813],
            [3.816471349327435, 5.473142529657857],
            [3.822392242172372, 5.478106224631287],
            [3.830957028356892, 5.47692878449014],
            [3.8392649623845982, 5.474426466371257],
            [3.844329716094607, 5.481341134167603],
            [3.8486790417760504, 5.483148856342155],
            [3.8506730129988336, 5.486894272074989],
            [3.8595691095639957, 5.481753286352119],
            [3.8618028115236482, 5.475961353729904],
            [3.8656743041304362, 5.472884467401754],
            [3.8708790495412813, 5.472187750818175],
            [3.8749814065983896, 5.474173930621969],
            [3.878566161264854, 5.473653950829641],
            [3.8841943191684654, 5.469378599226081],
            [3.8877740846169093, 5.474746167202272],
            [3.8869995692827923, 5.4804175110111055],
            [3.888810052662223, 5.483274831052167],
            [3.893170296622037, 5.485356037656162],
            [3.8931144664889605, 5.490629138419236],
            [3.8979509632606018, 5.492382495472272],
            [3.899039242289104, 5.4945115707460355],
            [3.8993905388987975, 5.50444457034053],
            [3.903997689463747, 5.504442584742175],
            [3.907514631354276, 5.502781698637619],
            [3.91455224138848, 5.502643041820675],
            [3.9182372658175684, 5.5060908550154855],
            [3.9210063931594763, 5.506026028120772],
            [3.9223506471985323, 5.5010004270841435],
            [3.928233733096083, 5.501116725306996],
            [3.9328719090616895, 5.498421810618791],
            [3.9333777165055874, 5.489775932452442],
            [4.025230033609694, 5.494846884122897],
            [4.061182432386641, 5.496277836952507],
            [4.104180793372143, 5.499197472135869],
            [4.106273472033095, 5.456609205636415],
            [4.108626647219963, 5.420537992093392],
            [4.114186107330022, 5.348424341810573],
            [4.115449916820831, 5.327419317124034],
            [4.116666831819264, 5.298683996104572],
            [4.11909251008652, 5.248138572764931],
            [4.124400401600818, 5.153754920840178],
            [4.071751171157777, 5.15089354738788],
            [4.042344270493028, 5.149103318538633],
            [3.982074270969919, 5.14592575128838],
            [3.9523739280679187, 5.145014427064466],
            [3.937114162994875, 5.144025585984756],
            [3.8749224341413773, 5.141219453401209],
            [3.8765909539123293, 5.149185777469666],
            [3.8756431312112998, 5.160497274366583],
            [3.8824739317749137, 5.18904453721531],
            [3.8822632390049927, 5.190657072885054],
            [3.868243892526943, 5.207479597530223],
            [3.8663977809893457, 5.215597499670764],
            [3.86405405852743, 5.219285509143566],
            [3.8602717093162053, 5.228708658015059],
            [3.85706211268745, 5.239661602056597],
            [3.85501488514999, 5.252448554577394],
            [3.849927421544077, 5.261530078502435],
            [3.8447209933027313, 5.2669462742523105],
            [3.8404845136486427, 5.269171518284853],
            [3.8296556775033492, 5.280865462447206],
            [3.825844276098481, 5.295117580604436],
            [3.8217170575211914, 5.301603448417808],
            [3.816068212934758, 5.30627445437735],
            [3.8086916778230693, 5.3101457871908595],
            [3.8054373333543756, 5.315023586596152],
            [3.80110666264235, 5.324085947393523],
            [3.793906357815223, 5.329005768596543],
            [3.7892809689925278, 5.338118970609363],
            [3.7878031085984927, 5.346373378542883],
            [3.7717774084259412, 5.364962458694812],
            [3.764863201387878, 5.3698010201892945],
            [3.7568183003139706, 5.373935357547242],
            [3.751717700045183, 5.383176314146882],
            [3.7420975826518044, 5.393629941514317]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.11524784263706, "lat": 43.90657829448611 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55063"],
        "coty_name": ["La Crosse"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["La Crosse County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01581091"
      },
      "bbox": [
        3.7420975826518044, 5.141219453401209, 4.124400401600818,
        5.5060908550154855
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.24276439623033, 6.5265130521113575],
            [5.3223984140777265, 6.532465004533488],
            [5.3846162305536245, 6.536930510682186],
            [5.413252825596827, 6.538498453127076],
            [5.414541188153499, 6.524219368811439],
            [5.416369180539371, 6.49294461908566],
            [5.418341569019246, 6.466803683168525],
            [5.419873339721937, 6.4530157969532596],
            [5.472469029611088, 6.457403808625905],
            [5.5024591981293725, 6.459322356755627],
            [5.568975495077683, 6.464707256431704],
            [5.59290246348318, 6.466407886988645],
            [5.593580329055395, 6.460528231820714],
            [5.599237942486842, 6.380227261590284],
            [5.676143847021191, 6.38617684091454],
            [5.7361292772557855, 6.390017519964967],
            [5.773614198760815, 6.392794272873922],
            [5.829139150178415, 6.396412002566537],
            [5.857819455531388, 6.398523156216501],
            [5.943795270244369, 6.403700355570093],
            [5.947878545953971, 6.318188383172821],
            [5.951222728654938, 6.30192770169685],
            [5.958323051230416, 6.260516068557031],
            [5.961311249172794, 6.238748316768952],
            [5.961833140336556, 6.232207022306813],
            [5.954834778211805, 6.231820213173944],
            [5.956553954508962, 6.2123736156456335],
            [5.963270598943806, 6.213474239254775],
            [5.965005692712345, 6.180809210640671],
            [5.967803636304761, 6.137834089813302],
            [5.960762043027495, 6.1374189291188435],
            [5.921881536861765, 6.136159797754883],
            [5.881546332358676, 6.133886694207302],
            [5.867158931079926, 6.1333677324379465],
            [5.824220242562508, 6.130811129245174],
            [5.7949284598014135, 6.128763204425948],
            [5.73233829362693, 6.124983442456017],
            [5.711745437226276, 6.123269231299034],
            [5.710240549218477, 6.14004674737],
            [5.707202403216209, 6.188005097067255],
            [5.7055591716525775, 6.210556996804468],
            [5.676623331559196, 6.208227631170563],
            [5.653614589560418, 6.2069387982110475],
            [5.609005335494208, 6.203940242583313],
            [5.569123878539469, 6.201014177936053],
            [5.515161384438113, 6.1974883444199],
            [5.464401346490761, 6.193574034480311],
            [5.381415788364684, 6.188029105738675],
            [5.3534111290018425, 6.186429785603824],
            [5.3250854972178665, 6.184367531222134],
            [5.29540794347193, 6.18285090553783],
            [5.267636288615279, 6.1810711041326405],
            [5.2588738911023025, 6.296889291783696],
            [5.256145433107324, 6.339882752270637],
            [5.254974277608612, 6.3547001995847765],
            [5.250531109735865, 6.419193766609843],
            [5.249773786105493, 6.4337839049008885],
            [5.246107884647273, 6.483859582000728],
            [5.24276439623033, 6.5265130521113575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.76544025568901, "lat": 44.78914627998939 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55115"],
        "coty_name": ["Shawano"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shawano County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01581117"
      },
      "bbox": [
        5.24276439623033, 6.123269231299034, 5.967803636304761,
        6.538498453127076
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -170.76820788744618,
          "lat": -14.323495553628788
        },
        "year": "2023",
        "ste_code": ["60"],
        "ste_name": ["American Samoa"],
        "coty_code": ["60050"],
        "coty_name": ["Western"],
        "coty_area_code": "ASM",
        "coty_type": "district",
        "coty_name_long": ["Western District"],
        "coty_fp_code": "050",
        "coty_gnis_code": "01805241"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -64.73832342697906,
          "lat": 18.338876906749537
        },
        "year": "2023",
        "ste_code": ["78"],
        "ste_name": ["United States Virgin Islands"],
        "coty_code": ["78020"],
        "coty_name": ["St. John"],
        "coty_area_code": "VIR",
        "coty_type": "island",
        "coty_name_long": ["St. John Island"],
        "coty_fp_code": "020",
        "coty_gnis_code": "02378249"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1758935899563507, 0.8511640526548666],
            [2.174457151161926, 0.9388098495157137],
            [2.2517028751025627, 0.9409758405312215],
            [2.3022907326670543, 0.9436317947487458],
            [2.3452929534052016, 0.945478756953579],
            [2.431179190702286, 0.9487634909821995],
            [2.5407548786925096, 0.9526409707204645],
            [2.5434851965156864, 0.9441744630956656],
            [2.547167629006772, 0.9380737245562398],
            [2.547359241198489, 0.9343818080635419],
            [2.5443487432302496, 0.9295388123209283],
            [2.54428392170385, 0.9254356400202027],
            [2.5482893656638765, 0.921257455901588],
            [2.5473130436977867, 0.9138970590442334],
            [2.5505863486439075, 0.9082419382877125],
            [2.547846585853909, 0.9018394573608772],
            [2.548528940055673, 0.8968913234879362],
            [2.5566345778012938, 0.89378451858417],
            [2.5577651500478917, 0.8905921125783491],
            [2.551924426559141, 0.8863274250916938],
            [2.5538950682400907, 0.8812144002678705],
            [2.55814022697575, 0.8826534413601056],
            [2.56039777752503, 0.8790563582527597],
            [2.554003308838902, 0.8789688722937994],
            [2.5505740766880027, 0.8768669202510515],
            [2.548426671224323, 0.8708175674318536],
            [2.5436115677892954, 0.8758199407159566],
            [2.5378492731605684, 0.8749189852277808],
            [2.5371047770806174, 0.87200487672203],
            [2.5394515455098694, 0.8689226217998741],
            [2.544257742629594, 0.8673022697360135],
            [2.5441356542037727, 0.8604669542802508],
            [2.540035820162684, 0.8587572536312782],
            [2.5397842118174543, 0.8555259883592373],
            [2.544569553780134, 0.8513029276003062],
            [2.547742372506194, 0.8428626090461384],
            [2.552178188576177, 0.8391913633772714],
            [2.553439369621649, 0.8341354623953381],
            [2.5504309538921826, 0.8323758082836494],
            [2.545383632154235, 0.8326924354695067],
            [2.5462042565202734, 0.8202616250300887],
            [2.5537111058996107, 0.8144054829512759],
            [2.55668253301633, 0.8091897242803138],
            [2.557892452868579, 0.8030174949401944],
            [2.5557509663335325, 0.7971202930733815],
            [2.550870844835056, 0.7974697083264032],
            [2.5462842053850396, 0.7955104194803878],
            [2.550243419589574, 0.7926744180755443],
            [2.5581452961995805, 0.7955998634819494],
            [2.5604964140280773, 0.7989474391273891],
            [2.5665832267714297, 0.7958980712752535],
            [2.5668616970246356, 0.7867261271202389],
            [2.563576925451851, 0.7828969323112642],
            [2.565912517959906, 0.7782961535342112],
            [2.569581852197831, 0.7791314429719327],
            [2.5707976787468882, 0.7868219545742803],
            [2.5687667043408187, 0.7943759201718964],
            [2.572203085367301, 0.7989377976297917],
            [2.576512359341423, 0.8019873071561734],
            [2.575434031112664, 0.8079197461020268],
            [2.5830922457401253, 0.8100633356035504],
            [2.5858142055315216, 0.8090411105181302],
            [2.588225994097975, 0.8046059174696772],
            [2.5860055240428887, 0.7973058732878185],
            [2.5902888621577773, 0.7876320035932021],
            [2.583676290298743, 0.7809427620913836],
            [2.582468887789405, 0.7767330203007531],
            [2.583674238598964, 0.7728006250157807],
            [2.5911464043404986, 0.7670660605944312],
            [2.5933620385721543, 0.768255869315858],
            [2.592640739068559, 0.7727324615329784],
            [2.5886542284182723, 0.7766671817592387],
            [2.592131353724419, 0.7801154226713023],
            [2.5969230254894753, 0.7783463396402788],
            [2.5972945620538366, 0.7753106380003074],
            [2.5954499888836984, 0.7672981581686213],
            [2.601315921867515, 0.766644367959964],
            [2.6067279027738244, 0.7707985595103587],
            [2.607772942709038, 0.7740608004983129],
            [2.6118299528493116, 0.7737907853604767],
            [2.618369225493407, 0.7699591571607293],
            [2.6255304369683508, 0.7703091009769532],
            [2.6320091881667604, 0.7742646857047588],
            [2.6368383997541436, 0.7685508502115597],
            [2.6381937310281116, 0.7631887433004393],
            [2.6407099084362886, 0.7597689799500822],
            [2.6447812093183383, 0.7587761298233832],
            [2.652604230513736, 0.7618983833273096],
            [2.6669119656761278, 0.7567208116584953],
            [2.670924632937375, 0.7529131482357263],
            [2.6715636561820975, 0.7498979117740165],
            [2.6690838774845664, 0.7444340242721798],
            [2.6690380305549906, 0.7411990387152259],
            [2.6715787593803753, 0.728113433115112],
            [2.6748847764627914, 0.7242005924230003],
            [2.680327623880249, 0.7225232073461942],
            [2.6768447283710195, 0.7218152682907231],
            [2.664658002782001, 0.7160073092319794],
            [2.6595644063386, 0.7155029569137742],
            [2.6535829525123633, 0.7166506501875919],
            [2.648544024921694, 0.7198862633050188],
            [2.6438649106932384, 0.7249578208901979],
            [2.6402173383087626, 0.7306946964599783],
            [2.6377773171981755, 0.7366859315754092],
            [2.6338917021206103, 0.7426845510732034],
            [2.6259509205748506, 0.7485262857871026],
            [2.621199040618785, 0.7491718111943608],
            [2.614514751860837, 0.7476418168164172],
            [2.6090303201578267, 0.7437938935698435],
            [2.606149231563711, 0.7386102674712824],
            [2.6068418570015592, 0.73277761028162],
            [2.6092568965318916, 0.7272370737823892],
            [2.6147864901794313, 0.718673203424118],
            [2.6158959833862356, 0.7145716438816443],
            [2.615609165762065, 0.7071759915304863],
            [2.613859536593572, 0.702400097773056],
            [2.6029894025796487, 0.6886332678102964],
            [2.5968303105286146, 0.6740284049806587],
            [2.5921905451113294, 0.6670445746032836],
            [2.585851017890066, 0.6633764068335533],
            [2.5777860384198057, 0.6717428900255593],
            [2.5719812320085853, 0.6738719947316163],
            [2.565767267862612, 0.6728520702569404],
            [2.559922665392405, 0.6657881374646504],
            [2.5570438770032515, 0.6597551326496337],
            [2.5581891947723796, 0.6547710078171626],
            [2.556068332470041, 0.6510754773446683],
            [2.549830269851963, 0.645846085556969],
            [2.5455270759450794, 0.6440616826404413],
            [2.537305811360956, 0.6431302978829612],
            [2.5247650799556673, 0.6443193795929698],
            [2.513820236792451, 0.6438801515344205],
            [2.508112147924929, 0.6427007214582589],
            [2.5046576964191583, 0.6400044311482335],
            [2.499378682156507, 0.6299064615791012],
            [2.4999134683215702, 0.6197469440176874],
            [2.5048147504656435, 0.6095792922957763],
            [2.5089121683213964, 0.6040438848279157],
            [2.511884373274458, 0.5982477882263358],
            [2.5126150460185728, 0.5897791438690887],
            [2.5089686799872877, 0.5825417756782544],
            [2.490665969012373, 0.5726242619850084],
            [2.4827529029484707, 0.5649435096080572],
            [2.4789726174249846, 0.5628403131589014],
            [2.4673662384471804, 0.5585767387392643],
            [2.4613184541739908, 0.5573140282029639],
            [2.4570520021491546, 0.5577678431645658],
            [2.4496227330397944, 0.561759171258989],
            [2.4465929033498504, 0.5655799138405102],
            [2.4464011287369747, 0.572516643582723],
            [2.454288613176626, 0.585279399442451],
            [2.45535068627999, 0.5911980182942763],
            [2.451960774464328, 0.5962113631962215],
            [2.446689749490207, 0.5987368100929925],
            [2.4321102868039772, 0.5978456531935467],
            [2.4234356472205763, 0.5988872830301079],
            [2.4183453648981548, 0.6032444100957371],
            [2.4140568790718016, 0.6156081847808756],
            [2.406883831754956, 0.6225237482677916],
            [2.39748627147583, 0.6227038466022466],
            [2.3923749219175496, 0.6197832107686608],
            [2.3879914491043377, 0.6147261660488446],
            [2.384042977765763, 0.6048406961087839],
            [2.383677053333734, 0.5941590339939937],
            [2.385490750672623, 0.5849626836734386],
            [2.39098632956824, 0.5675372697219364],
            [2.39190190314348, 0.5630403131093759],
            [2.391028674751742, 0.5579820186845639],
            [2.388047287063821, 0.5524358266795962],
            [2.3818629823884265, 0.5467630094104632],
            [2.3697739532752515, 0.5437031896498503],
            [2.3593726700928936, 0.5431361569380716],
            [2.3482930705265734, 0.543622521073582],
            [2.3334953593175323, 0.547541542810536],
            [2.3298469588526416, 0.5546725502599711],
            [2.3216536327247903, 0.5635135132475604],
            [2.3162805760908993, 0.567714024405754],
            [2.307811272910407, 0.569146314298518],
            [2.3007491725381244, 0.5677380228681779],
            [2.294394194832619, 0.5692706197108429],
            [2.282920462057745, 0.5696336934171674],
            [2.276667796683199, 0.57352527194087],
            [2.2713673879322127, 0.5715951442358003],
            [2.265794605363471, 0.5743078652062749],
            [2.2607507940380303, 0.5718284525495146],
            [2.261722420382286, 0.5670931505854826],
            [2.2573804292092534, 0.5615462961235176],
            [2.2478909246911347, 0.5594796072332979],
            [2.2423874232723167, 0.5565873197621095],
            [2.236552265042328, 0.5498622005550842],
            [2.233358683333261, 0.5408396360168315],
            [2.2287518611224044, 0.5345347427336067],
            [2.2202787195640075, 0.5308331489100754],
            [2.214109407464918, 0.5308201375271114],
            [2.198907528587029, 0.5337478584359445],
            [2.1935068682091927, 0.5334499120050396],
            [2.184002989516245, 0.5307349178430392],
            [2.1826644050952257, 0.5738833527679533],
            [2.18105338582073, 0.6380281640758084],
            [2.1777801515171284, 0.7785336466365653],
            [2.1758935899563507, 0.8511640526548666]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.50519732350202, "lat": 39.42695247089167 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29033"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00758471"
      },
      "bbox": [
        2.174457151161926, 0.5307349178430392, 2.680327623880249,
        0.9526409707204645
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.32484659243725, -2.0203064427923985],
            [8.333490638279022, -2.0212045189242938],
            [8.338276373030181, -2.002454710173255],
            [8.34258560160435, -1.9906561041111466],
            [8.348942721659803, -1.9772564473115501],
            [8.35471732279631, -1.9674365615409424],
            [8.362783716737226, -1.9562308680657958],
            [8.373083402873942, -1.9445473967549567],
            [8.382455059223096, -1.9357319309038623],
            [8.395756522809817, -1.9255299872510558],
            [8.40716573822172, -1.920516868937055],
            [8.408983800999344, -1.917598417114939],
            [8.421384039065588, -1.9116445639884316],
            [8.430533114391048, -1.9083076147688607],
            [8.436586636700977, -1.9070996817674049],
            [8.440024742682194, -1.8974295981107587],
            [8.439572291087588, -1.886996002555819],
            [8.443318195487038, -1.8825088156615848],
            [8.436406530940367, -1.8765094486354792],
            [8.445555659849061, -1.8771117454407722],
            [8.460127760008275, -1.8772078595768704],
            [8.462784518110855, -1.8797689089727032],
            [8.466031587161323, -1.8771190576687922],
            [8.49662659099349, -1.8778735882199218],
            [8.496843574773214, -1.880531189302236],
            [8.50149240301849, -1.8802963936409913],
            [8.501169794502593, -1.8775069834668152],
            [8.517693379966953, -1.878473761120389],
            [8.538763020258994, -1.8768131382167452],
            [8.557514427597102, -1.878048103231723],
            [8.557841351575924, -1.9388832155291094],
            [8.561500662629575, -1.939161214766163],
            [8.56384542818192, -1.9464180765168966],
            [8.557673893868582, -1.949166530390358],
            [8.55619534542107, -2.003672292868165],
            [8.563621839187393, -2.009349117219735],
            [8.56609921424704, -2.0138011946546346],
            [8.56792275784628, -2.023933994859407],
            [8.574687240920749, -2.0350632455690576],
            [8.578102268360261, -2.0387487071060555],
            [8.586677127071086, -2.0403271187572765],
            [8.59198905792454, -2.0373694602685934],
            [8.593681212033315, -2.0326186307291674],
            [8.603753950014388, -2.035940333209007],
            [8.605737145353372, -2.039477630835242],
            [8.610446893770453, -2.043019213916975],
            [8.611262240345846, -2.046819276841654],
            [8.614295184211638, -2.0483133778728555],
            [8.610114553936013, -2.056780594447186],
            [8.613212958327741, -2.056101535504345],
            [8.617324559738357, -2.0650917303159275],
            [8.613899863296231, -2.066824748469091],
            [8.615806313630758, -2.072195288277246],
            [8.61243489464478, -2.076227552412874],
            [8.598299409985692, -2.077241857979807],
            [8.594633285507555, -2.082302198509566],
            [8.596912613529756, -2.084749580831494],
            [8.602385212795527, -2.081761169451775],
            [8.603438736901854, -2.0866778652131472],
            [8.602512303874008, -2.093188491399866],
            [8.607565360633707, -2.099926705840638],
            [8.60410449791713, -2.1054146291956775],
            [8.600658331331514, -2.1055501795988323],
            [8.602938628148427, -2.113738426053638],
            [8.611056868220674, -2.1141090573546975],
            [8.610479150629292, -2.1078741487855455],
            [8.615219112897273, -2.1068692560446207],
            [8.61696518828458, -2.114639003333596],
            [8.606476227459167, -2.117901597806858],
            [8.602952382195207, -2.118187585461763],
            [8.60251028030623, -2.1410986702262376],
            [8.604779746235037, -2.1463143735444925],
            [8.60797571805824, -2.14976047161869],
            [8.604131123336229, -2.157383954615894],
            [8.593969857646055, -2.165988261678234],
            [8.588203020632317, -2.168167748800275],
            [8.58244741978078, -2.1631270121466186],
            [8.579876363061631, -2.162755603373966],
            [8.577576447391305, -2.1724432746522533],
            [8.569144695375996, -2.1725970918467796],
            [8.567927118053465, -2.1766602258230248],
            [8.570223327536041, -2.1816637341047955],
            [8.567846259158449, -2.186582322730476],
            [8.565193008252594, -2.1884690053804103],
            [8.562343570271445, -2.200242074742659],
            [8.556957050800296, -2.1969929886276045],
            [8.550219874080662, -2.197738218130369],
            [8.546622161399743, -2.1966719100842806],
            [8.537808524051572, -2.19148994632859],
            [8.539255620778237, -2.1878848803719464],
            [8.538151138114658, -2.182715018885156],
            [8.534542775246738, -2.1803641964837204],
            [8.524017923291868, -2.181034291712953],
            [8.523901775065537, -2.185772320378434],
            [8.52041476944791, -2.1886113068874415],
            [8.525143905321485, -2.200380825336935],
            [8.522207828146563, -2.20106865739661],
            [8.51981807906464, -2.1958985832613687],
            [8.510911047877654, -2.1952828261458843],
            [8.507461803099428, -2.191078042262706],
            [8.502716956985577, -2.191035343948783],
            [8.501353973357748, -2.1944703384751705],
            [8.49509702997908, -2.1990473227155287],
            [8.48755848586443, -2.1937936106958382],
            [8.481505954981285, -2.1935554928479415],
            [8.478843189746678, -2.2037210767119473],
            [8.473686054518131, -2.2058236156739004],
            [8.46829876083438, -2.210719875723922],
            [8.466691802314623, -2.217162479278588],
            [8.453803037852158, -2.2180568578350996],
            [8.454596660035707, -2.221270174841221],
            [8.450959878806792, -2.2232754318163903],
            [8.45077595711662, -2.216754514502012],
            [8.445511786067982, -2.2164900726370913],
            [8.445330494057085, -2.2231173956191195],
            [8.436261755831762, -2.222806896507162],
            [8.433631742085339, -2.224444659268203],
            [8.421392820687023, -2.2197208522544494],
            [8.41059890999448, -2.219675820620182],
            [8.408181893203093, -2.2244086744313805],
            [8.39959138906322, -2.1996240914448197],
            [8.399047165050602, -2.1866739421821286],
            [8.395488786387043, -2.1837276088099795],
            [8.391683803483216, -2.1767017306024172],
            [8.389066811588622, -2.1766036066355983],
            [8.36513218160045, -2.1173436729596324],
            [8.371374053351296, -2.114708529520739],
            [8.368177838947556, -2.107250611145605],
            [8.361367326730171, -2.10850075512179],
            [8.352173955951988, -2.0857090092728203],
            [8.347596668809798, -2.0856114667548304],
            [8.343856752314013, -2.083713387754612],
            [8.343948526681299, -2.078250458512299],
            [8.348665570061218, -2.076844733420108],
            [8.339442117274844, -2.054146735992701],
            [8.344505687768347, -2.045615404805226],
            [8.340771677705597, -2.0447562678589004],
            [8.336125655715637, -2.045707068403525],
            [8.325884861688383, -2.0214722703169787],
            [8.32484659243725, -2.0203064427923985]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.95669743757904, "lat": 36.25051373534181 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47159"],
        "coty_name": ["Smith"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Smith County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "01639791"
      },
      "bbox": [
        8.32484659243725, -2.224444659268203, 8.617324559738357,
        -1.8765094486354792
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.33749971845501486, -8.659670383177886],
            [0.3391438367912861, -8.662973865378277],
            [0.337154634015917, -8.66534932928008],
            [0.3421693204796218, -8.67155377659221],
            [0.3473002484099264, -8.674400716663191],
            [0.36240107221698015, -8.67959679304916],
            [0.366861112443472, -8.683430307752603],
            [0.37081667440081045, -8.690995999107283],
            [0.3697671548679312, -8.697543328943954],
            [0.36582568964307993, -8.702490850102057],
            [0.3700417686564554, -8.704620390473801],
            [0.37468595534088417, -8.703790269592789],
            [0.3773322999763735, -8.70136060047725],
            [0.38183252667420176, -8.704104393242241],
            [0.38544791724761, -8.715335604770265],
            [0.3906088956324988, -8.724148095232811],
            [0.38909468626089344, -8.729284209781827],
            [0.3845244682646734, -8.730988813614747],
            [0.3785854731906863, -8.725215215728502],
            [0.3758948349976605, -8.725523121276419],
            [0.3733201281861466, -8.732798016097258],
            [0.37465810760154467, -8.739457473525427],
            [0.3769533727792929, -8.745237129373335],
            [0.3809261318753999, -8.75085203145879],
            [0.3747018753755451, -8.761113143285593],
            [0.3818122740236859, -8.764539548705145],
            [0.381562861818124, -8.768976334798364],
            [0.3741626512990826, -8.767451116586322],
            [0.3705304489068777, -8.769454411517982],
            [0.36471624278665443, -8.76631260700241],
            [0.35976196694322415, -8.761750755606412],
            [0.35621759471090814, -8.760743069948566],
            [0.3546591139967756, -8.76385148399423],
            [0.35630169355578, -8.76979637427313],
            [0.3603395909578989, -8.773704202652354],
            [0.37168596129491505, -8.773239704927018],
            [0.3739338983585089, -8.776306908499988],
            [0.37413790166917943, -8.782056623520928],
            [0.37648230305553954, -8.785090097775212],
            [0.37447055064304563, -8.788148580781211],
            [0.3698651520356722, -8.787947653269953],
            [0.3658598673155674, -8.785464081383273],
            [0.36368066939471, -8.782151548751093],
            [0.35857763358541955, -8.779467391793835],
            [0.35069758553246455, -8.788977334828761],
            [0.35015537515117523, -8.79474453606036],
            [0.35243538124824025, -8.796997967705996],
            [0.3601191495802263, -8.799980289808476],
            [0.36560678147774245, -8.81298193081128],
            [0.3640330572218388, -8.816701950963898],
            [0.3564946469502695, -8.82104838757889],
            [0.35449401657702945, -8.82492280910705],
            [0.35437300124652354, -8.829253552887355],
            [0.35620168158467524, -8.833018077561933],
            [0.3620892847703511, -8.837133682959447],
            [0.3690472139401732, -8.839129696957455],
            [0.3721833650540455, -8.844269787037373],
            [0.37614058990381427, -8.84517990211377],
            [0.3817002422883739, -8.843893026860608],
            [0.3832229515796379, -8.84854245513531],
            [0.3807328993548129, -8.851213026221698],
            [0.3754562115577842, -8.85314583845172],
            [0.3681911768550161, -8.854027825632688],
            [0.36650276852232216, -8.855270877298448],
            [0.36660469149309743, -8.862068449088932],
            [0.36824118437075776, -8.869003035269957],
            [0.37564106916047996, -8.873667457955337],
            [0.37316038693944964, -8.877128508133138],
            [0.3680136103292695, -8.877557818026263],
            [0.36299077512966815, -8.880037660235393],
            [0.3585912726173565, -8.885512858210351],
            [0.35790844632953456, -8.888042151086093],
            [0.35981870824527173, -8.893575392927717],
            [0.37017303188025774, -8.90498699625419],
            [0.37792639877584555, -8.899951228693844],
            [0.3781461331718127, -8.906985683009111],
            [0.37416508769339685, -8.914728266005854],
            [0.3748661610484088, -8.917463446307645],
            [0.3832325953474988, -8.918525763502927],
            [0.3923954378431282, -8.922355896485497],
            [0.3993103974114457, -8.92195621510813],
            [0.4031644501037659, -8.920167827840297],
            [0.4077237812552303, -8.920186830938563],
            [0.4109965274105795, -8.922531853182063],
            [0.41258166471576374, -8.92669362583541],
            [0.42132521388904626, -8.924080872179598],
            [0.42710579223606254, -8.931689352497711],
            [0.42786511793938603, -8.934527676222798],
            [0.42643328482855763, -8.94768746747718],
            [0.43131905505845913, -8.95303883564818],
            [0.43806033877840594, -8.971870442266095],
            [0.4377572436789066, -8.978177675520712],
            [0.4359182483220513, -8.981446300256797],
            [0.42929404343607885, -8.986636124481091],
            [0.4315029026983585, -8.99264839768736],
            [0.435348328076731, -8.998277590131037],
            [0.43471959937089544, -9.006509782262842],
            [0.436535584052628, -9.009003469152516],
            [0.4420365584164114, -9.008973459235936],
            [0.44988086342813954, -9.006515649938498],
            [0.45366643380808475, -9.006286942368718],
            [0.4570906852310989, -9.008425622967707],
            [0.459769095371282, -9.01741367879787],
            [0.45715982245905185, -9.022991216419857],
            [0.4514174153565158, -9.022990566841015],
            [0.4465063858642563, -9.020667732759192],
            [0.4443264612016401, -9.023835001766846],
            [0.44966166700631993, -9.029217964963593],
            [0.4515186306461943, -9.037015671501427],
            [0.4492914794721918, -9.045592913050912],
            [0.4451156572389852, -9.046742061674088],
            [0.44288941563601997, -9.04130083239991],
            [0.4366398990093062, -9.037283869808379],
            [0.4284924318642174, -9.03820262745414],
            [0.4221760719567824, -9.041113286481602],
            [0.41582524379136093, -9.042797342435069],
            [0.41200973755091536, -9.046302322241516],
            [0.41162896019635176, -9.049626511097511],
            [0.4137661240141842, -9.052826720887007],
            [0.4168663520747108, -9.053614898199722],
            [0.421469501858908, -9.058923370205852],
            [0.42566015753513375, -9.059681117145256],
            [0.43447867271024726, -9.051374413536378],
            [0.43797653026423056, -9.050369854393644],
            [0.44767327882784164, -9.055715923906657],
            [0.4498080597014119, -9.061740454298961],
            [0.4479494085275989, -9.065073183764909],
            [0.44293668733711755, -9.067050756140741],
            [0.43726915287229445, -9.065004297912392],
            [0.4349646933013368, -9.067137298791991],
            [0.4420510414287481, -9.075279136361388],
            [0.44850434688203605, -9.079774046871826],
            [0.450636341296202, -9.08581659940137],
            [0.4469610355049567, -9.089571353732657],
            [0.4494551410479416, -9.09790517929347],
            [0.4439953326428885, -9.100532309694614],
            [0.4422024498272493, -9.107267749779814],
            [0.44216036185448204, -9.121809358241645],
            [0.3864501179175063, -9.123002025978737],
            [0.38232944709316086, -9.12064274574519],
            [0.3810949353922967, -9.112222208263217],
            [0.3781760446977433, -9.11159608151298],
            [0.37125384592293814, -9.106378907538655],
            [0.368446953739663, -9.102375717284488],
            [0.3627121130834628, -9.101566994772586],
            [0.36024321632016393, -9.105598601348547],
            [0.35757471000131463, -9.106546370091658],
            [0.3500327725008769, -9.102028756481914],
            [0.3456589673438669, -9.104896813760515],
            [0.3404700275506316, -9.105191552930359],
            [0.33481172559351313, -9.09944463293441],
            [0.32884848149242935, -9.09571456934358],
            [0.3261481322203496, -9.095421760099013],
            [0.32004088152555393, -9.098357805794176],
            [0.3157710248432773, -9.095667764526796],
            [0.3113076138295826, -9.091147847677949],
            [0.30663663083668946, -9.084129157348018],
            [0.3005491243437239, -9.08247780273426],
            [0.2986867639044743, -9.077524353290544],
            [0.29047525595810786, -9.06873491379494],
            [0.28226239410899195, -9.068763919525319],
            [0.2784376718643725, -9.06446430029842],
            [0.2738599215283462, -9.063293286465044],
            [0.2685794600510515, -9.060354049897557],
            [0.259826586539682, -9.064424930484869],
            [0.25604493999976874, -9.06728633244075],
            [0.25086559399054803, -9.062028743543712],
            [0.2454782512926689, -9.0591183798292],
            [0.2407747926704943, -9.058139808634824],
            [0.2381196229190663, -9.05589113848749],
            [0.2356430918244723, -9.050691915880916],
            [0.23631316825014934, -9.046485108774453],
            [0.23248510099204642, -9.038463138284106],
            [0.228378518479152, -9.035441239551858],
            [0.22660724152934167, -9.028814500669169],
            [0.2230936620919765, -9.026624828519898],
            [0.225984916391286, -9.02188744440914],
            [0.2289281005482653, -9.01980104136973],
            [0.22770331440384478, -9.014924302556489],
            [0.22925818214955343, -9.009182754139752],
            [0.22463017554214637, -9.006908767718294],
            [0.22025343314333456, -8.999647935478142],
            [0.21732851879608356, -8.99815510166224],
            [0.21197051213921822, -8.998458307377453],
            [0.2109348118031303, -8.9909754400883],
            [0.20484765105348404, -8.988727342259711],
            [0.20665693940636928, -8.982192677538455],
            [0.20585705466948248, -8.976366261640413],
            [0.20343351198019435, -8.974455272177478],
            [0.1965964552055198, -8.972182301146944],
            [0.19332753171936698, -8.969933225470365],
            [0.19134346108055153, -8.96336416659105],
            [0.19124010511740958, -8.955099976991605],
            [0.1866918363260071, -8.952019948856261],
            [0.19046446147026339, -8.946854997710176],
            [0.1908225476479765, -8.940949159455522],
            [0.18788494595810634, -8.93527746548155],
            [0.1849858540959098, -8.934436502689136],
            [0.17875983254477698, -8.927927828855413],
            [0.17474336678295016, -8.927790446525826],
            [0.1768619704859238, -8.912288054044323],
            [0.17122765882190874, -8.905590317794687],
            [0.16700920897485735, -8.902184345063864],
            [0.16512108454456859, -8.896727056835331],
            [0.15841580728949964, -8.899476021290514],
            [0.15343627417545708, -8.907654561183879],
            [0.1484069774199783, -8.907828482340143],
            [0.14602283702468302, -8.905130337319934],
            [0.134890294339952, -8.901402470067817],
            [0.12665264390058673, -8.905169971900706],
            [0.12253254562780776, -8.902531312117247],
            [0.11993487047882519, -8.904036252760015],
            [0.11252120462469262, -8.90107299954532],
            [0.11050217324740388, -8.902656219119988],
            [0.10596341715665644, -8.901924047880929],
            [0.10325717068898585, -8.898514332922279],
            [0.09774993000966088, -8.895760583814866],
            [0.0981963353099184, -8.89268076370434],
            [0.09262622201725247, -8.885779581668983],
            [0.0879485420241804, -8.885524298972108],
            [0.08694728588646448, -8.878813029099387],
            [0.07903334973551887, -8.87314474385562],
            [0.07379909490768768, -8.870375488889385],
            [0.06464200735581109, -8.87205565243351],
            [0.06073592175280944, -8.865965483574582],
            [0.057366494253260375, -8.865313300973675],
            [0.05381641913376183, -8.86027946189728],
            [0.04904117487310619, -8.857712459458483],
            [0.043415758724912205, -8.859431621292819],
            [0.027356570732525384, -8.844467014897733],
            [-0.00021450019478662868, -8.819650302973038],
            [-0.02945549364354311, -8.765877817442803],
            [-0.051553629183569434, -8.72490255453252],
            [-0.07403595553785733, -8.683701931584082],
            [-0.04979878344865921, -8.657389559281357],
            [-0.042714214730427164, -8.663722379108574],
            [0.015276706895694294, -8.66353096031566],
            [0.027643455930975742, -8.661526094117065],
            [0.0867180516023546, -8.652711621969061],
            [0.13946234307984143, -8.644718291579895],
            [0.1550211751675819, -8.642982889238771],
            [0.17506610656819027, -8.63904980328831],
            [0.21069571699402448, -8.633717424283667],
            [0.21683395694329416, -8.633501280993341],
            [0.22021020542675931, -8.636575086624395],
            [0.2250957918125261, -8.637494054574603],
            [0.22829200191571342, -8.635469869798026],
            [0.23255079850134547, -8.645914437968878],
            [0.2395977328391924, -8.654000125369347],
            [0.24989794716730562, -8.654510314333562],
            [0.2530332203568751, -8.65733538734616],
            [0.25668865817795655, -8.654214723788542],
            [0.2661708694010438, -8.654218014150322],
            [0.2692504924753987, -8.657412540649034],
            [0.27372914696619255, -8.657177425750122],
            [0.27892160885437745, -8.660784154008175],
            [0.2829225823587995, -8.667467131211803],
            [0.28499712464411875, -8.662803777065827],
            [0.29037108101591336, -8.66318435680969],
            [0.29343142695833374, -8.665056444658529],
            [0.2973602693895958, -8.664591283832605],
            [0.3030952328037637, -8.667404645842248],
            [0.3083374495250941, -8.667714515787946],
            [0.3099389179587259, -8.670176083263872],
            [0.31777735221403375, -8.675289420377887],
            [0.32297999050763493, -8.676811700346327],
            [0.32771057796211156, -8.673806809750209],
            [0.3278423577445325, -8.667899144556639],
            [0.33151266514472943, -8.662657215597099],
            [0.33749971845501486, -8.659670383177886]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.27790895321736,
          "lat": 29.887028640710454
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48015"],
        "coty_name": ["Austin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Austin County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01383793"
      },
      "bbox": [
        -0.07403595553785733, -9.123002025978737, 0.459769095371282,
        -8.633501280993341
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.1083552992949062, -6.639095666645397],
            [-1.0353504125161757, -6.596919533255439],
            [-1.0022927985874237, -6.577434287490558],
            [-0.9689956686275514, -6.558604746882748],
            [-0.9366048687329531, -6.539208345337056],
            [-0.9251506915821636, -6.532848954467988],
            [-0.9090591547988528, -6.522830578551251],
            [-0.9049817939682445, -6.526303834131776],
            [-0.8958292732318107, -6.526962272476349],
            [-0.8829836574657086, -6.526469015835087],
            [-0.8769776193071175, -6.530785008439806],
            [-0.8750132130013463, -6.535681569242035],
            [-0.8748729829552122, -6.542305429937692],
            [-0.8769049313925479, -6.545946864597952],
            [-0.8848596323053637, -6.550697665432439],
            [-0.8850156423581077, -6.554929434562874],
            [-0.8776707357267896, -6.556346346344203],
            [-0.8655204717724948, -6.550159267684189],
            [-0.8611220911540286, -6.5506871299274465],
            [-0.8564074411740935, -6.55606047156034],
            [-0.8568545580902607, -6.563254373394986],
            [-0.8543470608232956, -6.570527433627572],
            [-0.858402865135883, -6.575268233464827],
            [-0.8584735240633492, -6.5797207471945285],
            [-0.8558941779299933, -6.581115092228991],
            [-0.8457606822591291, -6.5816418785799735],
            [-0.8416006757503407, -6.58381832816231],
            [-0.8317146874602078, -6.590925698952365],
            [-0.818424817657964, -6.596868692761378],
            [-0.8133068559584553, -6.597943451176101],
            [-0.8081417218320173, -6.5956546727876555],
            [-0.8069568043663466, -6.591214992715657],
            [-0.8101325507041562, -6.585110745784909],
            [-0.811313475954149, -6.57615793769433],
            [-0.8098487202782605, -6.57038829340017],
            [-0.8067903996406937, -6.568461344398775],
            [-0.8021188093437007, -6.569159003140003],
            [-0.7949260046955664, -6.567414287304519],
            [-0.7902341213944077, -6.562179810160712],
            [-0.785461715312123, -6.5597683676501095],
            [-0.779297787973674, -6.55883711840712],
            [-0.7678621590641718, -6.560008395108711],
            [-0.7632477936161336, -6.565491315353415],
            [-0.7635745309763443, -6.569797296313003],
            [-0.7711163053815188, -6.577885393363593],
            [-0.7739003448667863, -6.584039709437837],
            [-0.7797176741109142, -6.586824953934207],
            [-0.7872519637877559, -6.589194697109081],
            [-0.7956952995896264, -6.592910501185715],
            [-0.7976555974982638, -6.599681648785327],
            [-0.7966566922855866, -6.603810026457595],
            [-0.7868372989410037, -6.623334663255658],
            [-0.7774027876907967, -6.634660304941111],
            [-0.7753882583471395, -6.64058553954696],
            [-0.7760820413492359, -6.645503634191826],
            [-0.7816372576463086, -6.651564657648095],
            [-0.7897425419309598, -6.663939571592579],
            [-0.7934855664374352, -6.668434347231265],
            [-0.794570037127179, -6.672158824328555],
            [-0.7894169261965157, -6.689011698725866],
            [-0.7891867625148283, -6.6925058325334925],
            [-0.790595875831975, -6.70296135271688],
            [-0.7900675588202757, -6.714262985963018],
            [-0.788027087975948, -6.717060289805837],
            [-0.7808823722053114, -6.721920464168113],
            [-0.7708847112049289, -6.721383295487817],
            [-0.7578506962963932, -6.71985890320743],
            [-0.7529830722835518, -6.717999174503655],
            [-0.7485382531071794, -6.711578615216659],
            [-0.7472408833630667, -6.707559842133879],
            [-0.7426716013577107, -6.7040500777380485],
            [-0.7389264657625371, -6.704746737947492],
            [-0.7368333851996207, -6.712661758605919],
            [-0.7368657496887665, -6.724773581179736],
            [-0.7334640884591671, -6.7318251348621505],
            [-0.7263934648880421, -6.739066222748923],
            [-0.7209722293049087, -6.74637910923523],
            [-0.7022280265824624, -6.747530021309415],
            [-0.7001207087288873, -6.750526258145173],
            [-0.6989004626316618, -6.7558866627150715],
            [-0.7013098720566944, -6.760372425620143],
            [-0.709209541170623, -6.766898007573687],
            [-0.7172557005246769, -6.775242589687676],
            [-0.7220553124426691, -6.779056857551732],
            [-0.7414482389584414, -6.789830671437891],
            [-0.7456378963592828, -6.794451664583404],
            [-0.7515216235591733, -6.798781516512003],
            [-0.7521746761351649, -6.802494292023008],
            [-0.7462689763918383, -6.807367013853649],
            [-0.7381346869037531, -6.809282234429596],
            [-0.7296773062301233, -6.822714648464251],
            [-0.7257059078367174, -6.824770467036277],
            [-0.71772413974016, -6.822928072016048],
            [-0.7088435323928914, -6.828890560998074],
            [-0.6984210887025986, -6.834575807587495],
            [-0.6858764179592524, -6.842478462046745],
            [-0.6879227261740213, -6.846927459436867],
            [-0.6940030123349887, -6.848572440970456],
            [-0.7041455040146333, -6.848615197674362],
            [-0.7069699792215005, -6.852553616179787],
            [-0.7068199412359906, -6.858688631383763],
            [-0.7052111235449064, -6.862033621097475],
            [-0.6936090935705231, -6.867506089746885],
            [-0.688061967752667, -6.868102929248495],
            [-0.6796026122797711, -6.87322522289921],
            [-0.6700658142136736, -6.880138062697527],
            [-0.6649868404347112, -6.885385694419549],
            [-0.6622567440567689, -6.8901614024696585],
            [-0.658538799017192, -6.891955480828979],
            [-0.6447088681934712, -6.886085831217618],
            [-0.6386549242686418, -6.88530873814635],
            [-0.6203927104027298, -6.890779774189532],
            [-0.6172716079474524, -6.8944958696675185],
            [-0.6160039583666693, -6.9004441100272595],
            [-0.6172717985849154, -6.905872682660711],
            [-0.6206325284684352, -6.910545086932658],
            [-0.6298069800718561, -6.916742626012479],
            [-0.6433619028559519, -6.932806890591406],
            [-0.6531976252164695, -6.9397471567250815],
            [-0.6573299759384411, -6.9413823354063044],
            [-0.6587630931772639, -6.944900547325077],
            [-0.6564772757876898, -6.954916863855965],
            [-0.6517574688802039, -6.961261964262119],
            [-0.6454310604084005, -6.971815431692463],
            [-0.6381579504692574, -6.9763486419519465],
            [-0.6337979753817072, -6.97796321874103],
            [-0.6275799741935523, -6.982655548635111],
            [-0.6176564755321566, -6.98820341480049],
            [-0.6681348530039317, -7.015912186267266],
            [-0.710920964527183, -7.0396486373302105],
            [-0.7271605586606045, -7.048272635958492],
            [-0.7870545318708491, -7.080616202464211],
            [-0.7913868149857799, -7.083647033129584],
            [-0.8244013745133767, -7.101721413483688],
            [-0.8765914644351543, -7.130561548629392],
            [-0.8979795501493995, -7.141201181337014],
            [-0.9086845565934595, -7.1225566648024605],
            [-0.9163536878748584, -7.108445723743143],
            [-0.9675413028562012, -7.017151516348756],
            [-1.0331309488911569, -7.054406338802619],
            [-1.0876276982314528, -6.957488789694734],
            [-1.1364948769681167, -6.870594809215984],
            [-1.1589615801116062, -6.830165015307016],
            [-1.2084085207232902, -6.741528876688486],
            [-1.224178616764285, -6.712810571357483],
            [-1.228335663928094, -6.705981865060863],
            [-1.21676025079025, -6.699453859411526],
            [-1.1083552992949062, -6.639095666645397]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.63433646020857, "lat": 31.90038350664244 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48035"],
        "coty_name": ["Bosque"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bosque County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01383803"
      },
      "bbox": [
        -1.228335663928094, -7.141201181337014, -0.6160039583666693,
        -6.522830578551251
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6825926287291164, -5.302374621345655],
            [-0.6163250913200775, -5.305984263747686],
            [-0.5475697488697542, -5.309558103316714],
            [-0.45782719264718647, -5.31369932416919],
            [-0.38351697342395247, -5.317671124724054],
            [-0.31870231823606876, -5.320887177069872],
            [-0.2983954323668992, -5.32253910746616],
            [-0.2624180852380288, -5.324321139139458],
            [-0.25605848805134057, -5.323973204382912],
            [-0.23354391660277835, -5.324724203184547],
            [-0.23367383192627172, -5.332530911150576],
            [-0.22782052009484155, -5.332673506673921],
            [-0.230012508876199, -5.401150864707375],
            [-0.23031081357960065, -5.416499701761254],
            [-0.233125112037159, -5.506635209010549],
            [-0.23292187399289957, -5.507987719849336],
            [-0.23430349258441707, -5.542215861319835],
            [-0.23531055019557343, -5.586133158914377],
            [-0.23637075272341448, -5.619663859914277],
            [-0.23686479016698797, -5.645069193527259],
            [-0.23985863580671613, -5.751430735459662],
            [-0.3353142876596328, -5.7489499374952375],
            [-0.3956021951760086, -5.747643164826462],
            [-0.48441827049257513, -5.74594806590942],
            [-0.5604061690664861, -5.744464097016858],
            [-0.7018232788752848, -5.74170514040879],
            [-0.7010548798812523, -5.720176277064832],
            [-0.6969289578204418, -5.620330205095373],
            [-0.6917097158150934, -5.487031596775342],
            [-0.6888743761721664, -5.438086504233531],
            [-0.6885148092367065, -5.425294259649312],
            [-0.6857149607639288, -5.370058130166246],
            [-0.6839794528343072, -5.3286679958529],
            [-0.6836512284907605, -5.328054144862538],
            [-0.6825926287291164, -5.302374621345655]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.11681853863722, "lat": 33.20551848916263 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48121"],
        "coty_name": ["Denton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Denton County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01383847"
      },
      "bbox": [
        -0.7018232788752848, -5.751430735459662, -0.22782052009484155,
        -5.302374621345655
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.263534375589211, -6.452343341606733],
            [-5.185960879205823, -6.4568913253680105],
            [-5.015749422299068, -6.468409937003596],
            [-4.832789848218994, -6.480657875756909],
            [-4.836723288841409, -6.5406279023453715],
            [-4.842142945889525, -6.6165582212107825],
            [-4.847281978384336, -6.693085807045434],
            [-4.8577992102816685, -6.850563902710557],
            [-4.861974588885332, -6.9144201506950616],
            [-4.887941721587578, -6.912657227207224],
            [-4.8973698242714425, -6.91208453380076],
            [-4.989974311639767, -6.905650724450197],
            [-5.082577850427828, -6.899203890875638],
            [-5.175180455195586, -6.892744032147407],
            [-5.267782140480462, -6.886271147016718],
            [-5.294573894186679, -6.884300658866224],
            [-5.278899099745776, -6.6736373795496196],
            [-5.263534375589211, -6.452343341606733]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.54288515205005,
          "lat": 31.869194128544684
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48135"],
        "coty_name": ["Ector"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ector County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01383853"
      },
      "bbox": [
        -5.294573894186679, -6.9144201506950616, -4.832789848218994,
        -6.452343341606733
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.4473831644128209, -6.18772813991472],
            [-0.40685006492764925, -6.188808718068363],
            [-0.33756446109828564, -6.190419436866996],
            [-0.23983142057531667, -6.191897099665828],
            [-0.15865004718738573, -6.193138681611481],
            [-0.07476728532024068, -6.194351193863052],
            [0.019756620853350202, -6.195693515281385],
            [0.0201065087533537, -6.200570468504786],
            [0.024911214726915026, -6.200629915168277],
            [0.024436552964968782, -6.2044434860310895],
            [0.027426169896259112, -6.205632552773992],
            [0.028505701238371373, -6.209491519307476],
            [0.03173961997974107, -6.2088211801100055],
            [0.03278335650450902, -6.204666763661965],
            [0.03804263513271175, -6.207855142753459],
            [0.03586585292625665, -6.210723858283194],
            [0.036647378652726575, -6.214584054220764],
            [0.04098435158318675, -6.217453294456872],
            [0.039048806748739784, -6.227848085325615],
            [0.035123855993651164, -6.232270815179358],
            [0.03691104626525265, -6.239413988509691],
            [0.03979283136274732, -6.243012024738947],
            [0.037013095192833786, -6.249121040779091],
            [0.042424931305059685, -6.253708902208645],
            [0.03592943246726876, -6.257500993304674],
            [0.03678034766834012, -6.260406338848173],
            [0.04074394744551802, -6.263914871204013],
            [0.04279065284863706, -6.2704547765994265],
            [0.049665167714929154, -6.27406692395873],
            [0.048478506308783725, -6.281159423535823],
            [0.04942264974520211, -6.284829498265011],
            [0.05432755529486856, -6.290039039780754],
            [0.057282747853235824, -6.2896572681066845],
            [0.05732728936537702, -6.297012604539918],
            [0.06334960727137165, -6.307083262915407],
            [0.06873031518608655, -6.309586484771232],
            [0.07511860132233664, -6.314509761658708],
            [0.08000990881053732, -6.316838893354725],
            [0.08534518596024797, -6.316618369824046],
            [0.08653189246740978, -6.319163393277736],
            [0.09321355254412096, -6.324769002271199],
            [0.09573329492998388, -6.3290828098409975],
            [0.09698848462406724, -6.337631838403689],
            [0.09439580498695359, -6.34115451740071],
            [0.09647976645218638, -6.347937282160171],
            [0.09883736909692044, -6.35209601421823],
            [0.09510602736171778, -6.3587330160072115],
            [0.09637096353735589, -6.362729762889004],
            [0.09046837225043271, -6.362902397596737],
            [0.08788406761111404, -6.368501966682255],
            [0.08873944859232272, -6.372191027567468],
            [0.0818854864367153, -6.380149217025977],
            [0.08366190057753826, -6.382546644984214],
            [0.08524229956299378, -6.386426828735861],
            [0.0817973012858403, -6.388871419677076],
            [0.08387480075433722, -6.3958202068652685],
            [0.086340340979693, -6.396709044409727],
            [0.09081954592547599, -6.394892580871115],
            [0.09711007783160179, -6.395843708522507],
            [0.10306866913062897, -6.4090346953668],
            [0.11283093758802773, -6.40578196217927],
            [0.11735452298715285, -6.408599989304527],
            [0.1207132136197331, -6.412843419284626],
            [0.12719225256948563, -6.412570090040808],
            [0.1352870108191919, -6.407551310351853],
            [0.13998913514459257, -6.409469615277408],
            [0.14190237531726585, -6.4125044485106875],
            [0.13165224474902668, -6.417742713417611],
            [0.10280212975522206, -6.4354995854842105],
            [0.0028240271893186994, -6.494796472796118],
            [-0.06260572637429686, -6.533631411968185],
            [-0.1282364712455553, -6.570558465033916],
            [-0.175629499586127, -6.5973087153280074],
            [-0.22435399034710904, -6.625384099040246],
            [-0.291935134198182, -6.664203349238946],
            [-0.32962895056618047, -6.685691077748825],
            [-0.37793095948806504, -6.6005691011683885],
            [-0.4253302273668201, -6.5150345025214405],
            [-0.4506213859270735, -6.469991971003009],
            [-0.4496497110329216, -6.386668357294101],
            [-0.44846482449988323, -6.282247069228585],
            [-0.4473831644128209, -6.18772813991472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.79470694899977,
          "lat": 32.348400222373954
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48139"],
        "coty_name": ["Ellis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ellis County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01383856"
      },
      "bbox": [
        -0.4506213859270735, -6.685691077748825, 0.14190237531726585,
        -6.18772813991472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.154907530110112, -2.1365198153546534],
            [-3.1358861471386774, -2.137479832571115],
            [-3.0713204597691175, -2.140323495284918],
            [-2.986529497868491, -2.14430867733275],
            [-2.978313248330826, -2.144421377348521],
            [-2.8646174799721456, -2.149554923763048],
            [-2.792065251524169, -2.1527106394831734],
            [-2.723438140318038, -2.1555663471867077],
            [-2.7207681708797633, -2.1556761897028043],
            [-2.7303749142370908, -2.3836715568328413],
            [-2.735035376277688, -2.4942643574557857],
            [-2.739622033559495, -2.603096789786427],
            [-2.837148630820989, -2.599166257381198],
            [-2.881611982798243, -2.59713067879518],
            [-3.032938332087658, -2.5901944165135284],
            [-3.0397033631136194, -2.5895826003945466],
            [-3.1715417286293324, -2.5828758866205437],
            [-3.17674243429514, -2.5825819105096217],
            [-3.1685296546627146, -2.422670793970656],
            [-3.160749620476183, -2.261207616543516],
            [-3.154907530110112, -2.1365198153546534]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.2731436368091, "lat": 36.27763588585094 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48295"],
        "coty_name": ["Lipscomb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lipscomb County"],
        "coty_fp_code": "295",
        "coty_gnis_code": "01383933"
      },
      "bbox": [
        -3.17674243429514, -2.603096789786427, -2.7207681708797633,
        -2.1365198153546534
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.530004579707059, -3.387674449774063],
            [-4.432029904626116, -3.394021797314286],
            [-4.358496313767476, -3.3986847486440035],
            [-4.344441456557995, -3.399769546692651],
            [-4.315617619471767, -3.4014652381169803],
            [-4.300791642326959, -3.402684719423983],
            [-4.240627468575467, -3.4061822029519155],
            [-4.200542747740538, -3.4082191619680144],
            [-4.157645694471345, -3.4110354955576576],
            [-4.089650035402572, -3.4150919689215646],
            [-4.102744214003181, -3.60532069946682],
            [-4.103779918463487, -3.613266447167559],
            [-4.107553159802291, -3.6696362519035683],
            [-4.112016692621031, -3.724414542815607],
            [-4.11227111413542, -3.7335538106164328],
            [-4.120724670197042, -3.849892729579024],
            [-4.120755269900089, -3.852316748339607],
            [-4.298209489480496, -3.8411311067749705],
            [-4.4210414686012935, -3.833421158924118],
            [-4.42914203898749, -3.8330480553320534],
            [-4.559618543789991, -3.825337938885201],
            [-4.5566768929968156, -3.7822464607664803],
            [-4.540190378048732, -3.541036078005453],
            [-4.535360773468132, -3.468916113485691],
            [-4.530004579707059, -3.387674449774063]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.89703505488582,
          "lat": 34.965867822080845
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48381"],
        "coty_name": ["Randall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randall County"],
        "coty_fp_code": "381",
        "coty_gnis_code": "01383976"
      },
      "bbox": [
        -4.559618543789991, -3.852316748339607, -4.089650035402572,
        -3.387674449774063
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.03276872716603575, -5.7579518157936125],
            [0.09366909461642256, -5.758760755313043],
            [0.0986368956108234, -5.759040001672405],
            [0.13281815807577121, -5.759377618158896],
            [0.139437917498861, -5.7591475392137825],
            [0.17875664755745874, -5.759511223570729],
            [0.21098031330716419, -5.760028524528447],
            [0.21597251762105096, -5.759843970814993],
            [0.21575474369723663, -5.843725197103848],
            [0.21545256455078676, -5.900010739736999],
            [0.21532078498464274, -5.92756836451527],
            [0.1547731120921883, -5.927637161190799],
            [0.14205157989062087, -5.92730871617096],
            [0.07566207612228897, -5.927820111525723],
            [0.05404129053533335, -5.927821144726482],
            [0.030205911974445363, -5.927347008585061],
            [0.03092985057823196, -5.864960495695387],
            [0.03165780142423197, -5.823651863459482],
            [0.03269345520279824, -5.77690416520009],
            [0.03276872716603575, -5.7579518157936125]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.40787776904052, "lat": 32.89784789265293 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48397"],
        "coty_name": ["Rockwall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockwall County"],
        "coty_fp_code": "397",
        "coty_gnis_code": "01383984"
      },
      "bbox": [
        0.030205911974445363, -5.927821144726482, 0.21597251762105096,
        -5.7579518157936125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.091154322409267, 2.050588731085896],
            [-10.964709668587519, 2.029441481049969],
            [-10.964406433068667, 2.031330713040252],
            [-10.798220102731973, 2.004094886171484],
            [-10.739868868726099, 1.9943899758351717],
            [-10.54310140815284, 1.9626976416719661],
            [-10.543859539249153, 1.957791068191307],
            [-10.411154674091046, 1.937517989320297],
            [-10.201596826443554, 1.9055339579586605],
            [-10.136435694169915, 1.8957906395962805],
            [-10.065897300694306, 1.885389404783974],
            [-10.074454427441436, 1.8822067592906822],
            [-10.072774762045249, 1.8777822913878717],
            [-10.064133508869874, 1.87238421765342],
            [-10.06191822649142, 1.8680006616497506],
            [-10.064121673050533, 1.8619468969166455],
            [-10.069260863046136, 1.863338618971733],
            [-10.073230776425463, 1.8675431412327244],
            [-10.079081862830996, 1.8696368457980965],
            [-10.08855548797057, 1.867198049334169],
            [-10.09591735231671, 1.8693016251724313],
            [-10.095130618597116, 1.8758368818156128],
            [-10.095938771663866, 1.882806073625883],
            [-10.098954522845897, 1.8831539533345845],
            [-10.1026528355901, 1.8799277880295597],
            [-10.101573913813315, 1.8727838724542882],
            [-10.099675078802846, 1.8684903727982156],
            [-10.099037342655834, 1.8575439137721803],
            [-10.102865423261102, 1.852120831175536],
            [-10.106189703096623, 1.8443832174525163],
            [-10.108055829592493, 1.8365589435688503],
            [-10.113027034118847, 1.8322061137294432],
            [-10.11898680706532, 1.8365480060158175],
            [-10.124378494491905, 1.826124093188629],
            [-10.129959106021644, 1.8213084081336446],
            [-10.130544195278777, 1.8171352680351096],
            [-10.127322098177945, 1.8094023512659843],
            [-10.130694011246362, 1.8059642294882257],
            [-10.136145141531829, 1.811033830770198],
            [-10.137056402540203, 1.8137660173968657],
            [-10.134753421516557, 1.8235111895702738],
            [-10.135437533060722, 1.828759213028748],
            [-10.13886611403681, 1.8315578414305365],
            [-10.152166592605177, 1.83193702857315],
            [-10.157123674070236, 1.8308348241607517],
            [-10.159379511362177, 1.8273315501079304],
            [-10.159914467272078, 1.8225737533169306],
            [-10.154785475546142, 1.8176476726514867],
            [-10.15226873114676, 1.813418895362763],
            [-10.150419024611974, 1.8043336288738878],
            [-10.145992812378982, 1.7989301111901008],
            [-10.147926808287174, 1.7953827792463666],
            [-10.1521991018854, 1.7940020552995415],
            [-10.1565325340584, 1.7956198097800944],
            [-10.164553240803071, 1.7949195401380684],
            [-10.1646569721272, 1.7895305956627432],
            [-10.166341570089193, 1.7850643793950627],
            [-10.169603779070952, 1.7824016815006642],
            [-10.173670145370892, 1.7819399900631105],
            [-10.175855238340795, 1.7767393037304127],
            [-10.164775154124841, 1.776099929256693],
            [-10.16114613133075, 1.771168536224476],
            [-10.163993672644995, 1.7659912210421558],
            [-10.163085721462824, 1.7553792865402833],
            [-10.16662014333999, 1.7511726098538887],
            [-10.167435173648242, 1.7460673333003003],
            [-10.169995982931544, 1.744716028355678],
            [-10.174640312072553, 1.738237432089111],
            [-10.181115206503398, 1.740679718251223],
            [-10.185272222166988, 1.7404653064290907],
            [-10.187648066036564, 1.7314036445078498],
            [-10.183392910350545, 1.7274501430973281],
            [-10.178436572206133, 1.7191591085581734],
            [-10.182603009545197, 1.7173352158079418],
            [-10.189320926588788, 1.7187624656325797],
            [-10.191885866518879, 1.7102223515135249],
            [-10.196057241656623, 1.707349204018674],
            [-10.196609919459993, 1.7039734394322599],
            [-10.202003442645294, 1.7019664679836952],
            [-10.202837573427097, 1.6988273294093503],
            [-10.206270866056482, 1.696482440387811],
            [-10.207264492174657, 1.693003869739739],
            [-10.2046548361328, 1.6866018853693954],
            [-10.20189489734905, 1.6849606823408116],
            [-10.200538064669402, 1.6812216651160081],
            [-10.20374905629494, 1.6760455071922613],
            [-10.206974253332532, 1.6740571545698524],
            [-10.211132606530931, 1.673892764113701],
            [-10.21476271118501, 1.6704102958416633],
            [-10.218105302069697, 1.6639340694481564],
            [-10.21812207825173, 1.6566622922028948],
            [-10.213157224163183, 1.650852289573763],
            [-10.213293625448854, 1.6441307857415124],
            [-10.216013993006845, 1.6391551183318545],
            [-10.215474270591217, 1.6370357110031581],
            [-10.218927306107396, 1.633201312546746],
            [-10.22739625142324, 1.6332377804074107],
            [-10.230841074167806, 1.6312796438297041],
            [-10.227378704369563, 1.6273949100571121],
            [-10.22563498426373, 1.6221756184494187],
            [-10.222869239941451, 1.6200525096051022],
            [-10.216233594489092, 1.6196638869130966],
            [-10.21539113290467, 1.6167364386064884],
            [-10.21693431037809, 1.6076010279378592],
            [-10.21587604036661, 1.6021840157998883],
            [-10.216259117155548, 1.5948204973978026],
            [-10.213640621906128, 1.592253572153715],
            [-10.211748553450366, 1.585342782126621],
            [-10.214722521618343, 1.5784944978147601],
            [-10.22016188500171, 1.574731167031507],
            [-10.221982054617172, 1.5647928516573777],
            [-10.221991131703112, 1.564794200311516],
            [-10.253885570516246, 1.5695290112528526],
            [-10.457088159255166, 1.6006579636353657],
            [-10.660297302418956, 1.6317436398662013],
            [-10.68525951199244, 1.6354133922747214],
            [-10.776948068404318, 1.649470459089993],
            [-10.851444205928757, 1.6613882357257577],
            [-11.018187983792817, 1.688085291736258],
            [-11.019683930174915, 1.69409083475576],
            [-11.015769423031664, 1.6964567773998929],
            [-11.015878467150108, 1.7022731380510487],
            [-11.012733163778028, 1.705235254073518],
            [-11.01261970910513, 1.7090601969431454],
            [-11.016219758300297, 1.714337304250163],
            [-11.016241777974933, 1.7243056584801535],
            [-11.017639163717694, 1.7270357361685917],
            [-11.01756114151478, 1.733666105775057],
            [-11.015904626559157, 1.7409604414080126],
            [-11.019009168905976, 1.7486293288547023],
            [-11.021769370898504, 1.751309965411399],
            [-11.024071316725749, 1.7574661216498024],
            [-11.029844177269847, 1.759764186992291],
            [-11.02950904665857, 1.7709995956976359],
            [-11.03434670853137, 1.7746054601751007],
            [-11.032221375848346, 1.7787096754653777],
            [-11.034432408091005, 1.7857213222263248],
            [-11.033243478385435, 1.7886615347703614],
            [-11.029547578601735, 1.7910976694999565],
            [-11.033374576217382, 1.7945140465667577],
            [-11.032988199890584, 1.800785260698225],
            [-11.034899531422226, 1.8029167434247528],
            [-11.0349855747427, 1.8149888655910023],
            [-11.03685068332385, 1.8313242029339116],
            [-11.036427340007084, 1.8382851552016284],
            [-11.040354127284587, 1.8402857035958258],
            [-11.04339248094613, 1.83406441268075],
            [-11.050094151724165, 1.8326844175994663],
            [-11.050646168922887, 1.8266707659718402],
            [-11.053643484420853, 1.8269265643235737],
            [-11.055708685655162, 1.8241050841699817],
            [-11.059545102121778, 1.823678502151688],
            [-11.063128884814939, 1.8271221333086187],
            [-11.063994326345826, 1.8306498154049708],
            [-11.066927745204602, 1.8324685569571093],
            [-11.069388666833468, 1.8440468201290199],
            [-11.074292992856419, 1.8473880123923845],
            [-11.076207745254354, 1.8504227395630715],
            [-11.075500347315051, 1.8560179695385979],
            [-11.078442103431309, 1.861485745057802],
            [-11.076994516441903, 1.866085922758848],
            [-11.077563504634929, 1.8729453702118215],
            [-11.083880054058318, 1.878283960153839],
            [-11.081514663360029, 1.8897265177183709],
            [-11.086236555692496, 1.8945079945579288],
            [-11.086922331682858, 1.9003216154937346],
            [-11.091651958195289, 1.9047757824402773],
            [-11.093891404707453, 1.9103293852903576],
            [-11.091084802710016, 1.9256680412558678],
            [-11.096914279223078, 1.9304556820371277],
            [-11.09633786882958, 1.9354381212883875],
            [-11.099935090199162, 1.9364954831912817],
            [-11.101270929490958, 1.9399414550257652],
            [-11.10864513664793, 1.9423925792486099],
            [-11.091154322409267, 2.050588731085896]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.58871295227779,
          "lat": 39.64813437598114
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49007"],
        "coty_name": ["Carbon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carbon County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01448018"
      },
      "bbox": [
        -11.10864513664793, 1.5647928516573777, -10.06191822649142,
        2.050588731085896
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.88962871795713, 8.128262086300664],
            [16.95028864145129, 8.114469119779299],
            [17.010774960656704, 8.10095913767856],
            [17.01501933146681, 8.100260352842621],
            [17.01270566371551, 8.091207675734891],
            [16.991799652506142, 8.003568076690906],
            [17.078760281710252, 7.983624758610932],
            [17.080722540142144, 7.983627564319192],
            [17.079093838167896, 7.9743247000646],
            [17.059094975834846, 7.895963525741703],
            [17.056815394216823, 7.888693569588225],
            [17.055041283593027, 7.882061519455901],
            [17.044967472470343, 7.83984637474697],
            [17.038322510130538, 7.815540734220395],
            [17.038663226873602, 7.813201862936031],
            [17.035720274120475, 7.8012564994411555],
            [17.03595460339518, 7.799417536658918],
            [16.95077413748133, 7.83491707535272],
            [16.950030517313127, 7.829193461742648],
            [16.93116289587874, 7.746986039309345],
            [16.87931202831528, 7.761578552398756],
            [16.84348280764179, 7.7708437920400595],
            [16.814132429589968, 7.772888351809392],
            [16.78923697366618, 7.774337471875743],
            [16.801796003450843, 7.82553323526005],
            [16.780619432636453, 7.830696147591732],
            [16.78764202325553, 7.863418752392828],
            [16.77489159093668, 7.864346163867778],
            [16.746219836007665, 7.887008466401673],
            [16.698269672119054, 7.927855433699706],
            [16.688261379168612, 7.9274621892818375],
            [16.686171460272114, 7.9358749327822995],
            [16.682831027375002, 7.938935247847881],
            [16.684973248790616, 7.9439385445107975],
            [16.689220668165117, 7.940980309803096],
            [16.699431664100093, 7.943642081015599],
            [16.700411037912907, 7.948187786027204],
            [16.70484111081644, 7.954486035219724],
            [16.71972910657172, 8.014859221195161],
            [16.764307977078122, 8.004927006091286],
            [16.761744863352465, 8.042895715921047],
            [16.760943217079138, 8.058458057106698],
            [16.764539345146247, 8.058668950670258],
            [16.7632378907292, 8.080662383391456],
            [16.77047121602148, 8.081063679157033],
            [16.769630916340642, 8.094547347050952],
            [16.7762693835942, 8.0950326909628],
            [16.772097421974138, 8.108503963401235],
            [16.780910859444734, 8.124943638284789],
            [16.86114447929693, 8.141137198713583],
            [16.86010876224856, 8.136203687142505],
            [16.875190785331572, 8.130967005592405],
            [16.876799733826097, 8.134684717666364],
            [16.88962871795713, 8.128262086300664]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.64181513916994, "lat": 44.60702105006542 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50015"],
        "coty_name": ["Lamoille"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lamoille County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01461764"
      },
      "bbox": [
        16.682831027375002, 7.746986039309345, 17.080722540142144,
        8.141137198713583
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.910417140001522, 0.40878973690987197],
            [12.90938108369227, 0.41371448449102305],
            [12.911791588445045, 0.4261307058336454],
            [12.915178384122516, 0.43064263526860364],
            [12.919115979746921, 0.43884328109360937],
            [12.923854513045427, 0.4447255066689936],
            [12.924322387006463, 0.44749643143959084],
            [12.928789081879662, 0.45643669348478505],
            [12.925862923623683, 0.45803304837659825],
            [12.918335349853757, 0.45922948139018377],
            [12.910421003444325, 0.47833214492193904],
            [12.911563831796487, 0.48134202468306025],
            [12.918271512873678, 0.48369009915364575],
            [12.921171067844023, 0.4885519964833316],
            [12.920561852184244, 0.49373079185299035],
            [12.922093806423726, 0.4994308676045224],
            [12.926577849313666, 0.5048608048610029],
            [12.92458677526288, 0.5125715075809503],
            [12.926930201826858, 0.5133539488153069],
            [12.92731186597984, 0.5180310651844569],
            [12.924830046283176, 0.5185034044191839],
            [12.923562562835867, 0.5226631449790727],
            [12.924197439780714, 0.5282245219395628],
            [12.920282320247303, 0.5299979069401478],
            [12.923454098819278, 0.5346455344154363],
            [12.92412174332929, 0.538890023293255],
            [12.930406090909706, 0.5405593081797581],
            [12.935597022288917, 0.5455918196583427],
            [12.93866192651779, 0.553105909057225],
            [12.938863434630798, 0.5580413396490989],
            [12.947369310661957, 0.5660170695691926],
            [12.95702150474675, 0.5809163497177354],
            [12.960913477423416, 0.5888883210764545],
            [12.965617863102407, 0.5920044973570494],
            [12.967451796215284, 0.5991567982088313],
            [12.974095898816973, 0.6016015095308604],
            [12.976365749430267, 0.6036541151763034],
            [12.977726375710565, 0.6108424099023393],
            [12.981880788943796, 0.6123768202697528],
            [12.985534034828035, 0.6107393578664291],
            [12.989680731029516, 0.6148240889653979],
            [12.98843621765476, 0.6181930343877547],
            [12.990374603740705, 0.6239934820532639],
            [12.994914215593202, 0.623536640254295],
            [12.998400379139712, 0.6264735864256818],
            [13.001518832492962, 0.6320712531148591],
            [13.00180366662241, 0.6312376898261459],
            [13.033923904049072, 0.6156958486931299],
            [13.078191607786197, 0.5989698078378572],
            [13.120078625780893, 0.5981537287693365],
            [13.192592547971692, 0.5959200345020722],
            [13.234019180417798, 0.5843204193852406],
            [13.23501298065657, 0.5808142637304384],
            [13.22742996307991, 0.5762023559660231],
            [13.224245692084208, 0.5729025844819735],
            [13.229898624514336, 0.5655775443481624],
            [13.227668983482266, 0.562303405454961],
            [13.222315388050635, 0.558300114141557],
            [13.223767170745363, 0.5539349956952502],
            [13.22758381855564, 0.5538865067487582],
            [13.234820637612493, 0.5584681250697294],
            [13.240743791889074, 0.5593778373948537],
            [13.243396303640152, 0.5621412054261323],
            [13.248343759001438, 0.5705683992188185],
            [13.25350010227106, 0.5754558656798567],
            [13.25921314538282, 0.5783665134838151],
            [13.264695261260897, 0.5771495398910288],
            [13.26888268347907, 0.5748401642946113],
            [13.272002122932797, 0.5769179332069305],
            [13.278017005782445, 0.5742750466201744],
            [13.28289453648143, 0.5767393238331068],
            [13.28667306454421, 0.5810991021265896],
            [13.294693769353238, 0.5773678552831863],
            [13.29367189851092, 0.5691065970187306],
            [13.291167437231685, 0.560675767590691],
            [13.282676518134878, 0.5437530450327075],
            [13.276736955989596, 0.5345225202440395],
            [13.273436464642591, 0.5260155751527165],
            [13.26335286620055, 0.5022873533682679],
            [13.273107016626128, 0.49443385813669755],
            [13.265920128564286, 0.4762863210570131],
            [13.26468187811539, 0.4709677132379782],
            [13.257945828350229, 0.45624498404058367],
            [13.253106512275028, 0.45320727756729356],
            [13.248876928131278, 0.44420367315946363],
            [13.260100242872644, 0.44007605761352764],
            [13.252478596559792, 0.42430957138486947],
            [13.247354906014108, 0.410514161781366],
            [13.247858558318814, 0.4048389211255642],
            [13.243226990332067, 0.4031080103612929],
            [13.239162829011205, 0.3880003656027696],
            [13.23472983849997, 0.3786206970768039],
            [13.219800032081569, 0.35013644347568745],
            [13.214825060643973, 0.3428814926824965],
            [13.20957770285707, 0.337314960841874],
            [13.206442870318375, 0.33197249379582466],
            [13.202051972838191, 0.32779829669212784],
            [13.197385292950564, 0.31407568518343426],
            [13.195265527806647, 0.3057496638774114],
            [13.192329492139866, 0.2999867189469459],
            [13.192553405804585, 0.29515802905642374],
            [13.189917554236876, 0.2831767367763916],
            [13.183048255638903, 0.26188104201842666],
            [13.178644521446172, 0.25427859294199734],
            [13.173467646073602, 0.2577222158361395],
            [13.167922492589778, 0.24889037978328912],
            [13.16082333999251, 0.23599249203282904],
            [13.153419853274874, 0.2259105936021452],
            [13.127618898334513, 0.24583600129146585],
            [13.102955844895574, 0.2591816111511541],
            [13.058379152250742, 0.2467114674318672],
            [13.02122786937752, 0.24754196576223014],
            [12.995293680469928, 0.24837558352401076],
            [12.989078743692675, 0.25249903311536864],
            [12.954097846391019, 0.2959240026140563],
            [12.949579067488651, 0.30235741289875734],
            [12.947804364075234, 0.3031670536740971],
            [12.917351402614758, 0.2973314505905687],
            [12.909603674711008, 0.2989928057809113],
            [12.904092094880522, 0.30207581567803643],
            [12.897767704751722, 0.2998800574234802],
            [12.895584008979556, 0.30056192388796776],
            [12.889883573250906, 0.29364243624980996],
            [12.883465345875038, 0.2875389322679471],
            [12.883362608887808, 0.28551702225389947],
            [12.878848204642049, 0.27979154520436916],
            [12.85503984772421, 0.28525621323546907],
            [12.860258405980069, 0.29147266845133885],
            [12.867867851494548, 0.30345420138840984],
            [12.875638162236784, 0.3139770443360992],
            [12.88287932345641, 0.32273040928689184],
            [12.882871360606089, 0.32721534864009955],
            [12.889624810763989, 0.3325969166340426],
            [12.893135457895323, 0.3416224611475094],
            [12.89285883808679, 0.3485990365886795],
            [12.895692668203191, 0.35460492756989614],
            [12.898589252669982, 0.3560563246001905],
            [12.898148505678122, 0.3610803794213815],
            [12.900817889397032, 0.37017566648321804],
            [12.904258916397062, 0.3733005950497313],
            [12.905624265556483, 0.3797066723771318],
            [12.903632805235354, 0.38336459089036523],
            [12.906713652993462, 0.3917816457813189],
            [12.910417140001522, 0.40878973690987197]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.7410493189375, "lat": 38.05868387476522 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51017"],
        "coty_name": ["Bath"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bath County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01673638"
      },
      "bbox": [
        12.85503984772421, 0.2259105936021452, 13.294693769353238,
        0.6320712531148591
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.397425314330203, -1.4000981612564456],
            [10.407537084283002, -1.3983419046949443],
            [10.413073731604424, -1.395977381899198],
            [10.416553457093054, -1.3962276433044545],
            [10.42647535976323, -1.3936863056680702],
            [10.43539374515726, -1.3890361694348856],
            [10.447193521558864, -1.381354244754332],
            [10.447226784627045, -1.3786005675833048],
            [10.453527355155533, -1.3705273631436994],
            [10.467350692142562, -1.3624726530531739],
            [10.469851700675958, -1.3602035550682332],
            [10.472976932494863, -1.3608039454477652],
            [10.485642774206806, -1.3512677669213131],
            [10.50604671936394, -1.3415044577978057],
            [10.512384751793777, -1.3373946425151806],
            [10.527250587740047, -1.3329522713524444],
            [10.536364349548231, -1.3274482715239067],
            [10.541175432420276, -1.3262910724478292],
            [10.545323213369164, -1.3231860160253486],
            [10.551589169515768, -1.3215264529435404],
            [10.558354893197924, -1.3170489539521124],
            [10.565928153906352, -1.314396831508375],
            [10.578234688346813, -1.3082519944808004],
            [10.597104909526962, -1.2973450972320946],
            [10.623085202617345, -1.2934122371956174],
            [10.626547553766397, -1.2905988387478606],
            [10.634939173531755, -1.2898641746791728],
            [10.642390707504731, -1.2875258261706233],
            [10.645725127423315, -1.2802466124081477],
            [10.648069037287218, -1.2788678928430406],
            [10.646339347497367, -1.2719359915750477],
            [10.647558267256276, -1.2685752897600058],
            [10.642568040794668, -1.265793500614934],
            [10.643117531140744, -1.261663224828801],
            [10.641432912603943, -1.258684767054205],
            [10.643759902044152, -1.2540322124790804],
            [10.639401225831977, -1.247057876959231],
            [10.640253557983046, -1.244723049089811],
            [10.646715803052881, -1.2425559941714341],
            [10.649622027555266, -1.2392289672749588],
            [10.654703298544959, -1.2274754965376657],
            [10.659894151832074, -1.2203479190641857],
            [10.662470107783744, -1.2122535214392216],
            [10.660967195871262, -1.2035953029307276],
            [10.657855843757776, -1.197805491657597],
            [10.659764876084445, -1.194794105642825],
            [10.665379698807241, -1.191378292385408],
            [10.668237358318958, -1.1871162918167424],
            [10.677135991774785, -1.1831486554192137],
            [10.67768789698807, -1.1789977887185872],
            [10.675494184757325, -1.1734905036123737],
            [10.677302271566791, -1.1691677392011406],
            [10.684452954466398, -1.1711436502754542],
            [10.686913424187331, -1.1686670889822892],
            [10.69731657649678, -1.1692792902563032],
            [10.701200603210335, -1.1660975587889961],
            [10.713063075152286, -1.1633487515573218],
            [10.717744628753575, -1.168309818509408],
            [10.725418130623494, -1.1700063966011633],
            [10.730440134745686, -1.168704455562367],
            [10.73170930842154, -1.1645559670194203],
            [10.735290378844402, -1.1591304366175768],
            [10.742535891412912, -1.1555783104784072],
            [10.749901439649538, -1.153996907959997],
            [10.757223205604006, -1.1550325074578467],
            [10.763852799259146, -1.1491755281432414],
            [10.770629878380023, -1.1445549276120144],
            [10.781551399158827, -1.1419011229997114],
            [10.792531849382632, -1.133604977062538],
            [10.80391004226974, -1.131232926121105],
            [10.804349211602005, -1.1260418173949585],
            [10.812553352433104, -1.1224531039598509],
            [10.816506689035885, -1.1197215252013155],
            [10.820163541964687, -1.1149436260252172],
            [10.824762018003284, -1.1131757462527734],
            [10.824599021090577, -1.1099263306878753],
            [10.828479694542784, -1.111378106877691],
            [10.834270820989142, -1.1168818565329575],
            [10.839901758304794, -1.1249361365161448],
            [10.848939855788165, -1.1300463866587829],
            [10.848546421767411, -1.1348964638963444],
            [10.853859355742344, -1.1380134090416199],
            [10.8559123299278, -1.1411999078279755],
            [10.852530200973456, -1.1446581387584167],
            [10.852880507807882, -1.148511841250436],
            [10.857237024494307, -1.1520971245144553],
            [10.861411898173202, -1.1497716952034693],
            [10.86445303749983, -1.1501693732632678],
            [10.876993229139757, -1.1597328886261649],
            [10.921231557914584, -1.1909948165065796],
            [10.918014262239208, -1.1984537980750518],
            [10.911401983749377, -1.2048046514456014],
            [10.910764024410236, -1.2097352724268455],
            [10.908522038013105, -1.212775287047764],
            [10.91022838620422, -1.21563305874343],
            [10.902416020330504, -1.2159670106408205],
            [10.895810964728193, -1.2223150085545411],
            [10.882869664940435, -1.2501820569524429],
            [10.887628708425053, -1.2530293206348508],
            [10.889842512529455, -1.2630862423549583],
            [10.886857755872505, -1.2676127240873893],
            [10.87483453725431, -1.2782554854635109],
            [10.869051201949594, -1.2827579460951948],
            [10.865839791256668, -1.2838570605897],
            [10.84879578021839, -1.2931478816217659],
            [10.84283812669784, -1.2970005971610528],
            [10.833932543069173, -1.3040465540040282],
            [10.828921434810177, -1.3094795804426758],
            [10.809293701000062, -1.3253497506080167],
            [10.800146713034536, -1.3343701903395273],
            [10.781927347655069, -1.4205714986593667],
            [10.747842970591293, -1.425093085143728],
            [10.632576900057211, -1.440872419961394],
            [10.564439084907928, -1.4500503194691414],
            [10.551878897405357, -1.4473634429481452],
            [10.4742688120524, -1.45858710303105],
            [10.397657237127389, -1.4688847186126797],
            [10.330865606035923, -1.477605008158624],
            [10.278884219063809, -1.483739912479101],
            [10.260524333502422, -1.4841658452728408],
            [10.236917153213385, -1.486451159722707],
            [10.238206827003072, -1.4823157614472104],
            [10.24397674024497, -1.4804436605875748],
            [10.24942120679455, -1.4736263638454783],
            [10.25524566185446, -1.4678774442895206],
            [10.255405881092678, -1.4617495983258124],
            [10.261831999578382, -1.4587722770529048],
            [10.265864387053316, -1.4601788603226777],
            [10.27344540079677, -1.4568458432518918],
            [10.277098137671121, -1.4535175766521837],
            [10.280567184868245, -1.446955934490406],
            [10.28708249517074, -1.442234043951211],
            [10.289249642215069, -1.442865987485493],
            [10.295610833994528, -1.4380993177160157],
            [10.308858655517305, -1.4353029714860113],
            [10.310557942985954, -1.4326019623542894],
            [10.317450444273513, -1.4280676664264218],
            [10.319190538111643, -1.4242738247500553],
            [10.325557886465017, -1.4208908291914275],
            [10.33082285323137, -1.4194848456242215],
            [10.334878774830875, -1.4168126166623818],
            [10.34103272610082, -1.410605799207225],
            [10.341568617186576, -1.4073792417924398],
            [10.353749756088378, -1.4031235814037388],
            [10.35693824898652, -1.4011753159356328],
            [10.36505081858704, -1.400103057544544],
            [10.370825495254412, -1.3983211731412335],
            [10.380243196758203, -1.4010451305124703],
            [10.393142334722535, -1.400847694891485],
            [10.397425314330203, -1.4000981612564456]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.12850862277041,
          "lat": 36.705423372039164
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51105"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01496538"
      },
      "bbox": [
        10.236917153213385, -1.486451159722707, 10.921231557914584,
        -1.1099263306878753
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.989040314705973, -0.3981004026661045],
              [12.989177320532429, -0.4035799289603226],
              [12.987497296252585, -0.40833108714785066],
              [12.989045848038948, -0.4118148443261747],
              [12.995890584007963, -0.4166432300977705],
              [12.99868273439166, -0.4133244054138944],
              [13.003176994473758, -0.41077346469893955],
              [13.014240525904608, -0.40830670781306216],
              [13.018265235167032, -0.4041302182573799],
              [13.01909034485342, -0.41085219985764415],
              [13.025521312374266, -0.41597797010236526],
              [13.031441704318736, -0.41827111504039033],
              [13.034633704099907, -0.42102097291611723],
              [13.037166542890512, -0.41821883781138514],
              [13.042885191227759, -0.4230805441445895],
              [13.047359948118, -0.4309346464953224],
              [13.056358118226093, -0.438041486663122],
              [13.064828722849986, -0.4362728566838691],
              [13.065104078036589, -0.4261457682945698],
              [13.070675197686734, -0.4208338472121726],
              [13.079024366731737, -0.42364431255194424],
              [13.080211318321753, -0.42176888937402013],
              [13.080748162181298, -0.4056256795431441],
              [13.0814166610533, -0.4044963533873262],
              [13.091887043857104, -0.3992876307222554],
              [13.09109233566455, -0.3952665544626593],
              [13.093262799268217, -0.3857967663303448],
              [13.090526006104145, -0.3864542887350161],
              [13.085959898471692, -0.3837642894693039],
              [13.0908692831918, -0.381582996049422],
              [13.088297419169336, -0.37798972580663837],
              [13.087974737276292, -0.3728573751511972],
              [13.08293146774906, -0.3666932670256106],
              [13.075859283758058, -0.36535723386439406],
              [13.083766609633484, -0.3605752390608451],
              [13.086731443646245, -0.36224824276251405],
              [13.093578011733722, -0.35773658383761175],
              [13.100473475496678, -0.34748712793150516],
              [13.102558862032723, -0.3489853210082421],
              [13.097285338126419, -0.35511479233638155],
              [13.10144310481412, -0.3576464268516542],
              [13.10446069493831, -0.3487251947217892],
              [13.100992994667081, -0.33859512695884586],
              [13.101824746419586, -0.33672239611065075],
              [13.093686653876228, -0.3326933120261079],
              [13.078467049831726, -0.3224967048770371],
              [13.073380283491858, -0.3256116975866094],
              [13.067947696547032, -0.3252870868415038],
              [13.064493649649885, -0.31942962010438736],
              [13.059047987494093, -0.32577733748768906],
              [13.050186755784106, -0.3267352555327812],
              [13.046986542218962, -0.32878377170917983],
              [13.043346565228436, -0.3239662725545553],
              [13.037180435052678, -0.33128094759525384],
              [13.031611743195734, -0.3191421352768755],
              [13.028560584514633, -0.3171215674034574],
              [13.019656482963564, -0.32175433561025435],
              [13.009485346062474, -0.33135176053977305],
              [13.002266330087624, -0.3418254558375872],
              [12.99544972883362, -0.3423635984344131],
              [12.99301413132975, -0.34479275008687243],
              [12.990094462433984, -0.35137510058352317],
              [12.985202259289789, -0.3494521959496862],
              [12.98448448129792, -0.34548032479910273],
              [12.979897514755635, -0.33797792090908196],
              [12.975692580450206, -0.34159036427831035],
              [12.968704074664982, -0.34538127419253684],
              [12.958557026698633, -0.35400746459572935],
              [12.944520609568608, -0.3697473317000803],
              [12.93395025239238, -0.37594811819210655],
              [12.929524099982949, -0.3736500414874936],
              [12.925569244216241, -0.376258185231728],
              [12.927756320852689, -0.37909013802503433],
              [12.91943271474818, -0.38380529554653914],
              [12.926671813940649, -0.3921369432995935],
              [12.93086010961529, -0.39234959906905337],
              [12.938950313947887, -0.38649400482453816],
              [12.943038050868376, -0.38604090947887765],
              [12.949537990735656, -0.39575737442202585],
              [12.952613312287435, -0.3968523662294173],
              [12.951204276196, -0.402483345249322],
              [12.956136266115726, -0.40408562963289246],
              [12.958123090880012, -0.40930519265225274],
              [12.965169225601944, -0.4047130657628511],
              [12.974054950847602, -0.410094760030451],
              [12.977059130782086, -0.41107908491771017],
              [12.980469865788368, -0.4088093928389705],
              [12.980862035586231, -0.40417430651711933],
              [12.98364578024157, -0.40014671112401845],
              [12.989040314705973, -0.3981004026661045]
            ]
          ],
          [
            [
              [12.798182693241923, -0.34971144157011425],
              [12.802447632395209, -0.34492603571762037],
              [12.805811421525252, -0.33793425119722204],
              [12.814216595960188, -0.33097391671374193],
              [12.82240471825196, -0.32184953465255356],
              [12.827439685056643, -0.320096807663889],
              [12.832076689196544, -0.3170230994247907],
              [12.839029978739918, -0.30941076043576693],
              [12.840082603253288, -0.30498813792643026],
              [12.880307226300838, -0.29393638741657047],
              [12.8814363791644, -0.2911924718883647],
              [12.886597546483669, -0.2859958688899938],
              [12.910111938884539, -0.26526497750579503],
              [12.913637725724127, -0.2599619915436674],
              [12.918487348184508, -0.2566194570476279],
              [12.920740128768543, -0.2534000108353417],
              [12.930572170397237, -0.24457200345546634],
              [12.94187131812171, -0.25714537952779665],
              [12.978233572917745, -0.26821762310473896],
              [13.029099973332613, -0.2832602515591766],
              [13.039946591345867, -0.2867255195776357],
              [13.108674581781129, -0.31058251946365273],
              [13.12560858995307, -0.32721028762134174],
              [13.131886351252055, -0.33259646508542745],
              [13.132760228243898, -0.3374491809385689],
              [13.12578494042717, -0.34177412459213175],
              [13.12789208599797, -0.3490604951587034],
              [13.127669444756755, -0.35445375226645043],
              [13.130654042175216, -0.3579812519108432],
              [13.129081615212048, -0.3631645417069284],
              [13.124325674381014, -0.37066096896923156],
              [13.13035695305426, -0.376582747239006],
              [13.130215693872739, -0.37904115968011787],
              [13.13697140586277, -0.3887447024805216],
              [13.137676811842036, -0.3948546120006231],
              [13.141373627332763, -0.4004767277954119],
              [13.14298614921067, -0.40523328731921665],
              [13.140146389141165, -0.4107181332825834],
              [13.136791290248002, -0.4130108199964289],
              [13.13821031942553, -0.4216505993190909],
              [13.132766569859886, -0.42416091298570013],
              [13.130834765630478, -0.42041275472871803],
              [13.122520913537919, -0.42386199821627163],
              [13.12029891716889, -0.4274450292313053],
              [13.11534478335349, -0.43104710063414065],
              [13.113263964041389, -0.44106348547268137],
              [13.108338530800902, -0.4429041453180091],
              [13.111768243540647, -0.4548834718956846],
              [13.110331192151879, -0.4604633157656297],
              [13.105999707431055, -0.46364119900611506],
              [13.101225789794137, -0.46450457867770845],
              [13.098172772734173, -0.46754017642921214],
              [13.099332292669255, -0.47458208877483776],
              [13.097487008696966, -0.4798582940366764],
              [13.09384095740567, -0.48486938895177384],
              [13.087272734954258, -0.4884697797548207],
              [13.082364123817449, -0.4939670446615337],
              [13.081715727592368, -0.49688729772882373],
              [13.075910475684786, -0.4988608009350945],
              [13.0718799504911, -0.5103447131511004],
              [13.065232194429727, -0.5138055808864702],
              [13.061877352242599, -0.5122916617900674],
              [13.05736797384045, -0.5128054887915529],
              [13.054754037994742, -0.5094700702199273],
              [13.043348647158458, -0.5112364380535808],
              [13.041270988886144, -0.5083471582480881],
              [13.040460152663767, -0.5021616908338578],
              [13.032941238210803, -0.5045602591870241],
              [13.028416658592064, -0.49696362143221423],
              [13.030852335249241, -0.49070481658992654],
              [13.026998053341892, -0.48902868896312324],
              [13.023143542829942, -0.48467321873477315],
              [13.012496960714122, -0.4888126801398176],
              [13.006112751094854, -0.48541520942562816],
              [13.003811516438258, -0.48944009429148183],
              [12.999614527545523, -0.493285438683902],
              [12.991650825924042, -0.4978054805555456],
              [12.98407659904543, -0.4990368793078383],
              [12.975928422439942, -0.5043747412524404],
              [12.975388510057439, -0.5081485235392607],
              [12.971254511469626, -0.5061022297291113],
              [12.965173136984859, -0.5054611554759808],
              [12.962603638220923, -0.5110594785034552],
              [12.963602991307864, -0.5152016933671538],
              [12.957244941286204, -0.5190865947953706],
              [12.952837917932149, -0.5194989307307727],
              [12.951065207861387, -0.5221338572631649],
              [12.952947642145295, -0.5318295548840206],
              [12.949934539112382, -0.5361410648061425],
              [12.945770614105793, -0.5393952391867236],
              [12.942127592305907, -0.5403413868291534],
              [12.942678008135807, -0.5442368175228657],
              [12.938543392316529, -0.5499920786270752],
              [12.935578793438388, -0.5541307037726431],
              [12.931195211510538, -0.5550299670973604],
              [12.92255732475602, -0.5606178350791222],
              [12.922582990906939, -0.5630493243170246],
              [12.914477834286572, -0.5680794513932027],
              [12.911701431081616, -0.5667382275748246],
              [12.90595387650509, -0.5696128859252708],
              [12.901625012450161, -0.5659327140417764],
              [12.898682213272918, -0.5462658183276047],
              [12.872678388678187, -0.453684270598905],
              [12.87144416804947, -0.44869030451429043],
              [12.868353412516672, -0.4449857398803388],
              [12.861388249910206, -0.44173457726394166],
              [12.859808904876378, -0.4369520098401088],
              [12.825454270728217, -0.40176924028918665],
              [12.8066820378432, -0.382176248440536],
              [12.798182693241923, -0.34971144157011425]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.06802411801335,
          "lat": 37.269262469268675
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51161"],
        "coty_name": ["Roanoke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roanoke County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01480165"
      },
      "bbox": [
        12.798182693241923, -0.5696128859252708, 13.14298614921067,
        -0.24457200345546634
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.020412159673482, 0.5641208086758457],
            [14.02172068465164, 0.5720201413470308],
            [14.026303610357122, 0.5717634666930698],
            [14.02938357139995, 0.5758904444798043],
            [14.03523202794191, 0.5769329891885944],
            [14.033257379382546, 0.5813209334932877],
            [14.034273219987234, 0.5852724635603701],
            [14.031511378642737, 0.5872808502528454],
            [14.029868628525346, 0.5797502543987331],
            [14.024020390517572, 0.5794969552464384],
            [14.022338643923337, 0.5862115042792031],
            [14.029188056008657, 0.5890011782640167],
            [14.030250793314666, 0.5915757810457931],
            [14.025454819087892, 0.5954755696009162],
            [14.026459604999033, 0.600107942302965],
            [14.031534203431837, 0.6028717697589554],
            [14.029681202215741, 0.6050154555302459],
            [14.034427522060652, 0.6109056497742593],
            [14.037712320921193, 0.6079821734644223],
            [14.04129031107532, 0.615920149609869],
            [14.048035287119966, 0.6130237441930614],
            [14.049732097983766, 0.6160704134689476],
            [14.05553721821319, 0.617401900751981],
            [14.058020978542558, 0.6146492114014179],
            [14.05428771058151, 0.6014661243056147],
            [14.057041503399377, 0.5960385460882838],
            [14.060218274133465, 0.5955434436291466],
            [14.061114180485763, 0.5996694650053791],
            [14.064747928867384, 0.6018381653506553],
            [14.070662005382943, 0.6110020604519941],
            [14.074730077092177, 0.6020751139084358],
            [14.074330684197648, 0.5981915042904156],
            [14.069034375075878, 0.5967555394288235],
            [14.070643689181683, 0.5908567280665628],
            [14.067306665431852, 0.5840056820842118],
            [14.074218053499134, 0.5797007746383025],
            [14.07347165002264, 0.5732654971538758],
            [14.067609553328726, 0.5731203181495095],
            [14.064176881964649, 0.567717610583533],
            [14.063920314159162, 0.5613555267931649],
            [14.058685869082506, 0.5632203942890514],
            [14.053493402421848, 0.5597325744870146],
            [14.052701844360277, 0.5625566352914302],
            [14.047799178256247, 0.5643053129639629],
            [14.03827410729421, 0.5549887505979479],
            [14.033100794224149, 0.5535881641365756],
            [14.026036739278437, 0.5531786609781796],
            [14.024649922086839, 0.5596564266539473],
            [14.02204171011134, 0.560112125767237],
            [14.020412159673482, 0.5641208086758457]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.48569031175465, "lat": 38.03720933508216 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51540"],
        "coty_name": ["Charlottesville"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Charlottesville city"],
        "coty_fp_code": "540",
        "coty_gnis_code": "01789068"
      },
      "bbox": [
        14.020412159673482, 0.5531786609781796, 14.074730077092177,
        0.617401900751981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.652211989644663, -1.022647659470618],
            [13.57181822174862, -1.0367937186548948],
            [13.552769721544093, -1.0403402681379674],
            [13.553205763775876, -1.0357348704518143],
            [13.548232785446356, -1.0303364277080473],
            [13.54771663846452, -1.0211451524137054],
            [13.556439613872818, -1.0108632008658225],
            [13.55711468098624, -1.0027371639566747],
            [13.538741726791043, -0.9983771493557015],
            [13.533037437680182, -0.9999698041809553],
            [13.530062497516713, -1.0037476965614194],
            [13.522686073846227, -0.9968461395280951],
            [13.520944306801551, -0.9926567577033335],
            [13.515529369184014, -0.9919315634750481],
            [13.503536632959316, -0.9864063188182054],
            [13.504068523018377, -0.9822447803768082],
            [13.508687520568659, -0.9818383498744935],
            [13.507768679844077, -0.9759786616233892],
            [13.51212206850979, -0.9698744168916514],
            [13.515056163601683, -0.9679232360457402],
            [13.521273426456233, -0.970621696210879],
            [13.533044429714844, -0.9667563052414336],
            [13.55071180314339, -0.9684230761902145],
            [13.553838076643675, -0.9672184522561311],
            [13.560740051646814, -0.9689910066466171],
            [13.562381563209845, -0.9718497320663871],
            [13.566221201152365, -0.9695371780894644],
            [13.571561439957662, -0.9756127803191231],
            [13.575004944692193, -0.9771054867981233],
            [13.579844781159006, -0.9746027528651361],
            [13.580113223089358, -0.9690523979715688],
            [13.582060074005916, -0.9674137543804757],
            [13.58359755688333, -0.960848342640289],
            [13.581385533187957, -0.9575882532712418],
            [13.58488006544013, -0.949013126381587],
            [13.588735212623149, -0.9430688017235626],
            [13.586232796682022, -0.9395628070889466],
            [13.5876741584699, -0.9312180614148315],
            [13.591080271053242, -0.9280145688033411],
            [13.597337424978322, -0.9317177173253198],
            [13.607350528688979, -0.9352675221101292],
            [13.609153340323472, -0.9323924838209259],
            [13.615089741026454, -0.9329619908870369],
            [13.618796157162258, -0.9509428899554216],
            [13.623470262483135, -0.9595903547896137],
            [13.631183744533251, -0.9565490481268272],
            [13.635529685632013, -0.965390414765392],
            [13.651075993522934, -0.9608375324798321],
            [13.652697143533892, -0.9741959204313047],
            [13.654921194320357, -0.9738971932697185],
            [13.656374599759443, -0.9794080901516548],
            [13.675176113553174, -0.9764593905791844],
            [13.678011603139348, -0.9839125901541734],
            [13.676841070594001, -0.9887879494332704],
            [13.670025727656569, -0.9914097180100548],
            [13.664290229827914, -0.9874199412680466],
            [13.660283064280737, -0.9917766614004443],
            [13.647683640845155, -1.0031226264709348],
            [13.648897132378902, -1.005521770371284],
            [13.643844812183326, -1.013812975966153],
            [13.65039061986564, -1.0197233284188085],
            [13.652211989644663, -1.022647659470618]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.40858793214231, "lat": 36.58305817505808 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51590"],
        "coty_name": ["Danville"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Danville city"],
        "coty_fp_code": "590",
        "coty_gnis_code": "01498421"
      },
      "bbox": [
        13.503536632959316, -1.0403402681379674, 13.678011603139348,
        -0.9280145688033411
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.782685588880094, 1.5578586907909644],
              [14.789171884152845, 1.555747850559881],
              [14.790131351994944, 1.559457665371411],
              [14.782685588880094, 1.5578586907909644]
            ]
          ],
          [
            [
              [14.767754131313726, 1.5603893811323848],
              [14.767311265041583, 1.5627094046029069],
              [14.769686442192743, 1.5745184476007388],
              [14.77801397284256, 1.5782884315090875],
              [14.782491979547087, 1.5788599348571],
              [14.788152503446087, 1.5766868449997973],
              [14.788224378354197, 1.5826959951798971],
              [14.79597878485193, 1.5866886452784636],
              [14.797243523608897, 1.5827334811840146],
              [14.813452300096841, 1.584501942667658],
              [14.815373650366961, 1.5814889620645454],
              [14.817378399691597, 1.5711099156290609],
              [14.81606141909507, 1.566921558395169],
              [14.818486913613915, 1.559597797188374],
              [14.812163604113294, 1.5594425044739986],
              [14.806555654809083, 1.5580605184728853],
              [14.806769626489205, 1.5523406211064366],
              [14.799363608894643, 1.5520910789950078],
              [14.799500525865126, 1.549720343855255],
              [14.790889442527872, 1.549956093578022],
              [14.784797432201803, 1.5482572571680324],
              [14.78186605413726, 1.5529944172845878],
              [14.778565506338166, 1.5540026541805099],
              [14.775399403210125, 1.5572750868544913],
              [14.771278053597568, 1.5568102125127041],
              [14.767754131313726, 1.5603893811323848]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.29999721919697, "lat": 38.85328836080451 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51600"],
        "coty_name": ["Fairfax"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Fairfax city"],
        "coty_fp_code": "600",
        "coty_gnis_code": "01789070"
      },
      "bbox": [
        14.767311265041583, 1.5482572571680324, 14.818486913613915,
        1.5866886452784636
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.430774100366502, 12.47980848292268],
              [-18.42936403608295, 12.477943755130926],
              [-18.42747683289573, 12.469701671584007],
              [-18.431912390967728, 12.469925873231475],
              [-18.430774100366502, 12.47980848292268]
            ]
          ],
          [
            [
              [-18.60316271798318, 12.048478630895247],
              [-18.599730522091548, 12.04473438835984],
              [-18.604177021700878, 12.043959747053385],
              [-18.60316271798318, 12.048478630895247]
            ]
          ],
          [
            [
              [-17.444389029824013, 11.864551681189656],
              [-17.458348072814548, 11.868381245919098],
              [-17.46458528447816, 11.847669374926058],
              [-17.467510280634, 11.832180136767283],
              [-17.472775972101367, 11.81925933648888],
              [-17.47666329819785, 11.805795346228127],
              [-17.48139487495681, 11.792602040599336],
              [-17.485161836016548, 11.779120988775011],
              [-17.49019609924629, 11.765386043392212],
              [-17.49853932054299, 11.738271019212767],
              [-17.502252372172215, 11.724438759901266],
              [-17.505268459178406, 11.70999526343532],
              [-17.508687467639273, 11.696901766142402],
              [-17.513372763671995, 11.683494175628102],
              [-17.58092519610547, 11.70288400559405],
              [-17.648482215105357, 11.722257177495525],
              [-17.735970314289204, 11.747513209577214],
              [-17.805196774220477, 11.767618141896582],
              [-17.874428104595008, 11.787705523927595],
              [-17.870412047372213, 11.800908201620356],
              [-17.932177650909686, 11.81898344794501],
              [-17.993947168479824, 11.83704468289035],
              [-18.059868879222, 11.856857236981135],
              [-18.14229384344621, 11.881078524919266],
              [-18.25356378665404, 11.914383363556306],
              [-18.364846807452878, 11.947642470662359],
              [-18.45922268976557, 11.976363113383709],
              [-18.473055800777903, 11.981736191435576],
              [-18.54210372991755, 12.001096771496933],
              [-18.55563497031393, 12.005029738878454],
              [-18.564667768088597, 12.006979358104381],
              [-18.585059158182702, 12.013077507541423],
              [-18.592415108511553, 12.022786607280482],
              [-18.59408479338002, 12.02787058864513],
              [-18.5924713838581, 12.03195382195538],
              [-18.592634359241003, 12.0390162313284],
              [-18.59682950958073, 12.044338154292593],
              [-18.591809723348902, 12.054305258669157],
              [-18.591326739284618, 12.070588497991288],
              [-18.59322544645616, 12.07912876805902],
              [-18.59846092723465, 12.084151263701889],
              [-18.59631607896857, 12.091422929116304],
              [-18.598855250629644, 12.096014462250393],
              [-18.59566313166049, 12.096731585692464],
              [-18.59486882700238, 12.100197265298718],
              [-18.60016028706218, 12.102809465677527],
              [-18.598083450113826, 12.1069939208503],
              [-18.59898394260914, 12.111321342310726],
              [-18.595921284147, 12.113750199281894],
              [-18.593840771053006, 12.119119319833588],
              [-18.59350742083743, 12.126122572655937],
              [-18.59551431808296, 12.129742145468706],
              [-18.59416087283194, 12.13778916799413],
              [-18.590175589650535, 12.14530900782159],
              [-18.589297331865147, 12.151582656428653],
              [-18.58992211898899, 12.156986399558019],
              [-18.587717842726708, 12.15990466530317],
              [-18.587966052838365, 12.163577241084674],
              [-18.585335063452476, 12.170976516065135],
              [-18.58351291042193, 12.183873604515487],
              [-18.583745263733675, 12.189719064834705],
              [-18.58605612080041, 12.194249140596535],
              [-18.58353032319795, 12.199008120938442],
              [-18.58478226157636, 12.204597073040663],
              [-18.57860940788071, 12.22080560519366],
              [-18.57283738796422, 12.224498429366424],
              [-18.570047326766577, 12.229931739744028],
              [-18.572260144346284, 12.232225608991323],
              [-18.570257450015117, 12.239691053467364],
              [-18.571150166183852, 12.251705014502235],
              [-18.5742456187787, 12.256178073330732],
              [-18.57560427358054, 12.260522186837033],
              [-18.57334761982, 12.26432139402102],
              [-18.576157293627, 12.276414520140921],
              [-18.57623076896529, 12.287136090580363],
              [-18.580513070273696, 12.295761499437189],
              [-18.580575619813384, 12.298814501335405],
              [-18.57770956610798, 12.304639769672091],
              [-18.572551876996638, 12.305554439683837],
              [-18.56333871051846, 12.311536666986301],
              [-18.560377554650774, 12.310897758449377],
              [-18.555730350394498, 12.312576211430965],
              [-18.546386986501663, 12.324108973465954],
              [-18.538910573017883, 12.33604756755548],
              [-18.536482622493192, 12.342535621254102],
              [-18.536571976345513, 12.34679539035522],
              [-18.5395059306266, 12.351850556887067],
              [-18.53845023718244, 12.355585356903099],
              [-18.54051494603547, 12.364188535529332],
              [-18.535430843483653, 12.366712343492521],
              [-18.53438593771236, 12.369774885180075],
              [-18.528165403734334, 12.370988192647527],
              [-18.52236535088326, 12.374209900253339],
              [-18.51694662402021, 12.382820703852436],
              [-18.51339465945353, 12.39378289415165],
              [-18.513965109561788, 12.404250537189736],
              [-18.507445475608744, 12.412659036420807],
              [-18.505251978270863, 12.409455253558805],
              [-18.500372173483548, 12.409198183789536],
              [-18.49734512112576, 12.411288480103885],
              [-18.491609314882247, 12.420817510076917],
              [-18.489960049490232, 12.430271257347846],
              [-18.485902343385483, 12.433850163708566],
              [-18.483542109218885, 12.439241048209999],
              [-18.487651235219374, 12.450905374262643],
              [-18.491279657243762, 12.453399534113569],
              [-18.499692239758993, 12.451963971771248],
              [-18.503383133612402, 12.458711750491196],
              [-18.502240960773936, 12.46385501141388],
              [-18.507720292315113, 12.470415592064999],
              [-18.50576278148023, 12.474633874317409],
              [-18.50832590140896, 12.482478673055688],
              [-18.515371023112014, 12.489475917903803],
              [-18.516327682553815, 12.494931015035442],
              [-18.515484271727395, 12.499694104038982],
              [-18.510218387632666, 12.503007366931364],
              [-18.50341584817834, 12.504748424711064],
              [-18.497790024208463, 12.499298451891258],
              [-18.492698728055906, 12.499742663977578],
              [-18.489649063918993, 12.498319198592975],
              [-18.48695710844648, 12.500130244575091],
              [-18.48085798513947, 12.49792401852805],
              [-18.47689564942096, 12.49829940066627],
              [-18.472948476061408, 12.494154014451727],
              [-18.469630981363704, 12.493035006543701],
              [-18.466249342243593, 12.494575563168157],
              [-18.462355182235644, 12.493194772342028],
              [-18.4518679822259, 12.487483039054485],
              [-18.455001503273955, 12.48573176910863],
              [-18.452342530148766, 12.475811217167855],
              [-18.452289841312307, 12.471468994569669],
              [-18.448868227821592, 12.465955022712365],
              [-18.441883632001602, 12.462718474077182],
              [-18.427333737558133, 12.465275855326476],
              [-18.419484209936243, 12.459223801083604],
              [-18.41804784480908, 12.454996613823617],
              [-18.41241031482115, 12.455004147966125],
              [-18.404700186973816, 12.438167190421787],
              [-18.401016607948975, 12.433306300164462],
              [-18.39270209973861, 12.429911036615163],
              [-18.384861761056317, 12.421684402725823],
              [-18.380158682732773, 12.415014679142539],
              [-18.37676118158695, 12.412837748620133],
              [-18.375100536949883, 12.407642863729183],
              [-18.372127522015592, 12.40693382826649],
              [-18.357708404270046, 12.388987262790616],
              [-18.351633531485348, 12.383934414060462],
              [-18.351322372694327, 12.380159346015889],
              [-18.347600754642865, 12.373435887808217],
              [-18.34267020750717, 12.371328956909089],
              [-18.335285871993722, 12.363858729800988],
              [-18.32700002396755, 12.349098627903977],
              [-18.31873804396867, 12.342489606358008],
              [-18.312029316693952, 12.341067020765502],
              [-18.305364020915064, 12.341388507857054],
              [-18.29961081121062, 12.335998082605657],
              [-18.29442049220438, 12.326344739907618],
              [-18.289867558006097, 12.32391786382293],
              [-18.271044388653223, 12.311503869557466],
              [-18.27359523909902, 12.30575244991855],
              [-18.2717369535452, 12.302002910219993],
              [-18.262980437926547, 12.298403451710563],
              [-18.261890919282028, 12.295314956569179],
              [-18.25298131214342, 12.292250402325044],
              [-18.247110220891912, 12.29340432891304],
              [-18.243028954986233, 12.29578679923519],
              [-18.24104546216412, 12.29900873336578],
              [-18.23381045541924, 12.294513478429042],
              [-18.2307092780131, 12.289450460099575],
              [-18.225355010334223, 12.286207334159203],
              [-18.223163698433044, 12.282039394740279],
              [-18.2128538449348, 12.273282224071604],
              [-18.20900092426713, 12.270743437562864],
              [-18.200175682155404, 12.260804380821067],
              [-18.195644032579207, 12.257094188561549],
              [-18.186033598680506, 12.247275558551065],
              [-18.18142255529944, 12.243377935145563],
              [-18.17656242999622, 12.235077620711875],
              [-18.174051094417912, 12.233339178341144],
              [-18.16812203608742, 12.232724906771024],
              [-18.159048586551272, 12.226052637084367],
              [-18.163017303323677, 12.222778813138023],
              [-18.163086475802345, 12.219324885486476],
              [-18.168304779594866, 12.21489726934076],
              [-18.167739134137285, 12.21164585990402],
              [-18.15868401524175, 12.205501749850027],
              [-18.156112681819938, 12.20204543180742],
              [-18.149516877749964, 12.196739058530905],
              [-18.142852526258366, 12.1868387780018],
              [-18.137494778397805, 12.180019796774726],
              [-18.126494027643915, 12.173287049681614],
              [-18.12165528256652, 12.172312987943616],
              [-18.12152876557734, 12.17009456979759],
              [-18.115295123520067, 12.166331742440292],
              [-18.109986135233733, 12.166420916683935],
              [-18.10551603269526, 12.164798264200341],
              [-18.1057351518586, 12.161420999234442],
              [-18.096352744314874, 12.154661225298206],
              [-18.09166364060519, 12.152851336767723],
              [-18.07339299074641, 12.149566887936452],
              [-18.069955382136506, 12.146546982664862],
              [-18.06777929547136, 12.142229232218765],
              [-18.055752807034725, 12.137165381628746],
              [-18.046552646400077, 12.135586435554188],
              [-18.04174283269488, 12.133229787478932],
              [-18.03656237117565, 12.133173187658157],
              [-18.02789985821388, 12.128359935980548],
              [-18.025545189407875, 12.12362917071118],
              [-18.020632740442775, 12.121650005056377],
              [-18.008188630421696, 12.119638224773963],
              [-18.002024089842386, 12.11987031446034],
              [-17.997977742518497, 12.121904198937111],
              [-17.992344569549914, 12.114493696130767],
              [-17.987198471341216, 12.112288654725296],
              [-17.98105939448653, 12.111547643173848],
              [-17.968283788221438, 12.10743356948151],
              [-17.94684813456483, 12.107322066170772],
              [-17.941653898582544, 12.104457295912587],
              [-17.93793457512946, 12.107468834956402],
              [-17.934498936565966, 12.107252107831945],
              [-17.93320666088882, 12.100893833930934],
              [-17.928829243100985, 12.099125112223415],
              [-17.91967851742217, 12.101181982082107],
              [-17.920571492223214, 12.10567408155725],
              [-17.906173975983442, 12.097675678589257],
              [-17.89809666799973, 12.094161036593695],
              [-17.881377350980078, 12.080504539573285],
              [-17.878745624143598, 12.075953679497648],
              [-17.882545692529476, 12.073937668473686],
              [-17.880553895241558, 12.068515637527142],
              [-17.876627386687133, 12.064164564419887],
              [-17.871411128368237, 12.061223298756424],
              [-17.866496126985005, 12.060909016237044],
              [-17.853356997754215, 12.052980579600739],
              [-17.84823372117169, 12.05297825686476],
              [-17.83713726469949, 12.057397108479229],
              [-17.83535167018696, 12.060634803862373],
              [-17.82308294767326, 12.060766040247758],
              [-17.81418558499, 12.05250526351516],
              [-17.808981677988477, 12.040629896203907],
              [-17.805283588196044, 12.03704994376833],
              [-17.80030340364155, 12.03432684734625],
              [-17.788120695113378, 12.031421356548027],
              [-17.777812026075715, 12.030078827478224],
              [-17.764932446146776, 12.03167192053978],
              [-17.7541122131414, 12.031214849670215],
              [-17.744668746908637, 12.02868174208262],
              [-17.730558770403064, 12.0237254351032],
              [-17.73039925415002, 12.02002271818323],
              [-17.75272536160861, 12.028235309951842],
              [-17.759801287672186, 12.026922287981817],
              [-17.77032860066552, 12.028538833596015],
              [-17.770489983814233, 12.02361176450075],
              [-17.765888989388777, 12.018422960138365],
              [-17.760313308752586, 12.015060163893052],
              [-17.750889804659106, 12.006058673412076],
              [-17.74292979456637, 12.002042926398966],
              [-17.738712980165513, 12.00153237980051],
              [-17.73284223178098, 11.9969561618617],
              [-17.7235202274628, 11.99488644173706],
              [-17.71952251462683, 11.992933920696103],
              [-17.710349256543193, 11.992076371392347],
              [-17.705209439824085, 11.992546658872278],
              [-17.699356215312875, 11.990621530944832],
              [-17.696764255753422, 11.985859841641794],
              [-17.692935532712635, 11.98410879883323],
              [-17.681019259181777, 11.981425660505947],
              [-17.66197074023124, 11.983313103217753],
              [-17.657793369359315, 11.978338521312669],
              [-17.65086023895728, 11.97510857273664],
              [-17.64116480740556, 11.973447343646004],
              [-17.637843247573525, 11.971000093156249],
              [-17.631022390733953, 11.971532387201536],
              [-17.614333157341935, 11.97580678761349],
              [-17.593102898242243, 11.986490919552383],
              [-17.569418310027864, 12.001984683986489],
              [-17.553945807237273, 12.007692090202896],
              [-17.547482136583263, 12.005888571584725],
              [-17.523741343962833, 12.00812528640921],
              [-17.52373006089043, 12.005575541128964],
              [-17.54112949282737, 12.00368221289877],
              [-17.54630776085142, 12.004247181016172],
              [-17.553020467844668, 11.997865770784168],
              [-17.557510573118723, 11.989645526729282],
              [-17.55179644817644, 11.983627629481969],
              [-17.547324383600806, 11.98308760617002],
              [-17.54031522961241, 11.97592837520586],
              [-17.538727471114, 11.968919296978523],
              [-17.529044306938466, 11.951234481588102],
              [-17.51865883434576, 11.94152099129143],
              [-17.515756120765587, 11.934128428865098],
              [-17.512508876841572, 11.916802087249456],
              [-17.51215393197058, 11.903111982829522],
              [-17.51609575319016, 11.902730035218973],
              [-17.51923981011563, 11.892719541843073],
              [-17.518470392306924, 11.8826485723207],
              [-17.52356929839688, 11.879431483657498],
              [-17.519250900719168, 11.873979944283741],
              [-17.515456788906175, 11.859999450296248],
              [-17.512327965284893, 11.854597457483223],
              [-17.51360131405796, 11.851370396169457],
              [-17.510700362960275, 11.844323820585851],
              [-17.507471069261378, 11.839987208444917],
              [-17.502910172668766, 11.838195329404337],
              [-17.49917168118594, 11.842008457439896],
              [-17.49971989143691, 11.84474220094635],
              [-17.49832223851086, 11.855012730946207],
              [-17.498619827728422, 11.859999774947552],
              [-17.50067489208504, 11.864959286037807],
              [-17.50096958685589, 11.869657185776738],
              [-17.49429949485004, 11.877191905563901],
              [-17.49449074417776, 11.88343546763041],
              [-17.501438426016104, 11.894346366179393],
              [-17.499910334131584, 11.899376254563325],
              [-17.494381256230824, 11.899595471005963],
              [-17.48685313403343, 11.902153375918777],
              [-17.469362106502103, 11.902638931999766],
              [-17.447103916169056, 11.898928243700354],
              [-17.44321762442707, 11.895582402463074],
              [-17.42868608091014, 11.890515833668914],
              [-17.42820384743254, 11.889020613653324],
              [-17.4336675530365, 11.884638727911291],
              [-17.4382671644354, 11.878233309167417],
              [-17.44437075984911, 11.866859807287266],
              [-17.444389029824013, 11.864551681189656]
            ]
          ],
          [
            [
              [-18.520235763110694, 12.513380825418128],
              [-18.514669307357256, 12.5140823268736],
              [-18.512720978847288, 12.510772348043567],
              [-18.514903050396196, 12.50760103310651],
              [-18.519156981841142, 12.510797160538543],
              [-18.520235763110694, 12.513380825418128]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.93065562952242,
          "lat": 48.04927021579324
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53009"],
        "coty_name": ["Clallam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clallam County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01531341"
      },
      "bbox": [
        -18.604177021700878, 11.683494175628102, -17.42820384743254,
        12.5140823268736
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.148082543624152, 11.948198000191578],
            [-14.084945771388458, 11.93359283676824],
            [-14.021812387003237, 11.918972851452276],
            [-14.021323790493813, 11.91833795594362],
            [-13.94585196474867, 11.900980289923938],
            [-13.940342217000985, 11.900346019795828],
            [-13.853358871202612, 11.880689548645657],
            [-13.766381739302236, 11.861005032441446],
            [-13.65167970570155, 11.834670788820125],
            [-13.668992538806092, 11.761978295449754],
            [-13.713448371010998, 11.771968879746732],
            [-13.732265327419189, 11.690573224850585],
            [-13.774734456582806, 11.699931559742273],
            [-13.792276720963864, 11.625977945953574],
            [-13.79554109738172, 11.611526466242593],
            [-13.838248892783485, 11.620874145912524],
            [-13.857493658371986, 11.538943569271352],
            [-13.84309457076439, 11.53595560404118],
            [-13.773298703717542, 11.520231139159426],
            [-13.792719154144146, 11.440530161306254],
            [-13.812310335771292, 11.357719475463849],
            [-13.811890700684396, 11.357627770524447],
            [-13.82089502855018, 11.318735722272613],
            [-13.831672110164172, 11.273245660130224],
            [-13.831305924641109, 11.273164003540012],
            [-13.850678143009704, 11.191849646140879],
            [-13.85494498915083, 11.172508047878555],
            [-13.866234094389105, 11.124782824073115],
            [-13.869975695681234, 11.110913520652087],
            [-13.870885410492187, 11.111114992584628],
            [-13.8773999041981, 11.083998240249462],
            [-13.881966536453827, 11.06353010570618],
            [-13.890680333616945, 11.027107639945552],
            [-13.848201283153132, 11.017505274994608],
            [-13.86056060656785, 10.96223748692765],
            [-13.867179615890805, 10.934427488071286],
            [-13.932788878976412, 10.94990106091599],
            [-13.9459741249326, 10.892348434189982],
            [-13.96135735922519, 10.824106814289824],
            [-13.966769957120484, 10.799166887227457],
            [-13.979609065508257, 10.743320569755753],
            [-13.986950646284779, 10.709500110122587],
            [-13.988875892416178, 10.711886805120011],
            [-13.997302423767218, 10.718215988081738],
            [-14.008174189398101, 10.719799829444339],
            [-14.011868908842853, 10.71611127511121],
            [-14.017099009861766, 10.714586876676476],
            [-14.02179042664897, 10.717082310527003],
            [-14.028934914284847, 10.72686950329178],
            [-14.033058866102893, 10.738621990856506],
            [-14.036002414567962, 10.744942804175574],
            [-14.036395194695428, 10.75388095412337],
            [-14.040345387509506, 10.757049119127972],
            [-14.041692012271184, 10.761001151489253],
            [-14.048357812704895, 10.76430743644467],
            [-14.055449960433615, 10.76462828550021],
            [-14.059893253404127, 10.774561038792562],
            [-14.060634871048995, 10.781299605522257],
            [-14.058924090231898, 10.787580127147866],
            [-14.059793576216645, 10.794667471440157],
            [-14.056339831532634, 10.804715350848369],
            [-14.055345210689996, 10.810351571356055],
            [-14.057610740939165, 10.819101591406646],
            [-14.061178254985201, 10.820088953726424],
            [-14.071595240056839, 10.81704029964451],
            [-14.077031537819531, 10.809650174749462],
            [-14.08201841988436, 10.80110351453099],
            [-14.081355679424119, 10.79210828948754],
            [-14.085534256337905, 10.791841251004177],
            [-14.091024221646508, 10.786981229430419],
            [-14.110876018645554, 10.780016012014675],
            [-14.116718716195972, 10.77439070743346],
            [-14.12436830653756, 10.772457235697257],
            [-14.12735275930723, 10.77585605589609],
            [-14.132532886302215, 10.77932936372122],
            [-14.142998152352186, 10.776354134312077],
            [-14.148129306833859, 10.768456061806274],
            [-14.152528286854084, 10.763424418206512],
            [-14.162572334773586, 10.766601065720959],
            [-14.165088396960162, 10.772454766104863],
            [-14.168443467116257, 10.777036350557596],
            [-14.169361630446465, 10.78172235177686],
            [-14.172504735726958, 10.789995639961681],
            [-14.180422083199247, 10.79529135561915],
            [-14.187084866143215, 10.79882207223326],
            [-14.19056886927362, 10.803845922179098],
            [-14.203584869648298, 10.811579123440442],
            [-14.205794588971006, 10.810425987932474],
            [-14.209570080587019, 10.803542314444877],
            [-14.215897295224835, 10.802948172263568],
            [-14.22779222901356, 10.804620303610166],
            [-14.233025369459616, 10.799610029774025],
            [-14.238825747589791, 10.797221046813434],
            [-14.245252777687718, 10.796622339511075],
            [-14.247070669874276, 10.799074805356259],
            [-14.258356041339551, 10.804528155594522],
            [-14.26349278034551, 10.809874054175303],
            [-14.271927755630633, 10.81402144029487],
            [-14.278058456417488, 10.815694078899128],
            [-14.282336407642102, 10.814191515806133],
            [-14.290640102514839, 10.807155543720325],
            [-14.294583662229716, 10.802127579502143],
            [-14.297712190370367, 10.795222951674074],
            [-14.300716900362476, 10.791795190496932],
            [-14.30865434622124, 10.790175713192108],
            [-14.313055447369454, 10.792909981055645],
            [-14.316223676159671, 10.792518736179339],
            [-14.324687328757228, 10.78692272292781],
            [-14.330375592964149, 10.792332288682003],
            [-14.335593368946922, 10.791576192098608],
            [-14.339082871582196, 10.795281927921696],
            [-14.34464246307327, 10.79645739196614],
            [-14.346056071271224, 10.806292130676889],
            [-14.353135384833408, 10.822035795538092],
            [-14.350631165766496, 10.826286575355608],
            [-14.355685657533467, 10.829407548893215],
            [-14.356712030218882, 10.831772909957404],
            [-14.363287960980283, 10.833420511084553],
            [-14.363142590471918, 10.840429409013167],
            [-14.361292001611826, 10.843834858739925],
            [-14.36072787164386, 10.852107875472266],
            [-14.362058646787405, 10.862452068410308],
            [-14.364017583984708, 10.866578726436455],
            [-14.36676314228902, 10.877034548953153],
            [-14.368441293724457, 10.886780671971067],
            [-14.37116077189282, 10.889374135407754],
            [-14.379411110971052, 10.889729440657767],
            [-14.379559977565947, 10.894496742148341],
            [-14.376385593877421, 10.90114841929066],
            [-14.37946330897571, 10.907430493797957],
            [-14.386703502908787, 10.907747956602613],
            [-14.386921485739304, 10.910666602504238],
            [-14.384134571458663, 10.916218169358903],
            [-14.389758684847516, 10.926916564961166],
            [-14.389458506787419, 10.933299190562893],
            [-14.395410739607188, 10.936801800365254],
            [-14.395251130151353, 10.943817668957019],
            [-14.396309478744222, 10.950890536613047],
            [-14.398495181237205, 10.954387532748099],
            [-14.403485587469259, 10.955045439215574],
            [-14.412085210840138, 10.952559350579856],
            [-14.417546206583022, 10.953728842710953],
            [-14.42014674619629, 10.957432036381656],
            [-14.425626716332328, 10.958379475932816],
            [-14.432194265594049, 10.954623120812851],
            [-14.433326822108048, 10.952076914549284],
            [-14.441617561495699, 10.951919814384269],
            [-14.443934061516003, 10.948695843674022],
            [-14.459179168690172, 10.942295203789078],
            [-14.466255388878938, 10.940450690524495],
            [-14.476894327589994, 10.936252591592694],
            [-14.481349411494996, 10.929277407703509],
            [-14.481415840970008, 10.92584540865684],
            [-14.49174123979132, 10.924735964068276],
            [-14.495857828191054, 10.926226705941676],
            [-14.493884252898193, 10.931634495910691],
            [-14.496853489408219, 10.94847478621228],
            [-14.497722722606262, 10.961722142022422],
            [-14.489676155064105, 10.98413201405433],
            [-14.483081861173394, 11.00079955275522],
            [-14.484627878572088, 11.004142614424586],
            [-14.4942716145039, 11.01723506259596],
            [-14.494050829665657, 11.031511364541357],
            [-14.496628732472601, 11.03842470910168],
            [-14.500079728520745, 11.044742910612191],
            [-14.505620520561328, 11.057258998488626],
            [-14.505662567035507, 11.060772047705862],
            [-14.500631962757218, 11.064891015033998],
            [-14.487767533299374, 11.069567907827292],
            [-14.480302571873853, 11.071045012918416],
            [-14.471806816330506, 11.075862665964753],
            [-14.463805989047165, 11.075046863026696],
            [-14.458990631163275, 11.073183560936734],
            [-14.4455358578266, 11.061905325911336],
            [-14.434851296404142, 11.059274819277087],
            [-14.41914333210493, 11.05463341049474],
            [-14.415280845953127, 11.05606063360371],
            [-14.41023151099623, 11.063264791627494],
            [-14.409637218300041, 11.068575861945012],
            [-14.403190389860065, 11.070116340242011],
            [-14.39915956736699, 11.064477066351019],
            [-14.396038380654783, 11.063346504635964],
            [-14.390643454718921, 11.065585573230845],
            [-14.38573277034399, 11.071540172888241],
            [-14.3847653012067, 11.081516312101165],
            [-14.379070650860182, 11.092986584895238],
            [-14.37947351302671, 11.109582557134225],
            [-14.382404523497161, 11.113768071864147],
            [-14.387005767861146, 11.1173445742642],
            [-14.38783971845336, 11.124114458905966],
            [-14.385081679182095, 11.134636804083833],
            [-14.381958179535921, 11.138120169668385],
            [-14.375763264933719, 11.139401329454696],
            [-14.369851556145834, 11.137230040565006],
            [-14.361144943611375, 11.138594125465307],
            [-14.35212607572052, 11.13668730177539],
            [-14.34687525835693, 11.138360383770928],
            [-14.340782979695087, 11.144936384667906],
            [-14.336859207150537, 11.153416540132154],
            [-14.335565436128336, 11.161610264926132],
            [-14.335235654709637, 11.173526268090217],
            [-14.332990726498737, 11.18449569790296],
            [-14.329802495677166, 11.187948686347498],
            [-14.32580678081502, 11.189314759184905],
            [-14.324447307232521, 11.19948912700435],
            [-14.32685690444571, 11.204947078885208],
            [-14.32332961832364, 11.207521124238506],
            [-14.303390897056447, 11.217359383054891],
            [-14.29460905408077, 11.222806540072348],
            [-14.288641733601379, 11.228908351293711],
            [-14.281000247676554, 11.241875062132236],
            [-14.278166928482722, 11.249376645282322],
            [-14.279308021108614, 11.256439602586823],
            [-14.281479870347134, 11.259816983240285],
            [-14.282009890552855, 11.264177189234902],
            [-14.281337406304832, 11.277638955471218],
            [-14.282914765549208, 11.283098204240295],
            [-14.286165274596494, 11.287349665644014],
            [-14.286969993692606, 11.295424252977687],
            [-14.289721544177048, 11.303153491472575],
            [-14.28838913907623, 11.309696189705459],
            [-14.289015431915564, 11.319161588856021],
            [-14.286912746504294, 11.32555888666389],
            [-14.28260319768013, 11.345614701474876],
            [-14.28160582081736, 11.354563452243752],
            [-14.282937733577976, 11.36016281497771],
            [-14.282004942243029, 11.369125686013744],
            [-14.282435902126082, 11.373317194357758],
            [-14.286755430035024, 11.38619790123357],
            [-14.2872683048548, 11.392603131171041],
            [-14.285715782474448, 11.39794566910033],
            [-14.281442701782824, 11.407805963396909],
            [-14.281722287901273, 11.41545246853907],
            [-14.279428986739376, 11.423196668939394],
            [-14.283573641876817, 11.431943509844874],
            [-14.281938781363033, 11.439241889630408],
            [-14.279386497219306, 11.444930567231996],
            [-14.275336003107867, 11.450268505123397],
            [-14.261474447881476, 11.458305804122404],
            [-14.252396432494088, 11.474436592421357],
            [-14.246845311330684, 11.489995286267304],
            [-14.239934718603088, 11.4946519449235],
            [-14.231396198410271, 11.490169630567133],
            [-14.22485142314531, 11.489716658656242],
            [-14.220363549653255, 11.493689529736832],
            [-14.21797947532997, 11.497863470454107],
            [-14.218273287427952, 11.503384406241366],
            [-14.216899283575623, 11.512304308803868],
            [-14.213652211708593, 11.516644644802433],
            [-14.208887774787556, 11.529729606394179],
            [-14.203904804470316, 11.537740988035841],
            [-14.196433946888499, 11.54574878407768],
            [-14.196441593114294, 11.5516939544376],
            [-14.193897055093556, 11.561259604654573],
            [-14.193751195247199, 11.565350563360001],
            [-14.189254139486524, 11.575428707188603],
            [-14.182628992751619, 11.581289151404453],
            [-14.182259392893554, 11.588413627131455],
            [-14.179818439084952, 11.58869437168268],
            [-14.17698711146204, 11.595153284196845],
            [-14.171654502407987, 11.596182027989068],
            [-14.168797847815727, 11.600594501469049],
            [-14.167376868970125, 11.607711623227194],
            [-14.167819405695331, 11.616547058986045],
            [-14.16671805554267, 11.62530244577582],
            [-14.17012841333291, 11.628760022802602],
            [-14.170286223464675, 11.634096788125422],
            [-14.166486318030277, 11.637770057756061],
            [-14.166648482779705, 11.656090065623033],
            [-14.163476361433663, 11.661398175697702],
            [-14.164013496169266, 11.66612395440777],
            [-14.161816711583405, 11.67148880814932],
            [-14.164699246681108, 11.677936033269663],
            [-14.1641789100318, 11.680875319530582],
            [-14.15729377947066, 11.68594721970473],
            [-14.156953062112034, 11.689037421655351],
            [-14.161315161090604, 11.689121614053633],
            [-14.163121986656275, 11.692746237470622],
            [-14.162826096411843, 11.697396001181048],
            [-14.157828259184583, 11.697371921626923],
            [-14.156665749719004, 11.70117452816624],
            [-14.158254879264824, 11.70534516801728],
            [-14.162302579730781, 11.709954401855189],
            [-14.160119424308656, 11.712502792577526],
            [-14.15596832252464, 11.712660208747506],
            [-14.155591031241183, 11.715242857255616],
            [-14.16000475793426, 11.718326071260181],
            [-14.159138237528387, 11.725800964037095],
            [-14.157284094115022, 11.72821149852689],
            [-14.150671017131343, 11.726046481711771],
            [-14.149768011345001, 11.728777375886228],
            [-14.151318775298888, 11.736031743489669],
            [-14.157860620966026, 11.734380590166907],
            [-14.160376484984033, 11.73174690879899],
            [-14.164483843338349, 11.733795363642066],
            [-14.16464380481037, 11.74107131392593],
            [-14.170056258085737, 11.745141382834975],
            [-14.17140461812169, 11.749328256083144],
            [-14.16888157662566, 11.753862241354673],
            [-14.168229972893528, 11.76260762256322],
            [-14.170394763327831, 11.768723351991968],
            [-14.170445380831877, 11.782091351270934],
            [-14.173110066125082, 11.786337971738472],
            [-14.173598372360106, 11.792379328735793],
            [-14.178229541421521, 11.793914486255856],
            [-14.183383026846212, 11.797725530384225],
            [-14.180070529012601, 11.807712313080842],
            [-14.183365174000814, 11.814493064204873],
            [-14.17923775455023, 11.823154235625802],
            [-14.185620964977621, 11.829632871082921],
            [-14.186206172038723, 11.837615175371992],
            [-14.184118922643384, 11.84250900154842],
            [-14.184819353972912, 11.845223027403817],
            [-14.179865988978221, 11.851074028725826],
            [-14.178917692754307, 11.855448364121914],
            [-14.174433512466893, 11.856088709285387],
            [-14.167442585428002, 11.867307043396773],
            [-14.170104396582778, 11.868291516321372],
            [-14.175240041699091, 11.877005899312664],
            [-14.177699337410738, 11.883909301396267],
            [-14.178269748644281, 11.892334980397779],
            [-14.170014430500423, 11.90648656976633],
            [-14.16299320781913, 11.914593716539038],
            [-14.166256000383367, 11.920646829856823],
            [-14.170619251799023, 11.92374168870883],
            [-14.167437494155633, 11.92594885135835],
            [-14.162497985470532, 11.937266897840853],
            [-14.156558943476691, 11.937285323901554],
            [-14.163321368423686, 11.946340645539042],
            [-14.16336041542658, 11.948778223300991],
            [-14.15553328623365, 11.946588658576099],
            [-14.14964104564336, 11.942032711170501],
            [-14.147233040494026, 11.944544284397184],
            [-14.148082543624152, 11.948198000191578]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.85521449495754,
          "lat": 48.39913931860078
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53065"],
        "coty_name": ["Stevens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stevens County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01531930"
      },
      "bbox": [
        -14.505662567035507, 10.709500110122587, -13.65167970570155,
        11.948778223300991
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.197606539804863, 10.371618801703871],
            [-18.131926712567275, 10.351946497274866],
            [-18.121666667663842, 10.350164293609767],
            [-18.104040064778555, 10.346070351863021],
            [-18.11052785216187, 10.324882286358427],
            [-18.11184482897503, 10.317894145421347],
            [-18.11616667454187, 10.304500031414621],
            [-18.119602699523295, 10.28976653104995],
            [-18.13093939995363, 10.249405906732667],
            [-18.135506532957443, 10.236577176542783],
            [-18.14667770249443, 10.200621029157737],
            [-18.1512225224288, 10.183501742242374],
            [-18.149821669563572, 10.183129571858563],
            [-18.1539979687823, 10.169571545418831],
            [-18.160833132821196, 10.144444398071451],
            [-18.174981184828653, 10.14009239045334],
            [-18.183381415017397, 10.139129563969096],
            [-18.190784708101535, 10.136652140906014],
            [-18.213324221419544, 10.131305454207725],
            [-18.227275966215792, 10.135144943749099],
            [-18.247687141921723, 10.142621065812406],
            [-18.25725248932516, 10.144313510065514],
            [-18.26853718470192, 10.148892617148228],
            [-18.273641640270892, 10.150429352111432],
            [-18.27772587283168, 10.156360730088453],
            [-18.283981685397265, 10.161700491580586],
            [-18.30327362249369, 10.195146666464618],
            [-18.287471313530297, 10.239476932807861],
            [-18.294916725782517, 10.262634673861365],
            [-18.304787442652675, 10.280576846296922],
            [-18.310718485997157, 10.287023865553499],
            [-18.32452932178959, 10.292986097378911],
            [-18.335833095244986, 10.29132921582633],
            [-18.351957487623743, 10.290378895057591],
            [-18.35873823281522, 10.290830594694793],
            [-18.35687337379243, 10.296927943741533],
            [-18.365173115886638, 10.298854818311955],
            [-18.369211703035177, 10.296164939396206],
            [-18.377025561094428, 10.299301971050664],
            [-18.380904979344244, 10.298766588812883],
            [-18.3948912057216, 10.30404159186514],
            [-18.402231950638367, 10.304510004113542],
            [-18.40931664411017, 10.308181748436986],
            [-18.415389442573534, 10.313745170747143],
            [-18.425787565922192, 10.317013392241286],
            [-18.43741745357628, 10.321884413959676],
            [-18.442180413785497, 10.329098947254145],
            [-18.441255394712517, 10.334401612708202],
            [-18.437478606750147, 10.342024203398246],
            [-18.436403040675877, 10.351498211118361],
            [-18.447313951995344, 10.363505725777346],
            [-18.463916481144242, 10.364880604635303],
            [-18.4655116221482, 10.35909811881018],
            [-18.469612049496703, 10.354803756628364],
            [-18.462093154982647, 10.378164236423512],
            [-18.44141516679306, 10.443988928376564],
            [-18.395682638129433, 10.430076925873736],
            [-18.30673195300675, 10.403418648039816],
            [-18.285538943321612, 10.39684004940642],
            [-18.197606539804863, 10.371618801703871]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.42441925646844,
          "lat": 46.29175523625204
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53069"],
        "coty_name": ["Wahkiakum"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wahkiakum County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01513275"
      },
      "bbox": [
        -18.469612049496703, 10.131305454207725, -18.104040064778555,
        10.443988928376564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.273048666443476, 2.124303617588658],
            [14.276657972293078, 2.1246343163504853],
            [14.28708738905801, 2.122893577843986],
            [14.296355223102491, 2.1240538780118046],
            [14.30026713189228, 2.1274672420576324],
            [14.301838017355006, 2.132283765391682],
            [14.30506364875774, 2.1354462747074616],
            [14.313057652891661, 2.137017587991783],
            [14.317424659621427, 2.1344093347800572],
            [14.317448799375953, 2.1299018374184686],
            [14.314378656944324, 2.1271213561054463],
            [14.302572501991044, 2.120557851257366],
            [14.297963522748246, 2.1163516833678027],
            [14.297097858863559, 2.109910724318566],
            [14.299881932494191, 2.10586727203605],
            [14.305037751018565, 2.103339920312154],
            [14.31418923298143, 2.1008355762999216],
            [14.31345603193397, 2.096792561654911],
            [14.30351293725636, 2.0970998076949545],
            [14.299788924562618, 2.094968324031944],
            [14.30093315709296, 2.090371726343617],
            [14.305599930258023, 2.0865748750403488],
            [14.311658163669636, 2.0834240935477846],
            [14.310658020015225, 2.07874157899729],
            [14.301802364530662, 2.074982509444942],
            [14.301474998198596, 2.0699126690020004],
            [14.309862285364764, 2.0660134367965757],
            [14.323837016883202, 2.065899432226317],
            [14.332384638604454, 2.06816568681471],
            [14.34106440997766, 2.0645339889687686],
            [14.34196719911579, 2.0615357995631656],
            [14.34765598447247, 2.05314080881382],
            [14.355045297677314, 2.0450847346183014],
            [14.359489526033506, 2.0366886157562347],
            [14.360511062348339, 2.0318100302093742],
            [14.357618407398013, 2.028847798055897],
            [14.35113057954001, 2.026314564579619],
            [14.348769382098405, 2.0237212022241016],
            [14.349582755898716, 2.020000466116359],
            [14.358985255497505, 2.0082803817335266],
            [14.360188819298523, 2.0031780165218103],
            [14.35993917449998, 1.996216547882199],
            [14.357314505032202, 1.991830723484234],
            [14.35139764494359, 1.9864304995036413],
            [14.350604566293159, 1.9834089952537195],
            [14.352709218366945, 1.97848041180682],
            [14.356247612054835, 1.9756402309413381],
            [14.373203221107959, 1.9718599807456783],
            [14.37997377948207, 1.9676788650969514],
            [14.385953816308806, 1.9684806934736008],
            [14.384904082984317, 1.965377764449518],
            [14.379124143271738, 1.9613463755252636],
            [14.376102209979065, 1.95741088144332],
            [14.370137007124097, 1.9383582923924145],
            [14.368284102032371, 1.9260463579330043],
            [14.36916098485789, 1.9200156349726447],
            [14.367741811839501, 1.9168979172708915],
            [14.36539545735558, 1.904576622960652],
            [14.365468327724532, 1.899877003493909],
            [14.361738042336178, 1.8983428642774716],
            [14.360189423330029, 1.8955805824923566],
            [14.361092397874668, 1.8901005902914692],
            [14.36387557682801, 1.890250215010833],
            [14.363185176021007, 1.8771610091568738],
            [14.356419400650505, 1.862799702090943],
            [14.354259496510714, 1.8532966925881518],
            [14.351575726549616, 1.8475158736450983],
            [14.34995123856427, 1.836356203118879],
            [14.351651140996973, 1.8297496725189244],
            [14.349125202700982, 1.8154797949085253],
            [14.34983180118155, 1.810274896849798],
            [14.345486672325988, 1.799978123944872],
            [14.341511336057112, 1.7814596675263148],
            [14.34352440913825, 1.773862828669371],
            [14.340359573778285, 1.765477233615973],
            [14.260404829820757, 1.8104685340499849],
            [14.160701666084481, 1.866766343330964],
            [14.160700539844694, 1.8667669667174551],
            [14.159812580420363, 1.8701477665321324],
            [14.163663168385733, 1.8725956873762155],
            [14.164584416741864, 1.8756905291429702],
            [14.15751683075841, 1.8778871782271536],
            [14.157732636666628, 1.8819760058306048],
            [14.16301345670066, 1.8832171412387981],
            [14.16278012258789, 1.8879248490410006],
            [14.160668297338455, 1.8912078743936134],
            [14.165818274309347, 1.8917390939832692],
            [14.166564515473063, 1.8975937793085869],
            [14.169794019146941, 1.9020715753410622],
            [14.173239764197143, 1.9125145602625695],
            [14.179485370171987, 1.9199150701876053],
            [14.183898597880825, 1.9278711548606844],
            [14.182029321773397, 1.9306020537480748],
            [14.1783873148481, 1.9309426731974166],
            [14.178119105912403, 1.9346790381468322],
            [14.183091299564902, 1.933610270319573],
            [14.181822498678674, 1.9399204298330937],
            [14.184285605736632, 1.941740531439458],
            [14.188026368548758, 1.9532214211196828],
            [14.183107550933068, 1.9563411423771768],
            [14.185840196891332, 1.959361645650728],
            [14.189883600007484, 1.9595527664245231],
            [14.195008704940026, 1.9564936246981706],
            [14.195168328297969, 1.9634969609336574],
            [14.191798399171084, 1.9677413919383575],
            [14.196091727144289, 1.9707855973059216],
            [14.19182586503172, 1.9784752233444955],
            [14.19769185227466, 1.9791760770108497],
            [14.201651874768936, 1.9850878332501163],
            [14.20735529967371, 1.9867251065110312],
            [14.203639472091421, 1.9906578849864962],
            [14.20627322563393, 1.994986837043253],
            [14.210936165839263, 1.9945033717032679],
            [14.215529572745151, 1.9970181163864373],
            [14.242983305856036, 2.0390557111671455],
            [14.258893092432615, 2.063071462131089],
            [14.259659533835304, 2.066715975423259],
            [14.265368748041286, 2.0755321394566133],
            [14.26622641835811, 2.086612861494211],
            [14.268486538497207, 2.099819289151382],
            [14.27094314090439, 2.108913841245719],
            [14.270403098558898, 2.112209340195198],
            [14.272079668230193, 2.1162510199665356],
            [14.273048666443476, 2.124303617588658]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.86282395085782,
          "lat": 39.307649464785825
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54037"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01550025"
      },
      "bbox": [
        14.15751683075841, 1.765477233615973, 14.385953816308806,
        2.137017587991783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.045358204903302, 6.454122181241613],
            [4.1014134982650745, 6.4575629193481685],
            [4.217781396858757, 6.46364187061135],
            [4.3035210141938185, 6.468310974633352],
            [4.390360507704131, 6.4731744255882],
            [4.409655272210896, 6.474816496354567],
            [4.473891497087007, 6.4809310549520545],
            [4.477223180045522, 6.4077719680643455],
            [4.478631374266196, 6.384009478287854],
            [4.479311307646427, 6.378964900219653],
            [4.4817373686049455, 6.3503377654063575],
            [4.483002506476406, 6.321694722430638],
            [4.4846257554408036, 6.292372132785963],
            [4.485260839125606, 6.274670400968684],
            [4.487347214761156, 6.235033242908843],
            [4.49390916163052, 6.134357548206539],
            [4.4955014536242075, 6.105387515365127],
            [4.501151139331113, 6.020206595119891],
            [4.504587468405282, 5.962871204860139],
            [4.509665548310005, 5.874984315169449],
            [4.46719930630332, 5.87130724734378],
            [4.45176898659299, 5.870338707077233],
            [4.424250453981266, 5.867997437701928],
            [4.3809647166868455, 5.865553751011187],
            [4.334652229583216, 5.862473642118723],
            [4.250664017914116, 5.857792443050607],
            [4.1642942315276885, 5.853236446604317],
            [4.162500987250581, 5.889162492244636],
            [4.159719472267113, 5.9401241074292965],
            [4.073578278441589, 5.93564484516727],
            [4.070213832348843, 6.006220826221288],
            [4.06933349261591, 6.021732551764672],
            [4.065878276445394, 6.095301737340164],
            [4.062002989464576, 6.166144939119206],
            [4.060593979255628, 6.1950811350542505],
            [4.055440426744634, 6.281396776907618],
            [4.051422397105707, 6.352406011981337],
            [4.0498837524229625, 6.382488592331022],
            [4.047240647355345, 6.418727525401934],
            [4.047394336408792, 6.423165984962803],
            [4.045358204903302, 6.454122181241613]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.61206432099736, "lat": 44.73472835096235 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55019"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01581069"
      },
      "bbox": [
        4.045358204903302, 5.853236446604317, 4.509665548310005,
        6.4809310549520545
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.498446039585765, 5.148362837083937],
            [5.521443775096824, 5.149969806621175],
            [5.585214616248605, 5.155284594389146],
            [5.596226945992432, 5.1559133371925805],
            [5.671932208548721, 5.161356819785033],
            [5.708038594893193, 5.164252367585805],
            [5.758704833664056, 5.167945790704901],
            [5.826290065069625, 5.172294755239842],
            [5.869401313153641, 5.175326293637218],
            [5.933872438067992, 5.1795994543834185],
            [5.9413266412249275, 5.0924724868225235],
            [5.941773257533132, 5.0843830572748105],
            [5.944309086055626, 5.054884921713592],
            [5.948105183830825, 5.005917590604737],
            [5.954441270860909, 4.919342704608526],
            [5.94225042405089, 4.918475142989087],
            [5.945650706718621, 4.873650642765352],
            [5.948757550300748, 4.830340262033917],
            [5.951483663503963, 4.801420584380434],
            [5.956631114798922, 4.743317516209683],
            [5.927908053312714, 4.742029075140254],
            [5.871319205914399, 4.73793142382602],
            [5.8391195217105, 4.736159268903953],
            [5.752816585186488, 4.729897508884002],
            [5.7275018328438385, 4.728582471328563],
            [5.70028781367434, 4.726421154220116],
            [5.627761047254202, 4.721378139032861],
            [5.625871148702655, 4.72089306429773],
            [5.5635495699435005, 4.716493647921264],
            [5.529166916067423, 4.713634446470967],
            [5.522510645164152, 4.800635557560814],
            [5.519373272521155, 4.839204449569024],
            [5.516332256161828, 4.887212942827124],
            [5.519307793989971, 4.887621230677409],
            [5.51184348546085, 4.974472233965045],
            [5.50901919197644, 5.0113664647748],
            [5.503818356734164, 5.071937869146631],
            [5.498446039585765, 5.148362837083937]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.70752533397815, "lat": 43.41628699492328 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55027"],
        "coty_name": ["Dodge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dodge County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01581073"
      },
      "bbox": [
        5.498446039585765, 4.713634446470967, 5.956631114798922,
        5.1795994543834185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.749580833904714, 6.22929361087799],
            [2.8087836762245595, 6.2319468622467245],
            [2.88339879109631, 6.234434472681844],
            [2.955857002042829, 6.23702143315844],
            [3.0283156844482186, 6.239594865049925],
            [3.04307419944829, 6.239318294662393],
            [3.11089650392424, 6.238574692270668],
            [3.1263862492901984, 6.238801295750669],
            [3.14071913746809, 6.2396762280326765],
            [3.165640703684866, 6.2404125155860495],
            [3.1971831909455286, 6.241774169066529],
            [3.199054452897902, 6.19891384650123],
            [3.2007152523368663, 6.155876479553147],
            [3.2018092187307063, 6.140995096106353],
            [3.205058952414355, 6.069149858075777],
            [3.2090640350045954, 5.978032466562018],
            [3.2108150718859885, 5.924933280798606],
            [3.1966600507601153, 5.924261167175772],
            [3.134505526264067, 5.922126750533487],
            [3.082292051125343, 5.9212383964391035],
            [3.0795017390234265, 5.925096084770813],
            [3.0728239978720158, 5.93078106607714],
            [3.0676594900646412, 5.933684882477058],
            [3.05940274951966, 5.936506632994133],
            [3.044599258201215, 5.9379705712879245],
            [3.0299226663722996, 5.935932439340166],
            [3.0226256438352377, 5.936250609885717],
            [3.0113187435443045, 5.937887598314894],
            [3.0033466796443533, 5.9360363789598205],
            [2.99579680367073, 5.929750915825865],
            [2.993368286998716, 5.930162240508613],
            [2.980113173358791, 5.939104041812621],
            [2.964206930772059, 5.944034377958222],
            [2.955192713852556, 5.941495016929769],
            [2.9444166309563244, 5.945352338630201],
            [2.9374208447493317, 5.949943532750431],
            [2.9311038219020924, 5.94808842286287],
            [2.921948948270156, 5.941475030730066],
            [2.91520525616912, 5.942957050969712],
            [2.9140070091953585, 5.9455266012029035],
            [2.9153689659209348, 5.951658295613413],
            [2.9148913840107253, 5.955058832541789],
            [2.9065651898126594, 5.96855090364028],
            [2.900121943405006, 5.97688088292637],
            [2.894591171898172, 5.978193674205994],
            [2.8915882409232676, 5.973905636456872],
            [2.886442509989928, 5.974554594034656],
            [2.885104605130642, 5.978734183024132],
            [2.8770420904037364, 5.9845473647551195],
            [2.8677884283125565, 5.98389759762429],
            [2.862782837545157, 5.986998959188802],
            [2.861457061449408, 5.9901508195211886],
            [2.861688723336479, 5.995439277051378],
            [2.863470745418158, 6.001183404930059],
            [2.861732642857391, 6.01086504486837],
            [2.8540167611148095, 6.020609560649908],
            [2.836884089702519, 6.028996009280814],
            [2.8303888830118864, 6.034094132626254],
            [2.8142641574681564, 6.052196080850259],
            [2.8069317903506072, 6.059260951598735],
            [2.803621633825116, 6.063448987541021],
            [2.7946825849103183, 6.070453302080217],
            [2.78089048950096, 6.08252819039556],
            [2.7770729892087274, 6.085871528482479],
            [2.767731130653235, 6.090503006850718],
            [2.7628607165978, 6.092041281129974],
            [2.756240454227143, 6.097574073808183],
            [2.740490757026866, 6.104846388993138],
            [2.7298121803337465, 6.112826907463895],
            [2.725789593026267, 6.118347192815585],
            [2.7271342197409045, 6.13522837812159],
            [2.7303527641818817, 6.1443243454656775],
            [2.7381698273707014, 6.154966832951132],
            [2.7405446387760937, 6.159540510373456],
            [2.7419349958668606, 6.165395566248177],
            [2.743237541921643, 6.179847854291902],
            [2.7484340871678756, 6.1888274123281795],
            [2.7484897836761264, 6.195428049781835],
            [2.752615464439982, 6.202463042235007],
            [2.7529903839404426, 6.208557966846044],
            [2.750205858749822, 6.22171378702566],
            [2.749580833904714, 6.22929361087799]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.42241302645705,
          "lat": 44.719400784984195
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55093"],
        "coty_name": ["Pierce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pierce County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01581107"
      },
      "bbox": [
        2.725789593026267, 5.9212383964391035, 3.2108150718859885,
        6.241774169066529
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.925772037217837, 6.851645395815638],
            [-7.813041061806899, 6.837745748272862],
            [-7.725549148981749, 6.8268822104901465],
            [-7.625888663513288, 6.815567543881694],
            [-7.544915120327043, 6.805357177302396],
            [-7.412291093295996, 6.788928995416654],
            [-7.376227991703441, 6.784347896902717],
            [-7.360962653303458, 6.781229265743598],
            [-7.346774946556772, 6.777673927957929],
            [-7.33947800634055, 6.777320940389144],
            [-7.322887271521984, 6.774722883918581],
            [-7.206458781999854, 6.760851341550511],
            [-7.096403734849928, 6.7479310856654156],
            [-6.986352620084179, 6.734978741806166],
            [-6.878582045795893, 6.722680111970551],
            [-6.770815138964442, 6.7103507446394515],
            [-6.645973899326106, 6.696700893826201],
            [-6.603088205931691, 6.692187045860799],
            [-6.604924853980159, 6.675715020400314],
            [-6.615026539909399, 6.568745863248644],
            [-6.611140577527944, 6.568302322992276],
            [-6.609977499292133, 6.557171930508315],
            [-6.626351539759662, 6.408038506254256],
            [-6.624782986708507, 6.393954655119784],
            [-6.625157732698938, 6.39104889961201],
            [-6.637689046250195, 6.265893229304302],
            [-6.672844344349183, 6.268694650325312],
            [-6.757725535389231, 6.278412454079125],
            [-6.7576956826195165, 6.27670565538248],
            [-6.845936574595621, 6.286110230088072],
            [-6.9341795424381685, 6.295495096610952],
            [-6.934728393723296, 6.290543260091119],
            [-7.020805840892406, 6.300120982001722],
            [-7.073656135812528, 6.306299192309884],
            [-7.077366497718956, 6.307014100521864],
            [-7.100674527455596, 6.30901873777014],
            [-7.139228772622246, 6.313999302286088],
            [-7.206654633527108, 6.321972306833886],
            [-7.241521267511952, 6.325941498785622],
            [-7.291524031011102, 6.332251261941001],
            [-7.335372208536191, 6.337926497130422],
            [-7.361277718574215, 6.341042180209769],
            [-7.361386049316252, 6.340198156556017],
            [-7.426625140063462, 6.347809116459203],
            [-7.547113679117246, 6.362742465519482],
            [-7.5986769805570855, 6.369620563849646],
            [-7.600017822276032, 6.377971230764728],
            [-7.59960598492256, 6.386108209307026],
            [-7.606058567099929, 6.400534463752933],
            [-7.604198262559864, 6.405915149096962],
            [-7.61077667098876, 6.407313204138006],
            [-7.613495111692129, 6.410311302695976],
            [-7.617713712281867, 6.412000406700851],
            [-7.624716118357839, 6.411893628538112],
            [-7.630950232703664, 6.4173096232356475],
            [-7.630145257323367, 6.422220194675246],
            [-7.631531481371614, 6.42536614503541],
            [-7.638890978284939, 6.426644191624139],
            [-7.637478901902765, 6.42233721095039],
            [-7.645042863110674, 6.421075127466222],
            [-7.655173372248078, 6.426022002910707],
            [-7.658808079075786, 6.429265793525457],
            [-7.6629311379239216, 6.429953130881428],
            [-7.668667496911928, 6.436258894454321],
            [-7.6690503804944745, 6.440627043534496],
            [-7.672893853417001, 6.44447462891988],
            [-7.675231979897873, 6.45208330252936],
            [-7.677117564137661, 6.461503133307435],
            [-7.6808507786782165, 6.4620232954609875],
            [-7.689427855968674, 6.454632238583903],
            [-7.698766247310752, 6.455066999194573],
            [-7.7014608682026635, 6.457177061143696],
            [-7.701363801194208, 6.466328664371044],
            [-7.704604642286352, 6.469361720504586],
            [-7.703474417546736, 6.47382734600543],
            [-7.699975682952698, 6.474664452655549],
            [-7.695271279617555, 6.477934831514308],
            [-7.692384682276127, 6.482064377435849],
            [-7.697811751483172, 6.487634630575931],
            [-7.700279595458367, 6.488772155926357],
            [-7.705442657361413, 6.487907242762373],
            [-7.712178279043318, 6.490811611015232],
            [-7.710925786626901, 6.502474046134787],
            [-7.7161962370411405, 6.502916116153189],
            [-7.72339276777587, 6.5084836242327055],
            [-7.727682601416651, 6.50871920926069],
            [-7.732064712127453, 6.516035911747828],
            [-7.737451881837194, 6.515241133579112],
            [-7.741730109736801, 6.522495664062192],
            [-7.748038181193129, 6.523201217408812],
            [-7.752966504895627, 6.526795358156016],
            [-7.755166500141008, 6.5304300084321305],
            [-7.758154517382673, 6.528303129680128],
            [-7.760888433443763, 6.522847186662173],
            [-7.765802031850066, 6.523640937872835],
            [-7.7718664240585555, 6.522518384594818],
            [-7.775462815574721, 6.524869128650198],
            [-7.780778163226162, 6.5245495218719],
            [-7.784251891214648, 6.521917260639941],
            [-7.7856601648518, 6.51704788255178],
            [-7.791250498373381, 6.514750283154662],
            [-7.796658437174396, 6.514390950589458],
            [-7.798564083252077, 6.519520212327672],
            [-7.802646101207118, 6.522918212682165],
            [-7.804407597348442, 6.528274631767248],
            [-7.801842201834051, 6.531367431316712],
            [-7.800893707882313, 6.537627872441384],
            [-7.803687548004139, 6.540597933210373],
            [-7.810625688398996, 6.544025054822483],
            [-7.812449170055661, 6.54112345024628],
            [-7.819845673276592, 6.546255021259973],
            [-7.825546650092382, 6.548437186953961],
            [-7.832244078619258, 6.555045966240693],
            [-7.8385402735531775, 6.552776589298804],
            [-7.842010174184925, 6.554180581002612],
            [-7.847737677091701, 6.56402073642033],
            [-7.8422567887776955, 6.568893306668266],
            [-7.842634339178862, 6.57343358062084],
            [-7.8400758860211885, 6.581149138220914],
            [-7.843307121734556, 6.586127581430383],
            [-7.8399077316134775, 6.59402271000172],
            [-7.844227548075879, 6.596789464192628],
            [-7.844568656715053, 6.601985689785972],
            [-7.843128805408792, 6.605748389245559],
            [-7.844098968758177, 6.610846575305342],
            [-7.851078588523316, 6.614577079975851],
            [-7.861217628376789, 6.61470468484479],
            [-7.868068802146923, 6.6203497474754895],
            [-7.8744450242018935, 6.627550298702787],
            [-7.879456145060198, 6.630391057121326],
            [-7.882864818732551, 6.634424326701647],
            [-7.891089863451683, 6.637933681613607],
            [-7.896509840840439, 6.63734355416987],
            [-7.896149859416924, 6.641781686267127],
            [-7.893977106997924, 6.647645097610696],
            [-7.886749392659414, 6.652538485157654],
            [-7.883515229260845, 6.655739969374953],
            [-7.881786602996912, 6.662575854751803],
            [-7.885045670852255, 6.666640503367218],
            [-7.88839562208446, 6.666387753290668],
            [-7.892017531234878, 6.671288992282015],
            [-7.888500085362361, 6.676668666827446],
            [-7.888620546987588, 6.682509285629957],
            [-7.8907066579704574, 6.685968082648789],
            [-7.889261499510187, 6.691051420129632],
            [-7.892962367083976, 6.693059567245121],
            [-7.894850673871713, 6.696611126379454],
            [-7.8961972045671045, 6.707605836325312],
            [-7.899737667181547, 6.709683642919444],
            [-7.902782413347407, 6.71527411297524],
            [-7.9073787919114, 6.71688028467624],
            [-7.909032472512446, 6.722230510491102],
            [-7.905043704672447, 6.729805899941617],
            [-7.903365331208678, 6.7425398858751135],
            [-7.900092744672637, 6.742551303988866],
            [-7.896479562411183, 6.745775382779831],
            [-7.894161642252509, 6.752490709920744],
            [-7.896027068160584, 6.753995936435749],
            [-7.895826269852268, 6.761457663821338],
            [-7.902429591265658, 6.770586540591068],
            [-7.9056847402294546, 6.7730981372291374],
            [-7.907173814552818, 6.776964308782387],
            [-7.913391166427529, 6.782705294866064],
            [-7.91261155528986, 6.791651597698677],
            [-7.907114762209775, 6.806114414187402],
            [-7.905958208435779, 6.81289214803493],
            [-7.907885404201634, 6.820227720811883],
            [-7.908666550360224, 6.829710927400948],
            [-7.906752843399267, 6.8340255539581705],
            [-7.91210076544018, 6.841111242703953],
            [-7.914353522711416, 6.840635025425862],
            [-7.917475065165079, 6.845699522945615],
            [-7.923469341665117, 6.846404713853373],
            [-7.925772037217837, 6.851645395815638]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.87928143965112,
          "lat": 44.78997481052514
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56033"],
        "coty_name": ["Sheridan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sheridan County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01605081"
      },
      "bbox": [
        -7.925772037217837, 6.265893229304302, -6.603088205931691,
        6.851645395815638
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -171.07798139252247,
          "lat": -11.05495725103169
        },
        "year": "2023",
        "ste_code": ["60"],
        "ste_name": ["American Samoa"],
        "coty_code": ["60040"],
        "coty_name": ["Swains Island"],
        "coty_area_code": "ASM",
        "coty_type": null,
        "coty_name_long": ["Swains Island"],
        "coty_fp_code": "040",
        "coty_gnis_code": "01805244"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.30972033318163, "lat": 18.20184753471774 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72019"],
        "coty_name": ["Barranquitas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Barranquitas Municipio"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01804489"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -67.23146037693405, "lat": 18.33532753005968 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72117"],
        "coty_name": ["Rincón"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Rincón Municipio"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01804539"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.33729107100162, "lat": 18.40921559732807 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72143"],
        "coty_name": ["Vega Alta"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Vega Alta Municipio"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01804552"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8315414919619636, 10.27946117933685],
            [-0.7444395424384105, 10.277804712995671],
            [-0.6574066107337003, 10.276223864971666],
            [-0.5704755050008878, 10.274741282425945],
            [-0.45959335167850435, 10.273030693297837],
            [-0.35246367901907194, 10.271623053199017],
            [-0.355683973187029, 10.26934037799691],
            [-0.35481017041857005, 10.266226003088507],
            [-0.3512093334312052, 10.264182910643612],
            [-0.35626036320935545, 10.260401358332746],
            [-0.3591142318545304, 10.254280512457154],
            [-0.3587744908773113, 10.237469450490982],
            [-0.35348440701790135, 10.236128410165179],
            [-0.35668442605041134, 10.220206043352896],
            [-0.351686637549973, 10.218211492567262],
            [-0.352021903938723, 10.211154088078246],
            [-0.34924092676950097, 10.205607675476163],
            [-0.3449040188564567, 10.205514993227686],
            [-0.34751684526478993, 10.195225114742671],
            [-0.3418552905198794, 10.189912387691395],
            [-0.3429901059015363, 10.181654614079708],
            [-0.339721377524104, 10.176251046733672],
            [-0.33089092507366896, 10.17237928812222],
            [-0.32788948008975255, 10.168180461063494],
            [-0.33078868790322286, 10.165167052631848],
            [-0.33588605739932925, 10.165596005426936],
            [-0.33306758038591905, 10.160672409354081],
            [-0.3338891858407543, 10.154411610070925],
            [-0.32782561617014955, 10.150749181167756],
            [-0.32134551600665084, 10.15113465708327],
            [-0.32175881807650425, 10.146811898636162],
            [-0.32742332104359084, 10.141757670729868],
            [-0.3284382489621949, 10.138065641378342],
            [-0.3214009064951521, 10.137554154003784],
            [-0.3212232562519991, 10.131892826306458],
            [-0.31790987677689236, 10.127877175852062],
            [-0.317468489875479, 10.125056163647425],
            [-0.3201217840278344, 10.120477638189872],
            [-0.3179694938560937, 10.113412777304868],
            [-0.3210451025185156, 10.110247991476554],
            [-0.3251194462843583, 10.108718589090394],
            [-0.32477885406816753, 10.105683299879894],
            [-0.3207558309059573, 10.10031609968409],
            [-0.32204084393788773, 10.095773620330561],
            [-0.3280676276357994, 10.092769425622697],
            [-0.3184451980239032, 10.08792195193048],
            [-0.3082765472728576, 10.086653610138749],
            [-0.3083134554774515, 10.08232803424562],
            [-0.31311588363172355, 10.081205305037079],
            [-0.3219138114382256, 10.077251672138916],
            [-0.31986752668025775, 10.073783169665143],
            [-0.31581213765534044, 10.07725140196904],
            [-0.31095023066658767, 10.076159999305803],
            [-0.31152787047470815, 10.072366189222471],
            [-0.3168461897080993, 10.072743917163962],
            [-0.3168149742320357, 10.068315827306877],
            [-0.3074175609314356, 10.066294702552646],
            [-0.30910757685579027, 10.062015555206468],
            [-0.3077653199655974, 10.059141518237912],
            [-0.30275861227569595, 10.058966810172878],
            [-0.30186659226808105, 10.055716612364385],
            [-0.30783431404533196, 10.053563566363104],
            [-0.308411232789497, 10.050472902838976],
            [-0.30462415155318556, 10.049302217744868],
            [-0.30026128307775485, 10.042436640345196],
            [-0.3011815687692975, 10.038673107619214],
            [-0.3062811249412491, 10.034535834592718],
            [-0.30513375246451385, 10.030072698297031],
            [-0.3025982655731044, 10.027619070179842],
            [-0.2953297746333783, 10.027416099565189],
            [-0.2940843358989503, 10.024087085404371],
            [-0.29455780102289403, 10.019317688881959],
            [-0.29804888508114785, 10.015010262300665],
            [-0.29516272929205206, 10.011805641456139],
            [-0.29013486037587977, 10.011741696912495],
            [-0.2904207370329938, 10.007128364135731],
            [-0.29469573105068136, 10.00384426778279],
            [-0.28776905382344176, 9.998958134768946],
            [-0.28293171036706743, 9.98940158235418],
            [-0.27697769436319125, 9.985855874682407],
            [-0.27854449202435433, 9.983627001577943],
            [-0.2840183291674122, 9.982083277597484],
            [-0.283776522265451, 9.979757518568203],
            [-0.2769692853082639, 9.97018406177896],
            [-0.27492065651263914, 9.968540663582678],
            [-0.2655389581670954, 9.964746851374265],
            [-0.2664292491573741, 9.96065787265107],
            [-0.2717966197630743, 9.959906509589262],
            [-0.27060056124117776, 9.950327505565527],
            [-0.27518039034204234, 9.941711126787458],
            [-0.271209512962147, 9.941868358641903],
            [-0.2704728300456681, 9.93834671743079],
            [-0.27461881184565, 9.933447529279219],
            [-0.27621652879747854, 9.927350845556962],
            [-0.2815306332674936, 9.924257029619826],
            [-0.2775455690493409, 9.918752407918308],
            [-0.2774160011410871, 9.912659601104098],
            [-0.28022058843113684, 9.910498344191998],
            [-0.28680900310235174, 9.913886010698729],
            [-0.2917402765796119, 9.912310397135183],
            [-0.29179354503364635, 9.909504482567757],
            [-0.2847542090198045, 9.902066620556493],
            [-0.2871981731740266, 9.898608039430023],
            [-0.2913601657656632, 9.903004187715819],
            [-0.2944669159937016, 9.900745567678047],
            [-0.2912548527599843, 9.897665241208113],
            [-0.2933974622383167, 9.894078495910623],
            [-0.3014982089286441, 9.895375830691396],
            [-0.3046769791369699, 9.89357259289675],
            [-0.303706080583013, 9.889301870575338],
            [-0.29649810033955404, 9.889724271892858],
            [-0.29471611090054683, 9.887243256389892],
            [-0.3008543982340115, 9.879526008183445],
            [-0.30566165069939544, 9.879315137461447],
            [-0.30679981850702054, 9.87526894330093],
            [-0.30184267927455793, 9.875355142127832],
            [-0.29944871909190834, 9.872160740101208],
            [-0.3004221411378802, 9.865263872169637],
            [-0.3041410044590697, 9.862671117038419],
            [-0.31083506126805477, 9.863994078155173],
            [-0.31202486961721415, 9.860846952050911],
            [-0.3049837860563986, 9.85867741870726],
            [-0.30387316258329594, 9.856427819595512],
            [-0.3064471743483624, 9.849637043055232],
            [-0.31934876445507054, 9.847367671290867],
            [-0.32235357994372404, 9.844789357943634],
            [-0.3202736504126251, 9.841502719211537],
            [-0.3159626402149258, 9.83954824310681],
            [-0.3028385492974986, 9.839546001668516],
            [-0.2977144145775021, 9.836629497764125],
            [-0.2994900796411982, 9.833648334662463],
            [-0.3094224803659072, 9.833627153685397],
            [-0.3138813395766978, 9.836546384894296],
            [-0.31629360976366566, 9.83177143493358],
            [-0.3144424651406278, 9.826658940948748],
            [-0.31319682800157156, 9.825220807129213],
            [-0.3133654788815948, 9.82490266994665],
            [-0.391266375502603, 9.826402670107843],
            [-0.4900399941531011, 9.828037614502602],
            [-0.5781347812834151, 9.829522735346957],
            [-0.6655851617806178, 9.831072992262326],
            [-0.7382572564871224, 9.832293179187078],
            [-0.8254712577907113, 9.834025554328086],
            [-0.8237464042348331, 9.918667723660961],
            [-0.8220881390365529, 10.002968917071335],
            [-0.8223714186249593, 10.004087844174393],
            [-0.8369004467514166, 10.004390434507247],
            [-0.8365026162671383, 10.018427542255454],
            [-0.8363074300934378, 10.047743101320137],
            [-0.835616656433894, 10.08894897513109],
            [-0.8329656741542077, 10.180711549474626],
            [-0.8325986163384657, 10.20119906543458],
            [-0.8330483398109952, 10.228820442968207],
            [-0.8315414919619636, 10.27946117933685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.55179439137906, "lat": 48.76749405555864 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38067"],
        "coty_name": ["Pembina"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pembina County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01034212"
      },
      "bbox": [
        -0.8369004467514166, 9.82490266994665, -0.2655389581670954,
        10.27946117933685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.41817682161870556, 7.949094844447122],
            [-0.3334317900006315, 7.948241888966871],
            [-0.24758098192431094, 7.9475991695268835],
            [-0.1745687187095816, 7.947194563472335],
            [-0.0871321686582089, 7.946328337557597],
            [-0.0861311718376987, 7.946466093283681],
            [-0.08006181021294995, 7.945330109042527],
            [-0.07716512090896285, 7.946402470317029],
            [-0.07642634802987212, 7.942424911340242],
            [-0.07284545575893277, 7.940547895828279],
            [-0.07875418607481474, 7.937474834482057],
            [-0.0786321109088582, 7.935425529658258],
            [-0.07069778133895777, 7.937331250617183],
            [-0.07178299429080785, 7.930176294087621],
            [-0.06866517471806015, 7.925693012361501],
            [-0.07283937218326739, 7.924201524315278],
            [-0.06873350086016349, 7.920054622279926],
            [-0.06835617701459916, 7.913360044978381],
            [-0.06528467160851827, 7.91524377796838],
            [-0.06293862611154892, 7.911088423359886],
            [-0.058476187205952615, 7.911828054041612],
            [-0.05811227906918629, 7.9033255673737655],
            [-0.055453962216546845, 7.904821165610309],
            [-0.054344269012967836, 7.89863772628574],
            [-0.055048521532519816, 7.8929165565232005],
            [-0.05129782666521328, 7.892286929693117],
            [-0.049280052404225436, 7.883810200731315],
            [-0.05226201709583837, 7.8751783772372805],
            [-0.050779939437705875, 7.872699120822941],
            [-0.053135666054710914, 7.866553460635411],
            [-0.0474062060692516, 7.857762257366846],
            [-0.049215124621053326, 7.850802863769479],
            [-0.049436403093815584, 7.843493140571895],
            [-0.04471655678956699, 7.841278940774143],
            [-0.046877717758543276, 7.837120666820395],
            [-0.04326001867347859, 7.828485953720718],
            [-0.04353625165772601, 7.824668456539319],
            [-0.04623223738430828, 7.818749682309612],
            [-0.04619990094039606, 7.815566746520911],
            [-0.04358402431907281, 7.812973402076103],
            [-0.04488815196439279, 7.809641571991707],
            [-0.043202124965095824, 7.806163270567946],
            [-0.045937237061458, 7.802920340969169],
            [-0.042237072480820696, 7.800175292489944],
            [-0.0382983734775258, 7.79411414427526],
            [-0.03834710022414632, 7.789770552553941],
            [-0.03383379658829046, 7.787895945791402],
            [-0.029150038578908032, 7.782866735954816],
            [-0.0327538212670972, 7.7798881596343445],
            [-0.02792635950893033, 7.777787226866754],
            [-0.029730615333034966, 7.767524002867658],
            [-0.03436866868653428, 7.767473725065893],
            [-0.03237850779734334, 7.760070829317455],
            [-0.032863816724118367, 7.758051784928572],
            [-0.026298077353874086, 7.753378440654897],
            [-0.024006120911681278, 7.746958217829048],
            [-0.020790874764495645, 7.745370337889574],
            [-0.023374893305083792, 7.737654523550165],
            [-0.0223245435694477, 7.735752358058779],
            [-0.015592728165751057, 7.740267005869181],
            [-0.014590597758603864, 7.734787911914554],
            [-0.020078860057729915, 7.735338657801661],
            [-0.018561842216795493, 7.73090316704731],
            [-0.011239242490288712, 7.732791261954283],
            [-0.00995274890314859, 7.73040922990902],
            [-0.013224725062737615, 7.727787057469372],
            [-0.011788575151703342, 7.72392929617645],
            [-0.007775710157804, 7.726113451058061],
            [-0.005376766433932165, 7.723114721131871],
            [-0.0013483022858897956, 7.713856258329699],
            [-0.0031816628668817366, 7.710266520221637],
            [0.0016747781683197607, 7.705635482594425],
            [0.0005054336533243256, 7.703129111710162],
            [0.002481769402863303, 7.698587323176265],
            [0.0030395457315968793, 7.693149876208084],
            [0.009566741125247599, 7.68798647013619],
            [0.010466001094972135, 7.684595653062091],
            [0.018362596885361973, 7.680966657710359],
            [0.015234946585807744, 7.675576372233882],
            [0.01716670608714772, 7.669606120567386],
            [0.025569269257457075, 7.671430417770717],
            [0.02881767519301357, 7.668265299161501],
            [0.03731894323905757, 7.664577944819709],
            [0.03434691382818768, 7.660099783692024],
            [0.04088945583987859, 7.655556388157353],
            [0.04285787029522964, 7.65137458079802],
            [0.04850016007245198, 7.648065432671898],
            [0.04764496666323155, 7.638469109746386],
            [0.050430174251137494, 7.636509759672682],
            [0.04586882945235002, 7.621985869031704],
            [0.05004900734219755, 7.617670967209001],
            [0.044646425434156985, 7.61387486654511],
            [0.0502902691695911, 7.611045819588848],
            [0.05113278874568268, 7.60430494345359],
            [0.047863479711843265, 7.600082675086272],
            [0.05120603402585795, 7.596058411182474],
            [0.05024149185986985, 7.587384758709918],
            [0.04819099667951811, 7.58167089529094],
            [0.05177301784002585, 7.578872231024238],
            [0.051299188803651426, 7.5735201578505595],
            [0.05412306105018201, 7.569306798336709],
            [0.058269123768636355, 7.567342641674718],
            [0.0491871673016985, 7.562860394943646],
            [0.04850921847002623, 7.555761212682096],
            [0.049941630950231686, 7.551867591044198],
            [0.04948505068685759, 7.5476453616082555],
            [0.05144512347272186, 7.543061755497095],
            [0.05073905335877322, 7.5398390706125005],
            [0.0535144963446372, 7.5381727140639905],
            [0.05269751010732137, 7.533954354171202],
            [0.05686649085853935, 7.529969362201701],
            [0.055251554163955836, 7.524887989149186],
            [0.05847599324667706, 7.524263744250306],
            [0.05804719097820307, 7.5174157488028595],
            [0.0561173265043693, 7.515479375313647],
            [0.055469058526193514, 7.509969179385366],
            [0.053361872250317806, 7.505027861933241],
            [0.056371012608370775, 7.503096675620506],
            [0.05545745211890146, 7.499669685948644],
            [0.06155861206026024, 7.496744098421468],
            [0.06120841560312919, 7.4921527674572115],
            [0.06382843930211997, 7.480126369794474],
            [0.061543178533682796, 7.468283168260679],
            [0.06475698853929114, 7.463854743005897],
            [0.06896256115928044, 7.453098002516091],
            [0.06818777719003909, 7.447015482695149],
            [0.06980729571005735, 7.440724553413851],
            [0.07467695278911024, 7.43753537312356],
            [0.0700466053165472, 7.435717526402976],
            [0.07537343722949995, 7.426058696309709],
            [0.07706074841882594, 7.418335403218105],
            [0.07664475111186979, 7.410714121763143],
            [0.07848740325031435, 7.405205983693192],
            [0.07592982059182371, 7.3934571501661654],
            [0.07670797196791179, 7.3862586168437705],
            [0.07384624948717489, 7.376953184581722],
            [0.07010390090072581, 7.373015503566994],
            [0.06491423128893327, 7.359673505513358],
            [0.06186046424471473, 7.348762139117911],
            [0.06278307062119066, 7.343776906959043],
            [0.06435428158086272, 7.338517980245187],
            [0.06318635513789295, 7.330061174044317],
            [0.06472680234825223, 7.324416445793982],
            [0.06544337492020659, 7.302544097834434],
            [0.06675903187623927, 7.286056791891904],
            [0.06816209629471581, 7.281179433096854],
            [0.07021303994969469, 7.279825944959704],
            [0.07054125535478432, 7.272912017742514],
            [0.07292855273072563, 7.268247585292703],
            [0.07123911518028396, 7.257937844817463],
            [0.018741390134158438, 7.258345627859485],
            [-0.02459849786010189, 7.2591332824912564],
            [-0.08739924380948044, 7.259672073788113],
            [-0.09690736557451837, 7.259329223457833],
            [-0.1588224338414036, 7.260000754717338],
            [-0.23163635170855434, 7.260864029279614],
            [-0.2328312193496387, 7.260413787209062],
            [-0.3044407422376036, 7.261950958780582],
            [-0.31477596023224425, 7.261569414406353],
            [-0.3335320770465625, 7.261585830590572],
            [-0.3915363101803638, 7.262168563236061],
            [-0.3909752974359474, 7.318810808240983],
            [-0.41248782020135216, 7.323499956718897],
            [-0.41209573297801294, 7.363300700317908],
            [-0.41050375362077796, 7.463492805968762],
            [-0.40909841724010054, 7.56308463467393],
            [-0.4086140644856322, 7.606107867835945],
            [-0.42326393335765844, 7.606341472304923],
            [-0.4226299954997578, 7.649357532966665],
            [-0.4221744435802248, 7.692890728196577],
            [-0.42116689472122165, 7.741716223656001],
            [-0.42094293417166406, 7.76368055206339],
            [-0.41926331950376217, 7.863910124420765],
            [-0.41817682161870556, 7.949094844447122]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.94822546909826,
          "lat": 46.264643190927586
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38077"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richland County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01035302"
      },
      "bbox": [
        -0.42326393335765844, 7.257937844817463, 0.07848740325031435,
        7.949094844447122
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.054364460502594, 2.4024745890872645],
            [10.097268686962037, 2.404760382908195],
            [10.121011981998594, 2.4062911853911033],
            [10.156173209851916, 2.409162454610214],
            [10.226038910625054, 2.415465378993149],
            [10.22712907416624, 2.400444320588033],
            [10.263946928292405, 2.403090854602558],
            [10.263965632182316, 2.4037721049298524],
            [10.300403277877441, 2.4065937762047307],
            [10.3046765562116, 2.3493019953075316],
            [10.350700251599008, 2.3527429697811306],
            [10.444006666868257, 2.360034418243323],
            [10.449834845617852, 2.2869394393879228],
            [10.452653680938413, 2.2518066811856845],
            [10.459582993869523, 2.1727093098087775],
            [10.462710634296814, 2.134863122035224],
            [10.38979304960298, 2.1289035437349018],
            [10.356008034105653, 2.126402177613933],
            [10.278600932244645, 2.119980277352325],
            [10.191949647294818, 2.1120332910778954],
            [10.15407442020273, 2.109829670135041],
            [10.138492014178741, 2.210671212782489],
            [10.081415785949497, 2.203162376386103],
            [10.075693592671948, 2.240864704916201],
            [10.067760266723539, 2.297831557338528],
            [10.062070419190727, 2.340197769143129],
            [10.05735261667847, 2.377181637083451],
            [10.054364460502594, 2.4024745890872645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.00484977374855, "lat": 40.27840309537755 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39041"],
        "coty_name": ["Delaware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delaware County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01074033"
      },
      "bbox": [
        10.054364460502594, 2.109829670135041, 10.462710634296814,
        2.415465378993149
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.859866710544935, 2.7442592826549057],
            [10.87424592127399, 2.7458306088740594],
            [10.91440848029828, 2.7523441690286075],
            [10.95927233280133, 2.75852084103758],
            [11.004657360578006, 2.764525999934788],
            [11.0571495978379, 2.772400514141567],
            [11.08941466465981, 2.7779224937176505],
            [11.12857157082012, 2.783651362882373],
            [11.157381793229598, 2.7882911784475675],
            [11.214096106456783, 2.796588724997718],
            [11.214918077410045, 2.7967105792966347],
            [11.219821662750816, 2.7635762811950517],
            [11.20613340205173, 2.7593104786448936],
            [11.206701694917198, 2.7543890528212733],
            [11.210755877512678, 2.7548047355001737],
            [11.214899399484635, 2.7190099616831453],
            [11.218793131701112, 2.688407632644052],
            [11.220094315728849, 2.68174804415937],
            [11.226241575082696, 2.6292761113589562],
            [11.233342558627388, 2.5713307948140858],
            [11.203847246837366, 2.567760445135704],
            [11.161098865539394, 2.562608125305191],
            [11.116792934045042, 2.5570646272981787],
            [11.06551442749112, 2.5503514326923864],
            [11.059259771670968, 2.5502469402476993],
            [10.995145797593008, 2.5431437374180583],
            [10.994335435963347, 2.542808531839712],
            [10.921384629790031, 2.5350837271002113],
            [10.921489196254727, 2.533905183367492],
            [10.864311042677642, 2.528098303692967],
            [10.847624798536858, 2.5265807993039084],
            [10.839483602493745, 2.600126841746995],
            [10.834844103728443, 2.643588752966172],
            [10.804469303033597, 2.634146432313978],
            [10.79743522298823, 2.6812300066417127],
            [10.789384946162038, 2.7329256299922453],
            [10.833665910437208, 2.7397018220775955],
            [10.859866710544935, 2.7442592826549057]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.92928161683707, "lat": 40.5612273979471 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39075"],
        "coty_name": ["Holmes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Holmes County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01074050"
      },
      "bbox": [
        10.789384946162038, 2.5265807993039084, 11.233342558627388,
        2.7967105792966347
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.639139471435952, 0.5748611060105717],
            [10.669092567069344, 0.5940800691971675],
            [10.693394343049874, 0.6094232703679575],
            [10.67748951035145, 0.6356501592737425],
            [10.670428192175375, 0.6505642833761135],
            [10.666956641578473, 0.6541559360184288],
            [10.663765773138794, 0.6896945841793168],
            [10.708147370056714, 0.6933910922548324],
            [10.710010435806337, 0.7073092635521241],
            [10.70635269395242, 0.767052357539701],
            [10.73149193150328, 0.7685594276188008],
            [10.73059112803492, 0.7832171696681273],
            [10.732321564494594, 0.7836655589159258],
            [10.72989544344905, 0.8263457270476381],
            [10.72702637384881, 0.8710099011130901],
            [10.784540276697404, 0.8744785499250096],
            [10.78840942093741, 0.8083359483992263],
            [10.865130384697004, 0.8123450355752402],
            [10.867029607425184, 0.7827333092645243],
            [10.882308765620994, 0.7833919824561673],
            [10.886505814175866, 0.7236126478063202],
            [10.97770502403397, 0.7304045204605483],
            [10.985314986926317, 0.6387830379467861],
            [11.042666067829495, 0.6446444532434081],
            [11.042823424391225, 0.6444685145114418],
            [11.040152395662862, 0.6404021959519233],
            [11.039074607300881, 0.633817826197693],
            [11.041333818758673, 0.621494218959464],
            [11.042657634425362, 0.5994438721324052],
            [11.03935700449634, 0.5833541778189164],
            [11.03931112081997, 0.5777358787880246],
            [11.041929841307994, 0.5645468799659737],
            [11.042217381979386, 0.5563486186074309],
            [11.039199969004724, 0.5425081973089645],
            [11.038857649199413, 0.5270642635641178],
            [11.0371319483894, 0.5163988724373698],
            [11.033859575080697, 0.5071419502538126],
            [11.029686415459413, 0.501672724594479],
            [11.022289823444762, 0.49697794293180775],
            [11.00765605119406, 0.4924621989471403],
            [10.991601586516207, 0.486254087439216],
            [10.9855417684244, 0.48494346584696296],
            [10.97320181096008, 0.48825802153002956],
            [10.951888792875488, 0.47574022708812685],
            [10.942580667842227, 0.47124088930263136],
            [10.93323439519609, 0.4675534784975082],
            [10.913519198852443, 0.457996075222827],
            [10.89835481480061, 0.44838085052062976],
            [10.882329573316364, 0.44038042961871543],
            [10.874386696278727, 0.4377012880878663],
            [10.867077197252877, 0.43618630341558456],
            [10.858571081783586, 0.4365181650962281],
            [10.850041925446517, 0.4357359893885197],
            [10.843991288781359, 0.4375733366885257],
            [10.836689800996316, 0.4415924628959009],
            [10.8313778431398, 0.446458664585017],
            [10.830872703699372, 0.4500269229077461],
            [10.827536292536792, 0.4545343519229806],
            [10.823065702418145, 0.46483289847412246],
            [10.817330006183525, 0.4868803589267144],
            [10.813008194633461, 0.4946382598422983],
            [10.807790592691523, 0.5005069824304395],
            [10.799148929895013, 0.504552779083832],
            [10.788036549427021, 0.5078255062948352],
            [10.778996078105386, 0.512582783573868],
            [10.771441512043756, 0.5180904090088978],
            [10.763712326830666, 0.5260958367231856],
            [10.75447407997149, 0.5347515540710854],
            [10.740669766452298, 0.5536233004784803],
            [10.731752370244326, 0.5609485856985071],
            [10.720066606907743, 0.5656336947423624],
            [10.71086529635302, 0.5715343127807087],
            [10.705944308068855, 0.5725393518371995],
            [10.699369151666733, 0.5713373737751698],
            [10.680679721475387, 0.5701509375734358],
            [10.668772990890602, 0.5670800872928001],
            [10.660740729489719, 0.5669021883974132],
            [10.652361935198837, 0.5690257309684503],
            [10.639139471435952, 0.5748611060105717]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.53676311205017, "lat": 38.59841624177514 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39087"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01074056"
      },
      "bbox": [
        10.639139471435952, 0.4357359893885197, 11.042823424391225,
        0.8744785499250096
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.324213397268572, 1.4394118614108184],
            [9.384477670867279, 1.4469094204588997],
            [9.449029776908368, 1.4492342362493098],
            [9.515837875623008, 1.4517840547859369],
            [9.551509370060627, 1.4533406408351282],
            [9.620887341491404, 1.4560837630195906],
            [9.628568725823024, 1.32083706630792],
            [9.63020856408989, 1.288467387126674],
            [9.633112228562961, 1.2356301131164624],
            [9.636039741289245, 1.1721434350814117],
            [9.637732906993186, 1.1384858400917088],
            [9.582778892885658, 1.1359810844194445],
            [9.488325541305954, 1.131955564723922],
            [9.444010039326873, 1.1301970611528647],
            [9.44448818478536, 1.1374900326964752],
            [9.438814191913169, 1.1395227857165808],
            [9.439750055186794, 1.1474491181105793],
            [9.428027920607022, 1.1470367649202862],
            [9.412710383341368, 1.1475716363954744],
            [9.38440848682564, 1.14563137930778],
            [9.369996710490657, 1.1428383524129198],
            [9.365826447718035, 1.2197736232383725],
            [9.362313896334687, 1.3083664184746473],
            [9.359576316663428, 1.3087427434500338],
            [9.356511526445644, 1.36279631489222],
            [9.354553556463426, 1.4001311093349624],
            [9.35366424231227, 1.4016055428724667],
            [9.332841477261768, 1.3923573777319072],
            [9.330547084138216, 1.3937446010721497],
            [9.324213397268572, 1.4394118614108184]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.16679222518454,
          "lat": 39.427708977015726
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39165"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "01074094"
      },
      "bbox": [
        9.324213397268572, 1.1301970611528647, 9.637732906993186,
        1.4560837630195906
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.805073149845159, 2.7495680355041285],
            [9.794442786096415, 2.8365386704785363],
            [9.822687641120824, 2.840118257988044],
            [9.816897201579566, 2.8834588127026684],
            [9.83107010253966, 2.885476420886959],
            [9.825219037483784, 2.9285401862888523],
            [9.853039694268796, 2.932455131301168],
            [9.88087248471465, 2.936532201900438],
            [9.920666603752853, 2.942028443565791],
            [9.924209312988797, 2.942727569313336],
            [9.967759962820184, 2.948918879707753],
            [9.972423853526559, 2.9493182424735123],
            [10.061509070124467, 2.9621144304560105],
            [10.08101054975315, 2.9647240067421743],
            [10.091807870622649, 2.888265520527959],
            [10.094904965088405, 2.8634119231363675],
            [10.097976923430835, 2.8422529420018265],
            [10.107238680759954, 2.7759083317069893],
            [10.111454950578596, 2.746966567911671],
            [10.117045817619632, 2.7064415244308173],
            [10.121642082229432, 2.6749133848684754],
            [10.061464169092526, 2.665931083097504],
            [10.035563741678473, 2.662628463770097],
            [9.97776681476504, 2.65452821951741],
            [9.979737499736295, 2.6396638804403754],
            [9.946293272855709, 2.635396133071802],
            [9.89394377846357, 2.6283570473927647],
            [9.894000618743434, 2.62790212436848],
            [9.878661671426517, 2.6266646609082116],
            [9.876803918764592, 2.6412473320679064],
            [9.862472560744264, 2.6392838659751097],
            [9.84881474248289, 2.636792539173877],
            [9.83551794084223, 2.6350539170763483],
            [9.831708003079456, 2.6640035165376283],
            [9.830861323114368, 2.6638956678931573],
            [9.821532385587194, 2.735339590657413],
            [9.819670348602354, 2.751298686963756],
            [9.805073149845159, 2.7495680355041285]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.30438038092959, "lat": 40.84238101601752 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39175"],
        "coty_name": ["Wyandot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wyandot County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "01074099"
      },
      "bbox": [
        9.794442786096415, 2.6266646609082116, 10.121642082229432,
        2.9647240067421743
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7189826164720228, -2.0612914194458156],
            [-2.587615961219601, -2.0666714158723747],
            [-2.457479583416592, -2.0718690367899693],
            [-2.403107537458013, -2.0744345768771377],
            [-2.4038538417490125, -2.098926623087378],
            [-2.4084309245718676, -2.2188326890906587],
            [-2.410176272346982, -2.2594076454424377],
            [-2.4124217704706155, -2.32104425918596],
            [-2.41590269354753, -2.42322456747051],
            [-2.4086168443891545, -2.423487340195168],
            [-2.411883596940683, -2.5068148288745533],
            [-2.298020830696193, -2.511171732579687],
            [-2.2408192689059083, -2.5128492684858768],
            [-2.2430368684851465, -2.5789697434625567],
            [-2.243333764124289, -2.5804675470243317],
            [-2.245412347299589, -2.6654129106458955],
            [-2.247347969510319, -2.664594519672633],
            [-2.260260968506998, -2.6659125994395785],
            [-2.2667384490752167, -2.665061367370311],
            [-2.2783896163411637, -2.6652412552286977],
            [-2.2905852674100933, -2.6685805593436007],
            [-2.3024447098264074, -2.6708466464568468],
            [-2.311441292421819, -2.6760298640579028],
            [-2.3172995895223005, -2.6847061694117045],
            [-2.323682795840159, -2.6900245911002645],
            [-2.3298370141497378, -2.6892363921810736],
            [-2.3386197431659843, -2.696537730726058],
            [-2.3416305488721485, -2.7030751054687387],
            [-2.3426633393879817, -2.7081890859130273],
            [-2.347078915236316, -2.7173649162403692],
            [-2.3479230460852225, -2.7262878031533715],
            [-2.3503611483219036, -2.7292716417784697],
            [-2.350853480554704, -2.7359426566564213],
            [-2.352438495371577, -2.7383162979670366],
            [-2.3562152233309837, -2.7492902938939126],
            [-2.363967716227271, -2.7549812280660833],
            [-2.3718774716306665, -2.7630300161702737],
            [-2.3734117960410503, -2.7661666524120916],
            [-2.380411254602508, -2.771807212044528],
            [-2.3847023492595416, -2.774031820621443],
            [-2.386918255856609, -2.77941336178583],
            [-2.385257276656798, -2.7871264899250114],
            [-2.3898537018975867, -2.795265542832566],
            [-2.3930971788760593, -2.8082481696932757],
            [-2.3959476142322584, -2.810778169253867],
            [-2.400914721341655, -2.811334384278966],
            [-2.4084879155541783, -2.8141243770954683],
            [-2.4282356540819388, -2.817096096946992],
            [-2.4359004347199424, -2.8253298487270913],
            [-2.4414737263155293, -2.8297519217701494],
            [-2.4553545564737806, -2.8289765801165703],
            [-2.4697004765358868, -2.821346938342274],
            [-2.47865770580728, -2.8193057276684215],
            [-2.4894423626606064, -2.819693401781863],
            [-2.4955650558145517, -2.818708941034933],
            [-2.5021392395870223, -2.8156779082182113],
            [-2.5206189242273846, -2.8096439368033153],
            [-2.5250092335328076, -2.8066669011121705],
            [-2.5258291623396336, -2.803477409794369],
            [-2.5300646171014294, -2.798660064361232],
            [-2.5370890876501755, -2.7935896079336238],
            [-2.540117819593812, -2.788786733527625],
            [-2.5432708502879047, -2.7863686183094423],
            [-2.5487499699406206, -2.7854817422621125],
            [-2.5550758711911103, -2.7871293762475715],
            [-2.559742648300236, -2.7850279662759054],
            [-2.5675025714274406, -2.778246694845594],
            [-2.5689033776135592, -2.7707954011882028],
            [-2.5737870688920053, -2.7674798677880856],
            [-2.5771460664040067, -2.76254302654978],
            [-2.5824128865143736, -2.759690802088617],
            [-2.5862027477961247, -2.7557279754132917],
            [-2.586551914954235, -2.745881646557079],
            [-2.5885047238216568, -2.7415491254976656],
            [-2.592544728771377, -2.7370481780250997],
            [-2.592509343541208, -2.7317680614332804],
            [-2.589651319113592, -2.725094667874804],
            [-2.591514250926353, -2.720362957298897],
            [-2.591192718438778, -2.7124548507198867],
            [-2.5894317706253265, -2.705459879878856],
            [-2.586837532844013, -2.70177517973768],
            [-2.5844623204699673, -2.694297091697037],
            [-2.58689794535109, -2.6818702667704115],
            [-2.585890822254975, -2.677245116203571],
            [-2.5890466544477553, -2.665417669205811],
            [-2.59242401727638, -2.6622230426425095],
            [-2.6001300630908113, -2.6594375181261105],
            [-2.611601605012939, -2.657700021121811],
            [-2.6191237067284896, -2.658118513973223],
            [-2.6253963171943484, -2.660279047538831],
            [-2.637035837629674, -2.6726792423865047],
            [-2.6423719959988325, -2.6756191192937044],
            [-2.6527155257468564, -2.675147444491888],
            [-2.6577604640659254, -2.6786934842961494],
            [-2.6585565260723283, -2.6857319355859737],
            [-2.6695860699375085, -2.6958596567219204],
            [-2.6723264587673086, -2.7004992881425154],
            [-2.673483248450659, -2.707451964017963],
            [-2.6724280755710357, -2.7181358753261033],
            [-2.6696130262459197, -2.720372400360874],
            [-2.668686658268333, -2.7260716409128047],
            [-2.6712808955860585, -2.734646942584931],
            [-2.68187696892372, -2.7425949249553607],
            [-2.685315310281655, -2.748655918858667],
            [-2.692964919277315, -2.752549005705365],
            [-2.713535512242348, -2.761235515968732],
            [-2.7197880264130974, -2.7689796179520445],
            [-2.7240202445866464, -2.772158572243199],
            [-2.734908389406336, -2.776468076363918],
            [-2.7470278863839224, -2.7788043236495636],
            [-2.739622033559495, -2.603096789786427],
            [-2.735035376277688, -2.4942643574557857],
            [-2.7303749142370908, -2.3836715568328413],
            [-2.7207681708797633, -2.1556761897028043],
            [-2.723438140318038, -2.1555663471867077],
            [-2.7222045165102426, -2.126166395330314],
            [-2.7189826164720228, -2.0612914194458156]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.75464701447223, "lat": 36.21836022610306 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40045"],
        "coty_name": ["Ellis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ellis County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01101810"
      },
      "bbox": [
        -2.7470278863839224, -2.8297519217701494, -2.2408192689059083,
        -2.0612914194458156
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9986261099311491, -2.2101360941255703],
            [1.0736698234002842, -2.2094366821665754],
            [1.1707915224226848, -2.208341932690505],
            [1.1980611813409416, -2.208394122392363],
            [1.255336690346211, -2.2082407423279413],
            [1.2558079949300414, -2.2567581072891723],
            [1.2560101008437365, -2.2574177494437833],
            [1.256367173958956, -2.306665965653731],
            [1.256789625206594, -2.324850528879337],
            [1.257511473420785, -2.427088231936099],
            [1.2582481838941886, -2.4716602266431313],
            [1.2545440460246606, -2.471581871028401],
            [1.2539392604944695, -2.501359012956818],
            [1.2545354045560033, -2.559377533310013],
            [1.1858957527452083, -2.5603372047654998],
            [1.1688170776813769, -2.5603541754362986],
            [1.1697307938688846, -2.6481574567138138],
            [1.0980074948868603, -2.6485584225038266],
            [1.0734988535054464, -2.6488149752314656],
            [0.998003296211609, -2.6487627060025094],
            [0.9122033797363761, -2.6493785596289485],
            [0.9114693062243697, -2.5173361930152143],
            [0.9123721856659718, -2.4738676644111655],
            [0.9147250365784905, -2.473855756613121],
            [0.9139351178983306, -2.344864919069254],
            [0.9130879603743957, -2.210772683478519],
            [0.9986261099311491, -2.2101360941255703]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.23074639579714, "lat": 36.3019264703526 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40097"],
        "coty_name": ["Mayes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mayes County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01101833"
      },
      "bbox": [
        0.9114693062243697, -2.6493785596289485, 1.2582481838941886,
        -2.2082407423279413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.702364679901779, 3.3745072576032413],
            [14.714429964049375, 3.361207406717268],
            [14.723680348972882, 3.359026538766191],
            [14.728396358270665, 3.354990335046939],
            [14.727587954229552, 3.3610964756288135],
            [14.73941501937061, 3.3653076685380268],
            [14.743003620353107, 3.364557623696568],
            [14.749539787883254, 3.365762864073992],
            [14.748183041486206, 3.3715992165051087],
            [14.750718844271564, 3.373635089103472],
            [14.761107640732288, 3.374265085879341],
            [14.763041660793023, 3.376786272598657],
            [14.762046781586491, 3.381822676203886],
            [14.765074205515003, 3.386656948992076],
            [14.771701359532775, 3.386241963368311],
            [14.783311416966631, 3.388169676689895],
            [14.787992159079298, 3.391347735725681],
            [14.790954026236127, 3.3984722112688344],
            [14.801551894309313, 3.3999818742321377],
            [14.803477591049123, 3.402024884150633],
            [14.802555947788221, 3.410578641008545],
            [14.805974695586395, 3.4151858804716015],
            [14.810304650190817, 3.413531476161996],
            [14.814356539128791, 3.410004318322184],
            [14.820004260892272, 3.4124114350966064],
            [14.824722638085452, 3.41774926980491],
            [14.840543997441808, 3.4231499715146123],
            [14.844331475270193, 3.4291292059613925],
            [14.846867546841898, 3.4309997271685972],
            [14.856489506509934, 3.4332497160427535],
            [14.862702469392403, 3.4328060930906923],
            [14.865250237114871, 3.4344094329703405],
            [14.866419577175828, 3.4390458754838247],
            [14.869636090706086, 3.44094606860243],
            [14.877604081466576, 3.438239990608015],
            [14.878746854555322, 3.441262606881084],
            [14.888841758881806, 3.436060978497465],
            [14.932166892604322, 3.4129409467827605],
            [14.986331044128901, 3.383863134776158],
            [15.02227861087592, 3.3650634034789726],
            [14.933463774203942, 3.2639906151159948],
            [14.96033250256963, 3.2128119312991443],
            [14.986412954209708, 3.1635387812707285],
            [14.99989777117303, 3.1383768277172055],
            [15.015789835641854, 3.1096718423482486],
            [15.041971290698058, 3.0596282254320855],
            [15.070856509328037, 3.005171881144755],
            [15.07291374564272, 3.0067246875477207],
            [15.069773697038482, 3.0037663377301094],
            [15.063857059944546, 3.0030098814161716],
            [15.061964653659123, 2.9986009290789553],
            [15.049775998707753, 2.9933141530204597],
            [15.044489907994052, 2.9939976618062256],
            [15.040636727592947, 2.98845895505373],
            [15.039416981993284, 2.9832946333590846],
            [15.035687329713108, 2.981736202047293],
            [15.03150405676924, 2.9776806879169353],
            [15.029478944895406, 2.9709623509228553],
            [15.026687865065561, 2.9698163698286684],
            [15.02559242738555, 2.9661700996327727],
            [15.021743955817927, 2.9634912245291907],
            [15.014834532963281, 2.963243677265017],
            [15.014049959629805, 2.9610158569459313],
            [15.008731074826207, 2.9593280889684053],
            [15.001968238624286, 2.951794502623669],
            [15.004241535128948, 2.9491635909444702],
            [15.000226105642664, 2.94686333237385],
            [15.000452299417502, 2.9426203902562085],
            [14.995451327473727, 2.9445840213781405],
            [14.990325113357617, 2.9439849535769054],
            [14.985751252033854, 2.9449567327686155],
            [14.986142900596763, 2.9409424030975257],
            [14.984404782949172, 2.9354334113107465],
            [14.980511696971474, 2.932474427718444],
            [14.978455466866482, 2.92595269567314],
            [14.975279865508973, 2.9195333824781704],
            [14.97335905678566, 2.9074005236773575],
            [14.964629238642386, 2.9083467373291083],
            [14.957716043651667, 2.912224283198217],
            [14.953620912609503, 2.916868632356079],
            [14.950058409035693, 2.9294214599667385],
            [14.94633956053357, 2.938573849434735],
            [14.942345670531628, 2.9526004197766125],
            [14.939554304896099, 2.9572240359621724],
            [14.931062499133791, 2.9591134779348764],
            [14.921486719591492, 2.962623064867168],
            [14.909848292341639, 2.9679127368931284],
            [14.898535154432489, 2.9744038662631107],
            [14.882673163346674, 2.9724287022256237],
            [14.87657471598929, 2.9749649061067],
            [14.869564717332457, 2.986844237797027],
            [14.865354453339622, 2.989741794005857],
            [14.84990446468132, 2.9914371543980423],
            [14.84340671183646, 2.9950787529219163],
            [14.83176966526871, 3.005800953877291],
            [14.822231649794114, 3.0096175789539927],
            [14.809233809272078, 3.018369441459658],
            [14.800309323716005, 3.0274099070301888],
            [14.79658939086696, 3.0359909077604175],
            [14.79317124373671, 3.0381751794221112],
            [14.788775808728715, 3.0441009412769064],
            [14.787464054781438, 3.054685565406686],
            [14.789625596238901, 3.067705117265343],
            [14.791165114537515, 3.0732779671605157],
            [14.790569830157347, 3.081327501663335],
            [14.787864703354508, 3.0838506830070127],
            [14.785286718968685, 3.0876992743989677],
            [14.776468663891043, 3.095388661127531],
            [14.773909530552492, 3.1010639503491055],
            [14.769896231500724, 3.10704531100356],
            [14.765319348404654, 3.109081917286501],
            [14.747738059736289, 3.1060826397695425],
            [14.741071383240271, 3.1029550577645755],
            [14.73245062869324, 3.102252049669231],
            [14.720715877515453, 3.0992177270010175],
            [14.712833575215996, 3.0994426104353288],
            [14.708513330226067, 3.102365966051945],
            [14.70343208844373, 3.1040544003780295],
            [14.700885247758205, 3.107222413122151],
            [14.69822938150323, 3.114940123408996],
            [14.694414501197974, 3.1187872609984133],
            [14.691594462883607, 3.1243719607023457],
            [14.691296003745402, 3.129559476900303],
            [14.694960357587645, 3.1362578017569764],
            [14.700392086464275, 3.1420484899152155],
            [14.700407473560345, 3.1472552400275493],
            [14.69571581287354, 3.1547734988060347],
            [14.693496745259981, 3.1641121490580124],
            [14.702811169593856, 3.1676676554033594],
            [14.70536907988897, 3.1752458026027783],
            [14.710742788472837, 3.1809510188249908],
            [14.715581693804008, 3.1911528770867106],
            [14.72141942727982, 3.1973026135300264],
            [14.728119323221089, 3.202587632991822],
            [14.732938687583886, 3.2104274203258862],
            [14.734081710924304, 3.2169884100131427],
            [14.733737061571714, 3.2218169321211487],
            [14.730978661918446, 3.232702669784232],
            [14.727119622332726, 3.2381327257934767],
            [14.71386357592908, 3.2426292739315343],
            [14.705099257391726, 3.2507061884465487],
            [14.698266613589448, 3.258777002139444],
            [14.696120095672555, 3.267229319031578],
            [14.697783550728435, 3.274683339659926],
            [14.697225025403487, 3.28115615339042],
            [14.69514043018911, 3.2859573009178553],
            [14.68417510955218, 3.3022953845831067],
            [14.682554884326564, 3.308545725602402],
            [14.683403491637774, 3.3133423126045636],
            [14.686911534560869, 3.3200952266100976],
            [14.69869168072988, 3.3314783461833404],
            [14.702369023727789, 3.3382245180602816],
            [14.704198223423608, 3.3505651349094],
            [14.70180796598387, 3.3606289470007136],
            [14.701345518567239, 3.3731466894748463],
            [14.702364679901779, 3.3745072576032413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.77943935306888,
          "lat": 40.415444729058706
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42043"],
        "coty_name": ["Dauphin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dauphin County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01213667"
      },
      "bbox": [
        14.682554884326564, 2.9074005236773575, 15.07291374564272,
        3.441262606881084
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.031677020391951, 4.1431551844465915],
            [15.037784108103828, 4.213310486189577],
            [15.127492117131693, 4.234937886349024],
            [15.204391180457229, 4.254104887851988],
            [15.238514620778037, 4.263258640318616],
            [15.2530253513016, 4.273047433220225],
            [15.262890343285903, 4.278198721569044],
            [15.324001125623196, 4.312886710511958],
            [15.350675752764047, 4.328444106515406],
            [15.353653676746639, 4.331481042381084],
            [15.358592819617693, 4.320713339174217],
            [15.360759269933896, 4.305217759336266],
            [15.363747068183605, 4.30018448484751],
            [15.372341624347136, 4.295254043193484],
            [15.382869044086444, 4.294804502791461],
            [15.388532608243525, 4.2934072895951765],
            [15.392903859702715, 4.288672249411786],
            [15.415268103785305, 4.281391624772302],
            [15.437758681287926, 4.2687160011116685],
            [15.478457603436757, 4.268394497049859],
            [15.483634283716235, 4.247287123493484],
            [15.478506542022066, 4.245911104478974],
            [15.481995650278467, 4.232813641501029],
            [15.48434806832682, 4.233554113880662],
            [15.48873297844068, 4.217478719415255],
            [15.496211143344736, 4.219277592952573],
            [15.501300513428584, 4.196040837238435],
            [15.522479038854884, 4.193512767886635],
            [15.539733772952813, 4.125013971104027],
            [15.544792170814118, 4.12102272926799],
            [15.546258660381891, 4.115198541886806],
            [15.549184320822006, 4.115787038930924],
            [15.552301266059803, 4.11146735019758],
            [15.556171467076311, 4.110568263468402],
            [15.561836924324638, 4.111881751067982],
            [15.566677659295369, 4.115946450054046],
            [15.572031604837008, 4.108371408073595],
            [15.575314134436155, 4.1090920110625255],
            [15.58062113612525, 4.107470054469754],
            [15.579031277840505, 4.101580224572007],
            [15.580817618750133, 4.097609963045773],
            [15.576820213274646, 4.094864835815213],
            [15.572108062425034, 4.094512922836431],
            [15.57432082652711, 4.089295153190906],
            [15.565732920249824, 4.0788649527236025],
            [15.567799752239868, 4.070504947639534],
            [15.56439667347885, 4.06941411578079],
            [15.564431653495626, 4.064585550099961],
            [15.559209266208386, 4.06713347516758],
            [15.553173783227447, 4.064035347794255],
            [15.553499412345149, 4.061243886485924],
            [15.550980081742253, 4.054791128422265],
            [15.547876451742036, 4.056162074451026],
            [15.548245469470269, 4.060749757357102],
            [15.543190303546343, 4.066131159452995],
            [15.540285432609492, 4.066582095444563],
            [15.537797203691692, 4.069855678559955],
            [15.529888238847805, 4.067157413492394],
            [15.525963236824664, 4.063160556017474],
            [15.520563676555327, 4.063272855013707],
            [15.515056227601224, 4.058081191714915],
            [15.514439661197779, 4.053107186381469],
            [15.509569976415628, 4.051402570495329],
            [15.51148600817406, 4.045274267078904],
            [15.505224023637062, 4.046494999086263],
            [15.502036186025595, 4.0368575567629215],
            [15.498232476588257, 4.034390289485457],
            [15.49681775935781, 4.029385124324322],
            [15.492195379830786, 4.027357834719145],
            [15.48435371657437, 4.027596477633567],
            [15.481024198243869, 4.024303484494209],
            [15.483049145731155, 4.01939787640889],
            [15.479210042101018, 4.013771421709814],
            [15.47627487612438, 4.015217941821829],
            [15.473760834497801, 4.012459381246673],
            [15.476685011496679, 4.00561431535088],
            [15.473679825187235, 3.9971624159545747],
            [15.476801766296784, 3.9895560098201597],
            [15.477347765343165, 3.981847921434484],
            [15.480621717208901, 3.971171388872128],
            [15.485388412388877, 3.9658950747357933],
            [15.489199229585692, 3.963619394900982],
            [15.493726127331742, 3.954991146516588],
            [15.504735189569425, 3.957132537211223],
            [15.508082676798656, 3.9543911405185264],
            [15.510973712820704, 3.943477121175398],
            [15.517424514756312, 3.935920281686152],
            [15.472190858153565, 3.900744228102361],
            [15.45917131837208, 3.897072017858165],
            [15.439931113651404, 3.8822414493191166],
            [15.441544804695077, 3.8765905241532135],
            [15.427778071306486, 3.8664236152855214],
            [15.415253165530254, 3.8564623834745104],
            [15.343185005574583, 3.8009082717733165],
            [15.323229456220805, 3.7853961009104835],
            [15.260228575262577, 3.793501271338241],
            [15.181500845482693, 3.804157404154208],
            [15.16152789274093, 3.851717310241021],
            [15.143425224562264, 3.899494368775935],
            [15.144731604545745, 3.9032341255966063],
            [15.12670367177551, 3.986646619360317],
            [15.112212057608875, 3.9800979615524117],
            [15.092700374547931, 3.9726389318593482],
            [15.06775425537594, 4.0084576989045875],
            [15.046293152057572, 4.041311519417705],
            [15.044129771079866, 4.0480211295787],
            [15.03150789237188, 4.14183660549141],
            [15.031677020391951, 4.1431551844465915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.98922796570223,
          "lat": 41.177014586959096
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42079"],
        "coty_name": ["Luzerne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Luzerne County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01209183"
      },
      "bbox": [
        15.03150789237188, 3.7853961009104835, 15.580817618750133,
        4.331481042381084
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.870920431107065, 4.624464321184725],
            [15.88034030061496, 4.615371354971756],
            [15.886191635848778, 4.6135477163070435],
            [15.891603041649423, 4.610110005054482],
            [15.895489068504482, 4.602574608421453],
            [15.899135697066031, 4.5978246427767075],
            [15.905457926583152, 4.594506536955783],
            [15.910015835447291, 4.593928904431147],
            [15.918995420278366, 4.583852513355085],
            [15.92175647844548, 4.579012922811574],
            [15.921647120031714, 4.5751103647587685],
            [15.91709651702876, 4.571073036660628],
            [15.919854519722326, 4.564839565958595],
            [15.924723564134558, 4.564861102685855],
            [15.930649109920916, 4.5624302342317575],
            [15.935755663846537, 4.559033913175914],
            [15.93928516144253, 4.553220343252439],
            [15.93871610519927, 4.546379930396114],
            [15.94250542758762, 4.543400218651347],
            [15.950886134357468, 4.54665500524835],
            [15.953729167383932, 4.545101953827652],
            [15.957355473621492, 4.535469543525124],
            [15.95742800284698, 4.524566820476178],
            [15.961595795823294, 4.519406903938707],
            [15.970683201753145, 4.518862590119737],
            [15.979346687347421, 4.51973291309736],
            [15.985793695235836, 4.525534891339595],
            [15.98699453448624, 4.528469630976249],
            [15.996654634226262, 4.529722630455305],
            [16.003962794176264, 4.5260250221057134],
            [16.012697073436403, 4.526409830840038],
            [16.015819289958856, 4.523848236037078],
            [16.019990810828755, 4.513143141064149],
            [16.029215718645055, 4.51218973159301],
            [16.033269167368445, 4.510150219015483],
            [16.035105459062937, 4.506362228531712],
            [16.03199953910374, 4.500362571190453],
            [16.031804549380386, 4.496281003129362],
            [16.034329412998577, 4.493502737052562],
            [16.038267260102515, 4.4936980891135105],
            [16.046490246821833, 4.497691569702651],
            [16.054407871935073, 4.503240760200544],
            [16.058743906607535, 4.504665380464603],
            [16.06692579432887, 4.5021347696627485],
            [16.077308081296, 4.495665651332965],
            [16.083553089926642, 4.496120602850618],
            [16.089056882285053, 4.5074669651230135],
            [16.09276456939865, 4.510856580398839],
            [16.09765265222831, 4.511053809092225],
            [16.101758010948817, 4.507860016048135],
            [16.104494271454154, 4.501462706679218],
            [16.10913509381991, 4.4949809165996495],
            [16.11326504528639, 4.4935248517895054],
            [16.117510550195, 4.495244833904719],
            [16.12148456325637, 4.498933405079342],
            [16.12658664009055, 4.50124874580478],
            [16.13221263008913, 4.499825520266326],
            [16.138428172933544, 4.502657174093497],
            [16.14068220774348, 4.506249545858463],
            [16.147043579550395, 4.510964356238263],
            [16.15055407052377, 4.509769801227424],
            [16.153433696336744, 4.503695376560046],
            [16.15263098631297, 4.493996143799353],
            [16.151346492365764, 4.4915924060571015],
            [16.15284262532469, 4.485447042510429],
            [16.157872397956343, 4.479660987351045],
            [16.162635124201636, 4.477920008202417],
            [16.169741437472204, 4.478533232805168],
            [16.17626128692106, 4.474988610588784],
            [16.182299431351893, 4.465113235600495],
            [16.197471907840598, 4.456629453910387],
            [16.199752837566507, 4.451205122328824],
            [16.196942500218572, 4.446304334048551],
            [16.193460582959208, 4.442554907899856],
            [16.188117835298453, 4.439466223470801],
            [16.180304367218362, 4.432177802812394],
            [16.173754991660918, 4.429247338437675],
            [16.16982328384697, 4.428906654420402],
            [16.157117249063553, 4.4256172351331164],
            [16.153265723002143, 4.418770048096235],
            [16.152916140288923, 4.409665934825367],
            [16.14848862832135, 4.401975462286655],
            [16.134157146379202, 4.396037425366859],
            [16.132345086060937, 4.391557800058052],
            [16.13583603437554, 4.387784189770782],
            [16.136476273044785, 4.384363222135303],
            [16.12774986411067, 4.374688026535376],
            [16.125102396464467, 4.368938709266793],
            [16.11890392076422, 4.363086916276098],
            [16.114440683408517, 4.355237846410222],
            [16.112880916019133, 4.348610501421414],
            [16.11060653271121, 4.344155069970309],
            [16.109995094206656, 4.3375182480298875],
            [16.10798516418157, 4.328919919174144],
            [16.110039440928713, 4.324207887491589],
            [16.10868894489215, 4.31683008246501],
            [16.10324323419156, 4.313316674737368],
            [16.10159541661403, 4.30531859443624],
            [16.102207348416368, 4.301369195760895],
            [16.10041780243953, 4.295321000588209],
            [16.100497552740812, 4.29084341087558],
            [16.10799396233611, 4.28504826207651],
            [16.10789052782423, 4.281878318457131],
            [16.10481075538898, 4.272217029474749],
            [16.102168857440805, 4.261097250239276],
            [16.1008708955158, 4.25250358884011],
            [16.10020197343096, 4.2424035327207354],
            [16.096503904123814, 4.234112301106118],
            [16.090665943738983, 4.225150976496303],
            [16.088952780127894, 4.213929534459907],
            [16.07978802484164, 4.193807636258485],
            [16.075033465205596, 4.187833548129721],
            [16.065844479818352, 4.181300682158048],
            [16.06498730491629, 4.1754475886559606],
            [16.05510932258494, 4.16362079532562],
            [16.04902403865812, 4.161317515243713],
            [16.04337111037691, 4.15481189425455],
            [16.03996794331996, 4.137598571085249],
            [16.036396215649454, 4.137523740633962],
            [16.03484826507941, 4.133450046255748],
            [16.031881909326163, 4.135245695968097],
            [16.02977320894568, 4.131428938073111],
            [16.026279523824424, 4.130121992126852],
            [16.026651292206086, 4.126250663199317],
            [16.02203325146306, 4.1259589014820754],
            [16.01478535936274, 4.122238667455079],
            [16.01026562252672, 4.126079712238125],
            [16.00609391571191, 4.126421608460065],
            [15.981655580679018, 4.154815707100652],
            [15.966894790943098, 4.171617333291637],
            [15.907027129417974, 4.167747696589379],
            [15.905214047237099, 4.237694732170234],
            [15.904207815299516, 4.271941332740565],
            [15.829595587751433, 4.249200652050179],
            [15.823763046016385, 4.247690110530144],
            [15.739937512014778, 4.2223082599069475],
            [15.747789864197403, 4.2329245871061465],
            [15.749224202661955, 4.240903154047035],
            [15.74198197350121, 4.244290200844148],
            [15.74261695348466, 4.249769905172115],
            [15.744837434863038, 4.252867530699165],
            [15.747769863986152, 4.253015081435256],
            [15.751206884543032, 4.256203859864956],
            [15.752113345920584, 4.262034887990452],
            [15.749789833293073, 4.265905433101772],
            [15.751287078447026, 4.2725449504793245],
            [15.754316839435367, 4.276610949890091],
            [15.750582152050457, 4.282422674797929],
            [15.749928112790721, 4.286073056186312],
            [15.753615389888894, 4.287785506141203],
            [15.757331817926831, 4.299646716782359],
            [15.75448910849702, 4.304546859245127],
            [15.754109701171657, 4.308181448170275],
            [15.756437037693344, 4.310273809355378],
            [15.756347105271903, 4.315729412351835],
            [15.754851247906199, 4.320543398628582],
            [15.749487353304733, 4.322681348180869],
            [15.744755288537915, 4.327170944106377],
            [15.741453130566294, 4.326268153374768],
            [15.740693213516792, 4.321645711431765],
            [15.731082260140429, 4.319986653135345],
            [15.728570595322127, 4.32439072378943],
            [15.731613740073678, 4.328852801073789],
            [15.731766764004997, 4.333075737829661],
            [15.727890985380158, 4.335698053366485],
            [15.727473704521744, 4.3387598498689055],
            [15.723578650110268, 4.340252014127529],
            [15.720676208691565, 4.345166844719527],
            [15.71861774862221, 4.34578825519437],
            [15.71916380386945, 4.352948312519763],
            [15.721978689918048, 4.354515934167356],
            [15.724551214893875, 4.359101519716989],
            [15.727515169279895, 4.360077511250891],
            [15.732349640598711, 4.354855941065746],
            [15.738220080181412, 4.352497756322071],
            [15.74447145862231, 4.356511921476324],
            [15.746947997042264, 4.363308973351737],
            [15.749233171156934, 4.3633436805176835],
            [15.756329269565292, 4.3578884155978805],
            [15.76979714289391, 4.366090073482663],
            [15.778963828661734, 4.368013734776298],
            [15.781015371911796, 4.371199248497211],
            [15.779643370411808, 4.37801719451629],
            [15.78307840993684, 4.383067153979275],
            [15.784015600004706, 4.388598337366267],
            [15.780775964224263, 4.390734246396918],
            [15.780982056705893, 4.395990392332567],
            [15.786142248344834, 4.400536888099313],
            [15.78364197626492, 4.406209239071166],
            [15.780549254939716, 4.409530240427547],
            [15.7852627454995, 4.4197720350186644],
            [15.791548074918953, 4.420230581455914],
            [15.790860099810107, 4.424319131267277],
            [15.798211637005725, 4.426363876794043],
            [15.802103506021862, 4.426389121749725],
            [15.808929283537864, 4.43493026486982],
            [15.813590624966857, 4.4387409679259],
            [15.812891570976388, 4.442585072883094],
            [15.818162664697963, 4.444513818686669],
            [15.821302148400884, 4.449914628478948],
            [15.818120955999039, 4.453761736091891],
            [15.818454778853953, 4.460345479227525],
            [15.817582723360244, 4.465603419437132],
            [15.822586077366873, 4.469671101052404],
            [15.822968509774926, 4.473852800798497],
            [15.826867656797084, 4.4845971209018884],
            [15.851708171576833, 4.563584569401201],
            [15.870920431107065, 4.624464321184725]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.03381448179402,
          "lat": 41.331983371563716
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42103"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01213683"
      },
      "bbox": [
        15.71861774862221, 4.122238667455079, 16.199752837566507,
        4.624464321184725
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.455416328954259, -3.9510117528408033],
            [11.458089657067832, -3.9468315079953666],
            [11.499318975553722, -3.885890655588114],
            [11.509959437993121, -3.886278366226549],
            [11.516935759629735, -3.8834489358485804],
            [11.524441108269823, -3.882128621289811],
            [11.527349301716548, -3.8773395401664383],
            [11.533815799520879, -3.8749457373933334],
            [11.536166464532775, -3.8711955174884025],
            [11.543270000302961, -3.8755611760624467],
            [11.553500683917708, -3.8802934720753948],
            [11.556462032429277, -3.8837819334071675],
            [11.560337082406706, -3.8851032051019363],
            [11.564249664064176, -3.888376021108238],
            [11.626620919600716, -3.8824367606522356],
            [11.628697692718209, -3.8815637888568686],
            [11.666042046720598, -3.8698972098643596],
            [11.69349705709743, -3.951421512704452],
            [11.69653895561956, -3.959271105565715],
            [11.707292994151645, -3.949076360672414],
            [11.726820231891484, -3.923080665070053],
            [11.740529736702495, -3.906065311493194],
            [11.748360682251873, -3.91228007713534],
            [11.752643119621744, -3.9181807362358176],
            [11.754329497410504, -3.922320720513607],
            [11.762993683283872, -3.9300057036037996],
            [11.769347050653867, -3.9341836603868234],
            [11.781556008017187, -3.940002091856841],
            [11.795105164252874, -3.9423022195125355],
            [11.803181705164775, -3.943106256367555],
            [11.808889826497802, -3.9416429657147702],
            [11.819327350326535, -3.9284835952074166],
            [11.820477872245808, -3.926268021346673],
            [11.852802771335448, -3.925780565482435],
            [11.858473014260577, -3.922806037656596],
            [11.882646699796247, -3.9249988918522543],
            [11.88864679285703, -3.9224916777563945],
            [11.907188998568841, -3.916694639682551],
            [11.908553981707, -3.929916107574828],
            [11.909238883561246, -3.943407171336527],
            [11.910136602672882, -3.9469315389102957],
            [11.825215299817938, -3.984089418311289],
            [11.834999497677098, -4.009175265548722],
            [11.826908080523449, -4.015237170250411],
            [11.832975103363351, -4.030942120679965],
            [11.835555063239696, -4.034286022369279],
            [11.86321021957149, -4.066817557091516],
            [11.873854643650532, -4.077555297881848],
            [11.87206516875586, -4.079804525137886],
            [11.866181773805227, -4.080812935135573],
            [11.862119253203762, -4.090524739281462],
            [11.85538942814727, -4.09108857024099],
            [11.854483626241107, -4.093128522515659],
            [11.860138933875325, -4.09956927760095],
            [11.854849585446582, -4.104984312635624],
            [11.857554347185793, -4.108705065586249],
            [11.854318446235677, -4.115908903916708],
            [11.849399932271153, -4.117802970864377],
            [11.844894580832886, -4.124457712404582],
            [11.846628787871019, -4.130386100699845],
            [11.843210581992269, -4.131147147319505],
            [11.843509942323788, -4.134964069687945],
            [11.841673823351131, -4.140389967939627],
            [11.839359092226585, -4.141420941698211],
            [11.835164652501813, -4.148642258131358],
            [11.835951874443559, -4.152592801125826],
            [11.840668071246107, -4.156497020779009],
            [11.84260205468647, -4.159921392327808],
            [11.841325499664421, -4.164251703331919],
            [11.84532535958739, -4.169588432303442],
            [11.842591959729099, -4.172562959887025],
            [11.841297808520483, -4.178917160887557],
            [11.832666437017014, -4.184537807205741],
            [11.832918528024813, -4.191336833225835],
            [11.835523991549309, -4.194929074030723],
            [11.843950645588293, -4.210294299129512],
            [11.851799258822606, -4.222714567139105],
            [11.853302495205831, -4.223472434934472],
            [11.861736526108285, -4.220670271850451],
            [11.869095909834064, -4.224256042270692],
            [11.868156521541541, -4.234149834221082],
            [11.87328767127328, -4.235989379363836],
            [11.879762531997827, -4.235071359025674],
            [11.882912243008136, -4.242991410646286],
            [11.885722578953635, -4.244876914932198],
            [11.884109010383437, -4.24903817344883],
            [11.889159737153003, -4.2499139933033225],
            [11.892334565928662, -4.252257498567794],
            [11.902116476132168, -4.25068221239808],
            [11.90488503765509, -4.2578249069419085],
            [11.912539720323315, -4.263046862228653],
            [11.914459213210423, -4.267556616629906],
            [11.917484109900869, -4.270181110322633],
            [11.906760342793703, -4.309592630003332],
            [11.90286650771605, -4.311900362337357],
            [11.898990075941072, -4.316675094786019],
            [11.892752450988603, -4.317798401132288],
            [11.884553879407203, -4.315200091690112],
            [11.879131875266689, -4.312122596028243],
            [11.874213133553, -4.304491882351309],
            [11.869647678118772, -4.301717818339107],
            [11.854456745943386, -4.2998121874675865],
            [11.85112756153372, -4.298095868285918],
            [11.83530707378686, -4.28554815477694],
            [11.829164324126609, -4.269882837450066],
            [11.828093956111696, -4.254955125728131],
            [11.81885808501485, -4.248670075637977],
            [11.814953946990677, -4.241184184916308],
            [11.809147857756395, -4.232804621401606],
            [11.802650015699463, -4.228538051120431],
            [11.79410483567397, -4.220866693509726],
            [11.790852766778697, -4.213559778272603],
            [11.791082521938627, -4.206917794388826],
            [11.78705497793955, -4.196523548164017],
            [11.785953749890073, -4.190931680765223],
            [11.779047317274998, -4.179698591713277],
            [11.77595745737408, -4.170335616170916],
            [11.768265016518987, -4.164057292969334],
            [11.760933906683652, -4.162109584668507],
            [11.759717072769796, -4.159343068325661],
            [11.748464431302885, -4.154589794051276],
            [11.742255327020573, -4.148638206939411],
            [11.738114332077025, -4.146340848894882],
            [11.732910162712916, -4.146858172059372],
            [11.729246249668092, -4.144742049940351],
            [11.726931938687486, -4.130392777756133],
            [11.722898808259911, -4.1265866582985335],
            [11.715003676787214, -4.123777643385002],
            [11.712869402645797, -4.120069989557165],
            [11.705898508566378, -4.115325416049832],
            [11.703311712006961, -4.112393600912179],
            [11.691388307115187, -4.106884186223861],
            [11.683594809987358, -4.101234208436245],
            [11.679192511916817, -4.099522003437574],
            [11.663945504330691, -4.095456609753142],
            [11.659905069746571, -4.093561328807063],
            [11.653712537237661, -4.088010100674575],
            [11.648988809562084, -4.085307056722349],
            [11.639538250159662, -4.081935174866876],
            [11.633466267154645, -4.07715502468455],
            [11.628205124648915, -4.07622146942568],
            [11.618567728119135, -4.080214093623629],
            [11.611295189741927, -4.079131477285511],
            [11.600715144307241, -4.0712280093004605],
            [11.594163983487192, -4.0697096196672735],
            [11.587869344785252, -4.06644138132123],
            [11.583695750857391, -4.062230682119851],
            [11.574191041411241, -4.057040051927392],
            [11.564579503761442, -4.049217026885927],
            [11.553004807794544, -4.042893405370299],
            [11.549883071922737, -4.039577598404694],
            [11.54199272854644, -4.027922734176692],
            [11.532800426304142, -4.0181459935887665],
            [11.522462668999657, -4.013130331894102],
            [11.514599047681598, -4.013954200783522],
            [11.50763287569217, -4.017688114669464],
            [11.497957133826786, -4.016149757801942],
            [11.495833366195232, -4.014894177855669],
            [11.48808547623097, -4.005448933363308],
            [11.485442412964085, -3.9966567380066356],
            [11.482372558473669, -3.9918986528371727],
            [11.477711493640411, -3.9888412954242094],
            [11.471360694742625, -3.9810284372177107],
            [11.471323033354578, -3.9758287116195423],
            [11.473980911288468, -3.9727177139045433],
            [11.473249281839452, -3.969718890921176],
            [11.467104687876224, -3.9682785048111175],
            [11.462267455592574, -3.9644137973223397],
            [11.455416328954259, -3.9510117528408033]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.30990832402486,
          "lat": 33.899501440494255
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45065"],
        "coty_name": ["McCormick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCormick County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01248012"
      },
      "bbox": [
        11.455416328954259, -4.317798401132288, 11.917484109900869,
        -3.8698972098643596
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8780452928136764, 6.266307080470394],
            [-1.8030837327205234, 6.263679521683011],
            [-1.7239053989419946, 6.261065315948076],
            [-1.62014600247339, 6.257647149050309],
            [-1.543660905002708, 6.255359247295022],
            [-1.4572676789320578, 6.252737201037583],
            [-1.4493928724797396, 6.252459081965537],
            [-1.4520513349040625, 6.164039090782803],
            [-1.4545380889757125, 6.07747510301232],
            [-1.4571714516725818, 5.990863189615764],
            [-1.4596159984224977, 5.904288053002657],
            [-1.4565009273610414, 5.904208868430965],
            [-1.459904385707585, 5.785639867949752],
            [-1.4638871645993372, 5.6415465719081945],
            [-1.4660539205567469, 5.556605701007835],
            [-1.4658643569168588, 5.554531585188374],
            [-1.5425761084518523, 5.556681761463152],
            [-1.553330530403858, 5.5566822548313795],
            [-1.6269507748068848, 5.559126735910472],
            [-1.7053220294899374, 5.5615209505981555],
            [-1.740798676995204, 5.562922094045999],
            [-1.74233200633247, 5.562758876758815],
            [-1.7978863527097542, 5.564665253753045],
            [-1.8489267246686885, 5.566145015195032],
            [-1.8490917329450824, 5.564645997168896],
            [-1.8943078239126685, 5.566102333427169],
            [-1.8927167507649116, 5.619651559695859],
            [-1.8924506046088507, 5.62115567664827],
            [-1.890327710516587, 5.681602598571856],
            [-1.8894141588823006, 5.711021398459438],
            [-1.8867751258500352, 5.783156339061805],
            [-1.8855841309329509, 5.826548719756797],
            [-1.882257890599527, 5.917672511523006],
            [-1.8907718713859862, 5.918072003783115],
            [-1.8878111215586189, 6.004475421244016],
            [-1.8841803114469236, 6.091919713301213],
            [-1.8806594958001805, 6.191937412132558],
            [-1.8796774617610361, 6.223397421111322],
            [-1.8780452928136764, 6.266307080470394]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.00493337645891, "lat": 44.54778044480887 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46059"],
        "coty_name": ["Hand"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hand County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01265783"
      },
      "bbox": [
        -1.8943078239126685, 5.554531585188374, -1.4493928724797396,
        6.266307080470394
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2025805447885147, 5.547552525986597],
            [-1.1589801098455752, 5.546406630956209],
            [-1.115292858229125, 5.545421446047868],
            [-1.0640124187535844, 5.543565675392121],
            [-1.0112167131673386, 5.542144185287275],
            [-0.9442307880885231, 5.53969522668667],
            [-0.8609132379824084, 5.538611028324979],
            [-0.8579350598778144, 5.538555270456493],
            [-0.8599418806639691, 5.468742128514272],
            [-0.8604097616198058, 5.4665154147513295],
            [-0.8609203184776137, 5.432737465053417],
            [-0.8620841387002646, 5.375039171957819],
            [-0.8640503896443495, 5.2804228614026565],
            [-0.8658417034958377, 5.193540317262847],
            [-0.9492526781599879, 5.196038221207237],
            [-1.0426704797027546, 5.198415901090338],
            [-1.107462892535842, 5.199868699642663],
            [-1.1245998151486667, 5.2004117422285825],
            [-1.1964310791499095, 5.202112192983285],
            [-1.206302135525127, 5.202192010289855],
            [-1.2107861089576177, 5.2022314182815395],
            [-1.2086679892667611, 5.288897252017768],
            [-1.208373434811684, 5.296075610117093],
            [-1.2063946967098604, 5.390422357951287],
            [-1.203269938590542, 5.520954201775566],
            [-1.2025805447885147, 5.547552525986597]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.09134167837801,
          "lat": 44.023414989992695
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46111"],
        "coty_name": ["Sanborn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sanborn County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01266977"
      },
      "bbox": [
        -1.2107861089576177, 5.193540317262847, -0.8579350598778144,
        5.547552525986597
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.686431388101703, -2.0006915991929404],
            [9.692788263875153, -1.9979839643725161],
            [9.69787573856796, -1.9980733117472873],
            [9.699608154513268, -1.9937963125606026],
            [9.706283955993522, -1.9936907479652062],
            [9.71103713526696, -1.9871125330027184],
            [9.714736806972088, -1.9857445685167772],
            [9.716504758883906, -1.9817675152497756],
            [9.713782309144701, -1.9746820342979123],
            [9.717876014623272, -1.9706230549220345],
            [9.722228449680104, -1.9627715416893468],
            [9.72031934396523, -1.9577206914168739],
            [9.721159669776448, -1.9553816112241755],
            [9.72690014594305, -1.9516280060059996],
            [9.732186645149127, -1.9454903156013748],
            [9.734092565943566, -1.9406823601978491],
            [9.740174911406285, -1.9443052764843907],
            [9.746312016095256, -1.9418225290306774],
            [9.754928212604566, -1.9398471033578488],
            [9.765675626275415, -1.9434016702564239],
            [9.768487067545449, -1.9452911777184536],
            [9.775830768828474, -1.942094022218354],
            [9.773915567680186, -1.9390309471876574],
            [9.784156701908278, -1.9352251631760102],
            [9.790134229443042, -1.9295055250793591],
            [9.79388955980582, -1.9305658806319568],
            [9.79909041624897, -1.9341917728499678],
            [9.804488903278855, -1.941350684262029],
            [9.813844027696081, -1.9459860124414894],
            [9.817024868501134, -1.951487580842013],
            [9.820008353211664, -1.9534556883750864],
            [9.823798978561557, -1.9586780995905402],
            [9.82792690714382, -1.9562345619015724],
            [9.832568626975604, -1.9592162686979253],
            [9.834378057026859, -1.9627527751109048],
            [9.843212472346464, -1.967042950335821],
            [9.85138086296985, -1.9614528224688803],
            [9.851989642638069, -1.955989296499778],
            [9.849219394516732, -1.9518610165199646],
            [9.850044563206064, -1.9474887635811908],
            [9.849412292604587, -1.9417719015013797],
            [9.845007265241374, -1.9355087009646652],
            [9.845582948301935, -1.9291342544042158],
            [9.850263745706474, -1.9266203761583127],
            [9.850432306802645, -1.9234479196582248],
            [9.846749584287263, -1.9178065124784722],
            [9.847266745406287, -1.910320874625784],
            [9.845434439477952, -1.9007892625562384],
            [9.845769452574528, -1.898307660877935],
            [9.881783697260163, -1.8991053827070554],
            [9.891314754403615, -1.8974058994297351],
            [9.899227208615853, -1.899120589639791],
            [9.907920358195705, -1.898174557028075],
            [9.914816044184267, -1.899853375869467],
            [9.925365331443466, -1.8986655431714365],
            [9.930666566582097, -1.899083988011879],
            [9.939997226517503, -1.897708508562734],
            [9.944901891055885, -1.8989221365720088],
            [9.94731742832848, -1.9064008679263105],
            [9.955458563625244, -1.9074345462178146],
            [9.95556313894868, -1.9004278175597034],
            [9.960046585511392, -1.899285730240158],
            [9.96742215033595, -1.9005609148739815],
            [9.97255187280529, -1.8971687155021553],
            [9.97270246711284, -1.8938958325295423],
            [9.970496891079334, -1.8891914495978452],
            [9.966340624614125, -1.8862581946203516],
            [9.965503519032596, -1.8802626399281266],
            [9.969166263965185, -1.8755381817899721],
            [9.975843548908875, -1.8798737120208702],
            [9.980144147896942, -1.8756701390860515],
            [9.978509934831198, -1.8703853012018046],
            [9.979834161662657, -1.8623880627889213],
            [9.986967754230475, -1.853860088375142],
            [9.989459507703017, -1.8493757392080274],
            [9.988059437425848, -1.8421291439197136],
            [9.99244561582952, -1.8360830143097815],
            [9.993770147046835, -1.8300171267049317],
            [9.989454677481906, -1.8251731160841753],
            [9.990601638680372, -1.8227907397851901],
            [9.994916719639017, -1.822548890341285],
            [9.998500418506465, -1.8260615070793802],
            [10.001180038425124, -1.8389438575983585],
            [10.001234279300968, -1.843818381971305],
            [10.00560852809214, -1.8503832114626002],
            [10.008217141893764, -1.8512731657854788],
            [10.01402099768719, -1.8494191009782524],
            [10.019479209290186, -1.8505576259669143],
            [10.015180540138921, -1.8511718155006438],
            [10.01797880537595, -1.855222556181001],
            [10.02795262829958, -1.866878968824723],
            [10.027229223591425, -1.8704274283054596],
            [10.037064892257696, -1.8831905536569549],
            [10.046269976217717, -1.8910628606513264],
            [10.055032190270582, -1.9073377919246055],
            [10.062950273487614, -1.9149022645477523],
            [10.075380905836804, -1.9238294561853122],
            [10.079812283066126, -1.928311863815187],
            [10.077668972695973, -1.928584053810284],
            [10.075706011775909, -1.9334105409694569],
            [10.072240491126662, -1.9340554291089347],
            [10.06863858046567, -1.9386835920993009],
            [10.064425619519898, -1.9410503315234104],
            [10.060397811422307, -1.9461389267870342],
            [10.059850619145442, -1.9500727919531138],
            [10.054721823659216, -1.9503181400142167],
            [10.055955142283564, -1.954940789942303],
            [10.053007493796562, -1.9577559749965145],
            [10.047324788795805, -1.965697698230172],
            [10.043884522533803, -1.9689318725038707],
            [10.03913114326838, -1.9761537443629429],
            [10.040271131156079, -1.9797317696294858],
            [10.032478773140074, -1.9872123665746615],
            [10.027902715074262, -1.9867703627236666],
            [10.027733732219325, -1.9937050190527155],
            [10.024599563214869, -1.9937969474387431],
            [10.019958985363287, -1.999492784014901],
            [10.018866159569969, -2.007134862883778],
            [10.013762725991882, -2.0126395308323928],
            [10.01065788741031, -2.0139115891499024],
            [10.007440109739072, -2.0214272996713993],
            [10.003106551075797, -2.0248795323705995],
            [9.994884702162068, -2.033343432918835],
            [9.989148727280625, -2.044655604570174],
            [9.984972418704443, -2.047547792485243],
            [9.980485546461113, -2.053669045174834],
            [9.97703992191758, -2.052573915697311],
            [9.973811849374039, -2.0611783374788746],
            [9.982605192979717, -2.068870125516299],
            [10.006084031027099, -2.0902600007784673],
            [10.00300322505655, -2.093999591311229],
            [9.998519219509287, -2.09679872014387],
            [9.997553376993757, -2.1014942172282978],
            [9.993393560645757, -2.1048894660068216],
            [9.987487169119484, -2.1125249615308404],
            [9.981066885008607, -2.115355170448088],
            [9.97509781243865, -2.119166933167256],
            [9.973590602499605, -2.1231776191626897],
            [9.966182988898954, -2.132662597699109],
            [9.9618171597088, -2.131763414715979],
            [9.954935440579979, -2.1369696213580673],
            [9.95412932633626, -2.13960788602529],
            [9.948400935249843, -2.1410418815351315],
            [9.948033310916967, -2.144600863597644],
            [9.943234324542951, -2.145254150048576],
            [9.939277894876312, -2.148592756938464],
            [9.932793464277422, -2.145244314545018],
            [9.929887617782079, -2.1469943552645003],
            [9.911367798954446, -2.146228482516877],
            [9.904901242488778, -2.1444489869854406],
            [9.902813921762132, -2.14997938659824],
            [9.90475755530402, -2.1565344278163368],
            [9.901931754719518, -2.1634089512506454],
            [9.890562038478643, -2.166273360854107],
            [9.888998121398826, -2.16897239472761],
            [9.889235693343688, -2.1758538267596745],
            [9.886772408946943, -2.1821283241661624],
            [9.892400587489533, -2.188061977704095],
            [9.89350068965531, -2.19428296104204],
            [9.887968936405677, -2.197107995831316],
            [9.882633304786287, -2.1951967047759844],
            [9.877847899693949, -2.1914310489082296],
            [9.871340757219786, -2.1890559598141994],
            [9.868794290545244, -2.1901040787326416],
            [9.86787623514346, -2.194769970763321],
            [9.872940303658641, -2.196667209616789],
            [9.875060573682589, -2.200024633830653],
            [9.874363104298443, -2.2036367313190253],
            [9.878220078211298, -2.2126237035935845],
            [9.873868502939338, -2.215701100463774],
            [9.868520502368023, -2.212544403169323],
            [9.862449774860792, -2.206190582324959],
            [9.853722116748967, -2.2035123339261786],
            [9.848467064657195, -2.2055956854089884],
            [9.848085277752721, -2.211266702709101],
            [9.856023098718513, -2.2157965710629135],
            [9.862276973820741, -2.217977892758957],
            [9.866207751609888, -2.225591268794551],
            [9.864601553783517, -2.230168458319091],
            [9.854892343363058, -2.233607423007248],
            [9.85241738157134, -2.23768829180254],
            [9.839569157577419, -2.2197193929649965],
            [9.803624528685415, -2.160703248424423],
            [9.779343429396965, -2.105655439502446],
            [9.761397001731586, -2.0865233336700726],
            [9.744040690733863, -2.062843619225849],
            [9.737332761821353, -2.060110217017924],
            [9.732129431629998, -2.059122601014674],
            [9.729021406731405, -2.054829047090578],
            [9.721578249281324, -2.057265681812338],
            [9.712737452271634, -2.0535720846367753],
            [9.709547172995737, -2.05386090049183],
            [9.707668009126191, -2.0470789409678254],
            [9.703447419771102, -2.037635252662208],
            [9.699038783041349, -2.031265045084073],
            [9.688986509606961, -2.0288350079599615],
            [9.686792506540595, -2.0260542969762487],
            [9.68300451936354, -2.025398914538688],
            [9.680928495533253, -2.0139973265541955],
            [9.68444290282605, -2.0127228052828605],
            [9.687508589620451, -2.0081818517402903],
            [9.68565044841323, -2.0035308452369653],
            [9.686431388101703, -2.0006915991929404]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.19848095028631, "lat": 36.11844381092833 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47001"],
        "coty_name": ["Anderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anderson County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01639722"
      },
      "bbox": [
        9.680928495533253, -2.23768829180254, 10.079812283066126,
        -1.822548890341285
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.588298617109974, -2.9492250939381495],
            [9.594835907572397, -2.9427330338097675],
            [9.602237265922067, -2.9419395748667383],
            [9.60136331255554, -2.9349284860358056],
            [9.608516014693977, -2.9339570432153095],
            [9.612744572783704, -2.921446059393171],
            [9.614459030266062, -2.9186748542351015],
            [9.648472586379382, -2.914800306739698],
            [9.735907957664857, -2.905670051297971],
            [9.737603019879353, -2.9015064495174605],
            [9.7434738554878, -2.8948062246358797],
            [9.750145757739856, -2.8846587746900267],
            [9.814626058840188, -2.9056750754379683],
            [9.86785637623381, -2.9228442522986278],
            [9.865504302905682, -2.9302386327840333],
            [9.879222452319148, -2.9349459701344753],
            [9.874969412438261, -2.94876603907627],
            [9.881610211994452, -2.950993913450027],
            [9.88393161879184, -2.944007997061591],
            [9.890665263835201, -2.9463261849839575],
            [9.89469799303031, -2.934053593581988],
            [9.923117922349025, -2.9434238755383277],
            [9.923776430695854, -2.967954702063638],
            [9.923405570556843, -2.983199523891536],
            [9.923600023596203, -3.0296264094813514],
            [9.924703364991016, -3.0729462816601214],
            [9.926347655403003, -3.164552685089192],
            [9.86751110131576, -3.172168113691386],
            [9.774797855427016, -3.183491229025209],
            [9.684760971513402, -3.1940353546854263],
            [9.682020761152119, -3.1947204201042183],
            [9.599341247718197, -3.2045599938219835],
            [9.560310753532915, -3.209417135717603],
            [9.561616136363899, -3.1968117139827115],
            [9.568917291325782, -3.1702785328634384],
            [9.573136482389868, -3.1391118624978995],
            [9.573840514957878, -3.1358345773706824],
            [9.58186343718661, -3.111986158471023],
            [9.571545218241631, -3.108484965486859],
            [9.585781918531772, -3.063716972286011],
            [9.59963269172549, -3.0189593412741877],
            [9.599354219698709, -3.0159491788471215],
            [9.595246196081607, -3.00548288176632],
            [9.597153513665049, -2.9975452899342803],
            [9.597711952975253, -2.989262201119246],
            [9.593376953974333, -2.97715060887714],
            [9.59210781044429, -2.97106057866896],
            [9.595097150966593, -2.961244288396149],
            [9.582069858357439, -2.962069248415017],
            [9.579361108468321, -2.9577575463473553],
            [9.58134077125778, -2.9549021172320535],
            [9.587402783606862, -2.952296496918912],
            [9.588298617109974, -2.9492250939381495]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.5233387542272, "lat": 35.119890286243375 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47139"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01639782"
      },
      "bbox": [
        9.560310753532915, -3.209417135717603, 9.926347655403003,
        -2.8846587746900267
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.910391280923906, -1.6066966456633158],
            [2.953258691375481, -1.6071943766626846],
            [3.0314021025768594, -1.6053306282874933],
            [3.0822180384934046, -1.6045373194907795],
            [3.124389810786925, -1.6035629352618774],
            [3.1933583189854664, -1.6035316822112646],
            [3.2476661206477586, -1.6027004170860244],
            [3.296814866040692, -1.6012742497712762],
            [3.382886325430317, -1.5993086953485778],
            [3.3966847830954228, -1.5997356195325345],
            [3.4256472179357838, -1.5992482375110564],
            [3.4265901075041025, -1.5991100275599717],
            [3.5112543808221255, -1.5984044076747608],
            [3.554232766701242, -1.5975053614912187],
            [3.5556218817095595, -1.6542126481701875],
            [3.555484840556328, -1.6581517233206926],
            [3.5571507879832875, -1.7364281070616985],
            [3.5574781898089003, -1.7601579185415737],
            [3.558203552827254, -1.7854939933984382],
            [3.5585898993769347, -1.818214378613535],
            [3.5593612798788707, -1.862170911944049],
            [3.546383908527352, -1.8624806832805427],
            [3.473437726730816, -1.8635214860349525],
            [3.3442431152820205, -1.865333643237521],
            [3.2523517462293254, -1.867081185856637],
            [3.200707969892473, -1.8674960508381466],
            [3.1733049334467505, -1.867981346437954],
            [3.043148144810948, -1.8697947673914839],
            [3.0287900737069964, -1.869892021940513],
            [2.9569710527755895, -1.870428100850184],
            [2.9141861861447116, -1.8705944799555925],
            [2.913331876653248, -1.8116077169052895],
            [2.9127031177959397, -1.7385378049929294],
            [2.911773893642668, -1.6796801492107527],
            [2.91104698407946, -1.6214220906750063],
            [2.910391280923906, -1.6066966456633158]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.49880316301487, "lat": 36.93258146268102 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29067"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00758488"
      },
      "bbox": [
        2.910391280923906, -1.8705944799555925, 3.5593612798788707,
        -1.5975053614912187
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4669220397080376, 1.305871230413405],
            [2.4660282298372374, 1.3434158505988396],
            [2.465092385276453, 1.3719191951304102],
            [2.548482494090543, 1.376110755411981],
            [2.657223446413208, 1.3814463446619616],
            [2.706165181960211, 1.382964077462148],
            [2.7334052055451026, 1.3832159292627435],
            [2.770232798289926, 1.3843574692718794],
            [2.8485191772798837, 1.3877756938173897],
            [2.8551252732738672, 1.3880429764550277],
            [2.85607202138267, 1.2913611971774783],
            [2.856078074073873, 1.2248884657848949],
            [2.856876558372512, 1.1366731176056581],
            [2.858105103922259, 1.0772777697612081],
            [2.858458876464467, 1.0476132096208937],
            [2.791591862053376, 1.0474019852426388],
            [2.7722080415659023, 1.047196515221264],
            [2.706940862645662, 1.0487570908147537],
            [2.686916220665056, 1.0489331899388994],
            [2.646948296507417, 1.0456950272590062],
            [2.629485610647944, 1.0448961129787928],
            [2.6146672173367618, 1.0446937910616252],
            [2.601299334325644, 1.04387095700773],
            [2.546693777634085, 1.0415873789218595],
            [2.514317423296128, 1.0405363115816335],
            [2.4721386947910102, 1.0397249730410008],
            [2.4713668670587654, 1.0817275565531963],
            [2.4683657427541994, 1.217589582016593],
            [2.4697785069731344, 1.2176641188796689],
            [2.467375394434064, 1.3059060197750505],
            [2.4669220397080376, 1.305871230413405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.10718611848912, "lat": 39.87019654453769 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29115"],
        "coty_name": ["Linn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Linn County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00758512"
      },
      "bbox": [
        2.465092385276453, 1.0397249730410008, 2.858458876464467,
        1.3880429764550277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.419814435548109, -0.35404139168331433],
            [3.553738331300219, -0.3521250251473702],
            [3.571301786266035, -0.351795984850388],
            [3.593141609272484, -0.34953105646678573],
            [3.661962683899092, -0.3463101186633713],
            [3.6780026537284076, -0.34186142184022084],
            [3.746226888956708, -0.3404413587036236],
            [3.7602282077312146, -0.34178630707490104],
            [3.760374850273498, -0.3431706133444821],
            [3.786278596041284, -0.34153996701512845],
            [3.80159372780408, -0.3412067155059289],
            [3.847807648242572, -0.33942552844489365],
            [3.850628226320177, -0.40074684823402196],
            [3.853917017744096, -0.47543928738132246],
            [3.865078601018698, -0.4750883905111885],
            [3.8675948666048674, -0.5513726559461821],
            [3.8683764697124534, -0.578617345417568],
            [3.825394261776262, -0.5793268893555762],
            [3.774079472468287, -0.5805765533666458],
            [3.757667608534993, -0.5821716813668059],
            [3.7361534617107184, -0.58360371589744],
            [3.684755798260653, -0.586566869116322],
            [3.663714650397999, -0.5874942958739905],
            [3.6624483149768685, -0.5909197389073381],
            [3.659240371307759, -0.591538323789132],
            [3.6494612914548172, -0.5964138334335696],
            [3.6413532715887507, -0.6046031709300396],
            [3.633339613424943, -0.6093470975701695],
            [3.6277301580157593, -0.5987502916653827],
            [3.6220791053521064, -0.598708503778304],
            [3.6185569371141173, -0.6005939714840332],
            [3.6151395871562038, -0.6046164424169589],
            [3.611929077357738, -0.6184739687980549],
            [3.611767062817695, -0.6259063064629382],
            [3.6100218307734906, -0.63175443238412],
            [3.5956169706594783, -0.6324263553927109],
            [3.5672373357207507, -0.6325926382690762],
            [3.5248916004245947, -0.6339499255331715],
            [3.5248844015470233, -0.6336055993679516],
            [3.4721977017113357, -0.6333309763170069],
            [3.462597395235633, -0.6328308254551129],
            [3.4390451559418223, -0.6333043192936426],
            [3.4389965330139143, -0.6320935771707851],
            [3.4391184533784274, -0.6282666703429919],
            [3.436235781934804, -0.485770008855923],
            [3.4234636284799618, -0.48597913958525646],
            [3.4210003809058156, -0.3988704951805437],
            [3.419814435548109, -0.35404139168331433]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.9248569388069, "lat": 38.16164324575124 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29125"],
        "coty_name": ["Maries"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Maries County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00758516"
      },
      "bbox": [
        3.419814435548109, -0.6339499255331715, 3.8683764697124534,
        -0.33942552844489365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.050644385620672, -0.9288958161567302],
            [5.0771499245210405, -0.8971892644582741],
            [5.118386134890398, -0.8155431679366303],
            [5.118954624335614, -0.8149500952921214],
            [5.147487937119171, -0.7547114005241912],
            [5.154115650598261, -0.740429788593047],
            [5.198579164441769, -0.6842170871381565],
            [5.198858808188511, -0.6833677521155123],
            [5.210850809475399, -0.6870922003665462],
            [5.218615630086191, -0.6876378849664174],
            [5.227563611434057, -0.6868804196099805],
            [5.2428097133731475, -0.6760145774028565],
            [5.246376147777582, -0.6720376920657836],
            [5.256131703703946, -0.6576341520939777],
            [5.26495034056135, -0.6499054145133115],
            [5.269728944994267, -0.6479847712246555],
            [5.276628113081693, -0.6513518721156978],
            [5.2951812343237785, -0.6644044774559316],
            [5.307882393049528, -0.6717265119523758],
            [5.308524609669758, -0.6772024969120787],
            [5.306799706138197, -0.6829586031047302],
            [5.310733690693037, -0.6919301542568952],
            [5.318828027845187, -0.6992642300560572],
            [5.321987926169082, -0.695659283951098],
            [5.328214399256043, -0.6982555163333493],
            [5.335324620196923, -0.6981338639279783],
            [5.344358932209492, -0.7030285986685899],
            [5.3554251227746175, -0.7017207158403832],
            [5.364365463147425, -0.713121113735408],
            [5.374312134916952, -0.7219321843688281],
            [5.386331101701604, -0.7301542734631411],
            [5.402542924201613, -0.7382079564932871],
            [5.409448395969543, -0.7425890379278478],
            [5.413380970920176, -0.7454470811345032],
            [5.421530794260942, -0.7586924111501353],
            [5.421609234003092, -0.769377774851472],
            [5.417388481635456, -0.786102127266558],
            [5.419796911666993, -0.7934188848276716],
            [5.425631889734995, -0.7974667453816218],
            [5.432753936185155, -0.7992290463542367],
            [5.44536046255671, -0.7980970687261462],
            [5.45243717172182, -0.7942439626431277],
            [5.457666009724119, -0.7932853048472619],
            [5.459487417189908, -0.8006212844441181],
            [5.465003897166478, -0.8029480147066725],
            [5.474991306237651, -0.8091544829408184],
            [5.48334659479893, -0.8241511318803398],
            [5.486681795629054, -0.8282257821478001],
            [5.4946277765234095, -0.8319346016984545],
            [5.5000804494767905, -0.8334637574222945],
            [5.522428186932144, -0.8381544843382531],
            [5.528125463758552, -0.8384950696454982],
            [5.532708984729085, -0.8400983545206593],
            [5.540170591241429, -0.8453364778107006],
            [5.544324693680973, -0.8523768976836246],
            [5.544613169868653, -0.8569519418732957],
            [5.54229821462962, -0.8702770225314799],
            [5.542583740144598, -0.8822867676991877],
            [5.5440652515689495, -0.8928464724485764],
            [5.542910304420612, -0.8973156193116805],
            [5.544857388004585, -0.9020110701660083],
            [5.549188705689756, -0.9064625264179049],
            [5.552751687198615, -0.9130045932415143],
            [5.570242234006886, -0.9299146138296333],
            [5.5766023563155, -0.9378657388692875],
            [5.579055329977065, -0.9464443501206394],
            [5.578167556899011, -0.9508986939111114],
            [5.571849952027098, -0.9564252085246483],
            [5.565645824288284, -0.9575966363916922],
            [5.5532390774922495, -0.9543665979251241],
            [5.547737101012722, -0.9543813605646877],
            [5.5444096958665785, -0.9602080846777132],
            [5.544688089971918, -0.9670899233089623],
            [5.5449306768199955, -0.9730873178283598],
            [5.539145538443954, -0.9755267471806983],
            [5.535416628151272, -0.97307478601125],
            [5.534278453693381, -0.969152886532834],
            [5.527912837793615, -0.9734378817433355],
            [5.523774514357948, -0.9715171932809051],
            [5.523536850104078, -0.9674317386563808],
            [5.517863590204242, -0.9641932247698689],
            [5.509934518834791, -0.9678976908329096],
            [5.501066867330376, -0.9697754232884368],
            [5.49781491170205, -0.9714293750677299],
            [5.495955032897684, -0.9691122366057536],
            [5.49682380690493, -0.9654296349057047],
            [5.493444532835422, -0.9614391591429534],
            [5.488747291941348, -0.9678838733994409],
            [5.485510010461135, -0.9641617682513365],
            [5.48813883165179, -0.9613542673930375],
            [5.486800926984045, -0.9578480483433431],
            [5.4790788780443185, -0.9513974176587177],
            [5.478904358998308, -0.9401065549660343],
            [5.475485063710246, -0.9406739220897289],
            [5.47451809054144, -0.9462694114462833],
            [5.468901919501028, -0.9514865288682836],
            [5.462725281775926, -0.9508553320522253],
            [5.461932958250828, -0.9561878672957521],
            [5.456301226955813, -0.9542576341265807],
            [5.454602655607941, -0.9578010161018108],
            [5.450991066677467, -0.9582110935889575],
            [5.449314208511531, -0.953268835912046],
            [5.4519563195354905, -0.9475403032477444],
            [5.450621377252774, -0.941633025281465],
            [5.448653314454973, -0.9417750161753351],
            [5.444297291127499, -0.9480725304074805],
            [5.4397616453721875, -0.9470634837016128],
            [5.430557535767984, -0.9482430241320552],
            [5.4315674852853855, -0.9559258918938767],
            [5.426534331052069, -0.9622228478182979],
            [5.422618481870971, -0.955686859821147],
            [5.421530391047552, -0.9629388237454242],
            [5.418916911377, -0.9629630963538124],
            [5.414519970451922, -0.9594691603407596],
            [5.41591331356472, -0.9541246935278116],
            [5.411279197072571, -0.9515955414577698],
            [5.40719066542164, -0.9543140036734278],
            [5.400234406464521, -0.9526558297311785],
            [5.394383309222111, -0.9495972311265082],
            [5.390701797484605, -0.9543591138543936],
            [5.392266195963154, -0.9590295855709494],
            [5.387710446276, -0.9600981242759856],
            [5.386989234068816, -0.9552837702569658],
            [5.381718210531244, -0.9500254780918722],
            [5.375586975356314, -0.9486849348120212],
            [5.37208077122377, -0.9501720023587987],
            [5.3720042967043815, -0.9533512676661036],
            [5.375603455768494, -0.9580820746283977],
            [5.369500299508734, -0.958080874698014],
            [5.365663620818369, -0.9608147372041581],
            [5.362166074923566, -0.9593147345922842],
            [5.34273632121916, -0.9618405591443268],
            [5.339317273693745, -0.9609060545064236],
            [5.336524575046495, -0.9546213150946076],
            [5.333743871075135, -0.9561531077040732],
            [5.331682885435178, -0.9607430128085037],
            [5.32345216492509, -0.9600798447288975],
            [5.326698417829532, -0.9530461026545783],
            [5.326687470941064, -0.950051814780252],
            [5.311750093328808, -0.9545647114403742],
            [5.27695425198607, -0.9574282277797865],
            [5.175559162374498, -0.9649845436287177],
            [5.168132147117962, -0.9656809343904866],
            [5.096421298423961, -0.9699003088191778],
            [5.0703548053625385, -0.9722655388202648],
            [5.053402151164164, -0.9734219255845213],
            [5.051975647287997, -0.9572112084761548],
            [5.050644385620672, -0.9288958161567302]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.8243839308674, "lat": 37.70710605546132 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29157"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00758533"
      },
      "bbox": [
        5.050644385620672, -0.9755267471806983, 5.579055329977065,
        -0.6479847712246555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.270474107313827, -0.7974720863078549],
            [3.267789643251059, -0.6777101965444496],
            [3.2665994499449615, -0.6339235001419968],
            [3.287548267767976, -0.6340860541715105],
            [3.298066194785727, -0.6332792597581529],
            [3.3001298342356646, -0.6338571203128731],
            [3.352912820192156, -0.632872775178928],
            [3.3529263365305066, -0.6333795353229636],
            [3.409411603168181, -0.6326187699242198],
            [3.4389965330139143, -0.6320935771707851],
            [3.4390451559418223, -0.6333043192936426],
            [3.462597395235633, -0.6328308254551129],
            [3.4721977017113357, -0.6333309763170069],
            [3.5248844015470233, -0.6336055993679516],
            [3.5248916004245947, -0.6339499255331715],
            [3.5672373357207507, -0.6325926382690762],
            [3.568700503634216, -0.6679686945374101],
            [3.5701139371820614, -0.7160987920852457],
            [3.571713529836271, -0.7636859621967779],
            [3.5714011597334103, -0.7636990405830625],
            [3.572663070432725, -0.8089955892676975],
            [3.5748125803004944, -0.8956421064595537],
            [3.575639691581591, -0.9390551526944826],
            [3.5742879256696023, -0.939319851258804],
            [3.5781404568995656, -1.04455775352455],
            [3.534579228575072, -1.0452500697040388],
            [3.457306933376239, -1.0467806678770202],
            [3.409962367884819, -1.049519354464122],
            [3.4054380760387253, -1.049553597363281],
            [3.404100169940294, -1.005219917157752],
            [3.360067063558904, -0.9845371143990086],
            [3.2741798075660427, -0.9439845418833731],
            [3.2725376090825256, -0.9439263091714739],
            [3.271890075615208, -0.8894713532966658],
            [3.271299189379656, -0.8606449870961494],
            [3.270474107313827, -0.7974720863078549]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.20763553519589, "lat": 37.82458154487306 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29169"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00758539"
      },
      "bbox": [
        3.2665994499449615, -1.049553597363281, 3.5781404568995656,
        -0.6320935771707851
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8965572843508096, -1.5900324470216702],
            [3.892057765972731, -1.4526192645071392],
            [3.8905282156794434, -1.3887996475629043],
            [3.8935908122527914, -1.388676587425966],
            [3.8925883112682773, -1.374069922800473],
            [3.8918674123706603, -1.3486010646026456],
            [3.890408114048966, -1.3103335141494004],
            [3.8898226180814417, -1.3010348041141448],
            [3.886366133659458, -1.2127659239668396],
            [3.9467675526199106, -1.2113601300555241],
            [4.028583066230291, -1.209806162251745],
            [4.042143757779531, -1.2093254307229193],
            [4.058880133418887, -1.2093989635564195],
            [4.103240980873338, -1.2070754614044035],
            [4.1321199766443115, -1.2064509031840054],
            [4.228280108399992, -1.2038478257347256],
            [4.256943853073907, -1.2028745034370156],
            [4.258324415231995, -1.2328015933971113],
            [4.26075589740068, -1.2910931629020872],
            [4.261588532030849, -1.3059593514541887],
            [4.2755179484828645, -1.3049221372515623],
            [4.2777916209408, -1.3633103753890512],
            [4.306292511390012, -1.3623922739943888],
            [4.307027371066965, -1.3769737119171477],
            [4.305353050764059, -1.3770374182878546],
            [4.306876426730746, -1.4179796739664063],
            [4.321657570249973, -1.4175017865560247],
            [4.3215245512741856, -1.4134190350027767],
            [4.336436486625908, -1.4127040220044704],
            [4.337473053058756, -1.4419771702981874],
            [4.351662499433395, -1.437811608995278],
            [4.352115682950251, -1.4528092446793839],
            [4.380691837025915, -1.4446183904975527],
            [4.381605156941537, -1.474047213781932],
            [4.395602136058159, -1.4699817411501783],
            [4.395983484460073, -1.488589448282493],
            [4.397655724198083, -1.5181899395654666],
            [4.383340248200923, -1.5209538308154962],
            [4.359124107468867, -1.5221234052367032],
            [4.360440559471623, -1.5273916495860516],
            [4.354818212843884, -1.527222617001046],
            [4.340831717782873, -1.5302461844407473],
            [4.325636904482725, -1.531039065547599],
            [4.325702220561358, -1.5336736162959796],
            [4.240841551933781, -1.5358313460606563],
            [4.243245592867397, -1.6134542169473982],
            [4.2442083136761015, -1.6579440997959958],
            [4.246624171895078, -1.7400161340294198],
            [4.224959825791131, -1.7397958156431692],
            [4.130628445965512, -1.7439271551867306],
            [4.126037956616915, -1.744433653538496],
            [4.032625645588038, -1.748244563559414],
            [4.027056918978789, -1.7476628533788097],
            [3.9979786494063725, -1.7488989474284622],
            [3.9624297045151646, -1.7495278042638909],
            [3.9019668734285267, -1.7516380244053316],
            [3.9021592890393735, -1.750695765799255],
            [3.9000523686879527, -1.6790837171172315],
            [3.8965572843508096, -1.5900324470216702]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.40049037407145, "lat": 37.15739270269381 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29203"],
        "coty_name": ["Shannon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shannon County"],
        "coty_fp_code": "203",
        "coty_gnis_code": "00758554"
      },
      "bbox": [
        3.886366133659458, -1.7516380244053316, 4.397655724198083,
        -1.2028745034370156
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.4084833293922863, -1.1824007694073486],
            [3.4054380760387253, -1.049553597363281],
            [3.409962367884819, -1.049519354464122],
            [3.457306933376239, -1.0467806678770202],
            [3.534579228575072, -1.0452500697040388],
            [3.5781404568995656, -1.04455775352455],
            [3.5922915014127987, -1.0443691705737808],
            [3.6069285570627665, -1.0436541529535943],
            [3.651736199374294, -1.0435069299568944],
            [3.708874124492436, -1.0426866738297793],
            [3.7508694080884384, -1.0408559827976387],
            [3.7934436004370786, -1.0390616134515334],
            [3.797373336568491, -1.1271263939105556],
            [3.7985337738881286, -1.159788833241174],
            [3.801126196583849, -1.2152297926880178],
            [3.886366133659458, -1.2127659239668396],
            [3.8898226180814417, -1.3010348041141448],
            [3.890408114048966, -1.3103335141494004],
            [3.8918674123706603, -1.3486010646026456],
            [3.8925883112682773, -1.374069922800473],
            [3.8935908122527914, -1.388676587425966],
            [3.8905282156794434, -1.3887996475629043],
            [3.892057765972731, -1.4526192645071392],
            [3.8965572843508096, -1.5900324470216702],
            [3.8691439601512405, -1.591407165879546],
            [3.8290972511348427, -1.5921934653981726],
            [3.782930919580227, -1.5940354213163905],
            [3.7231874329708985, -1.5959687831013656],
            [3.6818021865703745, -1.595398037994676],
            [3.639469304499424, -1.5945627849982107],
            [3.554232766701242, -1.5975053614912187],
            [3.5112543808221255, -1.5984044076747608],
            [3.4265901075041025, -1.5991100275599717],
            [3.4256472179357838, -1.5992482375110564],
            [3.4245308587697956, -1.5264123315250713],
            [3.4234611962815946, -1.4983516801863146],
            [3.421084502178673, -1.4070610050957406],
            [3.421168657842262, -1.4021832694226322],
            [3.4165989636893928, -1.4024292709398898],
            [3.4154295164305957, -1.3579635980486056],
            [3.4139161002450757, -1.3137234692306632],
            [3.4126661068048985, -1.2843456840574947],
            [3.411461814849756, -1.2788152435072286],
            [3.4084833293922863, -1.1824007694073486]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.96505775614084,
          "lat": 37.317301684853824
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29215"],
        "coty_name": ["Texas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Texas County"],
        "coty_fp_code": "215",
        "coty_gnis_code": "00758560"
      },
      "bbox": [
        3.4054380760387253, -1.5992482375110564, 3.8965572843508096,
        -1.0390616134515334
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.4152996090774606, 8.847991890541524],
            [-6.32904405407935, 8.839028352415824],
            [-6.33824318492863, 8.752956203294286],
            [-6.2516304192171965, 8.74414978064773],
            [-6.242867306506392, 8.830223335558584],
            [-6.125972293218044, 8.818517343877742],
            [-6.039353941429149, 8.81006594052932],
            [-5.9527378797339745, 8.801590930539911],
            [-5.897360639641051, 8.796094819124747],
            [-5.9059090284935785, 8.709745735755542],
            [-5.917209290405548, 8.596091300650926],
            [-5.829881400213079, 8.587627374055538],
            [-5.8356465632183125, 8.530832867885193],
            [-5.748594788169785, 8.522514694925635],
            [-5.7499534758279305, 8.508896344508093],
            [-5.735783388246748, 8.507511002656384],
            [-5.7371315798660465, 8.493248406144772],
            [-5.722625125850708, 8.491779004487551],
            [-5.72536472798868, 8.46322240362347],
            [-5.70979898915237, 8.461676332424597],
            [-5.641274828374861, 8.455272280132839],
            [-5.572752048595172, 8.448853794395937],
            [-5.504230674895679, 8.442420876949125],
            [-5.435710732353531, 8.435973529554875],
            [-5.43806654741432, 8.407511736990145],
            [-5.4407418843392765, 8.407761911662133],
            [-5.453704428991274, 8.263483497732],
            [-5.456267174306611, 8.235040697325521],
            [-5.542669447220907, 8.243155786828789],
            [-5.546801699152261, 8.200375991494685],
            [-5.6330644239857595, 8.20816347237028],
            [-5.637102046522482, 8.165491038123792],
            [-5.723587215241925, 8.17381928058861],
            [-5.726297842472673, 8.145332113387338],
            [-5.814310487640682, 8.154046609369425],
            [-5.901030323219449, 8.162757736363456],
            [-5.898093504493646, 8.191301209769977],
            [-5.970170503593963, 8.198693558722809],
            [-6.042249215177711, 8.206070242541484],
            [-6.039519819216224, 8.234595394984394],
            [-6.068673597724832, 8.237553389073122],
            [-6.062964072643282, 8.294508708115991],
            [-6.120581018985852, 8.300134172255714],
            [-6.112086585369629, 8.38550734856501],
            [-6.140634153819014, 8.388280744209268],
            [-6.1318993387358764, 8.47378176730076],
            [-6.20518581189241, 8.481140097641475],
            [-6.278473937547895, 8.488481920896179],
            [-6.275535161463296, 8.516758777894273],
            [-6.362253978040511, 8.52552795917443],
            [-6.448975080938738, 8.53427397183163],
            [-6.4232161076817285, 8.772883110703992],
            [-6.4152996090774606, 8.847991890541524]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.37795628848308,
          "lat": 46.86050470867544
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30079"],
        "coty_name": ["Prairie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prairie County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01715847"
      },
      "bbox": [
        -6.448975080938738, 8.145332113387338, -5.435710732353531,
        8.847991890541524
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.082198539398677, 10.173663303331786],
            [-6.015541167159628, 10.166921126576373],
            [-5.948885376795262, 10.160163763038096],
            [-5.834221306445435, 10.148665345529373],
            [-5.818897847280832, 10.147262307766685],
            [-5.743631630038886, 10.139963853425247],
            [-5.668367349213283, 10.13264605820495],
            [-5.598716944207056, 10.126099666053799],
            [-5.5290681283762435, 10.119536722705918],
            [-5.442379202006688, 10.111497689043112],
            [-5.385409390727873, 10.106244663779272],
            [-5.393308578142637, 10.022247539425985],
            [-5.306680195425799, 10.014220869737901],
            [-5.3145096317682485, 9.929755524424351],
            [-5.231928055760896, 9.922402276661872],
            [-5.231478112165592, 9.922507449866544],
            [-5.150075822081753, 9.915374096920212],
            [-5.068675563132005, 9.908218380394336],
            [-4.99625415315458, 9.902004591283555],
            [-4.926467674971928, 9.896075836445027],
            [-4.927375147087052, 9.881325015571035],
            [-4.936984965080938, 9.767146073595049],
            [-4.938038133148849, 9.752196281475715],
            [-4.943367876358376, 9.688766662048272],
            [-4.948481399494417, 9.625405310270207],
            [-4.957541286682093, 9.513229177883794],
            [-4.966855816120323, 9.520325891584926],
            [-4.971758883091955, 9.521581240923771],
            [-4.9838099323180645, 9.51999513064352],
            [-4.985697561807996, 9.51911335538187],
            [-4.994054726374821, 9.520134894616639],
            [-4.995938709408256, 9.521774920119658],
            [-4.995236605389064, 9.527330559926252],
            [-4.997950665884511, 9.530553158318435],
            [-4.998118769187657, 9.533979242248424],
            [-4.994088226962296, 9.540326632725142],
            [-4.98921705533202, 9.545110331848358],
            [-4.987132204809993, 9.551109061632813],
            [-4.990878023048899, 9.553919209918636],
            [-4.993034786984946, 9.550164433107636],
            [-4.997019815959472, 9.549449211273739],
            [-5.003254325501641, 9.552288476776258],
            [-5.007431422921663, 9.558166652714949],
            [-5.010492000643773, 9.571676659291443],
            [-5.012234878966784, 9.575684511474142],
            [-5.018664846975188, 9.576180624820717],
            [-5.0236343014282845, 9.572621417255197],
            [-5.028350834750372, 9.566499228292125],
            [-5.036948770977193, 9.558590643645937],
            [-5.039316503772418, 9.558674045831465],
            [-5.046263399327309, 9.564879624667563],
            [-5.049958970547304, 9.572943358592756],
            [-5.048131674743455, 9.581059521940528],
            [-5.045179452949187, 9.586340766853866],
            [-5.045045373216528, 9.589286894201743],
            [-5.048832800820444, 9.59195649697443],
            [-5.058507494405394, 9.590384950737594],
            [-5.06084758267895, 9.587549526251262],
            [-5.06159170580846, 9.580244306452576],
            [-5.057770839425727, 9.573052679108457],
            [-5.057788645834579, 9.565418807062686],
            [-5.059286204605622, 9.56225768941666],
            [-5.064566776955007, 9.559476311479981],
            [-5.075547914099887, 9.556913705542481],
            [-5.085970440929677, 9.557230929036974],
            [-5.090217817157552, 9.558724835648336],
            [-5.107505584414474, 9.57026170294036],
            [-5.113455513614753, 9.576849297824797],
            [-5.118396205199832, 9.580701360230693],
            [-5.125909430608463, 9.581281944334398],
            [-5.139203535846091, 9.576815198151905],
            [-5.149837218568341, 9.578972105561931],
            [-5.154857973751955, 9.5787215950595],
            [-5.1607655117654385, 9.582167332673954],
            [-5.162041578167304, 9.594844795446848],
            [-5.16383141889247, 9.602077219214294],
            [-5.168188078551535, 9.607050925142026],
            [-5.173975699121391, 9.610822732684465],
            [-5.181602881455546, 9.610846870206998],
            [-5.1863806537854735, 9.612112723834253],
            [-5.200753810654276, 9.6206498288872],
            [-5.2099146732046835, 9.62818711425366],
            [-5.217142345029565, 9.632573734705097],
            [-5.221751726739567, 9.641252413631925],
            [-5.223571548713399, 9.651987442188375],
            [-5.226191329763867, 9.65748255372923],
            [-5.2317289143398495, 9.661265505829297],
            [-5.236920783892067, 9.662592220303097],
            [-5.244185723282876, 9.661295393913088],
            [-5.247261430500419, 9.659480109323516],
            [-5.254009202469991, 9.653031667246859],
            [-5.258742115357011, 9.650826555468653],
            [-5.261750939289977, 9.651092841255457],
            [-5.267208337127981, 9.66087679833369],
            [-5.271637040441909, 9.666066207590656],
            [-5.276883606355728, 9.668555817957415],
            [-5.282286380837813, 9.669259393559145],
            [-5.285000025843613, 9.667562867180116],
            [-5.292335145424689, 9.66584003743318],
            [-5.300256139515092, 9.659563454497663],
            [-5.310728438622785, 9.653251164408077],
            [-5.31663890299741, 9.655282467967599],
            [-5.315920332820297, 9.658808675538127],
            [-5.3110956815788954, 9.670317910664448],
            [-5.311385471564018, 9.673028225100092],
            [-5.315461772914168, 9.680276991127954],
            [-5.3235443516803596, 9.68825218092956],
            [-5.325777892813918, 9.680241419331182],
            [-5.332003393848554, 9.677155257538145],
            [-5.337129263821799, 9.677037050017146],
            [-5.338975140641115, 9.675148119885064],
            [-5.338324551476155, 9.671056063417282],
            [-5.334060966867913, 9.666806668929821],
            [-5.333798952721548, 9.663672661907029],
            [-5.338309143160494, 9.659943107016073],
            [-5.347230089024192, 9.659919820009764],
            [-5.352934415442288, 9.657515209685172],
            [-5.361319943345489, 9.657248402723532],
            [-5.368273458905117, 9.655045848643764],
            [-5.37634023924565, 9.65489055160447],
            [-5.377124751675792, 9.664754262630172],
            [-5.378669360944054, 9.667120386474105],
            [-5.385862772154002, 9.67095700049057],
            [-5.396841433271088, 9.672064978930587],
            [-5.403747231640836, 9.66730674704383],
            [-5.410250563546545, 9.667582171659348],
            [-5.415507851370942, 9.665575137835564],
            [-5.4198748106945995, 9.666810424801312],
            [-5.427297578378312, 9.682141491001921],
            [-5.4339612233590495, 9.686142307089826],
            [-5.446224236278669, 9.68571080286274],
            [-5.452892950508196, 9.683563305619321],
            [-5.461644306699587, 9.682150916093612],
            [-5.465377320977213, 9.679481369003454],
            [-5.469449316806929, 9.678697882636808],
            [-5.478357058069445, 9.680731898249592],
            [-5.48932387261985, 9.686485771238457],
            [-5.494950736125762, 9.692548822763449],
            [-5.50021227381116, 9.705949887656713],
            [-5.506504673332033, 9.711964965850465],
            [-5.513075481837481, 9.713729195042395],
            [-5.529176888486914, 9.708849996205256],
            [-5.535182417841345, 9.701690066946718],
            [-5.5394728287060016, 9.676853727653592],
            [-5.542566974224441, 9.67457143759255],
            [-5.549159184602383, 9.663395261023236],
            [-5.552014860441447, 9.661451181967495],
            [-5.555395106724049, 9.662355691680922],
            [-5.560107384123514, 9.667196147333906],
            [-5.5652523637457145, 9.668224377248055],
            [-5.5724788480414045, 9.672885916578512],
            [-5.579035820991083, 9.671807047954754],
            [-5.579303701002628, 9.669528184806538],
            [-5.574805098758234, 9.660034352889582],
            [-5.574745648212293, 9.654601867806543],
            [-5.58077329058314, 9.643595626863705],
            [-5.58685331352746, 9.638044222055068],
            [-5.592179435268846, 9.639171025062316],
            [-5.592436935871267, 9.643209950171096],
            [-5.588218836532993, 9.648389933119836],
            [-5.586959972061503, 9.652037310545655],
            [-5.588733695676607, 9.656111677636959],
            [-5.5957336105564615, 9.65744751627456],
            [-5.599343514072838, 9.653915708243888],
            [-5.602390263533339, 9.648051353688762],
            [-5.602350312598497, 9.642326370984387],
            [-5.606310813467892, 9.64015385548264],
            [-5.618506063954321, 9.638034535558246],
            [-5.621648266457692, 9.634692942204875],
            [-5.6237747357779835, 9.628856795727001],
            [-5.62905456088824, 9.631922721100437],
            [-5.629303470759642, 9.636831470251485],
            [-5.625496237776645, 9.645958307908513],
            [-5.626393978352693, 9.649773954610389],
            [-5.6306274740186115, 9.65317230004827],
            [-5.63554878406501, 9.653733431945126],
            [-5.640442124000573, 9.651061954780017],
            [-5.650479514476389, 9.641915876780304],
            [-5.658133972896676, 9.639070365087193],
            [-5.6713453987157925, 9.638707609819212],
            [-5.672805970824516, 9.642372546150169],
            [-5.668007901857859, 9.644341068290071],
            [-5.665483533049198, 9.647528855397072],
            [-5.665082661865543, 9.652633243732497],
            [-5.668173216427981, 9.657416429762334],
            [-5.673095265698239, 9.657844035262933],
            [-5.680918838270028, 9.654388238268703],
            [-5.688207062588436, 9.654025517096752],
            [-5.69400456939658, 9.655881280873036],
            [-5.697020092375395, 9.65867340366192],
            [-5.708177463168824, 9.6646351370848],
            [-5.709572269885229, 9.67127626384363],
            [-5.7056521939846885, 9.676921815074193],
            [-5.702636693727106, 9.678474068487983],
            [-5.705571747585919, 9.68384075254514],
            [-5.709067804257492, 9.685579392795127],
            [-5.713030162835676, 9.680646338982353],
            [-5.713884748020185, 9.66309843302773],
            [-5.718920260073388, 9.653568453577755],
            [-5.724000673761086, 9.651183871235737],
            [-5.730960937486219, 9.65139546684327],
            [-5.7351164194336235, 9.648941714472905],
            [-5.740280722249018, 9.650275565475019],
            [-5.7432779872505595, 9.657717367854485],
            [-5.738776891854951, 9.667179027508745],
            [-5.744769691726246, 9.675432865907105],
            [-5.753653297173101, 9.677727966064799],
            [-5.759244142098557, 9.67658184999684],
            [-5.767296811346298, 9.677381963504471],
            [-5.778703345054648, 9.673609750544054],
            [-5.784476626963558, 9.674147758042063],
            [-5.7954007455714285, 9.671426529838934],
            [-5.805160637035479, 9.671176894564224],
            [-5.810148964032972, 9.674833707693274],
            [-5.808995180655479, 9.680584385277333],
            [-5.813052851429018, 9.685319556130784],
            [-5.819377791750618, 9.68815224007327],
            [-5.8225599489450675, 9.688074708314808],
            [-5.832629534685612, 9.68411131055397],
            [-5.835707358488046, 9.68370703456974],
            [-5.8429160031865575, 9.686197141349723],
            [-5.8480358711135425, 9.689007505737608],
            [-5.857151886954084, 9.688829776815655],
            [-5.871848869133585, 9.691080662730045],
            [-5.877268033834205, 9.691195627983372],
            [-5.8802470557366116, 9.688977761083132],
            [-5.896249722236371, 9.690412703143984],
            [-5.9028997911603645, 9.695082095871143],
            [-5.906292569870331, 9.695737494382692],
            [-5.914420056475193, 9.693734085181248],
            [-5.920882705817607, 9.696190949679105],
            [-5.9243150390413035, 9.701389447677718],
            [-5.930640285746358, 9.701176206615932],
            [-5.93904206381168, 9.693374077706947],
            [-5.9409739435123745, 9.686487856662376],
            [-5.9438407979147225, 9.680159561309317],
            [-5.949464376698682, 9.674535651600749],
            [-5.955893689074724, 9.673613768071242],
            [-5.964931318506441, 9.681545052930815],
            [-5.969897913181098, 9.689724354730798],
            [-5.972964467734714, 9.692118841314686],
            [-5.984330434008813, 9.68959957751741],
            [-5.990938156965378, 9.692172481707063],
            [-5.999460816265324, 9.689565424783527],
            [-6.006854225787743, 9.685402270187568],
            [-6.01320202407706, 9.688551744383599],
            [-6.026861655717934, 9.6913727110724],
            [-6.0307474382301525, 9.68782569878371],
            [-6.028670526643128, 9.683813300119565],
            [-6.022439061813247, 9.679825059882011],
            [-6.022459556645829, 9.672991356552702],
            [-6.0264739021979095, 9.665587349087698],
            [-6.0323480941416285, 9.66165851987366],
            [-6.03898305233931, 9.661592376878257],
            [-6.0404522438549515, 9.664265300268283],
            [-6.041143306238516, 9.672908285174163],
            [-6.044313304202452, 9.67555675687518],
            [-6.050205218214946, 9.67582291848543],
            [-6.060502559652106, 9.671408188997113],
            [-6.0686720640415714, 9.664170979937813],
            [-6.072918101589456, 9.656932545853998],
            [-6.080301470393732, 9.652197804194811],
            [-6.092370708287881, 9.652125884874385],
            [-6.100928452002435, 9.647848217710138],
            [-6.1074735338231205, 9.650109866990233],
            [-6.110383109143195, 9.653951366733219],
            [-6.111070701299472, 9.660910218051686],
            [-6.110417155586526, 9.666276087504302],
            [-6.112171968820328, 9.670500132244564],
            [-6.116986671701836, 9.670866151080595],
            [-6.1201900697427, 9.66666016393642],
            [-6.1207011831768, 9.656857465626056],
            [-6.122079046297576, 9.651717315768298],
            [-6.125183134588841, 9.647524333824395],
            [-6.1341816038102355, 9.651370471484734],
            [-6.140121189458815, 9.651184510383887],
            [-6.150043215020996, 9.647879694737714],
            [-6.158627723826759, 9.64192982129286],
            [-6.16508904560855, 9.63954254954024],
            [-6.161435454586526, 9.675685380590677],
            [-6.158717889877642, 9.700061992368855],
            [-6.143650084239539, 9.842387150961896],
            [-6.117415414544294, 9.839708684922567],
            [-6.108603098490858, 9.923920505839218],
            [-6.0857166582481845, 10.14124883911263],
            [-6.082198539398677, 10.173663303331786]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.01637349459007,
          "lat": 48.29452025037563
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30085"],
        "coty_name": ["Roosevelt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roosevelt County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01669428"
      },
      "bbox": [
        -6.16508904560855, 9.513229177883794, -4.926467674971928,
        10.173663303331786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.595621306939211, 4.242705619602852],
            [-2.588205687603032, 4.233852484043165],
            [-2.570577670018766, 4.228897600901363],
            [-2.5690073645850178, 4.222880679934393],
            [-2.561703415010269, 4.227543309933066],
            [-2.5571793591556493, 4.2241974430370535],
            [-2.5572137996176667, 4.219306942416414],
            [-2.5500700145191857, 4.215731073835668],
            [-2.5537448700635124, 4.208015296129188],
            [-2.5512651560716906, 4.203083647222301],
            [-2.545570999912621, 4.200237885270287],
            [-2.53837070152624, 4.19929762220274],
            [-2.5356419341142096, 4.193478061731633],
            [-2.525405310819908, 4.190239082827455],
            [-2.514056529515666, 4.184917456835978],
            [-2.5034647364284153, 4.182777134047106],
            [-2.5003199841632795, 4.179727715948427],
            [-2.4944098325040183, 4.177405128085073],
            [-2.4846981325843833, 4.176560417927015],
            [-2.476485645032886, 4.178954721842679],
            [-2.469107288875132, 4.1764205568548585],
            [-2.4657873228570777, 4.178118094535228],
            [-2.4592080523802036, 4.179055962605826],
            [-2.4493906699190098, 4.174765459913659],
            [-2.443590863715813, 4.170680521092664],
            [-2.437895113779326, 4.1648320240920205],
            [-2.431491490732367, 4.1617360639267345],
            [-2.4279449094976586, 4.162383678485775],
            [-2.423351124836216, 4.161091035380881],
            [-2.415734317329514, 4.161603389925456],
            [-2.4034679071307457, 4.156708813456713],
            [-2.3957388623388844, 4.154987446220304],
            [-2.3900082611634907, 4.155944815372152],
            [-2.3801498157907224, 4.152574257428978],
            [-2.3719871743498797, 4.154724987829191],
            [-2.3664317416948855, 4.155179308185931],
            [-2.362657827049084, 4.154023530302826],
            [-2.3538448603707045, 4.15505737026433],
            [-2.351530101808621, 4.150564291705387],
            [-2.3512446239033586, 4.144732495757504],
            [-2.3493158229909032, 4.138657328624036],
            [-2.3468156221807814, 4.136906261612278],
            [-2.3362940882237573, 4.13939173253947],
            [-2.3246919296938193, 4.12962533580901],
            [-2.323597902321448, 4.128020901199399],
            [-2.3103475724303726, 4.123548248388376],
            [-2.3049061663364583, 4.122317038727833],
            [-2.302394246464294, 4.123193137682805],
            [-2.291714392478429, 4.118450820308551],
            [-2.289231498149298, 4.119590654901964],
            [-2.2751237538659392, 4.12041015744545],
            [-2.266372385056598, 4.115871312946233],
            [-2.257776430801893, 4.114096229410698],
            [-2.245412890091473, 4.108676596295918],
            [-2.2353394826594863, 4.11089274699716],
            [-2.2300927572233227, 4.111237549333285],
            [-2.226618896205496, 4.109212107196791],
            [-2.22081315853741, 4.111533345786742],
            [-2.223781625791094, 4.0245880035408],
            [-2.2256442150991784, 3.9752657269928044],
            [-2.225540205166419, 3.9717004291084654],
            [-2.227416602270821, 3.9155150511705057],
            [-2.2310396452585577, 3.8141055874025374],
            [-2.222244060857696, 3.813535394017521],
            [-2.222964404513336, 3.7907785021696143],
            [-2.225064632088222, 3.7404297928480736],
            [-2.2283879583731445, 3.6387567050704197],
            [-2.231495614271596, 3.551363363025003],
            [-2.234653170383463, 3.4638935202712293],
            [-2.252751762256486, 3.4646587267939797],
            [-2.2907229365058477, 3.466181301501102],
            [-2.299495775417107, 3.4658886993566864],
            [-2.4635577514616913, 3.4723642062766644],
            [-2.501183277292419, 3.47423901166824],
            [-2.6066800895828917, 3.479036455527443],
            [-2.6032636287381976, 3.5590159564448323],
            [-2.591298843095777, 3.827771098476417],
            [-2.6027380899121004, 3.8284899671109525],
            [-2.599536676493724, 3.900932287613967],
            [-2.598157642646116, 3.9297804997323698],
            [-2.5946396901379183, 4.011956941775413],
            [-2.587427833940686, 4.176977015466491],
            [-2.5985829413809634, 4.177483976832275],
            [-2.595621306939211, 4.242705619602852]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.9294996373809, "lat": 42.4300087227783 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31017"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00835830"
      },
      "bbox": [
        -2.6066800895828917, 3.4638935202712293, -2.22081315853741,
        4.242705619602852
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9268810567020798, 2.016868735471779],
            [-1.9203730079462682, 2.0145817880274963],
            [-1.911580977480599, 2.015902831939768],
            [-1.9028202760063624, 2.0128397104927815],
            [-1.8962692550532803, 2.0126423100396726],
            [-1.8791337835657547, 2.009492729911032],
            [-1.8670417003609527, 2.0107656410300194],
            [-1.8632506824567072, 2.0098352995892936],
            [-1.8548726243247957, 2.0109044691371096],
            [-1.8419326935125446, 2.0086806696581667],
            [-1.8365290800487466, 2.0089977679323385],
            [-1.8322921998070985, 2.007177301788773],
            [-1.82374422086003, 2.008159939838909],
            [-1.817697625281732, 2.0052174495103583],
            [-1.811385307499254, 2.005568982951235],
            [-1.7982619476806692, 2.005087026184505],
            [-1.7945353212727337, 2.0056832607795494],
            [-1.7894215048344166, 2.0039536546226526],
            [-1.7724864197665526, 2.008346576707362],
            [-1.7648011281329368, 2.0075549465226277],
            [-1.7609032615506184, 2.0060317188973094],
            [-1.7538440756070515, 2.0057872026019923],
            [-1.7513651416138625, 2.0044345895641458],
            [-1.7448273395828962, 2.003921715187628],
            [-1.7404107436702037, 2.005142873501321],
            [-1.7344173764691542, 2.0032015405947075],
            [-1.7312424488112235, 2.0038886170599173],
            [-1.7217937781358117, 2.00241922104981],
            [-1.7175567913576884, 2.0038580491012032],
            [-1.7117361474047665, 2.0038844222988903],
            [-1.7099474309118077, 2.006159636729623],
            [-1.703406677673341, 2.007110752143245],
            [-1.700193881636133, 2.009388416214624],
            [-1.6919973454693886, 2.00815248400256],
            [-1.6791547436661436, 2.0135429141672656],
            [-1.6726815911962527, 2.0183360045769323],
            [-1.6665286110521775, 2.0184539042542946],
            [-1.6613573276310265, 2.022847072822883],
            [-1.6545034819312217, 2.02368232942527],
            [-1.651025092012774, 2.0228179619766333],
            [-1.6440724141863194, 2.023235814773221],
            [-1.6398346379013378, 2.026617291084869],
            [-1.6344323375168794, 2.0280729919573335],
            [-1.6273376263747827, 2.027354813778918],
            [-1.6227876454843804, 2.0296430576481024],
            [-1.6107980967124909, 2.0306261614227634],
            [-1.6077356705881907, 2.033258019266129],
            [-1.602537685035301, 2.0351828395646785],
            [-1.5958263272517264, 2.03503953561555],
            [-1.5911903083107148, 2.0335013888831663],
            [-1.5841068895100212, 2.035705106718273],
            [-1.5862418662768074, 1.9565656243047025],
            [-1.5892379963363776, 1.8451287394941507],
            [-1.589741632478791, 1.8321978076286307],
            [-1.59283501574008, 1.7228510508652455],
            [-1.5935875062249956, 1.6936643043864172],
            [-1.5957611416392, 1.6937336856413827],
            [-1.6365057084719026, 1.694862586295827],
            [-1.7381586621806062, 1.6979638163044806],
            [-1.8522096807563244, 1.7017099252572723],
            [-1.9374519899915634, 1.7046346982704363],
            [-1.9347564268779238, 1.7852373636608556],
            [-1.9316331331560639, 1.8803223743513355],
            [-1.9286123261563624, 1.968221624346185],
            [-1.9268810567020798, 2.016868735471779]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.9480284100243, "lat": 40.506699717613245 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31099"],
        "coty_name": ["Kearney"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kearney County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00835871"
      },
      "bbox": [
        -1.9374519899915634, 1.6936643043864172, -1.5841068895100212,
        2.035705106718273
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9012320400761077, 2.5068309914711624],
            [-0.901202719286956, 2.5088965186938728],
            [-0.8884301212760174, 2.5183710297712563],
            [-0.880787092641637, 2.525744579202135],
            [-0.8832847809825628, 2.5301223718873556],
            [-0.872776795544641, 2.539098274906667],
            [-0.8536055321442629, 2.5678306097172814],
            [-0.8375449923061563, 2.582423941070756],
            [-0.8351695806105187, 2.582438829513369],
            [-0.8157368445865305, 2.596708996301606],
            [-0.7933391680270063, 2.6197920421096987],
            [-0.787795228458711, 2.6247255151338154],
            [-0.7798730111702415, 2.6301876227755483],
            [-0.7768184021002477, 2.6267331407188808],
            [-0.7708659329595723, 2.633390871587548],
            [-0.7722346261327074, 2.6368388046547926],
            [-0.7602171814850867, 2.6414904504455503],
            [-0.7598259210792156, 2.6378260102774718],
            [-0.7516638055294151, 2.6383794840566104],
            [-0.7380301892560448, 2.644033348526779],
            [-0.7326144688313194, 2.6447272469282685],
            [-0.727056219971439, 2.648537994192697],
            [-0.7268229619077115, 2.664517674592567],
            [-0.7175351082043203, 2.665142687958406],
            [-0.7061526499389535, 2.668365611423532],
            [-0.6956259829924681, 2.6746192521551833],
            [-0.6921177410799091, 2.6775557046044614],
            [-0.6790470694857705, 2.685794192828286],
            [-0.6698675891129876, 2.6925997398190615],
            [-0.6559824584619494, 2.6953413356592124],
            [-0.6498769770219988, 2.6959801571836026],
            [-0.6355009977008002, 2.6952380586207627],
            [-0.6159586266475671, 2.6986510552346137],
            [-0.604599895930555, 2.705283556490899],
            [-0.5987277015500666, 2.7063008108074795],
            [-0.5921138313264145, 2.7099777783109484],
            [-0.5764491298328941, 2.714162194383534],
            [-0.5725035633307013, 2.716382923640423],
            [-0.5673028979371412, 2.722292864486849],
            [-0.5545370058032505, 2.7255677147863953],
            [-0.555009179922011, 2.6951313246337016],
            [-0.5563488504371583, 2.5928631430263906],
            [-0.5582704004953847, 2.461319852674585],
            [-0.5595573738600743, 2.373658513530874],
            [-0.6455487169881684, 2.3748123218041712],
            [-0.7312991847688306, 2.3760368213493717],
            [-0.7968114232786909, 2.377143272856331],
            [-0.9022196283311018, 2.379043764922026],
            [-0.9034597792951926, 2.379056504484978],
            [-0.9018989392267692, 2.466572135816549],
            [-0.9020504774564599, 2.4706148391407634],
            [-0.9012320400761077, 2.5068309914711624]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.5684446822463, "lat": 41.186894393165524 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31143"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00835893"
      },
      "bbox": [
        -0.9034597792951926, 2.373658513530874, -0.5545370058032505,
        2.7255677147863953
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.471905707957089, 4.505545249592367],
            [-4.4008785578534395, 4.500377188862026],
            [-4.315121675218184, 4.494235036506384],
            [-4.250809793775354, 4.489698929994051],
            [-4.1544284542168155, 4.483186836250345],
            [-4.055748136079571, 4.476654521848927],
            [-3.957069182661222, 4.470101884763057],
            [-3.966393590847827, 4.343195276036],
            [-3.9725826833345153, 4.256196118066756],
            [-3.959437843628063, 4.255337870653612],
            [-3.964398730761391, 4.170924485623638],
            [-3.970739170035075, 4.075774925762227],
            [-3.9812333504769817, 3.912745411874249],
            [-3.9603753235221553, 3.911261496113794],
            [-3.965794207351666, 3.831938758473778],
            [-3.974368270413626, 3.7055528032982616],
            [-3.9745886348828177, 3.704939604965697],
            [-3.97810023620401, 3.650618325880132],
            [-3.9840787426352398, 3.56390255588683],
            [-3.95921766076689, 3.5618072713882607],
            [-3.9663429302894464, 3.4743048162923578],
            [-4.009094136624238, 3.4773153731731896],
            [-4.136397102631493, 3.4845971981769996],
            [-4.144502200532467, 3.4849351017224435],
            [-4.229213807966187, 3.490350633368989],
            [-4.313926222070466, 3.4957532346758016],
            [-4.368233923069408, 3.4989532330183835],
            [-4.415435653825714, 3.501464582386748],
            [-4.459092795947121, 3.5035319866256227],
            [-4.474030114035166, 3.504140418975417],
            [-4.473211133293376, 3.5260509974855734],
            [-4.473871031641807, 3.5509666487803435],
            [-4.471139885268036, 3.5925122258008866],
            [-4.5004839346331975, 3.59422536959041],
            [-4.49388848921863, 3.679726575206887],
            [-4.492924224189729, 3.7136445142055727],
            [-4.492317317046294, 3.7523850420088034],
            [-4.489246338145527, 3.8076989666816696],
            [-4.488351944049156, 3.817799174660469],
            [-4.485944659765727, 3.8546525297770926],
            [-4.488376136249233, 3.8600025055932967],
            [-4.485309267215926, 3.895330984040127],
            [-4.4848320535617665, 3.8964941748044977],
            [-4.480921810447105, 3.942855840317687],
            [-4.498427910296543, 3.9440882957668566],
            [-4.494007317151683, 4.001173359543489],
            [-4.492126681531795, 4.029917152494703],
            [-4.48803580909829, 4.08832125786701],
            [-4.485033436473, 4.129370140371987],
            [-4.4800624384537056, 4.204225029627523],
            [-4.478823172167529, 4.218795988027631],
            [-4.476468664080028, 4.252965828992109],
            [-4.476110498129604, 4.254483213474969],
            [-4.473686602069827, 4.289805093208488],
            [-4.487731256993967, 4.290705746688189],
            [-4.485203638964493, 4.32806087497479],
            [-4.471905707957089, 4.505545249592367]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.40891466328263,
          "lat": 42.504750570733904
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31161"],
        "coty_name": ["Sheridan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sheridan County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00835902"
      },
      "bbox": [
        -4.5004839346331975, 3.4743048162923578, -3.957069182661222,
        4.505545249592367
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.32651983412916, 1.8870687692796095],
            [-17.138321758469626, 1.8422463435307959],
            [-17.11418099492629, 1.9412294149326],
            [-17.05506049712873, 2.1847667361737133],
            [-17.05104728720655, 2.1837832082018203],
            [-17.03003424188671, 2.2692895556531942],
            [-17.114171937169136, 2.290031971539007],
            [-17.09212061524703, 2.3803891692943644],
            [-17.076522895760093, 2.3990113289274295],
            [-16.988588142576877, 2.491046941233187],
            [-16.86650818985628, 2.4606560641547377],
            [-16.770141453067613, 2.436891578279748],
            [-16.766500813833233, 2.4355595945437813],
            [-16.659345226047474, 2.409394838004187],
            [-16.640700040397455, 2.405136031762794],
            [-16.614672445830088, 2.3986620459118337],
            [-16.489932690966228, 2.3688846565807773],
            [-16.48449705968484, 2.367169660515314],
            [-16.3964756811448, 2.3464334089090926],
            [-16.37661533932789, 2.3416329684894315],
            [-16.302951652325397, 2.324265769354972],
            [-16.29980996049936, 2.323712486611881],
            [-16.201219070403738, 2.300606607185332],
            [-16.40843572176461, 2.289581682818827],
            [-16.40993033741863, 2.289735649163671],
            [-16.466274588751734, 2.2866970690089308],
            [-16.485140733126254, 2.2073182338597057],
            [-16.389408835401742, 2.0250293767531278],
            [-16.30704916909954, 1.8683178855585423],
            [-16.224699182007207, 1.711580238295117],
            [-16.2240137513121, 1.7114208794645127],
            [-16.207883526453084, 1.6805994296572255],
            [-16.502022600760377, 1.471767524070885],
            [-16.504313216273108, 1.470417555161474],
            [-16.577948487976126, 1.4188324063314333],
            [-16.591289977620452, 1.408757614456585],
            [-16.621492491668608, 1.3870634853856254],
            [-16.62472194801502, 1.384259858332996],
            [-16.7289216125564, 1.311737190217671],
            [-16.745412973430664, 1.2981610557190446],
            [-16.842755113207538, 1.2286696735590075],
            [-16.890998525628376, 1.2404323381496554],
            [-16.89259791300177, 1.2435349899994659],
            [-16.900150923039803, 1.245064640152401],
            [-16.94322738779017, 1.3102562456353468],
            [-16.985023568589966, 1.3732308278474588],
            [-17.014459781859927, 1.4161563350887552],
            [-17.068527302161915, 1.4997310566157698],
            [-17.08752659545226, 1.5279908286137263],
            [-17.10258915523815, 1.5492746316968198],
            [-17.15343251747873, 1.627120935713945],
            [-17.190487293322086, 1.6831063319884365],
            [-17.206400420097147, 1.7067932820593867],
            [-17.236721357736698, 1.7503753346718052],
            [-17.253466993182894, 1.7768685790294692],
            [-17.28413040827628, 1.8219730972398274],
            [-17.292472185833212, 1.8360867480612393],
            [-17.32651983412916, 1.8870687692796095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.43493093109275,
          "lat": 38.53855920276182
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32021"],
        "coty_name": ["Mineral"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mineral County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00858644"
      },
      "bbox": [
        -17.32651983412916, 1.2286696735590075, -16.201219070403738,
        2.491046941233187
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.399591526090475, 6.585300588118644],
            [15.387340676244795, 6.623673634138524],
            [15.350473883172823, 6.740462649026871],
            [15.325355205479921, 6.819914761393595],
            [15.286465406877742, 6.942078257468788],
            [15.268882567022326, 6.998937877117141],
            [15.254422239570161, 7.044373236095522],
            [15.337769162079201, 7.016376298079592],
            [15.408464459717097, 7.042225691006065],
            [15.47916579142866, 7.068061295137126],
            [15.538942706119668, 6.8889253624865345],
            [15.572652152931534, 6.787095130437727],
            [15.580767370138602, 6.763183125950146],
            [15.611081572432063, 6.671878279454693],
            [15.663751380370387, 6.513153354091536],
            [15.642900951639506, 6.412046689540496],
            [15.631429169763248, 6.3555272100315126],
            [15.72518096941418, 6.334075107275295],
            [15.7528724638382, 6.327932857865078],
            [15.764399728273846, 6.29358125120642],
            [15.765026800420122, 6.291007836990167],
            [15.788191070860842, 6.2270650528915725],
            [15.789534020967537, 6.220819741915333],
            [15.786590759247007, 6.218774148828148],
            [15.782734503214408, 6.2188639756864985],
            [15.778723318915882, 6.214967659165306],
            [15.776334666307097, 6.209398238522372],
            [15.776857626763416, 6.2046140993919865],
            [15.780865387587754, 6.202124669299233],
            [15.78654458915437, 6.19570156879874],
            [15.778544881984423, 6.192494919425674],
            [15.77460342107012, 6.188823868271759],
            [15.769086001020574, 6.185815436550889],
            [15.772701249338075, 6.1793934878892145],
            [15.772832428603309, 6.175314702444679],
            [15.777608217684724, 6.1685605872571365],
            [15.770791841517461, 6.16619010049125],
            [15.770729861027524, 6.161902446503823],
            [15.765125436855481, 6.16247919370609],
            [15.757263956657628, 6.158213328670919],
            [15.758468552065501, 6.152706156971352],
            [15.753028510755412, 6.1522274267555055],
            [15.750904813051417, 6.1495428207134415],
            [15.75347900241876, 6.146857329634329],
            [15.753664185144826, 6.139003860183572],
            [15.758958041762446, 6.128427028521079],
            [15.756349761936946, 6.12556712699057],
            [15.754853739834212, 6.120572969320104],
            [15.755616151520158, 6.115718703207005],
            [15.759273505504172, 6.112883728690995],
            [15.761550499510713, 6.103947529114442],
            [15.76854698447301, 6.0991069702075364],
            [15.769034107832349, 6.0927331019181095],
            [15.772668043817669, 6.087737661176059],
            [15.77420770089864, 6.083153741694604],
            [15.779875459655392, 6.0810583674712895],
            [15.785346351929197, 6.077260743971938],
            [15.787791342380777, 6.074051459329809],
            [15.792918116141065, 6.062493479087972],
            [15.795202635199587, 6.052142077068849],
            [15.794842606005757, 6.043516977245619],
            [15.79765551777971, 6.043030311704653],
            [15.798821479696732, 6.032979957703211],
            [15.804361203244271, 5.978718503780096],
            [15.805699940735831, 5.97065812514749],
            [15.811297024954571, 5.907556475625255],
            [15.757375572298127, 5.917199299894635],
            [15.721428317918283, 5.923241745932975],
            [15.725306393256725, 5.876607680306457],
            [15.725477074923534, 5.865770812786329],
            [15.724837777760344, 5.85608216645379],
            [15.717829769775772, 5.84721713655277],
            [15.678882608747404, 5.860516288081587],
            [15.665651561815901, 5.864759361652494],
            [15.656184611984933, 5.868563170327554],
            [15.642110829103544, 5.872658232271053],
            [15.561326247187363, 5.897798076070405],
            [15.552750232614839, 5.870362645195056],
            [15.54931797459526, 5.861001432873562],
            [15.544341475889501, 5.844200309499239],
            [15.495394973929827, 5.830128926376719],
            [15.494592361409863, 5.830306099003691],
            [15.48850787792014, 5.852552240631423],
            [15.495976754394889, 5.854912425450714],
            [15.471574143192147, 5.936162476229339],
            [15.46049353377167, 5.972552192181441],
            [15.457998227452991, 5.97977153368758],
            [15.445939490254787, 6.0198912249356935],
            [15.457026062021686, 6.048136699037626],
            [15.467037047231319, 6.047946962622139],
            [15.468599300455324, 6.05570891200971],
            [15.464777282190571, 6.060146094954337],
            [15.461899961283876, 6.0602712759269295],
            [15.474570121312098, 6.092805113154619],
            [15.484151059015073, 6.121067997342761],
            [15.490156761397081, 6.140525195424833],
            [15.513891619273764, 6.214050764929474],
            [15.511178726435856, 6.214021559191758],
            [15.508026037369255, 6.219912522285643],
            [15.502741585570307, 6.214852221175692],
            [15.49782408403071, 6.213711769961641],
            [15.490853941553935, 6.214806447721483],
            [15.486314837720489, 6.216949580784734],
            [15.473027036914683, 6.219011958616232],
            [15.47095662715903, 6.224134366576069],
            [15.462686694296403, 6.224193532794342],
            [15.454461646462477, 6.2287507014741985],
            [15.450422140864946, 6.22507376770887],
            [15.448550128307476, 6.227836553120888],
            [15.444900056425974, 6.227577487754059],
            [15.441146950322347, 6.229772113177452],
            [15.442517227384315, 6.235944454080069],
            [15.440687994771096, 6.244606788965532],
            [15.442809189125091, 6.2527745320227375],
            [15.442085777366142, 6.257879716021167],
            [15.444477839098102, 6.261827688264186],
            [15.444262759682749, 6.271223664327984],
            [15.442090648371629, 6.276471069012979],
            [15.453302454789116, 6.282413854297716],
            [15.457966291642586, 6.282629780642623],
            [15.46089210086831, 6.28093301609861],
            [15.461081142038498, 6.287947715043998],
            [15.468366666791095, 6.290529545569293],
            [15.468831254095065, 6.295580800832556],
            [15.471625712796312, 6.3047505242340405],
            [15.475483778526245, 6.303558590960126],
            [15.475307487887763, 6.308068216030025],
            [15.478034536257377, 6.310719449927609],
            [15.485957344658377, 6.313668464415373],
            [15.465384321841043, 6.37887634437305],
            [15.451480847518875, 6.42152947190728],
            [15.43476788157016, 6.47221246654783],
            [15.424155239122918, 6.50836305148082],
            [15.399912107134801, 6.585622223618287],
            [15.399591526090475, 6.585300588118644]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.96237249694464, "lat": 43.4192703754 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36043"],
        "coty_name": ["Herkimer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Herkimer County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00974120"
      },
      "bbox": [
        15.254422239570161, 5.830128926376719, 15.811297024954571,
        7.068061295137126
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.01647308475832, 4.04331664962361],
            [17.013930669411796, 4.047242816321903],
            [17.010440194899882, 4.056169284722626],
            [17.01020317485158, 4.059462641545689],
            [17.005580288417157, 4.061154513400733],
            [17.000780721946356, 4.064882211245705],
            [16.99870254853095, 4.068449256095262],
            [17.0047472714778, 4.080305355091537],
            [17.003099617027168, 4.0860107187713375],
            [16.999391692037634, 4.092420462306614],
            [17.001412057543195, 4.097558502333563],
            [17.006976208645398, 4.0936670085053715],
            [17.010183172350914, 4.094057736320569],
            [17.014170889158407, 4.089785297064547],
            [17.019483806240377, 4.0900157683944],
            [17.02169228179529, 4.087018112776899],
            [17.028018361581204, 4.086804712618577],
            [17.032964060193823, 4.081219010626372],
            [17.035887834566715, 4.075150600761675],
            [17.039763483419957, 4.07293201189645],
            [17.040355403112745, 4.081213785426694],
            [17.042118180933453, 4.085575531066677],
            [17.0396855993274, 4.090296223948135],
            [17.03948307849111, 4.100218004038143],
            [17.03514390799261, 4.100598544719349],
            [17.03070991695875, 4.104985961203283],
            [17.02437540321432, 4.101715696570901],
            [17.019828530480822, 4.1020641722731215],
            [17.017012912733108, 4.105353543683465],
            [17.010336603469497, 4.110040427390386],
            [17.01630216891995, 4.116092362143786],
            [17.01631770797967, 4.120141546559158],
            [17.01138615461526, 4.127860668008703],
            [17.017891492154558, 4.1294883153811135],
            [17.022435127851047, 4.135237624288413],
            [17.05267411758242, 4.129260628956009],
            [17.053770056126485, 4.1267369913645995],
            [17.06981144571983, 4.109947630581484],
            [17.075632107124793, 4.105395847297893],
            [17.079841127519547, 4.106358177339726],
            [17.074591104859422, 4.112949194922017],
            [17.07235309336282, 4.120674621964342],
            [17.07211037398218, 4.126576352189635],
            [17.07429753697042, 4.1309631915358285],
            [17.070008404425714, 4.13453469297461],
            [17.066116367980413, 4.140436239379311],
            [17.064031130259224, 4.153652295938498],
            [17.067714603556368, 4.160624148967215],
            [17.070343920907685, 4.170054015319478],
            [17.07032089175744, 4.174207180952291],
            [17.074349667861924, 4.176802486771816],
            [17.073757780321575, 4.181306757883249],
            [17.07902345188418, 4.179160379816783],
            [17.086228269239076, 4.179333820181636],
            [17.088507021811846, 4.1843369752895265],
            [17.096518442638786, 4.186865313432407],
            [17.10047747777315, 4.193887076876698],
            [17.10916111631524, 4.1969102030010035],
            [17.11331899706439, 4.199550552543155],
            [17.116796095258636, 4.204757609702039],
            [17.11947047245312, 4.205812809721982],
            [17.126831653817746, 4.20320762186012],
            [17.134334161571143, 4.202035497883622],
            [17.140296310958185, 4.206954238291517],
            [17.14557608692479, 4.2097649029824895],
            [17.147433825402018, 4.213379820516336],
            [17.151478387599738, 4.216090793944794],
            [17.152473865884936, 4.2126670108275786],
            [17.159748141202474, 4.211466564792239],
            [17.16396026250026, 4.2091111934179795],
            [17.164967004245728, 4.201919200600674],
            [17.161421642601447, 4.202181797755253],
            [17.15864411598248, 4.2000273567153625],
            [17.158204205278377, 4.188955643633619],
            [17.159788816282497, 4.185433248667204],
            [17.150773945589094, 4.181779156964158],
            [17.14910867775708, 4.186397490465204],
            [17.152583508853105, 4.189463812576426],
            [17.15473160303385, 4.195741235867935],
            [17.15381159365646, 4.2025826575062855],
            [17.151972813627534, 4.207157976442982],
            [17.14617368189221, 4.206135808882537],
            [17.143116762512847, 4.199826739916549],
            [17.135708252136336, 4.197118746665423],
            [17.136920049229065, 4.188303432802096],
            [17.139450387631904, 4.183892735520447],
            [17.139605487413473, 4.1802120732259285],
            [17.146358235652016, 4.171980993499777],
            [17.156109550260624, 4.175624979088258],
            [17.161591011758855, 4.172665539014135],
            [17.173162937295448, 4.177122139996467],
            [17.165900793138757, 4.188203228411191],
            [17.166446452633064, 4.194283164164414],
            [17.176410835009197, 4.197795764120885],
            [17.17983489628976, 4.194232177357624],
            [17.182643747209095, 4.188699610076178],
            [17.182157201215656, 4.186165611396991],
            [17.185642289866852, 4.181613111169596],
            [17.19527683750509, 4.178168098126463],
            [17.201665482543497, 4.174500639066437],
            [17.204337453280967, 4.176778995521022],
            [17.2067978249175, 4.176027237476227],
            [17.207175071065915, 4.168713613209615],
            [17.21430682972629, 4.1595957313390945],
            [17.218022946563586, 4.151265510873528],
            [17.239149166582198, 4.098135431140323],
            [17.240214590237287, 4.096016207795062],
            [17.257569120413184, 4.051588012282205],
            [17.281389776378944, 3.991893930102402],
            [17.283460563771715, 3.9767387576306525],
            [17.291258912569642, 3.9488010439698207],
            [17.295691843117883, 3.9313315925537164],
            [17.277858333267744, 3.9207327254667925],
            [17.25402883985363, 3.908665976336117],
            [17.24560875615539, 3.9040989870182976],
            [17.233015865686397, 3.898233313183962],
            [17.21001303107542, 3.8850569312268752],
            [17.194964863894892, 3.874657642248738],
            [17.194588269915613, 3.880175398105022],
            [17.188416727496797, 3.8809048625234284],
            [17.178024092885206, 3.8781875298076716],
            [17.164128008738373, 3.877043260407915],
            [17.143291320805282, 3.8670063153702854],
            [17.096051492848666, 3.8566014678521734],
            [17.067829578488638, 3.853108661520326],
            [17.059827012051954, 3.8488774849382836],
            [17.06119938528984, 3.853825500901956],
            [17.065093126416112, 3.858782222729214],
            [17.07041257060709, 3.8601115592756767],
            [17.06728397150223, 3.8693977066336],
            [17.06236032683696, 3.8731836751696154],
            [17.059920563466598, 3.877106704116317],
            [17.053483708167445, 3.87412675371447],
            [17.04939083653929, 3.874129912238467],
            [17.043632626523824, 3.87654203319025],
            [17.039982382538792, 3.8853802772677053],
            [17.040403200791665, 3.88777696000992],
            [17.05405478206453, 3.899927243130216],
            [17.056178547702032, 3.9059054830459177],
            [17.054676978212544, 3.912155749743029],
            [17.058622456873334, 3.9160361847139806],
            [17.06316435892031, 3.918401588994821],
            [17.065193569269308, 3.9220175639728607],
            [17.06148021799305, 3.9284712216134623],
            [17.05935416332622, 3.935184914595418],
            [17.058583720042343, 3.9469139117370196],
            [17.050312896664565, 3.977144175352464],
            [17.04518101552552, 3.987757964860134],
            [17.05428381298969, 3.9943710813627105],
            [17.060227289726523, 3.997149859270565],
            [17.063012102219254, 4.009492650327157],
            [17.059039421494752, 4.022439840687959],
            [17.01647308475832, 4.04331664962361]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.58622928991298, "lat": 40.73265415450996 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36059"],
        "coty_name": ["Nassau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nassau County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00974128"
      },
      "bbox": [
        16.99870254853095, 3.8488774849382836, 17.295691843117883,
        4.216090793944794
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.778919413328092, -1.7685632746453335],
            [11.884617583051451, -1.7412614710788417],
            [11.896493661528769, -1.7437640214483927],
            [11.987733039436012, -1.7307860379396005],
            [12.00866685800432, -1.7427281735153177],
            [12.0139998637159, -1.7472447533107873],
            [12.020204643358548, -1.74672680641843],
            [12.027357613178188, -1.7420787862490368],
            [12.03151368531592, -1.744212163329416],
            [12.036899715345323, -1.7432685209817418],
            [12.038989295848463, -1.744713956585207],
            [12.045132447517705, -1.7432949593999723],
            [12.045081540309162, -1.7472020410360105],
            [12.054495876165198, -1.7530068692866834],
            [12.055630505533902, -1.7499678420117921],
            [12.060335249576438, -1.746263255223038],
            [12.064366373353298, -1.7466105542509247],
            [12.065279339601586, -1.7500118935532363],
            [12.070650570082146, -1.7532125712224265],
            [12.0715010650275, -1.75809137546784],
            [12.077468719726774, -1.762173493688519],
            [12.079370433287815, -1.7596975423545738],
            [12.083518255264885, -1.7593093341803032],
            [12.089997996115887, -1.7556819574312956],
            [12.096182033172546, -1.761631119540261],
            [12.100630400063956, -1.7589262241338997],
            [12.108723975500817, -1.7650202266619315],
            [12.114727960380462, -1.7730560682859],
            [12.121515631615749, -1.7792061530529544],
            [12.116398116037294, -1.7870739086638185],
            [12.117755168313362, -1.7890984333748736],
            [12.124509379382493, -1.7852350457371944],
            [12.134199863609304, -1.7871532602793618],
            [12.147200767737417, -1.7927351115609231],
            [12.1621584369744, -1.800512207667732],
            [12.178262582537139, -1.8247787849362789],
            [12.178097293585093, -1.8996298565386858],
            [12.192474961891321, -1.9424468028238029],
            [12.19246320474745, -1.9980350933902011],
            [12.196422074622772, -1.9987815785314893],
            [12.200623831652257, -2.0071543094657525],
            [12.199189628573126, -2.009299111678248],
            [12.20346115554267, -2.0180068415275745],
            [12.205869163778033, -2.0206383138804482],
            [12.20461976275671, -2.025142731465152],
            [12.197672314349315, -2.0269510739625836],
            [12.19423121213759, -2.0317037622473375],
            [12.192856566535378, -2.0396788969745727],
            [12.190197302036092, -2.0437209262499914],
            [12.193344584046182, -2.0487690389123356],
            [12.193301852681062, -2.0548960731432113],
            [12.19014157117971, -2.057226654490863],
            [12.185579392777537, -2.0571649927780395],
            [12.179918991810162, -2.0594889422340295],
            [12.176571797519548, -2.0689394562430645],
            [12.172603068650911, -2.070004463380026],
            [12.165160146631539, -2.0688426981378973],
            [12.158861521039707, -2.070736066952478],
            [12.150496139479923, -2.0650480230574924],
            [12.147171894838024, -2.0646925801907186],
            [12.134167011351563, -2.0605303369977532],
            [12.12229866067899, -2.0601949021077623],
            [12.119153561587305, -2.0506033462867252],
            [12.117536101275325, -2.0498895479707113],
            [12.095098615892427, -2.05508457321543],
            [12.083127060705925, -2.059982346120407],
            [12.062505070204681, -2.062832000886982],
            [12.041916477843102, -2.0679765871025815],
            [12.037807569814426, -2.0707770409966675],
            [12.031359364424432, -2.070993956230489],
            [12.00669575644545, -2.0470233689056134],
            [11.988501080654252, -2.029023475199785],
            [11.981730042294924, -2.0356510172926425],
            [11.964461469992365, -2.027299892645083],
            [11.967131327868167, -2.0237256689646137],
            [11.962023170928784, -2.0222009486188157],
            [11.95446312664801, -2.010490217112022],
            [11.928859858052508, -2.002453234918308],
            [11.894360382585162, -1.9923875083485272],
            [11.887420347092947, -1.9850599957231074],
            [11.876990654083045, -1.9787738266301815],
            [11.874237571114438, -1.9719831933433196],
            [11.865542010983566, -1.9639513821327468],
            [11.861688441305885, -1.9630033827144113],
            [11.859621074150889, -1.9554661148226837],
            [11.853018012728272, -1.9482534793421276],
            [11.846297904522183, -1.947037709414574],
            [11.84394814728482, -1.94826431948346],
            [11.838770507215488, -1.9456156605206583],
            [11.834323349996762, -1.9484995099618805],
            [11.832222561218934, -1.945788590030658],
            [11.833493430843536, -1.94181576154898],
            [11.82924437387931, -1.9359042253622922],
            [11.831236719486355, -1.9344778854179008],
            [11.828604265303532, -1.9291917845328708],
            [11.821009448077316, -1.9289637163793234],
            [11.815827214501322, -1.927534402178775],
            [11.81134938340418, -1.9278073109810747],
            [11.810610397017722, -1.9254265451118062],
            [11.802988699125688, -1.9207402482970315],
            [11.804031017648546, -1.9173520791479841],
            [11.844783312769383, -1.8034506396656953],
            [11.836542582069894, -1.7992281387523248],
            [11.829767512864738, -1.8005500905102931],
            [11.825250123840878, -1.796626476625146],
            [11.824827196781971, -1.7912156354098259],
            [11.821220133142727, -1.7840069811365455],
            [11.813755805257733, -1.7805641070372116],
            [11.808492560047059, -1.7765940132713571],
            [11.803586112871109, -1.7754102006224397],
            [11.80020603747416, -1.7766386100280522],
            [11.794662726305345, -1.774702359783057],
            [11.79047059141364, -1.771335104904798],
            [11.781465804062314, -1.7685201282716478],
            [11.778919413328092, -1.7685632746453335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.54643163496817,
          "lat": 35.952989263544545
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37027"],
        "coty_name": ["Caldwell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caldwell County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01008541"
      },
      "bbox": [
        11.778919413328092, -2.070993956230489, 12.205869163778033,
        -1.7307860379396005
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.762586580485657, -1.1654379872853693],
            [14.779562875174687, -1.109701730387954],
            [14.782722714252749, -1.1004535557444823],
            [14.793653329580103, -1.0652573249660078],
            [14.794667119658095, -1.0607376688985095],
            [14.796692890805389, -1.0300298991452508],
            [14.799031145446914, -1.0086907837413934],
            [14.80251046196156, -0.9729742150231112],
            [14.794387181085147, -0.9312594242721877],
            [14.7874673393424, -0.9254182940950189],
            [14.78590315275451, -0.9210723174520492],
            [14.7876444858265, -0.9154032149342619],
            [14.791115416562624, -0.9131239812149249],
            [14.787165208827979, -0.8818852266994234],
            [14.786804290076407, -0.864469132742978],
            [14.78897419681389, -0.8503664257486883],
            [14.792764578986977, -0.8417066608053367],
            [14.795897478642102, -0.8422271216063332],
            [14.799995557046705, -0.8460051553167293],
            [14.806985101603802, -0.8449987380627546],
            [14.815690640708445, -0.8459569529368909],
            [14.820751223113586, -0.8417779765612774],
            [14.840549513939042, -0.8435965352034818],
            [14.852651535642329, -0.8417466120332282],
            [14.864065944590642, -0.8431022285709309],
            [14.87191229858869, -0.8463531799114898],
            [14.877780952740578, -0.8466103870676303],
            [14.891421922270524, -0.8537460173420772],
            [14.896518462954283, -0.8544541070800032],
            [14.900600859046342, -0.8516704774410766],
            [14.906091118029265, -0.8532176424686192],
            [14.913899204543538, -0.8521903928325413],
            [14.916331505407152, -0.8507785783546541],
            [14.92436070519817, -0.8424286164253066],
            [14.940700421943914, -0.8386299766829224],
            [14.9458171527038, -0.8402409137039791],
            [14.956932142187076, -0.8418491322077519],
            [14.964527166294653, -0.8421075095777174],
            [14.97097947733977, -0.8410548134425523],
            [14.974016558625273, -0.8394024861890163],
            [14.98005129511492, -0.8390455393024481],
            [14.989310838892454, -0.8348878949133169],
            [14.993069750133316, -0.8354509406533698],
            [14.99783463612292, -0.8398859180355851],
            [15.001569819880094, -0.8462737267034833],
            [15.010023896280984, -0.8634663871611736],
            [15.018270830970735, -0.8686198662795941],
            [15.02204056110231, -0.8669343692938459],
            [15.028660980296086, -0.8732077402740317],
            [15.039389881310566, -0.8738697634135942],
            [15.04353281899429, -0.8758037281597929],
            [15.046153320428516, -0.8818831163577932],
            [15.049689719908143, -0.884212499445323],
            [15.053575265559227, -0.8813044432886507],
            [15.060180756944032, -0.8811795205554959],
            [15.074826460102859, -0.8834687024620591],
            [15.079334066277617, -0.8866563214973034],
            [15.08798506489826, -0.9056412156700008],
            [15.089868907569029, -0.9258246088909042],
            [15.088201929460528, -0.9300138742309803],
            [15.08402967806866, -0.9326216603576156],
            [15.079718429472587, -0.940241135947763],
            [15.073389308596399, -0.9454030155820925],
            [15.068746925899836, -0.9544935074243677],
            [15.066775946895975, -0.967975805885687],
            [15.067315807981592, -0.9700596650778456],
            [15.073645609624819, -0.9740004935852741],
            [15.077985214023663, -0.9798394813833652],
            [15.082429365282529, -0.9888257410609329],
            [15.095977267496119, -0.995296351614291],
            [15.103932076247775, -0.9957468053956156],
            [15.108253510543898, -0.9948826616617755],
            [15.122271697103951, -0.9883657000414723],
            [15.134318679160094, -0.9857008418497689],
            [15.143296334031154, -0.9827184674363884],
            [15.147932720982661, -0.9755257965583988],
            [15.151030486040128, -0.9726823086563032],
            [15.155765932610834, -0.9713312019551071],
            [15.163178275858233, -0.9648278330141724],
            [15.1704333217955, -0.9627537608538294],
            [15.178604887592519, -0.9587651718557314],
            [15.185395104935889, -0.9607630674543924],
            [15.18813805314884, -0.9657968867062503],
            [15.196020948526387, -0.9726964597670814],
            [15.202538271249646, -0.9800376157804453],
            [15.209404656411385, -0.9849932485555777],
            [15.212762464464639, -0.9943978604698808],
            [15.213373176092748, -1.0011744808156084],
            [15.217289981551302, -1.0110022060966162],
            [15.22263744071065, -1.0155542648032785],
            [15.237570023660089, -1.020587520043698],
            [15.244609958224016, -1.0234990399007518],
            [15.249198604163885, -1.029072738811143],
            [15.249840857954023, -1.0375686616666304],
            [15.247685488827361, -1.045701826124038],
            [15.246895256392033, -1.059794883315386],
            [15.250115738199728, -1.0638600865178744],
            [15.261550981806847, -1.068252811101359],
            [15.2711826500612, -1.0707428360397178],
            [15.279157362966822, -1.076041875016562],
            [15.288932919626271, -1.0756048363028272],
            [15.293039028888087, -1.0721909988098202],
            [15.296807037764317, -1.072146168560909],
            [15.299853025031242, -1.076631453131929],
            [15.307441964421416, -1.081024156536507],
            [15.31416500621741, -1.0802028552745182],
            [15.312209236875015, -1.0852589801590788],
            [15.312695770717154, -1.089252386525345],
            [15.31665306046636, -1.092611097512208],
            [15.323177846061876, -1.0944259536141958],
            [15.327936050284107, -1.0928642827474537],
            [15.330355238042138, -1.0897126380768392],
            [15.335696455172185, -1.0886382061816373],
            [15.340389085850282, -1.0928381572982975],
            [15.342643584809606, -1.0969821016443402],
            [15.346122477085567, -1.0983058886963126],
            [15.353352795469926, -1.0943968098316617],
            [15.354918900581112, -1.096258564387935],
            [15.352908090721467, -1.1030950049715955],
            [15.357297652539758, -1.1144759877986758],
            [15.368211886661728, -1.1159182654416622],
            [15.369573530239197, -1.1186192641927915],
            [15.36770612092102, -1.1262928307424107],
            [15.370319397197223, -1.129690513548454],
            [15.379162195607915, -1.1284129183526708],
            [15.38030346206972, -1.130752384282952],
            [15.37183178932889, -1.1342065252681817],
            [15.374120993593964, -1.137140956967208],
            [15.381614367481596, -1.138138658611118],
            [15.386156124527496, -1.137437282219317],
            [15.390583922010881, -1.140787478656165],
            [15.390822275675006, -1.1434999183046568],
            [15.38414662872962, -1.1513904611479029],
            [15.381252419591968, -1.152908627410086],
            [15.37618886354219, -1.1521516522706081],
            [15.363284502258356, -1.1533554037374625],
            [15.356782078356629, -1.1557369069093553],
            [15.350414197060001, -1.1596118085134808],
            [15.344946903298142, -1.1659046645602762],
            [15.328940771259367, -1.1714647434946208],
            [15.327610118145753, -1.1732844287138346],
            [15.326409867772282, -1.181063303308745],
            [15.324975129424473, -1.183809031452455],
            [15.320182496027135, -1.1865078732366763],
            [15.32118556635302, -1.191329228946036],
            [15.318802843922935, -1.1951811058832786],
            [15.313298262241982, -1.1997442557931024],
            [15.275267522243103, -1.268752294509719],
            [15.270211784837448, -1.2676668503197852],
            [15.260968949468023, -1.2729800986390125],
            [15.255296882618051, -1.2723828879572696],
            [15.248054692498929, -1.2656877677872655],
            [15.242728002998701, -1.264936061908936],
            [15.244836879790293, -1.260243203309851],
            [15.243239897610081, -1.2583815141900296],
            [15.236789109950557, -1.2564035572479242],
            [15.230275046717626, -1.252475127053352],
            [15.219125813417499, -1.252439284125526],
            [15.212054198224372, -1.247506761885192],
            [15.178610161563832, -1.2551283179015629],
            [15.172933731832508, -1.251560331607808],
            [15.171265707509951, -1.2465562817872662],
            [15.16749285327267, -1.2464112662854454],
            [15.156244899954155, -1.2347928718840466],
            [15.159188928862585, -1.2315183677802573],
            [15.16483586050635, -1.2223639419042396],
            [15.157229444405273, -1.2159673591141722],
            [15.155913046603597, -1.2041791849804617],
            [15.144458103115255, -1.1996628305001165],
            [15.139536844526104, -1.1989579659729412],
            [15.13587508654531, -1.2031946585770872],
            [15.132559338917758, -1.2044733510873138],
            [15.129600419104712, -1.2021452006513833],
            [15.122658922859825, -1.202575384463916],
            [15.118618266166374, -1.2039761963723803],
            [15.11408899089927, -1.2011587209965315],
            [15.096438187254163, -1.1986963705718057],
            [15.095169427376785, -1.1957942539824553],
            [15.088302341109168, -1.1981030160050925],
            [15.082744424962792, -1.1964694724342326],
            [15.078981312571791, -1.1977233284228608],
            [15.07488777001578, -1.1944648667475304],
            [15.073986936531567, -1.1875471617008095],
            [15.071573115764512, -1.183697683537806],
            [15.067451831416756, -1.1833759547155103],
            [15.066858438852258, -1.1793687147179739],
            [15.06305090570077, -1.1786152522656537],
            [15.059653890157646, -1.1742369861773236],
            [15.055089246995367, -1.1770264567614288],
            [15.050739055332226, -1.1753214807535117],
            [15.04300760881681, -1.1770919790360537],
            [15.039349568644479, -1.1792200611145338],
            [15.036629061592354, -1.1748785915318662],
            [15.033010583972628, -1.1737979159667642],
            [15.035700223904145, -1.168845515705305],
            [15.032368025171323, -1.1667959337740896],
            [15.023339825585886, -1.1658914836039018],
            [15.01964771383185, -1.1688827939556543],
            [15.014363605450956, -1.1676408434268286],
            [15.00891534951928, -1.175246744046707],
            [15.005240477147236, -1.177389704882642],
            [15.002315415060089, -1.1767133640535488],
            [14.998318545917884, -1.182309285091027],
            [15.002955922817035, -1.1863267638086332],
            [14.999742895333798, -1.1903882317517882],
            [14.995348127374827, -1.1871139357105605],
            [14.990669992158592, -1.1864770753778642],
            [14.99100830467559, -1.1820974898221757],
            [14.988850196578776, -1.1785100060794031],
            [14.983446213397684, -1.1730464566190677],
            [14.979476256469395, -1.172416287639635],
            [14.97587526716531, -1.1745875736206306],
            [14.973543905978106, -1.171680115735365],
            [14.970512819171185, -1.171979337825673],
            [14.97120454806332, -1.1770210294389263],
            [14.96842845377068, -1.181073202273567],
            [14.956159327758838, -1.1863897580441525],
            [14.950513957489726, -1.1920279012936161],
            [14.941673292691151, -1.1900091738064482],
            [14.93647789149169, -1.1916979201437643],
            [14.931020961281144, -1.1878677442539842],
            [14.932298005621341, -1.194896850442471],
            [14.930205361423232, -1.1993254915558373],
            [14.92530826011838, -1.1988637800777104],
            [14.918646250586788, -1.1948426744547755],
            [14.911560199491198, -1.1954082460815254],
            [14.91009684459866, -1.1969669330554624],
            [14.903278438094286, -1.1969865594094735],
            [14.899000488297197, -1.1983604752413612],
            [14.891945109571584, -1.1988010625295331],
            [14.887524491510478, -1.1966878392688216],
            [14.883454953804724, -1.197786256521697],
            [14.879692531581117, -1.201829310429892],
            [14.8737457335118, -1.20503975418893],
            [14.86919613685271, -1.2018075701185709],
            [14.866350375478712, -1.2043636311498578],
            [14.862073366531805, -1.1991926428558497],
            [14.85392977290003, -1.1951161775314532],
            [14.853286279323617, -1.189049241992409],
            [14.845003262207147, -1.187973101664639],
            [14.841453240007874, -1.1904789008439058],
            [14.834975483719269, -1.1882596513132255],
            [14.836166328823717, -1.1729861086226],
            [14.830227675759913, -1.1666569740095158],
            [14.829467040963653, -1.1725984943447179],
            [14.825087570497162, -1.1740619027168921],
            [14.822798021144274, -1.1705345301510655],
            [14.816150845141497, -1.1658597133392095],
            [14.813575940719938, -1.1686176792642118],
            [14.81554552758496, -1.1719406030447477],
            [14.81535113786122, -1.1762303727074168],
            [14.810334596145536, -1.1789426288033882],
            [14.794331348793936, -1.1677029678425996],
            [14.789961437089843, -1.1694132206709402],
            [14.791886487719538, -1.1737994137171002],
            [14.795629843138986, -1.1784016881387966],
            [14.794873761689772, -1.1845345737248445],
            [14.787572021192943, -1.1846236132435755],
            [14.78369354641668, -1.1821873411434956],
            [14.784084048127294, -1.1777391399709767],
            [14.779917629872873, -1.1755778734753197],
            [14.777743491101013, -1.1793024707363329],
            [14.772275840529502, -1.1740734142338787],
            [14.770480438392196, -1.1694185614908792],
            [14.762586580485657, -1.1654379872853693]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.65164376700656, "lat": 36.25745394648527 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37083"],
        "coty_name": ["Halifax"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Halifax County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01008559"
      },
      "bbox": [
        14.762586580485657, -1.2729800986390125, 15.390822275675006,
        -0.8348878949133169
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.42585213203481, -1.208350061658669],
            [12.476320305714355, -1.2029249889942657],
            [12.502784886360613, -1.196943373013825],
            [12.526632163880379, -1.1936119878745903],
            [12.560320516632668, -1.1860737807327257],
            [12.580367575411735, -1.1828536392124342],
            [12.621299284313114, -1.1793671300633068],
            [12.653943404436935, -1.1754233394609792],
            [12.789955401028472, -1.1604834941758395],
            [12.793429014436176, -1.1889631344803389],
            [12.801280249084881, -1.2568542826168765],
            [12.807512866456872, -1.3056948573489882],
            [12.817246408877649, -1.3724737547503574],
            [12.828393975499708, -1.4498778442484153],
            [12.831083161024852, -1.4697495863216785],
            [12.823160532284863, -1.4640069031736387],
            [12.821164381447822, -1.4566401716947204],
            [12.817005277245174, -1.453489711611761],
            [12.80871189509236, -1.4539820109552488],
            [12.804761011309736, -1.4593759557551247],
            [12.789839067736809, -1.4589478329925838],
            [12.766007918673642, -1.4637235889889189],
            [12.761355164186902, -1.4612169654764668],
            [12.760555975369668, -1.4487487839211313],
            [12.758298543939334, -1.4425521006104114],
            [12.755442813010626, -1.4403649678145347],
            [12.748757769574656, -1.4385317017547656],
            [12.744898767584647, -1.4420899617963796],
            [12.740047031388663, -1.4424729778055112],
            [12.732128516824837, -1.4457312239195241],
            [12.725011500373903, -1.450294029675215],
            [12.715994722949223, -1.4598056980823555],
            [12.711022516023485, -1.4589661027942868],
            [12.705850625932305, -1.4554779009505483],
            [12.695852099917508, -1.45235926436922],
            [12.688445751342242, -1.4469618665465553],
            [12.685141710887502, -1.4463690035783074],
            [12.683213382599613, -1.4504777592559344],
            [12.688618887515107, -1.4576385830915448],
            [12.687329674300551, -1.4612423225439797],
            [12.675977011319862, -1.4634856946767285],
            [12.673696228399303, -1.4736855308905552],
            [12.674731108542273, -1.4793690589181807],
            [12.671102315957722, -1.4847416833949736],
            [12.65835655589813, -1.488451741299135],
            [12.654696530278992, -1.4871147793484218],
            [12.651857859640286, -1.4835320144435793],
            [12.64781424320371, -1.4751867542078907],
            [12.64381666095015, -1.4727040421272763],
            [12.635752330041496, -1.4764900382987494],
            [12.621712960524157, -1.4783717695783778],
            [12.616057518608446, -1.4759276185784835],
            [12.608336496306727, -1.48020885577735],
            [12.604431583703223, -1.4784421970261585],
            [12.604858909474315, -1.4704506379799023],
            [12.600392612546875, -1.4678772511756166],
            [12.597236890771, -1.4710102001976444],
            [12.59624861078217, -1.4785904709661373],
            [12.591267779948435, -1.4867879649405351],
            [12.58705362830607, -1.48514304643778],
            [12.584352276958903, -1.4817946891240696],
            [12.576465293009552, -1.4772267183576455],
            [12.572497425401483, -1.4781652211753076],
            [12.569126524499847, -1.4817168411882815],
            [12.568631769647759, -1.485985508269659],
            [12.57176576212483, -1.4964623991755543],
            [12.568013828505213, -1.5012537969040702],
            [12.55839043121144, -1.5077872924908036],
            [12.553633575918084, -1.5038251023862084],
            [12.548539655502118, -1.5028524313987968],
            [12.541337539559278, -1.5079415806339038],
            [12.536147566720265, -1.5092800967482094],
            [12.528225076784437, -1.5157479541566308],
            [12.517771469896012, -1.5216721057157883],
            [12.51291294741241, -1.522399596888796],
            [12.503162107560032, -1.5262892643336499],
            [12.50027628499905, -1.5290466701254803],
            [12.489369397615633, -1.4386720330025196],
            [12.472957346216925, -1.4287960528210213],
            [12.467880665236695, -1.4273010107386617],
            [12.459157565837327, -1.4138925742815096],
            [12.45464961160956, -1.4088227234036639],
            [12.449155799706675, -1.4073495074356577],
            [12.446211634988414, -1.404254893760512],
            [12.44226026039463, -1.4045007392094526],
            [12.44107391983787, -1.4072945177371423],
            [12.43355137290005, -1.406229505483661],
            [12.432201925476514, -1.4039842824445068],
            [12.424022182665366, -1.4009406854304658],
            [12.414813671182767, -1.3923049065301336],
            [12.409839597933997, -1.3887942727271874],
            [12.410768551486518, -1.3825296717815345],
            [12.408222637316989, -1.3791720759708426],
            [12.40181933405651, -1.3781383810485996],
            [12.399799436884214, -1.3757666498108747],
            [12.412808470877136, -1.3562623058712542],
            [12.390119115591803, -1.3303961104310795],
            [12.38651154247619, -1.3253012690417092],
            [12.393272176717895, -1.3182937978153872],
            [12.413918530832506, -1.2750096118224594],
            [12.415579800974236, -1.2719853825845935],
            [12.416083994803833, -1.2466105722815204],
            [12.419388310137562, -1.247854329137703],
            [12.42585213203481, -1.208350061658669]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.68794617535109, "lat": 36.41457564641964 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37171"],
        "coty_name": ["Surry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Surry County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "01008587"
      },
      "bbox": [
        12.38651154247619, -1.5290466701254803, 12.831083161024852,
        -1.1604834941758395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.35146834523262, -5.329383946897351],
            [8.350042028111947, -5.307719740879414],
            [8.34767893455613, -5.303948125824309],
            [8.345275480652749, -5.295725049677904],
            [8.345566000615856, -5.293294153251578],
            [8.354838669630269, -5.284900684742942],
            [8.356116184407952, -5.281404278243734],
            [8.354893340632355, -5.277444274021119],
            [8.351272304383789, -5.271728242750891],
            [8.349260403539814, -5.263830068387035],
            [8.351287858348893, -5.2585685819744],
            [8.363346732744759, -5.249044610906569],
            [8.365003596853404, -5.24506647409208],
            [8.441378769653657, -5.23650691758236],
            [8.4556185462128, -5.235910426160973],
            [8.510403445186645, -5.229562328365342],
            [8.563530183238816, -5.223590506674615],
            [8.565197611413057, -5.223702695900899],
            [8.627050755937793, -5.216970757542641],
            [8.668615792227456, -5.2123648719997036],
            [8.763655640434541, -5.202487191298425],
            [8.765292767325665, -5.216810172116379],
            [8.773447227582373, -5.288317430468395],
            [8.778095586903797, -5.3308931141432305],
            [8.790434143225397, -5.442091895095467],
            [8.794339763198591, -5.478199006470221],
            [8.790298278146295, -5.478436120864247],
            [8.791822223730012, -5.482648637069838],
            [8.790211563953749, -5.486670589144057],
            [8.79619733858016, -5.4936851669512015],
            [8.797433256967265, -5.503583842866732],
            [8.800218497940154, -5.504433122259261],
            [8.798063402540349, -5.509369061652622],
            [8.802338649987517, -5.550652165491964],
            [8.757593199105438, -5.55539555147258],
            [8.69509302932202, -5.562529756154686],
            [8.643810115215539, -5.568108056502436],
            [8.636362951877206, -5.569372082757798],
            [8.615914080304107, -5.571522231057448],
            [8.542790695513254, -5.578778227292919],
            [8.541608074717631, -5.5646684167985825],
            [8.527000455725002, -5.565858185373152],
            [8.528403801712383, -5.5801548438497],
            [8.496648079174232, -5.5835771839708075],
            [8.485397246612225, -5.58072609279111],
            [8.477596531621856, -5.576076263360528],
            [8.474839502439021, -5.57114750502822],
            [8.46895356691155, -5.5668470779136765],
            [8.466250612048402, -5.563366731068342],
            [8.461180564760046, -5.552334167293553],
            [8.456383925007062, -5.54999622946657],
            [8.449320653550133, -5.549980392906587],
            [8.444184598436438, -5.545168911224172],
            [8.434232986591562, -5.538639710564438],
            [8.433292762437564, -5.536156643743456],
            [8.435724635341042, -5.532439187261874],
            [8.432364682315505, -5.5299072038818],
            [8.422326480090682, -5.53035686245064],
            [8.420400900960164, -5.525599210053209],
            [8.41729879951647, -5.511169320226965],
            [8.419100875019312, -5.501547525511548],
            [8.42120709670111, -5.497448019554355],
            [8.426212193034718, -5.492648784997537],
            [8.426704560684612, -5.489548430816203],
            [8.421865981941588, -5.480285217770973],
            [8.415820630453416, -5.4762239739716465],
            [8.404759400790415, -5.475861692280789],
            [8.39838078494319, -5.473612225980228],
            [8.39584917573798, -5.469335775735628],
            [8.394040135858004, -5.462707947019859],
            [8.387772958600767, -5.451353499347477],
            [8.38526744684472, -5.441744562684949],
            [8.37807607777387, -5.436388572441699],
            [8.373405821002128, -5.436208481036134],
            [8.370201174532761, -5.4310538161708095],
            [8.365997474525456, -5.426873438143424],
            [8.361759567807423, -5.420189487634886],
            [8.362652209442885, -5.413853690048462],
            [8.360186356171626, -5.406438042986081],
            [8.359931310636451, -5.395834810312586],
            [8.355752296430026, -5.37940911145329],
            [8.360082181196516, -5.372534555567285],
            [8.360570552452312, -5.363907133074231],
            [8.358617602822578, -5.359699679957379],
            [8.35093951827503, -5.350024172831994],
            [8.34899378166944, -5.3459143400965585],
            [8.35146834523262, -5.329383946897351]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.24766921354183, "lat": 32.93626048742867 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01037"],
        "coty_name": ["Coosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coosa County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00161544"
      },
      "bbox": [
        8.345275480652749, -5.5835771839708075, 8.802338649987517,
        -5.202487191298425
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.436409539344382, -6.0010702561808325],
            [8.441115831143525, -5.998254160050894],
            [8.44128727225101, -5.992289069550972],
            [8.438033926882985, -5.983674101176977],
            [8.438486087858065, -5.980875436960552],
            [8.442857995567577, -5.97785514203407],
            [8.45118216668722, -5.9795155399563695],
            [8.45682466311129, -5.970088189479677],
            [8.461675528254425, -5.964680030246787],
            [8.46058078305915, -5.954508084087352],
            [8.462703174523664, -5.946841877951334],
            [8.460142672743492, -5.939367138722974],
            [8.46201891187325, -5.936909637895295],
            [8.466892502541645, -5.937348952136546],
            [8.474341491334936, -5.941594332257196],
            [8.49049587837655, -5.937362483283529],
            [8.501349348003545, -5.928731647510955],
            [8.512181571007265, -5.924741157676094],
            [8.513483173505938, -5.921399207576495],
            [8.509496033596447, -5.913823634516299],
            [8.511746956064982, -5.910285338028165],
            [8.51729070615404, -5.910261878561722],
            [8.523120103537197, -5.908845018689081],
            [8.531335540642488, -5.9049999834671345],
            [8.543916401607774, -5.903625499740262],
            [8.547161654899364, -5.90103882828422],
            [8.55475426754862, -5.900516605923675],
            [8.560467012801242, -5.902816454509945],
            [8.565239039183778, -5.906437942531067],
            [8.578082156730785, -5.912108125411679],
            [8.58052660823658, -5.918105660342222],
            [8.584157780619597, -5.919109562271283],
            [8.586385002092866, -5.916720469195931],
            [8.587636695026442, -5.910535877054306],
            [8.582272978722195, -5.900157422344431],
            [8.577392124909379, -5.893882594423657],
            [8.57082475192721, -5.891042362308028],
            [8.571579196794625, -5.885236850517656],
            [8.576814344683289, -5.8811855749422355],
            [8.580342302146502, -5.870628242029404],
            [8.581816273222014, -5.861956614731035],
            [8.580041216185853, -5.853186085066729],
            [8.57562369940297, -5.847261447273073],
            [8.575063142618735, -5.841808976460864],
            [8.578161057259543, -5.840161328945872],
            [8.581640686805306, -5.8413395989504755],
            [8.58892950786282, -5.852649901208104],
            [8.595930424733908, -5.85613942711196],
            [8.597305456281411, -5.851626003838201],
            [8.60064219706729, -5.848416649889788],
            [8.6047197702791, -5.841740558197158],
            [8.61097685438837, -5.843325793006196],
            [8.61805911285565, -5.839885536500858],
            [8.618955863903427, -5.836487267986128],
            [8.614887305791912, -5.834846842019545],
            [8.616513466339063, -5.8247918468084805],
            [8.625351090849128, -5.825608111974321],
            [8.630081953695369, -5.829713503386953],
            [8.638010382167254, -5.829338309856568],
            [8.637134615427048, -5.836975715165154],
            [8.640793916155527, -5.8379470365703785],
            [8.641983053527225, -5.833628380984995],
            [8.644934942978969, -5.834291941419328],
            [8.652654189107098, -5.8430582931352735],
            [8.648893944563977, -5.844500367294755],
            [8.647412814771137, -5.8479790795510835],
            [8.649501795208481, -5.854701462601112],
            [8.654974248995297, -5.853513988367891],
            [8.657761507595499, -5.848294949917784],
            [8.661751807672912, -5.849447547884633],
            [8.661928522017257, -5.8542172331193285],
            [8.665157308680193, -5.859539847632785],
            [8.668591913414843, -5.862943520354331],
            [8.672024829940595, -5.869126678266678],
            [8.675056173363611, -5.86937777445702],
            [8.680130679466535, -5.863774813427448],
            [8.68221804316387, -5.863695489135771],
            [8.689090331685103, -5.873359896805651],
            [8.683477586140052, -5.8774590601360135],
            [8.679494006105399, -5.878966539299074],
            [8.67915178659554, -5.881645408770594],
            [8.683688643259577, -5.887499947985504],
            [8.6900480531131, -5.883966534767687],
            [8.69356871944249, -5.878470938703244],
            [8.703591562503709, -5.878864152744882],
            [8.708088542343212, -5.882500305911834],
            [8.713416050429869, -5.882547856531045],
            [8.712743393929529, -5.886665905222384],
            [8.714076179014828, -5.8902044605415265],
            [8.71710440450288, -5.891931542094801],
            [8.72337561748433, -5.889302558731492],
            [8.726303507600006, -5.885964500914511],
            [8.731703106412779, -5.884568397982629],
            [8.737484957848446, -5.880354730098634],
            [8.738642584930512, -5.882099083613215],
            [8.734510244449048, -5.891432248142859],
            [8.739319213538613, -5.894503403899145],
            [8.742827504334704, -5.890336277578567],
            [8.745778293289527, -5.890955162949295],
            [8.746876498365156, -5.896498620190718],
            [8.750470736156434, -5.896875570131995],
            [8.753339906143262, -5.894704104779597],
            [8.76578522226781, -5.892786584072801],
            [8.769765235860687, -5.889480141760358],
            [8.780265142241568, -5.898165048096956],
            [8.794418841286836, -5.900373154005194],
            [8.798973987999824, -5.90007141541758],
            [8.806409622853867, -5.901237212752259],
            [8.808405238965472, -5.898454089923856],
            [8.807082697799316, -5.894184614771279],
            [8.808390254489339, -5.8891834342359815],
            [8.81514690990085, -5.8836108455441165],
            [8.81963586847612, -5.883488743601386],
            [8.824484879273454, -5.885434622895326],
            [8.827831036331187, -5.895097609482204],
            [8.832571665819854, -5.895390968037775],
            [8.83621581642572, -5.899961637299981],
            [8.834350230064954, -5.907364933576891],
            [8.837263834785379, -5.914733282399683],
            [8.835158414121187, -5.9187081171848215],
            [8.845991492156772, -5.931827508265702],
            [8.84983038445743, -5.940615182827953],
            [8.855543449977997, -5.944594158201423],
            [8.855058486218645, -5.950773836242787],
            [8.859585454634708, -5.960677837283084],
            [8.858181090231149, -5.9623729077795415],
            [8.86223251318922, -5.967295103949841],
            [8.878646368954898, -5.966654364309052],
            [8.88215782594162, -5.975045079483662],
            [8.888131805242208, -5.9752638701826815],
            [8.88892694944597, -5.981445042108494],
            [8.891627795531717, -5.982538625056671],
            [8.89091849805722, -5.987064541756019],
            [8.893356772011037, -5.990988894011006],
            [8.8943250292404, -5.996515040405099],
            [8.898770556602024, -5.999935775781693],
            [8.899732894727858, -6.002693525345443],
            [8.9036295892314, -6.004572341042325],
            [8.907363825788973, -6.0099789193689706],
            [8.912028678715313, -6.010098201370167],
            [8.921944921464718, -6.0129472005605304],
            [8.926609227570145, -6.017789972825757],
            [8.926573460075334, -6.021082295741649],
            [8.870530248853203, -6.029046782553076],
            [8.872834029211356, -6.0506239235181605],
            [8.86224655794283, -6.052196948806838],
            [8.864076737936871, -6.0671904551145515],
            [8.87488042842638, -6.159984289319474],
            [8.885283809473123, -6.249867994100102],
            [8.895180788728362, -6.332685702885251],
            [8.888615846307141, -6.333641909876998],
            [8.789349013408343, -6.344050483699134],
            [8.78660666986258, -6.34481566689693],
            [8.730859050265105, -6.350875772458338],
            [8.67888034523334, -6.356671881970857],
            [8.63790845477547, -6.361782337465907],
            [8.630114527545688, -6.290077510260702],
            [8.627871223880565, -6.275863241372429],
            [8.592972297926343, -6.279694111529308],
            [8.541823702262281, -6.285509641332573],
            [8.539888982409984, -6.270773057406208],
            [8.536772118324691, -6.239333042679522],
            [8.530722092389711, -6.189356776851862],
            [8.52578986848585, -6.142886339069227],
            [8.52061628409779, -6.0988397647503065],
            [8.520129911022725, -6.093282918988239],
            [8.514914029337644, -6.0911677366787895],
            [8.507827549866269, -6.090562413375062],
            [8.507906594994626, -6.085061083302597],
            [8.503352357354903, -6.082066876556829],
            [8.500049849653957, -6.083042666739573],
            [8.491132195275087, -6.078388270163633],
            [8.48472031550276, -6.077465161414224],
            [8.484572646788019, -6.072915792022201],
            [8.475489032670934, -6.067844309940922],
            [8.471062031476729, -6.069264154618437],
            [8.465787179467021, -6.072916505153246],
            [8.459904239636241, -6.070683750943179],
            [8.458876393007579, -6.068267829203539],
            [8.453224793443484, -6.067758570214647],
            [8.456199148141904, -6.063021800592906],
            [8.452449083948355, -6.062489242256017],
            [8.447496465268358, -6.051292267658052],
            [8.44935883681058, -6.047130652831855],
            [8.44921509977551, -6.043180349137373],
            [8.445490646534584, -6.043184499210602],
            [8.446497658245029, -6.039214715118182],
            [8.450348277107256, -6.038010281600484],
            [8.449438499343957, -6.031847502670772],
            [8.453237319832274, -6.02886353735123],
            [8.454336492237598, -6.023145876079474],
            [8.45743211574973, -6.018084545494326],
            [8.452845466819413, -6.0127653200635045],
            [8.448293705190373, -6.0112557217214775],
            [8.448621415815222, -6.00399803749747],
            [8.444527804606198, -6.006133326804764],
            [8.44317431053049, -6.002490191387366],
            [8.438684593452571, -6.0068523105668294],
            [8.436409539344382, -6.0010702561808325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.2076002944217, "lat": 32.220240962699954 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01101"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00161577"
      },
      "bbox": [
        8.436409539344382, -6.361782337465907, 8.926609227570145,
        -5.8247918468084805
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-22.818023858923947, -12.569172455548903],
              [-22.81705307455825, -12.569157135259914],
              [-22.81140074486657, -12.571559928523335],
              [-22.809411326653123, -12.573332216889467],
              [-22.80637729102171, -12.573098506601108],
              [-22.79652251695696, -12.567580184958572],
              [-22.793392976505764, -12.566750837311126],
              [-22.784428983596445, -12.567424762737748],
              [-22.779195544846537, -12.569092960241752],
              [-22.776511258094605, -12.571413439223148],
              [-22.77073169525169, -12.58043043805145],
              [-22.76142877042141, -12.59681202692213],
              [-22.761654672651293, -12.59984135264788],
              [-22.762388326581707, -12.600838047798812],
              [-22.765861696995785, -12.603522861273433],
              [-22.767645111595392, -12.603156905610126],
              [-22.772178236131197, -12.609657023006768],
              [-22.77551673618342, -12.612784411249939],
              [-22.777722604710767, -12.613411600743607],
              [-22.79936466888115, -12.617079142509096],
              [-22.801683393245742, -12.616771604622526],
              [-22.806654720384795, -12.614795575039066],
              [-22.821795655502285, -12.599369525606905],
              [-22.825926036194087, -12.588632399880254],
              [-22.825545602515653, -12.582816979834888],
              [-22.818023858923947, -12.569172455548903]
            ]
          ],
          [
            [
              [-23.036774289837094, -12.605251421001961],
              [-23.029943246137943, -12.600628009263666],
              [-23.025642497879485, -12.600866663766363],
              [-23.023738322337422, -12.60274183045802],
              [-23.023712690889848, -12.606132004967979],
              [-23.02289907650419, -12.608525435236757],
              [-23.014889001270255, -12.616261311415212],
              [-23.005214733178025, -12.620106766275573],
              [-23.001325542568747, -12.621162188407872],
              [-22.990784071375817, -12.63002696099081],
              [-22.98410342337606, -12.635888494268709],
              [-22.98234185374936, -12.640097140007144],
              [-22.984111169722976, -12.643271600978464],
              [-22.98468139680963, -12.64629105238771],
              [-22.972830801236494, -12.663721083172938],
              [-22.96537600774097, -12.686790981232063],
              [-22.962198894943405, -12.69293025698165],
              [-22.955890238587443, -12.701495337892595],
              [-22.952338783838528, -12.70475213231256],
              [-22.9495818478368, -12.705836481008244],
              [-22.94721616254883, -12.707515282576756],
              [-22.945056094411992, -12.717270069096434],
              [-22.94531643641904, -12.722696055727704],
              [-22.946068422222815, -12.726265314423706],
              [-22.945380086637925, -12.72795832071809],
              [-22.940300889534196, -12.731459225056065],
              [-22.91577434001151, -12.74215029061625],
              [-22.913345264855934, -12.744570331689248],
              [-22.904109957566735, -12.75736137333027],
              [-22.903750084568212, -12.759184284410823],
              [-22.908149867366625, -12.759761112710045],
              [-22.91919472132837, -12.757307919434119],
              [-22.92092813888299, -12.756013055722129],
              [-22.92154095396357, -12.754578474396224],
              [-22.924126800737945, -12.750698778560228],
              [-22.947332395131742, -12.74629719489131],
              [-22.95306497679408, -12.736913371002954],
              [-22.952064964874047, -12.733378288333167],
              [-22.95361975542207, -12.730551671319931],
              [-22.96915707230333, -12.706608747851769],
              [-22.974681080953292, -12.699016289758596],
              [-22.976634945399987, -12.689457707351508],
              [-22.978289151027962, -12.681834661809386],
              [-22.982567923212983, -12.667484313446591],
              [-22.984586791001625, -12.662668816387082],
              [-23.001212843120616, -12.642085554105552],
              [-23.003320316320455, -12.64049396985947],
              [-23.01137805603136, -12.63897245369373],
              [-23.013905255275624, -12.639220663713237],
              [-23.016780592690143, -12.63642525954446],
              [-23.026792109856206, -12.625854911166458],
              [-23.036933199804896, -12.610122249743926],
              [-23.037165021230344, -12.609355737208478],
              [-23.036774289837094, -12.605251421001961]
            ]
          ],
          [
            [
              [-23.02464490819781, -12.483912425916955],
              [-23.020038274585918, -12.482315658468206],
              [-23.01706679423883, -12.48370369907887],
              [-23.00428669569871, -12.494228177459913],
              [-23.001538874998754, -12.497596292171703],
              [-22.999527962574906, -12.504177491787862],
              [-23.000801544272008, -12.506303720550742],
              [-23.008057695381012, -12.510445446755242],
              [-23.01680574449391, -12.515124770351289],
              [-23.021374727815545, -12.514461458143499],
              [-23.02464352254027, -12.513102294477749],
              [-23.026715456454163, -12.50840495236187],
              [-23.02700047501027, -12.50020847540567],
              [-23.025605434068314, -12.490083954217251],
              [-23.02464490819781, -12.483912425916955]
            ]
          ],
          [
            [
              [-23.08746596818365, -12.512553568975015],
              [-23.074735621186132, -12.520469250164462],
              [-23.072834842448966, -12.523525607597852],
              [-23.070831087296554, -12.52762739675808],
              [-23.06815275843238, -12.541003708076806],
              [-23.067921458515954, -12.544907497519358],
              [-23.069320470720374, -12.541015796614271],
              [-23.069906739289454, -12.540320744081901],
              [-23.075145305251297, -12.538958582826275],
              [-23.076051671996552, -12.539162879111233],
              [-23.07908018161405, -12.536963938906762],
              [-23.08111941113468, -12.534182203524706],
              [-23.087195290651383, -12.516810997642034],
              [-23.08746596818365, -12.512553568975015]
            ]
          ],
          [
            [
              [-23.08659618127433, -12.436586358042522],
              [-23.082327759099478, -12.433809894957289],
              [-23.079879612197523, -12.43380885207482],
              [-23.079142067525968, -12.432995262203033],
              [-23.07477710940104, -12.435129808789132],
              [-23.070064383223617, -12.44249014613028],
              [-23.06973826508575, -12.443946352782463],
              [-23.071770434209483, -12.454121045990222],
              [-23.076712896813458, -12.456388603807994],
              [-23.085673475746017, -12.454239449756647],
              [-23.08933343395262, -12.448407556060815],
              [-23.089163834259146, -12.446406665694232],
              [-23.08659618127433, -12.436586358042522]
            ]
          ],
          [
            [
              [-23.123602012439033, -12.477847670426435],
              [-23.122271417556988, -12.477859798566197],
              [-23.121074070943195, -12.478953573954675],
              [-23.121424881466105, -12.48050979545449],
              [-23.122467702700284, -12.481191854475316],
              [-23.123952947215837, -12.480732520713994],
              [-23.124255568734004, -12.479271494393542],
              [-23.123602012439033, -12.477847670426435]
            ]
          ],
          [
            [
              [-23.21878469584058, -12.344275186447478],
              [-23.217242893828736, -12.344096431733005],
              [-23.21615132655617, -12.344665638092913],
              [-23.216237561141618, -12.346134695435127],
              [-23.217356147041457, -12.34690088952396],
              [-23.21884795306777, -12.346865073222887],
              [-23.21934876839376, -12.34568802008358],
              [-23.21878469584058, -12.344275186447478]
            ]
          ],
          [
            [
              [-23.2821288701151, -12.400817858287278],
              [-23.274195111400438, -12.399508025258037],
              [-23.26503114649681, -12.399735721701788],
              [-23.26145507800278, -12.40158152291919],
              [-23.246379493016605, -12.395039748523805],
              [-23.244416680161272, -12.392930601000653],
              [-23.2286156314494, -12.393766469490835],
              [-23.214039185230185, -12.398365741365353],
              [-23.210110368672918, -12.396960459438764],
              [-23.2051352885915, -12.390561858996534],
              [-23.201974411851225, -12.383595909556336],
              [-23.185028683264036, -12.367845348396978],
              [-23.178514162231973, -12.36294415221007],
              [-23.168580003497237, -12.361624120935952],
              [-23.16054777033093, -12.374383610962198],
              [-23.160693556777357, -12.3820108717105],
              [-23.1646949430174, -12.386174731596752],
              [-23.167216088614435, -12.387609924276536],
              [-23.168237166506675, -12.386826001753402],
              [-23.170838607833073, -12.386420386767991],
              [-23.173171230029922, -12.386681472044897],
              [-23.18303468636068, -12.39587471539242],
              [-23.186253766477133, -12.398981108508142],
              [-23.192711759600844, -12.400370190878792],
              [-23.204167181934636, -12.405012534116286],
              [-23.20652756651303, -12.407260395595797],
              [-23.206709735071442, -12.411162709759154],
              [-23.20640878981179, -12.412509709901803],
              [-23.20149896116975, -12.416413139599156],
              [-23.200024804536227, -12.417351803488657],
              [-23.19399764265338, -12.418583273448544],
              [-23.19376685776675, -12.420140277939396],
              [-23.19598944915105, -12.424427338533269],
              [-23.198477782616024, -12.427672070374209],
              [-23.199974725740333, -12.428058012542067],
              [-23.208818545786237, -12.426320490685614],
              [-23.22283250050867, -12.417427646261812],
              [-23.236500773375344, -12.408534747802522],
              [-23.24512650843676, -12.408803766290102],
              [-23.25230366596144, -12.411303481077207],
              [-23.261140434862607, -12.418873738239311],
              [-23.261438894168776, -12.419708117228446],
              [-23.26067161376886, -12.42165583785349],
              [-23.263965730167786, -12.428532559532186],
              [-23.268716957098608, -12.432348143915558],
              [-23.271050499172677, -12.432260781131172],
              [-23.27221135454866, -12.430432404453867],
              [-23.272899306501483, -12.42718555471673],
              [-23.27213376641543, -12.426569880016592],
              [-23.271807887726425, -12.424565613083276],
              [-23.274084683297293, -12.419227411851923],
              [-23.279191123912913, -12.410877749023857],
              [-23.2832809828764, -12.407841679992075],
              [-23.284341754673623, -12.405825557356964],
              [-23.282965835990577, -12.401120018746806],
              [-23.2821288701151, -12.400817858287278]
            ]
          ],
          [
            [
              [-23.470244497009578, -12.134646364891053],
              [-23.463289062241426, -12.136197991772809],
              [-23.455945024723842, -12.14245508209851],
              [-23.454178622694275, -12.146563354483472],
              [-23.46204115725495, -12.151651212331805],
              [-23.46863857118439, -12.149121811430533],
              [-23.469979000183958, -12.147728850891777],
              [-23.471138388175618, -12.144261838108982],
              [-23.471951301237286, -12.137573020159302],
              [-23.470244497009578, -12.134646364891053]
            ]
          ],
          [
            [
              [-23.758580473100693, -11.854841983616174],
              [-23.757396072471956, -11.85396598407174],
              [-23.75083130405645, -11.854006214907434],
              [-23.745509539125763, -11.860451017435905],
              [-23.744055059949954, -11.863206212631587],
              [-23.744205154924416, -11.868198454241067],
              [-23.744831789810526, -11.87095245457519],
              [-23.745254275232682, -11.871248343728649],
              [-23.754052302657826, -11.86580556288812],
              [-23.759571543224126, -11.85924333434441],
              [-23.758580473100693, -11.854841983616174]
            ]
          ],
          [
            [
              [-23.776417400962263, -11.837870850037971],
              [-23.771269674878127, -11.841416810109227],
              [-23.76823171264975, -11.84480965609133],
              [-23.76709123738448, -11.850784291634495],
              [-23.77195746258288, -11.852311713314466],
              [-23.776485221084158, -11.846308301689385],
              [-23.77728380184981, -11.842541869911651],
              [-23.777229337611285, -11.83881299683675],
              [-23.776417400962263, -11.837870850037971]
            ]
          ],
          [
            [
              [-23.78887857720859, -11.822328022018112],
              [-23.786266164542717, -11.823709930731656],
              [-23.78377551546497, -11.826242376818177],
              [-23.779497937145962, -11.833529749950811],
              [-23.778987898272444, -11.836379210289545],
              [-23.781170658863577, -11.837267843282838],
              [-23.780970429811287, -11.835991489835612],
              [-23.781675176721954, -11.834779517725112],
              [-23.78768788052812, -11.832329080376917],
              [-23.789492039991618, -11.827114703346096],
              [-23.790217543566836, -11.822236671795528],
              [-23.78887857720859, -11.822328022018112]
            ]
          ],
          [
            [
              [-23.945670841917988, -11.883692703740856],
              [-23.93682178540229, -11.878159340442805],
              [-23.921891477459738, -11.877526231276223],
              [-23.920611981310255, -11.87766586131921],
              [-23.918186610755367, -11.883013922376255],
              [-23.91699193619989, -11.884628349971308],
              [-23.912468570385904, -11.887366657142243],
              [-23.90548874233999, -11.887508030158367],
              [-23.898928405254438, -11.884315484801926],
              [-23.89835480978262, -11.881162546390835],
              [-23.895814303799924, -11.88114271207646],
              [-23.890240496900564, -11.885077989636674],
              [-23.878446236918276, -11.879552352882653],
              [-23.866762811344483, -11.883318390417235],
              [-23.85008176261003, -11.89225190162478],
              [-23.850378229522473, -11.89410254836289],
              [-23.855423020601854, -11.895644874243835],
              [-23.858840361522848, -11.89498699221807],
              [-23.867413377064143, -11.896682100339206],
              [-23.87269339667167, -11.901066657047894],
              [-23.875591570118715, -11.904583235721558],
              [-23.876343883085433, -11.906987942554917],
              [-23.875388378935877, -11.90898320292193],
              [-23.87572375944725, -11.914122560585039],
              [-23.87822704030035, -11.921827836195746],
              [-23.883682860321564, -11.934869019533554],
              [-23.897834694391065, -11.927625905083799],
              [-23.89932128068064, -11.925675247943632],
              [-23.902705540831924, -11.91665476838304],
              [-23.902630823372125, -11.91142574006053],
              [-23.9023976547954, -11.908040758255655],
              [-23.907839561813606, -11.90513837774169],
              [-23.91228113001211, -11.90611098848717],
              [-23.919517088039065, -11.905292104645383],
              [-23.925132701440628, -11.902964422050955],
              [-23.92842966492687, -11.90080564033442],
              [-23.929469116443617, -11.898316904823373],
              [-23.93870221862011, -11.888468873522877],
              [-23.940320218362025, -11.887071114612262],
              [-23.94579312300175, -11.884282514044425],
              [-23.945670841917988, -11.883692703740856]
            ]
          ],
          [
            [
              [-24.026114086801602, -11.638120657079542],
              [-23.982619297163026, -11.632661004767222],
              [-23.979378000085443, -11.632979882876752],
              [-23.959276156680314, -11.641524654664368],
              [-23.89525180511253, -11.682432125799624],
              [-23.892988129709398, -11.684746181778381],
              [-23.891686568385023, -11.686533511448578],
              [-23.88866480348969, -11.693315820183924],
              [-23.888544799725175, -11.698665028816816],
              [-23.884700121076996, -11.708863250144956],
              [-23.879634709560886, -11.709925728487024],
              [-23.876520438421792, -11.711280255865264],
              [-23.87117145899595, -11.720830068006565],
              [-23.86100298425877, -11.757739265975868],
              [-23.86230044983552, -11.762757681154758],
              [-23.86334391594917, -11.762972528100065],
              [-23.865514956669774, -11.762188764593864],
              [-23.8869793422615, -11.752723143185657],
              [-23.88956239897316, -11.74956509711136],
              [-23.895243913483576, -11.735633803896256],
              [-23.89614031256648, -11.735065938079309],
              [-23.90094592071654, -11.735439965234468],
              [-23.90699965012112, -11.73900241265181],
              [-23.914179214615267, -11.745737015795063],
              [-23.916935150545726, -11.747832170951847],
              [-23.922948662184176, -11.748139478215965],
              [-23.924787650263983, -11.747904097915272],
              [-23.927757237749315, -11.746302428275825],
              [-23.948105906214526, -11.730652168620837],
              [-23.97168996434109, -11.731832372610441],
              [-23.984658752124375, -11.714166362875597],
              [-23.987483811811295, -11.699278251441427],
              [-23.982598033911056, -11.69227173122313],
              [-23.980334787568545, -11.687917070789522],
              [-23.980170168236107, -11.682234064239205],
              [-23.99327519734467, -11.656514940108003],
              [-24.004223721298725, -11.652223241280465],
              [-24.01214825275291, -11.650681358008205],
              [-24.020308705628103, -11.6498408203148],
              [-24.027421939454257, -11.643590551062113],
              [-24.026114086801602, -11.638120657079542]
            ]
          ],
          [
            [
              [-19.7048854591758, -12.813371190241316],
              [-19.70335472620212, -12.812139978117472],
              [-19.701001533205172, -12.811978199258903],
              [-19.700658611723494, -12.814272769842498],
              [-19.70295617437081, -12.815464441786023],
              [-19.704895255863544, -12.814219204690609],
              [-19.7048854591758, -12.813371190241316]
            ]
          ],
          [
            [
              [-19.760615195717023, -12.828760463961835],
              [-19.75939067607945, -12.828643587439169],
              [-19.757867534740665, -12.825540100110747],
              [-19.75554617086984, -12.828445542375105],
              [-19.75478865518359, -12.83128459825463],
              [-19.753225942270582, -12.831885575079477],
              [-19.752628223798236, -12.828636997703457],
              [-19.751779192215878, -12.825775162980605],
              [-19.749579599105655, -12.825008252461652],
              [-19.74821099213177, -12.82557380931998],
              [-19.746947796470565, -12.824465920567267],
              [-19.746168031618684, -12.822613636852177],
              [-19.744957819245208, -12.824268438959926],
              [-19.74521787753462, -12.826020803085633],
              [-19.744637956750932, -12.827439593284302],
              [-19.745267369432963, -12.827981908375701],
              [-19.746181862700606, -12.831586350557863],
              [-19.746441824424505, -12.835042811267636],
              [-19.744523896275897, -12.834442112221124],
              [-19.742251422936015, -12.831983780052786],
              [-19.740707993706994, -12.83189889915435],
              [-19.740306752829262, -12.827958370105291],
              [-19.738192788017628, -12.825009903681373],
              [-19.73918335130435, -12.823906462786434],
              [-19.739188427096597, -12.822227978755851],
              [-19.738100986811858, -12.821379692135249],
              [-19.73859331859898, -12.820026586304612],
              [-19.737807673968376, -12.818661954457326],
              [-19.734625590286072, -12.816662484412916],
              [-19.73344224450537, -12.816487969858008],
              [-19.732332045773113, -12.817223618458746],
              [-19.730000312933377, -12.820610091142877],
              [-19.729043460748233, -12.819786471665532],
              [-19.730505124384813, -12.816557859090901],
              [-19.730069296764977, -12.815713193318706],
              [-19.72719235312013, -12.815965938269958],
              [-19.726061281666045, -12.815538497447385],
              [-19.722366446124227, -12.816618040869596],
              [-19.7205174203621, -12.816489697175056],
              [-19.718260368863564, -12.814734076023992],
              [-19.71666991588347, -12.814121498092549],
              [-19.715736530223115, -12.816718391145267],
              [-19.713943403364652, -12.818206409687066],
              [-19.711508548424476, -12.818813636063997],
              [-19.716435502623742, -12.82120847326385],
              [-19.71825750843222, -12.821852618079149],
              [-19.72119577851774, -12.82389966407473],
              [-19.72313570345591, -12.824765593934469],
              [-19.72421075556158, -12.827270043767522],
              [-19.724965108117512, -12.828081961920352],
              [-19.724963212745273, -12.830051861694743],
              [-19.722293225407828, -12.831675372135507],
              [-19.72052537863364, -12.83357421242772],
              [-19.72150906472374, -12.834540057797438],
              [-19.72400453765974, -12.835160909795453],
              [-19.724396777232986, -12.83630619657075],
              [-19.72306048299778, -12.838371348024523],
              [-19.721870156156907, -12.838828712471766],
              [-19.72199001991499, -12.840388443734104],
              [-19.723545212431222, -12.841592566815747],
              [-19.725547963348422, -12.841986085939572],
              [-19.72830821106425, -12.841220856569347],
              [-19.729584105220038, -12.841477441243036],
              [-19.731699926395493, -12.841144396366536],
              [-19.732653968907275, -12.839706550095709],
              [-19.735149177175902, -12.838209235872576],
              [-19.736223309012203, -12.838720664213623],
              [-19.73744208686879, -12.838281125464103],
              [-19.738721452439286, -12.839606848890652],
              [-19.73862095635455, -12.84052551102601],
              [-19.737144471523404, -12.84171747655991],
              [-19.736875077335565, -12.842934794200803],
              [-19.73556376439252, -12.844997345288258],
              [-19.732450518795922, -12.848261857770353],
              [-19.73428473113824, -12.849342596560861],
              [-19.736244131011876, -12.848574534157835],
              [-19.737662463871185, -12.8497061681968],
              [-19.73654175843895, -12.851588946224364],
              [-19.738882836765054, -12.853089216394702],
              [-19.739756510516163, -12.852541747910575],
              [-19.74205538862756, -12.853026552391901],
              [-19.743896688723805, -12.852425083660876],
              [-19.745236495423693, -12.851037111357549],
              [-19.746178101276126, -12.851109826005315],
              [-19.74677973363194, -12.85465465773196],
              [-19.745937763873943, -12.856025492942093],
              [-19.745992682883564, -12.857233591794857],
              [-19.74513884405488, -12.858412109875934],
              [-19.745940903968034, -12.859460459971835],
              [-19.747308602058776, -12.85821327434584],
              [-19.749238742225415, -12.858204158798898],
              [-19.75131182881502, -12.856974582218163],
              [-19.751710796212706, -12.855781266123943],
              [-19.75287164541728, -12.855423962981384],
              [-19.752806049599638, -12.852853288282244],
              [-19.753659475972068, -12.852332464892262],
              [-19.753837793128763, -12.84959600987072],
              [-19.754540861221955, -12.848030717431891],
              [-19.758122340851028, -12.84735373325834],
              [-19.759862846302433, -12.846232224330516],
              [-19.75999513114286, -12.843918498431401],
              [-19.760879884745684, -12.841345977900254],
              [-19.759709435841017, -12.840342292969652],
              [-19.760680769719748, -12.838484751154603],
              [-19.759356333354962, -12.83198373451714],
              [-19.75968620513151, -12.82966021865659],
              [-19.760615195717023, -12.828760463961835]
            ]
          ],
          [
            [
              [-19.80722429849033, -12.779624272346759],
              [-19.805070447726173, -12.77832646354796],
              [-19.805744332400735, -12.780994200313286],
              [-19.806953944295593, -12.782444493485706],
              [-19.80722429849033, -12.779624272346759]
            ]
          ],
          [
            [
              [-19.876306107422668, -12.839032272792414],
              [-19.874176583951737, -12.839194552818757],
              [-19.873347149885, -12.8415750592506],
              [-19.87578880624187, -12.840962578250211],
              [-19.876306107422668, -12.839032272792414]
            ]
          ],
          [
            [
              [-20.108309690390527, -12.926803277510498],
              [-20.107382176559014, -12.925463533729284],
              [-20.104460386137735, -12.925374412477536],
              [-20.103441722512397, -12.926078123941748],
              [-20.10058346921619, -12.926987490734135],
              [-20.099530063528686, -12.925179802521953],
              [-20.098391864542375, -12.924154941924842],
              [-20.09496121892853, -12.922885017157915],
              [-20.09327820138712, -12.92098513768602],
              [-20.091610160857325, -12.921154670701446],
              [-20.089166322457444, -12.920323351980578],
              [-20.08810236302982, -12.919283323457437],
              [-20.085500072469458, -12.91865677586063],
              [-20.084668174684456, -12.917865292060632],
              [-20.084827114645236, -12.91600747040102],
              [-20.083797261014613, -12.914886492970219],
              [-20.08284129904416, -12.914934040258803],
              [-20.08164873428928, -12.916361727557149],
              [-20.08086730070757, -12.916275016777682],
              [-20.079229795200295, -12.914809659976642],
              [-20.080000567062484, -12.913665586000114],
              [-20.07801054223063, -12.912568469515302],
              [-20.074073900829426, -12.909625453946045],
              [-20.072691426661827, -12.910523714220162],
              [-20.07162240399554, -12.910396493950344],
              [-20.070706943848318, -12.90814333260518],
              [-20.0690040308857, -12.908613541095221],
              [-20.067225603867975, -12.908138240649535],
              [-20.066127717357446, -12.909298094045042],
              [-20.066480242217306, -12.912011217946338],
              [-20.065392558891187, -12.912626810876972],
              [-20.064177006304828, -12.911814399364424],
              [-20.06240838192322, -12.908773195028223],
              [-20.059760317577737, -12.908030185317571],
              [-20.058983676075893, -12.909148816769815],
              [-20.05915555891271, -12.91066614739012],
              [-20.060600669608117, -12.912910808441763],
              [-20.06020180886656, -12.915086644956206],
              [-20.058258686995526, -12.915505716228115],
              [-20.05633510424063, -12.912445799139729],
              [-20.05545519833449, -12.912131647509232],
              [-20.05426382680758, -12.913333933330321],
              [-20.052366265079687, -12.913964771732127],
              [-20.051516269879908, -12.91522099419295],
              [-20.052113039785, -12.91694829792284],
              [-20.050263471027048, -12.917569007662761],
              [-20.04916615684026, -12.916829915720486],
              [-20.05034255980647, -12.914719215344588],
              [-20.050006502483633, -12.912545283632998],
              [-20.05151200576359, -12.910910289644587],
              [-20.051791753246903, -12.90972044095575],
              [-20.051088464841424, -12.90880369288783],
              [-20.04879738021118, -12.911040839141913],
              [-20.046737540583816, -12.910669049301864],
              [-20.045212161516556, -12.908391325553497],
              [-20.046271690454027, -12.90716742491374],
              [-20.04585437258337, -12.905921890168798],
              [-20.04417362567901, -12.907566746572419],
              [-20.042370491801957, -12.907561758050335],
              [-20.041981057287384, -12.908477321979351],
              [-20.040092648793372, -12.908907700099856],
              [-20.039905824613996, -12.911137045624958],
              [-20.039183274350226, -12.913474658295808],
              [-20.037842608711962, -12.913498766703876],
              [-20.03617643258761, -12.91282444121252],
              [-20.03505033510675, -12.913740610615296],
              [-20.032208791830776, -12.913869136777507],
              [-20.032695963513977, -12.914731672216368],
              [-20.030118958389394, -12.9180325560856],
              [-20.028305020299978, -12.916056892397972],
              [-20.028051024623053, -12.914975112894883],
              [-20.029751954189283, -12.913894804050573],
              [-20.030834301460942, -12.912052092976909],
              [-20.030987141771572, -12.91049513113377],
              [-20.032109283697586, -12.909801406615241],
              [-20.03280973500349, -12.907715773187254],
              [-20.033893372639508, -12.908039162195687],
              [-20.034013686710612, -12.911363704946798],
              [-20.03505417969716, -12.91088322251292],
              [-20.036973460532643, -12.908083741071176],
              [-20.0400527586138, -12.904656320696168],
              [-20.038684395401468, -12.904784620907883],
              [-20.038048887969424, -12.906094475779161],
              [-20.0364446177194, -12.907624136187922],
              [-20.035026549829126, -12.907638662032035],
              [-20.033482285593507, -12.9068172581717],
              [-20.031180193593315, -12.9073297237293],
              [-20.028698814291836, -12.906154498455443],
              [-20.02766989641337, -12.905007635472117],
              [-20.02592132498158, -12.906096856165735],
              [-20.0250281272331, -12.905710388760822],
              [-20.02461649651747, -12.904242437169891],
              [-20.02305457670494, -12.90357165565277],
              [-20.0223215657809, -12.902020772880954],
              [-20.022408793221736, -12.899911985211636],
              [-20.021842403538965, -12.89854969832658],
              [-20.020225900552838, -12.897496279464038],
              [-20.018724114595486, -12.898067942184035],
              [-20.016306521646605, -12.900790203180136],
              [-20.01444305121137, -12.902294694032271],
              [-20.010452354420416, -12.904174375188155],
              [-20.01032884893907, -12.907569448244825],
              [-20.009018531266754, -12.908937765837996],
              [-20.00854048507209, -12.911493772932863],
              [-20.00589087998349, -12.911800549802136],
              [-20.00506571355689, -12.911251377310585],
              [-20.004790143557447, -12.908968691456838],
              [-20.005041625418492, -12.907024596587073],
              [-20.00480270187452, -12.904071307094148],
              [-20.005514629068816, -12.900215838401769],
              [-20.00426576286068, -12.899456871390749],
              [-20.0034875143904, -12.902513567807825],
              [-20.001508051324112, -12.906252043528804],
              [-20.000220450235016, -12.907246362087651],
              [-20.000059453706236, -12.908778681587945],
              [-19.997833535545414, -12.910500041768561],
              [-19.996735082199617, -12.913252053970547],
              [-19.995366546444917, -12.915319687831794],
              [-19.99473707634236, -12.916920990920163],
              [-19.992200893839865, -12.91607030183766],
              [-19.9918901922676, -12.912392732105754],
              [-19.993426811718127, -12.90930875833993],
              [-19.993250795372937, -12.907130417974997],
              [-19.994560685058133, -12.905271982324047],
              [-19.993440557595026, -12.903305926408217],
              [-19.99444268739306, -12.901189536893082],
              [-19.993723193702802, -12.899808097543506],
              [-19.992531627570475, -12.900167562610555],
              [-19.99177947535557, -12.899112465328495],
              [-19.990224285909473, -12.900035391651771],
              [-19.990404200146095, -12.901990766032542],
              [-19.988351089506818, -12.902471268142577],
              [-19.988467861892264, -12.90461135068095],
              [-19.98625261960669, -12.906992128193618],
              [-19.985812628007622, -12.908529885074117],
              [-19.982912264479694, -12.909693347971212],
              [-19.984551855652946, -12.906247042371367],
              [-19.98472532701666, -12.902943109145754],
              [-19.982298013578138, -12.90381657220433],
              [-19.978959592640727, -12.90445129473819],
              [-19.977231321222312, -12.904300921280885],
              [-19.976741844665025, -12.902554093455048],
              [-19.98062890276642, -12.901393618718377],
              [-19.980743724470752, -12.9002404338404],
              [-19.98195546109953, -12.900222204601546],
              [-19.98286775324848, -12.898764023075175],
              [-19.98504607479869, -12.897915212336565],
              [-19.983851809664767, -12.896922995830568],
              [-19.981433059674192, -12.89661533467987],
              [-19.982081319569424, -12.894742827634623],
              [-19.98339375239421, -12.894237286542491],
              [-19.981965049309697, -12.892481321464757],
              [-19.980640521363487, -12.894265979672284],
              [-19.978837515989603, -12.895212016678673],
              [-19.977533587560856, -12.895149976879347],
              [-19.975530974080566, -12.896233222854828],
              [-19.974856484419835, -12.897496031137653],
              [-19.972819504347534, -12.898904700712738],
              [-19.971258451786557, -12.89955633950117],
              [-19.967742338059743, -12.901771286711538],
              [-19.96418601774001, -12.903305159083853],
              [-19.962969181230918, -12.902807225022453],
              [-19.96177620500619, -12.901076054677059],
              [-19.962690167091232, -12.899251167032798],
              [-19.963871740146068, -12.897987856706987],
              [-19.962441064086736, -12.897065242470168],
              [-19.96151725078845, -12.897983407064832],
              [-19.961357623764417, -12.900397066365649],
              [-19.958112493174863, -12.900492731644162],
              [-19.956735683362425, -12.90154851344773],
              [-19.956428953331073, -12.902885557940962],
              [-19.95454593734752, -12.9033280645953],
              [-19.953130062112024, -12.90235240464],
              [-19.952678007100285, -12.900893777177652],
              [-19.953919010463053, -12.898809175499327],
              [-19.95606908426897, -12.897700800966033],
              [-19.95838891860314, -12.895944854223279],
              [-19.958904154267994, -12.894886513835651],
              [-19.957941017509587, -12.893528428867908],
              [-19.953700629200185, -12.894801091819803],
              [-19.952655316412663, -12.894023745325756],
              [-19.953195103529524, -12.892592798243154],
              [-19.953175768137147, -12.890902839722328],
              [-19.952373824069205, -12.88934208301023],
              [-19.953433596463217, -12.887981111250873],
              [-19.95498394291427, -12.887530208747721],
              [-19.95537768352709, -12.886618961990415],
              [-19.95766594655286, -12.884354460687026],
              [-19.956606175149716, -12.88313921337991],
              [-19.954084601293264, -12.884393991564362],
              [-19.95234009809674, -12.884637732587455],
              [-19.951829918543282, -12.885473414135394],
              [-19.949346607456558, -12.88593495702434],
              [-19.94498615826538, -12.888577798754907],
              [-19.94324619881453, -12.888598258909495],
              [-19.939754713652857, -12.890677284939665],
              [-19.93799966157458, -12.891117282495584],
              [-19.93600452984194, -12.892731948915458],
              [-19.934277715503605, -12.893558524016125],
              [-19.93311365765241, -12.891944607596871],
              [-19.930325525003017, -12.890916378672816],
              [-19.929450301684874, -12.888363779756926],
              [-19.930559200093406, -12.887854490220521],
              [-19.932525640284947, -12.888698612819725],
              [-19.93348526352195, -12.887089516768768],
              [-19.937242013242074, -12.886555187454098],
              [-19.936443856078615, -12.8835224795609],
              [-19.937222990117665, -12.88165430824384],
              [-19.939468089990484, -12.88040756219554],
              [-19.94064373463883, -12.880227299117385],
              [-19.94271852054747, -12.878890922693456],
              [-19.943569405648173, -12.877008445831645],
              [-19.944924536343304, -12.876229135868869],
              [-19.94417781519136, -12.874192924746668],
              [-19.945449984817596, -12.873380728328824],
              [-19.944484306501497, -12.872368294624513],
              [-19.942241957949825, -12.87165447086298],
              [-19.942194453248288, -12.869947964487045],
              [-19.943276730002115, -12.869687600962777],
              [-19.944621898815292, -12.867513328437601],
              [-19.944477097801055, -12.865091557785558],
              [-19.946515225817933, -12.859915669707474],
              [-19.94687900143816, -12.858374585023464],
              [-19.945579460090503, -12.855126896141718],
              [-19.946069049550925, -12.853953603978297],
              [-19.945385457434025, -12.85296102760437],
              [-19.944008639957783, -12.853377434157707],
              [-19.943014673136773, -12.854673953725102],
              [-19.94167200982736, -12.854397803064545],
              [-19.94252061887303, -12.85276269578063],
              [-19.942370608427247, -12.851788253330568],
              [-19.939041235647117, -12.850798980242999],
              [-19.936332018108324, -12.85086293261297],
              [-19.933860821923858, -12.8503659642869],
              [-19.93299397909214, -12.849580599186638],
              [-19.929731503672027, -12.850999305361107],
              [-19.929710455328664, -12.852496327658008],
              [-19.928550497356884, -12.8538478960258],
              [-19.9269649912577, -12.85435212122063],
              [-19.926151777187414, -12.85703117642975],
              [-19.923476140923636, -12.856767543284988],
              [-19.924262189532865, -12.859380886521329],
              [-19.924223214622163, -12.862399813363398],
              [-19.923730953474237, -12.86381749433086],
              [-19.92206382254937, -12.863186133869538],
              [-19.922145808297728, -12.86074645034522],
              [-19.920514700025073, -12.859177835768644],
              [-19.92101811043775, -12.854356735463641],
              [-19.922362672475476, -12.853043702725502],
              [-19.921841092921834, -12.851970254056162],
              [-19.919552917091842, -12.852610032374795],
              [-19.917421184351326, -12.85476034354486],
              [-19.914716868242685, -12.856948070824345],
              [-19.913066727597677, -12.857879011071407],
              [-19.911399135055014, -12.857981284468678],
              [-19.910538947699894, -12.85697304852209],
              [-19.911561835933387, -12.854940219884881],
              [-19.913171624003777, -12.85455566736725],
              [-19.913721206501062, -12.853666432541678],
              [-19.91274973622864, -12.852606573033668],
              [-19.91222562064072, -12.850897688400044],
              [-19.913685330202554, -12.85027291810386],
              [-19.914308769182835, -12.848758190893395],
              [-19.917600715188257, -12.844769585780712],
              [-19.92006720237623, -12.843899723867656],
              [-19.92140664711141, -12.842074526518484],
              [-19.922836254562014, -12.841307812759839],
              [-19.92354549422227, -12.839727322048379],
              [-19.921661675732118, -12.839995498027456],
              [-19.92137746060316, -12.838974829015717],
              [-19.922512404745763, -12.837507510973353],
              [-19.922182699729195, -12.8344181055089],
              [-19.91942865391657, -12.831531271548394],
              [-19.917893246664274, -12.829557034072298],
              [-19.917336816989145, -12.829665061786933],
              [-19.91349955200298, -12.827746409230771],
              [-19.911371460279774, -12.827792443207954],
              [-19.90976276075398, -12.826931580594792],
              [-19.908203900013103, -12.827672958953682],
              [-19.906189517321465, -12.826670411849127],
              [-19.902705522714417, -12.827587754673916],
              [-19.902103561316547, -12.828461309108784],
              [-19.899847229327566, -12.829360580805968],
              [-19.897940685865255, -12.828140678057302],
              [-19.896546133509432, -12.82870244957532],
              [-19.8951346289683, -12.828559376109299],
              [-19.892490588764478, -12.829654253029355],
              [-19.89117284809069, -12.828979608949163],
              [-19.889248428267052, -12.83027742975481],
              [-19.887191129091253, -12.829549382110633],
              [-19.884499090310342, -12.830407446875386],
              [-19.884865981942735, -12.835342876618395],
              [-19.883986810426318, -12.836219517247198],
              [-19.883749830766927, -12.838287588410273],
              [-19.88123404453543, -12.840553732175483],
              [-19.880012882838614, -12.844307450373563],
              [-19.879923714876334, -12.846607870415207],
              [-19.88076627842867, -12.848830761750193],
              [-19.881575763737864, -12.849117086373315],
              [-19.88122701756577, -12.850746579806595],
              [-19.88149066352481, -12.85347882026251],
              [-19.881442695960246, -12.856288597731035],
              [-19.879388489257387, -12.857153354981673],
              [-19.877947592757796, -12.855091622481247],
              [-19.8772802023307, -12.854874416994878],
              [-19.875921657091645, -12.852904038428731],
              [-19.87438647351622, -12.852260588371301],
              [-19.87392863385328, -12.854853644396936],
              [-19.871918645160765, -12.857813363234502],
              [-19.872418538467944, -12.859361133751364],
              [-19.871921595165098, -12.861253434895213],
              [-19.870257364889472, -12.864162266401308],
              [-19.869393325395748, -12.864911534674631],
              [-19.867949460524365, -12.863617807677107],
              [-19.868502865681585, -12.862608128127954],
              [-19.86778690383479, -12.860588608731664],
              [-19.868964548555784, -12.85812018734514],
              [-19.867560286305313, -12.857140562657836],
              [-19.868224557376177, -12.856183256995623],
              [-19.868076109364843, -12.853861403922686],
              [-19.869882078483304, -12.852088506225545],
              [-19.86887346564982, -12.849330980928926],
              [-19.870826362627344, -12.84706303512329],
              [-19.86993065712074, -12.845711957286213],
              [-19.87079147652467, -12.844304220362517],
              [-19.872614333843448, -12.84293610310816],
              [-19.871364410065194, -12.841342705692826],
              [-19.871134160502894, -12.839066911971397],
              [-19.872718407320257, -12.836689320687952],
              [-19.872210215440035, -12.835785321695667],
              [-19.867630386951927, -12.836633617225042],
              [-19.8660715813467, -12.83776049113936],
              [-19.864227618739488, -12.841358352370946],
              [-19.86230403984707, -12.842676092758765],
              [-19.859473513579058, -12.843482039773846],
              [-19.858646387574545, -12.844249291051868],
              [-19.855873799430118, -12.842699667742876],
              [-19.85409257672408, -12.842841740239857],
              [-19.853676941332957, -12.8412605632171],
              [-19.854953405002455, -12.84136056289449],
              [-19.857603076051387, -12.840028328609057],
              [-19.858883441794692, -12.840273657104914],
              [-19.861170511135526, -12.839644129950653],
              [-19.86175575892477, -12.837165280382067],
              [-19.8636745012562, -12.83570222114532],
              [-19.8612521471068, -12.834771421076129],
              [-19.860090367464196, -12.834992110665082],
              [-19.858387460479072, -12.833509540325299],
              [-19.85636411003014, -12.835455318983524],
              [-19.853244602012246, -12.836315101646633],
              [-19.852504293708762, -12.837138499362526],
              [-19.84932196153475, -12.837179262507748],
              [-19.84459955143931, -12.838949906367903],
              [-19.84268832614322, -12.838432071033909],
              [-19.843726706573186, -12.836577126527203],
              [-19.845796677393075, -12.835112863506717],
              [-19.846375919081403, -12.833857081997703],
              [-19.849584532510338, -12.833323663227812],
              [-19.8529953834304, -12.831409319934313],
              [-19.854149123793338, -12.831653941150302],
              [-19.85533316067614, -12.830161126864303],
              [-19.85788891125511, -12.828748923172093],
              [-19.86035998109819, -12.828548175256374],
              [-19.862775282759777, -12.827942512834936],
              [-19.86839256617002, -12.825896813296263],
              [-19.86972184285252, -12.824886981802077],
              [-19.87258132358805, -12.825244045225517],
              [-19.874107338479984, -12.824464487209944],
              [-19.875894282120676, -12.824732822696294],
              [-19.877378743480566, -12.823497377975162],
              [-19.874560683096448, -12.822596719638666],
              [-19.875173320271013, -12.82177213117049],
              [-19.875594284382803, -12.819496272876359],
              [-19.876997497075187, -12.818983754903536],
              [-19.878066042877006, -12.81768147025942],
              [-19.879198509370934, -12.817196562714406],
              [-19.88159085063718, -12.81810389678478],
              [-19.882683477287582, -12.816674681599327],
              [-19.885761490357613, -12.815132525004726],
              [-19.887617802371267, -12.814751549044944],
              [-19.88824447360957, -12.813752936183224],
              [-19.88981257381952, -12.812816934443894],
              [-19.89053668525357, -12.811433749956967],
              [-19.89412237742438, -12.807450239045947],
              [-19.89565597734636, -12.808081403978699],
              [-19.897216677773148, -12.807731643571527],
              [-19.8993517881297, -12.809221909349962],
              [-19.90004294579233, -12.810893671904694],
              [-19.90210974842484, -12.8110555248023],
              [-19.904810175662742, -12.812973120632234],
              [-19.908532508117986, -12.81176440825051],
              [-19.909593390398467, -12.810192361018503],
              [-19.909317428417978, -12.80797663690019],
              [-19.910257310695155, -12.806305941122199],
              [-19.91203273676359, -12.804302368399393],
              [-19.912778820421156, -12.802669653150312],
              [-19.91411199937139, -12.802191110603285],
              [-19.915881862365268, -12.799798050592596],
              [-19.917837393144264, -12.799295644406666],
              [-19.919369102210606, -12.797826577231486],
              [-19.918338158954185, -12.795734588505622],
              [-19.917064653142194, -12.795397425501664],
              [-19.916337173954044, -12.794295178424568],
              [-19.91584349421027, -12.791514424315485],
              [-19.91770887722982, -12.788128344219075],
              [-19.92053661040955, -12.786016992371573],
              [-19.92306907760605, -12.78466970697056],
              [-19.92721635109407, -12.784102971837534],
              [-19.92894278425923, -12.782741753160469],
              [-19.928831880404747, -12.78061839916112],
              [-19.92803160747815, -12.778922561706624],
              [-19.928947191676396, -12.776428591107504],
              [-19.927645848925028, -12.772662993872283],
              [-19.925921054534246, -12.770978701094242],
              [-19.924422840639455, -12.770638485600218],
              [-19.921247550055426, -12.77237955166114],
              [-19.918136721226656, -12.770405228418982],
              [-19.915773348867216, -12.767919726792314],
              [-19.915317126375527, -12.766304677160484],
              [-19.91417223343987, -12.76499414216345],
              [-19.91350440163628, -12.763323314459067],
              [-19.9114172189653, -12.7611987563286],
              [-19.91084749086703, -12.757927700341517],
              [-19.90815541585715, -12.755532365631833],
              [-19.906733433771773, -12.753839115972779],
              [-19.904361942462042, -12.75386234146706],
              [-19.903501556724805, -12.753446023972268],
              [-19.90054359082838, -12.753412279667472],
              [-19.898140541519425, -12.752419606097408],
              [-19.89657117142862, -12.750730527435664],
              [-19.89667913935239, -12.749542622966281],
              [-19.895092793262027, -12.746787379635105],
              [-19.892855487056384, -12.745495356482467],
              [-19.89065139756609, -12.744610156424532],
              [-19.888463215587723, -12.745276319292977],
              [-19.887830229577283, -12.746710831045837],
              [-19.884787270042256, -12.746861134267677],
              [-19.88097426709906, -12.745798925928838],
              [-19.879129333171676, -12.745693062983406],
              [-19.87864633756704, -12.744911561157247],
              [-19.879485428976654, -12.742272456337842],
              [-19.87845783345007, -12.742130302739364],
              [-19.874473315759683, -12.74416033859682],
              [-19.86944229801193, -12.741751877842976],
              [-19.868743827262595, -12.741011855087978],
              [-19.864027337846657, -12.739780273151053],
              [-19.86219953507941, -12.740494526525234],
              [-19.860903845001555, -12.743607149043003],
              [-19.859178193534813, -12.74495680085171],
              [-19.85727907280187, -12.745319817976895],
              [-19.854437992388874, -12.744721354885769],
              [-19.851987120949612, -12.742082345626015],
              [-19.850354763228335, -12.741034466190198],
              [-19.84812706970744, -12.741871596889267],
              [-19.84696193992423, -12.741535314435014],
              [-19.845107913143284, -12.73987441159583],
              [-19.842487156982425, -12.74061524563799],
              [-19.83960384384621, -12.739416428376853],
              [-19.837556252068044, -12.737403890775386],
              [-19.834186866222, -12.736636364720976],
              [-19.83286322267494, -12.738002626064299],
              [-19.83272299733415, -12.738926536890567],
              [-19.83110192657427, -12.742434804441109],
              [-19.826390129690214, -12.743447069464167],
              [-19.823151821577223, -12.739693083556585],
              [-19.8209984779272, -12.738765561691986],
              [-19.81834403369994, -12.738829338329568],
              [-19.816999765979585, -12.740852461750098],
              [-19.81522211764211, -12.741695901833678],
              [-19.81403162865917, -12.741095560753024],
              [-19.81207709763466, -12.743062950730481],
              [-19.81038964309254, -12.743985924272552],
              [-19.810276795821785, -12.74606810417624],
              [-19.8083808996297, -12.748339538828715],
              [-19.807117943863418, -12.751801616420407],
              [-19.806955688367463, -12.755664652556083],
              [-19.807111125545212, -12.757722224138975],
              [-19.806052762560117, -12.759570346813815],
              [-19.806876845580298, -12.76096889570994],
              [-19.80914766601085, -12.761854205846948],
              [-19.8122200980178, -12.7617395581102],
              [-19.814001635038625, -12.762546200290036],
              [-19.814343162026216, -12.764909657529241],
              [-19.815890982823355, -12.76617302453877],
              [-19.81614334735767, -12.767072495727989],
              [-19.818251893505558, -12.768643400157426],
              [-19.819762541594333, -12.769209512654243],
              [-19.820267112560803, -12.771130565539679],
              [-19.818116592052057, -12.777195015910213],
              [-19.81669584136654, -12.779113978277449],
              [-19.816745961561704, -12.78240940415951],
              [-19.818477603814145, -12.783202628439664],
              [-19.819052732762916, -12.784723304061949],
              [-19.820849910738442, -12.784580178284376],
              [-19.821329818911085, -12.786629516249441],
              [-19.81941316687254, -12.78959101778536],
              [-19.81776870555878, -12.79038567352398],
              [-19.815912232252757, -12.788326905936833],
              [-19.813400207176088, -12.786366443715163],
              [-19.812444386777965, -12.786083559731736],
              [-19.810678959716615, -12.787531936576945],
              [-19.808799103862757, -12.788272408516505],
              [-19.811383313436703, -12.790730826717436],
              [-19.811249759024154, -12.792214473705359],
              [-19.812047138130993, -12.793597182026902],
              [-19.813659334342997, -12.794924868691831],
              [-19.814106291768496, -12.797322010120654],
              [-19.815311767400832, -12.798361021789358],
              [-19.817340442896384, -12.799002858827041],
              [-19.817427313482465, -12.800713777848882],
              [-19.81667167160835, -12.801707106769744],
              [-19.819247539090185, -12.803852345967668],
              [-19.818599650320866, -12.804630898898393],
              [-19.814652760379776, -12.80378819645015],
              [-19.814204650111584, -12.802655320053386],
              [-19.8129969827779, -12.802370518757604],
              [-19.811149287553402, -12.798701889649548],
              [-19.807429762303123, -12.796454005175441],
              [-19.80443236918616, -12.795967640266712],
              [-19.803623265873554, -12.794902888721289],
              [-19.80354389657497, -12.79360492009337],
              [-19.802614262361335, -12.792052262510849],
              [-19.80306110756883, -12.791142562231325],
              [-19.804458198059777, -12.792145895705508],
              [-19.80584955030994, -12.792226629297938],
              [-19.806594600862113, -12.790798978785837],
              [-19.806478088487403, -12.789313908662805],
              [-19.80533498903853, -12.788968023422326],
              [-19.804177850489523, -12.787021057659889],
              [-19.802207002824034, -12.786659732511959],
              [-19.80118830571082, -12.78541605906833],
              [-19.800925210079605, -12.783181113594454],
              [-19.80219481739099, -12.781243890299553],
              [-19.801490759671044, -12.77931038958529],
              [-19.798019938646764, -12.77689710862443],
              [-19.79656608553349, -12.775468114014858],
              [-19.794312940654216, -12.77467349996957],
              [-19.79229121097426, -12.775316677235239],
              [-19.791267632266237, -12.777619097748184],
              [-19.791460562092112, -12.779501783770597],
              [-19.793128306559012, -12.781644640359731],
              [-19.795466791664914, -12.781209759565607],
              [-19.79840635481273, -12.782824365274164],
              [-19.799514192300272, -12.783759804567945],
              [-19.799639337602315, -12.78580184955686],
              [-19.798085239566067, -12.787184447178715],
              [-19.79887976710259, -12.788688942455954],
              [-19.800943900463476, -12.789908682452342],
              [-19.800557672185732, -12.791001297836498],
              [-19.798714920147265, -12.792316831172323],
              [-19.796022594913293, -12.79082471771488],
              [-19.79457858851702, -12.788808804220261],
              [-19.793191833290756, -12.787851648489001],
              [-19.78965817098623, -12.786394102850535],
              [-19.78555004187287, -12.784289853447786],
              [-19.784598035745177, -12.784660469736119],
              [-19.78471681435021, -12.786168538793298],
              [-19.78282976023203, -12.786615014852394],
              [-19.781229823644757, -12.785453854760652],
              [-19.779779098036393, -12.78210401038537],
              [-19.778307158274757, -12.782497499918282],
              [-19.777236528023366, -12.780971426095556],
              [-19.777960580111998, -12.78032775539053],
              [-19.77741708471145, -12.778558920861663],
              [-19.77828769187817, -12.777257485664695],
              [-19.778486589772502, -12.775327425495638],
              [-19.777790773428013, -12.773417416819992],
              [-19.77668363810104, -12.769133609093691],
              [-19.775318345536316, -12.768269976197631],
              [-19.772031881072913, -12.772418820193083],
              [-19.77076923609382, -12.771826859637839],
              [-19.769783655583648, -12.76931584784814],
              [-19.77080706764926, -12.767647333639285],
              [-19.770654664024253, -12.765832447287272],
              [-19.76974431264573, -12.764739431889778],
              [-19.769414009284453, -12.762520925620924],
              [-19.768119654113733, -12.759317009229681],
              [-19.76669245059126, -12.759798302995106],
              [-19.764598040347312, -12.757736124925865],
              [-19.761847976534828, -12.756788183707622],
              [-19.760650074519397, -12.755360836460074],
              [-19.76076183048282, -12.753619718594544],
              [-19.759654445370593, -12.752273130258727],
              [-19.75795130525007, -12.7529979573714],
              [-19.75737024517772, -12.755018770135786],
              [-19.75657189695224, -12.755916351868967],
              [-19.756495741877323, -12.758619874679322],
              [-19.756844916275444, -12.759525228497905],
              [-19.75835832845435, -12.760652776140915],
              [-19.758521515469248, -12.763046937222448],
              [-19.75945764429248, -12.763892986334449],
              [-19.76061857419363, -12.766031297574516],
              [-19.76179265227331, -12.766300396603091],
              [-19.763608992778437, -12.76834299423127],
              [-19.7632412529366, -12.770569026395123],
              [-19.764305400222504, -12.772847307615963],
              [-19.762697979904196, -12.774598465205594],
              [-19.75863613080031, -12.7733307937159],
              [-19.7570626579314, -12.774614053241029],
              [-19.755910695642125, -12.774849515697701],
              [-19.75378283096737, -12.774293334692858],
              [-19.752279516806805, -12.771925413938224],
              [-19.75209939393092, -12.770600373408367],
              [-19.75075953135407, -12.770894145212274],
              [-19.748413487006058, -12.769456166863508],
              [-19.747087944426642, -12.770862189629243],
              [-19.745784444802066, -12.77095498828774],
              [-19.74462307468231, -12.77010039330109],
              [-19.745029260344857, -12.76845055413542],
              [-19.742782789583284, -12.765055534933163],
              [-19.741815908685314, -12.764432292659796],
              [-19.74061940381684, -12.764820066291444],
              [-19.73923010657884, -12.769144431862133],
              [-19.73960184099827, -12.771476463951663],
              [-19.739471193783928, -12.773657934531341],
              [-19.74079281579583, -12.776132721613894],
              [-19.739067916238966, -12.776761994610858],
              [-19.738375082526165, -12.77991928495114],
              [-19.739663306935288, -12.781697757405244],
              [-19.739738021181218, -12.78326090130548],
              [-19.740849509837407, -12.785678487317352],
              [-19.74237232859556, -12.787245216180917],
              [-19.740622218386473, -12.788534518384001],
              [-19.738271149785486, -12.787724575158267],
              [-19.736946895054036, -12.785757751103825],
              [-19.735778917826817, -12.784999679539135],
              [-19.734832686578883, -12.782527560055845],
              [-19.733666867289973, -12.783345585243067],
              [-19.730423580478117, -12.78412812933749],
              [-19.732684335057357, -12.785779581019208],
              [-19.732780340675163, -12.787460366376452],
              [-19.734008508699397, -12.789057016035065],
              [-19.732670256771744, -12.78976085069581],
              [-19.733230120132845, -12.791648943785159],
              [-19.73516521044003, -12.793287450406707],
              [-19.737232470830982, -12.793130782422638],
              [-19.7396213542571, -12.794395505686673],
              [-19.741414923235684, -12.793850886910752],
              [-19.74069343423266, -12.796215237858737],
              [-19.739899641232718, -12.797549233384187],
              [-19.739933364213694, -12.799946623158606],
              [-19.741298980350653, -12.8014709878667],
              [-19.742361792274597, -12.8008891133047],
              [-19.745085685196948, -12.80245753871089],
              [-19.746349617159595, -12.80162034584873],
              [-19.748373054397607, -12.802660316515343],
              [-19.750307198310825, -12.802841720621243],
              [-19.753772819072427, -12.801237164164393],
              [-19.75588026106752, -12.801799374860984],
              [-19.75752950682043, -12.801667873364496],
              [-19.758110785152233, -12.800662492408376],
              [-19.759521711668658, -12.79994265728229],
              [-19.760208732597185, -12.797023285455676],
              [-19.759816833684415, -12.795637821545867],
              [-19.760782257363275, -12.794683484733364],
              [-19.762361388590133, -12.794709745846816],
              [-19.76310943396474, -12.795738239217098],
              [-19.7625377975384, -12.796790405104295],
              [-19.7638442931332, -12.797473694912943],
              [-19.76493563041977, -12.802740295167293],
              [-19.765477509643635, -12.80412307130063],
              [-19.766899482766185, -12.804493730217606],
              [-19.768137429326114, -12.80572466746574],
              [-19.76988739481165, -12.806496995083775],
              [-19.771667370126817, -12.806388453987347],
              [-19.772984657562187, -12.807896409035648],
              [-19.772921401179357, -12.810801528433656],
              [-19.77454261359226, -12.811937925302468],
              [-19.776065065567394, -12.812046612892916],
              [-19.780060552425503, -12.810969549906753],
              [-19.78211297400121, -12.81071243620517],
              [-19.783462080295728, -12.81211735050849],
              [-19.78112453932733, -12.814129801882446],
              [-19.780573054882268, -12.818513431730072],
              [-19.781553006174505, -12.81930594886852],
              [-19.784990335289546, -12.819596147758466],
              [-19.78595940283419, -12.820974688905041],
              [-19.78764993391128, -12.821295031607242],
              [-19.788788300308056, -12.820451671301758],
              [-19.790829835944745, -12.822703020835883],
              [-19.793919997432205, -12.822617533680761],
              [-19.796021857332025, -12.821960116691745],
              [-19.797193481176354, -12.821158396098102],
              [-19.80091382436378, -12.819809875062917],
              [-19.803233291640353, -12.820523066422881],
              [-19.80316783066785, -12.823262614310538],
              [-19.802125228555898, -12.824211130591134],
              [-19.802178595447387, -12.825638353598022],
              [-19.798175713518827, -12.825163914073439],
              [-19.79706198683334, -12.82549263774507],
              [-19.796479452098023, -12.827646284579172],
              [-19.800665956983668, -12.828160021644672],
              [-19.801042263646437, -12.828674799561005],
              [-19.800945084007573, -12.831128954490476],
              [-19.80305426659888, -12.831784718189333],
              [-19.80401454448063, -12.830924089476566],
              [-19.806410889060075, -12.83137963921606],
              [-19.808578235981997, -12.832584594076234],
              [-19.811567590698605, -12.832734336420932],
              [-19.817488476244495, -12.833627558066517],
              [-19.817757348805138, -12.834357345083815],
              [-19.820491534933886, -12.834480155894717],
              [-19.821420276353965, -12.833842992706424],
              [-19.824031622768157, -12.834231950634146],
              [-19.824045306304185, -12.83544825275305],
              [-19.82062322465698, -12.836552180191216],
              [-19.818791347848283, -12.836553421055873],
              [-19.817560463336427, -12.837441702975113],
              [-19.815339900906007, -12.837124923504946],
              [-19.81293278515633, -12.837647187096014],
              [-19.813248865796115, -12.840026220642207],
              [-19.81510908239283, -12.841703138147526],
              [-19.816428516739762, -12.842286098361983],
              [-19.819781491638985, -12.842611121911103],
              [-19.821015199676502, -12.843648791220621],
              [-19.82093051129959, -12.845006082421708],
              [-19.819961040544246, -12.846846018455269],
              [-19.81876586180209, -12.846898658423852],
              [-19.818009931130156, -12.845990781083021],
              [-19.81528029795731, -12.8461585984864],
              [-19.81221648513842, -12.844876248161516],
              [-19.8115820544997, -12.845482335333653],
              [-19.813418390196503, -12.847676774598368],
              [-19.81329705810749, -12.850260880645262],
              [-19.814760341612075, -12.852598884812764],
              [-19.816160258148365, -12.852947830652504],
              [-19.81664417656936, -12.855029638995905],
              [-19.81497021369863, -12.854951273102932],
              [-19.814612403714076, -12.853895202238467],
              [-19.813338214744018, -12.853546952445868],
              [-19.812052779668367, -12.852371298924242],
              [-19.81119052768695, -12.852458656263453],
              [-19.80912636589921, -12.848329631022606],
              [-19.80811387717081, -12.847517967094005],
              [-19.80796930374483, -12.845496296141706],
              [-19.808348359496513, -12.843840781836365],
              [-19.80684145260297, -12.842682395926944],
              [-19.804183953312865, -12.841542822727902],
              [-19.801708356735414, -12.841588182374071],
              [-19.80194889660706, -12.843591332083474],
              [-19.79894957874295, -12.844684021154581],
              [-19.797478430853474, -12.84434713279124],
              [-19.796412364156655, -12.842740696290692],
              [-19.79634940819547, -12.840485560984428],
              [-19.79576358843488, -12.838766179546584],
              [-19.792944092673775, -12.836266532157188],
              [-19.79093412263775, -12.83624863934415],
              [-19.78908583313232, -12.834738893513759],
              [-19.785235878350257, -12.834280433735033],
              [-19.784375756762522, -12.833464931473017],
              [-19.783077569768544, -12.83336356749498],
              [-19.78188032635066, -12.834558431100128],
              [-19.78105433713392, -12.838705214251396],
              [-19.781482139921593, -12.840136793817742],
              [-19.78339969598152, -12.84187903546797],
              [-19.782681843117373, -12.843351442011985],
              [-19.779519084557077, -12.843080978028814],
              [-19.77775712443267, -12.843697244228665],
              [-19.776306259971083, -12.841771204894915],
              [-19.775974279022304, -12.840443638309246],
              [-19.77696631728841, -12.83831251281463],
              [-19.776984667123536, -12.835167498895613],
              [-19.775328578852033, -12.836713997608477],
              [-19.77433375139413, -12.833901489690408],
              [-19.774222432391237, -12.831511354090667],
              [-19.771638844614543, -12.829551771629546],
              [-19.76818218101718, -12.827995296956],
              [-19.766184586355884, -12.828677963438638],
              [-19.765043703679954, -12.831077596067002],
              [-19.765355047539583, -12.832042742851076],
              [-19.764133910508406, -12.836502080877194],
              [-19.764492878700395, -12.838627862856834],
              [-19.764005602123728, -12.838960657043554],
              [-19.764337208416777, -12.841335037386633],
              [-19.765584473275016, -12.843907829189376],
              [-19.76664192538746, -12.845103008396412],
              [-19.768596010910528, -12.846133584414638],
              [-19.768919848929052, -12.84690292058442],
              [-19.76720565004617, -12.847508949851596],
              [-19.76359051535811, -12.846708437465566],
              [-19.761885571560306, -12.846971456779302],
              [-19.760732216107005, -12.848278159634164],
              [-19.759145336779234, -12.848373020107474],
              [-19.75722010554493, -12.851671860819142],
              [-19.75600767639778, -12.852282585853661],
              [-19.7564470240426, -12.85339656284917],
              [-19.75626834178891, -12.855475807730992],
              [-19.75642129474891, -12.85876234549698],
              [-19.75766047126412, -12.86012106181965],
              [-19.76109351268231, -12.859568347226661],
              [-19.761324374351435, -12.861817878097966],
              [-19.760326100987708, -12.862633977765503],
              [-19.75994237752526, -12.86416671967959],
              [-19.762611122079296, -12.864728801514582],
              [-19.765008655789266, -12.863876399398622],
              [-19.767097488276203, -12.864031110082598],
              [-19.768872605907806, -12.86673111634674],
              [-19.770462574807087, -12.865074334253755],
              [-19.772876518194145, -12.864046710157131],
              [-19.773490916776485, -12.862934407328765],
              [-19.77557230366166, -12.863308947480679],
              [-19.77563404026068, -12.866883510454999],
              [-19.77750070359164, -12.867834009815368],
              [-19.779671010018316, -12.867362505462518],
              [-19.78016240374084, -12.86080730563904],
              [-19.78170074142098, -12.8604513825967],
              [-19.78263296265563, -12.863841639791243],
              [-19.78224676489191, -12.864961698460405],
              [-19.78326619580653, -12.865555028197075],
              [-19.783890192299154, -12.863976344503369],
              [-19.78620403731829, -12.863989523007001],
              [-19.786806214309365, -12.862170634540703],
              [-19.787626229530897, -12.861995274276993],
              [-19.789333012203404, -12.863022649678614],
              [-19.78845634226856, -12.86472140614119],
              [-19.788601298699135, -12.865597543773768],
              [-19.787277560213045, -12.868233156493467],
              [-19.787711382755944, -12.870471773854353],
              [-19.789061142423, -12.869783663129107],
              [-19.790086455494976, -12.86781291606887],
              [-19.792408582553104, -12.867604287963712],
              [-19.793027847870558, -12.8680757300963],
              [-19.793749896495985, -12.870627822108768],
              [-19.794752356643876, -12.871516805383914],
              [-19.79698853963309, -12.871250281736861],
              [-19.79791457058025, -12.873813750339249],
              [-19.798907043229512, -12.874778170119894],
              [-19.801364440431247, -12.87293154877732],
              [-19.803596802838406, -12.87032014267399],
              [-19.804912941525224, -12.871394773052929],
              [-19.806103554501234, -12.871051964929068],
              [-19.808028443374944, -12.8671297657372],
              [-19.80988964257428, -12.867003481980934],
              [-19.810083508292195, -12.869409734152391],
              [-19.809659460613634, -12.872516897461288],
              [-19.809811967090603, -12.874198582331315],
              [-19.81134601292643, -12.873937873402767],
              [-19.81272787586117, -12.872899301105594],
              [-19.814552306040184, -12.868212239069921],
              [-19.816744492530038, -12.86592349280238],
              [-19.817927431879724, -12.867339144723763],
              [-19.816050379976147, -12.8705955413501],
              [-19.81591234187383, -12.872844158176083],
              [-19.81666794382055, -12.87438935566147],
              [-19.81864127502943, -12.874828159352514],
              [-19.820762703685872, -12.874481579508815],
              [-19.821672783876902, -12.876682151828623],
              [-19.821322535723013, -12.877847153693446],
              [-19.819732388843427, -12.879365604256494],
              [-19.816667574696645, -12.879912102996038],
              [-19.816035590375684, -12.881056131304089],
              [-19.815716498308742, -12.883413014603768],
              [-19.81467590469683, -12.884657839654851],
              [-19.814290410745162, -12.890670754436389],
              [-19.815843571101023, -12.890626464355481],
              [-19.817329871517124, -12.887537956881548],
              [-19.817745952435352, -12.885675737758369],
              [-19.818985593750092, -12.883391450880175],
              [-19.82180028362027, -12.881180092439639],
              [-19.82383593100256, -12.880262654429753],
              [-19.825101506719474, -12.881321969204125],
              [-19.8254743173412, -12.88245049566822],
              [-19.823924218771023, -12.88379093348603],
              [-19.825179703920902, -12.884412561415816],
              [-19.826445209054803, -12.88713512860641],
              [-19.825823977105422, -12.888205118323773],
              [-19.82597718362475, -12.890524421108516],
              [-19.82727735152098, -12.892140816799406],
              [-19.828079211737954, -12.894168745912085],
              [-19.829685830971055, -12.89631530733529],
              [-19.831011923784853, -12.896263374406837],
              [-19.83351483686738, -12.893225825367352],
              [-19.83479829539184, -12.895261520283087],
              [-19.83378888323853, -12.897946745054025],
              [-19.832712894276106, -12.89991035318234],
              [-19.832619255758765, -12.902767520518662],
              [-19.831588589416747, -12.9044537406705],
              [-19.834828907832826, -12.90284411034078],
              [-19.83615753740244, -12.899216979288324],
              [-19.837694567772598, -12.897803122128122],
              [-19.83883766842188, -12.895287953261551],
              [-19.83982732904177, -12.89480872411835],
              [-19.84003656544251, -12.892419882995359],
              [-19.83976004242484, -12.887700281001118],
              [-19.840535271412435, -12.88664981645983],
              [-19.84207791946148, -12.887314345088035],
              [-19.842103074117098, -12.885401168821852],
              [-19.843547461291852, -12.883148392333855],
              [-19.844120556508766, -12.881205907120536],
              [-19.84547710218121, -12.880804027200115],
              [-19.84666347946502, -12.882342018199857],
              [-19.846092553947425, -12.884675723011693],
              [-19.846776408362402, -12.885329681274346],
              [-19.84507356389158, -12.890862313104947],
              [-19.843856954282447, -12.891849610956967],
              [-19.844346417879176, -12.894070626390384],
              [-19.844290590004256, -12.896210634540047],
              [-19.84342302835257, -12.898968637242312],
              [-19.84441882183405, -12.900177094163654],
              [-19.84341356358931, -12.901345591613348],
              [-19.844217920257535, -12.903373842179624],
              [-19.844144252956603, -12.904661370015269],
              [-19.845262857102668, -12.905724691338582],
              [-19.84778277353577, -12.904173732399428],
              [-19.849648003808653, -12.903651341140222],
              [-19.85099564136184, -12.900899649607192],
              [-19.85174401825258, -12.90021992031651],
              [-19.855038972050796, -12.899403058716722],
              [-19.856560607250383, -12.897915900418095],
              [-19.857147668742382, -12.895282726748698],
              [-19.85656769924741, -12.893506811884452],
              [-19.85680546323988, -12.892164277680585],
              [-19.858347328429257, -12.89179988741501],
              [-19.85809138656496, -12.893684467162466],
              [-19.859416534710064, -12.89375245143414],
              [-19.859720564413283, -12.896168254163111],
              [-19.86049226537332, -12.896242614263363],
              [-19.860021252196248, -12.898315540055059],
              [-19.85863951908502, -12.899997236308113],
              [-19.855807161721316, -12.902001261294409],
              [-19.854306308481252, -12.90257826077704],
              [-19.85100764921562, -12.905673693543193],
              [-19.851031789364697, -12.907580155092813],
              [-19.850340694048995, -12.90893503448118],
              [-19.847919364296228, -12.910223325975776],
              [-19.8479799397084, -12.91116771076304],
              [-19.84913675317373, -12.912420527065326],
              [-19.84925245605734, -12.91377122787327],
              [-19.850057401640676, -12.915286326116734],
              [-19.851364529021943, -12.916658421831766],
              [-19.85267313521172, -12.91727026072282],
              [-19.853626759917148, -12.91596308594434],
              [-19.855244350320554, -12.915585010019786],
              [-19.856916110900467, -12.913823617601292],
              [-19.85735302199124, -12.912589164735145],
              [-19.856705123342373, -12.909451921050906],
              [-19.858075677715668, -12.908850179864851],
              [-19.859307495856022, -12.909965800101391],
              [-19.861495937613217, -12.910557429768074],
              [-19.863186158719177, -12.90800782827134],
              [-19.866406255242662, -12.906295664162569],
              [-19.866504621505225, -12.904635076074738],
              [-19.867284196844142, -12.90360524862105],
              [-19.866406236810736, -12.901100918258448],
              [-19.867283554674227, -12.900689567938787],
              [-19.867781146956535, -12.898880365156224],
              [-19.86942252476822, -12.898250844936971],
              [-19.8703887779684, -12.896769079707267],
              [-19.87094260961489, -12.894361379359685],
              [-19.871010572675416, -12.889523851081353],
              [-19.869686878950883, -12.886812291006342],
              [-19.870309749611778, -12.885763749334613],
              [-19.873066237815586, -12.88756587041912],
              [-19.8749280864394, -12.887162981947608],
              [-19.876094635641515, -12.891227114193482],
              [-19.87505056966245, -12.89206216702399],
              [-19.875295130408222, -12.894293846945304],
              [-19.871970925953537, -12.898624703397992],
              [-19.873501661820647, -12.898578935040291],
              [-19.8754852438939, -12.902564187432871],
              [-19.87440014515741, -12.90357908840674],
              [-19.87255269804633, -12.904444460788879],
              [-19.87303654459143, -12.90560286397142],
              [-19.87480513510144, -12.907374996059039],
              [-19.87511276475346, -12.908787709121306],
              [-19.87165167308312, -12.911699876669084],
              [-19.87124736390792, -12.91258587665376],
              [-19.86929235992232, -12.913299581680542],
              [-19.868970248974776, -12.914978861410171],
              [-19.86916223437878, -12.917590920839075],
              [-19.870187830328955, -12.920708036617356],
              [-19.87202997412256, -12.921070610702877],
              [-19.874247121555598, -12.92217150390428],
              [-19.87437231277263, -12.923178275027468],
              [-19.873086249408807, -12.924845034039118],
              [-19.87238246324262, -12.927530556724484],
              [-19.873035100219536, -12.928266085643608],
              [-19.8762917724964, -12.926838796749253],
              [-19.877994282108137, -12.924724111750825],
              [-19.88000050465982, -12.922993151571127],
              [-19.88082758583975, -12.923081479840748],
              [-19.881659660532495, -12.921426276098227],
              [-19.880206380306, -12.918586770083232],
              [-19.88169667163431, -12.915800919931009],
              [-19.883607700790257, -12.916001478365882],
              [-19.88398579670567, -12.918898128614485],
              [-19.88571220807198, -12.92094982263792],
              [-19.88612854952127, -12.92403639509699],
              [-19.885823946689687, -12.92718732061212],
              [-19.887841556076328, -12.926017613035183],
              [-19.891184847637117, -12.922630693948422],
              [-19.891852535274033, -12.920539560608491],
              [-19.891731430256762, -12.919433754275484],
              [-19.89063609320449, -12.918513897706351],
              [-19.889326820906106, -12.915647448985023],
              [-19.889943642989966, -12.914940817045647],
              [-19.892047217346988, -12.917606685240962],
              [-19.894538010550562, -12.916787085262062],
              [-19.89525203416087, -12.916061615971277],
              [-19.89659999053594, -12.917104543293036],
              [-19.895764502148285, -12.918859519878714],
              [-19.8964420667048, -12.919711887123988],
              [-19.897134273926827, -12.922648052745274],
              [-19.899403530834086, -12.926878929908588],
              [-19.90090785541416, -12.927057850946174],
              [-19.900238269732213, -12.922102973604952],
              [-19.900320374461586, -12.92000052815656],
              [-19.89884842915502, -12.918220593256253],
              [-19.898621768562673, -12.915588565373168],
              [-19.899762645225383, -12.915100209779489],
              [-19.900774317133372, -12.91635428903584],
              [-19.902547444302087, -12.91950028909693],
              [-19.90249829234876, -12.920761585365216],
              [-19.903495194515788, -12.922191084921037],
              [-19.90297358757989, -12.923494352745534],
              [-19.904176842842965, -12.92456514337365],
              [-19.906672146711564, -12.922883177856553],
              [-19.90797257319147, -12.921552959273614],
              [-19.909800830540345, -12.920956129907694],
              [-19.909790325175777, -12.91852734808493],
              [-19.910445730272198, -12.917640210567825],
              [-19.90845842127484, -12.91669661624963],
              [-19.90709460241088, -12.914331764704832],
              [-19.908089580634847, -12.91374788656124],
              [-19.91119772925529, -12.914230619667755],
              [-19.91380757636871, -12.912377930095149],
              [-19.915643401452986, -12.913570999007511],
              [-19.915135316659377, -12.91568193402714],
              [-19.916019400640895, -12.919292979171185],
              [-19.918096206292134, -12.923166365070413],
              [-19.92162302800802, -12.924697249884433],
              [-19.922763106160495, -12.924575390086874],
              [-19.924951086497344, -12.922506818920628],
              [-19.923256654949597, -12.920525099813515],
              [-19.923357973040403, -12.919031593943417],
              [-19.92031708976249, -12.916524451458345],
              [-19.920072230838045, -12.915319137436539],
              [-19.9207370644928, -12.914355974376722],
              [-19.923675799721195, -12.914868834679261],
              [-19.926245829236514, -12.912947764437625],
              [-19.926988531689073, -12.913860010442367],
              [-19.928190935535927, -12.91379904359666],
              [-19.930482387673752, -12.914484785862411],
              [-19.93438807150322, -12.91377673716696],
              [-19.935237923297063, -12.91496285443126],
              [-19.935532079259595, -12.916526798039198],
              [-19.935169653526863, -12.917727432304599],
              [-19.935946010490905, -12.919296664838738],
              [-19.937634296038677, -12.920369545266006],
              [-19.939318942402508, -12.920804071375485],
              [-19.94072211297031, -12.920604944264937],
              [-19.943263909810945, -12.921388800870236],
              [-19.94457011424707, -12.920716727355584],
              [-19.946899243281322, -12.920213825204428],
              [-19.948242582170977, -12.921451406380703],
              [-19.949508962032027, -12.921942053383617],
              [-19.951177753660517, -12.918224334084787],
              [-19.95224983516456, -12.91764640656583],
              [-19.954222375441077, -12.917998371789471],
              [-19.954947603704255, -12.919306910546588],
              [-19.956579460715805, -12.919725528557699],
              [-19.95838172800305, -12.921954573684067],
              [-19.95919050892324, -12.922189613150845],
              [-19.96127608041685, -12.924068570781543],
              [-19.962416716447535, -12.92603416781459],
              [-19.964746635246122, -12.926143098154807],
              [-19.96527770908624, -12.925030537558156],
              [-19.967203143797686, -12.924898978070603],
              [-19.969577370044654, -12.92546603740108],
              [-19.97185517269515, -12.927282048600887],
              [-19.972207034627765, -12.928738327284606],
              [-19.973709208442326, -12.92913215347974],
              [-19.976458288621465, -12.927828573420978],
              [-19.97794121841242, -12.928250060841453],
              [-19.97926490279784, -12.930106127661482],
              [-19.981814870065197, -12.929554217652992],
              [-19.983995059415122, -12.929665757754133],
              [-19.98518447070235, -12.929283055872295],
              [-19.98751701899495, -12.930003918695812],
              [-19.988906512859757, -12.929606361748291],
              [-19.99014184287129, -12.930297531908002],
              [-19.990870589518206, -12.933797584961255],
              [-19.992897620137377, -12.937189649206095],
              [-19.994849487725872, -12.941681402138599],
              [-19.99623186135897, -12.94197436154551],
              [-19.998020725662297, -12.940683507862587],
              [-19.999139728798365, -12.941053034585186],
              [-20.0030083416954, -12.939866701991942],
              [-20.004240505856014, -12.94053390479546],
              [-20.00797460658555, -12.938583827518986],
              [-20.007395233537967, -12.937516217487076],
              [-20.007830950505404, -12.936320642409834],
              [-20.009740887102758, -12.93525076775583],
              [-20.011290199848716, -12.935853897480497],
              [-20.0122308812618, -12.936824767382321],
              [-20.01595779384118, -12.938718879955148],
              [-20.017909381041747, -12.938329402028083],
              [-20.020152488564076, -12.938842840106114],
              [-20.022107203321386, -12.940399735450075],
              [-20.023663773679203, -12.940063809060039],
              [-20.02566195316561, -12.940255876663933],
              [-20.026433759800376, -12.941383828355589],
              [-20.026175985696774, -12.943901644732417],
              [-20.024863629662377, -12.944312209605231],
              [-20.024674453074887, -12.945829706740488],
              [-20.027241773008427, -12.945217331033646],
              [-20.028581900400933, -12.945540861802124],
              [-20.029051245988178, -12.946680299368168],
              [-20.030419253957046, -12.947738664495766],
              [-20.03264626981655, -12.950573707867543],
              [-20.0339516172776, -12.950608216649407],
              [-20.03559599691164, -12.952005699599818],
              [-20.03743292240896, -12.952747803224053],
              [-20.03679434361723, -12.955147040176936],
              [-20.0368825974864, -12.958215150862028],
              [-20.03824474671559, -12.959719775603478],
              [-20.040607344022828, -12.95872666186181],
              [-20.043544994481543, -12.95371632129141],
              [-20.044480312141236, -12.953083407887549],
              [-20.04595409111409, -12.950786957694516],
              [-20.048591956964387, -12.950378987825937],
              [-20.050825473739927, -12.951063853234746],
              [-20.0520560861401, -12.950025381977829],
              [-20.052899345131575, -12.948003523081606],
              [-20.05456906613488, -12.948431619484625],
              [-20.055494476419515, -12.946318866026928],
              [-20.057415369448112, -12.945535226420443],
              [-20.058700404740197, -12.94547286128135],
              [-20.06046949656187, -12.946126879102753],
              [-20.061875104180157, -12.947940666151547],
              [-20.06256274858233, -12.950567050497272],
              [-20.063604233014296, -12.951269881570473],
              [-20.063892279170936, -12.952619534672865],
              [-20.065950152316027, -12.955932596592065],
              [-20.06784941981544, -12.95539892030994],
              [-20.070498810726704, -12.955750623145338],
              [-20.07294520817343, -12.957057453721722],
              [-20.072341513864806, -12.961505176048133],
              [-20.07350704725856, -12.962899832957357],
              [-20.07424060498425, -12.960489192851249],
              [-20.074080243999372, -12.95866782942957],
              [-20.07501616002097, -12.956253344825727],
              [-20.073787366424074, -12.955514565159968],
              [-20.07456025322957, -12.951626204664827],
              [-20.076045425645862, -12.950113384020183],
              [-20.07801011904236, -12.948700387130394],
              [-20.07852522848025, -12.947656602301604],
              [-20.08099178650579, -12.947277023804332],
              [-20.080882127845275, -12.945817243160004],
              [-20.08163363744661, -12.94504620224375],
              [-20.08538649550132, -12.94531741786316],
              [-20.086255465471368, -12.94343537501974],
              [-20.08933919235983, -12.94438567253687],
              [-20.092039295654363, -12.94284441476402],
              [-20.091610601047798, -12.941919486064263],
              [-20.092229232008876, -12.940063411953004],
              [-20.093850295596006, -12.939311106100106],
              [-20.09511634949708, -12.940336160655582],
              [-20.098322929358584, -12.940789628662229],
              [-20.099766012730313, -12.939332192665397],
              [-20.098744721997637, -12.93531755657715],
              [-20.099493149425243, -12.933360740580415],
              [-20.100983545445917, -12.932362621916973],
              [-20.10440972329866, -12.932423278696382],
              [-20.105694818292733, -12.930478814114805],
              [-20.106732889739007, -12.929746328599602],
              [-20.108476559024382, -12.927336826412565],
              [-20.108309690390527, -12.926803277510498]
            ]
          ],
          [
            [
              [-20.10173258062115, -12.710530053463453],
              [-20.099841932069616, -12.71082821336437],
              [-20.099755595972905, -12.712261126115768],
              [-20.098908604727576, -12.714341220583604],
              [-20.09971014867394, -12.714564042378935],
              [-20.101194111423776, -12.71332644985181],
              [-20.10204744782277, -12.711732572121027],
              [-20.10173258062115, -12.710530053463453]
            ]
          ],
          [
            [
              [-20.250651460404335, -12.987841766874118],
              [-20.249351848784848, -12.987773441899835],
              [-20.248507419112745, -12.989373278913293],
              [-20.24966825759262, -12.990640968978406],
              [-20.25081848614537, -12.989597171843846],
              [-20.250651460404335, -12.987841766874118]
            ]
          ],
          [
            [
              [-20.263236573420148, -13.009177743611453],
              [-20.260984201116287, -13.007646100068262],
              [-20.25994923022986, -13.00637455755306],
              [-20.258947910823764, -13.00604284765491],
              [-20.25687951418764, -13.009054382946905],
              [-20.25461383900582, -13.011086983168724],
              [-20.255113541277176, -13.01170183352784],
              [-20.257300093950242, -13.010906975939692],
              [-20.259976035642417, -13.011700505348012],
              [-20.26108878295384, -13.011161342175207],
              [-20.263236573420148, -13.009177743611453]
            ]
          ],
          [
            [
              [-20.405442972483616, -13.032940708676412],
              [-20.404729557172246, -13.03157340308241],
              [-20.402979082809097, -13.030415570724523],
              [-20.401173248150936, -13.03022167240062],
              [-20.39648532374153, -13.031076940768658],
              [-20.394138235161176, -13.03045323929257],
              [-20.393442838849026, -13.02795562486907],
              [-20.391968652727176, -13.02620893949921],
              [-20.39059766404603, -13.026316882781607],
              [-20.38942520105327, -13.025078761321328],
              [-20.39199363325675, -13.02074717016014],
              [-20.39046861084001, -13.020639760093092],
              [-20.387658950099866, -13.021220873969412],
              [-20.386488921365967, -13.021083192937764],
              [-20.38336383937508, -13.02185980166143],
              [-20.38066490910589, -13.021814063329604],
              [-20.377936439703575, -13.022300361310899],
              [-20.375415157310105, -13.022238985708638],
              [-20.37178980184567, -13.021549006368842],
              [-20.370242820273226, -13.020794081879998],
              [-20.367353940906508, -13.017738258559621],
              [-20.365738982178353, -13.014823566100075],
              [-20.36559539663906, -13.01190610966939],
              [-20.366154776866985, -13.010881510683513],
              [-20.36872942088238, -13.009206837858947],
              [-20.368599618017186, -13.008435791956385],
              [-20.366061893259772, -13.005329594025794],
              [-20.364171471180875, -13.002229230307606],
              [-20.362054673265643, -13.003650966816092],
              [-20.357643037351252, -13.004309419432795],
              [-20.35769425118575, -13.00529744258675],
              [-20.35579722972819, -13.006669043372614],
              [-20.35317384971736, -13.00615366202781],
              [-20.352697067303414, -13.005660299831138],
              [-20.349918379443313, -13.005029001202459],
              [-20.349323883566907, -13.00568549262416],
              [-20.347576123002046, -13.005049961135148],
              [-20.34621663423451, -13.003978368125933],
              [-20.34520720203275, -13.005176178605513],
              [-20.34358909983561, -13.00553508051804],
              [-20.341723415491455, -13.003177320868934],
              [-20.341204344582852, -13.001395379578387],
              [-20.343987039955618, -12.998631540182213],
              [-20.342744973118737, -12.996735545668514],
              [-20.341900933263013, -12.996872898360039],
              [-20.341639393332756, -12.99343747351608],
              [-20.340376491455515, -12.992993683368008],
              [-20.339851870407227, -12.991189098252296],
              [-20.341640007256306, -12.989470217584376],
              [-20.342327993885775, -12.987895843982553],
              [-20.34143181689885, -12.98714658317683],
              [-20.341674707469455, -12.985321881709988],
              [-20.340951933033537, -12.983661954957121],
              [-20.339492456358762, -12.983586506497634],
              [-20.33832895898813, -12.982573144247649],
              [-20.33834308287806, -12.980649943976038],
              [-20.336894347180266, -12.980397908761747],
              [-20.336259238964406, -12.981536025662228],
              [-20.334375938012812, -12.980856290437142],
              [-20.33345172325063, -12.981858812167411],
              [-20.33157099990812, -12.98107844352851],
              [-20.330564387861372, -12.981176704546563],
              [-20.32865660508394, -12.980277517116827],
              [-20.324252819178703, -12.97893269141551],
              [-20.32460098758533, -12.977111761439684],
              [-20.32405930719324, -12.97434123349837],
              [-20.321520844173378, -12.974926489503899],
              [-20.319834191046436, -12.973754428726435],
              [-20.31806148268962, -12.97187876734111],
              [-20.31558722778131, -12.968639149102554],
              [-20.31336559819362, -12.965045458506061],
              [-20.312651876077926, -12.963186676032278],
              [-20.312714859760018, -12.960136506576701],
              [-20.31359340652374, -12.959494831924971],
              [-20.31452854764131, -12.957770784606284],
              [-20.315350765507578, -12.957440205417893],
              [-20.318965257047402, -12.953656201709746],
              [-20.31915506273855, -12.951823088333459],
              [-20.31858813348714, -12.94938601771467],
              [-20.3168190542983, -12.946966128584046],
              [-20.315254315605937, -12.94564525920531],
              [-20.31606290219625, -12.94205989602188],
              [-20.31483643172871, -12.939322524586505],
              [-20.31315399372665, -12.93815307761623],
              [-20.31378578989703, -12.936348114287414],
              [-20.312907384294498, -12.935548007279566],
              [-20.31007038870433, -12.937242701793839],
              [-20.308356745006282, -12.936377886228252],
              [-20.307627682611525, -12.934451212078116],
              [-20.30690340202039, -12.934312992481146],
              [-20.30624713009898, -12.932147004615405],
              [-20.306306394692502, -12.930966238716595],
              [-20.305281966829835, -12.929974742959772],
              [-20.303025822541745, -12.92952789015569],
              [-20.301158523662696, -12.927107633883068],
              [-20.299692969311344, -12.927305944695059],
              [-20.296322086441585, -12.92447201667053],
              [-20.294647240249773, -12.924095095754918],
              [-20.29253002883163, -12.924684174421856],
              [-20.290840781976666, -12.923689603923206],
              [-20.28978770496892, -12.922233116025996],
              [-20.287448881622204, -12.921083244101967],
              [-20.287306756951377, -12.918360121216882],
              [-20.2860955045998, -12.917658249898126],
              [-20.280493166396475, -12.918884955600491],
              [-20.274362096282534, -12.91514036151335],
              [-20.26950049010029, -12.910895823696935],
              [-20.267952627534786, -12.908606064423822],
              [-20.267318978344633, -12.906290880926624],
              [-20.26571812632044, -12.906218609313777],
              [-20.261994461882445, -12.908144517756645],
              [-20.260171231165696, -12.910449239842835],
              [-20.25998673366353, -12.912323137246696],
              [-20.25818947611676, -12.914523014090959],
              [-20.25655191999906, -12.915745939907016],
              [-20.254498070384216, -12.916265902249842],
              [-20.25304704081329, -12.917299351554831],
              [-20.247909089678522, -12.91729736222202],
              [-20.246272944923962, -12.916734407843771],
              [-20.24303203527249, -12.915069038365635],
              [-20.241496522974053, -12.914608296847696],
              [-20.241127187648974, -12.91231010781332],
              [-20.24038763540148, -12.91152849662861],
              [-20.237882024716967, -12.91241625772089],
              [-20.23631885273848, -12.912505731331864],
              [-20.234094420722226, -12.913282612246013],
              [-20.233078294132067, -12.915334222940785],
              [-20.233644181801125, -12.916252508618745],
              [-20.232638910267518, -12.920382941633513],
              [-20.229666562375268, -12.921022555519999],
              [-20.22759042440958, -12.920428530383724],
              [-20.223976937010704, -12.920263670102855],
              [-20.221790346870293, -12.92053467460866],
              [-20.220753414813288, -12.920014307885126],
              [-20.219472814392702, -12.921130920018404],
              [-20.218473743645912, -12.923722656168806],
              [-20.21790404458068, -12.924141842298788],
              [-20.215243562655456, -12.923671236509898],
              [-20.213301117946283, -12.922303614037055],
              [-20.212806665863734, -12.921468480906865],
              [-20.21273001216897, -12.918860391882014],
              [-20.213112646744385, -12.917837615951253],
              [-20.21251632427852, -12.916776918058812],
              [-20.209416570936785, -12.915706962154498],
              [-20.20956439538251, -12.912507714908886],
              [-20.209938010478847, -12.910992537551413],
              [-20.211048891816468, -12.910259892438166],
              [-20.21276933806989, -12.911327110373776],
              [-20.215074401755473, -12.910685134735877],
              [-20.214986205682305, -12.909614910488138],
              [-20.215966019666777, -12.907623520090702],
              [-20.21541392918684, -12.906306687602168],
              [-20.213692209832107, -12.905685700794969],
              [-20.21416834648612, -12.902367717325351],
              [-20.216180081983456, -12.90178804382015],
              [-20.21783703225216, -12.900542314293679],
              [-20.221988984716674, -12.899502291618598],
              [-20.225883922612276, -12.897328874982163],
              [-20.226563430641647, -12.895599282459186],
              [-20.225887966757057, -12.893518644806093],
              [-20.22347001798001, -12.893086795472414],
              [-20.221245183581804, -12.893169634340511],
              [-20.219002956146323, -12.89080762992908],
              [-20.214655957669194, -12.88442475623064],
              [-20.212252603137443, -12.880097470100742],
              [-20.21170320521306, -12.878115480178826],
              [-20.211829509011203, -12.876532200773992],
              [-20.213835526627513, -12.87560775518389],
              [-20.214941913611685, -12.87430810033678],
              [-20.213710269396508, -12.872349885641063],
              [-20.21391899287367, -12.871020948213335],
              [-20.214946219232615, -12.869936142618569],
              [-20.213699120274022, -12.865883450132486],
              [-20.211807230298422, -12.864265624654688],
              [-20.210191517255804, -12.864094191310231],
              [-20.203755957666683, -12.857997877157652],
              [-20.198440371326367, -12.853241895720945],
              [-20.196996324225804, -12.85224373772722],
              [-20.19658904974666, -12.849643769015366],
              [-20.19464246434494, -12.84934514219332],
              [-20.19354454000178, -12.850787548630604],
              [-20.18872644386586, -12.8494626094543],
              [-20.187297866846432, -12.848300732984065],
              [-20.185613696994206, -12.847809772900552],
              [-20.183976446729574, -12.848207808652566],
              [-20.179354379983092, -12.845249859169058],
              [-20.178210783556604, -12.844902064149775],
              [-20.174991313754912, -12.842532258762208],
              [-20.17178128503803, -12.8406533392163],
              [-20.1718093305374, -12.839416185939001],
              [-20.17064641769305, -12.83829662454805],
              [-20.1666783928944, -12.837218508515079],
              [-20.164373950018597, -12.838026677918739],
              [-20.15763141655827, -12.837459683267385],
              [-20.15573822282094, -12.836924467819179],
              [-20.153280095906386, -12.835327493923499],
              [-20.15243591267689, -12.836661982362397],
              [-20.150838229636943, -12.836998931221007],
              [-20.14846976871409, -12.83614496334444],
              [-20.14787784684617, -12.835531781275806],
              [-20.145610240718888, -12.834902472669429],
              [-20.144346680711603, -12.835832375581827],
              [-20.141531550250086, -12.83558830743627],
              [-20.138218315241616, -12.83412007904173],
              [-20.136551730979257, -12.836093134191774],
              [-20.133674328269986, -12.83728660248593],
              [-20.127682679157832, -12.837680488262981],
              [-20.124647216743234, -12.836889250146164],
              [-20.12346429615341, -12.835538552118777],
              [-20.121424829742306, -12.835128609349635],
              [-20.120381644022928, -12.835911539496173],
              [-20.115986629790505, -12.837688329864609],
              [-20.113694380754662, -12.840746495117216],
              [-20.113195796236845, -12.842054625349817],
              [-20.114579417659606, -12.843979447781068],
              [-20.114312851292457, -12.84600178553747],
              [-20.113230362790308, -12.847653048347087],
              [-20.113376123053904, -12.848434303012137],
              [-20.11055061433597, -12.851037990002395],
              [-20.10727264817683, -12.852849797619434],
              [-20.104076437621085, -12.85422566316035],
              [-20.098145504225172, -12.856191004662913],
              [-20.095183665400356, -12.85690110350558],
              [-20.08921136553453, -12.857862636150841],
              [-20.084176878756754, -12.858825285011413],
              [-20.081495913144046, -12.858491556977453],
              [-20.080639119294425, -12.859331144888504],
              [-20.08021491548916, -12.863229323729014],
              [-20.08079674952129, -12.866626417323333],
              [-20.082768975331053, -12.870476884070554],
              [-20.08429592274946, -12.871442511567224],
              [-20.086426425063163, -12.873908044998636],
              [-20.08955578733578, -12.875946897697476],
              [-20.090942176792723, -12.876375498463265],
              [-20.096048818147516, -12.879803813009454],
              [-20.097792602097172, -12.880355448669238],
              [-20.09880011634708, -12.881255450378605],
              [-20.100448848378104, -12.883821601901317],
              [-20.10077681364772, -12.885798439873092],
              [-20.100341108816014, -12.888351765393352],
              [-20.09924259365185, -12.891830744725807],
              [-20.09843779720121, -12.89268692827039],
              [-20.098561905460002, -12.89384421232833],
              [-20.100439286953637, -12.89675973859451],
              [-20.09998742351359, -12.898307102027063],
              [-20.100131794889705, -12.900964391703814],
              [-20.100569608680818, -12.902279563883138],
              [-20.10303600324553, -12.903102618914186],
              [-20.105326122439894, -12.904750710772399],
              [-20.107633292680458, -12.905655718253804],
              [-20.108110106698252, -12.906913646429985],
              [-20.112027332384642, -12.90644922847156],
              [-20.113698049023554, -12.906646220242985],
              [-20.11477846445342, -12.908569198824871],
              [-20.1166324630023, -12.909838526728246],
              [-20.120753938424834, -12.910069979880875],
              [-20.124515052180065, -12.910745377878909],
              [-20.125511002983156, -12.911575383086417],
              [-20.13257992461456, -12.913166735196281],
              [-20.13641947263362, -12.915231320288328],
              [-20.13833635716147, -12.917351046051792],
              [-20.138460514037202, -12.918264035749297],
              [-20.14020505751245, -12.91832006073368],
              [-20.1431457943583, -12.919064605992151],
              [-20.146530000067653, -12.920433148254412],
              [-20.150373293844737, -12.92064198210777],
              [-20.151352534454126, -12.921499814574018],
              [-20.153172753875022, -12.921662428005696],
              [-20.155656084136208, -12.921364129537793],
              [-20.158760698950818, -12.921800254049378],
              [-20.163175031217293, -12.923196818934157],
              [-20.164355758111927, -12.924729343335631],
              [-20.16403795022286, -12.926749996055765],
              [-20.165657320608823, -12.92715150071941],
              [-20.17335640408579, -12.927929101702423],
              [-20.182377615202267, -12.928671390000261],
              [-20.185334889222602, -12.929456234576476],
              [-20.189185425600783, -12.929778886125279],
              [-20.195118818902937, -12.930847027214798],
              [-20.199194068009618, -12.931937071287207],
              [-20.20258028784442, -12.93405248836664],
              [-20.204402004918023, -12.93465526229562],
              [-20.20582101296159, -12.935740328995033],
              [-20.205409595480553, -12.936868564093285],
              [-20.210297827837547, -12.939741661056793],
              [-20.213642186906636, -12.94051511928282],
              [-20.214731531653047, -12.941720062879735],
              [-20.214361217272263, -12.943484775824848],
              [-20.21146452424506, -12.944252241756178],
              [-20.21111071274206, -12.945864853257241],
              [-20.213112229400473, -12.945437724958287],
              [-20.217008279524016, -12.9468371130027],
              [-20.218369945630332, -12.947885088784222],
              [-20.21877747822388, -12.95037749852687],
              [-20.21776961000808, -12.951585091123645],
              [-20.218963940969246, -12.952570258518277],
              [-20.22001727167131, -12.954974989105759],
              [-20.21999591410171, -12.957609765526302],
              [-20.221563909717464, -12.957522786657359],
              [-20.222494971490345, -12.953700432944846],
              [-20.22378686079481, -12.95193539785472],
              [-20.225755566279425, -12.951811475163503],
              [-20.226744638758458, -12.952790293834116],
              [-20.225825508334072, -12.955071667593424],
              [-20.225619106346144, -12.956654858725384],
              [-20.227250876151842, -12.960028185686282],
              [-20.226597119760015, -12.96076408415777],
              [-20.225892284926147, -12.963546660438881],
              [-20.22651222385836, -12.96470517547648],
              [-20.228429316713793, -12.964344023201608],
              [-20.22906937074651, -12.96604454452455],
              [-20.23327248387142, -12.965590458402735],
              [-20.234455449876958, -12.967422664290833],
              [-20.235237818918403, -12.96725472268883],
              [-20.239454004998247, -12.970026034582675],
              [-20.23979254205854, -12.971294805195187],
              [-20.241766779700892, -12.972311827759416],
              [-20.24533326770875, -12.975371987977926],
              [-20.24860075760085, -12.979143352813017],
              [-20.251332626355566, -12.983714695027619],
              [-20.25196944151569, -12.985841175028837],
              [-20.254714856349207, -12.986169587642259],
              [-20.257995573155643, -12.986929422481845],
              [-20.259369674774867, -12.98800104074259],
              [-20.259245604062464, -12.988923651723093],
              [-20.261116833626524, -12.990485413845368],
              [-20.26116716435267, -12.98641821950844],
              [-20.26399320023951, -12.986080691335953],
              [-20.264990008813147, -12.986959727785734],
              [-20.264990722153367, -12.988428105921617],
              [-20.266407621851293, -12.988668918829761],
              [-20.266847517531456, -12.991386712292895],
              [-20.267736622140387, -12.991791536987082],
              [-20.269304716202825, -12.988414681622608],
              [-20.27205873923432, -12.990232237843847],
              [-20.27282189703411, -12.988622737570074],
              [-20.27498199637087, -12.988402904820452],
              [-20.275751251119736, -12.989181666173195],
              [-20.280602362533134, -12.988923911253938],
              [-20.28160599213137, -12.990498743841135],
              [-20.284345953997438, -12.992243554229077],
              [-20.28471338398037, -12.992835953947756],
              [-20.28833891009179, -12.994063948975768],
              [-20.288039605494248, -12.995898064708685],
              [-20.290579794083367, -12.996540280211093],
              [-20.290849852984316, -12.997826940085602],
              [-20.29354918812875, -13.000278528742966],
              [-20.296461508234398, -13.001636912527662],
              [-20.298023573739883, -13.00361399937723],
              [-20.29922455142019, -13.002902711261507],
              [-20.300597946806697, -13.00327589789966],
              [-20.30258631550583, -13.002965238668518],
              [-20.30379162516403, -13.003948482836615],
              [-20.30527132206725, -13.004222733944818],
              [-20.30632821083225, -13.006235945657814],
              [-20.3062294439924, -13.00792908459784],
              [-20.30522556930025, -13.009495989110974],
              [-20.30613546057052, -13.011542037134257],
              [-20.307111594089996, -13.009406967730158],
              [-20.30814996512552, -13.009329270711879],
              [-20.307588417396087, -13.007007607397986],
              [-20.308296919362302, -13.005056338059273],
              [-20.309331290120642, -13.004181009678007],
              [-20.312370507675542, -13.004736228560287],
              [-20.31351956748661, -13.005806098881829],
              [-20.31239321454705, -13.006951434814683],
              [-20.313004484337288, -13.009038096483518],
              [-20.314346014709763, -13.009267317949512],
              [-20.315119668320374, -13.010494808378542],
              [-20.316360920888407, -13.00939865647359],
              [-20.317734325144123, -13.009096793548132],
              [-20.319754363445213, -13.006581332861991],
              [-20.321371756750757, -13.005776453821676],
              [-20.32177842467246, -13.004863329624518],
              [-20.32307492232173, -13.004452993555578],
              [-20.325959543529535, -13.005888316864738],
              [-20.327192328196396, -13.006090839997713],
              [-20.328814229623852, -13.008079178575848],
              [-20.329039340743286, -13.00960218909649],
              [-20.328011506284412, -13.012724943973502],
              [-20.32464985935289, -13.01546310145868],
              [-20.32367733706633, -13.017275435319675],
              [-20.32365285342875, -13.019728239018237],
              [-20.324341044034604, -13.02124982062857],
              [-20.328777960347367, -13.020022981680864],
              [-20.330845668611047, -13.02081574814602],
              [-20.332357975077493, -13.01611116635854],
              [-20.33223612968728, -13.014589487492746],
              [-20.33329398247914, -13.01348171893766],
              [-20.336077281714918, -13.012916867960493],
              [-20.338810194266436, -13.014460377305532],
              [-20.339976686308567, -13.01570080691606],
              [-20.34215886113572, -13.015542582763668],
              [-20.344780340393598, -13.01461209890853],
              [-20.347051524457022, -13.015607523975978],
              [-20.349086389072855, -13.018129418999122],
              [-20.352260136570745, -13.018674246019202],
              [-20.35322876921889, -13.01983406015926],
              [-20.356872706868515, -13.020948848525464],
              [-20.35762747202663, -13.021855831901606],
              [-20.3601924479487, -13.023210270098632],
              [-20.360891007767457, -13.022554768981141],
              [-20.364238709098863, -13.023609455625348],
              [-20.365730796089455, -13.023801904859152],
              [-20.36921908819696, -13.025449780099581],
              [-20.37264639969269, -13.02430910029235],
              [-20.373626576017703, -13.024740369708407],
              [-20.3751772965884, -13.026495357735966],
              [-20.376949930380814, -13.027324951029431],
              [-20.377545955303226, -13.02601533673158],
              [-20.378881278273045, -13.02499105411114],
              [-20.381150877350397, -13.023982213538904],
              [-20.383948275714598, -13.02400551537722],
              [-20.386403726539076, -13.02640767563132],
              [-20.38835003584975, -13.027748130781436],
              [-20.389999327523007, -13.028379068595488],
              [-20.391087050492533, -13.029586673960296],
              [-20.390941682945872, -13.030720780500397],
              [-20.389398597949505, -13.031743623392254],
              [-20.3914404622779, -13.032937480127108],
              [-20.393051223504024, -13.032199872806515],
              [-20.395321375171385, -13.032716223045576],
              [-20.397094551873444, -13.031791253560613],
              [-20.399213058899548, -13.031339362788895],
              [-20.40308365494095, -13.031944662296347],
              [-20.403362288692012, -13.033009255184318],
              [-20.404692289406633, -13.033485778698413],
              [-20.405442972483616, -13.032940708676412]
            ]
          ],
          [
            [
              [-20.43979286989935, -13.045698806279226],
              [-20.43819781007544, -13.044456263873677],
              [-20.42914967239911, -13.041321883723464],
              [-20.42704160685013, -13.039769233527933],
              [-20.42308278328864, -13.038385720867977],
              [-20.420934770814313, -13.038070619155736],
              [-20.41894744433372, -13.037342721089278],
              [-20.41689814552686, -13.037330576395824],
              [-20.416232635247088, -13.036603791646122],
              [-20.414862028980615, -13.037590774043263],
              [-20.415117192658673, -13.03898677740699],
              [-20.41616268525897, -13.039026168907498],
              [-20.417312364799116, -13.040044216246955],
              [-20.420848832572002, -13.041399681426881],
              [-20.423712975867996, -13.043408608057776],
              [-20.42608368058623, -13.044325378736005],
              [-20.42758297953991, -13.046041863299404],
              [-20.430821445603648, -13.045055496789223],
              [-20.43545045141934, -13.046085305500387],
              [-20.438453883002047, -13.046279866391425],
              [-20.43979286989935, -13.045698806279226]
            ]
          ],
          [
            [
              [-20.52596340968961, -12.949231583970267],
              [-20.52365006527737, -12.946573159535536],
              [-20.521879500619722, -12.946414408585264],
              [-20.52248652274384, -12.944694958591569],
              [-20.521086337534957, -12.943423461085427],
              [-20.52040329315618, -12.940356810933691],
              [-20.5198313823181, -12.939716187250061],
              [-20.51993515477088, -12.937115243060381],
              [-20.519045101296815, -12.936024360009695],
              [-20.518070369483542, -12.936153819711077],
              [-20.517412671485367, -12.934958474775222],
              [-20.516157233482314, -12.93707922592219],
              [-20.514866342880154, -12.937808314012774],
              [-20.51333364866286, -12.936518103930306],
              [-20.51063375422094, -12.935202210728905],
              [-20.507564180553285, -12.934998039357966],
              [-20.50490091907713, -12.935497982655068],
              [-20.504213178192675, -12.937833956297164],
              [-20.5030530636864, -12.939931028551348],
              [-20.50325568861385, -12.943159181843896],
              [-20.50455980834891, -12.94582980085104],
              [-20.50349646810539, -12.947904587090616],
              [-20.504110150557594, -12.9491367643357],
              [-20.505088198265625, -12.949332963487326],
              [-20.50659439501904, -12.948529536427486],
              [-20.508790247706003, -12.94989118430178],
              [-20.509957084994742, -12.951268746102414],
              [-20.51113701040698, -12.953744923996977],
              [-20.512144373870516, -12.954684799408419],
              [-20.51229875801882, -12.956250466318796],
              [-20.513168133248865, -12.956421728915467],
              [-20.512984220772672, -12.95829235966777],
              [-20.514671219579252, -12.960725538018876],
              [-20.516984417946816, -12.960983639761885],
              [-20.51908070921421, -12.961618015876203],
              [-20.519386345019683, -12.962748326316142],
              [-20.520833915213622, -12.963059288812982],
              [-20.523257462444878, -12.962088347284963],
              [-20.524624782472337, -12.959988118784798],
              [-20.523808524797776, -12.95805172841829],
              [-20.524392594480865, -12.955610293275337],
              [-20.525739896346273, -12.955518188682726],
              [-20.526279128529744, -12.954564804241878],
              [-20.526520609571364, -12.952204501810332],
              [-20.52596340968961, -12.949231583970267]
            ]
          ],
          [
            [
              [-20.23162141541906, -11.741644652953227],
              [-20.228668475880234, -11.742344788164885],
              [-20.2261450683819, -11.742596356157106],
              [-20.224447614585163, -11.744383735829784],
              [-20.222733508278598, -11.745343664814593],
              [-20.22134444722725, -11.745048319083963],
              [-20.217739008731147, -11.746153801591365],
              [-20.21421146956818, -11.74786375619758],
              [-20.21285035695148, -11.748923573945556],
              [-20.20774838820046, -11.75111729592991],
              [-20.203376943876457, -11.752075230904497],
              [-20.19979000536009, -11.752108802914703],
              [-20.19854217577172, -11.753348100196227],
              [-20.19515779398252, -11.754787132221336],
              [-20.193762040982765, -11.754074993772157],
              [-20.190854910514222, -11.754292855419475],
              [-20.190429526496782, -11.755823813855882],
              [-20.188281391753545, -11.756071505025691],
              [-20.187165981982396, -11.75563948876435],
              [-20.185862272569135, -11.75626701158978],
              [-20.183270642541792, -11.755463358042425],
              [-20.178368760299445, -11.757135829491931],
              [-20.178090833424715, -11.758216021390172],
              [-20.176565377929542, -11.759286408883161],
              [-20.17612201391787, -11.760266642836374],
              [-20.174492352126215, -11.760714532549207],
              [-20.173172787942345, -11.761667388611006],
              [-20.173273399921015, -11.762567327202849],
              [-20.176552928708197, -11.76436829977289],
              [-20.17752239969182, -11.765458972143088],
              [-20.178006047147857, -11.767355848349967],
              [-20.179849851488278, -11.767689177420095],
              [-20.1812660295119, -11.769068802610287],
              [-20.18360525812146, -11.76930967471592],
              [-20.18534090412238, -11.76890535418199],
              [-20.186073718024613, -11.769404653009875],
              [-20.18864746238949, -11.769544141530062],
              [-20.18983321101162, -11.770260845127249],
              [-20.19188087423279, -11.772487039689421],
              [-20.194863931602075, -11.776714533089363],
              [-20.196452348640417, -11.777823387949987],
              [-20.198984497705403, -11.778456956152324],
              [-20.200229991901356, -11.777772416234077],
              [-20.208027042957728, -11.774326144538412],
              [-20.20969217995271, -11.773819440534156],
              [-20.212681169136875, -11.771127893619454],
              [-20.214627185526012, -11.767548251353848],
              [-20.21389716390538, -11.76457547267847],
              [-20.212979155732814, -11.762849380374112],
              [-20.214062873563105, -11.761322932376302],
              [-20.213940223349667, -11.759386987226282],
              [-20.214907001450776, -11.757865262805721],
              [-20.21611726942457, -11.757048335983429],
              [-20.21860247629619, -11.756346882061548],
              [-20.22064745493351, -11.754431305325891],
              [-20.223914006747986, -11.752989700724472],
              [-20.226462957356766, -11.752548656017996],
              [-20.227950641072756, -11.75000080060838],
              [-20.22824253779605, -11.747089464363945],
              [-20.229727731693, -11.744727421694195],
              [-20.23078660326712, -11.743875912131774],
              [-20.23162141541906, -11.741644652953227]
            ]
          ],
          [
            [
              [-20.527248820489877, -12.92271204709844],
              [-20.524784858029065, -12.922244589790385],
              [-20.52237468489648, -12.91784012018598],
              [-20.52144110019468, -12.917610772428556],
              [-20.520013481203414, -12.916223670438141],
              [-20.51855780373626, -12.91596755743585],
              [-20.517101844991018, -12.917060486285719],
              [-20.515911733618545, -12.918914694419845],
              [-20.515548931773633, -12.921298909030368],
              [-20.514617449388908, -12.92274265721276],
              [-20.514797963418335, -12.9241995562905],
              [-20.515821800183026, -12.92583298423106],
              [-20.516518266720546, -12.928018280409695],
              [-20.517630240656793, -12.928756434040604],
              [-20.519892125987404, -12.927473568334339],
              [-20.52190195538325, -12.927774399265664],
              [-20.521662900771435, -12.925980998132756],
              [-20.524873949910752, -12.923848134567434],
              [-20.527248820489877, -12.92271204709844]
            ]
          ],
          [
            [
              [-20.589413415582136, -12.986848861044736],
              [-20.587447097184302, -12.98440509609557],
              [-20.585897695149498, -12.981760868617823],
              [-20.58252612946254, -12.979503194175269],
              [-20.577525912422907, -12.980045676696143],
              [-20.57383659119688, -12.980022390779633],
              [-20.5715532941013, -12.981671821084502],
              [-20.570734354095244, -12.981716202029977],
              [-20.56843990373734, -12.983116726791616],
              [-20.565855977942014, -12.985640296094724],
              [-20.562719154172655, -12.986787920739639],
              [-20.55995623271151, -12.986942248565553],
              [-20.55777237833096, -12.986506610836857],
              [-20.556583010165536, -12.985483153959718],
              [-20.556249746293375, -12.984357291918048],
              [-20.556552151414714, -12.981624744520833],
              [-20.55718135334354, -12.980822859999748],
              [-20.5568006434277, -12.97950773168825],
              [-20.555659209245455, -12.978674408416],
              [-20.552550239363, -12.978057181477103],
              [-20.549404792039578, -12.978953083836345],
              [-20.546485273210095, -12.980547593480722],
              [-20.543087747285092, -12.980849165247708],
              [-20.54199264282655, -12.980405583922797],
              [-20.53891096368757, -12.980933061958332],
              [-20.538011886602046, -12.980442931302782],
              [-20.538546676005804, -12.97800910271115],
              [-20.535038588941198, -12.978485791172274],
              [-20.533627431099372, -12.97927010283042],
              [-20.529943012309698, -12.980288565514048],
              [-20.530579638691655, -12.98264663258155],
              [-20.528206489201914, -12.98310484627614],
              [-20.52706678621959, -12.982269257554801],
              [-20.52528510740177, -12.982186749885903],
              [-20.52437406914538, -12.984156383439686],
              [-20.521781138694628, -12.984564742490987],
              [-20.522230139211445, -12.987217888720545],
              [-20.520555781579816, -12.989667554802791],
              [-20.518445311851778, -12.990563927347516],
              [-20.51681945994353, -12.990693987488438],
              [-20.51617250313888, -12.992902356351184],
              [-20.51812659538688, -12.994100258102124],
              [-20.518478543397297, -12.996576569777774],
              [-20.517758173079375, -12.997648727688334],
              [-20.5186388871323, -12.998696730403061],
              [-20.520808140948358, -12.999292318352346],
              [-20.522298900460108, -13.000498828284124],
              [-20.52326757688431, -13.00253041637795],
              [-20.522976632927627, -13.00345238415577],
              [-20.520824067239765, -13.006919034963836],
              [-20.521952830424723, -13.007708812169485],
              [-20.523218347533195, -13.007161131561647],
              [-20.525019132569863, -13.00919949868163],
              [-20.527961359885868, -13.009764750287621],
              [-20.53008935748749, -13.011023142375002],
              [-20.53055776774293, -13.011867516818338],
              [-20.53036230280656, -13.014224596928464],
              [-20.52956131882173, -13.014764374793677],
              [-20.52923105888405, -13.018258625711603],
              [-20.52969543750791, -13.019506629069987],
              [-20.531573755341167, -13.020171309212769],
              [-20.53215318454095, -13.019783881327122],
              [-20.534186787129162, -13.020864492121397],
              [-20.534807613921295, -13.020014862850653],
              [-20.53765666155363, -13.019143451665176],
              [-20.538511031680365, -13.016931761659128],
              [-20.537700289132527, -13.01596674549508],
              [-20.539046940094075, -13.014694896857252],
              [-20.538295164437336, -13.011454556256346],
              [-20.541247666047294, -13.008497670188216],
              [-20.54239836914615, -13.005814911030468],
              [-20.54389661978357, -13.005159981604411],
              [-20.545666396427762, -13.005596204001664],
              [-20.548151798446376, -13.005360961167343],
              [-20.550573549938814, -13.004034799785057],
              [-20.550267826147294, -13.002599691429703],
              [-20.55089008926019, -13.001346935168376],
              [-20.552460625539982, -13.000774543331815],
              [-20.55413398621937, -13.001031415237176],
              [-20.556917454890584, -12.998663574588715],
              [-20.556857904515873, -12.996969580527606],
              [-20.558163761004135, -12.995755647198173],
              [-20.559412457249547, -12.995559817717469],
              [-20.56138980023165, -12.995994833792732],
              [-20.563578165045186, -12.997686163657683],
              [-20.563567312507043, -12.999095803926506],
              [-20.56902407416947, -13.002221986809108],
              [-20.571373136113564, -13.003925654396],
              [-20.574826941238857, -13.00526588073102],
              [-20.576220130027558, -13.00377724713661],
              [-20.578637255016897, -13.00284897690412],
              [-20.580510786284705, -13.004514052326108],
              [-20.58270523433432, -13.00394021322272],
              [-20.58297511957303, -13.001914077625473],
              [-20.58506311035574, -13.000711134725897],
              [-20.587406631308745, -12.99763627797325],
              [-20.58873313797161, -12.994653691293745],
              [-20.58870524918438, -12.993101466090828],
              [-20.587796692132827, -12.9894982778289],
              [-20.58943400115213, -12.987547850245383],
              [-20.589413415582136, -12.986848861044736]
            ]
          ],
          [
            [
              [-20.60647582391646, -12.95893221776587],
              [-20.604087952464464, -12.957901312512936],
              [-20.60230483288892, -12.958231065551663],
              [-20.601025749410425, -12.957685792925222],
              [-20.599389354140435, -12.955118080115568],
              [-20.598221274015103, -12.954395638975797],
              [-20.59760527099163, -12.952987874290859],
              [-20.59478339057683, -12.953918203251087],
              [-20.59084049201317, -12.954514974680036],
              [-20.58986039974975, -12.955352418829257],
              [-20.588187480348868, -12.955704085040862],
              [-20.583266044882215, -12.958992183258273],
              [-20.582074631874544, -12.96043167250505],
              [-20.579361473153973, -12.961181822948266],
              [-20.580979459158403, -12.96204890052471],
              [-20.580371666296728, -12.963750253938287],
              [-20.581335643897603, -12.965928823204038],
              [-20.58178670000454, -12.968130006542687],
              [-20.583476490759267, -12.971541296087066],
              [-20.584434843932648, -12.972667642016049],
              [-20.587271754767272, -12.974248093538382],
              [-20.59057681946481, -12.97521378387958],
              [-20.59456949971012, -12.975611778249194],
              [-20.595348284066755, -12.976228601232048],
              [-20.59732917729103, -12.973391309947324],
              [-20.600573181857772, -12.971857153138158],
              [-20.602522135412567, -12.970332875235975],
              [-20.604170133898613, -12.96762490574255],
              [-20.604083389868602, -12.965033918983654],
              [-20.60533928316655, -12.962420652672222],
              [-20.60613487021949, -12.961877105315951],
              [-20.60697359089633, -12.959665674368487],
              [-20.60647582391646, -12.95893221776587]
            ]
          ],
          [
            [
              [-20.634022587216265, -13.013626912989803],
              [-20.632370199414716, -13.012867739180034],
              [-20.631504233675564, -13.011515021121456],
              [-20.63192713131777, -13.00949759366796],
              [-20.631282451143058, -13.007990762740532],
              [-20.63091284956006, -13.004704917771132],
              [-20.627972960446737, -13.000933676752807],
              [-20.627673771314367, -12.998740027175446],
              [-20.62603499835539, -12.998230354044644],
              [-20.625844083104457, -12.996665328352856],
              [-20.626534739733792, -12.995088274034616],
              [-20.625925813272133, -12.994128318549631],
              [-20.623758619082654, -12.99440089796842],
              [-20.6206084375379, -12.99571610338519],
              [-20.61744980524005, -12.995975782550055],
              [-20.61667270520037, -12.994351333561497],
              [-20.61403490038515, -12.996044822753925],
              [-20.613780751112948, -12.998320639627424],
              [-20.61193553170861, -13.00047668051511],
              [-20.609690795497603, -13.001470302266002],
              [-20.607954683805133, -13.000982161291686],
              [-20.607577260576186, -13.003187023559411],
              [-20.60616940025607, -13.003173121385037],
              [-20.604439269007386, -13.003941528071442],
              [-20.60309740822873, -13.005421484698102],
              [-20.604541447443555, -13.008044540576876],
              [-20.604240103182008, -13.009526801762888],
              [-20.605090958583755, -13.010832711903898],
              [-20.6063114769146, -13.01421560733949],
              [-20.607752620523765, -13.015178661802397],
              [-20.610212068281555, -13.018516914227227],
              [-20.61243534975283, -13.020098307645345],
              [-20.614187841429715, -13.020230649023794],
              [-20.616239329812014, -13.019283040299364],
              [-20.618591212628942, -13.01972446719335],
              [-20.622124652313815, -13.01907397184589],
              [-20.62388432389675, -13.017388964160693],
              [-20.626362465793605, -13.016891214418253],
              [-20.628193855730906, -13.015490993632007],
              [-20.629886506044308, -13.015182452898365],
              [-20.63142748861448, -13.01632180528175],
              [-20.632558761836183, -13.015241606994527],
              [-20.634300463751444, -13.014920308351538],
              [-20.634022587216265, -13.013626912989803]
            ]
          ],
          [
            [
              [-20.303043460983417, -11.530581954936],
              [-20.30214498308034, -11.52961611969892],
              [-20.302147898403152, -11.527285387420411],
              [-20.301391728970312, -11.526421898113814],
              [-20.3009699889017, -11.524333708952538],
              [-20.300027561450115, -11.523196442100827],
              [-20.299594003764327, -11.520792398113347],
              [-20.29733156842046, -11.51947966771809],
              [-20.29559695289099, -11.517603038277704],
              [-20.293086851017165, -11.516945127245153],
              [-20.291761095177232, -11.518549934468018],
              [-20.28895537657161, -11.519446983628335],
              [-20.285525420650618, -11.519356356158507],
              [-20.28264864765205, -11.517714574713041],
              [-20.280991376817912, -11.517574853628812],
              [-20.27834587026865, -11.516651310436739],
              [-20.27631876430976, -11.516875137091098],
              [-20.274425025149995, -11.518890680356876],
              [-20.273669377688012, -11.520284797678126],
              [-20.269637085689332, -11.521819916627425],
              [-20.26700451274236, -11.522487208981648],
              [-20.26407725757694, -11.522815280095784],
              [-20.260789952839538, -11.522455386619509],
              [-20.25724131831435, -11.52243193029567],
              [-20.248352519068092, -11.521610352890825],
              [-20.24340662953006, -11.519895899116626],
              [-20.242742332818597, -11.519373593182657],
              [-20.242237742590085, -11.517560130328983],
              [-20.241154401265025, -11.51693476699072],
              [-20.241057791211674, -11.515546102747722],
              [-20.23923369793165, -11.515282763461343],
              [-20.236254220103138, -11.515845638349669],
              [-20.23648115738124, -11.517111267083248],
              [-20.239004944983684, -11.519688026930961],
              [-20.240027300027563, -11.521080236551125],
              [-20.241329885861365, -11.520650280612537],
              [-20.244466802585972, -11.522167334343346],
              [-20.24728184031375, -11.525152199706493],
              [-20.24963471018732, -11.52822778819185],
              [-20.25215185001019, -11.531948176365727],
              [-20.253421458571275, -11.534581610635271],
              [-20.25369242003138, -11.537937468715118],
              [-20.257494999375158, -11.541507840821842],
              [-20.2593728467538, -11.541963670444906],
              [-20.262037051283123, -11.542044804073571],
              [-20.264477807125424, -11.543070820471632],
              [-20.266072675938883, -11.544873627667938],
              [-20.26973129188737, -11.5440258280242],
              [-20.272068932835943, -11.544368015844011],
              [-20.274249006485014, -11.545182380463537],
              [-20.27606421244376, -11.54693147961847],
              [-20.275497614910464, -11.548623713627396],
              [-20.276624977697185, -11.550312971515064],
              [-20.27816599097949, -11.550255922224995],
              [-20.280388056092775, -11.553048662337801],
              [-20.283418703495794, -11.554637748889],
              [-20.28510233506934, -11.554407910145724],
              [-20.28545121611415, -11.553682028411524],
              [-20.283766089794526, -11.55281498481764],
              [-20.282438490381498, -11.553346438595977],
              [-20.28065476260455, -11.552000479200283],
              [-20.281756130239394, -11.550038658870646],
              [-20.28144684422846, -11.547646308863053],
              [-20.28073525571742, -11.546769525868234],
              [-20.282841038975462, -11.54474457188985],
              [-20.280408856107833, -11.543856209818458],
              [-20.27999742211075, -11.5425178067359],
              [-20.28077484767605, -11.54020248653159],
              [-20.28173381011301, -11.538870791818074],
              [-20.284337049894887, -11.538071719395326],
              [-20.288120801044904, -11.53798680182386],
              [-20.28895414621166, -11.539518033879851],
              [-20.291674513527425, -11.539716810821137],
              [-20.29202601755334, -11.5382820127372],
              [-20.291550720323833, -11.535977232350096],
              [-20.293366283634207, -11.534913177634165],
              [-20.295450720399554, -11.534444974852438],
              [-20.30042122773678, -11.53166415944572],
              [-20.302189927674686, -11.531592844112005],
              [-20.303043460983417, -11.530581954936]
            ]
          ],
          [
            [
              [-20.784061529187756, -13.033585837205456],
              [-20.782094652160517, -13.032105001036804],
              [-20.78158512703276, -13.027823644312361],
              [-20.780285693225913, -13.024908372115837],
              [-20.778627475179185, -13.023401292697915],
              [-20.778969792915547, -13.02133913624829],
              [-20.77844799350617, -13.020558727524502],
              [-20.77513729810166, -13.01815230423709],
              [-20.774823315309384, -13.017167794163129],
              [-20.77499503691593, -13.013478485263656],
              [-20.7729601494745, -13.010548821549369],
              [-20.770476934690393, -13.01026374383817],
              [-20.76712863276596, -13.011056576211633],
              [-20.765010464897717, -13.010172323916299],
              [-20.763222899596116, -13.011127988847486],
              [-20.7600427004819, -13.00919499472565],
              [-20.758067057038264, -13.009438313010875],
              [-20.75721495632744, -13.008589829449118],
              [-20.756046930580332, -13.006151135817218],
              [-20.75405697859551, -13.005942527087923],
              [-20.75284716537384, -13.004728536808267],
              [-20.7541883022039, -13.003077263117273],
              [-20.753889719243507, -13.002343054268616],
              [-20.750946509294053, -13.0005024885859],
              [-20.749544773086836, -12.999944168101552],
              [-20.74691027594922, -13.000654954237213],
              [-20.7463895865299, -13.002049152670331],
              [-20.744811958029384, -13.000624370245461],
              [-20.742894514274436, -13.002469030109724],
              [-20.740341365420978, -13.002298960347325],
              [-20.740283812581065, -13.000493666617693],
              [-20.73803048481417, -12.998681585348374],
              [-20.73759639723534, -12.997627815268908],
              [-20.73515310934224, -12.997075993352917],
              [-20.7311684562895, -13.000394806605561],
              [-20.73013504266193, -12.999641954174965],
              [-20.72816199787852, -13.000083270941685],
              [-20.727382248475344, -13.00149008481255],
              [-20.724862244217007, -13.003431065966126],
              [-20.722593699438992, -13.003742999432445],
              [-20.720811475546032, -13.00651051844775],
              [-20.719279539583304, -13.00704267982546],
              [-20.718365500259793, -13.009139082800358],
              [-20.716517368297858, -13.010861237608731],
              [-20.7172824130977, -13.012389481317816],
              [-20.716499300663592, -13.01319039525997],
              [-20.718641312219372, -13.015388084062504],
              [-20.717139479491046, -13.018439787650236],
              [-20.71903175915204, -13.018880455756607],
              [-20.71969763927698, -13.019827325397786],
              [-20.71961685156962, -13.02171820780994],
              [-20.723036052320932, -13.023195590066559],
              [-20.724417007373916, -13.024875581225649],
              [-20.727494950208534, -13.026842261563612],
              [-20.7276337785532, -13.027971449968842],
              [-20.73058200765945, -13.031235652512143],
              [-20.732221391145195, -13.03249811712574],
              [-20.7350118615208, -13.032360227955516],
              [-20.739045557058766, -13.03256971059703],
              [-20.740788622648605, -13.03183131016481],
              [-20.74339420282211, -13.031586082900002],
              [-20.745009564027534, -13.029765148937262],
              [-20.747758581112734, -13.028673037841195],
              [-20.751225071576687, -13.028514728681609],
              [-20.75283741457982, -13.028870838702792],
              [-20.754468686500076, -13.030487944242191],
              [-20.756474525644713, -13.030745159008598],
              [-20.760070738594887, -13.031666833621385],
              [-20.760977578365832, -13.033313925599705],
              [-20.761753335340597, -13.033473929330059],
              [-20.762796550957198, -13.0352389644847],
              [-20.76380439364889, -13.035087019591458],
              [-20.768233892271034, -13.037167380903837],
              [-20.77066275447269, -13.040003834580846],
              [-20.77473935261243, -13.042324741259229],
              [-20.775821132812975, -13.042052443046153],
              [-20.77863122346085, -13.036831654988703],
              [-20.779610292023456, -13.035976423102097],
              [-20.782376732236646, -13.035532288702544],
              [-20.784266692501152, -13.03475098813499],
              [-20.784061529187756, -13.033585837205456]
            ]
          ],
          [
            [
              [-20.853274765889516, -13.015622124775307],
              [-20.851337575403317, -13.016222906760493],
              [-20.84938971208959, -13.013881570221747],
              [-20.848139734092346, -13.0112089155928],
              [-20.84590818754396, -13.009753425405735],
              [-20.84323956197975, -13.00978047729784],
              [-20.839615033170837, -13.012285121999444],
              [-20.839453724702732, -13.013240029588337],
              [-20.839939989205938, -13.016007619089299],
              [-20.841220051327277, -13.018216423577861],
              [-20.840574573229727, -13.019905145405671],
              [-20.841992000586508, -13.020099323340114],
              [-20.846179742268266, -13.01927688661667],
              [-20.84940752460872, -13.017430835562587],
              [-20.8516387178089, -13.017719178706328],
              [-20.853413452169047, -13.01690658357018],
              [-20.853274765889516, -13.015622124775307]
            ]
          ],
          [
            [
              [-20.888756862466966, -13.034493951236334],
              [-20.887651374083777, -13.032186694952198],
              [-20.887598019525274, -13.031030332078654],
              [-20.88643621095662, -13.029094076618007],
              [-20.884740333205162, -13.027703927153093],
              [-20.88187050104356, -13.026058819960548],
              [-20.88143484076676, -13.024850197104389],
              [-20.877178191167957, -13.0235140563645],
              [-20.876392514782477, -13.02371777405478],
              [-20.87369861240617, -13.023094694384868],
              [-20.872095411996764, -13.022035856686255],
              [-20.871224684866498, -13.02231230023973],
              [-20.869581926662715, -13.024770377022962],
              [-20.86943517235485, -13.026739553101676],
              [-20.868117062454296, -13.02769057246163],
              [-20.86798272323376, -13.028741988154612],
              [-20.8660101240135, -13.029607501151391],
              [-20.866131726057993, -13.032372186291443],
              [-20.863689917553707, -13.034222785378775],
              [-20.86303474940208, -13.03703553434434],
              [-20.864769986115462, -13.038774179441708],
              [-20.868578213355903, -13.043487361385806],
              [-20.868197494432028, -13.044602853318274],
              [-20.86934422314075, -13.045527958206842],
              [-20.871016484684905, -13.046062469765666],
              [-20.8733904288806, -13.047433303579268],
              [-20.874167269855043, -13.047384912405635],
              [-20.87446273506573, -13.049242412730475],
              [-20.875558226328568, -13.049977329970247],
              [-20.876363206384173, -13.048292967126482],
              [-20.879876897159765, -13.048044995035008],
              [-20.87991804125699, -13.047423604306017],
              [-20.882196343708948, -13.047087694116046],
              [-20.884262327860633, -13.043854398732554],
              [-20.887014595478046, -13.043903531835653],
              [-20.88750290414566, -13.045303855147829],
              [-20.889815805717266, -13.045670455896834],
              [-20.89017899220472, -13.044303418536131],
              [-20.88919861246072, -13.043030943848315],
              [-20.88961540762088, -13.039359608311337],
              [-20.888756862466966, -13.034493951236334]
            ]
          ],
          [
            [
              [-21.18080378649944, -13.030075811395117],
              [-21.179607484432086, -13.028458775896874],
              [-21.178474523343816, -13.025077715572952],
              [-21.176065351478194, -13.022954273819696],
              [-21.175318862717663, -13.021237652590862],
              [-21.169731163236364, -13.018696469748958],
              [-21.16771008847737, -13.016079990463336],
              [-21.16576709057331, -13.01300581836666],
              [-21.16387190341021, -13.012612860756505],
              [-21.161739561735445, -13.011054420795627],
              [-21.16082096823563, -13.008207589814518],
              [-21.158743606450987, -13.008634980041805],
              [-21.157971074435878, -13.007183764469712],
              [-21.155966878651373, -13.008128750696546],
              [-21.15488266062665, -13.006970165963018],
              [-21.151471952138024, -13.007102407256601],
              [-21.150930170853417, -13.006433010933002],
              [-21.149031749172483, -13.006834557260488],
              [-21.145524379108316, -13.006454097293885],
              [-21.14370878804679, -13.005781020682093],
              [-21.14209161030838, -13.00569358256328],
              [-21.138817301275083, -13.003299579765118],
              [-21.13764766527533, -13.00211339381936],
              [-21.135256938286968, -13.002368428158693],
              [-21.132063982565914, -13.00169361907943],
              [-21.12864065816323, -13.002132085158513],
              [-21.12769054713008, -13.002780056900828],
              [-21.127416448890024, -13.004290551458332],
              [-21.12476961666919, -13.003667446219076],
              [-21.123878360778196, -13.004426595198915],
              [-21.12278901560638, -13.003781212839636],
              [-21.121957865002926, -13.005291882441867],
              [-21.123845955299014, -13.006766379537044],
              [-21.123805822680172, -13.008262944307324],
              [-21.120814326848283, -13.010910684152975],
              [-21.119054437872006, -13.013421451490775],
              [-21.11582673451951, -13.014263019787876],
              [-21.114613822480727, -13.013829823518842],
              [-21.11347284200192, -13.015374577490013],
              [-21.110786742112534, -13.016346888223872],
              [-21.108375971656923, -13.016807132170634],
              [-21.108264179784115, -13.01824690233722],
              [-21.107008966112254, -13.019310223809423],
              [-21.105340792034546, -13.021690937297322],
              [-21.10576395455346, -13.025980509497353],
              [-21.106616879317045, -13.028461605574583],
              [-21.106288682297635, -13.031627200968474],
              [-21.108247991370302, -13.030882418614066],
              [-21.109584797043723, -13.031282888024858],
              [-21.11109252484153, -13.033276655191319],
              [-21.113589712579323, -13.033741847028224],
              [-21.114394301625243, -13.033314464175344],
              [-21.116619189742927, -13.033572351759837],
              [-21.119419273701943, -13.035440201384644],
              [-21.121387246180703, -13.035178367837212],
              [-21.123147502328383, -13.036025455596924],
              [-21.124943026650246, -13.03599050067942],
              [-21.129077945669643, -13.036872722577815],
              [-21.130593630830464, -13.039608829415004],
              [-21.132022286620494, -13.039315781121818],
              [-21.134580064620046, -13.041250354079331],
              [-21.136210232487553, -13.040644095561436],
              [-21.136400252805537, -13.039385203932536],
              [-21.13748729903372, -13.038467631308652],
              [-21.14069472378038, -13.036986969363216],
              [-21.14284517463227, -13.036979839047211],
              [-21.143465246517454, -13.038553007816207],
              [-21.14620423876281, -13.039101078652354],
              [-21.148761038307356, -13.040931623032032],
              [-21.150428208641028, -13.040904432934052],
              [-21.151448403191146, -13.039849988349916],
              [-21.157194952397244, -13.039224727363328],
              [-21.15835377263228, -13.040725120949707],
              [-21.159589324728678, -13.040765732534565],
              [-21.163056578498935, -13.04360034779489],
              [-21.16430634005502, -13.041427312534594],
              [-21.164233577242467, -13.040728237275887],
              [-21.165762018740192, -13.039684562128004],
              [-21.168353785590615, -13.038728671142863],
              [-21.17084571027918, -13.039059411744594],
              [-21.17405535298045, -13.037672676734084],
              [-21.176442658085335, -13.037286412015538],
              [-21.17940963557379, -13.035709091934374],
              [-21.1814248093701, -13.03226556594494],
              [-21.18080378649944, -13.030075811395117]
            ]
          ],
          [
            [
              [-21.26925899240644, -13.075526470804133],
              [-21.26810093198546, -13.075237323006506],
              [-21.267411636770653, -13.07703634265394],
              [-21.2683293538443, -13.077238681830057],
              [-21.26950266301698, -13.076334891450124],
              [-21.26925899240644, -13.075526470804133]
            ]
          ],
          [
            [
              [-21.488262532108433, -12.99006541247948],
              [-21.48585729463506, -12.988927841849403],
              [-21.484143066578437, -12.989447770281283],
              [-21.482003916712095, -12.992170711915525],
              [-21.479426475575078, -12.993522021760288],
              [-21.47697296974182, -12.99442040498283],
              [-21.477029605282567, -12.996115174337639],
              [-21.47383316688064, -12.996874344055241],
              [-21.472661030398346, -12.996398738664995],
              [-21.468917599896276, -12.99763342024656],
              [-21.467719584190327, -12.99690620501742],
              [-21.466199843490614, -12.998039051914807],
              [-21.464074791950964, -12.997435646622622],
              [-21.458779397390096, -12.997839262763723],
              [-21.456097026226534, -12.99750681512958],
              [-21.454982803148106, -12.99670167969072],
              [-21.45013731367608, -12.994791189559997],
              [-21.449369761091905, -12.996265414967066],
              [-21.452893346021526, -12.997900639367503],
              [-21.453652913555175, -13.001145003498424],
              [-21.454838051945444, -13.002343522732566],
              [-21.455167079592563, -13.004059253345519],
              [-21.456173416229806, -13.00401547735709],
              [-21.45833194034358, -13.00523282548379],
              [-21.458364901120877, -13.005844995992604],
              [-21.452552033500798, -13.00733408296114],
              [-21.451811113201998, -13.008386547834256],
              [-21.450009990474122, -13.007787060119107],
              [-21.448862919670354, -13.008235271268934],
              [-21.445954676019777, -13.007189890871226],
              [-21.44474194299143, -13.005221289537458],
              [-21.44195824191751, -13.007455584342784],
              [-21.44421743589217, -13.0084889287193],
              [-21.44458493857355, -13.00931171807793],
              [-21.44385384542332, -13.010567684695202],
              [-21.44586832535325, -13.011674280789173],
              [-21.44272613959543, -13.012097998448887],
              [-21.44200756909406, -13.012883705607091],
              [-21.441848426883517, -13.015782991333774],
              [-21.44110210136418, -13.01818438046505],
              [-21.439386242954477, -13.019216557631292],
              [-21.438611542851696, -13.01846347077528],
              [-21.439447801977785, -13.015154057938501],
              [-21.438988888734055, -13.013528761010681],
              [-21.437424939326775, -13.011975429908416],
              [-21.435693021764045, -13.012441963073956],
              [-21.43438129599177, -13.01117619112664],
              [-21.432052507494948, -13.00974795141059],
              [-21.4308568350223, -13.007825881189918],
              [-21.429980683827385, -13.007259079946378],
              [-21.425724165109294, -13.008737878452267],
              [-21.423122804709354, -13.008996456792438],
              [-21.41994652597625, -13.010669207271155],
              [-21.418644285650768, -13.011989593809833],
              [-21.41687229685517, -13.010446011178631],
              [-21.414913195318555, -13.010356221630605],
              [-21.41282314635801, -13.010875206961535],
              [-21.411188195342383, -13.010792086108703],
              [-21.409063727020982, -13.011372202765765],
              [-21.40745160304096, -13.01050534932278],
              [-21.40340194119499, -13.010414702017004],
              [-21.401474048468977, -13.010935318151267],
              [-21.398207986473498, -13.009575560302165],
              [-21.3949020079485, -13.01065944126811],
              [-21.39281061921785, -13.01014053831739],
              [-21.39141358398777, -13.011330631161506],
              [-21.390043026213224, -13.014841064764248],
              [-21.385533611228436, -13.01705416431268],
              [-21.38366263383451, -13.015692625048528],
              [-21.38114469444698, -13.01483272372382],
              [-21.37870577357044, -13.015087371328555],
              [-21.3772775591313, -13.013077773890577],
              [-21.37625206811199, -13.013742461928704],
              [-21.376016605834845, -13.015053290982292],
              [-21.37463250732431, -13.016288864753337],
              [-21.375962336074185, -13.01781051527049],
              [-21.375927695634985, -13.01942412191143],
              [-21.37747887983052, -13.019587702509696],
              [-21.378499998014405, -13.020631736558585],
              [-21.38414236468863, -13.024813865647664],
              [-21.383563201348878, -13.026227269299214],
              [-21.380366024518576, -13.026290866350593],
              [-21.379093896406015, -13.027545897143833],
              [-21.379044294743885, -13.030666259180313],
              [-21.379825103436872, -13.032144217518347],
              [-21.37793334433672, -13.032960641684404],
              [-21.37700564643696, -13.03049051197532],
              [-21.37576640658497, -13.033236594081739],
              [-21.372504983169755, -13.0322299693597],
              [-21.37052722796665, -13.029654946652087],
              [-21.368984535995185, -13.030212256445239],
              [-21.367125659105056, -13.032518299315091],
              [-21.36786562823246, -13.034215209668389],
              [-21.36712743478181, -13.035467313038378],
              [-21.365696930075995, -13.03604283155737],
              [-21.36146559077873, -13.036922706142548],
              [-21.36093603166791, -13.036250057927122],
              [-21.36270325227146, -13.033817293828617],
              [-21.36251323402984, -13.032683067625312],
              [-21.361000172498976, -13.032816648057105],
              [-21.35895558363328, -13.033830500766474],
              [-21.358138223443458, -13.03500133842979],
              [-21.359296021614867, -13.035799960709424],
              [-21.358174699019138, -13.039284981044709],
              [-21.356588021970023, -13.039180769534854],
              [-21.353717857438244, -13.039607480416144],
              [-21.352011041644804, -13.038244815368301],
              [-21.351874507812347, -13.03554317732175],
              [-21.350606125716777, -13.036121398622196],
              [-21.349340354472883, -13.037577928287327],
              [-21.350608268587997, -13.039431054251223],
              [-21.349831349978082, -13.041779538215488],
              [-21.347158684022336, -13.04354382558479],
              [-21.34841462390927, -13.044314863052227],
              [-21.34831750487701, -13.045740362859371],
              [-21.345157385780006, -13.04749154934962],
              [-21.34410738917164, -13.046866683601289],
              [-21.343189836542138, -13.044754763188012],
              [-21.341062078099682, -13.044806754653923],
              [-21.33938991610869, -13.045294533090768],
              [-21.33579210612116, -13.045619230947157],
              [-21.334591574661616, -13.044676022548726],
              [-21.329294927196347, -13.044873735156166],
              [-21.32726314921556, -13.046808815832557],
              [-21.324739867715024, -13.04749049589074],
              [-21.323115283889848, -13.049358449834164],
              [-21.322322072087946, -13.052018781189068],
              [-21.320339251281442, -13.052542496612842],
              [-21.31832087383384, -13.052249068820933],
              [-21.315268341066037, -13.050497466990203],
              [-21.311346084677176, -13.049928105564248],
              [-21.311424449689916, -13.050887215837438],
              [-21.309760194935606, -13.051575720730556],
              [-21.30754292810492, -13.050977048856245],
              [-21.307482248029313, -13.052183063263824],
              [-21.306121877609165, -13.05211162202275],
              [-21.305221361863836, -13.054077179909479],
              [-21.30617071222045, -13.054733082976846],
              [-21.306321240533308, -13.055929975848779],
              [-21.308075836761603, -13.056766838728821],
              [-21.308871999871165, -13.058500953116262],
              [-21.307870028415717, -13.059255799952867],
              [-21.304562601114853, -13.060004802174202],
              [-21.30346806504447, -13.05975244930985],
              [-21.301914408849075, -13.056582898711206],
              [-21.302740172626248, -13.054897412066815],
              [-21.301327723725436, -13.054478416122477],
              [-21.2994835455724, -13.05475237284359],
              [-21.297984712422394, -13.054048319415681],
              [-21.29674500016633, -13.055077346230375],
              [-21.296182021594348, -13.057099935380808],
              [-21.29261252756972, -13.05962692905707],
              [-21.29074276948287, -13.059286970893085],
              [-21.28908428259936, -13.061055883791035],
              [-21.28690474932021, -13.06075289810405],
              [-21.285524409499367, -13.062027971961507],
              [-21.284483542295277, -13.06124230438191],
              [-21.282044011445418, -13.062201441307627],
              [-21.280498772218877, -13.061870324022639],
              [-21.279518216630333, -13.062874932674307],
              [-21.276470726710055, -13.06483381617074],
              [-21.274018051775315, -13.06610495494455],
              [-21.26631865861049, -13.068257189103141],
              [-21.265258919221477, -13.069180136222258],
              [-21.26638040848303, -13.070770345861499],
              [-21.267790390366827, -13.070831885213702],
              [-21.272021889556747, -13.069776302892778],
              [-21.274582038897798, -13.06868119167113],
              [-21.27779049455698, -13.06884644163062],
              [-21.279090010641827, -13.069248813170715],
              [-21.280656611896116, -13.07071141595466],
              [-21.2830094731383, -13.070346059470808],
              [-21.283752760169573, -13.069616149116284],
              [-21.286674719423758, -13.070068845083318],
              [-21.287905813634705, -13.068474604695323],
              [-21.289632348967583, -13.068339773271324],
              [-21.29253901749387, -13.067503514559743],
              [-21.29624922079588, -13.065608123630362],
              [-21.302178365199776, -13.066431790330382],
              [-21.304985331142404, -13.067379927728865],
              [-21.3088503675967, -13.068280670593602],
              [-21.311084632221917, -13.068048660807962],
              [-21.31244091522026, -13.06739771432995],
              [-21.315518567078417, -13.06676597998379],
              [-21.317586997117196, -13.065287719162589],
              [-21.31934631491787, -13.065605750443725],
              [-21.32192886029761, -13.062477238812686],
              [-21.32546967772398, -13.062484518129141],
              [-21.327751648853226, -13.063633151787904],
              [-21.331853690258605, -13.062492986154295],
              [-21.333147282067426, -13.061288886219584],
              [-21.334775715689293, -13.06117748044758],
              [-21.336591636162783, -13.06220165269369],
              [-21.339756063807155, -13.061849766422368],
              [-21.342469770325163, -13.060903520358131],
              [-21.344663379363748, -13.059487441541911],
              [-21.34638340648982, -13.060021044748238],
              [-21.346734966135582, -13.059245405225203],
              [-21.349859052273796, -13.05911018923974],
              [-21.350826276505273, -13.059811455416543],
              [-21.353128291447664, -13.059967096286636],
              [-21.353183927898428, -13.0611939816137],
              [-21.355838869877072, -13.060055353755137],
              [-21.35718853489234, -13.06147315020392],
              [-21.360554613083327, -13.061420604105644],
              [-21.362311329460564, -13.063807374966244],
              [-21.363379103743863, -13.061525988870406],
              [-21.36251483888444, -13.060639276573234],
              [-21.363029121619643, -13.059349056373524],
              [-21.36570854801833, -13.057941810969146],
              [-21.36792898371205, -13.057135334437204],
              [-21.36860258650087, -13.057404070437318],
              [-21.37140480721616, -13.055700424019728],
              [-21.371691116029336, -13.054891188484929],
              [-21.375293464916197, -13.054039647232184],
              [-21.377030257560307, -13.054098926084471],
              [-21.377965858329596, -13.053305839554842],
              [-21.382126957584006, -13.055812485595125],
              [-21.38016658402683, -13.058151941276538],
              [-21.380288507452473, -13.059411978150765],
              [-21.382061030796233, -13.058890357609727],
              [-21.38276424272858, -13.059771941415752],
              [-21.384073618257897, -13.060008536191733],
              [-21.384975048194022, -13.058757936660909],
              [-21.387293824854176, -13.05843772882799],
              [-21.386886017906566, -13.055913600171062],
              [-21.389686716399023, -13.054725060024328],
              [-21.391438828203096, -13.054311622439933],
              [-21.39209830466225, -13.055050188969904],
              [-21.394584165207878, -13.055612934307712],
              [-21.39524324047175, -13.053758834427263],
              [-21.397309432496638, -13.05159263911469],
              [-21.39813945657877, -13.048910260218028],
              [-21.397607294850427, -13.04771965979714],
              [-21.394999345573964, -13.04693558688163],
              [-21.394988722826305, -13.045694693545379],
              [-21.397497529061827, -13.045471413399396],
              [-21.400404029429147, -13.044455770126557],
              [-21.40198674949206, -13.043157948386579],
              [-21.403123547980705, -13.043702330997334],
              [-21.406626601928924, -13.043908627012346],
              [-21.407770882893782, -13.042584281209065],
              [-21.410758530592158, -13.040453442091808],
              [-21.41292175861968, -13.039811186306657],
              [-21.413675699209346, -13.037928244689605],
              [-21.41459462158693, -13.037603417927343],
              [-21.41546323379543, -13.039004363246503],
              [-21.41546645229629, -13.040559202515203],
              [-21.417267113858987, -13.040646354175628],
              [-21.417775993287112, -13.039353987628894],
              [-21.42011165903017, -13.038918682433348],
              [-21.4210341677383, -13.037918179245517],
              [-21.41809332000838, -13.034022274591539],
              [-21.419279339456896, -13.032321630174554],
              [-21.42145423870119, -13.032918392235688],
              [-21.42267473124429, -13.035095880566306],
              [-21.423534150939957, -13.034580867384635],
              [-21.42541028271549, -13.03542196864751],
              [-21.42713478199111, -13.034752555669469],
              [-21.429770805499082, -13.034589004677255],
              [-21.43383740546659, -13.03555434612098],
              [-21.43520801200172, -13.033588552972489],
              [-21.43680780389755, -13.033888691679586],
              [-21.439363193234897, -13.033124849592097],
              [-21.440471907006472, -13.032378278322431],
              [-21.448081602586225, -13.032123757062484],
              [-21.44843428539297, -13.032900394089829],
              [-21.45075281053485, -13.03308812518676],
              [-21.452581506104103, -13.032747080949367],
              [-21.45790599782047, -13.027982049715684],
              [-21.458176293600218, -13.0269664255806],
              [-21.45946961159887, -13.025955113276474],
              [-21.461405707994764, -13.026463017159436],
              [-21.46300499856443, -13.027435748976279],
              [-21.465174098636027, -13.026471527547441],
              [-21.465719380536257, -13.025476539828208],
              [-21.4649827952753, -13.023154215787539],
              [-21.467913804443178, -13.02221957996935],
              [-21.470952353254457, -13.022809344835387],
              [-21.47169360491888, -13.021755203210851],
              [-21.47143687192603, -13.017731197928121],
              [-21.472220705154253, -13.01495104859263],
              [-21.474251931047316, -13.013559362672499],
              [-21.474848734929544, -13.012392693629382],
              [-21.473910806107206, -13.009613869892622],
              [-21.47465494205294, -13.007728449763997],
              [-21.47454270228161, -13.005686578519407],
              [-21.476274347408847, -13.00454055495068],
              [-21.47539963987733, -13.003819080108444],
              [-21.476399236426417, -13.00206395429651],
              [-21.478198092678177, -13.002142605723677],
              [-21.478714501785557, -13.003595060631495],
              [-21.481030298370012, -13.003776511802544],
              [-21.48347392807112, -13.00199870513469],
              [-21.485233472901374, -12.998248080213308],
              [-21.486526998232463, -12.998426895690853],
              [-21.486574476134383, -12.995714124935894],
              [-21.485088528599864, -12.99476357384052],
              [-21.48659909724563, -12.993267709115058],
              [-21.488310612899923, -12.993578672763427],
              [-21.488262532108433, -12.99006541247948]
            ]
          ],
          [
            [
              [-21.592015884338362, -13.000086240542045],
              [-21.591201974515354, -12.998176424580356],
              [-21.58864123152601, -12.994803873416602],
              [-21.587106559376757, -12.996713056363015],
              [-21.58764996499252, -12.999201326996518],
              [-21.587416022487638, -13.000550174390174],
              [-21.590585184748456, -13.001077751930875],
              [-21.592015884338362, -13.000086240542045]
            ]
          ],
          [
            [
              [-21.60797776969714, -12.939694687364273],
              [-21.60587264655535, -12.938534268161154],
              [-21.604466489329965, -12.938350733028047],
              [-21.603120229672232, -12.937368667283689],
              [-21.60157674070916, -12.937747532342623],
              [-21.600997884961007, -12.938604469871471],
              [-21.602022276898253, -12.939427403059463],
              [-21.60309798866123, -12.941222495542767],
              [-21.60586204332863, -12.940461477470937],
              [-21.607900555247635, -12.940602736380605],
              [-21.60797776969714, -12.939694687364273]
            ]
          ],
          [
            [
              [-21.701363166698535, -12.88925460737039],
              [-21.699320005228547, -12.89014503666247],
              [-21.69839135971908, -12.891224200453612],
              [-21.69868672281048, -12.893055845785995],
              [-21.701466139771192, -12.893465596367042],
              [-21.70118121873949, -12.891187449801967],
              [-21.701363166698535, -12.88925460737039]
            ]
          ],
          [
            [
              [-21.76469675987825, -12.94146861796259],
              [-21.76211417936393, -12.94120751678394],
              [-21.76061780337985, -12.941587820205283],
              [-21.758255047733147, -12.94339986412746],
              [-21.75790907808771, -12.944610878144283],
              [-21.75647566477451, -12.94549356590131],
              [-21.754917991883744, -12.944898907363969],
              [-21.754028969097305, -12.943721827915422],
              [-21.754540370325923, -12.941882572314972],
              [-21.75053622221916, -12.943648797615998],
              [-21.748040762620807, -12.942206521351515],
              [-21.7464912800269, -12.940040521242521],
              [-21.744754134500944, -12.939870034157316],
              [-21.74512206788287, -12.941110631385035],
              [-21.744707436493286, -12.942917644367673],
              [-21.743675546810984, -12.944662792685186],
              [-21.741038762703806, -12.945670445043566],
              [-21.73917105195222, -12.945593497248263],
              [-21.737914466378633, -12.946678083876675],
              [-21.73557703997249, -12.946333748763752],
              [-21.733522797399676, -12.944747650443597],
              [-21.73316046543938, -12.942721544020321],
              [-21.731326003262254, -12.942580493715665],
              [-21.729755478982504, -12.941779705100394],
              [-21.72845565532588, -12.941937099155531],
              [-21.72724868913274, -12.942847822359951],
              [-21.72622737974714, -12.94254929379496],
              [-21.72506636062523, -12.943915467331628],
              [-21.72376925484526, -12.943601064165081],
              [-21.72322413360239, -12.942470033391682],
              [-21.721466216562895, -12.943191923966943],
              [-21.71976191719006, -12.943112426678432],
              [-21.716994611713844, -12.944210042442787],
              [-21.715394556731855, -12.945559138017543],
              [-21.714801219519668, -12.946846354617756],
              [-21.715069545809236, -12.947961875811494],
              [-21.714587443533233, -12.949579287157574],
              [-21.720081428068305, -12.951421771100819],
              [-21.720883294458602, -12.952993602845234],
              [-21.720032926134696, -12.953841613525086],
              [-21.71711368138905, -12.953053450162562],
              [-21.71233241400339, -12.953802454985603],
              [-21.709705088662027, -12.953233215637606],
              [-21.7087532550142, -12.9523366443482],
              [-21.70485278477079, -12.950555637758224],
              [-21.701091266350982, -12.949826326850982],
              [-21.696842828249878, -12.947164216638804],
              [-21.696269487940345, -12.945781430758226],
              [-21.694887435944345, -12.944082786279381],
              [-21.694172508448993, -12.944206779469056],
              [-21.69264744972204, -12.94610269064029],
              [-21.689842354507, -12.945797405284221],
              [-21.688570457447007, -12.946516331752322],
              [-21.688512309393936, -12.947630804980529],
              [-21.689564814951577, -12.94979995556963],
              [-21.688304776978818, -12.952811269228182],
              [-21.685629760973793, -12.952410941949559],
              [-21.682318430087903, -12.950595227136839],
              [-21.680956674114803, -12.94685498909126],
              [-21.680316389231677, -12.947684877654522],
              [-21.676483687651555, -12.948017331472986],
              [-21.674192588467523, -12.946659399476603],
              [-21.671508372137044, -12.94573928883466],
              [-21.67147772876478, -12.943872076400666],
              [-21.67012177073246, -12.943207938854037],
              [-21.67006123575882, -12.941089857010766],
              [-21.667854132404983, -12.941269463786119],
              [-21.666791434483844, -12.940512356421365],
              [-21.664963823847206, -12.940050100220528],
              [-21.6643056522938, -12.940988464680206],
              [-21.66503293681181, -12.944458394025157],
              [-21.665741534887125, -12.94496342025986],
              [-21.66622323443277, -12.947052210381104],
              [-21.66571444785107, -12.94763065191126],
              [-21.667136377916236, -12.951403045562893],
              [-21.665842813851185, -12.952543430371707],
              [-21.66369921477404, -12.95113734042674],
              [-21.663477812344816, -12.949017929749836],
              [-21.66202485884769, -12.946767610829315],
              [-21.65986437356934, -12.947087368699966],
              [-21.6589134888476, -12.946502495809336],
              [-21.6572468374976, -12.947655747890995],
              [-21.654622178173696, -12.947391992505967],
              [-21.652390209605937, -12.948306502146485],
              [-21.65558386186112, -12.949954131651433],
              [-21.654209760248502, -12.952473771713253],
              [-21.651427468660724, -12.953197084233343],
              [-21.650070400682832, -12.952687610968331],
              [-21.64822157164208, -12.952646367142242],
              [-21.64644196159475, -12.953625138029157],
              [-21.64344569008369, -12.955977697501345],
              [-21.642144065961215, -12.956283982636522],
              [-21.64214330160672, -12.959046027171977],
              [-21.64115847106559, -12.959981924708371],
              [-21.63926761547043, -12.958024119628352],
              [-21.638088919883668, -12.957561961035253],
              [-21.637216914783203, -12.955908855868332],
              [-21.634734955196258, -12.957211239934072],
              [-21.63304256853035, -12.95633746539347],
              [-21.631876117396747, -12.954933487419291],
              [-21.63298233106301, -12.953387704938958],
              [-21.632849289665085, -12.952335675091057],
              [-21.633908165038044, -12.950648294816022],
              [-21.632232013204263, -12.949821908569172],
              [-21.63024544712747, -12.950499141367358],
              [-21.62950717534019, -12.949898312353561],
              [-21.62641713913039, -12.95066197254145],
              [-21.62559653944043, -12.951440371360754],
              [-21.625072058845983, -12.953114870784125],
              [-21.62748198880648, -12.954857205306805],
              [-21.626306847689147, -12.956684412873084],
              [-21.625231963137402, -12.957022063510081],
              [-21.622905354839585, -12.956346885871092],
              [-21.622082012514333, -12.957281966648067],
              [-21.62099787146757, -12.957101792966945],
              [-21.6185817375795, -12.958275912614436],
              [-21.617812760652896, -12.957580108730474],
              [-21.615269780699816, -12.958533385216477],
              [-21.613306173930386, -12.958627848258105],
              [-21.612902314594816, -12.960836537495426],
              [-21.610734034635595, -12.960474043517952],
              [-21.60973459725201, -12.958913314452852],
              [-21.608632812275843, -12.958841566557274],
              [-21.60719998236829, -12.960382620265952],
              [-21.605273870797703, -12.961245072419024],
              [-21.603482499174042, -12.962845539482515],
              [-21.60116558359206, -12.965963309129252],
              [-21.599513800402732, -12.964709250020327],
              [-21.601926223271448, -12.96171839369736],
              [-21.602726619915508, -12.960219488774396],
              [-21.604492716647734, -12.959199492222105],
              [-21.604506774835457, -12.957113533809393],
              [-21.60353658530091, -12.956948626433183],
              [-21.601732705094093, -12.958344790770433],
              [-21.601250886211243, -12.958026807906945],
              [-21.60035789168751, -12.954820220061494],
              [-21.60090913011231, -12.953711715194284],
              [-21.60041263491996, -12.952202425388617],
              [-21.597809288104845, -12.951819333004789],
              [-21.59666801714117, -12.952279757873294],
              [-21.596025255664774, -12.954092585360549],
              [-21.59421078218235, -12.95512678795284],
              [-21.59292624032444, -12.956463524919144],
              [-21.590084120783487, -12.956829282495788],
              [-21.58887330550873, -12.957570425790351],
              [-21.587154989411058, -12.957585484786952],
              [-21.58477377112318, -12.958534805819877],
              [-21.582229982210666, -12.958987857337391],
              [-21.580319781960384, -12.956852527000994],
              [-21.579916990401912, -12.955704350104677],
              [-21.5817796230569, -12.954735236323218],
              [-21.585029131505745, -12.953646032881844],
              [-21.587408693080977, -12.953269005549759],
              [-21.58926096979811, -12.951366167330601],
              [-21.58984717186728, -12.95011789625292],
              [-21.58815139925315, -12.948723147546145],
              [-21.588108269965495, -12.946787248757328],
              [-21.588955512993593, -12.944859991524257],
              [-21.588727552964, -12.9433463135197],
              [-21.58688780437102, -12.942412843954312],
              [-21.585867628342882, -12.942418850348078],
              [-21.58302843786166, -12.943849106017531],
              [-21.582552948444107, -12.94527014850349],
              [-21.58113779879214, -12.946697681843599],
              [-21.579171619351268, -12.946607910111208],
              [-21.5781005003384, -12.947772238957137],
              [-21.57670646878891, -12.947868105452448],
              [-21.574726142623536, -12.94715876733545],
              [-21.574176038195823, -12.94613500517314],
              [-21.572699806938246, -12.94630776357903],
              [-21.57156680526432, -12.9458028531083],
              [-21.569680795082554, -12.946284312101277],
              [-21.56724737699883, -12.94755893768992],
              [-21.567010440679685, -12.949138356826682],
              [-21.566032139701463, -12.950012915324203],
              [-21.563526707413846, -12.950244271317173],
              [-21.56223484042413, -12.950981902894357],
              [-21.560828457029533, -12.954585464757505],
              [-21.558226815467698, -12.955182835642974],
              [-21.557460853012362, -12.954069589845027],
              [-21.55768950981332, -12.953038042336043],
              [-21.555640443349745, -12.950790449433205],
              [-21.55715477799115, -12.949828586916167],
              [-21.559569417968728, -12.945940107829479],
              [-21.56353899101534, -12.941881139490711],
              [-21.563184277524062, -12.939888563097487],
              [-21.564018114795118, -12.93841044519465],
              [-21.562849239650838, -12.936229801519648],
              [-21.56019964579278, -12.936999245037821],
              [-21.55751025346062, -12.93912992333954],
              [-21.554934631886244, -12.939797605153716],
              [-21.553172657833592, -12.939253223858094],
              [-21.55077885975293, -12.940148920660695],
              [-21.549286227982126, -12.939935906862836],
              [-21.547967381028908, -12.941329238561101],
              [-21.546339595557836, -12.941443025625986],
              [-21.543985242607945, -12.943700229893274],
              [-21.54281730640758, -12.944319930100166],
              [-21.542432468058312, -12.94677314337285],
              [-21.54266244342025, -12.949218634211734],
              [-21.540341827995025, -12.950426971145351],
              [-21.537773469169586, -12.947145773766836],
              [-21.536894061279, -12.946586850797457],
              [-21.53387724313242, -12.949538519160898],
              [-21.532585460571863, -12.94770605309825],
              [-21.531187408398615, -12.947202450220187],
              [-21.529456010147527, -12.94807214602034],
              [-21.52924644028691, -12.946347570092255],
              [-21.529702459216598, -12.94535162095923],
              [-21.52817820864351, -12.944290872062918],
              [-21.52725077213416, -12.945820174181597],
              [-21.527157933225727, -12.94810447439387],
              [-21.52815913436601, -12.950285728669114],
              [-21.527452529747297, -12.950840051685741],
              [-21.52603325729694, -12.949772088441172],
              [-21.525128639527935, -12.947639087535848],
              [-21.52295938669054, -12.946075643128802],
              [-21.523734783936018, -12.94407535502517],
              [-21.522038597045533, -12.944388650507634],
              [-21.520093068661915, -12.942187273435906],
              [-21.518276599653625, -12.942459499608233],
              [-21.516674673007884, -12.94131881156545],
              [-21.514674667070555, -12.94268329140038],
              [-21.51257605760057, -12.941331728642094],
              [-21.511458531946435, -12.939446575230738],
              [-21.51040829335724, -12.935857833309258],
              [-21.510254099098905, -12.934299736743139],
              [-21.510834754700518, -12.931946708256739],
              [-21.51171597784631, -12.931107216403781],
              [-21.514208391072547, -12.931274637762494],
              [-21.516693763024684, -12.930589549528564],
              [-21.522450037179862, -12.927837132320215],
              [-21.52344619570899, -12.926857661073583],
              [-21.523922422827965, -12.92518318722514],
              [-21.526198851215245, -12.923110230373572],
              [-21.529580626131857, -12.923208323074025],
              [-21.531706156159807, -12.922242300631329],
              [-21.532976433757007, -12.9221096675373],
              [-21.534503992603376, -12.922933953555692],
              [-21.537744497974483, -12.921934034940529],
              [-21.539087670002548, -12.920457167852257],
              [-21.537640925877955, -12.918727912433535],
              [-21.537245785154525, -12.917347691214305],
              [-21.540613211337742, -12.915504612202229],
              [-21.541707069559973, -12.916642888767422],
              [-21.542482189762538, -12.915729741916584],
              [-21.543859391499247, -12.915925726174338],
              [-21.546483279310873, -12.915010220543541],
              [-21.54781814341452, -12.912032252614123],
              [-21.549054977589456, -12.911468123608888],
              [-21.551259435712943, -12.909515723334229],
              [-21.551933862659066, -12.907311829971205],
              [-21.55204268825706, -12.903703917188611],
              [-21.550431928427017, -12.90353037289346],
              [-21.548250590083747, -12.902264442388205],
              [-21.5471074851082, -12.902126743094499],
              [-21.543756336926894, -12.90326839034778],
              [-21.543015160281577, -12.904610972804718],
              [-21.541394318561714, -12.905966845754667],
              [-21.539079225422338, -12.90593188428246],
              [-21.53796415513648, -12.906949809475817],
              [-21.534542866446433, -12.907877441737215],
              [-21.534415988425817, -12.909547271960378],
              [-21.533085246922525, -12.911304291950737],
              [-21.53150559246642, -12.911636360443513],
              [-21.52859752841616, -12.910928437807337],
              [-21.52356241208861, -12.908365337345707],
              [-21.52138144942708, -12.90551843518835],
              [-21.521139667730882, -12.903368272422316],
              [-21.520224347927247, -12.899719182078252],
              [-21.52090728861627, -12.896379665634747],
              [-21.520061215616124, -12.893770483903758],
              [-21.517948943979007, -12.892534067625075],
              [-21.51625586937462, -12.892590074540687],
              [-21.51271562607785, -12.894041513886659],
              [-21.51044383998894, -12.89528266164123],
              [-21.50889507060898, -12.895371052103366],
              [-21.50739967912533, -12.89479702505763],
              [-21.50668842639249, -12.893671766662566],
              [-21.505840466201057, -12.890469873336395],
              [-21.506810940787275, -12.887769409549183],
              [-21.505656646654113, -12.887504185315239],
              [-21.503279372949283, -12.889655052911118],
              [-21.50245872461088, -12.891249960813651],
              [-21.501281374590675, -12.891327352320506],
              [-21.49873722792792, -12.890480248734429],
              [-21.496959526627084, -12.891593764583897],
              [-21.49587954974182, -12.891227352472242],
              [-21.494405654545606, -12.892040444732789],
              [-21.49140104766256, -12.890507332283546],
              [-21.490735173542763, -12.88960104875541],
              [-21.488049503613883, -12.890216337138492],
              [-21.48626968876737, -12.88908263621033],
              [-21.485558803043293, -12.889196737143815],
              [-21.482230322875502, -12.89129828531936],
              [-21.480252904552813, -12.891540754427286],
              [-21.478734412938945, -12.88988820881222],
              [-21.476915523504324, -12.891372225437198],
              [-21.477168871481986, -12.89232710925946],
              [-21.476326243212775, -12.89369390295872],
              [-21.477057342587255, -12.894890408870365],
              [-21.47360457885185, -12.89852399109567],
              [-21.472253230839065, -12.899555380809767],
              [-21.469813936730073, -12.900607705480533],
              [-21.468286683404212, -12.903008321104766],
              [-21.465439815572235, -12.903873965968076],
              [-21.463580479492272, -12.906658581482024],
              [-21.464335288990725, -12.909604323240634],
              [-21.46421203557741, -12.91147475081969],
              [-21.46331433273409, -12.91267713784207],
              [-21.461355713423, -12.913736302449669],
              [-21.459954421809126, -12.916123631486816],
              [-21.458560879342638, -12.917113993069124],
              [-21.457610899444706, -12.917066448911541],
              [-21.45550687564618, -12.918091013828613],
              [-21.454458099509555, -12.919493290975275],
              [-21.455189706145006, -12.920950106457505],
              [-21.457448394703217, -12.921247101990534],
              [-21.458129467276922, -12.922461239712373],
              [-21.458017820744434, -12.924457664800316],
              [-21.45702879586273, -12.926384640553179],
              [-21.45613517364479, -12.929367407383356],
              [-21.45602868834164, -12.93247378888676],
              [-21.455466193962703, -12.933057624167672],
              [-21.456229902486005, -12.935539555426654],
              [-21.45724876168226, -12.936135724201698],
              [-21.457119565456274, -12.938164699162012],
              [-21.45752689470074, -12.93935949150079],
              [-21.45974388111739, -12.942204210019757],
              [-21.46261064291574, -12.942887731761118],
              [-21.46350825849295, -12.943520698049372],
              [-21.46392559149438, -12.944997614172713],
              [-21.46665303429147, -12.946835275219046],
              [-21.469858541223324, -12.946225666158227],
              [-21.471527533498456, -12.947762916711469],
              [-21.473275107358344, -12.952899573752022],
              [-21.47255784078877, -12.953505160813043],
              [-21.47425196715036, -12.954699585377936],
              [-21.475676778640068, -12.954966186266667],
              [-21.476922200245916, -12.95634812638272],
              [-21.478323303028066, -12.956958564616446],
              [-21.47917076589012, -12.95843558972545],
              [-21.480374854996175, -12.95918361320987],
              [-21.482815786307583, -12.958183129666583],
              [-21.483933023974927, -12.958490970805812],
              [-21.486131932287922, -12.957822393979338],
              [-21.48616813768459, -12.956930929490051],
              [-21.488229349262408, -12.95516431850531],
              [-21.489931584373434, -12.954620157722479],
              [-21.492641989401438, -12.955296775726646],
              [-21.492452230968095, -12.95437045503468],
              [-21.49380087459206, -12.952975312870125],
              [-21.49570989830142, -12.952574416603094],
              [-21.498940129905428, -12.953531918132807],
              [-21.500014732872508, -12.953203953400694],
              [-21.502241700435828, -12.948871180620937],
              [-21.50364093233694, -12.94846961615583],
              [-21.505691502136372, -12.949008420497806],
              [-21.509085456641237, -12.951468452378434],
              [-21.51031188431141, -12.951611440734682],
              [-21.51126001555537, -12.953472205752039],
              [-21.51050691768022, -12.956631508983829],
              [-21.50978743457623, -12.958147413954405],
              [-21.510009017929264, -12.959168687464313],
              [-21.509385462615437, -12.960733067932239],
              [-21.50742382383599, -12.959725545456836],
              [-21.506628417453097, -12.959839069716303],
              [-21.505328760666337, -12.961972656465882],
              [-21.50359032639226, -12.96341082309794],
              [-21.503183378405975, -12.96464981178201],
              [-21.5038123693306, -12.96627248899625],
              [-21.503507890883526, -12.968750692543162],
              [-21.50429111551181, -12.971104712581848],
              [-21.50221563113981, -12.972334059990109],
              [-21.50148571859518, -12.973490115096428],
              [-21.50296228960746, -12.974492463128044],
              [-21.502400261685057, -12.975753135734466],
              [-21.501193540805698, -12.976847016539846],
              [-21.50002453069995, -12.976969867294661],
              [-21.498623704950973, -12.979134196225814],
              [-21.497076083017262, -12.982769491170554],
              [-21.497302179020526, -12.983893951410689],
              [-21.49567456798805, -12.983844633646086],
              [-21.494630809452232, -12.985199500166782],
              [-21.493816806065087, -12.989286287558128],
              [-21.495333427034222, -12.990330235500673],
              [-21.49492815861533, -12.991750692144644],
              [-21.496069664304343, -12.992545549542669],
              [-21.49704061199836, -12.994066794399627],
              [-21.49686694130945, -12.995287744602743],
              [-21.49904186773106, -12.995949969546439],
              [-21.50096362593566, -12.997416198006288],
              [-21.501563391184515, -12.9963510599307],
              [-21.501244542350328, -12.99502025130421],
              [-21.50160690482315, -12.99187315888912],
              [-21.503618997706045, -12.989261958790674],
              [-21.504975142959506, -12.988796839206787],
              [-21.50439287333385, -12.986145440198696],
              [-21.50758134186766, -12.986029923248058],
              [-21.509813321989157, -12.987035912100783],
              [-21.513367000811723, -12.987301222285717],
              [-21.51285293531906, -12.988964066518012],
              [-21.515573979252014, -12.989898352191748],
              [-21.515060987919213, -12.988471215816096],
              [-21.517217914509292, -12.986565873372554],
              [-21.52165122163643, -12.988222354623678],
              [-21.522943128581407, -12.987723150781813],
              [-21.525604946103403, -12.989220112790205],
              [-21.524818055264287, -12.990785738266503],
              [-21.526005924265355, -12.991799103159684],
              [-21.527754543900812, -12.990795708275147],
              [-21.529315569835866, -12.990629536782455],
              [-21.531474162505507, -12.98939603592982],
              [-21.532299704522888, -12.988285584709667],
              [-21.534235641506136, -12.98761376052039],
              [-21.536005861136093, -12.987927839622953],
              [-21.53686596257906, -12.98750789942469],
              [-21.53799566130222, -12.985757918008304],
              [-21.538093794162755, -12.984480569296208],
              [-21.536751179921012, -12.981411854634013],
              [-21.53713520766806, -12.980852145815422],
              [-21.541474591636973, -12.980791293185622],
              [-21.543002306822608, -12.979360183130979],
              [-21.541481682642104, -12.978321014140475],
              [-21.54194636935554, -12.976931335603691],
              [-21.54404899683839, -12.976777733408467],
              [-21.544939855995793, -12.975542188880752],
              [-21.546074752347117, -12.975556583246547],
              [-21.547179861949086, -12.977138859205793],
              [-21.550050138565126, -12.978437101566392],
              [-21.552584301232216, -12.977785800749055],
              [-21.554546884676228, -12.977778287871763],
              [-21.55611282129451, -12.977295049946614],
              [-21.55683401490301, -12.979099748371075],
              [-21.55598100368623, -12.980948679220672],
              [-21.55806250839169, -12.982464193704613],
              [-21.560758861789875, -12.98139766182872],
              [-21.56112965839764, -12.980632846249534],
              [-21.56299855614769, -12.980913636130799],
              [-21.563015295235015, -12.981792380942789],
              [-21.561542715277234, -12.984718061657048],
              [-21.5630581376776, -12.985732405724162],
              [-21.564470441928997, -12.985270007437759],
              [-21.564618418530728, -12.98696674549172],
              [-21.563846885871495, -12.98790773329926],
              [-21.564878506504293, -12.988759492666214],
              [-21.564527703715775, -12.99066295340768],
              [-21.566103543658986, -12.990618311209268],
              [-21.569008834183226, -12.991593667475476],
              [-21.56989298106109, -12.99348007740474],
              [-21.571067469901386, -12.99410575847025],
              [-21.570679150917332, -12.996308362449891],
              [-21.57200934966951, -12.99732850352206],
              [-21.572408742387314, -12.999548094381497],
              [-21.573426415430085, -13.00035288591147],
              [-21.57505216013922, -12.999381257921854],
              [-21.574984689688332, -12.998594829711879],
              [-21.578102259154058, -12.99731728767605],
              [-21.57649471361614, -12.995862402113525],
              [-21.573237080645256, -12.9958814309086],
              [-21.573046060591953, -12.99380593298143],
              [-21.574575832787563, -12.99270776335873],
              [-21.576931962560803, -12.992655171007556],
              [-21.577823164998698, -12.991832354154278],
              [-21.57727509797975, -12.99064870197825],
              [-21.577943668682234, -12.989061670163197],
              [-21.57783904884001, -12.987584543720143],
              [-21.578730156544502, -12.986267469316978],
              [-21.578355545396704, -12.983469041575011],
              [-21.579571893153204, -12.982571343759458],
              [-21.580803113465254, -12.983204310164554],
              [-21.58203854052099, -12.982118039129828],
              [-21.583781471540377, -12.981759352575468],
              [-21.58387551881524, -12.980975199656745],
              [-21.58767022598075, -12.980707292028356],
              [-21.588891035303323, -12.979000485600075],
              [-21.588718691313243, -12.976087256729112],
              [-21.589676231511934, -12.975060679790463],
              [-21.589733744723496, -12.974001870109817],
              [-21.5908394140638, -12.973345632148234],
              [-21.592672009761596, -12.973920206360352],
              [-21.592803981225046, -12.974816037099764],
              [-21.591727448253017, -12.977206994780742],
              [-21.592020089574152, -12.979745071265599],
              [-21.591494136291494, -12.982173552789625],
              [-21.589602206917522, -12.984219547610854],
              [-21.58972377312942, -12.986733170972538],
              [-21.587132038715584, -12.990767194015628],
              [-21.588026507488472, -12.99119263659181],
              [-21.58931953471672, -12.990608566339228],
              [-21.591210089489206, -12.988224308168352],
              [-21.59205359600616, -12.986269263739366],
              [-21.591567644362346, -12.985691388430295],
              [-21.591953330956272, -12.983410397328495],
              [-21.593167697445622, -12.982095441257723],
              [-21.59648771050098, -12.981608553911348],
              [-21.59774845326323, -12.979367324859295],
              [-21.598842849780603, -12.978921871270465],
              [-21.59999081366231, -12.97658525414809],
              [-21.6011359082543, -12.976540746885435],
              [-21.601742863359476, -12.977731513675629],
              [-21.60112376289384, -12.980528515549157],
              [-21.599608848366433, -12.9834747448009],
              [-21.59769761161901, -12.985215823865317],
              [-21.596442583067844, -12.985502556528644],
              [-21.597039084333524, -12.98682736290534],
              [-21.59954225284897, -12.988782773952206],
              [-21.60095526976631, -12.988811547405444],
              [-21.602784821250648, -12.987642329205153],
              [-21.603903430477793, -12.98299511419324],
              [-21.60552437276963, -12.982671892121857],
              [-21.608140720680996, -12.98529406651873],
              [-21.608502135636193, -12.983930529522915],
              [-21.609429171807772, -12.983302431594193],
              [-21.609071735288396, -12.982215693705017],
              [-21.61033110778372, -12.981613790625397],
              [-21.611986579027803, -12.983363266889958],
              [-21.61502750697686, -12.985383543980529],
              [-21.61526192321223, -12.986587477148285],
              [-21.616558430031464, -12.986260137797457],
              [-21.617404318304764, -12.98448370140762],
              [-21.6193471887568, -12.98497056351614],
              [-21.61902648379437, -12.98637428093405],
              [-21.62183320511357, -12.986695018112233],
              [-21.621997878813808, -12.985392088294264],
              [-21.62317447266893, -12.982573108499333],
              [-21.625485447640692, -12.982292067284225],
              [-21.62607562178666, -12.981298706702152],
              [-21.628622197505795, -12.979196627445383],
              [-21.630319945821373, -12.979185172121534],
              [-21.632190763835574, -12.978389517306466],
              [-21.633393497214552, -12.97957595232375],
              [-21.631946386818605, -12.982716061111313],
              [-21.63120387392075, -12.983574958509584],
              [-21.633776150802635, -12.986288160669599],
              [-21.63582658703572, -12.987339546317129],
              [-21.63701125896918, -12.987489126325361],
              [-21.63971337199984, -12.986587852683565],
              [-21.641747251490376, -12.986443663920982],
              [-21.643041408294557, -12.98374102096823],
              [-21.646671353061176, -12.98001521193634],
              [-21.646729801384637, -12.978562037360355],
              [-21.64802617741282, -12.976849236535857],
              [-21.650559063328036, -12.974954910961358],
              [-21.65237578593152, -12.975216603135946],
              [-21.65473282852717, -12.974420481920333],
              [-21.65782423902291, -12.974043819408251],
              [-21.65811897907821, -12.973142078171318],
              [-21.666391830200553, -12.966088963505618],
              [-21.668143939531827, -12.96550772335742],
              [-21.66844659392038, -12.963741902236716],
              [-21.670096678272255, -12.963583913129822],
              [-21.671357535211783, -12.965741117396142],
              [-21.672319632476505, -12.966192758129266],
              [-21.673681571592358, -12.965656412522694],
              [-21.674808228415326, -12.964254941641569],
              [-21.67641384622717, -12.965337121790899],
              [-21.6779389677467, -12.965531475912092],
              [-21.681714988917562, -12.963965886456847],
              [-21.682691378329302, -12.962924477604577],
              [-21.68386794032861, -12.963046226520648],
              [-21.686188973087038, -12.961498438183432],
              [-21.688025148401017, -12.964151448295198],
              [-21.68894827742023, -12.966259785594945],
              [-21.690713649862893, -12.966924974307707],
              [-21.69158879477245, -12.966306936948593],
              [-21.69131365179614, -12.964357546050728],
              [-21.691705737687748, -12.963187985148965],
              [-21.69440653565764, -12.962770975863926],
              [-21.695592979363745, -12.960825647776193],
              [-21.696919078893334, -12.959618846087848],
              [-21.698731416564318, -12.960503114497143],
              [-21.699447523266457, -12.96231163797016],
              [-21.698143793204554, -12.964713014473642],
              [-21.697970624228766, -12.965970158441978],
              [-21.6989974292976, -12.967575534511628],
              [-21.701448981103223, -12.967942827707335],
              [-21.70246129563995, -12.96741064858583],
              [-21.703644742889594, -12.96577816391321],
              [-21.705024673228206, -12.966016690433504],
              [-21.707879792444817, -12.9646860257536],
              [-21.70937569732745, -12.964625555246988],
              [-21.71303212799923, -12.962619267307334],
              [-21.714974576298214, -12.963722215685415],
              [-21.716035174007697, -12.965421238578108],
              [-21.717051631106212, -12.964259100590427],
              [-21.7181760498137, -12.963898724045807],
              [-21.718917910955078, -12.962405935621367],
              [-21.72054812505661, -12.961778777154938],
              [-21.72261353354704, -12.961638927342404],
              [-21.725458362906494, -12.959157008334703],
              [-21.72901134011216, -12.957648966887055],
              [-21.731320898195452, -12.95742924968967],
              [-21.73225868371812, -12.955558989894708],
              [-21.734142409958203, -12.955841818307066],
              [-21.73694394872114, -12.954834968604267],
              [-21.73770438249379, -12.955479148871301],
              [-21.73986462598454, -12.955776977155095],
              [-21.742490029721974, -12.954250464084918],
              [-21.746490774546714, -12.95055282000252],
              [-21.748944172639096, -12.950754571041063],
              [-21.74998699410759, -12.950155827199602],
              [-21.751005034984022, -12.947891176538345],
              [-21.752745230421226, -12.947589915345258],
              [-21.754666754679718, -12.94670682007857],
              [-21.756794816698246, -12.94690764332183],
              [-21.75950169138902, -12.948804459617632],
              [-21.762723634855018, -12.947917570985013],
              [-21.761511343442308, -12.946112514196221],
              [-21.764743442591328, -12.942081400681502],
              [-21.76469675987825, -12.94146861796259]
            ]
          ],
          [
            [
              [-21.801674833337845, -12.945660443069903],
              [-21.800788979036827, -12.944980149006932],
              [-21.794671112602668, -12.946533429246784],
              [-21.793078661266243, -12.94553359103897],
              [-21.79089247224839, -12.944858359856005],
              [-21.7894901857741, -12.946939750037785],
              [-21.78764168229519, -12.948197356456166],
              [-21.788255624646574, -12.950224236387351],
              [-21.79145342849976, -12.94957469251328],
              [-21.79514094157582, -12.94782128356349],
              [-21.798460009311924, -12.947366348235473],
              [-21.79997271071736, -12.947579499245743],
              [-21.80213739676868, -12.946609804018319],
              [-21.801674833337845, -12.945660443069903]
            ]
          ],
          [
            [
              [-21.786009422305955, -12.879028964138792],
              [-21.784617462354266, -12.878048730191036],
              [-21.78276419921661, -12.877767665755526],
              [-21.781388211431224, -12.878166111847284],
              [-21.779501126547288, -12.87982758259326],
              [-21.778688966394704, -12.883200016196765],
              [-21.7810831568203, -12.885916129180094],
              [-21.78301821727939, -12.88651088528095],
              [-21.784711000097364, -12.885773856902844],
              [-21.78544851113574, -12.884775020843664],
              [-21.786599614707605, -12.881290138721724],
              [-21.786009422305955, -12.879028964138792]
            ]
          ],
          [
            [
              [-21.85538938158652, -12.937353244330923],
              [-21.853102794434484, -12.934460700224124],
              [-21.853196057937637, -12.932854985670202],
              [-21.850229579025797, -12.930818136364183],
              [-21.84616685200494, -12.932660154742452],
              [-21.84248070155464, -12.935898540289728],
              [-21.841368437885826, -12.937157718468551],
              [-21.84002458925803, -12.936341836495506],
              [-21.837753897827177, -12.935752746671374],
              [-21.835423597316467, -12.938593701557178],
              [-21.8334879299073, -12.939126504065337],
              [-21.832275356061146, -12.938764853007102],
              [-21.829650541504208, -12.941465553076247],
              [-21.827259057221177, -12.94225231944337],
              [-21.825673950080187, -12.94442604916129],
              [-21.82469787609645, -12.945061735675207],
              [-21.822501110929334, -12.945311378468519],
              [-21.820979088709098, -12.94405397135877],
              [-21.819840112810176, -12.944847380515114],
              [-21.821036763151557, -12.94650040659174],
              [-21.82298165449621, -12.947015767533529],
              [-21.824886046878, -12.946783769023414],
              [-21.827618513523973, -12.944153874393608],
              [-21.83162804532673, -12.941916360298835],
              [-21.83518244993788, -12.940719545158004],
              [-21.83715991556457, -12.940933904208295],
              [-21.841635118493333, -12.940665263485704],
              [-21.845555791780665, -12.9397383410869],
              [-21.848453650505025, -12.93993613513641],
              [-21.849171529121644, -12.940748694053482],
              [-21.849902814681617, -12.943710494960284],
              [-21.85184347962089, -12.945064675918003],
              [-21.853073891111062, -12.945393351018378],
              [-21.855564572195387, -12.941917024584791],
              [-21.856028768806357, -12.939032218192857],
              [-21.85538938158652, -12.937353244330923]
            ]
          ],
          [
            [
              [-21.883291665098206, -12.931054798922224],
              [-21.881294937129816, -12.930563795428924],
              [-21.881063950653456, -12.929904995975546],
              [-21.878887281398317, -12.929132182884656],
              [-21.876910996745174, -12.929395782745827],
              [-21.87486448044579, -12.930391923727788],
              [-21.874480568355565, -12.932017025963754],
              [-21.873455136404996, -12.932042723443299],
              [-21.872723632702897, -12.93026347345734],
              [-21.870289739120448, -12.930074314517746],
              [-21.867654690750584, -12.930476613977657],
              [-21.865477465096944, -12.931409590917465],
              [-21.864692314293915, -12.932589216695737],
              [-21.86610460776681, -12.933827756808714],
              [-21.865209551654893, -12.938589966170838],
              [-21.865692345492857, -12.939270616658993],
              [-21.865535829523097, -12.943578691349636],
              [-21.863901555421144, -12.944435621403125],
              [-21.86205869741296, -12.943680097808933],
              [-21.861444817079597, -12.945354705838424],
              [-21.862697312418778, -12.94746240169585],
              [-21.864627590064813, -12.947374497026967],
              [-21.867492942373868, -12.946766179415008],
              [-21.869623421331895, -12.94569157003801],
              [-21.86956072917137, -12.94410897086651],
              [-21.87090920685156, -12.943135733493275],
              [-21.872034669420863, -12.943550542322372],
              [-21.87412249022794, -12.942121263538255],
              [-21.875729646062954, -12.936751514742953],
              [-21.875992219282722, -12.935323950535752],
              [-21.880205781531124, -12.93266082722803],
              [-21.883291665098206, -12.931054798922224]
            ]
          ],
          [
            [
              [-21.89588917529943, -12.912213542692049],
              [-21.894951005766114, -12.911712992447688],
              [-21.891988317045726, -12.91125915198777],
              [-21.88944452751427, -12.911452601069305],
              [-21.889147650042318, -12.912155813387836],
              [-21.8867911279673, -12.912417904335625],
              [-21.88481342460499, -12.912054000187732],
              [-21.881693960749956, -12.914092428274621],
              [-21.881504737534666, -12.915258540294818],
              [-21.878631561270375, -12.914667099155158],
              [-21.875920666673842, -12.915623059211324],
              [-21.872531326589552, -12.917670209004116],
              [-21.869470950446885, -12.918793347872299],
              [-21.867387890664766, -12.918435971787167],
              [-21.864416356266055, -12.919501860384896],
              [-21.864107707100203, -12.921730455113641],
              [-21.864914398782, -12.922171247342611],
              [-21.867271840583808, -12.921913183212054],
              [-21.868903856999562, -12.921291869740719],
              [-21.874081253850566, -12.922405430552976],
              [-21.87713902278382, -12.920494990158316],
              [-21.879284824159267, -12.918545651820303],
              [-21.880744695992707, -12.919372243953426],
              [-21.88000700199139, -12.921535372685717],
              [-21.879821671213264, -12.923567052870226],
              [-21.881720177841423, -12.924168944777385],
              [-21.884470069778825, -12.92254288528433],
              [-21.88687642258274, -12.920636770762956],
              [-21.888857206179974, -12.919844244186747],
              [-21.890288695442546, -12.918341671718444],
              [-21.891700040340236, -12.917633664390522],
              [-21.89148896832908, -12.916259352533395],
              [-21.894024159995276, -12.917198515399866],
              [-21.89458949643439, -12.915170103618104],
              [-21.89588917529943, -12.912213542692049]
            ]
          ],
          [
            [
              [-21.910456242097165, -12.91561073130993],
              [-21.909558973749593, -12.915307182201131],
              [-21.907511266177977, -12.91567879125335],
              [-21.905523626382973, -12.917764565124084],
              [-21.905444885453786, -12.919394478912002],
              [-21.90683654825737, -12.919401208114083],
              [-21.909043021390563, -12.921948326623149],
              [-21.91027862532283, -12.920508356149833],
              [-21.909867601910026, -12.918726646767357],
              [-21.910859268003634, -12.916211859674876],
              [-21.910456242097165, -12.91561073130993]
            ]
          ],
          [
            [
              [-21.92104334369434, -12.921970613880756],
              [-21.919279012095412, -12.920143131185798],
              [-21.91847232585246, -12.917862677386449],
              [-21.9138981115154, -12.91671666890233],
              [-21.91373245444785, -12.919717816784722],
              [-21.914284639990647, -12.920663390990242],
              [-21.916370007434686, -12.920857563199114],
              [-21.915644713846444, -12.92189026380349],
              [-21.915098930143678, -12.924125272958662],
              [-21.91796589795014, -12.924214969193807],
              [-21.92037345795568, -12.923853167739939],
              [-21.92130476999792, -12.923171782754485],
              [-21.92104334369434, -12.921970613880756]
            ]
          ],
          [
            [
              [-21.932819827903998, -12.917269511113483],
              [-21.93195427123376, -12.91698226685748],
              [-21.927925243541964, -12.917076834041511],
              [-21.929493907712477, -12.91973237944513],
              [-21.930548342703062, -12.92024563183449],
              [-21.933100046120362, -12.919596636668924],
              [-21.932819827903998, -12.917269511113483]
            ]
          ],
          [
            [
              [-21.938793626240006, -12.93248851448482],
              [-21.935244835210852, -12.933104794590172],
              [-21.93350685070598, -12.933900901728954],
              [-21.93188889017104, -12.932338867740993],
              [-21.93098074724389, -12.932934318501518],
              [-21.928403283023908, -12.931589719430548],
              [-21.92672048716326, -12.931076041547373],
              [-21.92080236329863, -12.931774990854283],
              [-21.92037684802631, -12.932654918286715],
              [-21.917681288318633, -12.931665122984674],
              [-21.914225377300088, -12.932613863173737],
              [-21.9127336211389, -12.932482680809766],
              [-21.910133841777967, -12.933538131985646],
              [-21.910300779106244, -12.935403083228017],
              [-21.911530960287745, -12.93664870857527],
              [-21.91361047584584, -12.9368993211245],
              [-21.916670940869647, -12.936373075692245],
              [-21.918697099595867, -12.937088539514344],
              [-21.919248169835747, -12.938957188356616],
              [-21.918705519980666, -12.940666188259954],
              [-21.917819907307152, -12.941094977364248],
              [-21.915323859630455, -12.940826102702736],
              [-21.914080349328685, -12.94016368416897],
              [-21.91174830413613, -12.941287065347915],
              [-21.913202466926432, -12.943011350682687],
              [-21.912864691245026, -12.943756121694957],
              [-21.91087984854058, -12.94315729236521],
              [-21.908581517028143, -12.941899908048246],
              [-21.905311084001127, -12.941520442064673],
              [-21.90620264476046, -12.943432946191754],
              [-21.905152013591813, -12.94494221882717],
              [-21.906768193739524, -12.946665446346044],
              [-21.90892157544795, -12.946813764319733],
              [-21.90936809499888, -12.947849182520331],
              [-21.90756211753667, -12.949927651263252],
              [-21.90882131616793, -12.95048062626269],
              [-21.909281754791945, -12.952485840139893],
              [-21.911095724168938, -12.952985161636278],
              [-21.91123790980815, -12.954938948805902],
              [-21.912168618280674, -12.956418633871627],
              [-21.914245092194196, -12.954406869807153],
              [-21.915695895980765, -12.954184457767198],
              [-21.915485160076717, -12.953122207324215],
              [-21.917570559399653, -12.950131940199894],
              [-21.917820411476292, -12.948441524905414],
              [-21.920210959489772, -12.948561997714272],
              [-21.92179565201127, -12.946555301179636],
              [-21.92297200589986, -12.94563398543476],
              [-21.925893073257583, -12.944705619989824],
              [-21.928526278226396, -12.945665362108738],
              [-21.929692519884547, -12.944561889799258],
              [-21.92964491736532, -12.940415598619941],
              [-21.933112820103393, -12.938643286921922],
              [-21.93474149200386, -12.936382618828544],
              [-21.936985453462157, -12.934625624771028],
              [-21.938156003789786, -12.934231168508951],
              [-21.938793626240006, -12.93248851448482]
            ]
          ],
          [
            [
              [-21.934503033553288, -12.90857125722653],
              [-21.932819988770063, -12.908744295407876],
              [-21.9313022845906, -12.910150629592167],
              [-21.92575603008662, -12.909573537897],
              [-21.925156501499313, -12.91187944777584],
              [-21.925710613705554, -12.913981427718285],
              [-21.927091403899755, -12.914647464446555],
              [-21.92914376533589, -12.912825074808502],
              [-21.93215691798159, -12.913019581005845],
              [-21.935093162230572, -12.911844935998554],
              [-21.934503033553288, -12.90857125722653]
            ]
          ],
          [
            [
              [-21.942099237345825, -12.908926421251989],
              [-21.9408124783657, -12.907071799213604],
              [-21.938733465354627, -12.908432077002088],
              [-21.937647558546566, -12.911667179227818],
              [-21.939729505913437, -12.911464252520075],
              [-21.94031641087515, -12.910660622254621],
              [-21.94269148848527, -12.90959468291067],
              [-21.942099237345825, -12.908926421251989]
            ]
          ],
          [
            [
              [-21.938682378910535, -12.870117177591517],
              [-21.93716306147514, -12.86837298018567],
              [-21.936411432189626, -12.8662640560293],
              [-21.93508864335077, -12.865451574656351],
              [-21.933362216338505, -12.865642099109044],
              [-21.929777426819832, -12.864124848786483],
              [-21.929287577720807, -12.862978055519733],
              [-21.929363246010748, -12.860747620665773],
              [-21.92810356413844, -12.85965166232491],
              [-21.92426890303522, -12.860633478662104],
              [-21.921748221055044, -12.85904524905096],
              [-21.92182443543407, -12.857654956619795],
              [-21.919438565872863, -12.856519883681715],
              [-21.918584104335817, -12.857936420746427],
              [-21.915117264698576, -12.859185302130072],
              [-21.913714083602, -12.860970072075206],
              [-21.911981112183163, -12.861213332306924],
              [-21.910571966800934, -12.86237035397539],
              [-21.90848327976248, -12.862759236265909],
              [-21.907122524140885, -12.864895877397998],
              [-21.905833543318142, -12.865933028395116],
              [-21.901187729161656, -12.867076049400074],
              [-21.90012975341928, -12.86976565745167],
              [-21.899753161506688, -12.876921541903162],
              [-21.896934328325685, -12.879861472102387],
              [-21.89535019371896, -12.87960603012467],
              [-21.894938742255178, -12.8822887924509],
              [-21.896792459542247, -12.883923464534785],
              [-21.897998289511367, -12.886877827169698],
              [-21.89904922847382, -12.887391115039291],
              [-21.898855838809318, -12.888768181676975],
              [-21.897649070355655, -12.891587771154084],
              [-21.895514007060957, -12.894166893225904],
              [-21.892477690040323, -12.893110453344528],
              [-21.89222509447421, -12.894244826333665],
              [-21.895246538331783, -12.89672417180327],
              [-21.898142041019465, -12.895990221521597],
              [-21.899329961605, -12.896274575116522],
              [-21.89986368831838, -12.893549053541864],
              [-21.903878887253292, -12.894984946533137],
              [-21.903546446739362, -12.897355227992335],
              [-21.90589367815013, -12.897223875200215],
              [-21.907465366848097, -12.894358573944317],
              [-21.910461864085136, -12.895216451488912],
              [-21.910995814012345, -12.897033514584141],
              [-21.91012852168228, -12.898428225232447],
              [-21.911085402742987, -12.899210323688807],
              [-21.913821962597275, -12.898868347100613],
              [-21.91461547561425, -12.900572215438684],
              [-21.913501956391258, -12.9016562384231],
              [-21.90977282421921, -12.901963292283268],
              [-21.910376476083925, -12.903363232131717],
              [-21.909291281194818, -12.905067781355516],
              [-21.90946620643785, -12.906795832599572],
              [-21.908942586097883, -12.908627251571483],
              [-21.91217968011731, -12.91085254039761],
              [-21.913210950526494, -12.910611411858216],
              [-21.915703348189982, -12.911035899111443],
              [-21.917708706564643, -12.910467070722357],
              [-21.919604394689653, -12.910513015651718],
              [-21.920458651648985, -12.90946321832662],
              [-21.92198440626833, -12.90900225798228],
              [-21.92285564488725, -12.908077961253078],
              [-21.92150424349902, -12.904878307820086],
              [-21.921126607132695, -12.902429016947266],
              [-21.922521954702706, -12.899067884825502],
              [-21.92357922699359, -12.89813333152482],
              [-21.925651571117662, -12.89898575623941],
              [-21.92740543959988, -12.898709871779017],
              [-21.92983696903368, -12.895050570174252],
              [-21.93114375570208, -12.894819679465723],
              [-21.93355543770546, -12.895398784243906],
              [-21.93603222335533, -12.893326204338752],
              [-21.93926194512882, -12.891839967097898],
              [-21.939448830823814, -12.890146520249033],
              [-21.938128923736706, -12.88896276120278],
              [-21.936907870042806, -12.887062277960197],
              [-21.936918703895053, -12.884798279091157],
              [-21.938139591510662, -12.883333890584545],
              [-21.939081572657816, -12.879177886268906],
              [-21.93760469732785, -12.87518482700624],
              [-21.937858944029596, -12.8729967927965],
              [-21.938682378910535, -12.870117177591517]
            ]
          ],
          [
            [
              [-21.96988941140158, -12.943146532370957],
              [-21.967738324580665, -12.941105210730807],
              [-21.965585219881582, -12.940436517696421],
              [-21.964046070637412, -12.942409005017113],
              [-21.96277793157213, -12.942073562532379],
              [-21.962651935078902, -12.940876423413822],
              [-21.961060514743956, -12.93917308292123],
              [-21.961221903078616, -12.937324982762226],
              [-21.961866640462816, -12.935682818108239],
              [-21.96168030220362, -12.934163607794517],
              [-21.962487081758283, -12.933283804757266],
              [-21.961380670332886, -12.93110106847467],
              [-21.961159227611553, -12.929330634237953],
              [-21.958180767183876, -12.928256895560637],
              [-21.955327031239744, -12.929064825144403],
              [-21.9534866554819, -12.92926569086087],
              [-21.9510178726992, -12.931154900514969],
              [-21.95102733367854, -12.932179464650503],
              [-21.94992561492874, -12.936531442153951],
              [-21.94812334776891, -12.937456569668527],
              [-21.94798543451794, -12.938452062275053],
              [-21.946096188257222, -12.941593695604189],
              [-21.94608824532929, -12.943494719917009],
              [-21.949505188758053, -12.946111815745688],
              [-21.949765910249873, -12.946999568368149],
              [-21.948838123438225, -12.94823560465071],
              [-21.94681006589646, -12.94775950678255],
              [-21.943342245923034, -12.948770686858065],
              [-21.942064760956914, -12.948251800606542],
              [-21.942873548655424, -12.946371332184482],
              [-21.94204757732359, -12.944197904477491],
              [-21.939786832273388, -12.944063793315493],
              [-21.936118670410384, -12.945430765320923],
              [-21.93285157361764, -12.947004236367038],
              [-21.933716808266496, -12.948136309668643],
              [-21.933024216308997, -12.949344254496152],
              [-21.93017294683333, -12.94993368621719],
              [-21.928967426524007, -12.951313992006288],
              [-21.925778512418095, -12.952648240893502],
              [-21.92651339082058, -12.953877409775384],
              [-21.926636442061945, -12.956313255150162],
              [-21.924843074239504, -12.95781112753508],
              [-21.9258206380782, -12.958722012659274],
              [-21.92512874907753, -12.961405495818875],
              [-21.925761588398462, -12.962036911477437],
              [-21.926825721851802, -12.964817411391298],
              [-21.926227139357092, -12.965677348359195],
              [-21.923875013899362, -12.966914045748316],
              [-21.923643514017236, -12.967730048934273],
              [-21.9255114223945, -12.968606688015532],
              [-21.929240252859376, -12.965615748097271],
              [-21.929534833239074, -12.964514949780897],
              [-21.928004011914105, -12.96397393692092],
              [-21.92719662402426, -12.962926367977557],
              [-21.92703985108348, -12.960316538118464],
              [-21.92735430379628, -12.958576315090353],
              [-21.92902715212311, -12.957355828097748],
              [-21.930791215447137, -12.957475139161938],
              [-21.932521154224414, -12.95958340324384],
              [-21.934048396149194, -12.959650263329621],
              [-21.934263732504807, -12.957863968611141],
              [-21.935602119651815, -12.956702221199405],
              [-21.938630180708113, -12.956606624388847],
              [-21.93990050703913, -12.9551768117915],
              [-21.941331964830177, -12.954510371745743],
              [-21.942031522152188, -12.953167202192658],
              [-21.942955699615652, -12.953383328912318],
              [-21.94469713234016, -12.951741678188565],
              [-21.946628975271025, -12.951407143708618],
              [-21.946259447056942, -12.954063495966352],
              [-21.945349449231664, -12.95658584435945],
              [-21.94540943371053, -12.957910918253898],
              [-21.943758174426314, -12.959733360115818],
              [-21.943059020645478, -12.96115596650344],
              [-21.94352739770751, -12.96255448443712],
              [-21.94538387289516, -12.964858359204701],
              [-21.946866499645576, -12.963329774257684],
              [-21.947489060169687, -12.96153678176683],
              [-21.94969346583741, -12.96042431819253],
              [-21.950168396442947, -12.959604611003696],
              [-21.951852429800592, -12.958799278350776],
              [-21.95365105363221, -12.959933916994547],
              [-21.953568297879237, -12.96170368476533],
              [-21.95698252756065, -12.962530924782671],
              [-21.958283385403483, -12.963649399712326],
              [-21.95781118007952, -12.966633673126589],
              [-21.959832734435505, -12.967852411075599],
              [-21.960976252597252, -12.967756711939204],
              [-21.963094202939015, -12.965165906484264],
              [-21.964524724033236, -12.961645833895407],
              [-21.964553503619832, -12.959497347439065],
              [-21.96249469264234, -12.958635941538756],
              [-21.960342963177613, -12.958281226739484],
              [-21.959440636037417, -12.956975809399749],
              [-21.960665271249372, -12.956034300265049],
              [-21.96087267559742, -12.954618059993797],
              [-21.96283215147097, -12.95366517081811],
              [-21.963602256542114, -12.952216785730684],
              [-21.96575670597367, -12.951197353255731],
              [-21.968108808903263, -12.94958246705468],
              [-21.969177225543525, -12.94782151456509],
              [-21.969190669581753, -12.94670860819566],
              [-21.970339954719385, -12.945712209114626],
              [-21.96988941140158, -12.943146532370957]
            ]
          ],
          [
            [
              [-22.148628689716617, -12.953333882910206],
              [-22.147249391957253, -12.952887650616365],
              [-22.1440299206479, -12.952688988222945],
              [-22.144274788542596, -12.951485911584555],
              [-22.143502099992084, -12.948725907691522],
              [-22.143870121741763, -12.94524657250833],
              [-22.141632891018702, -12.943746388034299],
              [-22.141337077212093, -12.942946619431348],
              [-22.139659096539006, -12.94228652934052],
              [-22.138306934895297, -12.93959888361946],
              [-22.136581701412087, -12.94015164816395],
              [-22.134783816022704, -12.939985434860564],
              [-22.13393492851648, -12.938582818231838],
              [-22.132024886328, -12.937738890313852],
              [-22.130099724909304, -12.938121669911782],
              [-22.127038943432847, -12.93467984895788],
              [-22.126514444720613, -12.936244580909579],
              [-22.125446779160022, -12.93768080744525],
              [-22.12398750393626, -12.937607918077669],
              [-22.12193986778208, -12.938404552904213],
              [-22.12003645973345, -12.937424402023424],
              [-22.119653726914326, -12.9363106966625],
              [-22.118046854822694, -12.936209287236828],
              [-22.115920581438004, -12.933873865141972],
              [-22.11159144073904, -12.933104932362754],
              [-22.11286887578126, -12.931490906641079],
              [-22.11184879307934, -12.929990020774998],
              [-22.111556387218634, -12.928447402781668],
              [-22.112598795777235, -12.927392964948869],
              [-22.111382401979206, -12.926704019136448],
              [-22.111369008372268, -12.925621103659873],
              [-22.113347130845547, -12.925539626994237],
              [-22.114568335749542, -12.92362665947137],
              [-22.112865033281576, -12.92191489792749],
              [-22.111641187156234, -12.92165334677535],
              [-22.11062187403189, -12.922619827420357],
              [-22.110693414989203, -12.924159752840835],
              [-22.10915119934876, -12.924751880684948],
              [-22.10782073129432, -12.926145035470102],
              [-22.107595764671316, -12.928001035980628],
              [-22.104561289558795, -12.926779530267975],
              [-22.10369080566951, -12.925757760150026],
              [-22.104109342170815, -12.924577175677255],
              [-22.106547799017616, -12.923805171712122],
              [-22.108137926437188, -12.921923664007117],
              [-22.10722077222722, -12.919804396931582],
              [-22.110380626836132, -12.918752553833562],
              [-22.11148177642492, -12.916590933310502],
              [-22.113856546458443, -12.91438051341837],
              [-22.114100612903147, -12.911537567786725],
              [-22.11303448086206, -12.90976354195011],
              [-22.113453036063742, -12.908662398739692],
              [-22.115043270377107, -12.908503052932007],
              [-22.115354507308275, -12.90696225026862],
              [-22.112629675770556, -12.904789167669026],
              [-22.111075563437293, -12.904299961150013],
              [-22.111900978488194, -12.902738867469367],
              [-22.110774682902594, -12.901993775260781],
              [-22.10940097246068, -12.901918416858814],
              [-22.107849918082607, -12.903150590661662],
              [-22.10630891294292, -12.903292150880795],
              [-22.106890156426793, -12.900545350652672],
              [-22.105261192382102, -12.899552550395429],
              [-22.105004247212904, -12.898556289711639],
              [-22.107863365033385, -12.896628529540383],
              [-22.10759735874852, -12.895609065208205],
              [-22.10619359026954, -12.895226404665053],
              [-22.10373654412548, -12.897649011956917],
              [-22.103771595146572, -12.901398201192352],
              [-22.101334703829945, -12.900819960501503],
              [-22.0997001171092, -12.899510996033733],
              [-22.098737055792494, -12.902416537822711],
              [-22.09899920179752, -12.904099532191184],
              [-22.098392121959947, -12.905212209518044],
              [-22.098203485620537, -12.907238586777613],
              [-22.096464514365863, -12.907289149680139],
              [-22.095445071828355, -12.906532520491591],
              [-22.095713455720965, -12.904796755304124],
              [-22.094830072887554, -12.90388698811531],
              [-22.094042678303367, -12.906227437195602],
              [-22.093723902112643, -12.909172703983891],
              [-22.09184608456798, -12.909218480915069],
              [-22.089940593713198, -12.908664538669106],
              [-22.08946790098332, -12.907002244717782],
              [-22.08821577675381, -12.908153408001208],
              [-22.086541716390652, -12.908154248500518],
              [-22.086979876737892, -12.906280577289678],
              [-22.086093371279784, -12.906033312396943],
              [-22.08409118804406, -12.907683949444245],
              [-22.084107678971172, -12.909001934918303],
              [-22.08214525383399, -12.907990538488749],
              [-22.081866833004156, -12.906181726670551],
              [-22.08238729970057, -12.904756450215697],
              [-22.083715145239886, -12.903737951198405],
              [-22.085113549024893, -12.903436095836446],
              [-22.0854033698733, -12.900635388314193],
              [-22.084751620944463, -12.899830168046453],
              [-22.08312837578446, -12.901613249385782],
              [-22.08161149419093, -12.899944713253287],
              [-22.079526321456967, -12.899718102546748],
              [-22.077999873544318, -12.897497640234068],
              [-22.075344024290757, -12.896384746102775],
              [-22.07370142035922, -12.89444340058801],
              [-22.073324797572045, -12.89259108018339],
              [-22.071903664005777, -12.888933756944196],
              [-22.072621046377527, -12.88760037032127],
              [-22.072873363339465, -12.885820282118493],
              [-22.074695762956306, -12.88301804246094],
              [-22.076115824044923, -12.878373273974256],
              [-22.076406572268542, -12.874386780566619],
              [-22.07627068265548, -12.871553628032553],
              [-22.075745478273316, -12.870494925501319],
              [-22.073417063142816, -12.868400360040084],
              [-22.071878626649106, -12.86756272036078],
              [-22.070638139539234, -12.866119639677825],
              [-22.06888287532479, -12.863271501490393],
              [-22.06612195381473, -12.862305455802462],
              [-22.063908382486467, -12.86186167503737],
              [-22.061460068237643, -12.863241278560757],
              [-22.056858265027625, -12.86299354721959],
              [-22.054917701002505, -12.864116467681411],
              [-22.053309317180567, -12.864278850587185],
              [-22.05225718254954, -12.86596360771617],
              [-22.049080857689724, -12.86812116417718],
              [-22.047025362138836, -12.87065467035834],
              [-22.044163889966487, -12.87322960288056],
              [-22.041988871926687, -12.874087792660081],
              [-22.037807198555953, -12.873714027082707],
              [-22.03611655143401, -12.87334895844282],
              [-22.034718259836897, -12.872434189823093],
              [-22.03446601572638, -12.87046364085925],
              [-22.033566594409475, -12.868216353523609],
              [-22.03158641923214, -12.867503273720622],
              [-22.030670273622256, -12.866185007665994],
              [-22.029092244754025, -12.865675351406725],
              [-22.02893777659197, -12.863672413762638],
              [-22.026363896961776, -12.864403161992986],
              [-22.022724889349806, -12.863102638421967],
              [-22.020390099429182, -12.864039441588002],
              [-22.01793147080078, -12.865914894927457],
              [-22.016900296761957, -12.868114826340369],
              [-22.01759177101528, -12.869721582639329],
              [-22.01753232386159, -12.871138977494294],
              [-22.018679881253195, -12.875435969927736],
              [-22.02377917929892, -12.881590338809136],
              [-22.024084000565207, -12.885521189683242],
              [-22.02294880240152, -12.88849779768408],
              [-22.021900996278287, -12.889755409319422],
              [-22.024082952533394, -12.891854241881301],
              [-22.02412391333716, -12.892948323158137],
              [-22.02717862063159, -12.8934534344018],
              [-22.02913800887482, -12.892144881320027],
              [-22.030804557633175, -12.891913496250352],
              [-22.034331398462168, -12.89288819929023],
              [-22.03589461241272, -12.892295791429524],
              [-22.04031590890075, -12.893092671164744],
              [-22.043757924331814, -12.89774072993756],
              [-22.044829118600024, -12.899933349370015],
              [-22.04544302727814, -12.902072907103188],
              [-22.045219876358605, -12.902890093276142],
              [-22.0467900782673, -12.904646535025273],
              [-22.04880622274637, -12.904240210665384],
              [-22.052200806610337, -12.904308626048003],
              [-22.052882920950935, -12.905579566836202],
              [-22.05287239435943, -12.906905021430958],
              [-22.050690391701465, -12.907686056454956],
              [-22.050007795135226, -12.906864720089096],
              [-22.046782842258985, -12.907715100997187],
              [-22.041608106523583, -12.909607874311579],
              [-22.03907007161358, -12.909030020348265],
              [-22.038590683931236, -12.91019950737984],
              [-22.040380261806092, -12.91090357202792],
              [-22.042037761375376, -12.912525445809159],
              [-22.042792092088426, -12.914300829946448],
              [-22.0415125229291, -12.914927342951033],
              [-22.042306836494795, -12.91613375128214],
              [-22.039938304368103, -12.91602539990285],
              [-22.038839676182594, -12.915188091951277],
              [-22.03505540533551, -12.91532908616517],
              [-22.03229608709847, -12.916332209994302],
              [-22.032625367312825, -12.918148138598308],
              [-22.032285184229156, -12.919401888539179],
              [-22.02900278058363, -12.921535238976738],
              [-22.027741469033096, -12.924030587543845],
              [-22.027022175505568, -12.923405506093182],
              [-22.02689353831682, -12.920172751825524],
              [-22.024058429370445, -12.919376887172103],
              [-22.023553993686143, -12.918361208502667],
              [-22.02080439707018, -12.91779963932248],
              [-22.018359096613494, -12.91853365697517],
              [-22.016256530644696, -12.918700244853829],
              [-22.01400180065501, -12.920265739347991],
              [-22.01366812233096, -12.924500865946678],
              [-22.01497593311649, -12.925848887302791],
              [-22.014708304916088, -12.928371390335807],
              [-22.01338038285836, -12.928561955027552],
              [-22.012120132474703, -12.927725613744471],
              [-22.012226070830643, -12.9240704352751],
              [-22.009439477865637, -12.923175851808338],
              [-22.008775156492025, -12.924142897096276],
              [-22.008391088374378, -12.927179698698744],
              [-22.00714471695671, -12.927368450094233],
              [-22.006578550341477, -12.925872001748184],
              [-22.0066119764194, -12.923457435364607],
              [-22.005965082898733, -12.922041431420668],
              [-22.00379854049213, -12.920433134491974],
              [-21.99924763085572, -12.919191319481863],
              [-21.99622750339682, -12.920909450825667],
              [-21.991280769940257, -12.920539644973505],
              [-21.989991561335643, -12.921823774467233],
              [-21.9878578898163, -12.92479426374411],
              [-21.986898008993723, -12.92501568649215],
              [-21.983000401929935, -12.923678878821137],
              [-21.979818865833433, -12.923574799268858],
              [-21.97648386856437, -12.925025572453784],
              [-21.9756392137016, -12.92977055730705],
              [-21.97874098645565, -12.934388793435987],
              [-21.97942890257224, -12.936081445506627],
              [-21.980325045897697, -12.936674266687513],
              [-21.98556735384131, -12.936184241258314],
              [-21.986460849650623, -12.935088167690028],
              [-21.98886386786191, -12.93400556449218],
              [-21.991053054139957, -12.933470995656286],
              [-21.993992845481365, -12.934264235147682],
              [-21.994259436724725, -12.936074546502631],
              [-21.990229274623236, -12.936286260944696],
              [-21.98811104691327, -12.936638213761478],
              [-21.98507405303244, -12.938015328476515],
              [-21.985997482768866, -12.940974911531965],
              [-21.985994752862002, -12.942190364935335],
              [-21.98436660445076, -12.942612309617095],
              [-21.98324331367461, -12.941462861754257],
              [-21.980949961679947, -12.94079056947907],
              [-21.98016914478318, -12.941055955694326],
              [-21.980377575273888, -12.943704232527477],
              [-21.979715503596346, -12.944378036012141],
              [-21.97808764493186, -12.94334691333141],
              [-21.97766694579873, -12.94446652032022],
              [-21.97886638651822, -12.945907333433153],
              [-21.979140692145158, -12.947899825865369],
              [-21.980076998244996, -12.948374189920136],
              [-21.98176633847198, -12.947509569750908],
              [-21.982066338400795, -12.948807345338736],
              [-21.980284006697623, -12.950178564820407],
              [-21.982487148663925, -12.952203603847178],
              [-21.984189233646592, -12.9532099996534],
              [-21.981600344275304, -12.955621589026013],
              [-21.983655056417476, -12.958226238550765],
              [-21.985318766010014, -12.957132495591807],
              [-21.98702811902685, -12.957238629878972],
              [-21.989350400306414, -12.958061144420311],
              [-21.989176691776798, -12.960102369434026],
              [-21.990490498225483, -12.962087321223253],
              [-21.99138896059209, -12.966434781201318],
              [-21.992341865385466, -12.96756496222343],
              [-21.993322603254953, -12.962340099251536],
              [-21.995776620755176, -12.961690038452904],
              [-21.996794809616883, -12.962771234041217],
              [-21.995710196126876, -12.964488789753055],
              [-21.99590234750927, -12.965560769009278],
              [-21.99744668190978, -12.96611932750312],
              [-21.997862343255424, -12.967432172827582],
              [-22.00079790185244, -12.966591399048333],
              [-22.002007680780014, -12.967210711165048],
              [-22.003436844563236, -12.966988226967556],
              [-22.00494876550602, -12.968218883359977],
              [-22.005782999522914, -12.96748484313214],
              [-22.006195717444704, -12.96573028007628],
              [-22.007458233808194, -12.964585418858972],
              [-22.00770979679862, -12.96307110942341],
              [-22.009238767092732, -12.963660424218187],
              [-22.009863298954084, -12.964558372642339],
              [-22.014513634928306, -12.96154144129445],
              [-22.013072458086498, -12.95624010421389],
              [-22.01163152945281, -12.95353223980482],
              [-22.011293506101122, -12.951373211042492],
              [-22.008560203015353, -12.949187363019721],
              [-22.010823684081963, -12.947858623820217],
              [-22.009129392327722, -12.944445686419325],
              [-22.010035397787814, -12.942470627144855],
              [-22.012129935522076, -12.941437033407622],
              [-22.012260643191713, -12.94332207290161],
              [-22.014567114536927, -12.943484820277183],
              [-22.01575597239502, -12.945034340480355],
              [-22.01590711356932, -12.9472036871213],
              [-22.018330250684777, -12.946242167546362],
              [-22.018951995917984, -12.947510280729684],
              [-22.017597440462822, -12.948317878689902],
              [-22.017539283507364, -12.951352838397343],
              [-22.01576957663127, -12.951694080448965],
              [-22.016161627469778, -12.953543820096849],
              [-22.017672249259522, -12.954005790727374],
              [-22.016903949021696, -12.955300309476494],
              [-22.02008013690689, -12.958632088937959],
              [-22.021207354302227, -12.957875890123915],
              [-22.02221819239165, -12.958852787155019],
              [-22.023103136521378, -12.957729505295026],
              [-22.024690094555, -12.957715291330672],
              [-22.02569812619344, -12.959063767655147],
              [-22.026558344873326, -12.957948327932959],
              [-22.027683566047443, -12.958251015867953],
              [-22.029347508680896, -12.959666182919587],
              [-22.03131257805996, -12.958568594261193],
              [-22.029370794708825, -12.956004785856218],
              [-22.029522365624437, -12.955132384628252],
              [-22.028657203753884, -12.952888345913733],
              [-22.030150925234192, -12.95208491898899],
              [-22.032451309267934, -12.95396879179971],
              [-22.037451371819675, -12.955799374951864],
              [-22.038952257548054, -12.955468933433158],
              [-22.04032777116981, -12.957220499908614],
              [-22.039421061138214, -12.959041908403815],
              [-22.04378301798563, -12.957886686503105],
              [-22.04464296689843, -12.959047601811115],
              [-22.04289195688292, -12.960206301405705],
              [-22.041885472936343, -12.961373214820863],
              [-22.04315258427093, -12.963507582507225],
              [-22.045852416481853, -12.963904201989484],
              [-22.047307026923722, -12.96260876848967],
              [-22.047285959959407, -12.961185215893964],
              [-22.04818695461144, -12.960106651216327],
              [-22.05137133312741, -12.960626841824215],
              [-22.05446052019969, -12.962928349626731],
              [-22.0553111225907, -12.962317147162647],
              [-22.05685434653389, -12.964144630122073],
              [-22.057569261326883, -12.962704953780273],
              [-22.058968302499487, -12.962620136157],
              [-22.062678115993293, -12.965185018592189],
              [-22.06383689778184, -12.964891245556947],
              [-22.064670775451354, -12.965823013964307],
              [-22.06469108362146, -12.96761967496759],
              [-22.067596031630675, -12.967889934649815],
              [-22.069064946573505, -12.96648061913164],
              [-22.07034115629348, -12.9663577784522],
              [-22.070507481451347, -12.968024633939349],
              [-22.07126093376438, -12.968507098627596],
              [-22.071256119426472, -12.97023342107628],
              [-22.07455098677505, -12.970209094525927],
              [-22.0765740522175, -12.969111258431674],
              [-22.076139934793925, -12.968146693001612],
              [-22.074355523345485, -12.967782372130829],
              [-22.07187317613097, -12.966332474071747],
              [-22.07069672551511, -12.964537121433434],
              [-22.06817580395286, -12.964188199291499],
              [-22.065617902863256, -12.965098341911245],
              [-22.06225467943238, -12.962732518542962],
              [-22.060533657926516, -12.962159686630443],
              [-22.061090697404538, -12.960589152677192],
              [-22.06230508931522, -12.960222909955494],
              [-22.06458313182349, -12.960815148703068],
              [-22.065670275126568, -12.96017440231617],
              [-22.067442313013572, -12.960357600642633],
              [-22.07006710091614, -12.960086701978243],
              [-22.07247262740367, -12.957928931035294],
              [-22.07365650337014, -12.95770466864758],
              [-22.075438677749016, -12.959952692884317],
              [-22.075852052061737, -12.961162463753864],
              [-22.07721730090341, -12.961963146059452],
              [-22.077314675379995, -12.958984574997187],
              [-22.08023086882042, -12.960415400287204],
              [-22.08119383068442, -12.960187935452693],
              [-22.081119162340592, -12.958701272135993],
              [-22.08317114900507, -12.958441083544521],
              [-22.08293977595931, -12.956902801910044],
              [-22.0857455713885, -12.956672425323687],
              [-22.087063491773726, -12.95568427589442],
              [-22.087984044590474, -12.956320122055528],
              [-22.087489811491483, -12.95895982184313],
              [-22.08825045111979, -12.960288183116532],
              [-22.08949117890172, -12.959087621610417],
              [-22.090587597852466, -12.959450213230387],
              [-22.092325264673534, -12.96269603162243],
              [-22.09229876826143, -12.963528072354567],
              [-22.090170867576603, -12.966523378923359],
              [-22.091235754454512, -12.967401816551956],
              [-22.090727610516836, -12.968348336588434],
              [-22.09233728860415, -12.9717730366401],
              [-22.09227903917332, -12.972669602180462],
              [-22.09449335467039, -12.974052755385133],
              [-22.09506816761042, -12.972684459467812],
              [-22.09633117987189, -12.97221924017725],
              [-22.097665245737726, -12.970215005393527],
              [-22.099100887746804, -12.9697694107209],
              [-22.098052856727406, -12.968486842614226],
              [-22.099637780872502, -12.96724521270507],
              [-22.10076089259667, -12.96722672024193],
              [-22.1010641961791, -12.968581976544604],
              [-22.102455121986374, -12.967939040171869],
              [-22.10537793817291, -12.968994432185372],
              [-22.10800403120787, -12.97126889386363],
              [-22.11013498282266, -12.971590091889478],
              [-22.111623620818825, -12.973091487648906],
              [-22.1132121047769, -12.972910107670184],
              [-22.113020275227218, -12.970132742876453],
              [-22.113457498275874, -12.968093104884323],
              [-22.11416736461115, -12.967021723625294],
              [-22.11335422896703, -12.964807291069691],
              [-22.114723706465398, -12.962230331815931],
              [-22.114109810635895, -12.96100949450795],
              [-22.111342881973826, -12.962107425851991],
              [-22.109728222554757, -12.960411864526446],
              [-22.11112878998487, -12.957320569377629],
              [-22.10987668914987, -12.957438347369589],
              [-22.108781833770884, -12.956332485543703],
              [-22.109889012626805, -12.955070226808388],
              [-22.11021221344098, -12.949274289625826],
              [-22.110597176154158, -12.947998048080287],
              [-22.109716269575294, -12.945225936689596],
              [-22.108026151667097, -12.944222951124088],
              [-22.10625820703502, -12.944282231218011],
              [-22.106007983628047, -12.941051834671088],
              [-22.105014951390746, -12.93879755756323],
              [-22.104389104753004, -12.936044310096069],
              [-22.105626792095944, -12.935293877036068],
              [-22.106870711117995, -12.93613334977552],
              [-22.10920331910629, -12.94030829636175],
              [-22.113224252229653, -12.942408226282893],
              [-22.114732073405477, -12.94411161512077],
              [-22.116372520124226, -12.94505208695004],
              [-22.117641440736353, -12.94707810176805],
              [-22.1172822102097, -12.948797315284503],
              [-22.118858763148964, -12.950610514955063],
              [-22.11995737843253, -12.951050009965709],
              [-22.12206452177591, -12.95108380966279],
              [-22.12364080104133, -12.951621659957176],
              [-22.124933172074655, -12.953109320282632],
              [-22.12588230701929, -12.955461632145699],
              [-22.129561287944593, -12.956539508457503],
              [-22.130872003146976, -12.958074514857316],
              [-22.131792922843836, -12.960198294142012],
              [-22.13373923445761, -12.961510941625248],
              [-22.134914846784504, -12.962827785942075],
              [-22.13570403256949, -12.964892326153098],
              [-22.137885997351933, -12.965643804530307],
              [-22.13969245917613, -12.966873064228295],
              [-22.141346233433, -12.969034127589685],
              [-22.14274461384589, -12.969155838580328],
              [-22.14520068601212, -12.96765550284998],
              [-22.147597770851895, -12.965323762900772],
              [-22.14823073941764, -12.963824138726192],
              [-22.149409253536756, -12.963277113112662],
              [-22.149996369852804, -12.961952753582489],
              [-22.14926112481307, -12.959816282591387],
              [-22.1494805532987, -12.957051799061148],
              [-22.14924228530666, -12.954767556093579],
              [-22.148628689716617, -12.953333882910206]
            ]
          ],
          [
            [
              [-22.212985237162847, -12.831195019828145],
              [-22.211450002853088, -12.828302394336678],
              [-22.208811133728002, -12.828565237982628],
              [-22.205882758743396, -12.827547782243263],
              [-22.20501006976922, -12.829559098256166],
              [-22.203355085230776, -12.830176797296485],
              [-22.204167555351127, -12.832567454806357],
              [-22.20371478843955, -12.83521385190168],
              [-22.205132257018974, -12.83600153419868],
              [-22.206661454112044, -12.836024276458094],
              [-22.2076343362308, -12.836693514691001],
              [-22.209612942899543, -12.83645509708509],
              [-22.21179612571218, -12.83678809395039],
              [-22.212635974537193, -12.835628235786661],
              [-22.211934564105388, -12.834500152883944],
              [-22.212504095979195, -12.833381648894541],
              [-22.2139522449687, -12.832129498336698],
              [-22.212985237162847, -12.831195019828145]
            ]
          ],
          [
            [
              [-22.285444144283076, -12.876233672587526],
              [-22.28317614176171, -12.874927286188669],
              [-22.28158925297789, -12.874599179100322],
              [-22.277906873323268, -12.87534617719801],
              [-22.275009822414166, -12.874869047621482],
              [-22.274139081552285, -12.873503287399371],
              [-22.268607800494333, -12.871907974708638],
              [-22.268026735099852, -12.870229565646909],
              [-22.26394488758169, -12.875258166951962],
              [-22.261091521480175, -12.878104020403676],
              [-22.25730495117785, -12.87887341648932],
              [-22.25635043569391, -12.880371504298806],
              [-22.25309197325796, -12.88292725413087],
              [-22.24932556953071, -12.884161583754938],
              [-22.247341904384744, -12.883725607035855],
              [-22.244529731755794, -12.884621360383527],
              [-22.243669926176754, -12.882040311434533],
              [-22.242466086794725, -12.881458479184278],
              [-22.241684472942676, -12.879290955952888],
              [-22.23983509660703, -12.879039618796268],
              [-22.239281808465513, -12.88157463685762],
              [-22.236099602113587, -12.882399878482442],
              [-22.2332141203736, -12.8814178616212],
              [-22.23177036648795, -12.881690667875127],
              [-22.23030780405983, -12.880428078234992],
              [-22.23053797052861, -12.878863331526182],
              [-22.227747569712808, -12.880038743906153],
              [-22.226335400927542, -12.879003036423141],
              [-22.22446488182354, -12.88129186014299],
              [-22.22159584217795, -12.882056458411617],
              [-22.219820028564964, -12.882858001871812],
              [-22.217971480341625, -12.88286522045401],
              [-22.21668424678501, -12.881565265859352],
              [-22.21515558917673, -12.88137618180638],
              [-22.213223951019955, -12.879011360466837],
              [-22.21156993599197, -12.88122983168528],
              [-22.210847155540822, -12.881657839623626],
              [-22.2083258440849, -12.881257643979714],
              [-22.205135103469896, -12.881547321108735],
              [-22.203235576958356, -12.880286651789492],
              [-22.19783024529799, -12.882564941360727],
              [-22.196185031561264, -12.882167719418321],
              [-22.191126749327122, -12.883148644929067],
              [-22.187294345128755, -12.882638357238209],
              [-22.184499960721315, -12.881339500532976],
              [-22.182510007475102, -12.881171439190277],
              [-22.179977689063737, -12.881833859496759],
              [-22.177205699398957, -12.881120305098195],
              [-22.17453490149591, -12.88003690318989],
              [-22.170636656508904, -12.877699573489478],
              [-22.16971196234982, -12.876804797392904],
              [-22.169181313989053, -12.875195608412652],
              [-22.16943233480338, -12.873788850332431],
              [-22.169205252720648, -12.871434788736071],
              [-22.16644859491293, -12.870260405996047],
              [-22.16448731760962, -12.866825960825498],
              [-22.164475152691065, -12.863329981175596],
              [-22.163448003822953, -12.861599192507628],
              [-22.162678785417647, -12.859334849850116],
              [-22.16092351905697, -12.857344059904369],
              [-22.16010846837929, -12.853482513487759],
              [-22.15886102934916, -12.852038967166356],
              [-22.157312359939358, -12.84893786649062],
              [-22.157293130380474, -12.847328707480138],
              [-22.15608760694888, -12.844002596695505],
              [-22.15484991347522, -12.842084894658747],
              [-22.152811507205282, -12.84040119586592],
              [-22.150132405413444, -12.83948530119119],
              [-22.146871254379796, -12.841043525298813],
              [-22.145491353917567, -12.840807216549923],
              [-22.142524536334427, -12.842902270034132],
              [-22.14018497774294, -12.843847060894173],
              [-22.138505255562727, -12.846759931854939],
              [-22.13768615999806, -12.847579239047064],
              [-22.13517468488052, -12.84746110436886],
              [-22.132884054751695, -12.850362562235336],
              [-22.128403505912562, -12.859534265962719],
              [-22.127963871950193, -12.862818462319435],
              [-22.12899345701996, -12.864447572487887],
              [-22.1326289851238, -12.865409372222047],
              [-22.134286957492133, -12.865099355183391],
              [-22.13541610942999, -12.866012497427578],
              [-22.135966247437345, -12.867624681184365],
              [-22.13628747822806, -12.870636197251587],
              [-22.136234638377797, -12.87368464624421],
              [-22.136915241866536, -12.874439803353493],
              [-22.14036768121189, -12.874492889736256],
              [-22.142407886913595, -12.875003796165277],
              [-22.14425989252027, -12.876073854795273],
              [-22.14675002022833, -12.876182267446792],
              [-22.150016685766243, -12.876906798554502],
              [-22.15357847002057, -12.878835723373397],
              [-22.15465715666322, -12.881583723288172],
              [-22.15640310965714, -12.883744412189513],
              [-22.15723638334689, -12.886614532317905],
              [-22.15585407392304, -12.887898593690895],
              [-22.156758589067334, -12.890179356978416],
              [-22.15637024835068, -12.893421930948206],
              [-22.155532533970685, -12.89486854628197],
              [-22.15777199644046, -12.8971177760244],
              [-22.158158241278528, -12.898815199319326],
              [-22.16095061634242, -12.901730346223257],
              [-22.163073940520338, -12.902621553235509],
              [-22.163409986318005, -12.903675263054176],
              [-22.16219591782714, -12.904754106079393],
              [-22.1630863254891, -12.907243056756744],
              [-22.16223432859962, -12.90930982232931],
              [-22.16361951559479, -12.911929737894098],
              [-22.16729077198463, -12.914683105478622],
              [-22.16878804690257, -12.914741842901382],
              [-22.170357958628205, -12.91559062093038],
              [-22.171260758961775, -12.917716756902653],
              [-22.172998951248406, -12.917127743754849],
              [-22.17689670111785, -12.914788929466395],
              [-22.179051897622138, -12.91525283457269],
              [-22.180546776686338, -12.915036170598542],
              [-22.182985011305902, -12.916098966922199],
              [-22.184013469550766, -12.91517402480442],
              [-22.183622883686873, -12.914263299139295],
              [-22.186577939885208, -12.912428655017827],
              [-22.186319972568622, -12.91048586593046],
              [-22.187930728801604, -12.910072868819721],
              [-22.189746001433424, -12.910943250492904],
              [-22.19077469324181, -12.908901638815518],
              [-22.192755661172182, -12.908888042207083],
              [-22.1938014517057, -12.910058976967507],
              [-22.19391595083698, -12.911321913205356],
              [-22.192155803069816, -12.913916917303558],
              [-22.19327406104726, -12.91586684968246],
              [-22.19705498940073, -12.915901658802412],
              [-22.197843685401764, -12.917299434427274],
              [-22.20137072051334, -12.916850065722738],
              [-22.205062494633097, -12.913244414959363],
              [-22.20396709457869, -12.912144746501097],
              [-22.20403104956145, -12.910844345476699],
              [-22.206235314258254, -12.909951278797763],
              [-22.20946255309095, -12.909116007777971],
              [-22.20952935337502, -12.908421084594016],
              [-22.207464255369324, -12.908081297185323],
              [-22.206667126122262, -12.906940322543788],
              [-22.207066069194923, -12.904468125634066],
              [-22.206753627193294, -12.903077071610662],
              [-22.207319315914127, -12.902074549459783],
              [-22.209151043449722, -12.900716816641413],
              [-22.209612480272792, -12.898449093584436],
              [-22.211373324701338, -12.896458634563649],
              [-22.21267470056962, -12.893172800440182],
              [-22.21405834007894, -12.892890549092794],
              [-22.21560513431376, -12.89377385308925],
              [-22.216975452915854, -12.893017086179897],
              [-22.217973197361793, -12.891072149916045],
              [-22.21950369792235, -12.890501308650997],
              [-22.219938727158752, -12.892082006558903],
              [-22.222252977140553, -12.891351844197057],
              [-22.223797357942622, -12.889942425202655],
              [-22.224931434927065, -12.890550979051584],
              [-22.22530584330705, -12.892785906523915],
              [-22.227646275421236, -12.891892544619749],
              [-22.22817023096787, -12.890842691694674],
              [-22.229983872352733, -12.889694894298618],
              [-22.235223297283632, -12.891962795878058],
              [-22.236505820807665, -12.893121712819807],
              [-22.237770080802488, -12.892595842170836],
              [-22.238812754743197, -12.893529827707203],
              [-22.240868242202954, -12.894358366999858],
              [-22.24169455389979, -12.892831508048571],
              [-22.243993305129543, -12.89305553918612],
              [-22.24571547228055, -12.893782503694476],
              [-22.24846109420958, -12.891381932518318],
              [-22.25276849311585, -12.891138791612589],
              [-22.25635684847439, -12.889037472718167],
              [-22.25818061199621, -12.889596927997035],
              [-22.25908772666557, -12.889051026920558],
              [-22.260022421565548, -12.887380758668836],
              [-22.262739352694716, -12.88775078081818],
              [-22.263822523326173, -12.886120135909225],
              [-22.265827020244732, -12.884093635033098],
              [-22.267751347233997, -12.883833638351183],
              [-22.27163586701521, -12.885009367723885],
              [-22.272948651434906, -12.886963255235239],
              [-22.27488795706798, -12.887203899652176],
              [-22.275659416134804, -12.888791267761945],
              [-22.27485472349318, -12.889799716652485],
              [-22.276479786414857, -12.89221767225565],
              [-22.27705167267116, -12.896551001062623],
              [-22.279349259304876, -12.897593448770476],
              [-22.28094443104856, -12.897289166838418],
              [-22.280298906163658, -12.895885110533676],
              [-22.281098788540437, -12.894343503591863],
              [-22.28450229329906, -12.894122719667468],
              [-22.284608268475885, -12.893209135777285],
              [-22.28316698853963, -12.89135128134502],
              [-22.28338472501172, -12.889457506387195],
              [-22.282683680166357, -12.888057604364231],
              [-22.2814687494896, -12.887484733049638],
              [-22.281129093675965, -12.885877947269543],
              [-22.281736292652223, -12.885031476972399],
              [-22.28493693165791, -12.883237236981502],
              [-22.285000816315748, -12.881845476881841],
              [-22.28260893412304, -12.87816075361204],
              [-22.284014599068126, -12.877063304523878],
              [-22.28478448000398, -12.878063799222465],
              [-22.28644649361772, -12.877307889271627],
              [-22.285444144283076, -12.876233672587526]
            ]
          ],
          [
            [
              [-22.370700073117543, -12.78300195786571],
              [-22.369676501825104, -12.781516460581475],
              [-22.364626916547678, -12.778916991009092],
              [-22.360470546512563, -12.775771940027708],
              [-22.358090954555166, -12.77660360603875],
              [-22.35482217226594, -12.776006467384168],
              [-22.351352017261863, -12.777295067876127],
              [-22.34996476082396, -12.776850946149606],
              [-22.3452639436341, -12.777529199703256],
              [-22.339925588569837, -12.779826513233926],
              [-22.33827421577593, -12.780118571787604],
              [-22.337183950438654, -12.78142733626029],
              [-22.335568518100214, -12.78181178900888],
              [-22.333995798524725, -12.782872911623459],
              [-22.332923101536373, -12.784228011224604],
              [-22.331000116919853, -12.785098494019032],
              [-22.328345980276527, -12.784334270696595],
              [-22.32811275530996, -12.78576807167272],
              [-22.327138663855326, -12.786764668936636],
              [-22.323032724426795, -12.787554978954685],
              [-22.321133193153766, -12.789653639415718],
              [-22.319904625934285, -12.789530306382062],
              [-22.318018337469642, -12.790154203627587],
              [-22.315096547162995, -12.789246004952329],
              [-22.31410256733343, -12.790161918956386],
              [-22.312315254854024, -12.790014977880325],
              [-22.311084888534513, -12.79071268945615],
              [-22.310362434599497, -12.791898202393355],
              [-22.311591861737856, -12.794502499992593],
              [-22.311815704199777, -12.795823707713978],
              [-22.309876859574004, -12.797602173965503],
              [-22.309494297475243, -12.800010612512398],
              [-22.308710767082594, -12.80217791864368],
              [-22.307112390834376, -12.803826014313673],
              [-22.306355989383295, -12.806322879989574],
              [-22.305327777519338, -12.807587002905125],
              [-22.307583913334245, -12.808429346940873],
              [-22.309723705591033, -12.80986604082627],
              [-22.31172904547871, -12.812149452075243],
              [-22.311135518152057, -12.814172130065145],
              [-22.308764695267502, -12.814745325099915],
              [-22.308008997939233, -12.817710473884272],
              [-22.306653488557885, -12.819232461781128],
              [-22.30531178518979, -12.820053783511513],
              [-22.303789324952255, -12.81875178988217],
              [-22.301953247693348, -12.818582777592423],
              [-22.30179385266898, -12.819862055655744],
              [-22.300370048468455, -12.8208565339988],
              [-22.3000826698562, -12.822317829266346],
              [-22.301361025828054, -12.823540137612609],
              [-22.302325873990362, -12.82579114130641],
              [-22.301776429054016, -12.827022661178741],
              [-22.299232877892628, -12.82806285136823],
              [-22.296771837161216, -12.827915966040296],
              [-22.294990014559936, -12.828401120175545],
              [-22.293577666757372, -12.827875358317332],
              [-22.29176982075021, -12.826531024289121],
              [-22.289942080107462, -12.826383772649338],
              [-22.287806328583788, -12.827049955993699],
              [-22.28531828656976, -12.826812248954514],
              [-22.284713144634864, -12.82789297216804],
              [-22.282509081152053, -12.82962641952735],
              [-22.281817857913435, -12.833733252682684],
              [-22.27948917977845, -12.835577785950882],
              [-22.277055106027216, -12.836314214711813],
              [-22.26778171390739, -12.834937123758177],
              [-22.266051229219883, -12.833748957409796],
              [-22.26181527536182, -12.835439963677048],
              [-22.26066647641052, -12.834748406476338],
              [-22.258805715876584, -12.835008857164178],
              [-22.2536616933483, -12.836420610120163],
              [-22.24914139510994, -12.835859963491489],
              [-22.250472427353284, -12.837803067148945],
              [-22.251897763122507, -12.838600808204047],
              [-22.252729684204596, -12.839806833454965],
              [-22.253185919043364, -12.842517176128693],
              [-22.25427359486358, -12.843346577004247],
              [-22.255232283187183, -12.84250996153963],
              [-22.256955725859054, -12.842427930844574],
              [-22.259698170518465, -12.84340219917881],
              [-22.26106916215299, -12.845406020119302],
              [-22.262255302071303, -12.844582410454032],
              [-22.265025019881325, -12.843630169274062],
              [-22.266990753543617, -12.844246290852869],
              [-22.268693054289493, -12.843703357925719],
              [-22.27075409489027, -12.842434560288417],
              [-22.27390487599954, -12.841179906163585],
              [-22.277741185498616, -12.841105147331609],
              [-22.279729941878855, -12.840710120005443],
              [-22.28178131483773, -12.841710783532568],
              [-22.2833237672187, -12.840194209669054],
              [-22.28438140000702, -12.840161009430094],
              [-22.285956722240986, -12.84194686542276],
              [-22.28887183002626, -12.841629689002078],
              [-22.29132213412129, -12.842594355935892],
              [-22.294940807650395, -12.8417589814873],
              [-22.296487301522003, -12.842046703112032],
              [-22.298471592321064, -12.841747966324764],
              [-22.29956537467989, -12.843586809461875],
              [-22.297347870089332, -12.844717196141172],
              [-22.29623556216481, -12.846939880494642],
              [-22.296656251388587, -12.848381144379893],
              [-22.29525632290714, -12.850491741767078],
              [-22.292714591763566, -12.850779510619686],
              [-22.293281484922915, -12.852544992239233],
              [-22.295985547097352, -12.8514825296038],
              [-22.296633488460827, -12.852494632303689],
              [-22.29984241139607, -12.85119127186439],
              [-22.300082706446464, -12.852408399666562],
              [-22.30236583286469, -12.855040624752535],
              [-22.304242680610894, -12.854888320749428],
              [-22.309051267979438, -12.857611657815],
              [-22.310011197313443, -12.85838103297496],
              [-22.311079210744534, -12.861299280380727],
              [-22.310920672580536, -12.863332126627839],
              [-22.309941773315817, -12.864383883999416],
              [-22.31007723959917, -12.865455099298883],
              [-22.308073569726737, -12.86672139179505],
              [-22.307316169014456, -12.869934122364292],
              [-22.308096498159486, -12.870236164748578],
              [-22.309514423678618, -12.86859705027102],
              [-22.312268276680655, -12.867697162024088],
              [-22.312058635034347, -12.868734711445803],
              [-22.312407113162426, -12.871223820110366],
              [-22.31456096215043, -12.870489419983965],
              [-22.31528706840853, -12.872520009422956],
              [-22.31758115460048, -12.873443359583032],
              [-22.320763469617198, -12.873507317660254],
              [-22.321987127499, -12.873807057212279],
              [-22.32481021502567, -12.870208199157195],
              [-22.32439618849397, -12.868703814465222],
              [-22.32489527487076, -12.867986804092608],
              [-22.32632413518446, -12.86853139791489],
              [-22.32652833924875, -12.866907204519688],
              [-22.328259797009693, -12.86766117040673],
              [-22.327684195003535, -12.869902424026252],
              [-22.328215841946438, -12.870562386988416],
              [-22.333312401093767, -12.871417835343648],
              [-22.33534937406184, -12.874251457919193],
              [-22.33477144195478, -12.875051787132005],
              [-22.337212762926722, -12.876347310381968],
              [-22.338299421857382, -12.87872868495172],
              [-22.33746031794103, -12.882299337489187],
              [-22.337991655418293, -12.883387777951484],
              [-22.337358095867213, -12.8844759802527],
              [-22.338050347308975, -12.886843147607824],
              [-22.338326682728994, -12.890433058435843],
              [-22.337827136059975, -12.891151415478769],
              [-22.338235306359977, -12.895228818011004],
              [-22.34048496204678, -12.896597735840501],
              [-22.34132758919322, -12.894897229513608],
              [-22.34339191957207, -12.89520999429536],
              [-22.344183190793444, -12.894383983113945],
              [-22.345902439005965, -12.894234348416354],
              [-22.344628379826872, -12.890795029413898],
              [-22.345170669429706, -12.889900010557481],
              [-22.346926291878397, -12.88941544869912],
              [-22.347894460259603, -12.888042775519743],
              [-22.347568388217745, -12.883613853560561],
              [-22.346615376189188, -12.883589717601778],
              [-22.34574381697672, -12.882197822061949],
              [-22.344463728376063, -12.878602894059373],
              [-22.345314797372147, -12.877648004079125],
              [-22.345791032871137, -12.875867993114644],
              [-22.349337948576988, -12.877290927713958],
              [-22.34930948763039, -12.876071108975585],
              [-22.34780719993031, -12.874484483948896],
              [-22.348427207021093, -12.873507252260021],
              [-22.350647389334224, -12.873652779445992],
              [-22.352871311292933, -12.875668767375668],
              [-22.355825431638657, -12.876560087677918],
              [-22.357243702878, -12.878499340668913],
              [-22.35788154586049, -12.877996475834557],
              [-22.357785722410025, -12.87631916535494],
              [-22.356421636280153, -12.874949099086443],
              [-22.355014822850208, -12.874183489134733],
              [-22.355010323403196, -12.872312504769086],
              [-22.357498771326544, -12.870859737436882],
              [-22.356893395322732, -12.869156863131662],
              [-22.357391398494492, -12.868010208700118],
              [-22.359289282943188, -12.869182475129119],
              [-22.35955735561234, -12.866729381269419],
              [-22.358782847162047, -12.862307825039016],
              [-22.361268555090405, -12.862994555829431],
              [-22.362208069799866, -12.865269052613074],
              [-22.363645367488754, -12.865112580195346],
              [-22.362984621249755, -12.863270017976769],
              [-22.364458354744375, -12.861922969128427],
              [-22.364816711849105, -12.860509697118674],
              [-22.366375303354342, -12.861500248803155],
              [-22.366720111668126, -12.862317492319805],
              [-22.36870936835637, -12.862865886957868],
              [-22.370842889887427, -12.859935944352154],
              [-22.373260911792897, -12.857595822552796],
              [-22.373955975268135, -12.854823167312775],
              [-22.372015697147543, -12.854257870123915],
              [-22.371839018623444, -12.853092950238892],
              [-22.37047426610178, -12.851725845562475],
              [-22.369439458251914, -12.851446515246545],
              [-22.369127164815666, -12.849122482696377],
              [-22.368108100615757, -12.847360751449422],
              [-22.369294752075064, -12.846279330053916],
              [-22.367961140216906, -12.845275999845386],
              [-22.366524165420323, -12.846327669032446],
              [-22.36551458962624, -12.846395733766824],
              [-22.36478444566739, -12.848135174564254],
              [-22.36250442915493, -12.849576573517867],
              [-22.360529682196976, -12.848400402742456],
              [-22.35674782271284, -12.851179521133943],
              [-22.355317534149236, -12.851967996207021],
              [-22.354332411105837, -12.850423145108376],
              [-22.352484094646375, -12.852227939100922],
              [-22.351108846511444, -12.852254223531364],
              [-22.349179017586778, -12.85151679271812],
              [-22.346864640873047, -12.849597958443537],
              [-22.343987069517393, -12.850605329942896],
              [-22.343029480737066, -12.852462789507655],
              [-22.340077755752574, -12.852953334238576],
              [-22.33876543681659, -12.85156659813482],
              [-22.337061320809845, -12.853315789597463],
              [-22.335644509887246, -12.852798776339757],
              [-22.333643142335628, -12.85111600091941],
              [-22.332050762013232, -12.849193101395247],
              [-22.33099277467046, -12.846789603764558],
              [-22.330825918857197, -12.845401714287467],
              [-22.329302385366066, -12.84084569520302],
              [-22.329260509348412, -12.836591662728207],
              [-22.33049660859383, -12.83458180338328],
              [-22.33245648558536, -12.834988901834366],
              [-22.333298379800787, -12.833544274963275],
              [-22.334527380340727, -12.833052470954627],
              [-22.335381315147345, -12.831830677119966],
              [-22.336122345765766, -12.829541301862305],
              [-22.338408912445995, -12.826658961353091],
              [-22.34145084413389, -12.825376642807864],
              [-22.342768435667796, -12.826064251361908],
              [-22.34420707005129, -12.82820192005422],
              [-22.34537435983204, -12.828358275949212],
              [-22.346209891392963, -12.826254243985478],
              [-22.34851303018616, -12.826611519298629],
              [-22.348664061005007, -12.823726451355178],
              [-22.34827088310796, -12.82243078193435],
              [-22.348960040804084, -12.821215324797594],
              [-22.352524258706993, -12.81735296896203],
              [-22.350940428596804, -12.815359365770211],
              [-22.352050019278305, -12.811533569934022],
              [-22.35375264666109, -12.809942442375823],
              [-22.355564314088227, -12.809058059128821],
              [-22.355689270605527, -12.807250840820503],
              [-22.35646079989166, -12.805684439797217],
              [-22.35814181786731, -12.804519502683002],
              [-22.359895810615516, -12.804143506336533],
              [-22.360662527132003, -12.80214314899001],
              [-22.361885147378196, -12.801590877524509],
              [-22.36352376583856, -12.799184263754949],
              [-22.364611267216848, -12.799511371266892],
              [-22.3654777894073, -12.797908913797128],
              [-22.36438830839095, -12.796638584708028],
              [-22.370113572484648, -12.79180952423856],
              [-22.371380876311985, -12.789256966113856],
              [-22.371966928210977, -12.78722456261512],
              [-22.372026475851303, -12.784695247178318],
              [-22.370700073117543, -12.78300195786571]
            ]
          ],
          [
            [
              [-22.437099800803566, -12.902465599585613],
              [-22.434795585206786, -12.902708154177969],
              [-22.430867627604833, -12.903717647247129],
              [-22.429622632946653, -12.905875613541692],
              [-22.432541698805736, -12.906345556679877],
              [-22.433646149603973, -12.906954960578368],
              [-22.43519354561434, -12.90514054793626],
              [-22.436679551244545, -12.904235740080358],
              [-22.437099800803566, -12.902465599585613]
            ]
          ],
          [
            [
              [-22.498625700905556, -12.834987010630497],
              [-22.497752714488747, -12.833221972359054],
              [-22.49499320938063, -12.833571614249179],
              [-22.494073742090475, -12.8346197516448],
              [-22.492993340091648, -12.83400849429303],
              [-22.49181684492861, -12.834831368081124],
              [-22.489749586246756, -12.8338425290187],
              [-22.488219254572385, -12.834476713911481],
              [-22.48537022345408, -12.837814268593261],
              [-22.483779828941973, -12.837879637510381],
              [-22.48243917451244, -12.837312861357232],
              [-22.481943496057404, -12.83830668519866],
              [-22.482136261390593, -12.84102814572557],
              [-22.478329493743566, -12.841126088629187],
              [-22.47683192622271, -12.841424123343154],
              [-22.47562050536665, -12.842580866518142],
              [-22.475481668240683, -12.843493084248859],
              [-22.474117370729264, -12.844546148233862],
              [-22.47483522988423, -12.845510375906434],
              [-22.477441637484752, -12.847158027510295],
              [-22.477626107501784, -12.849023057438764],
              [-22.478750688553614, -12.849887963057583],
              [-22.479701932052155, -12.848775463332093],
              [-22.48229582179745, -12.848707853576277],
              [-22.48390700805197, -12.846592694704476],
              [-22.488774509798002, -12.843135564843427],
              [-22.489676068615683, -12.844137567749264],
              [-22.491967884892674, -12.843590941928914],
              [-22.49249673493679, -12.841562418933957],
              [-22.49571249818743, -12.841793630808539],
              [-22.497101738467176, -12.840244212304253],
              [-22.498447081606418, -12.84053980738033],
              [-22.49813965510005, -12.837537662302127],
              [-22.498883925575406, -12.836609439243727],
              [-22.498625700905556, -12.834987010630497]
            ]
          ],
          [
            [
              [-22.53763904397596, -12.829839968504004],
              [-22.53553698786161, -12.829891091133888],
              [-22.532879645404396, -12.83230815567844],
              [-22.53167057689442, -12.831801848769464],
              [-22.530195745818915, -12.833550271860501],
              [-22.529795794032054, -12.835749451337758],
              [-22.528340343877304, -12.836575155048335],
              [-22.528272002797927, -12.837516430525838],
              [-22.52621331165039, -12.838787696557992],
              [-22.524107728870042, -12.840776457365944],
              [-22.522679692841617, -12.840836910578977],
              [-22.52100805824453, -12.84195938874812],
              [-22.519013019036333, -12.841859023679904],
              [-22.51563331172193, -12.845408290861954],
              [-22.515044028065475, -12.84783996791165],
              [-22.515730057029568, -12.85010922976229],
              [-22.519773492534394, -12.850022432790684],
              [-22.521351488693885, -12.847966853084827],
              [-22.524718308893174, -12.84716706129258],
              [-22.52657679509258, -12.845811652865008],
              [-22.527961637809174, -12.84619858368857],
              [-22.529915402165567, -12.84577556671626],
              [-22.53185155329859, -12.84433530399559],
              [-22.533705204410225, -12.844219280688359],
              [-22.535123608162657, -12.840659706377176],
              [-22.533626486495592, -12.836384612529901],
              [-22.534658376507892, -12.833673938100631],
              [-22.535570865574776, -12.83219382266193],
              [-22.537749132584565, -12.830390251852661],
              [-22.53763904397596, -12.829839968504004]
            ]
          ],
          [
            [
              [-22.512798272330105, -12.76294030454496],
              [-22.51159197219601, -12.760291566743536],
              [-22.510163967978883, -12.759712570783655],
              [-22.506246442530024, -12.753090486219563],
              [-22.50401236908926, -12.75223111490427],
              [-22.50309554109806, -12.752367711123572],
              [-22.500739190459484, -12.751340632535868],
              [-22.499477209089005, -12.750135981731644],
              [-22.498300156888753, -12.75045218932079],
              [-22.496021241880015, -12.750306230836195],
              [-22.49389016376612, -12.751147796595646],
              [-22.4932300066524, -12.752819825963929],
              [-22.491266007106727, -12.753249002018832],
              [-22.488977699791317, -12.756533751590402],
              [-22.487989814176228, -12.758705463949333],
              [-22.486683241671617, -12.759391486901414],
              [-22.48675950013619, -12.761933891819305],
              [-22.484784449389508, -12.76483032247594],
              [-22.484560991116826, -12.76711217787663],
              [-22.484814461697077, -12.768784146888773],
              [-22.485755502647585, -12.770301219295837],
              [-22.4853713891095, -12.773154093738171],
              [-22.485492842256086, -12.774635623024723],
              [-22.488313896225485, -12.776616241916752],
              [-22.488847503647932, -12.777324234832449],
              [-22.491135680152144, -12.778596624090286],
              [-22.491539619839862, -12.780158941374946],
              [-22.492592921428958, -12.78160744076932],
              [-22.49401580119404, -12.782244913446627],
              [-22.495170771456873, -12.781590015306364],
              [-22.49725178366267, -12.782620013792817],
              [-22.502160607097032, -12.781550563588505],
              [-22.503963931667727, -12.780432389985592],
              [-22.50612229396536, -12.779714594974287],
              [-22.50752825581014, -12.7757425420284],
              [-22.508693874998652, -12.773525778585475],
              [-22.508726779805528, -12.772225624339463],
              [-22.51157396949903, -12.76831822724362],
              [-22.51202923060547, -12.765997965674332],
              [-22.513721304517592, -12.763713133639778],
              [-22.512798272330105, -12.76294030454496]
            ]
          ],
          [
            [
              [-22.588509598449516, -12.880572257023445],
              [-22.587137178577827, -12.879965666613323],
              [-22.5855804800038, -12.87829917997262],
              [-22.584512272351176, -12.87806064784352],
              [-22.583754342376114, -12.87670096025992],
              [-22.581299218076115, -12.87661431192455],
              [-22.579718411878687, -12.877781044399224],
              [-22.58040167878665, -12.881343189267868],
              [-22.579018714640167, -12.881860375883653],
              [-22.57721900997012, -12.8840442156942],
              [-22.5756749691968, -12.885248359794728],
              [-22.575174027211144, -12.887539564835025],
              [-22.57578631471628, -12.888641396272936],
              [-22.575828938906817, -12.891372124819933],
              [-22.574717194639465, -12.89372467990947],
              [-22.576144902438163, -12.894400143570627],
              [-22.57696890588777, -12.897219176359297],
              [-22.576984658728815, -12.89992740415876],
              [-22.57838908854762, -12.899994412533998],
              [-22.58250336489648, -12.896760749345514],
              [-22.583641759630957, -12.896310507849218],
              [-22.58533032519008, -12.8936714364994],
              [-22.587075124136216, -12.894250026458472],
              [-22.586838941496485, -12.897245467640081],
              [-22.58762415854437, -12.899262216095238],
              [-22.590500457601554, -12.900245348314108],
              [-22.59208219863603, -12.902227501984033],
              [-22.593958121547168, -12.901942284315819],
              [-22.59478436139613, -12.902906356113707],
              [-22.596272351167695, -12.902454505887496],
              [-22.597663670470084, -12.902986154294291],
              [-22.59410855569003, -12.896927353803934],
              [-22.594321777488283, -12.89615471089782],
              [-22.59362412261798, -12.893667762664109],
              [-22.59251251510042, -12.891943970995912],
              [-22.590302472749343, -12.889526300127606],
              [-22.58712476056679, -12.88765592166741],
              [-22.588387535215222, -12.88531652977048],
              [-22.58961857471727, -12.883834263493645],
              [-22.588509598449516, -12.880572257023445]
            ]
          ],
          [
            [
              [-22.576402781354997, -12.81100536390293],
              [-22.574743884301785, -12.811188204415389],
              [-22.573793466191095, -12.812633241001999],
              [-22.57296765999438, -12.812871477971946],
              [-22.573004074544013, -12.81571462936796],
              [-22.573787251179507, -12.81729925686438],
              [-22.573665485200184, -12.818721137115567],
              [-22.5776779136169, -12.81593127429042],
              [-22.57731808101338, -12.813050743994031],
              [-22.576402781354997, -12.81100536390293]
            ]
          ],
          [
            [
              [-22.634073104419926, -12.901640276969886],
              [-22.632809274716152, -12.900513541971357],
              [-22.630890360019254, -12.899630116874926],
              [-22.629990727274407, -12.899940864955768],
              [-22.62415110979133, -12.896882113313112],
              [-22.62271517753992, -12.897671920904445],
              [-22.62038853369073, -12.898258996704651],
              [-22.61936501177766, -12.901092779025285],
              [-22.61861054421073, -12.905737406274259],
              [-22.619813700876538, -12.907357066559587],
              [-22.62059828945528, -12.91093581091036],
              [-22.620085688788198, -12.912340728020444],
              [-22.62165119391472, -12.91317692236746],
              [-22.619274086131767, -12.91501234997972],
              [-22.618935216137093, -12.916404249381278],
              [-22.6203463078795, -12.917495727351843],
              [-22.62248080238934, -12.915751548841493],
              [-22.62543519594874, -12.916460499531183],
              [-22.626853554873616, -12.917331751311254],
              [-22.628645258756716, -12.919127469109977],
              [-22.629297857207586, -12.92042174618035],
              [-22.630710891143092, -12.921537755335905],
              [-22.635405841685998, -12.921059185661418],
              [-22.637701846913018, -12.922349633549965],
              [-22.63710851017428, -12.919950581141808],
              [-22.63802624664316, -12.918864647604948],
              [-22.638686854171738, -12.916603240499335],
              [-22.637513781563904, -12.914419970175896],
              [-22.63776905273112, -12.913546841030563],
              [-22.636474622902792, -12.912348900980108],
              [-22.6362743033788, -12.910460087447822],
              [-22.63456491622936, -12.909073050570651],
              [-22.633756717337207, -12.906765284601395],
              [-22.634929698209383, -12.904554813301308],
              [-22.634073104419926, -12.901640276969886]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.54539785152903,
          "lat": 52.79840641735421
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02016"],
        "coty_name": ["Aleutians West"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Aleutians West Census Area"],
        "coty_fp_code": "016",
        "coty_gnis_code": "01419965"
      },
      "bbox": [
        -24.027421939454257, -13.077238681830057, -19.700658611723494,
        -11.515282763461343
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.64654486373916, -5.266478274100146],
            [2.751472146977483, -5.266072677490836],
            [2.7661911334796954, -5.2671008857028525],
            [2.765928885636622, -5.252469301914212],
            [2.8528077834545824, -5.252057129311578],
            [2.852851574519178, -5.324900968044715],
            [2.9362914389774653, -5.324530266513879],
            [2.969397410751065, -5.324461799802985],
            [2.970010509583611, -5.411329751649389],
            [2.9705220873081584, -5.411350668383682],
            [2.9704868911715874, -5.455370630564104],
            [2.9709700232589404, -5.49845318037127],
            [2.9718118813740775, -5.604543717588981],
            [2.9723379797060123, -5.685092185718959],
            [2.9041072924274802, -5.68672009658165],
            [2.878493682632748, -5.6875538591707375],
            [2.798568680557168, -5.689728518332816],
            [2.7833552105438266, -5.689730786757912],
            [2.764216013250654, -5.690688200757464],
            [2.6794980616234882, -5.692747448284907],
            [2.648866420152524, -5.69369790128265],
            [2.5739714322710356, -5.695342126697389],
            [2.554389223031568, -5.6960281863641775],
            [2.554928017472135, -5.5844831487357265],
            [2.5551559957361034, -5.5267198823650805],
            [2.5548122921181595, -5.5120788205310856],
            [2.5551191434263623, -5.4976404800711505],
            [2.5552842162282534, -5.4538754786228285],
            [2.588313575875363, -5.4547916383051165],
            [2.590172435585281, -5.449234183519777],
            [2.592139778989303, -5.447875143194092],
            [2.595514205331908, -5.43505256855843],
            [2.592336675650901, -5.423716958447627],
            [2.5981489802855724, -5.417797822983725],
            [2.603048265371922, -5.409492530565357],
            [2.597619970704352, -5.397478079897184],
            [2.601443413135367, -5.3888935175064185],
            [2.6035435660311013, -5.386744228468564],
            [2.6046057933892386, -5.379723786202172],
            [2.6063135156618515, -5.377352338283869],
            [2.606885282579495, -5.370290785149094],
            [2.6099293321513284, -5.365164584008333],
            [2.6113127236710962, -5.355963891368071],
            [2.609635409173491, -5.349742012961965],
            [2.612888090798977, -5.3474235637201115],
            [2.616060768287193, -5.34267934257147],
            [2.6227671000566386, -5.3198203613088495],
            [2.6224639463430224, -5.312512558341384],
            [2.628540989186936, -5.307771245216304],
            [2.6296582148901444, -5.299000146175803],
            [2.635457050829611, -5.288399355759463],
            [2.6377895156128517, -5.27834350052187],
            [2.64445893141444, -5.271928131933599],
            [2.64654486373916, -5.266478274100146]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.2272974989001, "lat": 33.2142964522679 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05027"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00063761"
      },
      "bbox": [
        2.554389223031568, -5.6960281863641775, 2.9723379797060123,
        -5.252057129311578
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.6755800797400222, -2.9596545901132965],
            [1.7151143519884653, -2.960000870548407],
            [1.7995400848672465, -2.9604080806449526],
            [1.799542566817847, -2.9611932118614965],
            [1.8439929741843395, -2.961237923319006],
            [1.89460810830672, -2.9619300143362657],
            [1.9716499316442708, -2.9633828302149805],
            [1.9718916564709894, -2.948833005334603],
            [2.0290939015716294, -2.949284750846852],
            [2.0575923326521397, -2.9498838104421536],
            [2.101576084185961, -2.9499488093814157],
            [2.1435838391032287, -2.9503010888628167],
            [2.158531752346334, -2.9503061053610606],
            [2.1583624746224728, -2.9647799901332084],
            [2.143620916625547, -2.9648489760918415],
            [2.143556734923932, -2.9794804057954685],
            [2.101252882557221, -2.979163362511777],
            [2.101229840156606, -3.008107098414936],
            [2.0868854975372577, -3.0076968780536215],
            [2.0866951684818296, -3.0514079671101855],
            [2.0144296230406114, -3.0510864666248594],
            [2.0143377481135234, -3.1264697925921947],
            [2.014508351398105, -3.138621245585309],
            [2.0574015842729096, -3.1391499202924433],
            [2.0573435539721623, -3.1568007712692565],
            [2.047590304103786, -3.1615613895556947],
            [2.048385532883547, -3.167091121256235],
            [2.044425374137781, -3.169322108194834],
            [2.043600117660044, -3.182756795520706],
            [2.0463696417369084, -3.184160801194464],
            [2.0474816791041643, -3.1887769509409147],
            [2.0508886326172986, -3.194020740293743],
            [2.0538923619630984, -3.2060900800581122],
            [2.050502284916588, -3.2126732229920356],
            [2.045270021829151, -3.2148154490872956],
            [2.038200161545618, -3.2211391069491824],
            [2.040982813526529, -3.2263716792031056],
            [2.04591378858296, -3.2285110567203894],
            [2.0441588858092556, -3.2331647606743523],
            [2.041902010163529, -3.233098316580544],
            [2.0338982030312063, -3.2372823981334817],
            [2.032308978903682, -3.242778675893105],
            [2.037004714518859, -3.2424690636321936],
            [2.0462687251588525, -3.2498684314282875],
            [2.0433544667050967, -3.251581724712532],
            [2.0356578846168616, -3.2600866994796944],
            [2.0236375125630204, -3.268055001464703],
            [2.018489115510275, -3.270134979243458],
            [2.0134629914590274, -3.271964297593362],
            [2.007125783142859, -3.2719900636289747],
            [1.9930196694944766, -3.2667128442915874],
            [1.9848058660845251, -3.2647339728738296],
            [1.9771862498251385, -3.2656662040344786],
            [1.9710282160239796, -3.265079988240547],
            [1.963481420051555, -3.26623308542843],
            [1.952662258034654, -3.2739197744043294],
            [1.9485314814356243, -3.2813167217223587],
            [1.9510452852934406, -3.2893547423129794],
            [1.9566601098365906, -3.29551506024459],
            [1.9656885188471453, -3.3024112133464327],
            [1.9709293070026963, -3.3116310895217334],
            [1.972550527309526, -3.3166926215061174],
            [1.9735276863811255, -3.324495680304372],
            [1.9707660819180313, -3.3330891950433017],
            [1.964207596308879, -3.338291385993115],
            [1.9589709962795292, -3.338780162357361],
            [1.9492818466660002, -3.337885997692223],
            [1.943388975997507, -3.338171821182162],
            [1.933965837732424, -3.3418166863076215],
            [1.9169313586090917, -3.3566274205564284],
            [1.9109236485003696, -3.3601170755685152],
            [1.9030469930279956, -3.3630156879190882],
            [1.8950674591471415, -3.3649383277020433],
            [1.8844753044858338, -3.36203622650743],
            [1.8757451299257855, -3.3625101697040884],
            [1.87004794887131, -3.365681628569386],
            [1.8629262187187985, -3.373546172483282],
            [1.8574654502831138, -3.3754260647142615],
            [1.850961036662129, -3.375463996709445],
            [1.8466751829836165, -3.3738600290880707],
            [1.8236674001130728, -3.3566450085711605],
            [1.818600962419531, -3.354282678068794],
            [1.810160591354331, -3.352433405214279],
            [1.8046578176441848, -3.3499951881548604],
            [1.8016944904329233, -3.3468607411932663],
            [1.7984739966497996, -3.3371590308669106],
            [1.8011720829752131, -3.3298907744924247],
            [1.8059404103623304, -3.321813600584093],
            [1.8072373113724896, -3.3166898119703023],
            [1.8060118203078637, -3.3081729394492867],
            [1.8017996173662458, -3.3005209067418213],
            [1.7959933450878716, -3.2944314390714395],
            [1.7895903266003865, -3.290399789024282],
            [1.7790357747519223, -3.2825270389621553],
            [1.7686657379997637, -3.2720354148221076],
            [1.7629251619961053, -3.27006042542828],
            [1.7536259318018053, -3.2700871040891104],
            [1.7437807758834034, -3.2729616265208676],
            [1.7390492002055686, -3.2769379056359997],
            [1.734916617059742, -3.2841880269545847],
            [1.7345126475774213, -3.289732253177911],
            [1.7373998023811072, -3.3050104294769516],
            [1.7371537123217229, -3.310038114277554],
            [1.7341759255042648, -3.3209785790129027],
            [1.731607298777034, -3.3273227966846415],
            [1.7146743241780973, -3.2235736688541072],
            [1.7022818291296113, -3.1371845417112523],
            [1.6938571332343273, -3.0809955004021408],
            [1.6804208083534258, -2.992937378695506],
            [1.6755800797400222, -2.9596545901132965]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.24286141022503, "lat": 35.58806069138556 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05033"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00069161"
      },
      "bbox": [
        1.6755800797400222, -3.375463996709445, 2.158531752346334,
        -2.948833005334603
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1546857581911523, -4.369072615692465],
            [2.2398527590419666, -4.369884378953289],
            [2.2546738954147694, -4.368963683772672],
            [2.327418989826553, -4.368093125367198],
            [2.386655651206385, -4.368909232415491],
            [2.413962546859388, -4.368489127543729],
            [2.4682898671186337, -4.36916276918985],
            [2.5291139498337953, -4.369507377813363],
            [2.529866320289296, -4.457514533348812],
            [2.5125702832638597, -4.457538645204498],
            [2.513043353316415, -4.497322956000181],
            [2.5195081405782105, -4.499214623917717],
            [2.5219692063098615, -4.501483595861181],
            [2.5305152673811304, -4.502314509233536],
            [2.5331567861895774, -4.501447659115452],
            [2.5464983202723905, -4.504776967942702],
            [2.5487673537419644, -4.498381699244537],
            [2.5584656224036206, -4.506934778230193],
            [2.5565029520253324, -4.5126757833768565],
            [2.553250856198948, -4.51395568507975],
            [2.5480002649710247, -4.520104715587098],
            [2.5523256786224873, -4.525328894273835],
            [2.556629775828335, -4.528580574843956],
            [2.557531805074985, -4.531186472217061],
            [2.5544476129766345, -4.534463754342089],
            [2.5526417825500904, -4.539449360289742],
            [2.5536633859228424, -4.542288203323814],
            [2.5519797920430505, -4.547461365608026],
            [2.5544432268252826, -4.557091096583797],
            [2.5575161986199744, -4.557572705983271],
            [2.562413555191134, -4.562187720397065],
            [2.5582667561927535, -4.5644261630433025],
            [2.5571398390428692, -4.569716897400009],
            [2.553622358918968, -4.5710257805276],
            [2.553073008540539, -4.580460049327408],
            [2.5606836226718883, -4.578196622736169],
            [2.5630573986235747, -4.581145573529712],
            [2.556505203152753, -4.58436467004234],
            [2.557356571528672, -4.588090969113484],
            [2.5654173478261537, -4.590238401274484],
            [2.562817373450417, -4.596220527961857],
            [2.565451990438539, -4.608896784314712],
            [2.5653761149253085, -4.618537617557027],
            [2.5671546731317285, -4.624237082222837],
            [2.5643593451440436, -4.6310357948133],
            [2.572019289894075, -4.6400734889787945],
            [2.5716928684224456, -4.647273917295592],
            [2.574621721906395, -4.654468989851896],
            [2.572963188611134, -4.6601648894061665],
            [2.5778362619497597, -4.663350983790553],
            [2.588455247914073, -4.672240295805177],
            [2.594893087509204, -4.684151136718856],
            [2.5960832970690864, -4.690206641191467],
            [2.59552687618368, -4.697839501088113],
            [2.6022043409240956, -4.698549765798028],
            [2.59847580817749, -4.7046335090832585],
            [2.609275697697366, -4.70877592702919],
            [2.6132858720777112, -4.715219750507944],
            [2.6168150006298867, -4.716863816856273],
            [2.6203139828763367, -4.723480919091406],
            [2.618345831675521, -4.727183365887351],
            [2.6216695671511556, -4.733517776324595],
            [2.620241031820326, -4.737446403453884],
            [2.623118677951273, -4.74050022007323],
            [2.6227042709793547, -4.747419297484654],
            [2.6258829931619516, -4.752522765183056],
            [2.612018491042279, -4.751491243875381],
            [2.6136693243873452, -4.7545818836387435],
            [2.6080363866538243, -4.7554360627131755],
            [2.6044443665098753, -4.758903943216795],
            [2.592513105003642, -4.7568178361786835],
            [2.591032586353487, -4.758821606003148],
            [2.582060964170093, -4.755097809521977],
            [2.575641171216194, -4.7562229945955234],
            [2.5715036604303525, -4.75391557965522],
            [2.5677425465901966, -4.755292100631332],
            [2.5598443427454662, -4.750754541909867],
            [2.557336898226828, -4.754655328834833],
            [2.556969681006131, -4.7501814024694635],
            [2.5512666376251087, -4.752725825097812],
            [2.5452913518534275, -4.750177622123426],
            [2.5399446882966035, -4.750593451022336],
            [2.540613268091033, -4.755410996774084],
            [2.5236457233125433, -4.7583480285178235],
            [2.526954681137122, -4.763568298215367],
            [2.521333888455119, -4.766896681073891],
            [2.51793150864517, -4.765622856390912],
            [2.5131458123882524, -4.766145671709263],
            [2.5074050695803534, -4.768822310769321],
            [2.4982492641104153, -4.769084229701135],
            [2.498536871250989, -4.7642929961818075],
            [2.4949547886527483, -4.758219904889742],
            [2.4908658884601667, -4.761517523166783],
            [2.4861660091970452, -4.7627706801670975],
            [2.4770441079205208, -4.7575233014088],
            [2.4697421645404316, -4.755492584463545],
            [2.464992680357854, -4.755643957654221],
            [2.464040190874995, -4.752704298432148],
            [2.4598466377359824, -4.753848593550519],
            [2.4583869528225573, -4.756244993137593],
            [2.449804806269133, -4.754265041333068],
            [2.449476118277683, -4.751028192164308],
            [2.437341290625564, -4.752642987427855],
            [2.434344917709679, -4.751969008601769],
            [2.4315232073295205, -4.755275905737577],
            [2.4249996030719383, -4.755249360316747],
            [2.4236926365573166, -4.750202875882465],
            [2.4161487333526384, -4.74637537240372],
            [2.4160061659525116, -4.741275576816887],
            [2.4099630633262814, -4.742241257878614],
            [2.402056716795748, -4.738544885439482],
            [2.400387797192357, -4.732512400524281],
            [2.3976899497763453, -4.734167933292411],
            [2.3907795199290542, -4.733069373766747],
            [2.3888721538922577, -4.73417283965484],
            [2.3760468436290902, -4.732467587997727],
            [2.3716177076396625, -4.732797384698192],
            [2.367616702831556, -4.7287161945475304],
            [2.360327892529503, -4.72528684116679],
            [2.356147923025692, -4.72121837587273],
            [2.3509682383034853, -4.722139667279325],
            [2.3442161356064664, -4.721655953662583],
            [2.339744864817512, -4.719289078018026],
            [2.335465463810213, -4.718970438389933],
            [2.3319581377815175, -4.715424994895478],
            [2.3238533033945687, -4.7160595539406325],
            [2.3191570142029825, -4.715123139849997],
            [2.3148549848750433, -4.710476750544214],
            [2.25457397223749, -4.709846204923572],
            [2.2531351964334125, -4.643744256491925],
            [2.2527215494334776, -4.593071090616917],
            [2.2524691800213152, -4.5341700482663025],
            [2.2115530115472852, -4.533626636078721],
            [2.1804518319777944, -4.533738421893869],
            [2.1661343375054094, -4.53335086800299],
            [2.165656248612963, -4.456555751334691],
            [2.155304542224286, -4.456717166575125],
            [2.155285242338135, -4.441708002845708],
            [2.1546857581911523, -4.369072615692465]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.65642476686307, "lat": 34.16346337124213 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05109"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00069173"
      },
      "bbox": [
        2.1546857581911523, -4.769084229701135, 2.6258829931619516,
        -4.368093125367198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.727891920963043, -3.3347713738381803],
            [1.731607298777034, -3.3273227966846415],
            [1.7341759255042648, -3.3209785790129027],
            [1.7371537123217229, -3.310038114277554],
            [1.7373998023811072, -3.3050104294769516],
            [1.7345126475774213, -3.289732253177911],
            [1.734916617059742, -3.2841880269545847],
            [1.7390492002055686, -3.2769379056359997],
            [1.7437807758834034, -3.2729616265208676],
            [1.7536259318018053, -3.2700871040891104],
            [1.7629251619961053, -3.27006042542828],
            [1.7686657379997637, -3.2720354148221076],
            [1.7790357747519223, -3.2825270389621553],
            [1.7895903266003865, -3.290399789024282],
            [1.7959933450878716, -3.2944314390714395],
            [1.8017996173662458, -3.3005209067418213],
            [1.8060118203078637, -3.3081729394492867],
            [1.8072373113724896, -3.3166898119703023],
            [1.8059404103623304, -3.321813600584093],
            [1.8011720829752131, -3.3298907744924247],
            [1.7984739966497996, -3.3371590308669106],
            [1.8016944904329233, -3.3468607411932663],
            [1.8046578176441848, -3.3499951881548604],
            [1.810160591354331, -3.352433405214279],
            [1.818600962419531, -3.354282678068794],
            [1.8236674001130728, -3.3566450085711605],
            [1.8466751829836165, -3.3738600290880707],
            [1.850961036662129, -3.375463996709445],
            [1.8574654502831138, -3.3754260647142615],
            [1.8629262187187985, -3.373546172483282],
            [1.87004794887131, -3.365681628569386],
            [1.8757451299257855, -3.3625101697040884],
            [1.8844753044858338, -3.36203622650743],
            [1.8950674591471415, -3.3649383277020433],
            [1.9030469930279956, -3.3630156879190882],
            [1.9109236485003696, -3.3601170755685152],
            [1.9169313586090917, -3.3566274205564284],
            [1.933965837732424, -3.3418166863076215],
            [1.943388975997507, -3.338171821182162],
            [1.9492818466660002, -3.337885997692223],
            [1.9589709962795292, -3.338780162357361],
            [1.964207596308879, -3.338291385993115],
            [1.9707660819180313, -3.3330891950433017],
            [1.9735276863811255, -3.324495680304372],
            [1.972550527309526, -3.3166926215061174],
            [1.9709293070026963, -3.3116310895217334],
            [1.9656885188471453, -3.3024112133464327],
            [1.9566601098365906, -3.29551506024459],
            [1.9510452852934406, -3.2893547423129794],
            [1.9485314814356243, -3.2813167217223587],
            [1.952662258034654, -3.2739197744043294],
            [1.963481420051555, -3.26623308542843],
            [1.9710282160239796, -3.265079988240547],
            [1.9771862498251385, -3.2656662040344786],
            [1.9848058660845251, -3.2647339728738296],
            [1.9930196694944766, -3.2667128442915874],
            [2.007125783142859, -3.2719900636289747],
            [2.0134629914590274, -3.271964297593362],
            [2.018489115510275, -3.270134979243458],
            [2.0182620319365063, -3.3027776649490757],
            [2.017139607177014, -3.3028910163602565],
            [2.0168376279113405, -3.384916778942336],
            [2.017457064568994, -3.3949345575819456],
            [2.0168916852796923, -3.50205450182974],
            [2.031396267135441, -3.50200870769783],
            [2.0313207904984005, -3.516772477166056],
            [2.0457109381618293, -3.5168925320012527],
            [2.045778087507038, -3.5021731801696094],
            [2.0601031720608893, -3.5017822621179935],
            [2.0597197009895893, -3.575570667684451],
            [2.0164137138072054, -3.5753453388343086],
            [1.9720458695918834, -3.57470264665296],
            [1.9720000805468394, -3.618851427869681],
            [1.95725123630149, -3.618963863895138],
            [1.957172239929102, -3.6263875856886405],
            [1.9426117849758495, -3.6261985645484893],
            [1.942570410334788, -3.6299134230983143],
            [1.9390206554970912, -3.6299208925203517],
            [1.9389081442290999, -3.6335323723706527],
            [1.9279127849145061, -3.633343880250253],
            [1.9280949667727894, -3.6406143706353173],
            [1.9055098926841794, -3.640572014791793],
            [1.905425824706635, -3.647823225912338],
            [1.901636765553231, -3.64792101506242],
            [1.8962306347705804, -3.650438623451747],
            [1.8832440785532334, -3.6548320743101606],
            [1.8832449579770683, -3.6623170351383],
            [1.9016115664101252, -3.6626892415674006],
            [1.9014232117651477, -3.7522193541021105],
            [1.895612693935686, -3.7536255272732495],
            [1.8908572644418926, -3.756237760278126],
            [1.8854919729860355, -3.7571326851987807],
            [1.8810287129288343, -3.761298016217267],
            [1.8759817553618585, -3.7617143789012006],
            [1.8726762751643558, -3.7639396367519815],
            [1.8644364652255188, -3.7652054219833913],
            [1.86278672263597, -3.764502525640041],
            [1.8546336264194172, -3.7665749222118268],
            [1.850741572828237, -3.768725201281738],
            [1.8451330527615963, -3.7691344997539087],
            [1.8344835706721314, -3.7684179964218747],
            [1.825565858732762, -3.76628866871559],
            [1.820606957917534, -3.7679952125333713],
            [1.816851915002706, -3.7735130782835826],
            [1.8106222313672442, -3.775568255303316],
            [1.8063603426352723, -3.7756201548170387],
            [1.8034901467348832, -3.7702963055598264],
            [1.7958261269995321, -3.761842228117436],
            [1.7901562540178535, -3.760508374345084],
            [1.785485935444334, -3.762474455942011],
            [1.7861715642907015, -3.7693702680078216],
            [1.7847468439466434, -3.775021797901912],
            [1.7789723821956227, -3.7753667162706503],
            [1.7705242730324533, -3.7796876220336646],
            [1.7633382480493085, -3.7753590426081622],
            [1.7564128152735907, -3.773530520089348],
            [1.7520717758027609, -3.7777354255248534],
            [1.7462900565766248, -3.78777310575187],
            [1.7397991287016645, -3.7930785693298104],
            [1.7324065179420893, -3.7909315784569557],
            [1.7254044561340345, -3.789955471748375],
            [1.7265978984705226, -3.694737989232404],
            [1.7277403575024934, -3.6030492108647705],
            [1.7279776525904595, -3.5939015213140295],
            [1.7285460132791441, -3.5351141580825134],
            [1.7281969888361746, -3.524934730058889],
            [1.7288590718105843, -3.4910511942121314],
            [1.7285621875348418, -3.4826625881366366],
            [1.7293370711875795, -3.471750741770883],
            [1.7298029491879494, -3.430049878773359],
            [1.730407167016378, -3.4149339360922597],
            [1.730969992927193, -3.357439741292562],
            [1.731395137162928, -3.351418407406057],
            [1.7300412619766188, -3.3426190318527036],
            [1.727891920963043, -3.3347713738381803]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.2743307224747, "lat": 35.19887580974081 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05131"],
        "coty_name": ["Sebastian"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sebastian County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00069181"
      },
      "bbox": [
        1.7254044561340345, -3.7930785693298104, 2.0601031720608893,
        -3.2647339728738296
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.343314368511572, -2.885418205119605],
            [3.3412006132754364, -2.7843480862276966],
            [3.339284288535833, -2.7843597758461276],
            [3.3391960196204504, -2.755183027443103],
            [3.338672178994784, -2.7405280379052743],
            [3.3381580987683086, -2.6968149653805518],
            [3.424107903603821, -2.695332899396108],
            [3.4237004174821575, -2.6690513327531167],
            [3.422872464057411, -2.6366758005955697],
            [3.4223795077168266, -2.6075399205613046],
            [3.4370299590841342, -2.6067947026592955],
            [3.5086162088692165, -2.6060050264199597],
            [3.5070844252294258, -2.5316239143410897],
            [3.511310025932004, -2.538339234071107],
            [3.51181166915512, -2.54588778033683],
            [3.510384335655192, -2.5493013662550985],
            [3.512203514369989, -2.5578041491762202],
            [3.5200708276125288, -2.5621961631100905],
            [3.523490874396866, -2.5620950540217926],
            [3.53128703357657, -2.557397482191752],
            [3.536182667987541, -2.5534782286473723],
            [3.5414838937197217, -2.547739856610037],
            [3.5447441475352583, -2.5467753404007123],
            [3.5515922453512347, -2.548672460570078],
            [3.556691023474904, -2.55709469280733],
            [3.558411922137913, -2.564626660801738],
            [3.56604879953469, -2.5825518555789193],
            [3.5712156646288005, -2.5917461208734056],
            [3.577710480085692, -2.5995738302368747],
            [3.585722143508374, -2.603351805476068],
            [3.5914852510694733, -2.603743960419166],
            [3.5967830651833017, -2.6027259244388565],
            [3.6007339849561477, -2.603512826515005],
            [3.606301711083758, -2.60741455402374],
            [3.609440534747009, -2.61251214403138],
            [3.6213660800997536, -2.6247898196306663],
            [3.6223497211017985, -2.629240511897006],
            [3.6207236989895293, -2.6338629425459863],
            [3.6156621325533482, -2.6374358079820417],
            [3.6082619742378186, -2.6393571603484434],
            [3.603487478197645, -2.6385419967845096],
            [3.5966796103488736, -2.640733448466326],
            [3.5932040277874915, -2.6434332554048265],
            [3.589094283024357, -2.6515704176275032],
            [3.5891998222576644, -2.656050260094151],
            [3.59160489038631, -2.662858401067643],
            [3.5942450599311684, -2.665096986430394],
            [3.5992678964201015, -2.6724440394553857],
            [3.602424181273863, -2.6785619484881433],
            [3.6037795128412835, -2.6876396462109664],
            [3.6020387081543133, -2.6967609802849646],
            [3.5936518373893214, -2.705340999745565],
            [3.585282356137069, -2.709694712522155],
            [3.5833680643290013, -2.711581100680498],
            [3.5813270135506974, -2.718311525205017],
            [3.580826528720431, -2.7240466153354665],
            [3.5824703655674215, -2.7284227556499494],
            [3.5873256020380206, -2.7335431497818083],
            [3.597409711374015, -2.7366799640631005],
            [3.613860912735513, -2.7335698320083965],
            [3.6192162278024194, -2.730952244427606],
            [3.6267113536122526, -2.725344806266828],
            [3.633423867953927, -2.7176482188745483],
            [3.6402925851606183, -2.7160336038280106],
            [3.6472310761921714, -2.720755868610875],
            [3.6495771153842536, -2.728233255178847],
            [3.6498407818164256, -2.735624980411229],
            [3.6513467164970783, -2.739578706173969],
            [3.654761139540216, -2.7425364593824075],
            [3.6593841786281343, -2.744182259713833],
            [3.6682754874393657, -2.7409014981988618],
            [3.6729181558351347, -2.736834948567949],
            [3.6773933924679674, -2.7312112169553804],
            [3.6808770071012398, -2.723953057607393],
            [3.683303210172665, -2.7210769614527006],
            [3.6901685839350162, -2.7181422444822316],
            [3.6973109590148123, -2.7184875216859457],
            [3.7007696510673704, -2.7198179788989423],
            [3.7096892650942337, -2.726544278887924],
            [3.711848791204008, -2.7308939520076754],
            [3.723851956926298, -2.7456156123953304],
            [3.730554161383354, -2.751226403875174],
            [3.736604223108079, -2.7549313878478183],
            [3.744744298016354, -2.76288058914826],
            [3.7510437415281497, -2.7667028588185842],
            [3.758317248579468, -2.7743579822145534],
            [3.7637775138831175, -2.7759493105145814],
            [3.77155950797625, -2.7757779144141645],
            [3.781469181379211, -2.7732562040969624],
            [3.7872922505316993, -2.774677746055868],
            [3.7928455386430886, -2.7804189162652904],
            [3.795557084721673, -2.78767309025478],
            [3.7949310986610065, -2.798684826913306],
            [3.796202477841919, -2.8108969424355865],
            [3.7931053225102525, -2.8213814656183893],
            [3.7877022909683036, -2.8298746178983043],
            [3.785293303386187, -2.8322635302124026],
            [3.7822163567450837, -2.838819780522661],
            [3.7807766261959412, -2.8456003510762105],
            [3.7822973796991715, -2.853482078911906],
            [3.783583066473656, -2.866268776372063],
            [3.7868247029022357, -2.8740209513975072],
            [3.7868778381889796, -2.883289643232467],
            [3.787795004467119, -2.8864587737757375],
            [3.7944868641200613, -2.8917643261006445],
            [3.800284947050769, -2.8938216438369415],
            [3.8063864763790947, -2.8995988142005347],
            [3.8114897756886483, -2.906473377863733],
            [3.812578931893296, -2.950645278321677],
            [3.794398814397882, -2.9510252712263187],
            [3.73069127132369, -2.952916611103645],
            [3.6839158621891563, -2.954105674977981],
            [3.655785682207071, -2.9544340927859354],
            [3.598226146188792, -2.955865568819297],
            [3.516358051686313, -2.9565723137787305],
            [3.4877731979925164, -2.9570053930885276],
            [3.4252423804339873, -2.9579181157666112],
            [3.37347116189428, -2.9581051338273414],
            [3.3448191462125343, -2.9585842035371472],
            [3.343314368511572, -2.885418205119605]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.15679411885182, "lat": 35.85987601999142 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05137"],
        "coty_name": ["Stone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stone County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00069902"
      },
      "bbox": [
        3.3381580987683086, -2.9585842035371472, 3.812578931893296,
        -2.5316239143410897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-20.0491724919578, 6.379574429172973],
            [-19.98591171868865, 6.358865030100721],
            [-19.96031455592713, 6.350746245542305],
            [-19.89995536071786, 6.3319662155021605],
            [-19.78339107485438, 6.296899362166803],
            [-19.774937624241932, 6.293844946806473],
            [-19.76776204489252, 6.291253198455527],
            [-19.708189292705768, 6.275388494610742],
            [-19.65860309265812, 6.258555652504499],
            [-19.633789980372082, 6.256059679012835],
            [-19.594858678653054, 6.245390476907924],
            [-19.558479699009368, 6.234744775201222],
            [-19.561462354751473, 6.229784071678983],
            [-19.57008201531209, 6.228263084141558],
            [-19.572868239797106, 6.228742854838249],
            [-19.579341099687007, 6.224348786378417],
            [-19.57783871205952, 6.221305139369173],
            [-19.57876166220625, 6.212923667727585],
            [-19.581039566700888, 6.208355915826069],
            [-19.57990534323288, 6.204159183988031],
            [-19.582443398855368, 6.194214278551992],
            [-19.588009478910696, 6.189943665181028],
            [-19.594479608980777, 6.182106363585087],
            [-19.59746085102081, 6.181180427839775],
            [-19.599764740965096, 6.176526967298076],
            [-19.604631899082555, 6.174546991827324],
            [-19.60823403235349, 6.163248657945372],
            [-19.60875829804451, 6.159124714865702],
            [-19.612296359795945, 6.1566888804641176],
            [-19.614990422183435, 6.15267025497602],
            [-19.620206849612398, 6.151043953718685],
            [-19.638660497274632, 6.1587684632288076],
            [-19.64432776649962, 6.155240633433908],
            [-19.64540342468996, 6.14915192216187],
            [-19.652416159114672, 6.144882587591616],
            [-19.655009330037483, 6.138363394679537],
            [-19.66091489171714, 6.139872059537086],
            [-19.665362509089963, 6.1452221210571265],
            [-19.666238807812523, 6.1493431378710754],
            [-19.674419904478842, 6.150822312046693],
            [-19.678412361254587, 6.154335229224538],
            [-19.682905452143245, 6.1487237330870546],
            [-19.68870515568572, 6.146087633225115],
            [-19.68541155274844, 6.142445479445233],
            [-19.68979252246095, 6.1401250604516555],
            [-19.689552555992123, 6.137839333383405],
            [-19.692546571407302, 6.133237766429509],
            [-19.693175126545626, 6.127063068773798],
            [-19.701723265939982, 6.126493868766056],
            [-19.703553715852532, 6.1227983013888485],
            [-19.7119898977944, 6.117540669272348],
            [-19.71435616418926, 6.108256870874472],
            [-19.72245930123087, 6.112453551584827],
            [-19.731894396410986, 6.1121306624791485],
            [-19.739386314064795, 6.1095026670677886],
            [-19.739130372883462, 6.106312060601143],
            [-19.741752593234125, 6.100024916815454],
            [-19.736798881611936, 6.094255484574702],
            [-19.73728068265782, 6.081342564561501],
            [-19.73461260106949, 6.077178554636667],
            [-19.73140724599958, 6.077155860620885],
            [-19.727134594600695, 6.070778029449762],
            [-19.731527641315186, 6.065330408977411],
            [-19.732653383856217, 6.061028812849282],
            [-19.738524146412534, 6.062226590740454],
            [-19.742482571010658, 6.059949226914339],
            [-19.74234823951287, 6.047786459178452],
            [-19.743730755238893, 6.0392007745074405],
            [-19.746351097229613, 6.031244324589983],
            [-19.74572561088808, 6.024360710540402],
            [-19.747711758237912, 6.01687064824938],
            [-19.745675272947274, 6.0117848109851995],
            [-19.742455368468082, 6.008538777410185],
            [-19.739696642573417, 6.001350073891985],
            [-19.73993668964506, 5.995366481368763],
            [-19.74194989232311, 5.98953967827941],
            [-19.74624863368151, 5.985870657337667],
            [-19.750502193417585, 5.984163189590811],
            [-19.753239501160643, 5.9775142765130616],
            [-19.749774353672812, 5.970336102043075],
            [-19.753320998714592, 5.969531897503831],
            [-19.76096066613154, 5.963636564948479],
            [-19.772306492334984, 5.956570193239673],
            [-19.77571330930891, 5.952925366297727],
            [-19.779740397256273, 5.936645819192344],
            [-19.779885998394747, 5.927528051943797],
            [-19.778233706753475, 5.919761569492854],
            [-19.779487363351677, 5.916932649265654],
            [-19.783270856618184, 5.918839332371198],
            [-19.79102192698957, 5.920274566428561],
            [-19.792591202015636, 5.914854904295889],
            [-19.80150128345291, 5.909883447649977],
            [-19.80670428536067, 5.905236387469604],
            [-19.80875283797548, 5.899463484312657],
            [-19.81276508870242, 5.898180162806888],
            [-19.81815591041142, 5.887975805824098],
            [-19.816872266046925, 5.883462878535438],
            [-19.8091065726977, 5.88572725236021],
            [-19.80364715012348, 5.884126212217544],
            [-19.804120079355325, 5.879271438776738],
            [-19.79544442962521, 5.880729982680113],
            [-19.793789119977006, 5.871791501631041],
            [-19.79925436975999, 5.87138085559416],
            [-19.800771029802608, 5.867223490247012],
            [-19.799752753711267, 5.8604555795251505],
            [-19.7981943175748, 5.857641425921502],
            [-19.8039455839769, 5.854146133251577],
            [-19.806197990005373, 5.849396933614572],
            [-19.81131928276832, 5.845888694363348],
            [-19.811519954108775, 5.841820847824394],
            [-19.80752775819493, 5.830327406732795],
            [-19.80470730668017, 5.830424026556706],
            [-19.79353336080552, 5.823734626860408],
            [-19.79122092817104, 5.821173305827445],
            [-19.787177225630426, 5.820269947050577],
            [-19.78505954614008, 5.815069025072415],
            [-19.785951287843957, 5.8089131895322526],
            [-19.785519529959675, 5.80332276161331],
            [-19.789730371390615, 5.795042786470269],
            [-19.78988157980261, 5.789926125699067],
            [-19.787907956178522, 5.787297550487002],
            [-19.78920960569839, 5.783079167062027],
            [-19.78959946923073, 5.776120289390705],
            [-19.78878288019516, 5.770996841361523],
            [-19.78971425654504, 5.764518250959797],
            [-19.79167623324803, 5.760801792862777],
            [-19.78934654280379, 5.755747938024746],
            [-19.79087568085582, 5.753181495947079],
            [-19.78928744092114, 5.746539780404206],
            [-19.78666804093735, 5.7411162238388735],
            [-19.780346117669684, 5.736792401364283],
            [-19.785891945727535, 5.729430691543549],
            [-19.784535725852738, 5.724833216147482],
            [-19.790381467196756, 5.720309126322066],
            [-19.79609901601869, 5.711192718488849],
            [-19.80520723366756, 5.709374630532059],
            [-19.808658872690664, 5.710180477951099],
            [-19.818435634029058, 5.705478927082641],
            [-19.815263297073496, 5.699126964473583],
            [-19.815448308036142, 5.690501520472239],
            [-19.818310555796206, 5.68827617081906],
            [-19.819472639727355, 5.684185579342538],
            [-19.824128505504373, 5.682884004925121],
            [-19.831120114717045, 5.682545669444908],
            [-19.833081621834395, 5.675382708041941],
            [-19.837212092428313, 5.673592156947151],
            [-19.838762897695126, 5.670985653365794],
            [-19.899280118745935, 5.688630459050899],
            [-19.903104294594762, 5.689110171969966],
            [-19.91677323592471, 5.692910889270273],
            [-19.892778686569944, 5.773084181904055],
            [-19.974848311669952, 5.797340508150185],
            [-19.974270265061502, 5.799254262599912],
            [-20.085750166998363, 5.8317468920448805],
            [-20.102551981935655, 5.836785473440961],
            [-20.10131478395605, 5.842194166204418],
            [-20.099779084640673, 5.864482606658902],
            [-20.100917479116955, 5.867212172758046],
            [-20.09908674055907, 5.874527536437941],
            [-20.1002250044979, 5.884796386712319],
            [-20.089902968312327, 5.919950465856233],
            [-20.095585686924654, 5.927804751896466],
            [-20.097205943975595, 5.94461623703054],
            [-20.094664765238598, 5.953623678384998],
            [-20.089836545967508, 5.959208863774006],
            [-20.0926530775962, 5.969558189311213],
            [-20.089555484503627, 5.971462010399857],
            [-20.087311641572832, 5.976513883281802],
            [-20.09266958787238, 5.993085962130011],
            [-20.09027338517162, 6.005015847885807],
            [-20.091277542758114, 6.010542445946921],
            [-20.08986511422033, 6.016944491683714],
            [-20.092028895483896, 6.025112563938545],
            [-20.091918938995615, 6.028536169504831],
            [-20.0957557070884, 6.036489952755705],
            [-20.09410991246016, 6.041224355000599],
            [-20.094235287154664, 6.051055777792133],
            [-20.091414641541046, 6.057772669172458],
            [-20.09214235642303, 6.0662633750615536],
            [-20.088650611419922, 6.075839096590889],
            [-20.086096410422126, 6.088005335106933],
            [-20.086334194203683, 6.097159568550029],
            [-20.087987022962814, 6.109021142433888],
            [-20.09207296854271, 6.122122975815328],
            [-20.094968131686795, 6.126372471923242],
            [-20.09961833542576, 6.130485904474331],
            [-20.10446775685967, 6.1270727505471285],
            [-20.111910575769578, 6.123909383167211],
            [-20.11447640890205, 6.125421340942853],
            [-20.11607198219937, 6.134617149008261],
            [-20.12543326120081, 6.144364523945155],
            [-20.128384537123676, 6.150146787739076],
            [-20.1277240093743, 6.152645235458053],
            [-20.133895393642295, 6.162232756003441],
            [-20.137602247667022, 6.16938638850165],
            [-20.142313432615666, 6.170218528371117],
            [-20.144756986392775, 6.177992671966153],
            [-20.142633398572414, 6.184592573878498],
            [-20.138153246659922, 6.185508544882624],
            [-20.13356261292195, 6.189384733139244],
            [-20.124829938587993, 6.199140378824843],
            [-20.11563015275801, 6.211557657945107],
            [-20.099608889221688, 6.235746285739332],
            [-20.079419607192843, 6.273334833276479],
            [-20.067810699501774, 6.301542000593052],
            [-20.060316953993322, 6.3227773895298744],
            [-20.059687195761253, 6.328280768494788],
            [-20.062218018143255, 6.329118037972756],
            [-20.06215516129997, 6.3337363957996],
            [-20.0545234111705, 6.347139582584234],
            [-20.048898340993365, 6.36377091098827],
            [-20.049882060904274, 6.37014492430183],
            [-20.0491724919578, 6.379574429172973]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.89723593037331,
          "lat": 41.743122449112924
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06015"],
        "coty_name": ["Del Norte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Del Norte County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01682074"
      },
      "bbox": [
        -20.144756986392775, 5.670985653365794, -19.558479699009368,
        6.379574429172973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.397211957653806, 3.440847172116956],
            [-18.393036434198674, 3.4383513333331823],
            [-18.386220169786185, 3.439080886594315],
            [-18.38228908724143, 3.441540876459395],
            [-18.378836384646043, 3.441360340547153],
            [-18.375749671105265, 3.4448716768133987],
            [-18.373023103517, 3.444143534272766],
            [-18.368537462922415, 3.447325258698796],
            [-18.363478384947282, 3.4492128353442433],
            [-18.35832695658638, 3.45361739297303],
            [-18.356969501129083, 3.456733535697768],
            [-18.34904517361478, 3.458570660803677],
            [-18.344310350742113, 3.4611637554371746],
            [-18.34526722331032, 3.465464050919959],
            [-18.338504605124303, 3.4683417359884245],
            [-18.333769924548413, 3.473000778322002],
            [-18.331454549569177, 3.479140958756819],
            [-18.325524822639423, 3.4864527901312337],
            [-18.31587197356205, 3.5226427541624763],
            [-18.3079562674873, 3.5263137407114264],
            [-18.30413670772923, 3.532187111293886],
            [-18.299172025242243, 3.5332280832155747],
            [-18.295976744940255, 3.5365360785600197],
            [-18.29014529033149, 3.5351061262614265],
            [-18.287414577224354, 3.536907505325388],
            [-18.281567592714136, 3.535418821681018],
            [-18.27719316497535, 3.5391199984484514],
            [-18.268051144494702, 3.54348391365399],
            [-18.26396034824747, 3.5436039946549736],
            [-18.261485827178234, 3.546761439564743],
            [-18.256195164253246, 3.5431426736710763],
            [-18.2525062648601, 3.538717639760902],
            [-18.252805760591247, 3.534461521417567],
            [-18.251507672189085, 3.527447838158653],
            [-18.245080302492664, 3.5217914497214937],
            [-18.246019412222413, 3.5170314241164586],
            [-18.244601268079375, 3.5121425552779733],
            [-18.23603296728349, 3.509666852764253],
            [-18.23576944786819, 3.5046651480750963],
            [-18.229992860596568, 3.5048665631371065],
            [-18.226469850893043, 3.5072429133180147],
            [-18.225639869866555, 3.502210271879116],
            [-18.228154888946545, 3.4970685827075867],
            [-18.227707799606314, 3.494640650962753],
            [-18.229099860629148, 3.4854735542780375],
            [-18.2280145138541, 3.479475946654937],
            [-18.22461261365208, 3.479634727239022],
            [-18.218443827564805, 3.475337820297949],
            [-18.21701918801941, 3.471542169581085],
            [-18.21723541930144, 3.466771843914582],
            [-18.20276662102028, 3.466070686732767],
            [-18.200068068881464, 3.470039221499568],
            [-18.19279694380046, 3.4676974855842433],
            [-18.18510577534398, 3.467750295612466],
            [-18.181448168725357, 3.45938334741273],
            [-18.17681908027159, 3.456468891796266],
            [-18.17638972675801, 3.4535251413120025],
            [-18.171364139460316, 3.4508800732619096],
            [-18.166510648328558, 3.450520586739577],
            [-18.16200791628569, 3.44474989963245],
            [-18.159421225680518, 3.439654103784052],
            [-18.15716848730942, 3.4306823301939176],
            [-18.151907514652343, 3.429817757775096],
            [-18.14928306074117, 3.4211158789657996],
            [-18.146198871570455, 3.417098268766239],
            [-18.145258929950455, 3.4125434025571915],
            [-18.136845774478964, 3.4161631109326045],
            [-18.133342108198455, 3.4154491335429653],
            [-18.127563731357387, 3.4176143462917548],
            [-18.12237442277015, 3.4239148601528813],
            [-18.11799029492631, 3.436376632120038],
            [-18.046431948557366, 3.4173251787594614],
            [-17.99550690515473, 3.4039944907556396],
            [-17.978854744051738, 3.399491348292393],
            [-17.96429147600804, 3.397864150147136],
            [-17.902320632805118, 3.381546213330412],
            [-17.860971590198474, 3.3702658520993882],
            [-17.820333297755482, 3.3601066985402697],
            [-17.819383250196257, 3.3594136393534755],
            [-17.743895948057677, 3.3394111210234465],
            [-17.728007948363214, 3.3365747166654796],
            [-17.646660984592714, 3.315382215270914],
            [-17.6432713197631, 3.328701225914939],
            [-17.63256800935863, 3.3260066292912214],
            [-17.66191482523975, 3.2132698162396824],
            [-17.679174599492914, 3.1469611325838023],
            [-17.704410556664772, 3.055824460178251],
            [-17.79055667043221, 3.078158291289592],
            [-17.794703558559902, 3.079818757636615],
            [-17.809608536040397, 3.083126680371821],
            [-17.9238320587793, 3.1134440863174446],
            [-18.03805922787867, 3.143746902477415],
            [-18.075409639003436, 3.153573996108749],
            [-18.075176166653915, 3.1611074015568805],
            [-18.07672412679261, 3.1634737029281683],
            [-18.082263440974554, 3.164759712975473],
            [-18.090233381547815, 3.1739703074834487],
            [-18.092032903070162, 3.177275948612514],
            [-18.091132295524005, 3.1831253530789563],
            [-18.08922444732997, 3.1861229016881447],
            [-18.08761569886955, 3.1958760089854565],
            [-18.09018500392356, 3.199822450213495],
            [-18.090356769381284, 3.2041833905624384],
            [-18.09521655392522, 3.2091980515809513],
            [-18.09556523499105, 3.214220778153069],
            [-18.09403665461884, 3.2184344914205774],
            [-18.097622889546958, 3.222696638921582],
            [-18.095485738313464, 3.2292713494715577],
            [-18.09828841921259, 3.232668091907756],
            [-18.103885013218584, 3.233967043221119],
            [-18.104902014008513, 3.2377559305576233],
            [-18.108694750773125, 3.2426969063340687],
            [-18.114005800505474, 3.2423420645988092],
            [-18.116469508339375, 3.2451373620106283],
            [-18.124243793810557, 3.2442195908824614],
            [-18.14232056327774, 3.2498111802697855],
            [-18.14457593162713, 3.248382185274069],
            [-18.147413368532682, 3.2547121307120648],
            [-18.15062018786769, 3.2541065302444845],
            [-18.16318094429982, 3.2575256750832504],
            [-18.165306452315747, 3.2613284001647163],
            [-18.168864517473118, 3.259242214109451],
            [-18.172073100977062, 3.2596546394198396],
            [-18.183454425008275, 3.2575752795692092],
            [-18.186616435463872, 3.2528090756676113],
            [-18.18963668108655, 3.2527071676753243],
            [-18.193189286718788, 3.248451363267354],
            [-18.20627205469874, 3.2461150244965897],
            [-18.211167001315346, 3.2415111037780107],
            [-18.211828333016154, 3.2387583417344326],
            [-18.21734893024175, 3.236069642488208],
            [-18.220859629894807, 3.236551680408827],
            [-18.219924769758023, 3.2300281769113175],
            [-18.22561555456979, 3.227066926359773],
            [-18.231183076992405, 3.22271216534989],
            [-18.236917807141918, 3.221041847831146],
            [-18.240798286123823, 3.2224083324826123],
            [-18.24628775780783, 3.219823393970808],
            [-18.246754931521135, 3.2147231864461787],
            [-18.25017966411892, 3.2134301740216746],
            [-18.2551980397906, 3.2138807356027095],
            [-18.25920346649814, 3.2088540396397],
            [-18.262357891259626, 3.211223733452759],
            [-18.26638288216894, 3.209111639036576],
            [-18.27413039723058, 3.211040017646729],
            [-18.278665599508102, 3.207877273315515],
            [-18.28829238458557, 3.2049312738877274],
            [-18.291808389640256, 3.20646407858604],
            [-18.29539627545486, 3.2030558016819852],
            [-18.298976763289154, 3.2050526475753154],
            [-18.303223560648597, 3.2036115758275887],
            [-18.304951999197037, 3.2081850664657585],
            [-18.30895535865587, 3.20540244961605],
            [-18.3124933795, 3.2072645838143474],
            [-18.31556778435784, 3.205687630440794],
            [-18.319990394167988, 3.209075793857299],
            [-18.322082973845667, 3.2130398436395824],
            [-18.32739085911795, 3.209553726556578],
            [-18.33625375173942, 3.21206437559717],
            [-18.341832368307877, 3.2112035267672856],
            [-18.345218696787427, 3.208559122698961],
            [-18.35219145385968, 3.2113386077819412],
            [-18.35722244129727, 3.210089250268217],
            [-18.36004684515811, 3.211613883255106],
            [-18.36836830117425, 3.2084199386020793],
            [-18.382163605778253, 3.2128505656956574],
            [-18.38479058723773, 3.2084732812683803],
            [-18.38939559370843, 3.21124426380023],
            [-18.396153729279227, 3.2115851601697813],
            [-18.398318503756858, 3.209130711471748],
            [-18.403839079451494, 3.2113080807277807],
            [-18.405898286356866, 3.21390376116488],
            [-18.417343299169683, 3.2127997708005216],
            [-18.427323670183494, 3.218826143193106],
            [-18.43384587441548, 3.218364149597158],
            [-18.434162432797834, 3.214089507311056],
            [-18.439709646477077, 3.2143304295166337],
            [-18.443591578799577, 3.218434977655291],
            [-18.446562518549072, 3.217595835385585],
            [-18.456754572010887, 3.2120316422434723],
            [-18.46208442801304, 3.2143858795831113],
            [-18.46368063213394, 3.2115407419790185],
            [-18.460236514496813, 3.2058689851272737],
            [-18.46808207350816, 3.2048437796569456],
            [-18.471621723029635, 3.202134319950285],
            [-18.45103776060775, 3.3085208757051463],
            [-18.44842876636821, 3.324153113354148],
            [-18.455792228368555, 3.325780970536111],
            [-18.458332673504128, 3.3295172005462828],
            [-18.458238147433008, 3.338153958375317],
            [-18.45992342401874, 3.343448996564118],
            [-18.460045225291307, 3.3508779438465757],
            [-18.458735709609236, 3.3536020796488892],
            [-18.45364117667541, 3.354401508474201],
            [-18.44906258917734, 3.3600411137549595],
            [-18.44274489453916, 3.3599856610432908],
            [-18.43332576258866, 3.3652692203473036],
            [-18.429316671073593, 3.36557105686057],
            [-18.414782288358683, 3.3999701203644412],
            [-18.413692774863694, 3.401756853900145],
            [-18.405177848093608, 3.4229324958576544],
            [-18.397211957653806, 3.440847172116956]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.51608717127651,
          "lat": 39.58034206434351
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06091"],
        "coty_name": ["Sierra"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sierra County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00277310"
      },
      "bbox": [
        -18.471621723029635, 3.055824460178251, -17.63256800935863,
        3.546761439564743
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.079598293800602, -0.861925837149753],
            [-5.040570438557113, -0.8644080370502405],
            [-5.022733960615699, -0.8658967894180642],
            [-4.90473179729331, -0.8739464384084606],
            [-4.879869196996427, -0.8763855677043826],
            [-4.822814728052786, -0.8804057805205302],
            [-4.727277305452232, -0.8871586340945075],
            [-4.723410864707701, -0.8875651071152277],
            [-4.660408300085167, -0.8916824854159553],
            [-4.566052407641742, -0.8979443587570596],
            [-4.515674245165442, -0.901077570864889],
            [-4.391373718490023, -0.9093090414702575],
            [-4.360200468493222, -0.9110631813315891],
            [-4.270409138989302, -0.916975968024429],
            [-4.272770825933407, -0.953666501706188],
            [-4.277740260036826, -1.0268067269080536],
            [-4.279432824094404, -1.0562349468445178],
            [-4.2839765405223105, -1.127986708201319],
            [-4.2867728974151476, -1.174004188794109],
            [-4.2894241659620205, -1.2108373293953443],
            [-4.292706233842548, -1.2662278411134757],
            [-4.295474252075272, -1.3059937838401345],
            [-4.302972944334442, -1.4232756543569378],
            [-4.309750067565324, -1.530724127514169],
            [-4.312581802134678, -1.5730893088079339],
            [-4.443754140747618, -1.5639050411649273],
            [-4.485129036329445, -1.5605225288881228],
            [-4.559765402927883, -1.5553742726339366],
            [-4.830228801763204, -1.536198028501368],
            [-4.864700174011532, -1.5311873921836439],
            [-4.920104333883186, -1.525171146670728],
            [-4.971703826062074, -1.52157321779406],
            [-5.057859590965613, -1.516372094707364],
            [-5.069750699194865, -1.5138966209814764],
            [-5.1359276654412875, -1.5089139165892804],
            [-5.126463349452617, -1.3730607635440368],
            [-5.125325153377508, -1.3647045605803112],
            [-5.104440941186673, -1.1251398796777592],
            [-5.098251379594937, -1.1254588800434866],
            [-5.080732569981526, -0.880895514446792],
            [-5.079598293800602, -0.861925837149753]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.56038179234261,
          "lat": 37.31919763618651
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08009"],
        "coty_name": ["Baca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baca County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00198120"
      },
      "bbox": [
        -5.1359276654412875, -1.5730893088079339, -4.270409138989302,
        -0.861925837149753
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.55568756830938, 0.1493008358515986],
            [-8.552464715555093, 0.14103064338850893],
            [-8.552940613501395, 0.1346835426765297],
            [-8.551106844702211, 0.1325341461341206],
            [-8.550273233473417, 0.12606371468544258],
            [-8.545430875522475, 0.11832143082274159],
            [-8.542638499844193, 0.10591320343161373],
            [-8.534683943736928, 0.09788449308117432],
            [-8.527610784535804, 0.09513613174041713],
            [-8.525591022436359, 0.08571607833049859],
            [-8.52657588337901, 0.08298609335444058],
            [-8.522142952756267, 0.07287587131897506],
            [-8.522196303259383, 0.06457977029742941],
            [-8.52419004036624, 0.060171523706277145],
            [-8.524814645935967, 0.05452028526539398],
            [-8.521119117046407, 0.051358641421836874],
            [-8.522213694037916, 0.040987439662902116],
            [-8.520759565245262, 0.03530866709834971],
            [-8.521365577655928, 0.028638814008450295],
            [-8.520499780192342, 0.022345369747391337],
            [-8.518224282354108, 0.017277367498419727],
            [-8.519961658435376, 0.012223076220718793],
            [-8.517690466298461, 0.007058001047936686],
            [-8.517219584545925, -0.0019155354146154406],
            [-8.520095603559168, -0.009781962000821626],
            [-8.52341349044877, -0.011975490337473946],
            [-8.527047457730852, -0.01769298660378227],
            [-8.52871327348564, -0.023854722781314796],
            [-8.526029794287412, -0.024440456490826025],
            [-8.522781853376076, -0.03174956756743126],
            [-8.522175635739737, -0.036599098435747504],
            [-8.52348282852308, -0.04065920264394779],
            [-8.521915664647405, -0.04956026061790756],
            [-8.526506791609616, -0.06274425103786724],
            [-8.523428889714122, -0.06853585089115208],
            [-8.523760736964988, -0.07303668815894822],
            [-8.520482605933937, -0.08124531256508713],
            [-8.517693814628208, -0.0829023820739086],
            [-8.512811065010883, -0.08096134596626396],
            [-8.504222743983632, -0.08308038946396966],
            [-8.498310343505619, -0.09083164572330828],
            [-8.49284089889949, -0.09457517872553829],
            [-8.491946112051608, -0.09955283738726664],
            [-8.489451814050872, -0.10434876477349306],
            [-8.49355251198512, -0.10655349466066681],
            [-8.498588962780257, -0.10661047336164621],
            [-8.498716796452783, -0.11791936054179655],
            [-8.503154584219448, -0.12455159425824423],
            [-8.5076681532415, -0.12407874034437756],
            [-8.513195079594263, -0.12976794420616602],
            [-8.513355495680988, -0.13383999313616984],
            [-8.515874363023727, -0.13513698978108032],
            [-8.51387840779348, -0.13982105494612637],
            [-8.516691107124906, -0.1445939686665125],
            [-8.516642312697194, -0.15354818971736378],
            [-8.521214255976558, -0.15619788783228863],
            [-8.524093596986209, -0.1608719632455512],
            [-8.527194365233035, -0.1630692077162001],
            [-8.532189579630545, -0.16157595611781111],
            [-8.539044134265104, -0.1545047657017855],
            [-8.545331205373463, -0.15437449213175095],
            [-8.550543498430883, -0.15792082726866893],
            [-8.555575540618463, -0.15846428850685357],
            [-8.556309695627784, -0.1641163992857845],
            [-8.560040857316451, -0.16519744954306445],
            [-8.559067603446776, -0.17304574469046183],
            [-8.556454982615115, -0.182151860690254],
            [-8.560298515442609, -0.1874871287453809],
            [-8.559580733083536, -0.18944093926171487],
            [-8.554383163384069, -0.1900806087144644],
            [-8.5459573291318, -0.19463187344458008],
            [-8.602405602297326, -0.18796529868038908],
            [-8.601899244678446, -0.1950479892408828],
            [-8.604773786293489, -0.19950155529410968],
            [-8.603959774561272, -0.20550497752016963],
            [-8.60522719085295, -0.20901277196374834],
            [-8.604771514871127, -0.21380608066002266],
            [-8.606779313567895, -0.21606589357719327],
            [-8.606599644325144, -0.22180401262197527],
            [-8.604219663162812, -0.22965550380864816],
            [-8.604911497129287, -0.2323225335383982],
            [-8.611303240037833, -0.2349288531454164],
            [-8.613060800856635, -0.2389032713733715],
            [-8.617834517853536, -0.24293035412818015],
            [-8.624416495217854, -0.24153194245838386],
            [-8.627081781562303, -0.24723581660582966],
            [-8.63324663393873, -0.24711721989244106],
            [-8.638358852229134, -0.24486216349399506],
            [-8.642562454093285, -0.24796723689655376],
            [-8.646159732661587, -0.24661611840923978],
            [-8.653203147569862, -0.255310859505605],
            [-8.657110824276254, -0.25523751457937727],
            [-8.662048116168357, -0.25272468470066944],
            [-8.66312374122516, -0.24696965773420138],
            [-8.668884324530445, -0.24860967710878817],
            [-8.67470087711963, -0.24614467140495813],
            [-8.68035191122523, -0.23991742496482704],
            [-8.684635780297674, -0.2381657166753853],
            [-8.681456853699547, -0.23259835022982345],
            [-8.682499558591639, -0.22596057365328054],
            [-8.679050105272943, -0.2241215285662774],
            [-8.680110516151489, -0.21895909233755037],
            [-8.67736060826314, -0.21440685850841507],
            [-8.680955389679522, -0.20823894012398012],
            [-8.68109782187286, -0.2041814960078137],
            [-8.684428993369785, -0.20093594992956992],
            [-8.68428970367635, -0.1971342715939544],
            [-8.686928491907924, -0.18935877526582098],
            [-8.692051219559268, -0.18716517998104978],
            [-8.695382311834665, -0.1816772088899046],
            [-8.701336564187011, -0.17880551167507677],
            [-8.710986413948717, -0.17608959222987422],
            [-8.712953378011688, -0.16790896392946034],
            [-8.715374001333014, -0.1632710510172399],
            [-8.71316326947423, -0.16025255437213815],
            [-8.716461924428197, -0.1559284423324193],
            [-8.718589560208864, -0.14938926910601116],
            [-8.723768870044912, -0.15038548503764126],
            [-8.725537739530976, -0.14838784272596353],
            [-8.73291996859464, -0.14540912648128856],
            [-8.741375150038477, -0.14690657742645402],
            [-8.745106751845718, -0.1456256484163947],
            [-8.749551606784145, -0.1417618609034909],
            [-8.759330499192687, -0.1402867170444147],
            [-8.75789539846618, -0.13531789575666095],
            [-8.752653756398269, -0.1322985311322581],
            [-8.75256043970039, -0.12769183554760155],
            [-8.757462355320042, -0.1241619533702433],
            [-8.764072069521795, -0.1235124582207309],
            [-8.767808891145217, -0.12195169568408389],
            [-8.776768617094183, -0.12348439664698989],
            [-8.780526711333183, -0.12157425382315627],
            [-8.784233463391695, -0.12198475804730922],
            [-8.78945239929625, -0.11505910730824809],
            [-8.78761490246128, -0.11113358122243237],
            [-8.788094331909345, -0.10392339309759947],
            [-8.794674427173584, -0.10187519156346311],
            [-8.791049966063422, -0.09325873455561912],
            [-8.786274541172117, -0.08489179672757],
            [-8.783117273449594, -0.0834303802799498],
            [-8.785261221602418, -0.07978480090894052],
            [-8.784608153047584, -0.07057460423564696],
            [-8.785993322737747, -0.07049705580659922],
            [-8.783481095096487, -0.055823174360227865],
            [-8.78460076485232, -0.04106794682136406],
            [-8.78097259089963, -0.04133914926325257],
            [-8.779542477316543, -0.026928133252380144],
            [-8.776874093593865, -0.012394003998618721],
            [-8.823313347153602, -0.00636729185967977],
            [-8.819769125532119, 0.02255700576716756],
            [-8.830392200138192, 0.023820310520354215],
            [-8.8297103263543, 0.03129173992258835],
            [-8.815145282440385, 0.02961565845109127],
            [-8.813054945725362, 0.05100728620995736],
            [-8.805619700713049, 0.050240058532299264],
            [-8.799489865855573, 0.0953255962980192],
            [-8.806775954177317, 0.09620014407046946],
            [-8.805916814398278, 0.10375594139220969],
            [-8.820010251053851, 0.10557084543248435],
            [-8.819067024794965, 0.1130915828270672],
            [-8.833557825553788, 0.11484662510487585],
            [-8.831645642955158, 0.12931276461914315],
            [-8.852844711188638, 0.1318168465302608],
            [-8.851946370452447, 0.13888723779301812],
            [-8.909864468843315, 0.14620926203829285],
            [-8.909396581523826, 0.15363296706756213],
            [-8.905937665471468, 0.17536434210007062],
            [-8.919690458328699, 0.17696622994338077],
            [-8.916409053087863, 0.20661811889392853],
            [-8.930639246520172, 0.20835724336230851],
            [-8.930021450099742, 0.21570278690864325],
            [-8.936258578996576, 0.21632788817506476],
            [-8.935355055502367, 0.2272244877754015],
            [-8.842299647091773, 0.21573608178718368],
            [-8.833709392513565, 0.21518869914265218],
            [-8.737334466306185, 0.20330740742036316],
            [-8.730453537773514, 0.20186031925115444],
            [-8.66611079417725, 0.19384106852932317],
            [-8.552463749473358, 0.17968303141502048],
            [-8.549610467856512, 0.1727504091487406],
            [-8.555053008304888, 0.16372909086755888],
            [-8.553165116702127, 0.15674525839276063],
            [-8.55568756830938, 0.1493008358515986]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.76926128762919,
          "lat": 38.155475758459986
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08091"],
        "coty_name": ["Ouray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ouray County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00198161"
      },
      "bbox": [
        -8.936258578996576, -0.255310859505605, -8.489451814050872,
        0.2272244877754015
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.562316442009633, -0.113080581561481],
            [-6.478025416587236, -0.12077531813038013],
            [-6.467640588729269, -0.006378771424203413],
            [-6.463305707516087, 0.039673314998944595],
            [-6.455828452509113, 0.12230619372520796],
            [-6.45414260768937, 0.14199616209196522],
            [-6.447452969850758, 0.1420924746644349],
            [-6.418704319139055, 0.139402357126311],
            [-6.395963217155498, 0.1368219291701491],
            [-6.343469391687157, 0.13205854296503353],
            [-6.281687414308011, 0.12591934662943158],
            [-6.225101521974984, 0.12102229121041677],
            [-6.20017414703822, 0.11907748267519684],
            [-6.046341040583273, 0.1055653069372424],
            [-5.9397202021502205, 0.09686292236545335],
            [-5.845053397300815, 0.08943969768837313],
            [-5.843254789896038, 0.08911276797951413],
            [-5.796933894970404, 0.08542129567324876],
            [-5.791716162760994, 0.08541204740996679],
            [-5.769171139224594, 0.08345088107580564],
            [-5.768909341716991, 0.08342965625942356],
            [-5.769357100960651, 0.08064838563644113],
            [-5.791798843790211, -0.1786537669195867],
            [-5.794735149269214, -0.17944102238845092],
            [-5.804389675014668, -0.29450723636150056],
            [-5.804627619180356, -0.2995785742769633],
            [-5.808672097772651, -0.3374873918701922],
            [-5.8181662467230595, -0.4456924113973042],
            [-5.833569682377963, -0.6201666861540579],
            [-5.834921633638449, -0.6200385784648048],
            [-5.841013783376655, -0.6931989435864998],
            [-5.841859019450202, -0.708639037511736],
            [-5.889919587564356, -0.685822263755399],
            [-5.9038400874380885, -0.6793996530803009],
            [-6.0607757851666735, -0.6057875862506863],
            [-6.085701012447549, -0.5941500900727096],
            [-6.227251709408296, -0.5278782600439179],
            [-6.283222242334971, -0.5016569739574852],
            [-6.426036646181786, -0.4980233475563229],
            [-6.517634983151133, -0.49558473220754223],
            [-6.5708694498331575, -0.4943855495876921],
            [-6.572037298617927, -0.4899746254600414],
            [-6.576513617600976, -0.4875391655799024],
            [-6.585990833200247, -0.47944235887747055],
            [-6.582561725464079, -0.4700678021771046],
            [-6.588049637295487, -0.4692432766898283],
            [-6.588599773081198, -0.4654578875123184],
            [-6.595742236697485, -0.4573153346452956],
            [-6.587838941036737, -0.37232629485630003],
            [-6.578799837563201, -0.2760238546761172],
            [-6.577289564450742, -0.25787630331197636],
            [-6.574096111256221, -0.24403131881132878],
            [-6.5636960986672825, -0.13148706216827338],
            [-6.562316442009633, -0.113080581561481]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.51273646911473,
          "lat": 38.17352113014805
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08101"],
        "coty_name": ["Pueblo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pueblo County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00198166"
      },
      "bbox": [
        -6.595742236697485, -0.708639037511736, -5.768909341716991,
        0.1420924746644349
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.882204980426088, -0.40467277484435343],
            [-7.829247779953914, -0.41139926818268885],
            [-7.824176874226108, -0.41169197465792373],
            [-7.799365246950655, -0.4148169247257754],
            [-7.8083980004354325, -0.49958995951411045],
            [-7.8084930833902355, -0.5018065732682246],
            [-7.730875898918638, -0.510180099684238],
            [-7.693710498948849, -0.5140643685122657],
            [-7.575952440146671, -0.5269428145202582],
            [-7.548686425338272, -0.5300965288284637],
            [-7.468001931214313, -0.5387435234496553],
            [-7.381893427364851, -0.5477213639170566],
            [-7.393212957416669, -0.6495664409228519],
            [-7.400828243037718, -0.7197222832440818],
            [-7.405154128359242, -0.7606617674184916],
            [-7.419605382638259, -0.8965702492475972],
            [-7.476746519393459, -0.8902407003250152],
            [-7.526757479401094, -0.8850445745948785],
            [-7.589815842051265, -0.8782051988943181],
            [-7.6627505544379115, -0.8699594582749921],
            [-7.663269706339057, -0.8701403731556552],
            [-7.7706625368580875, -0.8600417920007165],
            [-7.770415562587362, -0.857798729978512],
            [-7.798245771323373, -0.8541200016646173],
            [-7.848858995822722, -0.8479131898278467],
            [-7.869223092794132, -0.846039907766778],
            [-7.894411036102252, -0.8422530239170857],
            [-7.919050324051826, -0.8391381110107472],
            [-7.944307332894738, -0.8356421924335127],
            [-7.915438651610151, -0.5746589646035459],
            [-7.902986685753501, -0.5760692020873738],
            [-7.897203674925409, -0.5248020345714322],
            [-7.892963738206882, -0.4900817097317289],
            [-7.892379589307526, -0.4888103828985911],
            [-7.882204980426088, -0.40467277484435343]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.38322031506343,
          "lat": 37.58250203234651
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08105"],
        "coty_name": ["Rio Grande"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rio Grande County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00198168"
      },
      "bbox": [
        -7.944307332894738, -0.8965702492475972, -7.381893427364851,
        -0.40467277484435343
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.987083810334168, 2.8252402957941523],
            [-7.9301751190782035, 2.8182973445971453],
            [-7.837141581032237, 2.8076551413353825],
            [-7.751262832458146, 2.7979412700785105],
            [-7.645155652885323, 2.784908548505112],
            [-7.648202620285324, 2.7825257827350947],
            [-7.648681162937936, 2.7793711300475237],
            [-7.641153364829876, 2.7722729867780638],
            [-7.645202862602418, 2.76912183351802],
            [-7.645851082867305, 2.7660169518127717],
            [-7.650707200742096, 2.7663241708026307],
            [-7.657148766870161, 2.7645488332614603],
            [-7.659873134991439, 2.757938268203437],
            [-7.660227330036422, 2.7500367351917507],
            [-7.658949914324907, 2.7458794835447],
            [-7.659452905442546, 2.7399718426859474],
            [-7.655410953885839, 2.7364474506061067],
            [-7.654816142051102, 2.729867383166668],
            [-7.655629428919886, 2.7245355482541203],
            [-7.651702647799673, 2.717037130806034],
            [-7.648958889643369, 2.7155233821701743],
            [-7.649530638231442, 2.71146957645764],
            [-7.647230714318605, 2.707735706320355],
            [-7.638909847404211, 2.7040996655267766],
            [-7.633020347233903, 2.7040345053541675],
            [-7.627989409432305, 2.709565910849572],
            [-7.625912707117228, 2.704287934916367],
            [-7.625953564437867, 2.6975262520740584],
            [-7.620908554886534, 2.6947370903416976],
            [-7.619252059780049, 2.6865326262148823],
            [-7.617891081939163, 2.684449028376179],
            [-7.618637821051542, 2.6757653517640385],
            [-7.615150075339715, 2.6734808192573576],
            [-7.606024357628552, 2.677149281443821],
            [-7.599190284593628, 2.6826468807023374],
            [-7.590378321567005, 2.678774546517279],
            [-7.589914743839244, 2.6731489106178086],
            [-7.586029640429299, 2.6681787382936686],
            [-7.578481608059631, 2.66716359780014],
            [-7.5728113642375865, 2.664468411219088],
            [-7.571044564746276, 2.6620437945691213],
            [-7.576338925891903, 2.655073017624035],
            [-7.573493255390926, 2.6494510117333006],
            [-7.57309728350571, 2.6445610081076873],
            [-7.569769044227605, 2.6449684584871114],
            [-7.563826801254947, 2.64241059715357],
            [-7.55253547114316, 2.6439259159408692],
            [-7.545490399088141, 2.645826276930957],
            [-7.544258236616898, 2.6495181549051656],
            [-7.540564728292581, 2.6541059633159425],
            [-7.535239025946679, 2.656413204550812],
            [-7.530547731898945, 2.6534316593629206],
            [-7.531344715829625, 2.6482429293368783],
            [-7.5276934267951185, 2.6414323490004095],
            [-7.526695108047199, 2.6347982494977256],
            [-7.519681059776593, 2.631244566354932],
            [-7.519691003092581, 2.625818970132107],
            [-7.517916218004668, 2.622544386749799],
            [-7.51311790210692, 2.6184369764238764],
            [-7.511339472224659, 2.6140581608181757],
            [-7.511691236702351, 2.6104744594982785],
            [-7.518031338177745, 2.608955347578273],
            [-7.517307564265677, 2.606403265336417],
            [-7.520018368741999, 2.6006883548891553],
            [-7.520380547280575, 2.5933535698156382],
            [-7.517102710616454, 2.589168677770996],
            [-7.5118672118691405, 2.58770495003224],
            [-7.5059799549881445, 2.584309067048365],
            [-7.502920401666427, 2.580555974761016],
            [-7.503821952081163, 2.57814090963793],
            [-7.501380151026007, 2.5746661107116813],
            [-7.502863241209185, 2.5726468001280676],
            [-7.50217068251597, 2.5680544512043855],
            [-7.503756992449407, 2.5629970640920563],
            [-7.5049225327617535, 2.552884945728111],
            [-7.515202895206852, 2.5445195234607283],
            [-7.518021054297037, 2.540295093704551],
            [-7.525812392972286, 2.5360583808927637],
            [-7.5284205120078225, 2.5312386929454944],
            [-7.531802462675635, 2.5289609297328415],
            [-7.528701657106983, 2.5196525505280434],
            [-7.53059871323597, 2.514574242206049],
            [-7.529094948151823, 2.510259871840688],
            [-7.5385994638679685, 2.5015351003755812],
            [-7.536098595778633, 2.4948469176719303],
            [-7.539838100116587, 2.4904353940134625],
            [-7.537312935692338, 2.4858545339138276],
            [-7.5387503009656145, 2.4825596284940827],
            [-7.537747559575663, 2.476238787260025],
            [-7.540603586050156, 2.4747565171426453],
            [-7.539202024735115, 2.460559104999737],
            [-7.5431661338531315, 2.454620041058186],
            [-7.554657062184834, 2.4480786503651095],
            [-7.550777670578101, 2.4421243736030056],
            [-7.5557556701579625, 2.439416323429913],
            [-7.555748643786431, 2.4296616593305473],
            [-7.560988027771732, 2.4256080971906915],
            [-7.558627349563635, 2.417357272259256],
            [-7.55340425898331, 2.4161708282314236],
            [-7.560738351959485, 2.4063432886612097],
            [-7.561251403279415, 2.402628435448699],
            [-7.565391327979746, 2.4009091187545684],
            [-7.571263680722333, 2.3945286771656455],
            [-7.576166544080945, 2.3855895788184776],
            [-7.575051010347804, 2.3793334711276652],
            [-7.575863977384227, 2.3762132360584705],
            [-7.5701089942083755, 2.366241216377411],
            [-7.57043939259603, 2.3600043483979434],
            [-7.574808697828988, 2.354425376669742],
            [-7.57430363363582, 2.351804240758781],
            [-7.577690877368326, 2.346639779001273],
            [-7.575439339249059, 2.3434673118385025],
            [-7.57173504071936, 2.331272053180082],
            [-7.573012379426268, 2.3244195597081996],
            [-7.567815248433476, 2.3160046109758867],
            [-7.567292379134684, 2.3114937924885144],
            [-7.563634315291513, 2.3107709177114466],
            [-7.563019894045787, 2.3044220056473432],
            [-7.559523588213461, 2.3018056212849682],
            [-7.558256553602883, 2.298251719923325],
            [-7.561724516863344, 2.293012898489407],
            [-7.561458730578193, 2.2871839677170342],
            [-7.557863332648661, 2.285692607053069],
            [-7.552439874353533, 2.279130930785262],
            [-7.554299108305811, 2.2769747275985663],
            [-7.5506483831608655, 2.2737207153369767],
            [-7.5518578157722756, 2.2645622760352366],
            [-7.550255751572395, 2.2590607289592],
            [-7.555271692516262, 2.2551973135093513],
            [-7.553586828758523, 2.250180304500465],
            [-7.559505852101318, 2.2454336662010523],
            [-7.5628153128169044, 2.241534665061844],
            [-7.5621205322525205, 2.235839631624126],
            [-7.556443422454617, 2.236250512747774],
            [-7.5571584506264164, 2.2270704133982875],
            [-7.55862517292517, 2.2241374199368136],
            [-7.557156150965968, 2.2205910433963894],
            [-7.557300226741731, 2.214670808633721],
            [-7.554310257556655, 2.2139155321348376],
            [-7.55509089081942, 2.2093906940914],
            [-7.561910426517205, 2.153085094564726],
            [-7.5673287018597035, 2.105593409526516],
            [-7.551882564109649, 2.103854684330735],
            [-7.570842983608701, 1.941033779244886],
            [-7.573759259598066, 1.9413501187966065],
            [-7.579987481455419, 1.8858208170612367],
            [-7.593720452508289, 1.7640758344950815],
            [-7.585825683808655, 1.7629508976086519],
            [-7.5857226039686285, 1.761026033916039],
            [-7.59453485616161, 1.6856816361096312],
            [-7.595212727538508, 1.6795513560275537],
            [-7.615535454320356, 1.6831100449097929],
            [-7.665966504956593, 1.6894976742111876],
            [-7.7151466725027165, 1.6942700309970222],
            [-7.720270779835222, 1.6950458456785582],
            [-7.754044230191654, 1.6980884785046997],
            [-7.872312848588222, 1.7113188451467132],
            [-7.902794238494491, 1.7149831829311335],
            [-7.899011830634523, 1.735621600592073],
            [-7.896560049832328, 1.75976587076953],
            [-7.8915258271433935, 1.7990013544919625],
            [-7.895511976157646, 1.7996102133916065],
            [-7.885172126037474, 1.8882271153919452],
            [-7.876753868982131, 1.9624604516401638],
            [-7.87728844481648, 1.9625512075199625],
            [-7.870016495912362, 2.0217256421533953],
            [-7.870078177879855, 2.022332819189655],
            [-7.898981733085267, 2.0256984391998705],
            [-7.913580233557641, 2.0281338820357604],
            [-7.913855911702615, 2.0272260511797295],
            [-7.928615439765347, 2.028977860632031],
            [-8.050233901801997, 2.042575035104346],
            [-8.171854438784342, 2.056153356023649],
            [-8.169043186303666, 2.0801380141477144],
            [-8.169175221639666, 2.082843437282675],
            [-8.160768149222655, 2.1679286171733465],
            [-8.152857799969743, 2.167098692113513],
            [-8.147282620591534, 2.2079601545165395],
            [-8.137999417650898, 2.272832037636535],
            [-8.127143486676408, 2.358876635861099],
            [-8.12532595787877, 2.374288539059581],
            [-8.082308147277347, 2.369303202845241],
            [-8.07545553775364, 2.4272568876335554],
            [-8.032608290989929, 2.422102221269554],
            [-8.003163833604802, 2.681623043976147],
            [-7.987083810334168, 2.8252402957941523]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.99125773164056, "lat": 40.4851301840297 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08107"],
        "coty_name": ["Routt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Routt County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00198169"
      },
      "bbox": [
        -8.171854438784342, 1.6795513560275537, -7.501380151026007,
        2.8252402957941523
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.754330006837215, 5.053267767036086],
            [17.7712982559109, 5.031313706561742],
            [17.77999048315131, 5.0209287139490435],
            [17.794884882324276, 5.002052746552063],
            [17.845167253765855, 5.021869523713802],
            [17.869797416496827, 5.031021135449312],
            [17.8741385927128, 5.015412076909203],
            [17.889620888545032, 4.977870206062625],
            [17.891493033305704, 4.978676396904601],
            [17.90837773912372, 4.935627520382163],
            [17.919984064147563, 4.94514823133707],
            [17.926807071914457, 4.948305459631511],
            [17.931429596142895, 4.913677388476788],
            [17.93793046503848, 4.896992923964495],
            [17.94520438314872, 4.876134675753352],
            [17.94934795292939, 4.866610609848163],
            [17.95348610849874, 4.861810158375934],
            [17.96032848640797, 4.85196933744225],
            [17.96993414662212, 4.8405484909821705],
            [17.969510560002437, 4.837268942943553],
            [17.97277148394281, 4.830584922766008],
            [17.982036096083295, 4.81609073200348],
            [17.98254966932542, 4.80653896805658],
            [17.976970323140993, 4.797790202309889],
            [17.97130948770476, 4.79791057515904],
            [17.96477347651069, 4.795868529078265],
            [17.960739221099672, 4.791467696261593],
            [17.951009600376462, 4.787043744553749],
            [17.937597104390836, 4.782461674750433],
            [17.930322629344396, 4.7813202058156],
            [17.92466447328688, 4.784504845543038],
            [17.91567041068865, 4.796195429190498],
            [17.908557482671956, 4.80975325502958],
            [17.905505903540675, 4.809536018928477],
            [17.90439942158135, 4.796673387651659],
            [17.906310461693202, 4.788458776682374],
            [17.913101938158444, 4.783329638915744],
            [17.921861115397977, 4.769211342763626],
            [17.917571489530218, 4.769467143374469],
            [17.910152703381357, 4.765487948802679],
            [17.90510813530475, 4.759459208201089],
            [17.896930143997928, 4.758474556603983],
            [17.89179583348662, 4.7542982016827455],
            [17.879022648812708, 4.7680391818229],
            [17.874281831591087, 4.765420681010779],
            [17.86521861052001, 4.764825225261555],
            [17.8631741449086, 4.760826190833299],
            [17.86016890418136, 4.759087361985174],
            [17.850496578470405, 4.761423018772129],
            [17.84037115000505, 4.759023114149015],
            [17.833991681017768, 4.7528550608424345],
            [17.831117798356708, 4.746461060011175],
            [17.827640835920814, 4.7467157233122395],
            [17.81793971914319, 4.745079223009711],
            [17.80917104878276, 4.737676566273799],
            [17.803661889230504, 4.726703918960529],
            [17.797803460450602, 4.72642155764797],
            [17.793490981752498, 4.733458340579502],
            [17.785578415790543, 4.728455383886992],
            [17.785290023119803, 4.7202201093554],
            [17.77706218012855, 4.723844842936792],
            [17.774757959678094, 4.727430063518554],
            [17.773414488308998, 4.734631645115827],
            [17.774847344822394, 4.73716379780647],
            [17.77125178100135, 4.740112875896194],
            [17.769545564297037, 4.744284199474546],
            [17.765418100300376, 4.741956493036861],
            [17.754855360283813, 4.751514591136714],
            [17.75109119316732, 4.752669217131739],
            [17.74980747946924, 4.756060830523107],
            [17.739217673407527, 4.762088256238534],
            [17.736742898229434, 4.762464478859358],
            [17.734671168983006, 4.767733244462841],
            [17.7320715826436, 4.769357445510839],
            [17.734175587422786, 4.773494254641971],
            [17.732779157984442, 4.777658118961227],
            [17.72846638920809, 4.77637246523378],
            [17.724353735814084, 4.78078702094038],
            [17.721231752493313, 4.7777048358902405],
            [17.7103687136081, 4.779285478306971],
            [17.70864271061694, 4.786140316364239],
            [17.70941883614286, 4.792787584550987],
            [17.70653255749937, 4.799299998267679],
            [17.703908583382464, 4.811541535204511],
            [17.705708779531918, 4.816890381710745],
            [17.70369735488836, 4.822713133119859],
            [17.69818291989398, 4.828858209974259],
            [17.698068891619688, 4.834420422285936],
            [17.692622258731255, 4.838728885046794],
            [17.68893552892668, 4.839813288254437],
            [17.682326533524083, 4.8460690145360195],
            [17.67828889522311, 4.852193379572368],
            [17.67721989059311, 4.856267506658697],
            [17.670152743601115, 4.8559720847330725],
            [17.66244725508252, 4.8596198696752975],
            [17.66581326674425, 4.871025420070382],
            [17.662123287344592, 4.87199793116341],
            [17.660047173902747, 4.875615205403088],
            [17.655486936895954, 4.8775579834019345],
            [17.638459888628585, 4.868826556451238],
            [17.63563128828911, 4.868099094752329],
            [17.592381647932477, 4.846477272596479],
            [17.593787263736164, 4.86234997579918],
            [17.587902007232532, 4.897089243855625],
            [17.58606659126445, 4.909150286532798],
            [17.579806038581463, 4.905259688635641],
            [17.566335526335067, 4.947623940295319],
            [17.550048064281505, 4.996970231409524],
            [17.54618128459954, 5.01008276743212],
            [17.560690852955677, 5.01711255901219],
            [17.560545496115434, 5.0229686611602835],
            [17.57094701600682, 5.02846779698315],
            [17.569432563352514, 5.03027789341858],
            [17.570025465294716, 5.042084979607077],
            [17.565711011490162, 5.046315945644477],
            [17.565690469588716, 5.0513638415569435],
            [17.59173664032772, 5.063432966018791],
            [17.624554555449063, 5.07897960040604],
            [17.62431733520251, 5.071762713789214],
            [17.66128085577775, 5.086932936427873],
            [17.71091964541762, 5.107667077659425],
            [17.711680651035884, 5.106342003836616],
            [17.737461754725828, 5.074159205817546],
            [17.746072548483134, 5.062844272714449],
            [17.754330006837215, 5.053267767036086]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.50719306219936, "lat": 41.44991653266097 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09130"],
        "coty_name": ["Lower Connecticut River Valley"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Lower Connecticut River Valley Planning Region"],
        "coty_fp_code": "130",
        "coty_gnis_code": "02830246"
      },
      "bbox": [
        17.54618128459954, 4.7202201093554, 17.98254966932542, 5.107667077659425
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.098437340463882, -6.733558574982799],
            [10.175421127274056, -6.726381173733338],
            [10.174891415384632, -6.717515178120131],
            [10.184235052647463, -6.71679962067525],
            [10.184986945589817, -6.7254360846631425],
            [10.194258668161805, -6.724522275047697],
            [10.193292609601968, -6.716054179132183],
            [10.202449356756253, -6.715377099445746],
            [10.203282736204608, -6.723935526779816],
            [10.212587007688564, -6.723440480132811],
            [10.213570982284965, -6.725714880399456],
            [10.223014626309096, -6.724669564780818],
            [10.222076304750129, -6.717193431470877],
            [10.22952685905693, -6.716296672895272],
            [10.229134836138, -6.712904226149597],
            [10.240401441664178, -6.711597995293439],
            [10.239204798416457, -6.702331828504835],
            [10.247355379170017, -6.7012891968555195],
            [10.246533971788061, -6.694826819694514],
            [10.255975594037084, -6.693700050482339],
            [10.256808560956408, -6.702122685564869],
            [10.266983931035067, -6.700869574489895],
            [10.26756732921945, -6.70553865040452],
            [10.257385238713255, -6.70681164941876],
            [10.25796427707483, -6.7116659662141505],
            [10.273361468680315, -6.709751473676851],
            [10.278020221330124, -6.709116988569236],
            [10.338699467337003, -6.702433800167603],
            [10.343158623634881, -6.7015918728521235],
            [10.457589499907735, -6.687962308616573],
            [10.457418080268441, -6.683389804896454],
            [10.516481463771976, -6.676304231270708],
            [10.517484546174089, -6.682510875149498],
            [10.51184358826286, -6.693770973617939],
            [10.510919646908212, -6.700333643444007],
            [10.509260313022672, -6.703969377447019],
            [10.50491079103761, -6.700997892175652],
            [10.498592679566379, -6.705231776692929],
            [10.49170351328671, -6.707956564943492],
            [10.488589622438628, -6.711351341486603],
            [10.48903165456889, -6.715155446307371],
            [10.492431993927466, -6.721669406129834],
            [10.491584460022008, -6.7265838869371],
            [10.48747264168639, -6.727381685446303],
            [10.486644939109935, -6.721206446908974],
            [10.477344649641758, -6.72899779377867],
            [10.474430724558495, -6.736545850544699],
            [10.474440113735607, -6.747315460534592],
            [10.477975757606384, -6.756342769056774],
            [10.478804774657094, -6.764029757437497],
            [10.47648821012759, -6.766288606966983],
            [10.472818252002288, -6.763876579847822],
            [10.467979646523604, -6.763598925891912],
            [10.467201990702408, -6.767224824645594],
            [10.462575363963214, -6.766771936913185],
            [10.45579627797672, -6.768973502579276],
            [10.454249304243685, -6.7771436998985495],
            [10.450305153721994, -6.7847329976980655],
            [10.444222504746302, -6.787298143589424],
            [10.440444512350421, -6.787361821251859],
            [10.43388430587435, -6.791644159291056],
            [10.431149871159079, -6.788121870034331],
            [10.422114708921272, -6.787004991573184],
            [10.41925756925996, -6.791006526782276],
            [10.420930706754609, -6.796018628829033],
            [10.416697018191389, -6.799562777369364],
            [10.412441252812684, -6.79967588307234],
            [10.406421489052242, -6.804484536078972],
            [10.397176369037341, -6.806099957087468],
            [10.39377477484203, -6.808389599103822],
            [10.38763338076098, -6.808912666585377],
            [10.385847738043754, -6.811599024812037],
            [10.386728153026622, -6.818727799279587],
            [10.38455374122273, -6.821690636246885],
            [10.380103830334445, -6.822117935069039],
            [10.377670221955325, -6.820308706926653],
            [10.371410459130578, -6.823329054101938],
            [10.36460272243421, -6.830926130532793],
            [10.36806308255279, -6.834870035084981],
            [10.37080255033738, -6.843635968394951],
            [10.370171859744936, -6.84706754384167],
            [10.367048552246436, -6.8502359748144706],
            [10.368013143826396, -6.856815285830477],
            [10.362972762159087, -6.8660989289618914],
            [10.35802509485653, -6.870619169123372],
            [10.35447170107811, -6.877515342496887],
            [10.355493385886836, -6.88311130924489],
            [10.353264125213167, -6.885712552673952],
            [10.350879510647987, -6.897998987264975],
            [10.346589326386422, -6.899921023011398],
            [10.34380489985116, -6.89913367131339],
            [10.338312440459829, -6.905263977834031],
            [10.334089331601282, -6.906885980277373],
            [10.328807729518209, -6.911085669266354],
            [10.32930250154708, -6.914553264843087],
            [10.32470460995412, -6.917190830990873],
            [10.320118423714487, -6.922720080137733],
            [10.321090740364694, -6.928264053992366],
            [10.318649945290163, -6.9322873489050405],
            [10.323976661718238, -6.938454294031461],
            [10.32146457403917, -6.947786752811453],
            [10.318427683239438, -6.949854124113878],
            [10.318019609302244, -6.953541400371411],
            [10.312050213258535, -6.9554783618277956],
            [10.314016217493695, -6.949281720921439],
            [10.310190737419456, -6.948731196060365],
            [10.305033280237993, -6.95394971129419],
            [10.300291745523678, -6.955389446048544],
            [10.296105045250485, -6.961823851532494],
            [10.28869746058085, -6.965391349314818],
            [10.285667439570407, -6.974117724490886],
            [10.280381008532919, -6.980465135787426],
            [10.273446020975056, -6.978365007522466],
            [10.271304480583513, -6.98082843713783],
            [10.273889972571281, -6.983342878018907],
            [10.270333596556856, -6.98748134645464],
            [10.262810680213251, -6.992066985882971],
            [10.263074939691549, -6.995222348444266],
            [10.267046480592013, -6.999725276010613],
            [10.266352424524555, -7.009404817065128],
            [10.26165465030998, -7.00928940106821],
            [10.250905444685642, -7.022853755187817],
            [10.246373929087511, -7.027519127634546],
            [10.250428741677739, -7.029220726975023],
            [10.25272498069947, -7.032135436466312],
            [10.251822287421575, -7.038204521188176],
            [10.248540414683783, -7.041639607516948],
            [10.24890276144167, -7.048313071742095],
            [10.251490038897394, -7.052366029023527],
            [10.25341884246813, -7.060967491167691],
            [10.250748626853008, -7.07206195452942],
            [10.22137019354747, -7.074968218452727],
            [10.212472683979952, -6.984432927200635],
            [10.208359825268195, -6.933479388432052],
            [10.207609616123317, -6.929352220435056],
            [10.20471977976733, -6.899500616051431],
            [10.157199428058885, -6.903358558525019],
            [10.115918534493114, -6.907090074624385],
            [10.109525017223795, -6.854129924295204],
            [10.11096564025465, -6.853883890927923],
            [10.109955718062475, -6.843670783739882],
            [10.110204811926707, -6.834399152071795],
            [10.11907491007188, -6.833302636986834],
            [10.117859567213214, -6.823952364243228],
            [10.108909788319275, -6.824912852990763],
            [10.105589690093568, -6.796652482947308],
            [10.104033205604088, -6.788523102897238],
            [10.098663694132018, -6.737503743245109],
            [10.098437340463882, -6.733558574982799]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.4447245747275, "lat": 31.326109180813813 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13007"],
        "coty_name": ["Baker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baker County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00342832"
      },
      "bbox": [
        10.098437340463882, -7.074968218452727, 10.517484546174089,
        -6.676304231270708
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.47309228015733, -5.360854898324085],
            [9.535577945783935, -5.354009854357391],
            [9.536115971692254, -5.357559119633869],
            [9.543798327405664, -5.356687461617375],
            [9.543348086831752, -5.353202755004371],
            [9.596766569089604, -5.3476628148906045],
            [9.668049708780023, -5.339970605327754],
            [9.74055257045757, -5.3318857850411066],
            [9.740168490355245, -5.328019046508096],
            [9.751844757447977, -5.326708976193689],
            [9.752408248612573, -5.330744315096677],
            [9.785500226474166, -5.327441342787622],
            [9.818572360778294, -5.323615248302615],
            [9.818523559043232, -5.322388225092335],
            [9.832103386989932, -5.320512251522617],
            [9.832773145685275, -5.32698643228597],
            [9.845414173865265, -5.330363562651494],
            [9.87714353361691, -5.339945124204182],
            [9.885688669071653, -5.35431022951799],
            [9.894308333854095, -5.428147555170495],
            [9.895982340552434, -5.444452517577809],
            [9.900258212588147, -5.444000088358831],
            [9.901150038737512, -5.452356525720786],
            [9.905446353973016, -5.451860090234365],
            [9.90633827098746, -5.459414551423136],
            [9.897774096131382, -5.460728519682948],
            [9.899346083790748, -5.475020018813559],
            [9.894143317668904, -5.475498704132441],
            [9.895030590551725, -5.482765775205709],
            [9.892108198953558, -5.483330039531689],
            [9.89386764030244, -5.497763616196006],
            [9.901663265388967, -5.497265095129069],
            [9.903472102210602, -5.515586269785146],
            [9.911641801783832, -5.582237922583954],
            [9.913183978156757, -5.598557671657174],
            [9.87512409427465, -5.603662037431843],
            [9.83598961929762, -5.608362541468182],
            [9.802302826748564, -5.612184701947558],
            [9.768964488630786, -5.616248869180539],
            [9.735795014704333, -5.619971749448495],
            [9.733121954005957, -5.595920523679658],
            [9.668382601292251, -5.603490962733856],
            [9.634499882646734, -5.6070090396009205],
            [9.58920105530699, -5.612090115602007],
            [9.586909689140814, -5.604122506846321],
            [9.58222036626663, -5.600422852394148],
            [9.579862952164456, -5.595696628424617],
            [9.584780222700438, -5.586662945247852],
            [9.583477323269054, -5.584657159371312],
            [9.577295166385836, -5.587318549122259],
            [9.5728465612817, -5.5871930089007344],
            [9.569411226593159, -5.585117165281049],
            [9.564407124673467, -5.577914637551758],
            [9.567955462085813, -5.572167271183586],
            [9.576137662167628, -5.56568642026071],
            [9.576934968220188, -5.563455524133639],
            [9.57135402841043, -5.5520271778457],
            [9.561484371364187, -5.543181976562529],
            [9.55389823206062, -5.5402215223801985],
            [9.549252374031445, -5.532087503723739],
            [9.546017698558078, -5.520431516178516],
            [9.545549655903898, -5.514346330836333],
            [9.54179206021534, -5.509061789055303],
            [9.542543056868805, -5.501714114010898],
            [9.546683947375342, -5.495294500807971],
            [9.547780540921535, -5.491155384030466],
            [9.545819831620685, -5.486046919076785],
            [9.54238877257845, -5.483705169493498],
            [9.530640785148455, -5.481426514963156],
            [9.528208635608582, -5.479301343639264],
            [9.526533975325904, -5.477837939480791],
            [9.52016028117228, -5.466223619486004],
            [9.523504274883905, -5.4573885679752046],
            [9.528843463312224, -5.456280310561701],
            [9.535628090708324, -5.4516827925862135],
            [9.531611595664549, -5.4462593509847],
            [9.528474291285782, -5.446154465036865],
            [9.52405118997276, -5.442369861207782],
            [9.52010557819917, -5.441796571710169],
            [9.517140726483396, -5.435179631021172],
            [9.514010589069182, -5.436248810311663],
            [9.50856917594306, -5.4338568558589815],
            [9.498921762867548, -5.42474248467991],
            [9.493262007248164, -5.417952931462829],
            [9.495338446918176, -5.40796979680255],
            [9.491185478726921, -5.400455615289626],
            [9.493338191206668, -5.39457663865431],
            [9.496320109577304, -5.390750356825319],
            [9.501116677985724, -5.388634459843045],
            [9.500510846574834, -5.380969560149696],
            [9.495021524493387, -5.3740652526537875],
            [9.492797837504838, -5.372772184774989],
            [9.486792335651053, -5.377471480606528],
            [9.478798783458064, -5.3755870793362925],
            [9.473921163702222, -5.370044487343855],
            [9.47309228015733, -5.360854898324085]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.90884840793633,
          "lat": 32.736017517090445
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13145"],
        "coty_name": ["Harris"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harris County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00326700"
      },
      "bbox": [
        9.47309228015733, -5.619971749448495, 9.913183978156757,
        -5.320512251522617
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.115918534493114, -6.907090074624385],
            [10.157199428058885, -6.903358558525019],
            [10.20471977976733, -6.899500616051431],
            [10.207609616123317, -6.929352220435056],
            [10.208359825268195, -6.933479388432052],
            [10.212472683979952, -6.984432927200635],
            [10.22137019354747, -7.074968218452727],
            [10.134839670657861, -7.084847152148459],
            [10.135268801412657, -7.096320795382143],
            [10.063013995744736, -7.103711772653251],
            [9.965083221029975, -7.1133319171293605],
            [9.946685489805331, -7.11533681137765],
            [9.93625138654861, -7.115900902688986],
            [9.900182070743652, -7.119386941544136],
            [9.898380840763283, -7.10269344954796],
            [9.896713891557509, -7.082047766688018],
            [9.895123504635038, -7.067047504380219],
            [9.889561982223448, -7.006690703240206],
            [9.887397513993614, -6.986165069053162],
            [9.88704764777082, -6.97896739850794],
            [9.883014868110996, -6.937499351217976],
            [9.970793407097226, -6.929593585119694],
            [10.02648422739101, -6.924203104620357],
            [10.02586350024788, -6.91829205152854],
            [10.035225541108284, -6.9173947525003605],
            [10.035759536304736, -6.923284974891991],
            [10.063106079778988, -6.920437492473282],
            [10.06242434399438, -6.914698133591354],
            [10.071668852664802, -6.913671044215679],
            [10.07232701213804, -6.919593808606407],
            [10.081651644101882, -6.918755812506474],
            [10.080992347429097, -6.913035845111386],
            [10.089944154807208, -6.912042410917421],
            [10.089633274730678, -6.909742529635787],
            [10.099428527429735, -6.908659764920073],
            [10.099736670826609, -6.9111335570410155],
            [10.11620551942819, -6.909498162051693],
            [10.115918534493114, -6.907090074624385]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.7307934658093, "lat": 31.164011049541458 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13201"],
        "coty_name": ["Miller"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miller County"],
        "coty_fp_code": "201",
        "coty_gnis_code": "00344088"
      },
      "bbox": [
        9.883014868110996, -7.119386941544136, 10.22137019354747,
        -6.899500616051431
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.187177230922321, -6.018858117233052],
            [10.184080498360114, -5.986810615149647],
            [10.310032874845188, -5.973900265891787],
            [10.310582015164647, -5.978306822515222],
            [10.318756643098602, -5.977356144362566],
            [10.31834532190096, -5.970458681297053],
            [10.32604697306015, -5.969606798805345],
            [10.326734342769276, -5.976473252546901],
            [10.335570181164611, -5.97450340301908],
            [10.391212524053328, -5.969157381116387],
            [10.383933404503365, -5.898316941702495],
            [10.423865894353586, -5.895086318631948],
            [10.428659822665702, -5.937392932092037],
            [10.433844162081503, -5.9327143361633645],
            [10.442159729037124, -5.931203781438964],
            [10.447523035158243, -5.929325056399748],
            [10.451035796214041, -5.929589961603588],
            [10.45700965335473, -5.927132366381944],
            [10.469636681455514, -5.92635262513501],
            [10.472280989451544, -5.929144842007858],
            [10.47947989395951, -5.9323743027344165],
            [10.483769044936011, -5.930726613600963],
            [10.494092310099921, -5.931143185831875],
            [10.50015614448284, -5.928768727094826],
            [10.508886346377693, -5.934955197239707],
            [10.508908549158507, -5.937732578517695],
            [10.516231768405513, -5.938500677773935],
            [10.519959138420521, -5.940280400758414],
            [10.518982673294595, -5.957318701640812],
            [10.520606690641692, -5.9609249748327455],
            [10.528705509175888, -5.969522223772457],
            [10.529491119997969, -5.974502404759692],
            [10.535470394323404, -5.978568901986857],
            [10.539438893680106, -5.977432668821817],
            [10.54116889867335, -5.979662825201321],
            [10.538995446602188, -5.985179258113684],
            [10.539559873800453, -5.989819293833056],
            [10.543254721394083, -5.990768814952335],
            [10.547337767779723, -5.993834349766976],
            [10.553799330750538, -6.007263737126294],
            [10.560171245802255, -6.005474643766302],
            [10.56518031560138, -6.012304109423151],
            [10.571001352389377, -6.010902207797532],
            [10.572563519494523, -6.015230250003876],
            [10.572038575779695, -6.020110319171229],
            [10.5699450973133, -6.024024015614936],
            [10.569233891706423, -6.030195775429538],
            [10.566829167926436, -6.035602219145186],
            [10.574928688034388, -6.040883561782835],
            [10.576279681922301, -6.043550499084865],
            [10.575942012216265, -6.061354707448376],
            [10.579336306725526, -6.061998260773288],
            [10.58528399671367, -6.058081753111164],
            [10.587302298474448, -6.0612411547371154],
            [10.586165433802531, -6.066377312997678],
            [10.59238380169149, -6.067428447283185],
            [10.59321503468484, -6.072650814325786],
            [10.596440227912355, -6.081688633099675],
            [10.599622963259321, -6.082484105744197],
            [10.604332534596276, -6.086570072042556],
            [10.604839180091378, -6.099681495696228],
            [10.608317131603233, -6.1054208779420795],
            [10.611461660019556, -6.104934584955768],
            [10.610859040363923, -6.111992810519237],
            [10.613332785903937, -6.1181370960915675],
            [10.615484673939807, -6.119428318270579],
            [10.626537452047044, -6.136518846300981],
            [10.625225767740774, -6.14021922497202],
            [10.628629594414932, -6.143199192448178],
            [10.634208007721055, -6.150917050278436],
            [10.633417066346086, -6.157352831954136],
            [10.634301637288495, -6.161660355447466],
            [10.640675046856925, -6.170238182726286],
            [10.642189938868396, -6.174709085411294],
            [10.641105902404165, -6.181529053463203],
            [10.64107285113403, -6.188383484384155],
            [10.62974388457002, -6.187619524209109],
            [10.611978113770148, -6.189719551619252],
            [10.575137905721116, -6.193480732754791],
            [10.56658708698223, -6.193854489704312],
            [10.504545847736255, -6.201223194392828],
            [10.406044506901083, -6.212463068574109],
            [10.35320920969394, -6.21798358690162],
            [10.335028489512062, -6.2203361830412405],
            [10.291805833154147, -6.225393197153409],
            [10.293426087538569, -6.241659458345271],
            [10.294304991650947, -6.241537626538831],
            [10.296496134647779, -6.2660983955177585],
            [10.296958253273111, -6.267626463901629],
            [10.292476489514206, -6.267269168002936],
            [10.283353735948413, -6.25892245233456],
            [10.27827343596592, -6.257240114159263],
            [10.272056418796565, -6.248339219782565],
            [10.268305276963114, -6.247488847658785],
            [10.262534508952479, -6.242760673349091],
            [10.26072603376041, -6.239206314738528],
            [10.257303281495407, -6.237522434874612],
            [10.257740484451853, -6.234778369299109],
            [10.25379189275838, -6.22929157182161],
            [10.247044869853475, -6.225125178995478],
            [10.24031957955666, -6.222163100789181],
            [10.23967944392932, -6.218975833074228],
            [10.230232113500756, -6.211391957786091],
            [10.227706930455067, -6.212838719182122],
            [10.219043900362605, -6.207406069399111],
            [10.21805819576307, -6.20475672568281],
            [10.208831080331032, -6.199988379207967],
            [10.206120578524963, -6.197609975849856],
            [10.204797903700598, -6.193468777097642],
            [10.200797285375149, -6.192799753417104],
            [10.200348105347798, -6.189547554386062],
            [10.196951110243567, -6.185378435161714],
            [10.190614248238166, -6.118983271984396],
            [10.189695063572202, -6.111173091540774],
            [10.196908095619095, -6.110396895007772],
            [10.194191955669814, -6.085925100263828],
            [10.187177230922321, -6.018858117233052]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.19692866001077, "lat": 32.03996833438463 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13261"],
        "coty_name": ["Sumter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sumter County"],
        "coty_fp_code": "261",
        "coty_gnis_code": "00343504"
      },
      "bbox": [
        10.184080498360114, -6.267626463901629, 10.642189938868396,
        -5.895086318631948
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.996220396969083, -5.591119348316849],
            [12.084401511167078, -5.598212594024424],
            [12.17463558112211, -5.605423799575558],
            [12.178359728633277, -5.617312368863953],
            [12.206339042803446, -5.696003222113564],
            [12.228450865329055, -5.758103834425521],
            [12.24147884040486, -5.795124244322707],
            [12.303575213263146, -5.810749814488661],
            [12.32191793835303, -5.814593935097021],
            [12.428547400604664, -5.801220559502745],
            [12.39257036722895, -5.835166647148556],
            [12.390202976085563, -5.8389851311814684],
            [12.381206236633167, -5.841693164832649],
            [12.368939830300237, -5.856417460226221],
            [12.366627897524662, -5.865911860747972],
            [12.359985593211913, -5.871701760200862],
            [12.358357888537395, -5.881948170598359],
            [12.355147227521252, -5.887954026799549],
            [12.349630869669971, -5.890104030320858],
            [12.345116296893554, -5.893925510333167],
            [12.345348225948376, -5.900265695988892],
            [12.339785412348954, -5.907238951885599],
            [12.337240068578287, -5.916784035839667],
            [12.343376612835298, -5.921847922721547],
            [12.343575489403522, -5.927507278383064],
            [12.345547466872342, -5.930731176972731],
            [12.345521216856651, -5.935535699600752],
            [12.347502424425285, -5.944287106736989],
            [12.345688968064643, -5.950302076778892],
            [12.341107086403776, -5.955414177598618],
            [12.338970281911399, -5.961193852048929],
            [12.342178730364441, -5.968395129223507],
            [12.340897052316192, -5.971447903101537],
            [12.336870561611287, -5.972766864233339],
            [12.334795958139512, -5.976390921307303],
            [12.329140641660496, -5.977079625224113],
            [12.326691100105949, -5.979393208284248],
            [12.322950263997212, -5.99330760277635],
            [12.322880640361486, -5.999359754790439],
            [12.32536476812581, -6.004265043976896],
            [12.323739198235039, -6.0153822613672],
            [12.320172185474014, -6.01751752552455],
            [12.316280367147384, -6.021969363441748],
            [12.315768106935186, -6.025994624819986],
            [12.310308141637151, -6.0290815807388265],
            [12.30693347346347, -6.034161993886987],
            [12.303583254490187, -6.044508491137317],
            [12.30396703090322, -6.056878874477443],
            [12.301559928956168, -6.061853462364107],
            [12.293131432930416, -6.063132844092964],
            [12.28930718981396, -6.067668096814781],
            [12.282484345730067, -6.068871430106784],
            [12.281743379822794, -6.073695748471152],
            [12.283492355468574, -6.082034738014209],
            [12.288894317385346, -6.084727272492971],
            [12.29382223653767, -6.082570901469436],
            [12.291314587639942, -6.088612580797755],
            [12.288546572747338, -6.090133462844617],
            [12.283760035304983, -6.089025183963361],
            [12.270035446646657, -6.082466724272791],
            [12.269603834337966, -6.075563014551334],
            [12.266802924058231, -6.074562642263658],
            [12.260665091653825, -6.076639369765012],
            [12.259593186698368, -6.069090825690334],
            [12.254511214392334, -6.066876389559368],
            [12.25088128372621, -6.056115730178016],
            [12.245186722605833, -6.05507961798367],
            [12.245445235391774, -6.060614679858285],
            [12.240337165644393, -6.064017683383098],
            [12.235736972153632, -6.059913589458971],
            [12.228589611818592, -6.0607896063966376],
            [12.22593518237572, -6.059712838031082],
            [12.221704439517744, -6.055084121563974],
            [12.214631030782614, -6.052212930420369],
            [12.205436164418428, -6.046225484445539],
            [12.19201456519771, -6.043559347271122],
            [12.188587406902261, -6.038876738969453],
            [12.178298152989447, -6.0333498020411405],
            [12.17550044231275, -6.030248638356759],
            [12.167253185564777, -6.025991430703266],
            [12.160497687676573, -6.027940516139654],
            [12.159203836341293, -6.024595546069213],
            [12.164301624113383, -6.0198486145054835],
            [12.162994679499333, -6.012271238341295],
            [12.162955221101525, -6.004501037533554],
            [12.15920942571065, -5.999393982632063],
            [12.159748893266649, -5.992649623338617],
            [12.156244945535711, -5.989842865843846],
            [12.154135033878893, -5.991654378296583],
            [12.156732186865131, -6.002281236743743],
            [12.15241513449393, -6.00543748766943],
            [12.148154706622929, -6.002628021234369],
            [12.14144674688753, -6.002901671996541],
            [12.138296590462504, -5.999173079178136],
            [12.141384814421675, -5.991499134404575],
            [12.139381796889307, -5.986035419182329],
            [12.136938805443831, -5.985685474985965],
            [12.133433024936089, -5.989126349259229],
            [12.132287726754043, -5.99525191495782],
            [12.127511364691356, -5.996454221487105],
            [12.121198969883396, -5.993034066651165],
            [12.112431009114328, -5.993807922016937],
            [12.099235001888545, -5.9981542105904655],
            [12.091560892446159, -5.99997816443951],
            [12.09077545721016, -5.99463956566331],
            [12.082356621712515, -5.9954613024171515],
            [12.077344176762269, -5.992150867727769],
            [12.066812479604485, -5.994286859720759],
            [12.06485760656791, -5.991440434405773],
            [12.061559485820029, -5.99164055833596],
            [12.055777472352656, -5.837220291531352],
            [12.055011164854712, -5.8272433600949665],
            [12.055018579591513, -5.774610133241865],
            [12.055850596867492, -5.766844020884208],
            [12.053400212640735, -5.76290159246461],
            [12.05768595016741, -5.756732457974992],
            [12.057124555539342, -5.752139993457256],
            [12.059970988729221, -5.747929440567308],
            [12.058439376687186, -5.745602591187103],
            [12.060925608157211, -5.741833445496498],
            [12.057067749163691, -5.734600857697798],
            [12.057477610020806, -5.729321799826145],
            [12.055484013221237, -5.72587750259094],
            [12.056861127022254, -5.722655798925899],
            [12.053797192247638, -5.719918178125839],
            [12.052980945942016, -5.715485571493602],
            [12.04588335908428, -5.708281084771029],
            [12.044929380097601, -5.702694788964011],
            [12.038762105680531, -5.69904262215239],
            [12.032533206259446, -5.692157275550874],
            [12.032688630241262, -5.687394875183566],
            [12.02513312051558, -5.677518601979893],
            [12.026810320543756, -5.6698266029074365],
            [12.024212576201583, -5.665495504425212],
            [12.024071005216125, -5.659856973598697],
            [12.02013960490732, -5.658596653047237],
            [12.020687699815776, -5.6549969247079686],
            [12.013291617895462, -5.646223033117087],
            [12.012655869017799, -5.637074083428736],
            [12.006659506014595, -5.63110167550644],
            [12.004329819651995, -5.6246904802253],
            [12.002577380541187, -5.608356696139715],
            [11.994941666449321, -5.595111839325393],
            [11.996220396969083, -5.591119348316849]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.0582181672485, "lat": 32.045891136198435 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13267"],
        "coty_name": ["Tattnall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tattnall County"],
        "coty_fp_code": "267",
        "coty_gnis_code": "00347445"
      },
      "bbox": [
        11.994941666449321, -6.090133462844617, 12.428547400604664,
        -5.591119348316849
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.081568778468622, -3.1461712204341126],
            [10.161782986596053, -3.136258475787936],
            [10.181669024788935, -3.1336205402144235],
            [10.237131009365497, -3.126529007381914],
            [10.237630993508994, -3.1317723763010097],
            [10.235355045811632, -3.13711190059193],
            [10.232416305001687, -3.1406190180857285],
            [10.231581409226566, -3.1444266297184185],
            [10.240288836041012, -3.148441099242225],
            [10.242813186433292, -3.154173855960679],
            [10.248907079172218, -3.1573347996895604],
            [10.252202600290627, -3.164906856711045],
            [10.256053705244891, -3.167737145647359],
            [10.260231603327616, -3.1751465158506],
            [10.259266538910282, -3.18294005950715],
            [10.262200780665623, -3.1847592624364665],
            [10.303380655196476, -3.191962217202359],
            [10.304463173955634, -3.1967409751865272],
            [10.312323529139377, -3.2021418903645764],
            [10.312948428402446, -3.2068137344997516],
            [10.331806532057849, -3.2036402486992706],
            [10.330800791749253, -3.1970346335144275],
            [10.328254011712929, -3.1942726116580955],
            [10.335362067123533, -3.191702120705197],
            [10.340757328588873, -3.1880913822488717],
            [10.347334385117431, -3.192270371691158],
            [10.350981347749732, -3.196618125243122],
            [10.354714129462906, -3.2037719473783803],
            [10.355094020891645, -3.2091869759919347],
            [10.352894254577205, -3.2132986777430523],
            [10.352708588820871, -3.2295017436866225],
            [10.356053295917702, -3.237009732946544],
            [10.355955710135632, -3.2402870654549547],
            [10.3635006697837, -3.2470801557217457],
            [10.364229618797067, -3.2495708134726913],
            [10.372608861345332, -3.2551439945358305],
            [10.370524052880556, -3.26052102776324],
            [10.370574280490608, -3.2710566696882073],
            [10.372208420569917, -3.2743309080193392],
            [10.375992603816208, -3.27425612480682],
            [10.380997027770118, -3.2786425287364267],
            [10.384372717190852, -3.279201733790664],
            [10.388047425625917, -3.3047007676459508],
            [10.364556324539828, -3.314542894604366],
            [10.357830158273103, -3.319062546188567],
            [10.35310541413185, -3.3238164321173693],
            [10.353059369695444, -3.3287053866965612],
            [10.351273510778892, -3.331893582815171],
            [10.350824817725213, -3.3369042210252107],
            [10.354437501975898, -3.349475691479921],
            [10.357596218613901, -3.3548231822565535],
            [10.358271456334817, -3.358802106671863],
            [10.355659032439457, -3.360869398525113],
            [10.355326249601886, -3.372866547055205],
            [10.34954208011717, -3.37452104544016],
            [10.348890672780792, -3.3780623306243096],
            [10.339953648520138, -3.378600639730234],
            [10.335616923578627, -3.3832172749470355],
            [10.330721967304065, -3.3822201441699566],
            [10.329349909634189, -3.3798589615367844],
            [10.324206277719123, -3.3794047882724665],
            [10.318559156967117, -3.384273436525195],
            [10.311335867916647, -3.381658250114263],
            [10.305562079829956, -3.3834124672319037],
            [10.299083155978662, -3.3777460062101468],
            [10.294172305310493, -3.379185163736306],
            [10.29070359235777, -3.3764823133014943],
            [10.283973757183135, -3.37690183764591],
            [10.281103961357555, -3.3746630503185604],
            [10.278295258591559, -3.3777610713956996],
            [10.269279006493743, -3.375359633913874],
            [10.266528317086834, -3.3731031569480066],
            [10.260218950656162, -3.3766807339309772],
            [10.255765383638373, -3.383723280918403],
            [10.248445111462088, -3.388455097444654],
            [10.246180871196888, -3.3933159577350978],
            [10.242405829487103, -3.393998465292937],
            [10.241876362299223, -3.39822577567128],
            [10.238742553865116, -3.4013632191850376],
            [10.234451858023215, -3.4025165878163803],
            [10.231338996567583, -3.4103283321721474],
            [10.233374380344426, -3.418582601682762],
            [10.229310058801158, -3.423460734149507],
            [10.23079494560464, -3.424794306808457],
            [10.23010088709614, -3.430560820502351],
            [10.22810865902515, -3.434667654080507],
            [10.229379263067619, -3.4414500898122466],
            [10.224673190451965, -3.4424715679073143],
            [10.218666404632646, -3.4477763397839865],
            [10.212907015784214, -3.448806615986028],
            [10.211130755032277, -3.4518607436384063],
            [10.20661125716786, -3.4518368486070483],
            [10.204766639252895, -3.455540558081446],
            [10.205632149042842, -3.4597892552564913],
            [10.20373939152277, -3.4621111740049684],
            [10.204972097143974, -3.466136899120317],
            [10.203523080555659, -3.471018884530137],
            [10.198674089708616, -3.471212548184002],
            [10.200393794807338, -3.4817024069384344],
            [10.195420759133873, -3.4820838999017827],
            [10.193161940556568, -3.484172607103306],
            [10.187902900599195, -3.4814644032062065],
            [10.185168706782335, -3.482813501869739],
            [10.178168553789494, -3.4773511224070526],
            [10.171841655091324, -3.4739862983390934],
            [10.170291150690074, -3.470528821094034],
            [10.163216931069115, -3.47159693881028],
            [10.163482838322093, -3.4745680104887535],
            [10.158041209626967, -3.4760640968501506],
            [10.148453334301816, -3.4769478368437463],
            [10.132223878109064, -3.4732666110554438],
            [10.125827185274723, -3.468433264336905],
            [10.122257587272335, -3.4695399921659895],
            [10.115721579286856, -3.4743561155728186],
            [10.11744522081988, -3.4778119601168234],
            [10.116724456071601, -3.4811641365909916],
            [10.110736509218079, -3.488410049718899],
            [10.108498466649186, -3.4883736343198675],
            [10.105701015819328, -3.4842872657766444],
            [10.101045105056858, -3.4879426145289685],
            [10.135071578404013, -3.4029424644965354],
            [10.143537985350001, -3.4019374211796154],
            [10.139496137960737, -3.368389139318916],
            [10.134242280428317, -3.3284020692601923],
            [10.12869089538695, -3.3287802046238677],
            [10.125776133473519, -3.3318249727246942],
            [10.120320635481976, -3.33366261722475],
            [10.117785580269308, -3.3331042008470972],
            [10.109826745211764, -3.3368734475115476],
            [10.095686451170808, -3.3276859076966585],
            [10.093188404435137, -3.31524233284791],
            [10.088453541874, -3.3089652307138633],
            [10.088238508497192, -3.302516910018866],
            [10.085712606115802, -3.297100451420815],
            [10.085049114936954, -3.2905752030430055],
            [10.088621774438675, -3.284768623020967],
            [10.087826617838106, -3.2808217277430236],
            [10.092215510688701, -3.2767461030865563],
            [10.0982292501083, -3.2693117832848433],
            [10.105365657268475, -3.26700839921236],
            [10.108967676002411, -3.261606568937242],
            [10.110677134822389, -3.254417654116373],
            [10.111885865985824, -3.2442795991537823],
            [10.108403228628392, -3.2436929740423217],
            [10.101434498618245, -3.2371231729372667],
            [10.098809001972262, -3.2319250435539497],
            [10.087190513712498, -3.217553029889272],
            [10.083464777909434, -3.2191472268690564],
            [10.074229715609253, -3.2159967251164416],
            [10.072032438561923, -3.2110252672770967],
            [10.069374967640899, -3.209684357033256],
            [10.063879222265316, -3.2098896010854827],
            [10.061206405598082, -3.2058236514109195],
            [10.060748299204187, -3.200902393576412],
            [10.057189048104492, -3.20154507202438],
            [10.053737846534128, -3.1999902891647247],
            [10.052628540848803, -3.196471573024412],
            [10.047026374214893, -3.192108318653776],
            [10.04607131965811, -3.187189115715268],
            [10.048803941237654, -3.1837974770495205],
            [10.050479981958935, -3.1786551800779734],
            [10.053999202694976, -3.1770941747414843],
            [10.055218711153644, -3.1739652958641504],
            [10.059557607403793, -3.1711456410172647],
            [10.065883590447415, -3.164397199185088],
            [10.06757542392825, -3.1595119862293926],
            [10.07140619659812, -3.158575751567179],
            [10.072657588569136, -3.15546165817775],
            [10.078700936860416, -3.150906822170143],
            [10.081568778468622, -3.1461712204341126]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.99076316213602, "lat": 34.83405935918213 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13291"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "291",
        "coty_gnis_code": "00353193"
      },
      "bbox": [
        10.04607131965811, -3.488410049718899, 10.388047425625917,
        -3.126529007381914
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.159449266776893, 5.333097903605044],
            [-11.15898835206153, 5.325939339269485],
            [-11.16077518082255, 5.322580307995066],
            [-11.156822876522211, 5.318032050790575],
            [-11.159550976363903, 5.314044545164119],
            [-11.156223065663054, 5.31029204356623],
            [-11.157476079907825, 5.300950770603214],
            [-11.16298303452746, 5.294119421114514],
            [-11.167227476243694, 5.291266923396645],
            [-11.17517084074061, 5.293023435210216],
            [-11.186137771043095, 5.287978214218661],
            [-11.184837437662146, 5.285189821554677],
            [-11.186805349700638, 5.280781535337287],
            [-11.18583817798716, 5.278197087825723],
            [-11.185270301453928, 5.264411990141025],
            [-11.189820496787258, 5.2633859610425],
            [-11.192793341045988, 5.2660650895827175],
            [-11.199906575974687, 5.268138937802623],
            [-11.205374813474252, 5.264303625449725],
            [-11.209324835368795, 5.265703320175533],
            [-11.215533429629568, 5.262897074995808],
            [-11.218825720504881, 5.264106913464024],
            [-11.22507890584217, 5.248258526270365],
            [-11.228955343122083, 5.243607983464026],
            [-11.233575886084504, 5.24159341118312],
            [-11.233217856934282, 5.2367523307692005],
            [-11.228887380533168, 5.23349195238423],
            [-11.233320855595947, 5.225554484722406],
            [-11.240137872754223, 5.226097836694302],
            [-11.243226918467366, 5.218543636269922],
            [-11.240397427206041, 5.210882573834959],
            [-11.238150895686998, 5.209047698957594],
            [-11.236172947242531, 5.201173444908318],
            [-11.236384545163538, 5.190336419543076],
            [-11.24006758786197, 5.176902380798929],
            [-11.237496017088292, 5.174271158462208],
            [-11.240503315113958, 5.17083496152725],
            [-11.240266894671828, 5.1648305544992255],
            [-11.238447473001237, 5.16089356954286],
            [-11.235670365209458, 5.160024302433999],
            [-11.235223456248418, 5.1531921343968685],
            [-11.23300740587334, 5.151196014774802],
            [-11.234902500159263, 5.144950226789964],
            [-11.234421391922972, 5.140163137919888],
            [-11.2377789310866, 5.138268979614183],
            [-11.240928423216216, 5.131662675268481],
            [-11.249847180572303, 5.133113971480739],
            [-11.253471748687492, 5.121551079438552],
            [-11.256915232359708, 5.119720935746082],
            [-11.257656313495994, 5.114394723422488],
            [-11.255741968606412, 5.106920181125373],
            [-11.255566691061022, 5.1010926298174],
            [-11.259428360541827, 5.086668522705976],
            [-11.258162410467547, 5.082752709478731],
            [-11.258817838850788, 5.074539134174141],
            [-11.255765811124851, 5.069077959566851],
            [-11.252816242832125, 5.059047052133694],
            [-11.249543919853483, 5.058292500364308],
            [-11.246619128036741, 5.045990608344224],
            [-11.249156866472818, 5.036914798084579],
            [-11.244981265646704, 5.019245066809661],
            [-11.237358591776221, 5.015194857510477],
            [-11.230072621297143, 5.015650256875533],
            [-11.224229293926209, 5.020020220113119],
            [-11.21704455175364, 5.021006488571138],
            [-11.213314244476434, 5.027962944178674],
            [-11.206797438434323, 5.031891949619994],
            [-11.143568113565465, 5.021184292390509],
            [-11.147377832780009, 5.018051731501467],
            [-11.146208769203655, 5.013076424494875],
            [-11.147769322555426, 5.0080540805194405],
            [-11.146082913870151, 5.006336761563192],
            [-11.146232749591189, 5.00026977408508],
            [-11.142202019666197, 4.997366622996478],
            [-11.139213169069803, 4.991817629218958],
            [-11.141709172354824, 4.984812853205373],
            [-11.146047246195044, 4.981866372580246],
            [-11.148435382302825, 4.97793791494638],
            [-11.13424296972301, 4.975537606585078],
            [-11.140881487356285, 4.936860017425215],
            [-11.126755029373053, 4.934494010335551],
            [-11.127367854258651, 4.931011353431876],
            [-11.123781781013905, 4.930385719326773],
            [-11.126199268807735, 4.915762685076883],
            [-11.122652085946974, 4.91520478731745],
            [-11.127408160995907, 4.88725714941482],
            [-11.127108784577228, 4.886568151509672],
            [-11.137795299271868, 4.823197978643025],
            [-11.123687919379165, 4.820668519722342],
            [-11.127276704452369, 4.799631861340184],
            [-11.12614417207501, 4.799405733142314],
            [-11.128357817393608, 4.785545047763598],
            [-11.121401948608195, 4.784365069085684],
            [-11.128564901866348, 4.741246809992676],
            [-11.121531637561702, 4.740132810884246],
            [-11.126524728187954, 4.711327148094468],
            [-11.140755337795222, 4.71375552439118],
            [-11.155175276776001, 4.62748834883032],
            [-11.158862150335782, 4.61330262793407],
            [-11.168573559478231, 4.555711317380983],
            [-11.231736404732139, 4.566585075069656],
            [-11.226789477683894, 4.5953319892138325],
            [-11.26912989618243, 4.602319272323866],
            [-11.32639161286325, 4.612095576680435],
            [-11.329958889763494, 4.612543787509166],
            [-11.331927035877806, 4.6193966704392695],
            [-11.336579114331073, 4.624384926501239],
            [-11.339068572714753, 4.62284039086479],
            [-11.34461632263309, 4.6230802364263495],
            [-11.349982102351603, 4.625377541723925],
            [-11.349453640144404, 4.627810003167727],
            [-11.352783959506972, 4.630898639667706],
            [-11.351176196958853, 4.639838250824916],
            [-11.353103498806197, 4.64575734308896],
            [-11.354826778942783, 4.646444303818657],
            [-11.35994479905069, 4.658931792699223],
            [-11.361050259046463, 4.666417526121714],
            [-11.364300203575135, 4.671524063202085],
            [-11.365449425450445, 4.685410375251784],
            [-11.41511930613036, 4.693824105248238],
            [-11.416572134846561, 4.685322398605345],
            [-11.42107665972267, 4.678411012874138],
            [-11.428993723874314, 4.671251680840119],
            [-11.435895311836013, 4.662629618256795],
            [-11.444064527802563, 4.664300276921859],
            [-11.452398091132828, 4.675587406687001],
            [-11.45418952105677, 4.6760871912397555],
            [-11.460939442184095, 4.673286028225787],
            [-11.46727014772461, 4.675685734978212],
            [-11.468979618225795, 4.6815076542517575],
            [-11.467339303355537, 4.689264375424142],
            [-11.468036526052435, 4.695541392875704],
            [-11.466063467103801, 4.699036944556262],
            [-11.456954578881772, 4.707641411471562],
            [-11.452010972143148, 4.714260671271268],
            [-11.448484641899835, 4.715981091377182],
            [-11.4486935691905, 4.719872911282923],
            [-11.439428942404255, 4.730912091440964],
            [-11.433950061518468, 4.733723258262528],
            [-11.432687279595614, 4.741934888624446],
            [-11.429921106187447, 4.743773688550121],
            [-11.42951418382891, 4.75300412610092],
            [-11.430249186093485, 4.755021376175351],
            [-11.427738408404199, 4.762562126630718],
            [-11.427681310029124, 4.768927828223083],
            [-11.424794497265914, 4.773262026683066],
            [-11.426354726186029, 4.783677956405177],
            [-11.42416063435386, 4.792618320381169],
            [-11.424866018553269, 4.8005136078874315],
            [-11.429879635571691, 4.804023424610384],
            [-11.43457662775566, 4.803671052471703],
            [-11.435688879488875, 4.801271592086215],
            [-11.458934310921572, 4.800082750366893],
            [-11.461567108175082, 4.805370726683993],
            [-11.459209386835925, 4.811383848951179],
            [-11.457819026643122, 4.819513619396499],
            [-11.471875872853367, 4.822006158420234],
            [-11.470664929831008, 4.829076596000086],
            [-11.474241854836574, 4.829726072054884],
            [-11.473007889185052, 4.836802538667486],
            [-11.480024293290757, 4.838151501370321],
            [-11.478824308126931, 4.845216388140485],
            [-11.481890573936836, 4.84575339021993],
            [-11.47939581637736, 4.860008751546328],
            [-11.504893211201432, 4.864419880730611],
            [-11.495520345634992, 4.918021651146116],
            [-11.492444168717789, 4.917457387893459],
            [-11.490544960531814, 4.928235900064322],
            [-11.472861908766125, 4.925156614206029],
            [-11.47222172198181, 4.928690824598809],
            [-11.468742809654778, 4.928105488630052],
            [-11.465865133546709, 4.944267990105731],
            [-11.468295279988451, 4.944708967869876],
            [-11.466609127719511, 4.955755481272125],
            [-11.461997016748164, 4.980462933766788],
            [-11.454954956288871, 4.979355371508979],
            [-11.451197017327809, 5.000862797286759],
            [-11.478838549294748, 5.0056219413393235],
            [-11.47383111234044, 5.034147337770114],
            [-11.487867156137813, 5.036538534499776],
            [-11.48441286799893, 5.058019842605912],
            [-11.498508233575043, 5.060452792145561],
            [-11.492400978375775, 5.0962201484284115],
            [-11.520553304768915, 5.101179621984623],
            [-11.51075408792682, 5.158177533550009],
            [-11.524757207246887, 5.160723031257314],
            [-11.514941317228828, 5.21719355416649],
            [-11.513898113986553, 5.217032539899311],
            [-11.503159726903505, 5.278122326658774],
            [-11.505085928241064, 5.2780462249881115],
            [-11.507008603443284, 5.283415491791188],
            [-11.504972785401932, 5.286625359363612],
            [-11.508216989404275, 5.2887747543834385],
            [-11.510989145997852, 5.293309443078144],
            [-11.511584317434362, 5.299827276983328],
            [-11.51693962670786, 5.303127438985271],
            [-11.521017512158291, 5.307865737140512],
            [-11.517942262660751, 5.314631481635114],
            [-11.520041405770883, 5.326452323692661],
            [-11.524324731844182, 5.331705652026023],
            [-11.531104330075745, 5.332954963008143],
            [-11.532303304237102, 5.338069766136703],
            [-11.538879492557184, 5.340828659016378],
            [-11.537991667652742, 5.347743999270771],
            [-11.542465551691222, 5.346644192779956],
            [-11.547481331530689, 5.350286159520678],
            [-11.551232875983379, 5.348398189476137],
            [-11.550028866220643, 5.345506628846666],
            [-11.55632961811376, 5.338326004449706],
            [-11.567721706121269, 5.34123361763563],
            [-11.572999203892513, 5.3345857818783395],
            [-11.57769248097615, 5.333843741490528],
            [-11.589626288128597, 5.325819192564718],
            [-11.594248834194381, 5.327406541903832],
            [-11.598607731276356, 5.326127834030649],
            [-11.601022201125897, 5.3273284436927915],
            [-11.60727453757687, 5.326258051551842],
            [-11.610554632516692, 5.327629031986012],
            [-11.61546951965643, 5.327067744149282],
            [-11.61889418970001, 5.330498610214068],
            [-11.624587733971495, 5.328484940894469],
            [-11.629167110032462, 5.3285263669712135],
            [-11.634213553155524, 5.323495388522912],
            [-11.634194799702735, 5.317406110187248],
            [-11.638197068965706, 5.314142195975759],
            [-11.640989215340277, 5.314918792250797],
            [-11.64392254052063, 5.3113154842272206],
            [-11.654064641412266, 5.310626858951877],
            [-11.659040909775591, 5.307852603650239],
            [-11.659172327019366, 5.3021737093912655],
            [-11.663150740864156, 5.301634514340015],
            [-11.664203556831628, 5.304961084527158],
            [-11.662967983883554, 5.309308175878071],
            [-11.66496054216403, 5.311671188315686],
            [-11.669250555371887, 5.3106740060035325],
            [-11.66859004970007, 5.316224511292452],
            [-11.665641364398779, 5.318614864266427],
            [-11.663720296603032, 5.325289438757363],
            [-11.659215597936097, 5.321133677693917],
            [-11.656016775787378, 5.32450927211577],
            [-11.66017999838945, 5.327438695865476],
            [-11.653591361664173, 5.333320799217805],
            [-11.656012690059526, 5.339663880912457],
            [-11.663662329820735, 5.34398941889621],
            [-11.664386954171343, 5.348762762493064],
            [-11.664520379444427, 5.355368668273891],
            [-11.662657902383804, 5.360511982162253],
            [-11.65718484792237, 5.366132812330352],
            [-11.649884501016453, 5.368267378567151],
            [-11.64949793744111, 5.37385408210866],
            [-11.652731372764348, 5.376492365278187],
            [-11.653029889399292, 5.380356697766374],
            [-11.651362529184636, 5.384417664084658],
            [-11.647385924218923, 5.386452604571614],
            [-11.639849091891397, 5.386219131041607],
            [-11.63284637743988, 5.38305686684502],
            [-11.625111281602754, 5.383041121406095],
            [-11.622265061020356, 5.388470017336874],
            [-11.619170838850222, 5.385892510188271],
            [-11.614800771749868, 5.389012564763851],
            [-11.613027059984493, 5.392001689274309],
            [-11.614500765564708, 5.397469925156005],
            [-11.612079333987001, 5.398570285068156],
            [-11.608453613147924, 5.395918735444785],
            [-11.603452075186095, 5.399746120565956],
            [-11.603621944990634, 5.406350154547683],
            [-11.59869355670191, 5.408813895836274],
            [-11.593054619727786, 5.404950885255209],
            [-11.591659927268246, 5.401078393217759],
            [-11.584673654072711, 5.406271846925983],
            [-11.469868515496774, 5.386207203442371],
            [-11.390647880681966, 5.3724605445445395],
            [-11.24296095209378, 5.3465766172051685],
            [-11.242827157190748, 5.347343037536233],
            [-11.159449266776893, 5.333097903605044]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.22460912458921,
          "lat": 42.66855285430434
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16005"],
        "coty_name": ["Bannock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bannock County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00395091"
      },
      "bbox": [
        -11.669250555371887, 4.555711317380983, -11.121401948608195,
        5.408813895836274
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.607658336219677, 10.874772233938943],
            [-13.58999015307666, 10.950134544048002],
            [-13.578292986043271, 10.996476780902686],
            [-13.576146425014482, 11.006028910587178],
            [-13.570276376188222, 11.02858507399421],
            [-13.558274382943969, 11.077651913643145],
            [-13.532598221191245, 11.18260862860391],
            [-13.50471709452705, 11.304881233975491],
            [-13.477862240846825, 11.419128204281826],
            [-13.469477155857456, 11.45318622005038],
            [-13.44906761116855, 11.541078523095774],
            [-13.427459547762068, 11.632338398597694],
            [-13.34705444417811, 11.61510487802556],
            [-13.26665421918461, 11.597847734790065],
            [-13.301394955550787, 11.445790253946765],
            [-13.304750485002934, 11.434258898414429],
            [-13.30358663009524, 11.434007349647276],
            [-13.331948067505163, 11.307288385038468],
            [-13.34090008256666, 11.269511060234095],
            [-13.288016647289604, 11.25788638860232],
            [-13.271725218517167, 11.254106316530876],
            [-13.204998744630414, 11.240495070215374],
            [-13.120876990530506, 11.222739304826884],
            [-13.072521198876878, 11.212346519182097],
            [-12.972093853730549, 11.191807033556033],
            [-12.859326784841429, 11.168011024129141],
            [-12.881699615835496, 11.065065430412227],
            [-12.89684805139206, 10.995515273545301],
            [-12.91851754627406, 10.896238778004571],
            [-12.937387538620252, 10.80942803395174],
            [-12.951210694365278, 10.746657050339637],
            [-12.96816044944941, 10.668860660079464],
            [-12.973685572226822, 10.680981571868422],
            [-12.972970523368401, 10.688027127442849],
            [-12.9806743821331, 10.6916909230288],
            [-12.98819476649871, 10.698016052642455],
            [-12.99546635849927, 10.710576425529167],
            [-12.994934198132867, 10.720124003712396],
            [-13.00335866172156, 10.732204263044919],
            [-13.009667347426706, 10.729502725450029],
            [-13.011752556649684, 10.727287416521769],
            [-13.023518376760762, 10.726887158278702],
            [-13.02881331398239, 10.724176915705108],
            [-13.033328834497443, 10.726708987538583],
            [-13.038258968306799, 10.732502535037058],
            [-13.038975457719635, 10.735882328612718],
            [-13.044560000674315, 10.73982862280823],
            [-13.049800935147264, 10.748893946564172],
            [-13.058967706965438, 10.752825559472665],
            [-13.057975012538483, 10.756684078011281],
            [-13.060389694352779, 10.762603549650361],
            [-13.064155747918175, 10.76673698870028],
            [-13.067182366617518, 10.772204475984719],
            [-13.07039289314668, 10.781715899860918],
            [-13.076247778805364, 10.782847811546722],
            [-13.080441637056923, 10.780509243880614],
            [-13.09071307760993, 10.779329406044937],
            [-13.098228564102435, 10.780634074886827],
            [-13.102756361843362, 10.778170332439533],
            [-13.104747717206408, 10.779548962400973],
            [-13.11135048837034, 10.771400881776387],
            [-13.113563492089202, 10.767402930283287],
            [-13.118764930168792, 10.765061186975718],
            [-13.121632783287078, 10.765312428778545],
            [-13.144719587031014, 10.746537893928444],
            [-13.1714875310929, 10.625248502759504],
            [-13.280557915016818, 10.648473497834342],
            [-13.287470087713835, 10.649869022303541],
            [-13.274863935048304, 10.706422451220886],
            [-13.265459682634505, 10.746155949087496],
            [-13.350250951404165, 10.764580087079539],
            [-13.354053075970782, 10.751012941569028],
            [-13.441871597165584, 10.770485871979778],
            [-13.496534249511418, 10.78234541823578],
            [-13.559693365953342, 10.796295217188472],
            [-13.622855534944884, 10.810231083883147],
            [-13.607658336219677, 10.874772233938943]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.60107628682432,
          "lat": 48.30004181340819
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16017"],
        "coty_name": ["Bonner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bonner County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00395158"
      },
      "bbox": [
        -13.622855534944884, 10.625248502759504, -12.859326784841429,
        11.632338398597694
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.588524301874601, -1.204536746292461],
            [5.648379384273302, -1.2002085217270424],
            [5.687078530472302, -1.1978455487240052],
            [5.714435791083861, -1.195147595403842],
            [5.729172594880831, -1.19490432513484],
            [5.758304543737502, -1.1916692910720226],
            [5.775381127009528, -1.1907216020079128],
            [5.77863685692533, -1.19387340207833],
            [5.784092936212134, -1.1940212581696932],
            [5.79597915979345, -1.1925438365118668],
            [5.796495101855545, -1.195124346132485],
            [5.804528917896124, -1.2009954014947932],
            [5.809368590726816, -1.2023697376836855],
            [5.812948489023633, -1.2169269461918462],
            [5.814699948963746, -1.2343931997356319],
            [5.809232327636619, -1.2439411551879367],
            [5.8010978173662275, -1.245755391248677],
            [5.796212150784838, -1.2518488372478689],
            [5.788216370287955, -1.2551576608569195],
            [5.78256739465991, -1.2624278379570295],
            [5.780850947757373, -1.2668542841362014],
            [5.781530594084214, -1.27530421565932],
            [5.780556894567023, -1.2834446188718098],
            [5.775796066808523, -1.2985396456238554],
            [5.770995071693501, -1.3011758407144647],
            [5.770288963480652, -1.3039685531934289],
            [5.773640076201414, -1.307483292282318],
            [5.773175782818752, -1.3142259961361098],
            [5.775618445331326, -1.3214292011779163],
            [5.774111439681158, -1.3236138823667623],
            [5.775890920791847, -1.327545729566682],
            [5.779639119213997, -1.330421790883385],
            [5.783091781098557, -1.3363213564906653],
            [5.776664126085516, -1.3446849164788188],
            [5.773478113105147, -1.3435954689270229],
            [5.771720656933306, -1.3476204186551113],
            [5.775077860956444, -1.3524776207645213],
            [5.77309393860695, -1.3573940170467607],
            [5.776788534136261, -1.358006175267107],
            [5.776396656208004, -1.36430735111442],
            [5.773437449339263, -1.3647076003094203],
            [5.772784108431245, -1.369448555865144],
            [5.779414016816217, -1.368711848027894],
            [5.779508641569324, -1.376413451778244],
            [5.78157092691857, -1.381268213683726],
            [5.781017506010172, -1.384193701221018],
            [5.775445030023128, -1.3879389200080403],
            [5.774111470944218, -1.395267085667428],
            [5.770569585114224, -1.4019006446001632],
            [5.777803515501045, -1.4111024811219164],
            [5.777994733232298, -1.4177769380526057],
            [5.781825846023841, -1.4207928627624944],
            [5.788027527036417, -1.4285663545858858],
            [5.795790648976087, -1.4267988127753783],
            [5.798152645797744, -1.430507485880026],
            [5.806242669234514, -1.43689331496508],
            [5.808877753504911, -1.4348524418155069],
            [5.8204944723461995, -1.4361296553290293],
            [5.827297546091824, -1.4391959980432474],
            [5.83177799010015, -1.4360536821700276],
            [5.83373235993953, -1.4390518094807458],
            [5.837364061229072, -1.44012218981568],
            [5.844130277435649, -1.445138825671306],
            [5.848790668563763, -1.4548895878349046],
            [5.8535185297476255, -1.453518464576845],
            [5.854969942698095, -1.4553621773189436],
            [5.8523826767862195, -1.46173658642868],
            [5.849074610598915, -1.4779272461116455],
            [5.84882923686423, -1.4870829755563957],
            [5.850893295359793, -1.4974915127580577],
            [5.8527994742081795, -1.5033402850629347],
            [5.857732450693083, -1.512618451503811],
            [5.863956318959887, -1.520339084713577],
            [5.868754628450411, -1.5233187583794578],
            [5.887381844433829, -1.5371152695524906],
            [5.892131116056546, -1.5396953503345954],
            [5.88591925888902, -1.5429618389837074],
            [5.878892860794708, -1.5452705637182595],
            [5.869867099533533, -1.5508475403798365],
            [5.86354227101607, -1.553802416434249],
            [5.85779590695727, -1.553621700858974],
            [5.851089487128345, -1.5514390999942558],
            [5.845407880562191, -1.5452926278622212],
            [5.842380288850251, -1.535620246054748],
            [5.841645430522234, -1.5252672941626138],
            [5.838073832033339, -1.5137120131816344],
            [5.835935097294117, -1.5093712357189113],
            [5.8323066906566305, -1.5057017229258367],
            [5.815388538409275, -1.4957494514742726],
            [5.808183904649902, -1.4899893988651733],
            [5.804471701982929, -1.4846114302493671],
            [5.797570227175938, -1.4699947011794612],
            [5.7892337600721735, -1.4561866967648582],
            [5.78585623667526, -1.4644643983822627],
            [5.782217921198883, -1.463970812810274],
            [5.769661811995216, -1.4644458959024764],
            [5.766944742367936, -1.4631081957673493],
            [5.7587418163667765, -1.4630719388673425],
            [5.74778611038563, -1.4615087065901902],
            [5.746182799042057, -1.473518487411051],
            [5.749411006132003, -1.4808446179241694],
            [5.754552216661341, -1.4859966970728098],
            [5.762907478640125, -1.4900349444433252],
            [5.773833994594029, -1.4935806178415294],
            [5.783379937290967, -1.5004496667159664],
            [5.788721167118897, -1.5055297452248906],
            [5.79116783751959, -1.5132406601612551],
            [5.78760331044751, -1.529123319272157],
            [5.785729119297728, -1.5330488093216774],
            [5.779866216044333, -1.5393403975428392],
            [5.776500754918951, -1.5414254306648685],
            [5.765595580830256, -1.538636156086275],
            [5.7476805291875825, -1.5223194690447868],
            [5.744378664976266, -1.51931095917709],
            [5.732830000211036, -1.5128692956715803],
            [5.720735839153366, -1.5080669494580454],
            [5.707472756267319, -1.5043057307671523],
            [5.694283655487953, -1.4956662194601265],
            [5.688626129281583, -1.4873125206224425],
            [5.687561067735099, -1.4777774752465447],
            [5.691629675333578, -1.4645919422105813],
            [5.6934305076388325, -1.4543417893145667],
            [5.693125061277056, -1.4488677468069204],
            [5.690077803970341, -1.4403278244750966],
            [5.685161472960815, -1.431886700062784],
            [5.677315136142204, -1.4244091740830214],
            [5.665698321062632, -1.4170107302168802],
            [5.659766468435679, -1.4116114423122563],
            [5.650095207601169, -1.3989406225928118],
            [5.6415512640257255, -1.3855127665941127],
            [5.638490743923005, -1.3764183645219215],
            [5.622587774726631, -1.3503650429723195],
            [5.617265410351555, -1.3391996274520097],
            [5.611429720964856, -1.320696712131331],
            [5.611280089028189, -1.317019749705389],
            [5.617230178195883, -1.2978658593288805],
            [5.616809078338237, -1.2911172200527294],
            [5.614641625001827, -1.2877138086584439],
            [5.606715839196229, -1.2854463792060125],
            [5.599910841953245, -1.2862228134660125],
            [5.592528314401328, -1.2882924787241121],
            [5.581008762346184, -1.2767061374998696],
            [5.5709613347529725, -1.2638079286168056],
            [5.566901198529218, -1.2556533419688096],
            [5.566960328812254, -1.2490286034673617],
            [5.568265201128503, -1.2455780132154917],
            [5.570264730694435, -1.2297945696705734],
            [5.572813798611548, -1.2247257385982238],
            [5.58240916686196, -1.2148270726142807],
            [5.585071445755925, -1.2080003209565602],
            [5.588524301874601, -1.204536746292461]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.33744555909507, "lat": 37.19154386335888 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17003"],
        "coty_name": ["Alexander"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alexander County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00424203"
      },
      "bbox": [
        5.566901198529218, -1.553802416434249, 5.892131116056546,
        -1.1907216020079128
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.356118354420993, 0.4643312890364155],
            [5.396932417347454, 0.4674091007650794],
            [5.394773203012773, 0.49648013217589554],
            [5.444785248267735, 0.49971126919527487],
            [5.477917551651214, 0.5016063261711075],
            [5.538752884146105, 0.5058684157451785],
            [5.567182089805485, 0.5077240942081587],
            [5.615327879954573, 0.5116080763409873],
            [5.65271482627702, 0.5142245152995298],
            [5.654795072182982, 0.48502597485225374],
            [5.649379826485311, 0.4846197136892477],
            [5.6533991224895095, 0.4314079491137395],
            [5.656564129182778, 0.39152569150200156],
            [5.663083085583318, 0.3140906571744731],
            [5.6702305738947745, 0.2258081348895507],
            [5.65632644241326, 0.22480070353632592],
            [5.5794553321318405, 0.2185587614040759],
            [5.494754724459486, 0.21201669421279443],
            [5.4428673045325695, 0.20986076787971963],
            [5.405723341068689, 0.20871561627100008],
            [5.398403026536007, 0.29656223087903444],
            [5.395051657936326, 0.34086407422280907],
            [5.3663879006778785, 0.33868155055298993],
            [5.362598133961109, 0.38302725912281677],
            [5.35740028756276, 0.45024777295944846],
            [5.356118354420993, 0.4643312890364155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.43556145918643, "lat": 38.8868485958443 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17005"],
        "coty_name": ["Bond"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bond County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00424204"
      },
      "bbox": [
        5.356118354420993, 0.20871561627100008, 5.6702305738947745,
        0.5142245152995298
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.977418787719767, -0.48316780833435846],
            [4.980125807567431, -0.4815319416542357],
            [5.022464480871318, -0.46213028722054705],
            [5.040373662982902, -0.45509800276763257],
            [5.050164424596066, -0.4498968556711967],
            [5.072052005319632, -0.4405617668315582],
            [5.092023622502952, -0.4315422520909058],
            [5.106057722307152, -0.42558170578718857],
            [5.100266212753732, -0.3373676897581792],
            [5.154738977918973, -0.3355531205020598],
            [5.207006873363354, -0.3331044506011291],
            [5.271786684278537, -0.3297862707627176],
            [5.359094991214178, -0.3245383071702974],
            [5.444850529608137, -0.3189332193825735],
            [5.4510953639764645, -0.40677759100678174],
            [5.45463511946238, -0.4662601724266772],
            [5.459434098264907, -0.5519492205724983],
            [5.461030858019655, -0.5849595853958774],
            [5.441281855979064, -0.6336272877232837],
            [5.419833884559584, -0.6855543981477488],
            [5.418706410201521, -0.6888155452153314],
            [5.4196648843499835, -0.6929907858196949],
            [5.418093524948636, -0.706173885690603],
            [5.415329422665482, -0.7119669534397565],
            [5.409673457752754, -0.719930170745899],
            [5.4032186305140115, -0.7230976499600257],
            [5.409448395969543, -0.7425890379278478],
            [5.402542924201613, -0.7382079564932871],
            [5.386331101701604, -0.7301542734631411],
            [5.374312134916952, -0.7219321843688281],
            [5.364365463147425, -0.713121113735408],
            [5.3554251227746175, -0.7017207158403832],
            [5.344358932209492, -0.7030285986685899],
            [5.335324620196923, -0.6981338639279783],
            [5.328214399256043, -0.6982555163333493],
            [5.321987926169082, -0.695659283951098],
            [5.318828027845187, -0.6992642300560572],
            [5.310733690693037, -0.6919301542568952],
            [5.306799706138197, -0.6829586031047302],
            [5.308524609669758, -0.6772024969120787],
            [5.307882393049528, -0.6717265119523758],
            [5.2951812343237785, -0.6644044774559316],
            [5.276628113081693, -0.6513518721156978],
            [5.269728944994267, -0.6479847712246555],
            [5.26495034056135, -0.6499054145133115],
            [5.256131703703946, -0.6576341520939777],
            [5.246376147777582, -0.6720376920657836],
            [5.2428097133731475, -0.6760145774028565],
            [5.227563611434057, -0.6868804196099805],
            [5.218615630086191, -0.6876378849664174],
            [5.210850809475399, -0.6870922003665462],
            [5.198858808188511, -0.6833677521155123],
            [5.187176581592704, -0.6759099491326196],
            [5.167930035301129, -0.6407101287051086],
            [5.166906706986636, -0.633184580527658],
            [5.1717117310457095, -0.6280865186835987],
            [5.176274066260099, -0.6248551457327722],
            [5.177947618438797, -0.6188467845431908],
            [5.187460526329532, -0.618099157643813],
            [5.194489310719347, -0.6117243662571793],
            [5.198660416300401, -0.6101384325393164],
            [5.203748539771812, -0.6031014971985165],
            [5.2036054497864725, -0.5971499161949196],
            [5.195238612853706, -0.5981372150648591],
            [5.190687744829551, -0.5868282131279676],
            [5.172832800022228, -0.5945061922524769],
            [5.153951238854548, -0.5985020249226293],
            [5.147285407958272, -0.5974911713784803],
            [5.140569950037069, -0.5930771979498666],
            [5.126799490975004, -0.5763477574385613],
            [5.118320336118737, -0.5671399735569618],
            [5.115096438620853, -0.5646391587138265],
            [5.101461901310474, -0.5569432236975347],
            [5.098785970857651, -0.5512416323976388],
            [5.095469677693872, -0.5478170371047688],
            [5.0853207756032, -0.5469763592206045],
            [5.078664093569373, -0.5489832152928308],
            [5.072957445921352, -0.5489907945107831],
            [5.068534622560188, -0.5471809236635348],
            [5.054950397374585, -0.539208727394614],
            [5.049253598383629, -0.5343404713174197],
            [5.041864305972568, -0.5256986600416379],
            [5.040821771537746, -0.5114018656936519],
            [5.03693969229097, -0.5041107717421147],
            [5.025812358829804, -0.49803770878064996],
            [5.015103388954788, -0.4928549480676732],
            [5.0108083441365805, -0.4935754282627527],
            [5.0042457103263285, -0.49874469981503183],
            [5.000307973736835, -0.49745262472298124],
            [4.977418787719767, -0.48316780833435846]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.82516764284259, "lat": 38.0521238536487 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17157"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01784967"
      },
      "bbox": [
        4.977418787719767, -0.7425890379278478, 5.461030858019655,
        -0.3189332193825735
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.685669201688206, 0.13099754899549557],
            [6.718382998261278, 0.1336530168481831],
            [6.762341416978624, 0.13732070049655076],
            [6.7948915352696435, 0.13940863117998656],
            [6.828748270065125, 0.14196808438460615],
            [6.850414235689966, 0.14337890762052838],
            [6.917563338750744, 0.1488448448213261],
            [6.919700628900264, 0.14913946821216031],
            [6.9190910286700955, 0.14532811499518383],
            [6.92139350358459, 0.1371995122025407],
            [6.910585861760541, 0.12986846877174288],
            [6.907425282136274, 0.1248173548858526],
            [6.908381575688427, 0.12135865033504441],
            [6.91559961243766, 0.11226513023095908],
            [6.9172396196001396, 0.10690112037427883],
            [6.920999002576532, 0.10124012712249464],
            [6.928495517981225, 0.09611224463108016],
            [6.929612668300242, 0.09121220052604982],
            [6.926440294209615, 0.08530369413701096],
            [6.921559517780118, 0.08198598555721376],
            [6.9160823456040985, 0.08269419977005293],
            [6.908985876821811, 0.08659652180904778],
            [6.905151150471136, 0.0771794030613625],
            [6.899906065312561, 0.07003412883970572],
            [6.879240017236666, 0.05609858903801436],
            [6.863313901972936, 0.05490904937506381],
            [6.855838615712757, 0.05140746006335496],
            [6.848730017750655, 0.037301918997407923],
            [6.848992237922022, 0.02913081700273784],
            [6.85310563974266, 0.02778679086743673],
            [6.860996237521315, 0.028999862458834597],
            [6.867947898591271, 0.025616228935910305],
            [6.869623725958256, 0.017783174688999943],
            [6.863049031477207, 0.01221186081911072],
            [6.861616035188033, 0.0013001561212800223],
            [6.86208602139326, -0.011781991534149518],
            [6.8613473925320205, -0.01731188493472585],
            [6.84490406018951, -0.047427491466180395],
            [6.835604818736849, -0.060227912776780974],
            [6.818313948293569, -0.06752103285253704],
            [6.81315712738568, -0.07744430356566527],
            [6.806392912704745, -0.08595804742608194],
            [6.804122103492002, -0.09825761633765423],
            [6.801407094906297, -0.10564010739715884],
            [6.801202608470468, -0.11612051903308403],
            [6.804136117744577, -0.127059345318907],
            [6.8045967826135, -0.1333472170551171],
            [6.8030469314538555, -0.1423502600228217],
            [6.799857806290789, -0.15102407483535407],
            [6.796754738457678, -0.15550235346099908],
            [6.791070274850372, -0.15908445654597297],
            [6.784332757165355, -0.15805071507627427],
            [6.78141514241964, -0.1547933750173693],
            [6.7780777279731295, -0.14513918263003867],
            [6.778722840295411, -0.13960173582942081],
            [6.781431107496177, -0.13154089265573626],
            [6.780507617904515, -0.1268434619402275],
            [6.777819650823653, -0.12415827530536168],
            [6.772837656140847, -0.12304811581812673],
            [6.769065745163041, -0.1256913437536394],
            [6.766038964332541, -0.13059044542211282],
            [6.761752346538094, -0.15128205526492003],
            [6.754543263273909, -0.15779395122458592],
            [6.7483886323142315, -0.16830036157726008],
            [6.7452191987664465, -0.17019542869712836],
            [6.740004316888279, -0.16856557046923887],
            [6.7381840989974116, -0.16419153114645849],
            [6.739556363077666, -0.15846907776256955],
            [6.74554642815046, -0.1455400700709162],
            [6.744032031473544, -0.1418890451844026],
            [6.738363710139874, -0.13901691167515434],
            [6.733466118126966, -0.13961063893795458],
            [6.725445282221884, -0.1436399021144172],
            [6.722705725578615, -0.14777469595955378],
            [6.722174977758881, -0.15706550891958812],
            [6.720058700285483, -0.1608137337417376],
            [6.7141120891623, -0.1639639198461953],
            [6.712955457823299, -0.16780168625714825],
            [6.714690541294082, -0.1740218284123978],
            [6.7218980779934006, -0.18001524096360344],
            [6.71922629028123, -0.18529122586264477],
            [6.713248396457378, -0.18811648533814784],
            [6.710032726885395, -0.19484079549026567],
            [6.711283896830171, -0.20139293025474816],
            [6.709807379506, -0.2045361439569529],
            [6.7030080657765225, -0.20483771927365446],
            [6.701740984441922, -0.19889997138063298],
            [6.6996352932333725, -0.19534382077905096],
            [6.691388547224661, -0.18651044400809752],
            [6.686813249107734, -0.18641989034711315],
            [6.6843301011183005, -0.1838793008927332],
            [6.682897305260262, -0.17329069621340337],
            [6.685386970938592, -0.1691807908293663],
            [6.693967492595967, -0.1693257436035116],
            [6.69289248873492, -0.16600757914069025],
            [6.695114625296694, -0.15769599630438816],
            [6.698641095317463, -0.15828110907719864],
            [6.700725269283841, -0.15538656311865934],
            [6.708273449122679, -0.1491798694224346],
            [6.709564021616609, -0.1441288715612326],
            [6.7068482033670955, -0.14117812491350445],
            [6.708238619146166, -0.13238823221622265],
            [6.712127743395585, -0.133517468296302],
            [6.714256713266227, -0.13164321848803848],
            [6.712264864219226, -0.12420348907217187],
            [6.706097470679723, -0.12359495373746734],
            [6.704360902865598, -0.11998142525544676],
            [6.705765555168798, -0.1159879340385592],
            [6.704176892836267, -0.10955771411729394],
            [6.7061864828439175, -0.103610670561095],
            [6.702981950379813, -0.09756584961089462],
            [6.702173044021012, -0.0927801513823876],
            [6.694399932602322, -0.08784092330595618],
            [6.693357257467562, -0.08255206851995865],
            [6.688553189610827, -0.07579912380805212],
            [6.6882308910639825, -0.07142111754184209],
            [6.684653947327815, -0.06405742149196121],
            [6.684463698861969, -0.057555301887803036],
            [6.6868850011748835, -0.05220024255756671],
            [6.693013315472909, -0.04993912404594283],
            [6.692198431352734, -0.04594844205171311],
            [6.687076024226771, -0.046378261518654006],
            [6.683663452859802, -0.041756159404013546],
            [6.687831436430048, -0.0390826217733583],
            [6.68726836375184, -0.030594376994701817],
            [6.690053156783627, -0.030308831705400396],
            [6.696148020874438, -0.01961545747818996],
            [6.700532561515975, -0.021907713968263437],
            [6.700828782433072, -0.013967744357563792],
            [6.7032262338977935, -0.01019186231364311],
            [6.699263522215308, -0.009414549354371523],
            [6.700484468481451, -0.0026395609135550766],
            [6.703889847383268, 0.0025900772199232607],
            [6.7038431266078105, 0.01665344871847705],
            [6.700838541557782, 0.018738207259264176],
            [6.704569592602378, 0.021503608091153172],
            [6.699063057692629, 0.03165444459534893],
            [6.698667437486496, 0.03939172544488715],
            [6.693968662274563, 0.04297858655543073],
            [6.695745323020662, 0.04793092654472985],
            [6.691436935065831, 0.05037142562755324],
            [6.693336458279279, 0.0530499069491284],
            [6.690259903783067, 0.057277246550942754],
            [6.693016176707948, 0.06748202353423544],
            [6.690095821338977, 0.075446824539721],
            [6.691065766651151, 0.07949457598088784],
            [6.6957073976485155, 0.0827170611034812],
            [6.701381320210926, 0.09448051061917334],
            [6.698929679044147, 0.09491359406366622],
            [6.69660612404983, 0.1023126543510875],
            [6.690199366768091, 0.10300390500506472],
            [6.690911113511626, 0.10812625518736523],
            [6.687159742948416, 0.11391661848451262],
            [6.6875405779065495, 0.11893584924480885],
            [6.683320433941671, 0.12145586305228631],
            [6.683104250247933, 0.12695542910216842],
            [6.685669201688206, 0.13099754899549557]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.84442628930776, "lat": 38.4460598212405 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17185"],
        "coty_name": ["Wabash"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wabash County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00424293"
      },
      "bbox": [
        6.682897305260262, -0.20483771927365446, 6.929612668300242,
        0.14913946821216031
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.858886129750128, 2.8790881881506034],
            [7.876310235894454, 2.8811962103654314],
            [7.870044499444387, 2.9329220747240385],
            [7.866800162730847, 2.9580263213230813],
            [7.854851867356869, 3.054602670613598],
            [7.845046699229659, 3.1431034289994497],
            [7.844819780981766, 3.143746459309218],
            [7.901931243489508, 3.1493381686209085],
            [7.963687348206, 3.1562342848426033],
            [7.998475950689319, 3.1591390767609946],
            [8.045089052261247, 3.1646483023647756],
            [8.109203277140995, 3.1727170394872597],
            [8.14478968728649, 3.17689092000147],
            [8.146972544152337, 3.156476992283295],
            [8.154377146431035, 3.0912157825268616],
            [8.16151835896256, 3.0348693414931596],
            [8.165237763502494, 3.0059063939008186],
            [8.170366387272246, 2.9541653755395036],
            [8.173672236743318, 2.9184315497595392],
            [8.14855494127588, 2.9155798353602154],
            [8.15555655473692, 2.85511926065624],
            [8.160848269237817, 2.8128951425735673],
            [8.164710048401705, 2.7839775343696793],
            [8.152912343233652, 2.781650068171656],
            [8.117165709403773, 2.7769096268547173],
            [8.082033900490211, 2.7718596864468554],
            [8.025241842328546, 2.765224056420268],
            [7.999055304659931, 2.7623076304546954],
            [7.985065093723449, 2.760470141423257],
            [7.970731299355388, 2.759245165218758],
            [7.9371456413323775, 2.7549173720087787],
            [7.928023595403849, 2.7543498126482753],
            [7.916457101326788, 2.752499153352775],
            [7.91196720786859, 2.796826068952668],
            [7.869329110872442, 2.7910944061245613],
            [7.865988737604462, 2.820259782964585],
            [7.858886129750128, 2.8790881881506034]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.8607315982036, "lat": 41.24407672918189 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18085"],
        "coty_name": ["Kosciusko"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kosciusko County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00450367"
      },
      "bbox": [
        7.844819780981766, 2.752499153352775, 8.173672236743318,
        3.17689092000147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.381360925121618, 1.1092057415611516],
            [7.3986857047679875, 1.1102668449091],
            [7.449229948629484, 1.1146886359731494],
            [7.458021588801459, 1.1152012976956056],
            [7.500155388968392, 1.1189184072004905],
            [7.516896484241779, 1.1190932921126586],
            [7.546367668525912, 1.122483384114625],
            [7.573406716176413, 1.1249407483945397],
            [7.5752159140551445, 1.1246713335262108],
            [7.615919318183898, 1.1288370244265458],
            [7.620131140842281, 1.089220953672951],
            [7.621343810844585, 1.0850841832236742],
            [7.621745540336308, 1.0758062312743675],
            [7.623225503084866, 1.0646925631482493],
            [7.629222295228034, 1.0051318024140468],
            [7.627159304187139, 1.006525327720742],
            [7.621802265826789, 1.0057423815921838],
            [7.614112442908128, 1.0123325053967651],
            [7.611255902294526, 1.010853847491875],
            [7.607866904991787, 1.006406840384606],
            [7.60789264604274, 1.0003776097870918],
            [7.611221123491395, 0.9963049348507866],
            [7.611934469224836, 0.9877317101956596],
            [7.609578267849361, 0.9861027320410923],
            [7.605965481551274, 0.9899487328342758],
            [7.602853685823474, 0.9848142954400625],
            [7.588529556762973, 0.9900593178333827],
            [7.601154702167026, 0.875754050862477],
            [7.60734461313498, 0.819177378755937],
            [7.5655482792577, 0.8156424570774821],
            [7.493237918585397, 0.8093545859279825],
            [7.482337771645143, 0.808868764194675],
            [7.472078070117398, 0.8075599605893614],
            [7.446513787455776, 0.8057274191803901],
            [7.344443880299168, 0.7962704439486011],
            [7.323084117682553, 0.7941588757791715],
            [7.3185215157393335, 0.8417363989023747],
            [7.3183664681743394, 0.8471098802381046],
            [7.3148604971457765, 0.8822696761564974],
            [7.313230038878727, 0.8964637166173695],
            [7.31031305593355, 0.9336651257535536],
            [7.307235391858189, 0.9696276673616204],
            [7.392076462127522, 0.9771001994478629],
            [7.389502107651711, 1.006232620466462],
            [7.383738086024188, 1.0648331425355644],
            [7.384234361538662, 1.0648359627577253],
            [7.382286026302895, 1.0913931859625363],
            [7.381360925121618, 1.1092057415611516]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.83765411432293, "lat": 39.31281225398067 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18119"],
        "coty_name": ["Owen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Owen County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00450379"
      },
      "bbox": [
        7.307235391858189, 0.7941588757791715, 7.629222295228034,
        1.1288370244265458
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.892884282988741, 1.479188085432668],
            [6.885390145013584, 1.567893837989221],
            [6.880627523308951, 1.6234923857834385],
            [6.8703863863871035, 1.7456886313043714],
            [6.901295941221354, 1.7487540721761263],
            [6.903226036696275, 1.7276454399068641],
            [6.917706568852904, 1.7288612254616404],
            [6.966415888037449, 1.7334469782929032],
            [6.96640068988658, 1.7244281272856048],
            [6.9673703555129105, 1.7122423902316612],
            [6.964781334379566, 1.7065146205504187],
            [6.9643031985711925, 1.6978070635383495],
            [6.966019629431439, 1.6918878409470188],
            [6.964401066945019, 1.677554108479224],
            [6.964550388986241, 1.6635747010912798],
            [6.962286709264978, 1.6585397467641616],
            [6.956565901639787, 1.6539964814248866],
            [6.955649119018371, 1.648966023393992],
            [6.960670647289913, 1.6454365419960393],
            [6.960636830850526, 1.6425023563951158],
            [6.956359629747246, 1.6367466975341856],
            [6.954251963028841, 1.6299840070865945],
            [6.954724433406492, 1.6213182808342599],
            [6.957474484205413, 1.6055494018868846],
            [6.958362599074029, 1.597690760807499],
            [6.963317048121107, 1.5905570924331827],
            [6.964005975083898, 1.5857990246348028],
            [6.962658701546825, 1.5746315770643153],
            [6.956237816377917, 1.5631770658339676],
            [6.960731563891591, 1.5595869177266075],
            [6.965349628049788, 1.5584301341807756],
            [6.970349791955494, 1.5604938587774932],
            [6.972112520494292, 1.5566593517055205],
            [6.970686071331166, 1.5476458197121383],
            [6.96351070516379, 1.5383709657372353],
            [6.965940257545783, 1.5329240713900343],
            [6.971074332098502, 1.5303929052254583],
            [6.9754171902383275, 1.5298710902624935],
            [6.98058539178817, 1.533376888663921],
            [6.984451984348031, 1.5334962485034171],
            [6.986099825340014, 1.5288805565462114],
            [6.980443134501064, 1.5228989669849082],
            [6.983522439892026, 1.5182497182319468],
            [6.987449249088092, 1.5159140557623583],
            [6.997638372996531, 1.512830940907552],
            [7.003349148469312, 1.5127681549092324],
            [7.007018319857468, 1.5107007793927005],
            [7.012761855972029, 1.5039607129444152],
            [7.016637019292927, 1.4979139725460544],
            [7.01783262138741, 1.4933627648986003],
            [7.016555545331348, 1.4895133890040042],
            [7.011110375044276, 1.4856201898081682],
            [7.012110138414598, 1.4803145438836969],
            [7.019388584078583, 1.4750432923188415],
            [7.028692620094804, 1.4729296930980813],
            [7.030597113212876, 1.4704206718033925],
            [7.029315542879333, 1.4668299055778502],
            [7.02643124074778, 1.4649997437522362],
            [7.025572753723201, 1.4592025792555043],
            [7.0228642147931355, 1.450258384472741],
            [7.018202036098486, 1.4445952478997097],
            [7.012761659576673, 1.4435898432013732],
            [7.009228404803102, 1.4393875472472872],
            [7.011380656601037, 1.4186310009619725],
            [7.0133348749322035, 1.410839344972628],
            [7.015575780343441, 1.406420100888727],
            [7.021263457604246, 1.3990135436037197],
            [7.022838381531796, 1.384374847221954],
            [7.0190826376702, 1.3728093975827613],
            [7.020496539434381, 1.3639753901643266],
            [7.023549900814542, 1.3522822322483727],
            [7.02290212265913, 1.3363717857728348],
            [7.020565140015578, 1.324115310050934],
            [7.021983888292673, 1.3191923379675905],
            [7.024476759258024, 1.3167825375491014],
            [7.025040673515666, 1.31282142132704],
            [7.02137093916841, 1.3054367912626317],
            [7.025065317982109, 1.2990193197212105],
            [7.023498280766778, 1.2946253182357434],
            [7.023078059933895, 1.287795336629569],
            [7.020501102273168, 1.2831941299056393],
            [7.019945870247829, 1.2782993489377392],
            [7.022431483249758, 1.2725012827120517],
            [7.021403935391727, 1.2666678183318338],
            [7.018506057246182, 1.2632524458869294],
            [7.01772461547845, 1.2584728757122847],
            [7.018750817743904, 1.253261544635199],
            [7.022175490811185, 1.246886837966494],
            [7.022158297948503, 1.2399584607370835],
            [7.025321451480346, 1.232987492581197],
            [7.030979095217191, 1.2248813772423979],
            [7.03232706494779, 1.2211229204237566],
            [7.03219438296988, 1.2130681439573323],
            [6.968537137746547, 1.2068024090874616],
            [6.918399333378185, 1.2021753108294402],
            [6.912836632366518, 1.2602541368660207],
            [6.902102175043374, 1.376347990407272],
            [6.892884282988741, 1.479188085432668]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.46401161235863, "lat": 39.85378843685928 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18165"],
        "coty_name": ["Vermillion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vermillion County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00450397"
      },
      "bbox": [
        6.8703863863871035, 1.2021753108294402, 7.03232706494779,
        1.7487540721761263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.383613454655297, 2.4096542260267886],
            [8.421393043527917, 2.4139612746747923],
            [8.423924449386938, 2.41453767602741],
            [8.46186352535035, 2.4196236525416692],
            [8.468853124136302, 2.420016774774395],
            [8.458682530997706, 2.507720836749907],
            [8.449432624153534, 2.5865664812106215],
            [8.445080554141532, 2.625705272424512],
            [8.438173797256168, 2.6828832832680614],
            [8.522057543343136, 2.692276365260831],
            [8.606642190462592, 2.7022997004810034],
            [8.633282061426577, 2.7058661130763895],
            [8.644415346466438, 2.6196594524989676],
            [8.648541328685221, 2.5890669346701776],
            [8.655622352302492, 2.5312706358275534],
            [8.656147479518582, 2.5313332587475115],
            [8.663179201017307, 2.4750502294909693],
            [8.666936446505565, 2.44372597208454],
            [8.66622359276852, 2.4436376182882458],
            [8.67775101668006, 2.356423604399047],
            [8.649042512512361, 2.352693658433678],
            [8.591893377508004, 2.3455664455483007],
            [8.578610358978633, 2.34403752605988],
            [8.513624768681034, 2.3365313695883088],
            [8.479438013710803, 2.332886438990444],
            [8.394654995833674, 2.3229868415491803],
            [8.383613454655297, 2.4096542260267886]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.22116591514717, "lat": 40.72924602496056 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18179"],
        "coty_name": ["Wells"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wells County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00450337"
      },
      "bbox": [
        8.383613454655297, 2.3229868415491803, 8.67775101668006,
        2.7058661130763895
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6389321000260266, 2.2498742401870273],
            [2.7119054949561487, 2.2519545560383896],
            [2.724523118498132, 2.2525251257055685],
            [2.8055406286044575, 2.25541478648972],
            [2.806430290552794, 2.254953045025578],
            [2.8388028833594676, 2.2563553839190953],
            [2.8964118962808283, 2.2583452507379924],
            [2.9824065182248587, 2.26162550212806],
            [2.983524471726645, 2.23331201800851],
            [2.987189804086632, 2.130759017233651],
            [2.9913020612331667, 2.035980893847969],
            [2.9925778059044545, 1.9921727716194648],
            [2.994287641315723, 1.951391317488169],
            [2.9576128844316267, 1.949050480666634],
            [2.936626347711642, 1.9480751236720035],
            [2.9044394738805783, 1.9463080639753436],
            [2.8128348178307756, 1.9426701737503989],
            [2.7945164426154716, 1.9415859889247162],
            [2.7658882915504903, 1.9405412291577646],
            [2.6576922110201373, 1.9337735234562516],
            [2.6488400099141467, 1.933110344514288],
            [2.6462757940098403, 2.016650213436541],
            [2.643175563001012, 2.114058242555218],
            [2.6432479511495566, 2.1148116576276803],
            [2.640587652214828, 2.192011115848184],
            [2.6389321000260266, 2.2498742401870273]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.86863539372796,
          "lat": 40.743180000077146
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19007"],
        "coty_name": ["Appanoose"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Appanoose County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00465193"
      },
      "bbox": [
        2.6389321000260266, 1.933110344514288, 2.994287641315723,
        2.26162550212806
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.105287583106345, 2.853570790724132],
            [2.1671554047974384, 2.855192603510998],
            [2.227834615028831, 2.8566607192416407],
            [2.2853432549503476, 2.8573702240956442],
            [2.3493523340939446, 2.8557925224614378],
            [2.364891366031308, 2.855719390353032],
            [2.3643974628697944, 2.8526693647677988],
            [2.3684391829936358, 2.8504733884552658],
            [2.3770795487808534, 2.855944528917013],
            [2.3852830530128437, 2.856095561255365],
            [2.384327130664099, 2.848914624060839],
            [2.3800800137062144, 2.8453497340582876],
            [2.380650870315475, 2.840978115080713],
            [2.385380809336388, 2.840939364667832],
            [2.388639503922945, 2.8436993461516833],
            [2.3924172690004415, 2.8504418268647687],
            [2.3956132277533393, 2.8509338644330087],
            [2.3983767168105308, 2.845265046978605],
            [2.3968134380054718, 2.841456428903748],
            [2.3933601835257883, 2.839835610698455],
            [2.392664368124509, 2.8354798048200753],
            [2.3982483123707743, 2.835253750160675],
            [2.401753831387575, 2.837385756839301],
            [2.4049801709700396, 2.8428995663043652],
            [2.41128586662235, 2.8439560514079747],
            [2.414668666099813, 2.842673862512969],
            [2.4169328832720653, 2.8354723785779865],
            [2.4258871683900405, 2.8374622986824845],
            [2.4271303814395804, 2.842754007328431],
            [2.426274565104774, 2.846067192587073],
            [2.4311208179972867, 2.846757708467094],
            [2.4357272592355277, 2.8327264931581504],
            [2.441324013435016, 2.8327790813358016],
            [2.4443669895181195, 2.837574764882157],
            [2.4492157211000443, 2.8411263085547196],
            [2.4524941475131445, 2.7320440062982225],
            [2.45386649362736, 2.677072577451507],
            [2.456147107863311, 2.596762666835755],
            [2.4567402891871866, 2.5819186648910692],
            [2.458957177457179, 2.508865493376293],
            [2.3739509262662137, 2.506405227224328],
            [2.2874905950241473, 2.504871870702017],
            [2.258493545882186, 2.5044112443095456],
            [2.1958945335283695, 2.5030171117885134],
            [2.1145420481152923, 2.5014110844510715],
            [2.1120338564774825, 2.5969092710751593],
            [2.109739485159587, 2.677777060006113],
            [2.10876961520716, 2.707247496962243],
            [2.1066129761589445, 2.795516063786211],
            [2.105287583106345, 2.853570790724132]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.56146130796797, "lat": 41.33426714259097 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19181"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "00465279"
      },
      "bbox": [
        2.105287583106345, 2.5014110844510715, 2.458957177457179,
        2.8573702240956442
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.2950651480658695, 2.2400512091310105],
            [2.380815319244069, 2.24158644571348],
            [2.4169778018916466, 2.2426479788187783],
            [2.4376172507152005, 2.243607737925887],
            [2.4667566487306223, 2.244255433355581],
            [2.5530713790380317, 2.2469050263149435],
            [2.6389321000260266, 2.2498742401870273],
            [2.640587652214828, 2.192011115848184],
            [2.6432479511495566, 2.1148116576276803],
            [2.643175563001012, 2.114058242555218],
            [2.6462757940098403, 2.016650213436541],
            [2.6488400099141467, 1.933110344514288],
            [2.6198975216765437, 1.93106253822557],
            [2.526027431852093, 1.9262214660684207],
            [2.4831366186716535, 1.9248713895796228],
            [2.4404103524136342, 1.9233390984759569],
            [2.3897069367945685, 1.9215349323702333],
            [2.327703846165428, 1.9204632337150522],
            [2.3030410294189423, 1.9195771516645355],
            [2.3002831343116843, 2.0365128962811356],
            [2.299512047329132, 2.0655164615758643],
            [2.2987052673636335, 2.108928073170308],
            [2.2969837624440435, 2.1534746082907543],
            [2.2950651480658695, 2.2400512091310105]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.32738092234506, "lat": 40.7394679393784 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19185"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00465281"
      },
      "bbox": [
        2.2950651480658695, 1.9195771516645355, 2.6488400099141467,
        2.2498742401870273
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4520951332573835, 0.1960315873871219],
            [-1.4457796618543952, 0.19578085628953457],
            [-1.381222513932491, 0.19440950462684858],
            [-1.3525564527748233, 0.19343467969244027],
            [-1.3239772154865812, 0.19278124666721086],
            [-1.2809008274152967, 0.19211349475137152],
            [-1.2697621776604238, 0.19225511242311613],
            [-1.2519257481786188, 0.19127777108683186],
            [-1.209065148151778, 0.18969180879033667],
            [-1.205952624492582, 0.18994399594256214],
            [-1.176065339559074, 0.1894619025555761],
            [-1.1658099533015658, 0.1890311122489998],
            [-1.0948625814533794, 0.18795112503843434],
            [-1.023271133662892, 0.1863844608870193],
            [-1.0249621149051504, 0.09842047419572235],
            [-1.026736492151103, 0.010602367692630028],
            [-1.0241894724318745, 0.010395193660103377],
            [-1.0251077935286943, -0.04830272232134703],
            [-1.0256851312005348, -0.07737989420448861],
            [-1.0270592149715636, -0.16534570234472062],
            [-1.0988436406327315, -0.16419649792884147],
            [-1.0998163317363712, -0.16434754644637026],
            [-1.2418663602959936, -0.16134012686276783],
            [-1.2848508417761435, -0.16025899335549956],
            [-1.371931726639046, -0.15852900962412994],
            [-1.3807750546213502, -0.15819281606365793],
            [-1.4578329953922862, -0.15628535855345327],
            [-1.4551645634189576, -0.06832415169164177],
            [-1.4528962139847459, 0.020428869925265273],
            [-1.4576491641159395, 0.02051468688774945],
            [-1.4549113028664125, 0.108392965521159],
            [-1.4520951332573835, 0.1960315873871219]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.20475681075713, "lat": 38.69663470788749 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20053"],
        "coty_name": ["Ellsworth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ellsworth County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00484996"
      },
      "bbox": [
        -1.4578329953922862, -0.16534570234472062, -1.023271133662892,
        0.1960315873871219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.210989341728457, 0.061597134723195286],
            [-4.2073297162853525, 0.11645478357088274],
            [-4.2056423509174214, 0.14462666004407662],
            [-4.201615648932304, 0.14462831188063338],
            [-4.058714656867944, 0.13576459751298148],
            [-3.9664437990414547, 0.13066582478843777],
            [-3.836655578864926, 0.12418388534658599],
            [-3.862761027647233, -0.3158333696136635],
            [-4.009930363433913, -0.307702852192278],
            [-4.233027387542904, -0.29392876350903857],
            [-4.232665114260226, -0.28753924424205474],
            [-4.229903936300767, -0.24362416363152525],
            [-4.225533418468286, -0.1709539031165853],
            [-4.223130485813695, -0.13935249078896195],
            [-4.223264122991578, -0.13542008784736398],
            [-4.221384381258824, -0.1011709061823192],
            [-4.21552007997144, -0.010328532985444148],
            [-4.210989341728457, 0.061597134723195286]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.80605082183688,
          "lat": 38.480566803421546
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20071"],
        "coty_name": ["Greeley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greeley County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00485002"
      },
      "bbox": [
        -4.233027387542904, -0.3158333696136635, -3.836655578864926,
        0.14462831188063338
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3233260981361417, -0.9237999467717829],
            [-2.240082419884768, -0.9275934043453462],
            [-2.237505034193255, -0.9275758927551958],
            [-2.1807351663983567, -0.9300458727308392],
            [-2.0670945862712817, -0.9345721552088855],
            [-2.0386126510276594, -0.935278914828984],
            [-1.989487082996774, -0.9372219919543546],
            [-1.9819458566340893, -0.9372500212176421],
            [-1.8960153122536698, -0.9405178345729822],
            [-1.9002771071576015, -1.0303984896436154],
            [-1.9011937227042588, -1.0889822014671255],
            [-1.9020373223613567, -1.1182178449873688],
            [-1.9025187922792095, -1.1468888235370949],
            [-1.9027424267724027, -1.1756191016897328],
            [-1.903015395060317, -1.1762700389185008],
            [-1.9036723519764756, -1.2054861547352849],
            [-1.904444135761882, -1.2400414261510933],
            [-1.904269968507622, -1.2452426901022657],
            [-1.9055652219765111, -1.2924505269428896],
            [-1.9838557855580154, -1.2902649751811401],
            [-1.9920240293919556, -1.290213287269097],
            [-2.068590794587591, -1.288150086886491],
            [-2.1623775476007867, -1.2858944440984401],
            [-2.2787613226192156, -1.28263595292246],
            [-2.2798536418814574, -1.2828969159969088],
            [-2.3238127052994932, -1.281196986045466],
            [-2.3337096138698876, -1.280839421006671],
            [-2.3331122651659744, -1.2714877728707286],
            [-2.3307093841646807, -1.1934531280882696],
            [-2.3264850902266874, -1.0434112322355158],
            [-2.3258734530432084, -1.0292406610500695],
            [-2.323494482551601, -0.9267874484412115],
            [-2.3233260981361417, -0.9237999467717829]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.28606647493706, "lat": 37.55823354426718 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20097"],
        "coty_name": ["Kiowa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kiowa County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00485013"
      },
      "bbox": [
        -2.3337096138698876, -1.2924505269428896, -1.8960153122536698,
        -0.9237999467717829
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.158174214988562, 0.08790062634163219],
            [-3.100607127367193, 0.08517246017529773],
            [-3.016811953116007, 0.08091930665146503],
            [-2.973708323111059, 0.07890664067643932],
            [-2.9732378501118606, 0.07869254289652576],
            [-2.9002874899942124, 0.07469643396539122],
            [-2.817933399708942, 0.07001940922694036],
            [-2.820328231458855, 0.02589909284225219],
            [-2.82163504775086, 0.010754732552189764],
            [-2.824703525690442, -0.07704691052320867],
            [-2.826607468476858, -0.12987511609610464],
            [-2.827134053366136, -0.13576971368068727],
            [-2.830006144287581, -0.22337987091873288],
            [-2.835414793793041, -0.3697733951769937],
            [-2.8729422410909256, -0.36795042133342276],
            [-2.879098149582819, -0.3679660945065951],
            [-2.9070304768517867, -0.36618962198813804],
            [-3.0061737927827, -0.36104625162588566],
            [-3.0339187285795903, -0.35944776211940316],
            [-3.1346381341675924, -0.3541597984040935],
            [-3.1773073572083916, -0.35183480176356585],
            [-3.175775758885166, -0.32214391729622466],
            [-3.172672026455605, -0.24884046337451862],
            [-3.1710377544480757, -0.20450312170961849],
            [-3.1703676831804914, -0.19167912088780595],
            [-3.166371697430593, -0.09954798707805557],
            [-3.1657641620315258, -0.0875045867250874],
            [-3.1610963296209187, 0.020453241688883277],
            [-3.1609276533011927, 0.02066935383535752],
            [-3.158174214988562, 0.08790062634163219]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.46642410120762, "lat": 38.4813276920415 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20101"],
        "coty_name": ["Lane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lane County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00485015"
      },
      "bbox": [
        -3.1773073572083916, -0.3697733951769937, -2.817933399708942,
        0.08790062634163219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.287495234443632, 1.3651044363423661],
            [-2.193784799608751, 1.3617518933960748],
            [-2.1778095129551174, 1.3610801687933856],
            [-2.1344351007163915, 1.3598356126945867],
            [-2.1191407868654344, 1.358982373168501],
            [-2.033657220280097, 1.355951401610649],
            [-1.9490158902136328, 1.353098492400973],
            [-1.8992224074469073, 1.351668021176932],
            [-1.8639539337519395, 1.350498283149519],
            [-1.8668155281672802, 1.2635472346096497],
            [-1.8670731353701115, 1.2494216296388374],
            [-1.8692923939581685, 1.1759918793381465],
            [-1.8719933779597495, 1.0881234449569703],
            [-1.8747080650803483, 1.0001960013678424],
            [-1.8774758682645303, 0.9127181561875788],
            [-1.9463373344650612, 0.9147547871628579],
            [-1.9630276608560546, 0.9154686690985423],
            [-2.0058375596279894, 0.916262896522219],
            [-2.0177575099019673, 0.916928147692132],
            [-2.0366199811580317, 0.917116274871311],
            [-2.0485954103869797, 0.9178763730152669],
            [-2.105689111948249, 0.9198285093540902],
            [-2.134347198851412, 0.9206229401589976],
            [-2.1798169226084285, 0.9224928309277093],
            [-2.286554817863615, 0.9262681005895399],
            [-2.306222072559883, 0.9271265153961159],
            [-2.3032188198318058, 1.0072940024647015],
            [-2.300903788216118, 1.065764781896434],
            [-2.3005330367185404, 1.0811615023750056],
            [-2.2955362501555845, 1.190278741276913],
            [-2.294200243174311, 1.2267568272757299],
            [-2.2919204365118437, 1.2775696271294341],
            [-2.289729267616328, 1.3212551212374977],
            [-2.28934812368162, 1.3243300870277657],
            [-2.287495234443632, 1.3651044363423661]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.34702028553345, "lat": 39.78457383879393 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20147"],
        "coty_name": ["Phillips"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Phillips County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00485037"
      },
      "bbox": [
        -2.306222072559883, 0.9127181561875788, -1.8639539337519395,
        1.3651044363423661
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8960153122536698, -0.9405178345729822],
            [-1.8928770061776896, -0.8473084380081438],
            [-1.8140400786831883, -0.8497171369820614],
            [-1.7798112925324474, -0.85088765734785],
            [-1.7279870551021337, -0.8524330732683646],
            [-1.6146834490704964, -0.8565708849623788],
            [-1.5559492063925577, -0.858268931484654],
            [-1.4698588869465419, -0.860365518157957],
            [-1.4641049554212098, -0.8604998316842853],
            [-1.4648786311672923, -0.8944254026456012],
            [-1.4664354447384997, -0.9531981400530446],
            [-1.4699987613848906, -1.0854960105393767],
            [-1.4710085525071601, -1.129560607238468],
            [-1.473176249446173, -1.2172934242604319],
            [-1.60236900152478, -1.2143202176966748],
            [-1.6670678076376648, -1.2119752205571026],
            [-1.6702498873528355, -1.2122499816509014],
            [-1.7311253460224394, -1.210741328355127],
            [-1.799113204432182, -1.208958774174556],
            [-1.9036723519764756, -1.2054861547352849],
            [-1.903015395060317, -1.1762700389185008],
            [-1.9027424267724027, -1.1756191016897328],
            [-1.9025187922792095, -1.1468888235370949],
            [-1.9020373223613567, -1.1182178449873688],
            [-1.9011937227042588, -1.0889822014671255],
            [-1.9002771071576015, -1.0303984896436154],
            [-1.8960153122536698, -0.9405178345729822]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.73963138354347, "lat": 37.64771877529038 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20151"],
        "coty_name": ["Pratt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pratt County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00485039"
      },
      "bbox": [
        -1.9036723519764756, -1.2172934242604319, -1.4641049554212098,
        -0.8473084380081438
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.2684227898717633, 0.8769378452743992],
            [-0.1522115942622962, 0.8758496497264913],
            [-0.034429205605996445, 0.8749680003337645],
            [0.020443961465085987, 0.8743749793706994],
            [0.016265048624249608, 0.8685778976297485],
            [0.0122533128620012, 0.861028816452487],
            [0.013945040814751987, 0.854212451145396],
            [0.011396324656089665, 0.8518442540010046],
            [0.0009812398076412448, 0.8456025710619771],
            [-0.006630202362662427, 0.8397872280840097],
            [-0.013019118329556777, 0.8447312387184306],
            [-0.023747993424448277, 0.832623757547035],
            [-0.02732558971054921, 0.8301699105255361],
            [-0.028958530609039735, 0.8246699172345935],
            [-0.02520722594100185, 0.8181413009183243],
            [-0.026675825507239233, 0.8143539943733219],
            [-0.03277745161857723, 0.8147234803386262],
            [-0.038238441514243694, 0.808132521172986],
            [-0.041986563696654385, 0.8008627978512382],
            [-0.044346714743120956, 0.7937369318208611],
            [-0.04678650965164595, 0.7831757208706189],
            [-0.05272250170482926, 0.7803096168668022],
            [-0.05709558554037482, 0.7847316509320865],
            [-0.0548383964057107, 0.7891073346783141],
            [-0.057794724483404725, 0.7906657766061229],
            [-0.06379482710944531, 0.7761012467796372],
            [-0.062350130229393085, 0.770403854322031],
            [-0.06336779699903188, 0.7681269625157015],
            [-0.06838107308159058, 0.7656611867277026],
            [-0.07136678913357676, 0.7659172827287453],
            [-0.07605558438484589, 0.7694020712912983],
            [-0.07822737118821185, 0.7682180557927483],
            [-0.08851187571327034, 0.7518633439640546],
            [-0.08611638592506872, 0.7468324454150902],
            [-0.08179295957244692, 0.7441794405932352],
            [-0.08550478282355647, 0.7374533598143673],
            [-0.0931118721857697, 0.7344920236501405],
            [-0.08902301168380455, 0.729002868862659],
            [-0.08485869798435727, 0.7292741686871015],
            [-0.08337351124861746, 0.7270119589202073],
            [-0.08307089148735343, 0.718709132622505],
            [-0.0871629929188201, 0.7118818952324454],
            [-0.09218275731575579, 0.711283123425181],
            [-0.08556747834305448, 0.700064398160479],
            [-0.07315568333449761, 0.6882944472247962],
            [-0.07272946437773778, 0.6853497545086761],
            [-0.06774201930565568, 0.6795208994390388],
            [-0.06313820694830487, 0.6808875447571917],
            [-0.059890294941728824, 0.6770978173134014],
            [-0.06096046150031673, 0.6728021925898449],
            [-0.06558833297173612, 0.6668223181820799],
            [-0.06087386720698832, 0.6613330255565083],
            [-0.05611815891983801, 0.6573357296834975],
            [-0.0497923447843625, 0.650289128124646],
            [-0.04271048877476856, 0.6497620438906095],
            [-0.044427698091429914, 0.645314139138688],
            [-0.049232468572685574, 0.6442898943295462],
            [-0.05092932143188401, 0.6409534201208807],
            [-0.04716811989164095, 0.6348387408299809],
            [-0.03889232838543106, 0.6306664899332908],
            [-0.03168488602737793, 0.6324271142255403],
            [-0.034268643874791734, 0.6257195294241454],
            [-0.03946792517760747, 0.6232194227186479],
            [-0.03471369017592594, 0.6154459351130919],
            [-0.030151405584497314, 0.6135795963251406],
            [-0.02182789581895769, 0.6045592909405141],
            [-0.021193643584946225, 0.6009198474086527],
            [-0.026484590628992794, 0.5985475842985617],
            [-0.023092668625584203, 0.5928655452172933],
            [-0.0163251759912793, 0.586458713137206],
            [-0.005704848445185147, 0.5736100754507489],
            [-0.002406595737029047, 0.571312441492108],
            [0.005894627688781799, 0.5692680440580193],
            [0.00773946481305244, 0.5656494603636107],
            [0.007232408725218842, 0.5576743602986076],
            [0.010405090554591184, 0.5548622094564005],
            [0.020368652804112937, 0.5539711049154621],
            [0.021256002893072123, 0.5579866593180485],
            [0.025756320496854095, 0.5553145256633364],
            [0.025912346616977836, 0.5519175370927262],
            [0.02278755249274057, 0.5489421030414413],
            [0.018267352488665567, 0.5510441651351342],
            [0.012472758234502342, 0.5477362316121606],
            [0.013198698741319766, 0.5437975906105247],
            [0.018829096093964368, 0.5393866834046207],
            [0.021732029579481664, 0.5423723979281216],
            [0.027501507441595664, 0.5432785393608692],
            [0.031830476124614995, 0.54606936501606],
            [0.034212595697241104, 0.5441250684243847],
            [0.04067190614977433, 0.527254287767796],
            [0.041576916568135794, 0.5184205809374395],
            [0.04422038687362559, 0.5132748078066677],
            [0.04696773946930592, 0.5132136299435366],
            [0.050002188972124835, 0.5195191492208368],
            [0.05365309026605323, 0.5169524578902742],
            [0.058859888381603845, 0.5154766915356438],
            [0.06560746351235947, 0.5100980344527857],
            [0.06519450868103198, 0.5033514399581271],
            [0.05614974705941748, 0.5002041501042676],
            [0.052239632861467, 0.5002573946921473],
            [0.04880711253905394, 0.5024897803469172],
            [0.04308927942072673, 0.5011979861950046],
            [0.034644080166407104, 0.5030936440459475],
            [0.03308375499129152, 0.501315923132158],
            [0.034752161280776815, 0.4937980065774762],
            [0.03517545307708203, 0.4874403240230026],
            [0.038474596483208605, 0.48334944773299915],
            [0.04477123624921216, 0.48690202865675647],
            [0.06676366172601003, 0.4919500454956421],
            [0.06904714550377684, 0.4880195558962012],
            [0.06534555483280234, 0.4802599749558603],
            [0.06743000262740051, 0.4751159885587908],
            [0.07896224356406102, 0.47156824088775673],
            [0.08560749172097765, 0.47367884371119573],
            [0.08786769287913085, 0.48191632584817234],
            [0.09161295851275296, 0.4835225274449991],
            [0.09617509854007754, 0.4796600404337299],
            [0.09640383149530611, 0.47247179233130515],
            [0.0980866929716143, 0.4683947818319874],
            [0.10818640932685225, 0.4706032901299323],
            [0.11029242883827453, 0.47288174943594563],
            [0.10806366423022414, 0.4780353002573124],
            [0.10773431873918973, 0.48230028832105376],
            [0.11079208891923906, 0.48806819303264903],
            [0.10943945056716871, 0.4920574502878294],
            [0.11288703693490469, 0.49487057443208277],
            [0.1215966688588278, 0.494722201815026],
            [0.13375110932208686, 0.49069261675057774],
            [0.1471596928557199, 0.48891595928897263],
            [0.15792258253687283, 0.4833407210875804],
            [0.16499957087099323, 0.47659178339201874],
            [0.16452178811430485, 0.43363947982192547],
            [0.1633945897757358, 0.43362896333878653],
            [0.16283057555085248, 0.375022119323865],
            [0.16323207513756274, 0.3602709978903567],
            [0.16311769792852027, 0.34573493021579005],
            [0.09262026624691495, 0.34631522884428084],
            [0.07821773548063485, 0.34654624687241276],
            [0.07852906741708626, 0.37583884252387945],
            [0.005270606381543059, 0.37701587945224146],
            [-0.023654666141557, 0.3768628167888571],
            [-0.07922173356822827, 0.37724038798781684],
            [-0.07918987372347963, 0.39549722308693647],
            [-0.08495053214299703, 0.3944397679003328],
            [-0.09121798981886794, 0.3958127381040915],
            [-0.09639691171096115, 0.39203890642492367],
            [-0.10218785942817527, 0.3843608856839505],
            [-0.10785769299336163, 0.38642225567712024],
            [-0.10780034585194842, 0.39218072504733176],
            [-0.19079867608197532, 0.3933990675893885],
            [-0.19057743935405516, 0.4060821124057298],
            [-0.18153141678979778, 0.42098448451557036],
            [-0.17578351229146857, 0.42503803360629716],
            [-0.17464705610626452, 0.44479934968916773],
            [-0.18900057514812477, 0.4449787554560217],
            [-0.1884413436435112, 0.525470282781571],
            [-0.27423170962049137, 0.527362058221167],
            [-0.27274613366042244, 0.6148590150396493],
            [-0.2716553748466866, 0.7252326801075436],
            [-0.26989164187000464, 0.7908399270295289],
            [-0.2684227898717633, 0.8769378452743992]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.73520540094495, "lat": 39.29656464687838 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20161"],
        "coty_name": ["Riley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Riley County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00485044"
      },
      "bbox": [
        -0.27423170962049137, 0.34573493021579005, 0.16499957087099323,
        0.8769378452743992
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.270409138989302, -0.916975968024429],
            [-4.2680813557071815, -0.8805458359628718],
            [-4.264679190840023, -0.8219749070736424],
            [-4.223513871670044, -0.82500311594642],
            [-4.223120394029836, -0.8247861384209388],
            [-4.130672094034409, -0.8310676096013764],
            [-4.1102376520641375, -0.8320734909558686],
            [-4.100574831714889, -0.8330238171832282],
            [-4.037814002089687, -0.8374717870451369],
            [-4.023502171064035, -0.8389160689058774],
            [-4.018665249577387, -0.8388367711392368],
            [-3.9899662497619404, -0.840531100562497],
            [-3.8839258594995982, -0.8475623823880658],
            [-3.862307181384222, -0.8487441049197114],
            [-3.8698545105087656, -0.987692360849664],
            [-3.871934965905666, -1.024399008702102],
            [-3.875816876314864, -1.0975507078015443],
            [-3.8817424915788785, -1.199484289460205],
            [-3.9059273763140334, -1.1979789280989308],
            [-3.9123366439351734, -1.1976915791894716],
            [-4.010674757488224, -1.191651222327608],
            [-4.1333379038007605, -1.1838828203777296],
            [-4.2867728974151476, -1.174004188794109],
            [-4.2839765405223105, -1.127986708201319],
            [-4.279432824094404, -1.0562349468445178],
            [-4.277740260036826, -1.0268067269080536],
            [-4.272770825933407, -0.953666501706188],
            [-4.270409138989302, -0.916975968024429]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.78420723432542,
          "lat": 37.56300513417321
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20187"],
        "coty_name": ["Stanton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stanton County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "00485055"
      },
      "bbox": [
        -4.2867728974151476, -1.199484289460205, -3.862307181384222,
        -0.8219749070736424
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.92011818968082, -1.576320849335558],
            [5.926806858730205, -1.5748242165093467],
            [5.930914479880395, -1.5803298136772652],
            [5.931654873820026, -1.5866654456209863],
            [5.936716878504048, -1.592389640177361],
            [5.934911874922458, -1.5969535809394977],
            [5.946216040062745, -1.6029598033602366],
            [5.94704893139306, -1.5980061280843523],
            [5.950799669676093, -1.5951111144457553],
            [5.950124812075026, -1.5884995952999252],
            [5.944558580540893, -1.586555337557275],
            [5.953991407460757, -1.5822937739653862],
            [5.957121231626408, -1.5846241324803616],
            [5.961921009562049, -1.5814573800910563],
            [5.963666998321684, -1.5905588777466402],
            [5.97300269624471, -1.5891174186486496],
            [5.979162056544919, -1.5903228458087268],
            [5.984810112328435, -1.587328087283196],
            [6.000409963900452, -1.5899976114728878],
            [6.002351725328701, -1.5939743528410462],
            [6.008726224945689, -1.5946474422943013],
            [6.017693938924007, -1.5871674920812955],
            [6.022874382609131, -1.588240408249806],
            [6.0266628117504055, -1.586331392410996],
            [6.030076274541927, -1.5815220771417877],
            [6.034447522875812, -1.5833413787948345],
            [6.03919553380538, -1.5818948455230701],
            [6.043825689761529, -1.578332406208509],
            [6.056053768931619, -1.5735309106169448],
            [6.065276815682628, -1.5688251190284568],
            [6.075811836443057, -1.5691170441176125],
            [6.0802122778347405, -1.567552080728209],
            [6.086181940322642, -1.5626628680724621],
            [6.0957293483321795, -1.562999624136688],
            [6.0970462241623125, -1.560516173188807],
            [6.102536192966031, -1.5597071084695135],
            [6.106816155310416, -1.5559096438732187],
            [6.115693012118436, -1.553525956469202],
            [6.120234873185348, -1.556358918861172],
            [6.127015712222681, -1.5567129035950058],
            [6.136226066437973, -1.5510595399963747],
            [6.144174408037602, -1.5494764179565452],
            [6.147137344867309, -1.5565763556271088],
            [6.1538889549687195, -1.6483611783813525],
            [6.160127611704786, -1.7314489707822274],
            [6.0108566390675575, -1.7441730650224132],
            [5.959162974895728, -1.746753279536881],
            [5.962425693657834, -1.7320909071124402],
            [5.928175459271665, -1.7241981614275301],
            [5.924585496480789, -1.728176352689287],
            [5.918600307826366, -1.7316471018807669],
            [5.913768025325683, -1.7374129067011315],
            [5.909286003264716, -1.7352895826494295],
            [5.887844782196641, -1.7353724951554592],
            [5.883770306820201, -1.7338570896871546],
            [5.875184804487478, -1.7271852953433136],
            [5.86950053119358, -1.718336202940882],
            [5.867658552097986, -1.7127560174949743],
            [5.867913132525856, -1.709055810610147],
            [5.866592293946043, -1.6941619142465623],
            [5.866940468651763, -1.6908808931040578],
            [5.870305333594023, -1.6853573110825946],
            [5.875308562547361, -1.68224212051069],
            [5.881140905296546, -1.6818463176852454],
            [5.885549691669293, -1.6773849864315256],
            [5.897783236349084, -1.6757437122102072],
            [5.9018107549988414, -1.6652447780225241],
            [5.904886368518654, -1.6502123500571766],
            [5.910988913801707, -1.634305387345951],
            [5.915067420088826, -1.600909586492689],
            [5.92011818968082, -1.576320849335558]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.97096542994267, "lat": 36.85328589831182 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21039"],
        "coty_name": ["Carlisle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carlisle County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00516866"
      },
      "bbox": [
        5.866592293946043, -1.746753279536881, 6.160127611704786,
        -1.5494764179565452
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.793948737345248, 0.38200671469237407],
            [9.853210161122105, 0.3530184495952745],
            [9.927833637381186, 0.3991986476483957],
            [9.935836391127921, 0.40191171495135236],
            [9.952793073779542, 0.41438006660315946],
            [10.01138738731449, 0.4438071551910188],
            [10.016248219798907, 0.4367594838804491],
            [10.018804522663824, 0.4411052226068094],
            [10.02204854877881, 0.4417528192347608],
            [10.024373419450331, 0.4371262732988887],
            [10.025199036909921, 0.43090421509631854],
            [10.023198692724339, 0.42678784558878535],
            [10.027372167851935, 0.423756706490712],
            [10.033940976057075, 0.42527094931960596],
            [10.039708601472817, 0.42389341530335584],
            [10.040961164128854, 0.4273653979567134],
            [10.043852807914368, 0.4274869989990905],
            [10.043003157146252, 0.42205849337257284],
            [10.048334077667327, 0.4226132503440677],
            [10.04624655599033, 0.41861299698128307],
            [10.053435684349687, 0.412298252967671],
            [10.05783998357575, 0.4053066205638904],
            [10.058639353844324, 0.4010955060760492],
            [10.062867774074324, 0.3955627424654246],
            [10.065515301061344, 0.38857886246330514],
            [10.07034143887717, 0.3820891326397074],
            [10.069099230126058, 0.38013846928261236],
            [10.070852481776482, 0.3724596369822866],
            [10.07351299448778, 0.3694250713223928],
            [10.069181312923284, 0.3629374735888928],
            [10.069059054985974, 0.356723127759698],
            [10.072136558246969, 0.35480446555830136],
            [10.083687405409389, 0.35278741053441437],
            [10.094104571603392, 0.34726576221764277],
            [10.102336347088874, 0.34700711017307934],
            [10.10671834325282, 0.3451547487441759],
            [10.111802107526227, 0.3482291450475534],
            [10.113710375361826, 0.3474981109187362],
            [10.11314652807977, 0.3419857615838473],
            [10.11773946522595, 0.3389263249368214],
            [10.121265727862976, 0.34178250284392897],
            [10.123555853202344, 0.34580578187587824],
            [10.129821433942224, 0.34368513437060627],
            [10.138880143792639, 0.3347097422419739],
            [10.14721722238029, 0.3391451200529321],
            [10.154288468505277, 0.3364516191291702],
            [10.15940422525107, 0.33240339015601217],
            [10.162801785702378, 0.3349380394124806],
            [10.164219138521108, 0.32918136197023706],
            [10.170495885126789, 0.3251726538914185],
            [10.17036808611837, 0.3207195380799422],
            [10.175649992467804, 0.31921535790678096],
            [10.17566287670968, 0.31491329650733],
            [10.173448073257811, 0.3117222419835042],
            [10.168691948264522, 0.30943171409552445],
            [10.168781622381054, 0.3038441934903192],
            [10.174241158356025, 0.2988968851378646],
            [10.165819994660485, 0.2908336341928643],
            [10.160153976582345, 0.2941967347125801],
            [10.156157770659474, 0.2941357960452903],
            [10.151957485772648, 0.2853879074418283],
            [10.144225907428416, 0.2819984844576821],
            [10.145451005224615, 0.27733347072001585],
            [10.14347972407174, 0.2749000622916033],
            [10.148187297334463, 0.2726585817365395],
            [10.14954621105387, 0.2690329406237022],
            [10.147256611380573, 0.2666469569887558],
            [10.153483617994633, 0.26271114364993403],
            [10.156128126728888, 0.2582565024371936],
            [10.150556821808062, 0.2573224412495773],
            [10.150798442566112, 0.2551175755838245],
            [10.146914718881753, 0.24818357388394452],
            [10.145477489403877, 0.23668921446780186],
            [10.14763216961637, 0.23034821590051768],
            [10.146815527707522, 0.2260955882744425],
            [10.140244364059296, 0.22311042436994202],
            [10.142650443562802, 0.21584300550901267],
            [10.147621472919829, 0.20483520641630318],
            [10.142126290206544, 0.19682410070450262],
            [10.138754464920595, 0.19812660815876623],
            [10.13696954228871, 0.190154879446523],
            [10.139526601992578, 0.18781367272912494],
            [10.13718694411773, 0.18474748228295704],
            [10.129560058218003, 0.18311560952451747],
            [10.126843517391489, 0.17330824179772933],
            [10.123390373507945, 0.17259938955462906],
            [10.115080210164008, 0.16400613213833581],
            [10.1131530200943, 0.15735810331104558],
            [10.11413604202053, 0.14719635440918014],
            [10.111614481640864, 0.14248789806492182],
            [10.102123954193829, 0.1383267233895811],
            [10.09808454044778, 0.14240145675080076],
            [10.094070940375511, 0.14188636946113833],
            [10.09427532769105, 0.1384544369566097],
            [10.091121645676372, 0.13338479873950476],
            [10.087684698551412, 0.13217994810201014],
            [10.085449680710905, 0.12567194138049742],
            [10.078683879462295, 0.1228321624831979],
            [10.076092679467852, 0.12399673279318751],
            [10.075594914258318, 0.11406270597639875],
            [10.07271615494519, 0.11290333331408636],
            [10.068717177609873, 0.11447140897092434],
            [10.065700581761726, 0.11112704592177376],
            [10.061774218580599, 0.11152362005917048],
            [10.060760761826607, 0.10619705360614373],
            [10.059148916950798, 0.09656072176368576],
            [10.054167998802667, 0.08846789958190451],
            [10.05109580039388, 0.09353215507728527],
            [10.050303083836203, 0.09936992470970234],
            [10.045198081401296, 0.10992873914447195],
            [10.040894204343793, 0.117366087196863],
            [10.034459319941817, 0.11704341700459027],
            [10.030786673376884, 0.11240318917565598],
            [10.024628444311299, 0.1198957373190205],
            [10.021435132385664, 0.12665278918216347],
            [10.018213973201357, 0.12771370948281607],
            [10.016137176260516, 0.12434534368763234],
            [10.012206762608512, 0.12212165561845635],
            [10.017814089023664, 0.1118151154806551],
            [10.011235798785957, 0.11052573951731622],
            [10.008794439907403, 0.11337092743969254],
            [10.007150895100393, 0.11933117470019068],
            [10.010026049113034, 0.12528685163278025],
            [10.008337216846018, 0.12933993923331763],
            [10.008710852098686, 0.13966863437992744],
            [10.011188453898935, 0.14217351881858925],
            [10.011388819530488, 0.14748376607070324],
            [10.006821996579456, 0.15628019231005136],
            [10.008539484086722, 0.16014231647251054],
            [10.014212718528846, 0.16583860076183987],
            [10.011036975901725, 0.17405833348391112],
            [10.007464464900982, 0.17320909371527918],
            [10.007446787870707, 0.16354688676405524],
            [10.003539967555746, 0.1583387165252015],
            [9.997066706521519, 0.1550749823973798],
            [9.989029317723714, 0.1624433302534232],
            [9.991034086847545, 0.1677434729754103],
            [9.995553700771522, 0.17019362508236488],
            [9.996560697096724, 0.17441211198915466],
            [9.991905084946486, 0.17934216828087876],
            [9.981578583689467, 0.17882399440803304],
            [9.979164705923672, 0.1778089146932509],
            [9.976448373123391, 0.17173047694287416],
            [9.97147015601789, 0.17375029837986544],
            [9.970760990699409, 0.17657563399983225],
            [9.971607333217943, 0.1875687032381995],
            [9.973330507320556, 0.19248962285170815],
            [9.977737466516803, 0.1930984177965932],
            [9.979703484910726, 0.19543919234193866],
            [9.978548357949116, 0.20041011105987358],
            [9.975012518016783, 0.20306179790148293],
            [9.969617487802047, 0.20235338036361986],
            [9.967130228488706, 0.199958506832431],
            [9.96676490932602, 0.19550000600526182],
            [9.964099648891949, 0.19257713344071858],
            [9.953982261888038, 0.19145124824693693],
            [9.951872362556845, 0.19420418029136616],
            [9.951021116514575, 0.19934294005378103],
            [9.94855211730171, 0.2013366579961708],
            [9.944242020257999, 0.1989856587881584],
            [9.940221839097646, 0.19054381229804063],
            [9.937134771470689, 0.19200893779459016],
            [9.93350689807481, 0.19774385199834404],
            [9.931581378022052, 0.1986231481671965],
            [9.923915377725569, 0.19527471402164098],
            [9.922174129368122, 0.1858760744875519],
            [9.920253166972843, 0.1813690923006968],
            [9.911511407737509, 0.18321044983274115],
            [9.908999533832368, 0.18708245536903598],
            [9.907962259510377, 0.19333564804901562],
            [9.902856882659924, 0.19474558157744842],
            [9.90324391922037, 0.1989912386997819],
            [9.901216210556566, 0.20083857615355535],
            [9.891193324956955, 0.20140208015305366],
            [9.887363391417988, 0.20045217271870525],
            [9.882136684374823, 0.19445326201689409],
            [9.881924499783453, 0.1969997696708409],
            [9.88578348458437, 0.20371972222076318],
            [9.886386497612703, 0.2105372348992791],
            [9.890896399948392, 0.2121224220076675],
            [9.888328297110235, 0.21722464714966397],
            [9.883893197550645, 0.21968297644121676],
            [9.880862354650471, 0.2193553118925132],
            [9.878461539351006, 0.22287066101203204],
            [9.882378110942541, 0.23051835582366276],
            [9.883550947290873, 0.23680437943870442],
            [9.87827027141183, 0.23495237043304534],
            [9.876751837325626, 0.2303640426513147],
            [9.870106554097893, 0.23047936673077554],
            [9.86783093554132, 0.24003810904410403],
            [9.868132744680203, 0.2481248618783831],
            [9.864974654730899, 0.2479992269813265],
            [9.86125885315856, 0.24510627053945375],
            [9.858876438977711, 0.24722148495582666],
            [9.85569251570852, 0.25669533851542364],
            [9.854198124642, 0.25728651263818064],
            [9.846574962541462, 0.2541334276683655],
            [9.843857262873726, 0.2449770156060487],
            [9.836330875616513, 0.24089693695472209],
            [9.83485944018706, 0.24681371682229838],
            [9.841023163398614, 0.25259744134054746],
            [9.840843977587603, 0.2569418814173356],
            [9.838391692784553, 0.2580275872613126],
            [9.829754383570455, 0.2582596265077175],
            [9.823693763320332, 0.25533031733239214],
            [9.821796996175905, 0.2510626202700672],
            [9.814793278078955, 0.2737413773692045],
            [9.788399368269221, 0.3105980013091588],
            [9.76244790024165, 0.3242160963529035],
            [9.758435653944334, 0.32985924323675586],
            [9.759679930336885, 0.33783280446686237],
            [9.763504668673455, 0.33992030471157153],
            [9.766886310820322, 0.34958596039240775],
            [9.793948737345248, 0.38200671469237407]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.69664811656872,
          "lat": 38.370153845711094
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21069"],
        "coty_name": ["Fleming"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fleming County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00516881"
      },
      "bbox": [
        9.758435653944334, 0.08846789958190451, 10.17566287670968,
        0.4438071551910188
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.453046199512984, 0.706936765760717],
            [10.459594790724674, 0.7111201489981427],
            [10.467025543169434, 0.7134327495559171],
            [10.476701819868804, 0.7140698521913096],
            [10.487232720676898, 0.7123605646886804],
            [10.492402208288228, 0.7127672291362238],
            [10.500205394258558, 0.7166971205222461],
            [10.506849463476316, 0.7239332781472526],
            [10.517752581814683, 0.7339033097398375],
            [10.531696055795924, 0.742759143737343],
            [10.553363887210926, 0.7523877656471959],
            [10.55725816260551, 0.7524185877606635],
            [10.56531827068792, 0.7488489699017445],
            [10.568962059885534, 0.7450740183764861],
            [10.573273628926541, 0.737620415593471],
            [10.575902017039551, 0.7265700310372571],
            [10.57626974651955, 0.7166314107388342],
            [10.574994308000072, 0.7027946798918814],
            [10.575290409083381, 0.6877492284310125],
            [10.578379304026193, 0.680686079895672],
            [10.583084246273174, 0.6765999521686301],
            [10.58914751741875, 0.668370547927782],
            [10.593372752812394, 0.6598866939368851],
            [10.597737666128738, 0.6459165042526013],
            [10.599191925077669, 0.6326625560657545],
            [10.60163441003286, 0.6207041374675525],
            [10.607363264945286, 0.6047013149347348],
            [10.61180451016016, 0.5959734642501029],
            [10.618922911894645, 0.587782872871284],
            [10.635657299293554, 0.5763984257743373],
            [10.639139471435952, 0.5748611060105717],
            [10.652361935198837, 0.5690257309684503],
            [10.660740729489719, 0.5669021883974132],
            [10.668772990890602, 0.5670800872928001],
            [10.680679721475387, 0.5701509375734358],
            [10.699369151666733, 0.5713373737751698],
            [10.705944308068855, 0.5725393518371995],
            [10.71086529635302, 0.5715343127807087],
            [10.720066606907743, 0.5656336947423624],
            [10.731752370244326, 0.5609485856985071],
            [10.740669766452298, 0.5536233004784803],
            [10.75447407997149, 0.5347515540710854],
            [10.763712326830666, 0.5260958367231856],
            [10.757079417503412, 0.5180039090677904],
            [10.694325882873803, 0.4428955187526491],
            [10.689877242907981, 0.42985855171927856],
            [10.692441421436769, 0.42844351152990695],
            [10.690670976411317, 0.4232392164037397],
            [10.68749463989208, 0.4226405622520121],
            [10.685096940363147, 0.41961321680119523],
            [10.682311601754565, 0.419752660429214],
            [10.681398467583652, 0.40918525417053764],
            [10.672500237598147, 0.4029748300787982],
            [10.668057994484675, 0.3977325025807443],
            [10.669646760321346, 0.3911049113873996],
            [10.664908530720536, 0.38063095218089793],
            [10.665482723629625, 0.377910356049224],
            [10.588765305988494, 0.3927419140308066],
            [10.585378402136532, 0.39031947055035865],
            [10.57638782548131, 0.389020626582459],
            [10.572593031378732, 0.3895149347074153],
            [10.568474040114534, 0.39268838065697115],
            [10.566175279738468, 0.3896008683467159],
            [10.56161802490096, 0.3899505557104776],
            [10.55530635887465, 0.3834160752048492],
            [10.550743804770779, 0.3815384691628214],
            [10.547205205145962, 0.38209086930061426],
            [10.542343259179782, 0.3863364016087839],
            [10.533516895578298, 0.3881224748454711],
            [10.530999246951543, 0.39097518138323106],
            [10.530715983033488, 0.3954017450744967],
            [10.526283301317147, 0.3975279590517167],
            [10.522995332779514, 0.39519358180296577],
            [10.517820084147372, 0.4008283422413523],
            [10.517692571249924, 0.40454341104090513],
            [10.472917976828358, 0.4443460129700802],
            [10.469622680894613, 0.44320640947652096],
            [10.464529504982284, 0.44508411988214047],
            [10.461232987732306, 0.44365630748685536],
            [10.453724830389424, 0.4505404231474148],
            [10.448989560831107, 0.45008425065733776],
            [10.446396530022433, 0.4539051051120074],
            [10.443100899260637, 0.45269630801398253],
            [10.440598548597563, 0.4559997549016291],
            [10.43560321766664, 0.4575369186511216],
            [10.430374459712, 0.45377165284647825],
            [10.422544426132678, 0.45583892447515323],
            [10.420779099762859, 0.4580663867649232],
            [10.416612604806128, 0.45746153911711784],
            [10.410514633056936, 0.4604152876686234],
            [10.405639345483802, 0.46552112847995225],
            [10.401932545196487, 0.4673866966097717],
            [10.39858219453551, 0.4655202449787428],
            [10.39582619378451, 0.4677926898652552],
            [10.38858741014966, 0.4687340572831414],
            [10.38578552933703, 0.47185961955497197],
            [10.379414851811992, 0.4710509425455741],
            [10.378608146103412, 0.47629221334929545],
            [10.382952281227471, 0.4773695856359527],
            [10.385301353527714, 0.48223171944158394],
            [10.39119944544081, 0.49103633639606786],
            [10.391017375486342, 0.4994023305187223],
            [10.397213001930334, 0.5057341878047269],
            [10.39955546477435, 0.5035228608624688],
            [10.40918504143608, 0.5072705073507732],
            [10.413180748299155, 0.5116052907789083],
            [10.413914231649105, 0.5175640256217389],
            [10.417539892546401, 0.5199755928479843],
            [10.41833952754377, 0.5235669419374103],
            [10.421607911295254, 0.5271722794470772],
            [10.423296836710556, 0.5386078565191065],
            [10.42607863655376, 0.5486662367894934],
            [10.42830329405854, 0.5508739203437961],
            [10.432828227317525, 0.5639490800960179],
            [10.438824560811737, 0.5672733391438773],
            [10.440189931658159, 0.5721328783285058],
            [10.433996540868415, 0.5792691759002583],
            [10.434523499644884, 0.5852714774657385],
            [10.430595312622655, 0.5865573191381932],
            [10.432163496067746, 0.594214343399105],
            [10.437816298752296, 0.5980768189056591],
            [10.434755308046658, 0.6047783975156734],
            [10.435562307719385, 0.6110962462224963],
            [10.440314607186398, 0.6149601761922024],
            [10.439973270652034, 0.6174693771916275],
            [10.446714462875262, 0.6184438684455076],
            [10.449777114172312, 0.6281663236719196],
            [10.445062926087756, 0.6360746692101507],
            [10.448745698104062, 0.6434352011687917],
            [10.451452233320955, 0.6420891302422146],
            [10.455624582924003, 0.6458636574875214],
            [10.45712719637834, 0.6602869246667809],
            [10.461881625041615, 0.6615287771268796],
            [10.464130935854685, 0.6648156938614668],
            [10.458140920129264, 0.6660099753340434],
            [10.459589251948149, 0.668958490612975],
            [10.455381382842113, 0.6725205427137818],
            [10.451123249349665, 0.6799821968606365],
            [10.455629539724534, 0.7032540137151359],
            [10.453046199512984, 0.706936765760717]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.92220088712446, "lat": 38.54568294145497 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21089"],
        "coty_name": ["Greenup"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greenup County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00516891"
      },
      "bbox": [
        10.378608146103412, 0.377910356049224, 10.763712326830666,
        0.7524185877606635
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.596022882238713, -1.4857361664554805],
            [6.60911886502741, -1.4748168986272991],
            [6.6190915889933075, -1.4655501628747776],
            [6.616954011466471, -1.4615662617179668],
            [6.60846505397072, -1.4493996628328132],
            [6.602975466160187, -1.4388935339299673],
            [6.60203264519452, -1.4283913586314192],
            [6.6027523058583215, -1.4208884439565808],
            [6.608868979546413, -1.4094213328631913],
            [6.603015988410599, -1.395051713265939],
            [6.595081347832974, -1.384877071502279],
            [6.5937601835750455, -1.380362822803399],
            [6.595968841158782, -1.375587824470429],
            [6.604700899379992, -1.3706454605806622],
            [6.605786798350121, -1.363492891169026],
            [6.603744758817334, -1.354460881940073],
            [6.6052278451171915, -1.3395202641693946],
            [6.606978411669625, -1.3344236954470736],
            [6.619268813643268, -1.3163667642169377],
            [6.620095863841822, -1.319263398402863],
            [6.618094792861379, -1.3261505299994891],
            [6.621397390685254, -1.328969027983068],
            [6.621859965611843, -1.3340277293803724],
            [6.629389268664916, -1.3299394754047287],
            [6.62809195695557, -1.3368245719490006],
            [6.63518933518063, -1.3348072320822315],
            [6.637640109263702, -1.3323341269980968],
            [6.646692215460988, -1.3284769267503391],
            [6.644377153237162, -1.3243259262113227],
            [6.643318076564205, -1.3185385815223278],
            [6.646734612129219, -1.3177153401695643],
            [6.650800226806365, -1.3114606676333165],
            [6.655645788899097, -1.3135119434001479],
            [6.659284265018561, -1.3114228101852328],
            [6.664062547598579, -1.3131175191858502],
            [6.666421978769881, -1.3080071072849715],
            [6.667280896089519, -1.301025567973738],
            [6.670783975396171, -1.305165508139282],
            [6.674647897737171, -1.3049976542823571],
            [6.676139803969945, -1.3019159084867669],
            [6.683662831326264, -1.2982941944850719],
            [6.68531733134687, -1.2917778834952043],
            [6.689686778608691, -1.2881604849362822],
            [6.690378885425398, -1.2844064783932232],
            [6.6888534233038754, -1.2795455860053981],
            [6.693440086426791, -1.2773765889129325],
            [6.7087268018702675, -1.279234318794892],
            [6.716743827389244, -1.2777436157092972],
            [6.735919272007209, -1.2787984209169367],
            [6.763974364399278, -1.325619878733035],
            [6.776909844985654, -1.3467665469390642],
            [6.797908263919864, -1.382359014675568],
            [6.823412516595332, -1.4127306756989133],
            [6.884385671664114, -1.4836697565361774],
            [6.8736020082099225, -1.4845641888578796],
            [6.789503059590613, -1.5423283406977224],
            [6.782076845474359, -1.5458519302130356],
            [6.770596958522195, -1.5499079931167177],
            [6.6985436753161025, -1.58352811758906],
            [6.690226320291186, -1.5879615141281596],
            [6.671034601564275, -1.5957546159433766],
            [6.663269837695323, -1.584007707776602],
            [6.655701222381189, -1.5708068517750344],
            [6.650130629141247, -1.5634085627453684],
            [6.646359875082348, -1.5505144733490932],
            [6.646266447075092, -1.5470687812091535],
            [6.642856970879104, -1.534699657516921],
            [6.640065076158503, -1.529073945346299],
            [6.634368377701486, -1.5221103319727782],
            [6.628401601724234, -1.5163888760134583],
            [6.617567637853168, -1.509059309939],
            [6.609549923771344, -1.502602429701873],
            [6.602400439248525, -1.4947095581218812],
            [6.596022882238713, -1.4857361664554805]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.08319823524039,
          "lat": 37.019037183613634
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21143"],
        "coty_name": ["Lyon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lyon County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00516918"
      },
      "bbox": [
        6.5937601835750455, -1.5957546159433766, 6.884385671664114,
        -1.2773765889129325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.294530759647483, 0.6247524018165571],
            [9.380014691073372, 0.6493743729064015],
            [9.380168119469646, 0.6501214667633637],
            [9.39013149591937, 0.6511184583629445],
            [9.396027607523523, 0.6565441127978332],
            [9.400387042030188, 0.6592620372928993],
            [9.403050196221228, 0.6587284170884049],
            [9.514331867469242, 0.7360733258975569],
            [9.515593781235287, 0.7146066327197532],
            [9.517307073054605, 0.7037249942008093],
            [9.521387749114302, 0.6886994353885894],
            [9.517774342442252, 0.6831194703102498],
            [9.535919702304948, 0.6052654811659709],
            [9.555464123310955, 0.516295799522263],
            [9.567751030268946, 0.46065548306918835],
            [9.571822197429132, 0.46752813393741216],
            [9.577593604270257, 0.4548909344227625],
            [9.57068093707834, 0.45034882587028324],
            [9.571253027698203, 0.4452560879649111],
            [9.502514189261277, 0.4263695025869176],
            [9.424088361381314, 0.40524312813774865],
            [9.420984758528421, 0.40926440014052423],
            [9.414274046514903, 0.40816313012751027],
            [9.413026728325942, 0.40318225995898554],
            [9.405378321748596, 0.3975184681450631],
            [9.409818411787352, 0.39444860236127555],
            [9.404631116951544, 0.3884749926310254],
            [9.409255603703167, 0.3882302092640735],
            [9.405596087179841, 0.38090142411931016],
            [9.401772108179635, 0.38070422240238455],
            [9.40048311316107, 0.37784369292275155],
            [9.390382518711265, 0.3769419036267089],
            [9.387496883627255, 0.37067622709570447],
            [9.383835439820995, 0.3712099014928178],
            [9.381905736651708, 0.375843944229883],
            [9.379388236555515, 0.37358572904784315],
            [9.37366076902236, 0.3760640699149638],
            [9.370876642032473, 0.38183717928476407],
            [9.367870540021192, 0.3801820302777064],
            [9.351124587196784, 0.43326178723153663],
            [9.337066765224591, 0.4794043210979921],
            [9.330979508288644, 0.5000681034866961],
            [9.305470858275694, 0.5878072563130337],
            [9.294530759647483, 0.6247524018165571]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.36026161953076, "lat": 38.69566419110338 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21191"],
        "coty_name": ["Pendleton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pendleton County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "00516942"
      },
      "bbox": [
        9.294530759647483, 0.37067622709570447, 9.577593604270257,
        0.7360733258975569
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.792568194240441, -1.715924159722848],
            [7.7947454394135, -1.6563406880434959],
            [7.794351999577723, -1.6364461965364405],
            [7.800263590346903, -1.6068510497768695],
            [7.815227081540284, -1.5652305173995422],
            [7.823394110659084, -1.5498350663196303],
            [7.830678290973793, -1.514060430747437],
            [7.8417097221090915, -1.5019326524371703],
            [7.85498630865538, -1.4792588132047317],
            [7.872838408876897, -1.470728395008328],
            [7.889238473138248, -1.4689756277017691],
            [7.916816675935544, -1.5197673138684353],
            [7.944883912195877, -1.5209095099553427],
            [8.005114179622405, -1.5242768740912906],
            [8.063334672641645, -1.5284527861669541],
            [8.062349816739646, -1.5600394396643644],
            [8.061956063459219, -1.5896277580318552],
            [8.06354895506215, -1.5962020429974961],
            [8.059741188683802, -1.5993464569098206],
            [8.062390440397708, -1.6017543264203946],
            [8.061335048844882, -1.606617500385329],
            [8.064460926336594, -1.6088442059871462],
            [8.06137440649307, -1.6140122906293675],
            [8.065752221679519, -1.6158729089843111],
            [8.065019724697862, -1.6200176804319577],
            [8.061484717607744, -1.622779370156577],
            [8.065877778690282, -1.625172024176586],
            [8.065828602311564, -1.6314396107972102],
            [8.06313169921467, -1.636028514393494],
            [8.066002849879855, -1.6413726929313217],
            [8.063845466013575, -1.6438042402107593],
            [8.064189070953345, -1.65646480935454],
            [8.061849087545749, -1.659361995901036],
            [8.067701575395068, -1.6646754137708244],
            [8.065397138608146, -1.6720279813115584],
            [8.067716005520523, -1.6763324515833442],
            [8.070686547542557, -1.686589532974843],
            [8.025405357510055, -1.6898951160449942],
            [8.021469157947969, -1.6904633317393674],
            [7.9942910363541335, -1.6924054978905971],
            [7.967014830537305, -1.707210033970697],
            [7.966986117987263, -1.7038114602456274],
            [7.961621600597138, -1.7034064488719018],
            [7.96132714558006, -1.7103643802278667],
            [7.9517867259280095, -1.715810710025047],
            [7.929340074136872, -1.6988411973257278],
            [7.831683301292815, -1.7116623357619491],
            [7.792568194240441, -1.715924159722848]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.58225440098984,
          "lat": 36.741945408733244
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21213"],
        "coty_name": ["Simpson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Simpson County"],
        "coty_fp_code": "213",
        "coty_gnis_code": "00516953"
      },
      "bbox": [
        7.792568194240441, -1.715924159722848, 8.070686547542557,
        -1.4689756277017691
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.68260568885015, -0.1312323363858351],
            [8.683045487868897, -0.1016604000593842],
            [8.75207484777005, -0.12075259723936908],
            [8.803081516614794, -0.1339539263950851],
            [8.837792398268794, -0.14308845517798488],
            [8.945257225323468, -0.18387497967936556],
            [8.9404929454511, -0.19469107249208026],
            [8.937701713695283, -0.19656239608414983],
            [8.932005787489052, -0.19691050915458827],
            [8.93350872085487, -0.2018139727431019],
            [8.927993834724681, -0.20311875353379744],
            [8.931502131399862, -0.21258545930324482],
            [8.927241689546237, -0.22801902179290864],
            [8.920843613094055, -0.22646456758187697],
            [8.914025059499501, -0.22892497451210053],
            [8.908954730620678, -0.2338118398305947],
            [8.90393946464296, -0.23608485696627118],
            [8.900264278485583, -0.22640047930356033],
            [8.89744235230533, -0.2293661887747983],
            [8.897147402169184, -0.23267075436442625],
            [8.900880912775767, -0.23953921561568653],
            [8.899312040566256, -0.24596973427856522],
            [8.901488729433048, -0.2554384988240476],
            [8.797163509760217, -0.2862278183450145],
            [8.74112224850034, -0.30558240419046623],
            [8.725326305092839, -0.3077840411273806],
            [8.717788271167725, -0.3015120194013385],
            [8.713947709209798, -0.29963918105520415],
            [8.70767849915396, -0.2932518153164143],
            [8.70273347698469, -0.29029073428206065],
            [8.691240002660216, -0.2876578628501146],
            [8.690386342473044, -0.28639967898986934],
            [8.672232758805798, -0.2817582484743081],
            [8.650094951852452, -0.264633333254164],
            [8.626332680660482, -0.24632546874226888],
            [8.629999236811893, -0.24428356316460886],
            [8.653798115235555, -0.15696073098776536],
            [8.658760289747097, -0.15675802069469402],
            [8.66656444462853, -0.1493514291059287],
            [8.677314726416963, -0.14853975652681534],
            [8.679375673376082, -0.14443336611206],
            [8.68258497615124, -0.14254584443825122],
            [8.68260568885015, -0.1312323363858351]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.32775464684971, "lat": 38.03253620369151 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21215"],
        "coty_name": ["Spencer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spencer County"],
        "coty_fp_code": "215",
        "coty_gnis_code": "00516954"
      },
      "bbox": [
        8.626332680660482, -0.3077840411273806, 8.945257225323468,
        -0.1016604000593842
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.6943006719984055, -0.6496011995450596],
            [6.70411884623183, -0.64603305924615],
            [6.712408638700895, -0.6471433658243573],
            [6.718547479106555, -0.6491315231039677],
            [6.723482250515587, -0.6523862662134112],
            [6.735520882779716, -0.657494314121808],
            [6.740822643872954, -0.6632757201543538],
            [6.749538805206836, -0.6712856184989213],
            [6.755468113669846, -0.6722834622112754],
            [6.761472917470745, -0.66821254263904],
            [6.76499780245842, -0.655085400101632],
            [6.767704035550446, -0.6508898213677904],
            [6.767228059853423, -0.647491818818104],
            [6.772595664156212, -0.6423419608926852],
            [6.778953320717532, -0.6394928722223135],
            [6.788092378234191, -0.6331436116598592],
            [6.78956468041973, -0.6227436871293803],
            [6.784766535243435, -0.6030374897274713],
            [6.7823177573276725, -0.5973634217061766],
            [6.778188947696016, -0.5914302329761718],
            [6.767740515486988, -0.5831073546656983],
            [6.759998012863342, -0.5744142819402451],
            [6.7553040653394465, -0.5634316256045413],
            [6.755318296103508, -0.5548143151074817],
            [6.756377299908676, -0.5515502475068856],
            [6.764220125655987, -0.5398343748431876],
            [6.85926065643581, -0.6668394338991358],
            [6.863086056706862, -0.666354233542527],
            [6.865876405621348, -0.6633920120313767],
            [6.874794264573469, -0.6609783309782746],
            [6.880816037205966, -0.6630052798778672],
            [6.877244166614633, -0.6686982682173985],
            [6.8760108108422875, -0.6737793392260826],
            [6.88343593534768, -0.6789868537169373],
            [6.885927210877131, -0.6771818812242955],
            [6.892401885988818, -0.6782586315571487],
            [6.892091580925511, -0.6756047202561288],
            [6.888430420047682, -0.6717169071703891],
            [6.892546939849986, -0.666910585453725],
            [6.89621228797959, -0.6653226451153516],
            [6.900040616556665, -0.6686806947933339],
            [6.905206203545441, -0.6706301070981756],
            [6.9027967174194185, -0.6815942487531037],
            [6.913858278569933, -0.6992772586227567],
            [6.912907998670693, -0.7033289877747647],
            [6.9147895763792695, -0.7124333105965165],
            [6.915148626279698, -0.7190834289470271],
            [6.920915594087186, -0.752905626594223],
            [6.918525786129752, -0.7600359952693889],
            [6.922872613831918, -0.7690381958982665],
            [6.928919110642608, -0.7770965782733463],
            [6.934117312261882, -0.7854048420283251],
            [6.937215822719179, -0.7918110160003144],
            [6.913483431869701, -0.8232436501155661],
            [6.88568029022779, -0.8590570852327043],
            [6.846830369519804, -0.9052866478201924],
            [6.805987435696168, -0.9505157566247411],
            [6.7957556981492875, -0.9644434592613861],
            [6.793051049398038, -0.9644505679853168],
            [6.787828576438022, -0.9679525797275355],
            [6.782289738015546, -0.9657276110876454],
            [6.778444382930433, -0.9670510005413269],
            [6.771801443458363, -0.976191577975516],
            [6.7625949569005215, -0.9768454653053875],
            [6.757213681050709, -0.9736336217022141],
            [6.758106073714544, -0.9708679828481596],
            [6.762265022913122, -0.970719865012985],
            [6.769099576512027, -0.9620766464502392],
            [6.768477399941892, -0.9578239571604985],
            [6.764697539835354, -0.9519185213904086],
            [6.763557410534463, -0.9476731732955133],
            [6.759503632743756, -0.9466452886738429],
            [6.757295579062497, -0.953612832071716],
            [6.7513398467424075, -0.9517928447752247],
            [6.748049581311778, -0.9454096197338848],
            [6.743439981537634, -0.9423121595985287],
            [6.74052415458133, -0.9341046152607078],
            [6.740955243263842, -0.9306100051995204],
            [6.73968492153092, -0.9224034012383765],
            [6.739214289564297, -0.9099252700532932],
            [6.737297866555278, -0.9041542792161583],
            [6.734725105633042, -0.902397421231448],
            [6.724986292103244, -0.9023708923006998],
            [6.72171509442468, -0.9057538552759826],
            [6.7199118302546745, -0.9122768393496516],
            [6.723053108966073, -0.9178873453131754],
            [6.72265630153608, -0.9215065948946569],
            [6.716343758709052, -0.930163556552352],
            [6.716100623876219, -0.9341538151939656],
            [6.7137195321285255, -0.9373834073336896],
            [6.7102157092620915, -0.9380130162756598],
            [6.706663044565294, -0.9341539600758647],
            [6.702838809893143, -0.9335648796457682],
            [6.699683641454918, -0.9449716144292396],
            [6.693093297756991, -0.9475120229602856],
            [6.691687561565606, -0.9447820765623457],
            [6.690666639677592, -0.9371348148720742],
            [6.685396361395257, -0.9279078074969186],
            [6.682576182578709, -0.9245680450423311],
            [6.677764578066598, -0.9217248699854718],
            [6.669676443945786, -0.919264261854644],
            [6.66556882247064, -0.9150343631006476],
            [6.656291829979532, -0.9013209338494518],
            [6.639512495994929, -0.8871034142558771],
            [6.630198018507552, -0.8825158756022808],
            [6.624229773008484, -0.8722904784990639],
            [6.6223768062809345, -0.8651341086527785],
            [6.622005745068072, -0.8546148460449728],
            [6.611784670619886, -0.8352162480461296],
            [6.60772143797398, -0.8254471443747773],
            [6.605917561341001, -0.8183552774119961],
            [6.604948320154998, -0.8091660237827737],
            [6.603032688922826, -0.8007175906862916],
            [6.604001292794047, -0.7935960186880456],
            [6.60824775979028, -0.7825497104207721],
            [6.612475567865396, -0.7746089496828577],
            [6.620442078432018, -0.7649231734199518],
            [6.6214866219254915, -0.7591180368546031],
            [6.626361522425347, -0.7486300042103743],
            [6.631547288580234, -0.7426376530706201],
            [6.643549382196316, -0.7361139508085062],
            [6.647865935686366, -0.7305168831148713],
            [6.658060683192248, -0.722387231071564],
            [6.665143393086063, -0.7188600826239555],
            [6.671510058842154, -0.7128974491641139],
            [6.674464667629185, -0.7086345009336472],
            [6.681024133066824, -0.6964625405280545],
            [6.6856495509121, -0.6828591787022412],
            [6.686579180181391, -0.6777531547036341],
            [6.687187476707629, -0.6653144215500857],
            [6.688838719189655, -0.6574644677711436],
            [6.691105719904548, -0.6527708560129695],
            [6.6943006719984055, -0.6496011995450596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.94536005932872,
          "lat": 37.658447669702696
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21225"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "225",
        "coty_gnis_code": "00516959"
      },
      "bbox": [
        6.603032688922826, -0.9768454653053875, 6.937215822719179,
        -0.5398343748431876
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.25665021230214, -6.877704159160526],
            [2.2571239538322625, -6.877040604904115],
            [2.2827867855410577, -6.876364133275932],
            [2.359064532946884, -6.873913432016493],
            [2.3686912947716934, -6.873808119920918],
            [2.437932698871026, -6.871596966236437],
            [2.505427258742927, -6.869616017195683],
            [2.512649083742593, -6.869765718024549],
            [2.578582221682296, -6.868212182585552],
            [2.5789805350905177, -6.868463168299213],
            [2.627279393473894, -6.867047595140133],
            [2.6292379217094295, -6.923084762723],
            [2.6295920194952793, -6.950366547761409],
            [2.6302607855578986, -6.96855455941847],
            [2.6303761274710435, -6.9973816894469785],
            [2.6519544601783793, -6.997000621405659],
            [2.717806651398883, -6.995277313400292],
            [2.719489547322725, -7.045413452709631],
            [2.7199932901563786, -7.069928968976887],
            [2.7223937152300617, -7.127213296193556],
            [2.7234415010580064, -7.170508938409693],
            [2.727913955955463, -7.170499085701904],
            [2.8090461755772345, -7.168493584153669],
            [2.811757775323289, -7.252064806923046],
            [2.814198251525087, -7.341069766103416],
            [2.771227898252666, -7.342691263416407],
            [2.683378039461303, -7.34508067213587],
            [2.641468500161499, -7.433264308589286],
            [2.5651084274283105, -7.434907117503249],
            [2.5624221452610545, -7.435648191860563],
            [2.563068653940133, -7.441375342519607],
            [2.562133717040803, -7.444686321540415],
            [2.5632814049128987, -7.451395778423903],
            [2.559528478273719, -7.454710343453539],
            [2.5626390895836093, -7.4592211112184685],
            [2.556165180301548, -7.464221773477508],
            [2.554778671120282, -7.468835860132534],
            [2.5491724549552974, -7.47408324447137],
            [2.5511122367978665, -7.482405063460118],
            [2.5554772845964053, -7.482170945908054],
            [2.5562447599973943, -7.488788685646151],
            [2.551436038943319, -7.493086782015161],
            [2.552618629185804, -7.495189312015736],
            [2.552335121153016, -7.502217746230917],
            [2.5567239822381644, -7.5090706671547816],
            [2.5543877241582487, -7.514348082632066],
            [2.552038024812787, -7.514235024341517],
            [2.550188033555127, -7.526330085883241],
            [2.543106458977948, -7.529618343085956],
            [2.535885184376101, -7.534685557861763],
            [2.527917273775688, -7.544988756753795],
            [2.5200460627238925, -7.547018966811365],
            [2.50971404749089, -7.536753952717305],
            [2.507732589434949, -7.530452124298884],
            [2.5082864314398168, -7.5259753636888105],
            [2.5078054488128134, -7.513680897159478],
            [2.503025491246814, -7.507819540588185],
            [2.506085023519293, -7.502498568453181],
            [2.5062660395204905, -7.496141732118231],
            [2.5126078883911562, -7.493197285471016],
            [2.5095317063673046, -7.488968055112812],
            [2.5114022563660408, -7.485135267531739],
            [2.509955277452239, -7.482075292710116],
            [2.5012114692571648, -7.485362301113301],
            [2.4994391266327076, -7.481288134736575],
            [2.492983850405342, -7.480500324454462],
            [2.494618268508484, -7.476037682544614],
            [2.4943531957569016, -7.469030406410552],
            [2.49005822953958, -7.4641137314039145],
            [2.495896411081875, -7.46198888209836],
            [2.4948091417990605, -7.457547811409677],
            [2.4953920127943134, -7.452230965015781],
            [2.491718027278379, -7.449975214136516],
            [2.4902525754704263, -7.442824795238569],
            [2.4880980721613635, -7.441849002525389],
            [2.474705400622339, -7.444527300672447],
            [2.470040282178394, -7.442764775677437],
            [2.4669779000050522, -7.432747306921484],
            [2.4639024655959836, -7.430240533757178],
            [2.4563331845922587, -7.432773016001224],
            [2.4495374759717436, -7.417914913369588],
            [2.4426048523393837, -7.414115247977896],
            [2.4352682226061657, -7.413565164583956],
            [2.4327673010816766, -7.410245747006445],
            [2.431826922440399, -7.405620239704011],
            [2.43731003455432, -7.395243259629052],
            [2.4423010738724438, -7.393206781548354],
            [2.4432520228442147, -7.389064838602324],
            [2.4403192597038426, -7.384857746220422],
            [2.4473053120131536, -7.375606667845573],
            [2.4464016838213882, -7.364709779524749],
            [2.4472840174600217, -7.362256743411531],
            [2.4656926633435314, -7.3562474215773275],
            [2.4669898447618954, -7.351863028578519],
            [2.4716433837984675, -7.343215503070819],
            [2.463531206951712, -7.344348058289459],
            [2.4570005054090176, -7.347732465118073],
            [2.4455522640253387, -7.34966467569983],
            [2.4426930195603718, -7.346628286968842],
            [2.446334426071682, -7.34272086810859],
            [2.4445616894511124, -7.326663168440485],
            [2.4413573836760496, -7.317918395879724],
            [2.435195498884284, -7.317706241317046],
            [2.429268697623481, -7.3111588643988386],
            [2.4225836467587034, -7.306708698832049],
            [2.417701935813656, -7.306883726396178],
            [2.414886709475132, -7.305410480945193],
            [2.4148631707035775, -7.297424360982877],
            [2.420644839534463, -7.287814600916203],
            [2.424720526969669, -7.277963255354259],
            [2.424525323567805, -7.275615237749447],
            [2.4133114377304654, -7.276119631160011],
            [2.4103926381223992, -7.271491969004212],
            [2.4144312142472724, -7.263489203329449],
            [2.4146081400017843, -7.260981697746529],
            [2.4101655620893725, -7.259839906885188],
            [2.4070698031570212, -7.262740893376972],
            [2.4028462570581266, -7.259656009395811],
            [2.3992302319639247, -7.2633380920123525],
            [2.3911324703654033, -7.259567670092109],
            [2.382159205555235, -7.2514319818199695],
            [2.3756066954649913, -7.248761062300571],
            [2.3763122696925434, -7.242649839808809],
            [2.378843290962305, -7.239290889279373],
            [2.375546282174459, -7.2327774317773805],
            [2.3788757118307755, -7.231800521044983],
            [2.381700145151886, -7.233829066342894],
            [2.387551094751711, -7.230223015510127],
            [2.393713220740863, -7.228198133087697],
            [2.3964368755444223, -7.224843810655005],
            [2.3970350616548184, -7.221117466814475],
            [2.400558009082745, -7.212999482229923],
            [2.4068162307375855, -7.2067417018774265],
            [2.405100425937921, -7.202083878804143],
            [2.395504280570502, -7.202782680141256],
            [2.3881668755111303, -7.204098465220082],
            [2.379217637163638, -7.201069606197107],
            [2.3819927603426376, -7.198957658570864],
            [2.3799199513623255, -7.190707646141319],
            [2.373642179655709, -7.188168052228988],
            [2.369718834569399, -7.187951233449686],
            [2.3653083619917967, -7.193965125201176],
            [2.347642582335141, -7.192930593502374],
            [2.341781005375737, -7.191113275704128],
            [2.3394848818184215, -7.1877496395975395],
            [2.332798156924565, -7.184644388155112],
            [2.331082714276658, -7.176885767393633],
            [2.323840654484938, -7.172554828488793],
            [2.32210937514365, -7.169111785710738],
            [2.318934688217441, -7.168508700204472],
            [2.3129959986765796, -7.161005969136058],
            [2.3161037017940442, -7.15752115993902],
            [2.3121912641045754, -7.155568378667852],
            [2.3115250141562664, -7.150463351887447],
            [2.314679664515795, -7.148289839037618],
            [2.3071129751077097, -7.140953742662893],
            [2.3043675243614743, -7.1401409898902495],
            [2.300342029273213, -7.1333994511307734],
            [2.296266559072017, -7.120670847725026],
            [2.2972146925808596, -7.1129551629526615],
            [2.3035140590220684, -7.106035148054946],
            [2.3070059823499633, -7.104652256174839],
            [2.312711259254516, -7.10530198605145],
            [2.313328099027991, -7.1028140723924],
            [2.3095726424155107, -7.098763076849209],
            [2.3148442723361584, -7.096892778675539],
            [2.3114942243204655, -7.089787399688795],
            [2.3153674070560597, -7.087142404973655],
            [2.31324268989097, -7.071627508095151],
            [2.3113761699464455, -7.065381823815237],
            [2.3064798445492802, -7.058692402823522],
            [2.3056657006531904, -7.052832118281122],
            [2.3092408882614293, -7.0457244902359735],
            [2.3152050705588763, -7.051582201576268],
            [2.3175556950720515, -7.047375297977971],
            [2.316069779754682, -7.04364774114742],
            [2.3238566767167073, -7.033729099513685],
            [2.3318865959756154, -7.017181284906017],
            [2.3292031641778985, -7.013777240949238],
            [2.321284021052359, -7.016689987223533],
            [2.3178136694020677, -7.015903948429833],
            [2.3174253047185474, -7.01238618454945],
            [2.312786958047842, -7.010949594162291],
            [2.3163885981290075, -7.004439112481784],
            [2.315314740782217, -6.99382228577333],
            [2.3124056814240026, -6.988950748729028],
            [2.307775712186697, -6.987410871273578],
            [2.3042850687879137, -6.983257177109902],
            [2.3009126282260954, -6.975574465760368],
            [2.29563127824065, -6.971696146234195],
            [2.2955611951724064, -6.9686412067164305],
            [2.300253604072203, -6.9643016817843595],
            [2.3037208188500475, -6.9577447564016115],
            [2.3014125599517596, -6.954503091538024],
            [2.3043649067155014, -6.952701773898169],
            [2.3057357257971725, -6.944962348168276],
            [2.296065974604185, -6.936992425315937],
            [2.29406456562992, -6.93162693726535],
            [2.294994664268757, -6.925865923867308],
            [2.291705944077884, -6.920114327917014],
            [2.285877419539716, -6.918559031375731],
            [2.281442755968925, -6.920524869512927],
            [2.2797073513239323, -6.915260470276802],
            [2.2746124560950722, -6.911735885576539],
            [2.2727914490490964, -6.908602681215613],
            [2.2646267026092177, -6.904256176665907],
            [2.2612674484403703, -6.899518955838924],
            [2.2617715664185716, -6.895832966192423],
            [2.2590254608950695, -6.88907186830856],
            [2.262314563089666, -6.884529863703312],
            [2.2607902542649523, -6.8806263580704075],
            [2.25665021230214, -6.877704159160526]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.55456518117785,
          "lat": 31.563958289145546
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22085"],
        "coty_name": ["Sabine"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Sabine Parish"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00559489"
      },
      "bbox": [
        2.25665021230214, -7.547018966811365, 2.814198251525087,
        -6.867047595140133
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.356326664592505, 10.34644228013212],
            [18.421476321960714, 10.364596594415579],
            [18.5018693853251, 10.38667330641057],
            [18.58226792181583, 10.408728575601504],
            [18.67489867840295, 10.435174853225307],
            [18.767537253324768, 10.461592479050942],
            [18.860183584061936, 10.487981436565228],
            [18.952837608063103, 10.514341709414118],
            [19.002309503745987, 10.348033920259352],
            [19.00387869667693, 10.348465301761783],
            [19.05398814423159, 10.177773650096803],
            [19.066539257453407, 10.132331540096937],
            [19.199003727910256, 9.676339972518877],
            [19.11690318624081, 9.62937039436882],
            [19.129082118262687, 9.608484280964511],
            [19.132534495619105, 9.595730413308603],
            [19.14419321955126, 9.55504737947367],
            [19.155085362880264, 9.486482453691867],
            [19.212301794826445, 9.5155115503662],
            [19.223076167085598, 9.521477289409008],
            [19.264547847608394, 9.446241653478209],
            [19.316927984482607, 9.344907849092168],
            [19.358788591696705, 9.26563415544995],
            [19.292327416983664, 9.230529347195981],
            [19.301970084361564, 9.212455429924201],
            [19.331929165477213, 9.157401379296902],
            [19.24656536864621, 9.11443875442968],
            [19.160946350890868, 9.069124099727238],
            [19.092580205611863, 9.034342719692598],
            [19.013426750602694, 8.994596228601534],
            [18.92108747021422, 8.94815073515074],
            [18.928781724801354, 8.933428162417057],
            [18.91374640402376, 8.92600439981625],
            [18.918290894302267, 8.917797970738796],
            [18.850667063409325, 8.884232022065351],
            [18.80906428511412, 8.965459874303273],
            [18.803326094612, 8.96247543931262],
            [18.75834405829199, 9.047368854181327],
            [18.751827343723985, 9.059253630629868],
            [18.752977659120518, 9.063864871655953],
            [18.722564147576687, 9.117671617838237],
            [18.71468890683927, 9.13422566836725],
            [18.719726901793425, 9.136774874662558],
            [18.676580032223313, 9.213714740643177],
            [18.656042605664382, 9.25160504383384],
            [18.597755508032407, 9.35948806217482],
            [18.601485887614505, 9.363414467950612],
            [18.599053822102377, 9.366638419407066],
            [18.598481904360447, 9.371058676208673],
            [18.60858242017447, 9.374655488876163],
            [18.61656617737247, 9.383505392369885],
            [18.61685390839823, 9.385282782868735],
            [18.623875032130304, 9.391660124277516],
            [18.625161984885004, 9.395405900180318],
            [18.624481688124657, 9.403984838690453],
            [18.625268296406382, 9.407330033587028],
            [18.62972779486519, 9.413326520351744],
            [18.629485361414613, 9.419214271632876],
            [18.62139193761022, 9.4270146204287],
            [18.620292209223628, 9.432524427087266],
            [18.621072390622825, 9.437089323238272],
            [18.62399568460604, 9.43979914344886],
            [18.628352487898447, 9.447771679320999],
            [18.627299987096507, 9.454853289542026],
            [18.622314985197857, 9.4586908509137],
            [18.620192266639666, 9.4629230943028],
            [18.61292804578284, 9.463150266769695],
            [18.612088409886155, 9.471463090823072],
            [18.615602016227488, 9.474089762685786],
            [18.62039211937394, 9.470240956479104],
            [18.62301708852661, 9.471075619596922],
            [18.62843974390689, 9.468436457999742],
            [18.62922307891329, 9.473037788374784],
            [18.62066954513953, 9.477656166457894],
            [18.611953938427753, 9.47912746023797],
            [18.604459596656522, 9.478857993720831],
            [18.59939218057626, 9.475837228133233],
            [18.59821014458514, 9.47069087987903],
            [18.591732890573102, 9.47095148470894],
            [18.593798305295604, 9.475554505975486],
            [18.588633541891152, 9.48094844361358],
            [18.59107248160632, 9.485428173971973],
            [18.588520659269268, 9.496581566740545],
            [18.581156642793488, 9.496741827966252],
            [18.577495936194836, 9.493888556824249],
            [18.573044418406575, 9.495798261501358],
            [18.569780744410505, 9.494941688770455],
            [18.5635070489641, 9.496444258299606],
            [18.55332328943808, 9.50083173925991],
            [18.551070318787016, 9.507303328976835],
            [18.548332279884068, 9.50858179003255],
            [18.545190522237064, 9.516552592263642],
            [18.538899262566368, 9.519413790592525],
            [18.53391771591898, 9.519505301990444],
            [18.532164541130697, 9.522950579898517],
            [18.533148879558844, 9.52693807244732],
            [18.539897114818647, 9.530788380393746],
            [18.532374951943495, 9.536328439290873],
            [18.52698533164146, 9.53445343847808],
            [18.513828255781068, 9.540431971370118],
            [18.517298009815292, 9.546004392960144],
            [18.521991863972474, 9.546970967446207],
            [18.526091856077795, 9.550737072482582],
            [18.530062606511382, 9.549493286223749],
            [18.535718998012378, 9.551562062382303],
            [18.532670276517464, 9.556594965961832],
            [18.529286543096408, 9.564566525659615],
            [18.529609915102654, 9.571237260814105],
            [18.534527912267368, 9.574301487892571],
            [18.5279291266096, 9.58210904120861],
            [18.533695906421823, 9.580105871415862],
            [18.538724872370228, 9.573710703807544],
            [18.545909970027996, 9.568969287940549],
            [18.551795525379603, 9.571543220342605],
            [18.55527863686353, 9.571626448524423],
            [18.55753660381179, 9.574402037007106],
            [18.569119178836463, 9.568623031603444],
            [18.57151079807617, 9.570651041298758],
            [18.57396018054068, 9.577820577916972],
            [18.574182747783347, 9.58145324760988],
            [18.57165146402448, 9.586704851327923],
            [18.568059852305925, 9.590336524779252],
            [18.562939751962205, 9.592001540484176],
            [18.560786298787306, 9.595102494790975],
            [18.569277348932214, 9.598354892558545],
            [18.570783625868785, 9.60397561819283],
            [18.570016923326214, 9.613151712039178],
            [18.572453680443882, 9.627181610041148],
            [18.568003874027756, 9.634153427506886],
            [18.566852243183522, 9.637631910633244],
            [18.56237360028046, 9.642923303400417],
            [18.56447912815871, 9.646798031129636],
            [18.56587468397138, 9.661447345053663],
            [18.562171552089705, 9.664135314975901],
            [18.562843687948135, 9.668445045467218],
            [18.558673118927874, 9.669787987749213],
            [18.551745483251164, 9.677552003455416],
            [18.547414551765463, 9.67612760295051],
            [18.544445386193747, 9.683969102950423],
            [18.537757724754613, 9.68516050996653],
            [18.55251372849682, 9.698158978337363],
            [18.556793343808373, 9.699716054059065],
            [18.559407747450987, 9.698823530953247],
            [18.560439595620128, 9.694850182287652],
            [18.558216241175955, 9.69243340274024],
            [18.560680890417384, 9.687041996532143],
            [18.568498021610345, 9.68061646210068],
            [18.573476015154252, 9.671609351177139],
            [18.57860964769286, 9.669945266753421],
            [18.583741737616766, 9.673646928006468],
            [18.58318432716932, 9.677826541481584],
            [18.58659565093949, 9.683427640425062],
            [18.594043011074344, 9.683802928839219],
            [18.595230785215545, 9.687730670323262],
            [18.59973945962863, 9.689164335748268],
            [18.542265621614728, 9.795501576073118],
            [18.51397506362863, 9.780680708845864],
            [18.39787439976844, 10.174420639036448],
            [18.406544504337372, 10.17694479028814],
            [18.356326664592505, 10.34644228013212]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.28459648491346, "lat": 45.83736124847841 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23021"],
        "coty_name": ["Piscataquis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Piscataquis County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00581296"
      },
      "bbox": [
        18.356326664592505, 8.884232022065351, 19.358788591696705,
        10.514341709414118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.624621411259715, 1.7326198308623109],
              [15.628022130158636, 1.7485397275952455],
              [15.629587578575615, 1.7501414992619513],
              [15.637086954215356, 1.7460897270287956],
              [15.639016231270872, 1.7532514917482924],
              [15.64491204438091, 1.7550054363044452],
              [15.646685015301454, 1.7696950620018927],
              [15.651246874201009, 1.7713520904821185],
              [15.656464700814652, 1.7751631491935604],
              [15.670571894674646, 1.774695995803396],
              [15.67436452348413, 1.771915212829622],
              [15.676263303173492, 1.7735115907527221],
              [15.677195968418944, 1.7787553844051638],
              [15.683669151803196, 1.778888815965371],
              [15.691510923934276, 1.7820701729120976],
              [15.690493029521877, 1.7899623127875846],
              [15.688230237635727, 1.793593195732721],
              [15.67942857853708, 1.8024182371322934],
              [15.679495476156905, 1.8091270181308006],
              [15.675882362689697, 1.8111560190713365],
              [15.67802782547229, 1.8187113398429355],
              [15.67658410384899, 1.8246495932906068],
              [15.678806992000906, 1.8317468769693896],
              [15.679492950361052, 1.838009315759441],
              [15.68345184217637, 1.844273633920145],
              [15.688152099762537, 1.846141922185235],
              [15.690127891885332, 1.8438360191222227],
              [15.698649669145299, 1.8432610979067794],
              [15.7079040993036, 1.844954993098756],
              [15.77082506443959, 1.8432806774993342],
              [15.78238917111245, 1.8422227389467496],
              [15.78643655618308, 1.8428177674940844],
              [15.80014465655769, 1.8424037048021116],
              [15.802842673140898, 1.8347589440019474],
              [15.807319925573339, 1.8319102008033488],
              [15.803972334408646, 1.829008685764455],
              [15.808290427911617, 1.8226962962849913],
              [15.806627969857704, 1.8159158171776435],
              [15.809699688829516, 1.8152781485610443],
              [15.813976674596935, 1.8105040818726654],
              [15.806365978986909, 1.8087416134850027],
              [15.80659043424752, 1.8044663421106801],
              [15.809017128418008, 1.80313524213393],
              [15.813920314974077, 1.807007695686427],
              [15.81710497847242, 1.8062685046819091],
              [15.816865123822437, 1.802697693217801],
              [15.81301186418059, 1.8005257265247088],
              [15.81497771240198, 1.7962062490517827],
              [15.818664147384833, 1.792933307956594],
              [15.821919683782449, 1.7946141768734862],
              [15.82661349436896, 1.7891947883641492],
              [15.831250808088459, 1.7892626821913709],
              [15.833593943159155, 1.7839807412532582],
              [15.828708810120098, 1.7788951030917497],
              [15.832236095253142, 1.7756936808935622],
              [15.8382634040158, 1.7748985273732503],
              [15.832498833509954, 1.7695880587737027],
              [15.833206586563765, 1.767494791012594],
              [15.84027746320053, 1.765203680820699],
              [15.84356089083691, 1.7655257414931773],
              [15.846392636495034, 1.7606592770672174],
              [15.853519842227564, 1.7589871710181524],
              [15.856228617641351, 1.7559060471679822],
              [15.85335017810018, 1.752008095044573],
              [15.856390672484329, 1.7496246390043706],
              [15.861301574342622, 1.7490764437614248],
              [15.85807611298541, 1.7398394517193276],
              [15.852485514106593, 1.737970299033583],
              [15.841462807619186, 1.728295174536661],
              [15.838673279319163, 1.7245359166645358],
              [15.836910645813122, 1.7149761168944957],
              [15.829636369792924, 1.7043117838620585],
              [15.825984201144744, 1.702577455472893],
              [15.818360185697648, 1.703186057486985],
              [15.815601500077479, 1.7005968506396285],
              [15.81667359423193, 1.6973881495272887],
              [15.814640563620214, 1.6919414878671526],
              [15.809707232740077, 1.6848676940908378],
              [15.800224172614707, 1.6782736958100628],
              [15.79694781534396, 1.6725747506056483],
              [15.797532739606229, 1.6702588126636668],
              [15.803266989713975, 1.6609675032561702],
              [15.803220646810857, 1.6545834759751517],
              [15.800915675376864, 1.6531892719402121],
              [15.793520982452849, 1.6533003238379527],
              [15.791015564016078, 1.649481735709429],
              [15.790596457891942, 1.6446407845968118],
              [15.795398720116598, 1.639259466185231],
              [15.80203348523209, 1.6364471464827959],
              [15.810485212355816, 1.6287750959774143],
              [15.811855837950835, 1.6263668005754546],
              [15.812209690754841, 1.6190689687638962],
              [15.816814075294817, 1.616996335819228],
              [15.824533962208669, 1.6205440444217787],
              [15.82721263908544, 1.6194393856167435],
              [15.832666897285822, 1.6081792436277556],
              [15.836051141177272, 1.6061779745130103],
              [15.851866133581185, 1.6035647236116577],
              [15.85487207612309, 1.6020457338824818],
              [15.852522058027027, 1.599163308398185],
              [15.849312074122695, 1.589868489526476],
              [15.851614078637063, 1.5800687486004559],
              [15.850799843723024, 1.5742605821510363],
              [15.846778000398556, 1.5661745839920165],
              [15.838375462529255, 1.553266240310619],
              [15.836284272629992, 1.547496289811598],
              [15.840589601208507, 1.5372139378061183],
              [15.841305826161634, 1.5299134489823207],
              [15.839076666895771, 1.5191047479909814],
              [15.837139090552114, 1.5135917597937092],
              [15.83140168203987, 1.5105714727890218],
              [15.825893167246123, 1.5052327944878874],
              [15.816864152356219, 1.4904634527904006],
              [15.813380152845728, 1.4881405967961843],
              [15.80910583407871, 1.4964872304767811],
              [15.802584272946, 1.4988366066966692],
              [15.79474995393259, 1.5042621113318089],
              [15.790302781488375, 1.505711470476549],
              [15.787910520390058, 1.5151706823468178],
              [15.783777755562001, 1.5173580303367469],
              [15.779096831957899, 1.5177033487616076],
              [15.77115532888579, 1.520997261299824],
              [15.765207968997265, 1.5215528465337487],
              [15.761286521461763, 1.5298221358680824],
              [15.756642180869694, 1.5313260367712913],
              [15.74849247832735, 1.5285407624713174],
              [15.743845524577383, 1.5256375376505624],
              [15.742200921941773, 1.522317450303653],
              [15.743351109356274, 1.5165166912495889],
              [15.7402450962862, 1.5169201737054383],
              [15.738798959004702, 1.5228417842096424],
              [15.729557829162609, 1.5287364635485512],
              [15.725087332201932, 1.5343012713233524],
              [15.71902233268495, 1.5367513871382952],
              [15.70999073552688, 1.532722773858705],
              [15.704709678469195, 1.5412027837510638],
              [15.69914762294214, 1.552344201108838],
              [15.695223547493146, 1.5559363896996163],
              [15.693048788296764, 1.5551725614860126],
              [15.688743630935965, 1.5601070921761213],
              [15.683194144704595, 1.5622578839027843],
              [15.678976091672169, 1.5665694451690966],
              [15.680360416552139, 1.5728927716056083],
              [15.67982574703355, 1.5785222146218696],
              [15.675516119067101, 1.58335186664947],
              [15.669517620463244, 1.5841887566047095],
              [15.663994261756292, 1.5699103355850488],
              [15.662729736520124, 1.5638997392732346],
              [15.66266022436389, 1.5577187272008663],
              [15.658786316533517, 1.5617738177302065],
              [15.650903167226144, 1.5667051152861287],
              [15.647649759072669, 1.5715157168418257],
              [15.648247004237469, 1.5769485327323336],
              [15.642536320191914, 1.5807420735709101],
              [15.636841361619878, 1.5804468980349309],
              [15.624847256181067, 1.5931376687306311],
              [15.623212353507453, 1.599597044508185],
              [15.624013021451399, 1.6045100210365941],
              [15.627933919614788, 1.6050626764837705],
              [15.629048447772952, 1.607783893135607],
              [15.626178653447246, 1.6127107321330065],
              [15.621919706706962, 1.6135484951747294],
              [15.620248798959267, 1.6170210788328494],
              [15.624790792726943, 1.618169923076928],
              [15.626521104049646, 1.6206393479232006],
              [15.632240615131137, 1.6188815706993218],
              [15.639255518573353, 1.6123294392596004],
              [15.643119316704095, 1.6180228057225046],
              [15.644485340264033, 1.624431902187607],
              [15.637713210674523, 1.6267308508174319],
              [15.627491839508913, 1.633369401927803],
              [15.627704525947832, 1.6399151900703874],
              [15.625597544896392, 1.6423382507942506],
              [15.618572954896724, 1.642290005651244],
              [15.616250083851455, 1.6435206519195014],
              [15.612153760809218, 1.6389289282246913],
              [15.613666275292097, 1.6326512670738222],
              [15.612950722268197, 1.628485729299715],
              [15.605124226907497, 1.6264535071248598],
              [15.604608219497539, 1.6195565096452895],
              [15.607549338377112, 1.6138675163218703],
              [15.60005551731289, 1.603783328348938],
              [15.598587628244484, 1.5995082045956335],
              [15.599914547236029, 1.588266916222887],
              [15.595613400310363, 1.5879051393883445],
              [15.591158060193061, 1.5895060207209155],
              [15.58885679549814, 1.5936737151810367],
              [15.5823224700136, 1.5944034187661376],
              [15.580757047443361, 1.5897154091193115],
              [15.577800759206736, 1.589876725238573],
              [15.579217842938062, 1.5952028401487224],
              [15.576150263480239, 1.5983298174817215],
              [15.578720999195857, 1.6021564053151467],
              [15.577917456154967, 1.6068640027898995],
              [15.571864837987398, 1.6200270622957749],
              [15.568355035481723, 1.6197678705887257],
              [15.560861329520334, 1.6170453780099758],
              [15.561983969196516, 1.6139354433792472],
              [15.554013241659606, 1.6063353660299762],
              [15.55736940429365, 1.6046493407374547],
              [15.562259819281374, 1.6054855956050316],
              [15.565156464217157, 1.598999214743445],
              [15.560507019600317, 1.5964168125831386],
              [15.558821903938512, 1.5850376605172758],
              [15.554619039590925, 1.5787975350732684],
              [15.554802858614456, 1.5683791933587117],
              [15.561719288312277, 1.5603267486747574],
              [15.56682038938399, 1.5568596033391264],
              [15.566645193567396, 1.5509077762039163],
              [15.56788567329843, 1.5469364104520338],
              [15.566124304154965, 1.5448555307733618],
              [15.56037020270309, 1.5443542915857555],
              [15.555802751366235, 1.5406205617052966],
              [15.552124446233496, 1.5427100071788773],
              [15.551908352910372, 1.5456628237483347],
              [15.547676491267369, 1.5554579756418458],
              [15.548995674504246, 1.562350680404368],
              [15.54632182711295, 1.567335384347274],
              [15.546098481409485, 1.57782358780337],
              [15.547434552190163, 1.586600992747977],
              [15.544223802414487, 1.5942234449137835],
              [15.542782690590755, 1.6004339330834203],
              [15.543662961581745, 1.6022604490140766],
              [15.538848482741743, 1.6123588093225065],
              [15.540401866873465, 1.624765373280368],
              [15.545304405291807, 1.6285941344778474],
              [15.544638288855278, 1.6339966359070368],
              [15.53987192775793, 1.6372165063422155],
              [15.542380378279859, 1.6418650391348375],
              [15.547178255208749, 1.641003405186429],
              [15.546748205955407, 1.6452353927091168],
              [15.548712370125552, 1.654384156742664],
              [15.553442864129208, 1.6647505250791483],
              [15.55089132622821, 1.681231436460959],
              [15.553597088554818, 1.6895906842568285],
              [15.553486746621694, 1.693960972347797],
              [15.55618000065635, 1.697779931728258],
              [15.56343667561151, 1.6983085257595665],
              [15.567839537708544, 1.7037294367493117],
              [15.569521589891643, 1.707991257800868],
              [15.566445080684097, 1.7098831330251256],
              [15.57469368760888, 1.7269786140489973],
              [15.583019160037015, 1.7388812660218063],
              [15.585165122186766, 1.7340990449163465],
              [15.581907181783054, 1.7327143067338517],
              [15.57782268599515, 1.7267515748502569],
              [15.576337924761724, 1.7218213372956555],
              [15.58203004737231, 1.7184902280557994],
              [15.584646610792252, 1.7154428175868726],
              [15.58739276213288, 1.7090376040331383],
              [15.591803549530603, 1.7071790732555645],
              [15.592592525935386, 1.7024779600963773],
              [15.596641261794181, 1.700024477751146],
              [15.600525822590653, 1.6958129523626493],
              [15.602000500273995, 1.6989521905712284],
              [15.609288440647925, 1.701804519897175],
              [15.613431570201861, 1.6980235500637932],
              [15.626059452791289, 1.6889742103036298],
              [15.622423778268852, 1.6826651249476843],
              [15.626038637808211, 1.6779827857558762],
              [15.624478978952844, 1.6724937004481715],
              [15.62630297157378, 1.6696304213796271],
              [15.634452550082965, 1.6652352438530753],
              [15.639170551434015, 1.6615485326346684],
              [15.64492617057102, 1.6596111839155105],
              [15.646880073539663, 1.656582707039603],
              [15.652282236034685, 1.655431467239829],
              [15.656536025460962, 1.6504032059362235],
              [15.658646766205017, 1.6453055397338032],
              [15.667847887398318, 1.6443831246820206],
              [15.670502299803797, 1.6500125731764823],
              [15.671111422224186, 1.6586498445618567],
              [15.675262603094241, 1.6616324715647375],
              [15.675443310710543, 1.6652074067626546],
              [15.671200145581816, 1.667081001059298],
              [15.667585199138692, 1.6655511947640154],
              [15.664051631091516, 1.6609799281293298],
              [15.655712725322651, 1.665809972719983],
              [15.656053794360522, 1.6695145242088039],
              [15.652630767653447, 1.6732822323741094],
              [15.649148052812865, 1.673787798341792],
              [15.646543278561746, 1.6794483927498436],
              [15.642679520606757, 1.6826444985336075],
              [15.638227506265059, 1.684188631958829],
              [15.635106135936448, 1.6883052588894025],
              [15.63552972740539, 1.6938404527160846],
              [15.633928852498254, 1.6974190472842954],
              [15.636336216259767, 1.7079443852782044],
              [15.6364578791467, 1.716091687333015],
              [15.631985491542853, 1.7211593527723013],
              [15.628529844575013, 1.7289115189698363],
              [15.624621411259715, 1.7326198308623109]
            ]
          ],
          [
            [
              [15.498866997750618, 1.6217879855407122],
              [15.504204813012262, 1.637259228301425],
              [15.507172906053222, 1.640331784490375],
              [15.512034355444435, 1.6372868429303273],
              [15.511132466844717, 1.632368787737036],
              [15.514008129941299, 1.6242984222051342],
              [15.521360811895583, 1.6141566817380897],
              [15.52367524260709, 1.6066978135023735],
              [15.513804421544279, 1.6006973046120117],
              [15.50851699226625, 1.6023428372265314],
              [15.50700639782548, 1.6068723599358794],
              [15.501045980663008, 1.6126775240514981],
              [15.498866997750618, 1.6217879855407122]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.09711852178198, "lat": 38.77131431391017 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24041"],
        "coty_name": ["Talbot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Talbot County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00592947"
      },
      "bbox": [
        15.498866997750618, 1.4881405967961843, 15.861301574342622,
        1.846141922185235
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.459848699200783, 7.083773671887839],
            [2.5103136849017904, 7.085638543795816],
            [2.515125754808704, 7.085525055149197],
            [2.5435180068608014, 7.08639817724628],
            [2.586534007242439, 7.08732037888166],
            [2.660407026454902, 7.089444597091974],
            [2.6644245807823257, 7.0883026430464104],
            [2.6633924073608406, 7.0839274642638355],
            [2.6550422325229497, 7.081534758208743],
            [2.650591466555562, 7.0767520122083925],
            [2.6510061052373795, 7.071233329994311],
            [2.6493738226300003, 7.05905415016959],
            [2.6506115414123994, 7.0561004986511335],
            [2.6471340266802144, 7.048302459446795],
            [2.6466046600357913, 7.034663266378692],
            [2.645496402283644, 7.025016292111781],
            [2.6432014269749446, 7.018852002649541],
            [2.641400776183966, 7.005438521538144],
            [2.6405141140408395, 7.003554383106797],
            [2.6400798319832917, 6.998435872468748],
            [2.641033634501049, 6.99290472205617],
            [2.6402983235466184, 6.9878913109973],
            [2.641590762341582, 6.979378627380664],
            [2.6447986464380513, 6.9700075954690845],
            [2.6433112740066727, 6.964781442776568],
            [2.6425788174754996, 6.954709567223678],
            [2.644943686585215, 6.94977225553953],
            [2.644131278763841, 6.938810272264847],
            [2.6450837257656334, 6.935529619346417],
            [2.654207340956972, 6.927980360528395],
            [2.6714826622128545, 6.927488756899478],
            [2.680198025006599, 6.924381169210913],
            [2.6878615955584007, 6.922488042788071],
            [2.695712096678673, 6.9229357816734405],
            [2.703058466322997, 6.924900936988229],
            [2.7139193144908043, 6.930263990843465],
            [2.720724394082949, 6.931078797391434],
            [2.724810935001761, 6.929688231592435],
            [2.7344521552875882, 6.92063931226557],
            [2.742524920221835, 6.916461072343984],
            [2.756589937277816, 6.905117847636456],
            [2.7577429068062917, 6.900818853596903],
            [2.755763191060256, 6.889733768933423],
            [2.757090981439768, 6.878663877182908],
            [2.767833633421741, 6.867925183664177],
            [2.774959282622702, 6.858002575432256],
            [2.7829724721556963, 6.841615142471452],
            [2.7864937030908923, 6.83776076759838],
            [2.791366929931451, 6.830053516800189],
            [2.80496842473596, 6.824499461424058],
            [2.811011329738532, 6.820983410480354],
            [2.815739168612731, 6.8083382624829865],
            [2.814375053614345, 6.796348533676488],
            [2.8139600989524864, 6.785948726696574],
            [2.816689569165979, 6.780139905076643],
            [2.814307942352204, 6.770198149744248],
            [2.814580973213269, 6.765435910977094],
            [2.805166319842896, 6.759940465470505],
            [2.801522692297968, 6.755640882103469],
            [2.7966050144007077, 6.746549833049336],
            [2.7952982594839715, 6.739121838061411],
            [2.7834716822090453, 6.729585904790674],
            [2.7792804955368484, 6.724414194998777],
            [2.7785109629861378, 6.719604007979656],
            [2.7820815098110634, 6.708553855493035],
            [2.782682676449083, 6.702562720576488],
            [2.7789324316508655, 6.692642258784895],
            [2.7754795473259066, 6.687329382619776],
            [2.7634128709013974, 6.674969971636768],
            [2.7571231022685616, 6.665976056065657],
            [2.7513423926490614, 6.6611896781809214],
            [2.7023915120742426, 6.660027697243599],
            [2.647808701729599, 6.6581132183824945],
            [2.6236187975995193, 6.65739844740912],
            [2.5588687840833653, 6.655996022337723],
            [2.558575467671461, 6.6702038259202885],
            [2.55740948553508, 6.700885915895226],
            [2.5571417224866018, 6.733518755672077],
            [2.5551802598001316, 6.770036007442359],
            [2.5518517702900336, 6.82818407028633],
            [2.5503052463269844, 6.863309919408004],
            [2.5489327411494505, 6.914556091789475],
            [2.505789045465829, 6.913718106851775],
            [2.4649081016187435, 6.91265369398872],
            [2.464015589774361, 6.942617027658248],
            [2.460864645860658, 7.055146933490494],
            [2.459848699200783, 7.083773671887839]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.90835674981808, "lat": 45.50244701601825 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27025"],
        "coty_name": ["Chisago"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chisago County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00659458"
      },
      "bbox": [
        2.459848699200783, 6.655996022337723, 2.816689569165979,
        7.089444597091974
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6236539394156949, 7.427519367805674],
            [0.71007383254481, 7.427768217992788],
            [0.7965969656331919, 7.428785080236311],
            [0.8212036610921828, 7.4289849308579115],
            [0.8827981808826918, 7.429181847765606],
            [0.9696429397901567, 7.429307092468423],
            [0.9840414255774266, 7.429146844322746],
            [1.0569446629287385, 7.429288367396486],
            [1.0571515433419048, 7.385830036874255],
            [1.0571640902125437, 7.343217637055281],
            [1.0576731483598674, 7.314422222677053],
            [1.0582445125133806, 7.257015539553238],
            [1.0634143383623063, 7.256955791297453],
            [1.0630537328968352, 7.185379042421674],
            [1.0642285442880373, 7.099085697363915],
            [1.0644025022162447, 7.08468356161396],
            [1.0136531337771109, 7.084093225183621],
            [0.8942533264384852, 7.0834886082453],
            [0.8705040221034265, 7.084068792259705],
            [0.8008684085462171, 7.082824650270869],
            [0.7045973859214796, 7.083093813473711],
            [0.6323436500054188, 7.083230576613104],
            [0.6322574607735503, 7.140864430502536],
            [0.6317681891186769, 7.255462142744199],
            [0.6242065881094296, 7.255431638072505],
            [0.6237803330341742, 7.365251076179997],
            [0.6236539394156949, 7.427519367805674]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.45350784999114, "lat": 45.93374943815417 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27041"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00659466"
      },
      "bbox": [
        0.6236539394156949, 7.082824650270869, 1.0644025022162447,
        7.429307092468423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.41776188867356306, 8.799566160289258],
            [0.4831975703549664, 8.799568855495048],
            [0.548633244644675, 8.799557967949278],
            [0.5527057358145734, 8.799810826717671],
            [0.6075274112062864, 8.800001672426081],
            [0.6334990311872016, 8.799742846610743],
            [0.6821197533612368, 8.80013851319653],
            [0.7471474015387889, 8.800926102409214],
            [0.7668197372369755, 8.80099566377642],
            [0.7687161293532402, 8.801129185589486],
            [0.7695288201926639, 8.700671946908964],
            [0.7696094080079485, 8.629457033051702],
            [0.7697986635520505, 8.544197987771428],
            [0.770537586676128, 8.458497683742484],
            [0.7266306661037972, 8.458273818305486],
            [0.709762927080145, 8.45783256682147],
            [0.7002172964116627, 8.458030725959308],
            [0.6471212356062275, 8.457170226954855],
            [0.6218421519117329, 8.457175367360536],
            [0.5971996248447282, 8.456809716329346],
            [0.5537714355358704, 8.456662030986289],
            [0.5053910204094435, 8.457845558386957],
            [0.41789353188249395, 8.458151436944997],
            [0.41793451926755976, 8.522298006650356],
            [0.4183367022833922, 8.587817954008452],
            [0.4182998121205268, 8.626219940529811],
            [0.4178278142058707, 8.714282244766242],
            [0.41788170953462256, 8.757136224826986],
            [0.41776188867356306, 8.799566160289258]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.80905445192374, "lat": 47.32524686606542 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27087"],
        "coty_name": ["Mahnomen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mahnomen County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00659488"
      },
      "bbox": [
        0.41776188867356306, 8.456662030986289, 0.770537586676128,
        8.801129185589486
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.13815704416418823, 5.181062575626108],
            [0.13815705338936562, 5.181067316142762],
            [0.18554454120045843, 5.180462765257337],
            [0.2875290363239939, 5.179614814745081],
            [0.382715866410758, 5.179597202866686],
            [0.4173224893272951, 5.179842998888993],
            [0.42615779086464434, 5.179868581653042],
            [0.4259310512425763, 5.120840063004995],
            [0.4258510940364686, 5.055927121896443],
            [0.42560293084656214, 5.0484047826347815],
            [0.4250079591407118, 4.918127643430854],
            [0.42555220204114547, 4.854579643409055],
            [0.42535691769137085, 4.830736905065652],
            [0.37428756993095397, 4.83082498846452],
            [0.2982582004552121, 4.83107383311668],
            [0.22399183858725183, 4.831449510295009],
            [0.1747831732851754, 4.831541298936026],
            [0.13648753483494733, 4.8317847135304826],
            [0.1367884096635679, 4.90660560185837],
            [0.137307690818881, 5.021175811994435],
            [0.13786649743800175, 5.122998731999682],
            [0.13807076679864128, 5.136686638283521],
            [0.13815704416418823, 5.181062575626108]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.2531837760052, "lat": 43.67464985258156 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27133"],
        "coty_name": ["Rock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rock County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00659512"
      },
      "bbox": [
        0.13648753483494733, 4.830736905065652, 0.42615779086464434,
        5.181067316142762
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.915864035075474, -6.832471932235877],
            [4.914766269719925, -6.803205275841605],
            [4.916197899313067, -6.7886579754277685],
            [4.929075913735314, -6.77335426822763],
            [4.926068339302871, -6.713954153505427],
            [4.92402024957592, -6.678669460562227],
            [4.9233037477532955, -6.656114765066891],
            [4.923655694359906, -6.640696198049029],
            [4.916427914076253, -6.570393358136068],
            [4.9695930477596555, -6.567314688451862],
            [4.969518549648779, -6.565836030327069],
            [4.997775105331992, -6.564150791895684],
            [5.027048233272548, -6.562736003283468],
            [5.0875198028419515, -6.559080960863126],
            [5.130733989571758, -6.556947000090965],
            [5.278323574866191, -6.548314733820642],
            [5.327234927140625, -6.5452631667411865],
            [5.32766877768544, -6.548307525580705],
            [5.322585847970244, -6.557793726446959],
            [5.3175322420452895, -6.558214392451885],
            [5.313533997731217, -6.5642988902758255],
            [5.31729922985977, -6.569267674903946],
            [5.317725082664412, -6.572962340262705],
            [5.326544773595548, -6.577921964570415],
            [5.3299005479047405, -6.57395209598974],
            [5.337033487149484, -6.575498177745803],
            [5.33403503673071, -6.584802040686244],
            [5.330250648666629, -6.584508632727766],
            [5.328464366843895, -6.587454589061048],
            [5.332845506545779, -6.592660160450441],
            [5.336932357395235, -6.599595212068126],
            [5.3371470001924735, -6.605238141958189],
            [5.342112459545706, -6.604295819241914],
            [5.344807353358277, -6.6074896076088825],
            [5.3477135513912035, -6.604520655483409],
            [5.351417769975033, -6.605542126228342],
            [5.35250606866395, -6.609834022225768],
            [5.351268361777967, -6.615870794604058],
            [5.352619919345457, -6.619242637474619],
            [5.356053106763191, -6.621869196752351],
            [5.356710263105853, -6.625334035032784],
            [5.360491790669281, -6.627896234793008],
            [5.359992718886812, -6.6351417515495426],
            [5.366989533016095, -6.6373983373752745],
            [5.3647504979583305, -6.639603157034775],
            [5.366099063216233, -6.648529834670985],
            [5.3611399018125745, -6.65003086455477],
            [5.364130607475954, -6.653128645069765],
            [5.370383408927811, -6.650770916880098],
            [5.372942456992618, -6.654491527154856],
            [5.376172532713823, -6.653107112292627],
            [5.377289347152581, -6.649293733972415],
            [5.386780160794507, -6.660826907978341],
            [5.388629848203339, -6.667660549134993],
            [5.38634343257045, -6.673759657217602],
            [5.386741183804162, -6.6868997994859605],
            [5.396362684822579, -6.690247178460682],
            [5.399656753019937, -6.693398771783518],
            [5.408172764010943, -6.697191206006629],
            [5.411854486838473, -6.702439805701716],
            [5.416982982202005, -6.7187432218452985],
            [5.417179647680853, -6.725187518757161],
            [5.42092174550899, -6.729337029051009],
            [5.4215045386979694, -6.7323039353770975],
            [5.418403024167172, -6.735119079374139],
            [5.418637596615206, -6.739448667298457],
            [5.41668507681828, -6.741414536410541],
            [5.405750158865325, -6.745467622349289],
            [5.399794899997342, -6.745807755556462],
            [5.402495116480622, -6.7494447539365465],
            [5.410783923775465, -6.756416628362813],
            [5.412968251938936, -6.759810915367809],
            [5.418477325916418, -6.7565568471808595],
            [5.420897496178728, -6.757035051317429],
            [5.4269515850334376, -6.7614087910947545],
            [5.419713742075225, -6.763302259319111],
            [5.420925452294691, -6.770274874390524],
            [5.410905620684524, -6.7820060437749445],
            [5.409712684625347, -6.7900458303746465],
            [5.415766265823367, -6.795259414437945],
            [5.418762164423967, -6.8000034152159134],
            [5.433353835860401, -6.799317595326384],
            [5.4400358220697385, -6.796807983801444],
            [5.443916277533431, -6.798544680034069],
            [5.44465513339247, -6.804331129969993],
            [5.447584625755923, -6.809891517144792],
            [5.443848825045663, -6.818095803620136],
            [5.437829663803318, -6.820125007805202],
            [5.4357995418129885, -6.813545921949949],
            [5.433711968604146, -6.814119928482596],
            [5.430018113978269, -6.820436245734809],
            [5.436857214587933, -6.832367180756053],
            [5.436403560167453, -6.835565471080849],
            [5.433194893476374, -6.835962504320271],
            [5.4288358462878845, -6.832665148547233],
            [5.42101343178718, -6.839028028983701],
            [5.418969821590188, -6.842150673982421],
            [5.415388754900911, -6.843180255273035],
            [5.409784225626222, -6.842728816030162],
            [5.402159341257951, -6.8461960064464655],
            [5.399001724784737, -6.849933512607869],
            [5.394918774412806, -6.8510177195730115],
            [5.390362340539891, -6.854532322176551],
            [5.385676878162016, -6.859866727969284],
            [5.3793500598608555, -6.861803842513539],
            [5.37635744834132, -6.86397665212984],
            [5.367102134899866, -6.867031551388283],
            [5.360696395882669, -6.867102759011128],
            [5.3524329028716675, -6.87019677431398],
            [5.347449901250939, -6.869907241642852],
            [5.3349194324842575, -6.876862009396225],
            [5.3271253118619954, -6.884760764705072],
            [5.324067488290795, -6.891107640649643],
            [5.312719138721999, -6.89148254602722],
            [5.306597386764355, -6.896201060677001],
            [5.221905589533477, -6.900883274789374],
            [5.223363195320952, -6.915789935001227],
            [5.194404152580054, -6.917400922670097],
            [5.193036939335324, -6.902324031346651],
            [5.165125289555793, -6.903714880893442],
            [5.165139799475244, -6.9051422293122595],
            [5.079508757761879, -6.910505378569314],
            [5.067954198723408, -6.911671510202974],
            [4.920278226934236, -6.919757404457725],
            [4.915864035075474, -6.832471932235877]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.44883866497831,
          "lat": 31.869194492311156
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28029"],
        "coty_name": ["Copiah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Copiah County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00695739"
      },
      "bbox": [
        4.914766269719925, -6.919757404457725, 5.447584625755923,
        -6.5452631667411865
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.736624970559796, -6.34703541960846],
            [5.761113225818871, -6.345482932454778],
            [5.760699338385586, -6.343731079641046],
            [5.848014380061488, -6.337992229306465],
            [5.920542497789583, -6.333345485249844],
            [6.034942025974395, -6.325770386019944],
            [6.041634541232847, -6.324889077039466],
            [6.078890520396829, -6.322395127335344],
            [6.087272499652549, -6.439682492673335],
            [6.095125953950245, -6.54483197090483],
            [6.104075791848457, -6.659270716107428],
            [6.105157961269915, -6.6700092601408905],
            [6.108248184687714, -6.669826156369888],
            [6.113788748871731, -6.741664151685668],
            [6.085563985844688, -6.745799438151462],
            [6.064651486452581, -6.748510065461488],
            [6.042692955796538, -6.751832390872949],
            [6.009449241016388, -6.756858947453569],
            [6.003481463025897, -6.757383350353283],
            [5.972801598136199, -6.761707767303556],
            [5.956782144168951, -6.764351140254322],
            [5.857656874782679, -6.778515532826536],
            [5.831218925389576, -6.782362982002885],
            [5.829764694266331, -6.7793586190979624],
            [5.825525406864251, -6.720033760963501],
            [5.820740616763383, -6.648981547906799],
            [5.815246158190477, -6.565627568095763],
            [5.814417358518208, -6.5504353436159475],
            [5.805720712206502, -6.517432828500908],
            [5.748517676852118, -6.5213750174583],
            [5.744537092410222, -6.457265585016933],
            [5.743008232966349, -6.434461830789699],
            [5.741824083269778, -6.434533558692334],
            [5.739738949908276, -6.404052992651969],
            [5.736097854314193, -6.347163136512985],
            [5.736624970559796, -6.34703541960846]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.50668842795419, "lat": 32.01766379141019 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28129"],
        "coty_name": ["Smith"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Smith County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00695785"
      },
      "bbox": [
        5.736097854314193, -6.782362982002885, 6.113788748871731,
        -6.322395127335344
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.427049671785723, -6.696657109202859],
            [6.4546413968263225, -6.692529045529593],
            [6.501816690143494, -6.685384829475044],
            [6.577954671373907, -6.673990939100008],
            [6.6800116025256715, -6.64820100618098],
            [6.695207175275581, -6.6437447771109195],
            [6.745174765941418, -6.624996992816433],
            [6.8180258561115785, -6.597460257144682],
            [6.820005247889477, -6.616027602983867],
            [6.823223673924455, -6.640002361531909],
            [6.830066825841119, -6.69974145475727],
            [6.838513160430415, -6.767527828180872],
            [6.841025010442146, -6.791700751265694],
            [6.851277267591261, -6.867211763182068],
            [6.866418183220979, -6.98749126116018],
            [6.869119556025124, -7.0059019399658995],
            [6.871327502423616, -7.027802568897604],
            [6.8744583690089565, -7.0511557701210315],
            [6.796274287707448, -7.0573156578050416],
            [6.797134634014198, -7.058489675760569],
            [6.735791243115159, -7.0636806028330374],
            [6.677790110816552, -7.068360115850327],
            [6.669744843335541, -7.068728896733018],
            [6.622138984832752, -7.07273166943716],
            [6.620024879690001, -7.073151817250048],
            [6.557096057786299, -7.077395703010224],
            [6.542320888524834, -7.078842150425065],
            [6.465908695860406, -7.084842626783606],
            [6.4560871096247565, -7.085498268136206],
            [6.451097702172902, -7.012916742816612],
            [6.4466717318427476, -6.954097792018869],
            [6.443267858400988, -6.904746687379052],
            [6.442025552512677, -6.891957744535785],
            [6.4359448599948985, -6.813564511687922],
            [6.430213250041414, -6.736788616410412],
            [6.427049671785723, -6.696657109202859]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.69578879706411,
          "lat": 31.640794232375587
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28153"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00695797"
      },
      "bbox": [
        6.427049671785723, -7.085498268136206, 6.8744583690089565,
        -6.597460257144682
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3906000953603272, -0.47395784272466035],
            [2.3910838795290754, -0.40798498832888774],
            [2.3922926056800513, -0.3054879942187589],
            [2.392773160119464, -0.27579585224238395],
            [2.393232950404332, -0.23186455108712972],
            [2.392993162004811, -0.22415853124062135],
            [2.390608147001366, -0.2241482110254407],
            [2.390960509737103, -0.17652189509991462],
            [2.3908893555181367, -0.16559933270319924],
            [2.4551719308072086, -0.16614123417213997],
            [2.477122507298249, -0.16644225353315018],
            [2.5621711201311212, -0.16713422707961267],
            [2.5624166621739906, -0.13776430400467293],
            [2.6485201621657914, -0.13658900767779786],
            [2.730372699387573, -0.13790701104199302],
            [2.735382612990824, -0.1380768345113464],
            [2.734422778490739, -0.22672701730216205],
            [2.736974239437725, -0.22664935787222665],
            [2.7370808739999752, -0.2353383480058343],
            [2.73608723772089, -0.30857057034402513],
            [2.7357670214530265, -0.3967229104136034],
            [2.735614201994383, -0.40771118964547837],
            [2.7345126367884585, -0.4851198786760614],
            [2.7525027866613527, -0.4853916339876762],
            [2.7515779423756808, -0.6098900810720314],
            [2.7087198005191944, -0.6109771392242351],
            [2.665795096092155, -0.6109452819768298],
            [2.6284592096580477, -0.6114305755273802],
            [2.5992157870089807, -0.6115783320820762],
            [2.5492247680308036, -0.611369196920678],
            [2.49428817119961, -0.6106186317806123],
            [2.48035763086555, -0.6101304739721035],
            [2.4149950521368555, -0.6093224761867603],
            [2.409353962332745, -0.6089173197324019],
            [2.409451226726007, -0.5899457718113503],
            [2.4102555511561583, -0.5305213283521493],
            [2.410535425066322, -0.5258815239777616],
            [2.4111996331222114, -0.48162947201881695],
            [2.398718182579233, -0.48151572272945653],
            [2.399762698204399, -0.47446193598460024],
            [2.397918978237744, -0.4733445050018695],
            [2.3906000953603272, -0.47395784272466035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.28792948858622, "lat": 38.29483898084191 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29015"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00758462"
      },
      "bbox": [
        2.3906000953603272, -0.6115783320820762, 2.7525027866613527,
        -0.13658900767779786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.311137960867323, -7.7666577963133765],
            [7.31581024748363, -7.755873733371947],
            [7.316643137629659, -7.751390076178115],
            [7.315543076811041, -7.74517183171803],
            [7.313733422690321, -7.741657504466088],
            [7.30739363062652, -7.737060982238596],
            [7.302684845683726, -7.727932345129425],
            [7.301833486539063, -7.723868008266827],
            [7.302007493033545, -7.713087993897534],
            [7.296099820146199, -7.705584697757565],
            [7.291636174237748, -7.702576849492403],
            [7.290373951739941, -7.6986808486900395],
            [7.294657893604591, -7.68712635126083],
            [7.292117753705482, -7.677467488028829],
            [7.296259065916963, -7.670540688525133],
            [7.3010020567559994, -7.666654565541853],
            [7.310850663389077, -7.662783030782432],
            [7.31615675734228, -7.658737032515752],
            [7.317438529522065, -7.655738653978452],
            [7.315571126372101, -7.643722915811478],
            [7.318997260699005, -7.638364557595626],
            [7.327394072104731, -7.6347225677888595],
            [7.338387368185166, -7.6276379079530505],
            [7.348476276066897, -7.626100500272481],
            [7.352441792672414, -7.6233888674459696],
            [7.353962085093818, -7.619867519992783],
            [7.352801969363949, -7.610002336334413],
            [7.343592862568888, -7.5984339651946575],
            [7.332205711826019, -7.591757675203362],
            [7.31993732023841, -7.587988749784248],
            [7.316072041307618, -7.5836929163418025],
            [7.314171088968937, -7.575199967641255],
            [7.315946886534907, -7.566674978502511],
            [7.318739123473803, -7.561030524574903],
            [7.328072914211802, -7.549660528756535],
            [7.335241856325535, -7.544679992453036],
            [7.338351219166939, -7.536667677753535],
            [7.337906216194198, -7.525962472391009],
            [7.340942338717877, -7.52158979612575],
            [7.346123563194457, -7.5188843264233345],
            [7.352773925664244, -7.517458657690786],
            [7.362024214056005, -7.5110777707238165],
            [7.360165424271212, -7.503747081097349],
            [7.357657973952542, -7.500612546027062],
            [7.346770368651833, -7.49590216329793],
            [7.343371001446459, -7.486336260910514],
            [7.337127782753933, -7.482676252570482],
            [7.3262153042359035, -7.483510222102667],
            [7.32443127299196, -7.481930552562068],
            [7.327233841794151, -7.474621875582807],
            [7.327103583910489, -7.466658174542045],
            [7.329865054047394, -7.459522015890699],
            [7.327213649422092, -7.446423634532209],
            [7.321376227468931, -7.442270779572847],
            [7.325925883286169, -7.436811444311587],
            [7.33022186861326, -7.436831390453464],
            [7.33278592034308, -7.429532064514361],
            [7.33232921630934, -7.427061877420488],
            [7.32588438430669, -7.420337723824636],
            [7.325218315976828, -7.416940636679005],
            [7.3283838332123, -7.4119073570772285],
            [7.3355929137464555, -7.405841392734793],
            [7.33807687067166, -7.400549359922095],
            [7.336609052436825, -7.387513016313446],
            [7.333445089329486, -7.382851307187347],
            [7.32998006737885, -7.381564612575824],
            [7.31707921696038, -7.382222645450298],
            [7.313834906746239, -7.379342180292177],
            [7.310587884184977, -7.373727993313146],
            [7.305650244740029, -7.369069256745234],
            [7.304732942741911, -7.362043896261874],
            [7.3128179302045195, -7.352696587847049],
            [7.327217754368779, -7.328048359814007],
            [7.328637812726534, -7.324442298803987],
            [7.328088436895974, -7.314869976117353],
            [7.331018135729868, -7.303638668098284],
            [7.329404664939234, -7.3011339086540215],
            [7.325145198145842, -7.300487105295553],
            [7.319401867748015, -7.303576603563222],
            [7.313507577292669, -7.3044540863966585],
            [7.3082115149867075, -7.303105560085646],
            [7.302730372261983, -7.299074557270718],
            [7.3007721541094535, -7.295195908740589],
            [7.301393048752112, -7.289262816103729],
            [7.3051854501113676, -7.288791442036373],
            [7.311612353956549, -7.29068432378142],
            [7.31889663852737, -7.288488250311376],
            [7.326254438360324, -7.288522700378306],
            [7.328261885528967, -7.2838516533326],
            [7.323454901459015, -7.277830062394239],
            [7.322255195528369, -7.27411338315502],
            [7.323187435442645, -7.267142335925481],
            [7.321158524883755, -7.257397753980315],
            [7.326591743368995, -7.260106507833536],
            [7.332431040784112, -7.2593841633315215],
            [7.339499139620202, -7.262650368014147],
            [7.345854604094118, -7.2626247071585235],
            [7.34962373909185, -7.260562713970039],
            [7.35490232105198, -7.248321657997208],
            [7.361024498486139, -7.249611240613665],
            [7.368605500843069, -7.241977941392725],
            [7.377993988276722, -7.247527791938345],
            [7.382178631796208, -7.24367538035313],
            [7.38238481237436, -7.24061564036149],
            [7.379549273997631, -7.233212566833327],
            [7.380101950501916, -7.230618818607675],
            [7.384448511871047, -7.229226064890059],
            [7.388695412861343, -7.234891431755944],
            [7.393749494910202, -7.239556582350792],
            [7.399326738373159, -7.240268311151844],
            [7.402456989464288, -7.237343783432179],
            [7.401770068917575, -7.23193411337326],
            [7.3944359087330955, -7.227690403148203],
            [7.388809355689832, -7.2185166079409475],
            [7.388242148049746, -7.213580906068942],
            [7.391006655060017, -7.209048859917726],
            [7.396943697363044, -7.206958158770877],
            [7.400779626171869, -7.2087884129254105],
            [7.407761489525889, -7.217601304150657],
            [7.412316251371896, -7.213986850283898],
            [7.411879197330512, -7.211612044118934],
            [7.404504309736206, -7.207153621588904],
            [7.403774094348588, -7.2040283206567635],
            [7.408336672102681, -7.198866288816736],
            [7.409478573224499, -7.195627983796156],
            [7.404624584664686, -7.1902484932550115],
            [7.401307508265958, -7.1883101104619564],
            [7.39725306808378, -7.1906386028383285],
            [7.395005446894166, -7.1881630769057345],
            [7.398044816420739, -7.183859627357849],
            [7.405180967782497, -7.1873179468666875],
            [7.411352327010476, -7.183653878713931],
            [7.413576575961845, -7.177575512257036],
            [7.414523918936598, -7.167164727580299],
            [7.417760921131173, -7.162934088720095],
            [7.4228022222905246, -7.1631392313880955],
            [7.437747524207634, -7.170664273668185],
            [7.443732676601854, -7.169166088369138],
            [7.450788277921289, -7.16356959375595],
            [7.451997418619516, -7.161489678451724],
            [7.449954735951347, -7.156490958239437],
            [7.442167695344249, -7.152293462480953],
            [7.44084283647348, -7.1478924232991945],
            [7.433906305344654, -7.139424973412298],
            [7.42822691391875, -7.134673348524908],
            [7.427172837628267, -7.130918352991373],
            [7.4288269519472045, -7.123529476335314],
            [7.432443548823362, -7.122137692059722],
            [7.435917622791379, -7.124443567470572],
            [7.437318236859386, -7.132502050636259],
            [7.43987873600779, -7.137572960758784],
            [7.446399548087195, -7.142338438474929],
            [7.4535983982623435, -7.141405579500826],
            [7.461062428240915, -7.144765344399762],
            [7.465913290568736, -7.142801126388445],
            [7.466200028535282, -7.140697307330825],
            [7.480160365128276, -7.1396838249557035],
            [7.483429413362632, -7.134864235714607],
            [7.488592230394235, -7.133407352261075],
            [7.495180521425792, -7.1331092835007945],
            [7.500386344193495, -7.134717783720112],
            [7.502987898452389, -7.132155252492276],
            [7.510642811428316, -7.133070035626401],
            [7.513337777455232, -7.136729827256363],
            [7.517177890937051, -7.139144515101289],
            [7.520679524600864, -7.144957116840103],
            [7.520646714826766, -7.1476858814135005],
            [7.530686681423062, -7.1495382259974996],
            [7.533493941038473, -7.156783934560819],
            [7.5444210947200006, -7.168913815378322],
            [7.553171862210724, -7.172687915644863],
            [7.557193738209943, -7.177147731489311],
            [7.563981958777174, -7.179883480609426],
            [7.571607221670108, -7.179952772175192],
            [7.576400493382581, -7.184116283321383],
            [7.5791802274333815, -7.183049452694105],
            [7.583744710508764, -7.1848747307963],
            [7.59363267303242, -7.182040116505905],
            [7.597473712862092, -7.182144950044523],
            [7.613084297849473, -7.356250389549243],
            [7.6135139092687805, -7.3588955194489865],
            [7.618672093564691, -7.414327016040168],
            [7.619705007439662, -7.4270518570130175],
            [7.633744631506997, -7.425723422836608],
            [7.636494604258069, -7.435314218389101],
            [7.639739103651455, -7.439672991542256],
            [7.639561642988725, -7.4450674101684085],
            [7.644961228917952, -7.45768012645026],
            [7.643668381303691, -7.470744985495234],
            [7.640467888907547, -7.481370156663478],
            [7.636138936258499, -7.488592826966542],
            [7.632636785996175, -7.498670260241406],
            [7.63129644764786, -7.506635866192484],
            [7.628595488724392, -7.514950075556808],
            [7.627683940525564, -7.522099873691025],
            [7.622756712349552, -7.52646930861563],
            [7.624518262230508, -7.533885483640369],
            [7.6239451493874055, -7.538441968788427],
            [7.618110805213592, -7.544235537872957],
            [7.614689954018194, -7.5587353234960855],
            [7.620904412459497, -7.563934718641772],
            [7.62385711751629, -7.569440248752249],
            [7.622764299536196, -7.575916563563459],
            [7.632000411714003, -7.582699352127641],
            [7.633658669352716, -7.5882018855048035],
            [7.642613397091758, -7.590798078564305],
            [7.646695344717413, -7.596590370775987],
            [7.648070642809214, -7.600972740228161],
            [7.653673102198547, -7.604115510942583],
            [7.664682084405828, -7.607718104427629],
            [7.66934128071226, -7.611538495680985],
            [7.67411941509796, -7.618731525557328],
            [7.677578071357969, -7.619867425935372],
            [7.685073213197303, -7.626020904635928],
            [7.6857326247295275, -7.627769601596222],
            [7.692448997668218, -7.631360050996929],
            [7.699104819993731, -7.638342488589588],
            [7.698744238628767, -7.6450049360045575],
            [7.70733643160294, -7.6537127638046],
            [7.709942141797744, -7.66620667325884],
            [7.712857617241202, -7.672219343729684],
            [7.720999976507953, -7.676668463389832],
            [7.731574316778978, -7.6804899868078955],
            [7.7378361061779115, -7.687138224086615],
            [7.7406808698454315, -7.691596763478099],
            [7.754008781286482, -7.693493913528407],
            [7.7591505885887155, -7.695023156261256],
            [7.765846079416224, -7.704323648610922],
            [7.7694074437937175, -7.705307838356375],
            [7.773274314349084, -7.709397636371626],
            [7.7815903985016055, -7.711921955083757],
            [7.786124252640319, -7.7092766023170505],
            [7.793276718203826, -7.713825852198382],
            [7.7968659347349965, -7.7176191702942925],
            [7.800269794413086, -7.719120839460485],
            [7.805098099364327, -7.718711350307967],
            [7.810263700266327, -7.723505874154355],
            [7.815146508005511, -7.7264522487230085],
            [7.821120573005566, -7.727837162551165],
            [7.82632168328466, -7.730252597955253],
            [7.828021784308708, -7.738626558477618],
            [7.833294828102616, -7.747595634593922],
            [7.836492541620119, -7.750097658465456],
            [7.837123200432071, -7.7562582188794895],
            [7.841760142507965, -7.7730310591873115],
            [7.84059636349059, -7.78706765881832],
            [7.841944423816452, -7.788569803375088],
            [7.839191306117885, -7.798459742452438],
            [7.834836805558468, -7.801066675069158],
            [7.833472932915602, -7.804640142536405],
            [7.833078323296685, -7.8208547144845255],
            [7.8306242947178495, -7.831517486674511],
            [7.825992548456073, -7.835587884451294],
            [7.827872169710621, -7.8386643073547395],
            [7.826575895090736, -7.843235811876595],
            [7.820411731068739, -7.845546953157995],
            [7.819359117603837, -7.851536804009492],
            [7.816672703858861, -7.855661168121157],
            [7.813351621069747, -7.8570779530024755],
            [7.805800618330581, -7.879754293312191],
            [7.806545771015107, -7.886427445737041],
            [7.808298523005507, -7.891615984458724],
            [7.806141523339799, -7.894828688767677],
            [7.809166478974431, -7.898962497024921],
            [7.8135444997836325, -7.899413142008891],
            [7.821812315333526, -7.909490561000443],
            [7.822750126076131, -7.914089593445235],
            [7.819423852253496, -7.924950905562386],
            [7.824058420997332, -7.928422491397757],
            [7.825456412143586, -7.934276368680474],
            [7.829762687261692, -7.938873077901668],
            [7.839423284945423, -7.946277667971876],
            [7.845330688449647, -7.946644333697679],
            [7.848388985745629, -7.949856309703413],
            [7.855280354204106, -7.951528936253585],
            [7.859389000510448, -7.950163038315796],
            [7.8687785796186525, -7.9508126532515755],
            [7.877989879003402, -7.9532031659417335],
            [7.8818510321649, -7.959217271989252],
            [7.882497528441723, -7.9629772707502555],
            [7.879133838309847, -7.96941648382096],
            [7.867007340559105, -7.9804654233673045],
            [7.8592986928203805, -7.984048114965386],
            [7.853281510718178, -7.991960300097307],
            [7.848778960808842, -7.993759326369225],
            [7.839822566485418, -7.993168001095542],
            [7.8339119585284935, -7.994693905264644],
            [7.831239948741298, -7.997623010400136],
            [7.82802213934829, -8.006876796139386],
            [7.823075331475855, -8.013296235006493],
            [7.823336325647705, -8.01805430800148],
            [7.825754618770127, -8.023715064545062],
            [7.823462364049529, -8.028396429047339],
            [7.81777170396539, -8.034786664545658],
            [7.816086939517382, -8.038124422861534],
            [7.816193162658134, -8.044987355661375],
            [7.8183278870239326, -8.058776970844752],
            [7.811487988916071, -8.069308593298869],
            [7.807552941898121, -8.072647099635674],
            [7.7985407581278565, -8.07534214609865],
            [7.784597792471105, -8.077080330728668],
            [7.777819688899222, -8.07961723840595],
            [7.774207970725648, -8.084835047901446],
            [7.773557154120895, -8.089516082806746],
            [7.77431360877996, -8.096315519057505],
            [7.777353672673297, -8.101222430179336],
            [7.784341858493182, -8.102892049726092],
            [7.793974150597248, -8.102234981893293],
            [7.800391784060115, -8.098578157197839],
            [7.809089228229706, -8.098102074050368],
            [7.8143482389919345, -8.096936110040781],
            [7.822250710593789, -8.093442668698215],
            [7.821257091604689, -8.104384011216275],
            [7.781492844798363, -8.120170686932894],
            [7.766051296714882, -8.125522343379318],
            [7.766408790851986, -8.128941301955603],
            [7.732578464716613, -8.141022753391356],
            [7.727060610210919, -8.141067988073837],
            [7.713266473698409, -8.144758542068995],
            [7.662787662316577, -8.163830058847926],
            [7.64737574868308, -8.16910005379588],
            [7.628831443525082, -8.173030739314616],
            [7.61117635373012, -8.177972773058238],
            [7.583331811755762, -8.184519081930663],
            [7.528426409803032, -8.20049612856713],
            [7.496037576738732, -8.205431253332463],
            [7.4204207534016575, -8.208667348549806],
            [7.389433112959908, -8.212119785181747],
            [7.357306388142536, -8.218558347946495],
            [7.345795720453487, -8.221769885499942],
            [7.3336858911841265, -8.222624296766506],
            [7.33264883126592, -8.219608956133133],
            [7.336289360339316, -8.215697933291208],
            [7.346652738017066, -8.212787196076782],
            [7.384968715398523, -8.206429635501593],
            [7.398551679007107, -8.184449740517602],
            [7.409252860332601, -8.17866915684229],
            [7.425236200697988, -8.185442358750034],
            [7.429555836788278, -8.19052137729574],
            [7.441524586703594, -8.195784472029729],
            [7.447958815657353, -8.19752262813442],
            [7.459924102502349, -8.197152884530688],
            [7.476329336706853, -8.194069991325646],
            [7.511511375388223, -8.177138698364702],
            [7.525070035294351, -8.17721128117166],
            [7.537285731086439, -8.174980617720674],
            [7.553540688727037, -8.165413871362297],
            [7.562568098777679, -8.149503771449794],
            [7.569238336929066, -8.13886971175456],
            [7.566168898405922, -8.134526724021606],
            [7.561137350011758, -8.135028678117909],
            [7.5451910123447625, -8.117116501044698],
            [7.523540886023196, -8.106533899606264],
            [7.512034658479171, -8.09905343220559],
            [7.492524258413066, -8.07970801142778],
            [7.487870592630864, -8.072524799761288],
            [7.484771054225488, -8.066097752744797],
            [7.484162482490302, -8.057995558466033],
            [7.478434209720276, -8.056656685115069],
            [7.469875213429653, -8.05707463130147],
            [7.459831185670422, -8.052981239565181],
            [7.422167330111574, -8.03035524660525],
            [7.419553402644951, -8.025736996101681],
            [7.412353518569371, -7.9945755486745975],
            [7.405215244550372, -7.970777455384549],
            [7.400243128572289, -7.964435305047044],
            [7.39399675634261, -7.960762833095803],
            [7.389640878722157, -7.959680625460463],
            [7.397398236950548, -7.945461930699437],
            [7.398181478515232, -7.939125546787643],
            [7.40113073963952, -7.929044019039488],
            [7.4047224923931285, -7.924131582745289],
            [7.412098526398144, -7.9035351088810994],
            [7.4140731901359604, -7.8901043770552635],
            [7.410681554967198, -7.875340274571003],
            [7.406887021458933, -7.868557781183479],
            [7.40358888819527, -7.865700814067577],
            [7.3997515759380805, -7.856427249594195],
            [7.399280569009362, -7.826668746207238],
            [7.397677364483212, -7.822519800869618],
            [7.390716513877882, -7.816334583283569],
            [7.392841076064221, -7.812327094539101],
            [7.391724586679704, -7.807110133187962],
            [7.38671026143124, -7.802074531932458],
            [7.385476422132604, -7.794845837088224],
            [7.3815342702795235, -7.793736100473278],
            [7.379598524269528, -7.789891446650383],
            [7.375051963602822, -7.78721463341501],
            [7.3584516148792325, -7.787186316089215],
            [7.331592339613017, -7.770853249143562],
            [7.327255081770512, -7.770667144001029],
            [7.312964155569611, -7.767850955819018],
            [7.311137960867323, -7.7666577963133765]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.72255994592025,
          "lat": 30.727605426278885
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01003"],
        "coty_name": ["Baldwin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baldwin County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00161527"
      },
      "bbox": [
        7.290373951739941, -8.222624296766506, 7.882497528441723,
        -7.122137692059722
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.734879834963487, -4.408368179023172],
            [7.766947714339123, -4.406223629166227],
            [7.764624152046177, -4.381934834099685],
            [7.752344215213879, -4.245409946909579],
            [7.750853960862537, -4.225900253143567],
            [7.746207352526109, -4.169994994758472],
            [7.739765178179593, -4.0989785977860835],
            [7.7382369907288355, -4.0844803043036455],
            [7.752548571103519, -4.0846332961932506],
            [7.845775190717345, -4.076581768088682],
            [7.960230741612773, -4.069070744427475],
            [8.011569128824325, -4.065037558104826],
            [8.015880647283653, -4.0644813562853646],
            [8.047725564715012, -4.06216330003459],
            [8.09265197049816, -4.05843392610053],
            [8.09810770984811, -4.058407326376971],
            [8.12206655141738, -4.055910565998254],
            [8.169968886080005, -4.052071161779828],
            [8.192890054055843, -4.050694907073507],
            [8.255312749328654, -4.045516541586996],
            [8.257087860438102, -4.058879388915004],
            [8.271428055748473, -4.057651190036744],
            [8.272739124501252, -4.072259541147552],
            [8.27970546308029, -4.071580585408673],
            [8.276618633953262, -4.08317404140705],
            [8.279686616973654, -4.086962766511806],
            [8.25178280251048, -4.088901091430992],
            [8.248245671501962, -4.092023636854903],
            [8.248522478447036, -4.0945449782321],
            [8.242673302807134, -4.101130595902455],
            [8.239491436285613, -4.097512694469022],
            [8.232845714921247, -4.0961018209499676],
            [8.226115664524853, -4.099958394313413],
            [8.226502942038847, -4.103333472412543],
            [8.22407570523068, -4.107822897281357],
            [8.222696701880361, -4.113791674959759],
            [8.225436119379905, -4.117884620093627],
            [8.225074826041382, -4.125963108694644],
            [8.213763121887055, -4.1294082883166565],
            [8.211390755476723, -4.136069380605186],
            [8.207719474676693, -4.139099720694795],
            [8.210811882875419, -4.142857783364113],
            [8.206464708845091, -4.147898794519129],
            [8.202434895540557, -4.149404759045818],
            [8.207224943976593, -4.153932454007804],
            [8.206905247199012, -4.156029973575428],
            [8.201711097277583, -4.16166079301492],
            [8.203659199076535, -4.166692331075482],
            [8.207145128207479, -4.167656714120288],
            [8.211673004232967, -4.166551581294441],
            [8.208372814192089, -4.172953704868452],
            [8.202910263225139, -4.175928240997651],
            [8.198124974462614, -4.184844848941838],
            [8.19552585665181, -4.1848101012792105],
            [8.190362706531626, -4.190723290755804],
            [8.189795572874923, -4.198595011121239],
            [8.186374376671914, -4.200838212338129],
            [8.18354885804238, -4.206501552155106],
            [8.183144662264112, -4.211679305855652],
            [8.17868040342967, -4.211578293314097],
            [8.181914979051971, -4.218936451835383],
            [8.180935133001055, -4.221213984503914],
            [8.176387553212956, -4.222403654054852],
            [8.173128710113673, -4.224915747942177],
            [8.169588098450768, -4.233436142593416],
            [8.173620190491745, -4.236533459950378],
            [8.172773378634467, -4.239323731069091],
            [8.168790964688709, -4.240761861656572],
            [8.165344537189197, -4.245342991711256],
            [8.162953916084165, -4.2456378108663255],
            [8.160649945279244, -4.241609912711556],
            [8.156421293909183, -4.237784102686797],
            [8.153671497130338, -4.238009099738766],
            [8.141445496074455, -4.2489485525239905],
            [8.143337205309361, -4.252875114530562],
            [8.138178217262736, -4.253330826572336],
            [8.131183470114681, -4.25536034166175],
            [8.131125139115381, -4.263735111494891],
            [8.129966725825776, -4.27120916706717],
            [8.121104163848596, -4.279972274403429],
            [8.117307910188801, -4.275726625096799],
            [8.115271726730553, -4.279010173769215],
            [8.105788441123902, -4.284600083276536],
            [8.104125595509819, -4.272781991885448],
            [8.10073103573256, -4.273312535751071],
            [8.098900898733598, -4.278810899756264],
            [8.09350432710229, -4.283739421535885],
            [8.092522079478638, -4.286926131139189],
            [8.095311679452607, -4.288626013747362],
            [8.102475466306952, -4.2976010719148015],
            [8.104015213672, -4.300543778771507],
            [8.10982520594039, -4.306007950713441],
            [8.11114984838285, -4.310594052693783],
            [8.108607092392493, -4.313295693882074],
            [8.098005793156203, -4.30519505721741],
            [8.094396332014474, -4.308534744185921],
            [8.091226989348087, -4.319679707592377],
            [8.093341984501238, -4.3231214753155625],
            [8.098571400616812, -4.326804607783625],
            [8.098778189498468, -4.3308953114520135],
            [8.095017814430848, -4.336747081782783],
            [8.092834688688244, -4.338052895693438],
            [8.085756658737907, -4.334987190774577],
            [8.083867292108657, -4.335590699190688],
            [8.080899118721836, -4.343581115112629],
            [8.082973160065736, -4.348466509738275],
            [8.075807804563114, -4.355027822943042],
            [8.067826048986072, -4.360490797060768],
            [8.066764920994528, -4.362796775365475],
            [8.070088283299135, -4.366223039849014],
            [8.06957531043254, -4.370875007101563],
            [8.062065135975631, -4.372647099780289],
            [8.05390121650066, -4.375776045521851],
            [8.057632748900973, -4.380782088926129],
            [8.053925570751291, -4.386357000057648],
            [8.054891451311832, -4.39505053087483],
            [8.053786237498452, -4.397237201422947],
            [8.044929362054352, -4.39897364345222],
            [8.044134935299152, -4.402034300373208],
            [8.048351071026195, -4.402855296757416],
            [8.04705626218861, -4.406694280710985],
            [8.03907377353433, -4.403722437026066],
            [8.037317160687348, -4.40690151672952],
            [8.032147185471965, -4.410065171356565],
            [8.032324783778337, -4.4132786457093065],
            [8.03556631148069, -4.414119082236277],
            [8.034597989728685, -4.4195509341149855],
            [8.028795838062674, -4.42153407924071],
            [8.023114901386744, -4.419819298325039],
            [8.017002594086728, -4.421625676243626],
            [8.008284295141399, -4.418858185128084],
            [8.006661697221944, -4.423458477956266],
            [8.012134639798294, -4.432177215059094],
            [8.010597236357473, -4.434531829863579],
            [8.004737163713164, -4.432218441585282],
            [7.9969104536369535, -4.4265288210354115],
            [7.991314037694322, -4.429176455336048],
            [7.982308306956435, -4.438907085677039],
            [7.978622331429877, -4.44470797069206],
            [7.977536863976572, -4.449950780431387],
            [7.971045034437149, -4.446241574858007],
            [7.964521704356773, -4.444032401703616],
            [7.957684246800958, -4.447608756179074],
            [7.960914891015393, -4.456129407418077],
            [7.958863930055123, -4.464184706803657],
            [7.947929598315996, -4.4670194253460185],
            [7.941941453648207, -4.470007122975553],
            [7.935759150714809, -4.467486507742895],
            [7.928626001371709, -4.474855683477042],
            [7.927437414479858, -4.478290748699768],
            [7.92723770087102, -4.486465315127302],
            [7.93264897107426, -4.488910907638201],
            [7.93473224989424, -4.499096979886228],
            [7.931948241833839, -4.507582559181861],
            [7.935498385297358, -4.510288375139242],
            [7.930467161496557, -4.513202288761327],
            [7.926141485375657, -4.517397389317639],
            [7.9151833496333115, -4.518685141332848],
            [7.910056633520673, -4.51468390437017],
            [7.909789969749114, -4.519126072639432],
            [7.9064867996044494, -4.521084841272448],
            [7.901064311914374, -4.519483006481312],
            [7.904696322686345, -4.5274826982041585],
            [7.901546201015435, -4.528890937252938],
            [7.892044475040934, -4.527513765949039],
            [7.8882849054798045, -4.529165946784519],
            [7.877780424285111, -4.529719239522567],
            [7.876153556136569, -4.5285660007234005],
            [7.873556033944507, -4.5212591967243325],
            [7.869171870522869, -4.520073375745611],
            [7.86517395755847, -4.52389072475536],
            [7.862747456751479, -4.501593373228946],
            [7.793106598979309, -4.50697454463202],
            [7.794145725515691, -4.504399643330518],
            [7.785032757487906, -4.498780039995982],
            [7.7867731307966785, -4.496208134804521],
            [7.7911969580881655, -4.495173335670598],
            [7.799639557178022, -4.4899107655168295],
            [7.79549249695252, -4.477424162773403],
            [7.788684441029502, -4.468936377237518],
            [7.77780258149533, -4.462116570368983],
            [7.776498928859983, -4.453417019334048],
            [7.771047884455701, -4.447806018082183],
            [7.771430519590895, -4.442037696741664],
            [7.769727295415655, -4.4391561288125665],
            [7.7638626752812145, -4.437398923828628],
            [7.760820283724531, -4.435105362929876],
            [7.751412274766345, -4.435210633117037],
            [7.748972535639553, -4.433915733676933],
            [7.74671577296176, -4.42908767325953],
            [7.746865013236336, -4.422983937687524],
            [7.741565786882902, -4.414670871060672],
            [7.734879834963487, -4.408368179023172]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.86761206558988, "lat": 34.13199560677352 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01043"],
        "coty_name": ["Cullman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cullman County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00161547"
      },
      "bbox": [
        7.734879834963487, -4.529719239522567, 8.27970546308029,
        -4.045516541586996
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.310697838177671, -4.130163571627537],
            [7.361007662985982, -4.127390514063087],
            [7.396631508196834, -4.124973631758633],
            [7.422414115078676, -4.122827887529744],
            [7.523916838333127, -4.117327848005699],
            [7.571862491052573, -4.114024866322201],
            [7.621038182861107, -4.1101055085336275],
            [7.713727570165222, -4.101557970751061],
            [7.739765178179593, -4.0989785977860835],
            [7.746207352526109, -4.169994994758472],
            [7.750853960862537, -4.225900253143567],
            [7.752344215213879, -4.245409946909579],
            [7.764624152046177, -4.381934834099685],
            [7.766947714339123, -4.406223629166227],
            [7.734879834963487, -4.408368179023172],
            [7.730273066468962, -4.403961027093066],
            [7.727575689411844, -4.403219146794658],
            [7.719127164605399, -4.397847871445067],
            [7.716159323816138, -4.3979217660780865],
            [7.709930301296455, -4.401123273045486],
            [7.702364443406433, -4.401522245384877],
            [7.697148079751848, -4.413188339932268],
            [7.695850464263364, -4.4202859489531825],
            [7.69092745888558, -4.419642916389138],
            [7.688137358552463, -4.416028949966824],
            [7.680986299113249, -4.412678732335091],
            [7.6573640173827116, -4.4141476497031045],
            [7.63516725933029, -4.41616755655393],
            [7.556960495033111, -4.422119012173051],
            [7.515874755985963, -4.4260738043979115],
            [7.465491439794013, -4.429465849912619],
            [7.448595532861783, -4.431059945409084],
            [7.387603569579166, -4.432578834766176],
            [7.336555294689174, -4.435372601765614],
            [7.325301185538001, -4.3124280696395365],
            [7.3243177832517725, -4.295022385920234],
            [7.319522872063804, -4.227075498163743],
            [7.317813087129518, -4.207036166909393],
            [7.310697838177671, -4.130163571627537]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.37368980502318,
          "lat": 34.149206672954016
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01133"],
        "coty_name": ["Winston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winston County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00161592"
      },
      "bbox": [
        7.310697838177671, -4.435372601765614, 7.766947714339123,
        -4.0989785977860835
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-12.740105051650541, -11.752723130640646],
              [-12.740154946573156, -11.751362232203912],
              [-12.739572869469749, -11.747562562932172],
              [-12.738554365471835, -11.746783691382014],
              [-12.73742246863651, -11.746924440499095],
              [-12.73554274800042, -11.745077678080449],
              [-12.731173779907364, -11.752073267000133],
              [-12.72711004323873, -11.757284583403095],
              [-12.726880887242286, -11.760012436854723],
              [-12.728380232192604, -11.764462174461862],
              [-12.73000993816934, -11.767405583610104],
              [-12.731709102484054, -11.767982057825032],
              [-12.732756448124826, -11.763645616216113],
              [-12.7335971066127, -11.761232647397433],
              [-12.73534381092338, -11.75963336086934],
              [-12.736664153902103, -11.759189136675081],
              [-12.737871450453072, -11.756734431545235],
              [-12.739239247510106, -11.755001987680162],
              [-12.740105051650541, -11.752723130640646]
            ]
          ],
          [
            [
              [-12.743637478783542, -11.778553984499554],
              [-12.743713232759111, -11.776091316568158],
              [-12.741734248411946, -11.775590482174415],
              [-12.739531082608408, -11.779866655788414],
              [-12.739143421578566, -11.781603664252467],
              [-12.74016697170052, -11.782309718211778],
              [-12.742607022915083, -11.780261079341845],
              [-12.743637478783542, -11.778553984499554]
            ]
          ],
          [
            [
              [-12.72355936346448, -11.92753880857694],
              [-12.72271973832148, -11.926051518605856],
              [-12.721382714302683, -11.926260155045785],
              [-12.721511110257557, -11.927578431052916],
              [-12.722758092928741, -11.928730451271766],
              [-12.72355936346448, -11.92753880857694]
            ]
          ],
          [
            [
              [-12.754776513282424, -11.863991768179378],
              [-12.754466230031007, -11.863289520463198],
              [-12.756163853265358, -11.859963236920823],
              [-12.75581749421069, -11.857586158432815],
              [-12.753532503984932, -11.85686731470281],
              [-12.753007735696803, -11.852211751499873],
              [-12.752539254325752, -11.851612878256933],
              [-12.752959420712228, -11.849464959194473],
              [-12.752286301439728, -11.848873405488328],
              [-12.749861171731949, -11.850201432593382],
              [-12.748384154182924, -11.84948662474421],
              [-12.746775010254865, -11.851456045769982],
              [-12.745542762442891, -11.852172543058314],
              [-12.744298756660184, -11.854468696874552],
              [-12.743083695070187, -11.855468716921763],
              [-12.74317089218391, -11.859102727070155],
              [-12.744021513056632, -11.85932121806155],
              [-12.744727625859952, -11.861707198434203],
              [-12.743485527349721, -11.864995983403748],
              [-12.741638796506837, -11.866726682643703],
              [-12.741062976828099, -11.8692990454872],
              [-12.742039484442401, -11.870948539556492],
              [-12.743442330529714, -11.870765599183],
              [-12.745660778186476, -11.871343094279343],
              [-12.746909911797111, -11.869362729002798],
              [-12.749622570431466, -11.868250892415668],
              [-12.752273485909717, -11.867750671942234],
              [-12.754869036600502, -11.864736545135278],
              [-12.754776513282424, -11.863991768179378]
            ]
          ],
          [
            [
              [-12.793182294379502, -11.7732570159969],
              [-12.790916316608456, -11.771900907244865],
              [-12.790294054127779, -11.774781478243346],
              [-12.792681746170091, -11.773942695401598],
              [-12.793182294379502, -11.7732570159969]
            ]
          ],
          [
            [
              [-12.755610298532973, -11.886823345328871],
              [-12.755110373736338, -11.884746651214932],
              [-12.755433595449531, -11.881966296130505],
              [-12.754357643687781, -11.880917525643566],
              [-12.752388995258924, -11.87987433600873],
              [-12.751445608095251, -11.876573188152097],
              [-12.75028844332952, -11.87597111211236],
              [-12.749142009465611, -11.876561505892807],
              [-12.745696383004162, -11.874684336346313],
              [-12.744772878286852, -11.874995520554444],
              [-12.74649955032788, -11.877144639394595],
              [-12.747613220746285, -11.877533636445978],
              [-12.749379136064576, -11.880132149883766],
              [-12.748947606607652, -11.884540109976392],
              [-12.751442867566375, -11.885251980660195],
              [-12.752318057678353, -11.884962302652323],
              [-12.754753660883658, -11.887396726866404],
              [-12.755610298532973, -11.886823345328871]
            ]
          ],
          [
            [
              [-12.8174967057563, -11.81618067533552],
              [-12.81694118258446, -11.815422792979854],
              [-12.81433207040898, -11.815898893215659],
              [-12.812771164258107, -11.817229389955966],
              [-12.811321484259473, -11.816998596525615],
              [-12.80932176263926, -11.817315850670363],
              [-12.807713131845887, -11.816758821114473],
              [-12.80650361393356, -11.81690622173272],
              [-12.803889365300554, -11.818364401377181],
              [-12.80292256029425, -11.820689318083563],
              [-12.803831402259114, -11.821792411743937],
              [-12.805421966819857, -11.822540452806443],
              [-12.80825585338792, -11.82297968810101],
              [-12.81315986199576, -11.820121044357387],
              [-12.814040125286038, -11.818727040164447],
              [-12.816773638573506, -11.81721043425477],
              [-12.8174967057563, -11.81618067533552]
            ]
          ],
          [
            [
              [-12.786413086800877, -11.925768149286895],
              [-12.78528588398469, -11.923832742312184],
              [-12.785925516821443, -11.9218327824986],
              [-12.785557597514313, -11.918018231248471],
              [-12.783848598733329, -11.916239081775405],
              [-12.784174980517905, -11.914885064862412],
              [-12.785452944430462, -11.914374867407478],
              [-12.784393205971647, -11.912819680164722],
              [-12.781933095385934, -11.911216612914066],
              [-12.780152808303427, -11.912107785060568],
              [-12.77734063388506, -11.911928208943626],
              [-12.776287855893967, -11.910691875775903],
              [-12.774320822542565, -11.911200697450626],
              [-12.77347126259341, -11.91074783201322],
              [-12.77390684022121, -11.909431448329473],
              [-12.773036712842702, -11.906235889093217],
              [-12.77098446187391, -11.905524774969459],
              [-12.770118992055345, -11.9046696213067],
              [-12.766740906847323, -11.903815190543742],
              [-12.765594353075342, -11.901276301982756],
              [-12.764433481704348, -11.900119938539879],
              [-12.762526898279972, -11.901242050199137],
              [-12.760472209767268, -11.900091990472005],
              [-12.761076701814035, -11.897645376240535],
              [-12.762493406351417, -11.895639848025791],
              [-12.761562750694159, -11.895078665088437],
              [-12.759043222686245, -11.89487639439447],
              [-12.757012804097624, -11.893773377116975],
              [-12.75621574090358, -11.894963052337342],
              [-12.754979866922953, -11.894572454357807],
              [-12.753293385982627, -11.89319228975928],
              [-12.75236162823545, -11.890964128688148],
              [-12.750003192327373, -11.889428310069274],
              [-12.749191167464152, -11.888431381293524],
              [-12.746288992978238, -11.886942744220935],
              [-12.745968315647621, -11.887822434382652],
              [-12.743254710012081, -11.88992883230085],
              [-12.742795900582246, -11.893299518478848],
              [-12.745524620659399, -11.894489716667785],
              [-12.74498625294576, -11.896523794941096],
              [-12.742409785735505, -11.89836294389106],
              [-12.741850468341742, -11.900231502108298],
              [-12.737712961659279, -11.903789040676894],
              [-12.73721703849295, -11.905482233949078],
              [-12.738649893493665, -11.906895852617994],
              [-12.73833979394171, -11.909527875501896],
              [-12.73636232518878, -11.910942679675827],
              [-12.735320390275232, -11.910459606204249],
              [-12.733830847834522, -11.911091577322134],
              [-12.732845359208023, -11.90911829597249],
              [-12.730036063997169, -11.910361347528879],
              [-12.72826857565725, -11.909862508324887],
              [-12.7262381531412, -11.91086099202035],
              [-12.725885201865507, -11.912048858160436],
              [-12.727335978480856, -11.914861873611217],
              [-12.727904605460129, -11.91764458152994],
              [-12.72873093721082, -11.91972231531704],
              [-12.729969607032384, -11.920671754729371],
              [-12.730155179146456, -11.921611327022081],
              [-12.728033706305837, -11.924528432898821],
              [-12.730416987346238, -11.926911683829799],
              [-12.733701985027311, -11.928495342437765],
              [-12.734009249290688, -11.929437812640407],
              [-12.732127031272025, -11.930809174099341],
              [-12.731709931191586, -11.931618555581258],
              [-12.733023490164651, -11.934264123855238],
              [-12.73539942764528, -11.934217552426144],
              [-12.736181187435411, -11.935086376267881],
              [-12.740202469562247, -11.936327989988815],
              [-12.739946303977927, -11.933455162729372],
              [-12.74099225793915, -11.931473512405317],
              [-12.74376330737623, -11.932795514124557],
              [-12.74550551269829, -11.931692223990277],
              [-12.745155014250871, -11.93467092697457],
              [-12.745696411986392, -11.937881106504246],
              [-12.747149665913522, -11.939141509195567],
              [-12.747826224299235, -11.941086261509254],
              [-12.749542989662533, -11.941285018076606],
              [-12.751475088914663, -11.93976883075879],
              [-12.754153170016766, -11.93910814398832],
              [-12.754605724000532, -11.940775503372414],
              [-12.756915961382058, -11.94034449056548],
              [-12.758127606196457, -11.939691528265726],
              [-12.75983914814201, -11.936311085632784],
              [-12.762271032396395, -11.933856428298965],
              [-12.767168052837429, -11.93289093839323],
              [-12.76925080726587, -11.932857280662637],
              [-12.77213386528557, -11.932067612203344],
              [-12.773112902746721, -11.930143337652114],
              [-12.7729752752069, -11.929063688843534],
              [-12.774635121249663, -11.927613312580942],
              [-12.77553873724672, -11.929155917445565],
              [-12.777138845465979, -11.93034379739744],
              [-12.7798126010686, -11.930354175139033],
              [-12.78008410124734, -11.929376421600395],
              [-12.782865154770167, -11.92807488940343],
              [-12.783325330121883, -11.927360822899292],
              [-12.7861080955856, -11.926614918508866],
              [-12.786413086800877, -11.925768149286895]
            ]
          ],
          [
            [
              [-12.802097614653286, -11.90660335719152],
              [-12.801340756544029, -11.905669779234875],
              [-12.79898896025573, -11.906245811925418],
              [-12.797993476759384, -11.905863354066216],
              [-12.79588901739569, -11.906088426381674],
              [-12.7929059466544, -11.907515702129716],
              [-12.791824170705647, -11.91276818498844],
              [-12.790541622013546, -11.915654755321471],
              [-12.790629200513234, -11.916874025096208],
              [-12.791531079470404, -11.918532210532714],
              [-12.79329975731915, -11.919696666789514],
              [-12.794702581760108, -11.916811234751965],
              [-12.79470286748827, -11.914671548225462],
              [-12.796820010685586, -11.91306344634179],
              [-12.797822191999614, -11.910952558990585],
              [-12.800247274020519, -11.908936143318822],
              [-12.801403083298293, -11.908423098464167],
              [-12.802097614653286, -11.90660335719152]
            ]
          ],
          [
            [
              [-12.810561323081624, -11.929273958103355],
              [-12.809287147737333, -11.926499593942909],
              [-12.8072807399064, -11.924979129616384],
              [-12.8072944689652, -11.923359559161407],
              [-12.8082581642187, -11.922026471462557],
              [-12.807684455204654, -11.92012645090632],
              [-12.806988885271954, -11.919808152910548],
              [-12.805547434566495, -11.920778960691713],
              [-12.803824135437036, -11.920503791594287],
              [-12.802157315681395, -11.921198738874862],
              [-12.800492228549137, -11.920309437431097],
              [-12.798252233080763, -11.920569119001936],
              [-12.79551663733991, -11.921530184704457],
              [-12.798164015402612, -11.924422602217547],
              [-12.7995975565004, -11.924717376438567],
              [-12.801510910894653, -11.926722583830975],
              [-12.799975184839674, -11.928969399439898],
              [-12.800452082208723, -11.930124393485174],
              [-12.80289458953368, -11.930884228989612],
              [-12.803091451993595, -11.932933858791635],
              [-12.804247989304956, -11.933211818144763],
              [-12.805158117049569, -11.932255599963277],
              [-12.806538575364685, -11.932134889779865],
              [-12.809503331221864, -11.931209754439243],
              [-12.811226660058278, -11.930017237008027],
              [-12.810561323081624, -11.929273958103355]
            ]
          ],
          [
            [
              [-12.862848949629736, -11.80781723508842],
              [-12.863342200508693, -11.805875399499172],
              [-12.860774175522213, -11.806051298193896],
              [-12.85749564881182, -11.80716201476943],
              [-12.85585345171304, -11.807409276588668],
              [-12.852539848710737, -11.80924391868743],
              [-12.852290390201228, -11.80987052101984],
              [-12.850109623064995, -11.81098898042452],
              [-12.84776609735294, -11.811510880457986],
              [-12.848098882261366, -11.812681672130852],
              [-12.849229639176135, -11.813585879651828],
              [-12.853033493808931, -11.812557114053558],
              [-12.855681962764782, -11.811180936974642],
              [-12.858130776939555, -11.811062478247099],
              [-12.8602881099312, -11.809935339380324],
              [-12.862848949629736, -11.80781723508842]
            ]
          ],
          [
            [
              [-12.933963892331635, -11.639815592615014],
              [-12.93167318176666, -11.638690442773006],
              [-12.930235450480234, -11.638479506751395],
              [-12.927069899128794, -11.637067627337586],
              [-12.927069625321998, -11.636381570602481],
              [-12.928950331082474, -11.634826602898897],
              [-12.930670193911839, -11.636514861766287],
              [-12.931735083818637, -11.636341746986165],
              [-12.932039073969653, -11.634902326451263],
              [-12.930978191795296, -11.633459588634684],
              [-12.931989931596297, -11.631631499534077],
              [-12.931698980482754, -11.629941977881725],
              [-12.932989769775329, -11.628980679027727],
              [-12.930975805830155, -11.622644312031381],
              [-12.928058726560552, -11.619050196437124],
              [-12.926297720637411, -11.618446568441966],
              [-12.923982380034282, -11.62057078559757],
              [-12.92193765141147, -11.620628629120285],
              [-12.916385998582303, -11.62502482730799],
              [-12.914431934820783, -11.627643144972668],
              [-12.913024043437447, -11.627901714635737],
              [-12.91273957409259, -11.629011061565103],
              [-12.911305727900357, -11.630157839641436],
              [-12.910724674285781, -11.63257781924407],
              [-12.911053764261446, -11.634380208422746],
              [-12.91240154395593, -11.635127235097475],
              [-12.924039169912394, -11.636773073972707],
              [-12.924749792561512, -11.63825826980066],
              [-12.926640785432651, -11.638874665800309],
              [-12.927700592258484, -11.63830200903792],
              [-12.92970308732368, -11.63953802789473],
              [-12.930394408355548, -11.641482347993644],
              [-12.931766240130381, -11.64116906883923],
              [-12.932965785167667, -11.642369783852057],
              [-12.934020163110324, -11.641376878290185],
              [-12.933963892331635, -11.639815592615014]
            ]
          ],
          [
            [
              [-12.901579989841188, -11.740107268891622],
              [-12.901397034917062, -11.737823770537117],
              [-12.900797176700738, -11.736642449414042],
              [-12.89951156827286, -11.736135934377659],
              [-12.897838180676839, -11.73635903740055],
              [-12.897416415665408, -11.738937123101005],
              [-12.89883301537503, -11.742274336553375],
              [-12.898690416673881, -11.743604565356009],
              [-12.899599667265923, -11.744317624489677],
              [-12.900611953335135, -11.742895644055698],
              [-12.901579989841188, -11.740107268891622]
            ]
          ],
          [
            [
              [-12.85440173949984, -11.87975450718441],
              [-12.85357997897575, -11.879139920439998],
              [-12.852060998257402, -11.879893089371],
              [-12.853229883648812, -11.881150643651056],
              [-12.85440173949984, -11.87975450718441]
            ]
          ],
          [
            [
              [-12.956787307688877, -11.650777002506576],
              [-12.956385093779199, -11.64877511668588],
              [-12.95510534026765, -11.648485771988968],
              [-12.953088042933931, -11.649302668040056],
              [-12.951819650841612, -11.649259155716633],
              [-12.952524126891037, -11.651800663995896],
              [-12.953949056893125, -11.65230906880762],
              [-12.955910999536982, -11.651788043432862],
              [-12.956787307688877, -11.650777002506576]
            ]
          ],
          [
            [
              [-12.921059382356729, -11.757400268275353],
              [-12.919567325470819, -11.755917530636486],
              [-12.917662145184805, -11.754758414655647],
              [-12.917118583406758, -11.753621873489154],
              [-12.915717841241452, -11.7537805279917],
              [-12.91475182631253, -11.751377623423304],
              [-12.915261668456255, -11.749939664292045],
              [-12.912531898777877, -11.748230783726553],
              [-12.910294077258463, -11.747591410802501],
              [-12.909305763275672, -11.748060610600083],
              [-12.906714974916406, -11.746031169593321],
              [-12.90491594148971, -11.745418196730608],
              [-12.904158186348141, -11.74747934799104],
              [-12.903601756289605, -11.750586107004466],
              [-12.902709078303372, -11.751625269075912],
              [-12.902172344440263, -11.753836068839796],
              [-12.90245688185828, -11.75478803176576],
              [-12.90447058889995, -11.756133599396033],
              [-12.905929970917676, -11.761076521514418],
              [-12.907261381160675, -11.761749439039788],
              [-12.907768010628523, -11.762850222128773],
              [-12.909457516693216, -11.763497959255513],
              [-12.910735244002606, -11.764884898136193],
              [-12.910904519614602, -11.767361261416802],
              [-12.910090674971258, -11.769235402322149],
              [-12.91168673213547, -11.770852705181722],
              [-12.912089185441697, -11.769083104271743],
              [-12.913206805428478, -11.767898867742556],
              [-12.914622399609415, -11.767279848632098],
              [-12.915228627413985, -11.764090091218495],
              [-12.91666786978718, -11.763333135883402],
              [-12.916054644665609, -11.761195497825316],
              [-12.917380513585814, -11.760546670633062],
              [-12.919068203876618, -11.76070417876883],
              [-12.92018333217408, -11.757835402663689],
              [-12.921059382356729, -11.757400268275353]
            ]
          ],
          [
            [
              [-12.998579603343574, -11.744177806087995],
              [-12.995473217237903, -11.742979222033078],
              [-12.99399037052639, -11.741138871050767],
              [-12.993873679755955, -11.739579110668682],
              [-12.991186061160578, -11.735958953193617],
              [-12.989554420865277, -11.735342030819103],
              [-12.987860086120863, -11.733736178281868],
              [-12.985792370609152, -11.733223195437864],
              [-12.983305379665408, -11.73031216171344],
              [-12.98136608683098, -11.728684863920515],
              [-12.982434115278293, -11.725814964071729],
              [-12.982393373879471, -11.724871038373145],
              [-12.983459435714966, -11.722863249418875],
              [-12.983141150075282, -11.721518437802569],
              [-12.98485333456306, -11.718104452720516],
              [-12.985068225309902, -11.716638168387302],
              [-12.983218740425675, -11.712629817592596],
              [-12.983576442282752, -11.71182558114286],
              [-12.98103622519103, -11.710362938187746],
              [-12.98000929193006, -11.710413316161487],
              [-12.977306183810825, -11.71207232635105],
              [-12.976494878970287, -11.713239771525156],
              [-12.974422916971633, -11.713930808462715],
              [-12.971987309676756, -11.71351529825041],
              [-12.969013299185885, -11.71498009003922],
              [-12.966470922651224, -11.713496432945478],
              [-12.964867401093889, -11.71307113162502],
              [-12.964830907954253, -11.710425894736682],
              [-12.963462780426553, -11.709708501844023],
              [-12.96197509739364, -11.70763686160159],
              [-12.963313787542653, -11.706146368493963],
              [-12.964493251691696, -11.703707053464246],
              [-12.966822821697884, -11.70325331059494],
              [-12.968842588712345, -11.700914279999902],
              [-12.968198556965568, -11.69979962487876],
              [-12.96819002878283, -11.696723740686688],
              [-12.970412287317727, -11.693425071070402],
              [-12.970919934570608, -11.691566233661403],
              [-12.97002653490595, -11.689289680201782],
              [-12.968697185377813, -11.68729251589994],
              [-12.96807816817377, -11.684761163599891],
              [-12.968506558324448, -11.682361178969986],
              [-12.965999301819007, -11.679984663620177],
              [-12.967214588996955, -11.678720685911147],
              [-12.96812752387862, -11.675791365179924],
              [-12.968085204200586, -11.67425597158945],
              [-12.969804061973392, -11.673865409533883],
              [-12.970693549989125, -11.671921073072683],
              [-12.97353902903938, -11.671100946371181],
              [-12.974208175492842, -11.670101229869417],
              [-12.97841243336329, -11.666538828700938],
              [-12.983448037200624, -11.664297678184171],
              [-12.98750594962015, -11.661740175601334],
              [-12.988515999878768, -11.660694885853404],
              [-12.988092667680009, -11.658507294633443],
              [-12.989598349194113, -11.655634953446315],
              [-12.98787552111944, -11.653609688652054],
              [-12.987660331001408, -11.652260145442522],
              [-12.98532996253792, -11.649800793977219],
              [-12.982827771093724, -11.64875997708892],
              [-12.982056347815934, -11.647765693585193],
              [-12.982931225759033, -11.645301275918941],
              [-12.984235799760981, -11.644649740792417],
              [-12.984743545126255, -11.643229435163322],
              [-12.984715838288883, -11.640127794449654],
              [-12.983336735984224, -11.639580865002348],
              [-12.981383435404389, -11.637766277007875],
              [-12.981613954092929, -11.636338637179717],
              [-12.979570084978725, -11.635110086844783],
              [-12.976815373332682, -11.634655806443861],
              [-12.975656793762594, -11.632893356404729],
              [-12.9746289328889, -11.632139771026528],
              [-12.97323786500979, -11.62605821382658],
              [-12.974102338022279, -11.623535808832179],
              [-12.973494084367113, -11.62146320428083],
              [-12.974750144566075, -11.619982183158674],
              [-12.977064682264247, -11.619309378622344],
              [-12.978275863119487, -11.617778475757147],
              [-12.981144799925431, -11.616617455186187],
              [-12.982662077524873, -11.615135130958132],
              [-12.983174890492723, -11.613780531490866],
              [-12.982136060395389, -11.6099779577628],
              [-12.979892978126378, -11.6078179130974],
              [-12.980800841004609, -11.60605920229089],
              [-12.981402204208147, -11.601949268766539],
              [-12.981043528405593, -11.600520724912034],
              [-12.982637452012545, -11.59760833388136],
              [-12.981598270871393, -11.595177029025733],
              [-12.98132324248883, -11.592283531290462],
              [-12.978782055586192, -11.590666555059466],
              [-12.97607539062045, -11.591441297365098],
              [-12.97484714646031, -11.590132328701946],
              [-12.974904179916015, -11.588796345410415],
              [-12.97590840324237, -11.58678986505373],
              [-12.977539843993378, -11.586110911264695],
              [-12.978337220326983, -11.585095111654592],
              [-12.977972378992016, -11.583898143087263],
              [-12.97662260203243, -11.584127726181167],
              [-12.974019168014882, -11.582916296197254],
              [-12.972774510670723, -11.583962604866576],
              [-12.971523998300384, -11.582934218944553],
              [-12.97119674072184, -11.581590417587766],
              [-12.967087122097407, -11.580164370523988],
              [-12.963779716632871, -11.577090594103849],
              [-12.96313123290617, -11.575774018784902],
              [-12.96191712627117, -11.575928335731565],
              [-12.96107506944027, -11.575192652194353],
              [-12.958026267193354, -11.575423005661754],
              [-12.955715178605141, -11.577556031351984],
              [-12.953791350715704, -11.576338105404513],
              [-12.952100998151817, -11.577209513301653],
              [-12.950560488532775, -11.575542814704882],
              [-12.9502276915879, -11.573792773676415],
              [-12.950618741551496, -11.572700299666373],
              [-12.948959454812409, -11.571185904052143],
              [-12.948808820009875, -11.569937359024292],
              [-12.950066951573302, -11.567198137266933],
              [-12.953095945689471, -11.567288783990337],
              [-12.952939191128447, -11.564820559280802],
              [-12.954365942759834, -11.564059595217298],
              [-12.955647207657126, -11.56425434011364],
              [-12.956031563420934, -11.562439032585667],
              [-12.95434977242324, -11.560855650943074],
              [-12.953602767035113, -11.559518919149117],
              [-12.951022127984283, -11.557474189665616],
              [-12.949571132736459, -11.558774247700129],
              [-12.946904690881937, -11.560534158201687],
              [-12.945343810924376, -11.560468797977645],
              [-12.94233715231471, -11.56101082861348],
              [-12.940251469551306, -11.55921839900947],
              [-12.93945604703052, -11.559609901417197],
              [-12.938768095620992, -11.561345984601202],
              [-12.936746740663791, -11.562595839558831],
              [-12.93550578318113, -11.564365572693132],
              [-12.933676555432557, -11.565366095542707],
              [-12.931819985124564, -11.56517114504947],
              [-12.929888343189697, -11.5662466809408],
              [-12.928964941204091, -11.566224735298963],
              [-12.926983218251845, -11.564942691328705],
              [-12.924740974912439, -11.56591466926862],
              [-12.92187697155844, -11.565900423626285],
              [-12.921033111516788, -11.567091568091662],
              [-12.920933383309992, -11.570261172934627],
              [-12.920003955308076, -11.57171796555185],
              [-12.918263454618698, -11.571673939681565],
              [-12.917318454751618, -11.572303059275873],
              [-12.913848099426291, -11.571508016588451],
              [-12.912932974263596, -11.573502077589655],
              [-12.912723962379275, -11.575141471762073],
              [-12.910459435088962, -11.574846153993088],
              [-12.908083990557989, -11.572051093381885],
              [-12.905185120096828, -11.571202230660479],
              [-12.901238586050612, -11.568944067267616],
              [-12.899063446639966, -11.568210912088723],
              [-12.89779130269221, -11.567334437946055],
              [-12.894312572489024, -11.567537455089564],
              [-12.890163437063284, -11.569397999506636],
              [-12.888646327835183, -11.568931967590078],
              [-12.887807371436036, -11.566931745161426],
              [-12.889611453678691, -11.564794457547096],
              [-12.891162768717727, -11.563959293770953],
              [-12.892592923310172, -11.56238840326218],
              [-12.89396080870614, -11.559735834429208],
              [-12.893605168586902, -11.557759315723219],
              [-12.89587273087694, -11.556918364629114],
              [-12.895952486713195, -11.556235743616883],
              [-12.894677712238519, -11.554434373968723],
              [-12.895131089687785, -11.55266803828997],
              [-12.894797767204748, -11.550429489421909],
              [-12.897315927894907, -11.549457857215055],
              [-12.897962193723915, -11.547965365371613],
              [-12.902130817895895, -11.547740521771562],
              [-12.903588984089284, -11.546277528815617],
              [-12.904438099983022, -11.54471798251303],
              [-12.906192636363231, -11.543857735334399],
              [-12.908211499023137, -11.543458628154948],
              [-12.909635150533264, -11.542250289256142],
              [-12.90925585751702, -11.539992494648592],
              [-12.911293746477908, -11.538348261394397],
              [-12.911815052840527, -11.53716374155435],
              [-12.913029607616526, -11.537004257367844],
              [-12.914719002316943, -11.535575562503846],
              [-12.915488817537335, -11.53215624375258],
              [-12.914649494041514, -11.530418065405785],
              [-12.913212034827842, -11.52967922384993],
              [-12.91066261581316, -11.530818981534402],
              [-12.908330739738156, -11.53036065230484],
              [-12.907321931607052, -11.529331171262115],
              [-12.906327148949018, -11.525752776883602],
              [-12.904684277150416, -11.525075796616623],
              [-12.903914421816408, -11.524007800460872],
              [-12.90291828188726, -11.521168059442438],
              [-12.903560815017244, -11.519341660788871],
              [-12.903431132356882, -11.517410369438776],
              [-12.901787024094926, -11.512316451175009],
              [-12.899883625569524, -11.512584774239052],
              [-12.899045025394651, -11.51109906847087],
              [-12.898933243275028, -11.506830373614688],
              [-12.896132232866034, -11.506497196135648],
              [-12.89504033091087, -11.505381500640542],
              [-12.895864304899632, -11.503519746702912],
              [-12.89593394161246, -11.502214439822836],
              [-12.895145581430087, -11.501559178593975],
              [-12.892520846671994, -11.500991376916884],
              [-12.891633661592612, -11.499272338911823],
              [-12.889616413758425, -11.498712449376214],
              [-12.887587928109484, -11.50114328258535],
              [-12.887140077207702, -11.503702336822856],
              [-12.886055488114934, -11.505236244353124],
              [-12.884880395519462, -11.505915458788552],
              [-12.883227196606924, -11.508963636534299],
              [-12.881575234174568, -11.50860368541019],
              [-12.880053130145496, -11.505678110164599],
              [-12.879159346890528, -11.503139055436195],
              [-12.876049938438221, -11.500630323729178],
              [-12.873690170666814, -11.499553963065441],
              [-12.87059717203175, -11.49943462437283],
              [-12.868422177801312, -11.498218394922452],
              [-12.867937795039756, -11.496672055427736],
              [-12.86899186978322, -11.495559435962747],
              [-12.86530457855208, -11.492591974662002],
              [-12.861385448189097, -11.493091529210897],
              [-12.861334288748024, -11.49077250865869],
              [-12.860221734647656, -11.48922942012082],
              [-12.859082885755198, -11.486102604014985],
              [-12.859115341666389, -11.482333188527035],
              [-12.857061698992904, -11.480131249641108],
              [-12.85798737486417, -11.476705874851282],
              [-12.85610724082344, -11.47515480631492],
              [-12.855446438109814, -11.473356772054101],
              [-12.85252669972989, -11.471686146354443],
              [-12.851293620952202, -11.469550650275576],
              [-12.850894640278325, -11.465205550245802],
              [-12.851340070562836, -11.462823010879562],
              [-12.851029509142348, -11.460435284201596],
              [-12.851854575409728, -11.459447689480989],
              [-12.85343664426174, -11.461803907807242],
              [-12.854537284691126, -11.462109986830503],
              [-12.855943034939916, -11.46020374617734],
              [-12.859425866034945, -11.459573605395954],
              [-12.861025138072339, -11.457379400709922],
              [-12.861495354638924, -11.455005685232333],
              [-12.860165581311303, -11.452221602132642],
              [-12.858257622391049, -11.450574938009039],
              [-12.858435846171597, -11.44857402658254],
              [-12.859871600704066, -11.44802593706118],
              [-12.86286989351579, -11.448234490480845],
              [-12.86453799116571, -11.447998826657125],
              [-12.867698636731417, -11.446304926372546],
              [-12.870245113151318, -11.4462792008593],
              [-12.87263686133546, -11.447169322992353],
              [-12.874939596897512, -11.447453288149456],
              [-12.876065390326234, -11.447141446607183],
              [-12.87822198605525, -11.445562318827639],
              [-12.881087279691556, -11.442449381694859],
              [-12.882176121974238, -11.440688810981825],
              [-12.881663986981097, -11.438403997072706],
              [-12.882438575701737, -11.434025392763072],
              [-12.880006617085442, -11.431648013035316],
              [-12.87976958444056, -11.430584486076242],
              [-12.880303438226074, -11.425808338189082],
              [-12.882845291103223, -11.423664695119015],
              [-12.84296309601734, -11.419025242198185],
              [-12.822629369051608, -11.4166108582225],
              [-12.812074943504175, -11.422281958901069],
              [-12.781707971147771, -11.43850889892553],
              [-12.764276185094596, -11.439333835995399],
              [-12.750506272924566, -11.435959608226074],
              [-12.730518680163335, -11.465884181117],
              [-12.715069242011738, -11.465032220390468],
              [-12.692288692004588, -11.468424040349866],
              [-12.694069823725114, -11.468994186319632],
              [-12.696124862515791, -11.474045292460223],
              [-12.696710105973521, -11.476268620973519],
              [-12.69512233922648, -11.480253380720685],
              [-12.695786197247463, -11.483129455264372],
              [-12.695608488328991, -11.484443078340849],
              [-12.694023349894287, -11.487117840319273],
              [-12.692147324680429, -11.488647018708688],
              [-12.689657457106025, -11.489631518658296],
              [-12.686034437196966, -11.490024219623564],
              [-12.6847515876129, -11.490721793727278],
              [-12.68383691124087, -11.49349639332153],
              [-12.683125965790783, -11.494358225402529],
              [-12.680162853786337, -11.495853457602749],
              [-12.678886083738726, -11.495979915403026],
              [-12.677605926356257, -11.496976522403587],
              [-12.67612592481991, -11.49686328330736],
              [-12.675839138794341, -11.498380177263792],
              [-12.678174683103284, -11.499565088045953],
              [-12.6792398312785, -11.500685221962485],
              [-12.67896804881826, -11.502493789151067],
              [-12.680473744736464, -11.503625069923991],
              [-12.681426550313137, -11.505271444395637],
              [-12.684053195076498, -11.504594415283378],
              [-12.686653615164479, -11.503061854881741],
              [-12.687874159319193, -11.502901485718235],
              [-12.688925597557315, -11.503669843926662],
              [-12.691755791827235, -11.50901301871694],
              [-12.692389397053185, -11.510839648675736],
              [-12.691820058837916, -11.512634308690863],
              [-12.690088317816022, -11.514392764310454],
              [-12.691587283811858, -11.515975538783085],
              [-12.69433969375565, -11.51600222743237],
              [-12.695839737996666, -11.516753808549117],
              [-12.69805728363412, -11.51920392212883],
              [-12.700227621665377, -11.522471214475663],
              [-12.699454409920254, -11.52492763864692],
              [-12.699490905225856, -11.527268431414985],
              [-12.697921716187885, -11.528522833713929],
              [-12.696325207234793, -11.527947236478994],
              [-12.695240533591802, -11.52830281065807],
              [-12.694756946224238, -11.530084087249532],
              [-12.691549685321837, -11.531612512563493],
              [-12.689423073684905, -11.532063586461776],
              [-12.687179180742906, -11.533483036356998],
              [-12.68451801010947, -11.536084599946026],
              [-12.68350800235717, -11.535926442220168],
              [-12.6813102644267, -11.532966503784486],
              [-12.680571661875254, -11.532995055289051],
              [-12.678380609091052, -11.535545486262919],
              [-12.674275834151358, -11.538651381528517],
              [-12.673361655793988, -11.54125987035436],
              [-12.673109579922318, -11.5440501725146],
              [-12.673642346263673, -11.545708870072025],
              [-12.671359258877832, -11.548452003185572],
              [-12.668713538565944, -11.549435278848414],
              [-12.666921778408298, -11.550905264271625],
              [-12.664274831938286, -11.551719310064602],
              [-12.662383563380452, -11.553324753341254],
              [-12.65980689643104, -11.554956164265342],
              [-12.65632956460025, -11.557867587356208],
              [-12.655405161106136, -11.55825856805811],
              [-12.653664879376366, -11.557917329176469],
              [-12.650492085400499, -11.557939657333696],
              [-12.649393950674874, -11.558892232663455],
              [-12.647443219909416, -11.559497466067887],
              [-12.645440283487805, -11.561954513823682],
              [-12.64452163850094, -11.563712794784067],
              [-12.642376836301061, -11.564295476187638],
              [-12.636395395435846, -11.567308596775195],
              [-12.63438138036942, -11.567848306576307],
              [-12.634388665972464, -11.568272514768836],
              [-12.627274611387975, -11.58444218076246],
              [-12.616602759755134, -11.59229627518827],
              [-12.607049590871785, -11.62611812540218],
              [-12.589760518101816, -11.650189653361549],
              [-12.575025516924029, -11.661704713159702],
              [-12.557214570162836, -11.69683704776773],
              [-12.544287794579823, -11.70581423940424],
              [-12.541538846766564, -11.711559653961675],
              [-12.554517611444366, -11.749078964624704],
              [-12.556486960566563, -11.76802257813778],
              [-12.555425387234576, -11.774304114449373],
              [-12.556656897950823, -11.78696766890702],
              [-12.554419110444496, -11.79654258631263],
              [-12.559640372885093, -11.83096289827962],
              [-12.566314323864002, -11.853556986495079],
              [-12.575530821470203, -11.873507521148781],
              [-12.579432098269777, -11.884017490459971],
              [-12.593197747864915, -11.909543170214276],
              [-12.603553885815849, -11.91671017005374],
              [-12.606902749361653, -11.925082565567418],
              [-12.598169693281612, -11.9305955518601],
              [-12.600988678170935, -11.93249916154194],
              [-12.59976076753937, -11.935149658651069],
              [-12.601084508180449, -11.937259718125784],
              [-12.602887557066452, -11.936955757266754],
              [-12.604532930498735, -11.937345711310476],
              [-12.60712506026417, -11.936573916166404],
              [-12.608326733753167, -11.93705447297965],
              [-12.608702002434754, -11.938239501116902],
              [-12.606850426159019, -11.940178154796184],
              [-12.606421009862645, -11.941325299980369],
              [-12.608552369419442, -11.941238024149358],
              [-12.611493086206583, -11.93843855526382],
              [-12.614893939936223, -11.937555845011545],
              [-12.618068804931877, -11.935489910893452],
              [-12.62021405778985, -11.935119024828232],
              [-12.622577418537277, -11.932452585844073],
              [-12.624371130928045, -11.92960066272889],
              [-12.625596771803739, -11.928334021748988],
              [-12.625458477355188, -11.927335241883263],
              [-12.623644474922626, -11.925487922105193],
              [-12.623621625046095, -11.924180750211654],
              [-12.625990502567564, -11.921530657181108],
              [-12.626184903504473, -11.920052180054418],
              [-12.627364742331311, -11.918244292530765],
              [-12.627177629491927, -11.91616248999133],
              [-12.62969499880864, -11.914615673586242],
              [-12.63103326520943, -11.915543168542714],
              [-12.631047890624705, -11.917145847577117],
              [-12.632793122637946, -11.917119914079256],
              [-12.635565924436571, -11.914273491921238],
              [-12.637441027936765, -11.913138964021227],
              [-12.638434980095088, -11.914546313473188],
              [-12.635261970407221, -11.923713363457093],
              [-12.63487280882045, -11.926329286627602],
              [-12.635838987734978, -11.92799234591328],
              [-12.635989099816825, -11.929503596635218],
              [-12.637687264654225, -11.932107652790712],
              [-12.63938420580186, -11.933150881628928],
              [-12.64013076199133, -11.934714912125779],
              [-12.64217747392987, -11.936492170402381],
              [-12.641624295403718, -11.937843806834781],
              [-12.643880722953526, -11.939195390646137],
              [-12.644602305528684, -11.938353053031497],
              [-12.648972438585073, -11.936210605077255],
              [-12.652511548312708, -11.936248927587839],
              [-12.658823955463465, -11.933921189173352],
              [-12.660236844908841, -11.932121872600073],
              [-12.663694789870014, -11.931600753869319],
              [-12.666300683825522, -11.927037862482905],
              [-12.667476724705153, -11.927304593463804],
              [-12.669656314180358, -11.92333977453849],
              [-12.669398718832527, -11.921784589387343],
              [-12.669774552336287, -11.9188777594103],
              [-12.669633293819096, -11.917201601147593],
              [-12.670085614677063, -11.916116118250574],
              [-12.671974596999087, -11.915140952646281],
              [-12.67339248838932, -11.915282717382382],
              [-12.675022148287086, -11.912907279091234],
              [-12.677909854301467, -11.906384720533111],
              [-12.677941816783168, -11.903957142564758],
              [-12.680032160898158, -11.900384418044183],
              [-12.683120291406068, -11.897756909408983],
              [-12.683584300289878, -11.896051236724416],
              [-12.68578631575089, -11.895488093988286],
              [-12.686281472672446, -11.894146975264086],
              [-12.68566780754931, -11.891330484806495],
              [-12.68440471042685, -11.890519918543315],
              [-12.682263569501108, -11.890559397176862],
              [-12.681842612326493, -11.889977019487688],
              [-12.683388312777756, -11.885108371994958],
              [-12.685574859147177, -11.882632653330383],
              [-12.688900343716213, -11.882071371584784],
              [-12.69151622543653, -11.87996838896825],
              [-12.693576251679596, -11.87679724545271],
              [-12.696843476448331, -11.87499347633783],
              [-12.697420753306224, -11.873606847050523],
              [-12.69903966641716, -11.873318585117792],
              [-12.700762500951893, -11.875235490169759],
              [-12.702480868002437, -11.872913116708384],
              [-12.70310031662229, -11.869855845693522],
              [-12.702735688503056, -11.86754348046168],
              [-12.703579992013648, -11.864842891766846],
              [-12.704680106254717, -11.862474717463213],
              [-12.70377048776477, -11.861161574158741],
              [-12.70527209214618, -11.859906338544192],
              [-12.706098611720531, -11.85821422159661],
              [-12.704451150555277, -11.858078925703756],
              [-12.703532780307304, -11.85713431374465],
              [-12.704419869668664, -11.85603428611899],
              [-12.7048023412484, -11.85431020393954],
              [-12.706415205312314, -11.853714503454153],
              [-12.706786341926101, -11.852432900202428],
              [-12.70525422053056, -11.851643653060057],
              [-12.705873405892351, -11.849210243428365],
              [-12.704865510759369, -11.847961693254287],
              [-12.702818688231122, -11.84699032807103],
              [-12.702352243866184, -11.845726368044714],
              [-12.6970066098739, -11.842231481175526],
              [-12.695739006792353, -11.842030113582442],
              [-12.695078020063413, -11.840531898234609],
              [-12.69295670171344, -11.838738715053651],
              [-12.69228396127071, -11.837136845325176],
              [-12.689920628129379, -11.834290422389804],
              [-12.689380376796723, -11.833191094135309],
              [-12.687168227436088, -11.83140440229487],
              [-12.687491913518022, -11.82912797171402],
              [-12.686429125711465, -11.828142927469422],
              [-12.686247654837665, -11.82597218149445],
              [-12.686709106375515, -11.825172442097504],
              [-12.685934221243341, -11.823408076906212],
              [-12.685057577304745, -11.823058312812943],
              [-12.681034625215299, -11.82277993846725],
              [-12.679792714165663, -11.82508783521589],
              [-12.678370180275339, -11.826588297768017],
              [-12.677719979436299, -11.829505702033673],
              [-12.675372773883268, -11.831050005923217],
              [-12.67442860792606, -11.832499032625314],
              [-12.672686868964787, -11.833639359213947],
              [-12.66968780234663, -11.83448034936394],
              [-12.668906270086104, -11.833770604261904],
              [-12.665895820913901, -11.832209136407066],
              [-12.665398622260168, -11.830583827673511],
              [-12.66366933599841, -11.82818894276404],
              [-12.661303351237667, -11.825904406375402],
              [-12.659449638657213, -11.824769078790359],
              [-12.658224035913356, -11.822818133276106],
              [-12.658383988623399, -11.81893139321756],
              [-12.659098300599283, -11.81817033402808],
              [-12.659376916781596, -11.813360120147776],
              [-12.659253286552165, -11.812200125035734],
              [-12.660590404190447, -11.810854294056028],
              [-12.662572984514266, -11.810091525243829],
              [-12.665239217865208, -11.811764206548382],
              [-12.663792828419485, -11.816452579470925],
              [-12.665010241638722, -11.817532466937884],
              [-12.66328083964083, -11.820194178246483],
              [-12.66312344339941, -11.821842098869485],
              [-12.666604712938343, -11.82588868903042],
              [-12.668122562201873, -11.826777842439249],
              [-12.669843572326092, -11.825829819939324],
              [-12.671852195782924, -11.82587696215511],
              [-12.673503634931045, -11.824978546439272],
              [-12.675943350483795, -11.821213038229303],
              [-12.67642598009972, -11.819575695688897],
              [-12.680383811426438, -11.815535664415883],
              [-12.681617125799653, -11.814711636705171],
              [-12.682413752777137, -11.81286594521768],
              [-12.684821649163256, -11.814416731846812],
              [-12.684538884355064, -11.81701562462816],
              [-12.684847486004736, -11.817818944159287],
              [-12.687802542141357, -11.820781766018516],
              [-12.689530076905937, -11.821218461969993],
              [-12.690692600511156, -11.822721554522023],
              [-12.690359567182162, -11.8256727212366],
              [-12.6915486389651, -11.827781552888931],
              [-12.691441394570642, -11.828412640464474],
              [-12.692984389871327, -11.831487536788464],
              [-12.695480698010282, -11.83356224785881],
              [-12.697102193705476, -11.83582425565052],
              [-12.6999434636761, -11.838191405920872],
              [-12.706483974181097, -11.84295834723869],
              [-12.708784336503042, -11.843994539582596],
              [-12.710624691523956, -11.84387644263559],
              [-12.712412348534809, -11.843145153134708],
              [-12.713838645006991, -11.844218516123023],
              [-12.715980610937768, -11.843760430952827],
              [-12.719183835330648, -11.839319182831646],
              [-12.721428339849785, -11.840159910584873],
              [-12.72268547845945, -11.839216641835725],
              [-12.722705447786119, -11.837788265580166],
              [-12.72476526610312, -11.836929991824956],
              [-12.726970343647478, -11.837375894283191],
              [-12.728145705973674, -11.836808762408321],
              [-12.72954581279343, -11.835198888987764],
              [-12.730246100569314, -11.83366418279458],
              [-12.729226862747145, -11.832835391010297],
              [-12.730375446555872, -11.831978407096559],
              [-12.731021807584881, -11.830425048670937],
              [-12.732291941799016, -11.82967957724222],
              [-12.733182862023863, -11.827773485630804],
              [-12.735212970856221, -11.826163626537195],
              [-12.735825902080439, -11.825044436822289],
              [-12.735914281476502, -11.822603977660057],
              [-12.737441424790118, -11.821263088239792],
              [-12.739146653154087, -11.818258140530592],
              [-12.740073349636502, -11.815835347365676],
              [-12.739324505809531, -11.813797928961607],
              [-12.7380050138406, -11.813407579624885],
              [-12.737795250177903, -11.811596730363473],
              [-12.734210394715028, -11.80493408935104],
              [-12.733950029785099, -11.802730433668348],
              [-12.732321844095665, -11.801502430241827],
              [-12.731761906817844, -11.798984058511323],
              [-12.731004439297527, -11.798371412425032],
              [-12.7312392732168, -11.796920201507058],
              [-12.730111573623676, -11.794501209470216],
              [-12.728785372788115, -11.793860144669514],
              [-12.726346504362269, -11.791862636146037],
              [-12.726988158080285, -11.790806083186045],
              [-12.726108427568152, -11.78827335244511],
              [-12.725763835440716, -11.785930374325567],
              [-12.724985229840263, -11.785309468458982],
              [-12.724173889821225, -11.780753520661133],
              [-12.723189585688406, -11.780281488768786],
              [-12.725212032229882, -11.77569357157122],
              [-12.724378711124354, -11.772907087294636],
              [-12.722727237977194, -11.772198788176635],
              [-12.722898188628239, -11.771396146144685],
              [-12.72147097997104, -11.769917658548447],
              [-12.718452064496793, -11.768783887480048],
              [-12.715965194076707, -11.769652517582914],
              [-12.715080454462507, -11.768030886211337],
              [-12.713680571734994, -11.76773135326612],
              [-12.712924985400164, -11.76936237272404],
              [-12.711140841556203, -11.768876523024051],
              [-12.710570104888014, -11.768106264008528],
              [-12.708792071845863, -11.767400105274138],
              [-12.707546112139106, -11.767500008145813],
              [-12.707734509013283, -11.764364898394778],
              [-12.709258854243066, -11.763495356798858],
              [-12.709592526521329, -11.762528300750454],
              [-12.713094213474912, -11.762102675901174],
              [-12.713931604497567, -11.760736616057185],
              [-12.713857630819746, -11.759580890801052],
              [-12.716162777977699, -11.75709641214121],
              [-12.717745887113518, -11.753640800835806],
              [-12.718084473042735, -11.75137052634762],
              [-12.719608706610178, -11.749787379699189],
              [-12.721017229134006, -11.74746027241582],
              [-12.721258658934124, -11.745181296486368],
              [-12.722293409307264, -11.743135262470759],
              [-12.722684180709685, -11.74086075439561],
              [-12.72226015784522, -11.739700504497717],
              [-12.724986815016019, -11.736410375826068],
              [-12.725619508705009, -11.734567481121553],
              [-12.728421890430823, -11.732019173480698],
              [-12.728402956754817, -11.73464535469975],
              [-12.726808874195509, -11.737254131249369],
              [-12.729499088685289, -11.736092834898518],
              [-12.73198551284422, -11.733128811475842],
              [-12.732728201838974, -11.731235188607],
              [-12.734993417649019, -11.728029775806599],
              [-12.736429152221442, -11.728760349417128],
              [-12.737474214448737, -11.725663932693141],
              [-12.737913545351498, -11.722741384340855],
              [-12.737208091853438, -11.720824798969595],
              [-12.738055526226246, -11.717586211491499],
              [-12.736551307279722, -11.71474242351768],
              [-12.736902690961905, -11.71277854807195],
              [-12.736743912845613, -11.709012362798923],
              [-12.736103049973961, -11.707089847019587],
              [-12.734613864701275, -11.706781738895131],
              [-12.73405615940429, -11.705920242761621],
              [-12.736009967710155, -11.70531296148954],
              [-12.736542874699914, -11.70326706127957],
              [-12.735705529423948, -11.701201435651607],
              [-12.736208303480796, -11.699980611246843],
              [-12.737340462650229, -11.699155343366032],
              [-12.73934864689419, -11.695425965186148],
              [-12.73984070054975, -11.693318682310975],
              [-12.739191549493636, -11.691933865688814],
              [-12.740437246217375, -11.689113272775707],
              [-12.740299523876667, -11.687731757663336],
              [-12.739092815533201, -11.687948517839455],
              [-12.734943477283638, -11.686250917536203],
              [-12.731292692319778, -11.685098016598442],
              [-12.729510510796926, -11.682352305546804],
              [-12.73162931029595, -11.681095360003539],
              [-12.732768108824684, -11.6813296695728],
              [-12.733361680444384, -11.68323395892895],
              [-12.73592293612455, -11.68368295898599],
              [-12.740720958030542, -11.683882343084353],
              [-12.742692401281975, -11.683565244559666],
              [-12.746961156838852, -11.676032030949846],
              [-12.748551705449072, -11.671402146651683],
              [-12.750874399834105, -11.667425663553864],
              [-12.751534196742055, -11.667194834249567],
              [-12.752582509366045, -11.664163009205591],
              [-12.754965214688267, -11.659819246043954],
              [-12.757307519788908, -11.657469101195993],
              [-12.758354763006347, -11.655247162720674],
              [-12.758958879666391, -11.652672216158683],
              [-12.759887959961812, -11.65150996106135],
              [-12.76359351045677, -11.644193190980392],
              [-12.764475914272728, -11.640488805347395],
              [-12.763929328810425, -11.6378348345506],
              [-12.765342958329107, -11.635160193865124],
              [-12.766745524830096, -11.635609356947423],
              [-12.768410786628312, -11.633464076764135],
              [-12.769644496471145, -11.633022793355744],
              [-12.77161771962087, -11.631181857792814],
              [-12.77228228688556, -11.629929029776061],
              [-12.775626847249047, -11.627208650799073],
              [-12.778207654834885, -11.624394450730524],
              [-12.780955936972633, -11.622679358792341],
              [-12.783797192150404, -11.619831359448957],
              [-12.785633362200404, -11.619206261605157],
              [-12.787017863600774, -11.617703751311597],
              [-12.787020593264746, -11.616753455139207],
              [-12.784695501561819, -11.612310380915126],
              [-12.785697117691187, -11.61031178313355],
              [-12.78676427692852, -11.60964139331404],
              [-12.786132521932648, -11.606712195485457],
              [-12.791736328878994, -11.613059258918943],
              [-12.792609984055353, -11.613855731352599],
              [-12.79622337781593, -11.61213563161789],
              [-12.799900381746145, -11.609025130837413],
              [-12.800749909571518, -11.607863723272091],
              [-12.80596302751716, -11.603470732065864],
              [-12.808013157175044, -11.601200269944403],
              [-12.81127215843055, -11.598943058529187],
              [-12.812662754649269, -11.597316948057628],
              [-12.814100561999886, -11.5971310924146],
              [-12.815507546756155, -11.596048258120714],
              [-12.818991128989028, -11.59222661926625],
              [-12.820699174226952, -11.592025676202601],
              [-12.82317914889327, -11.589179913603775],
              [-12.825141792107354, -11.58848536850911],
              [-12.826487903050143, -11.588594196455578],
              [-12.830395894071023, -11.586032541971074],
              [-12.834727702816556, -11.582915993077812],
              [-12.836067527275635, -11.58168724624317],
              [-12.83929095426829, -11.581191795341812],
              [-12.845446184920469, -11.577939450034172],
              [-12.848300958935, -11.575312301722612],
              [-12.850548462396238, -11.572353640863788],
              [-12.852843668860482, -11.570393669139643],
              [-12.855775533987195, -11.56952905574618],
              [-12.85663317669714, -11.568305744505215],
              [-12.856595336471255, -11.566578016302339],
              [-12.852572119450748, -11.55930577866227],
              [-12.849962056803818, -11.557604705140802],
              [-12.848493363724636, -11.555684251225196],
              [-12.845643968917356, -11.550661871868611],
              [-12.844659334253343, -11.549443727350369],
              [-12.843574941302832, -11.546882594922975],
              [-12.842292217295245, -11.546479992370887],
              [-12.841336222227092, -11.544108707791585],
              [-12.841675501695711, -11.54224196171409],
              [-12.84093476721396, -11.541303369143058],
              [-12.843435188515988, -11.540439772187355],
              [-12.844805891377135, -11.537709314557945],
              [-12.847241550230912, -11.538131823236844],
              [-12.84889572891484, -11.54001524071139],
              [-12.850196005639143, -11.544100708560816],
              [-12.851058428935007, -11.545298239412745],
              [-12.851306840624943, -11.547588374079258],
              [-12.852904170232213, -11.549435547172195],
              [-12.85441730829426, -11.549866339002802],
              [-12.855597816606933, -11.552169162667735],
              [-12.857223585797573, -11.553658844010531],
              [-12.857026233451132, -11.554924961012459],
              [-12.859267841045565, -11.558733871157205],
              [-12.859010578771406, -11.559615789924225],
              [-12.86133566231213, -11.562381104050363],
              [-12.862534315894237, -11.562492224401707],
              [-12.863549105101049, -11.56384720614138],
              [-12.86670934505948, -11.565791768321242],
              [-12.868768631185826, -11.567502695229052],
              [-12.870231126299956, -11.567771734030034],
              [-12.870757602505469, -11.568802294510714],
              [-12.872950026798788, -11.569858271690071],
              [-12.872640890078753, -11.570574032771365],
              [-12.874575634160111, -11.57224116733828],
              [-12.874716074878195, -11.575157172715267],
              [-12.875709889247908, -11.577407946546922],
              [-12.876509871096427, -11.578194990103963],
              [-12.877902399670578, -11.581635365657373],
              [-12.88007836603271, -11.582779566627687],
              [-12.878981794526428, -11.586420383470989],
              [-12.877349850931187, -11.586701360467655],
              [-12.874616721266486, -11.584708454518777],
              [-12.872528942595274, -11.582503332414698],
              [-12.870452982720119, -11.579440379707433],
              [-12.868100569667476, -11.577979030350013],
              [-12.867230328580758, -11.576706226954633],
              [-12.863985964063898, -11.57504085531405],
              [-12.861909889912493, -11.575021058475693],
              [-12.859926051781619, -11.576701374325499],
              [-12.857833048189734, -11.579395607963477],
              [-12.856296844299308, -11.580767393548934],
              [-12.847472187230634, -11.585928718482606],
              [-12.845386572597608, -11.586970337080054],
              [-12.843192758891044, -11.587561148057267],
              [-12.838678085010754, -11.589426529824776],
              [-12.835654594416232, -11.591741976713667],
              [-12.834883219421494, -11.592904530757517],
              [-12.826788273787775, -11.598519240127413],
              [-12.823823726282136, -11.601270304481446],
              [-12.82177322063017, -11.60198021480658],
              [-12.817358999386974, -11.605588810710055],
              [-12.815707900372741, -11.606102429728022],
              [-12.815443418230542, -11.606958613898092],
              [-12.812190362157216, -11.608660637270793],
              [-12.809470739195918, -11.611743867298458],
              [-12.808476115165654, -11.613439065932964],
              [-12.806146894955344, -11.614490551051247],
              [-12.806551882502568, -11.615366784539432],
              [-12.803611252894022, -11.6180330684085],
              [-12.802972897849617, -11.620512782840665],
              [-12.800840629847444, -11.622124930532024],
              [-12.800450779213415, -11.623522931125025],
              [-12.801270742338593, -11.624738510369001],
              [-12.801350100490575, -11.626009787997305],
              [-12.800114054825462, -11.626939033961655],
              [-12.79869816057684, -11.627073509852934],
              [-12.79785651005722, -11.628483861264879],
              [-12.795859416458661, -11.62965680271207],
              [-12.794329576305643, -11.631653583138313],
              [-12.791281207265927, -11.633383274018533],
              [-12.789417181816797, -11.634798876802304],
              [-12.788268301026134, -11.636221537128673],
              [-12.785519585814045, -11.638399939297903],
              [-12.782309129233589, -11.639707763571703],
              [-12.781087115568834, -11.641131612014705],
              [-12.77856243351193, -11.642509616046292],
              [-12.776223974360484, -11.645810906730006],
              [-12.774738405588572, -11.645651596289163],
              [-12.773985967425983, -11.647218044245529],
              [-12.775335422120067, -11.647475845377851],
              [-12.77525596031695, -11.650527029361136],
              [-12.773592827500211, -11.652602838302801],
              [-12.771680473014195, -11.654273296967615],
              [-12.770977259133844, -11.654219816950231],
              [-12.76724564348589, -11.65849827351623],
              [-12.76665734651898, -11.662204645950274],
              [-12.764561093414722, -11.664300516513803],
              [-12.762193260514463, -11.668210119044213],
              [-12.762665428103734, -11.672539697759145],
              [-12.763403283559425, -11.673854130214195],
              [-12.762151653521832, -11.677108793477569],
              [-12.762196777615332, -11.6793537419458],
              [-12.76117043341543, -11.680239557964176],
              [-12.760412428656938, -11.679383119922981],
              [-12.756971052520463, -11.678555765748548],
              [-12.755638820048167, -11.680089437619344],
              [-12.754844400464561, -11.682220497852503],
              [-12.755377681827225, -11.68313694199121],
              [-12.755838220084899, -11.685677740321228],
              [-12.754831064249354, -11.688605813826914],
              [-12.755816967404348, -11.689862247612657],
              [-12.758979666331241, -11.688947507531232],
              [-12.761645719467655, -11.686802851855669],
              [-12.762430384115799, -11.685218362114199],
              [-12.76428590797666, -11.685335823355622],
              [-12.763883226080248, -11.688256331918689],
              [-12.763107314239116, -11.690089342201432],
              [-12.762148925235712, -11.69119664350997],
              [-12.76105265915025, -11.695049926044309],
              [-12.761533451944944, -11.696904626738052],
              [-12.76096308382363, -11.698818947267188],
              [-12.759496850687974, -11.699403851577948],
              [-12.756888658497997, -11.701751035222328],
              [-12.75789575255749, -11.703473605448673],
              [-12.756587895585643, -11.706544313110006],
              [-12.757113549102142, -11.706950811909529],
              [-12.757502729123994, -11.710646976357955],
              [-12.755735716796176, -11.709911011924156],
              [-12.75469816121022, -11.713122732403923],
              [-12.755197428652183, -11.71717192691155],
              [-12.754863808125794, -11.71914883424107],
              [-12.751680967118661, -11.720865087130909],
              [-12.752589607734452, -11.72207046682585],
              [-12.751123519797677, -11.723124141031171],
              [-12.751499350466133, -11.723871334249196],
              [-12.748708715643918, -11.72885544646433],
              [-12.747629581556179, -11.731644777142527],
              [-12.748793401598462, -11.733113079507177],
              [-12.747609703058712, -11.733874626232677],
              [-12.746773081575258, -11.732742871970284],
              [-12.745459720336138, -11.734466793935258],
              [-12.743865783365312, -11.738378622785792],
              [-12.743059368346241, -11.738807148883772],
              [-12.741030660536545, -11.742676924104137],
              [-12.740742869761139, -11.745072591801025],
              [-12.742069978633616, -11.746919875824318],
              [-12.742070223270296, -11.74832150308193],
              [-12.743058105924149, -11.749210185847355],
              [-12.746402514932896, -11.74695014395269],
              [-12.74704250198225, -11.744396345144365],
              [-12.749509828319615, -11.7418909544374],
              [-12.752130334585107, -11.742233372085314],
              [-12.753157039910038, -11.741488884699045],
              [-12.753985464985885, -11.742101176160283],
              [-12.753655418459186, -11.743725269934837],
              [-12.753962127459529, -11.745436924014772],
              [-12.751753622260052, -11.749404040186898],
              [-12.750893870243619, -11.75166036488231],
              [-12.749011843450504, -11.753897069746927],
              [-12.748170089137583, -11.75599020974051],
              [-12.747907239987411, -11.758137435342856],
              [-12.745953720684632, -11.759417329398971],
              [-12.744896338383898, -11.762220639606346],
              [-12.746280511067644, -11.761600957204823],
              [-12.747031195453568, -11.762087335706466],
              [-12.74639497455926, -11.765113485109353],
              [-12.746927406798054, -11.768995401225727],
              [-12.74821611072257, -11.770139322329607],
              [-12.74738221307269, -11.771354807678367],
              [-12.746907156861173, -11.773767460124983],
              [-12.745226488789443, -11.776969770974322],
              [-12.74493552898214, -11.779060679711293],
              [-12.745637243810057, -11.780984007245205],
              [-12.743801580416369, -11.785908840581705],
              [-12.743455414324641, -11.790274860031891],
              [-12.742607293827888, -11.79217142938024],
              [-12.743888948768992, -11.795790304828582],
              [-12.74518609216581, -11.7955704972043],
              [-12.745962100480824, -11.797915713340023],
              [-12.747962412481497, -11.799877281074078],
              [-12.746406137383024, -11.801049621049437],
              [-12.747351570063584, -11.802228637339772],
              [-12.746925906486444, -11.80373216933052],
              [-12.747785296745171, -11.804715479279867],
              [-12.74856784060081, -11.807911965833265],
              [-12.751476891036598, -11.808637412580799],
              [-12.750310793371256, -11.811138009459071],
              [-12.75267879223483, -11.811822989783115],
              [-12.752073357866335, -11.814646566132081],
              [-12.752569021564144, -11.815289630602903],
              [-12.752274415500183, -11.817333941900955],
              [-12.753021597736446, -11.818805468726204],
              [-12.755710325444289, -11.818414925309566],
              [-12.75724319521759, -11.822358342974084],
              [-12.75966519550136, -11.823181367195227],
              [-12.760710619363737, -11.824115162550251],
              [-12.762968726212064, -11.82421350993965],
              [-12.764179331101081, -11.82310633237876],
              [-12.766225945331444, -11.823229613932494],
              [-12.766851878585427, -11.82413922064894],
              [-12.772167834832528, -11.822343323091232],
              [-12.773057191990018, -11.82287555313502],
              [-12.774742358478438, -11.82232875404029],
              [-12.775603322065509, -11.820655911307753],
              [-12.77735565621066, -11.818332043132301],
              [-12.779191494485381, -11.817369293683482],
              [-12.781279237579772, -11.818079354470468],
              [-12.78246080596605, -11.816339074676236],
              [-12.786480195014638, -11.814904473520121],
              [-12.78824548016928, -11.814754644237835],
              [-12.789317987109468, -11.815472892428287],
              [-12.790391234808748, -11.81431833131084],
              [-12.788693569663012, -11.812274060467407],
              [-12.786334585184287, -11.811095764441923],
              [-12.785073959545652, -11.808944551366649],
              [-12.783001190950932, -11.806620902404452],
              [-12.782088137825903, -11.804430060490043],
              [-12.780569035691139, -11.799631591492927],
              [-12.77893758505682, -11.795077198623494],
              [-12.778800023298071, -11.786684359382575],
              [-12.779825717409798, -11.783252632084992],
              [-12.778712317629875, -11.78114069601509],
              [-12.778962662913546, -11.779284183043744],
              [-12.779964084722724, -11.77765171755847],
              [-12.780175014187844, -11.774861527794439],
              [-12.779837432540605, -11.772209876676236],
              [-12.77940357733247, -11.771885890651074],
              [-12.77904920216243, -11.769007160229194],
              [-12.778201287659988, -11.767480888700936],
              [-12.779605050982463, -11.767209973406102],
              [-12.78024878231942, -11.765173387057796],
              [-12.780848107654993, -11.764768262696531],
              [-12.782811020322681, -11.761522266653246],
              [-12.783458691253648, -11.758678729751576],
              [-12.786863260387667, -11.759759094010283],
              [-12.788428009174105, -11.758842404224005],
              [-12.79052309278664, -11.756602431738422],
              [-12.792127088705827, -11.75563987149444],
              [-12.792590706542216, -11.756293260944428],
              [-12.790121035724544, -11.759286714596755],
              [-12.789032583295564, -11.76124039297408],
              [-12.790022087165593, -11.762790251103006],
              [-12.789352851791769, -11.764078667227855],
              [-12.79074987365822, -11.76471514439704],
              [-12.792012651507235, -11.761249551824045],
              [-12.792849756634148, -11.761222659166883],
              [-12.794908632520759, -11.762727503527861],
              [-12.794625117619209, -11.765502999468845],
              [-12.796688786087055, -11.765068116845063],
              [-12.798352982892084, -11.766213158797251],
              [-12.799716271374281, -11.766393552783704],
              [-12.7999161913397, -11.768256775062595],
              [-12.798555091813064, -11.76903533600711],
              [-12.798173212262478, -11.770499319054514],
              [-12.796885148382533, -11.770765792516446],
              [-12.796484959526907, -11.774383699647665],
              [-12.796075382368283, -11.775182651208826],
              [-12.793527140394708, -11.7760322372368],
              [-12.79296479718397, -11.776819370810816],
              [-12.79039404668709, -11.777794241353769],
              [-12.789307833918986, -11.779281723126676],
              [-12.786642446548921, -11.781499712217771],
              [-12.785680832074512, -11.785174306752966],
              [-12.786082494380835, -11.787381731262133],
              [-12.78814564803681, -11.787855081920437],
              [-12.787620086557814, -11.792889401457872],
              [-12.787663579142311, -11.795808986997356],
              [-12.787292208520967, -11.797389842552914],
              [-12.787877037112171, -11.800162062898378],
              [-12.788763396295483, -11.802322807927641],
              [-12.790383564550144, -11.802222357431866],
              [-12.791577087547275, -11.803573343277773],
              [-12.792197690255286, -11.806786725064708],
              [-12.794329658611025, -11.806377425782957],
              [-12.795225163570729, -11.810284059703546],
              [-12.797274254409569, -11.81163634174262],
              [-12.800444574731864, -11.81008190273787],
              [-12.800697510548243, -11.808294491533582],
              [-12.80231853954942, -11.809300352858836],
              [-12.802270449101783, -11.81137620226058],
              [-12.803720815648383, -11.812570817154738],
              [-12.806706614379888, -11.813909408487545],
              [-12.80852169560481, -11.814035451137984],
              [-12.81150081163457, -11.81302404259413],
              [-12.819216594152792, -11.812665997928999],
              [-12.82083420362697, -11.811453880652639],
              [-12.822583948463887, -11.811615232149885],
              [-12.822980801742387, -11.81079321387833],
              [-12.822405756134165, -11.808627000737093],
              [-12.825019390676292, -11.808201625869348],
              [-12.826107943635758, -11.806782500993863],
              [-12.825582797872988, -11.805593068175616],
              [-12.824033530588334, -11.805156531241316],
              [-12.824464246196655, -11.803556401630388],
              [-12.823022366338991, -11.798218886168238],
              [-12.820734149492514, -11.797329479984862],
              [-12.817254368332529, -11.79140577973504],
              [-12.814578551521283, -11.788955136954883],
              [-12.813292884862365, -11.788140681983444],
              [-12.81255495883297, -11.786852376628499],
              [-12.813004524629894, -11.78450199328153],
              [-12.814602567289022, -11.783065961931792],
              [-12.816474104923582, -11.783714865499254],
              [-12.817437893417509, -11.785695023420452],
              [-12.817340761487612, -11.786865291364393],
              [-12.821263272089741, -11.788223668411824],
              [-12.822084927998203, -11.790670084567115],
              [-12.823116853622194, -11.791076152087722],
              [-12.823892608765048, -11.792400856861116],
              [-12.826382963390419, -11.790780485526758],
              [-12.827066937290986, -11.793055722671205],
              [-12.826784587586749, -11.793769103783532],
              [-12.828948568056825, -11.798202029778102],
              [-12.831881221516415, -11.797035402135261],
              [-12.833932789183928, -11.79724375997926],
              [-12.835477479275609, -11.798734611972954],
              [-12.835554831934951, -11.800115582461965],
              [-12.836457527188415, -11.800889951099073],
              [-12.83615903115469, -11.802138433637216],
              [-12.835111623039596, -11.803148473541714],
              [-12.834611027932613, -11.811539508924378],
              [-12.835884559292149, -11.812640687950616],
              [-12.837980972035119, -11.813020360803991],
              [-12.840621070581262, -11.810852403929479],
              [-12.842411978134043, -11.810052273609703],
              [-12.843779292788065, -11.810347949907413],
              [-12.84873977567183, -11.80905652409297],
              [-12.849698005231073, -11.808196381544805],
              [-12.851990883047375, -11.807224408671894],
              [-12.852806540827812, -11.80732740724249],
              [-12.855929098085944, -11.805602710431815],
              [-12.86025814877724, -11.80375167953122],
              [-12.861218651401998, -11.804286607765837],
              [-12.866080612667952, -11.803327959834169],
              [-12.868977040999797, -11.804122588655082],
              [-12.87104626804427, -11.803235410053404],
              [-12.872611893420595, -11.804040127078451],
              [-12.870592383714818, -11.805631391320645],
              [-12.869650601699723, -11.805603936443001],
              [-12.866481012030514, -11.808519992390323],
              [-12.863694055596891, -11.809308989764995],
              [-12.862699453480344, -11.810760785643868],
              [-12.861551799444554, -11.810466020887302],
              [-12.85562290211929, -11.814009420380213],
              [-12.853618773751814, -11.814845473667846],
              [-12.8503966512972, -11.8174014152267],
              [-12.849062368422596, -11.819376447535738],
              [-12.84952002512111, -11.820270594378142],
              [-12.852543518188368, -11.82135652799314],
              [-12.851562975289243, -11.825640887457528],
              [-12.851445064416948, -11.827935813367452],
              [-12.852046391350623, -11.828289574393766],
              [-12.855201993430748, -11.82415304362464],
              [-12.85506345816022, -11.82209674167517],
              [-12.855995658813134, -11.82089251885875],
              [-12.857394597511394, -11.820978653553901],
              [-12.858405853355242, -11.819973497846421],
              [-12.861037724145355, -11.818221297872169],
              [-12.862886570476467, -11.818730977048784],
              [-12.864059030091852, -11.81790412443056],
              [-12.865946152220362, -11.818868244640141],
              [-12.86473504903744, -11.820787366557537],
              [-12.863421663735098, -11.821517124702828],
              [-12.86225265329435, -11.823598638172044],
              [-12.862442305940382, -11.825456682344509],
              [-12.861191278026315, -11.826994655072244],
              [-12.86114511650858, -11.82860071438706],
              [-12.860191361404361, -11.82874184307889],
              [-12.856657016357039, -11.832104797233397],
              [-12.855684642401082, -11.834476539617148],
              [-12.856281057221523, -11.835197073418097],
              [-12.858394584539376, -11.834198491848557],
              [-12.858969258749774, -11.83589471310644],
              [-12.857955303308836, -11.837047912907197],
              [-12.856234024523427, -11.840886193197088],
              [-12.8555333072277, -11.843131075601088],
              [-12.85602883346885, -11.844690145169787],
              [-12.85763008863637, -11.845421974770279],
              [-12.858547408042986, -11.844751076309976],
              [-12.860565495172844, -11.844727074679211],
              [-12.86167607428226, -11.845204499059225],
              [-12.86379443570175, -11.844968217307112],
              [-12.865601616130228, -11.842855147114667],
              [-12.867721752487808, -11.841906018503417],
              [-12.869467493711136, -11.839821806232171],
              [-12.8719671166628, -11.839567593117147],
              [-12.871973909574496, -11.841806342800405],
              [-12.870349942475524, -11.842703362710573],
              [-12.869636323823183, -11.844427105145245],
              [-12.866380135171704, -11.846169636501386],
              [-12.867054627575367, -11.848932416935913],
              [-12.866584660259402, -11.849829877873102],
              [-12.863077014693484, -11.850651106666623],
              [-12.863014221303786, -11.852450403134066],
              [-12.861362708451892, -11.852502189999361],
              [-12.858878666866893, -11.853549497789377],
              [-12.856489441889169, -11.855810356582351],
              [-12.856303408257762, -11.862541920806772],
              [-12.855968659397067, -11.863905136678786],
              [-12.856330842534254, -11.86592477382491],
              [-12.857025426209674, -11.86729469614911],
              [-12.859450027851258, -11.868539878780298],
              [-12.85917336367461, -11.869529178915101],
              [-12.857885292106715, -11.869755494584126],
              [-12.857802482176012, -11.871402174731426],
              [-12.857075162025213, -11.871819219471877],
              [-12.853209759008223, -11.870377963290998],
              [-12.852723608933946, -11.873932629525509],
              [-12.854613397565158, -11.875341170264988],
              [-12.855742706321632, -11.87740171826819],
              [-12.855786798849955, -11.879117280280752],
              [-12.858064442037143, -11.880287451213958],
              [-12.859267336683784, -11.880302778007309],
              [-12.860761351758944, -11.878224240052784],
              [-12.863085648168484, -11.878087096285128],
              [-12.86399442683786, -11.8753580742685],
              [-12.867284120975361, -11.874275135375255],
              [-12.868610376157445, -11.871781176050552],
              [-12.869913821649416, -11.871793399664103],
              [-12.870953221391167, -11.870812416334548],
              [-12.873201137569025, -11.867630148270099],
              [-12.875455518845667, -11.86728615336545],
              [-12.878279659142793, -11.86507333770638],
              [-12.879810676760181, -11.862568270534522],
              [-12.879442891368235, -11.860302434020628],
              [-12.88163253772969, -11.858021181410976],
              [-12.8843461674686, -11.853975589146389],
              [-12.885478567214987, -11.851878563071022],
              [-12.887293266670238, -11.847284002393735],
              [-12.887588993482128, -11.84581184625736],
              [-12.889883081465031, -11.842095207809317],
              [-12.890871235781173, -11.839729238408093],
              [-12.892796161166165, -11.838540755088951],
              [-12.893575026506086, -11.837331704009973],
              [-12.895475238576093, -11.835643954521277],
              [-12.89807127502969, -11.830855449788176],
              [-12.898879570006832, -11.828995099909756],
              [-12.899685555356543, -11.828556649771347],
              [-12.900939453363474, -11.825719344437553],
              [-12.900645786529747, -11.824001625525373],
              [-12.901173038690512, -11.82307666572628],
              [-12.9011417580346, -11.821325205566259],
              [-12.902534226691017, -11.818732741745759],
              [-12.902600377496283, -11.816353037106026],
              [-12.903890541947028, -11.81539313952356],
              [-12.901950135637723, -11.813878009400034],
              [-12.904837487862759, -11.81186721325219],
              [-12.905336070984568, -11.810810939839914],
              [-12.906766346306219, -11.810584998786887],
              [-12.90750852757918, -11.80912193525993],
              [-12.90917288606543, -11.808339311851759],
              [-12.909922006819752, -11.80660833626095],
              [-12.909739141735386, -11.805553705264263],
              [-12.907571533308188, -11.805126615773279],
              [-12.906512307358899, -11.804375888841005],
              [-12.904092615180236, -11.803726675448473],
              [-12.902629753996411, -11.80482262782554],
              [-12.900979199618476, -11.804188909403086],
              [-12.901512716432222, -11.802753408603799],
              [-12.904788179396938, -11.800632405634289],
              [-12.906742353860178, -11.797794085756745],
              [-12.907996467808083, -11.793722773131943],
              [-12.909872992822406, -11.791095166196268],
              [-12.909537360176738, -11.789800108773191],
              [-12.906478374062829, -11.789708498115798],
              [-12.904036372313854, -11.791139214878266],
              [-12.90253713384591, -11.790279190142058],
              [-12.900383532971647, -11.791143709554175],
              [-12.900310515552638, -11.79319917010018],
              [-12.894864598481712, -11.795168467195717],
              [-12.894336076944663, -11.794824291105453],
              [-12.88924606070822, -11.797319411378808],
              [-12.887274123776976, -11.797715895310319],
              [-12.885583861867065, -11.799461754830036],
              [-12.883872023192113, -11.800106213294475],
              [-12.882891015878743, -11.799737301779546],
              [-12.880226155048367, -11.802115230716465],
              [-12.87957540455292, -11.801106661773904],
              [-12.878148303968866, -11.802098539657006],
              [-12.876580753605841, -11.801442255516317],
              [-12.876647538861086, -11.800461688951293],
              [-12.880995876267342, -11.797928342789577],
              [-12.883101840103212, -11.796367465487805],
              [-12.884298644043598, -11.793075678717699],
              [-12.882475717423084, -11.789473458441787],
              [-12.882661719203956, -11.787110417643637],
              [-12.883820466983263, -11.787156282700556],
              [-12.88473397543647, -11.788582075634883],
              [-12.88500370974835, -11.790412525243191],
              [-12.886460099082525, -11.790947616961308],
              [-12.88682775746806, -11.789363286580564],
              [-12.888398595920243, -11.789658815811563],
              [-12.890393832198635, -11.789311101534185],
              [-12.892540164373337, -11.787958772627183],
              [-12.892395338658487, -11.787208588837546],
              [-12.894482842471886, -11.786709661169311],
              [-12.894431349471118, -11.785972414320648],
              [-12.897803343620499, -11.78544031468412],
              [-12.900566067189601, -11.783146037575914],
              [-12.90156380993601, -11.782679266507468],
              [-12.90312255358104, -11.78292132914384],
              [-12.904080416314251, -11.781543443027704],
              [-12.90504045952636, -11.781820650022633],
              [-12.908407225928393, -11.780851072716803],
              [-12.909689727194827, -11.779081012448026],
              [-12.909569660969762, -11.777039439330744],
              [-12.910418262407838, -11.77593920928068],
              [-12.91016729443663, -11.773702160578383],
              [-12.908986037574083, -11.77215060395859],
              [-12.907666469056231, -11.771932716872152],
              [-12.906028715663476, -11.770507209091942],
              [-12.904588500394423, -11.771451469363619],
              [-12.904271368633342, -11.76963702609894],
              [-12.90296366953835, -11.769058205592984],
              [-12.902126100198004, -11.767725975738802],
              [-12.899953176948268, -11.761559692172398],
              [-12.897311624206681, -11.75608925472509],
              [-12.894986209638624, -11.75199536947867],
              [-12.893823252412712, -11.746918925016134],
              [-12.894540210094501, -11.74608848662658],
              [-12.894751821760988, -11.743196120055162],
              [-12.895401507826364, -11.742417138735233],
              [-12.89492769104848, -11.739349269921199],
              [-12.895644095932834, -11.738177947021416],
              [-12.894597278650345, -11.737063190797922],
              [-12.894227386754894, -11.734959272221321],
              [-12.894786191823579, -11.734369380760276],
              [-12.896834398182996, -11.735118202461788],
              [-12.897801193127673, -11.733593623755631],
              [-12.896523946132051, -11.732010001295558],
              [-12.895477477295469, -11.729919478466025],
              [-12.896041610975091, -11.727989504370983],
              [-12.894924925106102, -11.726655727390732],
              [-12.891955624831398, -11.726957142842743],
              [-12.889709082231727, -11.726627039535584],
              [-12.889289732943357, -11.724457759096014],
              [-12.890648985988685, -11.724484159499719],
              [-12.891408680002511, -11.72291462671931],
              [-12.890500207317555, -11.72162745408571],
              [-12.889174581578809, -11.721368289610494],
              [-12.888382241951152, -11.719339749077156],
              [-12.891080083838723, -11.718752148272381],
              [-12.896464533024627, -11.719693539389763],
              [-12.898834700798849, -11.719114476330535],
              [-12.902973937357823, -11.719285784985468],
              [-12.905673767968414, -11.71652736132052],
              [-12.908561317789086, -11.714978764330773],
              [-12.909748838460327, -11.713946489579069],
              [-12.910395171104174, -11.712340062788641],
              [-12.910582017728485, -11.708676626409561],
              [-12.910273446556047, -11.70745061457272],
              [-12.908894780371666, -11.705883709831184],
              [-12.909149812421854, -11.704680093152076],
              [-12.910430031617905, -11.704362539695163],
              [-12.911384902890575, -11.700427386594736],
              [-12.912024264203389, -11.695777574547844],
              [-12.91140454575723, -11.694105237583956],
              [-12.914158027388606, -11.690276831502304],
              [-12.914967408792485, -11.689615269238281],
              [-12.917936027448416, -11.689207887395181],
              [-12.918693754474129, -11.687009946080954],
              [-12.919834319130217, -11.68596464968854],
              [-12.922336321802815, -11.684435715500028],
              [-12.922740188646747, -11.683405545758033],
              [-12.920945318150585, -11.682356265926954],
              [-12.922310078715922, -11.680610300496166],
              [-12.922837589210156, -11.678432452198027],
              [-12.922225486612176, -11.676593232726924],
              [-12.921337815978486, -11.675757432801525],
              [-12.920415973633606, -11.673061054281144],
              [-12.919762402732816, -11.672740685583314],
              [-12.916892677287082, -11.673703750984249],
              [-12.91698066903338, -11.671303761344054],
              [-12.915919058571081, -11.670114182981413],
              [-12.916987686262114, -11.668423524139481],
              [-12.915835480001723, -11.66639232762551],
              [-12.912576002142998, -11.66602756442607],
              [-12.910996892955978, -11.664686492690048],
              [-12.909506099980474, -11.664977412975558],
              [-12.908782302602406, -11.666070640920196],
              [-12.905471266558889, -11.665732632773587],
              [-12.904743653210767, -11.66499652569617],
              [-12.903179362786911, -11.661616017153841],
              [-12.900966382312863, -11.65908138519347],
              [-12.900320061619398, -11.657498536567289],
              [-12.89825173864124, -11.656981529295336],
              [-12.896990182556198, -11.65856517442611],
              [-12.894310350733395, -11.657472799478782],
              [-12.893232711091779, -11.657369101235838],
              [-12.890685112304766, -11.654965744072806],
              [-12.88945556387449, -11.654365915779128],
              [-12.888097698194404, -11.652147652127006],
              [-12.886562946265345, -11.651180578831994],
              [-12.88493074299658, -11.651103330480112],
              [-12.883983394888185, -11.649949684591968],
              [-12.88589051500125, -11.648298913895875],
              [-12.889429953614849, -11.64789180737426],
              [-12.890856843725095, -11.648262368797337],
              [-12.893602479413286, -11.647580555133224],
              [-12.894627129353452, -11.64686454504689],
              [-12.896719770304031, -11.647172496624277],
              [-12.897668944734821, -11.64825256403791],
              [-12.895752941865805, -11.649559865078253],
              [-12.896031297676224, -11.6521806089701],
              [-12.898464507811754, -11.652753242044557],
              [-12.902004189880289, -11.65314466980856],
              [-12.90679858579498, -11.658510485460566],
              [-12.908276648889824, -11.65865157894237],
              [-12.9094116681727, -11.659806566682159],
              [-12.911732083200052, -11.65985621447259],
              [-12.912471977125033, -11.65834129094996],
              [-12.915890782878602, -11.657569759470041],
              [-12.919642831214416, -11.657664674002792],
              [-12.922434531452849, -11.659687829537358],
              [-12.922999709429499, -11.662406086307719],
              [-12.923953598369264, -11.66236797118584],
              [-12.925484749981504, -11.65827851596842],
              [-12.926652014600396, -11.657779390273966],
              [-12.926832841151965, -11.655050185924216],
              [-12.927535382509262, -11.653494607102484],
              [-12.928499315994584, -11.65273226483133],
              [-12.92968525416839, -11.650832282922853],
              [-12.930800844966077, -11.64786629563136],
              [-12.929731877990983, -11.646288265920406],
              [-12.928347884476704, -11.646340023632902],
              [-12.924995048706243, -11.644601907230248],
              [-12.921467127219449, -11.643394159738778],
              [-12.916673769910648, -11.643055573124727],
              [-12.912632587439232, -11.641592073954536],
              [-12.903962216726267, -11.638982085912135],
              [-12.900787503526205, -11.637839627557604],
              [-12.8997823614321, -11.637056628825762],
              [-12.898382920036244, -11.637302828476031],
              [-12.896235411647227, -11.635296753537334],
              [-12.895112201317401, -11.635252911767745],
              [-12.893975676306612, -11.633598455347716],
              [-12.892343414558807, -11.632840945275149],
              [-12.890235469469, -11.63065662857624],
              [-12.89332866408837, -11.630996049118586],
              [-12.897673428699251, -11.63232471375781],
              [-12.900036335468746, -11.632216818916877],
              [-12.901953747355055, -11.633654632240084],
              [-12.904992090007049, -11.633219329468234],
              [-12.905687656956001, -11.63161416872785],
              [-12.904865980626077, -11.630677010504947],
              [-12.90598570047819, -11.62817565853989],
              [-12.907430393844784, -11.627799457583363],
              [-12.90906379592289, -11.62627607289186],
              [-12.908895757220137, -11.62488441330414],
              [-12.912143362620398, -11.624231419215404],
              [-12.915555899798994, -11.621934489589503],
              [-12.916083635359563, -11.620883214345666],
              [-12.917430653915202, -11.620085750586282],
              [-12.917139603105305, -11.618968114447775],
              [-12.917274496508197, -11.616179649507211],
              [-12.916127222149663, -11.61430272858376],
              [-12.914659286993176, -11.614868878567485],
              [-12.913509913440128, -11.614013030379162],
              [-12.913467679515916, -11.611309446557359],
              [-12.914142274822186, -11.610184999112304],
              [-12.915673181576672, -11.61066325053554],
              [-12.916281329203057, -11.60910447637611],
              [-12.920831398624584, -11.61355018375434],
              [-12.92193465746358, -11.61363843289606],
              [-12.92323768570995, -11.612753918806305],
              [-12.923018932695014, -11.611118194596674],
              [-12.924332515264709, -11.608384208975291],
              [-12.92525300450705, -11.608361217160333],
              [-12.927136142212241, -11.610266100514153],
              [-12.927336425049088, -11.611085411141188],
              [-12.929150514553104, -11.613324224774727],
              [-12.9328548744736, -11.617382467823214],
              [-12.934313874064532, -11.619237596325531],
              [-12.93526272880205, -11.621893262921564],
              [-12.938608082531543, -11.628091220075222],
              [-12.943299201508164, -11.635989282862637],
              [-12.944343538809939, -11.637217414717234],
              [-12.946656802187203, -11.637860336468004],
              [-12.947988599064177, -11.637514616888305],
              [-12.950471482972933, -11.638166271107416],
              [-12.952108294152714, -11.638141964537828],
              [-12.951454044300434, -11.640195752996291],
              [-12.953843441982363, -11.641250678552915],
              [-12.955879572662633, -11.639473045383657],
              [-12.956815593994351, -11.637248757113177],
              [-12.958328624002613, -11.63764192251795],
              [-12.958870318287007, -11.638479760554024],
              [-12.957117405813612, -11.640644131210262],
              [-12.95764789351746, -11.642307392240419],
              [-12.959066880223244, -11.644405503320948],
              [-12.960489459580996, -11.644428556095066],
              [-12.965561350117538, -11.646898832814095],
              [-12.966528550201804, -11.648001443466848],
              [-12.968244470372838, -11.648800480599611],
              [-12.970562294485447, -11.64922202781496],
              [-12.972190280026178, -11.651879238665694],
              [-12.971162267332776, -11.654025244638012],
              [-12.968510204825856, -11.654338724357986],
              [-12.965031406005748, -11.656503759603492],
              [-12.960265993348786, -11.655179452351472],
              [-12.956802930192445, -11.653592888510817],
              [-12.955797895890312, -11.653410092100973],
              [-12.953068912181225, -11.654166766558292],
              [-12.951051633915911, -11.654354180625942],
              [-12.949746333187598, -11.653716574031],
              [-12.94701020574262, -11.653561651014593],
              [-12.946386005799155, -11.654416175224995],
              [-12.943850356218197, -11.655226151446643],
              [-12.942044621241955, -11.656624329738571],
              [-12.940089424706127, -11.65544912897543],
              [-12.939253955926148, -11.656061850454632],
              [-12.937611811065262, -11.658388750319629],
              [-12.938339302157637, -11.660238022853926],
              [-12.93645295868835, -11.66520048111934],
              [-12.93665076634349, -11.666384555875238],
              [-12.937706084928802, -11.66703492668845],
              [-12.936462830206876, -11.66984015170302],
              [-12.936443503356912, -11.671775830705409],
              [-12.937366042451545, -11.674614997191014],
              [-12.939414762593684, -11.675675932141925],
              [-12.938890048989755, -11.678970228672693],
              [-12.937055715453493, -11.67953610173267],
              [-12.937193754585476, -11.680821877098563],
              [-12.938200334629578, -11.681334176848324],
              [-12.938590263053912, -11.683167072922195],
              [-12.938244649039, -11.68693668790994],
              [-12.937754058233494, -11.687699929999948],
              [-12.937697268524534, -11.69029841783011],
              [-12.938345727499243, -11.693362242641523],
              [-12.940033043151479, -11.693424779759086],
              [-12.940833551657482, -11.694522914490324],
              [-12.942038449277113, -11.693498131012964],
              [-12.943107177810377, -11.69446817951845],
              [-12.945330147559648, -11.692525179553808],
              [-12.947277311092252, -11.69129040573869],
              [-12.948259910531933, -11.689631935402113],
              [-12.949448756873972, -11.689840685519608],
              [-12.948649590879693, -11.692241654833339],
              [-12.947763061228548, -11.692718402817295],
              [-12.946650000653502, -11.694746466194458],
              [-12.94377949528942, -11.696895897714775],
              [-12.943067570179558, -11.698222002292152],
              [-12.941224684036307, -11.699670862652932],
              [-12.938715026530325, -11.702117830542045],
              [-12.937661861684367, -11.701910279198497],
              [-12.936390296082926, -11.703712080533775],
              [-12.935154389991917, -11.704751532260131],
              [-12.933914545787173, -11.7066416900866],
              [-12.932947262023538, -11.706921253208867],
              [-12.931633128245602, -11.708975233430046],
              [-12.932771017457195, -11.70965948836006],
              [-12.934534992746618, -11.708531143357462],
              [-12.93490647897929, -11.710214332130152],
              [-12.933775973501714, -11.71165550051393],
              [-12.933416677695359, -11.713180221809047],
              [-12.93573186591216, -11.715312703789586],
              [-12.934863831877465, -11.717695650920977],
              [-12.934976878064905, -11.7205332991035],
              [-12.934372576188254, -11.721399468355589],
              [-12.934401099933902, -11.723284226015844],
              [-12.935812007738493, -11.72421810325225],
              [-12.936698838298106, -11.722894539614753],
              [-12.937741456643101, -11.723807527781],
              [-12.937436255910857, -11.727551435369877],
              [-12.939343684898367, -11.728197430652845],
              [-12.93963694658925, -11.729124824346295],
              [-12.939103516810457, -11.730916489804141],
              [-12.93767567175583, -11.73235741838033],
              [-12.936143382487352, -11.734598615619433],
              [-12.936163605500548, -11.735231430616398],
              [-12.937964482246937, -11.736182212090213],
              [-12.942561008985196, -11.733645159596245],
              [-12.945188762357366, -11.734362978054193],
              [-12.94721866640368, -11.73275995719652],
              [-12.94871170247994, -11.734019197667246],
              [-12.950419219338862, -11.733329623426252],
              [-12.950348958427215, -11.73162627711061],
              [-12.954767536813021, -11.729296470164158],
              [-12.956217385821116, -11.727644203055624],
              [-12.956662726377594, -11.726237120632105],
              [-12.959493626966363, -11.72509971131475],
              [-12.960093723932749, -11.723745497156402],
              [-12.966717520994655, -11.720627818592508],
              [-12.96786886057509, -11.719678119454887],
              [-12.971644813632684, -11.71859147917313],
              [-12.972954943152377, -11.719517971168473],
              [-12.970563634018403, -11.720755260529582],
              [-12.968212773131611, -11.72159278050324],
              [-12.966935902914688, -11.72325356568171],
              [-12.964106373939961, -11.724392278615873],
              [-12.961840191428255, -11.726255346558311],
              [-12.961686717814937, -11.727468397991696],
              [-12.959733608854291, -11.727662000235513],
              [-12.959004921094945, -11.729240894022986],
              [-12.957125795656287, -11.730845856747239],
              [-12.955174256229654, -11.731526314644258],
              [-12.954544915730269, -11.733456008027666],
              [-12.952551369670807, -11.735241847137184],
              [-12.950596522943727, -11.73889199334697],
              [-12.947890678404264, -11.739731580749934],
              [-12.946166380022163, -11.741245043419871],
              [-12.944582045315778, -11.741440570528155],
              [-12.943520615739804, -11.74466397409768],
              [-12.945004180192177, -11.744896926233631],
              [-12.946122934258113, -11.745883652850997],
              [-12.943957322056919, -11.747516123660965],
              [-12.942303700388868, -11.749175859111853],
              [-12.941757558482536, -11.751501936318723],
              [-12.94248435777174, -11.752332446620045],
              [-12.94131949600057, -11.753240572343683],
              [-12.940426044415302, -11.755563180331274],
              [-12.938202651982621, -11.75968797503115],
              [-12.938664657282725, -11.761480564290558],
              [-12.938450490632787, -11.763359946256104],
              [-12.940184579463397, -11.761969401666557],
              [-12.941743018003077, -11.762348811040912],
              [-12.941491821503835, -11.764264548633543],
              [-12.941741477452092, -11.76595897686413],
              [-12.940337482909827, -11.769877447319434],
              [-12.937751133684383, -11.771207236983441],
              [-12.939773945413082, -11.771762036486624],
              [-12.93988282636146, -11.77414171256649],
              [-12.942184910051772, -11.774039186302742],
              [-12.942721607050766, -11.774708114731865],
              [-12.944784518433902, -11.773231215794485],
              [-12.948532183952906, -11.771491771330792],
              [-12.950460290676546, -11.772238148560948],
              [-12.952472187884178, -11.771256280493025],
              [-12.957732877533989, -11.767464340199536],
              [-12.958386998974033, -11.766733257232907],
              [-12.961094972170747, -11.766740877181437],
              [-12.962986114322083, -11.765742760362384],
              [-12.965066401245474, -11.76519756751437],
              [-12.964594603840823, -11.767184299626892],
              [-12.966676078538653, -11.768199139875728],
              [-12.968007332731112, -11.766525239828816],
              [-12.971219113104233, -11.765798503068595],
              [-12.97418047584347, -11.766497697297567],
              [-12.978686455439922, -11.764692623747036],
              [-12.979562243076439, -11.764888011163336],
              [-12.98132228547513, -11.764185762194055],
              [-12.982544752780123, -11.76281711888234],
              [-12.98444747535095, -11.761845974778293],
              [-12.98580307318584, -11.759523837839122],
              [-12.987464447857839, -11.758959137694736],
              [-12.9888234200113, -11.759047995153503],
              [-12.990760911600153, -11.75825885554187],
              [-12.993035273964644, -11.755165883263887],
              [-12.995017113913917, -11.753086268550677],
              [-12.996498325021768, -11.750467898752232],
              [-12.996507227260626, -11.74923079129697],
              [-12.99850262530917, -11.74627403959318],
              [-12.998579603343574, -11.744177806087995]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -130.92809323350832,
          "lat": 55.585251646724224
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02130"],
        "coty_name": ["Ketchikan Gateway"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Ketchikan Gateway Borough"],
        "coty_fp_code": "130",
        "coty_gnis_code": "01419973"
      },
      "bbox": [
        -12.998579603343574, -11.941325299980369, -12.541538846766564,
        -11.4166108582225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.551696091686884, -0.5821381164688164],
            [-12.41944770856231, -0.6048004445200458],
            [-12.410693634391622, -0.6064250668204505],
            [-12.026874269867223, -0.6718740210988985],
            [-11.847154846743683, -0.7018169478869588],
            [-11.74708380486572, -0.7182956950438611],
            [-11.67383793456877, -0.7302692288160251],
            [-11.66798278179875, -0.7312069733130415],
            [-11.568824313077583, -0.7484078813204715],
            [-11.550429539352418, -0.7507620629539294],
            [-11.455886615739168, -0.7663098150300895],
            [-11.403129812787293, -0.7731158690323874],
            [-11.15628645236416, -0.8113269728955733],
            [-11.179801407852125, -0.9615897279670877],
            [-11.218379495560232, -1.2081022452258319],
            [-11.227195108086308, -1.2644239208387649],
            [-11.24887516281791, -1.4029546438773577],
            [-11.266276998457235, -1.5141426035737975],
            [-11.286948015448232, -1.646211351690576],
            [-11.299356916539582, -1.7254989910801681],
            [-11.31923994622567, -1.8525248152678209],
            [-11.344840962317221, -2.0160659137033643],
            [-11.36902154410192, -2.170518421380601],
            [-11.387138240080878, -2.2862239280103234],
            [-11.40721948957, -2.4144707085346786],
            [-11.420817401089181, -2.501301971900403],
            [-11.44225942732066, -2.638211111824818],
            [-11.460455654908536, -2.754383762573146],
            [-11.475503255871775, -2.8504509198513737],
            [-11.51231530569996, -3.0854462017190287],
            [-11.525422667618168, -3.1691026171579018],
            [-11.583590317117993, -3.5402814283509474],
            [-11.593978167995576, -3.542859593230778],
            [-11.597455488259945, -3.542506451620032],
            [-11.596463733921844, -3.5341982392720532],
            [-11.591533770684439, -3.529188484392058],
            [-11.590562890552336, -3.526115536056733],
            [-11.586932622558704, -3.5234458927802166],
            [-11.588333889699566, -3.5145353403918076],
            [-11.590337887738398, -3.5095758591648614],
            [-11.601531631755101, -3.5011392014614082],
            [-11.6058144501908, -3.496350860694972],
            [-11.606541078705817, -3.4905324482463125],
            [-11.612269650764066, -3.4932524776885843],
            [-11.614718615865547, -3.4989768171408397],
            [-11.620394429421808, -3.499150612910033],
            [-11.621156429614944, -3.4875624913593284],
            [-11.62323976583645, -3.48800168918126],
            [-11.627417255455674, -3.50045394578027],
            [-11.632690633593567, -3.495103241027598],
            [-11.634304208144984, -3.495544592246316],
            [-11.644800293837644, -3.490324318097472],
            [-11.647569494714684, -3.4839193628438228],
            [-11.652985194261285, -3.4865951260667005],
            [-11.638431259685323, -3.499031490721341],
            [-11.636116266559487, -3.5068125310149014],
            [-11.645449397187623, -3.5093761045956184],
            [-11.64898497367487, -3.5120622835204545],
            [-11.647008300803117, -3.516538799587488],
            [-11.647787465566822, -3.520118113003396],
            [-11.651565945726867, -3.5235206319039376],
            [-11.661868270868306, -3.5240544732801844],
            [-11.667881592707106, -3.5195863343459655],
            [-11.67160897682693, -3.5197779797935262],
            [-11.684290705208841, -3.5117636656548896],
            [-11.690337295796244, -3.504180823939891],
            [-11.691793141284197, -3.4998540542130825],
            [-11.688419375466122, -3.4971675050624706],
            [-11.688965100861793, -3.494012826018343],
            [-11.695621223161732, -3.4899322971707605],
            [-11.695899978855186, -3.4828035755357347],
            [-11.701361629508026, -3.4842233471206296],
            [-11.704825512879493, -3.4831093087767884],
            [-11.708755589568444, -3.4780000693707906],
            [-11.712017318377343, -3.4779208516716373],
            [-11.717226633213356, -3.4740909594015488],
            [-11.719098215359624, -3.470934960544044],
            [-11.724514198804078, -3.46930044934998],
            [-11.730167793949128, -3.469204753081835],
            [-11.733368597437712, -3.461774622750958],
            [-11.738332978793114, -3.459625762549289],
            [-11.73918102668204, -3.463573211857683],
            [-11.744143731505522, -3.4629318700540153],
            [-11.744907533270938, -3.4598037769686814],
            [-11.750862470390512, -3.4518566188010595],
            [-11.75047093950568, -3.4484571402225845],
            [-11.754363911710637, -3.438525696785281],
            [-11.756841790506744, -3.438187677663455],
            [-11.764483932323492, -3.4313228837338494],
            [-11.770563131529444, -3.4285278384457953],
            [-11.769264168034676, -3.42581123122007],
            [-11.771013848088206, -3.4222965872231246],
            [-11.77526862210368, -3.4200179861379323],
            [-11.7737790121639, -3.4151289888555323],
            [-11.774691532193097, -3.4108821449870668],
            [-11.779401689045375, -3.4109841752619103],
            [-11.785958393831217, -3.4068960652763125],
            [-11.784431911326546, -3.3967473127285905],
            [-11.786997475593623, -3.39675280350293],
            [-11.790575234427925, -3.404492540949433],
            [-11.796025389837133, -3.40682838114586],
            [-11.792133717351714, -3.415221881929214],
            [-11.79733914871016, -3.419172818556483],
            [-11.795231003337836, -3.4223112803975293],
            [-11.800083422258343, -3.4270864592716834],
            [-11.807452518415257, -3.4239687968491537],
            [-11.812711359536555, -3.4187383354869314],
            [-11.81400082020523, -3.4129756788844214],
            [-11.817623327304636, -3.4092200306592866],
            [-11.814232283364937, -3.406004007683716],
            [-11.810312406315804, -3.406520922373017],
            [-11.808178567382138, -3.4019223126625033],
            [-11.803327386235832, -3.399455173989852],
            [-11.800247452503278, -3.3940910812515552],
            [-11.800236392325548, -3.389535144000337],
            [-11.802895746042834, -3.387202956919656],
            [-11.805512086407486, -3.3914772672811755],
            [-11.808800046999625, -3.393603487592114],
            [-11.810976154179468, -3.3867637540646105],
            [-11.814616717386926, -3.384321502123829],
            [-11.816829575452319, -3.3873556074988236],
            [-11.82125065471246, -3.383931535074055],
            [-11.825486168338438, -3.3848012952083555],
            [-11.828460749785343, -3.381128707106617],
            [-11.827589882427372, -3.375932185679372],
            [-11.82999587818916, -3.373329495395566],
            [-11.835344022657564, -3.3712379306957936],
            [-11.835417092951541, -3.366363310451222],
            [-11.841573944086825, -3.367134974868963],
            [-11.847128002354344, -3.369413008176724],
            [-11.855989245879712, -3.368041926041633],
            [-11.855309784024586, -3.3731707329849545],
            [-11.860479529525971, -3.372642715382326],
            [-11.862249234364784, -3.3742538235514474],
            [-11.869484554707805, -3.3656286920937206],
            [-11.872000005330449, -3.369040138206604],
            [-11.87712716699785, -3.368252816042271],
            [-11.879565564136923, -3.3695647625815077],
            [-11.885676876547318, -3.378077696673733],
            [-11.889200787118128, -3.3736802534135855],
            [-11.886632575680753, -3.3685105144531096],
            [-11.887719385408245, -3.358736535941768],
            [-11.889927003697027, -3.3534380530642744],
            [-11.89346837058738, -3.3520917428765147],
            [-11.893397441851436, -3.3480864144019087],
            [-11.902283934657508, -3.3479663221334923],
            [-11.903198174911006, -3.3443101267650297],
            [-11.906713646738554, -3.3410541129191342],
            [-11.91156986125058, -3.338869549315853],
            [-11.920276802194067, -3.341879882603309],
            [-11.922279363759216, -3.3384588495825964],
            [-11.929304900563178, -3.3361459837442977],
            [-11.932762776925149, -3.332233206228218],
            [-11.935278420417267, -3.332056084372644],
            [-11.9348234900359, -3.3271366774478373],
            [-11.940557397234388, -3.32740177671892],
            [-11.939318070221377, -3.3184416077698433],
            [-11.9455668625556, -3.3112152566180475],
            [-11.949729615571256, -3.3123834380592014],
            [-11.952721976103781, -3.3103783524350288],
            [-11.953103734315448, -3.302963552216501],
            [-11.955776130750532, -3.3028122951440477],
            [-11.954225175540362, -3.295277243604955],
            [-11.955064712521777, -3.290251249385612],
            [-11.957978420198483, -3.2872001955984222],
            [-11.960800979537735, -3.2878400098502745],
            [-11.963645968252653, -3.292976128862575],
            [-11.966470597280942, -3.2916804420682726],
            [-11.9687115478098, -3.2961861516665882],
            [-11.9723027672709, -3.293761076682484],
            [-11.977792907443217, -3.29425831794302],
            [-11.983039290611314, -3.296815328151312],
            [-11.989378873016362, -3.295875402967943],
            [-11.991620495500124, -3.2994527571307564],
            [-11.997750788921348, -3.2972135478190525],
            [-12.000043874676662, -3.3006508527744542],
            [-12.007504654790322, -3.2998427724701545],
            [-12.010748746310972, -3.304540701158265],
            [-12.013620605462082, -3.302825779450837],
            [-12.018616478082748, -3.3034484230646295],
            [-12.02232435669384, -3.308122667868815],
            [-12.026812613116089, -3.307285676262055],
            [-12.028159240480367, -3.304860556151745],
            [-12.03278434806718, -3.3068874029472752],
            [-12.035183852714448, -3.3039392498971623],
            [-12.046034818386909, -3.302215399585174],
            [-12.043309445370069, -3.296403372546104],
            [-12.04373558046912, -3.290781100694067],
            [-12.041593361567624, -3.287336518712159],
            [-12.046645988676731, -3.286495046081576],
            [-12.049507931493546, -3.2893451803384472],
            [-12.052081977313547, -3.28694493967543],
            [-12.057818824239591, -3.284978778113684],
            [-12.06249043735023, -3.2876785102189747],
            [-12.065029921287566, -3.2926588221346336],
            [-12.06752164125719, -3.2905824632176985],
            [-12.07225503148807, -3.2933256554282297],
            [-12.07357434557019, -3.297730742009468],
            [-12.077583402167656, -3.297837587419527],
            [-12.080660287343633, -3.295091262095583],
            [-12.083001248671986, -3.2985821135718973],
            [-12.086316670295275, -3.309673708401524],
            [-12.094923944946691, -3.3111797135340626],
            [-12.092053000859043, -3.315677293029289],
            [-12.090245866946699, -3.3223931612099316],
            [-12.076523535482549, -3.3245827993994665],
            [-12.079822221801376, -3.3282274269914085],
            [-12.08074206232629, -3.334112552769726],
            [-12.085752416160863, -3.3360676717403406],
            [-12.090836655526097, -3.341527111590782],
            [-12.096668169083552, -3.3426195932834144],
            [-12.09884705025873, -3.341197297197692],
            [-12.099515155258768, -3.3366721402861548],
            [-12.105399213514008, -3.338004166512156],
            [-12.10484757467525, -3.3298472765633536],
            [-12.10920729607737, -3.3290644190161056],
            [-12.112110316788424, -3.325703096549544],
            [-12.107985150136109, -3.322664767575255],
            [-12.10388034957739, -3.3094799100843733],
            [-12.104914982884148, -3.298681116430259],
            [-12.104173011936558, -3.2921046755962102],
            [-12.100974805467702, -3.289454978861735],
            [-12.099218079579163, -3.285400958837065],
            [-12.096115583921508, -3.2837725481911084],
            [-12.090731014259951, -3.2860461408499355],
            [-12.089694734544544, -3.2900445001649024],
            [-12.086739286947427, -3.2916059175511942],
            [-12.08532339527957, -3.280617908460558],
            [-12.079848175106381, -3.278994861591708],
            [-12.08325207978964, -3.27500170620707],
            [-12.089665361124014, -3.2764865948952964],
            [-12.095612573842665, -3.2749592559443146],
            [-12.101044478249882, -3.269335501946938],
            [-12.102861565584163, -3.2715236808613195],
            [-12.10840779163042, -3.2701209973199963],
            [-12.107370569777926, -3.276106639995764],
            [-12.110639873243976, -3.2776696044197813],
            [-12.116005142257192, -3.273813805393187],
            [-12.116089242926298, -3.2812181915799288],
            [-12.121538061582514, -3.280610787852955],
            [-12.126156149260204, -3.286624119146233],
            [-12.13159016796917, -3.287694069898455],
            [-12.133819872350726, -3.290331079996049],
            [-12.137685056400588, -3.2996500200343406],
            [-12.13915592362659, -3.297584492617133],
            [-12.145782662930866, -3.2975840686078466],
            [-12.149457645484537, -3.294806965057242],
            [-12.149247260517717, -3.2872058611091535],
            [-12.147022896415622, -3.2828264010056354],
            [-12.13894579049763, -3.2849720320121203],
            [-12.139720047192569, -3.281260317666875],
            [-12.149693724560883, -3.2783423397930664],
            [-12.152500598790123, -3.2795053362833304],
            [-12.157439471102691, -3.278825081606911],
            [-12.157623753209391, -3.285878959860002],
            [-12.160846569131214, -3.2897148407770223],
            [-12.163097863215851, -3.286465965944689],
            [-12.171141402509251, -3.284225395590306],
            [-12.175379759279698, -3.2901855968314346],
            [-12.18618156935577, -3.2926171271786933],
            [-12.196189571562496, -3.2899813934842435],
            [-12.199192214047148, -3.285347877105722],
            [-12.20193946016533, -3.2861661566305416],
            [-12.204388544336549, -3.2809064899727125],
            [-12.197684916939965, -3.2780443176161325],
            [-12.195539468851727, -3.2749032608826423],
            [-12.19195007808362, -3.2795018123084096],
            [-12.187184474892502, -3.2807269230731695],
            [-12.187373436505016, -3.273639752779763],
            [-12.182425527813383, -3.2750843535825704],
            [-12.177195758248423, -3.274861465465829],
            [-12.177448257449978, -3.267376320795344],
            [-12.174657707419273, -3.2603640410427706],
            [-12.171699572008663, -3.261400258510856],
            [-12.167822823336765, -3.265624763812102],
            [-12.163762130011069, -3.262946684204354],
            [-12.157026198708573, -3.261500330769179],
            [-12.153858995301897, -3.2565974369843262],
            [-12.150343050140721, -3.2553632851673613],
            [-12.145591628852241, -3.256397097444985],
            [-12.142138177050063, -3.2553094124571444],
            [-12.136330065264417, -3.251245085212175],
            [-12.141546055427625, -3.249717403058135],
            [-12.142794088568708, -3.247479903239523],
            [-12.152730334547215, -3.2465761188760296],
            [-12.16068985248177, -3.248634560670591],
            [-12.166203796467485, -3.2519153718333844],
            [-12.173935684604604, -3.246959797838834],
            [-12.177011503441937, -3.249528098213002],
            [-12.184062155699333, -3.2497978402259973],
            [-12.19068787481186, -3.248317210782229],
            [-12.18868634185869, -3.2434987305066736],
            [-12.18131090114478, -3.2413550868074297],
            [-12.174234384793237, -3.24161681313517],
            [-12.173300625023451, -3.2390275888927618],
            [-12.166807408671096, -3.2381798561491544],
            [-12.162347651451723, -3.222983360591804],
            [-12.164785692922234, -3.2217777102830687],
            [-12.161662898756017, -3.217544861439953],
            [-12.163883194710255, -3.2142818395617296],
            [-12.159960846026202, -3.212404107560093],
            [-12.1614256096831, -3.2095947881583977],
            [-12.165954006083886, -3.2116859326590865],
            [-12.168793408959726, -3.2070304394401066],
            [-12.172184861677145, -3.2098172987012257],
            [-12.170687303079461, -3.2189332404319146],
            [-12.17243771018688, -3.2272698352815503],
            [-12.174360253880847, -3.2271932364693146],
            [-12.179355610793333, -3.2336951191890297],
            [-12.18329953763911, -3.234729992115039],
            [-12.186037698604627, -3.2283954088708815],
            [-12.190715955498225, -3.230990041696091],
            [-12.192169630873245, -3.236435395750582],
            [-12.198551950453169, -3.2388835119006707],
            [-12.19854790546151, -3.2317507669876075],
            [-12.200279177645326, -3.2289222621668143],
            [-12.195539836578172, -3.2008137049616123],
            [-12.19438883878759, -3.20100346834781],
            [-12.176437700828536, -3.091039696383959],
            [-12.172191448888302, -3.0655259474662504],
            [-12.171128012736023, -3.065707406929183],
            [-12.164030204281065, -3.023983864681169],
            [-12.16198997896112, -3.0078196337230194],
            [-12.15791953244937, -2.985384594284209],
            [-12.143893210363009, -2.9006689607402603],
            [-12.180873074294926, -2.8944761759875073],
            [-12.214391228225216, -2.8886227265931574],
            [-12.228788085627558, -2.8864991097666133],
            [-12.250938578547213, -2.8818970308425573],
            [-12.283330999847076, -2.875901433863815],
            [-12.309743107755796, -2.871482597671752],
            [-12.325424542466449, -2.8696922918597996],
            [-12.324341846131952, -2.85474074421167],
            [-12.321649185218448, -2.840600504903471],
            [-12.318308771020094, -2.825746215937463],
            [-12.310707458698216, -2.785129820156271],
            [-12.303234392329813, -2.7400429785451608],
            [-12.295297378467808, -2.693249859206716],
            [-12.320496489416747, -2.688969996679701],
            [-12.321243752929908, -2.6937101935240926],
            [-12.364106701505195, -2.6865495009659655],
            [-12.4747791026742, -2.6676200792972744],
            [-12.491883848751971, -2.6653599858598755],
            [-12.492186394641573, -2.667135757615307],
            [-12.52227107766646, -2.662096834342587],
            [-12.664825766138055, -2.6377552056712092],
            [-12.675523408857677, -2.63651807217653],
            [-12.742671107246894, -2.625180632194657],
            [-12.731090746848473, -2.555801235874152],
            [-12.722875607978713, -2.5088994966759093],
            [-12.71876901272522, -2.479242964979938],
            [-12.713451389812695, -2.451063371727295],
            [-12.79832729521628, -2.435267219066048],
            [-12.78759660754758, -2.3720375010185237],
            [-12.782861196519018, -2.347795932768933],
            [-12.779318741544373, -2.3261119346299353],
            [-12.783649821730513, -2.3273130095955237],
            [-12.788682616670274, -2.330963643070663],
            [-12.799943371526796, -2.334422657413871],
            [-12.802835736196982, -2.3365629648923423],
            [-12.807264834279936, -2.3426971851846763],
            [-12.824539309352792, -2.3352742443114165],
            [-12.827839476203946, -2.334514939630551],
            [-12.860305438905156, -2.335029911368881],
            [-12.86252937972751, -2.334820385541427],
            [-12.889720050995765, -2.322899015473865],
            [-12.904945805188145, -2.2956533886551655],
            [-12.908485072085794, -2.2913423875747334],
            [-12.918726943454788, -2.285475582009033],
            [-12.915193461694082, -2.2779607603585648],
            [-12.91481444097785, -2.2695287019386883],
            [-12.916486816860946, -2.26517687007518],
            [-12.920474980841021, -2.26047225035536],
            [-12.92509831814675, -2.2578416040343545],
            [-12.933915296787871, -2.257585307582021],
            [-12.93775540508824, -2.259060069723112],
            [-12.943435663124221, -2.263708071372301],
            [-12.947399121222372, -2.262760045269964],
            [-12.94967708778425, -2.256152198519333],
            [-12.953230881679334, -2.250672618551156],
            [-12.959718216561317, -2.244319836346616],
            [-12.96989282522563, -2.239103088343408],
            [-12.976819499206517, -2.237786418745175],
            [-12.990534603293435, -2.240200640372882],
            [-13.004539748655239, -2.239499681650364],
            [-13.020088894537338, -2.2355223566086293],
            [-13.02229019543389, -2.2307204986735054],
            [-13.025578447918438, -2.2272792461947715],
            [-13.030743540418921, -2.2244259895205523],
            [-13.042431836168236, -2.2217466233262617],
            [-13.050652489511915, -2.2129063140604415],
            [-13.055768599748829, -2.209639900950038],
            [-13.064221388692538, -2.2066024071539125],
            [-13.12083521874792, -2.179233814692249],
            [-13.163010576083375, -2.162506053360106],
            [-13.16966129376291, -2.160911729949889],
            [-13.17221275002807, -2.135884782897661],
            [-13.173654388060477, -2.130509904591859],
            [-13.177417927113135, -2.122916211754498],
            [-13.181385870242485, -2.117922243931901],
            [-13.256242323167637, -2.043857707586508],
            [-13.294438182880462, -2.0142241600572666],
            [-13.301499430350393, -2.0078321550638005],
            [-13.302785557315318, -1.9964871188930957],
            [-13.307090374933658, -1.9877266298828697],
            [-13.313873928782044, -1.979898017175321],
            [-13.317971497786875, -1.9764151922999633],
            [-13.335850215033084, -1.968988746733832],
            [-13.342934571363651, -1.9690267445367535],
            [-13.352462344459846, -1.967675764056455],
            [-13.362203215044696, -1.958775177850927],
            [-13.373728317750537, -1.950647759196552],
            [-13.376815855047765, -1.9453633773880963],
            [-13.38250089764766, -1.9405657988471476],
            [-13.38699013372565, -1.9388846134086035],
            [-13.398383165567774, -1.9387708019812806],
            [-13.407134938232234, -1.936874033794271],
            [-13.412303968052457, -1.9340757792110765],
            [-13.427872708585177, -1.9315353584593091],
            [-13.437245364489812, -1.932570084964413],
            [-13.440568001593679, -1.9318633769698568],
            [-13.435974527928934, -1.9068511467388336],
            [-13.39050409849878, -1.6616045500062653],
            [-13.384769792896313, -1.650060350314824],
            [-13.386201600843274, -1.6457385931178943],
            [-13.385954936322026, -1.6405486136421406],
            [-13.379964524890521, -1.6358879630802483],
            [-13.377635778552628, -1.6229863344644855],
            [-13.370803057676769, -1.6149528090472003],
            [-13.365749536430297, -1.6110542796347838],
            [-13.360487188520406, -1.6030498823482557],
            [-13.360152735653003, -1.5910074141452946],
            [-13.355594588534661, -1.5812000592320452],
            [-13.355616329759812, -1.5731261958023106],
            [-13.361145627216867, -1.5692080165993552],
            [-13.363847451096042, -1.5659241753758426],
            [-13.363929497142372, -1.5619780940713055],
            [-13.366661479713839, -1.5552273027070902],
            [-13.370531025184516, -1.5492452109395107],
            [-13.369081895796667, -1.5445266751860622],
            [-13.36351948066134, -1.5380724310854894],
            [-13.359341647064605, -1.5298978326920203],
            [-13.358401951732068, -1.524762114449863],
            [-13.358989106042658, -1.5141283650222939],
            [-13.35577180527063, -1.5097426400682388],
            [-13.347848994543911, -1.5046694168822328],
            [-13.348544423628093, -1.5000274406762204],
            [-13.346635613076883, -1.4974798754120304],
            [-13.347335957193177, -1.4919187810900818],
            [-13.349639760922422, -1.4885951611984887],
            [-13.358314966827383, -1.4841790579845726],
            [-13.361365548627202, -1.4777973837875094],
            [-13.361636403703846, -1.4720472240362363],
            [-13.358328001338561, -1.4597528538285527],
            [-13.360014563263038, -1.452543088949622],
            [-13.363009463234421, -1.4488027737856295],
            [-13.363150796357294, -1.4415710803005481],
            [-13.361775388686834, -1.4273457772653633],
            [-13.362598725624851, -1.4209165516660103],
            [-13.359603078791498, -1.4141230588318587],
            [-13.354604118802857, -1.407339015040068],
            [-13.344269419448256, -1.3993041471782448],
            [-13.339043443761685, -1.3965801453260602],
            [-13.333572891776738, -1.3872236276798344],
            [-13.32932192856748, -1.3752740677263935],
            [-13.325333323268433, -1.3699194955866278],
            [-13.31959099674882, -1.3676610769680537],
            [-13.316048892847007, -1.3687677970096137],
            [-13.310259395744206, -1.373760893502933],
            [-13.303856947906583, -1.3735957513963823],
            [-13.29316638637599, -1.37525654431047],
            [-13.28699914649379, -1.38044311014631],
            [-13.281422021899397, -1.3834134636217081],
            [-13.277386003588024, -1.3872197273402223],
            [-13.267944294948425, -1.383990955179148],
            [-13.256713452005647, -1.3899605463951064],
            [-13.25151485038574, -1.389251205715076],
            [-13.240005232247826, -1.3729188429472188],
            [-13.234853037533794, -1.3703967251088405],
            [-13.228138137203398, -1.3649135395787264],
            [-13.228416354149813, -1.350407913227728],
            [-13.222537790519747, -1.3386452256764778],
            [-13.222274667289518, -1.334665958224046],
            [-13.218106093739857, -1.3319652428858217],
            [-13.210182541848809, -1.3293178738804035],
            [-13.20424423519019, -1.3284520143977399],
            [-13.197301716311616, -1.3257288328828443],
            [-13.191904755138461, -1.3224008690789264],
            [-13.188084502961061, -1.3181724466273226],
            [-13.181152963830423, -1.3165682151138631],
            [-13.174515239529915, -1.3193656621610428],
            [-13.168708862455272, -1.327161073065498],
            [-13.161015937847047, -1.3254321787522083],
            [-13.15500973420849, -1.3221154395533297],
            [-13.147583471520669, -1.3137775552477184],
            [-13.131068453344525, -1.3061729311893506],
            [-13.12420553272649, -1.305541226614658],
            [-13.11573613581195, -1.3027340331389161],
            [-13.109940060932962, -1.2994130976076128],
            [-13.102491324711613, -1.2974172643084814],
            [-13.094620096852628, -1.2965865571510913],
            [-13.083799804953735, -1.2843713079499455],
            [-13.078205259479452, -1.280212948763286],
            [-13.063238715215098, -1.2742321216133818],
            [-13.05680093637258, -1.2732411580368779],
            [-13.052831038518148, -1.2740134639414558],
            [-13.039524160087296, -1.2829640585078292],
            [-13.034321628098933, -1.284520889099158],
            [-13.017150724515165, -1.2829461754621225],
            [-13.01008931525416, -1.2811326782955053],
            [-13.000763053414616, -1.28075501512741],
            [-12.993151159270969, -1.278849514332803],
            [-12.990676567377157, -1.2762926405755612],
            [-12.986089265463301, -1.2680282577995023],
            [-12.981920511287488, -1.2667706160271701],
            [-12.977604218362169, -1.2677007529259539],
            [-12.96884500752341, -1.2737642907426536],
            [-12.964967568423587, -1.273434615864391],
            [-12.952408712855501, -1.2664015773504207],
            [-12.949080303030783, -1.262359491905783],
            [-12.94557951928155, -1.2548694042332098],
            [-12.94062124250497, -1.2513214736691625],
            [-12.933931444512973, -1.250686941231395],
            [-12.920052347846788, -1.2586825757286808],
            [-12.913102149587452, -1.2580425564290254],
            [-12.907420605803654, -1.252237544090023],
            [-12.901012991518437, -1.250471185350746],
            [-12.89157703781095, -1.2519305890301615],
            [-12.88276512891062, -1.2578402758175304],
            [-12.876391624371735, -1.2582585724801925],
            [-12.872714073782449, -1.2528769123837977],
            [-12.871534167352632, -1.2461913944154344],
            [-12.868556731417591, -1.242274642894521],
            [-12.865556033035803, -1.2417428482554647],
            [-12.856899319903011, -1.2432087423053566],
            [-12.852062861197615, -1.2414034990565856],
            [-12.847783916943884, -1.2377201216096065],
            [-12.842758210230944, -1.2260313486035819],
            [-12.838260667537098, -1.223758107875026],
            [-12.833540922361632, -1.2253426275686319],
            [-12.828237958109975, -1.2310611412018413],
            [-12.824355680721567, -1.2336368453059414],
            [-12.819887989929576, -1.2346045803264485],
            [-12.815529129326626, -1.233289434389169],
            [-12.813230943275487, -1.2308145015340595],
            [-12.812575600512206, -1.2253507180028123],
            [-12.814128318104887, -1.2201566093781009],
            [-12.814476060747749, -1.2108509114174628],
            [-12.811810229350531, -1.2072768929146651],
            [-12.804808914180851, -1.205867293453694],
            [-12.790393800031111, -1.2015112783550053],
            [-12.783179343380825, -1.2043114606952157],
            [-12.781807310048778, -1.2148189828030818],
            [-12.779247274549617, -1.2174960878583805],
            [-12.773730986696206, -1.2167745428796475],
            [-12.768045534374693, -1.2144068068634601],
            [-12.756907654045195, -1.2054985285966349],
            [-12.750953534115114, -1.1974674476021943],
            [-12.74699095564285, -1.1841394242598964],
            [-12.744650100607272, -1.1803636832301294],
            [-12.73822381259686, -1.1764372759198216],
            [-12.729548070860169, -1.175099284712009],
            [-12.72874154464703, -1.1638519967466172],
            [-12.726208903719408, -1.1635360477881052],
            [-12.72210711045438, -1.157539471777445],
            [-12.725247417043391, -1.1390657448162502],
            [-12.730343371203395, -1.1392204667315018],
            [-12.733849130766819, -1.1305626666358282],
            [-12.731943731807492, -1.1271770327509871],
            [-12.72661967898503, -1.1233176799236295],
            [-12.729864293732055, -1.1210690784496122],
            [-12.728428347892681, -1.1166717251329683],
            [-12.730266222745346, -1.1076332595475862],
            [-12.721607928704158, -1.1025728984618897],
            [-12.715954062046421, -1.1013850523632411],
            [-12.715892801175833, -1.0980278418063694],
            [-12.709863380600599, -1.0933801351584875],
            [-12.711288609398013, -1.0879573684884514],
            [-12.709440877079926, -1.0860104729077649],
            [-12.709881377410754, -1.0816984870828463],
            [-12.712423510735078, -1.080670131548428],
            [-12.718139732647394, -1.082337942087549],
            [-12.717169941327082, -1.0715604016481626],
            [-12.723863011899295, -1.0682168841005062],
            [-12.719789173396025, -1.06459863457063],
            [-12.724332056752797, -1.0616014062278916],
            [-12.721477100686299, -1.0591903205339481],
            [-12.721992841448623, -1.0551783387555251],
            [-12.726259233430348, -1.0552495537415447],
            [-12.728770089201781, -1.0486763420727192],
            [-12.72563455973214, -1.0463602080828864],
            [-12.727085761505638, -1.0417263399698886],
            [-12.725229623834606, -1.0351111563421684],
            [-12.728455021815124, -1.034431466787608],
            [-12.72720533068174, -1.0286263367905246],
            [-12.726852813116224, -1.0202523531791392],
            [-12.722278713218824, -1.020742357753353],
            [-12.717651264519638, -1.0137677637743279],
            [-12.722132413077462, -1.010578976543651],
            [-12.719233881871357, -1.0064628094719097],
            [-12.713670756033157, -1.00364225770625],
            [-12.713801973179194, -1.0009097678276497],
            [-12.708594355614643, -1.0004646563971542],
            [-12.707699413459661, -0.9979362563888464],
            [-12.70113091219944, -0.9972034685262737],
            [-12.699651381465966, -0.9930214253135181],
            [-12.695550788102713, -0.9899135654577653],
            [-12.693472096157597, -0.9864800434885023],
            [-12.694620533603764, -0.9784016086341785],
            [-12.6917149756961, -0.9752054335567764],
            [-12.686949589192457, -0.9731916208099366],
            [-12.688403479719423, -0.9696699787703152],
            [-12.685328498298748, -0.9673902352814063],
            [-12.686089535057636, -0.9616805286417803],
            [-12.682692042142449, -0.9588211489025384],
            [-12.68207838827241, -0.9553982325886717],
            [-12.685301840808586, -0.954144046805797],
            [-12.684958344462622, -0.9470979503742306],
            [-12.682925519532388, -0.9423194667637543],
            [-12.685638608928901, -0.9395972021293282],
            [-12.683196488776707, -0.9336722277161722],
            [-12.684505462201232, -0.929456407072901],
            [-12.68480974553556, -0.9163459774832741],
            [-12.681785874910151, -0.9134740302019017],
            [-12.685827502347742, -0.9089267393549569],
            [-12.68467226947281, -0.9060443578595763],
            [-12.6862922300652, -0.8993868168952899],
            [-12.684624207219668, -0.8971814749318937],
            [-12.686973460671961, -0.8930530394480191],
            [-12.682272664837296, -0.8893859820736918],
            [-12.681389957829126, -0.8806541658813836],
            [-12.676227472710197, -0.8767701864938953],
            [-12.67670174152636, -0.8718754247700556],
            [-12.67327551135497, -0.8673573956161733],
            [-12.675875607561949, -0.8639280123553684],
            [-12.671938081187905, -0.8621134067729763],
            [-12.669137665852725, -0.857355498838333],
            [-12.671381665628678, -0.8545683338348304],
            [-12.666354191085764, -0.8492290279125762],
            [-12.665990475668366, -0.8453506241811165],
            [-12.660776387717044, -0.8408620968831917],
            [-12.659595563407292, -0.8364914046313792],
            [-12.663851114841028, -0.8348139607161054],
            [-12.661684736586103, -0.8314949124966633],
            [-12.657280946689948, -0.8354670500671348],
            [-12.655387887950175, -0.8343189965677905],
            [-12.658017525501803, -0.8264408741338718],
            [-12.654181708681943, -0.8277128396938122],
            [-12.654305973054152, -0.8222331066369503],
            [-12.656748882739937, -0.8198754502999439],
            [-12.654261311957033, -0.8129922036799985],
            [-12.653893238032891, -0.8076834020171364],
            [-12.657028891678301, -0.8063996261441068],
            [-12.655277138770828, -0.8012962556585688],
            [-12.651935987727223, -0.7961291350880043],
            [-12.653185184072752, -0.7876641519123895],
            [-12.647714363690815, -0.7837444905088935],
            [-12.647342730431921, -0.779693081837094],
            [-12.636856365781956, -0.7680051006675352],
            [-12.633149809918285, -0.765103951700333],
            [-12.631395658312192, -0.7578601878554316],
            [-12.632890624018094, -0.7563805877924102],
            [-12.624479525170841, -0.7409146530602706],
            [-12.62181559372613, -0.7336569385174736],
            [-12.61860761794756, -0.7300257005490784],
            [-12.614529866090626, -0.7281469081266696],
            [-12.614866370528434, -0.7238978518138222],
            [-12.61180847827662, -0.7150250817005274],
            [-12.60662111222805, -0.7118715549335886],
            [-12.605764566219221, -0.7079106746655434],
            [-12.602401019802967, -0.7037436026907221],
            [-12.598566098874965, -0.6942549789746769],
            [-12.59955799176337, -0.6907352442414993],
            [-12.594728438271396, -0.6823320379410334],
            [-12.587123533820193, -0.6788837085105961],
            [-12.583864676907648, -0.6740713291779183],
            [-12.581083230322248, -0.6746017924725856],
            [-12.579287659896748, -0.6708685374388136],
            [-12.574970802724371, -0.6685023812939681],
            [-12.572605493932507, -0.6648190059092606],
            [-12.571325627178876, -0.6582005193559588],
            [-12.573327980546226, -0.6551051671843356],
            [-12.567490669325725, -0.6428310083309634],
            [-12.561001234939804, -0.6385152889213117],
            [-12.55289140192092, -0.6313757518774432],
            [-12.554347864416718, -0.6280302537720517],
            [-12.551850111404361, -0.6219690037500384],
            [-12.551574662369406, -0.6167935313175149],
            [-12.554183840832907, -0.611228006983756],
            [-12.55346583373568, -0.6072937491500086],
            [-12.55476080889971, -0.603084622820983],
            [-12.558728426699737, -0.5966894769834095],
            [-12.557089728487979, -0.5953507331374955],
            [-12.556307099098046, -0.5860264040398431],
            [-12.551696091686884, -0.5821381164688164]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.77052343768918,
          "lat": 35.83870743223998
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04005"],
        "coty_name": ["Coconino"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coconino County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00025443"
      },
      "bbox": [
        -13.440568001593679, -3.542859593230778, -11.15628645236416,
        -0.5821381164688164
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3521231216138556, -5.236406849480017],
            [2.475503244298212, -5.237223278407479],
            [2.532623491576464, -5.237148950302908],
            [2.5483035533985783, -5.237351823985043],
            [2.548480025324569, -5.2662390769028775],
            [2.5917940274580515, -5.266465296093097],
            [2.64654486373916, -5.266478274100146],
            [2.64445893141444, -5.271928131933599],
            [2.6377895156128517, -5.27834350052187],
            [2.635457050829611, -5.288399355759463],
            [2.6296582148901444, -5.299000146175803],
            [2.628540989186936, -5.307771245216304],
            [2.6224639463430224, -5.312512558341384],
            [2.6227671000566386, -5.3198203613088495],
            [2.616060768287193, -5.34267934257147],
            [2.612888090798977, -5.3474235637201115],
            [2.609635409173491, -5.349742012961965],
            [2.6113127236710962, -5.355963891368071],
            [2.6099293321513284, -5.365164584008333],
            [2.606885282579495, -5.370290785149094],
            [2.6063135156618515, -5.377352338283869],
            [2.6046057933892386, -5.379723786202172],
            [2.6035435660311013, -5.386744228468564],
            [2.601443413135367, -5.3888935175064185],
            [2.597619970704352, -5.397478079897184],
            [2.603048265371922, -5.409492530565357],
            [2.5981489802855724, -5.417797822983725],
            [2.592336675650901, -5.423716958447627],
            [2.595514205331908, -5.43505256855843],
            [2.592139778989303, -5.447875143194092],
            [2.590172435585281, -5.449234183519777],
            [2.588313575875363, -5.4547916383051165],
            [2.5552842162282534, -5.4538754786228285],
            [2.5551191434263623, -5.4976404800711505],
            [2.5548122921181595, -5.5120788205310856],
            [2.5551559957361034, -5.5267198823650805],
            [2.554928017472135, -5.5844831487357265],
            [2.554389223031568, -5.6960281863641775],
            [2.5290345697001992, -5.6965162599512675],
            [2.4541699803356076, -5.6980601274114075],
            [2.3605256909218264, -5.69986987795275],
            [2.2906709527656717, -5.701582799392507],
            [2.2901786264379917, -5.694384176600435],
            [2.284278453242677, -5.692108427989729],
            [2.2780356987979946, -5.6916941251462605],
            [2.2735195062347437, -5.688662790538804],
            [2.27541758001408, -5.683983827630519],
            [2.2806152055269755, -5.679177355073059],
            [2.2807715522739436, -5.672592548961268],
            [2.2781953982861456, -5.670487644248826],
            [2.272230843994948, -5.66963179668],
            [2.264385532271786, -5.666669396593478],
            [2.261899060487246, -5.6640129535758925],
            [2.265433127813271, -5.650162707289228],
            [2.2641827078497716, -5.643740474963474],
            [2.2514539262860334, -5.6363909192832065],
            [2.2425087082558033, -5.627574075440092],
            [2.2420722890847755, -5.623072483248775],
            [2.245702585234353, -5.621467327362617],
            [2.2497328180411817, -5.616837350110911],
            [2.2476792751709036, -5.6088422606878625],
            [2.248599748813634, -5.60490710909521],
            [2.2531513729623702, -5.59953357400191],
            [2.2543705924617337, -5.596235759681217],
            [2.253409904800846, -5.581408199210611],
            [2.2564272505414382, -5.576223928585939],
            [2.2607586071310144, -5.573144040958343],
            [2.2662889335760434, -5.572803272927659],
            [2.275435861440811, -5.5835791575452145],
            [2.2804695041329173, -5.585158551413094],
            [2.2834702845224917, -5.584291272918478],
            [2.2842043622916077, -5.576455808761762],
            [2.284032303543572, -5.567726060114214],
            [2.2864454926647753, -5.5633618888828025],
            [2.2934728407489895, -5.558130809328557],
            [2.3003402606498335, -5.558665689326844],
            [2.3041426617715057, -5.56238651373237],
            [2.3050382895805246, -5.573139776538372],
            [2.3091741091737683, -5.578336476142146],
            [2.3143284053047584, -5.580745630547704],
            [2.3160517995172345, -5.578801628238504],
            [2.3130349947312103, -5.567674200944097],
            [2.3127347604530994, -5.560919283608209],
            [2.314650017994788, -5.555409314204516],
            [2.31869109244143, -5.552965093827029],
            [2.326186752992785, -5.553725568538609],
            [2.3316240893880757, -5.556920773207087],
            [2.3347792833320415, -5.561246628272485],
            [2.341200393637276, -5.564698515110562],
            [2.347572170938517, -5.5627659211871965],
            [2.348500416441292, -5.558485045083904],
            [2.3458925971415945, -5.5533179722288475],
            [2.3422882005623054, -5.552174759593459],
            [2.332313649020565, -5.553345108888026],
            [2.327799813779063, -5.549410732717657],
            [2.3276330074321074, -5.541846625287606],
            [2.3302492728136066, -5.538955111386284],
            [2.3396161843826806, -5.5385028029053345],
            [2.3496680117549134, -5.536543916959938],
            [2.352984401485522, -5.534447702822384],
            [2.3541891616664348, -5.530627813179296],
            [2.3449489059616644, -5.5237519214364585],
            [2.342436667027799, -5.518320380084679],
            [2.3461243439551756, -5.511094171904949],
            [2.355269543684713, -5.502464823621771],
            [2.3657247367379277, -5.498689879079738],
            [2.3746328065496605, -5.49269261550295],
            [2.3747661811470393, -5.489699545083125],
            [2.3698191708147665, -5.490060131513313],
            [2.362232611574724, -5.494947831091936],
            [2.354536333832346, -5.496626048885844],
            [2.3507385163439922, -5.491584788715368],
            [2.3527908465169913, -5.484046731276703],
            [2.3629493663756485, -5.4750417538374885],
            [2.3672671381983834, -5.465967119509874],
            [2.366077327209911, -5.459452126147032],
            [2.3525913936210125, -5.44982571725761],
            [2.3491286739885937, -5.443526711018918],
            [2.3511151310602045, -5.435652335478306],
            [2.356108159475547, -5.430620187955695],
            [2.3628936134064378, -5.435134398468988],
            [2.368370011350708, -5.440340065712627],
            [2.3797766343528775, -5.441609931023397],
            [2.3823903234760353, -5.440225477900711],
            [2.3825644507306842, -5.4301815444004395],
            [2.384368931009648, -5.4216737588255075],
            [2.384045697292764, -5.413787747314979],
            [2.3788320474801568, -5.403053350235728],
            [2.3798779001607495, -5.399501027161727],
            [2.38350393268284, -5.397302810658824],
            [2.395994552967284, -5.396030617370252],
            [2.3996755761128905, -5.392853754506135],
            [2.401464096777526, -5.388188009716105],
            [2.3978511825796716, -5.383435675648988],
            [2.387448829813878, -5.378752081882118],
            [2.3801577321708622, -5.377601366051604],
            [2.371415097179891, -5.377984904120785],
            [2.367765857561089, -5.379269868076353],
            [2.3641591695618946, -5.374431555221503],
            [2.365012804987324, -5.365162562190038],
            [2.3709423144533504, -5.359793990749761],
            [2.3729166626954945, -5.3547168855132865],
            [2.3726247815617727, -5.3485512312572085],
            [2.3747449046142073, -5.346002289090402],
            [2.3809272600706035, -5.344006759597574],
            [2.386749586144156, -5.3456814771185766],
            [2.393108978658505, -5.34259672207588],
            [2.394573677400475, -5.339945838989942],
            [2.392181347827032, -5.336721140616658],
            [2.381957541908519, -5.329339527166156],
            [2.374396590294757, -5.333164501803698],
            [2.3712399680163827, -5.343158851569323],
            [2.367750301852704, -5.3455842493909485],
            [2.3599168909190453, -5.345780307817686],
            [2.355974787905217, -5.343569372463552],
            [2.351629874124881, -5.336572724052147],
            [2.3543104243443636, -5.3323432866967275],
            [2.3570557971824484, -5.33184345863504],
            [2.3666498406830554, -5.333975867175694],
            [2.371690226366743, -5.330491230827873],
            [2.368799773891251, -5.326924793157693],
            [2.3604853226311002, -5.322929862179551],
            [2.357660710194413, -5.31968728872832],
            [2.3568995722601165, -5.314096795381348],
            [2.352237962756742, -5.30608028832252],
            [2.345563934283271, -5.3017927212203535],
            [2.3436613983741323, -5.299012921264037],
            [2.344032022989967, -5.294688792549968],
            [2.3469020947136294, -5.292460324661565],
            [2.352378923624054, -5.290894616548782],
            [2.3580180011746648, -5.285928834320745],
            [2.357543967204169, -5.279346067961914],
            [2.3553004191288314, -5.277581471726237],
            [2.3507467353861617, -5.279263843043181],
            [2.344252536893913, -5.290157571240291],
            [2.3399355664974686, -5.291827593197378],
            [2.337446737784654, -5.288677374468572],
            [2.3311938876861, -5.277158529502559],
            [2.3324743852317567, -5.274435437667346],
            [2.3376002013509605, -5.273729429289951],
            [2.341564284708416, -5.275743542090497],
            [2.347167482703397, -5.274790893676363],
            [2.3470492419447124, -5.269764994914575],
            [2.3391833772671764, -5.263851022240336],
            [2.33849708161636, -5.261077062335348],
            [2.3400392933157073, -5.254491052642507],
            [2.3434942238775887, -5.246784198435784],
            [2.351344325282456, -5.240020326821466],
            [2.3521231216138556, -5.236406849480017]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.60699029422771,
          "lat": 33.241592231646834
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05073"],
        "coty_name": ["Lafayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lafayette County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00066864"
      },
      "bbox": [
        2.2420722890847755, -5.701582799392507, 2.64654486373916,
        -5.236406849480017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.5119648550219, -4.296029731114395],
            [4.555844582995198, -4.2940311973285565],
            [4.553878222845574, -4.245119500586944],
            [4.550761816883005, -4.160389802804603],
            [4.506208729719355, -4.161263902586766],
            [4.5035576512376645, -4.088975676329094],
            [4.501315367637541, -4.02993095713981],
            [4.499291336189532, -3.9855166948683114],
            [4.538784520783526, -3.984290688394559],
            [4.601137459409161, -3.982044163152682],
            [4.730827407936962, -3.976295820188745],
            [4.745352792205671, -3.9757599078581958],
            [4.8135842042888655, -3.9724861001333296],
            [4.87815024319504, -3.9692852587265253],
            [4.87592671429979, -3.9821183120710613],
            [4.876303667477034, -3.991710566989849],
            [4.879993273494206, -3.9998631301007657],
            [4.8920259424327845, -4.0180861712186156],
            [4.91324198317485, -4.039919570369648],
            [4.921129653442535, -4.050934633829849],
            [4.922067604092836, -4.054855594525147],
            [4.920495289059059, -4.068820916763035],
            [4.917895798249255, -4.072967688396065],
            [4.912506456493366, -4.078194638011569],
            [4.900771695296502, -4.086232455124028],
            [4.895306485204375, -4.08878475861654],
            [4.890281796134515, -4.095264146158943],
            [4.882440160782598, -4.120919829774968],
            [4.881780221764812, -4.127405784030994],
            [4.882839217849645, -4.134248203504879],
            [4.888805289004702, -4.156557810445276],
            [4.8935290848996305, -4.170485011282806],
            [4.898084254562553, -4.18005390955008],
            [4.896090534516403, -4.191357888680937],
            [4.892360661244268, -4.202334313278922],
            [4.883362041562845, -4.213906410786237],
            [4.877085336867889, -4.219226259173335],
            [4.871151304749615, -4.2225556736957985],
            [4.863942000887385, -4.223782829334567],
            [4.857022440199483, -4.223557193199472],
            [4.848834607470264, -4.225245887756581],
            [4.8405535826257005, -4.231865348846761],
            [4.8351665509571635, -4.239261794122822],
            [4.8379980068166715, -4.242988122776445],
            [4.829549255274419, -4.259596451718515],
            [4.829898631982624, -4.266876765592287],
            [4.835905083095799, -4.279435189200237],
            [4.8390563483407245, -4.292877953419625],
            [4.836246672800799, -4.299914117011197],
            [4.829878169322612, -4.302664760007548],
            [4.822714982213404, -4.3030544029219175],
            [4.8160918950442655, -4.300666123233771],
            [4.809879084097171, -4.294168431733281],
            [4.809023505479985, -4.287058741656265],
            [4.810267107706392, -4.277991689580522],
            [4.817701477745863, -4.2634978996512265],
            [4.821110864936722, -4.246237820421048],
            [4.8190244124823876, -4.244779867414086],
            [4.801149286036869, -4.254438022905789],
            [4.789213845517823, -4.257300096147074],
            [4.785319702800308, -4.257042967581486],
            [4.761108602332827, -4.250989420334748],
            [4.754884890051513, -4.252093462051643],
            [4.74929470188955, -4.256143024680194],
            [4.745629249781806, -4.26162160325176],
            [4.745196691087232, -4.264616096989142],
            [4.746661449564708, -4.272287016748724],
            [4.749866402092305, -4.277416971901279],
            [4.758362490252005, -4.285099242454063],
            [4.769335126239033, -4.297701111517072],
            [4.775064842142012, -4.306673562928547],
            [4.776614895301304, -4.316157528070528],
            [4.775005314071631, -4.329614675664453],
            [4.76844775163571, -4.33955291498713],
            [4.7636225983920015, -4.345012556378139],
            [4.757702649832054, -4.349235687274814],
            [4.7535131166736315, -4.35069401422772],
            [4.737907513642749, -4.349446766487389],
            [4.727008384057031, -4.345533968574259],
            [4.711054007676041, -4.341808450828292],
            [4.70808643900777, -4.341713277396748],
            [4.7006182326738255, -4.344465224614938],
            [4.697585100241031, -4.349157897551688],
            [4.697298030083385, -4.364711753190969],
            [4.694462330065544, -4.37901337184451],
            [4.693900595882872, -4.3856324945097285],
            [4.694992932549271, -4.396871549404016],
            [4.696858669949382, -4.40361948137544],
            [4.695951264233269, -4.407533902638132],
            [4.690226973699974, -4.417932947231341],
            [4.682358063319863, -4.413139760854988],
            [4.675524106559597, -4.413076872809564],
            [4.665485001993685, -4.410956972876482],
            [4.661655680583211, -4.409162400493219],
            [4.648657770011682, -4.40037773618192],
            [4.645585553171648, -4.396697254215832],
            [4.641531711466933, -4.385503672840807],
            [4.639663764249961, -4.382159946623994],
            [4.634615144574011, -4.380870008570564],
            [4.6257734739159115, -4.380740078923627],
            [4.621078414804544, -4.382991806795533],
            [4.616086864899872, -4.38999365811412],
            [4.615057283548826, -4.3953183517370125],
            [4.616031744682202, -4.403154738835674],
            [4.617982635967379, -4.410011283852964],
            [4.625942615274609, -4.420520332314238],
            [4.635659436246891, -4.4313350854791915],
            [4.64094613792011, -4.434730297312341],
            [4.658397224689818, -4.44351227191633],
            [4.666489829250534, -4.439838463648449],
            [4.672976805436821, -4.442300629527317],
            [4.680088523596334, -4.438832152489878],
            [4.685332779621851, -4.437615209984178],
            [4.691357000747316, -4.4380743485734975],
            [4.698777195058561, -4.439935528900775],
            [4.706769977608013, -4.438515797610289],
            [4.716551507261559, -4.439756006042653],
            [4.720116422582664, -4.4418319734062965],
            [4.72340916563158, -4.446572022633079],
            [4.725119227288572, -4.454949141701883],
            [4.725101606923614, -4.4606240740612915],
            [4.722705083246739, -4.4667093034845875],
            [4.718941282244976, -4.47297543911632],
            [4.7137545770206115, -4.479118408673898],
            [4.707678972244711, -4.483715453972613],
            [4.703016826197125, -4.485917231272546],
            [4.693992875079705, -4.487404037674398],
            [4.682977414029078, -4.485682166836734],
            [4.676094229727586, -4.4827039772432515],
            [4.670988578452804, -4.47821495425317],
            [4.6646773568628666, -4.474871953085983],
            [4.653964895260509, -4.465343365205865],
            [4.6462456705204875, -4.462357056113798],
            [4.640907883756947, -4.461459284552124],
            [4.630874735983002, -4.471725018861532],
            [4.619961444349175, -4.478808372797478],
            [4.602637479722208, -4.4937014863627285],
            [4.6009343577954285, -4.498791567300084],
            [4.603366975539632, -4.506781356720308],
            [4.60512704076182, -4.509051571154442],
            [4.606039819218252, -4.510228845576273],
            [4.603845978667571, -4.510708567853001],
            [4.472843060822014, -4.5170056601721],
            [4.476264105454616, -4.510784750384597],
            [4.478048537132016, -4.50451480777981],
            [4.481199859747177, -4.503501972691304],
            [4.485389634508425, -4.506330593422464],
            [4.488201875815663, -4.502787880355211],
            [4.487695367013159, -4.4978978799090195],
            [4.489953968721472, -4.494233609815849],
            [4.493615836560371, -4.493069193878126],
            [4.498975678339627, -4.493564368205458],
            [4.499544210446999, -4.488707342850197],
            [4.493599828738357, -4.478599904896491],
            [4.497135413935257, -4.476617828783884],
            [4.499147786305539, -4.47320518813943],
            [4.494362800722169, -4.4636372160535345],
            [4.490905447484839, -4.461360679003158],
            [4.489616948659468, -4.457119150272148],
            [4.494025266657224, -4.455103173888128],
            [4.494183383734024, -4.452082855367731],
            [4.488826339442696, -4.448239084871269],
            [4.48875456111364, -4.445267801929209],
            [4.492545643674175, -4.438194769243522],
            [4.49309733758811, -4.43319412337121],
            [4.496034509765527, -4.433165336417815],
            [4.4990104717808315, -4.436540138661458],
            [4.50391790529114, -4.436863038701337],
            [4.50762717465548, -4.431267260274078],
            [4.50775317723821, -4.421994174428681],
            [4.514732497163387, -4.416529286691759],
            [4.513578469175918, -4.41343276174445],
            [4.509502032024626, -4.409385863973893],
            [4.5083964134800905, -4.402056664520509],
            [4.5096741724260605, -4.395034537279208],
            [4.508678134688611, -4.393227647662399],
            [4.501892480743092, -4.390473657313513],
            [4.498210085245769, -4.38559965790562],
            [4.506273127472358, -4.383464939210078],
            [4.510934602453909, -4.378550389290249],
            [4.506097642024863, -4.372180775005914],
            [4.508616512293558, -4.368045302967337],
            [4.503433643486623, -4.368327791362431],
            [4.500159757440709, -4.3660830862274995],
            [4.501104159943999, -4.356807514108298],
            [4.497299811796095, -4.350460176419512],
            [4.500518607936844, -4.345443235952266],
            [4.500512415217116, -4.337279087016962],
            [4.503725668596727, -4.335039673796387],
            [4.507442192502421, -4.339420032567169],
            [4.506440733915378, -4.343356428792596],
            [4.5116473825707235, -4.3456224859143315],
            [4.512575704327726, -4.34091795652832],
            [4.510058907126507, -4.336414242135759],
            [4.510341656171212, -4.3298138931079695],
            [4.506472257599314, -4.322732308989627],
            [4.5080231535273345, -4.320826316066077],
            [4.514592725439419, -4.323225854700971],
            [4.516638602732637, -4.319331489222857],
            [4.513009868466363, -4.314238304869475],
            [4.507590856500665, -4.315383953622529],
            [4.506963106598558, -4.312597532462817],
            [4.513521245330376, -4.310659087508506],
            [4.5123671200375, -4.306437653852765],
            [4.51477128665245, -4.300411023314849],
            [4.5119648550219, -4.296029731114395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.84886829945981, "lat": 34.42743513566038 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05107"],
        "coty_name": ["Phillips"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Phillips County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00069172"
      },
      "bbox": [
        4.472843060822014, -4.5170056601721, 4.922067604092836,
        -3.9692852587265253
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.721459126802614, 0.8176131742846402],
            [-18.719168392242896, 0.812132836190785],
            [-18.721204600364196, 0.8066673005465294],
            [-18.728757959440696, 0.8018693599138828],
            [-18.72382146303975, 0.7966686628563926],
            [-18.724713558993656, 0.7927921078684596],
            [-18.719332856094393, 0.7916556164693128],
            [-18.719329746624325, 0.7837053948228713],
            [-18.715213332956875, 0.7841821787071354],
            [-18.71357441849601, 0.7808375537258722],
            [-18.708769750101546, 0.779239043667485],
            [-18.705939105103077, 0.7750061027112182],
            [-18.707380448756513, 0.7682360189413099],
            [-18.702788031721074, 0.762817330155835],
            [-18.703875353440605, 0.7594537881858924],
            [-18.70531936722901, 0.7480538434241367],
            [-18.70332605178575, 0.7451186418247905],
            [-18.703270791740366, 0.7410697179114137],
            [-18.70056747685666, 0.7403457979406449],
            [-18.696114639975058, 0.7341631373806533],
            [-18.700714853921497, 0.7319996844183294],
            [-18.700876161789235, 0.7286207779423721],
            [-18.696799925044616, 0.7220854609393998],
            [-18.69603510056267, 0.7156061969692432],
            [-18.69817522026318, 0.7115646060555801],
            [-18.697671913688573, 0.7014427366792706],
            [-18.692652223342844, 0.6982626867501429],
            [-18.69079731352599, 0.6874127302735895],
            [-18.688102920413094, 0.6811882915185598],
            [-18.692671883295294, 0.6794174350455754],
            [-18.69157000680289, 0.6747938649028824],
            [-18.687320060025947, 0.6730523173801762],
            [-18.685880877494757, 0.669024013123088],
            [-18.691698919402455, 0.6645122718207381],
            [-18.696169693201913, 0.6628596106149527],
            [-18.703327589772528, 0.6538016241705762],
            [-18.70289835185357, 0.6478620957760983],
            [-18.697653309000085, 0.643585703697915],
            [-18.696233029828022, 0.6400299952738],
            [-18.70000210624893, 0.6384024319642889],
            [-18.70107478638224, 0.6332059479300239],
            [-18.696114800295092, 0.63001137492164],
            [-18.69672126937211, 0.6273606057479799],
            [-18.70281593034595, 0.623046963674401],
            [-18.701840215470316, 0.6200164246477882],
            [-18.69789629356761, 0.6191072582639081],
            [-18.696783652091128, 0.6144530123676122],
            [-18.691389330292612, 0.6112994209280379],
            [-18.694003387502768, 0.6075104669501475],
            [-18.688832851341584, 0.6065487550821178],
            [-18.68595902726954, 0.5948628331505125],
            [-18.682544914161415, 0.593994909302218],
            [-18.67979891383383, 0.5885625414605703],
            [-18.673048048270342, 0.5892205233800011],
            [-18.671528916264425, 0.5803364203242777],
            [-18.672371689793383, 0.5765056145482886],
            [-18.670624473861864, 0.5723581051326506],
            [-18.661146873463977, 0.5719906693269916],
            [-18.655393667496757, 0.5628881551701644],
            [-18.656229880453576, 0.5547367027757216],
            [-18.649862066891917, 0.5543288731693866],
            [-18.649791508364796, 0.5504455251041406],
            [-18.6540073089821, 0.5484593226898464],
            [-18.655910320924043, 0.5453887839981278],
            [-18.653707960415417, 0.5403202420768616],
            [-18.657890110869378, 0.5340867446781439],
            [-18.655974371941348, 0.5292645620017943],
            [-18.64695529745687, 0.5293846745947441],
            [-18.643204389541825, 0.528061676722393],
            [-18.638749786753802, 0.5244944369959512],
            [-18.63828616192973, 0.5292322042345698],
            [-18.639363986962017, 0.5360070639344207],
            [-18.635476431503022, 0.5373046535055865],
            [-18.634406820793032, 0.5300060810969726],
            [-18.629391966430887, 0.5302229881534607],
            [-18.62764492361269, 0.5282962418207761],
            [-18.630438736151397, 0.5219122745172965],
            [-18.628138443637607, 0.5203093267956259],
            [-18.621185522900536, 0.5217175693429524],
            [-18.62292611537179, 0.5154826363734629],
            [-18.62147116981649, 0.5128102787152743],
            [-18.61558111538389, 0.5128066830616306],
            [-18.614347180636898, 0.5152858817266642],
            [-18.60671265774304, 0.5101047813060288],
            [-18.60440964538364, 0.5027001868938167],
            [-18.600506479197882, 0.500148345722955],
            [-18.603098885401486, 0.4966518164051147],
            [-18.601318745561542, 0.4922537865343899],
            [-18.598834899798593, 0.4934580588024427],
            [-18.598961732409084, 0.49848734095094954],
            [-18.597089149721466, 0.5011128808717324],
            [-18.591800652857344, 0.49926503812655726],
            [-18.59292069476882, 0.4939156205854704],
            [-18.584755256761184, 0.49941933136812483],
            [-18.583569987816645, 0.49656603301217656],
            [-18.575903834308427, 0.4952350760118043],
            [-18.57205467044483, 0.49190822566186354],
            [-18.569567054296108, 0.49507282923883417],
            [-18.566130122572584, 0.495638131226822],
            [-18.56472898465518, 0.4913465806549749],
            [-18.557614319884184, 0.48725266750873014],
            [-18.552817457081662, 0.48613080810363957],
            [-18.55271553621968, 0.49836211149480836],
            [-18.550355989210043, 0.4993945632181344],
            [-18.544183781263428, 0.4979104896072087],
            [-18.542092313158122, 0.5013823031385277],
            [-18.538670832035233, 0.5026412867684327],
            [-18.526607238272412, 0.5008972076750983],
            [-18.52808879634364, 0.49392075180517664],
            [-18.523672521945738, 0.48924224433332786],
            [-18.522667923845546, 0.4857375320816551],
            [-18.51978635050742, 0.48493780171773737],
            [-18.51243211394444, 0.49019376002357307],
            [-18.511551930955765, 0.49496479386460873],
            [-18.503751961636034, 0.5012882643092574],
            [-18.501154344265252, 0.5072703810750682],
            [-18.497450959574984, 0.5073508975894115],
            [-18.492196263457153, 0.5002805566090355],
            [-18.488380764930817, 0.5001488726350677],
            [-18.47780146741939, 0.5034941866450944],
            [-18.471318357782106, 0.5066500207547394],
            [-18.464963419580172, 0.507578237784219],
            [-18.4530427787403, 0.5068570262865043],
            [-18.44979211846019, 0.5044914729584596],
            [-18.445490215685815, 0.5041804885721759],
            [-18.437261596529595, 0.506799860569164],
            [-18.433820652862373, 0.5093292592923918],
            [-18.42341511538894, 0.5109709195354434],
            [-18.420843216317344, 0.5092799363467543],
            [-18.418419495781265, 0.5026654470476064],
            [-18.414699027159216, 0.5023794755347675],
            [-18.408473936129635, 0.5042155468823519],
            [-18.402345042580897, 0.5018816811906573],
            [-18.39737669575482, 0.4939649787601529],
            [-18.39205887868934, 0.49300874057196076],
            [-18.386769973933397, 0.49016882461755007],
            [-18.380515615941082, 0.4937962534827069],
            [-18.37768421133459, 0.49898566053086746],
            [-18.371931848630204, 0.500667133045094],
            [-18.360388497591575, 0.49692167840846657],
            [-18.354006055976296, 0.4984783583824655],
            [-18.35144235742105, 0.5058121674117639],
            [-18.346733646965145, 0.5073171265041916],
            [-18.343226034673823, 0.5052565478801752],
            [-18.342340153480155, 0.500144599682101],
            [-18.335013855645975, 0.49558133663593973],
            [-18.328038056531454, 0.49690168840761884],
            [-18.316865845214526, 0.4925219077898094],
            [-18.30898255310341, 0.4946560111256905],
            [-18.305862210374315, 0.5005679068895427],
            [-18.3011607892627, 0.5035222198908561],
            [-18.29567633432068, 0.49858208186559266],
            [-18.287390300113433, 0.4976269609261229],
            [-18.281220231781788, 0.5018842249315381],
            [-18.275194402250932, 0.5011233074167746],
            [-18.271622903186106, 0.4991376720795027],
            [-18.265704871877467, 0.5049303699336708],
            [-18.256337657456964, 0.49593670855645927],
            [-18.252085319377017, 0.4940682958708565],
            [-18.248292319860152, 0.4962848995645454],
            [-18.243630162462114, 0.49175834130378326],
            [-18.237788856547738, 0.49634985147524824],
            [-18.236798445894117, 0.4991987857374761],
            [-18.23107927571183, 0.498854608246267],
            [-18.230281004790914, 0.4912231755862705],
            [-18.221254015854957, 0.4831697526301698],
            [-18.217554791787702, 0.481663068220767],
            [-18.21324597039545, 0.48279043650447406],
            [-18.20693264584687, 0.4940568705047657],
            [-18.200172410485017, 0.4966209546561853],
            [-18.1947395462409, 0.503239050752521],
            [-18.18788606846158, 0.5033207414871707],
            [-18.18479102201314, 0.5054025846862966],
            [-18.18244901757234, 0.510876166542224],
            [-18.18374964973288, 0.5169411565100545],
            [-18.182789659974013, 0.5234589306114733],
            [-18.169213404287728, 0.5329286859241147],
            [-18.16459906662367, 0.5416222602101536],
            [-18.153441904131668, 0.5404807844320524],
            [-18.147770602712868, 0.5433969816099328],
            [-18.144458426991598, 0.5488598736494502],
            [-18.14494634997731, 0.5539265925575209],
            [-18.138726521767772, 0.556272821003674],
            [-18.134442499675163, 0.5602458980258792],
            [-18.1310331414017, 0.5595429209930399],
            [-18.127752970452296, 0.5612288997892997],
            [-18.128190673269877, 0.5687967547440231],
            [-18.132532954243807, 0.570009664663272],
            [-18.126984034690555, 0.5858012108416554],
            [-18.117890762214635, 0.5930679956655355],
            [-18.101369413842963, 0.6008221492915288],
            [-18.0921870332327, 0.6086590511077892],
            [-18.088248513275968, 0.6104325845736643],
            [-18.084852377803756, 0.6152146881143349],
            [-18.078453771455322, 0.616960262122668],
            [-18.068887528003977, 0.6115265742723186],
            [-18.063910616590213, 0.6104190223491756],
            [-18.0534651352103, 0.6120032456723098],
            [-18.05093155432881, 0.6171649414303509],
            [-18.04768200665392, 0.6372104543228954],
            [-18.04072594563215, 0.63963354086771],
            [-18.031255474824373, 0.6375673281413213],
            [-18.02550498230349, 0.6270779096358968],
            [-18.033696209844184, 0.617779305399312],
            [-18.031298626708935, 0.6143444526314554],
            [-18.025505432716827, 0.6172467781792536],
            [-18.020964306749686, 0.6180494899263407],
            [-18.013661512650643, 0.62840670000835],
            [-18.00845344730709, 0.6342603159588834],
            [-18.009492534470613, 0.6398465904619363],
            [-18.005662519149574, 0.6461560402257489],
            [-18.00320129400238, 0.6527439674133426],
            [-17.997983850247792, 0.6580079653019635],
            [-17.994111701407977, 0.6576698890552507],
            [-17.990253232593204, 0.6551846198412284],
            [-17.987215166181194, 0.6507160507566955],
            [-17.980696460866408, 0.6485093482366729],
            [-17.97187639775912, 0.6436365441857933],
            [-17.96605108684755, 0.6441574880273617],
            [-17.96421673292627, 0.6504608200861498],
            [-17.96527125629264, 0.6532116754243069],
            [-17.958597440675668, 0.6657805901629152],
            [-17.95306644015954, 0.6690885429217055],
            [-17.94397744469109, 0.6697462795298009],
            [-17.938313969538846, 0.6772726637271052],
            [-17.938664704055626, 0.6825966027584249],
            [-17.943178397664763, 0.6914385140938991],
            [-17.948195599252863, 0.6919537202208398],
            [-17.957991058459697, 0.6946723177217345],
            [-17.958728589335077, 0.6973544896552378],
            [-17.95199949832815, 0.7060057086833306],
            [-17.94980593213952, 0.7159029574963287],
            [-17.94514701130126, 0.720242699620948],
            [-17.939198361677335, 0.7204039079797854],
            [-17.936333232642216, 0.7180044761380449],
            [-17.931645418013513, 0.7072168978867982],
            [-17.927663829665633, 0.7047304786891233],
            [-17.9245075106435, 0.6994776098238685],
            [-17.921234768064227, 0.6992858787334862],
            [-17.918736943782665, 0.7050551454560865],
            [-17.916175054067892, 0.7076528624756538],
            [-17.91183629133143, 0.7154668602446671],
            [-17.903114038401384, 0.7168402207487686],
            [-17.898902959990995, 0.7094885934754024],
            [-17.896726301559266, 0.7083738218469441],
            [-17.893341592826552, 0.7019050564444342],
            [-17.893576509386158, 0.6978147585493808],
            [-17.89582093605485, 0.6956871720526286],
            [-17.89926803775516, 0.6880005411436196],
            [-17.89893273730143, 0.6836684678567015],
            [-17.893975919131112, 0.6718032349636945],
            [-17.885273323461796, 0.6707804234944453],
            [-17.87977007490915, 0.6787155329097776],
            [-17.880522284649846, 0.6840019653614502],
            [-17.87943539419208, 0.6877805132520968],
            [-17.87335569004572, 0.6966855917532959],
            [-17.87092608334113, 0.7021166204111868],
            [-17.86784545919697, 0.7024107911018416],
            [-17.85572091310884, 0.6981202778277525],
            [-17.848999697243507, 0.6994509188688203],
            [-17.8455481959254, 0.7066990745399451],
            [-17.844021649120748, 0.7133592879596157],
            [-17.83778360139357, 0.7146851182594046],
            [-17.83200776841087, 0.7129876750846248],
            [-17.82541521154704, 0.7083692373976653],
            [-17.822707679538084, 0.7027779718523196],
            [-17.82142852499752, 0.6955168290912439],
            [-17.811347288429605, 0.6926668453358917],
            [-17.809233271541324, 0.696074123514607],
            [-17.8004973372845, 0.6986299265913958],
            [-17.79860724193071, 0.7048948478635473],
            [-17.790879062065834, 0.7044076586256026],
            [-17.786261579664256, 0.7079783405850939],
            [-17.783856044252364, 0.7180467195368243],
            [-17.777216913568676, 0.7219985141006406],
            [-17.772578882585222, 0.7217193611576039],
            [-17.76648929807083, 0.72444086938646],
            [-17.761082019117183, 0.7330710501661369],
            [-17.754704816797485, 0.7370242841950471],
            [-17.752796703085334, 0.7409241818104996],
            [-17.752649231284575, 0.746578689074408],
            [-17.755736120450827, 0.7484876474139801],
            [-17.756600089006923, 0.7521806761555048],
            [-17.752995665600025, 0.7549820382884551],
            [-17.747077057413772, 0.7705279251022797],
            [-17.739470422695394, 0.7740258079019587],
            [-17.736549983242664, 0.7824414267608711],
            [-17.737088285595732, 0.7876243296557868],
            [-17.735484261043613, 0.7943232970250135],
            [-17.736348949380304, 0.80013131607398],
            [-17.739179937656218, 0.8037028232727585],
            [-17.735968521705466, 0.8127199490675312],
            [-17.732886574808845, 0.8162706555137412],
            [-17.73069319265537, 0.8214564021195958],
            [-17.731290303755518, 0.8314660222345398],
            [-17.733273636397268, 0.8338052214883768],
            [-17.732286898849274, 0.8417090809889707],
            [-17.729192191336256, 0.8444383651825764],
            [-17.721677486805532, 0.8484973473352566],
            [-17.717220702371623, 0.8477144587165086],
            [-17.713799354684983, 0.8516936107954134],
            [-17.714432575626756, 0.8550620297219411],
            [-17.719005811510545, 0.8599801457688486],
            [-17.717788232311563, 0.864410029632915],
            [-17.711825634574904, 0.8636706482864865],
            [-17.70783091710874, 0.8646711536492446],
            [-17.70651348046802, 0.8677063541251946],
            [-17.708735147973496, 0.8712547867344297],
            [-17.70460809937387, 0.8774148210658903],
            [-17.699802626726534, 0.8797613368575514],
            [-17.693546825171357, 0.8850486924335801],
            [-17.679670751982055, 0.894300752777016],
            [-17.426758929120147, 1.050750574645101],
            [-17.42227356351307, 1.0460027121056],
            [-17.41689230574837, 1.0383301832448577],
            [-17.414978299517227, 1.0326579492485513],
            [-17.40702928798275, 1.0265367723462604],
            [-17.402636984396363, 1.0256613727219315],
            [-17.399310515212154, 1.018497723032441],
            [-17.399153980246638, 1.013883617153404],
            [-17.39509629146977, 1.0155870460331153],
            [-17.38900781393607, 1.0127347866291443],
            [-17.384522319500753, 1.0168289419182814],
            [-17.382027475300287, 1.0157984657667256],
            [-17.378458904346846, 1.0181420043694276],
            [-17.37430761772605, 1.0162879712656903],
            [-17.371730208622193, 1.0126380480649104],
            [-17.370767632240785, 1.004394727341531],
            [-17.367526375277947, 1.0024533365886938],
            [-17.365004904903014, 0.9972579768079285],
            [-17.355135679503707, 0.9962863920738051],
            [-17.35214621343374, 0.9841145454694639],
            [-17.35022013973397, 0.9820816063302956],
            [-17.347540187480803, 0.9745610611154751],
            [-17.349327106463033, 0.9695936920655158],
            [-17.34220993687757, 0.9679493331521467],
            [-17.33954833384429, 0.961993435044268],
            [-17.336865748436015, 0.9603991189191242],
            [-17.336335180042976, 0.954654783828628],
            [-17.33769969254837, 0.9504153028625352],
            [-17.333700011426842, 0.946938476520202],
            [-17.327636687394463, 0.944618015706656],
            [-17.32387196014445, 0.9378728366668679],
            [-17.323879158573494, 0.9303770854502149],
            [-17.325577346005367, 0.9274876354866625],
            [-17.32542786751105, 0.9194284839047124],
            [-17.326481130166076, 0.9155762310727623],
            [-17.322213741686987, 0.9107085128771976],
            [-17.31444426139554, 0.9141050360485767],
            [-17.30956643128276, 0.9145960804439753],
            [-17.307662251375568, 0.9117148291409787],
            [-17.301054075987576, 0.9127504174508456],
            [-17.29999183672518, 0.9144383572497089],
            [-17.292652828283863, 0.9159536446521723],
            [-17.28907476534121, 0.9132465039802421],
            [-17.283792946401988, 0.9149624839768855],
            [-17.277490768317985, 0.9128318035291187],
            [-17.274627740929002, 0.9043372469927741],
            [-17.27233952547149, 0.9014995552214601],
            [-17.272731635450395, 0.8966093988256886],
            [-17.268346895730954, 0.8908409337751269],
            [-17.267663255565846, 0.8841123381715056],
            [-17.26721933424186, 0.8802694393521332],
            [-17.26421279249587, 0.8766238483540211],
            [-17.260269159738087, 0.8755350867002158],
            [-17.26106326023636, 0.8676408204495407],
            [-17.259813740021855, 0.8629341872930903],
            [-17.262459939600156, 0.8542812566709582],
            [-17.268071818249545, 0.849578537284521],
            [-17.271372776832923, 0.8440549616406043],
            [-17.275361562584035, 0.8460633581583855],
            [-17.2812028169324, 0.844416989745226],
            [-17.286112545985546, 0.8369212016205004],
            [-17.285928167773715, 0.8318880724839726],
            [-17.295682104735597, 0.8192204506972388],
            [-17.29366601808511, 0.8136251562045169],
            [-17.292752742001312, 0.8067341734535085],
            [-17.290651846556162, 0.8050587428389407],
            [-17.290625261512005, 0.7984250978631433],
            [-17.28749396259545, 0.7973680478754148],
            [-17.286222315598224, 0.7906549054875875],
            [-17.288927395561025, 0.7810144206741226],
            [-17.295224223749948, 0.781999720967187],
            [-17.301223243396716, 0.7772521660953734],
            [-17.30530927684805, 0.7689252706210716],
            [-17.30244180943403, 0.7634005703722677],
            [-17.301396608865137, 0.7584969862721556],
            [-17.297895126286242, 0.7581975856241843],
            [-17.29290538903169, 0.7531300492604707],
            [-17.286702367485745, 0.7492676381328469],
            [-17.282307768631256, 0.7416140361575889],
            [-17.28017297716374, 0.7407418426711019],
            [-17.276317933520275, 0.7325959217555592],
            [-17.270280033691463, 0.7338817031559174],
            [-17.265835435206235, 0.7381097679625311],
            [-17.25484463433079, 0.7408414627766189],
            [-17.25147711876248, 0.733478176134454],
            [-17.250733053169377, 0.7251485263867926],
            [-17.244987058347235, 0.7109779036961945],
            [-17.24322149746396, 0.7027824904494605],
            [-17.240291586358843, 0.6980791962299002],
            [-17.2410606051364, 0.6946656486789043],
            [-17.24028886987061, 0.6876922799139296],
            [-17.237185438872636, 0.6817573282646765],
            [-17.23747638197596, 0.6773868647548835],
            [-17.231966382257262, 0.6654430517653395],
            [-17.234178310696887, 0.6642257183495576],
            [-17.24266902823427, 0.655390985384223],
            [-17.244686395353906, 0.6559294278130201],
            [-17.251200313120144, 0.6512189067099252],
            [-17.252406646196214, 0.6460745461819059],
            [-17.25150006087185, 0.6421099506433592],
            [-17.256228502078134, 0.6366015075833918],
            [-17.253020086571777, 0.6309889170132763],
            [-17.2523667397132, 0.6266651431844169],
            [-17.253750388698474, 0.6223619713210665],
            [-17.251203199184026, 0.6210410366961395],
            [-17.257878049731392, 0.6137602639207177],
            [-17.25730131438385, 0.6098375136760609],
            [-17.250113510764443, 0.5961013431909628],
            [-17.252215729640394, 0.5887339483716926],
            [-17.251020380906443, 0.5839711020128988],
            [-17.254346479772032, 0.579215284888799],
            [-17.25949080259933, 0.5759947737298494],
            [-17.256751064054402, 0.5679520508492414],
            [-17.258894689487768, 0.5622957402682186],
            [-17.252617970312386, 0.5522153925446023],
            [-17.252282246440007, 0.5465394801480439],
            [-17.24634324697098, 0.5440119865247312],
            [-17.242105740807087, 0.5393078793885866],
            [-17.23667679470964, 0.5396803840791767],
            [-17.234080129694682, 0.537545669988161],
            [-17.23076854003346, 0.5392771936759037],
            [-17.22060886431784, 0.5400719085301828],
            [-17.211732583850623, 0.5312655624500731],
            [-17.20564276272667, 0.5314012261183906],
            [-17.20423490169396, 0.5276193238317931],
            [-17.203711593400687, 0.517206528534235],
            [-17.2020395949876, 0.5141669904836098],
            [-17.19652121865208, 0.5142072957022884],
            [-17.191202188909944, 0.5117531614321231],
            [-17.192462158226597, 0.5044693835846589],
            [-17.18965253487774, 0.5016214552399332],
            [-17.18672537236336, 0.5020528357552354],
            [-17.169492822140477, 0.4971298192155744],
            [-17.163283216465693, 0.48644391689861255],
            [-17.16094972110409, 0.4792532880353001],
            [-17.15773242142413, 0.47738264702186717],
            [-17.154379437421415, 0.4719094573401891],
            [-17.147083861918443, 0.4726520041739046],
            [-17.140451542158623, 0.461842459116061],
            [-17.14040069553926, 0.4575375364822143],
            [-17.138609675234402, 0.45211301965345535],
            [-17.133608145557034, 0.4475495367572404],
            [-17.12787590342454, 0.44458956802005795],
            [-17.126347186096297, 0.4380770961389723],
            [-17.11528278639802, 0.43602129463512546],
            [-17.110960827354628, 0.43640377799603935],
            [-17.104783927470585, 0.4256925393344051],
            [-17.106553772952932, 0.42203910656842414],
            [-17.105196062511357, 0.41651074638255164],
            [-17.111809448153494, 0.41200784226247794],
            [-17.110243719084373, 0.40381132710846523],
            [-17.105022241519457, 0.39888034783468296],
            [-17.10197777728954, 0.3881958326529071],
            [-17.10412537470914, 0.3810047696968942],
            [-17.10904160158052, 0.3770318798825066],
            [-17.1071859658303, 0.37242881059692695],
            [-17.104800768443294, 0.37143174388072314],
            [-17.10275549478148, 0.3645153938417948],
            [-17.100156866887836, 0.3607559592767529],
            [-17.106129285787677, 0.358533891086938],
            [-17.108326500845383, 0.3534544832924309],
            [-17.106962761803615, 0.3489730040062534],
            [-17.10196468203723, 0.34268381649972346],
            [-17.103522487998752, 0.33755454397650275],
            [-17.100353440973535, 0.3334704209168691],
            [-17.102454640826195, 0.32099528761980756],
            [-17.10201317586941, 0.31808563565918635],
            [-17.097816704310123, 0.31759711150678155],
            [-17.094287210460575, 0.304496236767944],
            [-17.0926988099854, 0.29279723046997513],
            [-17.093593587561127, 0.2839785357322613],
            [-17.090647084052502, 0.27216179020263154],
            [-17.08958304715044, 0.26505386762661803],
            [-17.08718735346278, 0.26281813106061486],
            [-17.090589624833914, 0.25678132846753904],
            [-17.089198859286668, 0.24627276529183806],
            [-17.086646123500177, 0.24264984259091935],
            [-17.088843690956114, 0.23891978108920436],
            [-17.09298236472359, 0.23762784866429265],
            [-17.097760826173477, 0.22698306829372514],
            [-17.095184959181946, 0.22514232933045858],
            [-17.09661851467632, 0.2199790983355423],
            [-17.093926326303585, 0.21701107632370653],
            [-17.097239067776425, 0.20581342592868324],
            [-17.09717309919464, 0.20108396484629504],
            [-17.099229318963264, 0.19869471615595755],
            [-17.107022131458347, 0.19390803641093476],
            [-17.110816360564943, 0.19316930349814546],
            [-17.121481653762107, 0.19569835113111197],
            [-17.125349940837282, 0.19292428381103174],
            [-17.124467757200875, 0.18720836823587234],
            [-17.12520138593931, 0.18143803651588525],
            [-17.12207370983245, 0.17598386167924132],
            [-17.122666373237088, 0.17078197337634277],
            [-17.119657850655653, 0.16873317632058024],
            [-17.119686754090424, 0.16381970200446141],
            [-17.11750275724734, 0.15949469562043692],
            [-17.117813519281672, 0.15336353236024353],
            [-17.120936282422498, 0.15097803348376299],
            [-17.12304047935583, 0.14526667947190852],
            [-17.126440410094048, 0.14265604053217193],
            [-17.12407193102663, 0.13824624304654107],
            [-17.12588776582834, 0.1320369379448395],
            [-17.123694008601877, 0.12621564262524668],
            [-17.12646014286279, 0.12386815964712253],
            [-17.12482820821264, 0.12046581743657149],
            [-17.12554254572196, 0.10932028653986224],
            [-17.12010312557125, 0.10224259515520481],
            [-17.270499795413972, 0.13842852179843915],
            [-17.27147908721937, 0.13284022945703394],
            [-17.42249127440314, 0.1698470955974819],
            [-17.559248627148158, 0.20518393091888898],
            [-17.600435771910952, 0.21579454197114506],
            [-17.622667824900596, 0.1334118568818813],
            [-17.645488553544702, 0.13925882786530208],
            [-17.68941557878134, 0.15106470643793593],
            [-17.702524426657558, 0.15353201404413352],
            [-17.728738781680374, 0.16097059974071706],
            [-17.75875297304509, 0.16898322754615755],
            [-17.768801298246814, 0.17141264085632402],
            [-17.79910189486404, 0.1799563851582058],
            [-17.8127711805937, 0.18423848972091067],
            [-17.8684739851061, 0.19807976284508633],
            [-17.890134172353886, 0.11308367811111049],
            [-17.972965940203164, 0.1354174071344837],
            [-18.014147877859834, 0.1458034383451258],
            [-18.03691532638548, 0.13226900790447427],
            [-18.047888802623238, 0.12473683780570123],
            [-18.065350901283452, 0.11401235607257938],
            [-18.082935813298192, 0.10378934224857506],
            [-18.098829400648878, 0.09394004235079154],
            [-18.108839347713104, 0.08726784080095448],
            [-18.11798575042577, 0.0820701149816566],
            [-18.178384024228446, 0.04796536534825892],
            [-18.207232890239613, 0.03194320102128107],
            [-18.20739570708263, 0.035711482580966604],
            [-18.210389390384005, 0.04071120806816957],
            [-18.208238128118627, 0.04481699027476584],
            [-18.21618201526925, 0.04535249798751465],
            [-18.221478640515492, 0.042711874195585454],
            [-18.226946592328186, 0.04268914700679626],
            [-18.231451978300832, 0.04432174276783191],
            [-18.23567726676819, 0.047554219685600634],
            [-18.238301433157215, 0.046416348792206935],
            [-18.2426550441123, 0.04137099624205893],
            [-18.250086801365953, 0.04178985263609946],
            [-18.256840062180167, 0.04625773617862206],
            [-18.25972153736883, 0.043023350778698344],
            [-18.262280529476154, 0.04447301073136949],
            [-18.270247841138566, 0.04536492820118181],
            [-18.27621951478229, 0.0391846159864752],
            [-18.276600379389187, 0.03439455663613267],
            [-18.279117003366867, 0.0326042252886135],
            [-18.382055680147978, 0.05897111172430989],
            [-18.437981857126633, 0.07225665006350566],
            [-18.441673850923003, 0.057928885044055065],
            [-18.44407558204789, 0.05105672353231053],
            [-18.463373604525323, -0.027367136024506303],
            [-18.49292773500018, -0.14154508692203402],
            [-18.493021044521438, -0.1424299447654893],
            [-18.51059698125318, -0.15186948301650335],
            [-18.528304213026768, -0.16261368831800257],
            [-18.533630373443856, -0.1652162830730475],
            [-18.653444822330172, -0.2335025583305896],
            [-18.65480353806107, -0.2340572201725845],
            [-18.72265448373248, -0.27216971962539144],
            [-18.726511301096195, -0.2744844305231804],
            [-18.838725237332895, -0.33864370557879986],
            [-18.84544569205369, -0.3351622711288864],
            [-18.845688154138198, -0.33062672125390097],
            [-18.849965627752965, -0.3270056630040853],
            [-18.84897288231517, -0.32385319754428854],
            [-18.85119430291161, -0.31877127372300734],
            [-18.848827477419935, -0.3138555638802672],
            [-18.848382055095918, -0.3061511167511172],
            [-18.852977519838774, -0.29562010996334304],
            [-18.856139725017346, -0.2956149842601307],
            [-18.86044830593966, -0.2903193201157008],
            [-18.859320811062553, -0.28279835975461676],
            [-18.862182949889533, -0.27802111135171004],
            [-18.859279916855204, -0.2735559544263646],
            [-18.88012205319588, -0.26303963242827677],
            [-18.88446167108031, -0.2633470052907377],
            [-18.88584165652616, -0.2603919081199145],
            [-18.893044428342876, -0.2542781049162494],
            [-18.90527789928076, -0.25174910009363793],
            [-18.91447603663211, -0.2543571502681419],
            [-18.916367428410496, -0.2519731828674669],
            [-18.915745001784448, -0.24646829965477676],
            [-18.916869706881357, -0.2426203081575325],
            [-18.919588406094473, -0.2405247009719966],
            [-18.92275694520395, -0.23529570331807365],
            [-18.92237975000526, -0.23193021029362823],
            [-18.929844134296715, -0.22446517189442153],
            [-18.935520104772475, -0.22229889919200693],
            [-18.937683541208543, -0.21705051695779182],
            [-18.94066309550994, -0.21418473327393459],
            [-18.94172204407504, -0.20857882076787287],
            [-18.9392702339141, -0.20478374108269523],
            [-18.952928037594535, -0.19025474840914694],
            [-18.96083301046246, -0.18676738603985335],
            [-18.964924533640254, -0.17990015777041043],
            [-18.96995196204917, -0.18315178818921482],
            [-18.975238975061394, -0.18058412668306573],
            [-18.97226045041792, -0.17247467527403576],
            [-18.972949216623174, -0.16959971222852485],
            [-18.980270438106725, -0.16632941408827415],
            [-18.981496108024956, -0.1627153513770585],
            [-18.981704628061255, -0.15607637618689427],
            [-18.98576301370759, -0.15145696283576682],
            [-18.991387120441004, -0.14944977788697306],
            [-18.996399355420873, -0.14508477617315507],
            [-19.002004362436345, -0.1354792531050329],
            [-19.005196510680427, -0.13237558558711912],
            [-19.01128920839334, -0.12194224594571584],
            [-19.012731520251943, -0.11481683296110468],
            [-19.008211076633906, -0.10784354135732799],
            [-19.006225979307555, -0.10187379204457118],
            [-19.008646124899446, -0.09300576693978986],
            [-19.010126322123543, -0.09065514065986706],
            [-19.015575148952742, -0.08805323765176387],
            [-19.01634141701166, -0.09050862679724733],
            [-19.020792228223886, -0.09447410797382727],
            [-19.031683584281655, -0.08744163659892543],
            [-19.034529003512628, -0.08393586749594062],
            [-19.042156451755496, -0.08249585355150413],
            [-19.045747957309807, -0.07452793298838374],
            [-19.043051733913135, -0.07235591165697539],
            [-19.041023116173935, -0.06720921742931105],
            [-19.046364396787002, -0.06306028410152967],
            [-19.044266660205153, -0.05719887846477389],
            [-19.044959035358648, -0.049893183969930144],
            [-19.04908241189619, -0.04362944747122901],
            [-19.049793334830635, -0.039665531570412776],
            [-19.04789094490622, -0.032936643629733815],
            [-19.047829655916317, -0.023821357295058368],
            [-19.04698165843809, -0.01928750879007939],
            [-19.04908111839785, -0.0148523508800765],
            [-19.044075735876305, -0.015278143069801294],
            [-19.04043067066571, -0.009973654678156533],
            [-19.03479946592298, -0.01505764526857561],
            [-19.030076298342454, -0.014633813869235054],
            [-19.03171837543677, -0.010512812965006073],
            [-19.02731069643161, -0.004824476397160081],
            [-19.024067746727205, -0.0057485128952867726],
            [-19.023180256029224, -0.0014361130013077284],
            [-19.020617353197686, 0.00017937068611189344],
            [-19.014348940811853, 0.010655441923143744],
            [-19.009876589187385, 0.010699659095229925],
            [-19.004194045151195, 0.013902735733983373],
            [-19.00502746911795, 0.01849903431133281],
            [-19.010356466072807, 0.027805600580026874],
            [-19.010974633167994, 0.03330061132275512],
            [-19.016103403639043, 0.03870364450103221],
            [-19.01612918249728, 0.045284460759323956],
            [-19.01914348087079, 0.04950351545845559],
            [-19.026618032827876, 0.05407354530590452],
            [-19.028790828570546, 0.06163220391982483],
            [-19.033758022191854, 0.06711144542676961],
            [-19.03410216047515, 0.07212938910298285],
            [-19.0302563103843, 0.07524878237933724],
            [-19.025664163260096, 0.0764645779823001],
            [-19.027510321913866, 0.08702305782232282],
            [-19.022759889609258, 0.09141671464506076],
            [-19.023566674469105, 0.09449583322699055],
            [-19.01994109733347, 0.10076331863801406],
            [-19.025783493134732, 0.10690665122985388],
            [-19.02289730329129, 0.11019747267816819],
            [-19.023676813930006, 0.11433167318734305],
            [-19.019038380189812, 0.11730010098188937],
            [-19.015960215827228, 0.12111657823419524],
            [-19.01098739064793, 0.12279647893546053],
            [-19.003391821438242, 0.12977413953601163],
            [-18.989258561489386, 0.1290343764252384],
            [-18.986407218803574, 0.1301014386052684],
            [-18.978894530707947, 0.12724443961215642],
            [-18.977183581038524, 0.125456210163625],
            [-18.968610488058484, 0.12635647358391558],
            [-18.967358491395167, 0.12484573804688963],
            [-18.962093697810815, 0.12638214270040632],
            [-18.96175397589704, 0.12915444569659085],
            [-18.956287673501848, 0.1276658719423824],
            [-18.951262500716453, 0.13047035107737914],
            [-18.94838423668636, 0.12991926517695515],
            [-18.941711832895052, 0.15639266630796045],
            [-18.92665816714011, 0.21466689995170166],
            [-18.921455230046, 0.23347281853653482],
            [-18.90757194522528, 0.2859299109132059],
            [-18.91261358340391, 0.2872720916360898],
            [-18.92009349031442, 0.3002949311181957],
            [-18.97152499626261, 0.39087352325806785],
            [-18.99435895414234, 0.43124944006023636],
            [-18.99534295357348, 0.43242056741708756],
            [-19.054163426445527, 0.5355238272563178],
            [-19.065409469477775, 0.5549934710076317],
            [-19.08905752864402, 0.5977394242741801],
            [-19.077748532554754, 0.6047106949918188],
            [-19.047368351307703, 0.6223412946814515],
            [-19.04508889445162, 0.6240133655559225],
            [-18.950850001119573, 0.6804129508893355],
            [-18.88538857049123, 0.7197574471262569],
            [-18.83251179738713, 0.7512702369006008],
            [-18.782538788710006, 0.7378275389188723],
            [-18.774983462055772, 0.7661155770345986],
            [-18.77060143323732, 0.7687950865003845],
            [-18.76862013448292, 0.7744638462849452],
            [-18.77191243434807, 0.7763146089266539],
            [-18.77283933557954, 0.781326385335399],
            [-18.77677403051152, 0.7843313033200504],
            [-18.77361670351713, 0.786497078266866],
            [-18.721459126802614, 0.8176131742846402]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.64926584892615,
          "lat": 36.75823003645674
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06019"],
        "coty_name": ["Fresno"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fresno County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00277274"
      },
      "bbox": [
        -19.08905752864402, -0.33864370557879986, -17.086646123500177,
        1.050750574645101
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-20.501386115125243, 4.421100404988199],
            [-20.437585648362017, 4.401891240052545],
            [-20.30340908191373, 4.362351123189681],
            [-20.299949265041114, 4.360996992033862],
            [-20.271453192772405, 4.352407811403885],
            [-20.15317411446594, 4.317290282479471],
            [-20.160433643632587, 4.293293065893084],
            [-20.06677514938456, 4.265737013786435],
            [-20.064134743646136, 4.264830825067198],
            [-20.00576280004253, 4.247789424298069],
            [-19.88505195763831, 4.212829205330983],
            [-19.7643463262008, 4.17784950561615],
            [-19.762096878585137, 4.177010986000427],
            [-19.715413879296797, 4.163668580318482],
            [-19.712160022806845, 4.15553638214487],
            [-19.714078448145465, 4.143644669358347],
            [-19.71672911309326, 4.141192827715339],
            [-19.719496793365423, 4.130196309854074],
            [-19.71214139377484, 4.11835221185],
            [-19.712289470697826, 4.114451337102286],
            [-19.719528392079276, 4.113283813851403],
            [-19.722034805935238, 4.107068073942841],
            [-19.722965632162847, 4.101236679284461],
            [-19.729749787358553, 4.099070606491231],
            [-19.736001027584862, 4.099675393606376],
            [-19.74692107829639, 4.099098181352996],
            [-19.74911294582539, 4.085456653017477],
            [-19.751718270973786, 4.081558439905142],
            [-19.754545657064078, 4.072051071822517],
            [-19.759263480825027, 4.065822497898986],
            [-19.75828337058509, 4.06184345196112],
            [-19.761624955320656, 4.056080823646756],
            [-19.765106111263506, 4.0527128748049375],
            [-19.76483692713746, 4.0486016541613905],
            [-19.76819463116751, 4.0465683492059545],
            [-19.771956411758875, 4.04077265114009],
            [-19.770986767720444, 4.03416315636121],
            [-19.767827415957868, 4.031428389823057],
            [-19.765507466226314, 4.026549014491202],
            [-19.767718973008076, 4.021088729627748],
            [-19.7700624845708, 4.009684157317984],
            [-19.770301677397768, 4.002693015151888],
            [-19.772221861665184, 3.99513537884913],
            [-19.768861607952612, 3.9904927448984555],
            [-19.77100608640659, 3.983663949170402],
            [-19.780988706227074, 3.9483398974093737],
            [-19.78354133477723, 3.942276251595235],
            [-19.764585130225754, 3.9368262247441295],
            [-19.775971029524868, 3.898767775861401],
            [-19.76113814494432, 3.894646875895192],
            [-19.783709831355267, 3.8110188710994475],
            [-19.782799152071128, 3.7980059847022405],
            [-19.792061902960317, 3.7685412339901525],
            [-19.79659994220026, 3.754158312428392],
            [-19.807658967101045, 3.726990441551181],
            [-19.810095154745223, 3.7201769254569177],
            [-19.817944948287167, 3.723146039453885],
            [-19.832840076446878, 3.7276145828229588],
            [-19.843647518878537, 3.731702058310658],
            [-19.84768954401946, 3.7178561165932376],
            [-19.89104270887611, 3.732040658139837],
            [-19.904183599898165, 3.7372448529896416],
            [-19.91199078149827, 3.739003944411489],
            [-19.9142615562221, 3.7317293693823705],
            [-19.928212097080667, 3.735856187057718],
            [-19.930328899725968, 3.728482070879348],
            [-19.944124307046767, 3.7324616579348673],
            [-19.958480581166263, 3.6830653063184657],
            [-19.965838260286922, 3.685424780672894],
            [-19.96823101163369, 3.6691190431581835],
            [-19.9717270585838, 3.670245575556333],
            [-19.97542807420889, 3.6560022953248015],
            [-19.980071742092736, 3.642348039823661],
            [-19.9662903209376, 3.6382170034778736],
            [-19.97507062904188, 3.6104452586324607],
            [-19.968044043867017, 3.608288562767743],
            [-19.97296222253467, 3.5945033041758703],
            [-19.965154223383333, 3.5920152822084632],
            [-19.97285385123496, 3.56518467256668],
            [-19.96613432371861, 3.5636428224310803],
            [-19.970314170467994, 3.549327149160031],
            [-19.963693647877264, 3.547395986590404],
            [-19.976022385555392, 3.5050132517209662],
            [-19.96485328592641, 3.50196769249823],
            [-19.970074066595615, 3.4816544125058564],
            [-19.96353331553767, 3.479086905203723],
            [-19.96968836085827, 3.459010596444463],
            [-19.982774787915954, 3.463102277703124],
            [-19.98693008073366, 3.448357306834872],
            [-19.993128617550582, 3.449850075920381],
            [-19.995331792676033, 3.443143498258305],
            [-19.997541705512845, 3.4437881469449527],
            [-19.9995581880605, 3.4374470160100308],
            [-20.00295829536912, 3.438124036597194],
            [-20.005660970474064, 3.4313552162953815],
            [-20.008874668348504, 3.4323969737450706],
            [-20.01145830536866, 3.4254873434152215],
            [-20.015334666931544, 3.426722732375391],
            [-20.01926842351941, 3.415482213590431],
            [-20.022613222934986, 3.416352678374675],
            [-20.024919766559314, 3.4095730900546783],
            [-20.048418334311666, 3.416752496293941],
            [-20.05858547886267, 3.38291612339188],
            [-20.065614553627622, 3.384606045682905],
            [-20.069224457365188, 3.3714902520536993],
            [-20.07371102981573, 3.3572369398023136],
            [-20.07195112138578, 3.356739038536403],
            [-20.076004099101294, 3.3423817195469576],
            [-20.082790870788987, 3.3443668637193755],
            [-20.086980846182332, 3.3300798035122345],
            [-20.08852171174646, 3.32157144329201],
            [-20.08171496263242, 3.3193704462731812],
            [-20.083860695987937, 3.312330821717802],
            [-20.070089452509777, 3.3081988725716247],
            [-20.074245612801516, 3.294291934681468],
            [-20.067555425369076, 3.292232126532282],
            [-20.075795916785392, 3.2643932336917563],
            [-20.06905734376338, 3.2622148971107543],
            [-20.070922164566156, 3.2553027159226424],
            [-20.064080945922157, 3.253201194766978],
            [-20.06597266208909, 3.2461917776185376],
            [-20.059103519839425, 3.244185752979322],
            [-20.061926423339692, 3.234609273755566],
            [-20.054968924805056, 3.232600230877791],
            [-20.055969748391682, 3.229051627131852],
            [-20.049025000031126, 3.2272581252739196],
            [-20.048019491319316, 3.23066779332342],
            [-20.031145082121032, 3.226358141997369],
            [-20.035214177600313, 3.2125545045434634],
            [-20.028405534935096, 3.2104565899299313],
            [-20.038852419061953, 3.1754779770215107],
            [-20.031935007411164, 3.1732671058485655],
            [-20.033780326330536, 3.1671466829228425],
            [-20.037055696457276, 3.160221314316742],
            [-20.029911661402124, 3.1579377121601793],
            [-20.033136847624906, 3.1515698615417596],
            [-20.02367227958511, 3.1487429462802905],
            [-20.028830426564088, 3.133763646656679],
            [-20.03064720087246, 3.1242868441204443],
            [-20.019078644446004, 3.12218195649884],
            [-20.002541847959396, 3.1174898005838223],
            [-20.004312397879144, 3.111328299635038],
            [-19.991286030568837, 3.1079155989537983],
            [-19.99597786862282, 3.0938517908497913],
            [-19.98195953636076, 3.0897883133965283],
            [-19.98471942280228, 3.082497316031948],
            [-19.970809968432516, 3.0786005428291836],
            [-19.973435128218192, 3.0715799830277213],
            [-19.959690387723803, 3.0677799315929866],
            [-19.962027755941715, 3.0600259394222027],
            [-19.948189050478874, 3.055941164127213],
            [-19.950527677666543, 3.04845091271181],
            [-19.961455435439547, 3.051782673255781],
            [-20.040009854924865, 3.0747298224387674],
            [-20.06950482677365, 3.084418355745067],
            [-20.087465014381284, 3.0894047298076686],
            [-20.102358836666717, 3.0955030726548],
            [-20.128031398047536, 3.1023287602166048],
            [-20.14196652901715, 3.1065730882741414],
            [-20.14612156965404, 3.093046599175862],
            [-20.173035082164137, 3.102126817638571],
            [-20.186840489570695, 3.1060635928062745],
            [-20.195177232369737, 3.0766561133383616],
            [-20.19971370396071, 3.077711697120305],
            [-20.24921313934993, 3.092312044328961],
            [-20.29570944589145, 3.1054259228923016],
            [-20.303308994981702, 3.106723662160879],
            [-20.36773233569491, 3.1248376575329653],
            [-20.37609576210449, 3.0962134982070326],
            [-20.389969577710467, 3.1002519658079706],
            [-20.470988273987498, 3.125965388828734],
            [-20.474167394003953, 3.122165037842667],
            [-20.479848827141282, 3.123263929641235],
            [-20.483276155637235, 3.1183120263083794],
            [-20.488389238163858, 3.119756922803984],
            [-20.492736456999786, 3.1121941856735775],
            [-20.500931836079268, 3.124145297419724],
            [-20.50314579946554, 3.1279352374829843],
            [-20.506421940673626, 3.1298995249926262],
            [-20.504664392016053, 3.1340474584646993],
            [-20.509850083729308, 3.13939806544338],
            [-20.509221546541315, 3.1408710735950502],
            [-20.51725871732017, 3.1477219971598998],
            [-20.514922902625468, 3.1504296434383354],
            [-20.520783197741373, 3.1613905390137997],
            [-20.525260870789342, 3.1676136497856247],
            [-20.532855388196776, 3.1693228735532077],
            [-20.53352115341428, 3.174536191356333],
            [-20.536539416561066, 3.176605602188009],
            [-20.53832665991212, 3.1924811145432046],
            [-20.546592986181132, 3.2025047839339527],
            [-20.550808486240086, 3.2054946172309076],
            [-20.551414546121478, 3.2100646173443304],
            [-20.555124630885246, 3.2150505459872836],
            [-20.556849821424045, 3.220214991022453],
            [-20.562850531307017, 3.2236994094064806],
            [-20.563777365270052, 3.2335630258730945],
            [-20.562410166677978, 3.244788595439698],
            [-20.564218191883118, 3.252580685700656],
            [-20.576511349406925, 3.266815359768775],
            [-20.578977492017636, 3.2791642885946026],
            [-20.587514596151134, 3.29060809515923],
            [-20.588981495650085, 3.298514352116207],
            [-20.59123833520484, 3.3015984330661765],
            [-20.5892624618039, 3.304643581991049],
            [-20.596373072652096, 3.311125159052001],
            [-20.600917031677213, 3.312926176084746],
            [-20.599412524556783, 3.3231933176414508],
            [-20.597737082514666, 3.3225720720429366],
            [-20.594772661791446, 3.3289104635998505],
            [-20.597474466670008, 3.3345122481016363],
            [-20.59754059902224, 3.3398100782827203],
            [-20.600516747720008, 3.351535500917817],
            [-20.595622877622052, 3.351983175500017],
            [-20.594215216525537, 3.348346940491235],
            [-20.59089754376528, 3.3491129019095682],
            [-20.58311941721725, 3.3543711896213635],
            [-20.57169772377864, 3.3650890737118],
            [-20.55333257741497, 3.388089711886971],
            [-20.543892330350413, 3.4030376022540367],
            [-20.54411997201395, 3.4072240799833495],
            [-20.540556301415283, 3.4124178416675583],
            [-20.539193344634644, 3.4176874435805167],
            [-20.540276577327834, 3.423628281073185],
            [-20.537300387407203, 3.4252183533731873],
            [-20.53797687682385, 3.429833683693196],
            [-20.535704780589146, 3.431628207407294],
            [-20.537031276466276, 3.4378048736066398],
            [-20.53512743074178, 3.4387216072420803],
            [-20.537677692613077, 3.4558169026093806],
            [-20.53622266867558, 3.4605830623384426],
            [-20.53608844494595, 3.472130289285914],
            [-20.53505558584086, 3.473646425248802],
            [-20.53670372298033, 3.481210580570297],
            [-20.53315028165682, 3.485091277077879],
            [-20.535299428479515, 3.492139473184424],
            [-20.53461322925627, 3.5021912652952545],
            [-20.536196901550746, 3.5074015013984674],
            [-20.533173729914424, 3.511974128948533],
            [-20.534159167222683, 3.5146083103435517],
            [-20.532122055416124, 3.518642008614618],
            [-20.5369961405968, 3.5242250003159934],
            [-20.53620835299985, 3.527237900004332],
            [-20.542825205971063, 3.5272455689326407],
            [-20.54317654190245, 3.531347065530614],
            [-20.541438627877643, 3.5358205988812914],
            [-20.540778898361154, 3.5423955433736465],
            [-20.537589298237485, 3.5499468294870944],
            [-20.541513598158673, 3.5561056106398716],
            [-20.54138919802306, 3.5608356271062402],
            [-20.545297263353742, 3.566197696873507],
            [-20.543548583692626, 3.568393978295264],
            [-20.54542324162402, 3.572498020756693],
            [-20.544943526426298, 3.5768478966118447],
            [-20.546169946338395, 3.5829102606863263],
            [-20.553056890631463, 3.5877436296186223],
            [-20.55304450240494, 3.5920107845423743],
            [-20.54974948818215, 3.5947200188975508],
            [-20.55049428323522, 3.605765327157327],
            [-20.545621053491974, 3.6079901407189303],
            [-20.545947027060045, 3.6119631093170694],
            [-20.548494215453395, 3.616608264763049],
            [-20.54777244661345, 3.6246236980898088],
            [-20.544926130398302, 3.630535437741707],
            [-20.544924808880385, 3.646781269671518],
            [-20.548185817484246, 3.6488686734340883],
            [-20.54537166700054, 3.654284714477],
            [-20.54402094842414, 3.6644508942101517],
            [-20.545165459809386, 3.6688601781901022],
            [-20.55087318657535, 3.668243590273278],
            [-20.55228043432261, 3.676469377201681],
            [-20.549359844517618, 3.6805988371286316],
            [-20.549821883280355, 3.687191612466221],
            [-20.54659042872779, 3.689998658056946],
            [-20.54252166400142, 3.686453961666783],
            [-20.54039656264931, 3.6966522384522067],
            [-20.543752370414413, 3.699402959085387],
            [-20.546836733866023, 3.698007906477199],
            [-20.54945758625715, 3.700893682691094],
            [-20.550921199635575, 3.707168919464119],
            [-20.549796461233857, 3.710894149289826],
            [-20.54489891724673, 3.708841064793034],
            [-20.540284551262214, 3.7090029318285636],
            [-20.538611310306205, 3.7139163095514145],
            [-20.541309899617314, 3.718209797232572],
            [-20.540564208670162, 3.725722821412192],
            [-20.543513215000388, 3.728396860392002],
            [-20.546391156126116, 3.733547444212744],
            [-20.544722480103893, 3.7373562022632782],
            [-20.549505518738602, 3.748929785717687],
            [-20.541065911722754, 3.7593292063986237],
            [-20.53943195278844, 3.7634785788493437],
            [-20.542563615568586, 3.7681753307879964],
            [-20.53975316210539, 3.7699065926328856],
            [-20.53161277509365, 3.789049899039401],
            [-20.528225086064705, 3.8039451566668783],
            [-20.52358798618536, 3.8046937607468108],
            [-20.519956338029118, 3.813075036422937],
            [-20.520439224053508, 3.820045434422999],
            [-20.51258796983498, 3.8209115456855844],
            [-20.512429544582382, 3.823953473953713],
            [-20.516755584301695, 3.8252938934703065],
            [-20.517654590358298, 3.828035232554634],
            [-20.51723817975551, 3.835020203178597],
            [-20.514677636682638, 3.8334845143500043],
            [-20.510937474601963, 3.8364426913024836],
            [-20.51301352228551, 3.8390980776818533],
            [-20.50863930839027, 3.8440536091355564],
            [-20.507159409822403, 3.847449276781478],
            [-20.49984720787114, 3.859185836927722],
            [-20.499396949038566, 3.862708908516485],
            [-20.49610390212641, 3.8640060154413534],
            [-20.49057216978525, 3.876858076782146],
            [-20.4841330891552, 3.880531788540356],
            [-20.4707325444468, 3.8946017003840683],
            [-20.463090794731638, 3.904989995872172],
            [-20.44516888133222, 3.932554031520932],
            [-20.443657196774733, 3.9395131243883816],
            [-20.44486501597938, 3.9455089049065664],
            [-20.44426597087311, 3.9526450091837084],
            [-20.446678416927906, 3.9596512503394004],
            [-20.443907626292866, 3.964764155066878],
            [-20.448158810728682, 3.975212255561696],
            [-20.4476500476171, 3.982904304505416],
            [-20.444364353033176, 3.9901956839317094],
            [-20.441153866878334, 3.9909878724171195],
            [-20.4367822489879, 4.002261306616389],
            [-20.438710992103303, 4.008206293222522],
            [-20.436355311263927, 4.0097598069464855],
            [-20.434425336664006, 4.020609226479292],
            [-20.43244174698326, 4.024308005840647],
            [-20.428548766048905, 4.040215236757018],
            [-20.429066854299016, 4.045448313505831],
            [-20.431183096223865, 4.048514772240183],
            [-20.428820996914403, 4.053290943903603],
            [-20.42640801862796, 4.061906400325318],
            [-20.42555237946588, 4.070925246201656],
            [-20.429586205684235, 4.08160190243567],
            [-20.42878626279671, 4.0864368998521785],
            [-20.4297207429824, 4.09396311696118],
            [-20.439628744337355, 4.104735442538048],
            [-20.44169177779372, 4.110553192297033],
            [-20.440988330534797, 4.118288717996566],
            [-20.43828569532166, 4.118968064317852],
            [-20.437529529601036, 4.13043391596964],
            [-20.437949185812567, 4.138399718837764],
            [-20.439375820774096, 4.140704592327097],
            [-20.43174891631462, 4.163458763586148],
            [-20.42802355660264, 4.182740462744016],
            [-20.428519820764485, 4.196168563268009],
            [-20.426549624992855, 4.204963422203214],
            [-20.425833313203682, 4.215760772405994],
            [-20.426988653358407, 4.222867507693629],
            [-20.443856371267906, 4.239849825674188],
            [-20.45016396290699, 4.2500071216485376],
            [-20.450858125593882, 4.253007868223119],
            [-20.454113184119613, 4.253942749828658],
            [-20.457797026336465, 4.2625628152853015],
            [-20.459651537849417, 4.2760391471952435],
            [-20.458474086938217, 4.281783435811641],
            [-20.460448687045744, 4.3124322726124],
            [-20.474857032327296, 4.330110493899075],
            [-20.476056145637425, 4.3363431064958124],
            [-20.475992835780087, 4.346501191400911],
            [-20.480587095575817, 4.363861446596195],
            [-20.481358087160945, 4.374223365359554],
            [-20.489760877104445, 4.387896501943227],
            [-20.49369108170722, 4.402247242692198],
            [-20.49712342896249, 4.408160828234563],
            [-20.501386115125243, 4.421100404988199]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.39145666055767,
          "lat": 39.44026171956059
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06045"],
        "coty_name": ["Mendocino"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mendocino County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00277287"
      },
      "bbox": [
        -20.600917031677213, 3.04845091271181, -19.71214139377484,
        4.421100404988199
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.315011682693417, 1.4350495365960902],
            [-19.314567284203118, 1.4345224056407868],
            [-19.221029589446353, 1.4891227619608138],
            [-19.181287579831025, 1.5117257133041146],
            [-19.17136296506716, 1.5178342379735335],
            [-19.11868155837566, 1.5482300477489082],
            [-19.090243574245395, 1.5648887905152193],
            [-19.084450695677603, 1.5608714246390498],
            [-19.082109009208374, 1.5620677492178319],
            [-19.081025943723883, 1.5665728241669685],
            [-19.0758917770726, 1.5661024583926197],
            [-19.071585821972167, 1.5691534991925111],
            [-19.071882125771097, 1.5784151632481986],
            [-19.0654978495594, 1.5810450224550476],
            [-19.060877792650352, 1.57927364260674],
            [-19.05344694909065, 1.5873553617322467],
            [-19.05295521655213, 1.5813790019532914],
            [-19.047650151605303, 1.584731887293711],
            [-19.042946772791453, 1.5770064074856018],
            [-19.037120458461597, 1.5778275856303798],
            [-19.03828585709421, 1.5839349619523762],
            [-19.03355750875426, 1.5849369252123184],
            [-19.03253590255001, 1.5882975876003396],
            [-19.027410048930612, 1.5836059297800573],
            [-19.025001120064093, 1.5862014762321688],
            [-19.01866908120862, 1.586794700508566],
            [-19.018114742161295, 1.5936549056336955],
            [-19.015066492593146, 1.598906395172993],
            [-19.012050460504003, 1.6011127647167511],
            [-19.00414570685881, 1.599122192635387],
            [-18.995435528519085, 1.5999640274361133],
            [-18.98484881282497, 1.5963597533625118],
            [-18.98086318554551, 1.5977077145339051],
            [-18.972313360783748, 1.6033628552593224],
            [-18.973081747422757, 1.6116727571706944],
            [-18.96612985520102, 1.6111075663969712],
            [-18.965870861523435, 1.6072940144064767],
            [-18.960400586738746, 1.602725645338579],
            [-18.955439344643896, 1.607974843816773],
            [-18.950966864193887, 1.6070552671239082],
            [-18.947328857276823, 1.6021475096757258],
            [-18.939172577104294, 1.6026755455273212],
            [-18.938267705707865, 1.6072022809602076],
            [-18.933690784831196, 1.6076315442330809],
            [-18.931786026075518, 1.610173708597888],
            [-18.927468744455375, 1.6092252720115354],
            [-18.92742064004805, 1.601932204949303],
            [-18.91987067266088, 1.5990188011383795],
            [-18.91307133484047, 1.5984424414235223],
            [-18.90845983314812, 1.5960485424105475],
            [-18.905338041554643, 1.600325929465634],
            [-18.898289660066805, 1.6074293765701946],
            [-18.895169042140928, 1.607885171199269],
            [-18.894230705402816, 1.6020551523482112],
            [-18.88814054557011, 1.600988258051801],
            [-18.883339561261582, 1.6031310836800665],
            [-18.880351894608577, 1.6077242616134562],
            [-18.874235104587907, 1.6021792422923071],
            [-18.870672008886036, 1.6013378815340074],
            [-18.86652534429221, 1.5912246571454538],
            [-18.859586688193566, 1.5829476597478542],
            [-18.854646176838276, 1.5780944466688795],
            [-18.846333838545405, 1.5797113708846653],
            [-18.84232093715851, 1.5784592851622397],
            [-18.83837150967073, 1.57482470378456],
            [-18.830762963480872, 1.5706684766149728],
            [-18.8292450342985, 1.5712907221870032],
            [-18.827639081225833, 1.5832450583695625],
            [-18.815206971744608, 1.6321526032895695],
            [-18.79478938611201, 1.7170025884212265],
            [-18.779549436769884, 1.7740514454895233],
            [-18.76949889724, 1.8111718485390396],
            [-18.760755493082964, 1.8442551182824805],
            [-18.744939048855887, 1.9029164610167955],
            [-18.740835193853563, 1.8948507098243763],
            [-18.719670443423762, 1.8454359772212425],
            [-18.70703908445269, 1.8216286920807865],
            [-18.69621279822026, 1.802535357943734],
            [-18.67337504577485, 1.7556226412167664],
            [-18.670593900508184, 1.7508984713525875],
            [-18.654161254527626, 1.717658310437667],
            [-18.650864045744616, 1.7055487415733712],
            [-18.642696858233407, 1.6877992217052926],
            [-18.637590220274365, 1.678745517850849],
            [-18.606686688573593, 1.6168754640415774],
            [-18.602799633362423, 1.6084604813378494],
            [-18.542779913600864, 1.5120852408508316],
            [-18.5396997691765, 1.5062237151147282],
            [-18.495163264398997, 1.4322483279203997],
            [-18.488496980986067, 1.421006813288871],
            [-18.452678112856496, 1.361981645993849],
            [-18.452808485470907, 1.3616609854614756],
            [-18.570854946504568, 1.3370693356925663],
            [-18.654664744783904, 1.3193178609658125],
            [-18.658737025461882, 1.3182360748065354],
            [-18.762840721120902, 1.296657808160035],
            [-18.794358666047643, 1.290038490617601],
            [-18.80676150484367, 1.2881082688938337],
            [-18.8202879697198, 1.2853587831925577],
            [-18.827038190629636, 1.2833052566881784],
            [-18.84267219653971, 1.2801453768440243],
            [-18.853145594209963, 1.278950603679627],
            [-18.867831802352693, 1.2754413883986997],
            [-18.880868411153372, 1.273589243759902],
            [-18.925002227802747, 1.2635954910488416],
            [-18.928691932820573, 1.2616384432463486],
            [-18.965929815650977, 1.2538381515213035],
            [-18.971784086513193, 1.251155151705383],
            [-18.976679721290065, 1.2417638091354883],
            [-18.969913239241436, 1.2416753857566345],
            [-18.968299546658624, 1.239590487178162],
            [-18.972881682369596, 1.23348096683451],
            [-18.97282302164661, 1.230074748103559],
            [-18.965923441479738, 1.2307446261008683],
            [-18.968671268189603, 1.2270050050673507],
            [-18.96820870410128, 1.2210700332336615],
            [-18.9730272955804, 1.2210488497077874],
            [-18.97158653326522, 1.2159410896606573],
            [-18.973387458094948, 1.2113780687327835],
            [-18.973512906899636, 1.2035803692635534],
            [-18.970547938786353, 1.202731775625661],
            [-18.96835483340014, 1.1984255907701653],
            [-18.965666644392556, 1.197047421263976],
            [-18.974182358387008, 1.1917650235364448],
            [-19.000781292729584, 1.1767224227587232],
            [-19.015694872418084, 1.167021370154804],
            [-19.06049697569354, 1.1406747260866006],
            [-19.065657450139636, 1.136974152344752],
            [-19.07741729906732, 1.1307539753451519],
            [-19.21643770753087, 1.0483385482736254],
            [-19.220665989950284, 1.0457171819256252],
            [-19.223123677847465, 1.0503273257789172],
            [-19.223821425536208, 1.062215834825062],
            [-19.22257444699384, 1.0697025496457653],
            [-19.227339666103333, 1.072427583497591],
            [-19.23132847433589, 1.072561534708552],
            [-19.241152172646505, 1.0771305619763507],
            [-19.243542383250244, 1.0900209898640965],
            [-19.245707356001848, 1.0928642774437642],
            [-19.24600431793841, 1.0986099983829756],
            [-19.24994189287216, 1.1048472621033798],
            [-19.25350185172776, 1.1031635451764565],
            [-19.258745775539804, 1.098615536826451],
            [-19.25938924417106, 1.0953430585092707],
            [-19.267040208111993, 1.090973153875809],
            [-19.269553214054035, 1.0939572205229253],
            [-19.272564499837436, 1.0931887732019074],
            [-19.275924709906594, 1.097663034055157],
            [-19.278310655551376, 1.0960838442219982],
            [-19.289776123714567, 1.0971611631308822],
            [-19.29133719609131, 1.1018370957827166],
            [-19.295288976378945, 1.106585046271361],
            [-19.29822134359793, 1.1080921928485385],
            [-19.299959800005045, 1.1145552939001762],
            [-19.304909966288207, 1.1200718545417576],
            [-19.311564479928368, 1.1214884983957427],
            [-19.313453080836187, 1.1186650304108432],
            [-19.320187760358685, 1.1169937732130455],
            [-19.32184137385912, 1.1143071082515166],
            [-19.32824059451333, 1.109822354155314],
            [-19.332634942150236, 1.1084088100896283],
            [-19.33360663003205, 1.103079198444228],
            [-19.332550827264313, 1.100146535138261],
            [-19.3356089829598, 1.0945482614614563],
            [-19.341577377546596, 1.0954066927169324],
            [-19.34402055026045, 1.093337164560001],
            [-19.348301941405232, 1.0973685888275841],
            [-19.348085753610437, 1.1015558965670542],
            [-19.350461384210664, 1.1033252268186111],
            [-19.35078428066049, 1.1110044713387974],
            [-19.34934251173187, 1.116644048666335],
            [-19.352129185263912, 1.1198345684866307],
            [-19.347082005755528, 1.1284141031608148],
            [-19.347858071116928, 1.1334049658215142],
            [-19.34573921009021, 1.1372094511829913],
            [-19.345455442909437, 1.1427087309801658],
            [-19.3471212326439, 1.147432538807925],
            [-19.34502593747251, 1.1596927511855497],
            [-19.3472742571227, 1.1640393174681931],
            [-19.34624745794201, 1.1711983696457777],
            [-19.349008913708264, 1.1735900962064234],
            [-19.351780706963847, 1.1788718453023068],
            [-19.3586433596976, 1.1842192193461327],
            [-19.364398536651027, 1.2049685275272342],
            [-19.362210890029697, 1.2107646085433454],
            [-19.362468596282216, 1.216481012337516],
            [-19.360052475250598, 1.2181190961505144],
            [-19.355628948967734, 1.2316064169098444],
            [-19.35800854258249, 1.2380745813080498],
            [-19.353826979042132, 1.238299707596527],
            [-19.348091229858483, 1.2432690585233757],
            [-19.347872750205994, 1.2470185471487494],
            [-19.34251797652561, 1.2483753334536],
            [-19.33864722219362, 1.2424285994376212],
            [-19.333718114978936, 1.2442418827237804],
            [-19.327607813054925, 1.2428741124112876],
            [-19.326046638412677, 1.2464774074526792],
            [-19.31762796559094, 1.2518867069120179],
            [-19.31269087416725, 1.2540599722251793],
            [-19.31071678622281, 1.2569076106645594],
            [-19.309946436398786, 1.2654366629456237],
            [-19.31108124098055, 1.2688676739294065],
            [-19.307311162278786, 1.2743164761766193],
            [-19.31235813315978, 1.29045758139482],
            [-19.309490815334463, 1.2981192087180746],
            [-19.31079683621734, 1.3047888415707833],
            [-19.308788456088127, 1.3086914049534988],
            [-19.30599034913796, 1.3093421108888443],
            [-19.300317527650993, 1.3197951393678455],
            [-19.293907323337, 1.323017744777783],
            [-19.294206105433403, 1.3322717780082323],
            [-19.29909610640947, 1.334971884705386],
            [-19.3018127323571, 1.3387516615572472],
            [-19.307343502782206, 1.3408953324277155],
            [-19.31027852841019, 1.3436834460574525],
            [-19.31623032021232, 1.341790717730544],
            [-19.320632195756545, 1.3418610404248097],
            [-19.32241179641634, 1.3454456210770998],
            [-19.326041546022722, 1.3473835158621157],
            [-19.32381306800005, 1.3525296746909805],
            [-19.322820874858103, 1.3582243708446402],
            [-19.32582372508887, 1.3686781785404425],
            [-19.32811223989741, 1.3683641002006761],
            [-19.330710008058222, 1.3777776548977902],
            [-19.327273009989526, 1.3788650608825275],
            [-19.326672542398747, 1.3845490308872705],
            [-19.31842942301185, 1.3905849747052397],
            [-19.317812182676505, 1.3976314235842864],
            [-19.31604857912362, 1.4056749569958082],
            [-19.31976168209756, 1.4067328056193031],
            [-19.32213972422813, 1.4104099817242342],
            [-19.321504348353002, 1.4138001085656022],
            [-19.323520361100382, 1.4175769344864895],
            [-19.32812225867949, 1.421755245202147],
            [-19.32746065935316, 1.4316446368067521],
            [-19.324971826542594, 1.4307212854699487],
            [-19.320394882106676, 1.4339564884449516],
            [-19.317191312829877, 1.432689521471936],
            [-19.315011682693417, 1.4350495365960902]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.99768397642244,
          "lat": 37.55913893150277
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06099"],
        "coty_name": ["Stanislaus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stanislaus County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00277314"
      },
      "bbox": [
        -19.364398536651027, 1.0457171819256252, -18.452678112856496,
        1.9029164610167955
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.406133876717262, 1.5515450146792726],
            [-6.392107398894931, 1.5501632328646682],
            [-6.3914587965864715, 1.5573878257170481],
            [-6.377143251877293, 1.5559620545660462],
            [-6.375199578682866, 1.577891047205294],
            [-6.361098025101493, 1.576660717957056],
            [-6.360784459103251, 1.5802110929386939],
            [-6.3677456886211345, 1.580905564362146],
            [-6.367423645188228, 1.5845574685939146],
            [-6.372147713539065, 1.5849101810579513],
            [-6.373977532736832, 1.5899928427476013],
            [-6.37170352423661, 1.6161282984006922],
            [-6.357776602228826, 1.6148253660639273],
            [-6.358756054953641, 1.6020645217287457],
            [-6.35198864638896, 1.601359724976735],
            [-6.3515966451564045, 1.6050809014604661],
            [-6.358370585024136, 1.6056971416981483],
            [-6.356015731422656, 1.6091763020061607],
            [-6.351011421465481, 1.608643907355438],
            [-6.349789517678041, 1.6199944555645007],
            [-6.343500293494419, 1.6328374499774434],
            [-6.3287332383361825, 1.631452157616653],
            [-6.257470513888434, 1.624784807260094],
            [-6.1849662323692955, 1.6181224730946773],
            [-6.056951630989772, 1.6064735193809785],
            [-5.972191352528588, 1.5989197929979306],
            [-5.844623483822522, 1.5877415037661367],
            [-5.715502615664899, 1.5766465954633058],
            [-5.587354540122471, 1.5660401113722184],
            [-5.500479456117216, 1.5588745568547249],
            [-5.379120532102551, 1.5490489063473696],
            [-5.379328055422739, 1.5476670300355215],
            [-5.398750395597698, 1.3154802351113444],
            [-5.401134224415158, 1.2861622882306292],
            [-5.60287166860739, 1.3033490000294965],
            [-5.606931680809271, 1.303554692950619],
            [-5.697010907229041, 1.3107617349267515],
            [-5.783066131840092, 1.3173212357929267],
            [-5.850220879977344, 1.3228238733670452],
            [-5.8823212659043005, 1.3252014443560196],
            [-5.923607833647305, 1.3286349688235193],
            [-6.009216571791895, 1.3364788672489418],
            [-6.0660505807371266, 1.3430041619419884],
            [-6.097995051211244, 1.346349789689791],
            [-6.103951382701706, 1.346308269111031],
            [-6.119387837110165, 1.3479961097026305],
            [-6.124748369474624, 1.349193804852168],
            [-6.138716139344379, 1.3499826419013499],
            [-6.174600214372975, 1.353552011013769],
            [-6.295233046371611, 1.3646442698974388],
            [-6.294557909300102, 1.3719903073003052],
            [-6.291128815460129, 1.3716294691879916],
            [-6.29026883368775, 1.378869969304302],
            [-6.265268159376533, 1.3765678597101425],
            [-6.266067308130753, 1.3783976549034223],
            [-6.2720725558698405, 1.3806893305175096],
            [-6.2711332581164525, 1.3911956647501977],
            [-6.257025498346243, 1.38844814197987],
            [-6.249794273287453, 1.389787929587256],
            [-6.249371700739623, 1.3930095878738984],
            [-6.235469910723208, 1.3921713145495547],
            [-6.214008702475504, 1.3901517286179434],
            [-6.213652381507234, 1.3938558351818833],
            [-6.206529662054985, 1.3931214171200164],
            [-6.206993130035711, 1.388189970222765],
            [-6.20121853307821, 1.3877247726712172],
            [-6.201451108617736, 1.385334608487514],
            [-6.178831976212872, 1.383270315577594],
            [-6.175859128863878, 1.412615100430503],
            [-6.197241298076515, 1.4145791285364209],
            [-6.19480828766618, 1.4396959136343463],
            [-6.12181860844759, 1.432326390793226],
            [-6.122802433916609, 1.4225724320103459],
            [-6.11467157287381, 1.4217526808780268],
            [-6.11374820451597, 1.4314007270121576],
            [-6.086793079439857, 1.4287545652890514],
            [-6.0816593699412245, 1.4797557114861462],
            [-6.071149056305384, 1.4786936572984628],
            [-6.070316852112971, 1.4869574895883921],
            [-6.0662736913565904, 1.4865511519062022],
            [-6.064483386160888, 1.5043506786162204],
            [-6.0882043053520665, 1.5067623311264444],
            [-6.087526716259081, 1.514150531373253],
            [-6.12437516762672, 1.5178820661212422],
            [-6.123668118158169, 1.5249169714081714],
            [-6.13309248304383, 1.5259444611001125],
            [-6.133832128123574, 1.518589380284026],
            [-6.142185991594512, 1.5194317161743998],
            [-6.143294390830819, 1.5084125792879488],
            [-6.1637765442718235, 1.5104801049908962],
            [-6.168920329756035, 1.4594007961964133],
            [-6.192630439780962, 1.4617321235747165],
            [-6.1929939005679095, 1.458116074145082],
            [-6.214614190832248, 1.4601317824076807],
            [-6.218701167462458, 1.416381456817373],
            [-6.247700949356294, 1.4188819191777238],
            [-6.275645987545966, 1.4218214233043482],
            [-6.274311477621602, 1.436350900853725],
            [-6.288205153175245, 1.4376192500073601],
            [-6.289622788260367, 1.4230651371670902],
            [-6.304082471425736, 1.4244917193057844],
            [-6.305359218780985, 1.4099140416008713],
            [-6.3232314480056795, 1.4114834284507656],
            [-6.322566970012058, 1.4187946727138567],
            [-6.332310871809333, 1.419652152246256],
            [-6.332419150136816, 1.423317884099217],
            [-6.3437619845422555, 1.4244129237752667],
            [-6.347700249336871, 1.4211366043940268],
            [-6.418223801898571, 1.4278762247424706],
            [-6.412062982711976, 1.4930810981759406],
            [-6.406133876717262, 1.5515450146792726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -104.3380151048538, "lat": 39.8736101415158 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00198116"
      },
      "bbox": [
        -6.418223801898571, 1.2861622882306292, -5.379120532102551,
        1.6328374499774434
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.836248170171592, -7.999625110787057],
            [9.836258582714525, -7.997127192241236],
            [9.832681098892921, -7.993009304489755],
            [9.834333072908544, -7.989179282600219],
            [9.838963483216231, -7.991033787538658],
            [9.840338813753503, -7.988562906370288],
            [9.837542691633097, -7.9833806167102965],
            [9.84031672254715, -7.981011819686881],
            [9.844053840464024, -7.986098774599223],
            [9.848490862920576, -7.984519490698603],
            [9.847836573929907, -7.978655733235114],
            [9.853209281993568, -7.976956366858904],
            [9.855025814159832, -7.973857560354027],
            [9.853960402683537, -7.967935628605874],
            [9.862396450127472, -7.9681332428824065],
            [9.863491777934884, -7.964990679972057],
            [9.86060411853976, -7.962267308035724],
            [9.85958656521059, -7.958347642912213],
            [9.863256489698388, -7.954089926066547],
            [9.86231340308929, -7.947859964511867],
            [9.863731757355518, -7.9455558984474965],
            [9.870251872014508, -7.945601072097296],
            [9.869973332123955, -7.938360172480672],
            [9.872124939645818, -7.935722265684094],
            [9.877129776523327, -7.933478594866803],
            [9.876350445958671, -7.929776958459894],
            [9.87242731654022, -7.924714466642527],
            [9.876210448876586, -7.920829841803844],
            [9.876695016330554, -7.917553511725763],
            [9.87427824550072, -7.911355533923563],
            [9.880093813512664, -7.9073145443766215],
            [9.874661823339437, -7.894058645346308],
            [9.876190211809563, -7.89035467904156],
            [9.88164810994636, -7.892044481062276],
            [9.88295850291573, -7.890190219177041],
            [9.879457980373493, -7.884690255716814],
            [9.881148307926699, -7.881960331473829],
            [9.888143079886701, -7.883656311932872],
            [9.891333930801865, -7.883091378932037],
            [9.892846763053427, -7.87898105638912],
            [9.885712503858658, -7.8767210969274855],
            [9.881891104577507, -7.874382390445191],
            [9.882796110480982, -7.868098186190223],
            [9.881229557177022, -7.863244084842133],
            [9.877032569691695, -7.85858256562081],
            [9.877121945807954, -7.855093815600788],
            [9.879850138567342, -7.851136580118819],
            [9.881166329585577, -7.8422019939049],
            [9.885238881991581, -7.836192762824161],
            [9.89292492639858, -7.832482709774467],
            [9.891439478293806, -7.828110277109342],
            [9.883239183954755, -7.828813003512844],
            [9.881104324252991, -7.82260352045435],
            [9.888010446637368, -7.815247110741807],
            [9.892639809823814, -7.817781858727502],
            [9.896198156751673, -7.810983960418413],
            [9.900862001160013, -7.806613599317569],
            [9.900463950583275, -7.798216529398294],
            [9.897947404304729, -7.795911795475657],
            [9.889029114433141, -7.795606856305663],
            [9.886329794356836, -7.790847507759642],
            [9.888268324090312, -7.78829240502761],
            [9.894566823016541, -7.786458230818032],
            [9.89901884668642, -7.7836437319201615],
            [9.897458133964852, -7.779671897863217],
            [9.88560020457544, -7.78119884101432],
            [9.881760603513596, -7.774353476792676],
            [9.886028912524194, -7.767012299695365],
            [9.89531509951621, -7.758741718577704],
            [9.910614420612262, -7.753030342922162],
            [9.916493974268432, -7.749593951625811],
            [9.921777917623523, -7.748220861976499],
            [9.923382050318528, -7.744416385237289],
            [9.921444792279159, -7.742466863850643],
            [9.912682321822103, -7.7461761638742335],
            [9.906895238693014, -7.744765963079299],
            [9.905191868247671, -7.742192426535797],
            [9.90583197471449, -7.735703472853798],
            [9.911923460462585, -7.72813020618592],
            [9.915844447669006, -7.725038036738409],
            [9.913903032518991, -7.718860155448311],
            [9.903955218291003, -7.719706888582933],
            [9.900435140857562, -7.717852124620438],
            [9.90037759556589, -7.713729133415061],
            [9.905932887348063, -7.705909291440623],
            [9.906497342311711, -7.696283729128473],
            [9.90786979366962, -7.6873874074111965],
            [9.905039454445578, -7.677315573914362],
            [9.906345905962937, -7.667066263477896],
            [9.910040895264132, -7.658740727540484],
            [9.916990640322876, -7.6376397349171175],
            [9.925574709761845, -7.626047001830347],
            [9.925664596072966, -7.623136302878617],
            [9.922000476843268, -7.618459316326402],
            [9.920714724009642, -7.611206878212299],
            [9.923464255994206, -7.607388403505637],
            [9.929200267487499, -7.609825491805626],
            [9.933132624285447, -7.6101705700974],
            [9.938744376015292, -7.606420228486725],
            [9.939066273859043, -7.603282295425196],
            [9.936335598464801, -7.59699705043251],
            [9.936626557441476, -7.592863326080894],
            [9.943830137967803, -7.587227334606452],
            [9.945934525361563, -7.580881477136683],
            [9.963403175513069, -7.579454247241057],
            [9.987991832286884, -7.576798124567083],
            [9.993066547856833, -7.619615130094929],
            [9.997068275647356, -7.648253341884434],
            [10.054086575087958, -7.641593662634889],
            [10.055973610321368, -7.655976779479361],
            [10.08480791563962, -7.652391103572202],
            [10.092357867318567, -7.710405501046534],
            [10.12619982392017, -7.705905347931533],
            [10.149530846122467, -7.703059320236223],
            [10.154635851398243, -7.745654688139422],
            [10.183341794703521, -7.742186054702392],
            [10.186737800151041, -7.771074163948749],
            [10.19848003848144, -7.7698550638806765],
            [10.215958662422453, -7.767296385979606],
            [10.202459060376318, -7.778777391785953],
            [10.201509819168674, -7.783312905650596],
            [10.203372221019876, -7.78462734401625],
            [10.198256621764342, -7.793530033941798],
            [10.190144247866154, -7.7904026548036525],
            [10.188615879258107, -7.791220650742685],
            [10.189370506706718, -7.797196093688497],
            [10.186507164576122, -7.803454259530098],
            [10.187224738903126, -7.809052932172311],
            [10.173926967416417, -7.818434098420319],
            [10.174368086289185, -7.8218412344621955],
            [10.168896961288297, -7.826682279686382],
            [10.166350789128531, -7.826974326542934],
            [10.164100862578124, -7.831563953378397],
            [10.169717579168642, -7.837548289592247],
            [10.174520574801658, -7.8387552404378695],
            [10.177501321540545, -7.841078052843742],
            [10.176938882586727, -7.844244796676579],
            [10.172196787473634, -7.850583190650015],
            [10.169186514783231, -7.8609145753727185],
            [10.157124594654247, -7.87506105858497],
            [10.156555170258466, -7.882121852478915],
            [10.159595215934305, -7.88345273331705],
            [10.157094545034479, -7.887335977413628],
            [10.158053688879592, -7.892690288677543],
            [10.15231005872793, -7.897404385503208],
            [10.162990459753216, -7.905062476588927],
            [10.17277082760991, -7.90792687350957],
            [10.176057452311971, -7.909794473626427],
            [10.181612642060124, -7.907774912776033],
            [10.187123368066889, -7.912806006045553],
            [10.190461818374818, -7.921369780118472],
            [10.18783565597962, -7.926851633026797],
            [10.193133631216305, -7.930863230655053],
            [10.196122887351262, -7.935690293203856],
            [10.200452691734347, -7.935057692670077],
            [10.205940689106274, -7.938956018288746],
            [10.206384194886551, -7.944511816737781],
            [10.20872974545812, -7.949561363343344],
            [10.208155121292668, -7.954199657846111],
            [10.213021897495901, -7.955074248726273],
            [10.211826252111404, -7.960506308595066],
            [10.212563791786268, -7.967759779892981],
            [10.221718435108293, -7.972166998564864],
            [10.222984505986226, -7.983553462311322],
            [10.222741394033468, -7.988925917386201],
            [10.224834840233326, -7.9929264100076365],
            [10.222740303698071, -7.99704808460753],
            [10.224660981447496, -8.001265691085552],
            [10.221950243129378, -8.004285757324658],
            [10.22516338729103, -8.009848009920832],
            [10.223409006044115, -8.013608412479396],
            [10.228069405949388, -8.019166508988347],
            [10.22776439938181, -8.028768621402536],
            [10.232592192185779, -8.033192895358074],
            [10.235603675191088, -8.03282950199188],
            [10.23723408511365, -8.037751756817105],
            [10.24011818316001, -8.037254554831966],
            [10.244355581847387, -8.039690118721026],
            [10.247664565533126, -8.043501978663022],
            [10.244823433732, -8.045102706857838],
            [10.24669257731536, -8.050445553809618],
            [10.243393836745124, -8.052157432916417],
            [10.255169177991153, -8.063295478533048],
            [10.255788840597939, -8.067285601607296],
            [10.2623485842137, -8.072394430244962],
            [10.263472108850081, -8.07800877904054],
            [10.268493169042776, -8.084086747998262],
            [10.276061424099332, -8.081627187658084],
            [10.280567607923683, -8.082241547069565],
            [10.28661447409944, -8.087153889800803],
            [10.291132088238703, -8.094055232859372],
            [10.293247587902338, -8.099725236609693],
            [10.298967385836075, -8.100411534399496],
            [10.302078849393745, -8.102690771981935],
            [10.297933458432588, -8.105359935928785],
            [10.298646451232894, -8.107532081056695],
            [10.306295261850783, -8.114838145148099],
            [10.323456455434815, -8.122770158881329],
            [10.326910362165235, -8.121597279410235],
            [10.329120864502435, -8.124339613538169],
            [10.335249208582228, -8.11888001846825],
            [10.337824696436657, -8.120942547512147],
            [10.338438313784128, -8.125827594697052],
            [10.342858475452452, -8.125466731247256],
            [10.348540887036858, -8.12835847487554],
            [10.299012327478156, -8.134393597618294],
            [10.292601836767313, -8.134880544300803],
            [10.162531155037696, -8.149990462931807],
            [10.064587643563597, -8.160808458038362],
            [9.980423013669064, -8.168981231291836],
            [9.950365975815991, -8.172275595038222],
            [9.952750306117311, -8.17484354782411],
            [9.948909126097464, -8.180601359984298],
            [9.949121298697962, -8.187278506420155],
            [9.945958232276249, -8.189165272530452],
            [9.94600678776918, -8.193113829233663],
            [9.94421138075823, -8.204290321429417],
            [9.94507533320713, -8.205648345356883],
            [9.939961345561619, -8.215848681189044],
            [9.937164225526805, -8.205478515875264],
            [9.93436641189825, -8.20051914363655],
            [9.928128728667115, -8.19812763755951],
            [9.921512003506678, -8.200964849978538],
            [9.916056279453574, -8.199051404259924],
            [9.915728211269874, -8.196245261090663],
            [9.911969944939676, -8.189253497025087],
            [9.908045972477725, -8.187062367022815],
            [9.896169025225236, -8.187554094030691],
            [9.894354386036794, -8.185009475979738],
            [9.887758894738404, -8.183123712549762],
            [9.88358854583155, -8.179122216773111],
            [9.879686740886838, -8.182079272338916],
            [9.876662854031837, -8.178879256744674],
            [9.871707501000882, -8.17984744526714],
            [9.869546109032092, -8.174239607898253],
            [9.864097794385673, -8.174986281953892],
            [9.861355784837356, -8.17091565804584],
            [9.858169557648356, -8.173558848829714],
            [9.852856682112733, -8.16844102906225],
            [9.841425031584768, -8.160708874005195],
            [9.84280179820027, -8.1559825598684],
            [9.837347807851824, -8.155880368676408],
            [9.837386166964006, -8.151364022757658],
            [9.835185689505495, -8.14665511220186],
            [9.833593049485081, -8.135810403426097],
            [9.83703225003531, -8.132807630384013],
            [9.832727292958156, -8.130175248887458],
            [9.831316884074496, -8.1271279876018],
            [9.833852238508852, -8.119410946932664],
            [9.830739761354902, -8.113440061743198],
            [9.824935007877233, -8.111703948872876],
            [9.822126213912686, -8.112430990830154],
            [9.815964728289392, -8.110397535040539],
            [9.818294226877425, -8.104578632737617],
            [9.822633124082213, -8.101551634261398],
            [9.817806079018451, -8.091029949729368],
            [9.820520880254431, -8.089558218266227],
            [9.825646630351821, -8.089764278985117],
            [9.82344376590899, -8.085448335047564],
            [9.831094598407383, -8.085047822081329],
            [9.833004389363683, -8.080403001311913],
            [9.830213375586672, -8.079204551157712],
            [9.82171267450275, -8.079364298610102],
            [9.819324643941725, -8.076718661871132],
            [9.819530710437936, -8.07233635342267],
            [9.825090612650703, -8.066015364282096],
            [9.824809816969525, -8.060346831961251],
            [9.828295094009578, -8.057164189407656],
            [9.82793612016107, -8.054878635813436],
            [9.822830720010128, -8.054687541428105],
            [9.824638499961678, -8.049933057431707],
            [9.825854348193804, -8.041223482662948],
            [9.824092349234634, -8.038672094756535],
            [9.819669740526807, -8.037922180562237],
            [9.82130180981862, -8.034428995776977],
            [9.819653926299793, -8.02889406839583],
            [9.823318317390646, -8.025042897602043],
            [9.822921597702438, -8.019306621218448],
            [9.827748548018047, -8.017550799672046],
            [9.829321997944742, -8.015034981162792],
            [9.830384789649534, -8.00787354649654],
            [9.83338728670537, -8.002307858045638],
            [9.836248170171592, -7.999625110787057]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.88291266674116,
          "lat": 30.241316709125456
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12077"],
        "coty_name": ["Liberty"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Liberty County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00308549"
      },
      "bbox": [
        9.815964728289392, -8.215848681189044, 10.348540887036858,
        -7.576798124567083
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.176574434913253, -9.462584543265988],
              [12.236976971620757, -9.453818468434923],
              [12.300440335335853, -9.445077331645823],
              [12.365923205754754, -9.43582332110358],
              [12.437563386317585, -9.425344890129699],
              [12.481471241876507, -9.418294273103388],
              [12.539804228020062, -9.409955965031472],
              [12.533653073210175, -9.367409081842146],
              [12.534817940244265, -9.366940273011538],
              [12.581507282275084, -9.360499029822615],
              [12.621296457852603, -9.354831527076518],
              [12.7067969828632, -9.342436781058309],
              [12.729963067797904, -9.503775912279744],
              [12.732892688937586, -9.521433724443208],
              [12.738066851153366, -9.556141285820635],
              [12.693737610901968, -9.562293148074577],
              [12.698825088494148, -9.59636509118133],
              [12.703032116569855, -9.622455570377827],
              [12.706763570922764, -9.647417250948449],
              [12.690109400966236, -9.64933733210624],
              [12.677503540597076, -9.651654318532232],
              [12.638341783068602, -9.65731755400587],
              [12.613893853022605, -9.660628769686294],
              [12.576894075170205, -9.666347568867833],
              [12.463813591873212, -9.682729630141898],
              [12.424759862574108, -9.688235027400824],
              [12.40630959181699, -9.69036236790242],
              [12.384525723734114, -9.693277135912188],
              [12.347221272016174, -9.697758245160854],
              [12.330175066036857, -9.700299256188101],
              [12.255834480886284, -9.70995017629948],
              [12.22925763076921, -9.713739418521362],
              [12.160836431358264, -9.72334099557306],
              [12.113242110298373, -9.730224735188575],
              [12.105294905111938, -9.731200870894895],
              [12.108204144807853, -9.727537467107773],
              [12.100055826929887, -9.7232883668133],
              [12.09888079869978, -9.717396241204211],
              [12.107395850742359, -9.711063025281007],
              [12.109492983554588, -9.69642286003147],
              [12.113197542965278, -9.694452969052104],
              [12.116772064365664, -9.695834010227262],
              [12.120343498598645, -9.694655176861707],
              [12.1253095985939, -9.68276647133289],
              [12.123573118360245, -9.681958450342819],
              [12.129883190148535, -9.673154878788823],
              [12.12854262047284, -9.671672898543495],
              [12.121907079928567, -9.670291475104225],
              [12.122488628149323, -9.66021877764405],
              [12.128100919763817, -9.66076599259461],
              [12.133941700355097, -9.65397909865164],
              [12.132498907885203, -9.650455560849142],
              [12.124431438607674, -9.648285799728756],
              [12.125439945604317, -9.646125451628619],
              [12.131926914737152, -9.645283857231645],
              [12.135625414893452, -9.632854326479205],
              [12.134446156763756, -9.623226434019186],
              [12.136135939216322, -9.61849037155434],
              [12.140238307881104, -9.619410459993542],
              [12.14288983155352, -9.617833986325941],
              [12.142394204671254, -9.612441280755789],
              [12.14677940615322, -9.611123782151372],
              [12.147322402280217, -9.607489213234787],
              [12.141320031320127, -9.608170049984164],
              [12.138062936234968, -9.601250306133547],
              [12.14023875948889, -9.5975601988497],
              [12.137146256171794, -9.594115298102908],
              [12.13924295780402, -9.586862417250554],
              [12.137434204405944, -9.585674220930954],
              [12.137893384327686, -9.57579694966692],
              [12.148717279794752, -9.55395200120886],
              [12.151706225170765, -9.550023458099622],
              [12.151363379556848, -9.545660297207396],
              [12.146111250488522, -9.54637215754787],
              [12.145093084176143, -9.542707463261195],
              [12.149202974840295, -9.54011207507305],
              [12.157334645408772, -9.523633974267275],
              [12.153245432113653, -9.520806664008013],
              [12.154182117709789, -9.51843857654407],
              [12.150863712337937, -9.513233203451435],
              [12.150056903135058, -9.507325246883651],
              [12.151116626931355, -9.500224061601648],
              [12.148946414035581, -9.496725442857759],
              [12.153682475517641, -9.495633513599001],
              [12.164367796521528, -9.489009966498122],
              [12.164183574218574, -9.485484661204381],
              [12.153758892369192, -9.487257578153356],
              [12.157680728629092, -9.483474634355058],
              [12.154496304057337, -9.479689574502613],
              [12.156563351306158, -9.476064855212686],
              [12.164581816294998, -9.476877556534108],
              [12.166523913542525, -9.471292539309294],
              [12.170349138520844, -9.469127718672022],
              [12.176574434913253, -9.462584543265988]
            ]
          ],
          [
            [
              [12.061452963085877, -9.738472770789583],
              [12.057057114030007, -9.739092872956922],
              [12.05435116167558, -9.731457805776458],
              [12.047931366685527, -9.702193902720643],
              [12.050064322297434, -9.698745006901976],
              [12.058172631173013, -9.698971131376384],
              [12.056776415731836, -9.704189350452719],
              [12.053772661449992, -9.703301059935868],
              [12.052208412051034, -9.707263222319957],
              [12.056025886710097, -9.712089762876865],
              [12.05585612071817, -9.716225412317062],
              [12.058842884156775, -9.720236100363724],
              [12.055786498638378, -9.72382443716752],
              [12.05656350246548, -9.729114528937084],
              [12.061452963085877, -9.738472770789583]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.39197138677957,
          "lat": 28.309152855291572
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12101"],
        "coty_name": ["Pasco"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pasco County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00295739"
      },
      "bbox": [
        12.047931366685527, -9.739092872956922, 12.738066851153366,
        -9.342436781058309
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.123981560425081, -6.688636164853064],
            [11.127536965081214, -6.687861778556588],
            [11.126060747413124, -6.6747385688158944],
            [11.1384505719892, -6.6738276611572545],
            [11.136876893961714, -6.661285899489054],
            [11.149677703684171, -6.659026168313602],
            [11.148316305835307, -6.646240339950049],
            [11.160625298137932, -6.645164152762671],
            [11.159167110743914, -6.633020170853929],
            [11.170871330224408, -6.6313513822747785],
            [11.163528224881917, -6.568025561877325],
            [11.189066674983874, -6.564623834816036],
            [11.187995774589703, -6.553767966423534],
            [11.233931101125354, -6.54800840762757],
            [11.350706598011405, -6.535866655494473],
            [11.351100369031975, -6.5356241825891175],
            [11.351312230139515, -6.538967590276802],
            [11.347921444485156, -6.5468482461618835],
            [11.349082295143246, -6.551487493018864],
            [11.354324964239982, -6.554307715246134],
            [11.359532051362757, -6.561559037608615],
            [11.36113118246266, -6.565216731959993],
            [11.361117723787233, -6.5703133255380175],
            [11.364889778412936, -6.575797538580697],
            [11.362672449214154, -6.578841029886536],
            [11.362422205966515, -6.586311288561297],
            [11.365926347905742, -6.593761666502379],
            [11.366063292723549, -6.596857860565427],
            [11.363784495057425, -6.602733177208626],
            [11.368088674238669, -6.607382991784161],
            [11.374387346088094, -6.609006339698452],
            [11.379672751097603, -6.6115926190846315],
            [11.382155244733879, -6.611220225878297],
            [11.388339245336594, -6.617340236179402],
            [11.388435359716388, -6.623478736511335],
            [11.392122027608915, -6.6256206815587255],
            [11.392062859571759, -6.630340086702713],
            [11.394441549504329, -6.6347320401798875],
            [11.399652981093231, -6.63886158402562],
            [11.40213053373029, -6.643874766019071],
            [11.408718048394341, -6.648974228276674],
            [11.41600575432032, -6.6487648875512555],
            [11.416370742770521, -6.652902207672046],
            [11.42344504220346, -6.651706948864085],
            [11.428402704666443, -6.652484222578022],
            [11.43080023054397, -6.656414644874127],
            [11.436769428691326, -6.66232043752492],
            [11.440866749944563, -6.665024175417016],
            [11.444721994624727, -6.670940199778992],
            [11.443498846365092, -6.679480904178386],
            [11.445689341427343, -6.682499079980124],
            [11.446872426708545, -6.691748280516394],
            [11.45419447073677, -6.6950909287287255],
            [11.453978938712115, -6.698298501661527],
            [11.457243319579023, -6.699733358123947],
            [11.459123432342174, -6.708445348214262],
            [11.461833272600462, -6.711531000695944],
            [11.468722245258153, -6.712623501127895],
            [11.472400302562221, -6.71763518121657],
            [11.470466116054123, -6.7236190429440645],
            [11.466762914936627, -6.728848810673441],
            [11.46938680889618, -6.73289943194486],
            [11.47030377248888, -6.739019406337936],
            [11.465535563229468, -6.74982565627734],
            [11.465951896458181, -6.75406103382973],
            [11.468510009780024, -6.759599922502663],
            [11.463699575500376, -6.762028274109302],
            [11.466201800140013, -6.769978554900333],
            [11.469947079349847, -6.773031077369676],
            [11.469268751695745, -6.779686182195241],
            [11.467131337977392, -6.783134286422141],
            [11.469944451868578, -6.792696970063106],
            [11.471917033407571, -6.792545026771909],
            [11.47353223233694, -6.802675713015847],
            [11.473535845910003, -6.809374958964413],
            [11.471695049033082, -6.812696823500638],
            [11.477006898435603, -6.822167501736027],
            [11.48149179507187, -6.824170163836779],
            [11.480172186760017, -6.828163131432754],
            [11.483493772496251, -6.831530819269896],
            [11.483273030692194, -6.837265440719978],
            [11.485877059632216, -6.844875504156576],
            [11.378622560547496, -6.85892073818791],
            [11.3813341504411, -6.878514597211741],
            [11.38792430495172, -6.9398308608724815],
            [11.38813702332514, -6.94289649994914],
            [11.362345294328675, -6.946536100511984],
            [11.367222983666394, -6.982863311362687],
            [11.30889578616487, -6.9893664461073195],
            [11.297217625988255, -6.991068534864399],
            [11.284783709777944, -6.992027909328024],
            [11.283943972561865, -6.991129344516458],
            [11.287577380314374, -6.982406229179736],
            [11.292736646317037, -6.977322666358184],
            [11.2902686364816, -6.973326145653484],
            [11.289939571029901, -6.967339793811488],
            [11.29181293906748, -6.963730665162749],
            [11.292883993483208, -6.954703387512977],
            [11.288612076735673, -6.953106897276209],
            [11.28552532649649, -6.949631697745269],
            [11.282312449992396, -6.950958050188564],
            [11.27748498002998, -6.94815005743793],
            [11.278221227213546, -6.940548870910747],
            [11.275028393825036, -6.937454126507793],
            [11.27119854535971, -6.937273856337359],
            [11.271965833439745, -6.932775308284163],
            [11.268455957199984, -6.929376904353221],
            [11.264241354710773, -6.931435228991364],
            [11.260519859098109, -6.931034051685075],
            [11.253830850013863, -6.925136681460079],
            [11.250739147333976, -6.9156746566559155],
            [11.250509819527304, -6.907372504825622],
            [11.249431248296204, -6.905329460261204],
            [11.250732616977182, -6.899193739448385],
            [11.255135466071234, -6.894090618307355],
            [11.254883955288221, -6.89138453414825],
            [11.257459732410965, -6.881626071021146],
            [11.25698431508633, -6.879295446982894],
            [11.260442818963593, -6.8735163413362015],
            [11.2595220483441, -6.865695902802194],
            [11.257278143460503, -6.862150666635962],
            [11.257146092663005, -6.855077030119031],
            [11.246138723935946, -6.850973177023642],
            [11.24003687140618, -6.844834501701611],
            [11.237737122595965, -6.844266325140884],
            [11.233612475328341, -6.83800146412915],
            [11.22976004867348, -6.8343156177186115],
            [11.228609585403111, -6.828629474343466],
            [11.22945821564567, -6.824818267208336],
            [11.227806012410161, -6.817269600967268],
            [11.228196088282337, -6.809987671858484],
            [11.223282718391518, -6.8038277053513845],
            [11.222342053906134, -6.799922543554486],
            [11.224732182720903, -6.790484845289736],
            [11.22422156208303, -6.787053091126961],
            [11.221193359150087, -6.782113515294648],
            [11.21037687132634, -6.775971756187036],
            [11.20279145422329, -6.779393040654209],
            [11.195090121935518, -6.7810825700927495],
            [11.188899827295433, -6.779158622989979],
            [11.182995903345365, -6.775584629644059],
            [11.175196314198345, -6.772262518463604],
            [11.173928846166126, -6.7684461693718],
            [11.170184097584874, -6.766317341530522],
            [11.163587726740158, -6.7603493524133516],
            [11.160839192321971, -6.759837582874231],
            [11.153566376094332, -6.7486395780161335],
            [11.15046316437389, -6.748566544655363],
            [11.14692768277002, -6.7444051088925505],
            [11.1415700339487, -6.741865897907312],
            [11.136342598669193, -6.7443987303926525],
            [11.129822225905034, -6.735911322825133],
            [11.129228471304353, -6.725833331824649],
            [11.124821620112572, -6.7226848082121915],
            [11.124625334946046, -6.718312575373875],
            [11.126395063555844, -6.715959227263293],
            [11.12554090248584, -6.707873716676105],
            [11.127981028050197, -6.705765521477282],
            [11.125798222369752, -6.699363608022736],
            [11.12631389803709, -6.693682121526687],
            [11.123981560425081, -6.688636164853064]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.22964909523492,
          "lat": 31.275942805215177
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13019"],
        "coty_name": ["Berrien"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Berrien County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00326638"
      },
      "bbox": [
        11.123981560425081, -6.992027909328024, 11.485877059632216,
        -6.5356241825891175
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.132294685605583, -5.348716375878954],
            [12.185184661450274, -5.366744968806915],
            [12.182834732314511, -5.376881730614049],
            [12.179666116514962, -5.379812158236797],
            [12.182535809039603, -5.382757055071706],
            [12.186830397954914, -5.3943744922385966],
            [12.185794990676639, -5.399419262766983],
            [12.188996185029549, -5.409975281645811],
            [12.1942053490831, -5.411486433999999],
            [12.198128084730678, -5.414917433172295],
            [12.198982289315115, -5.420071871287301],
            [12.20153731919605, -5.4257920481550945],
            [12.205583908106483, -5.426151996135721],
            [12.207186881071669, -5.4292916559930555],
            [12.211438627973907, -5.431809970251153],
            [12.216576693524397, -5.436716603080288],
            [12.218750519981958, -5.436652299249267],
            [12.2227041779409, -5.4404560176292565],
            [12.224179082205179, -5.4494353565299605],
            [12.230869550799767, -5.454130969656354],
            [12.238192692123501, -5.454245938304936],
            [12.243110308601466, -5.457168763812829],
            [12.239091254134273, -5.492834157352892],
            [12.236108747047664, -5.5171365370013525],
            [12.232347697409566, -5.559238680552534],
            [12.230638039448566, -5.564718039060177],
            [12.23236023220856, -5.571463023959188],
            [12.229283266818147, -5.581376991786544],
            [12.2304641908601, -5.589745394667224],
            [12.228180676841818, -5.591742484801074],
            [12.227890304722704, -5.597773499753973],
            [12.222941418520332, -5.60850435709218],
            [12.22230980148899, -5.607987938443688],
            [12.196244329073208, -5.604960495409497],
            [12.17463558112211, -5.605423799575558],
            [12.084401511167078, -5.598212594024424],
            [11.996220396969083, -5.591119348316849],
            [11.994471608725751, -5.587939422164197],
            [11.989634036861222, -5.584281508437686],
            [11.990787148134292, -5.579838016605032],
            [11.989803935090507, -5.575220147670305],
            [11.986853754119293, -5.5700392621288985],
            [11.988081749045758, -5.56643918075161],
            [11.982144971986122, -5.563267901856867],
            [11.977276636237482, -5.56418427917478],
            [11.974614440810987, -5.559396971259991],
            [12.009087821635552, -5.490510233702561],
            [12.01681618482347, -5.4720885261572425],
            [12.016563604413498, -5.431158655837072],
            [12.03702593389412, -5.381261077521436],
            [12.088029847892209, -5.333677257588808],
            [12.132294685605583, -5.348716375878954]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.07358092469394, "lat": 32.40345722605968 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13043"],
        "coty_name": ["Candler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Candler County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00342852"
      },
      "bbox": [
        11.974614440810987, -5.60850435709218, 12.243110308601466,
        -5.333677257588808
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.729695879542806, -5.706860586860482],
            [12.766568197153898, -5.663772833321759],
            [12.77567802270293, -5.653358575477745],
            [12.835849014230273, -5.582595973252687],
            [12.850355904606744, -5.565899158823379],
            [12.870884325828497, -5.541615508811167],
            [12.914522132444933, -5.545756599655811],
            [12.915011527528145, -5.545977376408107],
            [12.910705395246485, -5.551861713859217],
            [12.917020884691986, -5.550329462125983],
            [12.921319098495484, -5.552161815812028],
            [12.923613774748231, -5.557460233665294],
            [12.93142319854699, -5.561333748716122],
            [12.936835866012435, -5.567882087405796],
            [12.938654684563236, -5.573498797541235],
            [12.943639095856943, -5.571762651174837],
            [12.945508620768072, -5.574021021095341],
            [12.939568177181755, -5.576695362498472],
            [12.942824749807903, -5.579224004244407],
            [12.943685541071664, -5.583038435190258],
            [12.9426894934581, -5.590292057992815],
            [12.946408691200478, -5.5918586923044185],
            [12.949821189953623, -5.589466069620074],
            [12.951318381711934, -5.594597085659301],
            [12.94605685476098, -5.596987583588836],
            [12.94260454563295, -5.593718196647885],
            [12.937739140106698, -5.600377090714977],
            [12.938225706222651, -5.605060158548021],
            [12.943957447705268, -5.606791908623701],
            [12.94586495116002, -5.613883510774937],
            [12.951927415070493, -5.615447361607229],
            [12.954070172054724, -5.617857850043498],
            [12.951070079442502, -5.620460888477944],
            [12.949457374417534, -5.625875486538933],
            [12.950054407607986, -5.633989612970407],
            [12.955298330588775, -5.641766312670208],
            [12.954540998286642, -5.647655707372378],
            [12.956887032177184, -5.652450888894652],
            [12.964884694065407, -5.656263421634441],
            [12.967471127023432, -5.654399720298],
            [12.974314087601822, -5.652630705093971],
            [12.977566469559187, -5.653063564319244],
            [12.982208657116496, -5.659339518068732],
            [12.981763619559118, -5.663497097586048],
            [12.993789733336556, -5.6641808904246975],
            [13.00745283418333, -5.6708986389256815],
            [13.021178500719927, -5.671283114655752],
            [13.026063209444013, -5.672911415561746],
            [13.03524816688612, -5.6670097639212935],
            [13.038550099539423, -5.662888925365578],
            [13.040983026892425, -5.655312489854087],
            [13.045745647816458, -5.651252649409669],
            [13.051281273597974, -5.650055397638919],
            [13.055539811108291, -5.651338553944451],
            [13.062587040161754, -5.65581111463044],
            [13.068700569220722, -5.665777948467255],
            [13.072200236832101, -5.6698478980811355],
            [13.082631697521798, -5.67317155108486],
            [13.093193563733669, -5.673296532857506],
            [13.098360299552066, -5.675222239903963],
            [13.126813710855686, -5.699257421194842],
            [13.130503247573877, -5.700643709790127],
            [13.141932123094664, -5.700685574429015],
            [13.14328204554948, -5.703870907730114],
            [13.157201403162574, -5.7057669245352525],
            [13.171745360707176, -5.717593250087497],
            [13.179447041977044, -5.713710863539821],
            [13.187768217979315, -5.706217503598104],
            [13.189180244578422, -5.702627448580173],
            [13.197721009475623, -5.706464386011468],
            [13.201754816282385, -5.71799451848351],
            [13.203573191100453, -5.72639219182463],
            [13.202358154980343, -5.726992742306783],
            [13.200278855548433, -5.742610001936069],
            [13.191526002489292, -5.747338150024762],
            [13.192366024156279, -5.757776815275024],
            [13.190248133020305, -5.762645299441563],
            [13.176355955313213, -5.777684797637886],
            [13.164400626350103, -5.787304299292992],
            [13.146307195511334, -5.800645971494386],
            [13.140788613427093, -5.801727662283216],
            [13.13600989785164, -5.784091454304059],
            [13.13331141970596, -5.779235320290851],
            [13.124502216171408, -5.778798657735695],
            [13.119336713604701, -5.782069338898785],
            [13.120740388873312, -5.785987630473485],
            [13.103334511026175, -5.804906315526576],
            [13.093550100840813, -5.80759644771679],
            [13.095483900860419, -5.8158638679642225],
            [13.110612474644105, -5.82950894343522],
            [13.122955892938636, -5.831652725618868],
            [13.133701396690858, -5.828714699793768],
            [13.143836913969766, -5.832076767093566],
            [13.131407509760406, -5.846056535840014],
            [13.114152163736, -5.867284621412603],
            [13.099615537857714, -5.890130659023392],
            [13.093388786150129, -5.892024254673047],
            [13.079871794213808, -5.883305851330973],
            [13.06813904829752, -5.884486645406673],
            [13.064877071733594, -5.880155299426837],
            [13.055896877273778, -5.878266742831133],
            [13.03596375515137, -5.880503312836351],
            [13.04455608711641, -5.89865965952448],
            [13.045372033896715, -5.906326333580318],
            [13.043108984392546, -5.91211185685623],
            [13.033279352313764, -5.922368868166165],
            [13.034700571583093, -5.929328535241746],
            [13.042282971638787, -5.931072822449867],
            [13.047393456731953, -5.935381081395234],
            [13.05590143978813, -5.936085024187968],
            [13.058637057348877, -5.929753649532702],
            [13.065726602390688, -5.930537661108721],
            [13.071009734617675, -5.936357079337216],
            [13.070970670493917, -5.942492694967946],
            [13.063726923447678, -5.953240123706833],
            [13.048301823940298, -5.985506804205286],
            [13.04231480827915, -5.995238568279459],
            [13.031123990634699, -6.010692652862137],
            [13.01888078622414, -6.024676921044233],
            [13.005543240031606, -6.041458641095357],
            [12.999281178711847, -6.044218184811186],
            [12.98487281991309, -6.0411487866344045],
            [12.983038170413684, -6.0297886981973186],
            [12.977725395891856, -6.0222190119875005],
            [12.966632840756644, -6.015471355170976],
            [12.963970472275212, -6.011641931399264],
            [12.963560939714231, -6.006337643199847],
            [12.965515139457922, -5.997045332146856],
            [12.97054456034391, -5.9897852453998555],
            [12.97030862211408, -5.983439011601895],
            [12.967059932571715, -5.981326281599414],
            [12.955383734887855, -5.980629800837223],
            [12.95229970623145, -5.978481678159035],
            [12.951687017662529, -5.973532166491141],
            [12.953627249905805, -5.965731945875106],
            [12.95215538040055, -5.955349067834239],
            [12.954378798627648, -5.952567955066969],
            [12.963161860894202, -5.949065601510551],
            [12.965441072893688, -5.945682618841222],
            [12.965324550063183, -5.934674101494587],
            [12.967305762187479, -5.929407571936321],
            [12.971453587056626, -5.924812888891634],
            [12.977949319598935, -5.914386356179737],
            [12.978094932158205, -5.911022307084714],
            [12.965337356881747, -5.906655064215876],
            [12.960287160481279, -5.901779263323517],
            [12.955992204851695, -5.893030852105978],
            [12.954230106501594, -5.882744380541066],
            [12.946191419552482, -5.874420370399968],
            [12.942135644133147, -5.872315413263105],
            [12.936114957066318, -5.872286946983297],
            [12.927400830297717, -5.876451335179896],
            [12.922164093039509, -5.880484307036216],
            [12.914451266866655, -5.888010822643073],
            [12.90799364092211, -5.890141190505735],
            [12.903887261374681, -5.889120671194652],
            [12.902048621168083, -5.885329848537937],
            [12.90588021140636, -5.880017445883749],
            [12.917659410763164, -5.873491462361691],
            [12.923773619025036, -5.865917367732174],
            [12.925340214430802, -5.859502420500735],
            [12.924758934952177, -5.856162624825623],
            [12.921717221012088, -5.853629119846268],
            [12.9154008187777, -5.853465430635963],
            [12.90763216533185, -5.8579246062202],
            [12.904668646850105, -5.862587348441958],
            [12.898114045640687, -5.876280858847192],
            [12.897087302518722, -5.882658958288064],
            [12.892086950105272, -5.89234761597643],
            [12.88955664714986, -5.893332452680585],
            [12.885124883583444, -5.888730413814635],
            [12.885908498665781, -5.884746448022809],
            [12.889602178785776, -5.880308136058328],
            [12.891344788344693, -5.875980331205558],
            [12.888886785233002, -5.870157293402048],
            [12.883830754403224, -5.869049111097191],
            [12.876623755017182, -5.871450718576943],
            [12.871975974335244, -5.877577529020327],
            [12.867725243232503, -5.877326265585084],
            [12.863411795092793, -5.873632225926416],
            [12.862473638657216, -5.868455388790357],
            [12.86370383104612, -5.864360555724966],
            [12.868173642845887, -5.859601934837211],
            [12.867294527191707, -5.856718076360008],
            [12.86297521055473, -5.856986191775051],
            [12.859372290934475, -5.860176422640796],
            [12.85503695428533, -5.860348453934394],
            [12.852124968253989, -5.857626608566181],
            [12.851390681389995, -5.854022149475579],
            [12.853475800153891, -5.846676711143978],
            [12.851424270635428, -5.843203969042736],
            [12.845715572032514, -5.841258261228707],
            [12.841872578469573, -5.844195873581342],
            [12.838611373395556, -5.841764454695681],
            [12.83938049193592, -5.83683181783925],
            [12.83493106070461, -5.827551807860372],
            [12.835311312410571, -5.813663194517929],
            [12.833934417617547, -5.810822603348273],
            [12.828260045503468, -5.808963552593492],
            [12.821361202940645, -5.8101601648432935],
            [12.81627286601374, -5.808373328923372],
            [12.816318178737166, -5.800971774613882],
            [12.813215265253884, -5.795924733364129],
            [12.81748904782196, -5.791143336133817],
            [12.813036849506682, -5.787045993229027],
            [12.808448645505871, -5.787145023766051],
            [12.807427459379248, -5.782242436917536],
            [12.803662203948642, -5.78548573054282],
            [12.800024236366232, -5.781268667129268],
            [12.802747208646625, -5.778624043298902],
            [12.798264901091747, -5.7729875881265205],
            [12.792444744081857, -5.774452289750458],
            [12.787723327698718, -5.772654578161276],
            [12.787759465417832, -5.766882832990792],
            [12.783937771856518, -5.762206743042323],
            [12.782164969465475, -5.764094816188067],
            [12.769520395469323, -5.757798653011074],
            [12.762801245466346, -5.752508996793297],
            [12.75766504806094, -5.751123811839037],
            [12.75397821389558, -5.745035321107831],
            [12.756166489228798, -5.742123385991693],
            [12.752410238036322, -5.735888578093051],
            [12.747913075531553, -5.733590678195766],
            [12.75029385249929, -5.728592942160795],
            [12.743800954516876, -5.726511803498181],
            [12.738022576960264, -5.722140414592683],
            [12.733331231955885, -5.715245366568318],
            [12.734360971790018, -5.711865712653665],
            [12.729695879542806, -5.706860586860482]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.13296156626059, "lat": 32.0043293016434 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13051"],
        "coty_name": ["Chatham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chatham County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01694477"
      },
      "bbox": [
        12.729695879542806, -6.044218184811186, 13.203573191100453,
        -5.541615508811167
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.848776099926727, -5.779784167205228],
            [10.85639838695932, -5.762666037457627],
            [10.862037482621702, -5.7529282616297674],
            [10.867282593238393, -5.742324026045056],
            [10.872684974255915, -5.72850105121412],
            [10.910389894056149, -5.657070243822259],
            [10.913082283838902, -5.657770102067909],
            [10.921461560730199, -5.665809119885331],
            [10.929610679965291, -5.6676476439139565],
            [10.930008224696957, -5.657668401684026],
            [10.93185206486365, -5.654722850823732],
            [10.958336606749778, -5.676148552538567],
            [11.038918038922338, -5.739261324719611],
            [11.055327106739352, -5.752205736113188],
            [11.05769744052339, -5.752539247557214],
            [11.075214268204972, -5.766146651739202],
            [11.055397854669971, -5.791737641352892],
            [11.105365290482384, -5.8311164964685345],
            [11.133967370158492, -5.852806249033405],
            [11.122594446002537, -5.86786569678467],
            [11.114203426860849, -5.87814221035565],
            [11.109645464803062, -5.884764692219304],
            [11.128741498863084, -5.899530699257046],
            [11.12444394501913, -5.9050706986296735],
            [11.12620225414906, -5.90742601917998],
            [11.117779105333023, -5.914104549537645],
            [11.105140748697037, -5.930231417534743],
            [11.100634074744264, -5.928643528504543],
            [11.095461490384722, -5.934083782982705],
            [11.091280540382137, -5.93133860873001],
            [11.091733587685352, -5.928853797973976],
            [11.088227961016313, -5.920419098800207],
            [11.082831876250534, -5.914839782146207],
            [11.052732540835672, -5.918831864409774],
            [11.051745358650344, -5.910411563397055],
            [11.03542716552507, -5.9120726599915345],
            [11.036390053814129, -5.919918272427301],
            [11.02044463240891, -5.921777762073679],
            [11.02147412490624, -5.9298855793469185],
            [10.97576224795406, -5.935203150660064],
            [10.93282783685335, -5.940665371515919],
            [10.931892209542406, -5.932779369574764],
            [10.924080701418916, -5.933711565028381],
            [10.924975478355478, -5.941686580753572],
            [10.900081907472188, -5.944580427971296],
            [10.87687398976067, -5.947706294578063],
            [10.875254386703176, -5.935414167212378],
            [10.869750008635528, -5.887968798190409],
            [10.862562034774575, -5.828694427874508],
            [10.859542346204137, -5.82560878481443],
            [10.854672635592696, -5.82627000042121],
            [10.853436847364799, -5.816585412677367],
            [10.861321728993627, -5.815693240090238],
            [10.856447867211761, -5.778905610243478],
            [10.848776099926727, -5.779784167205228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.47598783390922, "lat": 32.23233971443515 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13235"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "235",
        "coty_gnis_code": "00347593"
      },
      "bbox": [
        10.848776099926727, -5.947706294578063, 11.133967370158492,
        -5.654722850823732
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.77225453998938, 7.4422102269778865],
            [-12.769160860203776, 7.445414545938754],
            [-12.767857490481106, 7.450156092765802],
            [-12.761705913978608, 7.455964972076504],
            [-12.757096753566145, 7.456418697335167],
            [-12.754679181607383, 7.465034200620612],
            [-12.748447439190777, 7.464267498152871],
            [-12.745975360037377, 7.4693154784617635],
            [-12.734607525607021, 7.46849776931093],
            [-12.73336696880334, 7.473382985590775],
            [-12.734971828423756, 7.478571248597717],
            [-12.728772978128257, 7.479621572251971],
            [-12.727138452570486, 7.484175194709983],
            [-12.731504553470478, 7.491656817649747],
            [-12.729453618973954, 7.498637150793885],
            [-12.724239525693463, 7.500773909283493],
            [-12.721862390453397, 7.497825425663179],
            [-12.717074485803268, 7.49803289484057],
            [-12.7161558773949, 7.502510309865978],
            [-12.70845115437279, 7.501782822878211],
            [-12.70437872099151, 7.500049753790678],
            [-12.702149713514325, 7.501836292402373],
            [-12.700958755504212, 7.507334074939246],
            [-12.694132084880541, 7.510609533076887],
            [-12.69972713010636, 7.514405327680225],
            [-12.698563807754478, 7.517667426066331],
            [-12.694751086608694, 7.5198471682976225],
            [-12.696563301725176, 7.5259996103608815],
            [-12.696272431790964, 7.534986787595372],
            [-12.692480612520036, 7.539834183107822],
            [-12.696236124812119, 7.545316909001247],
            [-12.694855592676298, 7.547560507840995],
            [-12.689038428669013, 7.548757891367151],
            [-12.685646511153926, 7.552679947643159],
            [-12.68679063778732, 7.562432654014837],
            [-12.685452940229279, 7.565897367655643],
            [-12.690779620429716, 7.568450922671601],
            [-12.690135730677513, 7.573632043377076],
            [-12.684611216049118, 7.585006625336398],
            [-12.684170534538278, 7.589558441707222],
            [-12.686668382223871, 7.591270581677391],
            [-12.684471220266525, 7.5954502818174845],
            [-12.683424202453061, 7.601512458181519],
            [-12.681115111138649, 7.604003819443693],
            [-12.680549235584527, 7.608242987260844],
            [-12.677603289343276, 7.614308492959243],
            [-12.677004470103677, 7.619891008260192],
            [-12.671643256205387, 7.6216660077840706],
            [-12.67076132955268, 7.62765475345602],
            [-12.673942859792911, 7.630339603991063],
            [-12.670662149481895, 7.634214096180933],
            [-12.670694346406682, 7.642414311141615],
            [-12.666936720341296, 7.648523650698748],
            [-12.667686127717472, 7.652625382986841],
            [-12.664097893101337, 7.6570346259494295],
            [-12.666540616739765, 7.661013798474378],
            [-12.663423335431993, 7.665390513815858],
            [-12.661561703257844, 7.670954480487198],
            [-12.663771097039177, 7.676963405888923],
            [-12.661509592605618, 7.681951150538259],
            [-12.662552219123075, 7.6873243255426935],
            [-12.659996924159154, 7.694217347886845],
            [-12.654626890177592, 7.6984755083867356],
            [-12.653598205714527, 7.702737424348601],
            [-12.656845954692301, 7.704425794103001],
            [-12.661129402594652, 7.709852880712426],
            [-12.65869345286713, 7.712238778318725],
            [-12.656465965359757, 7.722987041083945],
            [-12.653671492200246, 7.723397190025713],
            [-12.651483973275022, 7.730145223878484],
            [-12.647834127353292, 7.734062029404338],
            [-12.649411972529208, 7.743438673576925],
            [-12.648082096659543, 7.758446648085115],
            [-12.64938531787884, 7.76484435541581],
            [-12.641618747189034, 7.772308710822399],
            [-12.640946586221414, 7.776248151735102],
            [-12.636559944893134, 7.7866862476389915],
            [-12.63757791478895, 7.789744135750926],
            [-12.63102363384625, 7.798151385665781],
            [-12.626160159586345, 7.797045660974623],
            [-12.618744310840098, 7.797765789943466],
            [-12.613940050922697, 7.8043809404966495],
            [-12.610975180846586, 7.806215065978297],
            [-12.605587130229434, 7.8135975759788705],
            [-12.603544060801926, 7.818069280256352],
            [-12.603230701783597, 7.823662577931109],
            [-12.600081160633607, 7.826192199359638],
            [-12.599392078983799, 7.830298935148053],
            [-12.592397339328228, 7.8378936641368755],
            [-12.585895728551472, 7.8385709206389595],
            [-12.581184893061321, 7.84452795927736],
            [-12.580104677470253, 7.849668968938586],
            [-12.573663302740917, 7.8526491300849655],
            [-12.571572271600893, 7.856749991404175],
            [-12.56597661964437, 7.859796010020047],
            [-12.563584689610654, 7.859639536199502],
            [-12.550493048184162, 7.87031984056504],
            [-12.54319347925414, 7.873330102258541],
            [-12.537817343436728, 7.874364421732376],
            [-12.53494051525083, 7.878786874608076],
            [-12.524916868386967, 7.888161358222577],
            [-12.526536656999202, 7.889723071233322],
            [-12.532546442836965, 7.888053925588284],
            [-12.539062415414087, 7.895687302787265],
            [-12.545250750251355, 7.904221834906395],
            [-12.548146066758585, 7.912896173397078],
            [-12.553408245365143, 7.915719762338154],
            [-12.55684097241335, 7.923334258666465],
            [-12.559366307245954, 7.925770227102553],
            [-12.561471748630339, 7.931691953190442],
            [-12.5656214272304, 7.93584332041973],
            [-12.564867371166974, 7.939112494225212],
            [-12.568897157110552, 7.94279795819284],
            [-12.570975332152468, 7.949120578469866],
            [-12.5717061152069, 7.955786652164231],
            [-12.568202021551205, 7.962491396511423],
            [-12.568139385210413, 7.965143849681907],
            [-12.572498369501492, 7.965799270653759],
            [-12.576454418158129, 7.971516226462341],
            [-12.581381788134067, 7.971491457085076],
            [-12.582867943214417, 7.975656740316122],
            [-12.582696634736665, 7.980734258298547],
            [-12.586968473195249, 7.983052463729103],
            [-12.587228586283683, 7.991100946379259],
            [-12.591483886461573, 8.001204021867192],
            [-12.5961383658423, 8.003164226850737],
            [-12.603066641526777, 8.002516876451203],
            [-12.606807741176105, 8.00816997862661],
            [-12.60710040038267, 8.011817716486894],
            [-12.610708213176999, 8.013590184474126],
            [-12.612133629603374, 8.018177237224396],
            [-12.617442214643704, 8.022207953266062],
            [-12.621185472162779, 8.032321623890546],
            [-12.61738263955692, 8.03942717621149],
            [-12.620507578978907, 8.045428411622408],
            [-12.635432867065877, 8.050302380566542],
            [-12.63593131447063, 8.055122959539844],
            [-12.631332753344003, 8.067468207597866],
            [-12.628071338463302, 8.069410720525799],
            [-12.627624104921958, 8.078893489801851],
            [-12.629991670045209, 8.081652402364071],
            [-12.631304108054955, 8.089799458433422],
            [-12.628393725063578, 8.093392467034986],
            [-12.62851349422257, 8.096552563506897],
            [-12.625064178234187, 8.102527550063646],
            [-12.624113997176373, 8.106381956138572],
            [-12.626877820713585, 8.109659435171167],
            [-12.624526037422354, 8.112989275863226],
            [-12.621684924343958, 8.120256536955717],
            [-12.617062595205114, 8.123560017639162],
            [-12.610270922650303, 8.122008738968375],
            [-12.607313345331944, 8.12275934217982],
            [-12.602971938802591, 8.119731780099821],
            [-12.599622725369056, 8.114543648074354],
            [-12.597551358310296, 8.108344607577413],
            [-12.58431383163992, 8.09426676402266],
            [-12.581891416584568, 8.094673287805477],
            [-12.573725090682458, 8.09162386559284],
            [-12.568595167636333, 8.09147991191434],
            [-12.563912668214682, 8.092919811358096],
            [-12.554151765453739, 8.089197782335855],
            [-12.548640080638958, 8.081418667291684],
            [-12.548939538266305, 8.075511178055661],
            [-12.550621396290849, 8.071513612955313],
            [-12.541238937830473, 8.067015437718773],
            [-12.527639113023278, 8.079294885339024],
            [-12.526899491643265, 8.085046645939624],
            [-12.522284876649987, 8.086608656112862],
            [-12.521571748160023, 8.089563243429728],
            [-12.514302031448445, 8.097704229977955],
            [-12.513661130267138, 8.10115126897642],
            [-12.508985969900221, 8.106153634356742],
            [-12.50837824163568, 8.108852086696725],
            [-12.497472379581993, 8.1162128366701],
            [-12.480342542099965, 8.118472885875027],
            [-12.474412741774124, 8.121092897292115],
            [-12.47258306034386, 8.125508091820224],
            [-12.46969783855608, 8.12741961566796],
            [-12.466275813911695, 8.126275532121868],
            [-12.460916045530489, 8.130241074786662],
            [-12.454814756018042, 8.137323573874685],
            [-12.451877069695703, 8.13817794235485],
            [-12.446492640882168, 8.134900094284301],
            [-12.444796963999162, 8.137138982942062],
            [-12.437901305904964, 8.140043326784113],
            [-12.431292994739657, 8.140756629344805],
            [-12.426589931280418, 8.144933939698142],
            [-12.419177517250242, 8.138440483704574],
            [-12.414601225867898, 8.130971199437788],
            [-12.41229326361043, 8.13039958218045],
            [-12.409428572359277, 8.126110753576267],
            [-12.404758745496315, 8.126828905168477],
            [-12.399303431052369, 8.130484151840657],
            [-12.397576723040428, 8.129305116292736],
            [-12.39108904450443, 8.13039298669965],
            [-12.389467833582557, 8.132039112363119],
            [-12.385781958277839, 8.126573772567331],
            [-12.379568791728188, 8.125839955823919],
            [-12.385334426651257, 8.119861904982702],
            [-12.385136139356758, 8.116711113188195],
            [-12.387801692951157, 8.111681700769791],
            [-12.37906653791214, 8.106788905924974],
            [-12.378980727709438, 8.104280353135454],
            [-12.372923004604587, 8.10032933162287],
            [-12.372114997536515, 8.093903085072402],
            [-12.367923540379117, 8.091817823735331],
            [-12.369514468151406, 8.080049565687473],
            [-12.367649055033452, 8.071990667920248],
            [-12.363120419898625, 8.070895665569726],
            [-12.343812447845444, 8.059415585554122],
            [-12.337308685746514, 8.051120971888158],
            [-12.33102160520019, 8.045783908672425],
            [-12.331390490473716, 8.040429120360676],
            [-12.329446126358414, 8.03261106708187],
            [-12.330736232931168, 8.02900648136476],
            [-12.324607490128363, 8.023894455700983],
            [-12.325070468367665, 8.019899452839288],
            [-12.321921796816222, 8.012440392852728],
            [-12.317137813288177, 8.01246828332082],
            [-12.315301602313474, 8.01056516658213],
            [-12.306748349124932, 8.015939207136736],
            [-12.303166519539337, 8.015337706424368],
            [-12.298974885726818, 8.018295340988246],
            [-12.296231184623037, 8.017183138112397],
            [-12.289687984694835, 8.020037129975673],
            [-12.288195944361618, 8.022731478096802],
            [-12.283906173400723, 8.025130967253078],
            [-12.27313096961187, 8.023602205197497],
            [-12.266438396082336, 8.026686397979432],
            [-12.264913217315556, 8.03289424356791],
            [-12.260901832690331, 8.033417572798506],
            [-12.257365004080935, 8.037331150780329],
            [-12.253098064409155, 8.051160803588681],
            [-12.24891055261578, 8.054205495426944],
            [-12.242573276448521, 8.06317757819801],
            [-12.24344038755784, 8.067514896703347],
            [-12.241925371246886, 8.072548402523296],
            [-12.243329632737474, 8.075776706842449],
            [-12.239596341320182, 8.083029264854138],
            [-12.233015253233516, 8.082833963173023],
            [-12.22494910243761, 8.08066568187739],
            [-12.210741094032882, 8.067561330420352],
            [-12.2025866859851, 8.067520031448877],
            [-12.197019727662424, 8.074981093682114],
            [-12.192038832896731, 8.079224962195871],
            [-12.186030439814246, 8.077876614403376],
            [-12.181280688379372, 8.078793588559524],
            [-12.173234809964221, 8.077713532068552],
            [-12.169904104463532, 8.082120250695638],
            [-12.160260566537994, 8.079515967888918],
            [-12.157815208652135, 8.083320085323269],
            [-12.153727424803709, 8.086701271161385],
            [-12.15292933984741, 8.090884757373873],
            [-12.154585745411485, 8.093718753315903],
            [-12.151476032949832, 8.098405742691892],
            [-12.145065976246183, 8.104133312291705],
            [-12.128231830868875, 8.103380342842662],
            [-12.1225528008033, 8.106638221481798],
            [-12.119695081349283, 8.106206070759812],
            [-12.115673798002808, 8.111066599403184],
            [-12.115023452820266, 8.117369992685754],
            [-12.112483356017757, 8.124881099147817],
            [-12.106629310167948, 8.1272382875298],
            [-12.104300027941076, 8.133581918220592],
            [-12.099259587371327, 8.139386698945865],
            [-12.092761413613282, 8.141882816471453],
            [-12.087975642929072, 8.142012793571796],
            [-12.082316335299028, 8.145425098252261],
            [-12.080567085531339, 8.148422566590432],
            [-12.072352396851263, 8.154645109384832],
            [-12.062293619121803, 8.153040965189355],
            [-12.058215527137031, 8.158849537259162],
            [-12.057109097356392, 8.167093129303625],
            [-12.05906407497119, 8.174426835972103],
            [-12.061500209885377, 8.175160632295565],
            [-12.063074469877094, 8.180649972298488],
            [-12.052980943202062, 8.186544801827617],
            [-12.054127223996293, 8.196073182104037],
            [-12.051098821733852, 8.198671018737828],
            [-12.048951985077801, 8.196295164462086],
            [-12.04447070619292, 8.195654046726371],
            [-12.038692237511334, 8.197092897176832],
            [-12.034961059873773, 8.202983498788873],
            [-12.030441573896612, 8.204642454746939],
            [-12.026366631331953, 8.200824296683349],
            [-12.01963654814375, 8.199564258588465],
            [-12.019846401399539, 8.189576393850658],
            [-12.015469012410367, 8.185687570033622],
            [-12.012375917028882, 8.185554299612223],
            [-11.998143474256235, 8.188176403136618],
            [-11.99596294148126, 8.183949554926977],
            [-11.99788420461497, 8.174820970577965],
            [-11.996637346628294, 8.16994804377695],
            [-11.996610169536584, 8.162613144244721],
            [-11.992336987453642, 8.15587493699063],
            [-11.992329537332019, 8.149222314105948],
            [-11.98840003107719, 8.144353250246642],
            [-11.98266287430392, 8.14065327044286],
            [-11.979206827143113, 8.13545610009404],
            [-11.97838473715368, 8.132015060068547],
            [-11.984227027219996, 8.127420590719375],
            [-11.98451659217812, 8.117994419767976],
            [-11.98738067317492, 8.115743234053307],
            [-11.98826891174407, 8.111918255160756],
            [-11.981347197732433, 8.10952223996253],
            [-11.97671933600999, 8.105552568787918],
            [-11.968252491342502, 8.106644694541394],
            [-11.964215407035882, 8.10816601227253],
            [-11.958719228143469, 8.108361068182925],
            [-11.950713525944977, 8.103348624926374],
            [-11.94828323007351, 8.095115249964769],
            [-11.942478514139195, 8.091773192331086],
            [-11.938583142328268, 8.093501139886833],
            [-11.934518548673621, 8.092237749189001],
            [-11.932066657838277, 8.0875158740942],
            [-11.928506680657271, 8.08546418985327],
            [-11.925596630707858, 8.081174342990296],
            [-11.925156404074597, 8.07248718767838],
            [-11.922437671838285, 8.064113706698715],
            [-11.922380301060628, 8.059748532853062],
            [-11.92936679395739, 8.05718661682423],
            [-11.9371717554848, 8.049779291836145],
            [-11.941700606981577, 8.047199007972761],
            [-11.940351222760162, 8.04153448230956],
            [-11.94144087605983, 8.037677250857506],
            [-11.94606476959993, 8.028824555273555],
            [-11.953001534024478, 8.020110952176319],
            [-11.953162480167425, 8.015358137380142],
            [-11.959280493490875, 8.004615560366615],
            [-11.953159412918476, 8.004226891226107],
            [-11.949832433265287, 8.005283855201446],
            [-11.94222801281932, 8.000788685046885],
            [-11.937288926854588, 8.003137992236471],
            [-11.922878326024193, 7.999146948399174],
            [-11.920129754697594, 8.000054753086097],
            [-11.912721561281332, 7.996261179835875],
            [-11.918167327738162, 7.990578488620367],
            [-11.916788765699055, 7.9880919078801815],
            [-11.918191292112748, 7.984106622518583],
            [-11.91578824808624, 7.976828187560301],
            [-11.91601038726573, 7.967211082041495],
            [-11.914825622747433, 7.962176338098731],
            [-11.915661677842019, 7.956324450878467],
            [-11.922490865007811, 7.9507511384892835],
            [-11.928862568674049, 7.948399814627018],
            [-11.929053283035477, 7.940965749701853],
            [-11.936559593722016, 7.934985427962964],
            [-11.937238360048793, 7.9313785128343355],
            [-11.932090984861407, 7.925574355433063],
            [-11.935747254774036, 7.914031168051784],
            [-11.934119005106407, 7.910354421883319],
            [-11.928370331290017, 7.908628998899264],
            [-11.925674909796312, 7.904468266905343],
            [-11.929450127589096, 7.89995153448256],
            [-11.933959119068295, 7.899141698467281],
            [-11.93905439542882, 7.896281193711601],
            [-11.940161113793739, 7.888065903994554],
            [-11.939216627373677, 7.885942705593413],
            [-11.93010161286105, 7.884188520885612],
            [-11.92514447490623, 7.879496111540639],
            [-11.922639416570517, 7.8790907301145285],
            [-11.920195710225302, 7.872336175898472],
            [-11.914434949390396, 7.866990086461687],
            [-11.914265137720438, 7.860945264424729],
            [-11.917016637400016, 7.852734844717708],
            [-11.917245933267198, 7.847792866573692],
            [-11.922019652968034, 7.843981100784068],
            [-11.919165082202037, 7.838374313206233],
            [-11.917954356447188, 7.8307018244896],
            [-11.92173574120187, 7.828796754859229],
            [-11.922611782632341, 7.824368475133488],
            [-11.92739283469217, 7.820642339237318],
            [-11.928831808256769, 7.805155031300246],
            [-11.924111006896238, 7.796281972384889],
            [-11.917800081777253, 7.790410608619091],
            [-11.914553101133249, 7.7748892440759],
            [-11.910553640198247, 7.772289147421208],
            [-11.909588478083736, 7.765390227545472],
            [-11.902325701340333, 7.7581855632338685],
            [-11.898397361449224, 7.749971187821361],
            [-11.898059979149409, 7.746099783298034],
            [-11.901399801659949, 7.744125758403584],
            [-11.90658104403875, 7.744966241945247],
            [-11.90938715211241, 7.736015957918373],
            [-11.90585176667138, 7.726982825432006],
            [-11.90237132231305, 7.720771076449287],
            [-11.897892324908431, 7.7190612092874495],
            [-11.8894686959002, 7.710044160033959],
            [-11.884857603754796, 7.701737916554236],
            [-11.885199485438328, 7.694373920052761],
            [-11.879616134665005, 7.683400427393067],
            [-11.880384489276931, 7.6796542611673155],
            [-11.869424513081196, 7.667265644207757],
            [-11.867520101810191, 7.6622585687118185],
            [-11.865016487450825, 7.661057753966556],
            [-11.862211908751076, 7.655867446614023],
            [-11.858411060674024, 7.654167670105566],
            [-11.857716118222138, 7.648735454874005],
            [-11.854455169675447, 7.645821207266224],
            [-11.854072595707985, 7.639118756471312],
            [-11.859285602711395, 7.629139887850836],
            [-11.857887736946527, 7.623853207550584],
            [-11.858834467272999, 7.618070936058717],
            [-11.854483078547203, 7.615170266545667],
            [-11.852775862699243, 7.6093446748674065],
            [-11.84262764911042, 7.607856026622202],
            [-11.844493720407883, 7.603313644459758],
            [-11.853572463873304, 7.592498447535089],
            [-11.850182211593086, 7.584582820882894],
            [-11.84864274755958, 7.584259125969464],
            [-11.840566967619022, 7.5771383377375345],
            [-11.838566831498706, 7.57106857477292],
            [-11.83087648034586, 7.568879984367051],
            [-11.823769767407823, 7.57172121159622],
            [-11.817534502747923, 7.569152225273783],
            [-11.812349001091455, 7.570049249599566],
            [-11.81053202433798, 7.568339807199318],
            [-11.808683807004822, 7.561622064137999],
            [-11.814354673258178, 7.5533120512472784],
            [-11.823291538650569, 7.547686203303013],
            [-11.818832817414506, 7.538917120739626],
            [-11.811105321820055, 7.533889718262741],
            [-11.80696337317734, 7.532694980951871],
            [-11.8019546570105, 7.525545857913438],
            [-11.803568724750734, 7.523131989938183],
            [-11.802747842023134, 7.5144808811552535],
            [-11.796000181075396, 7.5114666379602495],
            [-11.788808866953737, 7.511172965109109],
            [-11.784831428637952, 7.512282641548419],
            [-11.780474628020913, 7.5059610343062255],
            [-11.781440103595495, 7.492334597458148],
            [-11.786548211407569, 7.487891766609908],
            [-11.78114681746784, 7.480124391804987],
            [-11.785215017856833, 7.467999471871057],
            [-11.782347043592946, 7.461664462252972],
            [-11.78011846518471, 7.453562896454052],
            [-11.787381079532215, 7.446774506138192],
            [-11.787911003056628, 7.439601065724427],
            [-11.79002662630014, 7.43478150973514],
            [-11.791519889375039, 7.420619363172159],
            [-11.794968840154562, 7.418601125056369],
            [-11.79295250482337, 7.408279312068289],
            [-11.795792785431916, 7.404002471752677],
            [-11.80016970830635, 7.401604499420089],
            [-11.805858544895711, 7.402664573726236],
            [-11.80997335687901, 7.398991523188195],
            [-11.814953824507022, 7.400227852785834],
            [-11.820382883445939, 7.4033797177956595],
            [-11.825743246800897, 7.400943358183673],
            [-11.831775799980953, 7.402461022407067],
            [-11.83414827503442, 7.397207695103493],
            [-11.833715143780058, 7.386747619051012],
            [-11.832141580054458, 7.385630718229241],
            [-11.832543797606762, 7.379591866113598],
            [-11.831128922251283, 7.375478489152829],
            [-11.828548815678335, 7.374312304401475],
            [-11.824569601942287, 7.3652250293244075],
            [-11.821686837515458, 7.362348444236797],
            [-11.824153870647802, 7.35890757326678],
            [-11.82633219971442, 7.352262100253044],
            [-11.828492804255665, 7.349222300661018],
            [-11.821691156131763, 7.3434596284268325],
            [-11.818368495158978, 7.338799526192695],
            [-11.820207483491677, 7.334191444766944],
            [-11.817593647908888, 7.324075158727537],
            [-11.818007681279559, 7.317180136488832],
            [-11.816324162396945, 7.314767155500077],
            [-11.810743766046928, 7.312135823928349],
            [-11.808916236065322, 7.305485758647072],
            [-11.801743650883111, 7.302857303548503],
            [-11.799429698125454, 7.2906914223853345],
            [-11.799795444018725, 7.2856644504813195],
            [-11.790743053112784, 7.287237247307638],
            [-11.780926934133525, 7.2815770962927],
            [-11.773880989574318, 7.280852813710135],
            [-11.769342293924634, 7.277318105666142],
            [-11.769483858117814, 7.272858380085339],
            [-11.76454788087823, 7.266582358854888],
            [-11.75742107917471, 7.259943750109545],
            [-11.753973083748262, 7.2399222914583],
            [-11.76071244255969, 7.235917368403288],
            [-11.76054401521437, 7.231287996069075],
            [-11.75259269312255, 7.223732689107966],
            [-11.744578233048404, 7.226109809852607],
            [-11.736559051131518, 7.23046359322166],
            [-11.722660830138295, 7.233086332248042],
            [-11.72106074128298, 7.235954113876734],
            [-11.710243213962526, 7.23965479879033],
            [-11.705807854891638, 7.242703731237417],
            [-11.693531508628576, 7.244833015512388],
            [-11.690009802732488, 7.247095334588611],
            [-11.680593505841363, 7.248812025108435],
            [-11.67607435632909, 7.239107621855792],
            [-11.671924466499247, 7.238812522412103],
            [-11.665509828812812, 7.233925159791722],
            [-11.657068626037884, 7.230760830032165],
            [-11.654211521529334, 7.225291274424722],
            [-11.648637486010974, 7.222424486568533],
            [-11.6456118614811, 7.21934354989365],
            [-11.64189859555849, 7.212380488776988],
            [-11.640363674751603, 7.205635677183107],
            [-11.630632571516129, 7.195398925350318],
            [-11.627479877517166, 7.196954830878718],
            [-11.615121234314005, 7.190488517858887],
            [-11.60965372124556, 7.185801729118788],
            [-11.610760703728559, 7.178155063250616],
            [-11.616070762538405, 7.173898392044972],
            [-11.615092308478044, 7.165797313498925],
            [-11.607097298278847, 7.159204658718327],
            [-11.604918063229897, 7.1509653801601365],
            [-11.60670599480117, 7.145125137993669],
            [-11.603039590058328, 7.144440639801907],
            [-11.596404401152464, 7.139301574393072],
            [-11.597518302170652, 7.135886888038671],
            [-11.59721352351655, 7.127653309283533],
            [-11.598669623716273, 7.126441656801348],
            [-11.60033695463146, 7.116598987291434],
            [-11.598219883270179, 7.111409234669188],
            [-11.599250611434604, 7.1089715471807375],
            [-11.597179684364493, 7.104998838913708],
            [-11.590266344523425, 7.1005672538644005],
            [-11.58855255964215, 7.096943227605597],
            [-11.590561803135328, 7.09174255050152],
            [-11.58747199611868, 7.088416195591811],
            [-11.581857192951897, 7.085538662213781],
            [-11.582339078601086, 7.080633495169072],
            [-11.584973911110435, 7.076248494556906],
            [-11.58579714395077, 7.0655106437981585],
            [-11.584100242651491, 7.0602580210521255],
            [-11.585626516800337, 7.056366280245697],
            [-11.57798886140753, 7.042554382860521],
            [-11.578213888858043, 7.03462498325405],
            [-11.58199908770607, 7.0281762017616],
            [-11.585194875885431, 7.025310247359332],
            [-11.590195066855852, 7.025786141520154],
            [-11.59828564129504, 7.022990684912883],
            [-11.602218603511957, 7.017668833962174],
            [-11.60987442995015, 7.010448223308678],
            [-11.601321495478727, 7.003266007959399],
            [-11.594853405979018, 6.994518165687854],
            [-11.599294544488316, 6.9878650929442845],
            [-11.581253158672748, 6.970482013261701],
            [-11.581422008427314, 6.965738552232131],
            [-11.587988279504982, 6.9624927517998145],
            [-11.591232352235403, 6.955288914691211],
            [-11.589630979052219, 6.950032302363717],
            [-11.585928240142064, 6.9453593909382425],
            [-11.581421909985053, 6.942089490800277],
            [-11.577487691031427, 6.942423840272524],
            [-11.576099007869246, 6.938948244416265],
            [-11.570675810505941, 6.9312487313745414],
            [-11.567146371973898, 6.929617731430202],
            [-11.5666217295858, 6.92240589863123],
            [-11.57444260551566, 6.919826785136119],
            [-11.575780557286876, 6.912304808079053],
            [-11.577653028897814, 6.908041331722418],
            [-11.585665546062462, 6.901577920892337],
            [-11.583333322589667, 6.888545417058287],
            [-11.576179911397347, 6.875076504887013],
            [-11.578667752812255, 6.8696673535272135],
            [-11.578228662591027, 6.857305672640394],
            [-11.576759385849847, 6.853133954139589],
            [-11.570992142340433, 6.847808513415228],
            [-11.563828402726877, 6.834326127167483],
            [-11.554931670234124, 6.822845625058851],
            [-11.546896863601775, 6.822307219406921],
            [-11.546884352543616, 6.814985487700314],
            [-11.539680442472626, 6.808698712085177],
            [-11.533219710385133, 6.80836285568331],
            [-11.530355285338906, 6.804970594335094],
            [-11.525577897140046, 6.802594371909421],
            [-11.525004787438261, 6.797647035268235],
            [-11.516174197596364, 6.790941025145507],
            [-11.512400030924741, 6.791623177320926],
            [-11.50703519066924, 6.795809438117822],
            [-11.503022098674561, 6.791635001010411],
            [-11.504483910367838, 6.786561132363922],
            [-11.504797674479184, 6.769211633580699],
            [-11.501807620917292, 6.76649637413418],
            [-11.500307245951355, 6.761045811852151],
            [-11.49396771457809, 6.756988574417461],
            [-11.489731662734984, 6.746637797370641],
            [-11.483132392921318, 6.743431936079562],
            [-11.480309850794429, 6.745849886429048],
            [-11.471098492279237, 6.748967509288073],
            [-11.463514878599913, 6.753081370363653],
            [-11.457899440305725, 6.757385866039229],
            [-11.483644794728567, 6.614306437808517],
            [-11.568657569507861, 6.629423212636865],
            [-11.567977483897588, 6.633270422794733],
            [-11.610415958438962, 6.64083520124325],
            [-11.724861971745351, 6.661111879021865],
            [-11.839313619916979, 6.681355684142686],
            [-11.838625629155047, 6.6840968441183515],
            [-11.84085010294259, 6.68966573082161],
            [-11.843386152760084, 6.692067085251571],
            [-11.845214950720852, 6.696809898256331],
            [-11.844443377788787, 6.709273887356146],
            [-11.842430513593609, 6.713529585577126],
            [-11.836008588204212, 6.720460464352194],
            [-11.83754885738184, 6.725922667982011],
            [-11.836540024776305, 6.72893271629846],
            [-11.837891857657187, 6.7396354464651935],
            [-11.839671851813987, 6.742503812280524],
            [-11.83965535946692, 6.753908591023388],
            [-11.837744235598741, 6.757006132128898],
            [-11.838041204358026, 6.767223959570216],
            [-11.839962240591511, 6.770720627742473],
            [-11.845213744997864, 6.775950024062043],
            [-11.84699805360731, 6.77996365521353],
            [-11.846083539259741, 6.7850409622846595],
            [-11.848322418567834, 6.798785977886169],
            [-11.854497729221237, 6.806326405791436],
            [-11.855690851728129, 6.813983463922482],
            [-11.86407876655905, 6.825356834045916],
            [-11.866097958187956, 6.831187979249754],
            [-11.871153767858685, 6.8384715591478535],
            [-11.870365902502352, 6.842633261655034],
            [-11.872540047191109, 6.852888460880135],
            [-11.871967015861884, 6.856526444546125],
            [-11.873425533536249, 6.864237827491697],
            [-11.875250969934937, 6.868303779747724],
            [-11.87613944797757, 6.8747943461541725],
            [-11.87825222945923, 6.880661724501589],
            [-11.884833225946107, 6.885787761302885],
            [-11.885487597588561, 6.8908865485171455],
            [-11.883345475599285, 6.898212724866039],
            [-11.884140494867317, 6.901425759179194],
            [-11.887708348057414, 6.904483561503463],
            [-11.888000984648716, 6.910977294792737],
            [-11.890866671141493, 6.9154234147554074],
            [-11.901507413315548, 6.915315660126059],
            [-11.910072114338302, 6.911913379601005],
            [-11.911647697217207, 6.906530503024439],
            [-11.916767937712562, 6.903518333933632],
            [-11.918299587345102, 6.899137658895018],
            [-11.92543495189312, 6.895184854172291],
            [-11.932054679061492, 6.889780313129157],
            [-11.936462414868172, 6.892113406190229],
            [-11.943562146192443, 6.894142041309752],
            [-11.946067111583677, 6.896412260771543],
            [-11.95459999105278, 6.896715640989326],
            [-11.967077690461522, 6.900642726232447],
            [-11.972449038338922, 6.906033107240305],
            [-11.973535271548696, 6.9117455376699],
            [-11.98117780641658, 6.915777993256524],
            [-11.98410181949733, 6.919851179431284],
            [-11.989143996451423, 6.922116623747329],
            [-11.99581267784989, 6.921173981406859],
            [-12.005532720086498, 6.927374101121678],
            [-12.01286834914005, 6.930191887127086],
            [-12.02086210618251, 6.931442959169369],
            [-12.024452341485754, 6.934128387565054],
            [-12.03352666744197, 6.936543560652603],
            [-12.039714068006592, 6.9399828137500865],
            [-12.042063581727193, 6.94369860771472],
            [-12.04644171071043, 6.945557188389434],
            [-12.049715451382259, 6.952002038872361],
            [-12.054728469464344, 6.959098176096316],
            [-12.058986375459707, 6.960706373145021],
            [-12.065579754609123, 6.96771714754642],
            [-12.074386248105224, 6.969610474335072],
            [-12.084326470344967, 6.975272206047076],
            [-12.085352707586729, 6.97709605876813],
            [-12.09151391431228, 6.978823247644859],
            [-12.113743305013614, 6.994632201027435],
            [-12.118773550149273, 6.997413636290596],
            [-12.123911671133275, 6.996953605939314],
            [-12.130030046824757, 6.998058800316998],
            [-12.138533988976294, 7.001085269382015],
            [-12.141370626109614, 7.0074764839669434],
            [-12.145531316250263, 7.01193463727905],
            [-12.150118450665222, 7.021252793670244],
            [-12.150137146242088, 7.024738222363026],
            [-12.15268892617659, 7.033571451983034],
            [-12.159281611384996, 7.042661573220475],
            [-12.16611355475572, 7.048979167543506],
            [-12.17136295598417, 7.055956630339853],
            [-12.174795961116647, 7.062980155445039],
            [-12.180377028336, 7.068500981715379],
            [-12.182578794101055, 7.068691447197968],
            [-12.184586528046848, 7.075024705191666],
            [-12.191027064210399, 7.077727760780283],
            [-12.192336273685859, 7.082312832705498],
            [-12.19757445923028, 7.085085777844859],
            [-12.1989451921724, 7.090268949307823],
            [-12.202362524725167, 7.097000281981603],
            [-12.201010854892747, 7.099261627402509],
            [-12.207346244359352, 7.106202748870541],
            [-12.210460095246853, 7.108072013623919],
            [-12.212726340920897, 7.118641022083047],
            [-12.215717625722048, 7.121720675210662],
            [-12.219142407365533, 7.131382455182394],
            [-12.2219023363928, 7.13193265218188],
            [-12.22093648753085, 7.138479737671281],
            [-12.224995951412774, 7.144160294543676],
            [-12.229843808370628, 7.144173898660472],
            [-12.237028063065251, 7.15371852806446],
            [-12.23736430960342, 7.157192631057586],
            [-12.244248307705343, 7.1659721966609995],
            [-12.242847054609731, 7.17180889057256],
            [-12.24294397535415, 7.178035747587841],
            [-12.24483619767154, 7.180896545292034],
            [-12.252217931534732, 7.182833242926064],
            [-12.252487792589466, 7.191738444187577],
            [-12.254327215051784, 7.193638795327755],
            [-12.256110254332928, 7.200493327773322],
            [-12.25819986189023, 7.203189617711973],
            [-12.256506889423987, 7.211094618066629],
            [-12.260216258813184, 7.219235250077167],
            [-12.26002782757587, 7.221703841846897],
            [-12.26330038866576, 7.2246723229009255],
            [-12.264550169140303, 7.230879269337001],
            [-12.262415421574133, 7.234172096864127],
            [-12.263851227419643, 7.239927390696002],
            [-12.261377186837029, 7.244613983495346],
            [-12.26454669054132, 7.250121770332318],
            [-12.266857891364369, 7.257226139897924],
            [-12.266849753670995, 7.264692516182967],
            [-12.270253898631678, 7.267760331069208],
            [-12.271776755625414, 7.273229291692461],
            [-12.272370899886699, 7.281216170075599],
            [-12.277185713249077, 7.285611435500023],
            [-12.276972121473337, 7.291395315656642],
            [-12.282994126896456, 7.292520823956182],
            [-12.287432620557405, 7.289968626398889],
            [-12.294049919643276, 7.288193715016703],
            [-12.300197924135466, 7.28197907321023],
            [-12.305912540396351, 7.2803905691881425],
            [-12.308923614824822, 7.28317888872685],
            [-12.311154149630614, 7.279717039570215],
            [-12.316774372144193, 7.274289834837991],
            [-12.320061573720018, 7.276258041052353],
            [-12.322499437318587, 7.28386301380063],
            [-12.325906040126004, 7.2854414403254735],
            [-12.326644433778851, 7.291043253663059],
            [-12.331378327299417, 7.291133460993838],
            [-12.334510232167164, 7.288506253576529],
            [-12.3383067147853, 7.289513332793166],
            [-12.340338090115353, 7.294022392447794],
            [-12.34572185176032, 7.292900130768527],
            [-12.349425642211848, 7.293571201560137],
            [-12.353085869998598, 7.297540381916448],
            [-12.358587599774511, 7.297977546188152],
            [-12.362663073743912, 7.296946216019408],
            [-12.369277113453315, 7.299708997556569],
            [-12.370317377999895, 7.30226802781894],
            [-12.366719456881144, 7.316222880968915],
            [-12.363234378737666, 7.3173844536140695],
            [-12.35809888603284, 7.323170486831506],
            [-12.358087542085036, 7.327318429155813],
            [-12.353548221285923, 7.3299081319769455],
            [-12.355886283867434, 7.3337445686205935],
            [-12.355120113177733, 7.339622643228733],
            [-12.352740508427908, 7.346633516116516],
            [-12.349562925248915, 7.352771113888911],
            [-12.345033453489592, 7.353481121599487],
            [-12.343669453425333, 7.362283795117877],
            [-12.337061748106159, 7.375022722743429],
            [-12.34173890541457, 7.380588788180592],
            [-12.340085988571772, 7.38380266922595],
            [-12.335354581364397, 7.386745623645315],
            [-12.335567124652131, 7.391406729750166],
            [-12.33904695139637, 7.394230887745361],
            [-12.335485887280123, 7.402372735057305],
            [-12.334429568154652, 7.411752514384229],
            [-12.337875905954009, 7.411773571959108],
            [-12.344401946367203, 7.413952436935264],
            [-12.345448283407219, 7.420135486150883],
            [-12.344415177783056, 7.423385867310211],
            [-12.348020706047576, 7.430699629648099],
            [-12.351389864440822, 7.42824407733469],
            [-12.353392486766765, 7.41692916416446],
            [-12.36356871095354, 7.41626225408515],
            [-12.368424190412304, 7.410993019954462],
            [-12.368138621595254, 7.408256431937401],
            [-12.382107919976395, 7.407814991864544],
            [-12.38710268849006, 7.400347891577817],
            [-12.384758305286908, 7.397683268593845],
            [-12.398249739585053, 7.383873751200308],
            [-12.401100489640543, 7.3858827728207315],
            [-12.404578410748591, 7.384077954218413],
            [-12.414101307006565, 7.3833698550217335],
            [-12.417248372191082, 7.379607764940408],
            [-12.420074383360804, 7.379361762871553],
            [-12.427991574949273, 7.371843108775794],
            [-12.428750812856576, 7.367867042826436],
            [-12.441073579706401, 7.367402257739117],
            [-12.446344410654227, 7.363286794706017],
            [-12.449839393081646, 7.364153444115058],
            [-12.448727525492297, 7.356935291752261],
            [-12.453239196668042, 7.352516860475317],
            [-12.453744686654076, 7.349585638042972],
            [-12.458537791991784, 7.348884907985886],
            [-12.460261740997673, 7.346699197593564],
            [-12.458958033884253, 7.341655288836215],
            [-12.462598518158309, 7.331122265527232],
            [-12.465350605060422, 7.3301554439473735],
            [-12.469125533227086, 7.325614264476137],
            [-12.474535321036889, 7.323387285232257],
            [-12.478085110119116, 7.326217082776257],
            [-12.484234074527846, 7.319901404598876],
            [-12.492504425585723, 7.325425377601944],
            [-12.498570290623814, 7.317551083319555],
            [-12.50192050494133, 7.319351037701564],
            [-12.506414818147137, 7.31141937424796],
            [-12.503959776590909, 7.308714705769798],
            [-12.504740256944675, 7.303198911269108],
            [-12.50751749190662, 7.300102099280862],
            [-12.503219228473542, 7.294373111953686],
            [-12.500592541238188, 7.296449152440687],
            [-12.496967119813378, 7.29283457262395],
            [-12.494200413590896, 7.292378941360479],
            [-12.49112246341011, 7.287888671383312],
            [-12.487739402649117, 7.285725515710387],
            [-12.490041360725359, 7.277926016798695],
            [-12.494417445850802, 7.273315610810816],
            [-12.4973817270429, 7.266221729532669],
            [-12.500393207028207, 7.262771324896151],
            [-12.502219281466193, 7.251972229794992],
            [-12.505001296232804, 7.247599750950617],
            [-12.508410371213937, 7.24901614300589],
            [-12.51310570799898, 7.246638751295903],
            [-12.516921256086297, 7.246932126406083],
            [-12.521151506181344, 7.238847978177738],
            [-12.525574743609518, 7.238116160031289],
            [-12.52913939689278, 7.240379476898175],
            [-12.535571849247205, 7.236401224511742],
            [-12.540612031867928, 7.23748554542579],
            [-12.542372808043655, 7.232831537267776],
            [-12.549927346115824, 7.2215907980697915],
            [-12.553576957309282, 7.219945516983001],
            [-12.555815676268526, 7.214984156345174],
            [-12.55603280453275, 7.209735806466972],
            [-12.558066908164161, 7.207261671781741],
            [-12.559385094034228, 7.201519519797274],
            [-12.568194519405777, 7.2000492198181085],
            [-12.575665925698972, 7.195620734456276],
            [-12.577968817595053, 7.190472943542888],
            [-12.581015174189, 7.187487213024772],
            [-12.586426858907691, 7.1884878504062995],
            [-12.592571445075112, 7.200079842407888],
            [-12.597370302818112, 7.199241726405471],
            [-12.605566067663272, 7.202273642876653],
            [-12.608934851742617, 7.201859817563751],
            [-12.617010440054415, 7.197156199071362],
            [-12.62717991825019, 7.1848433889260646],
            [-12.631818513858313, 7.182472484255533],
            [-12.638113670184575, 7.182899301542039],
            [-12.644129248473382, 7.181041536552189],
            [-12.648536048649412, 7.182486529019505],
            [-12.65151095879586, 7.185501769699036],
            [-12.652132309813448, 7.191986216864341],
            [-12.654449362996385, 7.194799386456393],
            [-12.667565568658954, 7.20459568529946],
            [-12.66859101927638, 7.209510314552551],
            [-12.662070605575584, 7.215942287895394],
            [-12.658438748910335, 7.2305222297033085],
            [-12.661830585585605, 7.237187813334475],
            [-12.662517299063142, 7.244747455538251],
            [-12.667047863066298, 7.252500761707434],
            [-12.671180802667926, 7.257952341007051],
            [-12.67511417393362, 7.26077425519108],
            [-12.67532648908107, 7.2654662250221484],
            [-12.681847234222555, 7.2679732342502374],
            [-12.685114863433796, 7.271801834383219],
            [-12.688585491195077, 7.272979673905141],
            [-12.696995326600993, 7.279154915354153],
            [-12.706011387023532, 7.277615113050668],
            [-12.713702998327822, 7.278606207999131],
            [-12.715422633112228, 7.27711740381913],
            [-12.722256348049322, 7.276893861392064],
            [-12.726258722090515, 7.279606113732195],
            [-12.734024154465486, 7.274545206035544],
            [-12.742373637596716, 7.276913502121571],
            [-12.749496898757453, 7.281053241618593],
            [-12.750621014020176, 7.284198520795258],
            [-12.747594996329767, 7.2889533821142685],
            [-12.748817181676326, 7.293076911039233],
            [-12.746936265171243, 7.296933264560384],
            [-12.749059323907456, 7.302007578835521],
            [-12.751937356630876, 7.304891090995687],
            [-12.75181507699157, 7.311240530166045],
            [-12.756334358506145, 7.323971322260446],
            [-12.765662571649704, 7.334652359689412],
            [-12.771192045021746, 7.346314470522843],
            [-12.77757894422461, 7.346631544743536],
            [-12.77891296231881, 7.350625490643539],
            [-12.782458850680484, 7.353586437823155],
            [-12.78622313010776, 7.362719859575857],
            [-12.786321102942141, 7.369802463690185],
            [-12.78862175964736, 7.371087106283842],
            [-12.78938535774966, 7.381041349952926],
            [-12.788342506236217, 7.385088298898914],
            [-12.784020338022478, 7.393260962747936],
            [-12.782003938163804, 7.394628233213654],
            [-12.78183854050858, 7.401653380676169],
            [-12.778297415727197, 7.404503865384889],
            [-12.774451859716416, 7.4098230746236595],
            [-12.771848144160973, 7.418880746464487],
            [-12.76481112067631, 7.426530024945653],
            [-12.764433009824007, 7.429641323227331],
            [-12.768459748517396, 7.431481166351037],
            [-12.769700818806747, 7.437983164924988],
            [-12.77225453998938, 7.4422102269778865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.93324900181382,
          "lat": 44.94329428718304
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16059"],
        "coty_name": ["Lemhi"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lemhi County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00399754"
      },
      "bbox": [
        -12.78938535774966, 6.614306437808517, -11.457899440305725,
        8.204642454746939
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.65271482627702, 0.5142245152995298],
            [5.648273632979398, 0.5728726029952785],
            [5.642030802592646, 0.6608037504001402],
            [5.638995522655304, 0.7048663734773447],
            [5.660139066305848, 0.7063754021048685],
            [5.723834393551526, 0.7113493598129552],
            [5.723978023251971, 0.711225131656787],
            [5.724056487082039, 0.710693365233258],
            [5.753634864878436, 0.712580946754979],
            [5.810399457092624, 0.715190091070216],
            [5.847809758259488, 0.7185940343778077],
            [5.8939661117893865, 0.7224723446770259],
            [5.9798124384691915, 0.7286463043386724],
            [5.983010932534893, 0.6847208473288454],
            [5.983166191896612, 0.6800846210932067],
            [5.98618036373061, 0.6416738726587727],
            [5.993836327238336, 0.5374447659723729],
            [6.001946339516856, 0.42184637074752257],
            [6.08874515037854, 0.4315501781374815],
            [6.0943366236484895, 0.342544914829724],
            [6.007944592517666, 0.3340812228311462],
            [5.92079213599902, 0.32744170498667563],
            [5.836485068830488, 0.3196729210988071],
            [5.753656117725374, 0.3149920795474152],
            [5.759860246601178, 0.22647820971342567],
            [5.73920696625609, 0.2262832930014457],
            [5.67747709560969, 0.22610807164968175],
            [5.6702305738947745, 0.2258081348895507],
            [5.663083085583318, 0.3140906571744731],
            [5.656564129182778, 0.39152569150200156],
            [5.6533991224895095, 0.4314079491137395],
            [5.649379826485311, 0.4846197136892477],
            [5.654795072182982, 0.48502597485225374],
            [5.65271482627702, 0.5142245152995298]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.02415478385434, "lat": 39.00017850383948 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17051"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00424227"
      },
      "bbox": [
        5.638995522655304, 0.2258081348895507, 6.0943366236484895,
        0.7286463043386724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.247565496962641, 2.669727140517607],
            [6.2554556084828015, 2.670538286769677],
            [6.245866875994295, 2.757843359076788],
            [6.274467197989074, 2.7608675107813947],
            [6.331398320325618, 2.7672285726041133],
            [6.418340254076641, 2.7761275715573004],
            [6.409416572977851, 2.8632200902435927],
            [6.4958690716471414, 2.8724613248389406],
            [6.58161061463896, 2.8813679028013595],
            [6.698710397442855, 2.8929174575629863],
            [6.770695267892451, 2.9002053432774897],
            [6.78264483883945, 2.767877709754131],
            [6.784077674808474, 2.7509519834158174],
            [6.796807362185515, 2.6116570071108325],
            [6.729722049734291, 2.6038724434605625],
            [6.700744775921355, 2.6010261964844545],
            [6.686411091924876, 2.599061474908777],
            [6.6145285997409955, 2.590614197562306],
            [6.584085182314864, 2.5876485477641897],
            [6.582814840556911, 2.587170947757915],
            [6.516142722054722, 2.579676514248514],
            [6.443040810463026, 2.5706307770166488],
            [6.431978846547441, 2.5695620283417866],
            [6.346320433538796, 2.5601726619031986],
            [6.289223853815443, 2.5532636966831963],
            [6.274655286994159, 2.5521088528741434],
            [6.260524588495152, 2.549861821239515],
            [6.247565496962641, 2.669727140517607]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.86182758061034, "lat": 41.13770526213418 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17091"],
        "coty_name": ["Kankakee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kankakee County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00424247"
      },
      "bbox": [
        6.245866875994295, 2.549861821239515, 6.796807362185515,
        2.9002053432774897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.974730593688753, 2.7154288808723885],
            [7.982019404155106, 2.6590663006782878],
            [7.996554081181015, 2.5397421403858593],
            [8.002339267288146, 2.4887248442451146],
            [8.012799598000807, 2.4025499918237583],
            [8.016975729615716, 2.3671249621112973],
            [8.07279734291452, 2.373784491593026],
            [8.08290946877279, 2.2875254558224865],
            [8.02671549854721, 2.2808008943147198],
            [7.914094888050086, 2.267520974410993],
            [7.85749101592228, 2.260858388086201],
            [7.849795332881764, 2.3323266470055133],
            [7.84868487955972, 2.339634431291482],
            [7.845181462940011, 2.3698962325624393],
            [7.8445757334476784, 2.3729823621566095],
            [7.838188759910533, 2.4414755867716593],
            [7.835782189701315, 2.441864181780931],
            [7.828841749099663, 2.514947636112428],
            [7.82769423421415, 2.528218527890118],
            [7.8239201705803625, 2.5647082996681054],
            [7.818763277363278, 2.6081732191376528],
            [7.818348564315462, 2.6085241823063985],
            [7.81538809088332, 2.63731044360116],
            [7.80977913840773, 2.6949918658899317],
            [7.838398968885614, 2.697949328138327],
            [7.892612913644111, 2.705161759272138],
            [7.974730593688753, 2.7154288808723885]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.04505731208002, "lat": 40.76944317540846 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18103"],
        "coty_name": ["Miami"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miami County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00450373"
      },
      "bbox": [
        7.80977913840773, 2.260858388086201, 8.08290946877279,
        2.7154288808723885
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.629222295228034, 1.0051318024140468],
            [7.629817776938059, 0.9989092160984245],
            [7.647916540814474, 1.0000712700330259],
            [7.7564033915296005, 1.0090475117342625],
            [7.820069925478878, 1.016956510992062],
            [7.8302264764131255, 0.9280227104655328],
            [7.835989888835401, 0.9284306637164271],
            [7.839098772842059, 0.900997405205344],
            [7.844906687277532, 0.8560214078670952],
            [7.847714292921194, 0.8299270527753669],
            [7.8490033753737976, 0.8210384677114129],
            [7.854976004016333, 0.7667312594567791],
            [7.857749217507204, 0.7386917710669292],
            [7.858459189417136, 0.7252088751077015],
            [7.883709549878658, 0.7283607471583583],
            [7.898155635569214, 0.7296968521763202],
            [7.903142197381598, 0.6834464425505673],
            [7.9046091420407425, 0.6715573226641762],
            [7.860578109779402, 0.666896330351022],
            [7.773698414807928, 0.6593607518820818],
            [7.697354210411004, 0.6520319721511441],
            [7.691378154755634, 0.6512305279486059],
            [7.625028568610998, 0.6450765946292321],
            [7.614871726306248, 0.7471459881335836],
            [7.60734461313498, 0.819177378755937],
            [7.601154702167026, 0.875754050862477],
            [7.588529556762973, 0.9900593178333827],
            [7.602853685823474, 0.9848142954400625],
            [7.605965481551274, 0.9899487328342758],
            [7.609578267849361, 0.9861027320410923],
            [7.611934469224836, 0.9877317101956596],
            [7.611221123491395, 0.9963049348507866],
            [7.60789264604274, 1.0003776097870918],
            [7.607866904991787, 1.006406840384606],
            [7.611255902294526, 1.010853847491875],
            [7.614112442908128, 1.0123325053967651],
            [7.621802265826789, 1.0057423815921838],
            [7.627159304187139, 1.006525327720742],
            [7.629222295228034, 1.0051318024140468]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.52312706126833,
          "lat": 39.160890834698485
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18105"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00451680"
      },
      "bbox": [
        7.588529556762973, 0.6450765946292321, 7.9046091420407425,
        1.016956510992062
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.802251759526927, 1.5043802945287137],
            [8.800693522826716, 1.518926767081061],
            [8.850152726753587, 1.5243812014952782],
            [8.850097146888922, 1.5221673978121777],
            [8.881745733990883, 1.5257053157081761],
            [8.967524278580326, 1.535764437213562],
            [8.978907095781993, 1.4373798334522856],
            [8.985694026893787, 1.3771002950079343],
            [8.985933183521443, 1.3764790361931085],
            [8.991034458565995, 1.3305806916247418],
            [8.96552524581601, 1.3288391282843992],
            [8.90447072874077, 1.3228971901943065],
            [8.890853498999494, 1.321124676357432],
            [8.833297794547223, 1.3145824584079477],
            [8.833354512671086, 1.3163608217633385],
            [8.823013045118723, 1.3152504951913502],
            [8.82117645949014, 1.3295703103421632],
            [8.812991431114877, 1.4027296777232823],
            [8.811121125237866, 1.4245116647589946],
            [8.802251759526927, 1.5043802945287137]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.92517835806788, "lat": 39.62558446022845 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18161"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00450395"
      },
      "bbox": [
        8.800693522826716, 1.3145824584079477, 8.991034458565995,
        1.535764437213562
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9092906098575911, 4.240726251990105],
            [0.9960095038613388, 4.241412367071672],
            [1.0437660987880613, 4.2416385853374186],
            [1.1111321194749093, 4.242304498178286],
            [1.15312362744245, 4.2424982675533185],
            [1.2546796888705478, 4.2436054281907065],
            [1.2553405162725653, 4.189116948181221],
            [1.256667230105988, 4.067786346636811],
            [1.256413541320953, 3.99837916034897],
            [1.256474374689761, 3.980153085699462],
            [1.2582608618220052, 3.893011830305959],
            [1.1717228630228602, 3.892795289011033],
            [1.0564195541572088, 3.8917529589716944],
            [0.9695972964921757, 3.890809963540484],
            [0.9116711510812587, 3.891362562222825],
            [0.9109856583825869, 3.977747979894297],
            [0.9109255303368897, 4.064567091913687],
            [0.9101550872539018, 4.1524355830817195],
            [0.9096028900997921, 4.196072426120764],
            [0.9092906098575911, 4.240726251990105]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.15112197531947, "lat": 42.73548712805438 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19021"],
        "coty_name": ["Buena Vista"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buena Vista County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00465200"
      },
      "bbox": [
        0.9092906098575911, 3.890809963540484, 1.2582608618220052,
        4.2436054281907065
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.961407187811837, 4.588111759258915],
            [2.9971331153481193, 4.58932937604815],
            [3.0610788377948372, 4.592027793454548],
            [3.132965130283952, 4.594660687453242],
            [3.1468674711295366, 4.595067906335447],
            [3.1615771456083994, 4.596535254845094],
            [3.2188050176686422, 4.598062974707294],
            [3.3043816371527672, 4.601498084235351],
            [3.3060475448083655, 4.557722308491409],
            [3.3079379390968002, 4.5147300708244265],
            [3.3096520168040198, 4.471167954341091],
            [3.3115559809858857, 4.4189846582741055],
            [3.3120514408695607, 4.411564779840718],
            [3.3130218161014287, 4.382411957909598],
            [3.314913678110587, 4.338619520544624],
            [3.316631253057237, 4.295058013149393],
            [3.284909349036622, 4.293478334311817],
            [3.187744583867595, 4.2897998816563545],
            [3.1306860807355297, 4.287709926146468],
            [3.058624546409878, 4.284952524414933],
            [2.9889096773755233, 4.28258830925395],
            [2.9726717796485995, 4.281862599704447],
            [2.968518808106528, 4.398233577946127],
            [2.9648714671913665, 4.499284894629849],
            [2.9629320529573544, 4.5445458345940795],
            [2.961407187811837, 4.588111759258915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.31764485780586, "lat": 43.06004489746864 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19037"],
        "coty_name": ["Chickasaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chickasaw County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00465208"
      },
      "bbox": [
        2.961407187811837, 4.281862599704447, 3.316631253057237,
        4.601498084235351
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.316631253057237, 4.295058013149393],
            [3.314913678110587, 4.338619520544624],
            [3.3130218161014287, 4.382411957909598],
            [3.3120514408695607, 4.411564779840718],
            [3.3115559809858857, 4.4189846582741055],
            [3.3096520168040198, 4.471167954341091],
            [3.3684347685611162, 4.473371921333511],
            [3.423404521514958, 4.475640264835183],
            [3.4247578185997747, 4.475534629961195],
            [3.4742358797526243, 4.477256444859836],
            [3.5679997012808924, 4.481248445082114],
            [3.605886513749557, 4.483014998626969],
            [3.655031244465157, 4.485091970446816],
            [3.6566622999307192, 4.447206025434831],
            [3.6596268311683007, 4.373845271727364],
            [3.661234175493755, 4.33097092543245],
            [3.6650875426203147, 4.239721161636152],
            [3.665765300785712, 4.214135752635208],
            [3.6686093773252253, 4.1632307264683],
            [3.670838936503369, 4.126801328286468],
            [3.674100019117443, 4.046497038396159],
            [3.5872306309754407, 4.041655245918269],
            [3.5240198726775276, 4.039379159092684],
            [3.500308434594658, 4.0383474828151025],
            [3.465125206440189, 4.036020468061664],
            [3.4432285827207054, 4.034078952800403],
            [3.4136873465559097, 4.033170086310006],
            [3.327548954277465, 4.029446683623654],
            [3.3239159892303327, 4.117384128846036],
            [3.3230872213980445, 4.135480135620047],
            [3.320305415092499, 4.206270130588845],
            [3.3195366700643127, 4.219245565262843],
            [3.3186110885050066, 4.250017823837814],
            [3.317800542374651, 4.264623148633974],
            [3.316631253057237, 4.295058013149393]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.84437011909107,
          "lat": 42.862613463702864
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19065"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00465221"
      },
      "bbox": [
        3.3096520168040198, 4.029446683623654, 3.674100019117443,
        4.485091970446816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.948365127990015, 3.9021127910947393],
            [2.005488424108025, 3.9031518408759784],
            [2.0347150892962946, 3.9033604570957596],
            [2.1215331664184287, 3.905467373859929],
            [2.243677538726396, 3.9084309172087655],
            [2.2938392827723795, 3.9098854698548973],
            [2.2964187749755767, 3.8228430694784272],
            [2.32313746490511, 3.823376049375396],
            [2.3241116158971127, 3.779464590381925],
            [2.326804697303608, 3.6769750974922304],
            [2.3276506749361596, 3.647854794267519],
            [2.3298642271901215, 3.5607697813787462],
            [2.250762174166556, 3.558549807010926],
            [2.2142966458143714, 3.5578047253252416],
            [2.1567833404700893, 3.556408837562362],
            [2.0704794799182453, 3.5546350258916],
            [1.9852670494174494, 3.5530445775321],
            [1.9833253534473603, 3.632976522685196],
            [1.9829557039300887, 3.6571033599847045],
            [1.9812204732060097, 3.7276085787927906],
            [1.9794492765749678, 3.8162800411742164],
            [1.9502016125998463, 3.8157223179660402],
            [1.9495266428636073, 3.8517256619220066],
            [1.948365127990015, 3.9021127910947393]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.70677545785851,
          "lat": 42.383768784990984
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19079"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00465228"
      },
      "bbox": [
        1.948365127990015, 3.5530445775321, 2.3298642271901215,
        3.9098854698548973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.611834002136658, 4.863806269746852],
            [2.680184474162066, 4.86605739609835],
            [2.8255470565177587, 4.871172211362291],
            [2.95184296822753, 4.875784267063681],
            [2.955292796387252, 4.761047812793002],
            [2.9595526642772914, 4.6356516159607954],
            [2.961407187811837, 4.588111759258915],
            [2.861093678026678, 4.5842472589775625],
            [2.8180806668354643, 4.5830849707826795],
            [2.7758662785334973, 4.581419777135416],
            [2.707341390151198, 4.579341120665217],
            [2.667816982925953, 4.577904608509398],
            [2.6210422408709753, 4.576644934028374],
            [2.6196608186625796, 4.619431354644233],
            [2.6169667506456453, 4.70633730855867],
            [2.614702461539715, 4.775482709550255],
            [2.613958965035254, 4.793432977141322],
            [2.611834002136658, 4.863806269746852]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.78906513060184, "lat": 43.35640026399249 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19131"],
        "coty_name": ["Mitchell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mitchell County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00465254"
      },
      "bbox": [
        2.611834002136658, 4.576644934028374, 2.961407187811837,
        4.875784267063681
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.1896319588869849, -0.18103621574785198],
            [0.19000173527121175, -0.13099427872647565],
            [0.19049536363977576, -0.09295117333564654],
            [0.19035662854828306, -0.07822834205254814],
            [0.1908449006264658, -0.005521937604847827],
            [0.19135042975826796, 0.0384422368635988],
            [0.20513308209965003, 0.03860141114130909],
            [0.2584065118635119, 0.0380857459944268],
            [0.36243805029032156, 0.03805530460082249],
            [0.4339589769448833, 0.03788139832970695],
            [0.5055132135146906, 0.038040720400936014],
            [0.5057416341940282, -0.006133919457953998],
            [0.5026552155762872, -0.006113404989784139],
            [0.5027700553567414, -0.06227528847050529],
            [0.5026456634392598, -0.13864829637954426],
            [0.5024422688838406, -0.18481794880965344],
            [0.5025274408979306, -0.22591864358064975],
            [0.5023078125091002, -0.269943978489327],
            [0.5021627862925682, -0.357938302971756],
            [0.5026238799363892, -0.4460485655487345],
            [0.49600819851355643, -0.44603963273656805],
            [0.49576707232485123, -0.5356868298009353],
            [0.4114883840508193, -0.5347382411850613],
            [0.38292775249671673, -0.5347054931045048],
            [0.276631759029083, -0.5335497295756121],
            [0.18559773944436853, -0.5334331797618892],
            [0.1861725526083271, -0.5034902131292393],
            [0.18682799312741874, -0.44487154758364106],
            [0.1873521097039733, -0.44486442142200117],
            [0.1882415729018745, -0.3089340898012716],
            [0.18908335903047285, -0.23946605513800515],
            [0.1896319588869849, -0.18103621574785198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.15263342396881, "lat": 38.45617837812281 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20111"],
        "coty_name": ["Lyon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lyon County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00485020"
      },
      "bbox": [
        0.18559773944436853, -0.5356868298009353, 0.5057416341940282,
        0.03860141114130909
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.649584232495439, 0.9918311295193522],
            [-3.6036779103550765, 0.9891665831039768],
            [-3.521968399611319, 0.9845606968710117],
            [-3.4929156534836334, 0.9831095031066974],
            [-3.439939474424774, 0.9799450975556794],
            [-3.3827558610745023, 0.9768387309964174],
            [-3.3257976137161402, 0.9738661897116365],
            [-3.257924145776124, 0.9701944480449994],
            [-3.234542429623672, 0.9688180579228229],
            [-3.212453157786008, 0.9678886632827821],
            [-3.1552900886040747, 0.9651390769289601],
            [-3.1395323562708572, 0.9643451456878989],
            [-3.139515194326597, 0.9615370925404266],
            [-3.144055823388066, 0.8772305874850743],
            [-3.1485818335136724, 0.7889775194203313],
            [-3.150585809997218, 0.7531250671134513],
            [-3.1556062102711726, 0.6574410112222494],
            [-3.159374778870824, 0.5845650849648408],
            [-3.1621461951131793, 0.5261790944024106],
            [-3.231638685498368, 0.5296457960542386],
            [-3.3337546181708326, 0.5345731476853758],
            [-3.418983137204342, 0.5391289012874482],
            [-3.4454339053526315, 0.5406917033071018],
            [-3.4874144722991045, 0.5435225417354184],
            [-3.5573322522304514, 0.5486348980637578],
            [-3.6154104480965374, 0.5522139382925372],
            [-3.676402297391418, 0.5553182260607753],
            [-3.668655877136498, 0.6865756927200789],
            [-3.6661063317951457, 0.7303748946164423],
            [-3.6607804223070093, 0.8179465070219876],
            [-3.6578672588028387, 0.8618657292228378],
            [-3.649584232495439, 0.9918311295193522]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.05554413066824,
          "lat": 39.350930823849126
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20193"],
        "coty_name": ["Thomas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Thomas County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "00485057"
      },
      "bbox": [
        -3.676402297391418, 0.5261790944024106, -3.139515194326597,
        0.9918311295193522
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.722169059606712, 0.5044214037402802],
            [-2.7079140893591234, 0.5035203917867503],
            [-2.6505372350129437, 0.5010466513712204],
            [-2.636030349088734, 0.5002025268537984],
            [-2.5914893983766443, 0.4986996919769494],
            [-2.536987287035689, 0.4962923555946788],
            [-2.5039022493268805, 0.4951604989214925],
            [-2.478775325419606, 0.4940620465760307],
            [-2.391380785663278, 0.49082553759043085],
            [-2.305500108344938, 0.4877229810233722],
            [-2.2952084055136184, 0.48720787467927384],
            [-2.2981800510908696, 0.4331761537079508],
            [-2.298223109409966, 0.4288233176369465],
            [-2.3003549340716907, 0.38906775344511135],
            [-2.30341891414659, 0.3254072593321734],
            [-2.3049413227556075, 0.2904493840937846],
            [-2.3100544285995137, 0.17917945869376883],
            [-2.314677719944346, 0.08642972774042298],
            [-2.316891508077201, 0.04765953251779183],
            [-2.363725840756015, 0.049398961991442426],
            [-2.4446758252216796, 0.05264950501678059],
            [-2.4456546026195234, 0.052975282204896605],
            [-2.4734614228499368, 0.05427669650900452],
            [-2.4774863235564997, 0.05400433568037425],
            [-2.548886748922535, 0.05678888978574931],
            [-2.648036536642896, 0.060700017318276255],
            [-2.6746874838311108, 0.06205205502534476],
            [-2.7458668364697627, 0.0659994724505865],
            [-2.7378809873336083, 0.21218271905061858],
            [-2.7366030374950934, 0.24117195702864624],
            [-2.72895957820861, 0.3730289738559244],
            [-2.722169059606712, 0.5044214037402802]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.87281865228306,
          "lat": 38.914299891539024
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20195"],
        "coty_name": ["Trego"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trego County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "00485058"
      },
      "bbox": [
        -2.7458668364697627, 0.04765953251779183, -2.2952084055136184,
        0.5044214037402802
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.686859267054123, 0.4970168881381038],
            [8.707567512668103, 0.5047838901522975],
            [8.719801085914984, 0.5069913671395223],
            [8.73599392904635, 0.506598281030519],
            [8.743596028649213, 0.5050269525665423],
            [8.753823557292787, 0.5001431177811305],
            [8.76416530144046, 0.48727599045238196],
            [8.772351334183186, 0.47587574268196803],
            [8.776833190948764, 0.4713964105008926],
            [8.783504660421865, 0.46655605963512453],
            [8.79307381987081, 0.4631823078538861],
            [8.803310960104236, 0.46082531698792334],
            [8.81523575956099, 0.46263475856270353],
            [8.827721378709976, 0.4683622708959287],
            [8.841746957846595, 0.47808620945396285],
            [8.845052501282671, 0.4811895278283566],
            [8.849551158483298, 0.487751526960974],
            [8.86225158489638, 0.5013322502757682],
            [8.865805457039144, 0.5075977287066622],
            [8.868516550012433, 0.5088877639671301],
            [8.881391742889459, 0.5199151287613727],
            [8.886690606277538, 0.5252683127903108],
            [8.900912710878533, 0.5335930511464884],
            [8.90889130699289, 0.5416549259675737],
            [8.921519228633302, 0.5501723387478487],
            [8.921845273569007, 0.5494217233013438],
            [8.951651975394993, 0.5089819971119688],
            [8.977776355450677, 0.4728382958562364],
            [9.001428751405616, 0.4578555805544332],
            [8.999876829934584, 0.449840232963418],
            [9.00087553122787, 0.44630030957828304],
            [8.99398188489876, 0.4450666213365135],
            [8.98991375589464, 0.44320180157431543],
            [8.98685721949372, 0.447131846550481],
            [8.982980170003136, 0.4441369341332647],
            [8.97584177765256, 0.44124791651518147],
            [8.97693813999448, 0.4383362229103031],
            [8.973619785112412, 0.4286754114608415],
            [8.967882417116686, 0.4284940280317785],
            [8.965602665542102, 0.42421427535679684],
            [8.960798783587457, 0.4212155489486948],
            [8.949801143474927, 0.4233097705644755],
            [8.94609932166477, 0.4207562641382206],
            [8.942511171737658, 0.4205022881422873],
            [8.942452613246852, 0.4163572957005925],
            [8.945681941886171, 0.4138676900574799],
            [8.945834434414607, 0.41097817256889413],
            [8.93982889057011, 0.40801835370886275],
            [8.938056010299892, 0.4017533108019062],
            [8.935667348628503, 0.40004911758620415],
            [8.926137309556525, 0.3966433410976925],
            [8.919015293619461, 0.3997952356184593],
            [8.91733116364975, 0.3973580216233944],
            [8.911101326688938, 0.3953994309888618],
            [8.909739417327359, 0.39186328457999153],
            [8.905246234175367, 0.3878149390868183],
            [8.90924811714713, 0.3840285696189856],
            [8.906451294596662, 0.3773840670297205],
            [8.901415217747891, 0.37986297658015816],
            [8.830683750305932, 0.3601550873050608],
            [8.798129224006164, 0.3511190533707135],
            [8.794132131102117, 0.35571947456189673],
            [8.790560373608368, 0.3663218126949477],
            [8.793707779356247, 0.3720890481727759],
            [8.78875211767197, 0.37762708745807366],
            [8.78706028380164, 0.38232565685033776],
            [8.779311907100256, 0.3871894298229134],
            [8.778073515456494, 0.3902293660668477],
            [8.779161525898799, 0.39663257082436826],
            [8.752895747334433, 0.4233099864691148],
            [8.69064985314739, 0.4868921800563486],
            [8.686859267054123, 0.4970168881381038]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.12357177008249,
          "lat": 38.667808973821266
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21041"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00516867"
      },
      "bbox": [
        8.686859267054123, 0.3511190533707135, 9.001428751405616,
        0.5501723387478487
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.269798014508147, 0.26832855291527224],
            [10.274932831036011, 0.26772991969169624],
            [10.278424357304347, 0.27102122373558474],
            [10.280455069678395, 0.28010447382855275],
            [10.290265039230537, 0.28553423526704924],
            [10.292987439573364, 0.2827658661262461],
            [10.296930833835848, 0.2838621521526079],
            [10.305348487572898, 0.2836447969582297],
            [10.31467874465622, 0.27916588913720475],
            [10.31946314354186, 0.2795370211723893],
            [10.321489180479203, 0.2819374036400681],
            [10.326336945220925, 0.2825763482120912],
            [10.327851321860477, 0.28687450891368504],
            [10.332218275491249, 0.2863628886529945],
            [10.34075180760906, 0.2892658473075423],
            [10.340990723235306, 0.2925709640635187],
            [10.345516088484121, 0.2940899076761657],
            [10.352371954088703, 0.2998053607016039],
            [10.353060634956739, 0.3046254627745732],
            [10.347963800014545, 0.30839663485568547],
            [10.34614352857061, 0.3077624772676098],
            [10.34322216756861, 0.31522197479514047],
            [10.346656586309292, 0.32986987546727686],
            [10.34627035394168, 0.3343102761670276],
            [10.343300950863258, 0.340046201204518],
            [10.342532792317849, 0.3487339456524732],
            [10.338693260733104, 0.36353510505836345],
            [10.340153084807131, 0.3704940806049846],
            [10.3367347463075, 0.37596860715613356],
            [10.338061506917764, 0.3828260179999605],
            [10.335525612336756, 0.3861414020100223],
            [10.338095720380727, 0.3885978686061509],
            [10.341898846882636, 0.3883252671267283],
            [10.343124552723094, 0.3935724983968784],
            [10.347510672799709, 0.39329447196178213],
            [10.350323899730066, 0.40228534871338445],
            [10.354102862671304, 0.40192765372867684],
            [10.356363637610187, 0.40394359171877064],
            [10.351373529245485, 0.41016137385160856],
            [10.34994329230432, 0.4166746346496526],
            [10.360052546854357, 0.4173241993964824],
            [10.361729939199822, 0.42044642816878464],
            [10.36079479333655, 0.42873245726228837],
            [10.363303908381056, 0.42902361881417983],
            [10.364647616353134, 0.43360476738623166],
            [10.368749622857194, 0.43440966802437],
            [10.367820792545034, 0.4401612750991496],
            [10.365133260243546, 0.44160959197932687],
            [10.367179663525372, 0.44758127091616173],
            [10.366802522163947, 0.45593785294425926],
            [10.363914655843834, 0.45883241602394065],
            [10.36664233254756, 0.4608837257086779],
            [10.368864893887958, 0.46658698032185675],
            [10.371407257878813, 0.46911880034001696],
            [10.376366741314518, 0.4672405498241532],
            [10.379414851811992, 0.4710509425455741],
            [10.38578552933703, 0.47185961955497197],
            [10.38858741014966, 0.4687340572831414],
            [10.39582619378451, 0.4677926898652552],
            [10.39858219453551, 0.4655202449787428],
            [10.401932545196487, 0.4673866966097717],
            [10.405639345483802, 0.46552112847995225],
            [10.410514633056936, 0.4604152876686234],
            [10.416612604806128, 0.45746153911711784],
            [10.420779099762859, 0.4580663867649232],
            [10.422544426132678, 0.45583892447515323],
            [10.430374459712, 0.45377165284647825],
            [10.43560321766664, 0.4575369186511216],
            [10.440598548597563, 0.4559997549016291],
            [10.443100899260637, 0.45269630801398253],
            [10.446396530022433, 0.4539051051120074],
            [10.448989560831107, 0.45008425065733776],
            [10.453724830389424, 0.4505404231474148],
            [10.461232987732306, 0.44365630748685536],
            [10.464529504982284, 0.44508411988214047],
            [10.469622680894613, 0.44320640947652096],
            [10.472917976828358, 0.4443460129700802],
            [10.517692571249924, 0.40454341104090513],
            [10.517820084147372, 0.4008283422413523],
            [10.522995332779514, 0.39519358180296577],
            [10.526283301317147, 0.3975279590517167],
            [10.530715983033488, 0.3954017450744967],
            [10.530999246951543, 0.39097518138323106],
            [10.533516895578298, 0.3881224748454711],
            [10.542343259179782, 0.3863364016087839],
            [10.547205205145962, 0.38209086930061426],
            [10.550743804770779, 0.3815384691628214],
            [10.55530635887465, 0.3834160752048492],
            [10.56161802490096, 0.3899505557104776],
            [10.566175279738468, 0.3896008683467159],
            [10.568474040114534, 0.39268838065697115],
            [10.572593031378732, 0.3895149347074153],
            [10.57638782548131, 0.389020626582459],
            [10.585378402136532, 0.39031947055035865],
            [10.588765305988494, 0.3927419140308066],
            [10.665482723629625, 0.377910356049224],
            [10.69079741809453, 0.372998011790023],
            [10.702223584196808, 0.37147871795519],
            [10.702444863493419, 0.3672292748784712],
            [10.699177434476011, 0.361831536110179],
            [10.697146005708115, 0.35328099536828556],
            [10.698703305175576, 0.34459355113672885],
            [10.69813794878804, 0.34283304383928764],
            [10.70156220518726, 0.2502372684705244],
            [10.701672928597253, 0.24703072313517072],
            [10.689599047197829, 0.24305635252462285],
            [10.687607577248556, 0.2382461069661084],
            [10.682379559595113, 0.23630197037857198],
            [10.680981815105204, 0.23146473459558914],
            [10.68855120911532, 0.22720710534632993],
            [10.690966030607036, 0.22453443151038363],
            [10.683878783391735, 0.2112936213207824],
            [10.675978884766591, 0.2071636497633432],
            [10.671956697337603, 0.20314566111312998],
            [10.67101084335418, 0.20027428884201207],
            [10.665516701123535, 0.19229156040769313],
            [10.662981400380357, 0.1901880181968757],
            [10.651797825452539, 0.19256644924511201],
            [10.648299635189202, 0.19036729602752062],
            [10.639207490265514, 0.1928680362563951],
            [10.63740912172797, 0.18784193555495698],
            [10.632564078828592, 0.18392942293375286],
            [10.630438727214653, 0.17816190596322257],
            [10.628016935319994, 0.17790547422986305],
            [10.619906988150346, 0.17292747733193262],
            [10.614573581279027, 0.1720855887573265],
            [10.610465757004839, 0.16756230387525073],
            [10.597409705103146, 0.16033263427483263],
            [10.59581853079904, 0.1586243189767166],
            [10.591437037154755, 0.16185382379362487],
            [10.585727617954735, 0.1635769538239684],
            [10.574483189303276, 0.16104434308341437],
            [10.57162415582833, 0.15901596921844416],
            [10.559811610092048, 0.16527573010618254],
            [10.558591415372586, 0.16977015548533006],
            [10.55908770817157, 0.17458052896238238],
            [10.549459039368978, 0.17691721832113488],
            [10.544651938286817, 0.1759510024352707],
            [10.539960871483956, 0.1823676480897929],
            [10.539419385732113, 0.18899008056832484],
            [10.531095180734034, 0.1788750202352547],
            [10.527447512906413, 0.1770641988965293],
            [10.5211307500412, 0.180224166762369],
            [10.518397213593884, 0.17992039227330778],
            [10.516153274225228, 0.17506251800234113],
            [10.513298416177463, 0.1728811435674721],
            [10.514870736322335, 0.1664511606810011],
            [10.511519654615613, 0.1613989001485216],
            [10.508147986152967, 0.16327596373285228],
            [10.50956051030713, 0.16837216641121613],
            [10.503817647894428, 0.16970933156966697],
            [10.501136999764585, 0.1754983592713338],
            [10.493262385268343, 0.18130611267275282],
            [10.48967892149886, 0.18299074442611774],
            [10.488117803857188, 0.18713940938548876],
            [10.481108330000195, 0.19553299319657344],
            [10.481422121948073, 0.19833183097231724],
            [10.47423398359086, 0.202707171973741],
            [10.467282386735684, 0.19978035778631661],
            [10.462561688990036, 0.20678885195838537],
            [10.454724920970653, 0.20842542718036888],
            [10.45165832635769, 0.20587108387155392],
            [10.439228267788522, 0.21226207561034674],
            [10.421508907147407, 0.22692700626679704],
            [10.418988538375226, 0.2311794244181695],
            [10.41383437390911, 0.23289107100502304],
            [10.404487554392711, 0.23282207082587583],
            [10.40384751806983, 0.22686640078993742],
            [10.398023397181772, 0.2231595750320187],
            [10.398616287270329, 0.21746401133903046],
            [10.395052709426471, 0.21447691982953165],
            [10.389996939825613, 0.2125147249332985],
            [10.385790635188746, 0.21337043371620368],
            [10.386640931545681, 0.20884903813145694],
            [10.38144044379769, 0.20460160358556623],
            [10.377644312660152, 0.19900899883780018],
            [10.37579540226584, 0.19376771660217298],
            [10.374031236505822, 0.1824993649725274],
            [10.375827317768602, 0.17258077087105111],
            [10.37737824719345, 0.1710643539842333],
            [10.369887112678114, 0.15875077449111652],
            [10.370117863777738, 0.15301038326929112],
            [10.361700113426437, 0.15114576506486085],
            [10.360620165646791, 0.1500003442691198],
            [10.353819079986728, 0.15200182344448962],
            [10.347447637679231, 0.1474885521224302],
            [10.344234745778694, 0.15028551817913455],
            [10.339026184949152, 0.15098778748493297],
            [10.337546964334505, 0.15773663686878076],
            [10.33300931378611, 0.1579223451416365],
            [10.32732356829262, 0.1604379380385627],
            [10.32725013475092, 0.16750034233574856],
            [10.324411322037147, 0.16966460634564842],
            [10.321994433049001, 0.16435090612811026],
            [10.316654933954288, 0.1621433033295159],
            [10.31735932015412, 0.17135100565675712],
            [10.309184235905343, 0.17755566028408346],
            [10.306868669016149, 0.18509913279346138],
            [10.308195989056523, 0.18608542251068913],
            [10.301987943882546, 0.1957225477322583],
            [10.304607066100623, 0.2044637369532608],
            [10.301407292780384, 0.20448123933612522],
            [10.295046717935902, 0.2116039769261761],
            [10.294394485672699, 0.21604831959968676],
            [10.295797315044167, 0.21914445216260064],
            [10.292218513027468, 0.22083426575937753],
            [10.289142084019957, 0.2282523555694695],
            [10.286628518208301, 0.22815661859607672],
            [10.282164868158599, 0.23195837719430004],
            [10.279125418902085, 0.23639545047653168],
            [10.285339437782408, 0.24051447189324401],
            [10.281672556063086, 0.24596963752071033],
            [10.277539722849504, 0.2492422632369568],
            [10.27581170817128, 0.2580914465887363],
            [10.269798014508147, 0.26832855291527224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.04953594722816, "lat": 38.31819651444209 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21043"],
        "coty_name": ["Carter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carter County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00516868"
      },
      "bbox": [
        10.269798014508147, 0.1474885521224302, 10.702444863493419,
        0.47185961955497197
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.269815138308404, -0.37142205788000304],
            [9.278077195680414, -0.36630620677390435],
            [9.28479540127157, -0.3569417517833911],
            [9.294144846758995, -0.35342274220392056],
            [9.296972295571189, -0.35356344644457105],
            [9.300388274651377, -0.35673142452959],
            [9.301781080470079, -0.3654239139237453],
            [9.300575823751037, -0.3707569917993655],
            [9.300156952182737, -0.3807077133635673],
            [9.303627971743959, -0.3924831731419518],
            [9.307238839555518, -0.39663252469593135],
            [9.310991072417044, -0.3986555143998873],
            [9.315830666263786, -0.39884450904615804],
            [9.320221825667963, -0.3973966567713454],
            [9.324239780906321, -0.39304286174361414],
            [9.32522157709854, -0.38866568046084754],
            [9.323724095213748, -0.38589389516732703],
            [9.317996129438223, -0.380196975087903],
            [9.314908534378795, -0.3755430059575978],
            [9.315171029685954, -0.3723231350842661],
            [9.323131606236155, -0.37087506988281843],
            [9.328983055197748, -0.3730855367092134],
            [9.3491426573645, -0.3735303400241229],
            [9.35509596392764, -0.3764111312050012],
            [9.357253969133287, -0.38143100493506177],
            [9.35677216307579, -0.38397482266765914],
            [9.351328205418321, -0.38576327372188507],
            [9.342594956423541, -0.38137755903287934],
            [9.33856899693758, -0.38207105556146337],
            [9.330473058900255, -0.38806076427988756],
            [9.329134760484987, -0.39183603895597713],
            [9.331788303516499, -0.40192292411110914],
            [9.33609506874032, -0.40604553353763817],
            [9.338969862688202, -0.4065931538085217],
            [9.34378791077921, -0.4045617205439456],
            [9.3572661650367, -0.4104472587842785],
            [9.363867253876279, -0.4174035460425997],
            [9.363620479205693, -0.42129213982552316],
            [9.356138055133446, -0.4292902987197851],
            [9.358119178755027, -0.43219260291594713],
            [9.36414707945274, -0.43365759733141873],
            [9.366078627202162, -0.4324983460295949],
            [9.367365064981255, -0.4268764428176487],
            [9.370907593488957, -0.4223545997765793],
            [9.375304097149977, -0.42103921868451866],
            [9.379960537645019, -0.42408717620821473],
            [9.37780822480845, -0.4323434504534877],
            [9.380240587448329, -0.4395980093713378],
            [9.387059936539687, -0.44346384554966223],
            [9.394195292118875, -0.4446433515247233],
            [9.399155917816577, -0.4358018167472421],
            [9.400620677757255, -0.4282747434754381],
            [9.403319984198873, -0.4226762739533452],
            [9.407710986104119, -0.4192835511708535],
            [9.413798341134557, -0.4169086927949595],
            [9.415540855108121, -0.41390438522997053],
            [9.414020363371947, -0.4056195546660706],
            [9.414407873586475, -0.4023816882811301],
            [9.419453021615318, -0.3985324087029788],
            [9.42396590597139, -0.3995546035675699],
            [9.433673085026053, -0.4008614012483164],
            [9.43552818729787, -0.4026562881810462],
            [9.433801687614334, -0.41069345724435724],
            [9.436890313678283, -0.41369449370015104],
            [9.442902825401054, -0.41287136249568307],
            [9.444221212513412, -0.41759177268599296],
            [9.446972853873497, -0.4194697176093793],
            [9.450865312509665, -0.41870233644093846],
            [9.452337540346974, -0.42597960452350164],
            [9.446436053198354, -0.4302820218079635],
            [9.445624267456136, -0.43260537756357653],
            [9.45098744437818, -0.4367892007398803],
            [9.451272855637503, -0.44011542552800864],
            [9.454752276991062, -0.44126178429035506],
            [9.456180269417514, -0.43688378326927413],
            [9.462389515771696, -0.44497494861054465],
            [9.462358267497674, -0.45426519509152635],
            [9.46401642042423, -0.45634600927390084],
            [9.471210981241862, -0.4562936083898659],
            [9.475442530572224, -0.4622333882466429],
            [9.484569792540054, -0.4681739369232038],
            [9.490622196761452, -0.46406286487294496],
            [9.49211715314838, -0.46593624272921647],
            [9.489449165280165, -0.47122636618505587],
            [9.48179765078411, -0.4763298531723907],
            [9.481655079739962, -0.479659461247687],
            [9.485140021834658, -0.48057205953058735],
            [9.488745192710102, -0.48645346354421976],
            [9.492882081758795, -0.4871854674624151],
            [9.49542404563772, -0.4821965476457182],
            [9.499668064497982, -0.4835020513682997],
            [9.497656077503049, -0.49048132021544766],
            [9.501787554838108, -0.49879032180389804],
            [9.504907546783679, -0.4989359443860532],
            [9.50239047801183, -0.5062313603185276],
            [9.509144362339486, -0.507696694574982],
            [9.523105758710248, -0.5174756384537418],
            [9.51837385732573, -0.519123123534231],
            [9.51709247191903, -0.5223186364396387],
            [9.521865231415072, -0.5266684026376616],
            [9.52807896752117, -0.52549742845911],
            [9.529023040520578, -0.5282048317610174],
            [9.524901583679176, -0.5303455226461319],
            [9.528227252395135, -0.5359820689240014],
            [9.524779086909314, -0.5375590263923153],
            [9.524900900780608, -0.5414383733105358],
            [9.530855252945575, -0.5414293219873142],
            [9.535685846111782, -0.5397630019864561],
            [9.54115113941479, -0.5418029812699136],
            [9.542614121976104, -0.551815184629296],
            [9.544353401372703, -0.5572683712990625],
            [9.55100987885037, -0.5570801731715302],
            [9.553910225023662, -0.5605818274664749],
            [9.5571966404271, -0.5593154555502029],
            [9.562202778970226, -0.5597115397076298],
            [9.565143579812132, -0.5671694759990574],
            [9.567678044108643, -0.5696291429999129],
            [9.566474133128363, -0.5738944515170061],
            [9.56879114409366, -0.5788469317229668],
            [9.56981865491027, -0.5842051773861],
            [9.57299535693683, -0.5839670482495881],
            [9.575747448414477, -0.586691736839061],
            [9.575708006520413, -0.5904842595573903],
            [9.580153770257587, -0.5941724208574679],
            [9.580339130348074, -0.5964875291590886],
            [9.585897117133017, -0.6003640561227982],
            [9.585767829180234, -0.6060834093366958],
            [9.58735629930261, -0.6110794482969224],
            [9.590603543827397, -0.6135993025932979],
            [9.590497779180621, -0.6183594321928528],
            [9.588288122203863, -0.6316529766239112],
            [9.583203664607232, -0.6403455706931998],
            [9.586061503431745, -0.6481306513321885],
            [9.590124741452877, -0.6516103167537078],
            [9.58851582668623, -0.6587366181125708],
            [9.58574619408422, -0.6657116496439385],
            [9.582637947326582, -0.6686394575752412],
            [9.582230242252715, -0.6739624688318013],
            [9.580232811404787, -0.6748785369142293],
            [9.578026514905451, -0.6827004008551385],
            [9.52002101957277, -0.6763496453227382],
            [9.514752814388716, -0.6699975129397807],
            [9.505559270618456, -0.6710258003738034],
            [9.499931450958488, -0.6679228992389361],
            [9.498453176161574, -0.670243269942241],
            [9.421787219083091, -0.6184377271425103],
            [9.373111583851784, -0.5851660101220101],
            [9.373211651681018, -0.5793842888357723],
            [9.368853692628067, -0.5749657535224904],
            [9.361078044737992, -0.5785550248594961],
            [9.353470631041398, -0.5715340590501142],
            [9.35065767564124, -0.5678149168209906],
            [9.34352258231288, -0.5631335263566477],
            [9.34913442896646, -0.556824857255249],
            [9.352876487307533, -0.5614748944974223],
            [9.35571455449027, -0.5573212016014258],
            [9.351963582787004, -0.5565309486779095],
            [9.349345141946316, -0.5529674438181935],
            [9.348383790418362, -0.5486445879450853],
            [9.343531684405018, -0.5479017389016285],
            [9.342164653752862, -0.5452110012206449],
            [9.337102282566116, -0.5473355116529951],
            [9.33241463920175, -0.549313043029938],
            [9.330427610112629, -0.5427891533187805],
            [9.335193060737614, -0.5394945078611513],
            [9.339487791147562, -0.5406138478429534],
            [9.340313049204942, -0.5315092337366913],
            [9.33680296573062, -0.5275591379266463],
            [9.333901019546884, -0.5271504428582793],
            [9.328925750595479, -0.5296291952450424],
            [9.327720689768054, -0.5355673709241952],
            [9.320254977640229, -0.5376257337540187],
            [9.320099658888077, -0.5413359471822787],
            [9.325326136391283, -0.5425357625189935],
            [9.320668693635124, -0.5469547708454109],
            [9.314763821689764, -0.5446865718422279],
            [9.30847509837919, -0.5440329893244275],
            [9.310720929897757, -0.5380339720208556],
            [9.318883091590099, -0.5308612510557352],
            [9.318610503513511, -0.5285507547880769],
            [9.31464035724823, -0.524702627577951],
            [9.310366120743684, -0.5258809568223322],
            [9.306188390906453, -0.5204626700404072],
            [9.300741299867726, -0.5242457284435554],
            [9.298225175598448, -0.5215421507352609],
            [9.30194340327207, -0.5169610745901897],
            [9.31142630995029, -0.5113447106141602],
            [9.314976536371912, -0.5078110773683562],
            [9.310451479536074, -0.5025088693198926],
            [9.312208853024721, -0.4998334896678766],
            [9.309322018773234, -0.4966559970284746],
            [9.304831065418401, -0.49950659791853064],
            [9.301274676446, -0.5036943960998507],
            [9.298051080050497, -0.503435756428968],
            [9.295345715000787, -0.49852762698945857],
            [9.29882624371916, -0.490865060346069],
            [9.297072167351518, -0.48815185463000355],
            [9.293742378693013, -0.48831969509426126],
            [9.285233369743922, -0.4917260571450646],
            [9.280226408748513, -0.49484411872116374],
            [9.27625465585441, -0.4912223341030127],
            [9.270459242517449, -0.4937645201001717],
            [9.262977553229357, -0.4912169202592047],
            [9.265723273901758, -0.4830019841788862],
            [9.269190773800977, -0.47790622795405424],
            [9.264106642311113, -0.47568450794055267],
            [9.26029968250873, -0.4766022627000967],
            [9.25983123120703, -0.47350049808259165],
            [9.264422602892562, -0.4704392769873337],
            [9.268700317012197, -0.47056246327641904],
            [9.27433071726005, -0.47419127096463665],
            [9.275957564538514, -0.47155776230485796],
            [9.270275844420999, -0.46284954510735626],
            [9.271636305194708, -0.4592532819812173],
            [9.275547236927652, -0.4617362919649238],
            [9.280345897090907, -0.4626783481181481],
            [9.286469517901054, -0.4621094411867651],
            [9.292042868139694, -0.4602948748444028],
            [9.29658355067064, -0.462355891719466],
            [9.301735241939193, -0.4575430696168858],
            [9.29463074504636, -0.45467412619238035],
            [9.288401055285979, -0.45438999354192433],
            [9.287934105300003, -0.449739243567446],
            [9.295128970092069, -0.4458930332036469],
            [9.300026557488138, -0.4495789621841966],
            [9.301519557517421, -0.44815362874592635],
            [9.300673959327451, -0.4426257284111889],
            [9.298034500155186, -0.43979068320701986],
            [9.290024994364018, -0.44023720957190693],
            [9.286975302421846, -0.43763388054899566],
            [9.28769064290487, -0.4304307078586463],
            [9.293137241006065, -0.42796578722135925],
            [9.29406194275695, -0.421987297706451],
            [9.287284469744755, -0.4186986199014975],
            [9.280970421283252, -0.4203107655910921],
            [9.276142718481756, -0.4168372498999713],
            [9.278794623073765, -0.41198115528799567],
            [9.278973942343685, -0.40516135607869475],
            [9.283576066617512, -0.4002674738253095],
            [9.283310442594846, -0.39465091550090103],
            [9.281426688297778, -0.39267613305996535],
            [9.276362378108354, -0.3930721360741271],
            [9.277180885074264, -0.38610993136157024],
            [9.272090071196498, -0.38724412193324975],
            [9.27359660738488, -0.38009007171483034],
            [9.269815138308404, -0.37142205788000304]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.53769291431136, "lat": 37.6395925859676 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21079"],
        "coty_name": ["Garrard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garrard County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00516886"
      },
      "bbox": [
        9.25983123120703, -0.6827004008551385, 9.590603543827397,
        -0.35342274220392056
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.673682746265435, -0.7052970674124908],
            [8.683414756871349, -0.6736105187603854],
            [8.695700360869342, -0.6276194373316746],
            [8.714203362809355, -0.5670910074372196],
            [8.747115503648542, -0.5179865631628984],
            [8.751662329639775, -0.5239894803749137],
            [8.754885289832826, -0.5311363224696897],
            [8.757516018202805, -0.5343246847212909],
            [8.765616533422175, -0.5397903592734988],
            [8.768768694655448, -0.5445060560565359],
            [8.77226169567223, -0.5464886519156316],
            [8.771922452941347, -0.5510027263044155],
            [8.777235929574143, -0.5585889026215392],
            [8.77555146519524, -0.561783744230412],
            [8.776444664202096, -0.5650884515479229],
            [8.775247708258963, -0.5728030496962607],
            [8.782405057835966, -0.5782879496832825],
            [8.787024816576222, -0.5775553722843487],
            [8.791839619538619, -0.5827855835436156],
            [8.793254916474359, -0.5864043684331197],
            [8.799620736814255, -0.5886185693908199],
            [8.803615034044633, -0.5921541482339565],
            [8.811164421555029, -0.5899226010528891],
            [8.817239479500179, -0.5913328814925123],
            [8.826525954437505, -0.5892116567542998],
            [8.87119819963942, -0.6053601125815207],
            [8.910141072662736, -0.6007473998754692],
            [8.975275888449453, -0.5932830667647594],
            [9.047850075247753, -0.584726832010866],
            [9.048519754976699, -0.619791213695248],
            [9.050444520987027, -0.6718843207583068],
            [9.052696969781104, -0.7175051920446021],
            [9.057894495974978, -0.7566276454068321],
            [9.061325951253197, -0.7988162873159429],
            [9.06029339569112, -0.8046014044726789],
            [9.057920350933694, -0.8058538399073715],
            [9.05322299076005, -0.8021486066164909],
            [9.048370920938535, -0.8011961779059266],
            [9.041532894003304, -0.8065590649310187],
            [9.039087968506681, -0.8069237199480642],
            [9.035725075290213, -0.8062365747169845],
            [9.032583001363648, -0.8029818269133221],
            [9.027228211693346, -0.8035079742270794],
            [9.023752202794395, -0.7986499652551438],
            [9.019282686097855, -0.7964055611957795],
            [9.017814126490006, -0.7906198239558637],
            [9.014018615674377, -0.7908404719522195],
            [9.008805092804604, -0.786429952155318],
            [9.006456425087315, -0.7876383018630485],
            [9.002921372509423, -0.7814924979633007],
            [8.996732038712313, -0.7794314891390228],
            [8.991525797510244, -0.7721611608207001],
            [8.98763809609446, -0.7723820201021177],
            [8.985961682464495, -0.7768928799810508],
            [8.981049999621844, -0.7793916041709018],
            [8.978169440501043, -0.7748040394771757],
            [8.974754426201867, -0.7767251741528916],
            [8.9723392762327, -0.773846360745618],
            [8.967618063202515, -0.7721992085592204],
            [8.965685863935988, -0.7665909987280928],
            [8.958453458532427, -0.7650347633483625],
            [8.955527992461082, -0.7676439458196455],
            [8.956284649868557, -0.7711591141409914],
            [8.952411928125988, -0.7750777295242998],
            [8.948809363845642, -0.7766491298727816],
            [8.940845070532067, -0.7765772259294084],
            [8.939130474028111, -0.7842841379167595],
            [8.935744480369541, -0.7830018800269863],
            [8.934370168409254, -0.78695639689829],
            [8.93054628808085, -0.7881831568197603],
            [8.924363616258546, -0.7871348829066417],
            [8.919562329627002, -0.7890140720807161],
            [8.915332218732088, -0.7933542269001164],
            [8.913616696689193, -0.7999546196236887],
            [8.911041446172133, -0.7996835921565302],
            [8.90915678684398, -0.8076068173271994],
            [8.906292897912934, -0.8084049357271006],
            [8.903583066910912, -0.8156432856224597],
            [8.896160661230544, -0.8172117885618708],
            [8.893969425101293, -0.8201807766520517],
            [8.883549805959737, -0.8210454513886812],
            [8.881917223920063, -0.8151762607320476],
            [8.878629750599531, -0.8139086940617065],
            [8.876719175002862, -0.8097384174176581],
            [8.876763428896261, -0.8039748988751226],
            [8.869074572923948, -0.8028639980401067],
            [8.866420831999136, -0.8003363853159113],
            [8.862546291684671, -0.7997392253778955],
            [8.858220738624215, -0.7957329500733564],
            [8.85411295291453, -0.7956169751904887],
            [8.848973110877818, -0.7908812176571751],
            [8.84269024775329, -0.792218380685265],
            [8.83291490112556, -0.7819892871650351],
            [8.827540044056972, -0.7820757264138312],
            [8.824369608483176, -0.7746597581932738],
            [8.821784061844122, -0.7760299672951619],
            [8.812552942376556, -0.7745040684336676],
            [8.807880875087287, -0.7794420782690203],
            [8.805678391356404, -0.7779317998251306],
            [8.802100716588, -0.7805415765076511],
            [8.797630589854405, -0.7780928803230999],
            [8.792844594124109, -0.7822714297344247],
            [8.788365619529417, -0.7804602497505011],
            [8.779752406945741, -0.7806634699317535],
            [8.77663798118303, -0.7753611780815264],
            [8.76269327677437, -0.7771925481025389],
            [8.757527424889808, -0.7772049284599046],
            [8.753705220893254, -0.7735211630176451],
            [8.746197923552472, -0.7740543024710962],
            [8.742834728550628, -0.7762297265624405],
            [8.744219374819794, -0.7813268199549012],
            [8.734652316218952, -0.7842391560338862],
            [8.7265417531181, -0.789590941598299],
            [8.723333519359429, -0.7792663897205031],
            [8.71990289593243, -0.7745571447772147],
            [8.717592362790322, -0.7635575658436768],
            [8.709753231120732, -0.7564375770066623],
            [8.705097398766512, -0.7501185756473197],
            [8.70141681493091, -0.7425969527410861],
            [8.70018988005375, -0.7334679546251417],
            [8.701005037234994, -0.7308173332457508],
            [8.69845992577345, -0.7265119475163362],
            [8.698201929464442, -0.7227217253370616],
            [8.693015852157622, -0.7141356180220744],
            [8.688538359487971, -0.7089877823002175],
            [8.676928673271608, -0.7040233846628594],
            [8.673682746265435, -0.7052970674124908]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.26963774472, "lat": 37.55256010540691 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21155"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00516921"
      },
      "bbox": [
        8.673682746265435, -0.8210454513886812, 9.061325951253197,
        -0.5179865631628984
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.187335058870087, 0.16488328124174143],
            [9.211848378356686, 0.1857514435241584],
            [9.249891478087354, 0.23760030086687178],
            [9.268063165546133, 0.25465652792198773],
            [9.296150177179893, 0.3006037296745849],
            [9.309095897997485, 0.3218379478833633],
            [9.311569116570944, 0.3226853355523091],
            [9.315302937706745, 0.32008370743882186],
            [9.31776816808429, 0.3095994364130024],
            [9.322465451295562, 0.2987578151127855],
            [9.325345963788395, 0.29568802109148434],
            [9.33573377583395, 0.2905204803248006],
            [9.340791221013376, 0.2824116026156875],
            [9.341996143537274, 0.27058558180877273],
            [9.341467421845117, 0.26561661052156926],
            [9.346013400189957, 0.26116358433111403],
            [9.362727777373943, 0.25338169275493044],
            [9.36839413137457, 0.25262626802769567],
            [9.373759384673141, 0.24741676835880302],
            [9.37702477532977, 0.2464389411816974],
            [9.380943991350094, 0.2404017524856822],
            [9.386848043132078, 0.23748333600569888],
            [9.389429594790583, 0.23197416778663035],
            [9.39280411997744, 0.2307955841563206],
            [9.39450706361058, 0.22591690861611077],
            [9.401585266806388, 0.21516004570977004],
            [9.400616804194087, 0.21069402032447804],
            [9.40153611864967, 0.2043902008015898],
            [9.400971421922398, 0.19630412261569224],
            [9.403479310219561, 0.1868736785189412],
            [9.407232109749463, 0.18143441746875288],
            [9.408768760605101, 0.17538394487582837],
            [9.4122442497188, 0.17070344833860415],
            [9.41703070188312, 0.16838362756060807],
            [9.417402707715459, 0.16413400471382433],
            [9.419894302208974, 0.16054415598023206],
            [9.423186639492194, 0.15961383193554993],
            [9.42377046640149, 0.15547146889347271],
            [9.429753300299865, 0.1450510772206253],
            [9.431027360335207, 0.14001750841659696],
            [9.425529793489122, 0.1364022271850499],
            [9.423710859438476, 0.12491926222129145],
            [9.42551810522577, 0.12324788391788205],
            [9.427283465475936, 0.11609518056144746],
            [9.431008768947656, 0.1147081859347774],
            [9.432553984055092, 0.11165998328043956],
            [9.432054743185777, 0.10686429091557634],
            [9.44576328793276, 0.09473621136215181],
            [9.446938618132197, 0.08873937987731717],
            [9.445678471238123, 0.08648834332500115],
            [9.445908517081223, 0.07982742965531585],
            [9.44827327049337, 0.0734990516376809],
            [9.451000172879422, 0.07141571755718663],
            [9.453059962395773, 0.06355658178298988],
            [9.449340950238057, 0.05886898483922707],
            [9.45187090089131, 0.05602290419892813],
            [9.45487690455414, 0.05607567064290338],
            [9.466270856413072, 0.05158260829775445],
            [9.369345527726242, -0.008332190614847324],
            [9.306742617551569, -0.04749020953318242],
            [9.304864601880638, -0.0610889273432837],
            [9.299111502257695, -0.06739384743799932],
            [9.2894174187962, -0.06270689918743441],
            [9.286109262226146, -0.06746207193700794],
            [9.283216414720389, -0.0636259556811034],
            [9.282508453289044, -0.059078166438784656],
            [9.287932256920364, -0.060250957425116866],
            [9.297214793737938, -0.056520266113564255],
            [9.296773967040819, -0.05230961339946528],
            [9.29174013512897, -0.04745056404430278],
            [9.289124656554382, -0.04328340716096122],
            [9.286041093240595, -0.04476931212456044],
            [9.285335517350934, -0.03388491212989081],
            [9.281952979457232, -0.034928553673203806],
            [9.279685575431266, -0.028117768556174805],
            [9.278914060693724, -0.021490605230828946],
            [9.2865775798154, -0.0215085683027901],
            [9.28316503660252, -0.016031449362459038],
            [9.27821453405214, -0.019555659263995266],
            [9.274845829559215, -0.01900874890982451],
            [9.273706659581052, -0.012961664783181486],
            [9.274938771932504, -0.009132170795763252],
            [9.279724658484632, -0.010638935984295913],
            [9.280027827926618, -0.002835236588385638],
            [9.273587759854232, -0.0006980507301771199],
            [9.270182748210154, -0.0015019620178517976],
            [9.265684415441125, -0.005253920693491357],
            [9.256139115690411, -0.0029502529175281945],
            [9.252426243886035, -0.007839932950658489],
            [9.259045650917615, -0.009867978789172501],
            [9.254932278747038, -0.013333054801985513],
            [9.251697090166443, -0.012284059227129102],
            [9.246553441883334, -0.008321562642452922],
            [9.248938009597127, -0.006252610956502975],
            [9.248137428568008, -0.002435897919093676],
            [9.244830059526974, -0.0025160442721629413],
            [9.242811537454312, -0.005587619584486802],
            [9.236956930538923, -0.0056676711974323266],
            [9.234252396504932, -0.011586074448564913],
            [9.228899296485258, -0.010201117349267439],
            [9.224818120619288, -0.0060291524979507825],
            [9.222044801685321, -0.0006200597723128893],
            [9.21743766989581, -0.0013807377079656754],
            [9.214384986184076, 0.002918307979647756],
            [9.21930854506938, 0.004783339380572456],
            [9.217992683186624, 0.008885547267388095],
            [9.212497042423575, 0.021325067210332786],
            [9.196044233098092, 0.11027460020379222],
            [9.193586904073332, 0.12860822866911786],
            [9.187335058870087, 0.16488328124174143]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.58404445918798, "lat": 38.29144248107373 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21209"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "209",
        "coty_gnis_code": "00516951"
      },
      "bbox": [
        9.187335058870087, -0.06746207193700794, 9.466270856413072,
        0.3226853355523091
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.7957556981492875, -0.9644434592613861],
            [6.805987435696168, -0.9505157566247411],
            [6.846830369519804, -0.9052866478201924],
            [6.88568029022779, -0.8590570852327043],
            [6.913483431869701, -0.8232436501155661],
            [6.937215822719179, -0.7918110160003144],
            [7.00746457547321, -0.7817013276066465],
            [7.0400836459172575, -0.7777214220584725],
            [7.10088161942108, -0.7694663235970538],
            [7.123246567352072, -0.7660612655342309],
            [7.120406255576188, -0.7747080574538636],
            [7.121689054734345, -0.7865798712332237],
            [7.135364419893649, -0.8072774342619028],
            [7.137323491425825, -0.8120730020530648],
            [7.15222454767512, -0.8179843598830627],
            [7.167977954788085, -0.8186780422758199],
            [7.185590267693162, -0.8163523955691888],
            [7.195053885575446, -0.8181810926455969],
            [7.205379111198408, -0.8177496399166022],
            [7.209663872171789, -0.819631700760523],
            [7.219633259002812, -0.8274287757861729],
            [7.2241979949082795, -0.8355716469664796],
            [7.136546143974151, -0.9255924847790818],
            [7.135115541832945, -0.9276914576741704],
            [7.063073254400796, -0.9595544630806028],
            [7.015148669434365, -0.9974247939410834],
            [6.948123788302751, -1.0498354003935353],
            [6.900595864168853, -1.0865900264281303],
            [6.896387858014431, -1.083528084649473],
            [6.891507815547319, -1.086173260418261],
            [6.889040494317223, -1.0852145125692132],
            [6.888268591605648, -1.0792851013402136],
            [6.894122761317778, -1.071554175124658],
            [6.900958880860415, -1.072937159199135],
            [6.905106094837004, -1.0652644307916517],
            [6.907789911633934, -1.056783578276964],
            [6.902431969999588, -1.0600982824299132],
            [6.894721552496137, -1.054659487518982],
            [6.8882744684172375, -1.0527662577210268],
            [6.88787983659244, -1.0578437459828471],
            [6.880168708764072, -1.0610180704041123],
            [6.877247782965696, -1.0592103667447896],
            [6.8753572343068825, -1.062509308487515],
            [6.871796174949779, -1.0638005151554575],
            [6.861761358942153, -1.060099581897664],
            [6.8611954891331415, -1.047376201255365],
            [6.867377322132044, -1.0437028662801404],
            [6.8709737555135995, -1.0448630537982722],
            [6.872279653535312, -1.037958299467674],
            [6.869544578393963, -1.0332868756986757],
            [6.871179767430527, -1.0220642449843553],
            [6.868160481462744, -1.018341410171614],
            [6.862170627915969, -1.0215577486012768],
            [6.861269313214297, -1.0253277837228152],
            [6.856553824196934, -1.0245084794172723],
            [6.856021791370878, -1.029245876307753],
            [6.851093547172695, -1.0353371177183295],
            [6.846738629503284, -1.0334323913251509],
            [6.8431029383242885, -1.0360044917911808],
            [6.8339610352104865, -1.0391902274520777],
            [6.826215465651251, -1.0447908171835736],
            [6.823800927836666, -1.0436816939860134],
            [6.811189337550365, -1.0343274050519307],
            [6.805149815823679, -1.0360130397722356],
            [6.801651109122414, -1.031803718786546],
            [6.801512157744938, -1.0281393910997125],
            [6.796203733234531, -1.0195453531429224],
            [6.7942921045392275, -1.0118681599299129],
            [6.796610268937479, -1.0063230129298488],
            [6.794773082785627, -0.998963720051955],
            [6.791126010302194, -0.9924188603742853],
            [6.791563476935764, -0.9905668981696741],
            [6.788407443279422, -0.9800922320521857],
            [6.789767008217759, -0.9757624605441151],
            [6.796422356987679, -0.9680325998023934],
            [6.7957556981492875, -0.9644434592613861]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.68333364542062, "lat": 37.51832129272567 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21233"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "233",
        "coty_gnis_code": "00516963"
      },
      "bbox": [
        6.788407443279422, -1.0865900264281303, 7.2241979949082795,
        -0.7660612655342309
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8603404946770175, -7.3427113526687915],
            [3.8538506790314355, -7.181118919299553],
            [3.8515079418738307, -7.137327956470988],
            [3.8488206964879703, -7.0800899425397725],
            [3.8440195073738015, -6.962805830027991],
            [3.84297218091961, -6.941650399397186],
            [3.840312049225224, -6.874244088649011],
            [3.8423395102169016, -6.874124539222388],
            [3.837008449561861, -6.743624928257611],
            [3.923141816546402, -6.739908023555651],
            [3.920449999205123, -6.696135805973943],
            [3.9328182706638577, -6.695314541024219],
            [3.9374834768377878, -6.6958850216444805],
            [3.945409923654383, -6.699314168635465],
            [3.956115696758197, -6.70684037022897],
            [3.9549403393032265, -6.701527507686587],
            [3.958347614418211, -6.700689882221003],
            [3.9580067550950835, -6.706789507250169],
            [3.959690869353528, -6.709244598124036],
            [3.9637497126687316, -6.707262884008142],
            [3.965819354116514, -6.708889101241418],
            [3.9688365951939244, -6.715181475147509],
            [3.968859735265877, -6.7223147499114795],
            [3.974185194990504, -6.725160605181465],
            [3.9752777293236465, -6.7300369391174355],
            [3.986045547701742, -6.731101096463136],
            [3.9815343122174176, -6.734938098850721],
            [3.9824379940517205, -6.737823984763995],
            [3.989039183793026, -6.740609175811576],
            [3.991098698738293, -6.746597335101032],
            [3.995681751904294, -6.745937682312504],
            [3.9973754520844804, -6.742254313544826],
            [4.000763016456682, -6.742901017116647],
            [4.002710660156216, -6.747758258434231],
            [4.0068955398847095, -6.745256843537001],
            [4.011937491809567, -6.752701457507937],
            [4.011412299744123, -6.758115304511179],
            [4.0160649682497285, -6.759933139946252],
            [4.0100004298837195, -6.763697778576008],
            [4.010209857625364, -6.767110874550183],
            [4.007955129467118, -6.770449296929263],
            [4.012385724378622, -6.771465160593193],
            [4.01702272561051, -6.774640660950572],
            [4.019117743122332, -6.77009774222162],
            [4.0216336070905525, -6.770325539490748],
            [4.0216621683761895, -6.7752094474560405],
            [4.024159143991296, -6.776506493452867],
            [4.027884187299788, -6.773858784497323],
            [4.030332894694355, -6.774964049551054],
            [4.029534744541413, -6.781195501632749],
            [4.02547129977626, -6.78335883392951],
            [4.025742864841279, -6.7862167271850735],
            [4.030045760476138, -6.7907441279299885],
            [4.040914775544818, -6.783501611294111],
            [4.04120863854595, -6.782131541642841],
            [4.048935736863733, -6.777178647722591],
            [4.053227285280591, -6.776623659688506],
            [4.057573562855752, -6.780359985990887],
            [4.065897159633359, -6.7787441749566195],
            [4.069426623401127, -6.779689241446493],
            [4.076597776779791, -6.774511728534712],
            [4.077737840227061, -6.767470295419506],
            [4.082022314117333, -6.765058543640036],
            [4.090545823890746, -6.7644936557232205],
            [4.094815313138278, -6.758292839186631],
            [4.099043025198755, -6.755955520735905],
            [4.100343331025336, -6.752420489739407],
            [4.100118689631982, -6.746554087051832],
            [4.104680498190893, -6.743179577273983],
            [4.105047175908808, -6.740692120139882],
            [4.11016318134438, -6.735617262973895],
            [4.115261389212589, -6.7331196722536335],
            [4.120076352405419, -6.733374264576232],
            [4.1225311738439485, -6.730776071285547],
            [4.121591186580955, -6.726677561102049],
            [4.123898252015596, -6.724789122510063],
            [4.1280615238170215, -6.717339691174978],
            [4.131171868137103, -6.7088348671743],
            [4.13686119022353, -6.704705468286062],
            [4.1371270015918356, -6.698849671251606],
            [4.13892185299967, -6.696731137841502],
            [4.137234236409206, -6.687433722302588],
            [4.180331075338292, -6.6855845233716185],
            [4.183875977605706, -6.772478594260664],
            [4.202193018266075, -6.771610311369984],
            [4.2011395699000476, -6.7757596500490145],
            [4.202283208156543, -6.779701444170567],
            [4.19912775750602, -6.783115953125002],
            [4.200272450839916, -6.791016185236695],
            [4.207404278646125, -6.791856583864545],
            [4.207525769929642, -6.801561384751393],
            [4.210415117519031, -6.827455447411752],
            [4.207714556244413, -6.8388282377061245],
            [4.2047917673803195, -6.845970450782915],
            [4.20319387712874, -6.852767575518259],
            [4.204329349492621, -6.858792223035875],
            [4.209604586383826, -6.869465144430848],
            [4.2226542505313365, -6.887744948360342],
            [4.226242677973432, -6.893489919877108],
            [4.234181839134971, -6.901457811767451],
            [4.240335655946637, -6.90754258690197],
            [4.242864282724101, -6.915028802526639],
            [4.240033065966402, -6.923217994464833],
            [4.237006599865293, -6.927290691454545],
            [4.232637331695506, -6.9305483556844],
            [4.226735377240434, -6.929880551412381],
            [4.211545384579741, -6.918084349722771],
            [4.207721143933113, -6.913054874052664],
            [4.200817362882985, -6.898978936011641],
            [4.195697491794339, -6.894407680496251],
            [4.19119621548338, -6.89328841600284],
            [4.185231363378911, -6.893707587045377],
            [4.182604373761923, -6.895525283875961],
            [4.1787811873448515, -6.901922619069736],
            [4.175832541579847, -6.910316753097544],
            [4.172444498741263, -6.915308019863581],
            [4.164521837067614, -6.923133398533932],
            [4.158239527870239, -6.92752836764067],
            [4.150595677745047, -6.9295883749441165],
            [4.142959865709279, -6.930064337306793],
            [4.135688321984978, -6.928305363297081],
            [4.131430003174049, -6.925109846762534],
            [4.124110461613591, -6.917167810117018],
            [4.119907722351943, -6.914773561948042],
            [4.113591878237007, -6.917762336993631],
            [4.108345552694432, -6.923633802517294],
            [4.104775405857683, -6.935735037423686],
            [4.10371591691603, -6.956083686492202],
            [4.095203078857288, -6.9792845812724025],
            [4.09427732808744, -6.983438171462919],
            [4.095695521272953, -6.992370992937867],
            [4.101912561410709, -7.0064013927935695],
            [4.102827436284109, -7.0161101950534785],
            [4.09799774887373, -7.02593854480173],
            [4.086808675805755, -7.036374684668524],
            [4.081019884231324, -7.043673154073157],
            [4.077664961519357, -7.0459425453224265],
            [4.070383585945842, -7.045410619930818],
            [4.065963454995867, -7.043040193656524],
            [4.06123911821567, -7.03811118043052],
            [4.057342340742647, -7.028791481995096],
            [4.0532019257182785, -7.0170337628791],
            [4.050093003727269, -7.01418621001262],
            [4.0433815327910665, -7.013006143770168],
            [4.039995201369485, -7.016440942285458],
            [4.033285690338288, -7.0204887784296055],
            [4.018394558448618, -7.031649882579881],
            [4.017464269582561, -7.035368819215596],
            [4.011409179220671, -7.0437970441379525],
            [4.00439109757249, -7.063554293308591],
            [4.0026251964530255, -7.071611052622305],
            [4.0024902032657, -7.081989224232687],
            [4.003895203353543, -7.090705036402764],
            [4.007687433140486, -7.099615584200603],
            [4.016032405778821, -7.107728264947115],
            [4.033233708158887, -7.118143824154821],
            [4.039682038405803, -7.123644378555022],
            [4.045332124892315, -7.130275505329068],
            [4.048888230115534, -7.137532043545637],
            [4.048307738059963, -7.145762603187372],
            [4.04287903084973, -7.159002790018013],
            [4.034916350622221, -7.166011770682536],
            [4.0299958430704805, -7.169028635076465],
            [4.026772037090854, -7.173192202357372],
            [4.025921717986201, -7.178767095779169],
            [4.028226087605194, -7.185375096219201],
            [4.03174969639386, -7.1883262256519656],
            [4.048788649829879, -7.192800005632432],
            [4.056471863295333, -7.192521696742122],
            [4.064149342213807, -7.19328777413414],
            [4.082739928457944, -7.19202975235145],
            [4.089240452389421, -7.193333390165764],
            [4.095228689709966, -7.1989554730951175],
            [4.098586214213509, -7.206550005017408],
            [4.09876193586004, -7.213061220194013],
            [4.096651448485419, -7.219868803725222],
            [4.092021486763004, -7.224504677725728],
            [4.084632887780565, -7.22766303317436],
            [4.0749438839026055, -7.22908658313032],
            [4.067058586328847, -7.2289058926478145],
            [4.060927912344948, -7.227136628976806],
            [4.052456874052481, -7.220619376077031],
            [4.045222942769049, -7.219609354550911],
            [4.032263866888695, -7.223138624814535],
            [4.026198027040594, -7.223023694641784],
            [4.02328316101706, -7.2186753398463],
            [4.023599378411137, -7.212357144919179],
            [4.021719298437866, -7.204124088229993],
            [4.017742403495891, -7.194800994839524],
            [4.01382163903377, -7.183177826472316],
            [4.009437880397796, -7.172288067350714],
            [4.0052326515349135, -7.1656953074994485],
            [3.996426570973398, -7.160463930678427],
            [3.990236018931305, -7.160993026268922],
            [3.9822498301245575, -7.16789494270364],
            [3.9810304575504327, -7.172065554255325],
            [3.983872365813533, -7.176738288753082],
            [3.9831366561441315, -7.183614653786832],
            [3.9786428630272956, -7.189015338070288],
            [3.976576748385257, -7.197893826493049],
            [3.9809170423264977, -7.213139437575692],
            [3.983308365934869, -7.224542771292122],
            [3.985424385666389, -7.239714347218658],
            [3.986812210557544, -7.243602483401896],
            [3.994855846024416, -7.253595094218409],
            [4.004615716560582, -7.261028170492107],
            [4.019671684325696, -7.266345003725619],
            [4.032454119160544, -7.26693577215425],
            [4.0408004807260784, -7.265490988680636],
            [4.046340784748638, -7.26577159234821],
            [4.051306223289389, -7.268058600703321],
            [4.054330426761764, -7.27519307797769],
            [4.052606987445645, -7.279061367753933],
            [4.044170320641331, -7.286173073346949],
            [4.039617443686595, -7.2877305434310085],
            [4.03408442429046, -7.287836813482988],
            [4.027590136630852, -7.290947677887785],
            [4.01410837512021, -7.284516574700519],
            [4.00801038569331, -7.283429851085672],
            [4.002793941549044, -7.284274662241187],
            [3.996757838681828, -7.286979476560732],
            [3.99104811840027, -7.292000655531925],
            [3.986808004063071, -7.296997602837233],
            [3.98341287809305, -7.303505299751499],
            [3.982160746993577, -7.309005335197067],
            [3.9812239822064663, -7.322587850656667],
            [3.9799137176134134, -7.332813910512711],
            [3.980326254222515, -7.347208653829721],
            [3.982050670247768, -7.354992278317688],
            [3.985400261524483, -7.360811491669151],
            [3.992463236245613, -7.366721845089166],
            [4.003815155297561, -7.369851100653534],
            [4.013767558730495, -7.366835965349595],
            [4.018566234675448, -7.368442068754467],
            [4.020278700772458, -7.373904621657189],
            [4.019234144726593, -7.383987235798081],
            [4.016571393859005, -7.3889000120104615],
            [4.010701958375656, -7.395548977749481],
            [4.007062249926947, -7.394368355225357],
            [3.9994093666004287, -7.400061780980886],
            [3.9932861397481787, -7.398358631739436],
            [3.9884797972468338, -7.3933636040740245],
            [3.9799561179276743, -7.382566401720689],
            [3.9662504839972406, -7.373820795009937],
            [3.9458701043809286, -7.368014085514146],
            [3.9341670849108445, -7.369397797266061],
            [3.930702533653958, -7.370612173585224],
            [3.924577814326728, -7.375828572663021],
            [3.9210218321748305, -7.380743229632064],
            [3.9183652523253847, -7.388204540300934],
            [3.91494946313288, -7.394042097731894],
            [3.9160190155884265, -7.40025440662502],
            [3.920876043340835, -7.409121004791971],
            [3.9240973990663854, -7.418138101566829],
            [3.923988578288866, -7.423246323035372],
            [3.9258601770662795, -7.426995557370183],
            [3.931922646187254, -7.429161336662755],
            [3.936750520348819, -7.427071557250321],
            [3.939081869211164, -7.430313847302782],
            [3.936258853431459, -7.434805379532856],
            [3.9308781354369584, -7.434889765379011],
            [3.9263285071357226, -7.438263034972931],
            [3.921842532969488, -7.444012565875199],
            [3.9170698397688835, -7.4417278332149905],
            [3.916292054689468, -7.426171944155629],
            [3.912463278727661, -7.421536134024161],
            [3.9081824970297596, -7.420463000781139],
            [3.9024687707239134, -7.424112358078343],
            [3.90122024202056, -7.431673665302698],
            [3.8964871933583134, -7.438774838481941],
            [3.8936680529478527, -7.4414021174421645],
            [3.8855138702579364, -7.44341855393544],
            [3.879425785080314, -7.442121962446671],
            [3.8756386641934646, -7.4379471394556385],
            [3.8789251397702205, -7.431763299592242],
            [3.877480808021085, -7.428464364228958],
            [3.869711955584647, -7.4272183963768565],
            [3.867037782752064, -7.424466561592572],
            [3.8741041078800476, -7.42197235298476],
            [3.88061424354949, -7.418480877131555],
            [3.880578645969078, -7.415323005380712],
            [3.872132745011264, -7.414870544928165],
            [3.871422218312676, -7.411993824897075],
            [3.8677487400399344, -7.409873254544108],
            [3.86606488464625, -7.404466231904366],
            [3.8676354015510475, -7.400995147125781],
            [3.8728375301753926, -7.401562777531492],
            [3.87678271020929, -7.394767796180842],
            [3.8753973329910867, -7.39366131595612],
            [3.8677319006072737, -7.397705045244084],
            [3.864473636611953, -7.392212024124448],
            [3.8603452606049973, -7.392608204218663],
            [3.8585627911208755, -7.390027791784448],
            [3.8603046884734384, -7.386940988244239],
            [3.852218456474233, -7.388226714503792],
            [3.8493054278367924, -7.3860118008926],
            [3.850571017077297, -7.381509495817648],
            [3.856098532580524, -7.379508544857312],
            [3.851854408750657, -7.373862423640739],
            [3.8513492546548678, -7.369832920564325],
            [3.854096644190787, -7.366247934244868],
            [3.859061970448065, -7.367578425270977],
            [3.858171587599357, -7.372592504435649],
            [3.861553195682382, -7.37500983487452],
            [3.863954638229418, -7.370607177207385],
            [3.871547906001029, -7.3707593279145875],
            [3.871290652178726, -7.368315432398753],
            [3.8618951505600863, -7.3617450538573035],
            [3.860819619545907, -7.357637555633305],
            [3.86606840767516, -7.350599188132395],
            [3.8650942183915427, -7.345670362859869],
            [3.8603404946770175, -7.3427113526687915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.84703832952027, "lat": 31.66610198441534 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22025"],
        "coty_name": ["Catahoula"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Catahoula Parish"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00558495"
      },
      "bbox": [
        3.837008449561861, -7.444012565875199, 4.242864282724101,
        -6.6855845233716185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.547264651235498, -8.410103091289756],
            [5.555768406193742, -8.41331946305317],
            [5.569799261146132, -8.416398743226438],
            [5.580990500500082, -8.417495405603319],
            [5.606339146749639, -8.416207741988014],
            [5.620698782627783, -8.412476784430154],
            [5.637617601934188, -8.406434269382977],
            [5.661751100154439, -8.39183882009015],
            [5.672056644142061, -8.388222677437504],
            [5.721636608641094, -8.365734338479276],
            [5.753993256328394, -8.370847284933697],
            [5.76941334990232, -8.371204279858295],
            [5.793848781119164, -8.379639038330884],
            [5.7965384289866995, -8.381456430429726],
            [5.815243483850923, -8.39736532005554],
            [5.833854704426862, -8.397503219001289],
            [5.850160098771209, -8.386873764449703],
            [5.856312075487289, -8.379682797349705],
            [5.858922135673211, -8.377955791302252],
            [5.866570734168707, -8.380216053959435],
            [5.876370226165197, -8.389500607362038],
            [5.8824908274416075, -8.392719094629784],
            [5.888987261017847, -8.391347318765364],
            [5.900728923934083, -8.384395067124334],
            [5.903417646237362, -8.37937788502017],
            [5.906461769894731, -8.377182903659516],
            [5.910873981850362, -8.376641358214412],
            [5.915422534070112, -8.378035784261941],
            [5.929118133509521, -8.383930054354527],
            [5.937683029340096, -8.390800941420569],
            [5.942038665959293, -8.391663527949047],
            [5.950593402568823, -8.391008475770642],
            [5.963712214010737, -8.393288048777697],
            [5.9594700700641186, -8.404118391158988],
            [5.956342611986532, -8.405593826838677],
            [5.951488393627852, -8.410431151267268],
            [5.945452221999303, -8.41882801010963],
            [5.939054698110184, -8.431338935591935],
            [5.929056776014549, -8.439656920663788],
            [5.924375328014937, -8.440224782440565],
            [5.9195260859599115, -8.44635230444941],
            [5.917778971367691, -8.466266391848944],
            [5.917847350038137, -8.475573652836909],
            [5.906668761922563, -8.48079557428334],
            [5.8872900882688635, -8.48439424942536],
            [5.879182991518146, -8.492477549412493],
            [5.877866357239901, -8.500525310651705],
            [5.88021476544869, -8.507925534947153],
            [5.884316347365413, -8.511263530075047],
            [5.893097670652755, -8.523648134303478],
            [5.892899342131166, -8.526783698610533],
            [5.88706992765304, -8.529961187784302],
            [5.879610878052074, -8.530845485702415],
            [5.867540909670454, -8.521169832833545],
            [5.86552293509945, -8.518026886888448],
            [5.848185327724775, -8.50939954661483],
            [5.842469767839728, -8.510178354434993],
            [5.8259575947564555, -8.50961461165544],
            [5.804711344004211, -8.512211371058477],
            [5.802661061861057, -8.516945382585575],
            [5.792429478652735, -8.525040992526066],
            [5.782510401809215, -8.537932614928042],
            [5.776224022838662, -8.549005256171199],
            [5.772428954182892, -8.551398938072438],
            [5.771705619325551, -8.557993312374952],
            [5.767281315345862, -8.562875335885959],
            [5.77308461253119, -8.568189202898438],
            [5.769869410679219, -8.572001565075613],
            [5.766562200424203, -8.571213080890157],
            [5.764993110710209, -8.567845484582802],
            [5.762133801180535, -8.567792010675836],
            [5.75871887002597, -8.573439838442724],
            [5.753954043336507, -8.574522360075958],
            [5.750559110505941, -8.569710630340888],
            [5.750179703684985, -8.564592541411272],
            [5.741744774269813, -8.559304650905819],
            [5.739370749939856, -8.561028900794923],
            [5.73323015369302, -8.55971191574335],
            [5.72500598674159, -8.563568762685627],
            [5.721173091541618, -8.56898066155951],
            [5.713620713177815, -8.575551031283952],
            [5.71099305700286, -8.575674554303692],
            [5.7056420189090975, -8.579284875885595],
            [5.703848234403563, -8.583703766567123],
            [5.699136507487257, -8.581766470473996],
            [5.692589350470516, -8.58340508923717],
            [5.689177689869935, -8.577752184164808],
            [5.6857862912102535, -8.578927733674853],
            [5.681633518347582, -8.575477387218351],
            [5.672286083977142, -8.572112947999138],
            [5.665945614030698, -8.579280037903539],
            [5.660246064220389, -8.577179306667484],
            [5.658939447339184, -8.586047648569416],
            [5.656436028152961, -8.594119681384774],
            [5.653650730014088, -8.593249531259382],
            [5.643801697385929, -8.621357236198355],
            [5.661447565802742, -8.631960699992312],
            [5.669182714447915, -8.635930484856157],
            [5.68172576325386, -8.640082533341252],
            [5.689614464619679, -8.640435433961228],
            [5.708616965283045, -8.638553690380768],
            [5.717334535427679, -8.640729685227711],
            [5.724425220327953, -8.646286897656783],
            [5.736580612205372, -8.663138662835431],
            [5.741566786366346, -8.67324734175986],
            [5.742495575225704, -8.683586272989084],
            [5.740512370247913, -8.688700767902162],
            [5.7364031266158895, -8.692982390469437],
            [5.73053186100129, -8.694548092177182],
            [5.727721460562215, -8.689794186814096],
            [5.713455240711249, -8.669555003318454],
            [5.692421490317523, -8.661287778315554],
            [5.680471385402982, -8.660279976629038],
            [5.674965889062578, -8.66272926638027],
            [5.667851344351434, -8.66048333607729],
            [5.667182156216038, -8.67600712642708],
            [5.65533415267835, -8.668402526645696],
            [5.655464249976273, -8.673805410273605],
            [5.6504787047757645, -8.670964084824886],
            [5.650312913306414, -8.669618207718322],
            [5.640914227872075, -8.660356532641783],
            [5.6094240619801425, -8.63026873259468],
            [5.603715615234215, -8.624488338714146],
            [5.604639201198746, -8.63199284873258],
            [5.604109126017835, -8.639267780458221],
            [5.601532431237317, -8.643789774536009],
            [5.593999952578396, -8.650898077171297],
            [5.58229078373757, -8.656477235763523],
            [5.566393538146107, -8.662982943693327],
            [5.555904803967605, -8.663747253858544],
            [5.548343301076651, -8.662731129092371],
            [5.541839264887776, -8.660347051798457],
            [5.536208880277445, -8.654940919142785],
            [5.535227678065713, -8.648954214314267],
            [5.534654198242421, -8.635604587354516],
            [5.533117778791908, -8.626279044694723],
            [5.544524259182922, -8.59999279990947],
            [5.544602481956699, -8.578102855661447],
            [5.54503259820119, -8.551728568480414],
            [5.5466493119835825, -8.544188215249138],
            [5.545510738434571, -8.537520688340459],
            [5.547264651235498, -8.410103091289756]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.92883872768027,
          "lat": 30.068737870996422
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22071"],
        "coty_name": ["Orleans"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Orleans Parish"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00558113"
      },
      "bbox": [
        5.533117778791908, -8.694548092177182, 5.963712214010737,
        -8.365734338479276
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.705455724433055, -7.823945634986252],
            [3.8012741172313405, -7.818757582082936],
            [3.8616332186662325, -7.816779703302033],
            [3.917993347110172, -7.814389842022666],
            [4.010764572004205, -7.811749708186127],
            [4.045355321354897, -7.810313773436207],
            [4.0579288320472156, -7.820295932169198],
            [4.060570921030182, -7.8286573115954985],
            [4.058084801178632, -7.833242813244185],
            [4.0532016074816735, -7.837620772569442],
            [4.052758152479494, -7.843427060084962],
            [4.053804060876725, -7.8467738563002625],
            [4.0719667303586915, -7.859464860598111],
            [4.080131291404359, -7.8630190011272125],
            [4.087925297814482, -7.870807074952905],
            [4.090932908752283, -7.87606180027658],
            [4.093151532417559, -7.883845493943685],
            [4.099737891204466, -7.895391225708253],
            [4.100804168579147, -7.898886962115758],
            [4.100518849810507, -7.905247705122588],
            [4.09896044161676, -7.909905164260266],
            [4.099170411991707, -7.914447504933099],
            [4.104579912876685, -7.919364924039359],
            [4.109721156756636, -7.931318115985808],
            [4.118031127947137, -7.942959678197776],
            [4.12140410154837, -7.950817390845173],
            [4.1218684738037785, -7.961965503806284],
            [4.12033580678518, -7.969922425576],
            [4.120567269520681, -7.9748581228496604],
            [4.12417454132425, -7.981452161974432],
            [4.12396593716853, -7.985922256611166],
            [4.119476485440835, -7.989564054791306],
            [4.114174646976564, -7.991871301306469],
            [4.112716650031874, -7.995548966787459],
            [4.115683562781502, -8.01430214809375],
            [4.118553589113545, -8.021366194515794],
            [4.115440138586755, -8.028805861652927],
            [4.111173393624657, -8.031448990974464],
            [4.108077416663976, -8.036844648861257],
            [4.1076765076510044, -8.041804896114607],
            [4.110960136306327, -8.050355085150994],
            [4.109287110284433, -8.067922598838573],
            [4.109636683279977, -8.079683877409442],
            [4.107608409351817, -8.087140712006077],
            [4.107976787869985, -8.091359621065358],
            [4.122071446988404, -8.121494732754261],
            [4.130610619592975, -8.132303472737153],
            [4.132173842448427, -8.140371953054883],
            [4.128489462534403, -8.14438770098865],
            [4.118640407696936, -8.143979773808278],
            [4.113242633077633, -8.147062782044328],
            [4.111520128707053, -8.155176100670966],
            [4.113855532112888, -8.167781234064364],
            [4.117176600576856, -8.17435107656443],
            [4.11892029361551, -8.17527266437157],
            [4.123380206656485, -8.182012011251636],
            [4.124861151857856, -8.186119171829223],
            [4.125488762104895, -8.194919302672483],
            [4.127738529933373, -8.199224374378367],
            [4.130507083539153, -8.200645156313543],
            [4.142420228829461, -8.199284059453223],
            [4.145979199011336, -8.202528535949234],
            [4.148582185044637, -8.20805412833869],
            [4.151374909751475, -8.219168845961837],
            [4.160191579389402, -8.228517558406791],
            [4.1648772108058205, -8.2357235926057],
            [4.169072003671404, -8.248299151650603],
            [4.181461061302925, -8.252305174451237],
            [4.1826385377701, -8.254654116285838],
            [4.122610187594817, -8.257835211216792],
            [4.119335127449568, -8.257753928581568],
            [4.0675698624995364, -8.260222122938421],
            [4.060638299505102, -8.254826486323548],
            [4.050683091303145, -8.252029874464164],
            [4.050205310687187, -8.250193669566817],
            [4.044653958843095, -8.248350299510415],
            [4.035444559356192, -8.249180821119678],
            [4.032016873134446, -8.243435484950016],
            [4.022522764312642, -8.243539466258955],
            [4.017919139094711, -8.239571119619],
            [3.9704006969598273, -8.260427539730426],
            [3.960719749281893, -8.264336152430248],
            [3.9569161639770494, -8.263658504944868],
            [3.951353126003134, -8.259344388860846],
            [3.9492197202890673, -8.259525738235824],
            [3.9430263060610695, -8.25644439063745],
            [3.9352951277849484, -8.249902055269201],
            [3.9315730339228043, -8.250218205076472],
            [3.9246828565336767, -8.253289010974694],
            [3.921571382148079, -8.267654218691078],
            [3.92119179060593, -8.272060265323498],
            [3.9229438947971103, -8.278876644427186],
            [3.919471383706317, -8.284987624686847],
            [3.9172636326043526, -8.292107133968848],
            [3.913173154249673, -8.290601065594148],
            [3.907488296297291, -8.293308840811799],
            [3.9068529492156547, -8.296609672606255],
            [3.897615764767771, -8.290924495084093],
            [3.8938651003278766, -8.290306304080245],
            [3.8905608483897667, -8.295201142815046],
            [3.887751370175243, -8.295418791500426],
            [3.886249776935269, -8.300860733377256],
            [3.8774343341500708, -8.299567333909158],
            [3.874894753226794, -8.294861968065076],
            [3.8719670117818055, -8.29409273634032],
            [3.872691545994342, -8.289070938518984],
            [3.8685813031050227, -8.284609552840147],
            [3.8637130908474075, -8.283695689064855],
            [3.8589131632643574, -8.284960714137487],
            [3.8498582605784515, -8.296590030564056],
            [3.8361917470362186, -8.30339158732978],
            [3.8354522089523417, -8.311153535421912],
            [3.83413021792279, -8.313090490623914],
            [3.8355099822906893, -8.318107857600795],
            [3.8336637033511085, -8.321350865439562],
            [3.83525681702261, -8.324346461499413],
            [3.8319879422845378, -8.330208783343926],
            [3.8312338500367886, -8.334531007441283],
            [3.827206439703752, -8.334234615903233],
            [3.7880473342249865, -8.36662916564786],
            [3.787736396667357, -8.344872376891066],
            [3.773151592375568, -8.345430459485064],
            [3.7718369222428656, -8.316597730438984],
            [3.7570644596827205, -8.31739485458912],
            [3.754776673572695, -8.26711203624971],
            [3.7529794747520406, -8.231080037832474],
            [3.6946864399742214, -8.233554297894928],
            [3.6924955244271893, -8.190450594118719],
            [3.6688367438535696, -8.191122774440469],
            [3.595969411599309, -8.194157977798357],
            [3.5732668504780967, -8.19520413618497],
            [3.5320091401950977, -8.196691828820216],
            [3.5280762871582265, -8.196653346939506],
            [3.4789532541904666, -8.198225520834203],
            [3.4819545513819667, -8.192886274803472],
            [3.486572950616843, -8.187356537276067],
            [3.489643044436391, -8.186753690073916],
            [3.4955312935567138, -8.18296332681133],
            [3.4984112242192613, -8.18436020468989],
            [3.5030201498343945, -8.182968707972458],
            [3.50436882000729, -8.178310442442786],
            [3.502401754132131, -8.17061671498216],
            [3.5026625059900556, -8.164074515748522],
            [3.5051060476373994, -8.162026920061555],
            [3.5065028744155176, -8.153361838096956],
            [3.5120481258704737, -8.150004189539283],
            [3.514662467786888, -8.143613533813001],
            [3.5216969037997847, -8.144135263198411],
            [3.5284206050280162, -8.140746523316599],
            [3.5307223015307834, -8.14347147173244],
            [3.5358888871634044, -8.140262114270493],
            [3.5440362803321586, -8.13794279958994],
            [3.591661844300752, -8.13604757591737],
            [3.6747859103882785, -8.133021947312196],
            [3.673934089606228, -8.103733888337874],
            [3.7176149133276337, -8.102160808025168],
            [3.7156226913943855, -8.053535488558303],
            [3.7217973967450697, -8.045316571205381],
            [3.720420852895952, -8.041011507674348],
            [3.7205506530303945, -8.029919959851348],
            [3.724032368493098, -8.022776973386135],
            [3.7235543932629263, -8.014495114737427],
            [3.7289962505807215, -8.01112230355352],
            [3.7360171677608296, -8.003644919658345],
            [3.7418056073608557, -8.00314729326639],
            [3.74318532873393, -7.996758863874646],
            [3.746822405638909, -7.996011760571323],
            [3.743333351438987, -7.908101783846049],
            [3.7428428442957675, -7.902601257441751],
            [3.734465421077026, -7.90073166180508],
            [3.7315825971434182, -7.896854784991258],
            [3.726638998512775, -7.892928422953462],
            [3.721107770600396, -7.891891573615736],
            [3.7128678482809363, -7.887134799550885],
            [3.7087007066069146, -7.8789431324308286],
            [3.7071397653332787, -7.840704906873381],
            [3.705455724433055, -7.823945634986252]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.00575531982106,
          "lat": 30.598931004698162
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22097"],
        "coty_name": ["St. Landry"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Landry Parish"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01629479"
      },
      "bbox": [
        3.4789532541904666, -8.36662916564786, 4.1826385377701,
        -7.810313773436207
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [19.846144560195643, 8.173373065688994],
              [19.84937994732062, 8.175879785834164],
              [19.84999773208469, 8.16875466942681],
              [19.847450039181602, 8.169194206908893],
              [19.846144560195643, 8.173373065688994]
            ]
          ],
          [
            [
              [19.817503733657414, 8.219412939665938],
              [19.81869833848076, 8.223843427328033],
              [19.82220229897243, 8.223269239797931],
              [19.81997935147394, 8.217665254655895],
              [19.817503733657414, 8.219412939665938]
            ]
          ],
          [
            [
              [19.817109385385162, 8.188166190286353],
              [19.818518368366234, 8.193534324918218],
              [19.8215025494123, 8.193661652642541],
              [19.820763571141363, 8.180048078177805],
              [19.817626350579868, 8.184071137847393],
              [19.817109385385162, 8.188166190286353]
            ]
          ],
          [
            [
              [19.759232455843147, 8.215407962469424],
              [19.765811983811073, 8.217641638510152],
              [19.775526296715142, 8.214034439367264],
              [19.77714477284588, 8.209465604880899],
              [19.766900177496268, 8.20854985511215],
              [19.765584568532788, 8.212657466960763],
              [19.760077128377887, 8.212582442273396],
              [19.759232455843147, 8.215407962469424]
            ]
          ],
          [
            [
              [19.76055404940801, 8.180254459559237],
              [19.762295385897797, 8.184438227114393],
              [19.765739171124746, 8.183371817920865],
              [19.77635643801247, 8.189042304236457],
              [19.77907061430414, 8.189088688579103],
              [19.783683922330287, 8.192512518210963],
              [19.786443331547556, 8.19622501476843],
              [19.786880926627376, 8.203176578885442],
              [19.788527746296314, 8.208747589765693],
              [19.791018028961933, 8.211285503811403],
              [19.79377143073409, 8.209322220516801],
              [19.798205968365494, 8.210388070354753],
              [19.798247371547223, 8.204918247349504],
              [19.805477342511583, 8.204217994671195],
              [19.81003447004241, 8.191043551695072],
              [19.81254105735621, 8.186825028029837],
              [19.812585280945996, 8.18312274346746],
              [19.815672963848744, 8.168861788723671],
              [19.81734460928015, 8.165164427483393],
              [19.81667253681505, 8.158329592551137],
              [19.817178018602153, 8.151193648630858],
              [19.8162705656107, 8.146601245644222],
              [19.81699851308301, 8.138744824991406],
              [19.819231890011917, 8.135893549595966],
              [19.82426595506267, 8.13594197754143],
              [19.823233577778794, 8.132059661125021],
              [19.81851002485548, 8.13197193976812],
              [19.814863588239803, 8.129262757298427],
              [19.811659310191313, 8.137001206357036],
              [19.80573461074108, 8.137211572303379],
              [19.806754985659616, 8.132021064499199],
              [19.802390959586337, 8.132117539850611],
              [19.79732214379611, 8.129184161683277],
              [19.795116694754334, 8.125226235124254],
              [19.792832493978853, 8.11323771794833],
              [19.790735196938545, 8.11442317715888],
              [19.787873570905084, 8.123924738730437],
              [19.78421097715829, 8.12621830892992],
              [19.78490889768984, 8.137017812575923],
              [19.783349824723135, 8.14758884852388],
              [19.78832602491372, 8.159195808153042],
              [19.788477961235014, 8.162248913584737],
              [19.784941962974187, 8.16457445232585],
              [19.778549708589928, 8.156861873763159],
              [19.77642667786845, 8.16769866751032],
              [19.777651019526463, 8.174116424153178],
              [19.775015098838015, 8.177590382194076],
              [19.770379867342637, 8.176003800432714],
              [19.765618678604195, 8.178773711861059],
              [19.76234149617179, 8.177772811580072],
              [19.76055404940801, 8.180254459559237]
            ]
          ],
          [
            [
              [19.66079408552764, 8.217478049435057],
              [19.662067399394687, 8.222130557155877],
              [19.66544439899651, 8.21971614248579],
              [19.66079408552764, 8.217478049435057]
            ]
          ],
          [
            [
              [19.65106345873391, 8.216232698774553],
              [19.65581102005758, 8.22291224167526],
              [19.656970823096103, 8.219012191561408],
              [19.654173661860337, 8.215902502209918],
              [19.65106345873391, 8.216232698774553]
            ]
          ],
          [
            [
              [19.636691788215924, 8.20675274334417],
              [19.637568427943126, 8.210362565028928],
              [19.643965810868416, 8.21328330435962],
              [19.64740378849086, 8.217814942019185],
              [19.64920952984829, 8.217104775569808],
              [19.64917219775639, 8.211268150333648],
              [19.646750561505886, 8.211782517136674],
              [19.642714219031266, 8.209132541532933],
              [19.640956007232482, 8.205521685376619],
              [19.636691788215924, 8.20675274334417]
            ]
          ],
          [
            [
              [19.71841850707391, 7.931484638445062],
              [19.721857386291603, 7.946874719753349],
              [19.725468178047436, 7.946533540944549],
              [19.72742588510961, 7.943700206935515],
              [19.72343564918259, 7.940528221829189],
              [19.722961946195184, 7.936651815716672],
              [19.72037574726395, 7.931083359797778],
              [19.71841850707391, 7.931484638445062]
            ]
          ],
          [
            [
              [19.61916664972492, 8.098333709932263],
              [19.621171544685737, 8.101855199032316],
              [19.62687474254522, 8.094552678862085],
              [19.619689531145895, 8.09487918967782],
              [19.61916664972492, 8.098333709932263]
            ]
          ],
          [
            [
              [19.67567382242299, 7.892370328969885],
              [19.677455589377175, 7.8973637411947175],
              [19.676275148998577, 7.904071160532755],
              [19.681250048836468, 7.91095583398986],
              [19.68581471717507, 7.912407470306451],
              [19.6867281412667, 7.908062152246423],
              [19.68344041531518, 7.905321257020358],
              [19.6841365198198, 7.895107905155935],
              [19.681445238556034, 7.8923021068603125],
              [19.67567382242299, 7.892370328969885]
            ]
          ],
          [
            [
              [19.66195992022995, 7.921466163366697],
              [19.66381045343233, 7.926182310047005],
              [19.66217631619991, 7.9339600160131125],
              [19.66007883505074, 7.9367994304094065],
              [19.666770236377157, 7.94529795206082],
              [19.67450478751516, 7.940380503502496],
              [19.677820903951357, 7.935463429915107],
              [19.675199713701964, 7.926021372261542],
              [19.67133050713212, 7.924578434824802],
              [19.67277572272863, 7.921587870705374],
              [19.67017742407698, 7.918346340781616],
              [19.662003981804876, 7.916819130055319],
              [19.66195992022995, 7.921466163366697]
            ]
          ],
          [
            [
              [19.60176754941851, 8.11886227436277],
              [19.605839692295028, 8.123070750190656],
              [19.60638313792058, 8.126036010543988],
              [19.612469493367424, 8.122851832407944],
              [19.60925192277198, 8.115661810859335],
              [19.60176754941851, 8.11886227436277]
            ]
          ],
          [
            [
              [19.58942805315646, 8.151619990750916],
              [19.59064908883827, 8.15522733085894],
              [19.5877351951405, 8.15968262384667],
              [19.586921992747957, 8.167218662838287],
              [19.590598450828026, 8.179940129029854],
              [19.598015362581595, 8.184212248400508],
              [19.609065826989536, 8.184595277971345],
              [19.616067200545576, 8.18309647733989],
              [19.619917399427617, 8.176090659356717],
              [19.619691846747628, 8.164895235086545],
              [19.624965538662604, 8.171021758925274],
              [19.625676575040853, 8.177587410432581],
              [19.62877300096674, 8.181490520924275],
              [19.627150243938885, 8.187554588519047],
              [19.623501600605366, 8.187906841191769],
              [19.622295774797347, 8.191971009288359],
              [19.62621794057625, 8.194877080048629],
              [19.625953851079963, 8.198156044673674],
              [19.628975408061002, 8.19991757776678],
              [19.63137152845709, 8.196022701515819],
              [19.632057205757224, 8.187744395119338],
              [19.63494988569865, 8.185759680546349],
              [19.639573117877752, 8.18869452880845],
              [19.642952416582236, 8.194623851226133],
              [19.650033376749132, 8.192268592842936],
              [19.650887696619495, 8.189887812597],
              [19.65627432773131, 8.192142469896785],
              [19.659132467838962, 8.189088404283112],
              [19.658732915508715, 8.182081189725759],
              [19.66377030661505, 8.179014546381083],
              [19.66824518237365, 8.179903897266508],
              [19.677034130792237, 8.174283241841225],
              [19.67788049320205, 8.170163521412217],
              [19.69034768539447, 8.162837389672614],
              [19.68807756261878, 8.151388360807587],
              [19.6928309512502, 8.14853046424365],
              [19.68890897631337, 8.1366459356379],
              [19.68491340057968, 8.135564299227672],
              [19.68256485829441, 8.123450060797365],
              [19.67767885970672, 8.124302019583087],
              [19.676202926301798, 8.122103374899524],
              [19.67975965271283, 8.117300500537759],
              [19.679015669677746, 8.114429499142052],
              [19.674284687257636, 8.110043352325471],
              [19.665070712166198, 8.106471791347163],
              [19.657423900378397, 8.108852141689075],
              [19.653783271224736, 8.112747148502885],
              [19.651756814458224, 8.111804673588965],
              [19.649098725828722, 8.106040578368775],
              [19.65123435685817, 8.099050387008598],
              [19.64817799299929, 8.096873577682347],
              [19.63641419312165, 8.098320616947957],
              [19.631655458831542, 8.104920465668771],
              [19.630679425423647, 8.116468543415738],
              [19.624272248458613, 8.12132794157269],
              [19.62107992434897, 8.122523262924528],
              [19.620594419478515, 8.127156084612619],
              [19.618218924477333, 8.128587580449437],
              [19.61745894717201, 8.137737086510576],
              [19.61128825732496, 8.140010746648446],
              [19.60540032195778, 8.147315965996677],
              [19.603356157231243, 8.145838663993825],
              [19.607635117818216, 8.132586889907126],
              [19.597866079175514, 8.135563857860904],
              [19.595679841566586, 8.146615280582111],
              [19.593447714138648, 8.150562563217163],
              [19.58942805315646, 8.151619990750916]
            ]
          ],
          [
            [
              [19.60028128489463, 8.104107349279937],
              [19.602610911213212, 8.110619911888751],
              [19.607757410617083, 8.103590346304024],
              [19.603741681256842, 8.100703716513806],
              [19.60028128489463, 8.104107349279937]
            ]
          ],
          [
            [
              [19.56256569773445, 8.160702398332633],
              [19.563330630223955, 8.165501302847478],
              [19.56788655422809, 8.174061331224609],
              [19.56434856637835, 8.178248757236503],
              [19.56463672261872, 8.182652706442761],
              [19.569421798390742, 8.187759703851185],
              [19.568950636047074, 8.192009774243589],
              [19.571794974478546, 8.200965911043705],
              [19.57403584429329, 8.200308703645227],
              [19.576797114461083, 8.207348368771074],
              [19.579723915257834, 8.20743984641944],
              [19.585861262239447, 8.215633369619633],
              [19.588420800213942, 8.217788768638599],
              [19.59582595334544, 8.230231100463818],
              [19.59955381158133, 8.232908519534455],
              [19.59999788190902, 8.236249607775946],
              [19.60467740585694, 8.241172119342274],
              [19.609673145877217, 8.248606411759322],
              [19.61387152421394, 8.247960154741271],
              [19.617727840268547, 8.249407509777566],
              [19.618844974408955, 8.25210326794596],
              [19.623873369435188, 8.254497361599391],
              [19.62948236530376, 8.24943052901243],
              [19.625516201724423, 8.244976184952234],
              [19.63190168677158, 8.241365541546047],
              [19.63426543836677, 8.233602834318413],
              [19.6364196777114, 8.23150460493948],
              [19.640050801610702, 8.23420823188523],
              [19.64399218318164, 8.231045778475561],
              [19.639306916611933, 8.226578786729172],
              [19.64228846437239, 8.222505273292015],
              [19.646945614596913, 8.226508868763785],
              [19.648412278049, 8.22216932339904],
              [19.64388410429392, 8.218819070478137],
              [19.641249212127676, 8.218848080603204],
              [19.63897119760272, 8.215184383325731],
              [19.63450127296985, 8.21353077306006],
              [19.634569341216753, 8.218669978417932],
              [19.63051762967241, 8.219785882339098],
              [19.62843245501337, 8.215471874519924],
              [19.62074918014624, 8.212708741429044],
              [19.623700646481442, 8.209329510350205],
              [19.617499900973964, 8.202760650887662],
              [19.613388153703887, 8.20527310791305],
              [19.61121209165021, 8.20305210100908],
              [19.61238774951219, 8.199686324224501],
              [19.61815733548974, 8.19218107351072],
              [19.606065853842082, 8.1881384007195],
              [19.599191164592046, 8.188614861943984],
              [19.591641292535815, 8.183598081389366],
              [19.586390702760664, 8.1827805304409],
              [19.592662596185406, 8.18972124888216],
              [19.595526164988335, 8.196201108079768],
              [19.601050745591852, 8.200276524123373],
              [19.59997939517525, 8.205085261237738],
              [19.592035307588354, 8.202601962080074],
              [19.589524644367234, 8.198520226476802],
              [19.590198769179366, 8.196244506972128],
              [19.58597825588088, 8.192548507409013],
              [19.582605568317994, 8.185390707966793],
              [19.57840102460764, 8.185231064997215],
              [19.576552070991987, 8.180104147548162],
              [19.573355519277296, 8.179530332636594],
              [19.571140053070845, 8.176239878518222],
              [19.569262393376302, 8.16880951953273],
              [19.569296491843613, 8.159106669662929],
              [19.56256569773445, 8.160702398332633]
            ]
          ],
          [
            [
              [19.527641409669485, 8.243867165983627],
              [19.52984386698338, 8.244514297760077],
              [19.528439863525172, 8.239181029678521],
              [19.530303955487113, 8.23351270210731],
              [19.525955098429378, 8.232049321637492],
              [19.523949473442546, 8.240635211394702],
              [19.527641409669485, 8.243867165983627]
            ]
          ],
          [
            [
              [19.571661265299642, 7.952103575219277],
              [19.576697635933424, 7.9521228294293325],
              [19.580446539260194, 7.947016259360465],
              [19.576458540671364, 7.944267361786204],
              [19.571661265299642, 7.952103575219277]
            ]
          ],
          [
            [
              [19.553660094989215, 7.954705792911002],
              [19.559304528103613, 7.95544937817614],
              [19.55648076530052, 7.950555729528123],
              [19.553660094989215, 7.954705792911002]
            ]
          ],
          [
            [
              [19.50282110519028, 8.105702051549395],
              [19.502824772480842, 8.111710054968125],
              [19.505666885711385, 8.116456206345429],
              [19.511655383760306, 8.111460713953194],
              [19.51020933210528, 8.105890870820884],
              [19.503962716982965, 8.103027412858582],
              [19.50282110519028, 8.105702051549395]
            ]
          ],
          [
            [
              [19.501979342301574, 8.095917176098705],
              [19.504392812357047, 8.098556902204583],
              [19.50684902674189, 8.092019615063144],
              [19.502802910213504, 8.092004033619865],
              [19.501979342301574, 8.095917176098705]
            ]
          ],
          [
            [
              [19.514301840300824, 8.031738198841433],
              [19.513045708097682, 8.037215901553187],
              [19.516239693420886, 8.039022254310025],
              [19.519118640539247, 8.043017174444753],
              [19.52470423922718, 8.040402748357426],
              [19.52164418236403, 8.031813059255734],
              [19.520348018064436, 8.02445593534708],
              [19.513261926206674, 8.029845228215912],
              [19.514301840300824, 8.031738198841433]
            ]
          ],
          [
            [
              [19.50265995818197, 8.039351812755584],
              [19.508690781679025, 8.043946409618906],
              [19.513943283800483, 8.042605689567502],
              [19.505376722361774, 8.03252642815997],
              [19.50265995818197, 8.039351812755584]
            ]
          ],
          [
            [
              [19.503972436205935, 8.00800481153777],
              [19.507091601983593, 8.011605539156823],
              [19.512062562281493, 8.007373127632242],
              [19.509555501142557, 8.000807800478004],
              [19.503972436205935, 8.00800481153777]
            ]
          ],
          [
            [
              [19.494378416779554, 8.007765260070295],
              [19.50627011989291, 8.018626030450895],
              [19.511017808810827, 8.026013011389765],
              [19.512555874036998, 8.02380146212017],
              [19.51202703844698, 8.014870964197026],
              [19.5061890298992, 8.013469477395036],
              [19.50229900646562, 8.010401261175872],
              [19.497759286195244, 8.003759249462165],
              [19.494378416779554, 8.007765260070295]
            ]
          ],
          [
            [
              [19.500875922585763, 7.892959016945805],
              [19.501314086706763, 7.898825924331634],
              [19.49977410606616, 7.901081300496062],
              [19.49932510081252, 7.909377687587497],
              [19.497375954910556, 7.9164945643820195],
              [19.498875387634804, 7.919410012285006],
              [19.502643078512612, 7.9214242150829985],
              [19.50517518177997, 7.903839858347774],
              [19.503976571568497, 7.900656588452185],
              [19.50501241364898, 7.896518560628526],
              [19.508981698257806, 7.895710048796147],
              [19.508698500986345, 7.892433869230984],
              [19.500875922585763, 7.892959016945805]
            ]
          ],
          [
            [
              [19.423221632463594, 7.91983849125331],
              [19.423651433963162, 7.926872642378042],
              [19.426880230059126, 7.927975325453157],
              [19.4315520226442, 7.923334408552941],
              [19.42818374426464, 7.917296695249927],
              [19.422791217962036, 7.91705710731219],
              [19.423221632463594, 7.91983849125331]
            ]
          ],
          [
            [
              [19.387682236815195, 7.860558479463351],
              [19.39603332210463, 7.865429686669502],
              [19.399255401898284, 7.856886157891064],
              [19.390935324620052, 7.852442792345667],
              [19.388299635635803, 7.854172517586322],
              [19.387682236815195, 7.860558479463351]
            ]
          ],
          [
            [
              [19.366780793291834, 7.922610485202757],
              [19.370358603638902, 7.929152588537264],
              [19.372883641298934, 7.920487923015474],
              [19.368620155921917, 7.918852200086169],
              [19.366780793291834, 7.922610485202757]
            ]
          ],
          [
            [
              [19.362400365093226, 7.900901024877197],
              [19.367179958202353, 7.9031202408480254],
              [19.368796890088994, 7.900622608180968],
              [19.36991315551004, 7.894155962977492],
              [19.368777003698852, 7.8913217510402545],
              [19.362832894869157, 7.897224690988769],
              [19.362400365093226, 7.900901024877197]
            ]
          ],
          [
            [
              [19.361048244774423, 7.8843288464625],
              [19.364035385732667, 7.887485586200422],
              [19.366966033661708, 7.886668972995719],
              [19.37269414754747, 7.8809203502999114],
              [19.374329744564537, 7.8771330352895195],
              [19.370347127331677, 7.876172136809673],
              [19.36887591435896, 7.880006450218791],
              [19.36505247853364, 7.88033214436611],
              [19.361048244774423, 7.8843288464625]
            ]
          ],
          [
            [
              [19.372074371092566, 7.844970773969246],
              [19.37334300654339, 7.85184975416944],
              [19.372224194748195, 7.860574175004334],
              [19.37016235111937, 7.864232833187237],
              [19.37158375362811, 7.8678721244347765],
              [19.37621690513644, 7.864552822241301],
              [19.379550065533426, 7.864541670119614],
              [19.38092628473158, 7.853707807238731],
              [19.381126286644555, 7.846431418800458],
              [19.378298331104634, 7.842963279150409],
              [19.374858670603597, 7.841765452506105],
              [19.372074371092566, 7.844970773969246]
            ]
          ],
          [
            [
              [19.33412661873537, 7.903043522356898],
              [19.337885327591337, 7.9120858582775195],
              [19.33993272222077, 7.911622966749219],
              [19.34019509197468, 7.9030809258836605],
              [19.33901596903737, 7.899655907945555],
              [19.33528291653823, 7.898601357629235],
              [19.33412661873537, 7.903043522356898]
            ]
          ],
          [
            [
              [19.31634323824644, 7.879379162790845],
              [19.318597952748753, 7.884874125195605],
              [19.323876505895115, 7.887013656899971],
              [19.324234096565934, 7.879674045808831],
              [19.32216836836165, 7.8737028008604515],
              [19.31971504519924, 7.872007370011066],
              [19.31634323824644, 7.879379162790845]
            ]
          ],
          [
            [
              [19.183113994165073, 8.274378018107905],
              [19.185217661818584, 8.280080507481422],
              [19.181165489010834, 8.282500133727574],
              [19.18399140797822, 8.29017974943363],
              [19.188448558953677, 8.288874196322288],
              [19.18944579714082, 8.291602069040394],
              [19.231768790936258, 8.267923343679417],
              [19.269380085709397, 8.336826258937668],
              [19.291207363974976, 8.324736782427166],
              [19.341828736998632, 8.295501634743236],
              [19.356620221862837, 8.287323984248632],
              [19.400719355722778, 8.261845130130741],
              [19.453452429915174, 8.28107094338257],
              [19.466514824755397, 8.273938583586563],
              [19.466178606968924, 8.267095482833362],
              [19.462713196895677, 8.256985502626346],
              [19.46280416823467, 8.24807311202108],
              [19.46611420884874, 8.238835619659525],
              [19.464494900194794, 8.235146090632414],
              [19.458980214131056, 8.232970351670188],
              [19.45688624768103, 8.22866645669562],
              [19.461275107993977, 8.225174761056506],
              [19.465342250083385, 8.218701800615472],
              [19.46461133156205, 8.212038469342065],
              [19.46536653996101, 8.205289508787947],
              [19.470306324158496, 8.19491986526776],
              [19.46740750593319, 8.187832501502434],
              [19.464548776796367, 8.194214438540168],
              [19.45467682693754, 8.203709821864383],
              [19.453447803762796, 8.202474507816111],
              [19.456250809423718, 8.195349619622004],
              [19.45591703725948, 8.17981986754182],
              [19.45630572708211, 8.175603225468866],
              [19.459929173447083, 8.17048662812066],
              [19.460837147792525, 8.163662755657901],
              [19.460331040778538, 8.158604583199104],
              [19.4569983132167, 8.15729181193143],
              [19.454084873273956, 8.152747517461131],
              [19.457605331535706, 8.150408881676817],
              [19.459173041913527, 8.153507523605164],
              [19.4660293789651, 8.155482911987402],
              [19.468430214583382, 8.146115592395036],
              [19.467241648212394, 8.136060154584152],
              [19.46490185033202, 8.133981205121561],
              [19.45919304548671, 8.136570052398534],
              [19.45386105588247, 8.13362267127955],
              [19.454903742047954, 8.130040491500207],
              [19.453180123579934, 8.126894981632999],
              [19.4572899590034, 8.121849415687377],
              [19.454850033293216, 8.118195513211344],
              [19.46018447408245, 8.11137726250767],
              [19.456814855921838, 8.107282814108562],
              [19.46059674404732, 8.104662530768667],
              [19.462968693249962, 8.09598315415861],
              [19.46512773572703, 8.101904188978358],
              [19.470771195503247, 8.105864694804751],
              [19.477960367895292, 8.113427955583855],
              [19.486210946747995, 8.11689680101871],
              [19.490536211135648, 8.121738560714876],
              [19.494384861592863, 8.122565171931136],
              [19.50024210861346, 8.121436517962714],
              [19.499386975253152, 8.114958570837269],
              [19.496196760583462, 8.113154542185601],
              [19.497632043597633, 8.105265672080424],
              [19.495473930834546, 8.096338033455622],
              [19.492127056826664, 8.096069319959941],
              [19.4892488671509, 8.089965226056393],
              [19.491630765121737, 8.084095370407884],
              [19.486670634074027, 8.083361008032606],
              [19.485577659259267, 8.07901649983901],
              [19.49228799711088, 8.071511772178095],
              [19.491115903056, 8.067153463901148],
              [19.480257341868903, 8.060641911748158],
              [19.478579457701702, 8.05611448233922],
              [19.470062136595182, 8.047254535579343],
              [19.469680010239163, 8.042942038493987],
              [19.463024755766355, 8.033254307307713],
              [19.465971009895465, 8.030201474228289],
              [19.468886599773228, 8.024494595041649],
              [19.471739527696855, 8.021423131279011],
              [19.48012605930738, 8.020651291772587],
              [19.4796279649591, 8.014491509321642],
              [19.47048980931698, 8.01334076478385],
              [19.467609802414618, 8.019173098715076],
              [19.464099214142113, 8.019048115356401],
              [19.46224767671568, 8.01568408431165],
              [19.463743357514346, 8.012398865379874],
              [19.46124070149062, 8.004600219574002],
              [19.46208186363149, 8.001125564941733],
              [19.473443631956812, 8.00049975545653],
              [19.476879681077197, 7.997608047268049],
              [19.47216767365045, 7.993223886430343],
              [19.46257159731974, 7.99400913716189],
              [19.45734249487316, 7.999058237016654],
              [19.455737955289692, 8.004610998613087],
              [19.45248563642187, 8.004207119107479],
              [19.4518609191712, 7.99907243352429],
              [19.448433816942796, 7.999937057576988],
              [19.44439878180123, 8.008955747173642],
              [19.441595913764655, 8.004440654350983],
              [19.441332680564795, 7.999631609466593],
              [19.438039241028623, 7.993233098724452],
              [19.442013437342926, 7.9854473053045725],
              [19.43718643045243, 7.981936676674899],
              [19.439083447602524, 7.9779835416871645],
              [19.437635024380228, 7.9746554359505994],
              [19.440131879485165, 7.967025316651551],
              [19.435730198289704, 7.963905165196035],
              [19.43546918004251, 7.957733252594316],
              [19.432072023381863, 7.946222338490035],
              [19.42804116243919, 7.940070209006702],
              [19.429710754854355, 7.937448145641772],
              [19.427442392201705, 7.933452437467932],
              [19.421686511736425, 7.934812984164694],
              [19.416853947864578, 7.9313019712086765],
              [19.407271740353814, 7.927307408135078],
              [19.409727041417472, 7.922904205539184],
              [19.403290549954196, 7.915098430761117],
              [19.399289092775213, 7.911555899091647],
              [19.39451722417113, 7.909511226038222],
              [19.391328042412464, 7.905993731431307],
              [19.38721491282036, 7.906338413414823],
              [19.385027827641334, 7.912622877565101],
              [19.38710655673481, 7.918945603804928],
              [19.385705259296696, 7.92734307866254],
              [19.38755773252238, 7.935394294099131],
              [19.380075044640794, 7.938128395005012],
              [19.374775041005325, 7.945989364607574],
              [19.36918986389264, 7.944625040037581],
              [19.366640592383074, 7.937650737152385],
              [19.35987108818219, 7.9272542310738086],
              [19.354009462586212, 7.922532591570324],
              [19.35122296996769, 7.926252200992906],
              [19.35407579772065, 7.933883433526232],
              [19.357983411671984, 7.94039868241719],
              [19.357086102010417, 7.945721144058915],
              [19.35082414443679, 7.9432224458968275],
              [19.350247883884432, 7.946421376694984],
              [19.340126626556085, 7.950057206126798],
              [19.338889772306473, 7.945832823539379],
              [19.335714881342042, 7.943333397512264],
              [19.340121001846498, 7.937334554914703],
              [19.345869302236245, 7.935258283129993],
              [19.347783114536327, 7.931732422359031],
              [19.345490218781908, 7.925588947893854],
              [19.339381215738396, 7.924023171818177],
              [19.335714049334477, 7.92687098957994],
              [19.33291757637037, 7.92347419032513],
              [19.332911564773827, 7.913323897037003],
              [19.33130353527934, 7.905427180944009],
              [19.326990740104637, 7.905613753128503],
              [19.325083071876925, 7.89810672844657],
              [19.31861448422874, 7.8959650575557285],
              [19.318225007527936, 7.899750442170084],
              [19.32157216329566, 7.904550074074705],
              [19.324318224414593, 7.911757825506217],
              [19.320675129393013, 7.916089723761741],
              [19.323871634511992, 7.923669884488436],
              [19.323571459719087, 7.928363904045665],
              [19.327275668449314, 7.927827106759107],
              [19.32774766352963, 7.9384054530787225],
              [19.331573022254215, 7.942328338515604],
              [19.336622879823228, 7.949963250730627],
              [19.331979495344473, 7.95131427764682],
              [19.32963918940927, 7.945315659516614],
              [19.325461363016014, 7.947485879061161],
              [19.325594400125425, 7.95495547877732],
              [19.31930921149039, 7.9570552284276],
              [19.317089478210022, 7.950053233437785],
              [19.319940968553322, 7.945734461402194],
              [19.313340598698712, 7.936016584742039],
              [19.31144919636078, 7.937120206281873],
              [19.30672509120729, 7.9472756092716885],
              [19.30822622853529, 7.964684705787562],
              [19.303815381340335, 7.964727326392519],
              [19.301847158260443, 7.982511777252903],
              [19.307038541670817, 7.982001785896333],
              [19.308054433765133, 7.985961047692209],
              [19.31274525536143, 7.9917027442633435],
              [19.31492567005202, 7.988754357919888],
              [19.32015373036404, 7.986222420556893],
              [19.324324295593854, 7.980447195781765],
              [19.32920458919194, 7.984705306243515],
              [19.326123258189142, 7.994320257890106],
              [19.327359038788448, 8.002472817560019],
              [19.3289766692047, 8.004423037142384],
              [19.32616996817765, 8.010695171798957],
              [19.326961060802606, 8.016266122118761],
              [19.328887862925086, 8.017915754198885],
              [19.330324467731685, 8.023868605924354],
              [19.333344729829278, 8.024501724311696],
              [19.33754748226812, 8.028357432881178],
              [19.335030856704535, 8.033128143226584],
              [19.33443615299064, 8.039508990035616],
              [19.347064243916314, 8.036492069925913],
              [19.34390620307854, 8.047937101900398],
              [19.32001045108895, 8.074168018821478],
              [19.315016777520718, 8.07170570086804],
              [19.310065221480823, 8.108740259739905],
              [19.265385550591912, 8.175259992843865],
              [19.24279511175584, 8.164724279329102],
              [19.218093006546876, 8.16313773505251],
              [19.217385068392694, 8.171688581468977],
              [19.195230074426917, 8.173236695204368],
              [19.173974656104956, 8.203900834067285],
              [19.17389280404894, 8.226768871067483],
              [19.158467968523283, 8.252870090054525],
              [19.165333939915808, 8.26569798954882],
              [19.180310452289703, 8.266666400497257],
              [19.183113994165073, 8.274378018107905]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.16963779935307, "lat": 44.14166859960191 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23013"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00581292"
      },
      "bbox": [
        19.158467968523283, 7.841765452506105, 19.84999773208469,
        8.336826258937668
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.995364456850816, 3.8004253382268196],
            [8.08144336587158, 3.810775815047775],
            [8.116469794833526, 3.8145154202038114],
            [8.166530770901685, 3.8204956261408665],
            [8.256749076020279, 3.83114400249943],
            [8.338969642483391, 3.8406028705001747],
            [8.346470648001082, 3.7782344933970005],
            [8.350897723670139, 3.7397895970183206],
            [8.35877110236988, 3.6743225947203086],
            [8.369635585081285, 3.5803201980026067],
            [8.375314388389617, 3.5295094734762515],
            [8.31134540972757, 3.5222263394980633],
            [8.210717732094482, 3.5104997177650996],
            [8.209013124221348, 3.510474180101201],
            [8.143340973260873, 3.5028078354917707],
            [8.104916122587463, 3.498630065069532],
            [8.0080603667277, 3.488088052687704],
            [8.011600206322854, 3.4928675961747464],
            [8.009693429731385, 3.4969921096596734],
            [8.010108838377699, 3.5067552604919108],
            [8.016499713726207, 3.510914799195988],
            [8.021569280135095, 3.5156788365008365],
            [8.022654665502664, 3.5215435405299167],
            [8.025547723946554, 3.524708774933408],
            [8.026683275165173, 3.5303108867829067],
            [8.019569165709507, 3.594552831475098],
            [8.016140282810827, 3.6280726803334327],
            [8.005924939227512, 3.7148066250816063],
            [7.995364456850816, 3.8004253382268196]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.52775351175944, "lat": 41.91444035739168 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26149"],
        "coty_name": ["St. Joseph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Joseph County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01625034"
      },
      "bbox": [
        7.995364456850816, 3.488088052687704, 8.375314388389617,
        3.8406028705001747
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.751823595875645, 5.872700527833041],
            [0.7604782832068061, 5.8729471911588575],
            [0.7969522478556325, 5.872632671397464],
            [0.8913562959084088, 5.872900064581208],
            [0.9184947774519728, 5.873070334059351],
            [0.9182499893309767, 5.9229046648801935],
            [0.9178290109996796, 5.974200680934992],
            [0.9175955432306703, 6.029352491423689],
            [0.9218020780656518, 6.026966137001942],
            [0.9299604662687984, 6.026811476915286],
            [0.9350915740721617, 6.025795584496356],
            [0.9412590344713964, 6.022825113409147],
            [0.9457018534627645, 6.024262717877529],
            [0.9503720071912432, 6.022697570762799],
            [0.9527228461857716, 6.018548746322757],
            [0.9513105844121638, 6.01421031592278],
            [0.9517154422033915, 6.0073255197022055],
            [0.9587857984261741, 5.999365597519744],
            [0.9650240052428006, 5.995563209260457],
            [0.9675033351217693, 5.992696127101397],
            [0.9828788681635082, 5.990595377157345],
            [0.9915155350572373, 5.992944508358966],
            [0.9969713342812898, 5.998678331841987],
            [1.0028012489494371, 5.996154945841765],
            [1.0078559904559798, 5.987574705343186],
            [1.0127874984408252, 5.9834530363302285],
            [1.0152035566508084, 5.983666005154409],
            [1.0190604819990534, 5.977205529181999],
            [1.0225961781127453, 5.978457610814944],
            [1.0242740457684443, 5.973489516571089],
            [1.0269497148970042, 5.972755106453763],
            [1.0333936030064352, 5.96764342933322],
            [1.036870714326993, 5.961400619903732],
            [1.0405946416842105, 5.960227979390053],
            [1.0414868837483995, 5.956476401359865],
            [1.0472889465314041, 5.954997840514142],
            [1.050216338910612, 5.9511711101358005],
            [1.055545241540622, 5.953812275461641],
            [1.0595417479432576, 5.952020947733182],
            [1.0625577420121053, 5.948148616694761],
            [1.0668782241742407, 5.947591721383327],
            [1.0699405920079967, 5.939832000330443],
            [1.0792681471692753, 5.933390852407593],
            [1.0799191991229906, 5.92886547450791],
            [1.084542709940793, 5.930187735429547],
            [1.0903834727629154, 5.9273491245211085],
            [1.0925547836638876, 5.92187467264315],
            [1.101543374436032, 5.9180232385339115],
            [1.103988398619143, 5.906473321025838],
            [1.1052455409948017, 5.904546837440289],
            [1.1132531630666398, 5.904479378041292],
            [1.1160046977594449, 5.901956157198178],
            [1.1205255350784717, 5.9067788337613],
            [1.1262117450278775, 5.904986455674847],
            [1.1289789233394623, 5.90107493547389],
            [1.1333821393386274, 5.8996434748240185],
            [1.132836056719119, 5.895381340464888],
            [1.1382968403980702, 5.8947902114894815],
            [1.139321069037383, 5.891262502607553],
            [1.1439202128477637, 5.889593289289078],
            [1.1455690897670217, 5.891311978626634],
            [1.1507415269388177, 5.89046167292473],
            [1.1533514986018951, 5.883985533273868],
            [1.1568446863850537, 5.885748217970736],
            [1.15686082598822, 5.879839996669062],
            [1.1625982977961915, 5.884648444408344],
            [1.1640524446403189, 5.876024614801493],
            [1.1754347296875474, 5.881056200474604],
            [1.1827799883347474, 5.876661042665379],
            [1.185920136492362, 5.873462322325366],
            [1.1911351440483025, 5.874245948091336],
            [1.1926528234204359, 5.870613296132641],
            [1.1959481387102804, 5.87399948155827],
            [1.197991948635666, 5.872612438346172],
            [1.1970727143418944, 5.867119591836532],
            [1.20503184526952, 5.866336351586193],
            [1.207744067581359, 5.862681047835283],
            [1.2127884160153692, 5.86339069543683],
            [1.2154735898343514, 5.859722385712316],
            [1.2212650635198163, 5.856752896262955],
            [1.2241808630604192, 5.858731221972768],
            [1.2303382448745053, 5.854341407716825],
            [1.2316389437867774, 5.850748735807228],
            [1.2359084273694445, 5.850053099543192],
            [1.2445649348737535, 5.851612130411831],
            [1.2472872631446732, 5.855140120980182],
            [1.251740952085086, 5.852859862297125],
            [1.2552257705209369, 5.847950526942547],
            [1.256731982234724, 5.851244387122447],
            [1.2615007589076082, 5.849196795563332],
            [1.262193774739718, 5.8431908138263235],
            [1.2650564134702882, 5.840209410972656],
            [1.2649444380551327, 5.834081035286522],
            [1.2706454799753386, 5.832912676117576],
            [1.2713688116248685, 5.79083336396677],
            [1.2724653889440256, 5.653995311455983],
            [1.2729178904998826, 5.617555750741939],
            [1.2012208719412845, 5.616743281414973],
            [1.1766324127746464, 5.6166913102432],
            [1.1007641781076725, 5.615126434121564],
            [1.1006542361900549, 5.528536834504751],
            [1.0790367967640635, 5.528633077566783],
            [1.0140329698635018, 5.528003015176109],
            [0.9128533716839102, 5.527702473240631],
            [0.847830335186745, 5.52754217086067],
            [0.8085404401184595, 5.526826057232689],
            [0.7541973035852917, 5.526667977673071],
            [0.7540277890663815, 5.613963733966595],
            [0.7530970030511087, 5.701118348884987],
            [0.7530493404555525, 5.759176342069658],
            [0.7521553169118688, 5.831153544126926],
            [0.7522836284928447, 5.8397182554691085],
            [0.751823595875645, 5.872700527833041]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.25387560713109,
          "lat": 44.403635965925716
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27127"],
        "coty_name": ["Redwood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Redwood County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00659509"
      },
      "bbox": [
        0.751823595875645, 5.526667977673071, 1.2729178904998826,
        6.029352491423689
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3169038897942396, 5.552062556892514],
            [2.3544896059461347, 5.552933130228733],
            [2.402686770657899, 5.554548757725963],
            [2.491401146740191, 5.557217008395582],
            [2.574499167529137, 5.559885646126936],
            [2.5773729380964516, 5.473750374672633],
            [2.5799846206283354, 5.386254921010603],
            [2.582997637482505, 5.299238935293785],
            [2.5850515208363434, 5.233905803610346],
            [2.5853460015328893, 5.212093180415845],
            [2.5827921926793533, 5.21199014900274],
            [2.45368834120181, 5.2078782747200805],
            [2.4104919110660132, 5.206586493130532],
            [2.3263844801061833, 5.204217774962722],
            [2.3230419683310606, 5.328551024750715],
            [2.3218860469112297, 5.37803843699591],
            [2.319321975823495, 5.465051058618655],
            [2.3169038897942396, 5.552062556892514]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.22608663512459, "lat": 44.02232528807793 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27147"],
        "coty_name": ["Steele"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Steele County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00659518"
      },
      "bbox": [
        2.3169038897942396, 5.204217774962722, 2.5853460015328893,
        5.559885646126936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.3742367228833094, -6.91327133088445],
            [4.380896508256094, -6.903260155999865],
            [4.386365516739108, -6.89776826171943],
            [4.393626608379453, -6.896495668462202],
            [4.408576087103465, -6.89487109271438],
            [4.426176569282348, -6.894224740413297],
            [4.437334317507658, -6.932376647832725],
            [4.441598483296622, -6.928957084488826],
            [4.4419474729523225, -6.934445084936377],
            [4.445284207479369, -6.9342981106094115],
            [4.444513453097579, -6.9429413621282],
            [4.448931840880388, -6.944915112748674],
            [4.448638095256693, -6.948869289040852],
            [4.45107967028755, -6.9510828322051],
            [4.448558917243855, -6.9572595017943195],
            [4.4444477608062956, -6.961801339125723],
            [4.447158121125615, -6.966064743067019],
            [4.446639940187778, -6.970117443027048],
            [4.450551017810211, -6.971995128247967],
            [4.45547477828337, -6.9717208330594636],
            [4.45946014441029, -6.9754158843531],
            [4.467523342320191, -6.97706199168604],
            [4.470849416077989, -6.975718920549303],
            [4.4734592265377096, -6.97763786220473],
            [4.474992861256975, -6.985870637148207],
            [4.470866855058531, -6.99076434292031],
            [4.472352324064242, -6.994302644686906],
            [4.4878141988710905, -6.997297093710447],
            [4.496737534233811, -7.003377488904501],
            [4.503749722997063, -7.010551993855719],
            [4.516630346673013, -7.009982109218824],
            [4.570973407225171, -7.006099146652123],
            [4.571999014654151, -7.026425440125011],
            [4.573238720024115, -7.056713472796119],
            [4.5731418986895145, -7.063273825384177],
            [4.574093090641732, -7.087989180565971],
            [4.578275043526514, -7.183685998170704],
            [4.5818609872600735, -7.266711471033358],
            [4.581832797935605, -7.288616343332306],
            [4.577777521173775, -7.2847879382044365],
            [4.56991820257896, -7.290220908262002],
            [4.564092316363185, -7.285128372742843],
            [4.5573064563122205, -7.287275171440999],
            [4.556724101206017, -7.282530376643407],
            [4.554555717131722, -7.279822127091811],
            [4.5474492650705525, -7.283612183259452],
            [4.538404640411904, -7.28270758153965],
            [4.534648912435315, -7.280616580153235],
            [4.537071291502514, -7.275769119712954],
            [4.532129240514339, -7.271126377138259],
            [4.5234207127903865, -7.266383095102698],
            [4.519466598737841, -7.267869244115881],
            [4.513527116123457, -7.267622631748607],
            [4.509893061976232, -7.271385283760106],
            [4.506687596761808, -7.271478751032491],
            [4.502048717503571, -7.27594881783927],
            [4.498753832112568, -7.273999780447158],
            [4.49704300786867, -7.279470723927243],
            [4.493316701171424, -7.279088023325004],
            [4.491778144008933, -7.27049621202166],
            [4.483268118669798, -7.272061304438865],
            [4.475177556711718, -7.282892620129008],
            [4.469518853441953, -7.284628607496056],
            [4.465905445614267, -7.280878742290794],
            [4.457535895835353, -7.280573004122794],
            [4.453891481158558, -7.282187151430905],
            [4.452830694253412, -7.2871076442148395],
            [4.4471214550202856, -7.285886941746449],
            [4.443415869169236, -7.29003345718538],
            [4.436566865675468, -7.291475350240733],
            [4.426182443493374, -7.302978625823468],
            [4.419178599087694, -7.303208449190989],
            [4.413769103031917, -7.2997112908655994],
            [4.408682186811525, -7.302929142099787],
            [4.405892137331629, -7.303208766881215],
            [4.40574850783043, -7.308238188113762],
            [4.402074454788559, -7.30941362710896],
            [4.395851222647188, -7.307467733464878],
            [4.393973445639544, -7.310282349587384],
            [4.389863040763091, -7.311164314940331],
            [4.387785725353091, -7.317757754474974],
            [4.38438610700838, -7.320183854822925],
            [4.382719620815289, -7.31372494339708],
            [4.379489480219272, -7.3196360083064524],
            [4.3768099036120045, -7.319467766406514],
            [4.3663151379134, -7.321981431231981],
            [4.3648858705234055, -7.325354699103173],
            [4.360083176201861, -7.327196057957806],
            [4.357590334005569, -7.330892038092351],
            [4.348736207322924, -7.332479717981284],
            [4.346740244252619, -7.329505377669957],
            [4.340793476132594, -7.327720650344549],
            [4.3194334489514, -7.328497135287324],
            [4.32020323333758, -7.349618263467307],
            [4.317723654938278, -7.35582307970826],
            [4.317750864670325, -7.362773080462625],
            [4.315175380907493, -7.362150467322528],
            [4.311279146554579, -7.366726745557772],
            [4.301442642278867, -7.364109477768371],
            [4.298633686114623, -7.364591419925567],
            [4.29698122628251, -7.373162524221792],
            [4.302013747315744, -7.3775190796875485],
            [4.304527535204707, -7.383397818591313],
            [4.309662844675765, -7.383030221164191],
            [4.314858752858118, -7.388523945836937],
            [4.312930833976369, -7.397750203083054],
            [4.315148450879641, -7.402211506574157],
            [4.312445325915574, -7.404695295741231],
            [4.314466877477502, -7.409014317508595],
            [4.310580994933524, -7.410835500164326],
            [4.309484357648664, -7.414774517611669],
            [4.3063739706946444, -7.414628201321772],
            [4.304170331641666, -7.421234243535902],
            [4.2993291046929265, -7.424003271582995],
            [4.290836570786693, -7.423099077147699],
            [4.289480985709147, -7.4281445122268535],
            [4.280570385764719, -7.434202996090054],
            [4.271923498764663, -7.435076172737799],
            [4.272278794535553, -7.425701810709859],
            [4.270984069054074, -7.419668634095769],
            [4.267687401078013, -7.4155935717788495],
            [4.261639040613654, -7.412141602258909],
            [4.256159752396916, -7.411495949176806],
            [4.251711033835754, -7.412333256671104],
            [4.24505959247799, -7.415643398254243],
            [4.232699892333876, -7.427301633870386],
            [4.230695374978281, -7.433794295182749],
            [4.22708294922278, -7.437811901252067],
            [4.224021276468661, -7.447417698353371],
            [4.22708364598019, -7.451399174490883],
            [4.22525418692547, -7.459212611527724],
            [4.222520153908516, -7.460975043439819],
            [4.217266665380018, -7.45043088345484],
            [4.211351257343628, -7.444124831230706],
            [4.190531936852348, -7.427648793079893],
            [4.173772638487949, -7.4201019288222065],
            [4.166870193819065, -7.412170391392891],
            [4.164068999770825, -7.404842089164238],
            [4.164562023774205, -7.3992628725526135],
            [4.168823606531385, -7.3926087969695935],
            [4.174918511508459, -7.387670144212465],
            [4.177930218001577, -7.3867728625064775],
            [4.191804482421463, -7.386009203123052],
            [4.20438816517957, -7.387336816980976],
            [4.220643791773802, -7.389914116995891],
            [4.231982255069665, -7.390660225995674],
            [4.24073090932961, -7.389912759553499],
            [4.249417178429784, -7.3880982095493275],
            [4.262972635365566, -7.383164642938624],
            [4.2788959000201086, -7.374535951948278],
            [4.281278816399161, -7.371507991419978],
            [4.286389048589249, -7.357882622077652],
            [4.286128439622197, -7.336670592822864],
            [4.284182782214099, -7.332896262867783],
            [4.276681649816346, -7.326760062090829],
            [4.265103855335073, -7.318861076649602],
            [4.261051144888077, -7.312518341512693],
            [4.252673911110719, -7.30751970642252],
            [4.249662331547197, -7.3041784865200325],
            [4.249407533698444, -7.297469849937397],
            [4.2474201590590335, -7.291008007133967],
            [4.247491376064904, -7.275315161766844],
            [4.2503519770803555, -7.269037028009073],
            [4.242119380222414, -7.265499195128106],
            [4.236428417275823, -7.268946908942821],
            [4.231254318885824, -7.274758478658966],
            [4.22640535405527, -7.261768433879069],
            [4.2222830990865905, -7.2538039137308745],
            [4.2221341418385645, -7.24903390912026],
            [4.223506661128798, -7.242352292589283],
            [4.228328926077907, -7.233168162534897],
            [4.23231560561456, -7.229035741937249],
            [4.240884257730451, -7.223530951881593],
            [4.246074902023902, -7.219204153998976],
            [4.248988975591637, -7.218711676678988],
            [4.252802676941771, -7.220795282054322],
            [4.256254407150432, -7.228185477575572],
            [4.254378219472175, -7.233530801513084],
            [4.254600429677707, -7.237397491313457],
            [4.261768757379886, -7.2607349887055825],
            [4.2667889392287135, -7.269890544722204],
            [4.27661088593015, -7.279966034140008],
            [4.286903234280992, -7.284802040765727],
            [4.308395438969939, -7.2837850224783125],
            [4.313533462110884, -7.27719178636654],
            [4.314427638942508, -7.271576391841058],
            [4.313418278219558, -7.266414748540414],
            [4.31269744970351, -7.252710140924282],
            [4.308479149547197, -7.251044362569456],
            [4.305358080669108, -7.24461719370823],
            [4.287761638968972, -7.229366473455342],
            [4.275319829236681, -7.206145846233857],
            [4.273594584406936, -7.201430822305623],
            [4.27146997412182, -7.190195392437084],
            [4.26941064639944, -7.167447907649768],
            [4.26956011744464, -7.152571164752149],
            [4.271006256261171, -7.147531017892334],
            [4.270890970336749, -7.1408216224979615],
            [4.265942009533277, -7.137967687757499],
            [4.263802968859615, -7.133793228723763],
            [4.263862681270916, -7.129217618081489],
            [4.269149495617957, -7.120177288694117],
            [4.27676031705684, -7.1177537424996995],
            [4.282374406307463, -7.117839077562655],
            [4.291199516469536, -7.115777942404913],
            [4.299780377757275, -7.119263033903684],
            [4.324519460299033, -7.10881461720691],
            [4.334720798515383, -7.101845355432275],
            [4.3438104763959675, -7.093032373242121],
            [4.3531919776373815, -7.085002064582855],
            [4.358776187480921, -7.077551686753207],
            [4.360550552941223, -7.070383434862604],
            [4.361176206931763, -7.057084535106229],
            [4.353194262915107, -7.051881439329383],
            [4.34489265725481, -7.050582856276099],
            [4.33814351382352, -7.051504021656956],
            [4.33347108932054, -7.053223521947397],
            [4.315862581748696, -7.061443033102411],
            [4.3084774796392775, -7.063289701436829],
            [4.2974043642857085, -7.064412107857249],
            [4.292456020450256, -7.06394737070407],
            [4.284723827773383, -7.060322281862709],
            [4.2771172377085644, -7.055131211313677],
            [4.267923036031799, -7.044430821741153],
            [4.264675977491712, -7.039661382725104],
            [4.263205914165181, -7.032921833536024],
            [4.2638634386216125, -7.024220620484137],
            [4.267174666236258, -7.016691824146592],
            [4.271224964113248, -7.012165310740124],
            [4.279093115320254, -7.005506179944182],
            [4.283308724961979, -7.0063973593874875],
            [4.28808126157777, -7.013370766536427],
            [4.294988816924477, -7.021126954943142],
            [4.299819099333692, -7.0244906709697155],
            [4.308952796866791, -7.029047058151537],
            [4.332279153331944, -7.0356207318796296],
            [4.338356314755221, -7.036627779493309],
            [4.345547083505402, -7.036084463703009],
            [4.349383115008077, -7.034336321151665],
            [4.362147263525109, -7.026507900884048],
            [4.364147435236238, -7.020524623073697],
            [4.36547903132197, -7.002598807656459],
            [4.362632294166343, -6.984273993042908],
            [4.359615642299437, -6.958970642933173],
            [4.359228968102408, -6.949307831404673],
            [4.3610265446991905, -6.935746649096428],
            [4.3742367228833094, -6.91327133088445]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.35352766188933, "lat": 31.48286975033231 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00695726"
      },
      "bbox": [
        4.164068999770825, -7.460975043439819, 4.5818609872600735,
        -6.894224740413297
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.923850696727367, -8.263561224053683],
              [6.935850533647875, -8.268758249560118],
              [6.949509162572284, -8.27144122126477],
              [6.969366173320552, -8.274410614465546],
              [6.97856250844714, -8.272614213124694],
              [6.988665533999627, -8.265618803605417],
              [7.00066420259011, -8.264610566955632],
              [7.002750834994626, -8.26938195309797],
              [6.969555046031733, -8.279020730154034],
              [6.9345154239045055, -8.27246578995052],
              [6.926216355686318, -8.268580874018783],
              [6.923850696727367, -8.263561224053683]
            ]
          ],
          [
            [
              [6.846138914069644, -8.14881286592423],
              [6.847782850530618, -8.147219445480038],
              [6.853832864752552, -8.147667973536022],
              [6.858390480394108, -8.144533481825194],
              [6.860373186807773, -8.15269339431049],
              [6.856971226123001, -8.156152057689068],
              [6.848120852729246, -8.154495210027052],
              [6.846138914069644, -8.14881286592423]
            ]
          ],
          [
            [
              [6.6984857337805535, -8.253031845832624],
              [6.713271195676403, -8.249316807333669],
              [6.727811505924407, -8.248502577393229],
              [6.735114875634551, -8.242732988285294],
              [6.7401643567930725, -8.241413853959797],
              [6.764027913406409, -8.248012442437213],
              [6.7721882527275605, -8.248854934540544],
              [6.79188098676169, -8.255667603995628],
              [6.806485786887, -8.25662617664003],
              [6.843566760606143, -8.259661932483217],
              [6.843990985557965, -8.263921963706277],
              [6.812304945619223, -8.261669822870452],
              [6.784612344602124, -8.260516820807235],
              [6.765889583390971, -8.25760705264295],
              [6.741129924020031, -8.24983256076271],
              [6.723815624719783, -8.255495939942511],
              [6.708961708616064, -8.257160149823044],
              [6.698739438685587, -8.25533587268676],
              [6.6984857337805535, -8.253031845832624]
            ]
          ],
          [
            [
              [6.558405356936161, -7.774083264787398],
              [6.601534893065497, -7.770411369975107],
              [6.601640954738116, -7.772208516158711],
              [6.7495168407579085, -7.76052220874393],
              [6.7905546969141755, -7.757180497768584],
              [6.8829407009341645, -7.749883397176788],
              [6.912788998235768, -7.747614501977983],
              [6.921298011175495, -7.746645704999987],
              [6.9619295111999335, -7.743088457005351],
              [6.965219451073383, -7.7719898062476505],
              [6.973562454107488, -7.840437312063755],
              [6.984594591746644, -7.932796631810803],
              [6.99513648056097, -8.01672654471387],
              [7.006155954506046, -8.104219097785652],
              [7.004395189726647, -8.10608619972059],
              [7.003383470146759, -8.11307669849686],
              [7.008109421446815, -8.123300867461658],
              [7.001663433754911, -8.128371040244511],
              [6.995528560978617, -8.123733546375243],
              [6.992172015556843, -8.116673739297001],
              [6.987344205465431, -8.116563469969982],
              [6.986187705561434, -8.119780090608684],
              [6.976450880529905, -8.120365882077794],
              [6.970839643720126, -8.118189391730974],
              [6.961864565106171, -8.11904564487168],
              [6.960241007579272, -8.122440883919829],
              [6.961781207962337, -8.127097938939372],
              [6.963641450753737, -8.13785887876345],
              [6.958851643841982, -8.147555635369756],
              [6.944096811771799, -8.158271910598604],
              [6.937149375017964, -8.160483611887377],
              [6.916394062410087, -8.16039110654448],
              [6.914401010480455, -8.158239317488793],
              [6.913913338713593, -8.153298944901426],
              [6.8997560869020145, -8.144957063207759],
              [6.899032932556287, -8.141834271672336],
              [6.895033656752024, -8.139816558810061],
              [6.886997492032572, -8.139582490394998],
              [6.849353268427022, -8.139972731011417],
              [6.847192180238319, -8.129549947557518],
              [6.843701864430541, -8.127286425575171],
              [6.844560100653637, -8.12049814886674],
              [6.843118176543824, -8.117739697887952],
              [6.839583041656701, -8.118665815376303],
              [6.836987818285351, -8.125616228870523],
              [6.826894508399677, -8.130679359174243],
              [6.825201943323173, -8.13300438584147],
              [6.82133775082844, -8.132020225484242],
              [6.819476781014938, -8.123025824694999],
              [6.820600179717376, -8.116498877120506],
              [6.819341172137983, -8.114878910552278],
              [6.814303352787172, -8.11608295284222],
              [6.8083467915455715, -8.120503923021912],
              [6.798555273902129, -8.12996305390905],
              [6.775948860425313, -8.129457854420119],
              [6.762912261189423, -8.136810024099352],
              [6.752747906455023, -8.145948897652843],
              [6.745791176536837, -8.15007267369155],
              [6.734319439621895, -8.152440589285876],
              [6.721555929119583, -8.15292767794818],
              [6.705671704352198, -8.14920731608291],
              [6.683019370308119, -8.133233931995928],
              [6.647213067058587, -8.116191520540347],
              [6.647500676125576, -8.114917638492555],
              [6.66082787278082, -8.116954512439783],
              [6.665474164726786, -8.115993328373976],
              [6.665915024013954, -8.113716113324223],
              [6.661822053817473, -8.108517260881937],
              [6.655307977315153, -8.109211792518721],
              [6.64775168486859, -8.106748196774145],
              [6.635584563457221, -8.100022730095528],
              [6.619928707885471, -8.094009728602757],
              [6.615380507391743, -8.083449603341776],
              [6.608668611574328, -8.081504269129503],
              [6.604253313420052, -8.074696645591661],
              [6.594093123112672, -8.081366532113554],
              [6.593839080132689, -8.086133381476895],
              [6.583358389638425, -8.087582149881857],
              [6.580449488312171, -8.052675419017037],
              [6.5775030928980245, -8.013477190101797],
              [6.572002345175117, -7.9469460931626825],
              [6.562777635035187, -7.831824928887542],
              [6.558405356936161, -7.774083264787398]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.63584891935392, "lat": 30.54255504218511 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28059"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00695753"
      },
      "bbox": [
        6.558405356936161, -8.279020730154034, 7.008109421446815,
        -7.743088457005351
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.597756060460223, -7.187174757336449],
            [5.655446469365717, -7.183470321483092],
            [5.712872996140005, -7.180290689381767],
            [5.709233207465926, -7.136537588513475],
            [5.781530953982022, -7.132157738140745],
            [5.853453580943152, -7.127384745937119],
            [5.855245808878276, -7.156357212297608],
            [5.858531763069201, -7.20104149863803],
            [5.859608478048522, -7.218610595651453],
            [5.863893425695854, -7.277065262454006],
            [5.8686407183400595, -7.347517816096049],
            [5.870527216602819, -7.377245230297319],
            [5.874679454034557, -7.4366151747543],
            [5.8824771137398875, -7.555666738220139],
            [5.819303776484411, -7.56003148895388],
            [5.815419798420064, -7.557763275472113],
            [5.807567462220962, -7.559662108957013],
            [5.803171040801341, -7.563194977120438],
            [5.7984454146307725, -7.5618403253479824],
            [5.727430443565947, -7.566237789894349],
            [5.722722927138605, -7.49392333921932],
            [5.70789247957126, -7.4947553510988],
            [5.682314484639351, -7.496685714492043],
            [5.650259464734597, -7.498805281636882],
            [5.64929670919565, -7.484285817544484],
            [5.642036951892839, -7.4848232504258],
            [5.640615976475668, -7.463046452164781],
            [5.6331885680197855, -7.4635260981102824],
            [5.631849627640529, -7.441888704412017],
            [5.581187490630993, -7.445395243237071],
            [5.574199472300004, -7.446166061162359],
            [5.571289144923652, -7.403176742708841],
            [5.549361219538981, -7.404425312776295],
            [5.545713704924565, -7.3466112777441355],
            [5.538486983959194, -7.347088539456361],
            [5.531988594701067, -7.245652600142657],
            [5.528283057898659, -7.187356920709069],
            [5.562566786803932, -7.185115267669243],
            [5.583097935360106, -7.1840096509083],
            [5.585459640718626, -7.185975462378454],
            [5.592680341874961, -7.182302987103953],
            [5.591505050564005, -7.187565254319494],
            [5.597756060460223, -7.187174757336449]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.8224507192479, "lat": 31.230848832360316 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28091"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00695769"
      },
      "bbox": [
        5.528283057898659, -7.566237789894349, 5.8824771137398875,
        -7.127384745937119
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.031830578987966, -5.615578951879893],
            [6.0539835682643135, -5.613590897005887],
            [6.089305171423175, -5.61129786513868],
            [6.157182265928852, -5.6063617306795335],
            [6.282645232914798, -5.597935453347662],
            [6.28303669542839, -5.602867156155409],
            [6.326599383358248, -5.599475601449448],
            [6.327225699536178, -5.606927386675624],
            [6.356101619859882, -5.604657595234167],
            [6.355509068134143, -5.597235435187947],
            [6.368937738864213, -5.596313693675309],
            [6.370588817511264, -5.619618323670277],
            [6.374597537589413, -5.669773278656903],
            [6.375884216081481, -5.693933867218379],
            [6.380955597637042, -5.765809673168206],
            [6.384544641388869, -5.813880190658382],
            [6.387024924760432, -5.8434999849925555],
            [6.395049283283499, -5.9452961468987],
            [6.352012061974494, -5.9487604063810435],
            [6.343957797751752, -5.949061064102248],
            [6.3160290168972, -5.951188123420434],
            [6.221809453700869, -5.958055657077615],
            [6.21680718054358, -5.958314887947051],
            [6.115055665895825, -5.965646104152856],
            [6.114680545486116, -5.966120894618914],
            [6.0582429332503125, -5.970100027774129],
            [6.054494885672196, -5.92221649987452],
            [6.0546741984493595, -5.92153601295644],
            [6.04980404636436, -5.85894213483891],
            [6.043826583678272, -5.776399603422551],
            [6.043403968954099, -5.773506394985534],
            [6.039162311787738, -5.711842140176008],
            [6.03899719854857, -5.697963980341162],
            [6.038183483324454, -5.697465999730894],
            [6.036911110084561, -5.6791543193827305],
            [6.035703350938773, -5.672043523205612],
            [6.031830578987966, -5.615578951879893]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.11755141177103, "lat": 32.75347423637006 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28099"],
        "coty_name": ["Neshoba"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Neshoba County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00695772"
      },
      "bbox": [
        6.031830578987966, -5.970100027774129, 6.395049283283499,
        -5.596313693675309
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.838749616093096, 1.6957471002067324],
            [2.92333242025776, 1.6983377592225344],
            [2.968181593451299, 1.700882271915159],
            [3.0096807138866124, 1.7025569680902124],
            [3.057126238029743, 1.7048264887071065],
            [3.095247387089104, 1.706884907021185],
            [3.136866414432272, 1.708719401120711],
            [3.151305603426219, 1.7098812218931487],
            [3.179546319274201, 1.7114568253373774],
            [3.220359955189474, 1.7131902847705063],
            [3.222114452516793, 1.6690819575870555],
            [3.2236967239073997, 1.669165958319526],
            [3.223981703040089, 1.647355572417732],
            [3.226449622291695, 1.5815407624071738],
            [3.2280817785786695, 1.5816579976450864],
            [3.2315223691882697, 1.506754009337775],
            [3.2320170314535726, 1.4892285884400167],
            [3.2358909554216577, 1.4023406714460518],
            [3.236065420670254, 1.4015952515420786],
            [3.1951526152442757, 1.3998333661625442],
            [3.143058367606289, 1.3978266554400003],
            [3.111313186546628, 1.3967536095398065],
            [3.0208996696643307, 1.3947311668230138],
            [2.9776696912032157, 1.3932095791456187],
            [2.8551252732738672, 1.3880429764550277],
            [2.8485191772798837, 1.3877756938173897],
            [2.8457013496651293, 1.4762736911372603],
            [2.8432145243965685, 1.5637281687260216],
            [2.838749616093096, 1.6957471002067324]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.60070310319884,
          "lat": 40.190569360398186
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29001"],
        "coty_name": ["Adair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adair County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00765805"
      },
      "bbox": [
        2.838749616093096, 1.3877756938173897, 3.236065420670254,
        1.7131902847705063
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9879017508975125, 0.9614083882591634],
            [3.0448838238947866, 0.96236826688583],
            [3.1104149815337054, 0.9637440764572767],
            [3.13825378255577, 0.9641606939278381],
            [3.1775994875490925, 0.9652581637173662],
            [3.2057565871686236, 0.9657055455036431],
            [3.286529287288143, 0.9674539942371908],
            [3.2867543862595836, 0.941562841366428],
            [3.2877552568360877, 0.859523204140983],
            [3.288431868358295, 0.8193078571428919],
            [3.2895611971332075, 0.723026361648239],
            [3.289636357326278, 0.7074187679620272],
            [3.290550163947511, 0.608644757661833],
            [3.2902016808992616, 0.6050629997915543],
            [3.217698304051013, 0.6040219540008982],
            [3.2013796272381465, 0.6040363193579744],
            [3.1010148284361665, 0.6348562938947679],
            [2.9863862333838513, 0.6698289519433656],
            [2.9864676517403863, 0.7129810606871589],
            [2.9859601961622833, 0.7638239271543156],
            [2.985653457909328, 0.7789521076902162],
            [2.985202592125142, 0.8372016032226774],
            [2.985209145962294, 0.8679746176014576],
            [2.9846181180872873, 0.8753255186640405],
            [2.984396748648223, 0.919448573592477],
            [2.9845090256052207, 0.9613974022555325],
            [2.9879017508975125, 0.9614083882591634]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.4970855132453, "lat": 39.44010978940316 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29175"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00758542"
      },
      "bbox": [
        2.984396748648223, 0.6040219540008982, 3.290550163947511,
        0.9674539942371908
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.7653327345448977, -1.2635319132214098],
            [2.764490786530115, -1.1903754371331674],
            [2.836542941453599, -1.1898769382152186],
            [2.853999603087929, -1.189301947385919],
            [2.9351734058021144, -1.1885288573215256],
            [2.9359021190140644, -1.1884057394253833],
            [2.9891347725800745, -1.1876939087387859],
            [3.012165550241129, -1.1871477305851845],
            [3.0669952553297026, -1.1863996061939266],
            [3.067602223798129, -1.2158869904570095],
            [3.0674358201658434, -1.2306292152256095],
            [3.0686210212357556, -1.290024374612475],
            [3.069320621681635, -1.3185462570404152],
            [3.0686125338455916, -1.3185709202876972],
            [3.0695240840901308, -1.3624424961913553],
            [3.070232576544026, -1.4065270401821572],
            [3.080747698488735, -1.4065289933861553],
            [3.0815900526784503, -1.5161994479346175],
            [3.0820870029659133, -1.5530949860884362],
            [3.0822180384934046, -1.6045373194907795],
            [3.0314021025768594, -1.6053306282874933],
            [2.953258691375481, -1.6071943766626846],
            [2.910391280923906, -1.6066966456633158],
            [2.9101891951442562, -1.5919895843176948],
            [2.8674798758585265, -1.5917301195344673],
            [2.8672698070923026, -1.5909218984689821],
            [2.8384839168103593, -1.5918217583739287],
            [2.7818774516313693, -1.5925537762769848],
            [2.7814513448615887, -1.571117380771967],
            [2.7800529955018543, -1.463587759040821],
            [2.779171319240886, -1.4097105346547785],
            [2.767150735082751, -1.409495454109078],
            [2.766313513190565, -1.358685442122617],
            [2.7656361241901366, -1.307599294689579],
            [2.7653327345448977, -1.2635319132214098]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.87589973928225, "lat": 37.28088877758407 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29225"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "225",
        "coty_gnis_code": "00758565"
      },
      "bbox": [
        2.764490786530115, -1.6071943766626846, 3.0822180384934046,
        -1.1863996061939266
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.970612540054216, 8.21054312662686],
            [-8.884466705538532, 8.198485828891341],
            [-8.798323930612, 8.186406470670338],
            [-8.776980059205526, 8.337100855909261],
            [-8.760773132962543, 8.451239679753588],
            [-8.750523722613844, 8.449782282182932],
            [-8.744472005772897, 8.49230849536111],
            [-8.722536091907166, 8.64793575215921],
            [-8.714491403969292, 8.704231829454049],
            [-8.657124030818226, 8.69619271833877],
            [-8.585473878052797, 8.686271316710037],
            [-8.520731509162644, 8.677076389191193],
            [-8.455991070044309, 8.667868493723915],
            [-8.473884037032782, 8.541485381211142],
            [-8.45936409103589, 8.539576786095049],
            [-8.460874526860643, 8.525617654457394],
            [-8.46543888385176, 8.497231132059783],
            [-8.408115297564494, 8.488521591324043],
            [-8.420112368934978, 8.403451447355518],
            [-8.402918158718244, 8.40106213040479],
            [-8.40918905203903, 8.364068231527733],
            [-8.39482565127154, 8.362067176452523],
            [-8.407553162888433, 8.2770569709088],
            [-8.39319758908992, 8.2751013176709],
            [-8.395415146698761, 8.260955812133728],
            [-8.388237993225307, 8.260017552040045],
            [-8.392382743151844, 8.231590238800358],
            [-8.385210930068714, 8.230640445212615],
            [-8.387144126020466, 8.216395333784805],
            [-8.372787686598436, 8.214453496303827],
            [-8.376634783691653, 8.18603478589929],
            [-8.36230964755003, 8.18410815795101],
            [-8.365691425446599, 8.155432008315502],
            [-8.370012322895645, 8.12724578280532],
            [-8.382016720227345, 8.042246409214602],
            [-8.481678266712946, 8.05558542610235],
            [-8.597778730761691, 8.070935539763603],
            [-8.653501081819643, 8.078647137059516],
            [-8.736614728070244, 8.090466502501664],
            [-8.819731340409275, 8.102265472180903],
            [-8.832677412376311, 8.01661720622315],
            [-8.962016333412029, 8.035181953045793],
            [-8.948894579010013, 8.12067824653459],
            [-8.983013536599472, 8.125536237408177],
            [-8.970612540054216, 8.21054312662686]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.17515238067408,
          "lat": 46.38122157390741
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30037"],
        "coty_name": ["Golden Valley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Golden Valley County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01723078"
      },
      "bbox": [
        -8.983013536599472, 8.01661720622315, -8.36230964755003,
        8.704231829454049
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.859326784841429, 11.168011024129141],
            [-12.829575753214423, 11.304051501713987],
            [-12.799352625964639, 11.442468199108323],
            [-12.756033191784057, 11.640698765202629],
            [-12.72472873152927, 11.63456079553178],
            [-12.701033416329274, 11.629239555629209],
            [-12.625728897044947, 11.613682470497489],
            [-12.550428634350872, 11.598104631969079],
            [-12.475132681000552, 11.582506048733746],
            [-12.399841089754021, 11.566886729448571],
            [-12.342234669904004, 11.554730606014207],
            [-12.275840329650729, 11.540832415332646],
            [-12.209449547657474, 11.526918107518139],
            [-12.11038562876984, 11.507534670448093],
            [-12.00323354806953, 11.486864098635085],
            [-11.896089272567714, 11.466151800868449],
            [-11.900736408058295, 11.4641889690531],
            [-11.906021382724646, 11.458461196937233],
            [-11.904288624231338, 11.45403443206751],
            [-11.904757306842372, 11.450281332483982],
            [-11.898486704018215, 11.446130365205248],
            [-11.880407591997102, 11.442708748869801],
            [-11.873927099513462, 11.434948082133282],
            [-11.876574517901005, 11.428076050317776],
            [-11.879794226115173, 11.427293044958486],
            [-11.881880249695111, 11.422505647150219],
            [-11.88552190781345, 11.417999237859592],
            [-11.891623208304814, 11.416800162604835],
            [-11.89555627753686, 11.411722837876273],
            [-11.902684361897554, 11.406324280400293],
            [-11.903576854449152, 11.39967441366733],
            [-11.89818244123516, 11.396851930966873],
            [-11.898963749292761, 11.385646957405038],
            [-11.898458502390612, 11.37744286358907],
            [-11.899382693492194, 11.370963668286263],
            [-11.902160763836733, 11.365036150644386],
            [-11.90654022536333, 11.35993710514327],
            [-11.90656374079789, 11.35731314471509],
            [-11.903117146574035, 11.348841329641278],
            [-11.89873177941505, 11.341866415288619],
            [-11.899146604702352, 11.33455480682829],
            [-11.897957519199336, 11.331527581478793],
            [-11.899608467673714, 11.32312105435107],
            [-11.903318227137621, 11.318903519888643],
            [-11.90394508682435, 11.310906678941473],
            [-11.913200930554957, 11.3094685793079],
            [-11.916168889555106, 11.304040574687395],
            [-11.925915484696288, 11.305099360023288],
            [-11.928844589406298, 11.300469299238067],
            [-11.931472375262327, 11.293533558767312],
            [-11.934113481755318, 11.291895964873344],
            [-11.93663455325122, 11.285153365374875],
            [-11.930723507796317, 11.281471621472765],
            [-11.926403601589628, 11.27553666553601],
            [-11.919228972330368, 11.275326517834367],
            [-11.915380804727686, 11.272493527482498],
            [-11.910513869150453, 11.271944739719121],
            [-11.905689027118934, 11.267083056185456],
            [-11.899155164951534, 11.26792364807503],
            [-11.90185787906421, 11.258684149078258],
            [-11.896991694539743, 11.253933600513461],
            [-11.89591185785596, 11.249272523157057],
            [-11.89197574168576, 11.24949921623467],
            [-11.887574275543285, 11.245969938939005],
            [-11.884061700091687, 11.236241851305316],
            [-11.884583391968818, 11.233317378828108],
            [-11.882681317424396, 11.228665969535012],
            [-11.88288667224065, 11.225285215707785],
            [-11.878017323703245, 11.223511202216656],
            [-11.87149253570966, 11.223259190014709],
            [-11.868843771398728, 11.217939825717751],
            [-11.868996533610742, 11.21516071022492],
            [-11.874180031015733, 11.213036301514304],
            [-11.875447182329196, 11.207263464033291],
            [-11.880603240389943, 11.204022456162573],
            [-11.884742732270093, 11.203817131332908],
            [-11.886341701856399, 11.201233290534146],
            [-11.890563334421307, 11.199656878855404],
            [-11.893109077632607, 11.200972838613906],
            [-11.906872809417102, 11.199327725823673],
            [-11.912190467522668, 11.199841483535184],
            [-11.918169234714945, 11.19750397556065],
            [-11.9222598803533, 11.193046341023805],
            [-11.92241851465179, 11.189748136340532],
            [-11.929100137662301, 11.18439606266827],
            [-11.929288256603392, 11.179211051827904],
            [-11.925040065599344, 11.17549648243093],
            [-11.925079735739565, 11.169500715674573],
            [-11.928977857120195, 11.168127539102928],
            [-11.930231287608324, 11.163844568916263],
            [-11.935433944016053, 11.157183275252656],
            [-11.933068071823389, 11.152883083189577],
            [-11.929361875521593, 11.151246675162865],
            [-11.92570617828185, 11.15175640716436],
            [-11.913360657683091, 11.143412261793644],
            [-11.905377675658345, 11.135580704778436],
            [-11.904536914640708, 11.130119494709525],
            [-11.981421138427173, 11.145159425704152],
            [-12.058309471838042, 11.160178232152525],
            [-12.068051187943551, 11.161861751877693],
            [-12.08470545560304, 11.081009152536698],
            [-12.05922714502678, 11.075935296574059],
            [-12.067953039855192, 11.033342040967094],
            [-12.09306113850995, 10.910129872748973],
            [-12.092396507457309, 10.909998720880619],
            [-12.100243214402003, 10.871434581171924],
            [-12.125872133654424, 10.744600129793756],
            [-12.217378845784589, 10.762726965143754],
            [-12.239250226044845, 10.766918383526123],
            [-12.256104939283192, 10.684022985259707],
            [-12.24976918556347, 10.682737646111242],
            [-12.256552896130314, 10.649876543904956],
            [-12.258356782857609, 10.643047665622362],
            [-12.274083212159463, 10.56678661489523],
            [-12.314697608205913, 10.574841406937505],
            [-12.369153555391405, 10.585877204602193],
            [-12.368454162194686, 10.576066794615159],
            [-12.369301800748632, 10.56936944402354],
            [-12.371070968076559, 10.564159358872264],
            [-12.363779273178453, 10.551456036930896],
            [-12.36637952225013, 10.546834911464398],
            [-12.370613020533252, 10.545966971852371],
            [-12.375680670474804, 10.533262041787276],
            [-12.382357370281625, 10.53252981430419],
            [-12.383817327610629, 10.534927239788237],
            [-12.384915612119356, 10.54422294176823],
            [-12.38758283451811, 10.546934658289574],
            [-12.391012508994175, 10.544662261993656],
            [-12.391849087452519, 10.539180169025586],
            [-12.394383608590736, 10.533396268120924],
            [-12.400611348000528, 10.533236460379747],
            [-12.401234605899763, 10.527891091117421],
            [-12.398840773401117, 10.522397522556007],
            [-12.400435127345496, 10.519693989678457],
            [-12.40319602549757, 10.507465872639129],
            [-12.40930253538117, 10.499200397748286],
            [-12.408848877013032, 10.4958971352427],
            [-12.419775072603851, 10.4949243381201],
            [-12.42248328451318, 10.498654066170948],
            [-12.42752528566011, 10.495465973517422],
            [-12.43154640071006, 10.49491121533667],
            [-12.437614455176277, 10.490766344601354],
            [-12.442492455571884, 10.493049743428427],
            [-12.443509362562295, 10.495474552526087],
            [-12.448330487244114, 10.499313363323528],
            [-12.45189794380539, 10.500239665353362],
            [-12.454526997000436, 10.496485506843312],
            [-12.455995963439069, 10.491407513877615],
            [-12.463466530488917, 10.491246467609677],
            [-12.467956230107767, 10.488539590918048],
            [-12.469733873620765, 10.484557534107507],
            [-12.47855854583141, 10.481090004908303],
            [-12.484854890198019, 10.490402753008123],
            [-12.485327427619769, 10.497145521873266],
            [-12.487512995308757, 10.505001689868404],
            [-12.49304193176715, 10.508036537555943],
            [-12.497234416954193, 10.516036496808004],
            [-12.499653490999744, 10.516232987956649],
            [-12.504036255697148, 10.513335039690206],
            [-12.508161597609288, 10.51437874866488],
            [-12.515242262288567, 10.51379146024453],
            [-12.518298028275577, 10.511052189989117],
            [-12.528304048027184, 10.512471349718801],
            [-12.530401098094403, 10.509406239024385],
            [-12.541698937476406, 10.50775096209291],
            [-12.552137075957145, 10.51809504372757],
            [-12.552051577705836, 10.527040106010427],
            [-12.548036062320127, 10.536387881483346],
            [-12.547615901729454, 10.54075518356644],
            [-12.562396814703343, 10.541425420331972],
            [-12.565764750299836, 10.536616776570437],
            [-12.568450320119764, 10.523171358456707],
            [-12.571698293672489, 10.520630771501963],
            [-12.575978906219818, 10.52301657613341],
            [-12.59172623256703, 10.534025417501674],
            [-12.596031844979017, 10.531931154289161],
            [-12.598789326669394, 10.528384145075892],
            [-12.603520509946758, 10.53208136242388],
            [-12.608139401726273, 10.533442842661097],
            [-12.614270445015526, 10.529610752983615],
            [-12.619059663449635, 10.528496259266822],
            [-12.6264172202345, 10.530504109239779],
            [-12.632484126388329, 10.529824471925613],
            [-12.636147549834703, 10.53182425455388],
            [-12.636954970672749, 10.537118667833264],
            [-12.64327150804517, 10.541990903037002],
            [-12.647476115888209, 10.547172889142425],
            [-12.64551104054195, 10.55285995476973],
            [-12.646329384398197, 10.556501578718906],
            [-12.651219063868052, 10.561422669778409],
            [-12.651053346593699, 10.568042085859414],
            [-12.6451122504919, 10.577898889083553],
            [-12.641264479767608, 10.579997247360266],
            [-12.641296470931808, 10.583570557853475],
            [-12.636696494578183, 10.59072060871014],
            [-12.6312801773864, 10.60144252811116],
            [-12.62990682444668, 10.612613883554022],
            [-12.630707371444114, 10.620745991860222],
            [-12.63272576464982, 10.624004605700806],
            [-12.634342679330583, 10.632093619496706],
            [-12.640674537562134, 10.638639789200193],
            [-12.641947798050543, 10.643718986232356],
            [-12.646303376766353, 10.642999207760868],
            [-12.65230987264235, 10.647442721322664],
            [-12.655333997774553, 10.65713011004055],
            [-12.658394644567586, 10.657679496684407],
            [-12.660724572429329, 10.66288151315268],
            [-12.659642050841583, 10.668429160210831],
            [-12.662728472976559, 10.672209662219046],
            [-12.664671879745347, 10.677325082099777],
            [-12.660993479017083, 10.683914037169746],
            [-12.660926601331404, 10.68738724888775],
            [-12.666178173924214, 10.691817114263506],
            [-12.670550055795921, 10.699662676291897],
            [-12.67627817270075, 10.705020642104346],
            [-12.677156335419577, 10.71107103035008],
            [-12.673845448417982, 10.711489940725894],
            [-12.670267004348323, 10.71769315990214],
            [-12.672958241199813, 10.724998004472521],
            [-12.670154382415348, 10.735946625269692],
            [-12.670206372487716, 10.743047462805203],
            [-12.674458134251587, 10.753951527176765],
            [-12.669933033724718, 10.76292134189145],
            [-12.676030359215403, 10.772311379462813],
            [-12.67527870076113, 10.777150814781782],
            [-12.678548994706839, 10.783706663617824],
            [-12.68153230769888, 10.785847994035466],
            [-12.681978172158928, 10.791760690769268],
            [-12.685395902308906, 10.797476587266774],
            [-12.693360420617543, 10.798457988480756],
            [-12.694948200717047, 10.800749589225655],
            [-12.693665712490914, 10.807818231880692],
            [-12.694269505788741, 10.811049491485086],
            [-12.690317051983023, 10.813772529749542],
            [-12.684446009329998, 10.820950539297236],
            [-12.682753942285467, 10.824715025240035],
            [-12.676335488053935, 10.82423216064967],
            [-12.675842141362361, 10.830525336999504],
            [-12.672739673399304, 10.83537009655323],
            [-12.67801652613519, 10.846018428747211],
            [-12.68028131790975, 10.85347456945414],
            [-12.682893649405498, 10.855538247622825],
            [-12.68482141644127, 10.86491836182114],
            [-12.68357298572445, 10.869529706622759],
            [-12.687722483196808, 10.874139219149763],
            [-12.688823086073096, 10.880486299511052],
            [-12.6931019056395, 10.882919577417999],
            [-12.69386241190651, 10.885623020118807],
            [-12.70067794313699, 10.888862651149427],
            [-12.704748912041858, 10.894011792859795],
            [-12.703838896029925, 10.898352097787534],
            [-12.7079608241268, 10.898085604823992],
            [-12.712595001268673, 10.900708215873276],
            [-12.718087220417097, 10.902020589947558],
            [-12.723908707134466, 10.898835109804994],
            [-12.727144063802854, 10.898992578441353],
            [-12.73319532875383, 10.893775138401532],
            [-12.73266704157756, 10.891411427046567],
            [-12.738416452401145, 10.882088981283378],
            [-12.743174110920597, 10.879668899793328],
            [-12.75348835446872, 10.868413181719841],
            [-12.7622727599585, 10.869246838971312],
            [-12.763797658104414, 10.867215324966473],
            [-12.7733586705999, 10.867236015773818],
            [-12.77648669144583, 10.86175309893087],
            [-12.78111603618175, 10.862048456228578],
            [-12.784961712765517, 10.86443119399198],
            [-12.788216816448136, 10.862455599902649],
            [-12.792697898126589, 10.864518485498365],
            [-12.795017250491275, 10.860109035574565],
            [-12.80133482612442, 10.858756731965212],
            [-12.804764548904044, 10.861317774791495],
            [-12.812197518750889, 10.860466549174236],
            [-12.816914165576575, 10.855853797970802],
            [-12.82572141955619, 10.854737270823712],
            [-12.83303160404333, 10.844971753483225],
            [-12.841697736885518, 10.845919009105364],
            [-12.85141676509429, 10.850261002255218],
            [-12.855553054499374, 10.846424996378186],
            [-12.856791076821786, 10.840946775623907],
            [-12.867752650741597, 10.827483232771907],
            [-12.872043570740926, 10.8197217461856],
            [-12.878994010040858, 10.826987199030253],
            [-12.883936391335654, 10.82845363860957],
            [-12.885203701784267, 10.831797908374986],
            [-12.88865734314259, 10.8312586550675],
            [-12.89430418155314, 10.833621180836166],
            [-12.898231800242273, 10.832738877090076],
            [-12.90406639178353, 10.837012099505541],
            [-12.903262468101776, 10.841659077501806],
            [-12.907792399256747, 10.847617708081716],
            [-12.907245177856275, 10.853690791301075],
            [-12.904578391977894, 10.857736087287044],
            [-12.907258714775574, 10.860881603442463],
            [-12.906879105652616, 10.864271334728995],
            [-12.89985688182676, 10.870508834475398],
            [-12.898906568990652, 10.874713910012858],
            [-12.901329030624261, 10.879402985631822],
            [-12.899349973812594, 10.88234895422767],
            [-12.915434057582866, 10.893543182307116],
            [-12.91851754627406, 10.896238778004571],
            [-12.89684805139206, 10.995515273545301],
            [-12.881699615835496, 11.065065430412227],
            [-12.859326784841429, 11.168011024129141]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.40505568840804,
          "lat": 48.54247785154951
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30053"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01720038"
      },
      "bbox": [
        -12.91851754627406, 10.481090004908303, -11.868843771398728,
        11.640698765202629
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.622235284421119, 8.292571831602846],
            [-7.61930603849881, 8.292213060546365],
            [-7.523337092239056, 8.280978948376568],
            [-7.4273712952156234, 8.26971710438884],
            [-7.331408711153335, 8.25842753391751],
            [-7.235449403772232, 8.24711024243617],
            [-7.237083844380459, 8.232856215736838],
            [-7.2227865465085745, 8.231111915584064],
            [-7.231156923489086, 8.160042809478242],
            [-7.145310061850651, 8.14992902252451],
            [-7.155647435216545, 8.062814168395068],
            [-7.150330348038442, 8.063900272641964],
            [-7.144589864361528, 8.063603439512791],
            [-7.141101740881004, 8.062137507724485],
            [-7.14312469603313, 8.044000300501043],
            [-7.160989698585096, 7.891864037007213],
            [-7.159422090460374, 7.894142987022994],
            [-7.113586966446653, 7.8888762638488945],
            [-7.128606051110503, 7.760674085813993],
            [-7.144181953338031, 7.626818821148582],
            [-7.22246150250517, 7.635846027965302],
            [-7.217280028554778, 7.678540430679999],
            [-7.3033695997139025, 7.688397420644873],
            [-7.2982783249460015, 7.731092448082989],
            [-7.384256139149777, 7.741237579432671],
            [-7.470236475604834, 7.75136136078397],
            [-7.459716915443842, 7.836502258985831],
            [-7.5194831473449035, 7.843710185067046],
            [-7.5228880051044795, 7.850735839458085],
            [-7.518596971621661, 7.860507502879207],
            [-7.51438356744465, 7.86296951313445],
            [-7.5119082097040355, 7.86990012204972],
            [-7.50859170421444, 7.87021187671649],
            [-7.509340632089038, 7.878901447690703],
            [-7.502596213693079, 7.88219846724854],
            [-7.504881902877845, 7.886254079142928],
            [-7.5018560273923, 7.887769482189494],
            [-7.49535092845073, 7.886385074856745],
            [-7.4955981091599835, 7.896321032748696],
            [-7.491366407567118, 7.89648545060231],
            [-7.486750983542383, 7.899137967093491],
            [-7.485578679637718, 7.902717276919851],
            [-7.4871736870090855, 7.9120552040930265],
            [-7.49090515134663, 7.9194038421655595],
            [-7.489661426249613, 7.921892515972751],
            [-7.4837341124746795, 7.919354512479398],
            [-7.480683599471159, 7.920310637443355],
            [-7.47834205073461, 7.925017908034183],
            [-7.482696761455078, 7.927749852702189],
            [-7.482275294381055, 7.93252121785583],
            [-7.475985079107713, 7.933504481141059],
            [-7.4739745333950065, 7.935877179636237],
            [-7.474719884364453, 7.940591195749971],
            [-7.4808996158151615, 7.946081322231589],
            [-7.480354132732297, 7.950340418576846],
            [-7.4739658603847445, 7.9551482985019915],
            [-7.47200660342355, 7.971833570049018],
            [-7.4864565723190575, 7.973589916120513],
            [-7.484647535465094, 7.987810694008523],
            [-7.499042142869546, 7.9895306377779525],
            [-7.495568641448602, 8.017993026057152],
            [-7.509848133362735, 8.019648380447155],
            [-7.506310708431786, 8.048105352677595],
            [-7.52069726614427, 8.049820452532892],
            [-7.518942001363943, 8.064034851330858],
            [-7.533328505706893, 8.065764005876558],
            [-7.529839791676966, 8.094149096096656],
            [-7.544225952561951, 8.095891218207454],
            [-7.542476325113711, 8.110113684914582],
            [-7.556884538278578, 8.111820806545577],
            [-7.551613620038217, 8.154404809623449],
            [-7.566007202710959, 8.156124104947114],
            [-7.564255486538978, 8.170303780084039],
            [-7.578525224131755, 8.172001143092455],
            [-7.574999162407284, 8.200355143341483],
            [-7.589343923243227, 8.20215420359713],
            [-7.587653970892508, 8.216366672675909],
            [-7.601996411939529, 8.218169559693527],
            [-7.598599914971493, 8.24658985632956],
            [-7.612974989774402, 8.248380915145976],
            [-7.609571614856851, 8.276801544974473],
            [-7.623906205440148, 8.278608610044293],
            [-7.622235284421119, 8.292571831602846]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.27161400670033,
          "lat": 46.21146090426857
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30103"],
        "coty_name": ["Treasure"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Treasure County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01719563"
      },
      "bbox": [
        -7.623906205440148, 7.626818821148582, -7.113586966446653,
        8.292571831602846
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.496940738084436, 3.2738847251393453],
            [-5.449244950361115, 3.269894901663386],
            [-5.447555837915091, 3.269914363675058],
            [-5.348334097073738, 3.2615508828483155],
            [-5.276865324787767, 3.255655248296307],
            [-5.1618572987046365, 3.2470819125505246],
            [-5.077520372349296, 3.2412962086289037],
            [-4.992753155268664, 3.2343517938608186],
            [-4.996769074704408, 3.176335946101655],
            [-5.002531700686638, 3.0803641246587503],
            [-5.0059037786788325, 3.034309074847464],
            [-5.01213501280848, 2.9719952606650373],
            [-5.016572505874107, 2.928838390270478],
            [-5.021895020041351, 2.929207209082123],
            [-5.0740981203543605, 2.932367904413475],
            [-5.106843644036879, 2.935067662444014],
            [-5.113072092499373, 2.9363115204619237],
            [-5.163332320485952, 2.9395819692245166],
            [-5.333232556813544, 2.9525516775372465],
            [-5.36121534316091, 2.9551539461475023],
            [-5.471228471335998, 2.9641529326981813],
            [-5.516804026598618, 2.96777952175164],
            [-5.522515291723276, 2.9684465122424597],
            [-5.511642323085879, 3.097948663772616],
            [-5.5081139673190815, 3.1399934151641316],
            [-5.503433757689663, 3.1988247982468336],
            [-5.496940738084436, 3.2738847251393453]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.71054215849516,
          "lat": 41.54600553422149
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31007"],
        "coty_name": ["Banner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Banner County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00835826"
      },
      "bbox": [
        -5.522515291723276, 2.928838390270478, -4.992753155268664,
        3.2738847251393453
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.11337857991874051, 2.7159147899398604],
            [0.21885235349258855, 2.71536784035155],
            [0.25679698029125747, 2.715144109269438],
            [0.2833729134360686, 2.715176143585714],
            [0.37083483172674875, 2.7150063964496476],
            [0.5102671462171088, 2.714918458190596],
            [0.5119850481294359, 2.7061606852906994],
            [0.5163841687080849, 2.6966003133582355],
            [0.5167600470650162, 2.6917679306090414],
            [0.5151259713949551, 2.6863299264440528],
            [0.5076843240686599, 2.679075764597883],
            [0.49934506024293673, 2.67504373122011],
            [0.49592125348397326, 2.670712655186316],
            [0.49599743085875664, 2.666987330210715],
            [0.4986815651632024, 2.661350169808804],
            [0.5033030778589971, 2.6555127288159905],
            [0.5089679680862248, 2.65028132265341],
            [0.5191059244312792, 2.643542309515958],
            [0.5279740374451385, 2.6415359802566494],
            [0.5387767313717103, 2.6425534977694607],
            [0.5466770194566155, 2.640447794943334],
            [0.5508532920360051, 2.6380362155405],
            [0.5545098251114438, 2.6338117464186994],
            [0.5571250911631991, 2.628377734359234],
            [0.5595252145286622, 2.617002473175922],
            [0.5584902239072357, 2.6106572316400065],
            [0.5514181645351983, 2.6024916453027838],
            [0.536441918811119, 2.5944198061265804],
            [0.5289796779462493, 2.6005551956677593],
            [0.5350794665654284, 2.6146576678991758],
            [0.5338794883023109, 2.6221079111596697],
            [0.5231463724500314, 2.6222994956881966],
            [0.5177823627685765, 2.6195764497027536],
            [0.5162217492601555, 2.6134328536779483],
            [0.5169008368426812, 2.6024583824454317],
            [0.5278687887363979, 2.5923975402067208],
            [0.5230994519124014, 2.589372378791724],
            [0.5219841451821624, 2.5855448169307933],
            [0.5224366435262248, 2.579402372531532],
            [0.5298387502176454, 2.5587644709031343],
            [0.530217589438156, 2.552520993195293],
            [0.5270922111312312, 2.543655798727666],
            [0.5197896550109142, 2.53176584383383],
            [0.5178563443939636, 2.5227002444354847],
            [0.5189817013321167, 2.5161547234409194],
            [0.5209844817891524, 2.5116284168109875],
            [0.46029066458608026, 2.511065356299739],
            [0.40298118921535886, 2.5111819083491627],
            [0.3744639705441807, 2.5110428314885502],
            [0.36010685965048894, 2.5112859197299424],
            [0.31692838742691504, 2.5112049421774554],
            [0.2193475705580906, 2.5108140308952303],
            [0.21552437250760764, 2.516423036081395],
            [0.20202492652909956, 2.5251691769558997],
            [0.1993266304058734, 2.5284785325768664],
            [0.1940954923431351, 2.5403338390819274],
            [0.19103441063708163, 2.5553683185714924],
            [0.19332212083903133, 2.562131112032657],
            [0.19737407614008234, 2.5702729499115216],
            [0.20212085407899294, 2.577594614464674],
            [0.20230997608612283, 2.586600766376999],
            [0.1949353816200684, 2.6019539251195978],
            [0.1900585871232493, 2.610145243842648],
            [0.17907951858814902, 2.622279074809591],
            [0.17445119751060367, 2.623738752914847],
            [0.1653256814727567, 2.6312853443655064],
            [0.1600132753333577, 2.6365358892624813],
            [0.1584940961128111, 2.6421056517670554],
            [0.15978402663108232, 2.6437061369277757],
            [0.16057144013772048, 2.6563635275523794],
            [0.15898774324921688, 2.6639823373319014],
            [0.15505901469398578, 2.6772184151666862],
            [0.15073823666210387, 2.6853192769873955],
            [0.1477312283193857, 2.6884507764514374],
            [0.1364179581580014, 2.692537489843859],
            [0.12165850431007237, 2.702862591100761],
            [0.11337857991874051, 2.7159147899398604]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.15432337051405, "lat": 41.2953307409694 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31055"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00835849"
      },
      "bbox": [
        0.11337857991874051, 2.5108140308952303, 0.5595252145286622,
        2.7159147899398604
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2188411311336225, 4.232266716072709],
            [-1.209940603470702, 4.229542515735783],
            [-1.1973472199290554, 4.2241600616352475],
            [-1.1888859172663773, 4.22311128056663],
            [-1.1815326872947065, 4.223175415075466],
            [-1.175433835140359, 4.2204755951806705],
            [-1.1733377158640659, 4.21696854732513],
            [-1.1626488946980365, 4.209435832260257],
            [-1.1540237347124418, 4.201224230615772],
            [-1.1430080880655191, 4.194634928928191],
            [-1.1323869482687932, 4.189155127723493],
            [-1.1188975282927336, 4.184316909888821],
            [-1.1131748508219736, 4.184215846234237],
            [-1.1057094389497593, 4.185975807532993],
            [-1.1012129323179165, 4.186634496581254],
            [-1.0947989293422853, 4.179370872504363],
            [-1.0885899634257352, 4.167691995653674],
            [-1.0732620790175282, 4.1567191845135945],
            [-1.063951445060349, 4.145149967484202],
            [-1.0554617353206852, 4.139979251431082],
            [-1.0444446485063092, 4.1301221638104835],
            [-1.0412600647415065, 4.126400106029196],
            [-1.0391990124438304, 4.117978493399148],
            [-1.0332936054385513, 4.113833608897184],
            [-1.028249324970729, 4.112982491866251],
            [-1.02128833341529, 4.108995597638496],
            [-1.0052860180330405, 4.106742721684922],
            [-0.9999148528260663, 4.108504213064938],
            [-0.9960007280803335, 4.107507622115047],
            [-0.9902405315278786, 4.109248635628423],
            [-0.9792546377000563, 4.113849108103646],
            [-0.9679394315337676, 4.112395792495175],
            [-0.9592407555679088, 4.113131477978134],
            [-0.949316050165827, 4.119086028253538],
            [-0.9465273548537115, 4.121487141280074],
            [-0.9379114215580389, 4.1314979025360925],
            [-0.9338778877630488, 4.1329711475049935],
            [-0.9257133620264437, 4.141809971878723],
            [-0.9177182089908992, 4.154505158358365],
            [-0.9133574747225629, 4.160006818987023],
            [-0.9104822044866314, 4.168960688744961],
            [-0.9066651629091572, 4.1780804636293905],
            [-0.9058431019494407, 4.186370198524769],
            [-0.9034836962176658, 4.190389316713215],
            [-0.904192221035398, 4.197094554872118],
            [-0.9028981222205545, 4.201413472989035],
            [-0.8957850338573234, 4.205423538262557],
            [-0.880808118860169, 4.210021965249008],
            [-0.8685667614845487, 4.210852478718341],
            [-0.8603809403298406, 4.203656813294558],
            [-0.8489909960205619, 4.199650077307563],
            [-0.8396919280825177, 4.19483158254696],
            [-0.8295531580514774, 4.191029067411021],
            [-0.8224778711162336, 4.190221429153658],
            [-0.8119858621410367, 4.190422215243499],
            [-0.7902383432552993, 4.187965318547322],
            [-0.7761508353410006, 4.18405827966916],
            [-0.7655896294468029, 4.1825040119511225],
            [-0.7523053682444614, 4.182868146509681],
            [-0.7446624504825601, 4.184335056774935],
            [-0.7281936467677365, 4.190895834820908],
            [-0.7170751164856185, 4.19587204385595],
            [-0.710876463454414, 4.197541715723429],
            [-0.705011911511227, 4.197404641443348],
            [-0.6964555455304778, 4.192754443025001],
            [-0.6838707351376414, 4.188347588560369],
            [-0.6747060264268403, 4.186088835638272],
            [-0.6641633173213827, 4.186394393859445],
            [-0.6527559248011303, 4.188293907467758],
            [-0.6410958986976926, 4.191766393192884],
            [-0.632930827755462, 4.1963773954174926],
            [-0.6296672701893602, 4.195064839333869],
            [-0.6267346948420748, 4.191016706677016],
            [-0.6185381896600081, 4.188016120678169],
            [-0.6196889516867145, 4.125039498684384],
            [-0.620414636509371, 4.12277796480429],
            [-0.6210611470945797, 4.05815263282579],
            [-0.6226391392388781, 3.9568457421820544],
            [-0.6231962500302882, 3.913116057599226],
            [-0.6241031128883981, 3.8621945232099093],
            [-0.6252876899592741, 3.77473856322139],
            [-0.6826043701933231, 3.775625806144201],
            [-0.6979064009025822, 3.7756124987519364],
            [-0.7957261569609172, 3.776980803205383],
            [-0.881262315249259, 3.7783017203906035],
            [-0.9245578403041155, 3.7790797678441077],
            [-0.9259147541874239, 3.778925946260416],
            [-0.9701314360296754, 3.7797144323519403],
            [-1.0561869085724147, 3.7814873688771273],
            [-1.1562496631882933, 3.7835905312718805],
            [-1.2227480392913241, 3.784940013084762],
            [-1.2265748112012316, 3.7850496274565546],
            [-1.225003970887647, 3.8447997922775037],
            [-1.224815351040905, 3.8569266779439038],
            [-1.2222581479291306, 3.9596767016138865],
            [-1.2206864545496994, 4.015165507235086],
            [-1.2203107479213822, 4.039540986113006],
            [-1.2184365096986016, 4.110477234990412],
            [-1.2177932882920763, 4.133983498344672],
            [-1.221577797916066, 4.134050073949913],
            [-1.2195483427304052, 4.219546561135241],
            [-1.2188411311336225, 4.232266716072709]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.8919059142742, "lat": 42.63682233029751 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31107"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00835875"
      },
      "bbox": [
        -1.2265748112012316, 3.77473856322139, -0.6185381896600081,
        4.232266716072709
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5595573738600743, 2.373658513530874],
            [-0.4735511037579872, 2.3721772531940477],
            [-0.3594689060846135, 2.370526017885759],
            [-0.21762768046816636, 2.3687250332595458],
            [-0.21821472115279608, 2.280904139678255],
            [-0.21897675397059815, 2.193296757028802],
            [-0.22000997104835837, 2.105570723367951],
            [-0.22112482756915064, 2.0179201700273857],
            [-0.2229117704502131, 2.0179100957053655],
            [-0.28480804336577215, 2.018523384706753],
            [-0.2858443119055707, 2.0187015774872883],
            [-0.3365449214467465, 2.0193812499556545],
            [-0.357337502462627, 2.019482987395836],
            [-0.3936687172120713, 2.0201454195305204],
            [-0.4788499248434475, 2.021308632364264],
            [-0.5648261973761607, 2.022694689267501],
            [-0.5635849166818334, 2.110410337325789],
            [-0.5622458601987192, 2.1981891711773054],
            [-0.5608494317329286, 2.28595472438548],
            [-0.5595573738600743, 2.373658513530874]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.13951565998005,
          "lat": 40.872371542271345
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31159"],
        "coty_name": ["Seward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seward County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00835901"
      },
      "bbox": [
        -0.5648261973761607, 2.0179100957053655, -0.21762768046816636,
        2.373658513530874
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.14085401346751097, 3.593778076660154],
            [-0.09516197843205555, 3.5931571885798785],
            [-0.0700629307736919, 3.593013540899822],
            [-0.07030361736511886, 3.606983013853576],
            [0.0015782887278459029, 3.6060946416145474],
            [0.05892656001127003, 3.6058409248524717],
            [0.09596437753103622, 3.6053009079315412],
            [0.10743640520943297, 3.6047592791654837],
            [0.2017995371880492, 3.6039165961248942],
            [0.21276476100616132, 3.596463132462636],
            [0.22016848742424655, 3.5867055903980756],
            [0.22280056321951386, 3.5772130476978536],
            [0.2210768639457391, 3.5674037371558533],
            [0.22630165923741927, 3.5607668184044363],
            [0.22566003167274645, 3.5570007253604583],
            [0.21951122799906758, 3.5486793182392544],
            [0.21635441396672617, 3.546014342831427],
            [0.20138470097950198, 3.542264976104132],
            [0.19900233450726595, 3.5376595888724363],
            [0.19956789863223737, 3.53489791358779],
            [0.2051111859271305, 3.527527074033493],
            [0.20762763550023242, 3.521751371407441],
            [0.20820368471364994, 3.5136833232912017],
            [0.20590267639050144, 3.504364358392168],
            [0.20775574484076198, 3.4936701440115283],
            [0.21167617115859133, 3.487309079078444],
            [0.2149145915433608, 3.483986853017804],
            [0.223808917087581, 3.4782169127987177],
            [0.22846343848824718, 3.4733365497878435],
            [0.23263283072825683, 3.462961118669947],
            [0.23537013533734844, 3.4591176320976826],
            [0.24202976043191715, 3.4545922899866826],
            [0.2533302265320609, 3.452122034111864],
            [0.25808714506779884, 3.4499579297575655],
            [0.2631577521698874, 3.444833069821346],
            [0.26680384398793, 3.4366497442013837],
            [0.2673174412526351, 3.4296090063001534],
            [0.26652962226443855, 3.422489370939872],
            [0.2597647140392937, 3.407670549141953],
            [0.258032250596008, 3.400246774520379],
            [0.2584593641710766, 3.386546570285807],
            [0.2625083987456632, 3.3733474023931014],
            [0.23560136217233066, 3.372837297891569],
            [0.23530922366336268, 3.341164099968096],
            [0.1791279044352771, 3.3424802704753427],
            [0.12412348523416432, 3.343489825017399],
            [0.10753041937186883, 3.342666147999202],
            [0.054410806846936374, 3.342677149426017],
            [0.05437104019551242, 3.4171539928080885],
            [-0.035822909839695084, 3.4178960242071175],
            [-0.14323348198869318, 3.4190415715606277],
            [-0.14239883740188952, 3.470560473147712],
            [-0.1422282048743334, 3.506511845861259],
            [-0.14163840789823223, 3.5375934105168465],
            [-0.14159730876145885, 3.5651350729294893],
            [-0.14094826888941644, 3.579516236220713],
            [-0.14085401346751097, 3.593778076660154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.54404883629817, "lat": 42.15819480318851 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31173"],
        "coty_name": ["Thurston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Thurston County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00835908"
      },
      "bbox": [
        -0.14323348198869318, 3.341164099968096, 0.2673174412526351,
        3.606983013853576
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.787906387302733, 2.731251945942628],
            [-17.728198901095556, 2.715945198049914],
            [-17.69931233514473, 2.7086645529128486],
            [-17.639246772367564, 2.694280426377172],
            [-17.607293808090876, 2.6863163180436733],
            [-17.610915946135286, 2.6721465820141783],
            [-17.60419135857179, 2.6704504297892293],
            [-17.607787256989518, 2.6561477954684496],
            [-17.565887482639027, 2.6455870568716318],
            [-17.55215261034305, 2.6418880146686274],
            [-17.538193148344746, 2.6396946812525615],
            [-17.45772419213402, 2.6189776293450855],
            [-17.457135771251668, 2.6193158008915725],
            [-17.44115604841961, 2.614957871801957],
            [-17.41026335619535, 2.607165228387071],
            [-17.373457768370148, 2.5969667631120283],
            [-17.342209311083735, 2.589237845151585],
            [-17.278927937644546, 2.5728758053354266],
            [-17.29382045950683, 2.5121766265067302],
            [-17.301690938220997, 2.481072649597443],
            [-17.32620304093124, 2.487269168541868],
            [-17.32709316626111, 2.4837120056462547],
            [-17.33056077285236, 2.4845721770374065],
            [-17.33201826828857, 2.4803584545564927],
            [-17.34359964812591, 2.484627004123359],
            [-17.37165932712358, 2.4910508143053565],
            [-17.379096186874172, 2.4628544374213672],
            [-17.39251134181922, 2.4661899266749554],
            [-17.411491226761957, 2.395494958464273],
            [-17.425030651268052, 2.398820049671938],
            [-17.432468342401997, 2.370383963771787],
            [-17.418721541016755, 2.3669182095075456],
            [-17.425737871633196, 2.3384324772135696],
            [-17.41883068742526, 2.3367020307361113],
            [-17.42227200624065, 2.322457656002905],
            [-17.415452351165744, 2.3206770791846294],
            [-17.426182064645705, 2.2780300664557385],
            [-17.428008291306426, 2.278452312557342],
            [-17.431319533032788, 2.2647164695289863],
            [-17.436296719813207, 2.247118937270449],
            [-17.422499528113804, 2.243630922289031],
            [-17.421700643259452, 2.2466064304684603],
            [-17.393620053036198, 2.239205057031607],
            [-17.413527802383378, 2.1532228192648297],
            [-17.400107142252573, 2.1498086895706257],
            [-17.41479756044358, 2.090387163735032],
            [-17.427905713473184, 2.039447787927604],
            [-17.4512825264136, 2.0737446873586096],
            [-17.454833062342598, 2.0782891870143896],
            [-17.497761820913187, 2.144401005387673],
            [-17.522968206093633, 2.181729020122475],
            [-17.575771650064844, 2.2611351524532313],
            [-17.63676044013676, 2.3525303812196405],
            [-17.687426192609145, 2.4287224273939554],
            [-17.75922910012587, 2.537072781130675],
            [-17.814662675346472, 2.6203340234148236],
            [-17.79860793895503, 2.686935417456622],
            [-17.787906387302733, 2.731251945942628]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -119.61619670444806, "lat": 38.9122671216851 },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32005"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00858643"
      },
      "bbox": [
        -17.814662675346472, 2.039447787927604, -17.278927937644546,
        2.731251945942628
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.738653946894697, 2.9307981931242177],
            [-17.732287980772835, 2.955190160162996],
            [-17.704410556664772, 3.055824460178251],
            [-17.679174599492914, 3.1469611325838023],
            [-17.66191482523975, 3.2132698162396824],
            [-17.63256800935863, 3.3260066292912214],
            [-17.59887290853684, 3.451539980115678],
            [-17.570829493692116, 3.553654257967657],
            [-17.541510954102723, 3.6660287539416525],
            [-17.527634801210368, 3.7191965698382647],
            [-17.492640307530067, 3.851700128578866],
            [-17.457294266064054, 3.9879935741551145],
            [-17.432613471296893, 4.083048362535021],
            [-17.378074862024775, 4.298712397946405],
            [-17.371479586704037, 4.32703985802393],
            [-17.34107716246633, 4.447161032138295],
            [-17.30378306752922, 4.591978860039381],
            [-17.263133998680175, 4.749787601865479],
            [-17.183292870422193, 5.056919519400809],
            [-17.152510418637508, 5.1722254513247075],
            [-17.151380871792846, 5.178286139056497],
            [-17.11950966486665, 5.299620218069185],
            [-17.088704651853956, 5.421603307603182],
            [-17.058519470490573, 5.537740661654423],
            [-17.049443134764008, 5.536202357866974],
            [-16.96992398248974, 5.517383123241515],
            [-16.967579741596992, 5.51724179077904],
            [-16.950499479519586, 5.512509036108186],
            [-16.908385981089673, 5.502049951097944],
            [-16.862682995359172, 5.489143960516239],
            [-16.762232059795892, 5.4633954447565465],
            [-16.661785975091536, 5.437627228487091],
            [-16.60159666902098, 5.421436605259312],
            [-16.575915318489272, 5.414844092459247],
            [-16.609971142023735, 5.281390704416735],
            [-16.611503413249476, 5.2817718323998815],
            [-16.676749161947377, 5.022561991565458],
            [-16.672409441767215, 5.021821790590393],
            [-16.717644093246193, 4.850532006866176],
            [-16.703655619237278, 4.84722483289097],
            [-16.748516504708917, 4.671869208335975],
            [-16.766723695484043, 4.6770094985067],
            [-16.793503708148027, 4.570231124677863],
            [-16.833107917643556, 4.408944397288686],
            [-16.81844213236747, 4.405266315926597],
            [-16.820044296241775, 4.398791703827665],
            [-16.87126833137926, 4.200261755524946],
            [-16.873098191938215, 4.194621656769958],
            [-16.912948168249624, 4.039028371318935],
            [-16.92920891141451, 3.974541927571267],
            [-16.94795045526407, 3.978696791648244],
            [-16.998307616275586, 3.777309346762012],
            [-17.036438567912736, 3.62699793565139],
            [-17.07587940203484, 3.4717815489118258],
            [-17.010833329953957, 3.455656641683052],
            [-17.010051443359743, 3.455967431451805],
            [-16.991646292686593, 3.4515687470525314],
            [-17.012540726541275, 3.368215078600523],
            [-17.01675704306308, 3.354060434207804],
            [-17.003838544002257, 3.3508562708802048],
            [-17.025612248118716, 3.2633467615621394],
            [-17.01173414079512, 3.2599239768281634],
            [-17.017002907777695, 3.2386241931023205],
            [-17.00309095768356, 3.2352373698164874],
            [-17.019229936573858, 3.1712312089243535],
            [-17.029172252383994, 3.1297317167101495],
            [-17.042991924464566, 3.1331935308190686],
            [-17.050089551554745, 3.1047786389578866],
            [-17.10044284348062, 3.117207531645003],
            [-17.12202777639292, 3.0924139297771203],
            [-17.126616933288915, 3.0936071516049672],
            [-17.133191079835708, 3.0935519750171863],
            [-17.140214725431264, 3.0893363560091993],
            [-17.149285535521244, 3.08794666336364],
            [-17.153149326864426, 3.0847584375457107],
            [-17.155667071554202, 3.085599826445469],
            [-17.160018980124335, 3.082541155895596],
            [-17.165435392070144, 3.0808149903411928],
            [-17.168387153691, 3.0814235183171372],
            [-17.174427800107072, 3.0790498344757755],
            [-17.187959035735773, 3.08353072454897],
            [-17.19302018894683, 3.082472900546034],
            [-17.198821771911874, 3.075673363403844],
            [-17.201791190225805, 3.07569426104766],
            [-17.20782625706957, 3.0786786935152675],
            [-17.21373405672397, 3.0796582755100235],
            [-17.21643781545001, 3.078097921044496],
            [-17.224699190430112, 3.084390329475508],
            [-17.23088711889456, 3.086805316890188],
            [-17.237911152344243, 3.085750660221373],
            [-17.245990747851334, 3.086954314867232],
            [-17.248369436180564, 3.0883212592441125],
            [-17.25454813602028, 3.0868820906538597],
            [-17.26035541308452, 3.0901073483611183],
            [-17.26386536275053, 3.0933809232460616],
            [-17.268419431085004, 3.091037378066494],
            [-17.27245373057324, 3.090679545184869],
            [-17.27465442218902, 3.0851307733177156],
            [-17.27730865114032, 3.083076511374721],
            [-17.27737553824956, 3.0769344304134356],
            [-17.28080747235564, 3.0736882195973294],
            [-17.28318783697362, 3.075552598527193],
            [-17.290630021565814, 3.075749090234445],
            [-17.29441578687893, 3.0739365944366153],
            [-17.30069395273107, 3.0767869159386185],
            [-17.30451115982216, 3.0759298629766665],
            [-17.31066353196654, 3.07739276397443],
            [-17.312813243201596, 3.0798249384271146],
            [-17.324024176586367, 3.08460290998634],
            [-17.329451293790907, 3.0807839620729998],
            [-17.33186662174943, 3.0842248310064946],
            [-17.339774676368695, 3.0832756510022907],
            [-17.35949700512503, 3.0772443932479967],
            [-17.36902321744711, 3.0767477790222517],
            [-17.37803742389512, 3.0739712798409404],
            [-17.387424562138616, 3.066422415834573],
            [-17.390251471583788, 3.0651583931353383],
            [-17.39122284728765, 3.061306163257591],
            [-17.397578753370947, 3.058133632541448],
            [-17.400794831603054, 3.054862586250464],
            [-17.40243280033145, 3.050250527577558],
            [-17.408580100427248, 3.0486833994327682],
            [-17.41306295431131, 3.0518249661325925],
            [-17.419737614597437, 3.0535468079642594],
            [-17.42882110195093, 3.0510152759950184],
            [-17.43744490552887, 3.0535673260312906],
            [-17.44033557856455, 3.0572666375886133],
            [-17.445585465581, 3.0601300961384412],
            [-17.45186034354531, 3.0692029780230197],
            [-17.457331471877097, 3.070588560498754],
            [-17.475735384321414, 2.9997913186632643],
            [-17.44532032995436, 2.9920813724844675],
            [-17.45042754931754, 2.9767071344009914],
            [-17.457644258121174, 2.950099230436242],
            [-17.472283434417786, 2.9541913805390565],
            [-17.47619194823558, 2.939688551783766],
            [-17.482270648029203, 2.9412332456165267],
            [-17.485847447779097, 2.9270453350464147],
            [-17.479985897775403, 2.9255890867390666],
            [-17.483581967991963, 2.9114723591103004],
            [-17.47654866470224, 2.909842797473384],
            [-17.48020045294623, 2.895600525083107],
            [-17.473318129333716, 2.8937197650943967],
            [-17.476697714172516, 2.879447614575045],
            [-17.490714165280256, 2.883122977981879],
            [-17.503400526350738, 2.833511100467964],
            [-17.517124798213324, 2.8370330940502995],
            [-17.522963117181735, 2.8158788208887735],
            [-17.535999380978062, 2.819226605531985],
            [-17.537010243970197, 2.810843099583107],
            [-17.540623861071236, 2.804907548326894],
            [-17.561309632435357, 2.809948956555002],
            [-17.56794994781723, 2.811974488248473],
            [-17.571624302542865, 2.797828639890698],
            [-17.585544262358688, 2.8013164020737045],
            [-17.589178431142223, 2.787103892942266],
            [-17.610000732339792, 2.7923710692379435],
            [-17.611798930240035, 2.785336425219447],
            [-17.619380643555864, 2.788719485608949],
            [-17.62568458299885, 2.7888706013807063],
            [-17.63253775555355, 2.7905856558999425],
            [-17.634322080137746, 2.783579698428482],
            [-17.647134964648135, 2.7868134176136725],
            [-17.649008571372605, 2.7793566226837063],
            [-17.65601414639777, 2.7810148830500614],
            [-17.657839881988497, 2.7739174061448972],
            [-17.66474953597679, 2.7755664078040847],
            [-17.66807624145483, 2.7613328481333332],
            [-17.68204441907507, 2.764664879357749],
            [-17.6833889677714, 2.7593865842740355],
            [-17.77295496959567, 2.782588556614699],
            [-17.775377619643695, 2.7831283088362944],
            [-17.761261340008925, 2.8415689218983595],
            [-17.749934295867654, 2.8875752724139256],
            [-17.738653946894697, 2.9307981931242177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.66433064741881,
          "lat": 40.66551344057775
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32031"],
        "coty_name": ["Washoe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washoe County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00858608"
      },
      "bbox": [
        -17.775377619643695, 2.7593865842740355, -16.575915318489272,
        5.537740661654423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.28419854081896, 3.1151006239360255],
            [16.28824241889454, 3.120686040568076],
            [16.31006237529066, 3.142214399202687],
            [16.31814670251958, 3.1467133562192364],
            [16.327187594014042, 3.1475162563824464],
            [16.350281980526855, 3.163518651573011],
            [16.355840576393685, 3.1660851278587656],
            [16.360310691652217, 3.1701716941503677],
            [16.36229475546349, 3.1792556457585754],
            [16.372867263064986, 3.1895368779714106],
            [16.374342697609666, 3.192969499745572],
            [16.37402811991794, 3.201226560009949],
            [16.3764151882818, 3.2142596156665597],
            [16.378526532223823, 3.217606910210518],
            [16.383063749749365, 3.2195590797370808],
            [16.395628767733996, 3.217310626326675],
            [16.40495973369376, 3.2169449817802023],
            [16.409747899336317, 3.2184433841080873],
            [16.41720943791496, 3.228746274354373],
            [16.42395229174719, 3.2353290657852116],
            [16.427978991139497, 3.2372729939728697],
            [16.434558022071467, 3.2381322920192135],
            [16.43716665879399, 3.239833325112766],
            [16.446676565775213, 3.2533086002611262],
            [16.447455140187007, 3.2574949732358425],
            [16.450225145939523, 3.257820386591085],
            [16.453032397181023, 3.2611698776708886],
            [16.4529648463268, 3.2647108405568375],
            [16.456599330771052, 3.2714248021508214],
            [16.45275524821674, 3.2809371688268727],
            [16.448765407318266, 3.283483644502289],
            [16.450606995807206, 3.290840301757975],
            [16.459311646853894, 3.2937011977683173],
            [16.464809621193528, 3.28888154232937],
            [16.469057979910218, 3.290958581662113],
            [16.478351872327995, 3.284835388673879],
            [16.47802135270012, 3.280300450675288],
            [16.483484627003165, 3.2826654515166216],
            [16.48856640261797, 3.2819463120147394],
            [16.489578254864174, 3.2793498423036835],
            [16.497316046934717, 3.2777849768599325],
            [16.5011427676566, 3.2751393411099627],
            [16.508298497676048, 3.2755208048378175],
            [16.5134966655431, 3.27127380336269],
            [16.52092554607198, 3.2724948845999657],
            [16.522095430851124, 3.266636915131069],
            [16.526096142424212, 3.265294813383762],
            [16.528109928734725, 3.267077758105609],
            [16.5327160939004, 3.265933249905774],
            [16.542379772464045, 3.266297879255069],
            [16.54935046452786, 3.268261413824241],
            [16.588345617448553, 3.216079438635202],
            [16.610825883996345, 3.186214612786386],
            [16.616254631783093, 3.1785951667463013],
            [16.642725816263805, 3.137756522539718],
            [16.685074040311637, 3.0763770484871737],
            [16.72703842616761, 3.0163653930728898],
            [16.73281685560938, 3.007608559762801],
            [16.77865539731616, 2.943582731573528],
            [16.811463810652732, 2.7998560918602404],
            [16.818434230973786, 2.7695446285577137],
            [16.817390747495494, 2.7676053135389544],
            [16.81641646458351, 2.753881662092579],
            [16.817213543224234, 2.7502058025219878],
            [16.81613094963169, 2.744218484473724],
            [16.813504274943895, 2.7408705011641996],
            [16.809283832976394, 2.74137371791814],
            [16.80524842272704, 2.7398616095953567],
            [16.803537477180697, 2.736744110214116],
            [16.808588282204337, 2.7308192469390566],
            [16.8072053925168, 2.7266483809788733],
            [16.80531642832286, 2.726498038226352],
            [16.80035105746066, 2.7208332813741385],
            [16.795267184663228, 2.722210421083705],
            [16.792958048279463, 2.717212785878806],
            [16.797081579667086, 2.713261800341463],
            [16.79798657341539, 2.708691737852516],
            [16.79316829225849, 2.7077328354655577],
            [16.78858811753482, 2.711071773345823],
            [16.78752001863901, 2.714334530184786],
            [16.788293849304853, 2.7197023147589516],
            [16.78594065519936, 2.723105481225871],
            [16.78106953203881, 2.720269341865931],
            [16.78234369610181, 2.711930969759272],
            [16.77778036987939, 2.7108817633475195],
            [16.77414872710033, 2.717825515301927],
            [16.770081247353584, 2.716447026854459],
            [16.76788159734898, 2.712140090301823],
            [16.765151036309106, 2.7109590229082223],
            [16.758512019179918, 2.7166037191939827],
            [16.75212834631658, 2.712237135867202],
            [16.747403162044975, 2.718299989784521],
            [16.73851527038736, 2.7236482123531234],
            [16.733746750380572, 2.7228700727375386],
            [16.72923047586974, 2.7261767814390314],
            [16.726624126314473, 2.721538146938569],
            [16.721532537920258, 2.720104202174134],
            [16.717971508510303, 2.7227835312188335],
            [16.711382591127435, 2.723585702973408],
            [16.70904231163628, 2.726683024844149],
            [16.708020439244535, 2.7333756438048074],
            [16.701746853642813, 2.7365876489793823],
            [16.69599636261612, 2.743722643127448],
            [16.6896727398025, 2.740443097726007],
            [16.682935727501004, 2.741199936907331],
            [16.6800540219892, 2.7399770986971212],
            [16.675142903340188, 2.743975714676222],
            [16.67159829874014, 2.744823257163311],
            [16.66738134158786, 2.750943298430843],
            [16.660373305358135, 2.7523204421638745],
            [16.647886924167196, 2.7580605836440553],
            [16.643959006797196, 2.7577790047549575],
            [16.640384892502503, 2.759903520477079],
            [16.637673287978696, 2.7591245616659226],
            [16.63651315565527, 2.752763589654168],
            [16.63282655010407, 2.7537323542204035],
            [16.631797051782886, 2.758194700239496],
            [16.629451589649168, 2.7589962368098333],
            [16.62597376430362, 2.7557033483242095],
            [16.620318700136938, 2.7539128234484362],
            [16.61623373476304, 2.754545283080793],
            [16.61439439966666, 2.7575704347184846],
            [16.610588548476045, 2.7579627852733415],
            [16.610166679615954, 2.7628574134424078],
            [16.608226344994858, 2.7656754722791814],
            [16.605518891376832, 2.7833952369792687],
            [16.60118242188705, 2.7947647823728268],
            [16.596521817791757, 2.7998908864705516],
            [16.596532141076338, 2.8019397022554173],
            [16.59226802209037, 2.8081396923221242],
            [16.58765917486247, 2.809998782179254],
            [16.584413900560424, 2.8145368202971253],
            [16.531214143018794, 2.8418821819699023],
            [16.513896805760375, 2.850800948174439],
            [16.505044576714337, 2.8532937205163504],
            [16.49994048536449, 2.856140367033801],
            [16.49469630880344, 2.8625528019668653],
            [16.491348840109083, 2.8626175294899316],
            [16.486853413160404, 2.868864055603308],
            [16.48143741035965, 2.873514823959815],
            [16.467103044730045, 2.882588088165501],
            [16.45790952677639, 2.883399609311472],
            [16.456401795836438, 2.8851037852740515],
            [16.43831009063647, 2.88299382072126],
            [16.430919804018266, 2.878368803873004],
            [16.420042802485508, 2.873094861283032],
            [16.41570441247565, 2.8691443454896723],
            [16.405511672387593, 2.867375746086771],
            [16.401347012474073, 2.8679328761823872],
            [16.397202122598255, 2.8734797106859262],
            [16.393672048381138, 2.874146144062646],
            [16.3748335247337, 2.9145684936828413],
            [16.352002977776273, 2.9627137146729488],
            [16.335292617847703, 2.971750561411416],
            [16.32728927684255, 2.985367719145365],
            [16.32278980406604, 2.9880805031026543],
            [16.32048442790738, 2.9911346456974948],
            [16.311191032718256, 2.9904569099908804],
            [16.30351755110899, 2.9940858197287215],
            [16.30762174754461, 3.006354577894892],
            [16.306727212802905, 3.0081690122218694],
            [16.292939004428128, 3.0046638347314816],
            [16.28518130129815, 3.005113431212281],
            [16.280652774745636, 3.007908323582701],
            [16.275983227885188, 3.008554415412436],
            [16.274488946239714, 3.0126845652174215],
            [16.275337294296037, 3.0183932892937984],
            [16.271332290984308, 3.020571447707379],
            [16.267454175562754, 3.029931542522615],
            [16.270075061146002, 3.031519707451888],
            [16.2695021360442, 3.0416999081350276],
            [16.26756891221178, 3.0464750660136404],
            [16.264220522063653, 3.049442718372722],
            [16.252798957388272, 3.0520179753101715],
            [16.2502156418901, 3.0534399366281506],
            [16.241229981587193, 3.049592377851274],
            [16.240722438739194, 3.0465634423088352],
            [16.23277814109803, 3.0451568709427588],
            [16.232944545160937, 3.051167375363145],
            [16.234833850440694, 3.058988169806526],
            [16.238325584566226, 3.0653180744873927],
            [16.246694796231132, 3.072642119772083],
            [16.261776809074167, 3.0816794295880143],
            [16.263772366568393, 3.0854161246787766],
            [16.27537987484431, 3.1018650745121454],
            [16.28419854081896, 3.1151006239360255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.66806345306553,
          "lat": 39.877725397589124
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34005"],
        "coty_name": ["Burlington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burlington County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00882272"
      },
      "bbox": [
        16.23277814109803, 2.7077328354655577, 16.818434230973786,
        3.2937011977683173
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.257984976427833, 5.473795012688374],
            [14.27508163931995, 5.4774623250819925],
            [14.275981859613951, 5.472278611643849],
            [14.282265298736604, 5.451185145135995],
            [14.289921490684264, 5.436618647916434],
            [14.298651511637177, 5.424825308542913],
            [14.329573471112413, 5.388550734002074],
            [14.33405485913009, 5.378844271621932],
            [14.341176574495451, 5.34651107352583],
            [14.350540141680785, 5.302990622581065],
            [14.356925259878583, 5.266185166318094],
            [14.358334967498472, 5.245090308290533],
            [14.362749220621232, 5.218555709937124],
            [14.366296266981209, 5.209498960439839],
            [14.376854357139875, 5.189956021955114],
            [14.324353650859743, 5.175363729119979],
            [14.32299557886884, 5.180268636408229],
            [14.306319138189735, 5.1758764317686685],
            [14.3010149619533, 5.196866513413196],
            [14.26401107978999, 5.189169637445081],
            [14.216563468708966, 5.1787962647618455],
            [14.21200042167539, 5.199959048015255],
            [14.206561520213613, 5.201695039287348],
            [14.204892206700384, 5.197005024835969],
            [14.199464213777242, 5.18915809014445],
            [14.194565586195704, 5.185669765238754],
            [14.188000082017266, 5.184250638997335],
            [14.182945472009683, 5.18872362280666],
            [14.179936376763889, 5.203660301402378],
            [14.178974897611244, 5.2176772069609765],
            [14.17401223580811, 5.233754756927832],
            [14.172210643495958, 5.2415715105957865],
            [14.171496945379367, 5.252875571548359],
            [14.171811469215832, 5.26499936988655],
            [14.137178342478302, 5.257761420813228],
            [14.054977181132168, 5.241035892776331],
            [14.0120964563951, 5.232706768168323],
            [13.99566778523658, 5.3131274576708],
            [13.995879419013765, 5.31843969236529],
            [13.993731212238016, 5.322541623229267],
            [14.000665091570616, 5.324016254611546],
            [13.997588448952826, 5.3457741104050225],
            [13.997112412258115, 5.3559950735901225],
            [13.999448587100767, 5.376372095777469],
            [14.002157866192807, 5.390388708884804],
            [14.00824142054521, 5.406503381822239],
            [14.010376802381261, 5.409785910528109],
            [14.014153544125934, 5.421970776706208],
            [14.024010470051572, 5.424254935844484],
            [14.070603644524123, 5.433310350487739],
            [14.149876639664209, 5.449489681390095],
            [14.14960393507931, 5.451088884752866],
            [14.201903342075024, 5.462098948638032],
            [14.225355835579606, 5.466774624859707],
            [14.257984976427833, 5.473795012688374]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.10546086760979, "lat": 42.63346528274162 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36123"],
        "coty_name": ["Yates"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yates County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00974159"
      },
      "bbox": [
        13.993731212238016, 5.175363729119979, 14.376854357139875,
        5.4774623250819925
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.509014135591483, -1.502106324725819],
            [15.509926346764534, -1.4984240681586107],
            [15.515707551209314, -1.4939290883999021],
            [15.521815816294705, -1.4954405394825738],
            [15.546254530487664, -1.5042014224891505],
            [15.565561384220999, -1.5105193120544602],
            [15.601641358523128, -1.5237278224831319],
            [15.610786475089519, -1.5260710669318014],
            [15.629682933699232, -1.533245030430212],
            [15.652340805221582, -1.5390443352576297],
            [15.672219832150722, -1.5453247972251287],
            [15.769215300758395, -1.4626583565658653],
            [15.774180655541855, -1.476329395709701],
            [15.876282525979835, -1.4557146616398975],
            [15.93753535310836, -1.4432977122172925],
            [15.949649472426975, -1.4526604961397962],
            [15.951280420802423, -1.4558535321905994],
            [15.955073941581725, -1.457226436067007],
            [15.972726409447695, -1.4722410859174344],
            [15.975292191353688, -1.4779856014343347],
            [15.974132343484902, -1.4957618336077871],
            [15.980915122817567, -1.5059829203181763],
            [15.98828766233752, -1.5126503260144146],
            [15.993709179002435, -1.5187858848106432],
            [16.00264768245288, -1.5236292131415825],
            [16.004015523511654, -1.5263454923402793],
            [16.016612597999217, -1.5339720306860296],
            [16.022603868075013, -1.5332303262007845],
            [16.02792426573292, -1.5364399043257988],
            [16.034314887874345, -1.5324673139575555],
            [16.04135216793124, -1.534722197116366],
            [16.04325431120983, -1.5368727866382093],
            [16.042492821292218, -1.540734405307785],
            [16.039226222310834, -1.5453210521490133],
            [16.040241984187617, -1.5479915382912472],
            [16.049413143994236, -1.5474901895597146],
            [16.050905662196325, -1.5433004641316794],
            [16.055416807547065, -1.5428803000747437],
            [16.056821545331648, -1.5488077015148658],
            [16.062393498076624, -1.5502632142826729],
            [16.06667282365716, -1.5444809483136983],
            [16.071495475965673, -1.54561873366386],
            [16.070192953462154, -1.549313136131047],
            [16.074207780227567, -1.553933097447511],
            [16.079286617742365, -1.5502080234887026],
            [16.084261455264954, -1.55371292498932],
            [16.08794588500859, -1.5541605551097188],
            [16.089779008520914, -1.5574249840448247],
            [16.100718590594443, -1.5613008924352656],
            [16.098182971190056, -1.565020277878187],
            [16.09495108720036, -1.5656646122002222],
            [16.092825220397206, -1.5704900503185584],
            [16.092426051072234, -1.5817306874954427],
            [16.090546642786798, -1.5847263467862849],
            [16.084207297597047, -1.5888869458520019],
            [16.077591025272007, -1.5876980833434684],
            [16.07318151978021, -1.5881895629372171],
            [16.06605846246871, -1.5964516486780351],
            [16.059725127378737, -1.595025241781581],
            [16.05469278793194, -1.5966307515384537],
            [16.052844590302676, -1.6008032037547264],
            [16.047619074487518, -1.5988151436660096],
            [16.04110790412084, -1.5985716695265824],
            [16.037287875266763, -1.6042763967248106],
            [16.03208777608762, -1.5994463650681883],
            [16.024537797956558, -1.597027219784206],
            [16.015053711603485, -1.5966014715762726],
            [16.00154931071943, -1.6003931893463121],
            [15.998151702238292, -1.6028893155873714],
            [15.996176374905078, -1.6084775054493836],
            [15.99174933961527, -1.6097905765241076],
            [15.985435337336487, -1.6180682532894848],
            [15.98170950379865, -1.6256116305678523],
            [15.976440797651358, -1.6332754803551264],
            [15.980620824948831, -1.6373925350760423],
            [15.985710865318593, -1.6383338155974596],
            [15.99285694196995, -1.6454255338561674],
            [15.995288501229394, -1.6514996350436033],
            [16.00006323702512, -1.6546979278979583],
            [16.014834223224153, -1.6572956026484247],
            [16.012849094016513, -1.6681998464967547],
            [16.01435214810231, -1.6716767465863038],
            [16.014304526846832, -1.6818544125113393],
            [16.01260378531654, -1.6849970923708373],
            [16.01768862782969, -1.696307460253118],
            [16.027720344050117, -1.7012118891916423],
            [16.02667334959555, -1.7056169712874336],
            [16.033328940395343, -1.7106469656079082],
            [16.03364201937782, -1.7203306113655612],
            [16.0379176957962, -1.7220385099660283],
            [16.04235341585116, -1.7283020387732237],
            [16.045464262075008, -1.7376327191497933],
            [16.04960277718397, -1.740567298737157],
            [16.051841872108334, -1.7456902615064516],
            [16.049818990829984, -1.7472256647397195],
            [16.043260141455626, -1.7468683736567296],
            [16.0350246022125, -1.7487729599099746],
            [16.026134742147175, -1.7456239947417722],
            [16.01986919998091, -1.7447252887205253],
            [16.014108853361474, -1.7453177845805772],
            [16.005388368375574, -1.743927502748866],
            [15.990909135865817, -1.7431267638695818],
            [15.984822937072645, -1.7411906063400329],
            [15.978818378612052, -1.7358475538662548],
            [15.976347585240562, -1.7295757371988931],
            [15.977140523683046, -1.725821741428004],
            [15.974559618420171, -1.7237623118265784],
            [15.971412403260597, -1.7256077183450582],
            [15.972389232320321, -1.729394196668838],
            [15.96716220125727, -1.7344604901217422],
            [15.96238177897823, -1.7360838809561054],
            [15.950319935231166, -1.7345390664827305],
            [15.943672001681376, -1.7327166728817827],
            [15.936136839429563, -1.7284848508916104],
            [15.926887935372438, -1.7329100780571598],
            [15.910354882343475, -1.7355777809316013],
            [15.909588716070115, -1.7385260209596312],
            [15.904112905702444, -1.741444407971152],
            [15.899679556662306, -1.7459190927317827],
            [15.890233713923935, -1.7397064340615327],
            [15.883001061358934, -1.7397932476878988],
            [15.877130478148606, -1.736011862258714],
            [15.856046075824002, -1.7325550484127574],
            [15.851729131105811, -1.7296512712317755],
            [15.847154169533422, -1.722614748417251],
            [15.842484893190143, -1.7227728769548787],
            [15.837101193909351, -1.7288368152452436],
            [15.824638345645187, -1.7291575238478205],
            [15.81356196738697, -1.727883074853904],
            [15.80446949589221, -1.7255530887092378],
            [15.795579155107283, -1.7251745305996689],
            [15.780608410051459, -1.7276265559025596],
            [15.775351201867274, -1.7296930961566934],
            [15.760936181656202, -1.7252542603145782],
            [15.748396423584866, -1.7194368372804003],
            [15.746341380185747, -1.7218467708727596],
            [15.740490736300146, -1.7211335697203778],
            [15.729805100555653, -1.7146487652423623],
            [15.722071273534118, -1.7180108171414437],
            [15.717093500906437, -1.7166300783573565],
            [15.712657378343845, -1.7177344212413046],
            [15.703873678018402, -1.709353394972941],
            [15.692813562844394, -1.7035092185425056],
            [15.685215733999161, -1.6983983302388093],
            [15.68247191157782, -1.69258331395733],
            [15.668884348227785, -1.685379331796591],
            [15.651558617582433, -1.675149474095327],
            [15.64622034693049, -1.675829721615931],
            [15.643788544417635, -1.6783107928398995],
            [15.643809546676597, -1.6822863812839826],
            [15.649025926528806, -1.686805444557371],
            [15.654182735327783, -1.6871567953090443],
            [15.656492723721744, -1.689874540396934],
            [15.662495049139316, -1.6934386934779682],
            [15.673833846436777, -1.7020947847345989],
            [15.676322357491687, -1.7095554312634105],
            [15.658150122792726, -1.7038724266969452],
            [15.656557403128692, -1.7085742587094659],
            [15.66691797319946, -1.7172314793915215],
            [15.678660607472295, -1.7209738190269133],
            [15.694015502783104, -1.7292731035433724],
            [15.709153522555198, -1.729592915747438],
            [15.721187336912596, -1.7412082563624645],
            [15.730397250357273, -1.7609448953183542],
            [15.732868192129729, -1.7644288570315978],
            [15.751377352110007, -1.7495060020990123],
            [15.76246146081478, -1.7431748154876934],
            [15.768405381481207, -1.7494382822084131],
            [15.778601793986896, -1.7533417725059934],
            [15.79127047320734, -1.7549478004597632],
            [15.79951096601326, -1.758849992601966],
            [15.805654267384885, -1.7591919869416892],
            [15.825020990124303, -1.7542447786531616],
            [15.831242812555052, -1.7549680373537124],
            [15.851245716533615, -1.7668064924964078],
            [15.854116349219792, -1.7748171004407138],
            [15.859224905703254, -1.775221605317404],
            [15.866611522637353, -1.777445729204986],
            [15.872891579026776, -1.7803486520951377],
            [15.880951238074214, -1.77949608802649],
            [15.894489299997801, -1.7757256032828495],
            [15.895730024582702, -1.7798584266198876],
            [15.89911022362329, -1.7829555359950862],
            [15.914087014248718, -1.7842714434691755],
            [15.925411009890976, -1.785936510421079],
            [15.940048509509014, -1.7827299969614223],
            [15.946805584660156, -1.7879240849169429],
            [15.955545936034621, -1.7913146781885123],
            [15.962604994703815, -1.7909510143383707],
            [15.975323769551201, -1.801610583862178],
            [15.984622781836851, -1.8038856632544087],
            [15.989928117928152, -1.8027270619859415],
            [15.994862684134251, -1.8059667096349843],
            [16.00120212449139, -1.8062558061644223],
            [16.004830208951606, -1.8021722328251932],
            [16.028314648756382, -1.7978619232403625],
            [16.03385847802497, -1.8041575291851175],
            [16.030938426039413, -1.8073732070974504],
            [16.03020611751632, -1.8117122031605795],
            [16.03438917741527, -1.8277171904563025],
            [16.034021978749845, -1.8365181240292896],
            [16.034999285511162, -1.8403233824642118],
            [16.040348882519254, -1.8480454399479407],
            [16.041526762334986, -1.854144299621099],
            [16.04454210173984, -1.8597901228830538],
            [16.04441488525578, -1.8689704978657955],
            [16.037376723551606, -1.9065665980319413],
            [15.9276362546067, -1.9420821172837375],
            [15.872550594457222, -1.9602215719398755],
            [15.871458447430781, -1.9597314964292671],
            [15.824747564912018, -1.93106626690244],
            [15.765410168723195, -1.894702782284155],
            [15.639549576123434, -1.8462763310503691],
            [15.559482885091521, -1.815470548149684],
            [15.556819975052866, -1.8044608164630853],
            [15.554502416381263, -1.7993304310509322],
            [15.561187034523542, -1.7921639289047917],
            [15.56160618454947, -1.7885202054188374],
            [15.558846149520312, -1.7837840447139468],
            [15.558777032550722, -1.777823236246369],
            [15.563988709566303, -1.7752433239122287],
            [15.55837424900947, -1.7471894164290678],
            [15.56134125967964, -1.7342951721761142],
            [15.552967683480103, -1.7314329574588205],
            [15.550421841012612, -1.7254212825634219],
            [15.549407967637961, -1.7194077713362044],
            [15.549705143135968, -1.7138183493674723],
            [15.581412173298228, -1.671791942448878],
            [15.593452799897335, -1.6735100812313504],
            [15.599585162086104, -1.6719719412508895],
            [15.602892888748698, -1.6698427812034737],
            [15.608772763933988, -1.6692724064173148],
            [15.611778872939446, -1.6650049045165858],
            [15.611913044390365, -1.6565658567596058],
            [15.606860052448253, -1.6506867657064426],
            [15.603556725802122, -1.6560995588515541],
            [15.599269548652305, -1.6552676471322438],
            [15.598760128235018, -1.651928765432266],
            [15.590514628359871, -1.6510437859165006],
            [15.59228378256515, -1.6411708223887165],
            [15.589395406626616, -1.63997968135348],
            [15.585910348572144, -1.6436092965017732],
            [15.58396431601536, -1.6428589561427405],
            [15.585501541733397, -1.6366862398573203],
            [15.577789027189034, -1.6398504052332679],
            [15.57809266763115, -1.6329188403758386],
            [15.569236511961465, -1.6304717380403657],
            [15.567238300639062, -1.6310278448613786],
            [15.562800686891766, -1.6269683313452339],
            [15.558966823863647, -1.6273510233388686],
            [15.556219067723463, -1.620480444167607],
            [15.556807514847316, -1.610775791409368],
            [15.55192957346976, -1.6093413780000987],
            [15.548926469263538, -1.604838752531792],
            [15.543895959113453, -1.6046043070647316],
            [15.540927404920769, -1.6016973778611374],
            [15.53373763025337, -1.6017055180386717],
            [15.528408892476795, -1.5985342200721906],
            [15.52860079305548, -1.5946090372892516],
            [15.525079760013618, -1.5805957511572375],
            [15.52319956787076, -1.5755101182019027],
            [15.517299971675198, -1.5707080644651281],
            [15.518890873817353, -1.5654199140190206],
            [15.523266377276412, -1.564943304369435],
            [15.526421806121348, -1.560559004216132],
            [15.523464035815396, -1.5578151181742252],
            [15.521919313249418, -1.5494078834213663],
            [15.517011701619277, -1.5473400793681558],
            [15.513874162764733, -1.550162892330986],
            [15.511513492919068, -1.5427042286962687],
            [15.505529857110114, -1.5413649884597733],
            [15.501714617698841, -1.5433581618792556],
            [15.498398039366137, -1.53824002742813],
            [15.497960781689942, -1.5285993579986308],
            [15.502046577279161, -1.5258194424733105],
            [15.502702239693553, -1.5190500042786514],
            [15.506764228427201, -1.516898954117061],
            [15.512758236035582, -1.5186328565675395],
            [15.51470510231656, -1.5151484025530302],
            [15.510366408680582, -1.5069207215501688],
            [15.509014135591483, -1.502106324725819]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.85975033779874, "lat": 35.49397523336673 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37013"],
        "coty_name": ["Beaufort"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beaufort County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01026333"
      },
      "bbox": [
        15.497960781689942, -1.9602215719398755, 16.100718590594443,
        -1.4432977122172925
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.518628021949004, -1.0466034210531145],
            [13.552769721544093, -1.0403402681379674],
            [13.57181822174862, -1.0367937186548948],
            [13.652211989644663, -1.022647659470618],
            [13.725387310195314, -1.0096939320932996],
            [13.749836761282628, -1.0049738463292361],
            [13.81256179860618, -0.9935048405808478],
            [13.8194718675728, -1.0425639763436296],
            [13.832706129657394, -1.1405999528640258],
            [13.8536619128468, -1.2936038870952806],
            [13.771615427433254, -1.3066409642031196],
            [13.67810622585608, -1.3204680409606209],
            [13.555006032936006, -1.3384824644881377],
            [13.537380191043631, -1.1970575074115526],
            [13.527124270697604, -1.114773048612679],
            [13.518628021949004, -1.0466034210531145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.33353649006052, "lat": 36.39316993948283 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37033"],
        "coty_name": ["Caswell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caswell County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01008542"
      },
      "bbox": [
        13.518628021949004, -1.3384824644881377, 13.8536619128468,
        -0.9935048405808478
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.826740864913274, -2.040091959116611],
            [13.835147753842678, -2.0351668095444793],
            [13.838482501423055, -2.0305346089808944],
            [13.842351481862776, -2.030926746278746],
            [13.847929424412474, -2.029545367885392],
            [13.854719438308507, -2.02237973781526],
            [13.854995441988619, -2.020003052613207],
            [13.85051590903406, -2.016067960529101],
            [13.843315092647615, -2.0120259995531047],
            [13.848366048029964, -2.0103044934246714],
            [13.857799791234049, -2.003599290999606],
            [13.857822395269611, -1.9996964292229882],
            [13.860345748635869, -1.9980054519277906],
            [13.865940534558067, -1.9973126173968554],
            [13.872217074640165, -1.9941437239710356],
            [13.874793705213575, -1.9972440562738425],
            [13.870369841984255, -2.0017740361584613],
            [13.868676640751223, -2.007347981808562],
            [13.879442064563898, -2.0142520883136052],
            [13.883508514920589, -2.0159189571557374],
            [13.889637499296255, -2.013900682009079],
            [13.894155524893312, -2.00853659613718],
            [13.900116081909918, -1.9962159613873305],
            [13.903854442932671, -1.9906055228764634],
            [13.904090902753751, -1.981277512685367],
            [13.90146236714284, -1.9742724489280172],
            [13.903971082059254, -1.9725761450481019],
            [13.911297064050823, -1.9737264548302529],
            [13.917532757201888, -1.9719862650766584],
            [13.922505357365504, -1.9740518014285657],
            [13.921421194291858, -1.9815627818252854],
            [13.918654787107217, -1.9858181576999865],
            [13.921133046241344, -1.9897685672165746],
            [13.927788960735176, -1.9835483375167227],
            [13.939196726167783, -1.9779060182725732],
            [13.93852760382221, -1.973195654691754],
            [13.934496794416047, -1.963449333487562],
            [13.935267774942645, -1.9602949458267585],
            [13.944594477746135, -1.9562199841426144],
            [13.946695513594818, -1.9519078038719793],
            [13.954780080099534, -1.9400646579906768],
            [13.958306613782103, -1.9366607204595194],
            [13.9641535603085, -1.927973972527843],
            [13.965492449048217, -1.92134862164788],
            [13.968906118539792, -1.911597691298229],
            [13.975388212834646, -1.9050668937254103],
            [13.985060615988395, -1.903603572653508],
            [13.988930772528134, -1.8989074228544651],
            [13.993222825782393, -1.8981752904195333],
            [13.996891639003609, -1.902278232384934],
            [14.006379721182284, -1.8998933227989276],
            [14.014903197437908, -1.9042720930342323],
            [14.025848850054105, -1.9062061350377453],
            [14.033950247124883, -1.9099693759941574],
            [14.04056427041462, -1.9154506213494285],
            [14.049031712517186, -1.9203834290210218],
            [14.05180764030337, -1.9313127639650784],
            [14.056957522893114, -1.937492146316139],
            [14.05724713208539, -1.9424168257006509],
            [14.059501004175111, -1.9469281093180015],
            [14.06383506633062, -1.948951541812101],
            [14.070548195665193, -1.9543494114519617],
            [14.072558768662955, -1.9571992164048626],
            [14.08023503434227, -1.9636892241084467],
            [14.086844988577276, -1.9667067886269505],
            [14.092973566258948, -1.96719880959814],
            [14.10386568442456, -1.965834552330808],
            [14.114370045051864, -1.9706330847209834],
            [14.128174038861683, -1.9823938596885244],
            [14.062510272789007, -2.1037512365607456],
            [13.996434828768185, -2.2258279699466392],
            [13.965019911016782, -2.214668723875073],
            [13.962796384699121, -2.2142428517210635],
            [13.933734971710997, -2.2000099867407044],
            [13.924271274771947, -2.1996574668253492],
            [13.91659181746711, -2.1927389152672316],
            [13.916405334758052, -2.1837461735770742],
            [13.913099688238503, -2.1804416222554783],
            [13.90972154640917, -2.1701666006809184],
            [13.90274038171523, -2.1619710158216696],
            [13.895553219489791, -2.148279124589688],
            [13.892492357433195, -2.149700991784151],
            [13.882777253863363, -2.1459210486499902],
            [13.877673471580074, -2.14317993670121],
            [13.875592542208997, -2.139033383183839],
            [13.868191085415885, -2.1319388759311955],
            [13.862313376774548, -2.1328911300765583],
            [13.858945054692686, -2.130078087415444],
            [13.859952113814803, -2.1193104167677763],
            [13.856802733050934, -2.1148571275846715],
            [13.85190018670745, -2.1105554362814716],
            [13.847092188478419, -2.1088569638291474],
            [13.845710581142791, -2.1056324525665726],
            [13.835814625826236, -2.098346166629892],
            [13.83783745258426, -2.094163024805981],
            [13.832063341280833, -2.09379683301313],
            [13.82946911034631, -2.086358096321608],
            [13.828652393346626, -2.080763426643103],
            [13.832430860724905, -2.0805816278698064],
            [13.835896520127259, -2.0683303730088483],
            [13.839916283208776, -2.0640791390321933],
            [13.841546838870578, -2.058205685383072],
            [13.83738374356677, -2.0513753075507744],
            [13.826030713818593, -2.042433479907372],
            [13.826740864913274, -2.040091959116611]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.17142613700332,
          "lat": 35.475178352783836
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37105"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01008567"
      },
      "bbox": [
        13.826030713818593, -2.2258279699466392, 14.128174038861683,
        -1.8981752904195333
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.167258866476677, -2.167936450304241],
            [13.240685773427868, -2.1542514335529055],
            [13.259071839165438, -2.1509236074885565],
            [13.335138068093315, -2.1360160762402027],
            [13.38998004416173, -2.124367816230619],
            [13.495780475675, -2.104554471478125],
            [13.499700467255185, -2.1219824219079655],
            [13.50490528319633, -2.1395578080969098],
            [13.509116518544676, -2.1466800843208382],
            [13.520265599376078, -2.16938332671932],
            [13.542906788883515, -2.2223490376290815],
            [13.578096340973548, -2.305400383842278],
            [13.577309733492063, -2.307400273474214],
            [13.579142925354539, -2.3140772230415343],
            [13.578976748160212, -2.323348298234712],
            [13.580818714810832, -2.3309053451879644],
            [13.587473554360601, -2.3375817527963627],
            [13.588675586024554, -2.343409065373758],
            [13.59167136571598, -2.3494609641283173],
            [13.596153780440833, -2.35317179216573],
            [13.60272622683645, -2.3537238447806357],
            [13.606854214024244, -2.3552399496393654],
            [13.617617466797517, -2.356130684376231],
            [13.62097891956811, -2.360960386466729],
            [13.623891728716508, -2.3715134263253743],
            [13.627322918496375, -2.373234341910882],
            [13.627309501808448, -2.377221035680107],
            [13.630826324980251, -2.385866590379795],
            [13.632825192100276, -2.394564572245281],
            [13.637386944203056, -2.4048984147212846],
            [13.641598179326826, -2.4087789606424517],
            [13.645786444579047, -2.408822260817546],
            [13.655289503122269, -2.4162177465280323],
            [13.657771146149576, -2.419626701220617],
            [13.665573923640919, -2.419964712942158],
            [13.666601473840817, -2.4243207679292897],
            [13.672066795330162, -2.4221634312091767],
            [13.676609663075377, -2.42507429499912],
            [13.678115560905592, -2.4288059162206026],
            [13.66586729309927, -2.4335636500438076],
            [13.662932127659968, -2.4360878255776846],
            [13.656927991353845, -2.4385874286452873],
            [13.648849974660312, -2.435123095036021],
            [13.643151075627165, -2.433689914792138],
            [13.636592317380773, -2.4280347998377247],
            [13.630665186770173, -2.427403438953173],
            [13.628836144308664, -2.4254006665722083],
            [13.623188197633942, -2.424323523609701],
            [13.621043410823132, -2.4255133694070574],
            [13.615230920961107, -2.4245337231550463],
            [13.608761375773748, -2.4257580092065063],
            [13.605131753961661, -2.4292519643983677],
            [13.597466277521438, -2.433159259984989],
            [13.58752707043469, -2.4331844527147806],
            [13.580303714146195, -2.4308995652958805],
            [13.56858467478887, -2.438248525991451],
            [13.561379227072951, -2.4385053172037594],
            [13.552764090065743, -2.436706411023391],
            [13.540508157579298, -2.440315308349522],
            [13.534101085821787, -2.4411694139295026],
            [13.52391419574346, -2.4396316552477026],
            [13.517342805524711, -2.4399685998919005],
            [13.512417204182059, -2.4429172113224733],
            [13.507438013998005, -2.4425635994496573],
            [13.503380194280075, -2.4453298275050925],
            [13.497352655643104, -2.4456401602247926],
            [13.492557110874044, -2.442927834873337],
            [13.485428986228003, -2.4414464223870316],
            [13.470525789785993, -2.4549398369291873],
            [13.451386221677323, -2.4699109102707926],
            [13.442406804824573, -2.4706239064371758],
            [13.414490494118128, -2.4736970863550485],
            [13.411384851415873, -2.481041812702271],
            [13.402404292351786, -2.4835227242271922],
            [13.397719421634397, -2.4826792986327177],
            [13.39112139606179, -2.4853912614511158],
            [13.384186449411747, -2.484639336491358],
            [13.380701738616164, -2.4898529484585024],
            [13.370787088871287, -2.496601781217031],
            [13.368274950224833, -2.499661297861114],
            [13.359098072136232, -2.5071875192583937],
            [13.356337833024645, -2.5111583500534085],
            [13.351970290602754, -2.511302824115513],
            [13.3479259392243, -2.50956274827552],
            [13.341245915160858, -2.511158307175257],
            [13.313291284823865, -2.512424399679927],
            [13.316046704859126, -2.5009391862873853],
            [13.321772025712553, -2.4939297497874966],
            [13.324553040107551, -2.489104259402202],
            [13.326140167044954, -2.4800559176645267],
            [13.323970350403357, -2.4721000263100392],
            [13.318834444685416, -2.4668750676882683],
            [13.316328200854477, -2.46212297362895],
            [13.314017211608757, -2.4527657999359564],
            [13.310696400212537, -2.448522319072885],
            [13.308786483862962, -2.4431008382943387],
            [13.305080133798763, -2.4369168941379202],
            [13.296753952109443, -2.4276977890397706],
            [13.28968359057858, -2.424925131899827],
            [13.285338567204903, -2.4221865712287474],
            [13.2762205644963, -2.40411676167484],
            [13.27542274426432, -2.3978721294464242],
            [13.278139335018052, -2.3866062099314362],
            [13.277945051802353, -2.3831615219368576],
            [13.275187537509138, -2.3759932444310214],
            [13.274559146802373, -2.3685738384307],
            [13.27769179080459, -2.358747808802321],
            [13.28152893692747, -2.349605833299433],
            [13.280817318159723, -2.3426519638925596],
            [13.278041960810512, -2.3360527996836646],
            [13.281777382228407, -2.3253817086685364],
            [13.286587135582375, -2.317062789098931],
            [13.287132934559548, -2.3119232148763706],
            [13.2844485719255, -2.298485404984797],
            [13.285972556715016, -2.2932906575508305],
            [13.29093997508301, -2.290203137813662],
            [13.293617185615556, -2.2862831350056863],
            [13.29350979525637, -2.28116677359525],
            [13.287720676144572, -2.2769290717758497],
            [13.28283538074856, -2.2691202264608035],
            [13.271163059072688, -2.261955470544981],
            [13.264091821028938, -2.263127736944886],
            [13.260772661587987, -2.259821666995666],
            [13.255112808561284, -2.257552699641716],
            [13.254528446492753, -2.2541302725530734],
            [13.255701388344663, -2.243628584234507],
            [13.249408056338673, -2.234604987107931],
            [13.245029201001733, -2.230757461626207],
            [13.246567458364312, -2.2264010857466032],
            [13.24606035382128, -2.2222088743400463],
            [13.24341025814661, -2.2198884018492975],
            [13.237633503535918, -2.2186576165060576],
            [13.234814984004647, -2.213393157613185],
            [13.233693734926788, -2.202459330525844],
            [13.224952265412506, -2.197992861723839],
            [13.215808661476112, -2.197604165176466],
            [13.20606085941644, -2.1911613285196347],
            [13.198256945170144, -2.1948678007101106],
            [13.18867127533784, -2.1939297778733398],
            [13.18454560703625, -2.1894960358301145],
            [13.175415060747689, -2.1857084726803904],
            [13.172501334614338, -2.180566670581893],
            [13.171101964178218, -2.1744630800251152],
            [13.167258866476677, -2.167936450304241]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.90551255133994,
          "lat": 35.332474799158824
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37123"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01008572"
      },
      "bbox": [
        13.167258866476677, -2.512424399679927, 13.678115560905592,
        -2.104554471478125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.313291284823865, -2.512424399679927],
            [13.341245915160858, -2.511158307175257],
            [13.3479259392243, -2.50956274827552],
            [13.351970290602754, -2.511302824115513],
            [13.356337833024645, -2.5111583500534085],
            [13.359098072136232, -2.5071875192583937],
            [13.368274950224833, -2.499661297861114],
            [13.370787088871287, -2.496601781217031],
            [13.380701738616164, -2.4898529484585024],
            [13.384186449411747, -2.484639336491358],
            [13.39112139606179, -2.4853912614511158],
            [13.397719421634397, -2.4826792986327177],
            [13.402404292351786, -2.4835227242271922],
            [13.411384851415873, -2.481041812702271],
            [13.414490494118128, -2.4736970863550485],
            [13.442406804824573, -2.4706239064371758],
            [13.451386221677323, -2.4699109102707926],
            [13.470525789785993, -2.4549398369291873],
            [13.485428986228003, -2.4414464223870316],
            [13.492557110874044, -2.442927834873337],
            [13.497352655643104, -2.4456401602247926],
            [13.503380194280075, -2.4453298275050925],
            [13.507438013998005, -2.4425635994496573],
            [13.512417204182059, -2.4429172113224733],
            [13.517342805524711, -2.4399685998919005],
            [13.52391419574346, -2.4396316552477026],
            [13.534101085821787, -2.4411694139295026],
            [13.540508157579298, -2.440315308349522],
            [13.552764090065743, -2.436706411023391],
            [13.561379227072951, -2.4385053172037594],
            [13.56858467478887, -2.438248525991451],
            [13.580303714146195, -2.4308995652958805],
            [13.58752707043469, -2.4331844527147806],
            [13.597466277521438, -2.433159259984989],
            [13.605131753961661, -2.4292519643983677],
            [13.608761375773748, -2.4257580092065063],
            [13.615230920961107, -2.4245337231550463],
            [13.621043410823132, -2.4255133694070574],
            [13.623188197633942, -2.424323523609701],
            [13.628836144308664, -2.4254006665722083],
            [13.630665186770173, -2.427403438953173],
            [13.636592317380773, -2.4280347998377247],
            [13.643151075627165, -2.433689914792138],
            [13.648849974660312, -2.435123095036021],
            [13.656927991353845, -2.4385874286452873],
            [13.662932127659968, -2.4360878255776846],
            [13.66586729309927, -2.4335636500438076],
            [13.678115560905592, -2.4288059162206026],
            [13.67869745909427, -2.432729972738316],
            [13.682418686431989, -2.436657108138135],
            [13.684569776889433, -2.442728317621194],
            [13.68708533898045, -2.4422526542035596],
            [13.69436962307862, -2.4467784062086584],
            [13.702537477433856, -2.44982591999924],
            [13.706169253035082, -2.4530168568245028],
            [13.709117750828536, -2.4598815407777663],
            [13.716509396020733, -2.462671331043099],
            [13.71760828467227, -2.4646074470655446],
            [13.71811243715557, -2.4753802150683315],
            [13.720259134689908, -2.4846132653676407],
            [13.719134329264485, -2.4909193172163038],
            [13.716311246166542, -2.4975939176699935],
            [13.71710644539466, -2.5035619589796845],
            [13.720447298641284, -2.5081379752907544],
            [13.725017320626273, -2.5165603607609737],
            [13.72799861207775, -2.516806566658614],
            [13.734729221003002, -2.5212480062962332],
            [13.74666042726874, -2.516391975978954],
            [13.759473026402064, -2.515608632782685],
            [13.76071529410567, -2.514286640574346],
            [13.77246515559499, -2.5139293557836764],
            [13.781031438623671, -2.5153677423147047],
            [13.78565586657714, -2.5117608631179342],
            [13.7930638623189, -2.514093435848619],
            [13.80613243048402, -2.5155245271265403],
            [13.809517204492602, -2.520645378669031],
            [13.82326534287781, -2.526234069282279],
            [13.822037104946729, -2.5292540034318285],
            [13.813515391068906, -2.5364565828382246],
            [13.805380072442334, -2.539561551491492],
            [13.788798871630148, -2.548883636303263],
            [13.782813145267282, -2.552771371059485],
            [13.777580053601941, -2.559111713576541],
            [13.754627530492783, -2.578010296876535],
            [13.743026523594304, -2.5917203105431623],
            [13.740498068089945, -2.59332725019157],
            [13.748124177409164, -2.6050830893096326],
            [13.744207728941612, -2.610642650018481],
            [13.740278565307886, -2.613640150785346],
            [13.741236757988883, -2.6171701828185077],
            [13.738624248892485, -2.622943622074498],
            [13.739828595635357, -2.6295979471065514],
            [13.737232865813924, -2.6322122509407597],
            [13.740329031875342, -2.638967328141631],
            [13.739520415139706, -2.6413857000569876],
            [13.743691724361657, -2.6508268857246304],
            [13.748243297150779, -2.655705012922761],
            [13.7557533965001, -2.656844544510683],
            [13.760936031243542, -2.665711778914304],
            [13.760302366864057, -2.672185193383323],
            [13.763961149383078, -2.6729518859744483],
            [13.74114832953562, -2.706604801484313],
            [13.728272601157599, -2.7245927484383046],
            [13.7221689777471, -2.739603940044795],
            [13.728306528687122, -2.742316867485786],
            [13.726758523948318, -2.7477593776451075],
            [13.73178562069778, -2.751225420197853],
            [13.73030876208263, -2.7558539854689483],
            [13.73173601845054, -2.7597342270391483],
            [13.72948093737528, -2.7643701719464815],
            [13.732032924540588, -2.7745345616733057],
            [13.725520471265984, -2.771513669194057],
            [13.720372871080068, -2.7673064933357243],
            [13.718544578918662, -2.7702269298691258],
            [13.712945555527133, -2.774272224541489],
            [13.706221286181115, -2.7806120053984014],
            [13.702461604944919, -2.780874690744253],
            [13.691092854669492, -2.784860467317002],
            [13.687077035677806, -2.7849091517433875],
            [13.679642730631961, -2.7888380203083787],
            [13.677085088250877, -2.7957887359303073],
            [13.612089886765613, -2.806031098365774],
            [13.534383969035733, -2.8199352303661507],
            [13.488658493842973, -2.8265484950476276],
            [13.491756989267605, -2.8237669144413484],
            [13.497521732734851, -2.8123960355496185],
            [13.497066623275689, -2.804711182786089],
            [13.497672640388881, -2.789640196517727],
            [13.500127154902888, -2.775550754330047],
            [13.502041850237541, -2.7712322522649866],
            [13.506095432013318, -2.767807097645203],
            [13.511182272799793, -2.7656540693211658],
            [13.516343530520913, -2.7602576118777735],
            [13.518895581619258, -2.7550189240104603],
            [13.522705599333289, -2.7505867051963073],
            [13.52740539077565, -2.7423390314996863],
            [13.531142446145038, -2.7317016780680796],
            [13.53470265371796, -2.7248419141973312],
            [13.534816784753577, -2.71625958269361],
            [13.53323024376873, -2.7118218238281986],
            [13.522029914390941, -2.692862886261019],
            [13.514451411220428, -2.6859625287835494],
            [13.50839937553557, -2.6762042211911554],
            [13.507822053020703, -2.670348291537455],
            [13.509845910353535, -2.6624361716932636],
            [13.510820811890715, -2.649011090712583],
            [13.507103951811068, -2.6438314568661814],
            [13.500880725036323, -2.642185939457537],
            [13.495288919143817, -2.6391348592795927],
            [13.484250352522528, -2.6310321004406303],
            [13.477717417225437, -2.6269694438232527],
            [13.47602804867265, -2.622795457067423],
            [13.479085798493081, -2.614671249555645],
            [13.47960582155101, -2.6049811444698183],
            [13.484368765462484, -2.598530427043566],
            [13.490016698474449, -2.5925288563355324],
            [13.489828660938729, -2.5851253144246384],
            [13.487131826235123, -2.5811451307526188],
            [13.480889571145179, -2.5764117216196647],
            [13.464714687174748, -2.569502079855276],
            [13.460329980306712, -2.5665832908213764],
            [13.45546164277185, -2.558823868604518],
            [13.454199815254789, -2.5534783999482054],
            [13.452765485752733, -2.541168144577362],
            [13.449578952088304, -2.534119892584184],
            [13.44212476826858, -2.5277497350560973],
            [13.438983363644672, -2.5193460640845564],
            [13.431097489711055, -2.517095804927512],
            [13.4207398476312, -2.519223049497143],
            [13.411690516871966, -2.5257464388975963],
            [13.404044736600888, -2.534748652250614],
            [13.399051842563749, -2.5393961388066053],
            [13.396112215989517, -2.545039282452551],
            [13.395708439853871, -2.550316630830487],
            [13.393433352443296, -2.5543143801646058],
            [13.388890826262578, -2.5583752177528396],
            [13.382784226578325, -2.5591996378186592],
            [13.370090226070836, -2.5574668739557023],
            [13.364164839691986, -2.55801890701942],
            [13.35685863683179, -2.5548236876003187],
            [13.347260166658346, -2.548083334696903],
            [13.32765230342457, -2.5435727151265852],
            [13.322510612696744, -2.539304461373352],
            [13.321678520821447, -2.531832318331108],
            [13.316004602140348, -2.5228799368453383],
            [13.313291284823865, -2.512424399679927]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.74788813788965,
          "lat": 35.005966180722176
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37153"],
        "coty_name": ["Richmond"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richmond County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01008581"
      },
      "bbox": [
        13.313291284823865, -2.8265484950476276, 13.82326534287781,
        -2.424323523609701
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.077649342859592, -2.1841816312946705],
            [13.161951318696048, -2.169668549677292],
            [13.16669956526829, -2.1680405540220824],
            [13.167258866476677, -2.167936450304241],
            [13.171101964178218, -2.1744630800251152],
            [13.172501334614338, -2.180566670581893],
            [13.175415060747689, -2.1857084726803904],
            [13.18454560703625, -2.1894960358301145],
            [13.18867127533784, -2.1939297778733398],
            [13.198256945170144, -2.1948678007101106],
            [13.20606085941644, -2.1911613285196347],
            [13.215808661476112, -2.197604165176466],
            [13.224952265412506, -2.197992861723839],
            [13.233693734926788, -2.202459330525844],
            [13.234814984004647, -2.213393157613185],
            [13.237633503535918, -2.2186576165060576],
            [13.24341025814661, -2.2198884018492975],
            [13.24606035382128, -2.2222088743400463],
            [13.246567458364312, -2.2264010857466032],
            [13.245029201001733, -2.230757461626207],
            [13.249408056338673, -2.234604987107931],
            [13.255701388344663, -2.243628584234507],
            [13.254528446492753, -2.2541302725530734],
            [13.255112808561284, -2.257552699641716],
            [13.260772661587987, -2.259821666995666],
            [13.264091821028938, -2.263127736944886],
            [13.271163059072688, -2.261955470544981],
            [13.28283538074856, -2.2691202264608035],
            [13.287720676144572, -2.2769290717758497],
            [13.29350979525637, -2.28116677359525],
            [13.293617185615556, -2.2862831350056863],
            [13.29093997508301, -2.290203137813662],
            [13.285972556715016, -2.2932906575508305],
            [13.2844485719255, -2.298485404984797],
            [13.287132934559548, -2.3119232148763706],
            [13.286587135582375, -2.317062789098931],
            [13.281777382228407, -2.3253817086685364],
            [13.278041960810512, -2.3360527996836646],
            [13.280817318159723, -2.3426519638925596],
            [13.28152893692747, -2.349605833299433],
            [13.27769179080459, -2.358747808802321],
            [13.274559146802373, -2.3685738384307],
            [13.275187537509138, -2.3759932444310214],
            [13.277945051802353, -2.3831615219368576],
            [13.278139335018052, -2.3866062099314362],
            [13.27542274426432, -2.3978721294464242],
            [13.2762205644963, -2.40411676167484],
            [13.285338567204903, -2.4221865712287474],
            [13.28968359057858, -2.424925131899827],
            [13.296753952109443, -2.4276977890397706],
            [13.305080133798763, -2.4369168941379202],
            [13.308786483862962, -2.4431008382943387],
            [13.310696400212537, -2.448522319072885],
            [13.314017211608757, -2.4527657999359564],
            [13.316328200854477, -2.46212297362895],
            [13.318834444685416, -2.4668750676882683],
            [13.323970350403357, -2.4721000263100392],
            [13.326140167044954, -2.4800559176645267],
            [13.324553040107551, -2.489104259402202],
            [13.321772025712553, -2.4939297497874966],
            [13.316046704859126, -2.5009391862873853],
            [13.313291284823865, -2.512424399679927],
            [13.310683211759304, -2.508251676619424],
            [13.302128867322681, -2.499630673646326],
            [13.2954372900033, -2.494135632954006],
            [13.287418744689885, -2.4904020881676825],
            [13.281499586757395, -2.4843791993457156],
            [13.278580071566997, -2.4696996559165605],
            [13.273203987875881, -2.4668377830870636],
            [13.267608431718935, -2.4696428199655163],
            [13.26291477967589, -2.4754432164094515],
            [13.263857738898931, -2.4793764342445774],
            [13.268349112152764, -2.4853895550258085],
            [13.267315464205419, -2.4887164405569075],
            [13.263569664094534, -2.489597611915332],
            [13.260545095672487, -2.4963784807418334],
            [13.256330877582455, -2.496486795266715],
            [13.249745848710111, -2.4924450661619204],
            [13.245185893521398, -2.4913376511611856],
            [13.242392314273808, -2.4940135750521875],
            [13.24242456638704, -2.4991534226599237],
            [13.2377035439809, -2.50297764863778],
            [13.23638675560335, -2.505872078555143],
            [13.238904157440771, -2.510628008743318],
            [13.24439924531323, -2.515761270684162],
            [13.240841451989992, -2.520139971669657],
            [13.232989166514782, -2.520689323090284],
            [13.224127807563109, -2.516443179440091],
            [13.219059939828538, -2.515558314416228],
            [13.215879762652847, -2.511956377519381],
            [13.213993599261872, -2.5063502009511764],
            [13.209631573881985, -2.50563564076185],
            [13.205322914268546, -2.5094425813493326],
            [13.205705828650212, -2.516736346992107],
            [13.20112352365344, -2.518746442534248],
            [13.19147254639795, -2.5194620368672274],
            [13.184602045090944, -2.509758559541328],
            [13.179629012758312, -2.5058545170848117],
            [13.173586987777393, -2.4965705713389372],
            [13.174424686910958, -2.491115300240855],
            [13.162116750500806, -2.4750144511104906],
            [13.159918158212937, -2.4689394367104645],
            [13.151958416126357, -2.4726126723440025],
            [13.151767169675537, -2.4767919067753703],
            [13.146745829469223, -2.4805194352687447],
            [13.14348159130948, -2.487141222761626],
            [13.139818610992643, -2.4876141858308443],
            [13.135992092436924, -2.4927782605162343],
            [13.131811773125472, -2.490985115017762],
            [13.12799018083323, -2.4921173479427687],
            [13.123004509718069, -2.4989989822718894],
            [13.123585214405578, -2.5033515638582533],
            [13.11934188428832, -2.5065987525217492],
            [13.112423414239796, -2.5083812738594924],
            [13.11217236433356, -2.514327903566992],
            [13.104023736156265, -2.513418950179465],
            [13.100947131629358, -2.5166394910345793],
            [13.09628660854049, -2.517037857925209],
            [13.09142647832903, -2.523253064514011],
            [13.087783636293697, -2.5238148966071945],
            [13.08401081865927, -2.5285413896294133],
            [13.077881413900972, -2.524053252611781],
            [13.072914285429741, -2.5158815081346204],
            [13.068135430974877, -2.51707311946115],
            [13.065144514232617, -2.523597605158702],
            [13.059302991553238, -2.5316357967676075],
            [13.051380110542302, -2.5332333219161707],
            [13.045521669850975, -2.533275101886378],
            [13.043478114221081, -2.536414836206744],
            [13.039910181356307, -2.536934304260012],
            [13.033416848802942, -2.528765881858654],
            [13.028739804197242, -2.5324026368032944],
            [13.02540684077776, -2.537016174780782],
            [13.021899768852924, -2.5383050710855724],
            [13.018887918737855, -2.5432400059326703],
            [13.012382329943973, -2.5404792365855147],
            [13.001914763620281, -2.5412481695371323],
            [12.997320344878235, -2.537504312856773],
            [12.993466941905364, -2.5410896609578497],
            [12.987213582474158, -2.5361580379512247],
            [12.985946592181953, -2.53110587948819],
            [12.982759229646671, -2.529755422942929],
            [12.977695286697106, -2.53526825535849],
            [12.973387842489156, -2.53266167605548],
            [12.966838986075635, -2.531860287384167],
            [12.962889187995412, -2.5279954392911197],
            [12.963035914161319, -2.5249718540938852],
            [12.96071115218896, -2.520586563877891],
            [12.965301861984187, -2.513888148284394],
            [12.966995555716746, -2.507668736059752],
            [12.970780931919826, -2.5020549702102692],
            [12.975646441771204, -2.497882992623541],
            [12.974238889263425, -2.494090488013738],
            [13.001376988332199, -2.412811630884202],
            [13.017503946629107, -2.3638452439420616],
            [13.03479571545068, -2.3120703221317185],
            [13.077649342859592, -2.1841816312946705]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.2510053932249, "lat": 35.3119176158007 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37167"],
        "coty_name": ["Stanly"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stanly County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "01025844"
      },
      "bbox": [
        12.96071115218896, -2.5432400059326703, 13.326140167044954,
        -2.167936450304241
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.667584854495459, -1.6060884844419154],
            [11.673240557112843, -1.5900433486282013],
            [11.68067022924117, -1.5833906537827707],
            [11.68866639952998, -1.5804130245999064],
            [11.696370665867395, -1.5722389246814779],
            [11.697362349195943, -1.5689122680470493],
            [11.704545720081075, -1.5565937889955497],
            [11.70845018907234, -1.5513376848515368],
            [11.713129666181759, -1.5478680555912334],
            [11.725612718809803, -1.5359558160561646],
            [11.733840578626822, -1.533210003592884],
            [11.741069144750925, -1.529830771070226],
            [11.749556704043432, -1.5214039407509599],
            [11.755725724791509, -1.5207530290459652],
            [11.75778076588656, -1.52237640726518],
            [11.760062876276496, -1.5299445263053788],
            [11.768251968697506, -1.5282149356718153],
            [11.77209145171764, -1.5318804762957328],
            [11.77702548983026, -1.5333796041880232],
            [11.780787817459984, -1.5364971823133224],
            [11.784946805098338, -1.5344634095944603],
            [11.789323776501845, -1.5368704484088693],
            [11.79707126638802, -1.534951378556708],
            [11.802995045437827, -1.5287401560277194],
            [11.809433920121004, -1.5293453836837199],
            [11.815439803178082, -1.5312892941051552],
            [11.817965436470935, -1.5335503774103414],
            [11.826677348935874, -1.5331335074362182],
            [11.82735456206079, -1.5262122620128253],
            [11.824764890867618, -1.5223639094405155],
            [11.81690773427275, -1.5217450856902612],
            [11.813200803939178, -1.518848324697338],
            [11.809945097996215, -1.5126142019663422],
            [11.809173297535885, -1.5060613716027194],
            [11.80687345714316, -1.5017145341943663],
            [11.80207384666952, -1.4971649680913977],
            [11.798535018168181, -1.4920785853457157],
            [11.801807935249089, -1.4854294561192893],
            [11.801527547154857, -1.479737317947953],
            [11.879122246765718, -1.5104368652634017],
            [11.909177939577306, -1.5378141791650608],
            [11.917545200012439, -1.5462947127728077],
            [11.923965413473402, -1.5501201626499623],
            [11.928063966917158, -1.5547888300445394],
            [11.932236388513225, -1.56204491877119],
            [11.939670167809759, -1.5684521171475923],
            [11.947809771933812, -1.5791339736576808],
            [11.954231039693397, -1.574656128933267],
            [11.958104673306748, -1.573117780554683],
            [11.963054762923486, -1.5766041191052058],
            [11.975226724322512, -1.5813932384574971],
            [11.985448668473888, -1.5904224041044766],
            [11.990383235696473, -1.5880673330323751],
            [12.015534575751108, -1.6001661577304211],
            [12.022641059515825, -1.6000995489158891],
            [12.023173225311274, -1.6045299847660854],
            [12.028724842567952, -1.6103712649693063],
            [12.033997774732953, -1.6117774846253077],
            [12.034482929769638, -1.6185744218507059],
            [12.041877893341027, -1.635432259326224],
            [12.045921848794176, -1.6371538933872023],
            [12.02761341130902, -1.681350356754999],
            [12.019585266628603, -1.7003279117489791],
            [11.987733039436012, -1.7307860379396005],
            [11.896493661528769, -1.7437640214483927],
            [11.884617583051451, -1.7412614710788417],
            [11.778919413328092, -1.7685632746453335],
            [11.778130969093677, -1.7687348568982089],
            [11.762536971835386, -1.7303422918256606],
            [11.761203317707446, -1.7251731872255438],
            [11.755369582015595, -1.7134392597373451],
            [11.750898691828564, -1.7143379078708683],
            [11.748557287393961, -1.7104982289284307],
            [11.730003066669616, -1.6920764199841791],
            [11.708018675125475, -1.6996817535384343],
            [11.704624483099487, -1.6928890360431985],
            [11.693222429817144, -1.685460595067096],
            [11.685319325413735, -1.6755895557300866],
            [11.68545681479586, -1.6680729730710695],
            [11.681668130253417, -1.6629910047661436],
            [11.683555796595158, -1.657789997208593],
            [11.68300288914177, -1.6532409926785059],
            [11.68748506244862, -1.651899344531641],
            [11.690859689836966, -1.6478847362411242],
            [11.687722645123396, -1.642373066289763],
            [11.68412643069705, -1.6403097647003424],
            [11.685161899680047, -1.6368884570968483],
            [11.68852423403054, -1.6366320232560152],
            [11.690366465661185, -1.6265045635854156],
            [11.687793963634286, -1.6183712016014533],
            [11.68239269998717, -1.610018657685513],
            [11.678305407771997, -1.6132449585502437],
            [11.672596200958312, -1.6110968535354706],
            [11.667584854495459, -1.6060884844419154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.69642761707048, "lat": 36.23109860724808 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37189"],
        "coty_name": ["Watauga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Watauga County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "01008594"
      },
      "bbox": [
        11.667584854495459, -1.7687348568982089, 12.045921848794176,
        -1.479737317947953
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3395457433472897, 8.690669037059092],
            [-2.285082091714311, 8.688264848053329],
            [-2.197739352816948, 8.684831121427662],
            [-2.1258903864729355, 8.68179629035688],
            [-2.0242991130495227, 8.677817905939808],
            [-1.908928220212929, 8.673421947692473],
            [-1.9117725238460925, 8.597784969077916],
            [-1.9118413013357398, 8.588814134021213],
            [-1.915288859393624, 8.503425768172871],
            [-1.9185282930902234, 8.417980841088996],
            [-1.9214918218513306, 8.332898203792208],
            [-1.8974516343469354, 8.331522458125802],
            [-1.9021696892464803, 8.225854951036856],
            [-1.906950547020296, 8.117095579614888],
            [-1.9085519921635585, 8.076006403736955],
            [-1.9102419094075613, 8.03767109721855],
            [-1.9126726164512438, 7.988181662905438],
            [-2.0170247045065506, 7.992345510493412],
            [-2.086476040757047, 7.995412039100861],
            [-2.1398747402005722, 7.997594238044634],
            [-2.1733320633626634, 7.999120543859614],
            [-2.1899645656572457, 7.999628404077885],
            [-2.2333703070322266, 8.001773125586237],
            [-2.3056284090620855, 8.004859056846525],
            [-2.34735736202616, 8.006988787744843],
            [-2.344847355743949, 8.050316980593173],
            [-2.343165115940554, 8.083708306661473],
            [-2.3391850752078316, 8.15074629390039],
            [-2.334515211032331, 8.23474520109195],
            [-2.328395783288142, 8.349479318120215],
            [-2.3553627712500633, 8.351008130133762],
            [-2.3534543631579172, 8.393779048795148],
            [-2.349777363541102, 8.472349727999829],
            [-2.3473368978942104, 8.522387168579884],
            [-2.343414849386072, 8.607470887311457],
            [-2.3394081581433883, 8.689915499063547],
            [-2.3395457433472897, 8.690669037059092]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.78007831978424,
          "lat": 46.980067597198804
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38043"],
        "coty_name": ["Kidder"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kidder County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01034206"
      },
      "bbox": [
        -2.3553627712500633, 7.988181662905438, -1.8974516343469354,
        8.690669037059092
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.924386454279673, 9.82745529242493],
            [-2.919692561986465, 9.91213229301621],
            [-2.9150895743659606, 9.99673293170789],
            [-2.8755277832138213, 9.994766614813452],
            [-2.8716899970106486, 9.994782313110232],
            [-2.8136254948911867, 9.99189050704364],
            [-2.7521274795009307, 9.988812559535926],
            [-2.6906301307900327, 9.985721772000863],
            [-2.6535867143588803, 9.983750181253573],
            [-2.595872245538679, 9.980917956728293],
            [-2.59389010547384, 9.980976946530053],
            [-2.523463504491203, 9.97728754694929],
            [-2.479476485765226, 9.97487909799758],
            [-2.483299051733167, 9.889933228826163],
            [-2.3964782782434475, 9.886204982396574],
            [-2.4002682913622966, 9.80173107104811],
            [-2.4042021065851586, 9.717155841183246],
            [-2.377721888781207, 9.71589813040107],
            [-2.378529569686376, 9.702786182667747],
            [-2.380472794839572, 9.658230784688165],
            [-2.3803333650095952, 9.656945192444198],
            [-2.385469207716294, 9.545050515711635],
            [-2.388295165869497, 9.488415358130254],
            [-2.38923967908429, 9.459826956666596],
            [-2.3912770410056234, 9.417548918172079],
            [-2.3930995381660747, 9.374810239620256],
            [-2.3665084578410163, 9.373636513525403],
            [-2.3692026004600466, 9.31452383058299],
            [-2.374433934087187, 9.203272773034133],
            [-2.4619064649508493, 9.206848947666563],
            [-2.493399729756393, 9.208262229590654],
            [-2.5487554601083855, 9.211043561989117],
            [-2.636000218375561, 9.215318312964238],
            [-2.723137646023165, 9.219553063812702],
            [-2.8100854242268434, 9.22432776593797],
            [-2.8966858380590157, 9.228710653310664],
            [-2.8966581830412546, 9.229180995369193],
            [-2.895297448181237, 9.257030774569866],
            [-2.892011460567724, 9.31229323545682],
            [-2.8871573461758118, 9.39933186066152],
            [-2.9171776632177355, 9.40085188866757],
            [-2.9135020752361864, 9.467702711294026],
            [-2.908905967203148, 9.549481215484246],
            [-2.903074366764578, 9.65534653504538],
            [-2.901370424703193, 9.683578091353313],
            [-2.8984229943600566, 9.741079096987958],
            [-2.9290246231388557, 9.742699543529204],
            [-2.924386454279673, 9.82745529242493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.63630611967221,
          "lat": 48.23455187719335
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38049"],
        "coty_name": ["McHenry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McHenry County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01035305"
      },
      "bbox": [
        -2.9290246231388557, 9.203272773034133, -2.3665084578410163,
        9.99673293170789
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.444010039326873, 1.1301970611528647],
            [9.488325541305954, 1.131955564723922],
            [9.582778892885658, 1.1359810844194445],
            [9.637732906993186, 1.1384858400917088],
            [9.651203061963836, 1.139161765027935],
            [9.65324933399245, 1.0753158924053077],
            [9.655382438730157, 1.0136978621641668],
            [9.655433754884013, 1.0008894572602096],
            [9.656233639159536, 0.9742588173097271],
            [9.658496643555543, 0.8600867766088672],
            [9.660674080530223, 0.7868635809501715],
            [9.661402660716972, 0.7696019412260026],
            [9.664621573865762, 0.6505198849174103],
            [9.664558832024625, 0.649643375952719],
            [9.650254516793742, 0.6469208691702862],
            [9.63215274304191, 0.6494945163607061],
            [9.620539169104752, 0.6521045542328197],
            [9.614878125787437, 0.6549279598186332],
            [9.599141894113938, 0.6598346388562661],
            [9.582510864552221, 0.6632688071044317],
            [9.549248389295395, 0.6652261801565658],
            [9.543499447095808, 0.6662060497750392],
            [9.537509737300892, 0.6686326625725476],
            [9.529494118556956, 0.6758202928236896],
            [9.526524122591287, 0.6794306368375216],
            [9.521387749114302, 0.6886994353885894],
            [9.517307073054605, 0.7037249942008093],
            [9.515593781235287, 0.7146066327197532],
            [9.514331867469242, 0.7360733258975569],
            [9.512818836859799, 0.7455452659375218],
            [9.510094891778095, 0.7542620803313452],
            [9.499811990671496, 0.7670322071159245],
            [9.489108841557764, 0.7821560606707632],
            [9.473147247328495, 0.7987955556567139],
            [9.468866060963082, 0.8019851346167354],
            [9.461242738937509, 0.8118453044197618],
            [9.454408435234544, 0.8237211536631365],
            [9.45123656426287, 0.8406331258712737],
            [9.447699873988908, 0.851058656419766],
            [9.442325995731546, 0.861044372501606],
            [9.434161789436772, 0.8707423754735684],
            [9.428752333684052, 0.8752618117267622],
            [9.427848559079198, 0.9147371096701281],
            [9.426958726654213, 0.9976344196680679],
            [9.425621554154143, 1.0145853661604807],
            [9.426240438737269, 1.019746544470671],
            [9.429677886277457, 1.0227462236377567],
            [9.425579761255705, 1.0292685022523622],
            [9.42982158896756, 1.036009062282239],
            [9.432647259548926, 1.0378998398278036],
            [9.433191968855077, 1.0453058751781392],
            [9.439062515866663, 1.054373659807913],
            [9.439434740436525, 1.0614959791534204],
            [9.432449807734642, 1.0700479539629555],
            [9.428222175102974, 1.0693229901830954],
            [9.421205463822032, 1.0645153424222071],
            [9.41370633868963, 1.0632961061429491],
            [9.409980142111973, 1.0671897264575578],
            [9.407134805318512, 1.0744204538637216],
            [9.403763280744467, 1.07697690232284],
            [9.40586463808361, 1.0808073355105243],
            [9.411163677635326, 1.08613553405712],
            [9.412237640430314, 1.0891913471062378],
            [9.417987947414291, 1.090658170145416],
            [9.419777494226892, 1.0950994375855783],
            [9.419311699733473, 1.1010415261644808],
            [9.420990016556248, 1.1049727439045514],
            [9.428556299962414, 1.109033141504023],
            [9.436500131425682, 1.1166298725482422],
            [9.440654398692661, 1.122761594380324],
            [9.44327340563183, 1.123826036564097],
            [9.444010039326873, 1.1301970611528647]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.15167121286692, "lat": 39.04755178430911 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39025"],
        "coty_name": ["Clermont"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clermont County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01074025"
      },
      "bbox": [
        9.403763280744467, 0.6469208691702862, 9.664621573865762,
        1.139161765027935
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.59323797833757, 0.953136517580111],
            [10.589608650932258, 1.0109741741756317],
            [10.588110413191886, 1.041541406790461],
            [10.586736080629095, 1.0414757015983707],
            [10.583847651757997, 1.086705858872452],
            [10.58133483086659, 1.1311668138513602],
            [10.578530029727165, 1.1760300672582278],
            [10.593271213608956, 1.1770737120965191],
            [10.590527055479194, 1.2176610823457577],
            [10.677065773412254, 1.224033860925562],
            [10.677797638199136, 1.2111890397695873],
            [10.709149941238332, 1.2115527205881662],
            [10.736910085267532, 1.2153920402198555],
            [10.757760328655936, 1.2153262543989483],
            [10.7665994177474, 1.214814010116139],
            [10.768747873805532, 1.1781237831849611],
            [10.799943897147054, 1.1792135075835466],
            [10.857601311430647, 1.1840581347544843],
            [10.864282060320962, 1.0802472307106363],
            [10.868405072259744, 1.0295394445568742],
            [10.870531684277237, 0.9914102503208538],
            [10.873593832905879, 0.939825545511615],
            [10.876454911881595, 0.8877088934714253],
            [10.861899220954443, 0.8876608766065861],
            [10.784177747901062, 0.8836015525105001],
            [10.784540276697404, 0.8744785499250096],
            [10.72702637384881, 0.8710099011130901],
            [10.699253031883805, 0.8692686627870785],
            [10.641699082078393, 0.8649126523063769],
            [10.638656765176805, 0.8794180552054323],
            [10.638976776691234, 0.8965406190358136],
            [10.634579948934045, 0.9561711017688096],
            [10.59323797833757, 0.953136517580111]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.6183650131263, "lat": 39.01964674103809 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39079"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01074052"
      },
      "bbox": [
        10.578530029727165, 0.8649126523063769, 10.876454911881595,
        1.224033860925562
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.0338841324866688, -2.563735022331912],
            [-0.03289856848406616, -2.5601758687275185],
            [0.05364495548014945, -2.5606541743210207],
            [0.1628877887058341, -2.5619207570125373],
            [0.22547024957135117, -2.562593178061616],
            [0.22518295473320904, -2.649822835654379],
            [0.32538698922759135, -2.650142271795511],
            [0.40440022863322084, -2.6503758498718892],
            [0.4400503494826465, -2.6505959125916054],
            [0.4400863176622763, -2.7823021773987686],
            [0.4400060418203088, -2.826268693153145],
            [0.4370322638647332, -2.826274767056906],
            [0.43727043561564927, -2.8546197232312096],
            [0.4371427085847874, -2.870901749447534],
            [0.39457026655426586, -2.8704991234787514],
            [0.30921998990557753, -2.870579833343619],
            [0.3089482163112895, -2.959040448511086],
            [0.3086725939934401, -3.0512677523575746],
            [0.30864598139161337, -3.0901734815586073],
            [0.2370233853884085, -3.0902661625864893],
            [0.1461147050839148, -3.0896330729995545],
            [0.12614851978463335, -3.089366382368203],
            [0.07990782551805647, -3.089416823517429],
            [-0.0006165183287797402, -3.0890368463832747],
            [-0.03628451730235833, -3.0887822671372094],
            [-0.036184653686994285, -3.0722852990013143],
            [-0.03525181479226831, -3.0253957974850545],
            [-0.03545282412136578, -3.017488030194653],
            [-0.03434475029759152, -2.9422934051535115],
            [-0.033723381912562266, -2.8617428842313557],
            [-0.03402011170501398, -2.795084996812699],
            [-0.033349124406297365, -2.7838646678349632],
            [-0.034513343936886626, -2.738063276689512],
            [-0.034874923353532386, -2.6634806939403104],
            [-0.03425641200789238, -2.5973457488058527],
            [-0.03334084701168844, -2.5637123555003947],
            [-0.0338841324866688, -2.563735022331912]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.37084362636948, "lat": 35.90257104054142 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40037"],
        "coty_name": ["Creek"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Creek County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01101806"
      },
      "bbox": [
        -0.03628451730235833, -3.0902661625864893, 0.4400863176622763,
        -2.5601758687275185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6324056774728494, -1.718355900009323],
            [0.7036748663743151, -1.718258184392711],
            [0.7117478614956235, -1.7180967578017299],
            [0.8414960431281987, -1.7176255622030951],
            [0.9322053485857114, -1.717155686347217],
            [0.9324732040380884, -1.774207241358871],
            [0.9135445268621968, -1.7744408165627885],
            [0.9141337945615894, -1.8740100407709852],
            [0.9147185485216667, -1.9616789193235797],
            [0.9150608789437931, -2.0202220121744014],
            [0.9157768523719464, -2.1226045601987034],
            [0.7977757009181262, -2.1232268434403583],
            [0.6576326982228204, -2.123743184025214],
            [0.6152017770644757, -2.1238037367267735],
            [0.6151023259024648, -2.0508329132669973],
            [0.614736420599105, -1.9483089532636688],
            [0.6144439943695205, -1.873958791777002],
            [0.6142833636115356, -1.7763033608782692],
            [0.6326163798043233, -1.7762543699464857],
            [0.6324056774728494, -1.718355900009323]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.61736628573692, "lat": 36.79846913311542 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40105"],
        "coty_name": ["Nowata"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nowata County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01101840"
      },
      "bbox": [
        0.6142833636115356, -2.1238037367267735, 0.9324732040380884,
        -1.717155686347217
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.30864598139161337, -3.0901734815586073],
            [0.3086725939934401, -3.0512677523575746],
            [0.3089482163112895, -2.959040448511086],
            [0.30921998990557753, -2.870579833343619],
            [0.39457026655426586, -2.8704991234787514],
            [0.4371427085847874, -2.870901749447534],
            [0.4799740885498431, -2.870846194266968],
            [0.5444786710989469, -2.8713364430901485],
            [0.6087351128997046, -2.871342340921036],
            [0.6515770942804552, -2.8712198245533664],
            [0.6517797730782893, -3.002773933526617],
            [0.6945659875941884, -3.0025994615531144],
            [0.6947988686388982, -3.0897574689754133],
            [0.6949251659401084, -3.0915707301933066],
            [0.6949506386050198, -3.163432936332668],
            [0.6951994323806152, -3.1779857730754197],
            [0.6069788835570818, -3.1782464398086576],
            [0.6070899500748811, -3.266901753972686],
            [0.5643703081200316, -3.267032016057394],
            [0.5644384612580038, -3.3545912706876897],
            [0.4787201409787977, -3.354557004984055],
            [0.39299797332085645, -3.3544363098020598],
            [0.3928864171121934, -3.312498866519098],
            [0.39294217413695265, -3.178035137906812],
            [0.30835741418254203, -3.1779457728647085],
            [0.30864598139161337, -3.0901734815586073]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.96428657715683,
          "lat": 35.646598118140396
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40111"],
        "coty_name": ["Okmulgee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Okmulgee County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01101843"
      },
      "bbox": [
        0.30835741418254203, -3.3545912706876897, 0.6951994323806152,
        -2.8704991234787514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.101506123929774, 9.21626651354085],
            [-16.075739984152083, 9.221811595407937],
            [-16.03543266850763, 9.21541298194944],
            [-16.012641988335282, 9.216338274615271],
            [-16.00702087097825, 9.216159421391845],
            [-15.959823162022454, 9.216022194532261],
            [-15.940223714142139, 9.209089512720539],
            [-15.867816211835086, 9.202359113298357],
            [-15.82442236734502, 9.241094322236153],
            [-15.805574320148233, 9.250555284096345],
            [-15.784577865296155, 9.251278981883958],
            [-15.75700084411686, 9.22725768769174],
            [-15.732704995890018, 9.218865769784308],
            [-15.704629286925805, 9.223112279940683],
            [-15.69218116005161, 9.22093020931879],
            [-15.704995066533325, 9.170396664446297],
            [-15.706888807147694, 9.170330227692636],
            [-15.716564770938858, 9.133388300624404],
            [-15.733297207989454, 9.066556312643478],
            [-15.746013156897597, 9.01677739158786],
            [-15.770755564755758, 8.919662264600793],
            [-15.644684808584158, 8.887374523226708],
            [-15.66524812098853, 8.805019883667233],
            [-15.59520357243085, 8.787611922013395],
            [-15.61657965124285, 8.703915614637054],
            [-15.66002311943237, 8.538633508496172],
            [-15.659355463241212, 8.538466388188029],
            [-15.679520073199125, 8.456831896346168],
            [-15.70053423732486, 8.372112180064832],
            [-15.711904657950756, 8.37491133769368],
            [-15.73280310408918, 8.291546200091238],
            [-15.8309742049731, 8.31522178828362],
            [-15.831291138512613, 8.315603611941338],
            [-15.912810386122237, 8.335750831607067],
            [-15.994334087856599, 8.355879234825865],
            [-16.000129400178686, 8.356943402785332],
            [-16.02784273973361, 8.36388588943622],
            [-16.035065048279233, 8.364909451612924],
            [-16.078444216903584, 8.37593538277685],
            [-16.08186617848979, 8.377259421143723],
            [-16.14892390339963, 8.394247218298654],
            [-16.16334533091609, 8.397445487567403],
            [-16.14490654618452, 8.467477852630624],
            [-16.14166626730969, 8.480384626638276],
            [-16.12109083024719, 8.475210416225016],
            [-16.098650855892288, 8.559386941631143],
            [-16.18338661000858, 8.580778909036137],
            [-16.160478172367206, 8.664619174628395],
            [-16.244899383664706, 8.68690751358068],
            [-16.211906674977932, 8.809277428755186],
            [-16.178735314049025, 8.935267380414444],
            [-16.174983503194934, 8.934337513211304],
            [-16.131685272188637, 9.097090235639333],
            [-16.101506123929774, 9.21626651354085]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -119.584374451503, "lat": 45.41895740886281 },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41049"],
        "coty_name": ["Morrow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morrow County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01135860"
      },
      "bbox": [
        -16.244899383664706, 8.291546200091238, -15.59520357243085,
        9.251278981883958
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.550277709041146, 5.295611353342107],
            [-1.5429687480633412, 5.295092700360478],
            [-1.464465809355342, 5.293676171331005],
            [-1.3799961796179674, 5.29190874846636],
            [-1.3659428628391361, 5.2918646180135225],
            [-1.2948149706401113, 5.2902613068497155],
            [-1.2086679892667611, 5.288897252017768],
            [-1.2107861089576177, 5.2022314182815395],
            [-1.206302135525127, 5.202192010289855],
            [-1.207662515390046, 5.156101318319721],
            [-1.2107299829511302, 5.03925983845392],
            [-1.2113908082371976, 5.018112031384628],
            [-1.2116269002948021, 4.998297451293386],
            [-1.2127874261273015, 4.937669234838028],
            [-1.2127570037507955, 4.9222816237643645],
            [-1.2116059589971635, 4.849647063324724],
            [-1.2970886757621751, 4.851606014353671],
            [-1.3828131293952368, 4.854209398303692],
            [-1.4683515581870712, 4.856825264283973],
            [-1.489601577255736, 4.857642252551885],
            [-1.4962210813536165, 4.857632103752954],
            [-1.5536975790507757, 4.8593585941139725],
            [-1.5510216319831274, 4.946073530650744],
            [-1.5483941397187824, 5.033220227268051],
            [-1.5470114927493694, 5.098237942550219],
            [-1.5450882175014877, 5.208802236195155],
            [-1.5521438259904028, 5.208921413181497],
            [-1.551970427949012, 5.223486727254768],
            [-1.5505089849387375, 5.281359608439354],
            [-1.550277709041146, 5.295611353342107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.5615577932117, "lat": 43.717995697320355 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46003"],
        "coty_name": ["Aurora"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Aurora County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01266983"
      },
      "bbox": [
        -1.5536975790507757, 4.849647063324724, -1.206302135525127,
        5.295611353342107
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9169621488652955, 4.871446556151405],
            [-1.9168719287578, 4.87163074267482],
            [-1.8106361569356435, 4.867854125439896],
            [-1.7243459251935989, 4.864955900151301],
            [-1.6393689736862709, 4.862066850706374],
            [-1.5536975790507757, 4.8593585941139725],
            [-1.4962210813536165, 4.857632103752954],
            [-1.489601577255736, 4.857642252551885],
            [-1.492701566885328, 4.786106693561491],
            [-1.494074011505154, 4.728307423281737],
            [-1.4751091082420873, 4.72876047068397],
            [-1.475065644523447, 4.730858203776682],
            [-1.4334128573025537, 4.712139405767416],
            [-1.406315655780521, 4.699608621222699],
            [-1.4046573382957732, 4.699176932313525],
            [-1.3638255311070413, 4.679932414330477],
            [-1.3213993043594296, 4.6604127309548256],
            [-1.2506384466590548, 4.6273060477954555],
            [-1.2353565623249934, 4.620582831815749],
            [-1.1689737631448642, 4.59046080849735],
            [-1.1506853231039547, 4.582490315990251],
            [-1.1084109569121068, 4.563570228536585],
            [-1.0659584974457827, 4.543891691916441],
            [-1.0368938113392259, 4.531275751103867],
            [-1.0431052505249023, 4.514814435194102],
            [-1.052672494344857, 4.499198132414694],
            [-1.0525282976256634, 4.492012267563366],
            [-1.0549704324893938, 4.481884462336085],
            [-1.0555943861771437, 4.465701117037059],
            [-1.0578130774873635, 4.4616904490083495],
            [-1.0631241488491856, 4.45946639373116],
            [-1.066820356183003, 4.448816148038031],
            [-1.0661079449036193, 4.440934727204727],
            [-1.0684290105565415, 4.434312371138703],
            [-1.0662515965719987, 4.4301602674471825],
            [-1.067605299673524, 4.425258974125829],
            [-1.0683029055810382, 4.411904173935327],
            [-1.0645700346139988, 4.403201042869671],
            [-1.0644254478596684, 4.395239822675439],
            [-1.0654718500688887, 4.390904769801119],
            [-1.064653249501102, 4.383730630615165],
            [-1.0601956502053929, 4.378106825958804],
            [-1.070843472633545, 4.366960410823976],
            [-1.0687495177451236, 4.36317632252646],
            [-1.0716782020855509, 4.359821286860957],
            [-1.0729792862034304, 4.347922421543261],
            [-1.0686638331699627, 4.345116926887255],
            [-1.0683680802485098, 4.338917154717996],
            [-1.0649225879100213, 4.335169219795225],
            [-1.064487198725223, 4.32871746537866],
            [-1.0595131916664393, 4.324985170573086],
            [-1.0587779291735318, 4.320220777150105],
            [-1.0623409344784254, 4.316901877955005],
            [-1.0628893297196833, 4.30521543831552],
            [-1.0653031983972427, 4.304716936683947],
            [-1.0710328371819713, 4.289331726533446],
            [-1.0675383846988944, 4.284300080686976],
            [-1.0734982530441441, 4.282202947078621],
            [-1.0727121179338277, 4.278790901794743],
            [-1.07469200170509, 4.2752996762670294],
            [-1.069922048559855, 4.272650047026686],
            [-1.0738357179944475, 4.2667005829143845],
            [-1.0743535780556885, 4.259576347874675],
            [-1.0823318651497105, 4.257454305482288],
            [-1.0815785841891918, 4.252481616877007],
            [-1.0774824340648124, 4.250099142881343],
            [-1.076989482638121, 4.243594204999081],
            [-1.0748368127304466, 4.242538178525286],
            [-1.0747419502285698, 4.23751073400503],
            [-1.0763458336299707, 4.2356410887329785],
            [-1.0763020073050893, 4.227218512016439],
            [-1.0793410496584566, 4.222969769170435],
            [-1.0809241323138374, 4.217814786729309],
            [-1.083634564573729, 4.215119986135017],
            [-1.088821471896103, 4.216338454694251],
            [-1.0914867079224273, 4.212819180217601],
            [-1.0952111341547732, 4.211505038074956],
            [-1.096288705744671, 4.208041562352659],
            [-1.0944183886101588, 4.205611549293718],
            [-1.0997920729128188, 4.200665271688263],
            [-1.1038115204833108, 4.200297341499257],
            [-1.1114636879118542, 4.19769711348164],
            [-1.1063176906606076, 4.19386095261922],
            [-1.1057094389497593, 4.185975807532993],
            [-1.1131748508219736, 4.184215846234237],
            [-1.1188975282927336, 4.184316909888821],
            [-1.1323869482687932, 4.189155127723493],
            [-1.1430080880655191, 4.194634928928191],
            [-1.1540237347124418, 4.201224230615772],
            [-1.1626488946980365, 4.209435832260257],
            [-1.1733377158640659, 4.21696854732513],
            [-1.175433835140359, 4.2204755951806705],
            [-1.1815326872947065, 4.223175415075466],
            [-1.1888859172663773, 4.22311128056663],
            [-1.1973472199290554, 4.2241600616352475],
            [-1.209940603470702, 4.229542515735783],
            [-1.2188411311336225, 4.232266716072709],
            [-1.230466373730231, 4.2365029831286005],
            [-1.2359010440850595, 4.241684590208327],
            [-1.2375097540610576, 4.245859660872918],
            [-1.242159332880356, 4.251183935822795],
            [-1.2533799843409412, 4.258151594894593],
            [-1.2658420200066323, 4.264095485234072],
            [-1.2737799690911251, 4.269586006764066],
            [-1.2891551798640222, 4.277339600520759],
            [-1.2983978656838018, 4.2837676924455295],
            [-1.3058276081940485, 4.283535483913504],
            [-1.312324018809789, 4.280381835023939],
            [-1.3167140138750648, 4.2829272112169186],
            [-1.3174607372516531, 4.287457869174995],
            [-1.3255916377303365, 4.295950613227065],
            [-1.331915592511527, 4.300309395738328],
            [-1.3399096568956341, 4.316550363526416],
            [-1.34794199527739, 4.331213698107286],
            [-1.3515041194205817, 4.341421956175286],
            [-1.3532640882319567, 4.352028186162179],
            [-1.353438218044515, 4.35943907422793],
            [-1.3586674617511294, 4.372963351373757],
            [-1.3642530227388057, 4.383255429440799],
            [-1.371311446658597, 4.393412181091178],
            [-1.3843007069576152, 4.405802376296637],
            [-1.3944727555754592, 4.413704439223656],
            [-1.4093149142598478, 4.419916893497468],
            [-1.4384215195172856, 4.430145173308824],
            [-1.4577725507865398, 4.427792379747633],
            [-1.471160174988574, 4.428791020217457],
            [-1.485326211369719, 4.432039491263528],
            [-1.490569818129495, 4.433991438238995],
            [-1.5027955733033875, 4.441928122165277],
            [-1.507725565706594, 4.446870856855571],
            [-1.5163239793427299, 4.458433863794203],
            [-1.519387198118435, 4.463518390234729],
            [-1.532528578996395, 4.488313754695637],
            [-1.5431290890121057, 4.500411969501458],
            [-1.5487690486503753, 4.505213122695509],
            [-1.5609946057334294, 4.5097680267658165],
            [-1.5751953159694738, 4.512004032071528],
            [-1.5959385908832933, 4.513659469406528],
            [-1.6066750005866566, 4.515649479004036],
            [-1.611322980593329, 4.517589539575651],
            [-1.6174548585414752, 4.523378531289393],
            [-1.6194009824631497, 4.527378426546617],
            [-1.6233104152531337, 4.541573705112061],
            [-1.6234391764662015, 4.54548056923541],
            [-1.6214906603657757, 4.570119757903365],
            [-1.6219941926475592, 4.588309340278462],
            [-1.6243722228532427, 4.597438910952949],
            [-1.6287948316310397, 4.605119664349599],
            [-1.6351762011645252, 4.609026045625384],
            [-1.6444352205863602, 4.610401618047766],
            [-1.6687783413221744, 4.6114055659633975],
            [-1.6739257376129189, 4.612157093459732],
            [-1.687094605652677, 4.617554723149019],
            [-1.6959812586906051, 4.622965116940394],
            [-1.7029184742837207, 4.630659854795332],
            [-1.7092919982499708, 4.640175625120971],
            [-1.7232105251545102, 4.655564091639598],
            [-1.7284384924285925, 4.660003517698035],
            [-1.735511417085347, 4.664613312548057],
            [-1.7492011783235872, 4.67788927842306],
            [-1.7577291431549125, 4.686807127505991],
            [-1.76939623295167, 4.705862720324632],
            [-1.7734982017156111, 4.720405715636925],
            [-1.7799489654747152, 4.73360484135802],
            [-1.784673324707913, 4.740104516418091],
            [-1.7970595440297097, 4.748143794941204],
            [-1.801061131931688, 4.757404134806028],
            [-1.8034191840172873, 4.760529600644687],
            [-1.8062185419208887, 4.7687324269740285],
            [-1.8057442654734457, 4.775159119379831],
            [-1.8116437760743613, 4.790158455042794],
            [-1.8184883032268808, 4.799006705476666],
            [-1.8266468748642355, 4.804791498922933],
            [-1.8322413323003521, 4.80670986537675],
            [-1.8411136664735062, 4.80509166628095],
            [-1.856247915055403, 4.806480287443883],
            [-1.8642327543516561, 4.805849013172005],
            [-1.8854950595845739, 4.807107805482284],
            [-1.888746556507016, 4.807788814012133],
            [-1.9064537375987525, 4.8161169395857275],
            [-1.9113356259864234, 4.821965396699392],
            [-1.922904470918404, 4.832302113339828],
            [-1.925833273304965, 4.836879595159544],
            [-1.9270169286187928, 4.846044613464074],
            [-1.925343957484484, 4.85243062335384],
            [-1.9222269218373809, 4.857406163050462],
            [-1.9204758783861025, 4.863729211394068],
            [-1.9169621488652955, 4.871446556151405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.58796360488476, "lat": 43.20796594162568 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46023"],
        "coty_name": ["Charles Mix"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charles Mix County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01266976"
      },
      "bbox": [
        -1.9270169286187928, 4.184215846234237, -1.0368938113392259,
        4.87163074267482
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6916278462608085, 5.189584233636274],
            [-0.6417464163149414, 5.188484579107833],
            [-0.5771028128993189, 5.1872874848066],
            [-0.5199404252475279, 5.186372321337153],
            [-0.4766320072091909, 5.18571949709734],
            [-0.3472962035510943, 5.183559226879242],
            [-0.3482860572060065, 5.096715770158175],
            [-0.34881138099075726, 5.081865871892271],
            [-0.3496153236681122, 5.010317570028578],
            [-0.3495450414141194, 5.002382206691143],
            [-0.35065720485463325, 4.910942274684645],
            [-0.3510284601238286, 4.893241138919407],
            [-0.3517324191517778, 4.83512766234593],
            [-0.4380239222256526, 4.836289706343245],
            [-0.5480793104867202, 4.837832899678344],
            [-0.6339434118098147, 4.839178157584524],
            [-0.6964770678432217, 4.840216430298394],
            [-0.6946956058858391, 4.941062799680374],
            [-0.6931468857866866, 5.013807603741015],
            [-0.6925621797125853, 5.0718421965662905],
            [-0.6934675992180038, 5.100882194455223],
            [-0.6916278462608085, 5.189584233636274]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.36844021116983, "lat": 43.67429851168016 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46087"],
        "coty_name": ["McCook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCook County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01265773"
      },
      "bbox": [
        -0.6964770678432217, 4.83512766234593, -0.3472962035510943,
        5.189584233636274
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.781927347655069, -1.4205714986593667],
            [10.858466695675865, -1.410262182345723],
            [10.903780411732477, -1.4036530619023277],
            [10.900949286103396, -1.4052491273014533],
            [10.88073363433674, -1.4194916122509986],
            [10.86442279463705, -1.430109375530189],
            [10.843014626926085, -1.4476371879933827],
            [10.834249703397845, -1.4533856505166474],
            [10.816198425275955, -1.4675223784560165],
            [10.80643808698626, -1.456491686195567],
            [10.79927680098951, -1.4604983210037996],
            [10.796652567550836, -1.4644401192042988],
            [10.7896937130421, -1.4696667235422853],
            [10.782345014100674, -1.4529465997824182],
            [10.776286902240397, -1.4564740874270743],
            [10.770683842745298, -1.4524161665286117],
            [10.765838410221841, -1.4533880892654716],
            [10.757294307224857, -1.462508066175401],
            [10.754629153869542, -1.4676618905390881],
            [10.749492463311746, -1.4706080672424828],
            [10.744048157832834, -1.4684008600255931],
            [10.69826578880304, -1.5054275591157804],
            [10.698894484105276, -1.5076894875723328],
            [10.69006302406745, -1.514796618193691],
            [10.686969986568473, -1.5145053385759586],
            [10.682712046224099, -1.5192533209386716],
            [10.684753375233699, -1.5217190078237044],
            [10.682223785974633, -1.5272600033068984],
            [10.677421221332095, -1.5331093122075448],
            [10.669664181792289, -1.5391880334588515],
            [10.66962490490085, -1.5422589093251793],
            [10.664000568635599, -1.5483094334908616],
            [10.66139628818441, -1.5533267773001875],
            [10.657365487006444, -1.5556057429213086],
            [10.658331053929542, -1.55975189689324],
            [10.655105315867674, -1.562634185575964],
            [10.66034420782927, -1.5715974058166746],
            [10.648396327278691, -1.579533446363702],
            [10.648648235940422, -1.5839352661945936],
            [10.644262516022385, -1.582843751594407],
            [10.638337012509126, -1.5859892836990226],
            [10.635847054153652, -1.5889743761521968],
            [10.63223957924849, -1.5890557348305894],
            [10.631234675094376, -1.5938455707279842],
            [10.627761639043664, -1.5966182108894016],
            [10.633694015225908, -1.6051498259157588],
            [10.636556568765421, -1.6054769487297562],
            [10.638315430594448, -1.6107375626844243],
            [10.640403270530955, -1.6124912982485042],
            [10.634225624264138, -1.6161997616414852],
            [10.629544170440111, -1.6218537205261523],
            [10.619483657886176, -1.6296806307682605],
            [10.614455777835596, -1.6311748079152881],
            [10.590472421839857, -1.6454092151522608],
            [10.577064076659504, -1.6515932711286232],
            [10.57590461191668, -1.651342053262803],
            [10.566400461368449, -1.6548603698934639],
            [10.55812630250001, -1.660350208322778],
            [10.554899825116326, -1.6561002178198903],
            [10.553116576207488, -1.6494164876342907],
            [10.547926318142938, -1.650922629036193],
            [10.544526953625269, -1.6447671850808476],
            [10.541096011723578, -1.6462709910561018],
            [10.538908908506999, -1.6428197272483582],
            [10.531180199911285, -1.6442161397591615],
            [10.526331649592251, -1.6440501758655994],
            [10.515888274631992, -1.6339449881993675],
            [10.488079767758956, -1.649393388456032],
            [10.486979207347924, -1.6459456258507297],
            [10.489497305971934, -1.6440897671862233],
            [10.487961036850885, -1.638686501654636],
            [10.495337300242443, -1.6343291770342085],
            [10.494437811903845, -1.6262448998440913],
            [10.497964192328585, -1.62496659442929],
            [10.498748268384826, -1.6217618676043695],
            [10.498266476096275, -1.6088693292380265],
            [10.497092733678368, -1.5962452132843856],
            [10.490467258011671, -1.579752618545753],
            [10.488859073711772, -1.5742080557807607],
            [10.480334739763505, -1.5568443036910464],
            [10.477443960876522, -1.548612895328039],
            [10.464166060505965, -1.5235711140645178],
            [10.449168667004749, -1.506836171684971],
            [10.432001076784191, -1.488948830151651],
            [10.397657237127389, -1.4688847186126797],
            [10.4742688120524, -1.45858710303105],
            [10.551878897405357, -1.4473634429481452],
            [10.564439084907928, -1.4500503194691414],
            [10.632576900057211, -1.440872419961394],
            [10.747842970591293, -1.425093085143728],
            [10.781927347655069, -1.4205714986593667]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.22184696000626, "lat": 36.52362209360593 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47067"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01648577"
      },
      "bbox": [
        10.397657237127389, -1.660350208322778, 10.903780411732477,
        -1.4036530619023277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.85420777042711, -2.100769374588781],
            [6.859924360353592, -2.100132117146912],
            [6.87788965635207, -2.0998858216167244],
            [6.88208479441597, -2.0982015408020738],
            [6.8980274470348055, -2.105440921418745],
            [6.910644226888415, -2.109913362380946],
            [6.925685334421942, -2.1135206371977024],
            [6.950964764496989, -2.116253575466627],
            [6.963180693835199, -2.116144279280273],
            [6.982675674684134, -2.1146921079480885],
            [6.994891539487619, -2.11203730951677],
            [7.011925488547041, -2.106697343882706],
            [7.024040872317428, -2.101124108141786],
            [7.033517758769015, -2.0958793382930443],
            [7.0480229572873645, -2.0857359689232777],
            [7.058744494056262, -2.075873041366093],
            [7.063740370020211, -2.0676457039494953],
            [7.1438035202211125, -2.060950315695944],
            [7.16163619411292, -2.059616920406707],
            [7.168237369681928, -2.0852447669047547],
            [7.2272314242701405, -2.087146864304956],
            [7.226467506055927, -2.171750846300504],
            [7.226924048048039, -2.174091922922898],
            [7.220602794669768, -2.173835211524281],
            [7.220733415072028, -2.180581217637939],
            [7.223253230554566, -2.183085425233496],
            [7.223005903370965, -2.19116640138891],
            [7.198922705513136, -2.248518081672171],
            [7.194508834593553, -2.2479159831002917],
            [7.192949619431023, -2.244611756067822],
            [7.189247442407737, -2.2440919661326246],
            [7.19012534421071, -2.237687484213601],
            [7.181746681485506, -2.234932558408191],
            [7.181877933532192, -2.229940073684298],
            [7.120866962436691, -2.23175443186129],
            [7.114772291683189, -2.227134163646006],
            [7.099513111238031, -2.217172101977224],
            [7.090784633345503, -2.2125873964890816],
            [7.078048701773744, -2.2071136327902456],
            [7.063091493503242, -2.202173712624301],
            [7.04751632781358, -2.198795329828657],
            [7.041040804768951, -2.197931587124481],
            [7.021310587993145, -2.196778819432738],
            [7.0085138213186555, -2.1974780890682206],
            [6.980823673976159, -2.2124059722395075],
            [6.946007505602368, -2.212011962031499],
            [6.890578287659882, -2.2093041565469633],
            [6.888367647543078, -2.2093814061948827],
            [6.889264560610768, -2.205215691710964],
            [6.89079759911946, -2.187899838184085],
            [6.886323382883698, -2.166891377169094],
            [6.8775056703564434, -2.140389152979495],
            [6.8719166029073895, -2.1302806767513083],
            [6.866039118702583, -2.1261650793804705],
            [6.863458087656035, -2.1148567693990126],
            [6.85420777042711, -2.100769374588781]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.7170975919819, "lat": 36.285979155580364 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47083"],
        "coty_name": ["Houston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Houston County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01648578"
      },
      "bbox": [
        6.85420777042711, -2.248518081672171, 7.2272314242701405,
        -2.059616920406707
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.098892873600873, -1.7913057669239805],
            [7.160627552875113, -1.7847483732366791],
            [7.278198696692433, -1.7722370912923464],
            [7.340151678963614, -1.7661000439883847],
            [7.423575303106512, -1.7580740693836578],
            [7.514969539947847, -1.7490392612973982],
            [7.5143690602355155, -1.7635848490215322],
            [7.507563695754687, -1.763339344916272],
            [7.507609872553663, -1.7709829159512709],
            [7.512929576106214, -1.778490520423794],
            [7.509873099070403, -1.8205935227376144],
            [7.506407153744281, -1.8226598001768153],
            [7.508061841830174, -1.8266024082843946],
            [7.505131936589618, -1.8303189946365441],
            [7.495801479732969, -1.8257049383982433],
            [7.494610759742461, -1.8303977748833007],
            [7.501023914999005, -1.830191107718675],
            [7.5043354205065045, -1.8314737637358944],
            [7.505134138426401, -1.8349542168913202],
            [7.50238675718407, -1.8389018495986396],
            [7.5070786556330615, -1.8413951754180937],
            [7.510741594224013, -1.8408509696323754],
            [7.51081407414067, -1.8450478787058056],
            [7.5147911112211165, -1.8454571387999534],
            [7.517883136982574, -1.842545953458947],
            [7.521138809582648, -1.8443996733595087],
            [7.518873433509075, -1.8499647798693206],
            [7.520701854075637, -1.8534986468960333],
            [7.523767364519398, -1.852808141617068],
            [7.523267351953834, -1.8686086171716647],
            [7.527591398092302, -1.8688327978015942],
            [7.5252867813417, -1.881761955160711],
            [7.52285597712418, -1.8815417073027643],
            [7.5223266786522185, -1.9042657354019281],
            [7.521108358908472, -1.9313532311599035],
            [7.52838931870008, -1.9315259339265443],
            [7.528250865608987, -1.9372612529643256],
            [7.526443945528484, -1.9371760929665172],
            [7.522633735660363, -1.9420764888693676],
            [7.5055930559353925, -1.9500172905250925],
            [7.506415741582867, -1.9572372453834537],
            [7.505700280836418, -1.9682312680294087],
            [7.50898126890115, -1.9721848845929557],
            [7.507673961808122, -1.9785172434754736],
            [7.502287463439743, -1.980122140337551],
            [7.498657448418052, -1.9827484617425521],
            [7.497494663194455, -1.9746879544973102],
            [7.490507889876187, -1.9689998005577027],
            [7.484305107545179, -1.9732399393654392],
            [7.485520799819444, -1.977362214019759],
            [7.483122592925244, -1.984709330522032],
            [7.486050218598416, -1.9906978000218383],
            [7.475152540903773, -1.9906194449476622],
            [7.4687534714070765, -1.987043104332349],
            [7.464971107702325, -1.98975779084301],
            [7.458737218807191, -2.0040359720371685],
            [7.4535010005000615, -2.0062067791355696],
            [7.432675401189592, -2.024711549402213],
            [7.429970954310081, -2.0295474114452974],
            [7.429014225969403, -2.042117099866618],
            [7.424212498059762, -2.0494071046423694],
            [7.421544322092022, -2.0476327730579116],
            [7.416843328237038, -2.0510622141104253],
            [7.4133261253369085, -2.048905801137981],
            [7.410177431512016, -2.052238598443176],
            [7.411683182763669, -2.0563752796193464],
            [7.410525726532229, -2.0622550986573303],
            [7.408850445581538, -2.083624093625316],
            [7.40615479912924, -2.0883735592719934],
            [7.399588139047564, -2.0893227636537115],
            [7.396509549501176, -2.094371308291156],
            [7.394333193396406, -2.0931404989850573],
            [7.3942614822833415, -2.087678909319745],
            [7.386216380888182, -2.0859828263369984],
            [7.386379531187511, -2.0924652054982573],
            [7.381255491078617, -2.0917703110461985],
            [7.381363278375196, -2.084881263967042],
            [7.377337030342724, -2.084842380742454],
            [7.377050532562669, -2.0926199047448435],
            [7.3463038365110656, -2.0914980327398838],
            [7.345448481835243, -2.0878472596715736],
            [7.340879949418591, -2.091205582531456],
            [7.2910272985201425, -2.0893965296947683],
            [7.239760646353209, -2.0877658831298245],
            [7.2272314242701405, -2.087146864304956],
            [7.168237369681928, -2.0852447669047547],
            [7.16163619411292, -2.059616920406707],
            [7.1489296891819505, -2.008770192093886],
            [7.147659774214775, -2.0018729154956816],
            [7.11928932182015, -1.8859512753168708],
            [7.098892873600873, -1.7913057669239805]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.38278402744345, "lat": 36.496918960421 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47125"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01639777"
      },
      "bbox": [
        7.098892873600873, -2.094371308291156, 7.52838931870008,
        -1.7490392612973982
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.356325073789986, -2.4480037093061653],
            [9.363666740909599, -2.435166664768112],
            [9.381224023154942, -2.4279840451518866],
            [9.443168280207543, -2.373723958733369],
            [9.45597065533266, -2.372247818689097],
            [9.453581826407804, -2.374610261588195],
            [9.455923357442316, -2.379348737175602],
            [9.451380203894182, -2.3832729823485908],
            [9.455061194220436, -2.3851621907115126],
            [9.457634335239163, -2.3837973429487977],
            [9.466147075200395, -2.3881148036921],
            [9.472147716557641, -2.396372613844887],
            [9.478744181410754, -2.399605364762925],
            [9.48757072047296, -2.3999702127274554],
            [9.494181109581994, -2.4057963763961108],
            [9.496423018555257, -2.413856724102758],
            [9.494644745538666, -2.418522568503702],
            [9.486946712740712, -2.4199787469409433],
            [9.484915838144921, -2.4243107642726427],
            [9.486507797300105, -2.427114839770111],
            [9.483032941740548, -2.434198143644025],
            [9.48626595199994, -2.4403466874450457],
            [9.492487468746306, -2.442884936344655],
            [9.499165182515567, -2.441906238619314],
            [9.504001469807426, -2.444069211732015],
            [9.51089545887602, -2.438934379444],
            [9.511950696057323, -2.441676020805649],
            [9.521221678244348, -2.4547210564056905],
            [9.523477473695415, -2.460612131693019],
            [9.523794925689922, -2.465691504577478],
            [9.518473107658961, -2.4763934981618045],
            [9.5169705075343, -2.484886645004307],
            [9.520550885732797, -2.4967083974539275],
            [9.518937127316725, -2.5021697975911055],
            [9.504719645770141, -2.5150087758142203],
            [9.501146308223944, -2.515928930742333],
            [9.497345377909456, -2.5140313592227557],
            [9.498344948307336, -2.5071878780973256],
            [9.497638670433734, -2.5011459738376978],
            [9.493572610779665, -2.495801616999438],
            [9.48661416736037, -2.493743533337191],
            [9.483268958723004, -2.4958653214425635],
            [9.48192015803664, -2.5068300756967243],
            [9.475634304904982, -2.5141668339736056],
            [9.473945436997868, -2.5189504080368756],
            [9.474002554708612, -2.523508788560176],
            [9.478081884780797, -2.540968050381111],
            [9.48018270449984, -2.5472899991404905],
            [9.480287978246038, -2.552513494205967],
            [9.476294125661337, -2.5603410674775344],
            [9.475290817282357, -2.5651191438901697],
            [9.475953866210853, -2.5704337491194282],
            [9.484421966049188, -2.583857820370381],
            [9.48615942618222, -2.5887729059758953],
            [9.486349581329675, -2.596291212682859],
            [9.482952740786692, -2.6027514434525676],
            [9.47830636553065, -2.6065517880027946],
            [9.468207268082233, -2.611694050568157],
            [9.462387205783239, -2.617703578164338],
            [9.461807456738685, -2.624783496819024],
            [9.465448306662221, -2.6311809455523285],
            [9.473501538382177, -2.635634518232025],
            [9.476868869325017, -2.6390696934965105],
            [9.47831297415085, -2.64314136033657],
            [9.477270256062665, -2.6477761994918936],
            [9.47290578032953, -2.6525176027477104],
            [9.462278272972714, -2.6553455602350162],
            [9.428919285366538, -2.6504291250133476],
            [9.423980039903403, -2.6504316756553195],
            [9.41777122292638, -2.6528411730537513],
            [9.414893952566603, -2.656027916670988],
            [9.411453790598426, -2.664762708293752],
            [9.411038758538671, -2.670414246493492],
            [9.411976034075842, -2.675819696178211],
            [9.415129427830943, -2.6815118580850474],
            [9.424303963370908, -2.686992600398205],
            [9.430201608428542, -2.6921241246073384],
            [9.432680089671274, -2.696203338054411],
            [9.433493603368703, -2.7045710173663813],
            [9.431105683688477, -2.710085103697904],
            [9.427652917729588, -2.7144131287728004],
            [9.421926157758692, -2.7183687784488813],
            [9.41169629961113, -2.7219035927283506],
            [9.40568178359876, -2.7253497378581675],
            [9.401139408731533, -2.730955638847708],
            [9.399668340443109, -2.7371146413825613],
            [9.402260483003218, -2.7536534740952097],
            [9.400754226870081, -2.760634142339829],
            [9.398569136189524, -2.7651453987566685],
            [9.39484407720451, -2.7694370002980624],
            [9.388345356476055, -2.773646886389428],
            [9.381470957638514, -2.7746543491821813],
            [9.370268882971596, -2.7734259483987347],
            [9.360777572547871, -2.7680397364170304],
            [9.355273259836949, -2.761985087193284],
            [9.348583119126664, -2.748556210238491],
            [9.345058534684847, -2.7462241556552773],
            [9.340784120771614, -2.7458084988931653],
            [9.337581114922848, -2.7476045645764944],
            [9.335925868635758, -2.7550045309751283],
            [9.337519648786468, -2.761007979765703],
            [9.340693560626404, -2.765914486542815],
            [9.343067960186591, -2.772334243078012],
            [9.342882993453705, -2.7770226150617945],
            [9.339327370902668, -2.7813927904594897],
            [9.333259691827722, -2.791431466656264],
            [9.330616222826842, -2.793868960303698],
            [9.321296810936865, -2.806825995149893],
            [9.317026270067634, -2.8106313623125607],
            [9.273533131455553, -2.7878925281857874],
            [9.269130185687972, -2.7956970789084923],
            [9.264605689806398, -2.7935925351407516],
            [9.262086034615825, -2.794913570290646],
            [9.257403504819221, -2.7917191385912785],
            [9.254654441993111, -2.7945179205792154],
            [9.246903286982262, -2.798173156615913],
            [9.242355232866068, -2.7959280708367],
            [9.238290405768566, -2.791178554114983],
            [9.243273115966948, -2.7821996025513496],
            [9.237721648905978, -2.7779882064437245],
            [9.237060101519338, -2.7728462802829332],
            [9.228412015162718, -2.771114280123838],
            [9.225607308039818, -2.7727083441941582],
            [9.219560522322693, -2.7722651893406516],
            [9.216200207088988, -2.771996363118417],
            [9.229673521481027, -2.7531840497281266],
            [9.22636799181233, -2.7522348701625847],
            [9.22047544280334, -2.7478647306885424],
            [9.216692870438141, -2.7483799318814635],
            [9.213431938736738, -2.7391932411772353],
            [9.208627147254873, -2.743130242608594],
            [9.205365038128853, -2.738753689568491],
            [9.206621459600173, -2.7310807750866],
            [9.211874374809744, -2.71629873944791],
            [9.218513226729728, -2.7033379113354257],
            [9.22085866175522, -2.7001123627107817],
            [9.225668538838612, -2.70381453908308],
            [9.231606994085258, -2.6982470704965107],
            [9.228959056436093, -2.6963348486520426],
            [9.236507936829614, -2.6935460990813764],
            [9.232844473161652, -2.6834033383805806],
            [9.229528114960237, -2.679033731100509],
            [9.226986923682322, -2.686658921808105],
            [9.225195694117573, -2.6566233670949195],
            [9.267854929237016, -2.6037170218063856],
            [9.271424689443654, -2.596801794406342],
            [9.302955041032034, -2.541702895649218],
            [9.31417684340368, -2.54136233863877],
            [9.313960462979653, -2.5366763937511494],
            [9.306692558882684, -2.5351315587671532],
            [9.347951564567005, -2.4629567963895784],
            [9.356325073789986, -2.4480037093061653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.92444320075757, "lat": 35.6087004901198 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47143"],
        "coty_name": ["Rhea"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rhea County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01639784"
      },
      "bbox": [
        9.205365038128853, -2.8106313623125607, 9.523794925689922,
        -2.372247818689097
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.2769290669185, -6.265828154652152],
            [-8.223304776780065, -6.271317257456889],
            [-8.128790575452108, -6.2812212753086065],
            [-8.065636238855756, -6.2872081849329255],
            [-7.95862954802789, -6.298716321352866],
            [-7.958698846697635, -6.300942610354702],
            [-7.968232205213569, -6.398865063603116],
            [-7.975346637723686, -6.470617962779653],
            [-7.983351179472239, -6.549312532003649],
            [-7.983258092661745, -6.551264846747684],
            [-7.989924699131855, -6.619273659354057],
            [-7.996887622234615, -6.691755949727874],
            [-8.007111474086335, -6.797551956233849],
            [-8.009872647405182, -6.819031881420013],
            [-7.981151984000636, -6.82201119759011],
            [-7.986318779218092, -6.876549440671676],
            [-7.982750381981829, -6.876914913332475],
            [-8.022754260285312, -6.909027342077177],
            [-8.028796423746217, -6.903171648795393],
            [-8.087086767769291, -6.891924270675143],
            [-8.091838364595237, -6.890276744239467],
            [-8.095536837973086, -6.887135775765668],
            [-8.109218502952176, -6.868433249934837],
            [-8.116168819362455, -6.862769333410525],
            [-8.126610306587619, -6.861510155235009],
            [-8.133401063244433, -6.859147097041654],
            [-8.150425677447465, -6.846961634658695],
            [-8.1543072170126, -6.8430678088505985],
            [-8.162312275819852, -6.8300847118433365],
            [-8.17016071353558, -6.823414610300693],
            [-8.181639874761387, -6.818628178598186],
            [-8.188806462113776, -6.814501022710211],
            [-8.193054795333252, -6.809695022431306],
            [-8.199867461172115, -6.798282176860783],
            [-8.200741556762564, -6.7956256735699325],
            [-8.202339793086383, -6.778549655553436],
            [-8.203429427245641, -6.774996373117149],
            [-8.210974840312344, -6.764375471344396],
            [-8.212259495703034, -6.761403578057353],
            [-8.216096424510287, -6.736616533891513],
            [-8.21822558428548, -6.731647804906408],
            [-8.223252797905843, -6.726584850637256],
            [-8.2427627160945, -6.711302944743335],
            [-8.24390601042609, -6.709642958136983],
            [-8.247660397878063, -6.684674586255029],
            [-8.250423690564682, -6.677184437407069],
            [-8.252573872694983, -6.667739645907982],
            [-8.255466296468278, -6.661292229110582],
            [-8.254841818506156, -6.657709807052346],
            [-8.25600957186999, -6.649549188154049],
            [-8.259361595158984, -6.640722632588191],
            [-8.271425512740255, -6.6182429572368005],
            [-8.278066119304935, -6.604172815727538],
            [-8.28697835552415, -6.570489702832662],
            [-8.302796781274667, -6.554719214925622],
            [-8.305463641202602, -6.550313572328567],
            [-8.307522291424329, -6.536538318375776],
            [-8.309631693202585, -6.53249401821182],
            [-8.33850685993555, -6.509365976677694],
            [-8.352916244699571, -6.504596429134669],
            [-8.365023514599995, -6.494096620534911],
            [-8.368607699279922, -6.493948350394372],
            [-8.37888212887517, -6.497348431789954],
            [-8.384540956305928, -6.5054807373779955],
            [-8.395100560588592, -6.507374574844993],
            [-8.399157657392179, -6.506326570356369],
            [-8.407244497529136, -6.498287857202867],
            [-8.411517011738367, -6.492851605774721],
            [-8.414998890647334, -6.491678326880716],
            [-8.416178423663336, -6.483730050035858],
            [-8.424767544055802, -6.475588903630038],
            [-8.42786534994199, -6.46827646016047],
            [-8.426681737042866, -6.462411035429417],
            [-8.430930377167728, -6.459141538096462],
            [-8.432540646268032, -6.45223486310305],
            [-8.4374062534834, -6.448142350655162],
            [-8.441076255622429, -6.442554817419057],
            [-8.453938664422845, -6.437314019475258],
            [-8.456971379259326, -6.4347660196076335],
            [-8.460764015685621, -6.437458762052129],
            [-8.466038500402359, -6.436672354269584],
            [-8.473812873690694, -6.424056986310708],
            [-8.478360196175325, -6.4207439201311045],
            [-8.485828471090079, -6.419789361927124],
            [-8.487640494432595, -6.416686695314349],
            [-8.483540660650648, -6.405397482172116],
            [-8.483087943189352, -6.400626131135901],
            [-8.486068814534573, -6.398385615889349],
            [-8.493436427796459, -6.397378995136577],
            [-8.501689215954055, -6.386627816263615],
            [-8.502923546743013, -6.382153127641498],
            [-8.509111139428047, -6.375794139132698],
            [-8.507301842328632, -6.367714629339769],
            [-8.501497989011149, -6.359080109696695],
            [-8.502451601514654, -6.3562669406299435],
            [-8.508129601189594, -6.350355966077318],
            [-8.513768854338611, -6.346514550034231],
            [-8.513494595648876, -6.342715965193525],
            [-8.508933552257439, -6.337269265320831],
            [-8.50232878903109, -6.332790047489411],
            [-8.495572612667786, -6.331095466934858],
            [-8.485185175785936, -6.326450078473809],
            [-8.48286231539839, -6.324699314802454],
            [-8.492412577387379, -6.3182766325419255],
            [-8.496576372130995, -6.319541356444705],
            [-8.497154946765244, -6.316506390208796],
            [-8.493049827115811, -6.3134645587513445],
            [-8.490166241118997, -6.30895277344013],
            [-8.489921556213773, -6.298280774209471],
            [-8.48327951637955, -6.296078099514725],
            [-8.481229337997545, -6.288708272504515],
            [-8.483751041596937, -6.288419087469438],
            [-8.488389414684809, -6.29103421238301],
            [-8.49013913747753, -6.289190855646427],
            [-8.488716542256546, -6.282794126771981],
            [-8.485226908207313, -6.280822700145842],
            [-8.483394968261422, -6.277457267312211],
            [-8.483568435895316, -6.272791760567539],
            [-8.486479060580645, -6.271128392678697],
            [-8.489454691018567, -6.273027515495627],
            [-8.492451745297519, -6.272122123157144],
            [-8.498600017502989, -6.265845383080547],
            [-8.499330726922505, -6.262217850256454],
            [-8.496180260010217, -6.257171534551871],
            [-8.491267195752503, -6.2536094046895805],
            [-8.484747032334804, -6.253141095376408],
            [-8.480872772936582, -6.249820254463108],
            [-8.479420372635152, -6.244190793943796],
            [-8.459969624042532, -6.246073183961552],
            [-8.43465150506255, -6.248928698764394],
            [-8.360397173608686, -6.256787829741029],
            [-8.29125658696532, -6.263957894814737],
            [-8.2769290669185, -6.265828154652152]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.23484049514478,
          "lat": 31.768554436407697
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48141"],
        "coty_name": ["El Paso"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["El Paso County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01383855"
      },
      "bbox": [
        -8.513768854338611, -6.909027342077177, -7.95862954802789,
        -6.244190793943796
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.469386493914187, -2.511047340122018],
            [-4.439368648842869, -2.513028137092515],
            [-4.434709363215522, -2.5130434681615363],
            [-4.344471909937025, -2.5189447994103777],
            [-4.302632879411726, -2.521450129026482],
            [-4.245375210701564, -2.5250734460599618],
            [-4.0881347803508055, -2.5346276027325376],
            [-4.03802864379426, -2.5376447163654317],
            [-4.048621126792971, -2.7213601363502695],
            [-4.0589535848341445, -2.8977375524899744],
            [-4.062129545896088, -2.9541581506456347],
            [-4.063258672829209, -2.9717134231198488],
            [-4.063464089620738, -2.975598713893021],
            [-4.103277903673067, -2.9733736685910634],
            [-4.33466587821116, -2.9592293511707664],
            [-4.367150763213613, -2.9570662455505468],
            [-4.497634913106566, -2.9488437980852633],
            [-4.497191681573509, -2.9413190754395835],
            [-4.485424865777627, -2.759337568969827],
            [-4.469386493914187, -2.511047340122018]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.89298751835544,
          "lat": 35.83771476397746
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48341"],
        "coty_name": ["Moore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moore County"],
        "coty_fp_code": "341",
        "coty_gnis_code": "01383956"
      },
      "bbox": [
        -4.497634913106566, -2.975598713893021, -4.03802864379426,
        -2.511047340122018
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7302842063626938, -6.338007919345458],
            [1.737113835018257, -6.342468212690321],
            [1.7403680996386726, -6.341385158838751],
            [1.7419680419000185, -6.346586560436977],
            [1.7440520180103412, -6.347568742522196],
            [1.7427308545004963, -6.353052384413664],
            [1.7538669969173006, -6.3549079878656025],
            [1.7549695311595255, -6.359521280046122],
            [1.760726178707484, -6.362391586541279],
            [1.7669619862712578, -6.3593675793101125],
            [1.7688181579672175, -6.364542008451123],
            [1.77689660379617, -6.369857672620656],
            [1.7832362880341004, -6.36863256194326],
            [1.7842838248861779, -6.364274269937648],
            [1.7893272616313667, -6.361634889177746],
            [1.8001722581860722, -6.363615772049935],
            [1.80441969494074, -6.361087604725003],
            [1.8101331466880461, -6.364313867297064],
            [1.8114951752188257, -6.362336311186258],
            [1.8197351269982225, -6.36346780779568],
            [1.8217015495445408, -6.36706918490671],
            [1.8226112371363652, -6.375735873380522],
            [1.8252325624144679, -6.382559623538345],
            [1.82199509681501, -6.383287927019714],
            [1.8260474092507417, -6.3881687021709475],
            [1.8321719613637335, -6.38865120582618],
            [1.8311369324889144, -6.3855071519289055],
            [1.8361568322691646, -6.3850108714679354],
            [1.8365811125666822, -6.3881603090571435],
            [1.8404498191577163, -6.3897548929240395],
            [1.8412104886775784, -6.393339160609952],
            [1.844411005221153, -6.39544859632679],
            [1.8471986275409533, -6.401204175748265],
            [1.852524412628763, -6.399399660289474],
            [1.9114038457239595, -6.384115148873123],
            [1.937809436224525, -6.377384409560723],
            [1.9855620347355762, -6.364924618227075],
            [2.1072678456825904, -6.333029731733072],
            [2.107998551383809, -6.361723263946872],
            [2.1099491001767774, -6.455551543926677],
            [2.111565330245728, -6.5289963997223674],
            [2.1129221577516564, -6.599778025243156],
            [2.113380438922474, -6.605010078042756],
            [2.1143970051534926, -6.668791137606859],
            [2.115554355144486, -6.72541308642032],
            [2.1164448852095377, -6.732244808654151],
            [2.119331094560662, -6.73215076161648],
            [2.1227798597915646, -6.729233431582476],
            [2.1269635034346392, -6.728572473120705],
            [2.1372415531371884, -6.7348696968970785],
            [2.1389909303003205, -6.743999815381119],
            [2.1388203616612, -6.744305590051645],
            [2.099063943579767, -6.745748993523383],
            [2.050700214681503, -6.747025985613965],
            [2.0463711717139788, -6.74741131751904],
            [1.959013209942104, -6.750209264666359],
            [1.954211863188469, -6.7501952001135495],
            [1.905909837399778, -6.752314401670281],
            [1.8840202103631045, -6.752680244812305],
            [1.8751902100120095, -6.753178296052527],
            [1.8239644861855215, -6.754657783110848],
            [1.7367890163426953, -6.757433655578554],
            [1.7204286766669536, -6.757757646549095],
            [1.6456922839584716, -6.759674886994268],
            [1.6439000990231984, -6.705181689843793],
            [1.6426769282035587, -6.6629919127080015],
            [1.6427781253495815, -6.653143541436501],
            [1.6453747204429314, -6.642543499660851],
            [1.6478366877522708, -6.6217005577295],
            [1.6526733502813187, -6.608228542960708],
            [1.6529260541493882, -6.595481330851809],
            [1.657746239496761, -6.58349577229734],
            [1.659134454779645, -6.573729288554028],
            [1.6586080468404982, -6.567176393728029],
            [1.6593412741959273, -6.5613775889598225],
            [1.6592721180471797, -6.545522114590961],
            [1.6584636510967776, -6.5392993184684585],
            [1.6588982539999366, -6.530515188262351],
            [1.6615760301843074, -6.522442511748743],
            [1.6648844525161661, -6.516478517956237],
            [1.6721382269146516, -6.5001533005753656],
            [1.6777625349017786, -6.483780120371528],
            [1.6804315770204028, -6.480371506060315],
            [1.699523272821431, -6.460683987146183],
            [1.703268282630037, -6.453349680257739],
            [1.7029922157780688, -6.44293607695109],
            [1.708351591824707, -6.426864117846191],
            [1.7151930747320514, -6.416799673594903],
            [1.7148880566315372, -6.410036169569363],
            [1.718302157933077, -6.400787503127712],
            [1.722378461914984, -6.3949233736407605],
            [1.7240369577349866, -6.387998699488127],
            [1.7295884848841336, -6.37563947228211],
            [1.729691338844399, -6.363547235790133],
            [1.7306612412014861, -6.359094892930121],
            [1.7302842063626938, -6.338007919345458]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.30558251188472, "lat": 32.16235699218102 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48365"],
        "coty_name": ["Panola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Panola County"],
        "coty_fp_code": "365",
        "coty_gnis_code": "01383968"
      },
      "bbox": [
        1.6426769282035587, -6.759674886994268, 2.1389909303003205,
        -6.333029731733072
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1057840011374447, -6.580350858429744],
            [-3.035671568589503, -6.583160162424095],
            [-2.876288676333082, -6.590492771828242],
            [-2.792054706237451, -6.594486983842532],
            [-2.6667771765904167, -6.598881469400673],
            [-2.668881778537125, -6.6443097641732445],
            [-2.6758382275623944, -6.781327963065523],
            [-2.686603633723833, -6.982369069196849],
            [-2.6931591323693946, -7.102235452332824],
            [-2.724535936238482, -7.101022499353585],
            [-2.7573913112261224, -7.099477492768308],
            [-2.874512227531857, -7.093676618125279],
            [-2.9352504351850754, -7.090362694573346],
            [-2.9932393851767567, -7.086870952432042],
            [-3.023231129150111, -7.08523221998391],
            [-3.121275420158466, -7.079884371825039],
            [-3.1270178833488247, -7.078783726430638],
            [-3.127519426376681, -7.073823125169491],
            [-3.123738413163198, -6.968413870105753],
            [-3.1179535061274484, -6.835282207327971],
            [-3.1104455357947423, -6.672525891003644],
            [-3.1057840011374447, -6.580350858429744]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.97619038221677,
          "lat": 31.831121030315852
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48399"],
        "coty_name": ["Runnels"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Runnels County"],
        "coty_fp_code": "399",
        "coty_gnis_code": "01383985"
      },
      "bbox": [
        -3.127519426376681, -7.102235452332824, -2.6667771765904167,
        -6.580350858429744
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.8476442124316392, -5.661623467921],
            [-3.7351262594378487, -5.660997943791234],
            [-3.722774639461371, -5.661902910759574],
            [-3.7062825972657247, -5.66600536100799],
            [-3.6950392799576766, -5.668320855096695],
            [-3.6127208219966342, -5.672787546347928],
            [-3.607400570146102, -5.673296697022205],
            [-3.416734486285031, -5.683944455011196],
            [-3.430716732218992, -5.91347137241336],
            [-3.4332419622585926, -5.963937508395833],
            [-3.4376596124279333, -6.031105010881148],
            [-3.4423003176063025, -6.121652378578962],
            [-3.473480986337106, -6.120166837065997],
            [-3.5451006293856677, -6.116454778361652],
            [-3.646195733706327, -6.110304191464972],
            [-3.72543652458462, -6.104923005666135],
            [-3.755159061968658, -6.10315333286015],
            [-3.872491396175542, -6.0971067401444845],
            [-3.8668854500396814, -5.997002047715507],
            [-3.8527392532556997, -5.7496645858873245],
            [-3.8482452444704944, -5.668101278213729],
            [-3.8476442124316392, -5.661623467921]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.91642289594763,
          "lat": 32.74628117659171
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48415"],
        "coty_name": ["Scurry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scurry County"],
        "coty_fp_code": "415",
        "coty_gnis_code": "01383993"
      },
      "bbox": [
        -3.872491396175542, -6.121652378578962, -3.416734486285031,
        -5.660997943791234
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.412531682653327, 8.24879969703224],
            [16.48501675456202, 8.268313038087133],
            [16.485882036432795, 8.267765431498702],
            [16.49949681230842, 8.271115477491918],
            [16.502948529846083, 8.273061362149392],
            [16.510952710887484, 8.273910633781533],
            [16.533953724835236, 8.279714747306292],
            [16.56619366462465, 8.286692455839532],
            [16.587809938817582, 8.292156189871209],
            [16.59159998531883, 8.293988037492454],
            [16.649458313451053, 8.309729542986396],
            [16.696458824239464, 8.32050421208824],
            [16.76679097037927, 8.337471489309728],
            [16.825464361598552, 8.349769568594253],
            [16.831019616698775, 8.349421215961359],
            [16.85132877788677, 8.351129753822859],
            [16.854489762016442, 8.344066644605547],
            [16.88333388524588, 8.27516194950433],
            [16.880018628118602, 8.274195231224969],
            [16.908069595256787, 8.18724625721825],
            [16.88962871795713, 8.128262086300664],
            [16.876799733826097, 8.134684717666364],
            [16.875190785331572, 8.130967005592405],
            [16.86010876224856, 8.136203687142505],
            [16.86114447929693, 8.141137198713583],
            [16.780910859444734, 8.124943638284789],
            [16.772097421974138, 8.108503963401235],
            [16.7762693835942, 8.0950326909628],
            [16.769630916340642, 8.094547347050952],
            [16.77047121602148, 8.081063679157033],
            [16.7632378907292, 8.080662383391456],
            [16.764539345146247, 8.058668950670258],
            [16.760943217079138, 8.058458057106698],
            [16.761744863352465, 8.042895715921047],
            [16.764307977078122, 8.004927006091286],
            [16.71972910657172, 8.014859221195161],
            [16.70484111081644, 7.954486035219724],
            [16.700411037912907, 7.948187786027204],
            [16.699431664100093, 7.943642081015599],
            [16.689220668165117, 7.940980309803096],
            [16.684973248790616, 7.9439385445107975],
            [16.682831027375002, 7.938935247847881],
            [16.686171460272114, 7.9358749327822995],
            [16.688261379168612, 7.9274621892818375],
            [16.605203985849528, 7.925485516490923],
            [16.553376421101714, 7.938984552027368],
            [16.510875272288036, 7.949282843349875],
            [16.456608263341078, 7.962597507042504],
            [16.43543942174457, 7.985476480404845],
            [16.42686799298888, 7.997060228104104],
            [16.423744406890627, 8.007030680562341],
            [16.423636819606404, 8.016270976168737],
            [16.42673357898167, 8.03378338884508],
            [16.430336564369377, 8.04494193775411],
            [16.437192427531087, 8.05527510818653],
            [16.44540843035616, 8.061288391017735],
            [16.44677858540022, 8.064175830575103],
            [16.446308125177143, 8.068781286701302],
            [16.447888868637005, 8.073670913587517],
            [16.44589142662091, 8.079824929934073],
            [16.441943689244596, 8.08495729724809],
            [16.44089418238047, 8.09067886882519],
            [16.440988790188687, 8.100754766836653],
            [16.44011386548143, 8.10482147378915],
            [16.442610194755186, 8.115056789852177],
            [16.44133699644132, 8.122454666788263],
            [16.44158993264005, 8.132262442705315],
            [16.438939816667904, 8.14497790203584],
            [16.434985835023483, 8.149102244837955],
            [16.427754919853697, 8.14787710077177],
            [16.41370057102629, 8.151382887392156],
            [16.411702509595386, 8.152669314471321],
            [16.40405410109388, 8.163494821486157],
            [16.40198537993777, 8.168086851781158],
            [16.398582164563702, 8.170969454136355],
            [16.394567538964733, 8.1784144821955],
            [16.39478531408933, 8.182884302695722],
            [16.399802796850608, 8.190314209769014],
            [16.40189249460417, 8.196526292392644],
            [16.404294569131874, 8.209458175338158],
            [16.408861942525267, 8.226104025057529],
            [16.412531682653327, 8.24879969703224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.91308964346784, "lat": 44.8576171427873 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50011"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01461762"
      },
      "bbox": [
        16.394567538964733, 7.925485516490923, 16.908069595256787,
        8.351129753822859
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.213362111185964, -0.6377204602682236],
            [11.22360570553613, -0.6261247116409967],
            [11.24908017969324, -0.5957860675759016],
            [11.284031155276274, -0.5536491831888737],
            [11.284609611903814, -0.5524757771193844],
            [11.336818798846183, -0.4915858403145339],
            [11.378652592870695, -0.4408803905762795],
            [11.386501415119639, -0.42990530240354347],
            [11.442383717567298, -0.3629145599698426],
            [11.4434923472917, -0.3680787265065221],
            [11.451064123546335, -0.36451942993812925],
            [11.451616561387771, -0.3699061984046419],
            [11.455120376440586, -0.3712069753614937],
            [11.460399478387023, -0.36665775140562623],
            [11.460738464766116, -0.37460005432812127],
            [11.463775375603376, -0.37690518765323805],
            [11.464073669613974, -0.3845738209793592],
            [11.468853085542014, -0.384632493577123],
            [11.471520631604307, -0.37753039922548154],
            [11.477468505869183, -0.3808671098845206],
            [11.47749511298369, -0.38405205276481036],
            [11.474019973601967, -0.38482298816061555],
            [11.466154176729898, -0.3894174888929058],
            [11.466325692440419, -0.39519076756227045],
            [11.460302931116932, -0.3969851355217047],
            [11.458888916488846, -0.39947022610956756],
            [11.460719049853635, -0.4074252227951672],
            [11.457688472012771, -0.4081407464956858],
            [11.451352610758896, -0.40705801603845126],
            [11.447689236153195, -0.4127276318115965],
            [11.443843353341716, -0.41408951214597844],
            [11.442873606499075, -0.4173891237362161],
            [11.436409885404307, -0.4172489513996735],
            [11.431205471765308, -0.4207902588483801],
            [11.431630732810428, -0.42396521803926535],
            [11.42928751898654, -0.42746942526445114],
            [11.431028500060652, -0.4342261674561953],
            [11.433314823827512, -0.43529860968363737],
            [11.43497780509958, -0.44274267806695683],
            [11.438920891165786, -0.4444591918163736],
            [11.441694656591114, -0.44848380040122027],
            [11.445058152331505, -0.4450287752303004],
            [11.450384407043375, -0.4454019730083978],
            [11.454629604260035, -0.44943919248194614],
            [11.455997110098538, -0.45424113229098484],
            [11.463014332962008, -0.4517149052298113],
            [11.470600968698466, -0.45299277151246314],
            [11.474216327337908, -0.45804168948402674],
            [11.47956253774611, -0.45699094547340474],
            [11.482911881699316, -0.4606499123244069],
            [11.4799300817673, -0.468579624494241],
            [11.484092914625746, -0.47728827966847304],
            [11.488279849143051, -0.4814654644574684],
            [11.49584318443105, -0.48425572284848023],
            [11.495606876953573, -0.48813578142483066],
            [11.491645546254071, -0.4910971965606526],
            [11.491608040124644, -0.49481380795983565],
            [11.494093748650084, -0.49811534463259916],
            [11.494333927858376, -0.5023816545822437],
            [11.490836760746443, -0.5061628699420427],
            [11.49321958932769, -0.5110887462877887],
            [11.490532303934094, -0.5138701139676872],
            [11.49109001753226, -0.5184759607302359],
            [11.495295291572004, -0.5210015550946587],
            [11.493493459018072, -0.5240460274669004],
            [11.494399947434136, -0.527388061170929],
            [11.500307389217543, -0.5313288524853199],
            [11.499497921963235, -0.5355056346248837],
            [11.502215796735785, -0.5384988429776547],
            [11.5055191474403, -0.5389176857343418],
            [11.510383661062294, -0.5454167240533957],
            [11.514994041195306, -0.5453583211096225],
            [11.518052148257977, -0.5499511231927945],
            [11.524993150080412, -0.5516512361801211],
            [11.529077719158938, -0.5603670413234118],
            [11.531090883476649, -0.5619670772576655],
            [11.54257317359495, -0.5585668777731142],
            [11.543297205047311, -0.5614356642521311],
            [11.547856464727182, -0.5646042437865414],
            [11.550876447278858, -0.5686422810657463],
            [11.552996656562854, -0.5681501292854162],
            [11.559338524810382, -0.5724304534477936],
            [11.556510112701954, -0.5798746132323033],
            [11.561478334495288, -0.5832896511798111],
            [11.565230947977671, -0.580884211866097],
            [11.566732979303055, -0.5865716271811142],
            [11.568764522452957, -0.5996196485456158],
            [11.574476636235186, -0.6018790519778211],
            [11.580491518519967, -0.5992468711665824],
            [11.584935982605801, -0.6004256353292216],
            [11.584522541893909, -0.6033180035544135],
            [11.59218535714577, -0.6044409039156379],
            [11.59644321870485, -0.6039286713276899],
            [11.6055348421744, -0.5987182550396296],
            [11.608206197957303, -0.5955175501048291],
            [11.619325076505882, -0.5953751413382986],
            [11.6244102748258, -0.596483719790783],
            [11.628129876544492, -0.6012185903327626],
            [11.632155205253655, -0.6032533410960816],
            [11.637579641265747, -0.6030386717339535],
            [11.642095657199368, -0.6008285735521407],
            [11.645564556717547, -0.6020510952324674],
            [11.646244419987969, -0.6060258990354533],
            [11.651843620236704, -0.6101625705130821],
            [11.65611264026997, -0.6110841080153763],
            [11.657455699661627, -0.6164689765373604],
            [11.661554985176293, -0.6200086636042038],
            [11.660555714216551, -0.6267472307170792],
            [11.660932997416225, -0.631870562021583],
            [11.66517444803888, -0.6349986213543111],
            [11.66299632431276, -0.6420347998188951],
            [11.66591456643492, -0.644421310861243],
            [11.665738145436563, -0.6482711956104035],
            [11.656397270588347, -0.6551751638203235],
            [11.656130695517636, -0.6683838847209416],
            [11.65091083556735, -0.6761449477447278],
            [11.64343578589945, -0.6739968339261919],
            [11.641270198927424, -0.6786486922131535],
            [11.636296053872183, -0.6812996560238727],
            [11.636910691242932, -0.6857538770375932],
            [11.627778755460481, -0.6945850520276486],
            [11.616303204062827, -0.6973072096442722],
            [11.61251549383552, -0.7026550566456629],
            [11.609537703246756, -0.7047893182164803],
            [11.60429048291462, -0.7035193402615699],
            [11.59707106687486, -0.7073345119797896],
            [11.593465932813485, -0.7121717946566162],
            [11.589985739970917, -0.7137812154605275],
            [11.586292787613045, -0.7123870697909164],
            [11.58266095799817, -0.7133154371424175],
            [11.580696781771021, -0.7181887386560563],
            [11.57421231059346, -0.7214583061046436],
            [11.57243455781109, -0.7250241300979674],
            [11.577627788249629, -0.7309558407988437],
            [11.569353876758493, -0.7385467804393742],
            [11.566299294225079, -0.738386242026341],
            [11.561241499822101, -0.7422759172890617],
            [11.554927106858651, -0.7400001357438014],
            [11.553537130269977, -0.7500847146566608],
            [11.547158118942217, -0.7536724379639772],
            [11.544741521564372, -0.7614057475327125],
            [11.539575058237098, -0.7608824477884413],
            [11.532579740957916, -0.7645004141247821],
            [11.532548320918144, -0.7690752360501931],
            [11.527298890843783, -0.7705243491527829],
            [11.525680153337893, -0.7688444548852836],
            [11.51986714014942, -0.7679302132745355],
            [11.515140806707823, -0.7728865036766492],
            [11.511596909620062, -0.7710621523039944],
            [11.506416780337377, -0.7718777909580679],
            [11.504767206488351, -0.7782302455049431],
            [11.49619378150904, -0.7809265934426628],
            [11.495347630248464, -0.7790578341850566],
            [11.489025453200775, -0.7791099479495557],
            [11.485783101343145, -0.774322494224668],
            [11.480284071411063, -0.7854201185742934],
            [11.474829363279145, -0.7889483019548411],
            [11.471390469034171, -0.7931192930013293],
            [11.473445850774551, -0.797961798789952],
            [11.470472767455393, -0.7988260762863956],
            [11.46894385771573, -0.8037833790976637],
            [11.472155099657003, -0.8072012643476437],
            [11.470104027818603, -0.8090627459603552],
            [11.4701171237238, -0.8148519461418103],
            [11.467830331786086, -0.8154101880913812],
            [11.468383578132396, -0.8228094900979813],
            [11.47302078498847, -0.8229328066501822],
            [11.473755685171012, -0.8268237898039584],
            [11.469569861124722, -0.8317541186031268],
            [11.472202462957195, -0.8337738140056008],
            [11.473078955837853, -0.8376182858391282],
            [11.463141314859318, -0.8424100715185875],
            [11.460999476634857, -0.8521686397125919],
            [11.457491033195065, -0.8603655712569612],
            [11.449511637348586, -0.8643641672557668],
            [11.446599950478934, -0.8622563160183476],
            [11.44197822950771, -0.8665069095037303],
            [11.438097871471397, -0.8672258309117974],
            [11.432657464813078, -0.8745591581329634],
            [11.423659255435973, -0.8732135682979651],
            [11.414132617489152, -0.8656095967248687],
            [11.41016300703651, -0.8648370332911726],
            [11.406128222246872, -0.8691935968360214],
            [11.407945151401659, -0.8717385525618729],
            [11.402676718865749, -0.877478536274201],
            [11.397686079472617, -0.8763503577235789],
            [11.393527600706394, -0.8789996652835511],
            [11.384204987687461, -0.8759848457277022],
            [11.382246547467638, -0.8793725387363148],
            [11.374284643733963, -0.8796240454229369],
            [11.382661922774313, -0.8696042398032212],
            [11.379586736671197, -0.8625761590260471],
            [11.38177462942096, -0.8608843747673476],
            [11.379915683311868, -0.8560389265021997],
            [11.374743971405358, -0.8557360798737349],
            [11.372621522105183, -0.8446158219887885],
            [11.366728202287355, -0.8395531085460716],
            [11.365487047463901, -0.8361617007156702],
            [11.360972772977798, -0.8336177601728492],
            [11.361660556294975, -0.8310454303519449],
            [11.35685905741897, -0.821520935712844],
            [11.35465345506624, -0.8193065515054885],
            [11.357021114535796, -0.8162522154183723],
            [11.35721181617746, -0.8114517262623848],
            [11.352944853599421, -0.8096743084857735],
            [11.34725887910965, -0.809322990332623],
            [11.345389684995146, -0.8044927864818898],
            [11.342696300313563, -0.8028332841752146],
            [11.343546455494781, -0.7947628192425568],
            [11.337740291139742, -0.7909775568502642],
            [11.337261174967074, -0.7878752791610336],
            [11.33190454295277, -0.7817156953288468],
            [11.327631767992129, -0.7806287956526144],
            [11.325193361521524, -0.7743897490164332],
            [11.321782187742325, -0.771505131080238],
            [11.319733102194597, -0.7675528603873477],
            [11.31708057283623, -0.7714294074533969],
            [11.313390402063453, -0.7647231371152411],
            [11.309958552347645, -0.7608340072871023],
            [11.281460337056181, -0.7193583593211543],
            [11.262421673385703, -0.6632661815804217],
            [11.256958485083782, -0.6556338088572873],
            [11.249950692976912, -0.6553040496070004],
            [11.244951361826862, -0.650075775550857],
            [11.243617091982129, -0.6455947246646961],
            [11.23573985886688, -0.6421834055977592],
            [11.232836509169507, -0.6376762612337975],
            [11.228379187168251, -0.6364751206828055],
            [11.223992364644017, -0.6320475201327238],
            [11.213362111185964, -0.6377204602682236]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.03602167123502, "lat": 37.26665345917841 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51027"],
        "coty_name": ["Buchanan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buchanan County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01497431"
      },
      "bbox": [
        11.213362111185964, -0.8796240454229369, 11.66591456643492,
        -0.3629145599698426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.364521358882815, -0.7503163074582613],
            [13.364986027575656, -0.7194825724852183],
            [13.366049043775304, -0.6282293974219292],
            [13.366437686174047, -0.6024096412120724],
            [13.368623060747893, -0.5589207634214362],
            [13.381088488770498, -0.5624931522573519],
            [13.387074637597687, -0.5617670638877311],
            [13.393100809244304, -0.5623402979800045],
            [13.395495710928758, -0.5604019543216905],
            [13.393586954257175, -0.5552047719525246],
            [13.395265483649373, -0.552534662205223],
            [13.40355269954527, -0.5530480716018507],
            [13.40733107969686, -0.5505434589486727],
            [13.407568861609253, -0.546585394542337],
            [13.414331439939923, -0.5520433173389944],
            [13.42168016490654, -0.5557868501511163],
            [13.429123785710415, -0.5560670143916652],
            [13.434420481916291, -0.5574320409906343],
            [13.44060289552793, -0.5615259600058293],
            [13.449160722057014, -0.5655831356908522],
            [13.455518819333543, -0.5721782220530347],
            [13.460093915172209, -0.5784770215203178],
            [13.464429643486447, -0.5788588179292687],
            [13.468792797038425, -0.5702863750826876],
            [13.475384916696344, -0.5683448533569241],
            [13.478219995925912, -0.5656270814950614],
            [13.477252560325693, -0.5623988312839256],
            [13.463821820323899, -0.5545250521753922],
            [13.4561071526956, -0.550704943728894],
            [13.45528294790168, -0.5478481369504288],
            [13.457077841244114, -0.542112282538758],
            [13.455176077958212, -0.5382381073305242],
            [13.447300489569942, -0.5313355338130172],
            [13.44555600586367, -0.5277001407213083],
            [13.448890730641955, -0.5224743223032817],
            [13.455274887289448, -0.521170035775669],
            [13.470576056347687, -0.5241280368394924],
            [13.47663329855283, -0.5262275952839978],
            [13.483973787696764, -0.5247126881285764],
            [13.489939069501508, -0.5194080701137945],
            [13.496222054329476, -0.5172137562793183],
            [13.502888041162663, -0.516678873817171],
            [13.510041896008502, -0.5135721404009768],
            [13.512637645590658, -0.511159128362158],
            [13.512865168417743, -0.5068313333359037],
            [13.509798845379375, -0.4898288773653107],
            [13.507353050017489, -0.4837775258484147],
            [13.509470965549108, -0.4819141699723346],
            [13.52051447320408, -0.4802540478994028],
            [13.521430743505073, -0.4777340306641398],
            [13.528634625919205, -0.47154806299500507],
            [13.53103700929428, -0.4651631782547391],
            [13.53129936499367, -0.46037252597985867],
            [13.529155522065887, -0.4575503524193807],
            [13.523661368239654, -0.45722524216449834],
            [13.51941236739673, -0.45558990944187494],
            [13.520461493146021, -0.45238603056317583],
            [13.524685455318256, -0.45068104964099637],
            [13.533446097970067, -0.4508099005316833],
            [13.543059420997164, -0.4458260494265772],
            [13.548112974804093, -0.441766121602258],
            [13.55016191837163, -0.4365500638015148],
            [13.54636410454001, -0.43269946260372366],
            [13.551859333623762, -0.4300487444855104],
            [13.553990967199626, -0.43593955201179985],
            [13.557854301713517, -0.44020175021832664],
            [13.561310551867164, -0.44075313773131086],
            [13.580710573134258, -0.4509746552673728],
            [13.585958905496556, -0.4554924610620191],
            [13.590384067276647, -0.4557014570483494],
            [13.599741072747705, -0.45321771683035605],
            [13.601262983749738, -0.45027574842745743],
            [13.606663887519716, -0.4463086745315069],
            [13.607611570479364, -0.4380393868784143],
            [13.610295215322429, -0.4295903746444119],
            [13.61468638986353, -0.42366571921626034],
            [13.619029912346784, -0.42228736853562565],
            [13.626489992200808, -0.429300889419908],
            [13.629993812363638, -0.4360999387520044],
            [13.632606372444835, -0.43901172194020777],
            [13.635500968587106, -0.44834371721899674],
            [13.637459027842755, -0.45122231355639025],
            [13.643714621944339, -0.4526690655482208],
            [13.648067559503849, -0.44810815448986846],
            [13.645694596251918, -0.4400771572094845],
            [13.645250997927585, -0.43508554867367516],
            [13.647128823800582, -0.43177106689021133],
            [13.651829418282796, -0.4313517529837867],
            [13.659177049082023, -0.4373232617934513],
            [13.661646021239667, -0.4410670899537257],
            [13.664766096293569, -0.44904342225625826],
            [13.66615790263166, -0.4630044242249454],
            [13.664648471225396, -0.471437175100035],
            [13.666055935224714, -0.4753274414889571],
            [13.67104210943135, -0.4837027336006396],
            [13.677244017416434, -0.49049238630856246],
            [13.679997073363095, -0.49121071514582026],
            [13.68237610040522, -0.4875187245301047],
            [13.68240035609276, -0.48189262312421854],
            [13.685181593271404, -0.4738134330461678],
            [13.688781739201648, -0.47300440297512464],
            [13.694862634226165, -0.47586133552493537],
            [13.700843357892134, -0.46987857069348843],
            [13.713390024502461, -0.4634725408484361],
            [13.716960199961026, -0.4593910534069134],
            [13.716958525342953, -0.4542470300412517],
            [13.719792064322997, -0.44948594892338395],
            [13.723599234644269, -0.44726840403111173],
            [13.729050933113205, -0.44732310685667326],
            [13.731885600809075, -0.4494003886788366],
            [13.739878213895473, -0.466018909383051],
            [13.752032767167728, -0.46860638624141376],
            [13.75578534867255, -0.4705867352958067],
            [13.755171867855445, -0.5598035199740004],
            [13.754286789803498, -0.6209786867125171],
            [13.753382088240329, -0.6917395968685797],
            [13.752751653103639, -0.7485331139900416],
            [13.752262404554733, -0.7703878816392811],
            [13.751293660013, -0.8769603503094716],
            [13.750643693686339, -0.9210812878237421],
            [13.749675376221655, -1.004095820141161],
            [13.749836761282628, -1.0049738463292361],
            [13.725387310195314, -1.0096939320932996],
            [13.652211989644663, -1.022647659470618],
            [13.65039061986564, -1.0197233284188085],
            [13.643844812183326, -1.013812975966153],
            [13.648897132378902, -1.005521770371284],
            [13.647683640845155, -1.0031226264709348],
            [13.660283064280737, -0.9917766614004443],
            [13.664290229827914, -0.9874199412680466],
            [13.670025727656569, -0.9914097180100548],
            [13.676841070594001, -0.9887879494332704],
            [13.678011603139348, -0.9839125901541734],
            [13.675176113553174, -0.9764593905791844],
            [13.656374599759443, -0.9794080901516548],
            [13.654921194320357, -0.9738971932697185],
            [13.652697143533892, -0.9741959204313047],
            [13.651075993522934, -0.9608375324798321],
            [13.635529685632013, -0.965390414765392],
            [13.631183744533251, -0.9565490481268272],
            [13.623470262483135, -0.9595903547896137],
            [13.618796157162258, -0.9509428899554216],
            [13.615089741026454, -0.9329619908870369],
            [13.609153340323472, -0.9323924838209259],
            [13.607350528688979, -0.9352675221101292],
            [13.597337424978322, -0.9317177173253198],
            [13.591080271053242, -0.9280145688033411],
            [13.5876741584699, -0.9312180614148315],
            [13.586232796682022, -0.9395628070889466],
            [13.588735212623149, -0.9430688017235626],
            [13.58488006544013, -0.949013126381587],
            [13.581385533187957, -0.9575882532712418],
            [13.58359755688333, -0.960848342640289],
            [13.582060074005916, -0.9674137543804757],
            [13.580113223089358, -0.9690523979715688],
            [13.579844781159006, -0.9746027528651361],
            [13.575004944692193, -0.9771054867981233],
            [13.571561439957662, -0.9756127803191231],
            [13.566221201152365, -0.9695371780894644],
            [13.562381563209845, -0.9718497320663871],
            [13.560740051646814, -0.9689910066466171],
            [13.553838076643675, -0.9672184522561311],
            [13.55071180314339, -0.9684230761902145],
            [13.533044429714844, -0.9667563052414336],
            [13.521273426456233, -0.970621696210879],
            [13.515056163601683, -0.9679232360457402],
            [13.51212206850979, -0.9698744168916514],
            [13.507768679844077, -0.9759786616233892],
            [13.508687520568659, -0.9818383498744935],
            [13.504068523018377, -0.9822447803768082],
            [13.503536632959316, -0.9864063188182054],
            [13.515529369184014, -0.9919315634750481],
            [13.520944306801551, -0.9926567577033335],
            [13.522686073846227, -0.9968461395280951],
            [13.530062497516713, -1.0037476965614194],
            [13.533037437680182, -0.9999698041809553],
            [13.538741726791043, -0.9983771493557015],
            [13.55711468098624, -1.0027371639566747],
            [13.556439613872818, -1.0108632008658225],
            [13.54771663846452, -1.0211451524137054],
            [13.548232785446356, -1.0303364277080473],
            [13.553205763775876, -1.0357348704518143],
            [13.552769721544093, -1.0403402681379674],
            [13.518628021949004, -1.0466034210531145],
            [13.446097836179135, -1.058647136769962],
            [13.360668910297855, -1.072829279433662],
            [13.361919832262908, -0.9666860012511956],
            [13.362518104847512, -0.9255253536169274],
            [13.363635921957195, -0.8249011261889929],
            [13.364521358882815, -0.7503163074582613]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.3970755157769, "lat": 36.821264038108914 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51143"],
        "coty_name": ["Pittsylvania"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pittsylvania County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01480157"
      },
      "bbox": [
        13.360668910297855, -1.072829279433662, 13.75578534867255,
        -0.42228736853562565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.335552496770037, -0.6997714968953405],
            [12.35805210286977, -0.743151442782939],
            [12.375042760454717, -0.7569523726449182],
            [12.385802479334139, -0.76299110368173],
            [12.411186513909064, -0.7841676965047242],
            [12.435445481392643, -0.8063954031858465],
            [12.433433652164057, -0.8075714912219525],
            [12.43656455805453, -0.8142169711272129],
            [12.43757283084294, -0.8193321394130546],
            [12.442949154058768, -0.8150027458256411],
            [12.454337321416384, -0.8242313222959741],
            [12.501255670291384, -0.8718324535487912],
            [12.461304483012604, -0.8942574759001594],
            [12.45471316593788, -0.9002003392765966],
            [12.448886352732867, -0.9066440233539927],
            [12.442752822463468, -0.9088428447020002],
            [12.439985842463326, -0.9085194966503342],
            [12.42574027438963, -0.9155921271137115],
            [12.420656039223887, -0.9169228591974954],
            [12.418414783523982, -0.9158045908109245],
            [12.335949321647671, -0.9539222003323674],
            [12.291553849927984, -0.9746755027252695],
            [12.284751475833117, -0.9724759061481897],
            [12.276535981232863, -0.9820326452924565],
            [12.271231330547822, -0.9839227940568511],
            [12.266585047794745, -0.9890544969354121],
            [12.265336700481113, -0.9928296711443186],
            [12.257318080793365, -0.9969618898881272],
            [12.25559962722724, -1.0013222605387369],
            [12.249191066369644, -1.0029499452258608],
            [12.244994719751242, -1.006373387082955],
            [12.245095240369945, -1.0125918459285834],
            [12.247794091103414, -1.0154353899392383],
            [12.246014896723368, -1.0229731779371878],
            [12.246598578147756, -1.0266623092715335],
            [12.225577475212894, -1.0293709074888022],
            [12.223274230806346, -1.0310630505407739],
            [12.215969181061755, -1.0326245127077491],
            [12.209512619337042, -1.0370150545967172],
            [12.199478345863412, -1.0360424807588902],
            [12.194931272756124, -1.03318192000527],
            [12.190322342769345, -1.0355425087068135],
            [12.188551855611944, -1.0401130483503347],
            [12.184820893344511, -1.0414153570435558],
            [12.172560614935147, -1.0410948637199777],
            [12.170317921551511, -1.0436952945395956],
            [12.171588387618979, -1.0476852268331318],
            [12.166225499935004, -1.0493450708124838],
            [12.16196121260974, -1.0482775139073],
            [12.154672974031097, -1.0497073824376149],
            [12.1431297381969, -1.0496138251922733],
            [12.139860326353856, -1.0462240127580866],
            [12.135403661789855, -1.0478846957531713],
            [12.134138747801, -1.0506739849699624],
            [12.126305034085828, -1.0528618148389248],
            [12.121635094175089, -1.0497957340039967],
            [12.111310795990336, -1.0524185471659406],
            [12.0985805715912, -1.0247002657419941],
            [12.090892901427084, -1.0113995423286666],
            [12.066443841914001, -0.9710706281292428],
            [12.050859077174154, -0.9459159111696404],
            [12.03927330671597, -0.9242664772156068],
            [11.98995064710816, -0.8777968265371406],
            [11.99333091292458, -0.8661623531916653],
            [11.99718445047853, -0.8615800862614246],
            [12.006517820970824, -0.8628897580879396],
            [12.012152027033913, -0.8589495299884362],
            [12.01646230485767, -0.8511277774617341],
            [12.018511840536988, -0.8498896080856357],
            [12.024976492180258, -0.8369299579867524],
            [12.030492922019961, -0.8296343956747448],
            [12.032826942777218, -0.8240600123242527],
            [12.038668697308875, -0.8177029561441215],
            [12.052278039069298, -0.8001056633753217],
            [12.058036178773536, -0.7974023626449191],
            [12.064094100687546, -0.7922401574786553],
            [12.070989759236777, -0.7837141856696819],
            [12.079929813094417, -0.7796161982728762],
            [12.086924225061376, -0.7742325577850131],
            [12.0960779605615, -0.7637832892750871],
            [12.107182488307922, -0.7643212360149968],
            [12.114179550186256, -0.7664497408528816],
            [12.123387704391742, -0.7705360197926022],
            [12.129795652834085, -0.7777472202361854],
            [12.135384986072756, -0.7808494655976855],
            [12.14545069094258, -0.7797222393427928],
            [12.149676329674893, -0.7777705023798089],
            [12.15614030782223, -0.7730120427112535],
            [12.16305000203804, -0.7667190293726199],
            [12.170676314662636, -0.7619975978609616],
            [12.17636220804193, -0.7663910406692511],
            [12.186182639722578, -0.7753881507813039],
            [12.201254817046175, -0.766996434716415],
            [12.210956271714114, -0.7596997543873267],
            [12.221440288603194, -0.7557612272754],
            [12.228224560978823, -0.7517350062687532],
            [12.240352842365022, -0.7466158918094963],
            [12.246232541216465, -0.7410956662715728],
            [12.253992436628527, -0.7381150006359014],
            [12.286496576592596, -0.72830454194352],
            [12.293649385030072, -0.7231637731094047],
            [12.316452652318052, -0.7096931774121177],
            [12.319542992638317, -0.7091450944973049],
            [12.329088426689808, -0.7022486713837106],
            [12.335552496770037, -0.6997714968953405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.0787205156901, "lat": 36.91707921391696 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51197"],
        "coty_name": ["Wythe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wythe County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "01501379"
      },
      "bbox": [
        11.98995064710816, -1.0528618148389248, 12.501255670291384,
        -0.6997714968953405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.169361630446465, 10.78172235177686],
            [-14.168443467116257, 10.777036350557596],
            [-14.165088396960162, 10.772454766104863],
            [-14.162572334773586, 10.766601065720959],
            [-14.152528286854084, 10.763424418206512],
            [-14.148129306833859, 10.768456061806274],
            [-14.142998152352186, 10.776354134312077],
            [-14.132532886302215, 10.77932936372122],
            [-14.12735275930723, 10.77585605589609],
            [-14.12436830653756, 10.772457235697257],
            [-14.116718716195972, 10.77439070743346],
            [-14.110876018645554, 10.780016012014675],
            [-14.091024221646508, 10.786981229430419],
            [-14.085534256337905, 10.791841251004177],
            [-14.081355679424119, 10.79210828948754],
            [-14.08201841988436, 10.80110351453099],
            [-14.077031537819531, 10.809650174749462],
            [-14.071595240056839, 10.81704029964451],
            [-14.061178254985201, 10.820088953726424],
            [-14.057610740939165, 10.819101591406646],
            [-14.055345210689996, 10.810351571356055],
            [-14.056339831532634, 10.804715350848369],
            [-14.059793576216645, 10.794667471440157],
            [-14.058924090231898, 10.787580127147866],
            [-14.060634871048995, 10.781299605522257],
            [-14.059893253404127, 10.774561038792562],
            [-14.055449960433615, 10.76462828550021],
            [-14.048357812704895, 10.76430743644467],
            [-14.041692012271184, 10.761001151489253],
            [-14.040345387509506, 10.757049119127972],
            [-14.036395194695428, 10.75388095412337],
            [-14.036002414567962, 10.744942804175574],
            [-14.033058866102893, 10.738621990856506],
            [-14.028934914284847, 10.72686950329178],
            [-14.02179042664897, 10.717082310527003],
            [-14.017099009861766, 10.714586876676476],
            [-14.011868908842853, 10.71611127511121],
            [-14.008174189398101, 10.719799829444339],
            [-13.997302423767218, 10.718215988081738],
            [-13.988875892416178, 10.711886805120011],
            [-13.986950646284779, 10.709500110122587],
            [-13.979609065508257, 10.743320569755753],
            [-13.966769957120484, 10.799166887227457],
            [-13.96135735922519, 10.824106814289824],
            [-13.9459741249326, 10.892348434189982],
            [-13.932788878976412, 10.94990106091599],
            [-13.867179615890805, 10.934427488071286],
            [-13.781652811655956, 10.914349461256524],
            [-13.694430628586776, 10.894337863292572],
            [-13.607658336219677, 10.874772233938943],
            [-13.622855534944884, 10.810231083883147],
            [-13.62533814272638, 10.799686649675222],
            [-13.653151710484764, 10.678615547474696],
            [-13.656460504938762, 10.662743694667485],
            [-13.666042537660205, 10.621101697299213],
            [-13.670308266212178, 10.604271613818957],
            [-13.675203354151074, 10.579792655875433],
            [-13.677977029230584, 10.567812247491101],
            [-13.709829664812435, 10.426145130592785],
            [-13.713583193300316, 10.411039149577174],
            [-13.720900460414436, 10.376742232498556],
            [-13.730237661449834, 10.3341976926713],
            [-13.747377657105627, 10.259074488591862],
            [-13.754717204414268, 10.227554717960142],
            [-13.758676266950426, 10.209551315505918],
            [-13.777990188821239, 10.125620287421322],
            [-13.796275316144301, 10.130256211957494],
            [-13.810307082097042, 10.133003491835998],
            [-13.897245668375364, 10.152446268057767],
            [-13.968702158026534, 10.168743489131405],
            [-14.066250436601127, 10.190412275940423],
            [-14.126066419301953, 10.204338082921977],
            [-14.207622369204206, 10.223015191282835],
            [-14.299008720607242, 10.244208511660522],
            [-14.264803485962819, 10.38622225744477],
            [-14.232154810128778, 10.521122066359059],
            [-14.217622924190598, 10.581220365659943],
            [-14.216055823773896, 10.58086937626676],
            [-14.19686162181228, 10.66363096836075],
            [-14.177392983405694, 10.74644872200466],
            [-14.169361630446465, 10.78172235177686]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -117.40404524948212, "lat": 47.6207475503381 },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53063"],
        "coty_name": ["Spokane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spokane County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01529225"
      },
      "bbox": [
        -14.299008720607242, 10.125620287421322, -13.607658336219677,
        10.94990106091599
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.626389314777823, 1.507367040145779],
            [11.637086940743101, 1.5101670416338109],
            [11.643758480347957, 1.513850219634529],
            [11.651727972584096, 1.5222622240436863],
            [11.662519006868175, 1.5326177946613566],
            [11.672281224849476, 1.5435831049351634],
            [11.677193065908158, 1.5482704627588586],
            [11.688623348908548, 1.5550373525730725],
            [11.692251392599132, 1.560228320433979],
            [11.695672648622738, 1.5629359727419194],
            [11.70381673464729, 1.5650090560977092],
            [11.711396355115617, 1.5695585255261537],
            [11.716834179873091, 1.570699296782348],
            [11.73130309003972, 1.5686605363304205],
            [11.735803612716643, 1.5709265756777653],
            [11.738539285649065, 1.5744871978580686],
            [11.739188626399057, 1.581183490941807],
            [11.73820736415431, 1.587618957800416],
            [11.7413190916806, 1.595484888735151],
            [11.75028777040002, 1.6099425570828811],
            [11.752768688183858, 1.6176550056410224],
            [11.756624722731672, 1.6227450307225197],
            [11.763017799874367, 1.6278909994053452],
            [11.776068620040046, 1.6340303489082801],
            [11.786856174830826, 1.6363424480871422],
            [11.79323038851475, 1.6430678453664758],
            [11.79724640676823, 1.6522635627031141],
            [11.80044042102143, 1.6515490818364398],
            [11.80732981625702, 1.6597946891644695],
            [11.810333854455335, 1.6598840428406572],
            [11.816911505327031, 1.6548031554317058],
            [11.819864157109178, 1.6563987314026243],
            [11.823144978708465, 1.663282999765507],
            [11.827865848556385, 1.6671119355714943],
            [11.837297255072553, 1.666776190122094],
            [11.844988249870168, 1.6655089123973088],
            [11.84665079492108, 1.6699753956397443],
            [11.841354538453645, 1.6743168066145344],
            [11.83977688719143, 1.6780654778078776],
            [11.844603409846867, 1.6782356617043157],
            [11.855090168691017, 1.672501688851888],
            [11.863011773839032, 1.6736891752624092],
            [11.866230487439394, 1.6721455661116666],
            [11.868922305378213, 1.6680081142556604],
            [11.874030451285089, 1.6481698053835534],
            [11.884891254139907, 1.6180427654875746],
            [11.900032126875148, 1.5593935129211418],
            [11.893031628378441, 1.5590512096293085],
            [11.888862569583429, 1.5530754845795676],
            [11.886107315844448, 1.5528422709495284],
            [11.882652018888871, 1.5561611405958755],
            [11.87720717288216, 1.5472382022348952],
            [11.87780901559543, 1.54355514217459],
            [11.875850560354172, 1.532924443967525],
            [11.869276832060628, 1.530349437302338],
            [11.867285253176407, 1.526764116842546],
            [11.863460361477408, 1.5254428285870998],
            [11.857177189705881, 1.526899910944444],
            [11.855281275918044, 1.5295627912656122],
            [11.851614286446042, 1.527245395461458],
            [11.848020848170242, 1.5309741584213326],
            [11.84017480567287, 1.5248279879087026],
            [11.834662137228506, 1.523945430450541],
            [11.830513897324796, 1.5195986937131305],
            [11.824772245862295, 1.5200998971831077],
            [11.821847587513119, 1.514244829378291],
            [11.821721026993922, 1.510683733851683],
            [11.816589862604129, 1.5083273708570353],
            [11.81147972831474, 1.5087474985427252],
            [11.809553479688885, 1.5037442347366434],
            [11.805789040150367, 1.5060657057626492],
            [11.793346528796887, 1.5022120519048476],
            [11.792524908930194, 1.5000395061959615],
            [11.787512840452129, 1.5018876336037703],
            [11.782186841815879, 1.495131880463085],
            [11.776471359508989, 1.4962541667365008],
            [11.775425256920112, 1.4982688047715191],
            [11.767087304396188, 1.4984924268056043],
            [11.769092098113578, 1.495638367483476],
            [11.767366376752607, 1.492909490946767],
            [11.763332668348346, 1.4917736390152503],
            [11.758839372451984, 1.4932137608028306],
            [11.74521013630993, 1.49107563627444],
            [11.746634751713714, 1.487927887336366],
            [11.743168454117777, 1.4838094445323826],
            [11.739677363248001, 1.4719238598151285],
            [11.73981893841564, 1.4675535208867339],
            [11.74244676655913, 1.4631649089875693],
            [11.742718085054587, 1.4569760965910796],
            [11.737663882557962, 1.4493937421834941],
            [11.733717110972716, 1.4515291009413163],
            [11.730115896592356, 1.4567096328365556],
            [11.723167696704419, 1.4580726279008642],
            [11.719909770433796, 1.4601518080463636],
            [11.71982158754879, 1.4656080116818568],
            [11.718236290529854, 1.4699394821384886],
            [11.712345831052128, 1.4734266901657302],
            [11.705831040450377, 1.4704655069992494],
            [11.699922322545344, 1.4728333173895274],
            [11.689419873910477, 1.4727243497517872],
            [11.683305027542174, 1.4708184030856135],
            [11.676523062819756, 1.4725953602809105],
            [11.668718106464766, 1.4696063660407939],
            [11.669015260960544, 1.4724858420965086],
            [11.663564398478194, 1.4824763069813784],
            [11.66604057462483, 1.4866833863006148],
            [11.663948359034467, 1.4910304773995127],
            [11.660407029050944, 1.4911914802016708],
            [11.657660966190837, 1.4939621897097575],
            [11.650715365357005, 1.4892221699666657],
            [11.645976003429194, 1.4968267720319433],
            [11.640524652185311, 1.494013190980705],
            [11.642163018564387, 1.489023287033458],
            [11.635505933184163, 1.4867634075683078],
            [11.631462841971423, 1.4945094622663604],
            [11.630943881115485, 1.4994606840283695],
            [11.626389314777823, 1.507367040145779]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.16045505406753, "lat": 39.37099708106522 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54073"],
        "coty_name": ["Pleasants"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pleasants County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01678557"
      },
      "bbox": [
        11.626389314777823, 1.4493937421834941, 11.900032126875148,
        1.6782356617043157
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.511047112656057, 4.7100293416192685],
            [-10.499630947254548, 4.778084200831191],
            [-10.475671273858199, 4.916309021241383],
            [-10.462111707649782, 5.002445717190621],
            [-10.451934223227743, 5.06708802264877],
            [-10.43590786964345, 5.166119782473772],
            [-10.429036113304402, 5.209999780893528],
            [-10.420642962290767, 5.262362204437053],
            [-10.400422347295132, 5.388958953394926],
            [-10.382421452081857, 5.50292348966981],
            [-10.298935819104194, 5.48995361222611],
            [-10.299309512195833, 5.487521853704472],
            [-10.217796053747962, 5.475166206169532],
            [-10.230082794693653, 5.397314126132374],
            [-10.167164723982813, 5.387429711198967],
            [-10.147997927824443, 5.384583636519396],
            [-10.06153762222322, 5.371205242284036],
            [-10.078214823727413, 5.263458121579412],
            [-10.0850940866901, 5.263123610130739],
            [-10.098254065176857, 5.179390545639232],
            [-10.098930858089943, 5.179394505922848],
            [-10.116396382982167, 5.064239229020035],
            [-10.128507925252935, 4.983983761671507],
            [-10.138096493714661, 4.920841883979009],
            [-10.163886574763302, 4.924839101208836],
            [-10.174559449358688, 4.856474786001259],
            [-10.15046526656134, 4.8526604725868525],
            [-10.182707752774364, 4.644385892230613],
            [-10.185440780317009, 4.625628722429887],
            [-10.190756512466338, 4.593409716559658],
            [-10.15684105827505, 4.588230067288304],
            [-10.181853189253987, 4.4184016084554845],
            [-10.096626403801485, 4.40783663242055],
            [-10.097277444007636, 4.4040772479814825],
            [-10.000508752890385, 4.389042199504615],
            [-9.93851513581563, 4.380461466858366],
            [-9.939690405699793, 4.374648679921769],
            [-9.927145529975208, 4.372863519914223],
            [-9.828307446864462, 4.358119030948287],
            [-9.867938352940364, 4.096281134386592],
            [-9.86211438395022, 4.095314494689564],
            [-9.866016566364571, 4.069289789884587],
            [-9.926912261881938, 3.669070361969158],
            [-9.937843311672921, 3.6701911478781013],
            [-10.09578668115982, 3.694788978079851],
            [-10.14030114252125, 3.70186110720509],
            [-10.142622090430967, 3.702398361291702],
            [-10.231705256170036, 3.7161546225927964],
            [-10.32079050383549, 3.7298972856259063],
            [-10.489738189187682, 3.7567627967254906],
            [-10.658693603422627, 3.783579308070293],
            [-10.627268423696604, 3.981962568425353],
            [-10.592349556832646, 4.202332016486536],
            [-10.570283834917902, 4.342001006002326],
            [-10.548306919810125, 4.479083938355652],
            [-10.537418442790758, 4.547100891427056],
            [-10.521666917097326, 4.644625491534901],
            [-10.511047112656057, 4.7100293416192685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.65604810431951,
          "lat": 42.26398197169527
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56023"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01605076"
      },
      "bbox": [
        -10.658693603422627, 3.669070361969158, -9.828307446864462,
        5.50292348966981
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": 145.75338488258353,
          "lat": 15.188774717340804
        },
        "year": "2023",
        "ste_code": ["69"],
        "ste_name": ["Commonwealth of the Northern Mariana Islands"],
        "coty_code": ["69110"],
        "coty_name": ["Saipan"],
        "coty_area_code": "MNP",
        "coty_type": "municipality",
        "coty_name_long": ["Saipan Municipality"],
        "coty_fp_code": "110",
        "coty_gnis_code": "01805247"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.22174266760146,
          "lat": 18.224880779687844
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72045"],
        "coty_name": ["Comerío"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Comerío Municipio"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01804502"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.560279942349, "lat": 18.37349656294898 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72054"],
        "coty_name": ["Florida"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Florida Municipio"],
        "coty_fp_code": "054",
        "coty_gnis_code": "01804507"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.91996833128059,
          "lat": 17.982957518567336
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72055"],
        "coty_name": ["Guánica"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Guánica Municipio"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01804508"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -67.08076037305334,
          "lat": 18.378099135369006
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72099"],
        "coty_name": ["Moca"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Moca Municipio"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01804530"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.978081656922136, -0.655849233045522],
            [1.9793449394970049, -0.5729497096304215],
            [1.9804121534518062, -0.5143677984911372],
            [1.9809495769569967, -0.47666186938209],
            [2.0663796698978425, -0.47758952988508313],
            [2.1331168951203714, -0.47855107585885387],
            [2.2090042542995527, -0.47957339358827233],
            [2.3186886170415044, -0.48049090830970065],
            [2.350110978763302, -0.48121211610454995],
            [2.3644266780613603, -0.4808394539688698],
            [2.359556657136467, -0.4759836113328911],
            [2.353597189711494, -0.4666370905563903],
            [2.3544828307392627, -0.4630436985432337],
            [2.3581546278661842, -0.4612789659760832],
            [2.36418436148565, -0.4620585514968255],
            [2.37810975203853, -0.47464493889901727],
            [2.3906000953603272, -0.47395784272466035],
            [2.397918978237744, -0.4733445050018695],
            [2.399762698204399, -0.47446193598460024],
            [2.398718182579233, -0.48151572272945653],
            [2.4111996331222114, -0.48162947201881695],
            [2.410535425066322, -0.5258815239777616],
            [2.4102555511561583, -0.5305213283521493],
            [2.409451226726007, -0.5899457718113503],
            [2.409353962332745, -0.6089173197324019],
            [2.4086825840257715, -0.6602991155445989],
            [2.4081037124033764, -0.6842881202682654],
            [2.407215237755341, -0.770173307799566],
            [2.36297025835254, -0.7699215249459407],
            [2.36279143736984, -0.7840104454970434],
            [2.3624067715205763, -0.8577935346258467],
            [2.361701251293527, -0.8577105500778873],
            [2.318502412293345, -0.8573870850998967],
            [2.2683875427033873, -0.8570017544332792],
            [2.2325526793344896, -0.8569491665174386],
            [2.1817511749285226, -0.8557451320701969],
            [2.1750597166252024, -0.8554238072744748],
            [2.1761893329732476, -0.8016916040786114],
            [2.1760897603677085, -0.7968317721809837],
            [2.1675935043003514, -0.7969979039399216],
            [2.147218485798855, -0.7953567577745414],
            [2.143619300618881, -0.796236154175852],
            [2.1045210579635714, -0.795860960706317],
            [2.061715437714537, -0.7952006728172634],
            [2.0611852203332086, -0.7949696890918081],
            [2.011160289680004, -0.793887846169286],
            [1.9751064792545412, -0.7929003557003791],
            [1.9769825694939307, -0.7206679470676326],
            [1.9774429263140871, -0.6901718765865916],
            [1.977194817856094, -0.6831031489121462],
            [1.978081656922136, -0.655849233045522]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.77595837333865, "lat": 38.03719789531926 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29185"],
        "coty_name": ["St. Clair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Clair County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00758547"
      },
      "bbox": [
        1.9751064792545412, -0.8577935346258467, 2.4111996331222114,
        -0.4612789659760832
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.800425923196658, 1.5783177071911836],
            [0.8758362014690477, 1.5780720569979707],
            [0.9109997303211195, 1.577528749508461],
            [0.9827807378804421, 1.577660053769478],
            [1.0619629847647232, 1.5778283851478854],
            [1.0834495943262854, 1.5774223239953074],
            [1.1263562221704408, 1.576646995671878],
            [1.1659091464279259, 1.5773219069538902],
            [1.1651083732862966, 1.5740451068694805],
            [1.1679059515273713, 1.570529097081594],
            [1.1630039046382807, 1.5678436648686966],
            [1.1652653625729739, 1.5649365807413909],
            [1.1645661211905618, 1.5596857870350682],
            [1.1711746885911294, 1.55982915863546],
            [1.1764986457756377, 1.5554688404480743],
            [1.1746647560193972, 1.549644819622972],
            [1.1698335938632802, 1.5444741994569346],
            [1.1690949430763535, 1.53762005101084],
            [1.1696144854482298, 1.5289464050003696],
            [1.1723123832482334, 1.5219160804568768],
            [1.1689498988291331, 1.5204617901390654],
            [1.168581743985195, 1.5160097957143277],
            [1.1650889041575068, 1.5114294179060785],
            [1.1670101781312863, 1.4954135212442123],
            [1.1728349006050294, 1.4920197810155218],
            [1.1735591032403054, 1.4886163735159779],
            [1.1701552433636437, 1.483428217397314],
            [1.1724765079616644, 1.4814315175285542],
            [1.1731374989718617, 1.4745371496309874],
            [1.1749926077184814, 1.4714595688573857],
            [1.1718838571324957, 1.468308829761234],
            [1.1766345127054296, 1.4660617687426185],
            [1.1751201148748185, 1.458405350863553],
            [1.178947419238282, 1.4514846894037652],
            [1.1836261711298461, 1.4513325676673448],
            [1.1888016243562447, 1.4456505214819766],
            [1.1862136275033612, 1.444695420936567],
            [1.1892868447190537, 1.4379552609511073],
            [1.1869151795180954, 1.4350522924293974],
            [1.193710041461702, 1.4310321215085466],
            [1.1910187484264891, 1.4266004323386794],
            [1.1939164128119848, 1.4235356981191793],
            [1.1900607382975918, 1.4206589216264238],
            [1.192407257595379, 1.4163436607530404],
            [1.1882348645444516, 1.413556574140262],
            [1.1914371421527208, 1.4070939731300371],
            [1.1888698120802093, 1.4041011056532522],
            [1.189803014883602, 1.398848378362285],
            [1.189012445591215, 1.3935480018204338],
            [1.1841678298931362, 1.3901934128570934],
            [1.1772416421720326, 1.389687694704742],
            [1.1784127499057404, 1.3853067349848693],
            [1.1776145551976662, 1.3809809018538348],
            [1.1898340378222947, 1.377408456817149],
            [1.1922998173103183, 1.3747093789885707],
            [1.1941531572853084, 1.3676427893882968],
            [1.1943865970840652, 1.361002661350632],
            [1.206717259503439, 1.367076025919619],
            [1.2105230066580082, 1.3654728738450839],
            [1.2143303391450442, 1.3618400503871515],
            [1.210256747035693, 1.3577077214389806],
            [1.215925086863011, 1.3549255656405703],
            [1.214040093781637, 1.351970035561574],
            [1.2168059006443392, 1.3486119737160618],
            [1.215096400387414, 1.346642922978798],
            [1.2193024700952666, 1.3422960844423406],
            [1.2149805209503768, 1.3376644236416069],
            [1.215204818449897, 1.3324536756722387],
            [1.213760146210242, 1.3291344186603484],
            [1.2167869777327327, 1.3231749291609345],
            [1.2145535147560191, 1.3208744926165883],
            [1.2145115741018393, 1.315934302605273],
            [1.219717943488944, 1.3119236301726531],
            [1.218479735778837, 1.302563765867952],
            [1.2190073212905106, 1.2948134238357623],
            [1.224760171846024, 1.2884759919406785],
            [1.2259562815273835, 1.2845193159051744],
            [1.2209805910964309, 1.2726951902486363],
            [1.2248340623510388, 1.2726126105573752],
            [1.2290780704741275, 1.2699422841086798],
            [1.229705244280553, 1.263024213813026],
            [1.231932937879526, 1.2570715693219408],
            [1.2252859894487684, 1.2517341650543994],
            [1.2216273563133695, 1.2467575867058918],
            [1.2194666931020322, 1.2414961438327343],
            [1.2223053438392608, 1.2375533880761227],
            [1.2197103957556314, 1.2350581160726255],
            [1.2232549959147536, 1.2315838857319104],
            [1.2287475425630539, 1.2290809215300464],
            [1.228917913015685, 1.2116891353427033],
            [1.2209782167051526, 1.2142368521537847],
            [1.2138887700776273, 1.2137108555124572],
            [1.2096658364989814, 1.2110627948969501],
            [1.2054379640448847, 1.2047934460795466],
            [1.2042996299102269, 1.2002864371033501],
            [1.205011048319579, 1.1923080279131013],
            [1.2029484235408567, 1.1849096123208824],
            [1.1955300098672703, 1.178799877487378],
            [1.1622830272349116, 1.1746122897700406],
            [1.1557104728569976, 1.1759839878989955],
            [1.1436721052777274, 1.1819483972424971],
            [1.126702666532011, 1.1868370978454792],
            [1.1216737744452125, 1.189502486047079],
            [1.1171784153069904, 1.1943414851337248],
            [1.1149782450706736, 1.2020589903386716],
            [1.1156513385820943, 1.2081838705905794],
            [1.1145607024866933, 1.2147307332182724],
            [1.110073880691482, 1.2187568384066487],
            [1.1023294457895751, 1.2197333267700106],
            [1.0929012041627366, 1.2146478739347415],
            [1.0874782144703656, 1.2126191310649468],
            [1.0765550796829924, 1.2131593404095118],
            [1.0703551270960123, 1.2165003734449074],
            [1.0674326994391254, 1.2207359781317628],
            [1.067365437630639, 1.2276915569015674],
            [1.0701423395983596, 1.2350492822717878],
            [1.0710968786199695, 1.240825756303148],
            [1.0705996399501023, 1.2469148936412475],
            [1.0681654385961183, 1.251692222739928],
            [1.0610576704702561, 1.2559283297241763],
            [1.0561286171001194, 1.257125748444353],
            [1.047852077256999, 1.2564035054277318],
            [1.0400416432581427, 1.2575162151107833],
            [1.033273300896967, 1.2611906798722097],
            [1.0276044356167846, 1.2674441738834994],
            [1.0181995694048203, 1.2820113038605223],
            [1.0144795933082567, 1.2847261569742223],
            [1.0030787424457728, 1.2902810738307122],
            [0.9933163492704824, 1.2969192149295459],
            [0.989785796233081, 1.3016928669794303],
            [0.9888107714647052, 1.3126668445997582],
            [0.9857658049515485, 1.3221254633122146],
            [0.9813330283693655, 1.3259485385753995],
            [0.97335740159247, 1.3283544808946126],
            [0.9674583669591355, 1.3317907080582743],
            [0.9595548089216596, 1.3409854176386935],
            [0.9517149098771706, 1.344210810472136],
            [0.9463226667682222, 1.344150321223062],
            [0.9319549439232736, 1.3396306981643145],
            [0.9254524294026764, 1.3395343070535302],
            [0.9169787165862456, 1.3430207148111672],
            [0.9086418810549124, 1.3508954971077527],
            [0.9042313905342889, 1.3609751732405946],
            [0.902406972183949, 1.3715670373776536],
            [0.9048594205640057, 1.3792057832259559],
            [0.9112483410330083, 1.3871251215301097],
            [0.9122803253727804, 1.3920122179113723],
            [0.9105438698695386, 1.40448347306417],
            [0.9128167484273169, 1.4110538041875058],
            [0.9206887111234444, 1.4183191975278346],
            [0.9237456303571525, 1.4243833036288953],
            [0.923477863983118, 1.4324891585245523],
            [0.9194002690497256, 1.43973346583115],
            [0.9111832879037454, 1.443346801031995],
            [0.9038264941569694, 1.4438401601028303],
            [0.8995746299685021, 1.4460123958994735],
            [0.8948111221008516, 1.451679157691287],
            [0.8929828740982337, 1.4594386106750505],
            [0.8926024990671401, 1.4663169439403467],
            [0.8906545363837198, 1.4721408734254402],
            [0.8857273021697721, 1.4766924445964398],
            [0.8765434037545479, 1.4799841178945083],
            [0.8721156578664391, 1.4825774916065142],
            [0.8642660713210784, 1.4903377693905466],
            [0.8602647703050363, 1.4954377975022106],
            [0.855484330807338, 1.5057960919117714],
            [0.8556055605021847, 1.514253518685919],
            [0.8588700090387533, 1.5223165167818344],
            [0.8622329846444409, 1.5272159775208352],
            [0.8647670768910526, 1.5353245092891579],
            [0.8649906021674207, 1.5417820978942582],
            [0.8628034897336578, 1.55001049585885],
            [0.8590193092918336, 1.556688906216922],
            [0.8525664195092951, 1.5618027381083532],
            [0.8469509972997118, 1.5635225469012373],
            [0.8364475953488241, 1.5627895611654932],
            [0.8297802651647489, 1.5630568948395964],
            [0.8236697485746419, 1.564984779488845],
            [0.8157333402170645, 1.5708196229173321],
            [0.808824052984977, 1.5745522492215482],
            [0.8022110484990981, 1.5757482809431884],
            [0.800425923196658, 1.5783177071911836]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.21558724591719, "lat": 40.09440535284793 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29087"],
        "coty_name": ["Holt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Holt County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00758498"
      },
      "bbox": [
        0.800425923196658, 1.1746122897700406, 1.231932937879526,
        1.5783177071911836
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9195067063355555, 0.46084267072589813],
            [1.9257450694892073, 0.45657686575821277],
            [1.933253603621663, 0.4530762795703469],
            [1.9398305980892059, 0.451900288972531],
            [1.9522306709992832, 0.4521853704144576],
            [1.956678946381533, 0.45355256089026774],
            [1.9650735934103376, 0.459072513679292],
            [1.971685097134041, 0.4657521638000221],
            [1.9811918604110934, 0.47323675798992443],
            [1.9798167224510232, 0.483774465582095],
            [1.972059834248814, 0.49623682285157766],
            [1.9714641964845225, 0.5037643978251458],
            [1.9725941335323605, 0.5067927989676062],
            [1.9768712974844667, 0.5105670018276578],
            [1.9871043793944438, 0.514430251313199],
            [2.0074785694217345, 0.521350336330923],
            [2.013968963847758, 0.5257643284587302],
            [2.016038314577577, 0.5254216032335334],
            [2.024354457357425, 0.5183035192243182],
            [2.0283162495582907, 0.5121823445627663],
            [2.027996784690456, 0.5033389633801914],
            [2.0239486499147583, 0.497966101912903],
            [2.018318843812496, 0.49239616411070913],
            [2.0122574277931724, 0.488013082211576],
            [2.010187054228879, 0.48063513860956547],
            [2.0099717682444034, 0.4751333117634533],
            [2.0083471543884, 0.4720382503902754],
            [2.016030688541424, 0.4648095866477942],
            [2.0240425544152623, 0.46177632000533547],
            [2.029846707351844, 0.46318305460886455],
            [2.0379036433859947, 0.4707097067089587],
            [2.0439250426962534, 0.47814872357696686],
            [2.0425235184534354, 0.48196166400964396],
            [2.042164976324025, 0.49036848558291624],
            [2.0452705725337412, 0.4999963808107548],
            [2.0511319077071186, 0.504230459973004],
            [2.0565597826496913, 0.5049334265998061],
            [2.0689369444169987, 0.5033547702005895],
            [2.076347938084071, 0.5055731252916239],
            [2.0944797826966277, 0.5257084736129941],
            [2.1050490355244724, 0.532679816974031],
            [2.114383114423649, 0.5367195928057968],
            [2.1211320137621037, 0.5378077284698396],
            [2.13340168164846, 0.5375120430025764],
            [2.137772235035319, 0.5363580798841402],
            [2.1501925539154523, 0.5301976998860147],
            [2.1523463127648137, 0.5281622949818437],
            [2.1611006712104777, 0.52414855873712],
            [2.168762916616413, 0.5238668006365899],
            [2.184002989516245, 0.5307349178430392],
            [2.1935068682091927, 0.5334499120050396],
            [2.198907528587029, 0.5337478584359445],
            [2.214109407464918, 0.5308201375271114],
            [2.2202787195640075, 0.5308331489100754],
            [2.2287518611224044, 0.5345347427336067],
            [2.233358683333261, 0.5408396360168315],
            [2.236552265042328, 0.5498622005550842],
            [2.2423874232723167, 0.5565873197621095],
            [2.2478909246911347, 0.5594796072332979],
            [2.2573804292092534, 0.5615462961235176],
            [2.261722420382286, 0.5670931505854826],
            [2.2607507940380303, 0.5718284525495146],
            [2.265794605363471, 0.5743078652062749],
            [2.2713673879322127, 0.5715951442358003],
            [2.276667796683199, 0.57352527194087],
            [2.282920462057745, 0.5696336934171674],
            [2.294394194832619, 0.5692706197108429],
            [2.3007491725381244, 0.5677380228681779],
            [2.307811272910407, 0.569146314298518],
            [2.3162805760908993, 0.567714024405754],
            [2.3216536327247903, 0.5635135132475604],
            [2.3298469588526416, 0.5546725502599711],
            [2.3334953593175323, 0.547541542810536],
            [2.3482930705265734, 0.543622521073582],
            [2.3593726700928936, 0.5431361569380716],
            [2.3697739532752515, 0.5437031896498503],
            [2.3818629823884265, 0.5467630094104632],
            [2.388047287063821, 0.5524358266795962],
            [2.391028674751742, 0.5579820186845639],
            [2.39190190314348, 0.5630403131093759],
            [2.39098632956824, 0.5675372697219364],
            [2.385490750672623, 0.5849626836734386],
            [2.383677053333734, 0.5941590339939937],
            [2.384042977765763, 0.6048406961087839],
            [2.3879914491043377, 0.6147261660488446],
            [2.3923749219175496, 0.6197832107686608],
            [2.39748627147583, 0.6227038466022466],
            [2.3961978784159346, 0.5615251489739272],
            [2.3962077277494345, 0.5486444770717633],
            [2.3951259372679035, 0.4897784593413889],
            [2.3945314900631467, 0.4356702907517434],
            [2.39401703208184, 0.4015710890230806],
            [2.3936824117312177, 0.35743297339069624],
            [2.3927076368110183, 0.31153893849403663],
            [2.3921215076406375, 0.2691287548395498],
            [2.391810680115507, 0.2545693434276663],
            [2.3038209600886463, 0.2560215008549106],
            [2.2892137618954393, 0.25564063252249025],
            [2.2539341425624473, 0.2562035180027766],
            [2.207876562249299, 0.25627229323444595],
            [2.17462691102774, 0.25665108506490025],
            [2.131680156497709, 0.2577535058537413],
            [2.1311189872712015, 0.22825083948621275],
            [2.091753200379039, 0.2289840123639497],
            [2.0598674995302866, 0.23008477833228844],
            [1.9771755240009468, 0.23140621555201568],
            [1.9199216247402116, 0.23273362119062704],
            [1.9168551940970573, 0.2323657064703261],
            [1.916556889705394, 0.24370864930488542],
            [1.91694195572732, 0.27639726953079924],
            [1.9176179366953507, 0.2985848911297119],
            [1.9181005278671424, 0.3037093246112309],
            [1.9181328988213162, 0.330382706290004],
            [1.9185865386796752, 0.3788528673008424],
            [1.9190577027683386, 0.4085230921416608],
            [1.9195067063355555, 0.46084267072589813]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.78548624916061, "lat": 39.06550888739627 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29107"],
        "coty_name": ["Lafayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lafayette County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00758508"
      },
      "bbox": [
        1.916556889705394, 0.22825083948621275, 2.39748627147583,
        0.6227038466022466
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.282755317301403, 1.3178694225633456],
            [3.366585063237884, 1.3232166285658726],
            [3.409879998216115, 1.3232912146989975],
            [3.472646363014342, 1.323633594770184],
            [3.537259896003982, 1.3251674668948732],
            [3.622595337422589, 1.3276503488170441],
            [3.6235353229280336, 1.298690300287662],
            [3.6251887385225636, 1.223597199873282],
            [3.6260191474554047, 1.196762505337288],
            [3.6271943342971436, 1.1412113061629772],
            [3.6302309313270635, 1.0418140168470509],
            [3.6305195889915782, 1.035370732827367],
            [3.5873785346897655, 1.0342611734586773],
            [3.5445087019067754, 1.0326292513644404],
            [3.486733977983328, 1.0311668542926917],
            [3.4298576694929754, 1.0301893275239375],
            [3.4156203885081573, 1.0297724038145593],
            [3.372581412790334, 1.0290171701952016],
            [3.373664747902047, 0.9696202777921032],
            [3.287715458586599, 0.9674961468618964],
            [3.286891161370985, 1.0043288171855023],
            [3.2861434017982174, 1.0548399619934543],
            [3.285594509313681, 1.156207558890497],
            [3.2849747609818025, 1.2017890220756848],
            [3.2847292351600568, 1.2042352731232295],
            [3.2840616743372424, 1.2592216247697745],
            [3.282755317301403, 1.3178694225633456]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.07656924309433, "lat": 39.79776254544566 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29205"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "205",
        "coty_gnis_code": "00758555"
      },
      "bbox": [
        3.282755317301403, 0.9674961468618964, 3.6305195889915782,
        1.3276503488170441
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.618582635890639, 9.25275498032411],
            [-7.616127266067822, 9.251148749969495],
            [-7.602627772030379, 9.25340403086284],
            [-7.587149678433672, 9.254153475804994],
            [-7.584292719904353, 9.25773797986407],
            [-7.58478987199078, 9.26494428544686],
            [-7.5879645352694745, 9.268861299611364],
            [-7.588139806523262, 9.275632952802393],
            [-7.585677421916226, 9.280156183578272],
            [-7.581629830129534, 9.282432246276818],
            [-7.574956170746267, 9.283737215175275],
            [-7.573890872774507, 9.287991542789495],
            [-7.577559485845704, 9.299370671174819],
            [-7.581581926199683, 9.304758351799439],
            [-7.581429137344014, 9.309628990304095],
            [-7.577751023087711, 9.312730953774942],
            [-7.5728481856488195, 9.312836661349909],
            [-7.568346012649418, 9.315323230794418],
            [-7.56426128671088, 9.319370398524336],
            [-7.563984177722046, 9.32287044312936],
            [-7.56119770643313, 9.328377204448294],
            [-7.55445830953345, 9.331701284473532],
            [-7.548136718348754, 9.33740892759503],
            [-7.542496068416662, 9.337347503212195],
            [-7.538528866043013, 9.333840451566411],
            [-7.530632642031344, 9.33595020423794],
            [-7.527469344578285, 9.34280782238644],
            [-7.522439697483748, 9.341038221692129],
            [-7.518546879064526, 9.332251701128216],
            [-7.515156694547797, 9.33126509504166],
            [-7.5072563740941725, 9.335214489261544],
            [-7.504896556677631, 9.340036848906756],
            [-7.506065611262451, 9.350475867682466],
            [-7.498674708891618, 9.353375740120661],
            [-7.488116933044477, 9.353552486074468],
            [-7.484348959365596, 9.355938546125179],
            [-7.482565172829772, 9.36294075303623],
            [-7.4821900403523705, 9.369042560147184],
            [-7.474522987972876, 9.372219590397306],
            [-7.471754650081979, 9.3765895397978],
            [-7.465552684508596, 9.381672451773287],
            [-7.463149712712485, 9.389395773493266],
            [-7.453289321255463, 9.40065429543225],
            [-7.452716657651802, 9.408467801054535],
            [-7.4461341188618695, 9.409920779345411],
            [-7.436110002259731, 9.40733807888896],
            [-7.433472460428778, 9.404285347180465],
            [-7.431016988512655, 9.397832040895194],
            [-7.425690751176033, 9.397641340391013],
            [-7.4216320518761805, 9.401116682809352],
            [-7.419668325432694, 9.404895998995844],
            [-7.417830921329986, 9.4144505952246],
            [-7.418491193523068, 9.419543378253953],
            [-7.4225347626410825, 9.425975106442248],
            [-7.417815785889587, 9.427443761539013],
            [-7.412038173887388, 9.423891401413675],
            [-7.408795877938531, 9.417828102661115],
            [-7.403503464976844, 9.411364166013923],
            [-7.401214852822991, 9.404519290676916],
            [-7.398779790985923, 9.405446252298933],
            [-7.394720400456346, 9.416952628124687],
            [-7.390230559375325, 9.421105225343373],
            [-7.381905149815083, 9.420343542934253],
            [-7.377444622765272, 9.418426363837412],
            [-7.368479973126306, 9.41276763121227],
            [-7.364757778570096, 9.411592914975188],
            [-7.354989676571898, 9.413754981721212],
            [-7.350689795707068, 9.413006941861248],
            [-7.341616116960736, 9.40933962315774],
            [-7.3332570706932705, 9.407755171216742],
            [-7.328097836379086, 9.394547070900776],
            [-7.32585611825207, 9.3912012884841],
            [-7.321082367362044, 9.387624806916998],
            [-7.307438213703729, 9.385984628287025],
            [-7.289078068672761, 9.381953864188679],
            [-7.282993506891408, 9.382738462945676],
            [-7.276647997340554, 9.389615703123003],
            [-7.275167223112068, 9.397868491698798],
            [-7.277493165727543, 9.402722165319634],
            [-7.276131105462485, 9.407618329431557],
            [-7.269393566650728, 9.408457020980725],
            [-7.264080435804211, 9.414100976168658],
            [-7.262898065327118, 9.41845878710858],
            [-7.26429500456119, 9.4227457938056],
            [-7.267858057263106, 9.42782766059947],
            [-7.267116890226947, 9.433003256585234],
            [-7.259559915841801, 9.443981781551916],
            [-7.256123915991224, 9.446698087590143],
            [-7.252178936494534, 9.446990185994045],
            [-7.231395556614024, 9.4448580217169],
            [-7.219398564406964, 9.441827578303473],
            [-7.213044576042899, 9.435427374607036],
            [-7.205904290443258, 9.430749964678922],
            [-7.20147649928503, 9.429315973372082],
            [-7.18783388936141, 9.428117552054914],
            [-7.169542805126693, 9.425314341867944],
            [-7.165727038969696, 9.423557338627187],
            [-7.161385767336323, 9.419218276990575],
            [-7.157073002737356, 9.41258418304395],
            [-7.152235285377308, 9.40686826103991],
            [-7.1480009695160405, 9.404157499096737],
            [-7.125397593512955, 9.401774185490742],
            [-7.115185072942752, 9.402286217885775],
            [-7.111334873728872, 9.399596229209529],
            [-7.098179104984491, 9.398671407750367],
            [-7.092464774046565, 9.401817486640091],
            [-7.086535853042675, 9.403114027718354],
            [-7.078419441533381, 9.402821120389934],
            [-7.056280399640083, 9.400821646621948],
            [-7.043013544092498, 9.39713218260634],
            [-7.034595831155432, 9.392892018860142],
            [-7.0276820827142465, 9.39097396072993],
            [-7.0185224558309764, 9.390321644218053],
            [-7.005174697789256, 9.388148851135904],
            [-6.999923702732408, 9.385843265346885],
            [-6.991717222894345, 9.385960334326594],
            [-6.987748865599292, 9.387081729600503],
            [-6.98228744225891, 9.391278915246673],
            [-6.977860483592014, 9.396651233951415],
            [-6.974411422016751, 9.396919526172958],
            [-6.964626426564732, 9.39382420774436],
            [-6.952623905348926, 9.391980946031836],
            [-6.941236366011256, 9.394754494899978],
            [-6.9364003877854055, 9.392986872729766],
            [-6.929219237853752, 9.38665952284932],
            [-6.92299012410617, 9.386664232334969],
            [-6.9065119968338715, 9.389350773002443],
            [-6.897236373283573, 9.392374593298111],
            [-6.892819720771613, 9.398721027557096],
            [-6.889020946346109, 9.406419182707232],
            [-6.888013113176532, 9.41431888777337],
            [-6.8888914524904905, 9.420157472193567],
            [-6.892489593795298, 9.430430071714925],
            [-6.888756945732251, 9.437240756173848],
            [-6.878488833972387, 9.447846254163155],
            [-6.872802492646853, 9.45010452809014],
            [-6.859301756656689, 9.451616237223732],
            [-6.845120784317927, 9.45102457501752],
            [-6.826780437412454, 9.447073563598794],
            [-6.810849321855964, 9.434389581873052],
            [-6.801699323911947, 9.433228925448454],
            [-6.793222485348764, 9.435079047983278],
            [-6.789759416123791, 9.436978217818895],
            [-6.78741263498829, 9.440817709766257],
            [-6.780464213209485, 9.446703290887438],
            [-6.775980337630235, 9.452607118352587],
            [-6.77464936787503, 9.456538226008496],
            [-6.77384912519411, 9.470319031948186],
            [-6.766769392249921, 9.472803203186274],
            [-6.761055344976581, 9.47345291221314],
            [-6.751314957250217, 9.471964123846565],
            [-6.744812621499193, 9.46407379534217],
            [-6.740110398886649, 9.466190746015393],
            [-6.737426146169563, 9.469147869613668],
            [-6.733799511154767, 9.476179675616951],
            [-6.733089146975978, 9.482206984444588],
            [-6.731492211869274, 9.484005919379818],
            [-6.724971574777342, 9.485510773161014],
            [-6.713012128774674, 9.483245658647572],
            [-6.711098906019891, 9.481808363457779],
            [-6.706940702275984, 9.467787501453017],
            [-6.704549053886284, 9.467664881190812],
            [-6.699220128497278, 9.474473505813812],
            [-6.697805350406575, 9.482030654540884],
            [-6.698214766483115, 9.486875183767225],
            [-6.701575237470139, 9.492039857383986],
            [-6.701741733234501, 9.494613423884957],
            [-6.697364130030173, 9.497493340383768],
            [-6.686989805581045, 9.499777441807241],
            [-6.674503615257481, 9.49951482453629],
            [-6.671110571692261, 9.501135620605417],
            [-6.666665530943308, 9.506382341013591],
            [-6.663693508772304, 9.513736116194869],
            [-6.666211410589876, 9.525965391476516],
            [-6.662873283261073, 9.530314878460514],
            [-6.657531230082137, 9.531790309764293],
            [-6.645932973906226, 9.53071322447472],
            [-6.642365647437016, 9.532507717830143],
            [-6.639941004852757, 9.538766852140112],
            [-6.639736692097088, 9.543003758338465],
            [-6.64864681992327, 9.552849496560166],
            [-6.648565978653893, 9.558594072382787],
            [-6.639931652330882, 9.56256268485484],
            [-6.634340010801564, 9.562397397759534],
            [-6.626460049699377, 9.559289571538796],
            [-6.624002028248212, 9.562679567960261],
            [-6.624954717574325, 9.571094016719147],
            [-6.633915618415711, 9.577910980990866],
            [-6.637530227082607, 9.5846847452362],
            [-6.6335161134445135, 9.589791851580275],
            [-6.62460543996058, 9.593060395082246],
            [-6.6171303413738105, 9.59250301121274],
            [-6.612905915213488, 9.594743572189856],
            [-6.607135886658942, 9.604800621151464],
            [-6.606079573174751, 9.609797497688412],
            [-6.609325800697945, 9.620722688445008],
            [-6.617006527154418, 9.624172348755284],
            [-6.618123847331908, 9.628229564156388],
            [-6.612011046421606, 9.63574405631587],
            [-6.603790744615452, 9.638780951641829],
            [-6.590689488037742, 9.638355382161807],
            [-6.5849801299401785, 9.639718363348555],
            [-6.577600419997895, 9.643925083344866],
            [-6.576363663900742, 9.645860305604259],
            [-6.576256566735633, 9.65234033209258],
            [-6.57476492593224, 9.65498252424592],
            [-6.5703978263279765, 9.655254012207436],
            [-6.563068307443895, 9.6514274923552],
            [-6.561237372435924, 9.647809243401055],
            [-6.56177262473765, 9.64199251794576],
            [-6.565511035066149, 9.63716399037164],
            [-6.56626328519106, 9.63378273831435],
            [-6.563612308326342, 9.62686660570683],
            [-6.559422530151723, 9.625790837780945],
            [-6.556332787580248, 9.628861567169436],
            [-6.515868596541994, 9.624246483799295],
            [-6.525314696628379, 9.537876247749463],
            [-6.460015365944328, 9.530882157662392],
            [-6.482778229727645, 9.324606997873255],
            [-6.496451035960864, 9.200360968339846],
            [-6.521419034922799, 9.203026265410347],
            [-6.524643233145492, 9.173666861466842],
            [-6.540256561592674, 9.032567842912403],
            [-6.453865036913586, 9.023539206482205],
            [-6.456825666067636, 8.995158245750025],
            [-6.472137860340949, 8.853888944078399],
            [-6.4152996090774606, 8.847991890541524],
            [-6.4232161076817285, 8.772883110703992],
            [-6.448975080938738, 8.53427397183163],
            [-6.450411775421382, 8.520154038053596],
            [-6.558589598822809, 8.531790759650889],
            [-6.666771361020237, 8.543391416108943],
            [-6.774956963352856, 8.554955999684113],
            [-6.883146307154368, 8.566484502808995],
            [-6.881474598624003, 8.58059514244586],
            [-6.988460814888175, 8.592580666800284],
            [-7.0954509570979996, 8.604530827532109],
            [-7.155566996438438, 8.611487322668367],
            [-7.234868826042204, 8.62074662203068],
            [-7.314172930565515, 8.62998646673652],
            [-7.391342719084575, 8.639361464155483],
            [-7.392327931933273, 8.631451988511762],
            [-7.478138399605405, 8.641933686495433],
            [-7.563951699683143, 8.652392584462572],
            [-7.665816974837367, 8.664662196695788],
            [-7.681610368757433, 8.666830482438332],
            [-7.6828709067663805, 8.669352799068783],
            [-7.687738949480538, 8.668865922106145],
            [-7.691077855165442, 8.673945155285146],
            [-7.685481487841304, 8.681703340807678],
            [-7.690810869392455, 8.681543154055028],
            [-7.694683809710709, 8.685040797598676],
            [-7.698735565550238, 8.686145949046493],
            [-7.695099640084304, 8.692649999683244],
            [-7.701355474163608, 8.695835711822628],
            [-7.704624747279076, 8.695704709533498],
            [-7.707758187778207, 8.692341274098665],
            [-7.710539770581664, 8.69526612252068],
            [-7.711074217182155, 8.702200539634283],
            [-7.707358763054463, 8.705929452822176],
            [-7.7100058657398245, 8.710112186112832],
            [-7.709280373778108, 8.713462133310868],
            [-7.702399413240145, 8.71519469021746],
            [-7.701464692865051, 8.717114742531717],
            [-7.703527616910793, 8.722749792499965],
            [-7.699226030078625, 8.725685163993168],
            [-7.70263677676569, 8.731826281756303],
            [-7.7018486852895025, 8.734889248216312],
            [-7.697754312306476, 8.735367487725801],
            [-7.694407225890989, 8.733414707404945],
            [-7.689950923259488, 8.73703527718367],
            [-7.693677560103307, 8.739388218153204],
            [-7.6970427790539375, 8.744538000171046],
            [-7.690957573324112, 8.744813919143931],
            [-7.69596239511082, 8.750391005148513],
            [-7.689531174093069, 8.752999168855423],
            [-7.681375973960571, 8.75064460160616],
            [-7.684251285703808, 8.75589599467796],
            [-7.686499607876953, 8.75708446894626],
            [-7.686156215704483, 8.761766369750767],
            [-7.682463310355964, 8.766635909610462],
            [-7.678464520222154, 8.767765461224633],
            [-7.6783697224396334, 8.771481341317758],
            [-7.680779414582513, 8.775454377390805],
            [-7.676149284751938, 8.776494410414978],
            [-7.678381539802173, 8.782877557267685],
            [-7.676290950215604, 8.787132975243122],
            [-7.672643670021711, 8.786017778632178],
            [-7.6714397845900635, 8.789037011540575],
            [-7.66726326455683, 8.792541230477365],
            [-7.659823336540005, 8.796486823915195],
            [-7.661436727691169, 8.801134936327442],
            [-7.6622888039708625, 8.808371138383983],
            [-7.657129445643483, 8.809711939022577],
            [-7.6612852818553305, 8.815605445783643],
            [-7.659909943312299, 8.820471548185866],
            [-7.664539377708119, 8.819632331359264],
            [-7.663864726685904, 8.826584849756951],
            [-7.667056521002441, 8.831738973964708],
            [-7.6707591449485415, 8.826797063749897],
            [-7.673994733780122, 8.826129142443238],
            [-7.679553208591191, 8.831088974173085],
            [-7.68012489135594, 8.838013980742346],
            [-7.671033373860259, 8.844636251973167],
            [-7.668573222456273, 8.850583489612678],
            [-7.66959094600032, 8.853086956756302],
            [-7.679882014361808, 8.85733616610383],
            [-7.681439448783149, 8.8607753033098],
            [-7.676618321615903, 8.862041787163774],
            [-7.677655799627419, 8.867110729249797],
            [-7.674524598678144, 8.872030800691556],
            [-7.6774896568014785, 8.875601316733011],
            [-7.673360196342567, 8.88128565661512],
            [-7.6779430941249505, 8.882754535737345],
            [-7.675471410582073, 8.888617346198552],
            [-7.670656327764342, 8.891712747814086],
            [-7.6732463530284605, 8.894949676847883],
            [-7.677352835122129, 8.896225414294857],
            [-7.677588846658705, 8.891941301251565],
            [-7.681334987410175, 8.892524294789164],
            [-7.680700900719473, 8.897784379130906],
            [-7.6869853278323115, 8.898223532554457],
            [-7.6859789731810215, 8.901234208028072],
            [-7.681230316033202, 8.900771606331709],
            [-7.679600028649094, 8.90350233085678],
            [-7.679417104819631, 8.910822784629023],
            [-7.681678950884369, 8.913174743462136],
            [-7.681089806045344, 8.917428146241575],
            [-7.683948633969758, 8.920155808694851],
            [-7.691163685998466, 8.923327484353816],
            [-7.688135309998362, 8.925285553939181],
            [-7.684898280970843, 8.922979169448773],
            [-7.680860440406591, 8.924357795359343],
            [-7.679837569059725, 8.92869252171282],
            [-7.682151145375704, 8.933819846110167],
            [-7.6902847877762035, 8.93505822019642],
            [-7.693930638375333, 8.940151248824796],
            [-7.687509129775714, 8.944304386273963],
            [-7.681906219636908, 8.94638564893461],
            [-7.67685282637872, 8.95474385932966],
            [-7.67659372367377, 8.95790807843146],
            [-7.682262862629728, 8.961144363900972],
            [-7.682486660510772, 8.966299282889118],
            [-7.686186979440034, 8.970881856452577],
            [-7.682467220303283, 8.974371331922745],
            [-7.679419103528131, 8.971638471265551],
            [-7.677342265043964, 8.965795924164732],
            [-7.6744261566097185, 8.965690691041312],
            [-7.675813768419887, 8.972232565948495],
            [-7.674734689014003, 8.974389872826087],
            [-7.678598186202818, 8.978438491742756],
            [-7.678694695655691, 8.982045767841047],
            [-7.675454637558127, 8.98372526178476],
            [-7.67354446803937, 8.978575554519038],
            [-7.669211152626908, 8.976832864197004],
            [-7.667148097734983, 8.982214073278099],
            [-7.669969442584487, 8.98491395785576],
            [-7.661761540556579, 8.989261756861781],
            [-7.6659457497598265, 8.993852317704148],
            [-7.667253353405963, 8.989315211612787],
            [-7.670046332503202, 8.988084786545073],
            [-7.672325320977367, 8.993019641813243],
            [-7.666729073048301, 8.996237553878338],
            [-7.670662853932081, 8.99938695898529],
            [-7.6689326678989715, 9.005084091359475],
            [-7.673442149152952, 9.003651186396315],
            [-7.6756968507754655, 9.010026554706293],
            [-7.672697003579197, 9.01518850759465],
            [-7.669379976900572, 9.015910472326718],
            [-7.6695406221702775, 9.019418896057848],
            [-7.6671176581586415, 9.024952632506794],
            [-7.6677633667627765, 9.027977766773175],
            [-7.672347682892089, 9.03072592724941],
            [-7.670098856081151, 9.033105710626483],
            [-7.673667326668859, 9.03971123059543],
            [-7.67626709231794, 9.035256728320794],
            [-7.681772469739873, 9.037766115959379],
            [-7.677674093843034, 9.040393671342372],
            [-7.676973163971451, 9.04454550350284],
            [-7.680708534040052, 9.049750345183718],
            [-7.675914403906437, 9.0513898752884],
            [-7.672368629141033, 9.049019677535865],
            [-7.671382181342978, 9.054243410929947],
            [-7.6838349929374115, 9.062174234662017],
            [-7.677930665191557, 9.068730997012635],
            [-7.671855657799214, 9.06438493530054],
            [-7.669180328065054, 9.070334736992017],
            [-7.67359950680228, 9.070375657872242],
            [-7.678419376634601, 9.075653810649097],
            [-7.676083594861862, 9.079464825123171],
            [-7.672665329099539, 9.07793918958373],
            [-7.670137976559719, 9.083889046880769],
            [-7.6728329702767395, 9.085888375226645],
            [-7.677831205405956, 9.08672657611285],
            [-7.675556163966165, 9.091632603490478],
            [-7.671140625153231, 9.094666854814612],
            [-7.66491056857598, 9.093390365853901],
            [-7.667217787018162, 9.097486653861411],
            [-7.673354028520949, 9.101826623230364],
            [-7.673487784590628, 9.103932521902442],
            [-7.667716925360746, 9.105992749096526],
            [-7.662277249857444, 9.109589016948371],
            [-7.6690840701208725, 9.11382602440308],
            [-7.667659942935641, 9.120372319594285],
            [-7.662613125462393, 9.124976935700548],
            [-7.659671397012288, 9.123931094467718],
            [-7.655712319959936, 9.12577155133138],
            [-7.658738314091453, 9.128687944726446],
            [-7.666993316658232, 9.132160242973725],
            [-7.663878823389325, 9.135627320375393],
            [-7.669063846205666, 9.13633315352411],
            [-7.670752697308679, 9.138811949198654],
            [-7.667607275358433, 9.144155690906851],
            [-7.6639363451484295, 9.146037198247912],
            [-7.66435852094953, 9.150502493792606],
            [-7.660581215310454, 9.151726701542753],
            [-7.662544157592561, 9.156016098006045],
            [-7.665907858027454, 9.157873598362233],
            [-7.667619684639768, 9.16325454239828],
            [-7.658556964734979, 9.163989699843935],
            [-7.661844870860743, 9.169389867564103],
            [-7.650383053936298, 9.173796109826855],
            [-7.65150757094821, 9.17672381822644],
            [-7.648675777527517, 9.1804747093847],
            [-7.650177881349712, 9.18429801839863],
            [-7.642366519218774, 9.182394672846879],
            [-7.641367685504073, 9.188264122179998],
            [-7.645737557124247, 9.189993530683575],
            [-7.643344010305757, 9.19452675593693],
            [-7.6394410749732, 9.19171926346704],
            [-7.635767151821776, 9.193425799030035],
            [-7.638045226968349, 9.197919676073312],
            [-7.635758193284943, 9.201592826060121],
            [-7.630491130001129, 9.201428784708128],
            [-7.627794066983214, 9.205882716368508],
            [-7.625009154703939, 9.204993444514868],
            [-7.62465799923357, 9.217994182899163],
            [-7.628798336951147, 9.217066466708374],
            [-7.628791784290626, 9.221975274197957],
            [-7.624886610623093, 9.220106099500038],
            [-7.6222556244552475, 9.224414510579809],
            [-7.624745045712733, 9.228202654491426],
            [-7.621827897128993, 9.231696081552004],
            [-7.622696636907869, 9.237106715742947],
            [-7.625687835167148, 9.236610667659345],
            [-7.625097049936249, 9.242408157706343],
            [-7.622852044186362, 9.244427597432017],
            [-7.624429897069259, 9.249469312040985],
            [-7.618582635890639, 9.25275498032411]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.99285767835448, "lat": 47.2775959630436 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30033"],
        "coty_name": ["Garfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garfield County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01716058"
      },
      "bbox": [
        -7.711074217182155, 8.520154038053596, -6.4152996090774606,
        9.655254012207436
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.16508904560855, 9.63954254954024],
            [-6.158627723826759, 9.64192982129286],
            [-6.150043215020996, 9.647879694737714],
            [-6.140121189458815, 9.651184510383887],
            [-6.1341816038102355, 9.651370471484734],
            [-6.125183134588841, 9.647524333824395],
            [-6.122079046297576, 9.651717315768298],
            [-6.1207011831768, 9.656857465626056],
            [-6.1201900697427, 9.66666016393642],
            [-6.116986671701836, 9.670866151080595],
            [-6.112171968820328, 9.670500132244564],
            [-6.110417155586526, 9.666276087504302],
            [-6.111070701299472, 9.660910218051686],
            [-6.110383109143195, 9.653951366733219],
            [-6.1074735338231205, 9.650109866990233],
            [-6.100928452002435, 9.647848217710138],
            [-6.092370708287881, 9.652125884874385],
            [-6.080301470393732, 9.652197804194811],
            [-6.072918101589456, 9.656932545853998],
            [-6.0686720640415714, 9.664170979937813],
            [-6.060502559652106, 9.671408188997113],
            [-6.050205218214946, 9.67582291848543],
            [-6.044313304202452, 9.67555675687518],
            [-6.041143306238516, 9.672908285174163],
            [-6.0404522438549515, 9.664265300268283],
            [-6.03898305233931, 9.661592376878257],
            [-6.0323480941416285, 9.66165851987366],
            [-6.0264739021979095, 9.665587349087698],
            [-6.022459556645829, 9.672991356552702],
            [-6.022439061813247, 9.679825059882011],
            [-6.028670526643128, 9.683813300119565],
            [-6.0307474382301525, 9.68782569878371],
            [-6.026861655717934, 9.6913727110724],
            [-6.01320202407706, 9.688551744383599],
            [-6.006854225787743, 9.685402270187568],
            [-5.999460816265324, 9.689565424783527],
            [-5.990938156965378, 9.692172481707063],
            [-5.984330434008813, 9.68959957751741],
            [-5.972964467734714, 9.692118841314686],
            [-5.969897913181098, 9.689724354730798],
            [-5.964931318506441, 9.681545052930815],
            [-5.955893689074724, 9.673613768071242],
            [-5.949464376698682, 9.674535651600749],
            [-5.9438407979147225, 9.680159561309317],
            [-5.9409739435123745, 9.686487856662376],
            [-5.93904206381168, 9.693374077706947],
            [-5.930640285746358, 9.701176206615932],
            [-5.9243150390413035, 9.701389447677718],
            [-5.920882705817607, 9.696190949679105],
            [-5.914420056475193, 9.693734085181248],
            [-5.906292569870331, 9.695737494382692],
            [-5.9028997911603645, 9.695082095871143],
            [-5.896249722236371, 9.690412703143984],
            [-5.8802470557366116, 9.688977761083132],
            [-5.877268033834205, 9.691195627983372],
            [-5.871848869133585, 9.691080662730045],
            [-5.857151886954084, 9.688829776815655],
            [-5.8480358711135425, 9.689007505737608],
            [-5.8429160031865575, 9.686197141349723],
            [-5.835707358488046, 9.68370703456974],
            [-5.832629534685612, 9.68411131055397],
            [-5.8225599489450675, 9.688074708314808],
            [-5.819377791750618, 9.68815224007327],
            [-5.813052851429018, 9.685319556130784],
            [-5.808995180655479, 9.680584385277333],
            [-5.810148964032972, 9.674833707693274],
            [-5.805160637035479, 9.671176894564224],
            [-5.7954007455714285, 9.671426529838934],
            [-5.784476626963558, 9.674147758042063],
            [-5.778703345054648, 9.673609750544054],
            [-5.767296811346298, 9.677381963504471],
            [-5.759244142098557, 9.67658184999684],
            [-5.753653297173101, 9.677727966064799],
            [-5.744769691726246, 9.675432865907105],
            [-5.738776891854951, 9.667179027508745],
            [-5.7432779872505595, 9.657717367854485],
            [-5.740280722249018, 9.650275565475019],
            [-5.7351164194336235, 9.648941714472905],
            [-5.730960937486219, 9.65139546684327],
            [-5.724000673761086, 9.651183871235737],
            [-5.72512276255044, 9.639124305209368],
            [-5.734776430921757, 9.542692451425566],
            [-5.7432496698633555, 9.457925680945088],
            [-5.769851428720413, 9.460454168774707],
            [-5.777398588790313, 9.384893710428347],
            [-5.86396563636064, 9.393195021658789],
            [-5.866701585928241, 9.36480988657711],
            [-5.876810649421788, 9.266018881527842],
            [-5.889609694373241, 9.138789435773788],
            [-5.918743455781814, 9.141615321787267],
            [-5.929938491323264, 9.027985458927814],
            [-5.930160106874956, 9.026883625378028],
            [-5.936755729983763, 8.960913918264787],
            [-5.948444492179471, 8.843984357953733],
            [-5.9527378797339745, 8.801590930539911],
            [-6.039353941429149, 8.81006594052932],
            [-6.125972293218044, 8.818517343877742],
            [-6.242867306506392, 8.830223335558584],
            [-6.2516304192171965, 8.74414978064773],
            [-6.33824318492863, 8.752956203294286],
            [-6.32904405407935, 8.839028352415824],
            [-6.4152996090774606, 8.847991890541524],
            [-6.472137860340949, 8.853888944078399],
            [-6.456825666067636, 8.995158245750025],
            [-6.453865036913586, 9.023539206482205],
            [-6.540256561592674, 9.032567842912403],
            [-6.524643233145492, 9.173666861466842],
            [-6.521419034922799, 9.203026265410347],
            [-6.496451035960864, 9.200360968339846],
            [-6.482778229727645, 9.324606997873255],
            [-6.460015365944328, 9.530882157662392],
            [-6.525314696628379, 9.537876247749463],
            [-6.515868596541994, 9.624246483799295],
            [-6.556332787580248, 9.628861567169436],
            [-6.552111508696318, 9.637906105179253],
            [-6.551761667919187, 9.643475491349438],
            [-6.554572709266619, 9.658438230089905],
            [-6.552644222400992, 9.666589564895487],
            [-6.554533174208351, 9.673975455109261],
            [-6.553876883027934, 9.681546015177583],
            [-6.5545220261573665, 9.685217488898951],
            [-6.557275949782978, 9.68879335352623],
            [-6.555254593824079, 9.694718193886244],
            [-6.552661756940134, 9.696171383385977],
            [-6.5465075052007204, 9.711852180694196],
            [-6.543955812532832, 9.713837885476819],
            [-6.536982454334859, 9.724734848186452],
            [-6.532928863578586, 9.729061996990062],
            [-6.528308970418898, 9.731319469282019],
            [-6.514799822211728, 9.727526089530432],
            [-6.511821127255032, 9.724846012344745],
            [-6.510371124835178, 9.720898630240836],
            [-6.511298816718353, 9.714660440828705],
            [-6.510335466992904, 9.711780976249564],
            [-6.5019621018723655, 9.70786053547309],
            [-6.493124516745153, 9.709187620731019],
            [-6.480579305861615, 9.717043322624685],
            [-6.47534307261914, 9.715937200062013],
            [-6.470347616885947, 9.710685109167901],
            [-6.4683727869226155, 9.701906249187159],
            [-6.460882575243745, 9.701029612551899],
            [-6.4576134311461875, 9.704611002798897],
            [-6.4508106112570465, 9.705139265460845],
            [-6.446987577933352, 9.702952925564466],
            [-6.442304996200069, 9.696202713892982],
            [-6.437261048854858, 9.692923003809822],
            [-6.431936669708501, 9.686768453530917],
            [-6.4219211511303556, 9.682233223140003],
            [-6.405034165850464, 9.680555848242015],
            [-6.394897740988302, 9.681986761269375],
            [-6.389092682912132, 9.681733954880137],
            [-6.385566539156006, 9.679728292008674],
            [-6.373173480088559, 9.68116239534746],
            [-6.365558983606565, 9.679619307809366],
            [-6.355939995050074, 9.681207151637343],
            [-6.350251218053382, 9.676435171265576],
            [-6.350788613327753, 9.67248076066023],
            [-6.354819696357079, 9.667624323261734],
            [-6.3654930211524965, 9.662819119256984],
            [-6.36763678635837, 9.659886460115137],
            [-6.36546290378313, 9.656571451862396],
            [-6.3586205423589295, 9.655375357367395],
            [-6.350899900453192, 9.652735494884956],
            [-6.338920621490532, 9.655009058889313],
            [-6.333887056758487, 9.657343832002597],
            [-6.327529687091896, 9.664399515011928],
            [-6.325105604421488, 9.671296980645012],
            [-6.327283171688144, 9.675730186996445],
            [-6.324779341545162, 9.6801100774813],
            [-6.320272176586085, 9.68045680393235],
            [-6.311897833349707, 9.67692944733058],
            [-6.30696148567204, 9.672543192362989],
            [-6.301510228166074, 9.662891210397385],
            [-6.299616067093971, 9.651680262055619],
            [-6.295052459433458, 9.650027352480675],
            [-6.290179596802728, 9.646357483272162],
            [-6.284013102574483, 9.64615727898736],
            [-6.279884257423941, 9.647668378088603],
            [-6.277197872138781, 9.65207682466624],
            [-6.27887824999738, 9.657374844408919],
            [-6.2841186506246185, 9.663592673512111],
            [-6.285017492950603, 9.667475054914185],
            [-6.280369614832792, 9.673694086599122],
            [-6.271531764465517, 9.673541529659314],
            [-6.267105155785926, 9.670875821483074],
            [-6.26110066781866, 9.66539817369455],
            [-6.258365474552413, 9.65942028164979],
            [-6.252209314921042, 9.654005156913398],
            [-6.24371543940551, 9.651080948930327],
            [-6.237191518158245, 9.650071452152462],
            [-6.230493513260823, 9.650657743748884],
            [-6.22605494758871, 9.648816375683388],
            [-6.219389480475306, 9.640644438892819],
            [-6.216511983797927, 9.638550169470617],
            [-6.211402116073966, 9.638561391930576],
            [-6.204989863450529, 9.640472641527161],
            [-6.201006528289584, 9.644013820303092],
            [-6.199959419455405, 9.647122275945831],
            [-6.199785320878287, 9.66662891438149],
            [-6.196249954308414, 9.670161614616948],
            [-6.191425157359308, 9.668199468272721],
            [-6.189892875595636, 9.665593560800541],
            [-6.18897654290832, 9.656590610792334],
            [-6.186320115478145, 9.652683615806653],
            [-6.178127433047629, 9.647415669421068],
            [-6.174727955306084, 9.644202391285523],
            [-6.173987711170831, 9.63958022666829],
            [-6.170695257043972, 9.63838038901777],
            [-6.16508904560855, 9.63954254954024]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.79540840597734,
          "lat": 47.64522220930148
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30055"],
        "coty_name": ["McCone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCone County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01716270"
      },
      "bbox": [
        -6.557275949782978, 8.74414978064773, -5.724000673761086,
        9.731319469282019
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.327353199444698, 9.97040665394225],
            [-11.233451035071429, 9.953390398928118],
            [-11.234289050500154, 9.948912765159529],
            [-11.113098797541037, 9.927025559197222],
            [-11.112100869465749, 9.924419632875738],
            [-11.10545386990553, 9.917862499962332],
            [-11.105022227788721, 9.906074624324823],
            [-11.100655128328931, 9.902487175425906],
            [-11.099771481638262, 9.89973462543665],
            [-11.101781833933126, 9.890210001914706],
            [-11.106617861771015, 9.888526139698111],
            [-11.107468853561555, 9.875952493696252],
            [-11.11027571322812, 9.873109525978672],
            [-11.110696808054874, 9.85554628348661],
            [-11.109015443817679, 9.851717427889225],
            [-11.113092810831077, 9.847664028419896],
            [-11.11001721602026, 9.839741917823599],
            [-11.110175958726053, 9.832532138738593],
            [-11.112944736905721, 9.83076195218271],
            [-11.111882138921398, 9.82224985979413],
            [-11.108271827107503, 9.820289733795056],
            [-11.105371403100227, 9.815071446533313],
            [-11.101968123907378, 9.814001699597906],
            [-11.098345757592783, 9.810091413227122],
            [-11.09487820965424, 9.812921656786449],
            [-11.089912930538304, 9.813492527806323],
            [-11.082632653567847, 9.808626047970398],
            [-11.078764889738208, 9.808185043972555],
            [-11.075169493350248, 9.81387415931228],
            [-11.129921830584571, 9.515842562091315],
            [-11.123446834369792, 9.514680253173808],
            [-11.123880686792656, 9.512331937520475],
            [-11.03861086665347, 9.497145222312467],
            [-10.953345261903836, 9.48193494808401],
            [-10.991056642949392, 9.274668760096597],
            [-10.999005614337788, 9.228560182691155],
            [-11.01366174651483, 9.14799265151084],
            [-10.927511787078426, 9.13281039954359],
            [-10.927070082464848, 9.13526766145832],
            [-10.837428617299786, 9.119731255150455],
            [-10.848207975717251, 9.059221581851967],
            [-10.86056297048127, 8.98915208215269],
            [-10.775978086190126, 8.97454757076647],
            [-10.783283191690645, 8.932347963422007],
            [-10.722383316941, 8.921800959318647],
            [-10.720403240749778, 8.91794764898407],
            [-10.720354426827154, 8.910573154262735],
            [-10.71691678287512, 8.906941827876816],
            [-10.71656190478854, 8.900992492600986],
            [-10.719165377193109, 8.89918187635851],
            [-10.713357778331773, 8.891924165461417],
            [-10.714344349742872, 8.878755745405604],
            [-10.712250758207832, 8.869264007248738],
            [-10.718323098267282, 8.864151356311774],
            [-10.718947768291939, 8.856788027595973],
            [-10.724238188913871, 8.853700449768162],
            [-10.727183365188411, 8.847716509654981],
            [-10.733348146915668, 8.842723736141583],
            [-10.733002164722086, 8.838751833073115],
            [-10.730278333690027, 8.83416465487785],
            [-10.730233763961065, 8.824375919222968],
            [-10.731633574176543, 8.816852531262914],
            [-10.728696143423614, 8.809947960380477],
            [-10.725170305157821, 8.797539528394953],
            [-10.728232211271632, 8.793315048031902],
            [-10.72804377321405, 8.786503395612304],
            [-10.73382417928033, 8.784516922027557],
            [-10.737254059577626, 8.7788743080969],
            [-10.736578943376424, 8.769568477849104],
            [-10.739168064118557, 8.762405232495947],
            [-10.73772337831418, 8.758437485883178],
            [-10.744107928819279, 8.750486473444461],
            [-10.742238213609305, 8.746646611117956],
            [-10.744603022895967, 8.73713139458765],
            [-10.74445745299318, 8.731142874963332],
            [-10.747195318059722, 8.72914704903006],
            [-10.748446620053913, 8.723609543704285],
            [-10.746324166047028, 8.720120966022986],
            [-10.758622351357378, 8.715673616664498],
            [-10.759435080376965, 8.709674311614934],
            [-10.762056526146448, 8.70602285149852],
            [-10.759985327664252, 8.703299637910147],
            [-10.759366206244238, 8.694724252191202],
            [-10.755360100450932, 8.692730086789805],
            [-10.757165623704644, 8.690254953920324],
            [-10.765630673516814, 8.685334293086948],
            [-10.76979608303986, 8.682006164950092],
            [-10.776096986207168, 8.679171669932508],
            [-10.779579755829984, 8.673238964413923],
            [-10.782687077370852, 8.67132366007668],
            [-10.78338186022139, 8.66790835567346],
            [-10.7884164602921, 8.6622739595777],
            [-10.792401535768718, 8.661974780909622],
            [-10.804488390105615, 8.66704218101719],
            [-10.81291536880775, 8.664757177763722],
            [-10.818342865714795, 8.666840700239856],
            [-10.822037264831033, 8.669953225886008],
            [-10.824765635815925, 8.670027020911002],
            [-10.828300174745111, 8.665657837085439],
            [-10.83584174471205, 8.662019705457945],
            [-10.834745681505701, 8.656687760775448],
            [-10.842981272923673, 8.655566057473546],
            [-10.845299620951481, 8.651810985782724],
            [-10.844896654708359, 8.644368733826868],
            [-10.848934108687255, 8.643150599279206],
            [-10.85299931025435, 8.639351589811946],
            [-10.860148996986217, 8.64135758991439],
            [-10.863462686851802, 8.64010123104847],
            [-10.86499138150653, 8.633689712221283],
            [-10.86493850001671, 8.624437403246572],
            [-10.868937954105798, 8.619956323860695],
            [-10.876126912290477, 8.621130586615068],
            [-10.880118288304944, 8.63386546146804],
            [-10.888569850206542, 8.634401812149099],
            [-10.8915470676673, 8.637254553692221],
            [-10.896997742005425, 8.637960981098054],
            [-10.899244084384518, 8.632359771178876],
            [-10.902721761586534, 8.627072059421817],
            [-10.908471392502182, 8.63057383251506],
            [-10.912627632898577, 8.62888290926807],
            [-10.91725398857639, 8.630010579343034],
            [-10.92144771771863, 8.63528018797938],
            [-10.922828952363071, 8.631265346434004],
            [-10.93040744791678, 8.624688327508673],
            [-10.93175497740315, 8.621119082994394],
            [-10.937691139324471, 8.617034791357666],
            [-10.94233488328714, 8.61119451853481],
            [-10.952143777550514, 8.610400043930548],
            [-10.95198208768985, 8.608059213546507],
            [-10.95519339595935, 8.602584741700696],
            [-10.949632322653082, 8.593391883795423],
            [-10.948341739618305, 8.582483199833115],
            [-10.951108298523955, 8.571002714381581],
            [-11.018628894106334, 8.583131572490773],
            [-11.0861520242156, 8.595246608935035],
            [-11.177737908200072, 8.610962402847413],
            [-11.191772624138862, 8.61409582272368],
            [-11.277111613143765, 8.629579515010223],
            [-11.260386986532588, 8.720363688181797],
            [-11.25396763977833, 8.755571729038724],
            [-11.253485230516674, 8.755485338417099],
            [-11.238206108833175, 8.839972232505062],
            [-11.239553216921642, 8.840215435811594],
            [-11.229272080321806, 8.896604556843817],
            [-11.195061703056012, 9.084154604162348],
            [-11.200538358795821, 9.08624764627005],
            [-11.20512572343128, 9.082454905178894],
            [-11.20983433756087, 9.080657746898966],
            [-11.211254102706826, 9.08286286680242],
            [-11.221420634808581, 9.078245076280263],
            [-11.224700190425253, 9.074501575145002],
            [-11.229299051928942, 9.074950689372734],
            [-11.231189085191813, 9.076958818998799],
            [-11.23672476205096, 9.077086643844277],
            [-11.238596435759108, 9.075118797394566],
            [-11.251073396743099, 9.072049599746439],
            [-11.25376919456904, 9.077363509301968],
            [-11.257245408300323, 9.079611788251494],
            [-11.260282016740653, 9.086310230872174],
            [-11.268487798231286, 9.08982843340995],
            [-11.271741295930605, 9.092716449049204],
            [-11.27977044876036, 9.09186627761986],
            [-11.282333107503451, 9.097935429916832],
            [-11.289889418132041, 9.0963903043904],
            [-11.291908136026077, 9.099849697691507],
            [-11.290764514860424, 9.111033290530433],
            [-11.284175644843742, 9.116419045057944],
            [-11.285658162754117, 9.12586848986864],
            [-11.289415215274298, 9.128064300156053],
            [-11.292155474788226, 9.134171157434094],
            [-11.29717424581287, 9.13687623165839],
            [-11.300179607520011, 9.140369708521403],
            [-11.304026201959843, 9.14746973538519],
            [-11.31178763114172, 9.152934448298332],
            [-11.314812008795188, 9.153719577774362],
            [-11.315792286931737, 9.158505021613683],
            [-11.321148994385123, 9.172733454697639],
            [-11.319067941661997, 9.176676354281783],
            [-11.318536698217422, 9.18464548294547],
            [-11.322331737007863, 9.19207332116856],
            [-11.326004244116604, 9.192277880738487],
            [-11.328718346760294, 9.197405994044358],
            [-11.331546044434177, 9.198050560849662],
            [-11.338111896473755, 9.192046868283043],
            [-11.341591813566673, 9.187771717885393],
            [-11.353210452484843, 9.184041309935882],
            [-11.348719569734293, 9.208483881915798],
            [-11.35643154153196, 9.209845827121613],
            [-11.332947864187519, 9.336689974979512],
            [-11.309529518647851, 9.460931139226657],
            [-11.293838922647096, 9.545460134555723],
            [-11.365863469737862, 9.558224622562769],
            [-11.403779536086972, 9.565058946244116],
            [-11.38937957789873, 9.64130285649631],
            [-11.373391643745572, 9.726141847131618],
            [-11.327353199444698, 9.97040665394225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.93610772310456,
          "lat": 46.85642799230308
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30077"],
        "coty_name": ["Powell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Powell County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01720021"
      },
      "bbox": [
        -11.403779536086972, 8.571002714381581, -10.712250758207832,
        9.97040665394225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5816211342214999, 2.0448414677943108],
            [-1.4557629908251413, 2.0411160037194533],
            [-1.3236566447610076, 2.0374215476192346],
            [-1.2520802046940063, 2.0355452420338684],
            [-1.2485120615751872, 2.035466723360534],
            [-1.2507579750819373, 1.947772094090502],
            [-1.2528221876489587, 1.8598380583769636],
            [-1.2555486616806553, 1.7358161874612712],
            [-1.2560952625259585, 1.7243604492265259],
            [-1.2569143416840396, 1.6847623539502514],
            [-1.3355969811487032, 1.6866132953093633],
            [-1.4218131841090484, 1.6889698883798534],
            [-1.5435053154288298, 1.6921508235248912],
            [-1.5935875062249956, 1.6936643043864172],
            [-1.59283501574008, 1.7228510508652455],
            [-1.589741632478791, 1.8321978076286307],
            [-1.5892379963363776, 1.8451287394941507],
            [-1.5862418662768074, 1.9565656243047025],
            [-1.5841068895100212, 2.035705106718273],
            [-1.5838620668969026, 2.0448935448523464],
            [-1.5816211342214999, 2.0448414677943108]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.50121004715264, "lat": 40.52447366337475 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00835823"
      },
      "bbox": [
        -1.5935875062249956, 1.6847623539502514, -1.2485120615751872,
        2.0448935448523464
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.2834641620154668, 3.6826213933802596],
            [-0.2823409947162015, 3.76971934135507],
            [-0.28069154601721047, 3.7696786386872425],
            [-0.2806657814634271, 3.798854498067818],
            [-0.2801557167815793, 3.848049612142325],
            [-0.2797696979721166, 3.85708090444218],
            [-0.2790287038058244, 3.9443850244072913],
            [-0.27866458910789055, 3.977081829365018],
            [-0.27765805222460205, 4.019754666705543],
            [-0.2776099516059527, 4.0944741462768715],
            [-0.26084378252071977, 4.092171988216643],
            [-0.25307998505913554, 4.093168258265501],
            [-0.24809815644735042, 4.0908763122081995],
            [-0.24342576593127896, 4.086771537529242],
            [-0.23798130612553567, 4.073013413830347],
            [-0.23806708549915354, 4.068945932420319],
            [-0.2414797815436975, 4.059473733799642],
            [-0.23986480743611524, 4.052981269924945],
            [-0.234279640972145, 4.051454750017987],
            [-0.22093203321863428, 4.051742628263625],
            [-0.21787096925204763, 4.055936662039786],
            [-0.2067144683616991, 4.063902946670662],
            [-0.19831061779033698, 4.06577737668773],
            [-0.18382465300691392, 4.057032498577222],
            [-0.1735718057712307, 4.055807801711719],
            [-0.1645819208281535, 4.052415234942305],
            [-0.1522341343881237, 4.0435003094362925],
            [-0.14213983069607308, 4.039815755900775],
            [-0.13476762036141327, 4.03908254859749],
            [-0.12513660979383304, 4.0353672820740485],
            [-0.12184361986345534, 4.02993995886377],
            [-0.12090010002053926, 4.0154512278017656],
            [-0.12245318008117316, 4.003310516979624],
            [-0.12160316411746233, 4.000815148229875],
            [-0.11597258073092938, 3.997020124545856],
            [-0.10499460150540484, 3.9938872683938236],
            [-0.09468190897719815, 3.992792029588207],
            [-0.08529284402302256, 3.9951012388007383],
            [-0.08214288886502406, 3.996946421266265],
            [-0.07373937618571245, 3.997825549702294],
            [-0.06830737426618885, 3.997500779412322],
            [-0.04615926545321859, 3.9895671711118688],
            [-0.03891619484078713, 3.983474936786826],
            [-0.03843834860817618, 3.98011590371818],
            [-0.04001573154981379, 3.974403755318826],
            [-0.04260103138535288, 3.9723737693762806],
            [-0.0534662609177821, 3.9556667843364846],
            [-0.0564671038655565, 3.947716540860573],
            [-0.05630487961392704, 3.938432494562798],
            [-0.05302088996408388, 3.9296590733132715],
            [-0.03805640471128307, 3.9079961116883077],
            [-0.03093514282135101, 3.901575972770721],
            [-0.018385593281414314, 3.896293392708504],
            [-0.010652011873767705, 3.8906691043539214],
            [-0.003318364172046383, 3.881666685525558],
            [-0.0013687803948235, 3.877316180379063],
            [0.00005211894756717401, 3.8698475484454544],
            [-0.00001915825696584888, 3.861587434641478],
            [0.0012834820780124288, 3.8538823264088857],
            [-0.06516142097915685, 3.8546888293656774],
            [-0.06521927907542106, 3.8073520109836307],
            [-0.06562293496480899, 3.7671317460517946],
            [-0.0686985201185532, 3.7670978775515156],
            [-0.06891175654877402, 3.760510864094357],
            [-0.06922845060285343, 3.6804320732357607],
            [-0.07030361736511886, 3.606983013853576],
            [-0.0700629307736919, 3.593013540899822],
            [-0.09516197843205555, 3.5931571885798785],
            [-0.14085401346751097, 3.593778076660154],
            [-0.24162250613137778, 3.5947219650987305],
            [-0.28435752635666983, 3.5953264165443812],
            [-0.2834641620154668, 3.6826213933802596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.86774167972656, "lat": 42.49312020773634 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31051"],
        "coty_name": ["Dixon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dixon County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00835847"
      },
      "bbox": [
        -0.28435752635666983, 3.593013540899822, 0.0012834820780124288,
        4.0944741462768715
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5719880347180533, 2.395152342934995],
            [-1.5570534945254983, 2.394631722154426],
            [-1.5058312881712255, 2.3933248652717],
            [-1.4152326775904676, 2.390744829884316],
            [-1.3432966661496, 2.388640084588819],
            [-1.3147516121141283, 2.387692901239799],
            [-1.2468780785203337, 2.3862771698789627],
            [-1.2432822182038006, 2.3861827253844208],
            [-1.2465082681895991, 2.258400945372421],
            [-1.2477483768096655, 2.207218917705169],
            [-1.2504516752945551, 2.10135230634067],
            [-1.2520802046940063, 2.0355452420338684],
            [-1.3236566447610076, 2.0374215476192346],
            [-1.4557629908251413, 2.0411160037194533],
            [-1.5816211342214999, 2.0448414677943108],
            [-1.5793543011252114, 2.1328966739762114],
            [-1.5769505857919255, 2.2205708770077672],
            [-1.574388866103663, 2.308097037893526],
            [-1.5738376405577146, 2.32275183291788],
            [-1.5719880347180533, 2.395152342934995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.50219054670295,
          "lat": 40.872588269460174
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31079"],
        "coty_name": ["Hall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hall County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00835861"
      },
      "bbox": [
        -1.5816211342214999, 2.0355452420338684, -1.2432822182038006,
        2.395152342934995
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.062596329128302, 2.466932580043449],
            [-4.048756299630577, 2.4653003009349774],
            [-3.920688103515568, 2.4572549732846998],
            [-3.892035911636759, 2.4552175228746203],
            [-3.8640260278566116, 2.4537959741995286],
            [-3.785167570257765, 2.4492910652984627],
            [-3.7781723981865234, 2.4491356130110153],
            [-3.7348634606944144, 2.445909074382151],
            [-3.6990012309657225, 2.44360998999451],
            [-3.662984860908147, 2.4415471674076796],
            [-3.6344803586213215, 2.440291551966684],
            [-3.608037996196144, 2.4387315858515017],
            [-3.592247297933789, 2.43733540102255],
            [-3.549165815377342, 2.4362201974307345],
            [-3.463563328780151, 2.4313839840670908],
            [-3.465126919009905, 2.386637180149341],
            [-3.468192333850229, 2.327650645145712],
            [-3.467938628685627, 2.3276366328103717],
            [-3.4790985428327046, 2.1232764746887383],
            [-3.4933676080543665, 2.1239206888848874],
            [-3.5521845148605515, 2.127644643292366],
            [-3.6232482117029297, 2.1316348849383933],
            [-3.6653927309458116, 2.1345875866379833],
            [-3.7641040071649803, 2.1419318177626896],
            [-3.845354310170701, 2.146179759884371],
            [-3.9508245347928366, 2.1516249430599994],
            [-3.979679280995197, 2.153647193841678],
            [-4.081981378916376, 2.1588681966171275],
            [-4.078561452865083, 2.2112145535903447],
            [-4.07171793487654, 2.320096140397247],
            [-4.065284251078055, 2.422445103804438],
            [-4.0626598904326165, 2.4654257708940404],
            [-4.062596329128302, 2.466932580043449]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.64966357404894,
          "lat": 40.85094457034984
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31135"],
        "coty_name": ["Perkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perkins County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00835889"
      },
      "bbox": [
        -4.081981378916376, 2.1232764746887383, -3.463563328780151,
        2.466932580043449
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.45604373546397997, 1.574526498615888],
            [0.5407376250046346, 1.5743070936771177],
            [0.5980994373096634, 1.5748039035059198],
            [0.7120958889546573, 1.575599447570905],
            [0.7574489174417212, 1.5753538375483647],
            [0.8022110484990981, 1.5757482809431884],
            [0.808824052984977, 1.5745522492215482],
            [0.8157333402170645, 1.5708196229173321],
            [0.8236697485746419, 1.564984779488845],
            [0.8297802651647489, 1.5630568948395964],
            [0.8364475953488241, 1.5627895611654932],
            [0.8469509972997118, 1.5635225469012373],
            [0.8525664195092951, 1.5618027381083532],
            [0.8590193092918336, 1.556688906216922],
            [0.8628034897336578, 1.55001049585885],
            [0.8649906021674207, 1.5417820978942582],
            [0.8647670768910526, 1.5353245092891579],
            [0.8622329846444409, 1.5272159775208352],
            [0.8588700090387533, 1.5223165167818344],
            [0.8556055605021847, 1.514253518685919],
            [0.855484330807338, 1.5057960919117714],
            [0.8602647703050363, 1.4954377975022106],
            [0.8642660713210784, 1.4903377693905466],
            [0.8721156578664391, 1.4825774916065142],
            [0.8765434037545479, 1.4799841178945083],
            [0.8857273021697721, 1.4766924445964398],
            [0.8906545363837198, 1.4721408734254402],
            [0.8926024990671401, 1.4663169439403467],
            [0.8929828740982337, 1.4594386106750505],
            [0.8948111221008516, 1.451679157691287],
            [0.8995746299685021, 1.4460123958994735],
            [0.9038264941569694, 1.4438401601028303],
            [0.9111832879037454, 1.443346801031995],
            [0.9194002690497256, 1.43973346583115],
            [0.923477863983118, 1.4324891585245523],
            [0.9237456303571525, 1.4243833036288953],
            [0.9206887111234444, 1.4183191975278346],
            [0.9128167484273169, 1.4110538041875058],
            [0.9105438698695386, 1.40448347306417],
            [0.9122803253727804, 1.3920122179113723],
            [0.9112483410330083, 1.3871251215301097],
            [0.9048594205640057, 1.3792057832259559],
            [0.902406972183949, 1.3715670373776536],
            [0.9042313905342889, 1.3609751732405946],
            [0.9086418810549124, 1.3508954971077527],
            [0.9169787165862456, 1.3430207148111672],
            [0.9254524294026764, 1.3395343070535302],
            [0.9319549439232736, 1.3396306981643145],
            [0.9463226667682222, 1.344150321223062],
            [0.9517149098771706, 1.344210810472136],
            [0.9595548089216596, 1.3409854176386935],
            [0.9674583669591355, 1.3317907080582743],
            [0.97335740159247, 1.3283544808946126],
            [0.9813330283693655, 1.3259485385753995],
            [0.9857658049515485, 1.3221254633122146],
            [0.9888107714647052, 1.3126668445997582],
            [0.9648193350697478, 1.312497279126912],
            [0.8708107702237623, 1.3120077468409725],
            [0.7991405509988933, 1.3117468061249327],
            [0.7119617327859391, 1.311525349643434],
            [0.6245830104186828, 1.3113939468161748],
            [0.5529151905848424, 1.311287943345694],
            [0.4556344911736761, 1.3114027947412705],
            [0.45581086295942896, 1.4240946602418614],
            [0.4559495329372769, 1.4868445424741195],
            [0.45604373546397997, 1.574526498615888]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.71757370863934, "lat": 40.12504351107232 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31147"],
        "coty_name": ["Richardson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richardson County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00835895"
      },
      "bbox": [
        0.4556344911736761, 1.311287943345694, 0.9888107714647052,
        1.5757482809431884
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.192502563150072, -0.23275590827990741],
            [-15.071429912847096, -0.2585655111074752],
            [-15.069177384124863, -0.24750038318445974],
            [-14.76460137126432, -0.310210652177098],
            [-14.460029077612383, -0.3729384170836705],
            [-14.341938045362374, -0.3967571656094357],
            [-14.309594898193739, -0.40309446149017214],
            [-14.311339169469553, -0.4126474559934234],
            [-13.849864751969404, -0.5039250145326467],
            [-13.796716749519796, -0.5141985528730624],
            [-13.757924611240085, -0.5219156821934922],
            [-13.770923108613234, -0.5918771932105353],
            [-13.786376501987917, -0.675057426312751],
            [-13.798205341827686, -0.7435636002068853],
            [-13.819596509749605, -0.8668393526889139],
            [-13.823238922984158, -0.8932359166148685],
            [-13.828982142152695, -0.9244466165791156],
            [-13.840491802104612, -0.9827440866317197],
            [-13.850808980302686, -1.0298015238559575],
            [-13.853398778339065, -1.0460457884752514],
            [-13.858965625471102, -1.0693198497683372],
            [-13.862481124786884, -1.0875839729555754],
            [-13.866318161439175, -1.1138697570516558],
            [-13.87651895431457, -1.1670320709458832],
            [-13.888289432347191, -1.1696171727719826],
            [-13.898568268305281, -1.1788889842992292],
            [-13.914031177521608, -1.2041522710854888],
            [-13.924718051405584, -1.2153562658279322],
            [-13.93202473795297, -1.23088459741404],
            [-13.940488842507442, -1.2307144695846106],
            [-13.948907851899442, -1.2337678262674174],
            [-13.953274568533566, -1.2384040582507383],
            [-13.954154944302267, -1.2440243158435396],
            [-13.950342777115683, -1.2488777885877438],
            [-13.948513601371625, -1.2533752621116463],
            [-13.956521073492762, -1.2621311174596546],
            [-13.961919988554214, -1.2716323808459407],
            [-13.969450703516946, -1.280248071721913],
            [-13.975776938479939, -1.2919066153455536],
            [-13.976494817696175, -1.3013861198610277],
            [-13.9804635807924, -1.3074876615463735],
            [-13.986061650535625, -1.3094050378758602],
            [-13.98838682281413, -1.3161938069515349],
            [-13.993485213540177, -1.3194179521493266],
            [-14.00302747442388, -1.3137498038116584],
            [-14.010002906841478, -1.3125040290885113],
            [-14.0254197911247, -1.3164389232222344],
            [-14.04271028427811, -1.3184166082122588],
            [-14.054183276553331, -1.3164249094351106],
            [-14.060018647868977, -1.3171123537663796],
            [-14.066407331883, -1.3134539299649886],
            [-14.079583475873852, -1.3003391649352964],
            [-14.08175930113773, -1.2964271131265945],
            [-14.083543072701987, -1.2878985691577463],
            [-14.082491385267028, -1.283854608683023],
            [-14.083153702192224, -1.279014532746526],
            [-14.088840045372683, -1.2776035063288702],
            [-14.097921394130331, -1.2710115714757932],
            [-14.099170372553502, -1.2666674254465395],
            [-14.103587072846906, -1.2628675499822901],
            [-14.11307986793565, -1.2607062179796238],
            [-14.114510148657258, -1.257484862355532],
            [-14.111851272696573, -1.2522523791968203],
            [-14.10728513765742, -1.2494880318325403],
            [-14.103538890975036, -1.2441445666482946],
            [-14.104379979308117, -1.236879594409182],
            [-14.117090372106714, -1.210738399222784],
            [-14.121441943143964, -1.2085695678179305],
            [-14.127341391545084, -1.195399615492929],
            [-14.136488978031096, -1.1840252486170026],
            [-14.142420016871107, -1.1676168604189872],
            [-14.14560261630621, -1.1659297209376023],
            [-14.151538170908086, -1.1671430939579914],
            [-14.163938560188058, -1.1601377944501299],
            [-14.172158273426154, -1.157291244068634],
            [-14.177322145305734, -1.158208647787012],
            [-14.18500486615514, -1.16469481413549],
            [-14.203484176826413, -1.173156971318667],
            [-14.20606966203864, -1.1722077099542967],
            [-14.208984332637012, -1.1665584251587582],
            [-14.211073770543734, -1.1588723091988034],
            [-14.216363043429464, -1.156121727320336],
            [-14.220474434579849, -1.1561418412295128],
            [-14.234158683455405, -1.1628785695002208],
            [-14.246559389245434, -1.1636322139814868],
            [-14.251052477250616, -1.162154076336719],
            [-14.253465995414876, -1.158875339958863],
            [-14.251196458071094, -1.1527122113871608],
            [-14.244978820951031, -1.1494534143333184],
            [-14.244791125945836, -1.1455653930949308],
            [-14.249313819438003, -1.1393281871560326],
            [-14.253949796176624, -1.1373009034714325],
            [-14.26598017827144, -1.1380579425512547],
            [-14.273344245137505, -1.132475743677966],
            [-14.281015742706469, -1.1320575560498967],
            [-14.285891946052336, -1.1293716304817996],
            [-14.29072761041468, -1.1299070347078866],
            [-14.298475299896797, -1.1281912112345194],
            [-14.305998751302893, -1.1312275225981587],
            [-14.320271531980143, -1.1337120479933762],
            [-14.33334800944548, -1.1413860959391826],
            [-14.337502266748125, -1.1425220125761837],
            [-14.341130745376972, -1.1396354555900823],
            [-14.342609224893492, -1.1338018243369232],
            [-14.346820553698016, -1.1277455418477893],
            [-14.353144437632432, -1.1333481949098745],
            [-14.355789069545684, -1.1332612171828913],
            [-14.372085590711574, -1.1413392152008281],
            [-14.378502788325584, -1.1481162595512746],
            [-14.384475057569977, -1.1472738401105282],
            [-14.391882810941006, -1.1520656707831192],
            [-14.394298923238075, -1.1523337245785414],
            [-14.402264211880553, -1.1473147634033576],
            [-14.410993950598291, -1.149828918045709],
            [-14.421765841527405, -1.1483621406603652],
            [-14.437235676410715, -1.148689987993091],
            [-14.447258999966857, -1.1542638261337266],
            [-14.453543402084609, -1.160717783782273],
            [-14.45575272445436, -1.1652250149639147],
            [-14.454013212632068, -1.1714352997321051],
            [-14.449559941725552, -1.1810432038070993],
            [-14.446377811119099, -1.1940939292120938],
            [-14.446947833483726, -1.1992043802227392],
            [-14.45382758181285, -1.205892679826647],
            [-14.454667658023572, -1.211658144410533],
            [-14.453487718675932, -1.2142862515895743],
            [-14.447576165358816, -1.2155068151279518],
            [-14.441877872671695, -1.2230217085254484],
            [-14.442041255747874, -1.2271718069145436],
            [-14.448087106587144, -1.2320371114584305],
            [-14.458654908503123, -1.2380847554850851],
            [-14.462139256160158, -1.2443920045466659],
            [-14.462327926797004, -1.2591951006649837],
            [-14.466781273896308, -1.2655206335276317],
            [-14.466162319665727, -1.275356516460739],
            [-14.460447213334369, -1.2903603040577398],
            [-14.46067721741266, -1.2929494127335357],
            [-14.45275099287421, -1.3230931645445567],
            [-14.449552941294204, -1.3276413872867334],
            [-14.453440013463702, -1.3430671604317028],
            [-14.449030579766378, -1.3547905535513205],
            [-14.434849800188921, -1.375170230694411],
            [-14.431462969766752, -1.3827251782330705],
            [-14.425389160619975, -1.3883834268114013],
            [-14.425805629716596, -1.3929079827868762],
            [-14.432182089455138, -1.395887052227187],
            [-14.442242057463005, -1.3957366740112391],
            [-14.450593047850187, -1.3988294709462357],
            [-14.453716068681146, -1.4025259228501021],
            [-14.461353789714174, -1.402925687313595],
            [-14.464368101456948, -1.405995379249027],
            [-14.462653877358834, -1.4148086172041852],
            [-14.458782552421933, -1.424331194008799],
            [-14.460212709846502, -1.427691958003545],
            [-14.468941192212505, -1.440514810338474],
            [-14.474695518962157, -1.4438939969452325],
            [-14.477218899012524, -1.447505672279994],
            [-14.469971736617937, -1.465409077317668],
            [-14.476104238446618, -1.4858904789167329],
            [-14.47419324790384, -1.499746206212506],
            [-14.479853531003394, -1.52155630612222],
            [-14.490600583304625, -1.5419705315858454],
            [-14.491255290704352, -1.5454092076398351],
            [-14.48952517215964, -1.5531627932770173],
            [-14.4862196241593, -1.5585866816083755],
            [-14.477185703764583, -1.5684904623979328],
            [-14.476478069756226, -1.5732852786030065],
            [-14.47887668578364, -1.5788327381614666],
            [-14.487766919864086, -1.590462884799357],
            [-14.489742355625136, -1.6053723019053974],
            [-14.482425635172417, -1.6155768795735568],
            [-14.477996050784274, -1.6305670616152224],
            [-14.477146818658557, -1.6365628540683115],
            [-14.47245963481119, -1.6404123774166033],
            [-14.469399480659169, -1.650032157551917],
            [-14.472707903526405, -1.662947687059883],
            [-14.478596542359744, -1.6721767026882421],
            [-14.482827834664871, -1.6729118456547278],
            [-14.492376693195192, -1.6764421381560817],
            [-14.492754070691543, -1.678716845996118],
            [-14.48842202758123, -1.683741382177861],
            [-14.486141554131759, -1.6936215494143352],
            [-14.488759448190429, -1.7179683008592275],
            [-14.48720123905239, -1.722997822055845],
            [-14.487814693079827, -1.7270814725641725],
            [-14.495205897164444, -1.7360385918470438],
            [-14.501470171553995, -1.737506319641908],
            [-14.507457993594315, -1.7431550972197611],
            [-14.511473346586117, -1.7568752512190269],
            [-14.511192675898563, -1.7674419200410503],
            [-14.509367218319369, -1.7744279645777623],
            [-14.51179463782313, -1.7814233448205936],
            [-14.507458278062977, -1.789307490740426],
            [-14.509883722497591, -1.7975719810698167],
            [-14.508412977098583, -1.8028213055447302],
            [-14.509494908307158, -1.8096594236914239],
            [-14.504296486137555, -1.8229544384191225],
            [-14.504290780449189, -1.8281496504248034],
            [-14.487865231608023, -1.8531807543856798],
            [-14.48571688184163, -1.866741947586778],
            [-14.486475779306199, -1.8837958230811698],
            [-14.483294716822314, -1.8947185079101825],
            [-14.481256491437275, -1.9071133357281997],
            [-14.47957255592661, -1.942616961785443],
            [-14.48678120807353, -1.9692323699092937],
            [-14.485326385158428, -2.005058968087924],
            [-14.48792226633216, -2.0356581701516676],
            [-14.488198669830508, -2.0479427917478854],
            [-14.489969984966152, -2.0583364268670628],
            [-14.486628516071827, -2.0628430110281473],
            [-14.485509802084737, -2.0685179261118254],
            [-14.486571179781123, -2.085891328301278],
            [-14.490946766194673, -2.1067724946394115],
            [-14.498065053088359, -2.124297137539374],
            [-14.497843678315443, -2.1287952939717494],
            [-14.50445524740983, -2.13853017669192],
            [-14.510805374926663, -2.141150368921061],
            [-14.521377307582853, -2.1424500288463713],
            [-14.540234791635797, -2.1393145812051015],
            [-14.549722351596433, -2.14160550208369],
            [-14.561521778483016, -2.1507562091172776],
            [-14.564229372857973, -2.154361945742996],
            [-14.562159821051353, -2.160290290314105],
            [-14.54752881215524, -2.171209094160921],
            [-14.541160995981802, -2.178232217765809],
            [-14.536101095264739, -2.18772956219732],
            [-14.535870583439902, -2.1941888819958772],
            [-14.53729219763427, -2.1983891309344488],
            [-14.54077686625319, -2.2031289194535053],
            [-14.559833258673399, -2.213961543460822],
            [-14.56545876974115, -2.220176650854599],
            [-14.570824824353997, -2.2285842738304535],
            [-14.573259680163414, -2.2361267830592677],
            [-14.574493989228358, -2.247953720098874],
            [-14.573320821003112, -2.2553274498737936],
            [-14.626808474972037, -2.17464744751381],
            [-14.67145398533461, -2.1068961834177538],
            [-14.696852717382981, -2.0689251316913855],
            [-14.758931362151806, -1.9764192072026208],
            [-14.802733349000764, -1.910526078386655],
            [-14.83362226399363, -1.865072824667007],
            [-14.859307626511551, -1.8261165553192231],
            [-14.871716912282206, -1.8090401836509495],
            [-14.907403092648455, -1.7549027753296282],
            [-14.910357907249384, -1.749356559715874],
            [-14.977344755766865, -1.6483394384825747],
            [-15.03901526617628, -1.5561940611758762],
            [-15.061116099408773, -1.5229850506468638],
            [-15.066210428330317, -1.5143325448694098],
            [-15.121498089559221, -1.4323882376127925],
            [-15.15213524861628, -1.3861707246562538],
            [-15.199578164882334, -1.3144437238590745],
            [-15.200416723648686, -1.3123786877374666],
            [-15.213380053418623, -1.2933924084519708],
            [-15.226382805375513, -1.2732576496415635],
            [-15.277656174536778, -1.1977517121413346],
            [-15.336706094338206, -1.1080059662958381],
            [-15.30904670077681, -0.9783490762303779],
            [-15.293315851362646, -0.9041242675192318],
            [-15.332119908183536, -0.8943828288763348],
            [-15.300583840410674, -0.7475025584458999],
            [-15.279397963651704, -0.6488118916532547],
            [-15.246312727542431, -0.49198416083910096],
            [-15.22474489019462, -0.38903753479391906],
            [-15.192502563150072, -0.23275590827990741]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.01350663482776,
          "lat": 36.21518647332633
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32003"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00863600"
      },
      "bbox": [
        -15.336706094338206, -2.2553274498737936, -13.757924611240085,
        -0.23275590827990741
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.824841840615308, 3.9791208325563066],
            [-14.720633921247838, 3.9562505736890667],
            [-14.616429672456295, 3.933363083082182],
            [-14.511465672092193, 3.9105623354007575],
            [-14.512637593423873, 3.90471398135181],
            [-14.57282312715895, 3.624700011703297],
            [-14.582034022119636, 3.5824006024903285],
            [-14.581729008978074, 3.5673203298367087],
            [-14.582357867719498, 3.466994035346112],
            [-14.58164652324294, 3.4582582666815163],
            [-14.581178029436273, 3.3568569858591233],
            [-14.581040166082404, 3.2819961089392686],
            [-14.581315573022941, 3.280825101781686],
            [-14.580229155907201, 3.0267887743008837],
            [-14.554013159305182, 3.0215264328561453],
            [-14.457151463233764, 3.001127773523641],
            [-14.456736639237251, 2.9993693383829685],
            [-14.450448975762242, 2.9928713320539755],
            [-14.450739417277045, 2.9904812781126107],
            [-14.457118077061828, 2.9854816611814536],
            [-14.454574162089434, 2.978159969103425],
            [-14.457471473258977, 2.9759285007736764],
            [-14.466799671152735, 2.973023859418393],
            [-14.463956169284916, 2.966328426541087],
            [-14.464149811606218, 2.9614682194123048],
            [-14.469260497639162, 2.9590035607113543],
            [-14.46641678127439, 2.9485470417301496],
            [-14.467504916610192, 2.944595918898197],
            [-14.46507661969158, 2.9355695716547627],
            [-14.466585426190763, 2.92615077129946],
            [-14.468151511218093, 2.922504506643366],
            [-14.473568232334665, 2.917411284397809],
            [-14.471795423534305, 2.911591990388193],
            [-14.473462311373895, 2.9069666788649933],
            [-14.472174395291088, 2.8994532771204677],
            [-14.473202069090263, 2.896939541674053],
            [-14.48049387390065, 2.8922663436224223],
            [-14.481053335511806, 2.8853071131010117],
            [-14.479634652579346, 2.8823563378843584],
            [-14.48171719924738, 2.872628439359123],
            [-14.485497662173307, 2.8699571209511334],
            [-14.485828984948643, 2.8600059580059645],
            [-14.48209845507708, 2.8561572411677676],
            [-14.480728616002626, 2.8481696253375834],
            [-14.482202039616555, 2.841322878468134],
            [-14.480741691329504, 2.83811813369313],
            [-14.47936777271902, 2.829022127179265],
            [-14.479555229649767, 2.8215284260334816],
            [-14.484109464963785, 2.8079246359292127],
            [-14.485364446100698, 2.8061467680456174],
            [-14.48285114390415, 2.7974711486417894],
            [-14.480519388974962, 2.795674186708048],
            [-14.479532988849996, 2.7863476908801648],
            [-14.47785949500461, 2.7839965232472785],
            [-14.479740781654316, 2.7768189970340535],
            [-14.482262137210869, 2.7757864374565915],
            [-14.48474368409506, 2.7713938757741334],
            [-14.485179200495374, 2.761911984935834],
            [-14.483965178856778, 2.757375553930755],
            [-14.485000366659644, 2.7526134807494613],
            [-14.484237417765693, 2.748826571666826],
            [-14.488457923386228, 2.7430061134787924],
            [-14.488688071205525, 2.7399801009501235],
            [-14.485431580708733, 2.736294060761416],
            [-14.484747824913752, 2.723922335044282],
            [-14.488189273430878, 2.721256881413825],
            [-14.491337280603123, 2.7128994595728204],
            [-14.491375623140943, 2.7067581057057875],
            [-14.49590833026947, 2.7051835608573924],
            [-14.501047643650915, 2.699279718313984],
            [-14.50381811459694, 2.6985120770601116],
            [-14.50630722315833, 2.6907067725538347],
            [-14.508303915023257, 2.6889482399682056],
            [-14.507361035102836, 2.6850547446299435],
            [-14.508644772893758, 2.675891966591074],
            [-14.508057700867807, 2.669827172399348],
            [-14.511077646487738, 2.6627200397098787],
            [-14.511385080512673, 2.6564278070058607],
            [-14.514471487294031, 2.653514386904098],
            [-14.516172292202695, 2.641399248593654],
            [-14.515109361549305, 2.6363053764169],
            [-14.520375766243335, 2.6272147328546094],
            [-14.523651698999027, 2.62298922367564],
            [-14.528191064166014, 2.6218618869725634],
            [-14.530908444236847, 2.61761841564309],
            [-14.53370701929741, 2.6162304320502816],
            [-14.539065550738464, 2.607935706920051],
            [-14.541753489266798, 2.5966921492590824],
            [-14.540078393621057, 2.5941610939841],
            [-14.542271605564606, 2.589668609025373],
            [-14.541030002566693, 2.582138839465296],
            [-14.543299062266453, 2.5751711696417483],
            [-14.541373636144938, 2.5636193509237306],
            [-14.542969109000028, 2.558413734747281],
            [-14.543570041699361, 2.547910309018545],
            [-14.545850509495997, 2.5436440819027197],
            [-14.547010689281908, 2.5337080882621743],
            [-14.55232521676368, 2.524813303500875],
            [-14.551614353309118, 2.5202668913694226],
            [-14.553721651276225, 2.507412840961092],
            [-14.551278827660154, 2.4996914154344823],
            [-14.553214026404863, 2.489899149137156],
            [-14.553470415526048, 2.4795529337999853],
            [-14.552377284736007, 2.4778066532982845],
            [-14.552823192629578, 2.470781372450175],
            [-14.556328893778865, 2.4636966498668564],
            [-14.558487555176756, 2.462760363944979],
            [-14.56220708959593, 2.4569279599287923],
            [-14.571228981114563, 2.450670839814284],
            [-14.575807671522087, 2.4442906130376327],
            [-14.579077422855637, 2.437848911922942],
            [-14.57632154865044, 2.433029932651918],
            [-14.577207836385025, 2.4250240588804335],
            [-14.5764086537144, 2.422026267410018],
            [-14.578340865333297, 2.4176218352330836],
            [-14.585746114261825, 2.4059509103392833],
            [-14.587519719244584, 2.4045891690707872],
            [-14.591454629182795, 2.3941364247411414],
            [-14.593629370230328, 2.391820447837391],
            [-14.598704279235992, 2.393144462460582],
            [-14.60320413399193, 2.389096273685857],
            [-14.600803567589844, 2.385491811424369],
            [-14.607439526368958, 2.38094657989638],
            [-14.61252141022352, 2.379768584508081],
            [-14.613114158761583, 2.375699001188238],
            [-14.617524028555602, 2.374795369709606],
            [-14.61630060979007, 2.366944561377807],
            [-14.621105818575977, 2.357942391425036],
            [-14.624841362668588, 2.3579703560604446],
            [-14.6262154741995, 2.354563288829118],
            [-14.63004913802239, 2.3556835778927883],
            [-14.63321735858432, 2.3538830889867715],
            [-14.641326457402833, 2.3529838010258595],
            [-14.645493872815276, 2.3464577422769275],
            [-14.64872525740057, 2.3490153511228984],
            [-14.648305773945545, 2.3546965307160814],
            [-14.650254236085132, 2.35833883706497],
            [-14.668701107988076, 2.269965018742882],
            [-14.713328278353792, 2.059676780080388],
            [-14.783796675243016, 2.0746797118628955],
            [-14.784967016484048, 2.074292990094126],
            [-14.877706603750656, 2.0946086836453683],
            [-14.959654940776495, 2.112391037129233],
            [-15.13021292616878, 2.1493570817658605],
            [-15.234251602814526, 2.171924003511973],
            [-15.231090701094898, 2.186399524844474],
            [-15.228165681207136, 2.1858509676549143],
            [-15.185289522597312, 2.3794377070837847],
            [-15.181854975673213, 2.3808872532684475],
            [-15.15858181905222, 2.4865447584510956],
            [-15.125719593885071, 2.635767436595193],
            [-15.12435137679104, 2.6354707224172236],
            [-15.05451356720127, 2.950229458155349],
            [-15.054382453080114, 2.95110670514161],
            [-15.02872382184968, 3.0670948140269263],
            [-15.035819625153216, 3.0686856604551602],
            [-15.035533822500465, 3.0703655185882632],
            [-15.016182612887304, 3.1558641781804377],
            [-15.014527037917622, 3.161634320699239],
            [-15.004892079798843, 3.2012370766428035],
            [-14.981519924835455, 3.296573465338327],
            [-14.977381761628404, 3.3144905554604573],
            [-14.958944737593342, 3.396366507503591],
            [-14.942833265529195, 3.469462450442874],
            [-14.940889550562533, 3.4813594116054074],
            [-14.927348254959698, 3.54406920270912],
            [-14.926498507672093, 3.5506276934435577],
            [-14.899224854176705, 3.6731468843236477],
            [-14.886501022022797, 3.7325050694915616],
            [-14.88571655260214, 3.73442571680582],
            [-14.861627025105642, 3.8457162398094686],
            [-14.859226338032135, 3.858700810823068],
            [-14.843867212633736, 3.927741065471447],
            [-14.836641650214043, 3.926732237483241],
            [-14.824841840615308, 3.9791208325563066]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.26857845492471,
          "lat": 39.98386801766992
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32011"],
        "coty_name": ["Eureka"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eureka County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00858640"
      },
      "bbox": [
        -15.234251602814526, 2.059676780080388, -14.450448975762242,
        3.9791208325563066
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.868746686438715, 7.331251599371573],
            [17.931456188885605, 7.294846777717112],
            [18.021460148147078, 7.2450360141788845],
            [18.037951880681568, 7.235778868936946],
            [18.04315209495362, 7.231524636753895],
            [18.044871404361565, 7.232244563481661],
            [18.108083383169838, 7.198628973988809],
            [18.130917915026806, 7.197750629767899],
            [18.147622424317667, 7.187661183227225],
            [18.15062752723229, 7.19042429092261],
            [18.151995550129417, 7.197704356663995],
            [18.182870594662287, 7.1850810146449025],
            [18.1694679870814, 7.156841152870679],
            [18.18455496724947, 7.120024606016625],
            [18.204933362211065, 7.071448086851616],
            [18.227837956169857, 7.018962831103048],
            [18.232907516632444, 7.008621016570908],
            [18.21726844712961, 6.9725051632375985],
            [18.21142728014154, 6.954263675986758],
            [18.197485083753342, 6.926820100222151],
            [18.10249016935388, 6.965313741715952],
            [18.00026521542512, 7.005237227046522],
            [17.985581730957605, 7.011345264162874],
            [17.935254111567605, 7.030611400202549],
            [17.930394428137973, 7.032000903222381],
            [17.92644110976143, 7.0307968593840435],
            [17.92699908009331, 7.026536556390308],
            [17.920729801577412, 7.026183446329342],
            [17.918664820120195, 7.020256301965974],
            [17.915956474340565, 7.017268149547653],
            [17.912619946782545, 7.016649741842576],
            [17.91065391531151, 7.013122303625711],
            [17.907087004013203, 7.013698973259758],
            [17.907028973531627, 7.0084820686321585],
            [17.903593186294636, 7.004432692808308],
            [17.90092493128609, 7.00884337982146],
            [17.89750924873167, 7.008653694019322],
            [17.895316147277665, 7.005179088569751],
            [17.89189510842103, 7.0093227504105045],
            [17.888122065374464, 7.009536370914398],
            [17.87866897377473, 7.022219659551743],
            [17.88060627496089, 7.023701157235045],
            [17.875914120018788, 7.03189834647826],
            [17.878608988883478, 7.033849109951774],
            [17.87407379869915, 7.041139415638773],
            [17.872570331774515, 7.0400162934958805],
            [17.86329519014133, 7.052443726079869],
            [17.853571802433702, 7.045653283729313],
            [17.851487540035706, 7.049625079388642],
            [17.843893393236005, 7.051945490879329],
            [17.839501761469325, 7.051755932503163],
            [17.83365829492088, 7.053744584511464],
            [17.83017456147061, 7.058407402956042],
            [17.819790454103334, 7.0662711777891705],
            [17.820347413384408, 7.075371926781736],
            [17.81840354789775, 7.0794417776161636],
            [17.80716615318324, 7.083774419869811],
            [17.80393277279072, 7.084295985509095],
            [17.799954166099972, 7.087996895316404],
            [17.799306715584606, 7.09054095529689],
            [17.794008775021922, 7.0957544633556315],
            [17.788971436112085, 7.096217932871771],
            [17.78217709089546, 7.102584315377879],
            [17.782568250733807, 7.105328238595253],
            [17.784161377983935, 7.108790527397659],
            [17.782674692548408, 7.1127518560890675],
            [17.786275102541918, 7.116836309845513],
            [17.78716630282645, 7.1214446928882005],
            [17.782726614866405, 7.125348184164769],
            [17.773467828074136, 7.128813021824294],
            [17.773029750876063, 7.132942622927976],
            [17.77614792770532, 7.137036479719041],
            [17.779680588158694, 7.137354376726292],
            [17.78311143596687, 7.14372282305988],
            [17.786883387177287, 7.145194119110862],
            [17.790502995099665, 7.140300984803967],
            [17.795564477949323, 7.140513465707917],
            [17.80210336559214, 7.14288575063286],
            [17.81199286299613, 7.155364629818923],
            [17.816089058395043, 7.156302804483098],
            [17.816249681464065, 7.1600461070590775],
            [17.813438227731176, 7.165013856436852],
            [17.821210701457108, 7.1748070603282645],
            [17.814546002416286, 7.184250348371062],
            [17.816508409776475, 7.1896018568846465],
            [17.81434508072189, 7.193708142750956],
            [17.815406664222532, 7.197952959629761],
            [17.810840886918154, 7.205560163281978],
            [17.808228683926473, 7.212786878660858],
            [17.81002189596735, 7.21886326647816],
            [17.80956924095701, 7.2254807013514135],
            [17.80612752374126, 7.231759932244067],
            [17.807032665234857, 7.236419741253009],
            [17.824927212590442, 7.244459423096485],
            [17.89194676360342, 7.272433132679772],
            [17.868746686438715, 7.331251599371573]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -71.42265204071063,
          "lat": 43.517888833916366
        },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33001"],
        "coty_name": ["Belknap"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Belknap County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00873174"
      },
      "bbox": [
        17.773029750876063, 6.926820100222151, 18.232907516632444,
        7.331251599371573
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.314302405171144, -2.350438569606055],
            [-7.311144709975708, -2.352223957426491],
            [-7.307437470804063, -2.3612727494615644],
            [-7.2974243440268864, -2.36351896458936],
            [-7.295594469404301, -2.36547897129705],
            [-7.291610686539559, -2.3626769735118884],
            [-7.285198374218756, -2.364128743912471],
            [-7.278653587212957, -2.370138576605739],
            [-7.272550631623714, -2.3716975082933724],
            [-7.270541188903994, -2.375404331776368],
            [-7.2637826809734465, -2.374816610070287],
            [-7.25831318445754, -2.3729609272076204],
            [-7.257018615635732, -2.366253885345179],
            [-7.2540622152334455, -2.3644838155768224],
            [-7.246120775325016, -2.356536606178429],
            [-7.239628101601719, -2.3597218939933984],
            [-7.235801730557101, -2.3601213855614063],
            [-7.2238834645506005, -2.365204589328817],
            [-7.218842849989224, -2.364957914980203],
            [-7.214266804196484, -2.3629084395282463],
            [-7.211867674244057, -2.365845148742572],
            [-7.203189025741739, -2.3669190484941827],
            [-7.199204275694658, -2.3685194946961614],
            [-7.1941322375981365, -2.366692250301375],
            [-7.186168554513824, -2.3580940370061363],
            [-7.169200099597587, -2.352867369699732],
            [-7.168060375263924, -2.3489208771073766],
            [-7.163572758132387, -2.3427133708737404],
            [-7.165247538542351, -2.3368662022353215],
            [-7.161591117083688, -2.331202337432949],
            [-7.14691687882421, -2.328349387487085],
            [-7.142063133962706, -2.325300105830869],
            [-7.137832253110093, -2.3185759453148287],
            [-7.13152841658586, -2.311938603175593],
            [-7.126415034925734, -2.3100171302482178],
            [-7.101236729701207, -2.271008609066339],
            [-7.074830947652531, -2.2364138622683254],
            [-7.071080602039712, -2.2340260791455506],
            [-7.066923450614851, -2.227009140139368],
            [-7.061706206128442, -2.2208878998650086],
            [-7.060857423728787, -2.203924044576502],
            [-7.056976627579028, -2.200399228193708],
            [-7.05498870106927, -2.195793314427228],
            [-7.057346766157464, -2.1913932550180477],
            [-7.059733521879431, -2.190385769389001],
            [-7.059357725670986, -2.182628537146961],
            [-7.04556014522022, -2.1696044868239475],
            [-7.0426074180898395, -2.1686050601045683],
            [-7.037445221581243, -2.1626126232586613],
            [-7.03598971303304, -2.156342790713355],
            [-7.0380077634127405, -2.1506692239824137],
            [-7.035449615814804, -2.1429375079029467],
            [-7.031645407466905, -2.138307197076549],
            [-7.032604683569851, -2.1330000497277175],
            [-7.034781487644756, -2.1321933449797306],
            [-7.035478029656093, -2.1240333757988337],
            [-7.043006085881704, -2.1162041044309796],
            [-7.029675112209245, -2.1107204743517096],
            [-7.023658569543083, -2.1018752135380456],
            [-7.011087887748372, -2.1004844940661704],
            [-6.98902293464372, -2.0965757837686487],
            [-6.986123766759178, -2.096438828942454],
            [-6.959167442407502, -2.0988063312552745],
            [-6.883231031431096, -2.107002313302879],
            [-6.84646984325329, -2.1108660158591848],
            [-6.626265506010366, -2.131456499168632],
            [-6.607734369728454, -2.133217481229404],
            [-6.611880517051159, -2.176949799364929],
            [-6.526116654538658, -2.184892753956718],
            [-6.5119297934571, -2.185417389514172],
            [-6.2700763915604725, -2.2074501475026973],
            [-6.266066623863586, -2.2128048852107662],
            [-6.269943112014345, -2.224959923016171],
            [-6.265933592765881, -2.2311781693622876],
            [-6.27322611415908, -2.2300003330392917],
            [-6.274758226057688, -2.232412756827181],
            [-6.2706521289915695, -2.2358349222467426],
            [-6.269867211743513, -2.239326216557284],
            [-6.2720319673758, -2.2421897418501735],
            [-6.273889069304193, -2.2487724207380646],
            [-6.271439583684211, -2.2506396811257035],
            [-6.2665990040244335, -2.248861414585188],
            [-6.2665791310551064, -2.2428991498369877],
            [-6.263676481027135, -2.243001022869279],
            [-6.261583634176695, -2.246360214321597],
            [-6.256579867161066, -2.2508716471911963],
            [-6.25758239304976, -2.254375247170735],
            [-6.261708380949746, -2.2590799854714807],
            [-6.2504705435601275, -2.2731168283128143],
            [-6.249920518919621, -2.2755074927812937],
            [-6.253868389262346, -2.2810697521877996],
            [-6.253630180015621, -2.2856795327729316],
            [-6.257139274081612, -2.2880566939092306],
            [-6.258208519390104, -2.282749503789992],
            [-6.26389114651586, -2.2837074386685132],
            [-6.263850271376967, -2.289401382538182],
            [-6.256479367178908, -2.2962668010684744],
            [-6.261409727811526, -2.3041826697839074],
            [-6.260312600903516, -2.3070268341868543],
            [-6.255224694656072, -2.309021857680251],
            [-6.252745732042287, -2.311789848033848],
            [-6.252850868936506, -2.320375305671663],
            [-6.249972577738, -2.3301562380945433],
            [-6.253541840612329, -2.3374972915522196],
            [-6.2413498349495375, -2.3422904390723716],
            [-6.245741847691431, -2.3476364388369912],
            [-6.239047849105071, -2.3542903441297294],
            [-6.236792311270274, -2.363572657624407],
            [-6.231161497933838, -2.3655233875663506],
            [-6.236849679155873, -2.3713486781037663],
            [-6.2393969144552255, -2.3759831017892368],
            [-6.240292370018769, -2.381468954842929],
            [-6.235319133943, -2.386297562590614],
            [-6.229541952181892, -2.3874581024086226],
            [-6.227539080860918, -2.3902687568518988],
            [-6.226698221413028, -2.397042423374243],
            [-6.227904465347378, -2.4014763591390493],
            [-6.227218104692255, -2.40828084476009],
            [-6.23193690319573, -2.4184900208129374],
            [-6.225867956474138, -2.4227915532381568],
            [-6.2199131545362, -2.4230192177718597],
            [-6.219223968779806, -2.4282809073468274],
            [-6.2125953426610625, -2.433754040312078],
            [-6.214584766028747, -2.4418340421638765],
            [-6.219034795213208, -2.442542018998676],
            [-6.220948939388589, -2.4456411462833056],
            [-6.225610929777564, -2.4455365078312736],
            [-6.227023229871758, -2.4500684821681222],
            [-6.217406914459086, -2.4587979139387754],
            [-6.211346371417644, -2.4696003794869354],
            [-6.207909982556403, -2.470199707896803],
            [-6.206292267033717, -2.474627309273918],
            [-6.213564513540215, -2.4785942286006106],
            [-6.21675440482042, -2.4846279569276972],
            [-6.218872212146236, -2.484445854953293],
            [-6.220261371531272, -2.478177690700454],
            [-6.226643693996807, -2.4790696963312344],
            [-6.225199941503621, -2.483535039003276],
            [-6.217381476324064, -2.4895547950337273],
            [-6.218475110059, -2.4930852955121625],
            [-6.221684746308606, -2.494050113059515],
            [-6.228454097546522, -2.4928047101289614],
            [-6.230757484786469, -2.4962751295712184],
            [-6.230940543790152, -2.5033897941408676],
            [-6.228879660456975, -2.504744324035562],
            [-6.2213650654514785, -2.5032201220444037],
            [-6.218265585866185, -2.5104905885571913],
            [-6.222631064097425, -2.5090056363540643],
            [-6.230318078194071, -2.5109619480467806],
            [-6.230443813330269, -2.5164337269191828],
            [-6.225620042861836, -2.5185272106164565],
            [-6.223701261170951, -2.5220309560920597],
            [-6.228349054349241, -2.5257698797549186],
            [-6.232346582430919, -2.525447399960242],
            [-6.232292685277733, -2.530161618358259],
            [-6.229866488710667, -2.5329287635289393],
            [-6.23515543030805, -2.535978296873859],
            [-6.2430817725645715, -2.5341320991170355],
            [-6.243231730971529, -2.5400530272823536],
            [-6.23924954709396, -2.543096257411206],
            [-6.238498367102992, -2.5464548606913455],
            [-6.243252944222159, -2.5492250511880084],
            [-6.249341089799241, -2.5489057242761692],
            [-6.2502672886945065, -2.553875498156589],
            [-6.245282716496143, -2.5590457648438445],
            [-6.249576013473264, -2.562148763855435],
            [-6.255073085634807, -2.554016049388934],
            [-6.256226635940545, -2.557633728010123],
            [-6.256983956994662, -2.566565544270726],
            [-6.258672394221199, -2.569447675315211],
            [-6.265743177167996, -2.5709633927149276],
            [-6.265779581506366, -2.5725117366169457],
            [-6.260290160712463, -2.577659645723372],
            [-6.256486560757683, -2.5786665817015155],
            [-6.255339037274181, -2.5816907883552043],
            [-6.260491543026953, -2.58794185706148],
            [-6.2572804636535935, -2.590803178082385],
            [-6.254874876995837, -2.5895712976659753],
            [-6.254839321540266, -2.5844189325264635],
            [-6.252204336261951, -2.5840098000251395],
            [-6.246859208861338, -2.5904908358632386],
            [-6.248295706366421, -2.5935157468487384],
            [-6.259076514249141, -2.595234324914004],
            [-6.257642457581881, -2.5989061957003474],
            [-6.249555722094686, -2.6032043335942596],
            [-6.251781638703203, -2.6053661059672146],
            [-6.259046026518997, -2.6082348519020218],
            [-6.2569895357380885, -2.613482657520324],
            [-6.254261962058022, -2.6148021542104747],
            [-6.248808365484277, -2.6202379075457047],
            [-6.250783764978736, -2.6243445984783116],
            [-6.254050094240947, -2.6246344309368577],
            [-6.255128072457854, -2.6278395218696553],
            [-6.25025064856003, -2.63676838156296],
            [-6.251795518279447, -2.643396341654135],
            [-6.248997560653654, -2.6466009405825903],
            [-6.24985903784293, -2.6499505655323987],
            [-6.256571110391921, -2.65328428653132],
            [-6.269090595951238, -2.652703243021605],
            [-6.397571966797412, -2.6393115957044184],
            [-6.3972174307654095, -2.636286816899183],
            [-6.486331407219937, -2.62856735363614],
            [-6.651289481751267, -2.6188370426942105],
            [-6.767468360329852, -2.614663984866422],
            [-6.773624428904904, -2.6168963091574526],
            [-6.776835935392489, -2.6155925834890943],
            [-6.7784054110643455, -2.6213834303769223],
            [-6.785319283376852, -2.629095035839239],
            [-6.786807151543676, -2.6223784222202786],
            [-6.791581743498729, -2.6129182603003116],
            [-6.795404125932918, -2.6155696772406745],
            [-6.798097075365049, -2.6113270975914102],
            [-6.801965930330839, -2.6090643583882898],
            [-6.80703879366377, -2.6018559263636467],
            [-6.813955924806668, -2.6016123039292034],
            [-6.818797335054296, -2.5984171027974012],
            [-6.829002683737404, -2.587689680234671],
            [-6.834098351295045, -2.5807177154148513],
            [-6.839917068099795, -2.5772620908669897],
            [-6.845886879895801, -2.570028959711016],
            [-6.852010734842452, -2.5701565854746473],
            [-6.860598667417779, -2.565452531442443],
            [-6.863807609965088, -2.566522057419018],
            [-6.86905139508813, -2.5645331890853282],
            [-6.878090418874786, -2.565662014075649],
            [-6.88070956711658, -2.5600361747456115],
            [-6.884823279096334, -2.5549940785993512],
            [-6.891016517244627, -2.5513510179745156],
            [-6.894800376044423, -2.550804868543677],
            [-6.898115306617747, -2.5469543008352433],
            [-6.905645319653105, -2.5453947221570012],
            [-6.9131298426280905, -2.5452214012228667],
            [-6.915413620895857, -2.5432131516685432],
            [-6.9249003012875505, -2.542727945209379],
            [-6.931345991682945, -2.539993741754757],
            [-6.931474829286474, -2.5348030687802123],
            [-6.934424547024423, -2.532024388551034],
            [-6.93796735025005, -2.5323259957226187],
            [-6.942702710368529, -2.528800846639887],
            [-6.945328397895102, -2.529596589833116],
            [-7.030111325618411, -2.488508138408632],
            [-7.035737017916727, -2.4881184986003912],
            [-7.131313258361133, -2.4785144092177864],
            [-7.171132675392272, -2.474447954973426],
            [-7.239483020064021, -2.467677559518917],
            [-7.246163613000834, -2.46639406646899],
            [-7.3278191063798666, -2.458074743652034],
            [-7.314302405171144, -2.350438569606055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.94491959938361,
          "lat": 36.01052744887009
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35033"],
        "coty_name": ["Mora"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mora County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01702367"
      },
      "bbox": [
        -7.3278191063798666, -2.65328428653132, -6.206292267033717,
        -2.096438828942454
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.608079896793972, -1.6875158848213612],
            [13.591700389534031, -1.5847146903496396],
            [13.578336727967187, -1.5055790009651915],
            [13.573678249760972, -1.4731980058642524],
            [13.566526517017271, -1.4254491640789713],
            [13.564159599067706, -1.405785253893173],
            [13.559465853140434, -1.3727720827805872],
            [13.556005823012141, -1.3467183569639107],
            [13.555006032936006, -1.3384824644881377],
            [13.67810622585608, -1.3204680409606209],
            [13.771615427433254, -1.3066409642031196],
            [13.779956437031016, -1.3554593643562534],
            [13.791936154901443, -1.429478873521682],
            [13.793906399848384, -1.4389793881222053],
            [13.795945993186727, -1.4542537988385043],
            [13.798508370519436, -1.4677880543328345],
            [13.799939443389725, -1.480550835526164],
            [13.80434926829595, -1.5078224825944382],
            [13.80962674209964, -1.5433082170840982],
            [13.825065507978211, -1.6346400824875218],
            [13.822673606426918, -1.6354988862089146],
            [13.822606197809664, -1.6401309778304867],
            [13.830378736778204, -1.6431934614357555],
            [13.832816649051383, -1.6456174575006126],
            [13.83387068029519, -1.6562522141784508],
            [13.83636178056675, -1.661156546536837],
            [13.843113662082594, -1.6696520282423037],
            [13.843363717699525, -1.676915197365262],
            [13.84531903142831, -1.6798008620176519],
            [13.845946714241768, -1.6894681069410928],
            [13.848204424082502, -1.691590855080026],
            [13.854642846565824, -1.6924526413515084],
            [13.858116919523209, -1.6946187527704633],
            [13.858540381405604, -1.7002699666500853],
            [13.833064223274512, -1.704985221849376],
            [13.704046066530232, -1.7282045972616613],
            [13.617358885389882, -1.7438017901687461],
            [13.608079896793972, -1.6875158848213612]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.39945220645292,
          "lat": 36.043681056595894
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37001"],
        "coty_name": ["Alamance"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alamance County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01008531"
      },
      "bbox": [
        13.555006032936006, -1.7438017901687461, 13.858540381405604,
        -1.3066409642031196
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.878658712751243, -0.5840862474563279],
            [15.899035192169965, -0.5796153077211272],
            [16.0174774402241, -0.5552373504809934],
            [16.076844471338774, -0.594598307769887],
            [16.164179986657363, -0.6534704962687442],
            [16.170688020760483, -0.6801107436235297],
            [16.179145909860082, -0.6821517215798092],
            [16.204182759169605, -0.7009610011310721],
            [16.21282646717055, -0.7130616116970224],
            [16.220341649304274, -0.7148213448202285],
            [16.232554599827964, -0.7145035692637814],
            [16.240804986725383, -0.7169214134954226],
            [16.24931848456162, -0.7137603964187265],
            [16.254108146255696, -0.7148885313201032],
            [16.25824268690081, -0.7027779748544961],
            [16.26134393968542, -0.7000864359194624],
            [16.26386506012176, -0.7033782119821941],
            [16.26649479603183, -0.701054184208302],
            [16.26992973354509, -0.703182007026081],
            [16.27415823657859, -0.7024995150825135],
            [16.277996862835717, -0.7061551293917139],
            [16.28137418516209, -0.7071987648307282],
            [16.282525669957295, -0.7121651644475061],
            [16.279721022157993, -0.7146611875194374],
            [16.281345841309225, -0.7180755676973348],
            [16.286118550590526, -0.7145694039755518],
            [16.28654736232083, -0.7103609646634488],
            [16.291542500561032, -0.7096740095020115],
            [16.292866184461662, -0.7164841144200186],
            [16.29106836779288, -0.7205821969109947],
            [16.29486478420873, -0.7261814087910128],
            [16.29797007627039, -0.7267056263356841],
            [16.301985680589688, -0.7239401139753299],
            [16.307898746778065, -0.7280228646270942],
            [16.309552130495483, -0.7362796903103731],
            [16.312119426944854, -0.7398113513039135],
            [16.319787995981006, -0.7411528785415723],
            [16.326000131423083, -0.7393339090870936],
            [16.330875534435442, -0.7366586517452035],
            [16.336585839218817, -0.7396001351842869],
            [16.33886597281281, -0.7503951428215243],
            [16.34408692865072, -0.7564394549850333],
            [16.34770271419712, -0.7564997403425247],
            [16.350477083021236, -0.754078952948058],
            [16.357583277800455, -0.7568277907116834],
            [16.357010793313155, -0.7615220506678558],
            [16.359117207061093, -0.7662320588966867],
            [16.357965059385887, -0.7709667802010867],
            [16.35210298204824, -0.7749393636552874],
            [16.350486552438554, -0.777390832054847],
            [16.346032399899592, -0.7810244014553425],
            [16.349412578191025, -0.7898239359849815],
            [16.355267705430364, -0.7926822013757089],
            [16.366124846410365, -0.8064073410663913],
            [16.37088447398761, -0.8168205302747944],
            [16.37124829866831, -0.8260145802138978],
            [16.369052085906258, -0.8372779653874598],
            [16.366834357070488, -0.8440197404976821],
            [16.38167540340013, -0.8527201780526189],
            [16.384108883982474, -0.8583227064742112],
            [16.389730177281546, -0.8611180478486878],
            [16.40581937873659, -0.8627555618995378],
            [16.410455863715548, -0.8667290362449414],
            [16.410320466339783, -0.8692126778865531],
            [16.401706883521484, -0.8719785849382605],
            [16.393594284159075, -0.8723198918633137],
            [16.371187999709964, -0.8708539318179044],
            [16.338918799650976, -0.869335838580799],
            [16.32487973380689, -0.8658941335323902],
            [16.31712611302709, -0.8579292579444368],
            [16.31441431185484, -0.8519887047255349],
            [16.299881208039096, -0.8457850031513934],
            [16.29659967657041, -0.8374785306418483],
            [16.294478630509403, -0.8368438295900025],
            [16.28964729138529, -0.8272699381825671],
            [16.285774339886675, -0.8242240858457508],
            [16.281603571658408, -0.8252525785954938],
            [16.276784836647884, -0.8237595265456145],
            [16.265032155415973, -0.8251148116406017],
            [16.259366121855273, -0.816027922001394],
            [16.24722198147894, -0.8108973109980695],
            [16.243442329717336, -0.808076568820985],
            [16.237460762467528, -0.7956857162858372],
            [16.231552957799305, -0.7937231210769896],
            [16.218414495051995, -0.7862277987603998],
            [16.21377762586445, -0.7815717450279301],
            [16.210355283734557, -0.7845128795195684],
            [16.195822712287896, -0.7869970656629435],
            [16.187442869347173, -0.7858079276793427],
            [16.185769975433285, -0.7811810570039268],
            [16.17873282679065, -0.7772389660966239],
            [16.169183188196822, -0.7805895383149261],
            [16.16227936443184, -0.7867982682193565],
            [16.156681966606445, -0.7847411114172308],
            [16.145611261075185, -0.7864730123487575],
            [16.146391363151142, -0.7823669693126578],
            [16.155416962558228, -0.7797760235612001],
            [16.15623579791091, -0.7782184980965972],
            [16.15403836392827, -0.768958689393756],
            [16.156307106171163, -0.7661909151361399],
            [16.16068202400744, -0.7686879545306309],
            [16.164653466485273, -0.7676561768598412],
            [16.16809299871155, -0.763578703767076],
            [16.167520662233787, -0.7586455253881456],
            [16.15822012380484, -0.755010693687836],
            [16.148707841519784, -0.7567357554144398],
            [16.141755274420973, -0.759811950950069],
            [16.138101338062484, -0.7575434839039101],
            [16.136815009021163, -0.7513375893574169],
            [16.13825608425378, -0.7453448345274518],
            [16.13351954196164, -0.7424651905280047],
            [16.128709777331903, -0.7423768490736112],
            [16.12586517272861, -0.7392779449370668],
            [16.126587485262736, -0.7348700777800068],
            [16.120309703802835, -0.7273366124110519],
            [16.119130713955464, -0.7191550806115001],
            [16.113217384673465, -0.7196930242790321],
            [16.109985377509677, -0.7264342961701876],
            [16.105179766052466, -0.7295478699659855],
            [16.100494841387253, -0.7308799231716779],
            [16.097218325485567, -0.7283189556081966],
            [16.098552432041007, -0.7206323025351997],
            [16.095997984857267, -0.7182585460732636],
            [16.096291416853116, -0.7123457074653619],
            [16.094462003066965, -0.7105608304100495],
            [16.081750661684286, -0.7091607230587323],
            [16.07852421431871, -0.7117730785247599],
            [16.072940506475113, -0.7103963568719194],
            [16.072589265335303, -0.7140361625265846],
            [16.068491908818142, -0.7135995872353408],
            [16.059699061953086, -0.7064007787838469],
            [16.058673740428, -0.7032145784757674],
            [16.050488668344485, -0.7016066726716123],
            [16.05041940707625, -0.6985794701314249],
            [16.045273125150956, -0.6933504969582186],
            [16.03749640973432, -0.6884623481790311],
            [16.03870065870063, -0.6822177737822088],
            [16.037601583574972, -0.6791727703084405],
            [16.030217973616704, -0.6832265961632751],
            [16.027677870125522, -0.6821374093320549],
            [16.02331214235936, -0.6841923542315873],
            [16.022369162343782, -0.6869718136791825],
            [16.017143024862555, -0.6874349280300834],
            [16.014872818292165, -0.6815938879745804],
            [16.009187140561053, -0.6847952658631757],
            [15.999895897152571, -0.6818375572384548],
            [15.99482867801319, -0.6745979628946028],
            [15.990839636756904, -0.6722064917630693],
            [15.989672430564955, -0.668970216299939],
            [15.98493377955283, -0.6683773678305039],
            [15.981666784425874, -0.6696646290047922],
            [15.973897104752568, -0.6633940216489239],
            [15.96611687419553, -0.6645770436520225],
            [15.961123915178627, -0.6642267884162779],
            [15.95706873803917, -0.6607885959865046],
            [15.951810693789898, -0.6604643273110729],
            [15.950059428974757, -0.6582335846234377],
            [15.937978784798952, -0.6571886309793252],
            [15.887014902310753, -0.6236479453372157],
            [15.839748873207375, -0.59260734285268],
            [15.878658712751243, -0.5840862474563279]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.20803540021487, "lat": 36.38915178132706 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37029"],
        "coty_name": ["Camden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Camden County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01026335"
      },
      "bbox": [
        15.839748873207375, -0.8723198918633137, 16.410455863715548,
        -0.5552373504809934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.166155064093111, -2.4152017953076554],
            [12.239706242724056, -2.407054635980325],
            [12.299493124949482, -2.4005885487363283],
            [12.33874222521109, -2.3964677002223596],
            [12.344783405993098, -2.3965469166465305],
            [12.357198398739074, -2.394543869541555],
            [12.448756990721613, -2.384212602705983],
            [12.523215443311367, -2.3758659222411826],
            [12.56887426894784, -2.3721914032623928],
            [12.569890746793202, -2.3760031297243693],
            [12.56817087328978, -2.3815455621053387],
            [12.562323395406219, -2.3849633008521],
            [12.554304549708926, -2.3925050269154933],
            [12.548715256847943, -2.3940135009190238],
            [12.546704983800995, -2.3972240523242148],
            [12.547273201655871, -2.4005263605153226],
            [12.550899624109329, -2.407439891599961],
            [12.553362694428, -2.4095402648467252],
            [12.559885988867249, -2.410255969807437],
            [12.563464962966851, -2.4061296730237176],
            [12.566431797823435, -2.398069893013029],
            [12.570137097468555, -2.3976047009685097],
            [12.576682491958854, -2.4044173069898864],
            [12.584992603599208, -2.405508273475098],
            [12.590065467868731, -2.407565586873805],
            [12.595076546339605, -2.405863832662428],
            [12.60066010647069, -2.4081114503715315],
            [12.596893051378075, -2.411162260047702],
            [12.591685693680532, -2.4129699311138584],
            [12.586555931141742, -2.419569373982828],
            [12.578933700798013, -2.420712179366967],
            [12.574123329014029, -2.4229542752266564],
            [12.571494817195266, -2.4259046399749553],
            [12.566949446030304, -2.4228036061079794],
            [12.562578116918628, -2.4240481819196016],
            [12.561942732211588, -2.429116939213973],
            [12.55675846760699, -2.4327359895972127],
            [12.554562174362966, -2.4386337394111948],
            [12.55933314471554, -2.445454423266985],
            [12.558484429487082, -2.449637291379166],
            [12.554082730503858, -2.4555612575603556],
            [12.550909082084251, -2.4675312716506355],
            [12.547175430493267, -2.472302113510083],
            [12.54473822477022, -2.488819968023735],
            [12.54438060372689, -2.498271519916984],
            [12.542352121393227, -2.5044207511903447],
            [12.541665911698091, -2.5106546039454907],
            [12.544022943537055, -2.5206296800146792],
            [12.550350926167795, -2.530295143334945],
            [12.549570339963415, -2.5353764522504805],
            [12.55023028097777, -2.542653355726723],
            [12.549311833170146, -2.5546604550768786],
            [12.549799978156933, -2.557011453781511],
            [12.559147590399803, -2.5700912878943916],
            [12.56044745153679, -2.5827454859762433],
            [12.56571128973216, -2.5964642099732904],
            [12.566138481254765, -2.6070180039987134],
            [12.564253609057928, -2.6126558556427617],
            [12.566746059400588, -2.620577317008169],
            [12.562788495972695, -2.625578067288563],
            [12.558124185419139, -2.624706830822112],
            [12.552894190109873, -2.631088368431094],
            [12.547638946783472, -2.632365035565626],
            [12.538305548570372, -2.6330238205411205],
            [12.537601663920334, -2.6324936756973405],
            [12.484356553430127, -2.636591134021101],
            [12.377416636900804, -2.6473046190503027],
            [12.307748396903332, -2.65477626988769],
            [12.307184441541525, -2.6281465493379867],
            [12.298717951395243, -2.5769287672755055],
            [12.297743956708034, -2.5573648620704312],
            [12.26970994547399, -2.544481873144436],
            [12.267359432419482, -2.541299484965613],
            [12.26589163869555, -2.5341229046251144],
            [12.265776536063155, -2.527720559582427],
            [12.260821883863667, -2.5207543290514476],
            [12.25343733304084, -2.5087539984288885],
            [12.254442837502637, -2.4995840622653183],
            [12.258926819590386, -2.4918417797287304],
            [12.235638585755408, -2.479672313067289],
            [12.221690764497252, -2.4746275762152137],
            [12.166516759530271, -2.4160782560969682],
            [12.166155064093111, -2.4152017953076554]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.18030122216727, "lat": 35.29436893298374 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37071"],
        "coty_name": ["Gaston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gaston County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01008554"
      },
      "bbox": [
        12.166155064093111, -2.65477626988769, 12.60066010647069,
        -2.3721914032623928
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.771615427433254, -1.3066409642031196],
            [13.8536619128468, -1.2936038870952806],
            [13.918818151773593, -1.2828108061927654],
            [13.949698363858092, -1.277880202505813],
            [14.01406571931118, -1.2673215345704325],
            [14.015816130912167, -1.3104221908951332],
            [14.020761067380363, -1.4287219682667003],
            [14.022450413286574, -1.4709528035514372],
            [14.026794969020486, -1.5755426255218996],
            [14.029873984023594, -1.650108071519549],
            [13.978438243251649, -1.6618670104516733],
            [13.938192770512043, -1.664451709229347],
            [13.867945104673947, -1.6683886933880168],
            [13.843113662082594, -1.6696520282423037],
            [13.83636178056675, -1.661156546536837],
            [13.83387068029519, -1.6562522141784508],
            [13.832816649051383, -1.6456174575006126],
            [13.830378736778204, -1.6431934614357555],
            [13.822606197809664, -1.6401309778304867],
            [13.822673606426918, -1.6354988862089146],
            [13.825065507978211, -1.6346400824875218],
            [13.80962674209964, -1.5433082170840982],
            [13.80434926829595, -1.5078224825944382],
            [13.799939443389725, -1.480550835526164],
            [13.798508370519436, -1.4677880543328345],
            [13.795945993186727, -1.4542537988385043],
            [13.793906399848384, -1.4389793881222053],
            [13.791936154901443, -1.429478873521682],
            [13.779956437031016, -1.3554593643562534],
            [13.771615427433254, -1.3066409642031196]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.12066905016559, "lat": 36.06115428022881 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37135"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01008576"
      },
      "bbox": [
        13.771615427433254, -1.6696520282423037, 14.029873984023594,
        -1.2673215345704325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.115461684348237, -1.1143328304738942],
            [13.211715033474924, -1.0980004487285322],
            [13.225295999291863, -1.0952678527320863],
            [13.360668910297855, -1.072829279433662],
            [13.446097836179135, -1.058647136769962],
            [13.518628021949004, -1.0466034210531145],
            [13.527124270697604, -1.114773048612679],
            [13.537380191043631, -1.1970575074115526],
            [13.555006032936006, -1.3384824644881377],
            [13.556005823012141, -1.3467183569639107],
            [13.465359357730376, -1.3591083738228067],
            [13.422873770665158, -1.3653513951365215],
            [13.313279214892033, -1.3794579976364891],
            [13.279662287346826, -1.3833387882386057],
            [13.246291098034451, -1.3875001920564487],
            [13.15750903965697, -1.399259358671366],
            [13.141338836558441, -1.2896884210326272],
            [13.129412895108024, -1.2088697407564724],
            [13.115461684348237, -1.1143328304738942]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.77500082861877, "lat": 36.39601830461092 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37157"],
        "coty_name": ["Rockingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockingham County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01008582"
      },
      "bbox": [
        13.115461684348237, -1.399259358671366, 13.556005823012141,
        -1.0466034210531145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.789955401028472, -1.1604834941758395],
            [12.90496477016735, -1.1482202999794364],
            [12.95981742787143, -1.1392845488450638],
            [13.041014022433837, -1.1267682724654227],
            [13.094960402618478, -1.1177649064703814],
            [13.115461684348237, -1.1143328304738942],
            [13.129412895108024, -1.2088697407564724],
            [13.141338836558441, -1.2896884210326272],
            [13.15750903965697, -1.399259358671366],
            [13.069182263386233, -1.4127955277915334],
            [12.940073580227892, -1.4325669221800814],
            [12.86494614384598, -1.4440877536390115],
            [12.828393975499708, -1.4498778442484153],
            [12.817246408877649, -1.3724737547503574],
            [12.807512866456872, -1.3056948573489882],
            [12.801280249084881, -1.2568542826168765],
            [12.793429014436176, -1.1889631344803389],
            [12.789955401028472, -1.1604834941758395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.23964434304634, "lat": 36.40189928710537 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37169"],
        "coty_name": ["Stokes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stokes County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "01008586"
      },
      "bbox": [
        12.789955401028472, -1.4498778442484153, 13.15750903965697,
        -1.1143328304738942
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.878923148640216, 9.695602346343929],
            [-1.769470633954094, 9.691568138531323],
            [-1.6827579266928503, 9.688509578680566],
            [-1.6857094656978209, 9.601751930136261],
            [-1.6861861300433951, 9.583114838617972],
            [-1.6896745985812591, 9.478252554322163],
            [-1.6849807786551398, 9.471662404077872],
            [-1.6805879679434228, 9.472356233867622],
            [-1.6729719251068471, 9.469886230512664],
            [-1.6562206108456643, 9.460636998582856],
            [-1.6493192297717205, 9.465544463233792],
            [-1.6459150227936123, 9.465543159107547],
            [-1.6424387218306615, 9.462072893143311],
            [-1.6443423336079315, 9.45848494233401],
            [-1.6421832225043564, 9.453784633791928],
            [-1.638215386606724, 9.450360016373084],
            [-1.6342568577928445, 9.44017744381423],
            [-1.6361933310355954, 9.436212100472572],
            [-1.6354874377781943, 9.433223688389555],
            [-1.6302718486511827, 9.429695164689148],
            [-1.6040979018484447, 9.42904526443021],
            [-1.6049069457240372, 9.410542338049623],
            [-1.6067868788902917, 9.34505751957381],
            [-1.5999505166233061, 9.344861426396713],
            [-1.5931025240507344, 9.353111206517323],
            [-1.5923886758730441, 9.360473495466136],
            [-1.5869755915669275, 9.364018073637105],
            [-1.5833926268866254, 9.36922693477284],
            [-1.5801216967223848, 9.368517972605508],
            [-1.57532829758557, 9.372802198815622],
            [-1.569074514013685, 9.370947966355224],
            [-1.5660600053743807, 9.373468960186216],
            [-1.5593014400330152, 9.37100675384746],
            [-1.5616254970809444, 9.36318796637935],
            [-1.557384285571888, 9.34843793099649],
            [-1.557432560971751, 9.344817291459027],
            [-1.5554402072120852, 9.33956667943362],
            [-1.5513288241962153, 9.33728514972056],
            [-1.5510543278074245, 9.328954755657495],
            [-1.5523046895029602, 9.323608556936037],
            [-1.555795996039123, 9.31855309958333],
            [-1.554453153536622, 9.312377873582296],
            [-1.5484493404152402, 9.317528076156195],
            [-1.54224092511948, 9.319454905890886],
            [-1.5358158333713412, 9.319857003793079],
            [-1.5291296272212975, 9.324265068239539],
            [-1.5230360563575216, 9.323588841461307],
            [-1.5124700959302377, 9.31767482642849],
            [-1.5082771606266447, 9.320169466102477],
            [-1.5032214641166375, 9.32602089180843],
            [-1.5055471394792685, 9.338035462825482],
            [-1.5040460837003895, 9.34073108890067],
            [-1.4956256993699042, 9.342434382547204],
            [-1.4926602477244448, 9.344498639558509],
            [-1.4907502494458404, 9.336413653254477],
            [-1.4848348533570543, 9.329089129294971],
            [-1.4823315231184921, 9.335867128692849],
            [-1.480316763356152, 9.344371667257038],
            [-1.4765408287567312, 9.34846119537169],
            [-1.4702134778316753, 9.352539366509264],
            [-1.46687350184094, 9.355865952192884],
            [-1.456091785284274, 9.362104302138574],
            [-1.452076967123993, 9.36325812097284],
            [-1.447589924487487, 9.366649428588417],
            [-1.4414881884147004, 9.374397762691908],
            [-1.4402539092064426, 9.379548571182706],
            [-1.4285385270908684, 9.376662387806212],
            [-1.4213425911872384, 9.373712676788308],
            [-1.424172452683795, 9.371543903887696],
            [-1.4247901100580072, 9.364416120343382],
            [-1.421662622611389, 9.356201286559893],
            [-1.4183904793435398, 9.350527007280595],
            [-1.4143216558814153, 9.346689517040222],
            [-1.4155752102999102, 9.34310390738408],
            [-1.4142580675077336, 9.330633265819985],
            [-1.4163419760673972, 9.328637681484803],
            [-1.416126938527833, 9.32451961560637],
            [-1.4137399438733123, 9.32307993419072],
            [-1.413785750804927, 9.319262983539044],
            [-1.4044451508095903, 9.316140673061994],
            [-1.4042683111001297, 9.321534097603452],
            [-1.4004611974526828, 9.324753402285229],
            [-1.3975746877774744, 9.321929357803903],
            [-1.4005840553734392, 9.318295297273464],
            [-1.3992321134841945, 9.314764173200986],
            [-1.394045431122224, 9.310598418308617],
            [-1.392363019084516, 9.299903160400326],
            [-1.3944862642197957, 9.295402778220225],
            [-1.3985543517642531, 9.291644471081732],
            [-1.4047740778682323, 9.293113656267652],
            [-1.412544267387664, 9.291108819513754],
            [-1.4154575340983637, 9.287716640003309],
            [-1.4158292329283813, 9.284159866248865],
            [-1.4210742822281253, 9.277756230301282],
            [-1.4245020541434608, 9.27526633200952],
            [-1.4229111980162095, 9.270579862358009],
            [-1.4197911298304142, 9.26989586036116],
            [-1.41269367379501, 9.279257907095667],
            [-1.408002114596721, 9.28259917156041],
            [-1.4065075844519035, 9.285705535588725],
            [-1.4015977478591428, 9.288644205796736],
            [-1.3950867845172512, 9.28884247431338],
            [-1.3823573539934333, 9.2975069788088],
            [-1.3771706221311564, 9.306368030587734],
            [-1.37370265915654, 9.314200530038862],
            [-1.3671995561841108, 9.314995971949253],
            [-1.3619382164202762, 9.319547293026853],
            [-1.353513521934658, 9.319595942871384],
            [-1.3466913190631324, 9.316904996839757],
            [-1.3388891705111872, 9.315966460174746],
            [-1.3335443164221497, 9.307666668586704],
            [-1.3345381911188698, 9.301318187686977],
            [-1.3385513061943108, 9.296381856494289],
            [-1.3352847770290062, 9.290801028731241],
            [-1.334094534771182, 9.280880720955897],
            [-1.3323611841049485, 9.277206508911958],
            [-1.3241150455773345, 9.267871442751748],
            [-1.3156000265513168, 9.260781198412484],
            [-1.3094921827612664, 9.254541934198095],
            [-1.3144733631815353, 9.245568964052717],
            [-1.3138196926469476, 9.239967857802348],
            [-1.3096926426870577, 9.232900326138862],
            [-1.2812401297056593, 9.23228928716557],
            [-1.280670196554389, 9.230848719526216],
            [-1.2423102784515492, 9.229782057547826],
            [-1.244097094731957, 9.162439182263649],
            [-1.2566457763463503, 9.16271576086883],
            [-1.2570967588705315, 9.163873315729132],
            [-1.3084362117560693, 9.165367591124754],
            [-1.3295568853500872, 9.165807927931077],
            [-1.4166298258707977, 9.16848491444933],
            [-1.4868463615878924, 9.170202632549413],
            [-1.4898453969212606, 9.17045724396291],
            [-1.5349381482377074, 9.171437375286239],
            [-1.5698000485875587, 9.171947925249352],
            [-1.6209526822255784, 9.17390359784379],
            [-1.631842393253064, 9.175026688923209],
            [-1.667148226012662, 9.175877181796583],
            [-1.6681588377729928, 9.176128858015943],
            [-1.7056586778162681, 9.177138822809479],
            [-1.707705869000105, 9.176994403516373],
            [-1.7657325454610544, 9.178765424571242],
            [-1.8093448377818124, 9.18016937114158],
            [-1.9109544514182366, 9.183853095483364],
            [-1.9403609006811087, 9.18480844253554],
            [-1.9686759895162704, 9.18614702897196],
            [-2.0406419499620547, 9.18915169250903],
            [-2.113746022178763, 9.19203507968168],
            [-2.1103070562880686, 9.277132894524685],
            [-2.106794086377231, 9.362434909414787],
            [-2.131116867696726, 9.363376123674794],
            [-2.1274851783255526, 9.448402758755748],
            [-2.1226652296506296, 9.560281911686847],
            [-2.118068189609393, 9.66310440495282],
            [-2.1162983932155064, 9.704889838902035],
            [-2.0298319869347807, 9.701383745304536],
            [-1.966708953954875, 9.6990125554606],
            [-1.878923148640216, 9.695602346343929]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.36608976459597, "lat": 48.06939254789686 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38005"],
        "coty_name": ["Benson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benson County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01034216"
      },
      "bbox": [
        -2.131116867696726, 9.162439182263649, -1.2423102784515492,
        9.704889838902035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7283245873380455, 8.163618890061162],
            [-3.6562915904935327, 8.159035120590072],
            [-3.5697081243839985, 8.15364168092645],
            [-3.46870593913861, 8.147686697466495],
            [-3.4740060455123305, 8.062291074168444],
            [-3.416104925242978, 8.058657523447028],
            [-3.3079993626324358, 8.052287979081425],
            [-3.1998959904653668, 8.045883341378845],
            [-3.185443488531518, 8.04504357505131],
            [-3.192587039852406, 7.918321218652339],
            [-3.197044744277553, 7.839152305238038],
            [-3.1999489241346684, 7.789651940408132],
            [-3.1135796342961144, 7.78485133830561],
            [-3.0269455170477313, 7.780357486054376],
            [-3.0278176768103955, 7.762386890938703],
            [-3.0315301068361036, 7.694707449942401],
            [-3.0157598208498766, 7.693614046444261],
            [-3.0148581093100444, 7.687897288911788],
            [-3.018549584150426, 7.685580912973319],
            [-3.024022681334283, 7.685847613569082],
            [-3.0246802857469914, 7.68977447553706],
            [-3.029038753248267, 7.692064277778627],
            [-3.036282955649873, 7.687876533695451],
            [-3.0372951419380465, 7.681368007658707],
            [-3.044599635683064, 7.68159541338205],
            [-3.0495722843631934, 7.68520739377904],
            [-3.0526543609120913, 7.684441872724011],
            [-3.058923616502636, 7.686900394083154],
            [-3.0645800021372924, 7.685026491944122],
            [-3.066588849045006, 7.682100324515622],
            [-3.064612665100132, 7.679733522080233],
            [-3.0601209542122025, 7.679088821338973],
            [-3.062575685587184, 7.669985061921912],
            [-3.0654704601836325, 7.668440604095494],
            [-3.071356306541034, 7.66952137123533],
            [-3.073131385913567, 7.667962153759248],
            [-3.073532757072268, 7.66183166279235],
            [-3.0778986472562884, 7.660138281068193],
            [-3.081026454966362, 7.654668083085292],
            [-3.07312105355269, 7.655450645036113],
            [-3.0701424365882746, 7.6428010046651],
            [-3.070983386032522, 7.639902171858323],
            [-3.0804013830876134, 7.63308862515678],
            [-3.0818647530981145, 7.627959625160317],
            [-3.084878199422888, 7.628028497085123],
            [-3.0893111868025205, 7.625277109739643],
            [-3.0930286824529163, 7.628330894917857],
            [-3.101115362704186, 7.623880159990178],
            [-3.1016062284485684, 7.617884746737411],
            [-3.104539116402795, 7.6160967283628285],
            [-3.1092855383948983, 7.615833852863024],
            [-3.112300252515678, 7.613800900005602],
            [-3.1185885261418633, 7.617492111450418],
            [-3.1173781659220445, 7.612084339643299],
            [-3.123256786333165, 7.609934867269354],
            [-3.1260156438488242, 7.610899254186612],
            [-3.1351692827063564, 7.607794556373975],
            [-3.1404800544170293, 7.600588816763664],
            [-3.136374512326258, 7.598351002953544],
            [-3.1393527406814896, 7.593259508595461],
            [-3.137179388180924, 7.591217573720796],
            [-3.1384867236836484, 7.584903765465212],
            [-3.1349096809857144, 7.582627204975164],
            [-3.134933726840276, 7.579707542536828],
            [-3.1401477332778285, 7.578405813029942],
            [-3.1394506029471576, 7.570737320129636],
            [-3.136854099349778, 7.5668371024102346],
            [-3.1407222687904808, 7.565076879557114],
            [-3.1435457224691112, 7.570239139188761],
            [-3.1516140597871547, 7.573884188328824],
            [-3.1574394340861875, 7.564056434002928],
            [-3.1632101192955875, 7.559273659388857],
            [-3.164307391048851, 7.556366555928792],
            [-3.169692377519284, 7.5619109637935065],
            [-3.172824528688912, 7.557324598634262],
            [-3.179318490852119, 7.56037378679839],
            [-3.1871792317923355, 7.55836436640712],
            [-3.191495603294025, 7.550745779965104],
            [-3.1940985075834223, 7.555645955379602],
            [-3.1970201993031697, 7.5553103260268974],
            [-3.1982006781132974, 7.5497819132259485],
            [-3.202212307509918, 7.551589748191774],
            [-3.2015096006797386, 7.5555369602670215],
            [-3.208919517591611, 7.554634897894826],
            [-3.2097725629175042, 7.548838759331158],
            [-3.2123853108520533, 7.5491199889553915],
            [-3.2137463674820235, 7.5541555577611454],
            [-3.217490165977382, 7.548565074504966],
            [-3.2222861460669865, 7.546843742820326],
            [-3.2138813218545805, 7.54211245347586],
            [-3.2115681688192326, 7.537749439530107],
            [-3.2138001306353443, 7.533003366147777],
            [-3.2164761517547777, 7.531407001864103],
            [-3.2178721635313567, 7.5272717615871905],
            [-3.222912575720177, 7.5258313388462135],
            [-3.2290480042935314, 7.52238834679709],
            [-3.2243539879999936, 7.5160802069923935],
            [-3.2324916408874396, 7.518514601475387],
            [-3.2337469652943462, 7.514095928771558],
            [-3.238275513589246, 7.514863368683292],
            [-3.246521680319404, 7.512760493385849],
            [-3.2460541702585544, 7.508517367064258],
            [-3.241603814368166, 7.508020419304596],
            [-3.242583255876919, 7.504835333452559],
            [-3.2490086136040874, 7.503129760151498],
            [-3.2496928335017907, 7.49990538541469],
            [-3.254650774300561, 7.498707231077634],
            [-3.2590035333372493, 7.500941429923156],
            [-3.2606485994564776, 7.494848232982273],
            [-3.26342550806415, 7.495047412671067],
            [-3.2645488535066813, 7.499844307433978],
            [-3.2738006697288715, 7.502336469821568],
            [-3.2767490938473722, 7.50470211086968],
            [-3.2848584701731456, 7.499611877879839],
            [-3.2916819198197436, 7.4970096767488545],
            [-3.293679178566107, 7.492886049697647],
            [-3.297687144816089, 7.49075786732624],
            [-3.2950664513639922, 7.487074112230847],
            [-3.2975842599483065, 7.485019291002043],
            [-3.3050953734593134, 7.487916238955438],
            [-3.309341300744573, 7.483667412186365],
            [-3.3338908502441713, 7.479128017773098],
            [-3.334580590060005, 7.48657624190873],
            [-3.3425462677576614, 7.481975681461196],
            [-3.34641208937087, 7.4819005152185865],
            [-3.3478725287587916, 7.4763867073170704],
            [-3.3560358914526476, 7.471909748832909],
            [-3.3551546594438277, 7.463815906325725],
            [-3.3530360894136773, 7.4601381940423765],
            [-3.3537464157100643, 7.455329536854957],
            [-3.3603135442732657, 7.4535535747338875],
            [-3.3658138468421823, 7.457907172507548],
            [-3.3721919641930143, 7.457077541539014],
            [-3.3749248351348284, 7.459933597033963],
            [-3.3806508381684215, 7.457388182542322],
            [-3.3802292194139225, 7.45215123139585],
            [-3.378234012172623, 7.448024326023018],
            [-3.382744739616062, 7.4451587746498005],
            [-3.3836307071413105, 7.448338080801305],
            [-3.388616127649166, 7.448265473303499],
            [-3.3973123774600893, 7.441835702794394],
            [-3.404177886524982, 7.447003008125365],
            [-3.40325808052954, 7.450990132341191],
            [-3.406450581296094, 7.452290486299105],
            [-3.405884857521081, 7.45683757991147],
            [-3.408964893592869, 7.456925520499756],
            [-3.4141422617887405, 7.454371727029026],
            [-3.414499677645174, 7.451808953113863],
            [-3.4223786670349705, 7.446441684858108],
            [-3.4245532284636093, 7.447542673267227],
            [-3.4247308274234687, 7.451881328664567],
            [-3.4309493217664455, 7.451425742101604],
            [-3.435148933078472, 7.4538228920529885],
            [-3.4352631956176496, 7.458089339077339],
            [-3.4382476075765873, 7.458625286157204],
            [-3.4416920276956278, 7.465305587531529],
            [-3.442304066843556, 7.47041822625193],
            [-3.44952887392533, 7.471594518278788],
            [-3.4602828623116317, 7.463803947031231],
            [-3.4581559082322864, 7.460822203092843],
            [-3.460383967597202, 7.451549141064203],
            [-3.4649439179293964, 7.4509592443984225],
            [-3.466923523564418, 7.453751147566266],
            [-3.4702480810797627, 7.449778849867729],
            [-3.4722959471439037, 7.451827121588043],
            [-3.478343789248139, 7.450922465011179],
            [-3.4824034670322, 7.45356139364381],
            [-3.4878367690458147, 7.454019693787963],
            [-3.4893430250042488, 7.46047778582197],
            [-3.4931495852007424, 7.457598593481949],
            [-3.5012826995447814, 7.461027509994064],
            [-3.504666194369262, 7.464786913329698],
            [-3.5098417765433956, 7.464484836347275],
            [-3.513109329976882, 7.467906456726388],
            [-3.517007996853338, 7.475716939245201],
            [-3.524360587579021, 7.476849566830188],
            [-3.529560532647472, 7.468755941313612],
            [-3.536795540795918, 7.469625004735794],
            [-3.534622667075444, 7.47407063360497],
            [-3.531689714025538, 7.473232892726599],
            [-3.53069673500435, 7.4806057175439555],
            [-3.5348580041330226, 7.4784129703904],
            [-3.53563965970405, 7.481656451710494],
            [-3.5424419125560545, 7.4743873032254315],
            [-3.5429194906971766, 7.471833364984949],
            [-3.5510605043203096, 7.480621636925686],
            [-3.553067164237757, 7.477367678838446],
            [-3.5564670006830155, 7.479295817576521],
            [-3.5603102746095696, 7.476629119292196],
            [-3.5620506659760767, 7.478434391051446],
            [-3.566353087496678, 7.4753643475309355],
            [-3.5684018836089773, 7.470684972561703],
            [-3.5726460131497175, 7.474115271293788],
            [-3.5765571183855025, 7.470976392870789],
            [-3.583776987634241, 7.480696962026429],
            [-3.586476965447018, 7.48141572636858],
            [-3.5876242029427723, 7.47698562192353],
            [-3.5951826873793706, 7.477768712070568],
            [-3.5975603534681664, 7.488477778238412],
            [-3.6019340466755803, 7.492001033297587],
            [-3.5951490498574574, 7.495691575529691],
            [-3.597194805770354, 7.498466421684385],
            [-3.5966447137795448, 7.504799744312615],
            [-3.5991745470005614, 7.5071290769196795],
            [-3.5965835444554495, 7.510234489746122],
            [-3.5983086802826376, 7.517474901267955],
            [-3.6031755178582676, 7.516003287757873],
            [-3.6025153879891647, 7.512994847319178],
            [-3.6074758369260036, 7.509625150044254],
            [-3.6108908672543745, 7.511327818197421],
            [-3.61590677432457, 7.508686027954555],
            [-3.6174292823539327, 7.513653672749891],
            [-3.630115718062179, 7.51543812775061],
            [-3.6318399830695998, 7.512010862783127],
            [-3.62894553101634, 7.508273359753005],
            [-3.6303902368626884, 7.503128845389672],
            [-3.641088903435058, 7.509230107892187],
            [-3.6418689700193565, 7.504837198427207],
            [-3.646809092620857, 7.507319289264578],
            [-3.6527661880406472, 7.504538917342804],
            [-3.6570914093048006, 7.508794702704951],
            [-3.6581431127307056, 7.5131422604556715],
            [-3.663910711904538, 7.513364167458478],
            [-3.6667631660394373, 7.506902430078617],
            [-3.671544634646289, 7.50611061158754],
            [-3.6751365942141025, 7.4995133871235025],
            [-3.6831087105361906, 7.503926713271135],
            [-3.6862275893548753, 7.497956031770435],
            [-3.6922109658607045, 7.497284238463311],
            [-3.6985877950460915, 7.497995457585514],
            [-3.699851963197585, 7.506230513086351],
            [-3.7028851055917285, 7.504109523245269],
            [-3.6986430652232074, 7.568494413037555],
            [-3.693038043171647, 7.6542406142816874],
            [-3.6882038650775972, 7.731566005194812],
            [-3.721984074196016, 7.733625499200523],
            [-3.718977159922548, 7.781923121148417],
            [-3.7128665266329772, 7.890839946383386],
            [-3.7126488458020077, 7.891963454810382],
            [-3.7080925748864466, 7.9763670431472375],
            [-3.7029290738603815, 8.07615408960741],
            [-3.7342117232044, 8.078243923341313],
            [-3.730176988312607, 8.134027867668902],
            [-3.7283245873380455, 8.163618890061162]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.63961725096252,
          "lat": 46.358315228986434
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38037"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01035300"
      },
      "bbox": [
        -3.7342117232044, 7.441835702794394, -3.0148581093100444,
        8.163618890061162
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2874961945317276, 9.199321271697954],
            [-2.2084697570233436, 9.196142971378015],
            [-2.2006912993094567, 9.195718060834205],
            [-2.113746022178763, 9.19203507968168],
            [-2.0406419499620547, 9.18915169250903],
            [-1.9686759895162704, 9.18614702897196],
            [-1.9403609006811087, 9.18480844253554],
            [-1.9109544514182366, 9.183853095483364],
            [-1.8093448377818124, 9.18016937114158],
            [-1.7657325454610544, 9.178765424571242],
            [-1.768581545418731, 9.101147669061966],
            [-1.768679113449045, 9.093667951582322],
            [-1.7717960688865364, 9.008486729145881],
            [-1.7503759496918458, 9.007721654267549],
            [-1.7533482552163229, 8.924025906867566],
            [-1.7565526076017643, 8.838847161080228],
            [-1.7596064109613296, 8.754078374009728],
            [-1.7625293702421494, 8.668255088025187],
            [-1.8496384733984923, 8.671249977729413],
            [-1.908928220212929, 8.673421947692473],
            [-2.0242991130495227, 8.677817905939808],
            [-2.1258903864729355, 8.68179629035688],
            [-2.197739352816948, 8.684831121427662],
            [-2.285082091714311, 8.688264848053329],
            [-2.2813239569587034, 8.773746944564747],
            [-2.2774661916067354, 8.859126047561672],
            [-2.2738116632780248, 8.94443313586892],
            [-2.270151529380227, 9.028081673035032],
            [-2.2950831039275688, 9.02911025027219],
            [-2.291259711534287, 9.114108237609752],
            [-2.2874961945317276, 9.199321271697954]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.66095801492014, "lat": 47.58750236377153 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38103"],
        "coty_name": ["Wells"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wells County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01034204"
      },
      "bbox": [
        -2.2950831039275688, 8.668255088025187, -1.7503759496918458,
        9.199321271697954
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.947733507724545, 0.5519762398647938],
            [9.943730632078925, 0.5967752791165956],
            [9.940741354496314, 0.642951114089232],
            [9.93680661805019, 0.7093917222860967],
            [9.932615177502404, 0.781913993348354],
            [9.92727874021356, 0.8625597120449888],
            [9.923931305761982, 0.9148548788172721],
            [9.922795403286349, 0.9363029508699006],
            [9.969865895408361, 0.9408891418139704],
            [9.988558065583957, 0.9481504250276284],
            [10.040993935622634, 0.9671842452633352],
            [10.064666531737451, 0.9753823725266394],
            [10.137389334047894, 1.00001979148775],
            [10.183198233201116, 1.0037304064126051],
            [10.191954653959515, 1.004266779992843],
            [10.193927729229086, 0.9989714746583893],
            [10.198498069244021, 0.9929891180162896],
            [10.202499262821064, 0.9922972559860282],
            [10.207425658732967, 0.9895115296532443],
            [10.215448775963093, 0.9825233463287335],
            [10.217953753625425, 0.9790304741094693],
            [10.226394703984049, 0.9764498745548635],
            [10.230229896255933, 0.9723337844122922],
            [10.243020736261602, 0.8867139972016002],
            [10.249908183376673, 0.839227726160348],
            [10.267368036038386, 0.7125744811212156],
            [10.273487879187797, 0.6665361993380094],
            [10.285763338385692, 0.5751116862689157],
            [10.286714153865516, 0.5748818004506191],
            [10.286022010734575, 0.5716570448488769],
            [10.27435124728516, 0.5539238969971371],
            [10.268818008089188, 0.5504766628534249],
            [10.262652966458177, 0.5512677319851833],
            [10.254677562756052, 0.5554287411095105],
            [10.249206792914288, 0.5607334931556146],
            [10.246332128155839, 0.5672762657186725],
            [10.242623612350156, 0.581623904983154],
            [10.23767303069474, 0.587962638160673],
            [10.227092723597739, 0.5948825956689675],
            [10.213372096560166, 0.6015363089607795],
            [10.204934909695046, 0.605020373201875],
            [10.190445999565345, 0.607805051908126],
            [10.169088788604668, 0.6083467929271793],
            [10.162580980199921, 0.6094450127230778],
            [10.146966120689552, 0.6083182453696192],
            [10.14181477829048, 0.6084302632718268],
            [10.13359142632262, 0.611231193867067],
            [10.12495745607202, 0.6116185702684912],
            [10.108901500368555, 0.6243906444265392],
            [10.103099080347983, 0.6277860844885575],
            [10.093981274646637, 0.6317425628915947],
            [10.08736803098636, 0.633373808306844],
            [10.080769801764804, 0.6338557316720889],
            [10.071403453338682, 0.6316622023056111],
            [10.059612470641563, 0.6267286817630661],
            [10.045222500811281, 0.6187800498597593],
            [10.028271600103782, 0.6124189517702829],
            [10.021504057998404, 0.6065969204496887],
            [10.015596479698562, 0.6069168621949094],
            [10.011869376505684, 0.6053662035081576],
            [10.002669301775276, 0.5994942162997634],
            [9.99813101545653, 0.5907375698629106],
            [9.99672464453357, 0.5851077408326761],
            [9.996350899207572, 0.5669881875743585],
            [9.994333225091633, 0.5546962314983239],
            [9.992499356245702, 0.5497683516506012],
            [9.986233982940952, 0.5449265814575611],
            [9.98101417317523, 0.5430679708984065],
            [9.975331867010606, 0.5429649945785265],
            [9.9635503351618, 0.5459969897913125],
            [9.947733507724545, 0.5519762398647938]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.47214684371203,
          "lat": 38.845494842399816
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01074014"
      },
      "bbox": [
        9.922795403286349, 0.5429649945785265, 10.286714153865516,
        1.004266779992843
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.038327952764098, 3.5527499668198854],
            [9.06701331803218, 3.5570420662921136],
            [9.14805074459442, 3.570175251424539],
            [9.23240667968276, 3.583948935771482],
            [9.316502261883041, 3.5983209244151433],
            [9.331567763060916, 3.6003840887135166],
            [9.403987222386935, 3.6127793142232947],
            [9.418209632232731, 3.614727911999927],
            [9.42764372457191, 3.5527555660880465],
            [9.43357062635159, 3.5127310619346312],
            [9.429839726625664, 3.512223175853794],
            [9.433472504682728, 3.483820448557777],
            [9.446124613911609, 3.382498363492387],
            [9.403131432626628, 3.3766755783980296],
            [9.303588041545408, 3.362914442301677],
            [9.27526374882538, 3.359589504391684],
            [9.22199356269278, 3.3523756458207723],
            [9.191183719448045, 3.3487224297191505],
            [9.152094232673624, 3.34367696331288],
            [9.119977866372814, 3.339760999243453],
            [9.107889379392262, 3.3379924253845656],
            [9.104254484556213, 3.3665236682483153],
            [9.075746585783783, 3.3628539676233093],
            [9.068492026122179, 3.4208232742626787],
            [9.06269049687593, 3.465425014258352],
            [9.050094387129892, 3.4641347839105223],
            [9.04256391737659, 3.5201368393670447],
            [9.038327952764098, 3.5527499668198854]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.13008050943148, "lat": 41.60182247266602 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39051"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01074038"
      },
      "bbox": [
        9.038327952764098, 3.3379924253845656, 9.446124613911609,
        3.614727911999927
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.715048805582574, 1.9715158922018359],
            [10.748970064293156, 1.9738952060561397],
            [10.749392663626196, 1.9683627409706728],
            [10.811535117437789, 1.9727978983806416],
            [10.889632176416857, 1.9793041671486826],
            [10.944047213485522, 1.9832962152538303],
            [10.949073999194942, 1.922172000427157],
            [10.95124451959168, 1.8940038228645308],
            [10.97985009011672, 1.8962062267502233],
            [11.02502760874576, 1.9002376224721882],
            [11.0289071350034, 1.854652679429541],
            [11.032582117280365, 1.8110543721402372],
            [11.075240347263772, 1.8143106289720627],
            [11.082329036346216, 1.7255851570758325],
            [11.08593615228906, 1.681431690136303],
            [11.086637365076015, 1.6677803105458207],
            [11.089416221591343, 1.6384662129276428],
            [11.083339410489087, 1.6381879250229756],
            [11.028019494837869, 1.633853559024297],
            [11.021236719119376, 1.633058573853874],
            [10.998134378717362, 1.6315086841461757],
            [10.991220133749596, 1.630732970273847],
            [10.91841817120372, 1.6255392541677245],
            [10.915499242036432, 1.6541278963388515],
            [10.886815997493342, 1.6515202614647535],
            [10.848534588462565, 1.6490611565338116],
            [10.825506533889467, 1.6473569372646721],
            [10.823016866335312, 1.684389680695823],
            [10.821159525439944, 1.7060801898951485],
            [10.814926935033084, 1.7944340751802508],
            [10.785826811200552, 1.7923639811352392],
            [10.785440931876884, 1.8000779645297729],
            [10.78047111661178, 1.866904745586934],
            [10.778862679665274, 1.8815097588202574],
            [10.757406023211846, 1.87986961972888],
            [10.721172739639236, 1.8774692712965713],
            [10.720088112848154, 1.8888878551315502],
            [10.719662063543957, 1.9003741295533805],
            [10.715048805582574, 1.9715158922018359]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.23615526865333, "lat": 39.73715586153638 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39127"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01074076"
      },
      "bbox": [
        10.715048805582574, 1.6255392541677245, 11.089416221591343,
        1.9832962152538303
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.12911154574546868, -4.580504106695438],
            [0.12970121262616052, -4.493182396780125],
            [0.13043430982560777, -4.366049819758577],
            [0.13060229734671366, -4.318171333212725],
            [0.18036774299217945, -4.318451428738625],
            [0.2472196056115972, -4.31867167612506],
            [0.2732007280575582, -4.318632921632405],
            [0.34472958544376925, -4.31886933569385],
            [0.34498266823190044, -4.304841588419098],
            [0.34484921556595377, -4.2307781039798655],
            [0.38851159957036435, -4.230618361112347],
            [0.3885428085456249, -4.1286808596610385],
            [0.388670430992129, -4.055251379883749],
            [0.3915460440834693, -4.055433127092494],
            [0.5211170455090135, -4.055278525955486],
            [0.5598186457779865, -4.055309710639541],
            [0.5600995839251494, -4.142747548817325],
            [0.6216147602199367, -4.142516327451357],
            [0.7317113277970122, -4.142140632734407],
            [0.7320630190724347, -4.229552182857736],
            [0.6442841535419086, -4.229955868922518],
            [0.6444027953423267, -4.319498740696529],
            [0.6446114115602081, -4.410813654883844],
            [0.6448039528728716, -4.489588897437764],
            [0.6450324396596857, -4.566509748797743],
            [0.6449050949896307, -4.581630404259507],
            [0.5302383190258454, -4.581776603377871],
            [0.4706557700238134, -4.581733216454636],
            [0.3425118256951667, -4.581477941853214],
            [0.2818063448035301, -4.58131621508143],
            [0.20039229189134616, -4.580914938182981],
            [0.14452527158546702, -4.580721156604911],
            [0.12911154574546868, -4.580504106695438]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.03784006383648,
          "lat": 34.373647898712555
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40005"],
        "coty_name": ["Atoka"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Atoka County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01101790"
      },
      "bbox": [
        0.12911154574546868, -4.581776603377871, 0.7320630190724347,
        -4.055251379883749
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.454242280308407, -2.9988612151996166],
            [-0.45351853841445194, -2.9335799789101786],
            [-0.45317536104093437, -2.9188072439673087],
            [-0.45284256625839425, -2.8530406612648602],
            [-0.4524122249802482, -2.823396528457515],
            [-0.451706829211017, -2.8234130511291844],
            [-0.45121863498924797, -2.779576181643852],
            [-0.4352700058412004, -2.779533826060268],
            [-0.31145260103460504, -2.7811870996903303],
            [-0.27992321596848035, -2.7813899016284513],
            [-0.265883647601879, -2.7820223817136065],
            [-0.24167107141735386, -2.7820150963304475],
            [-0.23718839074600023, -2.7816924717409806],
            [-0.19429098535011163, -2.7819221128089917],
            [-0.1517474614450876, -2.782442337177629],
            [-0.08004821764621427, -2.783040223070025],
            [-0.06580830738628199, -2.783551630700915],
            [-0.0516543154922125, -2.7833864124917187],
            [-0.033349124406297365, -2.7838646678349632],
            [-0.03402011170501398, -2.795084996812699],
            [-0.033723381912562266, -2.8617428842313557],
            [-0.03434475029759152, -2.9422934051535115],
            [-0.03545282412136578, -3.017488030194653],
            [-0.03525181479226831, -3.0253957974850545],
            [-0.036184653686994285, -3.0722852990013143],
            [-0.03628451730235833, -3.0887822671372094],
            [-0.037556966422520766, -3.176668531169411],
            [-0.04055686979842702, -3.26636598963416],
            [-0.13027615405046047, -3.2654982334855855],
            [-0.2156707258304956, -3.264324335835175],
            [-0.3154015370800533, -3.263221773995197],
            [-0.36532451973284297, -3.262778979061731],
            [-0.4313984433172993, -3.2619873659131806],
            [-0.4367548643676042, -3.261345556323212],
            [-0.4577392165437061, -3.261216667441817],
            [-0.4572720163788498, -3.2324433383990527],
            [-0.45665515243839616, -3.1743859443294746],
            [-0.45622396045598945, -3.1734672303631357],
            [-0.4561272796171784, -3.1448424143227354],
            [-0.45521084510828314, -3.0644170622358957],
            [-0.4543884906577897, -3.0172473290772936],
            [-0.454242280308407, -2.9988612151996166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.88090301028667, "lat": 35.70294404516082 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40081"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01101828"
      },
      "bbox": [
        -0.4577392165437061, -3.26636598963416, -0.033349124406297365,
        -2.779533826060268
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6193922829460533, -2.5584915891912727],
            [-0.540622112060593, -2.5593048091143986],
            [-0.44865543367165006, -2.560569978207751],
            [-0.44783873767005417, -2.4726365872267544],
            [-0.3468301641670086, -2.473749698180849],
            [-0.27535147394638787, -2.4744703278398106],
            [-0.19058340078152503, -2.475243331729823],
            [-0.19024258650951173, -2.491971984855874],
            [-0.19063634428219645, -2.5051058815838108],
            [-0.1913748238647039, -2.563567711408407],
            [-0.1780593237648864, -2.563204212017903],
            [-0.16335240442083157, -2.5634548902722156],
            [-0.09992767115820671, -2.563571962410966],
            [-0.06537215035528784, -2.5637888114643403],
            [-0.0338841324866688, -2.563735022331912],
            [-0.03334084701168844, -2.5637123555003947],
            [-0.03425641200789238, -2.5973457488058527],
            [-0.034874923353532386, -2.6634806939403104],
            [-0.034513343936886626, -2.738063276689512],
            [-0.033349124406297365, -2.7838646678349632],
            [-0.0516543154922125, -2.7833864124917187],
            [-0.06580830738628199, -2.783551630700915],
            [-0.08004821764621427, -2.783040223070025],
            [-0.1517474614450876, -2.782442337177629],
            [-0.19429098535011163, -2.7819221128089917],
            [-0.23718839074600023, -2.7816924717409806],
            [-0.24167107141735386, -2.7820150963304475],
            [-0.265883647601879, -2.7820223817136065],
            [-0.27992321596848035, -2.7813899016284513],
            [-0.31145260103460504, -2.7811870996903303],
            [-0.4352700058412004, -2.779533826060268],
            [-0.45121863498924797, -2.779576181643852],
            [-0.4529207916862362, -2.767228368771231],
            [-0.4598256338299516, -2.772988263144834],
            [-0.4653328058512804, -2.776218001783884],
            [-0.47673509643054673, -2.7802590485530487],
            [-0.49050937555839835, -2.7799368702459235],
            [-0.5017250496208144, -2.7761272483104293],
            [-0.5052724474208058, -2.7730931745184826],
            [-0.5064188170597697, -2.7693797471418033],
            [-0.5155857095948579, -2.756011498761211],
            [-0.5331125695712665, -2.7481133585054076],
            [-0.5606620151519759, -2.7461353364629963],
            [-0.567245356635462, -2.739283715277102],
            [-0.5660897931615952, -2.7343006754970562],
            [-0.5666694204497121, -2.727898801254856],
            [-0.5682923184884003, -2.7229446719837087],
            [-0.5738885695622256, -2.7139207363859894],
            [-0.5785273675745424, -2.7101108730763936],
            [-0.585041447272289, -2.708290409430378],
            [-0.5970711705133033, -2.7082379347567618],
            [-0.6008631983117, -2.712182766171042],
            [-0.6055112455912963, -2.714379213309252],
            [-0.6102399901277926, -2.7253982538673247],
            [-0.6161748737772352, -2.7306267630300574],
            [-0.6216862824807757, -2.734048046928712],
            [-0.6207128362842623, -2.66034270122365],
            [-0.6197454544055102, -2.601548224584709],
            [-0.6193922829460533, -2.5584915891912727]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.97565009914847, "lat": 36.07727820099273 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40119"],
        "coty_name": ["Payne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Payne County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01101847"
      },
      "bbox": [
        -0.6216862824807757, -2.7838646678349632, -0.03334084701168844,
        -2.4726365872267544
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.31262004160702, 8.53111010920309],
            [-19.29216702540964, 8.524044423270153],
            [-19.278525028281297, 8.518878583909467],
            [-19.277886695033075, 8.520847370255566],
            [-19.19437097039501, 8.495987163769028],
            [-19.19275237436542, 8.501282003976328],
            [-19.18953193966318, 8.50021622737276],
            [-19.095544230466306, 8.472618357847773],
            [-19.07951081173784, 8.468096882430823],
            [-19.038238939551043, 8.456242667684311],
            [-19.039293681447848, 8.452744865248153],
            [-18.956992286128408, 8.42466986065466],
            [-18.95534208765347, 8.42958358815479],
            [-18.94169003334975, 8.426256630099168],
            [-18.93001262387844, 8.421571873553988],
            [-18.872633127128786, 8.404736351744589],
            [-18.858603094636756, 8.399601285074782],
            [-18.803806198390625, 8.384061604510512],
            [-18.80303381362213, 8.386633715722288],
            [-18.746396180410454, 8.37006090228537],
            [-18.672273670045353, 8.34845325851736],
            [-18.67098438459441, 8.341748560819223],
            [-18.672778767809074, 8.330893529481006],
            [-18.675440521321057, 8.32432901526914],
            [-18.680186803372298, 8.318276551380368],
            [-18.67874298927543, 8.314045185102412],
            [-18.6754211056193, 8.31019150234689],
            [-18.674470910686235, 8.299011680298905],
            [-18.66859168702778, 8.293193079034339],
            [-18.66783729930955, 8.288094633207256],
            [-18.6773920413734, 8.277904715149171],
            [-18.677243863552444, 8.275293514784996],
            [-18.683548855329605, 8.270000584407057],
            [-18.685689302637936, 8.265807242194779],
            [-18.621411075388103, 8.247099223001298],
            [-18.598371852629008, 8.240536132185142],
            [-18.557817548907668, 8.2293170554228],
            [-18.507395229851994, 8.214903090875975],
            [-18.48982945357822, 8.270221082888566],
            [-18.463506641010188, 8.262495506754266],
            [-18.455523997739512, 8.289491132853362],
            [-18.452354451812244, 8.286791184292014],
            [-18.44733811062866, 8.285301372294091],
            [-18.442602162981558, 8.281938105906363],
            [-18.442116505810358, 8.27930369736202],
            [-18.435815127255246, 8.279838469948075],
            [-18.43296452447921, 8.277688037301584],
            [-18.43279314231661, 8.273875872388643],
            [-18.430058811230435, 8.268745283437477],
            [-18.423619116440456, 8.268912054839346],
            [-18.41670582359954, 8.274973684394302],
            [-18.403312490823858, 8.272784716056554],
            [-18.40090037430866, 8.26982947046474],
            [-18.39539431097927, 8.268621110029457],
            [-18.38420782568596, 8.272362866454195],
            [-18.381713417541995, 8.271162198581171],
            [-18.37698114890258, 8.264294447424545],
            [-18.37087086086889, 8.265374453083943],
            [-18.36864921388552, 8.263045566956276],
            [-18.363176120532753, 8.26396232998919],
            [-18.3598919625436, 8.26140959639327],
            [-18.360346703947148, 8.25791716868843],
            [-18.347695448623135, 8.249196242051303],
            [-18.344296873071585, 8.250000613822063],
            [-18.338506673326872, 8.242158795377778],
            [-18.329632242219493, 8.239199508689186],
            [-18.3258901010932, 8.233345491890864],
            [-18.31773189934158, 8.233282585279143],
            [-18.311361686110256, 8.226843705723082],
            [-18.311616687771387, 8.220170239725068],
            [-18.313723002257976, 8.213920836871786],
            [-18.311297702851626, 8.208895704790644],
            [-18.299202689313617, 8.206059300713214],
            [-18.28862049301524, 8.197237204408603],
            [-18.280912467002658, 8.195250091719648],
            [-18.276980184284934, 8.188709384277502],
            [-18.271619735916868, 8.184508908726164],
            [-18.271063020222122, 8.182326937550817],
            [-18.274195007199253, 8.17821915405671],
            [-18.267149245080283, 8.175759211931565],
            [-18.263138992155667, 8.176964918243419],
            [-18.26089580400318, 8.175244093389532],
            [-18.25574517425028, 8.175565378481576],
            [-18.253384508356813, 8.178044684774976],
            [-18.24368325256321, 8.174791067053103],
            [-18.24338732086386, 8.169552649548],
            [-18.241057004370468, 8.16540833845038],
            [-18.23384844198735, 8.167721687928708],
            [-18.229525836127415, 8.167340903380813],
            [-18.229549014125713, 8.16350917460928],
            [-18.2252161745818, 8.15592953497927],
            [-18.220794295590114, 8.15533545243612],
            [-18.218193270998167, 8.152180493141119],
            [-18.21497990232719, 8.153294702092445],
            [-18.20863428758872, 8.148676862276346],
            [-18.204750705080677, 8.15089284145175],
            [-18.199045659829082, 8.149931850675438],
            [-18.19376748066016, 8.144304031227104],
            [-18.188970654104796, 8.140584158070586],
            [-18.18180788655335, 8.140585168419479],
            [-18.1784061861839, 8.142304621566797],
            [-18.172527157098873, 8.13743341990626],
            [-18.1718556044273, 8.13978316165361],
            [-18.157902957273024, 8.135762921587055],
            [-18.15892764878624, 8.132291186435047],
            [-18.145000968315543, 8.128489984752866],
            [-18.146670459771826, 8.122713404576892],
            [-18.14368017867373, 8.120245534315927],
            [-18.139434057205328, 8.120052824275788],
            [-18.135181153471713, 8.11778701219405],
            [-18.12782457801204, 8.119788160110069],
            [-18.122045779483816, 8.125817321415129],
            [-18.113563612321443, 8.124290259326457],
            [-18.109449564029585, 8.128732002556532],
            [-18.10588061230823, 8.128400383334304],
            [-18.101788452647796, 8.130899218062424],
            [-18.101792865957243, 8.134544888998246],
            [-18.0989575774629, 8.136699558914934],
            [-18.102067043605494, 8.140696701103364],
            [-18.101969504056076, 8.143538237241616],
            [-18.095736734997796, 8.151548885151017],
            [-18.052778940092992, 8.139256105056749],
            [-18.05244586622096, 8.140418730806953],
            [-17.971176270115826, 8.117704489767137],
            [-17.88991138268294, 8.094972467923863],
            [-17.889288706129573, 8.097219285038895],
            [-17.842304854625784, 8.0853554311501],
            [-17.731531610904227, 8.05572776664041],
            [-17.73116617086435, 8.051846581583753],
            [-17.72721307038567, 8.045306795495183],
            [-17.72880827903979, 8.041763602928192],
            [-17.72824823321326, 8.03676266027976],
            [-17.72970198869271, 8.031202848563062],
            [-17.72931867341155, 8.02147974783388],
            [-17.727384024106335, 8.019867436349411],
            [-17.7273174029376, 8.013942137519729],
            [-17.732394163254085, 8.01211706571728],
            [-17.735610116265796, 8.004815749005848],
            [-17.733755853839444, 7.998269708336192],
            [-17.73626895755635, 7.991589952791969],
            [-17.732380127048767, 7.985720914431769],
            [-17.733157592031926, 7.9812605134647985],
            [-17.740198102885294, 7.972914608497637],
            [-17.739559974334068, 7.968557006980459],
            [-17.73679331664234, 7.963657648860669],
            [-17.738419101147034, 7.95992538424403],
            [-17.74233562733193, 7.957294133017006],
            [-17.746038116623627, 7.958140578786578],
            [-17.75045688710132, 7.94769997603572],
            [-17.745001004487378, 7.937295147694597],
            [-17.748320213968974, 7.921793339939498],
            [-17.748392890451317, 7.91286908210864],
            [-17.751637004762493, 7.906424865898276],
            [-17.752949340849014, 7.8997796882351725],
            [-17.754857249238857, 7.898513133327061],
            [-17.75794094148956, 7.890522230873724],
            [-17.761576104837026, 7.8889473049327306],
            [-17.76588629442421, 7.881451755958008],
            [-17.77378508258015, 7.8783640756898485],
            [-17.782406733926738, 7.866958489967884],
            [-17.7871618391995, 7.863293781654734],
            [-17.78876955518555, 7.859455740223419],
            [-17.795517333479303, 7.861804809571623],
            [-17.801552430352423, 7.86113866825304],
            [-17.803281828453322, 7.858526168565333],
            [-17.81573565958115, 7.850728213238023],
            [-17.812920145129887, 7.841832649450298],
            [-17.813611502156686, 7.837476101720871],
            [-17.813285808171013, 7.824595143560466],
            [-17.820773160043096, 7.811417460126968],
            [-17.826862956387767, 7.806393289161589],
            [-17.831830968208077, 7.799045409869953],
            [-17.836836299755415, 7.796738342142852],
            [-17.838646940340762, 7.791428388962801],
            [-17.8345205771156, 7.788004022530853],
            [-17.841601178257516, 7.785771428725496],
            [-17.850183534170128, 7.786153541973023],
            [-17.853016514168708, 7.783093815112951],
            [-17.85373360978109, 7.776081176881409],
            [-17.858841074772528, 7.765625210891529],
            [-17.861218931368008, 7.758836713892474],
            [-17.864784656318186, 7.756185774265674],
            [-17.86820604147573, 7.745405168046324],
            [-17.873101556493324, 7.737361502025684],
            [-17.879382828964456, 7.734949447818935],
            [-17.88921215143515, 7.738513358631776],
            [-17.893041213122707, 7.743302858324605],
            [-17.89419515372055, 7.747372442899941],
            [-17.897903714135467, 7.74577932876534],
            [-17.903385413196332, 7.746837221260618],
            [-17.908519839031342, 7.746456628060706],
            [-17.91144904141241, 7.744577867357435],
            [-17.91448618989773, 7.746054984739381],
            [-17.91769919331171, 7.743188105524291],
            [-17.924421447903086, 7.740221250022065],
            [-17.919499611425, 7.736920635477738],
            [-17.921439414198165, 7.73252203773489],
            [-17.930445114633986, 7.726806368954006],
            [-17.933574013271635, 7.723331495895363],
            [-17.939527000638364, 7.7208561892322445],
            [-17.94174160868337, 7.71487755044603],
            [-17.95196779578589, 7.711602156070177],
            [-17.95840229554623, 7.708629164734237],
            [-17.960882935893558, 7.70561306582416],
            [-17.964675773439318, 7.6947573096966],
            [-17.964326933282205, 7.69155949562525],
            [-17.9668467990431, 7.6848268566299796],
            [-17.970611687846258, 7.678304524912808],
            [-17.968007578248283, 7.676156078166186],
            [-17.97339799368386, 7.662559672434052],
            [-17.967941902647958, 7.661271490498751],
            [-17.96598415283477, 7.6576017310972215],
            [-17.968000310118594, 7.652186296469412],
            [-17.971558295952757, 7.650105044441105],
            [-17.974663080851798, 7.636504594791233],
            [-17.973548396287494, 7.627647659308902],
            [-17.97901996076832, 7.625067086896501],
            [-17.98113522405861, 7.617992541716916],
            [-17.976838382851778, 7.6130833392998305],
            [-17.98472430908992, 7.608127987640949],
            [-17.99124811044106, 7.599740952679063],
            [-17.99619174212584, 7.596978725143932],
            [-17.996135733652935, 7.592950088401453],
            [-17.993914030628922, 7.58898226737345],
            [-17.99429687518826, 7.583706769058119],
            [-17.999143022419442, 7.578655110506654],
            [-17.99792110997218, 7.569398678459384],
            [-18.000743201015016, 7.56484805585284],
            [-18.00077994849647, 7.560273995062191],
            [-17.99693476729068, 7.557165847909784],
            [-18.00249703195039, 7.551355890339468],
            [-18.004789363157435, 7.546067269436628],
            [-18.008991116470796, 7.543731792468375],
            [-18.015046688434886, 7.529922065334394],
            [-18.019210608836588, 7.52485543537112],
            [-18.021702938407245, 7.520056174446944],
            [-18.023753039999292, 7.511131675634313],
            [-18.023680874816158, 7.497830617739657],
            [-18.020640465181717, 7.492788747376585],
            [-18.01872327236459, 7.486267892206135],
            [-18.018859499444403, 7.482735596854336],
            [-18.02502165508101, 7.483838866268624],
            [-18.0408853356631, 7.488830356525254],
            [-18.045405259581727, 7.4788559749485755],
            [-18.05306511263224, 7.47454952825674],
            [-18.057038228378893, 7.476319605429415],
            [-18.060060092923308, 7.4737421197537035],
            [-18.067217590790587, 7.4726299095603155],
            [-18.07457905154481, 7.472617962713596],
            [-18.081661397080456, 7.47072882678782],
            [-18.083997377407258, 7.467965925679029],
            [-18.089642793491457, 7.466786888719909],
            [-18.096069638323996, 7.463905897345085],
            [-18.10095211651308, 7.465627037256971],
            [-18.10175555818581, 7.459504498497207],
            [-18.111394097473667, 7.458054528404718],
            [-18.113733362081167, 7.46074498669672],
            [-18.118534022433348, 7.4617036619980155],
            [-18.121937958070436, 7.457897487728709],
            [-18.12678536412193, 7.459114997092305],
            [-18.130303556370574, 7.454703466742866],
            [-18.139183425391238, 7.450121226682626],
            [-18.14463964836798, 7.451119916648777],
            [-18.147594190493177, 7.448173822316622],
            [-18.150541722494953, 7.447953926643492],
            [-18.155528758993956, 7.441227492649968],
            [-18.157724512180966, 7.436777482596222],
            [-18.164236743276042, 7.4309051277275255],
            [-18.16407332331257, 7.424302175747156],
            [-18.168096978305833, 7.422980168339073],
            [-18.173389836988306, 7.416473522405362],
            [-18.172279027233223, 7.408795326596317],
            [-18.16433725061268, 7.403320607500939],
            [-18.163770095984184, 7.398255290447305],
            [-18.165928121437506, 7.392730668760747],
            [-18.165424386454358, 7.389601143958977],
            [-18.168022198276827, 7.385236624509357],
            [-18.170665995415472, 7.383902655653545],
            [-18.170191055954973, 7.37868773847967],
            [-18.17226956002054, 7.376944006167097],
            [-18.17303446100363, 7.372368783851326],
            [-18.17778504418178, 7.363591166941108],
            [-18.18183664104036, 7.362957591575487],
            [-18.1836944356493, 7.351491912627832],
            [-18.188451912047114, 7.352564607463883],
            [-18.19018545615605, 7.348942314753419],
            [-18.19570604446827, 7.3471113068227565],
            [-18.193188358553414, 7.341039521120234],
            [-18.18790477703647, 7.342116102102736],
            [-18.183184039824976, 7.335901553505521],
            [-18.279630364985383, 7.362742656926207],
            [-18.27919879363754, 7.364296151556079],
            [-18.401896040215483, 7.39870918518989],
            [-18.44453417062418, 7.4106630916394245],
            [-18.44482226368626, 7.409657677452806],
            [-18.52432626182475, 7.43232344601213],
            [-18.524849612556235, 7.430602435693624],
            [-18.60761576337654, 7.453165065492815],
            [-18.603259974576563, 7.467078406931569],
            [-18.585383045782088, 7.529940544689309],
            [-18.57778358136933, 7.555828044503],
            [-18.60548892299699, 7.5630031710040155],
            [-18.641461931802805, 7.574155751544135],
            [-18.68230726595137, 7.586100897605669],
            [-18.69619028874116, 7.589070722868553],
            [-18.710005850117508, 7.593545554263161],
            [-18.73734700699993, 7.598665956441836],
            [-18.74911031016225, 7.601355033924152],
            [-18.749679848627142, 7.599441032427423],
            [-18.832393865604754, 7.624486742451586],
            [-18.831940660538248, 7.626519514691261],
            [-18.813666504179785, 7.687389986422126],
            [-18.83433962007739, 7.69341802134695],
            [-18.814463522044157, 7.761468934320434],
            [-18.797758583628987, 7.817997434696691],
            [-18.793092322612456, 7.834643526422279],
            [-18.78526188048755, 7.859343686725385],
            [-18.81887534683365, 7.868985211101303],
            [-18.905680623519764, 7.894726517750223],
            [-18.93059828046125, 7.902295678773467],
            [-18.922291108103206, 7.929981577765573],
            [-18.95653232102201, 7.93988706649227],
            [-18.965671438989972, 7.943402590808177],
            [-19.006232194858555, 7.955519796550778],
            [-19.00010363531382, 7.9756315362745855],
            [-19.040987562919497, 7.986520492201083],
            [-19.029912135121474, 8.022952143539124],
            [-19.064801252824267, 8.033217729727072],
            [-19.058186928005643, 8.054879512709308],
            [-19.085518571825737, 8.063604529877074],
            [-19.076662962085187, 8.091528238233474],
            [-19.103929399405843, 8.100183155558197],
            [-19.099568630941082, 8.114245524477559],
            [-19.13012940634895, 8.12427456195756],
            [-19.128251441654164, 8.130895982773145],
            [-19.166100499669632, 8.141695971973427],
            [-19.212732456285444, 8.156583882335259],
            [-19.216661689391916, 8.155933062198624],
            [-19.218808982956137, 8.149212695949577],
            [-19.222213204128334, 8.150225696626944],
            [-19.223283165983855, 8.146885617457924],
            [-19.226668258353385, 8.147866122151212],
            [-19.227750462371347, 8.144503706624796],
            [-19.23114694296478, 8.14545978585393],
            [-19.232586852432824, 8.141571013774097],
            [-19.235926815238923, 8.14259034165572],
            [-19.23735356364743, 8.138730801744371],
            [-19.244040869386875, 8.140837649308779],
            [-19.245437873946432, 8.137003449190548],
            [-19.25206154358018, 8.139160564424225],
            [-19.25342902266061, 8.135336196097336],
            [-19.256711414666327, 8.136416105528912],
            [-19.25808885326972, 8.132550026548875],
            [-19.261364667388815, 8.133617787424672],
            [-19.262736596461078, 8.129738588980661],
            [-19.27258695017373, 8.132822159093907],
            [-19.273951664182707, 8.128868114504224],
            [-19.27724134775949, 8.129852528559999],
            [-19.278605096319133, 8.12586802765804],
            [-19.28189442611385, 8.126822421019597],
            [-19.29413117623185, 8.132795564590985],
            [-19.300002227598178, 8.114009107855972],
            [-19.303287677478068, 8.101762144664667],
            [-19.309612340978987, 8.10372455604472],
            [-19.31608547013437, 8.111559952125772],
            [-19.318528617194996, 8.102996013418398],
            [-19.331929295864256, 8.107331637647485],
            [-19.34590261541724, 8.110444198332498],
            [-19.3594495484551, 8.115546420052587],
            [-19.373306646850704, 8.118909608467122],
            [-19.39995482136294, 8.126983124941852],
            [-19.39941000961776, 8.128827102418756],
            [-19.42685357350295, 8.136140147891805],
            [-19.464207263462143, 8.147863892974835],
            [-19.44458606052464, 8.190902058365117],
            [-19.426396778323124, 8.234838331732735],
            [-19.411651271639006, 8.268694933760687],
            [-19.402596517486213, 8.294705213537311],
            [-19.38568152546046, 8.334200298020729],
            [-19.37448920672792, 8.358725795012528],
            [-19.369472785580996, 8.370690581189773],
            [-19.368895240123585, 8.376116523954755],
            [-19.365914879695364, 8.381430952842829],
            [-19.367323544854596, 8.386847559359877],
            [-19.3611345102017, 8.397509515699955],
            [-19.36355037332115, 8.401817219043805],
            [-19.35784481166737, 8.405253688714772],
            [-19.345373382357153, 8.431992010597199],
            [-19.341066616861436, 8.445269068732605],
            [-19.335930339235595, 8.456379146707121],
            [-19.33432903526117, 8.464599849699228],
            [-19.33071119604565, 8.474033854216163],
            [-19.322834857404466, 8.490714976043753],
            [-19.321881425270924, 8.498392044766367],
            [-19.3225527030757, 8.501941238173366],
            [-19.31731305990655, 8.510156602594034],
            [-19.315889310729396, 8.514983435009809],
            [-19.312504977632685, 8.519134312140581],
            [-19.311553176604495, 8.524159118888523],
            [-19.314431785300595, 8.527229207975848],
            [-19.31262004160702, 8.53111010920309]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -122.84795354843676, "lat": 43.9386547354367 },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41039"],
        "coty_name": ["Lane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lane County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01135855"
      },
      "bbox": [
        -19.464207263462143, 7.335901553505521, -17.72721307038567,
        8.53111010920309
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.435240610477699, 4.1258041011004405],
            [13.43213112221441, 4.140979902122874],
            [13.501077193101121, 4.154039654395157],
            [13.590442584722497, 4.171030570226735],
            [13.591231750676746, 4.170469845303821],
            [13.655322317562216, 4.115428557014955],
            [13.728991572347951, 4.051899689312004],
            [13.773834962225841, 4.059809192094355],
            [13.779110300154029, 4.033504002162107],
            [13.79451726266327, 3.9538500349973766],
            [13.764868710154905, 3.852218452904581],
            [13.746440736563068, 3.7905528174526153],
            [13.704120982449478, 3.7880233423350598],
            [13.638796895071073, 3.783729877156505],
            [13.638753212564522, 3.784016462094147],
            [13.62291401129907, 3.8761592031390286],
            [13.60845471693906, 3.8736073981161505],
            [13.593583379918321, 3.953837220344989],
            [13.505164470831083, 3.9374010508682775],
            [13.472064116691522, 3.9313768923233487],
            [13.459671801823681, 3.999312904504468],
            [13.458488900445932, 3.9992158775262125],
            [13.451524965844234, 4.040303690476773],
            [13.446203296129623, 4.068719027689527],
            [13.447483509140254, 4.068862865957873],
            [13.445053500889713, 4.081908764027592],
            [13.435240610477699, 4.1258041011004405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.20398728718969,
          "lat": 41.436716200601474
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42023"],
        "coty_name": ["Cameron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cameron County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01213663"
      },
      "bbox": [
        13.43213112221441, 3.783729877156505, 13.79451726266327,
        4.171030570226735
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [13.656693531506736, -5.0944468488610495],
              [13.65810872169247, -5.093641301455106],
              [13.664160453961145, -5.096587006915204],
              [13.661187235450718, -5.0995842546605985],
              [13.656693531506736, -5.0944468488610495]
            ]
          ],
          [
            [
              [13.42873424539298, -4.8219293878863905],
              [13.50351616112646, -4.816715296971984],
              [13.513672428851836, -4.815095872838552],
              [13.534090952551477, -4.81961307501972],
              [13.636076447587007, -4.828418917460841],
              [13.643048679483016, -4.827270046504352],
              [13.638529929954375, -4.8208425583275085],
              [13.635354564054273, -4.819879565969156],
              [13.633857556725651, -4.814665221130957],
              [13.628995092088784, -4.806394685808372],
              [13.617034428609697, -4.803605124353173],
              [13.609829891065012, -4.803476483044081],
              [13.606402593400288, -4.79904118886918],
              [13.605928429044472, -4.790169057452409],
              [13.612254734171557, -4.78273752341343],
              [13.617451014641366, -4.786016326297486],
              [13.625253972101348, -4.79329986541618],
              [13.626836466563176, -4.7916549928250625],
              [13.630556887187598, -4.781728401370043],
              [13.622982417839802, -4.773275279751979],
              [13.632584842806905, -4.767352046678987],
              [13.635135389763326, -4.7580709131836585],
              [13.64183555397117, -4.7567866552107505],
              [13.64163155083656, -4.760871913886937],
              [13.65071523888302, -4.753347009054925],
              [13.650864230130194, -4.740987286963887],
              [13.65471216599001, -4.7409679869319366],
              [13.65595889126289, -4.744283997558711],
              [13.65496077795905, -4.748577277559011],
              [13.661062714596044, -4.74948147332621],
              [13.666483969406334, -4.746860250722806],
              [13.67188280209677, -4.74816359601288],
              [13.67402620228008, -4.752146058368201],
              [13.681804199565496, -4.708912148419832],
              [13.627966699471834, -4.66985840507491],
              [13.62297988955932, -4.666548025252119],
              [13.623960921391848, -4.664129470680167],
              [13.631485923676445, -4.66568718881636],
              [13.635217728741418, -4.661685445880153],
              [13.646925401267909, -4.656497932292821],
              [13.624131232067752, -4.646704092942689],
              [13.619599828025676, -4.660857253313644],
              [13.617971938255529, -4.662489287273358],
              [13.597198290685963, -4.647380675613578],
              [13.59996716560027, -4.638944479524241],
              [13.596517086597231, -4.637326818000093],
              [13.594566349602275, -4.641501473912975],
              [13.594945251986807, -4.6460474761398585],
              [13.58884431630549, -4.641302628123584],
              [13.593199035305922, -4.635048145126347],
              [13.598049712441174, -4.636910243114284],
              [13.600751272334012, -4.631579144324426],
              [13.60661268980919, -4.629397917471632],
              [13.609080825814898, -4.6261265972958965],
              [13.64250237013165, -4.644456976168225],
              [13.646601837426067, -4.642042280697054],
              [13.649786574545269, -4.645320965519442],
              [13.650251445812241, -4.6488191988126975],
              [13.656614324031999, -4.652208724823954],
              [13.667447886143401, -4.645102877076858],
              [13.68606324729478, -4.637375151217977],
              [13.689410065348723, -4.635237569114511],
              [13.695328216182366, -4.64324156544309],
              [13.70018841020327, -4.647995552990818],
              [13.705311930416588, -4.6494474219795885],
              [13.70697980933073, -4.6719634001684245],
              [13.708803441026626, -4.6770720069306595],
              [13.742523252139119, -4.72744634481789],
              [13.790691755772063, -4.708774593450385],
              [13.794143560301924, -4.710784103543843],
              [13.786100537080976, -4.723009463346566],
              [13.784408316423622, -4.72934810869546],
              [13.784079078534754, -4.737759059572595],
              [13.786135920233914, -4.746018020238991],
              [13.791691055132436, -4.755979462130232],
              [13.797175132232205, -4.760839515525415],
              [13.806247406614084, -4.761465432799195],
              [13.814376685155933, -4.763709308855936],
              [13.819118798155111, -4.769382806656828],
              [13.819617524211806, -4.781463550609959],
              [13.821885466566908, -4.788767869249136],
              [13.824038286882502, -4.790809020213761],
              [13.832378920099947, -4.7944667923504],
              [13.838825597093717, -4.793030416348339],
              [13.840731918340975, -4.7895008547423314],
              [13.845594223265556, -4.785850937056633],
              [13.849210003799582, -4.779231499614489],
              [13.84808830951892, -4.767249275846641],
              [13.8433079855548, -4.755825272304654],
              [13.844365245923903, -4.75069420946434],
              [13.852278902743977, -4.743489250448264],
              [13.86152161188976, -4.740150876430969],
              [13.873041394613121, -4.734666272933372],
              [13.8771998225751, -4.7287262886870645],
              [13.88080793207393, -4.716269928698728],
              [13.882790681167224, -4.706749452137598],
              [13.883375196181523, -4.698651166994791],
              [13.881157616735178, -4.690780828393692],
              [13.883103122880966, -4.684870940403708],
              [13.89238963334076, -4.68321389413651],
              [13.89763381022595, -4.6780662216390905],
              [13.899880302166496, -4.673096032996084],
              [13.90860865236473, -4.669781138329513],
              [13.91267194317936, -4.663461707515952],
              [13.922028384070307, -4.6535586531622855],
              [13.926565884788095, -4.651436996509544],
              [13.932872373849433, -4.652287088078466],
              [13.933446724756653, -4.642072051572113],
              [13.936691971365141, -4.6350115994556],
              [13.933743250997662, -4.629438312779471],
              [13.930198527328072, -4.625572411908512],
              [13.929658964245226, -4.618556756822078],
              [13.932606004757465, -4.604243953655],
              [13.938354876430909, -4.594663993865042],
              [13.941599576943267, -4.59158522223794],
              [13.945479767333469, -4.585449860067596],
              [13.954700652731344, -4.576473023765136],
              [13.955500428015101, -4.574858067753671],
              [13.958698274025243, -4.55711206914395],
              [13.961664549006274, -4.54888747957388],
              [13.964383799756142, -4.5447368979729585],
              [13.971373067905528, -4.539699466537008],
              [13.973394658952994, -4.530127838976756],
              [13.978123844768255, -4.52406017623219],
              [13.985668999587414, -4.508795037601605],
              [13.988722144716009, -4.501544331333112],
              [13.998547128581418, -4.489284261667485],
              [14.000958122987456, -4.478695225809771],
              [14.00544548177457, -4.4669302204215615],
              [14.00506927567561, -4.460599473549572],
              [14.007669126753497, -4.453531901879506],
              [14.013436701886691, -4.447799099034499],
              [14.018602630003368, -4.447058020528698],
              [14.02226130154724, -4.442389837574137],
              [14.023228418272284, -4.4390288150996176],
              [14.029705005901125, -4.435520088515675],
              [14.033410066422581, -4.440167282776427],
              [14.040811509793826, -4.437983141297228],
              [14.041749436844174, -4.429875907461136],
              [14.049660974904578, -4.423285952220902],
              [14.061410730571742, -4.418248630116581],
              [14.06923119715723, -4.410222255547791],
              [14.077971525784248, -4.409496909993586],
              [14.083711678058078, -4.414233874090076],
              [14.093096420463416, -4.41866166286733],
              [14.095389119757975, -4.41654392856271],
              [14.100110809577805, -4.415562874976344],
              [14.105119661793639, -4.411423986844196],
              [14.108604552755999, -4.401648732864779],
              [14.107010508343159, -4.399497259059666],
              [14.106424831576405, -4.393796109389877],
              [14.10993041617401, -4.391428009129341],
              [14.112839051567477, -4.3844658621998045],
              [14.111523060203437, -4.38180218108368],
              [14.117792168777534, -4.37787132164929],
              [14.116588468602233, -4.37267017621234],
              [14.118489576823274, -4.365537001590883],
              [14.123675229405768, -4.364072257744267],
              [14.12574678376514, -4.357610872084811],
              [14.123895378826086, -4.352373073783847],
              [14.128706661755606, -4.35233376065872],
              [14.128232918593651, -4.346457271026051],
              [14.133145968817123, -4.344041664673255],
              [14.140628844676636, -4.345682767312363],
              [14.146394127346603, -4.342032556443783],
              [14.150604362082577, -4.3441028534453325],
              [14.152479152227382, -4.337532821640524],
              [14.159493948329326, -4.334483605897017],
              [14.164882948781317, -4.337764945126757],
              [14.168855034785977, -4.338402449772608],
              [14.170668965024197, -4.342263423150958],
              [14.173763812475164, -4.344688534644814],
              [14.18149134810554, -4.347161500875817],
              [14.184197806424738, -4.349878745108225],
              [14.188346861637799, -4.356875441802613],
              [14.192594126936106, -4.360735010687886],
              [14.20148696734599, -4.365016160970921],
              [14.210956001039264, -4.366284208382484],
              [14.220447201228438, -4.373452383162472],
              [14.226752722748886, -4.376634720333697],
              [14.232357677309734, -4.377430957338205],
              [14.238441045283409, -4.381683051090531],
              [14.242531961203685, -4.383015837186502],
              [14.248962511502063, -4.381116273223316],
              [14.256973524451974, -4.381071164452392],
              [14.269533775683515, -4.384962413428163],
              [14.275868306016658, -4.385123234638549],
              [14.286293861353908, -4.3831293597426555],
              [14.29148329370906, -4.381209483684511],
              [14.301362029501293, -4.382812677379442],
              [14.30812970566404, -4.385302797345942],
              [14.311755650111126, -4.38833947616858],
              [14.31305407438736, -4.393954863623728],
              [14.309570078181833, -4.408371596124305],
              [14.287084383067397, -4.426225095530073],
              [14.279479847286183, -4.431574395477059],
              [14.274646949658013, -4.439203729220372],
              [14.271116319074334, -4.442046193036173],
              [14.270110119693278, -4.446116745044821],
              [14.266605331173892, -4.48012174844105],
              [14.25758708705382, -4.516529495400667],
              [14.257390534604912, -4.527325497281054],
              [14.248196043378153, -4.529352512345152],
              [14.242808048356707, -4.529590559237673],
              [14.213291237948152, -4.537402229509785],
              [14.208457547431207, -4.533810218458866],
              [14.216687884469618, -4.533216565032197],
              [14.225195047849779, -4.530868085957056],
              [14.224444124727524, -4.524550819449291],
              [14.220977500388713, -4.523010040949443],
              [14.219530672881783, -4.528528027865264],
              [14.21179544210989, -4.528182436391502],
              [14.182450955060855, -4.536846465165531],
              [14.168370223016634, -4.541952971374624],
              [14.164756696252931, -4.54125656885928],
              [14.157985748723517, -4.544075504586251],
              [14.152283216335725, -4.54081080317515],
              [14.15245586123621, -4.538884133281614],
              [14.137851188525826, -4.529633323817447],
              [14.134571633973634, -4.524715633026413],
              [14.12139123106411, -4.5244338209149495],
              [14.118780646563103, -4.522917727484347],
              [14.11348784996528, -4.525973087499595],
              [14.114106797695667, -4.5296670550555715],
              [14.11231383420088, -4.5330250503112985],
              [14.107527588181028, -4.536388607490667],
              [14.104154475410429, -4.536416580913694],
              [14.095019482281335, -4.543373443297762],
              [14.088974119973274, -4.5505201587965],
              [14.085190804943462, -4.552679778719061],
              [14.078570570887189, -4.5613305543396265],
              [14.07747488759436, -4.5677285933392],
              [14.077894359537357, -4.571928296845264],
              [14.076369142821875, -4.577102512402511],
              [14.072359292552262, -4.5840270668766605],
              [14.066602727329762, -4.591071342529829],
              [14.0632226537978, -4.598820167609784],
              [14.064694862514548, -4.605345314547083],
              [14.057560531114332, -4.619678577326415],
              [14.058830919929608, -4.627455996893701],
              [14.06449987370215, -4.636708516726554],
              [14.070416416265145, -4.644421102044641],
              [14.085272657565131, -4.643566741026108],
              [14.08815597322014, -4.641103700293195],
              [14.087769502633357, -4.63801489189187],
              [14.092164923569754, -4.6359056475441225],
              [14.095206237237852, -4.632403762712803],
              [14.098173452324245, -4.637916665963096],
              [14.098353448370613, -4.64477062306566],
              [14.097351016597756, -4.655847315105281],
              [14.09559933003617, -4.6602149160989015],
              [14.057495020680395, -4.684961833911909],
              [14.050012613173402, -4.693791612684997],
              [14.046906529648219, -4.699571345200112],
              [14.039312027467188, -4.7010633920366764],
              [14.020930330155885, -4.718666837343948],
              [14.012474604641946, -4.729171451618756],
              [14.008831867359966, -4.731322759172789],
              [14.009134657490735, -4.738823130873172],
              [14.006790293333264, -4.747245213716984],
              [14.002040487363864, -4.750782576524768],
              [13.995303728885188, -4.759633655967249],
              [13.998306925931825, -4.768090119030352],
              [13.99713323927777, -4.774217134526653],
              [13.993339909126314, -4.7801178236914],
              [13.985692100273244, -4.785914867383617],
              [13.970182618226495, -4.793661618252966],
              [13.946651262732006, -4.810050457023431],
              [13.933860599684074, -4.821777934266459],
              [13.926537942546704, -4.823312802943418],
              [13.926847417771716, -4.827705717668527],
              [13.924477945903291, -4.83227784064676],
              [13.920375249301523, -4.836667559415555],
              [13.901466521802869, -4.849155228127875],
              [13.896387879260555, -4.848754155055794],
              [13.888660760340336, -4.843311350202204],
              [13.884861217612848, -4.839386815661537],
              [13.886459538968506, -4.834031715741901],
              [13.884133107238076, -4.830465675153847],
              [13.879292831820909, -4.827891256722592],
              [13.871923453524346, -4.821576297852156],
              [13.864992161050797, -4.820523469737634],
              [13.853882161279229, -4.825058995148812],
              [13.848974355624472, -4.826403765110932],
              [13.835385198945001, -4.831765454999262],
              [13.835556245403689, -4.8386454305959505],
              [13.832931897168502, -4.845087659689283],
              [13.83564883488282, -4.859766812954363],
              [13.840259232777449, -4.860202629262439],
              [13.844331199304264, -4.858085965625155],
              [13.852248529493702, -4.859584101775243],
              [13.858813502635513, -4.859075790654582],
              [13.862985419734045, -4.859889097540077],
              [13.867235481383325, -4.857640147209362],
              [13.876964416037817, -4.856183944811184],
              [13.88513135304456, -4.863332269411909],
              [13.8879157678885, -4.87179770162499],
              [13.887887851546054, -4.875503010707217],
              [13.882088459584285, -4.890685391764925],
              [13.878681544929332, -4.905602658316807],
              [13.879060301477459, -4.912421643608412],
              [13.881896209346925, -4.924269137212319],
              [13.861381905146338, -4.946200877031449],
              [13.820668397353243, -4.9779135009166],
              [13.81705322273592, -4.9780184608104365],
              [13.813796941141206, -4.987318814758202],
              [13.809107535759333, -4.994241323012003],
              [13.807304783937717, -5.010188044217546],
              [13.801099849756044, -5.0164279313138005],
              [13.796766027786004, -5.0170598671725015],
              [13.79258834331067, -5.014860288309496],
              [13.786995723180292, -5.01423619103989],
              [13.770249747751865, -5.017230026204597],
              [13.738574493038678, -5.029601859673084],
              [13.722045505211522, -5.037507617337287],
              [13.704102830255255, -5.048402142055756],
              [13.690471796217858, -5.061101931708068],
              [13.686311094526816, -5.063976965755404],
              [13.678855664395908, -5.0714776309771175],
              [13.673876886914485, -5.082617457578152],
              [13.671828870777288, -5.0845959422148885],
              [13.664223158577851, -5.086903487190783],
              [13.66129372213415, -5.086353634864078],
              [13.648361902569325, -5.0887198333321955],
              [13.630805491599517, -5.1007361067531525],
              [13.616758387427101, -5.111979495892686],
              [13.604114886426547, -5.124277282319713],
              [13.601485087731406, -5.120141408576036],
              [13.598947202183636, -5.124218837331106],
              [13.595173224037799, -5.125033850432133],
              [13.595622842385977, -5.129609020022195],
              [13.588241693394677, -5.134868417423183],
              [13.58419254430838, -5.135373151977091],
              [13.578862397609354, -5.130849820480029],
              [13.573850770836627, -5.13496449822577],
              [13.559718865492314, -5.150451932370088],
              [13.553825455100625, -5.154165821020425],
              [13.552272786247604, -5.152221016736118],
              [13.552658261690368, -5.1465280017222925],
              [13.55030449390788, -5.142591837082212],
              [13.544986848433282, -5.142122941223944],
              [13.541975406670291, -5.144198846264822],
              [13.538615080760154, -5.1411683622946285],
              [13.535398301790787, -5.145058924325917],
              [13.526913469631918, -5.145411800526333],
              [13.527838916409564, -5.15128955409581],
              [13.532038677994839, -5.151013683306076],
              [13.53605931913175, -5.153457824075932],
              [13.542102112372387, -5.154672299733436],
              [13.545330301068713, -5.160150057293652],
              [13.548986517714106, -5.161135101291348],
              [13.551590562887004, -5.165621553706705],
              [13.550177496621432, -5.172791137126895],
              [13.543378547036967, -5.174415135831655],
              [13.53566412244582, -5.171599184241921],
              [13.529839208959626, -5.170717615974127],
              [13.519363158156985, -5.161299246710926],
              [13.508579251989545, -5.149104972686792],
              [13.50003239951938, -5.142075079917044],
              [13.492965274831544, -5.13920941314497],
              [13.476757026187322, -5.136722027623513],
              [13.468810282458824, -5.132283652883394],
              [13.467574746469738, -5.126917542473838],
              [13.469237644231008, -5.121673675053329],
              [13.473723969672807, -5.1178718901903775],
              [13.480068626220632, -5.1160679746507745],
              [13.484155496551622, -5.111799280904098],
              [13.48546068087201, -5.103741150948587],
              [13.483006443518072, -5.096428283782497],
              [13.476281660987722, -5.086438628532566],
              [13.476369387168951, -5.078552482670204],
              [13.480597584420071, -5.066442644906078],
              [13.480910408496511, -5.062935227464766],
              [13.477549532598871, -5.057526997747705],
              [13.473703135768913, -5.057224575734244],
              [13.466884927847456, -5.06119497502782],
              [13.461585186237686, -5.067757617163343],
              [13.456383824241332, -5.075628561845804],
              [13.452701963235523, -5.075148664634484],
              [13.44895253475413, -5.069545758319473],
              [13.44545766585141, -5.058988991938656],
              [13.44700304626453, -5.0544573220403795],
              [13.451234018565893, -5.052990587186926],
              [13.458573235814372, -5.052634011049832],
              [13.463020229683472, -5.049556931706006],
              [13.463874334206151, -5.038622857671722],
              [13.46820773332997, -5.031363473483464],
              [13.471623693157383, -5.029570771872019],
              [13.472802044286885, -5.024188458629447],
              [13.468770762246821, -5.021846685922419],
              [13.462953777774443, -5.026138837741477],
              [13.459645672877638, -5.02623157379658],
              [13.449573886596935, -5.017468088726923],
              [13.443536705548777, -5.010961685194365],
              [13.442859078758634, -5.0071205269936545],
              [13.44430098087801, -5.0000405356646045],
              [13.439545242043216, -4.99503796144742],
              [13.439518405944138, -4.992204603840273],
              [13.442544338209549, -4.989462343028463],
              [13.443630007235413, -4.985873717570004],
              [13.441360400477137, -4.98111237010834],
              [13.4348532368184, -4.971605853831793],
              [13.43468860375395, -4.967187079377631],
              [13.43174412755567, -4.966358792395668],
              [13.428449132371556, -4.970683049027055],
              [13.424502287279843, -4.970348645908811],
              [13.42423311935528, -4.9673356289642605],
              [13.427837903817506, -4.964469894744555],
              [13.426360385972085, -4.960444004648161],
              [13.41231597413826, -4.956862105936293],
              [13.410127599541072, -4.952044807799353],
              [13.405540839183194, -4.947129182295025],
              [13.405862344364783, -4.943146307300914],
              [13.408379361461998, -4.937138390249229],
              [13.405579971745489, -4.928651590833725],
              [13.407851308744206, -4.920051687132196],
              [13.41160809249981, -4.9197362257860995],
              [13.4141794992212, -4.914055822220893],
              [13.412197116597248, -4.911823124963072],
              [13.415831743375144, -4.905395487038425],
              [13.415622331427778, -4.9005738456009205],
              [13.411814934672242, -4.8966513820659525],
              [13.41412601772391, -4.893999204329404],
              [13.41822043573137, -4.885236689967924],
              [13.42233441624307, -4.884102650650117],
              [13.42637873618801, -4.872814504480192],
              [13.43127631437054, -4.86997372433349],
              [13.433072089672955, -4.861753091229238],
              [13.432100382339703, -4.8578825445470155],
              [13.434559658656907, -4.8516615146930135],
              [13.434193191820553, -4.844465736093925],
              [13.436959734634435, -4.834828982137791],
              [13.43239537698008, -4.834322354314156],
              [13.42873424539298, -4.8219293878863905]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.95314110296437, "lat": 32.83471281210665 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45019"],
        "coty_name": ["Charleston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charleston County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01252740"
      },
      "bbox": [
        13.405540839183194, -5.174415135831655, 14.31305407438736,
        -4.334483605897017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.495437545316209, -3.560811524447115],
            [13.562739170333488, -3.4873478224240815],
            [13.604947724067872, -3.441192572648828],
            [13.671476990097483, -3.368434382390365],
            [13.676455011596897, -3.3641804208187662],
            [13.67837877372857, -3.3600105662981767],
            [13.68436496364521, -3.3564157929381766],
            [13.686944795001722, -3.356218544650437],
            [13.693836603243376, -3.359274828206693],
            [13.698173417540271, -3.359757263467189],
            [13.709476759486975, -3.3582218315981023],
            [13.719430098736845, -3.359468698023133],
            [13.724962944727453, -3.35729022175021],
            [13.724322509971483, -3.3539669933148755],
            [13.73525437316555, -3.306568637426594],
            [13.738809586243514, -3.30411892451297],
            [13.741639431722152, -3.306682533383315],
            [13.746293930630783, -3.3078403097322426],
            [13.761890236166233, -3.3080193150099104],
            [13.769479023221395, -3.311266208401498],
            [13.772617292909638, -3.3110979173248913],
            [13.777185969320016, -3.3068686470091757],
            [13.777097480457673, -3.3019963766918337],
            [13.781303361338642, -3.2895960631418775],
            [13.787375374933191, -3.2848958856401365],
            [13.791520507309334, -3.2866233396708533],
            [13.80538760318963, -3.2897616240452683],
            [13.810272535006014, -3.2873439084390754],
            [13.81242601017283, -3.2903455226120553],
            [13.815542666235459, -3.2903558157519504],
            [13.816558361803267, -3.2870132299186157],
            [13.819697538199582, -3.286465850472819],
            [13.826574344630869, -3.289585020545161],
            [13.839888455277203, -3.293193605913698],
            [13.845412426072846, -3.296856144222045],
            [13.852626940362672, -3.3003220355625698],
            [13.856272879501914, -3.3042557659173406],
            [13.862653727097028, -3.307558617448534],
            [13.86849692406758, -3.3166694271906234],
            [13.876875157901075, -3.319450495846857],
            [13.879946640573026, -3.326302501310345],
            [13.885102076622884, -3.3351062463225944],
            [13.891412669273322, -3.3417797034678784],
            [13.893095132186824, -3.3448146785081354],
            [13.897232984015412, -3.349941676786812],
            [13.898192880001009, -3.355401761116865],
            [13.898363111186143, -3.3644282618626464],
            [13.896007329572418, -3.3744888235706076],
            [13.889344564672994, -3.378618106945171],
            [13.883089576474124, -3.3878870023403374],
            [13.881963165885521, -3.3949858183354955],
            [13.885758954869466, -3.40310867976614],
            [13.892348766800772, -3.407086194707892],
            [13.899358144422946, -3.4166454695988424],
            [13.908289584093195, -3.4209495717802385],
            [13.910058877724289, -3.422754600355792],
            [13.910995214834848, -3.4306779967504646],
            [13.914121727986023, -3.434840830006983],
            [13.920539775939588, -3.436140171608463],
            [13.922515741781453, -3.438935149104406],
            [13.922033677998536, -3.442658869091532],
            [13.923754049515606, -3.446287820856803],
            [13.928366953771112, -3.447030934801102],
            [13.93433325541798, -3.442439353138643],
            [13.936032543166522, -3.443673008557521],
            [13.93217764644205, -3.4529270091821194],
            [13.934309593091585, -3.458741611908083],
            [13.937562744733995, -3.459088856485497],
            [13.93699693598966, -3.463356176212018],
            [13.94191501388989, -3.4643904486445583],
            [13.938164409780189, -3.468150610355556],
            [13.942189456368505, -3.4715242511589084],
            [13.931047494999639, -3.471626738260854],
            [13.930589437705098, -3.4775873839920184],
            [13.933705956330803, -3.492590041117039],
            [13.930343708874878, -3.4952971373495596],
            [13.930464719064906, -3.4989957163386283],
            [13.936791716082974, -3.500520649541433],
            [13.939048695981144, -3.5039194882754456],
            [13.939287800836683, -3.508346853044113],
            [13.944349954959424, -3.510092312307448],
            [13.944950449364535, -3.514860802263473],
            [13.949979667196514, -3.5218465970235417],
            [13.95331403584156, -3.5223651939971163],
            [13.953669019701287, -3.5262085704212383],
            [13.956312654942957, -3.530827843214049],
            [13.955401468507857, -3.5361862288109145],
            [13.959845493881083, -3.5487605286849955],
            [13.95923199226118, -3.5550079849748957],
            [13.963636206469575, -3.561781524152309],
            [13.962855617379526, -3.5682581627979397],
            [13.960247314490433, -3.571149249672762],
            [13.959336745534829, -3.575184906014597],
            [13.966482725395773, -3.5803312156402],
            [13.970996599478976, -3.5882539869133634],
            [13.977199186768006, -3.59524899894226],
            [13.980535669365592, -3.596715946780068],
            [13.988604992428728, -3.59592968635771],
            [13.993169253813083, -3.5991667553012205],
            [13.992580584112833, -3.604225416468185],
            [13.986749663950821, -3.6126338967342213],
            [13.988046190120158, -3.618610667077075],
            [13.993266957695, -3.6217583074538613],
            [13.99696775324337, -3.6261673115029907],
            [14.003717247377164, -3.6277673443013065],
            [14.00554662803153, -3.632384576289603],
            [14.010390687638106, -3.6334728522651134],
            [14.013970158931693, -3.6291270160060387],
            [14.017351555221767, -3.634542708947011],
            [14.024065745533829, -3.634628268110437],
            [14.026691962763396, -3.6386724202735143],
            [14.025615773591278, -3.6443720366288073],
            [14.0291570176594, -3.647351987399764],
            [14.036916280123712, -3.6485792651507007],
            [14.040497537237748, -3.653028957286608],
            [14.043859380208527, -3.6522605591812387],
            [14.047419085107196, -3.657921472616978],
            [14.061701547202576, -3.660989791043051],
            [14.070730736604478, -3.658929838639425],
            [14.071679140605786, -3.663215065097091],
            [14.065154463992483, -3.6675804898938393],
            [14.067928663482881, -3.6700824054746364],
            [14.074301616244398, -3.6703661703058894],
            [14.07751151691926, -3.6757455410317856],
            [14.083762156775466, -3.676653517613962],
            [14.084617015183067, -3.682752805581682],
            [14.08897080988139, -3.6873299013214225],
            [14.092349012198076, -3.6886628920342064],
            [14.09553222185881, -3.692775298451221],
            [14.09934631983381, -3.694832566925815],
            [14.103181194764497, -3.7007867984261833],
            [14.106258170426536, -3.7035853093996915],
            [14.114684103936854, -3.702676083714802],
            [14.118993890225028, -3.7048022216421863],
            [14.125382879154637, -3.7005507217988307],
            [14.131055309330895, -3.70166672008152],
            [14.1336368170072, -3.7093461549421156],
            [14.140682643541274, -3.7120319404468414],
            [14.146462417388543, -3.7090309624526703],
            [14.149272073529918, -3.713776330029371],
            [14.150080705813528, -3.7195474831453526],
            [14.154910532313885, -3.721749329101031],
            [14.156219698578028, -3.7314562024406044],
            [14.151679279910116, -3.7362228230849515],
            [14.149702277040431, -3.7406325980363397],
            [14.144235298439051, -3.7404275585128883],
            [14.142188472071087, -3.738501738004151],
            [14.135998723296794, -3.7393059506594195],
            [14.132253765700284, -3.7373165763609286],
            [14.131914727094202, -3.734419101522328],
            [14.126670409103706, -3.7319838905501466],
            [14.124218637949788, -3.7287908659815527],
            [14.116754663866326, -3.73047101176252],
            [14.111056601405167, -3.727761744183244],
            [14.104209170818617, -3.7303302552941973],
            [14.098912443013328, -3.72974207662789],
            [14.096587721065594, -3.732582294274133],
            [14.09899989998693, -3.736879265777629],
            [14.095892455703867, -3.7417967530544476],
            [14.09161322027476, -3.744628850936071],
            [14.088564321225657, -3.749886642559921],
            [14.07977546956381, -3.75047323950173],
            [14.072992874610454, -3.753838457660808],
            [14.068842851721175, -3.7584477313723905],
            [14.062279623166102, -3.7624060050295305],
            [14.057053339535525, -3.7720043566619363],
            [14.050986949333549, -3.772882742625757],
            [14.043578838594943, -3.777756777084724],
            [14.039637369680174, -3.7766121965378163],
            [14.035912184358848, -3.778407422301283],
            [14.031337072010736, -3.777169438272225],
            [14.015296465926737, -3.786687861613075],
            [14.013967480336573, -3.7887736335148166],
            [13.92342040875988, -3.7786267413239587],
            [13.895773068194353, -3.7756986151898007],
            [13.893301439580634, -3.7706099626085616],
            [13.893348470883286, -3.7662442551757143],
            [13.88107326425937, -3.7723980886375537],
            [13.87809370360001, -3.7723054587015166],
            [13.869202125754363, -3.7751987132140203],
            [13.863950973864, -3.773793162512177],
            [13.859222731051041, -3.776193876362611],
            [13.853217913648272, -3.786585506778923],
            [13.850613558867707, -3.7860076052038005],
            [13.842176153451392, -3.7792184712865455],
            [13.8334500287147, -3.7808209612485375],
            [13.8280546013423, -3.780305106002803],
            [13.821520467314695, -3.7822295840951945],
            [13.818030900873154, -3.7805191334329304],
            [13.809279668233717, -3.77284974845384],
            [13.803008306545337, -3.7645062816563994],
            [13.758245268720867, -3.771692113126547],
            [13.720554454046178, -3.7301789212673713],
            [13.710263661988993, -3.7300181033486175],
            [13.70274659974087, -3.7239090331638565],
            [13.694640279454816, -3.7328601771443726],
            [13.687016729992465, -3.7332222774691495],
            [13.668852296967236, -3.732696210280562],
            [13.664596913833307, -3.733157318832477],
            [13.637133198871904, -3.740756585916245],
            [13.632838716047353, -3.7427349246272628],
            [13.629765584674866, -3.742219787301343],
            [13.623194876176699, -3.7349212569703987],
            [13.596256744312523, -3.6861858528899134],
            [13.62179326260261, -3.6633136199270497],
            [13.655017738570049, -3.6338573900484046],
            [13.65175922018567, -3.6333171020599178],
            [13.649993774860638, -3.6299725071672873],
            [13.644902915953807, -3.6263762383540237],
            [13.644537835881302, -3.6225109765927423],
            [13.63558223063296, -3.617656762474842],
            [13.628370417654592, -3.617366386542119],
            [13.621312467025586, -3.615017068592537],
            [13.619664420191002, -3.6120956594019913],
            [13.614920327537025, -3.611199074861504],
            [13.606138778257177, -3.611526012432631],
            [13.601230618126745, -3.608996859794771],
            [13.599073029433907, -3.6102054643382115],
            [13.592948715867683, -3.6088884969689556],
            [13.591296591093217, -3.6068792852943474],
            [13.582610856646816, -3.604409739711051],
            [13.577861269960358, -3.5995867536772743],
            [13.570978191130298, -3.5957122812618794],
            [13.56630708213538, -3.5961797250399177],
            [13.561720644295812, -3.590698831790891],
            [13.558048706578791, -3.589296889146766],
            [13.552557501854007, -3.5841444367303525],
            [13.553019305096928, -3.5815904234950753],
            [13.546504340386713, -3.5786258234643613],
            [13.54008501239459, -3.57690635542145],
            [13.539386005424989, -3.573193412957901],
            [13.534134313089952, -3.569828240165428],
            [13.533236090172185, -3.5676443943130365],
            [13.528451806092999, -3.5674476266159],
            [13.52777178756106, -3.564922815235925],
            [13.520986710946548, -3.564293124805409],
            [13.518848178719502, -3.5665705647045005],
            [13.511832990139922, -3.5635033820852158],
            [13.50670486689716, -3.5661450864685627],
            [13.50565911842322, -3.5641726285893216],
            [13.500807122106915, -3.5638469531987385],
            [13.498025089536517, -3.560158278818335],
            [13.495437545316209, -3.560811524447115]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.7029027930143, "lat": 34.02449249470277 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45041"],
        "coty_name": ["Florence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Florence County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01248001"
      },
      "bbox": [
        13.495437545316209, -3.7887736335148166, 14.156219698578028,
        -3.2848958856401365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5890325951795328, 6.487128856589273],
            [-0.5384390731302389, 6.486426090012783],
            [-0.5024583589826508, 6.486081632665216],
            [-0.4100805078590546, 6.4841272452893515],
            [-0.40024203828137667, 6.484637940507645],
            [-0.3205656545895751, 6.483544207162678],
            [-0.29892831248245505, 6.482914935449629],
            [-0.2954716230817473, 6.482465136632386],
            [-0.24441536147966753, 6.481468700979285],
            [-0.1590729119445587, 6.480384300572451],
            [-0.1590693150760417, 6.394383655131072],
            [-0.1596324292281151, 6.336400180340022],
            [-0.1595546895593315, 6.307906097956241],
            [-0.159576208231738, 6.292968424079484],
            [-0.1605997743767967, 6.221456059145838],
            [-0.16174121965720442, 6.221481543521579],
            [-0.16273378050911194, 6.1362362943478574],
            [-0.24871715944995754, 6.137001917133589],
            [-0.29473540255258157, 6.137076513780165],
            [-0.3345533537412272, 6.136954588654558],
            [-0.4205216261663643, 6.13891049828295],
            [-0.5065683658032808, 6.139801269422957],
            [-0.5924454109628078, 6.141177327028357],
            [-0.5909850785716041, 6.228048197760515],
            [-0.5930811879179777, 6.228088892944688],
            [-0.5926573115941212, 6.2389691599660235],
            [-0.5927361487286734, 6.271314307393724],
            [-0.5909605821462044, 6.357601834729634],
            [-0.5902071777643103, 6.403934187942136],
            [-0.5890325951795328, 6.487128856589273]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.18864429472578,
          "lat": 44.977850746117284
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46029"],
        "coty_name": ["Codington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Codington County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01265791"
      },
      "bbox": [
        -0.5930811879179777, 6.1362362943478574, -0.1590693150760417,
        6.487128856589273
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9546182432456073, 4.844263983951895],
            [-0.8688666522130485, 4.843107670611748],
            [-0.7912427372341085, 4.841932478079502],
            [-0.6964770678432217, 4.840216430298394],
            [-0.6339434118098147, 4.839178157584524],
            [-0.5480793104867202, 4.837832899678344],
            [-0.5485891965526599, 4.784235406875853],
            [-0.5495523311944877, 4.709689606084799],
            [-0.5499752584392613, 4.666214043164306],
            [-0.5503021036572311, 4.593870422805298],
            [-0.5513359968896905, 4.506939395642652],
            [-0.6378392204024352, 4.507871221771163],
            [-0.7077456449837781, 4.508731367597462],
            [-0.7242153493434118, 4.509042380208573],
            [-0.8100058220584331, 4.511434274361919],
            [-0.8952905396694778, 4.512402136649981],
            [-0.9412255567801804, 4.513237909218971],
            [-0.9806726988413764, 4.513685713507244],
            [-1.0431052505249023, 4.514814435194102],
            [-1.0368938113392259, 4.531275751103867],
            [-1.0659584974457827, 4.543891691916441],
            [-1.064811521643256, 4.600896272112216],
            [-1.0640470920111498, 4.673508878643885],
            [-1.0630471146951377, 4.774520845218558],
            [-1.0622182530142572, 4.831942886165547],
            [-1.0630362365481956, 4.845837743351931],
            [-0.9546182432456073, 4.844263983951895]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.75440771186655,
          "lat": 43.334871173468834
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46067"],
        "coty_name": ["Hutchinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hutchinson County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01265771"
      },
      "bbox": [
        -1.0659584974457827, 4.506939395642652, -0.5480793104867202,
        4.845837743351931
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5480793104867202, 4.837832899678344],
            [-0.4380239222256526, 4.836289706343245],
            [-0.3517324191517778, 4.83512766234593],
            [-0.24675723376312575, 4.834066679096108],
            [-0.20398844371473177, 4.8338609481988835],
            [-0.20461331784521516, 4.765948763133898],
            [-0.2047968356060212, 4.7224137749104935],
            [-0.20615768763822306, 4.591434492780579],
            [-0.20656966624890874, 4.504165842362992],
            [-0.20755177522855925, 4.416859563081841],
            [-0.2859923229820673, 4.417387768499162],
            [-0.379271758631458, 4.418147819754032],
            [-0.3782065390198643, 4.50517534768865],
            [-0.46401482513030123, 4.505873271080855],
            [-0.5513359968896905, 4.506939395642652],
            [-0.5503021036572311, 4.593870422805298],
            [-0.5499752584392613, 4.666214043164306],
            [-0.5495523311944877, 4.709689606084799],
            [-0.5485891965526599, 4.784235406875853],
            [-0.5480793104867202, 4.837832899678344]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.14866347176837, "lat": 43.31088356452802 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46125"],
        "coty_name": ["Turner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Turner County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01265770"
      },
      "bbox": [
        -0.5513359968896905, 4.416859563081841, -0.20398844371473177,
        4.837832899678344
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.888367647543078, -2.2093814061948827],
            [6.890578287659882, -2.2093041565469633],
            [6.946007505602368, -2.212011962031499],
            [6.980823673976159, -2.2124059722395075],
            [7.0085138213186555, -2.1974780890682206],
            [7.021310587993145, -2.196778819432738],
            [7.041040804768951, -2.197931587124481],
            [7.04751632781358, -2.198795329828657],
            [7.063091493503242, -2.202173712624301],
            [7.078048701773744, -2.2071136327902456],
            [7.090784633345503, -2.2125873964890816],
            [7.099513111238031, -2.217172101977224],
            [7.114772291683189, -2.227134163646006],
            [7.120866962436691, -2.23175443186129],
            [7.181877933532192, -2.229940073684298],
            [7.181746681485506, -2.234932558408191],
            [7.19012534421071, -2.237687484213601],
            [7.189247442407737, -2.2440919661326246],
            [7.192949619431023, -2.244611756067822],
            [7.194508834593553, -2.2479159831002917],
            [7.198922705513136, -2.248518081672171],
            [7.2144793255365345, -2.2879834068428395],
            [7.21505008943445, -2.291473410266206],
            [7.224174815352911, -2.331018144209008],
            [7.223520415127714, -2.3655812522382655],
            [7.226932968296281, -2.3698311666691554],
            [7.227814263798286, -2.3788027678902735],
            [7.225974390856597, -2.3804914150869774],
            [7.226307080272318, -2.386112086927281],
            [7.224730862340065, -2.3935357529873134],
            [7.228160796844601, -2.3967068180841142],
            [7.229385340216681, -2.402818900813771],
            [7.224914184364108, -2.4100750673486973],
            [7.233691406732178, -2.418470318668433],
            [7.235568069997959, -2.422336316415157],
            [7.236533294846493, -2.428817500315404],
            [7.24121536706608, -2.4318388877567454],
            [7.243812582453805, -2.435429807765554],
            [7.242896893792189, -2.4379088063486867],
            [7.244865246534659, -2.4419809887258466],
            [7.244565562178954, -2.445498335839728],
            [7.2465647604599, -2.44900382399372],
            [7.2449623339116025, -2.455410225724951],
            [7.24063715734532, -2.4593190116046904],
            [7.237297921060953, -2.4594233884878167],
            [7.234276867869042, -2.4640303997039896],
            [7.22878906527964, -2.4690167937078926],
            [7.229025431039432, -2.4726784924655383],
            [7.223108519622374, -2.478825147312577],
            [7.21750096429199, -2.479835820538753],
            [7.212176872006572, -2.4768548401233814],
            [7.20718839693696, -2.4781337173782383],
            [7.205050632215565, -2.4808732278068244],
            [7.202392955962518, -2.475476688125153],
            [7.1934374122483575, -2.477802701191023],
            [7.190833908593913, -2.4798896230276783],
            [7.183299762482438, -2.4806056380532615],
            [7.18469073694354, -2.486217953762577],
            [7.18039356974918, -2.4872638019729596],
            [7.177966237940455, -2.493551504402735],
            [7.170908697463936, -2.501350923717496],
            [7.166856710067725, -2.502173861599377],
            [7.1589584729410305, -2.5111938136127505],
            [7.156705372464108, -2.510252463424171],
            [7.15230953293824, -2.5123528158746367],
            [7.148957268372958, -2.518557495824267],
            [7.141179742587406, -2.5170596319154748],
            [7.128961643874415, -2.5197062916501127],
            [7.126462399679542, -2.5250708402982776],
            [7.119369222292206, -2.5248983903550477],
            [7.1111899945909185, -2.531576878183862],
            [7.1092516948976705, -2.5996875045582333],
            [7.027811679857265, -2.6087564835095334],
            [7.02745492179064, -2.613326471200295],
            [7.0236881765112775, -2.621955317278278],
            [7.017591724739198, -2.624183098745132],
            [7.013549111053249, -2.6239409601326127],
            [7.008867186582711, -2.626622077654149],
            [7.007585950931157, -2.631242851771438],
            [7.007795219108788, -2.6391544189480842],
            [7.006735059682178, -2.643705488776888],
            [7.003492920593455, -2.644208485208208],
            [6.999265692266121, -2.6410127783681987],
            [6.994410187776684, -2.639897329086142],
            [6.992846316484598, -2.6378509780094945],
            [6.985482568894029, -2.6364217712301707],
            [6.9817884678679825, -2.6315657161723616],
            [6.977946037781434, -2.6313156806201126],
            [6.975992919298855, -2.628079050989089],
            [6.969296673111989, -2.625829425931853],
            [6.963214792631124, -2.626845440367128],
            [6.959811443442871, -2.622830689102791],
            [6.95456718637856, -2.6204620453190466],
            [6.954395207055758, -2.6134640620765754],
            [6.933414624271124, -2.614847721948836],
            [6.9121986658153975, -2.6144334882360205],
            [6.922289059486942, -2.599804278904613],
            [6.9279923611239305, -2.587734303466468],
            [6.929926187239947, -2.5783859197245143],
            [6.931570609464375, -2.56045324169244],
            [6.933831476528386, -2.5476452805073233],
            [6.934200421973787, -2.541539675161696],
            [6.934072311746392, -2.5220080514188283],
            [6.932960050417677, -2.5169035213141986],
            [6.928610884887125, -2.5129282525062684],
            [6.917046766195836, -2.514128031480363],
            [6.900965063327067, -2.51769082169336],
            [6.894852039661874, -2.518473115815371],
            [6.879004439780445, -2.517570340770334],
            [6.873872222421042, -2.5165905691389745],
            [6.8630676407798274, -2.5116075916535143],
            [6.855378938570607, -2.4975461357262536],
            [6.853378507702282, -2.4893027448436547],
            [6.854259170530683, -2.478634458405895],
            [6.858609366343285, -2.471622520274639],
            [6.865929438138788, -2.465312263580822],
            [6.867872903291523, -2.4618122371701476],
            [6.869226367731635, -2.4544052466768247],
            [6.867790770310215, -2.442444786897976],
            [6.865604846628041, -2.433825097793379],
            [6.866063290221883, -2.4282449894377556],
            [6.870836497061865, -2.417920112953121],
            [6.873581554589119, -2.409487321628984],
            [6.881341109670465, -2.3963447107210243],
            [6.892170913024981, -2.3819774366954225],
            [6.895332597946307, -2.3765420357358935],
            [6.900221547085543, -2.364145623291338],
            [6.905968131616036, -2.3549782497549474],
            [6.9080943791759815, -2.3501946216729204],
            [6.909111089963076, -2.3435628898959515],
            [6.920314351002183, -2.328968559860062],
            [6.9223929305482645, -2.3209827647000987],
            [6.922093444922177, -2.3038791672684793],
            [6.922462392085829, -2.289901650917551],
            [6.918056314346452, -2.279090959937865],
            [6.914274361135871, -2.2747992188458177],
            [6.906316251218762, -2.267923947097779],
            [6.90026865707179, -2.2544752133409443],
            [6.8982616470431095, -2.2453786609457698],
            [6.891151592011233, -2.2358486567585327],
            [6.888520691416442, -2.230458930880195],
            [6.88774817152123, -2.2233475733320587],
            [6.888367647543078, -2.2093814061948827]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.7756088209027, "lat": 36.0408568242597 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47085"],
        "coty_name": ["Humphreys"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Humphreys County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01639757"
      },
      "bbox": [
        6.853378507702282, -2.644208485208208, 7.2465647604599,
        -2.196778819432738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.582857456855486, -1.393019926761263],
            [11.589706570229554, -1.3833297853999378],
            [11.589514210054636, -1.3766242282940957],
            [11.593379886849846, -1.373396698947829],
            [11.594789692667081, -1.3666517468872061],
            [11.606052525098562, -1.3595433981831226],
            [11.60748942663747, -1.3546652696708126],
            [11.609991513412382, -1.3525579627064113],
            [11.61294765806604, -1.3470155598084457],
            [11.618848431638401, -1.340727855119662],
            [11.614887268049527, -1.3330529115944134],
            [11.617924054470324, -1.3269877963332113],
            [11.623319866639186, -1.3215838476994934],
            [11.633734007638324, -1.313576889353837],
            [11.6355026839967, -1.3103594201988567],
            [11.639461455757282, -1.3116038353206378],
            [11.643607704335992, -1.3092554077291851],
            [11.648836917234469, -1.3087817065242406],
            [11.653953181277375, -1.3048618738965632],
            [11.656566347969285, -1.3004539505558061],
            [11.654728155217063, -1.2955681852302656],
            [11.656223216576398, -1.2932012552513263],
            [11.655756529819515, -1.2884745152139616],
            [11.657929235056494, -1.2858019502229068],
            [11.666483723629916, -1.28064237986272],
            [11.668921235917175, -1.2824203038919093],
            [11.675332079891543, -1.2822756257672356],
            [11.681394468432234, -1.2782022976695748],
            [11.684732105873241, -1.274743608801929],
            [11.689750215228663, -1.2735349613603502],
            [11.69068273284338, -1.2688469285556638],
            [11.76156085151573, -1.2600406596208367],
            [11.83241059136937, -1.2497666616476628],
            [11.81193691335464, -1.2771767341724631],
            [11.810284710510532, -1.2800807670357168],
            [11.814966336236663, -1.2944788907165194],
            [11.813003666650244, -1.296920613816309],
            [11.804887131293185, -1.2980500076858053],
            [11.803551320585417, -1.3012844655665117],
            [11.807708129493836, -1.3106949012405915],
            [11.807557370560378, -1.3145540274540386],
            [11.805021705807354, -1.318073492695103],
            [11.801626007834262, -1.3281521846811104],
            [11.80206256522794, -1.3310310105829004],
            [11.79586034002067, -1.3326036555684184],
            [11.79769596293141, -1.3426435955219682],
            [11.802529717303623, -1.3478154007647534],
            [11.808103134536392, -1.3590862639892354],
            [11.80899946135735, -1.3625853607977816],
            [11.807346308763455, -1.3673395553614653],
            [11.812102340344575, -1.3756983100827618],
            [11.812051274500131, -1.3826900736804282],
            [11.814241803465194, -1.3917887148624486],
            [11.815953854459423, -1.393791131206041],
            [11.816154112760168, -1.3992431906666183],
            [11.81453579251636, -1.4027252792138991],
            [11.806826683968614, -1.406469703824369],
            [11.802349371105814, -1.4122481903125195],
            [11.804786153338398, -1.4221944102676098],
            [11.802161025843784, -1.424587270654449],
            [11.805286603620686, -1.427891660223517],
            [11.805646468728764, -1.432278174768261],
            [11.800872911614782, -1.4362260484018086],
            [11.804299315662812, -1.4393328927474935],
            [11.802986172318239, -1.4475520213153026],
            [11.798313003867472, -1.450925000561882],
            [11.796817625231983, -1.4557471200207632],
            [11.788706611795996, -1.4593013466944371],
            [11.789649132167268, -1.469336460159998],
            [11.792080358819563, -1.470973520711942],
            [11.79299756433945, -1.4773688188193852],
            [11.799227903209825, -1.477339355689938],
            [11.801527547154857, -1.479737317947953],
            [11.801807935249089, -1.4854294561192893],
            [11.798535018168181, -1.4920785853457157],
            [11.80207384666952, -1.4971649680913977],
            [11.80687345714316, -1.5017145341943663],
            [11.809173297535885, -1.5060613716027194],
            [11.809945097996215, -1.5126142019663422],
            [11.813200803939178, -1.518848324697338],
            [11.81690773427275, -1.5217450856902612],
            [11.824764890867618, -1.5223639094405155],
            [11.82735456206079, -1.5262122620128253],
            [11.826677348935874, -1.5331335074362182],
            [11.817965436470935, -1.5335503774103414],
            [11.815439803178082, -1.5312892941051552],
            [11.809433920121004, -1.5293453836837199],
            [11.802995045437827, -1.5287401560277194],
            [11.79707126638802, -1.534951378556708],
            [11.789323776501845, -1.5368704484088693],
            [11.784946805098338, -1.5344634095944603],
            [11.780787817459984, -1.5364971823133224],
            [11.77702548983026, -1.5333796041880232],
            [11.77209145171764, -1.5318804762957328],
            [11.768251968697506, -1.5282149356718153],
            [11.760062876276496, -1.5299445263053788],
            [11.75778076588656, -1.52237640726518],
            [11.755725724791509, -1.5207530290459652],
            [11.749556704043432, -1.5214039407509599],
            [11.741069144750925, -1.529830771070226],
            [11.733840578626822, -1.533210003592884],
            [11.725612718809803, -1.5359558160561646],
            [11.713129666181759, -1.5478680555912334],
            [11.70845018907234, -1.5513376848515368],
            [11.704545720081075, -1.5565937889955497],
            [11.697362349195943, -1.5689122680470493],
            [11.696370665867395, -1.5722389246814779],
            [11.68866639952998, -1.5804130245999064],
            [11.68067022924117, -1.5833906537827707],
            [11.673240557112843, -1.5900433486282013],
            [11.667584854495459, -1.6060884844419154],
            [11.659125248473003, -1.630069863348903],
            [11.65247129583794, -1.630958866695181],
            [11.65008442968035, -1.6334974252855397],
            [11.644982612109603, -1.6353178755108104],
            [11.643172752680426, -1.6332735997713086],
            [11.64119979741477, -1.6259744301687074],
            [11.63853962021641, -1.6238250292656433],
            [11.63329984229015, -1.6236669038627574],
            [11.628328116571447, -1.6221128624947332],
            [11.6268647477959, -1.6164168120630276],
            [11.62492829637303, -1.6141125166822545],
            [11.618590624903991, -1.6124385743624754],
            [11.617855206092106, -1.6086479617924283],
            [11.615050712026193, -1.604481152868219],
            [11.615918884695995, -1.599748479181985],
            [11.613852412432776, -1.596896093998666],
            [11.607081352222318, -1.5937974350353827],
            [11.607643311359613, -1.5868232098089896],
            [11.599349553273088, -1.5837439511112728],
            [11.597726187392722, -1.5772979812447971],
            [11.59915123005374, -1.5728041761880198],
            [11.594354505144432, -1.5697422681654036],
            [11.590703609071934, -1.5723237898224407],
            [11.582966511104747, -1.5718392414049385],
            [11.58042528122847, -1.5753778909780507],
            [11.574130310982975, -1.569373465086283],
            [11.574121108241648, -1.5654995762697852],
            [11.567544712007283, -1.5624945806891413],
            [11.568946781384465, -1.5601970029816377],
            [11.564337734109694, -1.5558479390546305],
            [11.562274740081552, -1.5576036072445834],
            [11.557892684093648, -1.5534164965976494],
            [11.561458063186674, -1.5494047379085607],
            [11.55843252065085, -1.545074162642491],
            [11.552223172741778, -1.5450740162671688],
            [11.544495342108874, -1.5424425314038375],
            [11.551334407655817, -1.533067626234051],
            [11.553598913621904, -1.5287545973358434],
            [11.557928951528584, -1.5242369593562566],
            [11.562077181168993, -1.5174006512428133],
            [11.563931314287995, -1.5114136064514594],
            [11.566213908017806, -1.5083213785153038],
            [11.568151089308548, -1.5018117227301946],
            [11.574927716697177, -1.4931566858787366],
            [11.579293460196867, -1.4845521874971144],
            [11.57994730808581, -1.4786401684921626],
            [11.585780345607777, -1.475708013266893],
            [11.586839737435586, -1.4658475644325066],
            [11.593935381621622, -1.459085929604399],
            [11.593988727746064, -1.4560080949722936],
            [11.603664810230951, -1.4362155488971957],
            [11.611030345572448, -1.430246984830278],
            [11.613464646891446, -1.42361996205344],
            [11.608799270988717, -1.4217369521774077],
            [11.607558016218979, -1.4189708867086326],
            [11.596364915326811, -1.4115751309470443],
            [11.590815018412766, -1.405244576531119],
            [11.582043599092009, -1.3994665944200753],
            [11.582857456855486, -1.393019926761263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.85171526911373, "lat": 36.4549780661458 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47091"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01639760"
      },
      "bbox": [
        11.544495342108874, -1.6353178755108104, 11.83241059136937,
        -1.2497666616476628
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.455345738566074, -1.8178969845576627],
            [9.525758372268719, -1.8966512775520186],
            [9.538540937995146, -1.909992244672008],
            [9.545202382228357, -1.904516018223653],
            [9.553053811725615, -1.9022489871023125],
            [9.557782693756959, -1.9114340436823276],
            [9.56913466480776, -1.910165843241684],
            [9.5721270652688, -1.9262665674398354],
            [9.573583217240582, -1.9283262855510936],
            [9.576117329795276, -1.9392996225946304],
            [9.573386074759517, -1.9470544708765898],
            [9.579421762797462, -1.9499765159392628],
            [9.587656572001986, -1.9468472349230526],
            [9.589448981660626, -1.9410415115592579],
            [9.605750956468865, -1.9466882833888612],
            [9.657688048828325, -1.9632430277331434],
            [9.657603638164414, -1.9691475555522986],
            [9.661468385730172, -1.9750790198582497],
            [9.66455780168697, -1.9766333527962963],
            [9.669289469095826, -1.9764629267792426],
            [9.669846281338328, -1.9843217607843704],
            [9.68082174274421, -1.9917222579203195],
            [9.686431388101703, -2.0006915991929404],
            [9.68565044841323, -2.0035308452369653],
            [9.687508589620451, -2.0081818517402903],
            [9.68444290282605, -2.0127228052828605],
            [9.680928495533253, -2.0139973265541955],
            [9.68300451936354, -2.025398914538688],
            [9.686792506540595, -2.0260542969762487],
            [9.688986509606961, -2.0288350079599615],
            [9.699038783041349, -2.031265045084073],
            [9.703447419771102, -2.037635252662208],
            [9.707668009126191, -2.0470789409678254],
            [9.709547172995737, -2.05386090049183],
            [9.712737452271634, -2.0535720846367753],
            [9.721578249281324, -2.057265681812338],
            [9.729021406731405, -2.054829047090578],
            [9.732129431629998, -2.059122601014674],
            [9.737332761821353, -2.060110217017924],
            [9.744040690733863, -2.062843619225849],
            [9.761397001731586, -2.0865233336700726],
            [9.779343429396965, -2.105655439502446],
            [9.775984371455525, -2.105990939432541],
            [9.764278908407467, -2.1132006477047733],
            [9.75629256838906, -2.1237346468562386],
            [9.749931424778692, -2.134372759798018],
            [9.741075482800648, -2.1424707637369167],
            [9.732831347678724, -2.1529311539033062],
            [9.726283733461761, -2.1574925128997715],
            [9.722857504745628, -2.1611643163627923],
            [9.712587492643504, -2.1699898443423344],
            [9.708527463292066, -2.1754228434628415],
            [9.704170045691813, -2.178884155062581],
            [9.696014921212289, -2.181794459967491],
            [9.692703146625236, -2.1808998547280383],
            [9.68715721059666, -2.183345696100268],
            [9.680105794286836, -2.183184505172219],
            [9.674701615309038, -2.184635763622794],
            [9.67156421846613, -2.183671295582614],
            [9.66559115172476, -2.1866266330560094],
            [9.654697573699043, -2.1932846894677938],
            [9.646229969621679, -2.197211602102594],
            [9.637378691740805, -2.2002188461203156],
            [9.626969897570516, -2.205641286437936],
            [9.620844131643588, -2.210813503503534],
            [9.621789628823784, -2.2250855523057065],
            [9.614955503152126, -2.226731340384668],
            [9.605587869377539, -2.2275517112411207],
            [9.601151265297954, -2.226339879360296],
            [9.593627747256559, -2.2294503635463205],
            [9.584490945711961, -2.2284057887405186],
            [9.580549029708942, -2.2292622771640653],
            [9.581836098370015, -2.2357636419845455],
            [9.57466157585164, -2.240608584843932],
            [9.571502240289613, -2.2495947333901074],
            [9.56624415733671, -2.24800422910769],
            [9.565666378674575, -2.251704811798907],
            [9.561574615577861, -2.25285745401946],
            [9.557523808064042, -2.252025357577796],
            [9.554394722539838, -2.2566169633609965],
            [9.547464869369346, -2.2560829526676796],
            [9.544478630939366, -2.2656956058479447],
            [9.541394451646873, -2.265054528333359],
            [9.540893107557574, -2.2698962520350863],
            [9.53384621874451, -2.268924987543088],
            [9.530792199884356, -2.2768385490651992],
            [9.5267561540046, -2.279076228717449],
            [9.48447429341504, -2.196310791222713],
            [9.42013520359577, -2.1384859964186447],
            [9.406330629021696, -2.110481415087311],
            [9.40144146804856, -2.112557528044904],
            [9.398313300703576, -2.110104665512811],
            [9.398400810014568, -2.1064765415734703],
            [9.394197637211802, -2.1050057319558864],
            [9.38994373382629, -2.106234207721393],
            [9.388159071989403, -2.1149539107125603],
            [9.385052508826654, -2.1176076452037336],
            [9.350854904155199, -2.0721119270836628],
            [9.348189187150954, -2.0682063699869073],
            [9.341611032381156, -2.0662605382545114],
            [9.338287651675389, -2.061832716756296],
            [9.334259053813078, -2.0605852341244817],
            [9.325835444634789, -2.0604188023093943],
            [9.323922598823723, -2.057340318482174],
            [9.320342013636488, -2.056391019229828],
            [9.316617221079342, -2.052240996323412],
            [9.318316669751546, -2.049015315731435],
            [9.31756801737864, -2.0412695286595914],
            [9.320902071804992, -2.0353505914455776],
            [9.318332455560228, -2.031164723424323],
            [9.316248481637649, -2.024377659718075],
            [9.310933998741266, -2.0223667884821825],
            [9.309342352909479, -2.0176710006069296],
            [9.31123188880689, -2.0123876352590697],
            [9.308852778169882, -2.0107436906931486],
            [9.305423046637245, -2.0007419349602116],
            [9.310308482618098, -1.9925368607541425],
            [9.312531851913075, -1.9910330944983547],
            [9.313291477442991, -1.9841622584208165],
            [9.31684589310316, -1.9833473285121213],
            [9.319919531808104, -1.9741520854599495],
            [9.318769076392842, -1.9715913384877948],
            [9.320712705866596, -1.9669397734910394],
            [9.325471297454595, -1.967560439041682],
            [9.325769305634573, -1.9600769909020277],
            [9.323936493437033, -1.956954456108204],
            [9.324771872183547, -1.9437469590688066],
            [9.32838209995137, -1.935649653185302],
            [9.325213775237142, -1.9253754408863162],
            [9.327228743781728, -1.9196604773204582],
            [9.333586485012404, -1.9114660733355797],
            [9.340424199749437, -1.9114091708018495],
            [9.341367098270394, -1.909838420596377],
            [9.349001396622626, -1.9124927197274155],
            [9.352512403388593, -1.9152504459083255],
            [9.356911050240893, -1.910281407124281],
            [9.360405449032681, -1.9088726666186142],
            [9.36133430684935, -1.906049686531121],
            [9.367589974393061, -1.9007692614994518],
            [9.3722478734573, -1.9027517025675031],
            [9.374053559330397, -1.906224007574823],
            [9.381086802843656, -1.9018663950564763],
            [9.388865398079776, -1.900106908867388],
            [9.391566610365448, -1.8953637649500736],
            [9.387970946397171, -1.8898655732446625],
            [9.390454623033161, -1.8850678665787453],
            [9.391567282583448, -1.8796044093526763],
            [9.397206477965828, -1.8773320883036684],
            [9.393087609996753, -1.8729719817225676],
            [9.393606608957832, -1.8707678266341161],
            [9.399021852018588, -1.869404682943187],
            [9.402650943583927, -1.8606554528847212],
            [9.406137996527306, -1.8616438190399478],
            [9.411881293782047, -1.8660959395293926],
            [9.41656476418308, -1.859218101501905],
            [9.420960485647042, -1.8612825251431562],
            [9.428471028168923, -1.854520829037706],
            [9.425303212182081, -1.8497900255987412],
            [9.424164988086194, -1.844090270897106],
            [9.422294865889123, -1.841893464383786],
            [9.424366230891536, -1.838694491005751],
            [9.43208932143234, -1.8413591390516926],
            [9.435719612851804, -1.8399372506583875],
            [9.436643363424997, -1.8372393038083121],
            [9.43152586584307, -1.8330101525050977],
            [9.430778238279755, -1.8254623497435338],
            [9.433086308121771, -1.8221270984352178],
            [9.437541391161044, -1.8210822873796084],
            [9.435766488911778, -1.8146728706415423],
            [9.440691477632415, -1.8157188592078692],
            [9.44369628566494, -1.8185034551069033],
            [9.451413606631965, -1.8212266944962785],
            [9.455345738566074, -1.8178969845576627]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.64923411259565,
          "lat": 36.135034673638806
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47129"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01639778"
      },
      "bbox": [
        9.305423046637245, -2.279076228717449, 9.779343429396965,
        -1.8146728706415423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2303435162811565, -6.617498707317971],
            [-2.1964213951351406, -6.61839331185232],
            [-2.1709099303860846, -6.619510623052932],
            [-2.165271830282442, -6.619297140505751],
            [-2.0656310342575845, -6.6233882380246545],
            [-2.0625291972098574, -6.622856277108056],
            [-2.0016105389584857, -6.626032150227195],
            [-1.9513003401318008, -6.720580569444213],
            [-1.8909913671915224, -6.831860186969679],
            [-1.8888665586950426, -6.836659023620557],
            [-1.8621057787033009, -6.886645516507686],
            [-1.8232665239400494, -6.958692098092447],
            [-1.7965351001948766, -7.008757531961337],
            [-1.8744210124382839, -7.019121981019338],
            [-1.8935988082580915, -7.095509915170597],
            [-1.9306320267247075, -7.120191182412999],
            [-2.0347903435191057, -7.189646710346467],
            [-2.052705132282563, -7.200949274372327],
            [-2.064941445300126, -7.207270348798433],
            [-2.077024619331361, -7.216226981910087],
            [-2.082023248007917, -7.2188917184138575],
            [-2.0894516356056765, -7.219621484776148],
            [-2.0935942316005276, -7.228487368311431],
            [-2.100751545675318, -7.229903197582284],
            [-2.102893229160937, -7.224350209885715],
            [-2.1096111055041433, -7.217203496386095],
            [-2.113164899623555, -7.211645101170709],
            [-2.117392444214602, -7.208839376289515],
            [-2.127079540346208, -7.214514455676055],
            [-2.1314357015159975, -7.2241013147636615],
            [-2.1374576689886955, -7.227628781266903],
            [-2.1358390778872467, -7.233410082759057],
            [-2.1383232605751363, -7.235562675554665],
            [-2.146353960863667, -7.230964954322268],
            [-2.148957813801801, -7.234693759102289],
            [-2.155689532375662, -7.23915553386534],
            [-2.1618431908607056, -7.236595663666351],
            [-2.167390277619744, -7.241769250920185],
            [-2.1654216356451625, -7.247115801219228],
            [-2.17030513761619, -7.247933338331316],
            [-2.1738934614551413, -7.243448896041376],
            [-2.177704358340864, -7.241007616849861],
            [-2.1758723373640976, -7.233507133617934],
            [-2.1784422514086046, -7.230494136843596],
            [-2.1832816505548576, -7.228613932018823],
            [-2.1867723388780114, -7.229856472407582],
            [-2.1857909891180123, -7.235600114852947],
            [-2.1912527694640147, -7.240050514733071],
            [-2.197879839812035, -7.231554526047404],
            [-2.2064312076925545, -7.228933599828569],
            [-2.212847185892447, -7.230191567975517],
            [-2.215149510756704, -7.2278617516333625],
            [-2.222333169301066, -7.227724527025484],
            [-2.2306847012817177, -7.232432745178295],
            [-2.2332700774660936, -7.236474435730454],
            [-2.2385447567437193, -7.240031128226075],
            [-2.2420843740129643, -7.239909509913732],
            [-2.2416928784759964, -7.234487855875169],
            [-2.244695386211559, -7.224502796624395],
            [-2.24923326279734, -7.221324167890823],
            [-2.252259338396726, -7.222325338748148],
            [-2.2568660862518817, -7.227188830123292],
            [-2.255615070344066, -7.193497839009138],
            [-2.251962400088051, -7.073541113952327],
            [-2.2475654873847315, -6.937366354335743],
            [-2.2428855867086717, -6.843737490456544],
            [-2.2411014189378315, -6.813669499359247],
            [-2.2363688900889946, -6.725991437751256],
            [-2.2303435162811565, -6.617498707317971]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.99976897359171,
          "lat": 31.774256491020704
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48049"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01383810"
      },
      "bbox": [
        -2.2568660862518817, -7.247933338331316, -1.7965351001948766,
        -6.617498707317971
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [1.3952843447464458, -9.13572600780157],
              [1.4013282526698623, -9.131168030177921],
              [1.4039170416246847, -9.131649567185146],
              [1.4135820013972873, -9.145216990699126],
              [1.4138154064550619, -9.147561650031783],
              [1.4081781095710717, -9.151606021947003],
              [1.4056945038555362, -9.15132788469394],
              [1.3952843447464458, -9.13572600780157]
            ]
          ],
          [
            [
              [1.3529601098327406, -9.042638264981116],
              [1.3594468254118184, -9.038339255661898],
              [1.3619021593166132, -9.041503251508964],
              [1.3728620747658504, -9.04322048964565],
              [1.3776898639634947, -9.05030908343363],
              [1.3833472892586807, -9.066877029040832],
              [1.382537263144556, -9.06831443150263],
              [1.37225175372757, -9.070058815647467],
              [1.3774623063987677, -9.076123854153005],
              [1.377062798168131, -9.086535965037804],
              [1.3852592608120229, -9.098996679822655],
              [1.383561637120358, -9.104219700839076],
              [1.3786283997934377, -9.10641613821306],
              [1.373377247396752, -9.101252337546347],
              [1.372550988840947, -9.097380497018374],
              [1.3743289178669564, -9.091361492183706],
              [1.3729443048267933, -9.087601235812532],
              [1.368104723688307, -9.08407094377989],
              [1.36666460284107, -9.077223066594435],
              [1.362639405310643, -9.068986139770653],
              [1.3598668968019185, -9.053562791653391],
              [1.3529601098327406, -9.042638264981116]
            ]
          ],
          [
            [
              [1.3460954177199858, -8.839066820013871],
              [1.3997122246282931, -8.837633205605814],
              [1.4725352772038054, -8.83593473412501],
              [1.5138208073554815, -8.834782739445314],
              [1.5934686412542478, -8.832729998911708],
              [1.6432130076553888, -8.8313195808354],
              [1.733127822027126, -8.828896243866355],
              [1.7628974852618824, -8.82800804747723],
              [1.770400812427739, -8.82831799529713],
              [1.8131020384038963, -8.82760762399118],
              [1.8145314310648513, -8.83010472968521],
              [1.8861173714609296, -8.828444431261845],
              [1.888605289180072, -8.908920206548807],
              [1.8910218272594335, -8.985429773899288],
              [1.8941232713479954, -9.087530540732564],
              [1.8941139051623823, -9.092348476943288],
              [1.895514150281303, -9.137271331701882],
              [1.8951086255806284, -9.149404897452051],
              [1.8806699549746706, -9.155892282776431],
              [1.8792725666716872, -9.11542076237336],
              [1.8746087063670385, -9.118985193160224],
              [1.871881768827754, -9.117513015392198],
              [1.8659295390915482, -9.118537474707045],
              [1.8562965843797519, -9.116250794405106],
              [1.851293724209118, -9.11696703615008],
              [1.8489540690165045, -9.114923689282246],
              [1.8432305543720267, -9.120837835272354],
              [1.8400715258888891, -9.120779234025042],
              [1.8384730206465907, -9.127207642722347],
              [1.8425333890003066, -9.130571954894661],
              [1.8425831558975307, -9.135420419715535],
              [1.844187756947061, -9.139588358253192],
              [1.8411675421814726, -9.140325485081117],
              [1.839578157059152, -9.143704490485188],
              [1.8362277630072041, -9.1433348334767],
              [1.8352434200474392, -9.146762045661873],
              [1.823644476252433, -9.148873068309664],
              [1.8210018116005071, -9.14781384646451],
              [1.8173128443113695, -9.150894489342855],
              [1.81359838862005, -9.149296379038285],
              [1.8039767296587859, -9.152687138883657],
              [1.8003309563665297, -9.15277406422819],
              [1.7924327930128319, -9.156580080316337],
              [1.7904649361631984, -9.154994921611028],
              [1.7865856820977946, -9.158016857553756],
              [1.7771286190352313, -9.161330655979436],
              [1.7718999390187167, -9.164066845826456],
              [1.7697683854412156, -9.16862069775738],
              [1.749846287403335, -9.17323918375096],
              [1.749238454179321, -9.165692640759028],
              [1.747835346578962, -9.161830465421698],
              [1.7383669695183812, -9.154905691801046],
              [1.7336154373450472, -9.150513325923521],
              [1.7288628150494567, -9.142876483392088],
              [1.7225060231283236, -9.140837191317354],
              [1.7150374784497522, -9.140568959534466],
              [1.7072097038423852, -9.142860244593907],
              [1.7000851624502196, -9.147163865751113],
              [1.6879456883842756, -9.152748983487955],
              [1.6833459238820236, -9.153252600393625],
              [1.6801392991696391, -9.155782822033585],
              [1.6611790087028004, -9.161892147858813],
              [1.6529676364359567, -9.163524928045902],
              [1.648178373659179, -9.165409718301753],
              [1.6320097077697726, -9.168173589647731],
              [1.6240982587101225, -9.171768190874815],
              [1.605655518381457, -9.177912483452404],
              [1.5949253804910255, -9.17835234017031],
              [1.5927412839806177, -9.177512923574403],
              [1.5847965900317464, -9.179505524829489],
              [1.5797245250289835, -9.182327989974416],
              [1.5772438391115595, -9.182193158053424],
              [1.5594318657700528, -9.189657295038984],
              [1.5538189779715148, -9.18897326085389],
              [1.5494065254458982, -9.191264843785444],
              [1.540400174534498, -9.192636931046092],
              [1.535067518297849, -9.191227320633974],
              [1.5260346739989352, -9.186901445449227],
              [1.5238406747746525, -9.184387865460907],
              [1.5174885710752943, -9.171275851538612],
              [1.5248139561312042, -9.168301114003574],
              [1.5286105500287772, -9.171790789468053],
              [1.5321325542612803, -9.177473732462618],
              [1.5409942777404955, -9.175215632997592],
              [1.5414907570266299, -9.17367879945919],
              [1.549976966545178, -9.166524990029739],
              [1.5511777881610245, -9.163549081282932],
              [1.5480243506146174, -9.159608582299951],
              [1.5479755368482588, -9.155934845384202],
              [1.5527602696246487, -9.150463263250403],
              [1.5622622835297977, -9.142274966427419],
              [1.5683120170568985, -9.13107030717362],
              [1.5721091472051951, -9.121528012225497],
              [1.5806682335805402, -9.107275444742006],
              [1.587366490208793, -9.092294255786104],
              [1.5921740267253568, -9.078195374992278],
              [1.5943702334930119, -9.065310155753531],
              [1.5952747769022004, -9.056114873023342],
              [1.5958316019286922, -9.036723254520547],
              [1.6017553739598012, -9.024809265749472],
              [1.6010386605994114, -9.017882212735174],
              [1.6013237698536764, -9.008698051626563],
              [1.5986505904624329, -8.994557033882963],
              [1.5947598822863587, -8.989306633708082],
              [1.5942145503777563, -8.98065923768841],
              [1.5965444840541272, -8.9733236323368],
              [1.5936924036237532, -8.96535621396137],
              [1.5951387279733265, -8.959778644956074],
              [1.5842239017788224, -8.952909745078767],
              [1.5801177549467682, -8.943252704767433],
              [1.575151494303666, -8.938319946042656],
              [1.569083200246939, -8.93912812035517],
              [1.5693419623260505, -8.92630579364797],
              [1.5666432711908158, -8.925061259105075],
              [1.5641277525984332, -8.930048364423277],
              [1.5577938839903436, -8.929127248025202],
              [1.5500591261466237, -8.930267321401022],
              [1.547290853411491, -8.936686526597725],
              [1.5300105107372408, -8.94358372853718],
              [1.5158084381062988, -8.950907871819275],
              [1.504933773157992, -8.954619546760782],
              [1.4916713176867167, -8.961778164622404],
              [1.4842006469824482, -8.97017836199256],
              [1.4839290802958987, -8.971637567122656],
              [1.4740654883373296, -8.98296341367602],
              [1.4609838511248379, -8.998822474369678],
              [1.457621706157883, -9.004797843359096],
              [1.4564163857181798, -9.009973544289245],
              [1.4492310808905742, -9.024690158050369],
              [1.447317910240332, -9.041084093469564],
              [1.4429669283865982, -9.04856307792242],
              [1.4263837455135984, -9.058598845909406],
              [1.4121511334862058, -9.064385802812211],
              [1.4015241204862696, -9.063011950274976],
              [1.400716795093393, -9.055733971375858],
              [1.3953514169595382, -9.051973479295214],
              [1.3924291386843686, -9.046673577986857],
              [1.3949411215650844, -9.039782131595578],
              [1.401694061769805, -9.033617263887098],
              [1.4001107666436465, -9.027333044929813],
              [1.404702722664573, -9.02439718628003],
              [1.4050864988381777, -9.022138970545452],
              [1.3980891625668106, -9.021499149151548],
              [1.3968100445265035, -9.023842438089055],
              [1.392857567130529, -9.023327211104304],
              [1.3968103216119434, -9.017041142636456],
              [1.3918491370777764, -9.01636319918657],
              [1.389490056679775, -9.014450617351185],
              [1.388242271479123, -9.005792178786296],
              [1.3826225027074113, -9.007770296835378],
              [1.37919933319998, -9.004834399233648],
              [1.3825131849764114, -8.996459375477107],
              [1.3881928141534114, -8.988580513742386],
              [1.393790299407337, -8.982421538840269],
              [1.3923367474433415, -8.971321835268947],
              [1.3978510069666303, -8.966058462919111],
              [1.402208905037944, -8.965170436577452],
              [1.4026603328483904, -8.96029644269375],
              [1.4014184712592614, -8.956809374952455],
              [1.4056292490588354, -8.952248691721929],
              [1.4005125823419557, -8.946166842197542],
              [1.4004813399384075, -8.940585098902009],
              [1.4023022531421552, -8.932618759743042],
              [1.4008517335235413, -8.928072815093625],
              [1.3981660030263263, -8.925156947476246],
              [1.3977158424430285, -8.91948342296321],
              [1.402958381329298, -8.918517995211316],
              [1.403542361708678, -8.915392275301985],
              [1.406748110667723, -8.91305056853068],
              [1.4100961979342337, -8.90693134511706],
              [1.4077780994980573, -8.903761174769551],
              [1.4098787116390379, -8.896500950375026],
              [1.407141636820856, -8.893209784561543],
              [1.3940739198289451, -8.888567045289117],
              [1.3872498968819225, -8.888049640144759],
              [1.377334810607579, -8.876811408661602],
              [1.3758072792927991, -8.871836479118201],
              [1.3703425923187706, -8.867242510932426],
              [1.3598180568565565, -8.864824789292568],
              [1.3538944085796436, -8.859817213102657],
              [1.3500127503692247, -8.85494267206844],
              [1.3506179164252028, -8.846228530003236],
              [1.3460954177199858, -8.839066820013871]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.6099522420428, "lat": 29.738422179819427 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48071"],
        "coty_name": ["Chambers"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chambers County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01383821"
      },
      "bbox": [
        1.3460954177199858, -9.192636931046092, 1.895514150281303,
        -8.82760762399118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.6931591323693946, -7.102235452332824],
            [-2.686603633723833, -6.982369069196849],
            [-2.6758382275623944, -6.781327963065523],
            [-2.668881778537125, -6.6443097641732445],
            [-2.6667771765904167, -6.598881469400673],
            [-2.5972543290579435, -6.602365716024672],
            [-2.4868795773740353, -6.607879809500293],
            [-2.486118679335532, -6.60774682532636],
            [-2.421618228121338, -6.609962274091346],
            [-2.327358507929755, -6.613340591019739],
            [-2.2762156894337098, -6.615123839395299],
            [-2.2732823357851824, -6.6159316463886695],
            [-2.2303435162811565, -6.617498707317971],
            [-2.2363688900889946, -6.725991437751256],
            [-2.2411014189378315, -6.813669499359247],
            [-2.2428855867086717, -6.843737490456544],
            [-2.2475654873847315, -6.937366354335743],
            [-2.251962400088051, -7.073541113952327],
            [-2.255615070344066, -7.193497839009138],
            [-2.2568660862518817, -7.227188830123292],
            [-2.2623704222096803, -7.228959696571717],
            [-2.272607445403764, -7.217538659031686],
            [-2.281765717799409, -7.215885699027598],
            [-2.2837988558832505, -7.211797902678953],
            [-2.2866185658141216, -7.210350245669549],
            [-2.2941529804046517, -7.213498412108769],
            [-2.299464917905071, -7.2179919994755215],
            [-2.300912252044313, -7.222636544480186],
            [-2.308717490945481, -7.231246914594768],
            [-2.3164141419129045, -7.237808255087614],
            [-2.315121112916751, -7.243204464222036],
            [-2.3198431685856424, -7.246686100100434],
            [-2.3248053700926614, -7.244621948809419],
            [-2.3306181758302533, -7.24761716988976],
            [-2.331793363585287, -7.250344922245409],
            [-2.3290485105530285, -7.259033272182518],
            [-2.33112538135186, -7.2630541686337935],
            [-2.335010893562698, -7.262550996816829],
            [-2.3389693169497696, -7.259563100784497],
            [-2.3428507189969436, -7.258875348007272],
            [-2.3465857168116533, -7.263736428902196],
            [-2.3446654990526388, -7.2706836630104235],
            [-2.3485496412767866, -7.274953448299015],
            [-2.3510981803376665, -7.2797932445909534],
            [-2.3547627033472747, -7.280604006008578],
            [-2.358941206667618, -7.275332095643587],
            [-2.366375179353556, -7.275688744957535],
            [-2.373409821982691, -7.273414310694793],
            [-2.380299953164906, -7.268134229426049],
            [-2.3809597728176013, -7.265037310506625],
            [-2.375720351744326, -7.258589167330915],
            [-2.3763395024475793, -7.24899576929617],
            [-2.3796968505748666, -7.247029091064232],
            [-2.3869058315543388, -7.25766507347595],
            [-2.389532135050869, -7.258712955284448],
            [-2.397385410202611, -7.2516275756322335],
            [-2.4088902157636705, -7.2487988745270835],
            [-2.4111472371580085, -7.2455523601372365],
            [-2.4180547175016454, -7.244596532920092],
            [-2.427031402299125, -7.242283133143695],
            [-2.4298005880791913, -7.239609722497474],
            [-2.426430050161826, -7.233939702769572],
            [-2.4242639404802104, -7.233126713869648],
            [-2.423568161438039, -7.228569280670247],
            [-2.4287178568787104, -7.22889359667891],
            [-2.4328819792676337, -7.226321791063607],
            [-2.4388853911916666, -7.22672069765751],
            [-2.447587474542702, -7.222535022939529],
            [-2.453851815630599, -7.217569741415936],
            [-2.4587160505961805, -7.212438903158811],
            [-2.461937791560746, -7.21255230244201],
            [-2.466363975002904, -7.217678080887307],
            [-2.466971040225831, -7.229431963082184],
            [-2.4642929398243405, -7.236670704194687],
            [-2.455198365960318, -7.237857495833775],
            [-2.4564329700724565, -7.241398695083803],
            [-2.4706016541297022, -7.2463927209232795],
            [-2.4787911352579837, -7.25408787102828],
            [-2.4844844070757732, -7.2559973404085],
            [-2.4838676417210643, -7.261148464530447],
            [-2.4862032754396157, -7.264538448999323],
            [-2.490921094425837, -7.262325613905806],
            [-2.492410184442423, -7.2598491642996],
            [-2.4927517231169314, -7.25359386331212],
            [-2.4979005852875527, -7.248891527624466],
            [-2.5000558244277062, -7.244986448418698],
            [-2.504136705808461, -7.241186420493848],
            [-2.5080431778461567, -7.24126706339267],
            [-2.5145510773303634, -7.247039192822429],
            [-2.51822277871895, -7.259696736200359],
            [-2.522403707632124, -7.259469708777673],
            [-2.5247210761185106, -7.2526145197596685],
            [-2.526721150855534, -7.238482008874496],
            [-2.5312074591508265, -7.231761537741112],
            [-2.5347200532165504, -7.224058966762787],
            [-2.537826745761633, -7.214075670784952],
            [-2.5381649587168074, -7.20477714320004],
            [-2.5398160801064678, -7.201092162634333],
            [-2.5460484790825992, -7.20063846473727],
            [-2.552747776326512, -7.197755891145953],
            [-2.5559632717581593, -7.194937382450496],
            [-2.5626878545431335, -7.193171317876166],
            [-2.569849861036156, -7.189789546191672],
            [-2.5838451458974463, -7.193498440171529],
            [-2.594774720122488, -7.19055027951073],
            [-2.604966116710228, -7.1805830413439296],
            [-2.6113332124022675, -7.180579692086165],
            [-2.614096304308878, -7.188274147707865],
            [-2.6095007608394676, -7.19365715164828],
            [-2.6048116520388374, -7.195462957005232],
            [-2.6010013716504528, -7.200312305973784],
            [-2.600399722629349, -7.203137791625808],
            [-2.604223611439394, -7.212035788332273],
            [-2.607752834221117, -7.213787329708356],
            [-2.616391308003219, -7.214079596565885],
            [-2.6215595807826095, -7.20926299934152],
            [-2.6248117252278464, -7.204574572602376],
            [-2.6252643622083607, -7.201147538364556],
            [-2.6324681240971057, -7.189764561203409],
            [-2.637715955716907, -7.1844130541168],
            [-2.645553141480638, -7.182048278236468],
            [-2.652050369775739, -7.183850001287037],
            [-2.6578057575242973, -7.182858672764935],
            [-2.658615127588761, -7.178616940660863],
            [-2.6522936336323357, -7.169450103768103],
            [-2.644822427149037, -7.165581157112805],
            [-2.640160853514379, -7.1614656641304055],
            [-2.6364432340780053, -7.153566386864063],
            [-2.6383690079736195, -7.148169185926206],
            [-2.641447614114551, -7.14608558048931],
            [-2.652793400385826, -7.147072882194028],
            [-2.6689159198159946, -7.14751867134775],
            [-2.670318193607166, -7.141524546002893],
            [-2.662543707372404, -7.139768252412903],
            [-2.6531803336406137, -7.133348330939535],
            [-2.651603825087092, -7.130273144342579],
            [-2.6530645586817245, -7.125190004914113],
            [-2.6559210568679865, -7.123845988696621],
            [-2.664081187182481, -7.126776612496923],
            [-2.6679782203573277, -7.125849754225962],
            [-2.67096399216238, -7.121416276752712],
            [-2.6705720347255477, -7.1154678082506],
            [-2.672537815307938, -7.110526014438073],
            [-2.6750875985776488, -7.108873982736169],
            [-2.6782990183943185, -7.103813948325817],
            [-2.6835321774730585, -7.103383939984002],
            [-2.685794039563972, -7.113555769529456],
            [-2.6842804176630173, -7.117841186962395],
            [-2.690150674775347, -7.118597586140849],
            [-2.6940188687756956, -7.1161599318447175],
            [-2.6931591323693946, -7.102235452332824]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.45363721667914, "lat": 31.77317118697113 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48083"],
        "coty_name": ["Coleman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coleman County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01383827"
      },
      "bbox": [
        -2.6940188687756956, -7.280604006008578, -2.2303435162811565,
        -6.598881469400673
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.985820269080015, -7.469235564562918],
            [-4.911278524122137, -7.475118076285593],
            [-4.803632155154595, -7.483592797062433],
            [-4.6959838924180755, -7.492047767172353],
            [-4.655282066309626, -7.495393408991693],
            [-4.586751237845584, -7.500541797192577],
            [-4.4643968470930915, -7.509713271533801],
            [-4.328138535969234, -7.517961047685771],
            [-4.191878229778542, -7.526177271575301],
            [-4.122838828583095, -7.52989937539336],
            [-4.037101416601013, -7.53477219364889],
            [-4.016294150002831, -7.535882647985108],
            [-3.8933654024569355, -7.540916285821448],
            [-3.770435968319846, -7.545924320214915],
            [-3.78071960823522, -7.766824766175674],
            [-3.780662186428589, -7.767101351086533],
            [-3.7887749980114234, -7.919548738241611],
            [-3.7995666441935168, -8.12146150097954],
            [-3.799567452873968, -8.123614163552004],
            [-3.8071394528736238, -8.265967780449204],
            [-3.807391877429029, -8.273069708989535],
            [-3.8106909421597694, -8.333941273051805],
            [-3.820535102657956, -8.33361049083184],
            [-3.8448845012101374, -8.331866024452044],
            [-3.849032733277328, -8.332390167410342],
            [-3.9058879054791804, -8.329054971083282],
            [-4.056647136940416, -8.320598905693252],
            [-4.059761743378025, -8.3202201023606],
            [-4.16768639197934, -8.314477887006522],
            [-4.316114410768899, -8.305874921395636],
            [-4.389410011978686, -8.301726083505041],
            [-4.402506403942117, -8.300479470887078],
            [-4.497294013242287, -8.29532387904478],
            [-4.492051565746728, -8.287762676448308],
            [-4.487171392684733, -8.286601373873491],
            [-4.4845404192244365, -8.282947605570913],
            [-4.482708173191046, -8.275406604652105],
            [-4.480687830387922, -8.271733867703778],
            [-4.480108207516321, -8.263463972330143],
            [-4.4766138583869, -8.257954394679352],
            [-4.472663837274167, -8.257361248686406],
            [-4.468888193627641, -8.2533270441299],
            [-4.454657596412557, -8.246842898222893],
            [-4.450907267267139, -8.243514411114731],
            [-4.44408702628753, -8.24101581397641],
            [-4.4357991251135385, -8.241006373191304],
            [-4.428418211794822, -8.246674198335903],
            [-4.417780348831787, -8.249103305904322],
            [-4.408408679234615, -8.246411967719641],
            [-4.4071861245277635, -8.239596227816556],
            [-4.408127695434088, -8.234770203669697],
            [-4.407095199728205, -8.231538502334386],
            [-4.413432058395147, -8.22522963108646],
            [-4.4194527481747174, -8.223716559097872],
            [-4.4294867714193735, -8.218436981120037],
            [-4.433828476874184, -8.21213302436624],
            [-4.43768350147985, -8.20858436503965],
            [-4.440128166106842, -8.203533796041693],
            [-4.437162455278471, -8.20270661758479],
            [-4.435958946684074, -8.194448232117521],
            [-4.437297006182744, -8.190398945839874],
            [-4.441017550729104, -8.185649633661498],
            [-4.448247536862428, -8.18182377043414],
            [-4.452353986587877, -8.182245839661979],
            [-4.456607429179665, -8.179938701881916],
            [-4.460021430807937, -8.180446392242702],
            [-4.464164801766072, -8.178007299443353],
            [-4.469701446482672, -8.171484595765374],
            [-4.4711507232195125, -8.16704604565115],
            [-4.473876675657453, -8.164342300002392],
            [-4.470611978013537, -8.157756249948338],
            [-4.466644414067138, -8.15604699805955],
            [-4.460818027698977, -8.148886109986506],
            [-4.455238326745058, -8.144685006715884],
            [-4.455717594475498, -8.139106651241462],
            [-4.453537772443164, -8.131954707781576],
            [-4.458341027136577, -8.13020232192983],
            [-4.462946562559463, -8.125040913098964],
            [-4.463618407586592, -8.119227860832048],
            [-4.45797186270997, -8.115047361303327],
            [-4.454853591671861, -8.116097116367913],
            [-4.4523826309353005, -8.120620205585151],
            [-4.449252529516271, -8.120317877445114],
            [-4.447143155865062, -8.125990794848795],
            [-4.441596700438716, -8.130333745324183],
            [-4.436946738140932, -8.130496994394498],
            [-4.434504773004414, -8.124846609785694],
            [-4.426699138846104, -8.121147178239122],
            [-4.425468189335538, -8.115288327421817],
            [-4.428170851397227, -8.108268691062474],
            [-4.426814860245083, -8.10639231532009],
            [-4.42781168532616, -8.097430208827532],
            [-4.4252679117451095, -8.093418792543691],
            [-4.4219621921906, -8.09403726644316],
            [-4.419154720358712, -8.0911713201116],
            [-4.414574950513485, -8.09023302184317],
            [-4.412840229357232, -8.087937422484519],
            [-4.413727815913539, -8.08198297488331],
            [-4.415842867965589, -8.078843098153252],
            [-4.416157153427209, -8.071217644818669],
            [-4.415041458176798, -8.06630679918747],
            [-4.409891603688707, -8.065886055322466],
            [-4.404462273187745, -8.05961482429336],
            [-4.399934199830619, -8.05747182885028],
            [-4.399646731351328, -8.054314824287454],
            [-4.395086748919155, -8.051205203386512],
            [-4.3904024841837455, -8.042328981207724],
            [-4.385447958519728, -8.04075897752846],
            [-4.386743770020464, -8.035563950360448],
            [-4.384560521513685, -8.031057892419946],
            [-4.386533206626912, -8.02403922025443],
            [-4.390783229127294, -8.015229610154327],
            [-4.391517217700242, -8.00960767430825],
            [-4.397698104673297, -8.00248078834112],
            [-4.396561823081127, -7.998200877460808],
            [-4.392726420994338, -7.995200825599645],
            [-4.3905398849900825, -7.987157488700144],
            [-4.392838279400058, -7.983639049068236],
            [-4.391594349441732, -7.980236165834685],
            [-4.391777312659328, -7.974787059765355],
            [-4.386544992319304, -7.972665444140942],
            [-4.390103053084102, -7.968418215024062],
            [-4.397796379261692, -7.962456584877167],
            [-4.403261338777221, -7.951834451125921],
            [-4.405412573144165, -7.953568806104473],
            [-4.410156656453958, -7.953568198584916],
            [-4.417120982696105, -7.951292381542694],
            [-4.419269033846546, -7.944561129355318],
            [-4.424114174904468, -7.941425798663056],
            [-4.428095959313276, -7.94369428183548],
            [-4.432747648594279, -7.939757352527155],
            [-4.43304225361327, -7.936778921240791],
            [-4.437150897976261, -7.936761845991904],
            [-4.441433218076073, -7.938596083893769],
            [-4.449666511504504, -7.937239118540317],
            [-4.456570353370868, -7.934021390911772],
            [-4.464058749113729, -7.936832201755262],
            [-4.470919166848353, -7.936396809114398],
            [-4.472552036251482, -7.929993794658077],
            [-4.477991856365726, -7.928636477254257],
            [-4.483729642984123, -7.933357077583748],
            [-4.484609307067871, -7.930458445880887],
            [-4.484701844857137, -7.921669918384375],
            [-4.487303297188277, -7.915581811415348],
            [-4.486590684311246, -7.912949923010287],
            [-4.488612508204614, -7.904919840509769],
            [-4.492749604986374, -7.898690741642748],
            [-4.4963000855505895, -7.898120338727624],
            [-4.499070508311626, -7.895224275270239],
            [-4.50306219197144, -7.894564235633008],
            [-4.502395638955052, -7.889116031593043],
            [-4.509458439413172, -7.888444031463597],
            [-4.514295751589145, -7.885327620477697],
            [-4.515385553324408, -7.875093762535802],
            [-4.5131739534699085, -7.8597643348970045],
            [-4.517358513293726, -7.850511781719382],
            [-4.518787866052159, -7.844151329822156],
            [-4.517091408369864, -7.84169001206808],
            [-4.518274604067752, -7.832838599664079],
            [-4.524293873235845, -7.827181985586946],
            [-4.529393559740829, -7.828798468766028],
            [-4.537353915175612, -7.819832130286137],
            [-4.534852397282008, -7.815968000438454],
            [-4.533107275889954, -7.810010544964139],
            [-4.5368162855742575, -7.798605081294346],
            [-4.532437673931894, -7.795648187619626],
            [-4.529237008901233, -7.788966631139915],
            [-4.528599924413105, -7.782733943448576],
            [-4.531289099979585, -7.775489341282601],
            [-4.53099305459164, -7.7705792972096415],
            [-4.534565539573029, -7.762564659106269],
            [-4.540412954501696, -7.755452968364433],
            [-4.540307081187406, -7.7497892692680175],
            [-4.537827539045023, -7.743049809907166],
            [-4.5419641472160155, -7.7383612863646345],
            [-4.543663081332596, -7.732482386124053],
            [-4.542352969435698, -7.726093234545857],
            [-4.545265254330674, -7.721085665020505],
            [-4.547013827870552, -7.713413042976737],
            [-4.5523038163430165, -7.706752021660758],
            [-4.559154935708669, -7.70416667261139],
            [-4.563790063358262, -7.699235433563171],
            [-4.570647315587733, -7.697132535432055],
            [-4.5740879105985774, -7.691913458578594],
            [-4.570996821837188, -7.685278588714092],
            [-4.567451221492634, -7.681675669390798],
            [-4.564778800614887, -7.675169945844509],
            [-4.558370860868589, -7.671302084507963],
            [-4.561025799270439, -7.665671062267475],
            [-4.560741953034849, -7.662924981178974],
            [-4.565345059550219, -7.657114253121462],
            [-4.571939629964586, -7.655419200147494],
            [-4.577970349174201, -7.6525662088558315],
            [-4.581712718565916, -7.6544250717130335],
            [-4.595470306967879, -7.645798711453883],
            [-4.593699398355772, -7.640299854861683],
            [-4.59613122754535, -7.634543106700239],
            [-4.602188037953253, -7.630685338871074],
            [-4.60937676502175, -7.6299890159547985],
            [-4.607732917514004, -7.626448387413172],
            [-4.608361129956935, -7.622474033196055],
            [-4.621894353530385, -7.6237118434116296],
            [-4.628831562004444, -7.608305930953813],
            [-4.632819526303634, -7.60614299271536],
            [-4.633709884424064, -7.60354333577776],
            [-4.638764810226108, -7.598064007377324],
            [-4.643214952414859, -7.595611587435534],
            [-4.647003621690782, -7.5907744278353215],
            [-4.65487280172878, -7.58812347704419],
            [-4.659220825561854, -7.591781386253296],
            [-4.665200767746559, -7.591225291571303],
            [-4.6667383379088125, -7.59544251746064],
            [-4.670936032298071, -7.597080889104078],
            [-4.672939453436301, -7.59345138612638],
            [-4.679783868857721, -7.5881745138055985],
            [-4.68390513390217, -7.5826977447496535],
            [-4.683927858344889, -7.577612228800857],
            [-4.689038794368509, -7.578382279866002],
            [-4.69434153452005, -7.575401752410292],
            [-4.701719985890251, -7.574173787712571],
            [-4.703477555414111, -7.5716516031408245],
            [-4.708554443560234, -7.576761630815227],
            [-4.7097695869145175, -7.574980041233483],
            [-4.715866136701729, -7.579823805681088],
            [-4.723380606451221, -7.584093928010172],
            [-4.730700618944021, -7.585978593321316],
            [-4.732593603112668, -7.583201186063134],
            [-4.736303619844462, -7.58362492275058],
            [-4.738064215269648, -7.579573490920412],
            [-4.743289393424716, -7.576301729621576],
            [-4.748115973578097, -7.576792314752461],
            [-4.751444571420082, -7.579495403514873],
            [-4.757911307586935, -7.579179374282151],
            [-4.759564999852049, -7.575885425330718],
            [-4.764934916429831, -7.570996759247898],
            [-4.7690217231250545, -7.56909624525219],
            [-4.773237438458697, -7.573288170605766],
            [-4.779353865446923, -7.574669761369514],
            [-4.782437594903414, -7.572621679919484],
            [-4.789239183069498, -7.561702666866913],
            [-4.797981122398781, -7.561667610982661],
            [-4.799226775905973, -7.562892773986148],
            [-4.808146781289928, -7.560817394949423],
            [-4.810008166777599, -7.558662559528144],
            [-4.8098296950598, -7.553270163056077],
            [-4.813644675347252, -7.550789801181283],
            [-4.8175694887668294, -7.5520669389005075],
            [-4.817432745404922, -7.559859317526952],
            [-4.821642218290238, -7.563529284879405],
            [-4.825443624952433, -7.560058874204538],
            [-4.824226075998462, -7.556587182817511],
            [-4.829469419794511, -7.547212471677094],
            [-4.828674491523215, -7.544165717795997],
            [-4.831071901605743, -7.537442125122883],
            [-4.836835080589884, -7.532670590345108],
            [-4.8409045976744105, -7.533940284690009],
            [-4.846225800800164, -7.5310144874362175],
            [-4.851129950463177, -7.530341865434719],
            [-4.860789063220905, -7.5274198031064055],
            [-4.866050245967926, -7.522805164439423],
            [-4.870635084504325, -7.523686005015465],
            [-4.875652523300651, -7.522625730932318],
            [-4.880390790913551, -7.524497651398755],
            [-4.884685165933837, -7.528633839708945],
            [-4.8879198354221405, -7.526470606985899],
            [-4.895898861537657, -7.529214670845696],
            [-4.896817184800489, -7.527736192144338],
            [-4.9072997642102125, -7.524755478244856],
            [-4.914473145333808, -7.515894379756487],
            [-4.915716649671481, -7.509171262411812],
            [-4.920305914288515, -7.507614002322781],
            [-4.926825630602825, -7.507965487989017],
            [-4.927665035962694, -7.499499258338539],
            [-4.939058238543906, -7.492324884233204],
            [-4.945228910136052, -7.491409038243312],
            [-4.952766398956705, -7.485957062553888],
            [-4.9590778907971425, -7.483687970674098],
            [-4.964488849671971, -7.474863702383376],
            [-4.9668315034019495, -7.4760657353152284],
            [-4.970736800131042, -7.472291702881065],
            [-4.985820269080015, -7.469235564562918]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.41206041322907,
          "lat": 30.723088732376173
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48105"],
        "coty_name": ["Crockett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crockett County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01383838"
      },
      "bbox": [
        -4.985820269080015, -8.333941273051805, -3.770435968319846,
        -7.469235564562918
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0182660451205883, -10.605909682782798],
            [-1.8841491255845824, -10.609614310655159],
            [-1.7500308615557885, -10.613271590287434],
            [-1.676568289069526, -10.614956805353778],
            [-1.603105409746373, -10.616627820059458],
            [-1.5156159528075974, -10.618532865203248],
            [-1.5178459108978184, -10.723724468131161],
            [-1.519455138713706, -10.802874196257251],
            [-1.5212723628280702, -10.892270673030131],
            [-1.5217950734075834, -10.925978304710656],
            [-1.5225243413344687, -10.957658088872593],
            [-1.5223037510586759, -10.963934699452778],
            [-1.5237082568983922, -11.022402487266737],
            [-1.5266469567462486, -11.163173065978757],
            [-1.5289892699110414, -11.274238747074689],
            [-1.5315309754743223, -11.395743380885484],
            [-1.6614287370275422, -11.391282611343547],
            [-1.7913243241615708, -11.386773375715864],
            [-1.788376748487049, -11.310629821699472],
            [-1.8152824303799984, -11.309456946206668],
            [-1.8150235963902563, -11.29449793277774],
            [-1.847985599199456, -11.29401950880239],
            [-1.848487344294689, -11.3139698853132],
            [-1.8801393192603828, -11.313283177404802],
            [-1.8796867422076409, -11.294111125724763],
            [-1.9205689756363924, -11.293425243226205],
            [-1.9906972218071948, -11.29206394212065],
            [-1.991892955787902, -11.29426285606346],
            [-2.034457356286902, -11.293388535353378],
            [-2.0335274527501075, -11.257190541467446],
            [-2.0308674034282292, -11.146737841856316],
            [-2.0260663555345064, -10.906445512896411],
            [-2.0251116508274536, -10.864739656405696],
            [-2.019391675436894, -10.651261601274701],
            [-2.0182660451205883, -10.605909682782798]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.50886959364905,
          "lat": 27.681379589005342
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48131"],
        "coty_name": ["Duval"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Duval County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01383851"
      },
      "bbox": [
        -2.034457356286902, -11.395743380885484, -1.5156159528075974,
        -10.605909682782798
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.8007263360961336, -4.107611898698249],
            [-2.7912177722050284, -4.108357562509203],
            [-2.779476261526876, -4.106734568544172],
            [-2.774468573698195, -4.1032546175562965],
            [-2.7675969868724595, -4.096631142860541],
            [-2.764940054865681, -4.0912200321184775],
            [-2.7576760291055415, -4.090436362222133],
            [-2.744412225783318, -4.093560319873542],
            [-2.739505816790343, -4.09593855611624],
            [-2.7385340137122123, -4.100305290362388],
            [-2.733790757810522, -4.104805994502191],
            [-2.7204776423047075, -4.11558842996155],
            [-2.7180925118360055, -4.115961792481935],
            [-2.7111279029363287, -4.122770777739265],
            [-2.7012159292109876, -4.135202680849415],
            [-2.6971552795148783, -4.144907772362271],
            [-2.6848375107568025, -4.161530017992425],
            [-2.6781666691802415, -4.166635780352193],
            [-2.66883927141273, -4.173772648261939],
            [-2.662748679654727, -4.1765049203508235],
            [-2.6602416926718226, -4.176098428120494],
            [-2.6560383191992907, -4.18470112042395],
            [-2.6578797736231503, -4.1893987276197615],
            [-2.654618481269832, -4.198355683789884],
            [-2.6386598508065977, -4.2214401458267385],
            [-2.6320802189275736, -4.225574429539288],
            [-2.6302981342778926, -4.231360859827896],
            [-2.624382895630506, -4.231735405231426],
            [-2.616359611885866, -4.238830938784932],
            [-2.617975325749551, -4.245795368805967],
            [-2.6077246458796113, -4.255468678229771],
            [-2.59707446844739, -4.262452905076899],
            [-2.588578870270634, -4.266330184823565],
            [-2.5805229317995892, -4.271619799196146],
            [-2.577516963776495, -4.27523789778906],
            [-2.5749308055558155, -4.287296436064029],
            [-2.570197343827071, -4.292457077961357],
            [-2.5657520709641806, -4.293412517924074],
            [-2.5609350487699105, -4.3005100762028645],
            [-2.547224856119522, -4.299566008268502],
            [-2.5416557269166957, -4.30187811186177],
            [-2.5347169899066606, -4.30620290957006],
            [-2.5276429398983082, -4.303618904616943],
            [-2.5224670330597703, -4.297990228371158],
            [-2.518088872954956, -4.298919216963815],
            [-2.509309386440894, -4.303129043029552],
            [-2.503211908046801, -4.307511425731294],
            [-2.4892273812965673, -4.304671580673903],
            [-2.4833913868912516, -4.307145437734838],
            [-2.480268021043457, -4.304800088301978],
            [-2.4773343808025525, -4.299609933936938],
            [-2.47279527579567, -4.296300716816888],
            [-2.4700848085230374, -4.291033410740955],
            [-2.4704558698704826, -4.28406174726518],
            [-2.469417194352727, -4.274493451735639],
            [-2.4654611655457956, -4.265609019650465],
            [-2.4607436557302593, -4.264148507272624],
            [-2.450833108748326, -4.265487435120115],
            [-2.4404058857539437, -4.270507882674058],
            [-2.4245407415083804, -4.27236780513309],
            [-2.419494032799473, -4.271796187817521],
            [-2.414480159978531, -4.269679984237981],
            [-2.4092127071727694, -4.271673853671132],
            [-2.4058968770926548, -4.274999746707967],
            [-2.400145325058153, -4.275122742141635],
            [-2.3956049468396703, -4.280170920234045],
            [-2.392783774270361, -4.285365002965568],
            [-2.390224682165157, -4.287207897243495],
            [-2.38036713619649, -4.289536182775941],
            [-2.385082088897261, -4.412038326814179],
            [-2.3861321175587005, -4.436025967429125],
            [-2.3857337241190204, -4.436374321213127],
            [-2.388090733142411, -4.49320537849396],
            [-2.3919770838870766, -4.60119030087619],
            [-2.395402501648086, -4.611059804584111],
            [-2.3978385633176207, -4.614539815745117],
            [-2.40513702637104, -4.620976545416386],
            [-2.409036418828304, -4.616115936774444],
            [-2.4125479301466632, -4.61490663793187],
            [-2.41701171687127, -4.608892083018216],
            [-2.423947595403668, -4.611488087558952],
            [-2.4375979816267863, -4.610172552027286],
            [-2.4413684096052677, -4.611068036838564],
            [-2.4447605281205, -4.618170663880622],
            [-2.4448725345754885, -4.622356609791218],
            [-2.4486466747572737, -4.624564203762069],
            [-2.4515979950476527, -4.628368096455831],
            [-2.454695538735579, -4.628251768807543],
            [-2.4567985539833255, -4.623361206413546],
            [-2.4675633949208273, -4.623582296991834],
            [-2.4733346765436055, -4.619889598966802],
            [-2.4747819447736727, -4.614401842979076],
            [-2.4809227705307872, -4.604893108459614],
            [-2.4892332604131853, -4.600691379912807],
            [-2.4979134392552536, -4.599677096706484],
            [-2.5070686811893856, -4.599864065832282],
            [-2.5129507851203, -4.586497226691031],
            [-2.517723960395126, -4.589952347912933],
            [-2.524101353047365, -4.585054275534408],
            [-2.529679193151977, -4.582927343870011],
            [-2.537422602514125, -4.582329355412501],
            [-2.5435673687381923, -4.586605906624063],
            [-2.554835320013099, -4.592179337628981],
            [-2.558673686120887, -4.587241549295051],
            [-2.567350375339326, -4.585593353873843],
            [-2.5744920399431463, -4.586975153174488],
            [-2.578814977827305, -4.586347915186623],
            [-2.579004394095661, -4.581896505425263],
            [-2.584373159129507, -4.581941998764229],
            [-2.5893866410256625, -4.580435843432236],
            [-2.596201476336782, -4.581577117404549],
            [-2.603613964362701, -4.585250679318076],
            [-2.6059545054914386, -4.584308533901923],
            [-2.609038609185362, -4.579767551042512],
            [-2.6143780335614473, -4.577304053407451],
            [-2.623151914124543, -4.582275342220275],
            [-2.630048587620643, -4.584831871470431],
            [-2.6353919725890855, -4.584227508560851],
            [-2.667194389682264, -4.5596767984042605],
            [-2.815067992924365, -4.445118178363127],
            [-2.8127870067257237, -4.386298554667299],
            [-2.8114419928391268, -4.357291059602662],
            [-2.8081858437587446, -4.27796881220145],
            [-2.8051087955192733, -4.2050785412063485],
            [-2.8007263360961336, -4.107611898698249]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.74568865543534,
          "lat": 34.290244817779914
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48197"],
        "coty_name": ["Hardeman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardeman County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "01383884"
      },
      "bbox": [
        -2.815067992924365, -4.628368096455831, -2.38036713619649,
        -4.090436362222133
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.550420574879706, -6.082618038011164],
            [1.5492200956992463, -6.018060075028275],
            [1.5481925204766365, -5.941700876441756],
            [1.6347664171414455, -5.992808915672704],
            [1.6673114374510978, -6.011923831813065],
            [1.6706491208179608, -6.014130632659019],
            [1.71253272603283, -6.038707952123784],
            [1.8100117184060514, -6.036486666486459],
            [1.8158248651547595, -6.037426033957783],
            [1.8239446370481336, -6.032400062427284],
            [1.8258376763742057, -6.027856691118619],
            [1.8302659090632813, -6.029776071841287],
            [1.8383879116113262, -6.024589364482112],
            [1.8410440042850194, -6.025198967649833],
            [1.8455274807715836, -6.021265659780837],
            [1.8472085549573298, -6.017268540772226],
            [1.852748707533452, -6.013576554600699],
            [1.8588477251736626, -6.0151792347333854],
            [1.8614519241289955, -6.013855054148775],
            [1.8620878196062824, -6.007053223191541],
            [1.864757764257466, -6.007851930553708],
            [1.8681151920629289, -6.00511049754152],
            [1.871093216773131, -5.999958180384797],
            [1.882483807234004, -6.004646574189361],
            [1.8921518290110035, -6.002071962929549],
            [1.8968137083248835, -5.999237884453564],
            [1.8951914281884774, -5.99357655688626],
            [1.8991988062900325, -5.982553797898021],
            [1.9012250943762574, -5.979664508588446],
            [1.9052160840978714, -5.978693000805158],
            [1.9116049714726047, -5.98323449665655],
            [1.919707432783429, -5.979612970493377],
            [1.9221615276222077, -5.97720363651556],
            [1.9279268088309318, -5.979496762214015],
            [1.932745337722883, -5.977940322611479],
            [1.935444010771861, -5.982535713180097],
            [1.9393469765753966, -5.9845640805218006],
            [1.9416165154199665, -5.989166097263315],
            [1.9412421468181125, -5.996339463951644],
            [1.9452451100596153, -5.9998655160153],
            [1.9458540927548176, -6.003972656451807],
            [1.941694159890504, -6.0151919948537005],
            [1.9489964359484093, -6.019050792750803],
            [1.9505054871072853, -6.024999880407347],
            [1.9577164952107784, -6.026614335016859],
            [1.9645378860236962, -6.024525542684572],
            [1.976012989910721, -6.029941169191326],
            [1.9893369615430179, -6.032948647529214],
            [1.9928618876970816, -6.030674193886321],
            [1.993985024465367, -6.024934752039534],
            [1.997035487586557, -6.017161138995484],
            [1.9995542017924308, -6.0145153350559895],
            [2.0011712887787536, -6.005953336359762],
            [2.0067240170648635, -6.001409662660395],
            [2.0102531498818403, -6.001499535210187],
            [2.0116867771907283, -5.996797906981746],
            [2.015479953304535, -5.994157723598132],
            [2.0137277841978283, -5.988362001390877],
            [2.01599896095878, -5.985622141768035],
            [2.025968560567557, -5.988457801962069],
            [2.03332717078479, -5.987346939824569],
            [2.036000633317735, -5.989140580759151],
            [2.042366642316525, -5.988540738319956],
            [2.045587488468924, -5.9924726285426155],
            [2.0498583033970506, -5.988358336116635],
            [2.053630179093146, -5.993095496262387],
            [2.058732854497512, -5.993832335573552],
            [2.056747399570652, -5.997119009897368],
            [2.0512389149553516, -6.000548710450778],
            [2.0598965024828595, -6.001131711508137],
            [2.06292279488975, -6.0048885432100745],
            [2.059491583126962, -6.00734356919443],
            [2.056431064312138, -6.014131562857183],
            [2.0495260856380177, -6.014822181432951],
            [2.0488195756977543, -6.012340762075124],
            [2.0402202377326377, -6.012635922150554],
            [2.037972384522484, -6.018017253876051],
            [2.0429173453738065, -6.022892446569627],
            [2.04671325639079, -6.0236748290040385],
            [2.0535611443477535, -6.020813431601846],
            [2.057709933785194, -6.0264809316779555],
            [2.0592385127267994, -6.034309538031023],
            [2.061160061492433, -6.037010549699352],
            [2.0674561066990695, -6.036118119021063],
            [2.074329544886105, -6.038886406052412],
            [2.080768060417778, -6.036610367645199],
            [2.0903017512121314, -6.03502726332078],
            [2.1008346045909247, -6.032408022657316],
            [2.1021681465082636, -6.081966671290902],
            [2.1035546051056366, -6.161161408248145],
            [2.1051582929457764, -6.238825852925727],
            [2.105649182479005, -6.2549876595892995],
            [2.1072678456825904, -6.333029731733072],
            [1.9855620347355762, -6.364924618227075],
            [1.937809436224525, -6.377384409560723],
            [1.9114038457239595, -6.384115148873123],
            [1.852524412628763, -6.399399660289474],
            [1.8471986275409533, -6.401204175748265],
            [1.844411005221153, -6.39544859632679],
            [1.8412104886775784, -6.393339160609952],
            [1.8404498191577163, -6.3897548929240395],
            [1.8365811125666822, -6.3881603090571435],
            [1.8361568322691646, -6.3850108714679354],
            [1.8311369324889144, -6.3855071519289055],
            [1.8321719613637335, -6.38865120582618],
            [1.8260474092507417, -6.3881687021709475],
            [1.82199509681501, -6.383287927019714],
            [1.8252325624144679, -6.382559623538345],
            [1.8226112371363652, -6.375735873380522],
            [1.8217015495445408, -6.36706918490671],
            [1.8197351269982225, -6.36346780779568],
            [1.8114951752188257, -6.362336311186258],
            [1.8101331466880461, -6.364313867297064],
            [1.80441969494074, -6.361087604725003],
            [1.8001722581860722, -6.363615772049935],
            [1.7893272616313667, -6.361634889177746],
            [1.7842838248861779, -6.364274269937648],
            [1.7832362880341004, -6.36863256194326],
            [1.77689660379617, -6.369857672620656],
            [1.7688181579672175, -6.364542008451123],
            [1.7669619862712578, -6.3593675793101125],
            [1.760726178707484, -6.362391586541279],
            [1.7549695311595255, -6.359521280046122],
            [1.7538669969173006, -6.3549079878656025],
            [1.7427308545004963, -6.353052384413664],
            [1.7440520180103412, -6.347568742522196],
            [1.7419680419000185, -6.346586560436977],
            [1.7403680996386726, -6.341385158838751],
            [1.737113835018257, -6.342468212690321],
            [1.7302842063626938, -6.338007919345458],
            [1.7219313289158948, -6.334363417657554],
            [1.7174006440504193, -6.337794337067341],
            [1.7173586790427569, -6.340400456163159],
            [1.7092324536011694, -6.3449082603967115],
            [1.6999790828431018, -6.336442387447986],
            [1.701458502986034, -6.330276113521297],
            [1.6958275035993176, -6.329361282264285],
            [1.6892510835114254, -6.33339669711748],
            [1.6843172721650346, -6.329763959512057],
            [1.6804045229085605, -6.329214688393515],
            [1.6807730427947476, -6.326084840687063],
            [1.6764154775901008, -6.325484144463981],
            [1.668724011398719, -6.333831298996563],
            [1.6568803445864795, -6.338353600191878],
            [1.6490112417301934, -6.3420029998799725],
            [1.6469279788390883, -6.341200229698221],
            [1.6422340618163336, -6.3351249329739945],
            [1.6394941963714051, -6.333692961868136],
            [1.6324543424349458, -6.3357845662890675],
            [1.6248501657974632, -6.336184711330075],
            [1.621875127277, -6.33524925637186],
            [1.6046997152041935, -6.335925886282089],
            [1.5943228437042587, -6.331478378996135],
            [1.5883363022491, -6.323811878476131],
            [1.582598824660821, -6.325267271036719],
            [1.5770786046971776, -6.320917477826092],
            [1.5753030483856574, -6.315733899057225],
            [1.5786593708915508, -6.31258898286224],
            [1.5681969216135643, -6.307395360515842],
            [1.5631005337484565, -6.308824636349143],
            [1.5609331692663047, -6.307214124779512],
            [1.553421160294493, -6.312973542078996],
            [1.5528252349931733, -6.2823701113967],
            [1.5528032851649396, -6.267090433063828],
            [1.5518762598302525, -6.196383522087727],
            [1.550420574879706, -6.082618038011164]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.3714780968238, "lat": 32.548151935218705 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48203"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "203",
        "coty_gnis_code": "01383887"
      },
      "bbox": [
        1.5481925204766365, -6.401204175748265, 2.1072678456825904,
        -5.941700876441756
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.9907388804712425, -5.707081883222401],
            [-2.969655053653735, -5.708138752840326],
            [-2.8873437004885067, -5.711229854805546],
            [-2.8612769283755357, -5.712453601824613],
            [-2.8152755798625324, -5.714766277884723],
            [-2.752601911063054, -5.718087608636383],
            [-2.691933864576774, -5.721176720420082],
            [-2.6325202952748588, -5.72400132156112],
            [-2.547441220553924, -5.72811228383143],
            [-2.550413182628538, -5.801051194632075],
            [-2.5551935200862, -5.9349969442011],
            [-2.5565275017009106, -5.964289088832738],
            [-2.559774263834416, -6.0512483540006],
            [-2.5643673042953545, -6.170330999595773],
            [-2.579075441503858, -6.169770649467121],
            [-2.578893199435462, -6.163718338509862],
            [-2.6522310925836217, -6.161044911242851],
            [-2.684061888067208, -6.159544073970035],
            [-2.778763160271794, -6.155689953421519],
            [-2.889468742582814, -6.150320564408071],
            [-2.8917544669009114, -6.150392945040474],
            [-2.94478409593012, -6.147252666945305],
            [-2.989027029012234, -6.144796766038256],
            [-2.9941991717371637, -6.1450629690555765],
            [-3.0118515335998506, -6.144017498981479],
            [-3.0060939545491645, -6.026120840662301],
            [-3.003287606960954, -5.9597736946546345],
            [-3.002377770931816, -5.951518325832277],
            [-3.002141211530528, -5.939392833370999],
            [-3.000107418356557, -5.901643683477306],
            [-2.9947026413674, -5.785222266020763],
            [-2.9907388804712425, -5.707081883222401]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.87874143719178,
          "lat": 32.739889995060715
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48253"],
        "coty_name": ["Jones"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jones County"],
        "coty_fp_code": "253",
        "coty_gnis_code": "01383912"
      },
      "bbox": [
        -3.0118515335998506, -6.170330999595773, -2.547441220553924,
        -5.707081883222401
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5292015748158568, -9.09102789246443],
            [-0.5113387499757667, -9.090955542891084],
            [-0.42352981381529675, -9.090188732122531],
            [-0.4009850771690941, -9.089508201132917],
            [-0.3230198593801739, -9.089174606004821],
            [-0.29591249938804504, -9.0889234218461],
            [-0.287895817134103, -9.088995852211742],
            [-0.28841436005104043, -9.091512959837301],
            [-0.2828049966266842, -9.094949229041484],
            [-0.2828861960108176, -9.097268699991556],
            [-0.27582330825817836, -9.10015929895359],
            [-0.27270057319568924, -9.104585102778703],
            [-0.2688096436251955, -9.105585227881289],
            [-0.2701054569259979, -9.112528072662624],
            [-0.2646333477268952, -9.117759034205198],
            [-0.2643469553954029, -9.121221160418601],
            [-0.26069799785517356, -9.125585434350645],
            [-0.2628475199718185, -9.128657930751594],
            [-0.26552402512875944, -9.138240559282785],
            [-0.2604197757009006, -9.144390660457596],
            [-0.22591311831205657, -9.144173515200857],
            [-0.15158116396013263, -9.233421153232154],
            [-0.13493799801168269, -9.254337537858344],
            [-0.0800320268204128, -9.319358188740411],
            [-0.025109723399635367, -9.384350576952341],
            [-0.11099042051810952, -9.454375156045487],
            [-0.12850391741045772, -9.468543041607086],
            [-0.1837572042127533, -9.512000125117082],
            [-0.23902155494001656, -9.555440280147149],
            [-0.2772245384952238, -9.585337946410773],
            [-0.35746212735395333, -9.65003994280877],
            [-0.39010688298610935, -9.609524455140456],
            [-0.4072701792317256, -9.58845581235252],
            [-0.4566568880097308, -9.526332686541613],
            [-0.5060291299171862, -9.46418388916879],
            [-0.5849588942760926, -9.369217436426819],
            [-0.6170713140268885, -9.330434409692227],
            [-0.6071017193405175, -9.296270940791972],
            [-0.5825924446223372, -9.209444088965753],
            [-0.5831660988385106, -9.158303922114769],
            [-0.583194551182252, -9.13727249849006],
            [-0.5342537232767525, -9.094882331236347],
            [-0.5292015748158568, -9.09102789246443]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.93019814490947,
          "lat": 29.384317001834603
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48285"],
        "coty_name": ["Lavaca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lavaca County"],
        "coty_fp_code": "285",
        "coty_gnis_code": "01383928"
      },
      "bbox": [
        -0.6170713140268885, -9.65003994280877, -0.025109723399635367,
        -9.0889234218461
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5156690478205754, -7.74241655210399],
            [-2.4221555862733433, -7.745683489780885],
            [-2.4209932862900625, -7.745390271266244],
            [-2.368459637932831, -7.7473533508816095],
            [-2.315300505409397, -7.748876333442824],
            [-2.3132516002761196, -7.7490869655149295],
            [-2.2353656216060096, -7.751656419917996],
            [-2.2084818002376667, -7.752743917355207],
            [-2.1802538782796748, -7.7535258859644305],
            [-2.1809723337466194, -7.772427660398661],
            [-2.1305775295259792, -7.77421631892272],
            [-2.0717138075745454, -7.776474824378961],
            [-2.077961690832934, -7.991055649090613],
            [-2.084435170011586, -8.193878378741676],
            [-2.0846089194088715, -8.196115723870804],
            [-2.111698018323811, -8.195365076714005],
            [-2.115642370366823, -8.195554478959057],
            [-2.1829493556279824, -8.193009430463842],
            [-2.2701236165959147, -8.18968083675892],
            [-2.3572972401263765, -8.186337979918179],
            [-2.3765452475895747, -8.185243945765917],
            [-2.531649066795682, -8.179948431367917],
            [-2.531046463440889, -8.162826943180926],
            [-2.5266563529711235, -8.05548649772954],
            [-2.5233576968323215, -7.970589816007843],
            [-2.5196430214372554, -7.858756158812054],
            [-2.5156690478205754, -7.74241655210399]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.22613999292977,
          "lat": 30.717711832902268
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48319"],
        "coty_name": ["Mason"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mason County"],
        "coty_fp_code": "319",
        "coty_gnis_code": "01383942"
      },
      "bbox": [
        -2.531649066795682, -8.196115723870804, -2.0717138075745454,
        -7.74241655210399
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5783454693804667, -5.762330599491022],
            [0.6162326584720887, -5.762257048188194],
            [0.6719442220093822, -5.761484093508308],
            [0.7036677131614802, -5.762079658856559],
            [0.7407286338706568, -5.761948358978715],
            [0.7427461992812746, -5.781083908661577],
            [0.7518464354981985, -5.8639500513777385],
            [0.7618967783981222, -5.955862271164714],
            [0.7661125504602707, -5.995992616958628],
            [0.768998395529702, -6.0212262841873905],
            [0.7672523423262005, -6.016945273651339],
            [0.7642139890294946, -6.023111116037149],
            [0.7580445987726464, -6.0223907904709435],
            [0.7543236990239645, -6.027897417830829],
            [0.750355034608774, -6.0277346822941205],
            [0.7489366769933747, -6.030120597984683],
            [0.7447047176236634, -6.026038122454906],
            [0.741076488975146, -6.027038149666241],
            [0.7368913919833255, -6.02328117984312],
            [0.7384726721642986, -6.021018912331487],
            [0.7340691939598947, -6.018570981981489],
            [0.7308526827956286, -6.013389740984573],
            [0.7242800085422386, -6.013296391068905],
            [0.7219698507899512, -6.004489198061026],
            [0.7148613434857911, -6.003683492859432],
            [0.7117072108239695, -5.999934683095135],
            [0.6974751997913196, -5.995960758570663],
            [0.6950338596948593, -5.993698810607884],
            [0.6892436441243479, -5.993559289382817],
            [0.6866894587189369, -5.989120346081984],
            [0.6812614805693662, -5.986813180947942],
            [0.6767844141031718, -5.986399036394077],
            [0.6692936760315994, -5.9840684991212285],
            [0.6675011786019533, -5.985946018097035],
            [0.6626722048055435, -5.986495452153282],
            [0.6607399660230651, -5.982371189578382],
            [0.6631094702408004, -5.979221712579749],
            [0.6615699531910968, -5.975981856910763],
            [0.6620064105959421, -5.971368322399126],
            [0.6597696534429597, -5.970334281065994],
            [0.6508946495938946, -5.970951892453903],
            [0.6492964958858303, -5.96844225321123],
            [0.6450657694845298, -5.970314985755666],
            [0.6355885972832737, -5.96619966938429],
            [0.6333448455725489, -5.969463257785661],
            [0.6295468808429879, -5.967860350961102],
            [0.6243248911422135, -5.974066363530473],
            [0.6178667080148537, -5.976482348604904],
            [0.6059180863250766, -5.972991658862263],
            [0.6015584639635504, -5.970218806914453],
            [0.5945075111981464, -5.97276802504879],
            [0.5868761739972596, -5.9700606928564905],
            [0.5826020904526211, -5.9635925926408735],
            [0.5774467260283225, -5.965020894952874],
            [0.5761615706593597, -5.961087493565278],
            [0.5688772270610928, -5.954680687555103],
            [0.5647007756108825, -5.952843982358682],
            [0.5564348321406056, -5.947297637640743],
            [0.5513678786636558, -5.938252660101576],
            [0.5483912893691344, -5.940030009672974],
            [0.5416566123320424, -5.935248772392463],
            [0.5430749003328192, -5.9324485326252905],
            [0.5373665536397879, -5.930744863860269],
            [0.5284599049342174, -5.9261514727430145],
            [0.5265368804984437, -5.91979860283314],
            [0.524262051407296, -5.91935004306008],
            [0.5258455913645261, -5.9127821272768895],
            [0.5184969297520987, -5.904887671159224],
            [0.5180722046669795, -5.901763597799667],
            [0.511272255547397, -5.900766173772126],
            [0.5104407383363293, -5.896915696155717],
            [0.4989017182618463, -5.8960649488973305],
            [0.49840377078431564, -5.891654696684438],
            [0.49187952017712405, -5.887950299903573],
            [0.4749256992363869, -5.869029658904057],
            [0.47536452510615773, -5.861651118344807],
            [0.47809615348818524, -5.860277448607511],
            [0.47798532492946344, -5.856655208972159],
            [0.48199046998568096, -5.855843657617394],
            [0.48262380024898943, -5.848290559590429],
            [0.48500347270533695, -5.8467825515493415],
            [0.48665884210549415, -5.8399836488200405],
            [0.5093389771203064, -5.762093643950333],
            [0.5485999689696414, -5.7621425817246035],
            [0.5705813829679067, -5.76253062271018],
            [0.5783454693804667, -5.762330599491022]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.79344519849207, "lat": 32.87033608600131 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48379"],
        "coty_name": ["Rains"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rains County"],
        "coty_fp_code": "379",
        "coty_gnis_code": "01383975"
      },
      "bbox": [
        0.4749256992363869, -6.030120597984683, 0.768998395529702,
        -5.761484093508308
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.6717687709310634, -12.22519245446087],
              [-0.6666069739188337, -12.22422726428781],
              [-0.6648561676611403, -12.22961634294141],
              [-0.6661108920682248, -12.235173098001617],
              [-0.6690064700338274, -12.23513578066547],
              [-0.6717687709310634, -12.22519245446087]
            ]
          ],
          [
            [
              [-0.713470797617837, -12.054993718329468],
              [-0.6983366878683763, -12.05512663657497],
              [-0.6937393636186202, -12.069947508967049],
              [-0.6875016219530152, -12.086256214584038],
              [-0.6885622520002759, -12.089920058961123],
              [-0.7026887642883388, -12.089337035818527],
              [-0.7151684635500445, -12.089637788216283],
              [-0.7165359596075859, -12.084100189693132],
              [-0.7016946582913767, -12.084022313358933],
              [-0.6957011635494699, -12.078625211518904],
              [-0.6961667072579666, -12.071577332485278],
              [-0.710112778368179, -12.06181751972029],
              [-0.713470797617837, -12.054993718329468]
            ]
          ],
          [
            [
              [-0.642027381058989, -12.239377335601768],
              [-0.6560397861504875, -12.239213953588047],
              [-0.6535086300580031, -12.23208398050442],
              [-0.6587930243289799, -12.225462164723163],
              [-0.6581118894572495, -12.21901510714803],
              [-0.661537659592339, -12.210508591869448],
              [-0.6587871319536515, -12.203455033438432],
              [-0.6618329584577385, -12.187608790096665],
              [-0.6665674121804427, -12.172181353412261],
              [-0.6709242581305342, -12.164701692919671],
              [-0.6690318411274259, -12.155561852522059],
              [-0.6730783494928547, -12.15194488341986],
              [-0.6746737222490481, -12.14603474973391],
              [-0.6811952653610376, -12.145084326555587],
              [-0.6831101197550569, -12.141089831342862],
              [-0.6862602406700422, -12.12856408681593],
              [-0.6923230898875702, -12.117546673396657],
              [-0.6953422547137652, -12.106799320352858],
              [-0.7111386209885117, -12.10032980128241],
              [-0.7152112474229093, -12.096389824042706],
              [-0.7284240562111166, -12.096635137402545],
              [-0.7310924473891337, -12.093073518197176],
              [-0.6866185441282082, -12.092821582790663],
              [-0.6824173257347779, -12.094560674651996],
              [-0.6775454128226416, -12.113631438097112],
              [-0.6598216304608913, -12.17427031114581],
              [-0.6467206688425212, -12.221428306996184],
              [-0.642027381058989, -12.239377335601768]
            ]
          ],
          [
            [
              [-1.299048201199046, -12.034000915371708],
              [-1.213127066637138, -12.0490644337426],
              [-1.12548113458592, -12.050624943799297],
              [-1.0001773931521551, -12.051686003792723],
              [-0.9978824145241206, -12.051405892971767],
              [-0.8875645278302341, -12.051793042805652],
              [-0.8642029337259057, -12.053293339338602],
              [-0.8338703645998468, -12.053651153772654],
              [-0.8276533059571934, -12.063707025352267],
              [-0.8270493892707199, -12.070995001157],
              [-0.823044484346753, -12.080451748865672],
              [-0.8237789042949517, -12.083263769765669],
              [-0.8194898644431662, -12.096945951466653],
              [-0.8148898452140252, -12.097322845474148],
              [-0.8118206943581034, -12.099740703752175],
              [-0.8139831993170715, -12.103413881824606],
              [-0.8171091924180399, -12.116379076660342],
              [-0.8139262016525286, -12.132419190139316],
              [-0.8069477763920845, -12.145727841357786],
              [-0.8048920414778641, -12.151536545063806],
              [-0.8057595030318836, -12.159263480853985],
              [-0.8108418404426854, -12.169199950859436],
              [-0.8042325242000006, -12.171668699699955],
              [-0.7814832419299325, -12.170240704428922],
              [-0.7591482678050581, -12.226592209049743],
              [-0.7537741133223768, -12.238055511563388],
              [-0.7818237041114524, -12.237857632083617],
              [-0.7878690878928042, -12.238161459763512],
              [-0.7953054361910592, -12.24355118391505],
              [-0.795028072579826, -12.246125673805723],
              [-0.7988481765558673, -12.251871040614406],
              [-0.8013904823159712, -12.262192251908026],
              [-0.8072718905956038, -12.268119239489195],
              [-0.8118153363634044, -12.27415132497404],
              [-0.8167110353319672, -12.276825546878632],
              [-0.8199282534642734, -12.280648510575949],
              [-0.8265739438597592, -12.281710552593966],
              [-0.8299175397661065, -12.286422996930755],
              [-0.8298618407868508, -12.29030899876279],
              [-0.833090222334596, -12.300508959056593],
              [-0.834795179001507, -12.308448116587538],
              [-0.8392699277901644, -12.313456663169198],
              [-0.843753621907794, -12.320222729106192],
              [-0.8485268508541529, -12.320607097139362],
              [-0.8515481776066196, -12.319288474610772],
              [-0.854535165133467, -12.313432552304725],
              [-0.859511313635432, -12.313352926888703],
              [-0.8612074674522724, -12.311233895160818],
              [-0.8593956153234771, -12.305444850580672],
              [-0.8623523322721802, -12.302541941555411],
              [-0.8665066412750212, -12.302755392757183],
              [-0.8685819184192314, -12.30553092299167],
              [-0.8646421265783582, -12.308374218188474],
              [-0.8625503753450778, -12.312954330670106],
              [-0.8642403267721919, -12.31512984652025],
              [-0.8728185347115074, -12.309198152472453],
              [-0.878337499851611, -12.307930615285878],
              [-0.8848190144761908, -12.30820358031545],
              [-0.8949253500473285, -12.31189960695927],
              [-0.896703837073706, -12.315136358884414],
              [-0.8956984989739546, -12.319516105128418],
              [-0.8928983467456584, -12.322233253225978],
              [-0.8924920830025164, -12.325391135672161],
              [-0.896975287854222, -12.33076046181453],
              [-0.9045975566988752, -12.330091711843048],
              [-0.9036691708329363, -12.327256033717173],
              [-0.8988859420176982, -12.32702406769953],
              [-0.8985540360295533, -12.322169042921368],
              [-0.9035537726770075, -12.317125438742305],
              [-0.9108883521899352, -12.318335895932654],
              [-0.9133678075675511, -12.3205135593374],
              [-0.9162607073591479, -12.327214329262011],
              [-0.9154431337116293, -12.340656488387957],
              [-0.9169817138991524, -12.34395314485025],
              [-0.9929454364104909, -12.330972229806777],
              [-1.0689034565703857, -12.317972089171157],
              [-1.15925782352849, -12.302029198861426],
              [-1.2181517737285437, -12.291358942273712],
              [-1.2173728633424334, -12.254898800544689],
              [-1.2168093601217178, -12.208552839573045],
              [-1.2583643207418884, -12.20807300628127],
              [-1.258351907264715, -12.206458276903346],
              [-1.344585220362045, -12.191263260473471],
              [-1.3367624239553875, -12.149582979137076],
              [-1.3329616948283471, -12.150245104920224],
              [-1.3248841089707075, -12.106476626741284],
              [-1.3065125970354885, -12.109837325094126],
              [-1.3105869482063606, -12.092423835246965],
              [-1.3095474714373372, -12.075394323808194],
              [-1.3062500477054677, -12.075624138853424],
              [-1.299048201199046, -12.034000915371708]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.66318468985173,
          "lat": 26.469278138577934
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48489"],
        "coty_name": ["Willacy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Willacy County"],
        "coty_fp_code": "489",
        "coty_gnis_code": "01384030"
      },
      "bbox": [
        -1.344585220362045, -12.34395314485025, -0.642027381058989,
        -12.034000915371708
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.256437537458266, 1.2793142213195785],
            [-11.242601254364518, 1.364502371124493],
            [-11.242905425544064, 1.3645517481922047],
            [-11.227690027547645, 1.4576265938430952],
            [-11.21427803634262, 1.5405962488331852],
            [-11.215018762470716, 1.5406929740422064],
            [-11.199889917094543, 1.6349992808959626],
            [-11.187226581182145, 1.7127590462320992],
            [-11.147104456830736, 1.7062190336356702],
            [-11.133535119284547, 1.7900394478445967],
            [-11.133030278179474, 1.7899506419650488],
            [-11.119504404359231, 1.877388278017361],
            [-11.11824688365959, 1.8842148676701957],
            [-11.10864513664793, 1.9423925792486099],
            [-11.101270929490958, 1.9399414550257652],
            [-11.099935090199162, 1.9364954831912817],
            [-11.09633786882958, 1.9354381212883875],
            [-11.096914279223078, 1.9304556820371277],
            [-11.091084802710016, 1.9256680412558678],
            [-11.093891404707453, 1.9103293852903576],
            [-11.091651958195289, 1.9047757824402773],
            [-11.086922331682858, 1.9003216154937346],
            [-11.086236555692496, 1.8945079945579288],
            [-11.081514663360029, 1.8897265177183709],
            [-11.083880054058318, 1.878283960153839],
            [-11.077563504634929, 1.8729453702118215],
            [-11.076994516441903, 1.866085922758848],
            [-11.078442103431309, 1.861485745057802],
            [-11.075500347315051, 1.8560179695385979],
            [-11.076207745254354, 1.8504227395630715],
            [-11.074292992856419, 1.8473880123923845],
            [-11.069388666833468, 1.8440468201290199],
            [-11.066927745204602, 1.8324685569571093],
            [-11.063994326345826, 1.8306498154049708],
            [-11.063128884814939, 1.8271221333086187],
            [-11.059545102121778, 1.823678502151688],
            [-11.055708685655162, 1.8241050841699817],
            [-11.053643484420853, 1.8269265643235737],
            [-11.050646168922887, 1.8266707659718402],
            [-11.050094151724165, 1.8326844175994663],
            [-11.04339248094613, 1.83406441268075],
            [-11.040354127284587, 1.8402857035958258],
            [-11.036427340007084, 1.8382851552016284],
            [-11.03685068332385, 1.8313242029339116],
            [-11.0349855747427, 1.8149888655910023],
            [-11.034899531422226, 1.8029167434247528],
            [-11.032988199890584, 1.800785260698225],
            [-11.033374576217382, 1.7945140465667577],
            [-11.029547578601735, 1.7910976694999565],
            [-11.033243478385435, 1.7886615347703614],
            [-11.034432408091005, 1.7857213222263248],
            [-11.032221375848346, 1.7787096754653777],
            [-11.03434670853137, 1.7746054601751007],
            [-11.02950904665857, 1.7709995956976359],
            [-11.029844177269847, 1.759764186992291],
            [-11.024071316725749, 1.7574661216498024],
            [-11.021769370898504, 1.751309965411399],
            [-11.019009168905976, 1.7486293288547023],
            [-11.015904626559157, 1.7409604414080126],
            [-11.01756114151478, 1.733666105775057],
            [-11.017639163717694, 1.7270357361685917],
            [-11.016241777974933, 1.7243056584801535],
            [-11.016219758300297, 1.714337304250163],
            [-11.01261970910513, 1.7090601969431454],
            [-11.012733163778028, 1.705235254073518],
            [-11.015878467150108, 1.7022731380510487],
            [-11.015769423031664, 1.6964567773998929],
            [-11.019683930174915, 1.69409083475576],
            [-11.018187983792817, 1.688085291736258],
            [-10.851444205928757, 1.6613882357257577],
            [-10.776948068404318, 1.649470459089993],
            [-10.68525951199244, 1.6354133922747214],
            [-10.660297302418956, 1.6317436398662013],
            [-10.457088159255166, 1.6006579636353657],
            [-10.253885570516246, 1.5695290112528526],
            [-10.221991131703112, 1.564794200311516],
            [-10.223312359993843, 1.5622625849229161],
            [-10.221686240004791, 1.5550970871539607],
            [-10.217785848001327, 1.550883947723095],
            [-10.221990154942986, 1.546961453003527],
            [-10.225222286054072, 1.5409461093220953],
            [-10.226353857031524, 1.5349532981607155],
            [-10.224763330590513, 1.5323695350406028],
            [-10.225743884824766, 1.5232028381795868],
            [-10.22850361960673, 1.5187413491513095],
            [-10.222748930307466, 1.5154544189302037],
            [-10.219913550789814, 1.511110801141288],
            [-10.220225360428344, 1.5041309770466056],
            [-10.22796150379565, 1.4950509682535293],
            [-10.228103851646258, 1.4925154278179669],
            [-10.231483295604951, 1.4852228277019746],
            [-10.22927707797545, 1.4799755587944636],
            [-10.231499558081584, 1.4740005595227341],
            [-10.2370308247419, 1.4725879687201244],
            [-10.237068342258802, 1.4658067845200622],
            [-10.2337682458679, 1.4578349638484287],
            [-10.238360124858762, 1.4539004185820896],
            [-10.236966815033307, 1.450303056646774],
            [-10.238650878992882, 1.4471373795155158],
            [-10.245472496619742, 1.447684954973885],
            [-10.248176847031221, 1.4445252106630508],
            [-10.251241797682962, 1.4350197927633417],
            [-10.259139667574336, 1.4291556090803739],
            [-10.261136230421961, 1.4248469817799696],
            [-10.265083443130267, 1.4255794916640223],
            [-10.26816064981689, 1.4301324091243544],
            [-10.270114306028594, 1.425559410117918],
            [-10.268371784164056, 1.4180849359693006],
            [-10.274284190512455, 1.411875166133282],
            [-10.273341339496751, 1.4073256685579085],
            [-10.268770972693392, 1.4072265473156758],
            [-10.265737049018526, 1.4034770303312807],
            [-10.265924859244198, 1.4000673991528314],
            [-10.268871041801525, 1.3982173433397838],
            [-10.280723308630382, 1.394647457758654],
            [-10.286174594840519, 1.389758164520908],
            [-10.286990825647905, 1.3840227198430746],
            [-10.289403951780551, 1.3831142228501319],
            [-10.291188660368787, 1.3787813838784262],
            [-10.289598023541899, 1.3730338445769317],
            [-10.280637287959848, 1.3660582764803788],
            [-10.28113627047506, 1.3570621708837254],
            [-10.28446850571222, 1.349821839195113],
            [-10.281927651527234, 1.3434023555129342],
            [-10.282449504876558, 1.3393963491655514],
            [-10.280245934606766, 1.3326394495584235],
            [-10.280722089234091, 1.3280225119703852],
            [-10.286656779095344, 1.3237910703625178],
            [-10.290241415534183, 1.324511990855687],
            [-10.291908819941606, 1.3289321446179074],
            [-10.294798936608242, 1.3303651425158836],
            [-10.29934354417316, 1.32684578899567],
            [-10.300079178067675, 1.3198948765471634],
            [-10.297672018556108, 1.3082790007093619],
            [-10.299413620596827, 1.3024107332792438],
            [-10.30573863417921, 1.295371917871886],
            [-10.313044765039306, 1.2969675297018282],
            [-10.319664331110962, 1.294291456957216],
            [-10.324062980008375, 1.2900205285355812],
            [-10.326916415135171, 1.2847115342401094],
            [-10.323465383349822, 1.272850384611279],
            [-10.329405544659187, 1.2674024545131637],
            [-10.33581098814945, 1.2655617592927144],
            [-10.339109392172228, 1.2596601466359263],
            [-10.336669744287297, 1.2562773758953785],
            [-10.337256339696344, 1.253161486109226],
            [-10.33442916041402, 1.2497810876221038],
            [-10.33050960765529, 1.2481409455393002],
            [-10.328858139850144, 1.2411634805710925],
            [-10.331437790954148, 1.2387015403885837],
            [-10.338861138020176, 1.2364025020816585],
            [-10.342727293203886, 1.2285505410139077],
            [-10.341775487606244, 1.2223243315609598],
            [-10.339843711951245, 1.2206106896996647],
            [-10.348151959315079, 1.2080994860172438],
            [-10.348326516993708, 1.2038124169028697],
            [-10.35159653196427, 1.200530444803204],
            [-10.357955899967346, 1.198401022637282],
            [-10.36714378633802, 1.1977655586264095],
            [-10.369414027090102, 1.1945905797532597],
            [-10.367879048953563, 1.1906105644333933],
            [-10.372173934339056, 1.1871562190429217],
            [-10.369185292605675, 1.1794491687793018],
            [-10.370106399535466, 1.1702284925540836],
            [-10.380295721749052, 1.1512467240053312],
            [-10.386358344819804, 1.1488437437613486],
            [-10.387568546091455, 1.146388743947271],
            [-10.385598657408993, 1.1419204582403768],
            [-10.380949346201188, 1.1392389374772274],
            [-10.376212627848707, 1.1342582499136216],
            [-10.378722086737042, 1.129804269203593],
            [-10.387708541765504, 1.127408629929438],
            [-10.385541187018916, 1.120583478329747],
            [-10.379408976757325, 1.1190568676745802],
            [-10.377802933629386, 1.1133808137501322],
            [-10.381994538683898, 1.110771185268025],
            [-10.387451790695941, 1.1128122088740935],
            [-10.388131099097096, 1.1079001439843834],
            [-10.381413600234426, 1.103993163408091],
            [-10.376144594965135, 1.1031843416255054],
            [-10.375065824298087, 1.1105342919539605],
            [-10.346468620930384, 1.1061953212575362],
            [-10.348781278791769, 1.0908030567072702],
            [-10.320968191458636, 1.0866444856155955],
            [-10.319885490002276, 1.0939295970934282],
            [-10.305701139629116, 1.0917890915149482],
            [-10.307868292548102, 1.077271134431316],
            [-10.293684723783965, 1.0751580681510282],
            [-10.29586116152248, 1.0606627718966088],
            [-10.281685911526216, 1.0585527439584665],
            [-10.283845752508112, 1.0440395251801509],
            [-10.31219531634606, 1.0482735243912193],
            [-10.31111709532412, 1.055522738719588],
            [-10.318210604974064, 1.0565744782051751],
            [-10.31712651096025, 1.0638268641882571],
            [-10.331316536979193, 1.0659369979266728],
            [-10.329136857770333, 1.0804470866755937],
            [-10.349865203426244, 1.083549742002425],
            [-10.356866557987422, 1.0854166243817884],
            [-10.35633987014418, 1.0890011660533272],
            [-10.367045816278532, 1.0906156264003315],
            [-10.367617839266037, 1.0870490969494326],
            [-10.38900179962349, 1.0901807076431838],
            [-10.391627540058838, 1.0865240479866614],
            [-10.39124545609697, 1.0824898324635392],
            [-10.383045490434062, 1.0718370808467574],
            [-10.383688954474943, 1.0691856070390822],
            [-10.387699462801717, 1.0667498051509723],
            [-10.39338914736444, 1.0659460416339417],
            [-10.396911761884665, 1.0612948681788998],
            [-10.395213926434694, 1.0586515915141343],
            [-10.388891696692772, 1.05412699412869],
            [-10.385801707261637, 1.0427907410556794],
            [-10.389941987733195, 1.0337799958202394],
            [-10.393585500818961, 1.0337676531710973],
            [-10.401505253129674, 1.0359402517783456],
            [-10.409935209402358, 1.0392122028865274],
            [-10.416274724793661, 1.040464331675381],
            [-10.421458987708908, 1.0332867792935951],
            [-10.420636505756896, 1.0259427191914998],
            [-10.423447047161256, 1.0209790035000514],
            [-10.418159903358417, 1.0170210708252296],
            [-10.41519475867151, 1.0131212560971823],
            [-10.411359054275831, 1.003190502695122],
            [-10.411645529341593, 0.9996983291156213],
            [-10.414745089486898, 0.9910320629449315],
            [-10.414705642499925, 0.9852083207848907],
            [-10.417532226447205, 0.9779996445647019],
            [-10.414454281850139, 0.9735379937986925],
            [-10.410209192582291, 0.9737443445874502],
            [-10.40336842130371, 0.9788690810089529],
            [-10.398197199867349, 0.9773661978498336],
            [-10.397447708005524, 0.9730644673917154],
            [-10.399216259354876, 0.9661704262281801],
            [-10.402563883038795, 0.9621355054704905],
            [-10.408058151127708, 0.9532386525657994],
            [-10.408279564955334, 0.9496764280927197],
            [-10.40160603294484, 0.9437966567820633],
            [-10.393883412776088, 0.9420715027846801],
            [-10.39036661159735, 0.9398321792548556],
            [-10.390582449324272, 0.9342418438739094],
            [-10.39435582435787, 0.9313725685529253],
            [-10.393205119715464, 0.9276927885812207],
            [-10.3860301833071, 0.9252473263974682],
            [-10.382549641200237, 0.9167268357825074],
            [-10.382600640205455, 0.9073155169011397],
            [-10.385481570559762, 0.9047399350828786],
            [-10.394527343385972, 0.9029284248151702],
            [-10.397095359720028, 0.8989803149933903],
            [-10.394492664681033, 0.8925260743740744],
            [-10.38933691375885, 0.8847653140957874],
            [-10.376990864825549, 0.8748743693279633],
            [-10.372019028385893, 0.8580403101385795],
            [-10.373692902593447, 0.8553277807549101],
            [-10.38057460703315, 0.8557131420192525],
            [-10.386040406917715, 0.854568663967717],
            [-10.388721277580075, 0.852453974069746],
            [-10.392994285746253, 0.8457151245813611],
            [-10.399267336682781, 0.8395582947839414],
            [-10.399901330188769, 0.8324693661013889],
            [-10.39734165508387, 0.8250906700054325],
            [-10.397838671776032, 0.8205864555081528],
            [-10.400348350175864, 0.8191813572091706],
            [-10.407378874883294, 0.8202484151474985],
            [-10.410755524868636, 0.8161128708899873],
            [-10.409177421955302, 0.81358888092411],
            [-10.40305846068273, 0.8136115710242856],
            [-10.396245138539483, 0.8185300792350866],
            [-10.39168497296365, 0.8195298541508932],
            [-10.385501050701764, 0.8190572726320191],
            [-10.382254130050399, 0.8156232868161446],
            [-10.383108590924742, 0.8100056530529444],
            [-10.388825092616901, 0.804400468097761],
            [-10.393274283022883, 0.8029142077260559],
            [-10.39609949773204, 0.7990763752779586],
            [-10.394674599984366, 0.7939521219214163],
            [-10.389600707765654, 0.7866505694497667],
            [-10.387499145135635, 0.7810314647080916],
            [-10.393848692149897, 0.7745039854256814],
            [-10.394910622639316, 0.7708864634112012],
            [-10.390834214548327, 0.7693885076036272],
            [-10.379992971118094, 0.7750133208605934],
            [-10.376448700515835, 0.7749491534586638],
            [-10.37479870129693, 0.7720275547420835],
            [-10.376829148748138, 0.7667689012520473],
            [-10.380261469341171, 0.7639804708990621],
            [-10.378545286492614, 0.7588745707948787],
            [-10.374501503098298, 0.7592975739787343],
            [-10.368716008215667, 0.7629248553587717],
            [-10.366118583917544, 0.7603911512395582],
            [-10.366844965000546, 0.7571582759859915],
            [-10.371103664970162, 0.7513841414558116],
            [-10.369620058398946, 0.7477015293755009],
            [-10.365135822390895, 0.7461649078079895],
            [-10.361655722577067, 0.749506362884964],
            [-10.360156953525394, 0.7580701855320781],
            [-10.354592187979295, 0.7573522137848925],
            [-10.352449625092277, 0.754900036476894],
            [-10.352803563021912, 0.7495150360207181],
            [-10.362091946189556, 0.7409200912969992],
            [-10.365300195932603, 0.7341123033958772],
            [-10.364610714416159, 0.7285892013503052],
            [-10.361756153582363, 0.7219231535989361],
            [-10.362620002688203, 0.7159932861054875],
            [-10.368102468543253, 0.7152159166452396],
            [-10.376865534141503, 0.7210057165762322],
            [-10.379628920653012, 0.7212767124162859],
            [-10.383090328455546, 0.7178533506179896],
            [-10.381078703251102, 0.7099727055172019],
            [-10.3783073398994, 0.7073689513564545],
            [-10.371790972978175, 0.7053375603066812],
            [-10.360104573274715, 0.7075200127899997],
            [-10.351630952016126, 0.7057709559992037],
            [-10.346226516235738, 0.7084547312557289],
            [-10.341436803064616, 0.71892049385027],
            [-10.337620041373421, 0.7192600953766735],
            [-10.333080090297972, 0.7160148992532964],
            [-10.329330673455136, 0.7107397010034271],
            [-10.328411090869414, 0.7019362839573174],
            [-10.329907465858948, 0.6968912682743844],
            [-10.329463315806105, 0.6924484909624362],
            [-10.331990161941219, 0.6858486119867497],
            [-10.33623278376656, 0.6828554533873191],
            [-10.3419543327589, 0.6823644534175268],
            [-10.348273914532957, 0.6860509106332491],
            [-10.352251487742118, 0.697018160197005],
            [-10.357709652925747, 0.7025497987376816],
            [-10.37331942572055, 0.6917657310969956],
            [-10.380299768282505, 0.6828513880291565],
            [-10.37858412757037, 0.6787901119980247],
            [-10.369340649221886, 0.6770197245890465],
            [-10.366543292933686, 0.6708225868511695],
            [-10.362051406231512, 0.6698930857494267],
            [-10.356441811781188, 0.6741436041723704],
            [-10.352448593928187, 0.6710032695759328],
            [-10.351577513950975, 0.6595176579981988],
            [-10.34938454430558, 0.6569839753746243],
            [-10.346049485522375, 0.6571001726625871],
            [-10.337685811578476, 0.6622365354007042],
            [-10.333425239497352, 0.6626528269335051],
            [-10.330429796053403, 0.660529517337704],
            [-10.328831330363496, 0.6566332042857083],
            [-10.330174347182348, 0.6523849486981373],
            [-10.333241346208357, 0.6492089004694391],
            [-10.33969769449199, 0.6456180595374],
            [-10.345395010620965, 0.6380146505308668],
            [-10.345618439589746, 0.6338718400607357],
            [-10.343809595095628, 0.6291906135676376],
            [-10.33971929105296, 0.6231349674883867],
            [-10.338988009288938, 0.6190516751513929],
            [-10.344367185121687, 0.6162707952075575],
            [-10.352500074038364, 0.6203851271671589],
            [-10.354243271079671, 0.6191903890337216],
            [-10.355186735848456, 0.6123003140129939],
            [-10.357730773871092, 0.6096341544366577],
            [-10.363158883270595, 0.6100772394318886],
            [-10.370772694485963, 0.6165460389092582],
            [-10.37443945716562, 0.6170578107700317],
            [-10.378982591325627, 0.6153134837746729],
            [-10.380912276680485, 0.60958182341301],
            [-10.380374941922563, 0.6066863496410738],
            [-10.37495852859332, 0.6020430408886388],
            [-10.370107941372806, 0.6003191821631042],
            [-10.366872240698948, 0.5971288892069269],
            [-10.52164965523537, 0.6208340413951758],
            [-10.676429716670306, 0.6445216656590778],
            [-10.831212443468356, 0.6681917595821745],
            [-10.98599785366484, 0.6918443235714625],
            [-11.145253578818421, 0.7172670548203596],
            [-11.30451224966825, 0.7426711885703737],
            [-11.347433055591152, 0.7496503446350526],
            [-11.34575871947402, 0.7597825465903385],
            [-11.333388617115107, 0.8349832556660082],
            [-11.334543941257825, 0.8351709194696412],
            [-11.32053061714053, 0.9215580257447545],
            [-11.314522279905525, 0.9205802493316426],
            [-11.302733219138377, 0.9927887172504314],
            [-11.30112217168667, 0.999692860302961],
            [-11.29533196981443, 1.0369762049105566],
            [-11.257895599884533, 1.2647353062604123],
            [-11.258798144035595, 1.2648807947989429],
            [-11.256437537458266, 1.2793142213195785]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.70059542798705,
          "lat": 38.99676399066826
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49015"],
        "coty_name": ["Emery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Emery County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01448022"
      },
      "bbox": [
        -11.347433055591152, 0.5971288892069269, -10.217785848001327,
        1.9423925792486099
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.40771527878534, 1.296718899298638],
            [-13.397731176564784, 1.3480941476532184],
            [-13.393337118046217, 1.3685698937609734],
            [-13.369737743118526, 1.492516830268885],
            [-13.344581058517775, 1.6218690454812061],
            [-13.257888977144537, 2.0678562557251015],
            [-13.241170788499485, 2.1539887019575263],
            [-13.0668537365932, 2.1221121500625144],
            [-13.065227403732308, 2.130586341015507],
            [-12.897663392268578, 2.0996585175735265],
            [-12.730104929720824, 2.068700088696457],
            [-12.562552018912257, 2.037711060428117],
            [-12.395004661955701, 2.0066914426902835],
            [-12.304482863678041, 1.9905414217331465],
            [-12.174031908727917, 1.9671578034110104],
            [-12.048297849747737, 1.9451102525007207],
            [-12.048082878714611, 1.9463559318891204],
            [-11.966851395962129, 1.9321786458553858],
            [-11.877667152177303, 1.9166847101565012],
            [-11.85960494809508, 1.9139435088651637],
            [-11.860665023012475, 1.9077206407260998],
            [-11.857150673695097, 1.9070809174388874],
            [-11.857764819445633, 1.9034848827821562],
            [-11.854251423199083, 1.9028475477257203],
            [-11.854865803024628, 1.8992535853352834],
            [-11.847805118974708, 1.8980565375932108],
            [-11.850236854332568, 1.8837047679980177],
            [-11.864339055254879, 1.8861505490679737],
            [-11.866808241846245, 1.8717691826885374],
            [-11.863288525565284, 1.8711500230647118],
            [-11.86453867465134, 1.863961418617317],
            [-11.86102501043806, 1.8633455227150466],
            [-11.863496916602053, 1.8489622315014222],
            [-11.856457123159691, 1.847726771352704],
            [-11.876679862321728, 1.7316810684188453],
            [-11.873141383946377, 1.7310716212359452],
            [-11.880630202858383, 1.687618629580843],
            [-11.84164087194672, 1.680931449130861],
            [-11.792359548564535, 1.6728087936556992],
            [-11.79495242183162, 1.6581291921517403],
            [-11.780826820520316, 1.6552694891398774],
            [-11.752544432873677, 1.650534050904382],
            [-11.796643620838315, 1.3826065548593947],
            [-11.800189069212873, 1.3614670531728348],
            [-11.80400746918283, 1.3620397093680423],
            [-11.808704225242709, 1.333857885664524],
            [-11.837183577940735, 1.338480996551558],
            [-11.838436229086927, 1.331207430458556],
            [-11.845452130806045, 1.3324675978757357],
            [-11.850020861583353, 1.3034204497686694],
            [-11.902172943936291, 1.312337686392159],
            [-11.906369226907364, 1.2886323408651281],
            [-11.919955327738636, 1.2909822574553915],
            [-11.921512799126942, 1.2754628406361914],
            [-11.924014051551051, 1.26201424547606],
            [-11.938200179413636, 1.2640630816230531],
            [-11.940681773341693, 1.2501214485589],
            [-11.94457793005739, 1.2369757365089078],
            [-11.957289539100792, 1.2400115318590756],
            [-11.959852513884147, 1.225436321866568],
            [-11.973136058994653, 1.228054649118962],
            [-11.98714791765983, 1.2301515902328588],
            [-11.99196245985748, 1.2030276547134524],
            [-11.994853118323771, 1.2035197646182563],
            [-12.007423656071998, 1.1303720670431423],
            [-12.000374492155451, 1.1291572000702284],
            [-12.002556853085945, 1.1164863459482253],
            [-12.002156500800014, 1.1140981029367212],
            [-12.006074708866835, 1.0926190839507617],
            [-12.020039906635516, 1.0947631890476663],
            [-12.021346008542244, 1.0875662574232845],
            [-12.024891811008525, 1.0881021336047307],
            [-12.026220825813626, 1.0808927377595676],
            [-12.036834860193796, 1.0825015088124286],
            [-12.03814251820295, 1.0752904595673263],
            [-12.051751532554373, 1.077592717433716],
            [-12.052346813669876, 1.0739601632438711],
            [-12.059243461026405, 1.0753310769918731],
            [-12.061697241941364, 1.0607426526948882],
            [-12.06858041512636, 1.0620227780791833],
            [-12.069221204154891, 1.0583806418201507],
            [-12.083378645597039, 1.060947168244818],
            [-12.084616231262899, 1.0538663322750972],
            [-12.112979428117386, 1.0587550672291002],
            [-12.120100820096436, 1.0604851787598388],
            [-12.118795879915412, 1.0675491659956806],
            [-12.125911631133164, 1.069158104955265],
            [-12.139992209886893, 1.0706774604000757],
            [-12.15329243425049, 1.070598133547975],
            [-12.167404485836984, 1.0734851528271905],
            [-12.188533579821668, 1.0770537793089454],
            [-12.189925228222616, 1.0697672631580937],
            [-12.203889828149704, 1.0722031213855572],
            [-12.206557897917724, 1.0576549911816704],
            [-12.213556356006778, 1.0588696321328297],
            [-12.215977093678159, 1.0443477966201975],
            [-12.223036355220556, 1.0455553293852575],
            [-12.230968476469886, 1.00183075199134],
            [-12.244919711843638, 1.0042104863824515],
            [-12.250068579928854, 0.9751919999060198],
            [-12.257120052250972, 0.9764095551528067],
            [-12.259151341709648, 0.9782902876903532],
            [-12.32633881628541, 0.9899997050038225],
            [-12.439954464343307, 1.0100874716766421],
            [-12.578781619078985, 1.0350566834330652],
            [-12.717611387740186, 1.0600111755204142],
            [-12.895156657761799, 1.093361983792791],
            [-13.072706362383856, 1.1266886217950705],
            [-13.250260528184711, 1.1599910804920215],
            [-13.427819180809179, 1.1932693558318979],
            [-13.40771527878534, 1.296718899298638]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.10077888526037,
          "lat": 39.07326156054529
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49027"],
        "coty_name": ["Millard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Millard County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01448027"
      },
      "bbox": [
        -13.427819180809179, 0.9751919999060198, -11.752544432873677,
        2.1539887019575263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.67383793456877, -0.7302692288160251],
            [-11.671121143873401, -0.7282026696972835],
            [-11.66579196311833, -0.727783058192375],
            [-11.65555138188731, -0.7301992448161012],
            [-11.647791372433314, -0.7338110528971391],
            [-11.64136554166939, -0.7354601492289206],
            [-11.636686735657124, -0.7348494831100414],
            [-11.62760077072656, -0.7315208188574258],
            [-11.621765421649178, -0.7320163420180088],
            [-11.616418084872649, -0.7301201710969433],
            [-11.61043239046252, -0.7238472350116066],
            [-11.60628801827971, -0.7216176108710344],
            [-11.601195695929581, -0.722906252077185],
            [-11.59562961876519, -0.7319062392868407],
            [-11.59262448216966, -0.7334604322874404],
            [-11.588691564899637, -0.7328208196167774],
            [-11.58592562884183, -0.7297269186188368],
            [-11.58762213218039, -0.7215835690857904],
            [-11.586390741196771, -0.7187968529319988],
            [-11.58106741964266, -0.7158052301992313],
            [-11.57317074167167, -0.713531638181095],
            [-11.566123558911835, -0.7091833263343834],
            [-11.56652302579024, -0.7037814281207727],
            [-11.577445982262443, -0.7029590884323996],
            [-11.580259900855223, -0.6999296921786513],
            [-11.581205349989663, -0.6887179194587907],
            [-11.57937677077833, -0.6825483295223039],
            [-11.57486037974545, -0.6796250166878631],
            [-11.570617302668573, -0.682121227111602],
            [-11.565401960718077, -0.6884560931767636],
            [-11.558501838755719, -0.691591103397404],
            [-11.552275047941153, -0.6962599394855097],
            [-11.548759003301837, -0.7035544225289562],
            [-11.543457217944319, -0.7268197669905043],
            [-11.541925361308456, -0.7301185482452774],
            [-11.538066655229391, -0.7321419515254479],
            [-11.533010017700219, -0.7297258371408841],
            [-11.527358337818066, -0.7211096941549543],
            [-11.524806539144134, -0.7157968873748057],
            [-11.526385973267319, -0.7117216954120654],
            [-11.535204726343652, -0.7076364800861014],
            [-11.536697221495787, -0.7009260317610111],
            [-11.532814045197648, -0.6953051843838971],
            [-11.529514722856387, -0.687871535400351],
            [-11.525339744401299, -0.6842367846677526],
            [-11.52068570999675, -0.6887825151304614],
            [-11.51874873761883, -0.6977356102938349],
            [-11.516687386625145, -0.7000261379928642],
            [-11.512872110798698, -0.6999694094144071],
            [-11.5004306222787, -0.6889135952660723],
            [-11.494892041698597, -0.6826195377544283],
            [-11.48366064088459, -0.6720025911812624],
            [-11.475860799876708, -0.6604973176625455],
            [-11.47241103812707, -0.6588439571955543],
            [-11.4646811158775, -0.657641124984891],
            [-11.458481224428073, -0.6650321238288242],
            [-11.456124324154226, -0.6722218170157596],
            [-11.452194053919007, -0.6760042978000006],
            [-11.446068834614973, -0.6780704087660052],
            [-11.442893015758331, -0.6773728152655245],
            [-11.43990901645526, -0.6741471531194542],
            [-11.4339885811707, -0.6637315842002935],
            [-11.429740822224241, -0.6609651340462034],
            [-11.41439132522224, -0.6686402977849413],
            [-11.406198799335634, -0.6676140231313112],
            [-11.396092109547409, -0.6717234316699604],
            [-11.388557959512587, -0.6682729799693625],
            [-11.385463302439247, -0.6680877489189537],
            [-11.382297089042304, -0.6705323640931965],
            [-11.381164137487616, -0.6768174782111339],
            [-11.374039756277153, -0.6783479610183362],
            [-11.370642539746962, -0.6760581504506371],
            [-11.367614928970728, -0.6711766673125494],
            [-11.36390187088717, -0.6700719236553025],
            [-11.351508437964037, -0.6702518209777986],
            [-11.34271465026127, -0.666919190277004],
            [-11.3372276797492, -0.6712668887281482],
            [-11.33294657680482, -0.6730442102459463],
            [-11.323873935021698, -0.6733361385303637],
            [-11.319286253614342, -0.6700670901372702],
            [-11.319773426638351, -0.6614224701723241],
            [-11.31473901521048, -0.6594224473043193],
            [-11.302185018951596, -0.6653234941760391],
            [-11.297785294557835, -0.6637522114417979],
            [-11.294587220302855, -0.6585010239046151],
            [-11.29184359644026, -0.6563896966019248],
            [-11.29417825881202, -0.6456962381939558],
            [-11.293319050657427, -0.6402109289379284],
            [-11.288011838072437, -0.6376597828148263],
            [-11.283375193276717, -0.642627210625597],
            [-11.278971436723477, -0.6440294977821129],
            [-11.271085845671902, -0.6382291273179531],
            [-11.268225500708416, -0.6338273672540861],
            [-11.266882684483942, -0.62904115122115],
            [-11.267355393112567, -0.6231557933619429],
            [-11.264969895245175, -0.6157755703061996],
            [-11.259723392311907, -0.6164864481543759],
            [-11.253193171544751, -0.6231929925247848],
            [-11.248576345114149, -0.6239322126063153],
            [-11.246706895324317, -0.6197330371752262],
            [-11.246835191159544, -0.6128945333587722],
            [-11.244422370163765, -0.6099864292176184],
            [-11.238221615299356, -0.6070246363906354],
            [-11.23462235368071, -0.6030995677209094],
            [-11.233123188512405, -0.5965918248705282],
            [-11.233551611604469, -0.5932019737850704],
            [-11.238337434020044, -0.5862287079590152],
            [-11.237476582479134, -0.5811861435878175],
            [-11.234114153527724, -0.5786385029992378],
            [-11.225273164559995, -0.5770090427565474],
            [-11.220561763926538, -0.5744734996735422],
            [-11.217865140206726, -0.5699669386161464],
            [-11.220268910233072, -0.5619118730094271],
            [-11.224949353101875, -0.5538538590245106],
            [-11.225457093784016, -0.5503124204264713],
            [-11.221703859882046, -0.5464676416942127],
            [-11.210320371828338, -0.544644531234877],
            [-11.20511643217281, -0.5450021849877897],
            [-11.201878536222752, -0.5415874650148367],
            [-11.201673112624102, -0.5370200187935184],
            [-11.207614056960178, -0.526928379408796],
            [-11.208859707185876, -0.5224856143962817],
            [-11.207244895875215, -0.5133585202557099],
            [-11.202239358266318, -0.5110559050869012],
            [-11.19021011296575, -0.5115383322848183],
            [-11.184686799179257, -0.5101452055144996],
            [-11.18089451678046, -0.5077698396578499],
            [-11.17717806552528, -0.5012487769056754],
            [-11.17625451023829, -0.48927231943650756],
            [-11.177196761996584, -0.48592359042508615],
            [-11.183143289316137, -0.4799682994491814],
            [-11.192204994193379, -0.4768435005047493],
            [-11.196871715455583, -0.47231727454776773],
            [-11.19945454046283, -0.462842701530252],
            [-11.198818134560007, -0.45561676615074165],
            [-11.19473770063922, -0.4519763102217229],
            [-11.190214467065584, -0.4514384376188635],
            [-11.184814341027618, -0.4539017129060806],
            [-11.176758347951818, -0.4611925516555078],
            [-11.16891994913747, -0.4701642325778788],
            [-11.158517945843698, -0.4773125770468557],
            [-11.156518189023217, -0.4805246300592505],
            [-11.148565846286536, -0.4878135932110791],
            [-11.133377780456252, -0.487314751110682],
            [-11.126875793176335, -0.4891017180305647],
            [-11.12376321785391, -0.48744011893244005],
            [-11.121052234276393, -0.4832175993009455],
            [-11.11777832139541, -0.4810526828916746],
            [-11.112548615933344, -0.4816457521165783],
            [-11.108883481367123, -0.4782110612471227],
            [-11.106808474927426, -0.46915458492842965],
            [-11.10464099498603, -0.4641035891753502],
            [-11.10009340487692, -0.4637051752483244],
            [-11.098971305915551, -0.46860957666910946],
            [-11.094508418496806, -0.4719237823427564],
            [-11.091505757728035, -0.4711534544000212],
            [-11.089649759608605, -0.46675765521792506],
            [-11.090176806626351, -0.46206503514621755],
            [-11.088379815929288, -0.4578725790102521],
            [-11.080345334169737, -0.4526861919417499],
            [-11.0768213190276, -0.4477596940718166],
            [-11.079669901271572, -0.44261469565666106],
            [-11.090610718687461, -0.42943479742924207],
            [-11.094416956524364, -0.42201843820968854],
            [-11.096244680568422, -0.4161970974923085],
            [-11.09475960329444, -0.4095766572429515],
            [-11.089084081472162, -0.4084715240441912],
            [-11.082579708828458, -0.41129133915085625],
            [-11.075912826194843, -0.4178999376460941],
            [-11.069926819033112, -0.419078950467717],
            [-11.065445682548962, -0.41659491702582546],
            [-11.060842453645487, -0.4123003744264339],
            [-11.057104992459793, -0.4034986083025987],
            [-11.049992069828527, -0.3914520026543684],
            [-11.050984293835523, -0.38586145757671675],
            [-11.05700759021326, -0.38303235010641984],
            [-11.064761314580496, -0.38423413962393393],
            [-11.069659727796386, -0.3828366114029952],
            [-11.075736306399026, -0.3749793918421694],
            [-11.078929501996676, -0.3679831780193136],
            [-11.082305151429358, -0.36354702241612485],
            [-11.082810051508808, -0.3575268720432273],
            [-11.080334167357197, -0.3562205765547882],
            [-11.068562612884174, -0.36002183027996726],
            [-11.065100603362744, -0.35788593497507626],
            [-11.063799365943643, -0.34688070360275963],
            [-11.058292510441126, -0.3390259119317974],
            [-11.05482331499417, -0.33817651904522],
            [-11.041984893710648, -0.34021704765191985],
            [-11.033803807925892, -0.34273679915206823],
            [-11.027637399570938, -0.3455295378867149],
            [-11.017717251315718, -0.34808613733794685],
            [-11.013977771228019, -0.34794934491228624],
            [-11.005541037730058, -0.34501178758930234],
            [-10.9982567025704, -0.34442971186102206],
            [-10.995136096323792, -0.3430514016892676],
            [-10.995102138753877, -0.33848989519903167],
            [-11.002258362225694, -0.3339683000840317],
            [-11.013525936831684, -0.33127956377009654],
            [-11.015104574430108, -0.3286999266585127],
            [-11.012322164454003, -0.3216593892683043],
            [-11.01115499801457, -0.31527505386374854],
            [-11.008539171077167, -0.30791218741364446],
            [-11.004686769024746, -0.30060972908918293],
            [-10.999794088293813, -0.2971538838274542],
            [-10.991754278863787, -0.2878365846000342],
            [-10.982478202925638, -0.27659836223805834],
            [-10.96735069988735, -0.2681184738317309],
            [-10.956501516455612, -0.26863079518056326],
            [-10.951745506014513, -0.26645307735475754],
            [-10.949323557047705, -0.26178329272717027],
            [-10.948529543559635, -0.2475965219067037],
            [-10.94990465534338, -0.23720710961614763],
            [-10.948920406293126, -0.2315851206466638],
            [-10.945160865240133, -0.22928059329303827],
            [-10.931663300593295, -0.22810853007269166],
            [-10.918905474791236, -0.22434407001240544],
            [-10.914634358655942, -0.2131613635320491],
            [-10.912443802987317, -0.2020557504747988],
            [-10.908038607835435, -0.19688222483187057],
            [-10.903602090569054, -0.19821586787038942],
            [-10.895843833556402, -0.2075478997404295],
            [-10.890727990145733, -0.20808729570049966],
            [-10.885457677291894, -0.20310218047804507],
            [-10.882893045104101, -0.19775929722695101],
            [-10.878180869122898, -0.19240892457631073],
            [-10.870541640254228, -0.187667248858099],
            [-10.868576901320811, -0.18818824137949441],
            [-10.861602791680996, -0.1957231554063259],
            [-10.85946801021898, -0.19468539798119344],
            [-10.857661312915717, -0.18731898579158224],
            [-10.853359981400368, -0.17909261802333706],
            [-10.846771748816922, -0.17351516029561276],
            [-10.844234067544951, -0.1663068905022985],
            [-10.841425716770189, -0.15309605022102823],
            [-10.8441335082232, -0.14567868897891784],
            [-10.842985218224447, -0.14431340531030626],
            [-10.83360790002505, -0.141545174062375],
            [-10.82723748716647, -0.1351639154513952],
            [-10.826664244253037, -0.12858672514293],
            [-10.825118635962777, -0.12554747545625172],
            [-10.820574861342363, -0.1226125402899228],
            [-10.812599475899292, -0.12011449747845623],
            [-10.807711762315844, -0.11456625861282924],
            [-10.8063263464591, -0.1100168169103233],
            [-10.804086161953235, -0.09675328881455982],
            [-10.80126066607715, -0.091580568686569],
            [-10.787771113665755, -0.08403546546389384],
            [-10.785128279203741, -0.08080297293430887],
            [-10.785895043222393, -0.07572186774419092],
            [-10.788779437560684, -0.07586590350619196],
            [-10.795161424063593, -0.07918072243983837],
            [-10.80033944998522, -0.08035944663988932],
            [-10.808488321814211, -0.07967882264696381],
            [-10.811416486346852, -0.08057539850737383],
            [-10.814410009871922, -0.07815381116597611],
            [-10.817494023677838, -0.07205459611383312],
            [-10.81876103009927, -0.06542384737949918],
            [-10.818422074530634, -0.05523386648388251],
            [-10.821020422142904, -0.05303693980013575],
            [-10.820255260009436, -0.049217968777267106],
            [-10.814346449309811, -0.04116395103190749],
            [-10.808513824173128, -0.04227937156201724],
            [-10.798569838119443, -0.04254101137243629],
            [-10.792157500677165, -0.04765971264668693],
            [-10.789894960245718, -0.047951993674541435],
            [-10.786371820266245, -0.04231990067485032],
            [-10.785600438251771, -0.03539822174098924],
            [-10.781074877147782, -0.020455509359424234],
            [-10.778161590927809, -0.016426777666650978],
            [-10.773295938848754, -0.012598536430474736],
            [-10.758160265671313, -0.009186155236283433],
            [-10.754897965656145, -0.005937404823534003],
            [-10.75479344666713, 0.0025570384425846024],
            [-10.753312933617494, 0.006855314269952888],
            [-10.753763690156342, 0.01236485448017048],
            [-10.75308777803257, 0.0202020316900632],
            [-10.751656022386294, 0.022955008980936092],
            [-10.739225142278766, 0.027973209476469463],
            [-10.731462829301972, 0.029247083010770177],
            [-10.713794712682311, 0.029429910368784708],
            [-10.703236873823947, 0.02573674692318682],
            [-10.681572530167834, 0.0217346019566239],
            [-10.675763341396769, 0.021678461737476458],
            [-10.670800608310863, 0.020007631849642844],
            [-10.66624653038099, 0.014663990456879255],
            [-10.667245754465863, 0.0036673083771761963],
            [-10.666033544666302, -0.002180793268294721],
            [-10.660467988798692, -0.006257358076306853],
            [-10.65527769451506, -0.0025410856386704787],
            [-10.655180542751717, 0.005679194135739939],
            [-10.653896249866289, 0.01225212658835184],
            [-10.649035633833341, 0.02088205633549876],
            [-10.645035497482224, 0.023709496662628664],
            [-10.639347886430219, 0.024617209280763212],
            [-10.628231500612156, 0.0200205042108416],
            [-10.61434259109312, 0.017210236942517245],
            [-10.60470228645193, 0.01255719312235986],
            [-10.598662783246313, 0.01315561749569056],
            [-10.595203223668474, 0.016911450134360573],
            [-10.59313906393566, 0.024794835532654408],
            [-10.58735080602379, 0.03376993755545178],
            [-10.587296654760646, 0.040207614648287905],
            [-10.589620764318393, 0.04529691126393765],
            [-10.590260077834234, 0.053126808594481496],
            [-10.587519566374276, 0.06266176320055462],
            [-10.585356780049091, 0.0650780803896],
            [-10.574447329527219, 0.0688733133061035],
            [-10.56729285400503, 0.0734099505707385],
            [-10.560339724552172, 0.07669686101151675],
            [-10.554364662700122, 0.0816189937902696],
            [-10.55010907766525, 0.09331752538428201],
            [-10.547094623287096, 0.09679437831592505],
            [-10.535343104037773, 0.10225082381535033],
            [-10.526010860393745, 0.11567335982970794],
            [-10.520117439782371, 0.11671425165307063],
            [-10.508016034276308, 0.1161057412198956],
            [-10.5017691370531, 0.1098324380002314],
            [-10.498546629292512, 0.10395863720075511],
            [-10.494397287838057, 0.10026026123164408],
            [-10.486660183590573, 0.09987782674206473],
            [-10.48073596624093, 0.10329012631683634],
            [-10.478905211169293, 0.10656599787046842],
            [-10.47710965242017, 0.11482654894439209],
            [-10.478242563248985, 0.12385070583117541],
            [-10.474557085813409, 0.12925739386988502],
            [-10.468079682089146, 0.14100477204702094],
            [-10.462609993206401, 0.14665221103555007],
            [-10.456648999743315, 0.14958550523488057],
            [-10.45086082125781, 0.14891544721070818],
            [-10.446030784590903, 0.15792200805311846],
            [-10.446039582324362, 0.1651342577607114],
            [-10.447652775504485, 0.1699543844907146],
            [-10.445555268977554, 0.17357686247473514],
            [-10.438444941485967, 0.18203998945755714],
            [-10.43479741411615, 0.18395068635742515],
            [-10.427476972569236, 0.19472118313393832],
            [-10.416023806072479, 0.20440244902235324],
            [-10.411565880569421, 0.20546987204685857],
            [-10.408290613348374, 0.20360142650323798],
            [-10.405943729908445, 0.1984162639300064],
            [-10.40219695287378, 0.19444974383516306],
            [-10.39658042587103, 0.1937506985902938],
            [-10.391613345248631, 0.20027991651851879],
            [-10.38406667827726, 0.20365063609528064],
            [-10.377073003383554, 0.20467942047032417],
            [-10.376050497608727, 0.20830511401734067],
            [-10.369526034666452, 0.21910462871055464],
            [-10.367397418513079, 0.22074565294154705],
            [-10.357980414775186, 0.2235459321505883],
            [-10.35085891368567, 0.22328403738474323],
            [-10.346310425419764, 0.2269752204259087],
            [-10.343761701635497, 0.23389536745352066],
            [-10.343614085175524, 0.23821279632280518],
            [-10.346346693636917, 0.2442242264334664],
            [-10.344097933372923, 0.24605827431982133],
            [-10.336668677497247, 0.24847532132385466],
            [-10.330385956969325, 0.2524614947105696],
            [-10.320872260230516, 0.26202789091198725],
            [-10.310017309570915, 0.26322912450079383],
            [-10.307126317087322, 0.26527880892688516],
            [-10.305233042751002, 0.2697402602907922],
            [-10.309787207520133, 0.2725314895884601],
            [-10.315433710783662, 0.27106633882831943],
            [-10.319472565956419, 0.2736741348295466],
            [-10.317436099807061, 0.27813059192736334],
            [-10.30838817955116, 0.2834724751522711],
            [-10.304398065082182, 0.28948900121446003],
            [-10.313267298690965, 0.2901864704104416],
            [-10.321277003414407, 0.2956965336701791],
            [-10.326763226934887, 0.30208271612574844],
            [-10.32667609027255, 0.3098600521170903],
            [-10.323475278232113, 0.31233070428476],
            [-10.312595096323012, 0.31286842258724556],
            [-10.303552285328099, 0.3101476103734829],
            [-10.301774594830535, 0.3120753151143378],
            [-10.305912967152233, 0.3233619025279621],
            [-10.309737527097074, 0.3262717679353408],
            [-10.317075710731944, 0.32347650057827465],
            [-10.319970396865443, 0.32355213291652996],
            [-10.32271637871615, 0.32803689668196223],
            [-10.32165093834733, 0.3317319530691942],
            [-10.311793001772907, 0.33563126253347253],
            [-10.30798087302129, 0.3401914427629015],
            [-10.308167876665168, 0.34828451069302635],
            [-10.310346137321476, 0.3545898344007799],
            [-10.313230900831739, 0.3550334165063262],
            [-10.324490791612101, 0.3468921764793656],
            [-10.330143301199916, 0.34681494373535676],
            [-10.333167873857692, 0.35277559814935905],
            [-10.324942525837518, 0.3636303903222432],
            [-10.32516759325586, 0.3680945972397213],
            [-10.330192917741991, 0.3732696269112605],
            [-10.33783237858763, 0.3764990010148011],
            [-10.3401734796879, 0.38282568984654936],
            [-10.338614736641176, 0.3878848280948585],
            [-10.334515346800139, 0.396007363582221],
            [-10.337761581210223, 0.40351103757793866],
            [-10.344944304343038, 0.4074519523482439],
            [-10.34606953562107, 0.40979984401948966],
            [-10.346196891378131, 0.42087369056872775],
            [-10.342747224613579, 0.42414210415917436],
            [-10.33216599133875, 0.4262203253454915],
            [-10.328693335608927, 0.43319421305992034],
            [-10.324866769119689, 0.4376467233187208],
            [-10.325186882511098, 0.4429395698168193],
            [-10.330002282207802, 0.44438822388586746],
            [-10.333192315147102, 0.4433175145688858],
            [-10.335355607790687, 0.43507023733026307],
            [-10.338213694600146, 0.43144870132610996],
            [-10.343883535705194, 0.43014803516416034],
            [-10.350837987330067, 0.4366857142211808],
            [-10.356903538544435, 0.4446257304771448],
            [-10.358239647098166, 0.45299424541054734],
            [-10.352765670342025, 0.45620087342592125],
            [-10.34602365227679, 0.46562543058944644],
            [-10.343558254026238, 0.4749760835297781],
            [-10.344492444293936, 0.47900050619421947],
            [-10.347896032972631, 0.4816727809181471],
            [-10.355215262615106, 0.4789437834279971],
            [-10.367585929991161, 0.46494576492737827],
            [-10.374178829467503, 0.4603597742608393],
            [-10.378998754799433, 0.4628109591920763],
            [-10.37413852373362, 0.4670014655869172],
            [-10.373495504573489, 0.4731871832622657],
            [-10.380365102281797, 0.47978032389248926],
            [-10.38865649074331, 0.4824144542342871],
            [-10.38971346801985, 0.4870532482638786],
            [-10.387228215264464, 0.49055680802842044],
            [-10.382893375359272, 0.490948498027654],
            [-10.374789972410431, 0.5017443578850402],
            [-10.363976586294195, 0.5066607662531075],
            [-10.362409517826972, 0.5108238151211831],
            [-10.36553265685626, 0.5219845166093302],
            [-10.368761461272966, 0.5269127201560336],
            [-10.375673958629493, 0.5447927400428718],
            [-10.384163112214353, 0.5449230695259508],
            [-10.389040724993022, 0.5483929715045056],
            [-10.387236390024713, 0.5559370798426537],
            [-10.381030645021868, 0.5583467830335074],
            [-10.37717852045932, 0.5550124885565064],
            [-10.37392750945843, 0.5478906669178975],
            [-10.36967883539015, 0.5427390681463691],
            [-10.364775402563149, 0.5430427858166401],
            [-10.363113588368899, 0.5452837414995608],
            [-10.362196300836576, 0.5538999693296748],
            [-10.353400095447734, 0.5676245116288193],
            [-10.351716946150564, 0.5761933435492929],
            [-10.353629339822842, 0.579497669019561],
            [-10.36352864718327, 0.5892525366324685],
            [-10.363895824771179, 0.5925083573590656],
            [-10.366872240698948, 0.5971288892069269],
            [-10.22376272157223, 0.5761258346799474],
            [-10.080655385144588, 0.555107827671706],
            [-9.93180275437008, 0.5337579309727318],
            [-9.832441416112086, 0.5196725758452075],
            [-9.626296603558414, 0.49093751347017034],
            [-9.626302244904604, 0.49089603178816926],
            [-9.65743180599137, 0.26635161200307717],
            [-9.657489058390011, 0.23519831223593585],
            [-9.658643807393803, 0.15357022278633936],
            [-9.66031166310965, 0.14191647559182485],
            [-9.68230722785451, -0.011760520623773847],
            [-9.685999246617166, -0.03677772534566125],
            [-9.693661694162007, -0.10404451017355784],
            [-9.697735776967825, -0.1301402897066738],
            [-9.699028474918057, -0.13841997112991763],
            [-9.708771566039594, -0.21116788589919086],
            [-9.716187991137625, -0.2612308739154503],
            [-9.717180565267425, -0.2710634807996938],
            [-9.72126030163158, -0.30005837509967764],
            [-9.727913507216279, -0.34516181234931775],
            [-9.736103762420793, -0.40712604289019677],
            [-9.746294657075527, -0.48058563335361765],
            [-9.75152991183396, -0.5111912706225415],
            [-9.753878368857107, -0.5263323432583159],
            [-9.770881369127915, -0.6359331943621936],
            [-9.788331119434506, -0.7609330744509234],
            [-9.78806451240486, -0.7616242586065249],
            [-9.793308959648583, -0.800147977053813],
            [-9.79493787434521, -0.8091093534820907],
            [-9.798343407154421, -0.8336630314228928],
            [-9.806697412143494, -0.8989765847383289],
            [-9.822358383519017, -1.011957823660947],
            [-9.92886168981683, -0.9969812304625701],
            [-9.998501109624032, -0.9872341828429833],
            [-10.086601359866538, -0.974922446864434],
            [-10.17492078271948, -0.9623955104160725],
            [-10.277076215640994, -0.9485355120568365],
            [-10.34289971227334, -0.9389380239355103],
            [-10.472731531033427, -0.9198332359432482],
            [-10.570627580384752, -0.9059079672493549],
            [-10.587041155561684, -0.902837627965349],
            [-10.675135333815604, -0.8898492948929988],
            [-10.785935870448025, -0.8733617362893166],
            [-10.937842315282898, -0.8504829720175557],
            [-10.953186177067096, -0.8424389541944011],
            [-10.960726737729248, -0.8405711285961532],
            [-11.038098531841463, -0.8294637247993556],
            [-11.058517023429708, -0.8260209069221396],
            [-11.15628645236416, -0.8113269728955733],
            [-11.403129812787293, -0.7731158690323874],
            [-11.455886615739168, -0.7663098150300895],
            [-11.550429539352418, -0.7507620629539294],
            [-11.568824313077583, -0.7484078813204715],
            [-11.66798278179875, -0.7312069733130415],
            [-11.67383793456877, -0.7302692288160251]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.80461280510586,
          "lat": 37.626011808176486
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49037"],
        "coty_name": ["San Juan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Juan County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01448032"
      },
      "bbox": [
        -11.67383793456877, -1.011957823660947, -9.626296603558414,
        0.5971288892069269
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.766001974090123, 0.38090764626320367],
            [14.772537538709331, 0.3813587007118466],
            [14.775535451742414, 0.3851777887133027],
            [14.780624685578013, 0.38862166210841503],
            [14.791581083779258, 0.38381299205747055],
            [14.794822249038402, 0.381144331420384],
            [14.794919949548747, 0.37766169868821214],
            [14.805971873526273, 0.3746721698127307],
            [14.809563889489189, 0.3717589600042562],
            [14.814185608746353, 0.37190063556732483],
            [14.81923670470423, 0.36893777741906],
            [14.826725941849501, 0.3683488309074524],
            [14.82783457874298, 0.370514806462004],
            [14.83237736273043, 0.369935059101385],
            [14.83728663530252, 0.37323133975095235],
            [14.839123282398093, 0.3772408905557478],
            [14.84374500602394, 0.381479472466472],
            [14.846979938643418, 0.3876365772382505],
            [14.852095314467691, 0.3895534541492678],
            [14.858642189441715, 0.39508324062317063],
            [14.865640575547484, 0.3943318805277235],
            [14.871313085912925, 0.3973049064564194],
            [14.877481475321538, 0.3853903037136643],
            [14.884032316874892, 0.3807181282673594],
            [14.888612977227535, 0.3794668411337298],
            [14.888737923275388, 0.38416752726352876],
            [14.892162994638795, 0.38714623964964384],
            [14.902455078318864, 0.379471689275342],
            [14.909110905931263, 0.382890978506494],
            [14.910072376204557, 0.3872653071194625],
            [14.914837093778736, 0.38596345543665767],
            [14.91824581364866, 0.3812026224193318],
            [14.920418609925916, 0.3725771146724196],
            [14.929112072491773, 0.3640517803473898],
            [14.931011984607826, 0.3573796046497754],
            [14.935928860776034, 0.3557011288144128],
            [14.943630280107302, 0.3412311916712543],
            [14.9515692847856, 0.3369494773642628],
            [14.954932815505133, 0.3361274143336271],
            [14.956153553648985, 0.3328404347278706],
            [14.954608443625807, 0.324351302605691],
            [14.958710935288009, 0.32028372097396696],
            [14.96041245708325, 0.3156693511478977],
            [14.96310692213139, 0.3171947874844282],
            [14.97138926284678, 0.31062815880175776],
            [14.974393247110726, 0.31118282732770103],
            [14.979305163955253, 0.30851198433925436],
            [14.98640016152046, 0.30863231791884826],
            [14.995137066199538, 0.30566349784517066],
            [15.004120189783169, 0.2995930461259312],
            [15.016315084294238, 0.29804673623457173],
            [15.01859469205809, 0.29600038401480794],
            [15.025759665939036, 0.2943826229215257],
            [15.031141544564788, 0.29128816444828837],
            [15.03469459498698, 0.29167646761342475],
            [15.044263922249009, 0.2869364245532286],
            [15.049750981884191, 0.28669968503451654],
            [15.055662707994644, 0.2888019831095149],
            [15.059838456992122, 0.2852041027516867],
            [15.063648881668684, 0.2853691112602338],
            [15.069142316113538, 0.28357190650668923],
            [15.07689025280629, 0.2840179912528055],
            [15.082998792538294, 0.28020370221764224],
            [15.094080939777944, 0.2745335155332778],
            [15.098802755906119, 0.27421921577566044],
            [15.10553499771359, 0.2771620081258159],
            [15.110785041493797, 0.2722726110782128],
            [15.1149685714612, 0.2724498758679522],
            [15.116921871819272, 0.26665370805346045],
            [15.12145232857472, 0.26565667875451054],
            [15.12593922989699, 0.2614792282941261],
            [15.129855579385113, 0.25505789465996254],
            [15.132890084501279, 0.25524263669559816],
            [15.137540351773247, 0.2519830473673658],
            [15.14203240245425, 0.25044584466732484],
            [15.1438862126853, 0.2452963126644381],
            [15.157255905902982, 0.23702305956893419],
            [15.148837499624586, 0.19745505920274367],
            [15.139157896588443, 0.1505303450522706],
            [15.136665414609057, 0.1451233534705949],
            [15.141800926738766, 0.1412473587837415],
            [15.142780328471352, 0.1369163540048938],
            [15.147792353273031, 0.1351476388027164],
            [15.147929131097195, 0.13197637955980682],
            [15.145398838724383, 0.12474293427212656],
            [15.141440818966455, 0.11991586090680341],
            [15.133638177361643, 0.12271479998117824],
            [15.126157344005419, 0.12780512866784058],
            [15.12012016366897, 0.12833544631274646],
            [15.120440102433314, 0.124731417164997],
            [15.12331906085091, 0.12072960384522662],
            [15.123014885348327, 0.1183250825516254],
            [15.122069159974659, 0.11540413092243183],
            [15.116611188006141, 0.11461007454536008],
            [15.111671991495932, 0.10992060975035405],
            [15.111043143469402, 0.10500788964199115],
            [15.113828002634715, 0.09456665913481452],
            [15.110978487471076, 0.08632435441581197],
            [15.100556632003116, 0.08292045465119699],
            [15.095342964803528, 0.08339525502120956],
            [15.084946763457909, 0.08658020968637041],
            [15.079077812550478, 0.09285813025093805],
            [15.076997707542215, 0.10016177791709331],
            [15.080111304151187, 0.1064965297515394],
            [15.080110133347109, 0.10961505190916894],
            [15.083565999146769, 0.12083707590444062],
            [15.08333835533193, 0.12554044438618686],
            [15.081466451949707, 0.13185588877362628],
            [15.076195769674182, 0.1336296654647365],
            [15.073154991113011, 0.13104480472755717],
            [15.07455104787279, 0.12558791921667356],
            [15.07468795574678, 0.11944875926309309],
            [15.071973831120598, 0.10900834787254685],
            [15.070096570812538, 0.10588442345323916],
            [15.06562985877217, 0.10267957810064846],
            [15.060085301337468, 0.10109942492275523],
            [15.046869962113561, 0.09950786810567461],
            [15.040580195208868, 0.0961215405221507],
            [15.039333491154188, 0.10322768353058233],
            [15.037336844792936, 0.10615014002853676],
            [15.032091779436715, 0.10938995398482741],
            [15.02880992606232, 0.10991182461634123],
            [15.026465535300627, 0.10753044825597513],
            [15.02577646076506, 0.09864405664220664],
            [15.019027797562897, 0.10007195535722418],
            [15.016284034186171, 0.10235758842122938],
            [15.016863050883597, 0.11054962657554543],
            [15.015831576441585, 0.11296702133292921],
            [15.007130441845886, 0.11753933957482819],
            [15.000825620006395, 0.13316796297614208],
            [14.997603390136781, 0.1304281499615424],
            [14.994287492505773, 0.13189881517207153],
            [14.99360433383626, 0.13484861157878497],
            [14.984858321301168, 0.13128474136954144],
            [14.977591494835586, 0.134851907724696],
            [14.974781531019328, 0.14048639576191962],
            [14.974924150016305, 0.14505108235416778],
            [14.97813251109038, 0.15696316241051267],
            [14.979599240216801, 0.1627866239593866],
            [14.972769938940926, 0.18038341481000453],
            [14.968690909018814, 0.20083070725036445],
            [14.966996096782271, 0.2047990442058238],
            [14.96907342065866, 0.21249336844555303],
            [14.969271394314932, 0.21846915594797878],
            [14.9677362219891, 0.22655992713577894],
            [14.972593351863365, 0.22760751460205755],
            [14.975335175150594, 0.22135142333766517],
            [14.982145471728066, 0.22031698531172073],
            [14.98756690387001, 0.2179524960516158],
            [14.986135226478533, 0.22604836114687754],
            [14.990187202742792, 0.23093796578960274],
            [14.983393572417079, 0.23742681948461852],
            [14.984679826277894, 0.2432667188212084],
            [14.988899106328237, 0.2428878513444797],
            [14.98807398336675, 0.24916145788074354],
            [14.981699841273626, 0.25008578580864294],
            [14.977688233818995, 0.2585687970597594],
            [14.97464386427266, 0.26119872224563756],
            [14.964524940110753, 0.2621664109430958],
            [14.96610231530761, 0.26794722703046914],
            [14.96236578097898, 0.26911446523776467],
            [14.959870278214478, 0.27268325048579944],
            [14.96239722736881, 0.2751603005984898],
            [14.962951967890564, 0.2789678950849115],
            [14.958670882841018, 0.2856376314798907],
            [14.957863074885696, 0.2892833690513209],
            [14.953324483531917, 0.2907212215432877],
            [14.94457265791455, 0.2885171796558534],
            [14.936743107754571, 0.29079424177485574],
            [14.93708109414063, 0.2968293526829049],
            [14.933912895029799, 0.29904473266524095],
            [14.933468725996546, 0.30264095731816915],
            [14.927014023421753, 0.30669553802816796],
            [14.921935779032642, 0.3047446980007003],
            [14.922748372533912, 0.3003824222053171],
            [14.91414624230384, 0.2979232068192705],
            [14.913512944596807, 0.3002427227224114],
            [14.905361519417594, 0.29802488423410345],
            [14.904628440390168, 0.29227781694979815],
            [14.906608468124736, 0.2866916048835655],
            [14.91252034592549, 0.27906343334680217],
            [14.906039723246888, 0.2720110016792526],
            [14.896240721973099, 0.2789789208198025],
            [14.89206963260121, 0.2715806460065418],
            [14.880427567509539, 0.27662674077176996],
            [14.878119717138485, 0.27528394189525973],
            [14.86458190327566, 0.2830329212743415],
            [14.863970984842867, 0.27509106115074294],
            [14.86081808459059, 0.27313593367925615],
            [14.85598955460607, 0.26456239664972964],
            [14.856024233495052, 0.26153841917043785],
            [14.860404900594304, 0.26056081472316195],
            [14.863963911058516, 0.2630896964778994],
            [14.866574455509799, 0.2591769148454567],
            [14.873508332377911, 0.26055289082506367],
            [14.872206300305567, 0.25102375033260277],
            [14.858199164370012, 0.24919144693890166],
            [14.849566302355122, 0.2428100958666401],
            [14.835109161121068, 0.24348420357597778],
            [14.83003763573021, 0.24197334619520974],
            [14.822322866154275, 0.23764766873441395],
            [14.814296168154488, 0.23577980389001696],
            [14.805125764978103, 0.23552765013099486],
            [14.798228039026169, 0.23415746066213644],
            [14.791298796373182, 0.2347552987278697],
            [14.779636404591868, 0.23349499742410826],
            [14.774549891887595, 0.2367696611356251],
            [14.780474451908931, 0.24038900804163463],
            [14.786872932303504, 0.24201289779536195],
            [14.790045416253392, 0.25168526662089236],
            [14.796514103373523, 0.25317885703548937],
            [14.801936557326693, 0.256089802488884],
            [14.79861851258402, 0.2629782811351731],
            [14.798263864458049, 0.26712044914496297],
            [14.793334614247245, 0.26717185697578344],
            [14.789469166009075, 0.271180297036587],
            [14.790171118954145, 0.2756527297845856],
            [14.77872287354408, 0.2774089302982378],
            [14.777355635029092, 0.28250636491083336],
            [14.774005089730665, 0.2882304227014482],
            [14.77170382210425, 0.2874542251819521],
            [14.766890128544407, 0.2897089207267119],
            [14.766567985114074, 0.2969985640084299],
            [14.760414492854316, 0.3129641309579228],
            [14.761900783613967, 0.32144788445055616],
            [14.761811611335846, 0.3298840369573881],
            [14.763192648975076, 0.33253602566628193],
            [14.762632845381589, 0.34286501156283994],
            [14.76358515148053, 0.35201428791443573],
            [14.760927079765791, 0.3615902826639528],
            [14.764361454626888, 0.3610108995738136],
            [14.766001974090123, 0.38090764626320367]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.40573766972147, "lat": 37.53794491136159 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51087"],
        "coty_name": ["Henrico"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henrico County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01480133"
      },
      "bbox": [
        14.760414492854316, 0.08292045465119699, 15.157255905902982,
        0.3973049064564194
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [13.188064598465159, -0.95694697123741],
              [13.196245749192931, -0.9646521952629936],
              [13.19787135892078, -0.967652289902197],
              [13.205169353369632, -0.96640240236822],
              [13.209699332003817, -0.9706481900655287],
              [13.226527897732392, -0.9731467778477377],
              [13.22824748231314, -0.9745336341224292],
              [13.227534299564908, -0.9797767553843524],
              [13.228520921142259, -0.9845942562161852],
              [13.239802984318196, -0.9857470413297604],
              [13.243369725052432, -0.9887687555137077],
              [13.244804288719903, -0.9847678172348586],
              [13.244440056408767, -0.9797636250228045],
              [13.250558315870087, -0.979271238093469],
              [13.25139996427321, -0.9848131224946752],
              [13.254365935148199, -0.9829557749338228],
              [13.25162433590356, -0.9777935227445592],
              [13.252926395950876, -0.9712432014655008],
              [13.246023210859311, -0.9684907612433205],
              [13.24308784020926, -0.9632468688225571],
              [13.239070845204713, -0.9639548769581875],
              [13.237277148467284, -0.9586388005322932],
              [13.236879986469157, -0.9280898157362799],
              [13.205697649986403, -0.9219660891364129],
              [13.201258308469173, -0.926618177361817],
              [13.188064598465159, -0.95694697123741]
            ]
          ],
          [
            [
              [13.061860282717939, -0.8655455038633092],
              [13.067706919034105, -0.8727734057786722],
              [13.071704252736474, -0.8756301674637295],
              [13.076917606500297, -0.87693091687124],
              [13.083412291060162, -0.8755256469787248],
              [13.085783996278554, -0.8723583167878721],
              [13.084020255109154, -0.8695152301162101],
              [13.08065128751371, -0.8707178650272577],
              [13.073565945779677, -0.8667379256902448],
              [13.075427735406267, -0.8639369535199133],
              [13.080428854255254, -0.8630431856104099],
              [13.085696116547327, -0.8663359428822885],
              [13.088332437320748, -0.8238082042367044],
              [13.0956277243804, -0.8245557399478493],
              [13.179873732005134, -0.8306939992593841],
              [13.249440639796388, -0.8357922217033257],
              [13.255752891354705, -0.8280472656339725],
              [13.259926228685647, -0.8251773435560994],
              [13.264226389022049, -0.8277146393146132],
              [13.267459619164338, -0.825928199463212],
              [13.272223397416735, -0.8269509998591564],
              [13.274684477968128, -0.8290877250648956],
              [13.277966820651892, -0.8243204499217057],
              [13.280704683366203, -0.8271273926374021],
              [13.279343767901207, -0.8304354758587668],
              [13.282140817681764, -0.8340507135020078],
              [13.285101125306234, -0.8297494785046803],
              [13.290629877262035, -0.8263364453346533],
              [13.289102498152591, -0.8216816852209962],
              [13.29194594497815, -0.8190393260805714],
              [13.292728643701862, -0.8137817575160692],
              [13.295229314095893, -0.8124277772214906],
              [13.29603580114022, -0.8077806799127348],
              [13.301249010692537, -0.8044209757074082],
              [13.308168409713694, -0.7978970718391184],
              [13.314809282314794, -0.7967481746139581],
              [13.319215776855888, -0.7919897041667954],
              [13.329951276294654, -0.7842901880768659],
              [13.333612220369403, -0.7859098416452329],
              [13.33737901686094, -0.785359309337768],
              [13.342303008005306, -0.7817389272423265],
              [13.34715324361216, -0.7823319540769246],
              [13.349769379796003, -0.7774709560073461],
              [13.354119309467274, -0.7742566399374105],
              [13.354419524543482, -0.7676466608011576],
              [13.364521358882815, -0.7503163074582613],
              [13.363635921957195, -0.8249011261889929],
              [13.362518104847512, -0.9255253536169274],
              [13.361919832262908, -0.9666860012511956],
              [13.360668910297855, -1.072829279433662],
              [13.225295999291863, -1.0952678527320863],
              [13.211715033474924, -1.0980004487285322],
              [13.115461684348237, -1.1143328304738942],
              [13.094960402618478, -1.1177649064703814],
              [13.086245113003194, -1.0508583811356575],
              [13.082566949204548, -1.0470023086328981],
              [13.083317556663273, -1.0406424466823467],
              [13.080617311480873, -1.0382679616688661],
              [13.077973696466755, -1.02913405407617],
              [13.074988590761311, -1.028625894034133],
              [13.074009152833371, -1.0169250686570477],
              [13.07168379681457, -1.0125509489851738],
              [13.071794952789435, -1.0046735266428146],
              [13.069129657413422, -0.9973193104274786],
              [13.06457706658659, -0.99572179080546],
              [13.06093903250365, -0.9908754449657461],
              [13.059430506234172, -0.98656047347368],
              [13.054170624476436, -0.9830908599297952],
              [13.051144243472775, -0.9761720241165748],
              [13.045899917351218, -0.9615647605465173],
              [13.042035802439035, -0.9590308602985903],
              [13.037775711011315, -0.9530705927376675],
              [13.032372068232597, -0.9419827790767725],
              [13.035436006933208, -0.9351248933352552],
              [13.034427117537012, -0.931923003729418],
              [13.036612757117096, -0.9280983756468445],
              [13.034660603687096, -0.9252074066248045],
              [13.028952732287713, -0.9215493095003476],
              [13.030975210994221, -0.9129077515260399],
              [13.030161194733, -0.9042293204241411],
              [13.027972657282042, -0.9031647324156634],
              [13.026563434674092, -0.8975538093733075],
              [13.023283053401872, -0.8919016242842024],
              [13.022984989001145, -0.8872895568188186],
              [13.029641021151019, -0.8809639384744763],
              [13.030883042581449, -0.8773088075955168],
              [13.035005765729965, -0.8759565243358233],
              [13.036247536847034, -0.8735718749426243],
              [13.045584382360477, -0.8726270190646418],
              [13.046464850867888, -0.868894428323238],
              [13.053028885167429, -0.8703837296621659],
              [13.054297729114586, -0.8687701944736225],
              [13.061860282717939, -0.8655455038633092]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.87399512184963,
          "lat": 36.682788036850674
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51089"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01502770"
      },
      "bbox": [
        13.022984989001145, -1.1177649064703814, 13.364521358882815,
        -0.7503163074582613
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.721811973477429, 0.3770898203594947],
            [15.725942729989805, 0.37850114629394144],
            [15.73127384003548, 0.3754378274816035],
            [15.736233216121246, 0.37591078203344913],
            [15.740557082381695, 0.37954307959876377],
            [15.741886564005728, 0.38327896998947225],
            [15.74093042249112, 0.38665463765077224],
            [15.741022830221642, 0.3956912996300038],
            [15.743147205853681, 0.403399201044241],
            [15.75098348846573, 0.4006292876750202],
            [15.757013013076282, 0.4007140598477208],
            [15.763581161704904, 0.4037946330837251],
            [15.777952411927098, 0.40328236967358155],
            [15.78211697062253, 0.38874251325357834],
            [15.785515739092155, 0.3839435641929031],
            [15.789032306850055, 0.38140930752895236],
            [15.794579025992965, 0.38166168750612206],
            [15.801838588250579, 0.38356781522713956],
            [15.806171819217953, 0.3798663797444571],
            [15.811422175008682, 0.37050738914503517],
            [15.815693933755018, 0.36680574633994406],
            [15.820323787588476, 0.3675244951594606],
            [15.821859863455298, 0.3753269730687524],
            [15.823772387415003, 0.3775769231584106],
            [15.830865793776896, 0.39220685628381263],
            [15.830951868652878, 0.39673629118431797],
            [15.829154181076381, 0.40068069997761147],
            [15.832045367738148, 0.4023980849089571],
            [15.836715768839234, 0.40092377015288044],
            [15.843501557081463, 0.39585403350284964],
            [15.8523952890455, 0.38293712144048525],
            [15.854986546806328, 0.3761654391483607],
            [15.848035069741137, 0.37382573132961877],
            [15.837152700560162, 0.3774712243377419],
            [15.837302338872082, 0.38129794906927605],
            [15.829418191650282, 0.37886075039437056],
            [15.82626543251217, 0.3788789546530475],
            [15.824489755822762, 0.3746146385926239],
            [15.82602438184817, 0.3723101257073543],
            [15.831611550802148, 0.37251167632871435],
            [15.83409904540599, 0.3688505524420025],
            [15.838595211795514, 0.3688313970934844],
            [15.841280558254436, 0.3664688686369185],
            [15.851570603538786, 0.36337895384600943],
            [15.852501157254407, 0.3544259577931853],
            [15.860304520189962, 0.3522725537764696],
            [15.86471428331065, 0.3476526727695712],
            [15.870068742348822, 0.3489758296003076],
            [15.874171771625392, 0.34536185134051567],
            [15.875327134009638, 0.33625890855759816],
            [15.88034665629781, 0.33011179467285756],
            [15.884001345270741, 0.3154945822267294],
            [15.887133358956447, 0.31009827854110844],
            [15.886817011930722, 0.30712657590546943],
            [15.889350191842636, 0.3005493563930112],
            [15.892611946541425, 0.289156823290234],
            [15.89597124952092, 0.2737828786879629],
            [15.893091928086857, 0.26557744065868893],
            [15.890543148263697, 0.2555091056653793],
            [15.887265304937838, 0.24984654804858958],
            [15.88208360250936, 0.2468687238312243],
            [15.8813084698967, 0.24056354145597258],
            [15.88596206767709, 0.2281699243634342],
            [15.883249373368022, 0.22634801809300326],
            [15.88508952548244, 0.22215278497051028],
            [15.887966902906182, 0.22124490900135182],
            [15.889054705470175, 0.21315264451652655],
            [15.888938452114248, 0.20482232115322252],
            [15.8868831274803, 0.2013681559949122],
            [15.883697513323039, 0.20738523690814767],
            [15.87380023915582, 0.21268033434783284],
            [15.87128813410586, 0.21135113837151812],
            [15.868610132220745, 0.21466352192579446],
            [15.859399941485723, 0.21505585791359672],
            [15.8549152559434, 0.22311287522725243],
            [15.853005437814591, 0.224195290822881],
            [15.85205015558408, 0.23011943638940274],
            [15.847042131801622, 0.22766912930142288],
            [15.84590941586366, 0.23204645324854226],
            [15.842514215791851, 0.23210614750648528],
            [15.83142474716328, 0.24199315649399278],
            [15.829342038428235, 0.24630629932770953],
            [15.819816910304096, 0.25025171716243344],
            [15.815193415759097, 0.24723613381588092],
            [15.811257550062496, 0.2477748811553589],
            [15.808506662229583, 0.25041410425090393],
            [15.805223006832788, 0.25024795727970367],
            [15.80093290757607, 0.25554954257173124],
            [15.798563312448865, 0.2548519379955032],
            [15.788935286209961, 0.2569922818097634],
            [15.78294190287348, 0.26187093993342114],
            [15.77634346167485, 0.2726109584996539],
            [15.771651591828999, 0.286820200153149],
            [15.767510455463484, 0.2879016869309105],
            [15.760673958867535, 0.2858882783128419],
            [15.760338134730377, 0.2811866333927736],
            [15.736063060609697, 0.28122113770972423],
            [15.733278554550393, 0.28221313747296767],
            [15.730134374041286, 0.28973500217277964],
            [15.729849835205236, 0.29850959949672334],
            [15.732184128275627, 0.30162713556582793],
            [15.729508108184374, 0.3046584015067883],
            [15.730083709646406, 0.3075770645198344],
            [15.726813559801577, 0.3115860519576355],
            [15.730999802616699, 0.3147280365506154],
            [15.728039502066858, 0.321977709358333],
            [15.726306861138221, 0.32232271488675057],
            [15.723748239642557, 0.3285886359860619],
            [15.72293874246095, 0.3346532467773105],
            [15.720057695458705, 0.3392685190480493],
            [15.719810068433569, 0.3424290207575881],
            [15.716979406837176, 0.34538068757771057],
            [15.717806162421166, 0.3498938223565601],
            [15.720462843341862, 0.3535066759586802],
            [15.724190784455844, 0.37248029358244794],
            [15.721811973477429, 0.3770898203594947]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.34378718796191, "lat": 37.43529093523363 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51115"],
        "coty_name": ["Mathews"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mathews County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01480145"
      },
      "bbox": [
        15.716979406837176, 0.2013681559949122, 15.89597124952092,
        0.4037946330837251
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.996994002843797, 1.5721137715911926],
            [14.092266964938721, 1.5990289968206843],
            [14.091867255831236, 1.6025516430227016],
            [14.099022655795945, 1.6007333185643695],
            [14.108449819806012, 1.6033583218241179],
            [14.109117056941908, 1.6072879885192821],
            [14.113934218507294, 1.6184622344396407],
            [14.114457397300257, 1.6237350579080778],
            [14.160220487582713, 1.60808708365974],
            [14.18996835584726, 1.62060200689145],
            [14.190426575102704, 1.6170121065511827],
            [14.20208478640001, 1.6119750863588653],
            [14.203860206051663, 1.6094856559716564],
            [14.209687705447516, 1.6059450722691342],
            [14.236639445105732, 1.588280711731253],
            [14.230442617891377, 1.5790044840332578],
            [14.229461314176374, 1.5732243154723022],
            [14.227734083719703, 1.570837443675476],
            [14.226028593759068, 1.5629478156641419],
            [14.22420360883264, 1.5615566321524175],
            [14.223537447398705, 1.5556848546625093],
            [14.220825556048863, 1.555717952099645],
            [14.21809003034311, 1.5516167242853605],
            [14.217500745774506, 1.5439162869044483],
            [14.216301164227271, 1.541905110672394],
            [14.209255920325504, 1.538104839682265],
            [14.204093955546455, 1.5339200170545901],
            [14.200928883830723, 1.5276599865733171],
            [14.202166170276628, 1.5246861120013242],
            [14.195762245568059, 1.5110366328557607],
            [14.196615583292859, 1.50647272257779],
            [14.199704535045747, 1.5032930662414519],
            [14.208197648532098, 1.5014667997086604],
            [14.209580669946563, 1.4931772533578476],
            [14.205424268288317, 1.4929150003333689],
            [14.201302939890601, 1.4906898311212504],
            [14.201764880258605, 1.4861950222929166],
            [14.188090182770212, 1.482562559842724],
            [14.186953663982116, 1.4764396766504646],
            [14.181894450792884, 1.4746937052388467],
            [14.17374877537418, 1.474357872349586],
            [14.172900112476855, 1.4707295237031033],
            [14.164440564576383, 1.4650497179288362],
            [14.162192387925662, 1.4616280062855882],
            [14.162773416761087, 1.45645115112184],
            [14.163692109850395, 1.4545113469159348],
            [14.157913447883706, 1.4501512871031603],
            [14.154467100999861, 1.4489464829470424],
            [14.155840941678854, 1.4456649445819976],
            [14.148031431147457, 1.442880256694363],
            [14.150102165945176, 1.4370832997048937],
            [14.146575176465142, 1.4329652845100118],
            [14.143578847279233, 1.4235717232166463],
            [14.139845439448116, 1.4200674332489487],
            [14.138880253186471, 1.4153492360501143],
            [14.14031678570356, 1.412945413929541],
            [14.14092075765508, 1.4056327773581554],
            [14.13450240422586, 1.403493504827483],
            [14.135605702139319, 1.400912323952733],
            [14.135318442300976, 1.3772314048764136],
            [14.129758967788911, 1.3704702399570798],
            [14.129514593227134, 1.364490669129837],
            [14.126086003845622, 1.3588622673144721],
            [14.122146185859483, 1.3555927572066928],
            [14.117009948003705, 1.3552027794920354],
            [14.113215067897691, 1.352696880151822],
            [14.10962421542211, 1.346994681255375],
            [14.105234083642447, 1.3472450512329748],
            [14.102204425993646, 1.34490307133398],
            [14.099661766997563, 1.3386970599499124],
            [14.095657288733634, 1.3393507474412076],
            [14.09002315809764, 1.3318902975135618],
            [14.086593462391926, 1.3337903048824173],
            [14.080842402786717, 1.3317954308130318],
            [14.075652569101624, 1.3341249019131125],
            [14.069272041420318, 1.3332839465572306],
            [14.065665201601414, 1.3296248337646703],
            [14.059175514277888, 1.3379681829481376],
            [14.059199624710635, 1.3455238393543467],
            [14.05747784809503, 1.3497129325134158],
            [14.052298823317171, 1.3522973395552582],
            [14.032379171780695, 1.3543969282700568],
            [14.027475742475014, 1.3557096681309764],
            [14.01914385066629, 1.3604445703801982],
            [14.015650234612663, 1.3652449927394867],
            [14.011638020373322, 1.367409080465642],
            [14.007395813717405, 1.3673804609681335],
            [13.970449737940243, 1.3769270668145506],
            [13.976615755430121, 1.3882188574652443],
            [13.98217875538552, 1.4016495875737083],
            [13.989217213960048, 1.415453493279908],
            [13.996280821653302, 1.4265261858051204],
            [13.999054555035956, 1.428638071952438],
            [14.001818051591988, 1.4341127849073858],
            [14.005260751951912, 1.4436941574984856],
            [14.00547808943063, 1.4513711780379224],
            [14.000470461290003, 1.4525641081658403],
            [14.006305181937792, 1.4673433334680421],
            [14.008178784067645, 1.4821001612287978],
            [14.015209031874488, 1.4898319533540678],
            [14.016328734999858, 1.4926576575014578],
            [14.017361518998353, 1.5045443032477333],
            [14.019369387793805, 1.5101831034000808],
            [14.01250709304328, 1.518173509862072],
            [14.009164316371072, 1.5145493814789273],
            [14.004387113473797, 1.516135838066545],
            [13.991811025765553, 1.5134215961571118],
            [13.992931495787744, 1.5236454991140191],
            [13.986054412644581, 1.5376569522211896],
            [13.983564984467236, 1.5401919744368533],
            [13.98581446833283, 1.5431852615414943],
            [13.989225324439676, 1.5422531104179518],
            [13.995999946242218, 1.5371904912276777],
            [13.998865800005339, 1.5410827762309567],
            [13.998129204874594, 1.5449618598334085],
            [13.999884180535945, 1.5473162993307443],
            [13.98786616436287, 1.555031000041246],
            [13.988126214607592, 1.557495348196832],
            [13.983900721710025, 1.5609793027264367],
            [13.98964845398528, 1.5623670612177902],
            [13.992823531693874, 1.568878669117672],
            [13.996994002843797, 1.5721137715911926]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.20843440999592,
          "lat": 38.908711349060056
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51187"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "01674058"
      },
      "bbox": [
        13.970449737940243, 1.3296248337646703, 14.236639445105732,
        1.6237350579080778
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.41177539114486, 0.1644499689019899],
            [13.411871607993753, 0.16772688815392103],
            [13.41981127429406, 0.171193273088391],
            [13.423527333654597, 0.1708463622402185],
            [13.424042722775551, 0.1768484124053441],
            [13.427711287369789, 0.1816680174211133],
            [13.43416670492606, 0.18313342471577448],
            [13.43746356601663, 0.1912280232270276],
            [13.444482648387506, 0.18853830557710494],
            [13.446989418685385, 0.19060795199335692],
            [13.449540536127474, 0.17515682060722443],
            [13.447330445294122, 0.17416528448983584],
            [13.449256764704336, 0.16854919016498535],
            [13.446567766071784, 0.1667713958810282],
            [13.44449279496081, 0.1591769468477334],
            [13.437356186595473, 0.14364555580581295],
            [13.434115536096378, 0.12969253726055172],
            [13.426888818557117, 0.12131939804676636],
            [13.422827496169425, 0.1271727933331895],
            [13.417535355614977, 0.13077333766187801],
            [13.421423420469221, 0.13629740773668356],
            [13.41887039910053, 0.14307371944898],
            [13.422765431843638, 0.1533851373263554],
            [13.417192349959288, 0.1524350004621098],
            [13.416109900170131, 0.1585472416881319],
            [13.416885595423242, 0.16376139098264966],
            [13.41177539114486, 0.1644499689019899]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.35708550620468,
          "lat": 37.731976984123364
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51530"],
        "coty_name": ["Buena Vista"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Buena Vista city"],
        "coty_fp_code": "530",
        "coty_gnis_code": "01498417"
      },
      "bbox": [
        13.41177539114486, 0.12131939804676636, 13.449540536127474,
        0.1912280232270276
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.001524390806901, -0.06945383378184555],
            [15.012007880930675, -0.06535867871501264],
            [15.01459369486591, -0.06114959318420868],
            [15.02344428369965, -0.05467667760575076],
            [15.028466614311924, -0.05315166357087943],
            [15.032555372464671, -0.048611951768839486],
            [15.033711349364697, -0.04662564775110261],
            [15.038845834898911, -0.04660109881496596],
            [15.04757343473488, -0.044027904458805056],
            [15.051873429426063, -0.03705656300487964],
            [15.057563051257285, -0.037314721994703856],
            [15.065057192345929, -0.04079248345666427],
            [15.064632807605216, -0.04285237111764395],
            [15.075322140454578, -0.053607293892320884],
            [15.07572386254914, -0.05876349589180994],
            [15.08000531104982, -0.05879057465826432],
            [15.081613693878312, -0.06600270845886222],
            [15.0876357031166, -0.06583058326601571],
            [15.097562272654327, -0.07672692616271541],
            [15.090347789488721, -0.08557688933866725],
            [15.091324424627423, -0.0916524166928654],
            [15.087859803741026, -0.09376929932102078],
            [15.089853022606661, -0.1023090926083778],
            [15.085958057596242, -0.10481400110918256],
            [15.075061301406315, -0.10768224301407216],
            [15.074313429705656, -0.10454062287152784],
            [15.069072572036037, -0.10407731068340832],
            [15.065333464954508, -0.10528180448914262],
            [15.06457843540339, -0.10072816780892456],
            [15.05920779105169, -0.10735595659392348],
            [15.049067835103138, -0.11378926004348741],
            [15.044527287141287, -0.11400060426495372],
            [15.040385327450506, -0.11976846423940118],
            [15.031411156120068, -0.12321124198959434],
            [15.029557770250827, -0.11515409525547919],
            [15.03161162413424, -0.11443144305932787],
            [15.02866630697701, -0.1071977916153957],
            [15.023944468677385, -0.10418090045670367],
            [15.006796906716945, -0.10342996843996069],
            [15.00834633145311, -0.09498501480905537],
            [15.006797665860718, -0.08770224608385847],
            [15.008307121110366, -0.0809870667892866],
            [15.006306878484754, -0.07575956217255014],
            [15.002967511302593, -0.07653312085489594],
            [15.001524390806901, -0.06945383378184555]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.39111891417507,
          "lat": 37.204262381161726
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51730"],
        "coty_name": ["Petersburg"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Petersburg city"],
        "coty_fp_code": "730",
        "coty_gnis_code": "01498435"
      },
      "bbox": [
        15.001524390806901, -0.12321124198959434, 15.097562272654327,
        -0.03705656300487964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.544386302499655, 0.6114145525184848],
            [13.54391799578599, 0.6136038877649951],
            [13.547031264907886, 0.6304740680138876],
            [13.54903742514886, 0.6390295886303194],
            [13.553625405117797, 0.6470675165629346],
            [13.561500311176912, 0.6509736134408995],
            [13.565490098365618, 0.6489213063546079],
            [13.575081778994674, 0.6519744453810913],
            [13.57930192698939, 0.6522553650673953],
            [13.590677046755575, 0.6575916982605532],
            [13.597306469849038, 0.6679961221606512],
            [13.60457497093267, 0.666080874226539],
            [13.605414760051975, 0.6624236924416744],
            [13.609122086669847, 0.6607176439303759],
            [13.617570170223443, 0.6539229029900807],
            [13.610676636057645, 0.6525341876941418],
            [13.608609021637657, 0.6469391717748181],
            [13.61870678052281, 0.6403199955273428],
            [13.619592843394974, 0.638336533875819],
            [13.61826696967495, 0.6288836832146683],
            [13.617553115926835, 0.6149158143183766],
            [13.614181934398877, 0.6065807560382428],
            [13.611575136609101, 0.6026626592004708],
            [13.598974083887622, 0.5884272226565272],
            [13.581785309616128, 0.5954330953689151],
            [13.58102535458874, 0.5929323835316819],
            [13.576758730900467, 0.5898477896177308],
            [13.569762293002185, 0.5891062486439113],
            [13.565013661452806, 0.5935504325724645],
            [13.553784467897776, 0.59830252084727],
            [13.550417778898003, 0.6022251808550614],
            [13.544386302499655, 0.6114145525184848]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.06113992746239, "lat": 38.15924670184439 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51790"],
        "coty_name": ["Staunton"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Staunton city"],
        "coty_fp_code": "790",
        "coty_gnis_code": "01789075"
      },
      "bbox": [
        13.54391799578599, 0.5884272226565272, 13.619592843394974,
        0.6679961221606512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.9007431707393, 0.4483563891586745],
            [11.929035962259219, 0.47249192107857113],
            [11.992801460476588, 0.5265418514583725],
            [12.041194738616687, 0.5678247481563171],
            [12.04898189269386, 0.5729451467815871],
            [12.058196746538458, 0.5806002724785221],
            [12.061390115518185, 0.5847309164101954],
            [12.122463731104247, 0.6379455705117566],
            [12.184156907233792, 0.7130344377963354],
            [12.175598940955403, 0.7278108845716416],
            [12.14459087887175, 0.7287080230677474],
            [12.141946751906126, 0.7322737424001231],
            [12.138153862180783, 0.7304366696976565],
            [12.13316063894407, 0.730889107553481],
            [12.130759103212505, 0.7335880176954811],
            [12.19602632837773, 0.7957795770046814],
            [12.200501111013315, 0.7951030296510662],
            [12.202714383724548, 0.7882060764193473],
            [12.209393310439664, 0.7845609837904903],
            [12.213734578539526, 0.7851870090297255],
            [12.217731183506864, 0.7828456576453067],
            [12.218017642262783, 0.7792262799877098],
            [12.220812557703802, 0.7764237514399924],
            [12.22554958698119, 0.775180276245056],
            [12.227527826959292, 0.7682087247671969],
            [12.233181750411141, 0.7705456071904403],
            [12.23684472733285, 0.7679137360932452],
            [12.23704423017647, 0.7768662346964651],
            [12.241425223526784, 0.7794211821294416],
            [12.244501151665256, 0.7777194963674556],
            [12.246432951460184, 0.7820248446700239],
            [12.250690366161805, 0.778719814122397],
            [12.25208428627104, 0.7836490412181983],
            [12.255735525468362, 0.7844101132237747],
            [12.257101805101527, 0.7817892007346046],
            [12.264882942572902, 0.7822645384171946],
            [12.271750936089274, 0.7845737396567241],
            [12.2742017903157, 0.7819911613015378],
            [12.282295142509055, 0.7846805459111524],
            [12.284504888544664, 0.7820631330926561],
            [12.289849494677185, 0.780026327720732],
            [12.2978474800504, 0.7793936326617333],
            [12.303881806925551, 0.7815650682499654],
            [12.286592861597644, 0.7551226537987925],
            [12.289107215769933, 0.7520657593271401],
            [12.328215139143827, 0.6807556957747495],
            [12.314070617720162, 0.6665199278457222],
            [12.34057022114526, 0.632774094209519],
            [12.341766752566562, 0.6327687069434564],
            [12.351206736345379, 0.6131144020451241],
            [12.358940783742632, 0.6272589195399819],
            [12.362744801614301, 0.6194855363033863],
            [12.456319549957788, 0.5755939172256039],
            [12.458133234828331, 0.5749631696308852],
            [12.51037605080728, 0.5501657588546301],
            [12.495444184700675, 0.5297320621510424],
            [12.463698676686926, 0.4894545298288838],
            [12.407474102888143, 0.42045690941827313],
            [12.383523816444317, 0.3916748183026929],
            [12.343426727384296, 0.342614663154579],
            [12.329468940168391, 0.32796668342997226],
            [12.299185277239882, 0.33040121586649823],
            [12.253873246508329, 0.3307831771639278],
            [12.194580219377823, 0.3310889102802144],
            [12.197843136441932, 0.3367475035398998],
            [12.195722760312227, 0.3414339478546663],
            [12.1896198059417, 0.3440324067761945],
            [12.18739157572783, 0.34846543426146354],
            [12.187861147913168, 0.353025298026007],
            [12.190118413266628, 0.35868088733413395],
            [12.186490454998742, 0.3635837704750822],
            [12.182042542060135, 0.3593351215580718],
            [12.181507122157678, 0.3551554537094768],
            [12.176919405522668, 0.34774622444605396],
            [12.172787133249296, 0.35335943488676097],
            [12.168119324911732, 0.35696544577509387],
            [12.168184745623611, 0.36737948651944485],
            [12.15968058494995, 0.36435844765239345],
            [12.15231957552961, 0.37274054891184116],
            [12.14320163931399, 0.37406238690720806],
            [12.13799400390084, 0.3804437969803874],
            [12.137704998056137, 0.3832547767175143],
            [12.13230158245438, 0.38714069347306973],
            [12.134318208071395, 0.39222087895227914],
            [12.130086085530982, 0.39661093006065545],
            [12.134438054363937, 0.3988684881807583],
            [12.131926436483946, 0.40290128494033],
            [12.130795623915077, 0.40919163453518215],
            [12.132586389533193, 0.41345453156216616],
            [12.129539740748044, 0.4163342690287644],
            [12.120805256439267, 0.42067439137358187],
            [12.116489895478344, 0.41799793617952075],
            [12.114077002090447, 0.42018578459495914],
            [12.113372352707781, 0.42544793396125463],
            [12.110180523713916, 0.4316273653763022],
            [12.097723792807752, 0.43738134320976113],
            [12.089170326218028, 0.43624202776874715],
            [12.079321239619098, 0.43324939656837225],
            [12.077498018970648, 0.4273071731969261],
            [12.078021198071756, 0.42341293744373976],
            [12.081947137512044, 0.4175834241066717],
            [12.077670697600428, 0.41500869304157323],
            [12.073067607788014, 0.41589552692801723],
            [12.071678200583634, 0.42302110361870393],
            [12.066604116383969, 0.4269160826980782],
            [12.061830432949186, 0.4268398119249316],
            [12.058926185112497, 0.428465451325796],
            [12.060098141416146, 0.43442932984500077],
            [12.062920161726009, 0.4403864511035132],
            [12.061599499035658, 0.4454872450151136],
            [12.05591345167169, 0.4485063317660439],
            [12.052478674680444, 0.44589884380308975],
            [12.05470192274616, 0.44304643684844164],
            [12.054628101150023, 0.4366148973465647],
            [12.048567104392596, 0.4302752131327142],
            [12.04073783833741, 0.4286185855399054],
            [12.040453499484068, 0.4249910411601704],
            [12.04545713184818, 0.4234614305693407],
            [12.047524448832966, 0.4199235522104993],
            [12.042567885374565, 0.41636898601725686],
            [12.036649715095914, 0.41670293620320337],
            [12.03254927908463, 0.41332057492091695],
            [12.033267352161387, 0.40949815122313604],
            [12.037284438546953, 0.4067994565518839],
            [12.036877896501384, 0.4019451810711095],
            [12.034406394981639, 0.40020212886490336],
            [12.027232582925105, 0.40062239053429627],
            [12.024428914000449, 0.4021722896303178],
            [12.023099753808843, 0.40668320703474764],
            [12.014737235364077, 0.4061374572929309],
            [12.00741849937245, 0.4110419619827134],
            [12.00172290930222, 0.41231965326908393],
            [11.996826814336513, 0.41866269743773143],
            [11.98987870179077, 0.4227325684563022],
            [11.985839162762304, 0.4281440043930847],
            [11.980505583742552, 0.43176799081608963],
            [11.972200533858071, 0.4310128068763601],
            [11.967212104982512, 0.420654656119554],
            [11.962547265221286, 0.41957153391317026],
            [11.953031589937058, 0.42381787897317147],
            [11.946111815816852, 0.42452770270671225],
            [11.934515437026478, 0.4193211243036202],
            [11.93423191683485, 0.4227407120531489],
            [11.939968739775036, 0.4266655061701177],
            [11.934415323620424, 0.42975907862892215],
            [11.934497204910544, 0.4350166710822017],
            [11.933063600145923, 0.43876055465862884],
            [11.923927845838751, 0.4368304697886844],
            [11.919091740965104, 0.43832751056537067],
            [11.915792411590118, 0.4414508161578176],
            [11.911034563538847, 0.44027854708997466],
            [11.909592873526654, 0.4475364603921347],
            [11.905209586951376, 0.4488333537482393],
            [11.900619568241787, 0.44813056451107314],
            [11.9007431707393, 0.4483563891586745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.79934377198103, "lat": 38.29164770195358 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54067"],
        "coty_name": ["Nicholas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nicholas County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01550040"
      },
      "bbox": [
        11.900619568241787, 0.32796668342997226, 12.51037605080728,
        0.7957795770046814
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.062385239391892, 1.0502235917602536],
            [13.064406880188399, 1.0552891572581837],
            [13.068338055951376, 1.0537127012867424],
            [13.070973693279306, 1.055281319381749],
            [13.080560244705737, 1.0528866550658695],
            [13.085494770809438, 1.0528488141753716],
            [13.08722085574509, 1.05591459555254],
            [13.08202202246591, 1.0627600233979364],
            [13.080495980502969, 1.0773565493792836],
            [13.08740197592291, 1.0805065603774764],
            [13.087171637523147, 1.084975508035011],
            [13.0907925716754, 1.0916534156429696],
            [13.093778151575581, 1.0943264387310456],
            [13.093885104248274, 1.0986482918200575],
            [13.096286630098412, 1.1067433200597558],
            [13.100406869190415, 1.1064409473597265],
            [13.103317590919616, 1.1117096413102618],
            [13.102134180127848, 1.1184236143501587],
            [13.104752133368068, 1.1276012761503864],
            [13.107961526932723, 1.1289820113509428],
            [13.111697761798542, 1.1336320504632822],
            [13.111753265604193, 1.143172853528696],
            [13.117366956730072, 1.1442572130828954],
            [13.12023944566881, 1.152036369860243],
            [13.121189218051741, 1.1618363589271345],
            [13.123262891074429, 1.1683486023335072],
            [13.12741013498489, 1.1777863344836326],
            [13.13097644670767, 1.1815882721966504],
            [13.130101630069523, 1.1888141616796244],
            [13.131837548612868, 1.1945359227934211],
            [13.12912817132168, 1.201966012157876],
            [13.121791623510614, 1.2080596902746226],
            [13.11213372270808, 1.21256381893022],
            [13.109275924284317, 1.2173507441802867],
            [13.10914514856727, 1.2210817950683293],
            [13.112392652747259, 1.2290659187200816],
            [13.098359350683365, 1.2380850392327625],
            [13.103203728356993, 1.2462086346689918],
            [13.103184818071366, 1.2498946209760244],
            [13.107864082036695, 1.2549153881174957],
            [13.113923667647924, 1.267249641541718],
            [13.11439968119846, 1.2761455126235424],
            [13.110378437559508, 1.2794378127321855],
            [13.105524899051966, 1.2852489973872012],
            [13.10443858466301, 1.2910025965058438],
            [13.109936627991106, 1.2940152160735336],
            [13.122183114095302, 1.2938047116050269],
            [13.125819602793145, 1.2913679804297018],
            [13.133434459754758, 1.290346931416294],
            [13.135398849047414, 1.2938688409628918],
            [13.140394666520042, 1.2975132196251338],
            [13.145423076258941, 1.2982940390402709],
            [13.149711140262347, 1.3028397287866],
            [13.158816905404244, 1.3080280774219106],
            [13.158117288803577, 1.3133371054299137],
            [13.15406004039335, 1.3172889077905416],
            [13.153280959411251, 1.3208538702865855],
            [13.149432413879623, 1.3240051599006346],
            [13.146193647913735, 1.331738432063159],
            [13.14640514652887, 1.3372075134723531],
            [13.150794688877616, 1.338491802986326],
            [13.15511502192516, 1.3415065437797837],
            [13.17022129517905, 1.3405786056051687],
            [13.177816034668204, 1.3356644993956563],
            [13.19285332401824, 1.3378037362684179],
            [13.19718985123366, 1.3393890615089195],
            [13.20825287271319, 1.3387801175471725],
            [13.213695981713697, 1.343842150497633],
            [13.213656231864512, 1.3507029626137106],
            [13.215185417049074, 1.3517933347881839],
            [13.219021785174455, 1.3641573730277723],
            [13.21889062945642, 1.374179731713946],
            [13.2216756727219, 1.3787716756802335],
            [13.246231903482418, 1.3629272288706036],
            [13.28304859440354, 1.3410968511182404],
            [13.338770190649118, 1.3085802071057782],
            [13.410823391783374, 1.2646445236290318],
            [13.478636826459523, 1.2235723755678634],
            [13.476665326485824, 1.2183962855002457],
            [13.4694934001219, 1.2076683619758917],
            [13.469470887391992, 1.2021264165809975],
            [13.466384667125268, 1.1939807788775267],
            [13.463215629680452, 1.1784353463614485],
            [13.464480625981164, 1.1744583998639757],
            [13.462213150022729, 1.159998417755943],
            [13.465485741664656, 1.1505346565013876],
            [13.471427131892217, 1.1454496091399082],
            [13.47103403352138, 1.1323520092100525],
            [13.468711423469394, 1.1260856769604375],
            [13.46970791359885, 1.1174465313620874],
            [13.460097021630693, 1.1123347338857923],
            [13.455514154251748, 1.1151017300082886],
            [13.452327831263005, 1.1135983599115145],
            [13.448803021312276, 1.1144088741647873],
            [13.446641644789045, 1.1098167583384873],
            [13.44182936609619, 1.1059790750044622],
            [13.439589975103951, 1.0899873578831707],
            [13.436348072802454, 1.0857138774851558],
            [13.434769657189163, 1.0766124196444424],
            [13.43225655617626, 1.0708277738669527],
            [13.430807597427137, 1.0609343281871135],
            [13.432405810572087, 1.0563928027008775],
            [13.429691657607826, 1.0504718718780028],
            [13.431657452816289, 1.041695543309815],
            [13.429636468391502, 1.031897759332158],
            [13.426931622622256, 1.026798271887679],
            [13.425432913551104, 1.0193516550136892],
            [13.426588947884389, 1.0159687357917322],
            [13.422706674426152, 1.0126076098136434],
            [13.420500727398458, 1.006469592593565],
            [13.41955426162987, 0.9976851064634653],
            [13.414003951426084, 0.9873610375951992],
            [13.410495293201068, 0.9717604017082324],
            [13.40772530095281, 0.9678813053702161],
            [13.40686963595927, 0.950191861516614],
            [13.410613397047065, 0.9468602884143328],
            [13.40972501060498, 0.9358210546661855],
            [13.402904795160197, 0.9263214197270515],
            [13.40399756796448, 0.9221606609397814],
            [13.40196171769228, 0.9187933795513068],
            [13.391326074600286, 0.9088777873284561],
            [13.390801904451452, 0.9031345965273893],
            [13.392131107255436, 0.892947590527539],
            [13.388696661718026, 0.8914395259352357],
            [13.383878775128661, 0.8931701416457339],
            [13.381598472939237, 0.8869576369858801],
            [13.379108934686549, 0.8843876410255568],
            [13.376019112694067, 0.8738288062675262],
            [13.370936298588484, 0.8708892587569782],
            [13.365477202292595, 0.8651092891836987],
            [13.36915359570453, 0.8580980781961844],
            [13.36771215051647, 0.8516088910845501],
            [13.361468178178985, 0.8532294273331109],
            [13.355207200723628, 0.8460991249047388],
            [13.351659302747187, 0.8461082559133484],
            [13.346421554592625, 0.8414513963989656],
            [13.299383771232199, 0.8488805170827454],
            [13.212902240164583, 0.8643846088484343],
            [13.18817243258317, 0.9015531355698745],
            [13.165299868704752, 0.93464927849282],
            [13.155814042382527, 0.9421101275191389],
            [13.150589452314414, 0.9494982569838482],
            [13.145840759763562, 0.9510250515433939],
            [13.134781803560937, 0.9562663880357599],
            [13.121843878264475, 0.9569789540230261],
            [13.057961738989155, 0.9749568292812449],
            [13.058983511934075, 0.9812828075239876],
            [13.061795609490439, 0.9845383105268484],
            [13.060650604407654, 0.9869718875486786],
            [13.066295700982845, 0.9916863967330803],
            [13.071901384011245, 0.9941862137518509],
            [13.070768902811917, 0.9979858129635784],
            [13.074258154238048, 1.0011661048433655],
            [13.075275834018138, 1.0099513553057788],
            [13.067918931843279, 1.012554095961391],
            [13.0678640060677, 1.0160287288489076],
            [13.065121001184767, 1.0200594976025297],
            [13.06144766308843, 1.0214640192775966],
            [13.063144502165855, 1.0300657044597608],
            [13.066632798369383, 1.03302944650683],
            [13.069372371811935, 1.0443143040093714],
            [13.066602270051193, 1.0480880290302155],
            [13.062385239391892, 1.0502235917602536]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.35087823519953,
          "lat": 38.680729891729584
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54071"],
        "coty_name": ["Pendleton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pendleton County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01550042"
      },
      "bbox": [
        13.057961738989155, 0.8414513963989656, 13.478636826459523,
        1.3787716756802335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.147352184274197, 6.172562237767023],
              [6.152012474324549, 6.168485635577443],
              [6.156164113351361, 6.157028753870187],
              [6.154540692420154, 6.155199043329063],
              [6.151037833501238, 6.16556854454178],
              [6.147352184274197, 6.172562237767023]
            ]
          ],
          [
            [
              [6.139611146702334, 6.244479176331536],
              [6.142155459755582, 6.2450920837717785],
              [6.142917570481035, 6.2398201767931365],
              [6.148394671851954, 6.229759888854231],
              [6.150570303054504, 6.223269098639351],
              [6.148338366586174, 6.222676505001695],
              [6.147192382356718, 6.228160124320703],
              [6.144698483584017, 6.231035901881994],
              [6.139995865155876, 6.240923454313921],
              [6.139611146702334, 6.244479176331536]
            ]
          ],
          [
            [
              [5.961833140336556, 6.232207022306813],
              [5.970133680108287, 6.232809542522549],
              [5.970566972007566, 6.225651121640211],
              [6.005682328786932, 6.229815524387962],
              [6.040908344579301, 6.235981736330563],
              [6.086121881239736, 6.240186471998936],
              [6.137069326260792, 6.2447346811940365],
              [6.1381633229390715, 6.2443488692921685],
              [6.13327984826514, 6.230775316821304],
              [6.132283045001962, 6.222198566675187],
              [6.1332308726916045, 6.21265372003925],
              [6.130525112712319, 6.212350961761378],
              [6.126509101206209, 6.201057113746345],
              [6.1305744389072485, 6.201675548252569],
              [6.131476462046446, 6.194329847299808],
              [6.128550220309317, 6.188470149685341],
              [6.130509055280312, 6.168966567419396],
              [6.129202900877633, 6.158496762105359],
              [6.130803257359273, 6.152069230883334],
              [6.126795023000076, 6.150613646805723],
              [6.127321613966621, 6.146616295984152],
              [6.121728704994206, 6.144879430192137],
              [6.115219382725763, 6.141291325200014],
              [6.107844379483713, 6.129406554262611],
              [6.114573302193799, 6.124581918115922],
              [6.120237415872537, 6.124535775700221],
              [6.130850424254715, 6.115654068894419],
              [6.143596624842768, 6.106263083366558],
              [6.149073026975542, 6.1051311037321225],
              [6.166784961131988, 6.099838947475342],
              [6.177929749194544, 6.099387765996579],
              [6.1858973188208655, 6.100851736543982],
              [6.19584854390118, 6.107995608678677],
              [6.199349680147804, 6.115908751784724],
              [6.203320922278452, 6.12073274418235],
              [6.212752105748467, 6.142370971693482],
              [6.213928441410472, 6.147682147193609],
              [6.205458618683932, 6.1532344672724255],
              [6.212029786708312, 6.157551971614097],
              [6.220440387639859, 6.166389310614059],
              [6.219910832624379, 6.168391589111622],
              [6.224084024188346, 6.172228230709425],
              [6.224527680007207, 6.177755734312687],
              [6.231900413870996, 6.181376236061677],
              [6.233651306841804, 6.183665777863396],
              [6.23509092639655, 6.19084026063597],
              [6.239993889000193, 6.195485060855276],
              [6.246045291939089, 6.194655952423148],
              [6.251296574177086, 6.19543905820573],
              [6.2578502078915, 6.200884503309832],
              [6.272335640295027, 6.214882712460762],
              [6.277152087292555, 6.216812629742012],
              [6.290544126244406, 6.218277201317306],
              [6.295916093867257, 6.21984534025544],
              [6.302290846657917, 6.223147575351435],
              [6.304472230476384, 6.225851593790451],
              [6.308002193663292, 6.170753230117761],
              [6.312365129619262, 6.112811883502809],
              [6.318804912817316, 6.040651310992675],
              [6.3223513831580025, 5.9972397829423185],
              [6.327264088757664, 5.939265696143976],
              [6.329424247785173, 5.910428617521448],
              [6.243047833219212, 5.903427423888339],
              [6.246992413137356, 5.853470755728784],
              [6.250098969033628, 5.8167744564388695],
              [6.224722832272234, 5.814560195695799],
              [6.139640303341567, 5.8080207095265255],
              [6.061810577122268, 5.80181747048722],
              [6.033253134809193, 5.800153273706313],
              [6.030594934888555, 5.846836223619215],
              [6.028995801756255, 5.864277336942335],
              [6.027347051300236, 5.8715003406961515],
              [6.027105641557708, 5.8859607686079025],
              [6.025380262525226, 5.904936225850606],
              [6.021775788454896, 5.949011884270961],
              [6.01812591415415, 6.001285445390273],
              [6.012866456938052, 6.066054674387753],
              [6.010392146702962, 6.09496538122896],
              [6.007793969259699, 6.130424538800312],
              [6.006399263705692, 6.143036078091263],
              [5.986001806888768, 6.140559070277418],
              [5.967803636304761, 6.137834089813302],
              [5.965005692712345, 6.180809210640671],
              [5.963270598943806, 6.213474239254775],
              [5.956553954508962, 6.2123736156456335],
              [5.954834778211805, 6.231820213173944],
              [5.961833140336556, 6.232207022306813]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.00373520669808, "lat": 44.45245326511884 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55009"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01581064"
      },
      "bbox": [
        5.954834778211805, 5.800153273706313, 6.329424247785173,
        6.2450920837717785
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5139927042824746, 6.604057803645453],
            [3.5462453587548723, 6.605228092392068],
            [3.586096610871227, 6.606421699964851],
            [3.600848593787599, 6.606605302407044],
            [3.5996529385155944, 6.643476647751879],
            [3.5974691850321516, 6.69170468013588],
            [3.6404152962985687, 6.69306523930048],
            [3.6836395023888917, 6.695515202419435],
            [3.7253921582790253, 6.697232126290882],
            [3.813023289707011, 6.701865786492891],
            [3.89986403663401, 6.7063725873747835],
            [3.950930627945064, 6.708741657602223],
            [4.030109708241462, 6.713114531329013],
            [4.033155295149582, 6.6480549371554964],
            [4.038814901481871, 6.542387185474719],
            [4.041034512975767, 6.541714302685485],
            [4.045358204903302, 6.454122181241613],
            [4.047394336408792, 6.423165984962803],
            [4.047240647355345, 6.418727525401934],
            [4.0498837524229625, 6.382488592331022],
            [4.051422397105707, 6.352406011981337],
            [4.055440426744634, 6.281396776907618],
            [3.9972911120788526, 6.278354839900929],
            [3.9009868708215465, 6.272962901365774],
            [3.8117776907863257, 6.2685561637032325],
            [3.6913501739269083, 6.263120253880361],
            [3.672207261005959, 6.262067237677849],
            [3.6267940135586176, 6.260021376142675],
            [3.561569283662398, 6.256044579669651],
            [3.540801421198937, 6.254651404708064],
            [3.5357430995253436, 6.356070249736472],
            [3.53330703796963, 6.4069011495197525],
            [3.5295236970923822, 6.479597733256413],
            [3.5279701544329214, 6.517539826623544],
            [3.517438447078955, 6.517448853909977],
            [3.5152634710283865, 6.574937780186085],
            [3.5139927042824746, 6.604057803645453]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.27985610931908, "lat": 45.06940138133445 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55017"],
        "coty_name": ["Chippewa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chippewa County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01581068"
      },
      "bbox": [
        3.5139927042824746, 6.254651404708064, 4.055440426744634,
        6.713114531329013
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.928654461200951, 4.680523827252244],
            [4.93792637948947, 4.695616573852195],
            [4.942083523878426, 4.700338752073439],
            [4.945098814677816, 4.708793782112961],
            [4.950184052684857, 4.714850587286538],
            [4.952529150869852, 4.7155623376751725],
            [4.966546657953271, 4.715821517545673],
            [4.972701448242077, 4.716738619194267],
            [4.975141961566, 4.718921083619538],
            [4.981306287413755, 4.718620848458736],
            [4.986771762162316, 4.721371387305991],
            [4.988101719602354, 4.725833626068294],
            [4.994651703698102, 4.726767621274311],
            [5.001605798679329, 4.730731495950915],
            [5.003923900221545, 4.736492794783244],
            [5.006874217911578, 4.739908557520477],
            [5.008123167277323, 4.746888381621342],
            [5.011426053334192, 4.752778884072796],
            [5.01396146678378, 4.762430277649205],
            [5.010851176524799, 4.769573771042737],
            [5.008021942251187, 4.773072008578025],
            [5.094445229473593, 4.7788730842114875],
            [5.18052139634664, 4.785676809787029],
            [5.226797023121018, 4.78893633901489],
            [5.266114555010622, 4.791530924772546],
            [5.267060802989202, 4.778814792821968],
            [5.280505040144487, 4.779621654303465],
            [5.3448651540999865, 4.7847568794069675],
            [5.3586447384313765, 4.786226362539987],
            [5.4159791735075355, 4.790754968450606],
            [5.437370959439369, 4.7920819054902335],
            [5.493769947945917, 4.797007759471527],
            [5.522510645164152, 4.800635557560814],
            [5.529166916067423, 4.713634446470967],
            [5.530719105426347, 4.6846131120936985],
            [5.533109868011058, 4.633739583640224],
            [5.533255255281479, 4.626452268031687],
            [5.53650138974779, 4.590084570940171],
            [5.540805792164261, 4.518544006521211],
            [5.54114567521483, 4.515828857217465],
            [5.546469470986072, 4.435929293438701],
            [5.549969550179087, 4.388612190118358],
            [5.551585424103891, 4.363399588921569],
            [5.52661721990683, 4.361508426294761],
            [5.4655562962569535, 4.356567262582482],
            [5.429516618460314, 4.353292625538262],
            [5.379630998673293, 4.349261493312199],
            [5.340432313441695, 4.346409743811842],
            [5.293273151183171, 4.34230826916182],
            [5.2925142566004535, 4.353752033374882],
            [5.278261111011625, 4.352480869724223],
            [5.207645565745352, 4.34779716535784],
            [5.169494402530435, 4.345466716240235],
            [5.106396197412761, 4.342100013242856],
            [5.037363078505715, 4.3377195489805676],
            [4.990079116437949, 4.334180581363361],
            [4.951344540436659, 4.331753613826223],
            [4.949746625577455, 4.358728592942684],
            [4.945363528286173, 4.419129384711837],
            [4.939916568420779, 4.506191880384687],
            [4.9366023982820035, 4.557673449115408],
            [4.934476632552169, 4.59306045054984],
            [4.928654461200951, 4.680523827252244]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.41813468674302, "lat": 43.06730054827418 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55025"],
        "coty_name": ["Dane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dane County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01581072"
      },
      "bbox": [
        4.928654461200951, 4.331753613826223, 5.551585424103891,
        4.800635557560814
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.183770434426221, 7.065715213611977],
            [4.182022708970484, 7.10903180852368],
            [4.179606517719946, 7.151776400230976],
            [4.178626852675202, 7.165637463001156],
            [4.178659724558325, 7.173436815321413],
            [4.1746810600004425, 7.237070722061113],
            [4.172872916077946, 7.2702433008758796],
            [4.170959643621501, 7.293586487248622],
            [4.171466133896627, 7.300065336824157],
            [4.166877330317011, 7.363311205965737],
            [4.16581469324742, 7.405508665375216],
            [4.260768544966347, 7.410940036241122],
            [4.317744041906786, 7.414084683586937],
            [4.426264602745442, 7.42029640792981],
            [4.51974612950005, 7.426529478244892],
            [4.605491550608076, 7.431800348650001],
            [4.611553949235287, 7.348136078103758],
            [4.612161713739295, 7.338796404542128],
            [4.614908704314353, 7.269257689888385],
            [4.621561788313133, 7.183019291717742],
            [4.622757857219199, 7.168867861595061],
            [4.625600015856157, 7.115989990316851],
            [4.628245041602878, 7.078296321764666],
            [4.630705681538991, 7.036720649911798],
            [4.632584211505431, 7.009495499771037],
            [4.640881932918876, 6.888071505569977],
            [4.644233442745834, 6.83791539142072],
            [4.595011995771122, 6.835633270047226],
            [4.57715390115246, 6.83421147176121],
            [4.573131390701226, 6.833350965694284],
            [4.484926490703723, 6.82722094350102],
            [4.470199260790065, 6.826329912436212],
            [4.413188120075129, 6.820973653967983],
            [4.411100676945306, 6.82108662696192],
            [4.321127774127395, 6.8138888940813125],
            [4.198322387811591, 6.807674281004103],
            [4.1924006275111365, 6.922438567498101],
            [4.191369530471636, 6.929758664350164],
            [4.188968959485075, 6.962633532458647],
            [4.186131293850556, 7.0145731948951795],
            [4.183770434426221, 7.065715213611977]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.36140756631497, "lat": 45.68041593365476 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55099"],
        "coty_name": ["Price"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Price County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01581110"
      },
      "bbox": [
        4.16581469324742, 6.807674281004103, 4.644233442745834,
        7.431800348650001
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.97931494272598,
          "lat": 18.266285977419983
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72063"],
        "coty_name": ["Gurabo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Gurabo Municipio"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01804512"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.86936940592705,
          "lat": 18.187509113114825
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72085"],
        "coty_name": ["Las Piedras"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Las Piedras Municipio"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01804523"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.61411978618804,
          "lat": 18.059779988173318
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72113"],
        "coty_name": ["Ponce"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Ponce Municipio"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01804537"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.97115351763905,
          "lat": 18.328662660427447
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72131"],
        "coty_name": ["San Sebastián"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["San Sebastián Municipio"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01804546"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.464207263462143, 8.147863892974835],
            [-19.42685357350295, 8.136140147891805],
            [-19.39941000961776, 8.128827102418756],
            [-19.39995482136294, 8.126983124941852],
            [-19.373306646850704, 8.118909608467122],
            [-19.3594495484551, 8.115546420052587],
            [-19.34590261541724, 8.110444198332498],
            [-19.331929295864256, 8.107331637647485],
            [-19.318528617194996, 8.102996013418398],
            [-19.31608547013437, 8.111559952125772],
            [-19.309612340978987, 8.10372455604472],
            [-19.303287677478068, 8.101762144664667],
            [-19.300002227598178, 8.114009107855972],
            [-19.29413117623185, 8.132795564590985],
            [-19.28189442611385, 8.126822421019597],
            [-19.278605096319133, 8.12586802765804],
            [-19.27724134775949, 8.129852528559999],
            [-19.273951664182707, 8.128868114504224],
            [-19.27258695017373, 8.132822159093907],
            [-19.262736596461078, 8.129738588980661],
            [-19.261364667388815, 8.133617787424672],
            [-19.25808885326972, 8.132550026548875],
            [-19.256711414666327, 8.136416105528912],
            [-19.25342902266061, 8.135336196097336],
            [-19.25206154358018, 8.139160564424225],
            [-19.245437873946432, 8.137003449190548],
            [-19.244040869386875, 8.140837649308779],
            [-19.23735356364743, 8.138730801744371],
            [-19.235926815238923, 8.14259034165572],
            [-19.232586852432824, 8.141571013774097],
            [-19.23114694296478, 8.14545978585393],
            [-19.227750462371347, 8.144503706624796],
            [-19.226668258353385, 8.147866122151212],
            [-19.223283165983855, 8.146885617457924],
            [-19.222213204128334, 8.150225696626944],
            [-19.218808982956137, 8.149212695949577],
            [-19.216661689391916, 8.155933062198624],
            [-19.212732456285444, 8.156583882335259],
            [-19.166100499669632, 8.141695971973427],
            [-19.128251441654164, 8.130895982773145],
            [-19.13012940634895, 8.12427456195756],
            [-19.099568630941082, 8.114245524477559],
            [-19.103929399405843, 8.100183155558197],
            [-19.076662962085187, 8.091528238233474],
            [-19.085518571825737, 8.063604529877074],
            [-19.058186928005643, 8.054879512709308],
            [-19.064801252824267, 8.033217729727072],
            [-19.029912135121474, 8.022952143539124],
            [-19.040987562919497, 7.986520492201083],
            [-19.00010363531382, 7.9756315362745855],
            [-19.006232194858555, 7.955519796550778],
            [-18.965671438989972, 7.943402590808177],
            [-18.95653232102201, 7.93988706649227],
            [-18.922291108103206, 7.929981577765573],
            [-18.93059828046125, 7.902295678773467],
            [-18.905680623519764, 7.894726517750223],
            [-18.81887534683365, 7.868985211101303],
            [-18.78526188048755, 7.859343686725385],
            [-18.793092322612456, 7.834643526422279],
            [-18.797758583628987, 7.817997434696691],
            [-18.814463522044157, 7.761468934320434],
            [-18.83433962007739, 7.69341802134695],
            [-18.813666504179785, 7.687389986422126],
            [-18.831940660538248, 7.626519514691261],
            [-18.832393865604754, 7.624486742451586],
            [-18.749679848627142, 7.599441032427423],
            [-18.74911031016225, 7.601355033924152],
            [-18.73734700699993, 7.598665956441836],
            [-18.710005850117508, 7.593545554263161],
            [-18.69619028874116, 7.589070722868553],
            [-18.68230726595137, 7.586100897605669],
            [-18.641461931802805, 7.574155751544135],
            [-18.60548892299699, 7.5630031710040155],
            [-18.57778358136933, 7.555828044503],
            [-18.585383045782088, 7.529940544689309],
            [-18.603259974576563, 7.467078406931569],
            [-18.60761576337654, 7.453165065492815],
            [-18.524849612556235, 7.430602435693624],
            [-18.52432626182475, 7.43232344601213],
            [-18.44482226368626, 7.409657677452806],
            [-18.44453417062418, 7.4106630916394245],
            [-18.401896040215483, 7.39870918518989],
            [-18.27919879363754, 7.364296151556079],
            [-18.279630364985383, 7.362742656926207],
            [-18.183184039824976, 7.335901553505521],
            [-18.184882791970583, 7.33334502882226],
            [-18.182080150207934, 7.330428904607271],
            [-18.176533280700554, 7.329048279140749],
            [-18.172121152034077, 7.32128095794811],
            [-18.168219962800734, 7.320927671549584],
            [-18.16264458160734, 7.314707112279345],
            [-18.159297664297764, 7.317899188437588],
            [-18.15710055135207, 7.311448918041299],
            [-18.15505017145471, 7.309770468585483],
            [-18.15487163279224, 7.30131927428193],
            [-18.147347393257682, 7.291492493785809],
            [-18.145133028276273, 7.290402390076321],
            [-18.143870869660077, 7.281782362947767],
            [-18.147010524426513, 7.27925590537817],
            [-18.14726392809694, 7.2705313312435935],
            [-18.14643621824273, 7.264788493674217],
            [-18.14450000601335, 7.263657105960714],
            [-18.140014706967605, 7.256578433497478],
            [-18.139188781558985, 7.253221975460086],
            [-18.134470705358723, 7.248047385304831],
            [-18.132568869195268, 7.241966026346336],
            [-18.127747307506354, 7.239472099331477],
            [-18.127605805086382, 7.229801477891697],
            [-18.125484178570012, 7.221863496403847],
            [-18.12497734740969, 7.213156349176491],
            [-18.12717042044507, 7.208128400739699],
            [-18.133957621099782, 7.20196487781078],
            [-18.13309718667088, 7.195344656501915],
            [-18.13075196684487, 7.1939095992205315],
            [-18.127212074996606, 7.188087503954376],
            [-18.12647088943467, 7.184180809092375],
            [-18.134988084424958, 7.1784605717120735],
            [-18.13795608180126, 7.168796289848652],
            [-18.137582140788968, 7.163430529769702],
            [-18.135304469928926, 7.158368436262447],
            [-18.13089025810614, 7.1558376447209415],
            [-18.126946555760675, 7.151854481298319],
            [-18.125834308416263, 7.147274597252304],
            [-18.125295358147834, 7.138476010222601],
            [-18.122783304176924, 7.133427993561165],
            [-18.130647368666203, 7.131854779383874],
            [-18.137606004287584, 7.127372241047451],
            [-18.138375628167584, 7.12468705647034],
            [-18.149446167418883, 7.113137843240059],
            [-18.154620494645265, 7.1149550072926075],
            [-18.160334277636935, 7.108580952680295],
            [-18.166097023434816, 7.107781098565143],
            [-18.17082477687916, 7.104233470739101],
            [-18.180467169143, 7.103541210545784],
            [-18.178171600599693, 7.093818252266292],
            [-18.17921044874129, 7.091492660663979],
            [-18.185805884782024, 7.085380272247574],
            [-18.1860475283852, 7.079167147386325],
            [-18.196137077711946, 7.068462485596458],
            [-18.201967453791514, 7.06341959947554],
            [-18.20277096187914, 7.055830720992987],
            [-18.205381243435703, 7.049706576313037],
            [-18.214892842564357, 7.04667684766102],
            [-18.217039282426583, 7.044668437561698],
            [-18.21686819343727, 7.03779338293523],
            [-18.219567329783615, 7.030590803053684],
            [-18.22330852681503, 7.026868467963397],
            [-18.229133625165037, 7.023771774063205],
            [-18.232933593959043, 7.01566452950293],
            [-18.23523527458865, 7.014453035367904],
            [-18.23975174770211, 7.008042702620128],
            [-18.240222882992683, 7.004275386667544],
            [-18.244175998444437, 7.000903613707521],
            [-18.246836000706068, 6.992370323901358],
            [-18.25172033753388, 6.988918742682247],
            [-18.255753721369327, 6.9790768703014585],
            [-18.254539521776206, 6.976025076104204],
            [-18.245824596210856, 6.967475422160457],
            [-18.390090320105045, 7.007920571032898],
            [-18.409743835468387, 6.939565828262912],
            [-18.492463068708734, 6.963062640582626],
            [-18.496132253960784, 6.950426756907263],
            [-18.509965704047353, 6.954324194136731],
            [-18.51398378832118, 6.940397604828253],
            [-18.52774873435365, 6.9442943661809835],
            [-18.531733052360842, 6.930366878247809],
            [-18.545535066233125, 6.934232647352892],
            [-18.54955235033358, 6.920316951128878],
            [-18.591784497323562, 6.932196861880455],
            [-18.619756959499572, 6.9395617225820585],
            [-18.623796117119074, 6.925657220882364],
            [-18.637628440800004, 6.929558644794293],
            [-18.641505130947348, 6.916276134188248],
            [-18.655503311019018, 6.92055216548432],
            [-18.65981053002225, 6.905803462607147],
            [-18.674489867413545, 6.911156264637651],
            [-18.68574292474698, 6.91455577437167],
            [-18.690070394258065, 6.899324991539221],
            [-18.717730776489333, 6.907171960742341],
            [-18.721776255430544, 6.893285553316738],
            [-18.735661479851913, 6.897228980334275],
            [-18.739692056390012, 6.883341806365974],
            [-18.753447213112246, 6.887294794085669],
            [-18.75750560887201, 6.8734502798030475],
            [-18.771256780457453, 6.877383443019131],
            [-18.775238850556033, 6.863801220381535],
            [-18.7890985660387, 6.867466167431381],
            [-18.78759552121111, 6.872746075596045],
            [-18.80097263012973, 6.876703686391697],
            [-18.806990691727805, 6.85559250959994],
            [-18.813901455686203, 6.857593193794675],
            [-18.818260863700846, 6.844151411061982],
            [-18.824787442911525, 6.8460372810720145],
            [-18.828820834500924, 6.832119487775784],
            [-18.8419413810822, 6.838275460814632],
            [-18.855606826826744, 6.8423575066025295],
            [-18.86912379560204, 6.847409614102735],
            [-18.870597350789705, 6.840384618305783],
            [-18.925738263862524, 6.856584237517727],
            [-18.939391778070867, 6.860428098890372],
            [-18.94141699837283, 6.853505010632745],
            [-18.95501782017526, 6.858025378310983],
            [-18.956801456527398, 6.851081118207713],
            [-18.97049212413423, 6.855052060223136],
            [-18.97137561922793, 6.853838932754444],
            [-18.984734030648752, 6.85757824744168],
            [-18.986798153466914, 6.85061625830081],
            [-19.058877630929512, 6.871638156699511],
            [-19.057852503540115, 6.875015910009136],
            [-19.085548461416774, 6.883174357628411],
            [-19.090536793053364, 6.865772831158317],
            [-19.11047934969259, 6.871637226047253],
            [-19.112240680236788, 6.865790318978096],
            [-19.11916518105717, 6.867862156365189],
            [-19.121245179523264, 6.860965016227424],
            [-19.12819678326096, 6.862973735258106],
            [-19.130255932773096, 6.856039112212391],
            [-19.136924258601343, 6.857909612507818],
            [-19.139299885012605, 6.851129801769534],
            [-19.152789446914998, 6.8550458600545605],
            [-19.15486678424914, 6.848003799124539],
            [-19.168646196220916, 6.851838961706377],
            [-19.162475240322618, 6.872925002928572],
            [-19.179849292052513, 6.878333690163423],
            [-19.177781569862347, 6.885348693570831],
            [-19.20222236786994, 6.892540267174974],
            [-19.203236506829604, 6.889043717234926],
            [-19.216912476616436, 6.892885582111338],
            [-19.21588644747754, 6.896232806832084],
            [-19.22867505037002, 6.9004845544723405],
            [-19.24241853664351, 6.904490580234986],
            [-19.24032838269397, 6.911455823467317],
            [-19.2437763121042, 6.9124832072926505],
            [-19.248220481518874, 6.898656199173491],
            [-19.267994517420984, 6.90447041779281],
            [-19.27299696119869, 6.8906770549811895],
            [-19.276459268000174, 6.891687161342397],
            [-19.27537757789704, 6.895200403203528],
            [-19.288827779616607, 6.899701268741137],
            [-19.28978998596321, 6.896396655614914],
            [-19.30323325723115, 6.90044627122461],
            [-19.305926916727397, 6.892804110491716],
            [-19.312770906801696, 6.894778134704954],
            [-19.31385951791167, 6.8913731629711],
            [-19.320869621867526, 6.893328212219314],
            [-19.31981758037231, 6.896815855393406],
            [-19.340350266252663, 6.902156170189373],
            [-19.338437801879472, 6.908814795387423],
            [-19.358756793045135, 6.914828017948019],
            [-19.371936380848908, 6.9194011504698665],
            [-19.36976644536509, 6.926356372186391],
            [-19.383447251378996, 6.930878551852597],
            [-19.38131225872042, 6.937772973860763],
            [-19.384766038791856, 6.938831589000939],
            [-19.381459299232862, 6.949173217541671],
            [-19.38491634477384, 6.950221494836609],
            [-19.38601766315165, 6.946777195524565],
            [-19.39303264891765, 6.948909470919363],
            [-19.390681577430133, 6.956311551047643],
            [-19.45759745967422, 6.975935515339289],
            [-19.454527134380708, 6.985929195681878],
            [-19.461395099740614, 6.988107277661501],
            [-19.460384401171375, 6.9914706833971545],
            [-19.46727942230314, 6.99364610347782],
            [-19.471306871044117, 6.979922903032978],
            [-19.485036657730312, 6.98407993253046],
            [-19.47218513039723, 7.026540781465597],
            [-19.47689762926473, 7.02782399665892],
            [-19.484378802404976, 7.026077870691428],
            [-19.488884111633585, 7.030769525660814],
            [-19.489920032892456, 7.035903003906271],
            [-19.49483921468885, 7.037124187343102],
            [-19.501203617722187, 7.043876943336759],
            [-19.506492604254728, 7.047725091055101],
            [-19.508199332736314, 7.0511943174203955],
            [-19.514412576334223, 7.055154516655465],
            [-19.520892754348736, 7.054875844885455],
            [-19.524320124982854, 7.052143460711114],
            [-19.532129690953674, 7.04805171708479],
            [-19.537215433865594, 7.050928561819565],
            [-19.527147757479383, 7.084684400803236],
            [-19.533183546181323, 7.08650068056188],
            [-19.514795402459736, 7.143801781986917],
            [-19.507697337059167, 7.1680537025859135],
            [-19.504802182517388, 7.182635227656202],
            [-19.49268861505345, 7.221530867398458],
            [-19.483688964747074, 7.251147280933828],
            [-19.44222517112823, 7.23879299331163],
            [-19.416898881075117, 7.3216870018116],
            [-19.379053029415065, 7.310720689243438],
            [-19.378011238821607, 7.3141693094445355],
            [-19.374587106109793, 7.313166949279829],
            [-19.350478082385056, 7.392923866232646],
            [-19.34929385631554, 7.399967540290105],
            [-19.339075367257934, 7.434854464572824],
            [-19.327098163010124, 7.476661745864089],
            [-19.36836884320338, 7.489278903840284],
            [-19.359657197540635, 7.516905025301202],
            [-19.34335858071224, 7.572076699527306],
            [-19.339913378201924, 7.577936199167943],
            [-19.337580440410928, 7.584864595256567],
            [-19.32968301791663, 7.612933836212511],
            [-19.3188774480761, 7.645382495561352],
            [-19.31852261095071, 7.65490013430492],
            [-19.355084587070223, 7.665556645133983],
            [-19.346565740593736, 7.69243184114351],
            [-19.329741649027294, 7.746526203682383],
            [-19.370640585069804, 7.758229226537471],
            [-19.343836580596044, 7.846334668377323],
            [-19.394790991361848, 7.861667708833501],
            [-19.394554596225795, 7.8624212265214455],
            [-19.47266848119736, 7.886296464568193],
            [-19.498263802540368, 7.8956803314101816],
            [-19.529700841500226, 7.905143872641432],
            [-19.553450769888023, 7.912564258837842],
            [-19.555355079818618, 7.912599586141637],
            [-19.579845956240494, 7.920023424737728],
            [-19.571848543109912, 7.934960528374644],
            [-19.56157128207202, 7.958610482482563],
            [-19.554785474864943, 7.9703693410386105],
            [-19.552614130313774, 7.977401141184202],
            [-19.53442584255025, 8.005294529210932],
            [-19.534516710084237, 8.005880455264398],
            [-19.50553153146519, 8.060070343114287],
            [-19.487018718646578, 8.097845943895116],
            [-19.464207263462143, 8.147863892974835]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.16640156016794,
          "lat": 43.279697344857276
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41019"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01135849"
      },
      "bbox": [
        -19.579845956240494, 6.832119487775784, -18.122783304176924,
        8.156583882335259
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.562191726161434, 9.258562086341982],
            [-16.54745591241678, 9.26347792581665],
            [-16.517708918727756, 9.256414416599894],
            [-16.498401230680567, 9.243009160508436],
            [-16.480346020013005, 9.209224870265354],
            [-16.471965820914797, 9.19704358031042],
            [-16.457511130043237, 9.187569885692682],
            [-16.403302531456937, 9.178392534459167],
            [-16.3496838770832, 9.176553499326078],
            [-16.320075464224928, 9.178190210397148],
            [-16.315404222463126, 9.178107234930625],
            [-16.265954543149725, 9.170169251831176],
            [-16.229659333167945, 9.197544053032425],
            [-16.20718253615969, 9.203195592686557],
            [-16.156066679364223, 9.202343795445469],
            [-16.101506123929774, 9.21626651354085],
            [-16.131685272188637, 9.097090235639333],
            [-16.174983503194934, 8.934337513211304],
            [-16.178735314049025, 8.935267380414444],
            [-16.211906674977932, 8.809277428755186],
            [-16.244899383664706, 8.68690751358068],
            [-16.160478172367206, 8.664619174628395],
            [-16.18338661000858, 8.580778909036137],
            [-16.098650855892288, 8.559386941631143],
            [-16.12109083024719, 8.475210416225016],
            [-16.14166626730969, 8.480384626638276],
            [-16.14490654618452, 8.467477852630624],
            [-16.186086948093138, 8.47786465137547],
            [-16.226772540923346, 8.48834203035341],
            [-16.227024738512842, 8.48738275135355],
            [-16.30823052893233, 8.506337094431634],
            [-16.37638496489987, 8.524022458791455],
            [-16.378136479229756, 8.526416425536377],
            [-16.499134933056812, 8.558033020610258],
            [-16.62580982388217, 8.591419298010823],
            [-16.623766682061955, 8.597408844423125],
            [-16.627778474703206, 8.607490588333876],
            [-16.630099640728087, 8.611958082406549],
            [-16.632506818106556, 8.620160842473704],
            [-16.62752336845501, 8.625719344942253],
            [-16.62498664952038, 8.626519557210827],
            [-16.614033951214363, 8.62680904001344],
            [-16.608033712459996, 8.624427048136228],
            [-16.60226011179448, 8.629678363596428],
            [-16.59800400476811, 8.623760003089558],
            [-16.59478020663615, 8.621078667957498],
            [-16.591147376565058, 8.626785605734637],
            [-16.590316199492396, 8.63127697883862],
            [-16.587728436544765, 8.633878446249392],
            [-16.589954606836898, 8.645384081269395],
            [-16.58437906914787, 8.651938455183085],
            [-16.578997832304594, 8.651871783871304],
            [-16.575147114242014, 8.65489360505163],
            [-16.57688045099713, 8.657662023882276],
            [-16.585882188553793, 8.658720931922124],
            [-16.58661324389694, 8.661459092525773],
            [-16.591194564960265, 8.667117115237431],
            [-16.590431180678692, 8.67244380958639],
            [-16.584005065492466, 8.67660316254017],
            [-16.583701417936584, 8.67937875713756],
            [-16.591886335959483, 8.68694275871758],
            [-16.58648979761311, 8.688606959947982],
            [-16.582575740838106, 8.692089701271746],
            [-16.583470734854004, 8.694471185985238],
            [-16.590877050926775, 8.696195103771906],
            [-16.590921819016568, 8.700401511947083],
            [-16.586888121927917, 8.702420243948119],
            [-16.58470323221944, 8.708705754563177],
            [-16.58836829286621, 8.713632704188333],
            [-16.59170906701123, 8.714929578050093],
            [-16.59519015031889, 8.713892781195794],
            [-16.6007390690168, 8.715748177956867],
            [-16.606619691675093, 8.720452929788722],
            [-16.61080665701362, 8.726864979993127],
            [-16.61550322366123, 8.729727241789309],
            [-16.614940710151334, 8.734286603752295],
            [-16.620837108161147, 8.735108347732103],
            [-16.621580687895936, 8.737919506239086],
            [-16.618547035260793, 8.741774344375928],
            [-16.609979527608775, 8.739232701812451],
            [-16.606388556227248, 8.744229334701851],
            [-16.609663769258006, 8.747232035773937],
            [-16.61769543471612, 8.74441656878373],
            [-16.620254304466656, 8.749278979982112],
            [-16.61569220050621, 8.75627200034997],
            [-16.616192728592754, 8.76121058549044],
            [-16.619337229209144, 8.766327969187026],
            [-16.61901102912165, 8.772175793773146],
            [-16.620760373444224, 8.776519718402206],
            [-16.619084066342236, 8.77843458787484],
            [-16.61091294445238, 8.777426308612478],
            [-16.60468825245433, 8.777848470920436],
            [-16.603326705625783, 8.780766218882441],
            [-16.60551892264896, 8.784814792872325],
            [-16.611443917298093, 8.786872754785305],
            [-16.609869616615953, 8.790859830029685],
            [-16.6056334010329, 8.794458808379403],
            [-16.60347232314355, 8.798190307861185],
            [-16.603726403280586, 8.801324803390104],
            [-16.6105397277277, 8.807398958737755],
            [-16.602991855003747, 8.807882933749745],
            [-16.602106682610803, 8.810106331814584],
            [-16.603145411481684, 8.820910809485868],
            [-16.59755098883738, 8.825790701527088],
            [-16.595496060644283, 8.823413770972353],
            [-16.596204033020282, 8.818587781913436],
            [-16.59481202862338, 8.815361246004723],
            [-16.589891064819987, 8.814997836911592],
            [-16.586303305057623, 8.81835796200991],
            [-16.585894013610393, 8.823976493239778],
            [-16.589333173663004, 8.828247938121931],
            [-16.593911742998618, 8.830158318462107],
            [-16.59228550634271, 8.835971408055707],
            [-16.583763842192727, 8.837122498779944],
            [-16.582393690618897, 8.841979679202984],
            [-16.58282474075927, 8.846079609066491],
            [-16.58965332319592, 8.84745212943229],
            [-16.589116338386404, 8.850277100955664],
            [-16.582796913292245, 8.850264268632431],
            [-16.58066972961775, 8.85686614127026],
            [-16.581795976482773, 8.862169500418942],
            [-16.586610140222422, 8.864550173354935],
            [-16.58708379157833, 8.867127441503388],
            [-16.579345541882123, 8.870526751685857],
            [-16.578017597921757, 8.875496251917307],
            [-16.57452476192888, 8.8804120431932],
            [-16.576066327084167, 8.88551641032276],
            [-16.573585884782325, 8.887731585300868],
            [-16.56715931748244, 8.888406659189386],
            [-16.564975394387627, 8.892232520266665],
            [-16.561980707365574, 8.88930534275299],
            [-16.55848912901787, 8.89340370177069],
            [-16.564497574951154, 8.896196471096484],
            [-16.569675233124304, 8.89611561963939],
            [-16.56867020049426, 8.900964170852529],
            [-16.56298242055206, 8.902956160873781],
            [-16.558379618105935, 8.907684204048977],
            [-16.55855668502479, 8.909467826865464],
            [-16.563847980097236, 8.914935547520342],
            [-16.560153866001812, 8.918980179430005],
            [-16.553393122923122, 8.916298020185502],
            [-16.549753181105054, 8.916064861714997],
            [-16.546756932945346, 8.918043482990118],
            [-16.541890999756983, 8.926484071113762],
            [-16.536851776948726, 8.926602274457801],
            [-16.532899029502577, 8.923733769858014],
            [-16.527680892276106, 8.926156304990483],
            [-16.530189076360212, 8.933348735984131],
            [-16.533250906506378, 8.935474222122085],
            [-16.541392673796633, 8.937594683718148],
            [-16.54036434134836, 8.940903169852586],
            [-16.536601953428384, 8.942222202368502],
            [-16.526742636692134, 8.940012738421137],
            [-16.523083090736247, 8.943350540203072],
            [-16.525399827322783, 8.948041406401511],
            [-16.53057990411775, 8.950922576974003],
            [-16.528312437206136, 8.95697323658606],
            [-16.517559231897522, 8.960304120144444],
            [-16.519489633182843, 8.966118868425529],
            [-16.524075158889904, 8.968231962426984],
            [-16.525014428314762, 8.971234852167436],
            [-16.520367307616347, 8.97370273863012],
            [-16.5107451932306, 8.974978435109286],
            [-16.50659907852367, 8.977475146870628],
            [-16.498824321802427, 8.97816940343106],
            [-16.491855544253827, 8.982880707741355],
            [-16.4869376004531, 8.980066558052334],
            [-16.483654939085064, 8.971122260707203],
            [-16.473872901328505, 8.960665427833074],
            [-16.465484433733657, 8.960853256125047],
            [-16.46278492586378, 8.963028128643963],
            [-16.463310514989093, 8.972053147742468],
            [-16.469498266987866, 8.974680068259064],
            [-16.471193780787004, 8.978388389121617],
            [-16.469084010539287, 8.983866476095558],
            [-16.46993109587709, 8.99021401489214],
            [-16.46638240990769, 8.991907301069535],
            [-16.461661272356658, 8.988884788379663],
            [-16.451338411964368, 8.984369129019683],
            [-16.442993132454117, 8.982039428598862],
            [-16.437911966102426, 8.976804630056417],
            [-16.430615226375892, 8.977263444821977],
            [-16.428141763635246, 8.97866526215894],
            [-16.42203202768455, 8.988094990601091],
            [-16.42401149755314, 8.994944013869631],
            [-16.432355987288222, 9.002402180801411],
            [-16.43195361658805, 9.00669141251562],
            [-16.42454329797775, 9.011830097658432],
            [-16.416069243241207, 9.009301312767906],
            [-16.414169980275414, 9.012277805299291],
            [-16.418211638602624, 9.016933903915405],
            [-16.42640529084332, 9.019347666042767],
            [-16.430211861477396, 9.024410356976112],
            [-16.42993683966001, 9.029651927815845],
            [-16.433046807822944, 9.035530677183239],
            [-16.438350744786664, 9.039409832164857],
            [-16.441223197094708, 9.045871634278893],
            [-16.440003435216735, 9.048972155209647],
            [-16.435926346847392, 9.05194728103848],
            [-16.43524533785295, 9.054715771343607],
            [-16.43614565633747, 9.068953301376833],
            [-16.43409042401191, 9.077456780640786],
            [-16.43473412771939, 9.081256368250893],
            [-16.448342714917693, 9.08720748957882],
            [-16.451538204393167, 9.092045453889085],
            [-16.453871195462394, 9.09784565285443],
            [-16.45380705100101, 9.104453222310015],
            [-16.45143428889942, 9.107982874416939],
            [-16.4459316087361, 9.111495849942974],
            [-16.448874189293026, 9.116529065116776],
            [-16.454543214109986, 9.116806392190684],
            [-16.45910758790343, 9.1140689619911],
            [-16.46689083707862, 9.113341127638405],
            [-16.466818855959694, 9.118942243366611],
            [-16.471188682514924, 9.123063903102667],
            [-16.471965369796898, 9.129824582226204],
            [-16.47484481622993, 9.133615066858972],
            [-16.46850257701765, 9.135532465449556],
            [-16.46840089359242, 9.140096593050515],
            [-16.47682042056356, 9.140605913672642],
            [-16.47575824878817, 9.145915232233286],
            [-16.47188673108987, 9.150844508796228],
            [-16.47902583838997, 9.15421368589506],
            [-16.483791802772195, 9.164480102426502],
            [-16.490473430810184, 9.16852672739292],
            [-16.49614041946243, 9.174616156873771],
            [-16.50189204992709, 9.175366289292947],
            [-16.507920365663892, 9.174777611411447],
            [-16.509595277436553, 9.17878650891844],
            [-16.50892690532098, 9.183715015944193],
            [-16.51682588946063, 9.194450686092908],
            [-16.51654784682595, 9.202236147069433],
            [-16.520768204398394, 9.208338381289417],
            [-16.52641982707883, 9.21287584076619],
            [-16.536516123040478, 9.216737527660406],
            [-16.53552831969522, 9.226888474553716],
            [-16.542630697114998, 9.237317473722054],
            [-16.546461167933074, 9.238931701147612],
            [-16.551682468160173, 9.238868127749077],
            [-16.556290475076796, 9.240278249346902],
            [-16.560560355058065, 9.244559696836983],
            [-16.560481664593635, 9.253724532056662],
            [-16.562191726161434, 9.258562086341982]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.21079317372119,
          "lat": 45.37827748784467
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41021"],
        "coty_name": ["Gilliam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gilliam County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01135850"
      },
      "bbox": [
        -16.632506818106556, 8.467477852630624, -16.098650855892288,
        9.26347792581665
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.47218513039723, 7.026540781465597],
            [-19.485036657730312, 6.98407993253046],
            [-19.471306871044117, 6.979922903032978],
            [-19.46727942230314, 6.99364610347782],
            [-19.460384401171375, 6.9914706833971545],
            [-19.461395099740614, 6.988107277661501],
            [-19.454527134380708, 6.985929195681878],
            [-19.45759745967422, 6.975935515339289],
            [-19.390681577430133, 6.956311551047643],
            [-19.39303264891765, 6.948909470919363],
            [-19.38601766315165, 6.946777195524565],
            [-19.38491634477384, 6.950221494836609],
            [-19.381459299232862, 6.949173217541671],
            [-19.384766038791856, 6.938831589000939],
            [-19.38131225872042, 6.937772973860763],
            [-19.383447251378996, 6.930878551852597],
            [-19.36976644536509, 6.926356372186391],
            [-19.371936380848908, 6.9194011504698665],
            [-19.358756793045135, 6.914828017948019],
            [-19.338437801879472, 6.908814795387423],
            [-19.340350266252663, 6.902156170189373],
            [-19.31981758037231, 6.896815855393406],
            [-19.320869621867526, 6.893328212219314],
            [-19.31385951791167, 6.8913731629711],
            [-19.312770906801696, 6.894778134704954],
            [-19.305926916727397, 6.892804110491716],
            [-19.30323325723115, 6.90044627122461],
            [-19.28978998596321, 6.896396655614914],
            [-19.288827779616607, 6.899701268741137],
            [-19.27537757789704, 6.895200403203528],
            [-19.276459268000174, 6.891687161342397],
            [-19.27299696119869, 6.8906770549811895],
            [-19.267994517420984, 6.90447041779281],
            [-19.248220481518874, 6.898656199173491],
            [-19.2437763121042, 6.9124832072926505],
            [-19.24032838269397, 6.911455823467317],
            [-19.24241853664351, 6.904490580234986],
            [-19.22867505037002, 6.9004845544723405],
            [-19.21588644747754, 6.896232806832084],
            [-19.216912476616436, 6.892885582111338],
            [-19.203236506829604, 6.889043717234926],
            [-19.20222236786994, 6.892540267174974],
            [-19.177781569862347, 6.885348693570831],
            [-19.179849292052513, 6.878333690163423],
            [-19.162475240322618, 6.872925002928572],
            [-19.168646196220916, 6.851838961706377],
            [-19.15486678424914, 6.848003799124539],
            [-19.17652378407841, 6.774770702582727],
            [-19.197798798365508, 6.703438899537919],
            [-19.23232657220646, 6.585980678062915],
            [-19.25338164999453, 6.51531458225502],
            [-19.272181404314765, 6.453197178946633],
            [-19.317894480289937, 6.297087788514858],
            [-19.319329756046223, 6.297234705307002],
            [-19.327537122729076, 6.269176360537479],
            [-19.354309479465634, 6.178969792983734],
            [-19.354672666605797, 6.178033845077837],
            [-19.43797752796268, 6.1976274954721156],
            [-19.506723628968736, 6.219282344156378],
            [-19.558479699009368, 6.234744775201222],
            [-19.594858678653054, 6.245390476907924],
            [-19.633789980372082, 6.256059679012835],
            [-19.65860309265812, 6.258555652504499],
            [-19.708189292705768, 6.275388494610742],
            [-19.76776204489252, 6.291253198455527],
            [-19.774937624241932, 6.293844946806473],
            [-19.77192180296325, 6.296021394567662],
            [-19.777743696112214, 6.301886031701458],
            [-19.774946426424822, 6.307252062058195],
            [-19.7760812293337, 6.310847838935448],
            [-19.78090866871302, 6.316217430463578],
            [-19.775117442204323, 6.329106117308757],
            [-19.779809496903567, 6.334765610290595],
            [-19.780166788494295, 6.344960532088218],
            [-19.778787645342984, 6.348349338366781],
            [-19.77433914583634, 6.349440008787948],
            [-19.76859195414432, 6.356763194652056],
            [-19.768918672001657, 6.3598812372558795],
            [-19.76379964435504, 6.361528090710523],
            [-19.76304797259616, 6.363866035090632],
            [-19.756290203944022, 6.368607604290681],
            [-19.754715996687906, 6.37338128543385],
            [-19.751127994251153, 6.379568978215883],
            [-19.748461045375215, 6.380992327185595],
            [-19.749180722343155, 6.3881283971266525],
            [-19.750676545918456, 6.392858810023157],
            [-19.749440143093654, 6.403597922791704],
            [-19.75214188400983, 6.4061895603566406],
            [-19.75250614325284, 6.413782336275467],
            [-19.74956621409059, 6.421149758924859],
            [-19.75435945498486, 6.423143524379888],
            [-19.7588452226889, 6.430157507542348],
            [-19.760174010405304, 6.434977113982701],
            [-19.756217999391406, 6.440619870271118],
            [-19.750669471829543, 6.443583046733469],
            [-19.747122926255955, 6.443094709016961],
            [-19.7420535777694, 6.448414373731059],
            [-19.732353321060767, 6.44858253039684],
            [-19.7291703904316, 6.4495112333328],
            [-19.725445838654267, 6.454008429391918],
            [-19.720963258149382, 6.455821978559346],
            [-19.71817072495943, 6.463423748869033],
            [-19.715641966993907, 6.4669644034127876],
            [-19.714186847837187, 6.47253899865659],
            [-19.715552302092004, 6.477375999321814],
            [-19.717967864582278, 6.479796179494742],
            [-19.716944944415076, 6.483784305427729],
            [-19.71230106277514, 6.492467150618322],
            [-19.70814328518179, 6.493447815233562],
            [-19.705090161601024, 6.499781587728392],
            [-19.70129268226561, 6.503131154966145],
            [-19.697003430199224, 6.50056982693334],
            [-19.689064175440258, 6.503806846818258],
            [-19.683606744222054, 6.5194250131004425],
            [-19.68658874656553, 6.520185371118896],
            [-19.68808218936963, 6.5234600101091065],
            [-19.691047640640743, 6.52354498821243],
            [-19.695842203427606, 6.52973726949115],
            [-19.693199638481634, 6.532916034532992],
            [-19.6938390253103, 6.540427217949402],
            [-19.69240311885371, 6.548151726690619],
            [-19.696944759578066, 6.551352025664369],
            [-19.69782730386811, 6.558519142503171],
            [-19.695741258414785, 6.563274171149597],
            [-19.698926443956246, 6.571402354914759],
            [-19.69835320173767, 6.573978956931836],
            [-19.701349454150467, 6.5779214781709605],
            [-19.699180205631357, 6.583702007525782],
            [-19.702065638928172, 6.588550487230433],
            [-19.704502036908675, 6.590024320833329],
            [-19.70336441652651, 6.594194879466005],
            [-19.69522822873936, 6.600806814903187],
            [-19.698417112201618, 6.6066933980096625],
            [-19.702836559457563, 6.612006909498048],
            [-19.707707985603435, 6.611167212808526],
            [-19.71330365184815, 6.617290773341443],
            [-19.716052089646837, 6.626338944328153],
            [-19.716240737762664, 6.631210879562787],
            [-19.712699109312272, 6.640146481289052],
            [-19.716993084242816, 6.642710185159996],
            [-19.717927510806422, 6.64861215326527],
            [-19.720642330578205, 6.651347826995464],
            [-19.72714295624801, 6.649059619555285],
            [-19.732376572027547, 6.648970373738856],
            [-19.74213675033563, 6.650674984187672],
            [-19.743634146650766, 6.655905108380336],
            [-19.749449489945963, 6.662579502811256],
            [-19.749051835263373, 6.668585578320443],
            [-19.75970403905543, 6.666481212488885],
            [-19.763842160282827, 6.669107181356078],
            [-19.76881458991718, 6.6693999721327035],
            [-19.784669551598725, 6.6769891988470516],
            [-19.791137571627957, 6.677974518879299],
            [-19.80643455264166, 6.683926182382554],
            [-19.809048842961875, 6.686689402546906],
            [-19.813270834549133, 6.685391537600683],
            [-19.816596200544552, 6.697889510129892],
            [-19.814047579367347, 6.703051008170915],
            [-19.81364470709086, 6.710031154753601],
            [-19.815729150805407, 6.71404442438117],
            [-19.81295149584972, 6.716262185572763],
            [-19.80859780006707, 6.722857394231967],
            [-19.806976034428274, 6.727962707772989],
            [-19.801497111344933, 6.727924832002939],
            [-19.79862052363971, 6.7313414642927905],
            [-19.7880795101221, 6.733666007697902],
            [-19.782739804103993, 6.739311214403022],
            [-19.784405610324356, 6.744380390159665],
            [-19.780901517879627, 6.74668973205149],
            [-19.783031577925428, 6.750978486983899],
            [-19.782611999414232, 6.754489199938753],
            [-19.776203496334823, 6.760641075141866],
            [-19.77172511157861, 6.760961525988678],
            [-19.770266848200468, 6.763126011349358],
            [-19.770607439255073, 6.768589989911925],
            [-19.767263911479922, 6.77165689006106],
            [-19.769113057338792, 6.775888527053315],
            [-19.76351587735834, 6.78340328322592],
            [-19.763504163701167, 6.787867716950597],
            [-19.759797106029925, 6.796356893722574],
            [-19.75925255394918, 6.800163449912047],
            [-19.761270162622516, 6.805124295909854],
            [-19.76431821225903, 6.806878454321072],
            [-19.760146359580812, 6.81264319054034],
            [-19.754944565390783, 6.811621837559185],
            [-19.75234947468836, 6.814063697669192],
            [-19.74824698995121, 6.812444615012705],
            [-19.744110761927086, 6.813234133418618],
            [-19.74403796476025, 6.809750523493805],
            [-19.738492982817107, 6.807434613060874],
            [-19.734903030893, 6.804037910975787],
            [-19.72632093896674, 6.805030796500076],
            [-19.7243560725183, 6.8038361644921554],
            [-19.714906063104547, 6.804226789581645],
            [-19.710029877007827, 6.802529029756529],
            [-19.708352041339758, 6.797813820849906],
            [-19.704375436249258, 6.7939918117911535],
            [-19.698162159169325, 6.792306822731897],
            [-19.686824636956434, 6.793525209148395],
            [-19.683969883316845, 6.791886267719297],
            [-19.67614928725598, 6.791888203627489],
            [-19.671852292443145, 6.794322793805535],
            [-19.669927450193235, 6.798096478442711],
            [-19.661809947526017, 6.800717433200791],
            [-19.66214321832254, 6.807826979841432],
            [-19.660822584241085, 6.812324512878437],
            [-19.652652858166658, 6.820846313209405],
            [-19.65035308900376, 6.821391638936668],
            [-19.641175662870964, 6.829416498739129],
            [-19.636655709333944, 6.832183661760241],
            [-19.63817987443615, 6.838554900321791],
            [-19.636896249841456, 6.845277586615025],
            [-19.630199242178502, 6.850129671632065],
            [-19.626361499160964, 6.854110297280681],
            [-19.623370284617838, 6.862751409200502],
            [-19.606593540651023, 6.869570591112268],
            [-19.602198477596037, 6.879774535666795],
            [-19.596393839009597, 6.881191642417105],
            [-19.59297535297218, 6.886491579455903],
            [-19.593272351018097, 6.8913307463065285],
            [-19.59657793355639, 6.898158390621716],
            [-19.598629724635533, 6.899251376874503],
            [-19.596439890010874, 6.905393189602971],
            [-19.5370109422215, 6.958677811472966],
            [-19.534266248129423, 6.962096477696838],
            [-19.531134217212944, 6.962721446090575],
            [-19.526184102149436, 6.969121249022912],
            [-19.51905864293706, 6.974336845725717],
            [-19.51577563935093, 6.978963018526103],
            [-19.516169521404716, 6.9812775966667],
            [-19.50744025612379, 6.993240653314872],
            [-19.505918380133448, 6.993347614803472],
            [-19.49582185467775, 7.001327750158124],
            [-19.49492210774754, 7.005413269726483],
            [-19.488109212733953, 7.015528660032471],
            [-19.48433812263967, 7.018674589790948],
            [-19.478654997150862, 7.019476509511054],
            [-19.47578514632447, 7.024329770117324],
            [-19.47218513039723, 7.026540781465597]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.55546212920427,
          "lat": 42.36547144094872
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41033"],
        "coty_name": ["Josephine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Josephine County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01155133"
      },
      "bbox": [
        -19.816596200544552, 6.178033845077837, -19.15486678424914,
        7.026540781465597
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.358574326022677, -5.435876100627823],
            [7.420305023732574, -5.431990347178763],
            [7.433704948528046, -5.431417453258658],
            [7.514683805826428, -5.424756926642681],
            [7.547195895686906, -5.421973094395081],
            [7.602734808840108, -5.4177221901061365],
            [7.6040764261080085, -5.426128401637456],
            [7.614106911417229, -5.530125061272887],
            [7.615034412957408, -5.5462228363043184],
            [7.6188401234932215, -5.58979741157779],
            [7.576613503774798, -5.593799775891815],
            [7.5774802688352185, -5.607488913844526],
            [7.5844546442795115, -5.680719718582282],
            [7.584486825326616, -5.696055656406858],
            [7.590914075482623, -5.768156236990568],
            [7.548173108622894, -5.772124411371377],
            [7.551325521221879, -5.8086547752129825],
            [7.562166304292045, -5.923599832468887],
            [7.564323564673854, -5.945143615526849],
            [7.505391518518043, -5.95067283126211],
            [7.408949218098936, -5.960058643832813],
            [7.393734856146523, -5.96124479146319],
            [7.390109127681652, -5.917770874447392],
            [7.319910039798499, -5.92380376242589],
            [7.328215051646, -5.913412267867925],
            [7.330599628683371, -5.9036586185437665],
            [7.3284411672387035, -5.89338884817002],
            [7.326625127277984, -5.888756510420855],
            [7.328056148419931, -5.884037530310267],
            [7.330680385753618, -5.882730223035427],
            [7.334437076582707, -5.886935388862892],
            [7.3365645749169035, -5.886443862767539],
            [7.338146445634591, -5.8791952183080705],
            [7.335664210976357, -5.8644830060688244],
            [7.340772941741151, -5.860939610002579],
            [7.347697163469176, -5.8634643156934345],
            [7.350862306647865, -5.867681882135702],
            [7.3504408114310404, -5.87310679946595],
            [7.352329071242939, -5.877212521590011],
            [7.355342473085421, -5.877208289397277],
            [7.358453821797301, -5.873992120985641],
            [7.360817078080112, -5.865721994052295],
            [7.363557395657426, -5.861502171450893],
            [7.372013304327545, -5.85608122075214],
            [7.3768842963161765, -5.855018349542704],
            [7.376760408082965, -5.852653972360436],
            [7.371137889726458, -5.846004770213026],
            [7.366320529224105, -5.834921599419637],
            [7.365265583261259, -5.830887122143633],
            [7.360883254902115, -5.830002967154989],
            [7.353211732951281, -5.832584661372576],
            [7.349049163353075, -5.835863862313432],
            [7.342539709775022, -5.838080913560959],
            [7.33736964687635, -5.841296677688499],
            [7.32801677010269, -5.839113788778779],
            [7.3242629057595625, -5.837187334494867],
            [7.316557572285689, -5.828972159323589],
            [7.31407359175058, -5.821333949993909],
            [7.309748712329203, -5.814906225655906],
            [7.312038305266762, -5.810428948540214],
            [7.326837894242394, -5.809935100564691],
            [7.342099060635525, -5.804256126702235],
            [7.35165260378462, -5.808764289132222],
            [7.3601069981109815, -5.810857458990018],
            [7.365519892685438, -5.799011631820244],
            [7.366782581254705, -5.792038739375202],
            [7.3638161310079875, -5.78687855834068],
            [7.358475729050205, -5.785070812856185],
            [7.353010185024172, -5.7923188517185515],
            [7.344849844428413, -5.795919919136746],
            [7.333670368545254, -5.794252069467464],
            [7.3294592544014305, -5.7928342224483185],
            [7.325872405405358, -5.788798048084988],
            [7.3231992033861, -5.781354225643009],
            [7.3240576490920395, -5.778031822382434],
            [7.32734276407588, -5.774246147927387],
            [7.328880408963251, -5.768058447573879],
            [7.3279097487615354, -5.764521813221573],
            [7.32181398401464, -5.758393983018276],
            [7.318221595605552, -5.749320758256851],
            [7.318239012683855, -5.745417482440789],
            [7.3202527033586575, -5.739840368121345],
            [7.317138631909542, -5.732146963866599],
            [7.310072793750656, -5.733592867121701],
            [7.305906815635551, -5.736801134383953],
            [7.302397234605565, -5.742459172199775],
            [7.294467818981152, -5.743010338845436],
            [7.2884398360957015, -5.737401447631981],
            [7.287283481635155, -5.733025142105188],
            [7.288205852671473, -5.724967465576283],
            [7.290830410319262, -5.7189285572529105],
            [7.294924593088748, -5.716060570542268],
            [7.304381472496026, -5.715751554384541],
            [7.30609118865582, -5.714832980833],
            [7.307859084331593, -5.705522202013775],
            [7.306633527623818, -5.700688450572718],
            [7.3037566720825104, -5.696386442118537],
            [7.290183766446719, -5.683965180417073],
            [7.284011963706448, -5.6807940922714915],
            [7.279720605643829, -5.683651727411353],
            [7.281596254108782, -5.689435032768537],
            [7.2800132066211525, -5.69094013834164],
            [7.268186005164879, -5.692268141419459],
            [7.2600593349644145, -5.695760908993957],
            [7.2514001254563505, -5.69176608421259],
            [7.254771463920051, -5.679158483036329],
            [7.265228809750943, -5.679496745690518],
            [7.270391416028262, -5.6737509585307455],
            [7.277000525412355, -5.669463310761991],
            [7.27949469223974, -5.662461111567156],
            [7.28211971650928, -5.6585935692988825],
            [7.288999498401708, -5.655369617970058],
            [7.291199379194795, -5.650446846779008],
            [7.290013259826915, -5.644853058180878],
            [7.294677506644564, -5.639084237180855],
            [7.290368126436679, -5.633840998098795],
            [7.292004627370668, -5.627585409040819],
            [7.287196827109867, -5.622957512798154],
            [7.289677218484166, -5.616719734951899],
            [7.28684446345237, -5.61341041353047],
            [7.2766012660288695, -5.6101568261738874],
            [7.275737869503488, -5.604869216073449],
            [7.2789896545409745, -5.601644665549942],
            [7.285314264712317, -5.601492825506814],
            [7.28500030030922, -5.598315759740076],
            [7.277326659001316, -5.597025517916652],
            [7.274575397155729, -5.594169967094754],
            [7.274633000363855, -5.585842227092487],
            [7.282888188299115, -5.58588874461516],
            [7.284212148738933, -5.583520688557592],
            [7.282310122042269, -5.578629427499915],
            [7.281148500497764, -5.569547511832085],
            [7.285675819826331, -5.568745608102535],
            [7.289253522910265, -5.571782230227677],
            [7.290989905114074, -5.569972504547496],
            [7.290716721448999, -5.565415590070967],
            [7.28335445354877, -5.561267765558655],
            [7.285590116432383, -5.557702413084],
            [7.288265027314502, -5.5611232794145895],
            [7.293276353973193, -5.561897584657645],
            [7.294414590674647, -5.559454633805837],
            [7.29286260357039, -5.554826640322026],
            [7.294566287563879, -5.551305670649336],
            [7.298070926199757, -5.553658761215507],
            [7.303182927441058, -5.549641039843486],
            [7.3099436191891325, -5.552637851078628],
            [7.312452186896252, -5.551923913331728],
            [7.315476486284555, -5.545092838983183],
            [7.319593582619243, -5.543992495722991],
            [7.324307823919989, -5.5472995663913505],
            [7.3261943981638415, -5.541313122894928],
            [7.328775897794192, -5.537189483634513],
            [7.325613005976409, -5.535572065872134],
            [7.32160913484695, -5.529313433025325],
            [7.3168881551489955, -5.526771714833346],
            [7.316269029182995, -5.519927802227291],
            [7.320373896941426, -5.519624497947045],
            [7.3245364288536825, -5.521718706012021],
            [7.3247897204505, -5.514585128150681],
            [7.32908709176812, -5.510477552036069],
            [7.332577119000954, -5.517218964019424],
            [7.33622876193756, -5.513647472826787],
            [7.329888349650846, -5.510420282194849],
            [7.3317126902570235, -5.508618623734998],
            [7.336076274638082, -5.509958953376787],
            [7.343427223890271, -5.508541735646212],
            [7.3502953227103305, -5.498184483837768],
            [7.351793425216222, -5.4943494386030425],
            [7.347469965129568, -5.491388727200401],
            [7.337044296213186, -5.495838894925362],
            [7.336382645680359, -5.490416698033161],
            [7.343668178063082, -5.485357150829131],
            [7.33611464763876, -5.479302625915964],
            [7.336021822879654, -5.473111945379068],
            [7.332776766336977, -5.46898908152422],
            [7.332893864464197, -5.466327449687669],
            [7.3403859286334265, -5.466024958701844],
            [7.345106483808042, -5.469476574698909],
            [7.350322310037923, -5.457721675695331],
            [7.363069955931547, -5.456416290855103],
            [7.366809311035549, -5.452149964395784],
            [7.366300318009067, -5.444519637391312],
            [7.360879070385412, -5.440879626487361],
            [7.358574326022677, -5.435876100627823]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.62915308006073,
          "lat": 32.762722009237415
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01065"],
        "coty_name": ["Hale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hale County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00161558"
      },
      "bbox": [
        7.2514001254563505, -5.96124479146319, 7.6188401234932215,
        -5.4177221901061365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-15.559141928823534, -10.792006043179372],
              [-15.557517677360726, -10.791401055096122],
              [-15.55532491332287, -10.795184527575632],
              [-15.555373209188705, -10.797675367555874],
              [-15.553762073362138, -10.802041442572142],
              [-15.55343654397266, -10.804231717141281],
              [-15.552126951517367, -10.807690156610375],
              [-15.551891610983043, -10.810681860208147],
              [-15.551116986173488, -10.812229050779182],
              [-15.552435527857847, -10.812376679019579],
              [-15.554709195213897, -10.811168695609574],
              [-15.556061399911862, -10.811652401492609],
              [-15.5557531395128, -10.809494590524706],
              [-15.556373862695304, -10.808133017041843],
              [-15.555814229344065, -10.807389610581955],
              [-15.555397925954196, -10.804553969046543],
              [-15.555679632395602, -10.802937396939383],
              [-15.5573579763324, -10.80065133101729],
              [-15.558116487031505, -10.79835802599943],
              [-15.557773774992462, -10.79615612285612],
              [-15.558890091909273, -10.795115447834503],
              [-15.559424192046166, -10.79320499317288],
              [-15.559141928823534, -10.792006043179372]
            ]
          ],
          [
            [
              [-15.571126277715727, -10.757275101439484],
              [-15.570100900331175, -10.75688130440407],
              [-15.566966296426349, -10.757506421774034],
              [-15.565814580830017, -10.756558087175767],
              [-15.561299139724733, -10.75805718323428],
              [-15.557322838684488, -10.758724878603038],
              [-15.556232848166317, -10.758485550903272],
              [-15.553831248237701, -10.759213067550538],
              [-15.5519349924185, -10.762697018611812],
              [-15.550936140962964, -10.765195928410641],
              [-15.550368448713966, -10.768997075976959],
              [-15.550756823309094, -10.771986410356368],
              [-15.553321090794759, -10.777191180382923],
              [-15.55633312194031, -10.772664544134756],
              [-15.559085728701382, -10.76958921557392],
              [-15.561419117683283, -10.767362689650186],
              [-15.565624655870534, -10.76375299507646],
              [-15.568953305764417, -10.761545392748666],
              [-15.57083084239291, -10.758429287178187],
              [-15.571126277715727, -10.757275101439484]
            ]
          ],
          [
            [
              [-15.582802149832606, -10.88563370825409],
              [-15.582242947324108, -10.883972000312855],
              [-15.582285463807876, -10.882228208465413],
              [-15.58171019820736, -10.878939835381912],
              [-15.579705381232468, -10.873620220821318],
              [-15.579295159092, -10.871522457470705],
              [-15.579211028615182, -10.86776472144154],
              [-15.578697287381917, -10.864072384004848],
              [-15.57510818708379, -10.858991837296939],
              [-15.573782943772216, -10.856268230779776],
              [-15.571800951401908, -10.852870199868612],
              [-15.569759917327401, -10.850170924981594],
              [-15.56795790419705, -10.848710476394116],
              [-15.566806380970462, -10.84597039366857],
              [-15.564093318486437, -10.842718758936435],
              [-15.561116608461266, -10.83785068509103],
              [-15.560979035795771, -10.836792786358405],
              [-15.562046121953738, -10.835532534897256],
              [-15.561158953888002, -10.831877058037584],
              [-15.560029429815799, -10.830720005553806],
              [-15.557318922090284, -10.831744970161822],
              [-15.555440506752758, -10.829982221582368],
              [-15.554039961744635, -10.829242208440393],
              [-15.552656371608363, -10.82725915757739],
              [-15.549912484457739, -10.822301040958601],
              [-15.546427165343921, -10.81839833065422],
              [-15.54635785212297, -10.816894950176065],
              [-15.547020384634717, -10.814418779954286],
              [-15.546743313167285, -10.813466544913064],
              [-15.545399868022837, -10.812360800581752],
              [-15.545153417927725, -10.811206072695724],
              [-15.54376328691426, -10.810134851675572],
              [-15.54168437149982, -10.811991249710983],
              [-15.540254970061634, -10.811743379040974],
              [-15.538045415130515, -10.809433691717883],
              [-15.529067271143287, -10.80423394132425],
              [-15.527358970838328, -10.801954107924203],
              [-15.52644375969559, -10.803022998353143],
              [-15.524319234265075, -10.803500976787973],
              [-15.521962866133379, -10.80357140766607],
              [-15.52242613574968, -10.805214699302752],
              [-15.523307590046764, -10.80575788185575],
              [-15.526808432536143, -10.81004206564959],
              [-15.530572145185248, -10.813991055748476],
              [-15.533776148141266, -10.817774983469699],
              [-15.537371659793578, -10.821200243569741],
              [-15.542591323937584, -10.827806591201469],
              [-15.544227442979876, -10.829495360379225],
              [-15.54498429017984, -10.830891436975238],
              [-15.547592754055007, -10.833384362829483],
              [-15.547985308431405, -10.834977529514873],
              [-15.548977709519214, -10.836490672047693],
              [-15.551330590385644, -10.83873863643208],
              [-15.554906724311795, -10.842657251213705],
              [-15.558705638283527, -10.851346346923929],
              [-15.55862045651828, -10.85220758031426],
              [-15.560242004990886, -10.85489195243023],
              [-15.565380319675535, -10.85882423197913],
              [-15.571255054290662, -10.867519384336736],
              [-15.574065688775951, -10.874201795261433],
              [-15.57623385872038, -10.87896326029351],
              [-15.577595700761634, -10.87886313348711],
              [-15.579761267125889, -10.882791287953378],
              [-15.581316758891598, -10.884550859394398],
              [-15.582802149832606, -10.88563370825409]
            ]
          ],
          [
            [
              [-15.69207961044964, -10.715601432816934],
              [-15.69188251363105, -10.712214483315407],
              [-15.690698841501451, -10.705174566784905],
              [-15.689779068207228, -10.702840899822993],
              [-15.688034951257848, -10.700192866961375],
              [-15.686418507747076, -10.698421983020472],
              [-15.684989560889942, -10.699787011049711],
              [-15.68499218296861, -10.702162358760559],
              [-15.685453216287579, -10.703616346636867],
              [-15.687042421906884, -10.706490753047055],
              [-15.688968738672319, -10.71113086991973],
              [-15.68977611711317, -10.712180806402378],
              [-15.69088927364309, -10.7155257478499],
              [-15.69207961044964, -10.715601432816934]
            ]
          ],
          [
            [
              [-15.791426111217719, -10.703472399273537],
              [-15.789792585674036, -10.70269741989726],
              [-15.786258338379305, -10.702584350608836],
              [-15.784979429589246, -10.702261368532211],
              [-15.784635090601174, -10.70364868014483],
              [-15.787015204978383, -10.704394894586898],
              [-15.791007999416397, -10.704155745889665],
              [-15.791426111217719, -10.703472399273537]
            ]
          ],
          [
            [
              [-15.816285469104782, -10.636592387430843],
              [-15.816550987444764, -10.63579260894353],
              [-15.815811002659744, -10.633712327299797],
              [-15.81417375901564, -10.633531293413744],
              [-15.813823772411377, -10.635153050220774],
              [-15.81407213406413, -10.636584600309305],
              [-15.816285469104782, -10.636592387430843]
            ]
          ],
          [
            [
              [-15.82717901616496, -10.631653044793046],
              [-15.826911481601922, -10.630037966479305],
              [-15.825035394859206, -10.629159821047235],
              [-15.825599965799233, -10.631014086088369],
              [-15.82717901616496, -10.631653044793046]
            ]
          ],
          [
            [
              [-15.857755839102488, -10.611671436878567],
              [-15.856587310982903, -10.61057762996321],
              [-15.855834617342358, -10.611352441050931],
              [-15.856861478073425, -10.612454438713307],
              [-15.857755839102488, -10.611671436878567]
            ]
          ],
          [
            [
              [-15.864018004080789, -10.615382126908951],
              [-15.86136837202717, -10.614155952577189],
              [-15.860224676982579, -10.612987286844323],
              [-15.859577701979527, -10.614752385598846],
              [-15.862342793961933, -10.61587131232506],
              [-15.864018004080789, -10.615382126908951]
            ]
          ],
          [
            [
              [-15.852696213702803, -10.710260166527972],
              [-15.847797195973051, -10.707186705934951],
              [-15.84596800836924, -10.706641935595918],
              [-15.84319225041735, -10.705085710294016],
              [-15.84076126724518, -10.705407043063122],
              [-15.836513576918932, -10.706407642543226],
              [-15.835291187420365, -10.707281426611445],
              [-15.832341134642483, -10.707456902221368],
              [-15.831018781413432, -10.705827543554133],
              [-15.826921436651691, -10.706271447740978],
              [-15.821666511993898, -10.70837071408964],
              [-15.821199532043591, -10.709131075075373],
              [-15.819396358981074, -10.709361271933304],
              [-15.815484941199056, -10.708639510622287],
              [-15.81247833725675, -10.70729162545358],
              [-15.809029754237834, -10.70682871786848],
              [-15.807424206575895, -10.707449018013056],
              [-15.80598968805624, -10.709642824734843],
              [-15.805866164777644, -10.711262447439209],
              [-15.80664968988183, -10.716141487752248],
              [-15.80712643134028, -10.717590469363126],
              [-15.809357347256222, -10.719540224406028],
              [-15.81122302107904, -10.720463828750804],
              [-15.816806746521593, -10.722044859650838],
              [-15.819873257667522, -10.722294964362824],
              [-15.824495257547571, -10.721342457857114],
              [-15.826360646987226, -10.720627689356736],
              [-15.828966561665998, -10.718612245592958],
              [-15.831117761288823, -10.715602100165064],
              [-15.834496101112714, -10.714987474531831],
              [-15.837329907241916, -10.714102067838033],
              [-15.84838159761211, -10.712809505897878],
              [-15.851396859690981, -10.71210662938264],
              [-15.852696213702803, -10.710260166527972]
            ]
          ],
          [
            [
              [-15.857391532076807, -10.687813149805551],
              [-15.85672625803697, -10.685859846194877],
              [-15.85281133310882, -10.686576247160746],
              [-15.853149549611267, -10.687838884652606],
              [-15.857183355646484, -10.689173881585901],
              [-15.857391532076807, -10.687813149805551]
            ]
          ],
          [
            [
              [-15.91108970429659, -10.693525844514559],
              [-15.910207984662645, -10.692285080665112],
              [-15.91019267187241, -10.691021025644737],
              [-15.908837797620718, -10.688220524123638],
              [-15.909284528637535, -10.68513752935201],
              [-15.910130892568619, -10.684583111063573],
              [-15.9095070183108, -10.682558952000647],
              [-15.910550299536563, -10.680684345883341],
              [-15.90838987874072, -10.680193701439336],
              [-15.906579650453425, -10.677790328189618],
              [-15.905239430113458, -10.67454606512838],
              [-15.902913655528252, -10.674075951404708],
              [-15.900120590997654, -10.674080320578309],
              [-15.897861600052888, -10.673738863274378],
              [-15.893770818423317, -10.672575573008402],
              [-15.892303727909903, -10.671795744281928],
              [-15.890237847240124, -10.669848749643286],
              [-15.88363697473563, -10.668064836037692],
              [-15.882504911419032, -10.66825828063252],
              [-15.8807077223576, -10.669878418777705],
              [-15.877644739736489, -10.667364902040491],
              [-15.876506577168701, -10.665239560999277],
              [-15.87589187159279, -10.662525201963247],
              [-15.874764470162798, -10.664710146492173],
              [-15.873249203834138, -10.664003684743818],
              [-15.872076786689904, -10.66183338032538],
              [-15.869455797026966, -10.660102183129617],
              [-15.862429972040035, -10.65748366975793],
              [-15.862233088464352, -10.656078615547747],
              [-15.860383469062256, -10.656103018843625],
              [-15.86014745679659, -10.655018772596394],
              [-15.860859100241665, -10.653234235123307],
              [-15.85928334087162, -10.653371945575962],
              [-15.858648097402813, -10.652199842930466],
              [-15.859145004937925, -10.651161957324488],
              [-15.857723217570792, -10.650383525732037],
              [-15.855770693181118, -10.65124802249452],
              [-15.854667817623143, -10.652538421706904],
              [-15.853290003277491, -10.653064823259228],
              [-15.851298744765478, -10.652908043047697],
              [-15.849854566775116, -10.653304390446989],
              [-15.84749306135456, -10.652493242801238],
              [-15.85144175276372, -10.65142183638364],
              [-15.850791727146122, -10.650044285286043],
              [-15.852318936329608, -10.648642485714488],
              [-15.8510060525154, -10.646658030411144],
              [-15.850816540431428, -10.645538632168666],
              [-15.849235041550955, -10.645065115168993],
              [-15.848324246725223, -10.644143751381167],
              [-15.843755119614098, -10.644285606943287],
              [-15.842610287812118, -10.641955221823087],
              [-15.84109027615251, -10.641650353253633],
              [-15.83817318368415, -10.642353862458638],
              [-15.835819610871644, -10.641500883041278],
              [-15.833547955720986, -10.641631802246687],
              [-15.82968510031414, -10.640066686520342],
              [-15.82685785793765, -10.638098521939963],
              [-15.824566451499136, -10.637088123309125],
              [-15.823910851483687, -10.634166369749899],
              [-15.82281138307014, -10.632164892703477],
              [-15.821263275502371, -10.630798719363456],
              [-15.819276228910285, -10.629987108277861],
              [-15.819461789053603, -10.63175495721979],
              [-15.822361160084348, -10.635722736931294],
              [-15.82379389686542, -10.63833378226218],
              [-15.823334413180389, -10.639699055851398],
              [-15.82053745278095, -10.639763259614051],
              [-15.820437359233473, -10.637964231697673],
              [-15.818514201265081, -10.637931586528518],
              [-15.819007443940214, -10.640510250428727],
              [-15.820657636440357, -10.642377549995558],
              [-15.821495078438792, -10.644836607608255],
              [-15.823181888171934, -10.645773990191838],
              [-15.8231868163259, -10.64670915693745],
              [-15.824682079030104, -10.649817630237012],
              [-15.826380141322268, -10.65099966928311],
              [-15.827654321259988, -10.653268598905159],
              [-15.829741789768942, -10.653644300889816],
              [-15.831491535582474, -10.655076283960717],
              [-15.834298261883887, -10.656595138390903],
              [-15.837303956945895, -10.658828789542849],
              [-15.840793330985587, -10.66246206816126],
              [-15.842905051930158, -10.663976884942759],
              [-15.845592577160014, -10.664828454714074],
              [-15.847892122232878, -10.666161610443792],
              [-15.848414928117453, -10.666915615293735],
              [-15.851370563461511, -10.669262358122321],
              [-15.85300607770807, -10.66966086801387],
              [-15.855232238154901, -10.671268762988719],
              [-15.856253783471313, -10.67265163912419],
              [-15.859957987087856, -10.67394614987377],
              [-15.86011834807783, -10.674982697610615],
              [-15.864274576223503, -10.67897482646577],
              [-15.86588274897412, -10.680956142300369],
              [-15.866678680920804, -10.681172040280899],
              [-15.867804553963857, -10.68272999116694],
              [-15.868762858293639, -10.682964845271998],
              [-15.869878091422375, -10.684277186765263],
              [-15.874566769152272, -10.686985868004538],
              [-15.87880156734104, -10.68870278548251],
              [-15.880726587289704, -10.690475475189936],
              [-15.881960041729482, -10.690822895056574],
              [-15.886887939599971, -10.693636135865978],
              [-15.888751935482228, -10.694218920288314],
              [-15.889639407634444, -10.695054800285552],
              [-15.89284051866881, -10.696158266012887],
              [-15.894273396844806, -10.69587553009172],
              [-15.896331347168733, -10.696560714976396],
              [-15.898229884461452, -10.696168085183674],
              [-15.900156691119012, -10.696919166266232],
              [-15.90289551435309, -10.69707024064737],
              [-15.907355954476886, -10.696928692031104],
              [-15.9094042377479, -10.696306709612367],
              [-15.91108970429659, -10.693525844514559]
            ]
          ],
          [
            [
              [-15.97535821686134, -10.729265998319095],
              [-15.974878199854352, -10.72766392905136],
              [-15.972399651418524, -10.726988222419768],
              [-15.971929209364072, -10.725305731317677],
              [-15.97292378184763, -10.72341544830749],
              [-15.97307734514901, -10.722045685827041],
              [-15.971427385413989, -10.720970271650591],
              [-15.9711788341126, -10.719149524295892],
              [-15.972164072314545, -10.718441192945933],
              [-15.971377946413263, -10.716644134936821],
              [-15.968911878749852, -10.713320441703953],
              [-15.966743790196807, -10.712840097451691],
              [-15.965850129836538, -10.711642776273502],
              [-15.965801574330651, -10.70988588875135],
              [-15.966899786396265, -10.708539088763716],
              [-15.965623854497426, -10.705630739061096],
              [-15.964809537881958, -10.702284854514964],
              [-15.963895283791299, -10.70019053121993],
              [-15.960530834858279, -10.6950610870108],
              [-15.96059568343083, -10.69376623411501],
              [-15.959118538965145, -10.69230261151945],
              [-15.956437173327672, -10.69131638907701],
              [-15.953365174423697, -10.691954665133066],
              [-15.950815140980955, -10.69090027070545],
              [-15.947754710901895, -10.690358176513572],
              [-15.94651638010879, -10.689692185750054],
              [-15.944209902062223, -10.692243541127269],
              [-15.942377257549436, -10.69281296619321],
              [-15.9417724033629, -10.694495753714055],
              [-15.938030588931293, -10.69379406821062],
              [-15.936937023275421, -10.69436415978337],
              [-15.933892577039222, -10.692965489084342],
              [-15.931099427976111, -10.69436212882532],
              [-15.929533991338497, -10.694390089039464],
              [-15.927421975229196, -10.693460557443773],
              [-15.925889345503947, -10.692148288407473],
              [-15.924613214172739, -10.690050838582405],
              [-15.923282485442325, -10.689127508911769],
              [-15.921893891662258, -10.68905200201104],
              [-15.92130765540958, -10.688090536458372],
              [-15.919569259930453, -10.688545122804085],
              [-15.918863074508762, -10.690011645644066],
              [-15.91496727197754, -10.690628027426278],
              [-15.914775570539833, -10.691909167249888],
              [-15.913410885119626, -10.69232404323557],
              [-15.914162465425786, -10.694323351598264],
              [-15.914501808143422, -10.696683061147434],
              [-15.915776196815237, -10.69809060912706],
              [-15.917234098183433, -10.698988803708957],
              [-15.91608684341045, -10.69999967166299],
              [-15.914727081019553, -10.699315785080126],
              [-15.914419856472483, -10.70192903789088],
              [-15.91369794316054, -10.703517960956503],
              [-15.914388283315825, -10.705348864854951],
              [-15.914385390679904, -10.706775087314359],
              [-15.912270987643167, -10.709348159643362],
              [-15.913203246847361, -10.713328446393826],
              [-15.90932492342896, -10.71337692598366],
              [-15.907927977194813, -10.712646838041312],
              [-15.903634789509896, -10.70958703028508],
              [-15.901105571185738, -10.708685799957058],
              [-15.89963299112991, -10.708598637332472],
              [-15.897257041070025, -10.707795773468334],
              [-15.895600994929898, -10.70683021482645],
              [-15.894577913381736, -10.707120488291217],
              [-15.89261110601836, -10.70668975971628],
              [-15.890501546476983, -10.705386052224181],
              [-15.888592190183031, -10.705165276848087],
              [-15.886473864379987, -10.703941076384526],
              [-15.883636366962007, -10.702877989119502],
              [-15.880941197636098, -10.702686952796393],
              [-15.878333510470567, -10.701771253885157],
              [-15.877919071321955, -10.701111388144753],
              [-15.874881467389796, -10.70034874570879],
              [-15.87363899356061, -10.700407102989404],
              [-15.87308659674648, -10.70156587702233],
              [-15.874543868868761, -10.702796791264522],
              [-15.872675269094271, -10.706657257565283],
              [-15.87124669327049, -10.706204484058679],
              [-15.870284464577095, -10.70666289216372],
              [-15.867121840506062, -10.706576986391447],
              [-15.866183255686598, -10.707853875151724],
              [-15.866430130882355, -10.71090321120026],
              [-15.866253139875866, -10.713372462871881],
              [-15.865148020774688, -10.717366973683063],
              [-15.863675452198716, -10.719971275441512],
              [-15.86233496729704, -10.721488522296799],
              [-15.863305651191938, -10.722665317852293],
              [-15.869555713908422, -10.722173489025574],
              [-15.874744178690763, -10.722943650625325],
              [-15.877416963284794, -10.723704770063353],
              [-15.87949112745903, -10.724640702104987],
              [-15.882052954834093, -10.726327332268196],
              [-15.882058980496156, -10.729025025318341],
              [-15.882469053863195, -10.730421247023026],
              [-15.883831257265705, -10.73111059636574],
              [-15.886044631002127, -10.731244095171206],
              [-15.888089058782638, -10.732788249400347],
              [-15.89113970895799, -10.736287847291543],
              [-15.892618260184996, -10.736008296283819],
              [-15.892822472433007, -10.734641604607797],
              [-15.895436683425759, -10.733838587806776],
              [-15.899933672319642, -10.734558360003195],
              [-15.906459528498367, -10.73697879517441],
              [-15.912682897125704, -10.74058791360465],
              [-15.92180614167466, -10.74734176892655],
              [-15.92401808838106, -10.749635058600969],
              [-15.925686168484361, -10.750926472598954],
              [-15.926366211640767, -10.752189015154245],
              [-15.929799590780782, -10.75465928914829],
              [-15.931196197626505, -10.75616537646192],
              [-15.932368140917593, -10.758546962074325],
              [-15.934172659412756, -10.760466892117984],
              [-15.935811880883191, -10.761672357480887],
              [-15.936044533859517, -10.76288509502154],
              [-15.937068188565693, -10.76369476921348],
              [-15.93914366662282, -10.76687298013916],
              [-15.93995594344682, -10.767003508985551],
              [-15.94246927169649, -10.76998448500256],
              [-15.94440540322379, -10.771508790657943],
              [-15.945414422802708, -10.77354505435577],
              [-15.948440382621945, -10.776049406041944],
              [-15.948825099080361, -10.77703383557333],
              [-15.951899819616836, -10.77802657476087],
              [-15.954603461748121, -10.77791250435243],
              [-15.956280614459619, -10.777358043185497],
              [-15.956417630286076, -10.776512826460724],
              [-15.95800439625933, -10.774555776313692],
              [-15.957696773263288, -10.77288385694787],
              [-15.958255960696558, -10.771961718641455],
              [-15.962424678812228, -10.772046939414855],
              [-15.963137793491518, -10.771223633422712],
              [-15.96340625861831, -10.76957383619885],
              [-15.964759246214856, -10.768942840430437],
              [-15.965848812901916, -10.766973694320349],
              [-15.966175811880394, -10.764062398039584],
              [-15.964492615073661, -10.762488703233904],
              [-15.964347879321599, -10.761204799870045],
              [-15.963105176773347, -10.760128701399214],
              [-15.960977683969896, -10.76030631959116],
              [-15.961005988566802, -10.758223326584535],
              [-15.959261750430622, -10.755742553296098],
              [-15.956195752468204, -10.756184946591715],
              [-15.955680676420895, -10.754533476637317],
              [-15.954362896699726, -10.75303995335437],
              [-15.954119522673176, -10.751909202871333],
              [-15.952542890239638, -10.751245597767522],
              [-15.95183260069507, -10.750227462737998],
              [-15.949468865844741, -10.748863925156616],
              [-15.947688224593199, -10.748545315124284],
              [-15.947458666920793, -10.747661409971647],
              [-15.944991355703879, -10.746490012270536],
              [-15.945520545453533, -10.744750209377896],
              [-15.944633099666541, -10.742404496505738],
              [-15.94143162476526, -10.741886745216476],
              [-15.940596960390375, -10.742325742675765],
              [-15.939166815843024, -10.74184027490546],
              [-15.937497414430968, -10.739488995067592],
              [-15.93898750103116, -10.739450223571819],
              [-15.939593460510784, -10.738128649804874],
              [-15.937479793218795, -10.734626039594474],
              [-15.937417601640979, -10.732658784837664],
              [-15.938241265629513, -10.732668710506664],
              [-15.942489765809833, -10.735181928454772],
              [-15.945736959649032, -10.736725554656887],
              [-15.948987487656002, -10.73679821694046],
              [-15.950835773213317, -10.736144084153649],
              [-15.95398119957564, -10.736775525569042],
              [-15.954085671872235, -10.739849741309762],
              [-15.95629683114602, -10.74254308730513],
              [-15.956711640521762, -10.744345545011235],
              [-15.95835037482221, -10.745546156455813],
              [-15.959971841046363, -10.746172611992316],
              [-15.961181886073039, -10.74569161070369],
              [-15.962587808745267, -10.743107441934551],
              [-15.965183914480278, -10.741306898611011],
              [-15.967221773885226, -10.740793071815627],
              [-15.969177882946946, -10.741372996334185],
              [-15.969920663984437, -10.742106685881184],
              [-15.972085539984233, -10.74266771161161],
              [-15.972655666136328, -10.740891620456493],
              [-15.97380069771285, -10.7395047291077],
              [-15.974361421342305, -10.737442110745738],
              [-15.97372724435536, -10.73647559486423],
              [-15.973183554553716, -10.733967895799797],
              [-15.974766558381146, -10.731609054870797],
              [-15.97535821686134, -10.729265998319095]
            ]
          ],
          [
            [
              [-16.009407500895158, -10.554574536525479],
              [-16.00749102151838, -10.554671004618168],
              [-16.007377656506407, -10.553313340720624],
              [-16.00455192657741, -10.552287812820177],
              [-16.002936771066846, -10.55295812630275],
              [-16.002293298684382, -10.554917359655745],
              [-16.001363886259007, -10.555982480403861],
              [-15.999097790471376, -10.556662979581148],
              [-16.000762138420477, -10.55774601447941],
              [-16.003505928562475, -10.558060715348953],
              [-16.00440720449444, -10.557614651109068],
              [-16.004487520285313, -10.555976128640978],
              [-16.005094137679823, -10.555077024637203],
              [-16.007643663514962, -10.555490543964055],
              [-16.009407500895158, -10.554574536525479]
            ]
          ],
          [
            [
              [-16.006562136600355, -10.581071352147072],
              [-16.00580115664998, -10.57968185159147],
              [-16.00664200936571, -10.576853591255169],
              [-16.006484040424414, -10.574422363808303],
              [-16.00736295437716, -10.573268725335648],
              [-16.00744707166778, -10.571588340393062],
              [-16.006702782490866, -10.570422905872588],
              [-16.00469459437282, -10.56912221757558],
              [-16.005619796886887, -10.567733263666224],
              [-16.004432852331842, -10.565253952584257],
              [-16.004425049459726, -10.564408907027802],
              [-16.003082589906615, -10.563521249390597],
              [-16.001436601132912, -10.563907485600138],
              [-16.00005467426169, -10.565749453511375],
              [-15.9975495644371, -10.568194474867234],
              [-15.996755552602785, -10.567485676428113],
              [-15.996705237777224, -10.56556970985304],
              [-15.998326480745623, -10.56431703278465],
              [-15.997790594290251, -10.56275182427514],
              [-15.999660393069155, -10.560902822530851],
              [-16.00182441117285, -10.559869308522897],
              [-15.999940832964516, -10.558200063419763],
              [-15.99816425381202, -10.559033819419481],
              [-15.997168622395565, -10.558866102116388],
              [-15.995563585772778, -10.56015992911195],
              [-15.993769117528025, -10.562599494032735],
              [-15.990919895146114, -10.565387511402196],
              [-15.98813386293574, -10.56850424912709],
              [-15.988153706802116, -10.571222145780688],
              [-15.990327730552325, -10.571216562386827],
              [-15.991901757081994, -10.570219774308816],
              [-15.992814365167803, -10.572229690221421],
              [-15.990640200158053, -10.572779155739193],
              [-15.990274946976758, -10.574772191626085],
              [-15.989249243905249, -10.577941737971512],
              [-15.989981622231738, -10.580658434997629],
              [-15.991104430363608, -10.581706110789323],
              [-15.992997308417673, -10.582232941226648],
              [-15.997042774421153, -10.583876696233432],
              [-16.0018900086624, -10.584900277641637],
              [-16.004607813281748, -10.582754819227354],
              [-16.00670582749365, -10.581609843942111],
              [-16.006562136600355, -10.581071352147072]
            ]
          ],
          [
            [
              [-16.012279068231148, -10.571962422522391],
              [-16.011270059245117, -10.571352093450708],
              [-16.00857392272382, -10.56837049637545],
              [-16.007505250834193, -10.569040511369302],
              [-16.009138656011622, -10.570059292153891],
              [-16.00985721274122, -10.571644224582418],
              [-16.011892635201146, -10.572705706262242],
              [-16.012279068231148, -10.571962422522391]
            ]
          ],
          [
            [
              [-16.054707429789346, -10.535860651284292],
              [-16.05413636072589, -10.534576616877839],
              [-16.053979207030444, -10.532360694896402],
              [-16.05217092729616, -10.530186619794568],
              [-16.0503771440168, -10.53043265918166],
              [-16.049583279332076, -10.528681391254759],
              [-16.048388490556537, -10.527336889592474],
              [-16.04693786854512, -10.529061355810645],
              [-16.047621375472893, -10.529614288976147],
              [-16.04732405084202, -10.531237038941121],
              [-16.04781504731368, -10.532060686631322],
              [-16.049430435440588, -10.531321792677685],
              [-16.04946182847986, -10.534053817448699],
              [-16.051319599035843, -10.535758287659188],
              [-16.052441263823386, -10.537593824982913],
              [-16.05398513179749, -10.537557422306229],
              [-16.054707429789346, -10.535860651284292]
            ]
          ],
          [
            [
              [-16.08764536493693, -10.538718056834744],
              [-16.086986988329937, -10.537964422539192],
              [-16.08485981615121, -10.538175915524729],
              [-16.08466897533863, -10.539347967520886],
              [-16.085885316000446, -10.540074319556938],
              [-16.08764536493693, -10.538718056834744]
            ]
          ],
          [
            [
              [-16.094474297425172, -10.569087712509623],
              [-16.092726820503998, -10.568858440622066],
              [-16.08906644615305, -10.566721218038705],
              [-16.089620997432963, -10.564666575588015],
              [-16.086397677078022, -10.565307675733635],
              [-16.08558170970207, -10.5663845718637],
              [-16.084277791473845, -10.565700813797063],
              [-16.0844494478228, -10.56443665343622],
              [-16.083407699108268, -10.562887842789177],
              [-16.084139797978217, -10.561477408723812],
              [-16.083585120723097, -10.560403293893897],
              [-16.081379390335808, -10.559121857408947],
              [-16.079330291502558, -10.558864937357672],
              [-16.078935195457785, -10.557028202385801],
              [-16.07637054669086, -10.55685665408793],
              [-16.07590348369736, -10.557332756541319],
              [-16.077592053909243, -10.561350084380026],
              [-16.078021428202966, -10.563189251065513],
              [-16.07726143970747, -10.565131911597454],
              [-16.075753667604086, -10.562676797939519],
              [-16.074766003013686, -10.560088517541482],
              [-16.075086974178717, -10.559321690195636],
              [-16.074345771174738, -10.557400831380878],
              [-16.0727345073577, -10.559144409712468],
              [-16.070587278380483, -10.558404485395421],
              [-16.070469549863937, -10.559219941078265],
              [-16.073051404663044, -10.561792560240285],
              [-16.07172395682024, -10.56230580975904],
              [-16.070310259078465, -10.560649550075738],
              [-16.068636361076273, -10.560327365648169],
              [-16.067817051516645, -10.558949084607612],
              [-16.06654320484042, -10.559440094089235],
              [-16.066086008469703, -10.557785975485954],
              [-16.06642190919076, -10.555926063961529],
              [-16.065585840691288, -10.554666322257981],
              [-16.062967564575263, -10.554327564214349],
              [-16.06336644523428, -10.55528425882907],
              [-16.064870080377425, -10.55627018005867],
              [-16.06545371093045, -10.55864245697551],
              [-16.063907432452314, -10.559398854607121],
              [-16.06208042784063, -10.557572533364997],
              [-16.061282691296515, -10.55464372013243],
              [-16.060387261856267, -10.554801151172597],
              [-16.060083731917604, -10.558304313840257],
              [-16.06077786700622, -10.56001456894562],
              [-16.063486642990345, -10.563649369087042],
              [-16.066529692395633, -10.566791949945108],
              [-16.068335570404614, -10.566820458275158],
              [-16.068247024727174, -10.567857240214831],
              [-16.066970530443754, -10.568767534314818],
              [-16.065029003192066, -10.568014309514865],
              [-16.0643813653288, -10.567158496707098],
              [-16.061776774805477, -10.567463185452429],
              [-16.06052700778543, -10.567194288022765],
              [-16.060972410707954, -10.565172049784877],
              [-16.05973991549056, -10.563774910871045],
              [-16.058757373173787, -10.563705664746754],
              [-16.057644857856964, -10.562144476125635],
              [-16.05797778726185, -10.560998654144866],
              [-16.05736144122501, -10.559533687219858],
              [-16.057908468757212, -10.557531273869294],
              [-16.05692633838332, -10.556820484790972],
              [-16.056412964800302, -10.560779243593803],
              [-16.05519782131241, -10.559182207644486],
              [-16.053572366015555, -10.558358520240557],
              [-16.052425142854776, -10.559573626758791],
              [-16.053145843012945, -10.56160075230952],
              [-16.053424325548544, -10.564030643121894],
              [-16.054904502388073, -10.567051630328342],
              [-16.05579733236697, -10.56754498393992],
              [-16.059077425949194, -10.571722930165093],
              [-16.06178128291674, -10.574401709055026],
              [-16.06448926795721, -10.575147249971268],
              [-16.066147898158466, -10.574202374032776],
              [-16.06652275884433, -10.572995743884988],
              [-16.07063569973463, -10.57335609846027],
              [-16.07140794082153, -10.572706522964019],
              [-16.070659398686058, -10.571245871976155],
              [-16.069322227335775, -10.566938224709734],
              [-16.06993786309457, -10.565614261346651],
              [-16.072241720663804, -10.566804668169363],
              [-16.07397583256305, -10.56897200113122],
              [-16.07608631357781, -10.569050135400106],
              [-16.075752534557985, -10.570449630097421],
              [-16.077875566249677, -10.571874974541021],
              [-16.079076472135437, -10.57155896111152],
              [-16.081488150624594, -10.56984757171194],
              [-16.082335391398622, -10.570393513808767],
              [-16.08547583070288, -10.570806321192281],
              [-16.089916504553447, -10.570895766209903],
              [-16.091447023386138, -10.57062727625475],
              [-16.09240605266663, -10.569815532743391],
              [-16.094474297425172, -10.569087712509623]
            ]
          ],
          [
            [
              [-16.09573161628682, -10.693799222947042],
              [-16.094817158777296, -10.693333585500165],
              [-16.092871382841913, -10.690561802835894],
              [-16.091891666658906, -10.690741075318678],
              [-16.08748962492123, -10.68998193901546],
              [-16.085216246708914, -10.688705086411895],
              [-16.080703999505275, -10.688534053925492],
              [-16.08238013773118, -10.690203769218801],
              [-16.085099216664986, -10.691826055214115],
              [-16.087928822709166, -10.691629296089616],
              [-16.09112293220274, -10.693071342505934],
              [-16.091985297335057, -10.692805300481384],
              [-16.092788971060873, -10.694112071608748],
              [-16.095460731560532, -10.694474223543176],
              [-16.09573161628682, -10.693799222947042]
            ]
          ],
          [
            [
              [-16.07510266536049, -10.917379690423207],
              [-16.0739815535772, -10.915243534428873],
              [-16.072760536579455, -10.914917493868629],
              [-16.071941520619504, -10.913927281857106],
              [-16.069888105435247, -10.914801415764064],
              [-16.07020604379303, -10.916197148069841],
              [-16.072444779884464, -10.917615966601131],
              [-16.073897522984346, -10.918957861457478],
              [-16.07510266536049, -10.917379690423207]
            ]
          ],
          [
            [
              [-16.104202743999284, -10.63160592404744],
              [-16.10297676720866, -10.628822423632325],
              [-16.10169338210926, -10.629826997532376],
              [-16.10031325858378, -10.629772237471194],
              [-16.099672619469214, -10.628458383887642],
              [-16.097530320226074, -10.62828819280067],
              [-16.094986558648703, -10.626060715133033],
              [-16.094733074492524, -10.629344723818996],
              [-16.093473140283603, -10.630108542981835],
              [-16.094064439188088, -10.631902387525667],
              [-16.095801613200663, -10.634455521888766],
              [-16.096510299863624, -10.636705928851962],
              [-16.09861362066897, -10.637275895305521],
              [-16.09959496199289, -10.636847147223182],
              [-16.099018901872075, -10.634892825470825],
              [-16.100581586403937, -10.6339561176981],
              [-16.103334712288945, -10.633337638096647],
              [-16.104202743999284, -10.63160592404744]
            ]
          ],
          [
            [
              [-16.10040599831355, -10.693629263627408],
              [-16.099275719363103, -10.693293520582646],
              [-16.098220438593064, -10.694468605097887],
              [-16.09981454630901, -10.694974924399588],
              [-16.10040599831355, -10.693629263627408]
            ]
          ],
          [
            [
              [-16.11738935176659, -10.570860877061714],
              [-16.115612316001783, -10.569888208527972],
              [-16.112453635118076, -10.570966632735688],
              [-16.110476307119413, -10.57416019749643],
              [-16.110849050628616, -10.57517947258535],
              [-16.11476938320505, -10.574808184549696],
              [-16.116905637116044, -10.572376970644003],
              [-16.11738935176659, -10.570860877061714]
            ]
          ],
          [
            [
              [-16.120188374132375, -10.555648677882367],
              [-16.11850539928669, -10.557696733023535],
              [-16.11952408349023, -10.558121524285514],
              [-16.12037562517004, -10.557009932049041],
              [-16.120188374132375, -10.555648677882367]
            ]
          ],
          [
            [
              [-16.118531055076524, -10.57791689689106],
              [-16.117628235739527, -10.576619917633732],
              [-16.116487961601955, -10.577687393922758],
              [-16.11776905256009, -10.578959045878912],
              [-16.118531055076524, -10.57791689689106]
            ]
          ],
          [
            [
              [-16.116156540529577, -10.622924815890668],
              [-16.113692520942845, -10.62232354800409],
              [-16.111442983716838, -10.622830743603018],
              [-16.109962753125078, -10.621759643015599],
              [-16.10819675363752, -10.622313252498664],
              [-16.108720619407357, -10.619138893975732],
              [-16.108212677310465, -10.618928032515013],
              [-16.105273593549004, -10.621019934387016],
              [-16.10430199362308, -10.62096520281064],
              [-16.104072653462126, -10.619209064972386],
              [-16.103271265177433, -10.61707451302409],
              [-16.100070830727773, -10.617325268632163],
              [-16.09925178822722, -10.618574993223042],
              [-16.10040671902419, -10.621632278945311],
              [-16.10139026368779, -10.622373877481241],
              [-16.10335697482712, -10.6258742837849],
              [-16.104990584614722, -10.625428819313278],
              [-16.107503535188222, -10.626359737777639],
              [-16.109681485795896, -10.625765066731928],
              [-16.111206196596815, -10.625994154009494],
              [-16.114871957538675, -10.625180050148748],
              [-16.11662880641972, -10.623494780246753],
              [-16.116156540529577, -10.622924815890668]
            ]
          ],
          [
            [
              [-16.116896066707724, -10.648952311946795],
              [-16.1133863427452, -10.646916299105348],
              [-16.112607177127618, -10.647770016000033],
              [-16.11053015169314, -10.6481345883258],
              [-16.109863687396366, -10.649080267721116],
              [-16.105579280285564, -10.647855146072715],
              [-16.105744812421687, -10.646214459210753],
              [-16.109046436250782, -10.647061026347226],
              [-16.110282532829956, -10.64613044266029],
              [-16.10911018859605, -10.644804290783446],
              [-16.107623299621064, -10.644579217230792],
              [-16.10760693067345, -10.643123101341716],
              [-16.109189778897925, -10.641176448096077],
              [-16.113660620531924, -10.64092347227616],
              [-16.114923299538855, -10.639309109324751],
              [-16.113872353969374, -10.637996170206],
              [-16.114270673375888, -10.636056678923076],
              [-16.112720037013275, -10.635260413451013],
              [-16.111796525875828, -10.637148947415927],
              [-16.111017482273944, -10.63719444484604],
              [-16.110144807901566, -10.635737053734237],
              [-16.11095537295445, -10.63416069554292],
              [-16.109215334016785, -10.632821216558254],
              [-16.108222565688916, -10.63296680704103],
              [-16.106459030471708, -10.6375182283612],
              [-16.105247774046195, -10.63740010843236],
              [-16.104621890127536, -10.63632961564861],
              [-16.102187556530684, -10.63580921552724],
              [-16.100794131644868, -10.637086137727843],
              [-16.099682150449677, -10.640006176995284],
              [-16.099390345407514, -10.64207798627584],
              [-16.09792732152517, -10.643227406722348],
              [-16.097638820858382, -10.645664211471637],
              [-16.095818524681555, -10.647910278729976],
              [-16.094569414953906, -10.648151440280536],
              [-16.09328051269608, -10.647579663096854],
              [-16.093039088432718, -10.64274654605963],
              [-16.088303953698517, -10.642763551518318],
              [-16.087982124838536, -10.641923782355775],
              [-16.088888981301498, -10.64063963855034],
              [-16.08983421486839, -10.640571428020277],
              [-16.09025203905439, -10.639279778896697],
              [-16.088047421082525, -10.638899893135896],
              [-16.08722952412914, -10.640111585040648],
              [-16.085356426775206, -10.641663445670325],
              [-16.08426178859641, -10.64159499148705],
              [-16.083038528562266, -10.64317081802985],
              [-16.083343716200535, -10.644171171283572],
              [-16.084798283218575, -10.644315686911787],
              [-16.086104189486704, -10.64630471154614],
              [-16.086273454205603, -10.649030108445077],
              [-16.087921959948332, -10.652468966042761],
              [-16.087981027696724, -10.653486035956925],
              [-16.08925248992731, -10.65543185259595],
              [-16.092843026687504, -10.65667609147345],
              [-16.093547343518065, -10.656179120907137],
              [-16.096414922671404, -10.656501233092095],
              [-16.094147471723286, -10.65429669664842],
              [-16.094556725459594, -10.653487492488685],
              [-16.09655412386767, -10.65392632192006],
              [-16.097813286771668, -10.651178847617645],
              [-16.096795911114924, -10.649138232197553],
              [-16.09756058512604, -10.648041131934091],
              [-16.100772829822372, -10.650579446035682],
              [-16.101459848671904, -10.651859354819038],
              [-16.101322049019895, -10.653220628700927],
              [-16.102195046594197, -10.65629862781309],
              [-16.10352973936148, -10.65683347067331],
              [-16.10422538194621, -10.658034154713615],
              [-16.108028972487347, -10.660831551019498],
              [-16.110679459782354, -10.661290917340617],
              [-16.113006040636947, -10.661313820613259],
              [-16.112677004807882, -10.659704130430958],
              [-16.111668672985015, -10.658352704392582],
              [-16.109407089842023, -10.657688368254409],
              [-16.109329157931217, -10.655618168865571],
              [-16.1097772353251, -10.65400389784901],
              [-16.108179708671074, -10.653242295147937],
              [-16.107229846114883, -10.654160660448754],
              [-16.105636270708526, -10.651337033100038],
              [-16.105708729895706, -10.64980804367622],
              [-16.10957320934773, -10.650345543791955],
              [-16.111776942388303, -10.651165391804172],
              [-16.112436363897576, -10.651916566182477],
              [-16.114260046058565, -10.65245692323386],
              [-16.116570921504263, -10.650982120933254],
              [-16.116896066707724, -10.648952311946795]
            ]
          ],
          [
            [
              [-16.103343983019272, -10.785350617408385],
              [-16.10274828394132, -10.783044233109358],
              [-16.10130043055775, -10.783068148744999],
              [-16.09966343765883, -10.782092138955933],
              [-16.098984928641663, -10.782680548546935],
              [-16.09730747962315, -10.782109157317063],
              [-16.095699574716342, -10.780849587787003],
              [-16.094889120485572, -10.77905375364911],
              [-16.093126679331736, -10.778923259293379],
              [-16.09279945547933, -10.777665360700697],
              [-16.09326933472508, -10.77546329799322],
              [-16.092169616300954, -10.773680956711168],
              [-16.09038348214783, -10.772566777740716],
              [-16.089742061152624, -10.771564525605038],
              [-16.086413234362958, -10.768175003730665],
              [-16.08557571351958, -10.767888927451029],
              [-16.08573326345128, -10.771213111634687],
              [-16.084008431156597, -10.77153399392382],
              [-16.079816226118066, -10.766913916970987],
              [-16.077471905868098, -10.766437638600623],
              [-16.07651305923215, -10.771367601717744],
              [-16.07690765770819, -10.772755289880887],
              [-16.075828047547393, -10.77604078568668],
              [-16.076149702599793, -10.776931110761398],
              [-16.078853337619194, -10.77997812716881],
              [-16.08346545913368, -10.782149373598871],
              [-16.08402832193344, -10.78474005796671],
              [-16.08583690168657, -10.784426501021365],
              [-16.087002888223473, -10.784745244672807],
              [-16.09000589326228, -10.786920118706723],
              [-16.09132372307013, -10.788193777727356],
              [-16.092216245872013, -10.789999152886846],
              [-16.095291456822743, -10.792712106423778],
              [-16.0976718327888, -10.795357535236047],
              [-16.100056025490215, -10.796324645750826],
              [-16.100365518242356, -10.79447185776641],
              [-16.10250562418772, -10.793327994972797],
              [-16.102020309703878, -10.791153694095293],
              [-16.10038176884522, -10.789768228902206],
              [-16.1013536215979, -10.787489705277503],
              [-16.104250201506655, -10.787032802944195],
              [-16.103343983019272, -10.785350617408385]
            ]
          ],
          [
            [
              [-16.136882477319368, -10.576711134696058],
              [-16.136178219933754, -10.575018011739566],
              [-16.133175288575757, -10.574624159428769],
              [-16.131870752390714, -10.576193258993536],
              [-16.133700266859357, -10.577531474159343],
              [-16.136489954468896, -10.577634823819945],
              [-16.136882477319368, -10.576711134696058]
            ]
          ],
          [
            [
              [-16.12598473653453, -10.70301987035426],
              [-16.12511500694855, -10.702647788420656],
              [-16.123881554135448, -10.703410865460258],
              [-16.12354688957957, -10.70485512126821],
              [-16.12492591465036, -10.705459653850141],
              [-16.1258979252107, -10.704334451834008],
              [-16.12598473653453, -10.70301987035426]
            ]
          ],
          [
            [
              [-16.13154000129686, -10.695542826520747],
              [-16.130407164156342, -10.694266570811523],
              [-16.12967700160275, -10.696825622218464],
              [-16.130978498465822, -10.697139839895696],
              [-16.13154000129686, -10.695542826520747]
            ]
          ],
          [
            [
              [-16.135187866342267, -10.683511261812447],
              [-16.13416581707414, -10.680723059089585],
              [-16.133318243726062, -10.680760023519477],
              [-16.131719787426675, -10.682295215423574],
              [-16.132161523856407, -10.684834423572763],
              [-16.13132725202314, -10.685840241256036],
              [-16.13055557005553, -10.688843202431595],
              [-16.129705627028333, -10.68666336493904],
              [-16.130279819500384, -10.684044021196344],
              [-16.12756236168835, -10.684724208257059],
              [-16.126742397246183, -10.68358020011777],
              [-16.12673797289134, -10.682323431842201],
              [-16.125440551840413, -10.681116783075598],
              [-16.126825826355304, -10.6798076469931],
              [-16.128299171729225, -10.679108567975701],
              [-16.128139446746005, -10.678319501578006],
              [-16.124836098753597, -10.675333526622216],
              [-16.124217187399108, -10.6759920881477],
              [-16.124247317264178, -10.678494589797069],
              [-16.12306999325452, -10.67767786357245],
              [-16.12233530280329, -10.678357873026068],
              [-16.122890914817415, -10.682085893329896],
              [-16.121566514071077, -10.68303899864884],
              [-16.122385092330298, -10.684494443609436],
              [-16.123362420843858, -10.688565800716457],
              [-16.122158337265702, -10.689681052726149],
              [-16.123468439694676, -10.691015781848318],
              [-16.124959812004313, -10.689212230681608],
              [-16.126570013073977, -10.68972853064872],
              [-16.12702074311991, -10.691671518694845],
              [-16.12577100951122, -10.69280047187797],
              [-16.125525012484655, -10.694547372001225],
              [-16.126044757818345, -10.695285735866111],
              [-16.12813965968943, -10.695272456630992],
              [-16.132184863082315, -10.691233451507228],
              [-16.134562442899153, -10.687312773608532],
              [-16.13370875495137, -10.687029448525605],
              [-16.133303855889235, -10.68500475230595],
              [-16.135187866342267, -10.683511261812447]
            ]
          ],
          [
            [
              [-16.151520626990163, -10.59911550798036],
              [-16.149640764676928, -10.597173793231859],
              [-16.14905101158166, -10.598000854585472],
              [-16.15010735958506, -10.59891960960674],
              [-16.151520626990163, -10.59911550798036]
            ]
          ],
          [
            [
              [-16.159683195363556, -10.596317756219756],
              [-16.157123203019136, -10.596141695020748],
              [-16.15775316992296, -10.597524252422364],
              [-16.16001777898845, -10.597798203222963],
              [-16.159683195363556, -10.596317756219756]
            ]
          ],
          [
            [
              [-16.16170148804715, -10.606003004367828],
              [-16.15978948573013, -10.60371305883132],
              [-16.1569789079321, -10.602324676913145],
              [-16.156393797511566, -10.603336007455614],
              [-16.158229673665694, -10.604512954994679],
              [-16.158191564093464, -10.606802947563411],
              [-16.16063620735414, -10.60715129897113],
              [-16.16170148804715, -10.606003004367828]
            ]
          ],
          [
            [
              [-16.16341232348904, -10.650321528473977],
              [-16.16285010798081, -10.647847475236278],
              [-16.161000826194876, -10.642642289959072],
              [-16.160584268739296, -10.638410231182178],
              [-16.159377457729587, -10.639136878960247],
              [-16.15778902280884, -10.639300752384566],
              [-16.158129199651633, -10.641297522706479],
              [-16.15944958947534, -10.642163052062566],
              [-16.16045432639553, -10.64556387738892],
              [-16.160420160715198, -10.646423938535584],
              [-16.161722599929224, -10.64925387097804],
              [-16.161812254879354, -10.650844999161702],
              [-16.16341232348904, -10.650321528473977]
            ]
          ],
          [
            [
              [-16.173385563639016, -10.618331963336432],
              [-16.17195131124124, -10.61481834176871],
              [-16.17093983642394, -10.61540957672062],
              [-16.17169011403099, -10.618417929175578],
              [-16.173385563639016, -10.618331963336432]
            ]
          ],
          [
            [
              [-16.18091647777885, -10.607470589760354],
              [-16.180342462781233, -10.606452683379773],
              [-16.178939574084044, -10.60604325348315],
              [-16.178327489028128, -10.607576047797156],
              [-16.180523623756784, -10.609265196279214],
              [-16.18091647777885, -10.607470589760354]
            ]
          ],
          [
            [
              [-16.161613299226897, -10.95413975178169],
              [-16.160840833829898, -10.9529930117224],
              [-16.15888682264324, -10.951947113823472],
              [-16.156941676747465, -10.950363037054826],
              [-16.156553230936073, -10.948257220999897],
              [-16.156668478396725, -10.945245062337658],
              [-16.157166028236876, -10.943509970050362],
              [-16.158569391979178, -10.941484708446199],
              [-16.15987164852198, -10.938747006191383],
              [-16.16042630775934, -10.936397251368303],
              [-16.158618424996078, -10.933379964995668],
              [-16.15825813722587, -10.93053524711775],
              [-16.15667454377733, -10.927373889207418],
              [-16.15438934658262, -10.92501697464599],
              [-16.15259604289564, -10.923655260032591],
              [-16.1488683209836, -10.923315413659136],
              [-16.14495046821909, -10.922337136922],
              [-16.141316155710456, -10.92233395521438],
              [-16.138750082516975, -10.9216430787048],
              [-16.13510325258697, -10.919156997756534],
              [-16.134267119362324, -10.918294443889781],
              [-16.134757550644547, -10.916232466497178],
              [-16.139591099597546, -10.917216022545901],
              [-16.141926448930164, -10.916811528486685],
              [-16.14335009329814, -10.913265928729466],
              [-16.145290275695764, -10.912618038826421],
              [-16.145598803375332, -10.910251500945437],
              [-16.144465732330584, -10.90593671968919],
              [-16.140442583190286, -10.902636161283422],
              [-16.138881560872687, -10.902822326796647],
              [-16.137059833897503, -10.900508340411875],
              [-16.138407589990948, -10.899064988994697],
              [-16.136009885130587, -10.896244226283557],
              [-16.135464583000342, -10.894543873628267],
              [-16.134099353541792, -10.893138861626424],
              [-16.132189378623128, -10.892631483859393],
              [-16.130241931474142, -10.892945072096115],
              [-16.12920483485537, -10.8937556686583],
              [-16.127800284291062, -10.893624613944468],
              [-16.124529596590854, -10.89253520088159],
              [-16.12384242734723, -10.89102737524427],
              [-16.12420138807439, -10.88990659844062],
              [-16.122544168262934, -10.889380009645986],
              [-16.121885346170767, -10.887586314726171],
              [-16.12550882251, -10.883309749756382],
              [-16.129324052585048, -10.883048154063182],
              [-16.12959982798603, -10.881920175417928],
              [-16.128025418280114, -10.879260160395866],
              [-16.127719667909908, -10.878119416103727],
              [-16.126151991549023, -10.877972721481457],
              [-16.11837406043093, -10.872793413440379],
              [-16.11430848575018, -10.870967852199175],
              [-16.11437256637469, -10.870315331545113],
              [-16.11167259498368, -10.868577082802263],
              [-16.110101316818152, -10.86636940335823],
              [-16.108528456569065, -10.865025836068142],
              [-16.107792127615387, -10.863638730598849],
              [-16.107807681172797, -10.861376885543807],
              [-16.105575217337957, -10.859147586083429],
              [-16.105257885314195, -10.856896130049423],
              [-16.10181334295026, -10.85516776864419],
              [-16.099364137765736, -10.852217962596045],
              [-16.097275376871394, -10.850248737872402],
              [-16.094410713920507, -10.849396833029868],
              [-16.09316606161754, -10.846892122566478],
              [-16.091919037371795, -10.84607242829604],
              [-16.090309544185164, -10.84390260857032],
              [-16.088569536498085, -10.84303501190744],
              [-16.087072232449586, -10.840588062742073],
              [-16.08599499878764, -10.840154468233472],
              [-16.085382371981282, -10.837177488891033],
              [-16.083109710250326, -10.834614327697041],
              [-16.081355407085468, -10.833498177540422],
              [-16.080870946099218, -10.832136800453542],
              [-16.080946391038722, -10.828941273971363],
              [-16.078757667142902, -10.828028618264604],
              [-16.07837740817177, -10.825651443948392],
              [-16.07711439438828, -10.823393121234444],
              [-16.077972938140967, -10.817815477213758],
              [-16.07772364207186, -10.81660174010913],
              [-16.07522210962224, -10.815124979477025],
              [-16.074915716477214, -10.814069556536344],
              [-16.072771741631104, -10.812750545695856],
              [-16.071247195129327, -10.809032895951495],
              [-16.07161799764034, -10.807840004514693],
              [-16.069762575056664, -10.806549495113991],
              [-16.06873574619682, -10.805259006354285],
              [-16.069225645533955, -10.801701611124052],
              [-16.06690336591166, -10.798931228118159],
              [-16.067053745532274, -10.797471602641096],
              [-16.06916500971497, -10.796657324077074],
              [-16.07110192158872, -10.797135885299035],
              [-16.069141675866955, -10.793665638035659],
              [-16.067927505815565, -10.792603610635561],
              [-16.066992422331573, -10.793247428363802],
              [-16.065262121841503, -10.792379350168837],
              [-16.063283593969885, -10.789111687355154],
              [-16.063342993998607, -10.791737404553809],
              [-16.065145503915705, -10.795110935113195],
              [-16.063997130641827, -10.795815513237336],
              [-16.063336304169816, -10.794603137321209],
              [-16.061186884208016, -10.792586711662532],
              [-16.058754499853926, -10.792507058750308],
              [-16.058288804382578, -10.790617942683992],
              [-16.058372222515178, -10.78862043263278],
              [-16.05684338520279, -10.787812093699793],
              [-16.055180353368268, -10.785516625026139],
              [-16.0537511783632, -10.785741293648458],
              [-16.052495549441883, -10.78667889645721],
              [-16.051801287659764, -10.785012987096303],
              [-16.050314326831053, -10.784207913753752],
              [-16.050387742811765, -10.783110637814746],
              [-16.04900569364701, -10.781702531452778],
              [-16.049448992850312, -10.780233223475882],
              [-16.05272364242321, -10.780932223206861],
              [-16.054434618548438, -10.781963577108318],
              [-16.05506469860857, -10.780677029623467],
              [-16.05382350530365, -10.77989742044577],
              [-16.054347795465038, -10.77843683735714],
              [-16.05377528645818, -10.77719296783169],
              [-16.049871631902814, -10.775408430434238],
              [-16.050445701137253, -10.77387180558531],
              [-16.051869278905368, -10.773688394559812],
              [-16.052265435598645, -10.772665288477667],
              [-16.057119801004085, -10.770864964689522],
              [-16.058014077247623, -10.769810583659115],
              [-16.057638683237297, -10.768260865336712],
              [-16.05588179290951, -10.766898976425978],
              [-16.05657130924615, -10.76463957693528],
              [-16.055843185681343, -10.763708255685641],
              [-16.05142283528069, -10.763752616767395],
              [-16.048449178926045, -10.762593944028543],
              [-16.047382321257754, -10.761750511152163],
              [-16.048607752425816, -10.760690123662076],
              [-16.049032607745776, -10.758609242075325],
              [-16.052375749567176, -10.756503683045816],
              [-16.055379217524315, -10.757086457810335],
              [-16.056312136080027, -10.75644555987862],
              [-16.055888894187657, -10.754968531390288],
              [-16.056702502872835, -10.753841626077485],
              [-16.055813698489025, -10.752196577586592],
              [-16.05658324036782, -10.750711324643241],
              [-16.056161492471844, -10.74966986640613],
              [-16.054460425706036, -10.748704032451169],
              [-16.05377387806353, -10.74898135302247],
              [-16.051725777822735, -10.746745054556447],
              [-16.051386807435247, -10.745893901237013],
              [-16.048269506994863, -10.744408107176353],
              [-16.047190558180603, -10.740704072979662],
              [-16.041728812485065, -10.737786660926977],
              [-16.04066974126259, -10.736465145177752],
              [-16.03806203606164, -10.736709775642668],
              [-16.036156644697392, -10.738454798968172],
              [-16.035923997288627, -10.741497549929695],
              [-16.036894486681327, -10.743290368378815],
              [-16.039591824029202, -10.745498542293559],
              [-16.040316792234698, -10.746808800537819],
              [-16.04393648511189, -10.75042136938801],
              [-16.043714505532748, -10.752487469658698],
              [-16.042058044947783, -10.752649722615468],
              [-16.040528789609436, -10.750418437969877],
              [-16.03872061527937, -10.751190404315485],
              [-16.03778418320029, -10.749910838892104],
              [-16.035160934128513, -10.74898884679435],
              [-16.032164240935995, -10.750027909483821],
              [-16.02909257050185, -10.749058379981907],
              [-16.02542958422805, -10.747455531274873],
              [-16.02182218455798, -10.746877650491939],
              [-16.02028725091019, -10.746963310055019],
              [-16.02003254678209, -10.749712934793646],
              [-16.021772586940767, -10.75463029528489],
              [-16.023296336646997, -10.755809665932082],
              [-16.023246018777737, -10.75666208027949],
              [-16.02504491874926, -10.758359716745089],
              [-16.02751049883036, -10.760003638923289],
              [-16.027591603850976, -10.760788370348688],
              [-16.030461553277263, -10.76484355642436],
              [-16.032752814962937, -10.766591372547477],
              [-16.032604555621514, -10.76759815771597],
              [-16.03400660634288, -10.7691727718493],
              [-16.036063997280714, -10.774699723538351],
              [-16.03662637253648, -10.776802477308632],
              [-16.03601956021462, -10.777068007524367],
              [-16.033970941435882, -10.776121614382973],
              [-16.0327551742623, -10.776283628429084],
              [-16.027955662738, -10.773622150966645],
              [-16.02795846362109, -10.7716592536909],
              [-16.0236818540186, -10.769540958047347],
              [-16.022796709521288, -10.768549825489615],
              [-16.022644052371046, -10.766121602958549],
              [-16.021169335523147, -10.766009797957201],
              [-16.021082250265835, -10.764897091226416],
              [-16.01886252733543, -10.76250029629885],
              [-16.016675428008433, -10.763253757656539],
              [-16.01400788478369, -10.761954005181018],
              [-16.011919706205603, -10.759120217393049],
              [-16.01044611070593, -10.757862639691616],
              [-16.007806302987216, -10.757463542764086],
              [-16.005449066716796, -10.757502104532797],
              [-16.004282142583588, -10.75836042085463],
              [-16.00349067716734, -10.761833186471724],
              [-16.00361477097732, -10.763726987181025],
              [-16.00484478638106, -10.765328443129768],
              [-16.00503942477151, -10.766575958250986],
              [-16.006136153123833, -10.767508898947074],
              [-16.008046363438307, -10.771227081025529],
              [-16.008521503596686, -10.774468396699632],
              [-16.009744743923324, -10.776151314699945],
              [-16.010492194123756, -10.779176516271098],
              [-16.012848233088032, -10.779954752771749],
              [-16.01408855270739, -10.781107469824189],
              [-16.015835953639424, -10.784851477124905],
              [-16.019117167386707, -10.787813233558099],
              [-16.02163917829188, -10.791310337798715],
              [-16.024120216322125, -10.793656269851294],
              [-16.024949105234988, -10.795585747599606],
              [-16.026425159947795, -10.796885294195787],
              [-16.02849471603669, -10.79767165729117],
              [-16.028891264675817, -10.80017187152177],
              [-16.03167539480924, -10.802425428655045],
              [-16.035345355195638, -10.80493275096209],
              [-16.036896650475384, -10.805542019931742],
              [-16.042735364309447, -10.811877755268503],
              [-16.04397065424374, -10.81393110940552],
              [-16.04720258442341, -10.816719876707358],
              [-16.049108625817986, -10.821098837148726],
              [-16.05215777815792, -10.825675364734291],
              [-16.052727733240744, -10.827375398714922],
              [-16.05418703992181, -10.828507571674947],
              [-16.055241819296672, -10.83194035567853],
              [-16.056743199110667, -10.834679126469583],
              [-16.05963242998234, -10.838460923347942],
              [-16.060730440382823, -10.840296842524838],
              [-16.06269256292123, -10.842218511966003],
              [-16.06305864787543, -10.844310831760195],
              [-16.06382182252026, -10.845373642662636],
              [-16.06487878295645, -10.848028233534352],
              [-16.065865591562023, -10.84853732659404],
              [-16.070803527581884, -10.855937410845685],
              [-16.071682732033278, -10.857917405383468],
              [-16.071828750564226, -10.86015456862329],
              [-16.072839037513965, -10.863712561800757],
              [-16.07360003743645, -10.870542746745429],
              [-16.07313318205769, -10.871856834983484],
              [-16.07102851988932, -10.873710322550393],
              [-16.071213004182393, -10.874759000501369],
              [-16.07269615966399, -10.876965795080435],
              [-16.072921458143977, -10.879255566855113],
              [-16.072181602300383, -10.880791069617173],
              [-16.069468745790157, -10.88246258840647],
              [-16.067722814503377, -10.88241439196151],
              [-16.067205682497793, -10.883394620416471],
              [-16.06480232310674, -10.884065158347505],
              [-16.065573079530257, -10.885089992967053],
              [-16.066993689885646, -10.884652849606365],
              [-16.06902754928956, -10.885966967385235],
              [-16.06894415040813, -10.886783984344728],
              [-16.0701778750785, -10.887771837110352],
              [-16.07229796473901, -10.88538070986268],
              [-16.074625792747902, -10.886269134764456],
              [-16.07520856623389, -10.885047516695986],
              [-16.07732613986417, -10.885130897662568],
              [-16.07906015346072, -10.884062850275166],
              [-16.081470689213496, -10.885370208294765],
              [-16.08315969283955, -10.888050850332142],
              [-16.085261768612007, -10.889121371856415],
              [-16.08622895078163, -10.890700685921074],
              [-16.08617567945464, -10.891644373055117],
              [-16.089786556754408, -10.893066722672158],
              [-16.091167905257223, -10.894685857640042],
              [-16.091705241941987, -10.89890684883984],
              [-16.091026056775814, -10.90152544917224],
              [-16.088342163203, -10.904983471617488],
              [-16.086022346330616, -10.90480068969035],
              [-16.084232294289926, -10.90557742695579],
              [-16.083600156598084, -10.90646630615984],
              [-16.08174707981877, -10.905790654590547],
              [-16.080800145513628, -10.906070223614956],
              [-16.080784154897902, -10.90871337848024],
              [-16.081429889485428, -10.909767942776943],
              [-16.080995998402777, -10.911585948924307],
              [-16.08111258072417, -10.914160450211785],
              [-16.07930446790982, -10.917168680001096],
              [-16.079706344716744, -10.91857253634832],
              [-16.081826418278162, -10.919523082700138],
              [-16.08344282168286, -10.922575632686394],
              [-16.087958920863525, -10.92466739797053],
              [-16.0894224866019, -10.925925642797633],
              [-16.089951193503367, -10.928169899125704],
              [-16.091421960963686, -10.92810449528136],
              [-16.093346205026215, -10.929365198043435],
              [-16.094323013894872, -10.931321831259595],
              [-16.095723510560227, -10.931124699244767],
              [-16.095759987324197, -10.928231080241575],
              [-16.09734455062702, -10.927017213979227],
              [-16.101699364582814, -10.92569528688614],
              [-16.10456600698766, -10.925885319426156],
              [-16.109034045514544, -10.927012712857758],
              [-16.11126436359041, -10.929002465405546],
              [-16.113205470905047, -10.93224765585143],
              [-16.113931490957025, -10.932523304030592],
              [-16.11500833343188, -10.934776969922579],
              [-16.114596873929205, -10.936849258443925],
              [-16.11315640260415, -10.938742489588984],
              [-16.11555277685927, -10.939920259635112],
              [-16.11631738117529, -10.941524380878015],
              [-16.11805416382144, -10.943468410604664],
              [-16.118334880729414, -10.945317309005212],
              [-16.119899915722364, -10.945588283872574],
              [-16.121237131538408, -10.943890483283827],
              [-16.122078996176178, -10.943845120596196],
              [-16.125850713503688, -10.945108116374232],
              [-16.12735642384875, -10.945993797621565],
              [-16.129417627763875, -10.9458952335016],
              [-16.133216703223262, -10.948193829605806],
              [-16.134429299541477, -10.949962913355826],
              [-16.1367625761871, -10.95096555597702],
              [-16.1386638050789, -10.9525491269104],
              [-16.139502210254665, -10.952543389931026],
              [-16.14114313450292, -10.95422729142082],
              [-16.141702171693886, -10.955397479085919],
              [-16.144122779890672, -10.958147536053453],
              [-16.14582481518735, -10.958758904853589],
              [-16.147793449313575, -10.960099214418916],
              [-16.14844000651465, -10.95990939796459],
              [-16.151628367039386, -10.960986959865982],
              [-16.155092797023116, -10.959352613487614],
              [-16.15752281283214, -10.958909335229233],
              [-16.158295197132862, -10.957818385198024],
              [-16.16071526600868, -10.956130504759571],
              [-16.161613299226897, -10.95413975178169]
            ]
          ],
          [
            [
              [-16.18781604320988, -10.710127425463615],
              [-16.186737386513826, -10.706693605273395],
              [-16.185662167822656, -10.705956959380552],
              [-16.186185503853327, -10.709000933113941],
              [-16.18698049983261, -10.710364379683865],
              [-16.18781604320988, -10.710127425463615]
            ]
          ],
          [
            [
              [-16.183345770092288, -10.795300087229517],
              [-16.18174416428266, -10.792091456307414],
              [-16.17837694464068, -10.791012918449333],
              [-16.178344071646, -10.787823266776106],
              [-16.17766797039118, -10.784454381154271],
              [-16.177827245190645, -10.782304336160665],
              [-16.175684043863352, -10.778314651927685],
              [-16.174380245527953, -10.777706828819692],
              [-16.17128721380261, -10.779468065736582],
              [-16.17001568525924, -10.779393676000826],
              [-16.16928072885124, -10.777122537343796],
              [-16.16765676044838, -10.776852600105554],
              [-16.166595997567374, -10.775857984452177],
              [-16.165108887710602, -10.77588574984904],
              [-16.16459691833708, -10.776941327348725],
              [-16.162891220268804, -10.777969359042006],
              [-16.160919890994812, -10.775707221634027],
              [-16.15776503993842, -10.774193299313103],
              [-16.155526180473334, -10.773457124079236],
              [-16.15211074576003, -10.77036725791336],
              [-16.15192111679536, -10.768472523009718],
              [-16.149564882592998, -10.766826652603358],
              [-16.146956447556953, -10.766095315980039],
              [-16.14785669353127, -10.764016892333476],
              [-16.149208051891605, -10.76324494144918],
              [-16.150428560469063, -10.760829927238227],
              [-16.151921489220836, -10.760723268395408],
              [-16.15234478252223, -10.763616953360302],
              [-16.154900407083442, -10.764464280119324],
              [-16.15735089732389, -10.766851611551134],
              [-16.15788293676052, -10.767757093871962],
              [-16.159408264920614, -10.768182760330316],
              [-16.161642186316946, -10.770264193341763],
              [-16.164042981342707, -10.771462910512753],
              [-16.16741797956898, -10.77107697468187],
              [-16.168088116402544, -10.770525812571577],
              [-16.16976349613099, -10.770678091392552],
              [-16.172213447919848, -10.77179771061049],
              [-16.17269610841851, -10.770169033943883],
              [-16.174258465882865, -10.767129252259588],
              [-16.175031973427597, -10.764589563629945],
              [-16.173645083933966, -10.763567034954105],
              [-16.169932070607903, -10.76188496990384],
              [-16.169024472424642, -10.757971079652117],
              [-16.169628469324117, -10.75680342809421],
              [-16.17208398789108, -10.755640997729117],
              [-16.170784273231984, -10.752834443160006],
              [-16.16821981200385, -10.750360691907309],
              [-16.167982059575483, -10.74765140967705],
              [-16.168439071789006, -10.745860984308353],
              [-16.167402559914525, -10.742469352230959],
              [-16.166184808410094, -10.740567601887987],
              [-16.16599889446326, -10.73688833783122],
              [-16.16501003942531, -10.734316681511611],
              [-16.165449358235943, -10.73228267627723],
              [-16.164755127531865, -10.729210203423138],
              [-16.165269138768313, -10.728119089611631],
              [-16.164086635307196, -10.726303271092435],
              [-16.162467709366183, -10.725626352256942],
              [-16.162643996979956, -10.723773111654697],
              [-16.161736500086498, -10.72295818535999],
              [-16.160077709564842, -10.720123750614631],
              [-16.16061216486914, -10.715379904276203],
              [-16.16018340891836, -10.714284640865001],
              [-16.158188204330198, -10.711989058365733],
              [-16.15715472241545, -10.712502821406124],
              [-16.156147177654123, -10.714886773417469],
              [-16.157745152328914, -10.722631190198713],
              [-16.15799091365748, -10.725214376257801],
              [-16.157130137418168, -10.727777294459043],
              [-16.156002303699555, -10.728405093101335],
              [-16.154900496299696, -10.726189306217508],
              [-16.154884374865713, -10.724642808864205],
              [-16.15351814082107, -10.72476045795882],
              [-16.150929362236106, -10.726065128998128],
              [-16.14882082885533, -10.724934051386327],
              [-16.14865240285962, -10.723698884321982],
              [-16.149021133760012, -10.720725855554425],
              [-16.147255418001187, -10.717757583333517],
              [-16.147556214453758, -10.715916938965368],
              [-16.14930277513013, -10.715673539428789],
              [-16.14877509175506, -10.712212668100804],
              [-16.149063931457327, -10.710493621039685],
              [-16.148633457431146, -10.706880795874714],
              [-16.14952023073587, -10.704487822516073],
              [-16.14913573891418, -10.702950486855553],
              [-16.146707063933928, -10.70179074457275],
              [-16.145145452219683, -10.700143545862279],
              [-16.144301536484612, -10.701241226282221],
              [-16.143656193582792, -10.705360632807034],
              [-16.142937548204095, -10.70643008890312],
              [-16.139748996901453, -10.706333804132553],
              [-16.138670766844033, -10.703512834750637],
              [-16.136301757275188, -10.701747450437235],
              [-16.138092870424153, -10.699035276749155],
              [-16.13806098921185, -10.697593008463043],
              [-16.139541379154323, -10.69623343373677],
              [-16.139161717683564, -10.69522352033554],
              [-16.139789753349373, -10.692140139257315],
              [-16.138014484510045, -10.689969394760386],
              [-16.136811931202583, -10.690235760458345],
              [-16.134589714099555, -10.69278351609938],
              [-16.13389083768478, -10.694312156371778],
              [-16.132716976171274, -10.695098680585232],
              [-16.132541297117044, -10.696528331882632],
              [-16.131642579679102, -10.69778406472767],
              [-16.1312490159227, -10.699433409763715],
              [-16.131485656886095, -10.701205922140689],
              [-16.130212793453534, -10.701162280615248],
              [-16.128701633158038, -10.70356462829217],
              [-16.129053717467333, -10.704952417805254],
              [-16.129121721142504, -10.708240535259499],
              [-16.130318045049194, -10.709260545474589],
              [-16.13197310903679, -10.70702144679101],
              [-16.133671822155755, -10.707263219884874],
              [-16.134483109041113, -10.708192642091966],
              [-16.133792004280366, -10.71064520772503],
              [-16.1323286693296, -10.711765839161302],
              [-16.132127618116513, -10.713818659190215],
              [-16.130943529669995, -10.717526030006786],
              [-16.131905454569186, -10.718453496352298],
              [-16.134327357557847, -10.719124351667128],
              [-16.135563878461003, -10.720911041797459],
              [-16.13488967026457, -10.721553575812647],
              [-16.13423286753054, -10.723578973930163],
              [-16.13287943114834, -10.7240300761164],
              [-16.132354159917483, -10.7257876038844],
              [-16.13053480448274, -10.725638546286307],
              [-16.127942091239625, -10.72722967224194],
              [-16.127743201979907, -10.730161725064507],
              [-16.13354852732868, -10.73582929026872],
              [-16.135654569872813, -10.734888095268563],
              [-16.13834206325147, -10.735994992505555],
              [-16.140013150983407, -10.737413487350025],
              [-16.140880212330735, -10.740343881634976],
              [-16.13874544125049, -10.742424159144994],
              [-16.1369783740574, -10.744946054201927],
              [-16.13579208503741, -10.744875560409964],
              [-16.133909845300263, -10.742662021344891],
              [-16.13089480787515, -10.74278521971805],
              [-16.1300680399112, -10.741566601954759],
              [-16.128993781791696, -10.742035146258074],
              [-16.127413400833394, -10.745144245147108],
              [-16.12738734540108, -10.74876764195489],
              [-16.12669349135801, -10.749965233554054],
              [-16.127980902635425, -10.753633103948193],
              [-16.130152373430626, -10.756692368957896],
              [-16.129515276346257, -10.757733181073288],
              [-16.129438788450422, -10.759357076881953],
              [-16.12993652989058, -10.760586801990991],
              [-16.1321508134391, -10.762386308260364],
              [-16.133831809301018, -10.763319359530817],
              [-16.132983901207115, -10.764830802585818],
              [-16.132857323009077, -10.768246666482794],
              [-16.13521088106103, -10.772876200382301],
              [-16.137547052262008, -10.774728015603683],
              [-16.137458517839192, -10.77606736830818],
              [-16.138422357391665, -10.77889363411714],
              [-16.139444346802016, -10.779846804181235],
              [-16.14090478300287, -10.78010576887805],
              [-16.14251686182035, -10.782216760408705],
              [-16.14152471790893, -10.784371566227659],
              [-16.140550330829733, -10.785056998075992],
              [-16.14129600601342, -10.787169790184121],
              [-16.143603137011556, -10.788079483965072],
              [-16.14499865786672, -10.789884836266298],
              [-16.142657297321996, -10.79318357908071],
              [-16.142508808715377, -10.796441210838525],
              [-16.141297569401083, -10.796574007574725],
              [-16.14016847919316, -10.79585529783364],
              [-16.13823493549563, -10.79363035138438],
              [-16.13637658425295, -10.793620387322916],
              [-16.137951496774182, -10.80297260712224],
              [-16.13865902882689, -10.805494304698788],
              [-16.138695426656486, -10.80725800743933],
              [-16.140489027460493, -10.809677150155268],
              [-16.142226876086028, -10.8105346945326],
              [-16.146284039270995, -10.80878168788621],
              [-16.146191297297662, -10.811475416128465],
              [-16.14367421849707, -10.813126258907655],
              [-16.142631288041613, -10.814504105479037],
              [-16.143340841748202, -10.817888516999172],
              [-16.14422382225623, -10.824651010963773],
              [-16.145825540551456, -10.82566011631842],
              [-16.14709751069729, -10.824055664187199],
              [-16.149284619246927, -10.82327371095649],
              [-16.150528696664328, -10.821953700954953],
              [-16.15149453362071, -10.820075619403921],
              [-16.1515441923864, -10.818686859339982],
              [-16.149373659837543, -10.816274615454137],
              [-16.149800349372438, -10.814839465840947],
              [-16.152271960326228, -10.81539452652922],
              [-16.155200758342016, -10.817670559022458],
              [-16.15664745680522, -10.816820170587597],
              [-16.157928459559507, -10.815094240486578],
              [-16.159700097509354, -10.813863571013616],
              [-16.160517724545713, -10.812218462907731],
              [-16.157989164267537, -10.810963931692992],
              [-16.15793432564618, -10.808052363996618],
              [-16.155452384860215, -10.805451038960298],
              [-16.155445505579685, -10.802913566646014],
              [-16.158108137434745, -10.802298396112862],
              [-16.160107128723865, -10.803012923276645],
              [-16.161640442221, -10.805157972101043],
              [-16.164159828390257, -10.805182703056431],
              [-16.16491348433257, -10.803328422584253],
              [-16.166840581724955, -10.803053693760628],
              [-16.166844242640696, -10.804772364870006],
              [-16.16808144116962, -10.804802478748053],
              [-16.168617090871763, -10.803501133321694],
              [-16.17036588969761, -10.802923055499683],
              [-16.172405685363135, -10.804089288338503],
              [-16.17374597690251, -10.802574143215812],
              [-16.175926819041873, -10.801788878446379],
              [-16.17659060512933, -10.803975766051156],
              [-16.177443155340928, -10.804584032213878],
              [-16.178994029743688, -10.803905469669429],
              [-16.180102159179764, -10.802655084078133],
              [-16.180174650398317, -10.800984650756003],
              [-16.1794420487539, -10.799978398503468],
              [-16.179794947099737, -10.797516283553882],
              [-16.18165370939273, -10.797069537820592],
              [-16.183345770092288, -10.795300087229517]
            ]
          ],
          [
            [
              [-16.20729710987536, -10.63324909712812],
              [-16.20484234260469, -10.631881018984002],
              [-16.204532366365246, -10.631044220176245],
              [-16.202224926615845, -10.631349742899374],
              [-16.202483788496224, -10.633204525201595],
              [-16.201846862863107, -10.634979432873703],
              [-16.199418245768523, -10.635188717264448],
              [-16.199151523976454, -10.639000280861746],
              [-16.198510528573948, -10.639880497244226],
              [-16.19536641063136, -10.64036619953857],
              [-16.194021040402884, -10.639094647552007],
              [-16.196117570008738, -10.638302234226074],
              [-16.195823695132567, -10.637295686118012],
              [-16.197140129817313, -10.636092647775753],
              [-16.198220770230773, -10.63371829184235],
              [-16.198357780807303, -10.632239629022521],
              [-16.197257272599487, -10.631118911385647],
              [-16.19932509842106, -10.630153926515064],
              [-16.20040109014182, -10.627354596915163],
              [-16.201056588075456, -10.626774486972328],
              [-16.200344580271704, -10.625178324528258],
              [-16.199073867141585, -10.62451127524968],
              [-16.198082978220235, -10.623145500498186],
              [-16.196085373312037, -10.624754147522962],
              [-16.195447564275273, -10.626527686862941],
              [-16.19604651480162, -10.62841224859936],
              [-16.19490572637186, -10.629119115378618],
              [-16.194507868170824, -10.631085105419373],
              [-16.193529498688505, -10.631891752509693],
              [-16.194478562372442, -10.632786347278874],
              [-16.190380548199215, -10.636593328970688],
              [-16.18951274957076, -10.635748047741455],
              [-16.191252172780874, -10.632325786201728],
              [-16.19127338621825, -10.63117718771785],
              [-16.19299248649527, -10.627499067126582],
              [-16.193071180536748, -10.626654534433031],
              [-16.191369662348915, -10.626458599736067],
              [-16.187506013904745, -10.627770593948778],
              [-16.18475028241819, -10.63101356500008],
              [-16.181886528640693, -10.634929303559783],
              [-16.181796960722497, -10.636796489454786],
              [-16.180556464042976, -10.636257467009784],
              [-16.179382464724814, -10.63866535496774],
              [-16.17831298512908, -10.639505898914866],
              [-16.176825382501395, -10.638389802629593],
              [-16.17639349352369, -10.641590658094207],
              [-16.177219956492692, -10.644694483693792],
              [-16.17825500759275, -10.646964487304352],
              [-16.179769988331223, -10.646889189682366],
              [-16.179247802383763, -10.649231187813916],
              [-16.180268020566434, -10.64983581900588],
              [-16.182266400614417, -10.649206656293453],
              [-16.18223359466865, -10.648179721505267],
              [-16.183288631276685, -10.647038238865616],
              [-16.184163913446504, -10.648269480916419],
              [-16.186219362913494, -10.647943740241082],
              [-16.1873490345827, -10.6483017318704],
              [-16.187913960009126, -10.64732883298888],
              [-16.18791313093101, -10.645494511395427],
              [-16.189155571378553, -10.645563990333484],
              [-16.19026403803358, -10.647071644814366],
              [-16.189289101061757, -10.649671297378475],
              [-16.19010422695899, -10.650171571523325],
              [-16.18953077065217, -10.651698557621293],
              [-16.189453714734174, -10.653911005957987],
              [-16.19046968062611, -10.655496514900266],
              [-16.194721897973135, -10.651482467348053],
              [-16.19551561129222, -10.650358836394169],
              [-16.197186207568173, -10.649996658669194],
              [-16.19720708429035, -10.648377315255239],
              [-16.19802093590217, -10.645635166703332],
              [-16.20264924270124, -10.645877520178363],
              [-16.203080790227048, -10.644466036435327],
              [-16.20213479091868, -10.641184511705994],
              [-16.203369492345384, -10.6399305274737],
              [-16.20278844501986, -10.637364477358496],
              [-16.20380895361393, -10.637029231728237],
              [-16.20563278450875, -10.635444353881262],
              [-16.205854248655804, -10.633972854755987],
              [-16.20729710987536, -10.63324909712812]
            ]
          ],
          [
            [
              [-16.193785084632154, -10.82713224517056],
              [-16.19313462752103, -10.823613156969063],
              [-16.19251097232281, -10.822288171028402],
              [-16.191527728611927, -10.82240594363202],
              [-16.191844603580737, -10.819853712786813],
              [-16.190557466511276, -10.819002720348358],
              [-16.18959670777483, -10.819327080997798],
              [-16.186654058005256, -10.821400029637175],
              [-16.18674814098077, -10.824869895943316],
              [-16.187860381558693, -10.825829069056836],
              [-16.18907706862293, -10.829481928797113],
              [-16.190959431140698, -10.831759413384487],
              [-16.1924253834756, -10.83158173367658],
              [-16.193304547537974, -10.830347669251374],
              [-16.193785084632154, -10.82713224517056]
            ]
          ],
          [
            [
              [-16.189113458513372, -10.90002167559563],
              [-16.187617083553892, -10.897705128957185],
              [-16.185531436396012, -10.893646858788172],
              [-16.18502782619487, -10.890058997067046],
              [-16.18395420890228, -10.889963902424457],
              [-16.181672534291685, -10.885354405917806],
              [-16.17839718861134, -10.883868791416326],
              [-16.177918550135043, -10.880943805399253],
              [-16.178429372686917, -10.879919232025811],
              [-16.177379647109348, -10.879125774929436],
              [-16.17444623747918, -10.875323877252134],
              [-16.171249469423092, -10.873926067601838],
              [-16.17103197748711, -10.868229661308696],
              [-16.170460542329423, -10.866779905735257],
              [-16.16730242063404, -10.86411016274545],
              [-16.165075931325283, -10.86082553216671],
              [-16.164206870335466, -10.859020599899676],
              [-16.162277155725217, -10.856133195303462],
              [-16.16059120256593, -10.855076010142655],
              [-16.15932705379582, -10.853071083236202],
              [-16.157487541166333, -10.852328254868896],
              [-16.156339027260646, -10.853497332258272],
              [-16.15626593758299, -10.855586145102096],
              [-16.15452888519121, -10.856824715494259],
              [-16.15360896948241, -10.855137858446257],
              [-16.152623478931805, -10.855458648489467],
              [-16.151751815175214, -10.857639288595378],
              [-16.150640951128455, -10.858400684234034],
              [-16.151067876119058, -10.859591041573346],
              [-16.151390012887422, -10.863197859255441],
              [-16.15263993139109, -10.864916384276382],
              [-16.15494044344642, -10.871791171582675],
              [-16.156751587159413, -10.874631284164535],
              [-16.157555995384556, -10.878450819889265],
              [-16.157394827888307, -10.881483200172124],
              [-16.162547711490486, -10.888665281163272],
              [-16.16551721047759, -10.891199998237397],
              [-16.16749063054314, -10.892366546104547],
              [-16.16855589398794, -10.893451806565352],
              [-16.169959776420438, -10.89403107100916],
              [-16.174434589179974, -10.896987839047172],
              [-16.175966411565646, -10.898443782255805],
              [-16.178783600159345, -10.900426488276937],
              [-16.179523909920533, -10.900080118247521],
              [-16.184240312513218, -10.903632260293866],
              [-16.185593275497236, -10.903422146644324],
              [-16.1865362085808, -10.901773551092697],
              [-16.189113458513372, -10.90002167559563]
            ]
          ],
          [
            [
              [-16.193343593613175, -10.908352161997476],
              [-16.192312357987493, -10.907802093352926],
              [-16.191517503363368, -10.908624863517097],
              [-16.19278486725433, -10.9095999009464],
              [-16.193343593613175, -10.908352161997476]
            ]
          ],
          [
            [
              [-16.217343882075564, -10.776654644835457],
              [-16.21742746742775, -10.773888986373182],
              [-16.21664573737246, -10.771130009698638],
              [-16.2148294630705, -10.77117633264761],
              [-16.21207799801771, -10.769265259945792],
              [-16.21167424454472, -10.76735509417208],
              [-16.210584681553442, -10.76620035150025],
              [-16.207591505433257, -10.765612451013679],
              [-16.20741798537079, -10.762989300152435],
              [-16.208891230165506, -10.7626293797734],
              [-16.209090107580217, -10.761343160593544],
              [-16.207818028844137, -10.758583931710339],
              [-16.205238695213943, -10.757990942820726],
              [-16.2021345460169, -10.753238580830718],
              [-16.1966675805932, -10.754098874584958],
              [-16.19581445940881, -10.752638667146856],
              [-16.194724704683704, -10.749732911747806],
              [-16.193271480450555, -10.748993028108654],
              [-16.193248324491634, -10.751474236689049],
              [-16.191345830216076, -10.7515897339927],
              [-16.190324418956273, -10.754186447371776],
              [-16.190283264547695, -10.761760065811483],
              [-16.191596012217417, -10.764933733329698],
              [-16.192271688957888, -10.765646075502465],
              [-16.192701868976943, -10.767681901810487],
              [-16.19286423752838, -10.772181811497882],
              [-16.19364800359495, -10.773964741221949],
              [-16.193157156519096, -10.776164729113601],
              [-16.193476722594628, -10.77762120164499],
              [-16.193119425416796, -10.781507501612374],
              [-16.19353933479149, -10.7859128230797],
              [-16.195897695703486, -10.785836111127551],
              [-16.196582592092614, -10.787815708448939],
              [-16.198260554118487, -10.787963871090128],
              [-16.199808674456403, -10.788631208094772],
              [-16.201404242503827, -10.78787315506516],
              [-16.202651446969316, -10.789126250041146],
              [-16.205198739956266, -10.787879884180004],
              [-16.207441827296115, -10.787708602972215],
              [-16.209783141764095, -10.788729754491872],
              [-16.21159284855907, -10.787417705176408],
              [-16.210786386963733, -10.78538772710861],
              [-16.21069457023819, -10.783665647877656],
              [-16.211485025612923, -10.782673251595565],
              [-16.21286851414527, -10.782875486558785],
              [-16.21399007367385, -10.78415659873952],
              [-16.216033066779683, -10.78298721838819],
              [-16.21729569144116, -10.778567541639555],
              [-16.217343882075564, -10.776654644835457]
            ]
          ],
          [
            [
              [-16.207222368288413, -10.884879439428758],
              [-16.203882529223147, -10.884548245512274],
              [-16.203440290464986, -10.882534129816761],
              [-16.20447776138737, -10.881636543752007],
              [-16.205112899907594, -10.88012827074508],
              [-16.208451468008377, -10.88045877614192],
              [-16.20796543272942, -10.879387994968395],
              [-16.20531221962086, -10.878376366311086],
              [-16.204577642558046, -10.876378739609736],
              [-16.203632748613593, -10.876255302437595],
              [-16.203637396945325, -10.872060755947087],
              [-16.202948798153855, -10.867725008184989],
              [-16.202444254506368, -10.865954605354188],
              [-16.20093171496563, -10.86660332829608],
              [-16.20107098936692, -10.864149506956313],
              [-16.199554567809603, -10.861181606022557],
              [-16.20027960879179, -10.860053756487073],
              [-16.198779169115575, -10.857375598777905],
              [-16.196988784310584, -10.851510582514127],
              [-16.195872972460545, -10.850098525619527],
              [-16.191547811255997, -10.847952283108874],
              [-16.190893030879955, -10.846950710903423],
              [-16.191296170131427, -10.844359542965005],
              [-16.187695454238245, -10.842481721292527],
              [-16.18644280026724, -10.844381108251014],
              [-16.18575405144206, -10.847357403534014],
              [-16.18413809370858, -10.847788214903916],
              [-16.184606928872306, -10.84360264312661],
              [-16.184360969093333, -10.841775289006199],
              [-16.183404496471102, -10.840459105076846],
              [-16.18426470871265, -10.839222886666754],
              [-16.184683986242796, -10.837373617110119],
              [-16.183907698632304, -10.8354587892998],
              [-16.182865966628317, -10.83417680433289],
              [-16.181791517774432, -10.83190807638298],
              [-16.18239759633866, -10.830281316813098],
              [-16.181401728067737, -10.828511869415083],
              [-16.181970546099254, -10.82684124906592],
              [-16.18086162280233, -10.8267421634438],
              [-16.178408175088716, -10.830867461769627],
              [-16.17832262840874, -10.834467956288641],
              [-16.1778870571864, -10.836479540566751],
              [-16.178289283190217, -10.837951106036794],
              [-16.17701787790677, -10.83869895549574],
              [-16.176379910608773, -10.837533988141958],
              [-16.17450977171964, -10.835807493941692],
              [-16.17317745047859, -10.837205411574555],
              [-16.17134854604578, -10.83814818506334],
              [-16.170534537220306, -10.835326544334686],
              [-16.169327428547103, -10.83538149065667],
              [-16.16873371412807, -10.837296813614584],
              [-16.16802721528442, -10.837315085855773],
              [-16.16547226086169, -10.840243133728388],
              [-16.164902452343657, -10.844542489883187],
              [-16.165755860302752, -10.846056467297693],
              [-16.167663240735408, -10.84828207749461],
              [-16.16936010628906, -10.849215597906152],
              [-16.170828141182817, -10.850826086994514],
              [-16.172226647677842, -10.851403780503068],
              [-16.171959573705312, -10.85248888422779],
              [-16.17280749475096, -10.85363300443919],
              [-16.174318734554635, -10.854343881351877],
              [-16.176704400180057, -10.856817073178108],
              [-16.177915227747718, -10.859432086494374],
              [-16.179517403545653, -10.860068199311025],
              [-16.180018751014973, -10.860934730216352],
              [-16.179754461939353, -10.864240601563468],
              [-16.180244344398748, -10.865682214643586],
              [-16.184889802843944, -10.866218686826159],
              [-16.18731384364238, -10.866968069120585],
              [-16.188592004132307, -10.869795027129053],
              [-16.188659774064842, -10.870870071705163],
              [-16.189675764755556, -10.872029202048825],
              [-16.193090731955742, -10.872412266367288],
              [-16.194562265529495, -10.875421264497849],
              [-16.197292409866712, -10.87969268655498],
              [-16.197576818309052, -10.882516344733741],
              [-16.2004030476077, -10.88622114870166],
              [-16.200491143654048, -10.887546404682888],
              [-16.20131085922859, -10.888606393728821],
              [-16.203971941480518, -10.888631933992404],
              [-16.205861621103075, -10.88751975197536],
              [-16.208045164316214, -10.88544462153594],
              [-16.207222368288413, -10.884879439428758]
            ]
          ],
          [
            [
              [-16.227572607559473, -10.668521155079064],
              [-16.224929040839807, -10.667219340167021],
              [-16.224197104827567, -10.669769840400598],
              [-16.22719941533496, -10.671491400899544],
              [-16.227900534273214, -10.66899945587068],
              [-16.227572607559473, -10.668521155079064]
            ]
          ],
          [
            [
              [-16.222303244175272, -10.906732153972548],
              [-16.22089914498992, -10.906117567945783],
              [-16.216144669892415, -10.906164452205266],
              [-16.213796997151338, -10.905385611544387],
              [-16.211473167096578, -10.903412869992339],
              [-16.209998595120425, -10.901265995107291],
              [-16.21047788395312, -10.900565544240314],
              [-16.21328136760623, -10.902290675538001],
              [-16.215141852428808, -10.90245057960444],
              [-16.216935111323053, -10.901491768552225],
              [-16.217412548411726, -10.900337608961957],
              [-16.215981467456114, -10.899102213761958],
              [-16.213827448308024, -10.898505040443286],
              [-16.213512635365273, -10.897365600039473],
              [-16.211547652721276, -10.895589425900493],
              [-16.211668275836907, -10.894240509145872],
              [-16.21331485403259, -10.893517266398728],
              [-16.215296603709, -10.894635230443035],
              [-16.218243183545262, -10.894270206502561],
              [-16.217607224649296, -10.892527101163664],
              [-16.214085332074887, -10.890947728120047],
              [-16.211672661073884, -10.891398935938586],
              [-16.210758914294516, -10.892308515143629],
              [-16.21006203227642, -10.895596297154592],
              [-16.20916355639144, -10.89623107227872],
              [-16.208014331478434, -10.898062131847736],
              [-16.206356347836365, -10.897997548182609],
              [-16.205154937129617, -10.89529897146126],
              [-16.207306752154164, -10.894981231600573],
              [-16.208419515641015, -10.893912821680114],
              [-16.207398717710614, -10.892180409745723],
              [-16.20538698676573, -10.891776379401342],
              [-16.20456351278309, -10.89451269989822],
              [-16.202202976381514, -10.894430449084762],
              [-16.200262460404193, -10.89543553754547],
              [-16.19916177078274, -10.89489202697444],
              [-16.199077041357526, -10.893575401930027],
              [-16.197986168445077, -10.892804361893386],
              [-16.19589170365574, -10.888706082331273],
              [-16.196475069554367, -10.88731903747502],
              [-16.194856598652404, -10.88635349591536],
              [-16.19203474919866, -10.880795082829428],
              [-16.190421552089887, -10.880241475271134],
              [-16.189062441873997, -10.876459024075238],
              [-16.18790334342607, -10.874587482373489],
              [-16.185207830777628, -10.871346040775222],
              [-16.18395277215239, -10.868725818803366],
              [-16.182109101438204, -10.868438634577837],
              [-16.180857040500868, -10.86939666585826],
              [-16.180559613453926, -10.87216700141745],
              [-16.183418915442257, -10.87632969208993],
              [-16.183819967113976, -10.878299369859937],
              [-16.1845736348121, -10.879148429764589],
              [-16.18634453637075, -10.88387444206677],
              [-16.1862548472917, -10.885760651366404],
              [-16.187020513414865, -10.886034118314791],
              [-16.188458701033092, -10.888508675035164],
              [-16.19080278732511, -10.891557390678036],
              [-16.192106467244834, -10.892784640828399],
              [-16.193212529172122, -10.89527143989744],
              [-16.195522029959136, -10.89872976281203],
              [-16.197248488628226, -10.900364591245],
              [-16.200583958296384, -10.902180942634887],
              [-16.201510454124247, -10.903457166813798],
              [-16.206931838409332, -10.906195369924909],
              [-16.209801071811068, -10.906732131893659],
              [-16.21073293767938, -10.90656489380595],
              [-16.213736327952265, -10.90793677976288],
              [-16.21770499122635, -10.908772032099316],
              [-16.218454842223952, -10.906898381792137],
              [-16.220648266751642, -10.907539454037078],
              [-16.222050577056212, -10.908648381107147],
              [-16.222303244175272, -10.906732153972548]
            ]
          ],
          [
            [
              [-16.313651051055206, -10.662359634568864],
              [-16.305367020978917, -10.650697872673247],
              [-16.303737975909872, -10.645813319931774],
              [-16.30250587449337, -10.640821320460999],
              [-16.3025028642901, -10.639391657375612],
              [-16.301085204753278, -10.636157854993028],
              [-16.299320144067526, -10.635391626495426],
              [-16.29609478891723, -10.632656138117387],
              [-16.295075303925355, -10.630279888998986],
              [-16.29384113140335, -10.629495798514881],
              [-16.293835121522978, -10.6266950673257],
              [-16.29083464544266, -10.624930909321884],
              [-16.287439116411257, -10.626178261323892],
              [-16.286654309299937, -10.625852786793924],
              [-16.284915954433707, -10.626715911479469],
              [-16.285299551132447, -10.628416804267902],
              [-16.284068250509392, -10.629281529166116],
              [-16.28086498040998, -10.62968214333151],
              [-16.279613826904836, -10.626851643162002],
              [-16.280496084698374, -10.626444786784573],
              [-16.279731441170732, -10.62439898446139],
              [-16.278377914817725, -10.623603584492008],
              [-16.2757859208851, -10.621326639842023],
              [-16.272560677986707, -10.619703326491734],
              [-16.27201509361614, -10.620381542335531],
              [-16.270082213097833, -10.620716519801558],
              [-16.269296475990952, -10.622004979363483],
              [-16.26643065018507, -10.623676515442938],
              [-16.268610096244608, -10.626896076622977],
              [-16.2684667192244, -10.627849589155817],
              [-16.266281341350005, -10.630304986394691],
              [-16.265803540917133, -10.632094801727238],
              [-16.26631949899094, -10.635056868152036],
              [-16.267247726104593, -10.636785296257445],
              [-16.269363030606005, -10.639136470690623],
              [-16.27117719150485, -10.640032746827634],
              [-16.27162093879664, -10.642204519621746],
              [-16.271276078842455, -10.643848173434513],
              [-16.269583369312517, -10.645077596919096],
              [-16.269412022362904, -10.646317394675187],
              [-16.271039949907628, -10.648725157243044],
              [-16.26965022552635, -10.648791241953766],
              [-16.26884578865399, -10.650094787520493],
              [-16.267816687631022, -10.649988999553953],
              [-16.268373170902333, -10.652273144245488],
              [-16.267204174230766, -10.652841082357472],
              [-16.269104279011447, -10.654895040933132],
              [-16.269246082284884, -10.656560365758633],
              [-16.272155692732863, -10.660392630422715],
              [-16.274990905423447, -10.662261558383301],
              [-16.276009606547042, -10.66345542883636],
              [-16.27787057674429, -10.664335356268728],
              [-16.27790913749239, -10.66603382356919],
              [-16.275877955615094, -10.666189372093378],
              [-16.274266682792796, -10.667630757753887],
              [-16.27339964519544, -10.66751890293934],
              [-16.272782820775337, -10.669244294578457],
              [-16.274150598204187, -10.672325972398024],
              [-16.27358362879596, -10.674662178220101],
              [-16.273824227011733, -10.676379065377184],
              [-16.272340522960082, -10.676074537822988],
              [-16.27157522888067, -10.67310253245148],
              [-16.270793052830314, -10.671522916258008],
              [-16.270779790002138, -10.669300503687795],
              [-16.267631969581743, -10.66370996254879],
              [-16.266601815435887, -10.662655357864601],
              [-16.26420036508567, -10.661909954841766],
              [-16.263664511041792, -10.66245044190743],
              [-16.26138154835705, -10.66151300886763],
              [-16.26168252190061, -10.659217569583738],
              [-16.263321711637893, -10.65840635101088],
              [-16.26327107821313, -10.654993383016805],
              [-16.262086032147405, -10.652453916599223],
              [-16.262090107499795, -10.649591211597428],
              [-16.25998776503959, -10.6477819147902],
              [-16.259758353836734, -10.645505254935273],
              [-16.258658860160317, -10.642711436649847],
              [-16.254584216509933, -10.637654817889583],
              [-16.254575579338198, -10.634733886099431],
              [-16.253604637144516, -10.632356343456069],
              [-16.25232729713612, -10.630698180938918],
              [-16.2528686997985, -10.628768216680365],
              [-16.25212691678417, -10.626980338938411],
              [-16.25044836267712, -10.625433375735458],
              [-16.24796794519436, -10.625411815911024],
              [-16.245193755154045, -10.623106103814303],
              [-16.243150656686048, -10.62277180164586],
              [-16.24355067920119, -10.624677095636844],
              [-16.241243645303214, -10.625137551636888],
              [-16.238577021615537, -10.623485473191566],
              [-16.237627652211927, -10.623423826815111],
              [-16.236478063578424, -10.624693239099225],
              [-16.23351893489582, -10.623471560910968],
              [-16.231183503393908, -10.623229070678294],
              [-16.229518439406913, -10.623668325211208],
              [-16.22854958808826, -10.626079694965478],
              [-16.22695378615745, -10.62551829636532],
              [-16.226217317624595, -10.626923637385813],
              [-16.22411909773045, -10.626297612042167],
              [-16.22163024029671, -10.629986309770857],
              [-16.220564424362326, -10.636137492535195],
              [-16.220487828709068, -10.637764945741829],
              [-16.222008675484396, -10.64041536307627],
              [-16.219465719642468, -10.643317655046037],
              [-16.219075674311913, -10.645824123434224],
              [-16.21925918861996, -10.647393194614791],
              [-16.217107580655405, -10.650452407585975],
              [-16.21729848805646, -10.652163928592126],
              [-16.217964354910197, -10.65268645999834],
              [-16.216914924875887, -10.654592190690781],
              [-16.216940109044703, -10.655886351894207],
              [-16.2196994215392, -10.658954109168096],
              [-16.219687262387843, -10.660891072447944],
              [-16.22079304508011, -10.66129062961773],
              [-16.22123470942955, -10.662722621062866],
              [-16.223284458604766, -10.664416024241556],
              [-16.226099662241108, -10.66490099582654],
              [-16.228535571495836, -10.667804965630527],
              [-16.22944298943099, -10.667475554674489],
              [-16.231888368712283, -10.663163454260737],
              [-16.233286704094578, -10.655759467055598],
              [-16.235048946142914, -10.655872540677285],
              [-16.236730362572587, -10.654657181353413],
              [-16.23814554023502, -10.651656320368884],
              [-16.24182363278633, -10.647761267707072],
              [-16.24185611972684, -10.645699407885251],
              [-16.242807047222193, -10.645538159865902],
              [-16.24439780866219, -10.647542184511254],
              [-16.24406955994744, -10.650941849089776],
              [-16.241429237702434, -10.655994254373523],
              [-16.236288301062196, -10.661299360913945],
              [-16.23527162184258, -10.66483999252501],
              [-16.236628750586195, -10.66885116180157],
              [-16.235009758848438, -10.670809860960036],
              [-16.233942927940202, -10.67098007934828],
              [-16.232331083411484, -10.674797092010607],
              [-16.232413550753463, -10.675816903892756],
              [-16.23376995706636, -10.676518048583528],
              [-16.23516839614043, -10.678277584496174],
              [-16.236245041789264, -10.67852981165072],
              [-16.238097677026953, -10.680892781985397],
              [-16.241155962955613, -10.6832575088279],
              [-16.24216518763908, -10.685244743509866],
              [-16.244654073689745, -10.684586883625824],
              [-16.24529820781335, -10.687318254381758],
              [-16.246229708777808, -10.689899626552114],
              [-16.247274742176483, -10.691728494224252],
              [-16.2486330533575, -10.691155724414937],
              [-16.249558302639553, -10.691557657318743],
              [-16.249592209242294, -10.693038048612971],
              [-16.24893007260452, -10.693767582305346],
              [-16.249300910712282, -10.696130608123873],
              [-16.250179758586736, -10.698472404485589],
              [-16.251463189805452, -10.698762994412952],
              [-16.25180954693846, -10.702256110964958],
              [-16.25316745735648, -10.703139003876883],
              [-16.252201554655034, -10.704597115785553],
              [-16.252701416662457, -10.706138457936815],
              [-16.255016967950905, -10.703983332242073],
              [-16.25627491682332, -10.704575042113731],
              [-16.25812276697265, -10.704263900585808],
              [-16.25903846617449, -10.703611560899787],
              [-16.259352546562848, -10.701875674644011],
              [-16.260787906620006, -10.701833841538045],
              [-16.26181849084317, -10.700319880182782],
              [-16.263231954959267, -10.701713416285934],
              [-16.26484884606843, -10.701436755699627],
              [-16.267781613236497, -10.7002009472275],
              [-16.2692603815026, -10.698428393291211],
              [-16.269801157809027, -10.69665151844592],
              [-16.273010324791294, -10.695547912980787],
              [-16.273819454188086, -10.694595403814798],
              [-16.273222175214585, -10.692259929828888],
              [-16.2719686870538, -10.691387647013824],
              [-16.2722822684789, -10.689633469310317],
              [-16.273745771748573, -10.689956614842593],
              [-16.27517067603136, -10.691692318027982],
              [-16.27544505468496, -10.69278715605366],
              [-16.279268236240995, -10.692757230564357],
              [-16.280597707659567, -10.692016704988829],
              [-16.283863724206523, -10.69325433204117],
              [-16.284352252317913, -10.693759767615575],
              [-16.288361787123964, -10.695643455791227],
              [-16.28883194862406, -10.696612404978879],
              [-16.290327390008013, -10.697543171087622],
              [-16.29159631119867, -10.699651505144425],
              [-16.29365606410004, -10.700260572455754],
              [-16.293982297082685, -10.702303895992653],
              [-16.29748059572025, -10.704900288599456],
              [-16.299724783917092, -10.707671824563098],
              [-16.301137095849512, -10.70996623523282],
              [-16.305402413389885, -10.71446471679451],
              [-16.30583083397461, -10.717213737033491],
              [-16.307798057027977, -10.71818073260072],
              [-16.307801592736467, -10.719133418680052],
              [-16.30886308338853, -10.72065972212618],
              [-16.313651051055206, -10.662359634568864]
            ]
          ],
          [
            [
              [-16.31442706197856, -10.652902203686601],
              [-16.313282026827228, -10.65044219836293],
              [-16.314251593073784, -10.648544952713456],
              [-16.31372981698291, -10.646972809351283],
              [-16.312218728996005, -10.645564172813495],
              [-16.311481378496115, -10.643652918663259],
              [-16.30969130467232, -10.642155507443972],
              [-16.309109204970916, -10.642946041360169],
              [-16.30936609279755, -10.647109357531017],
              [-16.31016607545851, -10.648260842210373],
              [-16.313290856240574, -10.654795415586301],
              [-16.31321937161733, -10.656160090454625],
              [-16.314059903865914, -10.65736743919536],
              [-16.31442706197856, -10.652902203686601]
            ]
          ],
          [
            [
              [-16.295112110625546, -10.918668134048136],
              [-16.290375910511642, -10.917303252530424],
              [-16.280770375573162, -10.911542795642532],
              [-16.28435869463161, -10.8690570847995],
              [-16.28182533810641, -10.868927643356741],
              [-16.283691259401568, -10.84679087791266],
              [-16.28213322825255, -10.846666121421679],
              [-16.290550540593767, -10.7473199554592],
              [-16.307837965761582, -10.748696557306934],
              [-16.309006876252198, -10.734438966414565],
              [-16.30808458467533, -10.732421275162952],
              [-16.307317017491695, -10.733513331152501],
              [-16.30447721588376, -10.732902455016177],
              [-16.302907945329363, -10.729815466048969],
              [-16.301900957323816, -10.72910626600542],
              [-16.301157865856194, -10.726693985527904],
              [-16.297990368899967, -10.722405384026649],
              [-16.295870081777892, -10.721059384734648],
              [-16.294806011036876, -10.717365465054174],
              [-16.293009563893378, -10.71528423840981],
              [-16.291509157103015, -10.71517459559611],
              [-16.28859674406589, -10.714026998675454],
              [-16.2836246396908, -10.709268160427817],
              [-16.28258449419436, -10.708878520635567],
              [-16.280451077413385, -10.706165774470888],
              [-16.277424308577174, -10.703393448466889],
              [-16.276009795241293, -10.70127283266559],
              [-16.274468432174864, -10.70086817936525],
              [-16.27374798945573, -10.703576856763853],
              [-16.271812077971035, -10.704192535819683],
              [-16.2708502604651, -10.70539596781847],
              [-16.27126872618592, -10.706977721369789],
              [-16.272789191918715, -10.708338541856815],
              [-16.2714658651255, -10.70897906515789],
              [-16.272022436953275, -10.710848598958918],
              [-16.268570424586237, -10.709813674235514],
              [-16.26683793819996, -10.708778373978255],
              [-16.264740782907815, -10.70858622516699],
              [-16.262825648306908, -10.709032820507776],
              [-16.262347953876887, -10.711485418190081],
              [-16.260590269059982, -10.711217245425082],
              [-16.259856893403317, -10.71188565493363],
              [-16.260735020616224, -10.713093952477847],
              [-16.26077421425515, -10.714536391502024],
              [-16.263176582231992, -10.716358606773204],
              [-16.26564726662268, -10.716442302080633],
              [-16.26563724595551, -10.717272573437645],
              [-16.263641275498493, -10.718810223886239],
              [-16.262324048032717, -10.718883208475543],
              [-16.258725593830206, -10.717386407948823],
              [-16.257361105459204, -10.715406950847303],
              [-16.25798506489129, -10.713877923077431],
              [-16.256432184120804, -10.7136058406205],
              [-16.253203259946304, -10.715179754959019],
              [-16.253195078080648, -10.71738954603754],
              [-16.255917555640927, -10.72047773634161],
              [-16.25707928182194, -10.720311373287267],
              [-16.257617333320848, -10.7214314356883],
              [-16.257178943280866, -10.723889901747851],
              [-16.255248290441987, -10.72417480076068],
              [-16.252939289656283, -10.723859063301676],
              [-16.250186974659933, -10.721506379658024],
              [-16.249023031846306, -10.721297694928179],
              [-16.248237237152846, -10.719973646552484],
              [-16.246434293529592, -10.719739798630366],
              [-16.244995477493383, -10.7204904068177],
              [-16.243821264430217, -10.718463665575161],
              [-16.242314338687528, -10.717542910006166],
              [-16.241431945320578, -10.71907216344456],
              [-16.241548154354998, -10.721475981876504],
              [-16.24123420454223, -10.724574295725102],
              [-16.24010183684658, -10.726954326793328],
              [-16.240365499338996, -10.730245522136467],
              [-16.241585532875565, -10.733395482955112],
              [-16.24401886851913, -10.736994512649096],
              [-16.242755887383666, -10.737821902428655],
              [-16.24199252819821, -10.73670075670262],
              [-16.239145216113773, -10.73408188834817],
              [-16.238999346547157, -10.733175540427094],
              [-16.236403925397923, -10.732365191327368],
              [-16.236490899060296, -10.73068727490683],
              [-16.235939070751073, -10.727187977943013],
              [-16.235455697328604, -10.726395783663065],
              [-16.236254989594336, -10.72084207492601],
              [-16.236343393330532, -10.718455597675515],
              [-16.23739471124103, -10.717226973562564],
              [-16.238521171164166, -10.71699846606601],
              [-16.238695320437685, -10.713869794195357],
              [-16.239100298802512, -10.711836019767913],
              [-16.239947249201723, -10.711056870709843],
              [-16.239504526360648, -10.709579701362163],
              [-16.239426234378247, -10.707221907861777],
              [-16.236609950116637, -10.706434094348856],
              [-16.23630539831492, -10.70409806566949],
              [-16.233889096628833, -10.700892320816584],
              [-16.23268077264768, -10.698378286917807],
              [-16.231688619587732, -10.692987888971015],
              [-16.230429258591577, -10.692247941499325],
              [-16.229804966617316, -10.697138124829623],
              [-16.228823892935708, -10.700335029267029],
              [-16.2282802593276, -10.705272581747447],
              [-16.227800387566433, -10.707663243391595],
              [-16.228282536092568, -10.710056513804666],
              [-16.227317791238153, -10.712142965427113],
              [-16.22472176679695, -10.711857551895202],
              [-16.224187395099612, -10.710736622177224],
              [-16.22438907049161, -10.709172414776267],
              [-16.225487285632006, -10.706287806244807],
              [-16.226183198773064, -10.702861995068858],
              [-16.226320765993528, -10.69995654724241],
              [-16.22682971434099, -10.698157204071142],
              [-16.226453333007992, -10.69049109928948],
              [-16.226003363120814, -10.68958187644812],
              [-16.22566692512754, -10.686642492720566],
              [-16.22429266455092, -10.683828219809897],
              [-16.222235371482686, -10.68329415066778],
              [-16.2198527455719, -10.684304207664285],
              [-16.219220250697816, -10.681375681953163],
              [-16.218239412628066, -10.678474853495825],
              [-16.216857369357058, -10.6779716701408],
              [-16.21542361882865, -10.678887697190026],
              [-16.213642562263615, -10.678312060345354],
              [-16.21280874509358, -10.680474219916224],
              [-16.21325963396498, -10.682107938099268],
              [-16.211756165868234, -10.682772039499135],
              [-16.210095624171707, -10.689609719882755],
              [-16.209220239749047, -10.687326035770269],
              [-16.20724920282821, -10.686524807873477],
              [-16.204665289518587, -10.689737819426785],
              [-16.205897223185165, -10.690353180409629],
              [-16.206530315705823, -10.691927683495676],
              [-16.207847407986147, -10.692286887856334],
              [-16.20901383028838, -10.693625033988749],
              [-16.209206348809353, -10.694877328152335],
              [-16.211449954094007, -10.695398720472598],
              [-16.211332663034664, -10.698487776442256],
              [-16.212374234268026, -10.699410012695493],
              [-16.21323968134076, -10.70114749412094],
              [-16.213567253199763, -10.70362834835449],
              [-16.21202738936244, -10.703452811156371],
              [-16.211618150002476, -10.702099481433375],
              [-16.210491527713476, -10.701210282261362],
              [-16.20885088106529, -10.701694038920271],
              [-16.207633857240232, -10.70067492010189],
              [-16.206710416902492, -10.699134593590196],
              [-16.206626618059943, -10.697364647407763],
              [-16.204996726263715, -10.695275786516634],
              [-16.203332442959585, -10.694460230205939],
              [-16.202262541126785, -10.695195625015842],
              [-16.202140762008067, -10.696522141829263],
              [-16.19927143366539, -10.697239767100168],
              [-16.19845231009728, -10.696802263388156],
              [-16.197316450571023, -10.699355761268324],
              [-16.197461824011974, -10.700442943953428],
              [-16.19932066541344, -10.700263700926792],
              [-16.199820433887506, -10.702618747867541],
              [-16.19929768669903, -10.704295423414212],
              [-16.19624890208091, -10.704713677892732],
              [-16.1935819022817, -10.703055917432907],
              [-16.191717854767614, -10.706539826784452],
              [-16.190327764981284, -10.707834918804112],
              [-16.190207954980643, -10.709345629770159],
              [-16.191954480146183, -10.713275457999588],
              [-16.191073236531857, -10.71504354824763],
              [-16.191793215551172, -10.71634575840892],
              [-16.193068083241613, -10.717190322105361],
              [-16.193061928240184, -10.718367270412172],
              [-16.194742285538396, -10.71859822291257],
              [-16.19469068900901, -10.719678900192246],
              [-16.196688636891448, -10.720618939984714],
              [-16.196998546428823, -10.723265839301249],
              [-16.196079043582117, -10.7245649926816],
              [-16.19417947010799, -10.72403056402672],
              [-16.193069011071447, -10.725170382814849],
              [-16.1944040510249, -10.72626440186193],
              [-16.193902078892904, -10.727479277720413],
              [-16.19164540707279, -10.726587176454982],
              [-16.189602345557038, -10.726932805811773],
              [-16.189803686201913, -10.725203822540735],
              [-16.1907364987444, -10.724657426558602],
              [-16.19033360285557, -10.721920125351884],
              [-16.189459754682908, -10.720948649016421],
              [-16.187777492067628, -10.72205689210781],
              [-16.186729421214263, -10.724725223308502],
              [-16.18496655651939, -10.72803327982799],
              [-16.184145629163947, -10.728454824352193],
              [-16.183648678597574, -10.730483020111151],
              [-16.184944160560597, -10.730680599505702],
              [-16.18569395838012, -10.732109850985497],
              [-16.185268870716722, -10.733149008670194],
              [-16.18602872189985, -10.734030400909987],
              [-16.186119727173136, -10.735561286597312],
              [-16.186964872509154, -10.73655422493022],
              [-16.189647314474133, -10.73774992498293],
              [-16.191689846126987, -10.738318770251679],
              [-16.191120256537364, -10.739813459160043],
              [-16.192507542533825, -10.741258406286198],
              [-16.193011280246207, -10.740470061718021],
              [-16.195192109281777, -10.744102605055165],
              [-16.19685103463791, -10.74518495647435],
              [-16.19753489153366, -10.746242350591404],
              [-16.198824757028078, -10.74674337497296],
              [-16.198817584582557, -10.747719380718522],
              [-16.200504177943568, -10.747705646745784],
              [-16.20220811075232, -10.748629609325505],
              [-16.20286697918977, -10.749934278193155],
              [-16.204443107608125, -10.750942937204776],
              [-16.20436373959387, -10.748432794729156],
              [-16.205370043354925, -10.748216015933904],
              [-16.20688712760081, -10.749163367872615],
              [-16.206988489884726, -10.752073545221354],
              [-16.20780212562971, -10.754250502096259],
              [-16.209351751875985, -10.755571757969244],
              [-16.210651740358937, -10.753665210325545],
              [-16.213123548598833, -10.75361667895964],
              [-16.214056694072593, -10.751479591285484],
              [-16.216210592807233, -10.750161153280121],
              [-16.21695369522258, -10.748984881921361],
              [-16.219383567921124, -10.749846962102405],
              [-16.219832731749595, -10.751025232499833],
              [-16.21905381488399, -10.752829898901565],
              [-16.217950103334868, -10.752530380566519],
              [-16.217548197408185, -10.753798025031854],
              [-16.21630528560908, -10.754585761682854],
              [-16.216205058825754, -10.756612815520688],
              [-16.2142562169414, -10.758153630755752],
              [-16.21329824180311, -10.760106290760906],
              [-16.21382704446343, -10.762558548414232],
              [-16.214824261496258, -10.764294380740752],
              [-16.216156372547477, -10.764693627216108],
              [-16.21796452414953, -10.766732383632599],
              [-16.22027908347107, -10.768290711688598],
              [-16.220729225022534, -10.769470952161276],
              [-16.225025461227123, -10.76861883806874],
              [-16.225274819844046, -10.766745440475091],
              [-16.229376295179158, -10.766445699387429],
              [-16.229708295865425, -10.76757451863419],
              [-16.228044745748548, -10.770080572750015],
              [-16.22737945649278, -10.772469142866518],
              [-16.228056397850533, -10.774627114590187],
              [-16.225986361422464, -10.780485008403408],
              [-16.226244558939236, -10.78175129281379],
              [-16.22953181263914, -10.784420077883286],
              [-16.229843002343816, -10.78579329977847],
              [-16.232642084952094, -10.789807708560096],
              [-16.233938760030277, -10.789367035300526],
              [-16.236968178113848, -10.792666068482557],
              [-16.238314129405634, -10.793310903243052],
              [-16.239500464659233, -10.79318691009125],
              [-16.239266690528293, -10.795147483897756],
              [-16.24100770384373, -10.796887435448339],
              [-16.242219338060607, -10.796765277448598],
              [-16.242842188402786, -10.795776232696815],
              [-16.245351670958147, -10.79680436456749],
              [-16.24484184482372, -10.798864687042611],
              [-16.24231045469905, -10.799734214635478],
              [-16.24211157945297, -10.801065559898843],
              [-16.242929032032862, -10.802339541434094],
              [-16.244170341520046, -10.801831351654432],
              [-16.246531472820973, -10.802683456586895],
              [-16.24824337281616, -10.798660280035865],
              [-16.24773952265365, -10.796861914184753],
              [-16.247988089921904, -10.792105894762821],
              [-16.249209164263075, -10.788494432158672],
              [-16.250712935442237, -10.788742690362653],
              [-16.251310448422483, -10.789935386144325],
              [-16.254283183863908, -10.789408516892237],
              [-16.254772323836367, -10.790428476647076],
              [-16.257240435975692, -10.79145030205023],
              [-16.259539121458054, -10.793967597267905],
              [-16.2606415064398, -10.796018560143358],
              [-16.25742944523656, -10.797875253458527],
              [-16.254145601100443, -10.797683745875785],
              [-16.2526864464063, -10.799767294743438],
              [-16.251472600133706, -10.800442114570393],
              [-16.249865873587737, -10.80516959712751],
              [-16.24812984839374, -10.806617831332934],
              [-16.246700049694073, -10.805966607846218],
              [-16.247716438751457, -10.808524865826707],
              [-16.249200007395423, -10.8097526000508],
              [-16.250165304637836, -10.811959218005587],
              [-16.251179006647256, -10.812657274280323],
              [-16.253900661242014, -10.816544226825634],
              [-16.25557791138829, -10.818422245147202],
              [-16.258023749641737, -10.820261499973007],
              [-16.258618558780896, -10.821517657955859],
              [-16.26003290327802, -10.822861967168084],
              [-16.264048896390495, -10.825218677405601],
              [-16.26473077591559, -10.827648923257101],
              [-16.262025650844347, -10.82711904280011],
              [-16.259960455649463, -10.825638873506282],
              [-16.25663390138825, -10.823685615129152],
              [-16.256575371086484, -10.822923719581624],
              [-16.255000226310038, -10.821769929764526],
              [-16.25221715885171, -10.818572034135892],
              [-16.25230365636144, -10.817331410327146],
              [-16.250850470862655, -10.816453784354627],
              [-16.24797822724994, -10.820263409014304],
              [-16.246770042570756, -10.819180330137966],
              [-16.246868290381343, -10.816386279877754],
              [-16.245849155218934, -10.815748716479261],
              [-16.24590522305636, -10.814628470154611],
              [-16.2449623322376, -10.811932222106398],
              [-16.24388237325569, -10.81266611086982],
              [-16.242639791221848, -10.811798135788655],
              [-16.238141233149392, -10.805388194027724],
              [-16.23613733226205, -10.800280500925469],
              [-16.23472863617165, -10.800297332780895],
              [-16.231487902579612, -10.798625386013716],
              [-16.23060302167188, -10.798638564561546],
              [-16.22846436317733, -10.796923923477804],
              [-16.226927745899843, -10.796567515149215],
              [-16.226010830287017, -10.79550850327637],
              [-16.224823711783635, -10.795825447313472],
              [-16.220312707395415, -10.798776875288468],
              [-16.220100434680614, -10.799534942221849],
              [-16.22110789588089, -10.802584872090845],
              [-16.223501648413464, -10.804221236629846],
              [-16.224493094998362, -10.803754535725314],
              [-16.22604811489664, -10.804378456009964],
              [-16.227338976629998, -10.803794112872],
              [-16.228082278535506, -10.80449130920499],
              [-16.232008463803236, -10.803988516271435],
              [-16.23303999875908, -10.804934738950529],
              [-16.23295053513918, -10.8059490030463],
              [-16.23040116752505, -10.805588692245385],
              [-16.230572782576523, -10.80723247326245],
              [-16.231972895508438, -10.808134677758636],
              [-16.232842030592977, -10.80741161305266],
              [-16.234214941540532, -10.810349379844137],
              [-16.235736510644507, -10.811132876152957],
              [-16.237692779041527, -10.812852502827013],
              [-16.23824596029333, -10.814556019565705],
              [-16.2375683882426, -10.816155391603278],
              [-16.23653386874434, -10.81456694735918],
              [-16.234933925481112, -10.814152435608879],
              [-16.23278899750782, -10.811761617475309],
              [-16.232309625952414, -10.810637308879036],
              [-16.230532745503947, -10.809238534366841],
              [-16.22892935589406, -10.80891773463828],
              [-16.226835500841318, -10.80783904415767],
              [-16.22578466339232, -10.809670930913809],
              [-16.22486469211076, -10.80863110586416],
              [-16.223365918785518, -10.809688240791719],
              [-16.222099692686186, -10.812769929532],
              [-16.220790289085944, -10.811000680754626],
              [-16.219862708191183, -10.811206919022077],
              [-16.219412030093057, -10.81509547422398],
              [-16.2205532417637, -10.818058294520934],
              [-16.220597817942018, -10.820804324879347],
              [-16.221057112875325, -10.823771315047695],
              [-16.220941235819478, -10.825071448601324],
              [-16.221753618073492, -10.826635983857317],
              [-16.222402586204815, -10.82910850763164],
              [-16.22344741068823, -10.830160749724303],
              [-16.22280249945764, -10.831825958623917],
              [-16.22277306836552, -10.834486795465597],
              [-16.22075878084662, -10.834785326420509],
              [-16.21963288977622, -10.832783023412038],
              [-16.219162471362203, -10.829936025220693],
              [-16.217682916851395, -10.827964975599746],
              [-16.21781016571104, -10.825846232460304],
              [-16.21578431185993, -10.825364064527351],
              [-16.217505187123, -10.823936138388103],
              [-16.21586705532394, -10.817285744118951],
              [-16.215009071794793, -10.816249477562502],
              [-16.215646518885126, -10.814442921370963],
              [-16.214016537584, -10.81325831004118],
              [-16.212716875277373, -10.813002514323237],
              [-16.213742810614573, -10.811475707822236],
              [-16.214291747211437, -10.808451046434174],
              [-16.213898492444798, -10.806294964833658],
              [-16.213955324848367, -10.802906412250348],
              [-16.212073379824712, -10.801375856835204],
              [-16.21037106084452, -10.802349595430945],
              [-16.20899061667343, -10.804600525630919],
              [-16.209013510422995, -10.806176846423444],
              [-16.207818027248603, -10.80660441346423],
              [-16.207797571346678, -10.807972542860036],
              [-16.20621864231701, -10.807384619687266],
              [-16.204389576812783, -10.807960892147866],
              [-16.203716464736033, -10.807636204609821],
              [-16.202469753943042, -10.809531286946887],
              [-16.20348758614877, -10.811522960901778],
              [-16.205301683673355, -10.813944103784692],
              [-16.206611551592818, -10.816972553482033],
              [-16.20650465563066, -10.817925319778695],
              [-16.207302595534358, -10.82030781422684],
              [-16.208870062766984, -10.819441425733062],
              [-16.20936027485411, -10.820425719185094],
              [-16.20761654591323, -10.821870620002244],
              [-16.207823459651454, -10.824161297052655],
              [-16.206882329275313, -10.826156524336326],
              [-16.208084185831886, -10.827460937764076],
              [-16.209560533751368, -10.827384642442542],
              [-16.209698479727102, -10.828379797018776],
              [-16.207755821075615, -10.831099316850986],
              [-16.205115274011114, -10.830766574773229],
              [-16.20565430045327, -10.833047413464246],
              [-16.206064794646796, -10.836526354968926],
              [-16.20584607294953, -10.837799105159963],
              [-16.204656460650597, -10.838125603244283],
              [-16.203396249901274, -10.83580150971283],
              [-16.202573214997454, -10.836426574854766],
              [-16.200723051382383, -10.835813539097296],
              [-16.20105630086583, -10.832829735142573],
              [-16.200750495066224, -10.827536920387988],
              [-16.201506801952544, -10.826046612351126],
              [-16.199935704523917, -10.824434291228764],
              [-16.200576389121483, -10.822852115681526],
              [-16.200141374807462, -10.820356824819324],
              [-16.201340246405408, -10.818140726342778],
              [-16.20100774840048, -10.817198617851732],
              [-16.198575799483127, -10.81710760184855],
              [-16.19871379502738, -10.815464286228424],
              [-16.197356538116132, -10.814605775627333],
              [-16.197734388423104, -10.813411128090037],
              [-16.19582527030715, -10.813405346704204],
              [-16.194339791124804, -10.814810522745981],
              [-16.19439232766964, -10.816268329562693],
              [-16.193393117067085, -10.817694524952286],
              [-16.19382397500001, -10.819926539272856],
              [-16.194742165141566, -10.820969793167773],
              [-16.19498798203502, -10.824781570409163],
              [-16.195789170915855, -10.825588460069763],
              [-16.196977316235884, -10.830487101057932],
              [-16.196092865404754, -10.83155671775175],
              [-16.19825902560485, -10.833919858121885],
              [-16.198045222164385, -10.835356505073149],
              [-16.198411047069605, -10.8372542500836],
              [-16.1997562133575, -10.839094445096281],
              [-16.200676518684116, -10.841964238508771],
              [-16.20180112984474, -10.843047226182321],
              [-16.201049736505244, -10.844704601981142],
              [-16.201013749458504, -10.846014403774612],
              [-16.19889456855768, -10.845151812707558],
              [-16.200122220180283, -10.849897006013435],
              [-16.201276060424057, -10.851352474519409],
              [-16.20208501439539, -10.855015819442887],
              [-16.203448118171004, -10.85554530457534],
              [-16.203732544769792, -10.85813694454914],
              [-16.204778149092217, -10.859311589598489],
              [-16.207218122956803, -10.864829051660907],
              [-16.207091461634754, -10.866235781543093],
              [-16.206138412532994, -10.86851632344041],
              [-16.20792655082759, -10.871960707997578],
              [-16.211141931672067, -10.87526141576105],
              [-16.213765330964232, -10.877297842732588],
              [-16.21479357124176, -10.876954526468593],
              [-16.215354105381824, -10.878347955896563],
              [-16.21676624416238, -10.87924758223487],
              [-16.21935057826558, -10.879464126327665],
              [-16.220287816304143, -10.880614192243012],
              [-16.224318503696654, -10.880403043830512],
              [-16.225603370571086, -10.88142573419415],
              [-16.227193124660804, -10.881984855459372],
              [-16.228283268755852, -10.881645287664888],
              [-16.22888193492016, -10.87980392477455],
              [-16.23044256833007, -10.87907261400652],
              [-16.232739665806584, -10.87965768022723],
              [-16.233128701152275, -10.87853914746083],
              [-16.234738090039595, -10.877482449616545],
              [-16.236010506736008, -10.877425279589655],
              [-16.23654920236103, -10.875904073453215],
              [-16.234945473721993, -10.875588080116437],
              [-16.23187554462483, -10.875533954271077],
              [-16.229549537596036, -10.875994797067076],
              [-16.225971978975352, -10.875567408864057],
              [-16.223296039479127, -10.874578356041974],
              [-16.221907259179318, -10.874542107669173],
              [-16.219981179313322, -10.872835370864648],
              [-16.215686117871883, -10.872774788332448],
              [-16.214787012074503, -10.872142530273127],
              [-16.21454941934115, -10.87084749179454],
              [-16.221850562821786, -10.870261811189263],
              [-16.226027094697503, -10.870474292033101],
              [-16.2287791931158, -10.872003291021954],
              [-16.23072695890871, -10.87181915670499],
              [-16.23330737846302, -10.871051371957263],
              [-16.2347454562081, -10.870042573900404],
              [-16.235433126779068, -10.868354237123306],
              [-16.234170491685877, -10.867836530064046],
              [-16.23180805589464, -10.865428181265102],
              [-16.230531888625297, -10.866008451317594],
              [-16.229421372479344, -10.864476252329357],
              [-16.22626634218611, -10.863299378924392],
              [-16.22386247548802, -10.863961486207526],
              [-16.220985795810222, -10.864331877505023],
              [-16.218600219307337, -10.862915028751564],
              [-16.217369582257483, -10.862747965892876],
              [-16.216468218267053, -10.861684336184824],
              [-16.214626204089274, -10.86092988763772],
              [-16.215088558274022, -10.860168954306566],
              [-16.21712431733968, -10.859913051038983],
              [-16.21666764829646, -10.858518432572145],
              [-16.2170179200119, -10.85715238450201],
              [-16.218454792186797, -10.856393082535964],
              [-16.219485498867886, -10.857631537372125],
              [-16.222349002705034, -10.858328659126592],
              [-16.22434596363408, -10.857801197269382],
              [-16.224516942370062, -10.856337944132168],
              [-16.22582439634301, -10.85562838562087],
              [-16.226387361693405, -10.857236332900756],
              [-16.230062464363275, -10.856256250332493],
              [-16.23241651779338, -10.856845972638816],
              [-16.23417438563445, -10.855722089636126],
              [-16.234728073763044, -10.853901550236422],
              [-16.234559824812923, -10.848020153361851],
              [-16.236372597641935, -10.846963366845674],
              [-16.2370332108237, -10.845809088825048],
              [-16.236815904525162, -10.843084489638194],
              [-16.235545323867143, -10.841746878488498],
              [-16.235246586030748, -10.839959064062406],
              [-16.236332355665276, -10.839149042800324],
              [-16.2357226089112, -10.83807263569386],
              [-16.236039523902374, -10.836112115573897],
              [-16.23608329582512, -10.832326751305384],
              [-16.234338511640352, -10.829556325857713],
              [-16.235350256668752, -10.828638676844665],
              [-16.23854743090758, -10.830874988811088],
              [-16.240620356461466, -10.829411615830294],
              [-16.243225615000195, -10.831330677282446],
              [-16.24382149408612, -10.829476233091048],
              [-16.243260032339535, -10.828323547281451],
              [-16.243311285311194, -10.826546622397029],
              [-16.2440342468011, -10.826320946048323],
              [-16.24615286007786, -10.830265768000313],
              [-16.244903648581726, -10.831307741769004],
              [-16.24558381147454, -10.833719806648118],
              [-16.247018559525582, -10.833164283983209],
              [-16.24758375875622, -10.833805512283007],
              [-16.24771282118159, -10.835659763702779],
              [-16.24554093502669, -10.838264127857311],
              [-16.24503920855621, -10.839944333225551],
              [-16.247419547557378, -10.841433931137463],
              [-16.248879899542573, -10.84274443216672],
              [-16.249233803892682, -10.843921956641202],
              [-16.247511164525516, -10.84638996348241],
              [-16.24972683685781, -10.847325284671342],
              [-16.2510976895992, -10.850166844912614],
              [-16.251202671547, -10.852554913448024],
              [-16.24982129839146, -10.854388481714315],
              [-16.24699147382792, -10.856822355409648],
              [-16.246822066200558, -10.858140032624016],
              [-16.24923366588466, -10.85879273379748],
              [-16.24938760614739, -10.860611746209294],
              [-16.247808950459536, -10.860398106827397],
              [-16.247461885657387, -10.861292686226713],
              [-16.248301481014337, -10.863579921529794],
              [-16.248512747086167, -10.865938682743572],
              [-16.249350558606587, -10.866777167383525],
              [-16.251551129998173, -10.867526255209679],
              [-16.251711115209165, -10.869285382190432],
              [-16.250725144271538, -10.870128009805645],
              [-16.25146707270197, -10.87212070531512],
              [-16.25091899335273, -10.873904116512627],
              [-16.251745022375342, -10.87613051458343],
              [-16.25131679031474, -10.877245913309006],
              [-16.25275402596167, -10.878166646492378],
              [-16.25619382074791, -10.878266253221106],
              [-16.258263021512125, -10.878847878026807],
              [-16.258329762430066, -10.880497953407872],
              [-16.25342972612396, -10.882396166325039],
              [-16.2527880431281, -10.884543709861852],
              [-16.250075200476893, -10.884450679083535],
              [-16.251078668420963, -10.887261257690646],
              [-16.25160024466538, -10.891110946179825],
              [-16.249881780616825, -10.893438090242098],
              [-16.249814428442303, -10.89542918697238],
              [-16.25099084206855, -10.898203362381512],
              [-16.252364398837013, -10.898687533119864],
              [-16.253217961683355, -10.90038495940399],
              [-16.253018496439452, -10.904065264587775],
              [-16.25362848356074, -10.906042261782837],
              [-16.255013358107373, -10.906346935140123],
              [-16.256238516859153, -10.908153219880608],
              [-16.256993931343754, -10.907844276596487],
              [-16.257861840821434, -10.905237191949775],
              [-16.261256672490738, -10.90480682681527],
              [-16.262937618852632, -10.903326039818896],
              [-16.26326062951531, -10.901725408717445],
              [-16.26221876499323, -10.898798656104006],
              [-16.263845663572297, -10.896790614331211],
              [-16.265388487972732, -10.896505056697732],
              [-16.265677803616033, -10.892598071893413],
              [-16.26633729696702, -10.891684647625704],
              [-16.264657173285755, -10.889428374524766],
              [-16.263231639716356, -10.888097959503023],
              [-16.263573004647114, -10.887015291759877],
              [-16.26544263323285, -10.887764700673396],
              [-16.26688855626913, -10.888880819259802],
              [-16.269628300982422, -10.88866120900643],
              [-16.27143130212508, -10.88527042084855],
              [-16.272640355180005, -10.883744249928272],
              [-16.271883624856628, -10.882120491288203],
              [-16.274418109434574, -10.882120372083522],
              [-16.27563290601299, -10.879279593380435],
              [-16.277052636514817, -10.878942246620998],
              [-16.278008920153503, -10.879923673451346],
              [-16.27640191118964, -10.884974103414422],
              [-16.275755608432906, -10.885744383710463],
              [-16.275265830027074, -10.89158693023531],
              [-16.274552709376792, -10.894882924658274],
              [-16.274889697083694, -10.898306010963795],
              [-16.27468560162906, -10.900492458532765],
              [-16.27608837557411, -10.902129157485705],
              [-16.27586274666107, -10.905323547620629],
              [-16.276717524062573, -10.90757421492935],
              [-16.28043868603933, -10.912119131077022],
              [-16.281900236423276, -10.91332833133787],
              [-16.283606836120345, -10.915855874884086],
              [-16.28559143769168, -10.918055006762675],
              [-16.288496716706813, -10.919461378310874],
              [-16.292209237757483, -10.919644873870897],
              [-16.295112110625546, -10.918668134048136]
            ]
          ],
          [
            [
              [-16.302765574668584, -10.397936078189314],
              [-16.183452467991437, -10.38748569378903],
              [-16.18058382997083, -10.417174092613411],
              [-16.091233934907113, -10.40852153686905],
              [-16.089159751951303, -10.423225148232975],
              [-16.026469314010313, -10.416427387176396],
              [-15.937288647460294, -10.40655939821688],
              [-15.92998393009143, -10.406181316358785],
              [-15.929503746270951, -10.406627572324235],
              [-15.926653403657166, -10.405868378286293],
              [-15.925863054294535, -10.40520676206248],
              [-15.92305430940681, -10.404834102678134],
              [-15.919140052726219, -10.434761523393334],
              [-15.910069438024713, -10.433540914799995],
              [-15.78411629689146, -10.41823904675574],
              [-15.782076458836048, -10.418100763509537],
              [-15.69712038868995, -10.406662082307038],
              [-15.691281121270725, -10.405964796631823],
              [-15.621512393890006, -10.395799167077737],
              [-15.619756292860504, -10.406390542439595],
              [-15.61699927176745, -10.425542995514181],
              [-15.618997025284171, -10.425808105008127],
              [-15.61804521342742, -10.431118929209704],
              [-15.61520082705859, -10.45233277857552],
              [-15.614520521589629, -10.455701906069825],
              [-15.495835794065474, -10.438043919916483],
              [-15.485189732217016, -10.501924372618923],
              [-15.435744032830128, -10.494237770960648],
              [-15.434008631218616, -10.493889953642967],
              [-15.433364520887233, -10.500460750833794],
              [-15.433871684066183, -10.50043806921052],
              [-15.429014934599659, -10.524565754129583],
              [-15.420701859735255, -10.523575103614032],
              [-15.402566432384587, -10.519490035339551],
              [-15.340521135613482, -10.50027290559528],
              [-15.330902722140511, -10.546606130723159],
              [-15.327530448217495, -10.565960261957336],
              [-15.176716067416434, -10.53551168516242],
              [-15.171345379754767, -10.564660991762299],
              [-15.324484000145148, -10.591205317681585],
              [-15.379340714453948, -10.600198717714386],
              [-15.449427629242445, -10.744319868257966],
              [-15.471420073479743, -10.788522298391115],
              [-15.469392578533522, -10.801509390081815],
              [-15.470022627072897, -10.801658952174009],
              [-15.478792346404838, -10.799256255447789],
              [-15.481641005970538, -10.79926777437389],
              [-15.482718218819151, -10.79826750426657],
              [-15.485902595267225, -10.796619881494093],
              [-15.485763253136806, -10.7956530822322],
              [-15.486956335850563, -10.794711704269478],
              [-15.491223106216953, -10.793937832396729],
              [-15.495868092603676, -10.793965268362857],
              [-15.501657048130388, -10.794450259283249],
              [-15.506485561831433, -10.796282587719963],
              [-15.510939155653112, -10.79756063939931],
              [-15.515547504145065, -10.797823233996787],
              [-15.521433740510643, -10.796586744153108],
              [-15.525169328223884, -10.79732505641127],
              [-15.530206072705573, -10.797613743667108],
              [-15.532052716376926, -10.798037496822934],
              [-15.53375221719995, -10.797869898481531],
              [-15.533841156941833, -10.796722853796792],
              [-15.531977549591868, -10.794090975012885],
              [-15.527973064920069, -10.791311462333846],
              [-15.522942966643953, -10.79019613929345],
              [-15.520816254082469, -10.790143556418801],
              [-15.516227856146836, -10.788703932759175],
              [-15.509771717124327, -10.789846806293275],
              [-15.507151881854861, -10.78809347968092],
              [-15.506672995046165, -10.786573048219845],
              [-15.504312186991086, -10.787459017863362],
              [-15.501646816998818, -10.78769392868678],
              [-15.497970776975508, -10.785740645405323],
              [-15.49857566930098, -10.784256235126042],
              [-15.500756937152019, -10.781225121327537],
              [-15.503782296261855, -10.777864608867239],
              [-15.503676087106216, -10.776648566613863],
              [-15.505557435125771, -10.775316535869376],
              [-15.511676665267075, -10.7716242825646],
              [-15.511696642019885, -10.769509791064198],
              [-15.512689282222372, -10.768570356214045],
              [-15.51747383691157, -10.769499603822107],
              [-15.520167620511302, -10.767005993125],
              [-15.524937233064781, -10.76600556077279],
              [-15.528374468876642, -10.765640304049072],
              [-15.529905711194214, -10.76462409636949],
              [-15.531785513651059, -10.761646595564702],
              [-15.534128097409688, -10.760984466563341],
              [-15.5349653434216, -10.761519496948036],
              [-15.53896313993994, -10.761694938751196],
              [-15.543401677683649, -10.760349261956538],
              [-15.54680870380999, -10.758488753832609],
              [-15.546824198025494, -10.755601928261234],
              [-15.545725748086184, -10.75486491275664],
              [-15.545717164032173, -10.753254243842019],
              [-15.550212550183545, -10.75246006165069],
              [-15.550718603312443, -10.75158417904651],
              [-15.546247612901578, -10.748050161408067],
              [-15.544519942540926, -10.74734633713528],
              [-15.539746568384775, -10.746117232271336],
              [-15.538584770844906, -10.74636074065184],
              [-15.53641306821333, -10.745013515243338],
              [-15.538158833716174, -10.743659048787313],
              [-15.541438163903385, -10.744012282090385],
              [-15.542378438505333, -10.744684751647895],
              [-15.544832222422729, -10.7447109280774],
              [-15.550355785842212, -10.746211056108036],
              [-15.551778503300175, -10.747282374763532],
              [-15.555431012808608, -10.749046250774294],
              [-15.557982463190882, -10.749536772539141],
              [-15.561162449279955, -10.751684527865793],
              [-15.56486389772808, -10.752008347142487],
              [-15.568818957768135, -10.753151271221327],
              [-15.571450979040916, -10.752536868271436],
              [-15.572469002432697, -10.75325915056899],
              [-15.575188382006335, -10.753985517594346],
              [-15.576875367984892, -10.753885937765606],
              [-15.579082392767, -10.755024012175708],
              [-15.581317702602053, -10.754268858863982],
              [-15.583717703979735, -10.752670736223568],
              [-15.588928393032358, -10.750068230700663],
              [-15.591876549413842, -10.750689802982281],
              [-15.593097011421927, -10.753169541285756],
              [-15.594208821508863, -10.754397717722036],
              [-15.59559845566725, -10.75257342933729],
              [-15.597032534448193, -10.752444921785191],
              [-15.599076899840387, -10.754132892356582],
              [-15.600367512021087, -10.752313452055715],
              [-15.605327783610306, -10.749486163958888],
              [-15.61224925358958, -10.747361989284324],
              [-15.616774632824397, -10.746261129546962],
              [-15.62166612444323, -10.745497915989645],
              [-15.62709869435677, -10.745013358051878],
              [-15.634051499616692, -10.745228620610176],
              [-15.637914705897458, -10.746416463242198],
              [-15.641104214936812, -10.745906453313506],
              [-15.64876588815549, -10.745798575374167],
              [-15.655945337964562, -10.74615569032398],
              [-15.659101400233483, -10.744978246300215],
              [-15.659553823940854, -10.743229992134289],
              [-15.656926669849135, -10.741230241766324],
              [-15.655039653334239, -10.739289305286972],
              [-15.649752825130854, -10.736434170036782],
              [-15.64635184093531, -10.735231306963415],
              [-15.64406600324205, -10.735248154733217],
              [-15.639548978811584, -10.734014157534158],
              [-15.635448573844528, -10.731314790681452],
              [-15.629960831041592, -10.729039228404345],
              [-15.628151968212265, -10.728625651714092],
              [-15.627661973178474, -10.727407018600847],
              [-15.631160317568279, -10.726451443941372],
              [-15.633361390407904, -10.72527506614877],
              [-15.63555510680485, -10.723564028310845],
              [-15.637012593822082, -10.722942625879256],
              [-15.641034366125359, -10.723247537658771],
              [-15.642652133823345, -10.724125889693388],
              [-15.644877285858707, -10.72393717883081],
              [-15.647023967229808, -10.722834014594998],
              [-15.64834970434193, -10.723138137564039],
              [-15.650287757087932, -10.72233464023319],
              [-15.654550059078964, -10.721805517974405],
              [-15.656021583137274, -10.722251571449664],
              [-15.655587081580007, -10.724163263411661],
              [-15.658121395415053, -10.7244245031633],
              [-15.659185241514276, -10.726005557089673],
              [-15.661637459802618, -10.724999063027644],
              [-15.666231146380662, -10.725437599265309],
              [-15.667533588915257, -10.72442275813312],
              [-15.669903333107964, -10.718422208672747],
              [-15.669962266165873, -10.717404716737905],
              [-15.667793775641815, -10.71305251448098],
              [-15.668000207126811, -10.711276082214185],
              [-15.665982571440052, -10.706453898222664],
              [-15.663395959153302, -10.700982221929346],
              [-15.662802297074945, -10.6990172929326],
              [-15.661777198069228, -10.697772744626821],
              [-15.661945252341786, -10.69480575272712],
              [-15.660796551842258, -10.692970989175416],
              [-15.660664469023367, -10.691447521240033],
              [-15.659311991551984, -10.689412697122867],
              [-15.659238074346975, -10.68817447460802],
              [-15.660094969562072, -10.686969206499748],
              [-15.659375001155107, -10.684625221650046],
              [-15.65734780982654, -10.67986574981182],
              [-15.656212740858136, -10.67802776792701],
              [-15.655643700116439, -10.67439044721225],
              [-15.65478383502885, -10.673169336600974],
              [-15.653741056823204, -10.67061497233659],
              [-15.65341121421743, -10.668567367658286],
              [-15.65181738054857, -10.664957859759266],
              [-15.651168138881486, -10.664297030667765],
              [-15.650161264693244, -10.661503947367168],
              [-15.65639228822642, -10.662069114005646],
              [-15.658408049073817, -10.663569367360314],
              [-15.66037903800238, -10.663633317216298],
              [-15.661396445035578, -10.66464510710184],
              [-15.663531429113139, -10.665372800274827],
              [-15.664650573949109, -10.668245628358784],
              [-15.667080631820763, -10.67070111856208],
              [-15.66710042920943, -10.672031999895173],
              [-15.666386141202505, -10.673447555820532],
              [-15.66774672505795, -10.676554219912491],
              [-15.670734277081467, -10.676446816347285],
              [-15.671153912834892, -10.677136988580664],
              [-15.674149895825906, -10.677561266851614],
              [-15.675130781909022, -10.679410195252222],
              [-15.676385156183995, -10.68033537129701],
              [-15.679796969728372, -10.682081240344424],
              [-15.683390857459413, -10.683114430215587],
              [-15.685677281420586, -10.684646791875265],
              [-15.689149095571604, -10.688217941157435],
              [-15.693052059584925, -10.69663335061276],
              [-15.694225047456015, -10.700432143682232],
              [-15.6951434061964, -10.704586716333075],
              [-15.696074507557768, -10.711223207364274],
              [-15.69543015668993, -10.713207029686679],
              [-15.69511913874784, -10.718043489920447],
              [-15.69449766098219, -10.720462559991372],
              [-15.694596062785942, -10.722464481971771],
              [-15.696565245763761, -10.725329455643411],
              [-15.699038963220712, -10.726025123264371],
              [-15.701877488567325, -10.725414477142376],
              [-15.701701273971189, -10.723668663616088],
              [-15.704403570376316, -10.722835121751427],
              [-15.706768294961174, -10.723719638603848],
              [-15.709944430106553, -10.723356940632312],
              [-15.711531206866498, -10.725245956510978],
              [-15.712947358637706, -10.7257998777398],
              [-15.715699187056734, -10.724711881891348],
              [-15.716554195314659, -10.72393366140688],
              [-15.72146985732201, -10.72217572744085],
              [-15.722768751798284, -10.7205205717787],
              [-15.725053404897512, -10.719997415305821],
              [-15.72835387409896, -10.71837658725376],
              [-15.730488655448308, -10.715645425073603],
              [-15.731764858319888, -10.715985117023456],
              [-15.735571384181357, -10.715294798593948],
              [-15.734913991202921, -10.714022477351039],
              [-15.735857251718691, -10.712997517397573],
              [-15.738064077579757, -10.713813964160568],
              [-15.739824049442417, -10.713794433851357],
              [-15.740883385590978, -10.712825125492431],
              [-15.744259904708098, -10.711682527267513],
              [-15.74585483878913, -10.709942799375483],
              [-15.748045285675426, -10.708381747642678],
              [-15.75051239597094, -10.707223982699714],
              [-15.751042793687231, -10.706493781816073],
              [-15.75332088643052, -10.705823110373675],
              [-15.754271381211723, -10.704410755850592],
              [-15.755472521281314, -10.703602533912324],
              [-15.757101592955856, -10.703461970071523],
              [-15.75749626382919, -10.70457035093762],
              [-15.75920385429283, -10.703177276180643],
              [-15.761001232412047, -10.702382954871801],
              [-15.762547207298079, -10.70255867437237],
              [-15.766099777392139, -10.700330370223387],
              [-15.76683205591993, -10.699156262472137],
              [-15.766008647788368, -10.697090813678395],
              [-15.766901331744503, -10.69563068145522],
              [-15.76498630014312, -10.69481629001783],
              [-15.765255168157598, -10.692134194923716],
              [-15.766800925256147, -10.691512743383052],
              [-15.771822048217382, -10.690962266391795],
              [-15.774074476933896, -10.690449466393972],
              [-15.773332414051396, -10.688866044734251],
              [-15.777106904595716, -10.688850499542514],
              [-15.777359712199916, -10.687698528552062],
              [-15.779528526500853, -10.6868687081589],
              [-15.781829935767007, -10.686442830814862],
              [-15.78332392286496, -10.68556860008107],
              [-15.783809908238414, -10.684201404541676],
              [-15.785652069440006, -10.683656527283627],
              [-15.790930982972863, -10.683294494783683],
              [-15.793383189329635, -10.682804164048319],
              [-15.796203904720718, -10.682970444157132],
              [-15.798592842113957, -10.68361291951246],
              [-15.800043411453634, -10.684669212216479],
              [-15.801137696293972, -10.682072213195859],
              [-15.802896066152481, -10.682330030440019],
              [-15.805752913185131, -10.683660957678708],
              [-15.807707026311263, -10.683676976982232],
              [-15.810712057425407, -10.681579608699689],
              [-15.812913620061686, -10.682073638241006],
              [-15.813880366441458, -10.68418978329596],
              [-15.815261298253414, -10.68531688974815],
              [-15.821678855842325, -10.686833879154046],
              [-15.825332104315223, -10.688235956923974],
              [-15.827994920338393, -10.689659812000276],
              [-15.831874983118247, -10.690740995096514],
              [-15.83546651064589, -10.690012146082081],
              [-15.836417323756676, -10.690146834291529],
              [-15.839714583467282, -10.688301352501876],
              [-15.840988993418723, -10.687985533769801],
              [-15.84221355390129, -10.689381400408875],
              [-15.844147434868459, -10.688666766096658],
              [-15.845407225298898, -10.687210752840214],
              [-15.846955632384995, -10.686173441972631],
              [-15.847464720859202, -10.685052499729107],
              [-15.842487701000973, -10.67956784271584],
              [-15.840701975763034, -10.67656353772415],
              [-15.840255515037983, -10.674534897518562],
              [-15.83806621663873, -10.67494347377455],
              [-15.837594934441718, -10.676413725209722],
              [-15.836336018089355, -10.675956614477553],
              [-15.833010908337855, -10.672949085705902],
              [-15.83219350381527, -10.670610684928372],
              [-15.82943534231935, -10.667529100259618],
              [-15.821255069269675, -10.66248481440479],
              [-15.821027945358756, -10.659568280908799],
              [-15.819796922039854, -10.65777047111943],
              [-15.817916034775024, -10.657377623505287],
              [-15.816349486180641, -10.656072722343891],
              [-15.818039024177962, -10.65430154050519],
              [-15.815732045048692, -10.649695547507058],
              [-15.814169294861749, -10.64839931164336],
              [-15.814242566918631, -10.645563289255634],
              [-15.811952580747343, -10.642608208966482],
              [-15.809786915594163, -10.640657878563731],
              [-15.8089857220408, -10.63899654952933],
              [-15.808768988079448, -10.637340094953021],
              [-15.80795418313245, -10.636532706885722],
              [-15.807750800079406, -10.631905068265443],
              [-15.806766394047816, -10.63004744850155],
              [-15.805943942169582, -10.629437590593191],
              [-15.805752934921886, -10.624699463097967],
              [-15.804792432455006, -10.622126089655445],
              [-15.800661566033416, -10.618733181619358],
              [-15.799182764320301, -10.616541536170976],
              [-15.797587306643807, -10.614943873109477],
              [-15.797230985566419, -10.61262887188675],
              [-15.79897626048115, -10.609887279100429],
              [-15.800604931346701, -10.61011023706752],
              [-15.802505102878872, -10.609495467195751],
              [-15.804731684077698, -10.611433603810031],
              [-15.804933373714986, -10.613687954459563],
              [-15.807150880555783, -10.615868293212637],
              [-15.8101243246501, -10.617397372229247],
              [-15.813007011937863, -10.619638973945912],
              [-15.813666503380519, -10.620950810371877],
              [-15.814734894102713, -10.620981769269807],
              [-15.818548190091928, -10.623943792637363],
              [-15.820924152974758, -10.625553576360094],
              [-15.82325579290344, -10.626548763595649],
              [-15.825257248624704, -10.627776623443319],
              [-15.826989637957471, -10.628282335501359],
              [-15.831645240125729, -10.631753155578306],
              [-15.834485030248008, -10.633099751979474],
              [-15.836332964623217, -10.63315032476799],
              [-15.838117043129474, -10.633791972034993],
              [-15.84146478174434, -10.634249387723923],
              [-15.842190937978335, -10.632174108226994],
              [-15.841458031588187, -10.63099021874552],
              [-15.839020704625003, -10.62984428670041],
              [-15.837783983151134, -10.62876166589543],
              [-15.836483184712643, -10.628847776367211],
              [-15.832991704326655, -10.625503940014786],
              [-15.831667740365168, -10.623984740917875],
              [-15.830142654197118, -10.62292729480453],
              [-15.831412545934908, -10.622108917015785],
              [-15.833834087413702, -10.621896173207949],
              [-15.834917071781929, -10.621095124722403],
              [-15.837889666587085, -10.623178230862225],
              [-15.838006181395091, -10.623881558116945],
              [-15.839746469860984, -10.625024755390992],
              [-15.841421552145526, -10.628166811923972],
              [-15.84332055248525, -10.628700187438497],
              [-15.84355398485556, -10.627977910665834],
              [-15.842346193238056, -10.626007616740798],
              [-15.840728649186795, -10.624373134013272],
              [-15.842418905787042, -10.623786346445046],
              [-15.840218378794706, -10.621088447772639],
              [-15.840856929430815, -10.619909282061434],
              [-15.842011133042508, -10.620170072160295],
              [-15.843771162693457, -10.619511217811956],
              [-15.83981435256052, -10.61532572559994],
              [-15.839671435446782, -10.61358898812711],
              [-15.837828948171037, -10.610933515505716],
              [-15.838439828284002, -10.609974840708233],
              [-15.837653232449199, -10.60825986711681],
              [-15.836058035853183, -10.607507588517336],
              [-15.83678336289372, -10.606107762792636],
              [-15.840169297902081, -10.607592785476841],
              [-15.841415761437348, -10.608411563594407],
              [-15.842682107778653, -10.610872686742049],
              [-15.845216888566616, -10.61267690629609],
              [-15.845316553952108, -10.615321518733964],
              [-15.843770451852409, -10.613454057226825],
              [-15.84293634011371, -10.614892937837507],
              [-15.844800989596617, -10.61748772607626],
              [-15.846194993886945, -10.618283548525781],
              [-15.848959388959383, -10.621715898495975],
              [-15.848715038657868, -10.622699584307384],
              [-15.84942996950912, -10.624021765283551],
              [-15.848535771857446, -10.625617280114628],
              [-15.850233215130036, -10.627442373139063],
              [-15.849757562910595, -10.630284802018558],
              [-15.851006440570526, -10.631220644644177],
              [-15.854060341737583, -10.631915464774954],
              [-15.856203916026981, -10.63296208361146],
              [-15.85674620392298, -10.632053531598292],
              [-15.858155817394412, -10.632079666087908],
              [-15.86022581964003, -10.634556704815523],
              [-15.861763612798098, -10.634374661026223],
              [-15.862129705454766, -10.632897164018958],
              [-15.86150262062555, -10.629507579582235],
              [-15.860170047001121, -10.628528193746206],
              [-15.860632330353063, -10.626769281356585],
              [-15.861700161884933, -10.625741170823984],
              [-15.86087192157877, -10.624325411003849],
              [-15.85893504015718, -10.622777472353274],
              [-15.85869930943954, -10.62137191138095],
              [-15.859364371413472, -10.620458441773415],
              [-15.858457554975137, -10.619519670217533],
              [-15.856540688209387, -10.61947316000586],
              [-15.855621791498283, -10.618634257821583],
              [-15.857138935590445, -10.61612204258223],
              [-15.856801427932341, -10.614056830480418],
              [-15.855051455209361, -10.61283496551134],
              [-15.854186862431021, -10.611233538186637],
              [-15.853089806807096, -10.611344949672329],
              [-15.852323827029904, -10.609775321624205],
              [-15.853956144217424, -10.609303011611512],
              [-15.852520587093842, -10.607532083036968],
              [-15.850628283204777, -10.606151716802637],
              [-15.84988915357952, -10.605030697320233],
              [-15.851663318745329, -10.60407032354096],
              [-15.855051460405466, -10.605908050550926],
              [-15.857359530347543, -10.60772694481306],
              [-15.858622323456004, -10.609577786473169],
              [-15.860994678118928, -10.611980526501712],
              [-15.865206505246434, -10.614693371529176],
              [-15.866001561078809, -10.616043050912504],
              [-15.865259230073745, -10.616926780458689],
              [-15.866610225451664, -10.618079055777121],
              [-15.869644217063742, -10.619349658630698],
              [-15.873833181112413, -10.622052185867199],
              [-15.8780388041405, -10.625318624257606],
              [-15.881900430745143, -10.627699629842201],
              [-15.883642558714559, -10.62936233828995],
              [-15.885902906399316, -10.632159364086148],
              [-15.887794001776712, -10.632258611131201],
              [-15.89275819404587, -10.635389719816022],
              [-15.894090810346603, -10.634348639431554],
              [-15.902795355287825, -10.636509947060715],
              [-15.904304635980234, -10.636306534795269],
              [-15.907082636497902, -10.630145692385687],
              [-15.907336143939931, -10.628442797285542],
              [-15.906387203446535, -10.627139149621788],
              [-15.904878286380551, -10.626165181258312],
              [-15.903366671301976, -10.626406493358699],
              [-15.902201167733715, -10.625381322495299],
              [-15.902227016098704, -10.623966808189461],
              [-15.901246775715611, -10.6227605160796],
              [-15.899415837299221, -10.622346534503146],
              [-15.89853113420686, -10.621029657633583],
              [-15.898696973852285, -10.618964038630509],
              [-15.897817653844237, -10.618457480580126],
              [-15.896290553607615, -10.61654016223275],
              [-15.895705196106219, -10.614610909103197],
              [-15.894333393036629, -10.613278022472334],
              [-15.89208029766311, -10.61044723875363],
              [-15.890149259120102, -10.610202064583541],
              [-15.889257094144334, -10.608965026460618],
              [-15.889840728982545, -10.608022211140275],
              [-15.887815624198556, -10.60602647152199],
              [-15.88592632878527, -10.604936117013576],
              [-15.88528559363779, -10.603486018163913],
              [-15.88348539291193, -10.603012488547273],
              [-15.881370243984948, -10.601773399716633],
              [-15.88179560357696, -10.601008137764117],
              [-15.880295694120724, -10.59986849682791],
              [-15.87931225366349, -10.599732648262219],
              [-15.879722240174997, -10.598042573946557],
              [-15.877385959087185, -10.597120885179041],
              [-15.876454096774436, -10.595394359703288],
              [-15.874801785670623, -10.59439097726902],
              [-15.876046912743856, -10.59288130779479],
              [-15.877692106951349, -10.592772419504396],
              [-15.878859713584063, -10.592061338750966],
              [-15.877984883857419, -10.590706110397786],
              [-15.876423438008057, -10.5896332378845],
              [-15.873906459273913, -10.5902044183382],
              [-15.872623416800456, -10.591022058964912],
              [-15.871611121020342, -10.590584280845329],
              [-15.870298507091603, -10.591352617730974],
              [-15.869341593291677, -10.590673530550774],
              [-15.871082178937106, -10.588456106149389],
              [-15.872332169749225, -10.587574210105066],
              [-15.875118410565655, -10.587297864494484],
              [-15.87572628530721, -10.585295199388272],
              [-15.87484965351458, -10.583995377672675],
              [-15.874084613507554, -10.581421977924586],
              [-15.874693829250475, -10.579940219998873],
              [-15.874285672680072, -10.57878194316132],
              [-15.874662529143972, -10.576869179541564],
              [-15.875774164912542, -10.576274355219528],
              [-15.877682728632704, -10.576822652613366],
              [-15.87843583138677, -10.578828468345112],
              [-15.878249920929791, -10.580016999433424],
              [-15.878803318587426, -10.58216090931507],
              [-15.880804966142195, -10.584798779315074],
              [-15.880636239236328, -10.585848805278989],
              [-15.882155514362136, -10.587602411934578],
              [-15.883375089455239, -10.58964366893046],
              [-15.88341798570664, -10.591289973127584],
              [-15.88512089447484, -10.59340331314927],
              [-15.884724404101227, -10.59408683755483],
              [-15.886410499898698, -10.597156742090698],
              [-15.888043632311946, -10.598216906265161],
              [-15.888014372794537, -10.595887229034794],
              [-15.886354875790364, -10.593122215907444],
              [-15.888937440972649, -10.593403187672177],
              [-15.890906882278593, -10.596827113230699],
              [-15.89100629862504, -10.598030841186969],
              [-15.891892445311447, -10.599387850993201],
              [-15.891638831221378, -10.600493707201517],
              [-15.893346110029059, -10.60106401093168],
              [-15.893652286957945, -10.598640026822158],
              [-15.89625876781955, -10.598908066012232],
              [-15.89937054959033, -10.597416851534181],
              [-15.899394507457725, -10.595076602354638],
              [-15.896609317511384, -10.59277772940185],
              [-15.895591689958996, -10.591065649230142],
              [-15.895959143908435, -10.589267380045298],
              [-15.89743545685869, -10.589979421051112],
              [-15.898583500122776, -10.591861904895714],
              [-15.901924582642541, -10.594411379729568],
              [-15.903651446058294, -10.594974497098535],
              [-15.903745726516751, -10.596742414505643],
              [-15.903444376274395, -10.600626682662448],
              [-15.903797052484302, -10.603819755155358],
              [-15.907393426712957, -10.60633803467746],
              [-15.909966586589784, -10.60632910334724],
              [-15.912090619491925, -10.607002366029407],
              [-15.914548670823487, -10.607097401009103],
              [-15.917207980826538, -10.606007159773894],
              [-15.918082168967576, -10.604308624398838],
              [-15.917689401053206, -10.600385269655286],
              [-15.917927247190885, -10.59768608305679],
              [-15.918781392386396, -10.596205302876179],
              [-15.91795526512873, -10.594176109327968],
              [-15.917160946781742, -10.590914456412806],
              [-15.915503428902223, -10.589757716151855],
              [-15.91338573968262, -10.587174127852776],
              [-15.914370649189808, -10.586258004588016],
              [-15.915940739571147, -10.588475850477476],
              [-15.917745953991382, -10.588198590532203],
              [-15.919238218892259, -10.588671729683494],
              [-15.920813797894704, -10.589820300534152],
              [-15.920637127541893, -10.590970375316225],
              [-15.921521128719668, -10.59193900981678],
              [-15.92197685149775, -10.593948985676978],
              [-15.921237429741764, -10.596933081450825],
              [-15.922052387468135, -10.599529753251895],
              [-15.92332993287104, -10.600281176598587],
              [-15.925444934447397, -10.605033593562665],
              [-15.925290013636078, -10.606639066528597],
              [-15.926182100129857, -10.607294459256169],
              [-15.927483986013932, -10.606840409778085],
              [-15.930086676609417, -10.608177679695954],
              [-15.931207766700517, -10.61223998560578],
              [-15.931292600606112, -10.616023743299968],
              [-15.933741404447874, -10.61736818996957],
              [-15.936374434682634, -10.619194688289152],
              [-15.939702260674336, -10.619420433826537],
              [-15.942220332193736, -10.620861354368964],
              [-15.94347977554072, -10.622594007689568],
              [-15.943322454139542, -10.623580454384852],
              [-15.945834548226498, -10.62582113725722],
              [-15.947890856005788, -10.625744923064095],
              [-15.947126622372595, -10.623914847932665],
              [-15.946961795522615, -10.622281864794344],
              [-15.949591345908503, -10.620490381465187],
              [-15.952611134136207, -10.619583057257332],
              [-15.954132979187815, -10.61958342023606],
              [-15.955084379954712, -10.620308159347225],
              [-15.957141595226831, -10.620613464583249],
              [-15.958003164221504, -10.620214628823351],
              [-15.960220789820587, -10.620277546403024],
              [-15.962265207043046, -10.620786222323435],
              [-15.962998774699802, -10.619007348655476],
              [-15.96519961497207, -10.619573056488997],
              [-15.965550173347454, -10.62220820412448],
              [-15.968371908947203, -10.624348330210053],
              [-15.971794456229217, -10.623510112884755],
              [-15.973916223479296, -10.62351954930408],
              [-15.974394592889464, -10.622176814502108],
              [-15.976019449584754, -10.620979932267742],
              [-15.976202594270386, -10.618271866553862],
              [-15.974880585760477, -10.616248731068367],
              [-15.97615569106268, -10.614529389775674],
              [-15.978525065567519, -10.612868660746551],
              [-15.979479202914328, -10.611458040237595],
              [-15.98122955121218, -10.610578256402041],
              [-15.983266139501268, -10.607872318080668],
              [-15.98412990117328, -10.604898259512632],
              [-15.983414421770028, -10.604194924374754],
              [-15.981522097808611, -10.604715892835586],
              [-15.979194961245806, -10.604855692539028],
              [-15.976863471699136, -10.607175832762547],
              [-15.975788262343867, -10.608935780324005],
              [-15.973445050458604, -10.609308694100909],
              [-15.971901441899426, -10.611034850747291],
              [-15.970907051456923, -10.611531934868731],
              [-15.969867158086135, -10.609196630582385],
              [-15.970345815821432, -10.607492663318986],
              [-15.971376268464063, -10.60649508653565],
              [-15.9724656162577, -10.606594219341249],
              [-15.971944283417935, -10.604720598031594],
              [-15.971682220665503, -10.601281131757586],
              [-15.96957270327357, -10.600303393134832],
              [-15.968589779278327, -10.59676576070672],
              [-15.966398322064178, -10.59696777887079],
              [-15.963466887704353, -10.598642852451848],
              [-15.96320978748188, -10.600894454653652],
              [-15.963914029232042, -10.602223466834795],
              [-15.96415824844489, -10.604369760371378],
              [-15.963363634786626, -10.605796200849923],
              [-15.961824559131493, -10.605707021638432],
              [-15.962293157414141, -10.604103603503233],
              [-15.96025025386139, -10.601294214127897],
              [-15.956280322596376, -10.599663911740953],
              [-15.952992085796419, -10.600792007577548],
              [-15.954294997573731, -10.60434853790311],
              [-15.953290377885573, -10.604398517386887],
              [-15.952202629528339, -10.603045893019447],
              [-15.950558499324583, -10.602277235658974],
              [-15.949985251702547, -10.601062975707478],
              [-15.951029747653251, -10.598898425677763],
              [-15.95226197418967, -10.598107350252437],
              [-15.953285768134625, -10.596647247308955],
              [-15.95534094588602, -10.595604727141463],
              [-15.958866439800813, -10.59452327127559],
              [-15.959825432110923, -10.592551959170002],
              [-15.958773706167216, -10.591688639388076],
              [-15.957208533746424, -10.591757681973114],
              [-15.956091571264245, -10.589959954823513],
              [-15.955136355224823, -10.589591781381005],
              [-15.954148875594562, -10.5910953023645],
              [-15.95116327871075, -10.591206345525283],
              [-15.949811107185583, -10.590571723646043],
              [-15.947597246580766, -10.591050512322598],
              [-15.944042624459719, -10.590269199699737],
              [-15.941555561194015, -10.591341539588875],
              [-15.941050613773381, -10.590780458435681],
              [-15.941628171347922, -10.587739597393313],
              [-15.93739999616949, -10.586981176599993],
              [-15.93289224655184, -10.584959956319544],
              [-15.930370405105013, -10.58493647166451],
              [-15.928126257024447, -10.583068412607352],
              [-15.926096635850852, -10.583361975921868],
              [-15.925179639424716, -10.581987276507512],
              [-15.923747822918827, -10.582388787081898],
              [-15.921137488332041, -10.57967150181671],
              [-15.91910616447712, -10.578292267131701],
              [-15.916940795822535, -10.57626825995721],
              [-15.916452819370372, -10.574721019227173],
              [-15.91528498901468, -10.57376051879035],
              [-15.912137148864748, -10.573197368483875],
              [-15.911432213279998, -10.572483709931255],
              [-15.908495416679507, -10.571830442393212],
              [-15.90677644034673, -10.571913928244335],
              [-15.906204477898912, -10.571082079826892],
              [-15.901211913525568, -10.569112983074495],
              [-15.901855317560052, -10.568160012058087],
              [-15.905873458044002, -10.569089110640991],
              [-15.909007632886382, -10.570438452839506],
              [-15.910974234327492, -10.57032269160956],
              [-15.911086660621207, -10.566991517333111],
              [-15.91015884805384, -10.565394150561808],
              [-15.910123257190051, -10.563818955825955],
              [-15.91095719129432, -10.562108971731787],
              [-15.90958999621336, -10.561985666937957],
              [-15.906095309234388, -10.560450124457232],
              [-15.901499758932387, -10.558934415576262],
              [-15.898795870155196, -10.558600149094381],
              [-15.896956718491593, -10.560197910719907],
              [-15.894399459139215, -10.560161448921672],
              [-15.891446905525834, -10.5607024863065],
              [-15.88703412408109, -10.561877010538268],
              [-15.885175906020315, -10.561437113743034],
              [-15.885251743031406, -10.560479046550105],
              [-15.888491074263525, -10.559590597894243],
              [-15.889492315511479, -10.557372021310272],
              [-15.893447953514382, -10.557774925315243],
              [-15.89372996703072, -10.556619767463044],
              [-15.89508583149018, -10.554986604392486],
              [-15.899232593230897, -10.553457407903922],
              [-15.900392538960414, -10.551922304134509],
              [-15.902562383730757, -10.551108236370247],
              [-15.904048327181927, -10.549389859931638],
              [-15.905889899465585, -10.549442407939445],
              [-15.907794436071592, -10.551513439175388],
              [-15.90616252899077, -10.552250278246625],
              [-15.906447311944651, -10.553772064980077],
              [-15.907880547526398, -10.554018267416701],
              [-15.910514810742114, -10.556113575122481],
              [-15.911881018701493, -10.556412353212483],
              [-15.912191696285154, -10.5553412944668],
              [-15.910986274302532, -10.554377064474128],
              [-15.908374659003266, -10.551077687968673],
              [-15.909803692524173, -10.548467382237904],
              [-15.911838316736434, -10.548601464278857],
              [-15.913779569505325, -10.551902833295092],
              [-15.915910951926483, -10.554984576779487],
              [-15.915272592038521, -10.557788670874704],
              [-15.917491550046028, -10.559291552789857],
              [-15.91858633626997, -10.56239636341262],
              [-15.91821031473547, -10.564366508352409],
              [-15.920162715094255, -10.56418753470289],
              [-15.922114789248718, -10.566243192474035],
              [-15.921566669937638, -10.567721176826486],
              [-15.92331373053506, -10.568313299069363],
              [-15.92471658446576, -10.569520921968786],
              [-15.92514339690676, -10.57055629110621],
              [-15.927088049095905, -10.571140380727911],
              [-15.928247365258889, -10.572521406468423],
              [-15.929667919300629, -10.57185676666949],
              [-15.934056655107158, -10.57414709765284],
              [-15.934735707661789, -10.57494908720747],
              [-15.93665135498811, -10.575266368635868],
              [-15.938512190549233, -10.574831834679044],
              [-15.93945436880046, -10.573205482499132],
              [-15.937465321826862, -10.571953909684519],
              [-15.935713350493238, -10.56972197279043],
              [-15.935200856794518, -10.568194180685976],
              [-15.934024363945758, -10.566611334924405],
              [-15.935067929245966, -10.564817037431203],
              [-15.93609915582759, -10.565034157688478],
              [-15.937650591046392, -10.567061697178996],
              [-15.939566287007386, -10.568062792287671],
              [-15.940423508627067, -10.569951409247825],
              [-15.94204049599858, -10.572127014627833],
              [-15.943485680937524, -10.573336817210832],
              [-15.944906902138314, -10.573355601716278],
              [-15.944755588256733, -10.57553408209685],
              [-15.945916593428716, -10.576570820220681],
              [-15.947254630636811, -10.576257380093981],
              [-15.948236079789291, -10.577234465487328],
              [-15.95079752859385, -10.576572899178505],
              [-15.952973977976454, -10.576392719005032],
              [-15.955159586610394, -10.57683738058103],
              [-15.957002553675393, -10.577787815575878],
              [-15.958359781210811, -10.577656316751998],
              [-15.960522058009058, -10.578661730552076],
              [-15.961747325218743, -10.579683627453539],
              [-15.96275947636445, -10.579191235681657],
              [-15.96068813953486, -10.577390746563255],
              [-15.961179042809718, -10.576478606038405],
              [-15.96333134459152, -10.575971656471868],
              [-15.96431904673794, -10.574268433320306],
              [-15.96565580390155, -10.572886232826809],
              [-15.965904235158911, -10.571424131666832],
              [-15.96332141149026, -10.571440382645585],
              [-15.96288353852036, -10.568876053711795],
              [-15.964423555502568, -10.568201177038214],
              [-15.964610742373539, -10.567276204837642],
              [-15.966526353855025, -10.567045045014098],
              [-15.967176528763984, -10.56401884620272],
              [-15.96888249862735, -10.564730018017581],
              [-15.970534011382549, -10.567527016213573],
              [-15.9717068252219, -10.568822959712747],
              [-15.973366150773089, -10.576754593955553],
              [-15.973987989389643, -10.577366267959412],
              [-15.976614040018578, -10.577513099558795],
              [-15.97616686349874, -10.574102186267266],
              [-15.976634724991337, -10.568538536822428],
              [-15.97611881663488, -10.567355437719199],
              [-15.974827029554676, -10.566389225251806],
              [-15.974884223473024, -10.565168437571764],
              [-15.973973125808033, -10.563177996011408],
              [-15.974072271265399, -10.560876491240457],
              [-15.975889785305416, -10.559686167601019],
              [-15.977399155094787, -10.55641673672901],
              [-15.977627918384128, -10.555115328907712],
              [-15.978564239504893, -10.554012323198583],
              [-15.979546190447735, -10.554119764829174],
              [-15.979046460090657, -10.557280259313805],
              [-15.980490752607455, -10.558503590256906],
              [-15.980999982040341, -10.559564175658828],
              [-15.982781472191082, -10.560502185301576],
              [-15.982722516439509, -10.562104287709722],
              [-15.984504299318727, -10.563946833331633],
              [-15.985360399913283, -10.562652844010369],
              [-15.988653909473886, -10.559713823431043],
              [-15.98919525341315, -10.557782935174078],
              [-15.990885479867554, -10.55447029375034],
              [-15.989271247178845, -10.554757033971605],
              [-15.989175667725435, -10.553260152517872],
              [-15.992232013754302, -10.55150282375383],
              [-15.993059747630655, -10.55044751636971],
              [-15.996541536461244, -10.54831409598131],
              [-15.99515942013744, -10.546900049364892],
              [-15.995922013502204, -10.545697862768371],
              [-15.997454819963997, -10.541769521026678],
              [-15.997447412073054, -10.540384413239876],
              [-15.998663754902704, -10.540374917495546],
              [-16.00090443551675, -10.536986071350702],
              [-16.002432022202466, -10.53526549289809],
              [-16.001853145136735, -10.53392004493705],
              [-16.002053882142132, -10.532117123126389],
              [-16.001272866767874, -10.530409329861657],
              [-16.000260474488748, -10.531322503675062],
              [-15.999204943907563, -10.530808045343447],
              [-15.996970961442202, -10.533052691349946],
              [-15.995909591993113, -10.53566498480751],
              [-15.996047673451516, -10.536963497667658],
              [-15.992675781190377, -10.5390455016153],
              [-15.991475204394396, -10.540179492316037],
              [-15.987780121646097, -10.538814810994102],
              [-15.986757201245373, -10.539265381305455],
              [-15.984602184255285, -10.536643082305048],
              [-15.983137654188345, -10.536162083927913],
              [-15.983344842815224, -10.538451936476415],
              [-15.982756710889154, -10.539712094600407],
              [-15.98130512152137, -10.539292439864306],
              [-15.97897268915453, -10.541104213748829],
              [-15.977052172364841, -10.54035183228014],
              [-15.97450841779333, -10.541517503253212],
              [-15.972606059923521, -10.539361194789915],
              [-15.973307231617428, -10.537652321889013],
              [-15.975487919981298, -10.535042984336034],
              [-15.97535112830973, -10.534285924836567],
              [-15.976678101907977, -10.532766639955835],
              [-15.978713015772389, -10.53160641377815],
              [-15.979888388300887, -10.531775232102417],
              [-15.981360120911923, -10.531114131073391],
              [-15.983623412537026, -10.532043468356683],
              [-15.985410846608417, -10.533963323274316],
              [-15.987293492871574, -10.533606917857972],
              [-15.988568755152377, -10.534327451043255],
              [-15.99122022814557, -10.532890941927016],
              [-15.992722320608586, -10.531590268259441],
              [-15.99194493133525, -10.53022296949381],
              [-15.99412644551777, -10.529897965243418],
              [-15.994452823339278, -10.528971460751533],
              [-15.995852102797956, -10.528220863001813],
              [-15.995731753014615, -10.526584709807072],
              [-15.996568766260383, -10.525793341725576],
              [-15.99649293995364, -10.52423532757007],
              [-15.994678875964382, -10.52424637561832],
              [-15.993830857456622, -10.524956146974029],
              [-15.992805112563664, -10.523822880699859],
              [-15.993775424312535, -10.52094342201753],
              [-15.992514674800539, -10.519925319272351],
              [-15.992623760302065, -10.518415059458345],
              [-15.99347386103568, -10.515884318084822],
              [-15.993269979908698, -10.514821031340116],
              [-15.99210331786822, -10.513873463300667],
              [-15.991429908417809, -10.511058280929113],
              [-15.991280291253199, -10.507900337530462],
              [-15.990204318601245, -10.504722439410706],
              [-15.98958432128233, -10.50377455279536],
              [-15.988429557942062, -10.503808834229229],
              [-15.987202301585802, -10.505915168104337],
              [-15.98587760406098, -10.50727116843974],
              [-15.98396468435782, -10.504901148494016],
              [-15.98217679614181, -10.50588558242196],
              [-15.980918107065436, -10.507188184677402],
              [-15.977842508592145, -10.50598964755624],
              [-15.972145751990224, -10.507582947825881],
              [-15.971215595157734, -10.507059870216523],
              [-15.971252288501661, -10.505502842553803],
              [-15.973212018516326, -10.504438879856153],
              [-15.976518470040327, -10.503783056018072],
              [-15.975899105554308, -10.503014761653274],
              [-15.974494157390266, -10.502939763152469],
              [-15.974034183362226, -10.501308464224426],
              [-15.976640888552572, -10.500935879119197],
              [-15.97871030446442, -10.499783782311026],
              [-15.98424525264189, -10.499571395380952],
              [-15.987978795784459, -10.498700678703125],
              [-15.988590057735584, -10.496487803620152],
              [-15.989885002529732, -10.49395085544451],
              [-15.988270825210432, -10.491277079171342],
              [-15.987261465698666, -10.491106629273474],
              [-15.983915509115166, -10.486465355855344],
              [-15.982131065537132, -10.485490181608744],
              [-15.979261214146725, -10.485374417053515],
              [-15.976434919766623, -10.48558218988771],
              [-15.975509265371114, -10.486978217420727],
              [-15.971953086557226, -10.486685078269982],
              [-15.969778900830823, -10.486124269577735],
              [-15.96968441736575, -10.485014910509655],
              [-15.966375219601824, -10.484507477427663],
              [-15.964024079980437, -10.484785211446212],
              [-15.962633121150219, -10.485828820239405],
              [-15.961610864248527, -10.485075360977397],
              [-15.958633345223367, -10.484662491103961],
              [-15.95786264316881, -10.48539532175418],
              [-15.956227901110378, -10.484013294215965],
              [-15.95261130005244, -10.483547267658029],
              [-15.951973416220003, -10.48261632692644],
              [-15.949155214988489, -10.481359607750479],
              [-15.945566391205766, -10.481339098355319],
              [-15.943495786193116, -10.479596877014878],
              [-15.941675842826367, -10.479591118081816],
              [-15.939701441985415, -10.480628845120743],
              [-15.937140597712942, -10.479937919867025],
              [-15.935636165582872, -10.481065374798673],
              [-15.930732835186527, -10.480225298287401],
              [-15.929585332865303, -10.479354509513994],
              [-15.926666859590235, -10.478959952278977],
              [-15.923026389094739, -10.479365993666176],
              [-15.920754192050444, -10.478964307723777],
              [-15.9190416280413, -10.477807674463072],
              [-15.919475036265222, -10.475699812188429],
              [-15.921734188471918, -10.473763325216924],
              [-15.92181353027725, -10.473098046051438],
              [-15.920409261743904, -10.470772861596803],
              [-15.920914481834531, -10.470070483360098],
              [-15.922614286913513, -10.469986220608316],
              [-15.923934034237018, -10.47052471454252],
              [-15.925806901072399, -10.469254381070487],
              [-15.926198518714138, -10.468262930689225],
              [-15.927686002857277, -10.467646430872328],
              [-15.928064381961507, -10.466681936332236],
              [-15.930129482843341, -10.464829992327001],
              [-15.931406956448521, -10.46503275591982],
              [-15.93332325313328, -10.466247846330237],
              [-15.937100348760277, -10.465914802228838],
              [-15.937614441150208, -10.46673017843911],
              [-15.940547774532519, -10.467944006068407],
              [-15.941638072328105, -10.467409284759494],
              [-15.948059218400987, -10.468137054034695],
              [-15.950205156060658, -10.466964195775343],
              [-15.951284406709672, -10.46500968945854],
              [-15.952655752315605, -10.464645489505209],
              [-15.954517038347303, -10.465433666390547],
              [-15.959811282966902, -10.466486667576046],
              [-15.960333960102483, -10.467363331500032],
              [-15.961971526049798, -10.467307018664549],
              [-15.964134915086042, -10.468626191919208],
              [-15.96449275861471, -10.470062740520303],
              [-15.967912322971769, -10.470623152508123],
              [-15.968942812489177, -10.47041861551048],
              [-15.973083060171172, -10.47101790772748],
              [-15.97625247247024, -10.472006898172527],
              [-15.977336980207252, -10.473443853419],
              [-15.978311732806397, -10.472314241437509],
              [-15.977051583518694, -10.468185390036314],
              [-15.978355667424227, -10.466813734271305],
              [-15.97968519365294, -10.466980575219653],
              [-15.97975875922369, -10.465453224936061],
              [-15.981243859946934, -10.464958846092756],
              [-15.982866617167325, -10.465376977739794],
              [-15.983840895736375, -10.466720211246786],
              [-15.98151175135943, -10.467201643831476],
              [-15.981708326063748, -10.469895754372981],
              [-15.983486490489776, -10.473382783870932],
              [-15.984874358786124, -10.473575144070194],
              [-15.98638545372774, -10.476055126730037],
              [-15.989056198264977, -10.478443012127466],
              [-15.98989629532765, -10.481528806858043],
              [-15.99159803342665, -10.483591018208305],
              [-15.992841810393731, -10.487220890519087],
              [-15.992214575456014, -10.489030060913809],
              [-15.994517631979452, -10.492936836300762],
              [-15.994335768856107, -10.493656287366473],
              [-15.995384987916195, -10.495448874236901],
              [-15.995258581836866, -10.497114081214367],
              [-15.998228730039198, -10.497615841006168],
              [-15.999923387219118, -10.498878638382882],
              [-16.001643249023772, -10.500823580743948],
              [-16.003830302240043, -10.501479289213083],
              [-16.005889489546377, -10.502560716411855],
              [-16.00791871494223, -10.502279161046253],
              [-16.008882020639852, -10.499675014528757],
              [-16.00883074377404, -10.496243657234642],
              [-16.01010363905501, -10.494847179225415],
              [-16.012380677008434, -10.494662113004836],
              [-16.012479737279513, -10.496444498595679],
              [-16.011966217653573, -10.497490658127939],
              [-16.01293714131657, -10.49861546799711],
              [-16.012451000367438, -10.499389727052025],
              [-16.013178424167982, -10.501195516876573],
              [-16.011509627656764, -10.504000981968993],
              [-16.01082053286761, -10.50295217475185],
              [-16.009782967546073, -10.503717637816399],
              [-16.01066823498022, -10.504640549258763],
              [-16.011007696684434, -10.50766478134011],
              [-16.013923277960885, -10.511031750139763],
              [-16.015295518391813, -10.5147033677931],
              [-16.01753635990637, -10.517284470708931],
              [-16.019337028571563, -10.520840363753978],
              [-16.020083549010014, -10.523274064864742],
              [-16.020041471105873, -10.527507326283228],
              [-16.020719385352614, -10.529621963459268],
              [-16.02153054714512, -10.530268971252061],
              [-16.023085107529276, -10.533138332566441],
              [-16.024284943495335, -10.534006832701587],
              [-16.025054295588628, -10.535334493834704],
              [-16.026495290179152, -10.536184050642325],
              [-16.028334192476866, -10.53862281450787],
              [-16.03038978988744, -10.540732067295105],
              [-16.032857935814576, -10.542234559319366],
              [-16.03681655246836, -10.545146427292481],
              [-16.037938479001166, -10.54544414713777],
              [-16.039226219945927, -10.543452807031253],
              [-16.041267069271573, -10.542923483976303],
              [-16.045140984326125, -10.54322557932522],
              [-16.046145506664544, -10.542728195661953],
              [-16.049553142655448, -10.542511624722781],
              [-16.050852788687184, -10.541280662469813],
              [-16.049118110491204, -10.539407332957818],
              [-16.045632311464377, -10.539659334049263],
              [-16.045434788110494, -10.538668115486862],
              [-16.046649311017514, -10.537445448836689],
              [-16.04538811847059, -10.536441865244283],
              [-16.04466445307021, -10.53497887232639],
              [-16.04341730187397, -10.533809411089827],
              [-16.041095705855874, -10.53244210576112],
              [-16.038734180326596, -10.532359775052853],
              [-16.03803260149011, -10.531458795425895],
              [-16.03950811480404, -10.530532604908421],
              [-16.041266255248846, -10.527597871819308],
              [-16.03950865307136, -10.526172807746857],
              [-16.03962706830333, -10.524088928027883],
              [-16.040607456120327, -10.522402050379236],
              [-16.042359258505172, -10.52264475742213],
              [-16.042810942762145, -10.520443806383385],
              [-16.042254821006757, -10.5165261532056],
              [-16.044820263558414, -10.514352844223652],
              [-16.044941806945022, -10.512794101617692],
              [-16.04434505402068, -10.511709409151207],
              [-16.044684255624713, -10.510245210796056],
              [-16.043763905521544, -10.509609593092906],
              [-16.045585816760994, -10.507483462176278],
              [-16.046136310605892, -10.505939089993571],
              [-16.04740145685168, -10.504491899394333],
              [-16.047788073547718, -10.50065773124233],
              [-16.04919131416108, -10.49944879027629],
              [-16.0490763660151, -10.497228753890479],
              [-16.0500525408189, -10.4970775394292],
              [-16.051557355440515, -10.495636109710974],
              [-16.051603435955965, -10.4946429597249],
              [-16.052606515995375, -10.492990340543109],
              [-16.05374291778142, -10.49234971427477],
              [-16.05435833075956, -10.49111604881067],
              [-16.05558006324417, -10.490803295399566],
              [-16.054950968312397, -10.487645895039966],
              [-16.057687857172137, -10.483321810120456],
              [-16.058945732106224, -10.482095546722018],
              [-16.05732923920319, -10.479895412120655],
              [-16.055267010902025, -10.479423140994871],
              [-16.05285157017098, -10.478116669890504],
              [-16.05131672631102, -10.476482505582466],
              [-16.05015031478976, -10.474607439477515],
              [-16.04907549128987, -10.471885433899661],
              [-16.049657548542953, -10.470770802710327],
              [-16.053280041954263, -10.470370005605751],
              [-16.05535500464726, -10.469768366212396],
              [-16.05870399161934, -10.469656800934695],
              [-16.061032240052096, -10.471012261008102],
              [-16.063471956636185, -10.469809388903768],
              [-16.064708057119326, -10.470852335110374],
              [-16.067164500735345, -10.471761827699169],
              [-16.06923487900824, -10.474045187547615],
              [-16.070070027960806, -10.475464934605409],
              [-16.070492642158555, -10.478317476034709],
              [-16.06771176612076, -10.479886422672948],
              [-16.067602540700054, -10.481868463928292],
              [-16.06686888726296, -10.48366745308161],
              [-16.06430392683597, -10.484700390797089],
              [-16.064268708123436, -10.486930367871778],
              [-16.065686295865124, -10.488750769766511],
              [-16.065971809074444, -10.489857358453108],
              [-16.068451536838744, -10.490589593316749],
              [-16.069368413204923, -10.491441381428867],
              [-16.069682275939705, -10.493428664426576],
              [-16.0677999713368, -10.495611229803238],
              [-16.064783752990973, -10.49707870651364],
              [-16.064377453992456, -10.499772067789271],
              [-16.062455337930697, -10.502310692686867],
              [-16.06246100130049, -10.50548732848345],
              [-16.061482732690024, -10.507105044338623],
              [-16.063788446845184, -10.509898888820738],
              [-16.06396223176103, -10.511115863578382],
              [-16.062954939938926, -10.51167219734729],
              [-16.060448897435393, -10.50955502349317],
              [-16.06013225308759, -10.511082914299346],
              [-16.06049581483275, -10.512599384578772],
              [-16.05938626889856, -10.51430456098676],
              [-16.059279127178065, -10.517212913356213],
              [-16.06061092117853, -10.519309738690922],
              [-16.060883609543044, -10.521117889263683],
              [-16.062114767443596, -10.521123918715046],
              [-16.06286498671979, -10.523001369985101],
              [-16.064339243304588, -10.524912823848128],
              [-16.065262559562903, -10.528351635725034],
              [-16.06601959307642, -10.529086950924661],
              [-16.06615981913562, -10.530822945050566],
              [-16.06830268576271, -10.532542785953108],
              [-16.067542070325977, -10.534007112217589],
              [-16.06815341123064, -10.53607189810996],
              [-16.06716849750147, -10.536814730621389],
              [-16.066557231348668, -10.539514777286502],
              [-16.065016939778708, -10.542583309064527],
              [-16.06571182575515, -10.545039679465924],
              [-16.06812431044796, -10.544804328583085],
              [-16.06943373609184, -10.545438446971232],
              [-16.07033874632423, -10.547995935255821],
              [-16.071999465242833, -10.548565339977255],
              [-16.07359020552182, -10.546902152019834],
              [-16.073096496185137, -10.545048071109523],
              [-16.073508369906726, -10.54362695639963],
              [-16.07473703897827, -10.543290511614382],
              [-16.0752255799593, -10.545003026125526],
              [-16.076417138033747, -10.545604256326273],
              [-16.079522269055158, -10.542210642910394],
              [-16.079368618768715, -10.539610968261075],
              [-16.080580729185133, -10.5394184586987],
              [-16.081062786932122, -10.538099011163602],
              [-16.079999258719663, -10.536026448916648],
              [-16.080380943632733, -10.53474655986974],
              [-16.08070414313402, -10.531256018745347],
              [-16.08013985646167, -10.530078384701596],
              [-16.080323580460096, -10.528316054207265],
              [-16.07970715925398, -10.526092854375355],
              [-16.080550462244354, -10.524977545604276],
              [-16.081063401869837, -10.522769207185048],
              [-16.082649698874256, -10.523628902722919],
              [-16.08268434557647, -10.526012850311869],
              [-16.082156361978992, -10.527980131914086],
              [-16.083611402275338, -10.53088805816108],
              [-16.08564198883737, -10.532152526700864],
              [-16.085836550152628, -10.534173571933774],
              [-16.0875632049301, -10.534086461709972],
              [-16.08800637543728, -10.534823775059632],
              [-16.09065400810837, -10.535856599036503],
              [-16.089911944941658, -10.538345335666582],
              [-16.088757349403576, -10.539151058542302],
              [-16.08981545188715, -10.540257970261198],
              [-16.08762781767105, -10.543424653815858],
              [-16.08568418319634, -10.543249941957175],
              [-16.085295457807064, -10.544072693743313],
              [-16.08550004922453, -10.546978546754668],
              [-16.084185864307404, -10.5485303210017],
              [-16.083961416429876, -10.550878317235615],
              [-16.084872638979686, -10.551666384057617],
              [-16.08528565897605, -10.553151253114569],
              [-16.087001129906014, -10.550656299272426],
              [-16.087664535269234, -10.554812809362886],
              [-16.08987033817963, -10.555213412615007],
              [-16.090121571787446, -10.55395504826439],
              [-16.091215063032998, -10.55336205225218],
              [-16.09346755158753, -10.553305632999203],
              [-16.095005555575153, -10.551533857707252],
              [-16.096819583441363, -10.551012221574524],
              [-16.097558135703984, -10.551506458844559],
              [-16.09625590375823, -10.553943058133896],
              [-16.0945391080641, -10.555878108143482],
              [-16.092461931705653, -10.556193136794437],
              [-16.09184292545112, -10.55709418330056],
              [-16.091828714306555, -10.55919885234096],
              [-16.09360097034604, -10.55929480767377],
              [-16.094408575588634, -10.558331861714672],
              [-16.096471430073773, -10.55973988047606],
              [-16.095846955806845, -10.562859022010418],
              [-16.096652619242754, -10.56330884461952],
              [-16.101417250904607, -10.56783297325741],
              [-16.101500599523746, -10.570792171786625],
              [-16.103189954541588, -10.571319781874157],
              [-16.10237969917249, -10.568529981783442],
              [-16.10240479347547, -10.567488746931367],
              [-16.10489100284732, -10.566950594633138],
              [-16.105766853613424, -10.564909680562293],
              [-16.105009138794887, -10.56439375764181],
              [-16.106016804066453, -10.563048502721166],
              [-16.10849177831833, -10.562408617112565],
              [-16.109176535303042, -10.565444576483173],
              [-16.111559244051957, -10.566119031173674],
              [-16.115151954030708, -10.566449238913684],
              [-16.116760360811792, -10.565562476206706],
              [-16.116645136026914, -10.562883475945217],
              [-16.116177716017912, -10.562296598499783],
              [-16.115936423014997, -10.5594654058243],
              [-16.113967717878335, -10.557308825012141],
              [-16.111634840912455, -10.556960594374063],
              [-16.109562734724786, -10.556036266562407],
              [-16.111296757854852, -10.554301531249145],
              [-16.114392605661624, -10.555105064574649],
              [-16.115897545775958, -10.555833069545121],
              [-16.116236609217466, -10.557489649658827],
              [-16.117886160202165, -10.557590057302697],
              [-16.118190386413858, -10.556376809434667],
              [-16.11690723455306, -10.554247747004046],
              [-16.115860866691364, -10.551781287805898],
              [-16.114208206906856, -10.549315902975218],
              [-16.114214159115658, -10.548655296751864],
              [-16.112387805395304, -10.547916005295303],
              [-16.11175930894184, -10.546732748198515],
              [-16.11212599057036, -10.545707215462048],
              [-16.110875073689257, -10.544483113560354],
              [-16.109364871228376, -10.541832161900027],
              [-16.108310538819268, -10.54106780157469],
              [-16.10902586986431, -10.539796796505305],
              [-16.109986227761222, -10.540309610003945],
              [-16.11187385377009, -10.538814572059461],
              [-16.11182530756929, -10.54029123822941],
              [-16.113273844238552, -10.542755330338627],
              [-16.113818051793828, -10.544370401594996],
              [-16.115181458499723, -10.546286098571244],
              [-16.11696337049133, -10.546459759266973],
              [-16.11714034727688, -10.549321248791147],
              [-16.119064975615714, -10.549488291615546],
              [-16.119481130742603, -10.548366750513294],
              [-16.121348423637016, -10.546485060216728],
              [-16.122079553893858, -10.544608249717912],
              [-16.121382141815978, -10.542724080509966],
              [-16.120355430666198, -10.542884719428033],
              [-16.120390206957396, -10.54012541666712],
              [-16.120829571535857, -10.538367130339193],
              [-16.11955177958062, -10.534200880117963],
              [-16.120575127416203, -10.532660068722235],
              [-16.117854946155735, -10.528595411511638],
              [-16.114928306352272, -10.527989759085372],
              [-16.11325105511635, -10.528205805434617],
              [-16.1126481004785, -10.526586856390294],
              [-16.113254169686858, -10.524787067678073],
              [-16.114716963418022, -10.524889921403473],
              [-16.119215635679392, -10.526508646304363],
              [-16.120225398135773, -10.527506569081604],
              [-16.120525842154795, -10.529335429715072],
              [-16.121930643870982, -10.53203162761917],
              [-16.12298883954192, -10.532754521692434],
              [-16.124720006089632, -10.539464418795859],
              [-16.1245080841693, -10.542186021528435],
              [-16.125487933091755, -10.543502063509047],
              [-16.12539349979674, -10.544500774522582],
              [-16.12683881268653, -10.546976341609493],
              [-16.12617899070992, -10.547913871255576],
              [-16.126622508028376, -10.550560540327902],
              [-16.126695251543456, -10.554694873091346],
              [-16.12726757512664, -10.555852232471311],
              [-16.12669656821936, -10.557520888623678],
              [-16.125297724280305, -10.55754625171314],
              [-16.124622980344437, -10.55958308564502],
              [-16.123569147954544, -10.560867664466164],
              [-16.12447292462684, -10.562558977585228],
              [-16.125565258051004, -10.562163304932291],
              [-16.126337445995016, -10.560713982924357],
              [-16.12728563540093, -10.560744990261357],
              [-16.127027303262693, -10.562524628551392],
              [-16.127554890438425, -10.564340397152469],
              [-16.127183877397556, -10.56582877990685],
              [-16.127592908870504, -10.567212160889897],
              [-16.129660740016885, -10.565766183053192],
              [-16.131963324481106, -10.564803911505892],
              [-16.133634361718592, -10.565104567082221],
              [-16.133314397166316, -10.560480281889133],
              [-16.13218778441117, -10.557648229745668],
              [-16.1311333929474, -10.556244315108762],
              [-16.132693959960896, -10.556013416751021],
              [-16.132533908270307, -10.554976102891567],
              [-16.131371476006443, -10.55466394900118],
              [-16.131913854818553, -10.553073233036805],
              [-16.131840337454413, -10.550962871659527],
              [-16.13279185897754, -10.55081580334993],
              [-16.13284277605391, -10.549216406271967],
              [-16.13190174985104, -10.546682994704433],
              [-16.132861937129988, -10.546174490668157],
              [-16.13396719479802, -10.542777302496049],
              [-16.135223369206578, -10.541316330771828],
              [-16.134794031659425, -10.539534490746505],
              [-16.135663112906656, -10.538917479750884],
              [-16.135971738727466, -10.537026246018973],
              [-16.1353204692215, -10.535743330279018],
              [-16.135471512309906, -10.533518057015423],
              [-16.13445740245731, -10.532140911715931],
              [-16.13348665911295, -10.532767471613125],
              [-16.132191542785865, -10.531783020512576],
              [-16.132716436503884, -10.528077744408058],
              [-16.132204024913076, -10.526386208203794],
              [-16.133331002780515, -10.524995679850102],
              [-16.13473869762124, -10.524431619452688],
              [-16.134836327421375, -10.523042040947836],
              [-16.133810566434548, -10.522404180724012],
              [-16.133500398137546, -10.52065609421937],
              [-16.134502456600316, -10.520313037078994],
              [-16.13335315479694, -10.518285062808557],
              [-16.133555981306035, -10.517665288349098],
              [-16.136520334909175, -10.517251052636555],
              [-16.134645451471933, -10.51547631818009],
              [-16.134304626897737, -10.51358400378801],
              [-16.137122770247974, -10.51341525155788],
              [-16.13497836360243, -10.511672249975215],
              [-16.135110717035968, -10.510746858957397],
              [-16.133100224963478, -10.508477972015287],
              [-16.129536095207925, -10.507854760595603],
              [-16.12741190575499, -10.505932941972315],
              [-16.130880056861763, -10.505290843068355],
              [-16.13132145264924, -10.504096441304796],
              [-16.133333664064466, -10.50249501014975],
              [-16.132702938988388, -10.500340283445134],
              [-16.13310840303958, -10.497687388273677],
              [-16.135435598340834, -10.496205254597642],
              [-16.135217190845232, -10.494900385448402],
              [-16.13551574300378, -10.491700547632105],
              [-16.13663964150505, -10.49071292204186],
              [-16.1383400876746, -10.488303748965734],
              [-16.13835528063935, -10.487411474402021],
              [-16.140255460251485, -10.484268096304515],
              [-16.139750362263026, -10.483483142536867],
              [-16.137229881818374, -10.48174784701205],
              [-16.1357389800772, -10.48158421586496],
              [-16.138506342684817, -10.478406941508831],
              [-16.14027014343186, -10.47940688182375],
              [-16.142357395360413, -10.480090063167975],
              [-16.14326322592154, -10.48129121180886],
              [-16.143130129473864, -10.48243319350445],
              [-16.14391919717195, -10.48380252030187],
              [-16.144665745422145, -10.486621905859307],
              [-16.143648704410616, -10.48775926323239],
              [-16.142864339432432, -10.489795831425912],
              [-16.14163775101, -10.491012963520165],
              [-16.141897936841673, -10.494684467222203],
              [-16.140973430056214, -10.495692025718801],
              [-16.14012305436035, -10.499198887210149],
              [-16.140563501108428, -10.502271925295219],
              [-16.142331887777754, -10.505971559589684],
              [-16.14258770106795, -10.508070626805546],
              [-16.141934304408487, -10.509384955013807],
              [-16.14346351074555, -10.51246477529835],
              [-16.14425551392855, -10.514855667893361],
              [-16.144550013069388, -10.517798755363076],
              [-16.146522948115933, -10.521721035619953],
              [-16.145859165038715, -10.523755669461897],
              [-16.144152944441522, -10.524492504751505],
              [-16.143170807509204, -10.525657623493304],
              [-16.144896976496458, -10.527180839823504],
              [-16.145353604415295, -10.52910297380075],
              [-16.144357185022216, -10.530931024721204],
              [-16.144892821564596, -10.532557721465437],
              [-16.145373530074295, -10.535882935338101],
              [-16.146241641629764, -10.538145539577743],
              [-16.146070634296773, -10.539269542827599],
              [-16.148128541995256, -10.54444664708038],
              [-16.1494149843394, -10.544928857079249],
              [-16.15017622027808, -10.546441788160054],
              [-16.151763273627033, -10.546331363056222],
              [-16.153150224827158, -10.547442968132492],
              [-16.154621509069592, -10.546860816255613],
              [-16.15602959953368, -10.547133352562392],
              [-16.155333391396972, -10.549930321947915],
              [-16.153236712339154, -10.54987326069592],
              [-16.14886040452413, -10.547498531284583],
              [-16.147526566668905, -10.547292162999112],
              [-16.146910859650873, -10.545532236501806],
              [-16.145700127457193, -10.54633835543704],
              [-16.14464468271251, -10.546178162601896],
              [-16.143980934657158, -10.547996859616804],
              [-16.14264989796235, -10.54734985136582],
              [-16.14264194538653, -10.55051298510261],
              [-16.141811505328242, -10.55155547518395],
              [-16.142462609661372, -10.553980754885105],
              [-16.143434036188868, -10.556236858062135],
              [-16.143041650462077, -10.557141300168357],
              [-16.143957195459922, -10.55853079060182],
              [-16.143063231305298, -10.55918741584149],
              [-16.144661324851363, -10.560220737824231],
              [-16.14179458808964, -10.56137394499497],
              [-16.141493753512023, -10.562768311372686],
              [-16.141916483014082, -10.56447086537582],
              [-16.140866786051298, -10.565674322534399],
              [-16.141553899310498, -10.566922836342867],
              [-16.14161820055035, -10.568533698989045],
              [-16.144066910230784, -10.569788947576772],
              [-16.1447259738965, -10.569470089346305],
              [-16.147966147759917, -10.569676310128898],
              [-16.143287311013417, -10.571540405017469],
              [-16.139546393591907, -10.571887267935573],
              [-16.138773735047792, -10.573559691656353],
              [-16.138988261402673, -10.575907954260945],
              [-16.14056110608511, -10.576398961598175],
              [-16.139320240217288, -10.577789236991922],
              [-16.140174553411896, -10.578269140858412],
              [-16.139511269009443, -10.581082062717073],
              [-16.1404652639208, -10.582734049940294],
              [-16.1400812777094, -10.583340483175432],
              [-16.143975691674374, -10.585397043381095],
              [-16.14394454243281, -10.58409166359268],
              [-16.145918436329175, -10.58543991615764],
              [-16.147519606608906, -10.587318815798087],
              [-16.14857684926913, -10.586666703356553],
              [-16.150621310052983, -10.58837420332945],
              [-16.152029142425334, -10.586631780480118],
              [-16.150892725573527, -10.583920609044474],
              [-16.153274404705297, -10.582778919143442],
              [-16.15278485898153, -10.579681418769935],
              [-16.153747926441728, -10.577749975082465],
              [-16.154643287301237, -10.577447515627325],
              [-16.153863862191844, -10.575668547711043],
              [-16.152920606036634, -10.575158436882345],
              [-16.15122154154213, -10.575340040649168],
              [-16.152359871925285, -10.573522676855381],
              [-16.152560766716885, -10.572195459091205],
              [-16.15184671165938, -10.57140042298799],
              [-16.151618839822202, -10.569789299815977],
              [-16.1557275125978, -10.571911314463124],
              [-16.156707181556655, -10.573086206728528],
              [-16.157554228312378, -10.575633129500902],
              [-16.15855367129591, -10.575144814129],
              [-16.162073926783997, -10.574349688795323],
              [-16.16478583554108, -10.572054760230756],
              [-16.16480107331383, -10.570583930522536],
              [-16.162357994431698, -10.569723091005367],
              [-16.161771483298114, -10.56908699690048],
              [-16.164325598507148, -10.567159475467905],
              [-16.164087854355177, -10.564390177127594],
              [-16.163327232102112, -10.563658827750682],
              [-16.163153731523618, -10.562099582099796],
              [-16.164041967465494, -10.561701145251492],
              [-16.16339013102698, -10.560278089460654],
              [-16.16247591549149, -10.556546701602576],
              [-16.16361481079286, -10.555431376983263],
              [-16.16498897446363, -10.555018518507064],
              [-16.167159011570934, -10.555580748613652],
              [-16.167471019454226, -10.556751412336926],
              [-16.16888200873017, -10.55848469293693],
              [-16.16839646865088, -10.559962233945706],
              [-16.168645936193123, -10.561367774187786],
              [-16.168197347815493, -10.562668689643164],
              [-16.16930659470478, -10.564311725156344],
              [-16.17056928428942, -10.56282804379226],
              [-16.173594977919336, -10.563769103524837],
              [-16.17548583198243, -10.563883024371346],
              [-16.17587506217439, -10.562556321434398],
              [-16.177594149713737, -10.563836590704797],
              [-16.177397893707713, -10.56526119556192],
              [-16.175834235691745, -10.564897111256252],
              [-16.173349661325027, -10.565489909256035],
              [-16.171710491403253, -10.566761492806918],
              [-16.16980137229334, -10.56746708941889],
              [-16.16999533150895, -10.570091213632573],
              [-16.17238077769854, -10.578514887547568],
              [-16.173600241382722, -10.57963112250949],
              [-16.175149199912255, -10.579532630404778],
              [-16.17667849028686, -10.580495931548757],
              [-16.1743948393521, -10.58277469672594],
              [-16.174177671328522, -10.583778290606103],
              [-16.172990702329674, -10.584110894758803],
              [-16.171651566904007, -10.583063739374925],
              [-16.169961402606162, -10.583148761391607],
              [-16.168484798171782, -10.584176680309605],
              [-16.168517755246487, -10.585524902308594],
              [-16.16592033579359, -10.587031201792906],
              [-16.165815721410883, -10.58537486682175],
              [-16.16443213791022, -10.586270459988242],
              [-16.16392123126809, -10.588211340063179],
              [-16.164733254382067, -10.592823189552162],
              [-16.16205518603683, -10.59367610597576],
              [-16.160843634582392, -10.596350909079685],
              [-16.161282670550396, -10.597289143509562],
              [-16.16362877786271, -10.598854077054764],
              [-16.164164291848493, -10.598561759366348],
              [-16.164104533828834, -10.595380618022883],
              [-16.165341379199443, -10.593485924141463],
              [-16.16673101138471, -10.594016353499828],
              [-16.16675665265681, -10.596289651920085],
              [-16.167815719182073, -10.599320673773002],
              [-16.168709299039694, -10.600064006019696],
              [-16.16997052824919, -10.599201620083445],
              [-16.1715595261501, -10.599330425247196],
              [-16.171586938364783, -10.596990692019931],
              [-16.173540573301704, -10.597889883936043],
              [-16.175423874747775, -10.597348436456272],
              [-16.175999582718028, -10.599141687522952],
              [-16.178330669468565, -10.598341865220545],
              [-16.178775858133267, -10.596396327984232],
              [-16.175599735411037, -10.593755027370216],
              [-16.175806198764338, -10.592929424478655],
              [-16.173859882204283, -10.590019135203192],
              [-16.173564938489694, -10.587961865086745],
              [-16.176425828615898, -10.586955724836171],
              [-16.17686103913253, -10.589364272068483],
              [-16.17881733206994, -10.591195217542454],
              [-16.18060542438709, -10.591310928535158],
              [-16.179719348221276, -10.592999439673457],
              [-16.181860642607017, -10.595845504164796],
              [-16.182526010897064, -10.597233125789808],
              [-16.184159113656225, -10.596374426944],
              [-16.184741352573052, -10.59524930119458],
              [-16.18633139089266, -10.595393198054824],
              [-16.187720531477634, -10.594032583096068],
              [-16.1886010028747, -10.592328492701554],
              [-16.192147470382142, -10.588481064155275],
              [-16.1929061089167, -10.585012958619002],
              [-16.19243686753735, -10.583023574304384],
              [-16.192628636362766, -10.581120297034397],
              [-16.193744833829754, -10.58048838552708],
              [-16.193983215295905, -10.578095449850837],
              [-16.194957760877564, -10.577055290210094],
              [-16.194776253743616, -10.575343705136312],
              [-16.195350764915258, -10.574525771436345],
              [-16.197055845474654, -10.5746483190249],
              [-16.198252219504916, -10.57532584446451],
              [-16.200486013695624, -10.573032153028212],
              [-16.20089613086949, -10.573743149205043],
              [-16.200510683805913, -10.575776125854262],
              [-16.198547753504855, -10.577403050298452],
              [-16.19678186167961, -10.579712248632251],
              [-16.196993726671387, -10.580739471622786],
              [-16.19831373702425, -10.581233499407496],
              [-16.197275097530845, -10.582697146519827],
              [-16.197429947179504, -10.584200902541163],
              [-16.19908850236363, -10.587616392565563],
              [-16.19907858889444, -10.589247800988897],
              [-16.197817994121618, -10.590958256957967],
              [-16.19665376784071, -10.591014790604476],
              [-16.195092520062172, -10.592220057919302],
              [-16.192361054962298, -10.596988173137312],
              [-16.192413636382373, -10.600416404101157],
              [-16.192791084601442, -10.601788019644987],
              [-16.194216169457178, -10.603105290480775],
              [-16.196474231328942, -10.604317638753557],
              [-16.19962781797328, -10.60526198595857],
              [-16.200236735009817, -10.60411953347584],
              [-16.199601284117215, -10.602507024573173],
              [-16.201284979359905, -10.60237349304293],
              [-16.202029962844907, -10.599397001998657],
              [-16.201829112136103, -10.598039843027172],
              [-16.20260388403227, -10.59752104478344],
              [-16.204480849448743, -10.598733504607168],
              [-16.20447165677569, -10.601692206678564],
              [-16.203960502898934, -10.60221872547131],
              [-16.204469159391174, -10.606211479480177],
              [-16.203891504930304, -10.607968563156195],
              [-16.204234222985384, -10.609415228175669],
              [-16.20846471723514, -10.611478898426961],
              [-16.2099772342331, -10.6131414472773],
              [-16.21124824636288, -10.613455146077735],
              [-16.213690803364806, -10.612504806580096],
              [-16.216165688885248, -10.612509575740713],
              [-16.217579571062366, -10.611721556713821],
              [-16.219146930973455, -10.611899589041071],
              [-16.219825564832778, -10.612936868701969],
              [-16.221352349587168, -10.612656164784825],
              [-16.222389417145887, -10.613310044869305],
              [-16.227679695765648, -10.612284139987471],
              [-16.230437613496324, -10.609952134155964],
              [-16.23040307669233, -10.607737037143686],
              [-16.229975643812022, -10.606172440827034],
              [-16.23070355368096, -10.603945247913948],
              [-16.232314742302965, -10.602823634980956],
              [-16.231854506150718, -10.599264934089717],
              [-16.22994885756779, -10.597010840838749],
              [-16.229626155782515, -10.594292452790777],
              [-16.228592156187133, -10.592275434797502],
              [-16.229051057592404, -10.59123167378398],
              [-16.229372044968414, -10.588571024517677],
              [-16.229922446685272, -10.587710985353226],
              [-16.22869886515373, -10.583016060116105],
              [-16.227528247080173, -10.581630330475774],
              [-16.226501386977173, -10.578212439421664],
              [-16.225222096035203, -10.576697253916793],
              [-16.227302581842146, -10.57383307764731],
              [-16.226858872800094, -10.572030829251114],
              [-16.227173653446094, -10.569894810949378],
              [-16.223665040838945, -10.56666286959506],
              [-16.222729271304253, -10.564041085655942],
              [-16.221259235640463, -10.562887068328106],
              [-16.22133806319267, -10.560691790895278],
              [-16.22041926990586, -10.56013021311725],
              [-16.220313038652964, -10.558527147987324],
              [-16.218489439283374, -10.555596894336528],
              [-16.216022606291528, -10.552977872472683],
              [-16.213476575142035, -10.550791228090315],
              [-16.214136119975866, -10.548009982204452],
              [-16.21304422218441, -10.546272956761314],
              [-16.212075869475758, -10.546266901346804],
              [-16.210846353261086, -10.54383797251744],
              [-16.211321542437624, -10.542677617777068],
              [-16.210337846530567, -10.541913636558975],
              [-16.209120629369025, -10.538927137620348],
              [-16.207487208542044, -10.538700966414027],
              [-16.20576613445726, -10.535070239542957],
              [-16.203929549758037, -10.531828976929795],
              [-16.204596698052995, -10.530291384708711],
              [-16.205029275415203, -10.527218408710295],
              [-16.204144212681456, -10.525618335939098],
              [-16.203645148644476, -10.523617598586672],
              [-16.203756359757072, -10.521990828902485],
              [-16.2029452712735, -10.519744458716694],
              [-16.201701122343703, -10.517532473412532],
              [-16.199578654919375, -10.515389744549422],
              [-16.199328892558363, -10.51289398201806],
              [-16.2016827554098, -10.511830471673948],
              [-16.203213215499197, -10.51268611585807],
              [-16.206120779067096, -10.512589028313785],
              [-16.201860352928644, -10.507341021396192],
              [-16.20012375530288, -10.506546597125746],
              [-16.20001377526186, -10.505141509671018],
              [-16.197560377474733, -10.502129701428567],
              [-16.19629794651277, -10.49886778086445],
              [-16.19482568504256, -10.497419569513754],
              [-16.19267567772737, -10.49463481071097],
              [-16.191881238594743, -10.491470634743102],
              [-16.189386287643554, -10.487765391738973],
              [-16.18877271869264, -10.485759112694362],
              [-16.18721473786256, -10.484820427311373],
              [-16.18651228379171, -10.482995230593174],
              [-16.185545586218737, -10.482518544012649],
              [-16.183247135806017, -10.479243797153252],
              [-16.18203128961105, -10.476533998310344],
              [-16.17953955131426, -10.473930517203726],
              [-16.179160011009024, -10.471259415488785],
              [-16.178709020174292, -10.470608014599735],
              [-16.174254521241995, -10.468789247635893],
              [-16.171032876266743, -10.465588111030232],
              [-16.16881614485717, -10.465698851714858],
              [-16.164911361202122, -10.462948855018109],
              [-16.163895220126225, -10.461025907117902],
              [-16.15860425453156, -10.457309714034736],
              [-16.156443269839414, -10.454404762212011],
              [-16.156257907142034, -10.453434504156467],
              [-16.1576708826906, -10.452099183102947],
              [-16.162399134778383, -10.455801328484773],
              [-16.16376479352254, -10.455770931450644],
              [-16.16480419439489, -10.45662311948894],
              [-16.16699088209311, -10.456391822650012],
              [-16.167547744933852, -10.45561011688174],
              [-16.170017182740533, -10.456595745067549],
              [-16.173156376947816, -10.45895356100353],
              [-16.174325218916078, -10.460968894314748],
              [-16.17640291478727, -10.46187692407866],
              [-16.17853149781802, -10.463965897887535],
              [-16.17936699291503, -10.463586673717781],
              [-16.17911831054415, -10.461572619017153],
              [-16.17789549982332, -10.460109095546633],
              [-16.176147317610297, -10.456611381000574],
              [-16.176317579129126, -10.454007321157288],
              [-16.175309848598907, -10.452405130783625],
              [-16.173158859471563, -10.4506174552313],
              [-16.17255843031434, -10.448537941277221],
              [-16.172862688654806, -10.447789356020804],
              [-16.17194179792766, -10.445385916660038],
              [-16.170327566981754, -10.443450170489221],
              [-16.170591074984948, -10.441968000420184],
              [-16.173895381032366, -10.440492334658064],
              [-16.17480774488349, -10.43974491081452],
              [-16.176131517180064, -10.439709661371634],
              [-16.17711159173543, -10.441584902679335],
              [-16.178335597546617, -10.443007270281635],
              [-16.1795696344894, -10.445580381307925],
              [-16.181199262082597, -10.44779399264805],
              [-16.18160187546519, -10.44943994235948],
              [-16.182573642323447, -10.450957704217277],
              [-16.183453733855423, -10.451017516100976],
              [-16.185600205143572, -10.454549011183056],
              [-16.18659299983797, -10.454640448191284],
              [-16.188108537158794, -10.457240567513471],
              [-16.187037689173888, -10.458809298770475],
              [-16.18875089111226, -10.463136189842583],
              [-16.188682183358075, -10.464567333781279],
              [-16.190448192328606, -10.468495783464318],
              [-16.19240654121634, -10.468992784858667],
              [-16.19323412495518, -10.472440992323687],
              [-16.19424906528948, -10.472419830033434],
              [-16.19594857323666, -10.47588024854721],
              [-16.19662108579138, -10.475775974420593],
              [-16.19804221014479, -10.479444076813346],
              [-16.198436412870805, -10.481543305597112],
              [-16.201297186556822, -10.484551813600953],
              [-16.202314020356244, -10.486991222681352],
              [-16.20240497490704, -10.488478938112284],
              [-16.20475092236654, -10.489718153477197],
              [-16.207552826629026, -10.494149853143847],
              [-16.208443280391215, -10.496332885553198],
              [-16.21058863841188, -10.499121137374281],
              [-16.211813245170564, -10.500226200164557],
              [-16.21164172154898, -10.501645086249288],
              [-16.212624152287162, -10.50410463945341],
              [-16.214229036450668, -10.504983534813581],
              [-16.215421155999877, -10.508198106853694],
              [-16.214662248440728, -10.509884434895467],
              [-16.21540207418165, -10.511026540516013],
              [-16.214165503975405, -10.517895256153063],
              [-16.214306621438116, -10.519423787086335],
              [-16.217244431807654, -10.523395900607591],
              [-16.21839630898141, -10.527090271842825],
              [-16.22030471245777, -10.529135407458313],
              [-16.221501234793312, -10.531038228714719],
              [-16.222440430093542, -10.533557297292083],
              [-16.22433610491865, -10.5353219682769],
              [-16.223550063760225, -10.536950556632037],
              [-16.22690888882235, -10.537185954091617],
              [-16.22773708269093, -10.537592221413629],
              [-16.228679063494, -10.532787879784932],
              [-16.229838454197616, -10.53245012242848],
              [-16.23067608970624, -10.527652807213453],
              [-16.23321481797158, -10.526757508349805],
              [-16.234466623297166, -10.52315573912072],
              [-16.23423852062764, -10.521221010417742],
              [-16.234799380961757, -10.519913758289483],
              [-16.235088085204787, -10.51627016440752],
              [-16.23639250106109, -10.514749247735663],
              [-16.238726551835672, -10.512959230780542],
              [-16.23804562377778, -10.511585071201464],
              [-16.24007686928584, -10.508679996342927],
              [-16.241288932257888, -10.505930343148234],
              [-16.23896993333189, -10.50087022830281],
              [-16.23881380532904, -10.498587335620597],
              [-16.239568236589854, -10.49690177454783],
              [-16.2407570652309, -10.49708456571977],
              [-16.24125584953594, -10.498242426479703],
              [-16.24391866685147, -10.501259962636095],
              [-16.244936044785543, -10.500671142661824],
              [-16.246027942002573, -10.501044338280325],
              [-16.246396398206294, -10.505018042298301],
              [-16.246205767575848, -10.507152463125534],
              [-16.247326397553113, -10.508563670487211],
              [-16.24721336639458, -10.511183611440497],
              [-16.249161254126342, -10.51234755894549],
              [-16.251541529363617, -10.512079170387858],
              [-16.25301901273574, -10.511483317312154],
              [-16.25375581535384, -10.510431035756007],
              [-16.257292023034076, -10.512286976632037],
              [-16.259522354041458, -10.512995033352638],
              [-16.260977160420534, -10.515398669917959],
              [-16.263891545911175, -10.514083404029723],
              [-16.265747667687954, -10.515396020438533],
              [-16.26573599603978, -10.516909351442258],
              [-16.263859845304566, -10.519272731273086],
              [-16.266982721082943, -10.52060245605501],
              [-16.26966095480573, -10.52034978653541],
              [-16.26980974157901, -10.521877248008254],
              [-16.270615063511425, -10.523260572984658],
              [-16.272044694687118, -10.523021867740066],
              [-16.273409197909107, -10.523533240399612],
              [-16.275291824397485, -10.523174364266866],
              [-16.276442714670793, -10.523828681706227],
              [-16.277529668167894, -10.52336134061101],
              [-16.281345617529496, -10.523918324054964],
              [-16.281595589072573, -10.52569340504421],
              [-16.282787078307283, -10.526350744748916],
              [-16.28161860387459, -10.527769206980844],
              [-16.279625495761724, -10.52800211655623],
              [-16.277570912678502, -10.528947794278384],
              [-16.27655867096191, -10.528544412493224],
              [-16.274360836259625, -10.529278259834042],
              [-16.273665722109858, -10.531139107945856],
              [-16.274917324243475, -10.532157239780464],
              [-16.27629247386969, -10.535824116742623],
              [-16.27553429121595, -10.537081837943125],
              [-16.276297872965376, -10.539497132412498],
              [-16.279947151718254, -10.544873063050488],
              [-16.283187612963022, -10.547059201700655],
              [-16.283681172354623, -10.548305174260411],
              [-16.286244825415523, -10.54998857168404],
              [-16.285982392877216, -10.551645465932173],
              [-16.284322852260548, -10.554066310863128],
              [-16.28204813824662, -10.554237924523944],
              [-16.28036640833092, -10.552287527214663],
              [-16.277202496244204, -10.550518170574081],
              [-16.2757726126671, -10.549319990813592],
              [-16.273147381981836, -10.545624391315682],
              [-16.272227430282364, -10.542018291508162],
              [-16.270758679973003, -10.540151889836244],
              [-16.270097690554923, -10.538086545856624],
              [-16.269441325191735, -10.537685441872005],
              [-16.26842025423106, -10.535523462639883],
              [-16.268302349185582, -10.533637780590672],
              [-16.267582975790596, -10.532885958095193],
              [-16.26618963878085, -10.530147339439955],
              [-16.264111591512563, -10.528575364393244],
              [-16.262136666481883, -10.526056240400466],
              [-16.258977560561462, -10.524669172250249],
              [-16.2579179808795, -10.522983826236311],
              [-16.255202705292607, -10.522273404595245],
              [-16.25368148929193, -10.521266170728957],
              [-16.252963800118156, -10.521643327245608],
              [-16.25058968618196, -10.520722072956797],
              [-16.247444215510804, -10.518976272183146],
              [-16.243378955845095, -10.51627271358426],
              [-16.24232992776971, -10.516301533290205],
              [-16.242344650602345, -10.517861087869473],
              [-16.2434571126762, -10.520346761176544],
              [-16.24238392695063, -10.521091286608748],
              [-16.242404954627133, -10.524005030896738],
              [-16.241270021710633, -10.524984080932237],
              [-16.242358159646226, -10.529028649007543],
              [-16.242167793970683, -10.531606774378881],
              [-16.242956433716365, -10.533152368126332],
              [-16.243508330503385, -10.537353088648443],
              [-16.24255119261879, -10.538588304033047],
              [-16.242309425547965, -10.54076873920984],
              [-16.243019681445908, -10.542823708719702],
              [-16.242801353041113, -10.544363339683043],
              [-16.244000224615938, -10.544946632642931],
              [-16.245274312121307, -10.546495251492427],
              [-16.2452944490798, -10.549895015318134],
              [-16.243863910665542, -10.551451221550039],
              [-16.24574244646296, -10.552555295027227],
              [-16.247742484833026, -10.557784626652904],
              [-16.248651203098095, -10.557102280972105],
              [-16.248529067348304, -10.555291826250537],
              [-16.250641381132844, -10.555152770192024],
              [-16.251572469789583, -10.556952259336896],
              [-16.250003600693613, -10.559618873297884],
              [-16.25000458465517, -10.561481295804024],
              [-16.250790975545222, -10.56304756353983],
              [-16.25285349453677, -10.563944408031569],
              [-16.255201470389835, -10.563811653287596],
              [-16.2558187142471, -10.56147534722619],
              [-16.257867333675833, -10.560689184725948],
              [-16.26181169033314, -10.557622727076712],
              [-16.263308742236948, -10.557589421334148],
              [-16.264628694770412, -10.558660633694476],
              [-16.264084205430816, -10.560735103474611],
              [-16.261577543352466, -10.56168363143162],
              [-16.26051080372289, -10.562793818203575],
              [-16.259594015951436, -10.565878282628201],
              [-16.259664095711475, -10.567845863030238],
              [-16.25922296381376, -10.569650205430927],
              [-16.2570262511539, -10.570264692586143],
              [-16.254502911198603, -10.57137200392741],
              [-16.25613391013495, -10.578121131270718],
              [-16.257394699232833, -10.578508526421285],
              [-16.25857787942763, -10.583939908505007],
              [-16.258045086035338, -10.584937449546745],
              [-16.259525381381458, -10.586065122953606],
              [-16.26061657083048, -10.58840303387246],
              [-16.259283340442533, -10.589293160436458],
              [-16.257767798144616, -10.587640853211118],
              [-16.257131716421206, -10.589351627661532],
              [-16.257553614871465, -10.593319396783697],
              [-16.25846966038777, -10.594661346895705],
              [-16.25901926643339, -10.599262920529721],
              [-16.26060511773896, -10.600531544648085],
              [-16.262274849316043, -10.598956582484083],
              [-16.262704009614183, -10.597446196603677],
              [-16.263582200899894, -10.597600142998989],
              [-16.26385197765665, -10.595897130841148],
              [-16.268097719842135, -10.594126676728408],
              [-16.269567519124372, -10.594931713166206],
              [-16.27001556393192, -10.592561796438819],
              [-16.272215630417772, -10.59194345788834],
              [-16.27478723807019, -10.595005701277012],
              [-16.27546746323452, -10.59698843885693],
              [-16.2739375706886, -10.59922901112275],
              [-16.272807470273825, -10.59917516239969],
              [-16.269639047936764, -10.6005054729981],
              [-16.26605116795753, -10.603821419078342],
              [-16.264881178879346, -10.604208498766239],
              [-16.26378581946551, -10.605790521627732],
              [-16.264081975331756, -10.607238117388773],
              [-16.26383764080344, -10.609414918535222],
              [-16.26667471264864, -10.611298674555567],
              [-16.267592629356418, -10.609782306614228],
              [-16.268595228289406, -10.61090131672956],
              [-16.27169847559535, -10.611170563369345],
              [-16.273308665376554, -10.60795370624639],
              [-16.274918423372622, -10.607434209211501],
              [-16.275673539801126, -10.60597690120814],
              [-16.278142468169552, -10.604947771834793],
              [-16.279284495574565, -10.603044394996333],
              [-16.28183405998912, -10.603094103293778],
              [-16.28479670760626, -10.60257527849567],
              [-16.286678331055963, -10.602850380801476],
              [-16.288564425709406, -10.604049362349762],
              [-16.290479906083206, -10.604124566415962],
              [-16.29216593983414, -10.60362043166477],
              [-16.292541792161366, -10.602526987551366],
              [-16.29413514754891, -10.601894101349709],
              [-16.294550892769134, -10.604175725308291],
              [-16.29400067596155, -10.605415808696703],
              [-16.297765582545452, -10.607407590113185],
              [-16.299229711858658, -10.607789117709084],
              [-16.301634459391074, -10.60719861446032],
              [-16.30340872392864, -10.60633789013962],
              [-16.309374623124757, -10.606736457949847],
              [-16.31221165302983, -10.610175119205186],
              [-16.311853927711876, -10.611069889094729],
              [-16.312915980878884, -10.6119579799582],
              [-16.313955989688804, -10.611638910718325],
              [-16.319249478961204, -10.61631625402841],
              [-16.323656671155007, -10.619476156947742],
              [-16.325226927295144, -10.620121979921082],
              [-16.32744531121076, -10.621782751852592],
              [-16.326495552061665, -10.62548619056417],
              [-16.32327617092325, -10.6241480805847],
              [-16.321009064539368, -10.62457259737687],
              [-16.318302650181863, -10.623916436800615],
              [-16.315288368682694, -10.622069783479967],
              [-16.314086763725836, -10.620889287881017],
              [-16.30932617136052, -10.618098518307388],
              [-16.306346793690675, -10.614886973511107],
              [-16.30319241509459, -10.612825588852665],
              [-16.301120672506986, -10.612377602430845],
              [-16.299817274601573, -10.61279830768351],
              [-16.299295299163877, -10.61431910042406],
              [-16.299577801239632, -10.615306190750475],
              [-16.30115743613692, -10.617281828326805],
              [-16.301978175812987, -10.61911638276878],
              [-16.30164347427634, -10.620697027948701],
              [-16.29955241420532, -10.61803646865801],
              [-16.296287312376574, -10.616325626886079],
              [-16.296830987468066, -10.615164273843304],
              [-16.2939734666815, -10.61392782010537],
              [-16.28942147913155, -10.611390758151824],
              [-16.288725945002344, -10.612656181748644],
              [-16.28769961200708, -10.611237084288268],
              [-16.286587664494927, -10.612038961605906],
              [-16.284588761647537, -10.611173575350747],
              [-16.2831702254265, -10.61167827595623],
              [-16.282732436574104, -10.61343552445265],
              [-16.283052830119335, -10.614963373053538],
              [-16.28218351981588, -10.616539902133693],
              [-16.284718003016888, -10.619722388174303],
              [-16.289289885035004, -10.6208607314814],
              [-16.292911706242936, -10.62075365873243],
              [-16.29374491619228, -10.620017556686346],
              [-16.295710374986275, -10.620297722563379],
              [-16.29839197564752, -10.622203286917555],
              [-16.301384259546186, -10.624776912751301],
              [-16.3047066525151, -10.626813491616932],
              [-16.305326743054213, -10.628149971285126],
              [-16.307338484987525, -10.629357073939579],
              [-16.309730007068424, -10.632364038562404],
              [-16.31370144192814, -10.639400444802728],
              [-16.31532250600697, -10.642037691414968],
              [-16.315549363777038, -10.639239057313118],
              [-16.33058780055437, -10.64041002630968],
              [-16.333035892537858, -10.610583852775553],
              [-16.331750582614866, -10.610484316591657],
              [-16.332567609434236, -10.600542340540878],
              [-16.287485601889493, -10.596943792252318],
              [-16.291678819656216, -10.54756439300883],
              [-16.294241826671524, -10.517401171639381],
              [-16.296777075954846, -10.48756989235459],
              [-16.295148151646274, -10.487436145622178],
              [-16.302765574668584, -10.397936078189314]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -145.7711482113849, "lat": 60.72336745922988 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02063"],
        "coty_name": ["Chugach"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Chugach Census Area"],
        "coty_fp_code": "063",
        "coty_gnis_code": "02804400"
      },
      "bbox": [
        -16.333035892537858, -10.960986959865982, -15.171345379754767,
        -10.38748569378903
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-14.055877300099018, -10.707390500271487],
              [-14.054258998624105, -10.708482134619926],
              [-14.051766675117713, -10.708530123864906],
              [-14.048180147124691, -10.707000459334756],
              [-14.044990282498926, -10.708984396208157],
              [-14.042584899508412, -10.70996215459568],
              [-14.043451365523069, -10.707201102599207],
              [-14.045831693776838, -10.707888239848748],
              [-14.04655567849794, -10.70548761380409],
              [-14.048973145015198, -10.706148581746879],
              [-14.049681295552325, -10.70377368304968],
              [-14.055171154165661, -10.705342887242228],
              [-14.054678625591217, -10.707056975160771],
              [-14.055877300099018, -10.707390500271487]
            ]
          ],
          [
            [
              [-13.801080301693416, -11.043932793557046],
              [-13.799467198124718, -11.044007788771014],
              [-13.798099242873098, -11.045544945529265],
              [-13.797015529881747, -11.048870892136883],
              [-13.796354710315645, -11.04971359235673],
              [-13.793129941962626, -11.05152608786453],
              [-13.790392760997252, -11.05505208847054],
              [-13.791245071071957, -11.055701832816053],
              [-13.793556399662052, -11.054209902395169],
              [-13.794925651911955, -11.052671896835419],
              [-13.79811624659643, -11.049905866085643],
              [-13.798134321410084, -11.048474038610022],
              [-13.798928637018323, -11.046726360122406],
              [-13.800276369280713, -11.046170770962913],
              [-13.801080301693416, -11.043932793557046]
            ]
          ],
          [
            [
              [-13.910286110652908, -10.799297824726997],
              [-13.908976882814406, -10.79967210664829],
              [-13.90799038902457, -10.798952005709229],
              [-13.904756030385014, -10.801633623934917],
              [-13.903792973246274, -10.801886591549907],
              [-13.902545429579073, -10.803552882839835],
              [-13.90227708748139, -10.807169401704073],
              [-13.90305969164776, -10.806776660190854],
              [-13.90397947890865, -10.805016586392991],
              [-13.905164764600363, -10.804914480013046],
              [-13.906258452917676, -10.802413212898418],
              [-13.907566589562077, -10.801291645045705],
              [-13.909367678820034, -10.801057402957051],
              [-13.910286110652908, -10.799297824726997]
            ]
          ],
          [
            [
              [-13.914259683918456, -10.791689677184571],
              [-13.913611326693767, -10.79027610563402],
              [-13.910842884505582, -10.793044338097381],
              [-13.910308700591424, -10.794253398740912],
              [-13.91055929226548, -10.7955104849431],
              [-13.913991921978917, -10.792447600704172],
              [-13.914259683918456, -10.791689677184571]
            ]
          ],
          [
            [
              [-13.921171636573899, -10.809241312258987],
              [-13.92045245511435, -10.807455813793732],
              [-13.918042123734264, -10.808705535377829],
              [-13.91622244303182, -10.810211187780963],
              [-13.915388197213035, -10.811688537298554],
              [-13.91377812372698, -10.813385616757568],
              [-13.9130067770183, -10.815101244319417],
              [-13.910422150181097, -10.81784158537067],
              [-13.909639902758084, -10.819290799304566],
              [-13.906387055879474, -10.823690799495164],
              [-13.905862244116998, -10.825169970127211],
              [-13.905276742554355, -10.82927360626259],
              [-13.904558333312634, -10.830654640890513],
              [-13.904875315874435, -10.831845749380355],
              [-13.906399153466053, -10.832718789643776],
              [-13.904516686980358, -10.834122255296219],
              [-13.903358288970917, -10.836392037611835],
              [-13.902406504175037, -10.837355152678684],
              [-13.90243967643629, -10.838906583403293],
              [-13.903765056712878, -10.838490172964272],
              [-13.90435996313687, -10.8394961443422],
              [-13.902237200998586, -10.842771480498001],
              [-13.902654144035814, -10.844079895582505],
              [-13.906853023944139, -10.836018732337314],
              [-13.90956163966977, -10.833924683837711],
              [-13.912626953126177, -10.828190361621632],
              [-13.916397135627367, -10.821867697440203],
              [-13.917099739374502, -10.818416568509326],
              [-13.917653079183676, -10.81804554179069],
              [-13.920070555165704, -10.812840001616522],
              [-13.921171636573899, -10.809241312258987]
            ]
          ],
          [
            [
              [-13.955291410893658, -10.698736579433513],
              [-13.899016489566389, -10.682710747061126],
              [-13.898301160253697, -10.683816047725646],
              [-13.879757085006213, -10.701993892584454],
              [-13.832282718960101, -10.699633276051074],
              [-13.822876523204268, -10.717307968263038],
              [-13.797255926766972, -10.731783311382483],
              [-13.783229176756334, -10.72744918952135],
              [-13.772698038007535, -10.739596831081075],
              [-13.756353655580162, -10.752917819860665],
              [-13.754609966724477, -10.773875437221841],
              [-13.738280328151673, -10.774610069132946],
              [-13.740398916687838, -10.775719501131716],
              [-13.766296269611574, -10.78311592648038],
              [-13.845466995976434, -10.805341323555439],
              [-13.84767028064398, -10.80397840213191],
              [-13.848687268281717, -10.804146382481646],
              [-13.886185051632067, -10.81426754325868],
              [-13.888728346268037, -10.808930779241058],
              [-13.889152992226558, -10.806148769400654],
              [-13.89086843232943, -10.805012000357607],
              [-13.894532654205252, -10.801046512945105],
              [-13.895431719883819, -10.799061253359454],
              [-13.896846000964041, -10.797135851429918],
              [-13.898159587723116, -10.791799296710185],
              [-13.898563036106612, -10.7890905602097],
              [-13.900199374318609, -10.78640920697793],
              [-13.901117089664085, -10.783159202051925],
              [-13.901846799892109, -10.781743435406295],
              [-13.903132073307388, -10.780887341925098],
              [-13.906153057608075, -10.777531989997222],
              [-13.90708668300803, -10.774281731701793],
              [-13.910592432266387, -10.768362503810144],
              [-13.916622125208853, -10.760092320532307],
              [-13.916935395507151, -10.759480941128786],
              [-13.918997418998105, -10.758491747189371],
              [-13.922309156717855, -10.755363518771702],
              [-13.923666101489282, -10.752861432070818],
              [-13.923965216578972, -10.751546438184763],
              [-13.92608457343966, -10.748255914876873],
              [-13.92710544370961, -10.745091496337233],
              [-13.928817660319709, -10.74452898576497],
              [-13.9315056329602, -10.746954360731868],
              [-13.932792080925264, -10.747538069109156],
              [-13.934036624609176, -10.747367945595995],
              [-13.93620817872592, -10.745534991898806],
              [-13.937158940643904, -10.743051382634745],
              [-13.93724753412595, -10.739143872533017],
              [-13.93764682462969, -10.737334977833559],
              [-13.940867634885343, -10.735235067275966],
              [-13.941414693776963, -10.734123971610664],
              [-13.94456292300476, -10.731199735767259],
              [-13.945184494876964, -10.72999725768669],
              [-13.947364544456688, -10.728127338593765],
              [-13.94834946080273, -10.727926318795188],
              [-13.949199095082738, -10.726439198997966],
              [-13.949334760362637, -10.722011225372713],
              [-13.95038827676532, -10.717818212123461],
              [-13.952875895303459, -10.711287964334353],
              [-13.953531109018005, -10.707552766514617],
              [-13.953360916920843, -10.705283190791878],
              [-13.953629791747417, -10.700917878895407],
              [-13.955291410893658, -10.698736579433513]
            ]
          ],
          [
            [
              [-13.942469265726839, -10.767000559840561],
              [-13.940851998726167, -10.767922330275967],
              [-13.941940687879018, -10.768645805027603],
              [-13.942469265726839, -10.767000559840561]
            ]
          ],
          [
            [
              [-14.052268788271865, -10.589555317142457],
              [-13.960320381046126, -10.696132786854108],
              [-13.960770184683481, -10.698760587320722],
              [-13.960019169111137, -10.700437524536131],
              [-13.960487241495727, -10.701378742234633],
              [-13.959832031040182, -10.703114006069828],
              [-13.95998464025566, -10.705197945844775],
              [-13.958893747215503, -10.706370044749201],
              [-13.958150593611022, -10.709208185654008],
              [-13.958422506031697, -10.71263883949085],
              [-13.957310305426885, -10.714633833675869],
              [-13.956623193330463, -10.714875259249249],
              [-13.955337876600586, -10.717911271461007],
              [-13.955566682091034, -10.719551537775539],
              [-13.956885028615396, -10.721051053962732],
              [-13.958478258142138, -10.719670266376022],
              [-13.959511293339638, -10.720354102125011],
              [-13.962991059439867, -10.719897770234693],
              [-13.963331797350689, -10.72115079941457],
              [-13.972318745442998, -10.720305612163667],
              [-13.972983460922663, -10.71944423207651],
              [-13.976353800382945, -10.717691105646704],
              [-13.978265467452768, -10.717278493493154],
              [-13.981031261916371, -10.715521592704018],
              [-13.981938108673928, -10.715427812895431],
              [-13.983452287732986, -10.717027542633488],
              [-13.982568711607637, -10.720828481740169],
              [-13.98159090242624, -10.721468896376118],
              [-13.977721483388104, -10.722822071663503],
              [-13.976869973015232, -10.72263725200806],
              [-13.975358320208368, -10.723683447846936],
              [-13.971260949918307, -10.724753772060945],
              [-13.97005499443237, -10.725416959834952],
              [-13.967173217856347, -10.726088102203889],
              [-13.962339282130728, -10.726758243304964],
              [-13.960759334730614, -10.728291951293809],
              [-13.961256721847104, -10.729304353183846],
              [-13.960662044682984, -10.731491757385625],
              [-13.956733486555558, -10.735010307468668],
              [-13.956107956008875, -10.73702845582268],
              [-13.957397639121499, -10.738936211871057],
              [-13.957521096870128, -10.741257434428862],
              [-13.957062031223932, -10.742619467774297],
              [-13.954775641276292, -10.743393261426151],
              [-13.954122790556713, -10.74307800927399],
              [-13.950880685819957, -10.742922881921334],
              [-13.94750856923869, -10.743588063724584],
              [-13.945775415737023, -10.744685258353385],
              [-13.943178268594075, -10.745631504216917],
              [-13.943325821675241, -10.746478460723534],
              [-13.940486816820158, -10.748400987524294],
              [-13.938820475477405, -10.750572389460755],
              [-13.93735949552076, -10.753095314295345],
              [-13.935701198370149, -10.75506982647128],
              [-13.935817911549334, -10.756139815600926],
              [-13.932526634648552, -10.760381283774658],
              [-13.930760782563086, -10.762228366585362],
              [-13.931239793039751, -10.763184237210933],
              [-13.932550950701025, -10.76312682747622],
              [-13.93615816282569, -10.760700837073863],
              [-13.936917097602135, -10.761964451212505],
              [-13.93440918899812, -10.763369764221483],
              [-13.932434845694628, -10.766621176559145],
              [-13.930548771083867, -10.768270513042193],
              [-13.928169060960649, -10.769125230125807],
              [-13.92712834945324, -10.771295304077768],
              [-13.927122773616363, -10.772399610755109],
              [-13.92540506912782, -10.773828700827567],
              [-13.925313928458262, -10.774661263646342],
              [-13.921316808860862, -10.778993079474496],
              [-13.91913427156366, -10.78039666660353],
              [-13.918594395853827, -10.781691532333138],
              [-13.918976639431923, -10.783525381932149],
              [-13.920000257480538, -10.784375068340667],
              [-13.920971681767288, -10.784026336239444],
              [-13.922202973714866, -10.782037722406795],
              [-13.924631452520833, -10.77941189312814],
              [-13.926198935125736, -10.778426433912937],
              [-13.92760394943398, -10.779343472206689],
              [-13.928571136572884, -10.778946060429021],
              [-13.930094800501632, -10.777154491924303],
              [-13.933426143619585, -10.77776826079684],
              [-13.934268013038492, -10.775909061394168],
              [-13.936571772699645, -10.772410195248163],
              [-13.935836762254016, -10.770983436288033],
              [-13.93599777118747, -10.769939842608315],
              [-13.937697352501665, -10.767863987137703],
              [-13.937678136051623, -10.767055957715078],
              [-13.93911863254311, -10.764878342072759],
              [-13.938629377939304, -10.764132675046506],
              [-13.939266461190716, -10.762839878034889],
              [-13.941135190721905, -10.762703049787518],
              [-13.942718933759446, -10.761739237017197],
              [-13.94478711288585, -10.759169215570989],
              [-13.942016305760106, -10.758416830247276],
              [-13.94587839065862, -10.756410674012354],
              [-13.947733381764133, -10.75443587452661],
              [-13.949403509450237, -10.753917871306196],
              [-13.952207601917797, -10.751992965492978],
              [-13.952917493139088, -10.750929387582955],
              [-13.955102825981726, -10.750433688070933],
              [-13.956548039994512, -10.749188083404361],
              [-13.957575640811964, -10.746493842829821],
              [-13.963920127485032, -10.744666006722365],
              [-13.966322246928698, -10.742901581266484],
              [-13.972656202733074, -10.741456964672718],
              [-13.974678627238418, -10.741626638495841],
              [-13.976357148937836, -10.7410069319463],
              [-13.977011684208602, -10.73966404731294],
              [-13.980967550233945, -10.738330438899988],
              [-13.985945891919314, -10.738023039211214],
              [-13.990760175682983, -10.738583182208355],
              [-13.993396907676924, -10.739667552610715],
              [-13.993449138506476, -10.740553883111138],
              [-13.989728303905242, -10.741389606996268],
              [-13.988342530628115, -10.741308015042522],
              [-13.984153787272376, -10.74314577598855],
              [-13.97990640840602, -10.743963784637945],
              [-13.975468392852049, -10.746952463017672],
              [-13.974470059863636, -10.748112830891117],
              [-13.974362297193329, -10.75000295270629],
              [-13.96826848140654, -10.753969316561014],
              [-13.966908940784222, -10.754243027345597],
              [-13.966154743399436, -10.75516685471551],
              [-13.96028878486706, -10.758935749839205],
              [-13.960616526341957, -10.760994917847693],
              [-13.960001206135944, -10.762045537682921],
              [-13.958601191961982, -10.761695594823408],
              [-13.956755084569346, -10.762269179338649],
              [-13.955979839561097, -10.764018468197422],
              [-13.956329217579539, -10.76660939264111],
              [-13.955154622148564, -10.769121770607258],
              [-13.953948285536233, -10.770225969198396],
              [-13.953446721987799, -10.772097450752803],
              [-13.950610935956982, -10.77484373127431],
              [-13.949537313909108, -10.776248567958955],
              [-13.947850985592131, -10.77717449946787],
              [-13.947583783047131, -10.778544081349311],
              [-13.945810502180809, -10.780978561746632],
              [-13.943675342863848, -10.781164811520245],
              [-13.938981547311451, -10.7804092061966],
              [-13.935890028103731, -10.781287997439865],
              [-13.934552067145292, -10.782104962019426],
              [-13.93346720790374, -10.784416075269897],
              [-13.932737323154674, -10.784948561831538],
              [-13.932149798390178, -10.787243769082057],
              [-13.932610624033444, -10.789303359673035],
              [-13.931389268364901, -10.792275951516917],
              [-13.931936295458884, -10.794024823772121],
              [-13.932167978513323, -10.79777544447801],
              [-13.931434073476288, -10.799838127003312],
              [-13.931637453872963, -10.801706853754911],
              [-13.931247657310003, -10.804098659550567],
              [-13.930576460285232, -10.804875095285261],
              [-13.928836632708814, -10.804602670910752],
              [-13.926886840409137, -10.805500297003103],
              [-13.92610177969068, -10.806815246456186],
              [-13.92579015761216, -10.808483853968253],
              [-13.926698002713405, -10.810234183337323],
              [-13.928429801654428, -10.81129493122952],
              [-13.928991791632603, -10.813166851386896],
              [-13.928181781089746, -10.814871169215179],
              [-13.927266678914384, -10.817996080183683],
              [-13.926061350584963, -10.818622604813779],
              [-13.92476859037495, -10.820059357329027],
              [-13.92424751013691, -10.821837705742553],
              [-13.924451473016418, -10.823663019514173],
              [-13.925354335017499, -10.825589167580782],
              [-13.922874066360514, -10.829198904234861],
              [-13.921015463255607, -10.829773428731043],
              [-13.920039595245909, -10.831433504429388],
              [-13.917842914447029, -10.834068948384632],
              [-13.91722422573092, -10.83587520796095],
              [-13.915898760485135, -10.837965750764061],
              [-13.91633684121627, -10.84011512476387],
              [-13.915493504540693, -10.840713331233685],
              [-13.912470797271558, -10.840694519679872],
              [-13.9097743069323, -10.840018855193938],
              [-13.908353321453983, -10.840761352633816],
              [-13.906440193424732, -10.841056048371927],
              [-13.904994992297613, -10.844303405188562],
              [-13.904827489913554, -10.847297440024358],
              [-13.906490917367783, -10.85028240196978],
              [-13.905039064035286, -10.85233982534483],
              [-13.903757114068622, -10.85321136132666],
              [-13.902037240387642, -10.855722891900028],
              [-13.899543234145566, -10.858589078854505],
              [-13.900036500804784, -10.860097376877246],
              [-13.899303269003216, -10.861831338239968],
              [-13.896698114569425, -10.86222600856551],
              [-13.89507873109189, -10.863898498007707],
              [-13.893875990631319, -10.866162510681603],
              [-13.892454494014329, -10.867348507549591],
              [-13.890081777132034, -10.871003344623107],
              [-13.887372561565522, -10.872309718468365],
              [-13.886662816284185, -10.873654736840457],
              [-13.883522443476695, -10.876872535808564],
              [-13.880928069320225, -10.87838882571848],
              [-13.879057637588954, -10.881085052025504],
              [-13.87988624347654, -10.881763600944202],
              [-13.879336798409463, -10.883775015605265],
              [-13.876968243299693, -10.886640191735815],
              [-13.876855905210666, -10.887626265458634],
              [-13.875531421449669, -10.889683528896528],
              [-13.874722058812772, -10.893482047588986],
              [-13.872558362926927, -10.897095143040342],
              [-13.873255065672087, -10.899354286380069],
              [-13.872982408530051, -10.900428548916166],
              [-13.872935317716449, -10.9052900414125],
              [-13.871113853210474, -10.905081227585326],
              [-13.871335886264076, -10.902662471742861],
              [-13.870916185861525, -10.901656185035364],
              [-13.869528943157265, -10.902102644287735],
              [-13.86568291851274, -10.90570419413861],
              [-13.862125451694517, -10.908324794835828],
              [-13.860661356582339, -10.911144874119174],
              [-13.858026588385378, -10.914430053283597],
              [-13.857278547239778, -10.916346686934851],
              [-13.853964184432265, -10.918284521291376],
              [-13.853521821528892, -10.919623362278772],
              [-13.851993460634443, -10.921139849359273],
              [-13.851534161225818, -10.923140807640598],
              [-13.847385710242957, -10.927959116220995],
              [-13.845864221948814, -10.929515628376194],
              [-13.845218474221427, -10.93093114862849],
              [-13.846189158321138, -10.932054072609404],
              [-13.845950920091651, -10.93376412093991],
              [-13.843986012121642, -10.935380326685975],
              [-13.841755654244862, -10.939324670474468],
              [-13.840845294311446, -10.942310385563319],
              [-13.840965337958366, -10.943724395554288],
              [-13.84210286308645, -10.944139060662273],
              [-13.844427642089018, -10.942224005624553],
              [-13.845904955977415, -10.939977763015595],
              [-13.846528540308768, -10.938332509776151],
              [-13.845864719564249, -10.937386069778267],
              [-13.84703718445591, -10.936165168409259],
              [-13.847231609330478, -10.934753307705737],
              [-13.849056612064192, -10.932696962431349],
              [-13.851366531046235, -10.934158317980582],
              [-13.852334411057914, -10.934079166161085],
              [-13.854162623938409, -10.931401629292475],
              [-13.855932738056174, -10.931951913186293],
              [-13.857155135688206, -10.931012221754647],
              [-13.858466350436371, -10.932808526474586],
              [-13.85832380025161, -10.933745607030673],
              [-13.855364772015475, -10.936145521325448],
              [-13.851723951204551, -10.938261813118283],
              [-13.85127332654568, -10.939022522516224],
              [-13.852260327171937, -10.940549960872936],
              [-13.85121982588638, -10.941631209729204],
              [-13.849777796191969, -10.94406600699805],
              [-13.848451261707714, -10.947780543689646],
              [-13.845761647235934, -10.948346568326986],
              [-13.844200047908778, -10.949814233028423],
              [-13.843089111284025, -10.953859621102227],
              [-13.84222782359081, -10.955394716882457],
              [-13.842216664147605, -10.956950429030192],
              [-13.839297528354685, -10.958431494868021],
              [-13.835822323055195, -10.96238163627824],
              [-13.834628794726852, -10.96458123418549],
              [-13.832995542257718, -10.965673550591719],
              [-13.83336995089331, -10.967297178616265],
              [-13.832465242396692, -10.968821689836089],
              [-13.830902242575572, -10.968462597271763],
              [-13.82938553375502, -10.97128400189157],
              [-13.831629310494687, -10.972239497276572],
              [-13.83203816348288, -10.973293641464469],
              [-13.831458334515895, -10.974331967542486],
              [-13.82901613018026, -10.976621953910309],
              [-13.826337933166823, -10.981523149163074],
              [-13.825164834762074, -10.982124311731909],
              [-13.824055148056587, -10.983725859845542],
              [-13.822337840553873, -10.984483835053659],
              [-13.820477036790274, -10.986480477580542],
              [-13.819072754724308, -10.988460512357864],
              [-13.818371018428078, -10.990359304483212],
              [-13.817063863462277, -10.991860722782418],
              [-13.817171173821373, -10.993322104012925],
              [-13.814937853597538, -10.997017570530343],
              [-13.81316627622233, -10.998252423668712],
              [-13.81289751708771, -11.000366797584059],
              [-13.811383754190055, -11.003555181384682],
              [-13.81092096549192, -11.005928699362762],
              [-13.80975925400029, -11.006937193993279],
              [-13.809657594351501, -11.008340647978086],
              [-13.807677554770848, -11.009147811911848],
              [-13.807050139343511, -11.011306566282038],
              [-13.806273502565965, -11.011933980932897],
              [-13.80366672909411, -11.015349054592843],
              [-13.802368299551564, -11.018783938932321],
              [-13.80118957628657, -11.020147398034851],
              [-13.80136534486196, -11.021228833564743],
              [-13.80020960338576, -11.024033760528836],
              [-13.799811061816985, -11.026429923555234],
              [-13.798834001542572, -11.027269535321949],
              [-13.798098155664878, -11.029882803728706],
              [-13.79879981085766, -11.031789352666532],
              [-13.798161209168956, -11.03259137462815],
              [-13.797857057909539, -11.034407282421522],
              [-13.799595077253395, -11.033992042807794],
              [-13.801848621785346, -11.03100704418835],
              [-13.802399773439289, -11.030986351040346],
              [-13.804135265593938, -11.033234466557667],
              [-13.806083330817042, -11.03446665419697],
              [-13.80657774237231, -11.035550459904226],
              [-13.805679111656623, -11.037041816362796],
              [-13.804391578252618, -11.037704025930916],
              [-13.804585828310195, -11.03888119552515],
              [-13.802938166322788, -11.041055370628674],
              [-13.805306111388171, -11.042408558085752],
              [-13.805490643339967, -11.04331425134579],
              [-13.804888513971548, -11.04557214373995],
              [-13.800631196358433, -11.051840975249103],
              [-13.799213859758408, -11.052781388563433],
              [-13.798998545066475, -11.05487598337648],
              [-13.796292943170565, -11.057693075588807],
              [-13.794412160434216, -11.060793309190034],
              [-13.792519398423305, -11.062406688580976],
              [-13.792234955529965, -11.063359351208144],
              [-13.790430148450158, -11.065133584134099],
              [-13.791552129017646, -11.065951089413808],
              [-13.790068107212823, -11.067413278544809],
              [-13.791474371932509, -11.068452869930429],
              [-13.792863846258784, -11.067812145757745],
              [-13.795818455184444, -11.065692944319382],
              [-13.796910936454589, -11.067985176958539],
              [-13.800305987448485, -11.06621666625744],
              [-13.802657011894969, -11.065812071167205],
              [-13.80416362133177, -11.06426632818674],
              [-13.805162524750843, -11.06396814985195],
              [-13.806581538411276, -11.066082415484868],
              [-13.80936709184175, -11.06696932193377],
              [-13.81237034858627, -11.0658957647136],
              [-13.814388139573673, -11.06400146167608],
              [-13.818009141004522, -11.063596787401075],
              [-13.820594854158822, -11.062853943710339],
              [-13.821504342136762, -11.061317356247585],
              [-13.822945954382057, -11.061054872993656],
              [-13.824584123943247, -11.061970612946489],
              [-13.826514555113834, -11.062206138455647],
              [-13.827684893466, -11.06316790091195],
              [-13.830043367137076, -11.064108337177265],
              [-13.830711018608156, -11.064926361957337],
              [-13.83309239252994, -11.065019885957295],
              [-13.835122451717778, -11.064608943498431],
              [-13.839428536890399, -11.062330843524157],
              [-13.840853643228012, -11.06026763185786],
              [-13.842714881059985, -11.05949332635578],
              [-13.844796141130095, -11.05690031076035],
              [-13.845790144984681, -11.056837240223668],
              [-13.848067544590734, -11.05452077320433],
              [-13.847944677436901, -11.053757199506942],
              [-13.848875659001871, -11.05182475304544],
              [-13.850596901441804, -11.049981838573942],
              [-13.851524988890326, -11.050065160243637],
              [-13.853617846592677, -11.04649127545347],
              [-13.854797676612835, -11.044943917058037],
              [-13.857459810912298, -11.043905185309123],
              [-13.85995850982502, -11.041566878269016],
              [-13.861740546815266, -11.040279616563206],
              [-13.862293384690396, -11.037929783444348],
              [-13.865391980769358, -11.034815347582143],
              [-13.870659724062863, -11.02513034904138],
              [-13.871256272992357, -11.023555793826374],
              [-13.873245182139772, -11.021373278112266],
              [-13.87445649016111, -11.018337484486253],
              [-13.875548991559494, -11.016456888882068],
              [-13.875888690321899, -11.014677174682307],
              [-13.877005797700694, -11.014411741650825],
              [-13.879225662396431, -11.012536944240482],
              [-13.880289173259063, -11.009979963693764],
              [-13.881521309997291, -11.008854165784848],
              [-13.883479930393044, -11.003695114322806],
              [-13.8844634863929, -11.001563698190045],
              [-13.883577429454713, -11.000734459708664],
              [-13.884798287735595, -10.99902698552402],
              [-13.885753398638618, -10.998538089653474],
              [-13.886640207447405, -10.996736880687294],
              [-13.888907011294567, -10.993452756311045],
              [-13.89019152361144, -10.99198704207478],
              [-13.892276461521499, -10.99194921691617],
              [-13.893564479906265, -10.991242258723675],
              [-13.893551779680855, -10.988966879157791],
              [-13.895457741856957, -10.98710489196388],
              [-13.893859041576032, -10.985292931302478],
              [-13.892513124937123, -10.98321091812184],
              [-13.891313773355542, -10.982269322746525],
              [-13.888839323108206, -10.9815635466879],
              [-13.887103499176463, -10.97953102942496],
              [-13.885148600393205, -10.979098026047229],
              [-13.882096382564002, -10.97962518673372],
              [-13.881289511389266, -10.981196321692865],
              [-13.879619270012945, -10.981232391314522],
              [-13.878347801174678, -10.980365006273132],
              [-13.875807618789004, -10.980584170781816],
              [-13.874672876935456, -10.981255617490524],
              [-13.873404870446784, -10.982789760066352],
              [-13.870571323136016, -10.983191984781737],
              [-13.867957435597372, -10.981668507704727],
              [-13.866534336470504, -10.980430970893831],
              [-13.866330691611722, -10.978888449216768],
              [-13.865057810336022, -10.976825859464302],
              [-13.866186009067427, -10.97468462222886],
              [-13.868926012342314, -10.972679213066185],
              [-13.869676898196294, -10.971162163386207],
              [-13.871074163965302, -10.970189611447962],
              [-13.872559725018613, -10.970086964510028],
              [-13.875144762632843, -10.969097741674801],
              [-13.876562349215877, -10.969209718160144],
              [-13.879005261073614, -10.967544618904517],
              [-13.877858105338085, -10.964662071272647],
              [-13.87779036537034, -10.963164327284302],
              [-13.87919360161863, -10.96208348784696],
              [-13.883003332422557, -10.95747951576082],
              [-13.885437618653281, -10.95665772743202],
              [-13.886458215990476, -10.955637266587622],
              [-13.887879061225966, -10.956118473403402],
              [-13.890391086624804, -10.954508552808068],
              [-13.890581865599714, -10.953001184944142],
              [-13.888519135695507, -10.950174237194453],
              [-13.888512170586761, -10.947837062151324],
              [-13.891241809823013, -10.944139813682447],
              [-13.891830697041433, -10.942709926019978],
              [-13.894310552768323, -10.942032523156959],
              [-13.895928724861903, -10.939983499583162],
              [-13.897913518418092, -10.939733820006659],
              [-13.898899176457157, -10.939010777549717],
              [-13.901480821452802, -10.94023803568775],
              [-13.90424993813168, -10.939634311214181],
              [-13.905155577130705, -10.938441108922497],
              [-13.90720599390068, -10.937564762598319],
              [-13.90762292175017, -10.936560440061283],
              [-13.909984126550013, -10.934936918301549],
              [-13.911273459680343, -10.937313924774065],
              [-13.91256004057032, -10.936710799075637],
              [-13.913222331773433, -10.935304779954894],
              [-13.91521537773502, -10.93511920754405],
              [-13.917170718759088, -10.93677272947013],
              [-13.918837385193461, -10.935374503224306],
              [-13.919642806812409, -10.933863234167056],
              [-13.92084356585019, -10.93314792308303],
              [-13.921775586418555, -10.931508904296862],
              [-13.92068983422936, -10.930248430824804],
              [-13.922062990203287, -10.928300195240947],
              [-13.921973993138593, -10.926741957867204],
              [-13.922870914601097, -10.926354580207336],
              [-13.924817104512456, -10.923936320412793],
              [-13.927086345203058, -10.92411969374845],
              [-13.928147488420562, -10.925324033116803],
              [-13.92987929283805, -10.924873206997294],
              [-13.931039320767743, -10.922583772408803],
              [-13.933097815792888, -10.92170731402474],
              [-13.933399252817695, -10.923265364331208],
              [-13.934460794058548, -10.923778683334397],
              [-13.936413073891584, -10.923151318137132],
              [-13.936567803735873, -10.924436274973523],
              [-13.938281715330765, -10.923311241657446],
              [-13.940274590201854, -10.923205833886449],
              [-13.941288061677197, -10.922072736531119],
              [-13.941652386600836, -10.92062072237813],
              [-13.943934593116822, -10.921266831980791],
              [-13.945493141221956, -10.92267558955203],
              [-13.94614575524786, -10.924137050074785],
              [-13.94587539041499, -10.925718733808196],
              [-13.947550052461335, -10.925179886888312],
              [-13.948532847349519, -10.923828190682984],
              [-13.951194061415642, -10.922447207743515],
              [-13.952489161471558, -10.921257712197098],
              [-13.954226119008256, -10.9184369971154],
              [-13.95604964596705, -10.919080744247921],
              [-13.958703240162393, -10.923854918205418],
              [-13.961495938172332, -10.92479330586634],
              [-13.961756952678384, -10.921943056839673],
              [-13.962878115706383, -10.921174328344632],
              [-13.964933531117035, -10.91819985839639],
              [-13.965115892951127, -10.915631283973545],
              [-13.965588657786652, -10.914673303607328],
              [-13.96430760444883, -10.91334085962005],
              [-13.964176851010345, -10.912397062462349],
              [-13.961849977030763, -10.910466325053521],
              [-13.963312388176304, -10.909718525894132],
              [-13.96341655887325, -10.906873227056552],
              [-13.96489174171479, -10.903251847294515],
              [-13.963544736349656, -10.902119843177173],
              [-13.962378352071015, -10.899298187732755],
              [-13.962575605503911, -10.896133954173706],
              [-13.96353226922198, -10.894101091688755],
              [-13.963917016644494, -10.891940329921262],
              [-13.964898033617525, -10.890195874152852],
              [-13.96404921352402, -10.888910935040252],
              [-13.963749064907477, -10.887368901539048],
              [-13.962098931387308, -10.88522890664123],
              [-13.960027164344627, -10.883716848535206],
              [-13.960967206915027, -10.881259673810243],
              [-13.96251328808579, -10.879548037203868],
              [-13.961558333448396, -10.878289643138105],
              [-13.958528308184883, -10.87824294731066],
              [-13.957483132662977, -10.87792190739366],
              [-13.955364652985526, -10.875838316016672],
              [-13.952873695163772, -10.875799385088026],
              [-13.95134200891808, -10.876298321436312],
              [-13.949864626241588, -10.874523513140216],
              [-13.949563035654297, -10.873154177079227],
              [-13.948640633808468, -10.872214565027434],
              [-13.945368643011914, -10.87128836928151],
              [-13.943599757857392, -10.867033229504203],
              [-13.941920094843896, -10.865430338168297],
              [-13.941114404234414, -10.865250588162708],
              [-13.938617552966367, -10.865856555979391],
              [-13.937671447417163, -10.864598036410124],
              [-13.939715374062981, -10.860033313271572],
              [-13.941708554675124, -10.859325402860012],
              [-13.945006798716522, -10.856780374791654],
              [-13.94634466908309, -10.856949384622284],
              [-13.948158086729691, -10.857868162507136],
              [-13.949385457403931, -10.859464488654256],
              [-13.951350123603266, -10.859389199683442],
              [-13.95319634722986, -10.858416289928202],
              [-13.954021130687169, -10.858520363064756],
              [-13.954634693086955, -10.856656219548201],
              [-13.954316931002195, -10.854934018660702],
              [-13.956323211029895, -10.85230611466263],
              [-13.955168474401841, -10.85060049126151],
              [-13.953416878988358, -10.849960862300568],
              [-13.95468391651169, -10.847815182085851],
              [-13.951742928193442, -10.84592707061619],
              [-13.950902698099146, -10.843854836604615],
              [-13.951761362915908, -10.841376610025078],
              [-13.951852337296785, -10.839207574257959],
              [-13.953086706983653, -10.8368007203568],
              [-13.955725881489107, -10.836614968010222],
              [-13.957391369123366, -10.8357703214399],
              [-13.958180786809123, -10.832956608348521],
              [-13.958189550582729, -10.831759649662285],
              [-13.959275981588199, -10.831397588897412],
              [-13.960810903888163, -10.832384822276511],
              [-13.964101327305524, -10.831370997114437],
              [-13.965530404995361, -10.831675696119094],
              [-13.967850255437495, -10.830734566738855],
              [-13.970039727617623, -10.827816436161694],
              [-13.9724246953966, -10.827397388038397],
              [-13.972564207177339, -10.826111992182677],
              [-13.975088068399579, -10.825693211865875],
              [-13.976009254549309, -10.824220862541758],
              [-13.977998679652714, -10.823602030910012],
              [-13.98069718051834, -10.824017830946202],
              [-13.980750016734556, -10.822966248691055],
              [-13.982119289400904, -10.820297334147044],
              [-13.984766866463383, -10.817279162589553],
              [-13.98874571105477, -10.810980779243653],
              [-13.99023296476501, -10.80912792082667],
              [-13.989899105567424, -10.807336321371567],
              [-13.990765352877549, -10.806002386536877],
              [-13.990774160628545, -10.804655727955572],
              [-13.989843438782806, -10.804013136638403],
              [-13.990971289264262, -10.802506216941653],
              [-13.99052344673998, -10.799323266045],
              [-13.991063201801042, -10.798013101056993],
              [-13.990205936462898, -10.797210034353999],
              [-13.990427358205588, -10.795574112424296],
              [-13.995412336147327, -10.794263685744944],
              [-14.000391472505841, -10.791691995768463],
              [-14.000860001065648, -10.790577054672966],
              [-14.002959214567914, -10.790037927386601],
              [-14.003645736685204, -10.78907325628312],
              [-14.006100994472282, -10.788518587483876],
              [-14.009333680793308, -10.788471133723991],
              [-14.010245799365048, -10.788806220131065],
              [-14.012402222650076, -10.791299975930063],
              [-14.01416534198095, -10.79131538221541],
              [-14.01627559652269, -10.790607337082397],
              [-14.018437597983496, -10.788004635243267],
              [-14.020299249049772, -10.78735125488329],
              [-14.022823012095877, -10.787250348515494],
              [-14.024094805107733, -10.786651337762775],
              [-14.026803747997883, -10.787003689829154],
              [-14.026500600528781, -10.784890586179422],
              [-14.026897207872175, -10.78395691680173],
              [-14.028915435957492, -10.783556951629931],
              [-14.029506592137349, -10.782395430861138],
              [-14.03092609461852, -10.781216301269495],
              [-14.03196710035607, -10.781678001297486],
              [-14.037113943087258, -10.782310297428772],
              [-14.040544585616784, -10.783677498757042],
              [-14.043175039947208, -10.784329046701938],
              [-14.047508052393075, -10.783917137914356],
              [-14.047955909413206, -10.784988498421537],
              [-14.050895782723115, -10.78390848786532],
              [-14.051566922191546, -10.787173405521697],
              [-14.053814429635525, -10.788604883670407],
              [-14.055450133737052, -10.788313827866501],
              [-14.056933431110547, -10.788902367219439],
              [-14.058066893522351, -10.788630034119011],
              [-14.058408598549322, -10.786671762496823],
              [-14.059552333863246, -10.784427542597605],
              [-14.05935013307323, -10.783040585550182],
              [-14.060077663328164, -10.782048715591545],
              [-14.061072473236159, -10.782528762322967],
              [-14.063274956581719, -10.7818840898432],
              [-14.064748759954723, -10.783170617247201],
              [-14.067337780626334, -10.783214839233056],
              [-14.068075604317535, -10.781854597834773],
              [-14.067753709640565, -10.780748750214542],
              [-14.069218345380156, -10.779261391585614],
              [-14.070305803065851, -10.77884401931103],
              [-14.070590694864864, -10.780538989012758],
              [-14.071898476678589, -10.782170042679198],
              [-14.071491273777504, -10.78589156122259],
              [-14.072255625823248, -10.786906518236776],
              [-14.07217163548917, -10.789114045389466],
              [-14.073332057222455, -10.790201364360893],
              [-14.074867097727852, -10.790806488821634],
              [-14.077547370983655, -10.790939042635069],
              [-14.078059017475287, -10.787506045307373],
              [-14.07949820560437, -10.786148971279266],
              [-14.080824966021416, -10.786202936703708],
              [-14.082953849801587, -10.785395122366383],
              [-14.084448246251025, -10.781664246227773],
              [-14.086078101645676, -10.781926277876652],
              [-14.08939387376679, -10.784943681060565],
              [-14.091969231469553, -10.78561263800252],
              [-14.094262852998028, -10.784693271662254],
              [-14.097825066995131, -10.782202060678275],
              [-14.101362613187685, -10.783732600795904],
              [-14.106567861076499, -10.782615351572357],
              [-14.11023820650634, -10.784453662966818],
              [-14.113518183217943, -10.78493276092154],
              [-14.115697561390244, -10.784886256646182],
              [-14.117451942911856, -10.783727496741786],
              [-14.117255730426894, -10.782365574026628],
              [-14.117588525362628, -10.78015331234347],
              [-14.120163710301894, -10.78025203736098],
              [-14.121112858038707, -10.779839186632929],
              [-14.122126017510142, -10.780628697880724],
              [-14.122283422465527, -10.78202727872626],
              [-14.124520310743469, -10.783321193780338],
              [-14.127495158612394, -10.783306971123274],
              [-14.131316763787893, -10.781823443716904],
              [-14.133046075178727, -10.778817399229872],
              [-14.135181311656945, -10.778887616268428],
              [-14.135969961072487, -10.781127486469332],
              [-14.137140985488696, -10.782189023322887],
              [-14.139814265909726, -10.781893171580997],
              [-14.14008256260558, -10.781790970938546],
              [-14.142529850114125, -10.776950903362302],
              [-14.138789877805156, -10.772760641103506],
              [-14.148630675939726, -10.74242951577926],
              [-14.156800388290572, -10.712567184277146],
              [-14.13740109237649, -10.713199442310565],
              [-14.135771738158065, -10.712491539332559],
              [-14.127249413626073, -10.705149811709385],
              [-14.121434108869042, -10.682183626144544],
              [-14.124917318519937, -10.670562707003395],
              [-14.148092509810528, -10.662318220176854],
              [-14.12442532396344, -10.64156944088851],
              [-14.085702606380284, -10.623107813397162],
              [-14.052268788271865, -10.589555317142457]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -135.5002761571729, "lat": 59.120028232416 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02100"],
        "coty_name": ["Haines"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Haines Borough"],
        "coty_fp_code": "100",
        "coty_gnis_code": "01419970"
      },
      "bbox": [
        -14.156800388290572, -11.068452869930429, -13.738280328151673,
        -10.589555317142457
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-13.684339602700112, -11.309921824734637],
              [-13.683892261035679, -11.30874956799545],
              [-13.679672349724115, -11.30887962230704],
              [-13.680256434915599, -11.309861810886925],
              [-13.681386853590322, -11.309622751904758],
              [-13.683743321394394, -11.310264463300584],
              [-13.684339602700112, -11.309921824734637]
            ]
          ],
          [
            [
              [-13.724719792390188, -11.463794017567084],
              [-13.723024441930482, -11.464242066003816],
              [-13.72358998969723, -11.465708630632951],
              [-13.724719792390188, -11.463794017567084]
            ]
          ],
          [
            [
              [-13.734011019131545, -11.458918669377702],
              [-13.733623540090534, -11.458541275986011],
              [-13.730432043456325, -11.458452582387727],
              [-13.728049091815759, -11.460054281953688],
              [-13.7294484823369, -11.461605671327472],
              [-13.728595086371435, -11.462982474778455],
              [-13.734027802581437, -11.459659017328615],
              [-13.734011019131545, -11.458918669377702]
            ]
          ],
          [
            [
              [-13.744720777037843, -11.453008163360323],
              [-13.744596128270999, -11.4510326842663],
              [-13.742816450978696, -11.451676785915112],
              [-13.741817565671692, -11.453638390824151],
              [-13.74418680235587, -11.453919533338526],
              [-13.744720777037843, -11.453008163360323]
            ]
          ],
          [
            [
              [-13.722655508932707, -11.532361868545228],
              [-13.722300830826596, -11.530521116104426],
              [-13.721160867332095, -11.531084756830651],
              [-13.720998228176711, -11.533161431262352],
              [-13.722655508932707, -11.532361868545228]
            ]
          ],
          [
            [
              [-13.75292311639058, -11.43579987418612],
              [-13.752550629584462, -11.434582803629864],
              [-13.751383156960294, -11.43333327568324],
              [-13.75038665912423, -11.433594327789061],
              [-13.750950081048527, -11.435558289965591],
              [-13.750922137859023, -11.437223307999496],
              [-13.752234748138351, -11.436853636944114],
              [-13.75292311639058, -11.43579987418612]
            ]
          ],
          [
            [
              [-13.731763653112576, -11.515850721461756],
              [-13.730666825830903, -11.51561885168977],
              [-13.729300764408839, -11.5171744288804],
              [-13.72817301848496, -11.519329744870769],
              [-13.730069167151813, -11.519049588768915],
              [-13.73132197473275, -11.517537547145048],
              [-13.731763653112576, -11.515850721461756]
            ]
          ],
          [
            [
              [-13.728187370446477, -11.538165105845644],
              [-13.727378842710548, -11.536317499463353],
              [-13.726031492513092, -11.536001781539861],
              [-13.725058400787331, -11.536895850058638],
              [-13.725175138501628, -11.542732576668948],
              [-13.72624708962672, -11.542999769785727],
              [-13.728187370446477, -11.538165105845644]
            ]
          ],
          [
            [
              [-13.756714584272446, -11.446738382010752],
              [-13.75606038291149, -11.443630966041873],
              [-13.753386824315367, -11.443375709065316],
              [-13.752420697626407, -11.445223492837295],
              [-13.751240692950669, -11.445630674871566],
              [-13.750246642642857, -11.44683414762182],
              [-13.75056735447431, -11.44879770363106],
              [-13.7490083574964, -11.451225500908441],
              [-13.749783677999751, -11.452106045318484],
              [-13.750860903420891, -11.450511736550611],
              [-13.751660379967351, -11.450646727411645],
              [-13.752665019158512, -11.452059728236248],
              [-13.754523064160193, -11.450476108207559],
              [-13.75478148802299, -11.449474251705961],
              [-13.756094531316426, -11.448169127291346],
              [-13.756714584272446, -11.446738382010752]
            ]
          ],
          [
            [
              [-13.760130277958257, -11.450364240217208],
              [-13.759064575832054, -11.45059784909128],
              [-13.758331105108708, -11.452219603096177],
              [-13.759264297644712, -11.45272490208455],
              [-13.760130277958257, -11.450364240217208]
            ]
          ],
          [
            [
              [-13.734406638852912, -11.539608113299344],
              [-13.73277910735736, -11.538978765665666],
              [-13.73057113502945, -11.536170176565367],
              [-13.72935299162676, -11.536167410924946],
              [-13.729290789323086, -11.53795126085796],
              [-13.730281914491638, -11.538544064914804],
              [-13.73019809332985, -11.541597866772864],
              [-13.731232666440583, -11.542062919398012],
              [-13.732285101728447, -11.541038457294036],
              [-13.734155099916624, -11.540479057559471],
              [-13.734406638852912, -11.539608113299344]
            ]
          ],
          [
            [
              [-13.776491736461352, -11.40845314467616],
              [-13.77413571718947, -11.405779664291025],
              [-13.773166999440587, -11.403938989161947],
              [-13.773019569968076, -11.400893316566496],
              [-13.770937579775197, -11.399622695116825],
              [-13.767698525384786, -11.399721292670769],
              [-13.76580059404184, -11.40078242262468],
              [-13.765162565669696, -11.399858743376658],
              [-13.763505451566694, -11.398912309974405],
              [-13.762276853572734, -11.399170148258737],
              [-13.760549063448046, -11.397423943217667],
              [-13.755937433638149, -11.397433041066831],
              [-13.757306369441872, -11.398697710961935],
              [-13.75732509571685, -11.399656371025996],
              [-13.756029268563646, -11.401172000969618],
              [-13.754715824436586, -11.40616325728149],
              [-13.755047892067152, -11.409778883121568],
              [-13.755927418375448, -11.411599787103562],
              [-13.75670517308262, -11.415486856966176],
              [-13.758688295323182, -11.417986789636505],
              [-13.75715980352753, -11.419483347916264],
              [-13.75482192598708, -11.4199901492559],
              [-13.755485353304211, -11.420876809920355],
              [-13.758410210576397, -11.419669900695775],
              [-13.761138170272545, -11.42040806208659],
              [-13.763427676163174, -11.419361809501389],
              [-13.764530960419956, -11.417772494153121],
              [-13.767080037554411, -11.416466366457122],
              [-13.770799708637307, -11.41389498662948],
              [-13.774456453294441, -11.412255637918065],
              [-13.776566725513998, -11.40933331408789],
              [-13.776491736461352, -11.40845314467616]
            ]
          ],
          [
            [
              [-13.749676443875805, -11.53558414907798],
              [-13.748863854035791, -11.533988284199788],
              [-13.749801276063534, -11.532718516112048],
              [-13.749753274145052, -11.531244286372859],
              [-13.748477906763654, -11.530032493058282],
              [-13.747554674602016, -11.530935214512386],
              [-13.744230729832125, -11.531491801543531],
              [-13.74317034267109, -11.530413498539568],
              [-13.741672121744319, -11.533306936987607],
              [-13.740260707843982, -11.53240070756615],
              [-13.740596994359706, -11.530195972740694],
              [-13.738798478995678, -11.531121884942243],
              [-13.738438178935722, -11.53269406083948],
              [-13.739398324966839, -11.535348391149574],
              [-13.741975028010017, -11.534249818203458],
              [-13.741764451443355, -11.53780549411406],
              [-13.743761632706397, -11.540548597870515],
              [-13.74473931859858, -11.539022981835991],
              [-13.745337905874345, -11.5364172255427],
              [-13.7479959003057, -11.537928148974071],
              [-13.749676443875805, -11.53558414907798]
            ]
          ],
          [
            [
              [-13.5248015988479, -11.685535123235084],
              [-13.515932181017426, -11.714408103208042],
              [-13.51711248185515, -11.716469103585887],
              [-13.517746521611636, -11.715185131713554],
              [-13.519599017084143, -11.713547586892973],
              [-13.520901603372867, -11.713076014322912],
              [-13.522142062233536, -11.713913364396543],
              [-13.5240825900405, -11.714197541026387],
              [-13.52390504459208, -11.71130206259981],
              [-13.525902763038154, -11.712029096628385],
              [-13.526048640676157, -11.71060279290756],
              [-13.525198156873651, -11.709595852651455],
              [-13.523183467323356, -11.704978773897603],
              [-13.523927521734299, -11.702544267401134],
              [-13.525591785293685, -11.702463683159918],
              [-13.52644151815137, -11.701102599801104],
              [-13.528556719510837, -11.699070255774467],
              [-13.527521142690196, -11.696778687278483],
              [-13.52729565888884, -11.694204025905012],
              [-13.529326008833356, -11.694656864194897],
              [-13.529494173865737, -11.696315381440494],
              [-13.531626840547833, -11.697696860692915],
              [-13.532601097863816, -11.699875013092079],
              [-13.533474538632742, -11.703018166001899],
              [-13.534492705491894, -11.703315716742361],
              [-13.538953136512399, -11.702914143437424],
              [-13.54090082566242, -11.70348242129682],
              [-13.541731447193378, -11.702494158033605],
              [-13.543854240873179, -11.701693512628776],
              [-13.54374260645536, -11.700951182423402],
              [-13.540684057477097, -11.699443836923026],
              [-13.540991661224862, -11.697641121894474],
              [-13.54230647643247, -11.698545125358988],
              [-13.546664674778627, -11.699578879322987],
              [-13.547321714510737, -11.698209311646563],
              [-13.548694917842269, -11.699555332587963],
              [-13.549842334647613, -11.69799725980776],
              [-13.547920809413833, -11.69370152197135],
              [-13.54879533001659, -11.693199962699579],
              [-13.549071140744402, -11.691341448552565],
              [-13.548523328841409, -11.688392671868234],
              [-13.547986961871858, -11.6871489859236],
              [-13.54796673435117, -11.685157822371899],
              [-13.549079595589047, -11.684820754857569],
              [-13.551148101486676, -11.688306498787338],
              [-13.55096659930027, -11.69080630224743],
              [-13.551825332968459, -11.69162357548205],
              [-13.552346297233196, -11.693713581830824],
              [-13.554805289242886, -11.69211258382182],
              [-13.555655028498926, -11.690421820202863],
              [-13.555628887182808, -11.688287557105086],
              [-13.556215767625657, -11.687938327065217],
              [-13.55571746794363, -11.686092071732224],
              [-13.557891008375856, -11.686062881701702],
              [-13.560050222652475, -11.685604160139956],
              [-13.5609732824774, -11.683510223756128],
              [-13.561144821686414, -11.68119856659797],
              [-13.562899541107, -11.680008674523021],
              [-13.56469567548253, -11.67963307392638],
              [-13.565689360806402, -11.67793867783507],
              [-13.567118372189086, -11.677503866702294],
              [-13.568379009763229, -11.678577913366842],
              [-13.571225104569887, -11.678223290963944],
              [-13.572078356370485, -11.677149202948254],
              [-13.573295056391057, -11.678209604599378],
              [-13.575296986859497, -11.67619406303904],
              [-13.575518254549307, -11.674984393535945],
              [-13.574808848981261, -11.673835174838842],
              [-13.575709094010517, -11.67244484788375],
              [-13.576262684644213, -11.67029388805649],
              [-13.577460562269328, -11.668235742646928],
              [-13.578953305889636, -11.667583647671117],
              [-13.580361358519795, -11.665303758897918],
              [-13.582826166361397, -11.664131548564043],
              [-13.58309297654301, -11.660862501462242],
              [-13.583754752459935, -11.659782007260752],
              [-13.585074591252736, -11.66049358615132],
              [-13.58833218919644, -11.660822935032728],
              [-13.589589896553006, -11.660149678749647],
              [-13.591907841312663, -11.656909925061992],
              [-13.59007382375047, -11.656474250755531],
              [-13.589691130008942, -11.652972788643007],
              [-13.59042521901513, -11.650218611062131],
              [-13.593393854500599, -11.649429005947377],
              [-13.595379577948375, -11.648401971498444],
              [-13.599241580721433, -11.64575189697972],
              [-13.59859725940426, -11.643119625435004],
              [-13.600115006959777, -11.642052331744942],
              [-13.601838749506685, -11.641890908259162],
              [-13.603132798305108, -11.641088528027332],
              [-13.604351276204875, -11.638148077320322],
              [-13.605333808571716, -11.637585095287058],
              [-13.605548639730698, -11.635437365122701],
              [-13.607766199940285, -11.634901257971716],
              [-13.609836980147007, -11.633100942987552],
              [-13.610110249492712, -11.631393877785436],
              [-13.611599699223422, -11.630413195986955],
              [-13.613063574408384, -11.62872063090235],
              [-13.613956466997047, -11.628930706323189],
              [-13.615409922642597, -11.62615512914645],
              [-13.617168159764498, -11.62379642722592],
              [-13.61805953408381, -11.62114213699555],
              [-13.619185792016902, -11.618978068794908],
              [-13.621172445472789, -11.616968259752337],
              [-13.624422493939107, -11.617432897851618],
              [-13.62534803810827, -11.616572745460923],
              [-13.625953301410455, -11.613275268519946],
              [-13.625266237669551, -11.611107955128348],
              [-13.624442045417833, -11.610355362826464],
              [-13.627483908026079, -11.606727620876537],
              [-13.628868691230878, -11.603375331373229],
              [-13.628892229126517, -11.60122624520988],
              [-13.627994348254168, -11.598812697589558],
              [-13.628229729103925, -11.597708738745055],
              [-13.626573152994311, -11.595920539600378],
              [-13.626375555644668, -11.594036540423907],
              [-13.622541258201286, -11.589981406575577],
              [-13.622744856330977, -11.587557722704656],
              [-13.620433210625292, -11.587640985385086],
              [-13.619779669279099, -11.588389289165086],
              [-13.616433445337853, -11.588267409030193],
              [-13.615389161878651, -11.587778724205517],
              [-13.613547022553702, -11.58471699643024],
              [-13.613434408547114, -11.582716842754875],
              [-13.615747003013592, -11.581839153070606],
              [-13.618364163790972, -11.583906029925016],
              [-13.618870142862349, -11.583490150336539],
              [-13.618474228835819, -11.580846961206337],
              [-13.619807188044726, -11.579264840939123],
              [-13.621741761180164, -11.578371838962415],
              [-13.623865578754893, -11.578749949896949],
              [-13.62585585787973, -11.578621233044048],
              [-13.62947427929365, -11.57956952721385],
              [-13.629137388535085, -11.582280994696493],
              [-13.630044264232447, -11.583384282430458],
              [-13.629607981081529, -11.584522592312839],
              [-13.63170593269534, -11.587373243229534],
              [-13.632538481783776, -11.590000125457454],
              [-13.633428421627718, -11.590209181311607],
              [-13.63610138491009, -11.593692035380272],
              [-13.636916734211532, -11.593832125281518],
              [-13.638106867821959, -11.595906333520455],
              [-13.640517621130606, -11.596924924978012],
              [-13.644262416323466, -11.597622270638286],
              [-13.645972358868908, -11.599234941481464],
              [-13.646955271246581, -11.598813560976252],
              [-13.646618079116445, -11.594831523188265],
              [-13.647674501611633, -11.593682604288414],
              [-13.646501558548241, -11.591708932500671],
              [-13.647250119562358, -11.589676834756991],
              [-13.647305336510394, -11.588055072590128],
              [-13.649523053592752, -11.585882039593395],
              [-13.65017506638474, -11.58321530221307],
              [-13.64993927117542, -11.58193183062373],
              [-13.653856804204178, -11.582350403208812],
              [-13.653783921195139, -11.577326829448424],
              [-13.654950885052024, -11.575323546299703],
              [-13.65380519641784, -11.57326677988359],
              [-13.654800981348739, -11.572476431524885],
              [-13.654436697267526, -11.568914726506243],
              [-13.657105296686044, -11.568089056691447],
              [-13.659165783739327, -11.571060397146079],
              [-13.661208726248596, -11.57201721282607],
              [-13.661216710965615, -11.573748148846693],
              [-13.660409450127155, -11.574545806350278],
              [-13.661354038935636, -11.575843345520989],
              [-13.66041659348292, -11.577398222184641],
              [-13.66193157229225, -11.577736993431023],
              [-13.663329367400944, -11.578789936263723],
              [-13.66443047349155, -11.578122380444615],
              [-13.665598662612652, -11.578829100546436],
              [-13.666235591311661, -11.580365708700722],
              [-13.669078202319064, -11.578791659077082],
              [-13.669879303310129, -11.577851972579252],
              [-13.671795699521613, -11.576995567008213],
              [-13.672797318797718, -11.576019437826254],
              [-13.672457554451022, -11.573961373745613],
              [-13.671471915910102, -11.57087906649215],
              [-13.669801017772825, -11.569469618648348],
              [-13.668008218722516, -11.568631925405729],
              [-13.668065925602914, -11.565240310671506],
              [-13.667203921509731, -11.563827390863299],
              [-13.667353909597791, -11.56284320155871],
              [-13.66949712362745, -11.560420549268041],
              [-13.672013953812067, -11.562490789457403],
              [-13.672351243703064, -11.563753572457273],
              [-13.67172726694968, -11.565392022126296],
              [-13.672607230981086, -11.567096143893],
              [-13.673673647856003, -11.567065452234562],
              [-13.673956367356814, -11.568706044537844],
              [-13.676399879717003, -11.568439273107236],
              [-13.676744439486484, -11.570821991714615],
              [-13.678561979181802, -11.57066372313574],
              [-13.679196409019491, -11.570002950783465],
              [-13.681577804836598, -11.571696980335913],
              [-13.682591821218884, -11.571797978634029],
              [-13.684501271817822, -11.573366316466737],
              [-13.68528418092724, -11.572001370498214],
              [-13.684662859750368, -11.570891749549215],
              [-13.686533050698218, -11.568575712526098],
              [-13.685265565139542, -11.56644340698767],
              [-13.68941491368666, -11.565240388479591],
              [-13.68994012665223, -11.563943562652742],
              [-13.691864129664442, -11.564814613261522],
              [-13.691924285714622, -11.562360377049668],
              [-13.69351872444326, -11.56113339857852],
              [-13.694131865554994, -11.558090355189512],
              [-13.69160096206319, -11.556068442900795],
              [-13.69301423729452, -11.554651158201604],
              [-13.689322023443781, -11.553837522032582],
              [-13.68721310694659, -11.551514680266425],
              [-13.68749984914392, -11.550384437598828],
              [-13.6889848298398, -11.549687580092874],
              [-13.68916592960396, -11.548434344437899],
              [-13.694052321869231, -11.54744362326171],
              [-13.695237740993143, -11.547919325528293],
              [-13.69651608343717, -11.54711713069382],
              [-13.697109150340893, -11.545748131096511],
              [-13.69946351544939, -11.547718211789043],
              [-13.698624461731548, -11.551207149819756],
              [-13.698032658852634, -11.552251050473407],
              [-13.698470436012771, -11.553819030801007],
              [-13.700602981935596, -11.558801953214283],
              [-13.701572052487611, -11.558889433610595],
              [-13.70334439991481, -11.55640776855334],
              [-13.70430145643248, -11.5526719942377],
              [-13.704124191572493, -11.551504083073416],
              [-13.705775896168149, -11.551039348052404],
              [-13.706682082688278, -11.549246198562056],
              [-13.708397973971739, -11.550009749085032],
              [-13.711471208357638, -11.55259946072952],
              [-13.712508757402366, -11.552612251248558],
              [-13.713510590251714, -11.550930946509506],
              [-13.712194681058477, -11.548834989460094],
              [-13.711987946867437, -11.544847473581004],
              [-13.712815337635199, -11.542824150767302],
              [-13.714988449567324, -11.542843167988071],
              [-13.715818929388568, -11.541995216441448],
              [-13.718123384720274, -11.541811933386422],
              [-13.71857450402055, -11.537250113876807],
              [-13.716383345328472, -11.534661791988295],
              [-13.715570940247256, -11.535014193586521],
              [-13.713911975761503, -11.533662695001397],
              [-13.714713741015833, -11.532703048664608],
              [-13.717427962213824, -11.530702044053072],
              [-13.715683742289242, -11.528838770969704],
              [-13.715794699764627, -11.527336252191889],
              [-13.717557491954201, -11.527043478329096],
              [-13.718086555240015, -11.525403184656527],
              [-13.718096849124027, -11.523036518299314],
              [-13.716240758967519, -11.522443139871926],
              [-13.716615038319398, -11.520527732291157],
              [-13.717335876969702, -11.520243324071592],
              [-13.718959688289525, -11.518332088635791],
              [-13.721459934275027, -11.51801538485392],
              [-13.721811039991035, -11.516256872884773],
              [-13.718975427721047, -11.515387402427695],
              [-13.718558372295279, -11.514317640758826],
              [-13.719812427357125, -11.513743030029042],
              [-13.720130328149448, -11.512741522887714],
              [-13.717299186086928, -11.513544450614374],
              [-13.716319350172165, -11.513105021009418],
              [-13.716037847568478, -11.51165593525694],
              [-13.71777194476683, -11.51105439005982],
              [-13.719093861200767, -11.509686786717136],
              [-13.721600622730842, -11.509744281204876],
              [-13.721980288270872, -11.508853159487632],
              [-13.720974429104693, -11.50794275514555],
              [-13.722006553396445, -11.506516812532753],
              [-13.720004091490946, -11.506670981123957],
              [-13.715977836662129, -11.50592826818361],
              [-13.714684439020417, -11.506235879214364],
              [-13.712654812648971, -11.507681292223957],
              [-13.711407559857749, -11.508071461709243],
              [-13.70982520575059, -11.50959733564865],
              [-13.708864880564542, -11.509093306751469],
              [-13.708787529934192, -11.507515513538877],
              [-13.709451761114485, -11.505823194968798],
              [-13.710764947681284, -11.506009285908588],
              [-13.7120254966195, -11.505414053357754],
              [-13.712550090666545, -11.50347359510827],
              [-13.714740825722311, -11.502120730158],
              [-13.716868802078343, -11.499938172160162],
              [-13.717700978595042, -11.499593525243077],
              [-13.718223601980403, -11.497978340128343],
              [-13.72316258172197, -11.497610541002414],
              [-13.724163764233559, -11.496849702530275],
              [-13.726194880451532, -11.496912646460563],
              [-13.728011270336932, -11.495940825296358],
              [-13.729763142890606, -11.495669891214012],
              [-13.72995544478088, -11.494773422615392],
              [-13.728324636392156, -11.494151750904608],
              [-13.726464529675479, -11.494229892307875],
              [-13.725913865359402, -11.493378834848833],
              [-13.726765511595646, -11.490559718500744],
              [-13.728567092797565, -11.490117855979376],
              [-13.728853315459457, -11.489062901695666],
              [-13.727244929490258, -11.488447166495614],
              [-13.728362898817702, -11.486885687881292],
              [-13.72757204649405, -11.485411267155621],
              [-13.729615721380549, -11.482860732247536],
              [-13.728477593786426, -11.481288633949358],
              [-13.726005443732232, -11.481053934342633],
              [-13.723284727461806, -11.48158245785561],
              [-13.72215898495406, -11.48100947927774],
              [-13.718235779211767, -11.48066416837269],
              [-13.717579776199146, -11.48001507766671],
              [-13.715186569219892, -11.480148068353337],
              [-13.715643577420785, -11.477960544691081],
              [-13.716642882869255, -11.476807295226356],
              [-13.722835694063667, -11.477911357567342],
              [-13.724074646024928, -11.477219416996883],
              [-13.726743495325435, -11.477904151250597],
              [-13.728178577159944, -11.473424234304582],
              [-13.727225567296978, -11.47338649724254],
              [-13.720995055403481, -11.47449567798491],
              [-13.720732343883206, -11.471156508477518],
              [-13.719785062821348, -11.471258652793441],
              [-13.714808839840295, -11.468273674118096],
              [-13.710393440613863, -11.467136321989557],
              [-13.708644027226342, -11.467403491544532],
              [-13.707518597837192, -11.464767618062172],
              [-13.707653078194832, -11.46343949794774],
              [-13.707069721987663, -11.461675945531752],
              [-13.705252482890634, -11.458681505935846],
              [-13.704345365272523, -11.45833051402411],
              [-13.70117124808268, -11.459278741975643],
              [-13.700365439748882, -11.460647007834355],
              [-13.697594485132761, -11.461501466895344],
              [-13.693528483431434, -11.463306339150224],
              [-13.690305118667697, -11.46243215770864],
              [-13.689865802924135, -11.460823649147938],
              [-13.69257993491105, -11.460718632856645],
              [-13.693797775220787, -11.459630139833404],
              [-13.695237080146567, -11.459299846389888],
              [-13.69648248757176, -11.458196499628034],
              [-13.698131925284478, -11.457949194432352],
              [-13.700092479319762, -11.457049236824608],
              [-13.702155196252116, -11.455090785338822],
              [-13.705713751179147, -11.45450732285426],
              [-13.706852975040972, -11.453836359698855],
              [-13.707758919981574, -11.457126143853495],
              [-13.710118509075087, -11.460274012094455],
              [-13.711606451110491, -11.459377423225272],
              [-13.713251667188477, -11.459219803877247],
              [-13.714627312215036, -11.461485248808145],
              [-13.716031668137582, -11.460472159334387],
              [-13.717080280461483, -11.461139735911207],
              [-13.717959515337498, -11.460232000944842],
              [-13.716930651617101, -11.459338508950175],
              [-13.717037921867746, -11.45816383053724],
              [-13.7180369079514, -11.457552801071794],
              [-13.721953765655453, -11.458536151134679],
              [-13.722548756681954, -11.459350675038278],
              [-13.725034024287467, -11.45804357327989],
              [-13.727077002494529, -11.459709204781165],
              [-13.72988824898039, -11.457694507026511],
              [-13.729977676769586, -11.456385449556105],
              [-13.731914375977986, -11.45553163390577],
              [-13.733868909363428, -11.455251549375976],
              [-13.735790569818882, -11.45248882134343],
              [-13.736882713111061, -11.45212698906107],
              [-13.738070301569168, -11.450082123141224],
              [-13.740352633149612, -11.448623353263025],
              [-13.74266209045821, -11.446110430577756],
              [-13.743931153133117, -11.44538270258908],
              [-13.74429164736282, -11.443914041866272],
              [-13.743780039930801, -11.440144695684415],
              [-13.744199531166545, -11.43671967923851],
              [-13.742908733461078, -11.435847768974872],
              [-13.740904907882612, -11.433574139094357],
              [-13.743297491441103, -11.43069591109457],
              [-13.743445295706758, -11.429076514074389],
              [-13.740384509713945, -11.425304914237602],
              [-13.737733015445638, -11.421741181636634],
              [-13.735278344705433, -11.420215899860393],
              [-13.73297307260246, -11.419931886589538],
              [-13.730499003301796, -11.420061023896539],
              [-13.728106385709504, -11.4186440319154],
              [-13.728777595646543, -11.415420486108047],
              [-13.73021925291251, -11.415137565827813],
              [-13.733698934920655, -11.415247994426437],
              [-13.736591673946327, -11.41671332638498],
              [-13.739926020639166, -11.41604314124167],
              [-13.740282668964777, -11.414991136566039],
              [-13.741686162209897, -11.414835134138315],
              [-13.742272362196546, -11.416660563987243],
              [-13.741232582911861, -11.41701188360079],
              [-13.740204523268988, -11.419073024314018],
              [-13.742182463252844, -11.42078541281427],
              [-13.74214124445783, -11.42188072828829],
              [-13.745024945189702, -11.424816691558194],
              [-13.744380825300215, -11.426849261889744],
              [-13.746078181919131, -11.427928020881042],
              [-13.745905683409429, -11.429632371218462],
              [-13.746370830229983, -11.4312399480974],
              [-13.74773147940348, -11.431392817062104],
              [-13.750229438692415, -11.429744275733196],
              [-13.754500083975378, -11.424121504423491],
              [-13.753618727304763, -11.423135556220778],
              [-13.752618235222133, -11.42064102884326],
              [-13.752222517627047, -11.41863948853642],
              [-13.752443383253594, -11.417088641641566],
              [-13.751317054395034, -11.415664991459256],
              [-13.751468923143552, -11.414509737312835],
              [-13.750044075976366, -11.41378501008888],
              [-13.748902394018806, -11.411619730613108],
              [-13.74924097348706, -11.410148486070625],
              [-13.74877380528167, -11.40775896750703],
              [-13.749613720567115, -11.404265349233375],
              [-13.751082489282265, -11.40085798565281],
              [-13.749647041763478, -11.400176208997149],
              [-13.74867618673852, -11.399027065813778],
              [-13.748236278824985, -11.396232399502848],
              [-13.747442404679555, -11.394166515853033],
              [-13.748297687202777, -11.393165540835449],
              [-13.750786078335342, -11.392488397367938],
              [-13.751364624996551, -11.39449281194535],
              [-13.75290749429748, -11.394330157636052],
              [-13.757399618292931, -11.395736031917197],
              [-13.760829142609643, -11.39582841532568],
              [-13.763097352273759, -11.3978130447727],
              [-13.766321547302702, -11.399019665049472],
              [-13.769014519932114, -11.398177665309378],
              [-13.771093619215844, -11.397933821770547],
              [-13.774871564432203, -11.39954619069718],
              [-13.776752164151791, -11.399981239941305],
              [-13.77739017827748, -11.40227595255337],
              [-13.780027934924949, -11.404440526601235],
              [-13.780747249340791, -11.406619787048426],
              [-13.783979417185584, -11.408029877676197],
              [-13.784645532718846, -11.408630199449219],
              [-13.786707709002275, -11.406676584360998],
              [-13.786313500651147, -11.405784686472664],
              [-13.787455796084414, -11.404264202601086],
              [-13.789263679729842, -11.40334402085259],
              [-13.79063350142192, -11.401841492956974],
              [-13.79309891697001, -11.398200380772506],
              [-13.79392078665817, -11.397863964828707],
              [-13.79541355955844, -11.396002811741162],
              [-13.796800706350936, -11.395547138393368],
              [-13.798587712354381, -11.393721676026132],
              [-13.798409288337654, -11.3929903825994],
              [-13.79501978353978, -11.393437279970572],
              [-13.794552214637083, -11.392526847383536],
              [-13.792495825352797, -11.392000355984422],
              [-13.792793823621174, -11.390800000172424],
              [-13.794015298848661, -11.389867499922408],
              [-13.795263973672402, -11.390427745854513],
              [-13.799740270467872, -11.389231173252057],
              [-13.80053787285445, -11.38928539081553],
              [-13.805105562022447, -11.387094360542223],
              [-13.806860498671966, -11.386766050605859],
              [-13.807624032688382, -11.383101838235124],
              [-13.809090154330907, -11.383570811001686],
              [-13.811910213418699, -11.38319491080365],
              [-13.813595349478211, -11.381832915954046],
              [-13.81582275567518, -11.381051786834739],
              [-13.816897938683972, -11.378898093786745],
              [-13.818877061822048, -11.377200770964281],
              [-13.820439598510653, -11.377267424775559],
              [-13.821880764993814, -11.37404639479159],
              [-13.821177777031783, -11.372614118800712],
              [-13.821353271162065, -11.370234235284512],
              [-13.818353662786274, -11.370959798835282],
              [-13.816797014809403, -11.36974837377595],
              [-13.817287794265424, -11.368372629149484],
              [-13.814637690411374, -11.367727634890036],
              [-13.811809699158156, -11.367536744974004],
              [-13.811034816880454, -11.367000314187532],
              [-13.808379170702647, -11.36749818734954],
              [-13.806405393760624, -11.366444286166796],
              [-13.804462626311466, -11.367048524407604],
              [-13.802249322808057, -11.366659957727864],
              [-13.800164525657335, -11.36694928246458],
              [-13.798191160710633, -11.366214563337271],
              [-13.79643207028358, -11.366823252722321],
              [-13.793881244242948, -11.365513888415954],
              [-13.790997490457336, -11.365348874288614],
              [-13.789593975797127, -11.366331413412443],
              [-13.78838902389367, -11.365993821246445],
              [-13.785595636465283, -11.366632977999505],
              [-13.783831877288327, -11.36581689799122],
              [-13.78423967754422, -11.36473871124546],
              [-13.784195576262343, -11.362020090194363],
              [-13.785739087193164, -11.36199446763295],
              [-13.786991876799656, -11.362804566080529],
              [-13.789574764608243, -11.36256539244986],
              [-13.79214622601537, -11.361405926581035],
              [-13.793750181883478, -11.36180917689844],
              [-13.796320202977519, -11.361290425176312],
              [-13.801083671327454, -11.361384433831114],
              [-13.80420657988512, -11.359598281316723],
              [-13.808661531758831, -11.360428371566055],
              [-13.808919617142426, -11.362103990962217],
              [-13.81215817587959, -11.361998171013354],
              [-13.81356480673798, -11.360832271579651],
              [-13.814295191400586, -11.358791134974837],
              [-13.813484011282108, -11.357741034384079],
              [-13.811745448847219, -11.357485809888795],
              [-13.810873103268703, -11.354403725861355],
              [-13.807729226407114, -11.351466485844028],
              [-13.80839891328589, -11.350279758326055],
              [-13.80694392638441, -11.349690604009014],
              [-13.806791967943045, -11.34653530155664],
              [-13.80588409415698, -11.345503347040358],
              [-13.805443389591352, -11.343503865042965],
              [-13.80707030712162, -11.342539493682462],
              [-13.806286174319178, -11.340444055353949],
              [-13.806287236435935, -11.33884301219594],
              [-13.80364944344101, -11.338654815878206],
              [-13.801626619980425, -11.336990834893633],
              [-13.801339609034796, -11.335903621523656],
              [-13.801784196937925, -11.33342028713023],
              [-13.803192453766115, -11.33001796837744],
              [-13.804036009574592, -11.326961693155955],
              [-13.804988082980511, -11.325125186312153],
              [-13.8066197422568, -11.323662013440437],
              [-13.807675938515835, -11.321306707716909],
              [-13.809490953710604, -11.319529290513179],
              [-13.810037625964721, -11.317809309070729],
              [-13.808236529442132, -11.318264862139143],
              [-13.806768270092926, -11.316940010677982],
              [-13.804718030256279, -11.315863427058737],
              [-13.804187534234174, -11.314344109813165],
              [-13.80238423132305, -11.312422420738192],
              [-13.80178269289723, -11.309878215498314],
              [-13.80200440527799, -11.309118255905771],
              [-13.800967261092747, -11.307274526703182],
              [-13.800048461261008, -11.304550309380401],
              [-13.797379711382918, -11.30053823508818],
              [-13.79582736676318, -11.298813956908994],
              [-13.796110277952337, -11.297000322022287],
              [-13.792776453205803, -11.294104490650065],
              [-13.791562271063656, -11.295397750765316],
              [-13.790437986115966, -11.29541540216092],
              [-13.787642402074919, -11.294318897260439],
              [-13.786974672399861, -11.29351923950403],
              [-13.784119363200787, -11.293306694375598],
              [-13.782508642693971, -11.293902176425323],
              [-13.78086988339616, -11.293804424657115],
              [-13.779166452834692, -11.294556015106958],
              [-13.777142594889094, -11.294348914770568],
              [-13.776069471428796, -11.296421098977735],
              [-13.77398591489959, -11.297201792845641],
              [-13.771980530780281, -11.296771048743567],
              [-13.767724800817435, -11.30255880617359],
              [-13.766183428991658, -11.303539245412066],
              [-13.763459339522809, -11.304595582476948],
              [-13.763323881148978, -11.307256115351809],
              [-13.764044183673315, -11.309061371325585],
              [-13.765274828955183, -11.310554110802496],
              [-13.764976000751803, -11.311567644226894],
              [-13.766318872526789, -11.31268039836475],
              [-13.768043644544196, -11.313443351343926],
              [-13.770967192783399, -11.316284010665694],
              [-13.774182016757225, -11.31861142507467],
              [-13.775682013180193, -11.320774018940561],
              [-13.775624449501086, -11.321444198271815],
              [-13.778348481836979, -11.324501345107365],
              [-13.779598506400696, -11.326730294341306],
              [-13.781201644512466, -11.327914257092813],
              [-13.780531626617226, -11.330517891278662],
              [-13.777645144365797, -11.33355042860562],
              [-13.775110984932361, -11.33347697411595],
              [-13.77517367554622, -11.331205045947172],
              [-13.776096686054263, -11.328534935500263],
              [-13.775350277553686, -11.326172764853872],
              [-13.773743137578169, -11.326268267541067],
              [-13.771548318847096, -11.32441208390845],
              [-13.770475880793052, -11.319531507832231],
              [-13.767913725571384, -11.31798278012726],
              [-13.766553476968244, -11.317871972615517],
              [-13.764643083149014, -11.316003707424983],
              [-13.764476095898576, -11.314995002069754],
              [-13.761547652686787, -11.313432353695228],
              [-13.760665103964982, -11.314692548423691],
              [-13.759417777272127, -11.315299658371035],
              [-13.75827287092494, -11.31383002918524],
              [-13.7573894540785, -11.313991103711656],
              [-13.756064572071933, -11.312974109939752],
              [-13.752860663285583, -11.311559371137974],
              [-13.751754225700214, -11.309962877334979],
              [-13.749197392259486, -11.308090332791856],
              [-13.743671978826248, -11.308712532000788],
              [-13.74197593701889, -11.30941908263276],
              [-13.7395301753939, -11.313117957180367],
              [-13.73535634740955, -11.31371214153021],
              [-13.734891054110344, -11.314495613212046],
              [-13.735318941175628, -11.316496744810204],
              [-13.737344519483699, -11.318129498663929],
              [-13.739949529727973, -11.319377385985602],
              [-13.74015779360536, -11.32039936183188],
              [-13.741775517306575, -11.321685687892037],
              [-13.742498835684316, -11.326095386128918],
              [-13.740865105180234, -11.326009888244412],
              [-13.739713993537089, -11.32361867356562],
              [-13.736495070905068, -11.322241619824501],
              [-13.734586278492479, -11.319587569290373],
              [-13.732859025705494, -11.31913969651981],
              [-13.730787633564322, -11.319693139097987],
              [-13.730034141082474, -11.32034890807748],
              [-13.726955720160946, -11.320063763578602],
              [-13.723590008290325, -11.320429329463545],
              [-13.721519916845411, -11.321441090864116],
              [-13.719588333581138, -11.321207808003171],
              [-13.718090090945138, -11.322016460771424],
              [-13.716059936868097, -11.321800623745348],
              [-13.71380502431196, -11.3220243430904],
              [-13.71303460338815, -11.323822277759577],
              [-13.712055587825935, -11.324137473424946],
              [-13.711355954332268, -11.325542658167194],
              [-13.708593199096871, -11.325436774297769],
              [-13.706517047658076, -11.324747345890984],
              [-13.70562196777861, -11.321826862498483],
              [-13.701921329272311, -11.321586447725277],
              [-13.701385117257246, -11.319182270577247],
              [-13.699560516793454, -11.31702870693638],
              [-13.697094208420667, -11.316867355582195],
              [-13.696114202880954, -11.315680909856393],
              [-13.693320843848976, -11.314902968592767],
              [-13.691385067815927, -11.315673113054531],
              [-13.688614230277029, -11.314280632316585],
              [-13.68737989493422, -11.312419973714075],
              [-13.683901206978945, -11.312114522896215],
              [-13.680708672016369, -11.31369769928582],
              [-13.679466343751443, -11.31350451718311],
              [-13.676695302968016, -11.314374602749693],
              [-13.674479647455476, -11.314695474538082],
              [-13.673532641186496, -11.313156295276787],
              [-13.671858527620032, -11.312115982504626],
              [-13.671362451956885, -11.314047973997894],
              [-13.672573986356376, -11.31556274511252],
              [-13.670167345727165, -11.316381229624419],
              [-13.669990261823244, -11.317085927325229],
              [-13.670727857432801, -11.320600452174231],
              [-13.671474289938478, -11.321140272585444],
              [-13.67076687217657, -11.32242746499623],
              [-13.669737771085591, -11.322339411084169],
              [-13.66898697757999, -11.323801640559145],
              [-13.667655961776541, -11.323938548148531],
              [-13.665553930509752, -11.326059553110186],
              [-13.662383103932523, -11.332372670734504],
              [-13.66023532864962, -11.333449448740904],
              [-13.658872813989131, -11.335169890846778],
              [-13.65959560692966, -11.336945864564251],
              [-13.658481617861696, -11.338462739603356],
              [-13.65822984192839, -11.339908990318586],
              [-13.658623458512018, -11.342464630680526],
              [-13.65638504855257, -11.345716336789712],
              [-13.657507228727404, -11.346886077141665],
              [-13.656447509407576, -11.349111727084994],
              [-13.658219239011364, -11.349758884735943],
              [-13.658323992438078, -11.350838715180924],
              [-13.659412728122247, -11.351763974801111],
              [-13.661192119907803, -11.349096756483425],
              [-13.662400621985247, -11.348021653464137],
              [-13.662674849224773, -11.346057815385052],
              [-13.664967716816141, -11.345710717579232],
              [-13.666344751018844, -11.346464522902101],
              [-13.667092675169659, -11.345760466853632],
              [-13.670023613381206, -11.344607330700914],
              [-13.6721312896816, -11.34327356916999],
              [-13.673357276242252, -11.341357224594072],
              [-13.676872385692352, -11.339897489640382],
              [-13.677675321828355, -11.34017622107419],
              [-13.679221607641528, -11.342326980445641],
              [-13.677495901136012, -11.343713870610925],
              [-13.677547377920634, -11.345247693090208],
              [-13.679195901655367, -11.345356894240723],
              [-13.682091294269405, -11.343342066620016],
              [-13.685790191755162, -11.34206604984874],
              [-13.688860111568623, -11.342723193603097],
              [-13.690493877332942, -11.343655261132236],
              [-13.69281340713357, -11.344324844728613],
              [-13.695308473654864, -11.347988235666547],
              [-13.692906006149535, -11.348215593089758],
              [-13.689988690283553, -11.346269454897802],
              [-13.688087522023292, -11.346226386555527],
              [-13.684138071893107, -11.347247510884227],
              [-13.684015242631586, -11.349053051100931],
              [-13.684783870444088, -11.351622686594972],
              [-13.686816735895874, -11.352164173406488],
              [-13.687234087288354, -11.35357361956321],
              [-13.685115097562461, -11.3542504277246],
              [-13.683589753647093, -11.354039838105086],
              [-13.679160839229365, -11.356488963102503],
              [-13.679007386327298, -11.358240775336798],
              [-13.67954722448038, -11.359088095653936],
              [-13.678533541986432, -11.360591359731218],
              [-13.677282941220955, -11.360551911659483],
              [-13.676918563044259, -11.363626011836693],
              [-13.67803877026341, -11.364410974515657],
              [-13.677458309769785, -11.36571781277751],
              [-13.674547251858177, -11.36699541262124],
              [-13.673472198585108, -11.368389975586622],
              [-13.67113179966893, -11.368081196928115],
              [-13.670305535677636, -11.366320191841703],
              [-13.671768377194923, -11.365038171289564],
              [-13.66976916437213, -11.363444627437866],
              [-13.669895667643544, -11.362559408134423],
              [-13.671756836402052, -11.360886804226823],
              [-13.671775144762407, -11.358034929304306],
              [-13.673527639333608, -11.357805756023437],
              [-13.676283373063804, -11.355333463698791],
              [-13.67656287673142, -11.353940512033109],
              [-13.673978800882576, -11.353053626994988],
              [-13.673262165384319, -11.353260201595853],
              [-13.672571008392401, -11.355086642869388],
              [-13.670308457879157, -11.355766734802614],
              [-13.667528683661859, -11.355835337093886],
              [-13.66603688422269, -11.357521759508163],
              [-13.665828538308068, -11.35852141772218],
              [-13.66687080246344, -11.359561656014288],
              [-13.668135355171763, -11.361726324447899],
              [-13.66640015757658, -11.364219338026523],
              [-13.664731394484017, -11.364011511291265],
              [-13.665359818157432, -11.362395904554214],
              [-13.66254158192584, -11.3613465879553],
              [-13.659124247087577, -11.364134414930549],
              [-13.65892357877455, -11.364952593971609],
              [-13.656442206807244, -11.36773663778963],
              [-13.6568501358295, -11.36979314893609],
              [-13.655260486758076, -11.371176343492564],
              [-13.654874486081903, -11.374618200585761],
              [-13.65364157697492, -11.376059895668822],
              [-13.655636496740744, -11.377055593975522],
              [-13.657959824537416, -11.376346133380755],
              [-13.657451343737902, -11.380352980078202],
              [-13.656270588408047, -11.379917674160314],
              [-13.65523461293802, -11.380863198448363],
              [-13.653267913211241, -11.381630579828375],
              [-13.652137794845896, -11.38319541870966],
              [-13.650320105755666, -11.383313401332021],
              [-13.650129675719427, -11.385336717747744],
              [-13.648039487084535, -11.384959339813866],
              [-13.647111844610766, -11.387092015315956],
              [-13.645009000002851, -11.387218964171815],
              [-13.643439447014128, -11.390228341615098],
              [-13.640468527278731, -11.39352338232106],
              [-13.640788707857386, -11.394634300413994],
              [-13.642829741918996, -11.395645305001361],
              [-13.644155571257476, -11.397002657855174],
              [-13.64259509091668, -11.397658210613397],
              [-13.641179857326941, -11.400622689053439],
              [-13.639463472675866, -11.40132551608216],
              [-13.638917799214141, -11.399408034530166],
              [-13.637999101224551, -11.399649289256832],
              [-13.63682376937459, -11.40212883331232],
              [-13.636898023205852, -11.403122464381944],
              [-13.638673633536099, -11.404704607652048],
              [-13.6368191794391, -11.406015330579114],
              [-13.635502404556147, -11.405862767247472],
              [-13.634497201021315, -11.4065415267445],
              [-13.633864473946396, -11.408625595636876],
              [-13.633169905500012, -11.409210149938252],
              [-13.633261996892994, -11.410765103538772],
              [-13.632044467800837, -11.411058206808852],
              [-13.63089755378102, -11.413595289835202],
              [-13.629672306973495, -11.415461120944414],
              [-13.631850727413592, -11.416652862556324],
              [-13.629481771213712, -11.420270964102636],
              [-13.62723819448301, -11.419754961345664],
              [-13.624318156841552, -11.423166808504126],
              [-13.623658077176673, -11.425802375001613],
              [-13.621509836245503, -11.42791089905259],
              [-13.621064801518001, -11.429218908961106],
              [-13.62186223849564, -11.431864023983143],
              [-13.619772233727375, -11.431763905604297],
              [-13.618496808170137, -11.433942855671118],
              [-13.618843488149285, -11.435436651851077],
              [-13.621419741969348, -11.436885273449345],
              [-13.619463818070049, -11.437891843002655],
              [-13.617307552149981, -11.437076210047982],
              [-13.616143575477127, -11.438267583565265],
              [-13.616884685511819, -11.440480525062902],
              [-13.615040099994141, -11.44096271533148],
              [-13.613594180137836, -11.442304381648638],
              [-13.613100737628619, -11.443924953411349],
              [-13.613070822325056, -11.446192345080432],
              [-13.611949037596933, -11.447396971433188],
              [-13.611533657315439, -11.450156120927316],
              [-13.612830074562794, -11.451789791245812],
              [-13.612821874497621, -11.452902762607982],
              [-13.613992301198987, -11.453244809785497],
              [-13.613798054659929, -11.454814575623608],
              [-13.611210271743664, -11.45540606703439],
              [-13.609536510796897, -11.455009883351556],
              [-13.608288136828147, -11.45631798909358],
              [-13.608718083319726, -11.459558890333264],
              [-13.607547351124628, -11.461076614134619],
              [-13.60563423379088, -11.460377283423517],
              [-13.603590938274394, -11.463360805736867],
              [-13.603200347984634, -11.465107412739846],
              [-13.602284643621896, -11.466095372278879],
              [-13.600995338074446, -11.46846351744218],
              [-13.602809777863587, -11.46918092499161],
              [-13.605180010769175, -11.469315859018037],
              [-13.606247966428676, -11.470000531830433],
              [-13.603543654872821, -11.471117668665594],
              [-13.602962085002146, -11.47178516681547],
              [-13.60081710430014, -11.471995391866168],
              [-13.598098954049489, -11.471757884956924],
              [-13.597086514812489, -11.47383562673714],
              [-13.59507085558969, -11.475014727440021],
              [-13.59463119843576, -11.47707479154638],
              [-13.593874696377664, -11.47862289069698],
              [-13.594126117933554, -11.480280587857392],
              [-13.593273832413898, -11.481521821852857],
              [-13.5943559248691, -11.482165087285104],
              [-13.593642334112825, -11.484658505276714],
              [-13.591950875790513, -11.486166799196361],
              [-13.592607038626928, -11.487431070784789],
              [-13.591154104476505, -11.489242783226185],
              [-13.590657427513426, -11.491801456491624],
              [-13.591100522740158, -11.493610200767614],
              [-13.589790381125628, -11.49588450263305],
              [-13.588163413006328, -11.494847953590956],
              [-13.587444206362173, -11.497669204656178],
              [-13.585794794350871, -11.49779178484248],
              [-13.582751117014116, -11.49983840337197],
              [-13.58257926978239, -11.50272838981211],
              [-13.580340710640357, -11.503378264814899],
              [-13.579349958359368, -11.505841983726418],
              [-13.579530832127647, -11.50850973445378],
              [-13.578433155898633, -11.50837437032191],
              [-13.576456292722696, -11.512044062203355],
              [-13.576293364429185, -11.513818340665425],
              [-13.579038611069269, -11.514624227412074],
              [-13.578470792585698, -11.516326575771625],
              [-13.573761855656677, -11.517280440925884],
              [-13.573686508017794, -11.518613680641826],
              [-13.572429959786021, -11.51945960375955],
              [-13.57243263413324, -11.521003032025328],
              [-13.570801721153474, -11.520897937361644],
              [-13.57111433947802, -11.522205295380301],
              [-13.570458773502146, -11.523415362177204],
              [-13.568241536922969, -11.524446851130662],
              [-13.56833848579656, -11.527234937602636],
              [-13.56675845609627, -11.527425447854316],
              [-13.565447418137126, -11.52891079883661],
              [-13.564207633213456, -11.532336440524757],
              [-13.56512288004035, -11.533541626613674],
              [-13.563441047673082, -11.53421684599392],
              [-13.562198188536568, -11.53609808660546],
              [-13.562083296944117, -11.537094274332006],
              [-13.563060000689559, -11.538411555400453],
              [-13.561997094442765, -11.539550387782498],
              [-13.561365333241044, -11.54161206466473],
              [-13.560617288619065, -11.542188046232372],
              [-13.559372393382976, -11.545007030088387],
              [-13.560030723211629, -11.546277984687318],
              [-13.557389193375661, -11.547281133543851],
              [-13.556925938334174, -11.550190481732798],
              [-13.558239392569519, -11.552123749480794],
              [-13.556917731776776, -11.552859510859651],
              [-13.555690270526094, -11.554842206969397],
              [-13.555732710331656, -11.555792387169502],
              [-13.553801154100611, -11.557427530187102],
              [-13.553944972932598, -11.56084644540221],
              [-13.554888768409386, -11.561968145764887],
              [-13.553255571084879, -11.56247261162182],
              [-13.553073775353177, -11.5641548694416],
              [-13.554167099402006, -11.564945691923086],
              [-13.552734357121578, -11.56588470078206],
              [-13.55126747253533, -11.569112782980396],
              [-13.551537715625452, -11.569943388503122],
              [-13.551221506893476, -11.573933867153384],
              [-13.550497424430501, -11.574894422358877],
              [-13.549970634751777, -11.579106139017384],
              [-13.548527701120207, -11.583190647028252],
              [-13.547974763206339, -11.583591790985114],
              [-13.547509508919067, -11.587448376896585],
              [-13.548001835130162, -11.59036564646542],
              [-13.550279705259205, -11.58901439245168],
              [-13.552911064360508, -11.584009308986337],
              [-13.553601222340221, -11.581910865336527],
              [-13.554865006531717, -11.580122173441058],
              [-13.556839790395335, -11.57647697170303],
              [-13.558469858286688, -11.576298193138443],
              [-13.556902749635185, -11.580485600888355],
              [-13.557137225441316, -11.583935119743893],
              [-13.556452284230534, -11.585706638539682],
              [-13.55520585384984, -11.587595193033014],
              [-13.55492366515191, -11.590237116402118],
              [-13.554084826103814, -11.59172961204711],
              [-13.556712278527165, -11.591889433087994],
              [-13.556707660419379, -11.592686897373506],
              [-13.554136115417872, -11.594376079780618],
              [-13.552622146242241, -11.594636714528926],
              [-13.552340064733816, -11.596809938615014],
              [-13.550926080517103, -11.597993330411027],
              [-13.548570832163763, -11.60115734620672],
              [-13.548047340114534, -11.602555441927162],
              [-13.54902054823919, -11.604534597224845],
              [-13.547232956391355, -11.604903230686702],
              [-13.547503994417536, -11.606676224659791],
              [-13.545135751413833, -11.60753318933475],
              [-13.544128951878221, -11.608319861811642],
              [-13.542114156559007, -11.61083357980105],
              [-13.541404607725068, -11.612837325620214],
              [-13.541847326306565, -11.61405027235591],
              [-13.540970363719989, -11.61628767035031],
              [-13.541277077122693, -11.61731968718712],
              [-13.540461406270097, -11.619669703501321],
              [-13.539717482816357, -11.620534579113274],
              [-13.53873411691653, -11.623118849759077],
              [-13.540969944802441, -11.626931963935126],
              [-13.538197488478602, -11.627531215031256],
              [-13.537695217357884, -11.628231870526141],
              [-13.537935686955377, -11.62995201561995],
              [-13.53588443044949, -11.63038604656822],
              [-13.535544261167749, -11.631653075256388],
              [-13.533599035846986, -11.635182628136837],
              [-13.533495759057514, -11.637085693705554],
              [-13.534048836635247, -11.63904036674594],
              [-13.531933206584613, -11.640305278064368],
              [-13.531689724825114, -11.641412794565813],
              [-13.530387770256251, -11.643624796014231],
              [-13.529785350433185, -11.646373315100195],
              [-13.529429363387475, -11.649572415464853],
              [-13.529731224204259, -11.651879692899945],
              [-13.530294886694827, -11.6527063156656],
              [-13.53037670302897, -11.654949495681308],
              [-13.534056625173028, -11.65957085829201],
              [-13.53712139761109, -11.664955673756223],
              [-13.538802781043906, -11.667006827921645],
              [-13.538034971878547, -11.66810457762057],
              [-13.537121228354579, -11.667789693026146],
              [-13.536048989422222, -11.666105662132637],
              [-13.533031452998417, -11.663237115823755],
              [-13.530323312043029, -11.661403403479124],
              [-13.528828876473538, -11.65968927409153],
              [-13.526861231477636, -11.659677814497252],
              [-13.52422624853975, -11.664667041632322],
              [-13.525072174425713, -11.666144406082834],
              [-13.523980201759274, -11.667666865584426],
              [-13.524260866504793, -11.669734300323052],
              [-13.525036722001422, -11.671285862902351],
              [-13.525322250176528, -11.673024455933911],
              [-13.52662787950501, -11.675677069880328],
              [-13.52760390560178, -11.676105422109735],
              [-13.52910062822765, -11.677820932652107],
              [-13.528773291459563, -11.679049001202433],
              [-13.526403067314568, -11.683177737897404],
              [-13.526154591130936, -11.685564800131711],
              [-13.5248015988479, -11.685535123235084]
            ]
          ],
          [
            [
              [-13.790393448334475, -11.498954062018662],
              [-13.789888729945824, -11.498259263479868],
              [-13.78721123885373, -11.498581436876128],
              [-13.78733142899411, -11.499956414146183],
              [-13.790393448334475, -11.498954062018662]
            ]
          ],
          [
            [
              [-13.84216557446173, -11.428166666793837],
              [-13.841615469771178, -11.426499421222905],
              [-13.840031480208983, -11.425513220296065],
              [-13.840145247716231, -11.424625541275645],
              [-13.839224004098694, -11.422627148579581],
              [-13.839144952793989, -11.42127323047659],
              [-13.837654729720795, -11.420450451985573],
              [-13.837555926658139, -11.418677749356622],
              [-13.836766545293115, -11.417036916075153],
              [-13.837895607127605, -11.415372838674381],
              [-13.839926116409478, -11.414140466412123],
              [-13.840237655803168, -11.415006532292352],
              [-13.843211775119673, -11.413895507556424],
              [-13.841914295839166, -11.413217699150879],
              [-13.840670045206672, -11.411866047002189],
              [-13.841164795116722, -11.41062505221937],
              [-13.84005470761148, -11.408805355342558],
              [-13.840494107686895, -11.407595214555878],
              [-13.841755172701983, -11.40693244185194],
              [-13.84102313730839, -11.405584188335792],
              [-13.842008101332183, -11.403606694506454],
              [-13.840707195524704, -11.401643556159437],
              [-13.84056792491555, -11.400504236405895],
              [-13.841392231940073, -11.398437888774296],
              [-13.84274104481153, -11.398442008605933],
              [-13.843366024206809, -11.3975589644682],
              [-13.845064026541664, -11.397154845358315],
              [-13.847927520722493, -11.395603267493245],
              [-13.848382344376514, -11.393848914675011],
              [-13.849690238672691, -11.393016437296875],
              [-13.847124220261394, -11.391578206619249],
              [-13.847743837401419, -11.389411477583646],
              [-13.84522857694803, -11.38812441799514],
              [-13.83974419168261, -11.38762291427266],
              [-13.838493021928183, -11.386957268037259],
              [-13.835891304106212, -11.387431570968722],
              [-13.835180995392497, -11.386502008422429],
              [-13.83414163406716, -11.38186113039265],
              [-13.833107325772987, -11.381575503952373],
              [-13.831536765365017, -11.383479271568323],
              [-13.830312814178328, -11.383691077156218],
              [-13.828475139933357, -11.387492524283306],
              [-13.826788513820816, -11.387530813211596],
              [-13.826473482214332, -11.383775226522014],
              [-13.821060491735732, -11.385440466322306],
              [-13.820250161979219, -11.386958857104753],
              [-13.818896663374387, -11.387455194075008],
              [-13.818394607207386, -11.389518310290901],
              [-13.816971283446748, -11.388802310851894],
              [-13.816568893123764, -11.387131045159864],
              [-13.813838153736596, -11.387620858764135],
              [-13.810283195857167, -11.38964942726484],
              [-13.805831804763923, -11.391726153561018],
              [-13.805092592499914, -11.39068348453175],
              [-13.80406147773828, -11.390619998411363],
              [-13.8012893072241, -11.39302617732905],
              [-13.80041359888053, -11.394788227466673],
              [-13.797455191281866, -11.397062305815563],
              [-13.795716570584185, -11.398067668377555],
              [-13.795241726385846, -11.399221861934251],
              [-13.793347256400823, -11.400691343342482],
              [-13.792526823493903, -11.402070919800328],
              [-13.790706994657903, -11.40303424480825],
              [-13.788664277362914, -11.405406717236879],
              [-13.787583262774172, -11.408001836437702],
              [-13.786657056316104, -11.408939007235793],
              [-13.786063258601287, -11.411303582888618],
              [-13.786556652893006, -11.412177310821091],
              [-13.79009949926462, -11.412199894605221],
              [-13.79137074123496, -11.413290639292022],
              [-13.794506206261856, -11.411818653251762],
              [-13.795394769668077, -11.411974284493628],
              [-13.79751700931453, -11.409806212383396],
              [-13.79864588369127, -11.409292788927788],
              [-13.80144683167325, -11.409290528615994],
              [-13.804043157380839, -11.408219509700817],
              [-13.804629600730133, -11.408612330194359],
              [-13.803366745601938, -11.410881344949475],
              [-13.799974302456565, -11.412926758962081],
              [-13.796796497032341, -11.414066018212313],
              [-13.795112593062562, -11.418749659068885],
              [-13.792945590761887, -11.420906942598343],
              [-13.792291108919722, -11.422197599964555],
              [-13.789832860322182, -11.422939548458343],
              [-13.789338574828625, -11.423998775435932],
              [-13.78901138183063, -11.428834139154123],
              [-13.790482545061755, -11.430210957787535],
              [-13.790513776461914, -11.431877664209706],
              [-13.787929815662421, -11.431756734632598],
              [-13.787249917495876, -11.432811020173517],
              [-13.786860386217999, -11.434960068929893],
              [-13.785462967194274, -11.434939180306117],
              [-13.784355944583995, -11.436335497094781],
              [-13.783514952780752, -11.435363425721238],
              [-13.782890910607906, -11.433162175254376],
              [-13.78423917182387, -11.431418875036721],
              [-13.782471793017852, -11.429451557576355],
              [-13.780395683948008, -11.427904252000115],
              [-13.780508331142386, -11.425908971224729],
              [-13.779131524331968, -11.424050568328594],
              [-13.780018355680125, -11.419877764844854],
              [-13.781180952408711, -11.418130768578443],
              [-13.78120643881601, -11.41707935880278],
              [-13.780028519282661, -11.415506897584317],
              [-13.780624043141662, -11.41249801928175],
              [-13.78257442150751, -11.412859211756238],
              [-13.78292136255312, -11.411345811110287],
              [-13.781384422002871, -11.411330203070243],
              [-13.779873149369683, -11.41026294596207],
              [-13.776462698222517, -11.412667775629671],
              [-13.772310636434385, -11.414404861686116],
              [-13.769750823645202, -11.416127632004846],
              [-13.76927371163049, -11.416960677016805],
              [-13.765630558009917, -11.419346935164574],
              [-13.764639466628957, -11.420497048817706],
              [-13.76131148794414, -11.421958247517148],
              [-13.76020256096494, -11.423029247761795],
              [-13.759735822090919, -11.424464976177008],
              [-13.75847782478243, -11.42572474055865],
              [-13.755541770510092, -11.427757739789323],
              [-13.755038436080357, -11.428676522893477],
              [-13.754504452179175, -11.431939642712772],
              [-13.757826404638848, -11.431951205540871],
              [-13.760834075047438, -11.431274523595965],
              [-13.761121211607982, -11.429971548961207],
              [-13.759355347982364, -11.428645523302462],
              [-13.760671124366961, -11.426387384605588],
              [-13.763602064656922, -11.426288745783046],
              [-13.765631053085999, -11.429116625737842],
              [-13.765955508673722, -11.431051799543315],
              [-13.767029781415161, -11.432182785077892],
              [-13.769485002023359, -11.432271383568775],
              [-13.77143815593233, -11.43327931286632],
              [-13.771436323148192, -11.434892356156357],
              [-13.769165801763858, -11.43513279740586],
              [-13.767308120062992, -11.436364780057295],
              [-13.766687258740689, -11.437850950883867],
              [-13.767744799928044, -11.438239506430914],
              [-13.771774059685637, -11.437107829156853],
              [-13.773741408072961, -11.437104982207918],
              [-13.775104270319591, -11.43467404655641],
              [-13.776564172489515, -11.434482864315266],
              [-13.777138692413526, -11.435242709227452],
              [-13.779105063731999, -11.435884252142516],
              [-13.778782832000541, -11.437315271931912],
              [-13.77773717069905, -11.437852746981427],
              [-13.777562165936397, -11.441031419802195],
              [-13.776212296057057, -11.442452836326881],
              [-13.777312412170247, -11.445757570309144],
              [-13.775756791725549, -11.449659593827281],
              [-13.776505312519628, -11.451437273027283],
              [-13.7753216156879, -11.453414198064578],
              [-13.775172514642373, -11.454572701703935],
              [-13.773665798269349, -11.45766021711831],
              [-13.774272527160607, -11.459445409538265],
              [-13.776757022007132, -11.462677840900923],
              [-13.777563072723899, -11.466689179384174],
              [-13.776155757510365, -11.47073122316086],
              [-13.776658477916927, -11.472396002075484],
              [-13.775492284178902, -11.473180144312277],
              [-13.775144974058275, -11.474700653057372],
              [-13.776379705999753, -11.475460624167914],
              [-13.778484605719859, -11.479050359327728],
              [-13.778634101070898, -11.480155101848105],
              [-13.777858866592819, -11.481372415613631],
              [-13.77905188194753, -11.48341455194697],
              [-13.778816596053188, -11.484551207800742],
              [-13.77726539296315, -11.486339203366091],
              [-13.777949184569621, -11.487546720139564],
              [-13.78109122132394, -11.4874027988048],
              [-13.782233399279487, -11.487026563063614],
              [-13.78689781566736, -11.488274727303576],
              [-13.790336681491034, -11.491493495105495],
              [-13.79008909120851, -11.492025758530998],
              [-13.79189959086234, -11.493729105852635],
              [-13.795125792129415, -11.495084236643216],
              [-13.796733944793438, -11.494881639695967],
              [-13.797562125496471, -11.49575766907815],
              [-13.800109420559115, -11.496045165442856],
              [-13.801098720491614, -11.496687880099696],
              [-13.802228701071721, -11.498802716782633],
              [-13.805643211874537, -11.50016010907096],
              [-13.8058628656005, -11.500867635502194],
              [-13.808666505706686, -11.501408728446616],
              [-13.809817227631953, -11.503620893372695],
              [-13.811440387177456, -11.504020945227458],
              [-13.812624486664523, -11.503329757483682],
              [-13.815795958722553, -11.504062323428089],
              [-13.817637067412411, -11.503042858546275],
              [-13.818595175541137, -11.498870129975156],
              [-13.818466404013702, -11.497679581132267],
              [-13.817218346118482, -11.496135885381701],
              [-13.818405693406593, -11.494937637851873],
              [-13.819162134826492, -11.493113348367023],
              [-13.819031161839593, -11.489798973995],
              [-13.819668455252064, -11.486096102246455],
              [-13.820790805230068, -11.485942795824405],
              [-13.820776458175526, -11.483862049579162],
              [-13.820233357251698, -11.482974488909639],
              [-13.82088822062978, -11.479047753456161],
              [-13.822689167928171, -11.478158334731821],
              [-13.823349685742196, -11.47584906340083],
              [-13.822848563262713, -11.472852101781342],
              [-13.8235806732263, -11.471439375606474],
              [-13.821338822985807, -11.471745086966902],
              [-13.819957190819318, -11.470027794270969],
              [-13.821119041987155, -11.467442811388695],
              [-13.820141875764698, -11.466113711050285],
              [-13.818122071744718, -11.465972664246225],
              [-13.81720269763966, -11.463137707110967],
              [-13.813595035823107, -11.462004967872303],
              [-13.811994767446697, -11.46105624593343],
              [-13.810795696423872, -11.459526482889402],
              [-13.810432436934196, -11.45785907722138],
              [-13.810670212128178, -11.45377665273578],
              [-13.811112818173365, -11.452562870059413],
              [-13.812600817096197, -11.451130911376739],
              [-13.810961687111018, -11.448696808594347],
              [-13.809243729834103, -11.446701707922362],
              [-13.809716145917918, -11.44489805804467],
              [-13.812516121199696, -11.444106202004129],
              [-13.812944331566037, -11.44196805666276],
              [-13.81511823343102, -11.440911347562775],
              [-13.817407003053178, -11.441405061411634],
              [-13.821361620656115, -11.440654879560634],
              [-13.821850163075245, -11.442860982386398],
              [-13.823160856955166, -11.442853905033639],
              [-13.824502087986776, -11.444696339864475],
              [-13.826039623573635, -11.444060999668206],
              [-13.828182319896134, -11.445064513519915],
              [-13.830072356728841, -11.44286932024113],
              [-13.829863520279769, -11.441477618855462],
              [-13.83022746729477, -11.439553403431468],
              [-13.829822186272244, -11.438521903058865],
              [-13.829706603624375, -11.435500285608741],
              [-13.830445987438319, -11.434875803051245],
              [-13.829720260752309, -11.432193005971246],
              [-13.831747649690266, -11.427234218592329],
              [-13.831002746829851, -11.424133703497205],
              [-13.830403894274015, -11.424106687722691],
              [-13.829513183518154, -11.421517596535672],
              [-13.830813822927885, -11.42104890214039],
              [-13.830451743710752, -11.419708509117195],
              [-13.830965589245686, -11.41824215298375],
              [-13.832023364532423, -11.41715530910068],
              [-13.834654097785803, -11.41985491070865],
              [-13.835337010963197, -11.42105328779499],
              [-13.835565633223782, -11.422861733954573],
              [-13.834929627198292, -11.42622503597019],
              [-13.836287406323901, -11.427839062451623],
              [-13.838079996747732, -11.4284236970202],
              [-13.83987522064051, -11.429651940438808],
              [-13.84216557446173, -11.428166666793837]
            ]
          ],
          [
            [
              [-13.864976434011604, -11.369374914232452],
              [-13.864593840162652, -11.36762379440654],
              [-13.865498649017901, -11.366728625071122],
              [-13.864277297298855, -11.365479549540847],
              [-13.861499095473809, -11.366272523344952],
              [-13.859718687450844, -11.366332821981413],
              [-13.857196345533769, -11.368339143530534],
              [-13.85992022159007, -11.369040950269602],
              [-13.860696253519983, -11.368110324880213],
              [-13.861772301116082, -11.368405409194526],
              [-13.863380352875314, -11.370904024941481],
              [-13.864517083695063, -11.370986822467446],
              [-13.864976434011604, -11.369374914232452]
            ]
          ],
          [
            [
              [-13.963030228120497, -11.2858302902872],
              [-13.962894834186036, -11.284503071910068],
              [-13.95968710096692, -11.284888917832028],
              [-13.959564297010763, -11.283270536028411],
              [-13.957270899023493, -11.280050717297398],
              [-13.95575334266838, -11.280798046347117],
              [-13.955230040933092, -11.281767390236045],
              [-13.953433012821314, -11.282938028121166],
              [-13.95110332836206, -11.286752652086943],
              [-13.952243481582794, -11.290073299289757],
              [-13.953753432265097, -11.292156088693137],
              [-13.95571083790982, -11.293542504868128],
              [-13.956685060371578, -11.292851835227143],
              [-13.957640977531536, -11.290660748935489],
              [-13.95698029534547, -11.289486527620602],
              [-13.957775201543614, -11.28795519656234],
              [-13.958604448425197, -11.28835889175483],
              [-13.960292298547595, -11.286342211892471],
              [-13.963030228120497, -11.2858302902872]
            ]
          ],
          [
            [
              [-13.989768443742603, -11.25166683462617],
              [-13.926653263022176, -11.232270521596268],
              [-13.92354686120926, -11.213018530835061],
              [-13.920113000996267, -11.172381365660629],
              [-13.91866612040459, -11.17215087346415],
              [-13.91560721121055, -11.172548472326623],
              [-13.902743556145147, -11.177335606939767],
              [-13.896462707256067, -11.181461050869313],
              [-13.888726318908569, -11.184709446588107],
              [-13.879992656509144, -11.187053088708193],
              [-13.866569723261463, -11.189082045151993],
              [-13.858138666354085, -11.191264682247096],
              [-13.850620811119288, -11.192067237355797],
              [-13.842013543997743, -11.193991954027931],
              [-13.82882322496542, -11.198414446048613],
              [-13.82031920136453, -11.200962698535012],
              [-13.809840637019057, -11.205512690323507],
              [-13.803066197932042, -11.209902003937307],
              [-13.794140873969418, -11.213635800245406],
              [-13.786492945154468, -11.216730940592443],
              [-13.778612652471587, -11.218638587364303],
              [-13.774725331548701, -11.218578733176162],
              [-13.767185892109797, -11.216823701833698],
              [-13.758037800309179, -11.21245760599117],
              [-13.756542914245454, -11.210469560298865],
              [-13.755179306531103, -11.212496093160201],
              [-13.752059068637262, -11.214455176274518],
              [-13.748339243570861, -11.214092199219818],
              [-13.747136601250807, -11.212791152042518],
              [-13.744511667799003, -11.212468594819375],
              [-13.743795653806139, -11.211238540901515],
              [-13.73974545109092, -11.211824422786453],
              [-13.739591479020072, -11.213031685378152],
              [-13.738361201422611, -11.213519392043692],
              [-13.737310027080982, -11.2127154557164],
              [-13.734451350275126, -11.209091649142682],
              [-13.733564261225363, -11.20835788532978],
              [-13.73252221556197, -11.205758476816326],
              [-13.73128719846229, -11.204878328890642],
              [-13.729778835927458, -11.20521586280604],
              [-13.728978681580324, -11.20434735875217],
              [-13.727490589238961, -11.204463266076404],
              [-13.725434836900742, -11.20332193820159],
              [-13.723071208967268, -11.204276262118242],
              [-13.722060107404031, -11.206715013301833],
              [-13.72103347721461, -11.207442161270167],
              [-13.720636129352084, -11.20876161098836],
              [-13.71918580885288, -11.209821478281604],
              [-13.719852915216551, -11.21174557370612],
              [-13.717885216200472, -11.214751687236264],
              [-13.717746650543832, -11.216055615304995],
              [-13.716592717435987, -11.218045298190201],
              [-13.71657453717539, -11.219179474375824],
              [-13.714131487895365, -11.222072672785927],
              [-13.712854561954412, -11.222705407323229],
              [-13.71195294650862, -11.22408560961709],
              [-13.712614744781051, -11.227105365123204],
              [-13.713800202267022, -11.230231412032245],
              [-13.712544397355806, -11.231943367859595],
              [-13.710339608190585, -11.232581745096997],
              [-13.708738834151635, -11.2342849922118],
              [-13.712430352822533, -11.233780871862413],
              [-13.715006404014419, -11.232907576430964],
              [-13.714409710269173, -11.23458259685493],
              [-13.711084594432778, -11.236174928940102],
              [-13.707251738409749, -11.236683810545228],
              [-13.704307523179375, -11.239230751193158],
              [-13.702912588342294, -11.241474429525045],
              [-13.702686358451489, -11.243144495402525],
              [-13.701345907222986, -11.243211858078578],
              [-13.699342107963224, -11.245782168989143],
              [-13.69819326118501, -11.248281636860042],
              [-13.696903900263068, -11.249941061286396],
              [-13.695576493506616, -11.250652326210634],
              [-13.694310420918974, -11.25369019177882],
              [-13.69121888763372, -11.258622554719368],
              [-13.691036435789878, -11.260376761113411],
              [-13.68994434947932, -11.26253015600055],
              [-13.690341742520998, -11.263057533158888],
              [-13.689332199862681, -11.266242264600344],
              [-13.689799192390147, -11.267385057745797],
              [-13.689088532071285, -11.269581824369313],
              [-13.689457145430229, -11.270513228105264],
              [-13.68833817586203, -11.272294360696323],
              [-13.6876415857365, -11.275366381669292],
              [-13.685034934303966, -11.277379551003685],
              [-13.684261413529299, -11.279628966388655],
              [-13.682602185958702, -11.280658190179274],
              [-13.6813306438057, -11.27994448272232],
              [-13.679489330994372, -11.282570732050774],
              [-13.680063319751781, -11.283746669420454],
              [-13.681365600890175, -11.283437967086607],
              [-13.67909310161845, -11.288026205942993],
              [-13.678662602936019, -11.29021700822979],
              [-13.680056572492695, -11.292067543246032],
              [-13.681704058139633, -11.290620306988734],
              [-13.68342055811521, -11.289789571599151],
              [-13.68705996008519, -11.286056628619445],
              [-13.688876582719612, -11.284659413090122],
              [-13.689634975130232, -11.284765148742645],
              [-13.691429076029351, -11.286752373205871],
              [-13.689639510576704, -11.28875388900375],
              [-13.691201558951105, -11.290742806832379],
              [-13.689203094168448, -11.29220319875264],
              [-13.688064656904961, -11.292354039170725],
              [-13.686527236048514, -11.293902405976477],
              [-13.684484810167755, -11.295350271341905],
              [-13.68299525233124, -11.29773886517396],
              [-13.683884470211584, -11.298570368107823],
              [-13.686081177579286, -11.29900188395546],
              [-13.686982948589607, -11.30063986606306],
              [-13.689653687833383, -11.30150636805413],
              [-13.69261703446939, -11.301401712377357],
              [-13.693739387605158, -11.302850910206514],
              [-13.695175920212801, -11.302716035503208],
              [-13.697705397702403, -11.303356399076852],
              [-13.701373256211987, -11.303613760157488],
              [-13.702440629375133, -11.306100594339219],
              [-13.705347662986801, -11.305793269716268],
              [-13.70837587918657, -11.307950601521139],
              [-13.710448447264886, -11.309029071086579],
              [-13.710885072059224, -11.307183379066053],
              [-13.713533279053216, -11.308358264464106],
              [-13.714921077759051, -11.307451165232086],
              [-13.715497404574917, -11.30816706013476],
              [-13.716953886503102, -11.30780668131771],
              [-13.720619141950808, -11.30876814490126],
              [-13.721267869358247, -11.308152350219556],
              [-13.722536218883372, -11.309043563692585],
              [-13.723915560081792, -11.307927099058954],
              [-13.726550055668456, -11.306964385043969],
              [-13.72672136614089, -11.305845082002795],
              [-13.728150266416087, -11.304949408582157],
              [-13.730156257093645, -11.302661633118833],
              [-13.732046590455015, -11.301852371909947],
              [-13.732613762751033, -11.300572215743749],
              [-13.739193789725059, -11.299136441370678],
              [-13.741698705547238, -11.297815721696045],
              [-13.742528947262503, -11.296817752419871],
              [-13.74429782505299, -11.296019032501624],
              [-13.746720454704574, -11.296298819594174],
              [-13.747581136198665, -11.29574372846391],
              [-13.747448473642978, -11.294471150865977],
              [-13.75041308470555, -11.294173132006197],
              [-13.751520522873259, -11.294740422784695],
              [-13.752820309393659, -11.293876226829761],
              [-13.753188880935138, -11.292632321882577],
              [-13.755359394156374, -11.292427784601749],
              [-13.759660907751917, -11.289721001913398],
              [-13.76190005952786, -11.289124075740094],
              [-13.764470365383534, -11.288895017492496],
              [-13.771031435236466, -11.286600675790927],
              [-13.774719727125465, -11.284929302148658],
              [-13.777242081871002, -11.28477615605687],
              [-13.781717810277033, -11.281364617113747],
              [-13.782986931840487, -11.281061972444563],
              [-13.785212378751908, -11.282307132750523],
              [-13.787276378345963, -11.280951100792407],
              [-13.789607553551468, -11.279944248510267],
              [-13.791453345962626, -11.279644263874696],
              [-13.795369082081258, -11.277487738150736],
              [-13.797380728893174, -11.27764453320238],
              [-13.79882750967811, -11.2767299192551],
              [-13.799874760206633, -11.276705716333874],
              [-13.804767110586743, -11.274595576697399],
              [-13.80800686398923, -11.273865500781223],
              [-13.808851784957673, -11.274057345785602],
              [-13.817176977054347, -11.269265516526424],
              [-13.819484481793163, -11.270139665934643],
              [-13.820622033092345, -11.270117062525141],
              [-13.822144936397198, -11.269245786426396],
              [-13.822918880167007, -11.267141109739535],
              [-13.824556823275504, -11.266507313806924],
              [-13.826371002363228, -11.26637755063816],
              [-13.828514826140259, -11.265429854821972],
              [-13.83168882923292, -11.270388208080684],
              [-13.83200820729278, -11.272707131991877],
              [-13.83261153108602, -11.274286399932933],
              [-13.834850344408295, -11.275797919306921],
              [-13.835207402002368, -11.278947002077139],
              [-13.840765363299436, -11.282792304879086],
              [-13.840567685006766, -11.283875324318352],
              [-13.838920282733596, -11.28510189408457],
              [-13.834076171759849, -11.286281492440281],
              [-13.831859798237636, -11.287394755951475],
              [-13.830015555246028, -11.287382060280839],
              [-13.826627016264172, -11.285366295566536],
              [-13.825632743728143, -11.283380372587228],
              [-13.824219387395106, -11.28323614799305],
              [-13.821031113680405, -11.28434997680046],
              [-13.819673373282903, -11.283377618240868],
              [-13.818594764474888, -11.284146727586098],
              [-13.815106832668345, -11.284697268789206],
              [-13.81370266966941, -11.286423292490946],
              [-13.812058280391007, -11.287148050690973],
              [-13.812462628792208, -11.290521414735867],
              [-13.815487196902314, -11.29077523198234],
              [-13.818836195164954, -11.29349027424673],
              [-13.81902792265928, -11.294501501131842],
              [-13.82038760641159, -11.294835632643668],
              [-13.820771879362086, -11.296060159396019],
              [-13.82043154695129, -11.297789352027566],
              [-13.821475738548733, -11.29976842158449],
              [-13.822894143410439, -11.300141392624827],
              [-13.824862923899573, -11.299094471545311],
              [-13.82574007867981, -11.299498646144782],
              [-13.82663568931909, -11.303670186453154],
              [-13.823217086733004, -11.30413144719265],
              [-13.821054552259978, -11.305284533493698],
              [-13.819953875568952, -11.304931529405964],
              [-13.816582393146732, -11.306180502000997],
              [-13.81553429947026, -11.308831481879496],
              [-13.816152677748804, -11.313318354039499],
              [-13.815619591523731, -11.31435665826315],
              [-13.816586011864455, -11.31565408421498],
              [-13.816352780675958, -11.31693603340752],
              [-13.815014434117371, -11.317955589310156],
              [-13.81366106832588, -11.31814828678432],
              [-13.811918993741058, -11.321910438116983],
              [-13.810877422840717, -11.322144994831348],
              [-13.809034873289612, -11.323937797434054],
              [-13.80907709538902, -11.32474929852495],
              [-13.80680355001484, -11.32786233047738],
              [-13.806731038625776, -11.330105162522937],
              [-13.806158914706224, -11.332391803422675],
              [-13.806445913968961, -11.333638437197816],
              [-13.805352367105288, -11.3358028680409],
              [-13.805838858459968, -11.33724261696371],
              [-13.808166378602452, -11.337618546014808],
              [-13.809665518713489, -11.338929020660828],
              [-13.809950295943775, -11.339946493352958],
              [-13.81120156376988, -11.340753186899681],
              [-13.81221969905752, -11.342363922420448],
              [-13.811750058057404, -11.343262425811469],
              [-13.809203217532483, -11.344199192077115],
              [-13.809015789161023, -11.344924925663049],
              [-13.80992344274377, -11.347398096910075],
              [-13.81226812255007, -11.349081599035756],
              [-13.81276547875427, -11.350410159408217],
              [-13.814272739760051, -11.351058908955116],
              [-13.813478155367658, -11.353881934818158],
              [-13.81394517054882, -11.354996557400225],
              [-13.815505619859923, -11.356186191702133],
              [-13.817329716477133, -11.35630453327257],
              [-13.81853130652575, -11.357691744274003],
              [-13.819178638984722, -11.356818571793474],
              [-13.822880369055166, -11.358235841158395],
              [-13.821372640596552, -11.361525805864066],
              [-13.819584615594213, -11.36144150436304],
              [-13.816706875359104, -11.362473644708828],
              [-13.81668649385514, -11.364071010351227],
              [-13.81744040377135, -11.36556349647575],
              [-13.818565939450153, -11.366494398130879],
              [-13.819590513024131, -11.36455748398794],
              [-13.82080413095791, -11.364459329441527],
              [-13.821592439704816, -11.366075036091974],
              [-13.823037871380723, -11.36702557613557],
              [-13.82233959762061, -11.36896196034366],
              [-13.82469248829744, -11.372248686179853],
              [-13.827446782096484, -11.372129745710637],
              [-13.828904720461473, -11.3727167100638],
              [-13.830174798735829, -11.371373162460088],
              [-13.830799337015314, -11.37324089858647],
              [-13.832460973809475, -11.373929113203976],
              [-13.836055608063052, -11.373227859403842],
              [-13.835583940510379, -11.371311313786972],
              [-13.837090860093026, -11.371727494470317],
              [-13.839881529264435, -11.369533294189786],
              [-13.84157199838053, -11.370846581639247],
              [-13.843402138736572, -11.370458481561318],
              [-13.844825858854957, -11.371812037928414],
              [-13.847180152560744, -11.37202550833758],
              [-13.849113226911843, -11.371276215699252],
              [-13.851368128531982, -11.3720793433088],
              [-13.853307807336991, -11.370736461143613],
              [-13.85632492598282, -11.364566474294511],
              [-13.85664560210919, -11.363282626868417],
              [-13.858419205302964, -11.36072937479416],
              [-13.859774447233537, -11.363455839911266],
              [-13.861763003891328, -11.364047181476792],
              [-13.862117201253927, -11.362155583137351],
              [-13.864877963764147, -11.359713229673238],
              [-13.867229693973643, -11.359352488280015],
              [-13.868956431438244, -11.357198152662765],
              [-13.87287471335085, -11.35491302313148],
              [-13.874888010770684, -11.354596106222218],
              [-13.875626558671508, -11.355094845472243],
              [-13.876698236751574, -11.353606935685526],
              [-13.878606905810969, -11.354470966957168],
              [-13.88097842518243, -11.35411387452857],
              [-13.882121573997816, -11.352942339745743],
              [-13.882501216166593, -11.351197418873257],
              [-13.881681016722519, -11.349763897429748],
              [-13.883845182630502, -11.349806688449561],
              [-13.883427317026245, -11.348506260718823],
              [-13.885221283277124, -11.34764967027859],
              [-13.88561199645501, -11.346843772812186],
              [-13.887742628960682, -11.34651229159242],
              [-13.890277109051333, -11.344101460561571],
              [-13.891834404783188, -11.345300877754287],
              [-13.893929821450374, -11.344845004209812],
              [-13.896142543304633, -11.342665753911135],
              [-13.89840412667678, -11.342437317768836],
              [-13.899469418912272, -11.341450388225402],
              [-13.901156817144614, -11.341042649374808],
              [-13.902158539610173, -11.337988176000678],
              [-13.901825531717884, -11.336713025921075],
              [-13.903650037755934, -11.334998823833724],
              [-13.907405400782777, -11.333399303829076],
              [-13.908140310643685, -11.332186997095178],
              [-13.908079885693205, -11.331009193902544],
              [-13.908949114491843, -11.330220680724029],
              [-13.910800064659703, -11.330289903342443],
              [-13.913050148216966, -11.327713445163866],
              [-13.911438422099936, -11.32597952489279],
              [-13.911684061990151, -11.325272452600618],
              [-13.913449614429283, -11.324249074588781],
              [-13.913031726531617, -11.32270270971633],
              [-13.911631301798424, -11.322186224503104],
              [-13.907883748864133, -11.319030638706424],
              [-13.909914316898615, -11.316579368160978],
              [-13.911177613800158, -11.316353832294473],
              [-13.912645685890716, -11.315319655825233],
              [-13.915395511184787, -11.314973896043195],
              [-13.91633933122144, -11.315798113875418],
              [-13.917061693011208, -11.3180631429922],
              [-13.918188078242572, -11.319141119543485],
              [-13.920498032189942, -11.319538930342027],
              [-13.920785291267812, -11.31720662131776],
              [-13.922437550699506, -11.314448576736241],
              [-13.925158178409736, -11.314775162391129],
              [-13.924383174725957, -11.316383722439555],
              [-13.92445785841038, -11.318086289912378],
              [-13.923751644030798, -11.31953208078646],
              [-13.92413154193556, -11.321544821509674],
              [-13.923724017831875, -11.324800345244217],
              [-13.923230787570976, -11.326145169643528],
              [-13.92468593070272, -11.327288838616887],
              [-13.924242482521427, -11.328374771678254],
              [-13.92436519117114, -11.33097876453963],
              [-13.926583058349586, -11.330394210029443],
              [-13.927574411458787, -11.327272573617805],
              [-13.929895601604903, -11.325988182938238],
              [-13.932338210907059, -11.326078406437036],
              [-13.934696883850405, -11.324326668668725],
              [-13.936909853499902, -11.324740384648901],
              [-13.938701243137173, -11.323858493042522],
              [-13.940049798455908, -11.324312122205864],
              [-13.940825803261355, -11.323020662905217],
              [-13.940342608332164, -11.320050749002615],
              [-13.936319803042807, -11.320013466148616],
              [-13.933830120310645, -11.315820636721954],
              [-13.934443698337546, -11.313714338494464],
              [-13.936712965938973, -11.312440361508143],
              [-13.938900397758779, -11.314664644384058],
              [-13.940421428957803, -11.314415559485418],
              [-13.94081675272514, -11.31325007330705],
              [-13.943813269868803, -11.313488160203226],
              [-13.946328679988339, -11.314459104517589],
              [-13.943702862831142, -11.311823789481078],
              [-13.944099136242675, -11.309500905316206],
              [-13.946787038148116, -11.30820324841654],
              [-13.948767453919512, -11.306057194353636],
              [-13.951000275771262, -11.302346238348463],
              [-13.953848917183825, -11.302112675128978],
              [-13.95350980689345, -11.300524861331835],
              [-13.95196347390677, -11.300132336159539],
              [-13.951169673284273, -11.298445099558924],
              [-13.951415197428524, -11.296742144859548],
              [-13.954206288348718, -11.296380607282218],
              [-13.952848836336612, -11.29374919820148],
              [-13.95147101526011, -11.292427013663447],
              [-13.950715600765655, -11.290523865389673],
              [-13.94961786298267, -11.28943539158585],
              [-13.947954063432341, -11.289056049380763],
              [-13.944978254351234, -11.289093828918157],
              [-13.94496768941616, -11.287571878872203],
              [-13.946502436334221, -11.286851879538036],
              [-13.945757642365308, -11.284996943327831],
              [-13.947150576280881, -11.284125597777528],
              [-13.94652390914081, -11.283163743558749],
              [-13.947002519959048, -11.281208079529964],
              [-13.945373810392866, -11.28119983173788],
              [-13.942796727988345, -11.279983970830559],
              [-13.942252720672366, -11.278319323537707],
              [-13.944419895757378, -11.276570525150987],
              [-13.945633070023636, -11.27470036267292],
              [-13.949122512255327, -11.273964935568008],
              [-13.949815875421908, -11.274604616009256],
              [-13.951694892817928, -11.273797175342363],
              [-13.95079267255126, -11.271607168955992],
              [-13.951711407988128, -11.270948892037113],
              [-13.951302389280778, -11.267081734829459],
              [-13.952495555485195, -11.264868512382982],
              [-13.953737910652919, -11.26542925844708],
              [-13.95309391402898, -11.26715674733165],
              [-13.954603781534349, -11.268649197026418],
              [-13.955832236136734, -11.270903044588978],
              [-13.957188677775363, -11.271222285316831],
              [-13.957047608252, -11.26950972558054],
              [-13.961292662773433, -11.267369298780011],
              [-13.962588745193877, -11.265930228903045],
              [-13.963521397837486, -11.267108046706102],
              [-13.96231717235449, -11.268300611280328],
              [-13.961717199743942, -11.270040011124337],
              [-13.960006089665054, -11.273540725418355],
              [-13.959698802491305, -11.275382179389284],
              [-13.960592957775807, -11.27596151980274],
              [-13.96017122173025, -11.279448034956577],
              [-13.962091605160788, -11.281864983759407],
              [-13.963768392850975, -11.28095555362429],
              [-13.964492113946397, -11.281489130809415],
              [-13.967324869214572, -11.27799236788935],
              [-13.96814891646134, -11.276515623568988],
              [-13.970652167506161, -11.276506451860907],
              [-13.971714541047778, -11.27516148266557],
              [-13.971207712460071, -11.273849582219531],
              [-13.971365125582766, -11.272376006435094],
              [-13.970253914893277, -11.270517977799612],
              [-13.970662245050821, -11.268885632777389],
              [-13.970283930407067, -11.267608622867735],
              [-13.970755522886225, -11.266490964997121],
              [-13.97218696676645, -11.266783805905956],
              [-13.97311199536121, -11.26601365850153],
              [-13.975045486740944, -11.266643853238227],
              [-13.976433710117753, -11.264370369783185],
              [-13.97968376230104, -11.26537417994828],
              [-13.980321373886847, -11.263984976426192],
              [-13.979449466544642, -11.263164547676075],
              [-13.978552465763098, -11.26062007436331],
              [-13.97921152738082, -11.259236969361702],
              [-13.981333929248397, -11.260007204126945],
              [-13.984089465297904, -11.259567767030028],
              [-13.984921248957033, -11.254753212285184],
              [-13.986247417818666, -11.253932871480341],
              [-13.987091721201592, -11.252126272598316],
              [-13.989768443742603, -11.25166683462617]
            ]
          ],
          [
            [
              [-13.998305149237288, -11.254262830970692],
              [-13.991299431499213, -11.252132786711977],
              [-13.991691606056811, -11.256918998834204],
              [-13.99347263279808, -11.257844567495646],
              [-13.995856474303823, -11.25791425370059],
              [-13.997400794892185, -11.256383340164824],
              [-13.997117645719737, -11.25484106502464],
              [-13.998305149237288, -11.254262830970692]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -135.31431870627554,
          "lat": 57.24238969426386
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02220"],
        "coty_name": ["Sitka"],
        "coty_area_code": "USA",
        "coty_type": "city and borough",
        "coty_name_long": ["Sitka City and Borough"],
        "coty_fp_code": "220",
        "coty_gnis_code": "01419981"
      },
      "bbox": [
        -13.998305149237288, -11.716469103585887, -13.515932181017426,
        -11.17215087346415
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.472099481521646, -3.272804949332578],
            [4.467739545623223, -3.183570617310105],
            [4.476634082555407, -3.183382541306089],
            [4.554891171750835, -3.1801059018524893],
            [4.598357474216312, -3.175946837845498],
            [4.641299541121601, -3.171495896935505],
            [4.661601610304984, -3.1702589943977966],
            [4.728074034287693, -3.1666245380324676],
            [4.727908013195812, -3.1626737187877927],
            [4.761597039706881, -3.1610798399632314],
            [4.812871567021001, -3.1589183988626286],
            [4.813157945036798, -3.1659903341860227],
            [4.900674069979148, -3.1610781459588297],
            [4.9051949642006525, -3.249289233360123],
            [4.9093354287196185, -3.3454132784203243],
            [4.912661957744533, -3.4256021078172076],
            [4.916145387390233, -3.4253322398456723],
            [4.917502856424007, -3.460152800823954],
            [4.917568352801042, -3.4610859317043134],
            [4.838311697954711, -3.4640424231493574],
            [4.82957184974275, -3.4629608184365774],
            [4.808675716439987, -3.4635205857160027],
            [4.808716401622164, -3.4654161714037603],
            [4.794256680325712, -3.4657228038471874],
            [4.740437527770327, -3.467441434191625],
            [4.740374528709034, -3.46641234292715],
            [4.711328988413441, -3.4683766124375754],
            [4.6535199788057815, -3.4709581085252936],
            [4.6459984072452, -3.470421832778256],
            [4.616866340859475, -3.4729782074132274],
            [4.611900314066801, -3.4730197814186394],
            [4.567059972557355, -3.4750257704896996],
            [4.559819620076503, -3.4765754074736397],
            [4.53790888441202, -3.4778576402544097],
            [4.480569146809725, -3.480157248515525],
            [4.4775956863256985, -3.398467303296027],
            [4.476008354849371, -3.361479175150821],
            [4.474986441304051, -3.332221288051871],
            [4.472099481521646, -3.272804949332578]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.77112744386008,
          "lat": 35.295717100846936
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05037"],
        "coty_name": ["Cross"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cross County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00066848"
      },
      "bbox": [
        4.467739545623223, -3.480157248515525, 4.917568352801042,
        -3.1589183988626286
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.611680393211277, -3.602770220005574],
            [3.6108468195387142, -3.5477216119586097],
            [3.609108422808389, -3.451987828480574],
            [3.6079053176035143, -3.385614534824268],
            [3.6061242462953134, -3.3046328829842735],
            [3.6745181643735934, -3.3037800932388723],
            [3.689060646927501, -3.3041240746830316],
            [3.716489686151561, -3.3030603656573274],
            [3.7745737377903716, -3.301207260052659],
            [3.8157409117710857, -3.3000637205194283],
            [3.8140687465595327, -3.221397364774832],
            [3.8196473947214145, -3.219522423177351],
            [3.8255511363725767, -3.2155396373663243],
            [3.826944242234178, -3.2095700654202526],
            [3.830489298069453, -3.2022971097213793],
            [3.836734492716956, -3.2064545330856613],
            [3.8402292723956073, -3.206200107841812],
            [3.842582663902082, -3.2025725366143147],
            [3.8480699041183923, -3.2032796985521004],
            [3.856812051217306, -3.2002349248294015],
            [3.8555034539875104, -3.1488709018873777],
            [3.8552612352271636, -3.121176805522637],
            [3.902220810372249, -3.119134203471871],
            [3.923728772950829, -3.1189363673349324],
            [3.972673116656625, -3.117694891860293],
            [4.0258298024901835, -3.1172220830669075],
            [4.027303539286489, -3.1675182082896676],
            [4.028052782900252, -3.2058890984949167],
            [4.056131244616556, -3.205192701557388],
            [4.114033963437035, -3.2040501790351414],
            [4.21953177310061, -3.199991895164247],
            [4.217755608528731, -3.203588452681484],
            [4.211977279332712, -3.2092592708530723],
            [4.2120708943629515, -3.211732620910348],
            [4.219448140262673, -3.2132510370713074],
            [4.221872168742879, -3.215847366049625],
            [4.219838268968003, -3.2268245508331805],
            [4.217074594765983, -3.230371356992932],
            [4.2128648679898335, -3.2311356415562233],
            [4.207349588605812, -3.2238269049914585],
            [4.207525275689216, -3.2109155984912423],
            [4.202599616065785, -3.211271557603859],
            [4.200336708311627, -3.219994275304467],
            [4.2042490892758435, -3.227374536188201],
            [4.203959026541092, -3.2318178876513364],
            [4.198797208735505, -3.2368945541839294],
            [4.1944537719693695, -3.2386757799802783],
            [4.187425478361539, -3.2449171835402733],
            [4.179964516573339, -3.247050252307885],
            [4.179110820987978, -3.2506139759367496],
            [4.185973893635777, -3.255047613973152],
            [4.192717745873127, -3.261968135008881],
            [4.190343750828162, -3.266957931430149],
            [4.186418091297399, -3.266169032802719],
            [4.180941461840298, -3.2597131203014387],
            [4.174393015705991, -3.2553455527252186],
            [4.168637348828773, -3.2587049730866373],
            [4.1663963302922085, -3.2623897786964053],
            [4.161341054853149, -3.2649050892986593],
            [4.159383080874832, -3.2674738473017597],
            [4.162580118772912, -3.2733067899804786],
            [4.169180748567997, -3.273151198075243],
            [4.173012473758805, -3.277029121426766],
            [4.171909534187944, -3.281161192371649],
            [4.1663243002925086, -3.2804210568359626],
            [4.15745914929855, -3.272614273084911],
            [4.152955082309846, -3.2709842753778164],
            [4.1493759150643275, -3.274194207434167],
            [4.151463701981759, -3.279338550066248],
            [4.153971511975225, -3.281150204063439],
            [4.1609333421246415, -3.2818925920084108],
            [4.162075601255276, -3.286543631844114],
            [4.157986797851162, -3.292035039825664],
            [4.153190307273244, -3.2942729647906357],
            [4.147282243162672, -3.2947609489711374],
            [4.1454963466306785, -3.2988152475524886],
            [4.149980709998702, -3.3046351488719607],
            [4.155215090099836, -3.3043971413163375],
            [4.160718455956726, -3.307536805920102],
            [4.162301086762644, -3.312097910252353],
            [4.158879404155489, -3.3247581460186106],
            [4.155303731676488, -3.3278064526396958],
            [4.156294949404345, -3.3316739815998933],
            [4.15215389212976, -3.341681955562466],
            [4.153717704823727, -3.3473670424852933],
            [4.156089134816658, -3.3497002574377777],
            [4.160926742605642, -3.350022481414742],
            [4.167367473893951, -3.344709817682572],
            [4.170823111104837, -3.3378636888517907],
            [4.173410213938784, -3.3396597164356248],
            [4.172942540494238, -3.3456632361835723],
            [4.175070928868574, -3.349071314337742],
            [4.1759220481206105, -3.3778391034536965],
            [4.185057743141898, -3.377586498022145],
            [4.186068443570938, -3.3825503704366975],
            [4.192620163688645, -3.3896787376526554],
            [4.197625415611151, -3.39025578952299],
            [4.202336242559427, -3.385837127190478],
            [4.202194288127345, -3.374876782699826],
            [4.20510557877641, -3.373360114676983],
            [4.20872542617748, -3.377014285369664],
            [4.208124626569767, -3.385524538739887],
            [4.205526540019322, -3.389084772381353],
            [4.200052856937499, -3.393268420048339],
            [4.1977195495919855, -3.397618972747193],
            [4.19580624712501, -3.4081774273774395],
            [4.197516318314315, -3.412033354421767],
            [4.204426422492826, -3.4163142914811155],
            [4.205411446792815, -3.4184913987604437],
            [4.201644921405339, -3.421679529971235],
            [4.196274990872301, -3.4188984409557497],
            [4.1929058842914655, -3.4189426894814385],
            [4.1932451730971785, -3.4235888261431553],
            [4.201024797837002, -3.42434687498689],
            [4.204354120012579, -3.4272741383846874],
            [4.197063573604582, -3.4370626911088213],
            [4.1969014171371395, -3.4421997120580863],
            [4.199897027638629, -3.4439920372915442],
            [4.205344520214499, -3.4436510578922004],
            [4.207363418962137, -3.4459996098365986],
            [4.206830512517494, -3.4508068231695046],
            [4.20208141484147, -3.454390221567382],
            [4.194810123552287, -3.449917040139317],
            [4.192017325994023, -3.4447870649107313],
            [4.191699552610292, -3.4334685085611274],
            [4.189688434350765, -3.4292924690757767],
            [4.186032273743024, -3.4277070702722128],
            [4.181753983961998, -3.4300811180382134],
            [4.180236771558498, -3.434652450534553],
            [4.179395666546822, -3.4464945935921043],
            [4.175901065657808, -3.4505592010119703],
            [4.16661085288993, -3.4500062385290313],
            [4.163634644232178, -3.4529445288230805],
            [4.167556335134429, -3.4575503741646845],
            [4.170081452275879, -3.4637503483145347],
            [4.165465919685481, -3.4695808133830637],
            [4.163521413698199, -3.474939012856579],
            [4.159828994485273, -3.4788165239746927],
            [4.156651961547027, -3.479009118616586],
            [4.14640102063803, -3.474931342491995],
            [4.142096639743521, -3.477957231607585],
            [4.139434070452035, -3.484151264820592],
            [4.140800730979042, -3.4890543625614905],
            [4.1432873908829, -3.4901110026507305],
            [4.156789350367294, -3.49064169267704],
            [4.160578448416332, -3.4897686199241753],
            [4.163697978727403, -3.4919443614274726],
            [4.162848964283465, -3.4986144856817827],
            [4.163975995703483, -3.502231380546323],
            [4.167749714106394, -3.504462222463015],
            [4.168202183148657, -3.507567138825152],
            [4.160081288178569, -3.5090192023662388],
            [4.153882870631542, -3.5035889605777415],
            [4.150387871799, -3.5043649365247354],
            [4.150436011733239, -3.510577556079697],
            [4.15432677509278, -3.518575784286082],
            [4.16113892022482, -3.5261243221776843],
            [4.157189582455969, -3.5351376406369077],
            [4.158063942073069, -3.5403881520636715],
            [4.1603115751871025, -3.540893277434203],
            [4.165351049368269, -3.538414150350033],
            [4.168308735026388, -3.5332327273487887],
            [4.1706123148334875, -3.5328126419318435],
            [4.173511583856144, -3.5370293880382473],
            [4.171620423220926, -3.5415570186339616],
            [4.161935253141264, -3.5431295414258765],
            [4.150832623294419, -3.5435823257506036],
            [4.1501428368668885, -3.547113572817903],
            [4.153560370694837, -3.5562375559219657],
            [4.148696516840287, -3.556464938350799],
            [4.142479812637191, -3.5526586495864723],
            [4.141165649175711, -3.5562890384218413],
            [4.044790095009432, -3.558712356512856],
            [4.047012887940942, -3.6253377415539574],
            [4.04526978192978, -3.623809377003692],
            [4.032543031713767, -3.6250332712418576],
            [4.02885473240467, -3.6292462116400106],
            [4.024279055148636, -3.6306109870538847],
            [4.016087172031707, -3.627722448598959],
            [4.002267800048593, -3.6256694384326718],
            [3.9970796564295097, -3.612411767660608],
            [3.998363968346439, -3.61006765643752],
            [3.98824703720629, -3.60159018700862],
            [3.9824100288783186, -3.599086349054825],
            [3.97533025785745, -3.599248442791501],
            [3.9725933474483917, -3.6032261232311256],
            [3.969273459262988, -3.603547205221115],
            [3.9672384107218845, -3.6003606865571833],
            [3.9641679728848342, -3.6013221837315257],
            [3.961311956321358, -3.597299088252962],
            [3.9629675196106646, -3.5944026381582668],
            [3.95458792742045, -3.5933359843570303],
            [3.9509431151812784, -3.591749392964185],
            [3.9475492068425972, -3.594765356250449],
            [3.9455282439815393, -3.5924925736774105],
            [3.9376274576943966, -3.5976781110736424],
            [3.9349287219484435, -3.5968704450180664],
            [3.9297169115014032, -3.601660078543598],
            [3.916829563187681, -3.6093431526112214],
            [3.9070418566990655, -3.608486438725443],
            [3.9033483451024447, -3.6090520659560874],
            [3.8996173982783513, -3.6071253787724964],
            [3.895214243614113, -3.610268377736549],
            [3.8896732533390423, -3.610548651829157],
            [3.8872131576820332, -3.6144774912734348],
            [3.881868582563096, -3.6173923508603294],
            [3.873487280509107, -3.6159330959633054],
            [3.87016718821289, -3.6180242048456495],
            [3.870483434393164, -3.627918519656977],
            [3.8633724706457286, -3.6280444118409716],
            [3.8606616288175015, -3.6269999678466007],
            [3.852758677080114, -3.6272040446019522],
            [3.8465416290693124, -3.6313182642057624],
            [3.8433674557407778, -3.629286998649888],
            [3.8395876578299735, -3.6302472147504288],
            [3.837659421200635, -3.633013469656959],
            [3.8322848531952323, -3.632581049016818],
            [3.8300934254181485, -3.6358774307258646],
            [3.826166396931279, -3.634761874042392],
            [3.81658022896465, -3.6368600392000094],
            [3.8160870804047056, -3.635390345666556],
            [3.8088481091483946, -3.636804324546076],
            [3.8064866899556558, -3.6337248761141505],
            [3.8025711394595967, -3.6337037939391323],
            [3.7975424733242864, -3.6295242650777233],
            [3.7915942161093263, -3.631593237437304],
            [3.789464862876678, -3.6344827373438093],
            [3.7833088302860833, -3.6279258095473126],
            [3.7769478428622425, -3.624585028223279],
            [3.77626550646105, -3.621287523770606],
            [3.770193672013416, -3.61694137902536],
            [3.7661455222965246, -3.6187094657038528],
            [3.761662840979912, -3.617016977417721],
            [3.759180248801263, -3.619621552778209],
            [3.755361846235961, -3.6175578091067764],
            [3.7507461204377366, -3.6191699260666494],
            [3.745233992884122, -3.617199922385841],
            [3.7439819641516268, -3.6138074618232006],
            [3.7376294385080215, -3.6125778616479525],
            [3.7335317542161572, -3.6147372444011827],
            [3.724841281507209, -3.6066084639055553],
            [3.716007509362755, -3.6035947945013302],
            [3.7118011060649225, -3.6055843473011757],
            [3.7091126171185276, -3.6013731754244236],
            [3.7041974352492275, -3.5997852353758244],
            [3.7019284137556987, -3.597516808202218],
            [3.6977738460951075, -3.589381932703577],
            [3.69099626153752, -3.5937419741302645],
            [3.6841945209034077, -3.5949438316286235],
            [3.6801960878016766, -3.593249641543339],
            [3.675210055389214, -3.5952636601484382],
            [3.6739421236164307, -3.59802253524221],
            [3.667966575760514, -3.5999240447920795],
            [3.6608345450545836, -3.5966763414083767],
            [3.657278865679571, -3.5929194491521264],
            [3.6495508289136587, -3.5938009079967026],
            [3.647510281198916, -3.5927486289197215],
            [3.6436836027582205, -3.599542646780553],
            [3.6376903283756103, -3.6013457905731423],
            [3.636641351242507, -3.6035398508980596],
            [3.6306013415573513, -3.6041988484969294],
            [3.628288014721853, -3.6008390887353277],
            [3.6240883829420505, -3.6031338205777916],
            [3.612751961831737, -3.6020041792721202],
            [3.611680393211277, -3.602770220005574]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.74552788243174, "lat": 35.25623443578405 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05145"],
        "coty_name": ["White"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["White County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00069906"
      },
      "bbox": [
        3.6061242462953134, -3.6368600392000094, 4.221872168742879,
        -3.1172220830669075
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.315541738619803, -2.751312946708593],
            [-17.293025710074343, -2.7822109452311103],
            [-17.282841550650392, -2.794993744074231],
            [-17.283084455237887, -2.795989037448712],
            [-17.24781692489611, -2.8379707927709537],
            [-17.244271315720837, -2.8455914992091733],
            [-17.24643132845907, -2.8474809956031017],
            [-17.248264962288758, -2.8581793351680234],
            [-17.238600654673842, -2.8608908373403135],
            [-17.224407695181924, -2.8926034581315094],
            [-17.20821101366134, -2.93003362697511],
            [-17.193248429637382, -2.9622729848279397],
            [-17.19306100598662, -2.96385355637223],
            [-17.18501286828909, -2.9691975773716752],
            [-17.160266247534633, -2.982069603119074],
            [-17.16900126881353, -3.028894818634477],
            [-17.14082298556538, -3.0403096121069235],
            [-17.122650004585147, -3.046304018959902],
            [-17.113499623850558, -3.060887783634117],
            [-17.09025205372669, -3.0917002446323663],
            [-17.08335034732633, -3.101240451855338],
            [-17.08419262121072, -3.102749080900388],
            [-17.13217017294154, -3.1489833856140312],
            [-17.135968991837736, -3.1530026641243665],
            [-17.174609761023227, -3.190390005643177],
            [-17.179743621651355, -3.1962273120755893],
            [-17.189710903594197, -3.206126450838859],
            [-17.19250797316138, -3.219363357131245],
            [-17.18711176251145, -3.2207492030598552],
            [-17.190164426782086, -3.2318707980380434],
            [-17.194954412824778, -3.2306490649226642],
            [-17.195865526331104, -3.234610729125011],
            [-17.203295241798944, -3.2673452974356247],
            [-17.208561235636214, -3.2701516728517235],
            [-17.230200565797958, -3.277651705268814],
            [-17.24689761216424, -3.2779432434422717],
            [-17.262924879390095, -3.271881700534822],
            [-17.292067457778256, -3.333392719838325],
            [-17.29343176152884, -3.32341255746745],
            [-17.300004767232927, -3.307046134035873],
            [-17.30544680724634, -3.2950097257077684],
            [-17.311050379599045, -3.2848231194012913],
            [-17.31802288991007, -3.274314705996498],
            [-17.328167555939103, -3.2613214722279027],
            [-17.33207188975351, -3.257908673749199],
            [-17.338585674435254, -3.250082921037309],
            [-17.343920295764505, -3.245077672244379],
            [-17.3507172892402, -3.2436009889603246],
            [-17.351999676987, -3.247237870319596],
            [-17.356352165337487, -3.2485423825418502],
            [-17.363890051916723, -3.244446687041781],
            [-17.365292736145815, -3.241636888910921],
            [-17.371449269207552, -3.2405907741644713],
            [-17.370803212847857, -3.2360455503166947],
            [-17.375662216946605, -3.2153427893863773],
            [-17.381075988304513, -3.2122599869031463],
            [-17.38343903334961, -3.20724734046751],
            [-17.3834309780006, -3.2009327161126495],
            [-17.387658995279924, -3.1922683918948476],
            [-17.392036433296937, -3.1812107673282246],
            [-17.39559331848534, -3.1783432910683787],
            [-17.398684451099026, -3.1686059092961307],
            [-17.40493513631214, -3.158626858747366],
            [-17.40891852819766, -3.147299870024501],
            [-17.415159283725757, -3.143877799238604],
            [-17.417164823623704, -3.14156110105641],
            [-17.42385374052752, -3.1387058768007496],
            [-17.42555979779015, -3.134016611365748],
            [-17.43033432688357, -3.1326365657786175],
            [-17.434613999651635, -3.128016647153123],
            [-17.433398422224464, -3.125026830722357],
            [-17.437852962334862, -3.11811139053243],
            [-17.442493327716456, -3.114561998511356],
            [-17.4465460419591, -3.105426102568273],
            [-17.456027745318742, -3.096755908557572],
            [-17.463274969355776, -3.0891435972034467],
            [-17.46896793492506, -3.0805211355588646],
            [-17.479314346491584, -3.074810014971595],
            [-17.490422275726576, -3.0664974998782792],
            [-17.509706577805943, -3.0562539874785606],
            [-17.516870302167636, -3.0413145831624298],
            [-17.557237794518027, -2.996388710117186],
            [-17.574871647345077, -2.9687570722565937],
            [-17.57916636551745, -2.9608853178490704],
            [-17.588785026834337, -2.940429012833003],
            [-17.59535767275326, -2.9284679953727704],
            [-17.610451063280635, -2.904361597569359],
            [-17.628922555713963, -2.887503585464277],
            [-17.626141245437967, -2.8842378832923967],
            [-17.60657054795399, -2.8770999118361136],
            [-17.605455153444748, -2.8710986097206046],
            [-17.60711912060377, -2.8612030201295258],
            [-17.605589607997814, -2.8560210862718507],
            [-17.59304909973193, -2.8405890098026627],
            [-17.590458753085187, -2.8349658560634707],
            [-17.578127630173, -2.8255286320073374],
            [-17.56925351741857, -2.8226359230692455],
            [-17.566630374935833, -2.8110089304271457],
            [-17.562299484620265, -2.808225657170325],
            [-17.559795129163394, -2.7974563304884175],
            [-17.556297217792487, -2.798258223250867],
            [-17.555491386950223, -2.794723252806621],
            [-17.551969123248142, -2.795403557066043],
            [-17.551010230050796, -2.791911919691269],
            [-17.54768088115285, -2.7926478582734955],
            [-17.546590159130456, -2.7876560825839145],
            [-17.543106214284514, -2.7884500536060055],
            [-17.542293592101696, -2.7849021315595213],
            [-17.538797030459044, -2.78568857484338],
            [-17.538003181808897, -2.782108287287349],
            [-17.530826009785454, -2.783563813874132],
            [-17.529239765961847, -2.776617881485348],
            [-17.51525825379364, -2.7797998384801517],
            [-17.513616650304623, -2.7725205320086674],
            [-17.506611409455928, -2.774120643814277],
            [-17.50501267602095, -2.7669841593928375],
            [-17.49794331000347, -2.768589397403767],
            [-17.49632109600226, -2.761429403569434],
            [-17.489235806159652, -2.7630035964982196],
            [-17.48768388786055, -2.7561495283132316],
            [-17.48056735599016, -2.757591860291262],
            [-17.470507688436303, -2.71525396382396],
            [-17.418718655110364, -2.727387805253185],
            [-17.386780583534396, -2.735225306987692],
            [-17.370483441120072, -2.737794808926044],
            [-17.322368532762287, -2.749356005469236],
            [-17.315541738619803, -2.751312946708593]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -117.76092922224773, "lat": 33.7030590787256 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06059"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00277294"
      },
      "bbox": [
        -17.628922555713963, -3.333392719838325, -17.08335034732633,
        -2.71525396382396
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.883324017724654, 1.3877528835199433],
            [-19.881989945436136, 1.3820740828719837],
            [-19.883481570306373, 1.3787923431312261],
            [-19.881506410942606, 1.3706198897443163],
            [-19.876299583769413, 1.3641163526316418],
            [-19.87610611390752, 1.3616388742175067],
            [-19.872455086970625, 1.356505041792948],
            [-19.867623788185313, 1.3544853109257882],
            [-19.863492740225094, 1.3439025141354324],
            [-19.860314166890717, 1.333735489844762],
            [-19.861069176719123, 1.327162486945014],
            [-19.85843974931788, 1.3257086546504222],
            [-19.854203319928374, 1.3199534430813418],
            [-19.8531360860084, 1.31339188259173],
            [-19.846102414300073, 1.3115168719686678],
            [-19.839910680474134, 1.3027504300629673],
            [-19.83852711153263, 1.2957975120799188],
            [-19.833488364262667, 1.2967462358945567],
            [-19.830107111181782, 1.2932714033453407],
            [-19.826064579917038, 1.2865499949470076],
            [-19.823594642656452, 1.2756161346423605],
            [-19.817390518205833, 1.2684404485501148],
            [-19.819869987935085, 1.2650998533554743],
            [-19.819241460053572, 1.2579104082225558],
            [-19.820232316315497, 1.2449787696397956],
            [-19.813595275141523, 1.2412509510878493],
            [-19.807120182046315, 1.2323079044914327],
            [-19.804864793902706, 1.2318617255053412],
            [-19.803751940685462, 1.2273943323987144],
            [-19.800571270695645, 1.2217053562494256],
            [-19.799733094925834, 1.215546437321482],
            [-19.796590116630078, 1.2152407295311762],
            [-19.79248083123236, 1.211428793164575],
            [-19.78617532188772, 1.2088721199067143],
            [-19.781576337023143, 1.1988620344608831],
            [-19.77577856272823, 1.1929819078400055],
            [-19.7664076001027, 1.1870039595276967],
            [-19.76175435415507, 1.182682768810672],
            [-19.75518422752595, 1.178968503332708],
            [-19.747031354807795, 1.168318719653059],
            [-19.7381967901003, 1.1631538998650521],
            [-19.731477285941743, 1.1552091378363891],
            [-19.728834346901724, 1.1575013284513103],
            [-19.71913389933856, 1.148947025419796],
            [-19.71096033167291, 1.1486830791169982],
            [-19.713696209011506, 1.1443892963050732],
            [-19.704053352334995, 1.1413341464394424],
            [-19.701447182966273, 1.136135578536449],
            [-19.694931118088164, 1.1306514014378413],
            [-19.6935208316693, 1.1275022031675115],
            [-19.688076966817714, 1.1249061994100829],
            [-19.6848157879417, 1.1200680670532763],
            [-19.68550408114541, 1.1140349048090725],
            [-19.68268446887815, 1.1103941648934788],
            [-19.68165134946735, 1.1039719586786165],
            [-19.67638182256594, 1.1006075002603402],
            [-19.673113767271023, 1.0955799066474112],
            [-19.671182466394995, 1.0958285055487975],
            [-19.66637647924508, 1.0922282700394625],
            [-19.664026135163134, 1.0861687862725777],
            [-19.658659667213723, 1.0800967420126257],
            [-19.653919630042992, 1.07947087619031],
            [-19.65328105407355, 1.0750393627064976],
            [-19.650671140948457, 1.0726167729064253],
            [-19.647778201019996, 1.073940067578305],
            [-19.646012612693692, 1.06963575420561],
            [-19.63977528128221, 1.0481958095265569],
            [-19.632354575615295, 1.0414950587937561],
            [-19.640729572297808, 1.0360578386324306],
            [-19.635830460248275, 1.0289569021271165],
            [-19.629553535228403, 1.024800730398325],
            [-19.640446478526584, 1.017675925620906],
            [-19.64299568985502, 1.010997062865278],
            [-19.63211745728722, 1.0129441387070308],
            [-19.627305412611356, 1.0064155099819676],
            [-19.62436205582382, 1.0042973073681631],
            [-19.625000347957904, 1.0012109123730148],
            [-19.617758875157566, 0.9980567927141198],
            [-19.62325468268331, 0.9864376829866356],
            [-19.620754447749917, 0.9811616518590589],
            [-19.61687077910109, 0.9787458574623539],
            [-19.609383793854096, 0.977614024080891],
            [-19.604166653991996, 0.9717605791911478],
            [-19.600224576410746, 0.970745952050875],
            [-19.599981541486727, 0.9658989703916654],
            [-19.602252736166616, 0.9588807835836416],
            [-19.595561504140292, 0.9557022676477794],
            [-19.597190457132193, 0.9469006208871972],
            [-19.594183390133097, 0.9362008721261513],
            [-19.59086991860007, 0.9351819970579613],
            [-19.590403930885945, 0.9393675174138655],
            [-19.585708508272518, 0.9408995097883475],
            [-19.580275475261786, 0.9409594818442948],
            [-19.576024531474744, 0.9393134774262554],
            [-19.56638845120795, 0.921943992541748],
            [-19.553538938654494, 0.9185021423228747],
            [-19.55523921443219, 0.9117461149156186],
            [-19.54836945616439, 0.9098510141251644],
            [-19.553918707432672, 0.8903318714628548],
            [-19.556947524474825, 0.8930524002885974],
            [-19.56363499043025, 0.8950400077108103],
            [-19.573688900309673, 0.8961018633076745],
            [-19.57856874750129, 0.9032527603797152],
            [-19.580617657240236, 0.9079222655865918],
            [-19.587298217551595, 0.9126693586039661],
            [-19.5974662179806, 0.90149281565815],
            [-19.603134329169574, 0.898523585118904],
            [-19.60246911312786, 0.9068437809297252],
            [-19.606074360869602, 0.9058538689333109],
            [-19.607903907517155, 0.9100909908956474],
            [-19.605577521351965, 0.9139253598261688],
            [-19.60573071967802, 0.9174400746325663],
            [-19.611505236500303, 0.9218847959244715],
            [-19.616336437909393, 0.9210692579826747],
            [-19.61929756160129, 0.9189097929885317],
            [-19.628586443289354, 0.9152970741393891],
            [-19.631690139486278, 0.9209398288678464],
            [-19.639179908262065, 0.9269496737905887],
            [-19.643831975705766, 0.9246436393195883],
            [-19.646429065976843, 0.9285284203200587],
            [-19.641307022244508, 0.929710871081771],
            [-19.638574545256464, 0.9321571292436567],
            [-19.638921077345614, 0.9353383539254518],
            [-19.645379006892764, 0.9323565663400457],
            [-19.647764970873155, 0.9332024569159744],
            [-19.653636026781776, 0.928091017277182],
            [-19.659924446724926, 0.9355702586131477],
            [-19.662842125090062, 0.9333100841218316],
            [-19.669489009210285, 0.9321122054293152],
            [-19.675628261628173, 0.9348066257318212],
            [-19.681982563005036, 0.932247146378335],
            [-19.68813776407519, 0.9283534315968375],
            [-19.69708613541175, 0.9185691087268516],
            [-19.70398302881029, 0.9157677165169859],
            [-19.714735144624218, 0.9200179971916604],
            [-19.720809074427333, 0.9165175122850344],
            [-19.73206166046595, 0.9064735734448284],
            [-19.731665990028464, 0.8999586412314964],
            [-19.733640424522974, 0.895492864153177],
            [-19.74199419602021, 0.8916378573979445],
            [-19.74728000438258, 0.9231913795081006],
            [-19.75952124623773, 0.9813107215084523],
            [-19.76812102759494, 1.0032047757331763],
            [-19.775995771412056, 1.0176675207955108],
            [-19.783060478392645, 1.0270827584382125],
            [-19.798542805279048, 1.0410559144242644],
            [-19.805732880146437, 1.0429629152002522],
            [-19.816825149326984, 1.0391489143400727],
            [-19.83761661258249, 1.0268368676933644],
            [-19.84000631937739, 1.0274017564153053],
            [-19.844847206930496, 1.0336612823956715],
            [-19.851611300311387, 1.035954363741839],
            [-19.86559995388006, 1.0441897307474355],
            [-19.873992934929692, 1.0454283073356618],
            [-19.876985064188673, 1.0427684161918924],
            [-19.876694746395003, 1.0392779423490561],
            [-19.8791833129238, 1.0360351985279155],
            [-19.889969186510296, 1.040360311154896],
            [-19.89228180705861, 1.0385941647064738],
            [-19.89769069400044, 1.0385949818585136],
            [-19.909937085509394, 1.0411808771112672],
            [-19.925136354216523, 1.0511402556451632],
            [-19.934738626664107, 1.0555413376797194],
            [-19.94014193928779, 1.059942659075658],
            [-19.943588781643502, 1.065550974557484],
            [-19.94663831900779, 1.0664608992300517],
            [-19.948736985643585, 1.0705673212157816],
            [-19.95210983038608, 1.0697184468312435],
            [-19.95760711402636, 1.074859243492617],
            [-19.959764798823294, 1.0829950225423282],
            [-19.96916038936059, 1.0875955299316578],
            [-19.96918748888821, 1.0918431313591788],
            [-19.97312657249654, 1.1005174691584725],
            [-19.977659441170573, 1.1025770808084614],
            [-19.977571725850385, 1.104856999104256],
            [-19.981201978816358, 1.1104930455322457],
            [-19.98601939840062, 1.115044523347757],
            [-19.987191692526387, 1.1206369322217626],
            [-19.99338186590122, 1.1293739448291051],
            [-19.998995182664377, 1.1349891158278378],
            [-20.000597717976113, 1.1418191268103024],
            [-20.00461566271483, 1.1448959298264816],
            [-20.004041704539762, 1.1477215112315848],
            [-20.00917733066928, 1.1501697024173578],
            [-20.009424786497817, 1.1637764024883797],
            [-20.017088985521994, 1.1814713104978138],
            [-20.021468513069994, 1.1890896247387746],
            [-20.024171215841623, 1.2036012303294128],
            [-20.03082328956156, 1.2228820143438912],
            [-20.03467069299627, 1.2372184189669406],
            [-20.039282746356523, 1.2443737215111328],
            [-20.034856977735473, 1.2495751160906123],
            [-20.04247129325365, 1.2874934953110186],
            [-20.03607545876511, 1.3270245149667836],
            [-20.014044132051076, 1.3205585953395709],
            [-19.998237877285533, 1.3193254343789091],
            [-19.978282314969427, 1.3138710151550719],
            [-19.97130719953875, 1.3382294563958825],
            [-19.90307280405823, 1.3192605701423972],
            [-19.90130409964341, 1.3261039419497327],
            [-19.89807354620287, 1.3331420399170173],
            [-19.89512169616135, 1.3470065971440637],
            [-19.883324017724654, 1.3877528835199433]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.00181043267047,
          "lat": 37.05624519851755
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06087"],
        "coty_name": ["Santa Cruz"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Santa Cruz County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00277308"
      },
      "bbox": [
        -20.04247129325365, 0.8903318714628548, -19.54836945616439,
        1.3877528835199433
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.381893427364851, -0.5477213639170566],
            [-7.360529985651117, -0.549826584662045],
            [-7.260354447723969, -0.5593482638259756],
            [-7.20327409082798, -0.5643087917219426],
            [-7.125425208564648, -0.5713467644717818],
            [-7.059997391787175, -0.5775495621099808],
            [-7.05348930095753, -0.5777863568192297],
            [-6.960691451814396, -0.5884716598752],
            [-6.928917208757905, -0.5911826929621486],
            [-6.929430398708609, -0.5956371198293196],
            [-6.926527087169403, -0.602643741717037],
            [-6.928689765254111, -0.606302357755415],
            [-6.928011269410097, -0.611041106698673],
            [-6.929331202028869, -0.6190611062323982],
            [-6.9320361996086, -0.6235423127474252],
            [-6.935758228689742, -0.6250480126154521],
            [-6.937895490019853, -0.628506021573112],
            [-6.943756574320869, -0.6305110393498319],
            [-6.948936773229974, -0.6336076807106836],
            [-6.953512171320751, -0.6472870241033074],
            [-6.953803032634338, -0.6539302142240501],
            [-6.951572267990293, -0.6567604376191188],
            [-6.951296334720099, -0.6623156126061063],
            [-6.95333815346693, -0.6680164087026901],
            [-6.953060561505407, -0.6752958635400913],
            [-6.956537529105719, -0.6795104481142062],
            [-6.957115337522992, -0.6826776221020264],
            [-6.961932601675135, -0.6873119299457287],
            [-6.963489724508894, -0.6962495509499536],
            [-6.968037449280153, -0.7056770518782559],
            [-6.968339297980856, -0.7155714769852661],
            [-6.972728309667293, -0.7210356869419525],
            [-6.974966440297326, -0.725933986789143],
            [-6.973076173360579, -0.7285315908253575],
            [-6.971517047433528, -0.7352606315966886],
            [-6.9721379914626445, -0.7396309893260801],
            [-6.978626897688737, -0.7413307193080477],
            [-6.978588245948983, -0.7438776638418533],
            [-6.974835241532754, -0.7479579206529936],
            [-6.974787363638636, -0.7549697922285732],
            [-6.968398417340742, -0.7633657220865723],
            [-6.972667043252939, -0.7654112025952902],
            [-6.97742199336952, -0.7704165286153192],
            [-6.978242558161003, -0.7766340053724664],
            [-7.046780833212552, -0.8366441530077057],
            [-7.065415887129134, -0.8527658106649322],
            [-7.070991464940174, -0.8583406490482735],
            [-7.088600276792722, -0.8733395278540593],
            [-7.192558396493509, -0.9650028523689594],
            [-7.277258420262104, -0.9567747675032083],
            [-7.336657926532802, -0.9504802668256065],
            [-7.345206303230651, -0.9494182774645611],
            [-7.381480801231193, -0.945864849180148],
            [-7.423951040566881, -0.9406806459551951],
            [-7.419605382638259, -0.8965702492475972],
            [-7.405154128359242, -0.7606617674184916],
            [-7.400828243037718, -0.7197222832440818],
            [-7.393212957416669, -0.6495664409228519],
            [-7.381893427364851, -0.5477213639170566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.78836449740415,
          "lat": 37.57291170402426
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08003"],
        "coty_name": ["Alamosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alamosa County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00198117"
      },
      "bbox": [
        -7.423951040566881, -0.9650028523689594, -6.926527087169403,
        -0.5477213639170566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.0416934554592805, 0.5469679402531401],
            [-5.012718580079566, 0.5457892966808501],
            [-5.005269988397128, 0.5450804009165916],
            [-4.955783657564042, 0.5425032853650437],
            [-4.899095976826971, 0.538057161520341],
            [-4.719126228192557, 0.5257851550256218],
            [-4.704744186474453, 0.5249295547573138],
            [-4.698449891581454, 0.5229413244497126],
            [-4.662664937766667, 0.5211785630713246],
            [-4.5670290376719045, 0.5161139246671592],
            [-4.50640987271436, 0.513696028341302],
            [-4.471369199301867, 0.5127843046382315],
            [-4.436859057417131, 0.5111458920170221],
            [-4.430869118196243, 0.5115289564173262],
            [-4.362805146155954, 0.5077286111898576],
            [-4.184257398984513, 0.49683040895674296],
            [-4.198344278634931, 0.2613491345296642],
            [-4.200312017546688, 0.2311837487198303],
            [-4.2056423509174214, 0.14462666004407662],
            [-4.2073297162853525, 0.11645478357088274],
            [-4.210989341728457, 0.061597134723195286],
            [-4.22917205753105, 0.06276512496361247],
            [-4.427483315304927, 0.0758650014179736],
            [-4.428887519343515, 0.07581085911889125],
            [-4.527023528862193, 0.08206961425787487],
            [-4.570063282447544, 0.08382044147388816],
            [-4.64799891005964, 0.08879070821504598],
            [-4.688067914465212, 0.09170571602293837],
            [-4.827936803076682, 0.10263206093233536],
            [-4.967806809070087, 0.11354358436681798],
            [-5.081669256070253, 0.11948839259386991],
            [-5.075399263348141, 0.19760115991591573],
            [-5.068984171568555, 0.1971933667043499],
            [-5.063186761314571, 0.2701951244077562],
            [-5.057701012065332, 0.34327733873421096],
            [-5.052187971671191, 0.41184766326976946],
            [-5.0416934554592805, 0.5469679402531401]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.60356561187422,
          "lat": 38.82792427802275
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08017"],
        "coty_name": ["Cheyenne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cheyenne County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00198124"
      },
      "bbox": [
        -5.081669256070253, 0.061597134723195286, -4.184257398984513,
        0.5469679402531401
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.340342068121204, 1.0547090070827696],
            [-8.376965960000973, 0.7537490114932206],
            [-8.39137519728179, 0.6350988156052262],
            [-8.407333313373782, 0.5041500994500081],
            [-8.481162647625524, 0.5130837836749678],
            [-8.598101097148838, 0.5273012185586667],
            [-8.5996733148918, 0.5272839285543133],
            [-8.67437531189489, 0.536668984247401],
            [-8.789656584535853, 0.5515767621274659],
            [-8.835673648173218, 0.5573473030563122],
            [-8.86401731550341, 0.5610863987581857],
            [-8.941962272766723, 0.5710418720664506],
            [-9.080977920585063, 0.5887555265613252],
            [-9.06006635489062, 0.7498974414747339],
            [-9.05954244397213, 0.7502259374288787],
            [-8.960628958813011, 0.7782778443843396],
            [-8.940101453701017, 0.7839007752478794],
            [-8.89699281757178, 0.7961927173982626],
            [-8.891664299753437, 0.7985592712738881],
            [-8.887936056289185, 0.8020807885625878],
            [-8.882822523456884, 0.8002095264419383],
            [-8.877487865693885, 0.7997424005541064],
            [-8.872465859363286, 0.805410918455359],
            [-8.867231070468009, 0.8060576449915612],
            [-8.869351831582765, 0.8156283063711814],
            [-8.86593008675924, 0.8179584216848014],
            [-8.865707335081648, 0.8215432348234506],
            [-8.8630346392489, 0.8231125960888613],
            [-8.858102370066469, 0.8186656128002194],
            [-8.853443747732513, 0.8201962926719689],
            [-8.8482891820777, 0.8242459047890858],
            [-8.846848193002954, 0.826942669160303],
            [-8.840957518433223, 0.8319914565320193],
            [-8.832961352642775, 0.8427974459913488],
            [-8.826865296173104, 0.8497351996387544],
            [-8.819734048038463, 0.8553542098486449],
            [-8.818801992360418, 0.8599412034998203],
            [-8.820996825576367, 0.8640975051909868],
            [-8.8233338918044, 0.8726118651425164],
            [-8.816903442748062, 0.8751460599720314],
            [-8.810357050434707, 0.8825999602504678],
            [-8.802213922928093, 0.8871208345130411],
            [-8.797081139097994, 0.894157629936228],
            [-8.79458303836498, 0.8950123165821506],
            [-8.78762668620556, 0.9030290175438632],
            [-8.7848794101995, 0.9037789350210528],
            [-8.783394999791357, 0.8998436510354831],
            [-8.773746214668288, 0.904443980426342],
            [-8.773068507013459, 0.9078411794292945],
            [-8.769325820514675, 0.9142024730978338],
            [-8.762008087480753, 0.9169015291525507],
            [-8.755923367580303, 0.9214492239427513],
            [-8.74629328739746, 0.9261251056791852],
            [-8.743067126973653, 0.9293036471689594],
            [-8.731871140236812, 0.9354492123444788],
            [-8.72714335078197, 0.9419750088410416],
            [-8.719681543285994, 0.9423872172600297],
            [-8.713534235495475, 0.9400288431382162],
            [-8.703549441473228, 0.9388098749273659],
            [-8.69230432251534, 0.9397938079928703],
            [-8.677270706242938, 0.9398958593150856],
            [-8.6700191392268, 0.935425212391914],
            [-8.664238855606607, 0.9397726360512633],
            [-8.65454920331882, 0.9398683415222161],
            [-8.647899197524245, 0.9433963525317887],
            [-8.644474809692346, 0.9426223229763372],
            [-8.63964464744799, 0.9462544184169821],
            [-8.637455554729282, 0.945722259601005],
            [-8.633530419411267, 0.9495018411846707],
            [-8.63052949847148, 0.9503829440317206],
            [-8.626538413189468, 0.9480502313688308],
            [-8.616496802628944, 0.9456293832338103],
            [-8.608130215178246, 0.939083515261886],
            [-8.603401219183176, 0.9372204840425662],
            [-8.597480951537284, 0.9331742728690469],
            [-8.589144027004265, 0.9296154023845142],
            [-8.582492216413865, 0.9248444662121426],
            [-8.580144832035487, 0.9198334727334578],
            [-8.578168429815253, 0.9195036996318044],
            [-8.573431719067198, 0.9146723564035888],
            [-8.568083869058052, 0.9055302909067915],
            [-8.563360418942603, 0.9059496344309612],
            [-8.561505296179153, 0.9083058344571168],
            [-8.555854669497034, 0.9103183199587297],
            [-8.554998826970067, 0.91428408736013],
            [-8.551162739367964, 0.9138999155789652],
            [-8.54686426698955, 0.9170881047613069],
            [-8.545410767066578, 0.9215269544663406],
            [-8.539841038026161, 0.9246613478648622],
            [-8.536011017926281, 0.9211923626300638],
            [-8.533273958031833, 0.9240968234496847],
            [-8.527757198374754, 0.9252550243544325],
            [-8.52244363683756, 0.9309785993882953],
            [-8.518819603974551, 0.9371415450096322],
            [-8.511655053733211, 0.9405390062902075],
            [-8.508843856733227, 0.9390356517926546],
            [-8.500459113498053, 0.9413697562787409],
            [-8.494730305749428, 0.9462878014397738],
            [-8.492170303023155, 0.9536551557893863],
            [-8.486745952322803, 0.953835754169847],
            [-8.482776904136122, 0.9610069772922807],
            [-8.478667533148974, 0.9613371392984714],
            [-8.474633762232742, 0.9639938267918471],
            [-8.475461653701805, 0.9693106261237758],
            [-8.468598649581061, 0.9748999182655098],
            [-8.465877816384486, 0.9816121362710716],
            [-8.463123699272261, 0.9817672151293012],
            [-8.454275952740991, 0.9914620998427327],
            [-8.450234900794122, 0.9898452027638593],
            [-8.44575423966208, 0.9975171085454029],
            [-8.440498244202074, 0.998936742021199],
            [-8.438368996903547, 1.0025917445212924],
            [-8.434750768829316, 1.0016886800106535],
            [-8.428666978869439, 1.0081992919676595],
            [-8.423449865554893, 1.0101515757462347],
            [-8.417913679680836, 1.0101846660281402],
            [-8.410089586302407, 1.016313364067918],
            [-8.4090057015115, 1.018157614607756],
            [-8.400580106758817, 1.0197845973660156],
            [-8.395716646390026, 1.0243252916411167],
            [-8.391049111068712, 1.0207333218907824],
            [-8.38809334878139, 1.020284670131005],
            [-8.376884908523298, 1.0228393610595745],
            [-8.375859460760777, 1.03512356389806],
            [-8.369650595610139, 1.038417437871631],
            [-8.363855252388964, 1.0383627244815263],
            [-8.362547134776511, 1.043143308327077],
            [-8.357052544508523, 1.0449144069395948],
            [-8.350895209245689, 1.0520108138721829],
            [-8.347538594640797, 1.0542003747775466],
            [-8.340342068121204, 1.0547090070827696]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.86291655763576,
          "lat": 38.86137580393473
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08029"],
        "coty_name": ["Delta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delta County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00198130"
      },
      "bbox": [
        -9.080977920585063, 0.5041500994500081, -8.340342068121204,
        1.0547090070827696
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.928917208757905, -0.5911826929621486],
            [-6.927299723580296, -0.5862357085613508],
            [-6.9283976486958245, -0.5824403942068465],
            [-6.924563397822059, -0.5755632958358863],
            [-6.921527046609894, -0.5724910607427982],
            [-6.9215994018545395, -0.5678310481666012],
            [-6.919957618471077, -0.5638240486686918],
            [-6.921468009531802, -0.560294131682529],
            [-6.921010541461881, -0.5560167679555643],
            [-6.923359426398057, -0.5518054027180336],
            [-6.922655661918323, -0.5469214112245807],
            [-6.9163628078183645, -0.5431196481512407],
            [-6.906382661793242, -0.5393387026171949],
            [-6.905668082627367, -0.5293940168942677],
            [-6.906150684445331, -0.5246972400102065],
            [-6.903564942687899, -0.5195886169518271],
            [-6.904321330921427, -0.5154551797156379],
            [-6.897427628954077, -0.5007564687046863],
            [-6.8988034962945814, -0.496870924618934],
            [-6.896791211717092, -0.4926335964054632],
            [-6.899767543902381, -0.48646880965849887],
            [-6.903660100855808, -0.4822664961527765],
            [-6.904220105906547, -0.4737503654625795],
            [-6.90610571927104, -0.4724360048246699],
            [-6.910987260326027, -0.46444982562869497],
            [-6.91820468957992, -0.46145322869327227],
            [-6.92540084567568, -0.4623579813018702],
            [-6.931786913488568, -0.46000734061730436],
            [-6.930621973481828, -0.45249333149464255],
            [-6.926822448542168, -0.4447455487301908],
            [-6.922020756589881, -0.4456873095179859],
            [-6.915840198994588, -0.4446261884451625],
            [-6.910643593627707, -0.44665493560518194],
            [-6.901065789974936, -0.44580363234114434],
            [-6.8948413575420835, -0.44875156357366197],
            [-6.891974098816216, -0.4529408553970082],
            [-6.885058174950816, -0.4552696771454907],
            [-6.881045489009215, -0.45483234371482917],
            [-6.876814588585267, -0.45127983594555976],
            [-6.872578097581384, -0.45034068434357055],
            [-6.85007932490865, -0.43195110510430795],
            [-6.839139584430363, -0.4269772523466761],
            [-6.825991625975936, -0.42554705610516175],
            [-6.819993577983277, -0.42150650655641014],
            [-6.816190161315858, -0.4176764923174314],
            [-6.807005758547017, -0.41354204720047255],
            [-6.801168277589879, -0.41359379053579304],
            [-6.7936589584683595, -0.4210864910338589],
            [-6.791955061623248, -0.4274473160905779],
            [-6.789877729258972, -0.4307997484597331],
            [-6.791236889443712, -0.4357050854419882],
            [-6.790700072594404, -0.4414712933378387],
            [-6.788814677853511, -0.44484132650506214],
            [-6.784979521929658, -0.44595218303359013],
            [-6.784382554197813, -0.4508079537721634],
            [-6.7801856047510745, -0.4557609097186614],
            [-6.7764883997158565, -0.4543029050913597],
            [-6.770618173650285, -0.4483211937092272],
            [-6.765088119319748, -0.43807994730720506],
            [-6.759540919169588, -0.43118222319181493],
            [-6.760750321940691, -0.4278344691327788],
            [-6.758180243620876, -0.41961572896278115],
            [-6.754974114489738, -0.41895199610363265],
            [-6.752864210214791, -0.41430322693627036],
            [-6.747920852219318, -0.40721500061862337],
            [-6.741196859142111, -0.4043900803869603],
            [-6.7375637079044175, -0.40093053110166765],
            [-6.738058273391803, -0.3958174646501594],
            [-6.730455299769683, -0.39383429216565996],
            [-6.728134814239679, -0.3954269364197295],
            [-6.7252257426633415, -0.3907326443301842],
            [-6.719020666934355, -0.3895954114062139],
            [-6.719430685647011, -0.38462674766483185],
            [-6.717178960331085, -0.379892624130074],
            [-6.710418368709285, -0.3774979820358777],
            [-6.709926184522318, -0.3710526124533109],
            [-6.704241240251807, -0.3710842948730042],
            [-6.702670781593693, -0.3689692242750419],
            [-6.704156899908291, -0.36028341268405867],
            [-6.699261815078753, -0.35393570814954906],
            [-6.693656760569459, -0.3513972332705883],
            [-6.691445861904605, -0.3487901485922353],
            [-6.686214098611487, -0.34615715618625076],
            [-6.678013389457148, -0.3444432373123065],
            [-6.672449239998784, -0.34810616235255415],
            [-6.663185747733827, -0.3587678543315159],
            [-6.667777381168438, -0.36385854482926233],
            [-6.668069366017019, -0.37262712742383],
            [-6.6650651407618104, -0.37826570858449177],
            [-6.661817438245631, -0.3775677376480196],
            [-6.658706287645417, -0.38114573195195184],
            [-6.659989900181069, -0.38592495181689424],
            [-6.653276489395652, -0.3937679947921492],
            [-6.657337947859824, -0.39884153226924607],
            [-6.656063167896805, -0.4032810561387209],
            [-6.650846388732564, -0.40610585887607586],
            [-6.651580103907611, -0.4153845903034468],
            [-6.6490139536376995, -0.4180228108300666],
            [-6.644781981038537, -0.4184666498344978],
            [-6.638608548071851, -0.4248853940143043],
            [-6.631144511566617, -0.4240362050570435],
            [-6.622175324110155, -0.42119932859989223],
            [-6.6187002409513935, -0.41463846941695176],
            [-6.61381662664248, -0.41756141028861404],
            [-6.61148108442284, -0.4223003061795667],
            [-6.605530212771238, -0.4272359657996337],
            [-6.606363776233244, -0.43292212328043733],
            [-6.6044845680499975, -0.43667667450699654],
            [-6.605164015262263, -0.4424262656134246],
            [-6.60726294968794, -0.4452879704848766],
            [-6.607625053066285, -0.4508193835897585],
            [-6.605928441081526, -0.4548232361083847],
            [-6.601362121624703, -0.4563046715219224],
            [-6.59896134603825, -0.454948603068645],
            [-6.595742236697485, -0.4573153346452956],
            [-6.588599773081198, -0.4654578875123184],
            [-6.588049637295487, -0.4692432766898283],
            [-6.582561725464079, -0.4700678021771046],
            [-6.585990833200247, -0.47944235887747055],
            [-6.576513617600976, -0.4875391655799024],
            [-6.572037298617927, -0.4899746254600414],
            [-6.5708694498331575, -0.4943855495876921],
            [-6.517634983151133, -0.49558473220754223],
            [-6.426036646181786, -0.4980233475563229],
            [-6.283222242334971, -0.5016569739574852],
            [-6.227251709408296, -0.5278782600439179],
            [-6.085701012447549, -0.5941500900727096],
            [-6.0607757851666735, -0.6057875862506863],
            [-6.079245465729972, -0.6214753333392978],
            [-6.149319031112192, -0.6685015940089015],
            [-6.148552301656437, -0.6757078829651643],
            [-6.23338858973293, -0.801326276412939],
            [-6.236721822481181, -0.836229044240649],
            [-6.296839566326644, -0.8760491516122167],
            [-6.304313739143536, -0.8947854533387052],
            [-6.322622495899533, -0.9089149433363871],
            [-6.336166689603682, -0.908213212542248],
            [-6.3511282222373815, -0.9056271334708124],
            [-6.356550866780705, -0.9099613282388591],
            [-6.356765647763959, -0.9146086445053576],
            [-6.360217596661465, -0.9155077137397535],
            [-6.357405602068917, -0.9222485342440695],
            [-6.360859907547302, -0.9255604809375959],
            [-6.365251488245852, -0.9370323588382701],
            [-6.364439299049726, -0.9419432069416107],
            [-6.367092374294086, -0.9506088495041755],
            [-6.3636053056136435, -0.9613394741106108],
            [-6.380294289358795, -0.9650800701231667],
            [-6.384997269687336, -0.9700191922483626],
            [-6.3880617277711735, -0.9691562113628573],
            [-6.389676657379498, -0.9725085922947974],
            [-6.392580857689278, -0.9715253354846435],
            [-6.402547179051351, -0.9781625134559361],
            [-6.408738186863843, -0.9841949986058738],
            [-6.40883173965285, -0.9905213912183665],
            [-6.4162676204805305, -0.9898681525295573],
            [-6.418235538542246, -0.9912528267158569],
            [-6.43293241150508, -0.9915853088298465],
            [-6.43615573666298, -0.9946104489928477],
            [-6.4429918439015115, -0.9930803465120488],
            [-6.449948497250465, -0.9935815653757579],
            [-6.452122816773091, -0.9906642159804195],
            [-6.456203909306591, -0.9935916551621055],
            [-6.461566345499216, -0.9923762307916276],
            [-6.463240358412631, -0.9951418331302683],
            [-6.466954316511689, -0.9941178895105839],
            [-6.470781762515696, -0.9963148057926573],
            [-6.47715305494, -0.9961126207940432],
            [-6.4796001726694925, -0.9924267029109831],
            [-6.486863722824133, -0.9947758978630068],
            [-6.496170882913929, -0.9959873622431674],
            [-6.50124440964048, -0.9983979290830732],
            [-6.506429885577291, -0.9974675843260974],
            [-6.508475245819239, -0.9998659822037846],
            [-6.516823390139307, -1.0019851259204375],
            [-6.523266022271719, -0.9977232190406462],
            [-6.533496923640629, -0.9960638797121322],
            [-6.537121192369652, -0.991845372577816],
            [-6.545727518347787, -0.9906493313142447],
            [-6.5482662174939925, -0.9876418042790628],
            [-6.553750682328238, -0.9887841816849908],
            [-6.557865687698201, -0.9939130089767251],
            [-6.560657864254229, -0.9943818551885065],
            [-6.565233354794496, -0.9917230848352615],
            [-6.573461600749565, -0.9950784802471847],
            [-6.5784361890410095, -1.000142326046424],
            [-6.585865218776525, -1.0051906247922473],
            [-6.58938512588434, -1.0043462268154282],
            [-6.59577310246302, -1.007147507037251],
            [-6.6005209789629395, -1.0040807861741137],
            [-6.604951241352063, -1.0040833240579266],
            [-6.614898113749624, -1.0161797984797218],
            [-6.619206322520285, -1.019752911531526],
            [-6.628758312230929, -1.02080039409072],
            [-6.630329204152385, -1.0291151840072879],
            [-6.630593700215711, -1.0368738204015244],
            [-6.634633757743844, -1.0378622310403194],
            [-6.640595809531063, -1.0352585101258973],
            [-6.647718212816105, -1.0403386540669863],
            [-6.652382495239538, -1.0447006505073182],
            [-6.666543954763707, -1.0484210159652538],
            [-6.671595612585245, -1.0543067803279231],
            [-6.67212771143313, -1.0567315382744387],
            [-6.6802708210385084, -1.0583571498425361],
            [-6.686478647089132, -1.0573571580246302],
            [-6.6899692293501305, -1.0606085366915396],
            [-6.68928034030842, -1.0643208293179853],
            [-6.6921155752980965, -1.0681766246470834],
            [-6.702410544254876, -1.0718967297298259],
            [-6.706561388866699, -1.0747573752274808],
            [-6.716434231721437, -1.073271554512933],
            [-6.719083974266786, -1.0688780704154968],
            [-6.728253115911323, -1.0730318728483206],
            [-6.732142967564634, -1.0722172952797935],
            [-6.737256609977008, -1.0750087682882907],
            [-6.74020705091089, -1.0749640913514025],
            [-6.745788956849258, -1.078253437463233],
            [-6.745804956966518, -1.0720535075829],
            [-6.743821923347679, -1.0674598043070778],
            [-6.745240335340669, -1.053278526545174],
            [-6.743789545882473, -1.0503880891419208],
            [-6.744095529836225, -1.043303932001252],
            [-6.740773820321306, -1.038377106914441],
            [-6.7437877863761875, -1.029847283958833],
            [-6.739988080488745, -1.021912555701123],
            [-6.741157426148979, -1.0196673482107717],
            [-6.7409718555912, -1.008701100326645],
            [-6.742156532001279, -1.005171215945684],
            [-6.738875245307056, -0.9970605031400284],
            [-6.740761641173754, -0.9909796133179292],
            [-6.737433222956548, -0.9856861825690979],
            [-6.737865113293236, -0.9783187950746325],
            [-6.7344562647749795, -0.9767151262226057],
            [-6.728547834869203, -0.9682301462574527],
            [-6.7246267537888125, -0.967633112703777],
            [-6.714588674626032, -0.9680956630629464],
            [-6.709687671924192, -0.9656113868519368],
            [-6.706831450291413, -0.9601577231301249],
            [-6.712258077619169, -0.9557315798269186],
            [-6.714431870912552, -0.950422894300713],
            [-6.713785535261578, -0.9405548725789504],
            [-6.717344156049079, -0.9320125510989814],
            [-6.717134389709085, -0.9268697522663244],
            [-6.719074407074044, -0.9245624661456227],
            [-6.7203175267517405, -0.9159502068616834],
            [-6.7229067899581985, -0.9100845496279353],
            [-6.728098283782116, -0.9119411681224641],
            [-6.738102053814677, -0.9091848473634156],
            [-6.73604019150339, -0.9047507443588105],
            [-6.737436057505938, -0.8929328260431139],
            [-6.737144302327131, -0.8899371604766811],
            [-6.739806058172596, -0.8865478815689649],
            [-6.734323426864852, -0.8786644110473234],
            [-6.7362006269523445, -0.873707836437535],
            [-6.7315599611538754, -0.8665115972866353],
            [-6.732646995093968, -0.8630649135062325],
            [-6.73186234493505, -0.8562581215290046],
            [-6.729285890615378, -0.8525036531566199],
            [-6.72899757220903, -0.8475853001927514],
            [-6.731986546523014, -0.8391582940786049],
            [-6.7322543869967815, -0.8310575669795632],
            [-6.735985716370065, -0.8265430054180816],
            [-6.734898748641205, -0.8179414781797183],
            [-6.732105583232084, -0.8162897594773706],
            [-6.735063279970291, -0.8087347502177192],
            [-6.740576817518313, -0.8015910422895146],
            [-6.741400481521756, -0.79688017149101],
            [-6.747040228856452, -0.7891280694327188],
            [-6.749906615067073, -0.7886082182663475],
            [-6.759276331591799, -0.7794009402402403],
            [-6.758121248295575, -0.7770592729684102],
            [-6.753894879866886, -0.7762214474422225],
            [-6.748596846306348, -0.7719480177103039],
            [-6.746728634474654, -0.7684368211881657],
            [-6.738725029058595, -0.7715277804949109],
            [-6.738530314469427, -0.762551436984577],
            [-6.740082403995118, -0.7602288483725828],
            [-6.738969703542131, -0.7544904582683232],
            [-6.7328402027433, -0.748795387720262],
            [-6.73160230981492, -0.7443199030873795],
            [-6.7425459068144225, -0.7437398660644093],
            [-6.750406889738754, -0.7385752177685906],
            [-6.752009396612406, -0.7354844723072919],
            [-6.756106124070257, -0.737304671019044],
            [-6.757739480947202, -0.7402571985398317],
            [-6.761665929265929, -0.7406886106740966],
            [-6.769302766423886, -0.7395347455703942],
            [-6.7733758438681635, -0.736143757065836],
            [-6.774238078798534, -0.7304746987236251],
            [-6.781034903738478, -0.7287663573536118],
            [-6.78250746354878, -0.7255616900202289],
            [-6.782476050101184, -0.7184812399772702],
            [-6.791744573690282, -0.7195080226047691],
            [-6.796182061946204, -0.7163832695625983],
            [-6.800117462593509, -0.7105731224628258],
            [-6.805035952019054, -0.7105640854265286],
            [-6.806163837016386, -0.7053126852852317],
            [-6.808314787068727, -0.705620273279966],
            [-6.8125189633377765, -0.7011759762838388],
            [-6.813740001098873, -0.6972747898576563],
            [-6.817447749773387, -0.7015171178973105],
            [-6.8231728796227795, -0.7011262972907529],
            [-6.824027219441379, -0.7039918029002665],
            [-6.830829830421706, -0.7050692064394357],
            [-6.840144144489374, -0.7100627229427354],
            [-6.844332300589556, -0.7093620432654956],
            [-6.852651333789672, -0.7098010887129049],
            [-6.855502846943504, -0.7138482228558747],
            [-6.86540914908145, -0.7139780860244735],
            [-6.867515000745644, -0.7119557814597679],
            [-6.872816977108447, -0.7116395697429878],
            [-6.877940108629926, -0.7149853756033412],
            [-6.881635869860862, -0.7212138640670596],
            [-6.886277573376967, -0.7222913609508014],
            [-6.89084005712706, -0.7300408636126268],
            [-6.897879917353281, -0.7335201664637492],
            [-6.904172397147266, -0.7290782906233606],
            [-6.90946603196941, -0.7307005353971328],
            [-6.910941485296944, -0.7290013943394558],
            [-6.916086188628302, -0.7291321534442915],
            [-6.920278860096024, -0.7316323168792183],
            [-6.928014551288289, -0.731488136986298],
            [-6.931232419294848, -0.7326256576642229],
            [-6.933789109706636, -0.736405383457444],
            [-6.9367435197810465, -0.7438461184798055],
            [-6.94313605958532, -0.7496387609786966],
            [-6.942908710480078, -0.7531440373338403],
            [-6.955769320909469, -0.7605985389814163],
            [-6.968398417340742, -0.7633657220865723],
            [-6.974787363638636, -0.7549697922285732],
            [-6.974835241532754, -0.7479579206529936],
            [-6.978588245948983, -0.7438776638418533],
            [-6.978626897688737, -0.7413307193080477],
            [-6.9721379914626445, -0.7396309893260801],
            [-6.971517047433528, -0.7352606315966886],
            [-6.973076173360579, -0.7285315908253575],
            [-6.974966440297326, -0.725933986789143],
            [-6.972728309667293, -0.7210356869419525],
            [-6.968339297980856, -0.7155714769852661],
            [-6.968037449280153, -0.7056770518782559],
            [-6.963489724508894, -0.6962495509499536],
            [-6.961932601675135, -0.6873119299457287],
            [-6.957115337522992, -0.6826776221020264],
            [-6.956537529105719, -0.6795104481142062],
            [-6.953060561505407, -0.6752958635400913],
            [-6.95333815346693, -0.6680164087026901],
            [-6.951296334720099, -0.6623156126061063],
            [-6.951572267990293, -0.6567604376191188],
            [-6.953803032634338, -0.6539302142240501],
            [-6.953512171320751, -0.6472870241033074],
            [-6.948936773229974, -0.6336076807106836],
            [-6.943756574320869, -0.6305110393498319],
            [-6.937895490019853, -0.628506021573112],
            [-6.935758228689742, -0.6250480126154521],
            [-6.9320361996086, -0.6235423127474252],
            [-6.929331202028869, -0.6190611062323982],
            [-6.928011269410097, -0.611041106698673],
            [-6.928689765254111, -0.606302357755415],
            [-6.926527087169403, -0.602643741717037],
            [-6.929430398708609, -0.5956371198293196],
            [-6.928917208757905, -0.5911826929621486]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.96062241079312,
          "lat": 37.68469325479365
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08055"],
        "coty_name": ["Huerfano"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Huerfano County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00198143"
      },
      "bbox": [
        -6.978626897688737, -1.078253437463233, -6.0607757851666735,
        -0.3444432373123065
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.740533664694721, 0.43212331377291124],
            [-5.683563578498826, 0.4271881338701692],
            [-5.5926068717013795, 0.4179388112048236],
            [-5.569644045303661, 0.4158601597541124],
            [-5.482603836537799, 0.4086013685268786],
            [-5.4817457493394075, 0.41680472485563363],
            [-5.479984168664606, 0.44526632074264877],
            [-5.473297190352711, 0.5400139677891324],
            [-5.4720037742383605, 0.5517641599795794],
            [-5.46934608189583, 0.5830408817821067],
            [-5.466463077002417, 0.6278959752497505],
            [-5.464494902510277, 0.6420459405897672],
            [-5.462323977692183, 0.6718151148495982],
            [-5.457812146784045, 0.6713861550467545],
            [-5.453621233572551, 0.72158975577557],
            [-5.453399771022473, 0.7224559499011595],
            [-5.445091477582679, 0.8244807786542416],
            [-5.443716169497194, 0.8465646865282743],
            [-5.442807474219664, 0.8541320117853933],
            [-5.437394798262025, 0.9185044403070661],
            [-5.437612007585445, 0.9196401365531538],
            [-5.4326489222334375, 0.9786749004441018],
            [-5.42126703259828, 1.11207151401302],
            [-5.415726223308416, 1.111584642397759],
            [-5.3629806267593265, 1.1072443502506712],
            [-5.2363518985531154, 1.0968570979058545],
            [-5.165260079230217, 1.09157456790497],
            [-5.0864318794428565, 1.085763568806097],
            [-4.995387738821508, 1.0783089593048305],
            [-4.994969198686266, 1.077978830185206],
            [-5.000179267099778, 1.0132871317935048],
            [-5.00903861624527, 0.9002058506243286],
            [-5.016745030890194, 0.7975462030783325],
            [-5.027686595344995, 0.651452114567194],
            [-5.028868583842952, 0.6374981843857147],
            [-5.034858812262803, 0.6379573129096858],
            [-5.0416934554592805, 0.5469679402531401],
            [-5.052187971671191, 0.41184766326976946],
            [-5.057701012065332, 0.34327733873421096],
            [-5.063186761314571, 0.2701951244077562],
            [-5.068984171568555, 0.1971933667043499],
            [-5.075399263348141, 0.19760115991591573],
            [-5.081669256070253, 0.11948839259386991],
            [-5.088253035344233, 0.03174927730242859],
            [-5.14494745617409, 0.03464741249191403],
            [-5.148393144027254, 0.034643345625316034],
            [-5.3123258498486745, 0.04737791052485008],
            [-5.335217598906093, 0.04940043337738461],
            [-5.34468110413706, 0.04991665945131785],
            [-5.345252780317181, 0.0426130867599837],
            [-5.428798763123735, 0.05076062410773869],
            [-5.428426930987135, 0.05546057518140263],
            [-5.478597397754567, 0.0591626813808685],
            [-5.499701446705475, 0.0609249590628923],
            [-5.510379438751017, 0.06132323024519914],
            [-5.549733697052487, 0.06489776232364947],
            [-5.556810739972203, 0.06509194641993406],
            [-5.628946098831286, 0.07139559180305162],
            [-5.63112978349875, 0.07224059565806991],
            [-5.686884438296233, 0.07736365931359213],
            [-5.726495720512996, 0.0801777420667215],
            [-5.768909341716991, 0.08342965625942356],
            [-5.769171139224594, 0.08345088107580564],
            [-5.754852191434272, 0.2436118340155458],
            [-5.752689316177045, 0.25630800720722946],
            [-5.747113137391066, 0.34533533207306866],
            [-5.740533664694721, 0.43212331377291124]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.51396682723984,
          "lat": 38.98808220785168
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08073"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00198152"
      },
      "bbox": [
        -5.769171139224594, 0.03174927730242859, -4.994969198686266,
        1.11207151401302
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.358353523502085, 5.423785045851981],
            [17.370358390915403, 5.425912139028087],
            [17.394503396602314, 5.4314774506009815],
            [17.401674616370915, 5.393063545182944],
            [17.4361606043838, 5.407197764366401],
            [17.435444516286232, 5.411876745100042],
            [17.437759236164425, 5.422061796003833],
            [17.440265821756014, 5.436324525680792],
            [17.43535939866346, 5.438308791413802],
            [17.435868729293393, 5.441431880943359],
            [17.478589799655396, 5.4526721755200525],
            [17.517433332557932, 5.457819122932693],
            [17.543006789119985, 5.462555534232559],
            [17.54514532803431, 5.457095004592625],
            [17.562817658522135, 5.461206878471406],
            [17.56798967953646, 5.468131795091844],
            [17.59922373113464, 5.480256718792404],
            [17.650389530523817, 5.492811105552544],
            [17.750657108079864, 5.515966755152931],
            [17.799058612656893, 5.5279537755801895],
            [17.830951294159217, 5.535505787278883],
            [17.831668844664907, 5.503621508677503],
            [17.830266514648212, 5.484195513346449],
            [17.827962525964033, 5.458688967751107],
            [17.840636043637296, 5.462510353993884],
            [17.842632544163102, 5.453903270808563],
            [17.85741654650682, 5.399153493732761],
            [17.859075014903144, 5.390928621873362],
            [17.870780697496254, 5.3428953925428715],
            [17.908983507628395, 5.352347617318416],
            [17.934862244977417, 5.274875047490342],
            [17.935204757583165, 5.274726331547662],
            [17.932833356841765, 5.270633307175706],
            [17.926794901312597, 5.271275976159959],
            [17.92546598316197, 5.26703911083102],
            [17.915269511601927, 5.272361559140228],
            [17.912320510747257, 5.265376061379364],
            [17.911074347182044, 5.251527020342076],
            [17.915234316977855, 5.248429072325],
            [17.915299300389748, 5.245751032987311],
            [17.9115362905311, 5.242475748102333],
            [17.872402599409128, 5.232545925523238],
            [17.872968012999145, 5.229292299229528],
            [17.878063762552532, 5.228495795022703],
            [17.88113836696183, 5.223317123215037],
            [17.885285903241254, 5.221312742944117],
            [17.881684052577725, 5.2170419218313056],
            [17.881537103677015, 5.212838681895753],
            [17.87826359724041, 5.205349324403347],
            [17.87396032747453, 5.202336078415387],
            [17.87438624692758, 5.199028115571745],
            [17.871754505285548, 5.193520627512391],
            [17.865864632298184, 5.192034262262824],
            [17.870959589329075, 5.18817736520849],
            [17.87440333014799, 5.181118695813245],
            [17.8752869096324, 5.174187364793236],
            [17.86771418900839, 5.17313231729818],
            [17.854245922854282, 5.151082627694884],
            [17.83484587604349, 5.135413469370602],
            [17.84191706394995, 5.122706276267267],
            [17.848046706531342, 5.112840055428769],
            [17.848722509856504, 5.099445992922412],
            [17.839278452294728, 5.090689439538437],
            [17.832854591652477, 5.088778638466485],
            [17.830710912100525, 5.086744959394119],
            [17.825793092000076, 5.08879483870693],
            [17.819086116451405, 5.0857451073848985],
            [17.816001624631568, 5.0869906873980115],
            [17.81539739856274, 5.081450175873323],
            [17.813499719441733, 5.08017107154709],
            [17.811311634620726, 5.073535475423218],
            [17.801617334018474, 5.076421148495338],
            [17.79852626299821, 5.076559980835276],
            [17.790269581038142, 5.080860893793515],
            [17.78829339240818, 5.068765367510032],
            [17.754330006837215, 5.053267767036086],
            [17.746072548483134, 5.062844272714449],
            [17.737461754725828, 5.074159205817546],
            [17.711680651035884, 5.106342003836616],
            [17.71091964541762, 5.107667077659425],
            [17.66128085577775, 5.086932936427873],
            [17.62431733520251, 5.071762713789214],
            [17.624554555449063, 5.07897960040604],
            [17.59173664032772, 5.063432966018791],
            [17.565690469588716, 5.0513638415569435],
            [17.565711011490162, 5.046315945644477],
            [17.570025465294716, 5.042084979607077],
            [17.569432563352514, 5.03027789341858],
            [17.57094701600682, 5.02846779698315],
            [17.560545496115434, 5.0229686611602835],
            [17.560690852955677, 5.01711255901219],
            [17.54618128459954, 5.01008276743212],
            [17.550048064281505, 4.996970231409524],
            [17.53898288224579, 4.992584089796889],
            [17.516120478187016, 4.982546785837481],
            [17.51482152044048, 4.975499988246617],
            [17.507798452901003, 4.961033360641541],
            [17.50236790347072, 4.961341463168689],
            [17.500610936802655, 4.969596987001969],
            [17.497611136217923, 4.975785687776295],
            [17.48344699554781, 4.968480699999708],
            [17.492011996451897, 4.947218194263117],
            [17.48521088814885, 4.947279477663197],
            [17.47400671054372, 4.947213011768416],
            [17.47144221941134, 4.952271128885574],
            [17.467118381435306, 4.955983785162559],
            [17.458832255135093, 4.958753160378289],
            [17.41551100184971, 4.94080347392442],
            [17.412320379322466, 4.9927567745687025],
            [17.39998120806353, 5.02747494490298],
            [17.40682938887748, 5.030345729662915],
            [17.408568680785258, 5.025884814825581],
            [17.412661772148947, 5.027323784704586],
            [17.410198630128136, 5.031216217285042],
            [17.438404209300465, 5.042293103659672],
            [17.432899792687248, 5.054929277249082],
            [17.421832625042047, 5.082736847557577],
            [17.41881714939708, 5.089272072231846],
            [17.414321336603564, 5.101419696723722],
            [17.409818414698417, 5.111445698449542],
            [17.406546286668416, 5.119806949619568],
            [17.398961840411587, 5.136739313684271],
            [17.39656850888668, 5.1442676915162755],
            [17.389663818381297, 5.1611217713922315],
            [17.382662648463256, 5.1611470417625815],
            [17.38034214388539, 5.162271790863185],
            [17.374988720851015, 5.169637946867704],
            [17.371930300881477, 5.180167539120209],
            [17.369074305319614, 5.183740137937082],
            [17.373325854440445, 5.187221874343883],
            [17.369125883657343, 5.190286075436428],
            [17.35317880046621, 5.183533291785139],
            [17.35398358896485, 5.2186964843971575],
            [17.351579189297034, 5.220421814987002],
            [17.345973051808695, 5.2201997236232796],
            [17.342852159109707, 5.218468702227739],
            [17.340119838788205, 5.221911658746555],
            [17.33837681062751, 5.228962946892028],
            [17.338750219691992, 5.249833492641514],
            [17.338091992196357, 5.252985173896726],
            [17.337713958898373, 5.271452107202294],
            [17.355475132137176, 5.277486099693581],
            [17.357252487812325, 5.356786846745522],
            [17.357557524847525, 5.393746062569435],
            [17.357980799253443, 5.396749522273098],
            [17.358788917799348, 5.4214896816131635],
            [17.358353523502085, 5.423785045851981]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.57205192558183,
          "lat": 41.818466182680574
        },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09110"],
        "coty_name": ["Capitol"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Capitol Planning Region"],
        "coty_fp_code": "110",
        "coty_gnis_code": "02830244"
      },
      "bbox": [
        17.337713958898373, 4.94080347392442, 17.935204757583165,
        5.535505787278883
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.065628304927, -7.398268930177141],
            [11.16152879066079, -7.391347020426482],
            [11.20533608766729, -7.388858295180791],
            [11.221975410898533, -7.387558236133602],
            [11.28359306576909, -7.383576977234475],
            [11.298066037140831, -7.382681033909282],
            [11.325209665035006, -7.3810069782564165],
            [11.33198534814753, -7.383648564098302],
            [11.33773914812416, -7.381418057640182],
            [11.3396567900966, -7.384515315761056],
            [11.344699370450183, -7.382909772849484],
            [11.347098798305884, -7.384371883109586],
            [11.354556871820202, -7.382789312339079],
            [11.360993880855428, -7.388469955212718],
            [11.363820938948832, -7.395254484482658],
            [11.363628666954753, -7.399481614787983],
            [11.372255393732358, -7.412579043141276],
            [11.376443168143084, -7.422514231871635],
            [11.372640231837028, -7.424191151508524],
            [11.371941272133583, -7.428376233885179],
            [11.375476660089861, -7.434621482160727],
            [11.37384942990306, -7.439165164232866],
            [11.37805145543478, -7.442615451015724],
            [11.380545284276518, -7.448871132109691],
            [11.377527189758418, -7.451273247537625],
            [11.377348874094004, -7.455865554583503],
            [11.383335849490184, -7.458764919573462],
            [11.390402578038184, -7.465929252443821],
            [11.392418626163083, -7.470997714705017],
            [11.390232766639112, -7.475384160869884],
            [11.393724205513326, -7.475777132528942],
            [11.395308469723739, -7.480908159875258],
            [11.398038394741011, -7.481725762335136],
            [11.400639717159573, -7.487640809808876],
            [11.397752065072865, -7.489564484491832],
            [11.397241197399438, -7.495278456949296],
            [11.400876160982635, -7.499730432037419],
            [11.399454939578547, -7.50371036483114],
            [11.402362268277974, -7.512155343194929],
            [11.398968140081601, -7.513896947428363],
            [11.40092133625727, -7.517043947644069],
            [11.401472613234592, -7.526029405654878],
            [11.403454316351912, -7.527185573956922],
            [11.402708325885769, -7.532515107021134],
            [11.418489648665606, -7.535376101845852],
            [11.42465451913412, -7.540569008041612],
            [11.427119580496113, -7.546412147089038],
            [11.423251958002904, -7.550699743233345],
            [11.427368855776805, -7.5619221672086985],
            [11.42590241426179, -7.565651937401336],
            [11.430126376174282, -7.574090999960656],
            [11.429532462307531, -7.579538706439073],
            [11.432603637164071, -7.582893212249433],
            [11.43742843072055, -7.579383514484276],
            [11.440685706597503, -7.581090154809564],
            [11.444191273017672, -7.585203782309191],
            [11.451863574113567, -7.582091605491352],
            [11.457072023614433, -7.584774225778705],
            [11.465352895989296, -7.587079359206134],
            [11.465377425401737, -7.589041469962689],
            [11.471409203371321, -7.599567097470328],
            [11.469506584010672, -7.60457349287018],
            [11.473126898053216, -7.604755804014768],
            [11.476445890057498, -7.610576669787919],
            [11.470639415583626, -7.612446401016],
            [11.459711659666551, -7.622856585663056],
            [11.460089405091537, -7.630256183986581],
            [11.4613323370443, -7.634183504264092],
            [11.460858232420495, -7.6403314644392575],
            [11.464447083039294, -7.644612693026734],
            [11.46376232235394, -7.646425125280809],
            [11.458097031556768, -7.650065886956154],
            [11.452098129282655, -7.647922619374956],
            [11.448907799575347, -7.649041163231557],
            [11.446286997062789, -7.655596763014659],
            [11.448981266314293, -7.663019046912594],
            [11.452215813401452, -7.668080297916448],
            [11.4481273311245, -7.677150490952503],
            [11.448494594754186, -7.680635613355261],
            [11.453066798779949, -7.687210089265273],
            [11.450978011976297, -7.692426000997567],
            [11.441668154705111, -7.698667828287048],
            [11.438763211405314, -7.702589045515379],
            [11.43601725347802, -7.709387567399515],
            [11.438259064297116, -7.71730374431889],
            [11.433268401552409, -7.735117854510066],
            [11.4365971864664, -7.738479079441381],
            [11.43482868046385, -7.741208564504178],
            [11.428048274957604, -7.741853394381911],
            [11.425861100194323, -7.742463388911225],
            [11.397423396652723, -7.74636248697173],
            [11.325512748688658, -7.755733187257751],
            [11.274081972530976, -7.762163853039998],
            [11.268680741793858, -7.763513522410558],
            [11.238328555403191, -7.767325155592362],
            [11.232979333445483, -7.724113860356154],
            [11.138851689481054, -7.7367306469032435],
            [11.132299115697707, -7.73789913972509],
            [11.089398147980587, -7.743056168346631],
            [11.020528299819123, -7.752417315447048],
            [10.932696786378894, -7.763686126595817],
            [10.930812284783359, -7.760066870936372],
            [10.931222848845097, -7.754263100611873],
            [10.934835593239248, -7.749879679947077],
            [10.938582948777876, -7.7481359368707325],
            [10.943402124621068, -7.7500540773330355],
            [10.947405277926729, -7.749994619629241],
            [10.94908514112276, -7.747441864514809],
            [10.954359830326869, -7.745258767517771],
            [10.956835919416939, -7.7398054442781286],
            [10.957403627891019, -7.732372226638139],
            [10.95138311249472, -7.729305372201463],
            [10.944938050590496, -7.719554100477548],
            [10.93823016882786, -7.718087619650926],
            [10.940148797897717, -7.713137823864121],
            [10.936845183689465, -7.704185911772473],
            [10.935239656165965, -7.70215888776669],
            [10.935560478059532, -7.695110650270417],
            [10.93726423878106, -7.688989542337233],
            [10.941325951438763, -7.6838770296953305],
            [10.946231742273751, -7.675519519320698],
            [10.949246783823535, -7.675586041633379],
            [10.949815462432358, -7.682758477737883],
            [10.954693937653845, -7.68548047033116],
            [10.957177484156526, -7.681968708579583],
            [10.964826470979807, -7.679872010644549],
            [10.966919805542972, -7.680822975874859],
            [10.975983491641967, -7.676138906121113],
            [10.976921295812115, -7.669703918397113],
            [10.975790730591239, -7.665086225246517],
            [10.978869279763478, -7.66313598236015],
            [10.979555366897458, -7.6561481240183555],
            [10.978417709432453, -7.653667868932517],
            [10.98409983180166, -7.6447730590876075],
            [10.985623419631514, -7.639490330413604],
            [10.991591002628109, -7.635302202433088],
            [10.995450514896717, -7.629904716693074],
            [10.99568291929033, -7.626478948058939],
            [11.000021055879678, -7.624096852022099],
            [10.998067247238293, -7.616438780483637],
            [10.993846441441535, -7.610454352399656],
            [10.991879107708465, -7.603694881111492],
            [10.994658708195633, -7.597902651308832],
            [10.992886714046568, -7.590754113566758],
            [10.988914574337345, -7.5870887010848325],
            [10.989676385050949, -7.5846278410095715],
            [10.988315038420703, -7.576870076041492],
            [10.989527057657881, -7.575073348838666],
            [10.987778638253765, -7.569941442627587],
            [10.984534278953811, -7.5680380669671665],
            [10.981696448613093, -7.562396997487973],
            [10.980043569074644, -7.5623021052885795],
            [10.977541387494874, -7.5531345702823485],
            [10.982093278451341, -7.541869984217952],
            [10.984904851176776, -7.537300446605448],
            [11.003372652717667, -7.534850623237762],
            [11.001481013975452, -7.519992999006815],
            [11.029801359524733, -7.5164094702658],
            [11.027839903391238, -7.5017922515360915],
            [11.05658215959942, -7.498260135251708],
            [11.054717022334595, -7.483670486648887],
            [11.068493339490587, -7.482002804294299],
            [11.066980039834991, -7.467537862970589],
            [11.081078462497208, -7.465769678040958],
            [11.075694124105317, -7.42776986026076],
            [11.073553918797296, -7.410293342417039],
            [11.066917590940568, -7.410654997154108],
            [11.065628304927, -7.398268930177141]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.4701187901864, "lat": 30.444102680438228 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12079"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00295731"
      },
      "bbox": [
        10.930812284783359, -7.767325155592362, 11.476445890057498,
        -7.3810069782564165
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.05106900543643, -10.0509096415252],
            [14.183231354189894, -10.0300422860361],
            [14.186409899592908, -10.029150778884302],
            [14.226093274459808, -10.02302509556202],
            [14.324333632620899, -10.008055122303098],
            [14.3602456057239, -10.002309145848683],
            [14.366185137769417, -10.00157542021563],
            [14.379926654243535, -10.030813789913422],
            [14.393749297055729, -10.053092437781633],
            [14.399878930346993, -10.066598904754521],
            [14.40671436147388, -10.07709187162785],
            [14.408090843324938, -10.084592137451537],
            [14.425410538854232, -10.114536735862536],
            [14.43438313951776, -10.13079981131941],
            [14.445572497054485, -10.150089752401533],
            [14.47886551688988, -10.197269352563918],
            [14.479797522652664, -10.199895101201605],
            [14.487892952766334, -10.214214701781525],
            [14.509942486641341, -10.249782471365355],
            [14.521785332720121, -10.267881935359927],
            [14.482267248519195, -10.274410187025412],
            [14.446441029208131, -10.2795929827029],
            [14.449205589675856, -10.29878488586072],
            [14.447086780456699, -10.301079902632692],
            [14.442750478882902, -10.301763802201048],
            [14.444589402676895, -10.30647318360891],
            [14.451531426020649, -10.31121564323795],
            [14.455232920930118, -10.33538039798499],
            [14.407749822546966, -10.343492530523578],
            [14.3789199210927, -10.347792931776306],
            [14.37552024535631, -10.34886437950959],
            [14.28231644075214, -10.363242133664935],
            [14.194946870935494, -10.377692734464945],
            [14.108976661646771, -10.391529569254015],
            [14.102709741975172, -10.354335125876554],
            [14.094192428706561, -10.306615135064373],
            [14.095042531035014, -10.306462268995565],
            [14.069584157507729, -10.157266002960418],
            [14.067852721222232, -10.15049890039432],
            [14.060332788968761, -10.106974671234553],
            [14.05106900543643, -10.0509096415252]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.4720535311207, "lat": 27.37727644462554 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12111"],
        "coty_name": ["St. Lucie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Lucie County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00308372"
      },
      "bbox": [
        14.05106900543643, -10.391529569254015, 14.521785332720121,
        -10.00157542021563
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.41368903481592, -8.904703690167429],
            [12.467315705576329, -8.896863902989034],
            [12.468927122766525, -8.896853316963474],
            [12.53388114184721, -8.887793938067487],
            [12.615729761569318, -8.875639349526958],
            [12.66968706582994, -8.867872138661182],
            [12.687681106080197, -8.865453801908435],
            [12.723597761589126, -8.860047013387277],
            [12.727354582468475, -8.884322385236796],
            [12.736332898253565, -8.939521220782852],
            [12.743375323577558, -8.987971538341403],
            [12.754157535369494, -9.059706252378215],
            [12.761614522975377, -9.113132891196713],
            [12.768076338155211, -9.15694416921984],
            [12.769650070346115, -9.169927894005367],
            [12.779467234229692, -9.229978042331389],
            [12.787172635762154, -9.285443070442382],
            [12.80182449588493, -9.390695900966579],
            [12.810945370890224, -9.45972577622305],
            [12.81592895986896, -9.495048815789714],
            [12.809808457708057, -9.496818063136956],
            [12.799859498479472, -9.496786567012185],
            [12.798171466839529, -9.500825385150591],
            [12.7922220874147, -9.502109771363592],
            [12.789764107903169, -9.50075363724368],
            [12.781583452035564, -9.490235289145836],
            [12.775491940810918, -9.489649201637695],
            [12.770513704523614, -9.487503795076504],
            [12.7682762398033, -9.488885037025499],
            [12.763327936075799, -9.488189582484797],
            [12.754991884775787, -9.490104726190046],
            [12.743485015138193, -9.495540194996721],
            [12.738181097376943, -9.497101456949547],
            [12.729963067797904, -9.503775912279744],
            [12.7067969828632, -9.342436781058309],
            [12.700725413096116, -9.30055876514829],
            [12.69673010168422, -9.297139238119113],
            [12.687659186520175, -9.292442661614475],
            [12.683529159041056, -9.293001541241367],
            [12.677013130065873, -9.297331432681082],
            [12.672581387714734, -9.298999594172656],
            [12.672019738287343, -9.301507782960197],
            [12.667823158410027, -9.303476802899082],
            [12.66351815439163, -9.30262193055706],
            [12.661302961325806, -9.298813702054083],
            [12.655057543036468, -9.293946911093348],
            [12.64958354591965, -9.285637258107286],
            [12.647140743375655, -9.285768142690717],
            [12.641630029962, -9.289889628219154],
            [12.63061628976229, -9.285823598506505],
            [12.624509029877919, -9.27295194286219],
            [12.621526503711591, -9.268131830801387],
            [12.61660011060493, -9.268444748956929],
            [12.609950981774988, -9.264093767927317],
            [12.604595651896009, -9.262786957496504],
            [12.60390819073233, -9.266073667760434],
            [12.599952871971254, -9.26881902264781],
            [12.59810570827161, -9.272924297979062],
            [12.595028989849476, -9.270494913761862],
            [12.591795485498062, -9.272166917892697],
            [12.586879476687876, -9.270264991321564],
            [12.581824737524443, -9.271209519709497],
            [12.5779151841949, -9.26757413640199],
            [12.569095588492983, -9.265590051964692],
            [12.567447843186832, -9.268389814882942],
            [12.559483096160664, -9.27059595500281],
            [12.554181248457432, -9.268067099334917],
            [12.548288201817671, -9.261659829106273],
            [12.544345012066005, -9.253146640221008],
            [12.544702075462201, -9.251640974886248],
            [12.537525779631466, -9.245208478977673],
            [12.534028261229588, -9.246184928859758],
            [12.53155123329234, -9.238183206000814],
            [12.522558320938952, -9.232183961514774],
            [12.519347612237516, -9.228596371906756],
            [12.519145792515365, -9.224008434155696],
            [12.516133126406613, -9.219291105593138],
            [12.513011446247782, -9.220469710894742],
            [12.504451101598622, -9.21413237432106],
            [12.504530887405757, -9.20828014628491],
            [12.506604932877412, -9.204954573332852],
            [12.497322533155462, -9.203814357087863],
            [12.493991164273694, -9.202269809413334],
            [12.489362791372338, -9.19692603443581],
            [12.489429429232628, -9.192451212195818],
            [12.494548501550906, -9.1895994413503],
            [12.497960385980727, -9.184305294927556],
            [12.499564694305233, -9.179533462527724],
            [12.498471905466976, -9.169207553122373],
            [12.50265780193597, -9.161733986294177],
            [12.502654210202614, -9.159054796222874],
            [12.505657203504628, -9.149482098652667],
            [12.502891505810386, -9.145597644109914],
            [12.502093205878092, -9.140596535729635],
            [12.50284392340875, -9.134052863167868],
            [12.508254050620604, -9.12691115003009],
            [12.511395577569603, -9.124678074461153],
            [12.515292523599024, -9.118996329940252],
            [12.515670271307975, -9.113598052826198],
            [12.520990890258549, -9.107867889871143],
            [12.52954916212452, -9.100286528966349],
            [12.531027042565949, -9.093466622373011],
            [12.53451561175189, -9.089878933183899],
            [12.540707791862703, -9.088836578880937],
            [12.543391495752275, -9.085702324410608],
            [12.548794507755126, -9.08601365638942],
            [12.55341992360732, -9.080827944484117],
            [12.553615500487677, -9.075443449936573],
            [12.547802672439484, -9.072938000225498],
            [12.547195856232301, -9.068496280286512],
            [12.549870259700244, -9.06159534654262],
            [12.560428627453133, -9.053223661337919],
            [12.560412495742796, -9.046723948668971],
            [12.551182659786546, -9.041481354644507],
            [12.54620261783952, -9.028567775430153],
            [12.545649863572251, -9.023876028305976],
            [12.541200078203763, -9.020006719574159],
            [12.537443634892508, -9.020030413682372],
            [12.524350873064405, -9.014034272920862],
            [12.522091658803433, -9.009097166237],
            [12.516900900023641, -9.007151360298101],
            [12.510939603003056, -9.00120912167704],
            [12.506630658138334, -8.998662072988706],
            [12.497785612102007, -8.996104726326811],
            [12.493501250578708, -8.992734192735758],
            [12.492204703897453, -8.988359013107244],
            [12.489207361778824, -8.98717102256219],
            [12.48957412538958, -8.983897768115867],
            [12.485691422747182, -8.977681940016007],
            [12.47768854361818, -8.974509870137657],
            [12.466916608740526, -8.967964386652925],
            [12.463674966310387, -8.967364834006993],
            [12.455810022461002, -8.96164201475759],
            [12.452859953739598, -8.957627934725323],
            [12.450655910179572, -8.949087479718616],
            [12.445839434990246, -8.945652049787677],
            [12.445609577784149, -8.942560792801801],
            [12.442700706798965, -8.937645931708474],
            [12.438255126914735, -8.932691228874964],
            [12.43606632521893, -8.926219039841463],
            [12.430502406930168, -8.924221766314796],
            [12.430997588739027, -8.9209882968033],
            [12.428078994362856, -8.914642227599337],
            [12.422926282784609, -8.911483744607917],
            [12.42052952180709, -8.911554155478152],
            [12.414342360492888, -8.906567296950229],
            [12.41368903481592, -8.904703690167429]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.08102002550041,
          "lat": 28.704782632454556
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12119"],
        "coty_name": ["Sumter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sumter County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00295740"
      },
      "bbox": [
        12.41368903481592, -9.503775912279744, 12.81592895986896,
        -8.860047013387277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.44363248970317, -3.972507127912759],
            [10.445211765007341, -3.977332524800585],
            [10.449012675582631, -3.9788881170427066],
            [10.448767881054682, -3.9821853921074783],
            [10.451212507266359, -3.9868384974398943],
            [10.46137894731539, -3.995218815661037],
            [10.467885184698947, -3.9969441393215854],
            [10.470625606124495, -4.0034539216773135],
            [10.470547458961908, -4.0098899437373134],
            [10.48214075158294, -4.015869245816324],
            [10.486238206472033, -4.021000277835104],
            [10.489760311915246, -4.021755905550618],
            [10.492384497905876, -4.0280994347361965],
            [10.496030863635315, -4.029227970444395],
            [10.499126745676508, -4.027105063187616],
            [10.505843351584405, -4.028638180659844],
            [10.519829783613568, -4.023642136889321],
            [10.519752465493099, -4.026985826163648],
            [10.522340869248064, -4.030644208686185],
            [10.530337385747643, -4.02706022413666],
            [10.531902618490435, -4.034081225268111],
            [10.53897942960795, -4.034247292327964],
            [10.53783586887892, -4.038865491986855],
            [10.540823298216633, -4.042572923468564],
            [10.54645325112095, -4.041531360743055],
            [10.547554935472364, -4.034675349776632],
            [10.550755121040686, -4.034570070493237],
            [10.552095890067486, -4.031170651881538],
            [10.556051210514989, -4.0348877556833695],
            [10.560944635325505, -4.032401027559004],
            [10.561947661415704, -4.0388419709294165],
            [10.566666997186411, -4.037769256739639],
            [10.565999387912182, -4.033771145567122],
            [10.570829789685277, -4.03152711335068],
            [10.575720569621833, -4.035888957650171],
            [10.578745477142181, -4.0321856046506115],
            [10.583362020225566, -4.029640157911823],
            [10.586533630755067, -4.03511635214593],
            [10.592638311672673, -4.035833074489738],
            [10.593093276148124, -4.0317231099476505],
            [10.599845458324285, -4.032546413900817],
            [10.602184610428724, -4.034624363675378],
            [10.611278652339347, -4.034260167863916],
            [10.613805778277245, -4.032201662423415],
            [10.619544942144751, -4.031129232527887],
            [10.622283579895345, -4.033528489478216],
            [10.625257585377161, -4.039496573249202],
            [10.62867052170778, -4.038516907600693],
            [10.632603197858385, -4.041444872251664],
            [10.640741496459206, -4.038351830516994],
            [10.645049247364469, -4.034039602001174],
            [10.654207860809166, -4.034805494322695],
            [10.657111162481753, -4.042185977339141],
            [10.663438530702022, -4.0408862299482085],
            [10.677174141381508, -4.068213044071416],
            [10.678931490852253, -4.073500751687775],
            [10.693240022276942, -4.103826002847755],
            [10.664807458837751, -4.128362279158909],
            [10.611547875506872, -4.175043450487683],
            [10.609802405053014, -4.173490544343948],
            [10.602488288404203, -4.173827430437633],
            [10.599918272524757, -4.17045436992437],
            [10.596326863427958, -4.1707831360512415],
            [10.595342041618155, -4.167390019506195],
            [10.586098021494593, -4.166797136188185],
            [10.578344585116444, -4.174349949518319],
            [10.57110678385509, -4.174847259758522],
            [10.566878930987274, -4.181490845495498],
            [10.56058888945343, -4.182787157241849],
            [10.551169214312422, -4.189057079865616],
            [10.545181762034776, -4.189299640001018],
            [10.542178357151426, -4.1913987327744815],
            [10.535484989681866, -4.190059146292308],
            [10.528622313621714, -4.195589888826229],
            [10.525398324981891, -4.194358152844201],
            [10.520366589792172, -4.197360697888516],
            [10.517358980225977, -4.196905129857284],
            [10.517404073992495, -4.191966325638617],
            [10.515398054251722, -4.18650202849294],
            [10.509977667669391, -4.185539057339626],
            [10.50800683284219, -4.182704238903077],
            [10.503507797304215, -4.18298872104367],
            [10.501878066509905, -4.179848380832726],
            [10.495724832711515, -4.176645693355829],
            [10.484507379509019, -4.169305485603509],
            [10.484263354816475, -4.167574003973093],
            [10.480408214970721, -4.164649793542357],
            [10.477739864939764, -4.160679099919589],
            [10.478496616892686, -4.157312208409347],
            [10.474667413387898, -4.152477573778699],
            [10.470017831116209, -4.149513224384588],
            [10.469173714920526, -4.144543643661697],
            [10.458023005701232, -4.135209481791298],
            [10.452697282589869, -4.134625937598211],
            [10.446377489813607, -4.119464869927216],
            [10.440713237420681, -4.114823539861027],
            [10.429985734159068, -4.110441749260937],
            [10.425404198085463, -4.107056875369255],
            [10.422475802877413, -4.103100365734431],
            [10.417526384905177, -4.100686243970416],
            [10.418747759866418, -4.096737326013367],
            [10.427678740204508, -4.051859502158173],
            [10.44363248970317, -3.972507127912759]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.71272166481508, "lat": 33.99318864090839 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13013"],
        "coty_name": ["Barrow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barrow County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00356976"
      },
      "bbox": [
        10.417526384905177, -4.197360697888516, 10.693240022276942,
        -3.972507127912759
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.556369005346287, -6.6686415731801],
            [12.558800129623654, -6.669833340620403],
            [12.559937492782499, -6.673895871554409],
            [12.558985402900564, -6.678977012667136],
            [12.56041829894399, -6.683298461599656],
            [12.56956721271526, -6.686159498534269],
            [12.58341246947427, -6.6824679958720905],
            [12.591541652811232, -6.683767462657149],
            [12.59706003749592, -6.683743301848107],
            [12.601564790515559, -6.686695283381775],
            [12.604168725977127, -6.690736219558422],
            [12.608279868360551, -6.693948601212215],
            [12.61571746232221, -6.695750991523576],
            [12.621432271831042, -6.6997402418910745],
            [12.630945097991255, -6.705035381097116],
            [12.648228499183695, -6.6997386071697695],
            [12.660156074626245, -6.702163507772889],
            [12.663478103256622, -6.7062252818416335],
            [12.66783945132333, -6.70387585789321],
            [12.675891407641739, -6.710132815798169],
            [12.68063916962995, -6.710087806281123],
            [12.685137207958215, -6.702706398525808],
            [12.6899250270713, -6.701462334204336],
            [12.693293154425113, -6.703929629123975],
            [12.698600867726535, -6.704091011388417],
            [12.705009368922962, -6.700366756376385],
            [12.709169509595021, -6.700183342310532],
            [12.71469426233609, -6.696744441802496],
            [12.718746867371486, -6.698880132438807],
            [12.722504926149702, -6.697603905492904],
            [12.724228448069464, -6.693374553916789],
            [12.724603974772691, -6.688016195353697],
            [12.72760239946776, -6.68362210377753],
            [12.733175632230829, -6.6812870574633525],
            [12.737651196714877, -6.684049168889092],
            [12.739347968707838, -6.689159169976029],
            [12.737879599675788, -6.700655501692322],
            [12.736539735311425, -6.706105916052668],
            [12.73242970575518, -6.710642595377582],
            [12.730528123043864, -6.715315159482274],
            [12.731620650817305, -6.718259700121355],
            [12.737728864752704, -6.719592269549812],
            [12.746507094534273, -6.729478877622461],
            [12.749816884197262, -6.729407820381318],
            [12.753950922165581, -6.725924308854204],
            [12.760360548307768, -6.724378056937143],
            [12.765100336731589, -6.725933170690499],
            [12.768535419951563, -6.729865025179703],
            [12.771740355784154, -6.74058489604325],
            [12.774629954390536, -6.742949552747626],
            [12.791728272471854, -6.746320818313671],
            [12.804322276401104, -6.746898509798883],
            [12.807913445044907, -6.751567893551902],
            [12.809558994026084, -6.758869724414094],
            [12.812979049330899, -6.7659213205756785],
            [12.819581216040238, -6.767337990099678],
            [12.825419405663878, -6.765398860654657],
            [12.837404756592363, -6.759561854801481],
            [12.8412180611647, -6.759791171024074],
            [12.848758760017894, -6.766090363050899],
            [12.852148598613512, -6.777998065557346],
            [12.845320917049381, -6.780202592774437],
            [12.840761676067169, -6.786198151759787],
            [12.8397830663376, -6.7975517577490185],
            [12.833221671439057, -6.801694148459428],
            [12.8169304789591, -6.815346247856444],
            [12.815473399594556, -6.823049616133736],
            [12.822330410241475, -6.829988493142152],
            [12.832327637316595, -6.832113897596033],
            [12.834658793753393, -6.827804424000509],
            [12.839157178187094, -6.826097474326712],
            [12.851164440918776, -6.82963714221579],
            [12.855837009660739, -6.8289838196533115],
            [12.857738453506975, -6.8375386793073645],
            [12.875043991095117, -6.835003025734638],
            [12.878131470935795, -6.816933378519256],
            [12.881271962767508, -6.813310954606675],
            [12.887392522827117, -6.811840676934775],
            [12.894718125631929, -6.830672632493239],
            [12.902463531900782, -6.884071041872137],
            [12.89812414118843, -6.9028589866001555],
            [12.892072368535397, -6.953563969479559],
            [12.890954681435943, -6.958952593512804],
            [12.884585879703929, -6.969785882424237],
            [12.88051193254307, -6.98146685943004],
            [12.876409278078418, -7.00169146877519],
            [12.875578243008205, -7.022981941604844],
            [12.877207094463667, -7.0390715428351385],
            [12.880346638504193, -7.050375425336978],
            [12.892026723491504, -7.071031217756636],
            [12.898283094300744, -7.080110493388119],
            [12.89444451942674, -7.081061794819179],
            [12.88083904369018, -7.081440864851708],
            [12.870704524602667, -7.079256938386072],
            [12.86250323017389, -7.071312614829797],
            [12.857292551937778, -7.069884792092417],
            [12.842791821286374, -7.075282561753513],
            [12.835355350378848, -7.077120931510299],
            [12.822306689133223, -7.07711266938624],
            [12.820553097379861, -7.0781707758922],
            [12.820413082893188, -7.083724946481202],
            [12.82190372071391, -7.089417269555993],
            [12.818539548785138, -7.093350291991885],
            [12.815609869250267, -7.092380959376141],
            [12.810736092154057, -7.0861092029932795],
            [12.807827785549044, -7.085281292484657],
            [12.799159765892377, -7.093244424746787],
            [12.796563822383499, -7.091893630489315],
            [12.79562363746984, -7.087682561115148],
            [12.791524334181402, -7.087067206771712],
            [12.786516974115251, -7.0844487768161795],
            [12.775200314691356, -7.08475777700167],
            [12.770044457526023, -7.090827205777262],
            [12.767148867535258, -7.090415655031271],
            [12.766503949757087, -7.082538564382243],
            [12.762421344764594, -7.080949087213651],
            [12.75855169409905, -7.084780957471421],
            [12.75970111910462, -7.091177634100929],
            [12.756132725122152, -7.09521309617255],
            [12.751415626942059, -7.089411914851024],
            [12.746290504356041, -7.090339403674126],
            [12.743930234862761, -7.088542824435564],
            [12.745186405972673, -7.08136847650258],
            [12.741470381850178, -7.077180364521692],
            [12.738252732208366, -7.078619047669379],
            [12.738572463237722, -7.085282313573596],
            [12.735429795619165, -7.0857201938712215],
            [12.732880219331417, -7.081562787490567],
            [12.730314238510156, -7.081857982464557],
            [12.727715873209966, -7.0867248574757],
            [12.721904534436751, -7.0890345511815145],
            [12.718074704359672, -7.0872981623246405],
            [12.716766926202363, -7.084180675426161],
            [12.717815339218577, -7.076390153807533],
            [12.71460526710505, -7.073143034220329],
            [12.710484767800061, -7.0759839107250775],
            [12.706849964185817, -7.072961628129445],
            [12.70948548161382, -7.06882730662552],
            [12.70571178444316, -7.064403821588493],
            [12.700616031209936, -7.067922804856226],
            [12.69342573948846, -7.069609398682274],
            [12.68986357609999, -7.072740462989872],
            [12.693639472201996, -7.075942418225475],
            [12.698879262154291, -7.071439279504559],
            [12.702274178813598, -7.074398426270919],
            [12.702100580334672, -7.079205794531583],
            [12.70000787952264, -7.080829514144209],
            [12.693447433978463, -7.079136286514669],
            [12.68640069506046, -7.080316379185558],
            [12.67997476934103, -7.074307888888675],
            [12.673904211579236, -7.078214073535141],
            [12.667890479342425, -7.076566468291235],
            [12.659227527412515, -7.081231450452506],
            [12.647404276535969, -7.077118211047381],
            [12.64710767363253, -7.072322530823968],
            [12.638358583097583, -7.0698366221205475],
            [12.63904358333666, -7.065177351800867],
            [12.635530605364341, -7.062889654361536],
            [12.63033915639346, -7.06294860291556],
            [12.622549403314633, -7.06011903914981],
            [12.619154870503717, -7.055983457851394],
            [12.612234538652745, -7.055592850332649],
            [12.610488886939535, -7.066037745956592],
            [12.612265095114696, -7.06897681325538],
            [12.603989212800451, -7.072700509687648],
            [12.60291349200482, -7.068099928045242],
            [12.598871746532096, -7.064952082818967],
            [12.600972034048423, -7.061541752752251],
            [12.591543249175404, -7.050274348651243],
            [12.588111681128726, -7.0506432837106345],
            [12.587051343554597, -7.054191882162732],
            [12.582970695850513, -7.049824397177069],
            [12.578255335754026, -7.047588197326407],
            [12.568319446666681, -7.049280404252377],
            [12.56497506062534, -7.052878521330863],
            [12.56054130204243, -7.050998863260626],
            [12.551841627883872, -7.055068517826752],
            [12.538560969497139, -7.048967984802938],
            [12.52994520332692, -7.050604884028065],
            [12.526323845957565, -7.052577147978213],
            [12.523864957355691, -7.048280955879959],
            [12.518574906713818, -7.0467306947081685],
            [12.51406630904633, -7.047287743583118],
            [12.509524751077727, -7.036278043375359],
            [12.50309485660653, -7.031977001157927],
            [12.50264835247749, -7.026289513779135],
            [12.492716438767156, -7.020264378862874],
            [12.490097655882021, -7.022309056405322],
            [12.488737875796, -6.940381284629741],
            [12.487876215554946, -6.944320192325606],
            [12.485047302732442, -6.945387247800556],
            [12.477976344997995, -6.936524213202144],
            [12.471221298622103, -6.942849651114447],
            [12.468449349342606, -6.937261212635535],
            [12.471328470288656, -6.926181357086309],
            [12.474571303688661, -6.920289680813505],
            [12.477053968241316, -6.911672518699118],
            [12.477495979811955, -6.906091050213227],
            [12.482312224190858, -6.899715235474398],
            [12.481470648281515, -6.890758849910162],
            [12.47516626246105, -6.889186575078933],
            [12.4666149604997, -6.881014078696865],
            [12.462900690794333, -6.88089727396643],
            [12.458129171443263, -6.875001692379041],
            [12.455691617126035, -6.8674741677560585],
            [12.45872902316203, -6.859917311394377],
            [12.462837262335565, -6.858702014828675],
            [12.462851660381702, -6.85443853689376],
            [12.460045749991751, -6.850397879961556],
            [12.45904893446113, -6.842806113522275],
            [12.461677946056069, -6.8329029838226285],
            [12.458230072557544, -6.827726619381738],
            [12.459245222646796, -6.82383584145978],
            [12.457739043838131, -6.81425527093381],
            [12.452578718542878, -6.811479569397254],
            [12.449586736362486, -6.812974555303818],
            [12.442783931776427, -6.813602989937991],
            [12.437782073779593, -6.808927739643159],
            [12.431196818619645, -6.809851350494014],
            [12.430652224663632, -6.8054242172495245],
            [12.433242203172712, -6.802621738560335],
            [12.432587913277287, -6.799891617960985],
            [12.428677047071565, -6.797339377678155],
            [12.432023331722556, -6.793716843892384],
            [12.436289845620315, -6.796602020341882],
            [12.436607443730372, -6.7883254431066495],
            [12.433936859301168, -6.778350873348472],
            [12.436018270589289, -6.775503334052745],
            [12.435434702101395, -6.768941952618247],
            [12.43880168527719, -6.767426715183062],
            [12.439756224112726, -6.7625056807328905],
            [12.44489835492418, -6.758398055428825],
            [12.462579458081988, -6.752000487527757],
            [12.469740917583248, -6.753159800567137],
            [12.504324861908445, -6.74895660099734],
            [12.505836206382776, -6.743281928242362],
            [12.509143521496048, -6.738066667399286],
            [12.5085420415856, -6.731201457590363],
            [12.509872559943531, -6.726419682732933],
            [12.513842830637959, -6.720569817379259],
            [12.514705302895923, -6.7146091115343],
            [12.516934541278893, -6.707671332336812],
            [12.521165864957888, -6.702872811526031],
            [12.52928744245331, -6.691228538915716],
            [12.539295127278223, -6.694994354775982],
            [12.540450786425518, -6.688645971098853],
            [12.556369005346287, -6.6686415731801]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.66995528569973,
          "lat": 30.930620987807792
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13039"],
        "coty_name": ["Camden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Camden County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01671316"
      },
      "bbox": [
        12.428677047071565, -7.09521309617255, 12.902463531900782,
        -6.6686415731801
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.693240022276942, -4.103826002847755],
            [10.722326513502107, -4.078080465892514],
            [10.719235607590852, -4.075767370900505],
            [10.718837855495677, -4.069850775210656],
            [10.720886276127517, -4.068110501823105],
            [10.727505499547751, -4.068672234581154],
            [10.732859540624649, -4.07131869054418],
            [10.780598077807767, -4.040602980941489],
            [10.809758171875554, -4.022396190124883],
            [10.80205567755663, -4.020679803552044],
            [10.808377075262504, -4.014960574106734],
            [10.812265839710617, -4.0156107242079875],
            [10.814542786347033, -4.019360512757454],
            [10.828461646607595, -4.010501049014474],
            [10.845792015791577, -4.01610750720558],
            [10.860898059366436, -4.019812570392839],
            [10.881022712105517, -4.03139525728672],
            [10.885985824017027, -4.035391534012355],
            [10.892491581071107, -4.035526546872113],
            [10.898062826922319, -4.038368550373894],
            [10.901312767195211, -4.035703923035565],
            [10.908977266113677, -4.035895886401118],
            [10.91145894642766, -4.034011525109207],
            [10.916397021427152, -4.040490090253818],
            [10.913593132814277, -4.041625846402867],
            [10.907567800807247, -4.04015010465727],
            [10.909962055530283, -4.059028735685962],
            [10.905317629854734, -4.063870478661888],
            [10.91144794511662, -4.066769370795667],
            [10.913899786570823, -4.070009337866659],
            [10.91512341984271, -4.077177588515497],
            [10.91284854312324, -4.082676376148678],
            [10.905467145100788, -4.0870336987078515],
            [10.907752858853465, -4.094746548286713],
            [10.9101842077362, -4.099019462338813],
            [10.92600174801732, -4.11533559320776],
            [10.943475997695744, -4.132844052105777],
            [10.922432413884486, -4.192910515621168],
            [10.910849736080685, -4.191041996264392],
            [10.90094034324449, -4.193355294383544],
            [10.891083839573492, -4.189329491927703],
            [10.88583188816365, -4.191149799203949],
            [10.87994205795613, -4.190887751984831],
            [10.878537612114709, -4.186833242173148],
            [10.880891604721288, -4.184140115806468],
            [10.880444620873003, -4.18086677305605],
            [10.87747173156053, -4.177726566557038],
            [10.868197851047105, -4.1740550797951155],
            [10.862853568965233, -4.173230374591551],
            [10.860921641918736, -4.170038720080385],
            [10.85598596469598, -4.172087656187275],
            [10.855527374367835, -4.174903148356991],
            [10.849132840573269, -4.173777776859355],
            [10.84848536374047, -4.170314147089741],
            [10.843324475412363, -4.163143177957333],
            [10.837766565674656, -4.166111311906794],
            [10.832182796256589, -4.159335652002603],
            [10.827059969939397, -4.1575364062106335],
            [10.828353829745181, -4.154125260340865],
            [10.821635414665844, -4.153678620784375],
            [10.819158278507045, -4.1516574844856216],
            [10.817504034999741, -4.1462869229766435],
            [10.810613995124898, -4.143622948690488],
            [10.806875499251879, -4.139458887813155],
            [10.798993661502049, -4.137865536569094],
            [10.792619259727193, -4.130081211973677],
            [10.785122526479617, -4.132398090547746],
            [10.782186785718494, -4.135847902808525],
            [10.775613142280442, -4.1358618826139155],
            [10.77232570531791, -4.1343542978520125],
            [10.765977360066813, -4.136239299291542],
            [10.76080960341659, -4.1347531647497044],
            [10.756163545162886, -4.135751115420423],
            [10.753701541851326, -4.131174703713164],
            [10.748816646376437, -4.1340243653654865],
            [10.741861720967083, -4.132580696334875],
            [10.734654378965384, -4.13233038327166],
            [10.731283468015107, -4.13491714364488],
            [10.721548632690283, -4.135282947412362],
            [10.693240022276942, -4.103826002847755]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.36730672323698,
          "lat": 33.951288809635386
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13059"],
        "coty_name": ["Clarke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarke County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01672699"
      },
      "bbox": [
        10.693240022276942, -4.193355294383544, 10.943475997695744,
        -4.010501049014474
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.063013995744736, -7.103711772653251],
            [10.135268801412657, -7.096320795382143],
            [10.134839670657861, -7.084847152148459],
            [10.22137019354747, -7.074968218452727],
            [10.250748626853008, -7.07206195452942],
            [10.362095992367856, -7.058073427702618],
            [10.363110637142624, -7.063682320353111],
            [10.377619598206083, -7.180570899330004],
            [10.385584304264736, -7.25501793405377],
            [10.392090508532986, -7.317044472408175],
            [10.394710931088085, -7.339706654220834],
            [10.406189458158783, -7.442510188479222],
            [10.326061570282386, -7.449404102355674],
            [10.270265413231582, -7.452139766706247],
            [10.212942920458575, -7.45590573022403],
            [10.179847566014896, -7.457729325621546],
            [10.110994860154202, -7.4622346598438005],
            [10.015718860641094, -7.4683730149498],
            [9.992513176963932, -7.470287242027358],
            [9.991031243574941, -7.4622157089429155],
            [9.985775596039982, -7.455339104639701],
            [9.983309166293802, -7.449030615920408],
            [9.984808999708923, -7.434986024948504],
            [9.987032515774434, -7.431103840314346],
            [9.990971248938733, -7.428905225493991],
            [9.988475883171937, -7.420725563315216],
            [9.99048363332607, -7.418374831954194],
            [9.99632743867613, -7.417806319584855],
            [9.998068037353972, -7.4142992349642265],
            [9.9969236544532, -7.409026871564856],
            [10.000527435983445, -7.407404225154633],
            [10.00407253807124, -7.408191044316571],
            [10.005196192306135, -7.403854713355562],
            [10.00852563733428, -7.40066183136738],
            [10.01711849771718, -7.400356599639369],
            [10.023203711094135, -7.39493781409684],
            [10.02799235567888, -7.394576599182484],
            [10.030641541633246, -7.38757842859809],
            [10.031252113625833, -7.38067797195403],
            [10.035098479962075, -7.375320042853081],
            [10.045525896547467, -7.374495738810398],
            [10.046692032812741, -7.37055349802761],
            [10.043165658039602, -7.361254499830055],
            [10.047114512188637, -7.356783632770211],
            [10.04583390812443, -7.351827850797867],
            [10.05696148270854, -7.338711156943256],
            [10.057318216308452, -7.334653018716919],
            [10.05335382486013, -7.302574609294653],
            [10.055279955276985, -7.29787826272758],
            [10.054208450061834, -7.2890210936116],
            [10.063538940929721, -7.287963651561006],
            [10.053645548313215, -7.1967776381936535],
            [10.04759715336075, -7.13357916999087],
            [10.056660891562656, -7.1328010971051805],
            [10.055600395331746, -7.123729127639185],
            [10.06463298579881, -7.122671011817075],
            [10.063013995744736, -7.103711772653251]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.57906156227011,
          "lat": 30.878331953645976
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13087"],
        "coty_name": ["Decatur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Decatur County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00352234"
      },
      "bbox": [
        9.983309166293802, -7.470287242027358, 10.406189458158783,
        -7.058073427702618
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.766225569902558, -4.632568766521903],
            [10.79352271956689, -4.621791912421536],
            [10.803945497920761, -4.618073177031881],
            [10.824998877329302, -4.609567910742773],
            [10.879776324619922, -4.588262796826685],
            [10.892490945914382, -4.583763394746531],
            [10.968157224749767, -4.55616070705867],
            [10.970445395778578, -4.56275495388487],
            [10.971887223717056, -4.570408622241625],
            [10.974913889989223, -4.574824190065481],
            [10.981512356556765, -4.576500341641925],
            [10.990054122667196, -4.580332263856855],
            [10.991446693945107, -4.585340631386785],
            [10.988250056054003, -4.588541310852773],
            [10.987490392937714, -4.593823669662095],
            [10.990559199027015, -4.595281752922441],
            [10.993532525378242, -4.599265190849745],
            [11.000978937970963, -4.606504340593246],
            [11.002691973789211, -4.611427640759317],
            [11.00996105506573, -4.616097239377735],
            [11.009868645743277, -4.623558158001563],
            [11.00844805270767, -4.6333273241569986],
            [11.010514503778833, -4.636932767104152],
            [11.016363266802149, -4.631588250954503],
            [11.02356729886558, -4.628604390226637],
            [11.03090196490476, -4.629463665425529],
            [11.034819597376226, -4.63268121447126],
            [11.029185452068482, -4.639243874133879],
            [11.02981693744653, -4.642669682556384],
            [11.026918356717042, -4.6482219861826355],
            [11.027505375583141, -4.652505345594617],
            [11.03406640925754, -4.652384266792181],
            [11.036426860647483, -4.648423332747877],
            [11.036813525255436, -4.643746284382052],
            [11.040161749487746, -4.643998279118913],
            [11.044206171728105, -4.641810740023472],
            [11.047406462408246, -4.63473313900261],
            [11.056009142247184, -4.636444799624641],
            [11.056716348162531, -4.642109576571484],
            [11.05936943411734, -4.6448528419678],
            [11.065793701369078, -4.645656980518599],
            [11.065750788670998, -4.6495151527407765],
            [11.073696789946212, -4.656138450560085],
            [11.073857781741419, -4.66008440124204],
            [11.077277911394107, -4.663852387740027],
            [11.080552586494141, -4.671052634927594],
            [11.084445692680045, -4.674661046768781],
            [11.090929131850606, -4.676649335806279],
            [11.094775584309646, -4.681713729362287],
            [11.099123612093514, -4.68389167381816],
            [11.100304960896915, -4.688918240530653],
            [11.097758180457246, -4.694759215608557],
            [11.096342290329606, -4.702758425779828],
            [11.1015882080367, -4.712320847863565],
            [11.097814178042498, -4.716194293293489],
            [11.082638132755102, -4.725047119673541],
            [11.079112941393149, -4.728709495825685],
            [11.077376457042991, -4.735258255336151],
            [11.067699605297578, -4.740093935490451],
            [11.05946540299038, -4.746400907003993],
            [11.058110409838177, -4.7509634882869864],
            [11.054001596139646, -4.751796422026108],
            [11.051499587103772, -4.749035070658361],
            [11.048345353046233, -4.749911044054857],
            [11.043907847861245, -4.754341196293338],
            [11.037087293907222, -4.756887145138483],
            [11.041432800104094, -4.762132755177957],
            [11.042970084404029, -4.766290764042001],
            [11.040218811459814, -4.77646972133053],
            [11.031487258382022, -4.771252882413444],
            [11.027132261819252, -4.772274262796885],
            [11.020060652200751, -4.776148856055242],
            [11.019106600575762, -4.781088359653711],
            [11.020285790164317, -4.790430645102227],
            [11.023795973280288, -4.797142378015747],
            [11.024104426626588, -4.8009249873632625],
            [11.021477526591934, -4.80560117418892],
            [11.0199247006204, -4.81446788298382],
            [11.020766539394737, -4.81756526692731],
            [11.019445003506707, -4.82781140835793],
            [11.011133618411336, -4.836082951272528],
            [11.011281485244904, -4.8461249126436226],
            [11.012746082258817, -4.850058440848393],
            [10.998755354392234, -4.848758312921064],
            [10.99558179346869, -4.85020576316743],
            [10.99174387571099, -4.8547446156241145],
            [10.989149355018366, -4.85977243698042],
            [10.981578785663979, -4.859617978538196],
            [10.976780895925042, -4.862214868079506],
            [10.97991897543056, -4.864801582333868],
            [10.980244724782954, -4.868551713033998],
            [10.977107780807142, -4.872763908125724],
            [10.974689497531692, -4.869249100075005],
            [10.969748514671602, -4.868070915432787],
            [10.97119659693133, -4.872377306870818],
            [10.968822783851614, -4.8759234481396465],
            [10.961519010829855, -4.872226136979887],
            [10.95546264935676, -4.8740332860865125],
            [10.949323004717195, -4.867302820685823],
            [10.939990086666336, -4.867209392922389],
            [10.942611695992728, -4.876289448263061],
            [10.941482515700159, -4.878046725469623],
            [10.936331003780802, -4.874788934751246],
            [10.932259451101643, -4.876271141165525],
            [10.93107698691851, -4.872101998461979],
            [10.926372415606917, -4.87291641098305],
            [10.92012091210818, -4.868778027502223],
            [10.919293949466459, -4.864446068592428],
            [10.911074906034242, -4.868628878807764],
            [10.906515558589362, -4.869103101340072],
            [10.903956645538177, -4.866578542100644],
            [10.899576103875598, -4.8737904345961836],
            [10.893197823233772, -4.874621609079471],
            [10.890462256265268, -4.871556565127314],
            [10.885280290950902, -4.868969551221928],
            [10.880242910607697, -4.871824575542833],
            [10.87701556612813, -4.869783422304862],
            [10.790783112032114, -4.895001486707845],
            [10.779245384519458, -4.7815890256493985],
            [10.777207496984802, -4.754830512127151],
            [10.772294930581408, -4.713917782873438],
            [10.771708558052099, -4.6929249589379465],
            [10.768230994798346, -4.673471935033026],
            [10.766966652895974, -4.639469278429666],
            [10.766225569902558, -4.632568766521903]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.372863706957, "lat": 33.32175572888856 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13237"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "237",
        "coty_gnis_code": "00347246"
      },
      "bbox": [
        10.766225569902558, -4.895001486707845, 11.1015882080367,
        -4.55616070705867
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.242767790105034, -6.119056880936839],
            [11.265013035374945, -6.089784012424228],
            [11.322536694639224, -6.013683296883804],
            [11.366794381459243, -5.955828555743093],
            [11.36950641039808, -5.951353215371952],
            [11.37916846988644, -5.939817939752818],
            [11.391569453140448, -5.9229254371342925],
            [11.432732140619898, -5.867517961774795],
            [11.420006556519995, -5.857963503330796],
            [11.4349710186035, -5.837737954800189],
            [11.441735116792909, -5.842963939922931],
            [11.4365027419633, -5.849945182482688],
            [11.443042772155891, -5.854795042135526],
            [11.434549934813871, -5.866476666389093],
            [11.442667666588706, -5.864333124109709],
            [11.455142630921149, -5.864890727780351],
            [11.458786764751522, -5.869040269590684],
            [11.464004154552462, -5.872430681025808],
            [11.468111755509844, -5.876542109961082],
            [11.470195742274038, -5.889084286000153],
            [11.475834892647756, -5.898664818714442],
            [11.480715909657611, -5.900266799725231],
            [11.484673058809049, -5.905224557110217],
            [11.496123738707007, -5.909273650833077],
            [11.49965728612115, -5.908346062684548],
            [11.510315775474709, -5.91494810658246],
            [11.511868791561128, -5.918149272784938],
            [11.51642247947344, -5.919993342221118],
            [11.52482214084598, -5.91974808703412],
            [11.528804014906328, -5.918163726736365],
            [11.536069956508868, -5.9196639824626205],
            [11.53778838639964, -5.92204450491769],
            [11.548089702941207, -5.923978358981134],
            [11.555658492226675, -5.926515766312602],
            [11.560904017807795, -5.9296681881587],
            [11.566817858778714, -5.939419408754524],
            [11.572741603431568, -5.943374934078677],
            [11.576362464587802, -5.9501109534867975],
            [11.582988039060995, -5.953335306953493],
            [11.587325682796758, -5.952615128868578],
            [11.59000067708392, -5.956580906065234],
            [11.594675749186258, -5.958586555033832],
            [11.597685141228395, -5.957774471404043],
            [11.610168140308208, -5.960837844994959],
            [11.617301756547056, -5.958791289274949],
            [11.627260925725075, -5.959295020033865],
            [11.634717107252287, -5.963978693751902],
            [11.6338942915926, -5.968352607235566],
            [11.637292472592856, -5.973686178898242],
            [11.640257828027991, -5.975613620054139],
            [11.640198444838795, -5.978978426634378],
            [11.645572609887447, -5.982919965758597],
            [11.646820049579826, -5.987373316665111],
            [11.65069459047394, -5.98999050486407],
            [11.653654105136948, -5.989371200928568],
            [11.65903704341779, -5.996669027206953],
            [11.662222424167618, -6.004382379471338],
            [11.668239699430899, -6.006836682351332],
            [11.669912625022167, -6.010118821634056],
            [11.67661770499516, -6.012762671321598],
            [11.68689435337876, -6.02391163063046],
            [11.701242917615588, -6.026892714343136],
            [11.700515318672707, -6.031977767100617],
            [11.708974554266955, -6.036163583258793],
            [11.704473605241276, -6.038713716021399],
            [11.704092403717773, -6.034832034692629],
            [11.69578336180033, -6.0370088531102155],
            [11.688364615136951, -6.036437329351515],
            [11.68480907449886, -6.038473161251131],
            [11.677852661244573, -6.039325067098772],
            [11.684176020588604, -6.0453999660273094],
            [11.68327311079218, -6.049259864180893],
            [11.67811355487166, -6.050790780617923],
            [11.67507685193431, -6.055252343295265],
            [11.674925896075104, -6.0584011738217844],
            [11.671455777506088, -6.062216942301435],
            [11.668510055979942, -6.058291402900393],
            [11.665775991039467, -6.057665503290778],
            [11.664481951231217, -6.062386786405986],
            [11.661301644938698, -6.063437438183321],
            [11.661193115428826, -6.0686987536434955],
            [11.65797355805302, -6.073689198537473],
            [11.654834977898894, -6.073825703668082],
            [11.65345556717626, -6.077347784423798],
            [11.650358479188995, -6.076571371282084],
            [11.646552182551893, -6.0822484115671465],
            [11.642840372343901, -6.081960140683356],
            [11.638809935588476, -6.087264424688994],
            [11.634443459963967, -6.088983806131547],
            [11.627717933451667, -6.097656320703823],
            [11.625642976398431, -6.102529251935047],
            [11.626969504085215, -6.106237697049558],
            [11.624206864216223, -6.110565826959302],
            [11.619955365931544, -6.110331476662835],
            [11.619334600211388, -6.107696683257291],
            [11.613203482977596, -6.1076987576401045],
            [11.614079473776654, -6.113473168046598],
            [11.608372061984978, -6.110502914009397],
            [11.604798389993075, -6.113722691462357],
            [11.604336783807216, -6.117454199475762],
            [11.59735486537202, -6.117607692943992],
            [11.596662761919573, -6.124279796964779],
            [11.598540903301378, -6.127451677272095],
            [11.602027426395598, -6.128247514701737],
            [11.603818137476761, -6.131924599656449],
            [11.598171945476178, -6.137381478593113],
            [11.59501313499292, -6.136622597262905],
            [11.589386324221053, -6.1436875001539395],
            [11.584611103223724, -6.1454591294000736],
            [11.587116345406011, -6.148440062502074],
            [11.581010151613956, -6.155368787181181],
            [11.571803735284476, -6.161424955272416],
            [11.568591541774397, -6.157188492343681],
            [11.563670169470393, -6.160075012664233],
            [11.559560975048637, -6.16608341887332],
            [11.562905309427183, -6.168279062243518],
            [11.554095598389079, -6.180058136661117],
            [11.549698289404104, -6.180397520738913],
            [11.549548706369396, -6.188037586009995],
            [11.542707200645571, -6.194066262482061],
            [11.536735856057131, -6.195930061873871],
            [11.53465989796082, -6.193670204004166],
            [11.53007262449679, -6.199092679549648],
            [11.52329952004139, -6.201746586837596],
            [11.521110082005478, -6.199895300402245],
            [11.515256500035084, -6.200071648711235],
            [11.513746630154996, -6.192103725054313],
            [11.508322719189778, -6.199289521848488],
            [11.50110881759893, -6.201902437944032],
            [11.50106399040413, -6.205933975817733],
            [11.497429675949888, -6.205163187311978],
            [11.499096435024116, -6.20127428184177],
            [11.489825089306496, -6.201396128299092],
            [11.485528323784305, -6.199704852628134],
            [11.483228086832106, -6.2012056866186684],
            [11.47693915815379, -6.2010792346405745],
            [11.468604509497885, -6.206616267590954],
            [11.463252365119077, -6.204359114449022],
            [11.455988403137102, -6.203016077779677],
            [11.452739626727366, -6.20055240274592],
            [11.44788212887136, -6.199175029081532],
            [11.444455839374958, -6.204071842418556],
            [11.439481827497172, -6.205329768588646],
            [11.438039020888214, -6.211618651570894],
            [11.434980540090844, -6.21325800784493],
            [11.431488804889991, -6.2137741680320575],
            [11.430062088501266, -6.219117991262717],
            [11.427391806347197, -6.220700833059968],
            [11.419750579251577, -6.217160474770264],
            [11.408294612933418, -6.219619436955978],
            [11.405196596955072, -6.214705457825553],
            [11.400077198484642, -6.212390424495599],
            [11.397329079605965, -6.20874371436641],
            [11.392097097895626, -6.2084987264536355],
            [11.391497517974894, -6.210585232450221],
            [11.38596720055399, -6.211645438534458],
            [11.383730921423167, -6.209227785816648],
            [11.378725793482314, -6.207596405313903],
            [11.370941105381132, -6.206647439611721],
            [11.368012539294371, -6.2016405312824165],
            [11.362964868120164, -6.2011076031827645],
            [11.361328967867037, -6.203536373236319],
            [11.357875846630085, -6.201657439475849],
            [11.355881735548389, -6.1974090347913044],
            [11.35308395015924, -6.196157450873514],
            [11.34442868643887, -6.198073925673886],
            [11.339891389820414, -6.192783569641677],
            [11.333773901953041, -6.190363170603968],
            [11.331487386638015, -6.196646100208595],
            [11.325017561238191, -6.1973892095488505],
            [11.31927297567302, -6.199804351617391],
            [11.313598907050817, -6.197238791302149],
            [11.315577036147358, -6.195007626977222],
            [11.314810968923064, -6.1897343589631655],
            [11.312663686535194, -6.1864360370674065],
            [11.309539119063365, -6.185630432790792],
            [11.303303225975762, -6.1875003288495805],
            [11.298009561558718, -6.18764786147282],
            [11.296802560226416, -6.180977647349101],
            [11.289570176401888, -6.1790273474015605],
            [11.288112112567237, -6.175866067142781],
            [11.281349348027508, -6.174723449404371],
            [11.27353007245627, -6.16779643284503],
            [11.271218390441614, -6.159976482313032],
            [11.267136455952109, -6.157675746522127],
            [11.270891009841867, -6.149134764492916],
            [11.269035026909057, -6.142244661055739],
            [11.26615995644129, -6.139867650011495],
            [11.257282273892645, -6.1425556722334],
            [11.254909590492373, -6.139780970342497],
            [11.250516616074814, -6.1381533285149885],
            [11.25146907467812, -6.134189587338364],
            [11.245406866654077, -6.129872441789786],
            [11.24837085826095, -6.127095295656427],
            [11.242280415567663, -6.124250385669239],
            [11.242767790105034, -6.119056880936839]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.93895711272468, "lat": 31.92984230190497 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13271"],
        "coty_name": ["Telfair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Telfair County"],
        "coty_fp_code": "271",
        "coty_gnis_code": "00356958"
      },
      "bbox": [
        11.242280415567663, -6.220700833059968, 11.708974554266955,
        -5.837737954800189
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.97872537169439, -5.118729891597832],
            [11.033102486357837, -5.085430385300928],
            [11.044065779485384, -5.093888456426816],
            [11.053095918183946, -5.080496867567029],
            [11.047943005102034, -5.076547513570029],
            [11.073362170617486, -5.05967402476021],
            [11.096236531094995, -5.044865415284457],
            [11.099489120962724, -5.0465518255946105],
            [11.104059447889256, -5.0445916088043],
            [11.107608432799733, -5.045765295781422],
            [11.110801496410591, -5.050787335181329],
            [11.124223580606357, -5.053804399138526],
            [11.134317330805583, -5.053901380922804],
            [11.117769100484635, -5.038109459138661],
            [11.132104805804587, -5.020588563564764],
            [11.137584967170817, -5.025257803150581],
            [11.141800503505289, -5.021962151200023],
            [11.139245872411108, -5.0155481805910656],
            [11.141358225445218, -5.013403395128172],
            [11.15332391566154, -5.013352899426314],
            [11.155500867444166, -5.015341976629828],
            [11.156067607064971, -5.020027252242843],
            [11.161078029398134, -5.021895647460789],
            [11.16337314012365, -5.026570752129599],
            [11.160076493848834, -5.03040145399174],
            [11.165292044482475, -5.030849677610614],
            [11.162564633204608, -5.034734634809844],
            [11.170393118406155, -5.037127334713578],
            [11.172678723733661, -5.044516660781264],
            [11.178193895344787, -5.044870826470034],
            [11.18221753733749, -5.046902495157626],
            [11.185560512481722, -5.050516756520079],
            [11.18973808438416, -5.049469858501239],
            [11.191123662040534, -5.056406472004331],
            [11.193384160531265, -5.055817574713715],
            [11.197408504898258, -5.059103899045006],
            [11.198947750189355, -5.064199404619229],
            [11.203416722749795, -5.061444000451436],
            [11.210739011472397, -5.066802406988946],
            [11.211945774905486, -5.069275275008555],
            [11.216803518622086, -5.0717297914030395],
            [11.217151304687834, -5.0795640119596195],
            [11.22232534240859, -5.077131387531638],
            [11.224475747066336, -5.081038267556081],
            [11.22238134189014, -5.083875352826214],
            [11.225426890245933, -5.08697415210426],
            [11.225288826910905, -5.091278150950834],
            [11.232793605484309, -5.096867606426836],
            [11.232809947787691, -5.101747279443611],
            [11.236656171381759, -5.100169013307194],
            [11.235312741837706, -5.10976210299687],
            [11.238754291369506, -5.112564492973214],
            [11.236884328970751, -5.116504914056308],
            [11.242810358130965, -5.127039786663786],
            [11.247912301301538, -5.129864769956878],
            [11.252879593375246, -5.1350231890284945],
            [11.254356323961895, -5.1420696296417505],
            [11.25758223766932, -5.141386769578074],
            [11.258857071197722, -5.147357146716525],
            [11.261632662350959, -5.151326799899692],
            [11.264735410619178, -5.151281599523807],
            [11.27002566749986, -5.148711583928736],
            [11.274232312722374, -5.152004483453276],
            [11.28543912105646, -5.148752349802594],
            [11.287697179067564, -5.152893349183111],
            [11.290965771998854, -5.150320923801474],
            [11.292934459249796, -5.154804934522992],
            [11.303273411643245, -5.157635265258626],
            [11.302484722920646, -5.161078463517689],
            [11.30760378247627, -5.162116276277208],
            [11.311945818833951, -5.16786486190131],
            [11.309280775582845, -5.169958592584125],
            [11.315158431586935, -5.17338708093829],
            [11.311818047010263, -5.177892919948528],
            [11.316589073767105, -5.181284171930439],
            [11.322363801733319, -5.191316805883457],
            [11.329231050931824, -5.197048791921286],
            [11.32797374687564, -5.203795858151909],
            [11.328951911100486, -5.209024702403329],
            [11.327662112047218, -5.224674710149633],
            [11.328692574837362, -5.231511097346919],
            [11.330732046529207, -5.235880626465649],
            [11.33680106457859, -5.240102359208221],
            [11.341188949271393, -5.238287053942398],
            [11.344178694321622, -5.256179605585267],
            [11.343206557494515, -5.272289616140216],
            [11.340719428421115, -5.276878727037802],
            [11.33984906641345, -5.290083707837113],
            [11.275249676427071, -5.334301521219844],
            [11.235330240573433, -5.364445474809172],
            [11.187152223471116, -5.40159102123383],
            [11.133242426340344, -5.443640090185057],
            [11.116391326212149, -5.421094325654342],
            [11.055441713722415, -5.327278209068686],
            [11.018646335075031, -5.270687114013341],
            [10.941669177665327, -5.151888214363261],
            [10.97872537169439, -5.118729891597832]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.17124219189785, "lat": 32.80236006876395 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13319"],
        "coty_name": ["Wilkinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilkinson County"],
        "coty_fp_code": "319",
        "coty_gnis_code": "00346824"
      },
      "bbox": [
        10.941669177665327, -5.443640090185057, 11.344178694321622,
        -5.013352899426314
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.480213052897705, 6.858045705435691],
            [-14.459680090126266, 6.8535254456078745],
            [-14.469336055892471, 6.811066170727888],
            [-14.440964787609575, 6.804465662455578],
            [-14.444020749279924, 6.790352818477367],
            [-14.430189056097186, 6.787325233308029],
            [-14.433067151170949, 6.773553077919164],
            [-14.404607826455724, 6.766968846025492],
            [-14.407830715116582, 6.7526887937864695],
            [-14.365756742974797, 6.743361798635012],
            [-14.364201107305805, 6.750346370462989],
            [-14.336057255220773, 6.744204950447644],
            [-14.334120952718013, 6.751203568275352],
            [-14.306104466761548, 6.745000559437674],
            [-14.165600937674418, 6.714255229729958],
            [-14.176107688103027, 6.667204456357657],
            [-14.186146091513182, 6.621277031315061],
            [-14.203238123081903, 6.545805211959037],
            [-14.17535903548356, 6.5396570417686775],
            [-14.185499470371825, 6.49349821626378],
            [-14.191124407490774, 6.468645871140966],
            [-14.20659757220195, 6.397465793194624],
            [-14.21284662148956, 6.3697547975783895],
            [-14.241027693270816, 6.375344235461994],
            [-14.26004336359796, 6.290212328790605],
            [-14.25914141144718, 6.289772397477931],
            [-14.276317359901352, 6.210424005307906],
            [-14.277879284209131, 6.214307738049333],
            [-14.281755056946048, 6.219164471865754],
            [-14.288188991591152, 6.221702102245209],
            [-14.291787288859542, 6.221847853385512],
            [-14.297309057918115, 6.225211340972435],
            [-14.301679221006967, 6.224836679446688],
            [-14.309727175600214, 6.230192272033404],
            [-14.320520831367798, 6.236091025180802],
            [-14.321490399297995, 6.246401719736661],
            [-14.325687926319475, 6.258173316548312],
            [-14.329922863974218, 6.263366740902344],
            [-14.328391410339963, 6.2692395783024315],
            [-14.330553181256501, 6.284475029511554],
            [-14.333146858321804, 6.289179434370033],
            [-14.33517453845271, 6.299671971513773],
            [-14.337400873713664, 6.3050785089501895],
            [-14.341702905881238, 6.307410304947082],
            [-14.348698025851592, 6.315625105726693],
            [-14.353395631254456, 6.315901694814996],
            [-14.358632254508139, 6.3226344841058],
            [-14.365435445039854, 6.328198982297279],
            [-14.367336900871136, 6.333261316101317],
            [-14.368882134938739, 6.342900299674639],
            [-14.373222715148701, 6.349961282279353],
            [-14.378279115854479, 6.354513516402842],
            [-14.382532450261774, 6.360607900668171],
            [-14.384116024779754, 6.365934213325746],
            [-14.389326743724563, 6.372951588210892],
            [-14.391272924883124, 6.379356100092179],
            [-14.394282980705398, 6.383715109695809],
            [-14.39730644719788, 6.385505966903759],
            [-14.399080812934441, 6.392043670716436],
            [-14.403930826199987, 6.402201563084227],
            [-14.405072244952205, 6.407429821977802],
            [-14.410965553688184, 6.41348996391871],
            [-14.424469106711523, 6.429798817836899],
            [-14.425860527387131, 6.435633901574129],
            [-14.423513500600933, 6.446516802202856],
            [-14.423573557356146, 6.455294347619778],
            [-14.421186508421396, 6.462128214250353],
            [-14.420471264374825, 6.471578709352581],
            [-14.415564599509725, 6.47910331871605],
            [-14.415168433776865, 6.4850437250495965],
            [-14.418638455496914, 6.491330595677265],
            [-14.420657623191872, 6.498458720748957],
            [-14.42394826879261, 6.506471070452128],
            [-14.423439636314251, 6.517864551558654],
            [-14.424025372490636, 6.523387407188882],
            [-14.426629873271319, 6.533279508372344],
            [-14.428986900032852, 6.5378535322656575],
            [-14.43766143665173, 6.546617554847466],
            [-14.44088216920092, 6.55357628358139],
            [-14.445424229549738, 6.558339248837052],
            [-14.458055802904981, 6.560730779215959],
            [-14.462853405212082, 6.559588864072217],
            [-14.470596867332217, 6.565277432911087],
            [-14.47818576013981, 6.568846880295111],
            [-14.48497742397568, 6.573540861595344],
            [-14.488403983797845, 6.57403197613425],
            [-14.4927100283063, 6.584193224946562],
            [-14.49511553465831, 6.594744061075762],
            [-14.500453386924736, 6.602651530621513],
            [-14.50820486136852, 6.610813347345022],
            [-14.513990838972104, 6.615765708998059],
            [-14.516142703175865, 6.6216751194016386],
            [-14.516598005502976, 6.633043759099033],
            [-14.514306819273223, 6.641964079389341],
            [-14.516772210871272, 6.649775130565288],
            [-14.523525460244446, 6.655084184680467],
            [-14.531674126145546, 6.6562374063584535],
            [-14.540431594999777, 6.65984939347434],
            [-14.550524728280974, 6.667070532498067],
            [-14.554184930495765, 6.670870001531256],
            [-14.542855523767765, 6.721603920382074],
            [-14.542495177517782, 6.722576313899777],
            [-14.526139706217975, 6.794734740257234],
            [-14.522363122310274, 6.799748869925907],
            [-14.520087383245357, 6.80492230012969],
            [-14.520537326927135, 6.809528072602865],
            [-14.525690627765023, 6.817028692629125],
            [-14.524083513541216, 6.820890826745499],
            [-14.517784097875161, 6.826818311412151],
            [-14.509438969290287, 6.823593383923145],
            [-14.506665997161232, 6.82788095067774],
            [-14.505798968573167, 6.8327459744870795],
            [-14.511314555033712, 6.838144519454535],
            [-14.510313851539037, 6.843155255802358],
            [-14.5030923266674, 6.844928283793428],
            [-14.494366740077997, 6.845401079754853],
            [-14.489179192818964, 6.843454732485688],
            [-14.48344567688128, 6.8451700789161185],
            [-14.48111297313585, 6.84917988999396],
            [-14.480213052897705, 6.858045705435691]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.70930212133962,
          "lat": 43.62512852324066
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16027"],
        "coty_name": ["Canyon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Canyon County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00399406"
      },
      "bbox": [
        -14.554184930495765, 6.210424005307906, -14.165600937674418,
        6.858045705435691
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.935093103700938, 5.837963252063772],
            [-12.899852682780745, 5.830876222576092],
            [-12.864163613922129, 5.82403816757524],
            [-12.863894159677878, 5.825334860902902],
            [-12.778562285303888, 5.808609281032289],
            [-12.748027587344032, 5.802758731860769],
            [-12.69468860616158, 5.792808409568454],
            [-12.606909175609687, 5.775965464959751],
            [-12.519132982399222, 5.759105315891567],
            [-12.413709220507705, 5.738984200224672],
            [-12.308290133440863, 5.718838290045352],
            [-12.36648641070261, 5.409068987621984],
            [-12.373087737499276, 5.374486026597427],
            [-12.408721855319497, 5.381276176320159],
            [-12.424698562886151, 5.297322875277603],
            [-12.426509272043225, 5.297436523369626],
            [-12.481944436497546, 5.308115865133776],
            [-12.54492370768861, 5.32059869403157],
            [-12.6296995944001, 5.336749807124152],
            [-12.621370697473766, 5.379457638900893],
            [-12.727208123642702, 5.400206285395556],
            [-12.83305014910812, 5.4209311713814134],
            [-12.830245889540448, 5.435187527237948],
            [-12.844315916010038, 5.437976744504829],
            [-12.83909402146042, 5.46469037856164],
            [-12.895230907787827, 5.475652837863289],
            [-13.002845003132618, 5.496902668220433],
            [-12.977364351589133, 5.62535421248957],
            [-12.969804838296193, 5.664185479358304],
            [-12.968748623476559, 5.66826462757879],
            [-12.935093103700938, 5.837963252063772]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.13827414775572,
          "lat": 43.00237251514148
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16063"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00395624"
      },
      "bbox": [
        -13.002845003132618, 5.297322875277603, -12.308290133440863,
        5.837963252063772
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.642721580649611, 3.6449014978939838],
            [4.7181320812082115, 3.6516049466008402],
            [4.761384487030666, 3.6552347163572194],
            [4.796434370456498, 3.6577968513072165],
            [4.820717476862496, 3.659110069221929],
            [4.873875316304774, 3.6625476145852947],
            [4.8987536248357255, 3.663896349356324],
            [4.934488892049339, 3.6661989025037185],
            [4.97780847927423, 3.668772330954811],
            [4.97788715530428, 3.6701407434761775],
            [5.004102035486943, 3.6716969657003062],
            [5.0614669881118495, 3.6755197834104556],
            [5.104157334278486, 3.6794989530353734],
            [5.111816418489558, 3.5922849826027683],
            [5.113263751420368, 3.570528809358875],
            [5.116094259954281, 3.533985775532068],
            [5.118507664542044, 3.505688950600935],
            [5.118149719420581, 3.5043937892181596],
            [5.120019963975093, 3.4736750749396212],
            [5.12317449613887, 3.4166548370519356],
            [5.124417475197882, 3.4100999328997923],
            [5.080399751358851, 3.4075619758109355],
            [5.0627348766515, 3.4061420724640565],
            [5.009382545753506, 3.4025107171225324],
            [4.929893043377392, 3.398362195818893],
            [4.90867688276806, 3.396962884560667],
            [4.880345340175756, 3.394430774204441],
            [4.823308277096174, 3.390089093713798],
            [4.807767230833087, 3.389149714416281],
            [4.799784087496292, 3.387925736391593],
            [4.78066568541126, 3.386680154939202],
            [4.779804269294231, 3.390798370922361],
            [4.7708224797285625, 3.4022098734567625],
            [4.769774919087973, 3.4061013596741527],
            [4.769915263976913, 3.413480484328021],
            [4.771068510081369, 3.4187036073217407],
            [4.776396002067515, 3.431947260494621],
            [4.781554835848896, 3.4395299964175137],
            [4.781274099558558, 3.4463720665174025],
            [4.784778784317055, 3.4545047450776933],
            [4.784735252928372, 3.4618073884086975],
            [4.781278177848431, 3.4733070467187965],
            [4.777779168998047, 3.478261445602956],
            [4.774557080303633, 3.4887581169617934],
            [4.772461099177268, 3.491086640830898],
            [4.764347251333402, 3.4996845449114784],
            [4.762291117936551, 3.520236566880682],
            [4.759417123330261, 3.533293645370513],
            [4.762329628800387, 3.5453891145805585],
            [4.7630294168519915, 3.5568098270582826],
            [4.7628219378730305, 3.5643089206417615],
            [4.760905912827538, 3.5746089581539127],
            [4.754445337622589, 3.582751231583724],
            [4.742298190495824, 3.5822343728065773],
            [4.734875118879698, 3.5845399321333686],
            [4.7317186209776425, 3.5871404480144027],
            [4.728310928123116, 3.5951304691546877],
            [4.726180860405126, 3.6050990924688535],
            [4.724449431920806, 3.608588941629224],
            [4.719330508888637, 3.6123549671777733],
            [4.704975190976513, 3.6202432950929935],
            [4.693431644507482, 3.6256232182978527],
            [4.679324020305004, 3.627823167254616],
            [4.669441531579023, 3.631603517769169],
            [4.656962389655182, 3.639642656046258],
            [4.642721580649611, 3.6449014978939838]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.93426657468966, "lat": 42.06872313613508 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17015"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00424209"
      },
      "bbox": [
        4.642721580649611, 3.386680154939202, 5.124417475197882,
        3.6794989530353734
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.223098335836714, 0.9077516719727027],
            [6.23664978327043, 0.9079405613781848],
            [6.251096431462053, 0.9098538752026317],
            [6.307750276417933, 0.9141377669619623],
            [6.378610309442454, 0.9202387203502485],
            [6.392725266092319, 0.9218851281413466],
            [6.421574426984188, 0.9240673896129805],
            [6.446190802272862, 0.9263353389575696],
            [6.475334291488771, 0.9294546770588827],
            [6.475294932697113, 0.9299294706922896],
            [6.504179930961086, 0.9325823146069826],
            [6.561936040752741, 0.9385121643110036],
            [6.572802795272527, 0.9408680622711664],
            [6.57557143435791, 0.9115930313564607],
            [6.5845516698637345, 0.8231433900375631],
            [6.59351177850905, 0.734901627471451],
            [6.53937060030866, 0.7291137860953834],
            [6.471356448405867, 0.7223411501023222],
            [6.428612623170452, 0.7186149902774646],
            [6.323682832815014, 0.7098209036101467],
            [6.2392935050045315, 0.7034224213707887],
            [6.235781523145957, 0.7472618061814426],
            [6.230974617498485, 0.8055516867383481],
            [6.224309883240733, 0.8893271541358563],
            [6.223098335836714, 0.9077516719727027]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.24022990599002,
          "lat": 39.273341748027974
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17035"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00424219"
      },
      "bbox": [
        6.223098335836714, 0.7034224213707887, 6.59351177850905,
        0.9408680622711664
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.86859017944043, 1.6423328831365749],
            [3.8731686591746324, 1.6533907391112854],
            [3.8729135126413263, 1.658746092749022],
            [3.870881796407222, 1.6638081114347711],
            [3.8706089763920963, 1.6721693278150505],
            [3.874902401957247, 1.6877289375814097],
            [3.884515392935164, 1.7123306728346357],
            [3.8859097796114037, 1.717514887494319],
            [3.887634469410728, 1.7297649259882317],
            [3.8906196820983423, 1.737936738088285],
            [3.8975493032729585, 1.7496319528511401],
            [3.9026762690423302, 1.7594685229042966],
            [3.9066540476677667, 1.763090869476156],
            [3.9159786647080614, 1.7690099238117039],
            [3.921111935953661, 1.7755932379598092],
            [3.9257518178226762, 1.779868453965433],
            [3.9377881253584657, 1.7813086670279992],
            [3.944212728908203, 1.7834394434163072],
            [3.9489081643422295, 1.7863963677135337],
            [3.953384187886528, 1.7909017024707323],
            [3.955333435549446, 1.8004067297071593],
            [3.954907338966572, 1.8107590989581506],
            [3.953634274956202, 1.8171743004673926],
            [3.947316115376866, 1.8345375425243633],
            [3.946359390962393, 1.8417190603541709],
            [3.9484122163750053, 1.855789157872902],
            [3.9551017513382547, 1.8745356643557671],
            [3.9570125286965316, 1.8842448742246234],
            [3.9574462839613633, 1.8944038273325654],
            [3.95676188211554, 1.9002574164496622],
            [3.952498239809534, 1.9126560751075918],
            [3.942094384584493, 1.9280122798639872],
            [3.937184788530084, 1.932641009838122],
            [3.927477438830388, 1.9359253253061663],
            [3.9230679082586213, 1.9416762559785647],
            [3.9223427840159992, 1.9465455745070228],
            [3.923208832506954, 1.9537375307748188],
            [3.92580183187083, 1.9587248647939608],
            [3.941413867160648, 1.9746137868163427],
            [3.945151000258118, 1.9830113276057721],
            [3.9550183951657454, 2.0028858759955313],
            [3.9630042371591805, 2.0112394657146817],
            [3.9695927416393144, 2.0153904298588143],
            [3.993910082530558, 2.0294483610421215],
            [4.016417041608666, 2.036628317789383],
            [4.024766835626171, 2.0387122216026756],
            [4.0296646591090335, 2.0417612290973297],
            [4.0373911180382365, 2.0438811410204414],
            [4.059489671436956, 2.0450371419792805],
            [4.075034625240085, 2.0434693700817497],
            [4.084309736539562, 2.045920643432216],
            [4.09172259690878, 2.045933613544608],
            [4.12103631199835, 2.0471241252570898],
            [4.134423332680852, 2.047335158738058],
            [4.207095467420428, 2.049103722262458],
            [4.288331987791819, 2.0562242533582324],
            [4.295524031845271, 2.05807635115779],
            [4.297518727988694, 2.0023277137632687],
            [4.301744123918552, 1.90215634806349],
            [4.303629421137115, 1.8612822752742004],
            [4.308934226320452, 1.7425501464584876],
            [4.310522784097033, 1.700627395108776],
            [4.313781481651123, 1.6085819877160035],
            [4.197559722220989, 1.6042800062012468],
            [4.1373541017929965, 1.601822315232032],
            [4.089409476274006, 1.6006778028273125],
            [4.051378885985477, 1.5992595359199382],
            [3.982538955384403, 1.5972586371699844],
            [3.94708222075942, 1.5963255760181723],
            [3.925483203231267, 1.5955094707543613],
            [3.8650459340266674, 1.5928540001246043],
            [3.8629093966679307, 1.6022575773924472],
            [3.8628566409506395, 1.6085275560351713],
            [3.864453872334116, 1.617437208077517],
            [3.8640949137014933, 1.6249052551964172],
            [3.8622041313268407, 1.6294523933609997],
            [3.864333258079276, 1.636792688489646],
            [3.86859017944043, 1.6423328831365749]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.16469497397871, "lat": 40.4037353985597 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17067"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00424235"
      },
      "bbox": [
        3.8622041313268407, 1.5928540001246043, 4.313781481651123,
        2.05807635115779
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.939086680715992, 3.256352187331901],
            [5.969146679914313, 3.259098980659887],
            [5.993919602505605, 3.261676750858771],
            [6.103580779015099, 3.272399391815058],
            [6.189747407203623, 3.281456440351097],
            [6.190246938942494, 3.2815011719313265],
            [6.19642508901716, 3.2178459132900366],
            [6.19908880144233, 3.1929440570658096],
            [6.209029158628669, 3.106249243133508],
            [6.218388306927072, 3.019725229480694],
            [6.215282721893849, 3.019129616699471],
            [6.166469536406824, 3.013511414227738],
            [6.134804616207871, 3.0103589285827166],
            [6.099040108620376, 3.006552937002893],
            [6.048736772017983, 3.0008768392575513],
            [5.996396095437926, 2.996434031422965],
            [5.964077503551906, 2.993444887015452],
            [5.962286392779385, 3.0114457787405877],
            [5.953790660885482, 3.0920339918711517],
            [5.945767878653095, 3.1679022987053735],
            [5.940773397006158, 3.225006833164391],
            [5.937841976830717, 3.256238121094656],
            [5.939086680715992, 3.256352187331901]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.42877678492192, "lat": 41.59057571361742 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17093"],
        "coty_name": ["Kendall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kendall County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00424248"
      },
      "bbox": [
        5.937841976830717, 2.993444887015452, 6.218388306927072,
        3.2815011719313265
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.739246020424592, 1.5630450205427542],
            [4.744583065729733, 1.5656886048124485],
            [4.750916532459085, 1.5752005633948236],
            [4.756080892129903, 1.57838848723275],
            [4.76217875961325, 1.5800976886496847],
            [4.7717230924980285, 1.580220222931269],
            [4.776142465498846, 1.5822969319830134],
            [4.78383210722691, 1.5878665442193554],
            [4.7935532285370686, 1.5915161300750735],
            [4.802740175338413, 1.5975125159435108],
            [4.810942813644475, 1.5982344268497546],
            [4.820089601446817, 1.5970510785990712],
            [4.827943282061466, 1.5950749127599106],
            [4.835034440409973, 1.5949125637357842],
            [4.842312043538257, 1.5957647082029491],
            [4.847109793614557, 1.5987754073548772],
            [4.85186505983228, 1.6066859090451964],
            [4.85103947665091, 1.6200248337761827],
            [4.852737259238791, 1.6301041812250205],
            [4.856843485982287, 1.6387048283631922],
            [4.862842548502113, 1.6408170091984937],
            [4.866211312464175, 1.6432585692905428],
            [4.870365241263414, 1.6492882048073487],
            [4.8726369906687514, 1.6587998539880617],
            [4.874365934433674, 1.661377634168913],
            [4.882009781934165, 1.6681174651416901],
            [4.886048596496799, 1.6697433260511023],
            [4.896948037559619, 1.6720068189920199],
            [4.9045756966241445, 1.676900997518285],
            [4.9095709317991405, 1.683827766989708],
            [4.911338218693192, 1.688189325874644],
            [4.9153507469619635, 1.7061495723037012],
            [4.917702021110338, 1.7119994789909743],
            [4.920977759935103, 1.7158303663526182],
            [4.925351170524266, 1.7183200490964219],
            [4.932835551094679, 1.7291105515906335],
            [4.9399051097647835, 1.7420544725386968],
            [4.944589414845315, 1.7492411041503744],
            [4.944707405223981, 1.757348097561138],
            [4.943486540228204, 1.764362984243092],
            [4.945865117991022, 1.7726555157311845],
            [4.952696585257818, 1.7791917204390417],
            [4.9559083795375845, 1.7884753603427528],
            [4.955900573712612, 1.794430137140201],
            [4.953377483404949, 1.801701454976488],
            [4.953945601996085, 1.8064868161208025],
            [4.959291241132118, 1.8248558813925273],
            [4.962826904477001, 1.8301446772299463],
            [4.96636275922498, 1.8331603712055924],
            [4.97470196118371, 1.8358954864929264],
            [4.985925331017251, 1.8418759623860612],
            [4.994266439857075, 1.8479154083810194],
            [5.002544034768169, 1.8504266975744477],
            [5.0050340563193165, 1.8546259352545513],
            [5.008120773698677, 1.8627398344179504],
            [5.01522397432473, 1.8714464019435808],
            [5.02725914888233, 1.8846132328679432],
            [5.033570642460609, 1.8903038503274634],
            [5.044264118263092, 1.8968157735007058],
            [5.061840839669809, 1.8975584492908635],
            [5.066416312338748, 1.8982404097944423],
            [5.088291692275356, 1.8994327738733185],
            [5.116791379683794, 1.8999354452808042],
            [5.13115545617706, 1.9008986938151267],
            [5.151219301165255, 1.9029420585281864],
            [5.175751385462173, 1.9044564674680498],
            [5.20056075715051, 1.906717120762612],
            [5.209962129911831, 1.7896727340740726],
            [5.294312146578727, 1.796226668460921],
            [5.302700361422751, 1.693979249367082],
            [5.300749383819589, 1.693812401760791],
            [5.308707713721225, 1.5973016502087747],
            [5.29875122640755, 1.6089679391152192],
            [5.293705871159724, 1.6102896981727939],
            [5.293321459560919, 1.6129458759957036],
            [5.286077088482545, 1.6230144703920126],
            [5.278861516112611, 1.6281431824916004],
            [5.2728019735263105, 1.6264545735220215],
            [5.2552704396958125, 1.632422286364164],
            [5.254268320617108, 1.625768601432124],
            [5.247265633307297, 1.6266405144506584],
            [5.24243678281416, 1.6201054114102404],
            [5.242809403906005, 1.617563574425817],
            [5.235268650864767, 1.6124145380543387],
            [5.229883320678047, 1.6104802618799174],
            [5.227293937093777, 1.6124991593978337],
            [5.226252860768672, 1.6166343559682264],
            [5.221173176074895, 1.6128508945439413],
            [5.212309709200709, 1.6113620627400598],
            [5.2108852089715505, 1.6055636978703889],
            [5.207597713916606, 1.6060198912466725],
            [5.20251462355686, 1.5977170327833974],
            [5.199093615215882, 1.5971883488335459],
            [5.1968771305671275, 1.594374727944016],
            [5.182211201356423, 1.5958195090302931],
            [5.177378492498462, 1.5956834197459369],
            [5.171946281519004, 1.593004550826231],
            [5.167285315874674, 1.595671302637637],
            [5.162922848107997, 1.5890673206484123],
            [5.160627821610216, 1.590555908740014],
            [5.153425319778956, 1.589540900352033],
            [5.148761205685342, 1.5864550406702038],
            [5.13982808529098, 1.5866457680761767],
            [5.137781291263369, 1.5893338503309367],
            [5.132929326595056, 1.5877277867812258],
            [5.127410834513839, 1.5936486887942038],
            [5.125785743779483, 1.589240334959544],
            [5.118853425816131, 1.5924552609883433],
            [5.109719991781062, 1.5897286731293956],
            [5.106669405727504, 1.5913914367999702],
            [5.1070192437880655, 1.59446050555468],
            [5.104469842697921, 1.59828842772429],
            [5.101038273079816, 1.5979103156632408],
            [5.099426305837789, 1.5951359127715128],
            [5.094554108708468, 1.5925699294935525],
            [5.093592676236991, 1.5887792967653536],
            [5.08882991265886, 1.5910734419331967],
            [5.082740766690581, 1.5890031123603885],
            [5.077907688517551, 1.5950230921262212],
            [5.076832592935339, 1.59138212102369],
            [5.070107702480972, 1.5928885256052712],
            [5.066381061817808, 1.597657022507055],
            [5.0603726603943935, 1.59864616256678],
            [5.05869102069647, 1.5962503752685795],
            [5.050769896957581, 1.5949046135890261],
            [5.054404297694282, 1.590351826366289],
            [5.0482237734516815, 1.5884059932943453],
            [5.045367032902755, 1.5931390194213806],
            [5.03917257465266, 1.594310112472311],
            [5.034322267784706, 1.597387441525187],
            [5.034107637329067, 1.600211839923587],
            [5.0285670171677275, 1.5988844725838793],
            [5.029404446250118, 1.5949888605319493],
            [5.025864226695938, 1.5922676914154108],
            [5.028352129713929, 1.5896380901965832],
            [5.027179741303242, 1.5849791032720855],
            [5.023458690292296, 1.5813409883241336],
            [5.020953018419103, 1.5844295337830114],
            [5.016673455557633, 1.5774382474675228],
            [5.0188967172384675, 1.5678195886050073],
            [5.014083491705384, 1.5674835533038727],
            [5.0120812130820624, 1.5643105951004304],
            [5.010287182109074, 1.56814298871028],
            [5.00719596638042, 1.5586591644349264],
            [5.004210873525253, 1.559360093354413],
            [4.995412171393695, 1.5563845424695102],
            [4.9908057444647635, 1.5587354473323092],
            [4.984475222822314, 1.5591134960264676],
            [4.980426915256459, 1.5567619683328457],
            [4.97733951804411, 1.5622533003710193],
            [4.971618677501111, 1.558016509770154],
            [4.970277964214719, 1.552315083425312],
            [4.961308337684585, 1.552965509147938],
            [4.95933556361557, 1.5488904122191665],
            [4.949700060167055, 1.5385064838459666],
            [4.948748234184656, 1.5311994679097085],
            [4.941143656250556, 1.5312089655606012],
            [4.938942555814266, 1.5275750460560074],
            [4.9270662473731255, 1.5279804794246465],
            [4.9246797336191745, 1.5306290279843013],
            [4.91840029722433, 1.5257212763429087],
            [4.914495343116753, 1.5255726222018149],
            [4.912461843288551, 1.5175848434843697],
            [4.909271030830295, 1.5107313350990659],
            [4.902931877776637, 1.5125696148957595],
            [4.897267188737415, 1.5153797863311596],
            [4.894448676770241, 1.5138438327103847],
            [4.8930493340620504, 1.508682125487627],
            [4.88451335204979, 1.507746998594925],
            [4.876603462851318, 1.5096720169173916],
            [4.872631151256482, 1.509483149853576],
            [4.866042383480317, 1.5057861441539964],
            [4.8645018771240585, 1.4994056890005294],
            [4.855187613516407, 1.5004589448066301],
            [4.855587632078125, 1.5046856042786314],
            [4.850042411017549, 1.5040321507358854],
            [4.8457294735216525, 1.4984919143231339],
            [4.838265561650821, 1.4981784197746626],
            [4.837608941662435, 1.5010036568304612],
            [4.833101523033502, 1.5020629250427844],
            [4.824438793544722, 1.5019034476360635],
            [4.81938722719254, 1.5000210387472117],
            [4.814411828100128, 1.5019010445543104],
            [4.813660054833756, 1.5041547369236639],
            [4.807351788534429, 1.503453424129153],
            [4.807048665469133, 1.4997151103025916],
            [4.79849656090742, 1.498212250393925],
            [4.792885248946205, 1.5000756360043237],
            [4.793352679494219, 1.5052112600132486],
            [4.790000786298375, 1.504713614033109],
            [4.790955156834013, 1.5102311486377322],
            [4.784905661244819, 1.5167132825948277],
            [4.779515862550016, 1.51865048061274],
            [4.780815843808293, 1.5295524877538014],
            [4.779880974966457, 1.5337386677563265],
            [4.771694469319366, 1.5448559843764118],
            [4.769828668745863, 1.556277275987967],
            [4.763715788813747, 1.557235337861495],
            [4.75878696524122, 1.560158268555713],
            [4.75263666305806, 1.5621093185265063],
            [4.750088977234207, 1.5572849503399586],
            [4.742988069005225, 1.5576331375677774],
            [4.742341051706439, 1.561207112537471],
            [4.739246020424592, 1.5630450205427542]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.91682341215204, "lat": 40.23961964358626 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17125"],
        "coty_name": ["Mason"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mason County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00424261"
      },
      "bbox": [
        4.739246020424592, 1.4981784197746626, 5.308707713721225,
        1.906717120762612
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.41992561813751, 3.032538848562969],
            [8.458442256798708, 3.0365838007836863],
            [8.50563424612424, 3.042312609948173],
            [8.547762927848844, 3.048069261029585],
            [8.590140989145617, 3.05341211689506],
            [8.632740864214734, 3.0592767225278923],
            [8.675212522279601, 3.0653745190035013],
            [8.792600990957613, 3.0824471420130064],
            [8.794818727497699, 3.0640879814971305],
            [8.803452213716488, 2.9918779632990202],
            [8.810397644997442, 2.93282138292211],
            [8.814287175165944, 2.900863712574156],
            [8.826205544662422, 2.8009721727805723],
            [8.83437576079923, 2.7341620870248127],
            [8.77648742716548, 2.7253960876367587],
            [8.71912998441925, 2.71769553868653],
            [8.690064284606962, 2.7133926286113534],
            [8.633282061426577, 2.7058661130763895],
            [8.606642190462592, 2.7022997004810034],
            [8.522057543343136, 2.692276365260831],
            [8.438173797256168, 2.6828832832680614],
            [8.435136456186935, 2.712236075520575],
            [8.42850734134165, 2.7711613752318454],
            [8.412461861135995, 2.899513775187642],
            [8.406931901029111, 2.944867211638959],
            [8.428084246542099, 2.9470717626189016],
            [8.423534845219589, 2.9877060763805043],
            [8.42034160653425, 3.01930172552802],
            [8.41992561813751, 3.032538848562969]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.06652976053503, "lat": 41.09089847320983 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18003"],
        "coty_name": ["Allen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allen County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00450402"
      },
      "bbox": [
        8.406931901029111, 2.6828832832680614, 8.83437576079923,
        3.0824471420130064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.960338978077249, 0.4468027838963622],
            [7.9622786993764905, 0.44877009973698534],
            [7.969577825132423, 0.4494216565736436],
            [7.969444483883353, 0.45376132614389475],
            [7.97344382187879, 0.45648379085122776],
            [7.975953969170254, 0.45482569128943023],
            [7.97368404324123, 0.44943993301158675],
            [7.977143679313068, 0.448251012551642],
            [7.981468890014632, 0.45308724144570484],
            [7.984796297990292, 0.45115526200242545],
            [7.989220437688636, 0.45383611396349816],
            [7.992452777809405, 0.4596475542586751],
            [7.998087536327489, 0.4662714791188558],
            [8.00081283716292, 0.4645409989125693],
            [8.001741360407417, 0.45908960807510524],
            [8.0061339503562, 0.46169118095823497],
            [8.006439704376382, 0.46737056684219963],
            [8.015181952407278, 0.4647887110855645],
            [8.012071064587584, 0.4704233715275917],
            [8.016171561256815, 0.4714129386985597],
            [8.020761985409711, 0.46653048021849436],
            [8.024604386631083, 0.4664543381663905],
            [8.02728648753103, 0.47311812897987326],
            [8.030269023816318, 0.4729034767658076],
            [8.032499863086121, 0.46813441447078696],
            [8.038475735721907, 0.4640533573452978],
            [8.04217584637805, 0.46420697632189334],
            [8.04499300057826, 0.46674798772676107],
            [8.053504588130394, 0.46148692790711643],
            [8.06393911905902, 0.45917893859578623],
            [8.068279396232974, 0.45657533046873133],
            [8.075755758209317, 0.45906098938788736],
            [8.08152419507429, 0.4624493488820897],
            [8.089294241507634, 0.4635133969775049],
            [8.092959815420976, 0.46253098413818416],
            [8.09508004670255, 0.46597075618033845],
            [8.09332305341531, 0.47281115788028344],
            [8.095885708315897, 0.4797732286853688],
            [8.0992860838886, 0.4811045092290146],
            [8.107852617886936, 0.479067357607748],
            [8.11297456660901, 0.47373405502134686],
            [8.118804832900286, 0.47776864392339585],
            [8.124178255547701, 0.4773050421331394],
            [8.126473740421849, 0.4748810308771008],
            [8.1324926091091, 0.4718248251246421],
            [8.138651389599188, 0.46396537606294674],
            [8.140915320289233, 0.4626176114473136],
            [8.151823055948233, 0.464226532651375],
            [8.154490092781952, 0.4701767786667991],
            [8.159682859337615, 0.4691412828594466],
            [8.158674512256749, 0.46468956588164356],
            [8.161059913703799, 0.4607804197400935],
            [8.165126258850671, 0.461183919755976],
            [8.167212609253866, 0.46444689995084165],
            [8.17378626685187, 0.4660932902198951],
            [8.174516685567296, 0.47033015011733714],
            [8.177043713788734, 0.4730389683663839],
            [8.183409870905557, 0.4744369581697227],
            [8.183430132416772, 0.4644219719685641],
            [8.188231217096735, 0.464537952934319],
            [8.187965276091385, 0.4614881997177433],
            [8.19092538719614, 0.45926924082986464],
            [8.197368813100464, 0.46272039948282195],
            [8.198068302376829, 0.46895255086134585],
            [8.201789139759043, 0.4723929484520179],
            [8.204469449771619, 0.4698189511221065],
            [8.2087073338905, 0.47031622780734245],
            [8.211154915283132, 0.4628846287542253],
            [8.214081254499508, 0.46354455284433543],
            [8.214080920259246, 0.4678192024335253],
            [8.218993030727233, 0.47243186389062486],
            [8.221380417965431, 0.4659932375288278],
            [8.228270216478798, 0.46695730045902334],
            [8.22846537287635, 0.46149395810964045],
            [8.236344705542804, 0.45785965941013207],
            [8.23531734959045, 0.46580136839943354],
            [8.240816566763572, 0.4595665897581668],
            [8.240358069615157, 0.46877620078602894],
            [8.247511487840482, 0.464703284722548],
            [8.249184580646713, 0.4669023906640693],
            [8.2529870361474, 0.46349209872953223],
            [8.25153765248732, 0.46079788619061596],
            [8.254946600988262, 0.451608497220904],
            [8.257717899783348, 0.4502755372600381],
            [8.256271738253023, 0.4448703731883788],
            [8.260152930985884, 0.4444459430987908],
            [8.260671537568358, 0.448458484530389],
            [8.266916152588072, 0.39434698352039],
            [8.270029238349261, 0.36248211604533176],
            [8.271009576619608, 0.36258173889061684],
            [8.27979517126109, 0.2890100687009594],
            [8.308239409368783, 0.29292135140519227],
            [8.310378895511404, 0.27792069185846696],
            [8.312134819096968, 0.2637603391949271],
            [8.297697541586757, 0.26216803622165197],
            [8.300834638896733, 0.23338856437726388],
            [8.286656967690982, 0.23159532465876523],
            [8.288179547275472, 0.21684719061129074],
            [8.274028092739616, 0.2144218106488361],
            [8.255255754232138, 0.21242451623556752],
            [8.23260415450375, 0.20938792742372125],
            [8.234687060061177, 0.1964152871767327],
            [8.20611611268982, 0.19296798601074386],
            [8.207305976706573, 0.1765884235741824],
            [8.211591805547569, 0.13684145932519237],
            [8.212559752296077, 0.12237261734418305],
            [8.197420953417234, 0.12151989813816678],
            [8.183170627941339, 0.11881837682219601],
            [8.145053246165986, 0.11543869271096233],
            [8.113133302857932, 0.11328852172820754],
            [8.111855601051982, 0.11291364448066528],
            [8.066180594286957, 0.11011036598815296],
            [8.044082751821746, 0.10857555882860467],
            [8.011137831573054, 0.10577522850807514],
            [7.969727478160799, 0.1017191040542225],
            [7.965087351235243, 0.14946661386060653],
            [7.964758255239996, 0.14942278932070593],
            [7.960046367498199, 0.20102165869062708],
            [7.953460007256628, 0.26588020231227427],
            [7.94766338285158, 0.3243801898831947],
            [7.945737574521514, 0.3390590148715343],
            [7.944839752351159, 0.3516383875091055],
            [7.942445529802952, 0.36813977817146454],
            [7.937408092854252, 0.41083520429922155],
            [7.936774386811179, 0.41326416014469947],
            [7.942518301556006, 0.4165762241390417],
            [7.950406358506635, 0.4166555327788155],
            [7.9515519887806905, 0.418017345185137],
            [7.950023396989194, 0.4241718642080955],
            [7.952225089723536, 0.42976484720402675],
            [7.952571568917386, 0.4371671739624149],
            [7.957048272987162, 0.4457291187948419],
            [7.960338978077249, 0.4468027838963622]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.10523336743967, "lat": 38.60003424163784 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18175"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00451665"
      },
      "bbox": [
        7.936774386811179, 0.1017191040542225, 8.312134819096968,
        0.4811045092290146
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7056701324007854, 3.188319850063745],
            [0.7910563058015877, 3.188968916251466],
            [0.791276724193738, 3.156150512951933],
            [0.791502998238939, 3.079090361447128],
            [0.7913780310102922, 3.0463176730109103],
            [0.7917156600825709, 2.940898564200716],
            [0.7916388285015875, 2.9263235415923177],
            [0.8364239854441935, 2.926495360657768],
            [0.8363738928124143, 2.9094472631224657],
            [0.8367849381944382, 2.8296175147347626],
            [0.7833021209506553, 2.8294965120197064],
            [0.7676144273029146, 2.8292431604522523],
            [0.7205696329837825, 2.829037523120483],
            [0.6941558067820663, 2.829368263384338],
            [0.6802994001470767, 2.829212745071972],
            [0.5821131244363503, 2.829238898803193],
            [0.4964904705139705, 2.8290970796989945],
            [0.46658281690126807, 2.8295246040891144],
            [0.4690655259185516, 2.834600442863485],
            [0.468278636308254, 2.8460846858635516],
            [0.4637653158136409, 2.8622567123145353],
            [0.4599432664125934, 2.8660511783025013],
            [0.45343435357230233, 2.8681301604110816],
            [0.44951731709608433, 2.867954710559377],
            [0.44394050341031843, 2.863151213973245],
            [0.4419661317094484, 2.8506865696363164],
            [0.43654093057201776, 2.8316311876619125],
            [0.4334949188156437, 2.829648551079109],
            [0.4279834041289946, 2.829847397243298],
            [0.4238437354537696, 2.8314479839709104],
            [0.4127472542401018, 2.841775967055078],
            [0.40864758851263433, 2.8466444832359983],
            [0.4023359752207205, 2.848689852854079],
            [0.3953945839670001, 2.856683701725272],
            [0.39200571398072004, 2.8682483419010976],
            [0.3942265360415502, 2.8812030472157644],
            [0.4007897293907514, 2.8908182489113936],
            [0.40347407481466835, 2.897300149155492],
            [0.40181987424618765, 2.9064244558579153],
            [0.39791487053159214, 2.910635622476676],
            [0.38840875962496696, 2.914730950745716],
            [0.3825581225364847, 2.9200620428216015],
            [0.37926503411220325, 2.925506184311375],
            [0.37651035167467906, 2.9332803911786223],
            [0.37622868204593435, 2.9406841705321085],
            [0.37905901607549763, 2.9473413937779633],
            [0.3890457130389423, 2.9589345041330466],
            [0.39125519155548677, 2.9630840288861666],
            [0.39325222157260864, 2.9708623088015473],
            [0.3929839974701635, 2.976267054535511],
            [0.3897135932491259, 2.9846159836453086],
            [0.3784993718659491, 2.9948818012115117],
            [0.37405599344339474, 3.0015693527474063],
            [0.3735222402477425, 3.006730525006108],
            [0.3737598526695004, 3.01229641808886],
            [0.376472278560918, 3.018027023274587],
            [0.38076239747590335, 3.0215956322990283],
            [0.3858404670216567, 3.0237469778650286],
            [0.3966130981180782, 3.0212286328797204],
            [0.4026536009485678, 3.0219616416886965],
            [0.40745416976989723, 3.0254810958593827],
            [0.41002439933991464, 3.0326556952763823],
            [0.4047060735802109, 3.04188382694669],
            [0.398843784818875, 3.0461326260735375],
            [0.3877303521877505, 3.052015152596733],
            [0.38553286872836784, 3.0556705568028932],
            [0.3849154809893754, 3.061952003863378],
            [0.38625789775849967, 3.0683096589242083],
            [0.39152927059009096, 3.0731983583241647],
            [0.4010401235440382, 3.0774527338024753],
            [0.40456727873230325, 3.082058178774584],
            [0.40576617296256756, 3.0857823730492044],
            [0.4053012152011568, 3.095596068847369],
            [0.4063399978830396, 3.1021047789135894],
            [0.41458662114642053, 3.113253409152964],
            [0.415726993375775, 3.120612932642165],
            [0.4121927562896701, 3.1279373959760113],
            [0.4078407795320179, 3.132268052850305],
            [0.40378951638216753, 3.1346181080681736],
            [0.394314860390561, 3.1372833310240806],
            [0.3869846458774129, 3.1416825623124165],
            [0.3841455551674886, 3.145240423274059],
            [0.3817050939416848, 3.15543544679708],
            [0.3839320442424107, 3.1650093201272855],
            [0.38221508784394215, 3.1735716652097463],
            [0.3778181458431288, 3.179630715491989],
            [0.3726374524743167, 3.183369657924917],
            [0.36716543855082107, 3.1856188090565043],
            [0.36097070680903065, 3.191151216370363],
            [0.41966361408566405, 3.189486802278248],
            [0.44798283859527277, 3.1885223127971214],
            [0.4762354336895809, 3.188251109312596],
            [0.5477202412963692, 3.188297088974772],
            [0.6254047574834076, 3.1881932932825197],
            [0.7056701324007854, 3.188319850063745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.81684100841696,
          "lat": 41.682839517250144
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19085"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00465231"
      },
      "bbox": [
        0.36097070680903065, 2.829037523120483, 0.8367849381944382,
        3.191151216370363
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6528638851154448, 3.889721419299995],
            [0.6964582325595735, 3.889929595842543],
            [0.7605470923534167, 3.8905926259891896],
            [0.8252221416271586, 3.8909943153161572],
            [0.9116711510812587, 3.891362562222825],
            [0.9126484767271599, 3.804085855213649],
            [0.9603477618786926, 3.8043275567941395],
            [0.9608587536538518, 3.684521830152215],
            [0.9615500397455137, 3.5398788280791127],
            [0.9614025077874261, 3.539316016862615],
            [0.8761458037399146, 3.538530066051862],
            [0.765918592401976, 3.5382733570880487],
            [0.7058963590232693, 3.5384451399141197],
            [0.7063223830134127, 3.558307440919843],
            [0.7060703361420014, 3.5844907120165654],
            [0.706379515558469, 3.5900764641493885],
            [0.7058493156973501, 3.632870463475278],
            [0.705430239835935, 3.6526567585350866],
            [0.7058005783269533, 3.6975946399666353],
            [0.7062250081347888, 3.7028054915123954],
            [0.7058237086766364, 3.7244906727138827],
            [0.7061605618074555, 3.7272018219248038],
            [0.7062327129601456, 3.7891737853238276],
            [0.7061196424019656, 3.8028894903030546],
            [0.6529464299075812, 3.8029460465970475],
            [0.6531538350426055, 3.8518464985617156],
            [0.6528638851154448, 3.889721419299995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.51349091924446,
          "lat": 42.386897265354825
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19093"],
        "coty_name": ["Ida"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ida County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00465235"
      },
      "bbox": [
        0.6528638851154448, 3.5382733570880487, 0.9615500397455137,
        3.891362562222825
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1785458404303355, -1.033513065578124],
            [1.1928199018446564, -1.0334706714162183],
            [1.2213141376288539, -1.0327007147895528],
            [1.3209410615241735, -1.0319360855012443],
            [1.3359072837295127, -1.0314766336196295],
            [1.3499330512183314, -1.0318311267453844],
            [1.378353919077126, -1.031864271891031],
            [1.4226632375216672, -1.0311506283341159],
            [1.451427166892226, -1.0308909689063361],
            [1.5471436966995895, -1.030492163396008],
            [1.5475546605002561, -1.0502055131931156],
            [1.5493304470655898, -1.1512452679085698],
            [1.5501119852014944, -1.1835190827281983],
            [1.550564232283381, -1.2358593648138703],
            [1.551042818860312, -1.2659876876471376],
            [1.5511694517165564, -1.295173608647183],
            [1.551834951917916, -1.3423555481917457],
            [1.55213577298278, -1.3683484819043743],
            [1.5138875415502588, -1.3690594526343018],
            [1.4259369802826323, -1.3693644241754974],
            [1.3260159645664198, -1.3697503481348592],
            [1.1919016160390408, -1.3711852923631713],
            [1.1916230581239597, -1.326883084054996],
            [1.1812230943087731, -1.3269694227517774],
            [1.1807645009237733, -1.2386374420541293],
            [1.1797778480548617, -1.1948638708062236],
            [1.1793067072890575, -1.1472265451837917],
            [1.1795171917772471, -1.1142006293457427],
            [1.1785458404303355, -1.033513065578124]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.8517920330923, "lat": 37.507328316600955 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20037"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00484988"
      },
      "bbox": [
        1.1785458404303355, -1.3711852923631713, 1.55213577298278,
        -1.030492163396008
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.836655578864926, 0.12418388534658599],
            [-3.772806595575521, 0.12097027634624509],
            [-3.6010494930702417, 0.11258894190598699],
            [-3.5616038378238764, 0.11050048813938101],
            [-3.5547325395000273, 0.10951291880658515],
            [-3.4980549651022157, 0.1060566211848309],
            [-3.505582726933844, -0.04080029392768416],
            [-3.509122320038095, -0.10754946961124856],
            [-3.511957643496513, -0.1580661747778172],
            [-3.5133036618004954, -0.1873209511026924],
            [-3.516998563388395, -0.2752346490727447],
            [-3.519520977176675, -0.33378210219495985],
            [-3.5875126930236743, -0.33030812901477474],
            [-3.672674190400908, -0.32584822305210853],
            [-3.7651472680152325, -0.321104677268644],
            [-3.7657043080791084, -0.3209584530453737],
            [-3.8432199488776435, -0.31691403390997125],
            [-3.862761027647233, -0.3158333696136635],
            [-3.836655578864926, 0.12418388534658599]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.34737812394381,
          "lat": 38.48207290566053
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20203"],
        "coty_name": ["Wichita"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wichita County"],
        "coty_fp_code": "203",
        "coty_gnis_code": "00485062"
      },
      "bbox": [
        -3.862761027647233, -0.33378210219495985, -3.4980549651022157,
        0.12418388534658599
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.993946607465598, -1.4316646759572074],
            [7.009859089130629, -1.4105937282654015],
            [7.022523314155902, -1.2800745396848354],
            [7.032169107111513, -1.278727035571541],
            [7.046720204278638, -1.2801173560806036],
            [7.069608632634634, -1.2901133393733115],
            [7.12844672493142, -1.3068048509049042],
            [7.151500008278849, -1.3131344414694963],
            [7.156948034383463, -1.3109920453760309],
            [7.159403653977734, -1.3070496526271553],
            [7.159674344641099, -1.302910591234799],
            [7.165150102353218, -1.3008400172914127],
            [7.16946322251076, -1.297832401388645],
            [7.173868190411522, -1.2903678764118136],
            [7.178207527595142, -1.2888887567597578],
            [7.200641137012383, -1.2849489615220167],
            [7.264495474808885, -1.2742228850962445],
            [7.268191603094803, -1.2703235163641997],
            [7.273653765413369, -1.267582832532392],
            [7.275304458126807, -1.2623072955903305],
            [7.274184065063021, -1.2497678330913322],
            [7.280212608352506, -1.2468086106812164],
            [7.286042587982199, -1.2494281351731682],
            [7.287123204419583, -1.247991387655858],
            [7.29451751421839, -1.2476564171254894],
            [7.2966174028953, -1.2508481894140848],
            [7.299749465505806, -1.2697714392773305],
            [7.29797084235941, -1.271891528056661],
            [7.306092840991411, -1.277354376076042],
            [7.31498007639388, -1.2898614939097168],
            [7.321084543136073, -1.293528008803943],
            [7.3253781958751585, -1.294466123248373],
            [7.3268933822531395, -1.2903066746746377],
            [7.330110804162907, -1.2894760236379947],
            [7.337901048930493, -1.2935155767520425],
            [7.337229991757351, -1.2986205412954683],
            [7.340110252275483, -1.3043295971936193],
            [7.338888586549972, -1.3056746035112952],
            [7.3433922289414655, -1.3122875421792382],
            [7.338594050022085, -1.314487541473508],
            [7.342572320357903, -1.3206125626278558],
            [7.343719309507471, -1.3244889274186316],
            [7.348797458007495, -1.329312263109588],
            [7.354818374930884, -1.3305460733317236],
            [7.360833526405367, -1.3275162196930932],
            [7.354655863466442, -1.4567270744798966],
            [7.351533979276588, -1.5179709954624803],
            [7.345040932334263, -1.6555749985300445],
            [7.344453474577944, -1.6628706622186957],
            [7.340151678963614, -1.7661000439883847],
            [7.278198696692433, -1.7722370912923464],
            [7.160627552875113, -1.7847483732366791],
            [7.098892873600873, -1.7913057669239805],
            [7.0569819178649835, -1.7959651085987056],
            [7.062658740978158, -1.6751383219771137],
            [7.056300347067228, -1.6026913923919586],
            [7.053288905813408, -1.5513092534242212],
            [7.055132356559254, -1.4624857663245776],
            [6.993946607465598, -1.4316646759572074]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.49041036039145,
          "lat": 36.894193737785514
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21047"],
        "coty_name": ["Christian"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Christian County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00516870"
      },
      "bbox": [
        6.993946607465598, -1.7959651085987056, 7.360833526405367,
        -1.2468086106812164
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.796794063079497, -1.3175644737892473],
            [8.893674193986783, -1.3142802592697442],
            [8.971195040602028, -1.3112054799811597],
            [8.940515237224252, -1.342287924499173],
            [8.964168391037951, -1.3602043348015562],
            [8.967090765642029, -1.3674365083168143],
            [8.967332261180896, -1.376331385957244],
            [8.971492510790297, -1.381502796723885],
            [8.975698002217522, -1.3835684631471206],
            [8.983477474505746, -1.384815854040555],
            [8.992341703903609, -1.3805232062877717],
            [8.98333503447766, -1.4675281251655075],
            [8.980486482758407, -1.4941300356955725],
            [8.954858398866412, -1.6170065776759353],
            [8.951499764523577, -1.6188093364738303],
            [8.932329455373296, -1.6208585084919906],
            [8.92502940333219, -1.6233050983633641],
            [8.84963666805424, -1.6358204002571692],
            [8.844699097212882, -1.6368069160384657],
            [8.78885817445524, -1.5697108305681564],
            [8.79426975429282, -1.5555961083920649],
            [8.798571410899173, -1.5465887340883429],
            [8.800100382345326, -1.5413639585794887],
            [8.805079415641432, -1.5305421629615963],
            [8.805621632287032, -1.526944971733826],
            [8.803103147491749, -1.5240435231186793],
            [8.79423671488609, -1.5236883362642555],
            [8.781627560374982, -1.5271489907019085],
            [8.774568203709725, -1.524505378427901],
            [8.773005096005432, -1.5286966037257175],
            [8.768164903872524, -1.5307699374171393],
            [8.762512875980775, -1.523824491719085],
            [8.763519604601111, -1.5191558940599252],
            [8.758652861221064, -1.5171242580042767],
            [8.754170786922852, -1.5072351601847087],
            [8.748727253081597, -1.5060354068481112],
            [8.745755178247562, -1.4996233899384657],
            [8.746459660616114, -1.4915389757083741],
            [8.743552209337553, -1.4893327262079858],
            [8.740508830314397, -1.4909664703954872],
            [8.735934230304121, -1.490646824357402],
            [8.73247730441055, -1.4937494431498246],
            [8.727604413685498, -1.4929544785177316],
            [8.721509136702053, -1.4959421395726178],
            [8.718604782684244, -1.494140815299181],
            [8.716619359132691, -1.4888986505839767],
            [8.70680991871398, -1.490807367593861],
            [8.69643675185687, -1.450631584371874],
            [8.707721673822155, -1.4444661281085311],
            [8.71117108803335, -1.4284976758065855],
            [8.701370985001764, -1.419048074066317],
            [8.69768238065469, -1.4132636189000418],
            [8.693668319658372, -1.4109022469987653],
            [8.691279738111945, -1.4017141171890621],
            [8.687927444734886, -1.400101269593427],
            [8.688287142253156, -1.3952872103366505],
            [8.69597922540079, -1.3946439662014862],
            [8.69779505129889, -1.3969118337560633],
            [8.703172525918191, -1.3981866942462517],
            [8.707796856148416, -1.403064695778453],
            [8.720779637251255, -1.4146281866482875],
            [8.738221804084837, -1.4011956088613884],
            [8.760947522030717, -1.3932782614815424],
            [8.784123500666118, -1.3639821973207464],
            [8.796794063079497, -1.3175644737892473]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.38855502579506, "lat": 36.78658752165917 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21057"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00516875"
      },
      "bbox": [
        8.687927444734886, -1.6368069160384657, 8.992341703903609,
        -1.3112054799811597
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.293272284100988, -0.28872706762492745],
            [8.296840027898272, -0.28613239730378975],
            [8.30443657203896, -0.2764384075242751],
            [8.308139398089947, -0.2701891179850603],
            [8.310623955773636, -0.2612562597417803],
            [8.311294145949978, -0.2501411164063879],
            [8.31119819995303, -0.23011400458515513],
            [8.311937530088324, -0.21882890169441063],
            [8.313204508369399, -0.2172325802264105],
            [8.316766308363773, -0.20107865058926724],
            [8.316408629852653, -0.19007887022846615],
            [8.314475492755475, -0.17884186048237635],
            [8.30926387115533, -0.15632130812189365],
            [8.3078350844647, -0.14571498955755846],
            [8.306910987514154, -0.1284620257035046],
            [8.308722735233587, -0.11540302236470239],
            [8.311404001085883, -0.10879177761188934],
            [8.315124369936537, -0.09961585771335932],
            [8.323861762116639, -0.08410529586699535],
            [8.329630492008974, -0.07716960262980645],
            [8.343455711245628, -0.06314580675977034],
            [8.348645648284071, -0.053341283584516286],
            [8.351801801270518, -0.044186166766758864],
            [8.352007588460923, -0.03374288927270568],
            [8.350827056049045, -0.02447113031809424],
            [8.351307292090738, -0.018279193727217008],
            [8.3554718155792, -0.00643880987131642],
            [8.358725894395421, -0.0026401178589714035],
            [8.363970978708148, 0.00044558536572454843],
            [8.379170088440226, 0.0054436258887309704],
            [8.383731541190679, 0.008032361162394752],
            [8.391421947601073, 0.009587502138779874],
            [8.398504104283438, 0.0074179505429151195],
            [8.403924013734857, 0.0026783856626909457],
            [8.403346695003671, -0.00045140259154766984],
            [8.408741598093295, -0.005299045551852029],
            [8.416484502669723, -0.008502754238319553],
            [8.424706307335239, -0.0077463567265910705],
            [8.465973424100383, 0.024775886337589318],
            [8.472944308764053, 0.03250015339560582],
            [8.476393124413287, 0.041312659476086984],
            [8.484652805458897, 0.055642631988737194],
            [8.486978672928283, 0.06289885724181711],
            [8.490748634127835, 0.07882778090542159],
            [8.493126839344743, 0.09730278037333946],
            [8.491964670723812, 0.11373176003136479],
            [8.50235422757899, 0.10793028235236933],
            [8.549042850639157, 0.08089517648606297],
            [8.542205022906519, 0.07940247610479685],
            [8.53705528732344, 0.07721739217953753],
            [8.545800465468957, 0.07263929669674384],
            [8.55580163281476, 0.07693853742009234],
            [8.608418647526118, 0.04681070403409007],
            [8.633476839774717, 0.03289955858717856],
            [8.68480656228564, 0.01670215384066795],
            [8.684643251106646, 0.0011382993545913872],
            [8.683045487868897, -0.1016604000593842],
            [8.68260568885015, -0.1312323363858351],
            [8.644829688250553, -0.15410616208042272],
            [8.618482790180007, -0.16845640813409846],
            [8.588083004106718, -0.18698006392643252],
            [8.466261267031651, -0.1866347652941128],
            [8.34375420675941, -0.2460452730448891],
            [8.33936508022131, -0.24780720948289842],
            [8.339150195273936, -0.25083928616302265],
            [8.32907164422206, -0.25989457823594486],
            [8.324844124365175, -0.26056283076335596],
            [8.322717697054879, -0.2651787043667342],
            [8.318240221501291, -0.2702633232451591],
            [8.316954782561279, -0.27721342035269725],
            [8.318453955563278, -0.2802018731865447],
            [8.31165703028118, -0.28344912546369117],
            [8.30378866840947, -0.2955998076437173],
            [8.300770316148455, -0.2943577402933091],
            [8.29516199120215, -0.29122661219879614],
            [8.293272284100988, -0.28872706762492745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.65912015701392,
          "lat": 38.187174674382966
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21111"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00516902"
      },
      "bbox": [
        8.293272284100988, -0.2955998076437173, 8.68480656228564,
        0.11373176003136479
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.269685764492015, -0.3240843313637196],
            [9.272782830425124, -0.3041834285092443],
            [9.291287685269936, -0.17729468386102493],
            [9.331395078960185, -0.1856634332389907],
            [9.345907713546744, -0.1883400624870748],
            [9.438876375497815, -0.22407600726308574],
            [9.440428992422655, -0.22775357363053644],
            [9.444471254504931, -0.23189580242550983],
            [9.447483846535262, -0.24348078502947315],
            [9.452197458243587, -0.2442906253922652],
            [9.455616704154098, -0.2484493911386828],
            [9.463634592670898, -0.253008071309978],
            [9.464424918251687, -0.25686995434813664],
            [9.46891830270239, -0.2677182426287086],
            [9.473690001934116, -0.2737224588389103],
            [9.474079684167585, -0.2799527648697731],
            [9.480105323396012, -0.2892613920886276],
            [9.482812171568185, -0.29195393321789176],
            [9.48102826738567, -0.2983950912174649],
            [9.484005639748663, -0.3043537722206674],
            [9.48247144167913, -0.3119841615587063],
            [9.484316500152953, -0.31315740755814275],
            [9.480453383155194, -0.31841211597186425],
            [9.476524738735648, -0.32103258305870125],
            [9.47030253529934, -0.321885994009013],
            [9.462825260290717, -0.3189865666102606],
            [9.457740703662484, -0.31330549689493664],
            [9.453540982231274, -0.31049697698950046],
            [9.450372681226636, -0.31301013206623535],
            [9.447512395743402, -0.31835838964483193],
            [9.446772983723378, -0.3244167325924889],
            [9.44884720890557, -0.33037459894733323],
            [9.454414113487022, -0.3391480365761567],
            [9.458108062326751, -0.3416490496071475],
            [9.467564578600074, -0.3548743635876542],
            [9.469246650971565, -0.3595267393459008],
            [9.46568968930471, -0.36713752352267687],
            [9.460860985007345, -0.36682381968513283],
            [9.458350183751683, -0.36232010130531384],
            [9.453552029757995, -0.36275196930159853],
            [9.452087596957574, -0.3682749790480206],
            [9.44510986239145, -0.3809638960312774],
            [9.434350423296976, -0.38512001944262153],
            [9.425762188866047, -0.3906659901633469],
            [9.425608669262221, -0.3967624359802286],
            [9.42396590597139, -0.3995546035675699],
            [9.419453021615318, -0.3985324087029788],
            [9.414407873586475, -0.4023816882811301],
            [9.414020363371947, -0.4056195546660706],
            [9.415540855108121, -0.41390438522997053],
            [9.413798341134557, -0.4169086927949595],
            [9.407710986104119, -0.4192835511708535],
            [9.403319984198873, -0.4226762739533452],
            [9.400620677757255, -0.4282747434754381],
            [9.399155917816577, -0.4358018167472421],
            [9.394195292118875, -0.4446433515247233],
            [9.387059936539687, -0.44346384554966223],
            [9.380240587448329, -0.4395980093713378],
            [9.37780822480845, -0.4323434504534877],
            [9.379960537645019, -0.42408717620821473],
            [9.375304097149977, -0.42103921868451866],
            [9.370907593488957, -0.4223545997765793],
            [9.367365064981255, -0.4268764428176487],
            [9.366078627202162, -0.4324983460295949],
            [9.36414707945274, -0.43365759733141873],
            [9.358119178755027, -0.43219260291594713],
            [9.356138055133446, -0.4292902987197851],
            [9.363620479205693, -0.42129213982552316],
            [9.363867253876279, -0.4174035460425997],
            [9.3572661650367, -0.4104472587842785],
            [9.34378791077921, -0.4045617205439456],
            [9.338969862688202, -0.4065931538085217],
            [9.33609506874032, -0.40604553353763817],
            [9.331788303516499, -0.40192292411110914],
            [9.329134760484987, -0.39183603895597713],
            [9.330473058900255, -0.38806076427988756],
            [9.33856899693758, -0.38207105556146337],
            [9.342594956423541, -0.38137755903287934],
            [9.351328205418321, -0.38576327372188507],
            [9.35677216307579, -0.38397482266765914],
            [9.357253969133287, -0.38143100493506177],
            [9.35509596392764, -0.3764111312050012],
            [9.3491426573645, -0.3735303400241229],
            [9.328983055197748, -0.3730855367092134],
            [9.323131606236155, -0.37087506988281843],
            [9.315171029685954, -0.3723231350842661],
            [9.314908534378795, -0.3755430059575978],
            [9.317996129438223, -0.380196975087903],
            [9.323724095213748, -0.38589389516732703],
            [9.32522157709854, -0.38866568046084754],
            [9.324239780906321, -0.39304286174361414],
            [9.320221825667963, -0.3973966567713454],
            [9.315830666263786, -0.39884450904615804],
            [9.310991072417044, -0.3986555143998873],
            [9.307238839555518, -0.39663252469593135],
            [9.303627971743959, -0.3924831731419518],
            [9.300156952182737, -0.3807077133635673],
            [9.300575823751037, -0.3707569917993655],
            [9.301781080470079, -0.3654239139237453],
            [9.300388274651377, -0.35673142452959],
            [9.296972295571189, -0.35356344644457105],
            [9.294144846758995, -0.35342274220392056],
            [9.28479540127157, -0.3569417517833911],
            [9.278077195680414, -0.36630620677390435],
            [9.269815138308404, -0.37142205788000304],
            [9.264396218658721, -0.36686748561527516],
            [9.262665779545392, -0.36267339174886914],
            [9.262668755452891, -0.35441841526891055],
            [9.266776806151094, -0.3458172960745559],
            [9.272613811414388, -0.3420251866087244],
            [9.282861467333792, -0.33932870904270246],
            [9.286393883881637, -0.3356419212140715],
            [9.286708400076794, -0.32932839734179237],
            [9.282184959632632, -0.3251024646951213],
            [9.269685764492015, -0.3240843313637196]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.58094065099216, "lat": 37.87202245857762 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21113"],
        "coty_name": ["Jessamine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jessamine County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00516903"
      },
      "bbox": [
        9.262665779545392, -0.4446433515247233, 9.484316500152953,
        -0.17729468386102493
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.035367486726785, -1.2822518252853332],
            [6.044779566675667, -1.2837491699427224],
            [6.082545117153624, -1.2953765543932951],
            [6.110668922663624, -1.3066463611945678],
            [6.122099411009518, -1.3101183454795118],
            [6.134344108880593, -1.3128435804532927],
            [6.1411966962657925, -1.316111028992408],
            [6.14987921536319, -1.3217991274111716],
            [6.159283312699399, -1.3310091509950663],
            [6.168088637553227, -1.3365320859189904],
            [6.1783717912592895, -1.3438070600848082],
            [6.184124865626809, -1.3465433546235646],
            [6.195699011799084, -1.353360049173941],
            [6.205306994709339, -1.3559796529440682],
            [6.219061476615051, -1.3528931715579304],
            [6.230953468233795, -1.3552862812990096],
            [6.2660083884481415, -1.369316744691342],
            [6.271556732902492, -1.3704405812057212],
            [6.277384699994705, -1.370297965146552],
            [6.281218557026999, -1.3715643762859586],
            [6.293120911683532, -1.3774352387500428],
            [6.3016725457238065, -1.3825035954353462],
            [6.311513987586914, -1.389917533344408],
            [6.316523058208417, -1.396613653651778],
            [6.324660130894005, -1.4039172506521678],
            [6.325772295384051, -1.4080391734664044],
            [6.331441675318288, -1.4118705974982173],
            [6.332489485224834, -1.4198818237077748],
            [6.338570549074287, -1.4230187333080009],
            [6.346259336631272, -1.4290543182969486],
            [6.354104974338547, -1.4368457064976596],
            [6.366008540590571, -1.4501934284485758],
            [6.372091267306735, -1.4556423289710354],
            [6.379670239136287, -1.459728304848626],
            [6.387292393001655, -1.4611796233550327],
            [6.393238158034592, -1.4613493526063568],
            [6.401475076797243, -1.4602314328219246],
            [6.402256710269123, -1.4712010716599844],
            [6.4013756485150575, -1.481965165579352],
            [6.405197408653821, -1.5263675770659284],
            [6.406990146251981, -1.541271064371087],
            [6.3588285326657585, -1.5446221258166106],
            [6.330247475698919, -1.545895409813168],
            [6.3090516412353885, -1.5484607725716273],
            [6.236711016900066, -1.5538789440857215],
            [6.228972685177405, -1.5526385966642888],
            [6.228877560908408, -1.5508541590137503],
            [6.216141658941798, -1.5516200169000924],
            [6.147137344867309, -1.5565763556271088],
            [6.144174408037602, -1.5494764179565452],
            [6.122925590034127, -1.499120595485828],
            [6.113344029287969, -1.477294850346481],
            [6.084121751585516, -1.4083156184613186],
            [6.031169550850628, -1.2837698650544012],
            [6.030392520846735, -1.2837122607454021],
            [6.035367486726785, -1.2822518252853332]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.71273764579013,
          "lat": 37.053953136612854
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21145"],
        "coty_name": ["McCracken"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCracken County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00516925"
      },
      "bbox": [
        6.030392520846735, -1.5565763556271088, 6.406990146251981,
        -1.2822518252853332
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.893261781657149, -0.09447869937721073],
            [10.895324461139044, -0.08853882521401041],
            [10.894476907791837, -0.0859358159501233],
            [10.898227207444767, -0.08363829957741592],
            [10.90065931970242, -0.08467928345986013],
            [10.904628532862533, -0.08122839325093408],
            [10.902989009937317, -0.07448366312268687],
            [10.900962923245727, -0.07352693577799602],
            [10.900304608918825, -0.0678270695636073],
            [10.903165478601688, -0.06310855928266167],
            [10.897074104190244, -0.059733316993324764],
            [10.898641688745123, -0.05648974729434333],
            [10.895214127777843, -0.0532544120141561],
            [10.895727115933243, -0.050775565740535766],
            [10.901639508989577, -0.04963334225613943],
            [10.901352842054118, -0.04331971301087507],
            [10.902989988219975, -0.03988759009857287],
            [10.90802037592034, -0.04163819949781012],
            [10.910468969468537, -0.03626886649090226],
            [10.907878692327694, -0.032719291901320516],
            [10.9073561943518, -0.027338725283772805],
            [10.910474670839175, -0.02485550448623558],
            [10.907781227816185, -0.021871426056219997],
            [10.907031357681692, -0.01622941899264689],
            [10.912827487360882, -0.016618118676225032],
            [10.915018048135755, -0.012883462888081005],
            [10.918776054618366, -0.0164083882696926],
            [10.926062850150291, -0.007977059638189147],
            [10.931004761383132, -0.007441416496162506],
            [10.935186947735223, -0.00920578201946586],
            [10.941343287856323, -0.0024576773695193874],
            [10.96696916166833, -0.013769058227754686],
            [10.972536947339192, -0.015643266707598084],
            [10.973859397725358, -0.01940320292412589],
            [10.979457550853402, -0.02104031296114991],
            [10.978421987197791, -0.024747682795935266],
            [10.971751609550394, -0.024910241072456332],
            [10.970846055494409, -0.028575387508985903],
            [10.975432091103148, -0.033459725638002334],
            [10.97756261805896, -0.0340006299736748],
            [10.987445199543359, -0.03259022687503155],
            [10.988487567518135, -0.034975978073069895],
            [10.983682219430754, -0.04050240432395325],
            [10.984638236521862, -0.043305548817305056],
            [10.991144107397536, -0.044262279629563854],
            [10.994484758731728, -0.046723775704288935],
            [10.996048989683711, -0.05046902442211199],
            [10.995133975262528, -0.05560797547849202],
            [10.999750772715776, -0.05880156604034047],
            [11.001337069193589, -0.054288567203575944],
            [10.999719842005714, -0.04697638284636832],
            [11.000235932512293, -0.04359508146993504],
            [11.003856424879746, -0.042435333588757666],
            [11.006848355767422, -0.04740900486790873],
            [11.01289816412916, -0.04739081551132637],
            [11.017456665325376, -0.05168025979337911],
            [11.025105556088869, -0.05429930687659276],
            [11.031230382288095, -0.06393028945229629],
            [11.039022492821772, -0.0661205041255729],
            [11.042342043609299, -0.07031967447599294],
            [11.043793184180572, -0.0795387859190314],
            [11.045966300606647, -0.08250613383310326],
            [11.05160779425109, -0.08240216989756136],
            [11.052590399652448, -0.08548567202432622],
            [11.042445618001551, -0.08882688877875075],
            [11.041840924930794, -0.09267335992763993],
            [11.04960476231871, -0.09638407706386892],
            [11.046189575526718, -0.10468427916446323],
            [11.04729511056081, -0.10662485022458255],
            [11.053317895085888, -0.10770268466714475],
            [11.056820662433905, -0.11459205874075647],
            [11.064955667499497, -0.12026519108255716],
            [11.067106032961343, -0.12841018098780008],
            [11.065490273069296, -0.13779460637529067],
            [11.07006083725403, -0.14087427154942242],
            [11.07489395190184, -0.13181960165481318],
            [11.077925250047, -0.13117431197461957],
            [11.083260175242282, -0.13703952849099163],
            [11.085332078150444, -0.14344889981548223],
            [11.08718197585871, -0.14553061352661917],
            [11.092020820308552, -0.14511875189279513],
            [11.097706517095736, -0.1511815200272718],
            [11.105426553190291, -0.1520024032366826],
            [11.110818208269873, -0.15768244390833494],
            [11.11714895485911, -0.1574960956680822],
            [11.119572859680408, -0.16288981218182663],
            [11.119688152673724, -0.166516766568541],
            [11.122286461406544, -0.16854561561483078],
            [11.126963345445743, -0.16664705427598844],
            [11.13172665113204, -0.16663964578564405],
            [11.132278866153252, -0.16941359237392958],
            [11.12655582372085, -0.1743954577420471],
            [11.12518878347837, -0.17773710009307095],
            [11.130743771547754, -0.17983756653222466],
            [11.13968740239013, -0.17518340926803894],
            [11.14352219087416, -0.17751704088303327],
            [11.13882664087001, -0.18074271793070204],
            [11.136439984637944, -0.18447628035413016],
            [11.136934664255392, -0.19012782648373064],
            [11.132511737515776, -0.19270325880776668],
            [11.128319122987227, -0.19958150867251964],
            [11.129418478854099, -0.20171598258109874],
            [11.120090624553283, -0.19889397343013324],
            [11.118667014919408, -0.20315877513048167],
            [11.09633816330516, -0.20783900921508908],
            [11.098182231892276, -0.21070917216580812],
            [11.090569301433613, -0.2151664397292737],
            [11.089671962069533, -0.22029617394079418],
            [11.08673365072526, -0.21958739108733377],
            [11.083360783501957, -0.22279155704453962],
            [11.083418860614579, -0.22624182547661506],
            [11.076734140487204, -0.23258768071311284],
            [11.07149371615588, -0.2394900551984288],
            [11.07281189837918, -0.2420273592705945],
            [11.079182115936186, -0.24473192218904657],
            [11.081666965363938, -0.24245288489995248],
            [11.08897123860868, -0.24803081421650897],
            [11.094282892736807, -0.2509664135999924],
            [11.09477433708777, -0.25581215539745045],
            [11.088603292557657, -0.26406495950537007],
            [11.086139210349915, -0.2730114269498043],
            [11.087222656148267, -0.2764037010163847],
            [11.083187253025745, -0.27951106583728663],
            [11.078871955149351, -0.27196352994604095],
            [11.075805438297953, -0.2736210471845728],
            [11.07210496455518, -0.271352065113497],
            [11.06869380716036, -0.2768621554253915],
            [11.06274868229147, -0.2755347832435564],
            [11.0591606952507, -0.27990264079332566],
            [11.056712786431362, -0.27837925851207285],
            [11.052402777803135, -0.28390936078687584],
            [11.04462187398297, -0.2876948922499089],
            [11.041590499311589, -0.28420017887165966],
            [11.043079844309013, -0.28039664132585906],
            [11.034727847369973, -0.27422703185903624],
            [11.031902737558557, -0.2760203981054961],
            [11.026926064887656, -0.2755624207412577],
            [11.018589102424338, -0.27959726437017807],
            [11.016501961309748, -0.28180355986171773],
            [11.013001146654394, -0.28019492295565857],
            [11.010825964987818, -0.27654508981175036],
            [11.012924160369824, -0.27220333954186254],
            [11.00851053149264, -0.271265803463274],
            [11.000364042462955, -0.2759455857050268],
            [10.995471209915785, -0.2714249711280513],
            [10.992306108561293, -0.27235337175183116],
            [10.990725919669385, -0.26927506277145713],
            [10.987092299967744, -0.27037520635425066],
            [10.986654034372886, -0.2740262590698799],
            [10.98368420771262, -0.27712864671757764],
            [10.9790991385275, -0.2747185018937171],
            [10.967126680729635, -0.2766493324713724],
            [10.963443572897908, -0.27600395150340723],
            [10.958714905876738, -0.28348859369317214],
            [10.957184753945432, -0.27947241322671645],
            [10.95299962588422, -0.27932022165079845],
            [10.949146490512874, -0.28169702178671113],
            [10.947255911023573, -0.2752922154789972],
            [10.936959578432091, -0.27865556207105335],
            [10.930063709896302, -0.2721055549186639],
            [10.91426664194221, -0.26736095558350925],
            [10.91077315602115, -0.2697959059114355],
            [10.907661768970696, -0.2648302686054109],
            [10.903957072594007, -0.2633376591613429],
            [10.90022698204081, -0.2587919036731521],
            [10.89730533510452, -0.25954713049468464],
            [10.893823267944581, -0.25665493067523226],
            [10.897317990664558, -0.25221957279621227],
            [10.892937641824465, -0.24541481061311812],
            [10.886979362162263, -0.2418763429911807],
            [10.88823634747383, -0.235648719918568],
            [10.884527982300352, -0.22944721309751995],
            [10.877596273396012, -0.22562875283520767],
            [10.87750932488438, -0.22195326086335607],
            [10.875238767232299, -0.21939306821383042],
            [10.875742490370634, -0.2161205765846168],
            [10.873159427676464, -0.21025635566174286],
            [10.875698991077739, -0.20024658678959747],
            [10.867562932139737, -0.19738311531240524],
            [10.863347078520183, -0.19458038833428312],
            [10.8582630892169, -0.19354803274196283],
            [10.858903663090567, -0.18667474855021537],
            [10.862036593272661, -0.18573580183309588],
            [10.865058897526016, -0.17886665320248243],
            [10.863307256443198, -0.17262479840362036],
            [10.870404669373123, -0.16879599534490164],
            [10.868848653299214, -0.1648640772118315],
            [10.872416009095806, -0.16219872725407336],
            [10.871089972547162, -0.15948060620731797],
            [10.87614372576815, -0.1543570692316732],
            [10.873720344833117, -0.15261111822459847],
            [10.869854959586398, -0.1535553986562852],
            [10.869690412647088, -0.1498153661487216],
            [10.874337234101697, -0.14699718799711603],
            [10.871148489495031, -0.14256295982809167],
            [10.867761987865126, -0.14421458324360378],
            [10.862337495290289, -0.13930873597853713],
            [10.859609268143267, -0.13979919893308304],
            [10.854965082267512, -0.13502134428771456],
            [10.851887087633894, -0.12805391856509774],
            [10.85556948094475, -0.1262153251824424],
            [10.859787721842238, -0.12063648550036307],
            [10.867605023505423, -0.11823529329843584],
            [10.872369576352707, -0.11349107779273465],
            [10.870877655271991, -0.10893929956670924],
            [10.872696272283996, -0.1061516765947183],
            [10.878570935363742, -0.10669196492695934],
            [10.881641117741623, -0.10113733706919152],
            [10.887617343978501, -0.10095772687771955],
            [10.888240462794004, -0.09744964548639311],
            [10.893261781657149, -0.09447869937721073]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.51328118248492,
          "lat": 37.801706314718444
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21159"],
        "coty_name": ["Martin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Martin County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00516923"
      },
      "bbox": [
        10.851887087633894, -0.2876948922499089, 11.14352219087416,
        -0.0024576773695193874
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.175649992467804, 0.31921535790678096],
            [10.180509585568595, 0.31864045657304874],
            [10.184192175493346, 0.3267096334799504],
            [10.190083881738591, 0.3288997572575033],
            [10.19352201590596, 0.32812451130458814],
            [10.201377213891359, 0.33726048758399124],
            [10.205172884740374, 0.3378913547681766],
            [10.212679182267282, 0.33247284667254484],
            [10.216038712586418, 0.32454999076882873],
            [10.215729020274381, 0.3222267665169639],
            [10.223842313227099, 0.31299844167956065],
            [10.224238951273053, 0.3101551075323739],
            [10.231927626724746, 0.30930898252366273],
            [10.235652741836017, 0.30757748262029894],
            [10.237419363325522, 0.30068117366067976],
            [10.241766515974076, 0.29486829324328084],
            [10.245438826827213, 0.2942599167254778],
            [10.250406683459651, 0.28635630811451784],
            [10.250793777635346, 0.2758209006507286],
            [10.256111313227748, 0.2746810860316443],
            [10.255587136544639, 0.2713406336353725],
            [10.25794087637581, 0.2691330455320094],
            [10.261325913696874, 0.2700262296968063],
            [10.269798014508147, 0.26832855291527224],
            [10.27581170817128, 0.2580914465887363],
            [10.277539722849504, 0.2492422632369568],
            [10.281672556063086, 0.24596963752071033],
            [10.285339437782408, 0.24051447189324401],
            [10.279125418902085, 0.23639545047653168],
            [10.282164868158599, 0.23195837719430004],
            [10.286628518208301, 0.22815661859607672],
            [10.289142084019957, 0.2282523555694695],
            [10.292218513027468, 0.22083426575937753],
            [10.295797315044167, 0.21914445216260064],
            [10.294394485672699, 0.21604831959968676],
            [10.295046717935902, 0.2116039769261761],
            [10.301407292780384, 0.20448123933612522],
            [10.304607066100623, 0.2044637369532608],
            [10.301987943882546, 0.1957225477322583],
            [10.308195989056523, 0.18608542251068913],
            [10.306868669016149, 0.18509913279346138],
            [10.309184235905343, 0.17755566028408346],
            [10.31735932015412, 0.17135100565675712],
            [10.316654933954288, 0.1621433033295159],
            [10.321994433049001, 0.16435090612811026],
            [10.324411322037147, 0.16966460634564842],
            [10.32725013475092, 0.16750034233574856],
            [10.32732356829262, 0.1604379380385627],
            [10.33300931378611, 0.1579223451416365],
            [10.337546964334505, 0.15773663686878076],
            [10.339026184949152, 0.15098778748493297],
            [10.344234745778694, 0.15028551817913455],
            [10.347447637679231, 0.1474885521224302],
            [10.353819079986728, 0.15200182344448962],
            [10.360620165646791, 0.1500003442691198],
            [10.361700113426437, 0.15114576506486085],
            [10.360596263706999, 0.1439872070402865],
            [10.351580581102024, 0.1453721252317568],
            [10.352450706124543, 0.14095308124110548],
            [10.359766628185186, 0.13852459565613287],
            [10.364657722432273, 0.13495410817976167],
            [10.368599471066386, 0.13714130925350893],
            [10.374999506115179, 0.13620355411859308],
            [10.377746669872248, 0.1343728827820372],
            [10.386026260101945, 0.13883521303917884],
            [10.39410375861528, 0.1383401117872912],
            [10.399300098281897, 0.1341394213023638],
            [10.398350999687455, 0.13068364952542993],
            [10.390547116877373, 0.12660842495145747],
            [10.386412076739687, 0.11978488026320483],
            [10.388095733090816, 0.11420020056707336],
            [10.386333839476746, 0.11006509459091328],
            [10.38794861733091, 0.10771970693297762],
            [10.387008878093695, 0.09354746026665482],
            [10.384510763831514, 0.09182783157489338],
            [10.377485874487409, 0.09266659453247544],
            [10.371382906335462, 0.08920095931934734],
            [10.367312486776457, 0.08849346982231637],
            [10.359951675953965, 0.07730757721240232],
            [10.357446403991625, 0.07211748067768206],
            [10.349783422932079, 0.0668266255041324],
            [10.347633790482183, 0.06251942305173064],
            [10.344608501432898, 0.06133871424890238],
            [10.34140953126261, 0.05648191964608905],
            [10.336068548666951, 0.05527634040954522],
            [10.33161565114783, 0.05247063397059372],
            [10.33308419774629, 0.045606009599882466],
            [10.329433849275823, 0.0422767039229851],
            [10.327098769757947, 0.043127550342669546],
            [10.321217458069233, 0.03927995837418568],
            [10.316918629503395, 0.03952310708262947],
            [10.313439721854447, 0.035050105604890504],
            [10.311159977775635, 0.035659255901903684],
            [10.30448033089382, 0.03136377978384886],
            [10.300443281445162, 0.024602797166530726],
            [10.299399725288277, 0.01998622645780305],
            [10.301649544326976, 0.01718316131971038],
            [10.290826862487027, 0.01254222686999583],
            [10.286287142650952, 0.01248001804314324],
            [10.280119606114601, 0.01504602413804654],
            [10.281556308857217, 0.005297571317952127],
            [10.279467747129518, 0.0043501076287994515],
            [10.27394809147642, 0.006675208293108291],
            [10.27290962493855, 0.0014160815405557389],
            [10.275514283875328, -0.0037966279625177663],
            [10.267797910071938, -0.001872375884031039],
            [10.267311950132406, -0.008028501681867374],
            [10.264237314064241, -0.011460399950460142],
            [10.265406016377021, -0.014889551093722775],
            [10.2631245806338, -0.018484488188054652],
            [10.260552729744143, -0.018787711318560118],
            [10.257070147885923, -0.013498029444902393],
            [10.251766634598608, -0.014065192199447863],
            [10.248273267976236, -0.011505853876374322],
            [10.234141224679242, -0.018382322412472292],
            [10.237005172152926, -0.02180839167024362],
            [10.236501932767133, -0.027022902224731655],
            [10.233278296699112, -0.030598336489552264],
            [10.224306912687176, -0.03246785824841424],
            [10.223756158874119, -0.03513459393498071],
            [10.225732662533623, -0.042971725121840075],
            [10.221583242868416, -0.04577807746951563],
            [10.215976816271576, -0.04706609972085816],
            [10.211519323127812, -0.0453928583238955],
            [10.211391648749919, -0.04281015063105876],
            [10.21624173720059, -0.03916371299683401],
            [10.220787781677636, -0.03400681970594771],
            [10.218926644042963, -0.030472532022329656],
            [10.21456481251533, -0.03221269808440471],
            [10.20591054961041, -0.03945507883338636],
            [10.202161455837917, -0.038353661869255366],
            [10.202072990746748, -0.03323239399264042],
            [10.205675458969932, -0.027033127447786853],
            [10.211025813444284, -0.02248629894420892],
            [10.21105124171914, -0.013859863234833477],
            [10.207461957607421, -0.01451931321113267],
            [10.203403996837814, -0.01761316864748753],
            [10.200678727310168, -0.01699951640889331],
            [10.195804812916393, -0.01965502946859836],
            [10.186387307584294, -0.018158589824532882],
            [10.184112957742427, -0.017015095244320266],
            [10.183837416925819, -0.013493494166871796],
            [10.1875994066733, -0.008066537189221202],
            [10.191232801948244, -0.007737313509674639],
            [10.19130751313318, -0.0022430662594539],
            [10.19432122436243, -0.0007702778827637702],
            [10.195857272987807, 0.003407976038135999],
            [10.202099528962217, 0.004650903785008628],
            [10.204904111126647, 0.0013107676082234],
            [10.2087124867748, 0.00407124016702036],
            [10.209048684911528, 0.00862653132930422],
            [10.207739658532189, 0.01574859437055037],
            [10.205172424655643, 0.02009289033808523],
            [10.201348613098718, 0.017313134624594904],
            [10.197564201786257, 0.02049287519716049],
            [10.194803793960839, 0.016771614677780624],
            [10.187046867170569, 0.01843139285705418],
            [10.185186093249024, 0.019902468714990393],
            [10.181256540776712, 0.01754989067169549],
            [10.176869487458339, 0.019938809267821867],
            [10.172975658655238, 0.017814501615666556],
            [10.173277098320145, 0.006160709600673708],
            [10.172304587407897, 0.0015961283435494305],
            [10.167923518918597, 0.00269893331578874],
            [10.166734350953865, 0.00791494193352846],
            [10.160916736493173, 0.015024409742187968],
            [10.162995192314288, 0.019175634873363333],
            [10.156201097477178, 0.02267891300921533],
            [10.153333738543912, 0.021365466046959113],
            [10.15079059680067, 0.023475547133162335],
            [10.154158620993222, 0.028088954953624966],
            [10.158313439259269, 0.030841598040450318],
            [10.159502372121482, 0.037480884352995104],
            [10.163823156523918, 0.03884101919296299],
            [10.159807035639195, 0.043136609861506275],
            [10.159191837591914, 0.0461702120050809],
            [10.154473306141655, 0.04907658314475946],
            [10.147387079186165, 0.04870474834456834],
            [10.14213224930814, 0.04384177667400556],
            [10.138396667199048, 0.04284929335707763],
            [10.132763570112132, 0.03917480253044595],
            [10.12884849047567, 0.04239733058429363],
            [10.133572338152394, 0.04911943730480562],
            [10.131363045211343, 0.05140230510097339],
            [10.134374312459272, 0.05912332445578916],
            [10.131815041491306, 0.06485160419328605],
            [10.12873842108678, 0.06240116273570011],
            [10.12637166674569, 0.0679002793795414],
            [10.118124295725849, 0.07154184823274587],
            [10.111458345017333, 0.07171122592491863],
            [10.109731726784574, 0.06922623142167632],
            [10.104862285988084, 0.06915571337078286],
            [10.10359360306498, 0.060299271746587335],
            [10.102017481802397, 0.05684330421004959],
            [10.098401385471792, 0.05373069821602483],
            [10.096948283837168, 0.04999262289696907],
            [10.084459998889963, 0.053987977603707],
            [10.082131189072816, 0.06256879983319234],
            [10.07892452137603, 0.06637826102299511],
            [10.081955108805648, 0.06988776535953811],
            [10.077776452611882, 0.07309117934467624],
            [10.078456641969002, 0.07858724315159192],
            [10.08769619620593, 0.08613027780568583],
            [10.091573965108472, 0.08548915654828258],
            [10.093222854542374, 0.09069608239922647],
            [10.09678937634357, 0.09221535240902055],
            [10.095014329864624, 0.09555616248805464],
            [10.083668702264752, 0.10885157278338732],
            [10.077200565660934, 0.10744136868191087],
            [10.081017410200085, 0.09835088967473861],
            [10.076899421428648, 0.09821954940732343],
            [10.073824285146811, 0.09575531542746724],
            [10.070100903035328, 0.0998048097519527],
            [10.066452413262683, 0.1013181629417646],
            [10.060760761826607, 0.10619705360614373],
            [10.061774218580599, 0.11152362005917048],
            [10.065700581761726, 0.11112704592177376],
            [10.068717177609873, 0.11447140897092434],
            [10.07271615494519, 0.11290333331408636],
            [10.075594914258318, 0.11406270597639875],
            [10.076092679467852, 0.12399673279318751],
            [10.078683879462295, 0.1228321624831979],
            [10.085449680710905, 0.12567194138049742],
            [10.087684698551412, 0.13217994810201014],
            [10.091121645676372, 0.13338479873950476],
            [10.09427532769105, 0.1384544369566097],
            [10.094070940375511, 0.14188636946113833],
            [10.09808454044778, 0.14240145675080076],
            [10.102123954193829, 0.1383267233895811],
            [10.111614481640864, 0.14248789806492182],
            [10.11413604202053, 0.14719635440918014],
            [10.1131530200943, 0.15735810331104558],
            [10.115080210164008, 0.16400613213833581],
            [10.123390373507945, 0.17259938955462906],
            [10.126843517391489, 0.17330824179772933],
            [10.129560058218003, 0.18311560952451747],
            [10.13718694411773, 0.18474748228295704],
            [10.139526601992578, 0.18781367272912494],
            [10.13696954228871, 0.190154879446523],
            [10.138754464920595, 0.19812660815876623],
            [10.142126290206544, 0.19682410070450262],
            [10.147621472919829, 0.20483520641630318],
            [10.142650443562802, 0.21584300550901267],
            [10.140244364059296, 0.22311042436994202],
            [10.146815527707522, 0.2260955882744425],
            [10.14763216961637, 0.23034821590051768],
            [10.145477489403877, 0.23668921446780186],
            [10.146914718881753, 0.24818357388394452],
            [10.150798442566112, 0.2551175755838245],
            [10.150556821808062, 0.2573224412495773],
            [10.156128126728888, 0.2582565024371936],
            [10.153483617994633, 0.26271114364993403],
            [10.147256611380573, 0.2666469569887558],
            [10.14954621105387, 0.2690329406237022],
            [10.148187297334463, 0.2726585817365395],
            [10.14347972407174, 0.2749000622916033],
            [10.145451005224615, 0.27733347072001585],
            [10.144225907428416, 0.2819984844576821],
            [10.151957485772648, 0.2853879074418283],
            [10.156157770659474, 0.2941357960452903],
            [10.160153976582345, 0.2941967347125801],
            [10.165819994660485, 0.2908336341928643],
            [10.174241158356025, 0.2988968851378646],
            [10.168781622381054, 0.3038441934903192],
            [10.168691948264522, 0.30943171409552445],
            [10.173448073257811, 0.3117222419835042],
            [10.17566287670968, 0.31491329650733],
            [10.175649992467804, 0.31921535790678096]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.42096350124962,
          "lat": 38.196211744952876
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21205"],
        "coty_name": ["Rowan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rowan County"],
        "coty_fp_code": "205",
        "coty_gnis_code": "00516949"
      },
      "bbox": [
        10.060760761826607, -0.04706609972085816, 10.399300098281897,
        0.3378913547681766
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5407139225297053, -6.885969697868167],
            [3.5409846627676633, -6.882758919545552],
            [3.544900130502523, -6.880068104823099],
            [3.5449464999376685, -6.873092315800269],
            [3.551932543245918, -6.87280008738758],
            [3.553296724081125, -6.86817306591367],
            [3.559227227652472, -6.863554025203276],
            [3.5565336448817493, -6.858556918693648],
            [3.557770885970739, -6.848948896764931],
            [3.5636521506394514, -6.844218234802649],
            [3.561677891275351, -6.83962757081721],
            [3.5644485191395914, -6.8349458630679205],
            [3.560157505322135, -6.830353956987204],
            [3.5600998261500134, -6.826559058578199],
            [3.565477318857441, -6.824064118564485],
            [3.5687052990775827, -6.824694892718095],
            [3.5724304531899893, -6.813641151075219],
            [3.5693864382319243, -6.81014344647819],
            [3.572789572979015, -6.805994623349224],
            [3.572375718574218, -6.8006537272073615],
            [3.573858793996956, -6.798492264884318],
            [3.569307510089681, -6.7953728115612275],
            [3.5729223396660226, -6.788516092630825],
            [3.5771840066136105, -6.789228596573294],
            [3.5793147603572826, -6.785060244902615],
            [3.5779599269178113, -6.753754197738796],
            [3.670833697939474, -6.750006794448348],
            [3.7142128461027757, -6.748109223968926],
            [3.837008449561861, -6.743624928257611],
            [3.8423395102169016, -6.874124539222388],
            [3.840312049225224, -6.874244088649011],
            [3.84297218091961, -6.941650399397186],
            [3.8440195073738015, -6.962805830027991],
            [3.8488206964879703, -7.0800899425397725],
            [3.8515079418738307, -7.137327956470988],
            [3.8538506790314355, -7.181118919299553],
            [3.8603404946770175, -7.3427113526687915],
            [3.8482295291847963, -7.338995881657452],
            [3.848796412554844, -7.335294893824533],
            [3.846343251108614, -7.332992610576108],
            [3.847014719406835, -7.328822901444627],
            [3.842488636971782, -7.325607151091256],
            [3.834810178277695, -7.3267841018814694],
            [3.8325324346445604, -7.3323472807115015],
            [3.829517161156987, -7.334107875371834],
            [3.8220801267405258, -7.334400799477579],
            [3.8145747927632914, -7.338723945607395],
            [3.8087102158949167, -7.343212094857033],
            [3.7990409833470267, -7.34478203219653],
            [3.7976744022596103, -7.340290921563368],
            [3.7948388848962282, -7.339472363168189],
            [3.793033725423498, -7.335959459776191],
            [3.7924838721268714, -7.332235784663142],
            [3.7962774077005528, -7.332381600403818],
            [3.8039569968587377, -7.3288419984987305],
            [3.8043355340015474, -7.3255006718896265],
            [3.799617322345586, -7.32392049254073],
            [3.801196875706901, -7.319478754090533],
            [3.800073063030561, -7.314841776947536],
            [3.7966533017039787, -7.315167103163837],
            [3.7947275113701364, -7.3064286563522804],
            [3.7857816803111475, -7.305319324707184],
            [3.783279168495753, -7.299230491799044],
            [3.777633409403747, -7.29485281360551],
            [3.772300130476603, -7.29955272164277],
            [3.762525342184308, -7.29322818402493],
            [3.7669369250245066, -7.2867137220808935],
            [3.7641255669986897, -7.284712165128698],
            [3.757468681866295, -7.28510629404147],
            [3.7521789631640803, -7.280819906209911],
            [3.749249457901773, -7.275736346290768],
            [3.7371939972092596, -7.268731010416267],
            [3.7332443961774526, -7.254988470639104],
            [3.728778878961429, -7.251138443020393],
            [3.7286888668879996, -7.2486385330814125],
            [3.7247208221774923, -7.237041146590226],
            [3.725939239954603, -7.233854751235622],
            [3.730892401579981, -7.227209319567455],
            [3.729147548934262, -7.22171465405254],
            [3.7253996739263604, -7.221738433050609],
            [3.719486841325374, -7.219134601501712],
            [3.719506840494496, -7.213980584828611],
            [3.7240217825491486, -7.210292084713533],
            [3.724784613681455, -7.20735088465621],
            [3.7204975391970834, -7.202527709703211],
            [3.715528054497056, -7.205777782433846],
            [3.7117861844102173, -7.204232761510718],
            [3.70795259750602, -7.1996659054401375],
            [3.705185896389314, -7.20081790542823],
            [3.705173223068284, -7.204326160514978],
            [3.702855826485629, -7.20734108041061],
            [3.698610219294259, -7.205655048551248],
            [3.694275630063627, -7.1979257067278235],
            [3.6900434101748707, -7.195246816781509],
            [3.6833194068323656, -7.196468284636071],
            [3.6800327288896693, -7.194734298807389],
            [3.6795076235548265, -7.186511205033916],
            [3.6746706545560364, -7.185553004348668],
            [3.670816209131022, -7.19004042780677],
            [3.664516378986339, -7.185919511733584],
            [3.6572546175342224, -7.186878944347492],
            [3.65645244513115, -7.190571832422396],
            [3.6622591278238814, -7.193693946657912],
            [3.6650409607942076, -7.19710123266233],
            [3.6649917476316354, -7.200738501631641],
            [3.6614558028610085, -7.201525535620952],
            [3.652089761324565, -7.197291100626502],
            [3.649756773957057, -7.193100252734525],
            [3.654305138354201, -7.18257569915069],
            [3.657452984531569, -7.177941255812878],
            [3.656568521053766, -7.17613874244218],
            [3.6482410975061548, -7.171783988572311],
            [3.645879551875881, -7.173050817644745],
            [3.646448078391978, -7.1784346641862165],
            [3.6412959661767275, -7.182613695624089],
            [3.634208841895632, -7.185423375514267],
            [3.625262625388288, -7.183185949150107],
            [3.620312527162961, -7.175302739363366],
            [3.624151887235232, -7.174151696488386],
            [3.6262236293925754, -7.17081229151812],
            [3.621882051141894, -7.167330443510617],
            [3.6224987549668395, -7.1632988777075495],
            [3.6269160335456307, -7.162530916234833],
            [3.6271445011973036, -7.155500558126133],
            [3.626051341547937, -7.152027813889351],
            [3.628679161129649, -7.148631494913971],
            [3.624964185046317, -7.142620666067758],
            [3.6215590246754163, -7.144896630460118],
            [3.6059205839767325, -7.144360348821484],
            [3.6075029755919714, -7.140656103209012],
            [3.612204405330394, -7.14005829840828],
            [3.614928697072927, -7.142514990362],
            [3.6197019384293245, -7.139600907167892],
            [3.617894385203869, -7.136008041581648],
            [3.611292601936694, -7.136273054841907],
            [3.604918650562958, -7.134055099025036],
            [3.601231499162069, -7.1312892296561206],
            [3.599291803917071, -7.126596232302411],
            [3.602320532510441, -7.123997570457907],
            [3.6038661439740247, -7.116357989698009],
            [3.601962304995658, -7.11173120493884],
            [3.5937067501354094, -7.106791962593142],
            [3.585414691066717, -7.10861181392129],
            [3.583266055848783, -7.102488216014706],
            [3.5900985470470066, -7.102116755982505],
            [3.5937609031759608, -7.099498729160548],
            [3.5974000434565503, -7.093803103843028],
            [3.5959338772932417, -7.090467231884745],
            [3.5901644146321305, -7.0895358529153265],
            [3.57849943930544, -7.088979048588673],
            [3.5650760673349398, -7.085365533753508],
            [3.5602115805823487, -7.082265418217818],
            [3.550408509163709, -7.078006672356292],
            [3.540819875816397, -7.071969466584616],
            [3.533917597655508, -7.065969073217852],
            [3.5369010826782175, -7.062780555357422],
            [3.539690717374271, -7.065277766765458],
            [3.543380326398613, -7.063595053305139],
            [3.5429135671260936, -7.0562158221338205],
            [3.54708034003586, -7.055212879064111],
            [3.547922085290729, -7.058532848018232],
            [3.5562513964057074, -7.054420073979629],
            [3.5548021633096547, -7.047775198376539],
            [3.552514972061181, -7.044226947559374],
            [3.547183451239702, -7.049572070769702],
            [3.541469458805737, -7.050380430893108],
            [3.543674386963364, -7.042028739053378],
            [3.548333955913125, -7.039042113061745],
            [3.5465256749826928, -7.034282495685331],
            [3.5429161264796045, -7.031533110583867],
            [3.546804508186241, -7.028141825429865],
            [3.541056618379374, -7.023581423872378],
            [3.5461710231699572, -7.022913433272627],
            [3.5434483260725256, -7.014795839105781],
            [3.542850429678403, -7.009955828300695],
            [3.5459184773768047, -7.007553015263281],
            [3.5490878433142306, -7.0120379093944845],
            [3.5536402029938365, -7.007296053301305],
            [3.5556025905967936, -7.002432186826134],
            [3.5502035888755774, -7.0034688151935],
            [3.5477760604859356, -6.999062346916028],
            [3.5560255839981485, -6.995287653938874],
            [3.5579329006957208, -6.991093963054573],
            [3.5560263632329936, -6.9840300152803945],
            [3.550505142332915, -6.981608788951902],
            [3.547145830175993, -6.986121057990917],
            [3.5433142154162662, -6.984661597812649],
            [3.5424882958672543, -6.979445613406475],
            [3.53840209955314, -6.982570567735214],
            [3.5354980005602368, -6.9803542778609655],
            [3.536112692157931, -6.975993377673865],
            [3.539743286843127, -6.96965240321044],
            [3.537307993315713, -6.96793407158361],
            [3.5384106281332044, -6.962758292410645],
            [3.546876328395761, -6.959207153253482],
            [3.549888502498463, -6.95348542320574],
            [3.5464706376283335, -6.950720171370778],
            [3.5485654481737896, -6.946134700113677],
            [3.552799780094465, -6.9463285546832125],
            [3.5464542443114877, -6.939543117321401],
            [3.5519271481006016, -6.933476725641889],
            [3.552740987638611, -6.930905315790142],
            [3.557277811146754, -6.926988399456142],
            [3.5612127477307145, -6.927569406775929],
            [3.5638967542238467, -6.921092601354033],
            [3.5587445834520377, -6.9218175168654765],
            [3.554924548199037, -6.918945952693277],
            [3.5577937531090678, -6.915625298967107],
            [3.5546817943806084, -6.912875290317721],
            [3.5494853182173056, -6.901840289558934],
            [3.5463638600860516, -6.904150585390529],
            [3.542418037363998, -6.901146357127367],
            [3.5401527004581297, -6.892694257408137],
            [3.5419299394555117, -6.889658814109649],
            [3.5407139225297053, -6.885969697868167]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.16048725129802,
          "lat": 31.676905361091798
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22059"],
        "coty_name": ["LaSalle"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["LaSalle Parish"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00558049"
      },
      "bbox": [
        3.533917597655508, -7.34478203219653, 3.8603404946770175,
        -6.743624928257611
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.760696985141008, 4.595462872075323],
            [8.84707701589021, 4.6054873514687324],
            [8.883932156552547, 4.610085703064525],
            [8.933884884499697, 4.616575839090208],
            [8.933172189462494, 4.622355031772295],
            [9.060987164620265, 4.63872703107806],
            [9.081846622205763, 4.641621797243576],
            [9.089257761434878, 4.6048674909236045],
            [9.096612909497859, 4.565049682359127],
            [9.112500369735791, 4.472871862991065],
            [9.113680275249925, 4.466614418100627],
            [9.122943227784448, 4.41114196283787],
            [9.127967283145745, 4.377768397503038],
            [9.133033001549839, 4.33621233566973],
            [9.138583995216338, 4.292798125980379],
            [9.095230817865787, 4.287648319473487],
            [9.024650457197017, 4.278688061978073],
            [8.975482367778573, 4.272676254118391],
            [8.975811435508403, 4.270140856527429],
            [8.944015347653982, 4.266147966158363],
            [8.890289660393123, 4.2596649170775205],
            [8.804292589099012, 4.249146690551254],
            [8.798825367896216, 4.292594794910221],
            [8.789305906979742, 4.365122486761841],
            [8.776163135064275, 4.466362557346999],
            [8.767718792908529, 4.535236479077056],
            [8.760696985141008, 4.595462872075323]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.37353841176062, "lat": 42.59708867551571 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26065"],
        "coty_name": ["Ingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ingham County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01622975"
      },
      "bbox": [
        8.760696985141008, 4.249146690551254, 9.138583995216338,
        4.641621797243576
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.057271251423307, 6.384101854577924],
            [9.142113981012983, 6.395973359577713],
            [9.213216859320871, 6.406052379005451],
            [9.292169160117922, 6.4169753492800226],
            [9.38489168104313, 6.42934212287479],
            [9.457520779405225, 6.438963778894397],
            [9.457648734786085, 6.435775074898926],
            [9.461268429222601, 6.421344229895254],
            [9.46166369187837, 6.413794506282829],
            [9.460743722875126, 6.383525128888154],
            [9.460716631764948, 6.371799852384622],
            [9.462494832809776, 6.356777486711711],
            [9.466190951727208, 6.342997281628479],
            [9.470155593741996, 6.33537405882164],
            [9.467945898031093, 6.323349217370378],
            [9.467828022056098, 6.316412818018486],
            [9.465407135360568, 6.3001010977379055],
            [9.466284519517439, 6.285644074524981],
            [9.47053934859015, 6.268578542471391],
            [9.470226572254571, 6.264629184459183],
            [9.46615809748959, 6.258523790835881],
            [9.463518551253106, 6.257851410413515],
            [9.453663757335667, 6.25888355337947],
            [9.449124130182193, 6.2578081743103136],
            [9.443191750618722, 6.252185818756814],
            [9.436843125272912, 6.241302471988185],
            [9.432401419303645, 6.235124508770535],
            [9.426684221585322, 6.223890077000002],
            [9.418823194840963, 6.215517545467727],
            [9.416224978290817, 6.208390576353177],
            [9.413634346824558, 6.192643349378896],
            [9.409385632362378, 6.183836160727104],
            [9.399793284671428, 6.169998199611577],
            [9.398147861715612, 6.170937885497021],
            [9.402513696577559, 6.181037592678071],
            [9.40510663690887, 6.183870101968591],
            [9.404074514407105, 6.1872426424844695],
            [9.399333877450596, 6.191649243666877],
            [9.393755613834228, 6.193932528351477],
            [9.386411259824122, 6.1954359870125515],
            [9.374583883356147, 6.1951363599703955],
            [9.368045008772155, 6.192059350745905],
            [9.36028057633578, 6.189753289374549],
            [9.354684195045026, 6.186101504511147],
            [9.351977142362365, 6.180503079707208],
            [9.344972300054351, 6.172601236421675],
            [9.344697052896613, 6.1695433104363575],
            [9.341102523240869, 6.164996620138326],
            [9.337602034139195, 6.158167857489351],
            [9.335307992756045, 6.150730762360368],
            [9.3322782438648, 6.13645588769518],
            [9.331774005814607, 6.119725417760319],
            [9.332764334056943, 6.107015013619446],
            [9.332796672488566, 6.098933741863636],
            [9.331585401385707, 6.092641434865588],
            [9.329308150436335, 6.071911537564124],
            [9.293267015578364, 6.066559649433833],
            [9.211663679579074, 6.054992143683007],
            [9.157148647755019, 6.048150481489103],
            [9.103414147846927, 6.040993066181721],
            [9.09279885408582, 6.12641256936959],
            [9.08558523618749, 6.183386670723502],
            [9.072580886571638, 6.281231612150684],
            [9.070172803631618, 6.298463583145967],
            [9.057271251423307, 6.384101854577924]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.63590990104373, "lat": 44.35588831628273 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26069"],
        "coty_name": ["Iosco"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iosco County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01622977"
      },
      "bbox": [
        9.057271251423307, 6.040993066181721, 9.47053934859015,
        6.438963778894397
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.757911990698066, 5.285753608359301],
            [9.764783037984003, 5.242881360384526],
            [9.849717912696125, 5.255714098086846],
            [9.858702419624287, 5.197886546922923],
            [9.870646779977694, 5.126394278587764],
            [9.877153275519044, 5.091873331144357],
            [9.892514008228748, 5.007001044195263],
            [9.901180943338607, 4.957027163951],
            [9.900314113637195, 4.956864695218633],
            [9.91545381471091, 4.869274871854534],
            [9.901565351635721, 4.866802691009909],
            [9.8870803222242, 4.862149687932567],
            [9.830093499456128, 4.852454910554715],
            [9.800739638086132, 4.847708207977882],
            [9.77384132917425, 4.842772279994036],
            [9.68454641469524, 4.827495173811256],
            [9.612382907944227, 4.815779764720934],
            [9.57815578421586, 4.810342522990397],
            [9.569756902593143, 4.860579117598365],
            [9.564742513142233, 4.892175382480365],
            [9.551589581663707, 4.978236684079546],
            [9.546375631464752, 5.017801537126795],
            [9.539719132311351, 5.0645136856932],
            [9.528777371083153, 5.142191916766832],
            [9.527504284409911, 5.149935364796692],
            [9.526244899836072, 5.159524451696623],
            [9.604237661660292, 5.172303475184086],
            [9.590683039404924, 5.258418327520043],
            [9.613769420898487, 5.26203838406878],
            [9.673843677233391, 5.2718030317409],
            [9.757911990698066, 5.285753608359301]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.22177572955135,
          "lat": 43.090139397082254
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26087"],
        "coty_name": ["Lapeer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lapeer County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01622986"
      },
      "bbox": [
        9.526244899836072, 4.810342522990397, 9.91545381471091,
        5.285753608359301
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.14516453269552276, 6.596282020811771],
            [0.1608019841123464, 6.596633261513771],
            [0.1700643320602482, 6.593774170739449],
            [0.17204524452756872, 6.588537935506371],
            [0.1797336957192045, 6.583762410713538],
            [0.20042677536933004, 6.587914937935378],
            [0.20441557905680796, 6.584759236068413],
            [0.21752331350533013, 6.582499206778452],
            [0.22015022669852266, 6.584057290709755],
            [0.22606216009492858, 6.58306197012068],
            [0.23272273486783288, 6.579018735577398],
            [0.2331752580221497, 6.577239752144157],
            [0.2422693602801963, 6.577693337956095],
            [0.2443236000061383, 6.57510991138018],
            [0.25129350202726813, 6.576991249971021],
            [0.26435267937685314, 6.573940169648642],
            [0.26371944018252885, 6.569726992924958],
            [0.2611920743295406, 6.568586330662187],
            [0.2618789021311624, 6.563981386987658],
            [0.26506030207195364, 6.56399975907857],
            [0.2690509058029716, 6.550798268151916],
            [0.27533548428931515, 6.548869502603775],
            [0.2809790664492877, 6.549705000785677],
            [0.2872977968110069, 6.546156654511352],
            [0.2941482117548236, 6.545195522435986],
            [0.29654566165262, 6.546889668330503],
            [0.30161784385214857, 6.545224847676734],
            [0.3061682498800048, 6.547826887626545],
            [0.3089040120895393, 6.546573778321715],
            [0.31513754370205477, 6.5403297885731435],
            [0.316169702089098, 6.536931099141378],
            [0.3200532285480125, 6.532581649513657],
            [0.3275589592117885, 6.5296199364904925],
            [0.33151892216622175, 6.52594202007141],
            [0.3409393642774351, 6.521662463773671],
            [0.3419002994202755, 6.5200180540131045],
            [0.35838080880078865, 6.517822560909166],
            [0.36645291197468893, 6.520399723158953],
            [0.3707201915195696, 6.519033419528974],
            [0.3879662400545946, 6.51033289556633],
            [0.3906120755135984, 6.503918010044712],
            [0.3956185520337821, 6.501386906379754],
            [0.3980361773025668, 6.496733473152773],
            [0.40411309672759405, 6.492985642382532],
            [0.41042490307451707, 6.493152396925564],
            [0.41133811147141996, 6.4917096875482585],
            [0.42144335959100754, 6.4862328716718896],
            [0.42431343560253154, 6.4837657366315335],
            [0.429770957947895, 6.485676207825641],
            [0.4342625461101247, 6.483331018495455],
            [0.4378872400271904, 6.479419045383014],
            [0.43777514203216766, 6.477430999526884],
            [0.44375844013216825, 6.470066209587534],
            [0.4459052480214798, 6.463606709974244],
            [0.4532573065392744, 6.456102698712483],
            [0.454948920348799, 6.451152060137095],
            [0.45879609217532524, 6.451018382969112],
            [0.4638782255473654, 6.446776902202215],
            [0.46294695514617173, 6.440427734400676],
            [0.4687575921957116, 6.43829523755537],
            [0.4776039310046885, 6.425138860594734],
            [0.5380024747855252, 6.364401526726059],
            [0.5446657156104847, 6.3610110349149345],
            [0.545836524552963, 6.355978311950265],
            [0.554093577224582, 6.351005358395109],
            [0.5582943863605884, 6.345165704636143],
            [0.5603309127126916, 6.340474437361666],
            [0.5661415861391067, 6.333158454546104],
            [0.572920785364573, 6.33030387836454],
            [0.58317769195752, 6.31883520015125],
            [0.5876171783506053, 6.3151109273987585],
            [0.5871711888263911, 6.309930612486303],
            [0.5887446204235333, 6.303709787865212],
            [0.5880689180256378, 6.297831034320399],
            [0.5910169276253223, 6.289412658448373],
            [0.5972672723331203, 6.289819893496637],
            [0.6017598158654085, 6.280201273977404],
            [0.6020563030403626, 6.277626673361586],
            [0.6118197700733724, 6.274959639754714],
            [0.6158804844922409, 6.276291621693158],
            [0.6193736540997211, 6.274546576051164],
            [0.6213573808596753, 6.270997348553262],
            [0.6261757667932603, 6.2720540071680375],
            [0.6266484908724789, 6.276442150442024],
            [0.635951807566782, 6.27014001848196],
            [0.6363414883769876, 6.2749690464090975],
            [0.6498555796775987, 6.2646439223909125],
            [0.6495456354158288, 6.220277954029573],
            [0.5716392948812217, 6.2204273957344896],
            [0.5714026088358226, 6.184679650258552],
            [0.5706755845181856, 6.134329552345628],
            [0.45590704655250014, 6.133824211618237],
            [0.39769399374472414, 6.1336926184945755],
            [0.3608964627019903, 6.134196711342799],
            [0.31111328817956135, 6.134633290896711],
            [0.22393733198563934, 6.134346081172651],
            [0.14393666878913922, 6.135222060587276],
            [0.14402095321926459, 6.219385494050882],
            [0.144128184502302, 6.29171604711663],
            [0.14437863134846396, 6.306406001010821],
            [0.14458310061277377, 6.370946263041997],
            [0.14489274361944562, 6.452248607748468],
            [0.14532400046492822, 6.536692942550115],
            [0.14516453269552276, 6.596282020811771]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.17353670814322, "lat": 44.99544486268562 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27073"],
        "coty_name": ["Lac qui Parle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lac qui Parle County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00659482"
      },
      "bbox": [
        0.14393666878913922, 6.1336926184945755, 0.6498555796775987,
        6.596633261513771
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.31319682800157156, 9.825220807129213],
            [-0.3144424651406278, 9.826658940948748],
            [-0.23318433781555806, 9.826038523718436],
            [-0.22682926046094418, 9.825693276883625],
            [-0.14615674691691408, 9.824138358507023],
            [-0.05840984175659407, 9.823651486158045],
            [0.02924670367803317, 9.823152902069092],
            [0.09952023032319962, 9.822402100589526],
            [0.11219836002216921, 9.822558980556357],
            [0.1359963855329247, 9.822280646014885],
            [0.20426573509644802, 9.822823209465803],
            [0.2114783091261864, 9.822571326196519],
            [0.29129447436696004, 9.823219372011726],
            [0.30580978650922613, 9.82323974359139],
            [0.3951097357357691, 9.821637975768462],
            [0.4680821561973101, 9.821442695901714],
            [0.4976758467772873, 9.820442294907052],
            [0.555948562621794, 9.819522238012858],
            [0.5724104995428306, 9.818613745340127],
            [0.5845826378981132, 9.81845597652574],
            [0.6137449075751349, 9.818817492378367],
            [0.6575982504953712, 9.817937796410064],
            [0.686785851058979, 9.81795016455018],
            [0.7298267694004876, 9.81756429827884],
            [0.7306726842167374, 9.810925346292503],
            [0.7309689897489483, 9.769026494568092],
            [0.7300612997455206, 9.67718654404398],
            [0.7310088234566606, 9.6483306400364],
            [0.7366972547091145, 9.648368064128285],
            [0.7369026005958658, 9.566257074797765],
            [0.7367683895970442, 9.549798482086832],
            [0.7369935789659825, 9.460279874256488],
            [0.6931388647648704, 9.4600707766465],
            [0.6504570902274535, 9.460043301821448],
            [0.5776372197938984, 9.459014216401446],
            [0.47603627737581744, 9.458503780411132],
            [0.39071389017767133, 9.458656161074613],
            [0.37645095026375014, 9.45977357366828],
            [0.34689909894536514, 9.46057184972273],
            [0.3403230052051072, 9.458920193818704],
            [0.317303005334413, 9.459112781084777],
            [0.30241489754935835, 9.459688719177608],
            [0.2883026211815095, 9.461857458973988],
            [0.23050414105219616, 9.461475560175158],
            [0.21576748867245907, 9.462267336930259],
            [0.2017100218728241, 9.462064547633672],
            [0.12672841351624206, 9.461746191055989],
            [0.10472393267921568, 9.461528015288298],
            [0.039160967062205586, 9.461831339611612],
            [-0.03382364090883713, 9.462079572770392],
            [-0.13555726159512313, 9.462688883693547],
            [-0.222916892869296, 9.463632485322334],
            [-0.30764289299549835, 9.46459398915466],
            [-0.3009032609186119, 9.46727104798015],
            [-0.30126564659711114, 9.472290392799463],
            [-0.30982634899462363, 9.474664838228065],
            [-0.30839658363976136, 9.47867432447358],
            [-0.3038966660806159, 9.484545786783038],
            [-0.30015370616658454, 9.487871746295285],
            [-0.3036524484600517, 9.493340879023556],
            [-0.3014371575507421, 9.496744463903106],
            [-0.29593177331044135, 9.498428271270017],
            [-0.2966777943401878, 9.501317385565157],
            [-0.3024771083500148, 9.504703862512871],
            [-0.3021236373022625, 9.507393253839346],
            [-0.29701888987034086, 9.507437694727743],
            [-0.29469734564419875, 9.504708118683299],
            [-0.29254740920911043, 9.498420940479047],
            [-0.2880111864381796, 9.500082504491136],
            [-0.2890789596616722, 9.50376493541686],
            [-0.2926315254599435, 9.507609165143284],
            [-0.30317418313317174, 9.51235776696547],
            [-0.30759524313578335, 9.5091899906532],
            [-0.3092481565178746, 9.513414088835036],
            [-0.30082179321580155, 9.517029743086196],
            [-0.29819792812235385, 9.516991014272794],
            [-0.2929027882105136, 9.513413672422862],
            [-0.28978108705465033, 9.515800961402778],
            [-0.2922372533467977, 9.51833236053796],
            [-0.3044549083022031, 9.521205542674801],
            [-0.305531408452428, 9.524999222432564],
            [-0.2997921361589886, 9.526758708223955],
            [-0.2996792121587767, 9.530640734141157],
            [-0.3055281506245665, 9.530992333821283],
            [-0.30550405856980073, 9.535828011422678],
            [-0.29802515715976935, 9.53939604186673],
            [-0.2924283406959172, 9.53943794188022],
            [-0.29223310930889135, 9.54254383189635],
            [-0.2958985866118076, 9.546910295079165],
            [-0.29215509589610117, 9.549323788376098],
            [-0.2916510366754939, 9.552687700708681],
            [-0.2989285114669073, 9.554992780988202],
            [-0.30484538655175025, 9.554988483908577],
            [-0.30514004734708366, 9.558868706274856],
            [-0.30243089517537725, 9.560183848216266],
            [-0.29536922277196787, 9.558821814405057],
            [-0.29234953183985646, 9.559436176022455],
            [-0.2923639245857504, 9.565007932681954],
            [-0.2891131655735868, 9.565532768455848],
            [-0.2863449407737755, 9.568363026203489],
            [-0.28997841893913995, 9.5785598784094],
            [-0.2920984955576727, 9.580341927966384],
            [-0.29900440509759696, 9.575737959899827],
            [-0.3006682050305289, 9.57945692503045],
            [-0.29399649768901415, 9.587169540791459],
            [-0.29122040750985423, 9.586682897652768],
            [-0.28887533698165146, 9.583343264817845],
            [-0.285337531827838, 9.582220897037638],
            [-0.2837946507610618, 9.586010642880607],
            [-0.29157081134082175, 9.590672222348799],
            [-0.2928737593236918, 9.59279136528628],
            [-0.2897742247527798, 9.597911349513366],
            [-0.292944656462586, 9.599907604761126],
            [-0.2974951414288505, 9.597101171018172],
            [-0.3003073798403367, 9.600099590206051],
            [-0.29744694665274307, 9.60624628018705],
            [-0.28578256385575374, 9.609814520514556],
            [-0.2864579937064262, 9.613529568665134],
            [-0.28958230234484583, 9.6150024375051],
            [-0.2973168397396589, 9.61555682617321],
            [-0.29192743811948896, 9.62571815712556],
            [-0.29301646453201347, 9.629988431434752],
            [-0.30104819372839153, 9.631614981340066],
            [-0.3016211860836216, 9.634387113074322],
            [-0.2987861836942085, 9.63954340766412],
            [-0.3037853735004163, 9.641662766321197],
            [-0.30681153332225164, 9.64776601052833],
            [-0.311470413942416, 9.650800542460768],
            [-0.31094295836328284, 9.656849383411432],
            [-0.3075720499977925, 9.657913285577274],
            [-0.3005270141096051, 9.657145261670868],
            [-0.2993900623720083, 9.66022178453215],
            [-0.3018163913514424, 9.66502730235587],
            [-0.2971872255557421, 9.667235576057145],
            [-0.2983282561614736, 9.670330927446582],
            [-0.3037669275770488, 9.668117747330156],
            [-0.30796404888576306, 9.668932081434475],
            [-0.31236553163825304, 9.672254076423682],
            [-0.3118705414475711, 9.677034338566036],
            [-0.31636719475936775, 9.678408202468042],
            [-0.3155376436527304, 9.681106019652347],
            [-0.30969485170118977, 9.68318918966997],
            [-0.3061610171652205, 9.682943976796208],
            [-0.3010662734052125, 9.68784990392214],
            [-0.2948635422038432, 9.692402394116106],
            [-0.2949307766339533, 9.695273714947147],
            [-0.3027722174964382, 9.703670043551707],
            [-0.30576562522988976, 9.699013058403722],
            [-0.30940439182583857, 9.698884703697567],
            [-0.31039773593014586, 9.703202670846355],
            [-0.3077580188261243, 9.70513963864048],
            [-0.30065090344747214, 9.70709884127195],
            [-0.29608813701542175, 9.706402862992704],
            [-0.29110796647377385, 9.701663767867327],
            [-0.288675628908699, 9.703739610438067],
            [-0.29154234472409285, 9.70874649382391],
            [-0.302066575244649, 9.71304533073331],
            [-0.3037410985039007, 9.71786071478242],
            [-0.29923440773544957, 9.718739301454837],
            [-0.2946189724932649, 9.716369226043216],
            [-0.2899652464776888, 9.7187232313468],
            [-0.289391380915225, 9.724824331264347],
            [-0.2911449325196093, 9.728023978983904],
            [-0.29647470699769335, 9.728285531045376],
            [-0.3009246138288582, 9.72370194902936],
            [-0.3045003292966375, 9.723240833428179],
            [-0.3072289001388375, 9.726332540207371],
            [-0.30556591656345594, 9.72909278217327],
            [-0.2969350826000198, 9.733704565199078],
            [-0.2928651651759665, 9.73869647399093],
            [-0.29226443567274013, 9.744790498993625],
            [-0.29550189345325467, 9.748259891861961],
            [-0.3012954518435514, 9.747868713317702],
            [-0.30533586900793847, 9.755129559603105],
            [-0.3011174802035356, 9.758894044986],
            [-0.2958282494192177, 9.755997533244193],
            [-0.29276315742845543, 9.755712781985672],
            [-0.29233476061400737, 9.759855963191308],
            [-0.3001551513994645, 9.761628890018628],
            [-0.3097542837243548, 9.759251529890454],
            [-0.3138059206431418, 9.760172347325627],
            [-0.3141877358455148, 9.764112360421173],
            [-0.3113582732697533, 9.765771879343447],
            [-0.30341453114735906, 9.767031061419786],
            [-0.2998432915881678, 9.768704672345894],
            [-0.2993845490347016, 9.771951566866427],
            [-0.2944084923971038, 9.77226363858782],
            [-0.2943613439436238, 9.77610839362104],
            [-0.29735836368546636, 9.77899488435653],
            [-0.30248395981850684, 9.781253150571372],
            [-0.3059864658022371, 9.785617819568051],
            [-0.30598387267048366, 9.795371371701215],
            [-0.29866531373272115, 9.794969495148619],
            [-0.2913941951038453, 9.800736825596665],
            [-0.2908636842579175, 9.804270849454035],
            [-0.29694314938879796, 9.805097055098672],
            [-0.30103496790402756, 9.80254925838422],
            [-0.3063488809846891, 9.802658273168518],
            [-0.3090662662994799, 9.807284204363512],
            [-0.30821509274860037, 9.81248657412285],
            [-0.3007533302200195, 9.814936183394881],
            [-0.3006639782244981, 9.819243415629614],
            [-0.31319682800157156, 9.825220807129213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.36847114500299, "lat": 48.35810678573022 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27089"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00659489"
      },
      "bbox": [
        -0.31636719475936775, 9.458503780411132, 0.7369935789659825,
        9.826658940948748
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3955007825844379, 7.672500716760993],
            [1.402243303937577, 7.66554729617976],
            [1.406801891871675, 7.6654873417095315],
            [1.4152565559350032, 7.654710007813852],
            [1.4169986124940195, 7.651040879858264],
            [1.4205363517633363, 7.651976757781997],
            [1.4243575118303733, 7.649551038954989],
            [1.4275523624971274, 7.653964883530313],
            [1.4321492403890834, 7.651806016625827],
            [1.4366960712498058, 7.651444359043675],
            [1.4428461932377097, 7.649155713368505],
            [1.451684209085488, 7.640942811607066],
            [1.4598699259405121, 7.637588248163657],
            [1.4634392133087395, 7.632412592848654],
            [1.4674121040868724, 7.632864144532456],
            [1.4711758349259672, 7.630175902569005],
            [1.478362993996542, 7.62834802229232],
            [1.4903826638141104, 7.634485145728023],
            [1.4952040877752404, 7.635168059061321],
            [1.4967883612080566, 7.6385865977301926],
            [1.5038714588460758, 7.641018113148729],
            [1.509135392606565, 7.639803383162993],
            [1.5133971074091304, 7.641756432384048],
            [1.5152131956070896, 7.647390052838662],
            [1.5206291118642203, 7.646606864290644],
            [1.5246688384435532, 7.6486242863078955],
            [1.5285806600010656, 7.656253412774766],
            [1.5312855577008055, 7.657468594721076],
            [1.5341736076700563, 7.654142286621956],
            [1.5412723045123589, 7.658088784254027],
            [1.547162544110149, 7.656851770032375],
            [1.5501724054916646, 7.658771784485842],
            [1.5547102474030081, 7.657193933871757],
            [1.5552381974034526, 7.654190683214364],
            [1.5631774715226605, 7.651733946199715],
            [1.571246770645994, 7.646835817096965],
            [1.5716738057822368, 7.642200147814961],
            [1.5741264770889705, 7.640001269758007],
            [1.578935847144841, 7.63950337645824],
            [1.5805594773914922, 7.6362405360873264],
            [1.5776587477427555, 7.633229938690872],
            [1.5803790308970764, 7.630722163524594],
            [1.58520123711816, 7.635441602343543],
            [1.5920013872257173, 7.624612930611804],
            [1.5989203986625926, 7.6275415681532515],
            [1.606023743565785, 7.623113029122561],
            [1.610721042090114, 7.615683319226332],
            [1.606219526767327, 7.60773866248249],
            [1.609198626253292, 7.604582326966351],
            [1.612460022128308, 7.605715792905565],
            [1.6150303570378688, 7.60364063757856],
            [1.6128355793872036, 7.597332521245938],
            [1.606514643265629, 7.595197684587998],
            [1.603112162781901, 7.59071764649636],
            [1.6044990951973284, 7.588007331282065],
            [1.603414672591124, 7.583195010689996],
            [1.5978027459481599, 7.580008623325532],
            [1.592600727539576, 7.572045540389517],
            [1.5873590768775294, 7.5684457135736345],
            [1.5804066589621106, 7.5660570763608375],
            [1.5804503351327708, 7.561111209191014],
            [1.5767805906216896, 7.556642112282707],
            [1.5761397703444484, 7.539957999574862],
            [1.5789231864238702, 7.534496310356917],
            [1.5817353597182564, 7.532123271819783],
            [1.583019299185842, 7.526086134771358],
            [1.5906767934343096, 7.51888594978782],
            [1.597160191819309, 7.508869671023157],
            [1.5970122969926008, 7.505833947219821],
            [1.5934783663418748, 7.502778173941771],
            [1.5941073634751213, 7.493810547991042],
            [1.5917216850535252, 7.486024520648489],
            [1.6417104181042135, 7.486981065317501],
            [1.68724747629489, 7.487613054114587],
            [1.7209259430507544, 7.488298473609291],
            [1.7533949528877697, 7.487798664412148],
            [1.787381762483874, 7.488674161968682],
            [1.8014476228089702, 7.489275259735902],
            [1.895688557611989, 7.4913620795351346],
            [1.9239443077858795, 7.492297098887418],
            [1.9832307483362779, 7.493313301699403],
            [1.9834258763757697, 7.489039620044856],
            [1.9851023581173448, 7.407868764601047],
            [1.9872496241130904, 7.321584336156876],
            [2.0160830743401856, 7.321699692669344],
            [2.01746850092996, 7.292500518342647],
            [2.0174114948059354, 7.278672596965326],
            [2.018150280963416, 7.249584622313643],
            [2.0202947088928083, 7.213746571103299],
            [2.0226820318722973, 7.177253203622179],
            [2.0232902293249935, 7.162903068453949],
            [1.9801781722549865, 7.16188465685204],
            [1.9658269311931917, 7.162108730843696],
            [1.9513919481885726, 7.161665717478093],
            [1.9381770289824487, 7.161944840200568],
            [1.909038014892874, 7.161778994448238],
            [1.9017537009557421, 7.161999555518114],
            [1.8582098776010407, 7.16122409573778],
            [1.8293697363078523, 7.160185068481076],
            [1.7720982417749067, 7.1585747805757345],
            [1.7202284542668393, 7.157547290456607],
            [1.6761599808680974, 7.156377999964585],
            [1.612540063310235, 7.154453553871537],
            [1.6183063374746298, 7.143939056537951],
            [1.6256846848928526, 7.1355793786199095],
            [1.6304517959253093, 7.131553363743205],
            [1.6339609750930892, 7.130793689771138],
            [1.6377314365232052, 7.134091385544594],
            [1.6406277697749903, 7.133180504324367],
            [1.64164924118498, 7.123796128012656],
            [1.646292037227669, 7.1185946580578605],
            [1.6537021490539427, 7.116977881438501],
            [1.6607463083016627, 7.114086994356709],
            [1.6699994767065878, 7.109048922849943],
            [1.6276696335568053, 7.108253831444273],
            [1.545376216589403, 7.10700744582522],
            [1.5271707799830172, 7.106507092822804],
            [1.5014492536269517, 7.105398763637833],
            [1.4797692236838895, 7.104834671521282],
            [1.4293763411797469, 7.104110555677376],
            [1.410240902702863, 7.1036187174380085],
            [1.409640113896975, 7.142392261308807],
            [1.4093784509340905, 7.175961679295497],
            [1.4082504874060526, 7.261104157472298],
            [1.4046214961513783, 7.261097465985044],
            [1.403670643517037, 7.3731690389941456],
            [1.402993198729199, 7.41835436313725],
            [1.402337602424218, 7.4807360835043335],
            [1.401282030123283, 7.541907991913276],
            [1.401481969688384, 7.5491856242119955],
            [1.4002830563314543, 7.607067075713209],
            [1.396543663359141, 7.607205332570032],
            [1.3961122684357785, 7.642900891404951],
            [1.3955007825844379, 7.672500716760993]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.26836817787124,
          "lat": 46.012602489702466
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27097"],
        "coty_name": ["Morrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morrison County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00659494"
      },
      "bbox": [
        1.3955007825844379, 7.1036187174380085, 2.0232902293249935,
        7.672500716760993
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.07716512090896285, 7.946402470317029],
            [0.011914700483172632, 7.9458635909040884],
            [0.08705550796368314, 7.945450081054922],
            [0.15728947293577306, 7.945152418481334],
            [0.17429394415470878, 7.945228789528795],
            [0.26998747694212893, 7.944909740462886],
            [0.26982191139994127, 7.888097224432304],
            [0.2698317359595082, 7.773406463296866],
            [0.26966234422684826, 7.698699784376729],
            [0.2698221986066113, 7.629408590035051],
            [0.26978760254521883, 7.600530508512866],
            [0.28042233654692844, 7.600476570050749],
            [0.28020579746551466, 7.568539049204439],
            [0.2797989758918062, 7.56336795521976],
            [0.2797344004759087, 7.5140937228468045],
            [0.27944061359246053, 7.428730669172178],
            [0.2786598431295033, 7.3425943314669295],
            [0.1927542817599347, 7.342838764362264],
            [0.10633622224912011, 7.3435234924198625],
            [0.06278307062119066, 7.343776906959043],
            [0.06186046424471473, 7.348762139117911],
            [0.06491423128893327, 7.359673505513358],
            [0.07010390090072581, 7.373015503566994],
            [0.07384624948717489, 7.376953184581722],
            [0.07670797196791179, 7.3862586168437705],
            [0.07592982059182371, 7.3934571501661654],
            [0.07848740325031435, 7.405205983693192],
            [0.07664475111186979, 7.410714121763143],
            [0.07706074841882594, 7.418335403218105],
            [0.07537343722949995, 7.426058696309709],
            [0.0700466053165472, 7.435717526402976],
            [0.07467695278911024, 7.43753537312356],
            [0.06980729571005735, 7.440724553413851],
            [0.06818777719003909, 7.447015482695149],
            [0.06896256115928044, 7.453098002516091],
            [0.06475698853929114, 7.463854743005897],
            [0.061543178533682796, 7.468283168260679],
            [0.06382843930211997, 7.480126369794474],
            [0.06120841560312919, 7.4921527674572115],
            [0.06155861206026024, 7.496744098421468],
            [0.05545745211890146, 7.499669685948644],
            [0.056371012608370775, 7.503096675620506],
            [0.053361872250317806, 7.505027861933241],
            [0.055469058526193514, 7.509969179385366],
            [0.0561173265043693, 7.515479375313647],
            [0.05804719097820307, 7.5174157488028595],
            [0.05847599324667706, 7.524263744250306],
            [0.055251554163955836, 7.524887989149186],
            [0.05686649085853935, 7.529969362201701],
            [0.05269751010732137, 7.533954354171202],
            [0.0535144963446372, 7.5381727140639905],
            [0.05073905335877322, 7.5398390706125005],
            [0.05144512347272186, 7.543061755497095],
            [0.04948505068685759, 7.5476453616082555],
            [0.049941630950231686, 7.551867591044198],
            [0.04850921847002623, 7.555761212682096],
            [0.0491871673016985, 7.562860394943646],
            [0.058269123768636355, 7.567342641674718],
            [0.05412306105018201, 7.569306798336709],
            [0.051299188803651426, 7.5735201578505595],
            [0.05177301784002585, 7.578872231024238],
            [0.04819099667951811, 7.58167089529094],
            [0.05024149185986985, 7.587384758709918],
            [0.05120603402585795, 7.596058411182474],
            [0.047863479711843265, 7.600082675086272],
            [0.05113278874568268, 7.60430494345359],
            [0.0502902691695911, 7.611045819588848],
            [0.044646425434156985, 7.61387486654511],
            [0.05004900734219755, 7.617670967209001],
            [0.04586882945235002, 7.621985869031704],
            [0.050430174251137494, 7.636509759672682],
            [0.04764496666323155, 7.638469109746386],
            [0.04850016007245198, 7.648065432671898],
            [0.04285787029522964, 7.65137458079802],
            [0.04088945583987859, 7.655556388157353],
            [0.03434691382818768, 7.660099783692024],
            [0.03731894323905757, 7.664577944819709],
            [0.02881767519301357, 7.668265299161501],
            [0.025569269257457075, 7.671430417770717],
            [0.01716670608714772, 7.669606120567386],
            [0.015234946585807744, 7.675576372233882],
            [0.018362596885361973, 7.680966657710359],
            [0.010466001094972135, 7.684595653062091],
            [0.009566741125247599, 7.68798647013619],
            [0.0030395457315968793, 7.693149876208084],
            [0.002481769402863303, 7.698587323176265],
            [0.0005054336533243256, 7.703129111710162],
            [0.0016747781683197607, 7.705635482594425],
            [-0.0031816628668817366, 7.710266520221637],
            [-0.0013483022858897956, 7.713856258329699],
            [-0.005376766433932165, 7.723114721131871],
            [-0.007775710157804, 7.726113451058061],
            [-0.011788575151703342, 7.72392929617645],
            [-0.013224725062737615, 7.727787057469372],
            [-0.00995274890314859, 7.73040922990902],
            [-0.011239242490288712, 7.732791261954283],
            [-0.018561842216795493, 7.73090316704731],
            [-0.020078860057729915, 7.735338657801661],
            [-0.014590597758603864, 7.734787911914554],
            [-0.015592728165751057, 7.740267005869181],
            [-0.0223245435694477, 7.735752358058779],
            [-0.023374893305083792, 7.737654523550165],
            [-0.020790874764495645, 7.745370337889574],
            [-0.024006120911681278, 7.746958217829048],
            [-0.026298077353874086, 7.753378440654897],
            [-0.032863816724118367, 7.758051784928572],
            [-0.03237850779734334, 7.760070829317455],
            [-0.03436866868653428, 7.767473725065893],
            [-0.029730615333034966, 7.767524002867658],
            [-0.02792635950893033, 7.777787226866754],
            [-0.0327538212670972, 7.7798881596343445],
            [-0.029150038578908032, 7.782866735954816],
            [-0.03383379658829046, 7.787895945791402],
            [-0.03834710022414632, 7.789770552553941],
            [-0.0382983734775258, 7.79411414427526],
            [-0.042237072480820696, 7.800175292489944],
            [-0.045937237061458, 7.802920340969169],
            [-0.043202124965095824, 7.806163270567946],
            [-0.04488815196439279, 7.809641571991707],
            [-0.04358402431907281, 7.812973402076103],
            [-0.04619990094039606, 7.815566746520911],
            [-0.04623223738430828, 7.818749682309612],
            [-0.04353625165772601, 7.824668456539319],
            [-0.04326001867347859, 7.828485953720718],
            [-0.046877717758543276, 7.837120666820395],
            [-0.04471655678956699, 7.841278940774143],
            [-0.049436403093815584, 7.843493140571895],
            [-0.049215124621053326, 7.850802863769479],
            [-0.0474062060692516, 7.857762257366846],
            [-0.053135666054710914, 7.866553460635411],
            [-0.050779939437705875, 7.872699120822941],
            [-0.05226201709583837, 7.8751783772372805],
            [-0.049280052404225436, 7.883810200731315],
            [-0.05129782666521328, 7.892286929693117],
            [-0.055048521532519816, 7.8929165565232005],
            [-0.054344269012967836, 7.89863772628574],
            [-0.055453962216546845, 7.904821165610309],
            [-0.05811227906918629, 7.9033255673737655],
            [-0.058476187205952615, 7.911828054041612],
            [-0.06293862611154892, 7.911088423359886],
            [-0.06528467160851827, 7.91524377796838],
            [-0.06835617701459916, 7.913360044978381],
            [-0.06873350086016349, 7.920054622279926],
            [-0.07283937218326739, 7.924201524315278],
            [-0.06866517471806015, 7.925693012361501],
            [-0.07178299429080785, 7.930176294087621],
            [-0.07069778133895777, 7.937331250617183],
            [-0.0786321109088582, 7.935425529658258],
            [-0.07875418607481474, 7.937474834482057],
            [-0.07284545575893277, 7.940547895828279],
            [-0.07642634802987212, 7.942424911340242],
            [-0.07716512090896285, 7.946402470317029]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.46820528178675, "lat": 46.35699398371747 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27167"],
        "coty_name": ["Wilkin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilkin County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00659528"
      },
      "bbox": [
        -0.07875418607481474, 7.3425943314669295, 0.28042233654692844,
        7.946402470317029
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.14393666878913922, 6.135222060587276],
            [0.22393733198563934, 6.134346081172651],
            [0.31111328817956135, 6.134633290896711],
            [0.3608964627019903, 6.134196711342799],
            [0.39769399374472414, 6.1336926184945755],
            [0.45590704655250014, 6.133824211618237],
            [0.5706755845181856, 6.134329552345628],
            [0.5714026088358226, 6.184679650258552],
            [0.5716392948812217, 6.2204273957344896],
            [0.6495456354158288, 6.220277954029573],
            [0.6498555796775987, 6.2646439223909125],
            [0.6565796301315788, 6.258109257869777],
            [0.6621221713469174, 6.249681005626863],
            [0.6611292084991559, 6.244525949882806],
            [0.6626009909099452, 6.240121722461114],
            [0.659268183660056, 6.238014230792285],
            [0.6629906038919707, 6.2346698198746795],
            [0.6691302121700872, 6.232378297087695],
            [0.6785751134676133, 6.232933350322884],
            [0.6848891356897874, 6.231148590883669],
            [0.6899118421820549, 6.236126504843204],
            [0.6955690397039538, 6.23308108279802],
            [0.6951426453884224, 6.225513567797952],
            [0.7011721286160449, 6.223116943209076],
            [0.7042867713184771, 6.219263637218183],
            [0.7073574385904263, 6.218063843982062],
            [0.7111457877749997, 6.220029189713224],
            [0.7114511691938323, 6.215307624484177],
            [0.7082375077826378, 6.213774454308211],
            [0.717549833445579, 6.203286599965077],
            [0.7203747831865617, 6.202395080988666],
            [0.7234424526924472, 6.206976396755976],
            [0.7278102863297092, 6.198036233543859],
            [0.731953597344362, 6.196666372493416],
            [0.7364381994592791, 6.188862082023414],
            [0.7351390260350802, 6.1836096956351625],
            [0.7360122151873784, 6.179991207579436],
            [0.7404912760909359, 6.178525510012876],
            [0.7461071277672109, 6.180270600167013],
            [0.7492463630809215, 6.177201497722265],
            [0.7465327070272274, 6.172518307814037],
            [0.7587536398167826, 6.16990539744129],
            [0.7632528141277111, 6.168322707662073],
            [0.7656021675998799, 6.169755338403088],
            [0.7710928089367527, 6.162878158023345],
            [0.770270570520504, 6.158468261264613],
            [0.775131403488583, 6.152726648936067],
            [0.7807348004642002, 6.15154550003658],
            [0.786398095766976, 6.148997560558071],
            [0.7919467979861685, 6.14478114802449],
            [0.7925453040312855, 6.14115047077571],
            [0.7859204221345931, 6.133199842177869],
            [0.7898406111725281, 6.132179687662986],
            [0.8040704461382236, 6.13160226175493],
            [0.8107316762796786, 6.125875566849358],
            [0.8150871220372083, 6.12427334518083],
            [0.8196620976507684, 6.118725813740117],
            [0.8190419987025218, 6.116769089650828],
            [0.8087532265219007, 6.113245230443192],
            [0.7999155510139772, 6.11287801928936],
            [0.8017241504768174, 6.105041985312315],
            [0.7963318609586785, 6.104371736223254],
            [0.7966565501757452, 6.101629740729321],
            [0.800032160995012, 6.0993919460951735],
            [0.8049262589099552, 6.101533415548332],
            [0.8069848269192526, 6.096533734852524],
            [0.8123376302244223, 6.096587970960057],
            [0.8115897824016346, 6.099633624903477],
            [0.8145440262171456, 6.10287066749697],
            [0.821355815371295, 6.0997731503876125],
            [0.8253994088935425, 6.0942126401477],
            [0.8241192997172003, 6.092152515330352],
            [0.8241978212940378, 6.0828286613316305],
            [0.8274499910833448, 6.08082551896188],
            [0.8302897206747822, 6.082596330331189],
            [0.8342544383372256, 6.086232486923471],
            [0.8381807007363619, 6.0833588212378436],
            [0.8405434277018117, 6.079265101803713],
            [0.8439150951492692, 6.078931238441223],
            [0.8446666357062909, 6.074412087271641],
            [0.8478975969087255, 6.071094534448594],
            [0.8599239249801414, 6.073807123118617],
            [0.8666473637573744, 6.069743758518214],
            [0.8694020353214785, 6.069666536029128],
            [0.8724222351706135, 6.06650524612491],
            [0.8734128681616729, 6.062413065135563],
            [0.8772336611641459, 6.065066757700652],
            [0.8835465653804445, 6.061088091479158],
            [0.8912084914599303, 6.054390206047805],
            [0.8882571342333947, 6.049590699355782],
            [0.8919965627249371, 6.044138624370753],
            [0.8995939932409893, 6.040150270553363],
            [0.9050532213278649, 6.033666403305528],
            [0.9175955432306703, 6.029352491423689],
            [0.9178290109996796, 5.974200680934992],
            [0.9182499893309767, 5.9229046648801935],
            [0.9184947774519728, 5.873070334059351],
            [0.8913562959084088, 5.872900064581208],
            [0.7969522478556325, 5.872632671397464],
            [0.7604782832068061, 5.8729471911588575],
            [0.751823595875645, 5.872700527833041],
            [0.7450546536449528, 5.872913478627662],
            [0.74492784188867, 5.960049205121263],
            [0.7076199713376804, 5.960338474661374],
            [0.6705677258526433, 5.959858557172657],
            [0.6577241183689657, 5.960017994019723],
            [0.5563048251373264, 5.960374024741841],
            [0.48394927990767356, 5.960126496099485],
            [0.4405420274917088, 5.959709787098323],
            [0.39773922447654964, 5.960037961711893],
            [0.33877083280207804, 5.960818712038627],
            [0.31088997394504675, 5.961022321183461],
            [0.23874685723640812, 5.960602170704237],
            [0.1429645558598693, 5.961624931681519],
            [0.14346078745774446, 6.033168875305303],
            [0.14375387910343237, 6.048353927362706],
            [0.14367817571378366, 6.120183490717247],
            [0.14393666878913922, 6.135222060587276]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.86839515488963, "lat": 44.71623708346304 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27173"],
        "coty_name": ["Yellow Medicine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yellow Medicine County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00659531"
      },
      "bbox": [
        0.1429645558598693, 5.872632671397464, 0.9184947774519728,
        6.2646439223909125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.699721419635338, -5.6214500159884855],
            [4.694785851101225, -5.5317183515907775],
            [4.737829935164736, -5.529309669567448],
            [4.739566336298458, -5.531456355030911],
            [4.814170865962931, -5.526749827268043],
            [4.8715640882628595, -5.523223671174818],
            [4.90794971191633, -5.520973584948704],
            [4.913953628708148, -5.608473288243365],
            [4.917542595444639, -5.666014475198996],
            [4.918966620170357, -5.694899724829249],
            [4.879830149554306, -5.740577091599622],
            [4.879646155352383, -5.741127730382669],
            [4.837888862726289, -5.786469669745229],
            [4.839188214497435, -5.808112397811501],
            [4.843674884621571, -5.803874253078767],
            [4.849460673605863, -5.804171500399403],
            [4.854989511134518, -5.812128988290181],
            [4.861663744243055, -5.810909875990382],
            [4.8654070527553035, -5.805001361171041],
            [4.865009816289833, -5.802066086689984],
            [4.869148651362877, -5.801573712489381],
            [4.8719344433205745, -5.805358267489406],
            [4.876044967813837, -5.805807409623185],
            [4.881484276008824, -5.801806966210286],
            [4.884205528018434, -5.803712087968103],
            [4.887656784826718, -5.8018935478742835],
            [4.888816502024865, -5.806145741433624],
            [4.881404912388137, -5.812922459120507],
            [4.877674305971422, -5.820242291719696],
            [4.877421768399981, -5.830206942543316],
            [4.881314684975344, -5.8378217137110155],
            [4.8845598296905655, -5.841915803629665],
            [4.893901791367063, -5.8461563114236],
            [4.900175375960565, -5.852980069710005],
            [4.900715509540491, -5.8579855711025495],
            [4.898069102403892, -5.864707725724874],
            [4.892919633744919, -5.869168283303681],
            [4.884801516457289, -5.872321742418835],
            [4.87791507322536, -5.872143914946174],
            [4.874256994103624, -5.870202508682027],
            [4.8674251084536335, -5.8634791334235645],
            [4.862247278974714, -5.864752093950293],
            [4.861773845086128, -5.868411321999997],
            [4.8634577543954345, -5.877139990325368],
            [4.862010954277726, -5.88192309173703],
            [4.8586940442181294, -5.88777823023101],
            [4.858084163695783, -5.892047959928328],
            [4.860940851426659, -5.897141816996658],
            [4.865984888639042, -5.90215794974773],
            [4.875060730842016, -5.906724458458955],
            [4.880005394684748, -5.911104771923779],
            [4.883439723158821, -5.912606198889983],
            [4.893869804255661, -5.911923671046031],
            [4.900575704213494, -5.9124470217155505],
            [4.909162417807855, -5.915584803237706],
            [4.91941865517653, -5.921478450070209],
            [4.925663822425645, -5.928478886138016],
            [4.926388944780313, -5.9315678193054415],
            [4.925727392509959, -5.9431333443061725],
            [4.923955629489186, -5.946757447735626],
            [4.917467580659739, -5.952980303918221],
            [4.9105813522862, -5.954753829792329],
            [4.902755126121886, -5.950664317506725],
            [4.901221905410144, -5.947916907434823],
            [4.899830637204397, -5.933936898750535],
            [4.896501713612675, -5.9299763498813265],
            [4.889157557398899, -5.929318656656022],
            [4.885828116246209, -5.93238404063072],
            [4.886397645417932, -5.941432827101121],
            [4.878090795670588, -5.95817864733619],
            [4.740836444812301, -5.96551507470577],
            [4.676050107211517, -5.968419232689742],
            [4.674067773351143, -5.93779027306235],
            [4.673016019216587, -5.9069839138224225],
            [4.670893306544126, -5.854292372986082],
            [4.6705642011188715, -5.851023624344797],
            [4.667969286789597, -5.793031030379701],
            [4.673815776109336, -5.786545650258551],
            [4.671408496430074, -5.782679319141314],
            [4.673294027287459, -5.778057850054698],
            [4.678181733937052, -5.776971387182996],
            [4.678374190410713, -5.774643603499511],
            [4.682653033839259, -5.7731991127818585],
            [4.686016427545618, -5.768199125064716],
            [4.684113934073437, -5.760632135645635],
            [4.688735107672693, -5.753799730774976],
            [4.688332858894292, -5.750536871372361],
            [4.684655694274459, -5.744992495472806],
            [4.69121864108025, -5.729447555965133],
            [4.690937929708904, -5.725928357453679],
            [4.693541527974816, -5.71988571808377],
            [4.696069680516503, -5.718372714537691],
            [4.695323679182727, -5.712074786546245],
            [4.698535712537502, -5.702168144650634],
            [4.699664767559911, -5.69487569925481],
            [4.6989649131746045, -5.691537878698761],
            [4.703386236654712, -5.6849331119238],
            [4.7008430470299, -5.650790627369995],
            [4.699721419635338, -5.6214500159884855]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.81319854537168, "lat": 32.87982631242733 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28125"],
        "coty_name": ["Sharkey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sharkey County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00695783"
      },
      "bbox": [
        4.667969286789597, -5.968419232689742, 4.926388944780313,
        -5.520973584948704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.156015794426198, -7.62935485625776],
            [6.242562411700676, -7.623266801681502],
            [6.329108094126677, -7.617165576161891],
            [6.3514112476905105, -7.615524816315893],
            [6.448124159577839, -7.6080238817178],
            [6.544835694991669, -7.600506475366238],
            [6.55042611309177, -7.670185966714774],
            [6.558405356936161, -7.774083264787398],
            [6.562777635035187, -7.831824928887542],
            [6.492408896379973, -7.837137893426205],
            [6.4035548496013295, -7.843778477971465],
            [6.349026198007687, -7.847762329911724],
            [6.258562784088123, -7.853993937436097],
            [6.2606113253194255, -7.883230516258163],
            [6.252484377218415, -7.884139095035914],
            [6.173871759112406, -7.889232065350867],
            [6.164325428139808, -7.752250084445818],
            [6.159609618061155, -7.6811981728479415],
            [6.156015794426198, -7.62935485625776]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.11765553871227,
          "lat": 30.789963399684137
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28131"],
        "coty_name": ["Stone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stone County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00695786"
      },
      "bbox": [
        6.156015794426198, -7.889232065350867, 6.562777635035187,
        -7.600506475366238
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.344322727313891, -7.2428996960239305],
            [5.358336948284238, -7.242057906780897],
            [5.358835171612521, -7.241953120976628],
            [5.459054151587869, -7.235489896023315],
            [5.473152196749778, -7.234476439760166],
            [5.473622547011545, -7.24183083880091],
            [5.488306056814831, -7.241106007894573],
            [5.489044143413014, -7.248370840388523],
            [5.496300198863434, -7.247895490718512],
            [5.496798751170111, -7.25505519878194],
            [5.521803910574431, -7.2534091745794],
            [5.521497927889339, -7.249941602799196],
            [5.525153914262837, -7.249705317652706],
            [5.525014243246501, -7.246281226670444],
            [5.531988594701067, -7.245652600142657],
            [5.538486983959194, -7.347088539456361],
            [5.545713704924565, -7.3466112777441355],
            [5.549361219538981, -7.404425312776295],
            [5.571289144923652, -7.403176742708841],
            [5.574199472300004, -7.446166061162359],
            [5.581187490630993, -7.445395243237071],
            [5.631849627640529, -7.441888704412017],
            [5.6331885680197855, -7.4635260981102824],
            [5.640615976475668, -7.463046452164781],
            [5.642036951892839, -7.4848232504258],
            [5.64929670919565, -7.484285817544484],
            [5.650259464734597, -7.498805281636882],
            [5.682314484639351, -7.496685714492043],
            [5.70789247957126, -7.4947553510988],
            [5.722722927138605, -7.49392333921932],
            [5.727430443565947, -7.566237789894349],
            [5.709561151920781, -7.5673706022274265],
            [5.6531000447209685, -7.571600345278755],
            [5.610733741582462, -7.574331974528482],
            [5.608473476746252, -7.5741753233557425],
            [5.562329462500551, -7.577565691802591],
            [5.44745215392851, -7.58481173974444],
            [5.366207627151411, -7.59008863711887],
            [5.3589944337374105, -7.478045885054908],
            [5.354751528363504, -7.416299432228189],
            [5.350252450676304, -7.340752898101467],
            [5.348848803315129, -7.32136654079317],
            [5.346067195005357, -7.275843506422947],
            [5.345130395308805, -7.2645302767432485],
            [5.344322727313891, -7.2428996960239305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.10612499790263,
          "lat": 31.148413499320643
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28147"],
        "coty_name": ["Walthall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walthall County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00695794"
      },
      "bbox": [
        5.344322727313891, -7.59008863711887, 5.727430443565947,
        -7.234476439760166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.020390749870993, -5.438428880075356],
            [6.106634909577901, -5.431802135223604],
            [6.1007197480233275, -5.3436734128740175],
            [6.170788559869771, -5.338479387994774],
            [6.187347808655846, -5.336937947176715],
            [6.184070592322027, -5.2897270782276165],
            [6.183158782843513, -5.2844323009910115],
            [6.180951125417479, -5.24908388251416],
            [6.198032663175838, -5.247780221485716],
            [6.299300064961856, -5.240262966337113],
            [6.353669790131381, -5.235980494337648],
            [6.4258935394459025, -5.230496327549953],
            [6.4343814563458235, -5.343358189926092],
            [6.440334805122755, -5.427626369287457],
            [6.444604256107512, -5.481896653718188],
            [6.453525306588568, -5.590610388995174],
            [6.368937738864213, -5.596313693675309],
            [6.355509068134143, -5.597235435187947],
            [6.356101619859882, -5.604657595234167],
            [6.327225699536178, -5.606927386675624],
            [6.326599383358248, -5.599475601449448],
            [6.28303669542839, -5.602867156155409],
            [6.282645232914798, -5.597935453347662],
            [6.157182265928852, -5.6063617306795335],
            [6.089305171423175, -5.61129786513868],
            [6.0539835682643135, -5.613590897005887],
            [6.031830578987966, -5.615578951879893],
            [6.026404724788791, -5.533437358187379],
            [6.020390749870993, -5.438428880075356]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.03441648543983, "lat": 33.08849374010388 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28159"],
        "coty_name": ["Winston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winston County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00695800"
      },
      "bbox": [
        6.020390749870993, -5.615578951879893, 6.453525306588568,
        -5.230496327549953
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.188365332686377, -6.389026929882666],
            [9.189579389969575, -6.3871927833419555],
            [9.18737962356233, -6.380872309111046],
            [9.190053613308633, -6.374232362241275],
            [9.190919006987091, -6.3690069535929625],
            [9.193371804504368, -6.365772442284815],
            [9.19242205023139, -6.357109015768584],
            [9.198561375257823, -6.351265621368507],
            [9.198054756885558, -6.346648883973982],
            [9.202569058302293, -6.34181030069653],
            [9.204667987911883, -6.3353467682951905],
            [9.210446997522515, -6.328594682009573],
            [9.212641169179825, -6.320871439464604],
            [9.216350532013625, -6.317798855780395],
            [9.218742981322732, -6.312196344181659],
            [9.22079988198983, -6.310774433159039],
            [9.223975844990305, -6.3042110092207455],
            [9.223551502869237, -6.294819228615827],
            [9.22466737907769, -6.291704357439117],
            [9.228910010999241, -6.287349698441301],
            [9.231512923397554, -6.2778797464457785],
            [9.229877297781528, -6.27156751174222],
            [9.23459120972728, -6.2663748248784135],
            [9.240340043500003, -6.266147974569165],
            [9.27579284380527, -6.2611576950973],
            [9.27888959923023, -6.263829098543131],
            [9.282771248607936, -6.258899436551781],
            [9.297237731746332, -6.257149712746113],
            [9.295411288671936, -6.242918576138974],
            [9.30601856013473, -6.241348628300441],
            [9.33062565358954, -6.238930868739466],
            [9.329306618151884, -6.230936741113367],
            [9.336088063005885, -6.230087071118851],
            [9.337397675852683, -6.237975683672266],
            [9.365899164188269, -6.234223354609533],
            [9.363411400689786, -6.21465707562279],
            [9.360231162957069, -6.197650264059195],
            [9.354978499259287, -6.13105180387135],
            [9.352888585244107, -6.110606669371313],
            [9.367446251977865, -6.108886909251411],
            [9.366475028312362, -6.10175478883526],
            [9.49395181608147, -6.085860754393354],
            [9.49278180345946, -6.0908749310682095],
            [9.496517798400731, -6.097642560197487],
            [9.502430953328547, -6.1025146113413555],
            [9.512923112115406, -6.105275478023739],
            [9.514728702845556, -6.108241434880326],
            [9.507083177780064, -6.109348090974366],
            [9.507510365523464, -6.1136053482392185],
            [9.516898835197377, -6.112131609874902],
            [9.51688551987755, -6.115692402300209],
            [9.520913178687021, -6.117170762726853],
            [9.52081053363092, -6.119853570584632],
            [9.52399736936849, -6.125736364515902],
            [9.523114975778117, -6.127795317611179],
            [9.530805763297698, -6.134916820021204],
            [9.53903358147829, -6.134995315523243],
            [9.543566260948051, -6.142061185165641],
            [9.553417013947344, -6.14591858177171],
            [9.55272182928912, -6.1484150865461284],
            [9.55711238697531, -6.151855770750959],
            [9.554687770964339, -6.156186762071811],
            [9.557598415844717, -6.157675494036364],
            [9.559012854279022, -6.162629441377557],
            [9.564660837579702, -6.164890074085636],
            [9.572357306213682, -6.163666260983395],
            [9.624649639838546, -6.157362314954122],
            [9.623981401237529, -6.150215667077704],
            [9.631002811994051, -6.1492331742305],
            [9.631666987206756, -6.156412499558156],
            [9.672615150541697, -6.151195440352316],
            [9.673139179371182, -6.160086576813471],
            [9.672161531331314, -6.167741052586105],
            [9.67579323577303, -6.173434250530678],
            [9.676833549112889, -6.1772227918888865],
            [9.676435869835014, -6.185674032832131],
            [9.682906537015242, -6.190603737352599],
            [9.679487669900878, -6.193040501033359],
            [9.679457774108236, -6.203047915205534],
            [9.673203099833168, -6.210377621755831],
            [9.670715148575757, -6.223014578088844],
            [9.671108874109743, -6.228097483337039],
            [9.669516489897836, -6.233407354641623],
            [9.674921378736936, -6.243344064818366],
            [9.673766029532468, -6.247297457355447],
            [9.669017592559877, -6.251060011252025],
            [9.661412550887972, -6.253641742769642],
            [9.658933836830952, -6.258651278868771],
            [9.66405283715221, -6.270530744697835],
            [9.66758821708745, -6.275351940386924],
            [9.661778808239319, -6.2802404899188],
            [9.65806455783789, -6.287803701136886],
            [9.652992755435898, -6.2909983411845305],
            [9.650491046801665, -6.300231309652468],
            [9.642141079373099, -6.306715200771397],
            [9.645348235494337, -6.310167043813121],
            [9.64467935399715, -6.317084625924024],
            [9.645963065634225, -6.3213543603015285],
            [9.643509659240223, -6.3251528383395765],
            [9.627675887058734, -6.327263208539879],
            [9.62668381411606, -6.328984558949233],
            [9.631913773049535, -6.337433109058996],
            [9.633033042104099, -6.343436043251293],
            [9.629640063760887, -6.350153931108407],
            [9.628747223796383, -6.357893681532579],
            [9.625559333543933, -6.361975693406119],
            [9.628182322867954, -6.369212513922714],
            [9.62905306925458, -6.374540723271236],
            [9.626364456288744, -6.381479646592219],
            [9.629133059197109, -6.3862887233354995],
            [9.634928481732912, -6.391149192143871],
            [9.634358272810433, -6.395291906127538],
            [9.637673397483436, -6.401993544554283],
            [9.637417499737758, -6.4115682823983455],
            [9.639216610084635, -6.427136477854861],
            [9.63284150707247, -6.438312471883249],
            [9.633837579126029, -6.439708633491747],
            [9.64746040048309, -6.449805418596528],
            [9.647684587396748, -6.456342798270544],
            [9.640296567367843, -6.451225850145348],
            [9.628346045911012, -6.447359356232094],
            [9.61950873444121, -6.449772311551152],
            [9.617665309605988, -6.453424889299521],
            [9.618453373508345, -6.456913531369953],
            [9.612285368304068, -6.461717890729123],
            [9.607843705146227, -6.469378167831688],
            [9.604609811828391, -6.470457853672662],
            [9.594976490426232, -6.477245161751791],
            [9.589628461453492, -6.482201182796584],
            [9.584845921349482, -6.482928238816202],
            [9.583283986703538, -6.485037791523026],
            [9.581292550136363, -6.500910899433703],
            [9.581843152091107, -6.509475878482892],
            [9.58415247925288, -6.515656000625221],
            [9.579546151945507, -6.524277275129486],
            [9.550882802155483, -6.526055046114887],
            [9.499308602896775, -6.530640684421857],
            [9.479768114505848, -6.531968329042564],
            [9.469430074351116, -6.533461504577949],
            [9.463271620003411, -6.533615799088418],
            [9.410746429922611, -6.538936252309221],
            [9.413697607807796, -6.5637316148236176],
            [9.415706319883038, -6.585501428759477],
            [9.416894666377944, -6.593012532203536],
            [9.420141595210819, -6.625426246624574],
            [9.34966340511555, -6.632419199838403],
            [9.296683333939601, -6.64049501612286],
            [9.23485903743445, -6.647514629373285],
            [9.177129654148276, -6.653451005327239],
            [9.140602942103296, -6.65740603363199],
            [9.149535154797471, -6.6507834512628845],
            [9.154580343953322, -6.641529448248099],
            [9.155708899752794, -6.629922653473029],
            [9.161000046439897, -6.622800109885338],
            [9.162968247677165, -6.617850722445241],
            [9.163065717754762, -6.612387599828308],
            [9.160384190070587, -6.6087825572279275],
            [9.16244290926189, -6.605078454573704],
            [9.160134406424993, -6.597008719091173],
            [9.158736291910593, -6.5824359477304455],
            [9.155747856818051, -6.580505374461343],
            [9.157509294491446, -6.575328662379046],
            [9.161067277748888, -6.57508118940137],
            [9.162166630497671, -6.568787429451443],
            [9.166607411335136, -6.563536673626379],
            [9.163561838186583, -6.56095609137815],
            [9.166129213930967, -6.553929244375286],
            [9.16464328987003, -6.550962330767686],
            [9.166856321718697, -6.5478938677649206],
            [9.164635081994234, -6.540753647693067],
            [9.166102365991591, -6.533187590959357],
            [9.170885938782275, -6.5238985768909625],
            [9.184324624180263, -6.513749071023113],
            [9.189957022059758, -6.5086776146167225],
            [9.192877859102094, -6.4963774675142005],
            [9.19162188319838, -6.489292422622631],
            [9.194032666540753, -6.486733894795956],
            [9.18645867125654, -6.474485559979631],
            [9.18631894726744, -6.470290936048394],
            [9.182687141947754, -6.463622353170638],
            [9.182201995868597, -6.457946889411011],
            [9.18333844912521, -6.454609718326035],
            [9.180717270255164, -6.45065364175453],
            [9.182781322793721, -6.445737814722142],
            [9.182317827711936, -6.441508568355875],
            [9.184384622676152, -6.435165324640283],
            [9.17963120731336, -6.424499438788712],
            [9.174609063733252, -6.418669185063347],
            [9.176002847628666, -6.410350934410916],
            [9.178758838098437, -6.408418303192519],
            [9.181702178308678, -6.400070128241816],
            [9.187501420878085, -6.391973967525497],
            [9.188365332686377, -6.389026929882666]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.39323505553921,
          "lat": 31.869595430556192
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01005"],
        "coty_name": ["Barbour"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barbour County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00161528"
      },
      "bbox": [
        9.140602942103296, -6.65740603363199, 9.682906537015242,
        -6.085860754393354
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.85166201603376, -4.795696933324813],
            [8.85198645638406, -4.802825482674115],
            [8.838087682523646, -4.804379251588561],
            [8.839061378911802, -4.819227770733386],
            [8.824545607020783, -4.82076282940943],
            [8.825242463120432, -4.82809632712437],
            [8.911778108846182, -4.818917659957868],
            [8.910272218114013, -4.804658811568897],
            [8.924336791664583, -4.8033075490853925],
            [8.922868877367334, -4.788209327647626],
            [8.993129988252582, -4.782597226413176],
            [9.02355913043228, -4.7800307945748335],
            [9.024631244086185, -4.794836387270134],
            [9.028781823510595, -4.83426980209279],
            [9.033265086239949, -4.889377522187023],
            [9.034696960856934, -4.9168741624355],
            [9.03704930443461, -4.9518165953604125],
            [9.044326281730477, -4.951305131767217],
            [9.044704483039018, -4.954725700125506],
            [9.041082648698826, -4.9550700034655515],
            [9.041431837064854, -4.9586460512430985],
            [9.045028041508367, -4.9581885149728775],
            [9.046044424548075, -4.9692517934164115],
            [9.038570313728323, -4.9698694464884285],
            [9.041207915328272, -4.99828174894225],
            [9.045405265284284, -5.049380580635442],
            [9.049102132346118, -5.04908592036254],
            [9.050233710613073, -5.063545061092782],
            [9.046698361276333, -5.063847327364836],
            [9.057759090599312, -5.169022198347122],
            [8.98027568682898, -5.178745296274185],
            [8.959293558540397, -5.181629461500812],
            [8.902761385731141, -5.187934652534959],
            [8.878265832294462, -5.1901460507429],
            [8.808757874847462, -5.197079035034799],
            [8.792223720770057, -5.1988311769890805],
            [8.793918085441682, -5.213548304775892],
            [8.772865688055251, -5.215569654825464],
            [8.765292767325665, -5.216810172116379],
            [8.763655640434541, -5.202487191298425],
            [8.668615792227456, -5.2123648719997036],
            [8.627050755937793, -5.216970757542641],
            [8.625167597947568, -5.195112745572746],
            [8.61884225978287, -5.1258193848671345],
            [8.658496925393662, -5.122489103324473],
            [8.662179140359433, -5.122507769923463],
            [8.657299534710509, -5.066962402346414],
            [8.653501563655468, -5.020770840532549],
            [8.667863184096014, -5.019520678794366],
            [8.736173697042979, -5.0140907390521035],
            [8.767598223914652, -5.010975212519137],
            [8.762676568413648, -4.936468534771736],
            [8.761417132788825, -4.923193757498871],
            [8.775371719749323, -4.922127317262874],
            [8.790512696310525, -4.920241832587575],
            [8.789310361761606, -4.905938493079567],
            [8.803404912511398, -4.904292039235246],
            [8.797964401527882, -4.84597921969195],
            [8.812351563047896, -4.844316983168086],
            [8.808013799181472, -4.800434319076431],
            [8.85166201603376, -4.795696933324813]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.86053117508656, "lat": 33.26902442112119 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01027"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00161539"
      },
      "bbox": [
        8.61884225978287, -5.216970757542641, 9.057759090599312,
        -4.7800307945748335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.841025010442146, -6.791700751265694],
            [6.890864919581111, -6.7877150642381165],
            [6.895529409483903, -6.78701287303169],
            [7.002738924041908, -6.778266032390119],
            [7.158517023785374, -6.764671896061038],
            [7.16074591263504, -6.777619217405529],
            [7.166776102518157, -6.785456369473747],
            [7.168964619114098, -6.792447878587117],
            [7.169546072442624, -6.800532120591457],
            [7.167884270238072, -6.803091522727653],
            [7.160974433367839, -6.805053100527196],
            [7.159594098810734, -6.806856490635146],
            [7.16362491541164, -6.81461953591516],
            [7.164957944732587, -6.8241036459616975],
            [7.167922282610758, -6.832920926850518],
            [7.170735343111393, -6.837849411641318],
            [7.177295087404778, -6.84608866083556],
            [7.176869628063129, -6.85040601850702],
            [7.173363145782437, -6.857029777401876],
            [7.1738166644940895, -6.860255589499115],
            [7.180838762919347, -6.867686335878867],
            [7.1916134948312145, -6.873961154155003],
            [7.199330933859306, -6.877149728414047],
            [7.211341051407482, -6.876231344704394],
            [7.219351727151301, -6.874733733157896],
            [7.2243206303897125, -6.876675786452868],
            [7.228385659011312, -6.88172130182262],
            [7.228131977129041, -6.886291254508642],
            [7.224146469243005, -6.887672602256766],
            [7.216050095868172, -6.8846820408376415],
            [7.210006301071993, -6.885265017813825],
            [7.209905454716193, -6.887516228807874],
            [7.218319490276124, -6.898585581403799],
            [7.229701420929345, -6.905765741551349],
            [7.235776703164577, -6.906648266635675],
            [7.250895716667, -6.914305044270881],
            [7.264325276486057, -6.917334554554524],
            [7.268148368519349, -6.922187867795629],
            [7.272355476624925, -6.924016878587893],
            [7.2956344060316605, -6.925584522576592],
            [7.30392999253697, -6.9324354326552795],
            [7.308923751935021, -6.939245410943573],
            [7.3115294043650785, -6.946095813910309],
            [7.313558892644817, -6.948074707939431],
            [7.328711252600851, -6.955377014885838],
            [7.330003509386979, -6.957954031038755],
            [7.327814792614737, -6.967120947518279],
            [7.325349995174253, -6.973717513777365],
            [7.321541051263959, -6.9801865144081265],
            [7.3211465775522955, -6.983318144482257],
            [7.325577617041341, -6.9975069460317245],
            [7.32570822542938, -7.00030794462146],
            [7.32115058177434, -7.004442536093488],
            [7.313046681236966, -7.006238455013696],
            [7.309574964620465, -7.010255503842201],
            [7.313695922228396, -7.01437730444356],
            [7.321307287843357, -7.013909034321297],
            [7.331522825376391, -7.025178865654201],
            [7.331696621223376, -7.027031991792276],
            [7.32350446320857, -7.03407751717558],
            [7.318805897098447, -7.0428124816567195],
            [7.319914288402223, -7.045447365383464],
            [7.324421483660315, -7.0450373669628075],
            [7.327582881743839, -7.041616470591904],
            [7.336303997376359, -7.043105840019599],
            [7.338449686261415, -7.04561964407133],
            [7.338921773990777, -7.050670794568178],
            [7.33328646193882, -7.054899371481766],
            [7.319861638522768, -7.053995191526936],
            [7.315236362115509, -7.0589868400179805],
            [7.315445730800954, -7.06524263384971],
            [7.311655920632356, -7.069984304296955],
            [7.306003739960131, -7.07373703387428],
            [7.3081296409851335, -7.076592878934902],
            [7.31132716352932, -7.076111263444527],
            [7.319283699117704, -7.071188866687113],
            [7.323504031528795, -7.0705923526583305],
            [7.3288493848393745, -7.074319262082028],
            [7.33037638758674, -7.072935442779439],
            [7.326508204305046, -7.065614607935856],
            [7.328135230875383, -7.060229244152235],
            [7.334698778679622, -7.058362064998673],
            [7.340928686206034, -7.060376804521375],
            [7.346351359503976, -7.067237455691271],
            [7.3544293316687215, -7.0632377428236035],
            [7.351495766623792, -7.075534866998016],
            [7.355561330373386, -7.083508472439982],
            [7.355512118066134, -7.086879638047822],
            [7.352222033146855, -7.091584452150931],
            [7.349889125113282, -7.098999849842152],
            [7.350539591769021, -7.105283315347852],
            [7.345374514403744, -7.111923671039227],
            [7.3437362832803394, -7.117224248609157],
            [7.344337898924386, -7.122013106631605],
            [7.342775592010379, -7.125558834783376],
            [7.338706454755916, -7.126616988330121],
            [7.336002189307698, -7.125108657986164],
            [7.335657604744728, -7.120124167253561],
            [7.340097626792586, -7.114770606397123],
            [7.337734636411157, -7.110909380547232],
            [7.332183172933262, -7.108741192789767],
            [7.3297681841697635, -7.110215871924526],
            [7.32893871239511, -7.115207849332378],
            [7.330767253636026, -7.122378904395091],
            [7.328830473034944, -7.129012457466623],
            [7.329682188466248, -7.136795412742757],
            [7.324969349990391, -7.140864556999099],
            [7.320230782352576, -7.139844371706764],
            [7.316814009450368, -7.136520633942008],
            [7.299636118617475, -7.136031897572296],
            [7.296284031420964, -7.138542619859637],
            [7.296851576028275, -7.143936729991972],
            [7.300653984079364, -7.148771785366214],
            [7.308541712433539, -7.152015364964341],
            [7.311602043368538, -7.1549465620888855],
            [7.312254916112703, -7.1599883195674945],
            [7.30881475832994, -7.165154935767682],
            [7.305515611184839, -7.167118582411115],
            [7.304633717012993, -7.172147396271939],
            [7.308972604488758, -7.179518629419279],
            [7.307568046782836, -7.183793826062259],
            [7.303678829761688, -7.1840641726050505],
            [7.297728408598405, -7.1809672728611655],
            [7.2909784810327105, -7.1825286638665125],
            [7.281837949576617, -7.193936375978676],
            [7.283265325289261, -7.198228074154532],
            [7.286898021989436, -7.197428744801284],
            [7.291993181765811, -7.19322009283919],
            [7.2963863587680295, -7.19411204292956],
            [7.302044930613622, -7.20181875162714],
            [7.307313311931376, -7.203739615409213],
            [7.315830171982521, -7.204261431638853],
            [7.318964763190795, -7.206269391689522],
            [7.32704007881473, -7.218410486426203],
            [7.3315276406803775, -7.222382915997497],
            [7.331426123074895, -7.224938228226419],
            [7.325586515103371, -7.229609221951232],
            [7.3246237051403265, -7.238666021670111],
            [7.318431333919145, -7.243749507837356],
            [7.3174719435123965, -7.249781401680768],
            [7.321158524883755, -7.257397753980315],
            [7.323187435442645, -7.267142335925481],
            [7.322255195528369, -7.27411338315502],
            [7.323454901459015, -7.277830062394239],
            [7.328261885528967, -7.2838516533326],
            [7.326254438360324, -7.288522700378306],
            [7.31889663852737, -7.288488250311376],
            [7.311612353956549, -7.29068432378142],
            [7.3051854501113676, -7.288791442036373],
            [7.301393048752112, -7.289262816103729],
            [7.300750392149516, -7.287719668661082],
            [7.286941491435699, -7.279875601128913],
            [7.260639495620056, -7.311078360019074],
            [7.2303358096003825, -7.31378518826868],
            [7.2268868401343695, -7.314433137493063],
            [7.1125036624824896, -7.323526752674755],
            [7.038215928087414, -7.329929912990309],
            [6.999570457819769, -7.332887386419079],
            [7.000659976824744, -7.350541457827923],
            [7.001830200255667, -7.3621204614852775],
            [6.915005545175018, -7.369096921907196],
            [6.898500748997005, -7.238014506993156],
            [6.898211389682095, -7.232286923174318],
            [6.884518614290922, -7.130167570621891],
            [6.8744583690089565, -7.0511557701210315],
            [6.871327502423616, -7.027802568897604],
            [6.869119556025124, -7.0059019399658995],
            [6.866418183220979, -6.98749126116018],
            [6.851277267591261, -6.867211763182068],
            [6.841025010442146, -6.791700751265694]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.20792856968059, "lat": 31.40760311926274 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01129"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00161590"
      },
      "bbox": [
        6.841025010442146, -7.369096921907196, 7.355561330373386,
        -6.764671896061038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2269552491878133, -2.1733352280748015],
            [3.2367334440971263, -2.1728472254725903],
            [3.2945977298560947, -2.1709190485624648],
            [3.3135164663425614, -2.1708268696222115],
            [3.341732518948014, -2.1698288208260887],
            [3.349530012843981, -2.1701840573746947],
            [3.3693064506474717, -2.1688337886483886],
            [3.401809318558344, -2.167470929265601],
            [3.4757965636374752, -2.16403434575599],
            [3.5284007668939528, -2.161703446663458],
            [3.529545789537473, -2.2175187867471173],
            [3.5306912248092703, -2.225094591483649],
            [3.5308377423337953, -2.2725546848781355],
            [3.5311799817299554, -2.312776586893576],
            [3.5306745784742164, -2.312798038084869],
            [3.5308511266542397, -2.3570179109530014],
            [3.5304595131489225, -2.3717809310861195],
            [3.5309913016494874, -2.401174304343946],
            [3.5328019692234127, -2.4011909680462193],
            [3.5334112163049975, -2.4676532337404455],
            [3.5339744782833913, -2.4893848153130733],
            [3.4908039110568745, -2.4898313474324234],
            [3.491402187128739, -2.531785527261203],
            [3.5048219070917384, -2.5305790945267415],
            [3.5070844252294258, -2.5316239143410897],
            [3.5086162088692165, -2.6060050264199597],
            [3.4370299590841342, -2.6067947026592955],
            [3.4223795077168266, -2.6075399205613046],
            [3.422872464057411, -2.6366758005955697],
            [3.4237004174821575, -2.6690513327531167],
            [3.424107903603821, -2.695332899396108],
            [3.3381580987683086, -2.6968149653805518],
            [3.337115235483447, -2.6091200720558065],
            [3.336311059967612, -2.5365834066792403],
            [3.3221950483388634, -2.5369224141004585],
            [3.3219529721641994, -2.522200018935247],
            [3.3361121530385507, -2.521762447730643],
            [3.3366438430460144, -2.5132629120025487],
            [3.3330882241049733, -2.5089470028705962],
            [3.3288974551739847, -2.508043443066871],
            [3.321294534934263, -2.509092419370861],
            [3.316121995021734, -2.5034015331892148],
            [3.3105870551487504, -2.5076786756033376],
            [3.308629489818483, -2.507641948099618],
            [3.303258114323775, -2.501698314963263],
            [3.294542714931462, -2.4951825890946333],
            [3.286859101618751, -2.4912805055732705],
            [3.278117694113171, -2.4792248286246785],
            [3.2769629070680533, -2.4730039464254463],
            [3.2815519687918355, -2.4656862427352406],
            [3.287217993271685, -2.4621841118667076],
            [3.2929909721066033, -2.457252616135258],
            [3.292501941247078, -2.4520544814301224],
            [3.2840265849543866, -2.4499293991119546],
            [3.278938571921124, -2.444353761423111],
            [3.2790075537036194, -2.4302520289850493],
            [3.2838820939909716, -2.4212559161291867],
            [3.2820679941912534, -2.416242947339728],
            [3.2774731040382243, -2.414998430474038],
            [3.2704356928268763, -2.416437592409413],
            [3.263807666571267, -2.4165429925120043],
            [3.259699037490454, -2.4146013034703246],
            [3.2537902238089567, -2.409178233526461],
            [3.242190958814919, -2.4047210468108635],
            [3.237178060663946, -2.405663227878299],
            [3.2324710432177044, -2.409883876861876],
            [3.2283521677185516, -2.411593134240683],
            [3.2243834253786843, -2.410976594716215],
            [3.2241869972875237, -2.405012384324513],
            [3.231880812945944, -2.394862316902853],
            [3.2353437308071937, -2.391261267275842],
            [3.2385832472765617, -2.383532414543613],
            [3.2389370992776914, -2.3771805249550657],
            [3.2368414758235406, -2.3712673188640183],
            [3.2244292891448563, -2.362203735426315],
            [3.2160774125855776, -2.3603907385075162],
            [3.202807622630248, -2.3683088987467853],
            [3.1985839047736992, -2.3683925948281463],
            [3.1970185990367668, -2.365238644679839],
            [3.199631273122181, -2.35633995420103],
            [3.200524256001817, -2.3501503653671874],
            [3.207400835995339, -2.3392614261606757],
            [3.2122784953664594, -2.337503340495331],
            [3.216822052575701, -2.338378128618062],
            [3.2229051480870736, -2.3433679692300458],
            [3.226826952332375, -2.3445453548679347],
            [3.23065040591116, -2.341715297638604],
            [3.233547528721057, -2.3282608450552855],
            [3.2321950950771297, -2.324661639242412],
            [3.2271971533267463, -2.3224125239871896],
            [3.2194562832763993, -2.324614849492959],
            [3.2144294672002456, -2.325009271915676],
            [3.2062868789347965, -2.3283259130813736],
            [3.191610047671222, -2.332048486544705],
            [3.1874904488340894, -2.329819710126125],
            [3.181478124175833, -2.324567172188081],
            [3.1795809041082252, -2.3191063474164126],
            [3.1834116532421186, -2.3146503697276106],
            [3.195153633099528, -2.3080363623069493],
            [3.2014533414294815, -2.3024568583779326],
            [3.205028061940483, -2.3008187890815583],
            [3.2116524846787056, -2.29518421223849],
            [3.2137467012449674, -2.292087384080074],
            [3.2147995436882106, -2.2865160638607542],
            [3.2279179739375743, -2.2864052356961815],
            [3.2274176479898804, -2.277599828873448],
            [3.2274590687411466, -2.25715278291315],
            [3.228161469000533, -2.2134597484641096],
            [3.2269552491878133, -2.1733352280748015]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.33695874709254, "lat": 36.28716740503131 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05005"],
        "coty_name": ["Baxter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baxter County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00069895"
      },
      "bbox": [
        3.1795809041082252, -2.6968149653805518, 3.5339744782833913,
        -2.161703446663458
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.613822267488789, -2.4624568920572614],
            [4.61319528797511, -2.441115817275275],
            [4.611039514341273, -2.387807406290782],
            [4.611201317109673, -2.38704913236007],
            [4.609857001193909, -2.3441279528110455],
            [4.624241909995697, -2.3437515508406896],
            [4.667453742041134, -2.3399300469070217],
            [4.755062075549651, -2.3375804570708523],
            [4.7837329357989224, -2.3363976213248527],
            [4.783767196405184, -2.337419009017323],
            [4.812590625557025, -2.3364560072621616],
            [4.827002362461332, -2.337485247402269],
            [4.868569000566544, -2.335504284295499],
            [4.87007122909877, -2.3361424137166997],
            [4.91318279696653, -2.3347140161892357],
            [4.941791013787398, -2.333145735074774],
            [4.956621313509397, -2.331923244933044],
            [4.99876444494184, -2.3298487671007244],
            [5.0003806349928555, -2.3590414025014264],
            [4.999550994448538, -2.359104132656101],
            [5.001194891758782, -2.388872973515967],
            [5.043682834495465, -2.386358865885649],
            [5.043844794939115, -2.386070240770507],
            [5.105363769695112, -2.381757522865142],
            [5.101533434766408, -2.3831303557674723],
            [5.100263388556374, -2.3875071226717868],
            [5.095009627567983, -2.396983798625202],
            [5.089775662115425, -2.4008876372570676],
            [5.0823923237994935, -2.3999509284074194],
            [5.075958920575525, -2.4115810020859296],
            [5.075574823067878, -2.4182401477086763],
            [5.072030892617269, -2.426455941282529],
            [5.075488284489812, -2.431585566060221],
            [5.075934577480829, -2.438145621403282],
            [5.0730631874219725, -2.4462749037352114],
            [5.066271027502535, -2.4496892103756185],
            [5.063091133647422, -2.4566172100099206],
            [5.059734191409511, -2.459297477306712],
            [5.053784129091019, -2.4596308543432706],
            [5.049719033373788, -2.4667964481456397],
            [5.044978537999033, -2.4695766246598216],
            [5.039950359195432, -2.470570550663071],
            [5.0286422540626585, -2.4743196284436273],
            [5.024865819857738, -2.4822440915314696],
            [5.024184639195023, -2.4908837044905754],
            [5.019324473890867, -2.494688503541446],
            [5.014450440750994, -2.495233959679186],
            [5.0092933758226765, -2.5001195236460236],
            [5.008270428866484, -2.5030475022778105],
            [5.01070647710291, -2.51464384756833],
            [5.009156357604819, -2.518966973498545],
            [4.9993816682162215, -2.523411247555087],
            [4.997966967684375, -2.5293441740633322],
            [4.9974627859282466, -2.543475253724699],
            [4.989205635091793, -2.5498404999896565],
            [4.989306313302523, -2.556768660215457],
            [4.98737520219243, -2.5604207321462837],
            [4.98714207981321, -2.5667221930731374],
            [4.983041211089431, -2.5741341131861737],
            [4.977685939937327, -2.5791233060490373],
            [4.968006811350228, -2.597783024385927],
            [4.961904574756852, -2.6054771608621827],
            [4.963039563883577, -2.615437110864811],
            [4.961750306072589, -2.61726757741353],
            [4.961450173906787, -2.627724190139841],
            [4.962284604663213, -2.629457466799329],
            [4.860737330116725, -2.634671951970611],
            [4.832892311971507, -2.636261009888968],
            [4.7895244432030255, -2.6384139021698805],
            [4.732963815903823, -2.640874571113906],
            [4.672714162239309, -2.6437060809364517],
            [4.616556150116999, -2.6468707009210006],
            [4.590063430654728, -2.6473095800788715],
            [4.592200525944198, -2.642415096138775],
            [4.593140833179439, -2.636071894242782],
            [4.596778214794079, -2.6368217019831888],
            [4.596969446722964, -2.6314337918658732],
            [4.594539429154585, -2.627808590377421],
            [4.587486493787008, -2.6248891132478818],
            [4.583736323136395, -2.62173487324167],
            [4.586900585893444, -2.619890579619082],
            [4.585860108450245, -2.6125195960450833],
            [4.592658854921195, -2.603558634732676],
            [4.598453241169897, -2.5913475737799647],
            [4.595550262424954, -2.579436731547768],
            [4.5966178200165295, -2.574149245200753],
            [4.606492931501254, -2.5582748497992895],
            [4.606530840119865, -2.544811168012748],
            [4.608937329895834, -2.5333156075235626],
            [4.616987910921666, -2.529708623588938],
            [4.620571820351891, -2.525963258446097],
            [4.6232381371921685, -2.526257782078948],
            [4.629282225948162, -2.5203314105477737],
            [4.6326969788262895, -2.5151161965826137],
            [4.632592795348097, -2.511351059310063],
            [4.642239410375312, -2.5058640890573285],
            [4.646847299484852, -2.502079142319745],
            [4.647230671727611, -2.4993777868081506],
            [4.645808485584174, -2.488191560586014],
            [4.651673412934931, -2.475681929861834],
            [4.663120601413437, -2.463121814021814],
            [4.6636119801083025, -2.4602748526662808],
            [4.613822267488789, -2.4624568920572614]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.55902433804738, "lat": 36.11765938926182 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05055"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00066857"
      },
      "bbox": [
        4.583736323136395, -2.6473095800788715, 5.105363769695112,
        -2.3298487671007244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5859304013347035, -4.311066984757237],
            [2.6093110749727217, -4.310950169334553],
            [2.657841870484315, -4.310267680026126],
            [2.7096001539413446, -4.309950821091162],
            [2.731305061183714, -4.3101393092531195],
            [2.8190297289550315, -4.310147948232719],
            [2.8740279386051446, -4.3093516002072345],
            [2.93313736450873, -4.308367298138929],
            [2.9618649376268467, -4.30816944441781],
            [2.9619717736061735, -4.278645029248647],
            [2.9601399015769565, -4.2481367138946435],
            [2.988257639260933, -4.247874565135745],
            [2.985197059038304, -4.204395051499292],
            [2.985057860529318, -4.189868036384521],
            [3.0137578495120763, -4.189508759072053],
            [3.0277424678912337, -4.189911586858811],
            [3.0847162242504123, -4.189151272387991],
            [3.099113515704431, -4.188451007840387],
            [3.1296012824663064, -4.18796134115876],
            [3.1301598120855982, -4.217426054352161],
            [3.174122713067441, -4.216743590241652],
            [3.175257241260914, -4.275453772108833],
            [3.1896061306249157, -4.275146466030068],
            [3.1907550269233727, -4.377796570155031],
            [3.19197971200852, -4.4511457543090005],
            [3.189776435129897, -4.451183429957457],
            [3.1909768287716354, -4.541415937154045],
            [3.0763622164131985, -4.543068007473659],
            [3.0624566350950637, -4.541743923280554],
            [3.020262242267793, -4.541094446215802],
            [2.9064624328999735, -4.540377646179478],
            [2.9028538663376793, -4.538974560774065],
            [2.9000549709135583, -4.544715264113085],
            [2.894934851275353, -4.545471508166014],
            [2.8923943584382985, -4.542044743931767],
            [2.8932183949511066, -4.5376290163749315],
            [2.891078385711305, -4.534127401182057],
            [2.8902255359129225, -4.526699083218004],
            [2.890745603926495, -4.520152751020028],
            [2.8947477563448603, -4.511433609422728],
            [2.8955702435654898, -4.505621401800897],
            [2.898833419383429, -4.5037326968217695],
            [2.9012909920459116, -4.49964652588716],
            [2.9041409910431444, -4.4980518884337695],
            [2.9023969617419225, -4.492737610711379],
            [2.902678087363168, -4.489086018663723],
            [2.8972902513660075, -4.4850551621875026],
            [2.8988932818072155, -4.478839263926884],
            [2.8939616167913678, -4.4794450680193885],
            [2.893031425713968, -4.474688103051665],
            [2.8962724846285033, -4.471976725438637],
            [2.897184338808394, -4.467834888827417],
            [2.8955675050889043, -4.463745574114154],
            [2.8918321137344947, -4.463260556693623],
            [2.881496824763144, -4.465333085365651],
            [2.8784056332368912, -4.463154762643674],
            [2.8721637067770875, -4.465437253397527],
            [2.861726548450616, -4.465267586509844],
            [2.856413552897866, -4.461515978945878],
            [2.85498860233052, -4.465985671600421],
            [2.8497171628657654, -4.464271988918654],
            [2.8501635674965744, -4.456042452363347],
            [2.760324341362037, -4.456319412269518],
            [2.7604543289969987, -4.426922708214718],
            [2.717202207911398, -4.427070444375087],
            [2.67357568964128, -4.427478272805138],
            [2.630394447440978, -4.4276151732255915],
            [2.6296440770275358, -4.368935194720804],
            [2.5867244265000853, -4.369341154925516],
            [2.5859304013347035, -4.311066984757237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.94613610599782, "lat": 34.31764774078182 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05059"],
        "coty_name": ["Hot Spring"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hot Spring County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00066859"
      },
      "bbox": [
        2.5859304013347035, -4.545471508166014, 3.19197971200852,
        -4.18796134115876
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7215870668980238, -4.219192257712347],
            [1.7218236025300133, -4.1785522228958865],
            [1.7224836199564721, -4.0909699035473315],
            [1.7223279836894358, -4.0829099452310835],
            [1.7233279364914402, -3.996397455723483],
            [1.7276889039858665, -3.9965004540240874],
            [1.8356641664067528, -3.9969131488300746],
            [1.8354877761257828, -4.026112984043389],
            [1.9512895113138018, -4.026490598320863],
            [2.06581641617491, -4.026336656684412],
            [2.065969684435257, -4.035699324680048],
            [2.0884477622056385, -4.035638918013695],
            [2.137519371960715, -4.036649440418884],
            [2.1519418858352375, -4.03737457348677],
            [2.1520284786265793, -4.05154004127384],
            [2.1522624625043867, -4.137706620665498],
            [2.1528973325122562, -4.196931607395383],
            [2.1532779125505326, -4.280305020083369],
            [2.1541875943480377, -4.325877490606175],
            [2.1546857581911523, -4.369072615692465],
            [2.06669546179965, -4.369001068025184],
            [1.9028583604297082, -4.368666303506441],
            [1.8931576815172768, -4.368711862369566],
            [1.8934491324814504, -4.455723973297504],
            [1.9035916462119997, -4.455700582186779],
            [1.905103250915005, -4.532600254055837],
            [1.861984212931471, -4.534222720217181],
            [1.8441255485860644, -4.535110544244838],
            [1.7762498867397163, -4.536890474952068],
            [1.7192679774469948, -4.538132358347934],
            [1.7196371034448168, -4.478818445567999],
            [1.7202754458358804, -4.3754243447936965],
            [1.7204994057551528, -4.367907255589834],
            [1.7215870668980238, -4.219192257712347]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.22820720629238, "lat": 34.48584359582924 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05113"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00069175"
      },
      "bbox": [
        1.7192679774469948, -4.538132358347934, 2.1546857581911523,
        -3.996397455723483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7192679774469948, -4.538132358347934],
            [1.7762498867397163, -4.536890474952068],
            [1.8441255485860644, -4.535110544244838],
            [1.861984212931471, -4.534222720217181],
            [1.905103250915005, -4.532600254055837],
            [1.9477439822093097, -4.531771941574821],
            [1.9766785150900925, -4.531490079026453],
            [2.0244907028901262, -4.531696405961661],
            [2.031697820859063, -4.536093104880439],
            [2.030810534945441, -4.542703442293403],
            [2.0268364600744286, -4.543433032367357],
            [2.0272095016486507, -4.553412162612705],
            [2.024126376902547, -4.555519408744774],
            [2.0266703606635708, -4.5596012457296],
            [2.022870577356995, -4.564891692819817],
            [2.030940091902423, -4.56637129585242],
            [2.0304197315499675, -4.5735253780757565],
            [2.0255691513743646, -4.578544415622114],
            [2.0311593877698684, -4.582188300886206],
            [2.0292501201592286, -4.5850798497740115],
            [2.0245222186146226, -4.583273347944563],
            [2.0217504197869234, -4.584909946739966],
            [2.0234954637704132, -4.588646816216038],
            [2.0310693573305363, -4.59019752096829],
            [2.0404881838972693, -4.597187862104387],
            [2.0369817639299574, -4.600578798505226],
            [2.0300785417055747, -4.610933410216829],
            [2.03113697388118, -4.614073805510107],
            [2.0353770189059164, -4.618808012244041],
            [2.0391716669500513, -4.619704256205797],
            [2.0365078638899927, -4.633449409318804],
            [2.0336509952134842, -4.637835402215852],
            [2.0335347620757003, -4.64230400720274],
            [2.029295891745133, -4.645164379684647],
            [2.032794196470247, -4.6485942430826865],
            [2.0370980480375, -4.650166448999844],
            [2.039505284250581, -4.653610843834708],
            [2.0450215857442315, -4.650568514603834],
            [2.0473921789510463, -4.654537773418425],
            [2.046909801617526, -4.659040743673401],
            [2.0397034766048923, -4.661168872967941],
            [2.0392685362834295, -4.665439723921695],
            [2.036633287735591, -4.669614075613441],
            [2.0403082780392676, -4.6741869868603585],
            [2.038128208019549, -4.67875693702789],
            [2.037159620831185, -4.688504490585129],
            [2.0405149204957445, -4.691952616710924],
            [2.038199311301048, -4.694889882455272],
            [2.041619792271956, -4.700525216557711],
            [2.04157061395553, -4.703906028447148],
            [2.0450221391536783, -4.705405389287729],
            [2.044521458096606, -4.708628536092829],
            [2.05072838753495, -4.712443404903939],
            [2.0491709899298387, -4.721314351070698],
            [2.054426624408888, -4.725638167035355],
            [2.0530420386448767, -4.72832773924084],
            [2.055072923328632, -4.7337913305602015],
            [2.05549179334694, -4.744830278687478],
            [2.0563570544968477, -4.749748822880593],
            [2.060600701218245, -4.754035237620396],
            [2.0604263489153625, -4.762164299335147],
            [2.05682842718854, -4.763670469515675],
            [2.0549566370287993, -4.76801865128527],
            [2.0565524066208245, -4.772730287203428],
            [2.0556441955761007, -4.779713962068015],
            [2.052880552882373, -4.781708061933663],
            [2.0556069961663037, -4.791003865012357],
            [2.05291656628793, -4.796206745542594],
            [2.057589532627229, -4.808049393558416],
            [2.059213376509258, -4.808128890010198],
            [2.061577953917334, -4.815571607964846],
            [2.0642047507550547, -4.814487909414169],
            [2.067361820267794, -4.819362764099003],
            [2.0655983755140768, -4.823050662152279],
            [2.0664219164423656, -4.828120594364414],
            [2.0699419560082837, -4.8331002366761915],
            [2.069518900844643, -4.838012741869182],
            [2.071470618793886, -4.84105327950494],
            [2.0770846112457866, -4.842534667674327],
            [2.0862240396702236, -4.847415934918487],
            [2.0881641592304585, -4.846530456499897],
            [2.0930990155480607, -4.848612089489689],
            [2.097992379246152, -4.854997530499274],
            [2.0949031326427527, -4.861059673444101],
            [2.0943028996971123, -4.865556989157697],
            [2.0994098874938296, -4.869846357867086],
            [2.107133379255817, -4.878067467163299],
            [2.106941619890468, -4.881728893789645],
            [2.1114442954562347, -4.884343329103544],
            [2.1100810517111133, -4.8880192041380806],
            [2.1175839134203946, -4.8916074481635325],
            [2.118303382097355, -4.894460530641749],
            [2.123617956025532, -4.901651011412328],
            [2.1308975605980214, -4.9074411307991115],
            [2.135326494726984, -4.914673468693349],
            [2.1375482152873047, -4.921328025099165],
            [2.1430060019691513, -4.927184622276919],
            [2.141291370326955, -4.934718805136976],
            [2.1465454229025096, -4.936580130448656],
            [2.1430237057855397, -4.945435630853887],
            [2.139555559854294, -4.948323168818189],
            [2.139727248474929, -4.956095739480835],
            [2.141456200559127, -4.960958241096394],
            [2.1439447498254123, -4.960900146090503],
            [2.147998515879192, -4.967008620389185],
            [2.148426474223484, -4.971081630811072],
            [2.1093463144935116, -4.970348385420187],
            [2.079986878941297, -4.9702288811840045],
            [2.0801497917394323, -4.941476179718674],
            [2.0425507686059845, -4.941041945366209],
            [2.040209747455367, -4.937539497545479],
            [2.0313226809142035, -4.9366710835445735],
            [2.027189290317598, -4.934411470338656],
            [2.0131922293872697, -4.935031619522009],
            [2.01153633741996, -4.940001808095501],
            [2.00299100175396, -4.937705143145794],
            [2.000610582208715, -4.943721090216895],
            [1.9954614551493317, -4.943333645761486],
            [1.9927898648491575, -4.939741924890204],
            [1.9928707391540328, -4.935990245230684],
            [1.9894497094550496, -4.9331306163716215],
            [1.98611551710051, -4.935306151531599],
            [1.9870112463436762, -4.940319738493348],
            [1.9828634900608366, -4.942140442039112],
            [1.9790761808194204, -4.940131649917019],
            [1.977195687748515, -4.93392536056527],
            [1.9718129975448304, -4.929946299581345],
            [1.9679924412640741, -4.935805242003992],
            [1.9636430274007206, -4.937059667527855],
            [1.9602211661498457, -4.9399584487798505],
            [1.9567810854330756, -4.937297560888996],
            [1.9610593969634735, -4.930391572246574],
            [1.9591611383012992, -4.923128048968457],
            [1.9620553196998496, -4.919209305313633],
            [1.959962414349094, -4.913963993178092],
            [1.9553240949199422, -4.913466841088223],
            [1.949965922889528, -4.916363914776082],
            [1.9399049745071135, -4.918570013647105],
            [1.9376926806023291, -4.922828498338123],
            [1.9335993995953762, -4.921894244741833],
            [1.9329547771180235, -4.911443472041838],
            [1.930015997510938, -4.91049848569347],
            [1.9286104560217159, -4.914901368327979],
            [1.9242050440720115, -4.918553856473533],
            [1.9250854058403097, -4.922791644224206],
            [1.9160820581301392, -4.923248454182526],
            [1.9164912090197208, -4.9193862940090005],
            [1.9060175986692145, -4.913964668118805],
            [1.9047887005557875, -4.908212163369335],
            [1.899750514133918, -4.909430601444644],
            [1.8962353868191157, -4.907256143118271],
            [1.892033576957443, -4.9097377342425395],
            [1.8889986951018813, -4.904940241591516],
            [1.8853003297314672, -4.904497217136298],
            [1.8822537806104678, -4.89807035977571],
            [1.8784999984840103, -4.897051797590872],
            [1.8751328267921141, -4.898571904570081],
            [1.871006974921852, -4.903857812684936],
            [1.8657099920866176, -4.906015289008372],
            [1.863533837558094, -4.901631130156961],
            [1.8686757646334566, -4.90040409929377],
            [1.8678433033328439, -4.896995823508393],
            [1.8625728890267195, -4.895826885091942],
            [1.8609208897204375, -4.892735237195707],
            [1.860551010875436, -4.883540240334383],
            [1.8626543771141444, -4.881367562089607],
            [1.8637541820430779, -4.876576425584195],
            [1.8597128191594716, -4.873328335699347],
            [1.8558587854859323, -4.8745090118435535],
            [1.851826881635637, -4.871674958638677],
            [1.8432242572899886, -4.873952669781007],
            [1.8434204503664111, -4.870872216921401],
            [1.8490943989607158, -4.867344024113588],
            [1.846496600822375, -4.864456257731988],
            [1.8409392851420439, -4.867019478482363],
            [1.8365920305392047, -4.86677827269451],
            [1.8321982311438534, -4.857157786858359],
            [1.836374739570761, -4.849879492599967],
            [1.8306016281730995, -4.845492310271318],
            [1.8243049420316502, -4.848379588788054],
            [1.8170392390501526, -4.850406558593675],
            [1.8129885508488202, -4.849762377221219],
            [1.8059388335728246, -4.850951306950929],
            [1.8034644574043206, -4.847300914642162],
            [1.8088652601920359, -4.847149429573695],
            [1.813593818778538, -4.842013287278614],
            [1.8127268908773655, -4.840015163274373],
            [1.8073872842468073, -4.83751833064755],
            [1.8032393185003752, -4.8369716844903525],
            [1.797956558942449, -4.834153955110051],
            [1.7906553217434236, -4.8329824148383755],
            [1.7918846035783156, -4.822130210628244],
            [1.7939909820614117, -4.81785548902262],
            [1.7940592681113732, -4.8128260067800115],
            [1.7920945800176589, -4.80906085866299],
            [1.785161473224307, -4.809830445698782],
            [1.7814099110686985, -4.802271493095913],
            [1.784941593228283, -4.800838564671658],
            [1.7882160178661686, -4.804247528107715],
            [1.7928502593522875, -4.802840834646849],
            [1.7980387110139526, -4.794791332803873],
            [1.7972541545253755, -4.790767099570864],
            [1.793077915264437, -4.787252168289084],
            [1.7885091828846162, -4.7882421323773725],
            [1.780831114028788, -4.787657354722955],
            [1.774153882116985, -4.783255491043296],
            [1.7657084753419756, -4.784367983286633],
            [1.7630930869223467, -4.78921705703502],
            [1.7692050144425586, -4.791888059200534],
            [1.770823122463637, -4.79880152632049],
            [1.7699348411043907, -4.802517388684848],
            [1.758840806151038, -4.800213978292091],
            [1.756905018519969, -4.797274759032547],
            [1.7523982943621137, -4.796842771228101],
            [1.7463594250518706, -4.798299165392213],
            [1.7435655577898117, -4.7922247466860215],
            [1.7373831638894937, -4.796175992488561],
            [1.7311417019704198, -4.792375027861541],
            [1.7290838985129302, -4.787016125384604],
            [1.7265019758330018, -4.784718082854047],
            [1.7210828928216255, -4.7896458954990795],
            [1.717518250644932, -4.788588341045163],
            [1.7175504055174984, -4.772013556925688],
            [1.7182039703126344, -4.707217568745109],
            [1.7187188081083935, -4.625748148014833],
            [1.7192679774469948, -4.538132358347934]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.24114348082443, "lat": 33.9972344727088 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05133"],
        "coty_name": ["Sevier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sevier County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00069182"
      },
      "bbox": [
        1.717518250644932, -4.971081630811072, 2.148426474223484,
        -4.531490079026453
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.466588945702061, 0.7620516701252603],
            [-6.360671243360861, 0.752231695217076],
            [-6.311391767545959, 0.7474054223114657],
            [-6.205764795485295, 0.73741024759475],
            [-6.182800465710187, 0.7353008335780992],
            [-6.098089000549818, 0.7275055739200875],
            [-6.033027982594478, 0.7218945712820226],
            [-5.942369350314408, 0.7130478709704795],
            [-5.899631244642303, 0.7091745730778234],
            [-5.803708315034249, 0.70064384093734],
            [-5.771478568514725, 0.6982356273817134],
            [-5.715341664432727, 0.6926852008998524],
            [-5.728920175831238, 0.548187035564426],
            [-5.7314089121485825, 0.5176310226008967],
            [-5.740533664694721, 0.43212331377291124],
            [-5.747113137391066, 0.34533533207306866],
            [-5.752689316177045, 0.25630800720722946],
            [-5.754852191434272, 0.2436118340155458],
            [-5.769171139224594, 0.08345088107580564],
            [-5.791716162760994, 0.08541204740996679],
            [-5.796933894970404, 0.08542129567324876],
            [-5.843254789896038, 0.08911276797951413],
            [-5.845053397300815, 0.08943969768837313],
            [-5.9397202021502205, 0.09686292236545335],
            [-6.046341040583273, 0.1055653069372424],
            [-6.20017414703822, 0.11907748267519684],
            [-6.225101521974984, 0.12102229121041677],
            [-6.281687414308011, 0.12591934662943158],
            [-6.343469391687157, 0.13205854296503353],
            [-6.395963217155498, 0.1368219291701491],
            [-6.418704319139055, 0.139402357126311],
            [-6.447452969850758, 0.1420924746644349],
            [-6.45414260768937, 0.14199616209196522],
            [-6.450052333085605, 0.1902658510921261],
            [-6.4463903344554945, 0.23156904023332353],
            [-6.442275209686196, 0.2732995926267361],
            [-6.437917226731367, 0.31967915109618983],
            [-6.435977798570407, 0.3195478917605584],
            [-6.4340505587230865, 0.3337728262152049],
            [-6.426591516095093, 0.42030825438883784],
            [-6.43324408194577, 0.42298071897065925],
            [-6.468525493085931, 0.4263118505340398],
            [-6.484625495324672, 0.4271024452751264],
            [-6.494946584430337, 0.42832043607989534],
            [-6.514289812031699, 0.43160840601428874],
            [-6.527991379923146, 0.4328245843874658],
            [-6.527388589869028, 0.4419138074349416],
            [-6.51915110494166, 0.4902622751360968],
            [-6.516866498441828, 0.5025516093431387],
            [-6.48788725350674, 0.49933134677150853],
            [-6.48440933004121, 0.5284042206915062],
            [-6.48315657708814, 0.542861072096197],
            [-6.478389250259256, 0.5861815521720677],
            [-6.4756946152171695, 0.6164708026126541],
            [-6.476356195820484, 0.6309927873359712],
            [-6.473273723003264, 0.6456295245601732],
            [-6.471398484471613, 0.6602574491843771],
            [-6.466588945702061, 0.7620516701252603]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.52535802981652,
          "lat": 38.83211283221185
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08041"],
        "coty_name": ["El Paso"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["El Paso County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00198135"
      },
      "bbox": [
        -6.527991379923146, 0.08345088107580564, -5.715341664432727,
        0.7620516701252603
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.353304820320115, -10.679282788633184],
            [13.450786253092767, -10.665195161982513],
            [13.54826361822231, -10.651078569896228],
            [13.547894370736957, -10.643813148195656],
            [13.555695035187336, -10.642724747826872],
            [13.556803202891945, -10.649726064301513],
            [13.61505026016427, -10.640695285164156],
            [13.601042074619164, -10.555208094946083],
            [13.634152146974408, -10.550015357447364],
            [13.688860160526396, -10.541041167991517],
            [13.6745279518352, -10.456319500676619],
            [13.74037822444516, -10.445566103892956],
            [13.8574769842777, -10.426638891567466],
            [13.876912762529154, -10.428372012317373],
            [13.879786671122972, -10.42929095212327],
            [13.88083525740881, -10.434500543624893],
            [13.884745067792501, -10.436318080878333],
            [13.886543467069618, -10.432513801424516],
            [13.890552187658562, -10.43351835069519],
            [13.895010710905714, -10.43855674545996],
            [13.899924073205163, -10.440580142798307],
            [13.909493558502417, -10.439909294645487],
            [13.910415533416286, -10.454434733595038],
            [13.915561041920638, -10.45878127928882],
            [13.920480706255223, -10.45656639618],
            [13.920499456842418, -10.460162822113936],
            [13.92777262541787, -10.461666165793597],
            [13.934052967878207, -10.457124838555163],
            [13.940956176278524, -10.465261433349697],
            [13.946335002003005, -10.467928599503487],
            [13.945213825214962, -10.472954399996008],
            [13.947582305868098, -10.475541050921837],
            [13.951745418202751, -10.520332696032646],
            [13.952548468733273, -10.526068804550981],
            [13.964403217046886, -10.659070265903491],
            [13.96359430175128, -10.668777919909575],
            [13.954414694633765, -10.743587951242182],
            [13.945223807244776, -10.818364662700038],
            [13.941286535392274, -10.850319400784546],
            [13.912549200201747, -10.855106219960366],
            [13.819083376577806, -10.870193857155414],
            [13.739147842004238, -10.882711564537418],
            [13.728039254506031, -10.884191582510782],
            [13.61614614106905, -10.901124928251678],
            [13.506843377065604, -10.917664438894366],
            [13.504293226655822, -10.903557484340887],
            [13.482610748077683, -10.90683631810678],
            [13.484710191878694, -10.920935465343918],
            [13.455341678863016, -10.925241542725951],
            [13.390148285501795, -10.934463720791152],
            [13.377792348869432, -10.85000366884463],
            [13.3655199526855, -10.765076205765387],
            [13.353304820320115, -10.679282788633184]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.18902182557123,
          "lat": 26.956380816265224
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12043"],
        "coty_name": ["Glades"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Glades County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00295743"
      },
      "bbox": [
        13.353304820320115, -10.934463720791152, 13.964403217046886,
        -10.426638891567466
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.325512748688658, -7.755733187257751],
            [11.397423396652723, -7.74636248697173],
            [11.425861100194323, -7.742463388911225],
            [11.428048274957604, -7.741853394381911],
            [11.42395356772383, -7.746283705594312],
            [11.424339398397255, -7.751935389606098],
            [11.429343970242009, -7.756737001489898],
            [11.426034943392903, -7.764099178821814],
            [11.4292318474718, -7.770405971188184],
            [11.438576762926887, -7.773632973943511],
            [11.439098656596508, -7.775718043131949],
            [11.436675420461968, -7.78230661425659],
            [11.43711941088383, -7.787295787395409],
            [11.43367650263321, -7.801208146550536],
            [11.43543320479982, -7.808164923506623],
            [11.435105407263821, -7.8111862780540955],
            [11.436962971812079, -7.8175015307364255],
            [11.441267760712995, -7.823901753282916],
            [11.452578693436474, -7.8306323404773375],
            [11.454546593218115, -7.834079948960033],
            [11.453685687003917, -7.840107604991727],
            [11.450022675851647, -7.84770932535668],
            [11.461245082418454, -7.857102936948178],
            [11.464241286624002, -7.862555375383193],
            [11.465501418397704, -7.883062772952522],
            [11.471202593751597, -7.886502691814144],
            [11.476684985798407, -7.892172436872587],
            [11.479189768336042, -7.892637309410707],
            [11.488343947324987, -7.888807085301276],
            [11.493471874598942, -7.889319816432735],
            [11.496593156181074, -7.891102642995017],
            [11.503491916136536, -7.898182905399791],
            [11.506132837863356, -7.897727921413866],
            [11.50700948615627, -7.893306313327241],
            [11.514333870150644, -7.891886042413162],
            [11.517614465855287, -7.889878261859883],
            [11.519802813367546, -7.881676325790811],
            [11.52247939336718, -7.880213948765182],
            [11.533120401599767, -7.884686378934044],
            [11.538374254231497, -7.883577833319666],
            [11.541844406228073, -7.884711478558021],
            [11.545858824245295, -7.889174858191967],
            [11.550761445269647, -7.887412267797833],
            [11.556017121050054, -7.880574633047768],
            [11.563127197395774, -7.882137743089524],
            [11.56447429236285, -7.890760507289498],
            [11.567331970210457, -7.893075957115798],
            [11.574776023234636, -7.891476928111429],
            [11.579765751313525, -7.892167280429823],
            [11.588735559364967, -7.898173272228211],
            [11.602355634084509, -7.8971216879788315],
            [11.605054483606878, -7.899160157331268],
            [11.60469717939103, -7.9064026364001645],
            [11.609005649035186, -7.913014215093535],
            [11.620298511140403, -7.9160932274610705],
            [11.626573052298095, -7.91947816924631],
            [11.631911522848519, -7.920718743541403],
            [11.63891647412565, -7.928560685483497],
            [11.644699991520431, -7.9293786422003745],
            [11.652876462453136, -7.935835884106033],
            [11.659130361730426, -7.939482421654508],
            [11.664584165550885, -7.94672249114655],
            [11.67069446195478, -7.959252964384746],
            [11.672579236637267, -7.961003690598174],
            [11.67980663566951, -7.962738464819608],
            [11.691529539354713, -7.959815720264337],
            [11.694357780703227, -7.962863353870153],
            [11.697518529190214, -7.969764556666198],
            [11.704121361803228, -7.9696991125981045],
            [11.707467203398249, -7.9719929759519585],
            [11.708718790701846, -7.977989667987434],
            [11.712261328471069, -7.989247022058024],
            [11.715707550047933, -7.994816034103252],
            [11.718723675968668, -7.997148407335273],
            [11.719758964643303, -8.002021171490673],
            [11.72297568507654, -8.004630114573107],
            [11.735836266563615, -8.004351472646674],
            [11.74006649279755, -8.003208522295346],
            [11.74504832047707, -8.010042783087929],
            [11.748286607873824, -8.016309173788505],
            [11.748782369842193, -8.022911326186257],
            [11.752594829822435, -8.028835386494245],
            [11.74921153574391, -8.03468929315273],
            [11.749216435433516, -8.038044428614333],
            [11.75314159320394, -8.039501362728108],
            [11.756335856576614, -8.043331548996662],
            [11.756906406847017, -8.050072702950509],
            [11.763304845058446, -8.052615620940356],
            [11.759635741211126, -8.057175868643943],
            [11.758883435738236, -8.06167398796609],
            [11.764601518898388, -8.06750340627055],
            [11.768073471677079, -8.067310096483125],
            [11.768961255019157, -8.063519687011926],
            [11.768062743557422, -8.058663796998342],
            [11.773647028997425, -8.054506486831196],
            [11.778576426316013, -8.055100974747504],
            [11.78162818410101, -8.058213337831841],
            [11.788245881000012, -8.062456090614981],
            [11.784926432061937, -8.069575394512777],
            [11.790341960121696, -8.071414004197912],
            [11.79349088487171, -8.066465948190917],
            [11.796159305350882, -8.066796173987635],
            [11.798742516598416, -8.075329635533498],
            [11.798045398488123, -8.081125855645073],
            [11.79988651936676, -8.085486300425062],
            [11.798493733613459, -8.09050364568238],
            [11.79298205044858, -8.098649003311422],
            [11.791166107838759, -8.103530951707626],
            [11.790029173450382, -8.111379143446971],
            [11.79058691898802, -8.125269280758806],
            [11.788821471718803, -8.128190245698532],
            [11.781363917565832, -8.130703540531142],
            [11.768724832002256, -8.132648597289483],
            [11.767084975300317, -8.1328134277833],
            [11.734073091332172, -8.137465508219565],
            [11.733770817963991, -8.136107780698014],
            [11.71143906406718, -8.139481131918263],
            [11.698052754473926, -8.141119037776326],
            [11.637222128713688, -8.150133722653912],
            [11.531208835779902, -8.165319193690822],
            [11.4251918598322, -8.180480399207475],
            [11.396028882868308, -8.184750352844684],
            [11.387205625094765, -8.120315696169124],
            [11.371822841281444, -8.122277698093612],
            [11.35651254189168, -8.00622374715317],
            [11.341982320699708, -7.885451014462448],
            [11.334115965736121, -7.827898998689086],
            [11.333800886947298, -7.814053926178687],
            [11.325512748688658, -7.755733187257751]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.18107884564174,
          "lat": 29.985479877226943
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12067"],
        "coty_name": ["Lafayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lafayette County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00295732"
      },
      "bbox": [
        11.325512748688658, -8.184750352844684, 11.79988651936676,
        -7.741853394381911
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.345850682558648, -10.47335632078914],
            [12.419729023887218, -10.463733858662808],
            [12.446533724025906, -10.460352446061245],
            [12.454508745232546, -10.458879224899166],
            [12.470818379297233, -10.45715475350996],
            [12.504427599459978, -10.452624751525676],
            [12.518640421139903, -10.450276363450376],
            [12.519318310427483, -10.45261597169688],
            [12.583097361874934, -10.443104258748436],
            [12.691399170645422, -10.42802345367392],
            [12.694242066182866, -10.449190773399225],
            [12.704405826066157, -10.521514911969224],
            [12.715642468057116, -10.599788302180471],
            [12.840242309648284, -10.582575129194813],
            [12.890226584893785, -10.575744465679254],
            [12.901203669747437, -10.655585163177719],
            [12.902220651996398, -10.660850389179744],
            [12.914857433416715, -10.745632716973853],
            [12.88728714793551, -10.749550492347213],
            [12.827293843693488, -10.75769312278911],
            [12.739449893115818, -10.770022711263628],
            [12.751705129107341, -10.854832782523747],
            [12.693656903249869, -10.862758940009629],
            [12.654274639269461, -10.867848189604162],
            [12.645312268198026, -10.869216072528163],
            [12.63799310270244, -10.8587706553376],
            [12.625930775075075, -10.845665258681136],
            [12.61725387173064, -10.834837643439078],
            [12.60655619559019, -10.817050930028504],
            [12.595678483781846, -10.802583980418092],
            [12.566530440127382, -10.767345112025385],
            [12.553353456899096, -10.742880506702189],
            [12.548035317814962, -10.731181677965656],
            [12.54207942849241, -10.721365531831017],
            [12.538508013305137, -10.719026809661425],
            [12.527409505779504, -10.693334917060488],
            [12.516404947297868, -10.677679443829923],
            [12.501575506597788, -10.658148920599725],
            [12.497705764219313, -10.649646049060259],
            [12.487895886351794, -10.63340133445745],
            [12.484506055859512, -10.629603685157553],
            [12.475277984768516, -10.61464272550209],
            [12.468477175640011, -10.60671488953781],
            [12.460321449732334, -10.59993396660304],
            [12.459645999755386, -10.596710059609926],
            [12.455978357020797, -10.591726259307451],
            [12.450258500490728, -10.585911931264546],
            [12.438263769035556, -10.58132317634432],
            [12.432319079825135, -10.579703149781924],
            [12.42718388191021, -10.574773067786447],
            [12.425878432333898, -10.571129077098416],
            [12.43161868492687, -10.560713362539545],
            [12.432261737496862, -10.554782724748703],
            [12.423645604629268, -10.552543327535439],
            [12.416152219304161, -10.54298771487022],
            [12.408352635669932, -10.535915468127179],
            [12.40522247463408, -10.534358557270265],
            [12.400801547415133, -10.526326439879792],
            [12.366457452386767, -10.497686787279182],
            [12.351887416471124, -10.482159068661659],
            [12.345850682558648, -10.47335632078914]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.33145493762457,
          "lat": 27.184437979707823
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12115"],
        "coty_name": ["Sarasota"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sarasota County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00295741"
      },
      "bbox": [
        12.345850682558648, -10.869216072528163, 12.914857433416715,
        -10.42802345367392
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.537381831232556, -6.8003455811684566],
            [11.643017410630694, -6.78565753864621],
            [11.695305760728669, -6.77927936719903],
            [11.727417798279822, -6.775042564113852],
            [11.790387357303656, -6.765535430728274],
            [11.835636480419502, -6.842312969136271],
            [11.880893783560564, -6.919062425158378],
            [11.884899872690047, -6.919227748335026],
            [11.890756412611383, -6.924535896965485],
            [11.895061580135508, -6.925912766255081],
            [11.899720526976784, -6.925095139252173],
            [11.908939920297389, -6.929785339938057],
            [11.918750635685367, -6.931904631228465],
            [11.920032589220067, -6.936428361760436],
            [11.92430745798857, -6.942075497035954],
            [11.932073120433072, -6.944781306378672],
            [11.936480051554435, -6.951614942780459],
            [11.94328146619449, -6.960113419757827],
            [11.948143025082283, -6.961204660487206],
            [11.949596506858768, -6.965023466871816],
            [11.974614405085642, -6.961439446766463],
            [11.991773514076293, -7.090320220149519],
            [11.990847422447544, -7.1035301702135465],
            [12.041322227695266, -7.095831309123829],
            [12.054805538770493, -7.185289663394532],
            [12.067625478561292, -7.183411648133064],
            [12.069535773353666, -7.195761478806787],
            [12.05671020058219, -7.19766237043203],
            [12.058615783766893, -7.210495499745985],
            [12.065726009257977, -7.222751570552665],
            [12.06924992556655, -7.248617085620923],
            [12.069363171140894, -7.26131022834428],
            [12.075110767002302, -7.299237272186643],
            [12.085327545518176, -7.297494639535852],
            [12.089703534467304, -7.32839447660762],
            [12.054587332453874, -7.330845181719742],
            [11.947911158508209, -7.338410393705546],
            [11.939679681270048, -7.273458101719472],
            [11.940697887997084, -7.2700444102804616],
            [11.93715366155015, -7.2678714568018075],
            [11.934080341052715, -7.256755269462826],
            [11.93433856359732, -7.252653020722727],
            [11.936767275387677, -7.2455929670101025],
            [11.937896206033622, -7.238977046767228],
            [11.935560255509731, -7.235263359560223],
            [11.929099206170225, -7.231744280999636],
            [11.926942046374725, -7.226800686610003],
            [11.922150529016637, -7.225340116017962],
            [11.913836667921661, -7.220907534194598],
            [11.908485906485621, -7.221933768844675],
            [11.894889586608542, -7.218532726630801],
            [11.884931160472457, -7.221395143837408],
            [11.878188401433148, -7.221149270721051],
            [11.87063562587536, -7.219690546438369],
            [11.86860912932744, -7.218170671994233],
            [11.862739177868304, -7.219293827379342],
            [11.8559063372722, -7.217076991864386],
            [11.851979622891873, -7.217797620125927],
            [11.84205675870458, -7.213196771733109],
            [11.836374197334536, -7.211374934077217],
            [11.831121445860264, -7.211784814009718],
            [11.821581910135436, -7.218112503341848],
            [11.8152481013392, -7.217977202651216],
            [11.80473235997212, -7.220547854417412],
            [11.80029068855052, -7.218059473484525],
            [11.7921527814976, -7.217915705524273],
            [11.785107159805522, -7.221202635363484],
            [11.77743382485728, -7.22004463668568],
            [11.77307655865662, -7.22174225810681],
            [11.76610200420492, -7.218797805529362],
            [11.757006320520764, -7.2180926863714445],
            [11.747301634919413, -7.215538778914381],
            [11.743042044660916, -7.211275731327609],
            [11.738053625230611, -7.209239646329273],
            [11.73530910926431, -7.204242861633677],
            [11.734669767965572, -7.197262798081534],
            [11.73126224154267, -7.194443701249545],
            [11.725206147003652, -7.184527640105075],
            [11.721705392191245, -7.1848407247829575],
            [11.718165220451786, -7.181403620465138],
            [11.712705396481818, -7.181300505172728],
            [11.709165591514727, -7.176963010112205],
            [11.705787087067243, -7.1632987020620025],
            [11.708243581634212, -7.15396956125145],
            [11.706031622227, -7.1493132186005095],
            [11.700832622915366, -7.146820838408281],
            [11.696408043113212, -7.1392736237228815],
            [11.69272725102693, -7.13777128113782],
            [11.690480546335378, -7.132249177100589],
            [11.691114520938301, -7.130045875458823],
            [11.580430688407375, -7.1106698260339956],
            [11.570117734885692, -7.031286338175827],
            [11.561528540042914, -6.966734326057373],
            [11.540326489212276, -6.817439209280609],
            [11.537381831232556, -6.8003455811684566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.70626396957066,
          "lat": 30.914985384741478
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13065"],
        "coty_name": ["Clinch"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinch County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00351285"
      },
      "bbox": [
        11.537381831232556, -7.338410393705546, 12.089703534467304,
        -6.765535430728274
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.090285368135193, -4.189163468496562],
            [10.09388991923687, -4.187476354567868],
            [10.097258750009587, -4.18206167815913],
            [10.102839361570794, -4.1775474720877614],
            [10.09992929186203, -4.171706754978873],
            [10.100514549917142, -4.168065947193919],
            [10.09813815284755, -4.158853851089757],
            [10.10340723851302, -4.158779591087884],
            [10.106024112907146, -4.15727874317872],
            [10.10841628898791, -4.151612298424343],
            [10.108744940076926, -4.1457184291915405],
            [10.1175854989533, -4.142679777109752],
            [10.124518550154283, -4.138026701300542],
            [10.137310295124257, -4.1365790588789695],
            [10.146617871230294, -4.142129565473736],
            [10.147005400098852, -4.149642278172985],
            [10.155820693779791, -4.146765448474053],
            [10.16064382133763, -4.142806295628599],
            [10.1640058619005, -4.136687423131849],
            [10.163184721058231, -4.130175383492979],
            [10.165581525117647, -4.116028454906522],
            [10.169608083315392, -4.107682669487963],
            [10.17534930840289, -4.1053585190370105],
            [10.178922407530482, -4.102385105189572],
            [10.182386810551858, -4.103582945942981],
            [10.192306959178236, -4.10316398812151],
            [10.202072012981793, -4.098778389546541],
            [10.20625952478156, -4.097888177759923],
            [10.211704224862975, -4.094068726105638],
            [10.214283674702639, -4.08829457783737],
            [10.217841170207846, -4.084713184916518],
            [10.223315308120656, -4.081354919206369],
            [10.225123132920208, -4.078079817676386],
            [10.215874636128232, -4.073409781012652],
            [10.212047309349735, -4.067128042206476],
            [10.206575994616996, -4.0642472587684795],
            [10.20908721990375, -4.05412830403056],
            [10.207628053777844, -4.045337659411043],
            [10.209903013719492, -4.037612297167303],
            [10.208925790124471, -4.033237769342061],
            [10.21515007886686, -4.023008377169743],
            [10.213748526633701, -4.012542263784728],
            [10.216422411506992, -4.009511519578802],
            [10.216190437590965, -4.006033049818878],
            [10.218611155111866, -4.004003559625054],
            [10.218967039138683, -4.000329606277838],
            [10.217217229768734, -3.9964895342636497],
            [10.22005093397284, -3.992927730930169],
            [10.22372492908129, -3.9845911468897754],
            [10.222780492574588, -3.97897591017474],
            [10.229266954290145, -3.9682604530645667],
            [10.229377930322956, -3.96347588916389],
            [10.239214572622368, -3.9569226207600274],
            [10.249956436100378, -3.95942554447899],
            [10.270807462603091, -3.9663798270595465],
            [10.3008457579802, -3.975080616537834],
            [10.311442630908374, -3.9787603415471104],
            [10.315064217583881, -3.979208825123482],
            [10.343493317072415, -3.987970707314072],
            [10.399897423276933, -4.004912338398144],
            [10.406462876243431, -4.00650735259204],
            [10.42527717754852, -3.989394162757407],
            [10.436235850392823, -3.978708134301542],
            [10.44363248970317, -3.972507127912759],
            [10.427678740204508, -4.051859502158173],
            [10.418747759866418, -4.096737326013367],
            [10.417526384905177, -4.100686243970416],
            [10.422475802877413, -4.103100365734431],
            [10.425404198085463, -4.107056875369255],
            [10.429985734159068, -4.110441749260937],
            [10.440713237420681, -4.114823539861027],
            [10.446377489813607, -4.119464869927216],
            [10.452697282589869, -4.134625937598211],
            [10.458023005701232, -4.135209481791298],
            [10.469173714920526, -4.144543643661697],
            [10.470017831116209, -4.149513224384588],
            [10.474667413387898, -4.152477573778699],
            [10.478496616892686, -4.157312208409347],
            [10.477739864939764, -4.160679099919589],
            [10.480408214970721, -4.164649793542357],
            [10.484263354816475, -4.167574003973093],
            [10.44427067239308, -4.21782639799101],
            [10.410563865093877, -4.2603439103174425],
            [10.364054025888818, -4.315794446224426],
            [10.353100259762778, -4.329967431528417],
            [10.34983314373105, -4.333731940144209],
            [10.32319331659681, -4.367411951021675],
            [10.315651518715258, -4.365023357149572],
            [10.3089802172004, -4.364245321707228],
            [10.305942407335218, -4.359972530264786],
            [10.297866012497954, -4.356175730448413],
            [10.292429056540136, -4.3510860389626504],
            [10.281695625646874, -4.350143103590172],
            [10.277332011290042, -4.348187375014918],
            [10.266424998477646, -4.336904668514231],
            [10.262835201081918, -4.33482464885682],
            [10.25668610171135, -4.328725663709838],
            [10.24286046481667, -4.322146276961517],
            [10.235814854224769, -4.313614998782209],
            [10.224810639083467, -4.302286273548001],
            [10.223274617824272, -4.2983296207698825],
            [10.220041981556342, -4.2954508402530305],
            [10.213527274038768, -4.293741708072674],
            [10.208156519703786, -4.287644006482719],
            [10.204531186971552, -4.285837272823339],
            [10.200266859129307, -4.280806613280744],
            [10.197722798640289, -4.280805383174937],
            [10.185989901261989, -4.276481414732007],
            [10.181829782600081, -4.272294364489965],
            [10.169729213642382, -4.270021607576535],
            [10.16618661074056, -4.2666832729983595],
            [10.162883650876585, -4.266990069417446],
            [10.14814377668887, -4.25480493871895],
            [10.141011368205799, -4.248399422315941],
            [10.133880652941166, -4.240088661774764],
            [10.116157545467392, -4.232548673028477],
            [10.109201315772848, -4.226019384897026],
            [10.102996652841778, -4.212942013863997],
            [10.09885405772604, -4.205790126872593],
            [10.097606675000309, -4.200104372561713],
            [10.10045488826446, -4.197976008896551],
            [10.095092925160122, -4.190312480192188],
            [10.09216772901044, -4.192493765381621],
            [10.090285368135193, -4.189163468496562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.02359447860863, "lat": 33.96188986871549 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13135"],
        "coty_name": ["Gwinnett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gwinnett County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01688166"
      },
      "bbox": [
        10.090285368135193, -4.367411951021675, 10.484263354816475,
        -3.9569226207600274
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.44363248970317, -3.972507127912759],
            [10.505503443190115, -3.8889109045097556],
            [10.538089801137742, -3.8446600149442753],
            [10.582756346372362, -3.784242882443852],
            [10.58666258850934, -3.7881341793564216],
            [10.594678299986226, -3.791471436251593],
            [10.603886992840279, -3.7967685178859902],
            [10.605150444024716, -3.8009106976496727],
            [10.609156116559829, -3.805064830101952],
            [10.626205027734324, -3.816162069683262],
            [10.632113630388, -3.817387718607963],
            [10.635827587086336, -3.8205666516026198],
            [10.659948468501181, -3.8136247500925595],
            [10.683322583463793, -3.810515423057695],
            [10.688928079840373, -3.8049277185722197],
            [10.69451234826197, -3.8091282446485377],
            [10.70167069944803, -3.8037776251738014],
            [10.727728389103685, -3.8240720095525655],
            [10.739980748777228, -3.8331780040905112],
            [10.753022593627174, -3.841980599102404],
            [10.753967448042536, -3.8457869446628368],
            [10.763123378073404, -3.8507745306524797],
            [10.772528437410784, -3.858502378353614],
            [10.775535109793607, -3.8610441156753947],
            [10.781168105568954, -3.8697870940884647],
            [10.788342580811905, -3.8720798108452446],
            [10.794723561406734, -3.882119022616716],
            [10.808390908976323, -3.887645653049274],
            [10.811015174721616, -3.893088564827832],
            [10.812355923591408, -3.9017599423483236],
            [10.817190275063641, -3.915244419502576],
            [10.820308597846838, -3.9346009799582533],
            [10.815736179714824, -3.941703559679205],
            [10.816072371411394, -3.944161882217321],
            [10.81328803889751, -3.9505721044502358],
            [10.813926803788725, -3.952696910177649],
            [10.81000393709606, -3.9627627140883543],
            [10.810808157013444, -3.970400836868908],
            [10.805532466304433, -3.9747670939837896],
            [10.811018083881788, -3.9787042250681957],
            [10.810426059104964, -3.9850525880954595],
            [10.806325741444628, -3.9864913807280935],
            [10.807056292381489, -3.997996538718963],
            [10.805765883842005, -4.002653746047089],
            [10.80919798852354, -4.005003572908255],
            [10.828461646607595, -4.010501049014474],
            [10.814542786347033, -4.019360512757454],
            [10.812265839710617, -4.0156107242079875],
            [10.808377075262504, -4.014960574106734],
            [10.80205567755663, -4.020679803552044],
            [10.809758171875554, -4.022396190124883],
            [10.780598077807767, -4.040602980941489],
            [10.732859540624649, -4.07131869054418],
            [10.727505499547751, -4.068672234581154],
            [10.720886276127517, -4.068110501823105],
            [10.718837855495677, -4.069850775210656],
            [10.719235607590852, -4.075767370900505],
            [10.722326513502107, -4.078080465892514],
            [10.693240022276942, -4.103826002847755],
            [10.678931490852253, -4.073500751687775],
            [10.677174141381508, -4.068213044071416],
            [10.663438530702022, -4.0408862299482085],
            [10.657111162481753, -4.042185977339141],
            [10.654207860809166, -4.034805494322695],
            [10.645049247364469, -4.034039602001174],
            [10.640741496459206, -4.038351830516994],
            [10.632603197858385, -4.041444872251664],
            [10.62867052170778, -4.038516907600693],
            [10.625257585377161, -4.039496573249202],
            [10.622283579895345, -4.033528489478216],
            [10.619544942144751, -4.031129232527887],
            [10.613805778277245, -4.032201662423415],
            [10.611278652339347, -4.034260167863916],
            [10.602184610428724, -4.034624363675378],
            [10.599845458324285, -4.032546413900817],
            [10.593093276148124, -4.0317231099476505],
            [10.592638311672673, -4.035833074489738],
            [10.586533630755067, -4.03511635214593],
            [10.583362020225566, -4.029640157911823],
            [10.578745477142181, -4.0321856046506115],
            [10.575720569621833, -4.035888957650171],
            [10.570829789685277, -4.03152711335068],
            [10.565999387912182, -4.033771145567122],
            [10.566666997186411, -4.037769256739639],
            [10.561947661415704, -4.0388419709294165],
            [10.560944635325505, -4.032401027559004],
            [10.556051210514989, -4.0348877556833695],
            [10.552095890067486, -4.031170651881538],
            [10.550755121040686, -4.034570070493237],
            [10.547554935472364, -4.034675349776632],
            [10.54645325112095, -4.041531360743055],
            [10.540823298216633, -4.042572923468564],
            [10.53783586887892, -4.038865491986855],
            [10.53897942960795, -4.034247292327964],
            [10.531902618490435, -4.034081225268111],
            [10.530337385747643, -4.02706022413666],
            [10.522340869248064, -4.030644208686185],
            [10.519752465493099, -4.026985826163648],
            [10.519829783613568, -4.023642136889321],
            [10.505843351584405, -4.028638180659844],
            [10.499126745676508, -4.027105063187616],
            [10.496030863635315, -4.029227970444395],
            [10.492384497905876, -4.0280994347361965],
            [10.489760311915246, -4.021755905550618],
            [10.486238206472033, -4.021000277835104],
            [10.48214075158294, -4.015869245816324],
            [10.470547458961908, -4.0098899437373134],
            [10.470625606124495, -4.0034539216773135],
            [10.467885184698947, -3.9969441393215854],
            [10.46137894731539, -3.995218815661037],
            [10.451212507266359, -3.9868384974398943],
            [10.448767881054682, -3.9821853921074783],
            [10.449012675582631, -3.9788881170427066],
            [10.445211765007341, -3.977332524800585],
            [10.44363248970317, -3.972507127912759]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.56646411229978,
          "lat": 34.133895706517045
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13157"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00349570"
      },
      "bbox": [
        10.44363248970317, -4.103826002847755, 10.828461646607595,
        -3.784242882443852
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.484263354816475, -4.167574003973093],
            [10.484507379509019, -4.169305485603509],
            [10.495724832711515, -4.176645693355829],
            [10.501878066509905, -4.179848380832726],
            [10.503507797304215, -4.18298872104367],
            [10.50800683284219, -4.182704238903077],
            [10.509977667669391, -4.185539057339626],
            [10.515398054251722, -4.18650202849294],
            [10.517404073992495, -4.191966325638617],
            [10.517358980225977, -4.196905129857284],
            [10.520366589792172, -4.197360697888516],
            [10.525398324981891, -4.194358152844201],
            [10.528622313621714, -4.195589888826229],
            [10.535484989681866, -4.190059146292308],
            [10.542178357151426, -4.1913987327744815],
            [10.545181762034776, -4.189299640001018],
            [10.551169214312422, -4.189057079865616],
            [10.56058888945343, -4.182787157241849],
            [10.566878930987274, -4.181490845495498],
            [10.57110678385509, -4.174847259758522],
            [10.578344585116444, -4.174349949518319],
            [10.586098021494593, -4.166797136188185],
            [10.595342041618155, -4.167390019506195],
            [10.596326863427958, -4.1707831360512415],
            [10.599918272524757, -4.17045436992437],
            [10.602488288404203, -4.173827430437633],
            [10.609802405053014, -4.173490544343948],
            [10.611547875506872, -4.175043450487683],
            [10.613573666826559, -4.176199023678723],
            [10.617951026563052, -4.172072314930988],
            [10.619918893300557, -4.175959175630237],
            [10.625618954509248, -4.18249010693832],
            [10.62776752026464, -4.192739110213125],
            [10.631159748692443, -4.19403608865866],
            [10.640516274140028, -4.194449271321279],
            [10.643846212091722, -4.1960153135839],
            [10.652912063750444, -4.194687659512341],
            [10.656063258468231, -4.192903158488029],
            [10.660936200441418, -4.193648374679345],
            [10.666313680577165, -4.190777347691635],
            [10.667606122682908, -4.192392538346664],
            [10.66507972815693, -4.197663728094374],
            [10.665368732289835, -4.207084430153216],
            [10.66341848771613, -4.210575419984461],
            [10.669925292381386, -4.211578406827483],
            [10.677285395435934, -4.218912733909726],
            [10.678185003603563, -4.224291994338527],
            [10.680967241370393, -4.226385405774107],
            [10.685240914798369, -4.225411328831468],
            [10.689561818933155, -4.22940112421369],
            [10.696683669248713, -4.232165586462938],
            [10.702762737582699, -4.236632066757101],
            [10.715511592061103, -4.24311586731541],
            [10.718984396026283, -4.247107318519016],
            [10.72661530230021, -4.247648982689507],
            [10.735313978687952, -4.250790230770803],
            [10.738475728681108, -4.248019445632739],
            [10.73493778994088, -4.2550075859718115],
            [10.734495048514622, -4.258516241498511],
            [10.728338571874788, -4.2685532067158185],
            [10.724601338654198, -4.271775978133573],
            [10.719746880245172, -4.287182518176544],
            [10.709141152908366, -4.309846979923338],
            [10.677032829509777, -4.376509100371011],
            [10.664832186675923, -4.4023667421142285],
            [10.624150587767671, -4.486679070736425],
            [10.607338543189304, -4.476182501519741],
            [10.612801589074094, -4.467831925471072],
            [10.573991813956452, -4.443852718514356],
            [10.5542816799485, -4.445679454440379],
            [10.470508824149551, -4.397396605956774],
            [10.41345448881023, -4.364670676519465],
            [10.353100259762778, -4.329967431528417],
            [10.364054025888818, -4.315794446224426],
            [10.410563865093877, -4.2603439103174425],
            [10.44427067239308, -4.21782639799101],
            [10.484263354816475, -4.167574003973093]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.73383903418161,
          "lat": 33.781545834027895
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13297"],
        "coty_name": ["Walton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walton County"],
        "coty_fp_code": "297",
        "coty_gnis_code": "00351264"
      },
      "bbox": [
        10.353100259762778, -4.486679070736425, 10.738475728681108,
        -4.166797136188185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.310689123924755, -4.014814010969384],
            [11.322173607953218, -4.010858733214162],
            [11.33106749565773, -4.0111583881073924],
            [11.335403986587664, -4.0052048404616105],
            [11.339565790851186, -4.002207537034678],
            [11.34600351388008, -4.000306897585234],
            [11.349510924639478, -3.9969571144216594],
            [11.358322558023046, -3.994290111422576],
            [11.37270820786577, -3.9957517681810635],
            [11.390328997743241, -3.9894178636159654],
            [11.399265062274118, -3.9877425147494265],
            [11.405848643602472, -3.982086559503166],
            [11.409433942364226, -3.9805142380611884],
            [11.418111039375555, -3.986467216918873],
            [11.421855972443065, -3.9973018536689757],
            [11.426003934352497, -4.005961804575517],
            [11.438383968609315, -4.036254652866633],
            [11.460651340367885, -4.089540365762657],
            [11.468095847117093, -4.105521258051898],
            [11.472750261511976, -4.102464291457046],
            [11.476569198151374, -4.096792133239999],
            [11.481967714851315, -4.09386248488531],
            [11.482282447784677, -4.091501784566424],
            [11.488805990303389, -4.087579833130645],
            [11.494858064733924, -4.096087484447545],
            [11.493788376464643, -4.10206196931351],
            [11.495260471332122, -4.105928112529785],
            [11.49167445902656, -4.109247022627431],
            [11.49203169267354, -4.1132022140492825],
            [11.487079240121696, -4.116823119361261],
            [11.489066701228555, -4.123706476214283],
            [11.481571237263692, -4.130319716674997],
            [11.482639709060464, -4.1365669143668065],
            [11.504710678167433, -4.175254255950705],
            [11.535175970746684, -4.217019405247434],
            [11.572815570712988, -4.269108742693434],
            [11.581294394818713, -4.280367427619714],
            [11.6025315025362, -4.310060619671611],
            [11.597708771201669, -4.309174674594493],
            [11.595467465802724, -4.302955854547276],
            [11.586944345354908, -4.299883506782021],
            [11.583453031912654, -4.297527503411711],
            [11.579166206684185, -4.299422072309801],
            [11.57888754822067, -4.293546988121766],
            [11.573391402476632, -4.294294747258595],
            [11.568440905150256, -4.302222303608162],
            [11.569115262901644, -4.307263737737995],
            [11.56440739239323, -4.3102581601746435],
            [11.559551277563962, -4.309300647069784],
            [11.554768906161254, -4.306849200015728],
            [11.554151261855818, -4.315047678840652],
            [11.549671302979185, -4.318567580637553],
            [11.5433816064521, -4.317312677755001],
            [11.540753199804048, -4.31547149052367],
            [11.538452687711178, -4.323369754121664],
            [11.535558926255737, -4.316136954607012],
            [11.531195930407948, -4.313740288881045],
            [11.529116711365452, -4.315780082598004],
            [11.528056665400085, -4.320780309921101],
            [11.522783116193729, -4.3187598729535255],
            [11.519183772801865, -4.313675725779552],
            [11.515803602885072, -4.311298222469868],
            [11.516228086421219, -4.320088614831947],
            [11.518441728008245, -4.323482473246169],
            [11.523191228326104, -4.32452660252136],
            [11.520423689844629, -4.328770453075174],
            [11.516084526257103, -4.326757117481852],
            [11.514697791025549, -4.321583537350564],
            [11.510394096868499, -4.32637530131929],
            [11.507912791092945, -4.325408987618482],
            [11.504011305654632, -4.329328830054431],
            [11.500146954166409, -4.328999224069399],
            [11.497952270349515, -4.331032995108929],
            [11.500821190847928, -4.337500154454564],
            [11.497396758765316, -4.337471259585968],
            [11.495290007911162, -4.331282696838415],
            [11.490163823145918, -4.334710469411],
            [11.493423745223703, -4.337794641558402],
            [11.489226713049291, -4.341071610038297],
            [11.48734266193796, -4.346853364525988],
            [11.493808285633545, -4.352594256009016],
            [11.488631212573335, -4.352877506890418],
            [11.486080051157579, -4.3552369206453685],
            [11.480524470834059, -4.356195801693922],
            [11.476181582467161, -4.352829966042468],
            [11.472109584404695, -4.354360865378953],
            [11.473533225539269, -4.358408541896735],
            [11.472767508584399, -4.36170619197403],
            [11.467591139297715, -4.360417927184503],
            [11.464967889685148, -4.358533200796925],
            [11.46279241176223, -4.3632829144048495],
            [11.46723171980215, -4.373175071151444],
            [11.463625392409012, -4.373102219642627],
            [11.460687913911924, -4.367191882093046],
            [11.456210989277658, -4.36644222919531],
            [11.451392367202835, -4.367395510356003],
            [11.449732074080853, -4.370576265379944],
            [11.444067882898489, -4.372833542302195],
            [11.437037250986052, -4.369415878885764],
            [11.434745823321597, -4.362748697667668],
            [11.43440646983069, -4.358033031491427],
            [11.43149891431179, -4.356503673088674],
            [11.425029879108852, -4.3565089231274525],
            [11.424829016290197, -4.360170724135134],
            [11.418834233573117, -4.3584081691282455],
            [11.41911849312392, -4.36235572727802],
            [11.414099502652475, -4.3691353924173555],
            [11.411493654847831, -4.367363248788472],
            [11.4112891332287, -4.362900580603221],
            [11.405888512036585, -4.365041077838623],
            [11.401902553482572, -4.3642865414569645],
            [11.396561286252897, -4.366488004282453],
            [11.394223047417844, -4.364868499935915],
            [11.39014065883095, -4.368586642479579],
            [11.387248913447674, -4.366990685705137],
            [11.38592816920949, -4.363082851099811],
            [11.378471310859943, -4.362893918774449],
            [11.373958643028551, -4.359551876432988],
            [11.368798503917452, -4.357664955914293],
            [11.334911267217054, -4.339766127031215],
            [11.326192335967654, -4.332946343768948],
            [11.324681678900022, -4.3353763565233185],
            [11.319118433427425, -4.334913493254157],
            [11.316310443366556, -4.34020479909639],
            [11.31194310867232, -4.339420929717538],
            [11.307402074652224, -4.343035271512771],
            [11.299020841944838, -4.352786626908467],
            [11.283060144499322, -4.352109325143592],
            [11.27771106144129, -4.359345693264577],
            [11.280141021237023, -4.364180750747692],
            [11.27618680663988, -4.369150035287789],
            [11.282092670619575, -4.3724631998649635],
            [11.277828511349046, -4.375133415931312],
            [11.271552876182486, -4.369314255848925],
            [11.271389198669665, -4.366203124084297],
            [11.267057931641448, -4.364121097834377],
            [11.205259362400202, -4.270664782099548],
            [11.193735017200371, -4.253514073241843],
            [11.16746991056863, -4.2278226338834335],
            [11.168711556994305, -4.221051399799476],
            [11.171788580653047, -4.218565797256848],
            [11.173585019880456, -4.209873289777639],
            [11.17329436056392, -4.205361848507368],
            [11.178580855511246, -4.201229156843538],
            [11.181056659600937, -4.196657361167575],
            [11.18429198825093, -4.194784031949707],
            [11.185211551485342, -4.188862332898733],
            [11.187351235552732, -4.183360705005362],
            [11.186548359056689, -4.178590853958314],
            [11.19028775879684, -4.170153410785064],
            [11.190787954881632, -4.165172393537932],
            [11.195040316675094, -4.154465583478639],
            [11.200297789143534, -4.154226267301883],
            [11.205373183548023, -4.15222448533169],
            [11.210257789905441, -4.144797563900954],
            [11.212152503234982, -4.131991040730611],
            [11.215431777536422, -4.1233018846094645],
            [11.221089468369366, -4.119185202578796],
            [11.226823611000556, -4.108349722175407],
            [11.227235139582014, -4.105716986626426],
            [11.23088473816675, -4.101642752852232],
            [11.232984917806819, -4.0929182101939645],
            [11.23374157402074, -4.085187073967134],
            [11.23876275299196, -4.081489211430297],
            [11.240022399184467, -4.074730976456128],
            [11.242765394167408, -4.074006710618141],
            [11.246992834322336, -4.069424834237765],
            [11.255471448990416, -4.065529887715095],
            [11.26016060731357, -4.052787883108111],
            [11.268129270497361, -4.0522323394007165],
            [11.272326169448801, -4.0497755427096],
            [11.277326716893745, -4.050207170540268],
            [11.279339163038546, -4.046757086307421],
            [11.282806124019217, -4.046846741296612],
            [11.285430051751314, -4.043782125908728],
            [11.290678362503717, -4.042920069553448],
            [11.29102983740535, -4.038923656466162],
            [11.296486179854865, -4.0373471848462135],
            [11.301481813221628, -4.038077263837184],
            [11.305673924189263, -4.0323716646495855],
            [11.308442685771924, -4.026503124966849],
            [11.310604826646362, -4.019205917892143],
            [11.310689123924755, -4.014814010969384]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.7431819807538, "lat": 33.781918745998276 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13317"],
        "coty_name": ["Wilkes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilkes County"],
        "coty_fp_code": "317",
        "coty_gnis_code": "00351265"
      },
      "bbox": [
        11.16746991056863, -4.375133415931312, 11.6025315025362,
        -3.9805142380611884
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.05007416959459, 6.3642422152977804],
            [-10.964299056356676, 6.349239364603858],
            [-10.949232716797036, 6.434382312110699],
            [-10.925646067642749, 6.430156981195128],
            [-10.922677800384779, 6.43011286947811],
            [-10.864525323125058, 6.4203918537814335],
            [-10.857360649360398, 6.463123846848383],
            [-10.817973632602717, 6.456489464852687],
            [-10.810713188615573, 6.499410396887295],
            [-10.8068966052084, 6.498791075941589],
            [-10.792522121467448, 6.582844327767963],
            [-10.749790087519996, 6.575736819454069],
            [-10.735818433941139, 6.658852045139076],
            [-10.613462017044837, 6.638226177959098],
            [-10.612203422728975, 6.646436136636271],
            [-10.599441621432645, 6.7228465668263775],
            [-10.598374322858088, 6.72760608551401],
            [-10.588924680465926, 6.784600872167844],
            [-10.58592492162464, 6.782580810304149],
            [-10.57692793126043, 6.786465151084886],
            [-10.565302563127888, 6.79320244116605],
            [-10.561298133665085, 6.78957944370744],
            [-10.550904195646407, 6.785743323962379],
            [-10.549904608502462, 6.783160011458215],
            [-10.54456799266117, 6.782197903794048],
            [-10.538528625775758, 6.783279002799409],
            [-10.536925543640374, 6.779694110801298],
            [-10.532107635427655, 6.775586651369444],
            [-10.523593813777852, 6.7714385885017325],
            [-10.520680672681879, 6.7666268327011645],
            [-10.51952198463794, 6.759828094712955],
            [-10.51506554743528, 6.7582377407861465],
            [-10.508728004864613, 6.761545067435865],
            [-10.496805254674575, 6.759980233055001],
            [-10.493772083938714, 6.760740184861166],
            [-10.486985389991606, 6.757559959155668],
            [-10.482576982037173, 6.758410900647653],
            [-10.483999851134975, 6.764077213124556],
            [-10.483944956396167, 6.774734866946806],
            [-10.492665337033428, 6.774537381126656],
            [-10.499341633456822, 6.78053390125553],
            [-10.509924913819253, 6.78354322593906],
            [-10.511223687060214, 6.786862563498473],
            [-10.503974591057013, 6.793072770950776],
            [-10.50726388291223, 6.797921590352915],
            [-10.513950291555027, 6.804463969311822],
            [-10.51401248180188, 6.811077006111085],
            [-10.51602062833101, 6.812956894302951],
            [-10.515591706725681, 6.821207096709648],
            [-10.511824168776453, 6.823887882209875],
            [-10.51537284961723, 6.827930063100961],
            [-10.510677992400455, 6.834300686047439],
            [-10.506408867665183, 6.841775670720158],
            [-10.500289977842195, 6.845354869243528],
            [-10.495937510685694, 6.846556649102842],
            [-10.496193746671246, 6.849200378820333],
            [-10.499644403749096, 6.853982747945741],
            [-10.50042620175881, 6.859443229375908],
            [-10.503434431788977, 6.861977211679907],
            [-10.502713267954046, 6.865048932120725],
            [-10.49682695240643, 6.865584041440362],
            [-10.49438862688637, 6.864161004919309],
            [-10.490781767670745, 6.867899687479877],
            [-10.48803550841032, 6.8629164164737215],
            [-10.48107739361238, 6.871220637124638],
            [-10.477039261792473, 6.872722456624327],
            [-10.473471510596589, 6.878211356552894],
            [-10.468243064824227, 6.882447352893393],
            [-10.47036636302045, 6.885423135605618],
            [-10.470114235975105, 6.889636775298296],
            [-10.46656248460714, 6.890354134208547],
            [-10.463797767059486, 6.894339479251919],
            [-10.469075912675091, 6.897479670768903],
            [-10.473735060050757, 6.904195152056366],
            [-10.471546774139403, 6.907463450059425],
            [-10.475121973502121, 6.917508348911679],
            [-10.47351850201376, 6.922371868759874],
            [-10.470718997499402, 6.9240591926618285],
            [-10.466815717380799, 6.922450555987822],
            [-10.463314350853182, 6.923643158296746],
            [-10.456405331852011, 6.9274607380650375],
            [-10.44193491119749, 6.92941513478915],
            [-10.438922312287444, 6.9314397409448985],
            [-10.431149801063777, 6.930641073269755],
            [-10.427789434354004, 6.926836032540659],
            [-10.427401457867793, 6.923995028574508],
            [-10.420541973673558, 6.918882879474445],
            [-10.411478090956315, 6.928074146698791],
            [-10.406827643559234, 6.930100259121167],
            [-10.405700441066449, 6.933804749590868],
            [-10.406317019368084, 6.94028751413224],
            [-10.402693607782634, 6.945501697411328],
            [-10.401215745176115, 6.950072181792827],
            [-10.402869860207336, 6.952406462797343],
            [-10.398558971845056, 6.957272073911767],
            [-10.392995878929563, 6.958918637330573],
            [-10.388033698564971, 6.954345362440203],
            [-10.387027690110152, 6.951456677877733],
            [-10.381862579525464, 6.944353019135934],
            [-10.382763925364907, 6.940760153699761],
            [-10.379983278971995, 6.936694111917874],
            [-10.37650846951126, 6.928330478335642],
            [-10.371852588124822, 6.925681700268218],
            [-10.363091040246179, 6.93218244668363],
            [-10.357405059216765, 6.929586969182966],
            [-10.353824336574794, 6.926034898367129],
            [-10.354999682657033, 6.916369635345042],
            [-10.352464894604287, 6.91162793280847],
            [-10.345801944589509, 6.903728026630185],
            [-10.342120748120058, 6.901136932563967],
            [-10.339173811906603, 6.896963182502242],
            [-10.33923736462214, 6.892452249867587],
            [-10.34114855588813, 6.886201075647402],
            [-10.337846701501133, 6.880591262642789],
            [-10.331216663833093, 6.876452383034043],
            [-10.329079678345787, 6.871408517693632],
            [-10.329931904502319, 6.869099487064806],
            [-10.326044409598342, 6.861365926632224],
            [-10.32498555104662, 6.856973272077976],
            [-10.328524015052796, 6.855424860007703],
            [-10.332150772545782, 6.85009165807372],
            [-10.335859742654538, 6.848779586083305],
            [-10.33382139598797, 6.843185474341163],
            [-10.328916207383813, 6.839999956413622],
            [-10.324140798680467, 6.841764957388584],
            [-10.317315660796979, 6.842162514160525],
            [-10.315681673382922, 6.834774300750176],
            [-10.311040324273119, 6.832942026104924],
            [-10.30366380666018, 6.819742001310611],
            [-10.298784944877477, 6.809851428300737],
            [-10.304377509923054, 6.806990423485388],
            [-10.313886407250365, 6.804992469455599],
            [-10.311957666110489, 6.7951738289570445],
            [-10.313013748772889, 6.790928543079206],
            [-10.311236951627759, 6.787127707832838],
            [-10.31308930505717, 6.774816087354007],
            [-10.311153546587786, 6.76656927140385],
            [-10.30549015108694, 6.763894172317875],
            [-10.297309065551259, 6.762246800980039],
            [-10.29310795661757, 6.762389344857309],
            [-10.279815379358208, 6.7535413158193665],
            [-10.279677866892749, 6.750679046283547],
            [-10.281904257602521, 6.739408602651247],
            [-10.277881556328332, 6.733168979724931],
            [-10.267939335914193, 6.7284853414032995],
            [-10.265900720793907, 6.724265538393886],
            [-10.263894052026098, 6.716452056416609],
            [-10.25689955129241, 6.716215920611843],
            [-10.25082597964994, 6.711803613876385],
            [-10.258029903092696, 6.699262908803653],
            [-10.258382864585549, 6.697303392802676],
            [-10.25545121301433, 6.679971402017791],
            [-10.248653731251467, 6.673056743910242],
            [-10.245491833642348, 6.672047718009896],
            [-10.244466278531599, 6.668473627630965],
            [-10.24107629294758, 6.664366696182497],
            [-10.236517862307322, 6.664502318974822],
            [-10.215792793407822, 6.6555738742837525],
            [-10.212497424988896, 6.651461408923223],
            [-10.206540948675213, 6.648660392322336],
            [-10.203932989888141, 6.649873288870813],
            [-10.202187348093167, 6.645220638841391],
            [-10.208406345131381, 6.6076184529786985],
            [-10.21798541952571, 6.547717615141749],
            [-10.22173851821333, 6.526823331265312],
            [-10.257507413019361, 6.301628028017521],
            [-10.258632830832886, 6.291613967189434],
            [-10.266976726150595, 6.240485683365674],
            [-10.274068254212983, 6.198339375653054],
            [-10.276034156465192, 6.178290422400769],
            [-10.278437006225348, 6.162038702670611],
            [-10.28035666414345, 6.1613464361782055],
            [-10.286427168344733, 6.16416278360956],
            [-10.295622935850337, 6.161443486282147],
            [-10.298264387098724, 6.158956031543462],
            [-10.301844747390229, 6.159167717180438],
            [-10.305674345123164, 6.156820962029595],
            [-10.308315756900704, 6.157656690001128],
            [-10.3129184008053, 6.155918415851726],
            [-10.315265816576787, 6.15677633103629],
            [-10.320337044598592, 6.153525370103954],
            [-10.327958139983929, 6.154870476487771],
            [-10.33241056480905, 6.150820142133541],
            [-10.34271908945839, 6.146608955184267],
            [-10.34741881944363, 6.147628292140038],
            [-10.351863174060961, 6.140196395376151],
            [-10.35446096398536, 6.143894583797926],
            [-10.357614023205109, 6.141969599358888],
            [-10.36436570374168, 6.140483773090787],
            [-10.36613898527065, 6.1365784936414425],
            [-10.371122756750779, 6.1364681963671694],
            [-10.37476417862473, 6.132354526536256],
            [-10.377717451654311, 6.13362195498357],
            [-10.38587207107867, 6.127275606776606],
            [-10.39631751669266, 6.131362419354498],
            [-10.395359527374977, 6.138641182031078],
            [-10.405957976269576, 6.137953245354881],
            [-10.407841293205982, 6.140852813578938],
            [-10.413153421893167, 6.144775415166798],
            [-10.415864937142867, 6.149388417460482],
            [-10.41871152688074, 6.1492596755629005],
            [-10.422233483190022, 6.143992730481755],
            [-10.425424229018896, 6.144867869818624],
            [-10.432151374192914, 6.141272456880145],
            [-10.435949257631771, 6.143391301544393],
            [-10.444307148817678, 6.1434273064703495],
            [-10.452502507789585, 6.132587164526863],
            [-10.460983726699348, 6.130458754400833],
            [-10.463142772902597, 6.131330946417675],
            [-10.46954709563325, 6.12781467821818],
            [-10.477270585837296, 6.131630731589364],
            [-10.479576187153176, 6.134887232924333],
            [-10.486611954217226, 6.136715547307115],
            [-10.48560696985971, 6.143479477691531],
            [-10.488168329387111, 6.150971854723115],
            [-10.498273471991745, 6.151267925566878],
            [-10.499026401060481, 6.158555877524499],
            [-10.501762613094659, 6.162116484992574],
            [-10.511846400600595, 6.157446544496625],
            [-10.516955745373004, 6.153634960492774],
            [-10.51899301334088, 6.149570777958004],
            [-10.528231482854267, 6.145394294136175],
            [-10.532889172928833, 6.146514864083395],
            [-10.537161513504515, 6.142363994424725],
            [-10.542865564423867, 6.138255863787198],
            [-10.545823589654116, 6.138626633913172],
            [-10.554070645155262, 6.136458972978573],
            [-10.557916305256242, 6.133065739302221],
            [-10.561241481737083, 6.138935136281412],
            [-10.566042131248796, 6.136756806425858],
            [-10.570824297552143, 6.137700983430626],
            [-10.571608895589442, 6.139990247938676],
            [-10.581292977009914, 6.1438250799355165],
            [-10.586629968041823, 6.143992166585402],
            [-10.587153755347291, 6.149419987961634],
            [-10.59045334106709, 6.150948955161352],
            [-10.592954512748877, 6.156507581758403],
            [-10.598712431365893, 6.156820398159996],
            [-10.604188709021747, 6.160620537016399],
            [-10.608675182232615, 6.1604127760622625],
            [-10.615215414562314, 6.155132210270082],
            [-10.623064084417582, 6.155457548663671],
            [-10.630547733457655, 6.152972639148158],
            [-10.639180747897779, 6.144463944456273],
            [-10.64553281979269, 6.1427657490303895],
            [-10.646440913166368, 6.140910808806122],
            [-10.653151458920965, 6.140930076577134],
            [-10.654017181100752, 6.139366652336001],
            [-10.65696103251215, 6.12189613119216],
            [-10.688263425321933, 6.126944426595436],
            [-10.727457239763671, 6.133718305896698],
            [-10.755383273032118, 6.138270695188319],
            [-10.753152206873354, 6.152533819849381],
            [-10.809586533624529, 6.162253575335207],
            [-10.85182312437771, 6.169688458802924],
            [-10.846870728988812, 6.197740188315964],
            [-10.88359497320742, 6.203914291299219],
            [-10.94555300859652, 6.21454425516627],
            [-10.938361691308849, 6.257381192677626],
            [-11.030456285096838, 6.2733668408833605],
            [-11.065073137093753, 6.279220405238109],
            [-11.05007416959459, 6.3642422152977804]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.48192336806615,
          "lat": 44.22878775146553
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16043"],
        "coty_name": ["Fremont"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fremont County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00395408"
      },
      "bbox": [
        -11.065073137093753, 6.12189613119216, -10.202187348093167,
        6.958918637330573
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.049377585362272, 7.040209951490967],
            [-13.984035711077166, 7.025804083181079],
            [-13.984658670566494, 7.029015184816836],
            [-13.977477159569345, 7.04115861567551],
            [-13.975160632789336, 7.048664764603314],
            [-13.976678783674375, 7.052005533758609],
            [-13.976078545114206, 7.055872285296322],
            [-13.973194753123567, 7.059274584387762],
            [-13.972362463485762, 7.063573054488282],
            [-13.973542823095231, 7.067604881037575],
            [-13.970789673572746, 7.075931814389725],
            [-13.971079599414423, 7.080097272025495],
            [-13.964610075536902, 7.082144635485025],
            [-13.96195617333633, 7.086295144834494],
            [-13.960353454334577, 7.095109024354807],
            [-13.95775882904442, 7.096111008407359],
            [-13.958640529686544, 7.104875709890396],
            [-13.960683695966079, 7.10901747171385],
            [-13.95640608330858, 7.111581455338114],
            [-13.958292886938713, 7.1158451816748585],
            [-13.956154049732966, 7.122367475731821],
            [-13.951521488883403, 7.125988493382568],
            [-13.950356995920574, 7.133138283015952],
            [-13.947846935085886, 7.137132483648004],
            [-13.947946863363407, 7.142955557634165],
            [-13.945579315622007, 7.145663399771514],
            [-13.94562241979499, 7.156232255486196],
            [-13.94733095314102, 7.160204095014318],
            [-13.942358691859374, 7.16718219704932],
            [-13.93952829062733, 7.173545678265915],
            [-13.938328803499807, 7.178817697878393],
            [-13.940188527397192, 7.181199458853033],
            [-13.938595820857916, 7.185802991289738],
            [-13.940257736428933, 7.190658324207059],
            [-13.934636585970479, 7.19419527596371],
            [-13.931716251444671, 7.203567822278145],
            [-13.92740434483446, 7.209719807107052],
            [-13.922948512653324, 7.21378607499924],
            [-13.923205320565124, 7.216978340631942],
            [-13.919221270057308, 7.2221714824066545],
            [-13.921917531080634, 7.223758444800721],
            [-13.92245147370652, 7.231170253480034],
            [-13.919331055329232, 7.236484937027246],
            [-13.91574196011496, 7.239541340164482],
            [-13.913373426186071, 7.246264976357],
            [-13.908013808957115, 7.250310171566611],
            [-13.90817397301883, 7.255844653302494],
            [-13.905780432167791, 7.259081164123859],
            [-13.905268353752883, 7.2633692507598875],
            [-13.90246172444005, 7.267028696876741],
            [-13.900832578558084, 7.278025856637705],
            [-13.899554172005466, 7.282041649033133],
            [-13.896167380548336, 7.283649211085635],
            [-13.89106906581977, 7.283016799932145],
            [-13.884063462851707, 7.29746108331102],
            [-13.880717691181506, 7.302298751635508],
            [-13.87885130791278, 7.305583170829023],
            [-13.873152421400293, 7.308951016173696],
            [-13.86399681041859, 7.312773832825585],
            [-13.857235648419481, 7.313375530616279],
            [-13.855105761586653, 7.315227806385809],
            [-13.846296415083183, 7.316971750666295],
            [-13.838158767154923, 7.3132149575346395],
            [-13.83644705099704, 7.310500493718199],
            [-13.832094609884276, 7.312345719142027],
            [-13.831220589199084, 7.3173044585032585],
            [-13.82660080674503, 7.323520169653232],
            [-13.827015166232462, 7.328093566365118],
            [-13.820082370622922, 7.3382293901788165],
            [-13.81642566309392, 7.338939141884944],
            [-13.814216466513551, 7.3417597205121305],
            [-13.810048899783647, 7.352223280764698],
            [-13.807157935929988, 7.352923362709597],
            [-13.80603895171868, 7.347359705049195],
            [-13.797711572077487, 7.3391045994536395],
            [-13.796153919020838, 7.334102278494725],
            [-13.790444068452963, 7.333910298256265],
            [-13.785945262856819, 7.337674131372826],
            [-13.78304751578981, 7.33840948586158],
            [-13.772230850717147, 7.333469851946498],
            [-13.769825929783982, 7.3338268848727575],
            [-13.766644014213872, 7.333049795442143],
            [-13.80334270792205, 7.163520506595302],
            [-13.84563887068319, 7.172419732050215],
            [-13.864286897938815, 7.088309703972164],
            [-13.88293731365753, 7.0042412763690685],
            [-13.924348536663487, 7.012967419671313],
            [-13.933501807186282, 6.971938404694621],
            [-13.975749169952168, 6.779031171757659],
            [-13.979325962745778, 6.762097822008145],
            [-13.99807986057633, 6.678200814848414],
            [-14.003696363343376, 6.679414487741638],
            [-14.084646981618588, 6.696842854611567],
            [-14.165600937674418, 6.714255229729958],
            [-14.306104466761548, 6.745000559437674],
            [-14.290380351853187, 6.815774602182767],
            [-14.284592073135912, 6.840396176679706],
            [-14.268183099700712, 6.914467411789945],
            [-14.17015979009367, 6.892135363368855],
            [-14.16390982842752, 6.920079952790099],
            [-14.136011842119542, 6.91361764232895],
            [-14.123674080818331, 6.969250186528538],
            [-14.06815270494602, 6.956557863672333],
            [-14.049377585362272, 7.040209951490967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.39749795351136,
          "lat": 44.06147511395212
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16045"],
        "coty_name": ["Gem"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gem County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00395442"
      },
      "bbox": [
        -14.306104466761548, 6.678200814848414, -13.766644014213872,
        7.352923362709597
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.360389997085292, 7.109643543245944],
            [-14.34537541466312, 7.106270773833368],
            [-14.272743953741498, 7.089417659053322],
            [-14.197339291536968, 7.07283025452586],
            [-14.121937739184537, 7.056228380890687],
            [-14.049377585362272, 7.040209951490967],
            [-14.06815270494602, 6.956557863672333],
            [-14.123674080818331, 6.969250186528538],
            [-14.136011842119542, 6.91361764232895],
            [-14.16390982842752, 6.920079952790099],
            [-14.17015979009367, 6.892135363368855],
            [-14.268183099700712, 6.914467411789945],
            [-14.284592073135912, 6.840396176679706],
            [-14.290380351853187, 6.815774602182767],
            [-14.306104466761548, 6.745000559437674],
            [-14.334120952718013, 6.751203568275352],
            [-14.336057255220773, 6.744204950447644],
            [-14.364201107305805, 6.750346370462989],
            [-14.365756742974797, 6.743361798635012],
            [-14.407830715116582, 6.7526887937864695],
            [-14.404607826455724, 6.766968846025492],
            [-14.433067151170949, 6.773553077919164],
            [-14.430189056097186, 6.787325233308029],
            [-14.444020749279924, 6.790352818477367],
            [-14.440964787609575, 6.804465662455578],
            [-14.469336055892471, 6.811066170727888],
            [-14.459680090126266, 6.8535254456078745],
            [-14.480213052897705, 6.858045705435691],
            [-14.471667631810732, 6.871112469026717],
            [-14.470091615503309, 6.882051153413251],
            [-14.47183861875141, 6.889248907992887],
            [-14.469590866240127, 6.891582442769902],
            [-14.457222580862842, 6.891102811482152],
            [-14.453251616051597, 6.896107838267823],
            [-14.452494738443292, 6.903500879663871],
            [-14.456939073110682, 6.908720188552854],
            [-14.455783019495536, 6.915702376793409],
            [-14.450244191460689, 6.920817237702598],
            [-14.447818041061437, 6.928347565105528],
            [-14.454821268726604, 6.930890945936296],
            [-14.453447610994527, 6.933444338826685],
            [-14.445083224063234, 6.935719097966142],
            [-14.445439398289947, 6.9402432401011875],
            [-14.451844931131145, 6.941805955564068],
            [-14.454143187611214, 6.948870192475946],
            [-14.448334447645244, 6.950392943683943],
            [-14.44093156573905, 6.954307944535324],
            [-14.42540276977776, 6.952554203006991],
            [-14.422381881656975, 6.958299501089829],
            [-14.425101419114165, 6.967645306216019],
            [-14.425202915377625, 6.971498361905082],
            [-14.422675083630002, 6.975267019112893],
            [-14.417651012042677, 6.979480233503529],
            [-14.414768735251387, 6.987615800065522],
            [-14.414984045309993, 6.995959706279556],
            [-14.41781672215009, 7.002988651244288],
            [-14.425233746023332, 7.012031562402395],
            [-14.435304475756185, 7.020277962385667],
            [-14.435286510788066, 7.025267555580267],
            [-14.430652485511002, 7.056592742006617],
            [-14.427844861044749, 7.058959053136534],
            [-14.422340978576354, 7.060429311854923],
            [-14.415044137343077, 7.059629366156385],
            [-14.404843772772747, 7.059725719420109],
            [-14.396948198668314, 7.064072562691445],
            [-14.391581240023209, 7.070316301165853],
            [-14.391213962104722, 7.075637845428117],
            [-14.387178264552729, 7.081178105393678],
            [-14.37738028015161, 7.087548089459274],
            [-14.372494895945087, 7.099409180607806],
            [-14.366017207510447, 7.102491561244858],
            [-14.360389997085292, 7.109643543245944]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.76084117737382,
          "lat": 44.006754970422946
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16075"],
        "coty_name": ["Payette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Payette County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00394896"
      },
      "bbox": [
        -14.480213052897705, 6.743361798635012, -14.049377585362272,
        7.109643543245944
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.96816044944941, 10.668860660079464],
            [-12.96224874360621, 10.661687849153944],
            [-12.956782560899585, 10.661766479854085],
            [-12.955903601348972, 10.657619492303084],
            [-12.951711736813417, 10.651351760888788],
            [-12.946190587817881, 10.637774199203282],
            [-12.947118753693175, 10.63053516615152],
            [-12.943379112421619, 10.625659534889172],
            [-12.94161122582102, 10.619185017149993],
            [-12.94216973798226, 10.61240493627229],
            [-12.937054204050114, 10.607863888070382],
            [-12.937202503292704, 10.601498858119832],
            [-12.934430364696185, 10.599156588030159],
            [-12.928385238399525, 10.59762192848575],
            [-12.92667373131878, 10.593869149135099],
            [-12.931014957845958, 10.583618197193637],
            [-12.925901420927943, 10.580938101104996],
            [-12.922179824001894, 10.576176728605331],
            [-12.91875812863261, 10.567276103559301],
            [-12.91720785993811, 10.566594520067607],
            [-12.91416650629714, 10.560005378765704],
            [-12.914471132332356, 10.554717775421858],
            [-12.912204300504191, 10.551926709317357],
            [-12.907223238412307, 10.536499199681652],
            [-12.907654122980698, 10.532849097937929],
            [-12.9020373601357, 10.531037476467686],
            [-12.90017961363413, 10.528124793611056],
            [-12.90124974419031, 10.524256042295708],
            [-12.898342032637608, 10.520370861617677],
            [-12.884227265063982, 10.523704935715635],
            [-12.881012630785666, 10.51692711828692],
            [-12.879817171958244, 10.508366203163028],
            [-12.872967039531646, 10.503058516324721],
            [-12.868410057052975, 10.49641809889102],
            [-12.869297834717727, 10.492690964290158],
            [-12.866880334759246, 10.485683380515468],
            [-12.87010064366795, 10.482153692165337],
            [-12.870725332257647, 10.475050295982474],
            [-12.872465451654156, 10.472166623159412],
            [-12.871824788160241, 10.465026502859853],
            [-12.874578322636678, 10.457681411536043],
            [-12.870982495382984, 10.452071119814835],
            [-12.869596798805514, 10.442024035907215],
            [-12.87144253939786, 10.433565467289588],
            [-12.870298057912793, 10.42760913304386],
            [-12.866434611690336, 10.423202213709677],
            [-12.85887877542308, 10.425333945982755],
            [-12.851307259070744, 10.425916438224352],
            [-12.847129427630684, 10.423931228883717],
            [-12.845806693722203, 10.41848336224932],
            [-12.841287184292318, 10.413976782053867],
            [-12.83921632768557, 10.407661954548988],
            [-12.842214490241057, 10.402427817644726],
            [-12.844039425342606, 10.396180295977558],
            [-12.842761748835757, 10.389897761584342],
            [-12.839683669515782, 10.383240190233915],
            [-12.832929069199698, 10.381499629395057],
            [-12.829625790390343, 10.382409035694486],
            [-12.814283133429313, 10.365295796319902],
            [-12.810496701287882, 10.35405214867841],
            [-12.81680407374005, 10.342365247625105],
            [-12.817364598820491, 10.334014061680357],
            [-12.822335664346038, 10.329686097362973],
            [-12.822854855821838, 10.323930313147185],
            [-12.827775900663351, 10.3177137639989],
            [-12.826263827908397, 10.305012289833838],
            [-12.815494248729744, 10.295708036287516],
            [-12.812881556804752, 10.294751782227213],
            [-12.806191429933772, 10.282313499308774],
            [-12.806277991244391, 10.275478047004048],
            [-12.81153010374226, 10.271467522624606],
            [-12.812124400188987, 10.263548052609664],
            [-12.810072038690741, 10.261491558917415],
            [-12.809851799045605, 10.257177425055835],
            [-12.807939523276978, 10.25455770108569],
            [-12.81465783335319, 10.249246582755802],
            [-12.821297551524182, 10.246119904311524],
            [-12.823011390800074, 10.240124791802288],
            [-12.833677636582223, 10.240555575361356],
            [-12.835490644224432, 10.236330996602119],
            [-12.841711461814945, 10.235307517631565],
            [-12.84776985615349, 10.231702309931885],
            [-12.852554368011841, 10.227228679396001],
            [-12.860550600192017, 10.22249636992535],
            [-12.862313612484842, 10.218565835953749],
            [-12.861034826930387, 10.21199243767266],
            [-12.854875106655955, 10.206983375832094],
            [-12.850115996043282, 10.206996672472812],
            [-12.848130491746947, 10.203145723445527],
            [-12.843050930855561, 10.199923640333049],
            [-12.836123328531903, 10.197219558253257],
            [-12.832663009868414, 10.199012033754757],
            [-12.829717263867293, 10.1977347427523],
            [-12.82657537508311, 10.190460758639212],
            [-12.83787991546913, 10.188493183771925],
            [-12.839334679263892, 10.182296019968055],
            [-12.838032659026721, 10.180799211410307],
            [-12.833807655333523, 10.166662995419456],
            [-12.82840844124772, 10.164067626128833],
            [-12.829119637559291, 10.148369632257625],
            [-12.82089658599677, 10.148024470119546],
            [-12.816177700443589, 10.149551727398121],
            [-12.813356238910963, 10.143308884271292],
            [-12.813246911770822, 10.138114021971148],
            [-12.80463754055097, 10.136334091561656],
            [-12.802134206253568, 10.13773430164821],
            [-12.795253926497296, 10.137903633118654],
            [-12.792734871764758, 10.135550069610236],
            [-12.795277498061361, 10.130052866086446],
            [-12.803558785702796, 10.117874174697205],
            [-12.810183528358074, 10.115747102248111],
            [-12.820788376182529, 10.115603443417106],
            [-12.824361495010036, 10.116961678884945],
            [-12.82908715240321, 10.116515094721262],
            [-12.832244481987672, 10.120938807454364],
            [-12.838581972596572, 10.12248084246898],
            [-12.840296257119437, 10.120375355169768],
            [-12.846302321668329, 10.119499204341311],
            [-12.856225632605257, 10.121628551620399],
            [-12.862787586348217, 10.118010605680471],
            [-12.873537077055218, 10.115429598761681],
            [-12.879029891385276, 10.115459498448887],
            [-12.88396639040479, 10.106962912294406],
            [-12.887100422138124, 10.104964676873172],
            [-12.89025586283086, 10.099977912401949],
            [-12.885775896090479, 10.09743966327334],
            [-12.87926277356545, 10.097390883257344],
            [-12.876496402974253, 10.099202885192394],
            [-12.870772588100946, 10.09694672489881],
            [-12.864652256327188, 10.096517838759548],
            [-12.865043461528007, 10.091692118148199],
            [-12.86049112248291, 10.085347868608219],
            [-12.853712231257118, 10.08446481508963],
            [-12.84724778606104, 10.082539606199814],
            [-12.844479493706046, 10.078361868566207],
            [-12.837451147204494, 10.074593140189503],
            [-12.840051530725516, 10.06815993087666],
            [-12.833471645842799, 10.065936486987102],
            [-12.830627929422562, 10.066644744231548],
            [-12.827137173050296, 10.063249468551282],
            [-12.827799910768606, 10.058931329726304],
            [-12.824220949175588, 10.055051950903279],
            [-12.822421020342194, 10.049433988659962],
            [-12.82475879113831, 10.045218355689581],
            [-12.822210363718684, 10.03938955975083],
            [-12.81752236442601, 10.040784115064715],
            [-12.813247391500932, 10.039499928370239],
            [-12.805438416382366, 10.040875465552926],
            [-12.799346631209094, 10.037989580078925],
            [-12.794938966251, 10.033923202659413],
            [-12.791928479685504, 10.027496718779362],
            [-12.780708381825102, 10.020871650737286],
            [-12.782463482786216, 10.014916200001013],
            [-12.78132361211196, 10.009467988189337],
            [-12.775868269968873, 10.004926362373178],
            [-12.77013092374514, 10.004825915853553],
            [-12.767254083038702, 10.002140368439731],
            [-12.76575859650272, 9.99759645924637],
            [-12.769229855967016, 9.98484304128195],
            [-12.762610156648295, 9.978799998167139],
            [-12.764748070058022, 9.975955208212914],
            [-12.763704126190964, 9.967800405192966],
            [-12.759577427769573, 9.958324165049953],
            [-12.761754312205056, 9.948869077326535],
            [-12.753479845017507, 9.944623016138506],
            [-12.748908454062754, 9.938741317375925],
            [-12.742306998743691, 9.934875956727865],
            [-12.738590530118, 9.934282496817632],
            [-12.735268779802558, 9.926250792004526],
            [-12.726940818886371, 9.92665065374307],
            [-12.722930789705286, 9.928766222115664],
            [-12.719568115970262, 9.926236511084701],
            [-12.717817595004863, 9.922579103004338],
            [-12.71841790622858, 9.918987288290205],
            [-12.710283641939945, 9.916023613190822],
            [-12.704847355434154, 9.917072602802902],
            [-12.69712175142988, 9.916593085696478],
            [-12.694369864754426, 9.913310228374428],
            [-12.69573124460792, 9.908037920133776],
            [-12.69202916619769, 9.903501687580933],
            [-12.691005863590679, 9.899662272066028],
            [-12.677510241497306, 9.897677293267009],
            [-12.672374471898918, 9.89892255519309],
            [-12.667323066876879, 9.894880360125915],
            [-12.663585959738322, 9.894754580882655],
            [-12.660768679341537, 9.890821754812631],
            [-12.656679902810486, 9.887706722215507],
            [-12.65258713659898, 9.889379972278908],
            [-12.647512844967222, 9.886783385567714],
            [-12.643481093152827, 9.888250482797371],
            [-12.633485100979714, 9.879668139285783],
            [-12.630909601071664, 9.879112088534768],
            [-12.631244191788317, 9.874255275825286],
            [-12.636219660722306, 9.869644511188941],
            [-12.634548858603695, 9.866074795298113],
            [-12.633351825444489, 9.856603494716287],
            [-12.63049598407576, 9.852429957695977],
            [-12.62779310432344, 9.851804333156252],
            [-12.62313322525833, 9.846736798418247],
            [-12.621581395764819, 9.840523972383737],
            [-12.621423060772843, 9.830878457096288],
            [-12.62524208705979, 9.827307362929316],
            [-12.631196224284869, 9.81630109600884],
            [-12.631778990949947, 9.811102457445624],
            [-12.6256606788722, 9.808536398374194],
            [-12.62357457234051, 9.804780906262515],
            [-12.617728590029715, 9.802186844587307],
            [-12.614185088136322, 9.802056265436628],
            [-12.607587071948663, 9.799742150559583],
            [-12.604763258170511, 9.792455489738021],
            [-12.606530828657267, 9.781519391298099],
            [-12.6031321872485, 9.776212675851406],
            [-12.603145555638148, 9.772226975469469],
            [-12.60085196923587, 9.76739609780128],
            [-12.59310112862993, 9.765392180832754],
            [-12.586993491659154, 9.762858538833678],
            [-12.582120914699983, 9.754871023813452],
            [-12.573572788048496, 9.750766980782563],
            [-12.573516997642688, 9.748254503934115],
            [-12.566855727645686, 9.739182471016461],
            [-12.56811679727021, 9.73475645471134],
            [-12.564419473078093, 9.72990685715538],
            [-12.564403531938526, 9.726704522471511],
            [-12.561526367261624, 9.720714086174704],
            [-12.562038316132622, 9.71593828572163],
            [-12.555079673178948, 9.709603930574056],
            [-12.544414238536994, 9.70720910265365],
            [-12.542698743435114, 9.70164344928774],
            [-12.545273740481209, 9.697457644150198],
            [-12.545619602329301, 9.685469766344847],
            [-12.543331743596958, 9.680658363901259],
            [-12.542131460540492, 9.673691897219944],
            [-12.537122847527645, 9.667054792681096],
            [-12.534745131427448, 9.661109017269375],
            [-12.52728699651372, 9.649144119451364],
            [-12.523962724572897, 9.649639998709775],
            [-12.51753578595338, 9.645554205667999],
            [-12.518973140217367, 9.641168635672235],
            [-12.51518964519813, 9.637470530263624],
            [-12.516293125953366, 9.629341720988633],
            [-12.513482290572671, 9.62477934585623],
            [-12.51083979046558, 9.624250370850765],
            [-12.511433514320071, 9.613633309141138],
            [-12.514041457480836, 9.61238373266817],
            [-12.511699847234752, 9.599129132769702],
            [-12.513990753559568, 9.593970781688753],
            [-12.51045890595968, 9.59020293898498],
            [-12.508879993499702, 9.582773186547458],
            [-12.505235212910476, 9.578435076846944],
            [-12.507419253844358, 9.571976310207402],
            [-12.506275556447639, 9.567213593412715],
            [-12.498712430784025, 9.566421213812086],
            [-12.493177300536795, 9.567286566102675],
            [-12.491685977665457, 9.570142269021956],
            [-12.48439884591559, 9.566879636435992],
            [-12.480522545338703, 9.56637099757791],
            [-12.474216542309255, 9.562885095001743],
            [-12.474801917981162, 9.55879731247454],
            [-12.471185645510289, 9.552590939760798],
            [-12.471206977472034, 9.5496263077085],
            [-12.467683658255638, 9.54389533269495],
            [-12.466484635168314, 9.538684556120664],
            [-12.459890389435332, 9.526788348497462],
            [-12.456147947349903, 9.524777651400742],
            [-12.45370043070102, 9.519692936551204],
            [-12.56734196869715, 9.542952733861199],
            [-12.680992108529832, 9.566170819810969],
            [-12.794650730084278, 9.589347174198512],
            [-12.908317713190451, 9.612481777059736],
            [-12.909767770937252, 9.613281925822074],
            [-12.958247535384366, 9.623326271708333],
            [-13.036232753434655, 9.63984399121764],
            [-13.120431283876412, 9.6578080375763],
            [-13.204634741344808, 9.675749065209633],
            [-13.288843076800736, 9.693667065416776],
            [-13.37305624118643, 9.711562029569782],
            [-13.354608746973287, 9.795203125827237],
            [-13.343810861995038, 9.844159188505044],
            [-13.2919261491358, 10.079392030291766],
            [-13.271818567958686, 10.170531534446177],
            [-13.242042278789304, 10.30551698910719],
            [-13.20466343774749, 10.474906297372062],
            [-13.189508793130349, 10.543584075305578],
            [-13.1714875310929, 10.625248502759504],
            [-13.144719587031014, 10.746537893928444],
            [-13.121632783287078, 10.765312428778545],
            [-13.118764930168792, 10.765061186975718],
            [-13.113563492089202, 10.767402930283287],
            [-13.11135048837034, 10.771400881776387],
            [-13.104747717206408, 10.779548962400973],
            [-13.102756361843362, 10.778170332439533],
            [-13.098228564102435, 10.780634074886827],
            [-13.09071307760993, 10.779329406044937],
            [-13.080441637056923, 10.780509243880614],
            [-13.076247778805364, 10.782847811546722],
            [-13.07039289314668, 10.781715899860918],
            [-13.067182366617518, 10.772204475984719],
            [-13.064155747918175, 10.76673698870028],
            [-13.060389694352779, 10.762603549650361],
            [-13.057975012538483, 10.756684078011281],
            [-13.058967706965438, 10.752825559472665],
            [-13.049800935147264, 10.748893946564172],
            [-13.044560000674315, 10.73982862280823],
            [-13.038975457719635, 10.735882328612718],
            [-13.038258968306799, 10.732502535037058],
            [-13.033328834497443, 10.726708987538583],
            [-13.02881331398239, 10.724176915705108],
            [-13.023518376760762, 10.726887158278702],
            [-13.011752556649684, 10.727287416521769],
            [-13.009667347426706, 10.729502725450029],
            [-13.00335866172156, 10.732204263044919],
            [-12.994934198132867, 10.720124003712396],
            [-12.99546635849927, 10.710576425529167],
            [-12.98819476649871, 10.698016052642455],
            [-12.9806743821331, 10.6916909230288],
            [-12.972970523368401, 10.688027127442849],
            [-12.973685572226822, 10.680981571868422],
            [-12.96816044944941, 10.668860660079464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.89233553491174,
          "lat": 47.35293498837485
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16079"],
        "coty_name": ["Shoshone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shoshone County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01702379"
      },
      "bbox": [
        -13.37305624118643, 9.519692936551204, -12.45370043070102,
        10.782847811546722
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.317431626813669, 1.519247538965824],
            [4.377709395036988, 1.5231402084976549],
            [4.406073720502811, 1.5255109014184833],
            [4.4269647445867255, 1.5259109043785533],
            [4.48204654902455, 1.5277584988127355],
            [4.479614335115578, 1.5180077058238752],
            [4.472676412792999, 1.5151011969032293],
            [4.475978945428535, 1.5118421166035378],
            [4.475712209289695, 1.508129514593597],
            [4.48456688248212, 1.5030567618224677],
            [4.49100099257337, 1.5028375442360902],
            [4.500920584123302, 1.5054017771336556],
            [4.50208285178352, 1.5020005078655552],
            [4.498835158256988, 1.4893163752345404],
            [4.498491745262262, 1.4841433139836633],
            [4.500183207198061, 1.4809797132943605],
            [4.498555556359612, 1.4769359470288221],
            [4.501168558160612, 1.4702411985036556],
            [4.51138803893957, 1.4714827576990306],
            [4.513292145392315, 1.4661347411380206],
            [4.518018559674294, 1.4657287601070499],
            [4.518347126415589, 1.45823697814796],
            [4.524344005384532, 1.45572952203185],
            [4.532464265022129, 1.455302655386265],
            [4.536283411433185, 1.4496711883490343],
            [4.539438679049977, 1.451881618717418],
            [4.546880884904167, 1.453974364676395],
            [4.549939737143792, 1.4597890546267809],
            [4.55347232089948, 1.4565480406424507],
            [4.554919927842968, 1.4521924216815167],
            [4.553950297614151, 1.4478146949465736],
            [4.551096174928553, 1.4443465247393572],
            [4.546665748109309, 1.447074049902897],
            [4.545379094683449, 1.4417347297240353],
            [4.5589959404171525, 1.4303992164998993],
            [4.558487175435333, 1.4235557083478205],
            [4.5566113651359155, 1.4180168371170105],
            [4.556304567528224, 1.4083604436792665],
            [4.5728412747832845, 1.40644368831078],
            [4.577690743788108, 1.4092374973446837],
            [4.586214604598346, 1.4122447689775335],
            [4.591363784187461, 1.4113602351275019],
            [4.599251126646466, 1.4126208178613722],
            [4.606146988444447, 1.4102641952892019],
            [4.607597115393385, 1.4133750909428855],
            [4.61159141883486, 1.4123316124958594],
            [4.616839130124145, 1.4178319952053933],
            [4.621418601214027, 1.418810509651894],
            [4.625455482883745, 1.4150428325080522],
            [4.626733605321672, 1.4186929388665692],
            [4.628143083520308, 1.4147554744765205],
            [4.630165157610867, 1.4028195636661611],
            [4.629910181990249, 1.3983765739696714],
            [4.6279043808520335, 1.3946752124748967],
            [4.622529066877899, 1.388821984680478],
            [4.620291230185807, 1.3825103031653752],
            [4.6152428786416175, 1.3757093727737006],
            [4.614776163080156, 1.370218348224493],
            [4.612879567789387, 1.3641811620085726],
            [4.613041724357061, 1.3511963990505844],
            [4.609966732481587, 1.3430136542501723],
            [4.6010113310119705, 1.3297710127894597],
            [4.593110498478024, 1.3239318877642505],
            [4.5881316382772415, 1.321864422585681],
            [4.584276900960091, 1.316843847117984],
            [4.5802252566465675, 1.3037071892722363],
            [4.578590702249474, 1.2982203446743117],
            [4.579862382519891, 1.2904827900318254],
            [4.582334623364786, 1.2814159604685147],
            [4.584969736810833, 1.275416602212916],
            [4.591595940711954, 1.266165648077632],
            [4.535466862295255, 1.2636075164792049],
            [4.506635576643083, 1.2624605736576586],
            [4.45185667689902, 1.2597783823872226],
            [4.418312343321322, 1.2585036446505675],
            [4.3462495303721225, 1.2546774431611678],
            [4.3290107579431485, 1.257662215422546],
            [4.325645702567516, 1.3153571309095],
            [4.32524988551217, 1.3298986427890427],
            [4.325906804476338, 1.3436061650042785],
            [4.3211733096539735, 1.432148590008842],
            [4.320397472991399, 1.454189269361759],
            [4.317431626813669, 1.519247538965824]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.75027693300873, "lat": 39.96183349954285 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17009"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00424206"
      },
      "bbox": [
        4.317431626813669, 1.2546774431611678, 4.630165157610867,
        1.5277584988127355
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.187978136693823, 1.3274516603589672],
            [6.19621679605666, 1.3280885652502676],
            [6.189330440372304, 1.4158736237431255],
            [6.2462971660148465, 1.4205721571099847],
            [6.27496540554887, 1.4230920040850412],
            [6.360501505214625, 1.4297012315505393],
            [6.446542193133487, 1.4379163869383982],
            [6.532392401427701, 1.4442964479075941],
            [6.58679381066276, 1.4492757774459772],
            [6.594737440659219, 1.361417997558187],
            [6.570655987208237, 1.3593535070549463],
            [6.577157649217472, 1.2965956851511125],
            [6.581563909917282, 1.2525530471774646],
            [6.536161080488057, 1.247673341368866],
            [6.536450069915776, 1.2443831749389187],
            [6.50851512580342, 1.2416815448318717],
            [6.510543703058368, 1.2128347906846708],
            [6.4822893815666776, 1.2098593512884386],
            [6.45279698777371, 1.2074182446486046],
            [6.371097203361366, 1.200970332359181],
            [6.320168908301381, 1.1962941453105276],
            [6.200020049948706, 1.1864396702291464],
            [6.1926208953358435, 1.2745190480766702],
            [6.187978136693823, 1.3274516603589672]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.21736719764066, "lat": 39.76944220200008 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17041"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00424222"
      },
      "bbox": [
        6.187978136693823, 1.1864396702291464, 6.594737440659219,
        1.4492757774459772
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.613660841835613, 1.4107814968962493],
            [5.670006210629836, 1.415494538687081],
            [5.664199038218694, 1.4887821695604229],
            [5.65946899739682, 1.5474423699856619],
            [5.747027438404134, 1.5548202911632352],
            [5.830512050530058, 1.5643836184832793],
            [5.917267715052045, 1.5730809875427583],
            [5.961274397492659, 1.576289176302445],
            [5.964801163177711, 1.5272674412446499],
            [5.968062540720233, 1.48816146831771],
            [5.972526859982383, 1.4259525243357223],
            [5.976388128966336, 1.3707311912483877],
            [5.981133267067336, 1.3116519418626413],
            [5.971279489266892, 1.3108193046518746],
            [5.975909525813498, 1.258387797646888],
            [5.968962542024117, 1.2583183455798495],
            [5.934183297270461, 1.255800978214114],
            [5.942460679086786, 1.1681165092150325],
            [5.898738375642503, 1.1645193330141106],
            [5.871163326401809, 1.1624732205279944],
            [5.858442274203717, 1.1612528646665554],
            [5.829413156056035, 1.1598550349909393],
            [5.778767098336769, 1.1568717833569142],
            [5.778725134183242, 1.1573280918527256],
            [5.692394779829733, 1.1515346820197767],
            [5.679598491261178, 1.2984648558481346],
            [5.672390518017315, 1.297921075257248],
            [5.672124797050186, 1.3014851336478133],
            [5.6650909966548, 1.3008908972148738],
            [5.658534593931879, 1.3052603420304438],
            [5.657311489607982, 1.307632573960387],
            [5.650066288712216, 1.3070801875752616],
            [5.649806659703515, 1.3106486972161218],
            [5.62481484404011, 1.3088955071996604],
            [5.621378829893063, 1.3068178910988082],
            [5.617039611194615, 1.3665120066054555],
            [5.613660841835613, 1.4107814968962493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.96157781414784, "lat": 39.85999220172518 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17115"],
        "coty_name": ["Macon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macon County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00424256"
      },
      "bbox": [
        5.613660841835613, 1.1515346820197767, 5.981133267067336,
        1.576289176302445
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.928552980668804, 0.9640431315155271],
            [4.962798481248539, 0.9665018796228384],
            [5.016080866644449, 0.9705965026051752],
            [5.102136296899517, 0.976750269788695],
            [5.201766357001776, 0.9840383915156481],
            [5.2290480596324125, 0.9858379631021642],
            [5.2731541331097205, 0.9891213476745232],
            [5.275916610900327, 0.9544165335982726],
            [5.2866931698202, 0.8127243030925442],
            [5.283319048799096, 0.8124821860712454],
            [5.289842908613428, 0.7293083982237071],
            [5.291218544773471, 0.7143365831933399],
            [5.299632322007149, 0.6109569152347757],
            [5.303138461874615, 0.5612767510795384],
            [5.303531475499477, 0.5588613921886288],
            [5.310592462716562, 0.46114252182590554],
            [5.267179158735919, 0.45804840744002223],
            [5.222761920452452, 0.45470737658030413],
            [5.1351533135564065, 0.44949031998330785],
            [5.109550885345249, 0.44778590701240895],
            [5.063067886173921, 0.44502007246995673],
            [5.022356584518048, 0.44205023854802555],
            [4.966877469787755, 0.43946151034398423],
            [4.961510351634329, 0.5275482572138405],
            [4.955748565031144, 0.6155439283554622],
            [4.948919594673792, 0.7040104577781877],
            [4.942654303024816, 0.7889378277794278],
            [4.94175204534444, 0.7888953760341393],
            [4.935070681387514, 0.8769848016118795],
            [4.928552980668804, 0.9640431315155271]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.92446817061077,
          "lat": 39.261019572879206
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17117"],
        "coty_name": ["Macoupin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macoupin County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00424257"
      },
      "bbox": [
        4.928552980668804, 0.43946151034398423, 5.310592462716562,
        0.9891213476745232
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.909479740853947, -0.03675682041474942],
            [4.915553154014029, -0.023495259324542956],
            [4.932792155455626, 0.008202653360091185],
            [4.938360969572301, 0.012284749866983354],
            [4.948725493182158, 0.022932198970859217],
            [4.956357615242913, 0.033818694562132975],
            [4.96121987175742, 0.046863154059374225],
            [4.964534795040494, 0.06487034737514785],
            [4.964543500405751, 0.07862928533307567],
            [4.960746648213467, 0.09591029045367774],
            [4.986914917316127, 0.09769684556409315],
            [5.028982285106468, 0.09959146567038472],
            [5.056263797536799, 0.10032409417491639],
            [5.134301844616889, 0.10470795186269591],
            [5.167597825285843, 0.10626792636634977],
            [5.240679475768666, 0.1093203811817959],
            [5.285508168276346, 0.11171126751599922],
            [5.32712405912555, 0.11418367745333202],
            [5.334749468773036, 0.016695852742799527],
            [5.340623283495467, -0.061755876915796606],
            [5.3452012732833625, -0.12672546282438768],
            [5.3544281964408045, -0.25813464149848786],
            [5.359094991214178, -0.3245383071702974],
            [5.271786684278537, -0.3297862707627176],
            [5.207006873363354, -0.3331044506011291],
            [5.2032683909323385, -0.3287304926707022],
            [5.202891635292526, -0.3256320341326929],
            [5.207407052768077, -0.32517794887560797],
            [5.207482066240041, -0.32161635795598054],
            [5.204583905227229, -0.31878925771869276],
            [5.198392730070005, -0.31662678591435967],
            [5.198965896809076, -0.31102164690293754],
            [5.19581587322304, -0.3060915534566225],
            [5.19166659748302, -0.3038380576972385],
            [5.193670790118658, -0.29941316124420025],
            [5.192529782819686, -0.29554508394086765],
            [5.187707826032472, -0.2903333390131617],
            [5.183302182679309, -0.2815005407077537],
            [5.185294190805986, -0.2792136998189737],
            [5.187420209076923, -0.2684913788197578],
            [5.191533561105596, -0.2681022513904923],
            [5.192858196310754, -0.27180169965782625],
            [5.188696950314781, -0.27384127934317437],
            [5.1892347129466, -0.2765074951614626],
            [5.194264921406913, -0.277871744856352],
            [5.199705953749712, -0.2742399455151194],
            [5.200965948884402, -0.266705498283388],
            [5.1962439865759125, -0.26008853696755185],
            [5.198092754315592, -0.25692104249152087],
            [5.193367912071093, -0.2510600075976864],
            [5.190481188047178, -0.24577803979354299],
            [5.123858276978453, -0.2496531007473383],
            [5.095002335491339, -0.2509982889259122],
            [5.094086289618307, -0.2362827423803709],
            [5.04162237662204, -0.18790489229293236],
            [5.019272630566695, -0.16668686963362458],
            [5.017626150970732, -0.16639314404517314],
            [5.003703640840285, -0.15235354735248896],
            [5.00292022482832, -0.1376097041587918],
            [4.976617915058567, -0.11319866111111876],
            [4.929002552078873, -0.07041725391019729],
            [4.924535946984765, -0.06580521039404677],
            [4.905497934258035, -0.04862659437261546],
            [4.909479740853947, -0.03675682041474942]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.92835659695383, "lat": 38.47029794198555 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17163"],
        "coty_name": ["St. Clair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Clair County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01784987"
      },
      "bbox": [
        4.905497934258035, -0.3331044506011291, 5.359094991214178,
        0.11418367745333202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.840096045365942, 3.1871053082301706],
            [7.843960698579529, 3.153183980259139],
            [7.844819780981766, 3.143746459309218],
            [7.845046699229659, 3.1431034289994497],
            [7.854851867356869, 3.054602670613598],
            [7.866800162730847, 2.9580263213230813],
            [7.870044499444387, 2.9329220747240385],
            [7.876310235894454, 2.8811962103654314],
            [7.858886129750128, 2.8790881881506034],
            [7.803042285063373, 2.8726743562758252],
            [7.753989127935317, 2.8676622354646604],
            [7.74067624254518, 2.8657862272802657],
            [7.737411664192044, 2.865962371508035],
            [7.672819937742804, 2.859139537195284],
            [7.56973573433448, 2.847983615285481],
            [7.561200160581131, 2.9353376712554726],
            [7.550783605930466, 3.0417273312537763],
            [7.543666880313255, 3.1099543256957394],
            [7.540689706614125, 3.138957939656758],
            [7.538904184374848, 3.153462612708982],
            [7.562517084121358, 3.1562378512933864],
            [7.569480045161965, 3.1567430146027826],
            [7.6402666855031525, 3.1653805854953427],
            [7.657507114819258, 3.167258575873779],
            [7.6577546599805775, 3.1661266997678617],
            [7.672397142495958, 3.167842043500215],
            [7.6723786480206995, 3.169273493526715],
            [7.747273637590223, 3.1770934496557013],
            [7.789852928060412, 3.182088106932785],
            [7.7969992725219655, 3.1824660938630904],
            [7.840096045365942, 3.1871053082301706]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.26178121766101, "lat": 41.3248382785077 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18099"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00450372"
      },
      "bbox": [
        7.538904184374848, 2.847983615285481, 7.876310235894454,
        3.1871053082301706
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.618250203126439, -0.15431318140451034],
            [7.613447989488463, -0.11016928176596245],
            [7.637914526550706, -0.10834848448283939],
            [7.676741818239933, -0.10502049816503442],
            [7.701136915739653, -0.10264777438596054],
            [7.699249817977464, -0.08758879859502904],
            [7.727517952119689, -0.08460236828912192],
            [7.783556348196143, -0.07595586968258285],
            [7.788246086515536, -0.1351583856865214],
            [7.874454483298273, -0.12724187529961337],
            [7.879978837448764, -0.1942062848703656],
            [7.88264927472404, -0.21334515827704154],
            [7.8794182850605, -0.22050852771844454],
            [7.880087070540659, -0.22821141948813875],
            [7.8824828248573136, -0.2336578649893056],
            [7.8869022616002376, -0.2384609957401624],
            [7.907059663179129, -0.2458090561793362],
            [7.910951410574948, -0.25366244691536005],
            [7.910022606271676, -0.2653947419268221],
            [7.906481538814944, -0.272598121424801],
            [7.89666123520222, -0.28367311133909745],
            [7.889284726587727, -0.2874183869737003],
            [7.875276463141332, -0.29081064913627874],
            [7.867215341709458, -0.2915244191935732],
            [7.860004649852156, -0.2921621364973656],
            [7.85105057620304, -0.2943880191967766],
            [7.846942592320108, -0.296640322768481],
            [7.843855613559606, -0.30132025264929213],
            [7.842465745769538, -0.3120624669810143],
            [7.843850763640103, -0.32133159080181156],
            [7.844004576250543, -0.3329504338593271],
            [7.84475059803794, -0.3417658842385879],
            [7.847156381460184, -0.35832199112778834],
            [7.848301691134886, -0.3720154249091853],
            [7.8499539677987356, -0.3779991008074929],
            [7.855080202539864, -0.3880111513414265],
            [7.860219801560896, -0.39241657925630735],
            [7.86558675235823, -0.4025460840905622],
            [7.866491471642188, -0.408260420986846],
            [7.863546405034485, -0.41322282386767145],
            [7.857543761673792, -0.41783960127479564],
            [7.846467370584793, -0.42417976253429235],
            [7.835227781818151, -0.42445461947277063],
            [7.820997871862651, -0.42148701443739134],
            [7.809965923425914, -0.42158926258880564],
            [7.803744229661076, -0.4242229699414356],
            [7.798565150623153, -0.43170871962621765],
            [7.79642210151179, -0.4395676168344502],
            [7.796781273532784, -0.44514966956462276],
            [7.79995566562187, -0.46174556949648415],
            [7.799969267945689, -0.471688807284106],
            [7.801784718159093, -0.47483196030281594],
            [7.801701593057549, -0.478996639245737],
            [7.7975405094896555, -0.4886538073632972],
            [7.78218794813627, -0.5013427786158242],
            [7.772910914940007, -0.5068750197921118],
            [7.765441355244464, -0.5089247462865475],
            [7.759677698542658, -0.5083945533377305],
            [7.757202649275056, -0.5069786136073323],
            [7.754029046829203, -0.5016396994698112],
            [7.752644551012968, -0.4944329068655902],
            [7.754619819174647, -0.4816307204036535],
            [7.760472131192076, -0.4641485504087649],
            [7.762691901238711, -0.4550304445050109],
            [7.7624167737258505, -0.4473864208360517],
            [7.760938370491251, -0.44330817651862153],
            [7.7569764739993055, -0.4395521718739895],
            [7.748336469695037, -0.4379254565632805],
            [7.738707371995203, -0.4370029512800013],
            [7.732561613134352, -0.43749915434055764],
            [7.728797565392523, -0.43982354807394397],
            [7.7245985280194835, -0.4448580054824072],
            [7.71329738854988, -0.4562782122188595],
            [7.7055343659417534, -0.4623598929421761],
            [7.70263730786712, -0.4631255898747165],
            [7.695305387016664, -0.46212646416957137],
            [7.692550615952826, -0.46011606801844934],
            [7.67829541325427, -0.44496472986178837],
            [7.665696326174446, -0.4263919375537724],
            [7.65565728698053, -0.4101220224466109],
            [7.651640197993661, -0.40437282271803404],
            [7.6525066306193406, -0.40242574546191406],
            [7.644699899566637, -0.3915145878847154],
            [7.641005307306113, -0.3804649796897114],
            [7.636201520010226, -0.37138779446705505],
            [7.629983967100558, -0.3689215116737934],
            [7.621389175237562, -0.3639814526901609],
            [7.627098329803833, -0.3586502366190279],
            [7.629462296901613, -0.3538319687106859],
            [7.628494977007003, -0.3480424688654091],
            [7.633032133441471, -0.3459856951411845],
            [7.637210282238598, -0.3512217235596737],
            [7.638694432991861, -0.35676411638922445],
            [7.643442302962019, -0.36004522702788155],
            [7.6533880672495265, -0.3607644812821538],
            [7.653911686888236, -0.35797815806404903],
            [7.651059149516562, -0.34994042665183916],
            [7.649181924586617, -0.3472701954100331],
            [7.647678800458275, -0.3344877010556101],
            [7.644503411068088, -0.33510417779333346],
            [7.643693112061151, -0.33133574154420314],
            [7.653406548733056, -0.32912984138606877],
            [7.648251114289556, -0.32514447413427033],
            [7.644475923122298, -0.32376486448930736],
            [7.643215143456815, -0.3193128154122588],
            [7.64326297478352, -0.3092009027782187],
            [7.648298587536433, -0.30312836647601255],
            [7.6514660523192655, -0.30144805063635877],
            [7.64526983275082, -0.2911894179593766],
            [7.643719062075571, -0.2867423037578827],
            [7.638956773672312, -0.28083322675018474],
            [7.644437578945811, -0.27556564089647845],
            [7.647036455025002, -0.27104410593547457],
            [7.646190281066725, -0.26283325372740385],
            [7.646651053030089, -0.2580877413873367],
            [7.6406037252760095, -0.25367583290597545],
            [7.637018325433369, -0.2575971764025685],
            [7.630899460218327, -0.2549700505940557],
            [7.633115284569481, -0.24970806049673297],
            [7.62924323398606, -0.24845111469980094],
            [7.626156555135054, -0.24332012886009236],
            [7.620464309974944, -0.24994726745903004],
            [7.617475935780232, -0.24750819954904746],
            [7.616539177320923, -0.24378437689664417],
            [7.618050551781591, -0.23950943860552884],
            [7.623306302818649, -0.2368725108614392],
            [7.619746054022891, -0.22850117388829053],
            [7.617731233682981, -0.2208481603896664],
            [7.6129259450420115, -0.21815626270903082],
            [7.617668894709881, -0.20826449816221937],
            [7.618637754274392, -0.2000112655366918],
            [7.616170330681041, -0.1976343406564475],
            [7.616587307587576, -0.1920928814481265],
            [7.612970025934119, -0.19008321603332282],
            [7.612770342909912, -0.18381232704791237],
            [7.611212335994049, -0.1790419343332169],
            [7.620838334921136, -0.17948577579663672],
            [7.618250203126439, -0.15431318140451034]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.63795396191246, "lat": 38.07968612593306 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18123"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00451682"
      },
      "bbox": [
        7.611212335994049, -0.5089247462865475, 7.910951410574948,
        -0.07595586968258285
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.926536467949291, -0.25547721325158596],
            [6.9456224543847105, -0.25388147196893357],
            [6.9977336905231775, -0.2501777300062257],
            [7.012301445426543, -0.2494181623001164],
            [7.0438033636011985, -0.24661666763321077],
            [7.051820438384302, -0.2464794036004107],
            [7.098264392184965, -0.24327751883859658],
            [7.101229061506426, -0.28344875550540005],
            [7.098486044342597, -0.2875260698276617],
            [7.10211413234514, -0.33138384775977986],
            [7.104799207191346, -0.3674788959331627],
            [7.105609565404024, -0.3746937856740871],
            [7.123585197509424, -0.3730390733885347],
            [7.126559779939214, -0.4027924330113474],
            [7.127933528151822, -0.424857732315737],
            [7.128779648552925, -0.4318746486599971],
            [7.131106916275946, -0.46775468683469784],
            [7.120619922112117, -0.4761960111169977],
            [7.108481329314433, -0.4888753150430116],
            [7.098244282020268, -0.5010420461100458],
            [7.090401001989976, -0.5062435583842465],
            [7.087303060385609, -0.506829238434149],
            [7.07990921246676, -0.5012133825681415],
            [7.070825708314131, -0.4982945472604281],
            [7.05464374052505, -0.4904925789121019],
            [7.045541293737933, -0.48332175250933723],
            [7.036509144850878, -0.4705983541957364],
            [7.034926496911428, -0.4656620541482752],
            [7.032237583552363, -0.46524713452752053],
            [7.033737067881888, -0.46012104372623214],
            [7.033605756985585, -0.45516926614439224],
            [7.0318320768711455, -0.44957878917871347],
            [7.028812206385506, -0.4460403743167458],
            [7.0243622790695595, -0.44326851247116716],
            [7.015304288160987, -0.4438662615549165],
            [7.011420795838043, -0.4478153301892933],
            [7.010437338805625, -0.451974683869844],
            [7.010946457086537, -0.45903191548477307],
            [7.010181965482401, -0.4693759703003718],
            [7.008663576944971, -0.47272397117242315],
            [7.000747111738051, -0.4819974735055656],
            [7.001400290695776, -0.48659173586351373],
            [6.99669483616196, -0.4913737004214508],
            [6.995312429420193, -0.4989649026665268],
            [6.997655315434115, -0.5050683769696416],
            [7.002130951729844, -0.5131395106446708],
            [7.009697673054196, -0.518828448139203],
            [7.021920890475812, -0.5268797318368338],
            [7.03036001633758, -0.5337708627998073],
            [7.033615355936931, -0.5403531320427132],
            [7.033968634200913, -0.5459937198608181],
            [7.03108015879597, -0.5497992304711197],
            [7.030265892528642, -0.5604184906528247],
            [7.0193254417706905, -0.5815725378230785],
            [7.013065787977306, -0.588913308207762],
            [7.005832291532672, -0.5924894115837838],
            [6.989873799046915, -0.5971189644024899],
            [6.982605114202026, -0.5976192364530462],
            [6.973635228631238, -0.5969708556628875],
            [6.968909837842834, -0.5956912326384134],
            [6.962983370557779, -0.5889193433290353],
            [6.959979970173961, -0.5789561379755115],
            [6.959348786106704, -0.5693746947733751],
            [6.968772221227268, -0.5442860450769128],
            [6.970059161941757, -0.5371937408975157],
            [6.9673472865366985, -0.5282816708370357],
            [6.963158815437395, -0.5245554855212917],
            [6.957144657567687, -0.5218915250494549],
            [6.950972681424513, -0.5223326193461846],
            [6.940803683473842, -0.5285884205219806],
            [6.938888469453075, -0.4967981389694819],
            [6.932992565984753, -0.41806451096585795],
            [6.923860210568546, -0.29988377932796983],
            [6.9299693040884565, -0.2994832849040614],
            [6.926536467949291, -0.25547721325158596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.58584545192404,
          "lat": 38.024922285443914
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18163"],
        "coty_name": ["Vanderburgh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vanderburgh County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00450396"
      },
      "bbox": [
        6.923860210568546, -0.5976192364530462, 7.131106916275946,
        -0.24327751883859658
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9342469935903777, 4.601256635239705],
            [2.0199040282943406, 4.603104231076753],
            [2.0972365304284843, 4.604909831349033],
            [2.186177866094359, 4.607347142914025],
            [2.27671842975938, 4.609507064081666],
            [2.280318439151152, 4.472849205627371],
            [2.2831147249325716, 4.363291081014281],
            [2.2851870191090238, 4.261811121278876],
            [2.2635581410141, 4.2613460293907615],
            [2.14915946159732, 4.258323440286322],
            [2.120624457692491, 4.257752574308249],
            [2.113741827730461, 4.257024740855879],
            [2.0993860819075967, 4.2572627305183515],
            [2.027658748963176, 4.2555709203371],
            [1.9411102313235524, 4.252879745268438],
            [1.9395390622722812, 4.324467261044041],
            [1.9394077676428272, 4.3395029000594825],
            [1.9373914086473136, 4.457166865655415],
            [1.9358406953761735, 4.52948056671686],
            [1.9347005566529876, 4.587294453770214],
            [1.9342469935903777, 4.601256635239705]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.73426972765866, "lat": 43.08190444284175 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19081"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00465229"
      },
      "bbox": [
        1.9342469935903777, 4.252879745268438, 2.2851870191090238,
        4.609507064081666
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.884396885451223, 3.3559130373936967],
            [3.8808604643662457, 3.4434241012559523],
            [3.8758431928790102, 3.5462419016539757],
            [3.8732663871185884, 3.6115872829685376],
            [3.8691852926823143, 3.7063871794374674],
            [3.9078183159278144, 3.7082670824632493],
            [3.9092304817293684, 3.7080047582571685],
            [3.945199877481182, 3.7099732649312673],
            [3.961694513246318, 3.7105091674624515],
            [4.040335922998037, 3.7142479615840154],
            [4.13004414633119, 3.7189036288195765],
            [4.183928465700187, 3.7211045086403214],
            [4.210634402546381, 3.722642997672333],
            [4.217022974965533, 3.5994162210310305],
            [4.218819555362448, 3.5619334409994705],
            [4.219917404838117, 3.5474035445035383],
            [4.224512147054277, 3.4600308776735478],
            [4.229147665128145, 3.372382133967582],
            [4.171592752845192, 3.3697629113703815],
            [4.143225181191837, 3.3681798787550656],
            [4.056790517037742, 3.3638866427748892],
            [3.970525104288154, 3.3599551502114986],
            [3.9125287611662865, 3.3570615570401734],
            [3.884396885451223, 3.3559130373936967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.13147354603511, "lat": 42.12122494391214 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19105"],
        "coty_name": ["Jones"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jones County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00465241"
      },
      "bbox": [
        3.8691852926823143, 3.3559130373936967, 4.229147665128145,
        3.722642997672333
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9720895134221994, 2.5258863737344495],
            [3.0577826472099803, 2.5290744175613202],
            [3.143818337194333, 2.5327055174077926],
            [3.2005191951137553, 2.5350833771355106],
            [3.3156080746021064, 2.540124596464166],
            [3.3186051026433616, 2.471225803244691],
            [3.320613059195301, 2.4227382673696414],
            [3.323370412624581, 2.361366719745823],
            [3.3269365743665493, 2.275479422338919],
            [3.3024998675368886, 2.274314906048819],
            [3.2356642578163837, 2.2714309308375236],
            [3.125533211206758, 2.2669719995641473],
            [3.0680402114735923, 2.264934988774814],
            [2.9824065182248587, 2.26162550212806],
            [2.978962349699774, 2.350462241560661],
            [2.9752428521544076, 2.446225625970002],
            [2.9720895134221994, 2.5258863737344495]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.40948094149759,
          "lat": 41.030578215720084
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19179"],
        "coty_name": ["Wapello"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wapello County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00465278"
      },
      "bbox": [
        2.9720895134221994, 2.26162550212806, 3.3269365743665493,
        2.540124596464166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.05027309070557919, -1.4111451245357758],
            [0.09278276971253645, -1.4119865551306343],
            [0.10655772927882455, -1.4119697317064774],
            [0.16341355763902532, -1.41259584014742],
            [0.19232023632622938, -1.4126991120905832],
            [0.2349109958993022, -1.4138871580845491],
            [0.26658111824791214, -1.414173060418975],
            [0.2776515899733652, -1.4139126786275726],
            [0.3279545236914988, -1.4140308657676148],
            [0.37456233447942533, -1.4145783382549155],
            [0.44384701606360605, -1.415163800974018],
            [0.4917860969561271, -1.4158122923015302],
            [0.4918198173367959, -1.488970044118474],
            [0.4920328428358005, -1.5185201681572948],
            [0.4916313637707621, -1.6205589867844876],
            [0.4917377909701398, -1.6496380706166651],
            [0.4916284582756504, -1.7042398348167407],
            [0.4920017041977629, -1.7187581050751781],
            [0.4630993689258249, -1.7189991781328489],
            [0.3520461302593864, -1.7188021999395684],
            [0.3175932381161457, -1.7185029439775996],
            [0.30552259160093653, -1.718663211612456],
            [0.24514029695558545, -1.718266703076506],
            [0.15188160265296427, -1.7179882891438734],
            [0.06802344230198813, -1.718177170455022],
            [0.04802046030582264, -1.7179995906810215],
            [0.04870457891066925, -1.6161391421324125],
            [0.04929125965242982, -1.5134790651779477],
            [0.04972071000448055, -1.4547770909643292],
            [0.05027309070557919, -1.4111451245357758]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.24539113821741, "lat": 37.15002463720085 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20019"],
        "coty_name": ["Chautauqua"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chautauqua County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00484979"
      },
      "bbox": [
        0.04802046030582264, -1.7189991781328489, 0.4920328428358005,
        -1.4111451245357758
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.05163494915502262, -1.1039579490853084],
            [0.07674044816779302, -1.103844084577276],
            [0.1509174597456388, -1.104669679184943],
            [0.16932547021086083, -1.1045002913956032],
            [0.2652123563951096, -1.1057965290192555],
            [0.2878203038202967, -1.1057361683561908],
            [0.3659580779153569, -1.106606480613271],
            [0.4360455412215012, -1.1078971800952444],
            [0.46051713961609675, -1.1079436469979147],
            [0.4943360352602002, -1.1083756167743792],
            [0.4932955925327579, -1.213089511733299],
            [0.49321812194217063, -1.267633973251528],
            [0.49395152213676347, -1.3275784308989116],
            [0.4915429386335973, -1.3275591746448026],
            [0.4917860969561271, -1.4158122923015302],
            [0.44384701606360605, -1.415163800974018],
            [0.37456233447942533, -1.4145783382549155],
            [0.3279545236914988, -1.4140308657676148],
            [0.2776515899733652, -1.4139126786275726],
            [0.26658111824791214, -1.414173060418975],
            [0.2349109958993022, -1.4138871580845491],
            [0.19232023632622938, -1.4126991120905832],
            [0.16341355763902532, -1.41259584014742],
            [0.10655772927882455, -1.4119697317064774],
            [0.09278276971253645, -1.4119865551306343],
            [0.05027309070557919, -1.4111451245357758],
            [0.050541552137340594, -1.32451515338787],
            [0.05048320840158626, -1.2622380011757925],
            [0.05059950372971992, -1.2358172059459775],
            [0.050230966348672225, -1.211969841040754],
            [0.05087207879603144, -1.1839924523719452],
            [0.050679624497615594, -1.1770473318079633],
            [0.051221823318157944, -1.14773420915787],
            [0.05163494915502262, -1.1039579490853084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.2441507700276, "lat": 37.45367700410297 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20049"],
        "coty_name": ["Elk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elk County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00484994"
      },
      "bbox": [
        0.050230966348672225, -1.4158122923015302, 0.4943360352602002,
        -1.103844084577276
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5202962998487064, -0.8678405489370523],
            [-3.449004185955187, -0.8712460486415077],
            [-3.4062528405699775, -0.8734171842169223],
            [-3.292100646346901, -0.8794891827438948],
            [-3.2635032726226507, -0.8808899356122061],
            [-3.1781898099820416, -0.8854494168432576],
            [-3.1803624815154015, -0.929362825738611],
            [-3.1868840326012493, -1.0611046259639991],
            [-3.191413604366213, -1.1490680648944693],
            [-3.19579097248928, -1.237014970273012],
            [-3.2839015857501903, -1.2326420517815688],
            [-3.3877483086703353, -1.227172322552417],
            [-3.4244870466940602, -1.2253105494618302],
            [-3.5221949026741757, -1.220158677206198],
            [-3.539128031100956, -1.2193117958824227],
            [-3.5347835700510886, -1.141905124050099],
            [-3.5301589413666346, -1.0436003146371196],
            [-3.52203950295177, -0.8973283244654328],
            [-3.5202962998487064, -0.8678405489370523]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.87114717137639,
          "lat": 37.56222526323849
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20081"],
        "coty_name": ["Haskell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haskell County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00485328"
      },
      "bbox": [
        -3.539128031100956, -1.237014970273012, -3.1781898099820416,
        -0.8678405489370523
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.2867728974151476, -1.174004188794109],
            [-4.1333379038007605, -1.1838828203777296],
            [-4.010674757488224, -1.191651222327608],
            [-3.9123366439351734, -1.1976915791894716],
            [-3.9059273763140334, -1.1979789280989308],
            [-3.9065812500368926, -1.206912802679948],
            [-3.9140088303688847, -1.3446911581233292],
            [-3.920695404792256, -1.4619916139216396],
            [-3.928055808477083, -1.594144989848795],
            [-3.9890795311144016, -1.5910177301599422],
            [-4.056812881998866, -1.5873713366403288],
            [-4.142351388907685, -1.5826788533668863],
            [-4.228175200459979, -1.5778722136527925],
            [-4.301615725541687, -1.5736760782677106],
            [-4.312581802134678, -1.5730893088079339],
            [-4.309750067565324, -1.530724127514169],
            [-4.302972944334442, -1.4232756543569378],
            [-4.295474252075272, -1.3059937838401345],
            [-4.292706233842548, -1.2662278411134757],
            [-4.2894241659620205, -1.2108373293953443],
            [-4.2867728974151476, -1.174004188794109]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.7992464129641, "lat": 37.19138831376904 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20129"],
        "coty_name": ["Morton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morton County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00485135"
      },
      "bbox": [
        -4.312581802134678, -1.594144989848795, -3.9059273763140334,
        -1.174004188794109
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3196594040146006, -0.30300498474456455],
            [-2.239978985639755, -0.3059989222434148],
            [-2.146653372450303, -0.3093109631834428],
            [-2.062046116702331, -0.31099637697100757],
            [-1.9763242154453815, -0.31594562686127464],
            [-1.890954120848836, -0.31899756765370413],
            [-1.8936831461304073, -0.40691466777134655],
            [-1.8078321315227357, -0.4096046153310993],
            [-1.8006379994937207, -0.4099659179828256],
            [-1.803150888783928, -0.49732466046949253],
            [-1.807333115515424, -0.6146227356166188],
            [-1.8091336469296475, -0.673013775085186],
            [-1.8662707432091208, -0.6714703638757678],
            [-1.8941558866826944, -0.6705755677257084],
            [-1.9800506556634099, -0.668178718958692],
            [-2.0227262946827635, -0.6667939426940929],
            [-2.064615027171393, -0.6652285430313497],
            [-2.1063511443292247, -0.6632294701157434],
            [-2.150064648999131, -0.6614796671779511],
            [-2.1470283035677666, -0.573834986057493],
            [-2.2323178243560746, -0.5702072783088339],
            [-2.317750291819731, -0.5678419387462764],
            [-2.3161980788535583, -0.5235670530229516],
            [-2.3118697200167664, -0.3914637324701123],
            [-2.3225239886783595, -0.39102009461900955],
            [-2.3196594040146006, -0.30300498474456455]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.23671097479995,
          "lat": 38.181315942226476
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20145"],
        "coty_name": ["Pawnee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pawnee County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00485036"
      },
      "bbox": [
        -2.3225239886783595, -0.673013775085186, -1.8006379994937207,
        -0.30300498474456455
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.306667272653698, 0.0472962143758149],
            [-2.186004680612027, 0.042982351585646505],
            [-2.0732994217560687, 0.03919311285889128],
            [-1.9724355685335915, 0.035959927038739604],
            [-1.887623047556883, 0.03295239459557152],
            [-1.8801656779398965, 0.03266546759844621],
            [-1.8813392423670434, -0.007903299148701729],
            [-1.8830941408703454, -0.05553080967884901],
            [-1.8856731662570176, -0.14350533549053932],
            [-1.8867945241127666, -0.17287697146327877],
            [-1.8883876256362977, -0.23150892254878458],
            [-1.8894085099491276, -0.24571442491873036],
            [-1.890954120848836, -0.31899756765370413],
            [-1.9763242154453815, -0.31594562686127464],
            [-2.062046116702331, -0.31099637697100757],
            [-2.146653372450303, -0.3093109631834428],
            [-2.239978985639755, -0.3059989222434148],
            [-2.3196594040146006, -0.30300498474456455],
            [-2.3177040522554084, -0.2443351406378321],
            [-2.3161503710837184, -0.18733386556901546],
            [-2.3131816956271507, -0.09753839942893341],
            [-2.306667272653698, 0.0472962143758149]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.30915085830706, "lat": 38.52311306335208 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20165"],
        "coty_name": ["Rush"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rush County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00485358"
      },
      "bbox": [
        -2.3196594040146006, -0.31899756765370413, -1.8801656779398965,
        0.0472962143758149
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.763712326830666, 0.5260958367231856],
            [10.771441512043756, 0.5180904090088978],
            [10.778996078105386, 0.512582783573868],
            [10.788036549427021, 0.5078255062948352],
            [10.799148929895013, 0.504552779083832],
            [10.807790592691523, 0.5005069824304395],
            [10.813008194633461, 0.4946382598422983],
            [10.817330006183525, 0.4868803589267144],
            [10.823065702418145, 0.46483289847412246],
            [10.827536292536792, 0.4545343519229806],
            [10.830872703699372, 0.4500269229077461],
            [10.829308713834045, 0.4455825329947799],
            [10.829830120408051, 0.43775855116675616],
            [10.8333084282442, 0.42591882951225085],
            [10.83051307711602, 0.4207550354097208],
            [10.831117411172567, 0.4163206626401874],
            [10.836781790808573, 0.40849751285271085],
            [10.837604507478902, 0.400014524642016],
            [10.835852809010444, 0.392622450335348],
            [10.836329045436624, 0.3855935947643414],
            [10.838332051587361, 0.37264367854828384],
            [10.839742517929583, 0.3707429001545022],
            [10.84543793151374, 0.36919668217276363],
            [10.850216885352477, 0.36293300279033625],
            [10.857237611818345, 0.35820907645865935],
            [10.858815530896363, 0.35318787726763773],
            [10.862437151487851, 0.3478025242745317],
            [10.86285585446941, 0.34393731071898365],
            [10.860268762131426, 0.33876750052825555],
            [10.857352564873485, 0.3299955506791999],
            [10.857009559420435, 0.32488077273866134],
            [10.859912732941867, 0.32146658129351735],
            [10.86207047274129, 0.3115952789453857],
            [10.866287842347965, 0.30502872606983666],
            [10.867786962241036, 0.2941774294158447],
            [10.86630548893544, 0.2847219283667359],
            [10.864461900375979, 0.27811884612877236],
            [10.861600726512709, 0.2746769152691361],
            [10.854763890859473, 0.2735396313469308],
            [10.84706694813617, 0.2743340571206841],
            [10.84616982432229, 0.2821406783795377],
            [10.843603012403603, 0.28744519022128495],
            [10.836952682498158, 0.2920482981367367],
            [10.832876417485162, 0.29105541026925785],
            [10.826486693754617, 0.2934831165517454],
            [10.821088858679673, 0.2906882523963951],
            [10.771972173756708, 0.2786178275581253],
            [10.768259694538239, 0.26881822179478887],
            [10.764681348878591, 0.2696860800510766],
            [10.761544063394522, 0.26547765041953875],
            [10.756937390703381, 0.2642484218612158],
            [10.755791710179741, 0.25784653774025107],
            [10.747108070049649, 0.2552495267328203],
            [10.746209938066153, 0.2498228835328427],
            [10.738906390071305, 0.25048097331212177],
            [10.7271879866896, 0.24455964196512556],
            [10.719650305781235, 0.245982180836365],
            [10.714430056666375, 0.24924406549614245],
            [10.711722089159606, 0.24584985011763258],
            [10.708630875081298, 0.24690998141498113],
            [10.707298874490089, 0.2520512222371773],
            [10.70156220518726, 0.2502372684705244],
            [10.69813794878804, 0.34283304383928764],
            [10.698703305175576, 0.34459355113672885],
            [10.697146005708115, 0.35328099536828556],
            [10.699177434476011, 0.361831536110179],
            [10.702444863493419, 0.3672292748784712],
            [10.702223584196808, 0.37147871795519],
            [10.69079741809453, 0.372998011790023],
            [10.665482723629625, 0.377910356049224],
            [10.664908530720536, 0.38063095218089793],
            [10.669646760321346, 0.3911049113873996],
            [10.668057994484675, 0.3977325025807443],
            [10.672500237598147, 0.4029748300787982],
            [10.681398467583652, 0.40918525417053764],
            [10.682311601754565, 0.419752660429214],
            [10.685096940363147, 0.41961321680119523],
            [10.68749463989208, 0.4226405622520121],
            [10.690670976411317, 0.4232392164037397],
            [10.692441421436769, 0.42844351152990695],
            [10.689877242907981, 0.42985855171927856],
            [10.694325882873803, 0.4428955187526491],
            [10.757079417503412, 0.5180039090677904],
            [10.763712326830666, 0.5260958367231856]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.68777486222518, "lat": 38.35955117526263 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21019"],
        "coty_name": ["Boyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boyd County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00516856"
      },
      "bbox": [
        10.664908530720536, 0.24455964196512556, 10.867786962241036,
        0.5260958367231856
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.047850075247753, -0.584726832010866],
            [9.046326623619624, -0.5365327382573953],
            [9.065781782746614, -0.5329287292129142],
            [9.14295914743708, -0.5112080758847517],
            [9.212430802347209, -0.49072741679234755],
            [9.221929641958601, -0.4769128583734397],
            [9.26029968250873, -0.4766022627000967],
            [9.264106642311113, -0.47568450794055267],
            [9.269190773800977, -0.47790622795405424],
            [9.265723273901758, -0.4830019841788862],
            [9.262977553229357, -0.4912169202592047],
            [9.270459242517449, -0.4937645201001717],
            [9.27625465585441, -0.4912223341030127],
            [9.280226408748513, -0.49484411872116374],
            [9.285233369743922, -0.4917260571450646],
            [9.293742378693013, -0.48831969509426126],
            [9.297072167351518, -0.48815185463000355],
            [9.29882624371916, -0.490865060346069],
            [9.295345715000787, -0.49852762698945857],
            [9.298051080050497, -0.503435756428968],
            [9.301274676446, -0.5036943960998507],
            [9.304831065418401, -0.49950659791853064],
            [9.309322018773234, -0.4966559970284746],
            [9.312208853024721, -0.4998334896678766],
            [9.310451479536074, -0.5025088693198926],
            [9.314976536371912, -0.5078110773683562],
            [9.31142630995029, -0.5113447106141602],
            [9.30194340327207, -0.5169610745901897],
            [9.298225175598448, -0.5215421507352609],
            [9.300741299867726, -0.5242457284435554],
            [9.306188390906453, -0.5204626700404072],
            [9.310366120743684, -0.5258809568223322],
            [9.31464035724823, -0.524702627577951],
            [9.318610503513511, -0.5285507547880769],
            [9.318883091590099, -0.5308612510557352],
            [9.310720929897757, -0.5380339720208556],
            [9.30847509837919, -0.5440329893244275],
            [9.314763821689764, -0.5446865718422279],
            [9.320668693635124, -0.5469547708454109],
            [9.325326136391283, -0.5425357625189935],
            [9.320099658888077, -0.5413359471822787],
            [9.320254977640229, -0.5376257337540187],
            [9.327720689768054, -0.5355673709241952],
            [9.328925750595479, -0.5296291952450424],
            [9.333901019546884, -0.5271504428582793],
            [9.33680296573062, -0.5275591379266463],
            [9.340313049204942, -0.5315092337366913],
            [9.339487791147562, -0.5406138478429534],
            [9.335193060737614, -0.5394945078611513],
            [9.330427610112629, -0.5427891533187805],
            [9.33241463920175, -0.549313043029938],
            [9.337102282566116, -0.5473355116529951],
            [9.34099223593988, -0.5540846701599268],
            [9.341255088480382, -0.5581069177747983],
            [9.339049594535567, -0.5641357379877591],
            [9.335412237500925, -0.5581108020523293],
            [9.333013086227336, -0.5651114453749388],
            [9.327837966324077, -0.5673696495958712],
            [9.324359666053853, -0.5654439668859124],
            [9.325779824227334, -0.5623999988228788],
            [9.32409459061794, -0.5595935262665208],
            [9.318858470004264, -0.5632608252598393],
            [9.313631545427613, -0.5624235181962138],
            [9.309941386745283, -0.5663201896411388],
            [9.309981160402453, -0.5689666183254507],
            [9.316388275669285, -0.5721851603050486],
            [9.310799952081997, -0.5756924835900988],
            [9.310875589678023, -0.5777071648302682],
            [9.291355354567242, -0.5966940096169869],
            [9.273871604647429, -0.6046036306414847],
            [9.274827089646887, -0.5959299129893891],
            [9.273114576427655, -0.5925277986812675],
            [9.266087936067038, -0.5948682926758513],
            [9.268946632465452, -0.6022108852785024],
            [9.273626991581692, -0.6047130593658908],
            [9.246584828077012, -0.6169021193421229],
            [9.199998431430174, -0.6512462621956416],
            [9.16240081896166, -0.6721689134392812],
            [9.122467708587259, -0.6759692726004419],
            [9.081038182188777, -0.6801302608974411],
            [9.079125986519642, -0.6652031237118324],
            [9.077508709811076, -0.6672157435542229],
            [9.070461009450645, -0.6634294896933699],
            [9.063061750059726, -0.6656523871381894],
            [9.059655212512396, -0.6654345313974408],
            [9.050444520987027, -0.6718843207583068],
            [9.048519754976699, -0.619791213695248],
            [9.047850075247753, -0.584726832010866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.86672847767838, "lat": 37.62439284218141 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21021"],
        "coty_name": ["Boyle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boyle County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00516857"
      },
      "bbox": [
        9.046326623619624, -0.6801302608974411, 9.341255088480382,
        -0.47568450794055267
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.250393880113386, -0.5008854374397713],
            [7.25416053869813, -0.5023484170505672],
            [7.269040122554139, -0.5114063241857645],
            [7.278618123670259, -0.5183003426808378],
            [7.289276846045106, -0.527028508499382],
            [7.307343421919999, -0.5366921125531414],
            [7.319198257804945, -0.543851629397628],
            [7.332452777071603, -0.5472794490879553],
            [7.354605372918532, -0.5487412602660239],
            [7.358758781634013, -0.547157731318369],
            [7.363208429468417, -0.5475989955912689],
            [7.3703235923141195, -0.552438214980714],
            [7.383657849662454, -0.5710808040120855],
            [7.3879941302636984, -0.5799348360561584],
            [7.391543936048039, -0.5940487870865392],
            [7.395704679324001, -0.6000842946522366],
            [7.404660452220038, -0.6030913431897982],
            [7.410615279303326, -0.6030016153647348],
            [7.422009028465151, -0.5989857698560164],
            [7.427026375519205, -0.5958741805509258],
            [7.4344108270672065, -0.5888547215912433],
            [7.441007519801909, -0.5807128247226182],
            [7.445731714418286, -0.5674229691649205],
            [7.446909022430128, -0.5591714700571612],
            [7.448674392553232, -0.5536008999470838],
            [7.452837294531075, -0.5215401911866543],
            [7.455194798758541, -0.5113784560082207],
            [7.4540177393559786, -0.4999389906229563],
            [7.451357280745826, -0.4924473255749243],
            [7.451251341365498, -0.485602772430079],
            [7.454519730548536, -0.4783124637880515],
            [7.4587045627214446, -0.4727944519471267],
            [7.474469933682494, -0.4586799207084474],
            [7.481173429871796, -0.4543039759296444],
            [7.499450522177834, -0.4446175138051333],
            [7.501167262559605, -0.45060863502361614],
            [7.504414891710505, -0.45619179941741883],
            [7.501026417131153, -0.46108011797500964],
            [7.501148635296417, -0.4654799352236517],
            [7.498497313470828, -0.46752363259947494],
            [7.496135939567346, -0.4782529139878742],
            [7.500185031370599, -0.47974018867817325],
            [7.5081603714541085, -0.47731621975209876],
            [7.518338973115044, -0.4755362763996832],
            [7.525803637441489, -0.4692363999390552],
            [7.534396705819921, -0.46320913970764666],
            [7.537876863716817, -0.4617491799940184],
            [7.543027035508605, -0.4645337174149414],
            [7.551191921142052, -0.4662955465453995],
            [7.555414483792803, -0.4689663537691195],
            [7.551848348618772, -0.47380528743396905],
            [7.554555754115652, -0.47555525699262435],
            [7.558778577268704, -0.4743284582936661],
            [7.557463974029591, -0.48393849525346383],
            [7.564066569999968, -0.4871221144632921],
            [7.57036629374761, -0.4867228899155463],
            [7.5677416238889155, -0.4957327324675971],
            [7.561352859680969, -0.5027644201658479],
            [7.563108410950711, -0.5073657787846979],
            [7.5619652298044855, -0.516176214120844],
            [7.559304478187441, -0.5196532652323403],
            [7.561081837048466, -0.5238589874620221],
            [7.558361628053442, -0.52789959849143],
            [7.559945552500468, -0.5329222426865197],
            [7.5690132882844905, -0.539103348387115],
            [7.573796714666823, -0.539510229621393],
            [7.579298533334179, -0.5371807755919471],
            [7.580307371769161, -0.5322053102374193],
            [7.583950998156427, -0.5318334791156161],
            [7.605160076480334, -0.5251939279174191],
            [7.616172339428625, -0.5453228284316024],
            [7.6387053015830455, -0.571884771189065],
            [7.6390163251792345, -0.6264700383939998],
            [7.608202577819514, -0.6587691274117506],
            [7.649855366942579, -0.6902858828045179],
            [7.644873480125613, -0.69355929965504],
            [7.6424989178542395, -0.6976238761068501],
            [7.631612171207971, -0.7005657984619706],
            [7.623063987256197, -0.7120014256888536],
            [7.615272198067085, -0.7182217951139711],
            [7.605264829006225, -0.7217340556731212],
            [7.604732817968702, -0.7259940211793694],
            [7.5942121489921925, -0.727056628643763],
            [7.592600618302333, -0.7310590519917458],
            [7.586661125463308, -0.7365441343088482],
            [7.585938508374211, -0.741080788024139],
            [7.578002291456676, -0.7411056477332532],
            [7.57602875873699, -0.7462844454096028],
            [7.571161297952557, -0.7467558485481324],
            [7.566170594619036, -0.7491335139041132],
            [7.564151698564204, -0.7468091106908546],
            [7.559988727252174, -0.7478250278434707],
            [7.557164223794186, -0.74493338699742],
            [7.551971675992451, -0.7435996997388097],
            [7.548678654206269, -0.7464722852669626],
            [7.52418721030451, -0.7793220433719452],
            [7.511624582669655, -0.7982315908300828],
            [7.488365042955003, -0.820377794690863],
            [7.484339356887767, -0.8172127041755125],
            [7.4799167004518665, -0.8158841124858855],
            [7.472452583755042, -0.8118078518449026],
            [7.4664263329599265, -0.8104969491284846],
            [7.464432999728748, -0.814432252294542],
            [7.45763078676836, -0.8160821276424696],
            [7.443025648139403, -0.8184375016907367],
            [7.434900862571166, -0.8168962780248324],
            [7.432275679664989, -0.8151579248037757],
            [7.408376808682263, -0.8128640215114037],
            [7.400009239288468, -0.8090398212656976],
            [7.393757956233244, -0.8039220993133165],
            [7.308118395788056, -0.7751393979844792],
            [7.187734616025756, -0.7237320645736487],
            [7.189722659535341, -0.7174178737656677],
            [7.194278571277048, -0.7083835493319823],
            [7.196730826224157, -0.695836057310064],
            [7.194699245704724, -0.685987951220987],
            [7.195324059835674, -0.6820500135818057],
            [7.200101673783184, -0.6755113521704732],
            [7.206307803629754, -0.6700073745570412],
            [7.212260677540343, -0.666498951808078],
            [7.236469044832413, -0.6629547177744239],
            [7.2508131128207225, -0.6582093998677203],
            [7.2652269978939215, -0.6456641755956278],
            [7.273260884465214, -0.6373304261281215],
            [7.276401865274794, -0.6281335368059363],
            [7.285667257396043, -0.6168800238211114],
            [7.283417850090474, -0.6128859831657054],
            [7.267945058445247, -0.6147489250723399],
            [7.26409336895481, -0.6123110354851975],
            [7.263687585211301, -0.6062652179211008],
            [7.261830650366403, -0.6028237574759087],
            [7.257096704315331, -0.6035825939708429],
            [7.253628518873283, -0.6006720275505488],
            [7.254902149605048, -0.5957873938625092],
            [7.258638212524854, -0.5901363406281877],
            [7.258083124995037, -0.587383524033975],
            [7.254552013343917, -0.5841573825886064],
            [7.248130653993018, -0.5837715506249439],
            [7.244923673838671, -0.5811439848801101],
            [7.241697733006676, -0.5812497419353738],
            [7.250393880113386, -0.5008854374397713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.08728568454893, "lat": 37.73176049751725 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21059"],
        "coty_name": ["Daviess"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Daviess County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00516876"
      },
      "bbox": [
        7.187734616025756, -0.820377794690863, 7.649855366942579,
        -0.4446175138051333
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.836060534719157, -0.7830684650621775],
            [7.841689377635339, -0.7787478999235552],
            [7.846759957876076, -0.7714220315290444],
            [7.852918899046845, -0.7640512898167521],
            [7.8467866464477565, -0.7556448156767264],
            [7.845232699260026, -0.7509551759983996],
            [7.846427567386485, -0.7462346197415867],
            [7.855246241179892, -0.7478367644214047],
            [7.859778925280794, -0.7469224564799087],
            [7.864491662946677, -0.7482882790301163],
            [7.865948352086344, -0.7556743501680121],
            [7.875237961308393, -0.7549289229363717],
            [7.878790208904262, -0.7529271741459795],
            [7.886213663248109, -0.7441238520814358],
            [7.886533080328414, -0.7403413291103939],
            [7.878148914482382, -0.7398420817332362],
            [7.872548350920999, -0.74307837314223],
            [7.874879838866156, -0.7361157326894199],
            [7.875198294492878, -0.7293205841752021],
            [7.877327912534312, -0.7268621547816574],
            [7.886754568092711, -0.7254091543044395],
            [7.893575019656909, -0.7179060517029401],
            [7.900096851674569, -0.7179964004251252],
            [7.902535273862248, -0.7197358509901026],
            [7.907005850310871, -0.7263433460983533],
            [7.906764392203066, -0.7300736173903966],
            [7.90086007899645, -0.7330402966520939],
            [7.9009457270838785, -0.7384486500576817],
            [7.903677297853567, -0.7392839850523198],
            [7.909984865665663, -0.7323331474023552],
            [7.912190479475666, -0.7285903870787108],
            [7.918020491810925, -0.7273229068548409],
            [7.920327000974319, -0.7341430876173232],
            [7.92328483103644, -0.7371246582248564],
            [7.927044390107572, -0.7366836910374042],
            [7.928833993677983, -0.7412175253349853],
            [7.925298051354643, -0.743986392463568],
            [7.925420427263915, -0.7477441301780953],
            [7.933633303044961, -0.7475146249898813],
            [7.935839028008172, -0.745382661938848],
            [7.940944466050974, -0.7448552315896375],
            [7.941226273443203, -0.7503282672579168],
            [7.933728582013733, -0.7525192876413278],
            [7.933631191865763, -0.7555086118254064],
            [7.937821160261669, -0.7564415888305045],
            [7.944570663801224, -0.7538669001803291],
            [7.945719317376359, -0.7470247428360568],
            [7.949261827143795, -0.7461306482688935],
            [7.9485716823753005, -0.7594236804431734],
            [7.9534532320865186, -0.7589809859943204],
            [7.954036649210195, -0.7546952631451319],
            [7.9571320528428915, -0.7512682136945281],
            [7.958023055789527, -0.7583025365727748],
            [7.963582189773241, -0.7574771574929275],
            [7.965384357777979, -0.7537206763714851],
            [7.970761361657243, -0.7549733239471774],
            [7.972922828069951, -0.7607353268066208],
            [7.9767748951962405, -0.755950077714062],
            [7.9797146661082925, -0.7582606920223333],
            [7.977748799076162, -0.7640811530420782],
            [7.98436293299483, -0.7661332502568994],
            [7.991660285247551, -0.7637697300217962],
            [7.994066116421822, -0.7569927746573792],
            [8.000579634260049, -0.7586974041877809],
            [7.996344243724488, -0.7627424473709628],
            [8.004995657184056, -0.7670867480008472],
            [8.008176551699103, -0.7614473802421059],
            [8.014050435037333, -0.7571973828315623],
            [8.016461298780122, -0.7588936645217529],
            [8.014070425365082, -0.7674989066597648],
            [8.023567905897691, -0.7658218262815986],
            [8.024661827607066, -0.7605118729231057],
            [8.024114156378348, -0.7523719750600563],
            [8.021284465021152, -0.7414917107094823],
            [8.022109267771699, -0.7398862931856546],
            [8.028569517381335, -0.7412954470301775],
            [8.028825791192078, -0.7363051501354756],
            [8.033217271652942, -0.7383429424224236],
            [8.04248287933335, -0.7388800509155444],
            [8.041461966360949, -0.7439292794822289],
            [8.04932383294215, -0.7429880133821588],
            [8.055712075872714, -0.7459095320662635],
            [8.05807448084023, -0.7388460053286214],
            [8.057228851845903, -0.7325421017930861],
            [8.061253283221431, -0.7291926860805203],
            [8.062956903154378, -0.732002345767751],
            [8.059379479795862, -0.7364753673594832],
            [8.06410080162269, -0.7378402454427059],
            [8.064485545443656, -0.733264752705362],
            [8.068539387417204, -0.7359137042607599],
            [8.071110681778334, -0.7323259340922577],
            [8.075363820290493, -0.7306412528554158],
            [8.077421373197124, -0.7273018125824683],
            [8.081051155693913, -0.7287370086543389],
            [8.080828421196514, -0.7347110271661174],
            [8.087540151231309, -0.7370922146696374],
            [8.090119499740853, -0.7327456532117936],
            [8.094108203762739, -0.7345889807973714],
            [8.09592058894027, -0.7279062188697384],
            [8.100404580218424, -0.725841009465036],
            [8.10080388209832, -0.7222725511427819],
            [8.104212695763946, -0.7208536980955527],
            [8.10755013345613, -0.7226314027020021],
            [8.107416582734068, -0.7269846091318439],
            [8.110802098691908, -0.7290952672693399],
            [8.11136465704147, -0.7337259255210077],
            [8.116213389712525, -0.7437929956007996],
            [8.118908794466853, -0.7417751402541671],
            [8.121605415323137, -0.7369422057174622],
            [8.124842300306488, -0.7368100787847687],
            [8.125165210839354, -0.7419466059851064],
            [8.130883180226094, -0.7413042625538814],
            [8.132479564470351, -0.738321377027132],
            [8.137843137914745, -0.7441793112763727],
            [8.142931418618428, -0.7455623743567314],
            [8.146061672487383, -0.7504469607952268],
            [8.150709713243335, -0.7502174252736048],
            [8.152481663648521, -0.7541654270296783],
            [8.15678897492151, -0.7523821559647663],
            [8.162038596454769, -0.7596462394291191],
            [8.164413855178758, -0.7580821983752561],
            [8.162949090877435, -0.7522489029779468],
            [8.169179058007543, -0.7458566000505248],
            [8.173193852988435, -0.7503032344674315],
            [8.17732092628685, -0.7499261706700442],
            [8.187805208143423, -0.752194937298399],
            [8.189227884028403, -0.7474308499167605],
            [8.194570331099957, -0.7476145755479053],
            [8.195658716777004, -0.7441916757859123],
            [8.201706467714073, -0.7429968521330464],
            [8.207953523537059, -0.7455044969966551],
            [8.209613148523774, -0.7422145976961648],
            [8.221048203269818, -0.7577834278988279],
            [8.2549053766034, -0.7976057479525429],
            [8.25636800522362, -0.8022097252605817],
            [8.26071040407676, -0.8034971502057779],
            [8.258719486825461, -0.807144773246447],
            [8.264159656590872, -0.8098772522957929],
            [8.262353321038757, -0.8139065977850107],
            [8.258772916431958, -0.8154814165288953],
            [8.26614467093015, -0.8208537809369352],
            [8.267609341621222, -0.8257771903521832],
            [8.264984534472612, -0.8330103147028383],
            [8.261583518170701, -0.8328099712669107],
            [8.259521159224583, -0.8378802106899546],
            [8.260169059204676, -0.8407178193937423],
            [8.25769686043256, -0.848598446327329],
            [8.266391462619158, -0.8519317682768504],
            [8.270883268836565, -0.8518519202772524],
            [8.273895321496587, -0.8544644136179718],
            [8.275924124529508, -0.8564826890602689],
            [8.272029786833333, -0.8612361166432163],
            [8.274432895600256, -0.8639339042869887],
            [8.27867252493162, -0.8648842375012253],
            [8.27686137294168, -0.8689772061928767],
            [8.282687107988348, -0.8691575629499823],
            [8.278896680796048, -0.8731815723199426],
            [8.27959699653254, -0.875434870879046],
            [8.288309099523204, -0.8764220142616157],
            [8.287546225329033, -0.8807815641747208],
            [8.288865602138033, -0.8851564922610656],
            [8.283407560742589, -0.8867926520974552],
            [8.285563741118747, -0.8925303760630219],
            [8.281325596150094, -0.8954156532535994],
            [8.282296446272419, -0.898811043996232],
            [8.285475255795248, -0.9000645898805497],
            [8.295504766167747, -0.8998699618459668],
            [8.296677990752157, -0.9049170411403702],
            [8.301753563737389, -0.9061092455066246],
            [8.300533904935111, -0.9087312192964738],
            [8.291635758027317, -0.9122905965525238],
            [8.288640672968311, -0.9090524435864517],
            [8.283688934526076, -0.9091712032857618],
            [8.2831725694885, -0.91187420419703],
            [8.28694191090242, -0.916660562100147],
            [8.287545079958287, -0.9210854212613088],
            [8.282709403785256, -0.9232110863315064],
            [8.281573893218669, -0.92043301100285],
            [8.28453584398691, -0.9150049614838146],
            [8.282470602251871, -0.912436318313852],
            [8.274871276380415, -0.9109251560950595],
            [8.273274187066303, -0.9153861680983769],
            [8.277790571985095, -0.917709770732919],
            [8.276822203043935, -0.920391131286911],
            [8.2726382734097, -0.9204284358571263],
            [8.267508654498217, -0.9170704223606632],
            [8.262672815685194, -0.9180252928122031],
            [8.266868925106822, -0.9222084230579408],
            [8.261847836754585, -0.9257236368955942],
            [8.267374529317323, -0.9304738506297501],
            [8.273031065659673, -0.9295574889852929],
            [8.273517386354882, -0.9322373158242925],
            [8.266347663835921, -0.9329804331170415],
            [8.265452276711688, -0.9385522471223353],
            [8.269773780559627, -0.9426378913349661],
            [8.268597206005646, -0.9492716555539696],
            [8.266519580636142, -0.9523888610622249],
            [8.271778393425484, -0.9545376820268159],
            [8.271313348668977, -0.9575964702441974],
            [8.264270041878532, -0.9589116148316877],
            [8.266913944058452, -0.9664228283274815],
            [8.261878409379609, -0.9656166226762063],
            [8.25835997434622, -0.9630889145971624],
            [8.256206342465205, -0.9672877127410716],
            [8.25171853708032, -0.9656164521654866],
            [8.259432124542995, -0.9594499732049256],
            [8.256410763039137, -0.9559514192080214],
            [8.251105486436792, -0.9571117487757047],
            [8.250756283630588, -0.963070646899587],
            [8.245879034208624, -0.9622204563383177],
            [8.244251063005299, -0.9574997214909167],
            [8.240858543479222, -0.95667369673576],
            [8.23948166003295, -0.9595929312330722],
            [8.242669006494811, -0.967367734852973],
            [8.239746301864047, -0.9711174311799793],
            [8.24342306418893, -0.9745054799487851],
            [8.248950809604569, -0.9756715986839344],
            [8.246135099240346, -0.9788103939468152],
            [8.238164612113321, -0.9763013896624708],
            [8.23254633385466, -0.9716489079170485],
            [8.230560577978693, -0.9775021539173949],
            [8.227523069834957, -0.9786808084049924],
            [8.226789429241018, -0.9727103452535681],
            [8.231661782820828, -0.967065603774454],
            [8.22763542764886, -0.964482977189502],
            [8.225113553176637, -0.9666158091644104],
            [8.223139995014341, -0.9728624336585135],
            [8.219198855747798, -0.972501658936932],
            [8.216061853340555, -0.9681569616261684],
            [8.211016401403366, -0.9689400841653496],
            [8.199976872488428, -0.9688518642972512],
            [8.200275191794779, -0.9649757687307858],
            [8.195220145152415, -0.9641174743664341],
            [8.199181303480898, -0.9711128787274369],
            [8.202619699091064, -0.9742016644955155],
            [8.199819621948292, -0.9782210320764322],
            [8.189769250769164, -0.9828823466459184],
            [8.184946006667339, -0.9826874029512958],
            [8.181922530782868, -0.9783804465566037],
            [8.176810421277098, -0.9788696547476597],
            [8.173310995625467, -0.9768772608802218],
            [8.172193595220785, -0.9827958653815879],
            [8.173944259346861, -0.9860474000349595],
            [8.172852075628983, -0.9888787182846052],
            [8.167803750716935, -0.9890266893066223],
            [8.159685456777162, -0.9851403738550393],
            [8.072987591902038, -1.0003430796254373],
            [8.060427198357942, -1.0023490081868136],
            [7.957258966605862, -1.0177910536358115],
            [7.938956255881773, -0.9776195922166127],
            [7.837848965056227, -0.9546048629933015],
            [7.819119837493702, -0.903900047636474],
            [7.787220983084898, -0.8194568462771923],
            [7.7846644257682875, -0.8158320819132596],
            [7.784327405765166, -0.8109404529888744],
            [7.779664426439876, -0.8068007406630012],
            [7.778009412049511, -0.8036632798630817],
            [7.780518198331008, -0.7963860240559966],
            [7.794628886538923, -0.7960922049863358],
            [7.7969888928595, -0.7919995743269875],
            [7.797188611713355, -0.788040067839997],
            [7.802151456832821, -0.7846134118362588],
            [7.805660018105828, -0.78578648917228],
            [7.810512186175105, -0.7840514335582301],
            [7.815754429546457, -0.7956251191398045],
            [7.824790713383764, -0.7980590403120272],
            [7.8249947757285545, -0.805242861490655],
            [7.834678505848994, -0.8101847385679664],
            [7.833754322410585, -0.8030439224851643],
            [7.839698096039961, -0.79850778364921],
            [7.846797551573851, -0.7992533169543337],
            [7.849506685765808, -0.7924442584802277],
            [7.840730318829242, -0.789958049731205],
            [7.835254560422679, -0.7872254581369138],
            [7.836060534719157, -0.7830684650621775]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.34396656207439, "lat": 37.46077699042727 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21085"],
        "coty_name": ["Grayson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grayson County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00516889"
      },
      "bbox": [
        7.778009412049511, -1.0177910536358115, 8.301753563737389,
        -0.7179060517029401
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.311569116570944, 0.3226853355523091],
            [9.315758280701713, 0.3235014565149689],
            [9.322001852271988, 0.3304385954660239],
            [9.327524597154456, 0.3326670818317825],
            [9.33738511666098, 0.3414591712079327],
            [9.343762485967012, 0.3427867592867101],
            [9.346917598477079, 0.3417347706494967],
            [9.351261770014398, 0.34689293287321854],
            [9.356540774597917, 0.3477616737255553],
            [9.365123689259214, 0.34508823309781034],
            [9.367870540021192, 0.3801820302777064],
            [9.370876642032473, 0.38183717928476407],
            [9.37366076902236, 0.3760640699149638],
            [9.379388236555515, 0.37358572904784315],
            [9.381905736651708, 0.375843944229883],
            [9.383835439820995, 0.3712099014928178],
            [9.387496883627255, 0.37067622709570447],
            [9.390382518711265, 0.3769419036267089],
            [9.40048311316107, 0.37784369292275155],
            [9.401772108179635, 0.38070422240238455],
            [9.405596087179841, 0.38090142411931016],
            [9.409255603703167, 0.3882302092640735],
            [9.404631116951544, 0.3884749926310254],
            [9.409818411787352, 0.39444860236127555],
            [9.405378321748596, 0.3975184681450631],
            [9.413026728325942, 0.40318225995898554],
            [9.414274046514903, 0.40816313012751027],
            [9.420984758528421, 0.40926440014052423],
            [9.424088361381314, 0.40524312813774865],
            [9.502514189261277, 0.4263695025869176],
            [9.571253027698203, 0.4452560879649111],
            [9.575669925007947, 0.4332799161720834],
            [9.574539130178286, 0.42727053586620656],
            [9.566668099122039, 0.42512091325659895],
            [9.56454004585752, 0.4210694129707029],
            [9.570559053087145, 0.41344716810979915],
            [9.580354742067138, 0.41465686502650034],
            [9.584052827991052, 0.4179066847810962],
            [9.586829007562663, 0.4171879681315417],
            [9.593960530430726, 0.42408593972706204],
            [9.599093660439465, 0.4237977201758086],
            [9.603352157240398, 0.42564118507197507],
            [9.60802853697927, 0.4214467660692066],
            [9.607322580751482, 0.41213465068843913],
            [9.608675524337729, 0.40663990775062875],
            [9.60226687783041, 0.40059519388437387],
            [9.598059673920654, 0.3984724370880598],
            [9.598487569060605, 0.38788682321057766],
            [9.596623867223705, 0.3846997515372168],
            [9.598242981492383, 0.3738447679040118],
            [9.59824593839643, 0.3631286702515625],
            [9.60046922172715, 0.36146390840498993],
            [9.605596026042038, 0.3682116682348589],
            [9.615100997460676, 0.3690703886246759],
            [9.617820661979406, 0.3668627727907054],
            [9.616463035683271, 0.36264050141617243],
            [9.610416425943063, 0.36142265136846663],
            [9.606659211187127, 0.35723217088451065],
            [9.609758832214057, 0.3522936188518464],
            [9.614494027160406, 0.35208630093566956],
            [9.622856304782243, 0.3580487548073741],
            [9.624552696627706, 0.35745330035030803],
            [9.624763001351887, 0.35043236901251573],
            [9.628928956083795, 0.3450713806109532],
            [9.633803130115005, 0.3459552796147515],
            [9.635335371913918, 0.3501031849932774],
            [9.639105961460034, 0.3531663099314316],
            [9.64146710872674, 0.35126753649529024],
            [9.640777310796302, 0.3462746771296247],
            [9.642693118766866, 0.34506190937620845],
            [9.647397872008716, 0.34719553921444113],
            [9.652609709773232, 0.3438131418334188],
            [9.661672159915186, 0.3412837488103685],
            [9.664178440784685, 0.3338236272859219],
            [9.6660263739947, 0.33230565372522686],
            [9.614595431990216, 0.24889571303081098],
            [9.606239625501816, 0.23563308233711291],
            [9.557860811007568, 0.1815206044526559],
            [9.547909758085973, 0.1709576032910037],
            [9.54596115424668, 0.16780393894750564],
            [9.539207723542992, 0.16720037702307844],
            [9.538578497777372, 0.1712006540653217],
            [9.533947172815422, 0.17167230383040957],
            [9.537170370847347, 0.1657403416348052],
            [9.530799423047169, 0.16481659075137947],
            [9.525380742978289, 0.16527790537700457],
            [9.523488980684332, 0.1564869816191724],
            [9.521144386108302, 0.15403000312724566],
            [9.519225325448497, 0.14770839013455866],
            [9.515980756314365, 0.1491177718493365],
            [9.513870044700516, 0.1453713222318112],
            [9.509802725324958, 0.14349780761607756],
            [9.503927901849826, 0.1464054779905885],
            [9.501345496932355, 0.1445110582335048],
            [9.506493195568781, 0.1393330836073556],
            [9.500705287257682, 0.1343166879049685],
            [9.492213329625153, 0.13645921112038265],
            [9.485683265977908, 0.14237956432615678],
            [9.483888729472758, 0.1370879479810776],
            [9.483228313330232, 0.13101615670089284],
            [9.480258821648855, 0.12616621293332408],
            [9.470885029315221, 0.12463173152743305],
            [9.468118568318564, 0.12740114191659935],
            [9.456952053518076, 0.12770850423293886],
            [9.446255962009621, 0.13012512031289294],
            [9.443266486504918, 0.12952091986080402],
            [9.439646799498751, 0.12282415618270372],
            [9.433289300050614, 0.12121616711805173],
            [9.429546147953062, 0.1241217323525261],
            [9.42551810522577, 0.12324788391788205],
            [9.423710859438476, 0.12491926222129145],
            [9.425529793489122, 0.1364022271850499],
            [9.431027360335207, 0.14001750841659696],
            [9.429753300299865, 0.1450510772206253],
            [9.42377046640149, 0.15547146889347271],
            [9.423186639492194, 0.15961383193554993],
            [9.419894302208974, 0.16054415598023206],
            [9.417402707715459, 0.16413400471382433],
            [9.41703070188312, 0.16838362756060807],
            [9.4122442497188, 0.17070344833860415],
            [9.408768760605101, 0.17538394487582837],
            [9.407232109749463, 0.18143441746875288],
            [9.403479310219561, 0.1868736785189412],
            [9.400971421922398, 0.19630412261569224],
            [9.40153611864967, 0.2043902008015898],
            [9.400616804194087, 0.21069402032447804],
            [9.401585266806388, 0.21516004570977004],
            [9.39450706361058, 0.22591690861611077],
            [9.39280411997744, 0.2307955841563206],
            [9.389429594790583, 0.23197416778663035],
            [9.386848043132078, 0.23748333600569888],
            [9.380943991350094, 0.2404017524856822],
            [9.37702477532977, 0.2464389411816974],
            [9.373759384673141, 0.24741676835880302],
            [9.36839413137457, 0.25262626802769567],
            [9.362727777373943, 0.25338169275493044],
            [9.346013400189957, 0.26116358433111403],
            [9.341467421845117, 0.26561661052156926],
            [9.341996143537274, 0.27058558180877273],
            [9.340791221013376, 0.2824116026156875],
            [9.33573377583395, 0.2905204803248006],
            [9.325345963788395, 0.29568802109148434],
            [9.322465451295562, 0.2987578151127855],
            [9.31776816808429, 0.3095994364130024],
            [9.315302937706745, 0.32008370743882186],
            [9.311569116570944, 0.3226853355523091]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.33147824297127,
          "lat": 38.441823746037784
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21097"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00516895"
      },
      "bbox": [
        9.311569116570944, 0.12121616711805173, 9.6660263739947,
        0.4452560879649111
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.764220125655987, -0.5398343748431876],
            [6.7678553819387535, -0.533260886657625],
            [6.779593742973882, -0.5150239905880637],
            [6.784603975670086, -0.5119387517500629],
            [6.788919515867872, -0.5111482655419443],
            [6.796186377081122, -0.5122413452184229],
            [6.805028821255511, -0.5167935376202228],
            [6.810548956784498, -0.5222268041710041],
            [6.814493010874821, -0.5276612389952431],
            [6.818693258078115, -0.5362457619225517],
            [6.8276811685291605, -0.5426844514178503],
            [6.828196502410068, -0.5482570006700613],
            [6.834778384000862, -0.5556173990058015],
            [6.842179508968669, -0.5587766282479035],
            [6.859596469771708, -0.5584808513161061],
            [6.8692154525311375, -0.5576095466149003],
            [6.875939526339479, -0.5557269520295033],
            [6.879386222890274, -0.553138633906883],
            [6.893245960749851, -0.5398499659951727],
            [6.911947150359931, -0.5342098753474191],
            [6.923459550317002, -0.5358817148922604],
            [6.93338736636914, -0.533149288247311],
            [6.940803683473842, -0.5285884205219806],
            [6.950972681424513, -0.5223326193461846],
            [6.957144657567687, -0.5218915250494549],
            [6.963158815437395, -0.5245554855212917],
            [6.9673472865366985, -0.5282816708370357],
            [6.970059161941757, -0.5371937408975157],
            [6.968772221227268, -0.5442860450769128],
            [6.959348786106704, -0.5693746947733751],
            [6.959979970173961, -0.5789561379755115],
            [6.962983370557779, -0.5889193433290353],
            [6.968909837842834, -0.5956912326384134],
            [6.973635228631238, -0.5969708556628875],
            [6.982605114202026, -0.5976192364530462],
            [6.989873799046915, -0.5971189644024899],
            [7.005832291532672, -0.5924894115837838],
            [7.013065787977306, -0.588913308207762],
            [7.0193254417706905, -0.5815725378230785],
            [7.030265892528642, -0.5604184906528247],
            [7.03108015879597, -0.5497992304711197],
            [7.033968634200913, -0.5459937198608181],
            [7.033615355936931, -0.5403531320427132],
            [7.03036001633758, -0.5337708627998073],
            [7.021920890475812, -0.5268797318368338],
            [7.009697673054196, -0.518828448139203],
            [7.002130951729844, -0.5131395106446708],
            [6.997655315434115, -0.5050683769696416],
            [6.995312429420193, -0.4989649026665268],
            [6.99669483616196, -0.4913737004214508],
            [7.001400290695776, -0.48659173586351373],
            [7.000747111738051, -0.4819974735055656],
            [7.008663576944971, -0.47272397117242315],
            [7.010181965482401, -0.4693759703003718],
            [7.010946457086537, -0.45903191548477307],
            [7.010437338805625, -0.451974683869844],
            [7.011420795838043, -0.4478153301892933],
            [7.015304288160987, -0.4438662615549165],
            [7.0243622790695595, -0.44326851247116716],
            [7.028812206385506, -0.4460403743167458],
            [7.0318320768711455, -0.44957878917871347],
            [7.033605756985585, -0.45516926614439224],
            [7.033737067881888, -0.46012104372623214],
            [7.032237583552363, -0.46524713452752053],
            [7.034926496911428, -0.4656620541482752],
            [7.036509144850878, -0.4705983541957364],
            [7.045541293737933, -0.48332175250933723],
            [7.05464374052505, -0.4904925789121019],
            [7.070825708314131, -0.4982945472604281],
            [7.07990921246676, -0.5012133825681415],
            [7.087303060385609, -0.506829238434149],
            [7.090401001989976, -0.5062435583842465],
            [7.098244282020268, -0.5010420461100458],
            [7.108481329314433, -0.4888753150430116],
            [7.120619922112117, -0.4761960111169977],
            [7.131106916275946, -0.46775468683469784],
            [7.14122066958644, -0.4636588814672656],
            [7.148529825516841, -0.4621628248845751],
            [7.151828493173492, -0.4626036015012185],
            [7.1602123699321, -0.46144308775263887],
            [7.169020462183084, -0.4627039622301389],
            [7.174264535789531, -0.46476398715508027],
            [7.18254801253669, -0.4665586514792995],
            [7.1923640506252475, -0.47117476011363346],
            [7.192496259777824, -0.47225679807954934],
            [7.200886555742275, -0.48053433205538715],
            [7.206826123303735, -0.48254713109290004],
            [7.209958386259258, -0.4859432066903524],
            [7.216483131654405, -0.490343601224656],
            [7.223891193737724, -0.4934804286884696],
            [7.225608032110748, -0.49237538050079616],
            [7.236592826912907, -0.49422361290576317],
            [7.250393880113386, -0.5008854374397713],
            [7.241697733006676, -0.5812497419353738],
            [7.244923673838671, -0.5811439848801101],
            [7.248130653993018, -0.5837715506249439],
            [7.254552013343917, -0.5841573825886064],
            [7.258083124995037, -0.587383524033975],
            [7.258638212524854, -0.5901363406281877],
            [7.254902149605048, -0.5957873938625092],
            [7.253628518873283, -0.6006720275505488],
            [7.257096704315331, -0.6035825939708429],
            [7.261830650366403, -0.6028237574759087],
            [7.263687585211301, -0.6062652179211008],
            [7.26409336895481, -0.6123110354851975],
            [7.267945058445247, -0.6147489250723399],
            [7.283417850090474, -0.6128859831657054],
            [7.285667257396043, -0.6168800238211114],
            [7.276401865274794, -0.6281335368059363],
            [7.273260884465214, -0.6373304261281215],
            [7.2652269978939215, -0.6456641755956278],
            [7.2508131128207225, -0.6582093998677203],
            [7.236469044832413, -0.6629547177744239],
            [7.212260677540343, -0.666498951808078],
            [7.206307803629754, -0.6700073745570412],
            [7.200101673783184, -0.6755113521704732],
            [7.195324059835674, -0.6820500135818057],
            [7.194699245704724, -0.685987951220987],
            [7.196730826224157, -0.695836057310064],
            [7.194278571277048, -0.7083835493319823],
            [7.189722659535341, -0.7174178737656677],
            [7.187734616025756, -0.7237320645736487],
            [7.1850591746606245, -0.7329827539295238],
            [7.179600161357882, -0.7380647934907574],
            [7.165553290335227, -0.7385460263201394],
            [7.145199913308081, -0.7436966584757454],
            [7.139266120115493, -0.7470612328015257],
            [7.136438122252949, -0.7509115268851094],
            [7.124052456470172, -0.7645585155881026],
            [7.123246567352072, -0.7660612655342309],
            [7.10088161942108, -0.7694663235970538],
            [7.0400836459172575, -0.7777214220584725],
            [7.00746457547321, -0.7817013276066465],
            [6.937215822719179, -0.7918110160003144],
            [6.934117312261882, -0.7854048420283251],
            [6.928919110642608, -0.7770965782733463],
            [6.922872613831918, -0.7690381958982665],
            [6.918525786129752, -0.7600359952693889],
            [6.920915594087186, -0.752905626594223],
            [6.915148626279698, -0.7190834289470271],
            [6.9147895763792695, -0.7124333105965165],
            [6.912907998670693, -0.7033289877747647],
            [6.913858278569933, -0.6992772586227567],
            [6.9027967174194185, -0.6815942487531037],
            [6.905206203545441, -0.6706301070981756],
            [6.900040616556665, -0.6686806947933339],
            [6.89621228797959, -0.6653226451153516],
            [6.892546939849986, -0.666910585453725],
            [6.888430420047682, -0.6717169071703891],
            [6.892091580925511, -0.6756047202561288],
            [6.892401885988818, -0.6782586315571487],
            [6.885927210877131, -0.6771818812242955],
            [6.88343593534768, -0.6789868537169373],
            [6.8760108108422875, -0.6737793392260826],
            [6.877244166614633, -0.6686982682173985],
            [6.880816037205966, -0.6630052798778672],
            [6.874794264573469, -0.6609783309782746],
            [6.865876405621348, -0.6633920120313767],
            [6.863086056706862, -0.666354233542527],
            [6.85926065643581, -0.6668394338991358],
            [6.764220125655987, -0.5398343748431876]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.57291970380729,
          "lat": 37.795784194998696
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21101"],
        "coty_name": ["Henderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henderson County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00516897"
      },
      "bbox": [
        6.764220125655987, -0.7918110160003144, 7.285667257396043,
        -0.44326851247116716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.529975827598157, -0.5403252366942888],
            [8.533160049315907, -0.5428882442695121],
            [8.537732854925457, -0.5419354353851094],
            [8.542535706219306, -0.5432345898852567],
            [8.542775118116664, -0.5464883913692611],
            [8.547311967862079, -0.5463800014819379],
            [8.550274083296822, -0.5498798164324548],
            [8.559159553788534, -0.5535770470197178],
            [8.562162670774851, -0.5582432044180177],
            [8.558954750117685, -0.5623393356962265],
            [8.564735629242083, -0.5648233897655672],
            [8.56708490326014, -0.5685146857896276],
            [8.567053280152534, -0.5724381214673162],
            [8.57076873871701, -0.5748390418924744],
            [8.575109184266946, -0.572178624212699],
            [8.576730923837442, -0.5739218280815179],
            [8.590679672745269, -0.5656701802252974],
            [8.59607770211002, -0.5665544098359485],
            [8.60271533735212, -0.5713481343613769],
            [8.602840930595274, -0.5779830766093246],
            [8.604033176786071, -0.5810681909714072],
            [8.602235256938332, -0.589342826737489],
            [8.602538625868688, -0.5970532599040784],
            [8.604999082671812, -0.5991842826816247],
            [8.60230493964112, -0.6029708139487013],
            [8.603716243327264, -0.6066555973882989],
            [8.600099115236539, -0.6086133405020285],
            [8.603834426817771, -0.6179722410354063],
            [8.601701945878112, -0.6191106204616704],
            [8.6019637394699, -0.6262973007822961],
            [8.606516386000559, -0.6258519335212387],
            [8.611051688445468, -0.6208663568118515],
            [8.61501598605178, -0.6203672938626175],
            [8.620410054974753, -0.6245857069262911],
            [8.624193283438107, -0.6255201887679122],
            [8.624339429401997, -0.6343461341962994],
            [8.629460025564999, -0.6399574423280409],
            [8.62866582087946, -0.6463991597783277],
            [8.62561606417121, -0.646652816131887],
            [8.62070340394836, -0.6412459059116371],
            [8.620008874143794, -0.6377323423920165],
            [8.61604039953903, -0.6395790365909588],
            [8.613094550222929, -0.6457319357631812],
            [8.615216832789818, -0.6474926196152101],
            [8.611520673261305, -0.6517643098029473],
            [8.601398541392681, -0.649238745298068],
            [8.59456704244985, -0.6515102154874157],
            [8.59381059235638, -0.6542393685275286],
            [8.59750638596982, -0.6598494897526599],
            [8.60408226556065, -0.6604674623289515],
            [8.615100718479722, -0.6637292801790786],
            [8.611420064961493, -0.6668370386719404],
            [8.612005663688013, -0.6705413783683376],
            [8.609995991616067, -0.6739752747677136],
            [8.606994655944755, -0.6728107397048599],
            [8.603002422511459, -0.6764093221377051],
            [8.605668112652346, -0.6873270844266901],
            [8.60574941542194, -0.693165125168316],
            [8.607384705098823, -0.6975942638262832],
            [8.605614788280576, -0.7052364301563175],
            [8.60148560188734, -0.7073829147933113],
            [8.597588843688413, -0.7112904174046285],
            [8.597045006621874, -0.7148148765898094],
            [8.594361950310786, -0.7168165271766319],
            [8.594435947768607, -0.7220020639380508],
            [8.59967093270024, -0.7274009055350664],
            [8.603889350295884, -0.7262433921958996],
            [8.6081228980888, -0.7187139351529402],
            [8.609695000202645, -0.7231469335554336],
            [8.615369151749718, -0.7313652006651726],
            [8.619547913318629, -0.7339340847048261],
            [8.623500655189094, -0.7338418236145733],
            [8.638088944361652, -0.736814404660028],
            [8.643628120944758, -0.7404085184955278],
            [8.646758514626448, -0.7381637551580478],
            [8.646963384371727, -0.7324209535064591],
            [8.655178918178859, -0.7286649148251084],
            [8.650786496839741, -0.7212382740042546],
            [8.652976861214382, -0.7144818025017207],
            [8.650432430122066, -0.7081910654936169],
            [8.655349085742014, -0.6990945949036698],
            [8.661902463837485, -0.6978858762788345],
            [8.665538224804543, -0.6997320334868044],
            [8.6695059902575, -0.6988024509042251],
            [8.670607930113876, -0.7049272519999766],
            [8.673682746265435, -0.7052970674124908],
            [8.676928673271608, -0.7040233846628594],
            [8.688538359487971, -0.7089877823002175],
            [8.693015852157622, -0.7141356180220744],
            [8.698201929464442, -0.7227217253370616],
            [8.69845992577345, -0.7265119475163362],
            [8.701005037234994, -0.7308173332457508],
            [8.70018988005375, -0.7334679546251417],
            [8.70141681493091, -0.7425969527410861],
            [8.705097398766512, -0.7501185756473197],
            [8.709753231120732, -0.7564375770066623],
            [8.717592362790322, -0.7635575658436768],
            [8.71990289593243, -0.7745571447772147],
            [8.723333519359429, -0.7792663897205031],
            [8.7265417531181, -0.789590941598299],
            [8.720076192006669, -0.7887496637968293],
            [8.715958994403268, -0.790976049937717],
            [8.713374504930053, -0.788855512331016],
            [8.708503965598286, -0.7895620600445596],
            [8.705625937158246, -0.7854999779882278],
            [8.704551485311807, -0.7783504496553756],
            [8.69615139037102, -0.7759928943519455],
            [8.693899233289994, -0.7813880731001968],
            [8.687187775795895, -0.7859067203105586],
            [8.688204151726293, -0.791498286042889],
            [8.679520747425796, -0.7991550415565101],
            [8.678912986223873, -0.8065861958744726],
            [8.672566917816477, -0.8048437373732997],
            [8.667559248940814, -0.8066576962046933],
            [8.666478813193484, -0.8041155449144722],
            [8.661602903357275, -0.803326218278768],
            [8.657282815559697, -0.8046125553115969],
            [8.650024480215663, -0.8039684599987678],
            [8.647685240426704, -0.8001447478875593],
            [8.637804156073084, -0.7994461792474986],
            [8.634465032685826, -0.7953888437765484],
            [8.629132853782592, -0.7967656157234366],
            [8.626857763303134, -0.7958648558487628],
            [8.619236742388292, -0.799576819009895],
            [8.617168264784008, -0.8063251359061813],
            [8.614256667554486, -0.8073201853348284],
            [8.608662041953462, -0.8032056026951788],
            [8.607835241330825, -0.8001372913557251],
            [8.603450877137625, -0.8011044983776037],
            [8.599216564309076, -0.7979788448115894],
            [8.594540627231627, -0.7979790108296992],
            [8.593807699095196, -0.8051571656508939],
            [8.591377590951929, -0.8105809730114873],
            [8.59344596462705, -0.8159817125945223],
            [8.589011352420773, -0.8212549886563487],
            [8.580991486603851, -0.8240879705890486],
            [8.576179169433614, -0.8334104995332079],
            [8.57411551679503, -0.8356854371610684],
            [8.575425019176246, -0.8403182224110456],
            [8.578514112314672, -0.8411875694313047],
            [8.582033780170395, -0.8498122621907479],
            [8.522260987074823, -0.8529335437395549],
            [8.508365645028215, -0.8485292743100512],
            [8.395946929417656, -0.8513104293818027],
            [8.395826738464605, -0.8400754712649017],
            [8.393254489551756, -0.8321697886313453],
            [8.39122516636627, -0.8193198831516326],
            [8.395639472647725, -0.8173569978464917],
            [8.398027470870534, -0.746547081581942],
            [8.398702168151193, -0.7444013418535766],
            [8.42443916949549, -0.7178745496890283],
            [8.437022076960751, -0.7117348573322855],
            [8.438416792380407, -0.7061984419119782],
            [8.437879975078094, -0.7006706182091055],
            [8.442449392035503, -0.6919663169139244],
            [8.446096440871758, -0.6873713913214478],
            [8.445563157404518, -0.682037122052447],
            [8.452458328746387, -0.6748821184632707],
            [8.44894898212807, -0.6688792707358031],
            [8.446148983387918, -0.6618401915732387],
            [8.452842646154387, -0.6552519602916033],
            [8.467724445229539, -0.6496346625829228],
            [8.465490739778264, -0.6424273115031714],
            [8.468311172005585, -0.6410390399315942],
            [8.472812803586981, -0.6355841640897446],
            [8.476928851055728, -0.6324984893647524],
            [8.49048156212012, -0.6291942140168836],
            [8.493478570555451, -0.6267284433400105],
            [8.507228548894572, -0.5945182313692376],
            [8.529975827598157, -0.5403252366942888]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.69804934335488, "lat": 37.5457161180866 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21123"],
        "coty_name": ["Larue"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Larue County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00516908"
      },
      "bbox": [
        8.39122516636627, -0.8529335437395549, 8.7265417531181,
        -0.5403252366942888
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.618465680257474, -1.0280334974612912],
            [10.620781249688354, -1.0308590197185221],
            [10.625269911182798, -1.0299443170059177],
            [10.628459548370955, -1.0355685058074717],
            [10.634097312995387, -1.0336182400313148],
            [10.63740275213153, -1.0270677911324233],
            [10.641189260362433, -1.0278802729391991],
            [10.644124042145267, -1.0232731827933634],
            [10.647388417810195, -1.0232039985273498],
            [10.651267392550107, -1.0156358151183982],
            [10.655658515178407, -1.0117866872288257],
            [10.658441259388578, -1.0125399480888373],
            [10.660659295708921, -1.0081085069390185],
            [10.666510366445499, -1.0068058548581527],
            [10.669141568283326, -1.0034485252336034],
            [10.665262600860624, -0.9971762551264435],
            [10.6694688826527, -0.9924750204501445],
            [10.668524174882322, -0.9864283748821715],
            [10.665142205644612, -0.9870446724595295],
            [10.657625091265405, -0.9842989104095037],
            [10.655987311163376, -0.9800131378675196],
            [10.652137765307474, -0.9813786607213748],
            [10.650402526575014, -0.9773517172404603],
            [10.653142761847832, -0.9728620805600883],
            [10.657365087080139, -0.9718101884328246],
            [10.65813480507531, -0.9682972762625086],
            [10.661461127178645, -0.9648131826765597],
            [10.660496110833275, -0.9606411267426681],
            [10.66488250781867, -0.9606514691240757],
            [10.66802555489901, -0.9625307307005513],
            [10.67224775066909, -0.958301613476166],
            [10.667985815155461, -0.9516377673055998],
            [10.670320572223993, -0.9495628280120595],
            [10.669766223250928, -0.9454058042716109],
            [10.67134113800538, -0.9402423595327842],
            [10.664899455902688, -0.9335594713231232],
            [10.664628643282645, -0.9300208130685342],
            [10.661541382473786, -0.9291152345893726],
            [10.66109357030942, -0.9235230293586753],
            [10.663666848137902, -0.9224324626450533],
            [10.663323462080694, -0.9182138422858913],
            [10.657302352218366, -0.9180843583480327],
            [10.656846726235427, -0.9134052377583298],
            [10.650859751853334, -0.9071962045533424],
            [10.651180691316869, -0.8981480769937737],
            [10.654284169106162, -0.8918847591457348],
            [10.664782967161136, -0.8624898794195955],
            [10.661581230957779, -0.8545441927822751],
            [10.664912680736277, -0.8503958335877548],
            [10.668923285795426, -0.84908393229084],
            [10.672516560943754, -0.8438138202490091],
            [10.673255036498453, -0.8400934751138002],
            [10.676754380522633, -0.8402118355875332],
            [10.680850149515067, -0.8273691816445724],
            [10.687221221249235, -0.8202004507628038],
            [10.691711384003314, -0.8245640480641538],
            [10.697547859128886, -0.8237297001991124],
            [10.700552744917152, -0.8265098106221189],
            [10.700358569134087, -0.8321746529108375],
            [10.701615047041246, -0.8367549625400168],
            [10.704273296427942, -0.8396224962931725],
            [10.708043878256815, -0.8400353050962062],
            [10.710935168264427, -0.8342695794053195],
            [10.718019307370888, -0.8301989260132601],
            [10.720772678425801, -0.8246198370919621],
            [10.720696741837747, -0.8213708596752645],
            [10.727843281253367, -0.8171181463638248],
            [10.732570105471426, -0.819342186658033],
            [10.73402905220231, -0.8131615841796723],
            [10.739628489843845, -0.8058006721577236],
            [10.748955161598165, -0.8047593990285503],
            [10.75687859899824, -0.7998454411149062],
            [10.758907410291101, -0.7935268585535874],
            [10.762389892354141, -0.7937595283092085],
            [10.767543720319354, -0.7895849871927353],
            [10.768943767026885, -0.7801861040714131],
            [10.771843521278218, -0.7782035781376772],
            [10.773199548751053, -0.7735219997777665],
            [10.776523756370322, -0.7734568230953814],
            [10.779667771536298, -0.7703880082917038],
            [10.778773150219171, -0.7602116182471201],
            [10.782157114074291, -0.7577290186910063],
            [10.782790835390932, -0.7542270087978477],
            [10.7861251796649, -0.7508641962304641],
            [10.790465525895167, -0.7504601845528723],
            [10.794364677020964, -0.7441262684670295],
            [10.797274729647347, -0.7450606125796407],
            [10.800804875680916, -0.7418990917928765],
            [10.809397499607748, -0.7389920147188959],
            [10.810857645539757, -0.7342885856154721],
            [10.814341022865896, -0.7340443503211431],
            [10.817906454208979, -0.727682934111099],
            [10.82287808462455, -0.7309291939337004],
            [10.827530085132208, -0.7279082163207735],
            [10.833149051912475, -0.7331737800711435],
            [10.837274586366975, -0.7319487013631053],
            [10.841644840400757, -0.7281556702971921],
            [10.845897114799742, -0.7289982641784878],
            [10.851402728911138, -0.7280767430499308],
            [10.853341022986754, -0.7253350102536321],
            [10.86062148886666, -0.7271698089763805],
            [10.86423766800145, -0.7207311946238872],
            [10.866304506496546, -0.7199601678517765],
            [10.872351960111478, -0.7229149047865773],
            [10.875087527690802, -0.7224341872980302],
            [10.878419186931405, -0.7157868460384964],
            [10.885548705120792, -0.715360582504486],
            [10.893911118947308, -0.7220260553968042],
            [10.892539430519502, -0.727305710969805],
            [10.894185696547577, -0.7290054195095925],
            [10.902506922850282, -0.7276974559876602],
            [10.904753600284758, -0.7248271458877137],
            [10.913415248824325, -0.7278309985754081],
            [10.914857952055344, -0.7350263184960321],
            [10.910919498566422, -0.7381575612241095],
            [10.91295555566111, -0.7416873609945173],
            [10.918198752626656, -0.7402544827156506],
            [10.922202731956869, -0.7410902454266388],
            [10.920577649622418, -0.7484853279061737],
            [10.922986463159766, -0.7506552279071227],
            [10.927235490984074, -0.7496157927524869],
            [10.93103446759883, -0.7531821654849634],
            [10.933148553183777, -0.7512107079762105],
            [10.93913099392447, -0.7528657590722968],
            [10.942679593916246, -0.7493353325131203],
            [10.94390118703945, -0.7440582806047751],
            [10.946749623168053, -0.742153941272417],
            [10.952049339994057, -0.7425624344079906],
            [10.952707593230706, -0.7389218313590692],
            [10.959034385732757, -0.7318721834267262],
            [10.964052290939453, -0.7316537233864404],
            [10.965167780509294, -0.7276096235517442],
            [10.9698832397826, -0.7276293355330682],
            [10.976432597808996, -0.7341958137845732],
            [10.991162150543957, -0.742497953444564],
            [10.995753815678238, -0.7444805183566464],
            [10.99885178335266, -0.7483381749041699],
            [11.00194889158822, -0.7582177200486767],
            [11.00717619679691, -0.7627925745281209],
            [11.01729876813547, -0.7636486205043115],
            [11.02683757747026, -0.7722797731584745],
            [11.017284898712816, -0.7813829832429043],
            [11.00757096127167, -0.7885258598710967],
            [11.00767355677517, -0.7910158599930377],
            [11.004485438914246, -0.7948367730887135],
            [10.99658726963592, -0.8000782407949393],
            [10.990148447097441, -0.8060061970732585],
            [10.985059338568806, -0.8120267675593901],
            [10.979554087111802, -0.8216451471595356],
            [10.965699700692905, -0.8260073383960942],
            [10.963450548336555, -0.8276579468728805],
            [10.962121920224444, -0.8335323457643673],
            [10.95454474264179, -0.8377379867052417],
            [10.948457145704944, -0.8457182874536089],
            [10.942208347411002, -0.8457126039194884],
            [10.934165759428234, -0.8512518772461098],
            [10.925472981286852, -0.8586200014354085],
            [10.915096442234013, -0.865503814438392],
            [10.912489561159294, -0.8702400438523982],
            [10.91298328541323, -0.8742793735350493],
            [10.917254256523943, -0.8799623544894203],
            [10.918668158772235, -0.891365856545918],
            [10.916835295700292, -0.8940744785736334],
            [10.919304528406546, -0.9007753273939006],
            [10.924636689541956, -0.9055798902686351],
            [10.92427747305733, -0.9095433654431188],
            [10.920082312894644, -0.9103177924867885],
            [10.917871942810551, -0.9131834015883326],
            [10.919291805620754, -0.9192528101014121],
            [10.923721867595894, -0.9277261159693302],
            [10.924372214728994, -0.9381682336641318],
            [10.925357504682363, -0.9405937617735157],
            [10.922799520120902, -0.9440149110661727],
            [10.916725150402126, -0.9423941528981621],
            [10.910013389853, -0.944911776251617],
            [10.909272717327486, -0.9466295699194671],
            [10.909424733081163, -0.9583912011121242],
            [10.908179733306945, -0.9632809035003047],
            [10.899117368119354, -0.9623918027269956],
            [10.894046129695294, -0.9674117341818337],
            [10.890862891932349, -0.9753911835321364],
            [10.886559550991063, -0.9764392866224466],
            [10.88380410268069, -0.983998488128655],
            [10.878526304742548, -0.9848205380079134],
            [10.87534045240031, -0.9879868183976497],
            [10.871589255389924, -0.9842676419185448],
            [10.869444062807093, -0.9863105976229083],
            [10.859590294472774, -0.990361820763946],
            [10.857629374871166, -0.988723294482956],
            [10.852624538517736, -0.9925490642815085],
            [10.847776346782341, -0.9916158174938617],
            [10.84687693006516, -0.9965952156929015],
            [10.848497775251818, -0.9998389407699941],
            [10.847755204755147, -1.0041175789766308],
            [10.842580244217235, -1.0113807818695102],
            [10.837971958742031, -1.0152997830857418],
            [10.83094350847481, -1.0148860419498065],
            [10.8294088815074, -1.0212997929143905],
            [10.824460806365543, -1.021091222810439],
            [10.821190717023368, -1.0240502545591765],
            [10.820363109578068, -1.0275654979822222],
            [10.759993645944817, -0.9941056118838622],
            [10.758316494240365, -0.9943894731206158],
            [10.747713017537082, -1.003223946446318],
            [10.744875824412013, -1.0074292212648663],
            [10.741000884638455, -1.0103140949835463],
            [10.731016499052506, -1.015293595078856],
            [10.721742779397907, -1.0178808253332423],
            [10.710142809876364, -1.0240834479919787],
            [10.705379846643687, -1.030650821576013],
            [10.703784725171547, -1.0355208950167074],
            [10.699683976522529, -1.0409603397981761],
            [10.692388587578346, -1.0382509961500954],
            [10.68779466269614, -1.0388061061829812],
            [10.686761854636137, -1.0359010505928412],
            [10.668569458171055, -1.0446176940773833],
            [10.664966555283113, -1.0457570290621423],
            [10.652589975020524, -1.0521189872046977],
            [10.644884451341051, -1.0567433173289476],
            [10.640658411937876, -1.057909425773463],
            [10.629481620788425, -1.0635346649009505],
            [10.619467158608488, -1.0701672454945566],
            [10.61005691495862, -1.0732937969914225],
            [10.60265062402098, -1.0779029608688213],
            [10.59955938020133, -1.0752007043736918],
            [10.602147342557405, -1.066883762786132],
            [10.597760647359443, -1.0607724926420528],
            [10.600139150344743, -1.0589911319695369],
            [10.601724588236287, -1.0540114993844434],
            [10.599872914458325, -1.0502675663167151],
            [10.607434381375612, -1.0407049068287806],
            [10.610611060504478, -1.038483279700885],
            [10.616368856761763, -1.038055538705335],
            [10.616227485144732, -1.032227556939591],
            [10.618465680257474, -1.0280334974612912]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.85524975043911, "lat": 37.12116211040999 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21133"],
        "coty_name": ["Letcher"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Letcher County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00516913"
      },
      "bbox": [
        10.597760647359443, -1.0779029608688213, 11.02683757747026,
        -0.715360582504486
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.524153148102758, -1.3238189139164616],
            [7.564292946136702, -1.3115160317162593],
            [7.5833479423004615, -1.3054628509947854],
            [7.611328365270892, -1.3074654911869232],
            [7.688085831750528, -1.3127340849377727],
            [7.728499292112135, -1.3254744585653493],
            [7.828125121468721, -1.356633999737785],
            [7.889238473138248, -1.4689756277017691],
            [7.872838408876897, -1.470728395008328],
            [7.85498630865538, -1.4792588132047317],
            [7.8417097221090915, -1.5019326524371703],
            [7.830678290973793, -1.514060430747437],
            [7.823394110659084, -1.5498350663196303],
            [7.815227081540284, -1.5652305173995422],
            [7.800263590346903, -1.6068510497768695],
            [7.794351999577723, -1.6364461965364405],
            [7.7947454394135, -1.6563406880434959],
            [7.792568194240441, -1.715924159722848],
            [7.753346562179164, -1.7210135033893719],
            [7.720806158431313, -1.7249337157515516],
            [7.6794823917209865, -1.729546868870282],
            [7.596681659600322, -1.7397810331434589],
            [7.5577251988124825, -1.7442061579389372],
            [7.548830498252891, -1.6388828825955848],
            [7.554380662015147, -1.618526208517279],
            [7.544510650939134, -1.5817451269205511],
            [7.538634246767561, -1.5048143673724854],
            [7.527799087974594, -1.3743945605097487],
            [7.524153148102758, -1.3238189139164616]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.87892101552517,
          "lat": 36.859685425477124
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21141"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00516917"
      },
      "bbox": [
        7.524153148102758, -1.7442061579389372, 7.889238473138248,
        -1.3054628509947854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.60802853697927, 0.4214467660692066],
            [9.612987633513193, 0.4219222835858034],
            [9.614443952193735, 0.4192818068733712],
            [9.62033502044399, 0.4186259185116817],
            [9.627991946803045, 0.4240791719936683],
            [9.63728530930203, 0.4353228686326246],
            [9.6348237122919, 0.4393998321784695],
            [9.636316644741576, 0.44128788104398725],
            [9.642475225697499, 0.4430397708804698],
            [9.64560891773359, 0.44788817799815756],
            [9.64665789608063, 0.4526383700010719],
            [9.650470063786043, 0.45470556790179223],
            [9.648200367826021, 0.45921942007619987],
            [9.654165145405512, 0.4620950665447465],
            [9.654600398380973, 0.46581969218658686],
            [9.657573875811797, 0.4697133708472499],
            [9.662856800047658, 0.47271668263590977],
            [9.663235022181809, 0.47606581700153194],
            [9.660843880001643, 0.48040012575324137],
            [9.6623419055879, 0.483274664977017],
            [9.666043805206206, 0.4783138844183586],
            [9.667028330598418, 0.4738531994114938],
            [9.669734261751724, 0.4744987550565908],
            [9.672684936058628, 0.47879943236053724],
            [9.675810679621241, 0.4741276221371992],
            [9.678494867574154, 0.4761192703019517],
            [9.682126856243192, 0.47481213214357715],
            [9.68076687195936, 0.4706314768225089],
            [9.683772330419458, 0.468851395945835],
            [9.686049658840723, 0.47467466069011477],
            [9.684644711984436, 0.4771188766620111],
            [9.687782376373926, 0.4808037352181171],
            [9.692124738537682, 0.47876554795163234],
            [9.692195307084628, 0.47303733221095406],
            [9.698565343570449, 0.4757401673603251],
            [9.703366591632639, 0.4705942957398481],
            [9.702986133141863, 0.4627326015237507],
            [9.707532110621907, 0.46280838747564723],
            [9.71079692069589, 0.4649714845977679],
            [9.708566038654038, 0.4723325480126819],
            [9.713455008829229, 0.47577432519089286],
            [9.715779318529737, 0.4720689539177414],
            [9.714428550778054, 0.4652178906916697],
            [9.721682830404914, 0.4669386126403898],
            [9.723321502588892, 0.47209918121660743],
            [9.72621345570501, 0.47242337385208855],
            [9.731547437333456, 0.4669303587884574],
            [9.733442045526328, 0.47072217471596123],
            [9.733942893775925, 0.47760326637698464],
            [9.745300796792268, 0.4741957145809769],
            [9.748220167741096, 0.4749426166872081],
            [9.753231250059404, 0.4689294669669626],
            [9.76523167339504, 0.4196666970954406],
            [9.783218630777274, 0.3930889230499163],
            [9.793948737345248, 0.38200671469237407],
            [9.766886310820322, 0.34958596039240775],
            [9.763504668673455, 0.33992030471157153],
            [9.759679930336885, 0.33783280446686237],
            [9.758435653944334, 0.32985924323675586],
            [9.76244790024165, 0.3242160963529035],
            [9.761794804042601, 0.3208533882147074],
            [9.754416497778891, 0.3184581522414124],
            [9.754060211780315, 0.3091715032869759],
            [9.749384945540092, 0.30779309542696526],
            [9.750080508464956, 0.3158351035938971],
            [9.748626348739323, 0.3225710424712887],
            [9.744165923250701, 0.3230187167449364],
            [9.745723018048492, 0.31500005533521985],
            [9.74013852819877, 0.3146895865660086],
            [9.735213885510236, 0.32399639366846594],
            [9.733056777413948, 0.3264945701690144],
            [9.729330415162151, 0.32522539347143653],
            [9.724062734406834, 0.32055608565329474],
            [9.711499037396552, 0.32640767525442604],
            [9.705288768495668, 0.3276328028882499],
            [9.701329550491273, 0.3300444989262984],
            [9.693627683387115, 0.3309976628110472],
            [9.688386006878401, 0.3331158086954732],
            [9.677824486951181, 0.3291360906033908],
            [9.66972704116899, 0.33402631029614427],
            [9.6660263739947, 0.33230565372522686],
            [9.664178440784685, 0.3338236272859219],
            [9.661672159915186, 0.3412837488103685],
            [9.652609709773232, 0.3438131418334188],
            [9.647397872008716, 0.34719553921444113],
            [9.642693118766866, 0.34506190937620845],
            [9.640777310796302, 0.3462746771296247],
            [9.64146710872674, 0.35126753649529024],
            [9.639105961460034, 0.3531663099314316],
            [9.635335371913918, 0.3501031849932774],
            [9.633803130115005, 0.3459552796147515],
            [9.628928956083795, 0.3450713806109532],
            [9.624763001351887, 0.35043236901251573],
            [9.624552696627706, 0.35745330035030803],
            [9.622856304782243, 0.3580487548073741],
            [9.614494027160406, 0.35208630093566956],
            [9.609758832214057, 0.3522936188518464],
            [9.606659211187127, 0.35723217088451065],
            [9.610416425943063, 0.36142265136846663],
            [9.616463035683271, 0.36264050141617243],
            [9.617820661979406, 0.3668627727907054],
            [9.615100997460676, 0.3690703886246759],
            [9.605596026042038, 0.3682116682348589],
            [9.60046922172715, 0.36146390840498993],
            [9.59824593839643, 0.3631286702515625],
            [9.598242981492383, 0.3738447679040118],
            [9.596623867223705, 0.3846997515372168],
            [9.598487569060605, 0.38788682321057766],
            [9.598059673920654, 0.3984724370880598],
            [9.60226687783041, 0.40059519388437387],
            [9.608675524337729, 0.40663990775062875],
            [9.607322580751482, 0.41213465068843913],
            [9.60802853697927, 0.4214467660692066]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.0518955283337, "lat": 38.51888595632809 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21201"],
        "coty_name": ["Robertson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Robertson County"],
        "coty_fp_code": "201",
        "coty_gnis_code": "00516947"
      },
      "bbox": [
        9.596623867223705, 0.30779309542696526, 9.793948737345248,
        0.483274664977017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.703430273925711, -1.2030555192047587],
            [9.708234008233692, -1.1986496815239807],
            [9.711531763253232, -1.191710048825848],
            [9.717707216075707, -1.1906590966164092],
            [9.718164932443191, -1.1851217200812034],
            [9.725221704624422, -1.1853676214442062],
            [9.727984708811041, -1.1833362452571774],
            [9.726783438724274, -1.1788946111281053],
            [9.733175896714918, -1.1737443538523553],
            [9.732747298018666, -1.178799287166277],
            [9.730403772152096, -1.18242772712394],
            [9.734888679023545, -1.1849703940031557],
            [9.73827318443536, -1.190784618871094],
            [9.74269109784261, -1.1882531269316783],
            [9.750210751606977, -1.192583473089392],
            [9.749868839201724, -1.1959767882072811],
            [9.755017216586086, -1.1991266103014284],
            [9.759976963755811, -1.1960506219262412],
            [9.759198309245944, -1.184951600119016],
            [9.760497940089605, -1.1813829471292332],
            [9.764603600998056, -1.183712810174754],
            [9.76556698791483, -1.1879100964220344],
            [9.77213070728822, -1.1933422334444679],
            [9.776424432188405, -1.1883745130180736],
            [9.780017379800233, -1.1940269836991706],
            [9.782456067615364, -1.1919454566648258],
            [9.78742163124485, -1.1908026684237745],
            [9.791437666663226, -1.192945055745308],
            [9.794021642362747, -1.1984666696960082],
            [9.800899572975212, -1.1966578002259949],
            [9.807216207732008, -1.1920363898920736],
            [9.810475743200062, -1.187895796134705],
            [9.808341298849703, -1.184979701995906],
            [9.811683540502615, -1.181509243697423],
            [9.816553944329694, -1.1793070665502805],
            [9.816008407698774, -1.1671090095254404],
            [9.821143179545155, -1.166686231113801],
            [9.820658294459063, -1.1717993205156196],
            [9.82160191850577, -1.1777720576290527],
            [9.825314739761142, -1.176435671888592],
            [9.828190701336586, -1.1730522988999648],
            [9.829011412468855, -1.1640105199428892],
            [9.835368290577936, -1.1619082885424565],
            [9.839175043857553, -1.1629257946432088],
            [9.846757780630751, -1.1684671271451774],
            [9.851629355578332, -1.1702913218347268],
            [9.855415389592265, -1.1695535791364435],
            [9.855979733518325, -1.1754945895437328],
            [9.863618851708456, -1.1728247633290774],
            [9.861984140915055, -1.1747480394203156],
            [9.868308609933845, -1.1875812439870843],
            [9.873796916007464, -1.1946233404651856],
            [9.875741289436576, -1.2020447212511842],
            [9.872558676767452, -1.2065073723610535],
            [9.87700349624428, -1.2191321751579842],
            [9.875175657003195, -1.2234321945650852],
            [9.878269377442399, -1.2287734940323989],
            [9.884774113911089, -1.2350133965160628],
            [9.888694491282171, -1.2362048170079374],
            [9.893156679447687, -1.2486812032291994],
            [9.892812573373163, -1.2522937531992344],
            [9.895130306707939, -1.2564952401059315],
            [9.899878807754488, -1.257163538446434],
            [9.8960142612862, -1.2628066658902144],
            [9.89753419400815, -1.2728958333545812],
            [9.906103306945191, -1.2742241512677352],
            [9.90713280425681, -1.269412907408002],
            [9.910433021931611, -1.2725365618081277],
            [9.918317499169621, -1.2750916175893074],
            [9.918734579056936, -1.2823084890794028],
            [9.916135809753255, -1.2847106447346488],
            [9.920847009974596, -1.2904209190860343],
            [9.922438483178528, -1.2894972210682998],
            [9.928385743854122, -1.294928631813667],
            [9.928835927052766, -1.298552751488326],
            [9.931660442070983, -1.3003022994099434],
            [9.931560145638048, -1.3039899962741548],
            [9.941356533998361, -1.3079116251200886],
            [9.94718198618932, -1.3038684101991118],
            [9.953749421350363, -1.3086639351580491],
            [9.955747042297764, -1.3190206010328782],
            [9.959219231573334, -1.317989753242617],
            [9.968310883001534, -1.317444467718837],
            [9.97335515486708, -1.3210930556390492],
            [9.971779327866878, -1.327273151211724],
            [9.972825476691662, -1.3326447581839866],
            [9.976129131049253, -1.3347532142043745],
            [9.976512765085351, -1.338661424494439],
            [9.972619798678592, -1.3427113456498463],
            [9.969734916933028, -1.3485040483203155],
            [9.969769971273536, -1.354115958126797],
            [9.97157160174835, -1.3581207082736897],
            [9.974859422743975, -1.3594499050549393],
            [9.978483232942464, -1.35480443535129],
            [9.985300701950313, -1.3558979981112145],
            [9.993760261386962, -1.3665690824639838],
            [9.997477977335997, -1.38861442434998],
            [10.066421639366471, -1.4204914367405588],
            [10.066434671421302, -1.427535243894855],
            [10.047851623302067, -1.4417974634336541],
            [10.038726711919534, -1.4503693206965573],
            [10.032124400281543, -1.4518903030379744],
            [10.025273798349232, -1.457007481282357],
            [10.022364263270978, -1.4603709272255014],
            [10.017854100105525, -1.4622229064626318],
            [10.012229369332662, -1.4666695741661042],
            [10.00972036687071, -1.4702346934649062],
            [10.012740399454513, -1.4789181130979607],
            [10.016982053812196, -1.4829315677816768],
            [10.024208650615487, -1.486111487435043],
            [10.02631927690145, -1.4899841800547722],
            [10.031893034147098, -1.4944771418699665],
            [10.033055550829152, -1.4987728399885627],
            [10.040047861825183, -1.5099304280366683],
            [10.037754982913857, -1.5153447851819248],
            [10.038342729451864, -1.5192742376544035],
            [10.037191810386462, -1.5255343917339652],
            [9.992097044328535, -1.5293450901225556],
            [9.881485337598436, -1.541460247991401],
            [9.802717593634684, -1.5505255754708827],
            [9.801364157001121, -1.5439849326577466],
            [9.795123095203202, -1.5368574445370395],
            [9.793373155090437, -1.5369286393096673],
            [9.790289616122488, -1.5305379611071561],
            [9.7770734067276, -1.5236588057959006],
            [9.762536303190156, -1.513038312682733],
            [9.747033831539625, -1.497725812472205],
            [9.740344233832484, -1.4896077289495027],
            [9.728774330173632, -1.4736325905074132],
            [9.72324021868037, -1.4635206287622884],
            [9.719001957242243, -1.4533235535637574],
            [9.71350432667081, -1.435937338930329],
            [9.709130431983574, -1.4141865274642456],
            [9.70677705677149, -1.393101183477612],
            [9.700095068805346, -1.3934691407363813],
            [9.69458750985493, -1.3844647462037456],
            [9.693076317025792, -1.3787922649588533],
            [9.685724292724593, -1.3772077765957846],
            [9.682516790827757, -1.3737068618342163],
            [9.682194716446055, -1.3634080006925153],
            [9.68043437957575, -1.3587016243474592],
            [9.683380309228932, -1.3491685862015173],
            [9.681226288036449, -1.3466158762367126],
            [9.674885723598761, -1.3459891730858595],
            [9.674369874623435, -1.3417427036304337],
            [9.681230532313284, -1.3322939970211238],
            [9.68618645667045, -1.3279009309285446],
            [9.693429851807657, -1.3248687639778156],
            [9.699452029619252, -1.3203023986944553],
            [9.701019556341281, -1.31647796645175],
            [9.698877240715486, -1.314860976600791],
            [9.693577365201993, -1.3155436712612096],
            [9.688009726047365, -1.3143347845290598],
            [9.683416066161366, -1.3175240872136211],
            [9.679637203788305, -1.3162852728311605],
            [9.67925938849069, -1.3127153099893576],
            [9.68156097464686, -1.3083879858788792],
            [9.688681376757868, -1.3058115547648113],
            [9.689640761345009, -1.3009161434323082],
            [9.692693458161585, -1.296930941571198],
            [9.699190804684378, -1.295461530427134],
            [9.700412611164722, -1.291281990216641],
            [9.693057134430413, -1.28719041285277],
            [9.691042400163854, -1.280612554483501],
            [9.69728972629788, -1.2719964264140926],
            [9.696144053929213, -1.2641924501066113],
            [9.690819235550329, -1.26066979425745],
            [9.690271337829467, -1.2546705073053455],
            [9.693354035083672, -1.25085103605233],
            [9.693963616926004, -1.2454257846211358],
            [9.70182646283661, -1.2391691188266636],
            [9.702324082534854, -1.237238113737278],
            [9.697794220982159, -1.2270176283168839],
            [9.693955708019816, -1.2244986206214694],
            [9.693120424747837, -1.2211425896522936],
            [9.694791746205022, -1.2180718286660996],
            [9.701690372400464, -1.2125980430360794],
            [9.704328701157303, -1.2079487663945516],
            [9.703430273925711, -1.2030555192047587]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.14518151824657, "lat": 36.7581685325934 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21235"],
        "coty_name": ["Whitley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Whitley County"],
        "coty_fp_code": "235",
        "coty_gnis_code": "00516964"
      },
      "bbox": [
        9.674369874623435, -1.5505255754708827, 10.066434671421302,
        -1.1619082885424565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4076233919940666, -8.30729791007027],
            [2.407665061845845, -8.307742191424312],
            [2.4570795286264366, -8.306339257592787],
            [2.4690532219043293, -8.30623509517221],
            [2.5036443205585877, -8.30507332499114],
            [2.506625945766723, -8.305261500357414],
            [2.535708724159037, -8.304487037924767],
            [2.5394484887208524, -8.304113544908502],
            [2.5702222530786933, -8.303366757955665],
            [2.6275286830889466, -8.302258356096216],
            [2.6250547091856764, -8.215055338366884],
            [2.712576268807228, -8.21307159081909],
            [2.7135245976424014, -8.242899402288257],
            [2.714370159082732, -8.299829248273568],
            [2.8454782401765133, -8.29583176237029],
            [2.9329364873794406, -8.293191680068228],
            [2.933751344133283, -8.316029018409395],
            [3.0199490338685977, -8.314021650654228],
            [3.0223110421541355, -8.385776867799438],
            [3.0231685222236933, -8.415707057198365],
            [3.023865964342307, -8.431721965470066],
            [3.0528178753699695, -8.430686085699142],
            [3.056818989531326, -8.53337875378393],
            [3.115100315126895, -8.532238653264073],
            [3.1457074864546324, -8.531187195835113],
            [3.1457104246645966, -8.536501972369123],
            [3.1495708702490677, -8.546243518740333],
            [3.142065778160612, -8.551327063319851],
            [3.139884631464429, -8.556327398666355],
            [3.135854340700882, -8.557645179623954],
            [3.134269508183304, -8.56786179713208],
            [3.1345515385060936, -8.574723953357895],
            [3.138684224638769, -8.576380948719628],
            [3.14229519237543, -8.581736719519668],
            [3.141554773033119, -8.58588846395451],
            [3.1456260945250034, -8.587785756804585],
            [3.148620652987569, -8.595988941493255],
            [3.1531229606584796, -8.603906158560218],
            [3.1135562110309998, -8.60540811550745],
            [3.0590171942850937, -8.606976205306891],
            [3.0602873318043624, -8.650623599720014],
            [3.0383595619719017, -8.651094050904252],
            [2.946392374558542, -8.65421468058899],
            [2.9459016682126355, -8.640030205697503],
            [2.8728579867314252, -8.64298955809119],
            [2.8097617977940534, -8.645020041360722],
            [2.7797961833545517, -8.645181522260577],
            [2.6891269565977627, -8.647867409386365],
            [2.5984571809273316, -8.65053672277313],
            [2.522637096398152, -8.65214714080243],
            [2.4334810271388347, -8.653996911914422],
            [2.4348871060710384, -8.65041780158249],
            [2.4349012551239997, -8.642736191329117],
            [2.4397653588163397, -8.640760176541432],
            [2.4425276756385754, -8.65189260753613],
            [2.4485372810900756, -8.651834416703855],
            [2.452344343905857, -8.646833473766957],
            [2.451214157198916, -8.642488134034744],
            [2.446294519055207, -8.638996621335565],
            [2.4374074259660152, -8.637415077696044],
            [2.4282708069643504, -8.627934880644393],
            [2.4241024694006397, -8.625047907483653],
            [2.421723898260549, -8.620945099387633],
            [2.4254896761217326, -8.618990632387307],
            [2.4273627447572754, -8.623632122395602],
            [2.4308263398394176, -8.623655123900464],
            [2.430447920002731, -8.612816968193224],
            [2.4381824602576034, -8.605013152248839],
            [2.4406725422448026, -8.597460111118371],
            [2.4458424934922087, -8.596448499987293],
            [2.4484230320629243, -8.593978305284477],
            [2.4474721096013643, -8.589580017594555],
            [2.4447286923339373, -8.585195706259617],
            [2.449060040853489, -8.5844811432641],
            [2.448407622287906, -8.576211841887309],
            [2.4492685439001964, -8.568778633506371],
            [2.4513895840646955, -8.568257379376746],
            [2.4561561938177583, -8.571516633737279],
            [2.4597406045779615, -8.566318626877427],
            [2.45524408864758, -8.564308979319174],
            [2.4527857327231595, -8.555365091073536],
            [2.449402336281516, -8.554337714737189],
            [2.4440470534934913, -8.55971157043302],
            [2.4430097150850703, -8.551146358464853],
            [2.4475765824869966, -8.542513325774806],
            [2.445795264602302, -8.53340751137854],
            [2.4404806776981616, -8.524279568275434],
            [2.4377824147711773, -8.517500087100958],
            [2.4438424445201856, -8.51464596973363],
            [2.4411665329006302, -8.510907374305006],
            [2.4373113539054687, -8.514355847766137],
            [2.4317706509146664, -8.499273374820437],
            [2.4313846822181695, -8.489557625957726],
            [2.437450431406934, -8.488152059489618],
            [2.4362781481351594, -8.482783721358064],
            [2.439584841488368, -8.474171347330195],
            [2.4432632038488715, -8.474556229142038],
            [2.4418053432298312, -8.468384846073032],
            [2.442901009318642, -8.464194704810664],
            [2.440511940279676, -8.453949424477846],
            [2.444231787423177, -8.448161193035105],
            [2.4394161707949, -8.442830371810803],
            [2.4387997269600565, -8.43657750813152],
            [2.4403846293637272, -8.432886504876844],
            [2.4422816474409825, -8.418533087178366],
            [2.4351565792299, -8.420695284606424],
            [2.43378778379841, -8.41444082875858],
            [2.4252352296872997, -8.413799396369841],
            [2.416523125612529, -8.410358724593257],
            [2.412551768231342, -8.4055150578299],
            [2.40802935142116, -8.405385485224881],
            [2.407638642280869, -8.398803895701663],
            [2.402681224544048, -8.395250510845461],
            [2.4015091293908983, -8.388775121480627],
            [2.3970917252615185, -8.384156819041069],
            [2.3974135945981336, -8.380309877181778],
            [2.3899001057708404, -8.379846682360848],
            [2.3884860702915285, -8.376811368598323],
            [2.394305821296518, -8.371491937630363],
            [2.3906425227165213, -8.366025546645263],
            [2.394739792169884, -8.360599173631687],
            [2.3917290278894305, -8.357986575711136],
            [2.399955000920098, -8.3490537180171],
            [2.3951255269896663, -8.345958173212816],
            [2.396685663648511, -8.335096305738746],
            [2.3936239569871365, -8.32640932777854],
            [2.3949128839069562, -8.31931606365025],
            [2.397873442308555, -8.318186815900537],
            [2.3993841075895546, -8.314122459988186],
            [2.4040840421143628, -8.313823869996849],
            [2.4076233919940666, -8.30729791007027]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.35806576129129,
          "lat": 30.229336977845957
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22019"],
        "coty_name": ["Calcasieu"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Calcasieu Parish"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00558468"
      },
      "bbox": [
        2.3884860702915285, -8.65421468058899, 3.1531229606584796,
        -8.21307159081909
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.04316976735761, 9.335040308123586],
            [18.073494360449804, 9.27595027424839],
            [18.115713259375553, 9.197068200218917],
            [18.107418592106523, 9.193132171380263],
            [18.15518673572799, 9.098271249318836],
            [18.202951837434117, 9.003352385885565],
            [18.231772971395422, 8.94462081475262],
            [18.273038465871917, 8.860898725577774],
            [18.308101058570557, 8.879155937609836],
            [18.30582718396751, 8.883792151675298],
            [18.339529346647243, 8.900273703975504],
            [18.342641100329825, 8.89958840102177],
            [18.366845843482796, 8.851537265722385],
            [18.4532007546197, 8.894242601775563],
            [18.49548529743894, 8.811717646881167],
            [18.509930481373015, 8.783755982248744],
            [18.512834588730286, 8.778876669254819],
            [18.53525178799878, 8.730857746113609],
            [18.5083053267412, 8.717808504447653],
            [18.521474114796405, 8.69023435760427],
            [18.516468939573038, 8.687635387384926],
            [18.522672863892428, 8.674753027587709],
            [18.527868410726985, 8.675846500530666],
            [18.547930702093964, 8.635111085681258],
            [18.610090419741923, 8.666461923906782],
            [18.624516834144384, 8.635636312637246],
            [18.620161281390637, 8.63356133804175],
            [18.62928816029218, 8.61472096008329],
            [18.633450754932692, 8.616599873653676],
            [18.64311875840383, 8.595804182939155],
            [18.6512426191934, 8.59943892060391],
            [18.6567442587102, 8.586074303019151],
            [18.65477655456605, 8.585251640174503],
            [18.660859750396888, 8.572014398947038],
            [18.65244188639437, 8.568296502684294],
            [18.68598728472544, 8.495060141504496],
            [18.7095980791446, 8.505456998835236],
            [18.710743581536065, 8.497560980651533],
            [18.714356797902372, 8.493626630272653],
            [18.715593829850658, 8.486378440222136],
            [18.709101059770475, 8.484844715692702],
            [18.710831800389848, 8.48229974210913],
            [18.727531749744394, 8.476256894769621],
            [18.748986579030888, 8.443948571813017],
            [18.752721160350884, 8.438057669336422],
            [18.74304011312459, 8.405046173907746],
            [18.67990953791772, 8.401973592551473],
            [18.683134367420827, 8.397613502048623],
            [18.682255175960904, 8.390956318292357],
            [18.683182147076177, 8.384656382410023],
            [18.679431797126497, 8.3648451103519],
            [18.677079970393326, 8.360946502514729],
            [18.678019106105406, 8.356862471359042],
            [18.676090609707863, 8.349721521427748],
            [18.67326693830491, 8.344633638060541],
            [18.674049422892583, 8.339179364254552],
            [18.69923453845842, 8.33052259638444],
            [18.704913024404725, 8.32584995813696],
            [18.70552189978307, 8.319595655234854],
            [18.70219861852528, 8.307268175087312],
            [18.704989368954752, 8.306506598498135],
            [18.70643087171314, 8.302732643137551],
            [18.646246987022874, 8.288121890612185],
            [18.608623121193087, 8.270332187197344],
            [18.599456599474667, 8.26569864041197],
            [18.57876614799901, 8.240401498094524],
            [18.57559476545601, 8.24727597291081],
            [18.5586125441914, 8.280643634727157],
            [18.546531451275246, 8.275037572431104],
            [18.544337873079506, 8.27962114576534],
            [18.53758521976546, 8.276610839632111],
            [18.522012329895002, 8.30852511334778],
            [18.51047094137641, 8.302917745123468],
            [18.520404433762504, 8.338315258107198],
            [18.47180901171141, 8.335858525861523],
            [18.381924426428476, 8.33028395831301],
            [18.32504427297256, 8.327279039069929],
            [18.347642254456876, 8.350375216591432],
            [18.288427123455865, 8.422686620879217],
            [18.23158494928045, 8.491997656519437],
            [18.18722631105548, 8.44747105592407],
            [18.142878468259614, 8.402931870912152],
            [18.11142722671653, 8.50488348262813],
            [18.073438820502098, 8.583087304316432],
            [18.06814296822255, 8.580697763251175],
            [18.0318177575439, 8.662108140539804],
            [18.060450855245502, 8.67450049866407],
            [18.00780084308149, 8.792826416326546],
            [17.955149860067333, 8.911068845874476],
            [17.956810255346056, 8.914395609890448],
            [17.95525053755522, 8.925051226638658],
            [17.950364318384263, 8.927260219312384],
            [17.957741579864297, 8.93409722028165],
            [17.96233777931238, 8.934888723097409],
            [17.963956034145678, 8.939302358399752],
            [17.961026475207376, 8.945525004954865],
            [17.963967134485944, 8.949136835607955],
            [17.963097838938733, 8.958112191766716],
            [17.959778305023338, 8.96507228837646],
            [17.9566763379609, 8.963988752011133],
            [17.950744162393015, 8.969606413701626],
            [17.94878719100619, 8.975612532284075],
            [17.949940011139965, 8.980402073696391],
            [17.95328087074473, 8.984048810430386],
            [17.95268238201571, 8.987143278674834],
            [17.948233069785083, 8.99093367294919],
            [17.950732802257644, 8.99293473779089],
            [17.950523498244962, 8.997796065850103],
            [17.954034614682353, 9.001077941291834],
            [17.948550640339054, 9.011508945720399],
            [17.942596233460456, 9.016861715612569],
            [17.94096875267668, 9.020197765425282],
            [17.93717776356196, 9.022631494875908],
            [17.93267474165982, 9.022134323222192],
            [17.929206414534043, 9.030633520848088],
            [17.932387983813, 9.035739852518542],
            [17.93498955675112, 9.043507716048998],
            [17.93470699244076, 9.04834901029414],
            [17.94042506467605, 9.051726290598237],
            [17.940972802436264, 9.060809427766172],
            [17.944809977863205, 9.063327750200253],
            [17.947704922313388, 9.062509715531174],
            [17.951016266567247, 9.06806130468069],
            [17.963244495551688, 9.066385809911075],
            [17.96928929166159, 9.070103574878003],
            [17.974803932517947, 9.066053628679938],
            [17.978978151244096, 9.06526528077522],
            [17.98159033216417, 9.056584337604532],
            [17.992272440087923, 9.051956322866817],
            [17.99424021650262, 9.047120862821659],
            [18.008519513010135, 9.042005902481055],
            [18.016645721539916, 9.048180648539667],
            [18.0187306232371, 9.04635126513574],
            [18.02474568954733, 9.049070174727355],
            [18.026777572028685, 9.051629673877734],
            [18.030757752975642, 9.05183600704225],
            [18.044352416095577, 9.046978508475156],
            [18.046685423590095, 9.039555513432928],
            [18.053465830250925, 9.040306279304517],
            [18.06294092922599, 9.049505132346772],
            [18.058647530965413, 9.053781957265675],
            [18.059604542081463, 9.063256897816704],
            [18.06613280744429, 9.067520619022082],
            [18.064363306412545, 9.072784462807956],
            [18.059376631330064, 9.072802745285417],
            [18.0549994420291, 9.076586195972466],
            [18.057785067721685, 9.087051513113519],
            [18.0537922094021, 9.091295617106384],
            [18.05071243523734, 9.091473682015073],
            [18.045583641356867, 9.094229777862354],
            [18.035926707681067, 9.104988595584025],
            [18.027193893954145, 9.104302955135132],
            [18.017566545549887, 9.107699241446367],
            [18.013394083442765, 9.106346605146504],
            [18.01030743684931, 9.115416295171068],
            [18.00411804458977, 9.11555151794161],
            [18.001721613856976, 9.118150731512111],
            [18.000075582823715, 9.125769583255707],
            [17.993925958129022, 9.128528949396895],
            [17.987717537108747, 9.128808477905782],
            [17.979758395495903, 9.133682175340846],
            [17.978601397619354, 9.135884254752572],
            [17.980815133256122, 9.144599873345339],
            [17.979495493750946, 9.148327740608192],
            [17.972144273165846, 9.150272335233616],
            [17.969507893892096, 9.154114590426465],
            [17.969488989921594, 9.158881696922727],
            [17.971971224916768, 9.16305886873296],
            [17.975456622780694, 9.165589642857634],
            [17.97669343028268, 9.174348235579531],
            [17.980737677247525, 9.17741346940224],
            [17.9792021073759, 9.180204621725675],
            [17.980019945844138, 9.187648010740073],
            [17.981688553837387, 9.190154707232248],
            [17.983521369238158, 9.197486567518403],
            [17.98976749206642, 9.202306777515302],
            [17.979474438489905, 9.209222659283048],
            [17.980935926324094, 9.217238543905696],
            [17.984019105069557, 9.219695546511888],
            [17.987046775116767, 9.226288997709155],
            [17.986265141310927, 9.228220460508398],
            [17.992703292050074, 9.238610756811203],
            [17.99206162329383, 9.241260031146325],
            [17.99441171417329, 9.244561397505741],
            [17.997236698227375, 9.260498775160697],
            [18.002744395254535, 9.265184137324468],
            [18.012733457867732, 9.269687744946483],
            [18.013339356747824, 9.274353038077685],
            [18.01782341053344, 9.281927291482182],
            [18.018125212978926, 9.285881322989303],
            [18.023818874946063, 9.290916797409933],
            [18.026613157916024, 9.29173336914963],
            [18.027312093352467, 9.296179378197568],
            [18.029832538992437, 9.301853203547655],
            [18.032962073877513, 9.312290343157999],
            [18.03845804062963, 9.32079850436476],
            [18.038887778927695, 9.326479654069113],
            [18.037145353348713, 9.328157983241375],
            [18.039720732504644, 9.33292332977296],
            [18.04316976735761, 9.335040308123586]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -70.44397816716074,
          "lat": 44.974005710744876
        },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23007"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00581289"
      },
      "bbox": [
        17.929206414534043, 8.240401498094524, 18.752721160350884,
        9.335040308123586
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [20.52471131538896, 8.964707981746432],
              [20.5332975389319, 8.967928922582175],
              [20.530979224163456, 8.971934794784996],
              [20.537394145233225, 8.97848597897775],
              [20.540456123052106, 8.979428163404704],
              [20.545474213397924, 8.976412164512409],
              [20.548273003623805, 8.980431181281974],
              [20.552978919241006, 8.977845261024514],
              [20.556131941076085, 8.977938914966657],
              [20.561160760978968, 8.975451742650463],
              [20.567367000828455, 8.974788764823254],
              [20.567079824829356, 8.9694682573801],
              [20.558291122227132, 8.97334004379292],
              [20.553828123581344, 8.9717904457994],
              [20.556490645213586, 8.968398965626786],
              [20.55588610261579, 8.96585149220409],
              [20.55040336271647, 8.965289731503278],
              [20.548948023671194, 8.959232556162904],
              [20.54452512398056, 8.957947141511836],
              [20.54220360987853, 8.955370391281152],
              [20.534645404646767, 8.95311394082087],
              [20.532931834287115, 8.959410116346966],
              [20.525519294295506, 8.962337218714755],
              [20.52471131538896, 8.964707981746432]
            ]
          ],
          [
            [
              [20.506543019597377, 9.001789301705255],
              [20.509748638353106, 9.001246443558124],
              [20.508848353775512, 8.99723466714991],
              [20.505707035115122, 8.997150524708857],
              [20.506543019597377, 9.001789301705255]
            ]
          ],
          [
            [
              [20.493981652600738, 9.0259655830124],
              [20.498087875313534, 9.031431155670552],
              [20.499366350884706, 9.028495857804758],
              [20.497272923289714, 9.025049915077503],
              [20.493981652600738, 9.0259655830124]
            ]
          ],
          [
            [
              [20.50911357563022, 8.926801223225832],
              [20.510646823768333, 8.931485071547593],
              [20.514319113929883, 8.930361670826647],
              [20.513079427007472, 8.924409377378776],
              [20.50911357563022, 8.926801223225832]
            ]
          ],
          [
            [
              [20.487239751843003, 8.991829308235957],
              [20.48660609664994, 8.994965282242934],
              [20.488952650975193, 8.997613648876781],
              [20.491388333264176, 8.993804684148957],
              [20.487239751843003, 8.991829308235957]
            ]
          ],
          [
            [
              [20.475889795780237, 9.009374578178372],
              [20.479886110358144, 9.009023516310437],
              [20.485926486955115, 9.012280096749873],
              [20.48656944758292, 9.006870033987969],
              [20.479069708895825, 9.005443807120617],
              [20.475889795780237, 9.009374578178372]
            ]
          ],
          [
            [
              [20.480787716285093, 8.93759077077509],
              [20.48260503309853, 8.943060164510316],
              [20.485484939180807, 8.940083665732423],
              [20.480787716285093, 8.93759077077509]
            ]
          ],
          [
            [
              [20.440250014571287, 8.896698271057433],
              [20.443790554641527, 8.902430865507473],
              [20.447393626949097, 8.900335077571853],
              [20.443558650336197, 8.896334657608612],
              [20.440250014571287, 8.896698271057433]
            ]
          ],
          [
            [
              [20.395996204635008, 8.936899594388338],
              [20.402052319906318, 8.937872383651838],
              [20.40011832379681, 8.932197449636583],
              [20.395996204635008, 8.936899594388338]
            ]
          ],
          [
            [
              [20.382705479825493, 8.898154295803312],
              [20.38764952910973, 8.89956807428986],
              [20.390078547879508, 8.894230547103103],
              [20.39676682200916, 8.897148271535341],
              [20.400706340132714, 8.901508858613868],
              [20.396520093212732, 8.909149468853732],
              [20.398819312007383, 8.911702375397375],
              [20.40944089901187, 8.90522904813657],
              [20.414230742199404, 8.906867360228475],
              [20.41832392851512, 8.906174504004948],
              [20.42613499719777, 8.902163019611208],
              [20.426611579793757, 8.89922792882296],
              [20.421368405415436, 8.895361583727032],
              [20.414320480711304, 8.896088939961407],
              [20.409893278545788, 8.898699377769137],
              [20.403927882291782, 8.899685632918672],
              [20.400217080039393, 8.893463653018687],
              [20.401001935684153, 8.887561952940384],
              [20.404515280294113, 8.887404067731524],
              [20.41003563054974, 8.882421342421164],
              [20.419301816653363, 8.883321262341257],
              [20.422202601518723, 8.881398197143985],
              [20.42615316445332, 8.88200718197712],
              [20.426390085587173, 8.87705999364025],
              [20.41454113977869, 8.87027967256488],
              [20.408841712273748, 8.869749259263292],
              [20.395751520584692, 8.876237134288578],
              [20.38604733991546, 8.887459042948516],
              [20.382705479825493, 8.898154295803312]
            ]
          ],
          [
            [
              [20.39094308336791, 8.818993184923148],
              [20.39210682855064, 8.822709981428146],
              [20.39704977498852, 8.826158762685559],
              [20.4060556813545, 8.82861734524379],
              [20.40798672583826, 8.83359613114037],
              [20.410880937227233, 8.833331588530475],
              [20.413454301932752, 8.828494434873766],
              [20.417782114217275, 8.828234224926524],
              [20.424542820973066, 8.825206290533337],
              [20.431244721935396, 8.81663603532584],
              [20.42981241084291, 8.81085732240904],
              [20.42406889624588, 8.80119703102112],
              [20.42362068346389, 8.791174749571015],
              [20.41912758004601, 8.787681992568984],
              [20.415877870439846, 8.788449248849028],
              [20.413387168390642, 8.794723027901746],
              [20.40800479711768, 8.803455392266304],
              [20.407955226307127, 8.808713716805386],
              [20.399988509019813, 8.811557381571168],
              [20.392017150144248, 8.815900406639713],
              [20.39094308336791, 8.818993184923148]
            ]
          ],
          [
            [
              [20.35264238912173, 8.80451991075619],
              [20.353281624351318, 8.809282490060905],
              [20.351094861537405, 8.811763245179696],
              [20.35085542810937, 8.818206004657213],
              [20.35551381739407, 8.820852530876085],
              [20.363318389995815, 8.823052547943307],
              [20.36154170460324, 8.8151334870818],
              [20.364896439496025, 8.809477785774499],
              [20.37007427062506, 8.813865322521515],
              [20.369073602027097, 8.817074795029558],
              [20.372981426358756, 8.819377003006899],
              [20.372515142849174, 8.825325086398138],
              [20.378431076378938, 8.826775640690535],
              [20.379677198556113, 8.825047802649035],
              [20.37886744694185, 8.819706014571679],
              [20.374960171215115, 8.814650255053351],
              [20.3783960920043, 8.812710089539397],
              [20.376481157725344, 8.804523829457398],
              [20.3775261394053, 8.79790645034203],
              [20.385653051902334, 8.796817364994192],
              [20.388505267289034, 8.795049763343496],
              [20.388275186477653, 8.791815353829369],
              [20.39324070113818, 8.791218383303256],
              [20.394988984248673, 8.787882684297074],
              [20.40306275606326, 8.78282922232781],
              [20.39784033874247, 8.781014479058138],
              [20.399209601678095, 8.774924127468509],
              [20.402635450751184, 8.767349107982735],
              [20.40520003296877, 8.766541096462484],
              [20.401222675146418, 8.761141551071884],
              [20.394431918609133, 8.755305271163126],
              [20.392185807560303, 8.75633937611618],
              [20.38379109570557, 8.766683184100584],
              [20.383299894617902, 8.772012402112622],
              [20.37712796906692, 8.778750291291896],
              [20.37169584487391, 8.786670209153378],
              [20.36543520414326, 8.78503652352237],
              [20.364472673847683, 8.787557260902958],
              [20.36995290153514, 8.790982238823617],
              [20.366347203700112, 8.79744229416328],
              [20.36547504945347, 8.802433750172309],
              [20.363476366581928, 8.803401171331544],
              [20.35849345534323, 8.800501083956792],
              [20.35432717447987, 8.800814510261718],
              [20.35264238912173, 8.80451991075619]
            ]
          ],
          [
            [
              [20.348478605101956, 8.785504101042427],
              [20.34727241184026, 8.79392465663659],
              [20.34968521221732, 8.794131696184744],
              [20.351749759863164, 8.785795855309436],
              [20.348478605101956, 8.785504101042427]
            ]
          ],
          [
            [
              [20.33275659277783, 8.805325802366774],
              [20.33748094277516, 8.80605879116987],
              [20.345857216868104, 8.809834526694873],
              [20.346906543978125, 8.806464611565513],
              [20.342966673200085, 8.804915319376029],
              [20.33743136654086, 8.796556599027813],
              [20.332947690186362, 8.801870228520592],
              [20.33275659277783, 8.805325802366774]
            ]
          ],
          [
            [
              [20.321759410084518, 8.769057215369187],
              [20.326992691175818, 8.76908907671503],
              [20.32676985050207, 8.763537913337617],
              [20.324725988216723, 8.762798215718904],
              [20.32053765881644, 8.766300246065956],
              [20.321759410084518, 8.769057215369187]
            ]
          ],
          [
            [
              [20.282433481732745, 8.744061435641623],
              [20.28721097979344, 8.744693838226482],
              [20.289054256441272, 8.741032777883703],
              [20.28662856974092, 8.73801257207733],
              [20.283507753538597, 8.740598591859994],
              [20.282433481732745, 8.744061435641623]
            ]
          ],
          [
            [
              [20.244359431189537, 8.743679279865349],
              [20.253864406968052, 8.74268669897661],
              [20.252196573024726, 8.737788488920765],
              [20.24897253728926, 8.73631114550461],
              [20.244359431189537, 8.743679279865349]
            ]
          ],
          [
            [
              [20.217017420938557, 8.766335005220576],
              [20.218535790056354, 8.769428050811758],
              [20.2225657746458, 8.770117795273837],
              [20.227800396432077, 8.766992280162585],
              [20.232269199119564, 8.757573263037493],
              [20.239045632080344, 8.755952023758681],
              [20.24068953647347, 8.744678803222891],
              [20.238504416125945, 8.7432268067123],
              [20.2333252749074, 8.745616072608485],
              [20.23081461589347, 8.750303645774382],
              [20.22453446310364, 8.754028727299081],
              [20.22070677190977, 8.759547204449571],
              [20.21990087405914, 8.763869690170285],
              [20.217017420938557, 8.766335005220576]
            ]
          ],
          [
            [
              [20.198270562709563, 8.7875348493808],
              [20.199380099693897, 8.791379037757988],
              [20.203980314199114, 8.793645792987977],
              [20.20326812852484, 8.788516776552957],
              [20.208533567866844, 8.78062879701337],
              [20.208966293578683, 8.776370223409895],
              [20.211948480888466, 8.773583539794526],
              [20.20837727773136, 8.769697089091128],
              [20.20523330201386, 8.772435141787346],
              [20.198270562709563, 8.7875348493808]
            ]
          ],
          [
            [
              [20.21390250274751, 8.739224075121497],
              [20.222512226833683, 8.741120465741501],
              [20.217531516656006, 8.734346132210302],
              [20.214297797759066, 8.735653809965656],
              [20.21390250274751, 8.739224075121497]
            ]
          ],
          [
            [
              [20.193565189504913, 8.794187236750572],
              [20.196079595016755, 8.798630146826277],
              [20.201289466732195, 8.801782008179252],
              [20.202579047212343, 8.797609563279552],
              [20.193565189504913, 8.794187236750572]
            ]
          ],
          [
            [
              [20.215800805841074, 8.715897242215984],
              [20.217919387358393, 8.71845760709766],
              [20.22524776869349, 8.712874926459673],
              [20.224831874200884, 8.709158764485473],
              [20.221580412658177, 8.705852100569944],
              [20.215800805841074, 8.715897242215984]
            ]
          ],
          [
            [
              [20.210250485346837, 8.701214492609127],
              [20.213191312685645, 8.705442235277841],
              [20.217372118906212, 8.70336264906137],
              [20.21737018169655, 8.701076099761595],
              [20.211879511625636, 8.699947320683076],
              [20.210250485346837, 8.701214492609127]
            ]
          ],
          [
            [
              [20.219562368022757, 8.625784816073406],
              [20.221519374369308, 8.62676759359229],
              [20.22817307225395, 8.62239774889563],
              [20.22762015656652, 8.619916296868492],
              [20.220042861409777, 8.62422660755106],
              [20.219562368022757, 8.625784816073406]
            ]
          ],
          [
            [
              [20.197844760300434, 8.693255147427758],
              [20.19882795241717, 8.704978265504659],
              [20.203843200767487, 8.704205418620107],
              [20.20513109757617, 8.697737258817142],
              [20.20936327927286, 8.696173065890408],
              [20.213112384357782, 8.686779409589153],
              [20.21595906804024, 8.686737399686026],
              [20.221198353598457, 8.67778449569176],
              [20.21917933249234, 8.676296654559355],
              [20.219661589502863, 8.6718676035718],
              [20.21664750095688, 8.671310965536527],
              [20.215069308746322, 8.67470477935431],
              [20.21097144897931, 8.673645384253605],
              [20.207500045688995, 8.676293324870805],
              [20.199058515980084, 8.688170544492168],
              [20.197844760300434, 8.693255147427758]
            ]
          ],
          [
            [
              [19.841392124961096, 9.420491768329514],
              [19.854747859657426, 9.42809815697341],
              [19.87457784637531, 9.437856643552436],
              [19.87671538486415, 9.438375744720656],
              [19.91451613056973, 9.458131289831403],
              [19.87182443810874, 9.53200394640197],
              [19.877444009914285, 9.53509852385575],
              [19.82065913256401, 9.635362170646586],
              [19.81102682394338, 9.65185986508223],
              [19.777434124442717, 9.711302904539068],
              [19.733796409554593, 9.787440617189352],
              [19.82749084643224, 9.84163495839865],
              [19.81962642580338, 9.854524232350727],
              [19.825020735211666, 9.851007216093816],
              [19.830689976225223, 9.849320970389936],
              [19.838013802596766, 9.85191751478978],
              [19.841959217957474, 9.850091187717394],
              [19.88429609193353, 9.874093391333918],
              [19.88643481881117, 9.872312875612877],
              [19.909696324102484, 9.879008880887206],
              [19.922188931348707, 9.87269509734453],
              [19.927259770470073, 9.879582755449455],
              [19.936763559557917, 9.873693482969474],
              [19.94635630815962, 9.874564800824283],
              [19.946322593155507, 9.880182455868638],
              [19.934775352965676, 9.887237963278706],
              [19.929109818500038, 9.896612480848223],
              [19.933910757969198, 9.89752770606169],
              [19.9431096705828, 9.891017957653128],
              [19.945801130872777, 9.893647922696065],
              [19.95713784981156, 9.884599460856789],
              [19.96216681644577, 9.87647559304909],
              [19.96854598217665, 9.87200048901063],
              [19.968490065740433, 9.868733495911755],
              [19.98083615600689, 9.859826664666564],
              [19.985688777652747, 9.853943041338551],
              [19.99358876673062, 9.849639140101024],
              [19.995521991568225, 9.851203286318237],
              [20.01058729041674, 9.843592746588028],
              [20.01355533342325, 9.84715177076611],
              [20.00883240954165, 9.852977155725593],
              [20.01184138910412, 9.855800384648706],
              [20.01768600192497, 9.853794155881785],
              [20.037712486502638, 9.844191741076282],
              [20.050073159930914, 9.848527655008482],
              [20.055632501346565, 9.845812596376245],
              [20.07256900120436, 9.843137643044722],
              [20.075228570768182, 9.846372613303398],
              [20.082108111532765, 9.848567414617317],
              [20.09063990450914, 9.84833692624384],
              [20.103238412325975, 9.845269926339457],
              [20.11630500667355, 9.84830982850656],
              [20.12068175410646, 9.854256192066694],
              [20.12034378807036, 9.859778447938556],
              [20.115834400826593, 9.862773699020407],
              [20.121473084446514, 9.864938408575485],
              [20.12644545294976, 9.869074913386248],
              [20.130366734979216, 9.866582574312384],
              [20.133836910923495, 9.870318429234766],
              [20.14053317907187, 9.873895340221788],
              [20.144898827952122, 9.873366421763533],
              [20.148079496620372, 9.868316548860667],
              [20.163890213054103, 9.859482655601296],
              [20.168128950430045, 9.855943813889972],
              [20.171389396430953, 9.849789775432656],
              [20.16919686710022, 9.845771287377154],
              [20.17283244162016, 9.83831531792699],
              [20.177009894139484, 9.835433929540585],
              [20.179726575798068, 9.829518327175393],
              [20.17874798351021, 9.826299248246462],
              [20.179501956539212, 9.819924965239155],
              [20.174860045917082, 9.818742205824647],
              [20.17481871779701, 9.813457599032951],
              [20.176604483017677, 9.806649209589006],
              [20.18025111710322, 9.802403987000911],
              [20.181104393764915, 9.798959117404598],
              [20.185548668786154, 9.797958455952607],
              [20.18699840542394, 9.795122800874305],
              [20.191541692627183, 9.792983720028653],
              [20.196554773769922, 9.78667676997808],
              [20.19060748275156, 9.787327224651143],
              [20.188244179267333, 9.78215334035097],
              [20.185644551215255, 9.783687796262107],
              [20.179247678008995, 9.782967027258223],
              [20.172680706235603, 9.786193537097203],
              [20.17014691425025, 9.784033629384899],
              [20.173673762536605, 9.781150761239244],
              [20.175645939103205, 9.776246816968426],
              [20.170301098560582, 9.777375096633195],
              [20.16391654074963, 9.782049814006065],
              [20.159873316759878, 9.777325445813258],
              [20.161211117506912, 9.77232791835222],
              [20.166409870001274, 9.771390527132553],
              [20.164731402850055, 9.768355023706214],
              [20.16169128662048, 9.769544569707946],
              [20.157947035466794, 9.768415995298898],
              [20.15591001697123, 9.764474036854764],
              [20.15151122179083, 9.762865737291412],
              [20.15178979347724, 9.758155696880202],
              [20.14826956991934, 9.756631914477678],
              [20.144659440601515, 9.757941575504326],
              [20.142610989058117, 9.755950557508458],
              [20.143841058503444, 9.75186778678724],
              [20.148273108443007, 9.74566974703314],
              [20.159850342480404, 9.738854581149619],
              [20.165029149598872, 9.733005822030405],
              [20.164781365512674, 9.727952759958427],
              [20.167417479531355, 9.722115567986519],
              [20.17222547832883, 9.720344797438992],
              [20.17410533280291, 9.717762565833349],
              [20.172286552888277, 9.714613576494369],
              [20.177125233895453, 9.706527203602077],
              [20.182680602056745, 9.699688065294696],
              [20.19054543804928, 9.700975375357112],
              [20.192157491048224, 9.69771673713816],
              [20.199783432322675, 9.691132060394795],
              [20.203659610284543, 9.690095347063338],
              [20.212970705128892, 9.68371811770008],
              [20.223060689182358, 9.677819873922775],
              [20.22506158736947, 9.673280845363715],
              [20.22933449326987, 9.668275693408102],
              [20.232397873877048, 9.667324838314954],
              [20.23149354461766, 9.663763071975753],
              [20.22775712754681, 9.662220407826315],
              [20.225941333214493, 9.65866825642339],
              [20.22548024668313, 9.653004654225372],
              [20.22719845383365, 9.649281972084852],
              [20.233360215135132, 9.647403558489813],
              [20.233741997527392, 9.641851463941139],
              [20.232117012015262, 9.639672762157806],
              [20.23539163691958, 9.634133062273447],
              [20.229413090295566, 9.622365105725645],
              [20.228432675907342, 9.61754468388762],
              [20.223615802926158, 9.614031985811051],
              [20.222937949410547, 9.609362910067617],
              [20.22697299492794, 9.606157667868146],
              [20.2278461375141, 9.600876603116465],
              [20.226294041330483, 9.59420522510868],
              [20.22710668281114, 9.586319312501724],
              [20.223937555611712, 9.584707361283952],
              [20.22506930748686, 9.578920153686928],
              [20.220625611897237, 9.57514196506352],
              [20.218835468488436, 9.571406424039516],
              [20.215144297148754, 9.573407504023189],
              [20.21342541767686, 9.562420999366227],
              [20.217533076166344, 9.561875863074224],
              [20.21969223884721, 9.558853523464236],
              [20.223867553917646, 9.559041975649272],
              [20.225759091621153, 9.553399096204753],
              [20.231098782331387, 9.544525705806173],
              [20.241737188625006, 9.532650723386986],
              [20.244620646699314, 9.53128833020727],
              [20.249402838282716, 9.531923384672302],
              [20.256277636330296, 9.525353221812075],
              [20.26264229488469, 9.521421085016877],
              [20.266714328494242, 9.515034895744705],
              [20.27344287256921, 9.507147948149797],
              [20.278297925999503, 9.500054141024222],
              [20.280124212557414, 9.491802442323118],
              [20.2829378763948, 9.490520408857927],
              [20.288308903254595, 9.490930127758807],
              [20.296114650534822, 9.484633249991235],
              [20.304023532965054, 9.482745583799943],
              [20.306620646471966, 9.4793501757547],
              [20.307363527381526, 9.474966374193455],
              [20.30421183562903, 9.472020123463121],
              [20.306312986034314, 9.465408704562687],
              [20.317490993615895, 9.462822589379527],
              [20.32517297651382, 9.462773904946197],
              [20.333498309472567, 9.45627529940341],
              [20.346394633462356, 9.450080213095188],
              [20.349208711988474, 9.44737784114007],
              [20.35280421892984, 9.448175472631045],
              [20.356003632504112, 9.44596367498663],
              [20.360087996672576, 9.44639149367463],
              [20.36504306622342, 9.454178588785698],
              [20.37069427495348, 9.455603103918316],
              [20.37137516498228, 9.462801583400866],
              [20.368505542859065, 9.466373172989027],
              [20.381850154672254, 9.474869769769052],
              [20.383197626549027, 9.478379859936325],
              [20.382402794938244, 9.482106426581733],
              [20.376372452501474, 9.483989531417627],
              [20.37454936573136, 9.487802266396853],
              [20.374530087110593, 9.495643178578545],
              [20.379041566562076, 9.499627794763768],
              [20.3755380996365, 9.505288353859495],
              [20.376414049371064, 9.509420250016511],
              [20.375007717106936, 9.516184986063175],
              [20.37815879398662, 9.520626270410798],
              [20.386871065734784, 9.522332044719123],
              [20.394262382970222, 9.521197647862264],
              [20.401241244522968, 9.517766604291003],
              [20.40633493457746, 9.517654012918221],
              [20.408882873469132, 9.515862523487284],
              [20.41183812843494, 9.510532686236083],
              [20.419144509598393, 9.509004835596674],
              [20.42446507530347, 9.505540012569341],
              [20.437877070549945, 9.517693402704639],
              [20.448111713149522, 9.51512909407392],
              [20.464157001909605, 9.51875535621427],
              [20.471920746388776, 9.51743811095953],
              [20.484457539397305, 9.5064797773689],
              [20.500038900234856, 9.496295303793417],
              [20.517094448521984, 9.481036269667687],
              [20.540037880759318, 9.449984835154016],
              [20.544715595444117, 9.44445995129922],
              [20.535422876720382, 9.438545248353265],
              [20.535489445531212, 9.432030370435855],
              [20.53035093459578, 9.429398099292959],
              [20.530200171710703, 9.42755559901946],
              [20.54579045883366, 9.420248479684274],
              [20.550010635571972, 9.415666726735116],
              [20.54499134930988, 9.407678917341336],
              [20.551132812130458, 9.409927930618128],
              [20.5536290402377, 9.413135809127645],
              [20.556719100929925, 9.41308441117845],
              [20.562311032163098, 9.409419457318133],
              [20.57023938544575, 9.401155707060994],
              [20.57497309768064, 9.39131048268658],
              [20.58018564450915, 9.385351377852684],
              [20.59366959300774, 9.374775001998994],
              [20.598541564520506, 9.368763003304123],
              [20.60073648817553, 9.364042641095699],
              [20.596166357124826, 9.356881121389481],
              [20.600893589482297, 9.353644881369357],
              [20.602631619573707, 9.355926125458188],
              [20.607883048488155, 9.355465080810182],
              [20.61233364069254, 9.351445353467438],
              [20.617077653725303, 9.339227516124309],
              [20.62127599906829, 9.339409731961158],
              [20.6219864270751, 9.3350431089],
              [20.629143845596175, 9.336275874076293],
              [20.635789932623087, 9.336422322700455],
              [20.639247464181317, 9.333312870012232],
              [20.637322806615487, 9.32761448428671],
              [20.639019718353296, 9.325745145294137],
              [20.646400786992604, 9.325249156382387],
              [20.647750834052673, 9.32322755814655],
              [20.657311734702446, 9.323132309889099],
              [20.663264302797266, 9.319514067312552],
              [20.665647153183606, 9.315186797813176],
              [20.667843971428244, 9.306099849095434],
              [20.66488705291444, 9.303358507903479],
              [20.662555024495877, 9.297824958119646],
              [20.668326693750444, 9.28999276348537],
              [20.67097262740403, 9.288574852036101],
              [20.67902327356864, 9.272747890377282],
              [20.68329200087948, 9.267096738192214],
              [20.676610046496513, 9.257981451624227],
              [20.675567246285887, 9.252964719172393],
              [20.683153747090095, 9.24765808327468],
              [20.684068500904168, 9.241477017390356],
              [20.68669811709957, 9.236004262429002],
              [20.695092926878857, 9.224631892094257],
              [20.69961237387495, 9.227610824865598],
              [20.698873323335366, 9.22998527245587],
              [20.70356646465756, 9.235145087787684],
              [20.712957289454994, 9.239112883095649],
              [20.715666482313697, 9.234221844915403],
              [20.710767041961205, 9.22515824672247],
              [20.705185422877243, 9.221807450940615],
              [20.700190980567278, 9.222951050685817],
              [20.694219377141785, 9.21120723206238],
              [20.69480912255594, 9.209510870443056],
              [20.691727399042733, 9.19993835889894],
              [20.689160564917923, 9.197699067541546],
              [20.684047074410067, 9.19619251553259],
              [20.685006516562837, 9.187089532610756],
              [20.6780390781148, 9.180156093517196],
              [20.678554067181985, 9.174629832742964],
              [20.673760495657355, 9.172529238642936],
              [20.667867610559227, 9.168067967323257],
              [20.66588653970747, 9.163435174202895],
              [20.661482643510134, 9.171166578712974],
              [20.656958833455086, 9.171512863258341],
              [20.65169891154726, 9.169181193916964],
              [20.649414359441288, 9.166373136607952],
              [20.65513866311006, 9.16447439582892],
              [20.657505116778495, 9.159259288176065],
              [20.656427568162524, 9.157432988081881],
              [20.65759807563199, 9.151257708522396],
              [20.653720842494046, 9.149510710078742],
              [20.65446607404445, 9.139943371138106],
              [20.64829485861622, 9.135895976451883],
              [20.641325197844655, 9.136632651155477],
              [20.63434056336776, 9.13160168463484],
              [20.635212636209566, 9.128897179676716],
              [20.63991192139534, 9.126850598880475],
              [20.639660970160644, 9.12077554168391],
              [20.64108982002308, 9.109761339159888],
              [20.639011192349635, 9.108340764500827],
              [20.63930407247591, 9.103596214855529],
              [20.633581258259586, 9.102300874133157],
              [20.635731416342946, 9.092927933173092],
              [20.632984705896607, 9.09143664576538],
              [20.6309745241883, 9.084410002187067],
              [20.62439410592238, 9.080743373383845],
              [20.621317820711976, 9.069696692662104],
              [20.620933736153287, 9.054360720952307],
              [20.621764296163704, 9.053242459425226],
              [20.61314825370807, 9.044346867866615],
              [20.60459190643558, 9.043355656787844],
              [20.601636187068316, 9.04135470293506],
              [20.60007473450938, 9.03347337919427],
              [20.6028243463187, 9.026270072347245],
              [20.604850089605144, 9.024596624496954],
              [20.590747958857794, 9.013695411927317],
              [20.576950320619623, 9.007344844078979],
              [20.568473044897427, 9.008603001522351],
              [20.564450468553723, 9.018209071602076],
              [20.56367825172873, 9.025685305535262],
              [20.564023791416794, 9.032978142007332],
              [20.558988852162653, 9.034931461412233],
              [20.55514649763864, 9.031994045234683],
              [20.547457638527593, 9.028924257002577],
              [20.542789646952148, 9.02468216223666],
              [20.54712369066099, 9.01655222403545],
              [20.55020731455548, 9.012944148226607],
              [20.54984788024523, 9.007924029911562],
              [20.55220766289065, 9.002689925768577],
              [20.557775872501725, 9.003527988705093],
              [20.565344623052304, 8.99691559570493],
              [20.56954557179918, 8.99593005574291],
              [20.56890354125495, 8.992926046840848],
              [20.563988345273557, 8.992814318214249],
              [20.557883261672412, 8.994791848013561],
              [20.553181771606713, 8.988762562488045],
              [20.553359662529182, 8.985797776042592],
              [20.544916863877777, 8.983783197781086],
              [20.543634624313313, 8.98952795570036],
              [20.540321194553652, 8.98938426136738],
              [20.53587718442336, 8.994506238494408],
              [20.534248097738445, 8.999965534247401],
              [20.53415654543596, 9.005830415534215],
              [20.52822653279462, 9.005777602259624],
              [20.528333733694254, 9.010178321276115],
              [20.51928675014002, 9.012515674563405],
              [20.51022472699742, 9.01046544924843],
              [20.508842121020834, 9.006608202792304],
              [20.504840007612213, 9.016066591555948],
              [20.5078611965704, 9.01779126523137],
              [20.510891799573336, 9.014342209469913],
              [20.519760746494413, 9.014791787370088],
              [20.517335304904893, 9.01965305112715],
              [20.515479253378537, 9.026438021526081],
              [20.516676243797615, 9.032416143597601],
              [20.514431641142977, 9.03505418622039],
              [20.510922827344892, 9.04309237037975],
              [20.514556079037405, 9.049866030589914],
              [20.512543506934538, 9.058526478816688],
              [20.505682575267407, 9.05822902724223],
              [20.492880241193824, 9.049631929942958],
              [20.49181017619665, 9.046313166398312],
              [20.485994076750167, 9.043476609245632],
              [20.477592776659844, 9.042121679908968],
              [20.47376894312521, 9.04024727611663],
              [20.471505541051652, 9.033321184912653],
              [20.475003848746287, 9.032397827723184],
              [20.47663247360541, 9.028343933573698],
              [20.472545970052156, 9.026739445964571],
              [20.466952764207164, 9.029927187499183],
              [20.460509824624058, 9.025148661785556],
              [20.454586664249124, 9.030511649537846],
              [20.450347944877898, 9.02658527018581],
              [20.45353340715063, 9.020382524815842],
              [20.448012619804445, 9.013787721799709],
              [20.452148404203857, 9.012428242577071],
              [20.458450259094985, 9.015410976636836],
              [20.459887488438717, 9.012523975006392],
              [20.465938747958454, 9.016306365758075],
              [20.469129176934153, 9.01570872562878],
              [20.466956336943557, 9.011328816137109],
              [20.46146574651996, 9.00862825763304],
              [20.464913810634492, 9.002153092182706],
              [20.4704023319208, 9.003893467706225],
              [20.474564102235036, 9.002560442113406],
              [20.475966380466485, 8.999585866826859],
              [20.480505707418192, 8.99694781319019],
              [20.489482094327077, 8.983578036371247],
              [20.49118339734197, 8.97538216058245],
              [20.48984490081886, 8.967556048324425],
              [20.485009346196776, 8.960976949681664],
              [20.48156514116149, 8.963031354402213],
              [20.4802402452385, 8.96689071007487],
              [20.47672582746995, 8.965917437942727],
              [20.475865350891524, 8.961690538667499],
              [20.47875219146549, 8.953631642913313],
              [20.4746408211508, 8.950702916008494],
              [20.47655897119337, 8.942609847889125],
              [20.473640517162753, 8.931032831654148],
              [20.471277150137787, 8.930666142731466],
              [20.461785404956366, 8.936972805042563],
              [20.459337956405296, 8.94079148522634],
              [20.458326913510234, 8.94719585249311],
              [20.45615334646234, 8.950739556890863],
              [20.450003979195927, 8.955694138027358],
              [20.447348273125144, 8.959089056936001],
              [20.45203357511645, 8.961049489308545],
              [20.452519283659516, 8.964004071899424],
              [20.44491249195216, 8.970788944283074],
              [20.442793202290538, 8.96628447685951],
              [20.43750921201232, 8.969048772879715],
              [20.43323978985145, 8.96914422517223],
              [20.433798773750222, 8.965108618356071],
              [20.431900768278645, 8.961021674245947],
              [20.432943078249732, 8.957133833769168],
              [20.43608132477784, 8.953887292113647],
              [20.442287121555992, 8.954383375449918],
              [20.444354949439926, 8.948353810140958],
              [20.451533648870253, 8.944063052022248],
              [20.451506210631614, 8.93738945055156],
              [20.449205992899905, 8.934580899636376],
              [20.443099589153487, 8.933763823015466],
              [20.44096005574394, 8.931003798128343],
              [20.44264198763368, 8.927848007442988],
              [20.43471671703287, 8.926111454080994],
              [20.42920072430058, 8.926867448475978],
              [20.42914043406775, 8.93037002325379],
              [20.425947039465488, 8.930972038725333],
              [20.422649608412005, 8.929086978512448],
              [20.417471933405242, 8.931274833044105],
              [20.413833699501456, 8.929022836929382],
              [20.41173248443697, 8.925575172485768],
              [20.40544577654315, 8.931545675656649],
              [20.407657294609756, 8.935421592410078],
              [20.403571546802887, 8.945482913922248],
              [20.399603011971468, 8.94851839297974],
              [20.3929538719053, 8.950503219710994],
              [20.382540561849996, 8.943410645665159],
              [20.383610958151873, 8.936995642537786],
              [20.380419411214053, 8.931238557596515],
              [20.372708971447615, 8.933453231947809],
              [20.370511217007337, 8.932999569272793],
              [20.366434690033717, 8.924581068353163],
              [20.36854357721407, 8.91677778786152],
              [20.363499465726697, 8.91822044385198],
              [20.36338591284263, 8.912926032015626],
              [20.36988524775864, 8.90456098857158],
              [20.368540248045026, 8.894153839360596],
              [20.36978853226294, 8.885061079483341],
              [20.367920240385857, 8.880442706864665],
              [20.3697162670468, 8.87170286548541],
              [20.36846916184421, 8.86408974108501],
              [20.37315829910508, 8.861506283402406],
              [20.377700048380895, 8.857325383396748],
              [20.384865010197398, 8.847529860088622],
              [20.382716274750283, 8.842275610469137],
              [20.38393848961247, 8.839168253262763],
              [20.378546396648467, 8.837174744138991],
              [20.37538249763082, 8.83427865314276],
              [20.367217357285345, 8.832669839415749],
              [20.36369887391492, 8.833179281885448],
              [20.361591002702273, 8.829727588159061],
              [20.35632242316158, 8.82847544944114],
              [20.350771919022854, 8.82415187767152],
              [20.335089314498937, 8.81885659811134],
              [20.325696759621106, 8.814973330922905],
              [20.32012239834718, 8.82495046032443],
              [20.308116202904564, 8.823762874051656],
              [20.30682788191567, 8.818807037314803],
              [20.3025370664763, 8.820665435749229],
              [20.298586270497665, 8.81858897080063],
              [20.29755629334878, 8.815643414288427],
              [20.293961590929253, 8.813604872626028],
              [20.291410253935965, 8.806742202991197],
              [20.295165094485736, 8.804558644506095],
              [20.29997441388673, 8.790210411312897],
              [20.296542788866752, 8.78195359297142],
              [20.298128835279062, 8.779637349500929],
              [20.296813569241614, 8.773616144859915],
              [20.294424437225352, 8.77203889351588],
              [20.28936083885474, 8.774940768604047],
              [20.2862977866658, 8.77472757813729],
              [20.279408060992058, 8.77028567452571],
              [20.272693615152885, 8.769460506856595],
              [20.267925784192183, 8.788064919251068],
              [20.263166296908395, 8.797145024984067],
              [20.262084205849913, 8.801206423529681],
              [20.254786641051417, 8.80707150292673],
              [20.250348699996948, 8.813977196089617],
              [20.24700528452579, 8.815070580970508],
              [20.23717007774921, 8.810537311065891],
              [20.237707801011098, 8.806291928140768],
              [20.235829230884995, 8.799230390437993],
              [20.240488530247767, 8.78589351288688],
              [20.245237298555093, 8.778550779948588],
              [20.241007233442442, 8.778060149692134],
              [20.23631016776016, 8.781119068888778],
              [20.232156726400582, 8.779687539146508],
              [20.22465523102638, 8.782405076160131],
              [20.221343676085382, 8.788358065581761],
              [20.217818658188097, 8.799754272940515],
              [20.208954051890107, 8.795848571056679],
              [20.205287867183756, 8.796847609647527],
              [20.205118173462466, 8.803112821534986],
              [20.19770087232954, 8.805961696155249],
              [20.196200179427063, 8.810245272773836],
              [20.188000242998886, 8.811629126191907],
              [20.182456881173376, 8.81013317063306],
              [20.181941879260297, 8.804364505253506],
              [20.186003295299546, 8.802081419495224],
              [20.191886202907043, 8.793329601484627],
              [20.187962013917478, 8.783724054256096],
              [20.19054627260404, 8.782221536742194],
              [20.190206145342493, 8.777028934853636],
              [20.18680861073202, 8.773723559855945],
              [20.181136786167816, 8.771486519119524],
              [20.18235184159384, 8.768693525318564],
              [20.187969451637752, 8.76652537690063],
              [20.192967768692437, 8.758376959291086],
              [20.195905865374083, 8.756277425909834],
              [20.198359479561958, 8.747183005587264],
              [20.200846655204256, 8.746000997624842],
              [20.202674511953493, 8.735331093020719],
              [20.201820187024413, 8.728623971476157],
              [20.198455959680853, 8.726469890083239],
              [20.199418336039265, 8.722555668079549],
              [20.196188720626996, 8.719814495718957],
              [20.196882350790638, 8.71300511140953],
              [20.191586474338706, 8.717559164491172],
              [20.185798177829763, 8.726006383537403],
              [20.18233050575299, 8.728650776027095],
              [20.17809793120055, 8.726321214946362],
              [20.176688188869388, 8.723437277363967],
              [20.18324770534429, 8.715925326721282],
              [20.184734770500846, 8.711101925769352],
              [20.18986650807532, 8.704211137250123],
              [20.19403277733573, 8.701599680734468],
              [20.191327537303966, 8.69832376675852],
              [20.190144649832586, 8.687242274551018],
              [20.192817777745503, 8.68488303308338],
              [20.192773272597556, 8.67871461451712],
              [20.19574363706188, 8.670085370277784],
              [20.19472554578849, 8.666638833093677],
              [20.195419356425063, 8.658064292139812],
              [20.199131954029127, 8.655081861984158],
              [20.196416408305556, 8.649719632593248],
              [20.196796865903774, 8.641020045922042],
              [20.195465938805384, 8.640567448183702],
              [20.18819994206948, 8.650262311820578],
              [20.183369202069233, 8.658117934703235],
              [20.18102912786918, 8.658820807245617],
              [20.18035196679799, 8.663894418588118],
              [20.177995343836308, 8.67039592498491],
              [20.175335132741665, 8.673288170638406],
              [20.176277495558708, 8.678847758273156],
              [20.174667337204642, 8.68150672467022],
              [20.172811488245422, 8.692396861521912],
              [20.165118555281385, 8.69957283602328],
              [20.159457254620158, 8.700154001335163],
              [20.162827983768132, 8.689436424382814],
              [20.162943998372707, 8.686409881249599],
              [20.15583278584737, 8.683925225238784],
              [20.15896554378565, 8.679089370335117],
              [20.161400397511354, 8.678812496602983],
              [20.16474256675201, 8.672378723231375],
              [20.16442144318984, 8.66668100122692],
              [20.1655075233808, 8.659948529860964],
              [20.167560081731388, 8.658523591218165],
              [20.167092997432547, 8.653416796214376],
              [20.169297684986052, 8.64990092305901],
              [20.165816646221035, 8.647086358289396],
              [20.1571625277827, 8.651484917110347],
              [20.149027311392725, 8.660771650024989],
              [20.14384684821428, 8.67155714558725],
              [20.14008723430873, 8.677458711895635],
              [20.138756373845567, 8.684089728495126],
              [20.127789426562142, 8.69502949303439],
              [20.1259285537532, 8.697633006793078],
              [20.117288415211892, 8.69768328953362],
              [20.120576741111396, 8.701953876415576],
              [20.120895306807867, 8.704724849609024],
              [20.118997850641236, 8.714017298062679],
              [20.11340331653698, 8.721990202434275],
              [20.106546029867058, 8.722546031546276],
              [20.101557562750887, 8.725193671106659],
              [20.059645807195217, 8.800223074626693],
              [20.074842704065393, 8.807961936428505],
              [20.034957862927154, 8.88346676058007],
              [20.023080659690443, 8.8772877794755],
              [19.982347690709855, 8.95541522396969],
              [19.928847398076023, 9.054023026415653],
              [19.89849199708734, 9.113948205746768],
              [19.97692128416628, 9.154759104237073],
              [19.926574045597572, 9.255871291209456],
              [19.876226311721847, 9.356919848148513],
              [19.841392124961096, 9.420491768329514]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -67.62873443377046, "lat": 45.03124426223837 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23029"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00581300"
      },
      "bbox": [
        19.733796409554593, 8.619916296868492, 20.715666482313697,
        9.89752770606169
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.793557622813523, 2.082138467732757],
            [14.794008660638962, 2.082697147068824],
            [14.804060231453954, 2.080144830250513],
            [14.807530263523054, 2.0800039953886036],
            [14.811802793241558, 2.0834367814159602],
            [14.817093993137957, 2.093739694590419],
            [14.82282435612258, 2.0983493194668914],
            [14.83009536177068, 2.1027806777589864],
            [14.83724676196985, 2.104558488294611],
            [14.840124098148387, 2.107467647673085],
            [14.852844912452184, 2.1089218368468403],
            [14.859459143511337, 2.1084098941201046],
            [14.86265999662006, 2.1054501969914146],
            [14.869845748670345, 2.106165874493583],
            [14.873830415824283, 2.104743816568839],
            [14.880582422982576, 2.1053884385320463],
            [14.884689400326499, 2.1071966146359102],
            [14.894781840312493, 2.104332434097244],
            [14.897824158270808, 2.1008612052754203],
            [14.903894883929782, 2.1015369399239456],
            [14.904578314355112, 2.1045180379400468],
            [14.90867644580655, 2.1043640249584112],
            [14.91317542328943, 2.107604693463322],
            [14.92164823383698, 2.1104779186782325],
            [14.92668345210528, 2.1170428228939375],
            [14.937915824796315, 2.119374919343619],
            [14.941496056296678, 2.1226023232981968],
            [14.947640218460513, 2.117947176787717],
            [14.956657464905385, 2.1196599078027547],
            [14.957182403054842, 2.122232990442785],
            [14.963510784812405, 2.120533794356792],
            [14.96913056158974, 2.12195448418197],
            [14.973271774430842, 2.1188923379350197],
            [14.983358328980675, 2.11753756905108],
            [14.986180448093746, 2.1184462026226387],
            [14.990878640115508, 2.1226729165675673],
            [14.994233234328108, 2.12339583319833],
            [14.997316294719964, 2.1213940236795334],
            [15.002548693540193, 2.1240450253322503],
            [15.00933661734895, 2.1223545954478915],
            [15.014063023200551, 2.115165507087791],
            [15.016801596003178, 2.1131291100262533],
            [15.015075537545858, 2.1092158943344548],
            [15.018403449515118, 2.105637814932785],
            [15.024825081305924, 2.1064879229802753],
            [15.02833292500969, 2.1052522235286455],
            [15.034922595397743, 2.099812275771855],
            [15.037190277781098, 2.094548019292816],
            [15.04096607377927, 2.093498199135062],
            [15.044521008344624, 2.096574749930698],
            [15.048318335880953, 2.0943609828705014],
            [15.051338536999364, 2.0955576070257544],
            [15.054294685727147, 2.092088991501113],
            [15.05573974445022, 2.097864462234438],
            [15.059884269903305, 2.1005722476677002],
            [15.06435757565776, 2.095846846340546],
            [15.066599085918039, 2.1007846362635316],
            [15.070555508576849, 2.0988680709087735],
            [15.074466032977602, 2.1012086618307104],
            [15.082321175750755, 2.100287227573623],
            [15.084568336019746, 2.0978700275853037],
            [15.08435232871724, 2.0930011325183004],
            [15.090568045944966, 2.087486364961722],
            [15.097488071045003, 2.085744389924249],
            [15.098337059523487, 2.0837041575562187],
            [15.094019195067427, 2.0788010759166493],
            [15.095862138708707, 2.0707008223341106],
            [15.093933645845066, 2.0593646482894616],
            [15.091474266144354, 2.056894052553661],
            [15.092145523651737, 2.0532148459384243],
            [15.096848007708953, 2.0513744660777835],
            [15.103238650021373, 2.046958385317731],
            [15.111561016803742, 2.0454073276145426],
            [15.118288339441158, 2.0428111077126605],
            [15.119735770349235, 2.0379891395728666],
            [15.124062729868744, 2.0400652141682247],
            [15.128705494221155, 2.037916578115625],
            [15.13073628252206, 2.035331985755749],
            [15.136823074826719, 2.031243989228081],
            [15.139983752856134, 2.02778322435961],
            [15.14831893153745, 2.0259890036131796],
            [15.152405110368424, 2.0264330786375795],
            [15.158535366846708, 2.024466993942665],
            [15.162428619872381, 2.0213975077446182],
            [15.167354060747465, 2.0219191551904783],
            [15.16957054647461, 2.0166354219720812],
            [15.173724204327305, 2.0147519936651883],
            [15.176015518417586, 2.016332954520809],
            [15.172009064575365, 2.0120092401117464],
            [15.169987751471204, 2.004101460654922],
            [15.167154958674946, 2.001985028495749],
            [15.168182410991566, 1.9978626858890438],
            [15.166261025784076, 1.9914085444798668],
            [15.163978498771208, 1.9905643358910463],
            [15.163641759454201, 1.9817918428680452],
            [15.157809002570025, 1.9813740319812834],
            [15.152224227029802, 1.9753896462993374],
            [15.145977155557851, 1.9745344907106896],
            [15.144071439763632, 1.9695153403826267],
            [15.135624166591569, 1.9587324322616213],
            [15.126457081852498, 1.9355000276794252],
            [15.125628851966411, 1.92925741756259],
            [15.12641598851141, 1.921671962037386],
            [15.123747034907595, 1.9143467955298326],
            [15.116376937382949, 1.909430623702772],
            [15.108094965781374, 1.9082931826544607],
            [15.100874297754027, 1.9026338879488212],
            [15.099245014660175, 1.8990853299111936],
            [15.099667512093935, 1.89340194216538],
            [15.097475016042253, 1.889525153373053],
            [15.090729834403598, 1.8845659893676716],
            [15.089255466593935, 1.8870652105219776],
            [15.082958339504943, 1.8891121331280292],
            [15.0768808817985, 1.889556531829171],
            [15.072813303282194, 1.8883300669454819],
            [15.067329641659652, 1.8891332537824541],
            [15.061619568400904, 1.8927227126403203],
            [15.048862636621914, 1.9046813988964475],
            [15.043086495256738, 1.8994135924362117],
            [15.035815207964815, 1.8963845764081957],
            [15.029225952872865, 1.8966008244614254],
            [15.025683802827675, 1.9011618316763679],
            [15.019430533316514, 1.9031595941053443],
            [15.016803925406327, 1.9058032941141005],
            [15.011024785909294, 1.8988491297622925],
            [15.007084044266168, 1.8973545639592562],
            [15.003908652146622, 1.8941272428457618],
            [14.995536420022805, 1.896984835951069],
            [14.998645627000737, 1.9027096293910433],
            [14.998224757800694, 1.9100757478418118],
            [14.995599943731028, 1.908161103792658],
            [14.989807664914125, 1.9079894608397743],
            [14.988511064656475, 1.9101511349283098],
            [14.979512984349245, 1.9099239814265916],
            [14.977804774024468, 1.9141191369651527],
            [14.979132970980565, 1.9218447258215563],
            [14.976838591083856, 1.923233745255263],
            [14.967512663316935, 1.924524694794443],
            [14.95981388909903, 1.9231503524211913],
            [14.955859389493009, 1.9268876776709016],
            [14.958202107702151, 1.930682293748671],
            [14.95542552318449, 1.9347785630541492],
            [14.948434337163098, 1.936390939422416],
            [14.949970585149629, 1.9446156260821363],
            [14.948730500022474, 1.948488711144681],
            [14.94288762469567, 1.9492806303834531],
            [14.942638267981033, 1.9611215411124348],
            [14.93590266347393, 1.962866526310074],
            [14.931501546850873, 1.9663410925636724],
            [14.922688568152685, 1.9710712284535334],
            [14.922059162418208, 1.9751521879180174],
            [14.918142286727518, 1.9797843667815047],
            [14.909826368781104, 1.9863308603676186],
            [14.905754438705646, 1.9854188882353787],
            [14.89653778140225, 1.9873585171460815],
            [14.894829449555406, 1.9932452262734104],
            [14.887517149699852, 1.9987474651240342],
            [14.881269171873717, 1.9999679231288086],
            [14.877317223416517, 2.0027931241730186],
            [14.868490912644594, 2.003519524695621],
            [14.85995048657004, 2.0054345662570383],
            [14.854917550734275, 2.0025060096940135],
            [14.849590658716286, 2.0049301431042292],
            [14.839196796266824, 2.0037421390282817],
            [14.835256225109257, 2.0077477807077426],
            [14.83508692764818, 2.010905088698806],
            [14.829118050416826, 2.01718505838729],
            [14.829780310688532, 2.0221642356985248],
            [14.82736234206199, 2.025736069588995],
            [14.815349483733685, 2.0335489023310065],
            [14.80587430528263, 2.0372160042001486],
            [14.803298411389964, 2.0415272991548514],
            [14.800422550779231, 2.0419515195133204],
            [14.797272536864018, 2.0478702830602193],
            [14.791802847446624, 2.0529348937858236],
            [14.78307472892586, 2.0642941236784957],
            [14.78388299388422, 2.071922236678944],
            [14.786358761890186, 2.073542224880212],
            [14.793557622813523, 2.082138467732757]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.93107403865432,
          "lat": 39.250721435390275
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24027"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01709077"
      },
      "bbox": [
        14.78307472892586, 1.8845659893676716, 15.176015518417586,
        2.1240450253322503
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.104982276728187, 7.1281385813755165],
              [8.108135431118022, 7.097739755538787],
              [8.12228596261209, 7.099282342278765],
              [8.143555564736381, 7.100711962427975],
              [8.148972285026483, 7.095477799378776],
              [8.151931021815539, 7.088241043925758],
              [8.159171087302452, 7.082215314191855],
              [8.16253073543854, 7.0783410079942835],
              [8.168267014664597, 7.068018253305729],
              [8.169731956123988, 7.064086589600762],
              [8.167651953052323, 7.058419939135855],
              [8.171894672244445, 7.050797359399081],
              [8.180330773100488, 7.0433592626625785],
              [8.182822352520223, 7.042772909910527],
              [8.187950296228225, 7.045676198162954],
              [8.193359183076646, 7.046126967174319],
              [8.202311207708405, 7.044129563270532],
              [8.20787274403849, 7.045904874507307],
              [8.204610081242103, 7.054618137071154],
              [8.205205571843232, 7.064786234941429],
              [8.242460964672047, 7.068593019925337],
              [8.36753629100977, 7.081555811137963],
              [8.373413331998249, 7.023917986028973],
              [8.376755988845927, 6.995185316914391],
              [8.383023926229047, 6.9380209173163925],
              [8.38671023812818, 6.9092789705848325],
              [8.353818942161114, 6.906486517539045],
              [8.309865320556751, 6.90229029283788],
              [8.300633242252822, 6.900964046191614],
              [8.272895796412277, 6.897882800253194],
              [8.2155436655768, 6.892800638073893],
              [8.190436873590318, 6.889399780065952],
              [8.110004508482382, 6.8803738918106285],
              [8.044046167150835, 6.8726141950005175],
              [8.039153572655716, 6.919305666697684],
              [8.034796203973496, 6.95927141612345],
              [7.992452352770517, 6.9551651375126085],
              [7.918432829173213, 6.948424670900609],
              [7.917330964486254, 6.959116249510561],
              [7.917108706234358, 6.9718051539087575],
              [7.91544028013292, 6.975554654002371],
              [7.917119127064909, 6.979014945170414],
              [7.917581181236068, 6.9851773417242],
              [7.919237930437388, 6.989461683848458],
              [7.920229025526573, 6.997088975324303],
              [7.9221346283610155, 7.002002587753185],
              [7.923353795857301, 7.012010512322952],
              [7.926476542978964, 7.017961093127773],
              [7.930546325317553, 7.019074619597203],
              [7.934222086489148, 7.024769409294766],
              [7.942351752164162, 7.029968645634467],
              [7.945396225958296, 7.034079443811462],
              [7.946817730089454, 7.041095636452043],
              [7.950644735758869, 7.046959884434071],
              [7.95623283836841, 7.047837324701343],
              [7.96047071101143, 7.051397859106275],
              [7.965329363645398, 7.064399139474901],
              [7.968459893955896, 7.067980791230603],
              [7.974231225010833, 7.06102648337713],
              [7.986681292978577, 7.063679715396743],
              [7.9937605063072015, 7.068537352961823],
              [7.998613240987744, 7.075247259363295],
              [8.000791551247701, 7.084417725177652],
              [8.000705720355231, 7.089485898437009],
              [8.004953565257901, 7.090861131871547],
              [8.009237741870765, 7.089585920562869],
              [8.018504463290746, 7.098266103682868],
              [8.030419957514523, 7.115021524218129],
              [8.03819555549632, 7.114203715472856],
              [8.045296285001983, 7.1156452162834265],
              [8.05174362062215, 7.118803769228487],
              [8.058486448821675, 7.1242425918486525],
              [8.06230280502779, 7.123846114739217],
              [8.064519034747855, 7.126825757616081],
              [8.068024807494615, 7.126180484012052],
              [8.074924419808193, 7.131665848095359],
              [8.081752702619491, 7.130719412432826],
              [8.08658573525681, 7.1282171260463105],
              [8.095665027972204, 7.127246039420268],
              [8.104982276728187, 7.1281385813755165]
            ]
          ],
          [
            [
              [7.850784518606892, 7.509290300510302],
              [7.854838884325064, 7.512374493111405],
              [7.858331224368569, 7.519131535828596],
              [7.864594294962855, 7.525765390925398],
              [7.863209758202662, 7.530302141283318],
              [7.867391889482119, 7.530097929114007],
              [7.868376334160753, 7.532935745297959],
              [7.86107557082998, 7.535904610726321],
              [7.864884000660469, 7.538146579081503],
              [7.865676317925029, 7.541824017656811],
              [7.858327255113509, 7.546940360393804],
              [7.8642284590140275, 7.55161576594128],
              [7.8682129198503326, 7.551868198122446],
              [7.872097723216145, 7.548518689701291],
              [7.878475878178563, 7.538130296680931],
              [7.879566968105802, 7.531072189394911],
              [7.87767006695521, 7.527317964651514],
              [7.873385831204078, 7.524158901812229],
              [7.876381704886383, 7.5135274633560485],
              [7.872024239449455, 7.512275246081009],
              [7.866617644555314, 7.503627206981728],
              [7.8639230913533416, 7.502652404721048],
              [7.853138504088508, 7.506870283773942],
              [7.850784518606892, 7.509290300510302]
            ]
          ],
          [
            [
              [7.754493102198428, 7.52191198352187],
              [7.762429505312089, 7.525354977506272],
              [7.762428946966825, 7.52813141349958],
              [7.7562900343938885, 7.532241231413198],
              [7.752997380778952, 7.540016735498819],
              [7.756144276107241, 7.541136186837323],
              [7.754025252167352, 7.549136670750848],
              [7.7605817366468495, 7.549473527295666],
              [7.778343423595246, 7.54334718340767],
              [7.794420754334572, 7.532294252394013],
              [7.7937120495961505, 7.529131531671025],
              [7.795313692638703, 7.52512420047289],
              [7.7978111319349175, 7.5241029888034605],
              [7.804461760429571, 7.52447417627369],
              [7.807982252663803, 7.521711422813792],
              [7.808040186181321, 7.518509405181876],
              [7.800646067666215, 7.515542171496599],
              [7.801816797633849, 7.508860644357173],
              [7.807167691903604, 7.506669347877978],
              [7.808087166688756, 7.504255003918402],
              [7.80177435840355, 7.503120544717049],
              [7.799947144100876, 7.506666817799679],
              [7.792063806934954, 7.5052802925476145],
              [7.787891236935446, 7.5059359723864265],
              [7.783831983954091, 7.498958295107581],
              [7.781233344631002, 7.497879894676904],
              [7.7736883520759195, 7.5017179582144236],
              [7.774977423040549, 7.507107418337214],
              [7.777812169976176, 7.507999231207285],
              [7.7811031609716705, 7.513226203137446],
              [7.779808183296628, 7.515799676027159],
              [7.775637429884085, 7.517206664591097],
              [7.773559996923619, 7.52168740717122],
              [7.768987162889168, 7.5188586640867685],
              [7.761952159251826, 7.5199806851545805],
              [7.754968382091676, 7.519652978299946],
              [7.754493102198428, 7.52191198352187]
            ]
          ],
          [
            [
              [7.705619523592639, 7.553656130592371],
              [7.710442686538192, 7.557330313170584],
              [7.712860499197562, 7.556252933507139],
              [7.711275917548647, 7.550529410002422],
              [7.705619523592639, 7.553656130592371]
            ]
          ],
          [
            [
              [7.692572581125421, 7.525428818433145],
              [7.696051681644817, 7.5293206957953025],
              [7.701632291034437, 7.527458812028843],
              [7.697391140747321, 7.522564909920883],
              [7.692572581125421, 7.525428818433145]
            ]
          ],
          [
            [
              [7.709494926319211, 7.318708808570276],
              [7.711646237623726, 7.320386071991692],
              [7.712084718743003, 7.326851604960857],
              [7.710896438000362, 7.330959622521103],
              [7.711255406705197, 7.341802787467543],
              [7.715628790415993, 7.347992612963139],
              [7.718587925560525, 7.349640229787241],
              [7.720686247493501, 7.3583233304776305],
              [7.719232781838341, 7.367560733903179],
              [7.716259806179451, 7.373368246638514],
              [7.714983520351142, 7.381549236393395],
              [7.71702133259905, 7.385245387750887],
              [7.715962115571682, 7.390041191833217],
              [7.7172312767719164, 7.392679310097879],
              [7.716370499589788, 7.399715155423584],
              [7.718098970036162, 7.401949528397757],
              [7.718050188260199, 7.406471089892475],
              [7.721486297732747, 7.409180729860125],
              [7.724102294544105, 7.416595033064098],
              [7.72937489891974, 7.420467501182301],
              [7.7351745313806175, 7.431044132678914],
              [7.7347705416926855, 7.437489437003331],
              [7.732970261694606, 7.447001111360131],
              [7.736120993646247, 7.448370175630547],
              [7.739222085962838, 7.455442286563422],
              [7.738002378713778, 7.462872253660815],
              [7.73303930269274, 7.468612909801777],
              [7.734136852791294, 7.469805413917029],
              [7.7326446589450395, 7.477776212597514],
              [7.7335404697211105, 7.479511796176695],
              [7.740124746452673, 7.479500031993302],
              [7.745579393092966, 7.477882016001208],
              [7.7502536075387365, 7.472559434162263],
              [7.756008042281246, 7.4721741442555984],
              [7.763206821304373, 7.473031376348834],
              [7.775546860350182, 7.479116583292161],
              [7.779407230703715, 7.478751487752936],
              [7.782813388373299, 7.470982585899045],
              [7.7789609410657645, 7.467094627858902],
              [7.775494241695692, 7.466301840543453],
              [7.774665354131186, 7.472321748148149],
              [7.770322242628193, 7.4728046187212405],
              [7.76707522338921, 7.467756776443892],
              [7.767737279607759, 7.460354613303045],
              [7.772816494627391, 7.460214490506886],
              [7.777177264659952, 7.454822538831041],
              [7.779557232802466, 7.454800007246746],
              [7.784234205776578, 7.4512446096569676],
              [7.782637834458275, 7.44557943912231],
              [7.783467032943541, 7.4425209801804515],
              [7.787175793914762, 7.440446292599711],
              [7.787490451682909, 7.435285134650617],
              [7.7892314471785475, 7.432901206506638],
              [7.790606167115672, 7.424211946918384],
              [7.7853289416047735, 7.416174553407604],
              [7.784118621505698, 7.406219001916382],
              [7.786918287346699, 7.395880115818822],
              [7.789902772813529, 7.390051015839566],
              [7.798333275916699, 7.3788350536197225],
              [7.799200488823088, 7.372251904823248],
              [7.801992017603579, 7.364503963311587],
              [7.802155310637117, 7.357175466517807],
              [7.8039863328260655, 7.348624849667034],
              [7.802665619352656, 7.342464085316241],
              [7.8022268239888275, 7.3347801788106155],
              [7.800217216442726, 7.332541760595594],
              [7.7925047254735516, 7.328736336382566],
              [7.791238353934269, 7.322545448989899],
              [7.785535217225801, 7.3183641499696765],
              [7.7795188950239496, 7.316384734146247],
              [7.775305534770494, 7.307964075766404],
              [7.776002763210457, 7.302637974067706],
              [7.771432780827145, 7.298991147871324],
              [7.757473831253632, 7.294637285730581],
              [7.748429476606381, 7.296433228982644],
              [7.746655302589106, 7.29584235135122],
              [7.739817393308563, 7.3003266690567585],
              [7.732102477456136, 7.299095175090605],
              [7.72809299074086, 7.301588302388817],
              [7.72345999372416, 7.29932689065425],
              [7.715776482429768, 7.300735428474031],
              [7.710001846745934, 7.312247069598597],
              [7.709494926319211, 7.318708808570276]
            ]
          ],
          [
            [
              [7.641912036814588, 7.4836830916649735],
              [7.647437414331615, 7.4849472738596114],
              [7.6508285310672175, 7.480394417828768],
              [7.644481708468758, 7.4804684169508455],
              [7.641912036814588, 7.4836830916649735]
            ]
          ],
          [
            [
              [7.6426356775588875, 7.448015037816104],
              [7.644646873407201, 7.448509114859425],
              [7.649991175286933, 7.457493452966728],
              [7.655053920106607, 7.458296556008844],
              [7.66778934668906, 7.455796785555455],
              [7.680998391328417, 7.4563280321943415],
              [7.675286531173635, 7.453323485433753],
              [7.67530530592218, 7.445905324062554],
              [7.678267023240087, 7.440907192604322],
              [7.679102540288574, 7.435986526665328],
              [7.677016426730889, 7.4291610062577025],
              [7.671670788228165, 7.421063209982295],
              [7.666512281699752, 7.4152320767539575],
              [7.6662934727064105, 7.41033922057769],
              [7.661361866308399, 7.407707298771767],
              [7.65561164353942, 7.408486717526676],
              [7.652196954999353, 7.4067551312063316],
              [7.649291485587347, 7.40798582242617],
              [7.650836756644354, 7.419657184169982],
              [7.648472545103711, 7.422787441457147],
              [7.653299450469622, 7.4248666871656335],
              [7.654174464741363, 7.43058552991824],
              [7.649334832722194, 7.435910359301505],
              [7.649493967005942, 7.4389598423115775],
              [7.647259838769249, 7.444295709403238],
              [7.6426356775588875, 7.448015037816104]
            ]
          ],
          [
            [
              [7.547846237416971, 7.3943043626102245],
              [7.549255370843515, 7.402113784646015],
              [7.549704916793144, 7.409778984831071],
              [7.552458018625688, 7.409118129709249],
              [7.554455676570862, 7.402545715946368],
              [7.554102320707824, 7.396507254721263],
              [7.547846237416971, 7.3943043626102245]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.1241193000531, "lat": 45.29949412061433 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26029"],
        "coty_name": ["Charlevoix"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charlevoix County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01622957"
      },
      "bbox": [
        7.547846237416971, 6.8726141950005175, 8.38671023812818,
        7.557330313170584
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.311393207447987, 7.992702401520623],
            [4.313855368658596, 7.993706102031593],
            [4.3325776937041685, 8.010582979425031],
            [4.343009422271082, 8.017524701743378],
            [4.358293128732713, 8.029811042251213],
            [4.364540336162337, 8.036454802999584],
            [4.369134366977226, 8.038330888977434],
            [4.383282814089263, 8.033457493205093],
            [4.385992331284306, 8.033324703548642],
            [4.413472267781328, 8.050558680912548],
            [4.432156315592029, 8.057580043181163],
            [4.443820550039519, 8.063198478123569],
            [4.4501097598139525, 8.067070599834139],
            [4.481481700818829, 8.081353221266648],
            [4.489643413913899, 8.082956699819917],
            [4.505570056696648, 8.088115513206448],
            [4.5087937191817105, 8.088391103227401],
            [4.524431367018537, 8.093488348632832],
            [4.545768110225665, 8.102679098736797],
            [4.559541523923314, 8.107177116970623],
            [4.5733187427332345, 8.11490161152364],
            [4.593354826166758, 8.13394605089952],
            [4.600373004581545, 8.145707178380823],
            [4.60965911670849, 8.154329998144247],
            [4.619227924799695, 8.160470479297748],
            [4.63141855398413, 8.171012399919633],
            [4.643430392916996, 8.182009317210579],
            [4.665365767419031, 8.211364555907954],
            [4.680188227680405, 8.21224220734846],
            [4.690863456910083, 8.042149203125495],
            [4.776469262594993, 8.047537102377744],
            [4.779261484223817, 8.005536686978889],
            [4.781777158077595, 7.961960433740438],
            [4.8469520093427665, 7.966557087227449],
            [4.912127826801852, 7.971141081058442],
            [5.040365661768871, 7.979662533176164],
            [5.040849925705468, 7.969715922788075],
            [5.045988077726956, 7.894242709568185],
            [5.049334869964767, 7.8520125234690346],
            [5.049523913337051, 7.8381523612480155],
            [5.050502967120996, 7.823511730740987],
            [5.052105961112863, 7.809290585032261],
            [5.138119110645098, 7.815166204208307],
            [5.224133707081458, 7.8210200611373955],
            [5.296073094549465, 7.826415470862248],
            [5.310703407438049, 7.826947557595075],
            [5.321181477327769, 7.687863934498137],
            [5.328068252356011, 7.595216060958231],
            [5.255290290512489, 7.630773980906078],
            [5.231656937925606, 7.6350497717298245],
            [5.2021537256014945, 7.6412064167490525],
            [5.182670470001733, 7.644850885246177],
            [5.164666762471587, 7.648906040152806],
            [5.124506557572939, 7.65678096400345],
            [5.05681043249709, 7.670633912113177],
            [5.047524286580381, 7.672279101622689],
            [4.97015890023739, 7.687943724850563],
            [4.9432874336439845, 7.693873329831588],
            [4.869609332829635, 7.708448825360567],
            [4.849017347536168, 7.713023240642406],
            [4.780821091291409, 7.726667485869832],
            [4.67969019645998, 7.747855119853395],
            [4.664966619111791, 7.750598298363178],
            [4.621821271064976, 7.75966059179621],
            [4.530442367726775, 7.778953991260012],
            [4.53151621365149, 7.781353935681993],
            [4.529855158702232, 7.791574044303792],
            [4.5321798780569384, 7.7927257616886605],
            [4.5302093877169, 7.801109306964067],
            [4.527111994332811, 7.805238180548878],
            [4.519046208086391, 7.8128873708476005],
            [4.518335264961367, 7.820074137741526],
            [4.519585634061159, 7.822247558683464],
            [4.514412364396193, 7.825643444246807],
            [4.511048991871245, 7.830126324424286],
            [4.508464236762084, 7.839270806203029],
            [4.504076252171267, 7.841142077412317],
            [4.5030081079572755, 7.8464004682644495],
            [4.500194252794262, 7.84882227280828],
            [4.499146418270568, 7.853190870971072],
            [4.498856654215577, 7.861969536318025],
            [4.4959762777203665, 7.866579491871767],
            [4.494800664434234, 7.873548783119675],
            [4.490443686957828, 7.878569473962934],
            [4.484449856440247, 7.878485125601639],
            [4.484800122665343, 7.885875312422036],
            [4.483151569731216, 7.88834024610947],
            [4.483411545865271, 7.893878970620033],
            [4.475417088012482, 7.896320918926401],
            [4.472457602849375, 7.900433196295451],
            [4.473196076589082, 7.90292009453387],
            [4.471819778372955, 7.909640495774501],
            [4.4658569039937746, 7.9128286988446455],
            [4.462881428596901, 7.917254595501256],
            [4.462612195165976, 7.920915984635275],
            [4.458078852230341, 7.926484399805564],
            [4.454050613734317, 7.937527603299985],
            [4.449985232573416, 7.938886070107452],
            [4.445695389567397, 7.936839955726336],
            [4.443229975029341, 7.944871871320831],
            [4.440158705541661, 7.941995330420335],
            [4.433571543931581, 7.9393351083456905],
            [4.42038336682707, 7.937552464178856],
            [4.419246912653951, 7.941467225114331],
            [4.413174442406089, 7.9485837547744005],
            [4.414293576163581, 7.9542998461510175],
            [4.410969768035094, 7.957424889392684],
            [4.406971965728906, 7.951628227893144],
            [4.399001970260376, 7.953901267023208],
            [4.399402876270365, 7.95115745442541],
            [4.38613765380314, 7.947748863345605],
            [4.383138334502408, 7.952950042154359],
            [4.385313500190978, 7.955202703748636],
            [4.387428305051685, 7.964002670542895],
            [4.386847148010582, 7.970704709228031],
            [4.382988371567453, 7.971968262447994],
            [4.379663493063239, 7.9774402532690365],
            [4.37554266743767, 7.976745249983727],
            [4.371537271612874, 7.983557754709781],
            [4.368023393513622, 7.984139261333245],
            [4.363033866001841, 7.9818776581588],
            [4.362658113394132, 7.97610657887946],
            [4.359602448937115, 7.97020896322308],
            [4.3548532578729855, 7.968446682384318],
            [4.352409619670057, 7.970662676802657],
            [4.348015771358887, 7.970189719246841],
            [4.339204655642694, 7.965251648813462],
            [4.3354512736955275, 7.962161541192418],
            [4.330447037708523, 7.960705539323517],
            [4.32512631041557, 7.972034151584297],
            [4.321114756409354, 7.974964602346852],
            [4.3191594522259855, 7.981694917968594],
            [4.314344259915545, 7.9841979561815455],
            [4.313296741220715, 7.989920871020815],
            [4.311393207447987, 7.992702401520623]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.69425360835633, "lat": 46.40873441562253 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26053"],
        "coty_name": ["Gogebic"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gogebic County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01622969"
      },
      "bbox": [
        4.311393207447987, 7.595216060958231, 5.328068252356011,
        8.21224220734846
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.843212418929938, 5.018647882473864],
            [7.899269753223867, 5.025000920209752],
            [7.921360874541666, 5.027857056305021],
            [8.007150795831272, 5.037733250420804],
            [8.047224255980323, 5.042071003786883],
            [8.151048512066058, 5.05382572294288],
            [8.187202748529744, 5.057681466769027],
            [8.189001783610262, 5.042577399698835],
            [8.200518519073732, 4.940832535967857],
            [8.20689009201242, 4.8831157753251535],
            [8.217025179737885, 4.7944594415401145],
            [8.222299551192759, 4.750809101945431],
            [8.234755455749958, 4.6430439019499925],
            [8.239073100867058, 4.607895826612654],
            [8.243029802830964, 4.5791149522654795],
            [8.244258190344423, 4.567354120765029],
            [8.248358111599362, 4.5358488366465295],
            [8.193804403451033, 4.529147525668067],
            [8.127094432336841, 4.521188953327694],
            [8.077443917128, 4.515062704713531],
            [8.034324967615206, 4.5104479785176705],
            [7.992047277712055, 4.505673545635608],
            [7.93528634459102, 4.4996911021423935],
            [7.905557234771552, 4.49641555993039],
            [7.9021840714686284, 4.5254944325844235],
            [7.899061585229625, 4.554805441938036],
            [7.896333088094028, 4.584274178994264],
            [7.890294454175106, 4.63953851752161],
            [7.883967105282989, 4.683364602025741],
            [7.879945228294969, 4.714201484568964],
            [7.8728704614093035, 4.7577564341871925],
            [7.870992188013366, 4.778562056977827],
            [7.864985073766044, 4.828782552857867],
            [7.862952869480446, 4.844521845449262],
            [7.852523722406783, 4.931183419069549],
            [7.843212418929938, 5.018647882473864]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.54928920350709,
          "lat": 43.032136038913535
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26081"],
        "coty_name": ["Kent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kent County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01622983"
      },
      "bbox": [
        7.843212418929938, 4.49641555993039, 8.248358111599362,
        5.057681466769027
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.449618609260321, 3.9859410090046206],
            [9.535068624894084, 3.999199717996842],
            [9.542516237493587, 3.9994703962715255],
            [9.620593280305828, 4.011426366460528],
            [9.663843796324523, 4.01842714085405],
            [9.70707865236762, 4.025065203909642],
            [9.7062075390747, 4.030818027381746],
            [9.738011005545097, 4.035386426994507],
            [9.797774548700481, 4.043723607477463],
            [9.806437541191947, 4.03871868582051],
            [9.813501452923646, 4.027440408877475],
            [9.819806176842151, 4.026448942456803],
            [9.819309135351201, 4.023449700677536],
            [9.823738035118629, 4.0219114288545725],
            [9.824514463435266, 4.0255169645181645],
            [9.828039479503717, 4.026951061557368],
            [9.83071563354309, 4.022215541187521],
            [9.833288769975631, 4.0215431357887175],
            [9.83637628074505, 4.014837712451407],
            [9.840231075766024, 4.01625193540434],
            [9.851773044764466, 4.009105810796875],
            [9.851002007622261, 4.005532827168736],
            [9.859070422667552, 4.0062319387055],
            [9.861083061666616, 4.0020085425105005],
            [9.865059444139137, 3.9998153175755347],
            [9.873073742875848, 3.9938245469400524],
            [9.88125514821385, 3.9863393241982474],
            [9.886954726168645, 3.9871874085925425],
            [9.890892422312527, 3.9802480988663795],
            [9.889309378877766, 3.969607947622533],
            [9.884408170303626, 3.967251664830852],
            [9.884635441379094, 3.971457633783348],
            [9.880231009701795, 3.9764495202227055],
            [9.877149431966235, 3.9775811170559607],
            [9.871744715846154, 3.9732830530655057],
            [9.875679820252795, 3.9678227058164266],
            [9.87332191955413, 3.9646084927107657],
            [9.87350972035266, 3.954397559041863],
            [9.876596742184395, 3.9507741215819854],
            [9.870011564074582, 3.946227542271152],
            [9.868673665051789, 3.9504635372298016],
            [9.865034095651856, 3.953431736526366],
            [9.855876637507336, 3.9504304157101036],
            [9.85474404739659, 3.9467078616160576],
            [9.86305750423535, 3.9481604465421527],
            [9.862150634337045, 3.944994372565059],
            [9.854951386150923, 3.9373785446195817],
            [9.852094675178757, 3.9329805510101443],
            [9.846823758372306, 3.928239341162293],
            [9.84382907664662, 3.9135054097135353],
            [9.843479235689257, 3.906752086945289],
            [9.84832049025431, 3.8994095032328864],
            [9.842278548349114, 3.8928391046600743],
            [9.841476022828415, 3.8839804066916876],
            [9.836990042425628, 3.8924848654666757],
            [9.825772223342904, 3.895754429876459],
            [9.816714859256914, 3.8948957125947183],
            [9.813582236183574, 3.8935974938541387],
            [9.80479622145172, 3.88559012309901],
            [9.801471961809062, 3.8812311531056127],
            [9.797616774413187, 3.8714335350528755],
            [9.798917845429623, 3.8678266714973475],
            [9.79820417938656, 3.8632555652313436],
            [9.795381752548314, 3.860762796510812],
            [9.794771341635968, 3.8537669121551525],
            [9.795420250049716, 3.8360682642265416],
            [9.794396362594691, 3.83514750691786],
            [9.791822517762778, 3.8251052893634543],
            [9.789212243961805, 3.822266989504321],
            [9.78387404356626, 3.8207375911086494],
            [9.781250663137852, 3.818549893150241],
            [9.771347349399761, 3.819863863720103],
            [9.763096253270785, 3.811389181275702],
            [9.759217436036772, 3.8000175697431122],
            [9.755049686267583, 3.7920005659073044],
            [9.74938255128912, 3.7696992376388456],
            [9.74937643916518, 3.767163254872577],
            [9.74326226152293, 3.759732799643523],
            [9.73722144067662, 3.7581344608687557],
            [9.732901790943728, 3.75558164288421],
            [9.729652641146261, 3.7496746172766118],
            [9.728744118256042, 3.7449745649029302],
            [9.729354077482856, 3.7392964781944107],
            [9.729221584538603, 3.726501194154585],
            [9.732754595055965, 3.714297081958611],
            [9.745948426813106, 3.6886656762305683],
            [9.747954865325992, 3.679898194627101],
            [9.74212112719779, 3.6836442959471976],
            [9.739359609722484, 3.6826034144645052],
            [9.737304698374745, 3.6947935278306008],
            [9.736255960548576, 3.6956067474650216],
            [9.71971627008687, 3.692700872606361],
            [9.71414894932634, 3.696566216987639],
            [9.712840812143734, 3.6931397214998416],
            [9.707470795993075, 3.690207452294014],
            [9.708614837517365, 3.684246384602896],
            [9.716323546017332, 3.6793128485662154],
            [9.717480065155032, 3.674741753727321],
            [9.729516419885558, 3.676054740082628],
            [9.72872167487993, 3.6680951964867674],
            [9.633838533361926, 3.6520455426493923],
            [9.560692040817129, 3.6395552012551686],
            [9.543524671181515, 3.6360078700609257],
            [9.503905295458408, 3.6292523998983888],
            [9.492053168990232, 3.702722225463541],
            [9.488174843242327, 3.725969262067438],
            [9.478402363832979, 3.7902898170833055],
            [9.472954126746352, 3.8269764337931615],
            [9.462691471799875, 3.8992611694298813],
            [9.449618609260321, 3.9859410090046206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.5394320952419, "lat": 41.92910887598711 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26115"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01623000"
      },
      "bbox": [
        9.449618609260321, 3.6292523998983888, 9.890892422312527,
        4.043723607477463
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.612460022128308, 7.605715792905565],
            [1.6129506907388447, 7.611254276243432],
            [1.6187691657438237, 7.607665932233797],
            [1.622216371215711, 7.617864914241485],
            [1.6211657707549771, 7.668448793495152],
            [1.6199749255588034, 7.709953426364648],
            [1.6198033600570416, 7.732432371166102],
            [1.6184098294166496, 7.7822677238935904],
            [1.6174542071559426, 7.810849530563258],
            [1.6162664192471052, 7.8541337381358165],
            [1.6156005192831295, 7.8858731823316806],
            [1.6137697717250563, 7.941624829499029],
            [1.6137064705746078, 7.9549895751407425],
            [1.6037497326787764, 7.955116252470206],
            [1.6035353634212246, 7.969347939125804],
            [1.6025600786841254, 7.998027360044574],
            [1.6020720270639282, 8.040988271955284],
            [1.6029495860451046, 8.06405267293008],
            [1.6022044706502128, 8.110053117291946],
            [1.6024337942703732, 8.126853620869849],
            [1.6661022729752386, 8.127426177884063],
            [1.671834010084906, 8.127712360887784],
            [1.728793878312015, 8.12834717179721],
            [1.8175471529327751, 8.128681876377662],
            [1.8319468929854075, 8.129431666630285],
            [1.8684297861164558, 8.12995388171171],
            [1.9047957140004512, 8.130709715594328],
            [1.9919772774118727, 8.132126531272055],
            [1.9921672175855798, 8.079915079225927],
            [1.9925482985601766, 8.078985643083833],
            [1.9944606536292964, 7.961335803767999],
            [1.9956515773954253, 7.921783789733705],
            [1.9903315854683905, 7.921697325747063],
            [1.982743696799065, 7.917766141824927],
            [1.97264482182977, 7.915889785428839],
            [1.97426479346456, 7.8485012920277395],
            [1.97399254329138, 7.837014268522701],
            [1.9770024314206485, 7.758188012634536],
            [1.9773714839195877, 7.751237923869796],
            [1.978107626179319, 7.708605211496006],
            [1.9807074844881603, 7.588928759615459],
            [1.9824328804008435, 7.584575508963884],
            [1.985353673406026, 7.583048488750956],
            [1.9890057556199612, 7.584617265468061],
            [1.9909964471872328, 7.57920563256473],
            [1.9808600696215908, 7.578903145378549],
            [1.9817345928164303, 7.550583039577961],
            [1.9832307483362779, 7.493313301699403],
            [1.9239443077858795, 7.492297098887418],
            [1.895688557611989, 7.4913620795351346],
            [1.8014476228089702, 7.489275259735902],
            [1.787381762483874, 7.488674161968682],
            [1.7533949528877697, 7.487798664412148],
            [1.7209259430507544, 7.488298473609291],
            [1.68724747629489, 7.487613054114587],
            [1.6417104181042135, 7.486981065317501],
            [1.5917216850535252, 7.486024520648489],
            [1.5941073634751213, 7.493810547991042],
            [1.5934783663418748, 7.502778173941771],
            [1.5970122969926008, 7.505833947219821],
            [1.597160191819309, 7.508869671023157],
            [1.5906767934343096, 7.51888594978782],
            [1.583019299185842, 7.526086134771358],
            [1.5817353597182564, 7.532123271819783],
            [1.5789231864238702, 7.534496310356917],
            [1.5761397703444484, 7.539957999574862],
            [1.5767805906216896, 7.556642112282707],
            [1.5804503351327708, 7.561111209191014],
            [1.5804066589621106, 7.5660570763608375],
            [1.5873590768775294, 7.5684457135736345],
            [1.592600727539576, 7.572045540389517],
            [1.5978027459481599, 7.580008623325532],
            [1.603414672591124, 7.583195010689996],
            [1.6044990951973284, 7.588007331282065],
            [1.603112162781901, 7.59071764649636],
            [1.606514643265629, 7.595197684587998],
            [1.6128355793872036, 7.597332521245938],
            [1.6150303570378688, 7.60364063757856],
            [1.612460022128308, 7.605715792905565]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.07089388711496,
          "lat": 46.482477978353614
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27035"],
        "coty_name": ["Crow Wing"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crow Wing County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00659463"
      },
      "bbox": [
        1.5761397703444484, 7.486024520648489, 1.9956515773954253,
        8.132126531272055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9909964471872328, 7.57920563256473],
            [2.067842199737159, 7.58256306247984],
            [2.172670037649311, 7.58753970400957],
            [2.244249246406674, 7.588689472426011],
            [2.2454154234234287, 7.558092751889336],
            [2.24674589851935, 7.504996354273526],
            [2.2459217702313263, 7.497156882144734],
            [2.2459212396694372, 7.490069763330475],
            [2.247813312478726, 7.412205017164908],
            [2.2491212937855947, 7.35528819532432],
            [2.250116163476073, 7.3265095077512195],
            [2.2429339698055633, 7.326529450177165],
            [2.1905715415068356, 7.325194963827358],
            [2.192364764184933, 7.252860772101269],
            [2.193290703579233, 7.2228544479254255],
            [2.1956498444398322, 7.166189793861735],
            [2.199128145868032, 7.10508401476101],
            [2.200096920046328, 7.080156385294848],
            [2.201418161243125, 7.0645819580078815],
            [2.2020317083758085, 7.048928393609142],
            [2.2023237212007203, 7.022432039356165],
            [2.2030479892683577, 6.991760050123988],
            [2.2053475182651687, 6.935120068412311],
            [2.206772216010143, 6.906101271476263],
            [2.156811072047225, 6.905071768677897],
            [2.1125653928576313, 6.904670654071499],
            [2.0326116783701536, 6.902638244276664],
            [2.031568698448954, 6.931663958216955],
            [2.029511120724306, 6.998748429247375],
            [2.0276642010974912, 7.044858051693624],
            [2.0265400039299775, 7.076769907163152],
            [2.0261571333004333, 7.106587262600023],
            [2.0232902293249935, 7.162903068453949],
            [2.0226820318722973, 7.177253203622179],
            [2.0202947088928083, 7.213746571103299],
            [2.018150280963416, 7.249584622313643],
            [2.0174114948059354, 7.278672596965326],
            [2.01746850092996, 7.292500518342647],
            [2.0160830743401856, 7.321699692669344],
            [1.9872496241130904, 7.321584336156876],
            [1.9851023581173448, 7.407868764601047],
            [1.9834258763757697, 7.489039620044856],
            [1.9832307483362779, 7.493313301699403],
            [1.9817345928164303, 7.550583039577961],
            [1.9808600696215908, 7.578903145378549],
            [1.9909964471872328, 7.57920563256473]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.63007444366566, "lat": 45.93804080490491 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27095"],
        "coty_name": ["Mille Lacs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mille Lacs County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00659493"
      },
      "bbox": [
        1.9808600696215908, 6.902638244276664, 2.250116163476073,
        7.588689472426011
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5827921926793533, 5.21199014900274],
            [2.5853460015328893, 5.212093180415845],
            [2.6652404923899256, 5.214711549278609],
            [2.7048629194779514, 5.216192128770227],
            [2.7624866703982676, 5.218023126870711],
            [2.8413388240748425, 5.220600995964821],
            [2.841931152058453, 5.205892075530703],
            [2.927923288458814, 5.209146472665197],
            [3.0144717640965424, 5.212355536905459],
            [3.017233594496378, 5.138713163210989],
            [3.0200282769095623, 5.052759997863559],
            [3.0233936396192247, 4.965672340227147],
            [3.0260136886831184, 4.900527649368224],
            [3.0270035015300496, 4.878729864562153],
            [2.95184296822753, 4.875784267063681],
            [2.8255470565177587, 4.871172211362291],
            [2.680184474162066, 4.86605739609835],
            [2.611834002136658, 4.863806269746852],
            [2.593902083266283, 4.863275625136803],
            [2.5921388563374212, 4.914933346304736],
            [2.5895709812749477, 5.001151966572365],
            [2.5889835912969077, 5.015577681579711],
            [2.587140833663223, 5.078960369848116],
            [2.5855703458466897, 5.124551746122689],
            [2.5827921926793533, 5.21199014900274]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.75246814446986, "lat": 43.67149040958275 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27099"],
        "coty_name": ["Mower"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mower County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00659495"
      },
      "bbox": [
        2.5827921926793533, 4.863275625136803, 3.0270035015300496,
        5.220600995964821
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.312488167368542, -4.914185993894976],
            [5.435098012944995, -4.907246776267372],
            [5.481882703128543, -4.904048715968966],
            [5.5935849553313535, -4.896586154597298],
            [5.598507873294599, -4.956513568369129],
            [5.603331155850375, -5.030288934337502],
            [5.608299601284572, -5.099331871146334],
            [5.608757396230402, -5.114378275910112],
            [5.612094212150045, -5.157212943108536],
            [5.6694530300080475, -5.152957783242083],
            [5.670609634328877, -5.167654657132248],
            [5.7279244843828065, -5.1633735375802035],
            [5.730545551199903, -5.199531079891918],
            [5.7366517526726994, -5.28038742771815],
            [5.690069890039699, -5.283636290243429],
            [5.689531364293098, -5.292627013920494],
            [5.684428721077199, -5.300069414182702],
            [5.6846808979883505, -5.306346378924751],
            [5.681126474715308, -5.31159154865546],
            [5.67544979694732, -5.309938538810094],
            [5.672997625455294, -5.316736947077998],
            [5.670783011585964, -5.317826963231893],
            [5.669093433505569, -5.3259148569847605],
            [5.665977235524512, -5.330414921809586],
            [5.662079196770898, -5.333111912245916],
            [5.6598529699333815, -5.3410646622461595],
            [5.657595471926729, -5.343205618281319],
            [5.65955624503803, -5.351085140265058],
            [5.655047948083885, -5.357142100336482],
            [5.605422175945954, -5.34428067143928],
            [5.536335824907398, -5.326171251266643],
            [5.442752207716122, -5.301004841341203],
            [5.44011224859427, -5.3000892288938815],
            [5.339735469636933, -5.272671900927537],
            [5.295053648975295, -5.260522459091434],
            [5.289778920221965, -5.176841006576381],
            [5.304036890399609, -5.1758296690305725],
            [5.320377082980124, -5.175515554078817],
            [5.31790063704098, -5.132806829046933],
            [5.347854798538543, -5.131133425416721],
            [5.344801266333885, -5.0883345049765945],
            [5.343048192487072, -5.054063250128109],
            [5.340834139766739, -5.031224361541409],
            [5.339837181526794, -5.008569028404513],
            [5.3383240446714915, -4.986143269707015],
            [5.314986584295174, -4.987500965797434],
            [5.319345619538362, -4.983337101642229],
            [5.325968366211889, -4.986588465497079],
            [5.326275766707918, -4.981008577482232],
            [5.3332638829805274, -4.983924167318463],
            [5.335047284584498, -4.9777482452722746],
            [5.3353388928540255, -4.972644613803829],
            [5.331043143110705, -4.960752483285964],
            [5.3308890138188545, -4.956722723218555],
            [5.333738430888632, -4.950838309044056],
            [5.335213542012583, -4.942923509571974],
            [5.335148293563833, -4.937455411244358],
            [5.332810188299352, -4.93349018352749],
            [5.332058320903491, -4.927777902174768],
            [5.321658637244714, -4.928784613680481],
            [5.317192082850198, -4.917160483573738],
            [5.312488167368542, -4.914185993894976]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.92016401725644, "lat": 33.44852397458119 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28015"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00695732"
      },
      "bbox": [
        5.289778920221965, -5.357142100336482, 5.7366517526726994,
        -4.896586154597298
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.571999014654151, -7.026425440125011],
            [4.660795391768304, -7.021358240665051],
            [4.702208481666488, -7.019306381207404],
            [4.759634570768671, -7.016101235088459],
            [4.808077473910312, -7.0138101037606715],
            [4.817763192505851, -7.012715750554209],
            [4.868800714403572, -7.010127103700321],
            [4.913866495894861, -7.006869935795033],
            [4.9247058393856955, -7.006737506625843],
            [5.012837569727964, -7.001556466317551],
            [5.017717364857214, -7.088098240033309],
            [5.025877041279737, -7.225420313460205],
            [5.026763890518696, -7.23681234801886],
            [5.026793961529397, -7.248165143932634],
            [5.027627599001307, -7.262241715867785],
            [4.97581127422476, -7.264967080754363],
            [4.9549844207099545, -7.265914488650556],
            [4.9107819655344285, -7.268433131656675],
            [4.811187763301041, -7.274316515433846],
            [4.730559154099895, -7.278988091965164],
            [4.7270928279270485, -7.284012062171019],
            [4.7273101499903065, -7.290865786757314],
            [4.717422042590837, -7.291613224809934],
            [4.71375866978657, -7.290587244135062],
            [4.709737957599961, -7.282045689328625],
            [4.700872956551983, -7.281703968362641],
            [4.697451735620512, -7.2854720141999945],
            [4.696828489397145, -7.289641753731955],
            [4.692721603523616, -7.293910659539774],
            [4.6884600096982325, -7.294833695290251],
            [4.683100957953186, -7.293770700389871],
            [4.678267404729329, -7.29496707628474],
            [4.675960571761186, -7.299343186512995],
            [4.668455989756446, -7.300137730508856],
            [4.664347373430482, -7.297372063121613],
            [4.662006551286237, -7.292495320301789],
            [4.6587648241682125, -7.294475756586991],
            [4.658346062338592, -7.303014685456276],
            [4.652442180206753, -7.303819966564808],
            [4.651765486783378, -7.3061186197982755],
            [4.647450915507086, -7.3066972359253874],
            [4.643673979746487, -7.305427794423211],
            [4.636489115041845, -7.311473166446786],
            [4.629967512313584, -7.305656588404577],
            [4.622851356903841, -7.313191407562752],
            [4.615837854986028, -7.312451742566901],
            [4.615649548812471, -7.308570788639268],
            [4.609272557934101, -7.306912940410678],
            [4.608240857031876, -7.303558287848584],
            [4.602406541349156, -7.302793352241041],
            [4.594324211215088, -7.294619831883999],
            [4.596837596988162, -7.29256734789434],
            [4.5916598887285165, -7.287048076988581],
            [4.585067046744882, -7.292079340532085],
            [4.581832797935605, -7.288616343332306],
            [4.5818609872600735, -7.266711471033358],
            [4.578275043526514, -7.183685998170704],
            [4.574093090641732, -7.087989180565971],
            [4.5731418986895145, -7.063273825384177],
            [4.573238720024115, -7.056713472796119],
            [4.571999014654151, -7.026425440125011]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.8978871360244, "lat": 31.477150973095814 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28037"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00695743"
      },
      "bbox": [
        4.571999014654151, -7.313191407562752, 5.027627599001307,
        -7.001556466317551
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.849852744819018, -5.350066019446055],
            [4.8514199817946455, -5.349546508558019],
            [4.940737525377164, -5.34460851521341],
            [4.9472740764565195, -5.343975507673094],
            [4.983383497220708, -5.342051398749923],
            [4.979722931812878, -5.2833753610239365],
            [5.014391429145219, -5.28138103506702],
            [5.018610638344371, -5.280900150738291],
            [5.064477222670851, -5.27818579166132],
            [5.064652393987896, -5.279343481963891],
            [5.067657522646002, -5.340438231234277],
            [5.103183368461134, -5.370473676889563],
            [5.104630845010875, -5.3659694306299155],
            [5.104602315898564, -5.36056069210175],
            [5.118941412010374, -5.359328322589297],
            [5.128587504416509, -5.359863949358121],
            [5.135683512858968, -5.365415293593246],
            [5.140679057383389, -5.359420662143796],
            [5.139723484853283, -5.357477115367288],
            [5.134167753625529, -5.3575259433699935],
            [5.136691326511845, -5.352832839932139],
            [5.136937658009187, -5.345790042697488],
            [5.13962625091927, -5.341348970311522],
            [5.13646753038793, -5.337923888642275],
            [5.136955555787283, -5.333167876763347],
            [5.134185378196614, -5.330309101803194],
            [5.132819234621344, -5.321935168213117],
            [5.137989422690371, -5.3225085303704125],
            [5.1422682662505705, -5.3269237851760485],
            [5.144856528361647, -5.321710977327158],
            [5.142600747254168, -5.315677017348926],
            [5.145467001558224, -5.3099595331077225],
            [5.146147193064726, -5.305929727124617],
            [5.1488083522074195, -5.3046565339185205],
            [5.154578090753221, -5.29856763730462],
            [5.1563725408845, -5.293295554386115],
            [5.159051231989988, -5.292783102148438],
            [5.1639882146257525, -5.295109886876274],
            [5.166855553256567, -5.298935212165516],
            [5.174735415779747, -5.415076473368252],
            [5.177816327387247, -5.4639445526393535],
            [5.1776546580015665, -5.466445381613375],
            [5.171823039504679, -5.466585086232609],
            [5.164367210260496, -5.4705584203033],
            [5.158227838202558, -5.483381594999952],
            [5.158406379698906, -5.489859528011839],
            [5.162035587475126, -5.496418062653057],
            [5.166145440752131, -5.5013982975312805],
            [5.160691575768797, -5.508753462110136],
            [5.156370303197435, -5.509114532735297],
            [5.1527970974490644, -5.502557696856043],
            [5.150073062965168, -5.499872487636033],
            [5.148812533414732, -5.4921118371142095],
            [5.149537271969283, -5.482915955136705],
            [5.146543385327675, -5.478193984663135],
            [5.140364579256714, -5.478491335710857],
            [5.134953322875259, -5.482937198489385],
            [5.132813790650799, -5.4917113353306375],
            [5.137092957865339, -5.498244648440501],
            [5.143899881256626, -5.503962193121989],
            [5.15114835918709, -5.507964027738282],
            [5.152182042049014, -5.510797221759821],
            [5.1507189612568975, -5.516538646616906],
            [5.145598818547132, -5.519792288670646],
            [5.135453929830902, -5.517117697247304],
            [5.131516848468441, -5.513029196611006],
            [5.127554676383694, -5.503128353709948],
            [5.124281634905614, -5.5003079912207635],
            [5.118528785203169, -5.499913141704653],
            [5.113489946595829, -5.50452593515995],
            [5.108410168382608, -5.501922221705977],
            [5.104928112430382, -5.490155420919446],
            [5.101786951230437, -5.490337146057036],
            [5.098874381089861, -5.493264227813712],
            [5.097764356404148, -5.497555104273597],
            [5.099215063882745, -5.501444429589441],
            [5.102507689606357, -5.503482862320398],
            [5.103758326888641, -5.507226194320071],
            [5.096040781970204, -5.509857820045551],
            [5.097530038422439, -5.517300206238181],
            [5.0970782019619065, -5.525255144199482],
            [5.099156232226023, -5.535720303807139],
            [5.099735539417512, -5.545646508877383],
            [5.10379304428032, -5.551825234866815],
            [5.112372535846043, -5.556961418711784],
            [5.122079215777348, -5.557694909312405],
            [5.132250475410904, -5.554779636737432],
            [5.138766221360077, -5.556836523806714],
            [5.142330298668628, -5.561740915436378],
            [5.142860193928641, -5.567296533296483],
            [5.1408483166999925, -5.578441943976711],
            [5.141853182067192, -5.5827934144935725],
            [5.149711557600815, -5.59058950893396],
            [5.157401638637382, -5.592823357166775],
            [5.157436025136265, -5.593553737572194],
            [5.08654461298078, -5.598569417153396],
            [5.091104617994933, -5.684290451652397],
            [5.0340131085626, -5.687942172203736],
            [5.01151783163684, -5.6890679409509355],
            [4.9868474632290285, -5.690932822183841],
            [4.937166369557207, -5.693657792481225],
            [4.918966620170357, -5.694899724829249],
            [4.917542595444639, -5.666014475198996],
            [4.913953628708148, -5.608473288243365],
            [4.90794971191633, -5.520973584948704],
            [4.8715640882628595, -5.523223671174818],
            [4.876442854486549, -5.518917082792134],
            [4.884893727338326, -5.521722642740004],
            [4.887141960545139, -5.520326109127342],
            [4.890190093974496, -5.514644657543961],
            [4.8890622976759825, -5.50389604449171],
            [4.883379467223528, -5.503835545168293],
            [4.881147601250364, -5.501940997457062],
            [4.8807755143827904, -5.495913124480459],
            [4.878836497410979, -5.495221337996361],
            [4.872878864502569, -5.497959897795256],
            [4.871005008288759, -5.49432729595116],
            [4.873075219735575, -5.487421999495932],
            [4.872000374434476, -5.481318524966209],
            [4.8773719673122, -5.4769807917955715],
            [4.880024170860948, -5.470400754531735],
            [4.878194549296467, -5.460820708245702],
            [4.881773599199106, -5.451346570587982],
            [4.881815595527769, -5.439905435938324],
            [4.879255865952825, -5.434193050548068],
            [4.879738821444799, -5.429126966220781],
            [4.883924854394174, -5.425132975335025],
            [4.88508159275411, -5.421113064301279],
            [4.88350376929877, -5.416511978874355],
            [4.875449358426826, -5.409944163836518],
            [4.868121619563783, -5.408857375152752],
            [4.863108975483147, -5.406978965347496],
            [4.854120025823079, -5.400811117308559],
            [4.84868488947571, -5.392782401922271],
            [4.844809511807691, -5.391091787285445],
            [4.841052524724191, -5.3924467482236045],
            [4.83787190163184, -5.387926055718739],
            [4.840326766044087, -5.370580092930719],
            [4.840043730485902, -5.367220011202928],
            [4.837069509359436, -5.361683788678644],
            [4.837591300755684, -5.356238395291137],
            [4.840511856757939, -5.353117705576344],
            [4.843680472397621, -5.355578515460214],
            [4.847682235712099, -5.3535902717698685],
            [4.849852744819018, -5.350066019446055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.52663273497261,
          "lat": 33.128665958460495
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28053"],
        "coty_name": ["Humphreys"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Humphreys County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00695750"
      },
      "bbox": [
        4.837069509359436, -5.694899724829249, 5.177816327387247,
        -5.27818579166132
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.920278226934236, -6.919757404457725],
            [5.067954198723408, -6.911671510202974],
            [5.079508757761879, -6.910505378569314],
            [5.165139799475244, -6.9051422293122595],
            [5.165125289555793, -6.903714880893442],
            [5.193036939335324, -6.902324031346651],
            [5.194404152580054, -6.917400922670097],
            [5.223363195320952, -6.915789935001227],
            [5.221905589533477, -6.900883274789374],
            [5.306597386764355, -6.896201060677001],
            [5.312719138721999, -6.89148254602722],
            [5.324067488290795, -6.891107640649643],
            [5.3271253118619954, -6.884760764705072],
            [5.3349194324842575, -6.876862009396225],
            [5.340788626433983, -6.9670029948965],
            [5.3494366990866675, -7.105241486192707],
            [5.351937235919044, -7.119616493704206],
            [5.350665426699927, -7.124891611166753],
            [5.352309010055611, -7.147553880815174],
            [5.35448218829053, -7.1842021193327055],
            [5.358336948284238, -7.242057906780897],
            [5.344322727313891, -7.2428996960239305],
            [5.265401792599079, -7.247808415633083],
            [5.179315839791118, -7.253425755262415],
            [5.117887073024566, -7.256996781294935],
            [5.099905750908007, -7.257889422347681],
            [5.051083540348769, -7.260931072823174],
            [5.027627599001307, -7.262241715867785],
            [5.026793961529397, -7.248165143932634],
            [5.026763890518696, -7.23681234801886],
            [5.025877041279737, -7.225420313460205],
            [5.017717364857214, -7.088098240033309],
            [5.012837569727964, -7.001556466317551],
            [4.9247058393856955, -7.006737506625843],
            [4.920278226934236, -6.919757404457725]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.45399364934303,
          "lat": 31.532388023493333
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28085"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00695766"
      },
      "bbox": [
        4.920278226934236, -7.262241715867785, 5.358336948284238,
        -6.876862009396225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.027753130488202, -4.62076217692636],
            [5.027301097446542, -4.606278833703184],
            [5.026201419161595, -4.59328847098265],
            [5.022649207714024, -4.533284223943116],
            [5.1033435049429965, -4.528572795585666],
            [5.11052457919101, -4.528341825793215],
            [5.155189506091325, -4.52554734991063],
            [5.161907081809849, -4.524907732474605],
            [5.194945008536533, -4.522832116357973],
            [5.210004020382994, -4.522863887781087],
            [5.239350370655957, -4.52029591547317],
            [5.281360864111928, -4.517812502822374],
            [5.276140033320301, -4.4303898326303015],
            [5.324562644474197, -4.427569225402244],
            [5.42112456585011, -4.421847549727662],
            [5.41461346795014, -4.417426940860356],
            [5.443021463330971, -4.415673559557906],
            [5.444092472541474, -4.435736950014115],
            [5.449456623715134, -4.439174218257125],
            [5.453643407148867, -4.514235685454293],
            [5.454873751202912, -4.5323626208407495],
            [5.458489001183518, -4.595088231427781],
            [5.4605604099870515, -4.609368025666682],
            [5.464573683189312, -4.682371186585332],
            [5.469180705572203, -4.7566285169942235],
            [5.426398895532301, -4.759238424954444],
            [5.426474493976584, -4.773615900108669],
            [5.339162445593093, -4.77836110422865],
            [5.311969177290994, -4.780040929247586],
            [5.297080415107306, -4.782033006470018],
            [5.302281147313269, -4.869878369811468],
            [5.281829924417244, -4.871207773644766],
            [5.233305123858879, -4.873616533812746],
            [5.231346479991227, -4.870141791459087],
            [5.225585753819583, -4.86390807656591],
            [5.216586772411894, -4.859422236280642],
            [5.208185946087209, -4.863846070394257],
            [5.206512297862612, -4.866998654849049],
            [5.2061665905311685, -4.873820395330904],
            [5.204267923993716, -4.8831225146246435],
            [5.200547760708996, -4.891447234358889],
            [5.200187766651204, -4.894569530978962],
            [5.194704748589151, -4.900997123383702],
            [5.185503714562217, -4.9047078271991955],
            [5.179256013200836, -4.904260257986024],
            [5.174120631339218, -4.901755015303169],
            [5.168172926559525, -4.900593922547255],
            [5.165349651929929, -4.893766501087848],
            [5.15839946683255, -4.883971169933924],
            [5.158373518972206, -4.880307075405628],
            [5.156085059692096, -4.874619401380018],
            [5.1583352816515875, -4.865299545183689],
            [5.163474810379787, -4.854763991192903],
            [5.170514820942789, -4.848384260734443],
            [5.177077815018926, -4.847117169238845],
            [5.184557021237103, -4.842940851691567],
            [5.193807760294832, -4.839696838969396],
            [5.206370521912234, -4.833995394054364],
            [5.213269828823678, -4.833617891227572],
            [5.216890471971739, -4.834593565160138],
            [5.219651235041008, -4.830834640329135],
            [5.225036291038595, -4.836755086995012],
            [5.231609968899402, -4.835576185134228],
            [5.244394439440316, -4.835412832153958],
            [5.259348764203519, -4.828399640097962],
            [5.262204279431435, -4.8249248830898335],
            [5.2671926826144535, -4.815758424928009],
            [5.267841265895965, -4.8089738411196095],
            [5.269846808958672, -4.805836159796084],
            [5.267185841020484, -4.800520000473052],
            [5.263759071959191, -4.7985884000108525],
            [5.260432170703475, -4.794232861103042],
            [5.2617882678906645, -4.788279710447989],
            [5.259257751007467, -4.784705087387202],
            [5.206142966067254, -4.786668759436473],
            [5.2010512542766, -4.78732406622589],
            [5.172845541014584, -4.788922039092535],
            [5.166668579467256, -4.789588880821535],
            [5.118863088970783, -4.7917776118523605],
            [5.107572561368492, -4.791938253721739],
            [5.037479787967382, -4.7954997004454745],
            [5.036956387171995, -4.7764204442941764],
            [5.035566819568125, -4.756530866129876],
            [5.033150599261418, -4.708352550331119],
            [5.029214099095415, -4.635510125375784],
            [5.027753130488202, -4.62076217692636]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.17325000705335,
          "lat": 33.950481758793316
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28135"],
        "coty_name": ["Tallahatchie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tallahatchie County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00695788"
      },
      "bbox": [
        5.022649207714024, -4.9047078271991955, 5.469180705572203,
        -4.415673559557906
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6287675290213584, 7.294269011786387],
            [-1.6255807220243008, 7.369150280352827],
            [-1.6217080746186638, 7.477340778433618],
            [-1.620820663845233, 7.497612021220204],
            [-1.6172893685859888, 7.596213403308543],
            [-1.6165094746346491, 7.6285598359269535],
            [-1.6161173124354231, 7.633489503540138],
            [-1.6143833551362603, 7.633533152536893],
            [-1.5162267641172364, 7.630301811973337],
            [-1.4811942450866007, 7.629443413765656],
            [-1.458503340425153, 7.6286470544501315],
            [-1.380581241339871, 7.626298326108507],
            [-1.2696751148984742, 7.623569512884582],
            [-1.2108101319675644, 7.622028221652831],
            [-1.1770228110157566, 7.621296519678787],
            [-1.0886109885092896, 7.619021390598468],
            [-1.0121172377573502, 7.617171375859741],
            [-0.9454562263189413, 7.6156303102665515],
            [-0.9261762287100685, 7.615193306408325],
            [-0.9281658413597302, 7.53003472939234],
            [-0.9303213799207024, 7.444070182815937],
            [-0.9326017779013699, 7.3579816569866665],
            [-0.9344446906564982, 7.272284266435693],
            [-1.0580297254466973, 7.2750781417473185],
            [-1.122537728026313, 7.27670909169587],
            [-1.2173548501936537, 7.279219662222955],
            [-1.2817142258965823, 7.281622319678486],
            [-1.3640822662044874, 7.2847880303282615],
            [-1.432972564874115, 7.287165971235719],
            [-1.5589928028480151, 7.291695499892934],
            [-1.6287675290213584, 7.294269011786387]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.50472655691259, "lat": 46.11017594821108 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38021"],
        "coty_name": ["Dickey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickey County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01035622"
      },
      "bbox": [
        -1.6287675290213584, 7.272284266435693, -0.9261762287100685,
        7.633533152536893
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.463583339068379, 2.8184387345223203],
            [11.520591225958139, 2.8262631869423522],
            [11.51218903986636, 2.8993903803534793],
            [11.540708626574546, 2.902496186011478],
            [11.53988517955264, 2.9094422318381414],
            [11.597689916748838, 2.9174513443871595],
            [11.622811263263145, 2.9211375249500935],
            [11.691943959870946, 2.9312923439209375],
            [11.749184832879417, 2.9403204374354264],
            [11.757591280964832, 2.8863450598325553],
            [11.761781243456772, 2.8571822665665523],
            [11.804487775214685, 2.86310911912759],
            [11.810522859209247, 2.820032988056947],
            [11.816391224685553, 2.7760829703065073],
            [11.773593392700475, 2.770152599134122],
            [11.777797360253535, 2.7369667416743177],
            [11.783726096641615, 2.6927650373408722],
            [11.784957529300824, 2.6818230336156192],
            [11.773290785863642, 2.680341512697691],
            [11.778928960595943, 2.6366968061760123],
            [11.73557129734743, 2.6311312312064232],
            [11.660376991958596, 2.6221907884388678],
            [11.66012992059384, 2.6238536197278317],
            [11.591943789875677, 2.615672925484367],
            [11.576030610818199, 2.6135438423941992],
            [11.576295441192103, 2.6116675388724913],
            [11.533058749251236, 2.6068533465122363],
            [11.523596918681069, 2.679451855323165],
            [11.516447566349134, 2.7384356071670264],
            [11.47384784858274, 2.7334360191673523],
            [11.468145706397669, 2.7823407758781684],
            [11.463583339068379, 2.8184387345223203]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.0897337026698, "lat": 40.57956497264381 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39019"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01074022"
      },
      "bbox": [
        11.463583339068379, 2.6068533465122363, 11.816391224685553,
        2.9403204374354264
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.388789525413217, -3.967820927164412],
            [0.3889754070565768, -3.8802395686597593],
            [0.3913102360624152, -3.8800405619663985],
            [0.3914764535555669, -3.7852110192291],
            [0.39134371002126245, -3.7828983863710373],
            [0.39166986052302594, -3.683669169393217],
            [0.4042933312225483, -3.6801228770444916],
            [0.4075454588905978, -3.6769285912998626],
            [0.4115614603528089, -3.662287244354903],
            [0.41286780289933867, -3.64524081741713],
            [0.4143011497393895, -3.641711630994543],
            [0.41917917809208294, -3.6359548299039997],
            [0.4297899954826379, -3.6288646070715838],
            [0.43943739526732706, -3.6127741603135877],
            [0.4424581667568309, -3.612525402407367],
            [0.4524911393346538, -3.6165802774960856],
            [0.45533691912107194, -3.615694792637953],
            [0.45654001806870503, -3.610900241707844],
            [0.4526829354547364, -3.591183084780511],
            [0.4537761849102877, -3.587888320313141],
            [0.45960587390394697, -3.5841539886937586],
            [0.477457745033723, -3.5812082589736107],
            [0.49166392306750206, -3.5803980510034537],
            [0.5020197038642714, -3.581500992982475],
            [0.5070461997486672, -3.582907729706111],
            [0.5217377271220247, -3.5893429955374176],
            [0.5303902552265716, -3.590436327903088],
            [0.540051400066384, -3.588931433482749],
            [0.5511426989184929, -3.5807563046318664],
            [0.5542186732969095, -3.577128582923295],
            [0.5581007911616004, -3.5701765179413867],
            [0.5654226107322943, -3.552372918769195],
            [0.5685327634040207, -3.54661606263381],
            [0.5717629132211689, -3.5452917209493586],
            [0.5797859195072157, -3.5459848163443506],
            [0.5870750153842925, -3.544161303549924],
            [0.5942928372148137, -3.548277219852129],
            [0.6061172823671791, -3.54503461649567],
            [0.6150177305194866, -3.5389769563461075],
            [0.6223842628447018, -3.536142125214769],
            [0.6312131745507533, -3.5351166640924228],
            [0.6358328198196812, -3.5360126163622776],
            [0.6403761886160905, -3.5389220560787726],
            [0.6483393368811436, -3.5487698999767376],
            [0.6513488184332878, -3.5534944638118486],
            [0.6550007465024474, -3.555398351119692],
            [0.6614830624803818, -3.5552813353703816],
            [0.6666534300428901, -3.5487128352759263],
            [0.6678977936392356, -3.544675386589331],
            [0.6712285816812363, -3.540472224051851],
            [0.6743864866353391, -3.539534396843976],
            [0.6826733073036658, -3.540276487671936],
            [0.6888576235898234, -3.5428662759208844],
            [0.6937077298485964, -3.542955670519043],
            [0.6967424572732425, -3.535115712924582],
            [0.7009624406877082, -3.5298966498155573],
            [0.7090485796592841, -3.5291696093329747],
            [0.7174210574487293, -3.5271339301487217],
            [0.7229700712253714, -3.5286599379694548],
            [0.727642163792323, -3.523155914056472],
            [0.7225276482088931, -3.5197208273106906],
            [0.7206689252223029, -3.515640294429236],
            [0.7221111746282654, -3.51100399287721],
            [0.7292977565478348, -3.5046363951124553],
            [0.7411057359534892, -3.500466678565638],
            [0.7592858475960664, -3.490028278145138],
            [0.7648529905986439, -3.4848715748587566],
            [0.7748799318430426, -3.481911740279597],
            [0.7792514867992905, -3.4818939712160137],
            [0.782663264780055, -3.4844978785420078],
            [0.7848005652951285, -3.4922420857434],
            [0.7821466462338715, -3.4965826850237782],
            [0.7715577003919396, -3.501357991044817],
            [0.7692984035156497, -3.5033807107371606],
            [0.7694751839544832, -3.5071053969777783],
            [0.7740235545625848, -3.5104098510111688],
            [0.781096038097038, -3.5113818800257417],
            [0.7881818508421075, -3.510096849848952],
            [0.7923118418311248, -3.5068101001919687],
            [0.7987507296689291, -3.497519204315688],
            [0.8097165443107136, -3.4872005260467946],
            [0.8175801628983113, -3.4850443035048584],
            [0.822408964818098, -3.4820012744121245],
            [0.8334836391384113, -3.479438721966719],
            [0.8509167897639692, -3.4687804307641974],
            [0.856335709907748, -3.4679474698122124],
            [0.8576023421052678, -3.4624028354460004],
            [0.8540919901599211, -3.455688220098874],
            [0.8528419999200721, -3.450650669559356],
            [0.854840636941004, -3.4460084841218133],
            [0.858626538038134, -3.4418605581243114],
            [0.86213866992543, -3.433993992814345],
            [0.8679473827489496, -3.4299296835976376],
            [0.8746668923281021, -3.4298870806593897],
            [0.8843905590805513, -3.43225341794185],
            [0.8993088262398312, -3.43770899811705],
            [0.9077105230919285, -3.4346178922324575],
            [0.908466565328797, -3.5284900767715346],
            [0.9050625868324266, -3.5286163510126634],
            [0.9054465728033173, -3.571201192553399],
            [0.9075157933550821, -3.571056432311752],
            [0.990949636781943, -3.571026930826825],
            [0.9917444482790709, -3.673197948806504],
            [0.9919234560100453, -3.7026084463896978],
            [0.8634025040557979, -3.7034137454706153],
            [0.8639421731801581, -3.784212316959495],
            [0.8645319750247552, -3.878836063050912],
            [0.8591337160000836, -3.8788718349449423],
            [0.8595399973274721, -3.9667402793440516],
            [0.8597283816769224, -4.054115794810693],
            [0.860144837006162, -4.141168956150304],
            [0.8144470408937896, -4.141408467306831],
            [0.7324710825302301, -4.142018350869174],
            [0.7317113277970122, -4.142140632734407],
            [0.6216147602199367, -4.142516327451357],
            [0.5600995839251494, -4.142747548817325],
            [0.5598186457779865, -4.055309710639541],
            [0.5211170455090135, -4.055278525955486],
            [0.3915460440834693, -4.055433127092494],
            [0.388670430992129, -4.055251379883749],
            [0.388789525413217, -3.967820927164412]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.7483977497758, "lat": 34.923861978461446 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40121"],
        "coty_name": ["Pittsburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pittsburg County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01101848"
      },
      "bbox": [
        0.388670430992129, -4.142747548817325, 0.9919234560100453,
        -3.4298870806593897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.579845956240494, 7.920023424737728],
            [-19.555355079818618, 7.912599586141637],
            [-19.553450769888023, 7.912564258837842],
            [-19.529700841500226, 7.905143872641432],
            [-19.498263802540368, 7.8956803314101816],
            [-19.47266848119736, 7.886296464568193],
            [-19.394554596225795, 7.8624212265214455],
            [-19.394790991361848, 7.861667708833501],
            [-19.343836580596044, 7.846334668377323],
            [-19.370640585069804, 7.758229226537471],
            [-19.329741649027294, 7.746526203682383],
            [-19.346565740593736, 7.69243184114351],
            [-19.355084587070223, 7.665556645133983],
            [-19.31852261095071, 7.65490013430492],
            [-19.3188774480761, 7.645382495561352],
            [-19.32968301791663, 7.612933836212511],
            [-19.337580440410928, 7.584864595256567],
            [-19.339913378201924, 7.577936199167943],
            [-19.34335858071224, 7.572076699527306],
            [-19.359657197540635, 7.516905025301202],
            [-19.36836884320338, 7.489278903840284],
            [-19.327098163010124, 7.476661745864089],
            [-19.339075367257934, 7.434854464572824],
            [-19.34929385631554, 7.399967540290105],
            [-19.350478082385056, 7.392923866232646],
            [-19.374587106109793, 7.313166949279829],
            [-19.378011238821607, 7.3141693094445355],
            [-19.379053029415065, 7.310720689243438],
            [-19.416898881075117, 7.3216870018116],
            [-19.44222517112823, 7.23879299331163],
            [-19.483688964747074, 7.251147280933828],
            [-19.49268861505345, 7.221530867398458],
            [-19.504802182517388, 7.182635227656202],
            [-19.507697337059167, 7.1680537025859135],
            [-19.514795402459736, 7.143801781986917],
            [-19.533183546181323, 7.08650068056188],
            [-19.527147757479383, 7.084684400803236],
            [-19.537215433865594, 7.050928561819565],
            [-19.56392483022846, 7.0590838365012045],
            [-19.56603140536162, 7.052234736758684],
            [-19.578848799074205, 7.056178189930546],
            [-19.58105362894611, 7.049454349835314],
            [-19.621119117467014, 7.061132419240494],
            [-19.631416384609608, 7.027920428401762],
            [-19.639343216960395, 7.030255517863446],
            [-19.64243779288723, 7.020159404903352],
            [-19.65624451563393, 7.024261061120973],
            [-19.660439984582936, 7.010413011346859],
            [-19.67417424090254, 7.0145325643486185],
            [-19.678421238793195, 7.000743194810027],
            [-19.692140682351923, 7.004854150833765],
            [-19.696357632074196, 6.991045709703471],
            [-19.748199605550294, 7.006340512285864],
            [-19.76183277374685, 7.010591353357277],
            [-19.763956181679422, 7.003669198673337],
            [-19.784417549048403, 7.009992603158192],
            [-19.78655214535582, 7.003111321146174],
            [-19.792736672403954, 7.004976356616517],
            [-19.794022468556022, 7.000731063929963],
            [-19.79742229008888, 7.001773617626797],
            [-19.796130080249196, 7.005999211896087],
            [-19.800200747254443, 7.007227287910004],
            [-19.779928961901557, 7.072954433829408],
            [-19.794812185838133, 7.077452037946135],
            [-19.780222736594382, 7.125365785867717],
            [-19.783542565000502, 7.126286963886686],
            [-19.778958870303462, 7.139542539053444],
            [-19.775372222064018, 7.152843772498053],
            [-19.772085151253094, 7.151781253115139],
            [-19.76934842872409, 7.161937433264598],
            [-19.755713846541116, 7.15800419471312],
            [-19.74942667860316, 7.179171857721074],
            [-19.752843118950747, 7.180127739449631],
            [-19.749469939865936, 7.1911781571620965],
            [-19.75286018798558, 7.1921899185451865],
            [-19.75174319988152, 7.1957569224898075],
            [-19.755427552978944, 7.196862095610814],
            [-19.754395601005797, 7.20055807742665],
            [-19.75816450194899, 7.201791322224952],
            [-19.753587055066674, 7.214770279270057],
            [-19.76740961323717, 7.217863776502268],
            [-19.7695992115014, 7.2221468284312875],
            [-19.767490975266696, 7.228944594613863],
            [-19.770710995427955, 7.229905121983522],
            [-19.76968758016117, 7.23341756564241],
            [-19.77646164046338, 7.235429984900155],
            [-19.775414877643716, 7.238888337359997],
            [-19.77875122475268, 7.239954564074888],
            [-19.777921730693556, 7.2434412069012275],
            [-19.784405423759573, 7.245508512690485],
            [-19.78244004907801, 7.252356349986008],
            [-19.77905266351079, 7.25131185074128],
            [-19.777093168988852, 7.258126858481046],
            [-19.783873814127503, 7.260110347131535],
            [-19.779420146469516, 7.27506099089769],
            [-19.793192196880973, 7.2792099112319],
            [-19.790888703783473, 7.2860188905743914],
            [-19.79313809940958, 7.290199176300362],
            [-19.79992087309232, 7.29174761344001],
            [-19.797814504167384, 7.298937472120454],
            [-19.80120732846557, 7.29979950787728],
            [-19.800168873630756, 7.303442125910947],
            [-19.826676439291862, 7.311164809377976],
            [-19.909304386568802, 7.3370052517872795],
            [-19.90976068776205, 7.335617758946489],
            [-19.925918228191364, 7.3406091494020576],
            [-19.954248912182454, 7.349821629681247],
            [-19.931409763623115, 7.381548895227572],
            [-19.921561382027324, 7.396191722043506],
            [-19.90849536449159, 7.416673971991692],
            [-19.889370922166265, 7.452042434126888],
            [-19.88528976472745, 7.461391014393051],
            [-19.885389829600772, 7.465956687817985],
            [-19.882533784189565, 7.469170677486817],
            [-19.878895147366404, 7.476037558724934],
            [-19.878760598929695, 7.483606465260917],
            [-19.875717685988615, 7.489684936388633],
            [-19.87491991511239, 7.494227935350995],
            [-19.86452647683416, 7.502391833829538],
            [-19.831818594584767, 7.552925538661338],
            [-19.819612047166856, 7.5765219718880825],
            [-19.818530910420904, 7.585080106475388],
            [-19.816034197250463, 7.588782188479051],
            [-19.793245899144324, 7.630050021948222],
            [-19.79427883735953, 7.637998148856898],
            [-19.791677856064947, 7.650788619352473],
            [-19.79281096434721, 7.663346494435945],
            [-19.796214892712154, 7.664261545916395],
            [-19.79677272445002, 7.668341313306415],
            [-19.787879940966885, 7.675818464019541],
            [-19.78258232427717, 7.6820856231201065],
            [-19.77818687365166, 7.685448562442619],
            [-19.776194090692865, 7.690173973222916],
            [-19.770523859408815, 7.689885473464986],
            [-19.766388852245846, 7.693544860623948],
            [-19.751661487365357, 7.69292527335101],
            [-19.74207239773152, 7.699224677263105],
            [-19.728934751695892, 7.71089497770344],
            [-19.711666924517328, 7.7283797730954085],
            [-19.678112196299203, 7.768070932408894],
            [-19.637106356443674, 7.824204373872006],
            [-19.603117959339812, 7.876572037972084],
            [-19.579845956240494, 7.920023424737728]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -124.05941328221577,
          "lat": 43.17419606708879
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41011"],
        "coty_name": ["Coos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coos County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01135848"
      },
      "bbox": [
        -19.954248912182454, 6.991045709703471, -19.31852261095071,
        7.920023424737728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.731531610904227, 8.05572776664041],
            [-17.744125722837463, 8.062983326469125],
            [-17.74319997139698, 8.064772428779351],
            [-17.743541638815977, 8.072553420365198],
            [-17.744692239378203, 8.076401732071528],
            [-17.74235736617363, 8.083809076585037],
            [-17.74476886943916, 8.08690309032704],
            [-17.74970232180574, 8.090185952518635],
            [-17.751799574158305, 8.09346264287504],
            [-17.745458950786187, 8.105680885675408],
            [-17.746288463314787, 8.111276242107257],
            [-17.743976679328156, 8.115035602441141],
            [-17.743087564359147, 8.123552762077749],
            [-17.737157342356298, 8.137959158505014],
            [-17.739215689502753, 8.144293761581991],
            [-17.738374609405874, 8.148481018550878],
            [-17.73070679871613, 8.158571348646754],
            [-17.733217645478128, 8.162863968235753],
            [-17.734304901016046, 8.168417788066135],
            [-17.729911018033558, 8.173410909745416],
            [-17.730330073618042, 8.181012034473772],
            [-17.729587477467113, 8.186429285245923],
            [-17.726375317915117, 8.18913384183053],
            [-17.725408588841308, 8.19251061363355],
            [-17.67948969758221, 8.180060503300421],
            [-17.679335767393773, 8.180608464267907],
            [-17.608875794087226, 8.161236502771121],
            [-17.583245236322874, 8.153217757202528],
            [-17.556332860961565, 8.146028354181324],
            [-17.512367203884622, 8.134654795497903],
            [-17.471189475049986, 8.123734491610026],
            [-17.42468137139319, 8.110787710932684],
            [-17.34612547403108, 8.089271934285442],
            [-17.303588683061157, 8.077954980133109],
            [-17.30420986789196, 8.075663165337783],
            [-17.220483858941428, 8.053135741450005],
            [-17.23745627664095, 7.992439328015476],
            [-17.266241242987785, 7.888323232556106],
            [-17.262388357321186, 7.887258061805229],
            [-17.2833222922891, 7.8101279417804506],
            [-17.2046285472114, 7.784873464268423],
            [-17.226938858719883, 7.701869393554931],
            [-17.249320065397665, 7.618443529480765],
            [-17.202281630235703, 7.604381960325045],
            [-17.0851319421418, 7.571214577395788],
            [-17.107074369089293, 7.488461089931685],
            [-16.978814697394757, 7.4553946714464665],
            [-16.850565188681013, 7.4222865361144015],
            [-16.87226809301628, 7.338445310766945],
            [-16.81677395989974, 7.324153890064181],
            [-16.78902588200316, 7.316711281241489],
            [-16.81054086136607, 7.233196002736574],
            [-16.797069324517707, 7.228283426610458],
            [-16.678304958558197, 7.1982339922651315],
            [-16.55954896859078, 7.168149653549964],
            [-16.58070211910334, 7.083984727283796],
            [-16.695325256684146, 7.113680737783358],
            [-16.809956427074678, 7.1433444727131],
            [-16.916306973330183, 7.170756877953723],
            [-16.915200547028803, 7.175060969224175],
            [-17.001273980559944, 7.19761759605927],
            [-17.087351980958157, 7.2201559597744716],
            [-17.17343452562263, 7.2426760536379335],
            [-17.25952159189944, 7.265177871143234],
            [-17.331373727224385, 7.284149732217743],
            [-17.33084920805071, 7.286127958469092],
            [-17.45547150487718, 7.31923898764695],
            [-17.58010342719072, 7.352311572335831],
            [-17.625775973178015, 7.364254989154442],
            [-17.671508488514487, 7.377090812419381],
            [-17.76577029430331, 7.40265529995114],
            [-17.90558155009422, 7.440779973538142],
            [-18.045405259581727, 7.4788559749485755],
            [-18.0408853356631, 7.488830356525254],
            [-18.02502165508101, 7.483838866268624],
            [-18.018859499444403, 7.482735596854336],
            [-18.01872327236459, 7.486267892206135],
            [-18.020640465181717, 7.492788747376585],
            [-18.023680874816158, 7.497830617739657],
            [-18.023753039999292, 7.511131675634313],
            [-18.021702938407245, 7.520056174446944],
            [-18.019210608836588, 7.52485543537112],
            [-18.015046688434886, 7.529922065334394],
            [-18.008991116470796, 7.543731792468375],
            [-18.004789363157435, 7.546067269436628],
            [-18.00249703195039, 7.551355890339468],
            [-17.99693476729068, 7.557165847909784],
            [-18.00077994849647, 7.560273995062191],
            [-18.000743201015016, 7.56484805585284],
            [-17.99792110997218, 7.569398678459384],
            [-17.999143022419442, 7.578655110506654],
            [-17.99429687518826, 7.583706769058119],
            [-17.993914030628922, 7.58898226737345],
            [-17.996135733652935, 7.592950088401453],
            [-17.99619174212584, 7.596978725143932],
            [-17.99124811044106, 7.599740952679063],
            [-17.98472430908992, 7.608127987640949],
            [-17.976838382851778, 7.6130833392998305],
            [-17.98113522405861, 7.617992541716916],
            [-17.97901996076832, 7.625067086896501],
            [-17.973548396287494, 7.627647659308902],
            [-17.974663080851798, 7.636504594791233],
            [-17.971558295952757, 7.650105044441105],
            [-17.968000310118594, 7.652186296469412],
            [-17.96598415283477, 7.6576017310972215],
            [-17.967941902647958, 7.661271490498751],
            [-17.97339799368386, 7.662559672434052],
            [-17.968007578248283, 7.676156078166186],
            [-17.970611687846258, 7.678304524912808],
            [-17.9668467990431, 7.6848268566299796],
            [-17.964326933282205, 7.69155949562525],
            [-17.964675773439318, 7.6947573096966],
            [-17.960882935893558, 7.70561306582416],
            [-17.95840229554623, 7.708629164734237],
            [-17.95196779578589, 7.711602156070177],
            [-17.94174160868337, 7.71487755044603],
            [-17.939527000638364, 7.7208561892322445],
            [-17.933574013271635, 7.723331495895363],
            [-17.930445114633986, 7.726806368954006],
            [-17.921439414198165, 7.73252203773489],
            [-17.919499611425, 7.736920635477738],
            [-17.924421447903086, 7.740221250022065],
            [-17.91769919331171, 7.743188105524291],
            [-17.91448618989773, 7.746054984739381],
            [-17.91144904141241, 7.744577867357435],
            [-17.908519839031342, 7.746456628060706],
            [-17.903385413196332, 7.746837221260618],
            [-17.897903714135467, 7.74577932876534],
            [-17.89419515372055, 7.747372442899941],
            [-17.893041213122707, 7.743302858324605],
            [-17.88921215143515, 7.738513358631776],
            [-17.879382828964456, 7.734949447818935],
            [-17.873101556493324, 7.737361502025684],
            [-17.86820604147573, 7.745405168046324],
            [-17.864784656318186, 7.756185774265674],
            [-17.861218931368008, 7.758836713892474],
            [-17.858841074772528, 7.765625210891529],
            [-17.85373360978109, 7.776081176881409],
            [-17.853016514168708, 7.783093815112951],
            [-17.850183534170128, 7.786153541973023],
            [-17.841601178257516, 7.785771428725496],
            [-17.8345205771156, 7.788004022530853],
            [-17.838646940340762, 7.791428388962801],
            [-17.836836299755415, 7.796738342142852],
            [-17.831830968208077, 7.799045409869953],
            [-17.826862956387767, 7.806393289161589],
            [-17.820773160043096, 7.811417460126968],
            [-17.813285808171013, 7.824595143560466],
            [-17.813611502156686, 7.837476101720871],
            [-17.812920145129887, 7.841832649450298],
            [-17.81573565958115, 7.850728213238023],
            [-17.803281828453322, 7.858526168565333],
            [-17.801552430352423, 7.86113866825304],
            [-17.795517333479303, 7.861804809571623],
            [-17.78876955518555, 7.859455740223419],
            [-17.7871618391995, 7.863293781654734],
            [-17.782406733926738, 7.866958489967884],
            [-17.77378508258015, 7.8783640756898485],
            [-17.76588629442421, 7.881451755958008],
            [-17.761576104837026, 7.8889473049327306],
            [-17.75794094148956, 7.890522230873724],
            [-17.754857249238857, 7.898513133327061],
            [-17.752949340849014, 7.8997796882351725],
            [-17.751637004762493, 7.906424865898276],
            [-17.748392890451317, 7.91286908210864],
            [-17.748320213968974, 7.921793339939498],
            [-17.745001004487378, 7.937295147694597],
            [-17.75045688710132, 7.94769997603572],
            [-17.746038116623627, 7.958140578786578],
            [-17.74233562733193, 7.957294133017006],
            [-17.738419101147034, 7.95992538424403],
            [-17.73679331664234, 7.963657648860669],
            [-17.739559974334068, 7.968557006980459],
            [-17.740198102885294, 7.972914608497637],
            [-17.733157592031926, 7.9812605134647985],
            [-17.732380127048767, 7.985720914431769],
            [-17.73626895755635, 7.991589952791969],
            [-17.733755853839444, 7.998269708336192],
            [-17.735610116265796, 8.004815749005848],
            [-17.732394163254085, 8.01211706571728],
            [-17.7273174029376, 8.013942137519729],
            [-17.727384024106335, 8.019867436349411],
            [-17.72931867341155, 8.02147974783388],
            [-17.72970198869271, 8.031202848563062],
            [-17.72824823321326, 8.03676266027976],
            [-17.72880827903979, 8.041763602928192],
            [-17.72721307038567, 8.045306795495183],
            [-17.73116617086435, 8.051846581583753],
            [-17.731531610904227, 8.05572776664041]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.22815403805319,
          "lat": 43.91505347103019
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41017"],
        "coty_name": ["Deschutes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Deschutes County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01155130"
      },
      "bbox": [
        -18.045405259581727, 7.083984727283796, -16.55954896859078,
        8.19251061363355
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.582996046528105, 3.5307333332449646],
            [12.589887474103273, 3.525238661366229],
            [12.592047297815007, 3.518277751259042],
            [12.58886620697494, 3.510382209784534],
            [12.589213874100833, 3.506468547133661],
            [12.595756169727423, 3.4998020945411272],
            [12.597183310025986, 3.4955114042163093],
            [12.597564941849617, 3.488379101131679],
            [12.59955537711919, 3.479236317650641],
            [12.599774011880358, 3.4691462512170226],
            [12.602870790049618, 3.4567963800327783],
            [12.607304154877191, 3.4482669246501474],
            [12.61576059744532, 3.4438551929805787],
            [12.621831246020323, 3.4394147281152114],
            [12.625349551612874, 3.4346995758562775],
            [12.625220407895123, 3.4311887388542446],
            [12.619713200481161, 3.4237864955187143],
            [12.61890195630422, 3.421000232552554],
            [12.620909658735412, 3.4146050359044997],
            [12.62381882287538, 3.413054840833095],
            [12.632477774870674, 3.412227858480377],
            [12.644352028440462, 3.4070113302616147],
            [12.657842035190296, 3.4047180636664063],
            [12.664132259143127, 3.406392702947201],
            [12.666727263595222, 3.4093071359771723],
            [12.67235710772917, 3.4091993602240174],
            [12.673313295071132, 3.404214430379442],
            [12.672525036570187, 3.3944213196894646],
            [12.669553191629916, 3.386894582964543],
            [12.6693385041657, 3.381438133731503],
            [12.672439281966152, 3.3784095151326485],
            [12.680566302611211, 3.379751875547063],
            [12.68836222101413, 3.3776197460724884],
            [12.6918398661904, 3.374449964468555],
            [12.691921389917379, 3.3688535500134744],
            [12.68924150398282, 3.3671739934154656],
            [12.681225331049088, 3.3689297479819813],
            [12.674692362867633, 3.367802410182453],
            [12.665900522196715, 3.3607187530530584],
            [12.663398448126168, 3.3557883756536406],
            [12.66381440331618, 3.349919224921823],
            [12.668990421283732, 3.3461154607976957],
            [12.6824710960808, 3.3434956914514413],
            [12.688540359996068, 3.344245320566325],
            [12.691223394345087, 3.3466262684985333],
            [12.695384080296023, 3.3571204628035485],
            [12.700665715255074, 3.3630292294864597],
            [12.709088405165735, 3.364424083018565],
            [12.715295971179778, 3.361893693529387],
            [12.716493761369518, 3.360148894253578],
            [12.72293918878311, 3.3656751502382374],
            [12.725443320989012, 3.366317824201343],
            [12.72883612460572, 3.3625929337298412],
            [12.734438811510929, 3.3618856897200433],
            [12.739601908666993, 3.3592574216146422],
            [12.744604781219419, 3.3642884594590012],
            [12.741636139919258, 3.3678774199895702],
            [12.743746472042895, 3.3720930157843423],
            [12.749808764726133, 3.3693346875273704],
            [12.75320542425197, 3.363155656369901],
            [12.760307153906307, 3.3658880495644095],
            [12.760435630220558, 3.368963180841291],
            [12.758033430964643, 3.373951721349833],
            [12.761053844143438, 3.383870450533945],
            [12.766287081430555, 3.383459927266781],
            [12.770656237751009, 3.3850760948961627],
            [12.775375153102496, 3.384423784897642],
            [12.779526631335946, 3.3819317427453246],
            [12.784674021174624, 3.383695565035817],
            [12.786362724156547, 3.3809566050772033],
            [12.783205018505093, 3.3782520510979546],
            [12.784881589414049, 3.374489887917558],
            [12.790576466656617, 3.375048090225637],
            [12.794882088123337, 3.3806804264565553],
            [12.798495555461555, 3.3823025750429494],
            [12.805467425132456, 3.3814286889888447],
            [12.809259193207227, 3.385787182413895],
            [12.81028759723882, 3.396259254109802],
            [12.809856552739433, 3.4012364575496288],
            [12.814934079503065, 3.4067220109483793],
            [12.817150214430294, 3.4038691058863884],
            [12.814291637265395, 3.398672652634626],
            [12.815860518123506, 3.3964252716958594],
            [12.820888769155767, 3.397652820443795],
            [12.823100174763326, 3.395069981724433],
            [12.82263007387917, 3.3902456906932565],
            [12.82700479116559, 3.388013163494885],
            [12.829109203106695, 3.390402548537523],
            [12.83031407682778, 3.3954065103201843],
            [12.833754581843841, 3.3946360224726835],
            [12.841347278515025, 3.3977092252022447],
            [12.843348797488273, 3.393633287685096],
            [12.837952825138407, 3.391658578499701],
            [12.839223201172631, 3.3873871611624757],
            [12.844633916892608, 3.3886234577106404],
            [12.846953351147194, 3.3870864121933826],
            [12.84305057632222, 3.3824534630128715],
            [12.843678633800105, 3.3736753777723756],
            [12.84688424105375, 3.3713264610338896],
            [12.851022309356242, 3.3736122624707474],
            [12.852361237439904, 3.379933691890469],
            [12.84951646996532, 3.386333497129446],
            [12.848588029439275, 3.393942261465215],
            [12.8504390388525, 3.4051395862264875],
            [12.853563323903103, 3.4087197797345343],
            [12.857713059953955, 3.405397665622142],
            [12.865789436165668, 3.4047116910009305],
            [12.868868610629704, 3.409614589092483],
            [12.874058963497667, 3.407565913650712],
            [12.884761446092956, 3.4122256954566117],
            [12.894921105592982, 3.4260199301687115],
            [12.897501021578556, 3.4246677534269776],
            [12.9084861372181, 3.4240976490450388],
            [12.910991187373913, 3.4256318016834677],
            [12.91526237730962, 3.4338023301484952],
            [12.919527618211552, 3.4372277253087953],
            [12.922720658789444, 3.4467418345548295],
            [12.936255329118833, 3.4563945908499427],
            [12.938368300026557, 3.4621927027794888],
            [12.942357670160956, 3.467483455198362],
            [12.950237252123157, 3.4716812347566837],
            [12.952731013754558, 3.4740984661394054],
            [12.956677404825074, 3.473345768887754],
            [12.968553215286969, 3.3977018787315845],
            [12.970574589058323, 3.385643861562714],
            [12.971936672545436, 3.364577131763626],
            [12.977313845011578, 3.3361831762000116],
            [12.990292900131827, 3.2647178315800165],
            [12.999984249772691, 3.210670329530369],
            [13.001345913682844, 3.2020580466763824],
            [12.960147155105979, 3.114296476529696],
            [12.922067080630619, 3.033040806187421],
            [12.891624163479152, 2.9701079211569126],
            [12.870608416742229, 2.9274318883959465],
            [12.866312616131953, 2.9307259375765167],
            [12.859448942610605, 2.9294932124031554],
            [12.851744911852649, 2.9234955581026543],
            [12.849780984048467, 2.929534719080601],
            [12.844948826209226, 2.929126169605165],
            [12.844777519987016, 2.9233682416997326],
            [12.842732617240207, 2.9183712089326272],
            [12.838552079686655, 2.916418393519159],
            [12.83578508779431, 2.91762440237676],
            [12.834082312488736, 2.9230733729656686],
            [12.828632585450134, 2.9259903450218694],
            [12.822610607711747, 2.931835920030109],
            [12.816112733031241, 2.929289664431953],
            [12.812027492463425, 2.929658313580827],
            [12.803248090155407, 2.9362738107710875],
            [12.785766514929438, 2.94409008779295],
            [12.782775494625874, 2.9461534292767295],
            [12.771822310993207, 2.965284406795409],
            [12.774565261655521, 2.9766595201661064],
            [12.782837586858017, 2.985430968901406],
            [12.782216880599032, 2.988204282569564],
            [12.776444849974249, 2.9877204605260332],
            [12.771849220194156, 2.9896019450094142],
            [12.768148097068838, 2.987811209373218],
            [12.764733002560112, 2.9821275910145575],
            [12.760031572475787, 2.9828625176860095],
            [12.757535402755769, 2.9897376907407116],
            [12.752122401138735, 2.9953910282101064],
            [12.751299131139398, 3.0040983723416965],
            [12.75425922466047, 3.0122591580771982],
            [12.753029177041466, 3.015737034690161],
            [12.747683386230596, 3.0124828530109835],
            [12.745108525874029, 3.005883364429962],
            [12.741512948593437, 3.0013476158403067],
            [12.736364988971953, 3.00181589576322],
            [12.734431713691151, 3.006773847940437],
            [12.733757851882183, 3.0148361178594523],
            [12.730031400094711, 3.0188993172651393],
            [12.72293638195239, 3.019792430872066],
            [12.717678797078635, 3.0219214481211765],
            [12.711161472027156, 3.0267273325975617],
            [12.707698049551922, 3.0374943796033778],
            [12.702762666166771, 3.0399581169605483],
            [12.695632257304274, 3.041845038396592],
            [12.686174530157459, 3.0474999667806726],
            [12.682771317567433, 3.047897612693498],
            [12.675478556450065, 3.0383918676552923],
            [12.666385554902982, 3.034568913189816],
            [12.660749510343363, 3.0695544616625168],
            [12.653779551013997, 3.1056591596759264],
            [12.645893757559293, 3.153160867287145],
            [12.642241713857505, 3.1772373752929175],
            [12.630398877954212, 3.248229755171002],
            [12.619129644622577, 3.3200275816588243],
            [12.61060077050947, 3.3684726409029206],
            [12.59370460520622, 3.4649563038897786],
            [12.589609019318413, 3.4950687520156163],
            [12.582996046528105, 3.5307333332449646]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.46458337678814, "lat": 40.81210201317395 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42005"],
        "coty_name": ["Armstrong"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Armstrong County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01213658"
      },
      "bbox": [
        12.582996046528105, 2.916418393519159, 13.001345913682844,
        3.5307333332449646
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.343185005574583, 3.8009082717733165],
            [15.415253165530254, 3.8564623834745104],
            [15.427778071306486, 3.8664236152855214],
            [15.441544804695077, 3.8765905241532135],
            [15.439931113651404, 3.8822414493191166],
            [15.45917131837208, 3.897072017858165],
            [15.472190858153565, 3.900744228102361],
            [15.517424514756312, 3.935920281686152],
            [15.510973712820704, 3.943477121175398],
            [15.508082676798656, 3.9543911405185264],
            [15.504735189569425, 3.957132537211223],
            [15.493726127331742, 3.954991146516588],
            [15.489199229585692, 3.963619394900982],
            [15.485388412388877, 3.9658950747357933],
            [15.480621717208901, 3.971171388872128],
            [15.477347765343165, 3.981847921434484],
            [15.476801766296784, 3.9895560098201597],
            [15.473679825187235, 3.9971624159545747],
            [15.476685011496679, 4.00561431535088],
            [15.473760834497801, 4.012459381246673],
            [15.47627487612438, 4.015217941821829],
            [15.479210042101018, 4.013771421709814],
            [15.483049145731155, 4.01939787640889],
            [15.481024198243869, 4.024303484494209],
            [15.48435371657437, 4.027596477633567],
            [15.492195379830786, 4.027357834719145],
            [15.49681775935781, 4.029385124324322],
            [15.498232476588257, 4.034390289485457],
            [15.502036186025595, 4.0368575567629215],
            [15.505224023637062, 4.046494999086263],
            [15.51148600817406, 4.045274267078904],
            [15.509569976415628, 4.051402570495329],
            [15.514439661197779, 4.053107186381469],
            [15.515056227601224, 4.058081191714915],
            [15.520563676555327, 4.063272855013707],
            [15.525963236824664, 4.063160556017474],
            [15.529888238847805, 4.067157413492394],
            [15.537797203691692, 4.069855678559955],
            [15.540285432609492, 4.066582095444563],
            [15.543190303546343, 4.066131159452995],
            [15.548245469470269, 4.060749757357102],
            [15.547876451742036, 4.056162074451026],
            [15.550980081742253, 4.054791128422265],
            [15.553499412345149, 4.061243886485924],
            [15.557070251146715, 4.057726852112168],
            [15.559515794987654, 4.052739953841968],
            [15.564042012981194, 4.0543654073151245],
            [15.568450309998546, 4.050316166014337],
            [15.572258898970093, 4.049462326350902],
            [15.573794934759949, 4.05442336459062],
            [15.577806440485462, 4.052797724473889],
            [15.581696065536102, 4.049307492878331],
            [15.5863304419077, 4.039484326308421],
            [15.592781111796143, 4.0400063935005806],
            [15.593020253766715, 4.0320728108768344],
            [15.597099711390218, 4.031783218234757],
            [15.60142064373506, 4.0288072102372405],
            [15.612685164561167, 4.02297966566431],
            [15.615524907389233, 4.018583418718827],
            [15.617881166825317, 4.019515341972662],
            [15.620724382624223, 4.014492982711393],
            [15.624156762376995, 4.011753601949288],
            [15.627063769949784, 4.003143967168146],
            [15.633527212162077, 4.003180671700055],
            [15.679512758058653, 3.964936912743798],
            [15.694660582342452, 3.952876847935045],
            [15.662770327934432, 3.922663405843669],
            [15.644888573734164, 3.9050917648125036],
            [15.663042053263695, 3.885743500776871],
            [15.692976037943186, 3.8528301305166788],
            [15.733007806459819, 3.8075779324632064],
            [15.747861177790671, 3.786904201913408],
            [15.740219701605845, 3.7829437969533193],
            [15.724283868809614, 3.7759319195380376],
            [15.716261618423408, 3.7738825773949465],
            [15.709820690319862, 3.770325196927511],
            [15.700192680687412, 3.768316691790225],
            [15.693487028081464, 3.764522999530707],
            [15.689684716202885, 3.760228808652446],
            [15.684159526029731, 3.7589390824737277],
            [15.67543216380711, 3.7552960730041702],
            [15.663570449758547, 3.746418542122459],
            [15.659452154753582, 3.740105835434649],
            [15.654915378921604, 3.7384435505029967],
            [15.607816425052123, 3.7153655138309656],
            [15.59570072299544, 3.7077660669742447],
            [15.59174751387654, 3.698841554550875],
            [15.574308017682847, 3.6864965802889946],
            [15.56852922322354, 3.675197075472276],
            [15.565537628449327, 3.6738372634880982],
            [15.565271894620103, 3.67053293525118],
            [15.556811231993024, 3.663665589989626],
            [15.531474961988927, 3.6768861373372443],
            [15.508840307099282, 3.6892499249892112],
            [15.445507805162284, 3.7229663910430357],
            [15.425065604399189, 3.738438168067408],
            [15.408374640968617, 3.7515099346222223],
            [15.34571743579844, 3.798744162035],
            [15.343185005574583, 3.8009082717733165]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.70888603923791,
          "lat": 40.918229899137415
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42025"],
        "coty_name": ["Carbon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carbon County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01213664"
      },
      "bbox": [
        15.343185005574583, 3.663665589989626, 15.747861177790671,
        4.069855678559955
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.746440736563068, 3.7905528174526153],
            [13.764868710154905, 3.852218452904581],
            [13.79451726266327, 3.9538500349973766],
            [13.779110300154029, 4.033504002162107],
            [13.773834962225841, 4.059809192094355],
            [13.879696777450281, 4.081966455901688],
            [13.892436027365106, 4.0848284645054385],
            [13.936879594191742, 4.093919326275255],
            [13.953879855849292, 4.097205062145447],
            [13.996158347291113, 4.105933684027722],
            [14.039205203058993, 4.114576843198761],
            [14.058525287845859, 4.118724209270362],
            [14.066419094999073, 4.0818333083537555],
            [14.075576282222148, 4.083875914380075],
            [14.0797020628744, 4.078821541404522],
            [14.085919410281631, 4.0657195122030725],
            [14.090022280713688, 4.060723195402706],
            [14.095905541015302, 4.058537792146525],
            [14.109394648176135, 4.043910430807321],
            [14.118464986115299, 4.0308013855555185],
            [14.122413152226283, 4.018055196012672],
            [14.12607821046361, 4.014451139682529],
            [14.13411830298215, 4.01054306633589],
            [14.142229554078616, 4.009409417179601],
            [14.154449592530883, 4.009850071451947],
            [14.16663669205986, 4.003360276389651],
            [14.175554018317168, 3.9972959521407314],
            [14.177966618958925, 3.9865358480524975],
            [14.183159840667086, 3.9740261872160723],
            [14.18610057851034, 3.9714721339882586],
            [14.195873938606113, 3.9674634817695984],
            [14.20152043084574, 3.9588573724330858],
            [14.206700737088923, 3.9530111219580193],
            [14.209980286243146, 3.951232761086082],
            [14.21601819277177, 3.9508241444797854],
            [14.220034123793445, 3.9491669157647116],
            [14.225061103957918, 3.9408953379190232],
            [14.232108676742465, 3.9391638387483954],
            [14.236851990454431, 3.9361695959943592],
            [14.243008554388712, 3.929132610755262],
            [14.247935465723904, 3.9248607220952003],
            [14.254981059369607, 3.92085441639036],
            [14.273117079404813, 3.908956543714963],
            [14.27832506832951, 3.910911298481635],
            [14.282336953135903, 3.9086477628323437],
            [14.288836939810867, 3.9081687826131946],
            [14.29075688720955, 3.9026257129681468],
            [14.290496041701926, 3.8993151587189536],
            [14.301701673982755, 3.902110670128097],
            [14.311820399586937, 3.902536580788993],
            [14.324589508399539, 3.8939420527507735],
            [14.331373008262192, 3.8879991520446238],
            [14.338700087685172, 3.8834395724602238],
            [14.337246773789406, 3.8790161922246615],
            [14.338586221876247, 3.8745689387513984],
            [14.342752670515297, 3.871825694228783],
            [14.351212646542793, 3.8709958858221913],
            [14.355850479102518, 3.866692658390658],
            [14.35674091862543, 3.863886278823452],
            [14.365906319395176, 3.8553269870931155],
            [14.375641025469264, 3.8472479900924434],
            [14.456229051072476, 3.7772450361445267],
            [14.470987311298364, 3.7803393637689684],
            [14.475994371863095, 3.7569980083947385],
            [14.475820445448694, 3.756164705724518],
            [14.343473415267129, 3.6710921722531733],
            [14.305577632170033, 3.6544691987359936],
            [14.272274177514726, 3.6439506631229652],
            [14.224330284535268, 3.622698118282689],
            [14.175777816033484, 3.673549701881691],
            [14.155343127122993, 3.6956439124600045],
            [14.166768609154515, 3.7086667017084807],
            [14.161263485648906, 3.715091207154286],
            [14.156049307218327, 3.7177370953459112],
            [14.150584076143659, 3.7150598529867667],
            [14.144622098613297, 3.718520736570535],
            [14.138327869022623, 3.7235594421695657],
            [14.124504599071075, 3.7291232616386263],
            [14.117326937146855, 3.731080986513465],
            [14.11632550678941, 3.7330361641874505],
            [14.111377360075089, 3.7334678318440435],
            [14.108191777113266, 3.7354885516053975],
            [14.105075725981518, 3.7349416067952728],
            [14.095986013587511, 3.7361332272270813],
            [14.092196777559733, 3.735586720392046],
            [14.086942595555946, 3.737434379704951],
            [14.08466484071033, 3.742820974771528],
            [14.081839182747832, 3.7445703784395588],
            [14.076718155538272, 3.7397119348578025],
            [14.067347099270304, 3.7420585466908034],
            [14.063068242585212, 3.7380920085916287],
            [14.059065771161418, 3.738697846079576],
            [14.049689785084821, 3.743318063968727],
            [14.046505651055675, 3.7398802485645266],
            [14.045437501948912, 3.7339675784958333],
            [14.043240519651473, 3.732908143245282],
            [14.037617120389354, 3.734315336252132],
            [14.03285130368277, 3.737463766541899],
            [14.028567196363252, 3.7330835639506255],
            [14.02177599107215, 3.730079463303351],
            [13.991045817257342, 3.7654754257685172],
            [13.983425355805148, 3.759403860425268],
            [13.976376167617705, 3.7939198227918056],
            [13.897503095825348, 3.778470502223273],
            [13.882611333777957, 3.8531996663797843],
            [13.873549049891626, 3.8390632513202556],
            [13.87103470507955, 3.826978871901002],
            [13.869032881234384, 3.8237139556285857],
            [13.859861361164699, 3.821513416000262],
            [13.858475412288138, 3.817876478853285],
            [13.862449981091377, 3.810633449252027],
            [13.863019858094486, 3.8075162544550785],
            [13.859665001230935, 3.8045112983056666],
            [13.851674233359446, 3.807439072800065],
            [13.847311895637324, 3.810326768365635],
            [13.844497191182713, 3.809858823974333],
            [13.841449730831345, 3.8011697328262195],
            [13.837031534660612, 3.7947962911002677],
            [13.8395266822119, 3.7798127438941598],
            [13.843595330095617, 3.769551125474129],
            [13.843003721648392, 3.7640160090172765],
            [13.835338489635497, 3.759695337491365],
            [13.834710195796346, 3.752981491289699],
            [13.83249646369645, 3.750411820176511],
            [13.82569884419232, 3.750455129021479],
            [13.824722322760378, 3.745266647865291],
            [13.827161556341219, 3.738375481029007],
            [13.825941293164385, 3.731899801227282],
            [13.822172215756032, 3.72960164401638],
            [13.819700100502011, 3.730926760775316],
            [13.816585813113385, 3.73742487940416],
            [13.814253255901944, 3.738199059370943],
            [13.806546214041724, 3.733795300853823],
            [13.801188634967833, 3.7364546197472324],
            [13.798899842148536, 3.735693048827152],
            [13.778187801659316, 3.7531853621274673],
            [13.746440736563068, 3.7905528174526153]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.63852875204662,
          "lat": 41.233947373918454
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42035"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01214721"
      },
      "bbox": [
        13.746440736563068, 3.622698118282689, 14.475994371863095,
        4.118724209270362
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.169457398605486, 2.227596800236717],
            [12.176928269296374, 2.225859949065865],
            [12.184531268777429, 2.221473424737022],
            [12.184787752646612, 2.2254134286451546],
            [12.189667472176836, 2.2273983790599114],
            [12.194977575145153, 2.224188148294949],
            [12.204049891417991, 2.2229283700787343],
            [12.210138701869962, 2.228773809403048],
            [12.211349841160635, 2.23316579625078],
            [12.214502307971784, 2.236931436041989],
            [12.212014201345793, 2.2398939849382047],
            [12.215364335414634, 2.2425067176086286],
            [12.219410795670527, 2.242254213007861],
            [12.22402191846109, 2.2472063963963165],
            [12.22429343229507, 2.250797720779321],
            [12.230210150848347, 2.253243130372284],
            [12.234250771814294, 2.252205625874592],
            [12.237764135163959, 2.2488622641285314],
            [12.241668070651878, 2.2530008812158457],
            [12.246681946061562, 2.2554027761999547],
            [12.251365466421444, 2.2559739889686874],
            [12.259162089509797, 2.259806206805284],
            [12.258442150106703, 2.2640555774495645],
            [12.26113762773992, 2.2690380264680914],
            [12.268879977087325, 2.2766270932057164],
            [12.276186512741493, 2.280970146706231],
            [12.280094577671141, 2.280939612789617],
            [12.28721430062854, 2.282907067908307],
            [12.28865800397624, 2.2860629777040726],
            [12.305432927555202, 2.2935080825124947],
            [12.310747732495653, 2.2953283104148943],
            [12.313805346578311, 2.2934695266278977],
            [12.317488022766973, 2.2940711182357467],
            [12.319650116325423, 2.297044864714577],
            [12.317296654407349, 2.304053014225583],
            [12.316869775596054, 2.3086483924298196],
            [12.32298805455105, 2.3126366939578338],
            [12.328551387557903, 2.311506770045007],
            [12.333673619197215, 2.3130341486127617],
            [12.33687616153087, 2.3066238615672283],
            [12.345262421108824, 2.308908993264573],
            [12.347150120323786, 2.303549248138133],
            [12.34554807856799, 2.299012822521741],
            [12.352177561614358, 2.2982146465232796],
            [12.361820200648593, 2.3033970311178793],
            [12.362271758476002, 2.3061295206618726],
            [12.36797557433717, 2.306328331518355],
            [12.370686381049703, 2.3092668912436665],
            [12.379773679750276, 2.308622688177614],
            [12.384460419717637, 2.3066497768014904],
            [12.390772740931428, 2.305807162073758],
            [12.395315684067885, 2.3089279420557203],
            [12.402199979875602, 2.308122869544338],
            [12.406067850802852, 2.3105269775387254],
            [12.409296139486191, 2.3079234591277267],
            [12.41493957306948, 2.3102957200009464],
            [12.415239274010235, 2.3137824944665892],
            [12.41945659364614, 2.31590867105088],
            [12.431358395094092, 2.3131638569925808],
            [12.436377794201983, 2.3070577022952135],
            [12.439944433881058, 2.305480525214306],
            [12.4511609107843, 2.3055006685010198],
            [12.457026922330542, 2.302213052580555],
            [12.464929435736357, 2.306492512507857],
            [12.470711173978783, 2.3042746299217054],
            [12.474399856111809, 2.307748731469281],
            [12.484417168887298, 2.310515912936184],
            [12.488970157222573, 2.3095993806253636],
            [12.500637770159988, 2.324408237550205],
            [12.501450411393819, 2.327451001679974],
            [12.505282650630882, 2.331880917319054],
            [12.51027828469207, 2.3274461001292535],
            [12.513752956862012, 2.3304231531391033],
            [12.515850309521063, 2.32924111743909],
            [12.52011525341787, 2.319124717859288],
            [12.515841346970792, 2.313410337190722],
            [12.518769457838369, 2.308902924677961],
            [12.519492649531141, 2.3026579173105253],
            [12.526613357073629, 2.299336096696157],
            [12.53187781458916, 2.30390072359461],
            [12.529647132771252, 2.3085443972010546],
            [12.53204888315137, 2.3102472314962967],
            [12.542332910533418, 2.305466731801633],
            [12.54588930023503, 2.311269877189044],
            [12.549416512346747, 2.31404291756126],
            [12.556321019473092, 2.3138068269097474],
            [12.55097904241923, 2.309708667822338],
            [12.548583975322833, 2.302919932388446],
            [12.549870482097619, 2.294694026128151],
            [12.551984943753205, 2.287983203022667],
            [12.55568259280182, 2.2846504661909606],
            [12.56424144750834, 2.2805723684294956],
            [12.567481998930253, 2.2813847724709335],
            [12.57534431067358, 2.286938492459176],
            [12.581794720107522, 2.28964463424067],
            [12.590392439685981, 2.289471311939623],
            [12.594921890298705, 2.287853091361847],
            [12.60360263082417, 2.2816405861245954],
            [12.613518415940069, 2.2707383244206647],
            [12.621161585392821, 2.264109818228225],
            [12.62336684726024, 2.2581352417536853],
            [12.620365857503442, 2.247392992872005],
            [12.622702331604593, 2.2412278177226237],
            [12.629906771275232, 2.230263454039229],
            [12.634069488992019, 2.2256213308279538],
            [12.635758927589674, 2.221948401059874],
            [12.635211148352345, 2.218073548144914],
            [12.62788106261615, 2.212087727680121],
            [12.626916320867872, 2.205989303893242],
            [12.63229471933839, 2.1993432291880737],
            [12.633023106690809, 2.195654429018908],
            [12.624453125764502, 2.1856190896549093],
            [12.62642678068548, 2.1808401406163607],
            [12.63609631079458, 2.17890869695828],
            [12.639364356652303, 2.1717642911130484],
            [12.643103594872947, 2.154770552859777],
            [12.65330831917875, 2.142354207532289],
            [12.655432261604858, 2.1367865145742786],
            [12.6540084001328, 2.13193477335235],
            [12.650579652183673, 2.1292209956564117],
            [12.641224772562063, 2.1266840956755755],
            [12.638231282281692, 2.121056558032324],
            [12.640970215354093, 2.111496458237635],
            [12.640831436832562, 2.1046142972240403],
            [12.645591921659268, 2.0975516762790343],
            [12.65190996357297, 2.094945124275768],
            [12.658213505123214, 2.094691056966555],
            [12.664418769187012, 2.090942641801388],
            [12.667976521495694, 2.087047096795233],
            [12.668511496878564, 2.081747851233971],
            [12.665105141658223, 2.0698217305107183],
            [12.662186184111713, 2.0633576993852127],
            [12.542071970722152, 2.0434193440654673],
            [12.46811974777636, 2.030930056802647],
            [12.366593939844414, 2.013892875710069],
            [12.282459937069829, 1.9998585873123231],
            [12.208772513519158, 1.9879362656961566],
            [12.194836206671331, 2.072307095781067],
            [12.181359791673948, 2.15674970467619],
            [12.173563378568563, 2.2024846565574534],
            [12.169457398605486, 2.227596800236717]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.22289545598093, "lat": 39.85380244684332 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42059"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01214033"
      },
      "bbox": [
        12.169457398605486, 1.9879362656961566, 12.668511496878564,
        2.331880917319054
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.97335905678566, 2.9074005236773575],
            [14.975279865508973, 2.9195333824781704],
            [14.978455466866482, 2.92595269567314],
            [14.980511696971474, 2.932474427718444],
            [14.984404782949172, 2.9354334113107465],
            [14.986142900596763, 2.9409424030975257],
            [14.985751252033854, 2.9449567327686155],
            [14.990325113357617, 2.9439849535769054],
            [14.995451327473727, 2.9445840213781405],
            [15.000452299417502, 2.9426203902562085],
            [15.000226105642664, 2.94686333237385],
            [15.004241535128948, 2.9491635909444702],
            [15.001968238624286, 2.951794502623669],
            [15.008731074826207, 2.9593280889684053],
            [15.014049959629805, 2.9610158569459313],
            [15.014834532963281, 2.963243677265017],
            [15.021743955817927, 2.9634912245291907],
            [15.02559242738555, 2.9661700996327727],
            [15.026687865065561, 2.9698163698286684],
            [15.029478944895406, 2.9709623509228553],
            [15.03150405676924, 2.9776806879169353],
            [15.035687329713108, 2.981736202047293],
            [15.039416981993284, 2.9832946333590846],
            [15.040636727592947, 2.98845895505373],
            [15.044489907994052, 2.9939976618062256],
            [15.049775998707753, 2.9933141530204597],
            [15.061964653659123, 2.9986009290789553],
            [15.063857059944546, 3.0030098814161716],
            [15.069773697038482, 3.0037663377301094],
            [15.07291374564272, 3.0067246875477207],
            [15.116327065101895, 3.037139712695601],
            [15.138493082999728, 3.0520011230703674],
            [15.161363177790662, 3.067889521988842],
            [15.209245433125833, 3.0873596747771312],
            [15.252420975584858, 3.104260639378216],
            [15.313336088974506, 3.154282101298751],
            [15.355384195185495, 3.1884076725460897],
            [15.355518687657826, 3.1887203383966494],
            [15.372597858643184, 3.179145834382119],
            [15.449243741221458, 3.1377760761566447],
            [15.50496967292344, 3.1075187312593338],
            [15.525487283855545, 3.0965580554927032],
            [15.597219085347461, 3.057005785474494],
            [15.598800321461095, 3.0563094332924843],
            [15.587752567935588, 3.0461306624527777],
            [15.553110663194763, 3.0178253973603635],
            [15.564694021378328, 2.988633290571971],
            [15.567414017834244, 2.97563599267797],
            [15.572579669753074, 2.9584033084009858],
            [15.57357451978639, 2.948206508436945],
            [15.55701273127693, 2.8931770606241236],
            [15.550675045471309, 2.8709319547533227],
            [15.551777193342007, 2.8683875045060803],
            [15.547910787855383, 2.8550766594175023],
            [15.551611365347473, 2.850821179039062],
            [15.555545264553963, 2.8434440826524194],
            [15.56205842223377, 2.8385647442572357],
            [15.55808136251838, 2.833923560391413],
            [15.55519990723822, 2.832487034806783],
            [15.552453739721631, 2.8247467922890874],
            [15.555270292311443, 2.8197024946869185],
            [15.55473436734566, 2.8126884052653067],
            [15.56014395654452, 2.8026127190271333],
            [15.565149897311178, 2.7993292716752554],
            [15.566415673690232, 2.7969380018350103],
            [15.564088794870107, 2.791698666916518],
            [15.56442444274873, 2.786172100398097],
            [15.568201165348702, 2.78291482291088],
            [15.570096063016896, 2.7774024854872703],
            [15.568045537203167, 2.773109541609796],
            [15.562079990361948, 2.7752268115680248],
            [15.55761456854266, 2.775152442857351],
            [15.557657462303219, 2.768695503642346],
            [15.55966989820168, 2.756087247026537],
            [15.558720381143674, 2.75383036791673],
            [15.549959786098379, 2.753569703444052],
            [15.551120621683003, 2.745058584787198],
            [15.554756072770456, 2.7387683838572605],
            [15.557159760376406, 2.7323826000911287],
            [15.552575670608295, 2.730703599406892],
            [15.550843700802162, 2.723482831636628],
            [15.545942992875855, 2.7243303859670465],
            [15.544118366690089, 2.721188575887196],
            [15.549233447139729, 2.716308680758612],
            [15.550581753291215, 2.711144989042183],
            [15.547346730020733, 2.710040545848476],
            [15.548192945369719, 2.7064150367688478],
            [15.547027748818156, 2.6995563445163446],
            [15.541795796698182, 2.697678679957505],
            [15.545982261034021, 2.6944033866220605],
            [15.542191869389127, 2.6856521274805183],
            [15.542480736755493, 2.6800895227688493],
            [15.536812468831695, 2.6748396758137734],
            [15.536247843958819, 2.669720210756707],
            [15.533965071903314, 2.664361123390476],
            [15.53690907118189, 2.6590270990794256],
            [15.534819929160957, 2.653911219462453],
            [15.527149859095312, 2.654181529232219],
            [15.523230795836, 2.6528725366439696],
            [15.52144056001318, 2.6468631749534213],
            [15.524417228607048, 2.644568131891964],
            [15.524112992115585, 2.6396505719340007],
            [15.51882300760482, 2.632845371151004],
            [15.515864545834182, 2.632506866754253],
            [15.512686609049304, 2.628506007912162],
            [15.517610706413523, 2.626821818243328],
            [15.521046636382106, 2.623735420796557],
            [15.51615474901671, 2.6131487212443423],
            [15.513673795876327, 2.612323256850429],
            [15.508267374171378, 2.6158557835177114],
            [15.50888999385447, 2.622497079292529],
            [15.504645645329981, 2.6239560235221697],
            [15.50010392545635, 2.622208406993846],
            [15.501186317271161, 2.6157217041097107],
            [15.503664950943516, 2.6116749702034037],
            [15.501084113576203, 2.609061072700666],
            [15.496212146445322, 2.612310903158579],
            [15.491289973402703, 2.6107482640638824],
            [15.491533206790272, 2.605128652985319],
            [15.418764253058281, 2.58949075683619],
            [15.41388313617986, 2.588461842281145],
            [15.41392529889324, 2.5923742459264822],
            [15.411427140321608, 2.5972268703854944],
            [15.406277084447481, 2.603211735170155],
            [15.402702606039421, 2.605350191587989],
            [15.395405111175359, 2.614179468146989],
            [15.391998713152732, 2.6155179756454396],
            [15.385333659062834, 2.621660697724325],
            [15.38091959511176, 2.6273757287023067],
            [15.375513981461298, 2.6363503921342213],
            [15.371901758124856, 2.6397325984301645],
            [15.36840801063924, 2.640061258228014],
            [15.363078912429668, 2.643411482816918],
            [15.344193650526764, 2.6580383481121324],
            [15.33887039144993, 2.66410965814512],
            [15.328461787425523, 2.666820062344159],
            [15.319578577881197, 2.6724505407443373],
            [15.316591813972952, 2.676722667138559],
            [15.307175456379765, 2.6860176247874614],
            [15.305080904268543, 2.6951935202458968],
            [15.294891261188315, 2.7033227713516235],
            [15.288267968483453, 2.705381670844059],
            [15.281960353513313, 2.709462034142167],
            [15.27729513955343, 2.7167598839157936],
            [15.275424341713183, 2.7219149087542864],
            [15.275530828334489, 2.7295330734668886],
            [15.270874567728676, 2.735956193317431],
            [15.267080744936754, 2.7476052472304717],
            [15.26216002050475, 2.752810358217972],
            [15.25821121730384, 2.754309369214802],
            [15.25053023055157, 2.7541328273141636],
            [15.235666069002347, 2.761777414800713],
            [15.228898747322518, 2.763531915525654],
            [15.21396802013192, 2.7660111989376994],
            [15.204525239802342, 2.7711611180521176],
            [15.198333590458956, 2.7717240971948285],
            [15.192983137410433, 2.7750409139265084],
            [15.187262797647218, 2.78153262538937],
            [15.179672122955939, 2.787492371457896],
            [15.170873530067368, 2.800069741770703],
            [15.164161789632782, 2.8200942261370234],
            [15.16192768572911, 2.823429836467293],
            [15.153449492824514, 2.8307267485801564],
            [15.149345365665225, 2.83602537217619],
            [15.143290960214213, 2.83952833936991],
            [15.13713137353558, 2.8445869116565534],
            [15.130755202521803, 2.8556722245070207],
            [15.129586073900944, 2.8635875291147084],
            [15.126313262189838, 2.868251980483413],
            [15.121229381390716, 2.8668773504044998],
            [15.112873991211595, 2.8607066314488594],
            [15.100223662244103, 2.8569991277673767],
            [15.086652856525003, 2.8579411546887337],
            [15.080752522208213, 2.858986169932544],
            [15.067112751314427, 2.859216508709294],
            [15.061689329295804, 2.8583556234344507],
            [15.049647435033622, 2.859610777720055],
            [15.04324679242472, 2.857986717759809],
            [15.036805280439127, 2.858205176676023],
            [15.027846045032577, 2.860119972049684],
            [15.017058134070757, 2.868568171518242],
            [15.0114462752835, 2.877287263283374],
            [15.004317683603654, 2.885195236074451],
            [14.995072542418479, 2.893777366851522],
            [14.985478276564153, 2.900173948686138],
            [14.982559019661172, 2.9028839133860935],
            [14.97335905678566, 2.9074005236773575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.24764608084435, "lat": 40.0423602601464 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42071"],
        "coty_name": ["Lancaster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lancaster County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01209181"
      },
      "bbox": [
        14.97335905678566, 2.588461842281145, 15.598800321461095,
        3.1887203383966494
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.160658558971544, 2.281549950292263],
            [12.150685028609667, 2.342937273007941],
            [12.137227556507389, 2.4240826447179096],
            [12.121348985458512, 2.5208771700642236],
            [12.107427328791585, 2.6055454216320206],
            [12.103976298817484, 2.631398402732592],
            [12.098796425525542, 2.6628991706272043],
            [12.088739406776849, 2.725405379026047],
            [12.08533105647404, 2.7400575612784683],
            [12.146179568275734, 2.7504901443563297],
            [12.17869870516648, 2.755368174320234],
            [12.202981677173028, 2.7597029063245504],
            [12.259683671232667, 2.715890687027728],
            [12.324123380080438, 2.6657758571683394],
            [12.34420461926156, 2.6499850840498516],
            [12.358163092547958, 2.638004416202052],
            [12.3908992130324, 2.630744346342359],
            [12.412507735236646, 2.6262110426391843],
            [12.417801108178189, 2.6246675511528585],
            [12.443778170471635, 2.6193206195782204],
            [12.48390382832771, 2.6104588209508126],
            [12.529623945091576, 2.6010381198236687],
            [12.573117888357945, 2.5918915965826343],
            [12.571362705644551, 2.588527424705389],
            [12.56632267994949, 2.583183578184787],
            [12.557726197862113, 2.5780958698129712],
            [12.543598553825653, 2.5743384657378923],
            [12.539545807558934, 2.5721864562270564],
            [12.534915607553232, 2.5658117805449305],
            [12.53534947398774, 2.559330408017066],
            [12.539197238436989, 2.5550718761548987],
            [12.547170277449258, 2.5484234959560337],
            [12.553266878798613, 2.546700759444449],
            [12.56976412985613, 2.544933389646214],
            [12.57881133092715, 2.5395211153045563],
            [12.585288922710005, 2.537250154410992],
            [12.593449082010643, 2.5364595813045727],
            [12.60211949287339, 2.5378311357494256],
            [12.607482362248778, 2.5407057768630468],
            [12.61458570163915, 2.5426822165649368],
            [12.618831334851885, 2.543040917418459],
            [12.62749914776075, 2.539371076354725],
            [12.629524121336873, 2.5368871044460835],
            [12.633584200097445, 2.5258906961129433],
            [12.633200943994808, 2.5172817158262295],
            [12.629350457510577, 2.5101835260444907],
            [12.623175317273063, 2.507833160357896],
            [12.608230314530648, 2.5084505006096762],
            [12.60377449916279, 2.507688663299427],
            [12.59894099425261, 2.5043262494841887],
            [12.596524831795811, 2.498546261896591],
            [12.600007752548452, 2.49033767680539],
            [12.607942637056745, 2.4836437203773167],
            [12.613719126973788, 2.474763686726465],
            [12.621778924005143, 2.471878384310641],
            [12.63646360420477, 2.4660882471568852],
            [12.642547313728324, 2.4643321514952943],
            [12.6456881469274, 2.461302743635117],
            [12.656490604977298, 2.4425508925601873],
            [12.655574899269935, 2.433737821191148],
            [12.652203771054918, 2.429246032523052],
            [12.641166723766842, 2.4224835892903074],
            [12.635265311471896, 2.421499669829244],
            [12.629235937503147, 2.4235108206786653],
            [12.618382715699816, 2.4236194704182346],
            [12.612719013789448, 2.4189528747663815],
            [12.615848461863052, 2.4139070058770353],
            [12.62630984840825, 2.412913419136442],
            [12.631866643405123, 2.408217725792694],
            [12.63114306304843, 2.4027421135677667],
            [12.625013236895851, 2.394394293369198],
            [12.626264396326615, 2.389174590528621],
            [12.636285929080278, 2.3835902935535325],
            [12.638889065935379, 2.3794693750555793],
            [12.636997263041085, 2.373548089319124],
            [12.630537273548518, 2.3664895867503333],
            [12.61977728013421, 2.3647231130857964],
            [12.612553719739228, 2.361959147607282],
            [12.605515922457018, 2.355732492589564],
            [12.6025624372158, 2.3507494394048156],
            [12.601075855157408, 2.3380995607084163],
            [12.59285196192738, 2.3311987494060338],
            [12.586775264739408, 2.331211030328751],
            [12.582676965725797, 2.3353737796607748],
            [12.578204763847564, 2.3427348233413645],
            [12.571072771828426, 2.347497537622409],
            [12.560897625585955, 2.345042146280129],
            [12.55592548289552, 2.3404620393592643],
            [12.554350897526023, 2.3357434397279118],
            [12.55675068372882, 2.328083371766129],
            [12.561103789468541, 2.3179250022483946],
            [12.556321019473092, 2.3138068269097474],
            [12.549416512346747, 2.31404291756126],
            [12.54588930023503, 2.311269877189044],
            [12.542332910533418, 2.305466731801633],
            [12.53204888315137, 2.3102472314962967],
            [12.529647132771252, 2.3085443972010546],
            [12.53187781458916, 2.30390072359461],
            [12.526613357073629, 2.299336096696157],
            [12.519492649531141, 2.3026579173105253],
            [12.518769457838369, 2.308902924677961],
            [12.515841346970792, 2.313410337190722],
            [12.52011525341787, 2.319124717859288],
            [12.515850309521063, 2.32924111743909],
            [12.513752956862012, 2.3304231531391033],
            [12.51027828469207, 2.3274461001292535],
            [12.505282650630882, 2.331880917319054],
            [12.501450411393819, 2.327451001679974],
            [12.500637770159988, 2.324408237550205],
            [12.488970157222573, 2.3095993806253636],
            [12.484417168887298, 2.310515912936184],
            [12.474399856111809, 2.307748731469281],
            [12.470711173978783, 2.3042746299217054],
            [12.464929435736357, 2.306492512507857],
            [12.457026922330542, 2.302213052580555],
            [12.4511609107843, 2.3055006685010198],
            [12.439944433881058, 2.305480525214306],
            [12.436377794201983, 2.3070577022952135],
            [12.431358395094092, 2.3131638569925808],
            [12.41945659364614, 2.31590867105088],
            [12.415239274010235, 2.3137824944665892],
            [12.41493957306948, 2.3102957200009464],
            [12.409296139486191, 2.3079234591277267],
            [12.406067850802852, 2.3105269775387254],
            [12.402199979875602, 2.308122869544338],
            [12.395315684067885, 2.3089279420557203],
            [12.390772740931428, 2.305807162073758],
            [12.384460419717637, 2.3066497768014904],
            [12.379773679750276, 2.308622688177614],
            [12.370686381049703, 2.3092668912436665],
            [12.36797557433717, 2.306328331518355],
            [12.362271758476002, 2.3061295206618726],
            [12.361820200648593, 2.3033970311178793],
            [12.352177561614358, 2.2982146465232796],
            [12.34554807856799, 2.299012822521741],
            [12.347150120323786, 2.303549248138133],
            [12.345262421108824, 2.308908993264573],
            [12.33687616153087, 2.3066238615672283],
            [12.333673619197215, 2.3130341486127617],
            [12.328551387557903, 2.311506770045007],
            [12.32298805455105, 2.3126366939578338],
            [12.316869775596054, 2.3086483924298196],
            [12.317296654407349, 2.304053014225583],
            [12.319650116325423, 2.297044864714577],
            [12.317488022766973, 2.2940711182357467],
            [12.313805346578311, 2.2934695266278977],
            [12.310747732495653, 2.2953283104148943],
            [12.305432927555202, 2.2935080825124947],
            [12.28865800397624, 2.2860629777040726],
            [12.28721430062854, 2.282907067908307],
            [12.280094577671141, 2.280939612789617],
            [12.276186512741493, 2.280970146706231],
            [12.268879977087325, 2.2766270932057164],
            [12.26113762773992, 2.2690380264680914],
            [12.258442150106703, 2.2640555774495645],
            [12.259162089509797, 2.259806206805284],
            [12.251365466421444, 2.2559739889686874],
            [12.246681946061562, 2.2554027761999547],
            [12.241668070651878, 2.2530008812158457],
            [12.237764135163959, 2.2488622641285314],
            [12.234250771814294, 2.252205625874592],
            [12.230210150848347, 2.253243130372284],
            [12.22429343229507, 2.250797720779321],
            [12.22402191846109, 2.2472063963963165],
            [12.219410795670527, 2.242254213007861],
            [12.215364335414634, 2.2425067176086286],
            [12.212014201345793, 2.2398939849382047],
            [12.214502307971784, 2.236931436041989],
            [12.211349841160635, 2.23316579625078],
            [12.210138701869962, 2.228773809403048],
            [12.204049891417991, 2.2229283700787343],
            [12.194977575145153, 2.224188148294949],
            [12.189667472176836, 2.2273983790599114],
            [12.184787752646612, 2.2254134286451546],
            [12.184531268777429, 2.221473424737022],
            [12.176928269296374, 2.225859949065865],
            [12.169457398605486, 2.227596800236717],
            [12.160658558971544, 2.281549950292263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.2483273243431, "lat": 40.18937231295028 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42125"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01209190"
      },
      "bbox": [
        12.08533105647404, 2.221473424737022, 12.656490604977298,
        2.7597029063245504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.661095717770705, -4.354352768787881],
            [12.66438112623704, -4.355555672407658],
            [12.669943580467029, -4.353932826781128],
            [12.675114561448664, -4.3548657773059585],
            [12.681379470101307, -4.361274611503311],
            [12.683966330046573, -4.3698543941447205],
            [12.689177984094378, -4.371579983781712],
            [12.692654926590059, -4.378191798162466],
            [12.704590605833543, -4.3782084163169825],
            [12.706027731768934, -4.379412947137516],
            [12.711442622310807, -4.377683541665376],
            [12.718056180890706, -4.380256542342716],
            [12.720156076136766, -4.379474658387746],
            [12.72907971030878, -4.384865089517648],
            [12.731813532070186, -4.384609356146924],
            [12.739846812709187, -4.388935296144862],
            [12.744627636609652, -4.393121670202329],
            [12.750472574545691, -4.393031480084177],
            [12.755900046745097, -4.396947805982958],
            [12.761548858836385, -4.398695724845751],
            [12.769421365683225, -4.399817477203905],
            [12.778143923942562, -4.398444523520839],
            [12.783599291022488, -4.400877001202785],
            [12.789245753636525, -4.400120177956408],
            [12.792075019424706, -4.4014217055580565],
            [12.794152687522068, -4.406170343800902],
            [12.800307119328181, -4.409082912773637],
            [12.80475475284006, -4.4136246069262395],
            [12.809867085151213, -4.41464102974924],
            [12.811585195646147, -4.418140069707496],
            [12.821242159539244, -4.422684584032999],
            [12.825190801073873, -4.420722325753209],
            [12.831453544535588, -4.422498575871991],
            [12.832993606229222, -4.42117535603841],
            [12.83740887263256, -4.4250162190390805],
            [12.839153869114163, -4.4290755989620045],
            [12.844672061560008, -4.43016896789249],
            [12.848162219917437, -4.427891008174736],
            [12.85246327080194, -4.4298597883831405],
            [12.855543418235367, -4.428909856892667],
            [12.858237546909278, -4.432923059787161],
            [12.864220364483584, -4.435410105425003],
            [12.867925397663754, -4.433819821282999],
            [12.873270838341268, -4.435748798053659],
            [12.877007115921215, -4.440963988503261],
            [12.882189193367177, -4.4437690980523366],
            [12.886028595305879, -4.441992006068567],
            [12.889950466759563, -4.443746811837772],
            [12.893379241873616, -4.448853695052413],
            [12.906264697586238, -4.449784268324737],
            [12.913195216104379, -4.453372303402796],
            [12.923189674984531, -4.460175234446402],
            [12.925535534686766, -4.464085425046297],
            [12.92921915890889, -4.464277639520688],
            [12.935053276871713, -4.470275907777653],
            [12.937513101032652, -4.470071465545577],
            [12.948897195861061, -4.4766059979466375],
            [12.948974942850713, -4.478754466192192],
            [12.958896985266668, -4.481695412571934],
            [12.962253569024874, -4.488381514816971],
            [12.967826186725732, -4.489203202334476],
            [12.972759017096505, -4.493073442314741],
            [12.979405370633888, -4.4940122803075635],
            [12.98096013875821, -4.497809757505788],
            [12.98543052860291, -4.49792957222221],
            [12.986512912610293, -4.5002241028651895],
            [12.992564484827403, -4.4999043221910435],
            [12.99369345302219, -4.507315027879005],
            [12.9978236053162, -4.505184529100362],
            [13.001511458393848, -4.505430946740695],
            [13.004286082815296, -4.518770600265622],
            [13.003713976561599, -4.522612750627834],
            [13.008031160224323, -4.522919694501838],
            [13.007545258425509, -4.5311254875278575],
            [13.013062517107743, -4.531473568811667],
            [13.010944799008739, -4.534840931584926],
            [13.016520806069504, -4.538393096097971],
            [13.024947580020298, -4.538995227038138],
            [13.026629954985076, -4.541309740502779],
            [13.032122339253338, -4.544200494596165],
            [13.03173804857213, -4.548919134079003],
            [13.033559449770765, -4.5519561409998115],
            [13.04136170734016, -4.555219255552223],
            [13.046122989968945, -4.559833458920477],
            [13.05092333650213, -4.559886901465762],
            [13.013340194437959, -4.593935582193086],
            [12.979084354235361, -4.623832422767526],
            [12.98407167415079, -4.629140778088316],
            [12.987392135322787, -4.6357932424951045],
            [12.988030123164625, -4.645909997630017],
            [12.994976425717285, -4.648561700986034],
            [12.999437948336245, -4.6532602521723065],
            [12.995605364444218, -4.657408657477325],
            [12.989940586633024, -4.672750202703719],
            [12.988735224501005, -4.687247093534928],
            [12.98074095231141, -4.689724303926608],
            [12.978649321487257, -4.684191797118472],
            [12.970598835254199, -4.6794951677505985],
            [12.966465518638907, -4.67063095677367],
            [12.959390683650632, -4.667198858471227],
            [12.95608512266224, -4.6625489488232015],
            [12.953640651179885, -4.655414008761193],
            [12.948413171876531, -4.651852219237808],
            [12.87887632989232, -4.712781516569614],
            [12.841063401707462, -4.746008964131453],
            [12.83694881637485, -4.741492527773643],
            [12.836200963359143, -4.738072799921584],
            [12.832821158528823, -4.734558237702488],
            [12.8284661089029, -4.733431123720692],
            [12.82448509752554, -4.727728335920602],
            [12.821993759526668, -4.726194560124864],
            [12.817302899665824, -4.727284636368139],
            [12.80995337735566, -4.727374329676104],
            [12.802200311346114, -4.72513254895431],
            [12.793508491762859, -4.715420189396122],
            [12.782306858066637, -4.708383741532767],
            [12.777905794736371, -4.700836854440161],
            [12.771359640964176, -4.697139710569284],
            [12.765429184985651, -4.692112776505435],
            [12.757444655127703, -4.689036227985919],
            [12.753688483615155, -4.683249221324723],
            [12.74863095816526, -4.680414702668251],
            [12.746879179832662, -4.677454008991935],
            [12.735500713324164, -4.669139472110425],
            [12.730911279821362, -4.6649024526686125],
            [12.729966496385982, -4.661963346044277],
            [12.722820542994148, -4.659987223711351],
            [12.717804669981161, -4.65144365635552],
            [12.716530113505984, -4.646849934460222],
            [12.712243917919468, -4.643520027632319],
            [12.71183303146532, -4.640908463504657],
            [12.707236548792036, -4.637208421001456],
            [12.70272847256475, -4.635818769973277],
            [12.700142907143709, -4.630034217358457],
            [12.702225755154343, -4.622588131098186],
            [12.701342055019278, -4.613488881482595],
            [12.701640103659178, -4.607811050320143],
            [12.699273154588937, -4.5860987692175925],
            [12.701097598484841, -4.5834157338469],
            [12.697059831580503, -4.578021931299571],
            [12.699179980535497, -4.570080237793579],
            [12.69571483245105, -4.5638045189544405],
            [12.692936430099813, -4.542260563445963],
            [12.69080854089488, -4.533456328950865],
            [12.686586073215716, -4.497289584224301],
            [12.678744952569875, -4.42653062691529],
            [12.675440038338076, -4.394927001572476],
            [12.661095717770705, -4.354352768787881]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.05419582197476, "lat": 33.21479378603232 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45009"],
        "coty_name": ["Bamberg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bamberg County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01247982"
      },
      "bbox": [
        12.661095717770705, -4.746008964131453, 13.05092333650213,
        -4.353932826781128
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.3230396750641, -3.2550978441013023],
            [12.413563174645928, -3.2464239796068903],
            [12.442465679908553, -3.243539753943465],
            [12.569612492791112, -3.2324389758116174],
            [12.609816426451829, -3.229069886538663],
            [12.618685949490212, -3.2280286123095903],
            [12.663944704128482, -3.226159862293607],
            [12.707951886651344, -3.2218589436663976],
            [12.767529653998794, -3.214620640683253],
            [12.770311807382331, -3.221555488597962],
            [12.771491602754235, -3.2324891859856164],
            [12.770374743275598, -3.2517058784627912],
            [12.770988957780624, -3.2579294556266767],
            [12.767076315737434, -3.2633641450628543],
            [12.763416351812694, -3.2639867097352036],
            [12.75984421968908, -3.268318519407546],
            [12.759405943355096, -3.2734656832141233],
            [12.761993937283767, -3.275953504441318],
            [12.770867478486327, -3.290814067756195],
            [12.775878451643853, -3.2946014504669963],
            [12.77976320904963, -3.2996819909658894],
            [12.788373153972877, -3.306631750839418],
            [12.791530228669197, -3.3112392730061155],
            [12.801929788071012, -3.319037280618806],
            [12.808608751960861, -3.323249334171638],
            [12.81880385230703, -3.3329556582616564],
            [12.823802042702106, -3.33639484937546],
            [12.830388165462427, -3.3383533670531826],
            [12.842053656072158, -3.3336792326080236],
            [12.856154215658915, -3.3327462475952045],
            [12.865547679869792, -3.3381770900696583],
            [12.867249418233516, -3.3419158203121224],
            [12.866500585768186, -3.3500656572928555],
            [12.868055795227551, -3.35576866329065],
            [12.87028774028749, -3.3584412247631845],
            [12.881003330246925, -3.365625594492943],
            [12.85310083079948, -3.4805423102432806],
            [12.745670125568093, -3.5147843031194395],
            [12.73018321299376, -3.5225561584037117],
            [12.706924462130885, -3.5336972688492563],
            [12.686116838807989, -3.5440896056195887],
            [12.682661330669585, -3.540436720028487],
            [12.67631009015988, -3.543855135226623],
            [12.671095662629888, -3.5453291157533857],
            [12.669004884876667, -3.55141613149461],
            [12.661335042018239, -3.5483077929083695],
            [12.660562681909564, -3.5560710781088822],
            [12.651631198595558, -3.5574720852197044],
            [12.648369358507713, -3.5635200217868834],
            [12.644708343156562, -3.5658464761728195],
            [12.64316331576811, -3.5698897671540135],
            [12.622847176199189, -3.570874139611748],
            [12.619410938755179, -3.5717636608259897],
            [12.57299456152512, -3.574400338789886],
            [12.57425229320759, -3.578836818227433],
            [12.580720465969923, -3.582944289398944],
            [12.5820704993918, -3.589218218404624],
            [12.584839453225156, -3.5898882522169893],
            [12.587037421815378, -3.5985774053976236],
            [12.583769731368168, -3.6044245014048575],
            [12.579627954866435, -3.6076116611779674],
            [12.58250581977246, -3.619471176437097],
            [12.57658728504595, -3.616896351657425],
            [12.569893550869352, -3.612402380546318],
            [12.561336764501755, -3.60829752841747],
            [12.554990920456625, -3.6036532425332446],
            [12.54623410981904, -3.602508278975826],
            [12.542735412959408, -3.596719138208837],
            [12.53862223598789, -3.59464728736301],
            [12.523078673156123, -3.598857197253767],
            [12.518893062694948, -3.6005207025152948],
            [12.5114574503296, -3.5955802178727754],
            [12.508313957607527, -3.5910792620712786],
            [12.501167464473793, -3.5840496033316422],
            [12.498078852738436, -3.583548755232622],
            [12.491648788181154, -3.5765980254093264],
            [12.487589658531821, -3.5747728985902145],
            [12.476787703615594, -3.5720183015049267],
            [12.471918279054965, -3.572021693956087],
            [12.4657350465792, -3.5741806076813787],
            [12.460008926562905, -3.5725237695109016],
            [12.454088400152004, -3.566797290406131],
            [12.447990656576714, -3.5565107975395427],
            [12.441830967270548, -3.5520381618210757],
            [12.435180312337513, -3.548414962550445],
            [12.431327398682882, -3.5398617762037405],
            [12.431122493296847, -3.5329516180382092],
            [12.433735909556797, -3.5251703375021632],
            [12.429371942857747, -3.5174973038401682],
            [12.420142868814919, -3.514142733634989],
            [12.414923201381331, -3.507178894659305],
            [12.411615521008853, -3.500266657378282],
            [12.406489812394058, -3.492905923848846],
            [12.406292569166013, -3.488251202980943],
            [12.400095819210787, -3.47875604349409],
            [12.400229063628398, -3.4735226399989183],
            [12.398652864264143, -3.469093520257669],
            [12.391423184825255, -3.4583148533999704],
            [12.386968868033978, -3.4538177735912194],
            [12.38413710501167, -3.4461534514830383],
            [12.381246115336603, -3.4413927903918173],
            [12.374062182133583, -3.4355374885204273],
            [12.371210480751191, -3.430383501887181],
            [12.36941756008963, -3.4221690064909702],
            [12.360620203411155, -3.4097268388130826],
            [12.359225543408986, -3.402606084467063],
            [12.355625971777698, -3.397360289095753],
            [12.35463061315627, -3.3930165072511933],
            [12.35022734236845, -3.386239952086494],
            [12.347956805137565, -3.380444391213588],
            [12.342429873627516, -3.372482520091845],
            [12.342506626639, -3.3697875528947807],
            [12.345590522577368, -3.3635897992335586],
            [12.34703350950965, -3.3573916313794885],
            [12.346127983610415, -3.35237577771994],
            [12.3427260547768, -3.3462759102712756],
            [12.337079752568082, -3.344395995867937],
            [12.334566747151836, -3.3323989283259245],
            [12.335173931704762, -3.325074953809225],
            [12.331509310040106, -3.314042361340235],
            [12.328648107607625, -3.3030728827250733],
            [12.32568469712449, -3.2980216050142563],
            [12.324652736502323, -3.2885079496865663],
            [12.325594390986636, -3.281575832164162],
            [12.324219903316664, -3.2712510605658247],
            [12.326249677296431, -3.266908734376909],
            [12.326200053625444, -3.26015164019716],
            [12.3230396750641, -3.2550978441013023]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.12121847483517, "lat": 34.39509296854735 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45039"],
        "coty_name": ["Fairfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fairfield County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01248000"
      },
      "bbox": [
        12.3230396750641, -3.619471176437097, 12.881003330246925,
        -3.214620640683253
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.743916892315562, -3.335865636151463],
            [10.741394731700654, -3.323759367894086],
            [10.743803220163418, -3.315100361860419],
            [10.746492676099777, -3.312892366152193],
            [10.75172844380333, -3.312209358216184],
            [10.75146240208095, -3.3085551290768924],
            [10.755747717632017, -3.303888594904029],
            [10.755601158933422, -3.3009729425429524],
            [10.760288617498626, -3.298466355972198],
            [10.759865903623323, -3.292799575727531],
            [10.7640501654955, -3.2837111883761283],
            [10.760929111940351, -3.282886100834816],
            [10.76346421310255, -3.277249453210416],
            [10.759642395663715, -3.271349175050736],
            [10.760621901796872, -3.269776614728034],
            [10.757119405706316, -3.261674932727371],
            [10.759304703449668, -3.255728438300795],
            [10.764190617118517, -3.251225837439117],
            [10.763820336441952, -3.248148871368634],
            [10.772033761908727, -3.2447140055596764],
            [10.773439149330768, -3.242696950495562],
            [10.773743555185316, -3.2365062719276705],
            [10.770024986896766, -3.236028027717334],
            [10.767560034300473, -3.2324721309257334],
            [10.769886921187986, -3.228203262166096],
            [10.772874295282689, -3.2313558046230253],
            [10.777081800187425, -3.230299324401796],
            [10.780556637770763, -3.2270614125688284],
            [10.77901490789605, -3.2224593562202735],
            [10.780774032235454, -3.220719572527726],
            [10.791470184426919, -3.227184595525621],
            [10.795263447374928, -3.225507196937475],
            [10.797655378079023, -3.2220544045168067],
            [10.796929593852392, -3.2107260486848896],
            [10.792510902170674, -3.208937154779428],
            [10.795517972733432, -3.193978179376589],
            [10.79999706998383, -3.194212427831683],
            [10.800671806920741, -3.1971654172338684],
            [10.804739219316907, -3.197705788224222],
            [10.806235828036622, -3.1898569204125473],
            [10.805064498175785, -3.1857038717063633],
            [10.808783959386176, -3.1826291722369278],
            [10.808892218433357, -3.1739317075089724],
            [10.815640528147012, -3.174596673199956],
            [10.815768359643094, -3.1710994986161563],
            [10.81038713602173, -3.1631735479130825],
            [10.81276419871886, -3.1613451891598836],
            [10.81926845196813, -3.1614147090423783],
            [10.821669801989975, -3.159306388969292],
            [10.82898163002328, -3.1599316038001533],
            [10.830434403645043, -3.155398661452353],
            [10.839803683611455, -3.1568798305029344],
            [10.843330782391721, -3.151208377403054],
            [10.839485207290391, -3.145666284037039],
            [10.843615883168889, -3.1432622198273252],
            [10.846685158004929, -3.135737834588117],
            [10.851105321537274, -3.1374888172590967],
            [10.856869952540823, -3.12913436155797],
            [10.856274103360144, -3.124236722263464],
            [10.860802583649555, -3.1231463739564713],
            [10.864456155728554, -3.113808760970828],
            [10.867211235962486, -3.112775505005613],
            [10.871721471281033, -3.1165232198782475],
            [10.874873258388694, -3.114142161916417],
            [10.8710662316986, -3.1026924056724536],
            [10.873151958212402, -3.100223250589964],
            [10.884449779481159, -3.1050180673475],
            [10.886554864955414, -3.1045703582026962],
            [10.893845337901794, -3.097463810360097],
            [10.89229257182776, -3.092643198789748],
            [10.896018222581553, -3.0897174152548215],
            [10.901398496110977, -3.0942853176503244],
            [10.90322114016258, -3.091086686605924],
            [10.90833953110809, -3.090478956218911],
            [10.903212501239118, -3.0841938896845655],
            [10.89949941489475, -3.084912911010292],
            [10.893734222423134, -3.078625746734643],
            [10.899035719142624, -3.07413949711331],
            [10.898706992033468, -3.0698219282872152],
            [10.901621796943097, -3.066548594915236],
            [10.89670468652848, -3.064719851616361],
            [10.8969289858118, -3.058956801839788],
            [10.900229342957655, -3.05319047520345],
            [10.903524649543034, -3.0500195413285494],
            [10.905585344715174, -3.0427130308775285],
            [10.911069305061291, -3.033093573715902],
            [10.906980522398369, -3.0317360768797665],
            [10.907097660029962, -3.028245761409203],
            [10.901176457974957, -3.0250479223237448],
            [10.901950926572978, -3.0247827897753323],
            [10.978701098204478, -2.9875736615025903],
            [11.064155512982786, -2.946928380308666],
            [11.063849515610386, -2.9537501978209986],
            [11.060288829151757, -2.953979005608924],
            [11.060137140191795, -2.9616449719341977],
            [11.056305366870532, -2.9627276312018656],
            [11.05027549217036, -2.969127286724869],
            [11.054732762488646, -2.975172985074067],
            [11.052412310752317, -2.983161967204056],
            [11.053152944275494, -2.987148147978067],
            [11.051465743856939, -2.990238760101977],
            [11.05757348127672, -2.9917822908109413],
            [11.058891209364926, -2.9949330473527285],
            [11.054341283408325, -2.99904308207953],
            [11.045455272501732, -2.996687556244189],
            [11.041915747270314, -3.00627878989627],
            [11.042874294023681, -3.008942446928293],
            [11.040062288639591, -3.0114914766806544],
            [11.039255125353165, -3.01900377550562],
            [11.04199842342357, -3.021622229752168],
            [11.04150545249045, -3.026418075246414],
            [11.045772016930561, -3.030219944486199],
            [11.049298519219189, -3.0293534296539453],
            [11.05368654052201, -3.0312226165735265],
            [11.060990964920025, -3.032383139220891],
            [11.059566116556855, -3.0374564872468106],
            [11.06009204450215, -3.0452226383906957],
            [11.069191484612091, -3.0495575505085006],
            [11.064866998706018, -3.055643166947085],
            [11.0688273996933, -3.062014776954612],
            [11.076290583617086, -3.0682418041591215],
            [11.074289246007218, -3.0734335535555424],
            [11.077022355050067, -3.0771635238737316],
            [11.073668310194652, -3.082623753849208],
            [11.07444207041622, -3.084915956373932],
            [11.080616801930159, -3.088399084473119],
            [11.078034081905775, -3.0930561287339136],
            [11.077936362152313, -3.097082326293804],
            [11.08322952334934, -3.1005063815090494],
            [11.08199047605328, -3.1080251340571228],
            [11.077064719615878, -3.1091665674569664],
            [11.08033703530684, -3.1172642414569665],
            [11.08361788695959, -3.1294238178199993],
            [11.08440958768574, -3.134864677812377],
            [11.086942212262269, -3.1380069076711976],
            [11.085634253692959, -3.1436184571033405],
            [11.088802042306352, -3.1458431700446616],
            [11.090306290998617, -3.1493503177577375],
            [11.090157078121303, -3.156047600719619],
            [11.095708487810377, -3.1652924405322334],
            [11.093891635067104, -3.17061550131489],
            [11.09604846167877, -3.1776568956948448],
            [11.093537281025016, -3.1795294385018282],
            [11.098770835554047, -3.1865541913568816],
            [11.099235971141354, -3.197023424507375],
            [11.100821271474098, -3.1995990639295653],
            [11.105278472010857, -3.1938086106540426],
            [11.10689757911512, -3.194651469161775],
            [11.107299420783473, -3.2040031631076284],
            [11.112998467960548, -3.210195030912408],
            [11.116232127347478, -3.2115995223598266],
            [11.114371354372224, -3.2159437425230006],
            [11.116064444784012, -3.218638305596955],
            [11.111357919609652, -3.2257615211813477],
            [11.11243033498466, -3.2323374281618],
            [11.107920030916924, -3.2363024150253112],
            [11.111959212020752, -3.240459700823059],
            [11.10873178181697, -3.247284715674102],
            [11.109637679353309, -3.2533640814531735],
            [11.105418473824738, -3.26004556035889],
            [11.109367548980478, -3.2653374152690935],
            [11.117368195886591, -3.265097676789813],
            [11.12300751869612, -3.2624222213935363],
            [11.128280253808791, -3.262753786659053],
            [11.132663443124006, -3.2677750400273506],
            [11.139217742707391, -3.266480677496174],
            [11.14387579448587, -3.2721085969096353],
            [11.14443222519304, -3.276530730795025],
            [11.142277262491918, -3.280762424108097],
            [11.144419633421741, -3.2843045379883513],
            [11.142460298921343, -3.2864457976967785],
            [11.142945223390608, -3.291732472336138],
            [11.139011220621256, -3.296240435250057],
            [11.144166304826296, -3.299790967862313],
            [11.15292628554228, -3.300684517138045],
            [11.150249483172432, -3.3071300829052013],
            [11.151405174340432, -3.3124656184140493],
            [11.155062849701833, -3.3141778028115167],
            [11.152078747224937, -3.3192329683449873],
            [11.15527867414264, -3.3281948518250912],
            [11.160955255346693, -3.3290885512728368],
            [11.1619156021793, -3.3335210947719296],
            [11.168879639119176, -3.336156979924279],
            [11.166785595691485, -3.3381028396453014],
            [11.166507253114249, -3.3429067994882167],
            [11.16937891298045, -3.343844644271659],
            [11.174080160707588, -3.3400043084389583],
            [11.175966926185707, -3.3406257675432354],
            [11.169325473597352, -3.348359151436572],
            [11.171479801280517, -3.3584188947530436],
            [11.16230638872936, -3.35918875065555],
            [11.157875227349678, -3.3708526843450826],
            [11.165321005592727, -3.3758589431527946],
            [11.170641871129872, -3.3720063669401608],
            [11.169312929104624, -3.374069147762224],
            [11.167980039525133, -3.3762045854421263],
            [11.16719871684439, -3.377355839045088],
            [11.160927507359398, -3.3780203421987927],
            [11.155450937955735, -3.3759309291843884],
            [11.15205508013595, -3.385028612339002],
            [11.158286567237138, -3.3884390618549856],
            [11.160129992542068, -3.387933995163373],
            [11.160288309353316, -3.388099983774641],
            [11.12832361598317, -3.437828067920289],
            [11.074825231423983, -3.5209793600258013],
            [11.067405724664955, -3.5326807407920833],
            [11.062682283240713, -3.540196412294077],
            [11.048934973226215, -3.536669615012885],
            [11.036675071482852, -3.53188248713772],
            [11.033543231601149, -3.533385173148593],
            [11.024442616132735, -3.5285421273087314],
            [11.019622903051284, -3.5246184858071463],
            [11.01742583470116, -3.5245944029412866],
            [11.01530730416428, -3.521489882383786],
            [11.015054820186675, -3.5173980374799503],
            [11.010887499933096, -3.515543821590486],
            [11.004811478984086, -3.519086159263982],
            [11.001702110574525, -3.5184040868329056],
            [10.994319001037544, -3.5122090517696516],
            [10.99160248627226, -3.5072684435349246],
            [10.98544998080298, -3.5066000379909896],
            [10.985461757561833, -3.504710460160765],
            [10.991738707743135, -3.496777965065939],
            [10.985287716788688, -3.4913597539773606],
            [10.97877627622149, -3.4902402713474645],
            [10.975493442202582, -3.492130108771636],
            [10.97049714956869, -3.491744802710095],
            [10.969612697069419, -3.4877173912592467],
            [10.967642064656092, -3.483635342327842],
            [10.964605750847731, -3.4834366065923468],
            [10.962534987390695, -3.4781216723223785],
            [10.956150590235556, -3.473422438716967],
            [10.952388068780085, -3.4741386801968988],
            [10.950114063092844, -3.4717476136360172],
            [10.950512012734379, -3.4664813546549675],
            [10.946797322043755, -3.4650875350712544],
            [10.94211936469437, -3.468262720709682],
            [10.935948405250956, -3.4661694615153844],
            [10.93570225550323, -3.4605023484802104],
            [10.932297294097886, -3.4554807057319206],
            [10.918315999366756, -3.4496603538760895],
            [10.921060401613506, -3.4419765074552644],
            [10.909594491565892, -3.440688287392275],
            [10.9077863121598, -3.4395115883496814],
            [10.90697121949728, -3.432309659409846],
            [10.91148788398262, -3.430376866856694],
            [10.911011970468241, -3.426886683468065],
            [10.906236466729823, -3.424487350310934],
            [10.897243581998142, -3.4256044866578166],
            [10.892754486841845, -3.4271264916523307],
            [10.886148939446954, -3.4312704818040607],
            [10.88237103579899, -3.4271098416804104],
            [10.87411571484066, -3.4254768485865585],
            [10.867948923503086, -3.425999327020685],
            [10.862538075461176, -3.428209690951709],
            [10.855842431971231, -3.427454936437076],
            [10.84507405237628, -3.4217880936591674],
            [10.846497219033512, -3.4151880965474897],
            [10.841473827918884, -3.413438002532292],
            [10.839963888134172, -3.409580237650763],
            [10.833628364594505, -3.4041371845193598],
            [10.82688834693546, -3.4017948017134105],
            [10.819758443206792, -3.401433868282494],
            [10.813071897107129, -3.398486030475246],
            [10.812002218280613, -3.3961041412802455],
            [10.800016546743402, -3.3911893532035484],
            [10.792318744391022, -3.3831192099866936],
            [10.7916599301937, -3.3798339506726105],
            [10.788701910154852, -3.377205458227854],
            [10.778779306125125, -3.3782200014074752],
            [10.776779083508256, -3.3735108770225777],
            [10.77403171717706, -3.371065907355389],
            [10.766391862905527, -3.368230958678701],
            [10.759601580462414, -3.370462880864442],
            [10.756201639945035, -3.3679198224364395],
            [10.759182655844208, -3.3632599211491483],
            [10.754306486485335, -3.3570470976722744],
            [10.745973100400573, -3.355003793831011],
            [10.746233829218413, -3.3502548189986388],
            [10.750101124896345, -3.347176666322172],
            [10.747021954649217, -3.343471210823391],
            [10.743916892315562, -3.335865636151463]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.0660471431757, "lat": 34.75361198646321 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45073"],
        "coty_name": ["Oconee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oconee County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01244832"
      },
      "bbox": [
        10.741394731700654, -3.540196412294077, 11.175966926185707,
        -2.946928380308666
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.33825443905533, 5.877642652827097],
            [-0.2947777392793481, 5.877120317362834],
            [-0.2810900911343632, 5.877400652986389],
            [-0.25279366262411507, 5.8770444193930365],
            [-0.16582891966018373, 5.876470943599713],
            [-0.10257406602138787, 5.875887218358233],
            [0.007077163200423631, 5.875192207281341],
            [0.14238337826987982, 5.874179796273672],
            [0.1419530121713898, 5.803774640131865],
            [0.14211054926412414, 5.7911645117175405],
            [0.14107323292886753, 5.657054714924263],
            [0.14103764155866536, 5.629770308722257],
            [0.1406917151977728, 5.613847593095413],
            [0.1401688452901463, 5.528065157286642],
            [0.08802566962838672, 5.527288834796461],
            [0.049936359785026425, 5.527348406001313],
            [-0.04220962525258583, 5.527838578792558],
            [-0.07019282679836587, 5.528394312012323],
            [-0.08615008306665635, 5.528315324785385],
            [-0.17173364388277276, 5.529183483486715],
            [-0.20782959155109476, 5.529491231792207],
            [-0.32943586247005296, 5.5309461981303505],
            [-0.3435636408875566, 5.5312277222810335],
            [-0.34202788544995566, 5.617564270385358],
            [-0.34131656318547016, 5.686293663271411],
            [-0.340803551834872, 5.705319040180383],
            [-0.33965667333288363, 5.790963800338483],
            [-0.33821445511512255, 5.866927619817581],
            [-0.33825443905533, 5.877642652827097]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.79045873645269, "lat": 44.3696610370604 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46011"],
        "coty_name": ["Brookings"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brookings County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01265779"
      },
      "bbox": [
        -0.3435636408875566, 5.527288834796461, 0.14238337826987982,
        5.877642652827097
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0498245761815714, 6.619050727219634],
            [-1.9559787646627698, 6.615481516350014],
            [-1.8914821518840705, 6.6130594288893185],
            [-1.7986101272635726, 6.609701326256424],
            [-1.711315890273158, 6.60704648482627],
            [-1.6613024924600999, 6.605267307906594],
            [-1.5382740442870135, 6.601228768151173],
            [-1.4922798030875424, 6.599275377528055],
            [-1.451552466277863, 6.597768694679605],
            [-1.4482323139989797, 6.597642453316964],
            [-1.4506373994396984, 6.512098731372725],
            [-1.4526099952373273, 6.440286833954241],
            [-1.4528296906699567, 6.425616486820356],
            [-1.4542964139460204, 6.360875253442129],
            [-1.4572676789320578, 6.252737201037583],
            [-1.543660905002708, 6.255359247295022],
            [-1.62014600247339, 6.257647149050309],
            [-1.7239053989419946, 6.261065315948076],
            [-1.8030837327205234, 6.263679521683011],
            [-1.8780452928136764, 6.266307080470394],
            [-1.9761249679182942, 6.269833616560479],
            [-2.062477881180554, 6.272985558703042],
            [-2.0620339755477968, 6.287635826266622],
            [-2.059300589479595, 6.359722292973862],
            [-2.056787007496356, 6.431625394219901],
            [-2.056567229296332, 6.433999588021489],
            [-2.0529908757675157, 6.532373213280638],
            [-2.0507857348895704, 6.600437829464941],
            [-2.0498245761815714, 6.619050727219634]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.14528522446997, "lat": 45.07100094362724 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46049"],
        "coty_name": ["Faulk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Faulk County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01265760"
      },
      "bbox": [
        -2.062477881180554, 6.252737201037583, -1.4482323139989797,
        6.619050727219634
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.3652349745489465, 7.441528250135048],
            [-4.279031371380885, 7.435308261508162],
            [-4.200517123576962, 7.429762245948918],
            [-4.1635072995445785, 7.427554600282923],
            [-4.093615117153223, 7.422301316053969],
            [-4.041562503738933, 7.418925170122712],
            [-3.938922568573945, 7.411684564118803],
            [-3.8338662231163085, 7.404638401539142],
            [-3.711368907281353, 7.396739336652239],
            [-3.711690215192598, 7.3869502931735935],
            [-3.719245801405611, 7.272551184432113],
            [-3.7249019443099405, 7.186561729985568],
            [-3.729988337314905, 7.102510512525502],
            [-3.736754875442421, 6.995105695433592],
            [-3.74051619826766, 6.929492745121944],
            [-3.745798046690807, 6.843696544247894],
            [-3.7511671342401973, 6.757779664358125],
            [-3.7561768168461804, 6.687021072760372],
            [-3.7570319870546602, 6.671667505152354],
            [-3.7653408728655533, 6.542106887983597],
            [-3.7680626946438687, 6.498916379046221],
            [-3.7948734114414213, 6.500879741754859],
            [-3.8671399411567853, 6.50578783588983],
            [-3.9394074574910887, 6.510682189776982],
            [-3.9592349827325366, 6.51186639218107],
            [-4.057590635923663, 6.51848474648075],
            [-4.1292405436880575, 6.5239424177350855],
            [-4.214899868780979, 6.528819071091033],
            [-4.269256871435587, 6.532869329016038],
            [-4.270403657978919, 6.533089539751479],
            [-4.356039277126532, 6.539479990699466],
            [-4.4204814930288965, 6.544124155143193],
            [-4.442086913966751, 6.545926117135717],
            [-4.4356920896493, 6.631901732994238],
            [-4.429337840733747, 6.717754236019257],
            [-4.426728019159943, 6.754645307811737],
            [-4.4253672035205565, 6.763798548625738],
            [-4.42294184557536, 6.8036038009426045],
            [-4.416353192949627, 6.889656021245347],
            [-4.41194487649001, 6.889302389881036],
            [-4.407639496276772, 6.944411212407212],
            [-4.405511096663815, 6.9749846756990195],
            [-4.403736132260718, 7.004146177190169],
            [-4.399520048460163, 7.061363494408117],
            [-4.392630237917856, 7.147500611079157],
            [-4.386582061692537, 7.230522209441815],
            [-4.380971152247773, 7.231819470139326],
            [-4.374800718839239, 7.317863613277989],
            [-4.3652349745489465, 7.441528250135048]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.47568855383243,
          "lat": 45.49045642588958
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46105"],
        "coty_name": ["Perkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perkins County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01266990"
      },
      "bbox": [
        -4.442086913966751, 6.498916379046221, -3.711368907281353,
        7.441528250135048
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.699627985810968, -1.9948402743519562],
            [7.700972749154194, -1.9891179440509026],
            [7.703745550487641, -1.986557521342277],
            [7.708473195840299, -1.9874610414964318],
            [7.714034659689554, -1.9868946822501863],
            [7.7182706828317, -1.9889475233661504],
            [7.723530355106053, -1.9948645544956765],
            [7.727499268168294, -1.996207813641412],
            [7.729017801894701, -2.002588726049842],
            [7.734632087981904, -2.000022289432512],
            [7.741453584328693, -2.0040485874557943],
            [7.739808531779222, -1.992448178218884],
            [7.747749917816718, -1.9927324298352147],
            [7.747657138493751, -2.0032203460072764],
            [7.750186874015455, -2.005706728970953],
            [7.755913111649901, -2.0071344056234466],
            [7.7610987859272775, -2.0124815746843145],
            [7.772224684227296, -2.02020220944455],
            [7.779990921560956, -2.017362362991722],
            [7.789938242749101, -2.0123650610245547],
            [7.794106214400436, -2.00904858074331],
            [7.8017975166773885, -2.008272174509836],
            [7.801528437578295, -2.002088019849055],
            [7.797208422750237, -1.9989053963104577],
            [7.79720602127692, -1.9913654395207308],
            [7.801944448061594, -1.988187506904831],
            [7.802173946891485, -1.9838684638735504],
            [7.804427759775343, -1.9801137956723602],
            [7.803700539731278, -1.9771213218250303],
            [7.816687834106287, -1.971702308908897],
            [7.816297781928337, -1.9662331048860244],
            [7.821107738651794, -1.9656173604609533],
            [7.82315641178245, -1.9597116380221264],
            [7.8306143622280855, -1.961415768079964],
            [7.830661987709255, -1.9649113653158483],
            [7.834369065975447, -1.9668879705869704],
            [7.836178541755702, -1.9734218009270839],
            [7.842041631901276, -1.9777976729443376],
            [7.8448566698097, -1.9821610529229408],
            [7.8506012260174005, -1.9997550530301524],
            [7.850231493075552, -2.002199685340028],
            [7.853680319764765, -2.0153357535214083],
            [7.856170113123086, -2.0207725662088842],
            [7.861667527906691, -2.026213801259929],
            [7.8660237007036935, -2.0283931069377625],
            [7.8719443361805626, -2.0342929383468853],
            [7.876884844534655, -2.034297858640004],
            [7.877381084281024, -2.039291066149032],
            [7.884276383628066, -2.0404852942719516],
            [7.89113456929186, -2.043914650921717],
            [7.895296324722311, -2.0430076817207596],
            [7.898203658047662, -2.050031192807942],
            [7.906923755678466, -2.05901538625428],
            [7.922109633095835, -2.0659579411199007],
            [7.924602744523736, -2.0692140979915488],
            [7.9246487077330245, -2.082840290324231],
            [7.927182752068149, -2.095810157210257],
            [7.930266905799069, -2.10236292170846],
            [7.938970466054655, -2.104801363960463],
            [7.951425129541362, -2.1107234587176538],
            [7.96642306101607, -2.1079282618381048],
            [7.967780272776129, -2.1161736173932733],
            [7.969855676332238, -2.1160730781638253],
            [7.98639590301184, -2.157417092957915],
            [7.992250300687628, -2.1780379922936883],
            [7.998053190310191, -2.18762718940783],
            [8.007125168272136, -2.205240407938959],
            [8.007288027665494, -2.2157868374725207],
            [8.012829392648031, -2.212332735031746],
            [8.014966956916819, -2.2128990746469337],
            [8.017985406670055, -2.209009862877414],
            [8.021789398985963, -2.21390004053055],
            [8.023712228664609, -2.210547668728583],
            [8.029615344631107, -2.21046897178867],
            [8.028408250459707, -2.2200496199322863],
            [8.030350235180457, -2.224243528800266],
            [8.03003602539001, -2.236740110666126],
            [8.026720227112161, -2.2366181507583547],
            [8.02663462663971, -2.241015495921838],
            [8.036814606672678, -2.24155237047478],
            [8.043605682030488, -2.246978079681912],
            [8.043667923025248, -2.2637252928357134],
            [8.042249567214867, -2.263752615114149],
            [8.042211754656062, -2.2755886612814598],
            [8.039302554581472, -2.2795302677572193],
            [8.040778108026386, -2.289413735355417],
            [8.03581644456646, -2.2913294279366334],
            [8.033903543522696, -2.2890890370890675],
            [8.03679638363025, -2.274609621950068],
            [8.03485200328257, -2.271255460058494],
            [8.027373502349915, -2.272914343830296],
            [8.025918040006383, -2.272048072967807],
            [8.021508445871925, -2.2633671367803445],
            [8.018472407325236, -2.264381364823369],
            [8.01944492187179, -2.270059511527633],
            [8.021624626463653, -2.2725787022644015],
            [8.022410572977233, -2.2836470196217618],
            [8.019343687935443, -2.2851669536004238],
            [8.013801953684757, -2.2853177620167853],
            [8.01020877389199, -2.2839505845403094],
            [8.009018014254233, -2.2896463615379226],
            [8.011037082955605, -2.2931294035431455],
            [8.01122095978752, -2.2972339444487004],
            [8.008837842868743, -2.300880468658845],
            [8.009389601682816, -2.305430763039067],
            [8.013771628458535, -2.311542578292192],
            [8.012828945884964, -2.316219286349136],
            [8.007872531523455, -2.317660075288111],
            [8.000878946923741, -2.326042323092417],
            [7.993968153392785, -2.3279438326177706],
            [7.988468759030955, -2.334861878990119],
            [7.9846175448318135, -2.3427834093451927],
            [7.980734214974274, -2.3448798735299663],
            [7.975558843163107, -2.345588055244737],
            [7.9747919788234105, -2.3642792617415385],
            [7.979645695139489, -2.3645060194607823],
            [7.979765562631275, -2.369734135217564],
            [7.98207633188125, -2.369792030720873],
            [7.982029553579919, -2.3755726804256065],
            [7.980519114100186, -2.3800836408130706],
            [7.977940589176346, -2.3802538276700322],
            [7.978099804337926, -2.388108480680553],
            [7.974483383945928, -2.388021530066081],
            [7.974406894304054, -2.3848756873394623],
            [7.967070450703181, -2.384798681094139],
            [7.967119557390088, -2.382869567797444],
            [7.950295741331798, -2.3829641719963384],
            [7.950211567831573, -2.3821121972808856],
            [7.922116839554093, -2.371728869510782],
            [7.916882500347202, -2.3662202585496006],
            [7.912462508744018, -2.365988505492381],
            [7.8955339554154, -2.3553656274716457],
            [7.880067854576067, -2.3551046696297693],
            [7.841839689166732, -2.3351569793757743],
            [7.83053744841897, -2.3327335323918015],
            [7.809881477830738, -2.3322017783364575],
            [7.770823131359584, -2.330220698528164],
            [7.719143044892345, -2.327063724013323],
            [7.654975935919275, -2.3885685552077933],
            [7.645611217210688, -2.39792895060836],
            [7.636976213980495, -2.399323623941636],
            [7.6353270576048375, -2.3948819717422554],
            [7.62006356786438, -2.3438977931453624],
            [7.627295128031177, -2.3419065825942735],
            [7.630511751568108, -2.3462137074374136],
            [7.627833779625661, -2.2938000304590505],
            [7.6568228747237495, -2.2564099798848134],
            [7.660299411020774, -2.1739595070126776],
            [7.662134515085092, -2.166257803571785],
            [7.6584701977735, -2.1580708626082807],
            [7.663766455858789, -2.1327535882010986],
            [7.67456120298681, -2.105492042038353],
            [7.681751372451559, -2.098148455446336],
            [7.697168093997935, -2.053087529559866],
            [7.698621358722621, -2.047556020292809],
            [7.704360258451972, -2.016812752431013],
            [7.704058438432142, -2.0140191950792103],
            [7.7067503424252735, -2.010781462559745],
            [7.702134553205588, -2.005187816327326],
            [7.698861381828829, -2.0068261129003875],
            [7.698713390938057, -1.9995372217955014],
            [7.702678380675662, -1.998023097062104],
            [7.699627985810968, -1.9948402743519562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.78479850249431,
          "lat": 36.169509900776276
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47037"],
        "coty_name": ["Davidson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Davidson County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01639737"
      },
      "bbox": [
        7.62006356786438, -2.399323623941636, 8.043667923025248,
        -1.9597116380221264
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.931432445679763, -2.323397069749315],
            [5.981043749732336, -2.321204778440311],
            [6.085720320426376, -2.315193995391554],
            [6.085247339991035, -2.2937896934741535],
            [6.089783529985672, -2.2987193199820144],
            [6.093186895001784, -2.3048665204072813],
            [6.096979751918248, -2.3065458377338026],
            [6.099218251070995, -2.309858538356532],
            [6.109738771197322, -2.321567106982787],
            [6.119399686816826, -2.3244406123173795],
            [6.125034257815303, -2.327726835740879],
            [6.134885907419807, -2.335235410668076],
            [6.139281926477555, -2.3350188919750874],
            [6.142389885239096, -2.3389500242592893],
            [6.1497235484550075, -2.344893575629716],
            [6.150548739061953, -2.3495496502745357],
            [6.155373826467286, -2.3527467653678635],
            [6.15615865129848, -2.3578002115916252],
            [6.161381993540604, -2.362133161538634],
            [6.1684638884651966, -2.3736774570852637],
            [6.171639244401317, -2.375343052534405],
            [6.175584252871775, -2.3740490972218575],
            [6.180767645622984, -2.3748127704707205],
            [6.182394650228255, -2.38103935951217],
            [6.186307702879117, -2.3823585402858645],
            [6.192259861103648, -2.388865532460941],
            [6.199968984494972, -2.3887627750947074],
            [6.210401355712667, -2.3918340630385724],
            [6.213323938296899, -2.3904183757880473],
            [6.218061434664675, -2.3910252657235995],
            [6.221534326491064, -2.3937909482374846],
            [6.226703685398486, -2.393221732664846],
            [6.231933996061378, -2.394856342651035],
            [6.240615899151606, -2.395947905534548],
            [6.243113407954267, -2.393824087263871],
            [6.247503580231474, -2.3933309691744404],
            [6.253288164085681, -2.3973997985526507],
            [6.258232027400221, -2.397520238405556],
            [6.259243226157737, -2.4028812407877935],
            [6.263814524798213, -2.4067202961002496],
            [6.262075428372336, -2.4110755847909986],
            [6.263695259434093, -2.413241617070132],
            [6.268167834681831, -2.413463220250021],
            [6.270928284160652, -2.4174655417576356],
            [6.279251531879728, -2.423799000086484],
            [6.282695285420105, -2.4214669803584985],
            [6.2868800780244385, -2.424624354676913],
            [6.292304922574955, -2.4263038146168086],
            [6.293139019297574, -2.429109071753596],
            [6.298082606808958, -2.432585879134213],
            [6.303452629985827, -2.434605587646704],
            [6.3105465146993085, -2.438673813532386],
            [6.311288003147109, -2.4614522679729434],
            [6.3131061000221536, -2.5001035534667517],
            [6.31298724692673, -2.5018784122642925],
            [6.315187472815057, -2.5424043920619597],
            [6.31778215510619, -2.627907921664948],
            [6.318657130560113, -2.640669545152136],
            [6.318232588329134, -2.654580293918283],
            [6.31882736492591, -2.6620953526686573],
            [6.3189540161715145, -2.6785899882302004],
            [6.320303593900206, -2.7126332358572776],
            [6.277067536878686, -2.714636309408578],
            [6.17506695477562, -2.7183312721667177],
            [6.152023424599, -2.7190709766818775],
            [6.1507039763224585, -2.7158458125294134],
            [6.143684578646441, -2.710840788534984],
            [6.138518075435717, -2.709414060582514],
            [6.137777405646284, -2.706776355179014],
            [6.133517489313407, -2.705312165391079],
            [6.132319279133219, -2.7029116029211933],
            [6.124932286197851, -2.704551096578742],
            [6.12130196904984, -2.6989891664850356],
            [6.109569439859639, -2.692316193528873],
            [6.108391976415347, -2.6871754258463474],
            [6.099611334139095, -2.6893180725263903],
            [6.099763499721799, -2.691991534621213],
            [6.092060581641799, -2.692659672913265],
            [6.087605501105909, -2.6915470540404822],
            [6.087371068275924, -2.68832170233338],
            [6.076956851251911, -2.688876982863271],
            [6.0764560619898855, -2.682298195179192],
            [6.066247765586561, -2.6825195261485226],
            [6.063957980729418, -2.6752584491663685],
            [6.063040835384605, -2.6678559846980794],
            [6.059454984812922, -2.6701672520801645],
            [6.054404380514332, -2.671114068805336],
            [6.04971580035713, -2.674611523680275],
            [6.044932468799465, -2.6756381594340843],
            [6.042995347094966, -2.673856466759419],
            [6.035785906050879, -2.6745910868530327],
            [6.032967852175806, -2.676556808474412],
            [6.029666110888409, -2.674204360006864],
            [6.027651375546712, -2.669792886029716],
            [6.022534630394171, -2.6677646736090908],
            [6.017979907899425, -2.6683888744915625],
            [6.008040228113384, -2.6637960245714614],
            [6.004199884094942, -2.6651487588919367],
            [5.995821423144168, -2.6657604673021846],
            [5.992055314682913, -2.665091747120822],
            [5.989813077229417, -2.6564304958665717],
            [5.991560079582365, -2.6547694394833745],
            [5.986766946199527, -2.6483994790391474],
            [5.985260361687827, -2.6419760548968854],
            [5.98124268635057, -2.638466622807291],
            [5.973394709786128, -2.6285104071690513],
            [5.972728944045746, -2.6244214040757603],
            [5.974945885366138, -2.6208809136583726],
            [5.972421700229949, -2.618550686444506],
            [5.971845085696041, -2.6134484137652905],
            [5.975865548950624, -2.6070137658292722],
            [5.968634795279007, -2.589131727874344],
            [5.964337209405189, -2.5703615881349995],
            [5.963436636495909, -2.560535317504415],
            [5.957418491192601, -2.559067570763826],
            [5.953522889588457, -2.560243335491854],
            [5.950308951698472, -2.554641409976653],
            [5.946602337056546, -2.5556819061948635],
            [5.940513307823538, -2.5515806254324476],
            [5.937848060363116, -2.5534494501820895],
            [5.932902526388626, -2.549477595623722],
            [5.928362030711761, -2.5480772952527215],
            [5.927923959209307, -2.544905330859389],
            [5.923220405001903, -2.5433446054960984],
            [5.923304479554554, -2.5360077471768547],
            [5.918828848485727, -2.531480684595994],
            [5.913328200879217, -2.524276210609533],
            [5.905856070812588, -2.5217573705694507],
            [5.906277984575955, -2.5157629663948295],
            [5.911448988584535, -2.512391368670317],
            [5.923311996061706, -2.5093539912581684],
            [5.929821658076275, -2.506479332143588],
            [5.932638272686567, -2.5035564002838235],
            [5.936885613308251, -2.503465104851065],
            [5.936140824232487, -2.4710347157031887],
            [5.9346676673399905, -2.4247466493314613],
            [5.936298163916595, -2.424664570745814],
            [5.936420901689627, -2.4169151577625394],
            [5.934367522872053, -2.4162613392170993],
            [5.933357761517661, -2.394297928732295],
            [5.931432445679763, -2.323397069749315]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.93265574624537, "lat": 35.99652169965789 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47053"],
        "coty_name": ["Gibson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gibson County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01639745"
      },
      "bbox": [
        5.905856070812588, -2.7190709766818775, 6.320303593900206,
        -2.2937896934741535
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.757579104899267, -2.0338594463861477],
            [5.793652578752229, -2.0273408889253957],
            [5.810529819623169, -2.02679133258775],
            [5.864346271386023, -2.0238536171702575],
            [5.93904371245615, -2.0205257737854603],
            [6.004914624392885, -2.0163679619789665],
            [6.060699831849336, -2.013036192839508],
            [6.112280349034717, -2.009168320905965],
            [6.124192274368445, -2.0087963820106847],
            [6.131943040538618, -2.0074642795834277],
            [6.163555999259991, -2.004613974938797],
            [6.169566674355, -2.0042194827302957],
            [6.170291850015861, -2.0113011865693466],
            [6.174469830140915, -2.018797259483801],
            [6.177157095124299, -2.028041896203915],
            [6.179923683016163, -2.029301660655313],
            [6.182558751574044, -2.035664492771484],
            [6.185148466492901, -2.084308801091177],
            [6.185228162958489, -2.0962367586492467],
            [6.183210239641097, -2.095614484985947],
            [6.166073791141381, -2.0960236821324645],
            [6.161112957910037, -2.095598458872804],
            [6.15832923674244, -2.0993722706578186],
            [6.154035153740816, -2.099796728905837],
            [6.149159877553969, -2.1036516473467985],
            [6.145945611215204, -2.1085690670869686],
            [6.143087558966151, -2.108213213139329],
            [6.131327085591854, -2.1183488432606814],
            [6.127028905239225, -2.1166739074233525],
            [6.124171882195889, -2.1179975327191074],
            [6.119100973698859, -2.1173298881182108],
            [6.118275837903523, -2.114340591477825],
            [6.113015348156407, -2.1133144654806997],
            [6.108303169806959, -2.106229043479107],
            [6.09849562172306, -2.10578605289466],
            [6.0963435380256294, -2.103450786813403],
            [6.091650736961144, -2.1057343798173345],
            [6.086337487379063, -2.1031889672734647],
            [6.084462505350973, -2.1066858137175677],
            [6.08147629370079, -2.10270663030095],
            [6.078981121018327, -2.10570314984732],
            [6.08371958073657, -2.238442598627499],
            [6.085247339991035, -2.2937896934741535],
            [6.085720320426376, -2.315193995391554],
            [5.981043749732336, -2.321204778440311],
            [5.931432445679763, -2.323397069749315],
            [5.858517997942544, -2.3261016632439917],
            [5.841165599547811, -2.327076060274957],
            [5.784706609464943, -2.3293278377985525],
            [5.67242648775545, -2.333419820602703],
            [5.668915884409067, -2.3337972730994943],
            [5.666073710649155, -2.3256298884678],
            [5.6767971777840565, -2.3197933999197184],
            [5.687852998932661, -2.3179711426118996],
            [5.691993049015889, -2.3160581939079803],
            [5.698543179435781, -2.3075175232059015],
            [5.708818300131895, -2.2834552717647423],
            [5.714051556637415, -2.2635546776640885],
            [5.71659585893168, -2.2499757389545056],
            [5.72459278522764, -2.2278260320044643],
            [5.72462715143057, -2.222603300896975],
            [5.72646263873488, -2.2175789544240216],
            [5.726280317734598, -2.2095794894389744],
            [5.721403867293305, -2.190087852095132],
            [5.722268224877142, -2.189234066231581],
            [5.7389631199137305, -2.162689908687897],
            [5.753024958050018, -2.1291731074079623],
            [5.745812615919574, -2.114403190917987],
            [5.744014116033977, -2.1045092016924465],
            [5.74612463927369, -2.0908834794659494],
            [5.749753849577577, -2.08165962792366],
            [5.760834223865053, -2.066604145570647],
            [5.7641019679235335, -2.059737652470198],
            [5.760835321473441, -2.051762727408003],
            [5.758437076903327, -2.035791694609503],
            [5.757579104899267, -2.0338594463861477]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.14874964967152,
          "lat": 36.358210885828065
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47131"],
        "coty_name": ["Obion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Obion County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01639779"
      },
      "bbox": [
        5.666073710649155, -2.3337972730994943, 6.185228162958489,
        -2.0042194827302957
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.454289322077781, -6.001206821668548],
            [-5.400535111826968, -6.004485745086568],
            [-5.3970108692620045, -6.004464500510978],
            [-5.236960669976122, -6.015896550241915],
            [-5.076908203598467, -6.027296927475496],
            [-4.981013118821184, -6.034054115033404],
            [-4.962124781750885, -6.034993442935843],
            [-4.959602062356346, -6.035571581478904],
            [-4.877757505500935, -6.040895027431478],
            [-4.874472220083576, -6.040851836950853],
            [-4.740206569817512, -6.049830167228904],
            [-4.741563933773445, -6.072933161545371],
            [-4.750078751808943, -6.197609309036262],
            [-4.7533722295316405, -6.248904340860234],
            [-4.762932865939298, -6.395105908972584],
            [-4.769036928788125, -6.4850199937146575],
            [-4.832789848218994, -6.480657875756909],
            [-5.015749422299068, -6.468409937003596],
            [-5.185960879205823, -6.4568913253680105],
            [-5.263534375589211, -6.452343341606733],
            [-5.265516393910966, -6.450842623440753],
            [-5.320113147774251, -6.4469430058522885],
            [-5.486479352041963, -6.4348999438197945],
            [-5.482219678779652, -6.3771737526338415],
            [-5.472909538554184, -6.251877500546622],
            [-5.468178720845662, -6.188199753156977],
            [-5.454289322077781, -6.001206821668548]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.63774215344806,
          "lat": 32.305029298305065
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48003"],
        "coty_name": ["Andrews"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Andrews County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01383787"
      },
      "bbox": [
        -5.486479352041963, -6.4850199937146575, -4.740206569817512,
        -6.001206821668548
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5737386257866532, -9.489955915142966],
            [0.6017026051300111, -9.461321836949814],
            [0.5967139134445751, -9.457501721542494],
            [0.6401168468886261, -9.41267622345344],
            [0.6521883354476418, -9.424208918143961],
            [0.6792905448548122, -9.396281724769995],
            [0.7492229691244215, -9.420703043613871],
            [0.7559387828125463, -9.421307109848664],
            [0.7565313461498869, -9.423543422327105],
            [0.7651032101609859, -9.429104022792725],
            [0.7667388699089911, -9.42570023934331],
            [0.7763149538975873, -9.425733214643406],
            [0.7772703546390558, -9.4234528494551],
            [0.7854147105264858, -9.427333753387707],
            [0.7917845756895446, -9.424361828381933],
            [0.793812393789718, -9.418980777113067],
            [0.7934877049012384, -9.41505146870885],
            [0.7880877656332406, -9.410725673269488],
            [0.7901825501887854, -9.407286789008221],
            [0.7985833570187886, -9.40096004294804],
            [0.8010102682736678, -9.396796504744374],
            [0.806461036455321, -9.39124178237098],
            [0.8129582394753898, -9.392784113023382],
            [0.8206372175968294, -9.392859343542789],
            [0.8220777210505426, -9.385816393087307],
            [0.8237413397728393, -9.383556655212741],
            [0.8289683213609166, -9.38134949425361],
            [0.8309966694866853, -9.377647981087915],
            [0.8276495401029439, -9.370716904302428],
            [0.82970786887376, -9.368110924166226],
            [0.8351084779544314, -9.365991216608016],
            [0.8338542436922897, -9.36280980136779],
            [0.8294819326847366, -9.359900387652914],
            [0.8316801293691662, -9.355709433556466],
            [0.8335496945111739, -9.345020066184373],
            [0.8364769209188352, -9.337217832641956],
            [0.8408525023200933, -9.33140840396258],
            [0.8481982403728929, -9.33059275741946],
            [0.8580063293854221, -9.325901590015938],
            [0.8559790548940572, -9.318588677023882],
            [0.8594732061797375, -9.313524759188896],
            [0.8541020422395473, -9.301799834111682],
            [0.8505721405895751, -9.298722900395328],
            [0.8505810662302914, -9.296191955557257],
            [0.8541894685720408, -9.292748353189461],
            [0.8556287427288221, -9.28643238157824],
            [0.8551489825621007, -9.283380566367823],
            [0.9318085171802811, -9.282068138936925],
            [0.9451714312452735, -9.224439403578529],
            [0.9643264372076256, -9.142620440620796],
            [0.9705494813028818, -9.139655064775075],
            [0.9820816358356234, -9.141027181442254],
            [0.9885840657271341, -9.140114697842638],
            [0.9912815301787316, -9.141097090387932],
            [0.9957319580015537, -9.137135677154301],
            [1.0061010786524096, -9.134487735001606],
            [1.0130444300256658, -9.137967911310675],
            [1.0195568107137714, -9.137704701196252],
            [1.0229508039366095, -9.135861103689008],
            [1.0263349518032368, -9.137150842218277],
            [1.03197084628491, -9.137017966789724],
            [1.037025410295121, -9.129884079052118],
            [1.0397604070967221, -9.128756269103407],
            [1.0442131890180204, -9.123714543959183],
            [1.0527619189518014, -9.12583637737111],
            [1.0594811685358225, -9.124521744728959],
            [1.0638084007186583, -9.12742492068385],
            [1.077859723132683, -9.125862359181939],
            [1.082666480794468, -9.124034479752021],
            [1.087207731467086, -9.124575544020281],
            [1.0925768462880867, -9.127394413259577],
            [1.1015596065406603, -9.127542709517392],
            [1.1056752163650152, -9.12897086839508],
            [1.1052629602890833, -9.134921064175728],
            [1.1061620629977107, -9.140893612571102],
            [1.10809678844584, -9.143759278570531],
            [1.1075077061182086, -9.147457000204419],
            [1.1138531051683889, -9.160874690601329],
            [1.1117490544904083, -9.164361710201597],
            [1.112637071633827, -9.167639854850702],
            [1.1230564064013087, -9.165247990215562],
            [1.1233282148956474, -9.161858095180538],
            [1.1266945760340368, -9.160195372088701],
            [1.1302526129104045, -9.164340874099045],
            [1.1346649016493515, -9.161469822889313],
            [1.1436568170948567, -9.162040087152278],
            [1.1453276217538622, -9.165580141165668],
            [1.1315029772442935, -9.254733640127924],
            [1.18789067172897, -9.348574234496484],
            [1.1911891410750162, -9.35461932603829],
            [1.209854040553437, -9.38501016649825],
            [1.2455866416643453, -9.44412083650208],
            [1.270024049945119, -9.484988662242651],
            [1.2742506843493966, -9.492771044551082],
            [1.2873602090325096, -9.514759636092153],
            [1.285064098573287, -9.51515160622],
            [1.2669412258208843, -9.525996539521536],
            [1.252500731482944, -9.537908243667284],
            [1.2468340077252411, -9.5398966541708],
            [1.239386838062868, -9.540296706031084],
            [1.2430583907378847, -9.532746313532616],
            [1.2407951733016056, -9.523973141412592],
            [1.236130242716414, -9.516224939548433],
            [1.2313988384138905, -9.518435575516573],
            [1.2264734853720025, -9.518890357484645],
            [1.2200896807622241, -9.524031613774273],
            [1.216784998582811, -9.521021706850108],
            [1.2057653871980183, -9.519380975495507],
            [1.2001729869627853, -9.520964651102533],
            [1.1986475547945532, -9.524454117402412],
            [1.1999309499309068, -9.528635471913963],
            [1.2044015705210669, -9.529311768541515],
            [1.206486877789072, -9.536419742155825],
            [1.2029749639650702, -9.543844769245457],
            [1.2034656797307135, -9.55212315209134],
            [1.2015468459202814, -9.558173653653215],
            [1.2021175781839402, -9.563895683121096],
            [1.1979035504629436, -9.568944015327997],
            [1.1983571878434944, -9.573132631799487],
            [1.191788433951546, -9.593849624146012],
            [1.192067424982886, -9.601825266884736],
            [1.196377756949706, -9.60741412056417],
            [1.1977736764416327, -9.612414295705676],
            [1.2017275420780056, -9.612891047944744],
            [1.2068559841128452, -9.616835653974704],
            [1.2116987598276143, -9.62354353517816],
            [1.215155291887159, -9.626377322477698],
            [1.2178112912007577, -9.632593745845032],
            [1.2238464990943405, -9.633255661334028],
            [1.2297344340806549, -9.637524542765185],
            [1.2302588268642656, -9.643270028192578],
            [1.2118878672108238, -9.658645971135549],
            [1.1726932638393726, -9.688861968564911],
            [1.1189887434165062, -9.734459893330781],
            [1.1012416221821761, -9.751763973482221],
            [1.0889948504605682, -9.765256255057023],
            [1.0816203726697764, -9.775896345582618],
            [1.0593023669688697, -9.790562739233753],
            [1.041797198163924, -9.804401996209164],
            [1.009701612568713, -9.834203473846177],
            [1.0067923853152259, -9.835451124572188],
            [1.0042336571482495, -9.84253291996834],
            [0.9971606831122968, -9.844829910318804],
            [0.9758047987485559, -9.853057954987076],
            [0.9577715231527728, -9.853059904658101],
            [0.9346062094619874, -9.863744181049048],
            [0.8961004569818817, -9.88686711035919],
            [0.8987829497186679, -9.884027226253938],
            [0.8988786652867158, -9.875096885225],
            [0.8947897918674922, -9.87550243621236],
            [0.8824110684860065, -9.879385229084573],
            [0.8757074617793345, -9.883494446314193],
            [0.8688645584423124, -9.879776748675742],
            [0.8641580120481638, -9.880078508891788],
            [0.8583846462701609, -9.88387404568579],
            [0.8545932531447928, -9.882387622399458],
            [0.8431987268949758, -9.883030649807695],
            [0.8377873721025649, -9.880061437279307],
            [0.8330631422432003, -9.873333068123202],
            [0.8355196134174774, -9.86073727096495],
            [0.8327826735511362, -9.8536737853244],
            [0.8274687233626408, -9.851185098840661],
            [0.8259252127228202, -9.84723767065414],
            [0.8198928423990346, -9.841939594906895],
            [0.8122575775716726, -9.837102122731615],
            [0.8046456714800815, -9.830914771999689],
            [0.800014173771677, -9.828781432862298],
            [0.7940534969154291, -9.820281777981961],
            [0.787483102669907, -9.81669196510649],
            [0.7850412225063504, -9.8166215736719],
            [0.7814869503158124, -9.810469086903794],
            [0.7778603257708515, -9.810468861160757],
            [0.7745209417437752, -9.804601446701604],
            [0.7748804050039735, -9.802075955049657],
            [0.772151165404033, -9.79702570442161],
            [0.769565917137434, -9.795247935123252],
            [0.7688122918152034, -9.788917709142611],
            [0.7715404855769779, -9.780026561909999],
            [0.774089832835611, -9.775901245729441],
            [0.7709657867839149, -9.772343818738328],
            [0.7659395768367602, -9.763487770557067],
            [0.7533729663655083, -9.758437016021796],
            [0.7483221334708775, -9.751034236485904],
            [0.744445265743681, -9.749580508625778],
            [0.740723255757885, -9.754777375481337],
            [0.7348621664079896, -9.750671967329891],
            [0.7295736116660106, -9.749796943333866],
            [0.7272817703901592, -9.745892220870498],
            [0.7217382304291141, -9.746813981459939],
            [0.6696448169682135, -9.748196352134293],
            [0.6649026948790964, -9.742967898767281],
            [0.6657512730937268, -9.737917809792007],
            [0.6690545962058924, -9.736015800507293],
            [0.6647336621712379, -9.730819444034834],
            [0.6676391948957783, -9.727181745106208],
            [0.6632626301495069, -9.72156777032474],
            [0.6591769980917498, -9.721311507244593],
            [0.6578361107843548, -9.718992120493281],
            [0.662726205570108, -9.711250087584142],
            [0.6571391058972434, -9.707484270341647],
            [0.6550733612209119, -9.696061530499032],
            [0.6577770493843067, -9.693290453177875],
            [0.6575845543476987, -9.689994224315575],
            [0.6532839675498985, -9.688834191870527],
            [0.6527203366074434, -9.686209286628017],
            [0.6567848207548328, -9.681952054591745],
            [0.6526608124628582, -9.678609372382846],
            [0.6528749294869614, -9.673921485169664],
            [0.6586093341258409, -9.672214638315632],
            [0.6600762195929898, -9.664597819325714],
            [0.6644927633373866, -9.66498922806977],
            [0.6670420599004785, -9.662605779474978],
            [0.6693168201921794, -9.656530713806827],
            [0.6614964538703851, -9.652627683787633],
            [0.6554558847343868, -9.65150803656991],
            [0.6458640675549113, -9.645994190593413],
            [0.6429457302825135, -9.642893031662803],
            [0.6408527368401933, -9.637043958008704],
            [0.6379585105968594, -9.637639973716487],
            [0.6335074368836328, -9.626982710844633],
            [0.6231421131846727, -9.628043107775293],
            [0.6193184339295253, -9.62687021428682],
            [0.6138247883295876, -9.627882906643418],
            [0.6020150689227962, -9.618614304756822],
            [0.6008561861172699, -9.61125280316395],
            [0.5980791558606572, -9.610408126137566],
            [0.602925665202849, -9.602750859987086],
            [0.6015094391725835, -9.601373995502621],
            [0.6029944514253136, -9.593833111843816],
            [0.6057694383517566, -9.588245385977443],
            [0.6050775480923564, -9.581449473185426],
            [0.6035875340953664, -9.578132643531953],
            [0.596479303296567, -9.570216566156473],
            [0.5942281303581516, -9.566624681499627],
            [0.5956618396210345, -9.563566943979248],
            [0.5946673033276999, -9.55868313351022],
            [0.597432932458069, -9.551496349171526],
            [0.6039585099215431, -9.549739601794064],
            [0.6020547571429665, -9.54528470951882],
            [0.6049645436692819, -9.542281187915762],
            [0.58795891881245, -9.525800054850816],
            [0.5994174617096343, -9.514585404752356],
            [0.5737386257866532, -9.489955915142966]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.45208221383984, "lat": 29.18983736139677 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48039"],
        "coty_name": ["Brazoria"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brazoria County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01383805"
      },
      "bbox": [
        0.5737386257866532, -9.88686711035919, 1.2873602090325096,
        -9.123714543959183
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.22782052009484155, -5.332673506673921],
            [-0.1742656757332063, -5.334813626371796],
            [-0.0783765051993233, -5.338071903607002],
            [-0.042142512974034124, -5.339102767645381],
            [-0.0193979447354277, -5.339477452833335],
            [0.005376784226523046, -5.340246352044076],
            [0.0942497757648145, -5.341555221023375],
            [0.11158030147843603, -5.342192609003224],
            [0.1364005183862347, -5.34220892313881],
            [0.1448320714169376, -5.342743581429484],
            [0.14468982669105743, -5.399585955920272],
            [0.18834211561240288, -5.393448146762463],
            [0.2186427846135704, -5.389007120227957],
            [0.21852319635547543, -5.471201913333903],
            [0.21829475853958802, -5.532946895098575],
            [0.2175614322876276, -5.601033757827554],
            [0.21712316662415224, -5.666068861282659],
            [0.21688183266369576, -5.676654890085293],
            [0.21645098226281986, -5.736739535511957],
            [0.21597251762105096, -5.759843970814993],
            [0.21098031330716419, -5.760028524528447],
            [0.17875664755745874, -5.759511223570729],
            [0.139437917498861, -5.7591475392137825],
            [0.13281815807577121, -5.759377618158896],
            [0.0986368956108234, -5.759040001672405],
            [0.09366909461642256, -5.758760755313043],
            [0.03276872716603575, -5.7579518157936125],
            [-0.022895209726145862, -5.756624842879898],
            [-0.12912914242597479, -5.7540844455623805],
            [-0.23985863580671613, -5.751430735459662],
            [-0.23686479016698797, -5.645069193527259],
            [-0.23637075272341448, -5.619663859914277],
            [-0.23531055019557343, -5.586133158914377],
            [-0.23430349258441707, -5.542215861319835],
            [-0.23292187399289957, -5.507987719849336],
            [-0.233125112037159, -5.506635209010549],
            [-0.23031081357960065, -5.416499701761254],
            [-0.230012508876199, -5.401150864707375],
            [-0.22782052009484155, -5.332673506673921]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.57241525518299, "lat": 33.18799807156143 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48085"],
        "coty_name": ["Collin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Collin County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01383828"
      },
      "bbox": [
        -0.23985863580671613, -5.760028524528447, 0.2186427846135704,
        -5.332673506673921
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5450940437990932, -9.106018897619931],
            [-1.518415127072122, -9.095102608100087],
            [-1.5074552429591543, -9.090066191670111],
            [-1.4811513385426502, -9.07929745526124],
            [-1.44955870340697, -9.067041520654765],
            [-1.376924254116823, -9.034574883194418],
            [-1.3510703429234359, -9.022510736953539],
            [-1.313804669083138, -8.991145661575906],
            [-1.2820945324274189, -8.964865065085423],
            [-1.2708971996949678, -8.956048314209184],
            [-1.2214562275207086, -8.903207311187572],
            [-1.1612264550768852, -8.853676669543313],
            [-1.1586847629029149, -8.859352792807963],
            [-1.151264981279333, -8.855778158598989],
            [-1.1448982128862735, -8.863215054989652],
            [-1.1444147612806086, -8.868140629717965],
            [-1.1384481494570282, -8.868814292453491],
            [-1.1352417832420307, -8.873066072874364],
            [-1.1345471469584028, -8.879280001179666],
            [-1.1291849118784676, -8.883678431653085],
            [-1.129875508102003, -8.886711010551506],
            [-1.1336835498508526, -8.888024550809673],
            [-1.1311904545456, -8.891645047302008],
            [-1.1321498749620207, -8.896218893411424],
            [-1.136115844910651, -8.900734018116104],
            [-1.1337369498325263, -8.903560142898783],
            [-1.1338584274914942, -8.912534932493951],
            [-1.1270468610605513, -8.917189603459969],
            [-1.1234504470608278, -8.916383079054025],
            [-1.1233648799717677, -8.921872115760259],
            [-1.1254920348899122, -8.927256598244378],
            [-1.1222219481268563, -8.930354054980217],
            [-1.1163883790649822, -8.929184409375322],
            [-1.114290407133616, -8.922591010156957],
            [-1.1121667342413843, -8.921688916505698],
            [-1.109848990106893, -8.927304943160825],
            [-1.1105857639130192, -8.931266488043722],
            [-1.104632881982579, -8.93245326616151],
            [-1.102458299073609, -8.93504581091733],
            [-1.1072953201658002, -8.937482823079929],
            [-1.1019926855853894, -8.94476276960728],
            [-1.0979372461232675, -8.946129854810598],
            [-1.0986535922452934, -8.952804123073545],
            [-1.1009651577432122, -8.958213612605414],
            [-1.0944914028348145, -8.959637587728343],
            [-1.0918458729472442, -8.957849266273643],
            [-1.0915455904466216, -8.95271346395356],
            [-1.0860484663099579, -8.951267639678093],
            [-1.0819391600144834, -8.952569650626284],
            [-1.08174183108118, -8.959502933485286],
            [-1.0802879687877034, -8.96397811848544],
            [-1.0759762890831248, -8.970040037095313],
            [-1.0711253633684017, -8.970551434336413],
            [-1.0734689659397332, -8.979296545428046],
            [-1.064524823480014, -8.986808489324495],
            [-1.0669598264441593, -8.990360580576414],
            [-1.0712819312291169, -8.992913248189335],
            [-1.0669724784223658, -8.998982654687024],
            [-1.0628805527239826, -8.997232109862805],
            [-1.0609679965039907, -8.994365290559506],
            [-1.0553298322909128, -8.997624772225604],
            [-1.0520121597848144, -9.000979110583971],
            [-1.0452801662488067, -8.999512789793231],
            [-1.0433065502978711, -9.006739275728373],
            [-1.0442886613785947, -9.01035344752138],
            [-1.0498589906389606, -9.013329146001563],
            [-1.0452575457215343, -9.015968968561593],
            [-1.0433774879847157, -9.020999356280296],
            [-1.0316589950003983, -9.026820876957022],
            [-1.031502390592098, -9.03021508130893],
            [-1.022702366126233, -9.03095312146602],
            [-1.0198367482455528, -9.028797481583368],
            [-1.0158903466139717, -9.031304258404893],
            [-1.0177069594510098, -9.035340264104196],
            [-1.0157068593904657, -9.041964467313825],
            [-1.013238491535891, -9.044052495935572],
            [-1.005422450163282, -9.040284298677545],
            [-1.002538858271995, -9.04011459177617],
            [-0.999926738904539, -9.045242154048932],
            [-0.9959212903328932, -9.049089602758604],
            [-0.9918770263264887, -9.044702932401082],
            [-0.9809833360892876, -9.04602922358673],
            [-0.9769528353758367, -9.049788231148668],
            [-0.9716288910870999, -9.045340648368418],
            [-0.9685748263553494, -9.050947931648613],
            [-0.9713975334516327, -9.051295723284383],
            [-0.9726542423564651, -9.05684368883669],
            [-0.9676085074377991, -9.058901325597773],
            [-0.958683049537312, -9.058573496933569],
            [-0.9531237989126958, -9.059855486462666],
            [-0.9550585603129877, -9.063388345239957],
            [-0.9805873817317612, -9.100445948009078],
            [-1.0393897350684884, -9.185221347378844],
            [-1.0563184272090667, -9.209289273470032],
            [-1.062865161106052, -9.220773402202923],
            [-1.1015944607654085, -9.275226097195091],
            [-1.1403329594650709, -9.329660162960792],
            [-1.1808455131934985, -9.328436126648393],
            [-1.2411273732468262, -9.32605029953269],
            [-1.3389660330990765, -9.323116906172837],
            [-1.3531714673676423, -9.322556996135118],
            [-1.3783083411317405, -9.335751372698068],
            [-1.3797903475181699, -9.330709281540814],
            [-1.386171363426863, -9.323014337529498],
            [-1.3834628705798753, -9.318169689447304],
            [-1.3891071108408792, -9.310834622197508],
            [-1.390785292734055, -9.303810652529096],
            [-1.3896021162513454, -9.300528787193755],
            [-1.3922960705042962, -9.296375594447118],
            [-1.390367709394661, -9.290825360928926],
            [-1.3951209848732966, -9.287303372582075],
            [-1.3920685721036266, -9.283674788850924],
            [-1.3966171571638755, -9.270153719307672],
            [-1.39295935781429, -9.268960509881241],
            [-1.3956629788770938, -9.263718551864878],
            [-1.3948995005513025, -9.260298465085443],
            [-1.3900382049958397, -9.256840687495973],
            [-1.3830546693246841, -9.25539666913551],
            [-1.3833333416726596, -9.253351148956142],
            [-1.388165447521206, -9.24762972328172],
            [-1.3870623839945033, -9.244195075953193],
            [-1.382309238926792, -9.244964241291326],
            [-1.3793696310958958, -9.238792919229365],
            [-1.3804973734534733, -9.23408184961992],
            [-1.3860517978310065, -9.22703793646607],
            [-1.3837351707203358, -9.225257671870686],
            [-1.3887910354255573, -9.22011194175166],
            [-1.395662501877407, -9.22337575708856],
            [-1.4012248572972064, -9.220808634861411],
            [-1.4028368977981729, -9.224209468212878],
            [-1.4079285307058256, -9.226527549998977],
            [-1.407958853669292, -9.222493868218704],
            [-1.4128751119078193, -9.224302205398427],
            [-1.420601006746913, -9.223850436582776],
            [-1.422458622745438, -9.22201080609102],
            [-1.423989358133747, -9.21488748429792],
            [-1.4234145382702788, -9.20595409212981],
            [-1.4345881750764988, -9.204532616781172],
            [-1.4340313464779064, -9.209042685278167],
            [-1.4316814374595566, -9.214630907753575],
            [-1.4363151770631828, -9.216828400033808],
            [-1.4403462817328905, -9.213411584969615],
            [-1.4423038177697909, -9.208794676926845],
            [-1.4420298926317432, -9.20504199989802],
            [-1.4390121216606602, -9.199990979485717],
            [-1.4419514756218437, -9.196089059067182],
            [-1.442730067236208, -9.192376375485695],
            [-1.4463230197189316, -9.191056268859683],
            [-1.449413203121565, -9.192318798603992],
            [-1.4502871040856886, -9.188120920783694],
            [-1.4476970014678379, -9.18646286248289],
            [-1.4545160054905935, -9.179577222489426],
            [-1.4669729828566396, -9.177533195270566],
            [-1.466503947617892, -9.174555748591391],
            [-1.4687147277323347, -9.169859338947276],
            [-1.4694167230366366, -9.163123668170849],
            [-1.4751332764452212, -9.158081105495345],
            [-1.468865266225123, -9.157806289186366],
            [-1.468536170340642, -9.153793246875724],
            [-1.4726380815196582, -9.15200959764991],
            [-1.475803786225687, -9.154697763667809],
            [-1.4779154435347974, -9.147564367853033],
            [-1.4870810477321008, -9.144355625359884],
            [-1.4916934407077052, -9.145902380112028],
            [-1.4944525142050655, -9.151314518322945],
            [-1.5007603974975419, -9.146500970860226],
            [-1.5019509603300343, -9.150813842673891],
            [-1.500083520136347, -9.155249751673244],
            [-1.4967058662461932, -9.156813328409557],
            [-1.4967833090670877, -9.16000054857925],
            [-1.5018763796476926, -9.15960163766039],
            [-1.5110256656464522, -9.154976560926526],
            [-1.5138238640654387, -9.149442836886948],
            [-1.5184442611811337, -9.149457018590184],
            [-1.522836072160871, -9.147264957483188],
            [-1.5263999263823964, -9.140779010903799],
            [-1.5317275488858986, -9.13885253457849],
            [-1.5346834159173772, -9.139232415194094],
            [-1.5361341243678426, -9.133502445632475],
            [-1.538684575478734, -9.128784133389072],
            [-1.5385997283474013, -9.125752667814643],
            [-1.5413136205183147, -9.121755230578037],
            [-1.5394141189558912, -9.115773973886425],
            [-1.5461641780479982, -9.109568354279368],
            [-1.5450940437990932, -9.106018897619931]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.94867188213001,
          "lat": 29.583010146677747
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48187"],
        "coty_name": ["Guadalupe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Guadalupe County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "01383879"
      },
      "bbox": [
        -1.5461641780479982, -9.335751372698068, -0.9531237989126958,
        -8.853676669543313
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.6113324449475983, -7.592949699810976],
            [-2.608753123583619, -7.55872364619691],
            [-2.599100798608266, -7.28915558549037],
            [-2.594774720122488, -7.19055027951073],
            [-2.5838451458974463, -7.193498440171529],
            [-2.569849861036156, -7.189789546191672],
            [-2.5626878545431335, -7.193171317876166],
            [-2.5559632717581593, -7.194937382450496],
            [-2.552747776326512, -7.197755891145953],
            [-2.5460484790825992, -7.20063846473727],
            [-2.5398160801064678, -7.201092162634333],
            [-2.5381649587168074, -7.20477714320004],
            [-2.537826745761633, -7.214075670784952],
            [-2.5347200532165504, -7.224058966762787],
            [-2.5312074591508265, -7.231761537741112],
            [-2.526721150855534, -7.238482008874496],
            [-2.5247210761185106, -7.2526145197596685],
            [-2.522403707632124, -7.259469708777673],
            [-2.51822277871895, -7.259696736200359],
            [-2.5145510773303634, -7.247039192822429],
            [-2.5080431778461567, -7.24126706339267],
            [-2.504136705808461, -7.241186420493848],
            [-2.5000558244277062, -7.244986448418698],
            [-2.4979005852875527, -7.248891527624466],
            [-2.4927517231169314, -7.25359386331212],
            [-2.492410184442423, -7.2598491642996],
            [-2.490921094425837, -7.262325613905806],
            [-2.4862032754396157, -7.264538448999323],
            [-2.4838676417210643, -7.261148464530447],
            [-2.4844844070757732, -7.2559973404085],
            [-2.4787911352579837, -7.25408787102828],
            [-2.4706016541297022, -7.2463927209232795],
            [-2.4564329700724565, -7.241398695083803],
            [-2.455198365960318, -7.237857495833775],
            [-2.4642929398243405, -7.236670704194687],
            [-2.466971040225831, -7.229431963082184],
            [-2.466363975002904, -7.217678080887307],
            [-2.461937791560746, -7.21255230244201],
            [-2.4587160505961805, -7.212438903158811],
            [-2.453851815630599, -7.217569741415936],
            [-2.447587474542702, -7.222535022939529],
            [-2.4388853911916666, -7.22672069765751],
            [-2.4328819792676337, -7.226321791063607],
            [-2.4287178568787104, -7.22889359667891],
            [-2.423568161438039, -7.228569280670247],
            [-2.4242639404802104, -7.233126713869648],
            [-2.426430050161826, -7.233939702769572],
            [-2.4298005880791913, -7.239609722497474],
            [-2.427031402299125, -7.242283133143695],
            [-2.4180547175016454, -7.244596532920092],
            [-2.4111472371580085, -7.2455523601372365],
            [-2.4088902157636705, -7.2487988745270835],
            [-2.397385410202611, -7.2516275756322335],
            [-2.389532135050869, -7.258712955284448],
            [-2.3869058315543388, -7.25766507347595],
            [-2.3796968505748666, -7.247029091064232],
            [-2.3763395024475793, -7.24899576929617],
            [-2.375720351744326, -7.258589167330915],
            [-2.3809597728176013, -7.265037310506625],
            [-2.380299953164906, -7.268134229426049],
            [-2.373409821982691, -7.273414310694793],
            [-2.366375179353556, -7.275688744957535],
            [-2.358941206667618, -7.275332095643587],
            [-2.3547627033472747, -7.280604006008578],
            [-2.3510981803376665, -7.2797932445909534],
            [-2.3485496412767866, -7.274953448299015],
            [-2.3446654990526388, -7.2706836630104235],
            [-2.3465857168116533, -7.263736428902196],
            [-2.3428507189969436, -7.258875348007272],
            [-2.3389693169497696, -7.259563100784497],
            [-2.335010893562698, -7.262550996816829],
            [-2.33112538135186, -7.2630541686337935],
            [-2.3290485105530285, -7.259033272182518],
            [-2.331793363585287, -7.250344922245409],
            [-2.3306181758302533, -7.24761716988976],
            [-2.3248053700926614, -7.244621948809419],
            [-2.3198431685856424, -7.246686100100434],
            [-2.315121112916751, -7.243204464222036],
            [-2.3164141419129045, -7.237808255087614],
            [-2.308717490945481, -7.231246914594768],
            [-2.300912252044313, -7.222636544480186],
            [-2.299464917905071, -7.2179919994755215],
            [-2.2941529804046517, -7.213498412108769],
            [-2.2866185658141216, -7.210350245669549],
            [-2.2837988558832505, -7.211797902678953],
            [-2.281765717799409, -7.215885699027598],
            [-2.272607445403764, -7.217538659031686],
            [-2.2623704222096803, -7.228959696571717],
            [-2.2568660862518817, -7.227188830123292],
            [-2.252259338396726, -7.222325338748148],
            [-2.24923326279734, -7.221324167890823],
            [-2.244695386211559, -7.224502796624395],
            [-2.2416928784759964, -7.234487855875169],
            [-2.2420843740129643, -7.239909509913732],
            [-2.2385447567437193, -7.240031128226075],
            [-2.2332700774660936, -7.236474435730454],
            [-2.2306847012817177, -7.232432745178295],
            [-2.222333169301066, -7.227724527025484],
            [-2.215149510756704, -7.2278617516333625],
            [-2.212847185892447, -7.230191567975517],
            [-2.2064312076925545, -7.228933599828569],
            [-2.197879839812035, -7.231554526047404],
            [-2.1912527694640147, -7.240050514733071],
            [-2.1857909891180123, -7.235600114852947],
            [-2.1867723388780114, -7.229856472407582],
            [-2.1832816505548576, -7.228613932018823],
            [-2.1784422514086046, -7.230494136843596],
            [-2.1758723373640976, -7.233507133617934],
            [-2.177704358340864, -7.241007616849861],
            [-2.1738934614551413, -7.243448896041376],
            [-2.17030513761619, -7.247933338331316],
            [-2.1654216356451625, -7.247115801219228],
            [-2.167390277619744, -7.241769250920185],
            [-2.1618431908607056, -7.236595663666351],
            [-2.1697503888000096, -7.4462618764871005],
            [-2.17353019245972, -7.562120220064498],
            [-2.177297305397976, -7.669181185572643],
            [-2.1802538782796748, -7.7535258859644305],
            [-2.2084818002376667, -7.752743917355207],
            [-2.2353656216060096, -7.751656419917996],
            [-2.3132516002761196, -7.7490869655149295],
            [-2.315300505409397, -7.748876333442824],
            [-2.368459637932831, -7.7473533508816095],
            [-2.4209932862900625, -7.745390271266244],
            [-2.4221555862733433, -7.745683489780885],
            [-2.5156690478205754, -7.74241655210399],
            [-2.617250179949323, -7.738541013178612],
            [-2.615775946653468, -7.6988007667067935],
            [-2.6113324449475983, -7.592949699810976]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.34753682885997,
          "lat": 31.198848398105905
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48307"],
        "coty_name": ["McCulloch"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCulloch County"],
        "coty_fp_code": "307",
        "coty_gnis_code": "01383945"
      },
      "bbox": [
        -2.617250179949323, -7.7535258859644305, -2.1618431908607056,
        -7.189789546191672
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3621634775799, -6.890657181836745],
            [1.3950194571722312, -6.890641923339915],
            [1.4152652581511105, -6.891012878626702],
            [1.4782431390343056, -6.8908624970346715],
            [1.542093574268118, -6.890182731350978],
            [1.578934605540904, -6.889568875567978],
            [1.611605920719104, -6.889233867474355],
            [1.7321366100982916, -6.887096832554331],
            [1.7722887827651763, -6.88650458004395],
            [1.7811424030629424, -6.899844072836455],
            [1.786091663775987, -6.902955029366897],
            [1.788845783084551, -6.907374249152798],
            [1.7919251096059663, -6.918302581330633],
            [1.7936091788576671, -6.927515004248353],
            [1.7971659733177507, -6.931076669329712],
            [1.7937362225675757, -6.939457198358057],
            [1.7944803622218155, -6.942872488554606],
            [1.7931653462920987, -6.950915693217979],
            [1.794724671186649, -6.952805710910914],
            [1.7915888128397752, -6.958012606471514],
            [1.8009522104905005, -6.965299454468871],
            [1.7992098580022484, -6.96893983165027],
            [1.8035621642997504, -6.97240879911737],
            [1.802879923882598, -6.975599876544383],
            [1.806088585704938, -6.97885419321106],
            [1.8043542494603446, -6.980908990947866],
            [1.8070848289820745, -6.9861822091601615],
            [1.806275047745776, -6.988284477258394],
            [1.8076470028864293, -6.99442949826448],
            [1.8059620176988926, -7.000246151091859],
            [1.8058769309442853, -7.0065745462951625],
            [1.8075146782866465, -7.011031854516943],
            [1.8055239270291263, -7.017127349647991],
            [1.8047893661149363, -7.0237840934504945],
            [1.8068496802081015, -7.024785806069077],
            [1.8086757909537299, -7.031702009901443],
            [1.8133723769661034, -7.035264646582463],
            [1.8116682545541267, -7.04093328057377],
            [1.8162108722106192, -7.047326235853021],
            [1.8159294322635064, -7.052680895637983],
            [1.81421534798729, -7.056469404113684],
            [1.8152995123412268, -7.066602583304802],
            [1.816942679683536, -7.071031691382474],
            [1.8206810233251862, -7.075670889397203],
            [1.8208290185811984, -7.0790453092096275],
            [1.8233654840719753, -7.0823258941925165],
            [1.8221147522917756, -7.0854595169573455],
            [1.8264508463965594, -7.089592852781625],
            [1.8309021593910557, -7.08883429472671],
            [1.835057883004566, -7.092301400565081],
            [1.841595161091545, -7.091736239900803],
            [1.8471861542921455, -7.094459734437137],
            [1.8482705123075351, -7.104683729194039],
            [1.8537988974536657, -7.105106529104039],
            [1.8612396507497284, -7.114013039917036],
            [1.860526448822955, -7.116496832756492],
            [1.8629192111641684, -7.121972643259946],
            [1.8666149200168611, -7.120170895204518],
            [1.8770257111567081, -7.125362849318601],
            [1.8802585467050448, -7.128758552321375],
            [1.8813356205432012, -7.132904243291896],
            [1.8844392797526344, -7.136690577515226],
            [1.8965867672997618, -7.138701437318322],
            [1.8942722031875396, -7.14914245097785],
            [1.900563675312562, -7.155623927318562],
            [1.8990817714325305, -7.158405233800326],
            [1.9021080974496147, -7.164209623818526],
            [1.8999722014521099, -7.168816837133658],
            [1.9020283185179514, -7.177431908092755],
            [1.9007805898540944, -7.184151328590088],
            [1.903106053682184, -7.19558655242642],
            [1.905719935464224, -7.199994554039101],
            [1.9013749971480147, -7.202404709808153],
            [1.8985154689412198, -7.210432043255379],
            [1.9033848016436514, -7.212361337125381],
            [1.9052596466208045, -7.215363564360467],
            [1.904761854717273, -7.2213495038258655],
            [1.9031152145888508, -7.225283630397651],
            [1.902789310825535, -7.2306855302940285],
            [1.8963951931432528, -7.233132316419099],
            [1.8946718181512925, -7.237040534452542],
            [1.8916371793810454, -7.249034930968702],
            [1.8958963970608669, -7.254262075851066],
            [1.8953308701981835, -7.257990225319829],
            [1.8977550851873375, -7.2595531406470615],
            [1.895401876491311, -7.263103527277786],
            [1.8971504575911184, -7.266269917533779],
            [1.8929674783797323, -7.274070276289498],
            [1.8951622166495306, -7.279319232202358],
            [1.8906258362333346, -7.282362770622936],
            [1.8900708141022737, -7.287042367801481],
            [1.8925339401366355, -7.288409389811426],
            [1.894722555052511, -7.296343063426644],
            [1.900568273592673, -7.2987716361500485],
            [1.9001713196643428, -7.301763232764585],
            [1.9043533209344679, -7.305115083661272],
            [1.902065318177512, -7.3125027317198965],
            [1.8966056117489445, -7.318310861950457],
            [1.8987076393235607, -7.3213458485190035],
            [1.8969388877741462, -7.323918191721583],
            [1.8900706015605448, -7.322996165224209],
            [1.8863175282629194, -7.327201157074686],
            [1.8867244733750137, -7.331153122135138],
            [1.890037958035316, -7.3390360464244],
            [1.8858756918928852, -7.342994991761319],
            [1.8877232169987574, -7.34830851580983],
            [1.8874033844803126, -7.359615647795179],
            [1.885216546545242, -7.36324697981395],
            [1.8855796740212285, -7.36745899071333],
            [1.8877134517128196, -7.369074417987201],
            [1.8871791493554586, -7.372960515734803],
            [1.890966137029445, -7.379431116687415],
            [1.8950782435015237, -7.382006163929037],
            [1.8971985636188957, -7.389597559415226],
            [1.8954905736505068, -7.392183998500377],
            [1.897372350081144, -7.399558275589293],
            [1.8916800805998506, -7.403186019946569],
            [1.8939450926768395, -7.407184824815085],
            [1.8979914809129141, -7.418142897859598],
            [1.8973711820482124, -7.422071607955882],
            [1.889373073438118, -7.432741530869061],
            [1.8924027239140946, -7.439757244013696],
            [1.8871439425475913, -7.444520017541643],
            [1.8847176180577552, -7.449195265908867],
            [1.8852732557447944, -7.451904618355825],
            [1.8816384753254976, -7.454976450393719],
            [1.877917097235036, -7.463446596286862],
            [1.882681857628289, -7.468751864594635],
            [1.8842010170226964, -7.475498531350974],
            [1.8824321113403268, -7.480073096101275],
            [1.8794797142772643, -7.480752264928426],
            [1.87819229343318, -7.485785985189387],
            [1.881968230339957, -7.485744377636985],
            [1.8843078016538883, -7.489863228979567],
            [1.891424694031332, -7.4961583820122915],
            [1.889684258260729, -7.50157303063994],
            [1.8835093499049453, -7.503648782584005],
            [1.8804106382303942, -7.495650637318559],
            [1.8772111004529184, -7.495299090181833],
            [1.8749205057136995, -7.490026974396914],
            [1.8715375912330956, -7.489749020447371],
            [1.8692723448787605, -7.483023331124672],
            [1.8645536788713672, -7.476496759707652],
            [1.862653982261639, -7.467374848460114],
            [1.8546082945594484, -7.4659478938854384],
            [1.852287907485696, -7.462563940389133],
            [1.848442417853127, -7.4610767492781624],
            [1.8451110214585162, -7.454459279195685],
            [1.8405037610667492, -7.45074029849472],
            [1.8401588065540309, -7.445427480806363],
            [1.8368830480571838, -7.444423698613954],
            [1.838492674715019, -7.4375112365059834],
            [1.8348180313018534, -7.434025800827546],
            [1.8319491461517734, -7.428686287193163],
            [1.821750180762068, -7.424286082291074],
            [1.8123897782214955, -7.419204782574555],
            [1.800702022200573, -7.416159221616101],
            [1.7978104993224042, -7.4136344947641755],
            [1.7932826174251537, -7.415764874967186],
            [1.791659425507113, -7.4101295477871725],
            [1.7893880736344974, -7.411206681956884],
            [1.7834657362994268, -7.407237493773533],
            [1.7833156268196564, -7.400183363031574],
            [1.7787024173044694, -7.394332959852857],
            [1.7796160304429178, -7.387974067755308],
            [1.7763121215284516, -7.388957098356423],
            [1.7760524869039196, -7.378864890234544],
            [1.7655998994176674, -7.359882881853432],
            [1.7641524024058022, -7.356084856421699],
            [1.7678641911344615, -7.351070332768875],
            [1.7656510006933628, -7.345743180771088],
            [1.7609025042178275, -7.341882058777338],
            [1.7580757451168632, -7.342915703932563],
            [1.750252191974772, -7.33862677715224],
            [1.7454451743974522, -7.334436008412145],
            [1.7479358850793272, -7.330485662138241],
            [1.7404890017199255, -7.324747849841037],
            [1.7366118498476215, -7.318948559339589],
            [1.7256422532696338, -7.320535185365086],
            [1.7247677479092138, -7.327753859166414],
            [1.7209987726348086, -7.327375983541897],
            [1.7145517489969273, -7.331454080509331],
            [1.7108487080702317, -7.329964514608162],
            [1.7072631096459425, -7.3314859929586715],
            [1.7038988722892148, -7.32835996748858],
            [1.703046148452283, -7.325240408217664],
            [1.7046553935445499, -7.319660691890175],
            [1.700008398334896, -7.30984835512538],
            [1.7007934588605529, -7.3061241123683685],
            [1.6973385778240444, -7.300284287440932],
            [1.6920148179301842, -7.295378616049204],
            [1.6882155608473706, -7.295354173716787],
            [1.6825287849381994, -7.297593482125733],
            [1.6773551428618616, -7.298260280259697],
            [1.6694256688659153, -7.297642146413279],
            [1.6666432233389121, -7.295819092614506],
            [1.6688909809115173, -7.291934921761138],
            [1.6680723247299967, -7.28717884158154],
            [1.6574797404956345, -7.286579957546979],
            [1.6545398771727686, -7.28355669556593],
            [1.6516056053662076, -7.285767588920407],
            [1.6499928035455855, -7.290615075488105],
            [1.6454825563760302, -7.291004309938837],
            [1.6442912867434385, -7.288956181197077],
            [1.6378167490798055, -7.292123997858399],
            [1.631668893008849, -7.291204609324108],
            [1.630657624245619, -7.288827063154885],
            [1.6257360850645421, -7.28693460008181],
            [1.618499226245823, -7.2877874425622196],
            [1.6116227375743795, -7.283547663033452],
            [1.6021716057452513, -7.279524535215936],
            [1.6008100974601964, -7.2747323588476736],
            [1.5967558421739518, -7.274563809997085],
            [1.588260545503506, -7.277057832651808],
            [1.58641803810488, -7.280023142535102],
            [1.5800304719829812, -7.281361805857997],
            [1.5735313041741679, -7.278892224990963],
            [1.570028975737205, -7.279928809435925],
            [1.564897205673178, -7.275698109708238],
            [1.555792199743786, -7.275059887449624],
            [1.5439761781560362, -7.275465515280786],
            [1.5440677676448789, -7.271860109823313],
            [1.5395666714224228, -7.2675635541845045],
            [1.535428907205375, -7.2684138836378995],
            [1.5266678230517208, -7.265496145529392],
            [1.5231349300381591, -7.262741612878834],
            [1.5158817409778125, -7.261601714010533],
            [1.513629394755943, -7.264004139107741],
            [1.5023909411882255, -7.252807302855113],
            [1.4993262042475548, -7.251985827779335],
            [1.4943782617727053, -7.253748784340616],
            [1.4894419653573034, -7.2517942828403426],
            [1.4850615426839362, -7.247712014461377],
            [1.4802243296324147, -7.246555464249611],
            [1.4796210385977868, -7.243194482054387],
            [1.4728299514365746, -7.246510046297348],
            [1.463005007104141, -7.247328490311347],
            [1.45739347457778, -7.240423115677576],
            [1.4532078254258045, -7.239339646012056],
            [1.454477364665312, -7.234510330539213],
            [1.4534231043657115, -7.231536984620076],
            [1.4417933560832927, -7.226236091283889],
            [1.4400457595139229, -7.228547064302],
            [1.430656456764023, -7.219565909134247],
            [1.4273933082606454, -7.213800256385019],
            [1.4282350530637755, -7.208819546178586],
            [1.4265876032111884, -7.207526139947814],
            [1.4229559819866813, -7.207788207687196],
            [1.4208768661278663, -7.205461774249424],
            [1.4139950647186577, -7.206136187418864],
            [1.408923358575247, -7.192365270908399],
            [1.4054986768719484, -7.193638314521382],
            [1.400661778270943, -7.18907773805728],
            [1.4001901764175166, -7.17989583887658],
            [1.4014488349743917, -7.1759819427101075],
            [1.4059777549826338, -7.168577953822977],
            [1.4042250626298687, -7.157509152753426],
            [1.3952508805527706, -7.160685223268041],
            [1.3909156749901854, -7.164345480572848],
            [1.3843122005992354, -7.165465678004446],
            [1.3794113632807858, -7.160773565123491],
            [1.3766807502074956, -7.156012885241082],
            [1.3780439213594695, -7.151082519818399],
            [1.3805522546775624, -7.148226546766734],
            [1.3757720250058514, -7.144924512862298],
            [1.3744185945094713, -7.141695419146649],
            [1.373800127714146, -7.134833040901058],
            [1.3753235957754417, -7.12932456513822],
            [1.3706739534904007, -7.123284225211182],
            [1.3652610255865372, -7.11259129060501],
            [1.361324631106935, -7.108523230912852],
            [1.3608976812537321, -7.097150285260012],
            [1.3542213124472913, -7.099176064206865],
            [1.352776309555914, -7.092980216516304],
            [1.3548671618375057, -7.082649335663002],
            [1.3518043026428754, -7.076153883929691],
            [1.352938029234505, -7.072154813435255],
            [1.3500881584752997, -7.059290720964023],
            [1.3472361044021581, -7.048985615789088],
            [1.3452005859954, -7.049966636601784],
            [1.3404074703403586, -7.0421221413191315],
            [1.3420989589762469, -7.034290912099484],
            [1.3448952607189661, -7.026815249964471],
            [1.3439647338949925, -7.023626455255903],
            [1.3457334000782966, -7.017946020896897],
            [1.3492704955287287, -7.012822339012039],
            [1.3459025787658927, -7.011942893079505],
            [1.3423589074961377, -7.0023929789107155],
            [1.3400532884998082, -6.999646425011209],
            [1.3366188183084462, -6.999745283040291],
            [1.3343011883059754, -6.9962599219231505],
            [1.3404674980720366, -6.98122165667357],
            [1.3438150931584232, -6.983068744487986],
            [1.3482190213829215, -6.981281015836631],
            [1.3540059107798261, -6.98349983669397],
            [1.3579001625993692, -6.983619486714605],
            [1.3641942738557071, -6.9809226687875405],
            [1.3691908956006709, -6.980832112171694],
            [1.3720644601326497, -6.977119915863512],
            [1.3700813256469047, -6.969549553770876],
            [1.3630961195209395, -6.966408819374873],
            [1.3620601201006763, -6.96378302311651],
            [1.3533939619705093, -6.96170895535163],
            [1.3479460304373718, -6.96282251054176],
            [1.3459115437337272, -6.958486364970246],
            [1.3338476570467204, -6.953948316836489],
            [1.3314183848427728, -6.950650937191772],
            [1.328393794901754, -6.942923455061506],
            [1.336296918485429, -6.94124723774829],
            [1.338541648411179, -6.939603616864582],
            [1.3433043500756916, -6.94071275822774],
            [1.3487194518747203, -6.939364432010244],
            [1.3504622328774105, -6.935447367515829],
            [1.3484646679554526, -6.9307304977002575],
            [1.3528572424274388, -6.928573284517774],
            [1.3584446014317146, -6.917848243848704],
            [1.3553525422929777, -6.911329255808009],
            [1.363693256112367, -6.9046757462800485],
            [1.364750834303707, -6.9014067396514545],
            [1.3621634775799, -6.890657181836745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.61571817902181, "lat": 31.61586687400958 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48347"],
        "coty_name": ["Nacogdoches"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nacogdoches County"],
        "coty_fp_code": "347",
        "coty_gnis_code": "01383959"
      },
      "bbox": [
        1.328393794901754, -7.503648782584005, 1.905719935464224,
        -6.88650458004395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.429225116007523, -6.941676109093165],
            [-4.312700445620073, -6.948490195892115],
            [-4.196174576743387, -6.955283712686224],
            [-4.19446505759979, -6.955496839002555],
            [-4.090408047171464, -6.961656557569869],
            [-4.085084142396256, -6.961781861167564],
            [-3.9987857811035927, -6.966990361777452],
            [-3.9990369969121278, -6.973627437386969],
            [-4.004466274106275, -7.060896550431882],
            [-4.006279743365491, -7.088513247982393],
            [-4.009741261397373, -7.142416877570467],
            [-4.018711780261119, -7.268475265698913],
            [-4.022679229604327, -7.3216603432147895],
            [-4.037101416601013, -7.53477219364889],
            [-4.122838828583095, -7.52989937539336],
            [-4.191878229778542, -7.526177271575301],
            [-4.328138535969234, -7.517961047685771],
            [-4.4643968470930915, -7.509713271533801],
            [-4.4614434733568, -7.466925796383002],
            [-4.461081233611474, -7.464700251909654],
            [-4.446591559886099, -7.230769166213239],
            [-4.446656421404331, -7.228032859582675],
            [-4.429225116007523, -6.941676109093165]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.52309640825163,
          "lat": 31.366213248487842
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48383"],
        "coty_name": ["Reagan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Reagan County"],
        "coty_fp_code": "383",
        "coty_gnis_code": "01383977"
      },
      "bbox": [
        -4.4643968470930915, -7.53477219364889, -3.9987857811035927,
        -6.941676109093165
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0320369449835516, -4.860279717318423],
            [1.0358594871690048, -4.862825336963232],
            [1.0494603168176742, -4.864433685169351],
            [1.0563490147838748, -4.8620732545305865],
            [1.058105831728225, -4.859547395079921],
            [1.0587138571661994, -4.849903829981801],
            [1.0566567369737638, -4.840640564680961],
            [1.0533860098979926, -4.838168500823524],
            [1.0522895734575095, -4.83404166423455],
            [1.0544089782254267, -4.829964949191867],
            [1.0580155267598161, -4.827137825922147],
            [1.0645153347737668, -4.825764218247866],
            [1.0682751439470888, -4.82747919534968],
            [1.0690484546077226, -4.831696718841737],
            [1.068580737317505, -4.8419280299458585],
            [1.0701669189659557, -4.847558598621005],
            [1.0730046517423975, -4.849651799318069],
            [1.0794627341203316, -4.842991966321937],
            [1.0818263168962772, -4.834419232180069],
            [1.0828983989282537, -4.816907304303858],
            [1.0811896379684023, -4.798540986630514],
            [1.0847082080601782, -4.793242214057108],
            [1.0896994146268948, -4.789391335226905],
            [1.0953371035310158, -4.7871443628238355],
            [1.0973478298943946, -4.781071808733538],
            [1.0971009089249049, -4.777026472218981],
            [1.1005769374623273, -4.77483460687248],
            [1.1106643393070303, -4.77456337161004],
            [1.1201933058269864, -4.779740518859506],
            [1.122906079995465, -4.7826636673416205],
            [1.1347847237056266, -4.787025000617587],
            [1.1461845526899248, -4.789961940644842],
            [1.1526254605500914, -4.795577415369601],
            [1.1588410238677964, -4.799502786458437],
            [1.1718851019701924, -4.801505460513916],
            [1.1792872772964103, -4.799286791734467],
            [1.1845419661309213, -4.801497751300383],
            [1.1874686540105586, -4.804852300494729],
            [1.1862034621223536, -4.811501287274848],
            [1.1789970981143647, -4.820270592334982],
            [1.1793556447079847, -4.8240662623330675],
            [1.1833630072983778, -4.829212979382191],
            [1.1910596613772375, -4.8326166963319075],
            [1.194809388206946, -4.831594038501528],
            [1.201176012079156, -4.826522919415517],
            [1.2140459838948068, -4.821774888059463],
            [1.219510935292591, -4.8141375701768325],
            [1.2231951812416542, -4.817176190495185],
            [1.224527359470367, -4.820494441881459],
            [1.2212116332499026, -4.828199638607196],
            [1.2160838422353584, -4.8321843114549665],
            [1.207888620725251, -4.836394478972739],
            [1.2051111841167346, -4.840032791841317],
            [1.206196661908182, -4.845263885947642],
            [1.213959223941472, -4.85525202883839],
            [1.2199009367613904, -4.856173859765275],
            [1.2213792116904691, -4.853776448023172],
            [1.222629931893599, -4.832908438151167],
            [1.225640114804386, -4.826976189559985],
            [1.2264385549464274, -4.820505025593496],
            [1.2308007116453092, -4.818201637808606],
            [1.235358189242855, -4.8225131796286504],
            [1.2331999576790023, -4.827111336536532],
            [1.229434319097976, -4.8274503101170945],
            [1.2279129263725372, -4.833190540053819],
            [1.2335326259030066, -4.832272310543895],
            [1.2380605117719974, -4.833920438447792],
            [1.2397374433538784, -4.848284821453574],
            [1.2461592015817864, -4.858311079299641],
            [1.2460350681877266, -4.866400325185411],
            [1.2472338537456702, -4.871033118619515],
            [1.2496096683706537, -4.873266001244592],
            [1.2573488665519637, -4.875512102304021],
            [1.2778581645789548, -4.877548951251007],
            [1.2863443254405187, -4.872404381508009],
            [1.2900869682226708, -4.87492287775359],
            [1.2941407805427547, -4.882956829464868],
            [1.297605367910767, -4.884380692510446],
            [1.303227540912292, -4.883031993376386],
            [1.307631468633842, -4.875393024157894],
            [1.3115407914925874, -4.87306626025198],
            [1.3136475105768828, -4.874255134086926],
            [1.3162629318338628, -4.886768413849585],
            [1.3176139087087613, -4.898197827981977],
            [1.329954100591918, -4.901562997379717],
            [1.3346600593317166, -4.90576090902524],
            [1.3268147030864745, -4.918720174451009],
            [1.3315598768804453, -4.926817007791044],
            [1.338090953827641, -4.929431568846315],
            [1.3502451300299592, -4.926285511407218],
            [1.3519130144337481, -4.919463613198119],
            [1.349202391723461, -4.912311549675574],
            [1.349312294059653, -4.906367184658843],
            [1.352668023613193, -4.906086426400193],
            [1.3586831235993846, -4.910322262805964],
            [1.360938613710624, -4.9143305640904655],
            [1.362578527837536, -4.922380708224182],
            [1.3606324730988006, -4.92616779096102],
            [1.3570009199588489, -4.926567421818889],
            [1.353317288056586, -4.939056732355672],
            [1.353129069328918, -4.943394638388107],
            [1.3619667828973836, -4.956558245421726],
            [1.367966682195509, -4.957678831423165],
            [1.3679910908226902, -4.961641786811848],
            [1.3733896375946093, -4.966005441529131],
            [1.381614841562336, -4.965732337115021],
            [1.3849022438918301, -4.971487625525183],
            [1.3910316595044008, -4.977274505565342],
            [1.3931067183008203, -4.9740737568604985],
            [1.3922111628447047, -4.967197766314061],
            [1.3930787167229512, -4.96429417447975],
            [1.3977937906393347, -4.9656845516663735],
            [1.39954287369586, -4.968391535808489],
            [1.3990402756146807, -4.972738994250257],
            [1.3919922430015799, -4.979757027009349],
            [1.390617977341936, -4.982482800825261],
            [1.3926452377744871, -4.9855257385801615],
            [1.4042724668439448, -4.992632213529167],
            [1.4137043551253874, -4.994887314941876],
            [1.4192551494831094, -4.994960659448016],
            [1.4290301522736246, -4.993782747151212],
            [1.431259130867726, -4.995100112518835],
            [1.4310769983679117, -4.999330146358877],
            [1.4359326951237923, -5.001509179166492],
            [1.4378744938981303, -4.99936779372042],
            [1.4352782267877007, -4.986656108608453],
            [1.428707501478405, -4.976145383635701],
            [1.429260577604155, -4.970536639333643],
            [1.4331579351875645, -4.965607279162454],
            [1.4387135627337788, -4.966362625475314],
            [1.440761229106129, -4.9706536857966155],
            [1.440446533714623, -4.978824678354684],
            [1.4442216638459335, -4.98312216365109],
            [1.4436659010687616, -4.9886375383604555],
            [1.4411414679750678, -4.994922898371617],
            [1.4452946130340945, -4.999276676886978],
            [1.4526258148300488, -5.001229117847903],
            [1.4578548573902568, -4.996346437905281],
            [1.4700437919690588, -4.988950169638844],
            [1.4748591505718223, -4.975530114305464],
            [1.478473465903163, -4.97264649142725],
            [1.4871249953425587, -4.97519501343431],
            [1.4895253248824598, -4.978649196901713],
            [1.4890855104192515, -4.983380710960814],
            [1.4858786175322884, -4.986748177525075],
            [1.4759210672599752, -4.987160796950542],
            [1.4729880360272365, -4.988519104362044],
            [1.464152246359726, -4.998546689480449],
            [1.4688530970843674, -5.00357361928453],
            [1.4767443520008572, -5.006543231426116],
            [1.4870846701925193, -5.00654304090383],
            [1.4921265621824866, -5.000119173552457],
            [1.4946194378034627, -4.9997484016174845],
            [1.4973271619708317, -5.008759494231186],
            [1.4899188511733739, -5.015423124151577],
            [1.4942567190160987, -5.019714520378548],
            [1.4983497065024445, -5.018197829245935],
            [1.5000002993666854, -5.015552065002981],
            [1.5008406117036968, -5.008423307198433],
            [1.502632952751132, -5.006524157639946],
            [1.5080830563630319, -5.0067069779994045],
            [1.5102230240475358, -5.009387009371962],
            [1.5101463527251406, -5.013283558716742],
            [1.5054428021145076, -5.018899107190039],
            [1.4933615208501956, -5.023296518056518],
            [1.49446190185034, -5.028638510863748],
            [1.4993856566103556, -5.030752184427442],
            [1.5011810285475533, -5.179660641552318],
            [1.50158184163189, -5.207170102847179],
            [1.5019982463964379, -5.277760550090799],
            [1.5024086949438955, -5.292358746378388],
            [1.50366397889779, -5.405612439059745],
            [1.5015720936761323, -5.407536343468835],
            [1.4992283619671978, -5.415232981637537],
            [1.496081437004513, -5.417061208587278],
            [1.489607554536513, -5.411862961528069],
            [1.4821942713457126, -5.4148022425323825],
            [1.472954736205322, -5.41113061380765],
            [1.478493657199362, -5.403233446306354],
            [1.4700244172546466, -5.396085248964607],
            [1.471983051725062, -5.391764069001903],
            [1.463083420080672, -5.382602504420864],
            [1.4667146981644255, -5.379641522573456],
            [1.4634625079885168, -5.3749069973934445],
            [1.4590922533548412, -5.373170664607358],
            [1.4584823116083592, -5.369688761936335],
            [1.451893111671942, -5.371493495309941],
            [1.4480339769205335, -5.372505923836232],
            [1.4463127020513729, -5.368877338455059],
            [1.4458333539864283, -5.363188224473125],
            [1.4484855281870441, -5.359565369216835],
            [1.438884910849286, -5.35588673742738],
            [1.4354472116767378, -5.356251812412551],
            [1.4339288944411999, -5.352528073858632],
            [1.4263357826943703, -5.351933043286008],
            [1.4205989871176998, -5.356643191624532],
            [1.417862356182794, -5.35327873628918],
            [1.4112533415856807, -5.358893914944793],
            [1.4065460868263442, -5.353717072223655],
            [1.40197791135215, -5.352351794875073],
            [1.4017713479043223, -5.346658943070265],
            [1.3957865503026428, -5.341540532914704],
            [1.3840383468414308, -5.337677854278247],
            [1.3843458083680584, -5.340842319427783],
            [1.3760503128397894, -5.346171581973377],
            [1.3721389239363841, -5.34665065770625],
            [1.368746738704244, -5.349006331399815],
            [1.3608182919356389, -5.348591310742863],
            [1.3576417342000104, -5.35200169049165],
            [1.3538424851627888, -5.352456528663112],
            [1.3468234015820622, -5.3503988025091545],
            [1.3454374698678955, -5.347958100166928],
            [1.3399700419498446, -5.347031332582716],
            [1.3388099832086071, -5.3445188182809344],
            [1.3319174738883628, -5.345629317607129],
            [1.3297842258976096, -5.343127331872672],
            [1.325065227576342, -5.3443046578776165],
            [1.3251813865779793, -5.346576104216773],
            [1.320835348764295, -5.348667403430138],
            [1.3114651883602395, -5.346957770531267],
            [1.3070932041671997, -5.348752847678545],
            [1.3009320467353613, -5.346501448556227],
            [1.2998022403324154, -5.3446076078679505],
            [1.292366622848954, -5.345536932367003],
            [1.2893164340909287, -5.341595817384674],
            [1.2856353785858656, -5.344846202163231],
            [1.2829076138849327, -5.343793765232827],
            [1.2787874626440157, -5.3460839355965],
            [1.2780452232309496, -5.35111812968277],
            [1.2738683997002087, -5.354557424447441],
            [1.26837791925771, -5.354974314202477],
            [1.2585140178974474, -5.352696057440853],
            [1.261251293849318, -5.356157177124001],
            [1.2519544395644657, -5.354341559972159],
            [1.2473277743357056, -5.351733905898058],
            [1.2452084839059707, -5.345793992068481],
            [1.2389385395847994, -5.34801503807835],
            [1.2358454838877837, -5.3465294834114765],
            [1.2315041636413704, -5.351624295961231],
            [1.2248340829167532, -5.347992508633424],
            [1.2196206005628354, -5.34278632144609],
            [1.2090768863975476, -5.341075765112886],
            [1.2072931093747614, -5.3437802820716485],
            [1.2028996066967554, -5.345889602440823],
            [1.2019767169607425, -5.348722255154525],
            [1.188976331855341, -5.348456468335035],
            [1.1819851141456503, -5.351889575696006],
            [1.174195426802788, -5.351566894710496],
            [1.1723324273819382, -5.356035593470811],
            [1.1653362120940933, -5.356002669445392],
            [1.1637241940442378, -5.358084025549374],
            [1.1585173288487156, -5.358104829372234],
            [1.1585213069102038, -5.35330797455158],
            [1.147861666772397, -5.356176654647327],
            [1.145287063056486, -5.359594201443149],
            [1.1419682222378087, -5.357926540326525],
            [1.1385805243990117, -5.35894090779069],
            [1.1350010351833806, -5.364403616715993],
            [1.1298867651227478, -5.3646302568895186],
            [1.1287320178286184, -5.358840792409135],
            [1.1263438547837745, -5.35753055151812],
            [1.119705722408373, -5.359560672996351],
            [1.108167800020759, -5.360485458694959],
            [1.1017715282634157, -5.3670491204013935],
            [1.0922934904582948, -5.370853948088108],
            [1.0850668087023496, -5.368157326886354],
            [1.0807822412960908, -5.37119509009915],
            [1.0702354047278142, -5.36473875076799],
            [1.0670898822308064, -5.365577761605893],
            [1.0616162591674156, -5.36243053040921],
            [1.0533501359978774, -5.361226434246141],
            [1.044202061690416, -5.3566957936073685],
            [1.0430430902866645, -5.360808315550844],
            [1.0388088770049342, -5.361144929034582],
            [1.0371333078541796, -5.358515633824528],
            [1.0357584102770947, -5.243776101490799],
            [1.0352308091195643, -5.238771992141851],
            [1.0344553084454027, -5.207003590756635],
            [1.0344584297892658, -5.18766339221256],
            [1.033870675379197, -5.130146384818024],
            [1.033809976654036, -5.10138073723199],
            [1.033381576724977, -5.075243996105322],
            [1.0332173523316046, -5.041344672136329],
            [1.0324476184387958, -4.988011469938995],
            [1.0320106080175866, -4.873571958066681],
            [1.0320369449835516, -4.860279717318423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.05030691824761, "lat": 33.62078755914066 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48387"],
        "coty_name": ["Red River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Red River County"],
        "coty_fp_code": "387",
        "coty_gnis_code": "01383979"
      },
      "bbox": [
        1.0320106080175866, -5.417061208587278, 1.5102230240475358,
        -4.77456337161004
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7204286766669536, -6.757757646549095],
            [1.7367890163426953, -6.757433655578554],
            [1.8239644861855215, -6.754657783110848],
            [1.8751902100120095, -6.753178296052527],
            [1.8840202103631045, -6.752680244812305],
            [1.905909837399778, -6.752314401670281],
            [1.954211863188469, -6.7501952001135495],
            [1.959013209942104, -6.750209264666359],
            [2.0463711717139788, -6.74741131751904],
            [2.050700214681503, -6.747025985613965],
            [2.099063943579767, -6.745748993523383],
            [2.1388203616612, -6.744305590051645],
            [2.1389909303003205, -6.743999815381119],
            [2.1459327923016, -6.7502328328407],
            [2.150677254732285, -6.759741728566054],
            [2.157880250825982, -6.7722063520678555],
            [2.1634392176081336, -6.78013096651196],
            [2.1684018444883506, -6.783389415014158],
            [2.170148069620608, -6.786743436003038],
            [2.1705140533756464, -6.792669129641753],
            [2.175251651524045, -6.8016105509076565],
            [2.1803102596451174, -6.803198629764899],
            [2.1854729693897355, -6.799072519532289],
            [2.1879146554704114, -6.800776697696232],
            [2.1927187235769607, -6.812319737620316],
            [2.2041975543907513, -6.812293985816834],
            [2.213255918319697, -6.810686590430422],
            [2.218366463781245, -6.814531170152843],
            [2.2187174272735617, -6.819609308593307],
            [2.21215512931323, -6.8259665720753135],
            [2.211100267858731, -6.828938728716864],
            [2.2159241350705727, -6.834078482739272],
            [2.2198077860327823, -6.836536463374375],
            [2.221839839638947, -6.831462757505978],
            [2.2248680239284004, -6.829288640270101],
            [2.2320862349247834, -6.829517269440735],
            [2.235606737491453, -6.825738535053747],
            [2.240495175944421, -6.827375376668572],
            [2.241303675064145, -6.834483522552487],
            [2.237032156197055, -6.841791791472574],
            [2.237655837744192, -6.848165353493287],
            [2.24201118817197, -6.845512660424657],
            [2.2458881687768293, -6.846701396186547],
            [2.2462093719375544, -6.850366789366692],
            [2.251594839028956, -6.8556154064290835],
            [2.2538336132424797, -6.859515603787642],
            [2.2486018319644288, -6.863836206186209],
            [2.2493537728802986, -6.866939174903308],
            [2.253131064265441, -6.866384862715643],
            [2.25244909040238, -6.871575526861656],
            [2.25665021230214, -6.877704159160526],
            [2.2607902542649523, -6.8806263580704075],
            [2.262314563089666, -6.884529863703312],
            [2.2590254608950695, -6.88907186830856],
            [2.2617715664185716, -6.895832966192423],
            [2.2612674484403703, -6.899518955838924],
            [2.2646267026092177, -6.904256176665907],
            [2.2727914490490964, -6.908602681215613],
            [2.2746124560950722, -6.911735885576539],
            [2.2797073513239323, -6.915260470276802],
            [2.281442755968925, -6.920524869512927],
            [2.285877419539716, -6.918559031375731],
            [2.291705944077884, -6.920114327917014],
            [2.294994664268757, -6.925865923867308],
            [2.29406456562992, -6.93162693726535],
            [2.296065974604185, -6.936992425315937],
            [2.3057357257971725, -6.944962348168276],
            [2.3043649067155014, -6.952701773898169],
            [2.3014125599517596, -6.954503091538024],
            [2.3037208188500475, -6.9577447564016115],
            [2.300253604072203, -6.9643016817843595],
            [2.2955611951724064, -6.9686412067164305],
            [2.29563127824065, -6.971696146234195],
            [2.3009126282260954, -6.975574465760368],
            [2.3042850687879137, -6.983257177109902],
            [2.307775712186697, -6.987410871273578],
            [2.3124056814240026, -6.988950748729028],
            [2.315314740782217, -6.99382228577333],
            [2.3163885981290075, -7.004439112481784],
            [2.312786958047842, -7.010949594162291],
            [2.3174253047185474, -7.01238618454945],
            [2.3178136694020677, -7.015903948429833],
            [2.321284021052359, -7.016689987223533],
            [2.3292031641778985, -7.013777240949238],
            [2.3318865959756154, -7.017181284906017],
            [2.3238566767167073, -7.033729099513685],
            [2.316069779754682, -7.04364774114742],
            [2.3175556950720515, -7.047375297977971],
            [2.3152050705588763, -7.051582201576268],
            [2.3092408882614293, -7.0457244902359735],
            [2.3056657006531904, -7.052832118281122],
            [2.3064798445492802, -7.058692402823522],
            [2.3113761699464455, -7.065381823815237],
            [2.31324268989097, -7.071627508095151],
            [2.3153674070560597, -7.087142404973655],
            [2.3114942243204655, -7.089787399688795],
            [2.3148442723361584, -7.096892778675539],
            [2.3095726424155107, -7.098763076849209],
            [2.313328099027991, -7.1028140723924],
            [2.312711259254516, -7.10530198605145],
            [2.3070059823499633, -7.104652256174839],
            [2.3035140590220684, -7.106035148054946],
            [2.2972146925808596, -7.1129551629526615],
            [2.296266559072017, -7.120670847725026],
            [2.300342029273213, -7.1333994511307734],
            [2.2899469267251313, -7.131241936013768],
            [2.289036810849832, -7.128953232212829],
            [2.28247589833581, -7.127082229733478],
            [2.2780601926918824, -7.127676297219526],
            [2.2737646265059395, -7.122446126933499],
            [2.2648346135769954, -7.121763600525632],
            [2.2573099671467944, -7.119197303129107],
            [2.2526329274083037, -7.113783936509326],
            [2.248704767635519, -7.113123858679752],
            [2.245245496220602, -7.109213098817336],
            [2.227204559096799, -7.122125859105193],
            [2.2237838325850565, -7.129765367076659],
            [2.218254422447922, -7.131016118172744],
            [2.2107165384701135, -7.131341013990025],
            [2.2065974693886523, -7.135607164567112],
            [2.2001943498171848, -7.137604871195865],
            [2.1940579597279983, -7.142335889993444],
            [2.1863690665868827, -7.149688231786473],
            [2.17386925809868, -7.152893942261934],
            [2.1491570987878412, -7.140007069181788],
            [2.0826132036214986, -7.103739640000111],
            [2.053392566323644, -7.100804658692838],
            [1.9480837796240835, -7.089566140486455],
            [1.947173707358859, -7.089234926352572],
            [1.8206810233251862, -7.075670889397203],
            [1.816942679683536, -7.071031691382474],
            [1.8152995123412268, -7.066602583304802],
            [1.81421534798729, -7.056469404113684],
            [1.8159294322635064, -7.052680895637983],
            [1.8162108722106192, -7.047326235853021],
            [1.8116682545541267, -7.04093328057377],
            [1.8133723769661034, -7.035264646582463],
            [1.8086757909537299, -7.031702009901443],
            [1.8068496802081015, -7.024785806069077],
            [1.8047893661149363, -7.0237840934504945],
            [1.8055239270291263, -7.017127349647991],
            [1.8075146782866465, -7.011031854516943],
            [1.8058769309442853, -7.0065745462951625],
            [1.8059620176988926, -7.000246151091859],
            [1.8076470028864293, -6.99442949826448],
            [1.806275047745776, -6.988284477258394],
            [1.8070848289820745, -6.9861822091601615],
            [1.8043542494603446, -6.980908990947866],
            [1.806088585704938, -6.97885419321106],
            [1.802879923882598, -6.975599876544383],
            [1.8035621642997504, -6.97240879911737],
            [1.7992098580022484, -6.96893983165027],
            [1.8009522104905005, -6.965299454468871],
            [1.7915888128397752, -6.958012606471514],
            [1.794724671186649, -6.952805710910914],
            [1.7931653462920987, -6.950915693217979],
            [1.7944803622218155, -6.942872488554606],
            [1.7937362225675757, -6.939457198358057],
            [1.7971659733177507, -6.931076669329712],
            [1.7936091788576671, -6.927515004248353],
            [1.7919251096059663, -6.918302581330633],
            [1.788845783084551, -6.907374249152798],
            [1.786091663775987, -6.902955029366897],
            [1.7811424030629424, -6.899844072836455],
            [1.7722887827651763, -6.88650458004395],
            [1.771955524223942, -6.8825311418663],
            [1.7625793407052672, -6.874331322220372],
            [1.7654949478613966, -6.870181783874503],
            [1.7633283712847434, -6.861397548952525],
            [1.763845957719397, -6.859436054208333],
            [1.7596605176958375, -6.851916789383927],
            [1.753377522159582, -6.848507718573871],
            [1.7489705946894811, -6.839212402918731],
            [1.746965575485658, -6.831904683091639],
            [1.7447005365593378, -6.827432207300787],
            [1.7396884035410447, -6.825702678850923],
            [1.7362085811032029, -6.820476821989684],
            [1.7288151860299326, -6.817108895686612],
            [1.727154765670689, -6.811083773883689],
            [1.7230733202692063, -6.809398444541708],
            [1.7211460841478026, -6.805381650035966],
            [1.7204286766669536, -6.757757646549095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.14493498728561, "lat": 31.79238115142497 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48419"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "419",
        "coty_gnis_code": "01383995"
      },
      "bbox": [
        1.7204286766669536, -7.152893942261934, 2.3318865959756154,
        -6.743999815381119
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.22226878763835173, -8.567511038652105],
            [-0.1783685397822732, -8.532807926874634],
            [-0.17475937305419934, -8.5256976361611],
            [-0.17467878614641869, -8.522147414129664],
            [-0.17760362939810678, -8.51444253933228],
            [-0.17784425530557696, -8.510829224733477],
            [-0.17468448690332716, -8.508293072357464],
            [-0.17630207229990222, -8.501059407551997],
            [-0.17200181634028683, -8.497256944846955],
            [-0.16754366575693255, -8.485532329526366],
            [-0.16288585915346568, -8.485527058845697],
            [-0.15587228011100182, -8.47895522055088],
            [-0.1529456064154585, -8.479711141839937],
            [-0.14939430504008666, -8.483985462829445],
            [-0.14650581010472796, -8.48411575308532],
            [-0.13830516476113347, -8.480090234725859],
            [-0.12886723253687282, -8.48154123139401],
            [-0.12628119674700222, -8.479135512212642],
            [-0.12722983769584195, -8.473681947524142],
            [-0.12254422445417312, -8.47068663741533],
            [-0.11978099913934769, -8.463238998577545],
            [-0.11579374219840421, -8.462520948950827],
            [-0.11279030230919858, -8.454268968906165],
            [-0.1065701766364969, -8.45130594833121],
            [-0.1034004205115209, -8.442378596255034],
            [-0.09518180371695706, -8.4380697558186],
            [-0.08985662872729197, -8.436750016829965],
            [-0.08867454701471858, -8.433551435538014],
            [-0.08206746046837268, -8.430867325922852],
            [-0.07325177240625673, -8.43222599854082],
            [-0.06752707593826818, -8.429409144972572],
            [-0.05872455224673484, -8.428541627020534],
            [-0.05626692474714585, -8.423395415390035],
            [-0.05337139330304649, -8.421831031478318],
            [-0.049673390670899105, -8.423225491841652],
            [-0.04174863958740491, -8.421727405066521],
            [-0.038426307556871285, -8.422023099731337],
            [-0.03409035302781049, -8.418522524409264],
            [-0.030530525909679123, -8.420132335616161],
            [-0.025919779462972956, -8.417290938283612],
            [-0.02613500802959822, -8.413975890267741],
            [-0.021022490210127708, -8.411586023509093],
            [-0.02083880376539649, -8.408537833068072],
            [-0.00899335935614042, -8.409651815408388],
            [-0.002379538329784536, -8.413075493926181],
            [-0.0012433337652888274, -8.41000093021325],
            [0.007160241540065756, -8.410907875680756],
            [0.012239192387262218, -8.407677360835377],
            [0.013656536397235351, -8.408944630281281],
            [0.02002971243251039, -8.405173601353512],
            [0.02402444246508527, -8.40961277760252],
            [0.032905020019120365, -8.407069017520797],
            [0.036316108096690336, -8.406968770729472],
            [0.04020947909457643, -8.39999420917909],
            [0.04114534350917672, -8.395835638569372],
            [0.04512651828487552, -8.393359404801611],
            [0.047898197720873996, -8.398374203458005],
            [0.05414448205838574, -8.397915775569174],
            [0.060160066967460867, -8.393596607499653],
            [0.06284377034366927, -8.395337055794457],
            [0.07036892948006242, -8.391017457801828],
            [0.07165752770566296, -8.387148458940182],
            [0.07671547073405012, -8.390703477607198],
            [0.07976998953976117, -8.389332184828538],
            [0.0842660234830431, -8.390273628927245],
            [0.08633183508704924, -8.3888103377464],
            [0.09955738664947991, -8.388427570286764],
            [0.1031561056837659, -8.38487541373532],
            [0.10321978106287844, -8.37908563487787],
            [0.11044784638088471, -8.37350996403355],
            [0.11369182827542315, -8.380828379737025],
            [0.11551189471577307, -8.379042136277],
            [0.12293118206684676, -8.37673991391083],
            [0.13206210949522465, -8.374921611872622],
            [0.13864250696671004, -8.376260982582506],
            [0.14350990621469709, -8.369530242610242],
            [0.14904899917418046, -8.365041655439622],
            [0.1532629038182166, -8.364391500009617],
            [0.15460299743607456, -8.35964570873899],
            [0.15810309881664752, -8.358653626711869],
            [0.159677365565445, -8.361159251817483],
            [0.16680345452290438, -8.364276669740901],
            [0.1705097922364, -8.36437414006133],
            [0.17595213518678707, -8.358476781490369],
            [0.18142675464644903, -8.358160615574352],
            [0.18432985623122772, -8.353374926183704],
            [0.19023717737542584, -8.353073508630555],
            [0.1940175162637876, -8.348386417568708],
            [0.19868000555513807, -8.350781487549426],
            [0.20191554649520543, -8.349299960735399],
            [0.20612352263134923, -8.353364389179994],
            [0.21469557974893458, -8.360990305302892],
            [0.21763582545573348, -8.367735195038357],
            [0.2230748018355358, -8.367970243016275],
            [0.2255239986039027, -8.372142178761305],
            [0.23232714884138866, -8.373738397279954],
            [0.23783281603566062, -8.367823533030094],
            [0.24221267967838145, -8.366105780804528],
            [0.2469226167267615, -8.367128263707569],
            [0.25429301861289816, -8.362850481880674],
            [0.26128505257342366, -8.362866896782199],
            [0.27083613257474, -8.357282484900477],
            [0.2759844354122865, -8.35598988684786],
            [0.2810281674793926, -8.358988700645238],
            [0.28727680000853206, -8.352629701043313],
            [0.2919213583734154, -8.34986201767292],
            [0.2930800168618572, -8.337762916368472],
            [0.2962993361717145, -8.33303894503846],
            [0.3054877958484301, -8.338617309739378],
            [0.3099250217096038, -8.338192483281713],
            [0.31353387164378155, -8.342005680556763],
            [0.3145512015477603, -8.346396883328214],
            [0.31179378179007267, -8.354425911296921],
            [0.31257121898860923, -8.357731072078213],
            [0.316015288324438, -8.358948552228059],
            [0.32235720551696107, -8.355282225912557],
            [0.32730833352724426, -8.354430156370762],
            [0.328375194073654, -8.357035847511842],
            [0.3333173242446752, -8.361262358340543],
            [0.33466942005652117, -8.36393573583102],
            [0.3298666970187804, -8.369527229951471],
            [0.33249774359277334, -8.379702474775359],
            [0.33226448705349493, -8.382247265244029],
            [0.3257636757224489, -8.390732229432219],
            [0.3255141346172442, -8.393085571931971],
            [0.33050905317615736, -8.402088353972555],
            [0.33501930922484474, -8.407150571331423],
            [0.3440800213434847, -8.40987350329454],
            [0.3460672059699153, -8.41750770649352],
            [0.350297028387973, -8.419810593753718],
            [0.3557786462667673, -8.420681019181677],
            [0.35990442196895356, -8.426506905503356],
            [0.36457700100079865, -8.426203472507817],
            [0.3799777751001208, -8.421155941234266],
            [0.38237964124875223, -8.422883523848906],
            [0.3830365451940232, -8.4270221828713],
            [0.37860838814553843, -8.432606323440984],
            [0.37703940580200535, -8.43929295911037],
            [0.3801792567696191, -8.443066293580637],
            [0.3863211102066814, -8.442410392492926],
            [0.39099761435992875, -8.444404196900983],
            [0.3903836059466646, -8.449410184596918],
            [0.384647829306554, -8.453956556525254],
            [0.3828672576898591, -8.457617686499141],
            [0.3813789433944467, -8.46625443190218],
            [0.37814693340275846, -8.473728938052101],
            [0.37858562525240613, -8.477257171991676],
            [0.3819184708668427, -8.479336950312502],
            [0.3866064036397246, -8.47869851076633],
            [0.39079619928754017, -8.480473591469492],
            [0.3940149608696966, -8.4873592777421],
            [0.39186375386271477, -8.493294124355009],
            [0.38811620119466916, -8.493827688880613],
            [0.3822966090297962, -8.489249576949808],
            [0.37871916502628833, -8.488899271453997],
            [0.3747695257472432, -8.492912011299792],
            [0.3728360758158598, -8.498666162245282],
            [0.3789850320515413, -8.501080725914191],
            [0.38336479643017324, -8.50628741097698],
            [0.38339724203304604, -8.510982499681687],
            [0.3802993960544394, -8.516501448407816],
            [0.37837492804912054, -8.516843186517042],
            [0.36934729501655195, -8.51149563496282],
            [0.3656478231380836, -8.50427142527858],
            [0.36192242513545314, -8.507229615027398],
            [0.35309692499802986, -8.519705495012392],
            [0.3461178126409787, -8.52048727148554],
            [0.34277628495848256, -8.519077981965374],
            [0.33857093204708355, -8.512790083982553],
            [0.3365398743035471, -8.513371387104167],
            [0.3344121666714877, -8.518272981095325],
            [0.3265279485233627, -8.524610147797413],
            [0.3264374356062332, -8.535260978501096],
            [0.32815634270366123, -8.540573250637637],
            [0.32582836819237293, -8.547816824118973],
            [0.3262932853911238, -8.550557841141963],
            [0.3303181644646643, -8.553821563549567],
            [0.3297609462683982, -8.55774522479802],
            [0.32482216443371265, -8.562294373447857],
            [0.3238714774721256, -8.56590128903362],
            [0.3255713972183896, -8.568960035568486],
            [0.3312858195033227, -8.571287489019584],
            [0.3341131387998109, -8.575295406221166],
            [0.3332739971662038, -8.583803776961545],
            [0.3311529902080625, -8.588645259194404],
            [0.325014806657056, -8.587476753129504],
            [0.32168475444072586, -8.584061009016354],
            [0.31152145188836966, -8.575874935457005],
            [0.3077471857892281, -8.575013377117264],
            [0.3055867322259738, -8.579934539795923],
            [0.3098261539111937, -8.585605317622443],
            [0.31525016287862623, -8.58940847113507],
            [0.31180665932621815, -8.592800385136652],
            [0.3067129493787733, -8.589647227543704],
            [0.3015544639351365, -8.588856085357047],
            [0.29811073359132884, -8.5920890195753],
            [0.2984175308795404, -8.595803580563981],
            [0.30276626706037096, -8.602269549443532],
            [0.30836735666156617, -8.607384037675997],
            [0.3084093637682004, -8.612967977326365],
            [0.30184047666919817, -8.611725805058223],
            [0.2981278141795692, -8.615043999211178],
            [0.3007574723271044, -8.619773541585147],
            [0.3051653995942695, -8.621020563123617],
            [0.31251656209738465, -8.617843495021587],
            [0.31563692857273695, -8.622145718842514],
            [0.312832120421712, -8.627479618713357],
            [0.31441318882679936, -8.630807742420565],
            [0.31845544062323355, -8.631156443300089],
            [0.32179352961153335, -8.62902985701397],
            [0.32527340128580934, -8.622191053862844],
            [0.3298384054355857, -8.621748093619082],
            [0.3319290417501444, -8.627677444350407],
            [0.32635472519694375, -8.633119081768742],
            [0.3268444140667609, -8.63838629602677],
            [0.33035383210856034, -8.643526623489969],
            [0.33371262328039525, -8.645322650248144],
            [0.33972612000790436, -8.64506853578797],
            [0.34132481598201886, -8.64683486883745],
            [0.3419453898611738, -8.653129302611626],
            [0.3481080765428966, -8.658957318349078],
            [0.34531917025463243, -8.662875996515785],
            [0.34026153728732145, -8.658963845951268],
            [0.334850176323452, -8.653323497041978],
            [0.3340853111389607, -8.65817842124703],
            [0.33749971845501486, -8.659670383177886],
            [0.33151266514472943, -8.662657215597099],
            [0.3278423577445325, -8.667899144556639],
            [0.32771057796211156, -8.673806809750209],
            [0.32297999050763493, -8.676811700346327],
            [0.31777735221403375, -8.675289420377887],
            [0.3099389179587259, -8.670176083263872],
            [0.3083374495250941, -8.667714515787946],
            [0.3030952328037637, -8.667404645842248],
            [0.2973602693895958, -8.664591283832605],
            [0.29343142695833374, -8.665056444658529],
            [0.29037108101591336, -8.66318435680969],
            [0.28499712464411875, -8.662803777065827],
            [0.2829225823587995, -8.667467131211803],
            [0.27892160885437745, -8.660784154008175],
            [0.27372914696619255, -8.657177425750122],
            [0.2692504924753987, -8.657412540649034],
            [0.2661708694010438, -8.654218014150322],
            [0.25668865817795655, -8.654214723788542],
            [0.2530332203568751, -8.65733538734616],
            [0.24989794716730562, -8.654510314333562],
            [0.2395977328391924, -8.654000125369347],
            [0.23255079850134547, -8.645914437968878],
            [0.22829200191571342, -8.635469869798026],
            [0.2250957918125261, -8.637494054574603],
            [0.22021020542675931, -8.636575086624395],
            [0.21683395694329416, -8.633501280993341],
            [0.21069571699402448, -8.633717424283667],
            [0.17506610656819027, -8.63904980328831],
            [0.1550211751675819, -8.642982889238771],
            [0.13946234307984143, -8.644718291579895],
            [0.0867180516023546, -8.652711621969061],
            [0.027643455930975742, -8.661526094117065],
            [0.015276706895694294, -8.66353096031566],
            [-0.042714214730427164, -8.663722379108574],
            [-0.04979878344865921, -8.657389559281357],
            [-0.07403595553785733, -8.683701931584082],
            [-0.07551660593677763, -8.661491823664111],
            [-0.08152961865568083, -8.657914933348636],
            [-0.08446847589682614, -8.652536541137001],
            [-0.0828477114566347, -8.644292581591555],
            [-0.08373287042379371, -8.622406783204474],
            [-0.0896623764493154, -8.608074279686342],
            [-0.10036318343740584, -8.598684476220763],
            [-0.09517329957274129, -8.583685098272325],
            [-0.10779572248633408, -8.579678949312521],
            [-0.12636624054993756, -8.577662636667297],
            [-0.12950531761013614, -8.56445805968327],
            [-0.14238353715586388, -8.570812615160323],
            [-0.15369342859873308, -8.583459544911115],
            [-0.17133932118936107, -8.58094002416358],
            [-0.19860293272229332, -8.589290096142548],
            [-0.2037654540280574, -8.578632865398495],
            [-0.21042267432073794, -8.575947035751947],
            [-0.22226878763835173, -8.567511038652105]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.40346860708013,
          "lat": 30.214496799179937
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48477"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "477",
        "coty_gnis_code": "01384024"
      },
      "bbox": [
        -0.22226878763835173, -8.683701931584082, 0.3940149608696966,
        -8.33303894503846
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.674073775263713, 2.8161998111308795],
            [-11.669349213858606, 2.8105013324305825],
            [-11.665661607044369, 2.808622638839165],
            [-11.659567857316155, 2.8150327158327757],
            [-11.65182174891404, 2.8157448820875097],
            [-11.644016174429296, 2.8083655158278558],
            [-11.639392410936305, 2.801557073061211],
            [-11.637922239217895, 2.796890318482855],
            [-11.633689414931837, 2.7925475149812664],
            [-11.633225927650034, 2.78916118772193],
            [-11.635025295168955, 2.783159286351053],
            [-11.63354638298034, 2.780516304210116],
            [-11.62444493166754, 2.785701738011255],
            [-11.618391922264, 2.7870037122516838],
            [-11.609305955488907, 2.7858800548491347],
            [-11.607619559820481, 2.783923032598722],
            [-11.598736835554849, 2.782178183358447],
            [-11.592106320341037, 2.7877986720591683],
            [-11.582348243527022, 2.789860361159183],
            [-11.574365892957605, 2.796664466104112],
            [-11.571018142455149, 2.794138553780757],
            [-11.57149440677986, 2.788985283470586],
            [-11.57041777860368, 2.7850233536648634],
            [-11.571787689952924, 2.7818935435872234],
            [-11.566717724329978, 2.780824896624401],
            [-11.564200975600789, 2.7773092231298424],
            [-11.567534318732498, 2.775539297105421],
            [-11.56622438558919, 2.768878175815525],
            [-11.56305251762803, 2.7644467972799],
            [-11.5602827295131, 2.7656923362269255],
            [-11.555885057002083, 2.763464292013304],
            [-11.558151571587826, 2.759995827115585],
            [-11.557014843864307, 2.754677806486586],
            [-11.55227028107281, 2.7515193095157127],
            [-11.54732551354321, 2.7505666666973188],
            [-11.547853761284173, 2.7469204631182556],
            [-11.54243969135201, 2.742787509433181],
            [-11.534396865906086, 2.74146386029165],
            [-11.528612183545386, 2.74317386173405],
            [-11.52407144726849, 2.740875821963552],
            [-11.511753335378678, 2.7461559223175454],
            [-11.50001570063091, 2.7523595784333037],
            [-11.489452829027918, 2.760365525914779],
            [-11.484832924941262, 2.768599990476826],
            [-11.479248660952353, 2.7690829807196615],
            [-11.47261904471289, 2.778084355200135],
            [-11.466053336692449, 2.777769099514544],
            [-11.457371061251013, 2.7849108977283703],
            [-11.450062998725922, 2.7880891738342775],
            [-11.44772441024396, 2.7876147036190595],
            [-11.44689991308814, 2.783274193155963],
            [-11.443258492453266, 2.779215772145225],
            [-11.43385217532089, 2.780478278659018],
            [-11.429306487913534, 2.7844337020742174],
            [-11.427414771436942, 2.7820415647882792],
            [-11.422472526463913, 2.781639301745416],
            [-11.419009297001766, 2.7888985162352307],
            [-11.413811137846322, 2.788021598196387],
            [-11.410073570364426, 2.791292118328401],
            [-11.405284636162442, 2.793170538789965],
            [-11.398530911492584, 2.7922595380856743],
            [-11.394408729622512, 2.795923903704439],
            [-11.38376011678249, 2.7986606109228367],
            [-11.38429404793424, 2.8060465693217354],
            [-11.380133075376566, 2.8139936544221307],
            [-11.377019349042758, 2.814529673987117],
            [-11.374184817074505, 2.8181477031708493],
            [-11.36501046125679, 2.820613163836831],
            [-11.358682640179394, 2.8262441738808586],
            [-11.346138936072522, 2.817384787756809],
            [-11.342646663552207, 2.818261470930174],
            [-11.338681027648052, 2.8257082382890935],
            [-11.332073942130359, 2.8218948520768947],
            [-11.32812303593387, 2.8170315838599373],
            [-11.32458540076813, 2.8189873554013936],
            [-11.321350968144396, 2.823610752556287],
            [-11.311954942495623, 2.823244742918408],
            [-11.309679432557827, 2.824764706908389],
            [-11.30038864928621, 2.8187049841234693],
            [-11.293123980345792, 2.8194335262409775],
            [-11.291182513220175, 2.823008400731202],
            [-11.283492178130723, 2.826018221020111],
            [-11.280381532434449, 2.8341788941354533],
            [-11.275932289127844, 2.8356042521021743],
            [-11.271599656183321, 2.8342007589484934],
            [-11.267939574002401, 2.83860494549792],
            [-11.266617025426271, 2.8423379271000044],
            [-11.263342926621302, 2.844332676650407],
            [-11.259778160142103, 2.8491930136338324],
            [-11.24695190251174, 2.8444324091777307],
            [-11.239746582232286, 2.843953132997905],
            [-11.23624289291675, 2.841913913536392],
            [-11.23240586522068, 2.8472183863157747],
            [-11.23189598285204, 2.852299244345421],
            [-11.228380453733037, 2.8543523625450624],
            [-11.22539971289208, 2.8529965222032407],
            [-11.223984029790767, 2.8476402284349636],
            [-11.219251081508697, 2.842737502016954],
            [-11.215278278060218, 2.8280940987973255],
            [-11.210952891352628, 2.820402152415261],
            [-11.214030576392659, 2.8169102634276966],
            [-11.216096103798257, 2.8111343233655277],
            [-11.214911698514213, 2.807627994132984],
            [-11.215758860020674, 2.79988815310584],
            [-11.218441107371792, 2.7932620657315845],
            [-11.221560987983839, 2.7905879474742856],
            [-11.223861804252257, 2.7772993988603725],
            [-11.227066873213648, 2.774936570150323],
            [-11.224851358117935, 2.7670621125023174],
            [-11.226077187290894, 2.760995866665729],
            [-11.229767798562563, 2.7566460245100552],
            [-11.233940308207401, 2.754907774465467],
            [-11.234689200705027, 2.752319908095641],
            [-11.244319427892426, 2.744370564081166],
            [-11.252963274668843, 2.745436008597562],
            [-11.255909428140074, 2.742123069236317],
            [-11.264964732890524, 2.7353910393987415],
            [-11.266519362492181, 2.729803934157197],
            [-11.263630968815628, 2.7235737854836026],
            [-11.26584330984753, 2.719699154262387],
            [-11.263151532824155, 2.7109847300663863],
            [-11.259863959225427, 2.7099409821971174],
            [-11.253384895237225, 2.7123100355526177],
            [-11.248566183116628, 2.7068420400235818],
            [-11.246962371706829, 2.6974810541180907],
            [-11.243742476342973, 2.6958354749520566],
            [-11.24486016502547, 2.688496324474507],
            [-11.237845522713712, 2.6874007221417697],
            [-11.241345580838166, 2.6659831332507187],
            [-11.234356341137016, 2.6648781206066467],
            [-11.234985308448923, 2.6612332412006365],
            [-11.231426859081468, 2.660665356492569],
            [-11.234448630122227, 2.6428462657428575],
            [-11.230909921066935, 2.6423247101726886],
            [-11.231926905430603, 2.635135879249216],
            [-11.21108514114981, 2.630671225771428],
            [-11.176198914388106, 2.6254268257324074],
            [-11.177527110887224, 2.6182788612556593],
            [-11.174055480301783, 2.6176150722632956],
            [-11.174722585522153, 2.6139915004064593],
            [-11.172055919916126, 2.60985048511495],
            [-11.16514202803427, 2.608614355317606],
            [-11.166446032290489, 2.6015306460380683],
            [-11.159513529762664, 2.600338099694707],
            [-11.160602080247015, 2.5943710638736523],
            [-11.155731044369873, 2.5891700180754533],
            [-11.155512116924552, 2.585721852165729],
            [-11.151242467604938, 2.580148868388898],
            [-11.153900745121588, 2.578737504168664],
            [-11.155532034139016, 2.5739621993438067],
            [-11.1607269447021, 2.5689922773830967],
            [-11.163016608987046, 2.5653278243896986],
            [-11.169081379538317, 2.5614905140776147],
            [-11.165674368404524, 2.557309212121689],
            [-11.166114777349955, 2.5535490614053984],
            [-11.161024596717876, 2.549625437401533],
            [-11.153170527561839, 2.549882854539522],
            [-11.148435829046763, 2.544122761273265],
            [-11.137769901029685, 2.5448167064200793],
            [-11.135081767774468, 2.5501970081992],
            [-11.128481823478602, 2.5497622225731247],
            [-11.125386157671302, 2.5458965679815853],
            [-11.121310635787685, 2.5491163353097583],
            [-11.114166919962814, 2.5462502628941928],
            [-11.110108526598829, 2.5485491022046127],
            [-11.107566544960589, 2.547685292410173],
            [-11.10405059727867, 2.541898621910834],
            [-11.09858932706713, 2.537555978123916],
            [-11.09191859519085, 2.537426721493583],
            [-11.08857319266123, 2.534633462495137],
            [-11.081123188103598, 2.534444819174107],
            [-11.075701735807801, 2.5273697024940858],
            [-11.070311634268972, 2.5316162337508827],
            [-11.06521617670051, 2.5311562282991833],
            [-11.060327795615539, 2.5265831777196714],
            [-11.061888697384196, 2.5173384180732685],
            [-11.054627656776791, 2.5146049715906997],
            [-11.052279442968537, 2.511621126422259],
            [-11.053234657876038, 2.5076565634430126],
            [-11.049756452599357, 2.506792361197424],
            [-11.042813512666019, 2.4982115459787844],
            [-11.04174350130978, 2.4910982834634257],
            [-11.038808669446192, 2.4893077078051355],
            [-11.034913117889346, 2.4799490510061357],
            [-11.03791560665471, 2.4751259196941757],
            [-11.042446110071207, 2.474984315587904],
            [-11.042502164352506, 2.466238584403332],
            [-11.044574382343777, 2.4607235994920993],
            [-11.040158435183125, 2.4473270720097204],
            [-11.039584242687038, 2.4431696470949436],
            [-11.035315184557597, 2.43758925659865],
            [-11.037121992927979, 2.4353693293886978],
            [-11.030037838528838, 2.429494290567777],
            [-11.023140193082316, 2.4156837064289096],
            [-11.02354731404647, 2.410475864761621],
            [-11.01780959226417, 2.401029166588397],
            [-11.018288359575209, 2.397366720601285],
            [-11.021790567835103, 2.3923725666322984],
            [-11.020368449482758, 2.389305925409996],
            [-11.025125375863254, 2.381714072398471],
            [-11.021491414850678, 2.378054307437028],
            [-11.020869644954022, 2.371487299863873],
            [-11.022070166052243, 2.3664123638125596],
            [-11.021402961910756, 2.3579210030033635],
            [-11.02512154919728, 2.3535567795468113],
            [-11.030843203158447, 2.340836991692222],
            [-11.03464103555333, 2.3388899486735006],
            [-11.034761457208957, 2.336124223251096],
            [-11.038010399889743, 2.329893946563064],
            [-11.041648217600056, 2.3274647147502963],
            [-11.043299987097985, 2.321668848672101],
            [-11.040925272115958, 2.3157604829089973],
            [-11.04375752785021, 2.310363627073244],
            [-11.041145998373887, 2.3050175479611763],
            [-11.045790498447449, 2.301354627583673],
            [-11.053346764924678, 2.292278321146519],
            [-11.051986063222078, 2.2901094245874436],
            [-11.05239573626157, 2.2838213551697986],
            [-11.048954091557208, 2.2795235299513186],
            [-11.047829552923538, 2.274164174862508],
            [-11.039686539410123, 2.2697427043027503],
            [-11.036544593195423, 2.27374088420292],
            [-11.029281322305762, 2.2753591816172607],
            [-11.02140420274485, 2.279292656494791],
            [-11.019025043590302, 2.2717258706750125],
            [-11.019671803533782, 2.268047990932738],
            [-11.018692468059118, 2.2617455773501667],
            [-11.014119520663016, 2.259339868970165],
            [-11.013937206118595, 2.253085258288416],
            [-11.012170927986421, 2.2493914568058013],
            [-11.005831105179837, 2.244383420397706],
            [-11.002475380864476, 2.2381738920801477],
            [-11.00106390375571, 2.230691090697395],
            [-11.00303587351077, 2.223341871082702],
            [-11.00134093216301, 2.216931814860861],
            [-10.997435336083822, 2.2183026685563143],
            [-10.994443249320092, 2.2158862378495066],
            [-10.991987196318396, 2.210342880773521],
            [-10.984822234541193, 2.2111285373751426],
            [-10.98408713079805, 2.2081967010862784],
            [-10.979204106264884, 2.201707692246833],
            [-10.980547069625006, 2.199409681125054],
            [-10.976959062391943, 2.19290098137364],
            [-10.973439841475049, 2.192525462869266],
            [-10.970007110708131, 2.18955142355398],
            [-10.970108158879542, 2.183306842978943],
            [-10.972403299906397, 2.178814220315976],
            [-10.980069231327466, 2.174279098606817],
            [-10.982189202872714, 2.1702303713864604],
            [-10.973314372606355, 2.164882946235561],
            [-10.946834673680936, 2.160350948677457],
            [-10.953745484713432, 2.11739689991397],
            [-10.861360461321741, 2.1022793319931936],
            [-10.810084818409052, 2.0941552946697164],
            [-10.784540818924658, 2.090181408201599],
            [-10.798220102731973, 2.004094886171484],
            [-10.964406433068667, 2.031330713040252],
            [-10.964709668587519, 2.029441481049969],
            [-11.091154322409267, 2.050588731085896],
            [-11.13570446231262, 2.0578328668928636],
            [-11.135815485623185, 2.0571499077860405],
            [-11.285230686073254, 2.08123485858041],
            [-11.302281563306888, 2.084027453211809],
            [-11.30208714213544, 2.0849348397331675],
            [-11.337202932229403, 2.0905896804243813],
            [-11.387432970588991, 2.0989684092219205],
            [-11.413249960389109, 2.102864325589068],
            [-11.47215603247403, 2.1124646317816986],
            [-11.481212903592835, 2.1124485189923856],
            [-11.478400772520306, 2.1181291011785732],
            [-11.470362359939115, 2.127976074700995],
            [-11.464218118004768, 2.132549668301926],
            [-11.46398069601571, 2.1402599784222054],
            [-11.45969450956681, 2.149091239372578],
            [-11.452851278027572, 2.1492436682151017],
            [-11.449783473092513, 2.1515770818574094],
            [-11.45105879344004, 2.162023308664959],
            [-11.463564066106041, 2.1761510449419004],
            [-11.464979426321344, 2.18450246459443],
            [-11.461559674874668, 2.190602486563512],
            [-11.468316035283562, 2.1998216871606022],
            [-11.47501491513477, 2.2018897663557873],
            [-11.47813620282423, 2.2071763997731733],
            [-11.47690438622906, 2.210619504978824],
            [-11.480257694360954, 2.213003317431386],
            [-11.480044385229117, 2.2182019062712715],
            [-11.477665727036646, 2.224943684727781],
            [-11.478840520049523, 2.2299094944486466],
            [-11.481944177160917, 2.2351924363433087],
            [-11.489747491531551, 2.2407053249511417],
            [-11.491777687874517, 2.245037817443856],
            [-11.499554939164451, 2.25105788963732],
            [-11.50148795875205, 2.255866290222321],
            [-11.50399158019766, 2.2555770857631265],
            [-11.50991597768981, 2.246028647389406],
            [-11.51026125575202, 2.239667943998878],
            [-11.512468553647778, 2.2336159371175834],
            [-11.51837807203508, 2.234220520181724],
            [-11.526847061296792, 2.2279760284800103],
            [-11.53328501706109, 2.227511988732107],
            [-11.533645840591673, 2.223098619010709],
            [-11.541170705572327, 2.220448583978037],
            [-11.551423743132936, 2.2230635892073867],
            [-11.554423828204445, 2.219707563728739],
            [-11.558590107911522, 2.2185589130280667],
            [-11.56012473546268, 2.2152739832128203],
            [-11.564300722840638, 2.2150057592199124],
            [-11.566978787377783, 2.216786156927617],
            [-11.574501670007864, 2.2138320335955397],
            [-11.580735833769383, 2.203719225533032],
            [-11.585617524076396, 2.2009641703875285],
            [-11.587040567199944, 2.1954032807552397],
            [-11.593259322287688, 2.1869236955645484],
            [-11.595950431608639, 2.1865552904923184],
            [-11.602243245121567, 2.1804943765061737],
            [-11.601813900051551, 2.178347389386908],
            [-11.611278977495923, 2.173428146103484],
            [-11.611857204120891, 2.1687971945422087],
            [-11.615545175022573, 2.1591229173630175],
            [-11.620419685166373, 2.1624145987305985],
            [-11.624488431063781, 2.1554165092406934],
            [-11.627725846087772, 2.151729029721531],
            [-11.62767892985714, 2.142416305462932],
            [-11.634238950336727, 2.1344747483177895],
            [-11.638964905630779, 2.1352135757062967],
            [-11.64884829018043, 2.1411981258086072],
            [-11.650583350235777, 2.135009773887137],
            [-11.65433952002417, 2.132189587118956],
            [-11.660912428460655, 2.131505287743145],
            [-11.661402760895509, 2.1288406704363227],
            [-11.666480744356196, 2.12789161698139],
            [-11.671600432988066, 2.1253427238774507],
            [-11.675444862440735, 2.1210016821497035],
            [-11.67922677255245, 2.121056618622273],
            [-11.680947331536347, 2.117421604082523],
            [-11.685433508088538, 2.1166359321339745],
            [-11.689348123725388, 2.11948047677161],
            [-11.694824823062136, 2.118580610743905],
            [-11.697687715468529, 2.114299360705788],
            [-11.70399621755781, 2.1158439163903924],
            [-11.709173809721252, 2.121441375561939],
            [-11.713604624132682, 2.117524179143344],
            [-11.720992250785665, 2.1203154514743368],
            [-11.721938367166894, 2.1229735731691286],
            [-11.728844339241055, 2.1248107434148436],
            [-11.726341207055984, 2.1285845511531747],
            [-11.72543064530622, 2.1331276219007833],
            [-11.72066955517526, 2.135898938750595],
            [-11.71593005808404, 2.141225981229493],
            [-11.718038785387838, 2.143459339536675],
            [-11.714604707566197, 2.1509327219790193],
            [-11.710852261720378, 2.1526538420437484],
            [-11.704902639480155, 2.1673839650921445],
            [-11.702341331702454, 2.1695131134655],
            [-11.70458103080351, 2.1737584091626014],
            [-11.704665790107386, 2.177943095420636],
            [-11.708051733991235, 2.180364454131257],
            [-11.705847544442825, 2.1875409852932557],
            [-11.708323693251556, 2.198075967677375],
            [-11.708240450975556, 2.2063714049692176],
            [-11.70490060792022, 2.20664131532868],
            [-11.699672961089757, 2.209643199827829],
            [-11.694953244249728, 2.2154103595185988],
            [-11.689096176192544, 2.2187576324725704],
            [-11.688250344585875, 2.2255598663138847],
            [-11.683744718233411, 2.2291019296154952],
            [-11.687549861331922, 2.2366640770498942],
            [-11.687523434735207, 2.2433490843977983],
            [-11.693634881807393, 2.251181170029795],
            [-11.700098827699225, 2.2541563935694016],
            [-11.69894990131561, 2.257841662966394],
            [-11.70099069395895, 2.2669400194840126],
            [-11.706062081270577, 2.2704076848356016],
            [-11.714172228485562, 2.272540370055951],
            [-11.712321593144079, 2.2784421265601567],
            [-11.714277360925205, 2.2817003160463907],
            [-11.711563633748783, 2.286079482951353],
            [-11.71005982917878, 2.291779543135215],
            [-11.702718512276073, 2.2968820688770704],
            [-11.703517184518777, 2.299370398443402],
            [-11.708359219505427, 2.302995772732039],
            [-11.708261971160804, 2.3089238480974754],
            [-11.711698114483955, 2.3149537207901525],
            [-11.711404786729641, 2.318173087188823],
            [-11.721986321425122, 2.320260629607891],
            [-11.727693041735634, 2.3246801464421925],
            [-11.729473242342646, 2.3300654429768906],
            [-11.733106191817903, 2.3350572319488623],
            [-11.732545872506055, 2.3379628212471335],
            [-11.738538347491062, 2.3428907624167135],
            [-11.737630068692521, 2.3469643134716773],
            [-11.74029530667237, 2.350325719730295],
            [-11.74312125237981, 2.357286279645919],
            [-11.74601779197571, 2.35931574333893],
            [-11.750701292571586, 2.3596765357147147],
            [-11.753110846235877, 2.3633854779454695],
            [-11.757076153901762, 2.3646925331206408],
            [-11.753573620743337, 2.3720443272565417],
            [-11.753215779196843, 2.379285428808109],
            [-11.749197663911655, 2.3848892255469085],
            [-11.746472223782975, 2.3913410825882813],
            [-11.749473913030208, 2.401448288669335],
            [-11.748718529120827, 2.403646951115762],
            [-11.75170620743234, 2.412875145929825],
            [-11.747905557508645, 2.4197792349618927],
            [-11.74282819633337, 2.4180398925364743],
            [-11.741697845079823, 2.4199726241351613],
            [-11.74291360559706, 2.429841306835256],
            [-11.738173804365273, 2.437042495112313],
            [-11.727505729512645, 2.438849633274904],
            [-11.72508890439664, 2.448260251983379],
            [-11.719130478348747, 2.4560211981555327],
            [-11.721863999194573, 2.4579710012558404],
            [-11.7218451016812, 2.4619754339953857],
            [-11.725376962999986, 2.464276102744014],
            [-11.727093124343876, 2.4690998789461833],
            [-11.725920322605772, 2.473440284263195],
            [-11.731579240453469, 2.4784753434653126],
            [-11.733944393478275, 2.4826088082578788],
            [-11.731255509915849, 2.4861108667410963],
            [-11.729282642196438, 2.492437272602266],
            [-11.725013082859848, 2.497298528928101],
            [-11.727281143916363, 2.4997713448827295],
            [-11.728357435733304, 2.5056687560854582],
            [-11.719889917011388, 2.5120781415001496],
            [-11.716193852209186, 2.512273620606727],
            [-11.709223276242529, 2.5199419600059834],
            [-11.704576721774476, 2.518584025497026],
            [-11.703886214983234, 2.526082308369228],
            [-11.708224868426107, 2.527512264447084],
            [-11.708207408890177, 2.5307177288876206],
            [-11.703310032126689, 2.5383937770136322],
            [-11.702364800154138, 2.543213598539491],
            [-11.710600744598302, 2.5481992093927817],
            [-11.70749719360068, 2.5521496918851994],
            [-11.707916193106813, 2.555695829957583],
            [-11.70018524301787, 2.5600414393750066],
            [-11.703651121227951, 2.5633652466440173],
            [-11.704688498094988, 2.568089151903667],
            [-11.708336697890253, 2.5664351673374477],
            [-11.713297615657478, 2.569585426650399],
            [-11.713601245060548, 2.576039910981308],
            [-11.717819555101586, 2.5789629202454933],
            [-11.719287370412447, 2.5838408406606246],
            [-11.71608650209062, 2.600805483073058],
            [-11.719402434233343, 2.6019865556778066],
            [-11.717955029949376, 2.6100925375458246],
            [-11.723092130378948, 2.6174877919412736],
            [-11.72285597930992, 2.6219870386734043],
            [-11.71920100573566, 2.6260654559711147],
            [-11.71490343570458, 2.6461110275144617],
            [-11.715209496045375, 2.6525838749885544],
            [-11.718488351941225, 2.6593129608395154],
            [-11.71961286831175, 2.6657802547849405],
            [-11.71750822005317, 2.67032716030392],
            [-11.71500306625734, 2.671163623969123],
            [-11.713465752819, 2.6755483020320527],
            [-11.71563841635427, 2.678933353525997],
            [-11.711146191973922, 2.6817957038881337],
            [-11.702392540209118, 2.6830991035402865],
            [-11.698481984632682, 2.686213303660085],
            [-11.70110770757242, 2.6969389277971145],
            [-11.703623354295896, 2.7000337553221083],
            [-11.704564218099005, 2.7067357275195434],
            [-11.708111734294851, 2.7124417652383825],
            [-11.706546145597141, 2.7203787577756535],
            [-11.702043848912428, 2.724301686417101],
            [-11.705061485920584, 2.732036257084113],
            [-11.70808852655609, 2.7356252040135107],
            [-11.708926304660645, 2.7415046498613016],
            [-11.706891903191178, 2.74361918126993],
            [-11.705012796783107, 2.756520337257265],
            [-11.701611616963795, 2.767627881640915],
            [-11.698151693291932, 2.773300976269823],
            [-11.70404661042224, 2.7845513434122857],
            [-11.70662754089355, 2.785679264591189],
            [-11.707845613375895, 2.7992371164875376],
            [-11.707307674423914, 2.8068252363358672],
            [-11.704657523550745, 2.8134977280839535],
            [-11.691859476532127, 2.8143407945541496],
            [-11.686763534486014, 2.819864275185865],
            [-11.674073775263713, 2.8161998111308795]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.67023900634459,
          "lat": 40.11989670431489
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49049"],
        "coty_name": ["Utah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Utah County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01448038"
      },
      "bbox": [
        -11.757076153901762, 2.004094886171484, -10.784540818924658,
        2.8543523625450624
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.806134132737068, 3.4623661303483217],
            [-11.692435871769653, 3.572308248243131],
            [-11.665772635480318, 3.598147857640762],
            [-11.57353430601559, 3.687170710830733],
            [-11.496407606656453, 3.6742627565732575],
            [-11.419730309971628, 3.6608235437862136],
            [-11.414645535818467, 3.666685971026433],
            [-11.412278821836402, 3.6674278222680816],
            [-11.403593523794964, 3.6655687436007027],
            [-11.399943373605396, 3.667548175847245],
            [-11.398806656697257, 3.6704825918307815],
            [-11.392975638528187, 3.6700548408479334],
            [-11.390124894219763, 3.672906849614463],
            [-11.378867472546185, 3.6762598329510676],
            [-11.372197126367062, 3.680464160151554],
            [-11.366800372131655, 3.681413706314533],
            [-11.373513133206872, 3.695177980562349],
            [-11.37115292002036, 3.7027531226773975],
            [-11.36613825077272, 3.7085934155458373],
            [-11.364801271901628, 3.7118580689086933],
            [-11.362619829961494, 3.7260521659120287],
            [-11.364615417076168, 3.730918198710409],
            [-11.364289263822203, 3.7366897852230454],
            [-11.357117868312255, 3.740673360496127],
            [-11.35164006341282, 3.748608893958034],
            [-11.34891967891159, 3.7427467193653285],
            [-11.343363078228803, 3.7370662911384955],
            [-11.34088361893921, 3.7331210629210503],
            [-11.33988348049646, 3.7281762686420765],
            [-11.335001475520667, 3.7277322273745193],
            [-11.332366298738782, 3.7238324775604226],
            [-11.325583937540795, 3.7223502798689423],
            [-11.318496548282207, 3.7245811375320135],
            [-11.314304513317643, 3.7270384360768727],
            [-11.306410700801274, 3.72488115716483],
            [-11.304513086188736, 3.729346163817478],
            [-11.299539861827114, 3.7321366642952003],
            [-11.290782650664418, 3.726229322866092],
            [-11.296383645367017, 3.721866014827323],
            [-11.297229168677827, 3.7176755639777017],
            [-11.294990935483636, 3.7147684284473907],
            [-11.295513801187337, 3.709628089402011],
            [-11.291745576264942, 3.702594954412886],
            [-11.287440847169167, 3.702852327517482],
            [-11.286779008499737, 3.6994047804955708],
            [-11.282225952954024, 3.696526220327534],
            [-11.273853901794089, 3.6929954592655414],
            [-11.271856740858723, 3.6893372027788196],
            [-11.264612643909873, 3.688662122620588],
            [-11.26342896832304, 3.6909797015299493],
            [-11.257174318463719, 3.6898094187413664],
            [-11.253172739800306, 3.6852385613569725],
            [-11.247677035803198, 3.6856477025539838],
            [-11.240400194894026, 3.687566256356479],
            [-11.237277738224739, 3.685968665646303],
            [-11.235844545003282, 3.6788488274228395],
            [-11.228040813460161, 3.66983949734214],
            [-11.225345449626975, 3.6687902429829404],
            [-11.22161583551454, 3.6616265755590334],
            [-11.21744331113241, 3.659700612955326],
            [-11.211653344775396, 3.660451230933158],
            [-11.206787728429356, 3.658907923168164],
            [-11.198138276818659, 3.662541769538918],
            [-11.190654645113813, 3.6628372128076037],
            [-11.189894901698404, 3.671563256957036],
            [-11.18544299939945, 3.676574904357776],
            [-11.17697439064044, 3.683211145538289],
            [-11.171776454628379, 3.688836257205124],
            [-11.171532721551003, 3.6966186583353777],
            [-11.178615877956043, 3.702211167667381],
            [-11.180713817596345, 3.7092221739937967],
            [-11.176782533140479, 3.709776634164351],
            [-11.172476338018114, 3.7076432816534006],
            [-11.169413358755415, 3.709334824373666],
            [-11.167294539174698, 3.7046008019642116],
            [-11.162000332770525, 3.6996639273855765],
            [-11.156177958727922, 3.7021074843494817],
            [-11.147757136736422, 3.707701546421309],
            [-11.138355675865872, 3.70750655197072],
            [-11.137615484019042, 3.702296045594899],
            [-11.13386400855215, 3.6925401737539105],
            [-11.131311570850354, 3.6887623638016938],
            [-11.131535592990398, 3.6850708923861113],
            [-11.12833913902456, 3.6822131304824057],
            [-11.125466251013238, 3.682658578106513],
            [-11.124261347088645, 3.6868522042723657],
            [-11.12141095567687, 3.6903234668725955],
            [-11.11418403929415, 3.6929739663090366],
            [-11.110998677250137, 3.6917736049176844],
            [-11.104203754129118, 3.6954966615700564],
            [-11.099798677876528, 3.6940032347399487],
            [-11.098963676982459, 3.6913704218537955],
            [-11.094318626025885, 3.690884705503486],
            [-11.090500979775552, 3.6921345761738564],
            [-11.083093645188578, 3.6881479906558914],
            [-11.079398201045631, 3.687429683059039],
            [-11.071274680021965, 3.6967133532142524],
            [-11.069352785798246, 3.692529610768696],
            [-11.064384053643451, 3.6897028623197627],
            [-11.058717390637408, 3.690476167114891],
            [-11.056851967995613, 3.689167695412837],
            [-11.056400021085498, 3.6787728094656234],
            [-11.052320054115421, 3.67359188740767],
            [-11.049065081506999, 3.672728676008805],
            [-11.044179684699747, 3.674246683611219],
            [-11.041620924011346, 3.6772721447741947],
            [-11.034032837226313, 3.6774510873734094],
            [-11.0302782359868, 3.682580849404847],
            [-11.025083678188588, 3.6832163248774465],
            [-11.02272177642837, 3.677746933909356],
            [-11.02452397891635, 3.673870877215579],
            [-11.019555692454345, 3.6707307312507407],
            [-11.019407586481654, 3.667796209267204],
            [-11.013405235880958, 3.6626438345069596],
            [-11.00920442979504, 3.6620442721688726],
            [-11.007490453228986, 3.658173065907534],
            [-11.00292748609322, 3.655827552631836],
            [-11.00662743595223, 3.646988056364035],
            [-11.007051273167543, 3.6407161718513583],
            [-10.998750921373848, 3.635910282246965],
            [-10.996260253262905, 3.6328346321692626],
            [-10.996349886727295, 3.628605762965893],
            [-10.987044767330048, 3.6257337163695125],
            [-10.987102208437665, 3.620929793841017],
            [-10.984010247801013, 3.618471851371731],
            [-10.980591796948517, 3.6184193094089387],
            [-10.978760306864448, 3.6136408553371004],
            [-10.970720673707278, 3.613152432638449],
            [-10.969011509413525, 3.6110047845069206],
            [-10.972234861339313, 3.606470466858269],
            [-10.97384915776307, 3.596956687383925],
            [-10.978559851199647, 3.592368770334522],
            [-10.982131823387542, 3.5937325630058656],
            [-10.985496230079747, 3.5898738908896886],
            [-10.98556681478307, 3.583071735056516],
            [-10.987673968551311, 3.5752681209938575],
            [-10.991849479760617, 3.5748522053533085],
            [-10.993662198106732, 3.5711250427278665],
            [-10.997527175270584, 3.569182406972878],
            [-10.997638868822479, 3.563966722274277],
            [-10.995167295840673, 3.5591948144055556],
            [-10.995331112485006, 3.551019848461628],
            [-10.993339603250602, 3.5471370375178717],
            [-10.99648768725378, 3.545210333208851],
            [-10.99494525183955, 3.542128856812311],
            [-10.99850978720524, 3.54056086574207],
            [-11.000930646505715, 3.5349336426392144],
            [-11.000513608270186, 3.5312868091745018],
            [-11.01082192760647, 3.5281100718068656],
            [-11.011756816042029, 3.522745218389504],
            [-11.015036688112275, 3.521915204298184],
            [-11.01875678711516, 3.518391266255259],
            [-11.017979965195181, 3.5138102952157135],
            [-11.023286743607132, 3.5122716533989133],
            [-11.02440233740993, 3.508082314949144],
            [-11.02934137565455, 3.507900027606759],
            [-11.029745725462359, 3.5025784419474633],
            [-11.042989536077952, 3.5004525829734776],
            [-11.041393060794041, 3.495983189126448],
            [-11.046307787746995, 3.4904147778529233],
            [-11.047184250501763, 3.4867805786165733],
            [-11.053060732457512, 3.4918472371268012],
            [-11.05773971065374, 3.4906215270187495],
            [-11.06539598676875, 3.4931826589048507],
            [-11.068186723124237, 3.4921161513088785],
            [-11.070337851427077, 3.4965706435966246],
            [-11.074754876350559, 3.5010596520827915],
            [-11.087321577877425, 3.50450135780731],
            [-11.090977284343092, 3.507410814600165],
            [-11.100041339155512, 3.507545430459322],
            [-11.103182873869079, 3.5087318806937393],
            [-11.109237727374966, 3.5086627311918757],
            [-11.112328398581312, 3.51183810157244],
            [-11.118263776127915, 3.5105567635458343],
            [-11.129052312618395, 3.5028504393245687],
            [-11.128062143790345, 3.4979960491161615],
            [-11.134299458778408, 3.4837622969595765],
            [-11.143105518090199, 3.481066395523593],
            [-11.145683491233914, 3.4755599100274392],
            [-11.151944283445282, 3.475099526613901],
            [-11.157196130915533, 3.4764166211017984],
            [-11.16375092274927, 3.4701916640719226],
            [-11.169118349475813, 3.468572595909046],
            [-11.172836685425828, 3.4655162531781376],
            [-11.178396617016354, 3.468345755453702],
            [-11.183611655963768, 3.4646223459685577],
            [-11.192924396734826, 3.463637886776856],
            [-11.200916887808573, 3.466856351460769],
            [-11.208032758532939, 3.468791359603312],
            [-11.212984473895505, 3.4727784011425156],
            [-11.21539481342668, 3.4731370227198597],
            [-11.218168942522693, 3.47902252450166],
            [-11.225443260468154, 3.4867908258706817],
            [-11.228051025318196, 3.4905872654470502],
            [-11.233812963737478, 3.494072567272951],
            [-11.232709159741614, 3.502748707373744],
            [-11.23464350116166, 3.5052068044081537],
            [-11.238726108489578, 3.506117956229974],
            [-11.244943395200218, 3.500619941847216],
            [-11.252736176828922, 3.5119061810750876],
            [-11.25624201227694, 3.511010050013316],
            [-11.26385916466547, 3.5142636791409503],
            [-11.267169033648123, 3.5120405816651563],
            [-11.271641025970835, 3.5141044737363596],
            [-11.276401573204609, 3.513556158670622],
            [-11.278274918171626, 3.5106235080261374],
            [-11.286659229544188, 3.5039225262601223],
            [-11.29502145975986, 3.5054067081988705],
            [-11.303836167587662, 3.5013365221489665],
            [-11.317788079371507, 3.501845839200107],
            [-11.319931001872733, 3.4984183474000825],
            [-11.330285096198034, 3.493925031612434],
            [-11.328374144156149, 3.486757326323168],
            [-11.330907698404001, 3.48219145787517],
            [-11.335990414453013, 3.4764860926021783],
            [-11.333031722110341, 3.4711112718011234],
            [-11.332724522579428, 3.4667775824701987],
            [-11.32390339853741, 3.4609478611274374],
            [-11.322333217874009, 3.4584439660723807],
            [-11.325529539149368, 3.4528357975621797],
            [-11.32614044676384, 3.4435395516290948],
            [-11.330092768154797, 3.4425997427160295],
            [-11.335735706050158, 3.4441080774826878],
            [-11.351155638465048, 3.446253844775826],
            [-11.357180085208874, 3.4452369487978256],
            [-11.361331428142739, 3.4466634110222545],
            [-11.367048389490327, 3.445827158288461],
            [-11.37343602973555, 3.450962976300064],
            [-11.383595886615689, 3.4524825815580056],
            [-11.390246787685747, 3.4526776423288332],
            [-11.394990329178734, 3.45411649953417],
            [-11.399495568622191, 3.4574893999085274],
            [-11.399598500361956, 3.4629960486093743],
            [-11.402532835372867, 3.466955728350758],
            [-11.408378971090952, 3.4712574839406525],
            [-11.47012441755882, 3.4817038366473168],
            [-11.520181130768313, 3.4903832880653436],
            [-11.566992162510575, 3.498687274445392],
            [-11.576950546139454, 3.4972085488510336],
            [-11.675210360096088, 3.4822771448032843],
            [-11.773466637050655, 3.467330060681233],
            [-11.806134132737068, 3.4623661303483217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.91334132663944,
          "lat": 41.269840583611334
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49057"],
        "coty_name": ["Weber"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Weber County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01448042"
      },
      "bbox": [
        -11.806134132737068, 3.4425997427160295, -10.969011509413525,
        3.748608893958034
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [13.544386302499655, 0.6114145525184848],
              [13.550417778898003, 0.6022251808550614],
              [13.553784467897776, 0.59830252084727],
              [13.565013661452806, 0.5935504325724645],
              [13.569762293002185, 0.5891062486439113],
              [13.576758730900467, 0.5898477896177308],
              [13.58102535458874, 0.5929323835316819],
              [13.581785309616128, 0.5954330953689151],
              [13.598974083887622, 0.5884272226565272],
              [13.611575136609101, 0.6026626592004708],
              [13.614181934398877, 0.6065807560382428],
              [13.617553115926835, 0.6149158143183766],
              [13.61826696967495, 0.6288836832146683],
              [13.619592843394974, 0.638336533875819],
              [13.61870678052281, 0.6403199955273428],
              [13.608609021637657, 0.6469391717748181],
              [13.610676636057645, 0.6525341876941418],
              [13.617570170223443, 0.6539229029900807],
              [13.609122086669847, 0.6607176439303759],
              [13.605414760051975, 0.6624236924416744],
              [13.60457497093267, 0.666080874226539],
              [13.597306469849038, 0.6679961221606512],
              [13.590677046755575, 0.6575916982605532],
              [13.57930192698939, 0.6522553650673953],
              [13.575081778994674, 0.6519744453810913],
              [13.565490098365618, 0.6489213063546079],
              [13.561500311176912, 0.6509736134408995],
              [13.553625405117797, 0.6470675165629346],
              [13.54903742514886, 0.6390295886303194],
              [13.547031264907886, 0.6304740680138876],
              [13.54391799578599, 0.6136038877649951],
              [13.544386302499655, 0.6114145525184848]
            ]
          ],
          [
            [
              [13.685176600978782, 0.545833136514028],
              [13.691375122097796, 0.5444327514939388],
              [13.688034446192562, 0.5395432316578671],
              [13.690419510811328, 0.5339609061924463],
              [13.699990863647031, 0.5319525926580848],
              [13.703573380844903, 0.53384675139459],
              [13.708263645467529, 0.5282573543069049],
              [13.711847947925925, 0.5191153251296503],
              [13.715047580252401, 0.5215408177679872],
              [13.721788327538539, 0.5305669177815882],
              [13.726813772890974, 0.5319579209595006],
              [13.734907891116881, 0.5291658440987792],
              [13.739354387554261, 0.5298929849219846],
              [13.745393144374896, 0.534469889000622],
              [13.750765354681775, 0.532682330026414],
              [13.753588519857423, 0.5399105195078755],
              [13.75075290571168, 0.549867267737019],
              [13.750807262223958, 0.5555090914459913],
              [13.75690780970744, 0.5636727351557691],
              [13.755973671371303, 0.5688644544689387],
              [13.750113927611274, 0.5714070791450436],
              [13.747286472337954, 0.575438734685986],
              [13.748080967156495, 0.5834324978059766],
              [13.743981118453354, 0.5846067175180564],
              [13.736605939847925, 0.5841016997110219],
              [13.730505574062839, 0.5852540769347181],
              [13.725176807325207, 0.5878877412024476],
              [13.722375260926203, 0.5855757117880728],
              [13.714776498187211, 0.5874584071072726],
              [13.709234103780362, 0.5787103673540178],
              [13.704322418298963, 0.5781422199488381],
              [13.703287413910907, 0.5737453519141157],
              [13.69719873653282, 0.5755440347860734],
              [13.696032701952419, 0.5725993524179898],
              [13.695005377193631, 0.5603140964383727],
              [13.692129136836979, 0.5592420514847541],
              [13.684599118137726, 0.5508658123938303],
              [13.685176600978782, 0.545833136514028]
            ]
          ],
          [
            [
              [13.234019180417798, 0.5843204193852406],
              [13.233907043056625, 0.5862680372660277],
              [13.238996219394979, 0.5905287001948921],
              [13.239183131423651, 0.5962408902524009],
              [13.245092224172833, 0.5983218271417582],
              [13.246699487386826, 0.6018659226261248],
              [13.242872909402267, 0.606887480924899],
              [13.248866158498217, 0.6124990304740101],
              [13.251664044087711, 0.613023945408856],
              [13.255273258416185, 0.6203870666322293],
              [13.25151055572118, 0.6243551918231138],
              [13.256078971442307, 0.627264200067838],
              [13.257680335469733, 0.6302038574476323],
              [13.263015706170071, 0.6322741633676221],
              [13.271731080885326, 0.6301667094305269],
              [13.278637972316828, 0.6293352294247095],
              [13.284102950160428, 0.6298438212366371],
              [13.285600836401436, 0.6436925254255511],
              [13.293433692314577, 0.6480834762334983],
              [13.295252044778673, 0.656113193880961],
              [13.301549888950968, 0.6604480605982306],
              [13.301567945612376, 0.6632831970070189],
              [13.304603508489532, 0.6691349264876856],
              [13.304288443266984, 0.6757276189937463],
              [13.306202685237695, 0.6791628905884678],
              [13.299112171169494, 0.6864643745173574],
              [13.29879460905076, 0.6928340682185141],
              [13.29626233045662, 0.6953127092231555],
              [13.299728624748656, 0.711636176423447],
              [13.306977704544018, 0.7116861471000501],
              [13.307010066102986, 0.7290396905883516],
              [13.310126772833692, 0.7343785017262555],
              [13.31157238624634, 0.7414022503901356],
              [13.316026350809183, 0.7521035704715385],
              [13.31987480340739, 0.7519994938034623],
              [13.320368592363456, 0.7569645404208535],
              [13.317539403054381, 0.7579705966960952],
              [13.320603718901781, 0.7664991078288205],
              [13.324568028666366, 0.7701052547654944],
              [13.323635730558154, 0.7731231346100923],
              [13.32693530626794, 0.7798757394272138],
              [13.332314516120695, 0.7820009840950141],
              [13.336541067920384, 0.7871638700345045],
              [13.333003128485048, 0.7926375041520469],
              [13.335617444183029, 0.7984706405550818],
              [13.336696098792052, 0.8041395316025718],
              [13.340689404408666, 0.8055813257804202],
              [13.342091663921131, 0.8093901703286578],
              [13.349152886365397, 0.8078775063408095],
              [13.353909974189177, 0.812376072817279],
              [13.352474343241218, 0.8239398405830108],
              [13.34798243928864, 0.8279092939947128],
              [13.339995011414803, 0.8309659039744255],
              [13.343002808255537, 0.8390792280554097],
              [13.346421554592625, 0.8414513963989656],
              [13.351659302747187, 0.8461082559133484],
              [13.355207200723628, 0.8460991249047388],
              [13.361468178178985, 0.8532294273331109],
              [13.36771215051647, 0.8516088910845501],
              [13.36915359570453, 0.8580980781961844],
              [13.365477202292595, 0.8651092891836987],
              [13.370936298588484, 0.8708892587569782],
              [13.376019112694067, 0.8738288062675262],
              [13.379108934686549, 0.8843876410255568],
              [13.381598472939237, 0.8869576369858801],
              [13.383878775128661, 0.8931701416457339],
              [13.388696661718026, 0.8914395259352357],
              [13.392131107255436, 0.892947590527539],
              [13.390801904451452, 0.9031345965273893],
              [13.391326074600286, 0.9088777873284561],
              [13.40196171769228, 0.9187933795513068],
              [13.536933571591174, 0.8535560194435327],
              [13.574316081912464, 0.8353251872901547],
              [13.655619043373436, 0.7959450978007437],
              [13.671922698926661, 0.788462454872042],
              [13.678726830716908, 0.7922178289420784],
              [13.68483082434258, 0.7942578712867242],
              [13.68981990122249, 0.7921730287896493],
              [13.69349204599452, 0.7887546776647418],
              [13.69798743845514, 0.7878273791501168],
              [13.705487711406592, 0.7793109495840996],
              [13.709991340402237, 0.7786772226260801],
              [13.725049204254312, 0.768043001793464],
              [13.727178256069354, 0.7673280459272451],
              [13.759121281863942, 0.7473690634028517],
              [13.81366216998072, 0.7151955820374751],
              [13.812424781045966, 0.7094618560943444],
              [13.81388922801404, 0.707332424458741],
              [13.81346318182784, 0.7024189709641487],
              [13.811184027764828, 0.6980946619163438],
              [13.811522533723187, 0.6948347024902831],
              [13.808495933752566, 0.6895131766359498],
              [13.80885337049568, 0.687231950094328],
              [13.805198713751032, 0.6795780993888036],
              [13.803919695215516, 0.6717840045782708],
              [13.805900445645406, 0.6669330692524628],
              [13.80597605516402, 0.6590833812480361],
              [13.80505994379895, 0.6552999216303571],
              [13.805681599735491, 0.6463471745969117],
              [13.80309435130252, 0.6447244455588554],
              [13.80419060475981, 0.6369211551407901],
              [13.798653462897226, 0.6300680542647926],
              [13.802072670673413, 0.6233419674248435],
              [13.800716845815646, 0.6210878198949096],
              [13.80681651500395, 0.6175812552301644],
              [13.808997669729361, 0.6119148074930628],
              [13.806797313027099, 0.6043011817666746],
              [13.812268488332679, 0.5997875799891312],
              [13.813323832128757, 0.5896032605433391],
              [13.812318854164424, 0.5857111830537219],
              [13.808355930521001, 0.5859226666334689],
              [13.803057226710028, 0.5806831838239291],
              [13.805386477782097, 0.5728899292306662],
              [13.79602953937867, 0.5647107246629869],
              [13.788389979798616, 0.5596451871187229],
              [13.785086053688032, 0.5586318174566961],
              [13.78226007587938, 0.5531842324202914],
              [13.779713463710321, 0.5523064305912662],
              [13.774057206784024, 0.5444424681762995],
              [13.767005015540555, 0.5333200854213815],
              [13.763638012865131, 0.5306551465153554],
              [13.762553793481436, 0.523931365030444],
              [13.75865837458841, 0.521573803498839],
              [13.750737971838412, 0.5209486163198978],
              [13.746289889879058, 0.5094147551433018],
              [13.748003255013147, 0.4992821701257886],
              [13.74493683988662, 0.4901474850171759],
              [13.745597890405486, 0.48716505251908093],
              [13.74274891034199, 0.4844573152760688],
              [13.739473775967674, 0.48478413961189165],
              [13.732640060269922, 0.47548549005270796],
              [13.733913707996441, 0.4728740684497342],
              [13.73344337309898, 0.46668179763907197],
              [13.73755671275243, 0.4632934783076165],
              [13.744757173600032, 0.4670254159405127],
              [13.745123095158743, 0.46031793195929166],
              [13.742172719484772, 0.45333975407243665],
              [13.741474138066202, 0.4470145114281009],
              [13.744471443251072, 0.43845886255388045],
              [13.738352855108866, 0.4332204007284231],
              [13.730194168876029, 0.4326840864226434],
              [13.729700423753117, 0.42898378080577826],
              [13.724037840838006, 0.42498937711445656],
              [13.714195480925392, 0.42358998928858776],
              [13.708164554670892, 0.4139616582005126],
              [13.705346310634992, 0.40725006776024564],
              [13.70469221610238, 0.4017354600474551],
              [13.707052049057642, 0.3980109456433774],
              [13.697123674761144, 0.3919100423679744],
              [13.690351312718256, 0.3840924469450792],
              [13.687959483802748, 0.3795916876339378],
              [13.68728338154281, 0.3731818016896694],
              [13.684001131053629, 0.3676417717162772],
              [13.68021273447484, 0.3640720634945937],
              [13.67576001925549, 0.35644205490981395],
              [13.666383768772551, 0.3613810987943443],
              [13.664737154305506, 0.3654325091234801],
              [13.649275648074285, 0.362221109414001],
              [13.644447657510543, 0.3603489203119112],
              [13.642174862969359, 0.36696887173973275],
              [13.638321507492781, 0.36855007127469785],
              [13.638266224471527, 0.37181227750271345],
              [13.634926776422798, 0.37834982355248664],
              [13.625874311778487, 0.38431273457417015],
              [13.62136744375309, 0.3792327767908831],
              [13.614206550740132, 0.37846919647048727],
              [13.60480079628499, 0.3737598553308518],
              [13.599484755910952, 0.369413332644822],
              [13.599379003598687, 0.3666005705948111],
              [13.594996341862887, 0.36327175859436234],
              [13.593255184158723, 0.3642671028088017],
              [13.585749406246043, 0.3602333653929313],
              [13.583296547895008, 0.35437099499038177],
              [13.578216139640345, 0.35324296988946235],
              [13.572722079828619, 0.3479528751302412],
              [13.566123550680187, 0.34413863627719543],
              [13.562628226002078, 0.3471491263624097],
              [13.557465516044921, 0.3448209613277461],
              [13.532889957562434, 0.3642138506667611],
              [13.438009553874315, 0.41017810292059076],
              [13.399459450191141, 0.42867094272829703],
              [13.32596669883562, 0.46688296762125303],
              [13.273107016626128, 0.49443385813669755],
              [13.26335286620055, 0.5022873533682679],
              [13.273436464642591, 0.5260155751527165],
              [13.276736955989596, 0.5345225202440395],
              [13.282676518134878, 0.5437530450327075],
              [13.291167437231685, 0.560675767590691],
              [13.29367189851092, 0.5691065970187306],
              [13.294693769353238, 0.5773678552831863],
              [13.28667306454421, 0.5810991021265896],
              [13.28289453648143, 0.5767393238331068],
              [13.278017005782445, 0.5742750466201744],
              [13.272002122932797, 0.5769179332069305],
              [13.26888268347907, 0.5748401642946113],
              [13.264695261260897, 0.5771495398910288],
              [13.25921314538282, 0.5783665134838151],
              [13.25350010227106, 0.5754558656798567],
              [13.248343759001438, 0.5705683992188185],
              [13.243396303640152, 0.5621412054261323],
              [13.240743791889074, 0.5593778373948537],
              [13.234820637612493, 0.5584681250697294],
              [13.22758381855564, 0.5538865067487582],
              [13.223767170745363, 0.5539349956952502],
              [13.222315388050635, 0.558300114141557],
              [13.227668983482266, 0.562303405454961],
              [13.229898624514336, 0.5655775443481624],
              [13.224245692084208, 0.5729025844819735],
              [13.22742996307991, 0.5762023559660231],
              [13.23501298065657, 0.5808142637304384],
              [13.234019180417798, 0.5843204193852406]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.13385362086213, "lat": 38.16444026382986 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51015"],
        "coty_name": ["Augusta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Augusta County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01480098"
      },
      "bbox": [
        13.222315388050635, 0.34413863627719543, 13.81388922801404,
        0.9187933795513068
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.342878571900306, 1.317187871786734],
            [14.345403861209896, 1.3202703287646178],
            [14.358554786769075, 1.3223235332091978],
            [14.365071687237005, 1.321514483541345],
            [14.369228395256046, 1.3164945894578466],
            [14.369734074006388, 1.3103723006478116],
            [14.376627363696818, 1.3088480233392736],
            [14.377383017789155, 1.3066856732892962],
            [14.373080246156231, 1.301286524953175],
            [14.372006724639647, 1.2962806480717364],
            [14.374558623947953, 1.2920998324336643],
            [14.379118081908365, 1.2894307291089118],
            [14.387332414575436, 1.2957275143922868],
            [14.393224405048374, 1.2877623619195808],
            [14.400245336889055, 1.2796225876395535],
            [14.399515180660144, 1.274425251882235],
            [14.40063689218956, 1.2706196669565304],
            [14.39586016450518, 1.2664006202193447],
            [14.399776451936585, 1.261390520079058],
            [14.402861484035187, 1.263363665599157],
            [14.40744737918628, 1.2551189406505678],
            [14.41448254834732, 1.2538526382497839],
            [14.414631035414763, 1.2470079143147625],
            [14.409607998182302, 1.2456430773512395],
            [14.406487094864849, 1.2421781687647586],
            [14.406418768455245, 1.2382260903117304],
            [14.409795488065022, 1.2349811544355864],
            [14.416904327517623, 1.2314093214803263],
            [14.414934543547645, 1.2254674440732958],
            [14.409302392606085, 1.2225540801999866],
            [14.408273594260638, 1.21572279855047],
            [14.413744255865144, 1.21077209461939],
            [14.416346006367911, 1.2099408304590282],
            [14.42080001498885, 1.205326786567081],
            [14.423009189257748, 1.1984603815626405],
            [14.428874086800251, 1.1917829697671398],
            [14.435469037861974, 1.1899017692953457],
            [14.441567689909716, 1.1808424541230569],
            [14.448155331683244, 1.1755293377857041],
            [14.451373830654013, 1.176726772189845],
            [14.455831778638943, 1.1743585022445795],
            [14.462286641410907, 1.1687666254965698],
            [14.466613383483516, 1.1710800931739798],
            [14.469783844611976, 1.165770971757246],
            [14.48016637119167, 1.154936517105705],
            [14.481781164182154, 1.1458347832618125],
            [14.485877830082764, 1.1418685245341773],
            [14.493828308111942, 1.137814732413985],
            [14.494935243273527, 1.1329645459297772],
            [14.499638670651265, 1.1338286626257092],
            [14.49969471699637, 1.1307532536454383],
            [14.50243781291771, 1.123557941125202],
            [14.507104717455686, 1.1203879745138732],
            [14.505796438916006, 1.115435132138431],
            [14.509464945600495, 1.1103724504174597],
            [14.52024119086054, 1.1077576845607386],
            [14.523616995460285, 1.0954474249044925],
            [14.523554849031862, 1.0901520376755391],
            [14.526039291221919, 1.0851785428896548],
            [14.531021490536297, 1.0795940156875203],
            [14.535197965597314, 1.0775917108914894],
            [14.54213032457581, 1.0779562555352724],
            [14.549056091156169, 1.0663540120923494],
            [14.552733529895743, 1.0669429936404131],
            [14.555655332530337, 1.0735482738274948],
            [14.565559772587925, 1.079711572345839],
            [14.573556884676764, 1.0798205463143205],
            [14.574755116614618, 1.0836923345755514],
            [14.580767123094452, 1.0868086818595464],
            [14.58747002230732, 1.0855291949166945],
            [14.593085514371019, 1.0860315615653136],
            [14.59969601407685, 1.0833185707715411],
            [14.611176290212086, 1.081755135887445],
            [14.62310984932859, 1.0773109864148966],
            [14.626215812883094, 1.0784257249286155],
            [14.628673511840024, 1.0759766537751656],
            [14.62896041090562, 1.0677028684027163],
            [14.63174658531121, 1.0615651093538465],
            [14.638840566367872, 1.060626394314373],
            [14.641921391068252, 1.0555495610654875],
            [14.642397136271914, 1.0512384087747555],
            [14.644604010558364, 1.0482425322448405],
            [14.646788089153732, 1.03884917808104],
            [14.639404378499178, 1.0376475581078788],
            [14.63707789540973, 1.0290761893666736],
            [14.632665198696179, 1.0270257611906555],
            [14.628262055272128, 1.0296789495218008],
            [14.628422184740849, 1.0368282700904528],
            [14.6319726738369, 1.0401038675858656],
            [14.627872013338102, 1.0447439964088272],
            [14.624210993687795, 1.0449992544486566],
            [14.6191893699601, 1.0412215033044507],
            [14.616211125986073, 1.0406467020916792],
            [14.610514644584612, 1.034789429103865],
            [14.60545540702503, 1.0329199337931474],
            [14.602767570521692, 1.0276272516750713],
            [14.601982371181798, 1.0219355319827363],
            [14.594949631293474, 1.0198155962392421],
            [14.590513767451208, 1.0161114295591294],
            [14.583878177023303, 1.0194190689480065],
            [14.57671440675833, 1.0238658335103608],
            [14.571788919339205, 1.0257361914158787],
            [14.564222229268767, 1.0265773584299014],
            [14.557444053999848, 1.0298025975331926],
            [14.553085630627693, 1.0298989902288727],
            [14.548332059653701, 1.0274163490450483],
            [14.544079260776895, 1.029015943674185],
            [14.54779296860956, 1.0320953026270183],
            [14.545441927043099, 1.0363808244815753],
            [14.541923124580798, 1.0353101012363848],
            [14.535551379155253, 1.0368993800876727],
            [14.532295193120914, 1.0400651320537566],
            [14.525752649158258, 1.0411663276114484],
            [14.522697377203922, 1.0386180787059858],
            [14.518748043512877, 1.0324706813172622],
            [14.518175252460413, 1.0261568683241276],
            [14.51627583303117, 1.0224479576937735],
            [14.524062126441052, 1.0175563983739573],
            [14.52655502352325, 1.0179394323868605],
            [14.528408255840246, 1.013266754785728],
            [14.523314491526085, 1.0109565815292743],
            [14.517959915556094, 1.0148935142083895],
            [14.512291033027749, 1.0155856940324228],
            [14.5049720051283, 1.0200793871757858],
            [14.497418098211128, 1.0213873591883234],
            [14.494671845951757, 1.0202322353661113],
            [14.484775509253915, 1.022080214956153],
            [14.47882476973791, 1.0208794397432002],
            [14.477375203507743, 1.0166429536570623],
            [14.474987825160014, 1.0153606117732545],
            [14.468736780980986, 1.0186386746643696],
            [14.464421276086476, 1.0182303323672888],
            [14.449001682580043, 1.011647163512608],
            [14.441944480532845, 1.010659678423215],
            [14.440262606483046, 1.0169459052729781],
            [14.438448027207416, 1.0192621433671745],
            [14.434007274929497, 1.0189404073344213],
            [14.429320086204292, 1.0131567919299986],
            [14.424719316662177, 1.0121221059293224],
            [14.422950890894105, 1.0094309018880077],
            [14.422826023271156, 0.9982661964814904],
            [14.415084909344, 0.9900316719780489],
            [14.400918403745463, 0.9856138856257272],
            [14.394152602154097, 0.9812977644584968],
            [14.39034559006219, 0.9745270628801797],
            [14.384133279546168, 0.9770669610793952],
            [14.378479893676802, 0.9776871847667589],
            [14.376767491819802, 0.974815024798438],
            [14.379174208113893, 0.9686139024483358],
            [14.378614983678306, 0.9655209962653571],
            [14.37087976653281, 0.9638117218746027],
            [14.364348831816654, 0.9651088933367293],
            [14.357383051334208, 0.9563122716948647],
            [14.35154258012014, 0.9473959450863373],
            [14.350503318894056, 0.9442948505129156],
            [14.34026551968929, 0.9383035147572412],
            [14.340527157178803, 0.9358617329517404],
            [14.337803019395615, 0.9299704429856476],
            [14.340801427518313, 0.9249620367809479],
            [14.336390722448717, 0.9209152610855366],
            [14.329400862023505, 0.9213398693557772],
            [14.324616212440393, 0.924975225993953],
            [14.32115308325692, 0.9203385829583786],
            [14.31795602194187, 0.9188830228484604],
            [14.315968399511933, 0.9145984177616411],
            [14.307575360940431, 0.9200632677202907],
            [14.302897652121214, 0.9189385000872693],
            [14.2996430345166, 0.9137035945906323],
            [14.294796543950271, 0.9126407805844273],
            [14.286477688179902, 0.9119794868159619],
            [14.290444820894999, 0.9208040336827024],
            [14.29224391262685, 0.9270067658012967],
            [14.294254701610798, 0.9291487885941913],
            [14.300647722962061, 0.9308130738554583],
            [14.295797878532515, 0.9365898027081396],
            [14.290182641076202, 0.9409020464434866],
            [14.284645375164109, 0.943780191983474],
            [14.278501135570181, 0.9430083523573595],
            [14.279013031250074, 0.9473384453480349],
            [14.272610448635103, 0.9516938731520476],
            [14.267293923139468, 0.9607571559942556],
            [14.266011926768465, 0.9663396627575908],
            [14.26902712375519, 0.9753190851780071],
            [14.268640157130065, 0.980192194986066],
            [14.279103265230274, 0.9864593045504976],
            [14.281836875438652, 0.9916169566698496],
            [14.278244916136394, 0.9936384934519884],
            [14.278531143285727, 0.9977108266524254],
            [14.275981437597649, 1.0047474549497026],
            [14.266391450595705, 1.008106449193776],
            [14.267106805148426, 1.0124525734142664],
            [14.26191194174817, 1.011107509737297],
            [14.257110570876698, 1.01463949114143],
            [14.258111089388638, 1.0164322680954692],
            [14.250947665459833, 1.0222312124268986],
            [14.249844739118018, 1.0275146625901395],
            [14.25278141764113, 1.0316255264395078],
            [14.248698175483689, 1.0364824987183598],
            [14.24371671929687, 1.0358974367536253],
            [14.240518263045361, 1.0397976724297133],
            [14.234225963762523, 1.0427941752944174],
            [14.226635847587934, 1.0509182701667745],
            [14.221643173015867, 1.0533774000134315],
            [14.1950109846266, 1.0746881831705586],
            [14.14844589666587, 1.1122740157873487],
            [14.150343907914904, 1.1142184115914149],
            [14.155873845912728, 1.1155430841147724],
            [14.15994540891735, 1.1204843539980762],
            [14.162231413495993, 1.1197950820012366],
            [14.16671440819293, 1.1137060966597205],
            [14.169534546884025, 1.1168532571747591],
            [14.17419668284838, 1.112727217728091],
            [14.18104667230782, 1.1097333154286937],
            [14.183148058990236, 1.1139624991112653],
            [14.190357436114246, 1.114014483423563],
            [14.19315053401072, 1.1086716568321804],
            [14.198050161227478, 1.1127017479037316],
            [14.207721330860167, 1.130054418395445],
            [14.244116063489862, 1.1964615739655597],
            [14.275838897841169, 1.2349641198710446],
            [14.342878571900306, 1.317187871786734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.95585186768986, "lat": 38.48607610898953 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51047"],
        "coty_name": ["Culpeper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Culpeper County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01497831"
      },
      "bbox": [
        14.14844589666587, 0.9119794868159619, 14.646788089153732,
        1.3223235332091978
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.073080081148444, 0.8991899650803703],
            [15.07566552391395, 0.9009464727304556],
            [15.08231793674038, 0.9101142121142575],
            [15.086930523158925, 0.9140306924269322],
            [15.094995325881305, 0.9142145942716585],
            [15.0991974334036, 0.9012596867098577],
            [15.105756118877872, 0.8967115027622933],
            [15.109970005998415, 0.9002399949722197],
            [15.111023618196727, 0.9044699058036347],
            [15.10717269488448, 0.9140962340763258],
            [15.108039800645008, 0.9176704420676278],
            [15.112194717582524, 0.919127285404036],
            [15.115056842154075, 0.9175420782754807],
            [15.12290498119941, 0.9034699282515216],
            [15.124550182314946, 0.8925752364404497],
            [15.128826261711222, 0.8804597899124256],
            [15.1288443744197, 0.8740767775987197],
            [15.131713661755475, 0.8697119357387532],
            [15.142289120226458, 0.8657716296239583],
            [15.145353748435735, 0.8631978407952072],
            [15.146787637590458, 0.8568948265889043],
            [15.152015119532988, 0.8542445489370831],
            [15.161711200310101, 0.8589870837917761],
            [15.164360994463138, 0.8646982447903594],
            [15.165529085936857, 0.8723285756543585],
            [15.167548968017629, 0.8772706175224418],
            [15.173297809737143, 0.8778388433064505],
            [15.178220657686005, 0.8760271145700795],
            [15.180535010489264, 0.8718869413867437],
            [15.179699929110551, 0.8652641856323465],
            [15.181500277684465, 0.8610321522470782],
            [15.186353391116151, 0.8577590418701997],
            [15.224394655123087, 0.8547464726110228],
            [15.228945612248136, 0.8543044361565943],
            [15.233100963598483, 0.8504560927497525],
            [15.232529587730902, 0.847682508021786],
            [15.235325731910331, 0.8386149721352296],
            [15.245272882395184, 0.8197769443486221],
            [15.249047589174415, 0.8108590949779785],
            [15.248575493196059, 0.8066001159957368],
            [15.246045341203516, 0.806139930616179],
            [15.242405941198653, 0.8100364249547026],
            [15.239886254878515, 0.8034909658388717],
            [15.241535218586888, 0.7991256196219376],
            [15.244200466306355, 0.7975883272999597],
            [15.253917852930874, 0.7841811386982344],
            [15.25438673588532, 0.7804258335094835],
            [15.253300439721732, 0.7718088755335911],
            [15.251139501054613, 0.7684748148305144],
            [15.250857868513501, 0.7619506342015518],
            [15.256916557024718, 0.7572952972987431],
            [15.261225649616925, 0.7556620096089526],
            [15.269906163526475, 0.7562709364591372],
            [15.279486252835383, 0.7608285835705217],
            [15.29141141984005, 0.7585296186838134],
            [15.290511053637957, 0.7522638550200759],
            [15.287537862514148, 0.7431600472472478],
            [15.286880681713647, 0.7384877279860819],
            [15.292779180993744, 0.7388214916098508],
            [15.302854828983394, 0.7312183608474648],
            [15.311871270172126, 0.7264906455218609],
            [15.312015337221597, 0.7243950124689884],
            [15.320718821150033, 0.7133227251603479],
            [15.325228213492114, 0.7097998005968464],
            [15.33054951932452, 0.7097275419024954],
            [15.336623995669532, 0.7118770761448822],
            [15.34180277155927, 0.7107716122018308],
            [15.342098686924157, 0.7079329057726976],
            [15.347521388930321, 0.6999577655481027],
            [15.352366280754747, 0.7003686834112034],
            [15.355812941987248, 0.6978850730552069],
            [15.360726627549539, 0.696570766918061],
            [15.370018288717661, 0.697024390706279],
            [15.372324857942958, 0.6871525327550777],
            [15.378111965909193, 0.6797336541892942],
            [15.3822317586882, 0.6776774428958741],
            [15.382180327657784, 0.6751529003690515],
            [15.38549196894416, 0.6672042783305022],
            [15.396272930851012, 0.6607667064897393],
            [15.400164319320686, 0.6542257299348813],
            [15.402759346893102, 0.6529697011415824],
            [15.402743873310737, 0.6472950769534457],
            [15.405596090756662, 0.6426201109475708],
            [15.413158385260184, 0.6352473536021063],
            [15.417642987327408, 0.6335548979623581],
            [15.426387059837271, 0.622146632894097],
            [15.43576523479757, 0.611010433045292],
            [15.441823336034487, 0.6067889158456026],
            [15.445837581018518, 0.6026103198479428],
            [15.452784892530657, 0.6013279252331465],
            [15.466148108578945, 0.6046216153568279],
            [15.472643340571057, 0.6047118979162113],
            [15.480780391434468, 0.6011800402282256],
            [15.479489473548623, 0.5964240252301274],
            [15.480907475942963, 0.5912240014860891],
            [15.477817439494393, 0.5887687835434648],
            [15.475110658929324, 0.582831545429506],
            [15.468453387600038, 0.5734604503410166],
            [15.459230663462193, 0.5762573019678263],
            [15.452902942082055, 0.5712743614353227],
            [15.437146500467467, 0.539077291123428],
            [15.43446807855142, 0.5437846518351204],
            [15.433450022075649, 0.5484391382530527],
            [15.425083526858696, 0.5597246681654122],
            [15.417038537447468, 0.5643032170142154],
            [15.414187149719574, 0.5691217998518202],
            [15.403578767020598, 0.5723212171275825],
            [15.398486132801954, 0.5757180759506578],
            [15.394419027436802, 0.5864539146499174],
            [15.394734743892464, 0.5902973287598339],
            [15.384554145218505, 0.5963672091163426],
            [15.380453063974066, 0.5944061298386702],
            [15.37561485012567, 0.5940868540318058],
            [15.370804522483585, 0.5913009852022207],
            [15.366925621815032, 0.5911105361765864],
            [15.357803450336183, 0.5935680543999151],
            [15.35285858803151, 0.5933820261157154],
            [15.349639828458152, 0.5886019128659644],
            [15.34463171414783, 0.5834803451117055],
            [15.340802486395338, 0.5811104171430685],
            [15.333192938968946, 0.5735873851774366],
            [15.329212979736381, 0.5721252885162275],
            [15.324514228343036, 0.5726367230430205],
            [15.319140721302094, 0.5788767201918614],
            [15.314120318108051, 0.5790222284429483],
            [15.304292905675908, 0.5816165297160059],
            [15.292422203363751, 0.5774114324364523],
            [15.289981943165687, 0.5735639531220448],
            [15.28692008668643, 0.5731050471938876],
            [15.282759465737586, 0.5691934980261294],
            [15.281137229566982, 0.564028954031818],
            [15.278908946450196, 0.5646580030248977],
            [15.276595975627878, 0.5737079757418667],
            [15.276300884763973, 0.5824941492474558],
            [15.275183043721775, 0.585915670090984],
            [15.271392681210676, 0.590246969233119],
            [15.269934423687813, 0.5952778691793267],
            [15.268144290196, 0.6071739114585446],
            [15.26130598405734, 0.6072045546477968],
            [15.257634097276627, 0.6054583578404591],
            [15.249150250671075, 0.6037475234947418],
            [15.238044190587921, 0.6122460585207439],
            [15.231042977033693, 0.6088565862868917],
            [15.230517786856929, 0.6061527347183993],
            [15.222070955314033, 0.6059289308838722],
            [15.208236936855325, 0.6122404788888566],
            [15.208081114852002, 0.6161712665869427],
            [15.20407248588101, 0.6280535784279233],
            [15.196439510845499, 0.6286500193396216],
            [15.18638726464365, 0.6326934663397197],
            [15.184460237003305, 0.6363474326172354],
            [15.18605390622973, 0.6405389973179704],
            [15.1938616975502, 0.6423857742136118],
            [15.19827933804089, 0.6459859300920098],
            [15.196432943850565, 0.6479025279294294],
            [15.199188113608542, 0.6520236201530574],
            [15.195174472296618, 0.653396562153451],
            [15.190878077240328, 0.6592186526523743],
            [15.190641663924874, 0.6642333098953527],
            [15.192333346618899, 0.6708918446534393],
            [15.183313183678006, 0.6815966077809559],
            [15.183221610144631, 0.6861274646086968],
            [15.180595499693492, 0.6896543197345859],
            [15.176117645758426, 0.6906980295512531],
            [15.168968521312207, 0.6904264247531292],
            [15.167150518947231, 0.6927663495937884],
            [15.163267424449554, 0.6917449390265272],
            [15.161525148887641, 0.6985587340668223],
            [15.155949832745293, 0.70247015333859],
            [15.146690476711363, 0.7043774621208416],
            [15.14937147461428, 0.7100114467619305],
            [15.150995515087274, 0.7164314402073201],
            [15.145101232021474, 0.7229850067596736],
            [15.144815386961701, 0.7298888090972295],
            [15.138722299491713, 0.7409647560997533],
            [15.138490848099082, 0.7433779280482229],
            [15.1345344805279, 0.7477022962712147],
            [15.137168076811207, 0.7522551835557033],
            [15.13293241073745, 0.7576181565429572],
            [15.128131117235982, 0.7588272019076252],
            [15.125174912551813, 0.7642919335606836],
            [15.12091607275896, 0.7684505975113621],
            [15.1104200604291, 0.7639557908972414],
            [15.101259271309921, 0.767157825039582],
            [15.09722312506671, 0.7631481744530766],
            [15.095183710040278, 0.765297223755973],
            [15.089482628302957, 0.7646362053155185],
            [15.08755192340613, 0.7688569133876691],
            [15.088797900105634, 0.7764224281721891],
            [15.09182996724778, 0.7831753638773754],
            [15.08372142835588, 0.793248376569527],
            [15.078327010825209, 0.7949699566137582],
            [15.071175782914715, 0.7921304177819017],
            [15.066916622519887, 0.795171652824729],
            [15.068531880400382, 0.8002452342511376],
            [15.065677358349324, 0.8064535664844042],
            [15.05688199141369, 0.8076557357899936],
            [15.051948427494304, 0.8126012445422063],
            [15.04576414353471, 0.8212052645562039],
            [15.051540068810194, 0.8303413592846667],
            [15.056725592983312, 0.8319288368803864],
            [15.056662521392804, 0.8374168576932194],
            [15.061816929437153, 0.8395876658307585],
            [15.062741664541615, 0.8476987668980341],
            [15.058849645259562, 0.853556258625214],
            [15.06011345418325, 0.860713809606955],
            [15.057177328116902, 0.866040421326959],
            [15.060071779867716, 0.8690734971622811],
            [15.0629700721909, 0.8674800528899977],
            [15.066052874022985, 0.8705317263894388],
            [15.075132827152366, 0.8713359531235598],
            [15.0778984845856, 0.8701509845751454],
            [15.085775224293434, 0.8787595356521752],
            [15.08357686217391, 0.8828043749727049],
            [15.07768484719573, 0.8842298558383739],
            [15.073080081148444, 0.8991899650803703]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.95186546848372, "lat": 37.94285504738148 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51057"],
        "coty_name": ["Essex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Essex County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01480118"
      },
      "bbox": [
        15.04576414353471, 0.539077291123428, 15.480907475942963,
        0.919127285404036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.83241059136937, -1.2497666616476628],
            [11.847628106077165, -1.2477613045538865],
            [11.851821531892412, -1.244068562038887],
            [11.859940750506214, -1.2404333362040505],
            [11.861774572997193, -1.2296861367449765],
            [11.860680030208897, -1.2187494616107608],
            [11.8629652581616, -1.2145013910700877],
            [11.87393908589007, -1.2088262038615099],
            [11.879102069332848, -1.2073694323647355],
            [11.882637768230719, -1.20359511223561],
            [11.886144483566692, -1.1976480000330287],
            [11.890522941417906, -1.1936186334396348],
            [11.893596734177132, -1.1926937720255941],
            [11.903934909300155, -1.193346809632332],
            [11.909256494668263, -1.1839208355777509],
            [11.912038711640909, -1.1718569032055615],
            [11.912161136849074, -1.1629496932857815],
            [11.910056341265706, -1.1575017551756324],
            [11.910640776478754, -1.1542096378944198],
            [11.900979320277669, -1.152416010005443],
            [11.899615740076591, -1.1480184276116765],
            [11.908900097309509, -1.143551793082735],
            [11.913724353266723, -1.1397040876647182],
            [11.926354223891567, -1.1386829299856243],
            [11.93124127576766, -1.133206593376964],
            [11.938113628575225, -1.1326758962444816],
            [11.947865771361998, -1.1284535937577118],
            [11.963375900204836, -1.1235814410396743],
            [11.966253641433259, -1.1203842094089398],
            [11.974575494037747, -1.1216375389310382],
            [11.979816628311223, -1.1199716439738592],
            [11.98915804485589, -1.114781352332325],
            [11.997025602370357, -1.106369312382619],
            [12.00654477892885, -1.1005942565388491],
            [12.008714696334371, -1.0982205510855167],
            [12.019188014769275, -1.090299865847523],
            [12.08227890964928, -1.0666272526315788],
            [12.083907601779863, -1.0673010109286905],
            [12.106638006110556, -1.0537014669739888],
            [12.111310795990336, -1.0524185471659406],
            [12.121635094175089, -1.0497957340039967],
            [12.126305034085828, -1.0528618148389248],
            [12.134138747801, -1.0506739849699624],
            [12.135403661789855, -1.0478846957531713],
            [12.139860326353856, -1.0462240127580866],
            [12.1431297381969, -1.0496138251922733],
            [12.154672974031097, -1.0497073824376149],
            [12.16196121260974, -1.0482775139073],
            [12.166225499935004, -1.0493450708124838],
            [12.171588387618979, -1.0476852268331318],
            [12.170317921551511, -1.0436952945395956],
            [12.172560614935147, -1.0410948637199777],
            [12.184820893344511, -1.0414153570435558],
            [12.188551855611944, -1.0401130483503347],
            [12.190322342769345, -1.0355425087068135],
            [12.194931272756124, -1.03318192000527],
            [12.199478345863412, -1.0360424807588902],
            [12.209512619337042, -1.0370150545967172],
            [12.215969181061755, -1.0326245127077491],
            [12.223274230806346, -1.0310630505407739],
            [12.225577475212894, -1.0293709074888022],
            [12.246598578147756, -1.0266623092715335],
            [12.246014896723368, -1.0229731779371878],
            [12.247794091103414, -1.0154353899392383],
            [12.245095240369945, -1.0125918459285834],
            [12.244994719751242, -1.006373387082955],
            [12.249191066369644, -1.0029499452258608],
            [12.25559962722724, -1.0013222605387369],
            [12.257318080793365, -0.9969618898881272],
            [12.265336700481113, -0.9928296711443186],
            [12.266585047794745, -0.9890544969354121],
            [12.271231330547822, -0.9839227940568511],
            [12.276535981232863, -0.9820326452924565],
            [12.32837902547627, -1.040988953471593],
            [12.384299917094802, -1.102715204135842],
            [12.379443955843247, -1.103058858769153],
            [12.380314572488862, -1.099430935105817],
            [12.378357085631793, -1.0965309063583313],
            [12.37426287921931, -1.099504344890819],
            [12.374585172160794, -1.1049001676092716],
            [12.372075335175216, -1.1134600672205515],
            [12.372971331712248, -1.1211959699157723],
            [12.375852505535205, -1.1278124611399398],
            [12.382069762152186, -1.1299544793327854],
            [12.397059520342788, -1.1293583369015643],
            [12.39165272986806, -1.1455958157867847],
            [12.392565687208135, -1.1487474523753933],
            [12.397673051113388, -1.147158044991428],
            [12.40377165449674, -1.1427897184799138],
            [12.403230637053646, -1.1319334138355728],
            [12.400144089697145, -1.1272937059373447],
            [12.401903885502938, -1.1217210332304404],
            [12.422497681519918, -1.1440883346444393],
            [12.439468798565775, -1.1619940093187588],
            [12.476320305714355, -1.2029249889942657],
            [12.42585213203481, -1.208350061658669],
            [12.39079982754584, -1.2124764699598363],
            [12.34530749307849, -1.219284523626619],
            [12.33920914815482, -1.2194367266879398],
            [12.301528934355973, -1.2228148168173008],
            [12.282330398260646, -1.2254950751057436],
            [12.24933943506859, -1.2287667728380518],
            [12.23593237872358, -1.230574150223213],
            [12.212591446462788, -1.2327169132140798],
            [12.208128058950944, -1.232499158810078],
            [12.150472480324845, -1.2402129751717395],
            [12.140549364234156, -1.2410503511628577],
            [12.10484589592818, -1.2454977314373683],
            [12.068933250417876, -1.2513908614775082],
            [12.051989587307812, -1.2540717361472706],
            [11.9986703576767, -1.2601256451794316],
            [11.98265588932225, -1.2612414330173873],
            [11.961256536920281, -1.2636398639288497],
            [11.936148152496818, -1.2659724801190404],
            [11.87233408404559, -1.26910409391499],
            [11.81193691335464, -1.2771767341724631],
            [11.83241059136937, -1.2497666616476628]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.22494869484615, "lat": 36.65651442567961 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51077"],
        "coty_name": ["Grayson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grayson County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01501196"
      },
      "bbox": [
        11.81193691335464, -1.2771767341724631, 12.476320305714355,
        -0.9820326452924565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.443776886420732, 0.7445912302557504],
            [14.444558776648453, 0.7533386040337926],
            [14.451108370487109, 0.7642196148410854],
            [14.455140696854604, 0.7657492571079879],
            [14.457634000125914, 0.7828738014962824],
            [14.461175422696117, 0.7821788694184907],
            [14.466125936651261, 0.7910287223198536],
            [14.469328472086962, 0.7906062219250791],
            [14.469178917701313, 0.7964253804166037],
            [14.475548778815122, 0.8079797738257088],
            [14.477596406667914, 0.8082029524276999],
            [14.48257688967731, 0.8196806405416721],
            [14.486075387586249, 0.8223570315067469],
            [14.486958149168702, 0.8333684064399747],
            [14.48499146355301, 0.8369530361642413],
            [14.495046175976073, 0.8373183402437471],
            [14.497044262966975, 0.8403617401027604],
            [14.495566029608105, 0.8434625915100926],
            [14.499780557733024, 0.8469035569476212],
            [14.499643644500697, 0.8538177469888529],
            [14.50274835325915, 0.8559862722096714],
            [14.507425749125835, 0.8637914851260238],
            [14.506627020982203, 0.8682515023714383],
            [14.508326739720397, 0.8714609181276984],
            [14.513947994571778, 0.8712086023701769],
            [14.517770931480301, 0.883900216163254],
            [14.526395539171215, 0.8977879554948434],
            [14.53484849387395, 0.9056900563073572],
            [14.537214308323362, 0.9105735052799726],
            [14.534633740908154, 0.9142569477476798],
            [14.540415952086466, 0.9254138109184942],
            [14.54779429341326, 0.9293319250658625],
            [14.545775258927774, 0.9371064784013254],
            [14.54928785785995, 0.9372321058964552],
            [14.553525438868427, 0.9460100090278808],
            [14.561866489003734, 0.9594534911531657],
            [14.564667298661588, 0.9664771764178408],
            [14.563923338567394, 0.9744469869093377],
            [14.572696145592584, 0.9791810499724384],
            [14.57443466521629, 0.9886041616909435],
            [14.579485348082562, 0.9925449311848209],
            [14.57571941617555, 0.9982805460892741],
            [14.579849211037411, 1.0033896619409384],
            [14.57712693447021, 1.0060759270317081],
            [14.582870433651204, 1.0154167089783261],
            [14.583878177023303, 1.0194190689480065],
            [14.590513767451208, 1.0161114295591294],
            [14.594949631293474, 1.0198155962392421],
            [14.601982371181798, 1.0219355319827363],
            [14.602767570521692, 1.0276272516750713],
            [14.60545540702503, 1.0329199337931474],
            [14.610514644584612, 1.034789429103865],
            [14.616211125986073, 1.0406467020916792],
            [14.6191893699601, 1.0412215033044507],
            [14.624210993687795, 1.0449992544486566],
            [14.627872013338102, 1.0447439964088272],
            [14.6319726738369, 1.0401038675858656],
            [14.628422184740849, 1.0368282700904528],
            [14.628262055272128, 1.0296789495218008],
            [14.632665198696179, 1.0270257611906555],
            [14.63707789540973, 1.0290761893666736],
            [14.639404378499178, 1.0376475581078788],
            [14.646788089153732, 1.03884917808104],
            [14.652477027469153, 1.0357832552509414],
            [14.655956117829481, 1.0294728641306627],
            [14.66282292810809, 1.0222738752292158],
            [14.661882884895517, 1.0097845716961156],
            [14.665378709036256, 1.006710193137409],
            [14.668069703770222, 1.0069464718157697],
            [14.671204241256023, 1.0109027762459388],
            [14.67682367291903, 1.0231004215972106],
            [14.687326103594593, 1.026339767471345],
            [14.690870615620831, 1.0229097749413736],
            [14.689500059129953, 1.0184024871685804],
            [14.692445117559686, 1.0143063595337858],
            [14.699490687860214, 1.0141612942735612],
            [14.710940620851073, 1.0074473594247852],
            [14.714414350157384, 0.9998748255577746],
            [14.719455036574635, 0.9953610457591533],
            [14.72561140064298, 0.9939657705995519],
            [14.729249524790172, 0.9925588926784986],
            [14.738163855226565, 0.9924813152534662],
            [14.73734151850508, 0.9843843248737216],
            [14.746035284440808, 0.980593334327574],
            [14.7455055182156, 0.9678117893852496],
            [14.75505863870171, 0.9694071738359635],
            [14.758142528342848, 0.9726085036809191],
            [14.760071486354661, 0.969167773993775],
            [14.759690602836281, 0.9643577232622876],
            [14.768950703812646, 0.9646878271920079],
            [14.776278569098773, 0.9637926898766082],
            [14.779980053409188, 0.9746298922628479],
            [14.784898370570481, 0.973411244754018],
            [14.788484572553433, 0.9674907597525589],
            [14.793368667165893, 0.971968602966362],
            [14.788473591371032, 0.9800148752865054],
            [14.793818168039055, 0.9821426428498692],
            [14.801636783337443, 0.9792661707770095],
            [14.80351509137234, 0.9740664764876873],
            [14.807549285891286, 0.9699880232461339],
            [14.814853565469663, 0.9678383401174152],
            [14.819612915211444, 0.9598392802142116],
            [14.822007777068347, 0.9586141349063634],
            [14.831527945790274, 0.9582015127375024],
            [14.844395934919506, 0.9519896929059934],
            [14.849263525519556, 0.952664874718417],
            [14.851004918158733, 0.956647076891884],
            [14.854186581002526, 0.9584210320320221],
            [14.859880813973176, 0.9560782116430824],
            [14.854317053081175, 0.9465711100708635],
            [14.84156634197728, 0.9202604876395181],
            [14.831727622050636, 0.9016675129823098],
            [14.826740250124642, 0.8904326425479453],
            [14.79680382047322, 0.8350040967016884],
            [14.767045477110461, 0.7790791778453198],
            [14.744198513462894, 0.7365200708341055],
            [14.732415613930435, 0.7150939067786511],
            [14.711775490134936, 0.6766443972557916],
            [14.70176364958982, 0.6615761468736716],
            [14.697574146397923, 0.6641110699110021],
            [14.687527630201267, 0.6611669715470183],
            [14.686289524931366, 0.6656557445282635],
            [14.683074801614513, 0.6641460340718107],
            [14.67713693664944, 0.6703467173563006],
            [14.6719008108289, 0.6721023174767219],
            [14.664022733207302, 0.6718160446810826],
            [14.657526940116744, 0.670247701896238],
            [14.653511310379866, 0.674644655504789],
            [14.643263421476783, 0.6747524312858053],
            [14.637105423244448, 0.6771988939474338],
            [14.634436414612692, 0.6819256806007127],
            [14.627854164209552, 0.6785870099514152],
            [14.628897291410357, 0.6854765901171461],
            [14.626192772120016, 0.6883439224513335],
            [14.619298873004762, 0.689061057906817],
            [14.616993552529575, 0.6804861630587529],
            [14.613236791698485, 0.683458913611055],
            [14.610072415339905, 0.7025929687901007],
            [14.608515645062383, 0.7073307306915196],
            [14.603660938380372, 0.7016553240409278],
            [14.59349393845873, 0.7032804495931463],
            [14.58979409343268, 0.7084251104005392],
            [14.584492039899713, 0.7087330438390832],
            [14.578362196824413, 0.7141264895506568],
            [14.579737394017975, 0.7168619113191155],
            [14.57496463158875, 0.7246788086402952],
            [14.569049800081665, 0.7261029881559103],
            [14.559254472891931, 0.7242041661254734],
            [14.554066774826106, 0.7259771092193585],
            [14.55307542779264, 0.7299587918014464],
            [14.54939451023073, 0.7295996633285178],
            [14.546641894824683, 0.7327610160299006],
            [14.54648358056142, 0.7360256720472854],
            [14.542291916183446, 0.7388148803458292],
            [14.537355621649054, 0.7397117459318199],
            [14.532188337456686, 0.7422097663712139],
            [14.529680024538132, 0.7469696940271998],
            [14.524459716697349, 0.7440050388728935],
            [14.522721398808848, 0.7410957996214167],
            [14.513347722022035, 0.7427819202803131],
            [14.502100213143072, 0.741842863637715],
            [14.495424644613756, 0.7431254411596464],
            [14.489955114120804, 0.7463893747213506],
            [14.481634054474648, 0.7409800413173513],
            [14.473370850226718, 0.7422670002865293],
            [14.467309360868612, 0.7473721180555559],
            [14.462679566681697, 0.7425732198023207],
            [14.454727452126242, 0.7406007365955726],
            [14.453015484767322, 0.7421130014223833],
            [14.443776886420732, 0.7445912302557504]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.65611839370428, "lat": 38.18508446282255 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51177"],
        "coty_name": ["Spotsylvania"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spotsylvania County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "01480172"
      },
      "bbox": [
        14.443776886420732, 0.6611669715470183, 14.859880813973176,
        1.0449992544486566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.032555372464671, -0.048611951768839486],
            [15.028466614311924, -0.05315166357087943],
            [15.02344428369965, -0.05467667760575076],
            [15.022620788627723, -0.04646483915166674],
            [15.019778291442234, -0.0410523254179403],
            [15.019621909186228, -0.026877963933903643],
            [15.015454228141097, -0.022605945181318678],
            [15.013142983738701, -0.026584029543920248],
            [15.008453359759681, -0.02065897091556677],
            [15.003585337758418, -0.016061900377075878],
            [15.010244842229946, -0.014831231169080476],
            [15.006609388221344, -0.011444812220243076],
            [15.007284890913667, -0.005954317971367589],
            [15.014705412058461, -0.0059178007027324035],
            [15.01690272565931, -0.004686831516994611],
            [15.020578844782758, -0.006792414152224669],
            [15.023405027786609, -0.012581697883416313],
            [15.028877496073598, -0.01377201059132686],
            [15.024669139823954, -0.006175346092683085],
            [15.026258717354109, -0.0026001224100470482],
            [15.03174425001286, -0.0020683746392753657],
            [15.033781862082291, 0.003121577878516744],
            [15.042910898448978, 0.001989711786499399],
            [15.044707966309124, 0.01515609226105198],
            [15.04885169859288, 0.013598718651078106],
            [15.05252988262181, 0.0099096416947266],
            [15.05264888602849, 0.006827307890336484],
            [15.055716122713884, 0.0021192449395231647],
            [15.052868143062062, -0.0022936282333849345],
            [15.04704350188502, -0.007424916634858505],
            [15.045543198243555, -0.01491244527616152],
            [15.04902532761645, -0.03691253868478411],
            [15.045703307108392, -0.0420806537621275],
            [15.038526364567927, -0.045338561718129056],
            [15.03442110615379, -0.045352615715529905],
            [15.032555372464671, -0.048611951768839486]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.39704114336749,
          "lat": 37.264747444537534
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51570"],
        "coty_name": ["Colonial Heights"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Colonial Heights city"],
        "coty_fp_code": "570",
        "coty_gnis_code": "01498420"
      },
      "bbox": [
        15.003585337758418, -0.05467667760575076, 15.055716122713884,
        0.01515609226105198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.611248055878976, -0.0817289888644579],
            [13.61278835211072, -0.08843728279790997],
            [13.618931519425328, -0.09313765688731847],
            [13.621158535831894, -0.09612245892955341],
            [13.632982367913012, -0.10356013110846811],
            [13.644893155286377, -0.10966251965834145],
            [13.64642800069699, -0.10667202190220454],
            [13.649687387434541, -0.10864641799071811],
            [13.655034136548421, -0.11814477436137348],
            [13.655952868604418, -0.12408920805572056],
            [13.660923797844953, -0.12999643080511536],
            [13.668111922561156, -0.1364125657091572],
            [13.673766646273497, -0.1398143531979958],
            [13.67884945800915, -0.13943124651128838],
            [13.679001037677825, -0.13275290840006312],
            [13.68062743248319, -0.12975747633582074],
            [13.687640917623582, -0.13114135777410754],
            [13.701746114594462, -0.13828241098621719],
            [13.691311505548015, -0.1576633673058598],
            [13.6874732842862, -0.15871610932870667],
            [13.682401389412389, -0.1668187058418779],
            [13.678252224014487, -0.16666277496364532],
            [13.671029736572516, -0.16417215231882284],
            [13.66746794996336, -0.1648551310410173],
            [13.650454984724549, -0.18586049783474878],
            [13.641364103274576, -0.20322047783243635],
            [13.637356856912817, -0.20323764719407608],
            [13.631518949068678, -0.20615861962239249],
            [13.627735688134779, -0.20362927202128883],
            [13.623695016128199, -0.20391018044140663],
            [13.616860408719598, -0.21037443684928997],
            [13.611850764155491, -0.21791434379933072],
            [13.59597228476753, -0.21069041460038393],
            [13.596121141248068, -0.20667600717473203],
            [13.583366585072543, -0.20632705117729297],
            [13.579194515004952, -0.2047755918116754],
            [13.580015546875375, -0.19818727356368804],
            [13.574804452697041, -0.20106375791532088],
            [13.578698672876701, -0.18881238992044272],
            [13.58754680860622, -0.1589917497231818],
            [13.571078188310024, -0.1532260549043111],
            [13.569191147335655, -0.151194813917573],
            [13.576382988820697, -0.13582830940394822],
            [13.568759003072948, -0.13214410948139305],
            [13.567227921245864, -0.12684325899455473],
            [13.563897234968161, -0.1253726484095688],
            [13.553384485906815, -0.12750602756388582],
            [13.550092226927935, -0.1225080479630685],
            [13.553509547724056, -0.11892890869798656],
            [13.551774393991057, -0.11025295471864774],
            [13.5552867603125, -0.10781362732596124],
            [13.55866953675274, -0.10989161703444748],
            [13.567485663001696, -0.1085495291546773],
            [13.569250059757655, -0.10466480994220667],
            [13.576844191721246, -0.0983470458422731],
            [13.576750761865235, -0.09422187328643097],
            [13.57997070157, -0.09251842640962724],
            [13.581911944609294, -0.09640539306310245],
            [13.587173570151222, -0.09093714437592085],
            [13.589057723128922, -0.08634510507240503],
            [13.593101549131886, -0.0829665834096341],
            [13.603836839719293, -0.07960283749009572],
            [13.611248055878976, -0.0817289888644579]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.19084522334983, "lat": 37.40026635423887 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51680"],
        "coty_name": ["Lynchburg"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Lynchburg city"],
        "coty_fp_code": "680",
        "coty_gnis_code": "01498429"
      },
      "bbox": [
        13.550092226927935, -0.21791434379933072, 13.701746114594462,
        -0.07960283749009572
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.909176951322844, 4.151033308156371],
            [-6.8239108388620835, 4.141669398576839],
            [-6.817102851700525, 4.140257295350998],
            [-6.76502878935518, 4.134637668334344],
            [-6.763831030051604, 4.134281962749123],
            [-6.68604510068816, 4.126082389029115],
            [-6.635955111782641, 4.120385158266061],
            [-6.559452876341791, 4.112661645540745],
            [-6.532090115915265, 4.109378133787458],
            [-6.534651819104405, 4.085085605965237],
            [-6.548785989956913, 4.086484137923955],
            [-6.551783327899627, 4.057607879301229],
            [-6.580256875415229, 4.060608127710111],
            [-6.5870979382448835, 3.9876392257002604],
            [-6.576509189969334, 3.9869252281359815],
            [-6.577239394104397, 3.979657547430659],
            [-6.551230203780069, 3.976787621121007],
            [-6.531093646341128, 3.9719936330278465],
            [-6.524224025637141, 3.972905933065618],
            [-6.524737138535139, 3.9656112120382616],
            [-6.5180535419645755, 3.9657797697554615],
            [-6.4143043106250115, 3.9559118473313664],
            [-6.413935472907098, 3.9596075486031457],
            [-6.413736956862084, 3.985000314734492],
            [-6.399028018758307, 3.983798485405263],
            [-6.399252648590707, 3.9982146750942236],
            [-6.3956788785898055, 4.041039273358843],
            [-6.38872748437223, 4.040429064187786],
            [-6.3857158584775044, 4.068886126751934],
            [-6.378481820087577, 4.068211524021129],
            [-6.377115447204342, 4.082338450152411],
            [-6.3700935642461, 4.081687477122391],
            [-6.36902021482971, 4.093689869972969],
            [-6.3334294737067784, 4.090500548735647],
            [-6.338307902226097, 4.0396936894929825],
            [-6.338924065643096, 4.019620848644737],
            [-6.352122246763999, 3.8807860053729657],
            [-6.3650269102373365, 3.7479176422350977],
            [-6.359613868616808, 3.74732409181928],
            [-6.367327594553969, 3.66561615470066],
            [-6.368220522840323, 3.644429984399227],
            [-6.384802308761964, 3.4748030358291366],
            [-6.392212378342254, 3.400214423940343],
            [-6.397496235525239, 3.4006964557600345],
            [-6.405333353431299, 3.315217241491225],
            [-6.43006764450349, 3.0570496670374525],
            [-6.4324515874366845, 3.0537190881251415],
            [-6.439099854165982, 2.9892610275040465],
            [-6.452310436785659, 2.8486496496366036],
            [-6.45888120024398, 2.774098144893503],
            [-6.465738576537381, 2.7031111393275906],
            [-6.464313473533631, 2.7030739466793516],
            [-6.4689988941390695, 2.6554518655035344],
            [-6.570236090134439, 2.665039662104415],
            [-6.686488272819081, 2.6763351684224164],
            [-6.802742404500524, 2.6876102794907473],
            [-6.836814752571383, 2.69110277173109],
            [-6.944983353465385, 2.7024757153548635],
            [-7.053153807749678, 2.7138309752971077],
            [-7.149376741244706, 2.7247257458641587],
            [-7.1694706294964305, 2.7270175767608134],
            [-7.246406076305771, 2.7367605669255215],
            [-7.210857607060023, 3.0728941512820964],
            [-7.20644430974251, 3.1130558416755956],
            [-7.204409894429803, 3.1332559179298656],
            [-7.119515365461579, 3.123962242873391],
            [-7.1196040651123, 3.1226832243646427],
            [-7.016103915201654, 3.1128935907383],
            [-7.003855086522969, 3.2489045101414993],
            [-6.990034904109549, 3.384553468578609],
            [-6.979123122767319, 3.4926420547787322],
            [-6.974939275687277, 3.5331670760160843],
            [-6.96588572735663, 3.6165143149008525],
            [-6.965656382960107, 3.620297138967042],
            [-6.956283889062053, 3.707569993755536],
            [-6.947201023111819, 3.805013927029701],
            [-6.940410815993822, 3.8668127444255944],
            [-6.939921307785979, 3.869979601186201],
            [-6.909176951322844, 4.151033308156371]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.72378632229639,
          "lat": 41.65456801857754
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56001"],
        "coty_name": ["Albany"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Albany County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01605066"
      },
      "bbox": [
        -7.246406076305771, 2.6554518655035344, -6.3334294737067784,
        4.151033308156371
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.422891210419161, 6.915274836049984],
            [-8.362039651387246, 6.907347874549674],
            [-8.348537331889501, 6.904886294493064],
            [-8.263222303283287, 6.894062611191682],
            [-8.177909679929085, 6.883219562910048],
            [-8.162555270170923, 6.880916740629752],
            [-8.147421679654386, 6.879481137379951],
            [-8.10007560131196, 6.873417018798851],
            [-7.991346586728802, 6.859757562387052],
            [-7.925772037217837, 6.851645395815638],
            [-7.923469341665117, 6.846404713853373],
            [-7.917475065165079, 6.845699522945615],
            [-7.914353522711416, 6.840635025425862],
            [-7.91210076544018, 6.841111242703953],
            [-7.906752843399267, 6.8340255539581705],
            [-7.908666550360224, 6.829710927400948],
            [-7.907885404201634, 6.820227720811883],
            [-7.905958208435779, 6.81289214803493],
            [-7.907114762209775, 6.806114414187402],
            [-7.91261155528986, 6.791651597698677],
            [-7.913391166427529, 6.782705294866064],
            [-7.907173814552818, 6.776964308782387],
            [-7.9056847402294546, 6.7730981372291374],
            [-7.902429591265658, 6.770586540591068],
            [-7.895826269852268, 6.761457663821338],
            [-7.896027068160584, 6.753995936435749],
            [-7.894161642252509, 6.752490709920744],
            [-7.896479562411183, 6.745775382779831],
            [-7.900092744672637, 6.742551303988866],
            [-7.903365331208678, 6.7425398858751135],
            [-7.905043704672447, 6.729805899941617],
            [-7.909032472512446, 6.722230510491102],
            [-7.9073787919114, 6.71688028467624],
            [-7.902782413347407, 6.71527411297524],
            [-7.899737667181547, 6.709683642919444],
            [-7.8961972045671045, 6.707605836325312],
            [-7.894850673871713, 6.696611126379454],
            [-7.892962367083976, 6.693059567245121],
            [-7.889261499510187, 6.691051420129632],
            [-7.8907066579704574, 6.685968082648789],
            [-7.888620546987588, 6.682509285629957],
            [-7.888500085362361, 6.676668666827446],
            [-7.892017531234878, 6.671288992282015],
            [-7.88839562208446, 6.666387753290668],
            [-7.885045670852255, 6.666640503367218],
            [-7.881786602996912, 6.662575854751803],
            [-7.883515229260845, 6.655739969374953],
            [-7.886749392659414, 6.652538485157654],
            [-7.893977106997924, 6.647645097610696],
            [-7.896149859416924, 6.641781686267127],
            [-7.896509840840439, 6.63734355416987],
            [-7.891089863451683, 6.637933681613607],
            [-7.882864818732551, 6.634424326701647],
            [-7.879456145060198, 6.630391057121326],
            [-7.8744450242018935, 6.627550298702787],
            [-7.868068802146923, 6.6203497474754895],
            [-7.861217628376789, 6.61470468484479],
            [-7.851078588523316, 6.614577079975851],
            [-7.844098968758177, 6.610846575305342],
            [-7.843128805408792, 6.605748389245559],
            [-7.844568656715053, 6.601985689785972],
            [-7.844227548075879, 6.596789464192628],
            [-7.8399077316134775, 6.59402271000172],
            [-7.843307121734556, 6.586127581430383],
            [-7.8400758860211885, 6.581149138220914],
            [-7.842634339178862, 6.57343358062084],
            [-7.8422567887776955, 6.568893306668266],
            [-7.847737677091701, 6.56402073642033],
            [-7.842010174184925, 6.554180581002612],
            [-7.8385402735531775, 6.552776589298804],
            [-7.832244078619258, 6.555045966240693],
            [-7.825546650092382, 6.548437186953961],
            [-7.819845673276592, 6.546255021259973],
            [-7.812449170055661, 6.54112345024628],
            [-7.810625688398996, 6.544025054822483],
            [-7.803687548004139, 6.540597933210373],
            [-7.800893707882313, 6.537627872441384],
            [-7.801842201834051, 6.531367431316712],
            [-7.804407597348442, 6.528274631767248],
            [-7.802646101207118, 6.522918212682165],
            [-7.798564083252077, 6.519520212327672],
            [-7.796658437174396, 6.514390950589458],
            [-7.791250498373381, 6.514750283154662],
            [-7.7856601648518, 6.51704788255178],
            [-7.784251891214648, 6.521917260639941],
            [-7.780778163226162, 6.5245495218719],
            [-7.775462815574721, 6.524869128650198],
            [-7.7718664240585555, 6.522518384594818],
            [-7.765802031850066, 6.523640937872835],
            [-7.760888433443763, 6.522847186662173],
            [-7.758154517382673, 6.528303129680128],
            [-7.755166500141008, 6.5304300084321305],
            [-7.752966504895627, 6.526795358156016],
            [-7.748038181193129, 6.523201217408812],
            [-7.741730109736801, 6.522495664062192],
            [-7.737451881837194, 6.515241133579112],
            [-7.732064712127453, 6.516035911747828],
            [-7.727682601416651, 6.50871920926069],
            [-7.72339276777587, 6.5084836242327055],
            [-7.7161962370411405, 6.502916116153189],
            [-7.710925786626901, 6.502474046134787],
            [-7.712178279043318, 6.490811611015232],
            [-7.705442657361413, 6.487907242762373],
            [-7.700279595458367, 6.488772155926357],
            [-7.697811751483172, 6.487634630575931],
            [-7.692384682276127, 6.482064377435849],
            [-7.695271279617555, 6.477934831514308],
            [-7.699975682952698, 6.474664452655549],
            [-7.703474417546736, 6.47382734600543],
            [-7.704604642286352, 6.469361720504586],
            [-7.701363801194208, 6.466328664371044],
            [-7.7014608682026635, 6.457177061143696],
            [-7.698766247310752, 6.455066999194573],
            [-7.689427855968674, 6.454632238583903],
            [-7.6808507786782165, 6.4620232954609875],
            [-7.677117564137661, 6.461503133307435],
            [-7.675231979897873, 6.45208330252936],
            [-7.672893853417001, 6.44447462891988],
            [-7.6690503804944745, 6.440627043534496],
            [-7.668667496911928, 6.436258894454321],
            [-7.6629311379239216, 6.429953130881428],
            [-7.658808079075786, 6.429265793525457],
            [-7.655173372248078, 6.426022002910707],
            [-7.645042863110674, 6.421075127466222],
            [-7.637478901902765, 6.42233721095039],
            [-7.638890978284939, 6.426644191624139],
            [-7.631531481371614, 6.42536614503541],
            [-7.630145257323367, 6.422220194675246],
            [-7.630950232703664, 6.4173096232356475],
            [-7.624716118357839, 6.411893628538112],
            [-7.617713712281867, 6.412000406700851],
            [-7.613495111692129, 6.410311302695976],
            [-7.61077667098876, 6.407313204138006],
            [-7.604198262559864, 6.405915149096962],
            [-7.606058567099929, 6.400534463752933],
            [-7.59960598492256, 6.386108209307026],
            [-7.600017822276032, 6.377971230764728],
            [-7.5986769805570855, 6.369620563849646],
            [-7.600311784214734, 6.366913067011443],
            [-7.596291808388311, 6.36453146257336],
            [-7.593139680129916, 6.359404021480101],
            [-7.593742251079481, 6.356224868905127],
            [-7.590501975167285, 6.354008935098504],
            [-7.589603858683744, 6.350832283842172],
            [-7.5764344054427655, 6.34758282481217],
            [-7.572826017962527, 6.350452409579357],
            [-7.573629812977281, 6.342784614181193],
            [-7.569869539372214, 6.33948931993341],
            [-7.569259322163033, 6.335362769368831],
            [-7.572996633324244, 6.3302793367186805],
            [-7.565576406427435, 6.321463007182593],
            [-7.56333109984552, 6.314230662076257],
            [-7.556906229884866, 6.311042864474877],
            [-7.552445659648868, 6.304781118079913],
            [-7.556074102942345, 6.300701788483475],
            [-7.555699228307977, 6.295359362290849],
            [-7.55742032300878, 6.289170686972857],
            [-7.562288469322258, 6.288647830902491],
            [-7.559241325949503, 6.281060678523299],
            [-7.563997571769799, 6.269090464762618],
            [-7.561931962558443, 6.264129631730138],
            [-7.553627325616756, 6.263882717008942],
            [-7.546399202609953, 6.262402363076969],
            [-7.544018956067498, 6.2586123315044055],
            [-7.547467097065451, 6.25412070816331],
            [-7.543439833191036, 6.251703286046846],
            [-7.5399334894636745, 6.251985628278889],
            [-7.533598798455746, 6.24766759178883],
            [-7.531819361871796, 6.24302856194303],
            [-7.522926039799422, 6.238813512192055],
            [-7.52046096194276, 6.240286941248396],
            [-7.512261174330966, 6.240593796964192],
            [-7.503021390079076, 6.244735644074118],
            [-7.499789213672982, 6.242606388466148],
            [-7.493779534035427, 6.243248691881491],
            [-7.492955842573444, 6.2387927283104085],
            [-7.496307780267056, 6.232950225101918],
            [-7.494284463755186, 6.231008726738525],
            [-7.497448090762409, 6.226292166230878],
            [-7.497669662229529, 6.222524030152536],
            [-7.495383366614092, 6.218692499760545],
            [-7.49718704459712, 6.213690095792207],
            [-7.496613092450881, 6.199853986162212],
            [-7.4974979783846365, 6.196507838088271],
            [-7.4897970333537, 6.194960475098921],
            [-7.487603892566319, 6.19798726346051],
            [-7.482506193776285, 6.1987383960029945],
            [-7.476775981177586, 6.1882529030819695],
            [-7.47975680879084, 6.184209866055383],
            [-7.483866771190397, 6.172062247801515],
            [-7.476430569774824, 6.168496698814025],
            [-7.475694322418788, 6.162575337924052],
            [-7.483427704515319, 6.155850701240593],
            [-7.491957634431117, 6.155192187451965],
            [-7.495290450379219, 6.150107983851236],
            [-7.495883416997854, 6.144181430260125],
            [-7.48978534196123, 6.142157350356601],
            [-7.4875883542582, 6.13840908112546],
            [-7.488320877437908, 6.134069079290244],
            [-7.486045621166355, 6.130764448374593],
            [-7.477509562250431, 6.129066834614045],
            [-7.477995435832728, 6.119759406210065],
            [-7.4754104764143, 6.116628619915859],
            [-7.47183749399061, 6.118358658469177],
            [-7.467797413094999, 6.117419397846971],
            [-7.487662794595148, 5.960703985786529],
            [-7.622588276724339, 5.978789594839021],
            [-7.649850262678183, 5.982133249905439],
            [-7.7593828196210675, 5.994683757009814],
            [-7.868918559653451, 6.007205071881668],
            [-7.889348429439188, 6.009767841139646],
            [-7.895676632392879, 6.0119823937732875],
            [-8.027670595199703, 6.028448255723824],
            [-8.038402650927393, 6.029692786037752],
            [-8.181096690809397, 6.048075932629904],
            [-8.316164353899946, 6.065711347553412],
            [-8.451237849874804, 6.083302182896111],
            [-8.483141722720369, 6.087568624518341],
            [-8.499606813540822, 6.089758359488936],
            [-8.476419874748505, 6.2623344050819805],
            [-8.469440176650792, 6.3135301384844835],
            [-8.452729144532633, 6.437906275013641],
            [-8.466160575227445, 6.439803251860992],
            [-8.463412832198948, 6.460579007612955],
            [-8.447742577701032, 6.575829551223173],
            [-8.43477056245612, 6.673597820385332],
            [-8.434102011522052, 6.677573212828891],
            [-8.419621323938559, 6.785629730847005],
            [-8.439369614709035, 6.7882832356220195],
            [-8.432896066358452, 6.837280758507563],
            [-8.430505635139172, 6.860062887018098],
            [-8.42635675609581, 6.890415745513866],
            [-8.425746783162174, 6.898470900681748],
            [-8.422891210419161, 6.915274836049984]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.99518257496557,
          "lat": 44.52667718214813
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56003"],
        "coty_name": ["Big Horn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Big Horn County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01605067"
      },
      "bbox": [
        -8.499606813540822, 5.960703985786529, -7.467797413094999,
        6.915274836049984
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.05627763378743,
          "lat": 17.998320689194603
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72015"],
        "coty_name": ["Arroyo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Arroyo Municipio"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01804487"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.88790337148609, "lat": 18.32902903391714 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72029"],
        "coty_name": ["Canóvanas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Canóvanas Municipio"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01804494"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.968006811350228, -2.597783024385927],
            [4.977685939937327, -2.5791233060490373],
            [4.983041211089431, -2.5741341131861737],
            [4.98714207981321, -2.5667221930731374],
            [4.98737520219243, -2.5604207321462837],
            [4.989306313302523, -2.556768660215457],
            [4.989205635091793, -2.5498404999896565],
            [4.9974627859282466, -2.543475253724699],
            [4.997966967684375, -2.5293441740633322],
            [4.9993816682162215, -2.523411247555087],
            [5.009156357604819, -2.518966973498545],
            [5.01070647710291, -2.51464384756833],
            [5.008270428866484, -2.5030475022778105],
            [5.0092933758226765, -2.5001195236460236],
            [5.014450440750994, -2.495233959679186],
            [5.019324473890867, -2.494688503541446],
            [5.024184639195023, -2.4908837044905754],
            [5.024865819857738, -2.4822440915314696],
            [5.0286422540626585, -2.4743196284436273],
            [5.039950359195432, -2.470570550663071],
            [5.044978537999033, -2.4695766246598216],
            [5.049719033373788, -2.4667964481456397],
            [5.053784129091019, -2.4596308543432706],
            [5.059734191409511, -2.459297477306712],
            [5.063091133647422, -2.4566172100099206],
            [5.066271027502535, -2.4496892103756185],
            [5.0730631874219725, -2.4462749037352114],
            [5.075934577480829, -2.438145621403282],
            [5.075488284489812, -2.431585566060221],
            [5.072030892617269, -2.426455941282529],
            [5.075574823067878, -2.4182401477086763],
            [5.075958920575525, -2.4115810020859296],
            [5.0823923237994935, -2.3999509284074194],
            [5.089775662115425, -2.4008876372570676],
            [5.095009627567983, -2.396983798625202],
            [5.100263388556374, -2.3875071226717868],
            [5.101533434766408, -2.3831303557674723],
            [5.105363769695112, -2.381757522865142],
            [5.106850729511805, -2.37764924810466],
            [5.111123946882314, -2.377642345058931],
            [5.113448919375272, -2.374313134300154],
            [5.118440404139642, -2.3719469466887197],
            [5.127767628458325, -2.365851341324011],
            [5.131905141860943, -2.3676794445532656],
            [5.134695125166128, -2.3656122029672324],
            [5.135329775454781, -2.3619436425939924],
            [5.142135667712003, -2.353089102693095],
            [5.150086921075171, -2.3536897229941616],
            [5.1546825574107915, -2.3504501224161065],
            [5.155657809763401, -2.344143059549375],
            [5.151011480340131, -2.339622408722066],
            [5.151146461647596, -2.336655372216599],
            [5.155265205705954, -2.3354276554309013],
            [5.159674823714341, -2.3257642281487327],
            [5.161547696500665, -2.3134169704165504],
            [5.16919611541091, -2.3116897170008595],
            [5.173092028873548, -2.3092721873935678],
            [5.185991025962368, -2.3050907200293715],
            [5.191630878759619, -2.2954895804638085],
            [5.189712138299077, -2.2886726430374726],
            [5.195460444240702, -2.281885732702648],
            [5.19980084663978, -2.2731984024956686],
            [5.194952229548237, -2.26327996056133],
            [5.188803063732717, -2.2575140540217506],
            [5.186071945802517, -2.2583088650845395],
            [5.184276098921005, -2.2549058533221533],
            [5.188614705813389, -2.242565545469838],
            [5.186341523376949, -2.240210011510444],
            [5.186871115909575, -2.235297641638313],
            [5.189250889838473, -2.2335766648658666],
            [5.18601619063428, -2.228135959523368],
            [5.191144500546435, -2.220115866832506],
            [5.194411253556198, -2.216674722524132],
            [5.195464899498908, -2.202780811492602],
            [5.194395456069013, -2.193647323542405],
            [5.190484807485071, -2.187246254968509],
            [5.1838379165164055, -2.1803768869988045],
            [5.1805562471719275, -2.1756330520148306],
            [5.169272691000818, -2.1731011484507126],
            [5.161831888550297, -2.1727982924247136],
            [5.157216362082211, -2.1737385692301197],
            [5.14727899568761, -2.1674228718651523],
            [5.141445692334824, -2.167047867056032],
            [5.139388042990468, -2.1637285854186206],
            [5.13631795749176, -2.1652806084552303],
            [5.1363644643037905, -2.1560744128836458],
            [5.132258563005931, -2.1577124898363276],
            [5.128697049531654, -2.154924331955215],
            [5.129092680872122, -2.148101009461874],
            [5.133146600578934, -2.1470898696438985],
            [5.135582363478823, -2.142200303163148],
            [5.1336820421108555, -2.135910734221257],
            [5.1318768231453635, -2.1234184749964267],
            [5.128357892779049, -2.1191247074993433],
            [5.128059764355222, -2.1159906248327065],
            [5.116674759038489, -2.1161239188891128],
            [5.118535707042795, -2.1085552713949953],
            [5.123839826752515, -2.1096537220511373],
            [5.127039380182638, -2.108411374726513],
            [5.125537424442962, -2.1029701693453235],
            [5.12183511654309, -2.103057846249266],
            [5.113270010478372, -2.100158611559927],
            [5.115719167046353, -2.082548253518219],
            [5.117182032941044, -2.0813261585748606],
            [5.065358984163455, -2.084648527779862],
            [5.063173649264695, -2.0724786976754195],
            [5.065146568092648, -2.066622688373798],
            [5.06208579864961, -2.060358445267289],
            [5.065709030748523, -2.059222146138741],
            [5.064043729955817, -2.054837844012464],
            [5.070688439082441, -2.050569895305785],
            [5.067604858147453, -2.044585128084754],
            [5.06879265201955, -2.0397338264971334],
            [5.07341424149966, -2.0405749375462943],
            [5.0771013648732515, -2.0395493338251143],
            [5.077768959128471, -2.032682753580253],
            [5.085197255589465, -2.036266759882203],
            [5.08768764762432, -2.0320590676133254],
            [5.0850214815008385, -2.0260179650792463],
            [5.089142209839635, -2.0185435246967076],
            [5.087760362904355, -2.014544466293125],
            [5.090350526011566, -2.0106670314385675],
            [5.086607763628085, -2.0069237300609446],
            [5.084914421851388, -2.0031690747302],
            [5.085955865141055, -1.9956383447002792],
            [5.0895769515369045, -1.9853789258287406],
            [5.096590875852053, -1.9772612416462303],
            [5.097708096545477, -1.9739215099075442],
            [5.101217560290998, -1.9749604480050944],
            [5.102444697994303, -1.9713783375682812],
            [5.098249912288606, -1.969154352251042],
            [5.097159321931143, -1.9642680448300314],
            [5.1021074271649836, -1.9602015902006205],
            [5.1024884564438535, -1.9644905836422784],
            [5.106954279025256, -1.9614430982793036],
            [5.106222807349522, -1.954559477630695],
            [5.110178411899527, -1.956528851398285],
            [5.113414418603195, -1.9530147920328358],
            [5.112184136259841, -1.9474922273194082],
            [5.120456242598313, -1.9464200622053243],
            [5.163631510089597, -1.9442645121528854],
            [5.236047473042841, -1.9408053329547474],
            [5.262694939809697, -1.9394081571661748],
            [5.259374023349464, -1.9435219053605362],
            [5.259893757505015, -1.9556575168268235],
            [5.261354629420084, -1.9604225687524568],
            [5.260957100540334, -1.967947487946556],
            [5.263546721027546, -1.9733787337430142],
            [5.266481165998131, -1.9841805796264917],
            [5.265785153315436, -1.987042481736162],
            [5.2675041229057955, -1.994934041605087],
            [5.268514066376667, -2.0082722454428845],
            [5.271965719958102, -2.023425210652317],
            [5.269739800439777, -2.0279756245962686],
            [5.270595958002855, -2.0343416421861167],
            [5.267872413892423, -2.0420695991182747],
            [5.269197942346731, -2.0455751014992187],
            [5.268553659022373, -2.0501632079953076],
            [5.2698600547744485, -2.054243085081678],
            [5.270661171848286, -2.064153651148773],
            [5.269411195808311, -2.069670791368267],
            [5.271970535755529, -2.0745513832909257],
            [5.273945760049333, -2.0890340652973163],
            [5.273706291414834, -2.0973647702560902],
            [5.271487913794241, -2.103203109730297],
            [5.271836953312446, -2.106691637485652],
            [5.274625366480046, -2.1096742325676336],
            [5.274339330310188, -2.1226808497669305],
            [5.271791538625643, -2.1278748090263058],
            [5.272625240076133, -2.1324665881270657],
            [5.271623957460561, -2.1372235056128597],
            [5.272122629117138, -2.1424612239270084],
            [5.270538842092279, -2.1547259579483637],
            [5.27256371367593, -2.1597837234752135],
            [5.270476061455129, -2.1625545367507923],
            [5.269902379052225, -2.1690347572211808],
            [5.267171078457364, -2.181471905021638],
            [5.276109963605457, -2.181706690787312],
            [5.281610854925627, -2.262400315205384],
            [5.281879651125406, -2.27718859198925],
            [5.285893315731861, -2.33637970185738],
            [5.292618561415001, -2.4163551460857176],
            [5.293943681522306, -2.439713032352028],
            [5.302678918573418, -2.57167193823625],
            [5.302636850749228, -2.573911394892949],
            [5.187117021385879, -2.5820537961955616],
            [5.168355784556562, -2.583728831349693],
            [5.039013252175863, -2.592842479549336],
            [4.968006811350228, -2.597783024385927]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.09085191104693, "lat": 36.27204448083673 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29069"],
        "coty_name": ["Dunklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dunklin County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00758489"
      },
      "bbox": [
        4.968006811350228, -2.597783024385927, 5.302678918573418,
        -1.9394081571661748
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9206525782377866, -0.7729365350458054],
            [2.987395029733694, -0.7718130422078143],
            [3.052405048518247, -0.7705737846908703],
            [3.0949058738965576, -0.770252597978599],
            [3.1044591359568163, -0.7698739754313483],
            [3.104055066713607, -0.7760354629577849],
            [3.107381477006414, -0.7837980021198726],
            [3.1063040669230735, -0.7886861381603152],
            [3.1097458914480587, -0.7908874257452561],
            [3.109798399149145, -0.798967509444685],
            [3.114753536960303, -0.8062675357114587],
            [3.1223326911794835, -0.8103412264528728],
            [3.120785585339283, -0.8130235515103773],
            [3.1223800213567694, -0.8182204273946531],
            [3.122044751320021, -0.8219707923493145],
            [3.125695477755186, -0.8255784344145931],
            [3.1306913627183093, -0.827514975684591],
            [3.1339802642707366, -0.8339703189890474],
            [3.137786736358492, -0.8353489809459251],
            [3.1404789865675684, -0.8383841972115226],
            [3.1449274154507108, -0.8380207288540726],
            [3.148608407756823, -0.847178214604553],
            [3.150890174122781, -0.8492730993161264],
            [3.150426123244071, -0.8546691047786533],
            [3.152820171058835, -0.8568952665706308],
            [3.163364109546436, -0.860692961635083],
            [3.1707122862258457, -0.858884875872165],
            [3.174836061261871, -0.8508566040326618],
            [3.1765747042136536, -0.8495018836711752],
            [3.1876036766126843, -0.8469776468962648],
            [3.1907889208612383, -0.8491907969925279],
            [3.1954595478611725, -0.8378422336414884],
            [3.1995791835951657, -0.8318899411268049],
            [3.2160339739391746, -0.8299858501515196],
            [3.219632086688409, -0.8314640817141359],
            [3.225887860293424, -0.8312196497524218],
            [3.230609923641903, -0.8335922249682064],
            [3.23763704821035, -0.8341688574769739],
            [3.2374633726814346, -0.8297274596487257],
            [3.240518126624411, -0.8257868697199074],
            [3.239942912832039, -0.8226891804755975],
            [3.2454673159042295, -0.818168997243883],
            [3.2485052983655947, -0.8132839044858017],
            [3.2580301695345226, -0.8050195047104285],
            [3.2584716623118877, -0.8013238731081144],
            [3.2624657040372345, -0.7971862485152801],
            [3.270474107313827, -0.7974720863078549],
            [3.271299189379656, -0.8606449870961494],
            [3.271890075615208, -0.8894713532966658],
            [3.2725376090825256, -0.9439263091714739],
            [3.2741798075660427, -0.9439845418833731],
            [3.360067063558904, -0.9845371143990086],
            [3.404100169940294, -1.005219917157752],
            [3.4054380760387253, -1.049553597363281],
            [3.4084833293922863, -1.1824007694073486],
            [3.3662814925323348, -1.1833451753395885],
            [3.366151889106959, -1.1840574538388324],
            [3.324078841501703, -1.184760808682307],
            [3.3147844847616543, -1.185331512191578],
            [3.283261214151992, -1.1854213465040802],
            [3.2387832468521114, -1.1861148917121096],
            [3.196113916694621, -1.1863005620937197],
            [3.179805844786495, -1.1854115557570712],
            [3.145196887245847, -1.186069567050655],
            [3.0669952553297026, -1.1863996061939266],
            [3.012165550241129, -1.1871477305851845],
            [2.9891347725800745, -1.1876939087387859],
            [2.9359021190140644, -1.1884057394253833],
            [2.9350293116120074, -1.117854420850481],
            [2.934341913137885, -1.0478169386293068],
            [2.934102973170922, -1.0459600323692844],
            [2.9336959515737075, -0.9943133923596581],
            [2.9336148581114196, -0.9489971810899522],
            [2.922936007242284, -0.9491487925931396],
            [2.9225159077809213, -0.904994927427732],
            [2.921680409872415, -0.8837547137709143],
            [2.920932447307408, -0.8459865597873859],
            [2.9206525782377866, -0.7729365350458054]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.59035820321597, "lat": 37.65828769508338 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29105"],
        "coty_name": ["Laclede"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Laclede County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00758507"
      },
      "bbox": [
        2.9206525782377866, -1.1884057394253833, 3.4084833293922863,
        -0.7698739754313483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.143094594258435, 0.998646473982814],
            [4.145907088324053, 0.9938548423657213],
            [4.148787054022906, 0.9824667927511886],
            [4.152114462009739, 0.9654857404649102],
            [4.156090766013974, 0.959258846421345],
            [4.164254136597618, 0.9492477559209468],
            [4.168464133612021, 0.9469867464639655],
            [4.185156207108724, 0.9442324940856421],
            [4.194624252444855, 0.9435779594216491],
            [4.205429138993838, 0.9417060653818944],
            [4.211594905407006, 0.9325042287634652],
            [4.217246616716481, 0.9205332583760129],
            [4.22271665976891, 0.9113031301502633],
            [4.226376265874543, 0.9065577241707945],
            [4.235205921775918, 0.898726529284713],
            [4.237725245416913, 0.8781170922345396],
            [4.240273095189803, 0.8729312825321542],
            [4.245500152891925, 0.8663932246593541],
            [4.257515702028131, 0.8531873020418123],
            [4.269229293763653, 0.843953575884544],
            [4.285035049885979, 0.8335731741513787],
            [4.2928489173064825, 0.8292906620033139],
            [4.301211171149613, 0.8272080464904884],
            [4.305455107238508, 0.8252369475224715],
            [4.309614347295508, 0.8212662915450418],
            [4.321358202266695, 0.8166853585008226],
            [4.328439266770775, 0.8155515535798585],
            [4.33438574519621, 0.8123120724254996],
            [4.337675523227268, 0.8079412951531604],
            [4.340189624075161, 0.8006361388570603],
            [4.3444589770637005, 0.7962313641595382],
            [4.35060643023391, 0.7926610955309517],
            [4.360683372061157, 0.7902945582900596],
            [4.364755489857822, 0.7871994362763752],
            [4.367184491893761, 0.7820935903398624],
            [4.372287254365065, 0.7773023502506667],
            [4.399666709300718, 0.7626327241159466],
            [4.408882629963024, 0.756967710467962],
            [4.414803278770332, 0.752402431898396],
            [4.4301071926460285, 0.736273140456336],
            [4.433689949251461, 0.7332710024699685],
            [4.447493330536048, 0.7265355678427031],
            [4.452195173837, 0.7231648790764833],
            [4.4546917020478745, 0.7166395120704092],
            [4.460279978458786, 0.7111392412452828],
            [4.466733445097182, 0.7070932132237885],
            [4.473586420303169, 0.694543972240079],
            [4.48668630854281, 0.6805132642173681],
            [4.496464745968765, 0.6774763817475289],
            [4.503789475577125, 0.6718173741004222],
            [4.5063351429003875, 0.6671855814941439],
            [4.511495166764472, 0.648825485979489],
            [4.51179292646561, 0.6401246801938111],
            [4.461605695007645, 0.6373956995564025],
            [4.461388329427487, 0.6371835844238104],
            [4.378742151951293, 0.6338332323302094],
            [4.336157974236682, 0.6313402134539886],
            [4.298536835688104, 0.6289301266296801],
            [4.282226229561722, 0.6285058429423727],
            [4.2374374125392, 0.6264676810411931],
            [4.178591789255556, 0.6255583163798294],
            [4.15830757937863, 0.6244942614334867],
            [4.159466660143623, 0.5942216069805792],
            [4.159998539038182, 0.5649537430706574],
            [4.160885875870725, 0.5354871138891715],
            [4.103475489414026, 0.5334028133645048],
            [4.0538341195225485, 0.5320197064267398],
            [4.0294119198366, 0.5317939259625644],
            [3.9891679319987974, 0.5305136278514918],
            [3.9737606761957824, 0.6186565766254579],
            [3.9582275010575345, 0.7070775596969024],
            [3.9348666055631765, 0.8393586409286797],
            [3.9471158021318447, 0.84950862708302],
            [3.9586252106450415, 0.8598636395347043],
            [3.9652438874659715, 0.8648804114444983],
            [3.997632683928292, 0.8918068397402241],
            [4.003602973939449, 0.8952101939934913],
            [4.089500710291059, 0.9687282228147496],
            [4.090920571215906, 0.9705312816902564],
            [4.123493145481856, 0.9978146322315464],
            [4.143094594258435, 0.998646473982814]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.17137734583741, "lat": 39.34383488573943 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29163"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00758536"
      },
      "bbox": [
        3.9348666055631765, 0.5305136278514918, 4.51179292646561,
        0.998646473982814
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.383371277368619, -1.4292474332757175],
            [5.388878314582065, -1.4289128788395196],
            [5.387683670867048, -1.4142534210394613],
            [5.416622920748965, -1.4123937737851748],
            [5.4154492021680785, -1.3977885045092737],
            [5.429822872223368, -1.3968618793291687],
            [5.427598063597977, -1.3677571734793372],
            [5.442018230077342, -1.3667579578766538],
            [5.440931042238877, -1.3521799697094268],
            [5.455529713346757, -1.3509364126412116],
            [5.455037258677863, -1.3435109233084637],
            [5.469166283246368, -1.3425023053435043],
            [5.468198562150606, -1.3303473535134793],
            [5.491176225900169, -1.3287945392123695],
            [5.490336888024553, -1.3139497296571552],
            [5.519277910872169, -1.3120880811913875],
            [5.518774691632398, -1.3046358239524498],
            [5.547864571427562, -1.3027619083163646],
            [5.547422403063161, -1.2956343050587384],
            [5.5678375690056905, -1.294214171875017],
            [5.573575278623301, -1.2967252871509698],
            [5.578615832412196, -1.2968491504589041],
            [5.580948239760887, -1.2931399620310038],
            [5.590956606326019, -1.2934368540435428],
            [5.592528314401328, -1.2882924787241121],
            [5.599910841953245, -1.2862228134660125],
            [5.606715839196229, -1.2854463792060125],
            [5.614641625001827, -1.2877138086584439],
            [5.616809078338237, -1.2911172200527294],
            [5.617230178195883, -1.2978658593288805],
            [5.611280089028189, -1.317019749705389],
            [5.611429720964856, -1.320696712131331],
            [5.617265410351555, -1.3391996274520097],
            [5.622587774726631, -1.3503650429723195],
            [5.638490743923005, -1.3764183645219215],
            [5.6415512640257255, -1.3855127665941127],
            [5.650095207601169, -1.3989406225928118],
            [5.659766468435679, -1.4116114423122563],
            [5.665698321062632, -1.4170107302168802],
            [5.677315136142204, -1.4244091740830214],
            [5.685161472960815, -1.431886700062784],
            [5.690077803970341, -1.4403278244750966],
            [5.693125061277056, -1.4488677468069204],
            [5.6934305076388325, -1.4543417893145667],
            [5.691629675333578, -1.4645919422105813],
            [5.687561067735099, -1.4777774752465447],
            [5.688626129281583, -1.4873125206224425],
            [5.694283655487953, -1.4956662194601265],
            [5.707472756267319, -1.5043057307671523],
            [5.720735839153366, -1.5080669494580454],
            [5.732830000211036, -1.5128692956715803],
            [5.744378664976266, -1.51931095917709],
            [5.7476805291875825, -1.5223194690447868],
            [5.7209411512166115, -1.5246576139848345],
            [5.721367549177141, -1.5318450084062052],
            [5.700601133913973, -1.5410802321115518],
            [5.702067694428586, -1.570661310695598],
            [5.673481852075658, -1.5728127542399086],
            [5.674356564426881, -1.5875758967507838],
            [5.6598031881665625, -1.5884550670741076],
            [5.6607848912553935, -1.6032126240651001],
            [5.632784735195599, -1.6050238663742444],
            [5.634956697761967, -1.6347081754974382],
            [5.60627993549135, -1.6366534020558097],
            [5.608312243556873, -1.6661907982584345],
            [5.593807126903331, -1.6671711619432035],
            [5.594354907512618, -1.6745385242999897],
            [5.557334014432501, -1.677339565143751],
            [5.556510448191461, -1.675805227443997],
            [5.527558570000434, -1.6825062076115929],
            [5.526792794097989, -1.6871692434458876],
            [5.491805554332606, -1.6905035453897368],
            [5.459217905863924, -1.693856224793452],
            [5.456780213104658, -1.683613456290691],
            [5.4537167417518, -1.6794443909693533],
            [5.457724346243504, -1.6696655167756687],
            [5.461264892387497, -1.6659001735202696],
            [5.457141770579144, -1.6608812370343577],
            [5.457191177555152, -1.6576968881075662],
            [5.454815323859735, -1.6535660946885509],
            [5.456296129347862, -1.6462791693245187],
            [5.455818776833879, -1.6427292376378038],
            [5.459139963238181, -1.6387528440653862],
            [5.459007431416643, -1.6341138629119565],
            [5.45634852782105, -1.6270331629642798],
            [5.45850203308143, -1.624587828377804],
            [5.453341204140131, -1.6174862055315495],
            [5.453274433570995, -1.6121863201878204],
            [5.449356266854681, -1.6128572031732615],
            [5.446917156329256, -1.6079656255576988],
            [5.444221600345081, -1.605814958803464],
            [5.440066190768595, -1.6064323313358388],
            [5.434629593773166, -1.6018168571098648],
            [5.433298191622771, -1.592913757261592],
            [5.430317337112024, -1.5829423345695903],
            [5.427060852271493, -1.5783581009425227],
            [5.428253809274474, -1.5671272430562255],
            [5.424935746429393, -1.5627401847300504],
            [5.419599782852224, -1.5531120553650046],
            [5.413431611647035, -1.54752286791264],
            [5.414346093488585, -1.5439788394844423],
            [5.408688254790356, -1.5379277431433975],
            [5.404820194977695, -1.5317017413462313],
            [5.404822862997984, -1.527282184888478],
            [5.398693521516369, -1.525521004021512],
            [5.3995575610565485, -1.5195345505958044],
            [5.394555566494098, -1.517254810913867],
            [5.395673508711594, -1.5110675843318526],
            [5.393565508182865, -1.5048425930484846],
            [5.387403631417698, -1.5052180895307363],
            [5.383948949824009, -1.499617385845208],
            [5.384271942106851, -1.4966596952628324],
            [5.376107096070493, -1.4843060529907388],
            [5.37654261015791, -1.4803931850422785],
            [5.369906450155364, -1.4732655045629346],
            [5.368868040439019, -1.4688826625033615],
            [5.374848857228821, -1.460879056529055],
            [5.377937081399048, -1.4587313842728031],
            [5.376755829035657, -1.4527080886670014],
            [5.383585118678879, -1.4367889361833661],
            [5.383371277368619, -1.4292474332757175]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.5685856470163, "lat": 37.05301022186211 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29201"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "201",
        "coty_gnis_code": "00758553"
      },
      "bbox": [
        5.368868040439019, -1.693856224793452, 5.7476805291875825,
        -1.2854463792060125
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.742631105111704, 9.109764256372198],
            [-11.719519504066088, 9.105406049230568],
            [-11.720005214334385, 9.10279394781109],
            [-11.634988355710503, 9.087155134095154],
            [-11.62444810878308, 9.143118113881343],
            [-11.545509424888648, 9.128789433148139],
            [-11.54285070981496, 9.142794008812588],
            [-11.53852153876505, 9.141989753567453],
            [-11.536005637974514, 9.155169981310221],
            [-11.491884270194571, 9.147142733825007],
            [-11.481291408806854, 9.203271008571654],
            [-11.445625795110637, 9.196707093657713],
            [-11.438944791418157, 9.195232440384629],
            [-11.433240853051492, 9.223804047699137],
            [-11.35643154153196, 9.209845827121613],
            [-11.348719569734293, 9.208483881915798],
            [-11.353210452484843, 9.184041309935882],
            [-11.341591813566673, 9.187771717885393],
            [-11.338111896473755, 9.192046868283043],
            [-11.331546044434177, 9.198050560849662],
            [-11.328718346760294, 9.197405994044358],
            [-11.326004244116604, 9.192277880738487],
            [-11.322331737007863, 9.19207332116856],
            [-11.318536698217422, 9.18464548294547],
            [-11.319067941661997, 9.176676354281783],
            [-11.321148994385123, 9.172733454697639],
            [-11.315792286931737, 9.158505021613683],
            [-11.314812008795188, 9.153719577774362],
            [-11.31178763114172, 9.152934448298332],
            [-11.304026201959843, 9.14746973538519],
            [-11.300179607520011, 9.140369708521403],
            [-11.29717424581287, 9.13687623165839],
            [-11.292155474788226, 9.134171157434094],
            [-11.289415215274298, 9.128064300156053],
            [-11.285658162754117, 9.12586848986864],
            [-11.284175644843742, 9.116419045057944],
            [-11.290764514860424, 9.111033290530433],
            [-11.291908136026077, 9.099849697691507],
            [-11.289889418132041, 9.0963903043904],
            [-11.282333107503451, 9.097935429916832],
            [-11.27977044876036, 9.09186627761986],
            [-11.271741295930605, 9.092716449049204],
            [-11.268487798231286, 9.08982843340995],
            [-11.260282016740653, 9.086310230872174],
            [-11.257245408300323, 9.079611788251494],
            [-11.25376919456904, 9.077363509301968],
            [-11.251073396743099, 9.072049599746439],
            [-11.238596435759108, 9.075118797394566],
            [-11.23672476205096, 9.077086643844277],
            [-11.231189085191813, 9.076958818998799],
            [-11.229299051928942, 9.074950689372734],
            [-11.224700190425253, 9.074501575145002],
            [-11.221420634808581, 9.078245076280263],
            [-11.211254102706826, 9.08286286680242],
            [-11.20983433756087, 9.080657746898966],
            [-11.20512572343128, 9.082454905178894],
            [-11.200538358795821, 9.08624764627005],
            [-11.195061703056012, 9.084154604162348],
            [-11.229272080321806, 8.896604556843817],
            [-11.239553216921642, 8.840215435811594],
            [-11.238206108833175, 8.839972232505062],
            [-11.253485230516674, 8.755485338417099],
            [-11.25396763977833, 8.755571729038724],
            [-11.260386986532588, 8.720363688181797],
            [-11.277111613143765, 8.629579515010223],
            [-11.284845110781077, 8.587353530851884],
            [-11.368887044527849, 8.602415194811156],
            [-11.453893707662814, 8.61731653583789],
            [-11.469942681968895, 8.532942044823553],
            [-11.462652159761577, 8.53162663827904],
            [-11.476447510764034, 8.457366670703209],
            [-11.481243431216049, 8.45612504522618],
            [-11.48148215291592, 8.444166098336689],
            [-11.485840060627869, 8.442084676644338],
            [-11.487854986472, 8.438136150372763],
            [-11.4909516079693, 8.437199222880311],
            [-11.496322872544877, 8.432799002061008],
            [-11.507095891919992, 8.428746085618409],
            [-11.512564213381753, 8.423337790519728],
            [-11.521209757224277, 8.421507119699784],
            [-11.528217190619646, 8.412622501774813],
            [-11.531991816819161, 8.41602644456045],
            [-11.538894768826042, 8.41946653041815],
            [-11.547002983705697, 8.418226757891977],
            [-11.555340170745337, 8.430841707931998],
            [-11.568506116827994, 8.428562303082739],
            [-11.567996689285982, 8.421645164974901],
            [-11.57252027452786, 8.415784004040864],
            [-11.575813351059196, 8.415146501279784],
            [-11.580727655183003, 8.416495026236085],
            [-11.585282687447037, 8.40741095430234],
            [-11.591389820017463, 8.407163398550512],
            [-11.595948701302307, 8.405070931859058],
            [-11.599612735289668, 8.406408440825928],
            [-11.605315757169782, 8.402222569980927],
            [-11.612596076005259, 8.404942338406704],
            [-11.615933247588876, 8.407266728783561],
            [-11.62001149964803, 8.401779487628978],
            [-11.620520862172791, 8.398498869102497],
            [-11.624919098998555, 8.396157305108721],
            [-11.62554707174067, 8.393014948042053],
            [-11.620644080781915, 8.386121279395997],
            [-11.624335032096944, 8.380805360630095],
            [-11.630505596600683, 8.378944291967716],
            [-11.632606331855866, 8.37449568626892],
            [-11.638958586699456, 8.366901556435865],
            [-11.645215588881038, 8.373792353226712],
            [-11.650822898639474, 8.377886611986035],
            [-11.654134365488336, 8.378142036264794],
            [-11.65749912616358, 8.375117816287112],
            [-11.661168554724227, 8.376481835663814],
            [-11.664373671478202, 8.371992077907828],
            [-11.668782976432984, 8.375413795447852],
            [-11.669601671870387, 8.37797615002263],
            [-11.677532540694205, 8.378787808913234],
            [-11.683507084877421, 8.382140836570956],
            [-11.688547488586964, 8.383548710936077],
            [-11.695437198796581, 8.37963680291968],
            [-11.700203387984116, 8.379828815528578],
            [-11.706903958012182, 8.378418994721255],
            [-11.706109940038004, 8.383737423999573],
            [-11.708636095513398, 8.38719958304798],
            [-11.712125625352238, 8.387290881806377],
            [-11.714577444434708, 8.39041384391229],
            [-11.719339820479998, 8.39197475253605],
            [-11.723091604086008, 8.390980367612258],
            [-11.72517672291781, 8.393037628112857],
            [-11.72655174187529, 8.40325919668658],
            [-11.725207443861757, 8.409429859062774],
            [-11.726350065092381, 8.413799018219331],
            [-11.733356362409284, 8.414637579280404],
            [-11.73633963192946, 8.41140486754554],
            [-11.742601621887403, 8.412380608257097],
            [-11.746725931712524, 8.410516109835955],
            [-11.749583825116622, 8.413054533736476],
            [-11.753363346646752, 8.425039245215727],
            [-11.757127030880783, 8.429818035280471],
            [-11.756175536031138, 8.436120146649127],
            [-11.758860914866437, 8.444978063128717],
            [-11.756497368469155, 8.44754652652313],
            [-11.756383470108972, 8.452099303112167],
            [-11.758608236066115, 8.457372524932483],
            [-11.75674119204361, 8.461789836569118],
            [-11.759245954022353, 8.465379413694931],
            [-11.754821459179428, 8.470819996391475],
            [-11.763664639999798, 8.473843691983575],
            [-11.76718247277381, 8.477343803260391],
            [-11.763028555359377, 8.485898821019118],
            [-11.767060744609495, 8.48872188063941],
            [-11.776793424298958, 8.492455010313488],
            [-11.7930120252148, 8.49470805333258],
            [-11.79693805103634, 8.503275580409516],
            [-11.79993480232813, 8.506390853994102],
            [-11.804231396079615, 8.506278229337084],
            [-11.80801617169133, 8.503258356224197],
            [-11.809358446944728, 8.49887841848368],
            [-11.812245407625696, 8.495668573629487],
            [-11.814222256454666, 8.49024329159847],
            [-11.820275444106645, 8.489112158695601],
            [-11.82362306153173, 8.492891445990239],
            [-11.8287312282633, 8.494924085535597],
            [-11.834457441698985, 8.49929713898122],
            [-11.840106441421586, 8.500557658094873],
            [-11.842117778266815, 8.503126721705476],
            [-11.839473154102075, 8.509375855430259],
            [-11.839881847973501, 8.514128792578036],
            [-11.833272671601096, 8.518023632519377],
            [-11.8303918071332, 8.522017227772347],
            [-11.830055924811957, 8.526584969822972],
            [-11.824069261145974, 8.532091902983241],
            [-11.824206125609765, 8.53672173730956],
            [-11.813200205637825, 8.543480624703939],
            [-11.810899606727979, 8.54613275527851],
            [-11.805211189473672, 8.560402325456353],
            [-11.798019517654446, 8.561322052998296],
            [-11.795409631750374, 8.563996741497204],
            [-11.793738810670941, 8.569558264356544],
            [-11.796574660114832, 8.576229144129533],
            [-11.79950074766193, 8.580040970794007],
            [-11.800731448804925, 8.58857239865808],
            [-11.803114822471361, 8.592416399712596],
            [-11.806122174234881, 8.593367828068052],
            [-11.805473981302175, 8.598492872511837],
            [-11.806358202710795, 8.6037498713562],
            [-11.809906641966501, 8.605063964254036],
            [-11.814321500238801, 8.610830458266836],
            [-11.815002459573924, 8.613529310105058],
            [-11.809601651163256, 8.622463169873315],
            [-11.80849947592482, 8.634328617058879],
            [-11.803327941849163, 8.638655806302898],
            [-11.811777699691582, 8.646839036602424],
            [-11.812704441709077, 8.65200763618739],
            [-11.816070128776497, 8.653493950640204],
            [-11.820220085853693, 8.651601672781604],
            [-11.823366516003952, 8.65387375713859],
            [-11.824012060682785, 8.662951359685186],
            [-11.825240784045, 8.665196236764162],
            [-11.823383956711547, 8.671607904662508],
            [-11.818600464445787, 8.67734291978137],
            [-11.811682467020663, 8.678731882948025],
            [-11.80613921779419, 8.678547638006954],
            [-11.803176369230433, 8.68092441734728],
            [-11.79751928793042, 8.681487577989069],
            [-11.787187820045231, 8.684421434441653],
            [-11.787129342286871, 8.694411563359036],
            [-11.783105510224518, 8.700481177103194],
            [-11.776184698818211, 8.70021100085552],
            [-11.77221227939802, 8.711427671159669],
            [-11.767501946382696, 8.71483644156061],
            [-11.76200055732229, 8.716956430735744],
            [-11.76235573537721, 8.723696202378568],
            [-11.765449511496493, 8.727493859419477],
            [-11.77244575485016, 8.730860895281534],
            [-11.779943070662597, 8.738511724619354],
            [-11.782891696836375, 8.740368167271269],
            [-11.783406373194424, 8.743620909860608],
            [-11.780893391489094, 8.749453285307487],
            [-11.781373569830972, 8.75192865211015],
            [-11.777799495525617, 8.756222480771845],
            [-11.777981450919908, 8.759283177587674],
            [-11.772415409356814, 8.7642188157671],
            [-11.767828563551673, 8.774047741993993],
            [-11.771423062226733, 8.778485756975376],
            [-11.773023056971073, 8.78424550548406],
            [-11.773738132119586, 8.793011153371548],
            [-11.771477817171656, 8.80695834534144],
            [-11.76758926295611, 8.812346499768967],
            [-11.767269775842989, 8.816987706706636],
            [-11.769699919203603, 8.81979384229979],
            [-11.768358140487917, 8.823118053594342],
            [-11.774668500057711, 8.827110965704396],
            [-11.775717822865161, 8.839601717413647],
            [-11.780043039695993, 8.843144249385155],
            [-11.7804023564563, 8.850049494345903],
            [-11.784229802136421, 8.853166028577114],
            [-11.784070781732364, 8.856549566325675],
            [-11.786416036203045, 8.859729459505834],
            [-11.784684892498525, 8.863449056256425],
            [-11.787946733915266, 8.866874002560323],
            [-11.79269230930744, 8.86641702048449],
            [-11.794306828059026, 8.872523237186236],
            [-11.8045956091636, 8.87753272853865],
            [-11.808154534847228, 8.880805950925417],
            [-11.804740728816649, 8.889237418488026],
            [-11.803823517489757, 8.893813933179446],
            [-11.798091323766592, 8.899769638498041],
            [-11.796778695860326, 8.906608161831663],
            [-11.79759825944689, 8.914539655011245],
            [-11.799249650086013, 8.917506094248095],
            [-11.797742954567008, 8.929306910831928],
            [-11.801941805532962, 8.934799265439283],
            [-11.800040212360404, 8.93933394241316],
            [-11.802599236110847, 8.944666525391941],
            [-11.799903548583664, 8.951393705349375],
            [-11.807292743056172, 8.958095271602604],
            [-11.806271269248857, 8.963694919830196],
            [-11.802800956632055, 8.96818535219595],
            [-11.796251079386884, 8.97130909294984],
            [-11.784892789333709, 8.97134014287705],
            [-11.781116032772665, 8.97740841564881],
            [-11.77988497155635, 8.982365559460066],
            [-11.780998535075717, 8.98593938545702],
            [-11.777457250292247, 8.992419146901995],
            [-11.777846339792044, 8.994843491147122],
            [-11.775436633769532, 9.00201431770048],
            [-11.771783458219193, 9.004928787401088],
            [-11.771274117862054, 9.008928124899336],
            [-11.768009771213498, 9.011678001753344],
            [-11.766410821587703, 9.016309555498363],
            [-11.759906998168825, 9.023465391008777],
            [-11.760343035714126, 9.028712615066855],
            [-11.763075069606272, 9.034501484284357],
            [-11.76200591278061, 9.036397140311939],
            [-11.756138131896696, 9.037133620791664],
            [-11.75268921830691, 9.039961970341569],
            [-11.7466223071941, 9.03876823314411],
            [-11.742787010442498, 9.043060464462021],
            [-11.740185151359775, 9.057024765596301],
            [-11.74351008945454, 9.06376934536319],
            [-11.740518400824117, 9.066460720421098],
            [-11.735493199415743, 9.066355271354059],
            [-11.732953069628186, 9.069609185293825],
            [-11.731790021866034, 9.07670275406464],
            [-11.740183119193466, 9.085678453331052],
            [-11.739405511035374, 9.092357810358974],
            [-11.742010160035527, 9.094588548112743],
            [-11.740781595477477, 9.102236711746288],
            [-11.742631105111704, 9.109764256372198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -113.4403383566769, "lat": 46.40453346763503 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30039"],
        "coty_name": ["Granite"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Granite County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01719605"
      },
      "bbox": [
        -11.842117778266815, 8.366901556435865, -11.195061703056012,
        9.223804047699137
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6185381896600081, 4.188016120678169],
            [-0.6080481299236035, 4.187940729989515],
            [-0.6016086683355077, 4.186558465280466],
            [-0.5947411336263497, 4.183315202219996],
            [-0.5875244232053051, 4.183382175690465],
            [-0.5799164189848584, 4.188602849566918],
            [-0.5751692143632663, 4.193664339010111],
            [-0.5733865959007047, 4.19816231860446],
            [-0.5688529312747397, 4.202860089333223],
            [-0.5624406817517662, 4.205188801257662],
            [-0.5559262995447385, 4.201582578013145],
            [-0.5520461584694346, 4.200938824761402],
            [-0.5394478595452543, 4.201703718600909],
            [-0.5336789709195482, 4.1948227535515965],
            [-0.527118448932139, 4.191114161930839],
            [-0.5137029778313501, 4.19199350954664],
            [-0.5060651657139748, 4.194418597118196],
            [-0.5028176073663523, 4.197265623018888],
            [-0.4967552923652108, 4.199145809583029],
            [-0.4883962274327486, 4.203401666674152],
            [-0.48506988472737594, 4.2014059086400355],
            [-0.4763074443176592, 4.191093020922989],
            [-0.46037736221074244, 4.187953786114156],
            [-0.44620912669496055, 4.190578775006156],
            [-0.43414484421232513, 4.186357654580128],
            [-0.4246653635308492, 4.180730941757056],
            [-0.4236647566347788, 4.1783815645123425],
            [-0.4244701004001417, 4.164388055069109],
            [-0.42144749493240624, 4.154900252749121],
            [-0.4209025740122073, 4.147733481035234],
            [-0.41879309391850433, 4.1439832067077935],
            [-0.4117714193974471, 4.140070563927236],
            [-0.4024220334481158, 4.139301218496454],
            [-0.39112916249694624, 4.137244948447604],
            [-0.3826123133941894, 4.1339383459870955],
            [-0.3756696233073524, 4.129672611853849],
            [-0.3666640325978574, 4.117385044682698],
            [-0.36403191242578425, 4.108388916857733],
            [-0.36177889489174675, 4.105788262228017],
            [-0.34742800306513494, 4.103071561297807],
            [-0.3361228723612163, 4.102890416262157],
            [-0.32833250017987575, 4.103524729369013],
            [-0.3183732029442128, 4.105663742518924],
            [-0.31380905746807575, 4.105496149886643],
            [-0.3040451866687848, 4.103378728543476],
            [-0.29026385893814116, 4.0989300898736],
            [-0.28806939210502486, 4.0967067219803175],
            [-0.2776099516059527, 4.0944741462768715],
            [-0.27765805222460205, 4.019754666705543],
            [-0.27866458910789055, 3.977081829365018],
            [-0.2790287038058244, 3.9443850244072913],
            [-0.2797696979721166, 3.85708090444218],
            [-0.2801557167815793, 3.848049612142325],
            [-0.2806657814634271, 3.798854498067818],
            [-0.28069154601721047, 3.7696786386872425],
            [-0.2823409947162015, 3.76971934135507],
            [-0.2834641620154668, 3.6826213933802596],
            [-0.3264817443915334, 3.6828381777818624],
            [-0.38379660682101413, 3.6838791622658515],
            [-0.4695835421750607, 3.685168633569892],
            [-0.5403441163964889, 3.686355012667146],
            [-0.5389869689129085, 3.7736439194486757],
            [-0.6252876899592741, 3.77473856322139],
            [-0.6241031128883981, 3.8621945232099093],
            [-0.6231962500302882, 3.913116057599226],
            [-0.6226391392388781, 3.9568457421820544],
            [-0.6210611470945797, 4.05815263282579],
            [-0.620414636509371, 4.12277796480429],
            [-0.6196889516867145, 4.125039498684384],
            [-0.6185381896600081, 4.188016120678169]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.25241875105034,
          "lat": 42.599255716873216
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31027"],
        "coty_name": ["Cedar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cedar County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00835835"
      },
      "bbox": [
        -0.6252876899592741, 3.6826213933802596, -0.2776099516059527,
        4.205188801257662
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.2193475705580906, 2.5108140308952303],
            [0.31692838742691504, 2.5112049421774554],
            [0.36010685965048894, 2.5112859197299424],
            [0.3744639705441807, 2.5110428314885502],
            [0.40298118921535886, 2.5111819083491627],
            [0.46029066458608026, 2.511065356299739],
            [0.5209844817891524, 2.5116284168109875],
            [0.5247368400688864, 2.5070950751291274],
            [0.5311589691341609, 2.5047844099818137],
            [0.5646731925859763, 2.508752058362515],
            [0.5706476462474017, 2.5075522111149136],
            [0.5755781890720928, 2.5052433330748904],
            [0.5801389221139649, 2.501020557600061],
            [0.5822387371138085, 2.4953838406464137],
            [0.5817973020242457, 2.491455082565699],
            [0.5785938092198124, 2.487018181684721],
            [0.5736675233603942, 2.4857010301686007],
            [0.5644912708213651, 2.4881087244381432],
            [0.5593833873346152, 2.4884239657026286],
            [0.5526554151339262, 2.480505645711642],
            [0.5507551875728017, 2.475093581425278],
            [0.5518151435239407, 2.4641161026592493],
            [0.5542129812883564, 2.4581763797678606],
            [0.5618512314709782, 2.4446892183888354],
            [0.5639529539442313, 2.4378426520395786],
            [0.5643039802736902, 2.421089729685191],
            [0.5664625674618242, 2.408131542674806],
            [0.5643240904284111, 2.4000374883184197],
            [0.5548879800517587, 2.389165408431194],
            [0.5524468753264005, 2.3847459893281755],
            [0.5516751496035153, 2.379917650405145],
            [0.5538739242988121, 2.3727558174587045],
            [0.54659213428462, 2.3779290069816192],
            [0.5410262132765667, 2.378905955133446],
            [0.531263036814699, 2.3780618997312457],
            [0.5276183843573959, 2.3792472532057434],
            [0.5120039531213201, 2.3771546859019197],
            [0.502300948766122, 2.377369383623591],
            [0.4988507704696078, 2.379401516593467],
            [0.49290503831122734, 2.380231939577711],
            [0.4882023389884469, 2.378893363980926],
            [0.4848118717019642, 2.3753643934768456],
            [0.47721321564971086, 2.3718971005495595],
            [0.46981083582771993, 2.3736288104585497],
            [0.46143072636263754, 2.3799681077127213],
            [0.45321947171947247, 2.3802962487207675],
            [0.44270644628640216, 2.3831142174847537],
            [0.43826905669096194, 2.3854991268326255],
            [0.4216723639561223, 2.3848572472049727],
            [0.41647680443216156, 2.3827450112459134],
            [0.40866183192879313, 2.377502148368703],
            [0.4030363194115783, 2.3765718662249538],
            [0.3936630202051623, 2.372638539216817],
            [0.3888045842266875, 2.372686808749424],
            [0.38156432334334406, 2.3678149366939256],
            [0.37337267400521773, 2.3573316054181124],
            [0.36554903809902123, 2.3506919067632426],
            [0.35939699986694085, 2.3435679511922825],
            [0.3554667501522311, 2.33681479304129],
            [0.34898744521608865, 2.3350900900748552],
            [0.3454756779891455, 2.3324411592538365],
            [0.32876592401490856, 2.325366153916842],
            [0.32337992081052647, 2.3213859145306515],
            [0.31564985064034556, 2.3188919103270127],
            [0.3083093892398661, 2.314767746255164],
            [0.29985469017341654, 2.31345680041802],
            [0.2966301051181826, 2.314795207382877],
            [0.28937481402873994, 2.3200777897421543],
            [0.2872420520278053, 2.326567237715632],
            [0.2835710117617939, 2.3327290975856996],
            [0.27608540619837796, 2.3381444340838042],
            [0.2672684537355698, 2.3381883743488103],
            [0.25760446600679837, 2.339529436618699],
            [0.2509469240628468, 2.3412294723517904],
            [0.24130372257629465, 2.3463546617785385],
            [0.23087049845939886, 2.356085674822481],
            [0.22498358992393744, 2.3647368152068813],
            [0.22077369924835671, 2.378923269348093],
            [0.21639320094844247, 2.3889356656318186],
            [0.21092134624518113, 2.398029290157865],
            [0.20969947073256398, 2.402570783590509],
            [0.2104372802366815, 2.4115556912799025],
            [0.21494455595367848, 2.419797872569797],
            [0.21985757725535388, 2.4244104874246584],
            [0.22692645351336996, 2.4287059375363733],
            [0.2313552409028214, 2.435573198084121],
            [0.2299950892261987, 2.4400701715051243],
            [0.22541708715188907, 2.4492485822200925],
            [0.2251970299675592, 2.456904519540067],
            [0.22775521431434181, 2.4644100582346278],
            [0.22357087214385746, 2.4871631239693714],
            [0.2235937658191647, 2.497448492421066],
            [0.2213630378876704, 2.506663658140725],
            [0.2193475705580906, 2.5108140308952303]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.11188439724192, "lat": 41.11295971509696 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31153"],
        "coty_name": ["Sarpy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sarpy County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00835898"
      },
      "bbox": [
        0.20969947073256398, 2.31345680041802, 0.5822387371138085,
        2.5116284168109875
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5403441163964889, 3.686355012667146],
            [-0.4695835421750607, 3.685168633569892],
            [-0.38379660682101413, 3.6838791622658515],
            [-0.3264817443915334, 3.6828381777818624],
            [-0.2834641620154668, 3.6826213933802596],
            [-0.28435752635666983, 3.5953264165443812],
            [-0.24162250613137778, 3.5947219650987305],
            [-0.14085401346751097, 3.593778076660154],
            [-0.14094826888941644, 3.579516236220713],
            [-0.14159730876145885, 3.5651350729294893],
            [-0.14163840789823223, 3.5375934105168465],
            [-0.1422282048743334, 3.506511845861259],
            [-0.14239883740188952, 3.470560473147712],
            [-0.14323348198869318, 3.4190415715606277],
            [-0.20190195611919412, 3.4196450184577505],
            [-0.2874325568037227, 3.4206041110630228],
            [-0.326647040958266, 3.421022856979046],
            [-0.4027952387416733, 3.4220326129014724],
            [-0.4844673443442395, 3.4232346570297674],
            [-0.5446256965067543, 3.424176053434084],
            [-0.5442879797316201, 3.438598222221125],
            [-0.5432258865950511, 3.5116230637130657],
            [-0.5430183554227243, 3.5190205591880153],
            [-0.541758159733683, 3.5989526350652805],
            [-0.5403441163964889, 3.686355012667146]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.11929000135156, "lat": 42.20928325002284 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31179"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00835911"
      },
      "bbox": [
        -0.5446256965067543, 3.4190415715606277, -0.14085401346751097,
        3.686355012667146
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.991646292686593, 3.4515687470525314],
            [-16.89128942001834, 3.4266850628233967],
            [-16.790935616642454, 3.4017884032150243],
            [-16.690584885789736, 3.3768787732293455],
            [-16.590237230561062, 3.3519561783860214],
            [-16.40777166548522, 3.3100258165575633],
            [-16.22531542960695, 3.2680530669563996],
            [-16.180245845171658, 3.257425184084319],
            [-16.175356655686052, 3.2559936327624066],
            [-16.03365623185402, 3.2233601117504747],
            [-15.890342925389326, 3.1895473745443153],
            [-15.883795592299334, 3.1878886277957577],
            [-15.810725565044875, 3.1708065844287803],
            [-15.807443736074958, 3.1695297693103286],
            [-15.748667325148178, 3.155507601036023],
            [-15.744883106473567, 3.1462418417412685],
            [-15.744418865377154, 3.1425157607929073],
            [-15.739831872184501, 3.1363932966282824],
            [-15.737783170639965, 3.1307517064599852],
            [-15.738777053099545, 3.123741921725541],
            [-15.73279716537111, 3.1206087783617367],
            [-15.73036383251637, 3.1179812430884235],
            [-15.73298056619798, 3.112378548480025],
            [-15.73140891742948, 3.107364001357951],
            [-15.732447783752887, 3.105224484249532],
            [-15.729680016947546, 3.099986757511048],
            [-15.723729619609323, 3.095362257833731],
            [-15.720725181543354, 3.088778151738133],
            [-15.717708192274788, 3.0890159478435733],
            [-15.71542883207907, 3.0843575603368554],
            [-15.715222964752444, 3.0740734698240297],
            [-15.713701291200302, 3.066796228600869],
            [-15.714757465628862, 3.0618684541973504],
            [-15.713000217164836, 3.053916744589799],
            [-15.71529158549402, 3.0517540136610957],
            [-15.716456853545047, 3.0412672480286855],
            [-15.715214661791682, 3.029710968315459],
            [-15.719493455207138, 3.0151814028180204],
            [-15.719285336555641, 3.0109983191580576],
            [-15.723920606575271, 3.0091663281619745],
            [-15.723900813284352, 3.002129808717324],
            [-15.730023997226736, 2.997226767995692],
            [-15.728871353224857, 2.993756395464873],
            [-15.733296384757141, 2.9887739264891673],
            [-15.733904119847956, 2.9847767741722477],
            [-15.743310540628663, 2.9815586937198737],
            [-15.744015466995302, 2.977480356955703],
            [-15.748278056506308, 2.975258504434492],
            [-15.749605939184033, 2.9667674313628773],
            [-15.748406222963904, 2.959769367744393],
            [-15.75213864506638, 2.9581444768872],
            [-15.754043171145094, 2.9549621020277],
            [-15.753979603553956, 2.945742591092503],
            [-15.756769300546301, 2.9400743649061023],
            [-15.755761428768857, 2.9352920327589804],
            [-15.760191198988908, 2.928955830184069],
            [-15.765382159309812, 2.9247618618705804],
            [-15.766789789957361, 2.9176278640661018],
            [-15.769612094711649, 2.9121655985050454],
            [-15.769940792819371, 2.902919617924652],
            [-15.771522635622873, 2.8994498120467354],
            [-15.766421249791694, 2.8961045290930696],
            [-15.765462136168518, 2.8914303332088815],
            [-15.761880345603656, 2.8899871107867834],
            [-15.759406308288892, 2.883724019194232],
            [-15.765145708786944, 2.8761330931834594],
            [-15.768162785726364, 2.870507078089978],
            [-15.77354110942444, 2.8644904412201515],
            [-15.772221880873198, 2.857972791273644],
            [-15.774792884840341, 2.8546264453924075],
            [-15.775074365254842, 2.850340405743866],
            [-15.772491053672224, 2.840115755188828],
            [-15.768385302880196, 2.836171241610265],
            [-15.765772295007457, 2.8281134996324786],
            [-15.765421794992019, 2.823165217382756],
            [-15.769252440982214, 2.822179372392337],
            [-15.773270581646463, 2.8183362305106123],
            [-15.773889710293162, 2.810191583407563],
            [-15.778510640431373, 2.809179521719566],
            [-15.78016332558567, 2.8019961566460667],
            [-15.783720360126678, 2.798074148461266],
            [-15.788031095200592, 2.7962856958668376],
            [-15.78384697658232, 2.7873871068972376],
            [-15.77838243959782, 2.782005999897292],
            [-15.773837252950527, 2.780752843873637],
            [-15.775561183108566, 2.7725976365608522],
            [-15.774872351534112, 2.7701730705730254],
            [-15.779142534458755, 2.76754995481288],
            [-15.788363591388906, 2.7583400684520836],
            [-15.790255562582292, 2.7545433267045603],
            [-15.794679839702017, 2.750284299432211],
            [-15.792151761549075, 2.7473222151161067],
            [-15.794288625100899, 2.7437761628692354],
            [-15.794478881758886, 2.7343247961913133],
            [-15.797750456285799, 2.728865639717735],
            [-15.801470970161402, 2.725569454223532],
            [-15.802769985919298, 2.7210228932973095],
            [-15.802337711369846, 2.7153130456005923],
            [-15.805668457567553, 2.706975711339217],
            [-15.809803812736705, 2.703993143614242],
            [-15.80988605021184, 2.698529582165238],
            [-15.816177811121213, 2.697078297246659],
            [-15.817813923224966, 2.6903152274189437],
            [-15.820480697894787, 2.6879276334634246],
            [-15.825266407957848, 2.6867504667787365],
            [-15.83195917934386, 2.6888358810060233],
            [-15.836339131801047, 2.6969447132468045],
            [-15.840004361144265, 2.6934030259837383],
            [-15.85021364012659, 2.689904922068412],
            [-15.86296345573905, 2.6900481294245275],
            [-15.870639066978825, 2.6921268695643574],
            [-15.875808591257686, 2.6863865720944826],
            [-15.888111901917528, 2.6888101669179014],
            [-15.894250426163472, 2.689399334890132],
            [-15.893575661339467, 2.6865527808820024],
            [-15.895315606259624, 2.6797111458938763],
            [-15.89520260900237, 2.674096496473695],
            [-15.898290525811081, 2.6716011630573],
            [-15.903809859918374, 2.6718594700059937],
            [-15.907912750514967, 2.6691745409735135],
            [-15.910465463317033, 2.6641309622724116],
            [-15.913881296046325, 2.666194334750646],
            [-15.920077592932307, 2.6651467125462345],
            [-15.922177335132266, 2.6585837089693602],
            [-15.928412695372515, 2.6540192384306143],
            [-15.93487038096181, 2.6561878687352416],
            [-15.943531382965821, 2.6511619427422195],
            [-15.947883965695716, 2.6525432631984494],
            [-15.951121730649078, 2.6497508304693573],
            [-15.95519449492643, 2.6516246920751465],
            [-15.956863892053953, 2.6459382440548076],
            [-15.95501283005284, 2.6430013442015334],
            [-15.947016357859548, 2.638626151703592],
            [-15.944393732509052, 2.6324730082720214],
            [-15.947908852380396, 2.6274060747584915],
            [-15.94805492934658, 2.6207395237322815],
            [-15.952856972929844, 2.6166205147556982],
            [-15.953492790437217, 2.611915968658149],
            [-15.956684356769026, 2.609212958598728],
            [-15.963260048494877, 2.6092823464387265],
            [-15.968377179889863, 2.6107866227134036],
            [-15.977499651872428, 2.6111751788631543],
            [-15.97967733040735, 2.6102617876441685],
            [-15.982286432908785, 2.601720356869416],
            [-15.98765410116691, 2.6000001457068875],
            [-15.987364707167824, 2.594926459405136],
            [-15.992046092187703, 2.591280017780066],
            [-15.99224629261177, 2.588302376140661],
            [-15.997029256197845, 2.5848131937209606],
            [-15.999742784508769, 2.580717653195263],
            [-16.003463068020572, 2.5779553047988375],
            [-16.008956963439108, 2.578419937199545],
            [-16.016257676778295, 2.5771572756739256],
            [-16.022658029102782, 2.5792405767879325],
            [-16.0263255808787, 2.5780034366618985],
            [-16.03131206242295, 2.578506090748172],
            [-16.037384167232858, 2.5814888150731385],
            [-16.040926689087783, 2.5864556877500733],
            [-16.044113337076947, 2.585179004082127],
            [-16.04745081644596, 2.5797904414291732],
            [-16.050042071520657, 2.5787222442509408],
            [-16.051682900424083, 2.573493855440092],
            [-16.054635630832937, 2.5725492326228134],
            [-16.05516971276008, 2.5671480851890967],
            [-16.059206710053335, 2.5623728996213506],
            [-16.0608170459285, 2.5570109938497554],
            [-16.05840078176216, 2.555116756493933],
            [-16.058489774052443, 2.548152821392485],
            [-16.06190360317178, 2.54395106063017],
            [-16.062749143059857, 2.5380195327793063],
            [-16.060608567954414, 2.534754256937575],
            [-16.059253504987478, 2.526769628755197],
            [-16.0602160458382, 2.5203806169261966],
            [-16.062480692962794, 2.5148900285836513],
            [-16.059613466097414, 2.510844831639225],
            [-16.05994224719008, 2.506743899160282],
            [-16.057511686196694, 2.5031390932595166],
            [-16.056230023189073, 2.4974095158033576],
            [-16.058279829001336, 2.4959156393813378],
            [-16.06119061578647, 2.4897487153742204],
            [-16.054745282792126, 2.4815755160651793],
            [-16.055034033740153, 2.4706088208474104],
            [-16.05657259840562, 2.467995502993359],
            [-16.054310782184487, 2.4638359010061794],
            [-16.05413853389421, 2.4497805879560106],
            [-16.049875260664553, 2.4465106558017293],
            [-16.048796248010742, 2.443130542667981],
            [-16.052019368164448, 2.4406422315469456],
            [-16.05519829745703, 2.43557033790184],
            [-16.059128325036657, 2.424204738578087],
            [-16.059124858530936, 2.420135093065156],
            [-16.061373288400443, 2.4173167881481548],
            [-16.060520545771446, 2.4125288314840123],
            [-16.065643065611617, 2.413679020921913],
            [-16.07227497958009, 2.4118406637190297],
            [-16.073846585365132, 2.407266122640821],
            [-16.080065449410146, 2.402097816792421],
            [-16.082112342860473, 2.4021887350208853],
            [-16.08373807733276, 2.3951929270180288],
            [-16.087443545850686, 2.3950070004790867],
            [-16.091931093501003, 2.3902400509234525],
            [-16.097031592233392, 2.3923388520935114],
            [-16.10187069550557, 2.3895361100225503],
            [-16.102662995545572, 2.3871436904573713],
            [-16.10770173563908, 2.382889960827189],
            [-16.11191891488769, 2.3832158147306655],
            [-16.11585048987759, 2.386538192439707],
            [-16.12113921795978, 2.3809150524306264],
            [-16.12455780499684, 2.3805665142875534],
            [-16.123234214422503, 2.3764253473435586],
            [-16.127190633736376, 2.373903756407319],
            [-16.12320910224937, 2.362558082652686],
            [-16.130400155326804, 2.361211110933038],
            [-16.131293878709904, 2.357939063745401],
            [-16.13880344789015, 2.3606707133183886],
            [-16.14116952379336, 2.3572201394111216],
            [-16.138658341357363, 2.353497566472162],
            [-16.13371414223434, 2.352340134518911],
            [-16.13335077018331, 2.3418418185753347],
            [-16.135506781248523, 2.340326719143895],
            [-16.137178772174636, 2.3311761809939817],
            [-16.140840541421106, 2.3329687532886654],
            [-16.14401133668367, 2.3310233883587865],
            [-16.13957084043767, 2.3220474197411582],
            [-16.13235909153865, 2.3181263770984613],
            [-16.130038467205065, 2.312664077112137],
            [-16.129560808917375, 2.304355938174757],
            [-16.201219070403738, 2.300606607185332],
            [-16.29980996049936, 2.323712486611881],
            [-16.302951652325397, 2.324265769354972],
            [-16.37661533932789, 2.3416329684894315],
            [-16.3964756811448, 2.3464334089090926],
            [-16.48449705968484, 2.367169660515314],
            [-16.489932690966228, 2.3688846565807773],
            [-16.614672445830088, 2.3986620459118337],
            [-16.640700040397455, 2.405136031762794],
            [-16.659345226047474, 2.409394838004187],
            [-16.766500813833233, 2.4355595945437813],
            [-16.770141453067613, 2.436891578279748],
            [-16.86650818985628, 2.4606560641547377],
            [-16.857390966851256, 2.4980007494645333],
            [-16.88510971801102, 2.5048066529291173],
            [-16.87816881086562, 2.5331981675301525],
            [-16.892048509396776, 2.5365827874162616],
            [-16.888564799544636, 2.550797755656031],
            [-16.902450105921886, 2.554199037837616],
            [-16.898902953478107, 2.5687024512121126],
            [-16.912791191339142, 2.572198667667211],
            [-16.909414777951778, 2.5859969815096955],
            [-16.923303764048335, 2.589423533990552],
            [-16.920221939962342, 2.6020362250907434],
            [-16.93816669776863, 2.606445043021129],
            [-16.93106244392732, 2.6347994819206177],
            [-16.94475135085883, 2.6381501281969144],
            [-16.94134701211238, 2.652360097658022],
            [-16.955150550064044, 2.6557531122849674],
            [-16.951773718855687, 2.6699706072338105],
            [-16.965546021923952, 2.6733598049775242],
            [-16.96213190207906, 2.68756889741162],
            [-16.975943557658727, 2.6909851310008257],
            [-16.97238498781788, 2.7054761931178186],
            [-16.989286140358487, 2.709636741830597],
            [-16.985852012242656, 2.7238517588706217],
            [-16.99997273772608, 2.7273317921166997],
            [-16.996201306199445, 2.742595468348001],
            [-17.010094554824676, 2.7460596795779066],
            [-17.006602876082933, 2.760243276885135],
            [-17.020510445547117, 2.7637045260760935],
            [-17.017043095314996, 2.7778637080943596],
            [-17.03042528114164, 2.781219734721302],
            [-17.026873653343205, 2.7955894200886977],
            [-17.040717322437615, 2.799105904829197],
            [-17.037482054837184, 2.8130497506115137],
            [-17.05105661513993, 2.8166468621053613],
            [-17.047731451265964, 2.8304705370057586],
            [-17.060945112144445, 2.8345273848465964],
            [-17.05763991850074, 2.84865905240753],
            [-17.03110641461177, 2.954886772205537],
            [-17.02921177678507, 2.9620015652987544],
            [-17.00912493801525, 2.956946827477219],
            [-16.996268443249182, 3.0071525233388505],
            [-16.979456044110467, 3.0721034636966493],
            [-16.970578779947758, 3.069872926141051],
            [-16.94973848058825, 3.1538485660467583],
            [-16.9429650475831, 3.152170607276117],
            [-16.941211009105047, 3.1592474669961685],
            [-16.934250504673262, 3.1575322867159046],
            [-16.932488142584937, 3.1646298620683577],
            [-16.936100683177546, 3.16551745636969],
            [-16.971186659547556, 3.139255914633765],
            [-16.984323427705363, 3.1275411978351886],
            [-17.025263480272592, 3.10550695501742],
            [-17.031028537990988, 3.1033416863085903],
            [-17.040300991090266, 3.1040681250030144],
            [-17.04399489696911, 3.101136805375679],
            [-17.047099937840276, 3.094172659284808],
            [-17.0505974027521, 3.0897800666787707],
            [-17.05361004288848, 3.09048111267492],
            [-17.050089551554745, 3.1047786389578866],
            [-17.042991924464566, 3.1331935308190686],
            [-17.029172252383994, 3.1297317167101495],
            [-17.019229936573858, 3.1712312089243535],
            [-17.00309095768356, 3.2352373698164874],
            [-17.017002907777695, 3.2386241931023205],
            [-17.01173414079512, 3.2599239768281634],
            [-17.025612248118716, 3.2633467615621394],
            [-17.003838544002257, 3.3508562708802048],
            [-17.01675704306308, 3.354060434207804],
            [-17.012540726541275, 3.368215078600523],
            [-16.991646292686593, 3.4515687470525314]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.33574995769791,
          "lat": 39.58089497521216
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32001"],
        "coty_name": ["Churchill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Churchill County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00858638"
      },
      "bbox": [
        -17.060945112144445, 2.300606607185332, -15.713000217164836,
        3.4515687470525314
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.536570441261414, 2.810913271115685],
            [-17.484482834938987, 2.8140533415942817],
            [-17.41904394947364, 2.8313170056326284],
            [-17.384742723463955, 2.840152297045784],
            [-17.341660322500623, 2.8518601942614117],
            [-17.299406679359496, 2.8993374654816932],
            [-17.242435467388482, 2.963501774567067],
            [-17.159632847153144, 3.0565356318347585],
            [-17.126616933288915, 3.0936071516049672],
            [-17.12202777639292, 3.0924139297771203],
            [-17.10044284348062, 3.117207531645003],
            [-17.050089551554745, 3.1047786389578866],
            [-17.05361004288848, 3.09048111267492],
            [-17.0505974027521, 3.0897800666787707],
            [-17.047099937840276, 3.094172659284808],
            [-17.04399489696911, 3.101136805375679],
            [-17.040300991090266, 3.1040681250030144],
            [-17.031028537990988, 3.1033416863085903],
            [-17.025263480272592, 3.10550695501742],
            [-16.984323427705363, 3.1275411978351886],
            [-16.971186659547556, 3.139255914633765],
            [-16.936100683177546, 3.16551745636969],
            [-16.932488142584937, 3.1646298620683577],
            [-16.934250504673262, 3.1575322867159046],
            [-16.941211009105047, 3.1592474669961685],
            [-16.9429650475831, 3.152170607276117],
            [-16.94973848058825, 3.1538485660467583],
            [-16.970578779947758, 3.069872926141051],
            [-16.979456044110467, 3.0721034636966493],
            [-16.996268443249182, 3.0071525233388505],
            [-17.00912493801525, 2.956946827477219],
            [-17.02921177678507, 2.9620015652987544],
            [-17.03110641461177, 2.954886772205537],
            [-17.05763991850074, 2.84865905240753],
            [-17.060945112144445, 2.8345273848465964],
            [-17.047731451265964, 2.8304705370057586],
            [-17.05105661513993, 2.8166468621053613],
            [-17.037482054837184, 2.8130497506115137],
            [-17.040717322437615, 2.799105904829197],
            [-17.026873653343205, 2.7955894200886977],
            [-17.03042528114164, 2.781219734721302],
            [-17.017043095314996, 2.7778637080943596],
            [-17.020510445547117, 2.7637045260760935],
            [-17.006602876082933, 2.760243276885135],
            [-17.010094554824676, 2.7460596795779066],
            [-16.996201306199445, 2.742595468348001],
            [-16.99997273772608, 2.7273317921166997],
            [-16.985852012242656, 2.7238517588706217],
            [-16.989286140358487, 2.709636741830597],
            [-16.97238498781788, 2.7054761931178186],
            [-16.975943557658727, 2.6909851310008257],
            [-16.96213190207906, 2.68756889741162],
            [-16.965546021923952, 2.6733598049775242],
            [-16.951773718855687, 2.6699706072338105],
            [-16.955150550064044, 2.6557531122849674],
            [-16.94134701211238, 2.652360097658022],
            [-16.94475135085883, 2.6381501281969144],
            [-16.93106244392732, 2.6347994819206177],
            [-16.93816669776863, 2.606445043021129],
            [-16.920221939962342, 2.6020362250907434],
            [-16.923303764048335, 2.589423533990552],
            [-16.909414777951778, 2.5859969815096955],
            [-16.912791191339142, 2.572198667667211],
            [-16.898902953478107, 2.5687024512121126],
            [-16.902450105921886, 2.554199037837616],
            [-16.888564799544636, 2.550797755656031],
            [-16.892048509396776, 2.5365827874162616],
            [-16.87816881086562, 2.5331981675301525],
            [-16.88510971801102, 2.5048066529291173],
            [-16.857390966851256, 2.4980007494645333],
            [-16.86650818985628, 2.4606560641547377],
            [-16.988588142576877, 2.491046941233187],
            [-17.076522895760093, 2.3990113289274295],
            [-17.09212061524703, 2.3803891692943644],
            [-17.114171937169136, 2.290031971539007],
            [-17.03003424188671, 2.2692895556531942],
            [-17.05104728720655, 2.1837832082018203],
            [-17.05506049712873, 2.1847667361737133],
            [-17.11418099492629, 1.9412294149326],
            [-17.138321758469626, 1.8422463435307959],
            [-17.32651983412916, 1.8870687692796095],
            [-17.372800543202555, 1.9560399046493329],
            [-17.381971940412658, 1.9705831800788276],
            [-17.398552308427952, 1.994625223605738],
            [-17.427905713473184, 2.039447787927604],
            [-17.41479756044358, 2.090387163735032],
            [-17.400107142252573, 2.1498086895706257],
            [-17.413527802383378, 2.1532228192648297],
            [-17.393620053036198, 2.239205057031607],
            [-17.421700643259452, 2.2466064304684603],
            [-17.422499528113804, 2.243630922289031],
            [-17.436296719813207, 2.247118937270449],
            [-17.431319533032788, 2.2647164695289863],
            [-17.428008291306426, 2.278452312557342],
            [-17.426182064645705, 2.2780300664557385],
            [-17.415452351165744, 2.3206770791846294],
            [-17.42227200624065, 2.322457656002905],
            [-17.41883068742526, 2.3367020307361113],
            [-17.425737871633196, 2.3384324772135696],
            [-17.418721541016755, 2.3669182095075456],
            [-17.432468342401997, 2.370383963771787],
            [-17.425030651268052, 2.398820049671938],
            [-17.411491226761957, 2.395494958464273],
            [-17.39251134181922, 2.4661899266749554],
            [-17.379096186874172, 2.4628544374213672],
            [-17.37165932712358, 2.4910508143053565],
            [-17.34359964812591, 2.484627004123359],
            [-17.33201826828857, 2.4803584545564927],
            [-17.33056077285236, 2.4845721770374065],
            [-17.32709316626111, 2.4837120056462547],
            [-17.32620304093124, 2.487269168541868],
            [-17.301690938220997, 2.481072649597443],
            [-17.29382045950683, 2.5121766265067302],
            [-17.278927937644546, 2.5728758053354266],
            [-17.342209311083735, 2.589237845151585],
            [-17.373457768370148, 2.5969667631120283],
            [-17.41026335619535, 2.607165228387071],
            [-17.44115604841961, 2.614957871801957],
            [-17.457135771251668, 2.6193158008915725],
            [-17.45541708312291, 2.6245211173450675],
            [-17.454497694400107, 2.632422057234678],
            [-17.45765615165843, 2.63669299996428],
            [-17.457385849745148, 2.6449296524548145],
            [-17.45488558831145, 2.6523736278697956],
            [-17.4539971759182, 2.6661568869715415],
            [-17.45270605592444, 2.6703391541993],
            [-17.45750462083935, 2.6772212615766056],
            [-17.458425224879935, 2.6823425899637185],
            [-17.45682688739739, 2.6878004933011064],
            [-17.45823984186744, 2.6910843299594416],
            [-17.454871973930388, 2.693243070260142],
            [-17.449783724582247, 2.699586766895995],
            [-17.443407884706573, 2.710311170096515],
            [-17.44196092797575, 2.71143603203872],
            [-17.438136757942583, 2.722374856714521],
            [-17.438608960223082, 2.7271555316928993],
            [-17.45247905338121, 2.7311619267692273],
            [-17.502789404417083, 2.744074310287775],
            [-17.52478904041598, 2.7644013452511738],
            [-17.536570441261414, 2.810913271115685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.18901350868754,
          "lat": 39.02066970037713
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32019"],
        "coty_name": ["Lyon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lyon County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00858645"
      },
      "bbox": [
        -17.536570441261414, 1.8422463435307959, -16.857390966851256,
        3.16551745636969
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.197485083753342, 6.926820100222151],
            [18.21142728014154, 6.954263675986758],
            [18.21726844712961, 6.9725051632375985],
            [18.232907516632444, 7.008621016570908],
            [18.227837956169857, 7.018962831103048],
            [18.204933362211065, 7.071448086851616],
            [18.18455496724947, 7.120024606016625],
            [18.1694679870814, 7.156841152870679],
            [18.182870594662287, 7.1850810146449025],
            [18.187589652518046, 7.195267148311412],
            [18.198383207701273, 7.224100514227297],
            [18.22693208796311, 7.163507646878716],
            [18.22894988773145, 7.169760473276986],
            [18.233453576017315, 7.1654156005662015],
            [18.23578813052436, 7.17099761663323],
            [18.239474036357684, 7.1674901897787855],
            [18.24072876839039, 7.173351690753062],
            [18.245526585117837, 7.168431427330832],
            [18.252215297173098, 7.191425253355934],
            [18.256129725258432, 7.189310152078825],
            [18.25975259079497, 7.194331531840368],
            [18.263366735770695, 7.191767310841296],
            [18.266307249823846, 7.197708480385947],
            [18.268912421921318, 7.193355270108181],
            [18.2721955989554, 7.1994201892343215],
            [18.29397768694708, 7.15680861145469],
            [18.305003948189775, 7.1849007037617],
            [18.31860622103846, 7.217720773097873],
            [18.32206641751223, 7.224306635637071],
            [18.322756190522, 7.218522334364848],
            [18.327282715135873, 7.215954449940988],
            [18.329708461565797, 7.209798780636727],
            [18.33252593295875, 7.208091828609167],
            [18.333538378664375, 7.204426552058918],
            [18.3331697920599, 7.198053297471029],
            [18.33504420430216, 7.184754078221066],
            [18.333536968152938, 7.182697854301823],
            [18.33124263790447, 7.170160588179935],
            [18.333778177339163, 7.165245098661227],
            [18.330280594122538, 7.160837337921227],
            [18.333501751959886, 7.158064648665238],
            [18.338206984814963, 7.158679208691414],
            [18.342733454606154, 7.152989127380287],
            [18.34245540946871, 7.136255336279247],
            [18.348065969953925, 7.130095736165037],
            [18.349642316518395, 7.125645597655354],
            [18.34521444814223, 7.120918748415375],
            [18.346976575292913, 7.115599047514553],
            [18.34424482573362, 7.108402641270923],
            [18.339432211329758, 7.103304935926892],
            [18.338025176495105, 7.097695083534393],
            [18.340922503788207, 7.087395966980996],
            [18.34472295007507, 7.084044685620153],
            [18.345859348033102, 7.079696981909911],
            [18.343060769545026, 7.077553389059301],
            [18.346341148517848, 7.071498415752617],
            [18.347567770073304, 7.064883798833675],
            [18.349724449061558, 7.061437576795984],
            [18.357576770061247, 7.05439054716194],
            [18.36028673597136, 7.0506254075662484],
            [18.361089143996658, 7.045720823652487],
            [18.37013512164378, 7.033481104270548],
            [18.375593459332997, 7.032122892021001],
            [18.379990076644965, 7.026732704347917],
            [18.38349098295751, 7.027650508267106],
            [18.392857477832248, 7.032943808684008],
            [18.396073329940496, 7.033178477579869],
            [18.399321361844265, 7.026619561994494],
            [18.411792478552925, 7.020364670276071],
            [18.41499932835279, 7.020751575529615],
            [18.417852052611995, 7.011319345816923],
            [18.422157470363906, 7.007132134223331],
            [18.42569513814722, 7.0081743999535195],
            [18.427940515476912, 7.002465215166202],
            [18.42509492080862, 6.9963466664131],
            [18.430616538957544, 6.995643792378631],
            [18.435033283479697, 6.9904365419324135],
            [18.44254089536247, 6.9898696588742695],
            [18.44860106897246, 6.980852195458656],
            [18.453940185432334, 6.98165503941775],
            [18.458203358750676, 6.977056038253408],
            [18.463456259697786, 6.977222406381984],
            [18.468030800613388, 6.970424036309514],
            [18.471760766137887, 6.969203572822367],
            [18.473480718854216, 6.971337555099275],
            [18.48022811192086, 6.970581784303761],
            [18.483902290777063, 6.968368975232678],
            [18.483137640306825, 6.965505516579812],
            [18.486457515215033, 6.960483765570174],
            [18.496501622050022, 6.961118804523272],
            [18.50233658040004, 6.959569028579078],
            [18.506363430116142, 6.951464790042557],
            [18.509071341533282, 6.951452971453588],
            [18.51158387578877, 6.948257961851163],
            [18.511095187806095, 6.9405694204656125],
            [18.50914461308647, 6.93730614573127],
            [18.51034536912239, 6.9223022768987805],
            [18.512693946424335, 6.9181547071473455],
            [18.51252451281582, 6.914496268320162],
            [18.50854854456005, 6.911173512378171],
            [18.50851531913695, 6.908269356109002],
            [18.51505997478237, 6.89751981479319],
            [18.51317285968205, 6.891220842641966],
            [18.51553324443446, 6.88037892267825],
            [18.51513643401478, 6.8688965990992195],
            [18.520034776313327, 6.861424910888928],
            [18.522077713858152, 6.8558731696335835],
            [18.525250314653285, 6.851142627879603],
            [18.531199188170582, 6.848090672428531],
            [18.528349894782096, 6.842607939349839],
            [18.522652249981398, 6.8410572081849],
            [18.519522126766987, 6.841734939901852],
            [18.511430856165713, 6.846388431678048],
            [18.50667293281178, 6.8461622159384765],
            [18.50098816387314, 6.841793454314207],
            [18.500950510637434, 6.837428426281604],
            [18.50516319961439, 6.833850507122933],
            [18.50472473465222, 6.82944060728961],
            [18.509862768363945, 6.813423104496126],
            [18.510161823797997, 6.807244998666844],
            [18.503430184324746, 6.797008719290505],
            [18.49130376206894, 6.796544073753992],
            [18.49072841052174, 6.797225212725094],
            [18.459778388880952, 6.795307694112221],
            [18.429027593495032, 6.779065815709903],
            [18.406841636778488, 6.772745852786848],
            [18.364574782788562, 6.761141351647896],
            [18.376386433780844, 6.803413945108802],
            [18.38232753629253, 6.824043254633633],
            [18.33138838138954, 6.848137395539041],
            [18.295183196083286, 6.865023031296831],
            [18.255788302730487, 6.884311552350192],
            [18.227353578197604, 6.898653281335794],
            [18.220530021650877, 6.901557831819259],
            [18.19208586996049, 6.915311219244919],
            [18.197485083753342, 6.926820100222151]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -71.02885401164997,
          "lat": 43.296977943348786
        },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33017"],
        "coty_name": ["Strafford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Strafford County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00873182"
      },
      "bbox": [
        18.1694679870814, 6.761141351647896, 18.531199188170582,
        7.224306635637071
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.393668251265712, 2.5887617268465544],
            [16.453418175913676, 2.698739068372052],
            [16.49601607784474, 2.7771279156944724],
            [16.531214143018794, 2.8418821819699023],
            [16.584413900560424, 2.8145368202971253],
            [16.58765917486247, 2.809998782179254],
            [16.59226802209037, 2.8081396923221242],
            [16.596532141076338, 2.8019397022554173],
            [16.596521817791757, 2.7998908864705516],
            [16.60118242188705, 2.7947647823728268],
            [16.605518891376832, 2.7833952369792687],
            [16.608226344994858, 2.7656754722791814],
            [16.610166679615954, 2.7628574134424078],
            [16.610588548476045, 2.7579627852733415],
            [16.61439439966666, 2.7575704347184846],
            [16.61623373476304, 2.754545283080793],
            [16.620318700136938, 2.7539128234484362],
            [16.62597376430362, 2.7557033483242095],
            [16.629451589649168, 2.7589962368098333],
            [16.631797051782886, 2.758194700239496],
            [16.63282655010407, 2.7537323542204035],
            [16.63651315565527, 2.752763589654168],
            [16.637673287978696, 2.7591245616659226],
            [16.640384892502503, 2.759903520477079],
            [16.643959006797196, 2.7577790047549575],
            [16.647886924167196, 2.7580605836440553],
            [16.660373305358135, 2.7523204421638745],
            [16.66738134158786, 2.750943298430843],
            [16.67159829874014, 2.744823257163311],
            [16.675142903340188, 2.743975714676222],
            [16.6800540219892, 2.7399770986971212],
            [16.682935727501004, 2.741199936907331],
            [16.6896727398025, 2.740443097726007],
            [16.69599636261612, 2.743722643127448],
            [16.701746853642813, 2.7365876489793823],
            [16.708020439244535, 2.7333756438048074],
            [16.70904231163628, 2.726683024844149],
            [16.711382591127435, 2.723585702973408],
            [16.717971508510303, 2.7227835312188335],
            [16.721532537920258, 2.720104202174134],
            [16.726624126314473, 2.721538146938569],
            [16.72923047586974, 2.7261767814390314],
            [16.733746750380572, 2.7228700727375386],
            [16.73851527038736, 2.7236482123531234],
            [16.747403162044975, 2.718299989784521],
            [16.75212834631658, 2.712237135867202],
            [16.758512019179918, 2.7166037191939827],
            [16.765151036309106, 2.7109590229082223],
            [16.76788159734898, 2.712140090301823],
            [16.770081247353584, 2.716447026854459],
            [16.77414872710033, 2.717825515301927],
            [16.77778036987939, 2.7108817633475195],
            [16.78234369610181, 2.711930969759272],
            [16.78106953203881, 2.720269341865931],
            [16.78594065519936, 2.723105481225871],
            [16.788293849304853, 2.7197023147589516],
            [16.78752001863901, 2.714334530184786],
            [16.78858811753482, 2.711071773345823],
            [16.79316829225849, 2.7077328354655577],
            [16.79798657341539, 2.708691737852516],
            [16.797081579667086, 2.713261800341463],
            [16.792958048279463, 2.717212785878806],
            [16.795267184663228, 2.722210421083705],
            [16.80035105746066, 2.7208332813741385],
            [16.80531642832286, 2.726498038226352],
            [16.8072053925168, 2.7266483809788733],
            [16.809768194195144, 2.7195282556712543],
            [16.815362938419963, 2.7180308927628123],
            [16.823293064837653, 2.710355808037589],
            [16.84780564357397, 2.6752591142317894],
            [16.86177665484458, 2.6821032512292473],
            [16.865998091991713, 2.68674966594826],
            [16.877340539306825, 2.6907045587149323],
            [16.88654796485132, 2.692297036458822],
            [16.890293299067018, 2.6864949650727707],
            [16.902338850418786, 2.6723905512529327],
            [16.903893507122937, 2.6624955485542405],
            [16.901433573429784, 2.6524653710092885],
            [16.897168802405584, 2.640944513545952],
            [16.893382146604115, 2.636557585823263],
            [16.893967416005484, 2.631190201132909],
            [16.898300125591348, 2.626141581542971],
            [16.897148415664788, 2.621029925375947],
            [16.8800732701802, 2.582816551341477],
            [16.867544103802327, 2.5636515753670515],
            [16.85794353572333, 2.5474632830979793],
            [16.8577139317269, 2.539403685623382],
            [16.855357020547483, 2.534455049698625],
            [16.848426945078156, 2.5272523870305363],
            [16.837700148087418, 2.521924143858163],
            [16.823716176006684, 2.510803676857153],
            [16.803112315298396, 2.4902741033328244],
            [16.78842524025753, 2.4742683331371675],
            [16.77633683815151, 2.457020158048935],
            [16.767368389835756, 2.4524008854883554],
            [16.767103336306672, 2.453012699536529],
            [16.761759561039, 2.4487570403249004],
            [16.75329733845906, 2.4470819933972847],
            [16.74882579432937, 2.4486846698180735],
            [16.739448542311195, 2.4540294510427825],
            [16.73330608166081, 2.4531238361999703],
            [16.71726676139219, 2.4330839892425704],
            [16.71258334341863, 2.4308876047342274],
            [16.705864707987825, 2.4321365742637653],
            [16.69783908132612, 2.43068310959351],
            [16.694782379767897, 2.4242098495907247],
            [16.692534517698757, 2.4223061756068187],
            [16.688119746822192, 2.422426342542179],
            [16.686912104438356, 2.4283625486609877],
            [16.683621063582095, 2.429853588500748],
            [16.67347640937503, 2.4265021309667936],
            [16.670280232226187, 2.422762924813887],
            [16.66588824037352, 2.42201125577951],
            [16.66373092637746, 2.418279520897522],
            [16.657243227411627, 2.415070933646279],
            [16.65478060312631, 2.4191861068792857],
            [16.651788386833655, 2.418805833160697],
            [16.649445025257418, 2.4155113041961247],
            [16.645627095710214, 2.4148864708746927],
            [16.641112026929935, 2.4164235351499843],
            [16.638725745380896, 2.420077433596319],
            [16.634074140064687, 2.4171439476408376],
            [16.631228516613692, 2.418761221288785],
            [16.62653608588505, 2.4170903017964185],
            [16.624939808946515, 2.414133168213669],
            [16.61657529393135, 2.4116905661048342],
            [16.61408723993538, 2.4153974014728754],
            [16.61101094606654, 2.4148632075558183],
            [16.608746842923395, 2.4117466510627223],
            [16.605078192888943, 2.4133951914864316],
            [16.599272886425524, 2.4139218393728687],
            [16.590305008072022, 2.418322835157537],
            [16.585549942633822, 2.417461717163862],
            [16.583954849120598, 2.4144874870277504],
            [16.577419549209193, 2.4166933273744724],
            [16.571384510106768, 2.4128706521943677],
            [16.562958916186563, 2.411962651422801],
            [16.559698918991195, 2.4095130541288152],
            [16.54839602891743, 2.4167697882104933],
            [16.538049380831087, 2.415818862589017],
            [16.530142090808422, 2.417369844262178],
            [16.528661593082212, 2.421550189852613],
            [16.525493575742882, 2.4255715850684103],
            [16.522697690165774, 2.43536033326114],
            [16.52235266640512, 2.456543732745444],
            [16.52159612099358, 2.461911167925665],
            [16.523747371779706, 2.4706015230545035],
            [16.52249986682669, 2.481400407246567],
            [16.515347014862442, 2.4919998180042646],
            [16.51401542375168, 2.5001343668750033],
            [16.51591120887266, 2.5057876616960733],
            [16.514346489914217, 2.513158012937596],
            [16.510468634371804, 2.5176811108230686],
            [16.50935880102082, 2.521782339859157],
            [16.495937863888194, 2.5299286625752027],
            [16.47348791404214, 2.5423215561339925],
            [16.393668251265712, 2.5887617268465544]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.66126669429582,
          "lat": 39.477821945696476
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34001"],
        "coty_name": ["Atlantic"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Atlantic County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00882270"
      },
      "bbox": [
        16.393668251265712, 2.4095130541288152, 16.903893507122937,
        2.8418821819699023
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.324696860705696, 2.6288809431955653],
            [16.393668251265712, 2.5887617268465544],
            [16.47348791404214, 2.5423215561339925],
            [16.495937863888194, 2.5299286625752027],
            [16.50935880102082, 2.521782339859157],
            [16.510468634371804, 2.5176811108230686],
            [16.514346489914217, 2.513158012937596],
            [16.51591120887266, 2.5057876616960733],
            [16.51401542375168, 2.5001343668750033],
            [16.515347014862442, 2.4919998180042646],
            [16.52249986682669, 2.481400407246567],
            [16.523747371779706, 2.4706015230545035],
            [16.52159612099358, 2.461911167925665],
            [16.52235266640512, 2.456543732745444],
            [16.522697690165774, 2.43536033326114],
            [16.525493575742882, 2.4255715850684103],
            [16.528661593082212, 2.421550189852613],
            [16.52606044903338, 2.421539530987389],
            [16.524748074854447, 2.414719029003998],
            [16.521853492611278, 2.4084161145620264],
            [16.51650907094228, 2.4028426278636377],
            [16.522167720487747, 2.3282958472989237],
            [16.511661794160315, 2.3175620403021178],
            [16.505590113428358, 2.3141607893980822],
            [16.503791248172924, 2.307358798271855],
            [16.5054528332754, 2.3012670428301703],
            [16.509449210703654, 2.293542056846367],
            [16.507702399854878, 2.2901248664118516],
            [16.509633776304042, 2.2841733927207297],
            [16.512862052366344, 2.2783899656869737],
            [16.517241078415573, 2.2793549698629008],
            [16.518868093093143, 2.2753721158517997],
            [16.522870729865517, 2.2701128982925534],
            [16.521160576817646, 2.2686787872750163],
            [16.518944882328903, 2.26724875081102],
            [16.51103420852546, 2.2708015057895],
            [16.49342976996897, 2.2725536081432294],
            [16.488900718025043, 2.2743917274773517],
            [16.48172858665561, 2.2746833939543465],
            [16.471855984473034, 2.2727289707293052],
            [16.451646134023242, 2.266785649754927],
            [16.448594899989246, 2.267671518192432],
            [16.43417205489345, 2.2656674009404845],
            [16.431937652136646, 2.266137376713386],
            [16.431644775942587, 2.2711603559087177],
            [16.434131179753585, 2.2749350567576303],
            [16.432613015299943, 2.280225084454067],
            [16.42969350907445, 2.2849011442146447],
            [16.432252368561436, 2.291211566165236],
            [16.429810773796365, 2.2942815883528636],
            [16.424427437660615, 2.2964059353622455],
            [16.423948714169327, 2.2910830451418085],
            [16.419457119864873, 2.2913648075911617],
            [16.41517060114227, 2.2896427552593814],
            [16.41269340880129, 2.2831871715618846],
            [16.394069689375076, 2.277877512982836],
            [16.387845113729924, 2.274702663135655],
            [16.379251893095613, 2.2724608828705875],
            [16.375784692887162, 2.273364037586732],
            [16.373608419209447, 2.276304583728437],
            [16.367862997207638, 2.2764015866844205],
            [16.36619047304054, 2.2718647007578756],
            [16.36083649405807, 2.2684330393692607],
            [16.358389750043344, 2.2567984447853666],
            [16.355096043690235, 2.2550167673780885],
            [16.35873314424124, 2.2454276241272897],
            [16.35480441278779, 2.2416718346899414],
            [16.34857816922666, 2.239379464871412],
            [16.341154626524155, 2.241134088462962],
            [16.335580856611436, 2.2476908045451234],
            [16.332255737639343, 2.247951831674875],
            [16.326284952839263, 2.2515721267292594],
            [16.32553949856705, 2.2561397194463155],
            [16.327117309817204, 2.263155117174491],
            [16.32341037126843, 2.267086101395272],
            [16.32297887759186, 2.2705835519414634],
            [16.31901661427296, 2.2790754021803425],
            [16.315297536054075, 2.2848247642711215],
            [16.305902750027958, 2.2913411979517257],
            [16.2993174849564, 2.2899883670763916],
            [16.292257335132188, 2.2962335862123715],
            [16.29076422182395, 2.298850019946217],
            [16.284437761065156, 2.3035701417257495],
            [16.27942718785808, 2.3025976896667175],
            [16.25513781728533, 2.3089269807229407],
            [16.252542610322504, 2.312064012810564],
            [16.252791341404468, 2.315099099976162],
            [16.255862902841294, 2.319359554668221],
            [16.25127512753678, 2.3202670501678515],
            [16.246131986817392, 2.3264172904667646],
            [16.241967737810782, 2.3290846768119082],
            [16.241868940805674, 2.3331016394898736],
            [16.222305945087257, 2.333531091748647],
            [16.217315638222335, 2.332959617958649],
            [16.215701644145657, 2.3276144527146454],
            [16.218154512768088, 2.3260196618727593],
            [16.218472920382755, 2.3195213534167323],
            [16.216380824784025, 2.3184282158677334],
            [16.20843494397294, 2.3220397588552255],
            [16.192109908995416, 2.3326815184649266],
            [16.17917750666914, 2.3525000194504977],
            [16.17707966261654, 2.359348384333531],
            [16.17224635818994, 2.3611767192022652],
            [16.170667615647275, 2.363835221234287],
            [16.163782513121735, 2.3657885230110907],
            [16.157438900977386, 2.365620338085738],
            [16.152929166393953, 2.3624205100715923],
            [16.153577239585886, 2.356321425119873],
            [16.148561120214588, 2.3550741345968946],
            [16.14365135257548, 2.363484480192745],
            [16.136826532036558, 2.365783914735335],
            [16.13208345662652, 2.364778548268703],
            [16.125475410724235, 2.3678062510500295],
            [16.12148602443593, 2.3734546153415566],
            [16.119317081601412, 2.380849388105267],
            [16.11515461448545, 2.386408055782781],
            [16.111706912562614, 2.387946448196691],
            [16.108068366233688, 2.3869901638839046],
            [16.10594512415772, 2.392377953913628],
            [16.10311429218625, 2.389271068839108],
            [16.09938282282605, 2.3915567071680255],
            [16.100172423124423, 2.3952499667149607],
            [16.097525148582317, 2.3999101682030783],
            [16.10334125617452, 2.4002088519295466],
            [16.10415141831531, 2.4036081613823193],
            [16.100653869144512, 2.4060002551468194],
            [16.10345215581769, 2.409236717193539],
            [16.10357565614351, 2.4134000131327253],
            [16.100045657382097, 2.413724581375761],
            [16.099324381557285, 2.410210641535391],
            [16.09283859779102, 2.413911234152776],
            [16.092201750636793, 2.4189636948064046],
            [16.096439589831657, 2.4250361697214884],
            [16.09760282817085, 2.430116796742512],
            [16.092704129001998, 2.4331023193877925],
            [16.089579181879614, 2.433101068142314],
            [16.0898295937569, 2.437979786115347],
            [16.093005740515867, 2.447655247000849],
            [16.090728156561067, 2.4496132600821845],
            [16.090703294306266, 2.4543343657605696],
            [16.086915974736282, 2.455818992423328],
            [16.090739637168944, 2.463394788084083],
            [16.095844121143347, 2.4681216030296684],
            [16.106716440056505, 2.4659352940798684],
            [16.11012157038368, 2.466721150552368],
            [16.117221864617402, 2.466123424640626],
            [16.12072663020928, 2.4679521136418603],
            [16.1262135287699, 2.483135878502474],
            [16.129969147335817, 2.485267360762593],
            [16.129300874927036, 2.4936610752551],
            [16.132489200168948, 2.500644683859992],
            [16.132645433096243, 2.5054919139470737],
            [16.13837748871056, 2.504510466950177],
            [16.145204894691993, 2.5060827210690992],
            [16.15046521850395, 2.510918228436432],
            [16.15762350167247, 2.524259880897434],
            [16.164195255885307, 2.534094488396766],
            [16.177693337408435, 2.557412578052037],
            [16.19520194063297, 2.5900102283049025],
            [16.2434190505842, 2.565352215248069],
            [16.252490420082143, 2.5605606340995983],
            [16.3070090319004, 2.529872819166754],
            [16.332870694563724, 2.5155997685627045],
            [16.33476758551019, 2.5194277860379404],
            [16.33263739132778, 2.5232217378791413],
            [16.3322284638913, 2.530615296985028],
            [16.334634594243077, 2.5449511772532833],
            [16.33250059968203, 2.54767139541406],
            [16.332595777636314, 2.55154102830665],
            [16.32623350702836, 2.559668213591311],
            [16.327590527555994, 2.563555265545431],
            [16.3251642743857, 2.5703311760265812],
            [16.32638462193951, 2.57384768674407],
            [16.32539939841014, 2.5775221486568007],
            [16.326773236117766, 2.5834001095607975],
            [16.32386099369001, 2.594934167688153],
            [16.324181115516463, 2.599155622639527],
            [16.320635612182656, 2.6029849818207893],
            [16.32216806787111, 2.6121676829643072],
            [16.32387559380366, 2.615760070727132],
            [16.323218055338124, 2.62000359413357],
            [16.324696860705696, 2.6288809431955653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.11071117911655,
          "lat": 39.373912832186036
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34011"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00882275"
      },
      "bbox": [
        16.086915974736282, 2.239379464871412, 16.528661593082212,
        2.6288809431955653
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.608989230573048, 4.066252570382957],
            [16.613522898129474, 4.064425603367678],
            [16.616621893622256, 4.057734885417162],
            [16.62165458324982, 4.054818789922568],
            [16.626384779373755, 4.054018128610461],
            [16.635984968989334, 4.055083935280321],
            [16.672318340429943, 4.039384952815556],
            [16.730410045310993, 4.014593029594856],
            [16.726435173820988, 4.011974954724375],
            [16.72576613617384, 4.006606978540185],
            [16.726773357627263, 3.9986413016350797],
            [16.729333718132295, 3.991901068216439],
            [16.725301934560214, 3.978840087886092],
            [16.726187391692296, 3.970274175168957],
            [16.722858998556497, 3.962071881544536],
            [16.72256031735846, 3.9571301453667513],
            [16.72038409546302, 3.9517378535880106],
            [16.719809238457383, 3.946359681574435],
            [16.720757062614837, 3.937215844420159],
            [16.72427805015683, 3.9297355028438687],
            [16.72814701187059, 3.925765005233521],
            [16.73180361656263, 3.9256398449469],
            [16.73752419315273, 3.9278672387292266],
            [16.739689534921567, 3.93343658268297],
            [16.74349799482223, 3.9365594009473677],
            [16.75360262409271, 3.9395812438661486],
            [16.757958907271696, 3.938054401022399],
            [16.758984951471547, 3.9356972476899243],
            [16.75948149003073, 3.919149585696185],
            [16.760969389607805, 3.915499915290013],
            [16.760183963192816, 3.9102407637488663],
            [16.7638130309424, 3.9030888066380762],
            [16.760027608887256, 3.8874471898619336],
            [16.75606812089037, 3.8852930734372784],
            [16.752679746556158, 3.8746694803329045],
            [16.74378395950406, 3.87922333657858],
            [16.740847729964738, 3.8785741010060177],
            [16.734618240725915, 3.881470184477094],
            [16.731882199370816, 3.879236206159338],
            [16.708480765202264, 3.8719138794309473],
            [16.702137059983897, 3.87446561094524],
            [16.697046914866903, 3.883819483913481],
            [16.689028332867913, 3.888600401293979],
            [16.66269770599092, 3.8887572908454113],
            [16.639354680768243, 3.892361532931233],
            [16.63360079402294, 3.8887634086215406],
            [16.632143120051598, 3.883495491427647],
            [16.62758734052285, 3.8804702731943053],
            [16.623263409765315, 3.881058053058864],
            [16.61704426582964, 3.8842111104953676],
            [16.610935317261923, 3.8805298013825755],
            [16.59765716811372, 3.885061299849184],
            [16.591054752445455, 3.8895085383297068],
            [16.58222328589976, 3.8934098079063006],
            [16.57202171175448, 3.8948376583880537],
            [16.57082738662612, 3.898448387315158],
            [16.575054187022218, 3.89993115335989],
            [16.574539545214513, 3.9058772019923014],
            [16.57836216047767, 3.9082584108175857],
            [16.57880096999219, 3.912271325564741],
            [16.564205175491498, 3.91492296528483],
            [16.566911254202207, 3.9188541393900564],
            [16.565535373582414, 3.922114955104081],
            [16.566398466248664, 3.926333007881136],
            [16.563529734914173, 3.931296881281088],
            [16.56633092069949, 3.9357137837713596],
            [16.56323528944274, 3.9482138498979786],
            [16.56410761589367, 3.9546047584612594],
            [16.56701466873953, 3.9558622392994964],
            [16.57196473416842, 3.964834037218266],
            [16.571690287192684, 3.9690885598789327],
            [16.575672776736237, 3.972116525534274],
            [16.579683044915456, 3.9724029686382223],
            [16.582252476867843, 3.981959032366958],
            [16.578883950903588, 3.987487596117439],
            [16.5819903598298, 3.9906996548889406],
            [16.578881816090615, 4.010346884872931],
            [16.57969774662092, 4.01904541210225],
            [16.583427521456585, 4.0201693108758985],
            [16.579984120400123, 4.02516342016514],
            [16.56998336681555, 4.026810868688092],
            [16.5668574617157, 4.028312954651206],
            [16.56598697234705, 4.033241772061603],
            [16.563263843499694, 4.0373298840176055],
            [16.56278843218835, 4.045584168752353],
            [16.56134489130442, 4.046523411510451],
            [16.56071809103787, 4.0565825945039355],
            [16.561633696809608, 4.063682878036119],
            [16.56628947284329, 4.064644757836431],
            [16.572570391133738, 4.068416130693951],
            [16.57355774968847, 4.064150796403996],
            [16.577625378321294, 4.067322364098906],
            [16.5847050328072, 4.0678577640118165],
            [16.592124982642304, 4.071100956731038],
            [16.593394198027017, 4.066037647315642],
            [16.596299114692744, 4.065536049117582],
            [16.600131695316353, 4.068271468368085],
            [16.602740274381272, 4.065394279427703],
            [16.608989230573048, 4.066252570382957]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.24815072405723, "lat": 40.78805565713615 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34013"],
        "coty_name": ["Essex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Essex County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00882276"
      },
      "bbox": [
        16.56071809103787, 3.8719138794309473, 16.7638130309424,
        4.071100956731038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.47241952523697, 3.4940083980212235],
            [16.47731237506875, 3.4972035291118426],
            [16.483858437459368, 3.5038234369108],
            [16.487681591036512, 3.509876236767517],
            [16.48920344246028, 3.5167263543196343],
            [16.491655402049467, 3.5194659091254437],
            [16.491092798787705, 3.5289074812450223],
            [16.4882030579495, 3.5408608887259954],
            [16.488837559334733, 3.5441867411453156],
            [16.49391383400241, 3.5490817006920867],
            [16.508316268335452, 3.5606854712749305],
            [16.519694976474053, 3.571539653539471],
            [16.52529596619764, 3.579565291803021],
            [16.528422651470855, 3.586922493090461],
            [16.533057858291492, 3.5935063011024004],
            [16.53543365733408, 3.5985602946447646],
            [16.542818314216785, 3.6084759705989997],
            [16.54803512050962, 3.620677719667183],
            [16.551785541466526, 3.626010322548246],
            [16.558682424257043, 3.630620541943057],
            [16.56386161810247, 3.636152545966234],
            [16.563326055081795, 3.6412158089708493],
            [16.55989533221076, 3.644713936811135],
            [16.555929692194514, 3.6466044545601384],
            [16.554612389642138, 3.652468153470544],
            [16.5431226880442, 3.6528818103377088],
            [16.539364060572193, 3.656205918466938],
            [16.529306674049405, 3.6674845138979584],
            [16.514716164693223, 3.675237522401357],
            [16.510519476782783, 3.679614618199312],
            [16.50755096541804, 3.686720617216146],
            [16.501853264867293, 3.6916458489447272],
            [16.497910311267752, 3.7007282573772553],
            [16.500351329396395, 3.707506121908342],
            [16.506162670306413, 3.719139604620509],
            [16.511597827454025, 3.7215143979526473],
            [16.52442738447424, 3.7287216512406345],
            [16.528060126598717, 3.735449604471978],
            [16.532046391559984, 3.739676818217895],
            [16.53683565176253, 3.7416502914238126],
            [16.542288219223867, 3.739406303481977],
            [16.652275468497944, 3.7781214940034165],
            [16.6523604699504, 3.769774516342078],
            [16.656866582977997, 3.768271028056884],
            [16.66494725097193, 3.763769326572332],
            [16.686663455849818, 3.7743526179737232],
            [16.68689919164493, 3.7795362591697033],
            [16.690705128399244, 3.7788621888778358],
            [16.69875377619715, 3.779395750870139],
            [16.703007164384623, 3.7835348242975995],
            [16.708174244308733, 3.78091697745336],
            [16.719921507177393, 3.7877798345073623],
            [16.72166181451817, 3.7835341569973426],
            [16.727336037218958, 3.7802633960759153],
            [16.726259941572092, 3.7789421097201887],
            [16.726232857899717, 3.763614208372104],
            [16.727120891670445, 3.7503853797823545],
            [16.72416964777661, 3.7433531299073617],
            [16.715015541457056, 3.744769268529803],
            [16.71099344474029, 3.7391672583326896],
            [16.702213131569355, 3.731900433475142],
            [16.701419734815282, 3.7274227524933927],
            [16.704086773947786, 3.721509508284454],
            [16.705789771237427, 3.7149980068754713],
            [16.711217021884764, 3.703561861463536],
            [16.70653807454891, 3.689933847565091],
            [16.70612810238251, 3.6820214518682497],
            [16.70388729636805, 3.6766440289075395],
            [16.70193254545025, 3.665340270389357],
            [16.708236358764562, 3.657225538633254],
            [16.710728571615608, 3.649526886061274],
            [16.715284105968653, 3.64394478967136],
            [16.724666905918625, 3.6427935897669372],
            [16.729266440221956, 3.6402841159319745],
            [16.73490302111647, 3.641281680288718],
            [16.74049166869729, 3.6370872583984],
            [16.747171253476857, 3.6380965078117935],
            [16.745918770001637, 3.6303516044378323],
            [16.7425260034837, 3.6306135109699103],
            [16.7389245680297, 3.6274610197342367],
            [16.733459210511917, 3.6138745670761874],
            [16.738861475535273, 3.5893618124922835],
            [16.73194027540995, 3.5774779676946946],
            [16.702648171806455, 3.528547656031643],
            [16.666561772501396, 3.4680133785888216],
            [16.658149431066693, 3.4484535596897303],
            [16.660763730723605, 3.4400090511932793],
            [16.61752468430105, 3.4008089641243457],
            [16.615510533272897, 3.401123693471049],
            [16.599251531041194, 3.3986383780351326],
            [16.596749418075824, 3.419343904359657],
            [16.590919324341506, 3.4212787976339363],
            [16.580276234027053, 3.4213621152042015],
            [16.57651018884519, 3.4225836828194183],
            [16.56956970690319, 3.426764937095216],
            [16.567125691796228, 3.4255404347242706],
            [16.559982617117825, 3.430680338402705],
            [16.555643887360574, 3.4298998985233617],
            [16.5508331361427, 3.4236978888595573],
            [16.548262511470725, 3.4267046083614217],
            [16.54164050323117, 3.423885718453598],
            [16.5369499194343, 3.424439474076101],
            [16.534678774801858, 3.427931560647419],
            [16.53053664029837, 3.4279706390291245],
            [16.527686581284723, 3.4304199121530514],
            [16.518159474707655, 3.432211858155667],
            [16.513823146563087, 3.4357369125568606],
            [16.51297494422501, 3.4393833659949054],
            [16.5051245972127, 3.441689428124811],
            [16.502300978899257, 3.4396923041720857],
            [16.4966620231431, 3.445467991038795],
            [16.485125960817072, 3.446563588222799],
            [16.481543356088377, 3.446055238326736],
            [16.479408350187313, 3.4492083520172017],
            [16.47903436656724, 3.45489488582149],
            [16.472056926767333, 3.459175861638785],
            [16.47274310225284, 3.465411079891218],
            [16.47222529969022, 3.4758703314591832],
            [16.471147784118024, 3.4827388748559267],
            [16.47241952523697, 3.4940083980212235]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.41170335726979, "lat": 40.43917104138453 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34023"],
        "coty_name": ["Middlesex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Middlesex County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00882230"
      },
      "bbox": [
        16.471147784118024, 3.3986383780351326, 16.747171253476857,
        3.7877798345073623
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.817150794219156, -3.0708453552442134],
            [-7.8213698607296305, -3.1152415162680644],
            [-7.8313309636168436, -3.2045912397518683],
            [-7.83593456289545, -3.24675463765557],
            [-7.8452447014344004, -3.333503100619219],
            [-7.811031793580755, -3.3372547291015797],
            [-7.769332072790234, -3.3415565978116546],
            [-7.778214705612074, -3.424966601408969],
            [-7.809321063869944, -3.4215992543019014],
            [-7.809422697396431, -3.4224965091784214],
            [-7.836471527930641, -3.4194333461905666],
            [-7.958934306791599, -3.4052152029472142],
            [-7.990150709497175, -3.401881331412487],
            [-7.9878225879537474, -3.3824074771917427],
            [-7.990412034447168, -3.3787880414241522],
            [-7.992839085127319, -3.379278997009546],
            [-7.996077172358619, -3.373086428044604],
            [-7.9965391254583675, -3.3691596339701575],
            [-8.000807805457494, -3.367138627607711],
            [-8.207955606937187, -3.3411882723746738],
            [-8.217281061030421, -3.3494728323312692],
            [-8.223807487935202, -3.360591068874177],
            [-8.233820016523088, -3.3653049049529953],
            [-8.237572889962044, -3.36948338502118],
            [-8.240057135724559, -3.374232705218484],
            [-8.276766361532365, -3.3701607662974675],
            [-8.485499298745323, -3.3461826756471393],
            [-8.509284182555737, -3.2549832955360825],
            [-8.519296293856108, -3.2175697847203018],
            [-8.5341405808953, -3.1634142219079693],
            [-8.573021427228737, -3.019364572557685],
            [-8.583663462697631, -2.9802823826440745],
            [-8.533405662201947, -2.9862476822261925],
            [-8.504274798322932, -2.9905959883807802],
            [-8.394592803625152, -3.0034755739775965],
            [-8.307014303670645, -3.0139624851315534],
            [-8.23454161743794, -3.022226082252847],
            [-8.150125294072247, -3.0318807872815485],
            [-8.142938136245814, -3.0360865087649325],
            [-8.145178167897429, -3.0396330238266684],
            [-8.140573485534958, -3.0448334351978317],
            [-8.141754168583871, -3.0493453618357846],
            [-8.136982003403483, -3.048496580264832],
            [-8.121522186379423, -3.04376762221373],
            [-8.118983969477759, -3.0415757321216232],
            [-8.106936440960137, -3.0367465108726366],
            [-7.990128797199758, -3.0496419581454757],
            [-7.9573998448635805, -3.0537670093825198],
            [-7.916014974254221, -3.058326372038422],
            [-7.817150794219156, -3.0708453552442134]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.6701646125055,
          "lat": 35.051360682494206
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35001"],
        "coty_name": ["Bernalillo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bernalillo County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01702363"
      },
      "bbox": [
        -8.583663462697631, -3.424966601408969, -7.769332072790234,
        -2.9802823826440745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.255824188990353, 5.872627886917147],
            [16.286341707488464, 5.885584916981646],
            [16.3525906927959, 5.913061103344484],
            [16.38290207922565, 5.925953740751214],
            [16.40585325203427, 5.9360487672623],
            [16.426503452459727, 5.944565642631108],
            [16.44245442401329, 5.950681159344995],
            [16.50876540540574, 5.978241704296534],
            [16.508034758840473, 5.98203128222325],
            [16.515063494651297, 5.983703360858058],
            [16.518389166184754, 5.988294494968333],
            [16.521348549065408, 5.99629671398961],
            [16.524124457853635, 5.999113646195164],
            [16.527743673042266, 5.999970816323497],
            [16.535222179950225, 5.995674842810175],
            [16.538353369930974, 5.999192704339922],
            [16.54033805804505, 6.00655376851677],
            [16.54480478756072, 6.01388639180676],
            [16.545171775255564, 6.0179843228735885],
            [16.549588869919912, 6.033019714821457],
            [16.55652678061004, 6.038471554767351],
            [16.56039584234857, 6.036407770449612],
            [16.562505231054775, 6.0301209112260645],
            [16.566889165363225, 6.0252041137267875],
            [16.566326318651107, 6.018892231833228],
            [16.573782374734332, 6.0143893387151515],
            [16.57723843380368, 6.007496281442085],
            [16.58805458002596, 6.000470218053749],
            [16.594166133165057, 5.998868440648076],
            [16.59707730319378, 6.00301622115716],
            [16.598609444003, 6.008154778412603],
            [16.601116299823648, 6.008648434099067],
            [16.60024741207784, 5.9965274652384],
            [16.600263840075183, 5.988488923274272],
            [16.601667820829114, 5.982651576160594],
            [16.601201196945585, 5.976163355000833],
            [16.602853909571838, 5.9600414398426675],
            [16.59934297015969, 5.952243508738461],
            [16.59935633794716, 5.932307758246666],
            [16.602180669998194, 5.92426657784115],
            [16.60089727618889, 5.916829124810137],
            [16.59659767779614, 5.903768991534719],
            [16.59333549234852, 5.890442018391959],
            [16.59075350633994, 5.882729070793402],
            [16.585681193376036, 5.874116441412117],
            [16.58358412748769, 5.863431927151163],
            [16.582669421998688, 5.852823045457299],
            [16.583116485197564, 5.845313294138775],
            [16.58148212577403, 5.826093970987725],
            [16.58372182799461, 5.816745751936763],
            [16.58974144450962, 5.804178047128825],
            [16.595679561915688, 5.794780096786853],
            [16.598144537588006, 5.785113749334927],
            [16.59929539074981, 5.766818686023137],
            [16.601354902253377, 5.752418072004214],
            [16.600795522168255, 5.739738578100577],
            [16.595464216782975, 5.721789401273664],
            [16.59295397464668, 5.704857788717292],
            [16.593342969485263, 5.698658014333234],
            [16.596428388001506, 5.686826361820279],
            [16.59957107136973, 5.679951572363804],
            [16.563063794425823, 5.665507280945289],
            [16.536375969702075, 5.653326527511279],
            [16.499161718293898, 5.636643749926361],
            [16.48727535125942, 5.631801619479145],
            [16.454301014673792, 5.618999509502181],
            [16.431664439597572, 5.60979459418711],
            [16.370943193545006, 5.584390298969483],
            [16.364566489686624, 5.5822610185156805],
            [16.33096939305402, 5.56823292326335],
            [16.276624739707657, 5.546614045862855],
            [16.270322563160033, 5.544042691743382],
            [16.266454543699975, 5.55651838051213],
            [16.26948293603081, 5.583182826964199],
            [16.269485790985364, 5.608703450135247],
            [16.27110018206886, 5.610984565651897],
            [16.271732365320734, 5.6249359829557966],
            [16.27536373608913, 5.6349540092444625],
            [16.275720360975217, 5.640026606151339],
            [16.274633931852428, 5.649355999299263],
            [16.27008712060075, 5.666659925312475],
            [16.26704349277845, 5.668655063640956],
            [16.257177066279755, 5.681612503758925],
            [16.25315178468376, 5.687820031845261],
            [16.254312188055312, 5.697669778277961],
            [16.253154144063856, 5.70048984297667],
            [16.252868622648407, 5.713341289303959],
            [16.260424374634624, 5.725091887214536],
            [16.259524518095517, 5.731045592639023],
            [16.261315250841104, 5.737659702752683],
            [16.263820030490702, 5.7418961200866665],
            [16.266112383349316, 5.749050398485279],
            [16.27181882368217, 5.762268904756077],
            [16.27063144913189, 5.770289461683473],
            [16.275639914696583, 5.791310102158015],
            [16.27765271285273, 5.813409148547044],
            [16.276929652638863, 5.820317383428883],
            [16.272311360508397, 5.836774157847275],
            [16.269838711374618, 5.862760471581684],
            [16.255824188990353, 5.872627886917147]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.97355244227745, "lat": 42.600178610517 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36001"],
        "coty_name": ["Albany"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Albany County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00974099"
      },
      "bbox": [
        16.252868622648407, 5.544042691743382, 16.602853909571838,
        6.038471554767351
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.776375234161714, 5.07912671476975],
            [13.765781018628322, 5.142277341395823],
            [13.777815884785825, 5.144123454205794],
            [13.782675196826515, 5.145557132286024],
            [13.808399330057336, 5.1505578566965875],
            [13.800653824760115, 5.19535247591945],
            [13.828877503200623, 5.20058512634511],
            [13.922628207163765, 5.216012314561807],
            [13.955044037421974, 5.221877841680425],
            [14.0120964563951, 5.232706768168323],
            [14.054977181132168, 5.241035892776331],
            [14.137178342478302, 5.257761420813228],
            [14.171811469215832, 5.26499936988655],
            [14.171496945379367, 5.252875571548359],
            [14.172210643495958, 5.2415715105957865],
            [14.17401223580811, 5.233754756927832],
            [14.178974897611244, 5.2176772069609765],
            [14.179936376763889, 5.203660301402378],
            [14.182945472009683, 5.18872362280666],
            [14.188000082017266, 5.184250638997335],
            [14.194565586195704, 5.185669765238754],
            [14.199464213777242, 5.18915809014445],
            [14.204892206700384, 5.197005024835969],
            [14.206561520213613, 5.201695039287348],
            [14.21200042167539, 5.199959048015255],
            [14.216563468708966, 5.1787962647618455],
            [14.233306805567652, 5.103493732911356],
            [14.23701812212398, 5.086284466710246],
            [14.26402461135562, 4.972087570478986],
            [14.271911082672402, 4.973327589169788],
            [14.281324065206553, 4.978755230378348],
            [14.329875690790079, 4.990781715257262],
            [14.336467204758987, 4.992668707519692],
            [14.359782782205473, 4.997664099478215],
            [14.364889408889207, 4.969613520204926],
            [14.370548746619466, 4.943642636045401],
            [14.386081888360556, 4.865912804761129],
            [14.391421726709803, 4.840221396249367],
            [14.410028936903972, 4.747498791061341],
            [14.414763121055296, 4.724970593241774],
            [14.34413618440167, 4.709888988289801],
            [14.30021283496757, 4.699973105986153],
            [14.231336016588637, 4.686366706377158],
            [14.151558273837392, 4.670695788004014],
            [14.024640535073686, 4.645961624140816],
            [13.948926810977415, 4.630567512929282],
            [13.847747634590911, 4.610130401929836],
            [13.831088539526434, 4.712717552720665],
            [13.824108223754614, 4.75455706749674],
            [13.80976899964679, 4.845649009268595],
            [13.805203478214857, 4.8759574572869795],
            [13.79311666295595, 4.9524550944513015],
            [13.783453167933121, 5.011967949700573],
            [13.787030625300075, 5.012580925548936],
            [13.783290746498121, 5.036806569110461],
            [13.776375234161714, 5.07912671476975]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.38377566993576,
          "lat": 42.267810120180094
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36101"],
        "coty_name": ["Steuben"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Steuben County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00974148"
      },
      "bbox": [
        13.765781018628322, 4.610130401929836, 14.414763121055296,
        5.26499936988655
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.415008211661553, -1.925319297793614],
            [15.422727562134952, -1.9291184711667781],
            [15.438821175196788, -1.9278586593770735],
            [15.443153935636381, -1.930708248241779],
            [15.449428854824049, -1.9299008391804278],
            [15.483874268945131, -1.8709176249920334],
            [15.490646610627465, -1.8723992955248316],
            [15.495976769127758, -1.8718978103492716],
            [15.505698438577829, -1.8768308363466695],
            [15.507516441348582, -1.8809798107306537],
            [15.506422860924502, -1.8847648833933432],
            [15.509518128880629, -1.8904418156253586],
            [15.516279320588986, -1.8926950052678937],
            [15.526373051220423, -1.8872611573374918],
            [15.531282928913487, -1.8802008822087335],
            [15.529976192807112, -1.8748240679248689],
            [15.530933158483531, -1.8692877608863516],
            [15.526778665994769, -1.8600677248270479],
            [15.529042257920391, -1.8494627190363393],
            [15.533904424102507, -1.8473849299384264],
            [15.533042368018004, -1.8398077746696384],
            [15.537478189481819, -1.8369500224507096],
            [15.541962168444773, -1.8368918316715486],
            [15.545976773792697, -1.8389275600880908],
            [15.552213229638946, -1.8375759194297134],
            [15.554728384988087, -1.835312520246726],
            [15.557469570215856, -1.8205144328755767],
            [15.559482885091521, -1.815470548149684],
            [15.639549576123434, -1.8462763310503691],
            [15.765410168723195, -1.894702782284155],
            [15.824747564912018, -1.93106626690244],
            [15.820237083076531, -1.9504714345186513],
            [15.800403213594937, -1.960302641036016],
            [15.794630536348329, -1.9723784084833125],
            [15.79584484434522, -1.9786786836922055],
            [15.79318895940326, -1.983615914302335],
            [15.79033094196619, -1.9846859116587923],
            [15.78457284845077, -1.9917491632516107],
            [15.78283552232391, -1.99723068642687],
            [15.782485505173904, -2.006955681882029],
            [15.78316154301757, -2.012946184142307],
            [15.780698032920853, -2.0169092822058645],
            [15.7807383443534, -2.021134918652745],
            [15.78315783113193, -2.0256834142695292],
            [15.782186412880042, -2.02991978017178],
            [15.783843882749919, -2.0322055517133704],
            [15.78318560297317, -2.036767172201467],
            [15.780262941724915, -2.0413506986074568],
            [15.773809990604088, -2.0426535340849323],
            [15.772036357550135, -2.04425748795294],
            [15.778495493599092, -2.055671692878017],
            [15.783355629894968, -2.0591164838766787],
            [15.785446442194297, -2.0627162792498774],
            [15.793704327898597, -2.065492154034999],
            [15.807215159948528, -2.0673048652435533],
            [15.811530532114839, -2.070459708114935],
            [15.816212451694451, -2.0714641812028907],
            [15.816034727721359, -2.0752083963427417],
            [15.821105707250277, -2.0780581336459822],
            [15.822973270488665, -2.088185826502358],
            [15.82389878339413, -2.1001206391354152],
            [15.830019750856742, -2.108720379542306],
            [15.828257298876082, -2.1154977145499174],
            [15.83003882372916, -2.1170097703829125],
            [15.831416989990279, -2.1272023640217985],
            [15.828354540503991, -2.1325320411135484],
            [15.828198763933088, -2.138709014701825],
            [15.823456417197816, -2.139572715181377],
            [15.819059985284321, -2.134532474536508],
            [15.815773679724574, -2.135799089061255],
            [15.810207171024825, -2.1355277941735546],
            [15.803524966465009, -2.138484390064732],
            [15.798813801778483, -2.1356374279212225],
            [15.789781909995956, -2.1318660315953952],
            [15.789230440341193, -2.128176715100746],
            [15.784923424799958, -2.126462780197722],
            [15.77943252369062, -2.122559271415025],
            [15.77515824644374, -2.1148786044973007],
            [15.7663770795584, -2.105266375633398],
            [15.764509375022065, -2.100378842737468],
            [15.761436294500115, -2.0988008831424403],
            [15.757395992439308, -2.100217798477746],
            [15.756967244531273, -2.091306951182404],
            [15.750677512054834, -2.0825818376881564],
            [15.74657725287552, -2.0798114760082522],
            [15.742260759208943, -2.0720885986881203],
            [15.73672775250818, -2.0700085310111147],
            [15.73038519856046, -2.0648933209070472],
            [15.725314096359192, -2.0641189102979522],
            [15.720688219082353, -2.061655162068361],
            [15.716271492327612, -2.0631462798768236],
            [15.716907981177311, -2.0692137496729757],
            [15.7248067369676, -2.074188471650668],
            [15.72566999010159, -2.0814369370016523],
            [15.734313806488114, -2.0852886804624906],
            [15.743244423054598, -2.094387077276655],
            [15.744919616407397, -2.101740761455534],
            [15.743167984749808, -2.106694601158068],
            [15.747591177029868, -2.112999218949877],
            [15.750814749969692, -2.114347806628675],
            [15.75614487455933, -2.1202702494188888],
            [15.763949861907301, -2.1218919903910947],
            [15.767725798991592, -2.1337307558266945],
            [15.783040449161197, -2.1442353714829823],
            [15.788759220953482, -2.1510811023617435],
            [15.792805111558899, -2.1536695957513103],
            [15.798977894355279, -2.1694241414273505],
            [15.80480076265281, -2.179071766392583],
            [15.807146123491068, -2.1863851728085786],
            [15.810031990981715, -2.190147046168817],
            [15.817094822565688, -2.1965809159908343],
            [15.834074034424775, -2.2035482120464094],
            [15.844192709283295, -2.2097042508412157],
            [15.849569017738158, -2.2148215722778466],
            [15.857804047999728, -2.2165531140038253],
            [15.884458139203838, -2.2235501420198385],
            [15.886855578037975, -2.2304751530450564],
            [15.891680197639921, -2.231897189768198],
            [15.908454637366352, -2.2290793830270865],
            [15.921029193455846, -2.2327267009933527],
            [15.922194653437954, -2.2364970756227427],
            [15.927012567179261, -2.2369156597101463],
            [15.938537417183195, -2.2315567068633126],
            [15.942307818308532, -2.22878160481451],
            [15.955572284379707, -2.2280745900709635],
            [15.961954776369575, -2.2314410220005576],
            [15.976404723616666, -2.2344144347577792],
            [16.00043717083983, -2.2429406041001902],
            [16.005910388584997, -2.239812959837863],
            [16.00583760861406, -2.2356172652731052],
            [16.011437091189034, -2.2340680121386303],
            [16.01193170903399, -2.229755751446983],
            [16.00962629325263, -2.226219833949796],
            [16.016321575846252, -2.2242434914505544],
            [16.01987262103953, -2.227123256817564],
            [16.02524285339437, -2.225418263510966],
            [16.0303930500672, -2.215939940464206],
            [16.03503617442439, -2.196344161110132],
            [16.04057534688406, -2.192598468437726],
            [16.051438297712277, -2.1907638694477685],
            [16.05725079171151, -2.192172180151036],
            [16.058484458130753, -2.187941321259093],
            [16.082217725952667, -2.203748968340535],
            [16.08028657988608, -2.2268021576902624],
            [16.07950682681266, -2.2303800387643613],
            [16.0752993611716, -2.238575276256379],
            [16.071924914885283, -2.2425548401999524],
            [16.065815280978093, -2.2465645146123494],
            [16.063988803634253, -2.2509511165971445],
            [16.064845445676667, -2.25835530223452],
            [16.062829579379855, -2.264549248118719],
            [16.064483218597097, -2.2758540149409776],
            [16.063936411234113, -2.27790790776634],
            [16.016787039669843, -2.3111472868095357],
            [16.00956412243085, -2.310046583777428],
            [16.005739389496036, -2.3130091133523085],
            [15.917366725357152, -2.3328986414206088],
            [15.919615922895671, -2.340883855703429],
            [15.864261255909767, -2.3646599207969845],
            [15.867628031370339, -2.3798526328014593],
            [15.858420093841794, -2.38187387655907],
            [15.768360565428827, -2.397611378597171],
            [15.770511408559612, -2.3914774874789644],
            [15.775410703215552, -2.3862311330942028],
            [15.786632903315082, -2.3711046225485743],
            [15.788100072292641, -2.367835654801918],
            [15.740072385084535, -2.3833103192289284],
            [15.730175347757275, -2.3273014231703804],
            [15.721103016858214, -2.2727507125527384],
            [15.707553064671789, -2.198363756630518],
            [15.70689322740175, -2.192030975358494],
            [15.708897036599392, -2.1877278986570725],
            [15.701444432432446, -2.181884697558488],
            [15.697958879007027, -2.1725016361503457],
            [15.695973349239667, -2.1702384651653883],
            [15.696351946681537, -2.162389689550475],
            [15.692115922539063, -2.148557463455047],
            [15.685878399908352, -2.144085941670859],
            [15.684719908424755, -2.1468564538419903],
            [15.680761378875937, -2.1463038284579765],
            [15.674737815476032, -2.1481802731363016],
            [15.67411294135003, -2.153805176784937],
            [15.670050911415283, -2.1606070445844696],
            [15.66550034808604, -2.1626182560966356],
            [15.664428214152199, -2.166658968733227],
            [15.656980868548137, -2.1616758212877665],
            [15.654532511521621, -2.162800603021192],
            [15.649052000242818, -2.1603497838484507],
            [15.64614007539678, -2.166603483980637],
            [15.643074055984066, -2.1690801861366507],
            [15.638734681548767, -2.169759190336586],
            [15.635400904582067, -2.166038153288029],
            [15.62899664867209, -2.163153401635794],
            [15.62845769528778, -2.159280108517443],
            [15.625763167759509, -2.1536512311492184],
            [15.627524228899835, -2.148629238850298],
            [15.501358669430383, -2.1031586353599083],
            [15.389955738920404, -2.0541611085413165],
            [15.371036372616167, -2.047628671220733],
            [15.370946343220963, -2.0455101377506058],
            [15.37635112064618, -2.0407914999109957],
            [15.376496882476506, -2.036100556083714],
            [15.389666480353782, -2.0258703801361615],
            [15.39955733256697, -2.020217580268329],
            [15.402882474150045, -2.0137102900386643],
            [15.40224569282235, -2.007150003524696],
            [15.39607097386683, -1.999318244453136],
            [15.3902665971595, -1.9945021886787155],
            [15.386453076484813, -1.9874588557441173],
            [15.385993744372179, -1.9823915533841674],
            [15.380043317896089, -1.9795883219915098],
            [15.376377913876128, -1.9741545403043141],
            [15.37629044836515, -1.9717238076609451],
            [15.382725418947162, -1.9687696805013373],
            [15.382834480282742, -1.9601880284584436],
            [15.3884240533924, -1.957846341010485],
            [15.38500106200429, -1.941233976254997],
            [15.398408625193795, -1.9373742898250603],
            [15.400800362467924, -1.9329168303701305],
            [15.401077965076995, -1.9282087653853779],
            [15.41104589325187, -1.9225162480057687],
            [15.415008211661553, -1.925319297793614]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.09391949105861, "lat": 35.12489171146368 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37049"],
        "coty_name": ["Craven"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Craven County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01026123"
      },
      "bbox": [
        15.370946343220963, -2.397611378597171, 16.082217725952667,
        -1.815470548149684
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.108935702093548, -1.6640331594269613],
            [15.117211090016411, -1.6535288932391319],
            [15.129142179891643, -1.639633531017699],
            [15.132662338296205, -1.6361385772708616],
            [15.146082644818973, -1.6217880233579909],
            [15.189433461377451, -1.5733751246773269],
            [15.21329204359327, -1.5472166427024727],
            [15.233418781526654, -1.5275701835154643],
            [15.260339554885421, -1.4813801571383913],
            [15.276340265917602, -1.4794490058595424],
            [15.277647107163807, -1.4720674571924997],
            [15.280797398089343, -1.4695022114322709],
            [15.284051293023575, -1.4704590242770654],
            [15.296757306090267, -1.469601305990973],
            [15.301062590440315, -1.4631998512085556],
            [15.302975362304064, -1.4553938354407132],
            [15.302044169647456, -1.450231384289943],
            [15.304787886061492, -1.4465646109001935],
            [15.314877812152584, -1.4458119243244811],
            [15.31864622037068, -1.4408398554745525],
            [15.318817006832635, -1.436936774899232],
            [15.35288855123867, -1.4444024191583944],
            [15.43438358532945, -1.4619840493399763],
            [15.434981357202341, -1.4652986127327583],
            [15.429300195337115, -1.474439806355907],
            [15.42946491054286, -1.4773284801538409],
            [15.43494097751701, -1.483609919878949],
            [15.438194220476873, -1.4827914505868052],
            [15.442847218656192, -1.4857463859799485],
            [15.447805744491703, -1.4857821777446594],
            [15.451225632717366, -1.483606865406315],
            [15.460187643822195, -1.482969940476375],
            [15.46557291924386, -1.4841198036229264],
            [15.47054742659172, -1.4817805522344167],
            [15.479933986645491, -1.4859679372065708],
            [15.484042804914555, -1.4886459693058904],
            [15.482449599245438, -1.4913653981351425],
            [15.490411450630726, -1.4910972863980163],
            [15.491809677233546, -1.4930095134070565],
            [15.499442851539593, -1.4959125248741805],
            [15.503992477220432, -1.4963612445475147],
            [15.509014135591483, -1.502106324725819],
            [15.510366408680582, -1.5069207215501688],
            [15.51470510231656, -1.5151484025530302],
            [15.512758236035582, -1.5186328565675395],
            [15.506764228427201, -1.516898954117061],
            [15.502702239693553, -1.5190500042786514],
            [15.502046577279161, -1.5258194424733105],
            [15.497960781689942, -1.5285993579986308],
            [15.498398039366137, -1.53824002742813],
            [15.501714617698841, -1.5433581618792556],
            [15.505529857110114, -1.5413649884597733],
            [15.511513492919068, -1.5427042286962687],
            [15.513874162764733, -1.550162892330986],
            [15.517011701619277, -1.5473400793681558],
            [15.521919313249418, -1.5494078834213663],
            [15.523464035815396, -1.5578151181742252],
            [15.526421806121348, -1.560559004216132],
            [15.523266377276412, -1.564943304369435],
            [15.518890873817353, -1.5654199140190206],
            [15.517299971675198, -1.5707080644651281],
            [15.52319956787076, -1.5755101182019027],
            [15.525079760013618, -1.5805957511572375],
            [15.52860079305548, -1.5946090372892516],
            [15.528408892476795, -1.5985342200721906],
            [15.53373763025337, -1.6017055180386717],
            [15.540927404920769, -1.6016973778611374],
            [15.543895959113453, -1.6046043070647316],
            [15.548926469263538, -1.604838752531792],
            [15.55192957346976, -1.6093413780000987],
            [15.556807514847316, -1.610775791409368],
            [15.556219067723463, -1.620480444167607],
            [15.558966823863647, -1.6273510233388686],
            [15.562800686891766, -1.6269683313452339],
            [15.567238300639062, -1.6310278448613786],
            [15.569236511961465, -1.6304717380403657],
            [15.57809266763115, -1.6329188403758386],
            [15.577789027189034, -1.6398504052332679],
            [15.585501541733397, -1.6366862398573203],
            [15.58396431601536, -1.6428589561427405],
            [15.585910348572144, -1.6436092965017732],
            [15.589395406626616, -1.63997968135348],
            [15.59228378256515, -1.6411708223887165],
            [15.590514628359871, -1.6510437859165006],
            [15.598760128235018, -1.651928765432266],
            [15.599269548652305, -1.6552676471322438],
            [15.603556725802122, -1.6560995588515541],
            [15.606860052448253, -1.6506867657064426],
            [15.611913044390365, -1.6565658567596058],
            [15.611778872939446, -1.6650049045165858],
            [15.608772763933988, -1.6692724064173148],
            [15.602892888748698, -1.6698427812034737],
            [15.599585162086104, -1.6719719412508895],
            [15.593452799897335, -1.6735100812313504],
            [15.581412173298228, -1.671791942448878],
            [15.549705143135968, -1.7138183493674723],
            [15.549407967637961, -1.7194077713362044],
            [15.550421841012612, -1.7254212825634219],
            [15.552967683480103, -1.7314329574588205],
            [15.56134125967964, -1.7342951721761142],
            [15.55837424900947, -1.7471894164290678],
            [15.563988709566303, -1.7752433239122287],
            [15.558777032550722, -1.777823236246369],
            [15.558846149520312, -1.7837840447139468],
            [15.56160618454947, -1.7885202054188374],
            [15.561187034523542, -1.7921639289047917],
            [15.554502416381263, -1.7993304310509322],
            [15.556819975052866, -1.8044608164630853],
            [15.559482885091521, -1.815470548149684],
            [15.557469570215856, -1.8205144328755767],
            [15.554728384988087, -1.835312520246726],
            [15.552213229638946, -1.8375759194297134],
            [15.545976773792697, -1.8389275600880908],
            [15.541962168444773, -1.8368918316715486],
            [15.537478189481819, -1.8369500224507096],
            [15.533042368018004, -1.8398077746696384],
            [15.533904424102507, -1.8473849299384264],
            [15.529042257920391, -1.8494627190363393],
            [15.526778665994769, -1.8600677248270479],
            [15.530933158483531, -1.8692877608863516],
            [15.529976192807112, -1.8748240679248689],
            [15.531282928913487, -1.8802008822087335],
            [15.526373051220423, -1.8872611573374918],
            [15.516279320588986, -1.8926950052678937],
            [15.509518128880629, -1.8904418156253586],
            [15.506422860924502, -1.8847648833933432],
            [15.507516441348582, -1.8809798107306537],
            [15.505698438577829, -1.8768308363466695],
            [15.495976769127758, -1.8718978103492716],
            [15.490646610627465, -1.8723992955248316],
            [15.483874268945131, -1.8709176249920334],
            [15.449428854824049, -1.9299008391804278],
            [15.443153935636381, -1.930708248241779],
            [15.438821175196788, -1.9278586593770735],
            [15.422727562134952, -1.9291184711667781],
            [15.415008211661553, -1.925319297793614],
            [15.41323185413117, -1.9194001804572574],
            [15.402949314972293, -1.9175470894437399],
            [15.398667416111525, -1.9143329804736122],
            [15.394991137079515, -1.916775406192548],
            [15.38932831567895, -1.9175992683762269],
            [15.38894600742497, -1.920944503500126],
            [15.384908961876764, -1.920768895680486],
            [15.382509904480058, -1.9112148884737645],
            [15.37608521857767, -1.9037130363697152],
            [15.370821647021097, -1.9058689942275446],
            [15.363422646215303, -1.9026291008786933],
            [15.362352365736902, -1.8999966221358648],
            [15.363340910199923, -1.892850102606889],
            [15.360271677178286, -1.8934802408006515],
            [15.355240813958595, -1.8898643453721518],
            [15.359009605094856, -1.8850341756447628],
            [15.350961269391714, -1.8790849488631236],
            [15.345826407053659, -1.877236440068082],
            [15.34493223047738, -1.8728957133940973],
            [15.338065988908953, -1.86834935935283],
            [15.336225073346492, -1.861098591643616],
            [15.336728692286439, -1.8581716451549513],
            [15.333365471413844, -1.8528791098966466],
            [15.330967056888321, -1.852390325240478],
            [15.328995999627535, -1.8482793859664055],
            [15.329512593419128, -1.8398838378546984],
            [15.325478937370615, -1.8406364896030063],
            [15.326329184256398, -1.8340262410821304],
            [15.321643855452574, -1.8330397406314765],
            [15.321114109418797, -1.8299856716797585],
            [15.317892777030238, -1.8277461122420866],
            [15.31614209207427, -1.8230836992839186],
            [15.310586208221988, -1.8206289308994545],
            [15.311141411269485, -1.8136812536823796],
            [15.30687890288743, -1.8088580806537933],
            [15.30631745013307, -1.805070117429233],
            [15.30207383857982, -1.8033296521541864],
            [15.295246670063573, -1.7906847848892418],
            [15.292772591874602, -1.7905677696825344],
            [15.28820250922895, -1.7870522131246311],
            [15.291641619356739, -1.7799097010714249],
            [15.288897191703452, -1.7768260370909397],
            [15.290659891592984, -1.774434416620036],
            [15.289509983725095, -1.766417391869702],
            [15.279286404824356, -1.7694492342467085],
            [15.273660466383529, -1.768528553530135],
            [15.274840557053391, -1.763972192873745],
            [15.271806030845463, -1.7595349599105188],
            [15.266799605280223, -1.7584200619540797],
            [15.260057564305566, -1.7589268181033515],
            [15.25836393887641, -1.7573799240695],
            [15.250938504901665, -1.7589699359700435],
            [15.24701179456814, -1.7609089924141341],
            [15.24297897673965, -1.7599045466870022],
            [15.234092392917097, -1.751104425985283],
            [15.23167664684492, -1.7463462241126815],
            [15.222432354028511, -1.743297798078752],
            [15.21723456189231, -1.7382340010892334],
            [15.211129329348768, -1.7346510192813374],
            [15.20139416951769, -1.7330645723491838],
            [15.19691861706464, -1.7339741343340174],
            [15.184877595878078, -1.7210814917316992],
            [15.180833520598492, -1.7202768984403176],
            [15.171723242389287, -1.7129527247370175],
            [15.145563555287373, -1.6908441088357957],
            [15.13594124495822, -1.6886233143382874],
            [15.128170196597907, -1.682410754065061],
            [15.126849951397874, -1.679133245002406],
            [15.127619189389192, -1.6744944657159448],
            [15.123881656257511, -1.669368048875729],
            [15.118796748999637, -1.6650375925686638],
            [15.113674655860581, -1.6635791556821242],
            [15.108935702093548, -1.6640331594269613]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.37444347095656, "lat": 35.59330265371298 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37147"],
        "coty_name": ["Pitt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pitt County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01008578"
      },
      "bbox": [
        15.108935702093548, -1.930708248241779, 15.611913044390365,
        -1.436936774899232
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.692723738719339, -1.889736099577184],
            [12.699145724230508, -1.8912466620960555],
            [12.701744636932743, -1.8865197797171898],
            [12.704378091526214, -1.886527534228004],
            [12.703367002042992, -1.8785004549698183],
            [12.71681530089241, -1.8828771022572752],
            [12.71842050746272, -1.8807512074730042],
            [12.723632156235368, -1.8825811456582848],
            [12.720888832131122, -1.8885577459406582],
            [12.722723389460828, -1.8914344607978772],
            [12.732488767284915, -1.8917231559761987],
            [12.740197456392819, -1.8889231310907855],
            [12.743505231941803, -1.890113521804204],
            [12.75398969038605, -1.8871786736658154],
            [12.756272258178653, -1.894411924775747],
            [12.762920369159856, -1.8927615217051996],
            [12.764262306003461, -1.8944843351456235],
            [12.774246635357532, -1.900979502236237],
            [12.773019969437055, -1.9051644391074258],
            [12.775788233574088, -1.906750309379393],
            [12.7812211073846, -1.9053725052834414],
            [12.782905327163295, -1.9012996419351609],
            [12.786543387004269, -1.9005774105597133],
            [12.788890447426404, -1.907125028050204],
            [12.793301537853612, -1.903951086259463],
            [12.80181135538393, -1.9075558280337195],
            [12.808439505439818, -1.9091130158538054],
            [12.810286334938247, -1.9124123252160836],
            [12.814741220677877, -1.9134990126166005],
            [12.82276286913582, -1.9223726512464558],
            [12.829407187416745, -1.9233900634268912],
            [12.833315459478133, -1.9288447833942342],
            [12.840795591874821, -1.93034771132377],
            [12.84134153820833, -1.9337505369485317],
            [12.846285938143634, -1.9356864191732368],
            [12.850767229806989, -1.933648571853164],
            [12.853590523538823, -1.9347119148794134],
            [12.857868438334803, -1.9392739872707316],
            [12.864336966764318, -1.9416125550670764],
            [12.866146294786182, -1.9346111132783002],
            [12.868610241579532, -1.932044185932782],
            [12.87239683202173, -1.9326121764638575],
            [12.876275011702086, -1.9361045839562598],
            [12.879313362767359, -1.9443244186145108],
            [12.883209915115144, -1.9369420665010106],
            [12.887478909488197, -1.9378132573539688],
            [12.893671506669499, -1.9433503513306816],
            [12.897180025470822, -1.9499764159487047],
            [12.898167243540039, -1.9542560118304193],
            [12.903910129757417, -1.9589926298385407],
            [12.90810814380502, -1.9671359797375545],
            [12.91383854046985, -1.9746165048978144],
            [12.922876020299526, -1.9729923342226254],
            [12.933240224367283, -1.976417261108155],
            [12.939476301994878, -1.9792210467645124],
            [12.947018938581662, -1.981327893085248],
            [12.952580731054729, -1.9809844380148987],
            [12.9591978216812, -1.9769504162504172],
            [12.963294990327057, -1.97694671855075],
            [12.966929421705485, -1.9809285537699473],
            [12.972573139686519, -1.9799117366745878],
            [12.980815583262183, -1.9819526291056246],
            [12.98407979700142, -1.9818161078380006],
            [12.992390259423159, -1.9788373227887424],
            [13.005941344533653, -1.9728328110415014],
            [13.012476512593498, -1.9742717668471756],
            [13.018777328683406, -1.9803109715769218],
            [13.020689079734934, -1.9838994100629626],
            [13.020971708036555, -1.9883640454668792],
            [13.016389556267232, -1.995696630084581],
            [13.015610373716564, -2.003539583988097],
            [13.01757875236549, -2.0095220728843395],
            [13.020523516258413, -2.013902757950644],
            [13.026524498742551, -2.0177515216135267],
            [13.034230250536108, -2.018915752148053],
            [13.041236362229848, -2.023870048093675],
            [13.043430012065869, -2.0323754969028824],
            [13.046835123733173, -2.0370999255079583],
            [13.050276182525652, -2.0392675426715474],
            [13.056271499818793, -2.045183510648256],
            [13.06133595562225, -2.051539538284966],
            [13.065333324830185, -2.052909460865453],
            [13.077606718459489, -2.053276351295116],
            [13.080815593106523, -2.0541565791092595],
            [13.089686578187601, -2.0607321678470107],
            [13.094719951843002, -2.062510366220542],
            [13.100445111773261, -2.066384023047012],
            [13.108280017160501, -2.0752453635284183],
            [13.110973351305638, -2.081002688897944],
            [13.12422044875724, -2.089922131861669],
            [13.129933010189207, -2.0918719374310037],
            [13.133451205134756, -2.094696243967313],
            [13.136345449566639, -2.1026695470746444],
            [13.13689856778885, -2.1098327830451895],
            [13.1365455783186, -2.1206248765262603],
            [13.14090399885423, -2.1266308727276555],
            [13.147075377717893, -2.128898552486127],
            [13.151645320448523, -2.1380798762308624],
            [13.15090774811395, -2.1433348286272613],
            [13.153451736682038, -2.1462543603177533],
            [13.157737133923375, -2.148029026908191],
            [13.164162531837714, -2.1560958483817254],
            [13.164746883006131, -2.163612310875888],
            [13.16669956526829, -2.1680405540220824],
            [13.161951318696048, -2.169668549677292],
            [13.077649342859592, -2.1841816312946705],
            [13.026497292641894, -2.1929890538515013],
            [12.976776527480839, -2.2018983335410307],
            [12.910410842806304, -2.212158699125484],
            [12.897538843092553, -2.2146553575241157],
            [12.889588960338711, -2.215359431070814],
            [12.857364436136042, -2.2201146479167173],
            [12.827553643357748, -2.223563921158818],
            [12.789006597095048, -2.2289372143362916],
            [12.776150112356678, -2.2302242349524435],
            [12.771903186824133, -2.2315579408969906],
            [12.72540911501479, -2.2390919134475635],
            [12.72468574894795, -2.2299813045305816],
            [12.722293326852567, -2.2200928397219144],
            [12.718309481593684, -2.213324637172469],
            [12.715862163370671, -2.2049635472232714],
            [12.717194698844557, -2.201258931141278],
            [12.67128300444487, -2.0779202938671255],
            [12.677865465506551, -2.020208063778884],
            [12.692723738719339, -1.889736099577184]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.52473258580564, "lat": 35.63940654517806 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37159"],
        "coty_name": ["Rowan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rowan County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "01008583"
      },
      "bbox": [
        12.67128300444487, -2.2390919134475635, 13.16669956526829,
        -1.8785004549698183
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.926573460075334, -6.021082295741649],
            [8.943741055470838, -6.018654530664585],
            [8.940392635840555, -5.988661738908608],
            [8.943702455743763, -5.988909773019015],
            [8.945424392111772, -5.994885557701065],
            [8.949397153195543, -5.997115167590347],
            [8.954533199512792, -5.9973870087381105],
            [8.959386572743071, -6.000362130233106],
            [8.961781843487655, -6.006397586465694],
            [8.964530109764945, -6.023697149086371],
            [8.961984127646264, -6.024140792226482],
            [8.961658835856325, -6.030755544558061],
            [8.963808779468819, -6.0348731358540855],
            [8.963402644987301, -6.039366960782294],
            [8.96542843135776, -6.044901036133209],
            [8.971610384213058, -6.046668328537569],
            [8.977995904417913, -6.055321948742085],
            [8.98569063252514, -6.057340303994257],
            [9.034713692730021, -6.051234557913144],
            [9.049251204849524, -6.049257814156002],
            [9.154061260671213, -6.037770121916709],
            [9.202409491193286, -6.032789666507731],
            [9.337153171388746, -6.016512521034251],
            [9.352086008932467, -6.103454805637753],
            [9.366475028312362, -6.10175478883526],
            [9.367446251977865, -6.108886909251411],
            [9.352888585244107, -6.110606669371313],
            [9.354978499259287, -6.13105180387135],
            [9.360231162957069, -6.197650264059195],
            [9.363411400689786, -6.21465707562279],
            [9.365899164188269, -6.234223354609533],
            [9.337397675852683, -6.237975683672266],
            [9.336088063005885, -6.230087071118851],
            [9.329306618151884, -6.230936741113367],
            [9.33062565358954, -6.238930868739466],
            [9.30601856013473, -6.241348628300441],
            [9.295411288671936, -6.242918576138974],
            [9.297237731746332, -6.257149712746113],
            [9.282771248607936, -6.258899436551781],
            [9.27888959923023, -6.263829098543131],
            [9.27579284380527, -6.2611576950973],
            [9.240340043500003, -6.266147974569165],
            [9.23459120972728, -6.2663748248784135],
            [9.229877297781528, -6.27156751174222],
            [9.231512923397554, -6.2778797464457785],
            [9.228910010999241, -6.287349698441301],
            [9.22466737907769, -6.291704357439117],
            [9.223551502869237, -6.294819228615827],
            [9.223975844990305, -6.3042110092207455],
            [9.22079988198983, -6.310774433159039],
            [9.218742981322732, -6.312196344181659],
            [9.216350532013625, -6.317798855780395],
            [9.212641169179825, -6.320871439464604],
            [9.210446997522515, -6.328594682009573],
            [9.204667987911883, -6.3353467682951905],
            [9.202569058302293, -6.34181030069653],
            [9.198054756885558, -6.346648883973982],
            [9.198561375257823, -6.351265621368507],
            [9.19242205023139, -6.357109015768584],
            [9.193371804504368, -6.365772442284815],
            [9.190919006987091, -6.3690069535929625],
            [9.190053613308633, -6.374232362241275],
            [9.18737962356233, -6.380872309111046],
            [9.189579389969575, -6.3871927833419555],
            [9.188365332686377, -6.389026929882666],
            [9.076276019646842, -6.401034865005509],
            [9.07253781494497, -6.366589576722942],
            [9.067755000291863, -6.314677573771311],
            [8.988587696998488, -6.3231245501141835],
            [8.987113371327716, -6.3086184986943925],
            [8.983110187709356, -6.309121835117186],
            [8.982372274374171, -6.301992659985736],
            [8.979293530588253, -6.302215927207725],
            [8.972236016277225, -6.244404393718018],
            [8.95730117989623, -6.2459835998357045],
            [8.956264568554724, -6.23866242214479],
            [8.927330155557716, -6.24190348463497],
            [8.926536828623268, -6.234634751300713],
            [8.919628852767582, -6.235504215154527],
            [8.920094477328927, -6.239072559580723],
            [8.92373981416314, -6.2386769841188325],
            [8.923998565714829, -6.242276149523662],
            [8.902491324110684, -6.244667912361015],
            [8.902813586620162, -6.2478373994622896],
            [8.896010660759618, -6.248738826355003],
            [8.89639936593204, -6.252312119058912],
            [8.889257123631825, -6.253064779660638],
            [8.888894294170948, -6.249588217209792],
            [8.885283809473123, -6.249867994100102],
            [8.87488042842638, -6.159984289319474],
            [8.864076737936871, -6.0671904551145515],
            [8.86224655794283, -6.052196948806838],
            [8.872834029211356, -6.0506239235181605],
            [8.870530248853203, -6.029046782553076],
            [8.926573460075334, -6.021082295741649]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.71566540222558, "lat": 32.10051617515837 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01011"],
        "coty_name": ["Bullock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bullock County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00161531"
      },
      "bbox": [
        8.86224655794283, -6.401034865005509, 9.367446251977865,
        -5.988661738908608
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.106136235411796, -6.661189863589041],
            [9.140602942103296, -6.65740603363199],
            [9.177129654148276, -6.653451005327239],
            [9.23485903743445, -6.647514629373285],
            [9.296683333939601, -6.64049501612286],
            [9.34966340511555, -6.632419199838403],
            [9.420141595210819, -6.625426246624574],
            [9.427028146681662, -6.683450928165721],
            [9.434381819747808, -6.743555830277183],
            [9.438729297766237, -6.802656639837086],
            [9.442973356205416, -6.83629158713702],
            [9.445728780491265, -6.85468871960161],
            [9.447477205380173, -6.869119155415268],
            [9.451061235608048, -6.905061467929378],
            [9.45090896714775, -6.907024427762242],
            [9.453267251285776, -6.927187882131571],
            [9.45419655520919, -6.937872661956514],
            [9.456789512088424, -6.955652962429328],
            [9.39882237796139, -6.961156468941939],
            [9.402754419625884, -7.002013197166712],
            [9.3936319989846, -7.001688539425374],
            [9.387798236567788, -7.003177628309967],
            [9.383066274215416, -6.999896183166267],
            [9.376941983989928, -6.998481205281175],
            [9.369452879901452, -6.998151704251688],
            [9.36303969828018, -7.000900206070599],
            [9.360888169342454, -6.999228294531689],
            [9.351134217090989, -6.999699783658754],
            [9.3460316628407, -6.996974024688856],
            [9.336075483249585, -6.993976563345997],
            [9.323806596862898, -6.991967262429694],
            [9.316623297523831, -6.993142808146393],
            [9.31297828800068, -6.990785996318764],
            [9.300974481954158, -6.9866339926934735],
            [9.295258937123094, -6.9864100997566485],
            [9.288980363802532, -6.987509739111006],
            [9.286443578878073, -6.986246666819702],
            [9.277407611111737, -6.988840929012928],
            [9.273239174794053, -6.9864691943360056],
            [9.265878683147086, -6.990616603691483],
            [9.264074495939527, -6.98980141130629],
            [9.25516845294109, -6.993612466556157],
            [9.252855389564697, -6.993357240300068],
            [9.248049403057886, -6.997458280816296],
            [9.247899678640454, -7.001721931847531],
            [9.244785755892554, -7.007706288127718],
            [9.241714744415745, -7.009921435874526],
            [9.245667443942766, -7.014892893149322],
            [9.239709851444335, -7.027656656302486],
            [9.231992536750294, -7.030481926037644],
            [9.234102058479984, -7.037582269943333],
            [9.232029956260726, -7.0407665981250585],
            [9.232979397031674, -7.045255196984204],
            [9.229770769664402, -7.046842131602804],
            [9.232244781059865, -7.053139357838726],
            [9.23122747274899, -7.056784430258287],
            [9.225434587624205, -7.06294257077425],
            [9.221210958493307, -7.065900676114136],
            [9.218436625234986, -7.072934202490972],
            [9.149601181010922, -7.079151419574467],
            [9.143471875207373, -7.023950760537191],
            [9.13930333246189, -6.98288216627863],
            [9.136301862419863, -6.946599190020802],
            [9.13215724065357, -6.904334826841349],
            [9.130577288336907, -6.891704015622324],
            [9.11999559345396, -6.7906222619337555],
            [9.114465664614482, -6.737879304243742],
            [9.106136235411796, -6.661189863589041]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.61104897691365, "lat": 31.43181896545337 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01045"],
        "coty_name": ["Dale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dale County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00161548"
      },
      "bbox": [
        9.106136235411796, -7.079151419574467, 9.456789512088424,
        -6.625426246624574
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.707279815301675, -3.711351886731072],
            [7.713168003026056, -3.715610524151244],
            [7.716953369376792, -3.7200983010467428],
            [7.724729887587655, -3.7264022458182717],
            [7.739201029812118, -3.7333878198530743],
            [7.75189981875886, -3.7424669827849355],
            [7.755588408631031, -3.7434958188027214],
            [7.76046642069965, -3.7410299339282616],
            [7.767140652741675, -3.740077796278068],
            [7.773265907065223, -3.7424270055918862],
            [7.782385863156182, -3.7504903756168537],
            [7.78833119297126, -3.7540014775238126],
            [7.804647795714978, -3.7615354411483373],
            [7.821699027612276, -3.7742351526490525],
            [7.833513189156807, -3.7792110598565927],
            [7.864406940667209, -3.796879686310743],
            [7.8778441392338605, -3.8024075067169583],
            [7.8864019963105845, -3.803890755402505],
            [7.915753307449458, -3.810907905298063],
            [7.936212042669696, -3.8203625292268546],
            [7.944056118876851, -3.82117887684093],
            [7.9603320875655905, -3.8204814811964587],
            [7.976215369778751, -3.8223969157742212],
            [7.985879210913978, -3.8221381663149674],
            [7.999675557827535, -3.8184371522423457],
            [8.005756106402929, -3.814591863058935],
            [8.010000587046113, -3.808663984889517],
            [8.02957108194583, -3.7840738281422226],
            [8.038101186883598, -3.778385777621277],
            [8.043900446464638, -3.7771762251149763],
            [8.054582736015371, -3.7787363443080677],
            [8.061317695389626, -3.78157512526677],
            [8.067347624078488, -3.789439716042526],
            [8.068532206234453, -3.8012236687146563],
            [8.071706361685418, -3.8071474707690593],
            [8.077653962836616, -3.8111751697052196],
            [8.083112157448298, -3.812611417368159],
            [8.093209580366532, -3.812849494672609],
            [8.097354586542645, -3.8103779754563445],
            [8.101760755383527, -3.803998859349184],
            [8.104526656047161, -3.796920985043206],
            [8.116594901474196, -3.7819285110894603],
            [8.123720530199792, -3.777778548500699],
            [8.133229685508768, -3.774637165546748],
            [8.13893504322722, -3.7741363406744792],
            [8.144882568946752, -3.7749536033072033],
            [8.156997570897826, -3.7814822243747885],
            [8.163041883368606, -3.7863808675030626],
            [8.167422907567213, -3.792625354772648],
            [8.171344804299562, -3.8024252033438923],
            [8.171737713677363, -3.808063382059276],
            [8.169785958984406, -3.81032188649723],
            [8.170212396504644, -3.8142927068476085],
            [8.167116428785794, -3.885584515778893],
            [8.166284864506034, -3.908063164848809],
            [8.164474988603567, -3.9688282045555083],
            [8.163849786551738, -3.985586811059492],
            [8.169389179839856, -4.044486419265966],
            [8.169968886080005, -4.052071161779828],
            [8.12206655141738, -4.055910565998254],
            [8.09810770984811, -4.058407326376971],
            [8.09265197049816, -4.05843392610053],
            [8.047725564715012, -4.06216330003459],
            [8.015880647283653, -4.0644813562853646],
            [8.011569128824325, -4.065037558104826],
            [7.960230741612773, -4.069070744427475],
            [7.845775190717345, -4.076581768088682],
            [7.752548571103519, -4.0846332961932506],
            [7.7382369907288355, -4.0844803043036455],
            [7.73218023435647, -4.020470220972642],
            [7.729236887246513, -3.982299918565668],
            [7.723340316318568, -3.8988500491218545],
            [7.717963162944129, -3.8368303092535885],
            [7.715867592815135, -3.8099725599171443],
            [7.707279815301675, -3.711351886731072]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.85293182664331, "lat": 34.4534309161247 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01103"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00161578"
      },
      "bbox": [
        7.707279815301675, -4.0846332961932506, 8.171737713677363,
        -3.711351886731072
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.210106402101874, -4.927411045454684],
            [7.242073197446031, -4.926222495416539],
            [7.296367762858788, -4.925275559491697],
            [7.353907643524067, -4.918143510001088],
            [7.348803747469309, -4.8600293935939884],
            [7.377588908443465, -4.856634475738923],
            [7.374917239858825, -4.827489619987216],
            [7.413939545408557, -4.826731314432999],
            [7.444071000435762, -4.825235848085217],
            [7.4838588856787425, -4.822879662913867],
            [7.495580426989449, -4.8229971796582864],
            [7.546955137469392, -4.819963010969873],
            [7.561879113335242, -4.819147053091846],
            [7.590301152093394, -4.816444885590061],
            [7.591701411600111, -4.831062163852132],
            [7.634925239152439, -4.826798526262074],
            [7.641894884162977, -4.899946925996922],
            [7.684316911279043, -4.897310082374865],
            [7.6895362525307505, -4.903295256473964],
            [7.690451617984983, -4.906078650462503],
            [7.688419169007558, -4.911650638214336],
            [7.684665505584955, -4.913183158323562],
            [7.676849458390486, -4.909407696933112],
            [7.670031735370799, -4.9093494698307065],
            [7.667812343527384, -4.911739055057748],
            [7.668096944192719, -4.916852248432268],
            [7.671895678761503, -4.92579731752029],
            [7.6719740302193085, -4.930098059507559],
            [7.669614305445119, -4.932479209258646],
            [7.663378028313976, -4.933018816426109],
            [7.660885024024027, -4.9309509155061155],
            [7.6581855441484254, -4.924500247886179],
            [7.65225866531523, -4.923604340179764],
            [7.6473549044971065, -4.9265688246237636],
            [7.640677038998024, -4.922323368439817],
            [7.63648253389763, -4.921684332443297],
            [7.633366020028806, -4.924171663961989],
            [7.633386465830556, -4.929576663104191],
            [7.629813019716311, -4.940107151950569],
            [7.626550869612625, -4.945335229296402],
            [7.6316591733364145, -4.944942680922723],
            [7.6329068577183135, -4.959111310326243],
            [7.650664366520489, -4.958016877238941],
            [7.651719964954661, -4.972034290192777],
            [7.676609285078982, -4.970907409159221],
            [7.6780529960330846, -4.985754072773979],
            [7.6925402068937805, -4.985438885602255],
            [7.693042206184466, -4.992198198348076],
            [7.70394749994614, -4.991330365718624],
            [7.704663359836861, -4.998824379136304],
            [7.708832464096598, -4.998316083822541],
            [7.7097009807120545, -5.013193285401615],
            [7.723998825449698, -5.012326131734357],
            [7.72675309231079, -5.041570167611534],
            [7.740942759871771, -5.040313574097927],
            [7.741562884225485, -5.047792191516363],
            [7.755898055861361, -5.046651530741137],
            [7.75743897621586, -5.061658075074532],
            [7.771832247565928, -5.060439904350186],
            [7.774176411374807, -5.0822460343762135],
            [7.788617633574488, -5.081006642868124],
            [7.790104929260745, -5.095396221742397],
            [7.818976730071964, -5.093287102810026],
            [7.820719395986421, -5.108401538857653],
            [7.853190473888546, -5.10553674243508],
            [7.854187700926161, -5.116530742156704],
            [7.864888157220252, -5.115511547465351],
            [7.865207573015504, -5.119171656594145],
            [7.872557382323048, -5.11856340566833],
            [7.875313639038354, -5.14754008312291],
            [7.86630181737847, -5.148462301852804],
            [7.84597650518446, -5.175916408163119],
            [7.831539044336454, -5.176975847615183],
            [7.8299223287019535, -5.1629301076546055],
            [7.812125717233059, -5.164243198781951],
            [7.812303635765055, -5.167971349929513],
            [7.805252264292322, -5.168610212648638],
            [7.769642544938466, -5.208087411244435],
            [7.77563974386285, -5.273867675660498],
            [7.750314129567888, -5.275619617336206],
            [7.706961677950261, -5.2777696169552035],
            [7.686006198592707, -5.319062665550983],
            [7.687180322837411, -5.390589215738534],
            [7.688290732039537, -5.407150449610624],
            [7.602734808840108, -5.4177221901061365],
            [7.547195895686906, -5.421973094395081],
            [7.514683805826428, -5.424756926642681],
            [7.433704948528046, -5.431417453258658],
            [7.420305023732574, -5.431990347178763],
            [7.358574326022677, -5.435876100627823],
            [7.359031459780798, -5.428696351688894],
            [7.361532570765924, -5.424660241094795],
            [7.30407618207997, -5.4301673300096125],
            [7.260979539785748, -5.433473015803589],
            [7.258097445979745, -5.394198466114326],
            [7.254958552919115, -5.357298809546647],
            [7.248707950344678, -5.357730145927771],
            [7.246614214600322, -5.330237122829404],
            [7.244770141469402, -5.298042887007384],
            [7.236238840100669, -5.202952741718482],
            [7.235485923556345, -5.197966063396793],
            [7.233089032952948, -5.167748942922327],
            [7.2298073514349115, -5.130544057265454],
            [7.228990476234547, -5.12358919515982],
            [7.225490028345238, -5.081642383046241],
            [7.218826421219411, -5.0100701969239445],
            [7.21127620975804, -4.940703511082865],
            [7.210106402101874, -4.927411045454684]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.52511360903804, "lat": 33.28956232976029 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01125"],
        "coty_name": ["Tuscaloosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tuscaloosa County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00161588"
      },
      "bbox": [
        7.210106402101874, -5.435876100627823, 7.875313639038354,
        -4.816444885590061
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-16.415462262042244, -10.933462331000422],
              [-16.41453433123898, -10.932162387623467],
              [-16.411591638302927, -10.932536555346765],
              [-16.410454110637264, -10.931262941316833],
              [-16.41278785764246, -10.928622258702518],
              [-16.413835247414884, -10.928241380978378],
              [-16.41490643225164, -10.926358511276845],
              [-16.412214150566626, -10.924999125513546],
              [-16.411948610580044, -10.923765975853522],
              [-16.413798358578, -10.922637495395223],
              [-16.41304829885915, -10.92032144849193],
              [-16.410765695063674, -10.918784751505248],
              [-16.409303835060967, -10.92030965226058],
              [-16.408534255930043, -10.922912241763779],
              [-16.409274799748864, -10.92535208935762],
              [-16.408618914124588, -10.928396168591751],
              [-16.40963143202107, -10.93227772665431],
              [-16.411812601612795, -10.93527217739881],
              [-16.41438152012338, -10.935181018816133],
              [-16.41529013740357, -10.934707803781325],
              [-16.415462262042244, -10.933462331000422]
            ]
          ],
          [
            [
              [-16.418162597440965, -10.940614137204413],
              [-16.417791889834962, -10.939083969857093],
              [-16.416908196818312, -10.938322586542297],
              [-16.41539444901572, -10.939682503824386],
              [-16.414610935750087, -10.941319244013624],
              [-16.415034204703737, -10.942400159188345],
              [-16.417038480722447, -10.942063131104444],
              [-16.418162597440965, -10.940614137204413]
            ]
          ],
          [
            [
              [-16.422395932715197, -10.952316920987522],
              [-16.42046657319764, -10.951277388747181],
              [-16.420521945171703, -10.948722917623831],
              [-16.42204340949371, -10.947258464800337],
              [-16.42042309392735, -10.945992983537323],
              [-16.419383342172676, -10.94654099772979],
              [-16.417811392427648, -10.945773568315628],
              [-16.415730709719433, -10.948643125111708],
              [-16.41455735618588, -10.949305371466986],
              [-16.414047353222923, -10.952365671217333],
              [-16.414709553349436, -10.955961729352309],
              [-16.417064114195107, -10.957485550889956],
              [-16.41779873765159, -10.956544480057953],
              [-16.415506837807584, -10.955314483650858],
              [-16.415574014213142, -10.95436928762909],
              [-16.417585767331257, -10.952484257670035],
              [-16.41709176368067, -10.951212319136248],
              [-16.418799960412503, -10.951246393270443],
              [-16.420742402549106, -10.955052400718282],
              [-16.4215934744601, -10.95304653311122],
              [-16.422395932715197, -10.952316920987522]
            ]
          ],
          [
            [
              [-16.44055571040977, -10.976806966058533],
              [-16.43911336851497, -10.976504598539321],
              [-16.437309699587484, -10.97750093928093],
              [-16.436357572562418, -10.97857485283691],
              [-16.43682187001773, -10.980632478323145],
              [-16.43789988550241, -10.981676203890185],
              [-16.43884349161901, -10.978905730609249],
              [-16.440074639414725, -10.978635849887887],
              [-16.44055571040977, -10.976806966058533]
            ]
          ],
          [
            [
              [-16.447185298490606, -11.005330405589673],
              [-16.445483295105305, -11.005094333179455],
              [-16.445248849894543, -11.006384351283517],
              [-16.446807958660525, -11.00625889251778],
              [-16.447185298490606, -11.005330405589673]
            ]
          ],
          [
            [
              [-16.456399360511703, -11.036335183145841],
              [-16.454613571928935, -11.035648189456017],
              [-16.45463859770756, -11.037222787684426],
              [-16.456399360511703, -11.036335183145841]
            ]
          ],
          [
            [
              [-16.46286219677816, -11.018805693892858],
              [-16.461697608144874, -11.019004301055435],
              [-16.46153683295484, -11.016580148161829],
              [-16.462998699611944, -11.013987840969984],
              [-16.46326423245075, -11.009999272888727],
              [-16.46279843235379, -11.008012690273459],
              [-16.461485850922823, -11.009065682000916],
              [-16.46070505757868, -11.011109011658919],
              [-16.460962798554863, -11.012764348839106],
              [-16.460029177042983, -11.015026222212407],
              [-16.460164776512006, -11.01712950082361],
              [-16.459783748788514, -11.018698766727201],
              [-16.458815220169242, -11.020094004551696],
              [-16.459991658511775, -11.023859769453624],
              [-16.456957696877545, -11.0237554087076],
              [-16.456162187051167, -11.022564980644841],
              [-16.4550177542516, -11.019028887093214],
              [-16.45439430545164, -11.020081561907926],
              [-16.45503700293063, -11.023539953379752],
              [-16.452963301355513, -11.025592999403562],
              [-16.452060933602095, -11.02530664637824],
              [-16.451486255709142, -11.022216052583484],
              [-16.45067527228784, -11.026036566411092],
              [-16.451048044826535, -11.028704852443644],
              [-16.44963103332709, -11.029888793971194],
              [-16.45157411719153, -11.031155318508278],
              [-16.453979349304788, -11.02898609335704],
              [-16.454245382694296, -11.02777275585421],
              [-16.453566138463604, -11.026908329783613],
              [-16.454058428601353, -11.025755276343267],
              [-16.45548075559577, -11.025163853313938],
              [-16.457414193427788, -11.025881115230515],
              [-16.45999298370583, -11.02591043750275],
              [-16.461105831547222, -11.025116339263969],
              [-16.461241452752446, -11.02239129114186],
              [-16.46024441646253, -11.022144736481971],
              [-16.460237024493832, -11.02018556911078],
              [-16.461561042623686, -11.020361912865862],
              [-16.46286219677816, -11.018805693892858]
            ]
          ],
          [
            [
              [-16.47765816741395, -10.935242487307029],
              [-16.477279677436403, -10.932501216624384],
              [-16.476735871666065, -10.932586668029206],
              [-16.476804108638856, -10.937533667897625],
              [-16.47746810076214, -10.937491765366067],
              [-16.47765816741395, -10.935242487307029]
            ]
          ],
          [
            [
              [-16.474005145727368, -11.014186283830094],
              [-16.472398794845436, -11.014706629594167],
              [-16.47166793207947, -11.016256781193357],
              [-16.4726753859393, -11.017834133209428],
              [-16.474005145727368, -11.014186283830094]
            ]
          ],
          [
            [
              [-16.494483512949472, -11.017453297640804],
              [-16.49397730983917, -11.017173398622512],
              [-16.4923654863834, -11.018774062608724],
              [-16.491608571740848, -11.02011668872169],
              [-16.487235703176044, -11.024201665120277],
              [-16.486062049221307, -11.024833984272203],
              [-16.484929757150958, -11.027751242981427],
              [-16.481803144695338, -11.031956441181686],
              [-16.480562842721223, -11.035865084548137],
              [-16.47786052844741, -11.03930947851191],
              [-16.47868531606966, -11.04019214896373],
              [-16.480416470798275, -11.038119697703706],
              [-16.48267659475451, -11.03597636399566],
              [-16.485634235779887, -11.032444221069296],
              [-16.485072832709452, -11.031060118658067],
              [-16.48726732135736, -11.030552716330627],
              [-16.487953779269617, -11.029018032834735],
              [-16.489368509782402, -11.027902213216091],
              [-16.489165115766166, -11.026167280251533],
              [-16.489730268505703, -11.025206481331775],
              [-16.49197843289834, -11.024494988476471],
              [-16.492190804722934, -11.023470869855862],
              [-16.491299768698706, -11.02264854217248],
              [-16.491571036867203, -11.021358561210288],
              [-16.493452557388142, -11.021122081085402],
              [-16.493828873402258, -11.01851176335379],
              [-16.494483512949472, -11.017453297640804]
            ]
          ],
          [
            [
              [-16.59311434650754, -11.128381695378975],
              [-16.591428679158874, -11.128272117725885],
              [-16.591618770208683, -11.12673575197592],
              [-16.590734713222886, -11.125894794817695],
              [-16.58830184826331, -11.126309271813822],
              [-16.586540303623444, -11.126048604386396],
              [-16.584275362432788, -11.127244438032326],
              [-16.582917672104525, -11.126565714573871],
              [-16.583925538280578, -11.124404837982134],
              [-16.581959470763906, -11.124027951931025],
              [-16.581190901324163, -11.123025693334634],
              [-16.580291098509097, -11.124377163970431],
              [-16.581311446065026, -11.125414039879324],
              [-16.580813576040065, -11.127518912110046],
              [-16.582527750586376, -11.128634985321273],
              [-16.582757928845112, -11.129817842121426],
              [-16.58156898970702, -11.131802866381017],
              [-16.582719904598235, -11.134310808775503],
              [-16.58176448139062, -11.135890653630044],
              [-16.581881353248274, -11.137214807466878],
              [-16.58287931001375, -11.137916439137987],
              [-16.584589929458758, -11.136836584033707],
              [-16.58652135994668, -11.136730234581139],
              [-16.586516707063677, -11.135663403607523],
              [-16.587636341544616, -11.13492828819533],
              [-16.588950458797157, -11.13526961045656],
              [-16.59032931040955, -11.137517452207879],
              [-16.591724296240816, -11.13677545805822],
              [-16.591544267218463, -11.134653896279492],
              [-16.590854665442368, -11.133342099107079],
              [-16.588042708895752, -11.13254536552337],
              [-16.584081213820042, -11.133798117260664],
              [-16.5828878732306, -11.133190700450632],
              [-16.582979630822976, -11.131920152256336],
              [-16.5839924246271, -11.131200712219593],
              [-16.58493234123278, -11.128742403234712],
              [-16.586770080137597, -11.128777787638548],
              [-16.588145494858804, -11.127993758832153],
              [-16.588920718122573, -11.128891955135265],
              [-16.59011517924088, -11.128704251848301],
              [-16.592656005713053, -11.129799693740171],
              [-16.59311434650754, -11.128381695378975]
            ]
          ],
          [
            [
              [-16.651665146317757, -11.149344509489424],
              [-16.65038878541051, -11.14861416897732],
              [-16.649589072280087, -11.149370938015467],
              [-16.647571297808334, -11.148227978976212],
              [-16.647361447513497, -11.147339365806058],
              [-16.648403660905117, -11.145966698667456],
              [-16.6518905236549, -11.144794614380439],
              [-16.651084549133714, -11.143125034992497],
              [-16.651140447114614, -11.141998301086694],
              [-16.648500706887713, -11.143168716858364],
              [-16.647328959010036, -11.142903334694244],
              [-16.646035553307506, -11.139996975585294],
              [-16.647545625538925, -11.138564427573865],
              [-16.646295786026908, -11.137333421262632],
              [-16.645783567043612, -11.134048022829127],
              [-16.643032456937664, -11.131574575012898],
              [-16.641261076317708, -11.131488571497396],
              [-16.640137098088505, -11.12612754885893],
              [-16.63780427734237, -11.123799712842725],
              [-16.638421787290486, -11.123287057467117],
              [-16.64143338697015, -11.123058114704008],
              [-16.640794781873225, -11.121481960082743],
              [-16.6413067853906, -11.119711255905086],
              [-16.64036713296249, -11.11908119821078],
              [-16.63991648566774, -11.117138622441384],
              [-16.64064125986783, -11.115337573484052],
              [-16.639544068599214, -11.114490937514612],
              [-16.634779323845894, -11.116845407865492],
              [-16.63102114045694, -11.117661383698284],
              [-16.629076704898107, -11.117690183665859],
              [-16.62755927352652, -11.118449904224311],
              [-16.62677393700981, -11.119746779398024],
              [-16.62403371650607, -11.12207372272291],
              [-16.62385391155379, -11.123902564643483],
              [-16.622346927021013, -11.125247192255808],
              [-16.622942476631227, -11.125987376257104],
              [-16.625887967474597, -11.125424529726413],
              [-16.624688103165937, -11.127370107685659],
              [-16.624975561775177, -11.128345318375485],
              [-16.624152647119082, -11.130351781816454],
              [-16.623206092128044, -11.131474684000901],
              [-16.624617383402466, -11.13279951733744],
              [-16.624888795731177, -11.13490312137436],
              [-16.624491805437984, -11.136848363640919],
              [-16.626166810762204, -11.138813877314963],
              [-16.628516149726636, -11.138387219586159],
              [-16.628812846970803, -11.139196379464417],
              [-16.630683551321155, -11.140669127056537],
              [-16.63169284555367, -11.143270645128787],
              [-16.631727911146076, -11.147540449451828],
              [-16.632753321862403, -11.14901378889193],
              [-16.633605499801263, -11.151399860269679],
              [-16.634813360457606, -11.152631071034028],
              [-16.63468632242545, -11.153462330647049],
              [-16.636860348301756, -11.154029493968967],
              [-16.638474752678636, -11.155615564037692],
              [-16.638609871204476, -11.15712973008016],
              [-16.64155034072552, -11.159324716481025],
              [-16.643803328752774, -11.158344747977123],
              [-16.64276242947887, -11.155447027056093],
              [-16.640217958232395, -11.153816377491314],
              [-16.640815660441227, -11.152045215286607],
              [-16.643504904972485, -11.151631374276446],
              [-16.64712974550384, -11.154527202156036],
              [-16.649126465291683, -11.154413507681296],
              [-16.65163771890206, -11.153319584336723],
              [-16.651384400643455, -11.151591223272609],
              [-16.65204215159299, -11.150283084585737],
              [-16.651665146317757, -11.149344509489424]
            ]
          ],
          [
            [
              [-16.78611078956583, -11.08468411020428],
              [-16.784166665271997, -11.08382253821047],
              [-16.78439673723462, -11.0822092230127],
              [-16.78317555454136, -11.082247276210312],
              [-16.78254684139207, -11.081101401979492],
              [-16.78103335485352, -11.08108700543209],
              [-16.779854737969405, -11.083288390759815],
              [-16.779963703791772, -11.085912669712863],
              [-16.779686064643894, -11.087649358943269],
              [-16.781302448887384, -11.088291793301131],
              [-16.78323009871032, -11.08740653214221],
              [-16.78582389078008, -11.085588818555893],
              [-16.78611078956583, -11.08468411020428]
            ]
          ],
          [
            [
              [-16.783455046606882, -11.213990487623423],
              [-16.78148987736854, -11.214212675524017],
              [-16.779937430266525, -11.213651200701179],
              [-16.778523493632814, -11.213914217708213],
              [-16.77673676047481, -11.21502490540945],
              [-16.776064296817957, -11.214811010917451],
              [-16.77325396243929, -11.215967284800705],
              [-16.7726192730397, -11.216973474075115],
              [-16.769285185921877, -11.218445773402987],
              [-16.76685155935615, -11.21810179795458],
              [-16.765615610650578, -11.21868556897143],
              [-16.766570976622628, -11.220361680925757],
              [-16.766589129836614, -11.22206566879233],
              [-16.765696401994408, -11.223650978747646],
              [-16.765804975995973, -11.225758679968873],
              [-16.766313776440416, -11.226892675621302],
              [-16.76736867642853, -11.227142919143573],
              [-16.770142955064063, -11.226448261203627],
              [-16.770918177073145, -11.22567815324855],
              [-16.773385250720796, -11.225202246343946],
              [-16.774939238244226, -11.224103380772842],
              [-16.777241150971197, -11.221266031555588],
              [-16.78012508449576, -11.221540318553668],
              [-16.78173217413363, -11.220695282606865],
              [-16.78249551807901, -11.219650953045937],
              [-16.782725649005016, -11.217515499952087],
              [-16.782063931855934, -11.21589388352857],
              [-16.783455046606882, -11.213990487623423]
            ]
          ],
          [
            [
              [-16.7883346921712, -11.090268677454917],
              [-16.78710466629163, -11.089335381421062],
              [-16.783546070688413, -11.08967922299996],
              [-16.7833952997956, -11.090332569726437],
              [-16.788035452527385, -11.091248514611785],
              [-16.7883346921712, -11.090268677454917]
            ]
          ],
          [
            [
              [-16.81831348511941, -11.226101174040453],
              [-16.817283575502426, -11.223900878220576],
              [-16.815385995641332, -11.222785331956867],
              [-16.814678567407363, -11.221121752183556],
              [-16.81111827291055, -11.221315930456653],
              [-16.808765651012408, -11.224031497789834],
              [-16.80670071442353, -11.224632908601432],
              [-16.80562875543041, -11.224259679422468],
              [-16.804361603722228, -11.225161703255704],
              [-16.80315814373173, -11.224888489570738],
              [-16.802701581094297, -11.227501641236431],
              [-16.803579278906252, -11.229719987854175],
              [-16.806581885067676, -11.232685454417368],
              [-16.808966937328815, -11.231505195225918],
              [-16.810470185966977, -11.231156851786658],
              [-16.813468330107842, -11.231890314308107],
              [-16.815943476078125, -11.231153714362408],
              [-16.81597593673927, -11.230229208638793],
              [-16.81731181889375, -11.227350584299682],
              [-16.81831348511941, -11.226101174040453]
            ]
          ],
          [
            [
              [-16.846656521498225, -11.21323084985879],
              [-16.843639461525026, -11.210115833304549],
              [-16.841108249411135, -11.209794726839046],
              [-16.83846816603046, -11.206758874981809],
              [-16.83645247852873, -11.2053638330869],
              [-16.833479169207006, -11.205319899806582],
              [-16.831719278930013, -11.206258391052916],
              [-16.830421516207608, -11.208640731719829],
              [-16.830355845443446, -11.210085850784035],
              [-16.832188761396306, -11.214679979094427],
              [-16.83109533155316, -11.21549350468616],
              [-16.83102155195391, -11.219142560670145],
              [-16.833197669296474, -11.219981648726138],
              [-16.833987533959153, -11.2193666950313],
              [-16.835806326975593, -11.219142326758604],
              [-16.837936044960802, -11.21741875946713],
              [-16.840033160762992, -11.216726254909913],
              [-16.843425415271355, -11.217145051584728],
              [-16.8455281848839, -11.216364569681211],
              [-16.84563932747791, -11.214624429045546],
              [-16.846656521498225, -11.21323084985879]
            ]
          ],
          [
            [
              [-16.382577736094, -10.605233117168664],
              [-16.381882079754163, -10.614290854137673],
              [-16.382524757012835, -10.614338157974021],
              [-16.38023532619764, -10.644177494873333],
              [-16.345973808428734, -10.641598529766847],
              [-16.33058780055437, -10.64041002630968],
              [-16.315549363777038, -10.639239057313118],
              [-16.31532250600697, -10.642037691414968],
              [-16.315916716261935, -10.643119174168946],
              [-16.31733630681349, -10.644157415852257],
              [-16.317900794527052, -10.645208656593411],
              [-16.318424730750472, -10.65024502350266],
              [-16.31801961776841, -10.65122035453544],
              [-16.318866366027937, -10.655800560029123],
              [-16.317817221050554, -10.656685262264373],
              [-16.316331462630547, -10.653947832759018],
              [-16.31442706197856, -10.652902203686601],
              [-16.314059903865914, -10.65736743919536],
              [-16.314725686530842, -10.656158574928906],
              [-16.31608672355563, -10.655943779357724],
              [-16.3179628147301, -10.65838986777917],
              [-16.32223462504716, -10.662435662681158],
              [-16.32313501460658, -10.66589440326914],
              [-16.322205338053603, -10.666305708521728],
              [-16.318534563103906, -10.661862365136221],
              [-16.31759722833329, -10.6618691598447],
              [-16.317366037649204, -10.66519864637005],
              [-16.31852648796117, -10.667953024239015],
              [-16.317636080448, -10.669376052656549],
              [-16.31669029104472, -10.667485424386312],
              [-16.315757859808777, -10.66692755566454],
              [-16.31507514475689, -10.664816097971029],
              [-16.313651051055206, -10.662359634568864],
              [-16.30886308338853, -10.72065972212618],
              [-16.310265550211472, -10.724538273809626],
              [-16.31244147770412, -10.726138985385282],
              [-16.314306871645854, -10.730231013852121],
              [-16.316494049135027, -10.732309914108058],
              [-16.317904139103042, -10.734124553181347],
              [-16.317707251754847, -10.735286147614776],
              [-16.316202701643878, -10.73664923880714],
              [-16.315310279622977, -10.738548162037967],
              [-16.315964242878678, -10.739330155723867],
              [-16.31267730424064, -10.740411562507802],
              [-16.309351105979392, -10.737956748705768],
              [-16.3094568047902, -10.735164215383302],
              [-16.309006876252198, -10.734438966414565],
              [-16.307837965761582, -10.748696557306934],
              [-16.290550540593767, -10.7473199554592],
              [-16.28213322825255, -10.846666121421679],
              [-16.283691259401568, -10.84679087791266],
              [-16.28182533810641, -10.868927643356741],
              [-16.28435869463161, -10.8690570847995],
              [-16.280770375573162, -10.911542795642532],
              [-16.290375910511642, -10.917303252530424],
              [-16.295112110625546, -10.918668134048136],
              [-16.29590660422596, -10.918264158275292],
              [-16.295842803013826, -10.91499350970201],
              [-16.294891548884593, -10.913640996234227],
              [-16.295711718259998, -10.912016173575912],
              [-16.297362113798428, -10.910930907334107],
              [-16.298928680019454, -10.910868775804822],
              [-16.300963791461406, -10.911955869153426],
              [-16.301874506237027, -10.913004636972222],
              [-16.303997290073127, -10.913573732930063],
              [-16.30557435915666, -10.912830468588655],
              [-16.30458807414943, -10.910653802616926],
              [-16.305955138909393, -10.91022527168487],
              [-16.30745518744083, -10.90840643768603],
              [-16.309093939109495, -10.907442630567072],
              [-16.312524172196206, -10.906967907915034],
              [-16.316130460137046, -10.90792668280961],
              [-16.318618671893923, -10.909601048226632],
              [-16.319706975559658, -10.914645867455214],
              [-16.32058258705949, -10.915250886258665],
              [-16.321408477686834, -10.917168624795075],
              [-16.32278357015546, -10.91768616201423],
              [-16.324280282923475, -10.919820049125901],
              [-16.325045407710597, -10.919363327191785],
              [-16.32798288487892, -10.920143772623282],
              [-16.33067661603954, -10.919792239202927],
              [-16.33248822727623, -10.918734595457941],
              [-16.332677938036515, -10.917687466083466],
              [-16.331509728252414, -10.916085154544817],
              [-16.33274470990263, -10.914943249973799],
              [-16.335547520580665, -10.913178327907406],
              [-16.336634101045703, -10.911262966418091],
              [-16.33688786284741, -10.909882226285905],
              [-16.338149541419835, -10.910244825857427],
              [-16.33844275048481, -10.90888779443771],
              [-16.338302395351267, -10.90589300890272],
              [-16.33948785863129, -10.904829791967066],
              [-16.345103636897278, -10.904284184174474],
              [-16.34667189526965, -10.904710012161278],
              [-16.347025459983186, -10.906320642944713],
              [-16.34860195345078, -10.906644045946084],
              [-16.349806479539975, -10.908688784931595],
              [-16.351083972146785, -10.909792217350864],
              [-16.351912793134865, -10.911726763842408],
              [-16.353596966087355, -10.912284015316667],
              [-16.356269003357962, -10.913798891113231],
              [-16.35746388508121, -10.913739288780864],
              [-16.358575302877476, -10.912754258235209],
              [-16.35831992896162, -10.908742556118252],
              [-16.359265239555, -10.90780405542076],
              [-16.362210803238938, -10.907629508404565],
              [-16.364861597919727, -10.912165734586322],
              [-16.36795945042886, -10.91274143070875],
              [-16.369571173123628, -10.912611682948855],
              [-16.370874132193176, -10.911883021943702],
              [-16.371132418688166, -10.909555751929046],
              [-16.372133181706353, -10.90897004529739],
              [-16.375240336069737, -10.909688798576324],
              [-16.37528863009096, -10.90713772965807],
              [-16.374835302780806, -10.905935786428268],
              [-16.375255093830205, -10.903662657650898],
              [-16.37420303800491, -10.90327803804121],
              [-16.374289703137144, -10.901647403063878],
              [-16.372180867507204, -10.898936841641612],
              [-16.36969087754526, -10.89916726636163],
              [-16.37074189839104, -10.89597527030422],
              [-16.368550377853953, -10.892815034438074],
              [-16.36808168536818, -10.89050034878057],
              [-16.3670224303435, -10.89214899732356],
              [-16.365749734906103, -10.89195323872303],
              [-16.366076740318142, -10.888463946676861],
              [-16.36310922187501, -10.886448205378247],
              [-16.36364253283687, -10.884711818826958],
              [-16.362435888719187, -10.883657962675118],
              [-16.3620218167868, -10.882510717345736],
              [-16.362401848044417, -10.881043331867167],
              [-16.367021218965757, -10.877650615331246],
              [-16.368191311887305, -10.877817767225796],
              [-16.37240465957335, -10.881850651951813],
              [-16.373563558945968, -10.882211881820082],
              [-16.377068603869102, -10.881952214346212],
              [-16.378671256605124, -10.882991887767217],
              [-16.37833500883475, -10.884712563191114],
              [-16.379777250534445, -10.887075427705074],
              [-16.381864431207422, -10.886917243496722],
              [-16.384094555129717, -10.888186175713344],
              [-16.384271306713163, -10.88963785704117],
              [-16.3837224422343, -10.891240290920084],
              [-16.38440379605653, -10.893528515813978],
              [-16.385435504193484, -10.895267485949072],
              [-16.38594204129046, -10.897152182986899],
              [-16.388427112167946, -10.897534776957212],
              [-16.389332199080062, -10.895400627785378],
              [-16.390861304742423, -10.896351514147701],
              [-16.3902883097622, -10.897646682665213],
              [-16.390603229781327, -10.899292661453936],
              [-16.389355550718893, -10.90241080748801],
              [-16.39043371969696, -10.90328948312572],
              [-16.393191215156623, -10.90422501769621],
              [-16.393628327005416, -10.905633550523971],
              [-16.393048379462453, -10.906456202013963],
              [-16.39019300692062, -10.90543141406379],
              [-16.39071615853559, -10.908491868573883],
              [-16.39278121688582, -10.910098726829721],
              [-16.39276512649807, -10.91258715776435],
              [-16.39429792503048, -10.915514555304712],
              [-16.395245320297935, -10.915642922888043],
              [-16.396273298492652, -10.916950370518611],
              [-16.395360468551242, -10.917483038736819],
              [-16.392420409214825, -10.916719737156178],
              [-16.391270497188273, -10.917259547539494],
              [-16.390732352003447, -10.918741161774822],
              [-16.391338852081372, -10.919834142470924],
              [-16.392748436302277, -10.919624974576925],
              [-16.394319236274633, -10.920909341403375],
              [-16.393896827076496, -10.921847587685447],
              [-16.394447137560814, -10.923430616140369],
              [-16.39569221879323, -10.924054031300761],
              [-16.395694045104626, -10.92545448150146],
              [-16.396545502522212, -10.9266265912821],
              [-16.39874354909606, -10.92818186243299],
              [-16.399641398085674, -10.929583815225133],
              [-16.396850138283398, -10.931304672170981],
              [-16.395032551150894, -10.929095620955165],
              [-16.393524314844594, -10.929215863386155],
              [-16.393455746449092, -10.931142547037334],
              [-16.395252859715928, -10.93121278036141],
              [-16.394874319939774, -10.932690518023373],
              [-16.39595926551128, -10.932952554275111],
              [-16.396255771823427, -10.934601560400168],
              [-16.39511904649996, -10.93474884313837],
              [-16.397635936648026, -10.937110576041661],
              [-16.39855800442214, -10.938474101902214],
              [-16.399636159634028, -10.938837982585222],
              [-16.399965924620375, -10.940902723821052],
              [-16.398305365695926, -10.943385299062678],
              [-16.39998086288642, -10.945008510657416],
              [-16.40184984950261, -10.944829481595841],
              [-16.4024768982003, -10.943944711801423],
              [-16.401067773779705, -10.94238195397634],
              [-16.402909853029286, -10.939973926099093],
              [-16.402567712318792, -10.938362479151904],
              [-16.40419698623472, -10.937156338909622],
              [-16.402676184459214, -10.935999160089416],
              [-16.40320055515622, -10.934221915300363],
              [-16.402350825242426, -10.932719926724726],
              [-16.403942433355738, -10.930873186460678],
              [-16.40502794235815, -10.927781732908585],
              [-16.405345232327562, -10.924132211982402],
              [-16.404487163038855, -10.922178047820639],
              [-16.40472090751268, -10.920670599883856],
              [-16.404318751641714, -10.919325311912123],
              [-16.405776703643916, -10.917286111643438],
              [-16.40541163342699, -10.916293408251336],
              [-16.405751556119633, -10.913024693682722],
              [-16.403699116937556, -10.9106395501636],
              [-16.40520931034661, -10.909880925643272],
              [-16.40515337878082, -10.907203283537942],
              [-16.405764839445755, -10.906793508343982],
              [-16.408433159658774, -10.909858140060962],
              [-16.410025693118484, -10.909392722367258],
              [-16.409958103122833, -10.906282759459096],
              [-16.41041732305416, -10.90292082036649],
              [-16.409664018231773, -10.900835380809227],
              [-16.405575057598238, -10.897633104633748],
              [-16.405060006718813, -10.897001265496073],
              [-16.405088379673217, -10.894887239713377],
              [-16.409469493640653, -10.895746844388931],
              [-16.41246746602069, -10.897659529755455],
              [-16.41315614095984, -10.896741510000401],
              [-16.412997563364073, -10.895477545982502],
              [-16.413485953266232, -10.893005249467654],
              [-16.414034050675067, -10.886205871501286],
              [-16.41519110145825, -10.882485753662051],
              [-16.415843644490888, -10.876872387553853],
              [-16.415398328864647, -10.876144389454625],
              [-16.416160949395927, -10.873305848489053],
              [-16.418397504882176, -10.87128677061688],
              [-16.41880423872995, -10.869941281897441],
              [-16.420820921659573, -10.86837878604073],
              [-16.42033219038138, -10.866808187731385],
              [-16.420445948413914, -10.864316696095337],
              [-16.420182043904752, -10.860775086361814],
              [-16.42177591917655, -10.858734133791515],
              [-16.4240555287076, -10.859852817244619],
              [-16.426395627256003, -10.85982823952553],
              [-16.427993730766804, -10.860346590741702],
              [-16.430361913326724, -10.858746681566014],
              [-16.4319952467872, -10.861416742069753],
              [-16.433383584950533, -10.861981688334353],
              [-16.43242726696783, -10.864108715878276],
              [-16.43258960253136, -10.866516443926823],
              [-16.434215037116502, -10.868142405467523],
              [-16.43344633622043, -10.87276527786999],
              [-16.43347401054708, -10.874589365489346],
              [-16.432183581367283, -10.875855480542546],
              [-16.431766686804117, -10.87795972833713],
              [-16.432931525586255, -10.879084562172812],
              [-16.43304870033944, -10.882148562141099],
              [-16.431908894206757, -10.885188543572713],
              [-16.43255269314139, -10.886120087014923],
              [-16.432638137255143, -10.889795690641419],
              [-16.430734745741113, -10.892089601217593],
              [-16.429897710156283, -10.892484622522446],
              [-16.427036878154293, -10.896274883715078],
              [-16.42586550394493, -10.896400713309523],
              [-16.422233273482842, -10.902255265098043],
              [-16.421716911556626, -10.902507727513651],
              [-16.42125973637149, -10.906320275474075],
              [-16.425749905875573, -10.90570116027943],
              [-16.428793231346553, -10.908518335777506],
              [-16.429311728281363, -10.913571221764435],
              [-16.430101007505964, -10.917142224850908],
              [-16.430933731333223, -10.919214997610228],
              [-16.43084985342341, -10.921040233966576],
              [-16.43140730460327, -10.923940456656714],
              [-16.43202238282099, -10.925072076314622],
              [-16.432610873258344, -10.928571034121441],
              [-16.433218784737, -10.929703446435354],
              [-16.435609329935925, -10.92885450186114],
              [-16.43563268405959, -10.927620679143839],
              [-16.43693644305824, -10.925628200100473],
              [-16.43862188193068, -10.925328995977958],
              [-16.441083453427243, -10.925843245987695],
              [-16.443701872824466, -10.92726698837253],
              [-16.445562506293793, -10.92910503185447],
              [-16.44779132778356, -10.932732631894483],
              [-16.44882138937587, -10.933500911377822],
              [-16.450887630572574, -10.937097680537041],
              [-16.45057541722385, -10.938931588862019],
              [-16.44933576517553, -10.940004146114946],
              [-16.448200705114537, -10.93984719852507],
              [-16.44793546271917, -10.942509008495266],
              [-16.44812875097293, -10.94456279856347],
              [-16.451375412075024, -10.944322451624386],
              [-16.452514859671517, -10.945036268076024],
              [-16.452322506315436, -10.95063291857788],
              [-16.451006795473244, -10.950051394781099],
              [-16.450475136026, -10.952657290498827],
              [-16.4530956013668, -10.952457190352687],
              [-16.45447791482098, -10.953909075103434],
              [-16.453755835477818, -10.955172096120126],
              [-16.45376411191397, -10.956441973402695],
              [-16.45581471044688, -10.957896440261012],
              [-16.457803474804603, -10.960894734590212],
              [-16.45892477438092, -10.964394664337927],
              [-16.45883651471084, -10.966949564094287],
              [-16.45733295398365, -10.968504315777343],
              [-16.45361233952312, -10.969481104776225],
              [-16.454604511450004, -10.971797702283341],
              [-16.453303585565582, -10.972808327284994],
              [-16.45235141192566, -10.97576343256445],
              [-16.453108562241464, -10.97661888345503],
              [-16.452503272641525, -10.978460780828549],
              [-16.451203194970077, -10.978592273490792],
              [-16.452171903363247, -10.98180956597886],
              [-16.451587188860596, -10.983343048878755],
              [-16.448085644669018, -10.982865750994922],
              [-16.447118917738667, -10.98201629264828],
              [-16.44876976464932, -10.980801087612567],
              [-16.44731593405395, -10.980044129458461],
              [-16.44692713049109, -10.97869506443577],
              [-16.443781898365213, -10.977309602873248],
              [-16.442160811675482, -10.979001398374878],
              [-16.44198865741738, -10.980292839641972],
              [-16.44304281381688, -10.980775901880442],
              [-16.444079033016376, -10.979686298429407],
              [-16.445540804800963, -10.980630503352206],
              [-16.444787506117535, -10.98186295695065],
              [-16.444035264247006, -10.984605961243604],
              [-16.442065046198458, -10.984972297485747],
              [-16.44214837487357, -10.986198325249916],
              [-16.44448314134633, -10.988152495376008],
              [-16.44624601846171, -10.987151326914303],
              [-16.446989324988806, -10.988524318734688],
              [-16.445346410389227, -10.990216834613506],
              [-16.443517762201132, -10.989723810187112],
              [-16.442616919973112, -10.99065778632999],
              [-16.44386365582055, -10.994155324714248],
              [-16.443035459767234, -10.995550368570719],
              [-16.441719322635826, -10.995815383323446],
              [-16.43784932497214, -10.993033118778207],
              [-16.44030263010248, -10.997543981201673],
              [-16.438927265599922, -10.999275509761963],
              [-16.439065460059776, -11.00092094076963],
              [-16.438779181715912, -11.00386480495291],
              [-16.44035911166969, -11.002519069606441],
              [-16.441868811471224, -10.998827846543007],
              [-16.441703730901313, -10.997263982150294],
              [-16.443039129912126, -10.99610951345395],
              [-16.44494412818807, -10.996110873217232],
              [-16.445288118927827, -10.996899422703878],
              [-16.44714396483843, -10.997932357218305],
              [-16.44797805188614, -11.00014097122537],
              [-16.449733871504623, -10.999572533797826],
              [-16.448309523203555, -10.996186570259674],
              [-16.447672169013526, -10.995710009616177],
              [-16.448978252833854, -10.992814460970346],
              [-16.44889861710295, -10.991215520668733],
              [-16.44961157025832, -10.990268813689225],
              [-16.451908621541165, -10.990025512852688],
              [-16.453754073180292, -10.992443114051097],
              [-16.452927203480375, -10.994769623332338],
              [-16.45318401191371, -10.99561445259619],
              [-16.454989040232174, -10.997409064002289],
              [-16.45578801834079, -10.997046856590067],
              [-16.455689181369767, -10.994783567530261],
              [-16.457921837663445, -10.994886719830397],
              [-16.459871853191178, -10.993894985975228],
              [-16.459361409811883, -10.992632344559047],
              [-16.457873681734362, -10.991551513321289],
              [-16.45677096231765, -10.99208010641684],
              [-16.45436809161686, -10.991096388957232],
              [-16.454280614346995, -10.989600699619297],
              [-16.456614763740216, -10.987869269167403],
              [-16.455859342449028, -10.986972092924805],
              [-16.45336828028168, -10.98916875256025],
              [-16.451678617819482, -10.988479348001949],
              [-16.449624632504946, -10.98884183620738],
              [-16.448478942537122, -10.9866148557376],
              [-16.44907107745891, -10.9852883458177],
              [-16.450916046864524, -10.985222720894134],
              [-16.454907080951582, -10.98434530025661],
              [-16.455467929689288, -10.982540884626474],
              [-16.45460475455667, -10.981078714449835],
              [-16.455175073408526, -10.980228537085157],
              [-16.45352686700362, -10.979085732368299],
              [-16.45414471055986, -10.976748608620367],
              [-16.456913418912727, -10.977527895135445],
              [-16.457739035489745, -10.978925270015418],
              [-16.458452907230985, -10.981989929077331],
              [-16.459962719944162, -10.985355441157713],
              [-16.461229915030657, -10.985168298324712],
              [-16.460972294766027, -10.983393499094662],
              [-16.462076948816446, -10.983133928767321],
              [-16.46333108734789, -10.980319690342784],
              [-16.46281007992126, -10.979356088890526],
              [-16.459696932290363, -10.979651293924013],
              [-16.456997868133364, -10.975962425868872],
              [-16.45754974843068, -10.974282782462025],
              [-16.455538957348253, -10.974048890052192],
              [-16.45625309095408, -10.97244205047911],
              [-16.4577365681836, -10.970575722397172],
              [-16.45861160018704, -10.972161228658639],
              [-16.461161501363524, -10.972450166682385],
              [-16.462216577327435, -10.974791127491331],
              [-16.46422345188618, -10.97508548938243],
              [-16.4637552295941, -10.97365038870776],
              [-16.465452607935035, -10.97200327679515],
              [-16.462226837890363, -10.970576723341775],
              [-16.463454365584305, -10.969395584525294],
              [-16.466183492676553, -10.969178634567145],
              [-16.465900620052818, -10.967898219291294],
              [-16.464129288113934, -10.967105235010761],
              [-16.463211362365477, -10.966158191895463],
              [-16.465398978887965, -10.965596883244343],
              [-16.46674517655801, -10.96481605110845],
              [-16.46662632102614, -10.963466298860357],
              [-16.465163042417363, -10.96318640599668],
              [-16.462950924074782, -10.963807940744612],
              [-16.461268563390835, -10.963059600896155],
              [-16.46186780984865, -10.961281527533066],
              [-16.464147696850766, -10.961201375099119],
              [-16.466903345181723, -10.960511510909294],
              [-16.466919077549143, -10.957499490468173],
              [-16.467300264455698, -10.956471424360135],
              [-16.465358290885877, -10.955253436979932],
              [-16.46622656834406, -10.953972221521104],
              [-16.4647932561936, -10.951606312794215],
              [-16.46404920084204, -10.95143534683055],
              [-16.46177316243855, -10.953041738609585],
              [-16.460461969661292, -10.952069963257008],
              [-16.461920420113938, -10.951153525512055],
              [-16.46226169949577, -10.94979392038978],
              [-16.461050485022568, -10.9479627126604],
              [-16.45871900069355, -10.946059031367477],
              [-16.458940275133806, -10.944939544429877],
              [-16.462033463970844, -10.94604692122108],
              [-16.464693298221867, -10.947723561965423],
              [-16.465747670313778, -10.947853278607216],
              [-16.46775889826203, -10.948951665674986],
              [-16.46746753756923, -10.946437968229025],
              [-16.466069097450823, -10.944595952976439],
              [-16.46650254277364, -10.941532105630465],
              [-16.46606308134629, -10.940657288525312],
              [-16.463143036998858, -10.93974975706726],
              [-16.46594955277943, -10.937334563217469],
              [-16.46691965960887, -10.93714978060947],
              [-16.46791328880407, -10.935050665123613],
              [-16.466786637555515, -10.934772263168709],
              [-16.466588441245985, -10.93368858391812],
              [-16.468430936177686, -10.932397921336955],
              [-16.468476102824603, -10.928785961495649],
              [-16.4709046554793, -10.92511342067835],
              [-16.47140627209938, -10.922881922235188],
              [-16.47301793360682, -10.921154120666355],
              [-16.474549456118947, -10.920634388373685],
              [-16.476713478281233, -10.920607515039068],
              [-16.479140325366078, -10.920062122144698],
              [-16.47997680775906, -10.92093778124738],
              [-16.481310631833015, -10.921207351244579],
              [-16.482199941462767, -10.922868080634084],
              [-16.482382118165866, -10.924216621586755],
              [-16.48100308550531, -10.926537226227552],
              [-16.481215958370665, -10.92805293643989],
              [-16.479510382519283, -10.931218317075109],
              [-16.478738772015966, -10.935936899872535],
              [-16.479041391241392, -10.93659793144714],
              [-16.477974855637722, -10.938147089075665],
              [-16.47768888489945, -10.939760830367689],
              [-16.478742246809514, -10.942937679739359],
              [-16.47649184187613, -10.944640968963473],
              [-16.47818483737575, -10.946028129947898],
              [-16.48088113733282, -10.946746565200204],
              [-16.48096256111387, -10.948161906546007],
              [-16.482354990500443, -10.951734235239554],
              [-16.481898907440343, -10.953293379565384],
              [-16.480606553673127, -10.95552221324419],
              [-16.480654416419632, -10.957980215832551],
              [-16.479933763884347, -10.961177108389414],
              [-16.479746715578948, -10.963887423459413],
              [-16.48069527397734, -10.965660723987696],
              [-16.481934181845467, -10.966827297601082],
              [-16.48399766587272, -10.96515198394495],
              [-16.485133500441, -10.96127416639739],
              [-16.48847216447274, -10.959006700087519],
              [-16.488801128581986, -10.957789221814622],
              [-16.491386307213567, -10.9565060279517],
              [-16.4947001518761, -10.957185445299341],
              [-16.49730180146583, -10.957263674924858],
              [-16.499722268464776, -10.95625715389366],
              [-16.502949301993183, -10.95666108643526],
              [-16.50108433110839, -10.958774645239833],
              [-16.499091116642262, -10.958962048193582],
              [-16.496826017447393, -10.959812846142935],
              [-16.496233217332577, -10.960601935511564],
              [-16.492804800178707, -10.962990013682374],
              [-16.491139188243764, -10.965528841190666],
              [-16.491007400788305, -10.968225271708867],
              [-16.490286772901193, -10.968717588061235],
              [-16.489513556815954, -10.970672591578008],
              [-16.487865701787726, -10.972263450937792],
              [-16.48458808155307, -10.973856284996272],
              [-16.482724986176997, -10.97520630579339],
              [-16.48223454503691, -10.977283329271032],
              [-16.484351945218478, -10.976527459947619],
              [-16.48654003979257, -10.977903760202969],
              [-16.486639254498186, -10.98024539753891],
              [-16.483727158914302, -10.981324525365318],
              [-16.482855294986845, -10.982840960002887],
              [-16.483048886382512, -10.983721538401712],
              [-16.4844769175107, -10.984265670931329],
              [-16.48575535789581, -10.986475637396971],
              [-16.485063935592425, -10.98746644136627],
              [-16.483237960336478, -10.98789000818795],
              [-16.482120310106126, -10.985462453410332],
              [-16.480936664001206, -10.985645642916912],
              [-16.480535233012603, -10.989251113780915],
              [-16.481602495131956, -10.990207614014231],
              [-16.482625230013124, -10.992816502658469],
              [-16.48101208965417, -10.99381223672992],
              [-16.48038578282585, -10.9957181461719],
              [-16.479161562588164, -10.997483460046878],
              [-16.478105880977697, -10.996982303711539],
              [-16.47809013698606, -11.000107686448233],
              [-16.477273346228756, -11.001070828410654],
              [-16.476014365511173, -11.000473759283505],
              [-16.475131784134742, -11.001163412171575],
              [-16.476252540503154, -11.002911576353936],
              [-16.47694919860666, -11.005067943778878],
              [-16.478103785043192, -11.00534798693015],
              [-16.47827115633316, -11.008238048596466],
              [-16.477916378704318, -11.01014288924448],
              [-16.476726215536974, -11.010399342929977],
              [-16.475181239755905, -11.008395441714166],
              [-16.473389369662797, -11.008572421712548],
              [-16.473555579810053, -11.01017840436494],
              [-16.476313080302287, -11.013191986696022],
              [-16.477906987348177, -11.01092946743186],
              [-16.48027056767093, -11.011637703308727],
              [-16.480369857102982, -11.01301159733584],
              [-16.47977754282885, -11.014383927408963],
              [-16.478055656937844, -11.014752642446107],
              [-16.478050232347695, -11.016763370762781],
              [-16.479350350403745, -11.018690551335109],
              [-16.476437871808326, -11.019938351214911],
              [-16.47560688450178, -11.022063588359975],
              [-16.47665859454243, -11.024266632563855],
              [-16.47508369321682, -11.024601404621784],
              [-16.474700544451416, -11.02754918369056],
              [-16.474992747259744, -11.029204048632788],
              [-16.476905039162254, -11.02820391575021],
              [-16.478464126736334, -11.025210091218325],
              [-16.479509065909326, -11.025918670850613],
              [-16.4809718599441, -11.0260102785757],
              [-16.482657949551456, -11.025244242214542],
              [-16.48048392415175, -11.02415398236525],
              [-16.47952800010906, -11.02272509773435],
              [-16.479940130347003, -11.020904755728177],
              [-16.480989296815363, -11.021219597992484],
              [-16.48134218808452, -11.022568857341353],
              [-16.482564413734995, -11.022479394296806],
              [-16.485050837945202, -11.02327742336251],
              [-16.48318027367687, -11.017831092227103],
              [-16.483213715257378, -11.01569778334087],
              [-16.484005376505532, -11.015125221878623],
              [-16.48535338079052, -11.01599703119413],
              [-16.485627097072566, -11.017278703786717],
              [-16.48711674039593, -11.017910316492792],
              [-16.4871614307526, -11.01559115606324],
              [-16.485651589707533, -11.013652499696898],
              [-16.486338640179696, -11.013073628380448],
              [-16.489031884721303, -11.01388313748431],
              [-16.490238941528567, -11.014994083917196],
              [-16.49108757331348, -11.014507869737663],
              [-16.489467132271283, -11.012003474041546],
              [-16.4865736043153, -11.012031250486714],
              [-16.485939047765456, -11.011473478399811],
              [-16.48576549551349, -11.009618541080306],
              [-16.484023065529176, -11.011291898469299],
              [-16.48314976126496, -11.010864540687638],
              [-16.48082038111124, -11.007051485137621],
              [-16.483411349405543, -11.005535629239366],
              [-16.484529583340713, -11.004114394282281],
              [-16.486152957507464, -11.003946035650209],
              [-16.486783911452306, -11.005849509817027],
              [-16.488400457604275, -11.006115443582377],
              [-16.490595808024423, -11.009110405997875],
              [-16.492777093448318, -11.008084833378476],
              [-16.49083711165175, -11.00632858552125],
              [-16.489345474651305, -11.00281919351709],
              [-16.490939470725877, -11.001799728330475],
              [-16.491982492825947, -11.004141989771648],
              [-16.493330331259948, -11.004349547966148],
              [-16.494523889180943, -11.003748242568719],
              [-16.493837409601763, -11.002641380418119],
              [-16.493643265680053, -11.00076593823124],
              [-16.494360377341017, -11.000354701132723],
              [-16.49634974813139, -11.001325670336644],
              [-16.496329634398343, -10.999999660887495],
              [-16.494893877779237, -10.999538558638497],
              [-16.49629803140777, -10.99819678844216],
              [-16.495075000302354, -10.997686905446033],
              [-16.495810971567412, -10.995662732022916],
              [-16.497636381975067, -10.994926529472398],
              [-16.500065526754483, -10.994889029434121],
              [-16.503022230925378, -10.995772902248138],
              [-16.50366568584374, -10.994529111102969],
              [-16.505163146329107, -10.993006494016266],
              [-16.504493448700487, -10.990690492678361],
              [-16.50480701122069, -10.989365076658823],
              [-16.507585766470587, -10.98740374100427],
              [-16.50739009717564, -10.986192547178286],
              [-16.509036219025468, -10.98561004433132],
              [-16.51060616410919, -10.986242102528212],
              [-16.512293918604435, -10.985992336980807],
              [-16.513265145379144, -10.986505769861632],
              [-16.514027087215062, -10.984339469390036],
              [-16.51552408377216, -10.984801338987747],
              [-16.51712253566841, -10.98632324768588],
              [-16.518399148772964, -10.986296134459032],
              [-16.520579432035422, -10.984834176924839],
              [-16.52159835959163, -10.983220709058994],
              [-16.523188974545125, -10.982157588889466],
              [-16.524465915606743, -10.980414755537685],
              [-16.524684896494318, -10.97922946882756],
              [-16.52570775332248, -10.978897414712938],
              [-16.52698961182381, -10.976039994938917],
              [-16.528699516624346, -10.976760191624212],
              [-16.52967146122304, -10.97931670911353],
              [-16.53234800818982, -10.980302420945677],
              [-16.533322233227235, -10.97938609458684],
              [-16.5323611322248, -10.976293645571067],
              [-16.53186056112177, -10.973538296430087],
              [-16.53180793447761, -10.970624281495976],
              [-16.533615557939626, -10.968005333835094],
              [-16.534375920071263, -10.966130764574718],
              [-16.535835990584527, -10.963719242211736],
              [-16.537046420091418, -10.960943017818492],
              [-16.538984090662158, -10.962004399281927],
              [-16.537892558174196, -10.96489100482183],
              [-16.537068914309632, -10.965751126769948],
              [-16.535522131782457, -10.970634678345972],
              [-16.534858820051973, -10.974353724581338],
              [-16.535208440037916, -10.977203404079358],
              [-16.535901921493895, -10.979205855112205],
              [-16.537458667299223, -10.981444943306032],
              [-16.536966625915294, -10.982676709685423],
              [-16.535298628105544, -10.984005538971148],
              [-16.53521776377047, -10.985344084619996],
              [-16.53712090556883, -10.989134090763898],
              [-16.536649156724263, -10.990719388382935],
              [-16.535347616314056, -10.990809221035684],
              [-16.534842668821774, -10.989477028850121],
              [-16.533865321915037, -10.98904799423857],
              [-16.533920504747307, -10.987790195831591],
              [-16.53097004661842, -10.986129394927696],
              [-16.530650782432804, -10.984849983245203],
              [-16.528336733833488, -10.9886275741065],
              [-16.52734101752478, -10.989430665947912],
              [-16.522855225623665, -10.990985528846556],
              [-16.52169816398049, -10.992798878727552],
              [-16.520014035380807, -10.993319379152737],
              [-16.518713539239904, -10.992704378366948],
              [-16.51635687390783, -10.995306733292114],
              [-16.51572112671816, -10.996613777848369],
              [-16.51600853185924, -11.000239717997033],
              [-16.5177459552523, -11.000571096529411],
              [-16.518767039200807, -11.001997993249427],
              [-16.518401940561073, -11.003839485705576],
              [-16.517428300049012, -11.004692188932358],
              [-16.51552630995023, -11.004640838710213],
              [-16.514998742674933, -11.003698223508806],
              [-16.51242840030531, -11.002281370234327],
              [-16.511674146054563, -11.002629581848018],
              [-16.51044823617527, -10.999802830729557],
              [-16.508700739627283, -11.004313793259302],
              [-16.508176851270967, -11.008300021843398],
              [-16.508648545350834, -11.010834729494292],
              [-16.5080054889941, -11.013074809062612],
              [-16.509212177192502, -11.017230219307555],
              [-16.509736945815277, -11.020829260115644],
              [-16.511329766316354, -11.022602623660246],
              [-16.51277728015319, -11.023601815933548],
              [-16.51102320025979, -11.024492260642566],
              [-16.5124610259609, -11.025988706111956],
              [-16.51549880674771, -11.024013611056082],
              [-16.5181498753868, -11.025228956467332],
              [-16.519756327269498, -11.025365794039962],
              [-16.522179016178093, -11.0234769395632],
              [-16.523460461293748, -11.024465298910307],
              [-16.521432520957582, -11.029489209542477],
              [-16.520415324544604, -11.03071579091519],
              [-16.52059022980782, -11.03231415151383],
              [-16.52186510923323, -11.032357084008025],
              [-16.52156120384051, -11.034035228230486],
              [-16.523008205431644, -11.034935896339313],
              [-16.52346267362815, -11.0367682655686],
              [-16.525205080820353, -11.036767197376511],
              [-16.5251966793777, -11.040390899635149],
              [-16.526250659439818, -11.041312889186727],
              [-16.527125968899806, -11.039527971887807],
              [-16.528634040538453, -11.038026652320093],
              [-16.528713144986025, -11.036723862981296],
              [-16.52972915678313, -11.034853037588512],
              [-16.52971155507251, -11.033067204575367],
              [-16.52838418613738, -11.033155723527866],
              [-16.528406997528496, -11.031745984167806],
              [-16.529231286784885, -11.030978657686674],
              [-16.529102911883925, -11.02892378074823],
              [-16.53107908726124, -11.026426043643792],
              [-16.53135892781168, -11.024575991285907],
              [-16.532865424173277, -11.024974667160668],
              [-16.53587864405229, -11.024030145829],
              [-16.538408609480346, -11.020300136207437],
              [-16.541432427222563, -11.01914799253028],
              [-16.541237398984055, -11.01785178514107],
              [-16.542173727186174, -11.016206812645702],
              [-16.544917307293, -11.014106123138282],
              [-16.54570204967903, -11.015352411655154],
              [-16.544085982322354, -11.018927266106523],
              [-16.544422674173248, -11.020314414658795],
              [-16.54270628517456, -11.020982845485111],
              [-16.541498133736177, -11.02226058061067],
              [-16.54104550459121, -11.024577186096604],
              [-16.53986116443354, -11.026852321753024],
              [-16.537795540457925, -11.027375969544707],
              [-16.53628375270127, -11.028802503215337],
              [-16.536150138717925, -11.030338444731441],
              [-16.53668150556468, -11.033136320296967],
              [-16.53781264475937, -11.0354883043881],
              [-16.53792084305665, -11.038587306918462],
              [-16.537585535077124, -11.039979264565122],
              [-16.53773346988579, -11.042416995570877],
              [-16.538453058618185, -11.044078399912227],
              [-16.540061884295962, -11.04562476410783],
              [-16.542828548285208, -11.042896777310569],
              [-16.54483949494626, -11.040146807682135],
              [-16.54506690641851, -11.038789982566044],
              [-16.546522632817354, -11.038665451798392],
              [-16.549113230956834, -11.03922795340686],
              [-16.547106829931767, -11.041210368951889],
              [-16.54720877883091, -11.043749195895238],
              [-16.545862203648145, -11.044503134071531],
              [-16.54300114251274, -11.04811953519268],
              [-16.54037013529966, -11.050316223095608],
              [-16.539320665191866, -11.049944355285],
              [-16.5383706393662, -11.051073979742917],
              [-16.536063107206683, -11.05171138072757],
              [-16.534375604995212, -11.052858850445466],
              [-16.535638748808903, -11.054573915871487],
              [-16.537129887411727, -11.054597869908825],
              [-16.538471504098027, -11.055714435281349],
              [-16.53846400319914, -11.057041624252674],
              [-16.5397419281983, -11.057325801165891],
              [-16.542294725348015, -11.05894830447221],
              [-16.543496475936923, -11.05889235399666],
              [-16.54473733696642, -11.056759435065908],
              [-16.546151079111134, -11.057027183270812],
              [-16.547247879479123, -11.060467497501945],
              [-16.550532983655152, -11.059021913500336],
              [-16.552059985542556, -11.057362079069405],
              [-16.552218105249327, -11.05502226274408],
              [-16.550814234971018, -11.054589664631317],
              [-16.550207145812134, -11.05347469362601],
              [-16.551254757461418, -11.052453319551516],
              [-16.553795008201064, -11.053573285173043],
              [-16.55610970187171, -11.054243506605399],
              [-16.55719454179772, -11.055468135611083],
              [-16.556040387982524, -11.056879099983636],
              [-16.555080616079383, -11.059278201042067],
              [-16.55510441188683, -11.060672644131898],
              [-16.554046793608705, -11.061860577592471],
              [-16.553573036167396, -11.063851052507813],
              [-16.55166142537515, -11.065241076401717],
              [-16.550660851927095, -11.067269738813707],
              [-16.549554592131447, -11.068158943475725],
              [-16.549803806043318, -11.069650391737763],
              [-16.55230754029735, -11.07253881651455],
              [-16.55402574686729, -11.073759159743107],
              [-16.55468227584062, -11.074774317408895],
              [-16.55672389192333, -11.075006124877543],
              [-16.555406003345578, -11.073191564395072],
              [-16.555072382598254, -11.069884681969889],
              [-16.55619902897514, -11.067160027000163],
              [-16.55771293717445, -11.068264156806515],
              [-16.55770358311455, -11.072050774268405],
              [-16.559251498480393, -11.072220393392323],
              [-16.559793285866544, -11.073041355386682],
              [-16.562044249357285, -11.072333979980472],
              [-16.564049709098658, -11.072965523959418],
              [-16.56442421003306, -11.07084292000845],
              [-16.565808338194877, -11.072396633619691],
              [-16.56440954023509, -11.075129083341574],
              [-16.56313254094958, -11.075370547179801],
              [-16.561409476545293, -11.077502515878406],
              [-16.56130909325771, -11.079974484472455],
              [-16.560206679346564, -11.079965692268615],
              [-16.559347438578186, -11.08111502561964],
              [-16.559577268795216, -11.082606400866881],
              [-16.561366111885874, -11.084830450498739],
              [-16.562850476719344, -11.087600134257077],
              [-16.563810472938563, -11.087028286672554],
              [-16.56610911114817, -11.083322163987978],
              [-16.567695169788607, -11.082847359369737],
              [-16.570104936843734, -11.083812448200504],
              [-16.57025443032478, -11.085258033140859],
              [-16.56805505728663, -11.087616489669736],
              [-16.568241891703853, -11.090252226368932],
              [-16.56973112685772, -11.091125609463733],
              [-16.570708537683597, -11.088761877740433],
              [-16.57257680337295, -11.087780833641064],
              [-16.573032669696076, -11.089034851792944],
              [-16.5720899405121, -11.092651186074022],
              [-16.57285206375389, -11.09371403769703],
              [-16.572987257535022, -11.09728619047275],
              [-16.57502294950318, -11.100086753247565],
              [-16.574202296336956, -11.10116836707425],
              [-16.572693843366793, -11.10098201182333],
              [-16.572448132946317, -11.098987568690339],
              [-16.569971017969948, -11.09914401668002],
              [-16.568454160891978, -11.09799751634541],
              [-16.569114163194474, -11.101599862267415],
              [-16.570678764395897, -11.101915059977971],
              [-16.571067313167536, -11.10287502158854],
              [-16.57056069718455, -11.106226972659304],
              [-16.569952510167404, -11.106527580940453],
              [-16.5682183835149, -11.105472831549283],
              [-16.568675845507304, -11.108189798636172],
              [-16.568369602309556, -11.111345455280368],
              [-16.56923381876791, -11.11174768284992],
              [-16.571620028491996, -11.111377080803337],
              [-16.569810529057918, -11.109399836585267],
              [-16.571606675293495, -11.10713958563437],
              [-16.574096958138146, -11.107150180260735],
              [-16.57335366484472, -11.106108228632241],
              [-16.57359271931151, -11.104118138977576],
              [-16.574573585171894, -11.103190962693207],
              [-16.575614911337627, -11.103435289066205],
              [-16.577345961570085, -11.105677786763533],
              [-16.577422055831825, -11.108457225908948],
              [-16.57667952790186, -11.109272549852568],
              [-16.57676958228213, -11.111802767000071],
              [-16.57867268019551, -11.112135473635027],
              [-16.579055954071993, -11.110945440390637],
              [-16.580298450624362, -11.1108784052829],
              [-16.58162492453905, -11.10993578386702],
              [-16.581715616527447, -11.108688532012195],
              [-16.579922783272874, -11.107527799631828],
              [-16.58084799887726, -11.105324281376108],
              [-16.58428295417651, -11.1080749068826],
              [-16.584807799920824, -11.109647125500743],
              [-16.584460509893734, -11.111339800839545],
              [-16.58247157308743, -11.11536865304276],
              [-16.582594342066752, -11.1164170783084],
              [-16.585549128288548, -11.118371132138401],
              [-16.584469287442477, -11.120800679231754],
              [-16.585514783679283, -11.12357040089191],
              [-16.587223859176692, -11.122094552013005],
              [-16.58975730220178, -11.121372568571706],
              [-16.59109900405114, -11.121568855643622],
              [-16.592520605940738, -11.11953445896676],
              [-16.59257194585664, -11.118597214001733],
              [-16.591088295398748, -11.11791340398683],
              [-16.58855067679776, -11.118342685976428],
              [-16.58856174316078, -11.116610375378007],
              [-16.587432497061975, -11.115255865726029],
              [-16.58856165583295, -11.114313742293108],
              [-16.589346268449383, -11.115023341311593],
              [-16.59129101793783, -11.115376919736487],
              [-16.591538736583527, -11.11432507568921],
              [-16.590442279455303, -11.111991850756043],
              [-16.590536415470215, -11.110661235685427],
              [-16.589469398880954, -11.110103794390294],
              [-16.587427464142188, -11.111143144358087],
              [-16.58711453132764, -11.10916499353097],
              [-16.590617122324957, -11.105741433624052],
              [-16.589997585753988, -11.104728191881327],
              [-16.586400743705525, -11.107186161762746],
              [-16.58683813593879, -11.104622741621794],
              [-16.588126643670222, -11.102689049673591],
              [-16.587137671615785, -11.1022608041752],
              [-16.585453585133866, -11.103714477846331],
              [-16.58421446722965, -11.10323120350045],
              [-16.58377990522755, -11.10156016025069],
              [-16.582576285626242, -11.10157918575763],
              [-16.582117685896776, -11.100344868489827],
              [-16.581088279067796, -11.100644103389552],
              [-16.58043721646097, -11.103612271875333],
              [-16.578387321493476, -11.10479535931099],
              [-16.57752704482281, -11.1043314914868],
              [-16.577668369187695, -11.10219071453903],
              [-16.578558680334208, -11.100612045134195],
              [-16.579130472071302, -11.096430940434908],
              [-16.58152637953962, -11.097331273169498],
              [-16.58352345146546, -11.096312653332808],
              [-16.584756808849704, -11.098025821909385],
              [-16.58578768920476, -11.097309667718173],
              [-16.588428678526434, -11.09722084786832],
              [-16.588148227755024, -11.095809464943855],
              [-16.58683144560894, -11.095218009834918],
              [-16.586391431540154, -11.09402728705874],
              [-16.58701277903537, -11.092706063811338],
              [-16.586282356311024, -11.091812617044376],
              [-16.58396257622622, -11.092209506308025],
              [-16.582651037266118, -11.091534626302112],
              [-16.580004577910398, -11.09287197113343],
              [-16.579003891584886, -11.092672283074268],
              [-16.5774321755611, -11.088377923516587],
              [-16.579208566105205, -11.087140589987637],
              [-16.58112170024287, -11.087597993001854],
              [-16.581665031280544, -11.086169216322451],
              [-16.583044817851793, -11.087118254239128],
              [-16.584233983812776, -11.086952789445],
              [-16.584721268113515, -11.0838754011167],
              [-16.58373340127346, -11.082323331379115],
              [-16.581774705402385, -11.082322006566796],
              [-16.57879988398719, -11.083536053098136],
              [-16.576853807044767, -11.082930740225738],
              [-16.576452706313923, -11.081826210402665],
              [-16.577361456847456, -11.080647008444677],
              [-16.579738598238468, -11.079193221400612],
              [-16.580826660643314, -11.079314422583668],
              [-16.58315406491568, -11.077982638512937],
              [-16.582739175613245, -11.075608359128946],
              [-16.58138325383005, -11.075389670917765],
              [-16.57962276547712, -11.076002154744039],
              [-16.580834644278575, -11.073698279117734],
              [-16.579483708784323, -11.071729048419865],
              [-16.579674686109815, -11.068701894283699],
              [-16.57586038684603, -11.065832855329898],
              [-16.57520174765345, -11.063717610105744],
              [-16.576449428141803, -11.062850068874017],
              [-16.576489408075755, -11.061022480411571],
              [-16.57572712013028, -11.060004143779903],
              [-16.574349625321215, -11.059825146911711],
              [-16.57432966353008, -11.057579187547125],
              [-16.573426990496948, -11.056449410551904],
              [-16.570704327410493, -11.054804046999465],
              [-16.572278508884526, -11.053726942546056],
              [-16.57314506967251, -11.052527744483978],
              [-16.57545287997989, -11.051843602823693],
              [-16.57574283561472, -11.051173939900886],
              [-16.574879544426278, -11.048613959600559],
              [-16.572076050092626, -11.045470436996547],
              [-16.57068981634497, -11.042529440004818],
              [-16.569280680216153, -11.041476338731654],
              [-16.56845236310098, -11.039811706784416],
              [-16.566917716219027, -11.03802542843484],
              [-16.568077410564268, -11.036097475986304],
              [-16.56978248878834, -11.034531688351207],
              [-16.570916692324744, -11.034137867023428],
              [-16.570619700507955, -11.032358498671217],
              [-16.567837334073978, -11.028576060657358],
              [-16.56612306024748, -11.027029974015733],
              [-16.564781326738135, -11.021939288355789],
              [-16.56516890036832, -11.016304427227352],
              [-16.561724201385697, -11.011411394230525],
              [-16.560685202416636, -11.005867196062058],
              [-16.56098353152227, -11.002531294934068],
              [-16.560631635826365, -11.00174615187198],
              [-16.561749080773087, -11.00015376845099],
              [-16.561026440411382, -10.998913353486877],
              [-16.56218689308535, -10.997654595816261],
              [-16.563261125859466, -10.999327682914835],
              [-16.56322885678638, -11.000608761533059],
              [-16.56427187670841, -11.001742510575392],
              [-16.567696774568585, -11.010583971185506],
              [-16.568622054300825, -11.011608119055502],
              [-16.571028879308045, -11.01675275087495],
              [-16.57083196380638, -11.0176326438125],
              [-16.5716494035692, -11.019459411220364],
              [-16.571397407797278, -11.02093722463879],
              [-16.57244658507746, -11.022383257545272],
              [-16.575317846719347, -11.029028438164307],
              [-16.574714546856416, -11.03005294716336],
              [-16.575982675260192, -11.032838720585795],
              [-16.575472228812583, -11.034076221220056],
              [-16.577327671365083, -11.037247775423129],
              [-16.576988949233304, -11.03915874438841],
              [-16.57844842863501, -11.040815226826936],
              [-16.58065359456104, -11.045273071925685],
              [-16.581787484960433, -11.046019463645901],
              [-16.58183080366913, -11.047122329861846],
              [-16.580978850904035, -11.048138159881194],
              [-16.58281507463545, -11.049044261025005],
              [-16.583752445327985, -11.051815427637715],
              [-16.5847236343793, -11.056624856073794],
              [-16.58591185673932, -11.058359132889743],
              [-16.58666053645715, -11.060344941404987],
              [-16.58801838110621, -11.060500395860096],
              [-16.58897459267693, -11.062214306198742],
              [-16.59130935246917, -11.063336398596968],
              [-16.59172605222723, -11.06497026818878],
              [-16.59146506565329, -11.066234964344783],
              [-16.592613049957247, -11.068687180867302],
              [-16.594153949421287, -11.074343977086127],
              [-16.5943295992769, -11.079036257858792],
              [-16.5950968262014, -11.07980450961058],
              [-16.596439965026203, -11.08258193548913],
              [-16.596763701151676, -11.084368647581739],
              [-16.597615901615136, -11.085350370147236],
              [-16.5978491484408, -11.087257933500576],
              [-16.59935201717274, -11.092973136377665],
              [-16.601542916980346, -11.095305858975133],
              [-16.601633324405125, -11.098679129555356],
              [-16.602753505454622, -11.098266207947017],
              [-16.60538790511152, -11.099862036418825],
              [-16.606142261082162, -11.098775361635823],
              [-16.60642979089598, -11.096955823493994],
              [-16.60763479589273, -11.096893081742216],
              [-16.60859857422814, -11.097797472375294],
              [-16.609399989502315, -11.09660877900034],
              [-16.609826503203042, -11.093358899208779],
              [-16.609595763579293, -11.090972019839318],
              [-16.606716882523532, -11.090427597939147],
              [-16.603887511757858, -11.088968832148431],
              [-16.603348434451803, -11.085295962403285],
              [-16.603571390052245, -11.082725600932331],
              [-16.602394875284414, -11.080728311402321],
              [-16.603461225653525, -11.079305876333597],
              [-16.604296575138388, -11.0794325002438],
              [-16.60523158046446, -11.080833991024209],
              [-16.606085730399585, -11.085313011989928],
              [-16.608036715443063, -11.08624686249717],
              [-16.61046369089897, -11.08644469119478],
              [-16.61317994261175, -11.085782415862903],
              [-16.616143059421386, -11.083518270082516],
              [-16.61590395183141, -11.082069669419676],
              [-16.613004735810524, -11.07996521791826],
              [-16.610207100568118, -11.079134612828394],
              [-16.61000626844864, -11.077771683898046],
              [-16.611168522918994, -11.077290142726788],
              [-16.61242145135706, -11.078270330162175],
              [-16.615560326578986, -11.079013578831246],
              [-16.618699080378224, -11.076572078614412],
              [-16.61923716457839, -11.074747639227514],
              [-16.616677773391654, -11.070624003452592],
              [-16.61461512728391, -11.069458180298895],
              [-16.614834536374318, -11.067701802911797],
              [-16.61393928962241, -11.065951224244365],
              [-16.610469079767608, -11.062821182191074],
              [-16.609035075302724, -11.058591068570012],
              [-16.606439020272717, -11.058020296532764],
              [-16.606135296076538, -11.057028135467613],
              [-16.606676659888414, -11.055560534767777],
              [-16.609359594114064, -11.054889382689867],
              [-16.609603736839368, -11.050727391176673],
              [-16.61128272917815, -11.049568249118545],
              [-16.612384993863493, -11.048192455490925],
              [-16.61357278400149, -11.0499352477161],
              [-16.61432671190295, -11.052735637619003],
              [-16.615174581657218, -11.05298654319556],
              [-16.616109068720668, -11.051601502837979],
              [-16.61844832939272, -11.05224003688936],
              [-16.61781462427934, -11.055489034782303],
              [-16.61845751539748, -11.055646391141597],
              [-16.619703485955085, -11.057911671816576],
              [-16.62072616082171, -11.058441346599832],
              [-16.62179734398363, -11.061170804576083],
              [-16.621945593332732, -11.062430113214084],
              [-16.6229135773519, -11.06281145931041],
              [-16.62256822791879, -11.064186680550332],
              [-16.623830225618565, -11.06713501942873],
              [-16.62360529178014, -11.068874647613157],
              [-16.625403334026686, -11.070691172312639],
              [-16.625447479692205, -11.072669040368076],
              [-16.627329826963997, -11.072472044025545],
              [-16.630737529235443, -11.06962709086416],
              [-16.6319461513918, -11.070248497007226],
              [-16.633074059306406, -11.069992407945938],
              [-16.634964788357316, -11.070439488005803],
              [-16.63582273557189, -11.072166422512085],
              [-16.63399921261157, -11.07367768146031],
              [-16.631647243761496, -11.076452437730035],
              [-16.630982999368907, -11.07831282365512],
              [-16.629896561962497, -11.076531735577653],
              [-16.628572680147567, -11.076902732735208],
              [-16.62772124040653, -11.078711844934721],
              [-16.626340582019402, -11.079442574442428],
              [-16.626486515912514, -11.08181345214393],
              [-16.625383495486453, -11.083589772682814],
              [-16.62295956598128, -11.085521854960792],
              [-16.622013742479638, -11.085210802982148],
              [-16.620182885870072, -11.087992090374046],
              [-16.620280126652297, -11.090954624416524],
              [-16.619860848621492, -11.092351117689358],
              [-16.619874719419002, -11.096267615425798],
              [-16.62135047027339, -11.095863035334805],
              [-16.623065166921446, -11.094511733530496],
              [-16.6236220422856, -11.095956352407798],
              [-16.624734724528956, -11.096449901666656],
              [-16.628102388545056, -11.09613924958302],
              [-16.630940274820578, -11.096697081435433],
              [-16.632667327586656, -11.095907695676308],
              [-16.63368149313971, -11.09627022604003],
              [-16.631062069334238, -11.099245607378785],
              [-16.629040520405884, -11.099603854534235],
              [-16.62559227063696, -11.10103671888787],
              [-16.621698307154624, -11.101299860029053],
              [-16.621402959933842, -11.102911080431653],
              [-16.619946894324958, -11.102524866463527],
              [-16.619521381312925, -11.104176066558075],
              [-16.620530878319784, -11.106529683584238],
              [-16.62181798448177, -11.10747818796896],
              [-16.621877145772988, -11.109668111264803],
              [-16.623356951189344, -11.111957376387183],
              [-16.62430289002733, -11.110815774643914],
              [-16.62563508341523, -11.11198835023891],
              [-16.627918425883024, -11.11191457164554],
              [-16.62919215171943, -11.113000285163622],
              [-16.6313526379189, -11.113521317721471],
              [-16.631644678887472, -11.114979148483128],
              [-16.633043035940613, -11.114881239459123],
              [-16.6352635996189, -11.11315458215177],
              [-16.637352454259048, -11.111995723819689],
              [-16.639266726793167, -11.109660397009915],
              [-16.641062575396184, -11.109516473289808],
              [-16.64179334359825, -11.110293752852874],
              [-16.64592486555368, -11.11269359952197],
              [-16.646908269338738, -11.112866354258518],
              [-16.64787470492647, -11.120133703520782],
              [-16.64920467752075, -11.123423643392746],
              [-16.650475405808276, -11.125165187008841],
              [-16.651475108387608, -11.128011704783175],
              [-16.65184374760767, -11.12995110488022],
              [-16.65350897200698, -11.130469105409883],
              [-16.655021072914636, -11.131523096895508],
              [-16.656231143833672, -11.133565361829488],
              [-16.65753573309773, -11.134985287668842],
              [-16.66299617949369, -11.135743800676265],
              [-16.664559129308543, -11.136652917216068],
              [-16.664923487618232, -11.138299956150624],
              [-16.66468590570554, -11.139710496181255],
              [-16.66376815668308, -11.14027287971191],
              [-16.665903261880015, -11.141917212639015],
              [-16.668764340470513, -11.148149931712492],
              [-16.670115463588616, -11.149134290118536],
              [-16.670406236970862, -11.150225576353968],
              [-16.6735161513843, -11.150737092180446],
              [-16.675626715812935, -11.151601022349594],
              [-16.676709909261074, -11.152536803747791],
              [-16.676737742783985, -11.153642120997198],
              [-16.678613522739003, -11.154267072292146],
              [-16.679160402852414, -11.15339349276564],
              [-16.680445362202168, -11.153291652118035],
              [-16.682288032176807, -11.154031829677514],
              [-16.682986272121738, -11.154805417985976],
              [-16.682743772294373, -11.156110332236855],
              [-16.68165141333947, -11.155968241505487],
              [-16.68052227479909, -11.15714333928887],
              [-16.678629305894223, -11.157207261260512],
              [-16.677047574610317, -11.155958504766078],
              [-16.67556707274869, -11.156906351530932],
              [-16.6760752234026, -11.158809152043787],
              [-16.67527605036632, -11.160443884473494],
              [-16.673526488740293, -11.1611822038755],
              [-16.672421513610537, -11.163355438897312],
              [-16.672878611790537, -11.164290670126674],
              [-16.671166624783663, -11.168094693869605],
              [-16.672243247325593, -11.171427125509737],
              [-16.673475778463935, -11.172558255707301],
              [-16.67493816137912, -11.174700192684734],
              [-16.677893113547714, -11.177637301622877],
              [-16.67929100005584, -11.179944359843553],
              [-16.6823960436753, -11.180713370876681],
              [-16.685008982972384, -11.180201810022302],
              [-16.685757515503774, -11.179165586333777],
              [-16.687165581207733, -11.179459263962046],
              [-16.688469636497583, -11.180628821024715],
              [-16.688283105617014, -11.183283912517584],
              [-16.689710975150298, -11.184081771104767],
              [-16.68978109168021, -11.18624563333915],
              [-16.68873411373621, -11.186849360341986],
              [-16.686495360918745, -11.189792410798937],
              [-16.68271816485579, -11.191994774286712],
              [-16.68420071835117, -11.193006092359981],
              [-16.68590001683064, -11.192095575531107],
              [-16.690013912485032, -11.190410443041404],
              [-16.690494745953732, -11.189193763229214],
              [-16.6922383898647, -11.188683100159686],
              [-16.69202237994532, -11.186911260334155],
              [-16.69387793201047, -11.185335655131142],
              [-16.691599422938697, -11.184563849041128],
              [-16.69109767020878, -11.18347196700114],
              [-16.69143081130936, -11.182228336713134],
              [-16.694362574235026, -11.178918562946805],
              [-16.693412154809256, -11.176507543262069],
              [-16.694461643405113, -11.175359203075553],
              [-16.693135747196294, -11.174671899974257],
              [-16.691539404159258, -11.172945515850113],
              [-16.69013688338661, -11.172226521107081],
              [-16.68676205629588, -11.17260713766023],
              [-16.686404789972936, -11.17162731941653],
              [-16.688410813429876, -11.169977485051119],
              [-16.690753665380853, -11.169746655340385],
              [-16.691036625054934, -11.168669783661903],
              [-16.690251984162757, -11.167754944714016],
              [-16.68858282947159, -11.16717808353343],
              [-16.686653765164728, -11.16535329649248],
              [-16.687803072586192, -11.164336563080338],
              [-16.68878228521498, -11.165615934896639],
              [-16.689992759850917, -11.165564906171424],
              [-16.69269957732307, -11.167962725363255],
              [-16.69491763592312, -11.168170599483194],
              [-16.696763398989184, -11.166301599648392],
              [-16.696701808091312, -11.16437431159085],
              [-16.695723595445052, -11.162593369113361],
              [-16.699174860819973, -11.160249778541464],
              [-16.699303032471793, -11.157956111952869],
              [-16.698225782822902, -11.155564852071322],
              [-16.69610895095432, -11.153693218821084],
              [-16.695376747889362, -11.151652461484515],
              [-16.69599171082275, -11.149776200091683],
              [-16.697153202105785, -11.14936702404195],
              [-16.69885294118478, -11.150152552049839],
              [-16.698901575748334, -11.15327199304487],
              [-16.700303122089373, -11.156450813376825],
              [-16.701836315241906, -11.15766876636794],
              [-16.70334567028064, -11.16083213503835],
              [-16.70369218417826, -11.162432960021542],
              [-16.703253454666797, -11.163707570128848],
              [-16.706089181493727, -11.168636409306096],
              [-16.70795007227027, -11.168737137706922],
              [-16.70838888955278, -11.166975676533257],
              [-16.71240562442736, -11.164899292748203],
              [-16.712723551872923, -11.163370547105325],
              [-16.713781936176844, -11.161949837043561],
              [-16.714668158037476, -11.164505580213191],
              [-16.715813742741773, -11.16392041684254],
              [-16.716165852402625, -11.16265796079411],
              [-16.71740602798911, -11.162877964678565],
              [-16.717365952075358, -11.164313666082714],
              [-16.719649320270186, -11.16390404162842],
              [-16.720713497601846, -11.162817943918823],
              [-16.72391736827602, -11.161235311531913],
              [-16.72536861802989, -11.15999797497701],
              [-16.726629819947917, -11.158250363148897],
              [-16.729297388610313, -11.157272265969072],
              [-16.730288154816414, -11.158861821800286],
              [-16.733096014395162, -11.159562974427368],
              [-16.735803843300143, -11.158626836392047],
              [-16.737128410665626, -11.157341246922783],
              [-16.739152017059695, -11.1565445963944],
              [-16.74216355828093, -11.156414732128065],
              [-16.74582645486272, -11.155891687761992],
              [-16.747198782420327, -11.156490214585238],
              [-16.745831423581453, -11.157816553251681],
              [-16.742960737363344, -11.15862283117021],
              [-16.741927494590314, -11.160046283376783],
              [-16.740542976465026, -11.160743939437566],
              [-16.73728356851968, -11.161700534760344],
              [-16.73575598176112, -11.162768861049454],
              [-16.73409009205629, -11.165087921435143],
              [-16.733110207670986, -11.165215216291589],
              [-16.730870478814488, -11.164076646840222],
              [-16.728755033295208, -11.164994761437088],
              [-16.726191805354997, -11.16547522559261],
              [-16.72501726399015, -11.166180188908742],
              [-16.722576202999726, -11.165785385346735],
              [-16.722373154510002, -11.167536081460348],
              [-16.720532584347534, -11.168925094958148],
              [-16.71823463870051, -11.170095921573555],
              [-16.71806835152408, -11.171471765848924],
              [-16.713938993578832, -11.172805706141625],
              [-16.712790743192837, -11.171919090597424],
              [-16.71183338993255, -11.173910728427524],
              [-16.709814380479155, -11.173531030352642],
              [-16.708837681855854, -11.1740342373327],
              [-16.708083186875278, -11.17859232944409],
              [-16.709264147858345, -11.179229641860001],
              [-16.708029392423516, -11.182657451952204],
              [-16.70911677858006, -11.18350114249902],
              [-16.70947820127685, -11.184921816743984],
              [-16.708725533912567, -11.187050214633022],
              [-16.711647908498502, -11.187699195398714],
              [-16.711988380709307, -11.189119547206271],
              [-16.714509621910135, -11.189730045940395],
              [-16.71690332462872, -11.191320717792282],
              [-16.719232581843297, -11.192484986776165],
              [-16.721224077491133, -11.191585663300556],
              [-16.72449944483479, -11.19147016844452],
              [-16.723858129395378, -11.1905833860824],
              [-16.724301244326153, -11.189174942898164],
              [-16.72589440870753, -11.18915713912538],
              [-16.72728693592188, -11.187871984130634],
              [-16.727565348103937, -11.186331430380726],
              [-16.728920498718892, -11.186009229577792],
              [-16.729062000652156, -11.18756776827469],
              [-16.730927320366565, -11.19112665136642],
              [-16.732130177672094, -11.191805251564348],
              [-16.732886932391832, -11.192990453301489],
              [-16.734403604930346, -11.19328291942764],
              [-16.735375341259186, -11.192399136862841],
              [-16.73495426118915, -11.190999075023061],
              [-16.736093095477973, -11.186952531433844],
              [-16.737243218326807, -11.184839060173948],
              [-16.738400403928377, -11.184068072046301],
              [-16.740693422000763, -11.183531298412804],
              [-16.742533361430162, -11.181634369032064],
              [-16.74273818967157, -11.180279908553027],
              [-16.744188674878142, -11.180086419523878],
              [-16.744052510124725, -11.183372233527258],
              [-16.74281145495645, -11.184643579001104],
              [-16.74162620824313, -11.18507862707472],
              [-16.74135839178614, -11.187941098354905],
              [-16.742232806896347, -11.189417361443743],
              [-16.744071588796594, -11.19111203681072],
              [-16.74589067825639, -11.189736975535295],
              [-16.746666413533855, -11.190060546930168],
              [-16.74816173645171, -11.188715079457062],
              [-16.751251654594032, -11.186777942208735],
              [-16.752249499013136, -11.18529000705973],
              [-16.754440358715232, -11.184117597585232],
              [-16.755810466118735, -11.182242121349244],
              [-16.755774095865544, -11.18156993006589],
              [-16.75760454731516, -11.180930246902317],
              [-16.757826432030228, -11.179595569376481],
              [-16.759345621348665, -11.178732158910604],
              [-16.76020203915148, -11.176941867009354],
              [-16.76120960107957, -11.178259124446559],
              [-16.76453986682338, -11.175034320780618],
              [-16.76580312331548, -11.17579468465872],
              [-16.764770310784982, -11.177243055396897],
              [-16.766150747231293, -11.178259591707661],
              [-16.76779078063325, -11.177001768896375],
              [-16.76944457948307, -11.177546513559134],
              [-16.77029262449553, -11.179276978321857],
              [-16.76905285463665, -11.18157622773325],
              [-16.769034474078616, -11.182948061567048],
              [-16.770328110902344, -11.183664199496095],
              [-16.77243169975893, -11.183098801433868],
              [-16.77228418123593, -11.18203905011688],
              [-16.77429673326706, -11.181334737042976],
              [-16.775355251300482, -11.182819180889078],
              [-16.7768618269929, -11.18313286655067],
              [-16.779620684539477, -11.185763801648775],
              [-16.78121998147183, -11.185490327773838],
              [-16.78447747064809, -11.186489071618345],
              [-16.78638473163623, -11.185992363519304],
              [-16.789371618545093, -11.186121646231776],
              [-16.787809599754958, -11.187595825186628],
              [-16.785365280031563, -11.188156305774179],
              [-16.783297702302537, -11.189040100982202],
              [-16.782247788056438, -11.19010300619491],
              [-16.77753369942548, -11.191240508766866],
              [-16.77521490101762, -11.190189105197852],
              [-16.772742141871092, -11.19114740133689],
              [-16.771963507233668, -11.192996871453312],
              [-16.77431460962353, -11.194688709662705],
              [-16.775889492535516, -11.19393188361473],
              [-16.77838911262013, -11.193554974756843],
              [-16.78024743637452, -11.194836690059255],
              [-16.779570449190636, -11.195436895273229],
              [-16.779830388011383, -11.197327145853933],
              [-16.781579227117817, -11.197362535116893],
              [-16.786454834790025, -11.196513063501435],
              [-16.787842755153164, -11.195735155876106],
              [-16.78952837033398, -11.19552333138092],
              [-16.789437267982297, -11.193988377137538],
              [-16.79091123506864, -11.193748039854668],
              [-16.79219456305003, -11.194633056027852],
              [-16.794162959494006, -11.19766192357619],
              [-16.794506668610392, -11.198702389225135],
              [-16.796691362553744, -11.199934469625294],
              [-16.801564607609524, -11.200274239011222],
              [-16.802355151225942, -11.20189693668836],
              [-16.80027130487942, -11.201950032708638],
              [-16.799114181793236, -11.203378447863333],
              [-16.79691662134861, -11.203049072261221],
              [-16.792043892067742, -11.205520691547722],
              [-16.79288324700776, -11.207524677260096],
              [-16.794982606725082, -11.209384871980385],
              [-16.79886002872868, -11.20857715256524],
              [-16.80374282364763, -11.20933617933158],
              [-16.807819698914876, -11.208868717753655],
              [-16.810957180742438, -11.210299835655237],
              [-16.814255868220357, -11.209593218257877],
              [-16.815513455052475, -11.210707072076138],
              [-16.818576795086138, -11.212469782527473],
              [-16.81944686772269, -11.212520031653177],
              [-16.822096744254193, -11.211516107659413],
              [-16.823124413619897, -11.210689463376657],
              [-16.825982414505066, -11.205240799067365],
              [-16.82548835511433, -11.203146236904098],
              [-16.825743334166667, -11.2000486585961],
              [-16.82477505444742, -11.197330825271212],
              [-16.824759173087127, -11.195945678072897],
              [-16.82569525118505, -11.195385731363395],
              [-16.82567848007083, -11.193291335029148],
              [-16.823433576158223, -11.19191632261194],
              [-16.821833003824015, -11.19339414374344],
              [-16.82000439540546, -11.193479797312332],
              [-16.81848866130705, -11.194939001216527],
              [-16.81745010628341, -11.19307902017767],
              [-16.81809429786331, -11.19165367669933],
              [-16.81794399417185, -11.190495279981329],
              [-16.815377345071894, -11.189255073962041],
              [-16.815950559285874, -11.188645613514776],
              [-16.81888619336296, -11.18964643102188],
              [-16.82175534465002, -11.188903793991066],
              [-16.822450761112844, -11.190268938918095],
              [-16.823790723133985, -11.188950969252272],
              [-16.82542847732657, -11.18883741362775],
              [-16.826785838344673, -11.189469465730674],
              [-16.828577029863027, -11.191273742730036],
              [-16.83063432178018, -11.192363768595474],
              [-16.832710649967172, -11.194387000221605],
              [-16.83414233759855, -11.194071784217009],
              [-16.834824854350863, -11.192709610685382],
              [-16.836090514340178, -11.192939055911973],
              [-16.837200572934705, -11.194652767360763],
              [-16.83537791545426, -11.19520223940595],
              [-16.835583898405634, -11.196656217715354],
              [-16.83696032198574, -11.196674337993063],
              [-16.840151072088503, -11.194013201842676],
              [-16.843810402745657, -11.19440169615766],
              [-16.84601958690448, -11.19369555798347],
              [-16.846526985917144, -11.193103323391341],
              [-16.85062326208827, -11.190463369666752],
              [-16.85206539794823, -11.189166223642967],
              [-16.853936727817818, -11.188364440888654],
              [-16.85365247788754, -11.18663704862011],
              [-16.851907799124447, -11.18513931762788],
              [-16.849639906106795, -11.185444048419166],
              [-16.84668795125351, -11.184911529195238],
              [-16.847309009708674, -11.182772707499769],
              [-16.84834530939316, -11.180898510748259],
              [-16.849718911334854, -11.180375916950288],
              [-16.851282873156254, -11.18052931910492],
              [-16.853986476613976, -11.180172905343552],
              [-16.8556644231113, -11.17940732348381],
              [-16.859985102388357, -11.180813559751188],
              [-16.86127542765396, -11.181755505743483],
              [-16.86473375479159, -11.179442213435282],
              [-16.864922996942905, -11.17571436985349],
              [-16.86581280252126, -11.172690378248031],
              [-16.865041373883294, -11.170983801874995],
              [-16.86677418354224, -11.164231880681628],
              [-16.867320825480533, -11.163897834085168],
              [-16.86749662490296, -11.160718579220285],
              [-16.867896357838074, -11.15985915896763],
              [-16.86523870793238, -11.158465963055729],
              [-16.86369885119444, -11.156287221951592],
              [-16.86293572794264, -11.153630308663654],
              [-16.86371459052169, -11.153068598099084],
              [-16.8633007585384, -11.151425900760838],
              [-16.863211580470836, -11.148593343439313],
              [-16.86140709646907, -11.147002730821363],
              [-16.8581267758145, -11.146546835731352],
              [-16.856364535238644, -11.145123607921754],
              [-16.85644601501342, -11.143571283086356],
              [-16.853727421088575, -11.142683430624272],
              [-16.85287880901034, -11.143035454910496],
              [-16.8492530735022, -11.143170881340083],
              [-16.84783188981364, -11.142687715261795],
              [-16.84408881695944, -11.144700031999118],
              [-16.842512232406964, -11.144441320619615],
              [-16.84061722780685, -11.144861210419103],
              [-16.838303199560343, -11.147063949322746],
              [-16.838168547975958, -11.148564146561654],
              [-16.836944385092522, -11.149130568049891],
              [-16.8358332201457, -11.146963531411537],
              [-16.83460547355178, -11.147547533130721],
              [-16.834742153370925, -11.148822367022058],
              [-16.83330228598522, -11.149284173949],
              [-16.833217426641795, -11.152416681342462],
              [-16.832401219846634, -11.152160052777205],
              [-16.829809933649187, -11.154960077449521],
              [-16.829820242938634, -11.15640527286821],
              [-16.828460522292236, -11.156359489937858],
              [-16.827390405328497, -11.153760294730757],
              [-16.828723261559052, -11.15247113986631],
              [-16.830352532786648, -11.14997497136536],
              [-16.829878816194295, -11.148532789939905],
              [-16.831039333467448, -11.148063615843125],
              [-16.83194920269482, -11.14569569062252],
              [-16.83445433486687, -11.143346540886585],
              [-16.84160641657353, -11.140527790569871],
              [-16.84397040696198, -11.139955398226304],
              [-16.844686747042783, -11.138504233475137],
              [-16.844219822648974, -11.137397304261919],
              [-16.845983404458295, -11.13655339310169],
              [-16.8482830243393, -11.134684618731042],
              [-16.850679592507426, -11.135010289371696],
              [-16.85186102244416, -11.13308523686978],
              [-16.85142094619341, -11.131673528012783],
              [-16.854124045609684, -11.12967068174],
              [-16.85231852287107, -11.12871777554855],
              [-16.850820949506485, -11.126084733260667],
              [-16.85036427041735, -11.123901644720723],
              [-16.850721836445835, -11.120681076881148],
              [-16.849392523451726, -11.121348210260091],
              [-16.84799037270385, -11.121012444697397],
              [-16.847778237096218, -11.119954951486207],
              [-16.84545007642218, -11.120014936784978],
              [-16.84324123770161, -11.118569091435818],
              [-16.843160661655563, -11.11785090243142],
              [-16.841228269247406, -11.117587778829762],
              [-16.839840205476982, -11.115583970463819],
              [-16.83821173734745, -11.1157398344264],
              [-16.836986783926946, -11.11642967441761],
              [-16.833618725192732, -11.114402909474812],
              [-16.832993097899156, -11.113002880236493],
              [-16.83067046824108, -11.112192030495413],
              [-16.828793006042464, -11.11311926429267],
              [-16.82779316019195, -11.11277333521374],
              [-16.82581772399589, -11.110770353476186],
              [-16.825268545821014, -11.112022673922313],
              [-16.824094360137227, -11.112452512108854],
              [-16.824631847019457, -11.11579430874576],
              [-16.82533789305322, -11.116713920431788],
              [-16.825149492567817, -11.11850040956582],
              [-16.82369628329425, -11.120265654981205],
              [-16.822933528662915, -11.122179091663813],
              [-16.82171640016136, -11.123201869696413],
              [-16.820275372630423, -11.123382679737253],
              [-16.819999755726368, -11.124624989179576],
              [-16.81695357023465, -11.128422813840793],
              [-16.815574351104587, -11.12981539690315],
              [-16.814434296110484, -11.129818177596588],
              [-16.81389166494812, -11.127859243230656],
              [-16.815658850669013, -11.126834636128667],
              [-16.81676247018448, -11.124869794854494],
              [-16.816270485967895, -11.123267899196827],
              [-16.817724811301144, -11.122712427470843],
              [-16.819121122348026, -11.121404325143564],
              [-16.820301544115217, -11.119025801212482],
              [-16.819999465680546, -11.118014699098786],
              [-16.82107621594836, -11.116779724482758],
              [-16.820668140600656, -11.115786095921406],
              [-16.82146269130669, -11.114166647326252],
              [-16.820674486296262, -11.112597997319876],
              [-16.821469246600373, -11.11036390963685],
              [-16.82014808253068, -11.109579838060622],
              [-16.819029003722466, -11.10653601055864],
              [-16.819787896064536, -11.105433138308866],
              [-16.81853907286707, -11.103808306134994],
              [-16.817018643203756, -11.104550261689905],
              [-16.815612083238104, -11.103502653139271],
              [-16.813764680769278, -11.10302059236535],
              [-16.811663598771613, -11.101698885046838],
              [-16.80958549623544, -11.098587693389426],
              [-16.807019879831657, -11.098498354362821],
              [-16.8065272911502, -11.09933383842582],
              [-16.801140325301017, -11.101497484078896],
              [-16.799504351650832, -11.101314571089153],
              [-16.797693436540076, -11.100167607937463],
              [-16.795303191213836, -11.097625606216821],
              [-16.79322065664568, -11.099257493128043],
              [-16.79506977790489, -11.09936580363082],
              [-16.795753916983323, -11.100223078200374],
              [-16.79495050980523, -11.103579586969179],
              [-16.791626476037163, -11.103572524293293],
              [-16.79027882460498, -11.102440854653299],
              [-16.788647010693648, -11.103255950177472],
              [-16.787641352960616, -11.102144366139667],
              [-16.785538972681202, -11.101892820513132],
              [-16.78718085068206, -11.099704183229004],
              [-16.786962237045778, -11.097697805654946],
              [-16.78336526095045, -11.098148590619973],
              [-16.779907722653185, -11.100435287932166],
              [-16.77746228909243, -11.101798499705579],
              [-16.772658531814173, -11.103745397615372],
              [-16.770696354625823, -11.105420810887432],
              [-16.77006567291825, -11.10431399447135],
              [-16.770957937914957, -11.1030562779963],
              [-16.77125190672549, -11.100943401332934],
              [-16.77371287286161, -11.100494824656472],
              [-16.77419210633085, -11.099013959656219],
              [-16.77568533703647, -11.097446305577337],
              [-16.77576801291393, -11.095326057491135],
              [-16.778103054236038, -11.093748634383457],
              [-16.778160919918694, -11.091170666566661],
              [-16.772910932211133, -11.082954585879227],
              [-16.77316266078559, -11.081249090799226],
              [-16.774056322463846, -11.079910764923513],
              [-16.77297358713623, -11.07750032413516],
              [-16.771990439292413, -11.076839639931945],
              [-16.76994175447406, -11.076554062061334],
              [-16.76695700172587, -11.077603716214094],
              [-16.763373360383174, -11.076800554643512],
              [-16.761301004460634, -11.07501619279507],
              [-16.76163163219997, -11.07411470110634],
              [-16.7601476814874, -11.073392150017593],
              [-16.757290031757435, -11.06821158968873],
              [-16.75542945013817, -11.067473973711378],
              [-16.752837451730723, -11.067163985261748],
              [-16.75168764469408, -11.065498763574524],
              [-16.752278914686585, -11.06440077983919],
              [-16.749775080820363, -11.064010427299827],
              [-16.748955256257382, -11.063521230151174],
              [-16.747727844733852, -11.064759607704639],
              [-16.746337006747705, -11.064869864948554],
              [-16.744943267442704, -11.066059886152075],
              [-16.74321331376247, -11.066239299434796],
              [-16.743699590711067, -11.064529467689962],
              [-16.74264646326974, -11.06272778805735],
              [-16.74460731890564, -11.06184417837389],
              [-16.745144990512824, -11.060253320018793],
              [-16.74453480970653, -11.057483021090851],
              [-16.741428621761706, -11.057738070521484],
              [-16.73951145906311, -11.056414771727782],
              [-16.737054703154474, -11.056937008986784],
              [-16.73580423603276, -11.055726280747747],
              [-16.734032702822784, -11.055941605227908],
              [-16.733824931638065, -11.05883867558495],
              [-16.731561883845654, -11.058845325242032],
              [-16.72953654006858, -11.05799697380034],
              [-16.727907355731563, -11.057804590092717],
              [-16.726578230594033, -11.059409698444265],
              [-16.724896083809632, -11.060117119466332],
              [-16.72394415039846, -11.057617316792143],
              [-16.72531666630992, -11.055194344406239],
              [-16.727513970069868, -11.055256218013774],
              [-16.729622423984598, -11.05405750171577],
              [-16.72941105883205, -11.052826034661713],
              [-16.731936771642797, -11.046105048468236],
              [-16.732835056521534, -11.041788670098608],
              [-16.731172135945645, -11.039446895237072],
              [-16.72827151336007, -11.03873882016962],
              [-16.72665061077007, -11.037027591102246],
              [-16.724387014064675, -11.036503945222165],
              [-16.72361577465716, -11.034262639414498],
              [-16.722571386359594, -11.033310536233273],
              [-16.720902342698007, -11.032834745644314],
              [-16.720866065167613, -11.031756029501652],
              [-16.719289238713728, -11.031465450290737],
              [-16.716759072412874, -11.031788361222933],
              [-16.71643998608529, -11.029537826771985],
              [-16.71866616424601, -11.029579308074013],
              [-16.718963876616012, -11.028540318068893],
              [-16.7177734559993, -11.025908917110707],
              [-16.71767326538386, -11.021557755236755],
              [-16.71705980217901, -11.020289666858362],
              [-16.715761975413884, -11.019547249103336],
              [-16.715134058102024, -11.017448981498221],
              [-16.71369303385599, -11.016958696588569],
              [-16.711760710313, -11.01526168734292],
              [-16.71141824647541, -11.012640795761456],
              [-16.71056932093945, -11.011983762318062],
              [-16.71038017308537, -11.010610369794655],
              [-16.708384362884267, -11.010358355612558],
              [-16.706710475928155, -11.012229500751655],
              [-16.706013878630532, -11.011909465812035],
              [-16.705096035080324, -11.00909812659961],
              [-16.70631566109065, -11.008944704938292],
              [-16.70643914841307, -11.006221349085566],
              [-16.70734631735383, -11.004648544399334],
              [-16.703493575756685, -11.004810561280909],
              [-16.70148544135806, -11.00393680525905],
              [-16.7019533121883, -11.001932116751899],
              [-16.70165898139439, -10.99923271929517],
              [-16.7003833554265, -10.99789562511478],
              [-16.69879739355781, -10.996957488321138],
              [-16.695687599904236, -10.99735625882604],
              [-16.69491844813473, -10.996826164576197],
              [-16.693727655104187, -10.99349010935944],
              [-16.690630064783335, -10.990272764582595],
              [-16.688146609338933, -10.989128255791165],
              [-16.68673131775608, -10.98794925613962],
              [-16.689405836308904, -10.986997081974941],
              [-16.691449907377823, -10.987914777531246],
              [-16.693179611260906, -10.989313759238309],
              [-16.695029505148867, -10.98993346891137],
              [-16.6962437258186, -10.988955459858685],
              [-16.698107116508428, -10.988378030030036],
              [-16.697569862390054, -10.986455001157893],
              [-16.705879210712247, -10.987275962790152],
              [-16.710810614025988, -10.98897714537555],
              [-16.712899368012586, -10.990801580917717],
              [-16.71481774310822, -10.990843233946784],
              [-16.71654694676189, -10.992321135118608],
              [-16.71890184974257, -10.993826174482015],
              [-16.72111754076355, -10.996605107983497],
              [-16.722914287761405, -10.997783499293883],
              [-16.726481919942824, -11.000963290463018],
              [-16.72713346322464, -11.002312672238357],
              [-16.728795972072955, -11.003563839902988],
              [-16.732500134932984, -11.007703408720312],
              [-16.733590471054207, -11.009567574458309],
              [-16.738343290939195, -11.012823427168259],
              [-16.740635440805477, -11.01498522108909],
              [-16.74117818005363, -11.015999957571857],
              [-16.744860060861402, -11.017969569801128],
              [-16.747639617205852, -11.02065482227882],
              [-16.751847958444305, -11.024001977607558],
              [-16.75401163940276, -11.025329605171663],
              [-16.75499197707427, -11.026941396010944],
              [-16.757293763591306, -11.027984638718705],
              [-16.763735533041483, -11.029142466294703],
              [-16.771993588807504, -11.033183984083456],
              [-16.774008100594575, -11.034696370320805],
              [-16.774723844574982, -11.036153103361443],
              [-16.774629517426515, -11.039142645445207],
              [-16.775884729964933, -11.041043744973107],
              [-16.778031487522846, -11.042895368121124],
              [-16.780938687513228, -11.044425753534856],
              [-16.782308825342696, -11.04476695073011],
              [-16.783209539734543, -11.046417284064262],
              [-16.781061710411752, -11.047746939043648],
              [-16.779749213703976, -11.048071294390825],
              [-16.777160833559677, -11.049923100736539],
              [-16.773784731880163, -11.053653359102336],
              [-16.77063200387459, -11.054861332202954],
              [-16.76841130044749, -11.056892656617842],
              [-16.76930346624979, -11.0576738118328],
              [-16.772222023997234, -11.056042191428539],
              [-16.777624628833852, -11.050935979933548],
              [-16.781630236188043, -11.048224261314271],
              [-16.78721217263453, -11.045901560192368],
              [-16.789788988742078, -11.046493542264077],
              [-16.792991461896907, -11.04495188778792],
              [-16.799150524183563, -11.044087216333063],
              [-16.80130725210241, -11.0433857628258],
              [-16.805173322835667, -11.043107978998798],
              [-16.80798247375641, -11.041922171963652],
              [-16.809949497627567, -11.041990908525031],
              [-16.813300101196845, -11.03970417604916],
              [-16.816735075622532, -11.038538325286977],
              [-16.823016223407706, -11.033823901946203],
              [-16.82883695346185, -11.029791313346964],
              [-16.833728352576905, -11.026560348636831],
              [-16.839198609489298, -11.022497822795389],
              [-16.842640221876042, -11.019161271251384],
              [-16.84452273716205, -11.016616793259718],
              [-16.84664041285658, -11.01325352076666],
              [-16.84873832760615, -11.009188138079454],
              [-16.850328854456425, -11.005314409699764],
              [-16.851812006532384, -11.000777005306256],
              [-16.84981654511011, -10.996710161410856],
              [-16.84918832066301, -10.99297614955701],
              [-16.847632366941408, -10.990517532344295],
              [-16.845522330939087, -10.986207261344415],
              [-16.8430348193051, -10.977792751469273],
              [-16.841493711212905, -10.971210803063753],
              [-16.840403354878735, -10.962653249330245],
              [-16.838724275922036, -10.960787037915773],
              [-16.83786873435506, -10.959030739980307],
              [-16.83398271602528, -10.952279965691115],
              [-16.832460451559626, -10.948200107152722],
              [-16.832020582345766, -10.945091364560161],
              [-16.83091175390998, -10.941325866303254],
              [-16.829566621712516, -10.93343567012692],
              [-16.82839341410932, -10.925433108704096],
              [-16.828089989733403, -10.920870482560003],
              [-16.827671591108327, -10.918203033736184],
              [-16.825316086691434, -10.910260060320804],
              [-16.82399615206132, -10.908574455188232],
              [-16.820399771922578, -10.905358332389374],
              [-16.819954732459617, -10.903909051535107],
              [-16.818407145515245, -10.901432647080755],
              [-16.816265641778674, -10.897147498237109],
              [-16.812249189940413, -10.890552825718665],
              [-16.81113685068108, -10.888046325111688],
              [-16.809455391845606, -10.886475497933356],
              [-16.7991958450613, -10.875761291136556],
              [-16.794594315099758, -10.870247871949367],
              [-16.789835806896246, -10.862266043606985],
              [-16.778837746909996, -10.846204557682672],
              [-16.77643430061486, -10.840845718187117],
              [-16.775746957424438, -10.83709837084264],
              [-16.774740678594696, -10.833433940262813],
              [-16.773862089723202, -10.826600194050798],
              [-16.77312245193299, -10.81696930123106],
              [-16.77374888843272, -10.806840779930683],
              [-16.773798303981554, -10.800533335203987],
              [-16.773580251071063, -10.794437813696154],
              [-16.772743266584797, -10.792087746905036],
              [-16.7715725705362, -10.790762503275898],
              [-16.769331192021358, -10.789573467744376],
              [-16.766608453449596, -10.788682447804868],
              [-16.76366842664507, -10.786566660628152],
              [-16.76317942795639, -10.785341423348637],
              [-16.762089619808002, -10.78493299517681],
              [-16.76020064817049, -10.78588353991442],
              [-16.75969030141896, -10.783498751060641],
              [-16.75948508071764, -10.775256662384631],
              [-16.758674513248472, -10.768838815502466],
              [-16.758436337065007, -10.762767440991302],
              [-16.75840413152503, -10.751447073850331],
              [-16.758794235882725, -10.741905521208482],
              [-16.758527711996077, -10.739310669943363],
              [-16.757262265019328, -10.73284894707164],
              [-16.756402706354674, -10.73122495490007],
              [-16.757155454331215, -10.729281313549373],
              [-16.76328427817173, -10.725261175323595],
              [-16.767031562397275, -10.720984905706244],
              [-16.769395601044938, -10.71642397117667],
              [-16.771327198990175, -10.707994410167705],
              [-16.772523341943813, -10.700589021255261],
              [-16.77326754839349, -10.697821015106483],
              [-16.77471960314885, -10.6938582188617],
              [-16.77909514526261, -10.686799294760867],
              [-16.781182723016553, -10.682703750159659],
              [-16.781604816055484, -10.68090504741305],
              [-16.782737484626345, -10.678615024169408],
              [-16.783681862951013, -10.674339266736766],
              [-16.783641552456405, -10.671043225459357],
              [-16.78137870027798, -10.669284924013693],
              [-16.77891615183788, -10.666981103750935],
              [-16.77609361808038, -10.665586611594712],
              [-16.769386709907366, -10.663931731205777],
              [-16.765470073751107, -10.662676701448582],
              [-16.761943239806257, -10.660819881581228],
              [-16.760441068179336, -10.659511815318728],
              [-16.759251661769223, -10.657251056446583],
              [-16.758709363118047, -10.655429713738624],
              [-16.759141695323795, -10.652151927312248],
              [-16.756611674214433, -10.650685764201134],
              [-16.7521367953765, -10.649259359254716],
              [-16.7386683246823, -10.647974943603085],
              [-16.733556910454254, -10.64727624589646],
              [-16.730800495929927, -10.64643630779102],
              [-16.72600768599019, -10.64564630113532],
              [-16.72463874786508, -10.644806309919414],
              [-16.72117999742809, -10.64341216405785],
              [-16.71949395168902, -10.642215773973788],
              [-16.71894064491349, -10.639265949019409],
              [-16.71736215382062, -10.637624951649485],
              [-16.71395967531253, -10.634958287150386],
              [-16.712533192412312, -10.633451899992417],
              [-16.698430697615628, -10.62124356741166],
              [-16.69692283277276, -10.619816991849895],
              [-16.69688815429527, -10.618851962571071],
              [-16.69493197693673, -10.617521250401897],
              [-16.69350968232827, -10.615175464721753],
              [-16.690045669284867, -10.612098813141682],
              [-16.687005433882742, -10.610232944663343],
              [-16.684552541646312, -10.607558717620883],
              [-16.679977962800848, -10.602106353609715],
              [-16.675616391084993, -10.598142565932605],
              [-16.675267568497695, -10.597047426657282],
              [-16.67237817702272, -10.595150652263648],
              [-16.668783982886417, -10.592061553234062],
              [-16.665266648298633, -10.586700856571117],
              [-16.665295237505916, -10.585345460456846],
              [-16.6633148938084, -10.583614770752943],
              [-16.659996310491323, -10.5826110977925],
              [-16.65520774956723, -10.580179024023058],
              [-16.647889350042508, -10.575344499535058],
              [-16.646062469455202, -10.573338204051154],
              [-16.64309579335937, -10.57183991108897],
              [-16.636927885648994, -10.568008116563503],
              [-16.635959818426684, -10.566262850310958],
              [-16.63305534119503, -10.564492790086696],
              [-16.629422399506932, -10.563195734911348],
              [-16.624770980096443, -10.560720856215742],
              [-16.61804549568118, -10.554333819438058],
              [-16.61719811653274, -10.553669486528213],
              [-16.613938810423043, -10.553105184370157],
              [-16.611501487975218, -10.55419991561702],
              [-16.609841062047376, -10.555417089950017],
              [-16.609324395254493, -10.55647145453127],
              [-16.607671346490022, -10.557935702413372],
              [-16.605377340524942, -10.56231188039856],
              [-16.60343715532177, -10.56746651415787],
              [-16.601853177860015, -10.570569481516975],
              [-16.59775587644152, -10.577484716331883],
              [-16.593009357213734, -10.583688219892348],
              [-16.58908322561276, -10.587463205010053],
              [-16.583049400541555, -10.594836417603704],
              [-16.582016053728648, -10.597336572500659],
              [-16.580309165926554, -10.598919416229728],
              [-16.575705410606375, -10.598259010983423],
              [-16.572486825958606, -10.598755465239595],
              [-16.571147114746378, -10.5981991404576],
              [-16.567452547453247, -10.599226657307407],
              [-16.565719070471463, -10.601886581115906],
              [-16.56256699410987, -10.603264544380197],
              [-16.56056635808553, -10.602948203448523],
              [-16.55829016074932, -10.601175675332218],
              [-16.55638897249316, -10.601224839441183],
              [-16.553536081107133, -10.602977648184556],
              [-16.5508978675164, -10.603182584098628],
              [-16.55016278287517, -10.606620471653914],
              [-16.550737897697243, -10.608455690219994],
              [-16.550254829994245, -10.609748012626328],
              [-16.549124651798913, -10.609721452112863],
              [-16.548013910683807, -10.610696741128507],
              [-16.546567638615137, -10.60989050053231],
              [-16.545013328906467, -10.607556502245938],
              [-16.545743836620545, -10.604878296289408],
              [-16.545425814937488, -10.599538606606426],
              [-16.544356618994854, -10.59919477811139],
              [-16.54259195349777, -10.599649702558896],
              [-16.541636044712178, -10.597472870383845],
              [-16.538709948498443, -10.597447379116097],
              [-16.537931301905154, -10.594061582319581],
              [-16.535704107953663, -10.591908640833248],
              [-16.534342385567275, -10.587869663929084],
              [-16.531990138048265, -10.585169556432085],
              [-16.531580457823527, -10.583986272732323],
              [-16.531961119770585, -10.582740944511231],
              [-16.530253221569318, -10.579761464514744],
              [-16.527103555222737, -10.575376943642523],
              [-16.524133126971343, -10.572757074501519],
              [-16.52110618155763, -10.572065446891763],
              [-16.518927389822643, -10.572757790298924],
              [-16.51531031848546, -10.571974767366637],
              [-16.514278661018654, -10.572349308409118],
              [-16.51067123300289, -10.572044332165206],
              [-16.509532972390893, -10.571573627698767],
              [-16.50843389856212, -10.572981599877483],
              [-16.50518446090544, -10.573973326035036],
              [-16.5034607680262, -10.57506388637825],
              [-16.502064730122452, -10.57470971896488],
              [-16.499042396867434, -10.575422415486448],
              [-16.498877413291037, -10.5760909133906],
              [-16.495716751473495, -10.577183994096305],
              [-16.494546119365857, -10.578170887501566],
              [-16.492484244777923, -10.578548149373045],
              [-16.49218741710083, -10.58058655934655],
              [-16.489795898465395, -10.584388862132412],
              [-16.488043143725566, -10.585554998762062],
              [-16.486285623070938, -10.585581601810688],
              [-16.48441421366049, -10.584900749853974],
              [-16.482383478231878, -10.584788582871267],
              [-16.479030677376446, -10.582441821136637],
              [-16.475511977989758, -10.580772540186198],
              [-16.474772904220977, -10.58068625828705],
              [-16.472222110703257, -10.581974792932801],
              [-16.470113532672837, -10.58241496162546],
              [-16.467537141410517, -10.584083290417723],
              [-16.46519564331458, -10.583786831941238],
              [-16.461454998709236, -10.585057534050078],
              [-16.458265144778647, -10.585643731629126],
              [-16.456385942653515, -10.587116958695056],
              [-16.455067511723122, -10.58922828818094],
              [-16.453538699805886, -10.588565064868408],
              [-16.451149804490733, -10.590663879025053],
              [-16.449961854535253, -10.590323039147025],
              [-16.449778255851637, -10.58891036260838],
              [-16.44814912502133, -10.588239587250376],
              [-16.445102005286937, -10.59021315840603],
              [-16.443591618250466, -10.591569757108955],
              [-16.4375538947495, -10.592375876098181],
              [-16.427722156696912, -10.591133922723712],
              [-16.422348335054803, -10.591117724169711],
              [-16.420853731441643, -10.59055249772869],
              [-16.420363279258094, -10.591738746831597],
              [-16.41753537707777, -10.593100389155556],
              [-16.414928389204615, -10.593095920996706],
              [-16.411155460120696, -10.592727774962755],
              [-16.41009336511373, -10.592132023639039],
              [-16.406606287433338, -10.592743234701688],
              [-16.403274216040337, -10.595687944745153],
              [-16.39814186078717, -10.59509759411608],
              [-16.396340578061874, -10.595928390862825],
              [-16.39453919899884, -10.598101071222136],
              [-16.39058934970998, -10.59897559723748],
              [-16.388809014571816, -10.600047486396512],
              [-16.38681305151558, -10.602064956327803],
              [-16.386152181783956, -10.604663166189216],
              [-16.382577736094, -10.605233117168664]
            ]
          ],
          [
            [
              [-16.895232519680736, -10.804632441880718],
              [-16.894316204774466, -10.803713293986801],
              [-16.893990223073065, -10.802242570591675],
              [-16.89381709175978, -10.798382151288966],
              [-16.890072479048136, -10.798842976239357],
              [-16.887019607318255, -10.798105646306857],
              [-16.884197690113183, -10.796521794755693],
              [-16.8826051866585, -10.794973808796376],
              [-16.881886557225094, -10.793005286587139],
              [-16.881715259571255, -10.790566708535641],
              [-16.881960778443208, -10.787897672807306],
              [-16.882805087050162, -10.78573310114608],
              [-16.88434975292636, -10.784765046881901],
              [-16.88227796124046, -10.78288035205325],
              [-16.879403381799868, -10.781822561495881],
              [-16.877926318016467, -10.780603514136292],
              [-16.87699430791721, -10.777658222097694],
              [-16.87540205540829, -10.773600414203498],
              [-16.874403164140613, -10.768914151961175],
              [-16.87475071065484, -10.765645886985874],
              [-16.874208816276667, -10.763363548095771],
              [-16.875023587435294, -10.760839346293936],
              [-16.87652409849547, -10.758578807007769],
              [-16.875315538369154, -10.75672257503049],
              [-16.876184739351768, -10.755050094888324],
              [-16.87773664153546, -10.755056273297848],
              [-16.87785577949891, -10.753847056981789],
              [-16.875184341158796, -10.753079555679038],
              [-16.873881158140875, -10.751665739358113],
              [-16.87316195306618, -10.749865460506628],
              [-16.87379908064286, -10.749076355223446],
              [-16.873531248284472, -10.747209287081052],
              [-16.87405475068159, -10.746134231930943],
              [-16.871294986801903, -10.745646257104607],
              [-16.870506352197726, -10.744773990282313],
              [-16.869397968578756, -10.744982451411888],
              [-16.866630898770325, -10.747280759061601],
              [-16.861652327982853, -10.749752772722761],
              [-16.857219318397767, -10.751714746890064],
              [-16.853815933663835, -10.754598383379385],
              [-16.853419042610067, -10.755475288940747],
              [-16.85556049167494, -10.756190886606198],
              [-16.860638303477955, -10.759587351585271],
              [-16.863695513949835, -10.762353075548615],
              [-16.864610402557705, -10.764404803001996],
              [-16.862226829420454, -10.768580475797927],
              [-16.86189916254952, -10.771120788649275],
              [-16.863240221161075, -10.772660982679314],
              [-16.86410848949056, -10.771108852759859],
              [-16.86690747110754, -10.771843312598694],
              [-16.869730878203303, -10.77310443412817],
              [-16.871962338995143, -10.774995013299524],
              [-16.87418906469578, -10.77968089382039],
              [-16.874872593882035, -10.782700070563347],
              [-16.876838005631637, -10.784015621728127],
              [-16.877732083555554, -10.786880299460858],
              [-16.876690430694822, -10.79009312255601],
              [-16.875739471935802, -10.791686761081955],
              [-16.8742149319852, -10.793263389881341],
              [-16.873219809753316, -10.794937325069426],
              [-16.87440415798167, -10.796393204117683],
              [-16.878500380608283, -10.799153763009368],
              [-16.883354798661916, -10.801326707338076],
              [-16.88658627574245, -10.802963699135256],
              [-16.88954401535841, -10.80418585695318],
              [-16.891429370380433, -10.805620676984104],
              [-16.89346930105208, -10.806003793702127],
              [-16.895232519680736, -10.804632441880718]
            ]
          ],
          [
            [
              [-16.989566109766, -10.868941546166221],
              [-16.986396857713675, -10.86340984158747],
              [-16.985635943277682, -10.86261400565549],
              [-16.98428532964667, -10.865100463732174],
              [-16.9807356929561, -10.865310289414513],
              [-16.979124096011166, -10.8664837695308],
              [-16.977550004882872, -10.870008724592916],
              [-16.97682450394997, -10.87071914417054],
              [-16.9767764517606, -10.873602195433207],
              [-16.97547116154081, -10.87654893732066],
              [-16.975661260467284, -10.881085879689888],
              [-16.97358303093801, -10.885373848072664],
              [-16.97365151649461, -10.887555264326942],
              [-16.974417400003, -10.887980922734762],
              [-16.97412799280385, -10.890804808902415],
              [-16.974927398577616, -10.892769527678974],
              [-16.9758751944377, -10.892706515010728],
              [-16.976401763633767, -10.89047083503538],
              [-16.977115254929434, -10.889174944827431],
              [-16.978607939367826, -10.88842821115297],
              [-16.98016180013995, -10.886499607012711],
              [-16.98314400932151, -10.880835044789848],
              [-16.986125763595027, -10.876311935477533],
              [-16.987107927521965, -10.87443905066413],
              [-16.98809972799171, -10.874012240159662],
              [-16.988227698916305, -10.872742789893262],
              [-16.989472628452614, -10.870071606255781],
              [-16.989566109766, -10.868941546166221]
            ]
          ],
          [
            [
              [-17.00475980982042, -10.848735317101275],
              [-17.00391392484447, -10.848058098183753],
              [-17.00283961468637, -10.84891640820543],
              [-17.003621109662106, -10.849838898755133],
              [-17.00475980982042, -10.848735317101275]
            ]
          ],
          [
            [
              [-17.090604605070887, -11.32200596085722],
              [-17.099518847213854, -11.322180142464655],
              [-17.09809457845255, -11.32113872923365],
              [-17.09698249063381, -11.321005866970964],
              [-17.095227910574618, -11.31945470126101],
              [-17.092634289473956, -11.318655327052591],
              [-17.090604605070887, -11.32200596085722]
            ]
          ],
          [
            [
              [-17.11658781296421, -11.270716753299268],
              [-17.113396256507848, -11.269655044653533],
              [-17.113888335934508, -11.271767442183219],
              [-17.11559272415922, -11.272120526060307],
              [-17.11658781296421, -11.270716753299268]
            ]
          ],
          [
            [
              [-17.150023974189768, -11.143260731583092],
              [-17.148737508021075, -11.139872758979985],
              [-17.14748517622532, -11.137779082618575],
              [-17.145886098677025, -11.137100978883566],
              [-17.144240161539926, -11.137131693257016],
              [-17.142421482936598, -11.137703516334856],
              [-17.140807171702757, -11.139151982905995],
              [-17.138628470674554, -11.137009110627796],
              [-17.136388775815607, -11.137409808844549],
              [-17.133147275858406, -11.13638443013549],
              [-17.131341031858636, -11.135369479355711],
              [-17.130476249532677, -11.132777192446568],
              [-17.127364152220643, -11.131626462269805],
              [-17.124803312833627, -11.130229638751214],
              [-17.123067919187065, -11.130923678917188],
              [-17.12227659562863, -11.129791146297649],
              [-17.117163734945958, -11.13083025646061],
              [-17.11643843023993, -11.131699226032348],
              [-17.116507994829206, -11.13328440618793],
              [-17.115220129946657, -11.13560794465871],
              [-17.115038764968773, -11.1369409094564],
              [-17.11282084414112, -11.139340039200622],
              [-17.110777701886178, -11.14107310841656],
              [-17.109295617131455, -11.141517666789104],
              [-17.10944489079458, -11.143480676489453],
              [-17.10891038828411, -11.146230164405758],
              [-17.108395628370832, -11.147018265013328],
              [-17.108203174259064, -11.149354642443456],
              [-17.109655694734567, -11.151957489478253],
              [-17.11103818429242, -11.153181847057716],
              [-17.112110629537924, -11.1558655160085],
              [-17.11336986330145, -11.156796494387756],
              [-17.116406660351355, -11.157534340872207],
              [-17.11921934324919, -11.159690788311815],
              [-17.12127322451404, -11.16171456682324],
              [-17.122010647406626, -11.159631308267143],
              [-17.12433291308774, -11.160027019765122],
              [-17.125437165206158, -11.159451359126795],
              [-17.128731863981063, -11.159854248361425],
              [-17.129698194882142, -11.160614326139806],
              [-17.134386743587868, -11.161277550249068],
              [-17.138693228896713, -11.162228458710409],
              [-17.14004944855934, -11.16182042921111],
              [-17.14361846223776, -11.159462987841803],
              [-17.145663762009143, -11.157178583830484],
              [-17.144751496386363, -11.154624509213708],
              [-17.14411188036451, -11.1494000383696],
              [-17.14578383107342, -11.145862557173913],
              [-17.147814687048946, -11.145291607327755],
              [-17.14967192932433, -11.145428546368692],
              [-17.150522777990776, -11.144473972955604],
              [-17.150023974189768, -11.143260731583092]
            ]
          ],
          [
            [
              [-17.237223727157772, -11.148825178373817],
              [-17.236293029137027, -11.14736507218075],
              [-17.233399231711413, -11.146428176074876],
              [-17.23215350618518, -11.14678360064094],
              [-17.230696322254612, -11.14615844355118],
              [-17.23038007196073, -11.147431397470994],
              [-17.232914642822713, -11.147993919371642],
              [-17.235957195968393, -11.149515326935765],
              [-17.237223727157772, -11.148825178373817]
            ]
          ],
          [
            [
              [-17.13052279837955, -10.615007356960806],
              [-17.1312904860913, -10.525232881094022],
              [-17.138808544414328, -10.525293660134704],
              [-17.139514394868264, -10.435498366365954],
              [-17.05881870046657, -10.434587948485014],
              [-16.91205332905766, -10.431449320957258],
              [-16.812090716274188, -10.428215408291777],
              [-16.78056275933886, -10.427010902272738],
              [-16.778121440431104, -10.486830588544882],
              [-16.718004600308475, -10.48429392480173],
              [-16.716999943941087, -10.505949432137646],
              [-16.721164673909783, -10.508207098353099],
              [-16.725435565462824, -10.511446402742724],
              [-16.726895291613285, -10.51307964743761],
              [-16.730913697284752, -10.520084537204918],
              [-16.732546047046238, -10.522340890036395],
              [-16.733787581876438, -10.527253924562727],
              [-16.73558956960752, -10.531755953900293],
              [-16.737904099660387, -10.536936759867746],
              [-16.739695250149545, -10.539495579551355],
              [-16.74016929351788, -10.543820871265751],
              [-16.74266484931828, -10.549952484228795],
              [-16.746861713631407, -10.55680962756945],
              [-16.75112264184179, -10.558399159292634],
              [-16.75603071293684, -10.559318918990378],
              [-16.76234166425138, -10.559985973034507],
              [-16.768447052123534, -10.561534079392638],
              [-16.770937403710548, -10.563045932615523],
              [-16.772822642129167, -10.56654033719635],
              [-16.774617955211415, -10.568823498611188],
              [-16.776150295199297, -10.570177988976639],
              [-16.77965801066381, -10.571069030146194],
              [-16.78451280270269, -10.570676658486716],
              [-16.785529273717522, -10.570344349602667],
              [-16.790022942902105, -10.570038721146005],
              [-16.797532346661235, -10.570712643113],
              [-16.800882962272944, -10.570866133915747],
              [-16.80457347624688, -10.574242094716356],
              [-16.80642050776298, -10.575330916654114],
              [-16.808758284824858, -10.577308218460846],
              [-16.814937145038673, -10.58398182421798],
              [-16.82289946913012, -10.590367691146712],
              [-16.82413963975438, -10.591687421251358],
              [-16.82582464495937, -10.594637652942309],
              [-16.82590632166965, -10.596015441123082],
              [-16.8321726620983, -10.603034831909573],
              [-16.8343376722917, -10.604749589111728],
              [-16.837925774805367, -10.605285200922646],
              [-16.839094099650943, -10.610778388623782],
              [-16.84271824157829, -10.615014410573458],
              [-16.846989492785685, -10.619291944256645],
              [-16.850477235765506, -10.624182678778304],
              [-16.851831676191516, -10.627086845470114],
              [-16.851698319114444, -10.631042468747946],
              [-16.851347202844472, -10.633071456628794],
              [-16.849549222953733, -10.638435748544163],
              [-16.84704791473681, -10.643619398192785],
              [-16.84273372455773, -10.650267213770423],
              [-16.838976727495105, -10.658219749791192],
              [-16.8380700104497, -10.65983369311738],
              [-16.83718430044064, -10.662376200355407],
              [-16.83435283120649, -10.668776494136235],
              [-16.833935927560034, -10.671491826079071],
              [-16.83424836220706, -10.674635059852625],
              [-16.835853799219837, -10.67643123120795],
              [-16.84162394616171, -10.675405405657584],
              [-16.843803132502067, -10.67218496960536],
              [-16.847596018278608, -10.670944786296973],
              [-16.851905059453607, -10.670046918979624],
              [-16.852690522393967, -10.669298571573139],
              [-16.85384683704007, -10.66631917293257],
              [-16.85553482014265, -10.664470122548963],
              [-16.858591946141495, -10.66362868495776],
              [-16.860671857733617, -10.664887587466055],
              [-16.861337617836238, -10.666443101526948],
              [-16.866103117859616, -10.671071316576608],
              [-16.8708103395595, -10.673931173113006],
              [-16.87390771346633, -10.672559090144288],
              [-16.87542771218441, -10.67393867822976],
              [-16.877997134179743, -10.674622295481727],
              [-16.879990448537264, -10.676466959310538],
              [-16.881861326342772, -10.680718869319916],
              [-16.882990954731177, -10.681659154777156],
              [-16.88417417979978, -10.684310974276801],
              [-16.88562531406095, -10.68631255361014],
              [-16.886937106158822, -10.686981115410987],
              [-16.888395536736915, -10.686951628275272],
              [-16.889902664078722, -10.687862140356419],
              [-16.8931027158827, -10.692642639563669],
              [-16.894068140310946, -10.694424917591217],
              [-16.893799305740675, -10.696476333934088],
              [-16.897349908898345, -10.701257523330101],
              [-16.899691952708057, -10.700958403991644],
              [-16.900248858252287, -10.701686581583006],
              [-16.897633171356688, -10.70503798590343],
              [-16.898514346068257, -10.707570611799023],
              [-16.899620240997017, -10.709284763590356],
              [-16.899712432260767, -10.713938242412292],
              [-16.900235928212354, -10.71638457971554],
              [-16.903237128310845, -10.718406974792025],
              [-16.90336237254313, -10.71956943158745],
              [-16.906152618254684, -10.721865552351897],
              [-16.908755810711842, -10.721545804320115],
              [-16.920432173438638, -10.731318389068491],
              [-16.92407316616387, -10.734719672316757],
              [-16.927949354665277, -10.739113314727792],
              [-16.9285685255879, -10.740684065933765],
              [-16.93044546533297, -10.742649047940104],
              [-16.931003705684756, -10.743993302329388],
              [-16.935100355457852, -10.749532060989159],
              [-16.936688948361002, -10.753612499376525],
              [-16.93709349406503, -10.755340645870318],
              [-16.93641777072363, -10.757001187587797],
              [-16.937206042577298, -10.758112529640414],
              [-16.938620169171, -10.761247359798135],
              [-16.938759935528196, -10.766506068003343],
              [-16.938162444196895, -10.771728881886917],
              [-16.936691975071923, -10.776510820585342],
              [-16.934110819297338, -10.780598106817239],
              [-16.931569999529717, -10.782296723152934],
              [-16.928105071952537, -10.783302826781647],
              [-16.92552530257105, -10.785627506123843],
              [-16.923844368871418, -10.786785900494545],
              [-16.92175000989165, -10.787455112568052],
              [-16.92230838257652, -10.78876675944222],
              [-16.928391789272464, -10.793363637230039],
              [-16.928913001003156, -10.79405323214268],
              [-16.933304997264237, -10.797442826980681],
              [-16.933222877194176, -10.799814209093702],
              [-16.934252922061184, -10.800407876062994],
              [-16.937837899341766, -10.800496856695677],
              [-16.9412160821398, -10.801472775904415],
              [-16.94454681559999, -10.803541920471554],
              [-16.945176290982783, -10.804612377811024],
              [-16.94541966573592, -10.807196251072474],
              [-16.94713602561963, -10.811602776184321],
              [-16.946724494997238, -10.814132598459343],
              [-16.947040982641113, -10.816832344823595],
              [-16.947883793817923, -10.818730608789238],
              [-16.947908424443362, -10.820234850672017],
              [-16.949582433174324, -10.822306974592381],
              [-16.950256293499653, -10.824152350947003],
              [-16.95177638666826, -10.825834915966457],
              [-16.95455079471021, -10.826651696711803],
              [-16.956451540574683, -10.826508163415548],
              [-16.960586677120038, -10.828435468900866],
              [-16.962554110192865, -10.82968141523252],
              [-16.966146393841164, -10.832528135897325],
              [-16.9691004076503, -10.835502610891199],
              [-16.972327258567283, -10.84013131299856],
              [-16.973504365787406, -10.842681124733318],
              [-16.97410190665783, -10.846339034118664],
              [-16.975504075696115, -10.84714285079775],
              [-16.97526805931325, -10.848502491049315],
              [-16.97710179661863, -10.848419337944133],
              [-16.98467852958545, -10.849270219516375],
              [-16.98754461443584, -10.850063560302727],
              [-16.98758733818109, -10.847985020995779],
              [-16.990089423776023, -10.848261282536834],
              [-16.990314070166026, -10.84651287887882],
              [-16.99157351857873, -10.844318557200777],
              [-16.99344430215511, -10.842388173130633],
              [-16.995251030313597, -10.841624511201212],
              [-16.996421490943394, -10.841645399703554],
              [-16.997219960077523, -10.842841691968893],
              [-16.996129670005118, -10.844876675363286],
              [-16.99753439361191, -10.845616792054887],
              [-16.998189192385475, -10.844774291141611],
              [-17.000946239284183, -10.84372824640782],
              [-17.001109570308184, -10.844830607877702],
              [-17.00254403500459, -10.84512271456723],
              [-17.002408789573042, -10.843634024483533],
              [-17.003973858969175, -10.842503417287908],
              [-17.00604858763065, -10.84476163963874],
              [-17.00738972315814, -10.846700738584863],
              [-17.00637975666274, -10.847842531072523],
              [-17.007055666301994, -10.849077219534633],
              [-17.008835152242543, -10.848580850565504],
              [-17.010159994536092, -10.847098145677432],
              [-17.012773564934676, -10.848359671323912],
              [-17.015367089299406, -10.848149708362104],
              [-17.020221828974407, -10.845995642881551],
              [-17.025261500744705, -10.844902243340263],
              [-17.026631718275357, -10.844192567357508],
              [-17.02913638502799, -10.84211755623586],
              [-17.031117353307497, -10.841743716997234],
              [-17.032371237032127, -10.842985817588689],
              [-17.030764226875483, -10.845524073321096],
              [-17.029652316939245, -10.847949251425385],
              [-17.02692361385536, -10.850999276084366],
              [-17.02107724088358, -10.855584942574064],
              [-17.017993195968753, -10.857568597220208],
              [-17.016425340891956, -10.857703981419789],
              [-17.015092389763236, -10.858495272496365],
              [-17.01120963647776, -10.85903648970567],
              [-17.01085858266806, -10.86017167122944],
              [-17.006892031810256, -10.862871659092088],
              [-17.005832045023872, -10.86581972101604],
              [-17.00428625452623, -10.866514354901195],
              [-17.001918705454756, -10.868448282564275],
              [-16.999201756238215, -10.869253092961324],
              [-16.996080417949198, -10.868621360327868],
              [-16.997172383666264, -10.870703237484529],
              [-16.995903374436914, -10.872270420742455],
              [-16.99541070421026, -10.874165012463529],
              [-16.995775402073377, -10.875533889820316],
              [-16.99748422657695, -10.877564915460527],
              [-16.99633419736923, -10.87952610329834],
              [-16.99327368047026, -10.88183537861477],
              [-16.992306520564423, -10.883921245918941],
              [-16.99025144630353, -10.885227847411917],
              [-16.988968799315824, -10.88534497292731],
              [-16.987838391034504, -10.887058979376809],
              [-16.984144636504386, -10.888864092031534],
              [-16.981588312738676, -10.890548492437025],
              [-16.98109534895703, -10.89233751229725],
              [-16.979815227377035, -10.89515291646024],
              [-16.978238253522495, -10.89638769557022],
              [-16.977148895840635, -10.898495254642969],
              [-16.97672671393002, -10.90122449652035],
              [-16.97747462297864, -10.90295907325276],
              [-16.977584078327364, -10.908365106319538],
              [-16.978851181427338, -10.91195444128242],
              [-16.979469591056777, -10.912069851352376],
              [-16.98164684557355, -10.915740231359115],
              [-16.981393903163237, -10.919812080196136],
              [-16.98250145516286, -10.921290004182831],
              [-16.982462329659345, -10.92215007780139],
              [-16.98565421697089, -10.925023678916963],
              [-16.98747424994971, -10.927172488230012],
              [-16.99003175395892, -10.930771377646801],
              [-16.989728849766024, -10.931380511832588],
              [-16.993551057478236, -10.935087571566573],
              [-16.99539004085082, -10.938509178631135],
              [-16.99665877878594, -10.94557542078305],
              [-16.99688653548978, -10.947674674131676],
              [-16.99652137677538, -10.949310836583486],
              [-16.997073649866966, -10.951807212879551],
              [-16.999584185643204, -10.956129858156455],
              [-17.0022095866777, -10.957864944408596],
              [-17.006391752940637, -10.959752190533232],
              [-17.010195530178702, -10.96071237648831],
              [-17.01403302070892, -10.962358419296612],
              [-17.01617516156354, -10.964576340959718],
              [-17.01725020727504, -10.96718701280826],
              [-17.01680957381667, -10.968537027658812],
              [-17.020147784000144, -10.969109699990106],
              [-17.021456414093656, -10.968041897587383],
              [-17.025171172249873, -10.969488922063352],
              [-17.026916674838947, -10.969780818538533],
              [-17.028721946631563, -10.968823336402162],
              [-17.029499913369303, -10.967128704363143],
              [-17.030832749256966, -10.967006837125833],
              [-17.034410116888154, -10.968216887759805],
              [-17.039897326185965, -10.969682542399717],
              [-17.041501169272635, -10.969543017621792],
              [-17.04110419585436, -10.968364021666039],
              [-17.043475294926115, -10.967043315428946],
              [-17.048738379325403, -10.966896732575577],
              [-17.050226451777103, -10.966137192543016],
              [-17.053487638087773, -10.966349537810737],
              [-17.056634075317888, -10.96729994237951],
              [-17.06098297133567, -10.96956460985286],
              [-17.06285914593923, -10.971130997383828],
              [-17.066693475194157, -10.972129492934757],
              [-17.072304372710413, -10.974096655364377],
              [-17.073494791182046, -10.975326120500462],
              [-17.075238192999176, -10.975657050166705],
              [-17.076817566773833, -10.974215855103518],
              [-17.078132636225636, -10.973882173677113],
              [-17.08015849026432, -10.97491574137199],
              [-17.082487415742545, -10.976693504038003],
              [-17.08330591552053, -10.976126982955936],
              [-17.08478039933733, -10.976370838803273],
              [-17.08450839974317, -10.978179125108662],
              [-17.086553574557808, -10.981147457702045],
              [-17.088142279567087, -10.982339692475966],
              [-17.09129489444475, -10.986907157787611],
              [-17.089330196811584, -10.98748215912915],
              [-17.08416277065905, -10.987628016642265],
              [-17.081996756930838, -10.988574665729839],
              [-17.078933258572587, -10.9909643357722],
              [-17.077702893487768, -10.99105221178347],
              [-17.07577860319495, -10.993212719207463],
              [-17.071710868111115, -10.991944611488805],
              [-17.069902480730768, -10.991612018194735],
              [-17.06912007185075, -10.990921584273499],
              [-17.066883690027133, -10.986915100070103],
              [-17.065813513093058, -10.98449048176051],
              [-17.060658073240653, -10.9853057338268],
              [-17.057943313745223, -10.984370575755642],
              [-17.0562735581954, -10.984626264980866],
              [-17.053866729516532, -10.984035335332194],
              [-17.0505260058892, -10.985964325758745],
              [-17.05046903561332, -10.986972723819289],
              [-17.049392798662705, -10.990583616817913],
              [-17.04847136333174, -10.992218606162307],
              [-17.04910019972553, -10.996041992147262],
              [-17.048910004172182, -10.998864986518589],
              [-17.04943660283542, -10.999923724092397],
              [-17.04961352128177, -11.00198920111429],
              [-17.052045413973993, -11.008049916366616],
              [-17.052285370036056, -11.010425907304382],
              [-17.05305525093364, -11.013060293924527],
              [-17.053132886167084, -11.014837218742196],
              [-17.053851932491476, -11.017016215587624],
              [-17.054532099917193, -11.017625058341958],
              [-17.055542298828883, -11.021337264694775],
              [-17.055691374765665, -11.024449766238863],
              [-17.057656112507185, -11.028228699967459],
              [-17.058103009724913, -11.030550717033483],
              [-17.05799219858202, -11.031971348328593],
              [-17.05909106420795, -11.03306682748019],
              [-17.060340868709563, -11.03196723070991],
              [-17.061672497837538, -11.032440818184313],
              [-17.065207607594576, -11.035363557783885],
              [-17.065775438478585, -11.036274333825702],
              [-17.06948942540448, -11.037364941157488],
              [-17.070777092590127, -11.038064507557577],
              [-17.072253299564014, -11.037193877555895],
              [-17.073063615908772, -11.037618074762598],
              [-17.07518477263423, -11.040189914870407],
              [-17.07527865401086, -11.042612533676527],
              [-17.074891960762077, -11.043373188762821],
              [-17.076617580892925, -11.045899697083955],
              [-17.077700914982323, -11.046306612384276],
              [-17.08058699583019, -11.048226132326935],
              [-17.083695915736797, -11.050831353910068],
              [-17.08785754296724, -11.053116877819905],
              [-17.08830290978073, -11.05266615711633],
              [-17.091349935566857, -11.053633149258904],
              [-17.093608862941704, -11.052125268107114],
              [-17.09510089762799, -11.051706842404323],
              [-17.096354834436738, -11.050084321173342],
              [-17.096526747741716, -11.047829347261628],
              [-17.098777276410473, -11.04122939567469],
              [-17.101728432326617, -11.041177616399091],
              [-17.104832443712066, -11.04251319487396],
              [-17.10549239919765, -11.04345121751612],
              [-17.103756304352142, -11.045317395489068],
              [-17.103806698514063, -11.046497882401148],
              [-17.102828214867333, -11.047937138251775],
              [-17.103617365196932, -11.050533402862257],
              [-17.102295952057435, -11.052673884893398],
              [-17.10233807908678, -11.054600769297029],
              [-17.103644486728232, -11.055877883175846],
              [-17.105519141539713, -11.056953681462465],
              [-17.10923865709827, -11.057984857944376],
              [-17.110539843275326, -11.05746231388608],
              [-17.114382882533377, -11.054801620062367],
              [-17.11462383431777, -11.053726687929016],
              [-17.117267305484255, -11.052378255758136],
              [-17.120084268423625, -11.052222766422467],
              [-17.122655936354484, -11.052742390581976],
              [-17.12422026883227, -11.051119306161437],
              [-17.122833806390346, -11.049243781569212],
              [-17.123555348638604, -11.048173464200291],
              [-17.11970817500085, -11.045282874419474],
              [-17.11771610390911, -11.043423038881695],
              [-17.117845683150957, -11.038520142150935],
              [-17.116874261360415, -11.035056844661808],
              [-17.115274014211792, -11.033987321630503],
              [-17.1148064631945, -11.032597448117093],
              [-17.115028203604023, -11.031276369538148],
              [-17.11677990960982, -11.029555869912198],
              [-17.116532069452166, -11.02595863830329],
              [-17.113663381125875, -11.025434451438402],
              [-17.112850446961758, -11.02362462591416],
              [-17.111559258686093, -11.022666082392075],
              [-17.110295943858215, -11.023645718789341],
              [-17.109258441610436, -11.022933183102658],
              [-17.109352816432867, -11.02185954941082],
              [-17.11099502825506, -11.020594669634539],
              [-17.112728673020786, -11.018483808996915],
              [-17.114049601699406, -11.02008670828501],
              [-17.115842960010237, -11.02041303055123],
              [-17.116640577454067, -11.020007214716196],
              [-17.117921145054343, -11.017086216350826],
              [-17.12015076723964, -11.015330141643519],
              [-17.1207056737135, -11.0140135429628],
              [-17.122923932207662, -11.013413495562224],
              [-17.123431853360437, -11.012633305779513],
              [-17.123580191464345, -11.010033974628229],
              [-17.123289991347228, -11.008606850672109],
              [-17.124992105621857, -11.00608381876206],
              [-17.12616652993593, -11.005392219065806],
              [-17.12933110658784, -11.00611968053363],
              [-17.13105864859792, -11.009146256806785],
              [-17.129117712040188, -11.01662446669159],
              [-17.1296119256451, -11.019953506592039],
              [-17.12889635088774, -11.020608799709168],
              [-17.128497545411914, -11.023291220082017],
              [-17.12751901130077, -11.025349514024436],
              [-17.127881230393303, -11.026985305299497],
              [-17.12754671069199, -11.029442288204686],
              [-17.127589067192954, -11.031840958632742],
              [-17.12848298687576, -11.034929322660783],
              [-17.129538522048218, -11.036261650756728],
              [-17.13052138274167, -11.038813971993173],
              [-17.13100970348039, -11.043039125754953],
              [-17.130791977071322, -11.044072192444455],
              [-17.13145207147303, -11.047803450735934],
              [-17.13277953242984, -11.049366500496498],
              [-17.13320902318109, -11.050653884272265],
              [-17.135872040890675, -11.052910894776396],
              [-17.13731777613469, -11.052859585442748],
              [-17.139966079137515, -11.05447352960387],
              [-17.140980522518436, -11.05325877738944],
              [-17.142481282504527, -11.054305070701236],
              [-17.143203150531022, -11.055884404414178],
              [-17.144264672412266, -11.056886052066114],
              [-17.145568054581734, -11.056273171281529],
              [-17.146983155342337, -11.05769137286134],
              [-17.147946283544325, -11.057822127076289],
              [-17.148738712054946, -11.055258180997862],
              [-17.149067428096338, -11.05306461930429],
              [-17.1504006816545, -11.050981168492198],
              [-17.15117646252905, -11.050841200667369],
              [-17.153225047603403, -11.04809740856242],
              [-17.15459084887942, -11.047321158374059],
              [-17.15505728900532, -11.042956572551326],
              [-17.156036132601052, -11.04029310513807],
              [-17.156956984164395, -11.040257047052311],
              [-17.15630025702564, -11.038122294435222],
              [-17.15401747772605, -11.035150978225007],
              [-17.154034185993336, -11.032462827762336],
              [-17.15489178329654, -11.032426552935043],
              [-17.157397707485195, -11.036473817084776],
              [-17.16019908354276, -11.036737734541978],
              [-17.16042233476779, -11.037938576275215],
              [-17.158966280573214, -11.040123585397033],
              [-17.15999944728628, -11.042405405688445],
              [-17.160232250820812, -11.045635127703816],
              [-17.160110227666898, -11.048698396239626],
              [-17.15953559583673, -11.050310290402852],
              [-17.16011767626124, -11.051079977588115],
              [-17.161481011711714, -11.05069359294734],
              [-17.164049555090223, -11.05209453526599],
              [-17.164785694750957, -11.051498001748524],
              [-17.168843171414835, -11.052636082590217],
              [-17.172343261067965, -11.052155292102356],
              [-17.17315439560909, -11.05342219663112],
              [-17.172187052435042, -11.054225778546787],
              [-17.172390723435672, -11.055511035164999],
              [-17.173684982440154, -11.05655245763194],
              [-17.172508518022365, -11.057231025637742],
              [-17.170097893037113, -11.057406643473445],
              [-17.168709504653126, -11.058518975678815],
              [-17.166808432650264, -11.05732855938632],
              [-17.16277306724557, -11.055713083688428],
              [-17.161700827683983, -11.056411479588645],
              [-17.160867437703857, -11.055557782941346],
              [-17.15848024402118, -11.055337426195342],
              [-17.15749249512146, -11.05587041857025],
              [-17.15749819201471, -11.058460523142395],
              [-17.156129011601152, -11.05961287752644],
              [-17.15589113155443, -11.060834456506681],
              [-17.154857381754837, -11.061926886176698],
              [-17.1526751921855, -11.062288931609567],
              [-17.151873355181145, -11.06304875719958],
              [-17.150196122690335, -11.063059007514616],
              [-17.147906519387544, -11.063728776663027],
              [-17.14699952786102, -11.066499735708781],
              [-17.14725859773911, -11.0695923656163],
              [-17.149536298926, -11.074129408158765],
              [-17.150478400903612, -11.077683678735823],
              [-17.15185936036879, -11.081698706975331],
              [-17.153406587080724, -11.082766859318378],
              [-17.158244601223515, -11.082146832275892],
              [-17.159854128131872, -11.082720805524621],
              [-17.160973302627223, -11.081605734877892],
              [-17.163641812764908, -11.081334338418682],
              [-17.167207539235992, -11.08205274112473],
              [-17.171338465811143, -11.08333872468197],
              [-17.17591928398615, -11.082756585621786],
              [-17.17797314287956, -11.083761224925528],
              [-17.178955226731656, -11.08503202771993],
              [-17.181811999478896, -11.08498035986626],
              [-17.184199105023122, -11.087065559306236],
              [-17.185484642032137, -11.091972481531267],
              [-17.185145810761384, -11.092677716882838],
              [-17.183124526452477, -11.093668430894217],
              [-17.182566806150188, -11.096679772002446],
              [-17.17822106294747, -11.098525015254657],
              [-17.1766356679072, -11.102104528879904],
              [-17.176398237721504, -11.10353830174929],
              [-17.17480303440201, -11.105190827873484],
              [-17.174727995106487, -11.10704130845887],
              [-17.17308214864872, -11.111076377740906],
              [-17.172779617547995, -11.1127813752867],
              [-17.17462505685101, -11.11447563166973],
              [-17.17634953516636, -11.115023985783342],
              [-17.179475228048528, -11.118075935117735],
              [-17.179423198792794, -11.120553780575273],
              [-17.17746112708529, -11.121191734289415],
              [-17.17700356351977, -11.122790668319292],
              [-17.180273137594696, -11.124647146879363],
              [-17.18218968172678, -11.124680382028956],
              [-17.18311822067707, -11.12417078099199],
              [-17.184781816171164, -11.124551538485669],
              [-17.186316571373247, -11.125723399397332],
              [-17.190337310322523, -11.127444405072572],
              [-17.190692475832744, -11.127971425465153],
              [-17.19398175070605, -11.12881390750288],
              [-17.197185892481116, -11.128671213945882],
              [-17.19976181339322, -11.126968022552706],
              [-17.202060236007352, -11.126701770906193],
              [-17.204229799303842, -11.12768537471321],
              [-17.208064615158573, -11.129004398387476],
              [-17.210717836555286, -11.131738134876965],
              [-17.212970977727576, -11.134972004288608],
              [-17.214297733243203, -11.137350499489001],
              [-17.214549750417206, -11.138602223508672],
              [-17.21661621000032, -11.140564709020175],
              [-17.217271489418756, -11.13910481186064],
              [-17.217276234764878, -11.137642384347332],
              [-17.218033401857593, -11.135810249000873],
              [-17.221746414615605, -11.135436576883016],
              [-17.224805345932523, -11.136542460908833],
              [-17.224868685369817, -11.137585092842158],
              [-17.22273757140048, -11.13748038944525],
              [-17.221745597256312, -11.138085031212709],
              [-17.22229390298149, -11.139420082329437],
              [-17.22356018395728, -11.139628857725345],
              [-17.225100685435255, -11.140713648918268],
              [-17.226641289450857, -11.140171418366457],
              [-17.227380276231003, -11.141360409920805],
              [-17.227169310334915, -11.142674646517566],
              [-17.228203911701776, -11.143759437942975],
              [-17.229744849560905, -11.142945223056305],
              [-17.230018910516346, -11.142006257180707],
              [-17.231703096021114, -11.139769981363413],
              [-17.233372668373487, -11.138646050612227],
              [-17.23582211704281, -11.140312694298313],
              [-17.238865746103706, -11.144148510858972],
              [-17.241000063229478, -11.145732039834769],
              [-17.243598606952684, -11.146542107680487],
              [-17.24410405212559, -11.145727591410816],
              [-17.245666088502833, -11.145474482853299],
              [-17.24684635732896, -11.144324710387542],
              [-17.248978650464558, -11.144278999664317],
              [-17.25033154814015, -11.145048300766462],
              [-17.249912252996324, -11.146468125861874],
              [-17.248057038782676, -11.148016527006854],
              [-17.247743212471153, -11.149582535371378],
              [-17.246159628450457, -11.149898672427996],
              [-17.245109708217203, -11.15353339793405],
              [-17.24244875430081, -11.15433085581147],
              [-17.239531482938897, -11.153332423356638],
              [-17.238812124965886, -11.152560551606182],
              [-17.237270485057422, -11.153147048905895],
              [-17.235685625110076, -11.15289761550426],
              [-17.23365606893928, -11.151229025125065],
              [-17.231015169836766, -11.150666717678213],
              [-17.230297270699754, -11.151168158013347],
              [-17.22567091817791, -11.151148504747887],
              [-17.222460268965236, -11.149603099636373],
              [-17.223495353415885, -11.148747527461904],
              [-17.224171484919943, -11.14615959237931],
              [-17.22284138526001, -11.14519917456242],
              [-17.221425838102892, -11.148058072552981],
              [-17.220390848643618, -11.148475414378192],
              [-17.21878591614692, -11.148098632289212],
              [-17.216652217531692, -11.148932381494983],
              [-17.216440488846565, -11.149704594221651],
              [-17.218742044762564, -11.15087512952924],
              [-17.220009764046996, -11.150541788841421],
              [-17.223304712733384, -11.15252624867913],
              [-17.22744628655982, -11.156494126922068],
              [-17.228736124812755, -11.15877086888057],
              [-17.230796784771158, -11.160215862304037],
              [-17.234308948184, -11.162186788163941],
              [-17.237872962057317, -11.16327780962144],
              [-17.239015727302114, -11.163882771423932],
              [-17.242404041043226, -11.166825021510112],
              [-17.245072036021607, -11.16857784504496],
              [-17.24598461698229, -11.17018605018156],
              [-17.24743049934527, -11.173885386128738],
              [-17.248432906715585, -11.177649101756957],
              [-17.249369426408947, -11.180095374537016],
              [-17.250186111813786, -11.185661817670226],
              [-17.250226598774365, -11.192573251548415],
              [-17.251096749657975, -11.19495906710574],
              [-17.250125649088982, -11.197014472522747],
              [-17.250935233561183, -11.198668492456417],
              [-17.24943149972778, -11.19980352669712],
              [-17.247965020207666, -11.198401862335436],
              [-17.246864188206477, -11.19949377766223],
              [-17.2465487920772, -11.201066638739697],
              [-17.248615767401084, -11.205528484671666],
              [-17.25207135554954, -11.203886002368865],
              [-17.253411635535883, -11.205266756603487],
              [-17.255239907086704, -11.206394622494708],
              [-17.25602474234434, -11.20620417619739],
              [-17.257746667904737, -11.207164125004892],
              [-17.25754050519737, -11.209409172479273],
              [-17.25540112334177, -11.211344572519128],
              [-17.256062548204234, -11.212538874756783],
              [-17.25763777508076, -11.213814800186192],
              [-17.260721452844827, -11.215170266331164],
              [-17.265881341935565, -11.214587276381371],
              [-17.266140114592336, -11.215698974881168],
              [-17.268501186528162, -11.216551131251368],
              [-17.2687640098879, -11.218670216934424],
              [-17.268001664223796, -11.219365817890957],
              [-17.265277710729148, -11.218220530576454],
              [-17.26336557224795, -11.218226691970608],
              [-17.263877034694346, -11.220694451217097],
              [-17.2660109732175, -11.221304204532775],
              [-17.266948579157827, -11.221993897478699],
              [-17.269160516076017, -11.222406090436158],
              [-17.269824300876163, -11.223684681100647],
              [-17.27203421961838, -11.223487203959772],
              [-17.272738222286847, -11.224093618927636],
              [-17.272940091850966, -11.226655171431801],
              [-17.271948642772003, -11.22865492802256],
              [-17.270965821348526, -11.227461064724796],
              [-17.269945991853305, -11.227717065118416],
              [-17.269570110870045, -11.229525183724226],
              [-17.270298725752646, -11.23093025956951],
              [-17.27138653176221, -11.231682762406002],
              [-17.270732338356503, -11.233072305062302],
              [-17.268899337770716, -11.23215432033041],
              [-17.268128088176685, -11.230664908985728],
              [-17.265655480395687, -11.22911851771363],
              [-17.263190244929355, -11.229693919727621],
              [-17.26106259651546, -11.229427168902314],
              [-17.25972551355269, -11.230376779236508],
              [-17.25874627382028, -11.230043257774026],
              [-17.2565372479914, -11.23118368911653],
              [-17.25711769238409, -11.233409896657989],
              [-17.256293288311166, -11.235429911084449],
              [-17.256550642709414, -11.236185821722158],
              [-17.255512307564313, -11.237870400267528],
              [-17.257579527255764, -11.238832139523467],
              [-17.25903063789424, -11.24013218804022],
              [-17.26062895521251, -11.24071641666225],
              [-17.26039957968797, -11.242357311674684],
              [-17.2594017428918, -11.243306529526485],
              [-17.257824161325967, -11.242617013681377],
              [-17.255691105492694, -11.241129079324534],
              [-17.255443166207968, -11.242305520396002],
              [-17.25722932264476, -11.245560703099793],
              [-17.258197682492586, -11.246739085050951],
              [-17.26030904833594, -11.247658864992596],
              [-17.26131644588126, -11.24965506686719],
              [-17.261322090860844, -11.25148606507271],
              [-17.259702850199762, -11.25155380229924],
              [-17.258311277135455, -11.249263641524404],
              [-17.257632853393723, -11.25046501679626],
              [-17.25834135790517, -11.252357504296963],
              [-17.26007061322091, -11.2552357507824],
              [-17.25984630728438, -11.256837583704694],
              [-17.25803874482054, -11.25840105190734],
              [-17.25714187309004, -11.260106570741643],
              [-17.25495901569316, -11.263053276392451],
              [-17.25547577290562, -11.264948010994093],
              [-17.254197799327347, -11.2657203286947],
              [-17.2528725276073, -11.264701345601235],
              [-17.250762044012472, -11.26532772589715],
              [-17.24945643774078, -11.263233901810336],
              [-17.24680911571067, -11.261869565353669],
              [-17.247174413009766, -11.259907431878107],
              [-17.244820190032836, -11.25854521252685],
              [-17.244135462377706, -11.25702986073529],
              [-17.241789144925445, -11.254759980455065],
              [-17.23905364603341, -11.250131988894674],
              [-17.23670790732626, -11.247861746328125],
              [-17.228783598590812, -11.247361556187156],
              [-17.2268240452267, -11.247572449063627],
              [-17.221148025062522, -11.248773793573896],
              [-17.218920676796323, -11.248917514635876],
              [-17.2161934051091, -11.249631297967344],
              [-17.213271905461987, -11.251301979054656],
              [-17.210715056240797, -11.252088414637514],
              [-17.2061338364828, -11.25191358246094],
              [-17.204087671638934, -11.252268108733519],
              [-17.202466243054428, -11.253233541471582],
              [-17.199075807852463, -11.254152687666004],
              [-17.196307154187988, -11.25328343201855],
              [-17.194904150924536, -11.25195403469604],
              [-17.194289729913486, -11.250647521825414],
              [-17.193203426258858, -11.250518265737393],
              [-17.191507079632096, -11.24771492876878],
              [-17.189505297709463, -11.247540724884358],
              [-17.188385880359803, -11.24824119156919],
              [-17.187291421874068, -11.247071320618954],
              [-17.187253335218, -11.245724526234197],
              [-17.18341604736302, -11.246721632884872],
              [-17.18256434227678, -11.24667663262861],
              [-17.1803650643064, -11.24820759096726],
              [-17.18140426478305, -11.249281766465787],
              [-17.1806128154295, -11.250120495283497],
              [-17.175759128242674, -11.249196988125393],
              [-17.17379091025573, -11.246242925273533],
              [-17.174411708282484, -11.245508986170442],
              [-17.176692957303874, -11.24492957540094],
              [-17.177061982466313, -11.243227097340393],
              [-17.174124117620895, -11.243088964796426],
              [-17.172715571331317, -11.243819162627206],
              [-17.172276851758422, -11.246636031361751],
              [-17.17152825844947, -11.247327262811488],
              [-17.169915765002003, -11.250476357425288],
              [-17.167686117585504, -11.253244369520917],
              [-17.166000620600748, -11.25585304414437],
              [-17.164502663692925, -11.258893009538355],
              [-17.162146769500595, -11.262771274891998],
              [-17.159687928412406, -11.265777625700858],
              [-17.155115077813207, -11.270536506194127],
              [-17.151730432240964, -11.272498240982184],
              [-17.146955496836593, -11.276046403689014],
              [-17.145209511055356, -11.277096328799335],
              [-17.14043864744116, -11.278285110087202],
              [-17.139327869457247, -11.278300391439306],
              [-17.13739398957186, -11.277021012173712],
              [-17.136658619162507, -11.27541287319251],
              [-17.135128546867048, -11.274473972476642],
              [-17.133860309013453, -11.27281965378374],
              [-17.13304978264896, -11.272729136921214],
              [-17.13074796000653, -11.274925723957953],
              [-17.129019812421138, -11.277337571152474],
              [-17.12634453769206, -11.280543396012664],
              [-17.12507441176975, -11.281693493163019],
              [-17.122942543407486, -11.281169393619953],
              [-17.120901828946007, -11.282417956037106],
              [-17.118708137534313, -11.281639406373763],
              [-17.118579432843227, -11.284043989116634],
              [-17.117441086083492, -11.289310998562385],
              [-17.116205068161513, -11.291200315360543],
              [-17.11470462267565, -11.29158806733128],
              [-17.112909437931915, -11.295943323432372],
              [-17.110729094661284, -11.297972437010763],
              [-17.109542308603395, -11.297611274915242],
              [-17.107364688867413, -11.298510740357072],
              [-17.10467449487778, -11.297956391567533],
              [-17.10399974464536, -11.299069466752346],
              [-17.1034767740976, -11.302043621473231],
              [-17.104818913457827, -11.302649035542915],
              [-17.105149129957912, -11.303835758259218],
              [-17.10432372054179, -11.30915552282337],
              [-17.103090902876787, -11.312379056824899],
              [-17.101252034784064, -11.314094984003876],
              [-17.09873291926432, -11.31326525842875],
              [-17.096631612002717, -11.315380042270396],
              [-17.09840417503901, -11.31592761282977],
              [-17.100902453903053, -11.31472618154113],
              [-17.102314718778867, -11.31490959755912],
              [-17.104573430999046, -11.316116917398677],
              [-17.106247553707593, -11.315837164059852],
              [-17.106501263554428, -11.31829423136125],
              [-17.101826126320752, -11.322204025914315],
              [-17.160267016460633, -11.322657010651772],
              [-17.159978556949994, -11.362455605056706],
              [-17.192206099948447, -11.362586363757739],
              [-17.192122247380258, -11.392431455766474],
              [-17.281997040133017, -11.392348701612107],
              [-17.34191317350848, -11.391927809733996],
              [-17.341620994136225, -11.3620846151162],
              [-17.351119317791383, -11.361990834660153],
              [-17.349857217123677, -11.242579076283564],
              [-17.35948336867106, -11.242476434053028],
              [-17.3588015786174, -11.182748175046934],
              [-17.298759127956785, -11.183260922636364],
              [-17.29838399036234, -11.12351482414427],
              [-17.27714647153288, -11.123622218604806],
              [-17.24718575791975, -11.123715579659631],
              [-17.247130285963742, -11.09384115446778],
              [-17.21703497707598, -11.093852305226548],
              [-17.217059534846285, -11.062121988348578],
              [-17.217080900375038, -11.034085768681566],
              [-17.187144501088994, -11.034024667668307],
              [-17.187244311457242, -11.0041373666862],
              [-17.16511472497125, -11.004042340268468],
              [-17.1655931596397, -10.912838427133924],
              [-17.16574431890447, -10.884464673833055],
              [-17.143412892241965, -10.884328794628916],
              [-17.14428618767377, -10.764705512082289],
              [-17.12174809641521, -10.764523321457823],
              [-17.122854687512177, -10.644864136605507],
              [-17.130266828179217, -10.64492889320654],
              [-17.13052279837955, -10.615007356960806]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -151.56519541730484,
          "lat": 60.26551800715341
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02122"],
        "coty_name": ["Kenai Peninsula"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Kenai Peninsula Borough"],
        "coty_fp_code": "122",
        "coty_gnis_code": "01419972"
      },
      "bbox": [
        -17.35948336867106, -11.392431455766474, -16.280770375573162,
        -10.427010902272738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6189279720286973, -2.193357147308276],
            [2.7519850919357904, -2.189948530349887],
            [2.797749767129029, -2.188148695895679],
            [2.936610033620041, -2.184143662421095],
            [2.9684345008596584, -2.1829633311674224],
            [2.9690758762035676, -2.2165965849950995],
            [2.9659522938366045, -2.2108943517859636],
            [2.962179241549858, -2.2077608946573233],
            [2.9544696651964717, -2.20654230157328],
            [2.9497993553335817, -2.2001423539300307],
            [2.9487149803042767, -2.1964636848053423],
            [2.9440871139633913, -2.1909602488833992],
            [2.9449978952279063, -2.2627132576101223],
            [2.945374563518525, -2.2763154211736127],
            [2.9467348811184144, -2.347621879214345],
            [2.9461050622682565, -2.364879372915734],
            [2.9487881428575595, -2.4322230256565804],
            [2.950765988652188, -2.50765569695861],
            [2.951882702251577, -2.570738773014704],
            [2.908728464737311, -2.571120457268264],
            [2.9086949285197186, -2.5708249366310465],
            [2.8659452857320176, -2.5715265014055744],
            [2.8229738455357745, -2.5727203723164918],
            [2.807575633961107, -2.5724052370021475],
            [2.7949923859689223, -2.570607679722894],
            [2.7654347091191487, -2.571259171927221],
            [2.7521400564578338, -2.573646351484759],
            [2.6948331511033348, -2.5736349605836932],
            [2.6376444134113326, -2.5738867617388284],
            [2.6235969611145, -2.573393978346189],
            [2.6229598427149763, -2.558926649226293],
            [2.6229167773724114, -2.5310416797818753],
            [2.621736710114152, -2.461609568013493],
            [2.6210320100874074, -2.382129863314535],
            [2.6200550070528, -2.3201189916571208],
            [2.6190655687746696, -2.283274952790883],
            [2.61887105122787, -2.2644891123432105],
            [2.6170742049784206, -2.210270856726869],
            [2.6129462565280384, -2.2081770428304384],
            [2.617214974084263, -2.2043309133927873],
            [2.616838757059441, -2.1999890361243817],
            [2.614555613893804, -2.1948142627668488],
            [2.6189279720286973, -2.193357147308276]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.0915365812667, "lat": 36.30860543199839 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05009"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00069897"
      },
      "bbox": [
        2.6129462565280384, -2.5738867617388284, 2.9690758762035676,
        -2.1829633311674224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1896061306249157, -4.275146466030068],
            [3.2256710355803433, -4.275214777998885],
            [3.232158798786288, -4.2743449299984535],
            [3.2316916963232036, -4.271217242733093],
            [3.2256971090108912, -4.268338898389292],
            [3.2262485370953775, -4.262902799192823],
            [3.230900148391462, -4.2568685043082635],
            [3.236404278786993, -4.255919468656053],
            [3.243653100214667, -4.248603847942087],
            [3.246691718021719, -4.242918594065991],
            [3.2466888064464845, -4.23479178090741],
            [3.2528862070707563, -4.231592558104144],
            [3.291899892125566, -4.2315390586087505],
            [3.3445683217374134, -4.230506594478043],
            [3.4040858272735286, -4.229739658844157],
            [3.4034758334078408, -4.185681646735034],
            [3.5322541416433166, -4.182848572699018],
            [3.563164529243672, -4.182403912846068],
            [3.565479968135305, -4.265524000552119],
            [3.565390752473965, -4.2700908020804995],
            [3.5673766588333713, -4.328632605162939],
            [3.568165609781934, -4.357819611062247],
            [3.567695639991572, -4.357982132461267],
            [3.5684826410260744, -4.387397507383832],
            [3.569792060631378, -4.446097852344053],
            [3.5536800534861093, -4.446189572397897],
            [3.5570141291096813, -4.528281625762246],
            [3.559716509244586, -4.6154320794308505],
            [3.474890000429593, -4.621643470764026],
            [3.4746582223766396, -4.617715365968835],
            [3.467661130355187, -4.613888149181155],
            [3.4657253742307983, -4.610882660787926],
            [3.4595958308382873, -4.6145196725468995],
            [3.445150090015829, -4.60833554343559],
            [3.4449084042587286, -4.603830702619603],
            [3.4421877101229836, -4.595481950405704],
            [3.436775105503298, -4.590277856097902],
            [3.4347782426514977, -4.5859489876748105],
            [3.4231642319700395, -4.576902908776184],
            [3.4192808013776976, -4.578790598254455],
            [3.4192704758436427, -4.574103771407698],
            [3.416714635046458, -4.568464519693962],
            [3.406115517851283, -4.566237019645397],
            [3.403459045788753, -4.563036705072821],
            [3.3998848342988377, -4.562044007990927],
            [3.3950237726905987, -4.5577911558432245],
            [3.3863047387698364, -4.557868921760713],
            [3.3814583166317105, -4.560792981387345],
            [3.3769425876046992, -4.556401509383123],
            [3.371843333187317, -4.556197097425361],
            [3.3703290672590973, -4.551663476840037],
            [3.367152113240494, -4.551772355510767],
            [3.3628390394310164, -4.548525508653176],
            [3.3588154078386037, -4.551056864443821],
            [3.35157822658737, -4.552409894756664],
            [3.3438832027269414, -4.54975117002831],
            [3.3428070644460033, -4.541398046151646],
            [3.320689909361996, -4.540592254074422],
            [3.2774673741085256, -4.540658607884077],
            [3.1909768287716354, -4.541415937154045],
            [3.189776435129897, -4.451183429957457],
            [3.19197971200852, -4.4511457543090005],
            [3.1907550269233727, -4.377796570155031],
            [3.1896061306249157, -4.275146466030068]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.42368188953381,
          "lat": 34.290047562889235
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05053"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00066856"
      },
      "bbox": [
        3.1896061306249157, -4.621643470764026, 3.569792060631378,
        -4.182403912846068
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.563164529243672, -4.182403912846068],
            [3.6157504083316434, -4.181552379488262],
            [3.7085377447954766, -4.179770898927053],
            [3.738982595386364, -4.17911081709797],
            [3.797125698937981, -4.177564648959162],
            [3.8853152659685035, -4.177540415231833],
            [3.974326091092946, -4.175089792528583],
            [3.9754895884491956, -4.223296025720226],
            [3.9767023188016513, -4.263319210855645],
            [3.977239630121088, -4.293370066843331],
            [3.9788053508534573, -4.36433430459383],
            [3.98039199857686, -4.425211282478889],
            [4.000872583566777, -4.424752356342608],
            [4.065944119886911, -4.424776439598237],
            [4.072749889960027, -4.423400095997958],
            [4.072831076709406, -4.4261011922851985],
            [4.078048754255039, -4.425963576722686],
            [4.0767789398960375, -4.433445733395581],
            [4.075010383429319, -4.438051890732297],
            [4.076467800313467, -4.4423841388708825],
            [4.08100592478138, -4.442429677575525],
            [4.084789467601707, -4.439962082475453],
            [4.0910413705931425, -4.4336489295894586],
            [4.091457672687726, -4.4309207522658145],
            [4.098535028028419, -4.430339324841649],
            [4.100925214034878, -4.4285351604551035],
            [4.108320135076064, -4.427777102337227],
            [4.113069276242366, -4.430614360011567],
            [4.121365293940305, -4.428057667642325],
            [4.124484488003957, -4.42944659201943],
            [4.127162964410091, -4.433556914255666],
            [4.13145039690027, -4.436873397400288],
            [4.132280225000973, -4.442668598871902],
            [4.130204983729174, -4.450184305423443],
            [4.134155833796357, -4.454424628790638],
            [4.136560307643543, -4.460950264306351],
            [4.133797238737024, -4.468992905384213],
            [4.137310099592267, -4.470725876945189],
            [4.141068759085357, -4.477458063231056],
            [4.144448737458556, -4.479393083153],
            [4.140157290915573, -4.488020468989182],
            [4.145121244108254, -4.494874571517889],
            [4.146464823321883, -4.5031922340682025],
            [4.1451379845818, -4.506457972128674],
            [4.14754660048741, -4.509867631479471],
            [4.152563448637706, -4.508439394128087],
            [4.152701935555104, -4.505761630854682],
            [4.156168501339913, -4.502218743630266],
            [4.162156902190807, -4.502198279464337],
            [4.161408022311211, -4.520695854063877],
            [4.164462796255569, -4.523869216417591],
            [4.174649229621241, -4.519482507078554],
            [4.176328970364915, -4.516118118214378],
            [4.188465659943346, -4.5143171593147935],
            [4.198058310814997, -4.515694252232573],
            [4.199180855588567, -4.52125767018401],
            [4.203115821880703, -4.521390499854497],
            [4.201714517816961, -4.528353679161728],
            [4.205261821802705, -4.532506639618181],
            [4.2050556255210845, -4.53540083942899],
            [4.208693451899897, -4.543199886263013],
            [4.207558041545395, -4.545571285243177],
            [4.210323940326569, -4.55657153936485],
            [4.208090049596635, -4.5615095166712445],
            [4.213779513367722, -4.559675388205715],
            [4.213096581607129, -4.565205885615609],
            [4.206256585188791, -4.56889297126535],
            [4.199181200631843, -4.564195819947016],
            [4.1919071892120074, -4.564657249430435],
            [4.189717918656411, -4.570143485220436],
            [4.194299685220075, -4.5778453061550515],
            [4.192930243966569, -4.585228085189446],
            [4.189239863233464, -4.588790469553105],
            [4.177119377026909, -4.592383818212706],
            [4.1733901140243495, -4.591664644117826],
            [4.169822033937981, -4.58812417223133],
            [4.169372124351737, -4.576761575785075],
            [4.160965150890275, -4.57880917263012],
            [4.1550985918109085, -4.577549500718131],
            [4.150179178850966, -4.574009434741987],
            [4.136879927252183, -4.556384284540308],
            [4.1329978390936875, -4.552866758325652],
            [4.122409069851142, -4.54867936427295],
            [4.115521083973476, -4.547848652396266],
            [4.107791810045316, -4.549300029536249],
            [4.102902177344568, -4.552953626456433],
            [4.096630028221377, -4.561239372800406],
            [4.0918888918180825, -4.5660044108615185],
            [4.087251687540805, -4.5687562032391495],
            [4.080452054869416, -4.569725259834132],
            [4.073387278054588, -4.566667707502542],
            [4.069603321907524, -4.5593175825338745],
            [4.069877193470801, -4.554383730757118],
            [4.0726301693871525, -4.545230712244755],
            [4.072792879485953, -4.541151531274708],
            [4.076418954002128, -4.53670330779771],
            [4.085561116010901, -4.534671662190233],
            [4.09142518002915, -4.529493483917047],
            [4.090788575036698, -4.526565387642191],
            [4.084833215372198, -4.521516319987236],
            [4.0782448497039745, -4.52228864120261],
            [4.065045159046822, -4.527780800333914],
            [4.05618086146504, -4.526987615129395],
            [4.047535789785363, -4.52223929344217],
            [4.043474605760902, -4.521665981523798],
            [4.036262105334535, -4.518843019903356],
            [4.032855319206069, -4.5163094444210525],
            [4.027907824229056, -4.508965487308155],
            [3.99674712639924, -4.487416782836029],
            [3.9915824372400053, -4.484478003888073],
            [3.978910657621427, -4.483285748892109],
            [3.9701743577529442, -4.484596236170058],
            [3.9710304614744594, -4.5078861974623825],
            [3.9719225189040994, -4.507853229293333],
            [3.975711737622909, -4.595122854530841],
            [3.960921370006879, -4.595919483775345],
            [3.9593136607367003, -4.566793177252528],
            [3.9158764527549113, -4.567985830325152],
            [3.8734791754426525, -4.571397428713922],
            [3.7973470145227672, -4.574375759026975],
            [3.7880989512788745, -4.574838383109303],
            [3.789339540152792, -4.604213885235985],
            [3.729444562472906, -4.6070618910597725],
            [3.702647283108758, -4.608568671681972],
            [3.6429000556219413, -4.610727017259692],
            [3.588527711263724, -4.613643735517744],
            [3.559716509244586, -4.6154320794308505],
            [3.5570141291096813, -4.528281625762246],
            [3.5536800534861093, -4.446189572397897],
            [3.569792060631378, -4.446097852344053],
            [3.5684826410260744, -4.387397507383832],
            [3.567695639991572, -4.357982132461267],
            [3.568165609781934, -4.357819611062247],
            [3.5673766588333713, -4.328632605162939],
            [3.565390752473965, -4.2700908020804995],
            [3.565479968135305, -4.265524000552119],
            [3.563164529243672, -4.182403912846068]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.93046221834656, "lat": 34.26830628955364 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05069"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00066862"
      },
      "bbox": [
        3.5536800534861093, -4.6154320794308505, 4.213779513367722,
        -4.175089792528583
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.856237813412402, 2.8329951475569364],
            [-19.72553055736492, 2.8326469095793474],
            [-19.68560245303566, 2.870409052486494],
            [-19.672489711811785, 2.882617224028123],
            [-19.665457047408086, 2.8842964701980023],
            [-19.665189164277496, 2.8888048852041313],
            [-19.66209507065649, 2.8969061976784354],
            [-19.663338851908698, 2.898692972862332],
            [-19.659034990373748, 2.905819330825883],
            [-19.655230018490208, 2.909898952901397],
            [-19.648527553688517, 2.9143405647307605],
            [-19.64354582471472, 2.910357462432928],
            [-19.636182811114473, 2.907968375313229],
            [-19.631581748553035, 2.9127690760250196],
            [-19.6276868945286, 2.920747468366509],
            [-19.628167278703433, 2.9281292963664027],
            [-19.626293943728744, 2.930542630999036],
            [-19.629072454611478, 2.9394443943356885],
            [-19.631783150893146, 2.9415778283180862],
            [-19.633795104808268, 2.9462743245795435],
            [-19.637317544353213, 2.9644311818947346],
            [-19.63069993455888, 2.9711584380664524],
            [-19.62986076075957, 2.9654400285293114],
            [-19.62422515408186, 2.954691095842307],
            [-19.620644236310927, 2.952604905753043],
            [-19.619143726546778, 2.9482012096385835],
            [-19.608553843853194, 2.9383309584960373],
            [-19.605400946655198, 2.9344719626699383],
            [-19.603004992037896, 2.934337282847308],
            [-19.59750641177183, 2.938779061724912],
            [-19.591333929451434, 2.938752335795365],
            [-19.588458408293324, 2.9364134902311165],
            [-19.582741531557264, 2.9389227928962085],
            [-19.57956029940488, 2.934930345736534],
            [-19.57827192435716, 2.930758268316774],
            [-19.568175315461346, 2.9308465234675545],
            [-19.56803715537069, 2.927748495509081],
            [-19.563446487519588, 2.9256320233660738],
            [-19.557469556825083, 2.925173228208074],
            [-19.556616567087634, 2.9204209276333555],
            [-19.55692067739284, 2.910297448722579],
            [-19.555054275797158, 2.905210845629048],
            [-19.554448380323755, 2.8962897093285833],
            [-19.555216613036116, 2.89472331871973],
            [-19.5522952280746, 2.8780561788228542],
            [-19.549764656622237, 2.8704853057352295],
            [-19.549402007088137, 2.8528892564875115],
            [-19.550123316532275, 2.8444793541054545],
            [-19.55183833507209, 2.835341272173055],
            [-19.55100032824825, 2.8302571607994818],
            [-19.54892130206438, 2.828117411149234],
            [-19.548972195598633, 2.821564857778299],
            [-19.54631856938359, 2.819601235110332],
            [-19.542340405022156, 2.7978006024260957],
            [-19.54503765603796, 2.7965435835531975],
            [-19.544927016611517, 2.789760946912485],
            [-19.54623853166575, 2.7835618179999013],
            [-19.54558805532156, 2.7800079507565774],
            [-19.547882022736545, 2.775817154045667],
            [-19.54668241209384, 2.771326042937432],
            [-19.54192689174772, 2.7670278032332263],
            [-19.538943104438815, 2.768466271691908],
            [-19.534453835220987, 2.7621486845085728],
            [-19.533952364293285, 2.754586163114249],
            [-19.538569665954054, 2.7497747810462982],
            [-19.536666427288573, 2.740861249520955],
            [-19.53370692950079, 2.7338160732569863],
            [-19.528459139849737, 2.7253547054002576],
            [-19.5230387960007, 2.7256493500500976],
            [-19.51809608650863, 2.7206301891954543],
            [-19.51653962343645, 2.712179569974011],
            [-19.516797503904492, 2.708257068401633],
            [-19.520366529979654, 2.7065704018580297],
            [-19.51832284735039, 2.6993762544103537],
            [-19.52013867400834, 2.6974716157583862],
            [-19.526857279269183, 2.696284818579128],
            [-19.526671858067036, 2.683683458860221],
            [-19.52290186518532, 2.6840725387354487],
            [-19.51537520277729, 2.6877549795839446],
            [-19.511884483057674, 2.6776767275528837],
            [-19.511732100662652, 2.672990898351273],
            [-19.509367504305942, 2.670809950831038],
            [-19.508225197865624, 2.6645854473991997],
            [-19.508867674899403, 2.654425496338628],
            [-19.507418823311635, 2.6463403970135846],
            [-19.508876047427915, 2.6408201066709305],
            [-19.50849785732312, 2.626698151057606],
            [-19.510828869540187, 2.6237956162207228],
            [-19.510331321608753, 2.618905723856421],
            [-19.51110695371601, 2.611927264719591],
            [-19.511218364724684, 2.5954896417079656],
            [-19.513023998418397, 2.5931694323088452],
            [-19.511459018006704, 2.5881959300996225],
            [-19.513516905077203, 2.5845140187614346],
            [-19.512580324069507, 2.5790006121363422],
            [-19.50992787762073, 2.571897500232437],
            [-19.510681977026298, 2.5696206766964087],
            [-19.513204735994993, 2.5656775133688003],
            [-19.51513168341918, 2.5581268948495057],
            [-19.518124852972228, 2.5519548458742403],
            [-19.517609991404544, 2.5477905619724317],
            [-19.521195261728746, 2.5441737131998154],
            [-19.525628582257767, 2.536210312932201],
            [-19.527824599295354, 2.53442224813596],
            [-19.531396461710695, 2.527910030281502],
            [-19.536280229337837, 2.5216635598511523],
            [-19.539518439831557, 2.515108741033075],
            [-19.542403269663637, 2.5116910698440558],
            [-19.5485947300906, 2.4991929184502086],
            [-19.550640809901065, 2.490839931876512],
            [-19.548044006986956, 2.475994600936633],
            [-19.545775683898032, 2.475082157312504],
            [-19.543858635148254, 2.467946217229449],
            [-19.544484590234593, 2.4650356405210276],
            [-19.536395139800902, 2.446007169176795],
            [-19.53357662896524, 2.436811394136918],
            [-19.533894632255905, 2.431255708883251],
            [-19.53191175495338, 2.4188585589166633],
            [-19.529412201207542, 2.4156046079982287],
            [-19.5304821440564, 2.4110758262431125],
            [-19.529368576040323, 2.4046492047664025],
            [-19.531028201082457, 2.4024976566999814],
            [-19.531582320323384, 2.3931042194193943],
            [-19.529454566923736, 2.386424030184913],
            [-19.530382008149857, 2.378443568280016],
            [-19.533816458207372, 2.376825339438065],
            [-19.536818123029075, 2.372803807752567],
            [-19.535375276921066, 2.3696238660303113],
            [-19.63284654243248, 2.3969626891611897],
            [-19.641160265066382, 2.399013523446218],
            [-19.640974782024596, 2.394914834419813],
            [-19.638871119754782, 2.3919516326051466],
            [-19.641557499884566, 2.3879684527842198],
            [-19.639628342268846, 2.3842136938284333],
            [-19.645172840590163, 2.3769228082397027],
            [-19.643545324435106, 2.3675953857453043],
            [-19.64077631650366, 2.3602995350119347],
            [-19.6399448885004, 2.3526118140923082],
            [-19.644554686841012, 2.3532410611944803],
            [-19.64631607813669, 2.355872556259835],
            [-19.658657349134295, 2.3578114952501505],
            [-19.663518652650207, 2.3496985815542923],
            [-19.66087965362864, 2.3458033690659432],
            [-19.650093695209105, 2.3421535632315624],
            [-19.64782633999832, 2.3398918131659103],
            [-19.6497255174028, 2.3349833727456315],
            [-19.65762172816234, 2.334077701693054],
            [-19.662282189878226, 2.33913663327434],
            [-19.66400454402369, 2.3353013331399373],
            [-19.662098083030212, 2.329889470854342],
            [-19.65843175559275, 2.324953374881065],
            [-19.65706850958188, 2.3166681481550215],
            [-19.65736862336813, 2.3048338914299484],
            [-19.660072690032237, 2.3035784458081436],
            [-19.659984173412823, 2.2976006706122685],
            [-19.66309323356204, 2.29663794724139],
            [-19.67134061913, 2.290363234528131],
            [-19.673572774996966, 2.2832198032693425],
            [-19.67796524620273, 2.2815727173222964],
            [-19.678252328187696, 2.277757145933718],
            [-19.682765703053192, 2.277932364657339],
            [-19.682353916677982, 2.273091716364506],
            [-19.68515992871512, 2.2683860895080383],
            [-19.6835953046593, 2.2633242809218563],
            [-19.678251985197303, 2.2590965530445675],
            [-19.678902862486247, 2.2556658962463363],
            [-19.67554337333506, 2.254717385465544],
            [-19.673516337040645, 2.250292967467888],
            [-19.678608792099457, 2.2458346766366892],
            [-19.677207735703103, 2.2409212268491605],
            [-19.690896470593508, 2.2447480247628406],
            [-19.73266337377117, 2.2570365656865445],
            [-19.751700935200716, 2.262225429918101],
            [-19.815483928646653, 2.280988600940883],
            [-19.835395225952077, 2.286458656962538],
            [-19.83198827717475, 2.290500029623969],
            [-19.82632270385381, 2.289979118649489],
            [-19.817435901317722, 2.286937137176736],
            [-19.808105600873873, 2.2808776687312196],
            [-19.803568282013135, 2.282875592128272],
            [-19.80166338004676, 2.2877617795146525],
            [-19.80206183026474, 2.2982048444819174],
            [-19.79985389715121, 2.303895428992965],
            [-19.79764651880154, 2.3052879332576914],
            [-19.792000460189048, 2.3017408830920187],
            [-19.788472812656572, 2.3098225865558635],
            [-19.78986381017574, 2.314861474172212],
            [-19.785311603179146, 2.3154571405897753],
            [-19.783040841164457, 2.310449402536627],
            [-19.78074593888295, 2.318029836030312],
            [-19.783793827812655, 2.327618462551659],
            [-19.786974920337652, 2.335253146032639],
            [-19.785790040639565, 2.3428911390056726],
            [-19.782156855438803, 2.3508407043799724],
            [-19.782433333611397, 2.35536215550387],
            [-19.780377034564978, 2.3573106338969065],
            [-19.779344887256933, 2.365294066372309],
            [-19.787251677829765, 2.370219209958764],
            [-19.793570518927016, 2.3849662479944995],
            [-19.788603664155524, 2.3976760276750873],
            [-19.79566513382312, 2.3964831494301073],
            [-19.797497751833482, 2.399996284106978],
            [-19.7988718550561, 2.4087116706922624],
            [-19.794970303077474, 2.4125257378906197],
            [-19.792986939277206, 2.420542534968033],
            [-19.79313860600411, 2.425815636108283],
            [-19.790959313922134, 2.427836414761131],
            [-19.785299202550153, 2.4283526929915045],
            [-19.785051867731013, 2.4331217235127585],
            [-19.787702463960624, 2.4388170161833287],
            [-19.7882672973585, 2.447631004323732],
            [-19.791554350540824, 2.4476067004130497],
            [-19.790409961895154, 2.4523478279082744],
            [-19.792234498244866, 2.4577106028923867],
            [-19.789879081634957, 2.460640901211389],
            [-19.794549806273707, 2.4664584010383037],
            [-19.79682250209131, 2.4779157821770177],
            [-19.802573707272497, 2.488369208057243],
            [-19.80905571199137, 2.492410601599384],
            [-19.812257820638543, 2.4967649481968093],
            [-19.814384449223557, 2.5031469935443624],
            [-19.809864026629082, 2.508415082070691],
            [-19.806095761197533, 2.5084348015396007],
            [-19.80424275185788, 2.5124667522221373],
            [-19.80828215681577, 2.5169037756897077],
            [-19.807477600461432, 2.5193411602046902],
            [-19.81433076222466, 2.526347917983502],
            [-19.81591755047334, 2.534503578069403],
            [-19.81336959217035, 2.536656955364052],
            [-19.81647471155479, 2.5433546426224223],
            [-19.818439129174696, 2.5507496679002535],
            [-19.823449110705045, 2.5570889330841924],
            [-19.82873272534392, 2.5664639217140874],
            [-19.82143511140299, 2.575182807810954],
            [-19.81818790506119, 2.5762124400799813],
            [-19.81217918138948, 2.583040036283236],
            [-19.80809598383638, 2.58892393319671],
            [-19.816738382296297, 2.5971922773485994],
            [-19.82033258312408, 2.5967143012493157],
            [-19.827361309440576, 2.60112328717637],
            [-19.82725090803425, 2.6057683986857603],
            [-19.825250981770967, 2.6076295582125537],
            [-19.82939573699546, 2.6154616562036517],
            [-19.840012550714796, 2.6172183054131777],
            [-19.839028875411294, 2.6272212637374266],
            [-19.841404568299414, 2.6314567633858656],
            [-19.84250311867367, 2.642690990488188],
            [-19.842405282071383, 2.648326346158401],
            [-19.838112235677613, 2.6466958201078423],
            [-19.835317307136688, 2.649554421031097],
            [-19.83888305714176, 2.6519849179179364],
            [-19.83955097357173, 2.6568563203377686],
            [-19.841783323058984, 2.6604812546394885],
            [-19.836803516283876, 2.6622793139352923],
            [-19.836621556955045, 2.667633373208911],
            [-19.838306079421795, 2.6723531907963385],
            [-19.842543773616235, 2.6773167983158883],
            [-19.844911014512864, 2.677493646151041],
            [-19.85306132494256, 2.68380318654495],
            [-19.852119378651214, 2.687523954176379],
            [-19.85337056590932, 2.695379700352729],
            [-19.855199563695344, 2.6978761329112286],
            [-19.856911151210344, 2.7058085409786745],
            [-19.861706402348418, 2.7117883270401975],
            [-19.868497050184033, 2.7156107734862216],
            [-19.870081322583367, 2.7195110488643337],
            [-19.875930323027337, 2.7207321033076117],
            [-19.882668962052776, 2.7246620003911146],
            [-19.88086021098384, 2.729759339590161],
            [-19.88353553235615, 2.734888863612626],
            [-19.888223481010133, 2.738156921485079],
            [-19.884550687654503, 2.7443167926865772],
            [-19.88691736323021, 2.7496969419428847],
            [-19.885915348350558, 2.752956329932413],
            [-19.88852735579428, 2.757510856024978],
            [-19.891002284791288, 2.7677756327319143],
            [-19.88256668130943, 2.775940783104909],
            [-19.88223071133482, 2.7786684591172337],
            [-19.876446746950908, 2.781510126736093],
            [-19.875557295909108, 2.7852341550057966],
            [-19.871044564118282, 2.786647894775274],
            [-19.870337043043772, 2.803636068411967],
            [-19.86384377867783, 2.8079805264852116],
            [-19.858724223052782, 2.814577503031742],
            [-19.857988027476065, 2.8202039510304577],
            [-19.855426765277993, 2.826017463387165],
            [-19.857520231738597, 2.8311326031635957],
            [-19.856237813412402, 2.8329951475569364]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.33056892609903,
          "lat": 38.50692053399878
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06055"],
        "coty_name": ["Napa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Napa County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00277292"
      },
      "bbox": [
        -19.891002284791288, 2.2409212268491605, -19.507418823311635,
        2.9711584380664524
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.544734519087262, -0.7464768146049893],
            [-8.333427513856659, -0.7715293084564834],
            [-8.268686344711712, -0.7791919479712024],
            [-8.272332743616396, -0.8098044289438039],
            [-8.210322235743357, -0.8171784218566223],
            [-8.074308096249746, -0.8311875820896457],
            [-8.070900770253502, -0.8319429058213309],
            [-8.044038709761105, -0.8343915169187164],
            [-7.945208384957309, -0.8436590370236297],
            [-7.944307332894738, -0.8356421924335127],
            [-7.919050324051826, -0.8391381110107472],
            [-7.938850836363233, -1.0147422942462283],
            [-7.879176573062098, -1.0555758131176405],
            [-7.878893687598728, -1.1112624319645887],
            [-7.814252648758097, -1.2455355621655868],
            [-7.8065612551499886, -1.2679596584500767],
            [-7.825685347799585, -1.2659136070664998],
            [-7.917417773040539, -1.2564965133418666],
            [-7.952119991176738, -1.2523161840251724],
            [-8.02235952348491, -1.2451668910329092],
            [-8.116051019118409, -1.2345023559896153],
            [-8.121052616545114, -1.226090556880314],
            [-8.206090031563233, -1.216295990849822],
            [-8.37214944815262, -1.1968863520768096],
            [-8.479660520661934, -1.1841203260032636],
            [-8.548098635966415, -1.1759120622682342],
            [-8.595859677603729, -1.1701312034340023],
            [-8.585599037962567, -1.0874282151721486],
            [-8.573762174301548, -0.9859031864399149],
            [-8.56580153196037, -0.919161210791958],
            [-8.557017446215704, -0.8476310046789975],
            [-8.556304017370193, -0.8406377495117671],
            [-8.550907046478276, -0.7980087714538427],
            [-8.550610841437528, -0.7942631668985517],
            [-8.544734519087262, -0.7464768146049893]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.04828235465207,
          "lat": 37.19353798278597
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08007"],
        "coty_name": ["Archuleta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Archuleta County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00198119"
      },
      "bbox": [
        -8.595859677603729, -1.2679596584500767, -7.8065612551499886,
        -0.7464768146049893
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.140123437316383, -0.04842716587114115],
            [-7.113884414380779, -0.051294066657389774],
            [-7.031211037727886, -0.05957954081744517],
            [-7.01917130049229, -0.06069228156483422],
            [-6.9816121289914275, -0.06479572208291921],
            [-6.954073530449388, -0.06846526231682733],
            [-6.947349823577448, -0.06887736857998678],
            [-6.9392322035069265, -0.07063391936171404],
            [-6.905255135260629, -0.07496833939960687],
            [-6.809587642674325, -0.08759974923515387],
            [-6.759524787848348, -0.09372473501041084],
            [-6.727612952244421, -0.0960166494884422],
            [-6.691586996728551, -0.09996319827425232],
            [-6.6214400358247945, -0.1078414698835645],
            [-6.619674383029981, -0.1078725153082927],
            [-6.562316442009633, -0.113080581561481],
            [-6.5636960986672825, -0.13148706216827338],
            [-6.574096111256221, -0.24403131881132878],
            [-6.577289564450742, -0.25787630331197636],
            [-6.578799837563201, -0.2760238546761172],
            [-6.587838941036737, -0.37232629485630003],
            [-6.595742236697485, -0.4573153346452956],
            [-6.59896134603825, -0.454948603068645],
            [-6.601362121624703, -0.4563046715219224],
            [-6.605928441081526, -0.4548232361083847],
            [-6.607625053066285, -0.4508193835897585],
            [-6.60726294968794, -0.4452879704848766],
            [-6.605164015262263, -0.4424262656134246],
            [-6.6044845680499975, -0.43667667450699654],
            [-6.606363776233244, -0.43292212328043733],
            [-6.605530212771238, -0.4272359657996337],
            [-6.61148108442284, -0.4223003061795667],
            [-6.61381662664248, -0.41756141028861404],
            [-6.6187002409513935, -0.41463846941695176],
            [-6.622175324110155, -0.42119932859989223],
            [-6.631144511566617, -0.4240362050570435],
            [-6.638608548071851, -0.4248853940143043],
            [-6.644781981038537, -0.4184666498344978],
            [-6.6490139536376995, -0.4180228108300666],
            [-6.651580103907611, -0.4153845903034468],
            [-6.650846388732564, -0.40610585887607586],
            [-6.656063167896805, -0.4032810561387209],
            [-6.657337947859824, -0.39884153226924607],
            [-6.653276489395652, -0.3937679947921492],
            [-6.659989900181069, -0.38592495181689424],
            [-6.658706287645417, -0.38114573195195184],
            [-6.661817438245631, -0.3775677376480196],
            [-6.6650651407618104, -0.37826570858449177],
            [-6.668069366017019, -0.37262712742383],
            [-6.667777381168438, -0.36385854482926233],
            [-6.663185747733827, -0.3587678543315159],
            [-6.672449239998784, -0.34810616235255415],
            [-6.678013389457148, -0.3444432373123065],
            [-6.686214098611487, -0.34615715618625076],
            [-6.691445861904605, -0.3487901485922353],
            [-6.693656760569459, -0.3513972332705883],
            [-6.699261815078753, -0.35393570814954906],
            [-6.704156899908291, -0.36028341268405867],
            [-6.702670781593693, -0.3689692242750419],
            [-6.704241240251807, -0.3710842948730042],
            [-6.709926184522318, -0.3710526124533109],
            [-6.710418368709285, -0.3774979820358777],
            [-6.717178960331085, -0.379892624130074],
            [-6.719430685647011, -0.38462674766483185],
            [-6.719020666934355, -0.3895954114062139],
            [-6.7252257426633415, -0.3907326443301842],
            [-6.728134814239679, -0.3954269364197295],
            [-6.730455299769683, -0.39383429216565996],
            [-6.738058273391803, -0.3958174646501594],
            [-6.7375637079044175, -0.40093053110166765],
            [-6.741196859142111, -0.4043900803869603],
            [-6.747920852219318, -0.40721500061862337],
            [-6.752864210214791, -0.41430322693627036],
            [-6.754974114489738, -0.41895199610363265],
            [-6.758180243620876, -0.41961572896278115],
            [-6.760750321940691, -0.4278344691327788],
            [-6.759540919169588, -0.43118222319181493],
            [-6.765088119319748, -0.43807994730720506],
            [-6.770618173650285, -0.4483211937092272],
            [-6.7764883997158565, -0.4543029050913597],
            [-6.7801856047510745, -0.4557609097186614],
            [-6.784382554197813, -0.4508079537721634],
            [-6.784979521929658, -0.44595218303359013],
            [-6.788814677853511, -0.44484132650506214],
            [-6.790700072594404, -0.4414712933378387],
            [-6.791236889443712, -0.4357050854419882],
            [-6.789877729258972, -0.4307997484597331],
            [-6.791955061623248, -0.4274473160905779],
            [-6.7936589584683595, -0.4210864910338589],
            [-6.801168277589879, -0.41359379053579304],
            [-6.807005758547017, -0.41354204720047255],
            [-6.816190161315858, -0.4176764923174314],
            [-6.819993577983277, -0.42150650655641014],
            [-6.825991625975936, -0.42554705610516175],
            [-6.839139584430363, -0.4269772523466761],
            [-6.85007932490865, -0.43195110510430795],
            [-6.872578097581384, -0.45034068434357055],
            [-6.876814588585267, -0.45127983594555976],
            [-6.881045489009215, -0.45483234371482917],
            [-6.885058174950816, -0.4552696771454907],
            [-6.891974098816216, -0.4529408553970082],
            [-6.8948413575420835, -0.44875156357366197],
            [-6.901065789974936, -0.44580363234114434],
            [-6.910643593627707, -0.44665493560518194],
            [-6.915840198994588, -0.4446261884451625],
            [-6.922020756589881, -0.4456873095179859],
            [-6.926822448542168, -0.4447455487301908],
            [-6.930776058560541, -0.43974777977471113],
            [-6.93008270511189, -0.43693094924019227],
            [-6.9332228826725295, -0.43493712173296073],
            [-6.937043596145693, -0.4296416716155486],
            [-6.938834192774307, -0.4240023838682912],
            [-6.943023527663603, -0.41839252184555514],
            [-6.947282990972784, -0.41452901342174464],
            [-6.949598824266408, -0.4068931481620351],
            [-6.950114495689894, -0.4016919097869367],
            [-6.9519234133307455, -0.39842812680439565],
            [-6.960726330860165, -0.3885051055562291],
            [-6.96335304337705, -0.38672471868646796],
            [-6.967573876639966, -0.38056485598538403],
            [-6.974759314624854, -0.37849354949150366],
            [-6.980747504764681, -0.38056843834088694],
            [-6.982420672567724, -0.38373579591080675],
            [-6.988880840673495, -0.3817626413824737],
            [-6.993693038339768, -0.37593921764361393],
            [-6.996298192653521, -0.3745382939453444],
            [-7.000985000699462, -0.36668587837396327],
            [-7.005667803884584, -0.36452740362431246],
            [-7.0062161282908075, -0.36116821558785916],
            [-7.002987671604754, -0.3566494122269566],
            [-7.005941889103602, -0.3518217485214235],
            [-7.00697400565296, -0.34461048278603984],
            [-7.011995753343776, -0.3342759952743744],
            [-7.013886795093869, -0.33342364447157435],
            [-7.015046747233682, -0.32797438582367033],
            [-7.017904020406378, -0.32490366016539834],
            [-7.017305794946231, -0.32117739572347154],
            [-7.011185173139621, -0.31683144491208914],
            [-7.011187590124813, -0.31035460065922077],
            [-7.014468351381366, -0.3027903051835554],
            [-7.014369297897267, -0.2986196079467979],
            [-7.018801828728104, -0.29707895052350386],
            [-7.018127126126127, -0.2944931833802487],
            [-7.021215903173998, -0.29100079994005323],
            [-7.021974793002457, -0.2852631095063367],
            [-7.0239655683640105, -0.28140799525559496],
            [-7.02320695282543, -0.27539600356903693],
            [-7.028975536561788, -0.2723405071416696],
            [-7.030691017737594, -0.27010262640377375],
            [-7.028726781155568, -0.266815684114244],
            [-7.02906385539033, -0.2605400914758385],
            [-7.03423914144241, -0.2578518929184608],
            [-7.036313541114183, -0.25423342058259957],
            [-7.0354144316363705, -0.25149601534535865],
            [-7.041541402964464, -0.2439498614385433],
            [-7.048726899649486, -0.23318201383122503],
            [-7.048184511310437, -0.22999016450411194],
            [-7.05220397953706, -0.22407667589044825],
            [-7.051010660115504, -0.21345302105588454],
            [-7.04755038000364, -0.20776025235161777],
            [-7.051244134460416, -0.20565387371665214],
            [-7.057697703674799, -0.18648241700495033],
            [-7.059024606105403, -0.1774376070354574],
            [-7.056357606212323, -0.1758829002513878],
            [-7.053587628661366, -0.17096454675022177],
            [-7.05519474893355, -0.16468060414853392],
            [-7.061049016447256, -0.16268574345353345],
            [-7.065088291280056, -0.15583410973573228],
            [-7.070141259333729, -0.15644085214532677],
            [-7.075362987056651, -0.15241229798887673],
            [-7.076225467079777, -0.14722511486599707],
            [-7.078457336455294, -0.14472769886474887],
            [-7.080172707547317, -0.1390479987629352],
            [-7.0858167823384255, -0.13500466390635812],
            [-7.0928189104889015, -0.1196357284290673],
            [-7.097494155098531, -0.11708658390847648],
            [-7.099324994274438, -0.10896207633814498],
            [-7.102315580424401, -0.10792163712230585],
            [-7.105048775977348, -0.10325506051317165],
            [-7.109544875425057, -0.10318822465342063],
            [-7.113633258092722, -0.09793302499206204],
            [-7.113058050426462, -0.09191656350683758],
            [-7.114928202978465, -0.08806321827068635],
            [-7.119468616269608, -0.08532427667073034],
            [-7.12119469032235, -0.08214137640677699],
            [-7.126566446720399, -0.0794694772595904],
            [-7.132730311572, -0.07499153899690807],
            [-7.136752362560688, -0.06977710928988093],
            [-7.135664872311372, -0.06194158134104628],
            [-7.1396805105553955, -0.053455574319495915],
            [-7.140123437316383, -0.04842716587114115]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.36751244656968,
          "lat": 38.10868640831023
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08027"],
        "coty_name": ["Custer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Custer County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00198129"
      },
      "bbox": [
        -7.140123437316383, -0.4573153346452956, -6.562316442009633,
        -0.04842716587114115
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.2821971353740125, 1.0979677918390711],
            [-7.2790824515936405, 1.0975989757092948],
            [-7.270925874720491, 1.0937618146266994],
            [-7.259917205939892, 1.0939473952753331],
            [-7.253186677154288, 1.0932863143747515],
            [-7.245257950664972, 1.0840531856684466],
            [-7.236663261201689, 1.0820289759957218],
            [-7.232755104102496, 1.077349266571369],
            [-7.223970268222182, 1.0703278369059994],
            [-7.21481332282758, 1.0682873179528427],
            [-7.207693085734856, 1.0685454994721388],
            [-7.2012878374579214, 1.0708683940329216],
            [-7.197626701120017, 1.0708665688016452],
            [-7.193913403546536, 1.074320429766795],
            [-7.192277822559497, 1.0837742994822586],
            [-7.192806468245467, 1.0903411249361528],
            [-7.188772342603696, 1.0954916067387206],
            [-7.1845743051045, 1.095512698595869],
            [-7.180252581139721, 1.099531953016187],
            [-7.1742675837226475, 1.1021833103194825],
            [-7.169393879555629, 1.1089774192661839],
            [-7.164110809061504, 1.1086628926021598],
            [-7.162444364325169, 1.1120728579073056],
            [-7.158321198531891, 1.114273059475884],
            [-7.138524952102037, 1.1183293160166967],
            [-7.140469205335443, 1.1268878636341033],
            [-7.139689748253186, 1.1302249483346551],
            [-7.143875774895473, 1.1335045831249244],
            [-7.146671269154384, 1.1382822349148842],
            [-7.147534412854386, 1.1430403373696059],
            [-7.143487082655848, 1.1447010589571849],
            [-7.137462772160345, 1.1424936912891483],
            [-7.13001201798822, 1.1441161978639054],
            [-7.127251314650361, 1.1558651064490837],
            [-7.123980212452232, 1.1613315496171766],
            [-7.117167426708674, 1.1614694247778212],
            [-7.111273061038727, 1.1599556708015433],
            [-7.102578314842241, 1.1589652304782163],
            [-7.098981090476948, 1.1598888478947664],
            [-7.095362065544252, 1.1641691894450836],
            [-7.094628622410953, 1.169542742798304],
            [-7.086271013802412, 1.1802628723501167],
            [-7.083737183232053, 1.182338247235213],
            [-7.076014451755032, 1.1819555160302753],
            [-7.074839712196988, 1.1877700603884553],
            [-7.069784319969445, 1.1925092963021275],
            [-7.065399316003862, 1.1915886903377109],
            [-7.062286494698108, 1.1993352946081703],
            [-7.056523411059, 1.2016018527586385],
            [-7.0584924710514105, 1.2089277147187345],
            [-7.063293171030069, 1.214048403511377],
            [-7.063895391247632, 1.216940035359753],
            [-7.0610639326960225, 1.2193086076369182],
            [-7.0592472339017585, 1.2240182056674618],
            [-7.054727928825078, 1.22873770733636],
            [-7.052756598090216, 1.2242812205451519],
            [-7.04620572127179, 1.2194217240091665],
            [-7.045175188824842, 1.2215894396201088],
            [-7.033666102120066, 1.2265337362701714],
            [-7.029196040758987, 1.2245653369409124],
            [-7.023601342015264, 1.2318484903434224],
            [-7.023805715417958, 1.2394842061436768],
            [-7.020793087097417, 1.2454228574334731],
            [-7.025646584278117, 1.2469770621753067],
            [-7.027977910072954, 1.2499237375068282],
            [-7.029976665839917, 1.2594521266739171],
            [-6.949311462880713, 1.251620215616893],
            [-6.947843017476291, 1.2513863227303574],
            [-6.873414190410574, 1.2455795995480794],
            [-6.84602777679684, 1.243980537371302],
            [-6.737540689040641, 1.2308436326505308],
            [-6.702596417132786, 1.2274378787261973],
            [-6.706385226485805, 1.1859232279682679],
            [-6.713264760048634, 1.1130772052239408],
            [-6.71859650361918, 1.0600089838385027],
            [-6.721027240080032, 1.0386286698289824],
            [-6.723448630119118, 1.0110841396428636],
            [-6.726276191427186, 0.9865056689684062],
            [-6.726903736170564, 0.9760056701674454],
            [-6.730905926666854, 0.9247790925934248],
            [-6.733296824440219, 0.9099091038514748],
            [-6.7422949674501025, 0.8181186286468879],
            [-6.7452799220354605, 0.788934676561572],
            [-6.693682622283667, 0.7837437424019503],
            [-6.706504900821594, 0.6464134746855856],
            [-6.709980264185122, 0.6141888560591245],
            [-6.716257919453526, 0.5458460144884859],
            [-6.719646348275736, 0.5104073457416242],
            [-6.735332844932007, 0.3496632188703354],
            [-6.735887093327241, 0.3493586281458956],
            [-6.86558016543847, 0.3621653086893467],
            [-6.891311023995879, 0.36354324170621977],
            [-6.956448216590363, 0.3696030761118288],
            [-7.022572242891364, 0.3756266435982766],
            [-7.059870552080947, 0.37943759511743064],
            [-7.156006538486713, 0.38900783504382375],
            [-7.166177232755689, 0.39092901656885565],
            [-7.173608938275991, 0.3903003655148315],
            [-7.20911912018696, 0.3933302867464955],
            [-7.2284902018804145, 0.39583614201637063],
            [-7.227526305527593, 0.3994252573300197],
            [-7.224553403438877, 0.40093276447283976],
            [-7.221075568820812, 0.4077509951041978],
            [-7.213521999612669, 0.4146728296710979],
            [-7.20793079579994, 0.4172012288643822],
            [-7.208625806165414, 0.42079210536058226],
            [-7.2051665852579605, 0.4234288938432582],
            [-7.20674189528662, 0.4279507826180958],
            [-7.203618495088176, 0.4348280334017198],
            [-7.2066512670298755, 0.4424126891313615],
            [-7.201838030985876, 0.4450534717082085],
            [-7.197980411999246, 0.4536811480482028],
            [-7.197343529047714, 0.463093556623303],
            [-7.199647058004871, 0.46890899352836796],
            [-7.1968117035247685, 0.47214030757510544],
            [-7.190689519495617, 0.47227059334808863],
            [-7.188857615729026, 0.4739038638854659],
            [-7.188347472976152, 0.4807975034984004],
            [-7.184833067493277, 0.48172552051100187],
            [-7.181028442765238, 0.4881216353354868],
            [-7.175006657073597, 0.4906371175435632],
            [-7.171206472666215, 0.502845983979369],
            [-7.168019123970558, 0.504629153103165],
            [-7.170796360409812, 0.5084921532972756],
            [-7.172750067072658, 0.5143633949954587],
            [-7.175079101299917, 0.5160914521670239],
            [-7.187781240551035, 0.5367582764060379],
            [-7.191557777812101, 0.5410316875521055],
            [-7.188891753675788, 0.5464938175360646],
            [-7.190982558407098, 0.553571973771829],
            [-7.188062405443901, 0.5571140421787009],
            [-7.182601002377263, 0.5610667333918343],
            [-7.180828566866215, 0.56643997905177],
            [-7.178539897040327, 0.5660091482252324],
            [-7.17648775796749, 0.5738098354790325],
            [-7.179745266999921, 0.574632559070737],
            [-7.180768144455717, 0.5783031024725706],
            [-7.186326983471135, 0.5863713069861868],
            [-7.192647299650282, 0.5845092590302833],
            [-7.197572188162387, 0.5856227494438506],
            [-7.20447803356509, 0.588669840219311],
            [-7.212004996883123, 0.5858897137166669],
            [-7.215062016703772, 0.5927650273117597],
            [-7.214653602067882, 0.5984275300811435],
            [-7.210329073219837, 0.6001516024774484],
            [-7.205753300786954, 0.6037712417900171],
            [-7.204376802400001, 0.6079094937945889],
            [-7.205535161835204, 0.6117541700840183],
            [-7.210824999624181, 0.6143579079203016],
            [-7.210611624804209, 0.6182805257853237],
            [-7.217279799897676, 0.6226360936563335],
            [-7.224022149850483, 0.6200499422449628],
            [-7.2363602557834845, 0.6363858394186369],
            [-7.237883203832936, 0.6396403185258848],
            [-7.241908044711979, 0.6420113004787419],
            [-7.246863370252039, 0.6508822046169772],
            [-7.253756118939053, 0.649376856540473],
            [-7.26051555679384, 0.6510083642474539],
            [-7.264849098272431, 0.6534013038169624],
            [-7.2700413669979955, 0.6522804686474226],
            [-7.271992287564447, 0.6477646010603444],
            [-7.276966721670609, 0.6429558342044728],
            [-7.280444945278954, 0.6435439414397586],
            [-7.282830584203178, 0.6464852021509587],
            [-7.286351261015428, 0.647364444619415],
            [-7.291028165354129, 0.6521317845380105],
            [-7.295425483837682, 0.6496385640997601],
            [-7.3065872052506435, 0.6547084584958631],
            [-7.310627151979552, 0.6548706617889459],
            [-7.311722189157999, 0.6599881677627591],
            [-7.31027098003385, 0.665807453056536],
            [-7.3111098214122885, 0.6703838230358213],
            [-7.309390851311942, 0.6751357886048652],
            [-7.30604713907817, 0.6781039890868223],
            [-7.3028039366247, 0.6844214113406243],
            [-7.301912073289614, 0.6885042795452698],
            [-7.305013774939646, 0.696442108242415],
            [-7.3045759397483625, 0.7007673257460106],
            [-7.309904242087612, 0.7035142554031045],
            [-7.317493792337176, 0.710349496448531],
            [-7.321197763449907, 0.7122707825770065],
            [-7.328931111744944, 0.7130063253111375],
            [-7.330773944955838, 0.7157126770323827],
            [-7.342663765129353, 0.7138490738800077],
            [-7.349775127373766, 0.7112729186768575],
            [-7.349993074457003, 0.7144693930018738],
            [-7.354482059834313, 0.7223690720155154],
            [-7.354974814904237, 0.731372639347594],
            [-7.359446271813014, 0.7336984163136256],
            [-7.3599838728716, 0.7368166232528292],
            [-7.36396584295455, 0.7382137827227135],
            [-7.361968202313587, 0.7428015867676699],
            [-7.363095089329391, 0.7510540861182368],
            [-7.3587178914429225, 0.7545521748483738],
            [-7.354769380508111, 0.7595647957996122],
            [-7.356360264256298, 0.7652889563110495],
            [-7.355212648876538, 0.772087272959463],
            [-7.35938154931112, 0.7778522858458077],
            [-7.358125449204257, 0.7857486459309578],
            [-7.358531252550646, 0.7898537736378848],
            [-7.35427307569199, 0.7931067021640785],
            [-7.35359410579017, 0.7964340786267441],
            [-7.348930739358928, 0.7982252170227878],
            [-7.344770710793871, 0.8035594061074224],
            [-7.339553315472801, 0.8069231525156338],
            [-7.34053375214758, 0.8164080298960387],
            [-7.344765251370043, 0.8242228302750743],
            [-7.357791170444244, 0.8268233389275345],
            [-7.36381091140521, 0.8257050620991607],
            [-7.3688592100043, 0.8274534534973835],
            [-7.362646508114152, 0.8371109277857096],
            [-7.359442839664753, 0.8382065467944257],
            [-7.352734934806028, 0.8429274983058425],
            [-7.350223461776185, 0.8432258130053117],
            [-7.347497948923841, 0.8508724080955572],
            [-7.344708726974692, 0.8516293664910938],
            [-7.341264276695022, 0.8558076326109475],
            [-7.337522283031158, 0.8577467789916592],
            [-7.336394742257292, 0.8654637239298508],
            [-7.336595918958333, 0.8771632171894812],
            [-7.338782355024704, 0.8862697989049824],
            [-7.336960622715587, 0.8957638343852999],
            [-7.339695797067969, 0.9019698785541436],
            [-7.341096815086759, 0.9083990514140986],
            [-7.335614258661831, 0.9148209782859829],
            [-7.335054188100296, 0.9213650735019157],
            [-7.3380465201976435, 0.9311389361423428],
            [-7.332816280482257, 0.9343025634844649],
            [-7.332004942218832, 0.9404632092271449],
            [-7.325440293562097, 0.9436787460125926],
            [-7.32319287605029, 0.9512810856705111],
            [-7.326069488239639, 0.9577677236867881],
            [-7.33328207275223, 0.9613886530814816],
            [-7.334728395706306, 0.9646772304989694],
            [-7.331046150293769, 0.9698315428046159],
            [-7.33049191767877, 0.9787506329697659],
            [-7.329204552220874, 0.9827665156018678],
            [-7.331157314963868, 0.9908576514395752],
            [-7.331965696700505, 1.0021028552437166],
            [-7.330336791382112, 1.0079173852584598],
            [-7.3271594685413906, 1.0118568081127242],
            [-7.325462252122827, 1.020640553575961],
            [-7.326843659029031, 1.023136217515815],
            [-7.326655726720568, 1.031483219980035],
            [-7.320613343171493, 1.033595950109445],
            [-7.318232247316444, 1.0396351968944955],
            [-7.314219234214476, 1.0432201396393486],
            [-7.3022992118111505, 1.0400995597523917],
            [-7.2898438677524915, 1.058189539297663],
            [-7.292119035441163, 1.062059195835934],
            [-7.294282009438723, 1.0691724026477705],
            [-7.294284891734119, 1.078013341822814],
            [-7.297266028974542, 1.0822573123584227],
            [-7.293501536315742, 1.0878134974038165],
            [-7.290150021455428, 1.087220925075215],
            [-7.285248023025, 1.090879172472395],
            [-7.2821971353740125, 1.0979677918390711]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.71716199028387,
          "lat": 39.119379773493236
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08093"],
        "coty_name": ["Park"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Park County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00198162"
      },
      "bbox": [
        -7.3688592100043, 0.3493586281458956, -6.693682622283667,
        1.2594521266739171
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.908785599680986, 5.326495530562303],
            [16.947623291808405, 5.336821038843018],
            [17.047644004338768, 5.357280425773723],
            [17.09444152233837, 5.366470206246002],
            [17.22206211135859, 5.392454279396467],
            [17.260832109890323, 5.40072171068424],
            [17.358353523502085, 5.423785045851981],
            [17.358788917799348, 5.4214896816131635],
            [17.357980799253443, 5.396749522273098],
            [17.357557524847525, 5.393746062569435],
            [17.357252487812325, 5.356786846745522],
            [17.355475132137176, 5.277486099693581],
            [17.337713958898373, 5.271452107202294],
            [17.338091992196357, 5.252985173896726],
            [17.338750219691992, 5.249833492641514],
            [17.33837681062751, 5.228962946892028],
            [17.340119838788205, 5.221911658746555],
            [17.342852159109707, 5.218468702227739],
            [17.345973051808695, 5.2201997236232796],
            [17.351579189297034, 5.220421814987002],
            [17.35398358896485, 5.2186964843971575],
            [17.35317880046621, 5.183533291785139],
            [17.369125883657343, 5.190286075436428],
            [17.373325854440445, 5.187221874343883],
            [17.369074305319614, 5.183740137937082],
            [17.371930300881477, 5.180167539120209],
            [17.374988720851015, 5.169637946867704],
            [17.38034214388539, 5.162271790863185],
            [17.382662648463256, 5.1611470417625815],
            [17.389663818381297, 5.1611217713922315],
            [17.39656850888668, 5.1442676915162755],
            [17.398961840411587, 5.136739313684271],
            [17.406546286668416, 5.119806949619568],
            [17.409818414698417, 5.111445698449542],
            [17.405203681475534, 5.109272241961521],
            [17.37864632514684, 5.09926659839055],
            [17.375342829318853, 5.097175697383674],
            [17.35900271565558, 5.091101134902328],
            [17.340282303883715, 5.083270287958076],
            [17.33953581479486, 5.085050715347264],
            [17.30052922023755, 5.069024553906382],
            [17.29133187370864, 5.065666774175714],
            [17.282204791523316, 5.055346288038434],
            [17.272588372640996, 5.046185046106957],
            [17.25118390358097, 5.023248722946363],
            [17.246700357102185, 5.018781050629617],
            [17.226759670904386, 5.010711055599982],
            [17.20932772308274, 5.005427868867977],
            [17.183086017225428, 4.996765431802003],
            [17.162533523880224, 4.99036602097103],
            [17.182607799847837, 4.933135989135945],
            [17.172957651646946, 4.929413318827547],
            [17.187075763278706, 4.890896092513539],
            [17.195494223106916, 4.866411187125044],
            [17.205577321062197, 4.84322760515754],
            [17.167228047649285, 4.827641027167449],
            [17.159133676305263, 4.824774028057495],
            [17.151071835516944, 4.822014136211037],
            [17.146976640297233, 4.830410806030948],
            [17.13965511262801, 4.8496028050129265],
            [17.132574245866394, 4.864204326363774],
            [17.12723905138472, 4.879737435099288],
            [17.116256548121832, 4.907380753465449],
            [17.102366339838973, 4.939963174762807],
            [17.096506182579976, 4.9556378119657865],
            [17.086255607998908, 4.962212664184512],
            [17.080011345973404, 4.964522905060092],
            [17.07509482550253, 4.976413186063439],
            [17.07115541952774, 4.987526005231296],
            [16.98665525262523, 4.952473664687055],
            [16.985382443764717, 4.948759218588062],
            [16.977007195408202, 4.9477096743314934],
            [16.973131628603234, 4.968304279908513],
            [16.964034506444346, 5.021210423359506],
            [16.960520052022826, 5.038750298302886],
            [16.949370470775115, 5.1037205489001805],
            [16.94336515701549, 5.137815086499317],
            [16.938026777407863, 5.171405045027219],
            [16.932245621482036, 5.2008414479262175],
            [16.926255707746787, 5.236696489705049],
            [16.91884406805214, 5.277801850167428],
            [16.908785599680986, 5.326495530562303]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.22118928359768, "lat": 41.84689343456919 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09160"],
        "coty_name": ["Northwest Hills"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Northwest Hills Planning Region"],
        "coty_fp_code": "160",
        "coty_gnis_code": "02830251"
      },
      "bbox": [
        16.908785599680986, 4.822014136211037, 17.409818414698417,
        5.423785045851981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.461620821697137, -7.670925478428717],
            [12.541872349939357, -7.659734673486651],
            [12.5717635118607, -7.654703189536814],
            [12.63508244621142, -7.643710194829084],
            [12.671932515953722, -7.637618832149568],
            [12.726305553372532, -7.629307128851067],
            [12.730322141190749, -7.624543969963414],
            [12.737762129265304, -7.625895978669257],
            [12.7569580357397, -7.622539532875956],
            [12.776731584325526, -7.620556343310962],
            [12.77630914058232, -7.629710974664883],
            [12.77022608816842, -7.6401632648283675],
            [12.772074325516071, -7.650526496826891],
            [12.772945455508774, -7.667058923238324],
            [12.773563036687005, -7.669376146295306],
            [12.78663848184072, -7.6885875131612424],
            [12.787603137018976, -7.703560606761373],
            [12.791333266988133, -7.71935809004753],
            [12.792142793448125, -7.726484918797535],
            [12.787615685901864, -7.746928210742298],
            [12.789665376064834, -7.766814120961212],
            [12.793160517552387, -7.780603875366754],
            [12.79583748524008, -7.785803653583295],
            [12.800133152425179, -7.791466119578825],
            [12.804706325837003, -7.795253663162909],
            [12.811575400626289, -7.799227120846456],
            [12.8554628953903, -7.818672001382168],
            [12.869278164846387, -7.827648890847994],
            [12.874811863997381, -7.83357058306444],
            [12.88079856671231, -7.843960407995542],
            [12.883183051966972, -7.852914378055478],
            [12.88316292492908, -7.859334930126406],
            [12.879950519333198, -7.873347105833845],
            [12.879044412712537, -7.880878768996233],
            [12.880136844816148, -7.8869808319963735],
            [12.884373855037074, -7.899332534856627],
            [12.893126678487036, -7.9191371004312305],
            [12.913707626797061, -7.951363798225599],
            [12.844842292705579, -7.963160655728015],
            [12.763273400076415, -7.977133095949243],
            [12.716103105511491, -7.984733575451105],
            [12.711281176484913, -7.991715017866994],
            [12.709519209917321, -7.995885557216157],
            [12.70464371902052, -7.998535053777424],
            [12.698064175908316, -8.007808612595666],
            [12.690295246186544, -8.015625517966676],
            [12.685419016353846, -8.01888272780207],
            [12.679000463591294, -8.02662663915562],
            [12.67175036579896, -8.027019870933735],
            [12.654690836056371, -8.032210973115584],
            [12.64713769315337, -8.037416567876697],
            [12.639442239256343, -8.039126003815229],
            [12.635531089023944, -8.04186915553301],
            [12.631135831993392, -8.047766978914153],
            [12.62909682012367, -8.053318282867819],
            [12.62737707068874, -8.066842512042523],
            [12.627860675391378, -8.073342773305322],
            [12.626223731690459, -8.078572427933183],
            [12.620359470059835, -8.088084370133641],
            [12.5888296077892, -8.09311379569608],
            [12.576552235885174, -8.098085981361919],
            [12.563475477440894, -8.104475218956855],
            [12.550247406306037, -8.12068878760577],
            [12.54777004771646, -8.127615137782227],
            [12.530316734414114, -8.130182516120513],
            [12.528840883430238, -8.101903757979434],
            [12.52534594809747, -8.080513337451851],
            [12.522332442637753, -8.059843469937968],
            [12.520765943701447, -8.05198438548865],
            [12.517897303495863, -8.030932937070089],
            [12.516438509197211, -8.023265361787937],
            [12.498924050101706, -7.914546266007042],
            [12.493659871191861, -7.880007173738609],
            [12.493621163824217, -7.875762831196966],
            [12.491348191079139, -7.860341931146384],
            [12.480989524223812, -7.799510824834155],
            [12.468023481517013, -7.713924460532408],
            [12.461620821697137, -7.670925478428717]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.85785147063858,
          "lat": 29.983074309318678
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12019"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00295726"
      },
      "bbox": [
        12.461620821697137, -8.130182516120513, 12.913707626797061,
        -7.620556343310962
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.260161812258985, -10.086596526912224],
            [13.289777200306602, -10.082349114260596],
            [13.33585681392484, -10.075166965980834],
            [13.400925040643232, -10.065276356530772],
            [13.437791135675518, -10.05978709438966],
            [13.534490082433582, -10.046520292234877],
            [13.631185722338168, -10.033226808065711],
            [13.629997792359168, -10.03748386373935],
            [13.633286095179168, -10.04279167430542],
            [13.632434122379143, -10.045349138300319],
            [13.634599886021128, -10.04987332705381],
            [13.634191187963488, -10.057700261365198],
            [13.632996452530097, -10.058995966273905],
            [13.638024450522973, -10.06715059813986],
            [13.639173088715575, -10.073599063059843],
            [13.636891394979095, -10.077993141070996],
            [13.632396840868884, -10.078851131873375],
            [13.631852283843383, -10.081401972033706],
            [13.627665939821716, -10.085613704923295],
            [13.628753723546643, -10.08890932434291],
            [13.626729774064675, -10.093174363106883],
            [13.628308103666836, -10.101189084801197],
            [13.619120688027316, -10.104765215937952],
            [13.617357824556832, -10.110202188091469],
            [13.614638791381863, -10.114091839075133],
            [13.61453714709741, -10.118998451461163],
            [13.60887213482332, -10.12172696484784],
            [13.603438853720894, -10.12302767802639],
            [13.60263558794356, -10.12688205135646],
            [13.595204501444949, -10.135124846725956],
            [13.589887076353152, -10.134753384849796],
            [13.59108427978046, -10.138903193551885],
            [13.594200988888122, -10.141968945709946],
            [13.588680100376274, -10.147300103984206],
            [13.587829747595379, -10.151035989873831],
            [13.58906726017219, -10.157091980261548],
            [13.592899546023427, -10.16349566182607],
            [13.59628402375788, -10.165854320521833],
            [13.599567407624681, -10.164336655093555],
            [13.602211731362162, -10.169507422064772],
            [13.599665535283421, -10.176294064485472],
            [13.602055067266242, -10.178757516796969],
            [13.598896279003975, -10.18178465249327],
            [13.599557749078501, -10.190414915735671],
            [13.602781421941971, -10.190162796901964],
            [13.60525767198848, -10.192929857108375],
            [13.610831526438009, -10.192113012302714],
            [13.614615634530328, -10.195127720806214],
            [13.619444601487531, -10.193205099574355],
            [13.625813768496776, -10.198122450450171],
            [13.626142280578714, -10.200975357499653],
            [13.631535168186865, -10.205708155355913],
            [13.633357429565084, -10.212184948662529],
            [13.636155802107261, -10.2146750692356],
            [13.649572632977243, -10.21795270477735],
            [13.650927481815417, -10.2213133466433],
            [13.654840914391151, -10.225422207535127],
            [13.659515930571546, -10.225442762368885],
            [13.666346209655845, -10.235286983548736],
            [13.666841858135573, -10.256536720934527],
            [13.670177062032465, -10.256696304149484],
            [13.674207550024594, -10.259215682129032],
            [13.683375657340775, -10.262747970783499],
            [13.684788484089214, -10.272470758726236],
            [13.68884938287258, -10.275600045853398],
            [13.69153875258873, -10.274802769911124],
            [13.696530843133205, -10.279356781591067],
            [13.70353333266824, -10.279988764440949],
            [13.706937544029357, -10.27920773286966],
            [13.710757779146375, -10.28282729899965],
            [13.716755181822109, -10.277173992754282],
            [13.724358996514, -10.27490604864743],
            [13.727855762267765, -10.275931280395692],
            [13.736639534826189, -10.275559642360822],
            [13.74136358557169, -10.277772611341556],
            [13.746591435439885, -10.283245581545852],
            [13.75188630954885, -10.283146029241008],
            [13.755043244773633, -10.285567064695483],
            [13.754864596073405, -10.29187203132618],
            [13.764305801840742, -10.290865031145652],
            [13.769546414206928, -10.292945242237508],
            [13.774656813466517, -10.300175835320756],
            [13.773489221890683, -10.304228950362342],
            [13.770465409078323, -10.304108727584177],
            [13.764979519835093, -10.306627201534605],
            [13.766095215705139, -10.309334580061657],
            [13.763417613764556, -10.31200092923956],
            [13.763267203043513, -10.315800621149227],
            [13.768159554085413, -10.324268550214917],
            [13.77186193105223, -10.32209422219928],
            [13.779664623725221, -10.327080898443251],
            [13.777375386727613, -10.329135805465228],
            [13.780147400490218, -10.332379557122419],
            [13.782786266854375, -10.338192217330871],
            [13.783505045838357, -10.344100586334273],
            [13.787759784404555, -10.347385630548256],
            [13.798070700668053, -10.348066946532555],
            [13.799268868683559, -10.346132887893546],
            [13.805878389284342, -10.344348678478326],
            [13.807352327621143, -10.347717320252848],
            [13.81254012856535, -10.350106182486455],
            [13.813687925418149, -10.359431155979294],
            [13.814681781183156, -10.37401893938895],
            [13.817898916893219, -10.379901397808837],
            [13.818098505289496, -10.382807081649515],
            [13.824094414535546, -10.392712162277931],
            [13.829945744693896, -10.393460557711569],
            [13.834563214437598, -10.396437379583219],
            [13.83436041009022, -10.400606277238818],
            [13.836601546372915, -10.409332183504068],
            [13.842705083722914, -10.414722769974995],
            [13.848146884929337, -10.4211544675754],
            [13.854357640525846, -10.42017229791941],
            [13.860034848835475, -10.418028528969959],
            [13.8609914985804, -10.413633578565634],
            [13.870383934842813, -10.418198915315497],
            [13.873291917007641, -10.422369055763767],
            [13.873864852864145, -10.425963129426735],
            [13.876912762529154, -10.428372012317373],
            [13.8574769842777, -10.426638891567466],
            [13.74037822444516, -10.445566103892956],
            [13.6745279518352, -10.456319500676619],
            [13.688860160526396, -10.541041167991517],
            [13.634152146974408, -10.550015357447364],
            [13.601042074619164, -10.555208094946083],
            [13.61505026016427, -10.640695285164156],
            [13.556803202891945, -10.649726064301513],
            [13.555695035187336, -10.642724747826872],
            [13.547894370736957, -10.643813148195656],
            [13.54826361822231, -10.651078569896228],
            [13.450786253092767, -10.665195161982513],
            [13.353304820320115, -10.679282788633184],
            [13.35320017277083, -10.67915230106145],
            [13.326305170185968, -10.509396796283415],
            [13.326091796965164, -10.507131300850219],
            [13.30577007158167, -10.382880259870074],
            [13.300833079290827, -10.351292180099557],
            [13.294830645494294, -10.31099610447238],
            [13.273191493815194, -10.171300846329345],
            [13.268903088669049, -10.14252494789585],
            [13.260161812258985, -10.086596526912224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.34102173218866,
          "lat": 27.343316291755546
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12055"],
        "coty_name": ["Highlands"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Highlands County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00295756"
      },
      "bbox": [
        13.260161812258985, -10.679282788633184, 13.876912762529154,
        -10.033226808065711
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.780866502623573, -12.102984394118003],
              [14.780246032337072, -12.098401239740287],
              [14.782894769942729, -12.093598268095038],
              [14.781066556486206, -12.08947699951179],
              [14.780278389638324, -12.082364489623489],
              [14.78719252612351, -12.073844893343406],
              [14.792162458099599, -12.074805734014571],
              [14.795848153342918, -12.071449805070822],
              [14.794818072535989, -12.069549183571652],
              [14.788371270766074, -12.068950757013878],
              [14.78484316948316, -12.070407581570333],
              [14.783294869329296, -12.067841388711262],
              [14.789116858021318, -12.062895511450671],
              [14.793935554007854, -12.066892774612962],
              [14.797000225597367, -12.063947140231187],
              [14.795084269353785, -12.059803347747954],
              [14.799298826304579, -12.057507748068499],
              [14.804402924802426, -12.056606003751098],
              [14.807149066855402, -12.052842897636896],
              [14.811203029062101, -12.052541394256505],
              [14.81282387696223, -12.047768702514968],
              [14.816409072529918, -12.04346525420918],
              [14.814166091580768, -12.033552923360087],
              [14.81164460847134, -12.030773341137344],
              [14.81632739228278, -12.02600381602611],
              [14.819129089517162, -12.016600821925156],
              [14.822635321535246, -11.996352905527207],
              [14.82248656873555, -11.985979720381305],
              [14.824905356154433, -11.98033625221063],
              [14.825042720098887, -11.974878828741314],
              [14.827886052197647, -11.970305451764274],
              [14.829004156572667, -11.964016085867238],
              [14.820714976579575, -11.961555145234938],
              [14.819146611504392, -11.957925052921958],
              [14.820005834836419, -11.953397491232082],
              [14.823608558337954, -11.953548624957358],
              [14.827006903857866, -11.95141575306047],
              [14.828304498044188, -11.94699345687257],
              [14.827374289929022, -11.94076389355106],
              [14.830012728613909, -11.941150780467904],
              [14.830608479405758, -11.947015186429013],
              [14.829770066706871, -11.955801605143408],
              [14.832458280654688, -11.963358047930516],
              [14.833996952263833, -11.970398360242692],
              [14.833042978516644, -11.975056951921898],
              [14.826107172191135, -11.995736673251878],
              [14.827527930442216, -12.00331290326516],
              [14.826658364616527, -12.00872364622527],
              [14.821783678120628, -12.027451277797317],
              [14.820328565336698, -12.030085669645096],
              [14.820054940496133, -12.03719651588337],
              [14.821243124324974, -12.042547767962647],
              [14.820086175079476, -12.04562729178597],
              [14.815378156915767, -12.051061464405967],
              [14.804827943817909, -12.065476973306472],
              [14.804589114691497, -12.067937488574035],
              [14.800848417150066, -12.072446397409216],
              [14.803582527869096, -12.076151770908693],
              [14.801655752334334, -12.086702886692603],
              [14.797036477951858, -12.104308929992404],
              [14.799696421064722, -12.108753271737893],
              [14.796195917439793, -12.112747586975571],
              [14.79078108731222, -12.115892944774684],
              [14.78728211384342, -12.110884802504104],
              [14.781403635510328, -12.108055531248382],
              [14.780866502623573, -12.102984394118003]
            ]
          ],
          [
            [
              [14.737047898759736, -12.090027866994388],
              [14.741533967394009, -12.087296466901007],
              [14.745050215008238, -12.083495310423958],
              [14.746810617570967, -12.088995132776766],
              [14.745278900723799, -12.092025528498665],
              [14.738611166800414, -12.092396785061942],
              [14.737047898759736, -12.090027866994388]
            ]
          ],
          [
            [
              [14.47890780222529, -12.324898918955196],
              [14.490347113370957, -12.324118345342804],
              [14.489375761372177, -12.330105809150622],
              [14.479576611474334, -12.32626483377575],
              [14.47890780222529, -12.324898918955196]
            ]
          ],
          [
            [
              [14.156876476306325, -11.765625009808026],
              [14.156671744491167, -11.764887328638743],
              [14.129696745910044, -11.59888519611273],
              [14.216133310572893, -11.585554897722227],
              [14.30256599355607, -11.572199325753465],
              [14.306066978121576, -11.593170336602727],
              [14.420924487147428, -11.574681925610905],
              [14.524795306498548, -11.55805275418221],
              [14.579105717377875, -11.549024520188613],
              [14.600324809055058, -11.545680230335947],
              [14.636785162783122, -11.539538162906318],
              [14.65085368988208, -11.537629410325607],
              [14.648486109896588, -11.524431926138375],
              [14.691391746682573, -11.516132535929628],
              [14.722070657288295, -11.510591247832261],
              [14.738159550719223, -11.50717475327301],
              [14.755950764845899, -11.503852835833854],
              [14.792060612264624, -11.496619114606936],
              [14.80106424573005, -11.495510044160657],
              [14.806286463596026, -11.493894786595702],
              [14.810170115784429, -11.522139236478738],
              [14.812754201811726, -11.549441444575768],
              [14.815629327351429, -11.568445091302124],
              [14.818798958624296, -11.582486995204441],
              [14.823308478611533, -11.598760302501155],
              [14.826835439297907, -11.618050319163347],
              [14.829169259151477, -11.635339144326199],
              [14.830197396882978, -11.649430264228434],
              [14.829090702782404, -11.66225653961871],
              [14.828291018372479, -11.692468127025881],
              [14.829417577934034, -11.69758837701775],
              [14.827186414444467, -11.699849468171452],
              [14.825091394904012, -11.705969021173066],
              [14.820848706874303, -11.71214841823091],
              [14.821700654315666, -11.7163832147863],
              [14.820348868785072, -11.72152002071008],
              [14.808985296462437, -11.731784510420264],
              [14.813936537980178, -11.73507314402683],
              [14.820319852919447, -11.73695364705578],
              [14.821315230114397, -11.743424046617209],
              [14.819723113474232, -11.74975538651886],
              [14.81986342746001, -11.757206509031622],
              [14.817774843066891, -11.764240116906864],
              [14.81834808263168, -11.77138819311473],
              [14.824856141990788, -11.789544604966343],
              [14.822699560126624, -11.795238704380274],
              [14.819910794588836, -11.795671457680355],
              [14.815675758213768, -11.788250996246587],
              [14.80050474016764, -11.778798909866149],
              [14.801452110948528, -11.773638887677725],
              [14.807499666553383, -11.763412122403684],
              [14.805737051441609, -11.758474405638315],
              [14.801115545543372, -11.756126161043207],
              [14.80961203857349, -11.748326670272311],
              [14.815183120246855, -11.740393409531906],
              [14.806761859820016, -11.733519131392496],
              [14.803281876291608, -11.733943714493316],
              [14.802353748432768, -11.730237027431741],
              [14.792980518603109, -11.723172868740733],
              [14.789327439119647, -11.722203891252569],
              [14.770744320178759, -11.725316003560833],
              [14.767679703599653, -11.72363900268226],
              [14.762828577812154, -11.726996551802472],
              [14.761689201467638, -11.731971920161838],
              [14.758781366534736, -11.7348359455768],
              [14.755579930609423, -11.7342505700231],
              [14.74457219730337, -11.743803570854295],
              [14.74155200436796, -11.74971133539142],
              [14.739506263207709, -11.748882895999161],
              [14.734899147281975, -11.75882606828083],
              [14.731659381263196, -11.76377513879878],
              [14.735347459022213, -11.768932916040136],
              [14.737704492538784, -11.77749324642667],
              [14.735858372256233, -11.778619039425065],
              [14.734817227979718, -11.786050086526897],
              [14.7300404404652, -11.799020406498776],
              [14.728112479009145, -11.8025407156355],
              [14.724189659163768, -11.818451944964485],
              [14.724497781836925, -11.82549888519306],
              [14.723049617531569, -11.82986223642375],
              [14.723222023726008, -11.8380475711297],
              [14.720076597215611, -11.840329616231125],
              [14.71867196922515, -11.845347242129012],
              [14.713474726001246, -11.85842733832316],
              [14.702482248924188, -11.858696516702999],
              [14.702393510975527, -11.861010919706303],
              [14.697011197105633, -11.865193359077269],
              [14.695805254835323, -11.876858177934533],
              [14.699723279597922, -11.893884803167166],
              [14.70669253831925, -11.906930722500102],
              [14.707008245700596, -11.909131261220377],
              [14.704053540846235, -11.913957978544587],
              [14.704702963996846, -11.92083740837032],
              [14.702503798224525, -11.931946046659888],
              [14.701927775741158, -11.942668493361788],
              [14.692806021695782, -11.944712789354718],
              [14.689552917065818, -11.948152328670202],
              [14.687802734844256, -11.952755291916318],
              [14.689877513473782, -11.962492930895456],
              [14.687765065945891, -11.963761096964431],
              [14.68691917496309, -11.971141417512458],
              [14.690657236750301, -11.976011315799854],
              [14.684890780803096, -11.980695640665992],
              [14.686388748139029, -11.98526451883038],
              [14.685500103192012, -11.988464270260955],
              [14.68991463859522, -12.011626561023977],
              [14.695855495823729, -12.014236732458905],
              [14.693851335367311, -12.019490915035261],
              [14.694589939891149, -12.022343860526261],
              [14.701164125987772, -12.02669754025311],
              [14.702515790605737, -12.034023169425367],
              [14.707352335738037, -12.038164578491848],
              [14.712537325335669, -12.038092374141499],
              [14.71223175983271, -12.042381060337656],
              [14.709163629140056, -12.044865566089959],
              [14.710328471964724, -12.055827580939356],
              [14.708949223169004, -12.059319582884385],
              [14.71223776761563, -12.064604409479022],
              [14.709554260348117, -12.068647721963757],
              [14.711502575043296, -12.070195737223411],
              [14.71234624272044, -12.07766157220092],
              [14.714211392338647, -12.079883850468905],
              [14.719955722306592, -12.08166778877765],
              [14.7209126816459, -12.083813207388399],
              [14.727528575130549, -12.083893825583257],
              [14.730951017232574, -12.08095367610743],
              [14.734094557018908, -12.083033941225727],
              [14.732027444821998, -12.097728490265084],
              [14.729907556265339, -12.103905047889072],
              [14.726552691953955, -12.10861381913585],
              [14.722706405267871, -12.110650576778271],
              [14.720244580483802, -12.115380107382826],
              [14.71777707674574, -12.126055218528974],
              [14.709711817385973, -12.1420918577388],
              [14.711350608004217, -12.149947003829771],
              [14.705368688206393, -12.153121017522256],
              [14.702490091460406, -12.148881749429314],
              [14.696191450964895, -12.150453372695813],
              [14.693812292237169, -12.148081931627189],
              [14.690258643781469, -12.151855385292905],
              [14.685779887963687, -12.154138227677802],
              [14.68526471855626, -12.167639404230826],
              [14.683659670522527, -12.171477137635483],
              [14.681025269087563, -12.171884578874183],
              [14.68376727168544, -12.188676731499536],
              [14.679830086472125, -12.186069187116049],
              [14.677236829546832, -12.18701554184125],
              [14.668503520326748, -12.202430975472986],
              [14.667725841622792, -12.208241193379044],
              [14.66887612220079, -12.217633466215828],
              [14.672411410015766, -12.221588176150528],
              [14.672500155464437, -12.224612143089766],
              [14.660686794358421, -12.226537371168618],
              [14.655149290212252, -12.235969825186876],
              [14.65631142099488, -12.244046128405781],
              [14.644082201873783, -12.245615823817392],
              [14.63471556869479, -12.240062034974505],
              [14.631325344069744, -12.243025007108939],
              [14.623042574923355, -12.246670202090996],
              [14.612982409787088, -12.252589536290484],
              [14.612554627668267, -12.25710563211423],
              [14.607020949332634, -12.257573129725536],
              [14.60205651818514, -12.26071255309616],
              [14.600426407239528, -12.264344866198815],
              [14.595737213955623, -12.26124018975546],
              [14.58910910937792, -12.264916642754631],
              [14.590958055923533, -12.274456091942252],
              [14.59412428595983, -12.27643625504717],
              [14.59863162661021, -12.2768515219297],
              [14.598546741332687, -12.280928974304791],
              [14.592329117926612, -12.282149201316019],
              [14.588349893854469, -12.27930225689409],
              [14.586467647354072, -12.282583677342524],
              [14.591425066456928, -12.284910181622394],
              [14.590730172726616, -12.29023531713424],
              [14.581901380297937, -12.2838021952157],
              [14.576793217612387, -12.276366047705173],
              [14.567800666227663, -12.27171762690081],
              [14.563500117937261, -12.273106076761675],
              [14.55977548224089, -12.280454335930797],
              [14.553780561368294, -12.282370488695122],
              [14.549552031306716, -12.284980820139786],
              [14.553087786264484, -12.291022723813887],
              [14.546383839371511, -12.291372265114045],
              [14.543018279917623, -12.289479407335037],
              [14.542411756317449, -12.28378308956986],
              [14.537920411841071, -12.284718095780118],
              [14.53590357414947, -12.287146572274505],
              [14.530209367118308, -12.287839224918208],
              [14.534354289729714, -12.294790208358299],
              [14.53566922185654, -12.29934988782303],
              [14.53074628333245, -12.303070245028],
              [14.527762729392386, -12.306874220106728],
              [14.525570759306941, -12.301905051272296],
              [14.526245819708194, -12.297007329966107],
              [14.530049835715541, -12.29617920403475],
              [14.530549336887836, -12.292598325396485],
              [14.52565266168663, -12.289093301524739],
              [14.520666247923108, -12.291585466361916],
              [14.517798304406101, -12.29025514379022],
              [14.513049175255501, -12.292171556551978],
              [14.512391865886332, -12.296802186227545],
              [14.513396425567501, -12.301482077996544],
              [14.506295704349712, -12.304442234898332],
              [14.504163566725971, -12.313665555686729],
              [14.49726355500628, -12.314738199468517],
              [14.494014893637544, -12.31015567325138],
              [14.49498546103473, -12.303631064045625],
              [14.489939060974404, -12.30318699746467],
              [14.48130809674363, -12.309973731954795],
              [14.478699196521028, -12.308353442330018],
              [14.476531664016488, -12.313050643654483],
              [14.472873212027505, -12.31084897889419],
              [14.471180363281894, -12.31400837441624],
              [14.464920484225349, -12.319425595054659],
              [14.456141563519282, -12.318630827681114],
              [14.452528719406653, -12.319330148383315],
              [14.451290740320516, -12.327593216040839],
              [14.446456730833816, -12.328041330199664],
              [14.444483422454347, -12.3363560664867],
              [14.447227477818744, -12.337603356957338],
              [14.451979200758398, -12.335690138789955],
              [14.456166215736832, -12.335970903646196],
              [14.463558706349687, -12.332093804147302],
              [14.460489822335187, -12.337631678802827],
              [14.457815592347298, -12.348498558871684],
              [14.459310285334404, -12.352837831391387],
              [14.455438982910918, -12.356036268197075],
              [14.455917687766641, -12.360632833809596],
              [14.459682327097374, -12.364032530883325],
              [14.454578729791006, -12.366299891325708],
              [14.45192424180792, -12.369571249285746],
              [14.445629992615425, -12.370370421199107],
              [14.441770791743886, -12.374351148867271],
              [14.440443385832713, -12.37035350318351],
              [14.443715818000404, -12.36814925315339],
              [14.450025896966277, -12.3570449678785],
              [14.455043180818706, -12.353406262844464],
              [14.45608455474194, -12.346396867442062],
              [14.451296369277113, -12.342256559656722],
              [14.443431966208365, -12.34594211542208],
              [14.442115591313094, -12.342706951790436],
              [14.438489944526275, -12.339441582420665],
              [14.43301282231613, -12.341557266193796],
              [14.42912553019866, -12.341041935182071],
              [14.423943980798619, -12.347405436792268],
              [14.420785714725243, -12.34831760730957],
              [14.415771723593627, -12.353931710669453],
              [14.417368819012816, -12.36223201586438],
              [14.412784854506466, -12.364026182854818],
              [14.411154884182993, -12.368683943280017],
              [14.41405182778648, -12.374585626665102],
              [14.40961079363102, -12.373938152360418],
              [14.406193644978716, -12.366773982731418],
              [14.399059087831612, -12.363842722702895],
              [14.391591456839775, -12.368046617013668],
              [14.39165875936595, -12.364935609681714],
              [14.394393596762875, -12.361083230591158],
              [14.391529484536942, -12.356017481798562],
              [14.387093605598595, -12.354464345564798],
              [14.387208950640854, -12.361942109596102],
              [14.379218330062344, -12.361263273574636],
              [14.372203039911994, -12.358614242535117],
              [14.370830521395401, -12.35959611592468],
              [14.372018691626996, -12.366161531469],
              [14.378733826478017, -12.371305879336452],
              [14.387402818044468, -12.36977671989967],
              [14.39717598702893, -12.373429289986834],
              [14.387526005072157, -12.378170693075901],
              [14.379076338429018, -12.380154920670398],
              [14.37338487757428, -12.376247459321],
              [14.369055436954586, -12.37173214035593],
              [14.365303154805721, -12.372054283014329],
              [14.365739221724663, -12.36671115582146],
              [14.362554573906833, -12.364655974454683],
              [14.3572075989309, -12.364000448275133],
              [14.349551190388844, -12.366709676664149],
              [14.349612910450453, -12.371551569398147],
              [14.35367684005676, -12.376415721971503],
              [14.354112529253246, -12.381711636333451],
              [14.353052873070672, -12.386404418887343],
              [14.347434872040461, -12.389372803099818],
              [14.351005684019752, -12.382386885887325],
              [14.35124821889259, -12.378660058509471],
              [14.345446298175833, -12.367825039193995],
              [14.33846964282268, -12.363734722967662],
              [14.329335324872694, -12.367284525935599],
              [14.326746433327054, -12.371900562347767],
              [14.324092517208076, -12.368704380960502],
              [14.327412937617623, -12.355165196102009],
              [14.326008278406666, -12.352012387058606],
              [14.312595471085821, -12.349668679111023],
              [14.307397034946458, -12.352165475527205],
              [14.309274684620338, -12.35850465662799],
              [14.313160647708733, -12.361388119273027],
              [14.313826267957323, -12.364657247462382],
              [14.308537764785374, -12.36934669714441],
              [14.30022904835759, -12.374871505848208],
              [14.297854220090874, -12.370424124293868],
              [14.292196323753231, -12.364445012123296],
              [14.28650395281323, -12.362086221474717],
              [14.277494461020483, -12.36181473147991],
              [14.26925185999157, -12.36412558232513],
              [14.2636065374365, -12.331244486065641],
              [14.258716168510853, -12.300844063390073],
              [14.255117067613611, -12.301508796672671],
              [14.235914071487445, -12.185809587453015],
              [14.226023345846858, -12.187557807702651],
              [14.185423394104703, -11.93966740985414],
              [14.184963278263162, -11.937852626483105],
              [14.156876476306325, -11.765625009808026]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.56239316948337,
          "lat": 25.615177171828126
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12086"],
        "coty_name": ["Miami-Dade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miami-Dade County"],
        "coty_fp_code": "086",
        "coty_gnis_code": "00295755"
      },
      "bbox": [
        14.129696745910044, -12.389372803099818, 14.833996952263833,
        -11.493894786595702
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.271305989579881, -6.870882153969539],
            [12.312413288870333, -6.8651414925442],
            [12.313999468994462, -6.864726007299936],
            [12.321634965169086, -6.797983665280845],
            [12.355287300921969, -6.801794271217148],
            [12.403367867853497, -6.807646314726281],
            [12.431196818619645, -6.809851350494014],
            [12.437782073779593, -6.808927739643159],
            [12.442783931776427, -6.813602989937991],
            [12.449586736362486, -6.812974555303818],
            [12.452578718542878, -6.811479569397254],
            [12.457739043838131, -6.81425527093381],
            [12.459245222646796, -6.82383584145978],
            [12.458230072557544, -6.827726619381738],
            [12.461677946056069, -6.8329029838226285],
            [12.45904893446113, -6.842806113522275],
            [12.460045749991751, -6.850397879961556],
            [12.462851660381702, -6.85443853689376],
            [12.462837262335565, -6.858702014828675],
            [12.45872902316203, -6.859917311394377],
            [12.455691617126035, -6.8674741677560585],
            [12.458129171443263, -6.875001692379041],
            [12.462900690794333, -6.88089727396643],
            [12.4666149604997, -6.881014078696865],
            [12.47516626246105, -6.889186575078933],
            [12.481470648281515, -6.890758849910162],
            [12.482312224190858, -6.899715235474398],
            [12.477495979811955, -6.906091050213227],
            [12.477053968241316, -6.911672518699118],
            [12.474571303688661, -6.920289680813505],
            [12.471328470288656, -6.926181357086309],
            [12.468449349342606, -6.937261212635535],
            [12.471221298622103, -6.942849651114447],
            [12.477976344997995, -6.936524213202144],
            [12.485047302732442, -6.945387247800556],
            [12.487876215554946, -6.944320192325606],
            [12.488737875796, -6.940381284629741],
            [12.490097655882021, -7.022309056405322],
            [12.488428223184942, -7.0252945965483224],
            [12.49188314105035, -7.029959451474621],
            [12.491903903308184, -7.032639980800443],
            [12.486736648663687, -7.035034045632782],
            [12.479916611862725, -7.034668075269282],
            [12.472855826147724, -7.035637176847295],
            [12.467558093791224, -7.033562720110666],
            [12.461247095919685, -7.026018234824691],
            [12.457512700784626, -7.029443186724214],
            [12.452316228110686, -7.0283137266334705],
            [12.44781655068024, -7.034126154412851],
            [12.441537150613673, -7.039733049270616],
            [12.444222123400053, -7.04905448655153],
            [12.44262271028856, -7.050285635672925],
            [12.44592949913459, -7.056295530101713],
            [12.445693186850571, -7.061507484147225],
            [12.4428233849949, -7.063874766176012],
            [12.440711768824714, -7.069054432241928],
            [12.440742546436722, -7.074301067476983],
            [12.439267600845085, -7.07957659377383],
            [12.435963075596868, -7.0822690189766595],
            [12.430911680849345, -7.08151704752218],
            [12.422840601186566, -7.077805697013879],
            [12.419952618823611, -7.07513591605484],
            [12.410880069992022, -7.071124319042277],
            [12.407986573377105, -7.0708822442941],
            [12.404613520048539, -7.074114637076299],
            [12.4014314227515, -7.072311367071705],
            [12.399513861656693, -7.076203539972772],
            [12.396751708264901, -7.076377294164571],
            [12.39646637073588, -7.081991771919339],
            [12.404915579113315, -7.091534099957901],
            [12.409501959249186, -7.1002849505778425],
            [12.404038391917215, -7.107149339756166],
            [12.397820444588367, -7.11354058402497],
            [12.393894431938241, -7.11477311562957],
            [12.38916793345258, -7.1114866596755775],
            [12.387726224341463, -7.118443591175821],
            [12.389452408004136, -7.128782848404432],
            [12.38617529362818, -7.138025835656383],
            [12.390778352547938, -7.141268031147683],
            [12.393750968142111, -7.146809804158842],
            [12.396484632618149, -7.158530309580386],
            [12.392116917848268, -7.167545274412163],
            [12.394153787936773, -7.171936848725325],
            [12.393653284143262, -7.180916501008207],
            [12.3890466920917, -7.1901060331380435],
            [12.393480869529155, -7.199850967353088],
            [12.392869209720763, -7.210373831978726],
            [12.399906373782382, -7.215469604732048],
            [12.403826003530023, -7.223258129053172],
            [12.403690166515792, -7.227286963197452],
            [12.415654378463442, -7.240925049023862],
            [12.418569172449208, -7.249066973276198],
            [12.419279245150566, -7.256149421084723],
            [12.4286847353665, -7.2584550499459715],
            [12.43369760630306, -7.2664735587885385],
            [12.439574363823242, -7.28244919998083],
            [12.4437839518552, -7.295420748503505],
            [12.439176664998874, -7.309568734262739],
            [12.437580750966422, -7.328802458716069],
            [12.438230204127459, -7.336098412137616],
            [12.441648625429298, -7.341285094915302],
            [12.44330429271654, -7.346223309826689],
            [12.444922587045081, -7.363578090825523],
            [12.443442198632075, -7.367225616862505],
            [12.446451559038787, -7.380151057125826],
            [12.446316686837982, -7.383885893799837],
            [12.442394207874992, -7.392289809436997],
            [12.442327729395805, -7.401876734213427],
            [12.441503637673321, -7.412403168674313],
            [12.436013230505182, -7.422184693437184],
            [12.43573509600477, -7.426184828660339],
            [12.439020889239686, -7.432200942636022],
            [12.440246512398845, -7.437736826272268],
            [12.436351617202755, -7.446420192073187],
            [12.43624730913782, -7.457496502731136],
            [12.437892734798083, -7.463707335147968],
            [12.444095096141647, -7.474399905811563],
            [12.444368232353268, -7.481793630951411],
            [12.442160929782071, -7.489875296874113],
            [12.435445430358198, -7.49866729913286],
            [12.420093865638627, -7.504127159751882],
            [12.409435930436109, -7.506065998434958],
            [12.397575105064533, -7.505816817743329],
            [12.387828762368809, -7.499672261795722],
            [12.378130438161913, -7.50207540903791],
            [12.355786121789981, -7.509288878752858],
            [12.343657455372538, -7.5145469991269565],
            [12.340848397029122, -7.517025334600989],
            [12.333620989221263, -7.516993589104293],
            [12.323722056976827, -7.508698148904214],
            [12.319763648930625, -7.5041661974759855],
            [12.318550234215417, -7.500875979159665],
            [12.315070403493403, -7.501952155304043],
            [12.311238243491795, -7.500316666974142],
            [12.31091296298027, -7.494550419537992],
            [12.306662723099155, -7.490402384948822],
            [12.298418049102592, -7.479536598035349],
            [12.289818503705728, -7.457430156795465],
            [12.288985048390444, -7.4492896493372935],
            [12.291248752720213, -7.444681266230244],
            [12.292310447688479, -7.437070919045117],
            [12.29052575469301, -7.429966283519709],
            [12.28749088646325, -7.425296975827721],
            [12.28681454439543, -7.421805066633775],
            [12.288235782491721, -7.4131989237611124],
            [12.290556941086077, -7.407268807465364],
            [12.288595190871506, -7.396781389775022],
            [12.28334298665687, -7.390800874132586],
            [12.271291304878313, -7.380183586867894],
            [12.265223897306026, -7.377403199285818],
            [12.259295902247253, -7.368710591928898],
            [12.259623723291766, -7.365163864097951],
            [12.257614207720849, -7.359493474164387],
            [12.252410053231793, -7.355829880351719],
            [12.247813520043852, -7.349850247239559],
            [12.247974482882102, -7.342136778022261],
            [12.251261550794519, -7.338068268640559],
            [12.250173035089835, -7.330601407721538],
            [12.25454573063203, -7.323954407913964],
            [12.258733243958444, -7.320319391990113],
            [12.263476896168305, -7.320039280557178],
            [12.2651174526958, -7.316459567042961],
            [12.277020609157244, -7.206292611505915],
            [12.28890873640947, -7.096076909571628],
            [12.26396581540817, -7.093051647030653],
            [12.160949961359776, -7.1057507713227706],
            [12.057932167021606, -7.118430418750038],
            [12.030842044397652, -6.902707323626383],
            [12.092713184630714, -6.894005807620567],
            [12.180940141701958, -6.882610009212865],
            [12.26916557444242, -6.871200460055738],
            [12.271305989579881, -6.870882153969539]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.13793129915264, "lat": 30.78175675048949 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13049"],
        "coty_name": ["Charlton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charlton County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00357747"
      },
      "bbox": [
        12.030842044397652, -7.517025334600989, 12.491903903308184,
        -6.797983665280845
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.362095992367856, -7.058073427702618],
            [10.459855696352099, -7.046083000754416],
            [10.50403096208499, -7.040769673568349],
            [10.582454025354872, -7.031805324749844],
            [10.587179158793033, -7.084384603716655],
            [10.592542768110734, -7.127882360337964],
            [10.595706197602896, -7.1353370575543105],
            [10.59466595776527, -7.13944996011979],
            [10.59816717280985, -7.142004420522227],
            [10.602470878876975, -7.1494476972252965],
            [10.605438219139355, -7.156248962454992],
            [10.608845820916482, -7.15904928139453],
            [10.615621864145151, -7.169885835389432],
            [10.62334687618378, -7.175622382618823],
            [10.630849328048713, -7.185033628283911],
            [10.636446181520114, -7.18798110709353],
            [10.637867780303296, -7.191465815282563],
            [10.63892194265571, -7.20445940782564],
            [10.63794916370355, -7.208856165256154],
            [10.640040431869485, -7.211304128972485],
            [10.641057568291453, -7.21688980502317],
            [10.63824198476266, -7.224163145847434],
            [10.638399051828987, -7.227815550327287],
            [10.642682023230725, -7.231017965048516],
            [10.646125936626373, -7.236845984489724],
            [10.6443663811582, -7.242224024485358],
            [10.639471819763305, -7.2495239995861285],
            [10.642509774102841, -7.2581787673398495],
            [10.643642584807587, -7.270161364330675],
            [10.65486639881381, -7.373768441033256],
            [10.660742266332962, -7.425274359898971],
            [10.640236010756974, -7.426830389653627],
            [10.62544432673048, -7.427443673252156],
            [10.518270196253502, -7.434610737632301],
            [10.490318990170298, -7.436871580640386],
            [10.411149663721917, -7.442080828925933],
            [10.406189458158783, -7.442510188479222],
            [10.394710931088085, -7.339706654220834],
            [10.392090508532986, -7.317044472408175],
            [10.385584304264736, -7.25501793405377],
            [10.377619598206083, -7.180570899330004],
            [10.363110637142624, -7.063682320353111],
            [10.362095992367856, -7.058073427702618]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.23445360721256,
          "lat": 30.874693570161345
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13131"],
        "coty_name": ["Grady"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grady County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00351261"
      },
      "bbox": [
        10.362095992367856, -7.442510188479222, 10.660742266332962,
        -7.031805324749844
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.381206236633167, -5.841693164832649],
            [12.384002762669667, -5.849235391673142],
            [12.39126471419909, -5.852094629549658],
            [12.400514441852312, -5.860343570354851],
            [12.402048715081527, -5.866479888619714],
            [12.40758688866514, -5.871927644231391],
            [12.412191610300107, -5.874543193684982],
            [12.423940073161821, -5.869539715962947],
            [12.42876984341991, -5.869777593717094],
            [12.430884417928377, -5.871910554023567],
            [12.442894160859794, -5.872283990711815],
            [12.448933773859437, -5.873367000558184],
            [12.452866552187258, -5.877340875123941],
            [12.456950436352505, -5.88569593425443],
            [12.45826346048549, -5.891724001738682],
            [12.456555412153554, -5.900467132501619],
            [12.458918295042503, -5.9094986378097865],
            [12.456771388044581, -5.919824139033983],
            [12.455582838726828, -5.932089071821305],
            [12.4513878631316, -5.941082863659793],
            [12.45340404836152, -5.946247346067446],
            [12.450891390290224, -5.952509059457756],
            [12.448978838198713, -5.961563420897987],
            [12.45151650850612, -5.97299918311677],
            [12.455991116915092, -5.976182437746867],
            [12.46440872386322, -5.98453581650653],
            [12.46730737921092, -5.984553016809661],
            [12.479509010998195, -5.989843486464464],
            [12.486802722900153, -6.000434993185087],
            [12.49979553902808, -6.005484318361693],
            [12.508053491503258, -6.011979966947536],
            [12.518081465587455, -6.022056461311704],
            [12.519249154139622, -6.025180270708172],
            [12.526542933175369, -6.027856746921006],
            [12.550427849758757, -6.03260297669322],
            [12.5540280994374, -6.034879622678371],
            [12.566955763828298, -6.045362583029602],
            [12.571305534373726, -6.065165632385459],
            [12.587324050236223, -6.070282265629367],
            [12.599009285287215, -6.074700587658227],
            [12.70024840350139, -6.111708387299337],
            [12.706843632539627, -6.111096855147757],
            [12.695110937163522, -6.144130230348054],
            [12.680179228238076, -6.190086865375654],
            [12.679366547519145, -6.1913752932939605],
            [12.671682060731905, -6.216465655795935],
            [12.663424873361217, -6.242015999565155],
            [12.620071109363431, -6.274065508842819],
            [12.58758327719205, -6.291729225047928],
            [12.586321779075353, -6.288774343810979],
            [12.579000971345348, -6.283578951554512],
            [12.575886123692115, -6.285892487669481],
            [12.571824003146135, -6.285827212244066],
            [12.570977219035411, -6.282300760043312],
            [12.568167861364877, -6.280886407801468],
            [12.562906357867458, -6.283269890871092],
            [12.557098508096066, -6.280874884721066],
            [12.555879880139463, -6.274822141894493],
            [12.551962832572771, -6.271346310180004],
            [12.555381659171967, -6.269699439632219],
            [12.552013444000938, -6.263045712216365],
            [12.55333068825875, -6.257329143660607],
            [12.549520926400495, -6.255795409200961],
            [12.548254595904357, -6.250968808918351],
            [12.5454288610208, -6.25240307859726],
            [12.537873737823272, -6.2464680384463],
            [12.534239189835317, -6.2489060481663765],
            [12.529287380089672, -6.247038539265741],
            [12.526244436730655, -6.243258274468346],
            [12.526773696800962, -6.2395553753980595],
            [12.520312791361423, -6.238989543468112],
            [12.520313711020089, -6.2353761959091205],
            [12.515311842556612, -6.232189856556439],
            [12.512253049965064, -6.233030177719145],
            [12.512204776629936, -6.237451196973714],
            [12.50966179634443, -6.240438876496148],
            [12.50633204694375, -6.2391541759306595],
            [12.505969015109756, -6.234654679616866],
            [12.508870740632922, -6.229813092148944],
            [12.501691857518622, -6.226579464748481],
            [12.498309827226269, -6.227661661626779],
            [12.494447732823975, -6.223171289451431],
            [12.491677546071445, -6.224808540088666],
            [12.490508472472406, -6.229191736238094],
            [12.4856480108234, -6.228144932302262],
            [12.483329871811963, -6.217207702183086],
            [12.476941741981452, -6.214687351795547],
            [12.472120333066428, -6.2170634631052595],
            [12.468003238158039, -6.215793268033423],
            [12.466777628839658, -6.212152580590633],
            [12.469408187922014, -6.208351265926446],
            [12.467643353100462, -6.204292523963161],
            [12.460045385527543, -6.204521542172589],
            [12.459985292689577, -6.19943812016712],
            [12.457249544505157, -6.195541605496225],
            [12.449826608788364, -6.194716814602487],
            [12.44653595848795, -6.189306742158353],
            [12.443267404808068, -6.19104336689464],
            [12.445693212071733, -6.196098226404452],
            [12.44395237433099, -6.198597774368206],
            [12.43580796527633, -6.2003136311036355],
            [12.42910287476966, -6.195761415499791],
            [12.431175995401182, -6.192044488206925],
            [12.429806814174713, -6.188944560535315],
            [12.423854326108808, -6.190099810731626],
            [12.419277399874533, -6.18624273622468],
            [12.411060902998134, -6.18799330528245],
            [12.409173285689388, -6.183365153284067],
            [12.412234497745684, -6.180470495604079],
            [12.410977128953173, -6.177077930890474],
            [12.404923410918432, -6.174998105723701],
            [12.401001057992119, -6.170571945124092],
            [12.39374738449116, -6.166941668554542],
            [12.385732639826434, -6.154907701244854],
            [12.38481169296462, -6.148968583071805],
            [12.382641042768737, -6.14631008652764],
            [12.376386438111258, -6.1461281275240545],
            [12.368823009219094, -6.143717070691774],
            [12.35652330957663, -6.1385154887877125],
            [12.35166821034207, -6.132621054312699],
            [12.350816115622251, -6.12760919968311],
            [12.347889046236842, -6.124633976723611],
            [12.347947823982889, -6.120327851478796],
            [12.349859311542982, -6.118212362201088],
            [12.349505655792887, -6.113714922528262],
            [12.347418364099099, -6.110822892390588],
            [12.34046962712376, -6.106078464285009],
            [12.336411904665532, -6.114059831845384],
            [12.332826742363077, -6.1129446768976585],
            [12.331167627516956, -6.106722245642118],
            [12.327252975056254, -6.104816613251386],
            [12.322063898673974, -6.108476576220551],
            [12.318655890029799, -6.1080999635396305],
            [12.318190289824964, -6.101113819237175],
            [12.31345563868766, -6.099927815162393],
            [12.310656407497428, -6.096538507379387],
            [12.309033512400644, -6.083826204913691],
            [12.304284122918896, -6.080613202956649],
            [12.29382223653767, -6.082570901469436],
            [12.288894317385346, -6.084727272492971],
            [12.283492355468574, -6.082034738014209],
            [12.281743379822794, -6.073695748471152],
            [12.282484345730067, -6.068871430106784],
            [12.28930718981396, -6.067668096814781],
            [12.293131432930416, -6.063132844092964],
            [12.301559928956168, -6.061853462364107],
            [12.30396703090322, -6.056878874477443],
            [12.303583254490187, -6.044508491137317],
            [12.30693347346347, -6.034161993886987],
            [12.310308141637151, -6.0290815807388265],
            [12.315768106935186, -6.025994624819986],
            [12.316280367147384, -6.021969363441748],
            [12.320172185474014, -6.01751752552455],
            [12.323739198235039, -6.0153822613672],
            [12.32536476812581, -6.004265043976896],
            [12.322880640361486, -5.999359754790439],
            [12.322950263997212, -5.99330760277635],
            [12.326691100105949, -5.979393208284248],
            [12.329140641660496, -5.977079625224113],
            [12.334795958139512, -5.976390921307303],
            [12.336870561611287, -5.972766864233339],
            [12.340897052316192, -5.971447903101537],
            [12.342178730364441, -5.968395129223507],
            [12.338970281911399, -5.961193852048929],
            [12.341107086403776, -5.955414177598618],
            [12.345688968064643, -5.950302076778892],
            [12.347502424425285, -5.944287106736989],
            [12.345521216856651, -5.935535699600752],
            [12.345547466872342, -5.930731176972731],
            [12.343575489403522, -5.927507278383064],
            [12.343376612835298, -5.921847922721547],
            [12.337240068578287, -5.916784035839667],
            [12.339785412348954, -5.907238951885599],
            [12.345348225948376, -5.900265695988892],
            [12.345116296893554, -5.893925510333167],
            [12.349630869669971, -5.890104030320858],
            [12.355147227521252, -5.887954026799549],
            [12.358357888537395, -5.881948170598359],
            [12.359985593211913, -5.871701760200862],
            [12.366627897524662, -5.865911860747972],
            [12.368939830300237, -5.856417460226221],
            [12.381206236633167, -5.841693164832649]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.74585930796174,
          "lat": 31.752619603573535
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13183"],
        "coty_name": ["Long"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Long County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00326719"
      },
      "bbox": [
        12.281743379822794, -6.291729225047928, 12.706843632539627,
        -5.841693164832649
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.6025315025362, -4.310060619671611],
            [11.606182301898867, -4.305822798907137],
            [11.610549210458975, -4.309846493582178],
            [11.616275804970778, -4.307752506022997],
            [11.61947513388773, -4.310232144801826],
            [11.620610110888391, -4.3040157615466414],
            [11.624906436390964, -4.301241917263595],
            [11.623861673453716, -4.296808430549409],
            [11.626564038848757, -4.294629791372979],
            [11.630754979880317, -4.2953903399203845],
            [11.632841896795963, -4.292105347891517],
            [11.636387386057136, -4.2925237773984675],
            [11.640073914711518, -4.288921019942277],
            [11.642870508606054, -4.292965360702922],
            [11.645281908250873, -4.292686568131641],
            [11.646064256702969, -4.295963351667752],
            [11.63367635974116, -4.306814614072831],
            [11.635102109554108, -4.309360999489321],
            [11.633901439351595, -4.314564341395821],
            [11.638650564295983, -4.316367790253615],
            [11.642685738695999, -4.321589980945781],
            [11.645276011237927, -4.328595713241578],
            [11.64510189310379, -4.335814883822341],
            [11.648554711256715, -4.337013262108817],
            [11.65594502550904, -4.343693498624088],
            [11.663221517346344, -4.343920690198814],
            [11.663618280818202, -4.349389974082756],
            [11.657995753526691, -4.366436887794016],
            [11.650913595547552, -4.374847619506024],
            [11.649816279587071, -4.37852597620891],
            [11.65067172841079, -4.383492778594988],
            [11.64966123940393, -4.392010464879481],
            [11.650347307286319, -4.394398452780818],
            [11.695685721406884, -4.407882691340698],
            [11.689433083641568, -4.4149106643630835],
            [11.686659794096292, -4.420873062267828],
            [11.683313361181808, -4.423323663879267],
            [11.685347662090011, -4.430970804768026],
            [11.689093976242162, -4.439127512858794],
            [11.68942100710199, -4.446739612309786],
            [11.704614278435434, -4.459648516662582],
            [11.70632812688044, -4.466772808458629],
            [11.704827665351159, -4.470135866544745],
            [11.714239656623556, -4.480197360760983],
            [11.718066515879329, -4.482718738088334],
            [11.724090749436161, -4.484201368734767],
            [11.730232034960185, -4.492039222171092],
            [11.737189393717019, -4.499341084379368],
            [11.742314277057918, -4.50614393668445],
            [11.74919246693885, -4.509290798031604],
            [11.753045860017881, -4.514704394452721],
            [11.750028191264256, -4.526050504972319],
            [11.7515533565126, -4.529365859506119],
            [11.758678736913456, -4.532191355605476],
            [11.761318570578455, -4.538112236550638],
            [11.766449581987098, -4.542733081047787],
            [11.767939179223912, -4.548374595968957],
            [11.772876421695852, -4.551696527300495],
            [11.777491245406662, -4.553265707012503],
            [11.781157880842693, -4.56229071631289],
            [11.788141025579431, -4.56564652590326],
            [11.795396946935298, -4.57131300733218],
            [11.75505801482762, -4.61753198478432],
            [11.752787630412282, -4.620376724776],
            [11.749321524756823, -4.620471592466497],
            [11.737817007061688, -4.623991577434522],
            [11.727898916926497, -4.624174242528181],
            [11.71589650866208, -4.624167411873339],
            [11.711273027519827, -4.620488118300033],
            [11.707202794324296, -4.620995349294007],
            [11.701150755193675, -4.613829195771467],
            [11.698225780787826, -4.612973363738404],
            [11.697395005002555, -4.608054764745705],
            [11.691660449284525, -4.611107448074234],
            [11.680784712401074, -4.606299938761034],
            [11.671649854184594, -4.606834121775812],
            [11.668106551584417, -4.603581901104428],
            [11.656663362808473, -4.605908493763745],
            [11.654378532554809, -4.604750808715896],
            [11.649983807482696, -4.6075926838518],
            [11.638925339531658, -4.608789077710761],
            [11.635203534489932, -4.61124204230609],
            [11.629991953118633, -4.612217304502927],
            [11.627478503050032, -4.607616440887326],
            [11.619372258627868, -4.6093532893454965],
            [11.611845300534252, -4.60334522957894],
            [11.606175174894735, -4.602365963850551],
            [11.604840254951322, -4.599692137597587],
            [11.596596203701926, -4.596967810852644],
            [11.589577360056404, -4.603791965834253],
            [11.58716727637308, -4.603048650040479],
            [11.585390320478188, -4.598268079704207],
            [11.587134982749388, -4.580814465163814],
            [11.573663634847918, -4.541080226977619],
            [11.543469071159334, -4.511041268758136],
            [11.520941325793899, -4.466644813601613],
            [11.51674548014041, -4.457771777123658],
            [11.496876296021137, -4.418008049209393],
            [11.480171456550982, -4.385485299842382],
            [11.477429583676397, -4.377850283355659],
            [11.473373430330188, -4.371652947125331],
            [11.467591139297715, -4.360417927184503],
            [11.472767508584399, -4.36170619197403],
            [11.473533225539269, -4.358408541896735],
            [11.472109584404695, -4.354360865378953],
            [11.476181582467161, -4.352829966042468],
            [11.480524470834059, -4.356195801693922],
            [11.486080051157579, -4.3552369206453685],
            [11.488631212573335, -4.352877506890418],
            [11.493808285633545, -4.352594256009016],
            [11.48734266193796, -4.346853364525988],
            [11.489226713049291, -4.341071610038297],
            [11.493423745223703, -4.337794641558402],
            [11.490163823145918, -4.334710469411],
            [11.495290007911162, -4.331282696838415],
            [11.497396758765316, -4.337471259585968],
            [11.500821190847928, -4.337500154454564],
            [11.497952270349515, -4.331032995108929],
            [11.500146954166409, -4.328999224069399],
            [11.504011305654632, -4.329328830054431],
            [11.507912791092945, -4.325408987618482],
            [11.510394096868499, -4.32637530131929],
            [11.514697791025549, -4.321583537350564],
            [11.516084526257103, -4.326757117481852],
            [11.520423689844629, -4.328770453075174],
            [11.523191228326104, -4.32452660252136],
            [11.518441728008245, -4.323482473246169],
            [11.516228086421219, -4.320088614831947],
            [11.515803602885072, -4.311298222469868],
            [11.519183772801865, -4.313675725779552],
            [11.522783116193729, -4.3187598729535255],
            [11.528056665400085, -4.320780309921101],
            [11.529116711365452, -4.315780082598004],
            [11.531195930407948, -4.313740288881045],
            [11.535558926255737, -4.316136954607012],
            [11.538452687711178, -4.323369754121664],
            [11.540753199804048, -4.31547149052367],
            [11.5433816064521, -4.317312677755001],
            [11.549671302979185, -4.318567580637553],
            [11.554151261855818, -4.315047678840652],
            [11.554768906161254, -4.306849200015728],
            [11.559551277563962, -4.309300647069784],
            [11.56440739239323, -4.3102581601746435],
            [11.569115262901644, -4.307263737737995],
            [11.568440905150256, -4.302222303608162],
            [11.573391402476632, -4.294294747258595],
            [11.57888754822067, -4.293546988121766],
            [11.579166206684185, -4.299422072309801],
            [11.583453031912654, -4.297527503411711],
            [11.586944345354908, -4.299883506782021],
            [11.595467465802724, -4.302955854547276],
            [11.597708771201669, -4.309174674594493],
            [11.6025315025362, -4.310060619671611]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.48139063754903, "lat": 33.48283069247509 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13189"],
        "coty_name": ["McDuffie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McDuffie County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "00348794"
      },
      "bbox": [
        11.467591139297715, -4.624174242528181, 11.795396946935298,
        -4.288921019942277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.58920105530699, -5.612090115602007],
            [9.634499882646734, -5.6070090396009205],
            [9.668382601292251, -5.603490962733856],
            [9.733121954005957, -5.595920523679658],
            [9.735795014704333, -5.619971749448495],
            [9.768964488630786, -5.616248869180539],
            [9.802302826748564, -5.612184701947558],
            [9.83598961929762, -5.608362541468182],
            [9.87512409427465, -5.603662037431843],
            [9.913183978156757, -5.598557671657174],
            [9.915550462866722, -5.618685488449179],
            [9.938153335925117, -5.615741853245036],
            [9.933229247223457, -5.624004720469589],
            [9.932950344834754, -5.6327659906078615],
            [9.930536345344576, -5.635822379005925],
            [9.931622498019763, -5.649193140566682],
            [9.926489828850215, -5.653774274250596],
            [9.92456162595291, -5.660327076908458],
            [9.92104409863978, -5.663353813161607],
            [9.914793832283507, -5.6641452925262445],
            [9.906094552225015, -5.672288760809638],
            [9.90622907487163, -5.674164401319303],
            [9.89726279614347, -5.680285351028518],
            [9.898218187314765, -5.681971869487085],
            [9.894513297221275, -5.687956757996114],
            [9.891180863487815, -5.697651804315182],
            [9.892347622859953, -5.700144587262411],
            [9.890139427458996, -5.707791368228572],
            [9.887660878136703, -5.7095873434659214],
            [9.885980465961413, -5.714794233127585],
            [9.886875157990554, -5.721102714343975],
            [9.884322403706173, -5.726643343224477],
            [9.881008194748455, -5.729514151702407],
            [9.877936965156389, -5.735955967880317],
            [9.879257844540744, -5.738410252222474],
            [9.878084130594127, -5.744432944233957],
            [9.876176366582834, -5.746462945573503],
            [9.875482685957746, -5.7517526338527345],
            [9.871624289367091, -5.753079081085962],
            [9.871411133410676, -5.759905577899894],
            [9.869258627584983, -5.762609927024221],
            [9.867727539477412, -5.768030324571337],
            [9.862948437831264, -5.7653859215688295],
            [9.859597618562553, -5.767345832070745],
            [9.856094891490283, -5.773027630101107],
            [9.851737542196016, -5.777217222630708],
            [9.847608547061819, -5.776736726304575],
            [9.840279265472356, -5.773118198529623],
            [9.838078882054015, -5.770091221278887],
            [9.835358047181355, -5.773600709210205],
            [9.83603721088386, -5.776583110770358],
            [9.830291374072107, -5.780708078396777],
            [9.826623860924, -5.780011070561473],
            [9.808435091563718, -5.782904450469762],
            [9.805260165789402, -5.7816813198971895],
            [9.803200338665457, -5.784275844225066],
            [9.799316990000051, -5.782780986883253],
            [9.790349647738404, -5.784480101615734],
            [9.787551581543168, -5.7877205951694],
            [9.783451251608072, -5.786347094970731],
            [9.777465145957478, -5.789368842165566],
            [9.775661092783427, -5.794252161683284],
            [9.772203959557505, -5.798893382969706],
            [9.767733508261006, -5.801478215626913],
            [9.763491920387903, -5.799459525005733],
            [9.76139105369909, -5.80550689742789],
            [9.754980712565382, -5.807478277442988],
            [9.752701707915248, -5.810757264128564],
            [9.746324798683231, -5.8146263535328675],
            [9.744024564062114, -5.818649641570481],
            [9.735955028472905, -5.8256311542416945],
            [9.726764198386798, -5.830435815178883],
            [9.722440742887605, -5.829923056007705],
            [9.719345846135782, -5.832961083423834],
            [9.713722250032236, -5.830931232518214],
            [9.71045044359722, -5.832217118346793],
            [9.706422582886015, -5.830638068761923],
            [9.704620917607578, -5.828656770091456],
            [9.694168025580131, -5.829401679337427],
            [9.691837166031466, -5.825900449186586],
            [9.693337149882874, -5.820103734719156],
            [9.695255751985647, -5.81777083897719],
            [9.69959383927006, -5.818541092287205],
            [9.705078587100052, -5.817802575775526],
            [9.707309775061862, -5.815116876712972],
            [9.70278179804797, -5.813418415074941],
            [9.697195836757286, -5.809151493859314],
            [9.695876684238181, -5.806549057236512],
            [9.6961723783518, -5.797037280187501],
            [9.702045866784088, -5.7923280370287324],
            [9.708316991931737, -5.785255659891116],
            [9.70845248773561, -5.783527790077147],
            [9.703823691580425, -5.772886400209599],
            [9.698948690876467, -5.765897955522473],
            [9.688619120152616, -5.764275047229208],
            [9.67994021714416, -5.760143296999589],
            [9.674911504819224, -5.749645923845484],
            [9.673804212762153, -5.741616437756371],
            [9.675677095656205, -5.735960535209637],
            [9.674755737209782, -5.725188460114961],
            [9.670897863663022, -5.71747560809781],
            [9.67082190947661, -5.710850068530258],
            [9.66846377248542, -5.707483321361576],
            [9.666986935672801, -5.701757253881775],
            [9.665840057201832, -5.697310131854208],
            [9.660143052175373, -5.688774374731339],
            [9.654313172706642, -5.687191551592506],
            [9.651729888962779, -5.682433768410324],
            [9.647940732530978, -5.679223499447409],
            [9.64510130160979, -5.67131552070741],
            [9.6368491949102, -5.669743127112247],
            [9.63378253361043, -5.663480860195465],
            [9.628603080185405, -5.660402760354843],
            [9.613171237490656, -5.646465412551131],
            [9.610250170321466, -5.64126029339804],
            [9.603381785725011, -5.6392252320871945],
            [9.594260298902398, -5.625040812084576],
            [9.589996453663296, -5.616551259087013],
            [9.58920105530699, -5.612090115602007]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.8771501965249, "lat": 32.50998465568982 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13215"],
        "coty_name": ["Muscogee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Muscogee County"],
        "coty_fp_code": "215",
        "coty_gnis_code": "00357428"
      },
      "bbox": [
        9.58920105530699, -5.832961083423834, 9.938153335925117,
        -5.595920523679658
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.14054646216413, -4.176135878360598],
            [9.178914735628457, -4.172382456664154],
            [9.179596214642466, -4.172109961677655],
            [9.230534263621038, -4.167239038277728],
            [9.274514342918042, -4.16279473004367],
            [9.272431147679352, -4.141248416667772],
            [9.311323144639312, -4.1371895185203735],
            [9.31163486811776, -4.13988022857693],
            [9.354681083497535, -4.135333105166151],
            [9.356133836592651, -4.14913137392323],
            [9.384790245142733, -4.146172977268007],
            [9.38364441533816, -4.132541756738836],
            [9.444982307546917, -4.125825389218907],
            [9.446407260486193, -4.139350977537957],
            [9.485616292560223, -4.134753469291479],
            [9.534586178970896, -4.129451704355299],
            [9.535108252686625, -4.133595205232442],
            [9.54247940454396, -4.132937738554664],
            [9.542045922008247, -4.1285369963704035],
            [9.547936263971824, -4.127950561394945],
            [9.544301968508062, -4.139302280556396],
            [9.517550662973026, -4.26412939793354],
            [9.459218074370998, -4.269627020639398],
            [9.46440401002822, -4.317722741183918],
            [9.374008182706085, -4.32688707767093],
            [9.331229622044905, -4.331140421738168],
            [9.332024666912167, -4.3382186234276725],
            [9.189555898149212, -4.35174632000757],
            [9.172434635825658, -4.290567607445541],
            [9.162610390129375, -4.255296927457851],
            [9.16168357741817, -4.253161871958883],
            [9.14054646216413, -4.176135878360598]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.18813104027613, "lat": 34.00178729055605 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13233"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "233",
        "coty_gnis_code": "00343585"
      },
      "bbox": [
        9.14054646216413, -4.35174632000757, 9.547936263971824,
        -4.125825389218907
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.444067882898489, -4.372833542302195],
            [11.449732074080853, -4.370576265379944],
            [11.451392367202835, -4.367395510356003],
            [11.456210989277658, -4.36644222919531],
            [11.460687913911924, -4.367191882093046],
            [11.463625392409012, -4.373102219642627],
            [11.46723171980215, -4.373175071151444],
            [11.46279241176223, -4.3632829144048495],
            [11.464967889685148, -4.358533200796925],
            [11.467591139297715, -4.360417927184503],
            [11.473373430330188, -4.371652947125331],
            [11.477429583676397, -4.377850283355659],
            [11.480171456550982, -4.385485299842382],
            [11.496876296021137, -4.418008049209393],
            [11.51674548014041, -4.457771777123658],
            [11.520941325793899, -4.466644813601613],
            [11.543469071159334, -4.511041268758136],
            [11.573663634847918, -4.541080226977619],
            [11.587134982749388, -4.580814465163814],
            [11.585390320478188, -4.598268079704207],
            [11.58716727637308, -4.603048650040479],
            [11.589577360056404, -4.603791965834253],
            [11.596596203701926, -4.596967810852644],
            [11.604840254951322, -4.599692137597587],
            [11.606175174894735, -4.602365963850551],
            [11.611845300534252, -4.60334522957894],
            [11.619372258627868, -4.6093532893454965],
            [11.627478503050032, -4.607616440887326],
            [11.629991953118633, -4.612217304502927],
            [11.635203534489932, -4.61124204230609],
            [11.638925339531658, -4.608789077710761],
            [11.649983807482696, -4.6075926838518],
            [11.654378532554809, -4.604750808715896],
            [11.656663362808473, -4.605908493763745],
            [11.668106551584417, -4.603581901104428],
            [11.671649854184594, -4.606834121775812],
            [11.680784712401074, -4.606299938761034],
            [11.691660449284525, -4.611107448074234],
            [11.697395005002555, -4.608054764745705],
            [11.698225780787826, -4.612973363738404],
            [11.701150755193675, -4.613829195771467],
            [11.707202794324296, -4.620995349294007],
            [11.711273027519827, -4.620488118300033],
            [11.71589650866208, -4.624167411873339],
            [11.727898916926497, -4.624174242528181],
            [11.693694616463073, -4.666871875512873],
            [11.636335176316907, -4.646523989628503],
            [11.629820632472674, -4.645535720215699],
            [11.58118961776345, -4.629758063639504],
            [11.574212848461661, -4.632708989286331],
            [11.570224317163186, -4.636100260701126],
            [11.560112614469888, -4.637254149337384],
            [11.555830911523211, -4.639722210639191],
            [11.552232128852468, -4.647604750034965],
            [11.547656251261929, -4.650656023784203],
            [11.542265726696796, -4.652220859423091],
            [11.537554293811585, -4.656834057470107],
            [11.527126608030876, -4.656733806382489],
            [11.521829101504592, -4.661560328189619],
            [11.514294884604206, -4.665389371597983],
            [11.508370333613401, -4.675901797535398],
            [11.505310379593393, -4.677729167678745],
            [11.495934910402006, -4.690740247433657],
            [11.491146362194462, -4.696210511009595],
            [11.48293797292976, -4.699733206398216],
            [11.471460455110341, -4.700359129556162],
            [11.467260028589568, -4.704615283708624],
            [11.459549497639445, -4.710099813073103],
            [11.455289851304796, -4.715894207840251],
            [11.448361160052526, -4.720457206757185],
            [11.44095628239329, -4.720299252665768],
            [11.432248831634457, -4.723370065885538],
            [11.43036889923047, -4.72581298003545],
            [11.424114276331071, -4.726169333221603],
            [11.42203334618502, -4.721315747016313],
            [11.414891908656859, -4.7214042529919205],
            [11.412761457438148, -4.717011204736096],
            [11.4062131864778, -4.712319683250379],
            [11.403190539111936, -4.705724805263152],
            [11.40575745695911, -4.701528165993389],
            [11.403883382836304, -4.694937016645999],
            [11.404845915568663, -4.692638724923727],
            [11.402678130581577, -4.683842270905834],
            [11.402081675679275, -4.678067469622885],
            [11.399851477962425, -4.673766691055103],
            [11.395934078545995, -4.672915903420974],
            [11.39143444136812, -4.674145042698138],
            [11.388176350939903, -4.66559518717838],
            [11.392304720034295, -4.664172718805165],
            [11.393129989866553, -4.661579403824952],
            [11.38657216143927, -4.659685980893016],
            [11.383648020850128, -4.653697155353942],
            [11.38456911607954, -4.651213117238493],
            [11.382036510066841, -4.637457866933713],
            [11.37974756861134, -4.6340399274176045],
            [11.381954836231497, -4.629738111431546],
            [11.378906104763944, -4.626175701821661],
            [11.379071950064263, -4.623320487383381],
            [11.376094995357047, -4.62032146926479],
            [11.368491436802968, -4.622689395864343],
            [11.362999420526073, -4.613778975282102],
            [11.360908862595375, -4.608191752850069],
            [11.360736183082997, -4.600022167359927],
            [11.357216116765109, -4.597606695790043],
            [11.353755731041899, -4.5976978385707445],
            [11.354595000358023, -4.588548295628146],
            [11.352806999729234, -4.584219672278841],
            [11.354256136792628, -4.581128017610378],
            [11.353120340403809, -4.5775172772951445],
            [11.350304184558773, -4.575745375443783],
            [11.350632770494258, -4.5677527008064205],
            [11.349551499591145, -4.560236643700796],
            [11.340792233994376, -4.557696654921444],
            [11.338141271389143, -4.556087854600127],
            [11.335105759511869, -4.5585637203085145],
            [11.330669055953653, -4.5549418068673395],
            [11.329003242780756, -4.551176207075792],
            [11.324905953594776, -4.547882834555825],
            [11.32352500885188, -4.547274897007735],
            [11.318981747740468, -4.537379843931792],
            [11.31541344084378, -4.5364782941709425],
            [11.315553474768091, -4.533226004126457],
            [11.309682631866341, -4.5266287472022135],
            [11.316619029131113, -4.521066646988385],
            [11.322032862816503, -4.512771872699348],
            [11.32380659273294, -4.508311395519659],
            [11.329323432407554, -4.501729433417512],
            [11.329041441062085, -4.498204931222809],
            [11.330649239467544, -4.4913800893364115],
            [11.339176548266103, -4.4864948681963215],
            [11.340131509687321, -4.484416896503057],
            [11.339396383157137, -4.474965636794428],
            [11.340603244419148, -4.469284435235049],
            [11.34417394438297, -4.466559444999747],
            [11.368350145825604, -4.473770554659677],
            [11.372597615129404, -4.471181959123492],
            [11.381106143095451, -4.470241473679183],
            [11.384470821109623, -4.4675970143907415],
            [11.39014809252312, -4.469437364674908],
            [11.393234473922632, -4.468631819884247],
            [11.398218189704322, -4.4701630881589045],
            [11.402172633829236, -4.466769255889033],
            [11.4019700104149, -4.463720792620922],
            [11.404771180776766, -4.450516253489669],
            [11.411552013105785, -4.447963736668335],
            [11.415375773836836, -4.439387008363698],
            [11.417178286802168, -4.4380920782351225],
            [11.4174900476654, -4.425606815002795],
            [11.414740487417678, -4.424047607376548],
            [11.415113703172421, -4.418019206495842],
            [11.42274375797104, -4.409664801938989],
            [11.422078708613178, -4.404230923596658],
            [11.427302189258604, -4.395811633994208],
            [11.427547150112193, -4.3911755968940955],
            [11.425323828476337, -4.387919368585701],
            [11.428197028124014, -4.383286347886385],
            [11.432465415973422, -4.381282310873191],
            [11.437958571358953, -4.3834460965749935],
            [11.444067882898489, -4.372833542302195]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.6766854068481, "lat": 33.40896033068773 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13301"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "301",
        "coty_gnis_code": "00347777"
      },
      "bbox": [
        11.309682631866341, -4.726169333221603, 11.727898916926497,
        -4.358533200796925
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.221704439517744, -6.055084121563974],
            [12.22593518237572, -6.059712838031082],
            [12.228589611818592, -6.0607896063966376],
            [12.235736972153632, -6.059913589458971],
            [12.240337165644393, -6.064017683383098],
            [12.245445235391774, -6.060614679858285],
            [12.245186722605833, -6.05507961798367],
            [12.25088128372621, -6.056115730178016],
            [12.254511214392334, -6.066876389559368],
            [12.259593186698368, -6.069090825690334],
            [12.260665091653825, -6.076639369765012],
            [12.266802924058231, -6.074562642263658],
            [12.269603834337966, -6.075563014551334],
            [12.270035446646657, -6.082466724272791],
            [12.283760035304983, -6.089025183963361],
            [12.288546572747338, -6.090133462844617],
            [12.291314587639942, -6.088612580797755],
            [12.29382223653767, -6.082570901469436],
            [12.304284122918896, -6.080613202956649],
            [12.309033512400644, -6.083826204913691],
            [12.310656407497428, -6.096538507379387],
            [12.31345563868766, -6.099927815162393],
            [12.318190289824964, -6.101113819237175],
            [12.318655890029799, -6.1080999635396305],
            [12.322063898673974, -6.108476576220551],
            [12.327252975056254, -6.104816613251386],
            [12.331167627516956, -6.106722245642118],
            [12.332826742363077, -6.1129446768976585],
            [12.336411904665532, -6.114059831845384],
            [12.34046962712376, -6.106078464285009],
            [12.347418364099099, -6.110822892390588],
            [12.349505655792887, -6.113714922528262],
            [12.349859311542982, -6.118212362201088],
            [12.347947823982889, -6.120327851478796],
            [12.347889046236842, -6.124633976723611],
            [12.350816115622251, -6.12760919968311],
            [12.35166821034207, -6.132621054312699],
            [12.35652330957663, -6.1385154887877125],
            [12.368823009219094, -6.143717070691774],
            [12.376386438111258, -6.1461281275240545],
            [12.382641042768737, -6.14631008652764],
            [12.38481169296462, -6.148968583071805],
            [12.385732639826434, -6.154907701244854],
            [12.39374738449116, -6.166941668554542],
            [12.401001057992119, -6.170571945124092],
            [12.404923410918432, -6.174998105723701],
            [12.410977128953173, -6.177077930890474],
            [12.412234497745684, -6.180470495604079],
            [12.409173285689388, -6.183365153284067],
            [12.411060902998134, -6.18799330528245],
            [12.419277399874533, -6.18624273622468],
            [12.423854326108808, -6.190099810731626],
            [12.429806814174713, -6.188944560535315],
            [12.431175995401182, -6.192044488206925],
            [12.42910287476966, -6.195761415499791],
            [12.43580796527633, -6.2003136311036355],
            [12.44395237433099, -6.198597774368206],
            [12.445693212071733, -6.196098226404452],
            [12.443267404808068, -6.19104336689464],
            [12.44653595848795, -6.189306742158353],
            [12.449826608788364, -6.194716814602487],
            [12.457249544505157, -6.195541605496225],
            [12.459985292689577, -6.19943812016712],
            [12.460045385527543, -6.204521542172589],
            [12.467643353100462, -6.204292523963161],
            [12.469408187922014, -6.208351265926446],
            [12.466777628839658, -6.212152580590633],
            [12.468003238158039, -6.215793268033423],
            [12.472120333066428, -6.2170634631052595],
            [12.476941741981452, -6.214687351795547],
            [12.483329871811963, -6.217207702183086],
            [12.4856480108234, -6.228144932302262],
            [12.490508472472406, -6.229191736238094],
            [12.491677546071445, -6.224808540088666],
            [12.494447732823975, -6.223171289451431],
            [12.498309827226269, -6.227661661626779],
            [12.501691857518622, -6.226579464748481],
            [12.508870740632922, -6.229813092148944],
            [12.505969015109756, -6.234654679616866],
            [12.50633204694375, -6.2391541759306595],
            [12.50966179634443, -6.240438876496148],
            [12.512204776629936, -6.237451196973714],
            [12.512253049965064, -6.233030177719145],
            [12.515311842556612, -6.232189856556439],
            [12.520313711020089, -6.2353761959091205],
            [12.520312791361423, -6.238989543468112],
            [12.526773696800962, -6.2395553753980595],
            [12.526244436730655, -6.243258274468346],
            [12.529287380089672, -6.247038539265741],
            [12.534239189835317, -6.2489060481663765],
            [12.537873737823272, -6.2464680384463],
            [12.5454288610208, -6.25240307859726],
            [12.548254595904357, -6.250968808918351],
            [12.549520926400495, -6.255795409200961],
            [12.55333068825875, -6.257329143660607],
            [12.552013444000938, -6.263045712216365],
            [12.555381659171967, -6.269699439632219],
            [12.551962832572771, -6.271346310180004],
            [12.555879880139463, -6.274822141894493],
            [12.557098508096066, -6.280874884721066],
            [12.562906357867458, -6.283269890871092],
            [12.568167861364877, -6.280886407801468],
            [12.570977219035411, -6.282300760043312],
            [12.571824003146135, -6.285827212244066],
            [12.575886123692115, -6.285892487669481],
            [12.579000971345348, -6.283578951554512],
            [12.586321779075353, -6.288774343810979],
            [12.58758327719205, -6.291729225047928],
            [12.584190388545395, -6.293242118389645],
            [12.584586915329211, -6.297419825850349],
            [12.590075711600484, -6.301738714538254],
            [12.596025729799933, -6.299863364252753],
            [12.598082103100262, -6.302128545725826],
            [12.596202953148909, -6.3066733752096304],
            [12.597867205510614, -6.309372281123338],
            [12.596219319173827, -6.312859497455695],
            [12.595900843592327, -6.3185308333102785],
            [12.599012443485911, -6.322806514148282],
            [12.608670567083747, -6.327802865453813],
            [12.60757067606943, -6.33277768582942],
            [12.6139950264298, -6.338301786827384],
            [12.621699814471866, -6.341954073299983],
            [12.629415369970292, -6.339821665850412],
            [12.634495981585347, -6.344771656575386],
            [12.640998115734165, -6.354673400798454],
            [12.638306128233884, -6.359219508450038],
            [12.638476405824145, -6.36535922722457],
            [12.63320338893858, -6.371312283556559],
            [12.631772202091723, -6.371491721198894],
            [12.606985311580988, -6.428841310376214],
            [12.584233262130336, -6.4316233740620845],
            [12.581062484826424, -6.440343667862186],
            [12.57846806704369, -6.450327423950422],
            [12.577292164098123, -6.458567734676912],
            [12.583972417473982, -6.464616793381084],
            [12.583956141368109, -6.4695398932881085],
            [12.579200435614629, -6.484073281414704],
            [12.567286899976112, -6.508152956579743],
            [12.56142493003402, -6.506167844389724],
            [12.536438795785624, -6.497711875709713],
            [12.53117236704615, -6.492517955227902],
            [12.498024729164207, -6.481695897154391],
            [12.4622306085887, -6.496108838762937],
            [12.408711996803914, -6.511660473577927],
            [12.397873572493992, -6.514619988947051],
            [12.373176490341034, -6.512970926472008],
            [12.304097955326803, -6.507936264873257],
            [12.294559362544474, -6.501795871958635],
            [12.293453398876885, -6.4953610553339605],
            [12.29012197754664, -6.4910537669479575],
            [12.288650762204838, -6.484126909719662],
            [12.28383072890719, -6.480585466514233],
            [12.282641678179345, -6.473136927293364],
            [12.27748832237852, -6.470561538654399],
            [12.275956198325389, -6.465194733414838],
            [12.27683091500957, -6.462061648402724],
            [12.274955194317483, -6.453557885849031],
            [12.275623244595112, -6.449579781037702],
            [12.27395465307565, -6.441942637738784],
            [12.274848449470797, -6.4389637645730975],
            [12.270954920410796, -6.422812350046627],
            [12.267425253889204, -6.417842760771059],
            [12.262242633343, -6.413132740728871],
            [12.258502951505568, -6.412564167527265],
            [12.254448317529816, -6.409093930997359],
            [12.237447182368413, -6.403006076991585],
            [12.231069221457641, -6.402699698135093],
            [12.218982989358986, -6.405173124834118],
            [12.209076363196505, -6.410256559958982],
            [12.203187248173819, -6.416837218933947],
            [12.19212674541741, -6.343172369439846],
            [12.190535985603223, -6.331699428412982],
            [12.177921666917145, -6.333748522195184],
            [12.176180316363551, -6.322085305432001],
            [12.188751054202902, -6.320061694510895],
            [12.176072103537654, -6.238788014773331],
            [12.176127722042919, -6.237303713992966],
            [12.168632571584725, -6.185083545063901],
            [12.158892838121634, -6.118477235514423],
            [12.195451040972952, -6.113622889667018],
            [12.193633574320867, -6.100775346596507],
            [12.17879432216085, -6.102749188544752],
            [12.177198862444937, -6.089154836059652],
            [12.193390704996661, -6.08707445958277],
            [12.190245650717584, -6.065834036228675],
            [12.199898915999754, -6.056044468732731],
            [12.203883059286003, -6.058832235970687],
            [12.211293398432522, -6.05823379663319],
            [12.21314481815407, -6.055968545217607],
            [12.221704439517744, -6.055084121563974]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.91675134670811, "lat": 31.55140368181652 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13305"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "305",
        "coty_gnis_code": "00350608"
      },
      "bbox": [
        12.158892838121634, -6.514619988947051, 12.640998115734165,
        -6.05507961798367
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.11199757248635, -10.43445046364457],
            [-10.095062174083553, -10.433023337492227],
            [-10.07188216693794, -10.429899332690734],
            [-10.065432201115488, -10.4316553239897],
            [-10.054295796865091, -10.431707668226467],
            [-10.04782708514028, -10.429796718753433],
            [-10.03123697089638, -10.429287756777688],
            [-10.017623791999858, -10.431314304820168],
            [-10.013305876784532, -10.430170508649734],
            [-10.008860982700481, -10.43234730853662],
            [-10.005290223673859, -10.430853560472526],
            [-9.996512173226733, -10.431227438140267],
            [-9.979667652489326, -10.427706337565246],
            [-9.97552021782129, -10.429820721422624],
            [-9.966969074686977, -10.428754031942816],
            [-9.962418484986552, -10.42221150940175],
            [-9.957589816912593, -10.422649924934847],
            [-9.949079937811812, -10.412118837665414],
            [-9.951766413269615, -10.409777865547255],
            [-9.940673003579601, -10.399878120798627],
            [-9.932157702690274, -10.394886790097196],
            [-9.932287309417724, -10.391486081005713],
            [-9.926708945680996, -10.388922109039264],
            [-9.918786879726737, -10.380288545198239],
            [-9.915516704094765, -10.375125605131432],
            [-9.912619202113481, -10.374749069625958],
            [-9.90991851644363, -10.35886000510128],
            [-9.895533274575838, -10.344587512111467],
            [-9.889043158139057, -10.339547394756067],
            [-9.886246317312478, -10.333705767498314],
            [-9.881752470444408, -10.33223630148804],
            [-9.8808108030927, -10.328743186100601],
            [-9.877457380542788, -10.325523121873767],
            [-9.864233071895825, -10.31710861310724],
            [-9.86008625450693, -10.315175759108646],
            [-9.851587099334141, -10.313984762957306],
            [-9.848753150906518, -10.310285047272473],
            [-9.840992258316573, -10.310039482209705],
            [-9.835918089398266, -10.305124270851879],
            [-9.830624634873097, -10.306627710663319],
            [-9.82839958160529, -10.305021830164048],
            [-9.820832663576002, -10.305480516190295],
            [-9.815827157405812, -10.312260561335155],
            [-9.811958863770782, -10.313487969337412],
            [-9.803755423692687, -10.322570085719018],
            [-9.79335068518163, -10.3383431790261],
            [-9.78886174028993, -10.341089074405767],
            [-9.791590033343294, -10.343738730103695],
            [-9.79093896776379, -10.348267529221765],
            [-9.78805636488047, -10.351512178930822],
            [-9.782496407598677, -10.353256556756776],
            [-9.784323169139425, -10.360876082422912],
            [-9.773661489119513, -10.367126779959104],
            [-9.774995547380271, -10.372255524265256],
            [-9.774797756137735, -10.379155140593172],
            [-9.777448291495324, -10.384288957522473],
            [-9.776165283234462, -10.387775639330494],
            [-9.769948878984776, -10.392972927890199],
            [-9.769906876155149, -10.399213188223046],
            [-9.765306015266525, -10.405875382572384],
            [-9.756312921298926, -10.410928744014836],
            [-9.753560112550712, -10.418870561092604],
            [-9.748091554529346, -10.423398094163034],
            [-9.745745173122343, -10.43244508491516],
            [-9.741970484873749, -10.435908776992209],
            [-9.734952993370364, -10.439850807190242],
            [-9.734856971294144, -10.449689318422253],
            [-9.736637808079012, -10.455122070077591],
            [-9.733401469616373, -10.457492713447389],
            [-9.729083319192462, -10.456550791510148],
            [-9.724367328613054, -10.45246182911988],
            [-9.715950925253566, -10.45507776164183],
            [-9.712092693821445, -10.4576307079178],
            [-9.708313763247174, -10.462605532588277],
            [-9.70829047645573, -10.467379737748171],
            [-9.703842741490012, -10.4703062771631],
            [-9.696974578410947, -10.485004004858704],
            [-9.698110189128098, -10.49474857410394],
            [-9.697336424887608, -10.502517204087772],
            [-9.71215107849111, -10.5050796964204],
            [-9.714047712459761, -10.511244023623433],
            [-9.708827381104165, -10.518801746163039],
            [-9.710930872444324, -10.52347619250676],
            [-9.70893364907201, -10.525856048466432],
            [-9.704949038647955, -10.52631594877636],
            [-9.703836561650043, -10.53032846257007],
            [-9.706357050631773, -10.540526001733287],
            [-9.703273150788574, -10.550790449156315],
            [-9.700558567047011, -10.553512125828455],
            [-9.693051020433309, -10.55228904420243],
            [-9.688191479684527, -10.554843712834943],
            [-9.685772279006677, -10.557644302521107],
            [-9.680409071252011, -10.555587485868351],
            [-9.675415444909271, -10.565465193917246],
            [-9.672898405505011, -10.567080275131412],
            [-9.66977029367564, -10.574645079641241],
            [-9.670465890301633, -10.579568070834464],
            [-9.66189253228392, -10.58428150923301],
            [-9.660614012436879, -10.580888477004416],
            [-9.657704145781917, -10.580825144925354],
            [-9.654730384891264, -10.584303343165331],
            [-9.652981371796743, -10.595619715811484],
            [-9.64440109354594, -10.597489881721444],
            [-9.636813108262247, -10.596080894718146],
            [-9.633597206007398, -10.593201885945314],
            [-9.631317234273435, -10.588162480124677],
            [-9.632631164943712, -10.585143237709449],
            [-9.628699961648104, -10.581323580208483],
            [-9.625560181815041, -10.573116050877701],
            [-9.639337189666833, -10.566991029787474],
            [-9.643141602451978, -10.566820631572387],
            [-9.644514806943185, -10.563651808938564],
            [-9.643592057587071, -10.558457122312438],
            [-9.6392993841917, -10.553474460284404],
            [-9.63507086337428, -10.554084217683851],
            [-9.632529644196808, -10.549041598890245],
            [-9.630330425360658, -10.550997846267629],
            [-9.614130100778024, -10.557012266373869],
            [-9.607756519600136, -10.55485330834532],
            [-9.599187863483307, -10.550326070028165],
            [-9.592187220950205, -10.551376134198595],
            [-9.59249776965512, -10.554709804055177],
            [-9.59526226293138, -10.560396269207624],
            [-9.598782722173574, -10.563532597894893],
            [-9.604568371093867, -10.564986923295317],
            [-9.605283780989188, -10.571386533070418],
            [-9.604756943749226, -10.577514447985779],
            [-9.607752776167766, -10.585467936493963],
            [-9.61009888494318, -10.584180942689404],
            [-9.612898729817521, -10.587296643143725],
            [-9.611803951798016, -10.59570182580614],
            [-9.607433957408224, -10.604932093848271],
            [-9.603068956153994, -10.60860385086719],
            [-9.596744895029584, -10.61071673843136],
            [-9.586143044068924, -10.615694615206332],
            [-9.582510685391023, -10.619949464948968],
            [-9.57963965153816, -10.625501984235315],
            [-9.576822098257399, -10.628439087633605],
            [-9.577043235259483, -10.632705783949756],
            [-9.579509094714101, -10.63940007145604],
            [-9.579824814132817, -10.64791422979993],
            [-9.57758509396432, -10.654963774168884],
            [-9.565613710734858, -10.674721023635161],
            [-9.560529947096304, -10.679031966919661],
            [-9.550656271889311, -10.683074288414774],
            [-9.53946697497695, -10.69169995986462],
            [-9.537129864669733, -10.69090577741284],
            [-9.533355722779286, -10.69696529385504],
            [-9.523696536131963, -10.696619754223848],
            [-9.523593081901408, -10.702331315987728],
            [-9.525580970536616, -10.708083497628337],
            [-9.52898502353683, -10.70890730242467],
            [-9.532118260117269, -10.713428015229578],
            [-9.546943353618525, -10.721230480356665],
            [-9.549933304811024, -10.725662509840221],
            [-9.558237974836159, -10.73049427189496],
            [-9.561587051202027, -10.73710994062644],
            [-9.565341674061601, -10.733185170886845],
            [-9.567797961775842, -10.734475415530186],
            [-9.567809937682826, -10.738798047677976],
            [-9.563655491750296, -10.741684712624979],
            [-9.570424017263086, -10.74517744206123],
            [-9.580332721437362, -10.746090299377625],
            [-9.582432108993101, -10.743876409743342],
            [-9.579793569162039, -10.736919548044035],
            [-9.580469596248001, -10.728770000579742],
            [-9.583447458778599, -10.725376895080979],
            [-9.589773974169631, -10.722021348733213],
            [-9.59255575019126, -10.724905850260953],
            [-9.596817942483659, -10.725432610662477],
            [-9.601750803344927, -10.724276145170421],
            [-9.604030889792192, -10.726557918065245],
            [-9.61248732331439, -10.72648218343254],
            [-9.622750356269231, -10.729984951465815],
            [-9.632015728722665, -10.730839035688994],
            [-9.642397907376166, -10.735394456247834],
            [-9.646626773845675, -10.740501690975774],
            [-9.655889604659423, -10.745758516892476],
            [-9.657232469677279, -10.749956085869451],
            [-9.661603947333681, -10.748356161810191],
            [-9.671296236358346, -10.750388120344606],
            [-9.679456580905153, -10.74931765965862],
            [-9.685259141756564, -10.744922130456878],
            [-9.686803739686999, -10.740648260487198],
            [-9.68716122412824, -10.734342663443899],
            [-9.693297854913899, -10.7292618247936],
            [-9.697115483385756, -10.72805331885887],
            [-9.70098445595715, -10.724809110730632],
            [-9.70855729818131, -10.724274275007627],
            [-9.730878960100814, -10.711080281756132],
            [-9.731698884374495, -10.708080890335712],
            [-9.738156658818038, -10.705162071327946],
            [-9.74393044611082, -10.706273471792022],
            [-9.746644280412049, -10.699789850447576],
            [-9.763486079740757, -10.70102675742216],
            [-9.765462329296394, -10.7029714673418],
            [-9.803405952383073, -10.702397187302518],
            [-9.805406464276466, -10.699747441734289],
            [-9.80336277750611, -10.690945376677766],
            [-9.807760929846841, -10.68777065425167],
            [-9.816049346085942, -10.684849858959156],
            [-9.820264221110719, -10.679216540670279],
            [-9.824942828734589, -10.678335548207546],
            [-9.825186952486792, -10.68373573093039],
            [-9.832567766577764, -10.690423573839889],
            [-9.835581131506332, -10.690442474918823],
            [-9.872963625173755, -10.698893449790095],
            [-9.883451750608375, -10.700796822732503],
            [-9.894551875815369, -10.70205423808626],
            [-9.900111928667014, -10.704612842381689],
            [-9.927514573652136, -10.707419306942196],
            [-9.93187758291239, -10.709674770817697],
            [-9.949523736461206, -10.709719662078541],
            [-9.954588228479254, -10.707806075973677],
            [-9.958699621152357, -10.70360626190198],
            [-9.964149683384964, -10.692461681731675],
            [-9.965942490025276, -10.684890487990693],
            [-9.960841964981956, -10.68447231062317],
            [-9.958732193647652, -10.68194228640599],
            [-9.96188438815863, -10.677332710348002],
            [-9.965928129797838, -10.680829228061565],
            [-9.968342443146263, -10.68032896118651],
            [-9.968997377116057, -10.672181015667498],
            [-9.973130418418997, -10.665686625205845],
            [-9.975017725226612, -10.65504489681227],
            [-9.974521008692383, -10.651592630175458],
            [-9.97685454476164, -10.645102006484167],
            [-9.980707423209173, -10.637785979905445],
            [-9.984700604232918, -10.635190346409452],
            [-9.98503899922998, -10.630810282520336],
            [-9.989837394781343, -10.627538667346297],
            [-9.993057901088143, -10.622163183970132],
            [-10.00456696868154, -10.611719290998826],
            [-10.014785955347326, -10.60899472029628],
            [-10.020619228658065, -10.603408922190575],
            [-10.019304857544332, -10.598095497727103],
            [-10.020912075068075, -10.579687405481435],
            [-10.023734326809592, -10.578243971922603],
            [-10.030435151798455, -10.56518264511716],
            [-10.030412387547804, -10.562156570847156],
            [-10.037755785992488, -10.559964233203424],
            [-10.03929844337846, -10.55628685977356],
            [-10.042529378795386, -10.555097960065131],
            [-10.043342133136312, -10.550955505176777],
            [-10.052402035119016, -10.545710015131096],
            [-10.05681053359948, -10.54146579037346],
            [-10.058900360430421, -10.53316780471524],
            [-10.063463200226623, -10.531040385342784],
            [-10.068956327733895, -10.526691255380578],
            [-10.067844162657774, -10.514368070961142],
            [-10.067366234087533, -10.493320181306993],
            [-10.06680805632238, -10.4853672391371],
            [-10.067432027583706, -10.476301998464905],
            [-10.069058592166181, -10.473506120890956],
            [-10.086899706721498, -10.453717208420274],
            [-10.092238624396362, -10.451776710369089],
            [-10.109362182169656, -10.439219095352612],
            [-10.115773814971247, -10.436214898422506],
            [-10.11199757248635, -10.43445046364457]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -158.06665666671944,
          "lat": 21.487412064557862
        },
        "year": "2023",
        "ste_code": ["15"],
        "ste_name": ["Hawaii"],
        "coty_code": ["15003"],
        "coty_name": ["Honolulu"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Honolulu County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00365281"
      },
      "bbox": [
        -10.115773814971247, -10.750388120344606, -9.523593081901408,
        -10.305021830164048
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.824704174602612, 8.86404488486682],
            [-13.820846073741524, 8.866465264496695],
            [-13.81387801820323, 8.864431931613902],
            [-13.801163399016351, 8.857042091592817],
            [-13.799084126906783, 8.853642680364787],
            [-13.795587998222814, 8.853281879267541],
            [-13.788048198144473, 8.855359565456851],
            [-13.783418871652914, 8.862006898612892],
            [-13.78267192109802, 8.864898383027063],
            [-13.783229047200916, 8.876275002672974],
            [-13.781131363984862, 8.889100581871459],
            [-13.773487845573195, 8.892912417705917],
            [-13.763607811000748, 8.892424283036975],
            [-13.760209163718265, 8.8906587637232],
            [-13.757698166672236, 8.886604765395981],
            [-13.753662151824646, 8.887418157919083],
            [-13.747215411955288, 8.884994057286049],
            [-13.739081841993569, 8.878481604569675],
            [-13.735767550818055, 8.877062125330653],
            [-13.733639537018874, 8.87114798024385],
            [-13.727425253791916, 8.862765292462207],
            [-13.722721987761728, 8.852034248769488],
            [-13.716071961372563, 8.846912895524902],
            [-13.714500891416796, 8.842053427343192],
            [-13.706974137035733, 8.842787927392608],
            [-13.70386616313994, 8.845514323353871],
            [-13.701426320238037, 8.850454297391224],
            [-13.70250638238517, 8.858032853241756],
            [-13.701464536076738, 8.8610957838254],
            [-13.696767696841828, 8.867474194930338],
            [-13.688665600543668, 8.876687911263533],
            [-13.688732429144922, 8.882864911581484],
            [-13.685819651191007, 8.888582013685912],
            [-13.669201950797412, 8.963979839343875],
            [-13.666899648284849, 8.963512535669766],
            [-13.661754384547146, 8.956572245994185],
            [-13.65660997729696, 8.953787373043827],
            [-13.652076053271081, 8.954878874434966],
            [-13.651133343756644, 8.952330144990107],
            [-13.646348195736909, 8.952063576289772],
            [-13.64303343518573, 8.955504602614058],
            [-13.642788097502981, 8.961109942786607],
            [-13.644766853609054, 8.965144035169441],
            [-13.642113486264622, 8.969501818760524],
            [-13.642156301644977, 8.97454228370695],
            [-13.637112452365884, 8.977334538028272],
            [-13.636449475390211, 8.981093872542656],
            [-13.626544264437069, 8.991753795991592],
            [-13.625913373555584, 8.995899112906592],
            [-13.620717631906754, 8.999432797200834],
            [-13.619607431064518, 9.004659988370166],
            [-13.616608048037577, 9.009301524189057],
            [-13.614693732797805, 9.01596808719895],
            [-13.6110998144321, 9.019522558834797],
            [-13.605670830870787, 9.018065448082071],
            [-13.596270178323374, 9.022030434954349],
            [-13.58986158485487, 9.020173746508036],
            [-13.58454314687003, 9.01246736892845],
            [-13.5757664204776, 9.005578572114736],
            [-13.574358054509, 9.00310035643954],
            [-13.56492666566105, 9.001856942331928],
            [-13.559659591329389, 8.995257508724848],
            [-13.557014868071885, 8.996337379392257],
            [-13.547296495914027, 8.995138884420083],
            [-13.533267419955168, 8.990554364130373],
            [-13.529913101837185, 8.986050890767345],
            [-13.525321455429442, 8.97573599882374],
            [-13.518100628703253, 8.969714236905311],
            [-13.513022293352455, 8.972111554854981],
            [-13.509908655211907, 8.971068389379166],
            [-13.505768192749807, 8.974138062836467],
            [-13.501840878313857, 8.97318334022315],
            [-13.493239565486478, 8.965706232578844],
            [-13.488085227529778, 8.965324195215295],
            [-13.48536898417391, 8.967861342411817],
            [-13.483144281945375, 8.963693011314275],
            [-13.479952520356639, 8.963893511761135],
            [-13.476625885302058, 8.96074479238499],
            [-13.476222627453563, 8.956652132746717],
            [-13.473666164372338, 8.953128428521405],
            [-13.469414342872343, 8.951267351686145],
            [-13.462284537571755, 8.952024245334977],
            [-13.457130961316146, 8.947876616110731],
            [-13.452004090857374, 8.941566485760365],
            [-13.448768131304409, 8.94006974810138],
            [-13.442698932163047, 8.942082828344251],
            [-13.437763994631778, 8.953722824278467],
            [-13.43831660061027, 8.95676132558166],
            [-13.43603814504073, 8.963699770014678],
            [-13.42725613269829, 8.96926212784093],
            [-13.421118705971423, 8.970208653644606],
            [-13.416544724339106, 8.97714323586205],
            [-13.409356250624747, 8.984678117058],
            [-13.400851093776598, 8.990111297658604],
            [-13.392532642624678, 8.9917888649079],
            [-13.387016825765576, 8.990267605025506],
            [-13.384674158015098, 8.985809068301705],
            [-13.375130305691508, 8.983347268268265],
            [-13.36352065742344, 8.977935761055061],
            [-13.361521003946095, 8.978639101883639],
            [-13.352825292879373, 8.977037959261757],
            [-13.35096849565464, 8.979293068370696],
            [-13.34035354991106, 8.975435375687429],
            [-13.328864500829527, 8.976990408355787],
            [-13.318023278870376, 8.981084028023561],
            [-13.316327461243084, 8.982625806713814],
            [-13.308357491623402, 8.984478626379875],
            [-13.310066788368543, 8.989500031714567],
            [-13.317245250444149, 8.998966385746648],
            [-13.32295392112727, 9.003750751352285],
            [-13.323290050837148, 9.01253461224186],
            [-13.326763937222378, 9.016217018831277],
            [-13.333405970565668, 9.018403079598656],
            [-13.338551212792698, 9.02189463259353],
            [-13.342932850000397, 9.02301576887669],
            [-13.345092075711742, 9.026678948529614],
            [-13.351608564778566, 9.032080674640268],
            [-13.353378959029667, 9.035315053218158],
            [-13.354268987781204, 9.04495279463997],
            [-13.358367139800409, 9.051203137399513],
            [-13.36380149298855, 9.056436192458023],
            [-13.37066941720729, 9.071152396188959],
            [-13.370207741713106, 9.077736315176837],
            [-13.371801965614694, 9.081314434446263],
            [-13.374466036454306, 9.103195024930097],
            [-13.37687587808603, 9.10864096421918],
            [-13.378668329202997, 9.116036200738272],
            [-13.378020514309878, 9.12258211231957],
            [-13.381902888865525, 9.12836313497364],
            [-13.38365871222077, 9.13290326570539],
            [-13.38309240014734, 9.143332296985374],
            [-13.384554182777102, 9.147665623621261],
            [-13.380793986150593, 9.147833900194195],
            [-13.3704461918916, 9.142628275419892],
            [-13.36783189119441, 9.139889935914356],
            [-13.367575762435132, 9.134733339287877],
            [-13.365022442459574, 9.131946608288159],
            [-13.362072476747143, 9.125329346194848],
            [-13.355860870767888, 9.124756262568116],
            [-13.347681682462657, 9.132172449828284],
            [-13.344479286623162, 9.131615131619753],
            [-13.340418182375474, 9.128368811342098],
            [-13.332693030188036, 9.124130830784775],
            [-13.329797030264356, 9.125321345388215],
            [-13.322864871312978, 9.12490388401173],
            [-13.31798037586072, 9.122483004998893],
            [-13.313429602587103, 9.117841691569026],
            [-13.308667132969408, 9.115386985146259],
            [-13.304671672518996, 9.109005435994598],
            [-13.300694467472775, 9.105007102959055],
            [-13.302254079183317, 9.09994377674005],
            [-13.29820589284875, 9.098326901682293],
            [-13.298682576166096, 9.093383093583496],
            [-13.296419858899725, 9.089746203508792],
            [-13.289254328870749, 9.072083521604823],
            [-13.286177193248294, 9.068993276152687],
            [-13.285948463452396, 9.066064883760111],
            [-13.282390522929013, 9.063293470349665],
            [-13.282353317637822, 9.060178778560296],
            [-13.271349216841664, 9.051246206763471],
            [-13.271050985488145, 9.045865125717322],
            [-13.265162736829705, 9.04438999278943],
            [-13.259456185976445, 9.04037667896766],
            [-13.257666728661418, 9.037547914013318],
            [-13.25335165409648, 9.039246037788303],
            [-13.243913503914435, 9.038232949851261],
            [-13.23892130738143, 9.03338362358566],
            [-13.234067467083392, 9.03463123252309],
            [-13.22899365403609, 9.032893495456516],
            [-13.218886182081018, 9.031454466683295],
            [-13.21389910083404, 9.028028777327767],
            [-13.210446714064942, 9.02334183371627],
            [-13.200581559626022, 9.020982644692392],
            [-13.19628071279013, 9.016571074262545],
            [-13.191563296691271, 9.015453117272695],
            [-13.185279666679007, 9.015928567080385],
            [-13.18265724373298, 9.010613286161151],
            [-13.17942379367371, 9.010878569067208],
            [-13.178326960027652, 9.006727757205807],
            [-13.17341672729655, 9.002618542307813],
            [-13.169980512443829, 9.0040376153535],
            [-13.164667406741685, 8.995392715462275],
            [-13.15693568719878, 8.998068729990193],
            [-13.151749625965195, 8.992458353091695],
            [-13.146936200347069, 8.99405152675184],
            [-13.141216965795186, 8.99141102314068],
            [-13.13731652269024, 8.995635710152321],
            [-13.137073357630381, 9.00124838585596],
            [-13.13119069752711, 9.004031384893793],
            [-13.128371182541267, 9.00339740546478],
            [-13.122660688825995, 9.005434337353686],
            [-13.124950070399404, 9.008837898004481],
            [-13.119714431669744, 9.01124270003754],
            [-13.114760105026345, 9.015412228331625],
            [-13.116396671850017, 9.018822370842127],
            [-13.11582912032864, 9.028576497455129],
            [-13.112447651654731, 9.029062501286337],
            [-13.108361026290204, 9.036489376272094],
            [-13.103673857689119, 9.03651558613204],
            [-13.102566463634998, 9.040568236254087],
            [-13.103594224416131, 9.044507370947311],
            [-13.097659912138566, 9.04711342600766],
            [-13.09368250100286, 9.055437346086428],
            [-13.094957591886546, 9.06261864013316],
            [-13.092016792523824, 9.06650566933415],
            [-13.093200923214837, 9.07008701938788],
            [-13.0897741840408, 9.071775007992215],
            [-13.09068389312169, 9.077715965395015],
            [-13.086354041871576, 9.082698762126372],
            [-13.082599206961103, 9.084347745582559],
            [-13.080891669120133, 9.087886925429515],
            [-13.07387770703716, 9.092439715100046],
            [-13.067880067958574, 9.089569277832668],
            [-13.06101506898785, 9.098497542361484],
            [-13.05659477380153, 9.099951904794315],
            [-13.054648005008994, 9.098348307466448],
            [-13.048924952972472, 9.0999524234901],
            [-13.041728150836452, 9.109208843120026],
            [-13.041853375167015, 9.111333807989215],
            [-13.035246572228413, 9.11551430683964],
            [-13.030590174111543, 9.116667299451914],
            [-13.02857957760084, 9.119281223507844],
            [-13.022693903037986, 9.121641830077222],
            [-13.02040721262633, 9.132419099056024],
            [-13.017655340860184, 9.135098704359224],
            [-13.008661646776, 9.134943291593299],
            [-13.00829442315075, 9.143611025290252],
            [-13.010005194621757, 9.145784787779974],
            [-13.006630167539871, 9.150203367015532],
            [-13.006117855662039, 9.15371045812859],
            [-13.003045469175367, 9.15915607795542],
            [-12.999310455269157, 9.162488111207745],
            [-12.999151642062573, 9.168510027874381],
            [-12.99741203085426, 9.169148905472206],
            [-12.928051351131739, 9.170496937132173],
            [-12.85868705109737, 9.171829671051539],
            [-12.789319137210247, 9.173147096622888],
            [-12.7199476161543, 9.174449203394854],
            [-12.650572494838402, 9.175735981071169],
            [-12.581193780396461, 9.177007419509385],
            [-12.511811480187516, 9.178263508719915],
            [-12.442425601795758, 9.179504238864757],
            [-12.354441151807386, 9.181053716098418],
            [-12.266450978853925, 9.182578465015979],
            [-12.266290854054565, 9.182875549369992],
            [-12.262284644672441, 9.183490587563304],
            [-12.258890940489907, 9.180878231988462],
            [-12.247771681135818, 9.188831393408645],
            [-12.243867831228217, 9.185572709113124],
            [-12.2379204894593, 9.188180160305343],
            [-12.232107293939885, 9.187132854707963],
            [-12.227962605459341, 9.191305139913906],
            [-12.222261453465435, 9.186559225013756],
            [-12.220048377898586, 9.182405429116832],
            [-12.215642332146945, 9.179404766783604],
            [-12.207132517161694, 9.176961026032632],
            [-12.20178480631098, 9.177884399112648],
            [-12.200327303169125, 9.173895521997377],
            [-12.194019314033598, 9.168128753126105],
            [-12.189953412141696, 9.166093664434321],
            [-12.18056518775168, 9.164145751871555],
            [-12.168827807748372, 9.172003893906453],
            [-12.169644321815241, 9.174499612859675],
            [-12.168004194513216, 9.179198463339718],
            [-12.165193226458571, 9.178867430032481],
            [-12.155503069980258, 9.183324880957061],
            [-12.146170845137062, 9.186432105600588],
            [-12.139261033821162, 9.181209660638189],
            [-12.136247496415745, 9.185065120329751],
            [-12.13276303388129, 9.182690266854582],
            [-12.125151912917039, 9.186570416518878],
            [-12.117634422243317, 9.183059431949768],
            [-12.11359090682314, 9.186625170624254],
            [-12.099683230704365, 9.185506039070459],
            [-12.097278156916488, 9.179861517202832],
            [-12.091800070441883, 9.177297757533191],
            [-12.087254676309682, 9.17683489947439],
            [-12.084163241196121, 9.17437809605724],
            [-12.080216574104128, 9.166655074099323],
            [-12.07885476397248, 9.160256937965762],
            [-12.08105195505896, 9.155171989627584],
            [-12.080040507672301, 9.151479494318933],
            [-12.082066102022434, 9.147816808559995],
            [-12.083548973495105, 9.140259885628172],
            [-12.088694883837501, 9.131727307363322],
            [-12.086731912170146, 9.125453521099143],
            [-12.093171485131993, 9.118771858046422],
            [-12.094209073394817, 9.115056358560581],
            [-12.099515548204538, 9.11014352604583],
            [-12.105242940065152, 9.107416899247632],
            [-12.103262409054913, 9.104577879021589],
            [-12.100458909152696, 9.09572665067382],
            [-12.09814442098025, 9.093496235416694],
            [-12.10000779252977, 9.089123044904522],
            [-12.107259423810929, 9.082035195584293],
            [-12.111047793037272, 9.073925990222438],
            [-12.114685433585086, 9.07181561649985],
            [-12.114620153004381, 9.0606169253452],
            [-12.11927216050074, 9.05401461217107],
            [-12.120412119818468, 9.049943204178328],
            [-12.117637381298191, 9.042656186098647],
            [-12.11822056135098, 9.03822721596504],
            [-12.121673425559763, 9.035908074534582],
            [-12.12304559306693, 9.032162949648017],
            [-12.12641304485442, 9.029261509532775],
            [-12.132212610223617, 9.027553324918639],
            [-12.13806276224237, 9.028726914806631],
            [-12.143599762529549, 9.026572531021307],
            [-12.148114336729085, 9.030555095160738],
            [-12.159995853201256, 9.030185497403707],
            [-12.162159306569704, 9.028611621927979],
            [-12.163912182941544, 9.022780871453433],
            [-12.163527424416866, 9.017552485292647],
            [-12.165294242045638, 9.008031996303615],
            [-12.16296163468786, 9.001841976751258],
            [-12.16271333146453, 8.997829739729836],
            [-12.155508922503772, 8.993243103539013],
            [-12.154311899605958, 8.98746560128001],
            [-12.15991742168419, 8.974295903779383],
            [-12.15530087080069, 8.96968110355914],
            [-12.15268580900441, 8.969176417671383],
            [-12.151482756907225, 8.962618310764885],
            [-12.160525785734892, 8.961728230544773],
            [-12.164127737636194, 8.956072046493379],
            [-12.164942242897931, 8.947780245100798],
            [-12.16734553247693, 8.940310472197064],
            [-12.173280335514752, 8.939524583187248],
            [-12.178058713917617, 8.936214090003535],
            [-12.180180215050225, 8.933096935423263],
            [-12.18640824470531, 8.932117756653746],
            [-12.187464384953897, 8.929038194111495],
            [-12.191988064187802, 8.926574435468336],
            [-12.1971613241061, 8.92209203343545],
            [-12.195795237861537, 8.909887763385264],
            [-12.193468426596782, 8.899095402087863],
            [-12.199135938618065, 8.881699922209242],
            [-12.201721435556472, 8.870906893389785],
            [-12.207466752540979, 8.867219722240717],
            [-12.20952451140946, 8.860938076321432],
            [-12.217601890386042, 8.849943394031897],
            [-12.21996043557088, 8.844929065242816],
            [-12.219739467269465, 8.831190815323751],
            [-12.218469537794931, 8.826310771489707],
            [-12.220552640020514, 8.82246295330656],
            [-12.227428097032698, 8.816749896916324],
            [-12.232169004808267, 8.814757429919691],
            [-12.24090114875177, 8.8136762898774],
            [-12.2481205604755, 8.817362592194664],
            [-12.25344549862711, 8.811185072451206],
            [-12.253513822175819, 8.804732670837627],
            [-12.252289126902072, 8.79717840031325],
            [-12.25422501300172, 8.792276619389442],
            [-12.245501840338399, 8.784146828419697],
            [-12.244749453102376, 8.776252786193325],
            [-12.24546971622394, 8.762894276719512],
            [-12.249972804134416, 8.759737523815708],
            [-12.24969580308669, 8.753186214563977],
            [-12.246888123378936, 8.746492914075779],
            [-12.24815236878806, 8.743657452378967],
            [-12.254337880475024, 8.71874399116821],
            [-12.254998012794688, 8.712885039527922],
            [-12.262243369726086, 8.71662265461452],
            [-12.267025671952021, 8.715362634842657],
            [-12.277327906948917, 8.709846788537984],
            [-12.279650371105912, 8.711012727564032],
            [-12.284812415773613, 8.718272042486197],
            [-12.288446087488524, 8.71945740643673],
            [-12.297582462526702, 8.717844173138994],
            [-12.303272812253828, 8.720455005216909],
            [-12.305050378715407, 8.708183539315788],
            [-12.310201667807576, 8.7065123810831],
            [-12.314930734135752, 8.702706528724844],
            [-12.312618837890172, 8.692004178045204],
            [-12.310750540070469, 8.690636977117837],
            [-12.314566227755176, 8.681205035532866],
            [-12.304833410324374, 8.672723953645034],
            [-12.298825206859481, 8.67086002769885],
            [-12.295819382519769, 8.666062163620603],
            [-12.285944581739113, 8.663828708592654],
            [-12.284494956226425, 8.65626761850773],
            [-12.282661874075028, 8.654989627872514],
            [-12.278891132470822, 8.646977962722671],
            [-12.279242008492146, 8.642652613105055],
            [-12.283977710603288, 8.628470865868435],
            [-12.290241261647704, 8.628396796777842],
            [-12.291950402893065, 8.620206535438072],
            [-12.28960760001037, 8.616611837600317],
            [-12.291932419971696, 8.61334079958506],
            [-12.301248986975136, 8.608591581888305],
            [-12.310143377222202, 8.60740125566267],
            [-12.310164797036876, 8.6051787908557],
            [-12.315452532617456, 8.597988635910417],
            [-12.321445198360552, 8.596041608891616],
            [-12.323621285139165, 8.58935963957055],
            [-12.319278840025666, 8.585116715311125],
            [-12.312040088875069, 8.583085158256232],
            [-12.305537907061218, 8.584389738484953],
            [-12.303634441687109, 8.570122284393598],
            [-12.30409049102296, 8.566631534546895],
            [-12.312259481808596, 8.563340290536358],
            [-12.315671523120253, 8.559415740608689],
            [-12.315113856462128, 8.552484480363642],
            [-12.312427098936586, 8.547970590114852],
            [-12.308531432889396, 8.54655284812359],
            [-12.300802608581535, 8.55035156862359],
            [-12.296209759052903, 8.549310179873137],
            [-12.295288650564617, 8.543959086051531],
            [-12.291394552729827, 8.538294595509642],
            [-12.284938448061029, 8.537444486652841],
            [-12.279116461958306, 8.535158230041318],
            [-12.268733875592275, 8.524348811971791],
            [-12.268735633503026, 8.518676832889856],
            [-12.266408918756317, 8.515957947245859],
            [-12.264924543715484, 8.50952955417953],
            [-12.266259195452637, 8.503813740499712],
            [-12.273093783365601, 8.5002738092869],
            [-12.27527205726319, 8.497371738294428],
            [-12.28428828236767, 8.492859697328523],
            [-12.290196493730217, 8.486410791449059],
            [-12.281638416171324, 8.470380259139214],
            [-12.283121258143346, 8.467585368693843],
            [-12.282464477843908, 8.460182905274284],
            [-12.277946486998326, 8.451269974133126],
            [-12.272160521080579, 8.447415435319801],
            [-12.272719524065302, 8.439656314072394],
            [-12.269450510444166, 8.438161802474125],
            [-12.269338815289217, 8.433746163754739],
            [-12.271266440058394, 8.42852037157611],
            [-12.273997684430425, 8.426337103660922],
            [-12.278946684276914, 8.418722289669624],
            [-12.283755924574644, 8.42055726541216],
            [-12.291407820663485, 8.402371003891343],
            [-12.29901789823385, 8.406715489189843],
            [-12.309097280151601, 8.41609096778472],
            [-12.315396204784111, 8.415900485341075],
            [-12.323284209614709, 8.410920427149904],
            [-12.326399189196243, 8.41198179475252],
            [-12.329326712624162, 8.409512841036278],
            [-12.332914885037653, 8.409567747545617],
            [-12.337174172658125, 8.40546871026734],
            [-12.34363686110571, 8.411793206177741],
            [-12.34864834927765, 8.410907546333048],
            [-12.352870544322203, 8.412664523297067],
            [-12.357214628795784, 8.40864352489287],
            [-12.360919479573184, 8.409035925995251],
            [-12.366061109361608, 8.404270283440079],
            [-12.368635890089076, 8.398428372614351],
            [-12.366249563412227, 8.394061885159246],
            [-12.367964589915935, 8.391875033506185],
            [-12.379878545761606, 8.386289842218279],
            [-12.38266519743623, 8.383048031132189],
            [-12.382684792848774, 8.377357225440878],
            [-12.388407033277854, 8.373070783397605],
            [-12.39185587554503, 8.368436817512219],
            [-12.3945430828382, 8.36761397682113],
            [-12.39570112845275, 8.359908053933195],
            [-12.402097425131657, 8.358450312217578],
            [-12.409314383176401, 8.352879803392845],
            [-12.414027763744167, 8.346648105624471],
            [-12.409651039431598, 8.336701807288618],
            [-12.405425959131982, 8.335491185633963],
            [-12.40159221462451, 8.32923550786627],
            [-12.404615826826271, 8.324000268269222],
            [-12.406249396568262, 8.31456813198414],
            [-12.399590372883337, 8.30939969486458],
            [-12.395606760924816, 8.297008419413443],
            [-12.391232786336722, 8.294796276904536],
            [-12.387840293513124, 8.295227480166496],
            [-12.381357072431214, 8.28820344525805],
            [-12.379208253593157, 8.277737405315236],
            [-12.378927907184375, 8.268976202506252],
            [-12.384849495789291, 8.260706653274113],
            [-12.395857492827057, 8.254110463304137],
            [-12.395306444880747, 8.252757736996408],
            [-12.386723703368537, 8.249568222282267],
            [-12.386140160808326, 8.245870227226447],
            [-12.389192420287255, 8.24116755298698],
            [-12.388267787524999, 8.237074134127901],
            [-12.397251922291224, 8.225923279773912],
            [-12.408294486325149, 8.220563382640153],
            [-12.411168788819102, 8.223742812153631],
            [-12.419916236630739, 8.223762709896421],
            [-12.420328179664079, 8.219620927549725],
            [-12.42294414009364, 8.215973608037583],
            [-12.425261868679671, 8.2174626566526],
            [-12.435102352418193, 8.216968969638613],
            [-12.438650495776665, 8.214670351552972],
            [-12.439346956666332, 8.209438206023638],
            [-12.437347841847778, 8.205108325222191],
            [-12.434960316633223, 8.195035100412705],
            [-12.42959613763551, 8.192232554163585],
            [-12.42696848083826, 8.182278832065037],
            [-12.431373500727673, 8.176792794586806],
            [-12.434457916614384, 8.175975946359097],
            [-12.43675073865043, 8.17165028895161],
            [-12.44088232346015, 8.168329024085446],
            [-12.441252433251096, 8.165554707879812],
            [-12.445112000023459, 8.16212978271172],
            [-12.443160041094483, 8.159605959011932],
            [-12.442913347611936, 8.153956660926395],
            [-12.445782719429454, 8.15124661006875],
            [-12.448783427673565, 8.144458115682825],
            [-12.454239581209256, 8.142047817020497],
            [-12.454814756018042, 8.137323573874685],
            [-12.460916045530489, 8.130241074786662],
            [-12.466275813911695, 8.126275532121868],
            [-12.46969783855608, 8.12741961566796],
            [-12.47258306034386, 8.125508091820224],
            [-12.474412741774124, 8.121092897292115],
            [-12.480342542099965, 8.118472885875027],
            [-12.497472379581993, 8.1162128366701],
            [-12.50837824163568, 8.108852086696725],
            [-12.508985969900221, 8.106153634356742],
            [-12.513661130267138, 8.10115126897642],
            [-12.514302031448445, 8.097704229977955],
            [-12.521571748160023, 8.089563243429728],
            [-12.522284876649987, 8.086608656112862],
            [-12.526899491643265, 8.085046645939624],
            [-12.527639113023278, 8.079294885339024],
            [-12.541238937830473, 8.067015437718773],
            [-12.550621396290849, 8.071513612955313],
            [-12.548939538266305, 8.075511178055661],
            [-12.548640080638958, 8.081418667291684],
            [-12.554151765453739, 8.089197782335855],
            [-12.563912668214682, 8.092919811358096],
            [-12.568595167636333, 8.09147991191434],
            [-12.573725090682458, 8.09162386559284],
            [-12.581891416584568, 8.094673287805477],
            [-12.58431383163992, 8.09426676402266],
            [-12.597551358310296, 8.108344607577413],
            [-12.599622725369056, 8.114543648074354],
            [-12.602971938802591, 8.119731780099821],
            [-12.607313345331944, 8.12275934217982],
            [-12.610270922650303, 8.122008738968375],
            [-12.617062595205114, 8.123560017639162],
            [-12.621684924343958, 8.120256536955717],
            [-12.624526037422354, 8.112989275863226],
            [-12.626877820713585, 8.109659435171167],
            [-12.624113997176373, 8.106381956138572],
            [-12.625064178234187, 8.102527550063646],
            [-12.62851349422257, 8.096552563506897],
            [-12.628393725063578, 8.093392467034986],
            [-12.631304108054955, 8.089799458433422],
            [-12.629991670045209, 8.081652402364071],
            [-12.627624104921958, 8.078893489801851],
            [-12.628071338463302, 8.069410720525799],
            [-12.631332753344003, 8.067468207597866],
            [-12.63593131447063, 8.055122959539844],
            [-12.635432867065877, 8.050302380566542],
            [-12.620507578978907, 8.045428411622408],
            [-12.61738263955692, 8.03942717621149],
            [-12.621185472162779, 8.032321623890546],
            [-12.617442214643704, 8.022207953266062],
            [-12.612133629603374, 8.018177237224396],
            [-12.610708213176999, 8.013590184474126],
            [-12.60710040038267, 8.011817716486894],
            [-12.606807741176105, 8.00816997862661],
            [-12.603066641526777, 8.002516876451203],
            [-12.5961383658423, 8.003164226850737],
            [-12.591483886461573, 8.001204021867192],
            [-12.587228586283683, 7.991100946379259],
            [-12.586968473195249, 7.983052463729103],
            [-12.582696634736665, 7.980734258298547],
            [-12.582867943214417, 7.975656740316122],
            [-12.581381788134067, 7.971491457085076],
            [-12.576454418158129, 7.971516226462341],
            [-12.572498369501492, 7.965799270653759],
            [-12.568139385210413, 7.965143849681907],
            [-12.568202021551205, 7.962491396511423],
            [-12.5717061152069, 7.955786652164231],
            [-12.570975332152468, 7.949120578469866],
            [-12.568897157110552, 7.94279795819284],
            [-12.564867371166974, 7.939112494225212],
            [-12.5656214272304, 7.93584332041973],
            [-12.561471748630339, 7.931691953190442],
            [-12.559366307245954, 7.925770227102553],
            [-12.55684097241335, 7.923334258666465],
            [-12.553408245365143, 7.915719762338154],
            [-12.548146066758585, 7.912896173397078],
            [-12.545250750251355, 7.904221834906395],
            [-12.539062415414087, 7.895687302787265],
            [-12.532546442836965, 7.888053925588284],
            [-12.526536656999202, 7.889723071233322],
            [-12.524916868386967, 7.888161358222577],
            [-12.53494051525083, 7.878786874608076],
            [-12.537817343436728, 7.874364421732376],
            [-12.54319347925414, 7.873330102258541],
            [-12.550493048184162, 7.87031984056504],
            [-12.563584689610654, 7.859639536199502],
            [-12.56597661964437, 7.859796010020047],
            [-12.571572271600893, 7.856749991404175],
            [-12.573663302740917, 7.8526491300849655],
            [-12.580104677470253, 7.849668968938586],
            [-12.581184893061321, 7.84452795927736],
            [-12.585895728551472, 7.8385709206389595],
            [-12.592397339328228, 7.8378936641368755],
            [-12.599392078983799, 7.830298935148053],
            [-12.600081160633607, 7.826192199359638],
            [-12.603230701783597, 7.823662577931109],
            [-12.603544060801926, 7.818069280256352],
            [-12.605587130229434, 7.8135975759788705],
            [-12.610975180846586, 7.806215065978297],
            [-12.613940050922697, 7.8043809404966495],
            [-12.688763298288153, 7.819436618324568],
            [-12.763589681929053, 7.834476628668703],
            [-12.838419179083559, 7.849500967464561],
            [-12.91325176697075, 7.864509630737529],
            [-12.98808742279272, 7.879502614603347],
            [-13.062926123736696, 7.894479915268418],
            [-13.13776784697709, 7.90944152903023],
            [-13.212612569677642, 7.924387452277799],
            [-13.32938727015839, 7.94868779988827],
            [-13.446169767471549, 7.972949813150261],
            [-13.446373163285282, 7.972139439447035],
            [-13.498220840406454, 7.983143511488964],
            [-13.49627143475433, 7.986377950057826],
            [-13.491263142223474, 7.987290218962395],
            [-13.489122441448025, 7.989566190965885],
            [-13.49223507532456, 8.006573545797975],
            [-13.504296909540997, 8.002216600219835],
            [-13.50647714650019, 7.995449103835727],
            [-13.518188980159763, 7.989216687521858],
            [-13.525498298265529, 7.9809406578700415],
            [-13.534429943001058, 7.977349410142145],
            [-13.536955613096277, 7.975102058651728],
            [-13.541584695932508, 7.979101286571966],
            [-13.548065972281274, 7.977461516159699],
            [-13.55166319387455, 7.97320258776367],
            [-13.551751839418705, 7.969344091653092],
            [-13.55574057232487, 7.965052505349761],
            [-13.565149854278888, 7.966907798659223],
            [-13.573352007597524, 7.962458916370805],
            [-13.575521120278212, 7.9583939060522155],
            [-13.579910628601002, 7.957446565227432],
            [-13.581619700225069, 7.959686248157709],
            [-13.588006722378076, 7.9623807915083695],
            [-13.594371410768238, 7.962937086001307],
            [-13.5962312336007, 7.966948057044527],
            [-13.601576603670486, 7.968983510494534],
            [-13.606874665831805, 7.9673350424223495],
            [-13.609958145537187, 7.964735797084848],
            [-13.611049762379869, 7.958511475856962],
            [-13.614269540639903, 7.954592612610763],
            [-13.617269659874948, 7.9539143424510295],
            [-13.621104825702036, 7.950228037241102],
            [-13.621375421979025, 7.9427513686676114],
            [-13.623008948455386, 7.937423580779746],
            [-13.626592662965452, 7.933166243573674],
            [-13.629721865337947, 7.931862580107397],
            [-13.632406953712058, 7.928116587679596],
            [-13.632751559134256, 7.922849398525152],
            [-13.636133225061888, 7.923907938598754],
            [-13.743021993248766, 7.947605071087341],
            [-13.740694139385, 7.949603605368748],
            [-13.741757172731736, 7.954054202048719],
            [-13.740409653815536, 7.957564800469229],
            [-13.725853801970441, 7.964144665998177],
            [-13.722069150707876, 7.9719419934584845],
            [-13.724356812166633, 7.978298693060613],
            [-13.722919483472342, 7.981640537935288],
            [-13.728079977929553, 7.98395748746065],
            [-13.73028175670941, 7.988372813464262],
            [-13.728890450737321, 7.99031449019974],
            [-13.728937446527015, 8.00833191498551],
            [-13.724428336357034, 8.02042138014947],
            [-13.724961373364824, 8.02863537398152],
            [-13.727301906306035, 8.031481714800748],
            [-13.727954574725239, 8.035880988035485],
            [-13.726579209482207, 8.039924513490835],
            [-13.72770889934506, 8.043447617282663],
            [-13.726742133294815, 8.048163848732386],
            [-13.728311423076446, 8.057591370038821],
            [-13.729902755703879, 8.06232282098437],
            [-13.728875421738934, 8.065191406918206],
            [-13.731084470179814, 8.069097444336553],
            [-13.730594059867427, 8.07348357810627],
            [-13.733127857587244, 8.078043462178655],
            [-13.731615535531356, 8.083075471469055],
            [-13.732772578015378, 8.093672512016541],
            [-13.735545466801522, 8.101186233311585],
            [-13.735471941200164, 8.107307790678812],
            [-13.792394606213717, 8.119533081640693],
            [-13.882227309244518, 8.138993066655893],
            [-13.972064853481882, 8.158430093641854],
            [-13.967168877982814, 8.160479937136481],
            [-13.961475748449777, 8.164944148657124],
            [-13.957157565477868, 8.17676888435919],
            [-13.955491876740068, 8.185619185284262],
            [-13.953378123223663, 8.201707679549342],
            [-13.951243446510253, 8.208511146874848],
            [-13.930768640997073, 8.234022724017533],
            [-13.89716432743, 8.274461818729176],
            [-13.879218191480714, 8.285307127678086],
            [-13.872633607551753, 8.298655074804895],
            [-13.866395335256811, 8.31306862056091],
            [-13.86042451282563, 8.317913339875341],
            [-13.84610472528521, 8.326130630510672],
            [-13.839240480395665, 8.327435462498173],
            [-13.837225534133806, 8.336998074379016],
            [-13.838044246078729, 8.345672835059773],
            [-13.831023221518105, 8.3590826099876],
            [-13.830548709131365, 8.362195662192406],
            [-13.832483051407038, 8.366779394463956],
            [-13.831151484923403, 8.369543946508838],
            [-13.820716423281482, 8.375339978829093],
            [-13.812664073734382, 8.384616725162799],
            [-13.799945583800232, 8.403660807112994],
            [-13.802418548675224, 8.40751900238096],
            [-13.799958544952585, 8.410877647878028],
            [-13.793544074826448, 8.41258036522388],
            [-13.78866537538221, 8.411541446896136],
            [-13.783410635898168, 8.414598153391129],
            [-13.7813788663746, 8.41988353332801],
            [-13.771157000962855, 8.425657907352253],
            [-13.76562177175301, 8.426999222414384],
            [-13.76472525623222, 8.432481599538487],
            [-13.761792065487645, 8.437239342606636],
            [-13.754321719965496, 8.44139757789003],
            [-13.7468923560538, 8.449040202517155],
            [-13.744026226977699, 8.461578827877482],
            [-13.747309085145156, 8.467166669892496],
            [-13.74849215764793, 8.471754663073003],
            [-13.74677563108317, 8.47420197628256],
            [-13.749031883482562, 8.478770089329265],
            [-13.75341227942352, 8.481636290016246],
            [-13.751848583616502, 8.487695161063291],
            [-13.75455937832842, 8.492721073070536],
            [-13.753430787322273, 8.498009518314063],
            [-13.76574254001655, 8.52137778221304],
            [-13.77209994408209, 8.530260226333603],
            [-13.774222240217444, 8.534600471912993],
            [-13.776887508981199, 8.545562163641216],
            [-13.77370418341096, 8.568340725605347],
            [-13.767988205532392, 8.586628302531372],
            [-13.771866324470855, 8.604405898567027],
            [-13.773153860778583, 8.60646893084139],
            [-13.779692222965837, 8.610371659745361],
            [-13.7975612746453, 8.63787941793278],
            [-13.805233235236962, 8.642055126566273],
            [-13.822778395934463, 8.649885031607017],
            [-13.828761763617583, 8.647441985789202],
            [-13.833643055654555, 8.647030970693185],
            [-13.842655527238886, 8.6492015179706],
            [-13.846123279393197, 8.651963902402517],
            [-13.853705675477741, 8.665347464081533],
            [-13.855638846564883, 8.678646615727674],
            [-13.86004409952791, 8.694310623829683],
            [-13.868234104980791, 8.701580008618738],
            [-13.870647818362823, 8.702620208389787],
            [-13.884899952986276, 8.70514113421436],
            [-13.896570231429424, 8.69996910113408],
            [-13.903082192492048, 8.699000006046955],
            [-13.905453241193761, 8.699938101560393],
            [-13.916673538506462, 8.711300036512494],
            [-13.91910215676766, 8.718461788709066],
            [-13.916061817700877, 8.730275777896727],
            [-13.918022522871455, 8.742717096677485],
            [-13.91533134084663, 8.741190461060155],
            [-13.907451317621554, 8.744674655224287],
            [-13.898881968268677, 8.744748409848858],
            [-13.893987985404811, 8.747967826823908],
            [-13.885082821210958, 8.748782611897497],
            [-13.879432395113334, 8.753915088195228],
            [-13.876362286060823, 8.759856873034035],
            [-13.872335579823055, 8.762721050453047],
            [-13.866083236973, 8.770148607590663],
            [-13.865834554386325, 8.774363204258378],
            [-13.863736003019193, 8.778976325263022],
            [-13.866651126413236, 8.78061389463648],
            [-13.868291204877401, 8.789463396995055],
            [-13.872103608153056, 8.794745653943476],
            [-13.872453745721925, 8.801976571484827],
            [-13.874314754305047, 8.80877625650164],
            [-13.873383188850042, 8.812756471105802],
            [-13.874449765786714, 8.818129118213678],
            [-13.869236903560301, 8.828388182593683],
            [-13.866196283820159, 8.83209153685764],
            [-13.864083298471622, 8.837431552760167],
            [-13.861489219020852, 8.838442855245818],
            [-13.857728005269552, 8.843511459924224],
            [-13.852648115603518, 8.843028210784949],
            [-13.84447770979733, 8.850871997546136],
            [-13.838642149058979, 8.858195118899957],
            [-13.83438861828808, 8.860715440976628],
            [-13.824704174602612, 8.86404488486682]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.46753770898322,
          "lat": 45.844083804048225
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16049"],
        "coty_name": ["Idaho"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Idaho County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00395699"
      },
      "bbox": [
        -13.972064853481882, 7.8043809404966495, -12.07885476397248,
        9.191305139913906
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.96008214046162, 9.327536700287045],
            [-13.934624825991362, 9.438656021291399],
            [-13.85759565569282, 9.422025962159092],
            [-13.780570377519014, 9.405377111452363],
            [-13.742284752159629, 9.396849646948597],
            [-13.718506076541198, 9.392223625456078],
            [-13.713392921085097, 9.398411598256434],
            [-13.710835250491632, 9.404495944693428],
            [-13.707459344923508, 9.408586294293716],
            [-13.707179725685359, 9.411450222047838],
            [-13.703286644246527, 9.416254402330265],
            [-13.702625753819385, 9.420112574307451],
            [-13.6985566083156, 9.424145950929976],
            [-13.697446996618027, 9.428424597406895],
            [-13.693534885658975, 9.431864761568757],
            [-13.687686080382246, 9.431504803551725],
            [-13.674665063446705, 9.442972119476016],
            [-13.668385457840902, 9.44547591119695],
            [-13.662912128892877, 9.449800938504064],
            [-13.652879516086946, 9.44805408430583],
            [-13.651842789248478, 9.451508240229884],
            [-13.645792536282558, 9.456288362621146],
            [-13.637667344638876, 9.460326414041493],
            [-13.633808349003747, 9.461185474705472],
            [-13.63004107137404, 9.460024189362391],
            [-13.627233783837044, 9.461321600446745],
            [-13.62301180848405, 9.45928681234533],
            [-13.619324510180212, 9.455598809562735],
            [-13.607836402530161, 9.454325698086475],
            [-13.522942638638678, 9.43658113702022],
            [-13.538227635957796, 9.366933672389907],
            [-13.53532289436413, 9.366228665436514],
            [-13.549315946221913, 9.30306994227756],
            [-13.544553074975816, 9.309705154413663],
            [-13.54041559154137, 9.30989876540931],
            [-13.53147979329581, 9.305812899814464],
            [-13.515746999030526, 9.302738863371866],
            [-13.505612622399765, 9.303970786266238],
            [-13.495263919047757, 9.299847314072968],
            [-13.49178076230866, 9.300413148388573],
            [-13.498771794583682, 9.268108789752192],
            [-13.502667777481648, 9.270973254362495],
            [-13.509485444389986, 9.272862646972316],
            [-13.519592442013648, 9.273407733232107],
            [-13.526294212879275, 9.275536910030219],
            [-13.529156021090113, 9.273103059314],
            [-13.527917989571632, 9.269888277856104],
            [-13.529242079832693, 9.261068378414453],
            [-13.526917787101965, 9.248629027941233],
            [-13.522786555342153, 9.241090413953422],
            [-13.508698810476636, 9.219322747830963],
            [-13.512836844120095, 9.212158969509854],
            [-13.512170045465847, 9.203672296846808],
            [-13.510578846356943, 9.199751600938985],
            [-13.512108778779389, 9.193125843715158],
            [-13.51069924426976, 9.190542843931274],
            [-13.514386000279819, 9.174981261645243],
            [-13.51548549603046, 9.165064389196742],
            [-13.5183501740935, 9.163269116323841],
            [-13.518381564100947, 9.156954869881407],
            [-13.524793955913948, 9.149062239027904],
            [-13.534125661432867, 9.150518847081813],
            [-13.537453569140775, 9.149313409957834],
            [-13.543820088567092, 9.152999315613163],
            [-13.546473239465843, 9.157362186938403],
            [-13.555292170650224, 9.157861937866295],
            [-13.557720070841876, 9.15891710783613],
            [-13.560916192833004, 9.156410361770329],
            [-13.568181250866097, 9.158955896278623],
            [-13.57266496487134, 9.163618032039224],
            [-13.582959576670632, 9.168920549190378],
            [-13.59080127531685, 9.171111506070554],
            [-13.603803457227091, 9.167523444976474],
            [-13.609384096595866, 9.162815185504606],
            [-13.608892084383461, 9.158523910575212],
            [-13.610279221344664, 9.149714706724128],
            [-13.649442565018619, 9.15830593832198],
            [-13.712866848536724, 9.17165633341626],
            [-13.761605349979572, 9.182554586318053],
            [-13.76114662001897, 9.178312715654007],
            [-13.762488872961347, 9.171914433114413],
            [-13.765477615814204, 9.166310620021227],
            [-13.765507193745139, 9.15503884727627],
            [-13.761584203063345, 9.148426092524957],
            [-13.760384952161708, 9.142677940451323],
            [-13.761194506222509, 9.138705325041643],
            [-13.760143646809077, 9.13157991205169],
            [-13.759267775306075, 9.116768867943652],
            [-13.757596762390664, 9.109977618206313],
            [-13.759047605268517, 9.09869133017026],
            [-13.767761705741385, 9.095428880859854],
            [-13.77311912255291, 9.096555110939258],
            [-13.785378941480616, 9.042519396714933],
            [-13.797953384287554, 8.986133304375803],
            [-13.811832943937013, 8.929370873860867],
            [-13.810013740678995, 8.928865009292762],
            [-13.824704174602612, 8.86404488486682],
            [-13.83438861828808, 8.860715440976628],
            [-13.838642149058979, 8.858195118899957],
            [-13.84447770979733, 8.850871997546136],
            [-13.852648115603518, 8.843028210784949],
            [-13.857728005269552, 8.843511459924224],
            [-13.861489219020852, 8.838442855245818],
            [-13.864083298471622, 8.837431552760167],
            [-13.866196283820159, 8.83209153685764],
            [-13.869236903560301, 8.828388182593683],
            [-13.874449765786714, 8.818129118213678],
            [-13.873383188850042, 8.812756471105802],
            [-13.874314754305047, 8.80877625650164],
            [-13.872453745721925, 8.801976571484827],
            [-13.872103608153056, 8.794745653943476],
            [-13.868291204877401, 8.789463396995055],
            [-13.866651126413236, 8.78061389463648],
            [-13.863736003019193, 8.778976325263022],
            [-13.865834554386325, 8.774363204258378],
            [-13.866083236973, 8.770148607590663],
            [-13.872335579823055, 8.762721050453047],
            [-13.876362286060823, 8.759856873034035],
            [-13.879432395113334, 8.753915088195228],
            [-13.885082821210958, 8.748782611897497],
            [-13.893987985404811, 8.747967826823908],
            [-13.898881968268677, 8.744748409848858],
            [-13.907451317621554, 8.744674655224287],
            [-13.91533134084663, 8.741190461060155],
            [-13.918022522871455, 8.742717096677485],
            [-13.918602926967448, 8.745203822099333],
            [-13.926773543944876, 8.766296836292694],
            [-13.935640589007793, 8.777203036160893],
            [-13.94357961964589, 8.784886117876542],
            [-13.950314928980598, 8.798391412130805],
            [-13.953847394517096, 8.81211417749285],
            [-13.954473936957145, 8.819170547061232],
            [-13.953164432010078, 8.827587560391825],
            [-13.95397160985453, 8.840506618219184],
            [-13.95211186532841, 8.849603070865866],
            [-13.954294921846895, 8.85422818077242],
            [-13.961035802617598, 8.85723452037858],
            [-13.961470515056861, 8.86711373538501],
            [-13.95879784323947, 8.873284504154256],
            [-13.962583556522114, 8.88061914998469],
            [-13.968661673721197, 8.888139952036452],
            [-13.970354314944897, 8.895086305804204],
            [-13.97120851603345, 8.899785939173215],
            [-13.969915344904903, 8.9133049572181],
            [-13.970128585761405, 8.918165774001952],
            [-13.973619595924614, 8.924284932728968],
            [-13.971085036047139, 8.934939208890414],
            [-13.971374955633136, 8.94002977269084],
            [-13.975204932004292, 8.946218596574578],
            [-13.976133358107118, 8.95600441014711],
            [-13.974144947053112, 8.962219629658938],
            [-13.976638462364798, 8.969778039177221],
            [-13.9809701372165, 8.978332514809768],
            [-13.989249939139633, 8.981500214968618],
            [-13.994595997618463, 8.985957139029011],
            [-13.995573205519115, 8.991133699147548],
            [-13.994530474067915, 8.997402479390384],
            [-13.991081234011949, 9.001068122232711],
            [-13.987419744355021, 9.00225349945627],
            [-13.97728996751204, 9.001375003851859],
            [-13.973691582405774, 9.003790553295348],
            [-13.969033978374384, 9.011776417294193],
            [-13.965678521098882, 9.023463923979076],
            [-13.953227224369513, 9.033054702033645],
            [-13.951245201462715, 9.035885388414718],
            [-13.951508165621116, 9.03950739189667],
            [-13.948198644126334, 9.0506758300337],
            [-13.938832929597472, 9.05518613465552],
            [-13.937008759056733, 9.058874610173739],
            [-13.937502156952592, 9.06516978341726],
            [-13.939489744133008, 9.067891566049731],
            [-13.943422843743068, 9.069203357001792],
            [-13.946304798444773, 9.075817551284583],
            [-13.946452753503637, 9.081402896266573],
            [-13.951839864764258, 9.091158657662254],
            [-13.957634110227652, 9.098668068211607],
            [-13.95876375133359, 9.102692057217494],
            [-13.957641290319437, 9.10853894727516],
            [-13.947201585432278, 9.122912465009886],
            [-13.945612486448248, 9.127512361434965],
            [-13.945508100223726, 9.13903967327902],
            [-13.946887427641926, 9.150412160568195],
            [-13.949153578332062, 9.158940829010634],
            [-13.952001832035267, 9.164394106478264],
            [-13.958168070788432, 9.172680409529978],
            [-13.959938220999668, 9.176582729273452],
            [-13.958895175063336, 9.180419723641473],
            [-13.952804187151685, 9.18852422673952],
            [-13.951966692670105, 9.191333512603629],
            [-13.953994269611407, 9.198535444904344],
            [-13.958217796188903, 9.203262720090528],
            [-13.964656328903333, 9.20686157573741],
            [-13.971481468393481, 9.217955481316054],
            [-13.971840911431435, 9.223467336776485],
            [-13.969754275991859, 9.231900851922136],
            [-13.968993796103009, 9.238782457356452],
            [-13.972654482037806, 9.24397402025545],
            [-13.982168806392101, 9.248282297750041],
            [-13.988600784908217, 9.252780800447358],
            [-13.991555411514323, 9.26049299228858],
            [-13.988861338690782, 9.272775577966085],
            [-13.983966262896221, 9.27785168032792],
            [-13.975019909818236, 9.284118174641936],
            [-13.96891374179547, 9.295457189346187],
            [-13.963399795376947, 9.308235463856228],
            [-13.960684017677869, 9.31163933601966],
            [-13.958293010687129, 9.319487179020676],
            [-13.96008214046162, 9.327536700287045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.75024490367147,
          "lat": 46.326814171817674
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16069"],
        "coty_name": ["Nez Perce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nez Perce County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00399394"
      },
      "bbox": [
        -13.995573205519115, 8.741190461060155, -13.49178076230866,
        9.461321600446745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.772617951469767, -0.00873051100010608],
            [5.767458267849816, 0.09427286026152332],
            [5.7653100802504715, 0.1382970776967275],
            [5.7621423083799295, 0.19174105866430272],
            [5.759860246601178, 0.22647820971342567],
            [5.753656117725374, 0.3149920795474152],
            [5.836485068830488, 0.3196729210988071],
            [5.92079213599902, 0.32744170498667563],
            [6.007944592517666, 0.3340812228311462],
            [6.0943366236484895, 0.342544914829724],
            [6.099854340947074, 0.253380086110837],
            [6.101589794879496, 0.22387269254303868],
            [6.102921215187349, 0.20734334433143223],
            [6.107097153739915, 0.1445526190870435],
            [6.108869734320075, 0.12062739397855614],
            [6.115099678758643, 0.03377632312942504],
            [6.118645310781721, -0.011441131902142016],
            [6.092647164025453, -0.012910937791386915],
            [6.0322978916052685, -0.017166302092787196],
            [5.945733182898017, -0.022464538646485555],
            [5.860345838512068, -0.03182851748843439],
            [5.831731130798032, -0.03364271766770883],
            [5.774340242883035, -0.03817964114618495],
            [5.772617951469767, -0.00873051100010608]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.91900735249074, "lat": 38.64959754984434 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17121"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00424259"
      },
      "bbox": [
        5.753656117725374, -0.03817964114618495, 6.118645310781721,
        0.342544914829724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.820069925478878, 1.016956510992062],
            [7.875053424007286, 1.0239096771037304],
            [7.914895921694335, 1.028765820285244],
            [7.9187289360523225, 1.0289897123317302],
            [7.986427640960796, 1.0369567468813081],
            [8.045018579914329, 1.0446520145995313],
            [8.04762249283213, 1.0284664363069418],
            [8.055986411629874, 0.956287186198479],
            [8.056564317490134, 0.9563213089388266],
            [8.060294558940159, 0.9265924404368163],
            [8.07494984586879, 0.8048447823112972],
            [8.077853101214764, 0.7795839598519841],
            [8.07640103542997, 0.7794237437157022],
            [8.079992716694752, 0.7499946990698695],
            [8.009715229388751, 0.7409283618443501],
            [7.954587974870332, 0.7350273557123425],
            [7.954479281931449, 0.7358422825103281],
            [7.898155635569214, 0.7296968521763202],
            [7.883709549878658, 0.7283607471583583],
            [7.858459189417136, 0.7252088751077015],
            [7.857749217507204, 0.7386917710669292],
            [7.854976004016333, 0.7667312594567791],
            [7.8490033753737976, 0.8210384677114129],
            [7.847714292921194, 0.8299270527753669],
            [7.844906687277532, 0.8560214078670952],
            [7.839098772842059, 0.900997405205344],
            [7.835989888835401, 0.9284306637164271],
            [7.8302264764131255, 0.9280227104655328],
            [7.820069925478878, 1.016956510992062]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.2273639784973, "lat": 39.196225932995915 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18013"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00451684"
      },
      "bbox": [
        7.820069925478878, 0.7252088751077015, 8.079992716694752,
        1.0446520145995313
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.510664851885906, 2.5783938882676263],
            [7.571550585422378, 2.5834479885693917],
            [7.5950515857774095, 2.58577703284121],
            [7.679085346449167, 2.5938329212704785],
            [7.726357583647577, 2.5986450202823104],
            [7.763695590571512, 2.602096159033748],
            [7.818348564315462, 2.6085241823063985],
            [7.818763277363278, 2.6081732191376528],
            [7.8239201705803625, 2.5647082996681054],
            [7.82769423421415, 2.528218527890118],
            [7.828841749099663, 2.514947636112428],
            [7.835782189701315, 2.441864181780931],
            [7.838188759910533, 2.4414755867716593],
            [7.8445757334476784, 2.3729823621566095],
            [7.845181462940011, 2.3698962325624393],
            [7.84868487955972, 2.339634431291482],
            [7.849795332881764, 2.3323266470055133],
            [7.85749101592228, 2.260858388086201],
            [7.799689038024497, 2.2541868994919314],
            [7.721495640370671, 2.245542054648246],
            [7.700749083889394, 2.2434626857885545],
            [7.6978665044083385, 2.27496065214852],
            [7.692458458641104, 2.33120210812675],
            [7.692051567323197, 2.3334258679837294],
            [7.688049868393048, 2.3749817662139234],
            [7.61748636614232, 2.367340217912901],
            [7.5746318971892865, 2.3635144488184854],
            [7.570328671214561, 2.4066588095240973],
            [7.527986536013801, 2.40276420828121],
            [7.526282051845171, 2.4211524928786026],
            [7.520101763383389, 2.4921460208015502],
            [7.510664851885906, 2.5783938882676263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.34599487740253, "lat": 40.7615214527042 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18017"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00450339"
      },
      "bbox": [
        7.510664851885906, 2.2434626857885545, 7.85749101592228,
        2.6085241823063985
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.674100019117443, 4.046497038396159],
            [3.719695050365098, 4.048879921733255],
            [3.7214316065894644, 4.049132016302727],
            [3.761047340906968, 4.050611270277584],
            [3.817244466358924, 4.05365994313893],
            [3.8492187019033666, 4.055783229979618],
            [3.9341633791876136, 4.060593714396835],
            [4.020328564567127, 4.065214857003915],
            [4.023596361131949, 3.9777525470900588],
            [4.028275241160976, 3.8901370640076016],
            [4.03069462284485, 3.890253752132821],
            [4.034416763347687, 3.8217001938287867],
            [4.040335922998037, 3.7142479615840154],
            [3.961694513246318, 3.7105091674624515],
            [3.945199877481182, 3.7099732649312673],
            [3.9092304817293684, 3.7080047582571685],
            [3.9078183159278144, 3.7082670824632493],
            [3.8691852926823143, 3.7063871794374674],
            [3.80471032090088, 3.7030402823662443],
            [3.7547561050860505, 3.7006785321657993],
            [3.697659225694054, 3.6982037797502487],
            [3.6929453162848613, 3.786054516812326],
            [3.6892980598883907, 3.8715959694230393],
            [3.681161875812436, 3.8712533245671006],
            [3.679768265259835, 3.900485300715169],
            [3.6767150523755703, 3.9586636552463252],
            [3.674100019117443, 4.046497038396159]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.36733277347464, "lat": 42.4712128111335 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19055"],
        "coty_name": ["Delaware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delaware County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00465216"
      },
      "bbox": [
        3.674100019117443, 3.6982037797502487, 4.040335922998037,
        4.065214857003915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.6720208991020584, 2.2915650433235593],
            [3.6711024949242366, 2.3167248421008004],
            [3.6674381248633297, 2.394098175545321],
            [3.6660449364260823, 2.4324584153587634],
            [3.6645679111618463, 2.47919947857366],
            [3.6629697830454826, 2.518713280780483],
            [3.661731357439187, 2.555022400120106],
            [3.747628994546584, 2.5597071901679906],
            [3.793406772648456, 2.561006413359417],
            [3.8335631421553313, 2.5625671213962673],
            [3.919710685133465, 2.5655426054385564],
            [3.923680563326486, 2.477867566323523],
            [3.928079064612501, 2.3757143598356834],
            [3.93140932446899, 2.3023174138255174],
            [3.932574196188454, 2.280419251029083],
            [3.935479919844087, 2.2146802746038716],
            [3.9074634157207986, 2.2135979850097334],
            [3.8422107249760415, 2.2108534671835898],
            [3.762373055466204, 2.2077316298911454],
            [3.740583656023861, 2.206738035523951],
            [3.675541753099908, 2.203418554563913],
            [3.6720208991020584, 2.2915650433235593]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.54454247271649,
          "lat": 40.987985684987805
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19087"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00465232"
      },
      "bbox": [
        3.661731357439187, 2.203418554563913, 3.935479919844087,
        2.5655426054385564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.6018692183073369, 3.982968691350924],
            [1.6454151262229524, 3.983532352961207],
            [1.6883364870971713, 3.984364241927885],
            [1.785072804202409, 3.985375593225101],
            [1.7886829113404212, 3.9858226667650714],
            [1.859864315994028, 3.987281643220805],
            [1.9464104498458665, 3.988993287075587],
            [1.948365127990015, 3.9021127910947393],
            [1.9495266428636073, 3.8517256619220066],
            [1.9502016125998463, 3.8157223179660402],
            [1.9794492765749678, 3.8162800411742164],
            [1.9812204732060097, 3.7276085787927906],
            [1.9829557039300887, 3.6571033599847045],
            [1.9833253534473603, 3.632976522685196],
            [1.9852670494174494, 3.5530445775321],
            [1.9498179242040705, 3.5522211212573613],
            [1.8997748644669088, 3.5512777006372604],
            [1.8138037822533457, 3.5495416587094897],
            [1.7135493504139523, 3.5473694158432876],
            [1.656426518260857, 3.5458256861374364],
            [1.6425676763459836, 3.545687559806595],
            [1.6413931894142224, 3.610375083785643],
            [1.63971483086075, 3.7333824022403217],
            [1.6379785459950011, 3.8109945891564876],
            [1.6047375372110972, 3.8105216261172172],
            [1.6033351986212192, 3.896326115716277],
            [1.6028083278461513, 3.9244890954849843],
            [1.6023315592995608, 3.9327595625386795],
            [1.6018692183073369, 3.982968691350924]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.18173698422133,
          "lat": 42.427910717466894
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19187"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Webster County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "00465282"
      },
      "bbox": [
        1.6018692183073369, 3.545687559806595, 1.9852670494174494,
        3.988993287075587
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.2704641620939188, 4.85391182841372],
            [2.334511456201394, 4.855555379039472],
            [2.4410657382694523, 4.858377036883898],
            [2.4929289298868564, 4.86007553387714],
            [2.593902083266283, 4.863275625136803],
            [2.611834002136658, 4.863806269746852],
            [2.613958965035254, 4.793432977141322],
            [2.614702461539715, 4.775482709550255],
            [2.6169667506456453, 4.70633730855867],
            [2.6196608186625796, 4.619431354644233],
            [2.5346312718409663, 4.616396211248374],
            [2.490552032861899, 4.615039395894233],
            [2.4054391329004985, 4.612739345507939],
            [2.372742780441889, 4.612333992292344],
            [2.3673037998310145, 4.611796997502488],
            [2.337854108069502, 4.611136916679618],
            [2.27671842975938, 4.609507064081666],
            [2.274510822403474, 4.697169354539956],
            [2.272540551461695, 4.762531119352927],
            [2.2704641620939188, 4.85391182841372]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.26084502685606,
          "lat": 43.377397036540316
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19195"],
        "coty_name": ["Worth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Worth County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "00465286"
      },
      "bbox": [
        2.2704641620939188, 4.609507064081666, 2.6196608186625796,
        4.863806269746852
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9411102313235524, 4.252879745268438],
            [2.027658748963176, 4.2555709203371],
            [2.0993860819075967, 4.2572627305183515],
            [2.113741827730461, 4.257024740855879],
            [2.120624457692491, 4.257752574308249],
            [2.14915946159732, 4.258323440286322],
            [2.2635581410141, 4.2613460293907615],
            [2.2851870191090238, 4.261811121278876],
            [2.2874599766486354, 4.172716042210295],
            [2.288765986027806, 4.124116746183103],
            [2.291197808893626, 4.0191139475995215],
            [2.2924546908937664, 3.96087912400625],
            [2.2938392827723795, 3.9098854698548973],
            [2.243677538726396, 3.9084309172087655],
            [2.1215331664184287, 3.905467373859929],
            [2.0347150892962946, 3.9033604570957596],
            [2.005488424108025, 3.9031518408759784],
            [1.948365127990015, 3.9021127910947393],
            [1.9464104498458665, 3.988993287075587],
            [1.9452154451013899, 4.0435123117751415],
            [1.9449000968715522, 4.072517654741969],
            [1.9438483592170979, 4.112587016802984],
            [1.943462186727402, 4.134485031087514],
            [1.9413267242230088, 4.236844768700926],
            [1.9411102313235524, 4.252879745268438]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.7351705103206, "lat": 42.73309316370658 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19197"],
        "coty_name": ["Wright"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wright County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "00465287"
      },
      "bbox": [
        1.9411102313235524, 3.9021127910947393, 2.2938392827723795,
        4.261811121278876
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.233027387542904, -0.29392876350903857],
            [-4.009930363433913, -0.307702852192278],
            [-3.862761027647233, -0.3158333696136635],
            [-3.8432199488776435, -0.31691403390997125],
            [-3.847889150679777, -0.4044793056283552],
            [-3.8533968896454582, -0.5066549891392823],
            [-3.862121080592316, -0.6490941105439977],
            [-3.8692044867528326, -0.7560178318337651],
            [-3.8568706716985246, -0.75670447525713],
            [-3.862307181384222, -0.8487441049197114],
            [-3.8839258594995982, -0.8475623823880658],
            [-3.9899662497619404, -0.840531100562497],
            [-4.018665249577387, -0.8388367711392368],
            [-4.023502171064035, -0.8389160689058774],
            [-4.037814002089687, -0.8374717870451369],
            [-4.100574831714889, -0.8330238171832282],
            [-4.1102376520641375, -0.8320734909558686],
            [-4.130672094034409, -0.8310676096013764],
            [-4.223120394029836, -0.8247861384209388],
            [-4.223513871670044, -0.82500311594642],
            [-4.264679190840023, -0.8219749070736424],
            [-4.263423296503944, -0.8001770765158012],
            [-4.2612616564715315, -0.7564329882277453],
            [-4.2573375088297825, -0.6915296136018942],
            [-4.253963696632358, -0.6308610846471108],
            [-4.2470506188801975, -0.5124830493818544],
            [-4.242417330665691, -0.4445005205287958],
            [-4.241906755819321, -0.43238895224121565],
            [-4.240568073376113, -0.41551071517525706],
            [-4.233735993570824, -0.30642703614386174],
            [-4.233027387542904, -0.29392876350903857]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.7912333891463, "lat": 37.99912981024026 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20075"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00485327"
      },
      "bbox": [
        -4.264679190840023, -0.8487441049197114, -3.8432199488776435,
        -0.29392876350903857
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4664354447384997, -0.9531981400530446],
            [-1.380876205414425, -0.9554719885181089],
            [-1.3096203621816416, -0.9572645457655118],
            [-1.2805387323334714, -0.9576205282805351],
            [-1.2520056322149344, -0.9584140504266562],
            [-1.1238929850925656, -0.9606733495959027],
            [-1.0382770042218907, -0.9618494558017288],
            [-1.002188847070273, -0.9629759457624493],
            [-0.9520076173890444, -0.9635696517587251],
            [-0.9522554799305486, -0.9784502540527398],
            [-0.9526736436867802, -1.0441588714942873],
            [-0.9540914531317494, -1.0514541794898804],
            [-0.9550487249423245, -1.1102880035702245],
            [-0.9552325213961316, -1.137232943769491],
            [-0.9568197404601764, -1.2256958797453181],
            [-0.9580803799116691, -1.3144174914324067],
            [-1.0274158072058464, -1.313737711045174],
            [-1.1300498222394628, -1.3120279273523385],
            [-1.2161780918726197, -1.311068859562555],
            [-1.3028150899612498, -1.3091594440103216],
            [-1.3604121074508868, -1.3077878518439632],
            [-1.3851010072664982, -1.3073391013830502],
            [-1.4756787910208433, -1.3050146488302667],
            [-1.473176249446173, -1.2172934242604319],
            [-1.4710085525071601, -1.129560607238468],
            [-1.4699987613848906, -1.0854960105393767],
            [-1.4664354447384997, -0.9531981400530446]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.13634819590091,
          "lat": 37.558896050385606
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20095"],
        "coty_name": ["Kingman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kingman County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00485012"
      },
      "bbox": [
        -1.4756787910208433, -1.3144174914324067, -0.9520076173890444,
        -0.9531981400530446
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.2821599042098261, 1.3116842188856839],
            [0.3465628395031638, 1.3113532004945987],
            [0.39558803434974044, 1.3113144627904254],
            [0.42450195409419456, 1.3115027978094382],
            [0.4556344911736761, 1.3114027947412705],
            [0.5529151905848424, 1.311287943345694],
            [0.6245830104186828, 1.3113939468161748],
            [0.6246879745131143, 1.1928585812416919],
            [0.6244433036418029, 1.0784299813209048],
            [0.6245989535015457, 1.0416200722893312],
            [0.6247319889660998, 0.960794516605539],
            [0.624668033404416, 0.8874832790543792],
            [0.6248072273473296, 0.8729306656747821],
            [0.5365648073342866, 0.872822826159432],
            [0.43628333459181773, 0.8729156331545943],
            [0.3658454875016139, 0.87310866477259],
            [0.2812387000137848, 0.8732609616558975],
            [0.28089820037748053, 0.9611097304557678],
            [0.2811790718175558, 1.048900064168314],
            [0.2813789111624815, 1.121810038541937],
            [0.2818809936266291, 1.2413738649614083],
            [0.2821599042098261, 1.3116842188856839]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.01406649093762, "lat": 39.78340502691597 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20131"],
        "coty_name": ["Nemaha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nemaha County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00485029"
      },
      "bbox": [
        0.28089820037748053, 0.872822826159432, 0.6248072273473296,
        1.3116842188856839
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5055132135146906, 0.038040720400936014],
            [0.5051515597786199, 0.08343653474969286],
            [0.5049267970489213, 0.1701717184133523],
            [0.5451697343822116, 0.17016903427199945],
            [0.5762512620747199, 0.1696679570456801],
            [0.6193994914831198, 0.16923397673280616],
            [0.7049600988296447, 0.1706389050945735],
            [0.786589668451304, 0.17057238649531734],
            [0.8167394263508189, 0.17039839810836116],
            [0.8487306006300872, 0.1710118149368648],
            [0.8490371866642183, 0.15243992937436612],
            [0.8491913662747319, 0.10445709271025208],
            [0.8491780766934772, 0.03965550304425819],
            [0.8494146610689427, 0.03873485260853703],
            [0.8492707488807077, -0.0052352886860482645],
            [0.8440000103590155, -0.005257711292224388],
            [0.8434380715580475, -0.041917752620310555],
            [0.8439060109606135, -0.07438929042732212],
            [0.8438765757526078, -0.09384362058772959],
            [0.8448397572001497, -0.22635398882971025],
            [0.8451913801697317, -0.2691409868046255],
            [0.7741366041721343, -0.2692754388108671],
            [0.7167348675045676, -0.26913123277059403],
            [0.7027531082141123, -0.26961007184307484],
            [0.6872956176817823, -0.2695404169491891],
            [0.6022790400978593, -0.2701611726396776],
            [0.5023078125091002, -0.269943978489327],
            [0.5025274408979306, -0.22591864358064975],
            [0.5024422688838406, -0.18481794880965344],
            [0.5026456634392598, -0.13864829637954426],
            [0.5027700553567414, -0.06227528847050529],
            [0.5026552155762872, -0.006113404989784139],
            [0.5057416341940282, -0.006133919457953998],
            [0.5055132135146906, 0.038040720400936014]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.72691538650308,
          "lat": 38.652324445881895
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20139"],
        "coty_name": ["Osage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osage County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00485033"
      },
      "bbox": [
        0.5023078125091002, -0.2701611726396776, 0.8494146610689427,
        0.1710118149368648
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.860822283093587, 0.9120918046315628],
            [-1.7759506601764041, 0.9093324635149933],
            [-1.7264879577656933, 0.9078881763322181],
            [-1.7060313574130928, 0.9071150457005493],
            [-1.6058045454672913, 0.903913608600827],
            [-1.5420303390533974, 0.9022600946849093],
            [-1.5206470254236901, 0.9014389589000815],
            [-1.4492829754138474, 0.8996386563802308],
            [-1.4356343273006935, 0.8991680664643313],
            [-1.4387991521963914, 0.8111487272439781],
            [-1.440517622839754, 0.7692634300904836],
            [-1.4420156297681734, 0.7238076918203321],
            [-1.444559945971245, 0.6362187091046464],
            [-1.4469407034090602, 0.54836013142484],
            [-1.4470015035449948, 0.5417632294877106],
            [-1.4491271492838524, 0.4604729025015944],
            [-1.4865489619356207, 0.46190038788206866],
            [-1.5706239469064542, 0.4645788371452429],
            [-1.5719108476426722, 0.4643763628345839],
            [-1.6429515547904716, 0.4662395680549768],
            [-1.7559223597036842, 0.469694579924817],
            [-1.7914021779189573, 0.4708528593924078],
            [-1.869586306172871, 0.4731306087274863],
            [-1.8774124730879802, 0.4732731427381153],
            [-1.8749304586588476, 0.5607226280516608],
            [-1.873074648231717, 0.6050295239417552],
            [-1.872513245785288, 0.6487798667923987],
            [-1.8705361471326414, 0.6638257754606366],
            [-1.868723143030108, 0.707123307521832],
            [-1.8671345485738635, 0.7363878544597362],
            [-1.8656883188473203, 0.7875701984113075],
            [-1.8636684619402502, 0.8238499926105098],
            [-1.8622356771228992, 0.8677486613975398],
            [-1.8611396274228917, 0.8957502197955483],
            [-1.860822283093587, 0.9120918046315628]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.7679532706696, "lat": 39.35032961994588 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20141"],
        "coty_name": ["Osborne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osborne County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00485034"
      },
      "bbox": [
        -1.8774124730879802, 0.4604729025015944, -1.4356343273006935,
        0.9120918046315628
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.066421639366471, -1.4204914367405588],
            [10.06439500141113, -1.41815140149917],
            [10.065770374447792, -1.4125433979307411],
            [10.069480143687672, -1.407789839971603],
            [10.067125407782404, -1.403796698354276],
            [10.067972228362432, -1.397587756930644],
            [10.072242337991277, -1.3918136149045583],
            [10.077193087068409, -1.3948882573762018],
            [10.081288271300153, -1.4000049260728245],
            [10.088429183113531, -1.3964385794628924],
            [10.092973649132897, -1.3898330318598235],
            [10.093996151651755, -1.3847965507369204],
            [10.097111933558216, -1.3836853759986039],
            [10.09906455576003, -1.3796281069465028],
            [10.09620787577749, -1.3773040808142603],
            [10.098165610761177, -1.370833287525568],
            [10.095885429914741, -1.3684717006935507],
            [10.097492207995305, -1.3595089831309708],
            [10.104891953816784, -1.3582965603335564],
            [10.112400008401195, -1.3526638356680722],
            [10.111905136434283, -1.34711606814425],
            [10.109733001139096, -1.3441282915079942],
            [10.111083705707166, -1.3389877610876724],
            [10.117386159946932, -1.3342301471908948],
            [10.117382922204815, -1.3301464452117655],
            [10.11935899935172, -1.3268453526058075],
            [10.116198982509113, -1.3144226289353242],
            [10.121257898357944, -1.3015901206181193],
            [10.123701787072422, -1.2976980332157817],
            [10.127336706124394, -1.2951775452256789],
            [10.132597045238017, -1.2990541238191162],
            [10.138051467970902, -1.2934408513063478],
            [10.140841198988147, -1.294068128933962],
            [10.148361324505093, -1.2897529873752325],
            [10.150255948260934, -1.2950790792261568],
            [10.155713710044177, -1.2943606465518547],
            [10.157602808481407, -1.2976109689969855],
            [10.160911486028922, -1.2921070444922138],
            [10.160450747693213, -1.2849574554568597],
            [10.1643736982302, -1.2802936765023243],
            [10.168136224765624, -1.2779691291694566],
            [10.172159371654333, -1.2710616444408158],
            [10.177293802041818, -1.270524881952173],
            [10.180347604100414, -1.2659230635734826],
            [10.181664503300073, -1.2602022741718237],
            [10.17962162574836, -1.2565184323719905],
            [10.182255175540233, -1.254020076313851],
            [10.18793875727498, -1.2548666326995144],
            [10.196416190223546, -1.2528631865555708],
            [10.192956615662117, -1.249796737729283],
            [10.194483810059504, -1.2452411239743932],
            [10.194014269097496, -1.240809092734738],
            [10.196606315454805, -1.238981215564005],
            [10.197901832609531, -1.2332045496612436],
            [10.210005039473497, -1.2293503726678816],
            [10.212048460339979, -1.2215201238116968],
            [10.220838394481907, -1.2219371387369662],
            [10.228179631763721, -1.2173791503862235],
            [10.226444826853886, -1.2126929586506017],
            [10.228482335534082, -1.2085194133885846],
            [10.226257205159728, -1.205661557740193],
            [10.231472766621094, -1.1961521409797427],
            [10.234461191184012, -1.1942636087632816],
            [10.238768170355899, -1.1972407024296023],
            [10.243276435329586, -1.1971350015360134],
            [10.244775672887693, -1.1922667156922366],
            [10.249857430555581, -1.183942820903687],
            [10.254170084295584, -1.1825822629325078],
            [10.257156177864209, -1.178217967953932],
            [10.259538112517033, -1.1798174587790509],
            [10.264939441752716, -1.1730272834310091],
            [10.271296801204548, -1.1726127718162365],
            [10.271369589885346, -1.1685846225923728],
            [10.275388751869503, -1.1637669580972492],
            [10.275512787503974, -1.16097517219152],
            [10.273130510808702, -1.1542651099713028],
            [10.275476130598594, -1.1494452836723092],
            [10.278748534556444, -1.1474113232260414],
            [10.278912247202522, -1.1433517182500192],
            [10.275961213243555, -1.1412473630099114],
            [10.275555612928034, -1.1365560182216656],
            [10.272610336612768, -1.1359862099693794],
            [10.268860814969061, -1.1391670121120552],
            [10.264345584499106, -1.1362801903453237],
            [10.260380735885935, -1.128482603957522],
            [10.25753706223978, -1.1265183055643777],
            [10.257959247521036, -1.1223179700789565],
            [10.305682622871053, -1.1290169196890345],
            [10.314381289969218, -1.1334569573890263],
            [10.323361336148805, -1.1312942151316072],
            [10.322806059581412, -1.1418149044844128],
            [10.325050563940664, -1.1464812644723033],
            [10.331279429236178, -1.1454246466768938],
            [10.333337539341006, -1.1490035320465397],
            [10.337500994315796, -1.1486574247348977],
            [10.34117852213154, -1.152084984791521],
            [10.342395630424326, -1.1564806554203932],
            [10.33590356198332, -1.1595340618136667],
            [10.335564496094069, -1.1626102600893184],
            [10.332085287972063, -1.163472565817846],
            [10.332604888596563, -1.171157803231043],
            [10.33627121953269, -1.1734762192398784],
            [10.344194984798525, -1.1724217201160991],
            [10.341682919017238, -1.1748354969778514],
            [10.341788805586082, -1.1815266718078345],
            [10.340131568880192, -1.1849625625448643],
            [10.34308352341312, -1.1932698398607826],
            [10.345238158690469, -1.2047708376914084],
            [10.351134268071474, -1.2139162332345932],
            [10.356694178711901, -1.217890388134274],
            [10.338633246345255, -1.2628120127597975],
            [10.343042611320271, -1.2656870116499308],
            [10.354796513021869, -1.2794836511096441],
            [10.355478700445484, -1.2822554871796261],
            [10.362197071359384, -1.2842018960365564],
            [10.361561611929705, -1.3110690561242313],
            [10.360567967163485, -1.316067332714838],
            [10.357723981011683, -1.3203940006151955],
            [10.358087206265894, -1.3234288897046262],
            [10.356965106706523, -1.3358417336643096],
            [10.361361012506277, -1.3403906702042898],
            [10.36426617111782, -1.3460336388162457],
            [10.367756230009041, -1.3489845503709508],
            [10.369778787828412, -1.35528784923116],
            [10.373402692340168, -1.3583073810433024],
            [10.376363816796863, -1.357073222585161],
            [10.394332991605912, -1.3674098020067351],
            [10.397425314330203, -1.4000981612564456],
            [10.393142334722535, -1.400847694891485],
            [10.380243196758203, -1.4010451305124703],
            [10.370825495254412, -1.3983211731412335],
            [10.36505081858704, -1.400103057544544],
            [10.35693824898652, -1.4011753159356328],
            [10.353749756088378, -1.4031235814037388],
            [10.341568617186576, -1.4073792417924398],
            [10.34103272610082, -1.410605799207225],
            [10.334878774830875, -1.4168126166623818],
            [10.33082285323137, -1.4194848456242215],
            [10.325557886465017, -1.4208908291914275],
            [10.319190538111643, -1.4242738247500553],
            [10.317450444273513, -1.4280676664264218],
            [10.310557942985954, -1.4326019623542894],
            [10.308858655517305, -1.4353029714860113],
            [10.295610833994528, -1.4380993177160157],
            [10.289249642215069, -1.442865987485493],
            [10.28708249517074, -1.442234043951211],
            [10.280567184868245, -1.446955934490406],
            [10.277098137671121, -1.4535175766521837],
            [10.27344540079677, -1.4568458432518918],
            [10.265864387053316, -1.4601788603226777],
            [10.261831999578382, -1.4587722770529048],
            [10.255405881092678, -1.4617495983258124],
            [10.25524566185446, -1.4678774442895206],
            [10.24942120679455, -1.4736263638454783],
            [10.24397674024497, -1.4804436605875748],
            [10.238206827003072, -1.4823157614472104],
            [10.236917153213385, -1.486451159722707],
            [10.234543812597874, -1.4935815167170696],
            [10.23203156845394, -1.4958425805519433],
            [10.227210902968636, -1.506241698774407],
            [10.14950207560028, -1.5149952555041868],
            [10.066016700615357, -1.5230843089475943],
            [10.037191810386462, -1.5255343917339652],
            [10.038342729451864, -1.5192742376544035],
            [10.037754982913857, -1.5153447851819248],
            [10.040047861825183, -1.5099304280366683],
            [10.033055550829152, -1.4987728399885627],
            [10.031893034147098, -1.4944771418699665],
            [10.02631927690145, -1.4899841800547722],
            [10.024208650615487, -1.486111487435043],
            [10.016982053812196, -1.4829315677816768],
            [10.012740399454513, -1.4789181130979607],
            [10.00972036687071, -1.4702346934649062],
            [10.012229369332662, -1.4666695741661042],
            [10.017854100105525, -1.4622229064626318],
            [10.022364263270978, -1.4603709272255014],
            [10.025273798349232, -1.457007481282357],
            [10.032124400281543, -1.4518903030379744],
            [10.038726711919534, -1.4503693206965573],
            [10.047851623302067, -1.4417974634336541],
            [10.066434671421302, -1.427535243894855],
            [10.066421639366471, -1.4204914367405588]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.67410010128383, "lat": 36.73064727749305 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21013"],
        "coty_name": ["Bell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bell County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00516853"
      },
      "bbox": [
        10.00972036687071, -1.5255343917339652, 10.397425314330203,
        -1.1223179700789565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.693093297756991, -0.9475120229602856],
            [6.699683641454918, -0.9449716144292396],
            [6.702838809893143, -0.9335648796457682],
            [6.706663044565294, -0.9341539600758647],
            [6.7102157092620915, -0.9380130162756598],
            [6.7137195321285255, -0.9373834073336896],
            [6.716100623876219, -0.9341538151939656],
            [6.716343758709052, -0.930163556552352],
            [6.72265630153608, -0.9215065948946569],
            [6.723053108966073, -0.9178873453131754],
            [6.7199118302546745, -0.9122768393496516],
            [6.72171509442468, -0.9057538552759826],
            [6.724986292103244, -0.9023708923006998],
            [6.734725105633042, -0.902397421231448],
            [6.737297866555278, -0.9041542792161583],
            [6.739214289564297, -0.9099252700532932],
            [6.73968492153092, -0.9224034012383765],
            [6.740955243263842, -0.9306100051995204],
            [6.74052415458133, -0.9341046152607078],
            [6.743439981537634, -0.9423121595985287],
            [6.748049581311778, -0.9454096197338848],
            [6.7513398467424075, -0.9517928447752247],
            [6.757295579062497, -0.953612832071716],
            [6.759503632743756, -0.9466452886738429],
            [6.763557410534463, -0.9476731732955133],
            [6.764697539835354, -0.9519185213904086],
            [6.768477399941892, -0.9578239571604985],
            [6.769099576512027, -0.9620766464502392],
            [6.762265022913122, -0.970719865012985],
            [6.758106073714544, -0.9708679828481596],
            [6.757213681050709, -0.9736336217022141],
            [6.7625949569005215, -0.9768454653053875],
            [6.771801443458363, -0.976191577975516],
            [6.778444382930433, -0.9670510005413269],
            [6.782289738015546, -0.9657276110876454],
            [6.787828576438022, -0.9679525797275355],
            [6.793051049398038, -0.9644505679853168],
            [6.7957556981492875, -0.9644434592613861],
            [6.796422356987679, -0.9680325998023934],
            [6.789767008217759, -0.9757624605441151],
            [6.788407443279422, -0.9800922320521857],
            [6.791563476935764, -0.9905668981696741],
            [6.791126010302194, -0.9924188603742853],
            [6.794773082785627, -0.998963720051955],
            [6.796610268937479, -1.0063230129298488],
            [6.7942921045392275, -1.0118681599299129],
            [6.796203733234531, -1.0195453531429224],
            [6.801512157744938, -1.0281393910997125],
            [6.801651109122414, -1.031803718786546],
            [6.805149815823679, -1.0360130397722356],
            [6.811189337550365, -1.0343274050519307],
            [6.823800927836666, -1.0436816939860134],
            [6.826215465651251, -1.0447908171835736],
            [6.8339610352104865, -1.0391902274520777],
            [6.8431029383242885, -1.0360044917911808],
            [6.846738629503284, -1.0334323913251509],
            [6.851093547172695, -1.0353371177183295],
            [6.856021791370878, -1.029245876307753],
            [6.856553824196934, -1.0245084794172723],
            [6.861269313214297, -1.0253277837228152],
            [6.862170627915969, -1.0215577486012768],
            [6.868160481462744, -1.018341410171614],
            [6.871179767430527, -1.0220642449843553],
            [6.869544578393963, -1.0332868756986757],
            [6.872279653535312, -1.037958299467674],
            [6.8709737555135995, -1.0448630537982722],
            [6.867377322132044, -1.0437028662801404],
            [6.8611954891331415, -1.047376201255365],
            [6.861761358942153, -1.060099581897664],
            [6.871796174949779, -1.0638005151554575],
            [6.8753572343068825, -1.062509308487515],
            [6.877247782965696, -1.0592103667447896],
            [6.880168708764072, -1.0610180704041123],
            [6.88787983659244, -1.0578437459828471],
            [6.8882744684172375, -1.0527662577210268],
            [6.894721552496137, -1.054659487518982],
            [6.902431969999588, -1.0600982824299132],
            [6.907789911633934, -1.056783578276964],
            [6.902398454208085, -1.061803637027142],
            [6.758547687588335, -1.1853702860536963],
            [6.722596249200113, -1.2162057289823895],
            [6.723569219981707, -1.2197985816184453],
            [6.721942305689008, -1.2245078662287594],
            [6.715142024146457, -1.2230055758210157],
            [6.702784432491299, -1.2289266405807757],
            [6.701347993281391, -1.232485838566884],
            [6.694826786306286, -1.2343277105898809],
            [6.695126511791013, -1.2376446717647087],
            [6.7002679920092705, -1.23914954131839],
            [6.702753207966668, -1.2437275951570999],
            [6.701001124589434, -1.2474356567078992],
            [6.696050905648451, -1.2496903525659437],
            [6.697207299059498, -1.256766025857359],
            [6.701867496069763, -1.2640477056081378],
            [6.702659045159455, -1.2721140641788076],
            [6.698934362439092, -1.2771960774749822],
            [6.693440086426791, -1.2773765889129325],
            [6.6888534233038754, -1.2795455860053981],
            [6.690378885425398, -1.2844064783932232],
            [6.689686778608691, -1.2881604849362822],
            [6.68531733134687, -1.2917778834952043],
            [6.683662831326264, -1.2982941944850719],
            [6.676139803969945, -1.3019159084867669],
            [6.674647897737171, -1.3049976542823571],
            [6.670783975396171, -1.305165508139282],
            [6.667280896089519, -1.301025567973738],
            [6.666421978769881, -1.3080071072849715],
            [6.664062547598579, -1.3131175191858502],
            [6.659284265018561, -1.3114228101852328],
            [6.655645788899097, -1.3135119434001479],
            [6.650800226806365, -1.3114606676333165],
            [6.646734612129219, -1.3177153401695643],
            [6.643318076564205, -1.3185385815223278],
            [6.644377153237162, -1.3243259262113227],
            [6.646692215460988, -1.3284769267503391],
            [6.637640109263702, -1.3323341269980968],
            [6.63518933518063, -1.3348072320822315],
            [6.62809195695557, -1.3368245719490006],
            [6.629389268664916, -1.3299394754047287],
            [6.621859965611843, -1.3340277293803724],
            [6.621397390685254, -1.328969027983068],
            [6.618094792861379, -1.3261505299994891],
            [6.620095863841822, -1.319263398402863],
            [6.619268813643268, -1.3163667642169377],
            [6.623566295433516, -1.3086350739829251],
            [6.620557015465591, -1.2969003502227863],
            [6.615348965618121, -1.2903886426775895],
            [6.609061607259003, -1.2870506160699666],
            [6.604806616770791, -1.2862202235824713],
            [6.5952169143825214, -1.2821252280715354],
            [6.59776065224374, -1.2769382264902516],
            [6.596859475984343, -1.2745042609182868],
            [6.601950083670176, -1.2672665903203515],
            [6.601198209073205, -1.2644061212808881],
            [6.605731595885524, -1.2604166306263895],
            [6.60660027725304, -1.253589123423019],
            [6.608826786161529, -1.25342936589542],
            [6.6111389087416965, -1.2438777841035817],
            [6.607491411575716, -1.237255470595975],
            [6.603457835230172, -1.2369387783196846],
            [6.606134388734078, -1.2282902131526139],
            [6.58884226205852, -1.1913526562707852],
            [6.547219027929274, -1.1500105081157659],
            [6.525120383881879, -1.1335198727541045],
            [6.522489961548323, -1.128019754029197],
            [6.522511492499316, -1.122150243375201],
            [6.514050804704158, -1.107400324385936],
            [6.5163390828553425, -1.1024944851086163],
            [6.514008003067364, -1.0991961901903222],
            [6.517069534241063, -1.0910601408290723],
            [6.508227242058915, -1.087629595480098],
            [6.5096874496425094, -1.0827008659199158],
            [6.505358732744982, -1.081733975459726],
            [6.505420437989516, -1.077821151757234],
            [6.501043999605559, -1.0733572793277253],
            [6.496883871282242, -1.076628480956529],
            [6.495735636317608, -1.0727508038008533],
            [6.492824188084525, -1.070940268054654],
            [6.490117732182461, -1.0763573299011195],
            [6.472160648544171, -1.07379375426079],
            [6.468570871276018, -1.0677581704340042],
            [6.476010611734261, -1.0611736936136904],
            [6.486604166660964, -1.0436215803636917],
            [6.488440240470808, -1.0413399467917168],
            [6.49814674294723, -1.0336037544442207],
            [6.501658497692073, -1.0288491432592721],
            [6.512720353749106, -1.0216461526477905],
            [6.524905721451061, -1.0148006863602892],
            [6.545308386102053, -1.0089316530061168],
            [6.55894314750819, -1.0077532288708155],
            [6.568902095473269, -1.0063509819470822],
            [6.582842922214956, -1.0023723816153334],
            [6.597044378654231, -0.9994738298672147],
            [6.607331413431567, -0.9967071116500855],
            [6.60993674662258, -0.994646297079139],
            [6.621344065450426, -0.9923615241215824],
            [6.638122375914613, -0.9862216645484241],
            [6.643802099933592, -0.9868841225542617],
            [6.665639364280288, -0.9819620463991529],
            [6.671256531270693, -0.9814077961703087],
            [6.6742063340834195, -0.9832154536264386],
            [6.679812613342853, -0.9813392985655934],
            [6.685283242938456, -0.9684476933166039],
            [6.68963434061762, -0.9675033446041331],
            [6.692920308372296, -0.9570114640556164],
            [6.693093297756991, -0.9475120229602856]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.09743386281453, "lat": 37.35265632692383 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21055"],
        "coty_name": ["Crittenden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crittenden County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00516874"
      },
      "bbox": [
        6.468570871276018, -1.3368245719490006, 6.907789911633934,
        -0.9023708923006998
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.590047870366442, -0.0505011398383213],
            [10.589806629018886, -0.048063434759774114],
            [10.595104405401925, -0.04387469258272565],
            [10.597045785413961, -0.03877929083764658],
            [10.596901804441659, -0.028151707627250153],
            [10.601230950397417, -0.0241172376949304],
            [10.600466138220574, -0.02153155524564813],
            [10.603840595167746, -0.01803325336044871],
            [10.613521337574964, -0.013528263576096058],
            [10.613618036622858, -0.010196700003736318],
            [10.623418702916917, -0.010202990902087485],
            [10.676155249394094, -0.02467027149436529],
            [10.711248790884106, -0.02972563415180856],
            [10.756001777829237, -0.05270644084002805],
            [10.791939320088009, -0.0709884240903996],
            [10.84147080488869, -0.08848900768650945],
            [10.893261781657149, -0.09447869937721073],
            [10.888240462794004, -0.09744964548639311],
            [10.887617343978501, -0.10095772687771955],
            [10.881641117741623, -0.10113733706919152],
            [10.878570935363742, -0.10669196492695934],
            [10.872696272283996, -0.1061516765947183],
            [10.870877655271991, -0.10893929956670924],
            [10.872369576352707, -0.11349107779273465],
            [10.867605023505423, -0.11823529329843584],
            [10.859787721842238, -0.12063648550036307],
            [10.85556948094475, -0.1262153251824424],
            [10.851887087633894, -0.12805391856509774],
            [10.854965082267512, -0.13502134428771456],
            [10.859609268143267, -0.13979919893308304],
            [10.862337495290289, -0.13930873597853713],
            [10.867761987865126, -0.14421458324360378],
            [10.871148489495031, -0.14256295982809167],
            [10.874337234101697, -0.14699718799711603],
            [10.869690412647088, -0.1498153661487216],
            [10.869854959586398, -0.1535553986562852],
            [10.873720344833117, -0.15261111822459847],
            [10.87614372576815, -0.1543570692316732],
            [10.871089972547162, -0.15948060620731797],
            [10.872416009095806, -0.16219872725407336],
            [10.868848653299214, -0.1648640772118315],
            [10.870404669373123, -0.16879599534490164],
            [10.863307256443198, -0.17262479840362036],
            [10.865058897526016, -0.17886665320248243],
            [10.862036593272661, -0.18573580183309588],
            [10.858903663090567, -0.18667474855021537],
            [10.8582630892169, -0.19354803274196283],
            [10.863347078520183, -0.19458038833428312],
            [10.867562932139737, -0.19738311531240524],
            [10.875698991077739, -0.20024658678959747],
            [10.873159427676464, -0.21025635566174286],
            [10.875742490370634, -0.2161205765846168],
            [10.875238767232299, -0.21939306821383042],
            [10.87750932488438, -0.22195326086335607],
            [10.877596273396012, -0.22562875283520767],
            [10.884527982300352, -0.22944721309751995],
            [10.88823634747383, -0.235648719918568],
            [10.886979362162263, -0.2418763429911807],
            [10.892937641824465, -0.24541481061311812],
            [10.897317990664558, -0.25221957279621227],
            [10.893823267944581, -0.25665493067523226],
            [10.890617175920992, -0.2529882450669471],
            [10.882848975578925, -0.25163393646858073],
            [10.875487748427322, -0.25369493807895344],
            [10.872981079128758, -0.2522560945255372],
            [10.868788580083281, -0.2547428526493274],
            [10.861473755806104, -0.2514489796136511],
            [10.859019612890759, -0.2527629183532085],
            [10.85610791689424, -0.25021504898034613],
            [10.857398440480896, -0.24633731973032705],
            [10.84827399269061, -0.24482208970515912],
            [10.844570320594944, -0.2464778206212089],
            [10.838720289742447, -0.2447133442613508],
            [10.834195596001495, -0.24021461215404855],
            [10.828486386627628, -0.241199265147863],
            [10.825800052375179, -0.2367780801623878],
            [10.815557504927137, -0.2425095475964635],
            [10.813604023181112, -0.23992255956036132],
            [10.807423286786765, -0.24024473972851818],
            [10.802681711297573, -0.2371799940800003],
            [10.800148270561314, -0.2376913842524189],
            [10.79381110121591, -0.233984207171715],
            [10.794255732105468, -0.24096893543830203],
            [10.792866081865515, -0.24869507633935783],
            [10.786118481976523, -0.24950575052492724],
            [10.777787476114028, -0.2465954067773911],
            [10.73365903626683, -0.2696196469603206],
            [10.720642723195704, -0.2732544900166862],
            [10.71683458060559, -0.2703503734641842],
            [10.714096986412008, -0.27272724634111273],
            [10.711251551022704, -0.28314357316300687],
            [10.704905745650043, -0.28774426500434314],
            [10.700701249697628, -0.29543487254410244],
            [10.696307817134038, -0.2963830037132262],
            [10.694176634235754, -0.30194014598563396],
            [10.691855040815843, -0.2985175986230311],
            [10.684798110657898, -0.29613674288600694],
            [10.681784236574066, -0.2938038636054473],
            [10.67600270289606, -0.29176854308528505],
            [10.671746415262799, -0.2885746610040868],
            [10.667815635350559, -0.29217692744700824],
            [10.661616223766178, -0.2930558066903058],
            [10.655312657544592, -0.2903255864097898],
            [10.654897642008619, -0.28634405658294965],
            [10.643161559847957, -0.21568868566826277],
            [10.615684859750166, -0.20326181936759555],
            [10.611705457797855, -0.20029336136515866],
            [10.609624103672653, -0.1967870610498494],
            [10.612921162699168, -0.18814733925924873],
            [10.610231761569992, -0.18446188004129493],
            [10.613570156789459, -0.1783056131920033],
            [10.609291178845462, -0.17553241198311903],
            [10.61071987590818, -0.1724833637616276],
            [10.592369546496762, -0.15692892770593822],
            [10.595367784623393, -0.14762358857471597],
            [10.600327953468883, -0.14357067971733145],
            [10.602896932157869, -0.14493751033148314],
            [10.606240350226644, -0.13807727495128908],
            [10.605716775827487, -0.12985278538397743],
            [10.600694763529214, -0.12290972850525486],
            [10.600338404697206, -0.11747159034526596],
            [10.604557329666704, -0.11485249744700178],
            [10.608897282454727, -0.11978329552957091],
            [10.613613105769534, -0.11469347219650926],
            [10.617324378624495, -0.11855051433335943],
            [10.619116162698486, -0.11446009095172191],
            [10.617541604696479, -0.10855592830376684],
            [10.61963897926612, -0.10432234352170852],
            [10.618258429090314, -0.09868704224665184],
            [10.611828948663376, -0.10132055936211323],
            [10.609263535310735, -0.09870292166298157],
            [10.611723710422448, -0.09239501522878733],
            [10.611522676675035, -0.08825751264816269],
            [10.605191241662526, -0.0822347098097052],
            [10.602648767214621, -0.07399700550406318],
            [10.599052431366271, -0.0731635283665003],
            [10.597987964134646, -0.06363944445346796],
            [10.595086101045679, -0.06279065068192018],
            [10.592382829909505, -0.05845670658192455],
            [10.591747605507265, -0.05184393054117494],
            [10.590047870366442, -0.0505011398383213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.8315502290921, "lat": 37.84663122754563 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21115"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00516904"
      },
      "bbox": [
        10.589806629018886, -0.30194014598563396, 10.897317990664558,
        -0.010196700003736318
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.208972235804206, -1.0894126917827411],
            [9.273984312026819, -1.0220469289266916],
            [9.335864858394794, -0.9503484117319319],
            [9.35785240069902, -0.9249197645119682],
            [9.39615787842814, -0.8798921970248302],
            [9.450202885794269, -0.8172314257019444],
            [9.495314965581022, -0.8391486376993701],
            [9.49758312066135, -0.8405592662464795],
            [9.545686513407638, -0.8836137897178551],
            [9.56248660348924, -0.8962629523501022],
            [9.619303311791336, -0.9406692285891535],
            [9.673998951985594, -0.9849326053515381],
            [9.680951825882277, -0.9871545885596927],
            [9.684441227660892, -0.99605116517311],
            [9.681721152856019, -1.0039280604444814],
            [9.684100079210411, -1.0077668065054606],
            [9.683951529962188, -1.0126701907590325],
            [9.686932062514174, -1.0183061982298456],
            [9.681896603865374, -1.0263535582956826],
            [9.684463696934428, -1.0271904661554478],
            [9.68916615116331, -1.0242532779300588],
            [9.696293649479623, -1.0272156220523045],
            [9.69485846982935, -1.0328359507619014],
            [9.68925843688425, -1.0325204577115654],
            [9.686135994505495, -1.0346811527244955],
            [9.688282936530287, -1.0376553749648927],
            [9.697605466669621, -1.0451291853616071],
            [9.693214995605194, -1.05315206911907],
            [9.69555312057801, -1.0582163425449422],
            [9.690608986042195, -1.0608722648490736],
            [9.684903305829764, -1.0602203694175993],
            [9.68267551465217, -1.0615742389881129],
            [9.682176715191353, -1.069086182108303],
            [9.677749850542638, -1.0723281525147634],
            [9.673646346888797, -1.0732675711482613],
            [9.671404449577286, -1.080266250546457],
            [9.66721411296769, -1.0832076543170348],
            [9.667204453695916, -1.0892876136180545],
            [9.673728580966115, -1.0928509058464946],
            [9.675930873314122, -1.0993107022937905],
            [9.67481219654968, -1.1043151573403698],
            [9.676317889585983, -1.110222166222385],
            [9.681533799286477, -1.1121491831214214],
            [9.684812243727714, -1.1086495911476597],
            [9.687570225214209, -1.110963466832082],
            [9.684751106750562, -1.1177458617617961],
            [9.684008217240605, -1.1244108137576518],
            [9.679133122614383, -1.1274534415317747],
            [9.675615261339807, -1.1223819321752928],
            [9.668995914479934, -1.12357033644695],
            [9.666730488006618, -1.1277944184032642],
            [9.668955025235181, -1.1325783132359573],
            [9.672137672144174, -1.1360853651629264],
            [9.680147998556178, -1.1399990648233953],
            [9.683284396178626, -1.1433507261617468],
            [9.6813875678343, -1.1514620319823954],
            [9.673066112954853, -1.154268422846499],
            [9.668334877582167, -1.160699657558518],
            [9.664375924455026, -1.1627287571967544],
            [9.658726661207853, -1.163552080452503],
            [9.657078034164407, -1.1667190390103117],
            [9.660086226243218, -1.1703792994251283],
            [9.66307717889658, -1.18182556189738],
            [9.659736502555532, -1.1903841161594106],
            [9.654156221731597, -1.1954365274191907],
            [9.649546668157745, -1.1927999334716686],
            [9.645789844665643, -1.1932162456470072],
            [9.635753603250699, -1.2040100230332897],
            [9.63270460366048, -1.2061093386111994],
            [9.624446022689288, -1.2092890876128455],
            [9.609507094918877, -1.213610594861522],
            [9.526200542029912, -1.2815732362098553],
            [9.492391856693038, -1.3089826914624247],
            [9.488713476493153, -1.303511388955844],
            [9.483132844638083, -1.297918647815512],
            [9.48126527955423, -1.2946097754209507],
            [9.48274093905015, -1.290300843619203],
            [9.48606544275983, -1.286992902288362],
            [9.485103031251997, -1.2828743356821781],
            [9.47980592330778, -1.2839962987593696],
            [9.477353263503144, -1.2918737256437263],
            [9.473033730904044, -1.2985820048634489],
            [9.469358294467778, -1.2979663604408818],
            [9.460706549140081, -1.2880153900956393],
            [9.455773604805046, -1.2837195859284192],
            [9.39927680622151, -1.2044931719202974],
            [9.383008293551514, -1.2047503074713126],
            [9.377295499019816, -1.2070661182322504],
            [9.373020799355935, -1.215365561310823],
            [9.360475811777995, -1.2237361308811376],
            [9.34577044809453, -1.2301927890342148],
            [9.330469919876967, -1.2361435746459053],
            [9.317367643300418, -1.2167193951015978],
            [9.274311190431998, -1.2023664896119601],
            [9.251067493393757, -1.194526024882266],
            [9.213439394934065, -1.1591352037687812],
            [9.207758596818026, -1.1188715664195716],
            [9.209199355708451, -1.1035423085376896],
            [9.208972235804206, -1.0894126917827411]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.57719143506823, "lat": 37.10389097242643 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21199"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "00516946"
      },
      "bbox": [
        9.207758596818026, -1.3089826914624247, 9.697605466669621,
        -0.8172314257019444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.468940948428698, -7.979082168808228],
            [4.476454899844511, -7.981351813359952],
            [4.487009722357847, -7.982887693911376],
            [4.487677757790687, -7.984808025325043],
            [4.494741297786583, -7.984883631244568],
            [4.497859749479481, -7.986742409125567],
            [4.501030718071334, -7.993838165791257],
            [4.5028996785681485, -8.004393405660744],
            [4.501645613498996, -8.010747680189926],
            [4.4962388707752385, -8.026624524939196],
            [4.489739574327507, -8.035090893563831],
            [4.48548151095345, -8.042263516010495],
            [4.484842906540463, -8.051280968432343],
            [4.486997065578052, -8.05756151092664],
            [4.490572489688, -8.061498127109788],
            [4.4946207143372625, -8.062941446984452],
            [4.503424836735491, -8.063303942011599],
            [4.5160110481256215, -8.061968301731413],
            [4.527878695130521, -8.06180878806015],
            [4.532755065933863, -8.063009687656555],
            [4.53905880827587, -8.067196867577012],
            [4.544955143365905, -8.07272212046181],
            [4.549468820839937, -8.079997437351567],
            [4.550394547340025, -8.08506402151956],
            [4.549888536567662, -8.092425835630467],
            [4.5477880231818775, -8.097256730308516],
            [4.544959466535335, -8.099470127989587],
            [4.531142344943238, -8.107289744514594],
            [4.518758690074416, -8.11585366321783],
            [4.515930746434099, -8.11920511914507],
            [4.516384254174244, -8.124848585128909],
            [4.518863097619769, -8.12822302424098],
            [4.523220758386184, -8.129425961604648],
            [4.5350022624417585, -8.128298699528782],
            [4.579982253470305, -8.108432178832476],
            [4.5875474727520045, -8.113318927046407],
            [4.5911887363129225, -8.123889681148544],
            [4.595720209571097, -8.190676400621065],
            [4.595613469681648, -8.19534793114304],
            [4.593394608138586, -8.2109493205678],
            [4.587037690049114, -8.22655769536375],
            [4.58137945169107, -8.236451710427811],
            [4.5662814590373095, -8.255785660326605],
            [4.561139980428038, -8.268485163976266],
            [4.560632456382193, -8.273636348868346],
            [4.562631921369044, -8.279500840961648],
            [4.566193358860937, -8.286362572219772],
            [4.571097163227253, -8.289493727108958],
            [4.577747500838391, -8.289659210215651],
            [4.593161408734471, -8.284319556174587],
            [4.601600960216017, -8.282115641981017],
            [4.607837919018689, -8.282282516534506],
            [4.622573354576611, -8.284472410113677],
            [4.636758072677458, -8.288090061216108],
            [4.639691204105928, -8.289697809570683],
            [4.644991765676231, -8.295515360279323],
            [4.6478965860247135, -8.303308827772389],
            [4.552629417032387, -8.308172508739062],
            [4.539195753449629, -8.309172346675817],
            [4.50234097587222, -8.311363177970316],
            [4.493969408096522, -8.289736803838956],
            [4.4785140968794, -8.28178852725344],
            [4.454263871129224, -8.25244353530262],
            [4.42714912007729, -8.243196915429094],
            [4.426541729386985, -8.229499512125981],
            [4.40990273870643, -8.20667751650357],
            [4.408537622851261, -8.207427844343481],
            [4.372919831865649, -8.166094797095615],
            [4.36708210062498, -8.170986765275597],
            [4.344376967537533, -8.145392681033218],
            [4.347458978922376, -8.1451115307918],
            [4.346660550429539, -8.131632513050244],
            [4.404100952340989, -8.12842451163594],
            [4.402503811768512, -8.09997995872831],
            [4.408834173214999, -8.099564899808675],
            [4.408288398582295, -8.097022227480585],
            [4.409974527159185, -8.085696432911924],
            [4.415353501386605, -8.071013851663416],
            [4.444069397195823, -8.068813603192128],
            [4.442943857201173, -8.050131837761581],
            [4.451224912959941, -8.040419175422869],
            [4.455476104468269, -8.033851867052013],
            [4.465516189673558, -8.022785627602206],
            [4.479682629150836, -8.00411752156843],
            [4.487466189343607, -7.986716698326139],
            [4.467534049261465, -7.984285120396306],
            [4.468940948428698, -7.979082168808228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.31275714502964,
          "lat": 30.463576163003694
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22121"],
        "coty_name": ["West Baton Rouge"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["West Baton Rouge Parish"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00559570"
      },
      "bbox": [
        4.344376967537533, -8.311363177970316, 4.6478965860247135,
        -7.979082168808228
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.265826496238728, -5.644991815220013],
            [4.351396924954769, -5.64142464132099],
            [4.3918851168781305, -5.639957623391161],
            [4.408011667062225, -5.6390818730783],
            [4.411054159891593, -5.642299907360012],
            [4.409932538836581, -5.652535741402273],
            [4.402094484183645, -5.655952380141578],
            [4.404133692407803, -5.662764504170274],
            [4.407182183819275, -5.667506153983172],
            [4.406516352818155, -5.670111852627346],
            [4.399477582619345, -5.669032808978376],
            [4.398525157857725, -5.672707323620238],
            [4.402550874235865, -5.679329602757053],
            [4.401886511819363, -5.687881215663103],
            [4.398081869270287, -5.693948318473217],
            [4.3910322295590705, -5.6958545506609655],
            [4.387738922210059, -5.694409028412715],
            [4.387262717976925, -5.69897988361446],
            [4.382897987868408, -5.69969726184494],
            [4.377394515465456, -5.708555388205909],
            [4.377068271467378, -5.7156898432325525],
            [4.380242930579161, -5.717508470642013],
            [4.378343809312299, -5.720838757473059],
            [4.375306804362838, -5.730493913584094],
            [4.373265135251181, -5.732797468232689],
            [4.373190351814475, -5.741343341430361],
            [4.374315179820238, -5.750746198754589],
            [4.375971447323094, -5.755784685212868],
            [4.374921327131279, -5.75976330592528],
            [4.378435315069162, -5.762459204968621],
            [4.375477635835451, -5.765956187949853],
            [4.373883269699278, -5.773979446557045],
            [4.366669552271037, -5.779040791699516],
            [4.363035287996446, -5.774373968817272],
            [4.3598764871704905, -5.776090044398349],
            [4.360567380274032, -5.779499919221549],
            [4.35623856165072, -5.780953333715806],
            [4.355910702944075, -5.786249008285382],
            [4.35297306745267, -5.785106658567582],
            [4.352179208926963, -5.7905522637110005],
            [4.354255649765301, -5.792924279281408],
            [4.348535526182002, -5.811837338516836],
            [4.348039395224748, -5.822902651801217],
            [4.354838812009723, -5.825508091888469],
            [4.353651507849223, -5.8354353335073235],
            [4.355606383331862, -5.846495487857548],
            [4.354651033402468, -5.853772524861745],
            [4.354028694673018, -5.874617416392395],
            [4.355979538462445, -5.878287428664471],
            [4.353806484112108, -5.890740657600763],
            [4.3554474948019015, -5.897678612571237],
            [4.350589879660557, -5.901313614586459],
            [4.345360743355443, -5.9070551052822475],
            [4.334842490875662, -5.9269602512260375],
            [4.3314785417623884, -5.9296036000606165],
            [4.331740373348101, -5.936728119559214],
            [4.32925703041241, -5.942402774529445],
            [4.332049570918974, -5.950754667579665],
            [4.330108095785155, -5.95387067324303],
            [4.332014053302124, -5.957521493051106],
            [4.32810208155623, -5.9588727799336505],
            [4.312633308246713, -5.956183242827838],
            [4.311866335121072, -5.963790403475877],
            [4.308883746476646, -5.96781122344817],
            [4.310822261497782, -5.973178482227833],
            [4.310565596467219, -5.980555295272089],
            [4.313839859551137, -5.987258078687515],
            [4.311248990514756, -5.989996857156553],
            [4.314133123101756, -5.992864451089035],
            [4.317101747482873, -5.9927684058649975],
            [4.314319717180892, -5.99953242806012],
            [4.316924660118242, -6.008355001720341],
            [4.314609531007467, -6.010229147214223],
            [4.310933246235394, -6.0092835801214415],
            [4.310971682280045, -6.01336261078869],
            [4.313392502588701, -6.015083676053352],
            [4.312796004359684, -6.019652861096115],
            [4.3099019838443375, -6.02268123815955],
            [4.309317179907351, -6.027427955167628],
            [4.31140709379837, -6.03310935937657],
            [4.316830143632096, -6.034502436400063],
            [4.31903718660277, -6.036965541730854],
            [4.314469112475361, -6.042940443402301],
            [4.307153424908924, -6.04652472249778],
            [4.302466259635926, -6.046724845966851],
            [4.299267838158885, -6.050042478276819],
            [4.293149715549978, -6.050725206885919],
            [4.288467123423294, -6.058081475335576],
            [4.278848150223376, -6.066615034280391],
            [4.278345273285266, -6.069353369987021],
            [4.259498075558399, -6.070005671706723],
            [4.15204058060427, -6.075119702306591],
            [4.150388922561572, -6.044714424165611],
            [4.1495866670947885, -6.039051258403765],
            [4.1475224168035245, -5.990184585814305],
            [4.113472779451174, -5.99159604272239],
            [4.117396927012927, -5.9890012845995475],
            [4.1204982573561315, -5.983132234157221],
            [4.12593099536568, -5.978361834354927],
            [4.1246618031942885, -5.972972049001604],
            [4.126809459604843, -5.970243705083559],
            [4.12350605626207, -5.962723698359164],
            [4.119678246780151, -5.963023202475821],
            [4.116244463816347, -5.957480723608932],
            [4.110894310707402, -5.957233502651108],
            [4.114684750847541, -5.949790180042252],
            [4.115240627946476, -5.944806075728964],
            [4.118624274907489, -5.939469127997173],
            [4.127646416543344, -5.9365035376253035],
            [4.127329692589181, -5.931661304818792],
            [4.12984325852576, -5.9278449311529915],
            [4.1326755568770865, -5.926750233018529],
            [4.131826459356655, -5.9198969744606424],
            [4.135808562473641, -5.919306193116695],
            [4.139130222400306, -5.913645138991816],
            [4.1434677762425185, -5.908493927227256],
            [4.144493846918783, -5.897919614972326],
            [4.143401864151024, -5.884853068189165],
            [4.138991246137192, -5.878035918037651],
            [4.135069381249024, -5.87476834728735],
            [4.139490163779715, -5.86721042092256],
            [4.145140130832578, -5.863267068880824],
            [4.147582646469603, -5.8587331097039534],
            [4.145743624985622, -5.849974524404364],
            [4.151112027495969, -5.838823684403202],
            [4.1549596945595715, -5.838147664622898],
            [4.155127665123819, -5.83499982573716],
            [4.15957508151286, -5.831119613510784],
            [4.1583466298283, -5.824975411214281],
            [4.158736456699958, -5.815235040430722],
            [4.161889640948385, -5.810916395893059],
            [4.1617150326974786, -5.806978518484144],
            [4.163720951878365, -5.8012358826015005],
            [4.167479292866296, -5.79951709731568],
            [4.177973329557621, -5.788463615819697],
            [4.179643184294793, -5.78206341726142],
            [4.1841878580908425, -5.778705592456007],
            [4.189542405124721, -5.777534339081025],
            [4.198218814067254, -5.7788767511686014],
            [4.208823856379787, -5.775089753299484],
            [4.214942105589716, -5.77002848877265],
            [4.219485845631406, -5.764326344740568],
            [4.222318851922046, -5.762639267132269],
            [4.220453960283396, -5.759079216285486],
            [4.218763928343179, -5.751873737207628],
            [4.219696204179844, -5.746526868141194],
            [4.223790576489724, -5.743191503693359],
            [4.232723366377595, -5.729186970372412],
            [4.236220285394316, -5.726101530921446],
            [4.236206335526694, -5.722966886686838],
            [4.23262097916278, -5.717426381482128],
            [4.234564752845306, -5.711141677655147],
            [4.237536115633624, -5.707091513318677],
            [4.244645589984207, -5.701490380889262],
            [4.244814924834614, -5.697678153345971],
            [4.2476468008373764, -5.690833198232333],
            [4.250701056714201, -5.6860725457402],
            [4.260699768676452, -5.679760457853284],
            [4.265569281363853, -5.670235601022654],
            [4.264115384419114, -5.665720527523951],
            [4.2610842295134415, -5.6661320037635265],
            [4.25918763968986, -5.6694967993338174],
            [4.255179190606056, -5.66828146781167],
            [4.257361836737141, -5.664026897969433],
            [4.256069430058169, -5.659180085731718],
            [4.263941287099506, -5.660262974683447],
            [4.264172209737127, -5.651061400194808],
            [4.26729877978441, -5.650132875652738],
            [4.265826496238728, -5.644991815220013]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.45681783452892,
          "lat": 32.788457582308595
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22123"],
        "coty_name": ["West Carroll"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["West Carroll Parish"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00559578"
      },
      "bbox": [
        4.110894310707402, -6.075119702306591, 4.411054159891593,
        -5.6390818730783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.403149177694658, 2.195765519311987],
            [13.493117446043144, 2.212306949207511],
            [13.55669321969784, 2.224066591119978],
            [13.667416808448854, 2.2439969706082437],
            [13.689446492944667, 2.2483978094390396],
            [13.69604434239877, 2.2492338193896826],
            [13.753120269211392, 2.2602442333722683],
            [13.77010882421888, 2.2630167777885193],
            [13.813725867120258, 2.2712122863901785],
            [13.842005906502678, 2.276540772060152],
            [13.842906248671305, 2.2712271284825554],
            [13.846241116517515, 2.271125914781959],
            [13.849970895977037, 2.274031956983558],
            [13.853158880524072, 2.2670524378020502],
            [13.856203431036487, 2.2637537264895444],
            [13.862087605618282, 2.260250086572493],
            [13.865378840791312, 2.2569589905137644],
            [13.864232500627283, 2.253935548233724],
            [13.868077025649235, 2.2473094765824766],
            [13.868443471469602, 2.238383037958285],
            [13.862623410958188, 2.2331425425387454],
            [13.854797853125232, 2.2360201763531453],
            [13.850286671039775, 2.229859930577684],
            [13.856915021771405, 2.225786948531306],
            [13.859697338030767, 2.2222631544350446],
            [13.859736110321737, 2.2181519954858615],
            [13.85590435580128, 2.219065929008949],
            [13.848721576931151, 2.2142082773641008],
            [13.845240263505545, 2.2144271008686722],
            [13.84344889298969, 2.210216858461864],
            [13.846788000760272, 2.2084144007628193],
            [13.857124266545735, 2.2077587569634827],
            [13.85759331323381, 2.2037263463973815],
            [13.853287286809849, 2.203370245971652],
            [13.85727446596081, 2.198686930379823],
            [13.864062438618507, 2.1969314886886697],
            [13.864763389142148, 2.1925042624185025],
            [13.850502509118563, 2.193931188737016],
            [13.845888365329941, 2.19221753034405],
            [13.846293537052672, 2.1881156480399557],
            [13.85098408090934, 2.184067744683615],
            [13.851401449551284, 2.1810005318977868],
            [13.848451798130453, 2.1782497177563873],
            [13.845258266549362, 2.1781308431384967],
            [13.836426958597205, 2.18100041088922],
            [13.829853998965605, 2.1774665974959975],
            [13.830610586802315, 2.1714817754111233],
            [13.84037902396045, 2.1631025553112924],
            [13.84029694369006, 2.1602474883093032],
            [13.836811978048452, 2.158206703502283],
            [13.832616959766979, 2.1581738291869104],
            [13.82663244149472, 2.160341839640081],
            [13.822105192250897, 2.1635568645222625],
            [13.808397565224215, 2.166137945352703],
            [13.802086145833979, 2.1679643257159054],
            [13.794945231124998, 2.16587947404793],
            [13.793348387260785, 2.1604186039391213],
            [13.795623294517426, 2.156969946351698],
            [13.805883127230272, 2.147290895005991],
            [13.812620661096933, 2.143551270794985],
            [13.82112610743845, 2.1403041027150085],
            [13.825676541862336, 2.1377036527097886],
            [13.828411449771762, 2.1320407788685505],
            [13.824938190795605, 2.127284498641008],
            [13.819914469749328, 2.1246807868760493],
            [13.811462012226976, 2.125683787971276],
            [13.803234736491053, 2.1298986637357697],
            [13.791207921321533, 2.1322061284684457],
            [13.785374288881822, 2.13012994475234],
            [13.781391983678171, 2.1264992786839985],
            [13.781816141140133, 2.119443697329776],
            [13.785921484473421, 2.113943016380711],
            [13.789686581377016, 2.111125964240752],
            [13.800081443221421, 2.10550903641006],
            [13.80963214992599, 2.102810033153759],
            [13.81834417561278, 2.0946362022581595],
            [13.817104305753208, 2.090097166413935],
            [13.811650084616769, 2.0903008157082974],
            [13.806873399795666, 2.0954239124238536],
            [13.801609377702134, 2.093907916201905],
            [13.806272714598249, 2.0866175123570976],
            [13.805926098968383, 2.0817438585698023],
            [13.801377154928021, 2.0828656049787924],
            [13.795655659441671, 2.088976671575413],
            [13.79286458505379, 2.0904803620036727],
            [13.785816893151358, 2.090183273412079],
            [13.786881109895605, 2.0849061443981953],
            [13.79437479361093, 2.084399849741225],
            [13.79625701797732, 2.082799357422895],
            [13.79563722950959, 2.0784310834190562],
            [13.787852693221195, 2.076455165351072],
            [13.786981932368226, 2.072407613293573],
            [13.789937988758084, 2.065095304210201],
            [13.789427963005428, 2.0597183298148094],
            [13.78586598079146, 2.0548969448443337],
            [13.781806314681667, 2.0535767371453955],
            [13.776420480171954, 2.0553642207139826],
            [13.769826793589534, 2.0529343385830967],
            [13.759556396835162, 2.051908015632731],
            [13.744758561724636, 2.0554541025787794],
            [13.739901946388976, 2.0544119655946957],
            [13.726528350034789, 2.048177088329123],
            [13.718509672723986, 2.047230945733623],
            [13.71227962429423, 2.0439394463240865],
            [13.706659094375292, 2.045901720581037],
            [13.70171565794666, 2.049289703971086],
            [13.694295362888974, 2.0492952841064294],
            [13.69031684901523, 2.052563999895116],
            [13.689757920956856, 2.0576671580067103],
            [13.685541362345237, 2.055246271530052],
            [13.682651074557507, 2.0514490557118465],
            [13.678641230211737, 2.0537542807573033],
            [13.66568437477477, 2.0559036930420205],
            [13.661589746285436, 2.0548168926480748],
            [13.660261614076612, 2.0524367665033614],
            [13.641814412288056, 2.046555847491482],
            [13.640669779467329, 2.046727107773143],
            [13.635417639938566, 2.047513183158234],
            [13.631225181838001, 2.0502138059658277],
            [13.626015225721446, 2.0494662404105717],
            [13.620274743426462, 2.051975591303559],
            [13.614640192310151, 2.0529097865536037],
            [13.609387905100682, 2.0596166921348114],
            [13.599542657802964, 2.060478836164155],
            [13.59372991001821, 2.065743874000687],
            [13.584605974105148, 2.066058331230467],
            [13.582946084064558, 2.0694601564032684],
            [13.577283860616882, 2.0763967874353],
            [13.573739208371947, 2.0872883148692125],
            [13.569208695762297, 2.085469161385868],
            [13.56780274005219, 2.080141680944616],
            [13.56568523436521, 2.0785553331176683],
            [13.561204461256112, 2.080081101656978],
            [13.557721452725229, 2.0782702703851257],
            [13.548416022963524, 2.0835356281787156],
            [13.544781214408326, 2.0905684551276593],
            [13.5378931723521, 2.0958395882392438],
            [13.538370549165988, 2.098657908309311],
            [13.544085031488525, 2.104500803801767],
            [13.549571075595388, 2.10681870952157],
            [13.556321457249672, 2.1080182838246553],
            [13.560438567670674, 2.104407588831767],
            [13.563352115514684, 2.108735621427238],
            [13.565723713279121, 2.109486665324623],
            [13.568923462210833, 2.1144162057085207],
            [13.565681361581467, 2.121796931860358],
            [13.560043264511126, 2.124228684268461],
            [13.555612073884902, 2.1246198239592817],
            [13.550066800786661, 2.120228036513194],
            [13.545940977229206, 2.1152939005491826],
            [13.541044245022167, 2.1149443786307893],
            [13.534660992271604, 2.1161145277634184],
            [13.53344979922959, 2.118654388196728],
            [13.535559807747243, 2.13184071491683],
            [13.538500031900634, 2.1348404034316553],
            [13.539745661843037, 2.1398883509367894],
            [13.538551360034495, 2.1442841642543775],
            [13.532006902279356, 2.140214160646446],
            [13.529048234724547, 2.1305459325972054],
            [13.521571026980446, 2.1307158046727497],
            [13.51833073835748, 2.121066489135672],
            [13.515427568278303, 2.1185186192120646],
            [13.522177433765634, 2.106131958338112],
            [13.523579017262731, 2.0989321832687997],
            [13.513245581850612, 2.0982007532875615],
            [13.512970528275517, 2.0875412854859334],
            [13.509581610600144, 2.0837145891886473],
            [13.50928464987923, 2.0793340220370053],
            [13.504224492991584, 2.076829807213599],
            [13.506046252126387, 2.065374002036435],
            [13.510935258433728, 2.065194116967013],
            [13.515579483566274, 2.060980758363717],
            [13.517442059688372, 2.057597554090106],
            [13.51609330616322, 2.0511685494173233],
            [13.51280230328719, 2.0494650734267394],
            [13.505260522408346, 2.0529477956310442],
            [13.49870603648975, 2.053746212461526],
            [13.495368010760819, 2.0481086436900067],
            [13.49054363384484, 2.044694144984706],
            [13.491744011249509, 2.0388835134957426],
            [13.49022680710599, 2.032718979054586],
            [13.486285535040942, 2.0244772660066395],
            [13.479726511237468, 2.0210287563479334],
            [13.481988146314714, 2.0142893995968136],
            [13.479599778573649, 2.004439190788166],
            [13.476591252580283, 2.002449840563141],
            [13.471145904006976, 2.002869939097622],
            [13.467363832772193, 2.004709554438322],
            [13.465655736538896, 2.001310474035345],
            [13.46790096862184, 1.998505235503021],
            [13.46770395017737, 1.9921683932826355],
            [13.45954947169029, 1.9905096084861837],
            [13.458465376197736, 1.989248269291478],
            [13.460920596884494, 1.9826921663423607],
            [13.458734992183622, 1.9740745640740387],
            [13.455440697701627, 1.970455385119687],
            [13.454724400061048, 1.962933375465116],
            [13.446734817695756, 1.9619535780632995],
            [13.441907827208532, 1.960233864980392],
            [13.436313911196157, 1.953894736423121],
            [13.440131143925495, 1.9475254278318708],
            [13.439208287981593, 1.9437088607913995],
            [13.435746100770189, 1.9385686103964501],
            [13.43113112414086, 1.9351739883984511],
            [13.427802805690554, 1.934776037464325],
            [13.428054782069564, 1.9299021732607176],
            [13.432018923035388, 1.9261663035729266],
            [13.428303717914158, 1.922356750001483],
            [13.431951647190402, 1.9192084500343463],
            [13.432768714203364, 1.911497192277735],
            [13.426520227220045, 1.9085106241074286],
            [13.422155186542112, 1.9127157518481084],
            [13.414637874022707, 1.916841755402548],
            [13.399866767675354, 1.9206125632211064],
            [13.388878619493179, 1.9248681314255518],
            [13.382508754732738, 1.9297965895482538],
            [13.37456496000959, 1.9263978309210272],
            [13.369772069798277, 1.9283024131865307],
            [13.365871961427844, 1.9368605583113325],
            [13.359677932370536, 1.9388195262211367],
            [13.3570710277758, 1.9419951647236946],
            [13.354463298227776, 1.9414720389782447],
            [13.352514844167413, 1.9378355370776954],
            [13.352891591206394, 1.9290883047718195],
            [13.348820800133634, 1.9286054319184607],
            [13.345026520202385, 1.9347937476080312],
            [13.342375535312014, 1.9352671990605554],
            [13.364071499680028, 2.0280736133731914],
            [13.386270218372255, 2.123152202586464],
            [13.403149177694658, 2.195765519311987]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.69743754464854, "lat": 39.62145418925498 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24001"],
        "coty_name": ["Allegany"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allegany County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01713506"
      },
      "bbox": [
        13.342375535312014, 1.9085106241074286, 13.868443471469602,
        2.276540772060152
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.642506479404299, 7.80933169378107],
              [8.712447577262438, 7.818185680846209],
              [8.712913030622898, 7.814658380637061],
              [8.710726058513714, 7.8161724913396196],
              [8.700462024120302, 7.812458322524373],
              [8.701188934757347, 7.807540106001339],
              [8.69376431874975, 7.810587785130422],
              [8.690862304284426, 7.8084982754928145],
              [8.692204450591513, 7.8052966766147005],
              [8.689483819107664, 7.803611647948364],
              [8.681248944030438, 7.803435175213188],
              [8.674772579770567, 7.806757128576174],
              [8.672210217306388, 7.805472377437601],
              [8.667168990343539, 7.809709615944291],
              [8.665265352310806, 7.8060439729496025],
              [8.672715481221472, 7.80105897750657],
              [8.67681004094309, 7.795372252152995],
              [8.674975570144444, 7.794246422787197],
              [8.670328214866418, 7.797022987666084],
              [8.668089190115895, 7.803100274208396],
              [8.659096530838566, 7.803470805987648],
              [8.654473705058942, 7.8053239117302],
              [8.655817915257478, 7.798895482991953],
              [8.645362103034001, 7.805827073520708],
              [8.642506479404299, 7.80933169378107]
            ]
          ],
          [
            [
              [8.489575845810528, 7.78701946282903],
              [8.490845848504998, 7.78747035264126],
              [8.501138300011315, 7.781787207344435],
              [8.499216068864705, 7.780638980821021],
              [8.489575845810528, 7.78701946282903]
            ]
          ],
          [
            [
              [8.391540829133309, 7.7570474797005735],
              [8.394390196332507, 7.7640413906423795],
              [8.401070195241383, 7.763134676504796],
              [8.405860340108038, 7.759109576706433],
              [8.406322259875385, 7.752561373621934],
              [8.40300237934987, 7.747817685640539],
              [8.397217728220033, 7.749926111358638],
              [8.393330373705224, 7.75294765585554],
              [8.391540829133309, 7.7570474797005735]
            ]
          ],
          [
            [
              [8.404307299401975, 7.608688924128674],
              [8.404704164607054, 7.612298424143786],
              [8.41098117580658, 7.616518565348741],
              [8.414946918366095, 7.616586325281112],
              [8.424206111434048, 7.6135869165478764],
              [8.432124449102387, 7.610240172632091],
              [8.44104872142061, 7.608158240843372],
              [8.444813313302324, 7.609693922823761],
              [8.450174543748211, 7.609460556561816],
              [8.460723122601763, 7.613781624128221],
              [8.465241788005105, 7.6135308391658025],
              [8.471670373215193, 7.609830372883231],
              [8.486272788743523, 7.604457366002534],
              [8.495887604929704, 7.6028128853353945],
              [8.50709505888876, 7.5997521512785005],
              [8.51586389689277, 7.596090086319995],
              [8.522121486368537, 7.600309356920357],
              [8.524205964703375, 7.605398575387284],
              [8.522089009891598, 7.615815580950743],
              [8.517226048549269, 7.620822729264119],
              [8.522156969899068, 7.621404998618321],
              [8.526293098865308, 7.613716810388803],
              [8.5291574616612, 7.6111531966216],
              [8.534577673374589, 7.599612624753586],
              [8.539965432918237, 7.595142572954166],
              [8.5454105802085, 7.596870580924395],
              [8.558919829441418, 7.590987464831981],
              [8.568247089003673, 7.589471263635739],
              [8.571697328844747, 7.586896405202249],
              [8.566630606328477, 7.5780677780168055],
              [8.566062064272387, 7.573880632481986],
              [8.563353084582664, 7.571170046142961],
              [8.565224253808086, 7.564451725947603],
              [8.563023685686254, 7.5597310510471445],
              [8.559347199845304, 7.5595455669252285],
              [8.551107313608354, 7.553161626225206],
              [8.548922885321403, 7.545780326971396],
              [8.550805695186472, 7.541815203830061],
              [8.543102144618446, 7.535075141982257],
              [8.538694691289072, 7.5358062717202525],
              [8.533720115713045, 7.531774518505468],
              [8.527350943394335, 7.5345780027362945],
              [8.523095381592984, 7.53859338415612],
              [8.518291778204558, 7.538211770363436],
              [8.510854506736447, 7.535371721657494],
              [8.500485805411596, 7.538983934061496],
              [8.494169896036006, 7.539522063420064],
              [8.48966639322154, 7.536380257487479],
              [8.480032381334501, 7.5393775201699285],
              [8.475374470456757, 7.541816921371737],
              [8.470034939947753, 7.549022503708581],
              [8.467876556745074, 7.557661931212075],
              [8.460687009536178, 7.562185875406305],
              [8.455474998121435, 7.563833934705167],
              [8.454279687627636, 7.568009761270613],
              [8.443878927929466, 7.57842373184535],
              [8.443304329107656, 7.581473615914665],
              [8.437228412931855, 7.585935141095939],
              [8.43493983880474, 7.589685101137237],
              [8.425637876677248, 7.594991303772934],
              [8.411364065472437, 7.599269384068576],
              [8.406184079786618, 7.603574635890621],
              [8.404307299401975, 7.608688924128674]
            ]
          ],
          [
            [
              [8.387158816051517, 7.628356633237467],
              [8.39466490394275, 7.628600537609929],
              [8.399368114835564, 7.625890053432152],
              [8.403408569389862, 7.621805888037605],
              [8.401758291385773, 7.617412343760335],
              [8.39092964811448, 7.61988106365497],
              [8.387158816051517, 7.628356633237467]
            ]
          ],
          [
            [
              [8.349654103027044, 7.761799157235621],
              [8.350219873178197, 7.767291950270989],
              [8.352710478997723, 7.770109719650964],
              [8.357112159923279, 7.76922366788789],
              [8.366371311689187, 7.76385905810491],
              [8.372991491209453, 7.759168113791258],
              [8.366730729649522, 7.749336527858464],
              [8.3586864364357, 7.745381903664546],
              [8.352380259975757, 7.747640230251595],
              [8.351965507234898, 7.750206167997129],
              [8.3543492740743, 7.754726703166099],
              [8.349654103027044, 7.761799157235621]
            ]
          ],
          [
            [
              [8.355922134346175, 7.652755733370922],
              [8.357279802098168, 7.655505840349664],
              [8.356663215143977, 7.660238788772453],
              [8.35862444593599, 7.664941210477763],
              [8.35670031589129, 7.673589478974881],
              [8.359936824880268, 7.675864990165869],
              [8.369103902390364, 7.6737189708115325],
              [8.374227247269907, 7.669641092993629],
              [8.384019565651611, 7.6566252250597975],
              [8.385547436680772, 7.655578991935265],
              [8.391371333347186, 7.646301766246092],
              [8.388664475881932, 7.6424740681713415],
              [8.38244923660421, 7.6430358242356045],
              [8.379933289070852, 7.638440420939743],
              [8.372022109415362, 7.642336313261643],
              [8.365310315271714, 7.643748965280732],
              [8.35668763207673, 7.649883124645355],
              [8.355922134346175, 7.652755733370922]
            ]
          ],
          [
            [
              [8.197190580377146, 7.636615971204008],
              [8.19838938936803, 7.638716569673927],
              [8.205015775855799, 7.636639718906742],
              [8.206009457246443, 7.633862456743339],
              [8.210537643232312, 7.633081666317418],
              [8.2092805884136, 7.626773654902095],
              [8.20629312714802, 7.627339456108178],
              [8.19794758005801, 7.632611746608484],
              [8.197190580377146, 7.636615971204008]
            ]
          ],
          [
            [
              [7.474813786391109, 7.9338205646794755],
              [7.5614610300893, 7.943311402059518],
              [7.648110768805081, 7.952780109131563],
              [7.676489358965926, 7.9562438052151565],
              [7.7484758918316565, 7.964256910627636],
              [7.820464157270263, 7.9722547308620975],
              [7.9067907412911325, 7.981837199139387],
              [7.992493102990351, 7.991835507850097],
              [8.00303133860618, 7.906023842076104],
              [8.110113048640105, 7.9186332980247345],
              [8.131635896192064, 7.9209447332440925],
              [8.225853899360732, 7.931512159069083],
              [8.303879569388602, 7.940365142464355],
              [8.433252633746948, 7.956493326083902],
              [8.519224425702161, 7.966610622649689],
              [8.530043619352082, 7.881851642526455],
              [8.615715780100906, 7.892233856925276],
              [8.620904193510867, 7.848920299808002],
              [8.626072190650358, 7.807247931836356],
              [8.638092548584364, 7.808762376968031],
              [8.638896229369331, 7.80091203629713],
              [8.632652309096283, 7.803517724626179],
              [8.631622732956107, 7.799767585391985],
              [8.623203908292082, 7.801776006741832],
              [8.621431807275357, 7.803945563901454],
              [8.613328847877625, 7.803442710419375],
              [8.606096926976102, 7.810620661406835],
              [8.602062346601889, 7.807572712977414],
              [8.611570905262575, 7.791533641492211],
              [8.614829335901431, 7.788146663535939],
              [8.614953463902914, 7.780501408586493],
              [8.616295142308799, 7.7784429268059725],
              [8.611599968256026, 7.775970954451401],
              [8.60739627776549, 7.778446513454168],
              [8.603408444433477, 7.778975567424789],
              [8.599772044920714, 7.774351220294877],
              [8.591849138412497, 7.772033917778542],
              [8.580510682387407, 7.779980567866458],
              [8.579746492478643, 7.776757296755485],
              [8.574851097597216, 7.776570688083082],
              [8.57421690848105, 7.772386279045642],
              [8.56886320904059, 7.772459126223661],
              [8.564866228997023, 7.77002419779061],
              [8.560802540569126, 7.771927419428142],
              [8.556252322304038, 7.769641806043525],
              [8.550706414146104, 7.772012676858171],
              [8.548670903288395, 7.770281784576944],
              [8.55704680593603, 7.7619120522179434],
              [8.557786651891956, 7.759420986968327],
              [8.551633249771765, 7.753093183263782],
              [8.547633731262387, 7.753844689310761],
              [8.542075061788545, 7.752673474321678],
              [8.533756670542202, 7.754788016614648],
              [8.529647959382055, 7.760188318491694],
              [8.525648009992901, 7.759405567701379],
              [8.52394480201758, 7.756048872949234],
              [8.529100297680353, 7.748159200293598],
              [8.519858480900062, 7.752918979923528],
              [8.50707581532847, 7.761659519204085],
              [8.50438645909411, 7.7653179718248895],
              [8.506986491163785, 7.773824079235028],
              [8.504460521905209, 7.781858315733796],
              [8.507192430569969, 7.786986653493522],
              [8.502527045177695, 7.7922936141464785],
              [8.494023054783904, 7.798034302660258],
              [8.497703221378952, 7.798990827314993],
              [8.506875977396051, 7.793519184341942],
              [8.509176062318199, 7.7901581360346395],
              [8.515363030335442, 7.791323396526],
              [8.518105959467912, 7.795972988867706],
              [8.514040789802763, 7.799574681439164],
              [8.506940036697072, 7.8017572776676385],
              [8.497351637157859, 7.808575470854797],
              [8.48610418421, 7.811984348202005],
              [8.481407139763684, 7.811580071908345],
              [8.479771175789748, 7.806610103494196],
              [8.47061371053968, 7.809286812600372],
              [8.467719718138415, 7.808443724912658],
              [8.465518035037569, 7.803324106541826],
              [8.469062426461393, 7.796181605658931],
              [8.470025323091487, 7.789714685711153],
              [8.474596522922868, 7.785740000289926],
              [8.471705943005107, 7.780122671817622],
              [8.473454109154911, 7.772682498476091],
              [8.466992160318707, 7.774520409379789],
              [8.463141143705169, 7.779006446840504],
              [8.459698055622418, 7.779647458948408],
              [8.456695510693823, 7.7899212739166765],
              [8.457077728803261, 7.7940767302717],
              [8.452779779300828, 7.796520405147596],
              [8.448016820966519, 7.7952884271521246],
              [8.440478684753392, 7.7976712754471675],
              [8.435779975924563, 7.791839504882108],
              [8.43548888089803, 7.788101918201553],
              [8.437323054271044, 7.780537524248384],
              [8.435549207620564, 7.7762565194350275],
              [8.437973628335701, 7.770763134490634],
              [8.432303090101328, 7.767211414596475],
              [8.425537557375886, 7.767429947529057],
              [8.4237367216733, 7.770516809645389],
              [8.422667649148439, 7.776516174447663],
              [8.424106974601441, 7.780764501428916],
              [8.424246207965696, 7.789139159022802],
              [8.421673393093045, 7.791957484958003],
              [8.422288002022002, 7.794752043047966],
              [8.42046378502234, 7.8029709236779246],
              [8.418886117238133, 7.805929521850789],
              [8.41389479802233, 7.8077797375861335],
              [8.415152534332412, 7.810981012601481],
              [8.413582027938427, 7.81587756005725],
              [8.410824484442097, 7.818893738881728],
              [8.403756254117488, 7.821672002742356],
              [8.396221355423826, 7.826707590050872],
              [8.384120083083264, 7.823297346191704],
              [8.381253738436657, 7.81906277045388],
              [8.367511163665377, 7.819765789536514],
              [8.363698034092973, 7.817584173710598],
              [8.360012836288409, 7.825659324362731],
              [8.35571705045396, 7.827673855936404],
              [8.347788040145721, 7.8283035209020895],
              [8.336377366367987, 7.83674686287753],
              [8.329844031994535, 7.838909139383389],
              [8.323101250806072, 7.83594876106496],
              [8.317334593248871, 7.830804680150443],
              [8.310725214992733, 7.818934393408883],
              [8.309375789476684, 7.811867532553591],
              [8.310114604011376, 7.808501952192221],
              [8.309273283145219, 7.800917068722154],
              [8.312844097597035, 7.794306846803615],
              [8.316555837722525, 7.790270948298928],
              [8.316891593938815, 7.784472784328204],
              [8.315157605003801, 7.780316444978914],
              [8.315914199180828, 7.777258308150098],
              [8.311945037173432, 7.769984208821837],
              [8.314664128391563, 7.766254489971888],
              [8.319570190938947, 7.762808857421587],
              [8.317999432397531, 7.756405198131009],
              [8.312257319983331, 7.75554168099111],
              [8.303883806192058, 7.756599642610681],
              [8.301210628941728, 7.754697022413101],
              [8.302969454211794, 7.750458367878596],
              [8.294057466222016, 7.749605373389949],
              [8.28984138733618, 7.743047401607001],
              [8.285667637429723, 7.72720104455432],
              [8.285265943677228, 7.7232138669718395],
              [8.28866285105195, 7.719907947205307],
              [8.291254116097084, 7.713739100292003],
              [8.299175396202699, 7.711931428166175],
              [8.303087321791052, 7.708465423628907],
              [8.306564365440009, 7.700691689504767],
              [8.301912942358607, 7.700569529181772],
              [8.298245092761649, 7.702575410554772],
              [8.293060784216568, 7.6995241133209165],
              [8.291137984014394, 7.694994943073845],
              [8.29303662277438, 7.690035423446802],
              [8.292487734270379, 7.68661620782651],
              [8.294427453826437, 7.679844955620592],
              [8.3006791642831, 7.675422963942331],
              [8.304064277861517, 7.664682627845027],
              [8.30681629520114, 7.658970825664737],
              [8.300549531271972, 7.657121849521025],
              [8.300819368580646, 7.6532363143052295],
              [8.307208112097497, 7.651151314750634],
              [8.31235168422002, 7.64658436756117],
              [8.316775761413977, 7.64577047164285],
              [8.322477865310516, 7.638908799578703],
              [8.319689854050843, 7.634645934033663],
              [8.309554301220956, 7.632757316509967],
              [8.307802284793464, 7.631315786546738],
              [8.295329285556017, 7.630972106863709],
              [8.290673040633868, 7.627884266624386],
              [8.288794807002516, 7.621842372284602],
              [8.284837290358475, 7.624516217005433],
              [8.271971053011661, 7.6294543901936285],
              [8.270780844646712, 7.630868920711759],
              [8.258628643979145, 7.637192285930275],
              [8.255432135836477, 7.639803166369668],
              [8.253683510826425, 7.644433466635848],
              [8.249817809263211, 7.647868176418905],
              [8.237804007048899, 7.644247806844251],
              [8.23031933572265, 7.64718102209822],
              [8.224312528340883, 7.655923155829145],
              [8.22401665691519, 7.663406894972034],
              [8.221161424810274, 7.668950357259929],
              [8.221806689145733, 7.671657352428123],
              [8.212141828564711, 7.673040986036635],
              [8.20791129692624, 7.674632341769621],
              [8.203136346293476, 7.679197446132688],
              [8.200466273280625, 7.678876087176906],
              [8.19628772005091, 7.682961838014032],
              [8.193092669633828, 7.684276919894521],
              [8.19101750935023, 7.688752376697652],
              [8.184878733647105, 7.694133978135649],
              [8.179778014456172, 7.694281967264131],
              [8.177661141051171, 7.691823335739543],
              [8.1712000286803, 7.691171028585354],
              [8.16716899819688, 7.693475308467411],
              [8.152359941671978, 7.714869910926338],
              [8.143198030080642, 7.726002175756633],
              [8.118717911004978, 7.747912710919887],
              [8.095650494594421, 7.76517123682376],
              [8.087934713581967, 7.768908778926183],
              [8.073051914747145, 7.771753979269579],
              [8.064358935835457, 7.775835761519858],
              [8.058334605360457, 7.777492459651059],
              [8.043988607290588, 7.777969125488349],
              [8.035558617152226, 7.7806322746326195],
              [8.030778107283277, 7.779240715169065],
              [8.026223236970399, 7.780657638073264],
              [8.022597978260332, 7.784027106201794],
              [8.012133340469319, 7.789303712167124],
              [8.00345642149414, 7.794398661440922],
              [7.995871233660351, 7.797045696777796],
              [7.98801418900577, 7.797272006925352],
              [7.981234973498511, 7.793563203223924],
              [7.97734978341695, 7.794809128716151],
              [7.976135084594959, 7.8007388159945625],
              [7.970540379004824, 7.804944243082077],
              [7.96724370411117, 7.805851058607042],
              [7.961163458889359, 7.804079420348043],
              [7.959075956830405, 7.798818461988945],
              [7.962364492844953, 7.797121733356652],
              [7.961706063531106, 7.791199876376876],
              [7.956018367394596, 7.796611818310011],
              [7.9506474795672295, 7.795925985732803],
              [7.946726284417538, 7.799360764323548],
              [7.943987554982924, 7.797305233950741],
              [7.940966928470576, 7.800662759606017],
              [7.93479329008083, 7.80139085078961],
              [7.930119502182853, 7.7987265020320695],
              [7.923066669608165, 7.800266509524027],
              [7.91923729955986, 7.802905576370752],
              [7.915400677479259, 7.803224494500911],
              [7.912724697415158, 7.800800154431114],
              [7.900517511544711, 7.805947939261895],
              [7.896973783753615, 7.80654164517255],
              [7.89361340584841, 7.809950225477438],
              [7.887325125952963, 7.808371215897585],
              [7.8853684347557085, 7.812445074140011],
              [7.879991013570938, 7.815118505259755],
              [7.876048931515581, 7.814804631194878],
              [7.874109529969911, 7.818010581698023],
              [7.863764715381876, 7.822615735296451],
              [7.856330185966702, 7.8241243231414614],
              [7.849843427872438, 7.824254473477292],
              [7.842371412491702, 7.822061064711494],
              [7.8384030568086835, 7.819600709927037],
              [7.835777990498895, 7.816044038444882],
              [7.837205165193272, 7.812158116848637],
              [7.83417388446516, 7.811187745453021],
              [7.827561352871903, 7.804279501819378],
              [7.827195348736159, 7.808122453915128],
              [7.824644005898764, 7.812031957582715],
              [7.819680207140321, 7.814602594126064],
              [7.818261717036843, 7.820893079339564],
              [7.809157915791294, 7.825073584543438],
              [7.805011573970239, 7.824549137226655],
              [7.802777258378861, 7.8269674865245396],
              [7.792466709641981, 7.826350091975208],
              [7.7827841851563955, 7.819138393964861],
              [7.7843374662002685, 7.814617922659763],
              [7.779812281737637, 7.812709776594812],
              [7.781712893045344, 7.808729038701445],
              [7.776097138811634, 7.809327957482522],
              [7.772308172533175, 7.812687415743621],
              [7.764392220171596, 7.814043534949582],
              [7.756021887798292, 7.816769517554343],
              [7.742499467419357, 7.815840314214336],
              [7.734046407652005, 7.812709818724223],
              [7.728300614432884, 7.80862648303118],
              [7.716262708920037, 7.795688630188981],
              [7.707589148548471, 7.7824187913756475],
              [7.70149638085393, 7.775251450260745],
              [7.6967649313992865, 7.761008609010452],
              [7.688489677229469, 7.754600235657051],
              [7.682176774970379, 7.745771938848417],
              [7.6738976301441495, 7.72887076439922],
              [7.671020850323114, 7.7197476616201],
              [7.671205838171722, 7.717127866560129],
              [7.666780114683739, 7.714000140768316],
              [7.664248987783152, 7.709778295282789],
              [7.663627919589614, 7.70486188951148],
              [7.6604609646387765, 7.700408780381547],
              [7.65589091389245, 7.6981042780585565],
              [7.6507913840320345, 7.6899119198940165],
              [7.6488897653286285, 7.683243771867955],
              [7.650401488413951, 7.678734210081323],
              [7.647089051718166, 7.6749058339825424],
              [7.643436029077533, 7.675716148825533],
              [7.632882557917377, 7.674588022295745],
              [7.62826096186248, 7.67270399872868],
              [7.626753414191557, 7.668328876146646],
              [7.622018180082765, 7.665625594421164],
              [7.611398850226358, 7.6688536018627875],
              [7.598811720965046, 7.669880399896053],
              [7.59231239996693, 7.667419792339366],
              [7.577335726420241, 7.670579203789683],
              [7.572276979428179, 7.670517925243918],
              [7.565298362195728, 7.673936766224741],
              [7.555048784426597, 7.676953762931006],
              [7.540897404482333, 7.6778497655179345],
              [7.536186882365009, 7.677111600659031],
              [7.530451587999255, 7.672824563672126],
              [7.529104334722753, 7.668304293491273],
              [7.525829279897037, 7.668103997793321],
              [7.526510891734501, 7.663996748686675],
              [7.520552462950571, 7.660590609772559],
              [7.513147271915753, 7.662971069473096],
              [7.503902897938198, 7.662142743863972],
              [7.49034580932001, 7.792867875179376],
              [7.4807571951981435, 7.877597157103189],
              [7.474813786391109, 7.9338205646794755]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.08752248557786, "lat": 46.08057810086589 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26097"],
        "coty_name": ["Mackinac"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mackinac County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01622991"
      },
      "bbox": [
        7.474813786391109, 7.531774518505468, 8.712913030622898,
        7.991835507850097
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.830093499456128, 4.852454910554715],
            [9.8870803222242, 4.862149687932567],
            [9.901565351635721, 4.866802691009909],
            [9.91545381471091, 4.869274871854534],
            [9.957649730021771, 4.875985667555481],
            [10.048007207506485, 4.889623130850627],
            [10.062800485050596, 4.892108116345927],
            [10.091419872715143, 4.8975121204917365],
            [10.099430305096835, 4.854950439278057],
            [10.116267732434071, 4.759806619776821],
            [10.125247424891034, 4.708423602727387],
            [10.13262315117651, 4.706402225955991],
            [10.130345230397227, 4.703449297506082],
            [10.14525270049558, 4.691612579660977],
            [10.14300499880517, 4.6881772271817725],
            [10.135585120820053, 4.6872744291537165],
            [10.130614921578232, 4.685591610144733],
            [10.127376438469586, 4.682536565995345],
            [10.124877000000224, 4.677576120257253],
            [10.1254173364068, 4.67486805925591],
            [10.117088864359522, 4.673597200560347],
            [10.112936641710428, 4.669916883697641],
            [10.108887041779823, 4.663374324805315],
            [10.109746865226912, 4.656144764089151],
            [10.100161534824128, 4.65240091489695],
            [10.095475546585435, 4.649757087105848],
            [10.086673178170443, 4.651466053433342],
            [10.083279327502598, 4.649879156497725],
            [10.0780106715115, 4.643811781007615],
            [10.073388455589662, 4.635136180145874],
            [10.070435091983132, 4.619936612160157],
            [10.071768061110006, 4.60901906905518],
            [10.078492727171458, 4.605301468974251],
            [10.093557478184229, 4.60141581311709],
            [10.093824497832024, 4.5966596073050745],
            [10.0994914932335, 4.589571324145661],
            [10.099098272805527, 4.581772486118412],
            [10.102391301208955, 4.576435311219739],
            [10.10361133542417, 4.571871414600864],
            [10.106275722733633, 4.568652521292361],
            [10.1051554075804, 4.5613786573431865],
            [10.101151865235511, 4.565682086315288],
            [10.09528032700327, 4.56749695359779],
            [10.085531023737781, 4.5664670060321075],
            [10.0813236214715, 4.564198004759133],
            [10.077708812135395, 4.564746353494516],
            [10.068542086873311, 4.560549776193217],
            [10.061552827454417, 4.55309174338983],
            [10.059278139704192, 4.54699269241646],
            [10.059690721835088, 4.541028629351244],
            [10.053941912416276, 4.532275958662283],
            [10.047473449989193, 4.518155045444369],
            [10.047978078161066, 4.515204554144421],
            [10.045541051472824, 4.512474391518392],
            [10.042925970430463, 4.489321432174954],
            [10.045141291965766, 4.468010186328415],
            [10.044821414029515, 4.4648042775359045],
            [10.050788824982376, 4.460979925020341],
            [10.0534639063683, 4.44941163723847],
            [10.055690763017791, 4.446306112581956],
            [10.059417196149091, 4.444772110359209],
            [10.058622287423834, 4.440818259848983],
            [10.016312391858381, 4.434572581558575],
            [9.98917054252282, 4.43008915335865],
            [9.946810322337834, 4.422524694660366],
            [9.918510525206594, 4.417741920092172],
            [9.904348953900207, 4.415703322698186],
            [9.889867890052956, 4.50248215053109],
            [9.88695481007566, 4.516855308228259],
            [9.87974518258309, 4.5600468836125545],
            [9.876027139662483, 4.581101770672874],
            [9.86203675225304, 4.662883603860522],
            [9.85095568084412, 4.728480024601482],
            [9.844580851261474, 4.76530635260447],
            [9.830093499456128, 4.852454910554715]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.93237675601722, "lat": 42.69577013022876 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26099"],
        "coty_name": ["Macomb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macomb County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01622992"
      },
      "bbox": [
        9.830093499456128, 4.415703322698186, 10.14525270049558,
        4.8975121204917365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.28638806686071566, 7.08314214314632],
            [0.35324815344460947, 7.083037902646842],
            [0.37288612823360495, 7.082790174219991],
            [0.4595956624396829, 7.082535209270833],
            [0.5173951105480439, 7.082700396228916],
            [0.6323436500054188, 7.083230576613104],
            [0.6324032658225779, 7.0400258802567555],
            [0.6327216846901358, 6.996737060548253],
            [0.6327203652820651, 6.910094082225486],
            [0.6403153948289565, 6.910136490408104],
            [0.6404687262163797, 6.896257233193791],
            [0.6406805064658805, 6.824421621472684],
            [0.6410212059068253, 6.7382418662165655],
            [0.59779972625139, 6.7381307688411685],
            [0.511120002741502, 6.73806634311329],
            [0.46775453368203235, 6.738125245542871],
            [0.3815811309612947, 6.7377393003444395],
            [0.3383965604767097, 6.7378099780867595],
            [0.2943694365924976, 6.738573093157436],
            [0.2948774599718497, 6.838314131331814],
            [0.29473646107822626, 6.910290656804431],
            [0.2866196649522318, 6.910228246648455],
            [0.2861743347903556, 6.99676721623029],
            [0.28638806686071566, 7.08314214314632]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.00028196860573, "lat": 45.58612871349435 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27149"],
        "coty_name": ["Stevens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stevens County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00659519"
      },
      "bbox": [
        0.2861743347903556, 6.7377393003444395, 0.6410212059068253,
        7.083230576613104
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.287717937047429, -3.5192195730425095],
            [6.317221874903126, -3.516890598977505],
            [6.399951064654212, -3.5103125595282276],
            [6.497569226843294, -3.50243568121135],
            [6.57937112384951, -3.4957724447684466],
            [6.646048663324087, -3.490865957211846],
            [6.65979561359013, -3.489782926357316],
            [6.664218098302654, -3.5560384376246965],
            [6.669595331296441, -3.631624227412013],
            [6.673937164376915, -3.6867268467646377],
            [6.677643157321219, -3.730662484330637],
            [6.621277313418967, -3.7350313439120213],
            [6.533611499228853, -3.7416139736027616],
            [6.497708545306587, -3.7444314427776737],
            [6.418489318354423, -3.749840150626311],
            [6.3907849606072675, -3.7519823743121226],
            [6.3626969027924805, -3.7539480987648446],
            [6.354964572466907, -3.6517845666573368],
            [6.297760934468553, -3.6562719705564914],
            [6.29665464481609, -3.639740867919944],
            [6.293531496087429, -3.6011872428237512],
            [6.287717937047429, -3.5192195730425095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.58025070812128, "lat": 34.88081619709366 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28003"],
        "coty_name": ["Alcorn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alcorn County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00711755"
      },
      "bbox": [
        6.287717937047429, -3.7539480987648446, 6.677643157321219,
        -3.489782926357316
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.745415017183898, -6.794011863648116],
            [5.779455110089638, -6.789651431745964],
            [5.805801058346587, -6.785505440551424],
            [5.831218925389576, -6.782362982002885],
            [5.857656874782679, -6.778515532826536],
            [5.956782144168951, -6.764351140254322],
            [5.972801598136199, -6.761707767303556],
            [6.003481463025897, -6.757383350353283],
            [6.009449241016388, -6.756858947453569],
            [6.042692955796538, -6.751832390872949],
            [6.046029818946742, -6.795397899682525],
            [6.055590048157847, -6.924007838193324],
            [6.061582756308643, -7.005915820456613],
            [6.066283115111821, -7.065196934307535],
            [6.06970619775917, -7.112523323109998],
            [6.025242268526871, -7.115580297670867],
            [5.9763336392673905, -7.119044379519256],
            [5.935674094054301, -7.12174981584628],
            [5.9106144389632105, -7.123688723771176],
            [5.905131074079564, -7.044417592056035],
            [5.9028254605497, -7.04196561205297],
            [5.8979594498764945, -7.044671556995902],
            [5.895982449792663, -7.041717016635729],
            [5.896118993527842, -7.032647589867317],
            [5.890915764189106, -7.0274888633702695],
            [5.893183091597699, -7.024042244788832],
            [5.889886663260909, -7.0200790223910445],
            [5.883908254714427, -7.020480775627836],
            [5.878332311910956, -7.017104845962631],
            [5.876834543458067, -7.013820962201898],
            [5.87129059962192, -7.008933184053765],
            [5.866916016091974, -7.008006249427495],
            [5.863882969372867, -7.0041601241172495],
            [5.859693056600965, -7.002057879940757],
            [5.839096697429186, -6.9998501843557275],
            [5.833445156966198, -6.997320113028095],
            [5.828782267876402, -6.998335961336257],
            [5.824998542103971, -6.994813714613001],
            [5.817004986089959, -6.99060748157335],
            [5.813747974549119, -6.98782597378124],
            [5.806006416459035, -6.987353657586578],
            [5.803485210491221, -6.983678209047248],
            [5.7989982164083225, -6.980177006567819],
            [5.789893121368887, -6.976684462166328],
            [5.78833109820432, -6.972715668605935],
            [5.782704506910976, -6.968855831616732],
            [5.782269666443912, -6.966437063425025],
            [5.77802340552725, -6.962462269997518],
            [5.777028295620967, -6.959387908082145],
            [5.773172823691609, -6.956385102330472],
            [5.755856392506959, -6.958106278290638],
            [5.750751625601968, -6.878522945368023],
            [5.745415017183898, -6.794011863648116]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.55260225423406,
          "lat": 31.633195247892456
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28031"],
        "coty_name": ["Covington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Covington County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00695740"
      },
      "bbox": [
        5.745415017183898, -7.123688723771176, 6.06970619775917,
        -6.751832390872949
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.166855553256567, -5.298935212165516],
            [5.168601272375117, -5.297854303601121],
            [5.170183230593923, -5.290248601146389],
            [5.173196002315949, -5.289471745954925],
            [5.178485065476584, -5.291701380509423],
            [5.180379205460079, -5.2895950319563845],
            [5.177495277886794, -5.283716353723902],
            [5.1833246119009075, -5.280308683660737],
            [5.186775181936619, -5.28141024340157],
            [5.189229408659284, -5.285280706433092],
            [5.187533867584783, -5.289160006684535],
            [5.190921692680253, -5.290289230765794],
            [5.193630808493605, -5.286285984436869],
            [5.196493379305967, -5.285064273097616],
            [5.201161674216048, -5.287966292519227],
            [5.203711200714705, -5.285363121890903],
            [5.198942296241477, -5.280767011409941],
            [5.198493110831821, -5.2760687253735865],
            [5.200203806474466, -5.271587512318003],
            [5.206891074453237, -5.26380987168858],
            [5.207695459569403, -5.259654844739914],
            [5.20515773935013, -5.251317217028388],
            [5.200811618759754, -5.243524649008946],
            [5.193592493840685, -5.23812746618492],
            [5.1806356905441024, -5.2368066422084505],
            [5.17846549234547, -5.23861046324642],
            [5.174447316736775, -5.238015413367499],
            [5.1715868204872795, -5.235538278069122],
            [5.170250741266991, -5.2310166889464655],
            [5.170859665780572, -5.2260889107675395],
            [5.174314816373292, -5.227211870529986],
            [5.237257631379562, -5.2445018543170026],
            [5.295053648975295, -5.260522459091434],
            [5.339735469636933, -5.272671900927537],
            [5.44011224859427, -5.3000892288938815],
            [5.442752207716122, -5.301004841341203],
            [5.536335824907398, -5.326171251266643],
            [5.605422175945954, -5.34428067143928],
            [5.655047948083885, -5.357142100336482],
            [5.654822601924552, -5.366215274727336],
            [5.648758762375149, -5.3770446022312735],
            [5.647261471344895, -5.376096123196398],
            [5.6338076586885855, -5.3792985643997016],
            [5.63227054443401, -5.3817158048365465],
            [5.6358704149746, -5.388680497023619],
            [5.632745715684981, -5.391476489688878],
            [5.635892326899087, -5.399069107244515],
            [5.632942720035407, -5.401797327236891],
            [5.630148342456889, -5.411410184595358],
            [5.626978708170499, -5.412082750202034],
            [5.625654851835702, -5.415121326082172],
            [5.621764460086641, -5.414556268500767],
            [5.621265264362705, -5.421296637775859],
            [5.62403076394009, -5.4286638135187895],
            [5.6232906567345795, -5.434377318240663],
            [5.621528697340914, -5.435997176472482],
            [5.623732039834891, -5.443305252057605],
            [5.622316351465531, -5.449757276422043],
            [5.619373401306919, -5.454010178420449],
            [5.614210098248725, -5.457549713069629],
            [5.614767592238522, -5.461766609966143],
            [5.608151475964752, -5.459547518446921],
            [5.601631676776441, -5.461574718373139],
            [5.600519799451477, -5.471611544225347],
            [5.604567034601028, -5.475275881085079],
            [5.604394655403688, -5.477753836280772],
            [5.600701695105958, -5.4808634758316845],
            [5.6015830193579275, -5.484060223198593],
            [5.598863937195878, -5.486798393153987],
            [5.598597554727668, -5.492144534511711],
            [5.601443903708556, -5.494604572541674],
            [5.600481432578657, -5.499333099231396],
            [5.603467334317854, -5.499443888454185],
            [5.604600382332376, -5.503768574387797],
            [5.602886157492406, -5.511498106811329],
            [5.597214052987861, -5.51269748718737],
            [5.591389225394316, -5.51607363613154],
            [5.5907475646788605, -5.528540495875181],
            [5.59438623659893, -5.5344697099052365],
            [5.591031615729683, -5.541320471592791],
            [5.584569901899194, -5.5474278749208645],
            [5.578633116215593, -5.556127497359774],
            [5.579689582951885, -5.559186994259851],
            [5.57480016139659, -5.5657930240557345],
            [5.5700120838742135, -5.5674510084223705],
            [5.57054921265725, -5.570142434234234],
            [5.565949787619245, -5.577250858169898],
            [5.560316743330307, -5.579711135139426],
            [5.559871431091043, -5.582209627508023],
            [5.563018596434951, -5.585486173834854],
            [5.558600562947378, -5.59124230836682],
            [5.555031106449478, -5.598439998399873],
            [5.559279794980952, -5.604828222171491],
            [5.558126038468604, -5.60725351098631],
            [5.553023395395116, -5.611312637434929],
            [5.552221953822304, -5.6172405391249685],
            [5.556410062349765, -5.61897725205805],
            [5.550788411367854, -5.630754890296679],
            [5.553363816702135, -5.633363573956164],
            [5.548426134240556, -5.635712575837972],
            [5.549505267521141, -5.642236096192217],
            [5.551882472790002, -5.643377388638159],
            [5.549748778555828, -5.649227344424609],
            [5.546590921432086, -5.6518173768677675],
            [5.535458035101232, -5.655622736039113],
            [5.533842439923765, -5.657677320364339],
            [5.5356495490593955, -5.664306613496412],
            [5.531041490074877, -5.669113373909934],
            [5.522668261816795, -5.673599509095216],
            [5.518588966761165, -5.6773503528081],
            [5.522015563556323, -5.6810894615244205],
            [5.516972202019265, -5.6883024563808755],
            [5.508021949278911, -5.692531331513626],
            [5.503144337459845, -5.6909413444379355],
            [5.501554185228074, -5.696190613395021],
            [5.496915785869849, -5.70350259489944],
            [5.453816551364585, -5.688528209257212],
            [5.373172118982942, -5.660336492612486],
            [5.233881968483153, -5.611022142183914],
            [5.217250031022203, -5.604558336968652],
            [5.197674072513891, -5.598621732789456],
            [5.178800659313442, -5.592022630722238],
            [5.179643358766873, -5.588004439898947],
            [5.174760084018123, -5.58118653138175],
            [5.171511105958877, -5.580160101968041],
            [5.168918563284959, -5.582083638934532],
            [5.167714903417472, -5.588378627624193],
            [5.165774783235298, -5.5908472874860875],
            [5.157401638637382, -5.592823357166775],
            [5.149711557600815, -5.59058950893396],
            [5.141853182067192, -5.5827934144935725],
            [5.1408483166999925, -5.578441943976711],
            [5.142860193928641, -5.567296533296483],
            [5.142330298668628, -5.561740915436378],
            [5.138766221360077, -5.556836523806714],
            [5.132250475410904, -5.554779636737432],
            [5.122079215777348, -5.557694909312405],
            [5.112372535846043, -5.556961418711784],
            [5.10379304428032, -5.551825234866815],
            [5.099735539417512, -5.545646508877383],
            [5.099156232226023, -5.535720303807139],
            [5.0970782019619065, -5.525255144199482],
            [5.097530038422439, -5.517300206238181],
            [5.096040781970204, -5.509857820045551],
            [5.103758326888641, -5.507226194320071],
            [5.102507689606357, -5.503482862320398],
            [5.099215063882745, -5.501444429589441],
            [5.097764356404148, -5.497555104273597],
            [5.098874381089861, -5.493264227813712],
            [5.101786951230437, -5.490337146057036],
            [5.104928112430382, -5.490155420919446],
            [5.108410168382608, -5.501922221705977],
            [5.113489946595829, -5.50452593515995],
            [5.118528785203169, -5.499913141704653],
            [5.124281634905614, -5.5003079912207635],
            [5.127554676383694, -5.503128353709948],
            [5.131516848468441, -5.513029196611006],
            [5.135453929830902, -5.517117697247304],
            [5.145598818547132, -5.519792288670646],
            [5.1507189612568975, -5.516538646616906],
            [5.152182042049014, -5.510797221759821],
            [5.15114835918709, -5.507964027738282],
            [5.143899881256626, -5.503962193121989],
            [5.137092957865339, -5.498244648440501],
            [5.132813790650799, -5.4917113353306375],
            [5.134953322875259, -5.482937198489385],
            [5.140364579256714, -5.478491335710857],
            [5.146543385327675, -5.478193984663135],
            [5.149537271969283, -5.482915955136705],
            [5.148812533414732, -5.4921118371142095],
            [5.150073062965168, -5.499872487636033],
            [5.1527970974490644, -5.502557696856043],
            [5.156370303197435, -5.509114532735297],
            [5.160691575768797, -5.508753462110136],
            [5.166145440752131, -5.5013982975312805],
            [5.162035587475126, -5.496418062653057],
            [5.158406379698906, -5.489859528011839],
            [5.158227838202558, -5.483381594999952],
            [5.164367210260496, -5.4705584203033],
            [5.171823039504679, -5.466585086232609],
            [5.1776546580015665, -5.466445381613375],
            [5.177816327387247, -5.4639445526393535],
            [5.174735415779747, -5.415076473368252],
            [5.166855553256567, -5.298935212165516]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.0920312089193, "lat": 33.12356195894454 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28051"],
        "coty_name": ["Holmes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Holmes County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00695749"
      },
      "bbox": [
        5.096040781970204, -5.70350259489944, 5.655047948083885,
        -5.2260889107675395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.853453580943152, -7.127384745937119],
            [5.883098118926034, -7.125255656849558],
            [5.9106144389632105, -7.123688723771176],
            [5.935674094054301, -7.12174981584628],
            [5.9763336392673905, -7.119044379519256],
            [6.025242268526871, -7.115580297670867],
            [6.031759911727628, -7.202632652168321],
            [6.119346507615226, -7.196271797216881],
            [6.121683899998493, -7.231426326715939],
            [6.124033559837078, -7.261921528805465],
            [6.126752309393842, -7.302601086395197],
            [6.1298793238699885, -7.3550164484829805],
            [6.133151659244706, -7.405874498490758],
            [6.14202047148951, -7.530204596350372],
            [6.0773790142625, -7.534925929247126],
            [6.078845941683951, -7.562397230846554],
            [6.064967452020764, -7.562918699875344],
            [6.035595685347664, -7.5649087952344996],
            [6.034395457191389, -7.546589745080887],
            [6.012686746919715, -7.54796873394833],
            [6.011736308603122, -7.533515814358643],
            [5.9685361913724915, -7.536504022134697],
            [5.969640233716522, -7.550425215765346],
            [5.907175570827788, -7.55402677744058],
            [5.8824771137398875, -7.555666738220139],
            [5.874679454034557, -7.4366151747543],
            [5.870527216602819, -7.377245230297319],
            [5.8686407183400595, -7.347517816096049],
            [5.863893425695854, -7.277065262454006],
            [5.859608478048522, -7.218610595651453],
            [5.858531763069201, -7.20104149863803],
            [5.855245808878276, -7.156357212297608],
            [5.853453580943152, -7.127384745937119]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.5086707178821, "lat": 31.206011432030802 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28073"],
        "coty_name": ["Lamar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lamar County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00695760"
      },
      "bbox": [
        5.853453580943152, -7.5649087952344996, 6.14202047148951,
        -7.115580297670867
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.334102856147966, -4.1517117091151805],
            [6.331757429643561, -4.122515192284244],
            [6.360630297882012, -4.120534341738881],
            [6.356264025823896, -4.06276230605967],
            [6.353166476730471, -4.019012045106273],
            [6.396206131021875, -4.016012917086822],
            [6.3952769698916, -4.00170767633349],
            [6.488528894166251, -3.994180209874125],
            [6.499763500121484, -3.9931159903369906],
            [6.520183122723042, -3.9921109142344804],
            [6.5539411249319155, -3.9891403738280875],
            [6.554552193429987, -4.002749918407859],
            [6.557142517839648, -4.033188076576448],
            [6.56291060947436, -4.10850649105615],
            [6.567120112779164, -4.160778503366193],
            [6.5653290544236, -4.1637756594076585],
            [6.569927328806791, -4.222275775589524],
            [6.576363969069087, -4.3003971390908005],
            [6.578411168470371, -4.318804512167114],
            [6.582180112593655, -4.368845819167426],
            [6.5858235638112985, -4.410268415761723],
            [6.521195806648728, -4.41535562537623],
            [6.51286657516129, -4.415725004620198],
            [6.470665203967734, -4.4190462416690774],
            [6.442126798025126, -4.4211005650239645],
            [6.443047546985592, -4.43596181237178],
            [6.431040619406022, -4.436563367046902],
            [6.3564942686844965, -4.442107081521715],
            [6.351039369412193, -4.369042435585397],
            [6.340798628785959, -4.244944737392708],
            [6.335824858322578, -4.180182092694736],
            [6.336356222090835, -4.179204457961036],
            [6.334102856147966, -4.1517117091151805]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.68041147883518, "lat": 34.28990653012599 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28081"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00695764"
      },
      "bbox": [
        6.331757429643561, -4.442107081521715, 6.5858235638112985,
        -3.9891403738280875
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3523292039665096, -1.5950363156609608],
            [2.425039842075645, -1.5940758168769438],
            [2.445957272056401, -1.594128261235281],
            [2.478542950505672, -1.5936566957908578],
            [2.540333099704873, -1.5931140908970474],
            [2.598203091563759, -1.5921869006722433],
            [2.6248137788133463, -1.592132480991962],
            [2.6751648190144235, -1.5928080076981375],
            [2.6966079536247927, -1.592925636757865],
            [2.7818774516313693, -1.5925537762769848],
            [2.8384839168103593, -1.5918217583739287],
            [2.8672698070923026, -1.5909218984689821],
            [2.8674798758585265, -1.5917301195344673],
            [2.9101891951442562, -1.5919895843176948],
            [2.910391280923906, -1.6066966456633158],
            [2.91104698407946, -1.6214220906750063],
            [2.911773893642668, -1.6796801492107527],
            [2.9127031177959397, -1.7385378049929294],
            [2.913331876653248, -1.8116077169052895],
            [2.9141861861447116, -1.8705944799555925],
            [2.8565185767789947, -1.8706764637180402],
            [2.8070716612537123, -1.8710579058254384],
            [2.73031038174927, -1.8714973143110025],
            [2.6008605370741678, -1.8723685262874623],
            [2.5709815827435634, -1.8727706755316058],
            [2.5700900584666013, -1.766085001946685],
            [2.569664954778934, -1.6959375349748307],
            [2.53988896177726, -1.696226485771164],
            [2.4400267168312766, -1.697851468982772],
            [2.3970422398790703, -1.6979149779599096],
            [2.353958401177456, -1.6983218901303616],
            [2.3534571570594554, -1.6763256801578352],
            [2.3523292039665096, -1.5950363156609608]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.18884681770872, "lat": 36.96957216590477 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29043"],
        "coty_name": ["Christian"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Christian County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00758476"
      },
      "bbox": [
        2.3523292039665096, -1.8727706755316058, 2.9141861861447116,
        -1.5909218984689821
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.103475489414026, 0.5334028133645048],
            [4.160885875870725, 0.5354871138891715],
            [4.159998539038182, 0.5649537430706574],
            [4.159466660143623, 0.5942216069805792],
            [4.15830757937863, 0.6244942614334867],
            [4.178591789255556, 0.6255583163798294],
            [4.2374374125392, 0.6264676810411931],
            [4.282226229561722, 0.6285058429423727],
            [4.298536835688104, 0.6289301266296801],
            [4.336157974236682, 0.6313402134539886],
            [4.378742151951293, 0.6338332323302094],
            [4.461388329427487, 0.6371835844238104],
            [4.461605695007645, 0.6373956995564025],
            [4.51179292646561, 0.6401246801938111],
            [4.515982564902251, 0.630048840126024],
            [4.516684857502168, 0.6134071787715476],
            [4.519689568279962, 0.6013341939160866],
            [4.52317365916344, 0.5924870159553933],
            [4.525390324177041, 0.5711195076680139],
            [4.529113247820807, 0.5592351157699704],
            [4.533155210990953, 0.5516618250088183],
            [4.537713117579751, 0.5460932597509014],
            [4.545207174908425, 0.5344848319082999],
            [4.549987669921868, 0.5173657742079554],
            [4.549406353431996, 0.5049546037593039],
            [4.536767357760245, 0.48750213955617777],
            [4.535802762773253, 0.48115989810866844],
            [4.528290898878193, 0.4721422532750935],
            [4.527628664073336, 0.46898392538182],
            [4.529605297783899, 0.4618348540469672],
            [4.53269803817094, 0.4574205138969255],
            [4.539039341935073, 0.4444388153691629],
            [4.546032324288015, 0.4322725083784866],
            [4.549315896201569, 0.4230378514849806],
            [4.55498255465162, 0.41469509897383866],
            [4.558351996567697, 0.407879242962137],
            [4.5601707374662945, 0.40013923526104017],
            [4.561756244365112, 0.3780257561088539],
            [4.56771368850457, 0.36423918851640835],
            [4.56972973619908, 0.35644855811954096],
            [4.572963497543947, 0.35042255533844036],
            [4.551308592908739, 0.34922245170561356],
            [4.547544216143236, 0.3475447940366715],
            [4.547113517086956, 0.3428357200514795],
            [4.553446709821068, 0.3386007062551211],
            [4.557844142635006, 0.3323000249775093],
            [4.550611910155641, 0.33026435607207133],
            [4.548017756502226, 0.33066650371555617],
            [4.544921415578394, 0.33428676350823794],
            [4.539917309583061, 0.33569842117516135],
            [4.5324281502728345, 0.3290987288684428],
            [4.535447001033862, 0.3259327398376928],
            [4.538359270169513, 0.3276350381720295],
            [4.543538858059611, 0.3265455002939945],
            [4.546836554131603, 0.3223225783334774],
            [4.5419188971906745, 0.31754518116536706],
            [4.5394405280443655, 0.3170682737721242],
            [4.538110087764371, 0.32206344571474765],
            [4.532674254867084, 0.3239956323305043],
            [4.527341419155816, 0.32316318491904555],
            [4.528104039147933, 0.3275376282527513],
            [4.525720496942044, 0.32855495384644035],
            [4.520049725003544, 0.3272947129819325],
            [4.519017861435424, 0.33273544293869345],
            [4.525424745413218, 0.3360468015968306],
            [4.527067084839162, 0.33947505322601224],
            [4.522821245736357, 0.3445066248166693],
            [4.513489427286966, 0.343609952701161],
            [4.510366646061823, 0.34214575266930886],
            [4.507566842896301, 0.336625432202502],
            [4.50395918306938, 0.3329515357631835],
            [4.499188296301272, 0.33173555597733967],
            [4.493346812698377, 0.3339656801874535],
            [4.485322613645533, 0.3336847235139193],
            [4.482619731950193, 0.3295631920324972],
            [4.475471569735403, 0.32849929030751884],
            [4.465784664972004, 0.32113706334171094],
            [4.4708612629046875, 0.31652395885438683],
            [4.469622446338288, 0.3111676361927552],
            [4.4651291386855565, 0.3115900906265425],
            [4.463410709328799, 0.30929174601207887],
            [4.464731186549086, 0.3050067955661289],
            [4.462732407884792, 0.2951507572285218],
            [4.466174914054327, 0.2886763091977263],
            [4.46076548462815, 0.2883179199528662],
            [4.457401643845567, 0.2851128422393318],
            [4.453608068554816, 0.2853366577607562],
            [4.450188607935514, 0.28775102642695666],
            [4.447061894093907, 0.2868203466396506],
            [4.437647160840339, 0.2916099658731312],
            [4.427653377784434, 0.29234899622870997],
            [4.425146205450346, 0.28931625726665877],
            [4.420791910509268, 0.29516270692436936],
            [4.415628418947396, 0.2957511853559963],
            [4.408278263207929, 0.29514523477847854],
            [4.406480260730946, 0.29325355131464625],
            [4.395667481470409, 0.2919689419467544],
            [4.392474238445793, 0.29510480667704697],
            [4.387346181193805, 0.29639382888385296],
            [4.376486437629839, 0.2923289559144642],
            [4.374058173598043, 0.2934175314688625],
            [4.3683236490672925, 0.2903529707607956],
            [4.364782835622118, 0.29237135083432164],
            [4.362641708817859, 0.29062529970520484],
            [4.359049405110534, 0.2951224467364801],
            [4.355218456129043, 0.2976273161627966],
            [4.348894867150654, 0.2967826574806048],
            [4.349339922939877, 0.274137491104734],
            [4.310276615402344, 0.27324174938974954],
            [4.260539100703844, 0.2713704907280295],
            [4.247763293019446, 0.2703226181986853],
            [4.2316478427118085, 0.2698480801425665],
            [4.229393733132394, 0.3295754157844393],
            [4.168471433157841, 0.32671654101210623],
            [4.167170588598838, 0.35711341751497494],
            [4.166143520715938, 0.38724475624465365],
            [4.144533107519833, 0.3863137500537631],
            [4.1193387606285965, 0.38558278903822657],
            [4.10776033489852, 0.3849377702924385],
            [4.106442285550263, 0.42959412566532756],
            [4.105198568326202, 0.46290853911754914],
            [4.1049638035868545, 0.4780605073999277],
            [4.103475489414026, 0.5334028133645048]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.9600322275098, "lat": 39.05802532758834 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29113"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00758511"
      },
      "bbox": [
        4.103475489414026, 0.2698480801425665, 4.572963497543947,
        0.6401246801938111
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.7476805291875825, -1.5223194690447868],
            [5.765595580830256, -1.538636156086275],
            [5.776500754918951, -1.5414254306648685],
            [5.779866216044333, -1.5393403975428392],
            [5.785729119297728, -1.5330488093216774],
            [5.78760331044751, -1.529123319272157],
            [5.79116783751959, -1.5132406601612551],
            [5.788721167118897, -1.5055297452248906],
            [5.783379937290967, -1.5004496667159664],
            [5.773833994594029, -1.4935806178415294],
            [5.762907478640125, -1.4900349444433252],
            [5.754552216661341, -1.4859966970728098],
            [5.749411006132003, -1.4808446179241694],
            [5.746182799042057, -1.473518487411051],
            [5.74778611038563, -1.4615087065901902],
            [5.7587418163667765, -1.4630719388673425],
            [5.766944742367936, -1.4631081957673493],
            [5.769661811995216, -1.4644458959024764],
            [5.782217921198883, -1.463970812810274],
            [5.78585623667526, -1.4644643983822627],
            [5.7892337600721735, -1.4561866967648582],
            [5.797570227175938, -1.4699947011794612],
            [5.804471701982929, -1.4846114302493671],
            [5.808183904649902, -1.4899893988651733],
            [5.815388538409275, -1.4957494514742726],
            [5.8323066906566305, -1.5057017229258367],
            [5.835935097294117, -1.5093712357189113],
            [5.838073832033339, -1.5137120131816344],
            [5.841645430522234, -1.5252672941626138],
            [5.842380288850251, -1.535620246054748],
            [5.845407880562191, -1.5452926278622212],
            [5.851089487128345, -1.5514390999942558],
            [5.85779590695727, -1.553621700858974],
            [5.86354227101607, -1.553802416434249],
            [5.869867099533533, -1.5508475403798365],
            [5.878892860794708, -1.5452705637182595],
            [5.88591925888902, -1.5429618389837074],
            [5.892131116056546, -1.5396953503345954],
            [5.898046030460965, -1.5379525942167331],
            [5.903505584562542, -1.5391963369348156],
            [5.910839894660199, -1.5440438914655985],
            [5.916565599856755, -1.550573230602307],
            [5.919535844714394, -1.5555761134456072],
            [5.920618834963468, -1.5622705317436536],
            [5.92011818968082, -1.576320849335558],
            [5.915067420088826, -1.600909586492689],
            [5.910988913801707, -1.634305387345951],
            [5.904886368518654, -1.6502123500571766],
            [5.9018107549988414, -1.6652447780225241],
            [5.897783236349084, -1.6757437122102072],
            [5.885549691669293, -1.6773849864315256],
            [5.881140905296546, -1.6818463176852454],
            [5.875308562547361, -1.68224212051069],
            [5.870305333594023, -1.6853573110825946],
            [5.866940468651763, -1.6908808931040578],
            [5.866592293946043, -1.6941619142465623],
            [5.867913132525856, -1.709055810610147],
            [5.867658552097986, -1.7127560174949743],
            [5.86950053119358, -1.718336202940882],
            [5.875184804487478, -1.7271852953433136],
            [5.883770306820201, -1.7338570896871546],
            [5.887844782196641, -1.7353724951554592],
            [5.909286003264716, -1.7352895826494295],
            [5.913768025325683, -1.7374129067011315],
            [5.919721657734245, -1.7467460382043027],
            [5.9205344880481645, -1.7548321191574228],
            [5.9190156019078906, -1.7627887219985827],
            [5.91411469011194, -1.7713058735987297],
            [5.906670848831741, -1.7716209482463978],
            [5.901043957804165, -1.7685744879132728],
            [5.889383530946612, -1.7688099343415007],
            [5.881283403088419, -1.765685356629964],
            [5.871519149329639, -1.7699297022274327],
            [5.867759387229628, -1.7727230158243363],
            [5.862658808888942, -1.7795853421086079],
            [5.858270720701087, -1.7877963703953152],
            [5.85707017563872, -1.7931382035610022],
            [5.856690666307161, -1.8017091906811913],
            [5.858633562022027, -1.8114107429105069],
            [5.86164874855759, -1.8152697611169095],
            [5.871682068435148, -1.8254549762773176],
            [5.879750031312522, -1.8322383636003066],
            [5.8843280334417365, -1.8370504763635083],
            [5.885765041284933, -1.8403503749705628],
            [5.886192538151267, -1.8541006767223094],
            [5.894235860123664, -1.8591261186004575],
            [5.8903119436568, -1.8657013466847698],
            [5.883022291032329, -1.8759977610784626],
            [5.873341376934265, -1.8861596575480528],
            [5.866368525578332, -1.898980123973972],
            [5.8645696335699835, -1.9099927862615536],
            [5.864415199932448, -1.9267971465510043],
            [5.857270661818628, -1.9490133173109474],
            [5.854474143012134, -1.9532188673323203],
            [5.84712885073432, -1.9606054684580143],
            [5.839993280417342, -1.963694537666732],
            [5.822846915494205, -1.9668116533115318],
            [5.814835209029547, -1.9633746444036353],
            [5.805575846836785, -1.955138658372457],
            [5.7919760094246024, -1.9398860800285964],
            [5.785789955317128, -1.9297940917754848],
            [5.775214279975538, -1.9143737652596717],
            [5.771097887076521, -1.9096677499828747],
            [5.763111010745221, -1.9030128697761979],
            [5.762295643785244, -1.890147597396747],
            [5.7547774593074745, -1.8907858699454148],
            [5.754269376323465, -1.883531539096528],
            [5.747151746400936, -1.8842825984426175],
            [5.745920361802228, -1.8692295045937182],
            [5.738883500712959, -1.8698063110010814],
            [5.738549399623169, -1.8627419606782059],
            [5.731031850565255, -1.8629612755554228],
            [5.730198954512364, -1.8486902242915433],
            [5.723026461621667, -1.8491204072024396],
            [5.721539385317797, -1.8343546844346843],
            [5.707505016587533, -1.8353703328967381],
            [5.706323580378471, -1.8208136857209074],
            [5.6992370684435105, -1.8212378343823457],
            [5.6982865553661055, -1.8086182192110374],
            [5.6858646292041195, -1.7999590741415088],
            [5.683271378911084, -1.8001388840389787],
            [5.682804971835602, -1.7927637011407604],
            [5.675554821595144, -1.7934722932429221],
            [5.674472792107731, -1.7791883350010427],
            [5.667517997647431, -1.779869733324216],
            [5.666987433972043, -1.7723977028664704],
            [5.6598826889526785, -1.7731899610358488],
            [5.658592327788146, -1.7513637621979334],
            [5.644682437816428, -1.7527152782894542],
            [5.643397631279903, -1.7382596073939676],
            [5.636298450778505, -1.738703539001635],
            [5.635654247140726, -1.724157084528642],
            [5.626853157696121, -1.7247152001147628],
            [5.625686649570813, -1.7096217968402017],
            [5.610936669947799, -1.7106449424375467],
            [5.60988089855401, -1.6957784329789023],
            [5.5959344097132755, -1.6964029364755289],
            [5.594354907512618, -1.6745385242999897],
            [5.593807126903331, -1.6671711619432035],
            [5.608312243556873, -1.6661907982584345],
            [5.60627993549135, -1.6366534020558097],
            [5.634956697761967, -1.6347081754974382],
            [5.632784735195599, -1.6050238663742444],
            [5.6607848912553935, -1.6032126240651001],
            [5.6598031881665625, -1.5884550670741076],
            [5.674356564426881, -1.5875758967507838],
            [5.673481852075658, -1.5728127542399086],
            [5.702067694428586, -1.570661310695598],
            [5.700601133913973, -1.5410802321115518],
            [5.721367549177141, -1.5318450084062052],
            [5.7209411512166115, -1.5246576139848345],
            [5.7476805291875825, -1.5223194690447868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.29114783403178, "lat": 36.82806321892845 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29133"],
        "coty_name": ["Mississippi"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mississippi County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00758521"
      },
      "bbox": [
        5.593807126903331, -1.9668116533115318, 5.920618834963468,
        -1.4561866967648582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.262694939809697, -1.9394081571661748],
            [5.294394379726317, -1.938485043900327],
            [5.365979173516719, -1.9347448104455347],
            [5.380579377131148, -1.9336318019300969],
            [5.467342100340004, -1.9280104456541451],
            [5.465602356084383, -1.8997506775264401],
            [5.4651285192290615, -1.8979638881309473],
            [5.463169424696143, -1.868713662341427],
            [5.4585124963092335, -1.815713900213036],
            [5.4604708584528145, -1.814382538442909],
            [5.455670641070982, -1.7679726913620826],
            [5.448772210384546, -1.694784183751618],
            [5.459217905863924, -1.693856224793452],
            [5.491805554332606, -1.6905035453897368],
            [5.526792794097989, -1.6871692434458876],
            [5.527558570000434, -1.6825062076115929],
            [5.556510448191461, -1.675805227443997],
            [5.557334014432501, -1.677339565143751],
            [5.594354907512618, -1.6745385242999897],
            [5.5959344097132755, -1.6964029364755289],
            [5.60988089855401, -1.6957784329789023],
            [5.610936669947799, -1.7106449424375467],
            [5.625686649570813, -1.7096217968402017],
            [5.626853157696121, -1.7247152001147628],
            [5.635654247140726, -1.724157084528642],
            [5.636298450778505, -1.738703539001635],
            [5.643397631279903, -1.7382596073939676],
            [5.644682437816428, -1.7527152782894542],
            [5.658592327788146, -1.7513637621979334],
            [5.6598826889526785, -1.7731899610358488],
            [5.666987433972043, -1.7723977028664704],
            [5.667517997647431, -1.779869733324216],
            [5.674472792107731, -1.7791883350010427],
            [5.675554821595144, -1.7934722932429221],
            [5.682804971835602, -1.7927637011407604],
            [5.683271378911084, -1.8001388840389787],
            [5.6858646292041195, -1.7999590741415088],
            [5.6982865553661055, -1.8086182192110374],
            [5.6992370684435105, -1.8212378343823457],
            [5.706323580378471, -1.8208136857209074],
            [5.707505016587533, -1.8353703328967381],
            [5.721539385317797, -1.8343546844346843],
            [5.723026461621667, -1.8491204072024396],
            [5.730198954512364, -1.8486902242915433],
            [5.731031850565255, -1.8629612755554228],
            [5.738549399623169, -1.8627419606782059],
            [5.738883500712959, -1.8698063110010814],
            [5.745920361802228, -1.8692295045937182],
            [5.747151746400936, -1.8842825984426175],
            [5.754269376323465, -1.883531539096528],
            [5.7547774593074745, -1.8907858699454148],
            [5.762295643785244, -1.890147597396747],
            [5.763111010745221, -1.9030128697761979],
            [5.750378970856374, -1.905122928483166],
            [5.740443353797834, -1.9084001536880075],
            [5.733514445167503, -1.912303456054487],
            [5.729486175992066, -1.9168522048646062],
            [5.726316309491103, -1.9222531264068308],
            [5.724822481542215, -1.9300676060065713],
            [5.72392750430225, -1.9472900030165552],
            [5.722774959501791, -1.9549832998607637],
            [5.714022229327384, -1.9798197371211046],
            [5.713032318814526, -1.997405514494931],
            [5.70849085120401, -2.0120458614931165],
            [5.701299804083866, -2.0420288825828727],
            [5.6974702501913885, -2.0520330140540164],
            [5.687530911819314, -2.0678382660408032],
            [5.678925632552353, -2.078557158166368],
            [5.67547720814589, -2.0819652258720467],
            [5.666961267617542, -2.0866938572349545],
            [5.65707629070764, -2.0867092232757907],
            [5.64911882847234, -2.0834391831528603],
            [5.645307936959833, -2.079748708325017],
            [5.642981349451292, -2.0752606443404136],
            [5.64215309939818, -2.06664521002877],
            [5.647265000096341, -2.04729262884135],
            [5.649290003711671, -2.0424614667090455],
            [5.653148778510312, -2.03720189337766],
            [5.656440610060415, -2.030229508519388],
            [5.658929061363318, -2.022423232387841],
            [5.660536644847745, -2.0135599134040376],
            [5.660457248848402, -2.0072781292971835],
            [5.657877593885243, -1.996650820731157],
            [5.652542173727762, -1.9837987978210068],
            [5.6474028052247665, -1.9757700602778807],
            [5.642594704635868, -1.97244417919315],
            [5.630190115366934, -1.9687595725392264],
            [5.618665331157397, -1.9680326821576548],
            [5.608027489021804, -1.9653767415662375],
            [5.596262061522658, -1.9667653677696872],
            [5.588414365646052, -1.9707248789483267],
            [5.584340393363628, -1.974706694093033],
            [5.578048086682571, -1.9845360071708924],
            [5.575118373991717, -1.9965124132376149],
            [5.57568772631737, -2.001758589693611],
            [5.5858367345555795, -2.0232238424040387],
            [5.59119569655455, -2.0313686287524715],
            [5.6010501400211945, -2.042899407588668],
            [5.604489220131763, -2.049767203232579],
            [5.608675708768697, -2.0560571101470293],
            [5.6187870087722835, -2.0656084658349783],
            [5.621713196147591, -2.0713607320982645],
            [5.622118055139882, -2.079844309394402],
            [5.619888741419043, -2.0905430153087416],
            [5.617176130883975, -2.0958111179719485],
            [5.607054146414669, -2.1065977190493834],
            [5.6041756209068465, -2.113511453353006],
            [5.604558171772922, -2.121408657444726],
            [5.607356713852394, -2.128271979676771],
            [5.622262264309475, -2.14713251586788],
            [5.63235139272771, -2.1621717739665853],
            [5.635646700161906, -2.168554172496187],
            [5.636496080695368, -2.173278599670051],
            [5.634691072294093, -2.1872830794823015],
            [5.63083429973198, -2.1989684021036804],
            [5.628154931994634, -2.2030043239448234],
            [5.621269634512791, -2.20907781600894],
            [5.6109402428503135, -2.2122445026181405],
            [5.609288933953465, -2.1889138570449544],
            [5.6020525991956065, -2.1893972770729637],
            [5.601743669828119, -2.1821235461225506],
            [5.594375732814882, -2.1828133757511576],
            [5.594174111112803, -2.1802316893962717],
            [5.587420116793929, -2.176824961284998],
            [5.576967933578188, -2.1678176983175215],
            [5.568729414282299, -2.1473672677786615],
            [5.553338699400772, -2.140915290962612],
            [5.548188618544973, -2.1427023405843713],
            [5.543075955751863, -2.1465702692213138],
            [5.53119604697292, -2.1529406852398734],
            [5.521809784015616, -2.155282388124705],
            [5.514762619924868, -2.1559927415183067],
            [5.500952458684301, -2.1544738032768023],
            [5.4929353957137375, -2.1498308029995723],
            [5.485555255565661, -2.140210045069526],
            [5.47895251323275, -2.1374229747994935],
            [5.469001420774247, -2.1343444039656303],
            [5.46120590885726, -2.130883594412249],
            [5.456823266084123, -2.1307190840977466],
            [5.451235560113701, -2.132796275789873],
            [5.447180100040815, -2.137034661241144],
            [5.446147876231981, -2.140763367516537],
            [5.445840980377443, -2.1498478464982282],
            [5.446551288912262, -2.155033760731935],
            [5.441575478592509, -2.157115248699234],
            [5.4444478105546095, -2.162579427879092],
            [5.442720200734642, -2.173363487675144],
            [5.4374271021076765, -2.174712313872248],
            [5.4344280095118735, -2.1713640454873175],
            [5.4308477453193795, -2.1708661848568984],
            [5.429989187077777, -2.17462045151465],
            [5.411417820112837, -2.1758458187433094],
            [5.397696145869371, -2.176205765248948],
            [5.368985120110937, -2.1779475393982106],
            [5.329301423477737, -2.1808575611723313],
            [5.314369850216395, -2.1816430206014195],
            [5.297159885757989, -2.181638081031875],
            [5.290141299085783, -2.1821364562088683],
            [5.276109963605457, -2.181706690787312],
            [5.267171078457364, -2.181471905021638],
            [5.269902379052225, -2.1690347572211808],
            [5.270476061455129, -2.1625545367507923],
            [5.27256371367593, -2.1597837234752135],
            [5.270538842092279, -2.1547259579483637],
            [5.272122629117138, -2.1424612239270084],
            [5.271623957460561, -2.1372235056128597],
            [5.272625240076133, -2.1324665881270657],
            [5.271791538625643, -2.1278748090263058],
            [5.274339330310188, -2.1226808497669305],
            [5.274625366480046, -2.1096742325676336],
            [5.271836953312446, -2.106691637485652],
            [5.271487913794241, -2.103203109730297],
            [5.273706291414834, -2.0973647702560902],
            [5.273945760049333, -2.0890340652973163],
            [5.271970535755529, -2.0745513832909257],
            [5.269411195808311, -2.069670791368267],
            [5.270661171848286, -2.064153651148773],
            [5.2698600547744485, -2.054243085081678],
            [5.268553659022373, -2.0501632079953076],
            [5.269197942346731, -2.0455751014992187],
            [5.267872413892423, -2.0420695991182747],
            [5.270595958002855, -2.0343416421861167],
            [5.269739800439777, -2.0279756245962686],
            [5.271965719958102, -2.023425210652317],
            [5.268514066376667, -2.0082722454428845],
            [5.2675041229057955, -1.994934041605087],
            [5.265785153315436, -1.987042481736162],
            [5.266481165998131, -1.9841805796264917],
            [5.263546721027546, -1.9733787337430142],
            [5.260957100540334, -1.967947487946556],
            [5.261354629420084, -1.9604225687524568],
            [5.259893757505015, -1.9556575168268235],
            [5.259374023349464, -1.9435219053605362],
            [5.262694939809697, -1.9394081571661748]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.65173198881043, "lat": 36.59463877864532 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29143"],
        "coty_name": ["New Madrid"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["New Madrid County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00758526"
      },
      "bbox": [
        5.259374023349464, -2.2122445026181405, 5.763111010745221,
        -1.6745385242999897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.4189953826427093, -0.3103163203425757],
            [3.418575510515554, -0.2746600670648323],
            [3.426737149047646, -0.26887226280064713],
            [3.4279317102321696, -0.26662012307871574],
            [3.4436136456654522, -0.26738562349390427],
            [3.4525870865014014, -0.26449584905551926],
            [3.4643985243094444, -0.25888916446718785],
            [3.473121577590949, -0.25173408210476844],
            [3.4759523737212157, -0.24686850281739287],
            [3.4779578214167515, -0.24082380564996608],
            [3.477514758794552, -0.23568771972062455],
            [3.4740093818686133, -0.22784805423546783],
            [3.469617021807813, -0.22297424442705507],
            [3.4587567059309223, -0.21589042987875254],
            [3.45015482361008, -0.21243061458803633],
            [3.4433371797109187, -0.20473095160244587],
            [3.440615741504483, -0.20014772795268046],
            [3.4388910895619804, -0.19388799440174595],
            [3.437574498680645, -0.1847537749283487],
            [3.433517417456226, -0.17706513308024657],
            [3.43458265268498, -0.17411668857648088],
            [3.438595942186872, -0.17058025560654194],
            [3.446586861136624, -0.16849648612634271],
            [3.4537485666866328, -0.17047885793235798],
            [3.4572509108234164, -0.17285600415726232],
            [3.463630396528848, -0.1805529503564775],
            [3.4746563568028406, -0.1847336264354105],
            [3.479204931521531, -0.1847445887552064],
            [3.48670016415055, -0.18300725865226974],
            [3.5009374048447923, -0.17589373655817972],
            [3.5072535874799176, -0.17414325683272672],
            [3.5147234817368336, -0.1732732105707524],
            [3.524424597877878, -0.17388327034960313],
            [3.5306781545536206, -0.1734189100844568],
            [3.5406705229566313, -0.16873400878850492],
            [3.5480314602618677, -0.16277843241233217],
            [3.5520758253533784, -0.15782237375713684],
            [3.55643421189116, -0.1467625994152601],
            [3.556206833460501, -0.13843415570122514],
            [3.549634862614576, -0.12762810637428945],
            [3.5424261735703575, -0.1146641858955335],
            [3.539734075613963, -0.10619533335388384],
            [3.5389485836976755, -0.10068575955339569],
            [3.5407272755827415, -0.08655018513043587],
            [3.543409438545038, -0.08149987528885813],
            [3.5494764450068264, -0.07814385410244515],
            [3.5576771540753866, -0.0775082079369695],
            [3.552983902987951, -0.06695214651798091],
            [3.5658558256510524, -0.05491694936547959],
            [3.5731240370720436, -0.04918666068089637],
            [3.583963401283454, -0.04371038780788023],
            [3.595952328111755, -0.04117608334146485],
            [3.6021755600590146, -0.0384142353316439],
            [3.61087418961098, -0.029102777094820818],
            [3.619410587967079, -0.019131135721937483],
            [3.6250974948720205, -0.01436990723324665],
            [3.6393702681337996, 0.0005914225339500831],
            [3.6410090364681205, 0.003090986603906565],
            [3.645340033092878, 0.015130886230981975],
            [3.6510043123614135, 0.02500439058959675],
            [3.6568107008644546, 0.03151994310877291],
            [3.6678254316444034, 0.038464230348294076],
            [3.677861746744459, 0.04206238744472208],
            [3.692631603978999, 0.04916897814846323],
            [3.6985463220503285, 0.05143363352723337],
            [3.708549680713391, 0.05315471197715243],
            [3.7236898678635977, 0.052861294233519936],
            [3.740651378279436, 0.05665886572104407],
            [3.744226031673472, 0.059699166863490534],
            [3.754280806964864, 0.07157478064269254],
            [3.7609032180409447, 0.07852277579494713],
            [3.7722014114187497, 0.0805959632611946],
            [3.7841698920838835, 0.08147114130742364],
            [3.793488113707785, 0.08101099569824664],
            [3.7992600870524567, 0.07895341438813641],
            [3.812646886066763, 0.07691589925948145],
            [3.819757336732475, 0.07702948911288998],
            [3.8267314241418275, 0.07898828276103202],
            [3.8319623082079795, 0.07962847817188055],
            [3.83328575268683, 0.05190938047316758],
            [3.834091591766943, 0.016337600668799992],
            [3.834669758296946, 0.008379719259212378],
            [3.8363680136995355, -0.04321342079069709],
            [3.83788437627905, -0.08312107793882582],
            [3.83957118782714, -0.120782166779375],
            [3.840225000107093, -0.142254721680463],
            [3.8438850206527646, -0.24985097995587047],
            [3.8449123427441707, -0.2698965197197636],
            [3.847807648242572, -0.33942552844489365],
            [3.80159372780408, -0.3412067155059289],
            [3.786278596041284, -0.34153996701512845],
            [3.760374850273498, -0.3431706133444821],
            [3.7602282077312146, -0.34178630707490104],
            [3.746226888956708, -0.3404413587036236],
            [3.6780026537284076, -0.34186142184022084],
            [3.661962683899092, -0.3463101186633713],
            [3.593141609272484, -0.34953105646678573],
            [3.571301786266035, -0.351795984850388],
            [3.553738331300219, -0.3521250251473702],
            [3.419814435548109, -0.35404139168331433],
            [3.4189953826427093, -0.3103163203425757]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.86185866054845, "lat": 38.46037452504165 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29151"],
        "coty_name": ["Osage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osage County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00758530"
      },
      "bbox": [
        3.418575510515554, -0.35404139168331433, 3.847807648242572,
        0.08147114130742364
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.467160298408109, 10.890529337447642],
            [-8.443721437766364, 10.88776044073947],
            [-8.432857122413559, 10.885750204721719],
            [-8.397818988345966, 10.880610984059349],
            [-8.333282570713399, 10.871762930227304],
            [-8.310156418712362, 10.868113258072388],
            [-8.247624341437387, 10.859396172786395],
            [-8.185094287118512, 10.850665259158816],
            [-8.145759397051338, 10.844912316584571],
            [-8.082357302626074, 10.836442187882708],
            [-8.018957131519672, 10.827957866290122],
            [-7.9320724186572695, 10.816487784278657],
            [-7.87015929452192, 10.808412262521617],
            [-7.808247964434525, 10.80032322295296],
            [-7.725339772437106, 10.789761479076875],
            [-7.642434695157599, 10.7791755180368],
            [-7.653339203768677, 10.696393623383548],
            [-7.668512543136899, 10.698396155976415],
            [-7.690306486569945, 10.533308796807388],
            [-7.729817685679602, 10.538344008841774],
            [-7.739046327124564, 10.468409365205007],
            [-7.751962125802191, 10.370725491090106],
            [-7.769985739370941, 10.3730576206859],
            [-7.788725567166859, 10.232423869366457],
            [-7.791701221613693, 10.23749431784353],
            [-7.792761348213995, 10.24254040637202],
            [-7.796437905326184, 10.239623709966835],
            [-7.802138272516164, 10.243282599283878],
            [-7.799698563316947, 10.246197995711038],
            [-7.8008985273220075, 10.252299531491698],
            [-7.806013970382762, 10.252405378025772],
            [-7.812945276958409, 10.250696285450612],
            [-7.814162909352644, 10.253656419581855],
            [-7.8180183711290345, 10.250909597913802],
            [-7.825327110855861, 10.254803713324533],
            [-7.825619501026054, 10.260626419308585],
            [-7.8289955758504375, 10.25941303818881],
            [-7.845725339615343, 10.13427277719065],
            [-7.858185820383812, 10.041527890804952],
            [-7.873176566118481, 10.04346533627124],
            [-7.895735846771203, 9.874816144558736],
            [-7.904689704205721, 9.808214599902],
            [-7.994794764677383, 9.824613109619747],
            [-8.006127061279445, 9.831346321730832],
            [-8.012289153180031, 9.83740905606441],
            [-8.018950817654122, 9.837371649353924],
            [-8.033872157954267, 9.806053311793711],
            [-8.040269154348364, 9.770572238889223],
            [-8.047966401093118, 9.774013744396184],
            [-8.049283452505845, 9.771982874928485],
            [-8.060778147842441, 9.772850230451148],
            [-8.064138225190483, 9.778213890791521],
            [-8.06752476043959, 9.776465595710455],
            [-8.07076562302405, 9.777401847619952],
            [-8.14330491167786, 9.786817740361133],
            [-8.215846416569692, 9.79621610827406],
            [-8.222954796066787, 9.745745843640245],
            [-8.224680331632511, 9.74597790752002],
            [-8.242983143498796, 9.61399974170348],
            [-8.249115867321983, 9.616211227128503],
            [-8.261847535639882, 9.61746946384691],
            [-8.26902841091061, 9.616240095473335],
            [-8.274311418790715, 9.612632991093815],
            [-8.278970928888599, 9.613585434221338],
            [-8.28195064395758, 9.618301552477359],
            [-8.282182835661276, 9.621701817319662],
            [-8.27877824225321, 9.626802622920705],
            [-8.273750170290482, 9.629538439805744],
            [-8.267814307923679, 9.630962638912864],
            [-8.261561349207414, 9.63470440066633],
            [-8.259690401334337, 9.638019935328897],
            [-8.261657886844448, 9.642308428642593],
            [-8.265170466262855, 9.645513454633923],
            [-8.27441460194821, 9.656209178496272],
            [-8.274137692615334, 9.662496787461734],
            [-8.268378772996718, 9.66746189822693],
            [-8.267626714320262, 9.672397014992647],
            [-8.269908155939559, 9.674293141318126],
            [-8.28134336733389, 9.676628856727131],
            [-8.284760974340728, 9.67875724405506],
            [-8.289578468057908, 9.686478220366206],
            [-8.295375431744587, 9.688649907698332],
            [-8.30012163263542, 9.688450797850384],
            [-8.307256086262301, 9.690503728794946],
            [-8.312410078985815, 9.68885381737725],
            [-8.317548199766236, 9.688971858665196],
            [-8.325185890794247, 9.6841067989699],
            [-8.33313188159243, 9.683153946979084],
            [-8.338141329785357, 9.684996294050173],
            [-8.351233175668476, 9.694459211654749],
            [-8.358170882021593, 9.694726175573685],
            [-8.364266985423631, 9.691405243768312],
            [-8.374214874863398, 9.689616689786401],
            [-8.379814774837554, 9.687026146958882],
            [-8.385534432399313, 9.686509916181137],
            [-8.394577764156761, 9.683634227354473],
            [-8.39878591940796, 9.681260286040505],
            [-8.41745409879969, 9.682525984258872],
            [-8.421162254595483, 9.684058953711405],
            [-8.42285660595381, 9.687756349496285],
            [-8.429033739745524, 9.692240179547971],
            [-8.436002736794325, 9.696035440865263],
            [-8.441867714395476, 9.697210710153835],
            [-8.448829684572749, 9.697060900744521],
            [-8.453261792722154, 9.700952922251973],
            [-8.462014952095418, 9.703593534358086],
            [-8.474040477758683, 9.70354731178807],
            [-8.479196338789935, 9.705091339368478],
            [-8.486138236313021, 9.704423162399697],
            [-8.491918247788261, 9.706066524338151],
            [-8.495847299544968, 9.704441537531613],
            [-8.499407484680884, 9.700378598305198],
            [-8.500137539273334, 9.690214206585171],
            [-8.50406973160917, 9.68758883787254],
            [-8.513136133801307, 9.68630872433071],
            [-8.517066002743558, 9.682888140555127],
            [-8.522665366988086, 9.675893111274826],
            [-8.527020975604165, 9.674313662063476],
            [-8.537956593913776, 9.674359757417731],
            [-8.543151148778303, 9.672220105407051],
            [-8.548439218131948, 9.671973581077518],
            [-8.564505463329626, 9.666334698336764],
            [-8.573656023551445, 9.667734515924955],
            [-8.576624058811136, 9.66628327532476],
            [-8.578266865766123, 9.661807995667775],
            [-8.587668586980737, 9.657384091601829],
            [-8.5935413698264, 9.652407556162172],
            [-8.603428954126192, 9.649379944410725],
            [-8.607012110055098, 9.650375681090333],
            [-8.610277066964406, 9.65585078621009],
            [-8.618950986731182, 9.657202838971335],
            [-8.622733061619707, 9.655626408421417],
            [-8.628692801420016, 9.65781052840691],
            [-8.63157593232488, 9.663776845553699],
            [-8.634956979204938, 9.664999856446578],
            [-8.639611819147627, 9.66394866212768],
            [-8.643454561498029, 9.66566915349747],
            [-8.64726619429493, 9.671143144299018],
            [-8.654366061882445, 9.674970325675954],
            [-8.657421462165615, 9.681051910911235],
            [-8.662171395766581, 9.6837111761588],
            [-8.665199532887707, 9.683605873879435],
            [-8.6768377448842, 9.678212539500315],
            [-8.67226918104655, 9.710120202591764],
            [-8.658207648630535, 9.806173830999636],
            [-8.654354978072709, 9.805690716776374],
            [-8.64851737537848, 9.847667103743456],
            [-8.618192113965407, 10.060598063612794],
            [-8.605752882198939, 10.144349978343035],
            [-8.617605724643864, 10.146079017665523],
            [-8.607378640698924, 10.215666627206428],
            [-8.585731617130252, 10.212590338763768],
            [-8.571314690154734, 10.31025492623908],
            [-8.556873211540163, 10.308234676907285],
            [-8.54854970230424, 10.36412019351296],
            [-8.527064964484653, 10.361011844598936],
            [-8.516916209003451, 10.431003079291326],
            [-8.5384970301905, 10.43398166033753],
            [-8.532516592449296, 10.475122012745624],
            [-8.538112159153789, 10.475904993422105],
            [-8.531948514932083, 10.517400472842168],
            [-8.489784024284377, 10.808745637734509],
            [-8.479314580187944, 10.807331179189712],
            [-8.467160298408109, 10.890529337447642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.95859933636314,
          "lat": 48.43267645911988
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30005"],
        "coty_name": ["Blaine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blaine County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01722470"
      },
      "bbox": [
        -8.6768377448842, 9.612632991093815, -7.642434695157599,
        10.890529337447642
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.021895020041351, 2.929207209082123],
            [-5.016572505874107, 2.928838390270478],
            [-5.01213501280848, 2.9719952606650373],
            [-4.969528121982041, 2.9691457332690674],
            [-4.947154743906451, 2.9672837082785497],
            [-4.8264647402732, 2.958620996969694],
            [-4.771757313968388, 2.954549586437509],
            [-4.754671962659294, 2.9529263080345705],
            [-4.697479495906715, 2.94902280523713],
            [-4.668861884343695, 2.947423003019818],
            [-4.555098743970025, 2.939418446727629],
            [-4.4686928813537845, 2.9329879691489036],
            [-4.4719182917574845, 2.88923184630728],
            [-4.45161502764165, 2.887709568879568],
            [-4.4582193601410784, 2.800913800136646],
            [-4.4645314235818105, 2.7135065523911726],
            [-4.467749882537882, 2.670255047988975],
            [-4.468496547846673, 2.6626934666639843],
            [-4.470220790874481, 2.632613631664588],
            [-4.476531727226484, 2.539276908047491],
            [-4.484499586763904, 2.539622852877189],
            [-4.487806282827806, 2.4940068258850654],
            [-4.512038247859891, 2.495432581892836],
            [-4.576373512180967, 2.499865687856714],
            [-4.601685438218434, 2.5018522394577456],
            [-4.670575084492804, 2.5063688140816587],
            [-4.729558797852682, 2.510975820333266],
            [-4.75693262275376, 2.5127900476539944],
            [-4.772238923230431, 2.514294754578625],
            [-4.799633522206911, 2.516082610583537],
            [-4.828814117902616, 2.5182990331582498],
            [-4.999332100024179, 2.5308470066567086],
            [-5.043418021419805, 2.534163915028209],
            [-5.056206586290335, 2.5355472529077927],
            [-5.0526504373935115, 2.581178182074854],
            [-5.047583182043805, 2.5807368891137834],
            [-5.034424777791611, 2.754003120786165],
            [-5.029049698807642, 2.822186933030138],
            [-5.027312532939558, 2.8402649878422848],
            [-5.0275902468973905, 2.8557614307736205],
            [-5.021895020041351, 2.929207209082123]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.99500829032377,
          "lat": 41.21974594142156
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31033"],
        "coty_name": ["Cheyenne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cheyenne County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00835838"
      },
      "bbox": [
        -5.056206586290335, 2.4940068258850654, -4.45161502764165,
        2.9719952606650373
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9113584977858111, 4.17395607233112],
            [-1.9076718655731006, 4.1773716384393245],
            [-1.8989073771177767, 4.180578305134951],
            [-1.8881922900677748, 4.1832160297399685],
            [-1.8747653551840713, 4.191542731060833],
            [-1.8621038136933712, 4.195695668350482],
            [-1.8534882498304095, 4.1972796297342265],
            [-1.8439712564766664, 4.204852982457495],
            [-1.8348504257007465, 4.209111269768543],
            [-1.827066150595338, 4.208994522020849],
            [-1.8159999220902587, 4.210884564949322],
            [-1.8104262156686344, 4.2148529592516715],
            [-1.7924786251482925, 4.222171092594484],
            [-1.7857520768068806, 4.223997190207508],
            [-1.77618450188038, 4.2254612092079515],
            [-1.7710243955696732, 4.227507857087791],
            [-1.7634773475872274, 4.227571397463415],
            [-1.7610820831508016, 4.231216922477218],
            [-1.7444378883573561, 4.24117873832145],
            [-1.7336102487262643, 4.250370658141547],
            [-1.7260435585801577, 4.2526111546454475],
            [-1.7233924447658477, 4.251863223139285],
            [-1.7186735713482837, 4.25701413660985],
            [-1.7083397260697728, 4.259784627878847],
            [-1.6933999931072428, 4.258962328237767],
            [-1.6881064596739435, 4.256787000118248],
            [-1.6818579027456493, 4.247391519442826],
            [-1.6790430964604428, 4.2464274891105305],
            [-1.6776280919307334, 4.242136963188469],
            [-1.6728115471196559, 4.2409328211681],
            [-1.6688532596731966, 4.237047878665551],
            [-1.659184602336388, 4.223171541898898],
            [-1.6498871887381632, 4.215953180838153],
            [-1.6445985452335454, 4.206995909474821],
            [-1.6367297567604593, 4.202394749206569],
            [-1.6337766531123084, 4.202039525787687],
            [-1.6248244745442741, 4.203702633009667],
            [-1.6163091082737646, 4.203518283188254],
            [-1.609927457272068, 4.206472667779515],
            [-1.6061422902330267, 4.205634134117127],
            [-1.5938380465648383, 4.19345505306102],
            [-1.5907387193789437, 4.189686023821501],
            [-1.585708208037824, 4.187121658561476],
            [-1.5755242523865496, 4.183427603293918],
            [-1.5700618105406507, 4.183409954741602],
            [-1.562109364666993, 4.186066995420118],
            [-1.5506782759965687, 4.186250371240844],
            [-1.541471022629742, 4.1803375515053105],
            [-1.5365088689346873, 4.176264239949905],
            [-1.5309686602464616, 4.173619905664133],
            [-1.5218734461123913, 4.165344144200377],
            [-1.511411789052793, 4.160480235204306],
            [-1.4976174682543721, 4.161045946360871],
            [-1.4868163143725202, 4.159137002997042],
            [-1.4787776695153638, 4.163391118668169],
            [-1.4736716779179728, 4.165113319571509],
            [-1.4609219719740334, 4.15935127893434],
            [-1.4567119306628311, 4.1561987130051845],
            [-1.4536797485779587, 4.152002940999467],
            [-1.4472860478992355, 4.150414633448118],
            [-1.4350273417054016, 4.144114706455612],
            [-1.429190384252517, 4.139239109246369],
            [-1.4211981287843902, 4.134277366969551],
            [-1.4092749051473512, 4.133082798670723],
            [-1.40258437601701, 4.13547330284459],
            [-1.3954097162568204, 4.135502825340287],
            [-1.3860165580761241, 4.13107680106668],
            [-1.382993568430974, 4.128114766963812],
            [-1.3783514603379132, 4.129446963485768],
            [-1.3739038863787707, 4.126350222733193],
            [-1.3684935343168585, 4.127864520764672],
            [-1.3647820497392822, 4.126062486873546],
            [-1.353663393194227, 4.125818059480788],
            [-1.346535815300761, 4.122850789145966],
            [-1.3426912568303389, 4.122535978370511],
            [-1.3382515434087643, 4.119371458828299],
            [-1.3334227887964754, 4.11838024459644],
            [-1.3208219509748544, 4.121894813960665],
            [-1.3164971800173757, 4.1223660680944185],
            [-1.3122304266731197, 4.121092631797497],
            [-1.3082436066444167, 4.126266305428721],
            [-1.298961045729172, 4.126992816120166],
            [-1.2857157987387473, 4.125512986401987],
            [-1.2767568955776103, 4.122961550073867],
            [-1.2732116058433263, 4.122874877562733],
            [-1.2680949853508858, 4.119515346056907],
            [-1.2581996118244854, 4.117903505144232],
            [-1.2503964225117294, 4.120839137082907],
            [-1.2440710543830753, 4.120591109265508],
            [-1.2287406972691597, 4.115858193142129],
            [-1.2257617967419685, 4.113072765054906],
            [-1.2184365096986016, 4.110477234990412],
            [-1.2203107479213822, 4.039540986113006],
            [-1.2206864545496994, 4.015165507235086],
            [-1.2222581479291306, 3.9596767016138865],
            [-1.224815351040905, 3.8569266779439038],
            [-1.225003970887647, 3.8447997922775037],
            [-1.2265748112012316, 3.7850496274565546],
            [-1.2227480392913241, 3.784940013084762],
            [-1.225013262571336, 3.69758527029849],
            [-1.2271694056122857, 3.610186898568504],
            [-1.2293191680470332, 3.5226523055996273],
            [-1.2314908881028441, 3.4353314507545205],
            [-1.2886193231582082, 3.4365965818387174],
            [-1.3607844117897303, 3.438403350237387],
            [-1.4536419282097697, 3.440826886858449],
            [-1.5355162206989137, 3.442995150995714],
            [-1.5707869730548756, 3.444015413828013],
            [-1.6240096247509899, 3.4456247149078183],
            [-1.6275460952339904, 3.445508832091195],
            [-1.7404342099715644, 3.4488239416109656],
            [-1.7481389195173294, 3.449157020129516],
            [-1.8332864974457805, 3.4518006001937156],
            [-1.8964033744446742, 3.4537675688447607],
            [-1.9107952375382629, 3.4540974974449155],
            [-1.9195542198887232, 3.4544740738020185],
            [-1.9156340240908785, 3.5692715383209657],
            [-1.9134242875542058, 3.6285062852420027],
            [-1.9088474018128325, 3.759570294999436],
            [-1.907269223361264, 3.8024312215105063],
            [-1.914980003712491, 3.802809108149679],
            [-1.9136875644479632, 3.846653461849057],
            [-1.913063644988211, 3.874750285025832],
            [-1.9123142650227476, 3.8900458203974013],
            [-1.9093623194166458, 3.988193757604778],
            [-1.9094843181036831, 3.993861499362574],
            [-1.9069859869548673, 4.064584134732251],
            [-1.9039168262077224, 4.15182073467904],
            [-1.9119636383836258, 4.1522519994909155],
            [-1.9113584977858111, 4.17395607233112]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.78382123591669, "lat": 42.45570698717621 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31089"],
        "coty_name": ["Holt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Holt County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00835866"
      },
      "bbox": [
        -1.9195542198887232, 3.4353314507545205, -1.2184365096986016,
        4.259784627878847
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.129218243740198, 1.753222975919068],
            [-3.1079253076551994, 1.7521183061054335],
            [-3.0467053123407664, 1.7493630918077345],
            [-3.002713493850653, 1.7471695050483511],
            [-2.9738593625390624, 1.746161792878661],
            [-2.9345287719827557, 1.7442134005575156],
            [-2.9332402405378057, 1.7444350586326842],
            [-2.832842764700402, 1.7409643560439763],
            [-2.805715609119071, 1.7390134633592071],
            [-2.790898023890177, 1.7374656143625022],
            [-2.7598819975239692, 1.73540732273512],
            [-2.7390122443706755, 1.7350229330084177],
            [-2.7061745926834173, 1.73381007319564],
            [-2.7075961442674052, 1.6596163489100104],
            [-2.7115559814183054, 1.557960065217329],
            [-2.711966802631522, 1.5431181903246025],
            [-2.7137100418408475, 1.5069698857037765],
            [-2.7136948985847065, 1.4992934438457053],
            [-2.7146812112807597, 1.4695934852049817],
            [-2.7169480335974043, 1.4117677745564523],
            [-2.7185007951331497, 1.382542336225281],
            [-2.8046392328209677, 1.3865359807251594],
            [-2.8674895148832817, 1.3895110851019263],
            [-2.9271628346812726, 1.3922074600919683],
            [-2.959224442520205, 1.3938399082818187],
            [-3.0611088894080685, 1.3987934608522976],
            [-3.089894075313207, 1.4005613937529178],
            [-3.1318884507187117, 1.402638427109348],
            [-3.147050415012653, 1.403470713857097],
            [-3.1427739002209556, 1.4889797494464578],
            [-3.139020777469444, 1.5586134755075973],
            [-3.139987823064394, 1.5774677476405852],
            [-3.137374544659157, 1.624420710792037],
            [-3.129218243740198, 1.753222975919068]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.47688870187244, "lat": 40.1758235153973 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31145"],
        "coty_name": ["Red Willow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Red Willow County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00835894"
      },
      "bbox": [
        -3.147050415012653, 1.382542336225281, -2.7061745926834173,
        1.753222975919068
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.575915318489272, 5.414844092459247],
            [-16.523635854812692, 5.401455359783325],
            [-16.50982965544695, 5.398406940670156],
            [-16.493186262726507, 5.3932067687792005],
            [-16.344587955390303, 5.3571528343548165],
            [-16.19771911089636, 5.319779559122828],
            [-16.183494998701992, 5.316625204198532],
            [-16.126740580199296, 5.301915929805751],
            [-16.058401095164054, 5.287554116258993],
            [-15.98573106261739, 5.271655180210401],
            [-15.8766015099354, 5.2464298816673205],
            [-15.76747697388009, 5.221181707966136],
            [-15.714691735932275, 5.209011521551251],
            [-15.624620419840486, 5.1884126065861915],
            [-15.53455249245739, 5.167798136321453],
            [-15.437090736697089, 5.144997482932877],
            [-15.356741049712493, 5.12630940423575],
            [-15.355046397872105, 5.126294422887366],
            [-15.224869741425534, 5.097632381192724],
            [-15.196580276910494, 5.090791398848757],
            [-15.062590936688602, 5.0609687439461934],
            [-15.048267081621049, 5.058238267867252],
            [-14.955367601961225, 5.0369611169227735],
            [-14.945889931275431, 5.034684885630962],
            [-14.94141728776955, 5.032748817207591],
            [-14.935454818899457, 5.032344472556],
            [-14.92486600987085, 5.029971282100715],
            [-14.91923514899055, 5.028150946946971],
            [-14.937103686391337, 4.949457430775001],
            [-14.946364250385406, 4.907441917661304],
            [-14.97222537332043, 4.797740179774354],
            [-14.974659084605621, 4.783962843891892],
            [-15.00217552708072, 4.661482040017788],
            [-15.002491150173942, 4.65900407305824],
            [-15.029644309018273, 4.538949599620867],
            [-15.030412553655776, 4.533259733239666],
            [-15.046589538630906, 4.463004961891295],
            [-15.085022221980473, 4.293865611113052],
            [-15.112290868018725, 4.171174029861178],
            [-15.140234290701743, 4.048955559635738],
            [-15.140683319099976, 4.0477665934671645],
            [-15.187509393088373, 3.8384894319355034],
            [-15.205979477873903, 3.757923546334362],
            [-15.20778029413962, 3.7537948812117676],
            [-15.20800979039289, 3.748891740232564],
            [-15.219434243344635, 3.6983208931207305],
            [-15.243731953253468, 3.703053404688902],
            [-15.386952660801365, 3.7355059361614713],
            [-15.452496043691616, 3.6303211588105024],
            [-15.430045955887909, 3.726296970066437],
            [-15.418382292627687, 3.7775539828879965],
            [-15.417896011625146, 3.783723543506601],
            [-15.423693844944536, 3.78626987905852],
            [-15.539548933567492, 3.8133218348823923],
            [-15.655408558456868, 3.840353678888938],
            [-15.668943256649056, 3.843359010485006],
            [-15.635749668900548, 3.985425123698077],
            [-15.629311584699343, 4.013373199189243],
            [-15.697718720457999, 4.028993625057508],
            [-15.746440411129647, 4.040331481380031],
            [-15.816426209071244, 4.057021676025832],
            [-15.854722090835153, 4.0658587720281085],
            [-15.88936185546475, 4.074076375454899],
            [-16.07070673260391, 4.115939463284235],
            [-16.072486827647783, 4.1164724831998205],
            [-16.17019474130155, 4.139746181909011],
            [-16.26790605550324, 4.163004968503484],
            [-16.365620761518006, 4.186248838922332],
            [-16.463338850512844, 4.2094777895541995],
            [-16.43819078816906, 4.3119648353380615],
            [-16.501854369593502, 4.327697537794381],
            [-16.65945672902763, 4.366273448239328],
            [-16.81706837720866, 4.404809506234629],
            [-16.81844213236747, 4.405266315926597],
            [-16.833107917643556, 4.408944397288686],
            [-16.793503708148027, 4.570231124677863],
            [-16.766723695484043, 4.6770094985067],
            [-16.748516504708917, 4.671869208335975],
            [-16.703655619237278, 4.84722483289097],
            [-16.717644093246193, 4.850532006866176],
            [-16.672409441767215, 5.021821790590393],
            [-16.676749161947377, 5.022561991565458],
            [-16.611503413249476, 5.2817718323998815],
            [-16.609971142023735, 5.281390704416735],
            [-16.575915318489272, 5.414844092459247]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.11199313882173,
          "lat": 41.40684020335828
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32013"],
        "coty_name": ["Humboldt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Humboldt County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00863310"
      },
      "bbox": [
        -16.833107917643556, 3.6303211588105024, -14.91923514899055,
        5.414844092459247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.389500318416067, 5.7659666663675155],
            [14.38423665571331, 5.774164542672715],
            [14.382426779031269, 5.781134646409791],
            [14.380773367797435, 5.797155737799623],
            [14.37884382050671, 5.803208175781658],
            [14.382636384786132, 5.810832046880564],
            [14.385663989160012, 5.812927683149143],
            [14.386249159542368, 5.82286069529011],
            [14.369290597245005, 5.888849813348917],
            [14.355406321454986, 5.943950288689415],
            [14.344179152773188, 5.98667590150328],
            [14.336672607462909, 6.014505061582698],
            [14.335776928551525, 6.01434834639482],
            [14.318606928494756, 6.077660931500373],
            [14.321656485112099, 6.078163947440121],
            [14.32702891234053, 6.082349332142455],
            [14.332579669645318, 6.081381677017736],
            [14.338199814492755, 6.084610760078399],
            [14.343435369193145, 6.09203959035643],
            [14.351421418976253, 6.107791875591114],
            [14.357645447976179, 6.12737456955106],
            [14.360060208974197, 6.132308038248198],
            [14.36346059478776, 6.145678850464631],
            [14.36942172577776, 6.159262492911837],
            [14.375547329603792, 6.160881519563539],
            [14.378271815230754, 6.165864297516723],
            [14.382440140776335, 6.151026645634176],
            [14.388222641681809, 6.128650888375466],
            [14.391572090963164, 6.117052980326541],
            [14.409493166151375, 6.048513498554533],
            [14.420201819629122, 6.006647988524633],
            [14.457171399500162, 6.016040391867807],
            [14.507451251958022, 6.0277984991578695],
            [14.514785980325133, 5.999582122094558],
            [14.522024255851258, 5.972169962973308],
            [14.535870555037613, 5.920714234415836],
            [14.530099100415216, 5.919384367532146],
            [14.527038401848067, 5.916030226611534],
            [14.534942042077418, 5.905418375495726],
            [14.542504360387532, 5.89004478179254],
            [14.545205299701397, 5.880732155795333],
            [14.54410711827741, 5.879529898348597],
            [14.536860288045139, 5.880144799393158],
            [14.531103319760199, 5.879150471997356],
            [14.527158587528671, 5.874617248187807],
            [14.52724885123464, 5.86906228769445],
            [14.538946114191463, 5.826789848691305],
            [14.551365451206697, 5.779813580793949],
            [14.571693254103202, 5.785408879831072],
            [14.591426452936242, 5.711013530847183],
            [14.595936192680437, 5.694714888280085],
            [14.613401199869543, 5.629934772220051],
            [14.679507836640768, 5.6474657292459804],
            [14.697411355245837, 5.635600975447011],
            [14.72354309255933, 5.619731557979846],
            [14.729749880943388, 5.615017380126942],
            [14.741419129339747, 5.604143911353725],
            [14.752060310757795, 5.592077627758446],
            [14.754451923675337, 5.583152645823108],
            [14.77290028344809, 5.512398706942262],
            [14.79156884556502, 5.4398077640593],
            [14.695925494125754, 5.416245000263941],
            [14.654587952643892, 5.406133586622838],
            [14.652452114972704, 5.414696048866705],
            [14.617173538151851, 5.405806367106289],
            [14.583732186415851, 5.397026861425543],
            [14.542251797146958, 5.386473668366703],
            [14.54147903036355, 5.389517456506038],
            [14.504555089077007, 5.380106556334542],
            [14.49836330431833, 5.391348660775586],
            [14.481604647064477, 5.423286293038584],
            [14.478838033806161, 5.427323860637734],
            [14.47183608811434, 5.434013851446112],
            [14.450885429673672, 5.447805257705221],
            [14.447483301661684, 5.450899126718639],
            [14.44173381443132, 5.4586955002436675],
            [14.435474901959447, 5.472748019196776],
            [14.422623303942759, 5.513272066862104],
            [14.418293642351887, 5.532128452876234],
            [14.418476123944455, 5.537550539841595],
            [14.423048568969513, 5.554701230205481],
            [14.425674034912522, 5.570462902851442],
            [14.42561701226438, 5.577722307988118],
            [14.423003192544655, 5.589061351021419],
            [14.418757168207517, 5.598490938461529],
            [14.41549436071219, 5.6134836401904185],
            [14.411031835313032, 5.622494154936557],
            [14.399648728546948, 5.638781532556091],
            [14.397336615359263, 5.643006935498478],
            [14.393128031220964, 5.6571959286408955],
            [14.392107771797209, 5.665099809058521],
            [14.390911542315743, 5.6853950641106055],
            [14.38538051692202, 5.6940655501567585],
            [14.385621173609572, 5.7053726920183925],
            [14.384047935727109, 5.709947353322675],
            [14.388636304725082, 5.71679649510218],
            [14.388954265277652, 5.718978191540641],
            [14.38615743191742, 5.7282331569591625],
            [14.390419317266705, 5.7369319264452505],
            [14.387219439320795, 5.747886217357095],
            [14.388588487879458, 5.75280990953041],
            [14.392569305816115, 5.7604735637926145],
            [14.389500318416067, 5.7659666663675155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.55451305201696, "lat": 42.91750217957766 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36011"],
        "coty_name": ["Cayuga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cayuga County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00974104"
      },
      "bbox": [
        14.318606928494756, 5.380106556334542, 14.79156884556502,
        6.165864297516723
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.169494554192841, 5.367958978200471],
            [13.232132316001666, 5.3809005105624],
            [13.282084404829376, 5.391534960837687],
            [13.31130444312411, 5.396706566413658],
            [13.319929807510881, 5.398627863334074],
            [13.373464478185213, 5.409125990344955],
            [13.40754477269194, 5.415325504663338],
            [13.448371543780244, 5.423250239967782],
            [13.449576373487721, 5.417005020601072],
            [13.469755475751036, 5.421107643632828],
            [13.505484115316595, 5.428883986427003],
            [13.505807984685111, 5.427237046119821],
            [13.535094091006362, 5.4322063338490345],
            [13.53755071721366, 5.420726091549495],
            [13.544844159791447, 5.38080806982559],
            [13.552219492806659, 5.341877422092305],
            [13.55606904382593, 5.323287757322124],
            [13.571430223346495, 5.240404592437289],
            [13.567861230276028, 5.233707249245396],
            [13.564251833204017, 5.23392288856037],
            [13.560677875554427, 5.22424177524226],
            [13.563572027408151, 5.2168776027800705],
            [13.56057755936607, 5.213153447053861],
            [13.561815059457418, 5.208914881048824],
            [13.558229369605778, 5.203468788225359],
            [13.559071393670518, 5.200242180493435],
            [13.555712346840348, 5.197619952700418],
            [13.554967249752645, 5.194348253484101],
            [13.557647857050185, 5.18958508918523],
            [13.556743752716432, 5.183650370728801],
            [13.551720411923109, 5.183548178246088],
            [13.550173510854574, 5.179823414253147],
            [13.546566862533048, 5.176510640737397],
            [13.542623048000813, 5.178154923538031],
            [13.539974609372692, 5.176886478020128],
            [13.539731600196271, 5.172639361813373],
            [13.536539606984816, 5.169703220510329],
            [13.532979662092131, 5.16930817532035],
            [13.531164890884202, 5.166443047724811],
            [13.534372724618226, 5.161726199277605],
            [13.538221950692105, 5.160641755799268],
            [13.543149182375629, 5.165332391690956],
            [13.548383698492843, 5.16550768124562],
            [13.550417911991165, 5.161106120100486],
            [13.546121218472532, 5.152721878400293],
            [13.539005226886264, 5.149401455144813],
            [13.536007599544881, 5.150373859541693],
            [13.528513869465257, 5.15023252747035],
            [13.521498240223814, 5.139633422502095],
            [13.521476996896922, 5.134728446588863],
            [13.525880323948714, 5.131708668398156],
            [13.534518342797368, 5.136433801639677],
            [13.538482692752169, 5.1314136360095155],
            [13.532108967720879, 5.129061264273078],
            [13.526837526518623, 5.120801888240998],
            [13.525269880090889, 5.115192975126447],
            [13.525275518601218, 5.109900891015778],
            [13.527570693441428, 5.10403837759446],
            [13.521599656714791, 5.099109752788187],
            [13.521776118042034, 5.093078508105095],
            [13.52416040632825, 5.093446483768373],
            [13.528349721704156, 5.100553706621047],
            [13.532939664325157, 5.098400844133115],
            [13.533963739503273, 5.0957690060726595],
            [13.531748372161585, 5.088993242564025],
            [13.539972981565159, 5.085043539024626],
            [13.53917082014741, 5.084545764480881],
            [13.503608512782227, 5.077730617585091],
            [13.450184992244761, 5.06814013932836],
            [13.408616989180672, 5.060362404707502],
            [13.345345643616248, 5.047938022077164],
            [13.26059099191507, 5.030151258436751],
            [13.233628454323094, 5.025045644346988],
            [13.230934295089664, 5.042010732137849],
            [13.218174901321625, 5.118071790283114],
            [13.207231109931028, 5.170239971115848],
            [13.201774113597583, 5.197226060028929],
            [13.191134743970654, 5.256362930734401],
            [13.186290375139334, 5.282550333271925],
            [13.168618595611026, 5.279277694225745],
            [13.155677840358953, 5.355181035806635],
            [13.15380008882381, 5.365203637460775],
            [13.169494554192841, 5.367958978200471]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.22442639238558,
          "lat": 42.702424894984446
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36121"],
        "coty_name": ["Wyoming"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wyoming County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00974158"
      },
      "bbox": [
        13.15380008882381, 5.025045644346988, 13.571430223346495,
        5.4322063338490345
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.375038010450435, -2.9377313885311964],
            [10.381791874829664, -2.9444542586338383],
            [10.385858173234448, -2.946959167947911],
            [10.392318769025163, -2.9372793281616163],
            [10.394395949383478, -2.935867904984102],
            [10.400052773226303, -2.9373783385859196],
            [10.406695456731129, -2.9361078635292177],
            [10.410979575578422, -2.9330173253011704],
            [10.416277902429682, -2.934245091227341],
            [10.416895844806014, -2.9311810579239532],
            [10.424147314185674, -2.9311585441906614],
            [10.426881904736597, -2.929871841484919],
            [10.433848120100281, -2.9360663207665088],
            [10.438496725372035, -2.9309669278517276],
            [10.437784013439922, -2.9254408172184556],
            [10.441393365371727, -2.926695098037055],
            [10.444079282684767, -2.930343366511299],
            [10.447513896268628, -2.9314088779143015],
            [10.447611515882622, -2.9365590610097456],
            [10.451167675442962, -2.9386691965385086],
            [10.449039859524026, -2.9436567345816456],
            [10.44225355303638, -2.9450552019825715],
            [10.444957712754807, -2.949358296963735],
            [10.44933726260116, -2.9496594862170378],
            [10.456297208164838, -2.9448943975240143],
            [10.459095774387809, -2.948475659106889],
            [10.457083633955122, -2.952810255842685],
            [10.462683470381368, -2.9616484737133373],
            [10.464068899129279, -2.957498309887141],
            [10.468476346001616, -2.957426059874216],
            [10.470943989426004, -2.9529695985301934],
            [10.473823272796771, -2.955013919532576],
            [10.475663146972373, -2.9617515648550836],
            [10.479859361891867, -2.9672837146799123],
            [10.477396534921697, -2.9724457617335385],
            [10.478735709774831, -2.97538324093556],
            [10.48288642570384, -2.977727187970807],
            [10.48863787589051, -2.977874196435671],
            [10.493253229542804, -2.979684379409439],
            [10.497343266213067, -2.9843365988680284],
            [10.504442643048474, -2.985488331271246],
            [10.508514974690181, -2.990657420183646],
            [10.507743919332185, -2.995650167647042],
            [10.513512862452922, -2.999746091480849],
            [10.516983164954366, -3.004852564750514],
            [10.523494703235675, -3.0045672728270483],
            [10.523243764205175, -3.008173173449151],
            [10.529113827122385, -3.015680379480689],
            [10.526576373628076, -3.02428616659097],
            [10.531949964137223, -3.029887546788125],
            [10.535771819030035, -3.0359232352100975],
            [10.539317328376029, -3.0346016115178718],
            [10.546932516365098, -3.034343213107252],
            [10.55190181810721, -3.0371571841984344],
            [10.553613850157275, -3.0402059120633265],
            [10.56291797973719, -3.0491804776470413],
            [10.567614300701402, -3.0526492213569547],
            [10.567697415189357, -3.057328569685746],
            [10.564024376047298, -3.0620926358622578],
            [10.5688490735441, -3.0671403098270438],
            [10.569006224499809, -3.0716990442311474],
            [10.573460860212162, -3.0710384221299423],
            [10.575159089210622, -3.065774691827875],
            [10.578835959526613, -3.064495052063264],
            [10.58325515208672, -3.0682463838961542],
            [10.592603229276762, -3.0688095799079504],
            [10.597835760629957, -3.068343373556745],
            [10.601634787862729, -3.073106957869668],
            [10.548272045231066, -3.0811535961859713],
            [10.491301635364279, -3.089034529460623],
            [10.49218307561353, -3.094504465177479],
            [10.38739499698396, -3.107022536015105],
            [10.322025502779361, -3.1158622976892403],
            [10.237131009365497, -3.126529007381914],
            [10.181669024788935, -3.1336205402144235],
            [10.182632520343546, -3.1247892030438646],
            [10.185858601177548, -3.124043315156231],
            [10.196429515630513, -3.1140706880793516],
            [10.199803822190338, -3.112615003705391],
            [10.205850155138405, -3.105151885992484],
            [10.204578728853754, -3.1033327512381153],
            [10.207560900511817, -3.099370129427432],
            [10.210579956068802, -3.09825441309304],
            [10.216040796490502, -3.089696936123454],
            [10.212031949276605, -3.0856737255116857],
            [10.21309636609696, -3.08104482004364],
            [10.211893443808291, -3.0761052330276693],
            [10.206040323998756, -3.0729883742470867],
            [10.207178822412791, -3.0688251893959984],
            [10.210957758464685, -3.0635799001479196],
            [10.216192326727624, -3.0621412657703355],
            [10.222677622461152, -3.0587407839444083],
            [10.23095718180912, -3.0441258600628136],
            [10.23426967898493, -3.046423650346684],
            [10.237141541219456, -3.038612596554311],
            [10.241896933756456, -3.037515316796615],
            [10.248690642893392, -3.0329304115760247],
            [10.249551648404355, -3.0242898353443066],
            [10.256367655778723, -3.0180926194005084],
            [10.262164139891437, -3.0098661512720106],
            [10.264888878909552, -3.002551164238159],
            [10.270201876412342, -2.9971924002580694],
            [10.270325738040722, -2.9948591150498296],
            [10.276361766644307, -2.9888607537560166],
            [10.278781345796386, -2.9850855033464905],
            [10.27704736036845, -2.97844669326196],
            [10.277875965743315, -2.974126845580904],
            [10.281807534884813, -2.9689316062951856],
            [10.287093454999546, -2.964356418438015],
            [10.29082575703212, -2.9636273844013146],
            [10.294116187243917, -2.9604707050273427],
            [10.302638800274886, -2.9624608856418257],
            [10.310002628149075, -2.963181437632507],
            [10.314146892387402, -2.9625851218087553],
            [10.321014204215079, -2.9572308554456845],
            [10.32904334556908, -2.954876712599727],
            [10.33063662675557, -2.951445408000062],
            [10.338399336097531, -2.95075779999535],
            [10.343740500481292, -2.947717878180409],
            [10.347066923890889, -2.941443656790319],
            [10.350963197594865, -2.939760898655421],
            [10.353667303557126, -2.940987820477671],
            [10.360401962567547, -2.938334191561282],
            [10.362657654738307, -2.9343712943814184],
            [10.368113256679864, -2.933699637665214],
            [10.375038010450435, -2.9377313885311964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.75014233544655, "lat": 35.0571955954885 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37043"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01008546"
      },
      "bbox": [
        10.181669024788935, -3.1336205402144235, 10.601634787862729,
        -2.9254408172184556
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.940166918871089, -2.0593667091189265],
            [10.944765397364325, -2.058633426958412],
            [10.958420207806846, -2.04908481903969],
            [10.969826253142006, -2.052864097606301],
            [10.976086354807444, -2.0503040205091256],
            [10.986086013763538, -2.056415165405646],
            [10.99984717210075, -2.066717778101095],
            [11.004271351913642, -2.074127407969832],
            [11.012156779075704, -2.0679742380883877],
            [11.016929043642845, -2.0669342602928036],
            [11.018285893256989, -2.063729380564511],
            [11.014746349693185, -2.056271167803686],
            [11.018184097325008, -2.049459741482889],
            [11.027365034281212, -2.0400211930121843],
            [11.029050997111177, -2.0267300723328203],
            [11.03301723493244, -2.024209557339923],
            [11.034568351479768, -2.018832942302797],
            [11.028724086241109, -2.017019010818385],
            [11.025294734616597, -2.0142059998661033],
            [11.024108608838755, -2.004052793078925],
            [11.028127781082079, -1.9988218521824503],
            [11.029761270048972, -1.9908608613915144],
            [11.0377982491005, -1.9867818926600087],
            [11.046268177163224, -1.9842698986052578],
            [11.049522341957848, -1.9820821017706558],
            [11.062339288416181, -1.9684680453475119],
            [11.067651470148569, -1.9671106950403956],
            [11.074226310918544, -1.961500960353418],
            [11.07404557043432, -1.9556183415902435],
            [11.0799442094621, -1.953260723501977],
            [11.084416950412518, -1.9482510762913277],
            [11.093504501821922, -1.9426928633842289],
            [11.0966520417684, -1.9346091102600858],
            [11.107749605161588, -1.926115682236945],
            [11.116039376409427, -1.921144434065159],
            [11.12149253577198, -1.9191831140532112],
            [11.126020027835246, -1.9134492888275394],
            [11.13067105570888, -1.9097351814648083],
            [11.134570825896889, -1.9092853281561775],
            [11.138172956608827, -1.9124432342808146],
            [11.146715735059717, -1.9173464568423273],
            [11.148095155927434, -1.9190868000039591],
            [11.148401162641706, -1.9263788834424946],
            [11.155441272522925, -1.9275197826410557],
            [11.161543059185876, -1.9318231267757282],
            [11.162969404408255, -1.9355198599957124],
            [11.170785058548976, -1.9347166045377262],
            [11.172277059741093, -1.9383763909635747],
            [11.164628410209785, -1.947203640617581],
            [11.163308319883413, -1.9504472551508443],
            [11.164662385961671, -1.9537191423771654],
            [11.160747051902229, -1.9569231399696354],
            [11.16158129782096, -1.963936336164067],
            [11.157806254394416, -1.96813994553317],
            [11.157477259558968, -1.9726690995350755],
            [11.160394094338736, -1.979201651758222],
            [11.165073346528583, -1.9798811328306671],
            [11.167908135250025, -1.984421196451557],
            [11.166330157466376, -1.987571808732111],
            [11.164457462376044, -1.9980287386997826],
            [11.165450910503312, -2.005052645439444],
            [11.174197505390621, -2.006647656295539],
            [11.180611953831104, -2.0039455804348725],
            [11.189442596904215, -2.003535269972999],
            [11.192243339012434, -2.0045239300435123],
            [11.193771823087756, -2.009340490453186],
            [11.201583473280607, -2.012002642635035],
            [11.209464331063787, -2.0125636628926156],
            [11.21449257583853, -2.001278884761452],
            [11.219694392491848, -1.9967490257413718],
            [11.225537643627604, -1.993987686933521],
            [11.227965179581973, -1.991297235882802],
            [11.234606260914132, -1.989078496381494],
            [11.239214086986568, -1.985851319507096],
            [11.242308953043016, -1.9857090445229522],
            [11.247692918123718, -1.982894710284878],
            [11.253081018755935, -1.9941656459754487],
            [11.257380001645485, -1.9979670819575683],
            [11.257593142203179, -2.0025695295530372],
            [11.266720613104937, -2.00446661235558],
            [11.272034390606912, -2.0094314571942182],
            [11.266182920064788, -2.016315862381243],
            [11.2655030582182, -2.0217489903198],
            [11.262078550267693, -2.0281888585024936],
            [11.259975916322821, -2.029410467630552],
            [11.261189978806653, -2.0344106796636288],
            [11.26760079434314, -2.037411590463722],
            [11.268452125562995, -2.0414263931018293],
            [11.26567583628817, -2.0489929990037994],
            [11.272819696969709, -2.0511195704816503],
            [11.275457731327219, -2.0488888399527667],
            [11.28160858060032, -2.047766952168859],
            [11.291699337141983, -2.055717603657152],
            [11.297713380567515, -2.0559875465448334],
            [11.299723585995288, -2.0547170936903116],
            [11.304361219211838, -2.057128958686511],
            [11.311043450249059, -2.065611157246837],
            [11.310539812762928, -2.068574039913591],
            [11.314386316631207, -2.0736553458016327],
            [11.32112548764441, -2.075964334769925],
            [11.328246733773645, -2.081673988324783],
            [11.327391169610591, -2.086073262018462],
            [11.328470741507658, -2.090316667819769],
            [11.334520812394837, -2.091122007712559],
            [11.335105400594376, -2.1001977917961105],
            [11.336355272105632, -2.10309612572281],
            [11.335113053904003, -2.107240211390375],
            [11.339780930988306, -2.1208444050318573],
            [11.343528649009212, -2.1229136779055238],
            [11.34300929951408, -2.130043985830276],
            [11.347503851292998, -2.131089738050437],
            [11.34521157343859, -2.134771554185018],
            [11.340817444267527, -2.1369613146810016],
            [11.333214765283307, -2.137639413146429],
            [11.328174284548028, -2.143065283840869],
            [11.32100420382294, -2.1444511774360326],
            [11.318108748018297, -2.143211112795643],
            [11.312711347829316, -2.1471210828555702],
            [11.306809238775513, -2.145441656803734],
            [11.304181011056977, -2.148330539194416],
            [11.304867481086413, -2.153901536701515],
            [11.296899791081405, -2.158575638486945],
            [11.289011091628327, -2.158218275220834],
            [11.286660801367425, -2.156881744893172],
            [11.28132970858292, -2.1596529286138955],
            [11.277597491719893, -2.1580705474219273],
            [11.27193626061349, -2.1576895418224793],
            [11.264103719716877, -2.1589056666273803],
            [11.2620403240672, -2.162333539145894],
            [11.255189940534269, -2.1652563324467144],
            [11.25129690061173, -2.1691402494137817],
            [11.2502841214088, -2.172630778422321],
            [11.246858404466915, -2.1724873830816076],
            [11.188131988008847, -2.215183986291559],
            [11.15274135961786, -2.2407346483102866],
            [11.1517763983562, -2.247968560608187],
            [11.152784346269197, -2.252957695251417],
            [11.142193086898963, -2.2528828852409566],
            [11.13595345980694, -2.2512753219514092],
            [11.133294052693461, -2.2471541074555295],
            [11.126754980938369, -2.2474851044427284],
            [11.1221097480135, -2.2507292039773756],
            [11.11823406317597, -2.2504240516799396],
            [11.120971423733994, -2.256321751522115],
            [11.11885812802768, -2.2658279619610147],
            [11.1138048598069, -2.2688506656050786],
            [11.107860524831276, -2.2670720044101684],
            [11.10384583319475, -2.2673883392552914],
            [11.100901342917357, -2.2696476807145416],
            [11.101177647625049, -2.2743587903467364],
            [11.094672081442502, -2.2723432594820308],
            [11.089616455386917, -2.2773987996770186],
            [11.088773616577875, -2.2846145521880046],
            [11.076492230198443, -2.291593582381876],
            [11.073334606746982, -2.2904421959519023],
            [11.067154767718721, -2.292241429021755],
            [11.062776144969728, -2.2957858265441766],
            [11.05741360476376, -2.296796965257698],
            [11.055937273497781, -2.3037856301659976],
            [11.04898480939592, -2.308146633439086],
            [11.041544183090327, -2.305883443826663],
            [11.03514278452302, -2.3075081280253182],
            [11.032871426577293, -2.3056054642616197],
            [11.022307866556021, -2.303881618808171],
            [11.01703406648251, -2.297493865828516],
            [11.01320051162198, -2.2972312967359576],
            [11.009607801104462, -2.299810873982938],
            [11.00816943637619, -2.3060282286353337],
            [11.000640748453089, -2.3117553726164353],
            [10.997502992631345, -2.312209620729281],
            [10.995326583454036, -2.318027118143465],
            [10.98877593967337, -2.324302978118789],
            [10.980519160365876, -2.322422084630074],
            [10.975653995873053, -2.318315478298072],
            [10.975418131734102, -2.312636694938488],
            [10.973137821703858, -2.3087833855448214],
            [10.973580437646431, -2.300723216033572],
            [10.97001015903208, -2.2952590867556757],
            [10.962388493300603, -2.28933195245015],
            [10.964769582957025, -2.284878507089012],
            [10.96287600876822, -2.2772425968837138],
            [10.955316717421985, -2.268517091234567],
            [10.952654209459181, -2.261542150032352],
            [10.9477507812628, -2.2602886288845694],
            [10.945481065542355, -2.262372813747449],
            [10.937924903461994, -2.26355092794505],
            [10.933591385141543, -2.2682326132410613],
            [10.929380449281291, -2.2707278856114548],
            [10.925034847981776, -2.2678222137197253],
            [10.924198222208586, -2.264689584705619],
            [10.920577414452513, -2.263141281553707],
            [10.922055136023628, -2.2601167558404494],
            [10.919664239408354, -2.25343231367341],
            [10.922765819505223, -2.2511282275567615],
            [10.92238878172485, -2.242353844306513],
            [10.920656198728723, -2.23399043682798],
            [10.915825197030538, -2.2255079280421515],
            [10.91012909753158, -2.2196488443358557],
            [10.90985543523019, -2.2107731840838825],
            [10.911673060196383, -2.207639548156824],
            [10.915409346880477, -2.1940326421410314],
            [10.919420358942977, -2.1848470982586794],
            [10.925481968878184, -2.1813036803980395],
            [10.928672011826427, -2.171668743151471],
            [10.931776498006563, -2.168964054363178],
            [10.940158232292065, -2.164970930458322],
            [10.935295575072784, -2.1557644670609424],
            [10.93526011300278, -2.1461483625702735],
            [10.933339186414932, -2.1430514125926567],
            [10.933177231529415, -2.1383436926772355],
            [10.93980508970419, -2.137360983398387],
            [10.947963120915496, -2.132100173812355],
            [10.950852511963564, -2.123852692982267],
            [10.94508650958901, -2.124572538617236],
            [10.942212691933232, -2.1211923708693177],
            [10.945080761885013, -2.1144976095782826],
            [10.94200004059299, -2.1080651247751105],
            [10.938673152624425, -2.0979512887673804],
            [10.935283863899398, -2.0931547496537872],
            [10.931253901742757, -2.0819588977081795],
            [10.928477164746832, -2.082304667453406],
            [10.925353584107247, -2.078388357856889],
            [10.92965261967864, -2.076509276069307],
            [10.933032607559255, -2.078844300177743],
            [10.937740318583135, -2.0790351819605246],
            [10.941774061101157, -2.074119159376998],
            [10.938607002391644, -2.0670925324332132],
            [10.940166918871089, -2.0593667091189265]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.70578348974682, "lat": 35.85797620977283 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37115"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01025834"
      },
      "bbox": [
        10.90985543523019, -2.324302978118789, 11.347503851292998,
        -1.9092853281561775
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.887014902310753, -0.6236479453372157],
            [15.937978784798952, -0.6571886309793252],
            [15.950059428974757, -0.6582335846234377],
            [15.951810693789898, -0.6604643273110729],
            [15.95706873803917, -0.6607885959865046],
            [15.961123915178627, -0.6642267884162779],
            [15.96611687419553, -0.6645770436520225],
            [15.973897104752568, -0.6633940216489239],
            [15.981666784425874, -0.6696646290047922],
            [15.98493377955283, -0.6683773678305039],
            [15.989672430564955, -0.668970216299939],
            [15.990839636756904, -0.6722064917630693],
            [15.99482867801319, -0.6745979628946028],
            [15.999895897152571, -0.6818375572384548],
            [16.009187140561053, -0.6847952658631757],
            [16.014872818292165, -0.6815938879745804],
            [16.017143024862555, -0.6874349280300834],
            [16.022369162343782, -0.6869718136791825],
            [16.02331214235936, -0.6841923542315873],
            [16.027677870125522, -0.6821374093320549],
            [16.030217973616704, -0.6832265961632751],
            [16.037601583574972, -0.6791727703084405],
            [16.03870065870063, -0.6822177737822088],
            [16.03749640973432, -0.6884623481790311],
            [16.045273125150956, -0.6933504969582186],
            [16.05041940707625, -0.6985794701314249],
            [16.050488668344485, -0.7016066726716123],
            [16.058673740428, -0.7032145784757674],
            [16.059699061953086, -0.7064007787838469],
            [16.068491908818142, -0.7135995872353408],
            [16.072589265335303, -0.7140361625265846],
            [16.072940506475113, -0.7103963568719194],
            [16.07852421431871, -0.7117730785247599],
            [16.081750661684286, -0.7091607230587323],
            [16.094462003066965, -0.7105608304100495],
            [16.096291416853116, -0.7123457074653619],
            [16.095997984857267, -0.7182585460732636],
            [16.098552432041007, -0.7206323025351997],
            [16.097218325485567, -0.7283189556081966],
            [16.100494841387253, -0.7308799231716779],
            [16.105179766052466, -0.7295478699659855],
            [16.109985377509677, -0.7264342961701876],
            [16.113217384673465, -0.7196930242790321],
            [16.119130713955464, -0.7191550806115001],
            [16.120309703802835, -0.7273366124110519],
            [16.126587485262736, -0.7348700777800068],
            [16.12586517272861, -0.7392779449370668],
            [16.128709777331903, -0.7423768490736112],
            [16.13351954196164, -0.7424651905280047],
            [16.13825608425378, -0.7453448345274518],
            [16.136815009021163, -0.7513375893574169],
            [16.138101338062484, -0.7575434839039101],
            [16.141755274420973, -0.759811950950069],
            [16.148707841519784, -0.7567357554144398],
            [16.15822012380484, -0.755010693687836],
            [16.167520662233787, -0.7586455253881456],
            [16.16809299871155, -0.763578703767076],
            [16.164653466485273, -0.7676561768598412],
            [16.16068202400744, -0.7686879545306309],
            [16.156307106171163, -0.7661909151361399],
            [16.15403836392827, -0.768958689393756],
            [16.15623579791091, -0.7782184980965972],
            [16.155416962558228, -0.7797760235612001],
            [16.146391363151142, -0.7823669693126578],
            [16.145611261075185, -0.7864730123487575],
            [16.14474858936966, -0.7903704585470966],
            [16.154900140865657, -0.7921254957146698],
            [16.158869065314747, -0.7981181440164469],
            [16.164388757733356, -0.7960363149541105],
            [16.168421060153662, -0.7962999201562732],
            [16.171158158375572, -0.8022782184774164],
            [16.183476470820835, -0.8116269414421933],
            [16.186001145866467, -0.8157237689248023],
            [16.196457368070305, -0.8140700716985824],
            [16.200071706174977, -0.8124997146282047],
            [16.21013763123512, -0.8154632636050324],
            [16.217835035919194, -0.8226051568745827],
            [16.220929742670542, -0.8310994046678817],
            [16.22988538405273, -0.8381160151175244],
            [16.240821944679286, -0.855773977324062],
            [16.24929539839159, -0.8563488797739909],
            [16.2727693852488, -0.8635052243747888],
            [16.27643457229298, -0.8694026786929007],
            [16.2805318995564, -0.8790001113551366],
            [16.28809807493614, -0.8926335979464807],
            [16.297428508559598, -0.9045073477891807],
            [16.29960584839213, -0.9095466365133204],
            [16.29688753364838, -0.9158107728466622],
            [16.29181386780061, -0.9205968438986821],
            [16.27639206698477, -0.9284049684299636],
            [16.25140584605476, -0.9386148784931672],
            [16.23543234516258, -0.9430246914205945],
            [16.220941688793225, -0.95263064268187],
            [16.214470321431673, -0.9542027166926722],
            [16.21053254093396, -0.9530513005441049],
            [16.204204942200725, -0.9543898696169743],
            [16.195681774123383, -0.9490859553480947],
            [16.18654830446359, -0.9456627659193232],
            [16.178635496409427, -0.9392061869716376],
            [16.17621646923851, -0.9341687294524156],
            [16.1654949601609, -0.9284826968235226],
            [16.16023422253646, -0.922668687150782],
            [16.160750606164452, -0.9198170814609724],
            [16.155818996535025, -0.9167018572915712],
            [16.146611110904118, -0.9152813009475426],
            [16.14464832485023, -0.9129731784815401],
            [16.143616164977693, -0.9058191548125846],
            [16.138820194602733, -0.9042577479496158],
            [16.13397147706951, -0.9042708125672411],
            [16.129933580469736, -0.9063282219314509],
            [16.126239657023604, -0.9035448385650233],
            [16.123302798538976, -0.9040636064861605],
            [16.122563430657518, -0.8996880507153646],
            [16.117215506225783, -0.8976527621369786],
            [16.11556435127205, -0.8928991371112269],
            [16.109162670016858, -0.8874022048783203],
            [16.10307529714713, -0.8745831404180684],
            [16.09355122220348, -0.8784249721796016],
            [16.09203324590172, -0.8744568256810745],
            [16.088623257753284, -0.8705119889745928],
            [16.082389669850567, -0.8694292917822708],
            [16.078402881622868, -0.8623277967879536],
            [16.07295408837508, -0.8634526486879138],
            [16.065986536502752, -0.8608047872212605],
            [16.06269016078325, -0.8652865919788528],
            [16.057730896453783, -0.8638768766703886],
            [16.057037123711567, -0.8602438837915855],
            [16.05321832371216, -0.8579408675255321],
            [16.04121794354819, -0.8572673502871762],
            [16.029934304385915, -0.8536793278091894],
            [16.025626154095754, -0.8443531254064695],
            [16.026275443091336, -0.8390497805300688],
            [16.02142117434183, -0.8377296056215676],
            [16.016070880294713, -0.8313694155485709],
            [16.010802714746795, -0.8281379355626141],
            [16.007320087633023, -0.8236633286063023],
            [16.007125183308077, -0.8202372804082939],
            [16.003251393560863, -0.8162146009917517],
            [16.000060719592074, -0.8156270739756547],
            [15.951517691107304, -0.7619053584837449],
            [15.943672702932963, -0.7485507205709562],
            [15.89560901562327, -0.6651946812302728],
            [15.887014902310753, -0.6236479453372157]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.28426014718603,
          "lat": 36.295430136319055
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37139"],
        "coty_name": ["Pasquotank"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pasquotank County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01026330"
      },
      "bbox": [
        15.887014902310753, -0.9543898696169743, 16.29960584839213,
        -0.6236479453372157
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.876713841882635, -2.8360783570517296],
            [14.899701022207877, -2.7781073807157677],
            [14.931727247849517, -2.697038114769199],
            [14.96088277506784, -2.6626647018617158],
            [14.957704794456538, -2.6483242081578533],
            [14.966283591169613, -2.6429481089356175],
            [14.973365241388478, -2.6430618689247583],
            [14.978021873212658, -2.6400307315511182],
            [14.984333824335096, -2.6422353104097547],
            [14.994839083962523, -2.6350240036449866],
            [14.99806960217023, -2.6344251110674173],
            [15.009705315094727, -2.6349041482660636],
            [15.0154518672573, -2.6313515377098544],
            [15.021825536169146, -2.630243362165724],
            [15.027297157803169, -2.630850542849138],
            [15.028517919528644, -2.6259478403335828],
            [15.032959778905907, -2.6232051208602165],
            [15.038252328681784, -2.6229134862825947],
            [15.041839784714517, -2.62773732826871],
            [15.051892698519525, -2.63152817901004],
            [15.056443491003604, -2.635418312543402],
            [15.060096707171846, -2.6332527990493895],
            [15.065892740602546, -2.635679269393721],
            [15.071371845708303, -2.629110869457172],
            [15.079513075918172, -2.627693704648609],
            [15.085467582598023, -2.6307284050642155],
            [15.09232120384136, -2.625383542064901],
            [15.094222666737023, -2.6252265286135366],
            [15.097634166332515, -2.62014620071461],
            [15.099544738605324, -2.622795704876397],
            [15.104348993080945, -2.6190525838052587],
            [15.112187849180694, -2.6208748177423487],
            [15.170866197302468, -2.609247172017771],
            [15.305219864480684, -2.5826216039940384],
            [15.319711422655033, -2.6059775962554808],
            [15.351526150506608, -2.6577706600521664],
            [15.380250753007182, -2.7049789474331565],
            [15.386262580190039, -2.7151738490224764],
            [15.436366565830392, -2.8052276517325465],
            [15.43883888840617, -2.8065702819900675],
            [15.44010432520886, -2.8108112281622337],
            [15.443614358936362, -2.812682836989602],
            [15.451484874033696, -2.8118106029127112],
            [15.455800306362857, -2.8090518249613106],
            [15.464201288905421, -2.8155936014754914],
            [15.47484244422138, -2.8196615868663555],
            [15.489098938752676, -2.8336653982271023],
            [15.480078654076914, -2.843320847987237],
            [15.462741171214788, -2.863117442681887],
            [15.44526700578352, -2.883515213876557],
            [15.423285752381938, -2.913580649304022],
            [15.402289931653021, -2.945510182756747],
            [15.389471026729325, -2.958523674336032],
            [15.375336591763062, -2.979596619326448],
            [15.362335987880797, -3.0053462715264576],
            [15.359000369617544, -3.004283118422527],
            [15.351860113581075, -3.012339952071287],
            [15.345639545363529, -3.012014097093495],
            [15.340314691157717, -3.0146862242368613],
            [15.337831847722722, -3.012044249429105],
            [15.33796719956791, -3.0075176383080455],
            [15.327544568216313, -3.0054001279979836],
            [15.269950050423374, -2.961402049395519],
            [15.266458351261143, -2.9571334660099926],
            [15.26497153513582, -2.9531536640734255],
            [15.268877623511624, -2.9505728344115405],
            [15.268816628936806, -2.9477864520352335],
            [15.27157793585652, -2.942355927198679],
            [15.265879508412054, -2.937681781090375],
            [15.260593489024842, -2.9381404770502457],
            [15.259300014418002, -2.935568870469258],
            [15.254374590326362, -2.9322856310690426],
            [15.247767789064445, -2.936803929085288],
            [15.239274482623427, -2.9439169259804268],
            [15.229213967368562, -2.9464375082914946],
            [15.218963209439568, -2.955177557845673],
            [15.21304214517279, -2.963925055686912],
            [15.209924523254557, -2.9661394969034838],
            [15.202871680523998, -2.9685438253503733],
            [15.19689457863356, -2.966182586385214],
            [15.195704411464883, -2.958155135911782],
            [15.194166028550574, -2.9555941743368908],
            [15.189363052958754, -2.959289622357538],
            [15.182950309798432, -2.9597555865678227],
            [15.180377538084667, -2.961440589403703],
            [15.179202903413543, -2.9677351195757717],
            [15.174638111445551, -2.9761736943436867],
            [15.171492832313929, -2.979107086267099],
            [15.166879349232799, -2.9794030089530565],
            [15.164041472068, -2.975060685601132],
            [15.163642416596451, -2.9695938397605675],
            [15.156934173175655, -2.96919275103358],
            [15.155543569022846, -2.9765939510403587],
            [15.146839971483526, -2.971097233310866],
            [15.146350659148998, -2.961111997176267],
            [15.143292929708096, -2.960606966110594],
            [15.13764096990638, -2.9674659080767274],
            [15.134969351598142, -2.9727176862189966],
            [15.129106501748081, -2.9730367139171388],
            [15.12582249176645, -2.9747656909823927],
            [15.125766333859417, -2.9807939523552425],
            [15.127282255549895, -2.983832587652977],
            [15.133812093893988, -2.9849757290879593],
            [15.135500155021766, -2.9894028621314126],
            [15.130154386943422, -2.992984409431962],
            [15.125669003701411, -3.0049493886341705],
            [15.12751788918095, -3.010546841997833],
            [15.098931176909012, -3.0212009220031493],
            [15.095324833002024, -3.023367702118599],
            [15.092551280855131, -3.021726021726352],
            [15.089242182605645, -3.024543820159015],
            [15.085174778824442, -3.0248787386155738],
            [15.084384200439844, -3.020217430015149],
            [15.080180208311958, -3.0212360918508234],
            [15.07957995562367, -3.0177466108479902],
            [15.07383742589229, -3.013412230332853],
            [15.074132802737083, -3.0196252476431487],
            [15.06916051435483, -3.019582747953492],
            [15.060972258593283, -3.022139861468897],
            [15.058201805300412, -3.0202987484783157],
            [15.060281174501482, -3.01572268884248],
            [15.059839254655705, -3.012049285716989],
            [15.053593029420718, -3.007120015638332],
            [15.051073007602284, -3.0102530996544106],
            [15.044434125127582, -3.0104723000575357],
            [15.042175225617893, -3.0072094063251966],
            [15.03593183171643, -3.0093804711143393],
            [15.033067088496407, -3.0074233395656402],
            [15.026676964816271, -3.0058303177631913],
            [15.019024526953855, -2.999301268329978],
            [15.010222453882186, -3.002346059302542],
            [15.00629369131173, -2.998127015407538],
            [15.0030464746585, -3.0004353819833773],
            [15.004420439081313, -3.004682778566931],
            [15.001709330702045, -3.0061965613259947],
            [14.995976804139826, -3.004782679976492],
            [14.992400428290273, -3.00746646221076],
            [14.991137541766143, -3.013951830739296],
            [14.987606793348872, -3.016532323427761],
            [14.982973617639455, -3.017130140158855],
            [14.978193940679448, -3.024063368662966],
            [14.974314445622712, -3.0208233996678144],
            [14.963847164352947, -3.025472550811639],
            [14.955967802257492, -3.0263173963168013],
            [14.94892887027143, -3.0228811775803504],
            [14.946805765784582, -3.018525174857772],
            [14.947290530761537, -3.013860329363497],
            [14.945697320536814, -3.011818699239544],
            [14.934278234130323, -3.0097279828070884],
            [14.92896020739643, -3.005828789496438],
            [14.928513562988478, -3.0093747261484665],
            [14.924600942980495, -3.0088331825968093],
            [14.922188419818474, -3.0037322787068317],
            [14.91508292159957, -3.0004904363716522],
            [14.914017297636546, -2.994644380546036],
            [14.911625568750662, -2.993395224564304],
            [14.90799718363109, -2.995842905813743],
            [14.904232336468286, -2.9888003355088055],
            [14.955858626928096, -2.9115329489221264],
            [14.944641971375987, -2.90972091888634],
            [14.943476102502586, -2.9062107416557335],
            [14.931515628581671, -2.9046065122816294],
            [14.925599511678842, -2.8943055903962494],
            [14.919923890545729, -2.895972287532473],
            [14.915673855901902, -2.8930777405804555],
            [14.91047922071223, -2.894150734982431],
            [14.903260643169988, -2.893640377242654],
            [14.901531978187982, -2.890517893611882],
            [14.895512186155614, -2.886649171776789],
            [14.894033161846314, -2.887881300397096],
            [14.887530555678717, -2.8841831096689345],
            [14.884530525303749, -2.881209035051299],
            [14.881916889934775, -2.872940402738776],
            [14.881853875995825, -2.869185667997303],
            [14.875512124951696, -2.8711226340968903],
            [14.875280446579113, -2.866716299087751],
            [14.871779984915742, -2.861520483138475],
            [14.867825701405133, -2.8594789121534627],
            [14.865280318727871, -2.853824107211467],
            [14.873187798175767, -2.8451707174487995],
            [14.876713841882635, -2.8360783570517296]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.90529256494635, "lat": 34.52486482258561 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37141"],
        "coty_name": ["Pender"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pender County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01026129"
      },
      "bbox": [
        14.865280318727871, -3.0263173963168013, 15.489098938752676,
        -2.5826216039940384
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.876615406855657, 10.488323418964386],
            [-4.824181233494833, 10.483625339267533],
            [-4.746597204856611, 10.477295798777188],
            [-4.6639822583172315, 10.47046687441712],
            [-4.577369524388748, 10.463422669200593],
            [-4.490112223132064, 10.456445224099046],
            [-4.430908843506369, 10.451779183749064],
            [-4.417630167462963, 10.451381817187855],
            [-4.315912253844024, 10.443660787001914],
            [-4.228652211342684, 10.437166604385007],
            [-4.141718280201729, 10.430815495326982],
            [-4.149698577915197, 10.329150707537535],
            [-4.155891282343341, 10.24469771603429],
            [-4.162477516794807, 10.160324870697886],
            [-4.1263788502945395, 10.15775444305515],
            [-4.132679865888291, 10.073091599835482],
            [-4.14726861222064, 10.074058584429302],
            [-4.21917140254863, 10.07932748942123],
            [-4.281455768681091, 10.08392851185419],
            [-4.343741135736575, 10.0885163113951],
            [-4.405205934238718, 10.093154028222587],
            [-4.466671721691142, 10.097778863331646],
            [-4.5523616829356515, 10.10487531296916],
            [-4.6280626560396, 10.110876600946035],
            [-4.654502884046574, 10.112759161008533],
            [-4.740107060891566, 10.119606990454296],
            [-4.826823867368673, 10.126847632389975],
            [-4.906442846433892, 10.133658451760127],
            [-4.905307126280266, 10.149198526532292],
            [-4.8974769189566745, 10.243509053857254],
            [-4.8894667416146484, 10.340695202060454],
            [-4.887768629607052, 10.358453524260288],
            [-4.880903343777825, 10.439701622626465],
            [-4.877519723267879, 10.47585526220561],
            [-4.876615406855657, 10.488323418964386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.48721376887906,
          "lat": 48.814898102917375
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38023"],
        "coty_name": ["Divide"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Divide County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01034234"
      },
      "bbox": [
        -4.906442846433892, 10.073091599835482, -4.1263788502945395,
        10.488323418964386
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7112708565259114, 8.422798948927884],
            [-3.63983187434009, 8.418360309473735],
            [-3.5683938850162265, 8.413905947806791],
            [-3.4845101687079194, 8.408761910109028],
            [-3.4123271338438976, 8.404353049396022],
            [-3.293404327507125, 8.39747863431923],
            [-3.2543948286456312, 8.395121545451115],
            [-3.1549647302886252, 8.389509011529109],
            [-3.1115071625054314, 8.387454836025855],
            [-3.064707784713182, 8.385481773685683],
            [-2.991141224536958, 8.38208397821601],
            [-2.917575321050959, 8.378669539305582],
            [-2.920306179464315, 8.368836823445701],
            [-2.91673686155012, 8.360448805699797],
            [-2.9028813932290314, 8.348648393272457],
            [-2.9008818351049417, 8.346327860706614],
            [-2.899195701259279, 8.339922166201271],
            [-2.8983631653253052, 8.326811853044003],
            [-2.89926468508079, 8.318317164764428],
            [-2.9025262123065803, 8.301718752350634],
            [-2.899786729348857, 8.292597594700695],
            [-2.8821590079732697, 8.260749937884514],
            [-2.8750099187310165, 8.241994111977464],
            [-2.8686950117838075, 8.231396405087068],
            [-2.8596615904497047, 8.22155779478527],
            [-2.8546780048064817, 8.215336085440427],
            [-2.8509372228821754, 8.212773948993673],
            [-2.8453819071835893, 8.19972971707017],
            [-2.847326260303609, 8.19232604331718],
            [-2.847468537045952, 8.1862629817666],
            [-2.855674508749758, 8.171273569252797],
            [-2.8602061775821355, 8.16648533980374],
            [-2.8625827772759953, 8.159704599860707],
            [-2.860779707013394, 8.153089990094742],
            [-2.860143593996389, 8.145120963342666],
            [-2.8573409470179603, 8.140143169337396],
            [-2.848926282537598, 8.132935923984663],
            [-2.8434836670736003, 8.130898126418593],
            [-2.8333505468346445, 8.13188495562527],
            [-2.822782949879951, 8.130846062707755],
            [-2.8193247105606978, 8.122934659414518],
            [-2.820467134560221, 8.116826184960168],
            [-2.822924829777628, 8.114517136146775],
            [-2.831578683686624, 8.113698494687874],
            [-2.8365218377631933, 8.110815808947947],
            [-2.8332187532846613, 8.098405667037692],
            [-2.8314178866060207, 8.086961807211635],
            [-2.829002182374843, 8.083708051365601],
            [-2.824383041603789, 8.081459746495076],
            [-2.818503220336971, 8.081934602514961],
            [-2.80904558176327, 8.086044216349128],
            [-2.8035482099776243, 8.086410915980624],
            [-2.800633548262196, 8.083607693729782],
            [-2.798091347791244, 8.07830613680362],
            [-2.7975681043560257, 8.070182299585568],
            [-2.800648302991194, 8.066821800818232],
            [-2.802929942928849, 8.059945508326],
            [-2.802135778125587, 8.056525643357151],
            [-2.7974273613956244, 8.051997470050821],
            [-2.7914191964254687, 8.049412965285674],
            [-2.780362973661036, 8.050657004693454],
            [-2.773210238286568, 8.053241049096771],
            [-2.754586290570809, 8.065425596492593],
            [-2.748287065530829, 8.066996630921924],
            [-2.737987520709598, 8.070705243028875],
            [-2.7309253194339314, 8.06887453929033],
            [-2.7296683298856514, 8.066184261259203],
            [-2.7316458744421355, 8.05640082545691],
            [-2.734722140941686, 8.052540071502662],
            [-2.7391766426726, 8.049304347455172],
            [-2.7446019405098316, 8.041614024990704],
            [-2.747949646055862, 8.031391224104542],
            [-2.747059862144836, 8.026396050214682],
            [-2.7414635468895168, 8.020816517815845],
            [-2.733183189461599, 8.013991852086212],
            [-2.7256597060532024, 8.005227361748101],
            [-2.722949351192039, 8.00307980882939],
            [-2.7070967542688864, 7.993907989354957],
            [-2.6955706611504584, 7.989202611324211],
            [-2.6844006613759386, 7.983287826167278],
            [-2.679802710132035, 7.976963697859333],
            [-2.67999844251113, 7.973439998090282],
            [-2.6832372752417357, 7.967839353984227],
            [-2.687442792305371, 7.9672767315616015],
            [-2.6938201427185553, 7.970518283080817],
            [-2.6972293210221054, 7.969282781821101],
            [-2.6983960108130667, 7.963607317984722],
            [-2.6915114065867938, 7.9526159165914825],
            [-2.6710298391191523, 7.9230939798310835],
            [-2.672311162861365, 7.914677795669834],
            [-2.6759222768991937, 7.909358389399022],
            [-2.68466726585662, 7.902254374844984],
            [-2.6959456833452293, 7.896390286523072],
            [-2.7019840991627557, 7.883961654464372],
            [-2.7056140786137837, 7.870489648192814],
            [-2.707515601820271, 7.857032805205064],
            [-2.711911689125694, 7.843496757488182],
            [-2.7125137972170816, 7.836739871472303],
            [-2.711878822894082, 7.831428783198353],
            [-2.7075863898086365, 7.820145042858061],
            [-2.714423049285875, 7.821857559204996],
            [-2.7163950940937083, 7.816907546744328],
            [-2.722177645732148, 7.82035076301197],
            [-2.723565432953447, 7.817450052089384],
            [-2.720076935705018, 7.815205002395944],
            [-2.7213639501225484, 7.8101230737625595],
            [-2.7254873397534216, 7.810717161694663],
            [-2.728851099629671, 7.816913287765715],
            [-2.7335117472770856, 7.817633687187402],
            [-2.733411957794645, 7.812598833683981],
            [-2.74440302497952, 7.806620155962218],
            [-2.750318096136689, 7.806523064807811],
            [-2.755605460340086, 7.802707006478513],
            [-2.7608995425610723, 7.801378673224792],
            [-2.7665679615040615, 7.807903112707752],
            [-2.771630985545039, 7.807752528941054],
            [-2.774937601509356, 7.805442909284735],
            [-2.779284169965429, 7.79397174152368],
            [-2.783771890759934, 7.790350866298323],
            [-2.786579855553032, 7.790439090133578],
            [-2.788656871363126, 7.795272145994959],
            [-2.791175873163352, 7.7935220168289066],
            [-2.791929356785428, 7.789548122856271],
            [-2.7901710915598166, 7.78306329997605],
            [-2.798403791899596, 7.777494853959875],
            [-2.801463127262443, 7.77811947843381],
            [-2.799934867944921, 7.787226088660681],
            [-2.8022093403457298, 7.7897790070359365],
            [-2.8068441814703555, 7.787631094101922],
            [-2.8109217370761463, 7.788870382907241],
            [-2.8084207493595916, 7.793632426148905],
            [-2.8104369831260048, 7.799089435866429],
            [-2.813659153188805, 7.79820598659576],
            [-2.8187801446190264, 7.790881867909961],
            [-2.8217071304952683, 7.793810114308805],
            [-2.8253968439326695, 7.794561098684832],
            [-2.828912009561452, 7.792454162104177],
            [-2.8307392534892752, 7.7965263081532585],
            [-2.83372752441725, 7.796223817669555],
            [-2.836300804452011, 7.790633203301979],
            [-2.841137865568593, 7.789518793829237],
            [-2.851004052597101, 7.79069337921988],
            [-2.858464742598975, 7.78931574994491],
            [-2.8601379925690305, 7.78489268673644],
            [-2.8648632539916883, 7.785129894672654],
            [-2.869040178536999, 7.7896351248622855],
            [-2.8752249689223266, 7.788858113233713],
            [-2.8767171781669783, 7.793658948387334],
            [-2.879862106230011, 7.79209793551704],
            [-2.8911347424538896, 7.79707279783466],
            [-2.890836428532562, 7.802009735123909],
            [-2.8969758559664585, 7.800462792482073],
            [-2.8974416338809204, 7.7953759959109235],
            [-2.9018149824280517, 7.791683708133338],
            [-2.9091567860268577, 7.79208080999941],
            [-2.911603353640928, 7.79469491822406],
            [-2.907855483108971, 7.803341743935954],
            [-2.908621457822437, 7.811385910784851],
            [-2.9134673038876397, 7.810574173931193],
            [-2.9155732063311137, 7.807924152757036],
            [-2.920638124757567, 7.806422588781125],
            [-2.92096951126769, 7.7988189279982825],
            [-2.928519306903949, 7.800949492704036],
            [-2.9362193652481334, 7.7989269907813705],
            [-2.9361992799927497, 7.79582791871033],
            [-2.940440350870421, 7.79084588735096],
            [-2.9413444267909816, 7.78668587333675],
            [-2.9455688279165093, 7.785501911124055],
            [-2.9460430483668576, 7.780392468271842],
            [-2.951019386747744, 7.78144038782654],
            [-2.949933866224075, 7.776031772507439],
            [-2.9540044265336163, 7.773415250785342],
            [-2.9558682577284183, 7.766659126354909],
            [-2.953328918238235, 7.763181099177095],
            [-2.95412812543192, 7.755351238299385],
            [-2.9643951533909534, 7.754929314133005],
            [-2.967590079198133, 7.753736705300408],
            [-2.965727292436816, 7.746085463231433],
            [-2.9752700361442352, 7.742889849644065],
            [-2.9760023571551377, 7.740258310495625],
            [-2.97445205263924, 7.73536037074866],
            [-2.977880750873286, 7.732324188170717],
            [-2.981450573951505, 7.7366481764297745],
            [-2.9850639767546876, 7.732263864511778],
            [-2.985405291082587, 7.726173990616754],
            [-2.9931041648305294, 7.72324479923934],
            [-2.9991886772588243, 7.731324174473852],
            [-3.0028353310910174, 7.731539474107914],
            [-3.0081449229112223, 7.728064536414128],
            [-3.004744336014395, 7.721572773235499],
            [-3.0064165513987104, 7.716005563525865],
            [-2.999116907005013, 7.715256729949841],
            [-2.9983618479721548, 7.707637871225756],
            [-3.0013505278864527, 7.704786229332417],
            [-3.008869908991069, 7.708238685753755],
            [-3.010383472580841, 7.702640049640035],
            [-3.0158573960458073, 7.696955813516589],
            [-3.0157598208498766, 7.693614046444261],
            [-3.0315301068361036, 7.694707449942401],
            [-3.0278176768103955, 7.762386890938703],
            [-3.0269455170477313, 7.780357486054376],
            [-3.1135796342961144, 7.78485133830561],
            [-3.1999489241346684, 7.789651940408132],
            [-3.197044744277553, 7.839152305238038],
            [-3.192587039852406, 7.918321218652339],
            [-3.185443488531518, 8.04504357505131],
            [-3.1998959904653668, 8.045883341378845],
            [-3.3079993626324358, 8.052287979081425],
            [-3.416104925242978, 8.058657523447028],
            [-3.4740060455123305, 8.062291074168444],
            [-3.46870593913861, 8.147686697466495],
            [-3.5697081243839985, 8.15364168092645],
            [-3.6562915904935327, 8.159035120590072],
            [-3.7283245873380455, 8.163618890061162],
            [-3.721273906307591, 8.275499319427364],
            [-3.721286633045893, 8.277551386483568],
            [-3.717360032213906, 8.340358149167207],
            [-3.712205424561722, 8.422081766460328],
            [-3.7112708565259114, 8.422798948927884]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.281101669734, "lat": 46.716056347870385 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38059"],
        "coty_name": ["Morton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morton County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01034207"
      },
      "bbox": [
        -3.7283245873380455, 7.693614046444261, -2.6710298391191523,
        8.422798948927884
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8817394045715924, 8.983366669891064],
            [-0.812602534246605, 8.98185578338125],
            [-0.7375814830023625, 8.980309577024082],
            [-0.7372583027717198, 8.980435078228838],
            [-0.6526916079371967, 8.978885064843757],
            [-0.5349357592720008, 8.976888991956685],
            [-0.5369700010526448, 8.863276459203979],
            [-0.5378953079327693, 8.822363463569259],
            [-0.5383480077331227, 8.783277929956627],
            [-0.5390170205297093, 8.75004297178219],
            [-0.5393175951457669, 8.74823801876579],
            [-0.5412957280409796, 8.635801943860805],
            [-0.5259056511765969, 8.635416325841136],
            [-0.5271099157272124, 8.551450300291648],
            [-0.5484127774751937, 8.55197419671126],
            [-0.6137263783614049, 8.552773404055186],
            [-0.7007538379466276, 8.555203799482637],
            [-0.7884507313783115, 8.557074908175707],
            [-0.8172075121934531, 8.557957696704475],
            [-0.8749783632469653, 8.558870236076073],
            [-0.8734380757002733, 8.616194893137017],
            [-0.8725222566915833, 8.643121080103437],
            [-0.890404306280313, 8.643639593229842],
            [-0.8894906996329542, 8.671987433491184],
            [-0.8888552401990555, 8.703818003621176],
            [-0.8880717641986481, 8.728860026996982],
            [-0.885210804648022, 8.84703790017202],
            [-0.8817394045715924, 8.983366669891064]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.72463911216907, "lat": 47.45614772409915 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38091"],
        "coty_name": ["Steele"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Steele County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01034220"
      },
      "bbox": [
        -0.890404306280313, 8.551450300291648, -0.5259056511765969,
        8.983366669891064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.240897901525374, 3.28811523320743],
            [10.283578971521614, 3.292678709441757],
            [10.325639961742574, 3.2975736032812453],
            [10.35990886579917, 3.3017976370372586],
            [10.374564046149438, 3.3033802978024127],
            [10.39369174807803, 3.306103074684292],
            [10.402478526956145, 3.3069266042472543],
            [10.430105449613963, 3.3108926428889407],
            [10.464473351180057, 3.315125530949581],
            [10.536209882764116, 3.3235764945780617],
            [10.610096679768274, 3.334586088589911],
            [10.62211609006399, 3.262129625097881],
            [10.624775390018895, 3.238782790084802],
            [10.632496074696784, 3.1889970661211833],
            [10.633951068149269, 3.180619848914138],
            [10.6376423483635, 3.1672795669319487],
            [10.645961852232912, 3.117566016248974],
            [10.571692908983014, 3.1064822012957207],
            [10.585091208642796, 3.034725132305295],
            [10.551961109580954, 3.0299506821164974],
            [10.509930785603865, 3.02451780261926],
            [10.474899612257314, 3.020262067081329],
            [10.438315168870542, 3.0155398905549773],
            [10.39555701734998, 3.010295972587006],
            [10.368354115410158, 3.006697176946734],
            [10.315184684298101, 2.999763159828797],
            [10.290588097838194, 2.996825172820242],
            [10.27653419255951, 3.0801835352311566],
            [10.261616598366654, 3.166560587215307],
            [10.246748428738924, 3.2536842947005415],
            [10.240897901525374, 3.28811523320743]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.59802903432241, "lat": 41.14627658356218 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39077"],
        "coty_name": ["Huron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Huron County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01074051"
      },
      "bbox": [
        10.240897901525374, 2.996825172820242, 10.645961852232912,
        3.334586088589911
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.810522859209247, 2.820032988056947],
            [11.834034296690605, 2.8229152736918723],
            [11.896284582300675, 2.8313832614283765],
            [11.898332429215538, 2.817769013871071],
            [11.95744809286186, 2.826503759972248],
            [11.959651981628758, 2.817846787738127],
            [11.972218006509642, 2.808539335118243],
            [11.982728945456541, 2.7958290761712563],
            [11.990456656725499, 2.7871731707810636],
            [11.995093575755044, 2.784955945258948],
            [12.001529075588554, 2.7703893039569896],
            [12.003843995972677, 2.7623543227675507],
            [12.007645480301859, 2.752552430540526],
            [12.016339824422534, 2.7411646944463723],
            [12.02480842954946, 2.7354612842953547],
            [12.029905768362802, 2.724858192759114],
            [12.030240568428555, 2.716744481332293],
            [12.02941692648853, 2.71150468553041],
            [12.026274671205305, 2.702211549144037],
            [12.02640680004802, 2.699067812347683],
            [12.023163944505196, 2.689451064058613],
            [12.023189631417694, 2.6808782005111715],
            [12.0254671998253, 2.6702219817931683],
            [12.026941815267987, 2.659332460175073],
            [12.028230209940004, 2.6556624009370817],
            [12.02634778293022, 2.6512707854513082],
            [12.016331634287456, 2.6446746820891716],
            [12.01416567249367, 2.639686245460866],
            [12.017197948482396, 2.6344957619887053],
            [12.026309120962685, 2.6327828761938314],
            [12.034495053860997, 2.627174379521403],
            [12.036938502303638, 2.6220587567742575],
            [12.037354936825018, 2.6143656397019335],
            [12.036149437939432, 2.6072247414135736],
            [12.036623670439534, 2.599643035510007],
            [12.039220717793858, 2.5931224744659955],
            [12.047226968065498, 2.5811540899012666],
            [12.051124313675498, 2.571373461639385],
            [12.050611797655698, 2.560464090426766],
            [12.048371685060834, 2.5568302442268585],
            [12.044115058925815, 2.5439821735536983],
            [12.043786792764612, 2.5370858843097017],
            [12.046348111187442, 2.5242275846106366],
            [12.04518797968781, 2.516786893718408],
            [12.043352103784562, 2.5130149587918402],
            [12.03367104518207, 2.503777120424714],
            [12.028558883880159, 2.499880561604579],
            [12.023981523791827, 2.4927011551834775],
            [12.019389112001294, 2.476458588339056],
            [12.01905365591156, 2.465549393136807],
            [12.019650449646582, 2.4524721913780247],
            [12.019374574450193, 2.4456864267338037],
            [12.017195108233604, 2.437876247442421],
            [12.01141325258845, 2.429986718159766],
            [12.008822141814768, 2.4255221209542603],
            [12.000213330250569, 2.399254611613877],
            [11.952745649229783, 2.3942164781447266],
            [11.953197291813817, 2.3894527719385086],
            [11.927389983150157, 2.3867748173190404],
            [11.924313081882778, 2.3860829456026162],
            [11.890376792586835, 2.3826934163508837],
            [11.865284118142085, 2.379784350815973],
            [11.854662526244391, 2.4681154499752975],
            [11.84956317959188, 2.5123218188250127],
            [11.841102123639715, 2.5813609249146148],
            [11.838972566312043, 2.594270920047595],
            [11.838586766298812, 2.6000650631112694],
            [11.84184407069904, 2.6005058427603935],
            [11.836142363377544, 2.644044285822925],
            [11.8178730770619, 2.641544493959263],
            [11.778928960595943, 2.6366968061760123],
            [11.773290785863642, 2.680341512697691],
            [11.784957529300824, 2.6818230336156192],
            [11.783726096641615, 2.6927650373408722],
            [11.777797360253535, 2.7369667416743177],
            [11.773593392700475, 2.770152599134122],
            [11.816391224685553, 2.7760829703065073],
            [11.810522859209247, 2.820032988056947]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.76101403127909, "lat": 40.38502027999564 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39081"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01074053"
      },
      "bbox": [
        11.773290785863642, 2.379784350815973, 12.051124313675498,
        2.8313832614283765
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.0437463053498285, -4.23028764552597],
            [0.045127044544229424, -4.230128185834697],
            [0.045610846077591895, -4.142390636062536],
            [0.04601624361284946, -4.05465875856874],
            [0.1323167779717077, -4.055116976093927],
            [0.13226781770148371, -4.03914412325927],
            [0.1325905014066569, -3.967302576314728],
            [0.22516945661059248, -3.968108105980122],
            [0.2540178105963978, -3.9682175715758716],
            [0.388789525413217, -3.967820927164412],
            [0.388670430992129, -4.055251379883749],
            [0.3885428085456249, -4.1286808596610385],
            [0.38851159957036435, -4.230618361112347],
            [0.34484921556595377, -4.2307781039798655],
            [0.34498266823190044, -4.304841588419098],
            [0.34472958544376925, -4.31886933569385],
            [0.2732007280575582, -4.318632921632405],
            [0.2472196056115972, -4.31867167612506],
            [0.18036774299217945, -4.318451428738625],
            [0.13060229734671366, -4.318171333212725],
            [0.09297544409380648, -4.318009598754928],
            [0.09202440716855426, -4.3168300342920745],
            [0.043294153742710624, -4.316564491876916],
            [0.0437463053498285, -4.23028764552597]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.29775763586657,
          "lat": 34.588204511867424
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40029"],
        "coty_name": ["Coal"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coal County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01101802"
      },
      "bbox": [
        0.043294153742710624, -4.31886933569385, 0.388789525413217,
        -3.967302576314728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.5388493143221, 9.495715530220002],
            [-18.452805897214873, 9.470813364385213],
            [-18.36676862612662, 9.445888581000293],
            [-18.31713601552822, 9.431241737760683],
            [-18.320709038084317, 9.417342957749526],
            [-18.307261457919743, 9.413471140074462],
            [-18.311327004991632, 9.399660210825107],
            [-18.290487251256998, 9.393771630507283],
            [-18.283080300748324, 9.392212415153676],
            [-18.26948615169789, 9.38792176232602],
            [-18.25560346067078, 9.38415759535012],
            [-18.259642497567608, 9.370854526551852],
            [-18.245484527394986, 9.36678678279709],
            [-18.249812117123565, 9.353065899094577],
            [-18.23639888640268, 9.348296479470726],
            [-18.24043258127239, 9.334679781508118],
            [-18.226299708490387, 9.330275749506805],
            [-18.23026153665159, 9.316694666787283],
            [-18.188900586861788, 9.304528893058302],
            [-18.196972117767068, 9.27732582035037],
            [-18.169354323092826, 9.269267462047688],
            [-18.185567361802683, 9.214628335158103],
            [-18.173307171577253, 9.211116349530005],
            [-18.180707195160977, 9.20811692551068],
            [-18.186839947008668, 9.208078079087745],
            [-18.194512063105417, 9.211772885673511],
            [-18.202973399700248, 9.217990127408074],
            [-18.207646363748584, 9.21790163072526],
            [-18.21491548414506, 9.230464758209747],
            [-18.221606518357355, 9.234168657264872],
            [-18.23691100104584, 9.237385294080601],
            [-18.23911204260154, 9.240451284603909],
            [-18.240494972098457, 9.249948000574326],
            [-18.243314583420993, 9.257136078885015],
            [-18.245663508767866, 9.25800649283037],
            [-18.251899906703414, 9.254551145524259],
            [-18.253259627924912, 9.250857489628826],
            [-18.256549957635876, 9.248021048912983],
            [-18.266322603626854, 9.246086703816362],
            [-18.27056383661988, 9.244321900762586],
            [-18.276589762541352, 9.237615317109794],
            [-18.278705456501175, 9.224355747398384],
            [-18.27801480730684, 9.217458935163734],
            [-18.28024820480381, 9.212011662301252],
            [-18.28415257890063, 9.206343943788246],
            [-18.290358577104904, 9.206115795172188],
            [-18.30252342852663, 9.210742877058697],
            [-18.311815463381336, 9.21210289703105],
            [-18.32040172967423, 9.207135271499967],
            [-18.322973156009418, 9.203734960465207],
            [-18.322117594105926, 9.19363213492002],
            [-18.319640423622822, 9.190665756950345],
            [-18.31024504284404, 9.191067717004588],
            [-18.306496906938854, 9.189494305726237],
            [-18.305115943680985, 9.18420785291988],
            [-18.307177320456763, 9.177114494627004],
            [-18.30825768913493, 9.164836977942198],
            [-18.30653542540896, 9.160259736035119],
            [-18.30183929577514, 9.153050428092142],
            [-18.301916350357335, 9.150018358294483],
            [-18.307740694744258, 9.14665328213216],
            [-18.314034938686614, 9.15183186491526],
            [-18.320893626424944, 9.152629887698337],
            [-18.32690544174349, 9.14606685100802],
            [-18.32837625887313, 9.139657001806793],
            [-18.326906050684425, 9.133459646005583],
            [-18.319324792044576, 9.126581359921845],
            [-18.317935307570952, 9.118474886462423],
            [-18.313655540808007, 9.11103823705347],
            [-18.311980206610016, 9.105220622121468],
            [-18.31469427879752, 9.102528889705354],
            [-18.32011882665326, 9.100382899421733],
            [-18.324704384470245, 9.095890358714307],
            [-18.331458414800338, 9.093222113621664],
            [-18.338018975018652, 9.09469715333503],
            [-18.344550708104734, 9.093672266745092],
            [-18.353712479386868, 9.087530728383928],
            [-18.364180129748455, 9.085142372992474],
            [-18.371960066406658, 9.081197430529482],
            [-18.37274028182926, 9.078265801151769],
            [-18.495213094468568, 9.114010094268266],
            [-18.543854814551484, 9.128657321804782],
            [-18.666242007847085, 9.16408138708065],
            [-18.716249599558285, 9.179688316330706],
            [-18.816054304896127, 9.20944573099647],
            [-18.815891615117994, 9.209966036942376],
            [-18.856222724161054, 9.221809609226499],
            [-18.853077892848972, 9.233261731650567],
            [-18.83669037400504, 9.286207233733629],
            [-18.83330957484706, 9.30069504944472],
            [-18.8284499697218, 9.313348991051004],
            [-18.82011656053301, 9.340496965019595],
            [-18.816296816538802, 9.353999112178522],
            [-18.78744021290825, 9.34540800417014],
            [-18.728753632475343, 9.328388721862346],
            [-18.721556102773704, 9.326770413385846],
            [-18.701033965988046, 9.320714909255882],
            [-18.69612700043478, 9.31870245400829],
            [-18.613015807223903, 9.293810411556953],
            [-18.59980311556948, 9.290116067318204],
            [-18.58705381529634, 9.331300279674958],
            [-18.581306894895302, 9.350497886301023],
            [-18.564231196557387, 9.405273813233531],
            [-18.55509192915027, 9.43995796279079],
            [-18.54396821597032, 9.480807064886756],
            [-18.5388493143221, 9.495715530220002]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.30811704189989,
          "lat": 45.23262680302027
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41071"],
        "coty_name": ["Yamhill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yamhill County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01135866"
      },
      "bbox": [
        -18.856222724161054, 9.078265801151769, -18.169354323092826,
        9.495715530220002
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.819598742838247, 3.3149544895529295],
            [13.82006007595285, 3.3152020838744276],
            [13.902942702149787, 3.3014212502247138],
            [13.916936941574749, 3.2987512341678764],
            [13.95577130918541, 3.2922002406169977],
            [13.981350449164017, 3.3167806210266724],
            [13.987950582494515, 3.323658989257778],
            [14.011025306098396, 3.3430937058657926],
            [14.033902522440131, 3.360550034445948],
            [14.080089721054966, 3.34480631304816],
            [14.115352990703958, 3.359762011322922],
            [14.123818758435238, 3.3482700802460426],
            [14.142432184885374, 3.3674797840551625],
            [14.148486365805283, 3.3550095163478546],
            [14.132585503329079, 3.3401463345528786],
            [14.135345099947196, 3.3335876243861717],
            [14.133560693941627, 3.3277160971019],
            [14.130080279326059, 3.3247902404104503],
            [14.13548784588286, 3.3150173901988715],
            [14.1481372801553, 3.3225767758774523],
            [14.150506381979417, 3.3207946123843994],
            [14.14843260320174, 3.314268974411364],
            [14.146155484612306, 3.3120670671321997],
            [14.133737498853504, 3.29627948646821],
            [14.127213918320912, 3.2908713801948632],
            [14.128091766492371, 3.2875611771296307],
            [14.12352008666145, 3.2805151216581505],
            [14.119127437563673, 3.2757304310079807],
            [14.109354368179789, 3.261069758669569],
            [14.095171985295208, 3.251786116009564],
            [14.090932155933588, 3.244525099641734],
            [14.07892249679082, 3.221594099743399],
            [14.073354042905354, 3.2098611835260598],
            [14.06927542038917, 3.1997392414934898],
            [14.068207399003125, 3.1990772698646515],
            [14.062951326633645, 3.1805132046632725],
            [14.058482235460293, 3.166827740703634],
            [14.086513360109606, 3.121481887222688],
            [14.085605634820444, 3.118858309388912],
            [14.07973650880338, 3.110940795764819],
            [14.075493741712753, 3.102604534050488],
            [14.071442897132295, 3.090756783719014],
            [14.057554196269432, 3.0591406224312276],
            [14.046218222594334, 3.038513777986155],
            [14.043136174855187, 3.027782443287428],
            [14.035465123566778, 3.0228483543026137],
            [14.033406502618934, 3.0170453843303124],
            [14.034098350820047, 3.006847835391724],
            [14.052482045328766, 3.0102634551512932],
            [14.054863194965158, 3.003333581444659],
            [14.061868626588831, 3.0069326474542035],
            [14.067609197343465, 3.0067167736642983],
            [14.067752320363255, 2.9961417391521166],
            [14.074670091159224, 2.9875861027546398],
            [14.078634459641894, 2.9858388858731506],
            [14.081301710671493, 2.9824408237015496],
            [14.086796302073408, 2.9826978187435724],
            [14.091084460105115, 2.9873226234367323],
            [14.095739434915101, 2.988307934585907],
            [14.103030414846286, 2.984447230051435],
            [14.11197875362304, 2.9827363499262263],
            [14.114525185878714, 2.9852269862697103],
            [14.116546175258916, 2.9918801371959955],
            [14.152603051733436, 2.999012023995482],
            [14.157830739123474, 3.0100970261544444],
            [14.172950317999899, 2.982938637769564],
            [14.216407257384752, 2.903469729259752],
            [14.212859068620016, 2.9004917528479726],
            [14.210015684110783, 2.8949736903095404],
            [14.20328787760142, 2.887107045488951],
            [14.19576297108946, 2.8725869036414826],
            [14.179369149556447, 2.835242851945328],
            [14.165685305107514, 2.7942827632801253],
            [14.161814226205282, 2.779207879044794],
            [14.158598143175908, 2.764012611414443],
            [14.157797353670064, 2.757468999462612],
            [14.151782741844624, 2.740210316103013],
            [14.13831620398398, 2.684678733068451],
            [14.135190432264116, 2.680339576828759],
            [14.081620048336223, 2.7135558883685857],
            [14.081757321522858, 2.711461626313312],
            [14.006820123990444, 2.7169837024788333],
            [13.96233854268569, 2.720755962212958],
            [13.91426602506343, 2.7443245820688147],
            [13.900379680222763, 2.7518862206448835],
            [13.82773486516093, 2.7888383345545855],
            [13.826417093736913, 2.7908930649973054],
            [13.808354558057587, 2.8346648500109572],
            [13.798297633988707, 2.858536736840681],
            [13.80095710648385, 2.8738138711310275],
            [13.807607094049517, 2.897176794075718],
            [13.813457722357468, 2.9114114057920273],
            [13.818214274630686, 2.919455103129846],
            [13.82036212521954, 2.9258572737752266],
            [13.821151819364133, 2.9338125914360185],
            [13.829693153876924, 2.9600444854587757],
            [13.831876062254747, 2.9694768404450183],
            [13.836408909685074, 2.979324772781067],
            [13.845419654153963, 3.0068234061494397],
            [13.846806776925547, 3.0097414462546044],
            [13.856644557569753, 3.0494068840523294],
            [13.858070814392466, 3.0586483019720627],
            [13.856056294853724, 3.0694990007957785],
            [13.854044876141334, 3.07309234901673],
            [13.85090029434862, 3.07392237355892],
            [13.843070774514171, 3.061582170022297],
            [13.83958135500988, 3.0618725753300637],
            [13.83781424718309, 3.0701390556521395],
            [13.83763176365028, 3.0837979248619445],
            [13.8357207330038, 3.0988202579122364],
            [13.83563972595189, 3.106949921085602],
            [13.838665273887907, 3.120787520216668],
            [13.838266034491705, 3.125231184817192],
            [13.842930095366347, 3.1439138669280107],
            [13.83925035249351, 3.1457133988092583],
            [13.837134272005182, 3.144061700967723],
            [13.835851559565986, 3.1313673287456885],
            [13.833377795642837, 3.1276650350288864],
            [13.834277792520979, 3.122917639724598],
            [13.831338184872525, 3.1192510874985855],
            [13.831162311458971, 3.1137488886596323],
            [13.823092737929946, 3.107496819295792],
            [13.821641838206306, 3.1025280522811634],
            [13.817345766454647, 3.1046736127342944],
            [13.813581621081672, 3.1040177016829094],
            [13.811881833970762, 3.1069538522535547],
            [13.805349376730923, 3.1119231613955103],
            [13.801304910272433, 3.1188872984449545],
            [13.794077604036872, 3.1249014724573394],
            [13.803226177560775, 3.1526132602635517],
            [13.800794615031261, 3.1613163379244895],
            [13.796674836619465, 3.1631705654021394],
            [13.802756380961554, 3.1817106990108694],
            [13.80554327511928, 3.18827273758337],
            [13.800424613871789, 3.1935371586981485],
            [13.798773031913282, 3.1971246052608855],
            [13.794790850355023, 3.1952209910276306],
            [13.785960055766111, 3.1995789738273746],
            [13.784306918973357, 3.2037515435765545],
            [13.779210571830443, 3.2043305999273954],
            [13.779029078838963, 3.208214861587903],
            [13.776452681795538, 3.2130911313056374],
            [13.769214802921537, 3.219304644354615],
            [13.761712135822036, 3.2284182674474557],
            [13.75388422462402, 3.236301305232242],
            [13.755887815714377, 3.2452244865566593],
            [13.762511606339016, 3.259798398286401],
            [13.7656271020918, 3.26356286499009],
            [13.76935578724399, 3.2625486398290042],
            [13.777086281222568, 3.2728335166866103],
            [13.78508902248704, 3.2812114575695874],
            [13.789339223888378, 3.2829364465765996],
            [13.794950739950943, 3.283464482105407],
            [13.794585658075261, 3.28828933724153],
            [13.805751390165069, 3.2971010808503474],
            [13.812585575095726, 3.305360511349986],
            [13.819598742838247, 3.3149544895529295]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.98126437970139,
          "lat": 40.416945542260166
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42061"],
        "coty_name": ["Huntingdon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Huntingdon County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01213672"
      },
      "bbox": [
        13.75388422462402, 2.680339576828759, 14.216407257384752,
        3.3674797840551625
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.366553854952356, 3.491136857003487],
            [14.39069973116427, 3.506043175337695],
            [14.445031461158184, 3.532157024308027],
            [14.524414791650347, 3.570332603922689],
            [14.562332963181778, 3.592885570980633],
            [14.578316246327184, 3.5971888525280575],
            [14.588356486119912, 3.5923744694886643],
            [14.590151648782928, 3.594673333180924],
            [14.594190288706708, 3.594977117882848],
            [14.600633333761339, 3.58947504491226],
            [14.604934454983004, 3.591218679805778],
            [14.608964112858619, 3.6036561956108004],
            [14.612457613740734, 3.6068977163970795],
            [14.618539234707649, 3.6080319519804016],
            [14.620062075791425, 3.611526450809055],
            [14.634724629719573, 3.616540703250308],
            [14.63628087114541, 3.6207541362553526],
            [14.652110130454151, 3.6289233536412],
            [14.655583626758704, 3.631990906455931],
            [14.66599817606535, 3.633412036050298],
            [14.672728931931257, 3.6325233344808625],
            [14.683023215868463, 3.634386785060986],
            [14.693013880379537, 3.6402511396661104],
            [14.703049729534154, 3.6379782861805188],
            [14.716767605932272, 3.645687747655275],
            [14.721441594470758, 3.6460178010746955],
            [14.723436860829858, 3.6441123549256056],
            [14.729995116102144, 3.6459888262238755],
            [14.73425901211137, 3.649543658532029],
            [14.740976730796536, 3.6492997324339878],
            [14.75579234194234, 3.6426588294303714],
            [14.760271767799443, 3.644378512180812],
            [14.760781992808905, 3.6471804367048355],
            [14.76264376634065, 3.643791863698369],
            [14.762423849878823, 3.6384563400852157],
            [14.758977362014349, 3.6186338747573235],
            [14.758459197621239, 3.610815911418053],
            [14.755542978266897, 3.606352443867163],
            [14.749452173283458, 3.5925099219360277],
            [14.743369369646352, 3.5812987005659824],
            [14.739323973461605, 3.5684971828821284],
            [14.740372764940442, 3.564933487453143],
            [14.73807309302093, 3.5492825778487402],
            [14.7386085059078, 3.5348359474765965],
            [14.745284793467812, 3.51333058118437],
            [14.745417881487679, 3.508475340973666],
            [14.74991198432219, 3.4939876759959327],
            [14.751617944731816, 3.4815812328217977],
            [14.750388977890804, 3.469995403629863],
            [14.74879997996414, 3.462487316192478],
            [14.744410733029193, 3.4494656071406866],
            [14.74156257246899, 3.4431203481524193],
            [14.737158065060127, 3.437494278570629],
            [14.72651957709224, 3.4266038914840515],
            [14.721801288678815, 3.419013420389491],
            [14.718962449669139, 3.4112297894436874],
            [14.718205195267851, 3.4061871422134935],
            [14.714708158361836, 3.3950344593973205],
            [14.707192065586309, 3.3857358046673434],
            [14.70500821952111, 3.393546435843424],
            [14.700041595982423, 3.3965942215950564],
            [14.689511503726454, 3.38988905749168],
            [14.685308118844498, 3.3886324525930998],
            [14.68621004310251, 3.3846798139485306],
            [14.680495709322097, 3.3851188338450426],
            [14.678685227743854, 3.3873874597938003],
            [14.670591624785944, 3.383917034911331],
            [14.665557478644665, 3.3748714822731474],
            [14.660444420829371, 3.3768567432344776],
            [14.657508651854943, 3.3802677206066774],
            [14.6583977351943, 3.383485362283277],
            [14.654253745969353, 3.3885063672301907],
            [14.652302643731499, 3.3969848553084168],
            [14.647890556425496, 3.3984064910639153],
            [14.644474140169738, 3.394979404594492],
            [14.641717078661214, 3.395846206457429],
            [14.640294208471945, 3.3906042235658087],
            [14.637631385911686, 3.3895517791960494],
            [14.633140232711028, 3.3931300083915654],
            [14.63365859556579, 3.398107952164869],
            [14.630661774554238, 3.401451658251176],
            [14.628903152482547, 3.409727422854484],
            [14.626208653394592, 3.412065899303797],
            [14.62037075260192, 3.4074416178943348],
            [14.616179489897265, 3.4053861781655046],
            [14.606335649466907, 3.4065714563382836],
            [14.604341801732806, 3.407775086395669],
            [14.592484758005615, 3.402959709816424],
            [14.589989454019648, 3.403381776690603],
            [14.586047530744978, 3.400344181000091],
            [14.583081838131545, 3.4019793306503305],
            [14.579066627574301, 3.4109873682085166],
            [14.571406433165787, 3.4132017484395045],
            [14.567981875579061, 3.4098440415566675],
            [14.560826203354225, 3.4050251885849354],
            [14.55070448427522, 3.40083287847793],
            [14.544495411714696, 3.3964586354310677],
            [14.54413190841723, 3.392828230118632],
            [14.528399403634447, 3.3917113509788552],
            [14.439551943113322, 3.3888907813877895],
            [14.389190518929587, 3.3871680701928093],
            [14.376931493756791, 3.444011892332195],
            [14.366553854952356, 3.491136857003487]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.07008265116676, "lat": 40.76984284249556 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42109"],
        "coty_name": ["Snyder"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Snyder County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01213686"
      },
      "bbox": [
        14.366553854952356, 3.3748714822731474, 14.76264376634065,
        3.649543658532029
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.007884910379527, 4.845187532975031],
            [15.036537607544977, 4.851189692661362],
            [15.12713681527813, 4.870610208056656],
            [15.206236773372428, 4.887296290748189],
            [15.299100430540065, 4.906266330875082],
            [15.393978836608264, 4.9279193095701315],
            [15.485591788625117, 4.948176944393716],
            [15.504679727855896, 4.875696407345221],
            [15.517643400126511, 4.825803432691284],
            [15.527090439981782, 4.792103255604249],
            [15.5411453177895, 4.7382947031910305],
            [15.55576030258376, 4.683755486597655],
            [15.577785358318256, 4.600736242990793],
            [15.52787794220424, 4.589909036169017],
            [15.4618818687079, 4.575835019432746],
            [15.440145308478778, 4.571388785542403],
            [15.391062258485684, 4.5608380653070695],
            [15.355996673020389, 4.55445118882938],
            [15.33867249016576, 4.54932426085787],
            [15.334843401726431, 4.549080923161083],
            [15.297169591452928, 4.542112455666113],
            [15.282715806997663, 4.539675238839591],
            [15.275447596183897, 4.537199136092058],
            [15.209942484071615, 4.52408757828722],
            [15.197612019276391, 4.521931550516574],
            [15.151423050251024, 4.511787246492407],
            [15.124154150417974, 4.506259109225557],
            [15.104863714611724, 4.50079166308971],
            [15.102409698329913, 4.508939017178179],
            [15.087010021475907, 4.565667365266743],
            [15.071485513972116, 4.620558010902278],
            [15.069784216160711, 4.623995262843864],
            [15.067967773595965, 4.633550713149692],
            [15.042359542684485, 4.723885442192802],
            [15.031282425044775, 4.763310695466008],
            [15.007884910379527, 4.845187532975031]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.80068684509108, "lat": 41.82137176549465 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42115"],
        "coty_name": ["Susquehanna"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Susquehanna County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01213688"
      },
      "bbox": [
        15.007884910379527, 4.50079166308971, 15.577785358318256,
        4.948176944393716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.353213479794274, 3.52913476416379],
            [14.403315885653436, 3.603510551610536],
            [14.44214254002816, 3.696437179504394],
            [14.476376226989231, 3.7547542869075734],
            [14.475820445448694, 3.756164705724518],
            [14.475994371863095, 3.7569980083947385],
            [14.470987311298364, 3.7803393637689684],
            [14.49314036964182, 3.7849839318301477],
            [14.498936374642891, 3.7896021162631888],
            [14.523335647740243, 3.8076830277726956],
            [14.588967161781603, 3.823656867559361],
            [14.589720380062568, 3.8863370163229822],
            [14.63860598722928, 3.886269197734517],
            [14.638317369519907, 3.8812164755204805],
            [14.641851739475108, 3.8716602586526427],
            [14.642618777215908, 3.867486151391359],
            [14.647271608913552, 3.8584383583617683],
            [14.6491221149346, 3.8531128836502933],
            [14.656319876616845, 3.8433495696658424],
            [14.667504123221232, 3.833852579311897],
            [14.673681024387148, 3.8326317193230883],
            [14.68010826940794, 3.825915850489707],
            [14.681851790464247, 3.8206700772957936],
            [14.683704664622763, 3.8095117125837272],
            [14.686144459747096, 3.801841614155079],
            [14.684462115882546, 3.7918961288827004],
            [14.686424520956884, 3.7824680531594037],
            [14.685596819269788, 3.772126489862077],
            [14.686066487870171, 3.7612932136351414],
            [14.687832918844377, 3.7519272898179636],
            [14.687295321621578, 3.7451080705891195],
            [14.684637961515557, 3.736490492632156],
            [14.682454048233703, 3.723015515465409],
            [14.683134131812622, 3.7203791405593294],
            [14.688676442725177, 3.712070433021098],
            [14.691046571798152, 3.703926303560219],
            [14.698914072712268, 3.694315258568193],
            [14.708474150270392, 3.6796315226789895],
            [14.714471615601424, 3.6720699374850323],
            [14.742744680977564, 3.6514109981330742],
            [14.755376842768491, 3.650194199542587],
            [14.760781992808905, 3.6471804367048355],
            [14.760271767799443, 3.644378512180812],
            [14.75579234194234, 3.6426588294303714],
            [14.740976730796536, 3.6492997324339878],
            [14.73425901211137, 3.649543658532029],
            [14.729995116102144, 3.6459888262238755],
            [14.723436860829858, 3.6441123549256056],
            [14.721441594470758, 3.6460178010746955],
            [14.716767605932272, 3.645687747655275],
            [14.703049729534154, 3.6379782861805188],
            [14.693013880379537, 3.6402511396661104],
            [14.683023215868463, 3.634386785060986],
            [14.672728931931257, 3.6325233344808625],
            [14.66599817606535, 3.633412036050298],
            [14.655583626758704, 3.631990906455931],
            [14.652110130454151, 3.6289233536412],
            [14.63628087114541, 3.6207541362553526],
            [14.634724629719573, 3.616540703250308],
            [14.620062075791425, 3.611526450809055],
            [14.618539234707649, 3.6080319519804016],
            [14.612457613740734, 3.6068977163970795],
            [14.608964112858619, 3.6036561956108004],
            [14.604934454983004, 3.591218679805778],
            [14.600633333761339, 3.58947504491226],
            [14.594190288706708, 3.594977117882848],
            [14.590151648782928, 3.594673333180924],
            [14.588356486119912, 3.5923744694886643],
            [14.578316246327184, 3.5971888525280575],
            [14.562332963181778, 3.592885570980633],
            [14.524414791650347, 3.570332603922689],
            [14.445031461158184, 3.532157024308027],
            [14.39069973116427, 3.506043175337695],
            [14.366553854952356, 3.491136857003487],
            [14.358895005255826, 3.5277440185715463],
            [14.353213479794274, 3.52913476416379]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.06225539682407,
          "lat": 40.963016978815645
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42119"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01213689"
      },
      "bbox": [
        14.353213479794274, 3.491136857003487, 14.760781992808905,
        3.8863370163229822
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.037784108103828, 4.213310486189577],
            [15.049738480914106, 4.353345293541932],
            [15.050048270185002, 4.367179216566104],
            [15.049321143473323, 4.384211098699397],
            [15.04799369021542, 4.4140207731058085],
            [15.044193424866654, 4.477084124985746],
            [15.04315623038271, 4.492314536755754],
            [15.06653136470631, 4.498629385980958],
            [15.102409698329913, 4.508939017178179],
            [15.104863714611724, 4.50079166308971],
            [15.124154150417974, 4.506259109225557],
            [15.151423050251024, 4.511787246492407],
            [15.197612019276391, 4.521931550516574],
            [15.209942484071615, 4.52408757828722],
            [15.275447596183897, 4.537199136092058],
            [15.282715806997663, 4.539675238839591],
            [15.297169591452928, 4.542112455666113],
            [15.334843401726431, 4.549080923161083],
            [15.33867249016576, 4.54932426085787],
            [15.355996673020389, 4.55445118882938],
            [15.391062258485684, 4.5608380653070695],
            [15.393258579795944, 4.555552071261782],
            [15.391389890249728, 4.553010771297567],
            [15.386177797807951, 4.552970578862642],
            [15.366142905999633, 4.485355087031851],
            [15.370898742323682, 4.48047296818518],
            [15.362194068859123, 4.450829689417833],
            [15.355730440022839, 4.4319069233579835],
            [15.382604844255507, 4.418744243945555],
            [15.353653676746639, 4.331481042381084],
            [15.350675752764047, 4.328444106515406],
            [15.324001125623196, 4.312886710511958],
            [15.262890343285903, 4.278198721569044],
            [15.2530253513016, 4.273047433220225],
            [15.238514620778037, 4.263258640318616],
            [15.204391180457229, 4.254104887851988],
            [15.127492117131693, 4.234937886349024],
            [15.037784108103828, 4.213310486189577]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.01639448988949, "lat": 41.51841156705807 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42131"],
        "coty_name": ["Wyoming"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wyoming County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01209192"
      },
      "bbox": [
        15.037784108103828, 4.213310486189577, 15.393258579795944,
        4.5608380653070695
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.07052662274306, -2.4489997378038915],
            [9.075922105340778, -2.4512994779516433],
            [9.076945990116762, -2.4416036819375804],
            [9.086627099392354, -2.4417352770346623],
            [9.086138444007464, -2.4303750964418818],
            [9.091036080075769, -2.4303293911899995],
            [9.09834646502049, -2.3629489902988503],
            [9.098438770536882, -2.360880362276844],
            [9.089304974107915, -2.3455809902542475],
            [9.094747621693022, -2.3450188413500834],
            [9.094665025178825, -2.338339167229193],
            [9.102268838621042, -2.3382500613919275],
            [9.102074294189011, -2.3266941918229818],
            [9.078181769923392, -2.326710910889781],
            [9.07045517525248, -2.307575631546243],
            [9.054012623301382, -2.275953700440582],
            [9.053510596901969, -2.2624105767864537],
            [9.05931739095161, -2.2624240392588244],
            [9.058965928369096, -2.2441966972609695],
            [9.054546770548157, -2.244540608323067],
            [9.056752208793979, -2.1997563941841234],
            [9.058500155159134, -2.1999183315445663],
            [9.058576807493811, -2.189373510516626],
            [9.06152824868518, -2.184602572768264],
            [9.057302810532546, -2.1766513059407417],
            [9.057359095148392, -2.1718933861571705],
            [9.060131586715956, -2.166846238765985],
            [9.05793104357418, -2.1599418597195674],
            [9.054241184755258, -2.1553655940112177],
            [9.053876589888517, -2.1389989154687754],
            [9.062017186343931, -2.138220281199014],
            [9.061735260469298, -2.132975694643501],
            [9.128464089544481, -2.131663776580979],
            [9.141861768607194, -2.1009875939883123],
            [9.14508544426065, -2.1000987136968936],
            [9.157929501487612, -2.094232632508514],
            [9.160745473876762, -2.0940935396808804],
            [9.16574024586235, -2.087769947090337],
            [9.181159703188914, -2.0918540881489713],
            [9.18059925426285, -2.08640021039892],
            [9.18422562501019, -2.083599897522944],
            [9.189973692179809, -2.0836331206079306],
            [9.192449469380039, -2.0792857146517267],
            [9.19117348152588, -2.076225421698595],
            [9.198539905954775, -2.068874829795978],
            [9.208390593327284, -2.06796618741067],
            [9.211405604418424, -2.0573358914069444],
            [9.21497568904291, -2.0544803399855116],
            [9.218777052547935, -2.0491372955646816],
            [9.221824560092397, -2.0543478898889846],
            [9.224975353535122, -2.0538211647661613],
            [9.228076428416072, -2.0584617469914033],
            [9.231941636138046, -2.0608942635328193],
            [9.234254676473713, -2.058394830773666],
            [9.239827469569518, -2.064027601304848],
            [9.243412937057403, -2.066257500926174],
            [9.245827937234623, -2.0646973840962097],
            [9.246688734213913, -2.0561362045629976],
            [9.254217489025676, -2.0544229334784267],
            [9.258614100900628, -2.057454485117368],
            [9.26421564871356, -2.0549865482762244],
            [9.266862748444597, -2.0564574217372225],
            [9.276934636391145, -2.06553631123522],
            [9.28024567962199, -2.057330388649522],
            [9.282124937497672, -2.0589391024775376],
            [9.293713146722837, -2.0566332812357446],
            [9.2973027714437, -2.0600871457950234],
            [9.29761037275795, -2.064655794413856],
            [9.302378247658966, -2.0635427902556507],
            [9.306445413690911, -2.0590005796407493],
            [9.311098973876648, -2.058241588349364],
            [9.316617221079342, -2.052240996323412],
            [9.320342013636488, -2.056391019229828],
            [9.323922598823723, -2.057340318482174],
            [9.325835444634789, -2.0604188023093943],
            [9.334259053813078, -2.0605852341244817],
            [9.338287651675389, -2.061832716756296],
            [9.341611032381156, -2.0662605382545114],
            [9.348189187150954, -2.0682063699869073],
            [9.350854904155199, -2.0721119270836628],
            [9.385052508826654, -2.1176076452037336],
            [9.388159071989403, -2.1149539107125603],
            [9.38994373382629, -2.106234207721393],
            [9.394197637211802, -2.1050057319558864],
            [9.398400810014568, -2.1064765415734703],
            [9.398313300703576, -2.110104665512811],
            [9.40144146804856, -2.112557528044904],
            [9.406330629021696, -2.110481415087311],
            [9.42013520359577, -2.1384859964186447],
            [9.48447429341504, -2.196310791222713],
            [9.5267561540046, -2.279076228717449],
            [9.523855334729646, -2.285093116313161],
            [9.514354131027025, -2.2895063810467007],
            [9.509660624368797, -2.295856304510552],
            [9.507879355942427, -2.293911770997145],
            [9.501098208371449, -2.3160404897077767],
            [9.495740336320031, -2.327740609963904],
            [9.494273219523807, -2.332948034550923],
            [9.49060074927007, -2.334278769807374],
            [9.48578088252247, -2.3410302334955833],
            [9.477084678132528, -2.347515801099223],
            [9.470754534908302, -2.3542981124530566],
            [9.469468766777497, -2.361827640990178],
            [9.460423050478788, -2.369938186635523],
            [9.45597065533266, -2.372247818689097],
            [9.443168280207543, -2.373723958733369],
            [9.381224023154942, -2.4279840451518866],
            [9.363666740909599, -2.435166664768112],
            [9.356325073789986, -2.4480037093061653],
            [9.352757094620218, -2.448480110896853],
            [9.34558732527632, -2.4425500215674636],
            [9.295089065567613, -2.463160355615174],
            [9.2903694111834, -2.464757164401452],
            [9.268109957469761, -2.474164689617701],
            [9.265012266574148, -2.473844481882387],
            [9.262967334693471, -2.4682698035613893],
            [9.263540997341416, -2.4615048113935107],
            [9.255281955481433, -2.4497842060055177],
            [9.249712951913375, -2.4547966719053007],
            [9.239799255801428, -2.4557758910980008],
            [9.230479795574213, -2.4641162991913337],
            [9.221579468411017, -2.4650674289405554],
            [9.205763346495061, -2.4573741936673055],
            [9.156664752867133, -2.46465377105756],
            [9.08590618464225, -2.475440833725028],
            [9.086190972646044, -2.4740732288857523],
            [9.087829440763587, -2.4631956920053804],
            [9.088524048567779, -2.4537857476609197],
            [9.080732111175218, -2.454153331527366],
            [9.078927606235851, -2.4590143274435308],
            [9.06853146919436, -2.454978925258396],
            [9.07052662274306, -2.4489997378038915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.99835684481187, "lat": 35.95035866096812 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47035"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01639736"
      },
      "bbox": [
        9.053510596901969, -2.475440833725028, 9.5267561540046,
        -2.0491372955646816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [7.519819142565028, -2.1067439502090872],
              [7.522479690683009, -2.102063180090473],
              [7.526334139009933, -2.104398198040146],
              [7.519819142565028, -2.1067439502090872]
            ]
          ],
          [
            [
              [7.198922705513136, -2.248518081672171],
              [7.223005903370965, -2.19116640138891],
              [7.223253230554566, -2.183085425233496],
              [7.220733415072028, -2.180581217637939],
              [7.220602794669768, -2.173835211524281],
              [7.226924048048039, -2.174091922922898],
              [7.226467506055927, -2.171750846300504],
              [7.2272314242701405, -2.087146864304956],
              [7.239760646353209, -2.0877658831298245],
              [7.2910272985201425, -2.0893965296947683],
              [7.340879949418591, -2.091205582531456],
              [7.345448481835243, -2.0878472596715736],
              [7.3463038365110656, -2.0914980327398838],
              [7.377050532562669, -2.0926199047448435],
              [7.377337030342724, -2.084842380742454],
              [7.381363278375196, -2.084881263967042],
              [7.381255491078617, -2.0917703110461985],
              [7.386379531187511, -2.0924652054982573],
              [7.386216380888182, -2.0859828263369984],
              [7.3942614822833415, -2.087678909319745],
              [7.394333193396406, -2.0931404989850573],
              [7.396509549501176, -2.094371308291156],
              [7.399588139047564, -2.0893227636537115],
              [7.40615479912924, -2.0883735592719934],
              [7.408850445581538, -2.083624093625316],
              [7.424838137847003, -2.083336738651582],
              [7.436920453975925, -2.07996299395349],
              [7.443692970273491, -2.078959021678817],
              [7.452575126430598, -2.0736351295172963],
              [7.458445829599105, -2.079953717593315],
              [7.464865483501613, -2.0845828907331407],
              [7.4694737446941435, -2.0852602240963436],
              [7.4764962332862535, -2.083368028661894],
              [7.484823389901085, -2.0844733589496918],
              [7.49636704119824, -2.083422585485505],
              [7.504635572301029, -2.086711497846138],
              [7.513434580468926, -2.0883564277134217],
              [7.516474227403305, -2.0904598771436422],
              [7.518818306484637, -2.0962217385566566],
              [7.515875841505044, -2.1004677335211848],
              [7.514741395141858, -2.104893502289638],
              [7.510351387280818, -2.1059926709526917],
              [7.505723603348512, -2.1053083548619593],
              [7.505513021724872, -2.1118138787917005],
              [7.515771072914671, -2.113060477899965],
              [7.514553470783683, -2.1164615549305186],
              [7.517803007437494, -2.1213253814355193],
              [7.51694229818923, -2.1246323858713088],
              [7.4978737954896095, -2.138376538543208],
              [7.497470518557988, -2.140783579385933],
              [7.489738819311985, -2.150067297490438],
              [7.489520393457302, -2.153793256592131],
              [7.496078398571975, -2.156463244650736],
              [7.501996129404604, -2.1510048325227387],
              [7.507549790420577, -2.150816249681559],
              [7.508035433203148, -2.1541404576381074],
              [7.513568247718242, -2.1614925501750224],
              [7.513077623323362, -2.167021871576541],
              [7.509177915680591, -2.171009653649278],
              [7.50360475340116, -2.169755457015343],
              [7.501262601427626, -2.1725210349275144],
              [7.497597295430338, -2.1835652149567872],
              [7.498777804942684, -2.1889095058139567],
              [7.504457934298753, -2.187886079474813],
              [7.512730023723126, -2.1963569450792506],
              [7.511627202217716, -2.2009431496237792],
              [7.512634445034755, -2.204667364158317],
              [7.52270818577992, -2.20564753189242],
              [7.528464140324524, -2.213698977937533],
              [7.531049471297019, -2.219251092355094],
              [7.5265941333205255, -2.2234299642599056],
              [7.5222139177387755, -2.2247783454239394],
              [7.515390077505851, -2.2317774108432067],
              [7.514885282807286, -2.237349064635908],
              [7.520353876510237, -2.242802107293263],
              [7.519117489720192, -2.288689060238769],
              [7.521533824634757, -2.3164649979161007],
              [7.518798040799703, -2.3178377391293874],
              [7.522457146969127, -2.3274140318136114],
              [7.518388873333719, -2.3312027318203175],
              [7.516903409060639, -2.349360875673185],
              [7.514415158875129, -2.3834036565066503],
              [7.513160055317202, -2.410307976725349],
              [7.511587066970973, -2.414822803339564],
              [7.511583730907711, -2.4205033455259124],
              [7.517163218516746, -2.4207874266211293],
              [7.517218345012797, -2.424115100796588],
              [7.5103620475944854, -2.4249986203667264],
              [7.510440442492258, -2.428987401931508],
              [7.50245414387578, -2.429440294311674],
              [7.503939663731591, -2.4386748556458473],
              [7.508018640666563, -2.438703816868092],
              [7.508064278022382, -2.441874283485937],
              [7.491504235938927, -2.441605497479322],
              [7.451666201666366, -2.44160558399789],
              [7.449885284493493, -2.4450906741877483],
              [7.442432569404304, -2.442170834327436],
              [7.429136744802964, -2.4418397750847594],
              [7.429212035967924, -2.4398451966945074],
              [7.4146663761985625, -2.439073395038949],
              [7.350392909025878, -2.436331004901715],
              [7.283354408574344, -2.4336436262632053],
              [7.283759978594256, -2.435799085407784],
              [7.277849747199658, -2.437884525098095],
              [7.277258684154925, -2.4334120999484927],
              [7.24121536706608, -2.4318388877567454],
              [7.236533294846493, -2.428817500315404],
              [7.235568069997959, -2.422336316415157],
              [7.233691406732178, -2.418470318668433],
              [7.224914184364108, -2.4100750673486973],
              [7.229385340216681, -2.402818900813771],
              [7.228160796844601, -2.3967068180841142],
              [7.224730862340065, -2.3935357529873134],
              [7.226307080272318, -2.386112086927281],
              [7.225974390856597, -2.3804914150869774],
              [7.227814263798286, -2.3788027678902735],
              [7.226932968296281, -2.3698311666691554],
              [7.223520415127714, -2.3655812522382655],
              [7.224174815352911, -2.331018144209008],
              [7.21505008943445, -2.291473410266206],
              [7.2144793255365345, -2.2879834068428395],
              [7.198922705513136, -2.248518081672171]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.35672624166216,
          "lat": 36.149041303910565
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47043"],
        "coty_name": ["Dickson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickson County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01639740"
      },
      "bbox": [
        7.198922705513136, -2.4450906741877483, 7.531049471297019,
        -2.0736351295172963
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.170816225323626, -2.4623102406595185],
            [-5.072555579463011, -2.4695796249232345],
            [-4.955255033444237, -2.4780588484437023],
            [-4.920541128043952, -2.4802478119017537],
            [-4.919460039512317, -2.480595300961727],
            [-4.771211058220258, -2.490995694767299],
            [-4.744731498775756, -2.4928023447894763],
            [-4.715499659511905, -2.4944315142707176],
            [-4.594279885614079, -2.502641022149772],
            [-4.536898084382549, -2.506648686320495],
            [-4.469386493914187, -2.511047340122018],
            [-4.485424865777627, -2.759337568969827],
            [-4.497191681573509, -2.9413190754395835],
            [-4.859968937198786, -2.9198186666721884],
            [-4.869296178738567, -2.919787049260221],
            [-4.9680581042164915, -2.9129077602793743],
            [-5.064133685970021, -2.906291522291976],
            [-5.070261893764285, -2.906505999626041],
            [-5.2037247213138835, -2.8973036363886826],
            [-5.194763548030378, -2.7797820051532574],
            [-5.190767463168358, -2.7273683582088215],
            [-5.191022598835575, -2.722439096512465],
            [-5.189544471597679, -2.70472741516658],
            [-5.189088527470658, -2.6934957080063073],
            [-5.187450655632798, -2.6810050171704565],
            [-5.170816225323626, -2.4623102406595185]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.60291498395196,
          "lat": 35.83999803071577
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48205"],
        "coty_name": ["Hartley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hartley County"],
        "coty_fp_code": "205",
        "coty_gnis_code": "01383888"
      },
      "bbox": [
        -5.2037247213138835, -2.9413190754395835, -4.469386493914187,
        -2.4623102406595185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7207469247036666, -9.374153777720819],
            [-3.712703229821807, -9.369951237176354],
            [-3.706604026848355, -9.369891942505731],
            [-3.699795238913559, -9.373131508911666],
            [-3.6930244205014753, -9.379311703381818],
            [-3.6886181077528337, -9.378978721258628],
            [-3.6880960248826478, -9.375669434941464],
            [-3.6925289856810477, -9.368671218363936],
            [-3.691895192352971, -9.366004149321244],
            [-3.6853663791563105, -9.36162115889083],
            [-3.6812365859345864, -9.363722816545941],
            [-3.677106677997601, -9.363271924437885],
            [-3.676380244710235, -9.353345961668326],
            [-3.6736595426044274, -9.348938892845643],
            [-3.673387328947704, -9.339365044467602],
            [-3.6694172126789666, -9.336691936927517],
            [-3.669669327611381, -9.328494967825058],
            [-3.6745757608705603, -9.323802304791997],
            [-3.677243142797872, -9.313704938227445],
            [-3.672501422974091, -9.30462040381936],
            [-3.6744689653755747, -9.297614552170971],
            [-3.67443258379222, -9.293395858280718],
            [-3.6698959778128146, -9.290134807959744],
            [-3.6647615757661125, -9.290260228873152],
            [-3.65775107314263, -9.288282783639662],
            [-3.653382356047024, -9.285751383426401],
            [-3.6490693239401755, -9.285864185724714],
            [-3.6438985270114026, -9.282861916209523],
            [-3.641614871933161, -9.27425358370068],
            [-3.6418107674206373, -9.268632201415132],
            [-3.637482250150438, -9.25746485992912],
            [-3.6409653603343246, -9.251498386487981],
            [-3.638783950229801, -9.248208666998027],
            [-3.636803029299193, -9.238045623697515],
            [-3.6378186336161895, -9.234567594190503],
            [-3.6354090290692875, -9.220447846624293],
            [-3.6312372352263176, -9.21643566243547],
            [-3.630666934052535, -9.208038878891902],
            [-3.6284838648540374, -9.202738394647067],
            [-3.6250687527164063, -9.11984179168249],
            [-3.6190804958268106, -9.001362274467624],
            [-3.5111530522035843, -9.006962602861007],
            [-3.4242435917147875, -9.010851012978055],
            [-3.3373334198302356, -9.014723142660648],
            [-3.336261443235155, -9.014999371066557],
            [-3.228819319335026, -9.019887408341324],
            [-3.2267714514436143, -9.02015490288866],
            [-3.1087992937975173, -9.025369471449403],
            [-3.1158103701518858, -9.181519647406017],
            [-3.116804830138482, -9.204591877017863],
            [-3.13141087293662, -9.554626942006992],
            [-3.2507151966070214, -9.550175623998133],
            [-3.2528758125907453, -9.550438295571153],
            [-3.383615428091443, -9.544135076274861],
            [-3.48114395767695, -9.540261238870425],
            [-3.5786717383031825, -9.536365313289414],
            [-3.617429796937336, -9.53447279168832],
            [-3.6229011519145713, -9.518932749123735],
            [-3.63093992167244, -9.5078082704387],
            [-3.63757499121178, -9.502975413822671],
            [-3.6527591700113824, -9.497837588008142],
            [-3.667569139449871, -9.487798444341175],
            [-3.6688384330364388, -9.485424220537148],
            [-3.6760959537458975, -9.477555282838887],
            [-3.6757017357881265, -9.471249360121979],
            [-3.677174395784818, -9.466245740168592],
            [-3.6826300405037613, -9.462362162749033],
            [-3.6916439177260463, -9.460062002241045],
            [-3.696940178425543, -9.456196059102803],
            [-3.697345639519016, -9.451195076224286],
            [-3.70505029468477, -9.447098659098572],
            [-3.707648408334227, -9.442181085655909],
            [-3.6984051025383335, -9.430296739799612],
            [-3.6988292457002325, -9.420959926180373],
            [-3.7006385486189273, -9.417293098516543],
            [-3.7057925762743267, -9.416260728703747],
            [-3.7070658520073696, -9.41162620960736],
            [-3.7046305914820157, -9.40641744788555],
            [-3.7113380275816845, -9.39154699770496],
            [-3.713970658739925, -9.387420741253754],
            [-3.718497395839189, -9.389718942508024],
            [-3.722165421316305, -9.387774019203263],
            [-3.7229597468881135, -9.379978358208664],
            [-3.7207469247036666, -9.374153777720819]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.41798312562567,
          "lat": 29.350201767538493
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48271"],
        "coty_name": ["Kinney"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kinney County"],
        "coty_fp_code": "271",
        "coty_gnis_code": "01383921"
      },
      "bbox": [
        -3.7229597468881135, -9.554626942006992, -3.1087992937975173,
        -9.001362274467624
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8206810233251862, -7.075670889397203],
            [1.947173707358859, -7.089234926352572],
            [1.9480837796240835, -7.089566140486455],
            [2.053392566323644, -7.100804658692838],
            [2.0826132036214986, -7.103739640000111],
            [2.1491570987878412, -7.140007069181788],
            [2.17386925809868, -7.152893942261934],
            [2.1768164748803556, -7.242067728913161],
            [2.177106602063354, -7.255748337245472],
            [2.1630862358722216, -7.273729250480569],
            [2.126522407008386, -7.312706215146399],
            [2.135901451354986, -7.327948560133037],
            [2.1382326558445235, -7.334941871006932],
            [2.142383949948456, -7.340717493693343],
            [2.1457522018316615, -7.350787541663877],
            [2.145777778545676, -7.358251725695934],
            [2.1403136586721776, -7.362009447514901],
            [2.13747741317414, -7.366529251550289],
            [2.1339337677430126, -7.376816012739373],
            [2.130102957342847, -7.381849448551586],
            [2.134103985934253, -7.389319941518626],
            [2.129000168790046, -7.398055584325429],
            [2.1285971420732945, -7.401073232271981],
            [2.130563819155866, -7.407591343945044],
            [2.1277505283717915, -7.415255089768344],
            [2.128941241181702, -7.420275652503492],
            [2.1263628575699984, -7.426278806537917],
            [2.130163349722362, -7.431598271645785],
            [2.133589068242793, -7.434110236696676],
            [2.135198519580283, -7.441376217764326],
            [2.1347633658373235, -7.44829368161638],
            [2.1375544163820708, -7.455951030906711],
            [2.137521891270434, -7.4588847719943425],
            [2.141611766527015, -7.464776334357234],
            [2.14259867985436, -7.470247748314166],
            [2.1422418083404433, -7.481501843508634],
            [2.138909248011043, -7.4885035723377635],
            [2.1352466872776326, -7.503920311674877],
            [2.13592263053717, -7.513701886002277],
            [2.1363222775766673, -7.538584442664169],
            [2.136008163815534, -7.545288723067296],
            [2.1333713911168606, -7.551786594270195],
            [2.1295169647988805, -7.566555260164886],
            [2.127997749383973, -7.569980514594521],
            [2.128360924942517, -7.575815570069304],
            [2.1327953386948892, -7.581912673550329],
            [2.1340424121778536, -7.585793609947202],
            [2.1365829618182643, -7.5869134912183185],
            [2.1369984616952777, -7.5941645068670365],
            [2.133325239993844, -7.602615880110949],
            [2.1268620984357445, -7.606669504051463],
            [2.119859919212413, -7.608164284477998],
            [2.0599974738496853, -7.623247826315204],
            [2.0593966850935725, -7.618398015493269],
            [2.0561428378464566, -7.61495742736769],
            [2.0530268130542533, -7.617480649955592],
            [2.0467280854725534, -7.610198872826611],
            [2.0382269746046116, -7.6069722246823686],
            [2.0323146292353336, -7.6007926559189345],
            [2.0223279143105146, -7.597137169311422],
            [2.017742564741029, -7.599511157877109],
            [2.014945681511278, -7.593792141027696],
            [2.011030156718909, -7.592085810590923],
            [2.0053285910792895, -7.58760789708587],
            [2.0038050286092037, -7.584243617478569],
            [1.9988204796975695, -7.580894569480234],
            [1.9997312350274785, -7.578282181493124],
            [1.9934718462107215, -7.574263320480563],
            [1.9964245557026286, -7.57006280439293],
            [1.988783564903536, -7.566961680279077],
            [1.9892103540596495, -7.5641006323927575],
            [1.982037222584754, -7.559938559021209],
            [1.9811147793022645, -7.552738149131579],
            [1.9778859040824213, -7.548809635301014],
            [1.9657105937137853, -7.54638393943354],
            [1.9601627540602409, -7.548107336692523],
            [1.9581363687663669, -7.540403237106578],
            [1.9505415756000242, -7.542923524210671],
            [1.9425298408256255, -7.540655277938759],
            [1.9432868720835168, -7.5353208266422],
            [1.9385608774731806, -7.529076525409275],
            [1.9279166777310168, -7.523363913851035],
            [1.9231080522386097, -7.524289687772842],
            [1.9183109170301473, -7.517571623626271],
            [1.9173089892949993, -7.513130893121994],
            [1.9104617747276897, -7.514432504324789],
            [1.9062468556282137, -7.511326018663843],
            [1.901679508013076, -7.502372712032819],
            [1.8946710383712486, -7.503051022576004],
            [1.889684258260729, -7.50157303063994],
            [1.891424694031332, -7.4961583820122915],
            [1.8843078016538883, -7.489863228979567],
            [1.881968230339957, -7.485744377636985],
            [1.87819229343318, -7.485785985189387],
            [1.8794797142772643, -7.480752264928426],
            [1.8824321113403268, -7.480073096101275],
            [1.8842010170226964, -7.475498531350974],
            [1.882681857628289, -7.468751864594635],
            [1.877917097235036, -7.463446596286862],
            [1.8816384753254976, -7.454976450393719],
            [1.8852732557447944, -7.451904618355825],
            [1.8847176180577552, -7.449195265908867],
            [1.8871439425475913, -7.444520017541643],
            [1.8924027239140946, -7.439757244013696],
            [1.889373073438118, -7.432741530869061],
            [1.8973711820482124, -7.422071607955882],
            [1.8979914809129141, -7.418142897859598],
            [1.8939450926768395, -7.407184824815085],
            [1.8916800805998506, -7.403186019946569],
            [1.897372350081144, -7.399558275589293],
            [1.8954905736505068, -7.392183998500377],
            [1.8971985636188957, -7.389597559415226],
            [1.8950782435015237, -7.382006163929037],
            [1.890966137029445, -7.379431116687415],
            [1.8871791493554586, -7.372960515734803],
            [1.8877134517128196, -7.369074417987201],
            [1.8855796740212285, -7.36745899071333],
            [1.885216546545242, -7.36324697981395],
            [1.8874033844803126, -7.359615647795179],
            [1.8877232169987574, -7.34830851580983],
            [1.8858756918928852, -7.342994991761319],
            [1.890037958035316, -7.3390360464244],
            [1.8867244733750137, -7.331153122135138],
            [1.8863175282629194, -7.327201157074686],
            [1.8900706015605448, -7.322996165224209],
            [1.8969388877741462, -7.323918191721583],
            [1.8987076393235607, -7.3213458485190035],
            [1.8966056117489445, -7.318310861950457],
            [1.902065318177512, -7.3125027317198965],
            [1.9043533209344679, -7.305115083661272],
            [1.9001713196643428, -7.301763232764585],
            [1.900568273592673, -7.2987716361500485],
            [1.894722555052511, -7.296343063426644],
            [1.8925339401366355, -7.288409389811426],
            [1.8900708141022737, -7.287042367801481],
            [1.8906258362333346, -7.282362770622936],
            [1.8951622166495306, -7.279319232202358],
            [1.8929674783797323, -7.274070276289498],
            [1.8971504575911184, -7.266269917533779],
            [1.895401876491311, -7.263103527277786],
            [1.8977550851873375, -7.2595531406470615],
            [1.8953308701981835, -7.257990225319829],
            [1.8958963970608669, -7.254262075851066],
            [1.8916371793810454, -7.249034930968702],
            [1.8946718181512925, -7.237040534452542],
            [1.8963951931432528, -7.233132316419099],
            [1.902789310825535, -7.2306855302940285],
            [1.9031152145888508, -7.225283630397651],
            [1.904761854717273, -7.2213495038258655],
            [1.9052596466208045, -7.215363564360467],
            [1.9033848016436514, -7.212361337125381],
            [1.8985154689412198, -7.210432043255379],
            [1.9013749971480147, -7.202404709808153],
            [1.905719935464224, -7.199994554039101],
            [1.903106053682184, -7.19558655242642],
            [1.9007805898540944, -7.184151328590088],
            [1.9020283185179514, -7.177431908092755],
            [1.8999722014521099, -7.168816837133658],
            [1.9021080974496147, -7.164209623818526],
            [1.8990817714325305, -7.158405233800326],
            [1.900563675312562, -7.155623927318562],
            [1.8942722031875396, -7.14914245097785],
            [1.8965867672997618, -7.138701437318322],
            [1.8844392797526344, -7.136690577515226],
            [1.8813356205432012, -7.132904243291896],
            [1.8802585467050448, -7.128758552321375],
            [1.8770257111567081, -7.125362849318601],
            [1.8666149200168611, -7.120170895204518],
            [1.8629192111641684, -7.121972643259946],
            [1.860526448822955, -7.116496832756492],
            [1.8612396507497284, -7.114013039917036],
            [1.8537988974536657, -7.105106529104039],
            [1.8482705123075351, -7.104683729194039],
            [1.8471861542921455, -7.094459734437137],
            [1.841595161091545, -7.091736239900803],
            [1.835057883004566, -7.092301400565081],
            [1.8309021593910557, -7.08883429472671],
            [1.8264508463965594, -7.089592852781625],
            [1.8221147522917756, -7.0854595169573455],
            [1.8233654840719753, -7.0823258941925165],
            [1.8208290185811984, -7.0790453092096275],
            [1.8206810233251862, -7.075670889397203]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.1681284184652, "lat": 31.39416035879015 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48405"],
        "coty_name": ["San Augustine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Augustine County"],
        "coty_fp_code": "405",
        "coty_gnis_code": "01383988"
      },
      "bbox": [
        1.8206810233251862, -7.623247826315204, 2.177106602063354,
        -7.075670889397203
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.4398360036543405, -2.0631117966593675],
            [-4.410425175820797, -2.065016457255979],
            [-4.407712779967507, -2.0648274027969094],
            [-4.336416546021332, -2.069464138179698],
            [-4.255288181124038, -2.074658131690034],
            [-4.172942430513291, -2.080635739742341],
            [-4.079745346913781, -2.0862261030269553],
            [-4.071309857634084, -2.086948910818208],
            [-4.01187614454994, -2.090470723798738],
            [-4.020140255630873, -2.232607573531937],
            [-4.027168415314337, -2.35115343876903],
            [-4.033086103456053, -2.45389427126553],
            [-4.03802864379426, -2.5376447163654317],
            [-4.0881347803508055, -2.5346276027325376],
            [-4.245375210701564, -2.5250734460599618],
            [-4.302632879411726, -2.521450129026482],
            [-4.344471909937025, -2.5189447994103777],
            [-4.434709363215522, -2.5130434681615363],
            [-4.439368648842869, -2.513028137092515],
            [-4.469386493914187, -2.511047340122018],
            [-4.440239301505393, -2.0655362585162034],
            [-4.4398360036543405, -2.0631117966593675]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.8934324037829, "lat": 36.27771806262089 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48421"],
        "coty_name": ["Sherman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sherman County"],
        "coty_fp_code": "421",
        "coty_gnis_code": "01383996"
      },
      "bbox": [
        -4.469386493914187, -2.5376447163654317, -4.01187614454994,
        -2.0631117966593675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.3653634215539219, -8.286899272371503],
            [-1.340487802197802, -8.246344916179595],
            [-1.3398741181054932, -8.21617023196632],
            [-1.3469327368570734, -8.218712097431414],
            [-1.3510184354492476, -8.223018087752086],
            [-1.3538591060730403, -8.228246005502253],
            [-1.361949638776113, -8.2289136803445],
            [-1.3619106517848623, -8.226615073043495],
            [-1.3558224934965015, -8.213701192220896],
            [-1.2959788273352122, -8.091989257168363],
            [-1.2878739084749857, -8.09806879805506],
            [-1.2847520427005654, -8.104564852227018],
            [-1.278854739700892, -8.101715108371986],
            [-1.2642534271710915, -8.099993795747952],
            [-1.25847645747721, -8.08944553300131],
            [-1.2548878034048434, -8.095566299624222],
            [-1.2516691641291813, -8.103971796684554],
            [-1.2457490497823456, -8.107246077244495],
            [-1.234205975972166, -8.095311177456022],
            [-1.224254489058133, -8.093965241545938],
            [-1.215939843110363, -8.08959608391452],
            [-1.2118392271532323, -8.092714890798915],
            [-1.1974883229068756, -8.107799245236214],
            [-1.1823631383223063, -8.113477052671422],
            [-1.1867935770270053, -8.127196376314233],
            [-1.1855799657798105, -8.131372897553188],
            [-1.1811883752007124, -8.137620356464616],
            [-1.1916378149177518, -8.150225370099852],
            [-1.1872750824379883, -8.153709492698885],
            [-1.1704952910207094, -8.147001272115869],
            [-1.1648937276891997, -8.15347378808931],
            [-1.1611424661696566, -8.151959111385938],
            [-1.1587383598313428, -8.154579464640799],
            [-1.1581099784393831, -8.161848317762633],
            [-1.1412748837851423, -8.172212043231633],
            [-1.1447942388101293, -8.195741919977252],
            [-1.1412859361756094, -8.201172473583526],
            [-1.1349541220937425, -8.206249740779697],
            [-1.1316430947901288, -8.211188701091208],
            [-1.1320268735926469, -8.215733667171236],
            [-1.1374138974505181, -8.221088331194416],
            [-1.1237754937244537, -8.242850931852631],
            [-1.1243760343190745, -8.245046323991172],
            [-1.1075012744773276, -8.261132371019063],
            [-1.1045753342031164, -8.265235476314151],
            [-1.09512602825651, -8.271730882613966],
            [-1.0846153034314812, -8.271858118954654],
            [-1.0800857524663467, -8.274218932440933],
            [-1.0752531289517973, -8.274956694008404],
            [-1.0723638090814844, -8.27851620844913],
            [-1.0672838788148862, -8.280845807299103],
            [-1.0648241350253624, -8.28945256367079],
            [-1.0575839977144919, -8.286806513560204],
            [-1.0452233596685472, -8.286323106022857],
            [-1.0459812549532574, -8.279430888151275],
            [-1.0415175401059786, -8.272226138987929],
            [-1.039049524029802, -8.270509732987868],
            [-1.0277587645675867, -8.270362269491402],
            [-1.0116890939049916, -8.261777532353761],
            [-1.0020515121709512, -8.262094898397738],
            [-0.9951186788909016, -8.259341456943151],
            [-0.9889260054141402, -8.259450593983443],
            [-0.9835280378444663, -8.241032888011535],
            [-0.9760745525240051, -8.240445064844959],
            [-0.9723827294273976, -8.24286601997609],
            [-0.9671571355474214, -8.23980359067088],
            [-0.9565724843835086, -8.246630748895381],
            [-0.9496669052671226, -8.243592179228278],
            [-0.9477684243689621, -8.239694900708056],
            [-0.9361286005803113, -8.236688296120395],
            [-0.9281067270588832, -8.23175831823591],
            [-0.9271712318481659, -8.232722337404548],
            [-0.9179501267526773, -8.231992382046712],
            [-0.9172295923916466, -8.22721847645152],
            [-0.9085872297379185, -8.221070756024341],
            [-0.9044290664636401, -8.221707163926123],
            [-0.903233642474765, -8.225210638294769],
            [-0.8957169861427136, -8.22200781114959],
            [-0.884624945392373, -8.223207441352884],
            [-0.8852263567628713, -8.226731842553562],
            [-0.8808370076764396, -8.227403549690745],
            [-0.8806293058649931, -8.231101774799125],
            [-0.8716335173541601, -8.232772288448503],
            [-0.868655229453363, -8.241910850309175],
            [-0.869369221573191, -8.246508385026784],
            [-0.86595618044776, -8.24761771345905],
            [-0.8633687313120212, -8.243948907102817],
            [-0.8505384193701129, -8.247850618004286],
            [-0.8469961012587617, -8.251139213172054],
            [-0.8455405471369484, -8.246990750121395],
            [-0.8355137684084188, -8.238337625790377],
            [-0.8303587930113285, -8.242554567560218],
            [-0.8274591614851186, -8.246371872925405],
            [-0.8169823373039563, -8.250502235525438],
            [-0.8147520061932333, -8.254324433076597],
            [-0.8093136290713784, -8.253457314458212],
            [-0.8053905580316734, -8.256777653696757],
            [-0.7980371227514147, -8.258829205186192],
            [-0.7955407965118366, -8.263376773193109],
            [-0.7920078876604929, -8.265737319399872],
            [-0.7864622178072866, -8.26285714733241],
            [-0.7797843884224697, -8.262860751220853],
            [-0.7792807755020513, -8.268103645998492],
            [-0.7766150692230069, -8.268930138142203],
            [-0.7745657999536928, -8.264051868460031],
            [-0.7699054534823715, -8.264679938512844],
            [-0.7692935534022859, -8.271441638510034],
            [-0.7639811661963022, -8.27222386331328],
            [-0.7596381625239705, -8.280104656666275],
            [-0.754001160193159, -8.286119921978024],
            [-0.7484255120454998, -8.286347666769908],
            [-0.746188859487015, -8.282316726562417],
            [-0.7432773193384037, -8.284540911599496],
            [-0.7335914294941498, -8.287884768907272],
            [-0.7302810106325732, -8.291341816193386],
            [-0.7267946335234184, -8.300584052208372],
            [-0.7233896881836837, -8.30087992412821],
            [-0.7211672296481112, -8.305577035779901],
            [-0.7184089844949851, -8.30708498574981],
            [-0.7149416226873847, -8.305302150460188],
            [-0.7217389103018632, -8.317575998120889],
            [-0.7419946999473704, -8.356125987890739],
            [-0.8038237654511763, -8.472772252737728],
            [-0.8133110766984584, -8.491112841099124],
            [-0.8242102586667772, -8.511420036191808],
            [-0.8449631393301038, -8.532583327930901],
            [-0.9270204095939307, -8.615234352848542],
            [-0.9309396503109564, -8.61812615029307],
            [-0.9529037474167121, -8.639704454004674],
            [-0.961864873351946, -8.649793764145505],
            [-0.9655379488885026, -8.646146889719091],
            [-0.9934219161332276, -8.673682798143403],
            [-1.0080733716471402, -8.687883302358903],
            [-1.0140189399725412, -8.692925776904609],
            [-1.0318704771802147, -8.677465156973627],
            [-1.0757981261201506, -8.640111754958905],
            [-1.1547406522080583, -8.572536448250231],
            [-1.2010500541160467, -8.532688375217552],
            [-1.284042384455136, -8.461644485355425],
            [-1.3173366132247035, -8.433054719718202],
            [-1.3373867523409788, -8.41530841389172],
            [-1.367963638987828, -8.389375469074027],
            [-1.4077639500487555, -8.355236707705801],
            [-1.3653634215539219, -8.286899272371503]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.7819706660037, "lat": 30.334370340570324 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48453"],
        "coty_name": ["Travis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Travis County"],
        "coty_fp_code": "453",
        "coty_gnis_code": "01384012"
      },
      "bbox": [
        -1.4077639500487555, -8.692925776904609, -0.7149416226873847,
        -8.08944553300131
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.32614044676384, 3.4435395516290948],
            [-11.327082486007123, 3.441467035136658],
            [-11.321697514486624, 3.4373586148980624],
            [-11.320544806484243, 3.4325307532043867],
            [-11.320418022700775, 3.424927908229622],
            [-11.325229088243274, 3.419286270268504],
            [-11.330592264726857, 3.416557436297947],
            [-11.329638566241039, 3.4125474955533566],
            [-11.33239060002468, 3.4076448217551305],
            [-11.329765009380703, 3.4019025152357814],
            [-11.333077298856576, 3.3973867725651283],
            [-11.330713464662841, 3.392071120522528],
            [-11.332454077195953, 3.3868114075093865],
            [-11.330930472387667, 3.379696686099752],
            [-11.334985021139632, 3.3711022808185267],
            [-11.331800039958177, 3.3649452683996874],
            [-11.330931921380188, 3.359797114396823],
            [-11.332164558448193, 3.353483019215997],
            [-11.329009138385755, 3.347772041199801],
            [-11.327402203719789, 3.3401511825678156],
            [-11.331743229759262, 3.3345485937787105],
            [-11.330065667812255, 3.322983794599552],
            [-11.325685447792429, 3.3227170969998596],
            [-11.323787466915894, 3.3200734045804667],
            [-11.321255205737762, 3.3118328881080417],
            [-11.321593462703545, 3.307478005216173],
            [-11.314785722779172, 3.304872797814879],
            [-11.312150041053446, 3.3009595712866635],
            [-11.311827914684956, 3.294054447257193],
            [-11.308835964929747, 3.287812585332476],
            [-11.305149029426067, 3.283512319034118],
            [-11.301277536006637, 3.2717228562561607],
            [-11.300382659620267, 3.2654761688966385],
            [-11.296348220916299, 3.2571537458165905],
            [-11.296262738067774, 3.255051998682579],
            [-11.303743580337407, 3.2541589063679144],
            [-11.307613732024699, 3.2585203126275983],
            [-11.313394011177321, 3.2576436922218304],
            [-11.317511247046125, 3.2586386629676767],
            [-11.326353362518272, 3.25790968358961],
            [-11.324858309567082, 3.2505029624859736],
            [-11.321462968794089, 3.24893342112514],
            [-11.320910886055483, 3.2414918869468767],
            [-11.315933303478454, 3.232613774091061],
            [-11.313473483710496, 3.224975289958009],
            [-11.315382033449605, 3.2229121761898836],
            [-11.317310718648766, 3.214320917637173],
            [-11.309931144074339, 3.209899442626344],
            [-11.306831056212149, 3.1967750535459616],
            [-11.309012512924552, 3.194531615337533],
            [-11.305438113912473, 3.189181520281049],
            [-11.30463526174486, 3.1835456906786725],
            [-11.299837662118785, 3.183857443214559],
            [-11.298770173815925, 3.1798782895599316],
            [-11.302430415549914, 3.173380539629815],
            [-11.305214803267075, 3.171079346304822],
            [-11.298799244072153, 3.1665114682812097],
            [-11.293980089952932, 3.1660024773019475],
            [-11.289792841494103, 3.163717825281293],
            [-11.286248376938007, 3.157337749988062],
            [-11.2858899914673, 3.153133127272724],
            [-11.291919648410829, 3.1531380764812194],
            [-11.29687864803759, 3.146898346284742],
            [-11.298971387090319, 3.1479380519406175],
            [-11.309716625911525, 3.144103260110098],
            [-11.312462434422363, 3.1449677202020716],
            [-11.317555436268446, 3.141629497573785],
            [-11.320450486555385, 3.1412746358166537],
            [-11.32570956756317, 3.143841592425005],
            [-11.328531911892737, 3.1431818592051086],
            [-11.338577493954883, 3.138163694165279],
            [-11.343492542496708, 3.1411348654853786],
            [-11.347412420168679, 3.1402483529965166],
            [-11.351658547828544, 3.136732345535104],
            [-11.358459781056219, 3.1353138358038932],
            [-11.36455778485314, 3.135254342868395],
            [-11.368774957858921, 3.1371646211164177],
            [-11.37061120842857, 3.1350857560203935],
            [-11.376173811923858, 3.1356316487211457],
            [-11.38051826601045, 3.1312655463445873],
            [-11.38854305771483, 3.1322121719894382],
            [-11.38982577225023, 3.130288654987811],
            [-11.445575357946298, 3.139744990816764],
            [-11.44583832075715, 3.1418872471804344],
            [-11.441897873445637, 3.1480115830200672],
            [-11.443496097923337, 3.1559057886696618],
            [-11.446161173661388, 3.160445806261895],
            [-11.447179286759141, 3.166416908535948],
            [-11.454845072633809, 3.1748480873505915],
            [-11.450046100391965, 3.1897407018170054],
            [-11.454971325074279, 3.1973568449201983],
            [-11.451798714040647, 3.2003060852236938],
            [-11.45151517985307, 3.2072484307412736],
            [-11.448802335570571, 3.2116388437334416],
            [-11.445260415789543, 3.2127824192516337],
            [-11.44179108796362, 3.219146503206228],
            [-11.438193388353497, 3.2406509816899347],
            [-11.473570716775708, 3.246671672433704],
            [-11.591146633729045, 3.189386043960718],
            [-11.68712839866775, 3.127167056713237],
            [-11.74661544122766, 3.2947954110429176],
            [-11.806134132737068, 3.4623661303483217],
            [-11.773466637050655, 3.467330060681233],
            [-11.675210360096088, 3.4822771448032843],
            [-11.576950546139454, 3.4972085488510336],
            [-11.566992162510575, 3.498687274445392],
            [-11.520181130768313, 3.4903832880653436],
            [-11.47012441755882, 3.4817038366473168],
            [-11.408378971090952, 3.4712574839406525],
            [-11.402532835372867, 3.466955728350758],
            [-11.399598500361956, 3.4629960486093743],
            [-11.399495568622191, 3.4574893999085274],
            [-11.394990329178734, 3.45411649953417],
            [-11.390246787685747, 3.4526776423288332],
            [-11.383595886615689, 3.4524825815580056],
            [-11.37343602973555, 3.450962976300064],
            [-11.367048389490327, 3.445827158288461],
            [-11.361331428142739, 3.4466634110222545],
            [-11.357180085208874, 3.4452369487978256],
            [-11.351155638465048, 3.446253844775826],
            [-11.335735706050158, 3.4441080774826878],
            [-11.330092768154797, 3.4425997427160295],
            [-11.32614044676384, 3.4435395516290948]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.11133146558366,
          "lat": 40.990016786832214
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49011"],
        "coty_name": ["Davis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Davis County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01448020"
      },
      "bbox": [
        -11.806134132737068, 3.127167056713237, -11.2858899914673,
        3.498687274445392
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.908825030996619, -0.48314704929353064],
            [13.909377638121569, -0.4809089434584673],
            [13.920261540749626, -0.41284059962163666],
            [13.938127920285012, -0.2899115077328836],
            [13.95118872361422, -0.29112594952797544],
            [13.953660100561514, -0.2889597083178739],
            [13.961095905335307, -0.2727106382187781],
            [13.967294547880199, -0.2627884864108178],
            [13.970209095072649, -0.2596666422252718],
            [13.97703485537309, -0.25791475877503767],
            [13.980512270176082, -0.2581713649342779],
            [13.989797215095042, -0.26440489281408314],
            [13.999100238413266, -0.259036533297803],
            [14.004687036667939, -0.2624240186623129],
            [14.009865946416992, -0.25615763167051736],
            [14.010673353634488, -0.24770362414486113],
            [14.012914943450859, -0.24366131023898335],
            [14.017980841075389, -0.24162204947402344],
            [14.02117293647631, -0.24234908001652042],
            [14.032068066740614, -0.233875755871494],
            [14.033757676950803, -0.23055736650450123],
            [14.040848908692928, -0.22651179477380365],
            [14.042064024791786, -0.23807081803515265],
            [14.039320672834249, -0.25473485776355137],
            [14.041848762538395, -0.26311445942007505],
            [14.040440116940214, -0.2717354549663871],
            [14.042897394415787, -0.2749134023480119],
            [14.046094123522753, -0.2758123291592174],
            [14.047458389930293, -0.27951697999988995],
            [14.050888337288447, -0.2775225778685615],
            [14.06203021058409, -0.2752068145487264],
            [14.067440744904452, -0.27691022677098237],
            [14.074948054676046, -0.2765413174124947],
            [14.079477262418578, -0.2752800085367319],
            [14.083603088948248, -0.2765387869751745],
            [14.086653590827828, -0.2811042196693442],
            [14.08630089888646, -0.28595741244954803],
            [14.091448258456769, -0.2979782112199253],
            [14.100917997242341, -0.3018621729685153],
            [14.104985567789404, -0.30821168429522616],
            [14.107799479013572, -0.30799316753496364],
            [14.117869962925871, -0.31188645511992824],
            [14.122105747680456, -0.30959487647694556],
            [14.125471707560136, -0.3113026265664497],
            [14.126687645342475, -0.31581345106906555],
            [14.136265124530333, -0.3197743824581916],
            [14.141002626048856, -0.3180346988577894],
            [14.143588953129939, -0.3120775375854055],
            [14.151396742192661, -0.30775379591004554],
            [14.163422369199193, -0.3049534728182171],
            [14.166248275167812, -0.31147477045421496],
            [14.168395819460086, -0.31357349132571277],
            [14.175972465508005, -0.31118684611544417],
            [14.179190679845386, -0.31144511696331556],
            [14.18500230219898, -0.3153105776818925],
            [14.191013449656863, -0.31772843669569584],
            [14.197006710961096, -0.32333103579380584],
            [14.205004051656818, -0.3342644505665822],
            [14.205186393917675, -0.3424141308906339],
            [14.208015048879126, -0.3436642214677995],
            [14.219848208979021, -0.3550880290178366],
            [14.22667247108811, -0.3600360513739404],
            [14.23098975138065, -0.3583548836153745],
            [14.236256116918401, -0.35907752186034075],
            [14.241767414936655, -0.35651245763333667],
            [14.244691929367095, -0.3565201585918285],
            [14.253537728663002, -0.3622380701165213],
            [14.25668061440038, -0.36041831100540167],
            [14.256865825960443, -0.36310878793207024],
            [14.255373112148082, -0.4095301421865561],
            [14.254388493352911, -0.4480702372735135],
            [14.253588244019797, -0.5264932623558446],
            [14.253118704000999, -0.554329343262862],
            [14.245345072791276, -0.5746239325762906],
            [14.214559209172103, -0.6514768711634378],
            [14.167432618781794, -0.7687076753817077],
            [14.162748949289295, -0.7654587294420947],
            [14.152315029857325, -0.7624079152239902],
            [14.147911738560712, -0.7567013571394087],
            [14.14557380638335, -0.749223977922716],
            [14.13577812911981, -0.7406203598568505],
            [14.129009984826535, -0.7366021072076093],
            [14.125981568258739, -0.7312460926041482],
            [14.129652310262339, -0.7242426149197512],
            [14.131614576151627, -0.7166163716130415],
            [14.135951257478352, -0.711684321017861],
            [14.139726003807597, -0.7109319915591538],
            [14.141515563428781, -0.7052700306199692],
            [14.137745241343563, -0.699376746229101],
            [14.133310697885532, -0.6953827633291202],
            [14.125337520519063, -0.684571432371592],
            [14.122623476399712, -0.6750204871658266],
            [14.125049279770433, -0.6673495917329724],
            [14.130226165005594, -0.6640198587232999],
            [14.132162264645471, -0.6582743019958341],
            [14.128893963327705, -0.6560209549552177],
            [14.121973597526381, -0.6543061055548379],
            [14.116696249413794, -0.651082852179719],
            [14.113888159529493, -0.6479137169631959],
            [14.114620126020103, -0.6406586318691625],
            [14.125152826281987, -0.6342149256889978],
            [14.127617296330405, -0.6283122816579803],
            [14.126164950926738, -0.6238289495364416],
            [14.120233549515053, -0.6131176005244067],
            [14.117040264932449, -0.6107013717574659],
            [14.106939723231603, -0.6095370788667657],
            [14.10247980111225, -0.6048416045442698],
            [14.09827986282714, -0.5963223562893989],
            [14.087407718065242, -0.5892936153570967],
            [14.08092482963205, -0.5812676733482464],
            [14.071063790422073, -0.5731817409062545],
            [14.063124606317349, -0.5686733729741922],
            [14.047619788783342, -0.5624283982004955],
            [14.045749970865733, -0.5593019935485798],
            [14.047218137335536, -0.5533099152243256],
            [14.058577374507117, -0.5481457902077774],
            [14.062024557154682, -0.5412537125022211],
            [14.059409166546907, -0.5358070474708753],
            [14.055088253189107, -0.5314702228179219],
            [14.052481691586792, -0.5255906582028503],
            [14.051153429988563, -0.518083279179315],
            [14.047905108225239, -0.509951240018667],
            [14.046861358547186, -0.5011319980543577],
            [14.040565132749258, -0.48622285115969366],
            [14.040285175621511, -0.4803973247919725],
            [14.036894788153852, -0.4770419472968263],
            [14.031800103569177, -0.47485228792101886],
            [14.025733127654341, -0.4787390158665372],
            [14.025584640214053, -0.48455367729781795],
            [14.032964006012351, -0.48850801717714404],
            [14.036770301638304, -0.4959344023155098],
            [14.031786288716214, -0.4997631691597968],
            [14.023437824759226, -0.4980238283543748],
            [14.01898154352473, -0.5012590731626664],
            [14.01736788332185, -0.5057345558963123],
            [14.018239320347764, -0.5146426202044635],
            [14.019977875685212, -0.5225233851466432],
            [14.021983449823743, -0.5263376552061847],
            [14.021086804824836, -0.5312226048945452],
            [14.01190170538838, -0.5356968327928463],
            [14.006231293698848, -0.5334225839583373],
            [14.00434462317855, -0.5263674476376307],
            [13.99875425548956, -0.518251246914855],
            [13.994569909370703, -0.51443483853484],
            [13.983553153058475, -0.5087984603195536],
            [13.979552945488509, -0.5089044260344965],
            [13.972774679931602, -0.5113024065010854],
            [13.963717434978754, -0.5131385760345303],
            [13.951125447165698, -0.5129179458989609],
            [13.940857529055412, -0.5147195292104979],
            [13.931757831670637, -0.5211180086148367],
            [13.926312691813779, -0.5267558099175614],
            [13.922714717205384, -0.5263934120719822],
            [13.917912641235493, -0.5216339384046058],
            [13.91713598582666, -0.5175492430749563],
            [13.921061178431456, -0.509260756918015],
            [13.922649581626969, -0.5023843618585696],
            [13.920702845173505, -0.4981584912585155],
            [13.912363885771601, -0.493449223172697],
            [13.908825030996619, -0.48314704929353064]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.66162431721008, "lat": 37.01166620487389 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51037"],
        "coty_name": ["Charlotte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charlotte County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01492442"
      },
      "bbox": [
        13.908825030996619, -0.7687076753817077, 14.256865825960443,
        -0.22651179477380365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.312354550661265, 11.302227411956217],
              [-17.30383766677395, 11.298724048010882],
              [-17.29703840483158, 11.293197883407693],
              [-17.301986462803583, 11.290152716478554],
              [-17.302840738076874, 11.284515898529586],
              [-17.306711957563746, 11.283361516864314],
              [-17.311071960120138, 11.286888694768832],
              [-17.313875804966486, 11.300336043722234],
              [-17.312354550661265, 11.302227411956217]
            ]
          ],
          [
            [
              [-17.336452861684442, 11.427253483659792],
              [-17.33250856341025, 11.42836973449809],
              [-17.321927168368752, 11.434284176261526],
              [-17.320077010094526, 11.432840074409786],
              [-17.323288276298186, 11.424036703011366],
              [-17.319343865694407, 11.425152664033972],
              [-17.317009407223765, 11.430187773761707],
              [-17.31408257632979, 11.431760205642632],
              [-17.314270235566926, 11.43986973480172],
              [-17.31133740414525, 11.45185746824962],
              [-17.307637533874754, 11.45789336776259],
              [-17.306063487375635, 11.466105094537069],
              [-17.295943201782624, 11.474067016582458],
              [-17.29095266163032, 11.470061810818308],
              [-17.292319899519594, 11.463112491619663],
              [-17.291458235219853, 11.460532019254687],
              [-17.285541502244946, 11.454206107360529],
              [-17.28164721541014, 11.456685518786072],
              [-17.27717971629321, 11.45313422983935],
              [-17.272103225893108, 11.455180961152173],
              [-17.2704261136045, 11.445014222790201],
              [-17.271211798602838, 11.440439638783397],
              [-17.277229467546928, 11.429426907192102],
              [-17.280835449380632, 11.419293414645255],
              [-17.279489211659758, 11.412921715763744],
              [-17.276215436159305, 11.408860228192049],
              [-17.27868562687037, 11.407303607790437],
              [-17.289475182350643, 11.404800765977056],
              [-17.287912432848927, 11.393752800454655],
              [-17.285220542522797, 11.388356191821204],
              [-17.27835989324621, 11.380466489052994],
              [-17.281741061467514, 11.3777764600795],
              [-17.286210153607282, 11.371109790832785],
              [-17.28828966128818, 11.376114113501423],
              [-17.29038258073825, 11.376508127596322],
              [-17.298140764058783, 11.373772226057335],
              [-17.301362160987193, 11.376064509563752],
              [-17.30539900813565, 11.37262950096107],
              [-17.29794649245899, 11.368277711410123],
              [-17.292343037435078, 11.367214024865303],
              [-17.289883808843776, 11.368136177671802],
              [-17.290176940348342, 11.360915899301274],
              [-17.292575416935684, 11.356425386103593],
              [-17.294022524447275, 11.349091780897878],
              [-17.3046721194082, 11.350996739719465],
              [-17.305662332247135, 11.348886165432967],
              [-17.29889205942915, 11.344873067982322],
              [-17.29671997786687, 11.34190407797807],
              [-17.287748272008336, 11.335733777636122],
              [-17.28621940001424, 11.332113977337068],
              [-17.297247215657766, 11.332194179151085],
              [-17.303825506486035, 11.329018764079478],
              [-17.313598849325114, 11.330490826919599],
              [-17.316094291483335, 11.332552544202356],
              [-17.31835672978292, 11.347563560994976],
              [-17.320670262682427, 11.354758288868947],
              [-17.324361676921114, 11.356932731928161],
              [-17.324817025999696, 11.36364253512081],
              [-17.326551419464753, 11.36495589302372],
              [-17.33119765911554, 11.363414036026581],
              [-17.336458858297192, 11.35680458209194],
              [-17.34121779817461, 11.355071847716898],
              [-17.34384880849369, 11.359769770736103],
              [-17.34456346538425, 11.365855250620408],
              [-17.338251380255063, 11.379577274762177],
              [-17.339430572078513, 11.384333958606726],
              [-17.33332452430314, 11.40652560648635],
              [-17.33464829719636, 11.408750689289706],
              [-17.336856627648405, 11.42570026523635],
              [-17.336452861684442, 11.427253483659792]
            ]
          ],
          [
            [
              [-17.381577600579114, 11.176603418831057],
              [-17.406417756211635, 11.183841816899937],
              [-17.448566758967686, 11.195143167997124],
              [-17.475846217293917, 11.203267941875222],
              [-17.4916578219447, 11.207585391455249],
              [-17.545322473681388, 11.223053519771437],
              [-17.537315796274118, 11.250268703342421],
              [-17.53352260315547, 11.261625310231393],
              [-17.522884532863852, 11.298389330871299],
              [-17.521263700258615, 11.304762282255345],
              [-17.51289412425668, 11.332378563119619],
              [-17.539540453051693, 11.340944649694704],
              [-17.554281025863638, 11.345039909491668],
              [-17.602812348774385, 11.360125359749668],
              [-17.624170031487825, 11.365147979312049],
              [-17.638641548030503, 11.368106591081874],
              [-17.658271161339822, 11.373751301822098],
              [-17.65239354168792, 11.37904128742238],
              [-17.644960900641255, 11.381960755283286],
              [-17.633813135712675, 11.391142613078012],
              [-17.621623823611642, 11.402138734857882],
              [-17.615775652560348, 11.401443093983415],
              [-17.614677176183598, 11.407961690464866],
              [-17.609929457303657, 11.411484089064048],
              [-17.606816568091062, 11.417424231472177],
              [-17.601976838882297, 11.423520633359555],
              [-17.59119419669619, 11.421903289536397],
              [-17.582046986990207, 11.422704696228134],
              [-17.57510918067473, 11.427388611659344],
              [-17.570879946095165, 11.427481696878223],
              [-17.5688596942871, 11.431455936946465],
              [-17.563228894617776, 11.436835465419223],
              [-17.563345760036373, 11.445366927403548],
              [-17.560821492534945, 11.447764343705384],
              [-17.5551342643539, 11.448477103202913],
              [-17.545883786596054, 11.448295255079037],
              [-17.542135428868562, 11.450107983135855],
              [-17.529769447053845, 11.451660748335879],
              [-17.525631819554476, 11.45032047031033],
              [-17.518349294461697, 11.453928572216123],
              [-17.513123059148935, 11.4613682411285],
              [-17.495251992818453, 11.464085865438657],
              [-17.4933006266624, 11.461410266135472],
              [-17.49832345110048, 11.45748335144812],
              [-17.50390266706097, 11.450903361238566],
              [-17.501548419512897, 11.448190819723893],
              [-17.4977612204147, 11.450465704561353],
              [-17.493843574243197, 11.450549083066567],
              [-17.481547330347965, 11.45527210061548],
              [-17.466867284728167, 11.4577261596597],
              [-17.46530365219771, 11.456244891916366],
              [-17.457940071982353, 11.45934134292625],
              [-17.45485511743391, 11.458306279683061],
              [-17.44694929892767, 11.460610550585331],
              [-17.44053103863879, 11.461264318753635],
              [-17.43153389701496, 11.473867562284546],
              [-17.430720193297148, 11.480016404487982],
              [-17.42919926307997, 11.482536072195067],
              [-17.42740798330301, 11.491349814445783],
              [-17.427081107598877, 11.49870930172274],
              [-17.42401791650294, 11.507351023037552],
              [-17.41315491092334, 11.520379070613448],
              [-17.40861281390837, 11.522930539621296],
              [-17.40167485599039, 11.529721532720988],
              [-17.398806674064243, 11.531496571546574],
              [-17.393525433950845, 11.542301385819599],
              [-17.388520777761244, 11.547501825451288],
              [-17.38325198548284, 11.547865023773971],
              [-17.3780266829179, 11.551983949370165],
              [-17.37208953377464, 11.551504021954974],
              [-17.36894184425207, 11.55365588955497],
              [-17.360004197074474, 11.570878386460489],
              [-17.352432956304746, 11.574648452141929],
              [-17.350601405963246, 11.57689973839757],
              [-17.343501589037576, 11.580961168058856],
              [-17.338967784277376, 11.58025822142637],
              [-17.33547638730152, 11.581652677777257],
              [-17.33296778921157, 11.586987963730879],
              [-17.31523032245689, 11.595315027895719],
              [-17.310077786733867, 11.594858149229504],
              [-17.300476566109182, 11.606927584214375],
              [-17.29464129135825, 11.611273416704822],
              [-17.272029054420834, 11.60577320627843],
              [-17.267138205987557, 11.621081589937871],
              [-17.268087477272566, 11.649599568752468],
              [-17.266333027697563, 11.660125134524446],
              [-17.26948987068743, 11.665942516253422],
              [-17.26952659873925, 11.66839005847023],
              [-17.275612261891997, 11.673296433735834],
              [-17.282185952261734, 11.677079405670705],
              [-17.279795656967575, 11.681236041383979],
              [-17.282054875410484, 11.683383585987269],
              [-17.27787840206914, 11.68972154175533],
              [-17.274101041737524, 11.690461987778534],
              [-17.268927680417143, 11.688708309180974],
              [-17.26979815319872, 11.680107160305072],
              [-17.26904327445619, 11.67546434022835],
              [-17.266268400490095, 11.669807216559782],
              [-17.260168971434215, 11.66583002587007],
              [-17.247709328854178, 11.662338869449641],
              [-17.239219019976197, 11.65871800481094],
              [-17.234879666282637, 11.652019840704321],
              [-17.23025758539779, 11.649144226121994],
              [-17.225641417810003, 11.648097105251368],
              [-17.22887584217296, 11.642481389349804],
              [-17.229542945232378, 11.636672438282378],
              [-17.225703464553458, 11.617233156073523],
              [-17.226343899758724, 11.613215336911379],
              [-17.231249098338935, 11.60279402268422],
              [-17.231296395106625, 11.596546673208287],
              [-17.229949489769993, 11.591376124424952],
              [-17.230298861267126, 11.58537287523393],
              [-17.23286458990871, 11.578445959259543],
              [-17.235179335540685, 11.569294207282473],
              [-17.234105689917325, 11.563582551883217],
              [-17.224266788728517, 11.549816453973284],
              [-17.225914626245654, 11.543951158850621],
              [-17.229121014692147, 11.539664385140862],
              [-17.23764906248393, 11.534886148469415],
              [-17.242305386902384, 11.534122552511922],
              [-17.243637297913903, 11.530135329989845],
              [-17.237413773892367, 11.520828278544672],
              [-17.234115468291886, 11.518544993587817],
              [-17.235093266931084, 11.514018984349658],
              [-17.23406046638501, 11.505555317667952],
              [-17.2305482351526, 11.501460115850884],
              [-17.232269050456704, 11.492982556028966],
              [-17.235242538916143, 11.486439951520756],
              [-17.23986154432377, 11.483889556211823],
              [-17.24778011110098, 11.483666927871171],
              [-17.252868421317253, 11.486492443015015],
              [-17.257551442899793, 11.485965573660067],
              [-17.265085368531135, 11.488831803100355],
              [-17.267144777117736, 11.491746523590589],
              [-17.278609092151022, 11.49589729800882],
              [-17.290159447195105, 11.49769022780308],
              [-17.288460296977412, 11.494229085084191],
              [-17.28914986817403, 11.488437595875038],
              [-17.291078265686565, 11.482993078042798],
              [-17.2960789802776, 11.47872988877607],
              [-17.300524451567714, 11.477200457766532],
              [-17.302492572317675, 11.474365045825618],
              [-17.31053918224702, 11.468123411189266],
              [-17.31214480560674, 11.46868147631221],
              [-17.32075034972168, 11.462834414372647],
              [-17.321423618920548, 11.458164307492902],
              [-17.32423720479835, 11.457135978825239],
              [-17.326844011627752, 11.452828771579245],
              [-17.329418962741517, 11.456717885222178],
              [-17.33543486640347, 11.460284464756342],
              [-17.333780585368764, 11.4681824564356],
              [-17.337370598017454, 11.476733553402704],
              [-17.341175708029144, 11.47805302742363],
              [-17.351243173982887, 11.47388932461289],
              [-17.34791011728806, 11.471575473268565],
              [-17.34397786176264, 11.471158396480757],
              [-17.34222055590134, 11.464807801981621],
              [-17.345136998114118, 11.465274459688509],
              [-17.346855669580012, 11.460113002387313],
              [-17.349813723272106, 11.44215959071072],
              [-17.35120043429877, 11.436577518687825],
              [-17.350941286643547, 11.431717230069975],
              [-17.35497349881331, 11.42225083315306],
              [-17.357736191848833, 11.419640652253705],
              [-17.350354999309513, 11.410923907495684],
              [-17.349213390217017, 11.404120717972063],
              [-17.344351569109616, 11.403802565021886],
              [-17.344222563920304, 11.401371738977534],
              [-17.357851856304105, 11.371854002857011],
              [-17.35585239746742, 11.363157940934249],
              [-17.36103110918049, 11.357738081767817],
              [-17.361292308922785, 11.355702056696462],
              [-17.368486392537143, 11.346208826128226],
              [-17.373113429409802, 11.342310232956171],
              [-17.37775849609461, 11.341814858886405],
              [-17.38154790894279, 11.346840938450462],
              [-17.385167983754968, 11.340375537140103],
              [-17.387709225102384, 11.338040716600691],
              [-17.394528457394983, 11.338902620273597],
              [-17.399417707124403, 11.336852671171362],
              [-17.40608813562222, 11.33800922081783],
              [-17.421633983576534, 11.333058964017027],
              [-17.425318154308368, 11.329400502375954],
              [-17.42613538635165, 11.32617348108648],
              [-17.437423888703506, 11.322116307252172],
              [-17.443570476359568, 11.320765655261773],
              [-17.442966249282136, 11.318484726329551],
              [-17.434682189087912, 11.316994413979552],
              [-17.422446044942763, 11.318283514846081],
              [-17.41628161845912, 11.3242435852097],
              [-17.40814362922997, 11.319397633164728],
              [-17.400358376123794, 11.322821888538895],
              [-17.391458004677077, 11.321393039166923],
              [-17.387118408216807, 11.324708958724239],
              [-17.378467555697835, 11.321181106303433],
              [-17.367406425598485, 11.332143450594355],
              [-17.362537272950576, 11.335911753052143],
              [-17.351286959837235, 11.341639672960333],
              [-17.344554108577537, 11.348012640782212],
              [-17.333152575877, 11.35208531166639],
              [-17.32980895160416, 11.347849134730662],
              [-17.3330631241705, 11.340567690458535],
              [-17.330922852658066, 11.336924122811528],
              [-17.337166578898447, 11.332842782391655],
              [-17.32537610444372, 11.325128976939295],
              [-17.329664099667674, 11.323837618540816],
              [-17.33537357907614, 11.317906827711212],
              [-17.33485764765709, 11.310992391055649],
              [-17.335785014334082, 11.306087761548635],
              [-17.345532031477745, 11.292566194520768],
              [-17.34499090213245, 11.287446452749618],
              [-17.334933814910443, 11.283585003121715],
              [-17.329275667935885, 11.283455449297911],
              [-17.326854514985715, 11.277961919364662],
              [-17.319101383244554, 11.275248255326227],
              [-17.315786850361246, 11.267202651591527],
              [-17.32345603186276, 11.262044798883254],
              [-17.324821832469436, 11.25825314044706],
              [-17.33128976509206, 11.252459923510186],
              [-17.338019604298008, 11.24783722805863],
              [-17.33925029471077, 11.243623956222724],
              [-17.34367496383808, 11.238841059434018],
              [-17.35140729516339, 11.234824705890059],
              [-17.353460547174897, 11.222041746392007],
              [-17.359040519290353, 11.216765804681183],
              [-17.360414716129913, 11.206882250438454],
              [-17.362627102799603, 11.203917277851712],
              [-17.361756205262157, 11.198283966029525],
              [-17.36575383104144, 11.1932182416779],
              [-17.369922085165182, 11.190475463175666],
              [-17.370405243007344, 11.188153701915942],
              [-17.381577600579114, 11.176603418831057]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.67620507216267,
          "lat": 47.61271020719555
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53035"],
        "coty_name": ["Kitsap"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kitsap County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01529223"
      },
      "bbox": [
        -17.658271161339822, 11.176603418831057, -17.224266788728517,
        11.690461987778534
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.592001367601979, 1.0688800197674613],
            [11.595222815672399, 1.071146282631467],
            [11.595110381019095, 1.0753594891748863],
            [11.597837804255104, 1.0776623097523512],
            [11.600689863813118, 1.0766670029605983],
            [11.602998859716603, 1.0792662235437158],
            [11.607466218258832, 1.0776842499321968],
            [11.617386540934305, 1.0825724537890626],
            [11.618256376399195, 1.0877318273036514],
            [11.62071130206454, 1.0869825384746084],
            [11.625128425284508, 1.0903876522976563],
            [11.625329347697047, 1.0967504427621488],
            [11.629840863010655, 1.0989376418650718],
            [11.658239792839572, 1.0819552196235387],
            [11.692971814868903, 1.0723462668748078],
            [11.716144733441592, 1.0653826518319667],
            [11.741060470266545, 1.0819167836018468],
            [11.763218653097184, 1.0922821628952746],
            [11.76438507765528, 1.0901623142683818],
            [11.769729177187088, 1.0917274192993354],
            [11.769810496490384, 1.0849220394082233],
            [11.772075245401886, 1.0848906101404798],
            [11.775639014065096, 1.0903017961355734],
            [11.779239879277407, 1.0874121067436178],
            [11.77887303546246, 1.0816614979125652],
            [11.782698199963125, 1.0788621168438597],
            [11.788557570749095, 1.0775142312083117],
            [11.780644757964104, 1.0728406269830932],
            [11.78678231273802, 1.0684400062484913],
            [11.789716057883677, 1.0686802140862974],
            [11.794588353321757, 1.0646768760310292],
            [11.800495310084157, 1.057389160603156],
            [11.797851457069358, 1.0537984800729778],
            [11.798552487251689, 1.0461750988246565],
            [11.80417725708323, 1.045158096169516],
            [11.803289931994316, 1.0413191218152933],
            [11.79788242355351, 1.0413157208789603],
            [11.797233840687971, 1.0345223521564388],
            [11.800846948338428, 1.0334691918154886],
            [11.804173952917433, 1.0296574088244703],
            [11.808403861477858, 1.0352000431400654],
            [11.81127945650473, 1.035855865959263],
            [11.8124935130323, 1.02956855339828],
            [11.818232681537786, 1.0280716310662767],
            [11.821013323398692, 1.0186444063235267],
            [11.824598149983338, 1.0160825536999443],
            [11.818196843142632, 1.0092421858883895],
            [11.820749552543113, 1.0074063749030724],
            [11.822258835698827, 1.0022085825100704],
            [11.81875938721236, 0.9962646686018543],
            [11.823343485250678, 0.9955248222138036],
            [11.821785248593603, 0.9865087581825824],
            [11.827538515387847, 0.9832994428454156],
            [11.824085479494437, 0.9804272520946942],
            [11.821527648627466, 0.976044149457912],
            [11.8271248733718, 0.9748407319203053],
            [11.825960427962393, 0.9702814334852093],
            [11.832253692292142, 0.9713947357061196],
            [11.83726604119362, 0.9710547582350485],
            [11.836424918492659, 0.9646666104982153],
            [11.841734674909665, 0.9626096531907843],
            [11.842886161062257, 0.9568324713219291],
            [11.849155940993073, 0.9550931601108813],
            [11.848032957859848, 0.95127870874438],
            [11.85153909720113, 0.9507347018373211],
            [11.859580858183566, 0.9409596377310021],
            [11.862115331435044, 0.9362858115220613],
            [11.869561935360505, 0.932658149825086],
            [11.871836575502169, 0.9304117922237708],
            [11.874339831500155, 0.9228859547114261],
            [11.871363998195456, 0.9132842646779518],
            [11.875411232479953, 0.91064209140427],
            [11.877387080884509, 0.9018916232719952],
            [11.876649683812738, 0.8980953401548467],
            [11.882091661226607, 0.8909212754742262],
            [11.881646048311975, 0.8816497791215522],
            [11.878582692716469, 0.8781315160803244],
            [11.881152928355725, 0.8737965589611313],
            [11.879412324293192, 0.871404142644431],
            [11.881899306871828, 0.8667187977283125],
            [11.889562870720177, 0.8648818397698393],
            [11.888373288265347, 0.8598879136128523],
            [11.888521515357285, 0.8522560382220106],
            [11.89215080322711, 0.8541803615496293],
            [11.894486998418087, 0.8489532841064112],
            [11.89271052224775, 0.8441694219188552],
            [11.895418786108035, 0.8411901429769216],
            [11.89670988991778, 0.8369136229442729],
            [11.89938807272871, 0.8377573824883634],
            [11.90436770841194, 0.8351707597024155],
            [11.906291002798543, 0.836576582444645],
            [11.910802158039852, 0.8341628621091481],
            [11.918502268070787, 0.8339755164973146],
            [11.920252781075517, 0.8308417884611635],
            [11.925582002946081, 0.8276328285853959],
            [11.932816755492569, 0.8295117717832462],
            [11.93669232815728, 0.8378534330080247],
            [11.9409311394946, 0.8382522824426781],
            [11.941785484778705, 0.8344079666027501],
            [11.94511333243461, 0.8346109387703405],
            [11.946981705197988, 0.8283970172958276],
            [11.951637733213053, 0.8292722606306511],
            [11.95342681624281, 0.8258804181566136],
            [11.958770740608761, 0.820549662027872],
            [11.9592407699962, 0.8135502973712061],
            [11.934140202842178, 0.7677898955612121],
            [11.930373256392455, 0.761805787335132],
            [11.888063169657853, 0.7161145158173295],
            [11.867163000277577, 0.7171330384143887],
            [11.827628741060407, 0.7007182510325519],
            [11.803229092160826, 0.710164627584219],
            [11.767129149509584, 0.7111910035592784],
            [11.676836088272866, 0.7059300359112052],
            [11.672721867754225, 0.7017296647151141],
            [11.639665412689805, 0.7338053352818231],
            [11.623877595767985, 0.7620597085130603],
            [11.606916566182093, 0.793540076347095],
            [11.596041810072077, 0.8187114774280173],
            [11.598124095835901, 0.8455622292596934],
            [11.597101439322426, 0.8867770913916098],
            [11.597758157769304, 0.896517972232198],
            [11.59183287532998, 0.9738480385738205],
            [11.580164228779116, 1.0204557689989564],
            [11.579938273740874, 1.0232747443079049],
            [11.575833378787015, 1.0398259201450228],
            [11.57457221369892, 1.0425759200724893],
            [11.57569180259305, 1.0497723965453238],
            [11.581261272938448, 1.0501267180178913],
            [11.587372974285278, 1.0542099648399643],
            [11.589550330886174, 1.0636294281839385],
            [11.592001367601979, 1.0688800197674613]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.34834904823315,
          "lat": 38.713970488223985
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54087"],
        "coty_name": ["Roane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roane County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01550050"
      },
      "bbox": [
        11.57457221369892, 0.7007182510325519, 11.9592407699962,
        1.0989376418650718
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.449303196945564, 6.653500374335679],
              [6.454749631547061, 6.655315296549897],
              [6.458271757346778, 6.650233697271017],
              [6.449303196945564, 6.653500374335679]
            ]
          ],
          [
            [
              [5.749595055565608, 7.254928030436205],
              [5.7760932083032746, 7.256509547502954],
              [5.791431475275723, 7.2579802904504],
              [5.890292471165466, 7.263066097965453],
              [5.895841461821279, 7.263080039915373],
              [5.92201618088638, 7.264503323565181],
              [5.940610958048993, 7.2645123641948315],
              [6.005201608395437, 7.266358813143594],
              [6.000286491572268, 7.333245207183096],
              [6.005566682394538, 7.3339349329985515],
              [6.011518964195718, 7.337176968406212],
              [6.012427850896417, 7.34311217584702],
              [6.021157711894063, 7.343406018462314],
              [6.027587801971718, 7.347189556513108],
              [6.0349425570626725, 7.347542490309031],
              [6.0441738061305275, 7.35171705680338],
              [6.048150419801355, 7.34952618725252],
              [6.052706038451683, 7.339832559388272],
              [6.054423453963893, 7.334042007478889],
              [6.048531474886541, 7.32953785612824],
              [6.051178199334454, 7.326428725886977],
              [6.061177395531086, 7.324008237418736],
              [6.065183927590895, 7.32205907854969],
              [6.0681207551895175, 7.3165357949879795],
              [6.0743607594736595, 7.3172536479133825],
              [6.080050713849095, 7.316031821771092],
              [6.0882139083288145, 7.31810270753485],
              [6.091816454563816, 7.3206647586459095],
              [6.097063452178893, 7.317750773875911],
              [6.0993452245980215, 7.320097217881168],
              [6.105434136386778, 7.318187094150942],
              [6.108943132217131, 7.320918279873603],
              [6.112661248730922, 7.315596995183836],
              [6.126594794303751, 7.318118096789689],
              [6.131473768611245, 7.314151676706816],
              [6.13519315644065, 7.313510984268448],
              [6.139679014813682, 7.309456825173185],
              [6.1388847861405935, 7.3015507478511505],
              [6.145908229906131, 7.292004828247522],
              [6.152489892438685, 7.28817130178997],
              [6.159390039508179, 7.283181353190255],
              [6.167531352275586, 7.281170689584992],
              [6.1689182514545875, 7.279752993377114],
              [6.177277550937224, 7.279123274851663],
              [6.182165961506554, 7.275102253470808],
              [6.182999335749418, 7.2719048645843545],
              [6.180418455753473, 7.268480416670437],
              [6.186058969349616, 7.262520614505361],
              [6.196489577230881, 7.256766429559893],
              [6.201897183106423, 7.250433048168561],
              [6.201939807965346, 7.243401351071478],
              [6.192543457921702, 7.240657224985069],
              [6.187433376766469, 7.2354016426259875],
              [6.179895684230645, 7.233395045715421],
              [6.17391293558743, 7.230499198513669],
              [6.174812658902777, 7.223952485263372],
              [6.173677253139699, 7.221002759854807],
              [6.17459871926365, 7.215036884549914],
              [6.1796302791603495, 7.212270410932782],
              [6.1850125640501155, 7.207561399129368],
              [6.18983728309074, 7.198220756738747],
              [6.195521452646584, 7.193412526894763],
              [6.196701084857491, 7.188768217327759],
              [6.199574706636322, 7.1869343414093265],
              [6.207547915352567, 7.1854722892581355],
              [6.210748239136858, 7.1752064293749065],
              [6.212930651685734, 7.173415976898087],
              [6.211677455119437, 7.165154844050561],
              [6.21234411785192, 7.159899318903132],
              [6.206844507800422, 7.154906842910357],
              [6.205751436026664, 7.152239983218137],
              [6.206478472905992, 7.145860123864302],
              [6.206200915142, 7.136915221633153],
              [6.2039570629047, 7.1338426022571655],
              [6.200434693319855, 7.1326130333459945],
              [6.1943935880731535, 7.132830582043996],
              [6.191172157314313, 7.134989074617221],
              [6.1776710928252125, 7.137286504588074],
              [6.175245777468142, 7.130858690959485],
              [6.175943687154709, 7.1278633049442295],
              [6.180287371985824, 7.124409870820981],
              [6.186467659211596, 7.121433509429094],
              [6.195322386907192, 7.113650800499058],
              [6.198404818280619, 7.10868573461664],
              [6.19808179803369, 7.10165865415362],
              [6.201378547562673, 7.083829440360078],
              [6.204368732769654, 7.07734081366195],
              [6.208372754058698, 7.076430597044041],
              [6.209120654445223, 7.071453622169586],
              [6.206018164380932, 7.065287169193495],
              [6.206074695039165, 7.056429266294277],
              [6.201056553265115, 7.0499667876779535],
              [6.202350143475838, 7.044147299328139],
              [6.198813994888238, 7.0387154611372145],
              [6.1980908459659165, 7.034835831888101],
              [6.1936059826854555, 7.0308969357474576],
              [6.185021058526027, 7.025510730449015],
              [6.183138156110301, 7.020323451403964],
              [6.177194811232176, 7.017358878993887],
              [6.175730747825879, 7.0130154732401735],
              [6.170470463376267, 7.009779000329531],
              [6.166588576241912, 7.002567321664553],
              [6.168104327473271, 6.997825162928962],
              [6.1684112702242375, 6.991793155560257],
              [6.171992536446998, 6.9847217413035345],
              [6.1771349575906935, 6.9786005229329815],
              [6.176875584152849, 6.971011844923182],
              [6.17142048792749, 6.9675989151113225],
              [6.173531491728232, 6.961938043233881],
              [6.172138794982073, 6.956957001031978],
              [6.164540209897665, 6.951216209329516],
              [6.161709236404014, 6.944931825108739],
              [6.164897135644014, 6.941641051265695],
              [6.160241088189925, 6.9335467083848075],
              [6.156514935085203, 6.930277804599792],
              [6.154968021792951, 6.9220780008833165],
              [6.1601156060272215, 6.919107533878489],
              [6.167211146132937, 6.924683867542835],
              [6.167173741423189, 6.927426677470795],
              [6.162819875789399, 6.932245069106353],
              [6.166432332046584, 6.934753152220906],
              [6.16967577390226, 6.931798008234417],
              [6.170432154750443, 6.924971074067067],
              [6.17230246595862, 6.921880983951885],
              [6.181924204040643, 6.917191169050873],
              [6.181626152319355, 6.912025206041378],
              [6.183943186695944, 6.910569204800383],
              [6.190722396897597, 6.915559134829094],
              [6.192204232408603, 6.921545997525537],
              [6.193978667377595, 6.922962641063846],
              [6.199539564874377, 6.9219073474280925],
              [6.200651741193215, 6.923933351593699],
              [6.209835199249292, 6.923343665311483],
              [6.216360682018842, 6.926235111201428],
              [6.223471154296268, 6.926682482203868],
              [6.228864777131977, 6.923439141820386],
              [6.238468470880246, 6.925731480768973],
              [6.243640111809682, 6.923392189168685],
              [6.249165588091459, 6.924906773744083],
              [6.250903123537591, 6.930634192906902],
              [6.258684688464612, 6.932705352062147],
              [6.262346230346314, 6.940988770566686],
              [6.271369870274898, 6.954758556060519],
              [6.278430955365953, 6.959114989839768],
              [6.279296118251994, 6.961790601067487],
              [6.287727245704685, 6.968569403056023],
              [6.293441017216261, 6.967888435708429],
              [6.295915562244997, 6.964355164890494],
              [6.302020904555312, 6.961596821156078],
              [6.303157871310886, 6.95700808004184],
              [6.314154375393776, 6.950767675344444],
              [6.315818241335717, 6.948492678560239],
              [6.316573745442227, 6.939907819775236],
              [6.319104789287376, 6.9357296451425245],
              [6.3234963501255415, 6.932641300089506],
              [6.324212854514291, 6.921413333866149],
              [6.319609308393552, 6.912487460509296],
              [6.315618427997891, 6.907738952295859],
              [6.316431267312091, 6.902776794980903],
              [6.309590135254154, 6.891039333187545],
              [6.3054800437390774, 6.886321639880948],
              [6.304874215017975, 6.883236568753659],
              [6.300269189839482, 6.878104047460823],
              [6.29894214370412, 6.870225541404035],
              [6.294184379026933, 6.8610781378632995],
              [6.2937364664476565, 6.856199603362713],
              [6.294867125505011, 6.849078688239578],
              [6.2902317492148985, 6.845140474131763],
              [6.287570437309758, 6.838375995749988],
              [6.288892499953029, 6.833828251973825],
              [6.288077534722104, 6.824357322160785],
              [6.288634733075553, 6.8191603692699125],
              [6.28392261190554, 6.81712369196058],
              [6.280235917898956, 6.81172015288928],
              [6.279983909855411, 6.808447651074594],
              [6.282756466113796, 6.805565965443218],
              [6.282279886209742, 6.801995583727719],
              [6.279518731557064, 6.797407206096494],
              [6.28087907620348, 6.787990787292345],
              [6.275315750150677, 6.783781065463957],
              [6.272187031097587, 6.779990886806986],
              [6.270956808004088, 6.775968976821123],
              [6.272919879757889, 6.771614715242278],
              [6.275048673852642, 6.761927383438778],
              [6.277318529679339, 6.7560091477666315],
              [6.276776726503458, 6.751719056298009],
              [6.285649100932103, 6.746564134157337],
              [6.2908683060921975, 6.740734873206201],
              [6.298009092060802, 6.737894431880364],
              [6.298840022078374, 6.7349642143319555],
              [6.303898469709048, 6.7319204176236465],
              [6.307861285353482, 6.731600504659494],
              [6.31624819590397, 6.725957322200756],
              [6.322718870927387, 6.717464336802547],
              [6.321164266604412, 6.713481745679723],
              [6.327413184389088, 6.702914335097171],
              [6.334885448035893, 6.696078573556299],
              [6.335321175690323, 6.691837984320826],
              [6.342178687683333, 6.692715891317322],
              [6.344633227099281, 6.690744835291323],
              [6.356343865868928, 6.691626821513314],
              [6.359334456700279, 6.68899857388982],
              [6.384988582524139, 6.682703555915062],
              [6.389041744532967, 6.675396527712549],
              [6.379407654537227, 6.670118943688602],
              [6.374815190923351, 6.664779719985811],
              [6.373400745663652, 6.661127554888192],
              [6.365787893350707, 6.631495716852971],
              [6.3692594495014125, 6.600867334672164],
              [6.368747332477841, 6.573419287655465],
              [6.367319068218977, 6.5709641657344235],
              [6.35719869756821, 6.570921216504595],
              [6.348734427487005, 6.564792046341423],
              [6.348616206751172, 6.557463481352263],
              [6.338522008710066, 6.5591684781554225],
              [6.3221018271705915, 6.5578095778325896],
              [6.276497338697924, 6.545293578050522],
              [6.276830944557449, 6.554842338335828],
              [6.276094359113612, 6.569145930679358],
              [6.2617600440271355, 6.568015632457293],
              [6.189328483194024, 6.561640643496638],
              [6.189147361245911, 6.564203157970508],
              [6.181973720488798, 6.563853035025991],
              [6.146146264008782, 6.560574861873327],
              [6.145742276065074, 6.574860863083719],
              [6.144840628117245, 6.587779265440462],
              [6.087327598361815, 6.5843684790276455],
              [6.076119617081599, 6.583529745671142],
              [6.0192486916529075, 6.580452404864361],
              [6.01632531520203, 6.623384359294494],
              [6.01366542266948, 6.666425328926684],
              [5.964088691425012, 6.663994284960305],
              [5.960732424289909, 6.723000282905447],
              [5.959041247747235, 6.749490936358969],
              [5.944427928884086, 6.748528144858916],
              [5.915989345883461, 6.748369334429792],
              [5.8893410615599215, 6.746538315197638],
              [5.87263950805264, 6.746072639753692],
              [5.867981398621953, 6.802937361664391],
              [5.86630469470253, 6.831525122765855],
              [5.860927055459098, 6.91753185126294],
              [5.836746401797332, 6.9159762622771845],
              [5.799784465389014, 6.9143888205078685],
              [5.7751308174750005, 6.913129673137054],
              [5.773125227445864, 6.950209156717506],
              [5.769995183555797, 6.9988859346918835],
              [5.768460213596539, 7.010234661432177],
              [5.766976936525903, 7.0343333566014286],
              [5.7656906406995665, 7.04768895527264],
              [5.754380690243016, 7.190681801297363],
              [5.749595055565608, 7.254928030436205]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.03379831903179, "lat": 45.38333942761862 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55075"],
        "coty_name": ["Marinette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marinette County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01581097"
      },
      "bbox": [
        5.749595055565608, 6.545293578050522, 6.458271757346778,
        7.35171705680338
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.936166206469091, 6.632034488770491],
            [-5.9092068232017585, 6.629466085449044],
            [-5.80440012990138, 6.619540855058967],
            [-5.718904952804778, 6.611077131443781],
            [-5.623186374359991, 6.601685500844445],
            [-5.5356296966382095, 6.593507834961731],
            [-5.454282051469559, 6.586154405437918],
            [-5.3642170230129205, 6.578080724676638],
            [-5.269988766588422, 6.569823577752362],
            [-5.219909595290242, 6.5652203539821645],
            [-5.2244424801571, 6.502028195290542],
            [-5.2289223518098975, 6.443531305614931],
            [-5.230028509773243, 6.435419631398318],
            [-5.237361903819207, 6.345050963025681],
            [-5.249303126659181, 6.203797866002558],
            [-5.254651334339054, 6.141862406569729],
            [-5.259847964474999, 6.081676450411823],
            [-5.266461334246054, 6.002869370346298],
            [-5.275931046341002, 5.890205440224414],
            [-5.287107619735032, 5.753580515005293],
            [-5.39866465010851, 5.763474791833852],
            [-5.510224417254036, 5.773338961170142],
            [-5.5153439563116855, 5.774500247739541],
            [-5.576403544002097, 5.779018305639073],
            [-5.672475002447674, 5.786892161088132],
            [-5.76854814351861, 5.794743703255407],
            [-5.864622931937818, 5.802572931521351],
            [-5.960699332439385, 5.810379845542605],
            [-6.008721022970198, 5.814497583613849],
            [-6.0168208612597756, 5.814989478635213],
            [-6.018885174621687, 5.815179274493169],
            [-6.016638253197482, 5.8555283454804306],
            [-6.010489225563784, 5.916075411540904],
            [-6.009529006982572, 5.9273544405354945],
            [-5.996117831034906, 6.06442019287273],
            [-5.995550406524351, 6.068673231863504],
            [-5.985623608463981, 6.164133503728444],
            [-5.988058347483785, 6.16446670783668],
            [-5.986345785094902, 6.178482706153124],
            [-5.972553628404762, 6.320918951653186],
            [-5.962779615300279, 6.421330542645896],
            [-5.956780125973307, 6.420151083504071],
            [-5.947214425628396, 6.504112668164925],
            [-5.948555942770499, 6.504242333368409],
            [-5.936166206469091, 6.632034488770491]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.56993077567786,
          "lat": 44.58850023016911
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56011"],
        "coty_name": ["Crook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crook County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01605071"
      },
      "bbox": [
        -6.018885174621687, 5.753580515005293, -5.219909595290242,
        6.632034488770491
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.5986769805570855, 6.369620563849646],
            [-7.547113679117246, 6.362742465519482],
            [-7.426625140063462, 6.347809116459203],
            [-7.361386049316252, 6.340198156556017],
            [-7.361277718574215, 6.341042180209769],
            [-7.335372208536191, 6.337926497130422],
            [-7.291524031011102, 6.332251261941001],
            [-7.241521267511952, 6.325941498785622],
            [-7.206654633527108, 6.321972306833886],
            [-7.139228772622246, 6.313999302286088],
            [-7.100674527455596, 6.30901873777014],
            [-7.077366497718956, 6.307014100521864],
            [-7.073656135812528, 6.306299192309884],
            [-7.020805840892406, 6.300120982001722],
            [-6.934728393723296, 6.290543260091119],
            [-6.9341795424381685, 6.295495096610952],
            [-6.845936574595621, 6.286110230088072],
            [-6.7576956826195165, 6.27670565538248],
            [-6.757725535389231, 6.278412454079125],
            [-6.672844344349183, 6.268694650325312],
            [-6.637689046250195, 6.265893229304302],
            [-6.6413617535703615, 6.223291518460201],
            [-6.64561608268196, 6.22363744931888],
            [-6.670036125304144, 6.00912535159052],
            [-6.6841059379503545, 5.875427288791133],
            [-6.680460187571422, 5.875049785763699],
            [-6.683895834302531, 5.84275758809833],
            [-6.69412400758254, 5.736679239114289],
            [-6.715644249003683, 5.529112538736422],
            [-6.721654432234271, 5.529654699477413],
            [-6.74332227247573, 5.334379158675887],
            [-6.743272541479135, 5.328954391860709],
            [-6.755989008790898, 5.204945186338922],
            [-6.799627593078929, 5.209055617054081],
            [-6.932071921821014, 5.222489453230722],
            [-7.0645200472045495, 5.235883978594321],
            [-7.103168841908655, 5.239745904230349],
            [-7.114736961985079, 5.24048526400151],
            [-7.242256851946154, 5.254885257176567],
            [-7.391638681029316, 5.27225374205083],
            [-7.5410263762428285, 5.289572063819663],
            [-7.539964445606257, 5.297429452521153],
            [-7.533533079810776, 5.35235783983398],
            [-7.53554330474902, 5.352804398225666],
            [-7.515550598606024, 5.52063317229296],
            [-7.514690629684063, 5.531032593805535],
            [-7.512733649324284, 5.545619598350186],
            [-7.5050547301497375, 5.611263256353866],
            [-7.515039043561688, 5.612299413971228],
            [-7.5054428831229645, 5.698210931834099],
            [-7.479969697305084, 5.9151666551201405],
            [-7.479331268802216, 5.918829267690521],
            [-7.474719451121825, 5.959214596830788],
            [-7.487662794595148, 5.960703985786529],
            [-7.467797413094999, 6.117419397846971],
            [-7.47183749399061, 6.118358658469177],
            [-7.4754104764143, 6.116628619915859],
            [-7.477995435832728, 6.119759406210065],
            [-7.477509562250431, 6.129066834614045],
            [-7.486045621166355, 6.130764448374593],
            [-7.488320877437908, 6.134069079290244],
            [-7.4875883542582, 6.13840908112546],
            [-7.48978534196123, 6.142157350356601],
            [-7.495883416997854, 6.144181430260125],
            [-7.495290450379219, 6.150107983851236],
            [-7.491957634431117, 6.155192187451965],
            [-7.483427704515319, 6.155850701240593],
            [-7.475694322418788, 6.162575337924052],
            [-7.476430569774824, 6.168496698814025],
            [-7.483866771190397, 6.172062247801515],
            [-7.47975680879084, 6.184209866055383],
            [-7.476775981177586, 6.1882529030819695],
            [-7.482506193776285, 6.1987383960029945],
            [-7.487603892566319, 6.19798726346051],
            [-7.4897970333537, 6.194960475098921],
            [-7.4974979783846365, 6.196507838088271],
            [-7.496613092450881, 6.199853986162212],
            [-7.49718704459712, 6.213690095792207],
            [-7.495383366614092, 6.218692499760545],
            [-7.497669662229529, 6.222524030152536],
            [-7.497448090762409, 6.226292166230878],
            [-7.494284463755186, 6.231008726738525],
            [-7.496307780267056, 6.232950225101918],
            [-7.492955842573444, 6.2387927283104085],
            [-7.493779534035427, 6.243248691881491],
            [-7.499789213672982, 6.242606388466148],
            [-7.503021390079076, 6.244735644074118],
            [-7.512261174330966, 6.240593796964192],
            [-7.52046096194276, 6.240286941248396],
            [-7.522926039799422, 6.238813512192055],
            [-7.531819361871796, 6.24302856194303],
            [-7.533598798455746, 6.24766759178883],
            [-7.5399334894636745, 6.251985628278889],
            [-7.543439833191036, 6.251703286046846],
            [-7.547467097065451, 6.25412070816331],
            [-7.544018956067498, 6.2586123315044055],
            [-7.546399202609953, 6.262402363076969],
            [-7.553627325616756, 6.263882717008942],
            [-7.561931962558443, 6.264129631730138],
            [-7.563997571769799, 6.269090464762618],
            [-7.559241325949503, 6.281060678523299],
            [-7.562288469322258, 6.288647830902491],
            [-7.55742032300878, 6.289170686972857],
            [-7.555699228307977, 6.295359362290849],
            [-7.556074102942345, 6.300701788483475],
            [-7.552445659648868, 6.304781118079913],
            [-7.556906229884866, 6.311042864474877],
            [-7.56333109984552, 6.314230662076257],
            [-7.565576406427435, 6.321463007182593],
            [-7.572996633324244, 6.3302793367186805],
            [-7.569259322163033, 6.335362769368831],
            [-7.569869539372214, 6.33948931993341],
            [-7.573629812977281, 6.342784614181193],
            [-7.572826017962527, 6.350452409579357],
            [-7.5764344054427655, 6.34758282481217],
            [-7.589603858683744, 6.350832283842172],
            [-7.590501975167285, 6.354008935098504],
            [-7.593742251079481, 6.356224868905127],
            [-7.593139680129916, 6.359404021480101],
            [-7.596291808388311, 6.36453146257336],
            [-7.600311784214734, 6.366913067011443],
            [-7.5986769805570855, 6.369620563849646]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.5846772918881, "lat": 44.03880522314175 },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56019"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01609191"
      },
      "bbox": [
        -7.600311784214734, 5.204945186338922, -6.637689046250195,
        6.369620563849646
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -170.659360957618, "lat": -14.27444850350063 },
        "year": "2023",
        "ste_code": ["60"],
        "ste_name": ["American Samoa"],
        "coty_code": ["60010"],
        "coty_name": ["Eastern"],
        "coty_area_code": "ASM",
        "coty_type": "district",
        "coty_name_long": ["Eastern District"],
        "coty_fp_code": "010",
        "coty_gnis_code": "01805240"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": 145.62688882057316,
          "lat": 15.003247461289911
        },
        "year": "2023",
        "ste_code": ["69"],
        "ste_name": ["Commonwealth of the Northern Mariana Islands"],
        "coty_code": ["69120"],
        "coty_name": ["Tinian"],
        "coty_area_code": "MNP",
        "coty_type": "municipality",
        "coty_name_long": ["Tinian Municipality"],
        "coty_fp_code": "120",
        "coty_gnis_code": "01805248"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.151025926844845, -6.6224355445674155],
            [8.154125956776676, -6.648153117535585],
            [8.15633801636304, -6.671704146762956],
            [8.1568009035123, -6.6798671182696765],
            [8.156435887368366, -6.690112824019393],
            [8.162105057135761, -6.7420408195812085],
            [8.165791205783329, -6.7469009478379975],
            [8.166171528643503, -6.750614477713714],
            [8.170938362012587, -6.7565212816289915],
            [8.174456348861188, -6.757748396314213],
            [8.174279476439816, -6.761599090393195],
            [8.17782753597487, -6.7659677304632035],
            [8.177606088980134, -6.768881935777049],
            [8.180650230311857, -6.774193017121258],
            [8.181481149846928, -6.780678930999086],
            [8.185158737563839, -6.781913366544964],
            [8.188867989425203, -6.785600778692904],
            [8.187594519851078, -6.789899506344438],
            [8.194283334838806, -6.793693493497709],
            [8.19581522937697, -6.802016960860369],
            [8.199620519492482, -6.805002400440745],
            [8.202224752678173, -6.812887305754125],
            [8.204344127697407, -6.824354862713102],
            [8.208968048603102, -6.826185693054047],
            [8.216919952380232, -6.833315971457273],
            [8.219583523622997, -6.834413679464621],
            [8.22459923724126, -6.83319643736016],
            [8.230246186141116, -6.843120397252466],
            [8.244889644910955, -6.841515859038754],
            [8.259541574861577, -6.841656522090115],
            [8.299678591079283, -6.837934591047749],
            [8.307939484090346, -6.836693186672527],
            [8.345685358092599, -6.833214076377936],
            [8.354529168300239, -6.919788433454939],
            [8.376842820953147, -6.917695298736814],
            [8.379760347680156, -6.919728322931928],
            [8.377828033271786, -6.924185929647035],
            [8.379537981093327, -6.9290174758760745],
            [8.386615375313664, -6.934547689817405],
            [8.383971035097517, -6.939648552445742],
            [8.386254444439027, -6.945414905348805],
            [8.390966708912334, -6.950117454195986],
            [8.388128147842474, -6.953722253561666],
            [8.388854980991026, -6.961062188868551],
            [8.380996671817469, -6.964447451919723],
            [8.381659556000228, -6.968624664371568],
            [8.385906694776558, -6.9709397863369915],
            [8.389201226129352, -6.979524894945124],
            [8.389741181249233, -6.984061239561719],
            [8.384628163378375, -6.990984025271423],
            [8.380308928447532, -6.99232290147051],
            [8.381340845360924, -6.996282438202757],
            [8.377730217041325, -7.001515026920058],
            [8.374911816608927, -7.001681956462068],
            [8.372822271099153, -7.005954930823452],
            [8.368642737308917, -7.007798917095848],
            [8.364723743586644, -7.007455141972961],
            [8.362146242532162, -7.010405892832735],
            [8.36575802261083, -7.0148777117520895],
            [8.363892177668511, -7.018127419056101],
            [8.366466985309106, -7.039736379035614],
            [8.379287492183861, -7.16201012117918],
            [8.37362318104601, -7.15992661300025],
            [8.37320009044797, -7.164502458322792],
            [8.36229535894419, -7.164615596758688],
            [8.365812769950551, -7.169084336632379],
            [8.362559836490336, -7.172397478754901],
            [8.354723589447717, -7.1710059113644755],
            [8.350187843144857, -7.17160816048146],
            [8.346417703367402, -7.162773925285681],
            [8.342219456689856, -7.163005940947879],
            [8.339856357689591, -7.165382676007759],
            [8.331351629471204, -7.165723222944755],
            [8.328428116718158, -7.171543797346439],
            [8.32671789804968, -7.178199989055221],
            [8.323602104253625, -7.176864888301013],
            [8.3268362587266, -7.172342982620535],
            [8.326787645393178, -7.167446270410087],
            [8.323680403012402, -7.166996585399655],
            [8.32186134041528, -7.163179263608889],
            [8.317021120395813, -7.158021322344369],
            [8.322658263877802, -7.152702735628314],
            [8.316140777676148, -7.149689495175615],
            [8.322792122206586, -7.138776444888975],
            [8.31722259297501, -7.1303652173189755],
            [8.316739134738945, -7.122956552882867],
            [8.313034812637213, -7.118045088304927],
            [8.313863015102761, -7.113855000364102],
            [8.312529053988037, -7.110022898396689],
            [8.316632540382464, -7.106424499281118],
            [8.31853242170605, -7.098798607504388],
            [8.248962120294129, -7.104803144021025],
            [8.18409090196432, -7.1112003264695645],
            [8.118450878376343, -7.118159714498633],
            [8.08747128465735, -7.120796370588112],
            [8.024632659360464, -7.127049949255144],
            [7.926911763084491, -7.136382294665232],
            [7.808682026441202, -7.147431307428111],
            [7.80837600415951, -7.147246997050537],
            [7.755936208791628, -7.152159878428747],
            [7.7557899085491755, -7.148199776108652],
            [7.760076051131456, -7.135857876809456],
            [7.762778443112591, -7.131971566401189],
            [7.77325349001734, -7.121626465064631],
            [7.774981718808121, -7.11704713810731],
            [7.781317808062368, -7.109414645612285],
            [7.785014256183399, -7.107901481394277],
            [7.789022943808571, -7.103181890571416],
            [7.799381611769391, -7.094980347533766],
            [7.807935512059404, -7.090367709718327],
            [7.810791568706867, -7.076608529148401],
            [7.814791350645834, -7.069735243894424],
            [7.81649251186717, -7.064206055627757],
            [7.816752935938243, -7.056569709279739],
            [7.823240015633462, -7.054673297130508],
            [7.828087831217458, -7.05077953323313],
            [7.833238166621586, -7.040434893052205],
            [7.837550515046482, -7.027310496110636],
            [7.84461158388263, -7.020422742400008],
            [7.847143008491498, -7.013510425027135],
            [7.849233542561279, -7.011339163409875],
            [7.853904878073896, -7.002386477485814],
            [7.8629673315588, -6.994828448510897],
            [7.870920739595788, -6.9917618884454855],
            [7.873739021498228, -6.98808839507692],
            [7.875960719852845, -6.980961179406992],
            [7.895237918560238, -6.961177029114108],
            [7.898965109278179, -6.954566600351656],
            [7.902643232036335, -6.95130181691952],
            [7.905936764487872, -6.945168885619271],
            [7.909573459128169, -6.943626779127567],
            [7.9233664836351325, -6.939978957989867],
            [7.925576190977059, -6.937663708535903],
            [7.927378192164916, -6.931728840258429],
            [7.931553129008564, -6.924129731327398],
            [7.930420460614869, -6.918489005814875],
            [7.933598755051646, -6.911637828091443],
            [7.938171976283345, -6.907391178175695],
            [7.941854833285259, -6.897426647990235],
            [7.953845323413903, -6.8732205766391585],
            [7.950679822218214, -6.859865009428748],
            [7.951824045353166, -6.850422103293611],
            [7.955502875898179, -6.846732463987648],
            [7.956086860792717, -6.843575582907376],
            [7.954258551988085, -6.834874854700478],
            [7.955201852339196, -6.828068913564883],
            [7.957998262074554, -6.8175083008840245],
            [7.959752171548973, -6.813513583007308],
            [7.964896278125622, -6.806114036716488],
            [7.967006154289804, -6.792585400336548],
            [7.966750750019488, -6.785737119579198],
            [7.968871714467317, -6.778427652756356],
            [7.966111526389216, -6.7676572249857045],
            [7.968239087736625, -6.750471951985567],
            [7.974473173009846, -6.748200855617243],
            [7.979916871173917, -6.747455149112495],
            [7.984670046426576, -6.742813853722036],
            [7.992962710541873, -6.738793880800816],
            [8.004198304501973, -6.737260918848081],
            [8.01038847549362, -6.730202671808514],
            [8.01364432892478, -6.722536520682339],
            [8.020176363901312, -6.718358207075646],
            [8.024957817353473, -6.717722268160188],
            [8.031682974797324, -6.709476422683012],
            [8.029074960351336, -6.7048529247636806],
            [8.025477800806797, -6.694507088802626],
            [8.024892434335793, -6.68264527547137],
            [8.028626029945283, -6.676449048839322],
            [8.031928903905216, -6.668467239380631],
            [8.037575556942604, -6.669767045010917],
            [8.055208233498591, -6.672072953743102],
            [8.059023103989448, -6.670055639232784],
            [8.065066156626017, -6.670258132827655],
            [8.071577320911484, -6.668226618851619],
            [8.078852082790256, -6.662689444933038],
            [8.083999769695435, -6.663343759764521],
            [8.08911673033337, -6.659226780703174],
            [8.091221536516473, -6.655028458238621],
            [8.101991568692704, -6.649718335915312],
            [8.106465392835183, -6.649276544050245],
            [8.111179020114202, -6.646868600497541],
            [8.111912864663385, -6.64473257396916],
            [8.116718381497682, -6.643770673614157],
            [8.117443631132776, -6.639327344582253],
            [8.125100018705341, -6.634478339669873],
            [8.12831599269558, -6.631396603294844],
            [8.141201952788208, -6.627132022494756],
            [8.146330314843665, -6.623156690567039],
            [8.151025926844845, -6.6224355445674155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.99364043548422,
          "lat": 31.429214056954905
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01035"],
        "coty_name": ["Conecuh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Conecuh County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00161543"
      },
      "bbox": [
        7.7557899085491755, -7.178199989055221, 8.390966708912334,
        -6.6224355445674155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.597473712862092, -7.182144950044523],
            [7.60384557181704, -7.185009957104011],
            [7.608598408937024, -7.18280324564775],
            [7.611820547762982, -7.184901892600791],
            [7.6173209528081856, -7.184667983007335],
            [7.627596781425986, -7.1878152942206555],
            [7.628444374108661, -7.190145470237871],
            [7.633715975010657, -7.190665301528944],
            [7.637185435157347, -7.192466277298864],
            [7.647036791500675, -7.19493996764011],
            [7.651296307834091, -7.192318615365428],
            [7.655529153313521, -7.191440561139046],
            [7.665885427038357, -7.183287978209598],
            [7.667433745011623, -7.178935500674393],
            [7.670550163345396, -7.177560710114626],
            [7.675984757559999, -7.171765686636254],
            [7.679535930558795, -7.172437169113545],
            [7.68888209961743, -7.169800574016545],
            [7.701022603522011, -7.162128526121152],
            [7.703576810180938, -7.157151372670471],
            [7.755936208791628, -7.152159878428747],
            [7.80837600415951, -7.147246997050537],
            [7.808682026441202, -7.147431307428111],
            [7.926911763084491, -7.136382294665232],
            [8.024632659360464, -7.127049949255144],
            [8.08747128465735, -7.120796370588112],
            [8.118450878376343, -7.118159714498633],
            [8.18409090196432, -7.1112003264695645],
            [8.248962120294129, -7.104803144021025],
            [8.31853242170605, -7.098798607504388],
            [8.316632540382464, -7.106424499281118],
            [8.312529053988037, -7.110022898396689],
            [8.313863015102761, -7.113855000364102],
            [8.313034812637213, -7.118045088304927],
            [8.316739134738945, -7.122956552882867],
            [8.31722259297501, -7.1303652173189755],
            [8.322792122206586, -7.138776444888975],
            [8.316140777676148, -7.149689495175615],
            [8.322658263877802, -7.152702735628314],
            [8.317021120395813, -7.158021322344369],
            [8.32186134041528, -7.163179263608889],
            [8.323680403012402, -7.166996585399655],
            [8.326787645393178, -7.167446270410087],
            [8.3268362587266, -7.172342982620535],
            [8.323602104253625, -7.176864888301013],
            [8.32671789804968, -7.178199989055221],
            [8.328428116718158, -7.171543797346439],
            [8.331351629471204, -7.165723222944755],
            [8.339856357689591, -7.165382676007759],
            [8.342219456689856, -7.163005940947879],
            [8.346417703367402, -7.162773925285681],
            [8.350187843144857, -7.17160816048146],
            [8.354723589447717, -7.1710059113644755],
            [8.362559836490336, -7.172397478754901],
            [8.365812769950551, -7.169084336632379],
            [8.36229535894419, -7.164615596758688],
            [8.37320009044797, -7.164502458322792],
            [8.37362318104601, -7.15992661300025],
            [8.379287492183861, -7.16201012117918],
            [8.38572340269807, -7.228445499207146],
            [8.385683460411487, -7.230684615497383],
            [8.398137989139054, -7.351971501111843],
            [8.408023736386717, -7.351009477172126],
            [8.40883552890311, -7.356748903849944],
            [8.393560016867854, -7.358129663186751],
            [8.377087609333861, -7.357562539351559],
            [8.360252093541918, -7.359777029390599],
            [8.325778534850144, -7.362425557494656],
            [8.251460452325647, -7.3689029743542465],
            [8.204819447568024, -7.373272173876737],
            [8.144611343146792, -7.378010330233334],
            [8.13954522613648, -7.377832940148493],
            [8.12019834453158, -7.379712988748212],
            [8.109206891047792, -7.380405671128968],
            [8.097554235642116, -7.381960111549941],
            [8.042108674186016, -7.386836394655266],
            [8.03698047513656, -7.387937266093508],
            [8.02348088340449, -7.3884605690430405],
            [8.004050282439408, -7.390767464595101],
            [7.952233249004651, -7.3973948598451456],
            [7.941294543861605, -7.399173710197057],
            [7.926402740310412, -7.398647711185643],
            [7.877710656814275, -7.402938669156148],
            [7.7810709145684465, -7.412009989948003],
            [7.753056466941775, -7.414222505191633],
            [7.701325790313954, -7.4196273512133715],
            [7.676591441206257, -7.42147736923788],
            [7.633744631506997, -7.425723422836608],
            [7.619705007439662, -7.4270518570130175],
            [7.618672093564691, -7.414327016040168],
            [7.6135139092687805, -7.3588955194489865],
            [7.613084297849473, -7.356250389549243],
            [7.597473712862092, -7.182144950044523]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.16158187503181, "lat": 31.12613355037151 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01053"],
        "coty_name": ["Escambia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Escambia County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00161552"
      },
      "bbox": [
        7.597473712862092, -7.4270518570130175, 8.40883552890311,
        -7.098798607504388
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.871818122600952, -4.00994521157489],
            [6.875240453738197, -3.890087699345058],
            [6.891466144935875, -3.888981361070349],
            [6.917508030173844, -3.888349064188757],
            [7.011785250349392, -3.8844558414294887],
            [7.1117768448579195, -3.8784952239604156],
            [7.206856406315539, -3.8721632533465913],
            [7.284864696996029, -3.8677980472829745],
            [7.293695363048799, -3.866915350642939],
            [7.317488132010929, -3.8658762820664787],
            [7.373127133029291, -3.862068977178835],
            [7.379127593726022, -3.93096210898594],
            [7.38115401774318, -3.958546150954173],
            [7.381556206616485, -3.960277215615485],
            [7.3840327465060955, -3.9932095926311995],
            [7.396631508196834, -4.124973631758633],
            [7.361007662985982, -4.127390514063087],
            [7.310697838177671, -4.130163571627537],
            [7.262875986755708, -4.132287002968546],
            [7.231907495160061, -4.133838977545258],
            [7.186514371481329, -4.137039082156609],
            [7.1560471107811425, -4.139571882985405],
            [7.107499252613398, -4.142762837668579],
            [7.059352200956424, -4.145566550626909],
            [6.988794211744726, -4.149134331901015],
            [6.869470260706748, -4.153557644481408],
            [6.8708522708188475, -4.09085227765162],
            [6.871818122600952, -4.00994521157489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.84374613210444, "lat": 34.44168284238212 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01059"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00161555"
      },
      "bbox": [
        6.869470260706748, -4.153557644481408, 7.396631508196834,
        -3.862068977178835
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.498441342620575, -3.7873181454712674],
              [8.498818103377419, -3.7907985392558645],
              [8.495182072676412, -3.791274926001415],
              [8.4948328703597, -3.7875449061352597],
              [8.498441342620575, -3.7873181454712674]
            ]
          ],
          [
            [
              [8.32025238500137, -3.3428329973846953],
              [8.448295736297805, -3.330623626587444],
              [8.517727473593075, -3.3239131287858488],
              [8.681941860440702, -3.307790181655701],
              [8.713891088651017, -3.3046089321068535],
              [8.818818152952362, -3.295352935267705],
              [8.891330600248326, -3.2888721062213198],
              [8.899623034607721, -3.321299536337922],
              [8.900865599071697, -3.328102427563287],
              [8.906074334039607, -3.3485415105036713],
              [8.922824102440405, -3.4113177820526173],
              [8.920604556269458, -3.4117306838652093],
              [8.915160284908637, -3.4182435702306977],
              [8.908434950427104, -3.422021366739104],
              [8.909887397668848, -3.426314850185607],
              [8.904590399960469, -3.432718305035689],
              [8.90097346615102, -3.434159603490173],
              [8.8976769750127, -3.4405528519398496],
              [8.890427679809186, -3.4437217173017016],
              [8.886763145905707, -3.4632775242688627],
              [8.888213040651676, -3.4772785742344663],
              [8.8837289502152, -3.4924581005194955],
              [8.879680028160168, -3.5010911898478048],
              [8.87204133250842, -3.5236079914575025],
              [8.862463478007838, -3.5348240232936194],
              [8.846610826860722, -3.5372215229819775],
              [8.807157115074551, -3.619978016162885],
              [8.800628282302002, -3.6339020264085016],
              [8.78466547912036, -3.6650446801620227],
              [8.700121133046407, -3.749076384937183],
              [8.691065038593644, -3.7571438078568646],
              [8.684706714189758, -3.764296114732248],
              [8.671010057495936, -3.7775886386561925],
              [8.65800242480931, -3.797406282552249],
              [8.65438959120913, -3.805243422150378],
              [8.647816828849495, -3.8088737108276502],
              [8.645181318884681, -3.81339232512721],
              [8.637306398225384, -3.8163357678999836],
              [8.638331677338133, -3.8197717088087746],
              [8.633855587077935, -3.8204543779696047],
              [8.622740951612954, -3.8285340015098557],
              [8.607844945478206, -3.8285712863267656],
              [8.605178581807793, -3.834959321658865],
              [8.598221909465165, -3.8377957583056452],
              [8.594118747964682, -3.8346846900136162],
              [8.587743841165164, -3.8356063084625918],
              [8.582327254147781, -3.8376881156557907],
              [8.579355774310239, -3.8371741962606674],
              [8.573974133467605, -3.841631373836483],
              [8.569934855191267, -3.8434446551859773],
              [8.56679443547832, -3.847890174849434],
              [8.560191340351494, -3.8508305389241153],
              [8.556015153042742, -3.849158267037774],
              [8.553795564412361, -3.845119386960076],
              [8.554933966610093, -3.837645331520554],
              [8.553545227266197, -3.8329734812657112],
              [8.546754236646382, -3.8276943640338286],
              [8.54506482333094, -3.82258747489856],
              [8.542565736929028, -3.8195734867040443],
              [8.543985755262193, -3.8168949852361997],
              [8.542119906557975, -3.8125254259172645],
              [8.538165603584241, -3.8105469783516357],
              [8.54313808057251, -3.802720245087765],
              [8.540256269789195, -3.7952636044062156],
              [8.536973589796055, -3.7983407281745407],
              [8.532042851731024, -3.7971060164008863],
              [8.530947198326768, -3.7949911125291145],
              [8.532965296495696, -3.790869794259076],
              [8.528201690301998, -3.788541336574757],
              [8.523976058582978, -3.793932073543871],
              [8.520435648536543, -3.791324107815396],
              [8.517517418634986, -3.785672761375064],
              [8.514703974024645, -3.7897125346648544],
              [8.507946883889147, -3.7954666149442593],
              [8.503279497648716, -3.800592402984718],
              [8.501428837702806, -3.799881414496202],
              [8.50657164152654, -3.7868147465632327],
              [8.498441342620575, -3.7873181454712674],
              [8.50299170706465, -3.7862126423923304],
              [8.502970836451244, -3.7792232147143614],
              [8.49242765446408, -3.7711847585564464],
              [8.49706383194287, -3.771163888267131],
              [8.492706340327402, -3.72172988502172],
              [8.420683581187191, -3.728207510221853],
              [8.394613661753805, -3.730848357985237],
              [8.347672512503792, -3.735965140761715],
              [8.347792725713957, -3.736297736957914],
              [8.344021671880643, -3.7331374204818313],
              [8.343910487012042, -3.7277029477679497],
              [8.34755192284351, -3.7260232673965565],
              [8.318263672499095, -3.705719931416741],
              [8.308546353504315, -3.60311327328201],
              [8.316006317771286, -3.5966944125626976],
              [8.31948261687857, -3.5911342872958008],
              [8.319374894491837, -3.5867843662971666],
              [8.321616538553878, -3.5834081823969957],
              [8.322113391116801, -3.573404501516802],
              [8.320336492476692, -3.5711706854331102],
              [8.31803206367359, -3.562642605866542],
              [8.317130155303207, -3.555882611155194],
              [8.31937796236705, -3.5491165314720856],
              [8.32266719215531, -3.5481290526361207],
              [8.321343251790752, -3.5426906229216053],
              [8.317229726305227, -3.5422343724627874],
              [8.31547498140889, -3.536132513778846],
              [8.311212107796448, -3.5327987890139187],
              [8.312354131900166, -3.530757365906659],
              [8.311413406134665, -3.524391399258114],
              [8.311979022566998, -3.519785224245033],
              [8.31760481404907, -3.5178507675489814],
              [8.318184902325926, -3.5129505809494783],
              [8.324282388231522, -3.5040997447768367],
              [8.320383459798979, -3.5032668140228185],
              [8.314417687921946, -3.4991414720850105],
              [8.315661902172724, -3.497546712786644],
              [8.316473602886967, -3.490209656866535],
              [8.313766657236965, -3.4848234203357067],
              [8.305050930284706, -3.479383809460444],
              [8.305470236149882, -3.4693051390330374],
              [8.299910026128023, -3.4637451984861154],
              [8.30336739710695, -3.4609409137696225],
              [8.308416089552635, -3.4480806327664864],
              [8.307940723870315, -3.4416844864889367],
              [8.313582527690874, -3.43694291313432],
              [8.31476895638074, -3.4341637753875283],
              [8.323278917663036, -3.4325583025062354],
              [8.328054330762162, -3.419256894155572],
              [8.323109296537861, -3.411507281682628],
              [8.317984276801873, -3.409119810337759],
              [8.317892393493494, -3.4066812751018585],
              [8.313691663791738, -3.3981477472924726],
              [8.31893128689059, -3.398246851641736],
              [8.322086725387912, -3.396513148938094],
              [8.326233118649252, -3.3992998300914463],
              [8.333936973016927, -3.3902730617372923],
              [8.33954506017159, -3.3874690561085443],
              [8.343900572280644, -3.392510502171081],
              [8.35079237113232, -3.392179220508386],
              [8.351694151722157, -3.3975011324032307],
              [8.356949914347304, -3.400969071892209],
              [8.358701334304753, -3.4067047020680827],
              [8.363941984248804, -3.407865359844761],
              [8.370826616714329, -3.403046879909308],
              [8.371487978683394, -3.40020195167085],
              [8.368063145086067, -3.393493661861967],
              [8.368783399231065, -3.3897854507971594],
              [8.365531952418372, -3.384406219369788],
              [8.360262336157698, -3.383346903911737],
              [8.353691241425294, -3.377408972195403],
              [8.34995807478419, -3.3781356468392887],
              [8.343261034275983, -3.374243006950202],
              [8.33987658804296, -3.363417317288389],
              [8.335720025349152, -3.3654791121897336],
              [8.3271157009447, -3.3614067855195606],
              [8.325919576261045, -3.358630467123827],
              [8.320418256498673, -3.3582480996791695],
              [8.323057412231869, -3.3535346281822966],
              [8.322891794296917, -3.348835290701382],
              [8.32025238500137, -3.3428329973846953]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.99935238948197,
          "lat": 34.779461960018246
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01071"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00161561"
      },
      "bbox": [
        8.299910026128023, -3.8508305389241153, 8.922824102440405,
        -3.2888721062213198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.727740032267581, -6.087006651842809],
            [-11.714515567583183, -6.001222159828273],
            [-11.713524657841685, -6.001389341605839],
            [-11.700043364250348, -5.915476275365313],
            [-11.688087388740197, -5.834132528690344],
            [-11.674075987129603, -5.742906060061761],
            [-11.672718779202118, -5.743071501125224],
            [-11.66261857650726, -5.686047098123135],
            [-11.644361189691086, -5.571285411833718],
            [-11.647096480814417, -5.570880461617987],
            [-11.633799113533623, -5.484679326906283],
            [-11.62066649828378, -5.398956412511837],
            [-11.535996018929032, -5.411724095967555],
            [-11.536169134027727, -5.412973653596971],
            [-11.45504336868537, -5.425006099231389],
            [-11.353253364027275, -5.440081451089706],
            [-11.233443706916761, -5.457589702079393],
            [-11.113631399885177, -5.475079206674731],
            [-11.032122817646629, -5.486954821082334],
            [-11.030439016614832, -5.487425405778816],
            [-10.966646486750292, -5.496836694523423],
            [-10.774500189935043, -5.523381117902358],
            [-10.690006360917298, -5.537081457153105],
            [-10.605052290813704, -5.550038919546788],
            [-10.604821773520072, -5.548461263985371],
            [-10.510405696037662, -5.561562774740874],
            [-10.455048555995198, -5.569169690661018],
            [-10.502006815751734, -5.903245432892877],
            [-10.510759701462709, -5.963532263826649],
            [-10.512646633103333, -5.977925085494186],
            [-10.53228315507816, -6.119318078570261],
            [-10.536437979075208, -6.146048537701186],
            [-10.54067915267863, -6.178675428631573],
            [-10.542996838987232, -6.192697687922464],
            [-10.564914322712212, -6.3508905289586925],
            [-10.58434085126631, -6.486290055569662],
            [-10.587326643077576, -6.505540479952775],
            [-10.607484207250137, -6.651259223088225],
            [-10.703660332388198, -6.637216677638208],
            [-10.799834093784236, -6.623158705193909],
            [-10.887695512436906, -6.610773603712966],
            [-10.975555134487172, -6.598375646751808],
            [-11.110433912936417, -6.5790868024674545],
            [-11.264139712445743, -6.556823584499331],
            [-11.337714896601428, -6.546552273341085],
            [-11.408179367507202, -6.536650825784789],
            [-11.52581352020814, -6.518394532913985],
            [-11.638385660363575, -6.502029765333092],
            [-11.79459315291056, -6.479054471297993],
            [-11.784525991578404, -6.412933453645621],
            [-11.773892218431488, -6.3439301125333865],
            [-11.77473031244618, -6.343802394397809],
            [-11.7615208804331, -6.258887991413416],
            [-11.752674378024118, -6.201734697591651],
            [-11.745536788702406, -6.202768872137851],
            [-11.727740032267581, -6.087006651842809]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.75117469245517,
          "lat": 31.87956965231651
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04003"],
        "coty_name": ["Cochise"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cochise County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00025442"
      },
      "bbox": [
        -11.79459315291056, -6.651259223088225, -10.455048555995198,
        -5.398956412511837
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9684345008596584, -2.1829633311674224],
            [2.9806775277727535, -2.182460100860655],
            [3.033443277537629, -2.1809970735778603],
            [3.146192081376006, -2.176763704078592],
            [3.1990308015116278, -2.1747218819312706],
            [3.2269552491878133, -2.1733352280748015],
            [3.228161469000533, -2.2134597484641096],
            [3.2274590687411466, -2.25715278291315],
            [3.2274176479898804, -2.277599828873448],
            [3.2279179739375743, -2.2864052356961815],
            [3.2147995436882106, -2.2865160638607542],
            [3.2137467012449674, -2.292087384080074],
            [3.2116524846787056, -2.29518421223849],
            [3.205028061940483, -2.3008187890815583],
            [3.2014533414294815, -2.3024568583779326],
            [3.195153633099528, -2.3080363623069493],
            [3.1834116532421186, -2.3146503697276106],
            [3.1795809041082252, -2.3191063474164126],
            [3.181478124175833, -2.324567172188081],
            [3.1874904488340894, -2.329819710126125],
            [3.191610047671222, -2.332048486544705],
            [3.2062868789347965, -2.3283259130813736],
            [3.2144294672002456, -2.325009271915676],
            [3.2194562832763993, -2.324614849492959],
            [3.2271971533267463, -2.3224125239871896],
            [3.2321950950771297, -2.324661639242412],
            [3.233547528721057, -2.3282608450552855],
            [3.23065040591116, -2.341715297638604],
            [3.226826952332375, -2.3445453548679347],
            [3.2229051480870736, -2.3433679692300458],
            [3.216822052575701, -2.338378128618062],
            [3.2122784953664594, -2.337503340495331],
            [3.207400835995339, -2.3392614261606757],
            [3.200524256001817, -2.3501503653671874],
            [3.199631273122181, -2.35633995420103],
            [3.1970185990367668, -2.365238644679839],
            [3.1985839047736992, -2.3683925948281463],
            [3.202807622630248, -2.3683088987467853],
            [3.2160774125855776, -2.3603907385075162],
            [3.2244292891448563, -2.362203735426315],
            [3.2368414758235406, -2.3712673188640183],
            [3.2389370992776914, -2.3771805249550657],
            [3.2385832472765617, -2.383532414543613],
            [3.2353437308071937, -2.391261267275842],
            [3.231880812945944, -2.394862316902853],
            [3.2241869972875237, -2.405012384324513],
            [3.2243834253786843, -2.410976594716215],
            [3.2283521677185516, -2.411593134240683],
            [3.2324710432177044, -2.409883876861876],
            [3.237178060663946, -2.405663227878299],
            [3.242190958814919, -2.4047210468108635],
            [3.2537902238089567, -2.409178233526461],
            [3.259699037490454, -2.4146013034703246],
            [3.263807666571267, -2.4165429925120043],
            [3.2704356928268763, -2.416437592409413],
            [3.2774731040382243, -2.414998430474038],
            [3.2820679941912534, -2.416242947339728],
            [3.2838820939909716, -2.4212559161291867],
            [3.2790075537036194, -2.4302520289850493],
            [3.278938571921124, -2.444353761423111],
            [3.2840265849543866, -2.4499293991119546],
            [3.292501941247078, -2.4520544814301224],
            [3.2929909721066033, -2.457252616135258],
            [3.287217993271685, -2.4621841118667076],
            [3.2815519687918355, -2.4656862427352406],
            [3.2769629070680533, -2.4730039464254463],
            [3.278117694113171, -2.4792248286246785],
            [3.286859101618751, -2.4912805055732705],
            [3.294542714931462, -2.4951825890946333],
            [3.303258114323775, -2.501698314963263],
            [3.308629489818483, -2.507641948099618],
            [3.3105870551487504, -2.5076786756033376],
            [3.316121995021734, -2.5034015331892148],
            [3.321294534934263, -2.509092419370861],
            [3.3288974551739847, -2.508043443066871],
            [3.3330882241049733, -2.5089470028705962],
            [3.3366438430460144, -2.5132629120025487],
            [3.3361121530385507, -2.521762447730643],
            [3.3219529721641994, -2.522200018935247],
            [3.3221950483388634, -2.5369224141004585],
            [3.336311059967612, -2.5365834066792403],
            [3.337115235483447, -2.6091200720558065],
            [3.279788776625971, -2.6099722131959076],
            [3.251162901420208, -2.6105885768886643],
            [3.1679101563380487, -2.6120771320440195],
            [3.1587921175450564, -2.612443757862029],
            [3.1250107500103406, -2.6128307683781804],
            [2.9956840216848466, -2.613804410893347],
            [2.9949465577052354, -2.56977268454929],
            [2.951882702251577, -2.570738773014704],
            [2.950765988652188, -2.50765569695861],
            [2.9487881428575595, -2.4322230256565804],
            [2.9461050622682565, -2.364879372915734],
            [2.9467348811184144, -2.347621879214345],
            [2.945374563518525, -2.2763154211736127],
            [2.9449978952279063, -2.2627132576101223],
            [2.9440871139633913, -2.1909602488833992],
            [2.9487149803042767, -2.1964636848053423],
            [2.9497993553335817, -2.2001423539300307],
            [2.9544696651964717, -2.20654230157328],
            [2.962179241549858, -2.2077608946573233],
            [2.9659522938366045, -2.2108943517859636],
            [2.9690758762035676, -2.2165965849950995],
            [2.9684345008596584, -2.1829633311674224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.6842861637244, "lat": 36.2684722930062 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05089"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00069898"
      },
      "bbox": [
        2.9440871139633913, -2.613804410893347, 3.337115235483447,
        -2.1733352280748015
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-19.926603596889834, 2.00544031442288],
              [-19.92696289709469, 2.0030697477035857],
              [-19.928094956592275, 1.9990101456715104],
              [-19.931065839424186, 1.997752162970026],
              [-19.936435477440618, 2.0004856661552948],
              [-19.939906783754772, 1.9993896702583807],
              [-19.945074527808337, 2.003557717125411],
              [-19.945725968540472, 2.009173105168503],
              [-19.942462963201645, 2.009418230191224],
              [-19.931413968452176, 2.016308255908672],
              [-19.927038436038476, 2.0121025457754667],
              [-19.926603596889834, 2.00544031442288]
            ]
          ],
          [
            [
              [-20.241738050405328, 2.5507210988471436],
              [-20.233539013436857, 2.5529229093265715],
              [-20.232685612200246, 2.5590961153151257],
              [-20.22969286394989, 2.5578713714781487],
              [-20.22418912606239, 2.5587552833918945],
              [-20.22148046385436, 2.561025849378413],
              [-20.2122081033118, 2.5579697090886397],
              [-20.208281454993305, 2.5633114333757083],
              [-20.204797224593317, 2.5618447337773813],
              [-20.201160576967713, 2.5576270491855095],
              [-20.195460095857833, 2.5535244522656493],
              [-20.1907537107584, 2.551828959170952],
              [-20.17927424352949, 2.550419466711563],
              [-20.177373830027907, 2.5454875506131724],
              [-20.17239986822249, 2.5489184960921847],
              [-20.174622647810235, 2.5533745013512945],
              [-20.170018264388816, 2.555630048009179],
              [-20.166202470822682, 2.555520999166853],
              [-20.167101973261783, 2.551218494898304],
              [-20.165799858041435, 2.5481346416101354],
              [-20.16024915291722, 2.5493088804124513],
              [-20.145178227275974, 2.5251234319276192],
              [-20.11037263702458, 2.4709562914827106],
              [-20.104296189035765, 2.461071430548823],
              [-20.070307399160896, 2.4077896323276926],
              [-20.057637818533482, 2.4042521713707385],
              [-20.05273292298575, 2.398915747084866],
              [-20.05282133783424, 2.3966561405656823],
              [-20.044343690085327, 2.388710710286731],
              [-20.035180601665967, 2.3847085927804788],
              [-20.030894980173695, 2.3782812323432485],
              [-20.02076665864716, 2.3753158753843358],
              [-20.01929606770908, 2.3715397991880853],
              [-20.015754280515267, 2.371015816615911],
              [-20.01228880408969, 2.367841787313086],
              [-20.009758204320015, 2.3631489054756343],
              [-20.001558927541254, 2.359868387609065],
              [-19.99901051048203, 2.3572477488947263],
              [-19.994634391535662, 2.3564472643008907],
              [-19.99157926663828, 2.359250969552686],
              [-19.983886319855266, 2.356996952171609],
              [-19.97562415323033, 2.353047596203073],
              [-19.97245753262618, 2.3567689031268855],
              [-19.965256983412292, 2.358388268742882],
              [-19.96494384261521, 2.3553768213980977],
              [-19.95940298275709, 2.3559709837021288],
              [-19.955931677267696, 2.350261457893868],
              [-19.948735494892603, 2.34918486635952],
              [-19.94650522304467, 2.3461235389196426],
              [-19.95046679367464, 2.341611184267716],
              [-19.948021815444534, 2.3390677263359776],
              [-19.949095037903753, 2.3347704014511907],
              [-19.942169070223162, 2.328506081748859],
              [-19.94716175146352, 2.3250625853741416],
              [-19.946858351776307, 2.322460511481298],
              [-19.941864766586665, 2.318627409217429],
              [-19.93722833513953, 2.318115377619685],
              [-19.93217265464538, 2.3062240365524755],
              [-19.926497447309913, 2.2997621387446854],
              [-19.923843392558364, 2.2950463288756144],
              [-19.921533935715665, 2.2863852595052383],
              [-19.922178469869806, 2.2790116083161513],
              [-19.921554665131858, 2.271673852079783],
              [-19.91862055721043, 2.264879063326349],
              [-19.916610260243758, 2.2631214823694488],
              [-19.910196159753976, 2.254801669738879],
              [-19.90986285244822, 2.2505848499217973],
              [-19.916322080816897, 2.2215445059317367],
              [-19.92697237891133, 2.2084463135594516],
              [-19.929686655947293, 2.2008751587050375],
              [-19.93909988886585, 2.186497773939403],
              [-19.94141921157834, 2.1737648397092872],
              [-19.940147214653663, 2.16893590715257],
              [-19.935053998362697, 2.166647060467132],
              [-19.93241920378703, 2.1588258143812076],
              [-19.919605811418673, 2.1506994609457895],
              [-19.91360716559269, 2.1372988857104835],
              [-19.91323538017681, 2.128960438148294],
              [-19.92108259375097, 2.126482430373108],
              [-19.926352799736023, 2.1296585927229326],
              [-19.927579202246786, 2.1334504456815075],
              [-19.932477042356293, 2.131707493918274],
              [-19.939246671797818, 2.1230203574944637],
              [-19.944930106668426, 2.123489414581028],
              [-19.95329542687544, 2.1258564196195313],
              [-19.954789288149094, 2.123334177176333],
              [-19.950958043174296, 2.1191293515118366],
              [-19.95250359247917, 2.1137321567061016],
              [-19.953075789973273, 2.101009278561787],
              [-19.94895099742166, 2.098289149047573],
              [-19.949031309932234, 2.0952503474478066],
              [-19.95505447386185, 2.09409841636105],
              [-19.95843768643534, 2.0917216506214875],
              [-19.96318482174234, 2.095529314786089],
              [-19.96368729715537, 2.098338196814113],
              [-19.968140196455206, 2.10099044312085],
              [-19.96991202419843, 2.094806620700964],
              [-19.97054276263415, 2.086945296200634],
              [-19.96532581583003, 2.0782393983447354],
              [-19.95991917243657, 2.0766932365517956],
              [-19.956030055922106, 2.0697799458878556],
              [-19.95319628771269, 2.069559858293174],
              [-19.95347081530821, 2.0611751594472],
              [-19.95739166852594, 2.0589495320387887],
              [-19.94878974642472, 2.0478300576492274],
              [-19.946746035379622, 2.0437311765812103],
              [-19.939304565652943, 2.040919723911518],
              [-19.93764736499391, 2.033427177132573],
              [-19.934762056745715, 2.0280339105082503],
              [-19.940368481965912, 2.025934492906403],
              [-19.946160048429043, 2.021104772974813],
              [-19.95389141680135, 2.024712931133509],
              [-19.956719592757004, 2.0200124443464],
              [-19.954578490529858, 2.0160620123710755],
              [-19.956229048375718, 2.0135231767376998],
              [-19.961457329200613, 2.0214731153579284],
              [-19.963406860348798, 2.028406829364768],
              [-19.959917250782006, 2.033564677356646],
              [-19.960115208111873, 2.0378502530759324],
              [-19.965098458223718, 2.044657267849527],
              [-19.969198319584212, 2.0518095209519975],
              [-19.972972072376727, 2.0510864686456807],
              [-19.981080157395112, 2.053601275479013],
              [-19.980518431408385, 2.0456904085454353],
              [-19.979299749575198, 2.0445555103906288],
              [-19.979902479027555, 2.0356562593567786],
              [-19.983825739675606, 2.033429999567433],
              [-19.98154926775831, 2.0292338216798482],
              [-19.98154996097469, 2.0245071290300514],
              [-19.976942613847555, 2.021022838278897],
              [-19.971278454527386, 2.014479335625084],
              [-19.97557552996934, 2.0031682319954323],
              [-19.972937938709645, 1.9911166514148508],
              [-19.97425744156284, 1.9874945064071712],
              [-19.978037648895416, 1.9889811994633797],
              [-19.98060089509034, 1.9820375268720176],
              [-19.989773639646334, 1.985372005609683],
              [-19.994395441899368, 1.9821569941858277],
              [-20.001510846563775, 1.9827934139325432],
              [-20.005415827313616, 1.988026149185988],
              [-20.012000525905393, 1.9905988504008731],
              [-20.014913669633724, 1.9905385852426902],
              [-20.022089345298944, 1.9854810995202403],
              [-20.023595487060277, 1.9923954718691361],
              [-20.02363122050266, 1.9988204044020634],
              [-20.03078608797918, 2.0070642126884457],
              [-20.03544083350826, 2.0192129081961583],
              [-20.03583833277887, 2.024891524077109],
              [-20.043798409145936, 2.031277139941047],
              [-20.044361636711464, 2.034588653884474],
              [-20.047219292724098, 2.0368220048355665],
              [-20.04966629007996, 2.034333426046975],
              [-20.059252205903622, 2.056075371745942],
              [-20.06783363991508, 2.062014541196898],
              [-20.0707974607159, 2.0616073222400906],
              [-20.07472848070597, 2.0667434605243393],
              [-20.08355330690398, 2.0865633991990205],
              [-20.094192275584895, 2.0972190440581935],
              [-20.108424170816825, 2.103277599497551],
              [-20.121277270945154, 2.101275730604745],
              [-20.13014571156528, 2.0961119739317966],
              [-20.135114111589374, 2.1002811779732813],
              [-20.13683009119176, 2.1050228370607544],
              [-20.142397442024684, 2.1075526517436916],
              [-20.145629906194703, 2.1119299071241584],
              [-20.145461881643648, 2.12826666079682],
              [-20.14689390207961, 2.1345624696799197],
              [-20.154310660508926, 2.1422258135429635],
              [-20.157460428220276, 2.147806241648044],
              [-20.165417426483856, 2.1527081681564235],
              [-20.165960344556616, 2.1567215184134967],
              [-20.170579811763844, 2.162908603505928],
              [-20.174871472281, 2.166472706236199],
              [-20.174507309547717, 2.1693403869765904],
              [-20.17579798668581, 2.1887161389338066],
              [-20.178013871370553, 2.1969582667554977],
              [-20.184094153493035, 2.2078607607716334],
              [-20.18618174089754, 2.208211070950862],
              [-20.19034510359964, 2.221623093870313],
              [-20.211092669346066, 2.248632730889619],
              [-20.227816567806027, 2.2624772787069025],
              [-20.244161295873056, 2.2704951137406653],
              [-20.257584280277023, 2.2747080989075936],
              [-20.26908365438704, 2.28144748206177],
              [-20.282790045243026, 2.282087619365831],
              [-20.296843180873793, 2.2772763998251784],
              [-20.3070289356854, 2.268548887288698],
              [-20.30900005692972, 2.2655897307042583],
              [-20.311284285367815, 2.2574778363567227],
              [-20.305428146311442, 2.2525017926170796],
              [-20.300820781745557, 2.250612553008236],
              [-20.298800939715967, 2.2459648181175753],
              [-20.305154235620687, 2.2480399566418496],
              [-20.3062160404026, 2.250769034952044],
              [-20.3150216581053, 2.252967158452348],
              [-20.31846048136894, 2.2564633023870972],
              [-20.32086342161334, 2.255823947103216],
              [-20.335672131599196, 2.260937707428503],
              [-20.342736836109513, 2.2639979972306086],
              [-20.338790513771016, 2.2677507453506185],
              [-20.334567857790923, 2.267289529094792],
              [-20.330924914304287, 2.2695479730087498],
              [-20.305766070551975, 2.3024878723394306],
              [-20.26203466747343, 2.364579815760987],
              [-20.24821690762029, 2.387459756827752],
              [-20.24158633088712, 2.4018161525983404],
              [-20.23917924903546, 2.411604303975569],
              [-20.2403387606127, 2.418502633890408],
              [-20.23888569077984, 2.423739631258507],
              [-20.23987728057046, 2.4264916767168048],
              [-20.247134113201966, 2.4335972529552774],
              [-20.244454296877947, 2.4373870048912982],
              [-20.241950267046196, 2.448639000828433],
              [-20.24214525344742, 2.452809077855361],
              [-20.247922009195264, 2.4680620875008707],
              [-20.246095689944262, 2.473461237578651],
              [-20.2487932162753, 2.4783378569186425],
              [-20.252459790062503, 2.493857664570229],
              [-20.249962934387483, 2.494613452073973],
              [-20.246434475024312, 2.4909572286251436],
              [-20.24267687572083, 2.481194814988601],
              [-20.237934033584956, 2.480184639262676],
              [-20.236731005782165, 2.483522754317453],
              [-20.232793492291993, 2.4881848154284265],
              [-20.22807782016082, 2.4982676277203173],
              [-20.22768577240926, 2.502430450505508],
              [-20.230330937957067, 2.5181730471278034],
              [-20.23573667211261, 2.5252785532419026],
              [-20.23607106046694, 2.5328164802199904],
              [-20.239108591058987, 2.5366994411182486],
              [-20.239175891563914, 2.5434050507791564],
              [-20.241738050405328, 2.5507210988471436]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.72356686890564,
          "lat": 38.07346375383791
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06041"],
        "coty_name": ["Marin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marin County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00277285"
      },
      "bbox": [
        -20.342736836109513, 1.9820375268720176, -19.90986285244822,
        2.5633114333757083
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.345252780317181, 0.0426130867599837],
            [-5.34468110413706, 0.04991665945131785],
            [-5.335217598906093, 0.04940043337738461],
            [-5.3123258498486745, 0.04737791052485008],
            [-5.148393144027254, 0.034643345625316034],
            [-5.14494745617409, 0.03464741249191403],
            [-5.088253035344233, 0.03174927730242859],
            [-5.081669256070253, 0.11948839259386991],
            [-4.967806809070087, 0.11354358436681798],
            [-4.827936803076682, 0.10263206093233536],
            [-4.688067914465212, 0.09170571602293837],
            [-4.64799891005964, 0.08879070821504598],
            [-4.570063282447544, 0.08382044147388816],
            [-4.527023528862193, 0.08206961425787487],
            [-4.428887519343515, 0.07581085911889125],
            [-4.427483315304927, 0.0758650014179736],
            [-4.22917205753105, 0.06276512496361247],
            [-4.210989341728457, 0.061597134723195286],
            [-4.21552007997144, -0.010328532985444148],
            [-4.221384381258824, -0.1011709061823192],
            [-4.223264122991578, -0.13542008784736398],
            [-4.223130485813695, -0.13935249078896195],
            [-4.225533418468286, -0.1709539031165853],
            [-4.229903936300767, -0.24362416363152525],
            [-4.232665114260226, -0.28753924424205474],
            [-4.289198155687, -0.28426752936467403],
            [-4.361885690374169, -0.27978346590436914],
            [-4.397260661087979, -0.27748118361364743],
            [-4.560989494737798, -0.26702214761048587],
            [-4.570335867315742, -0.26608799885323003],
            [-4.677893320488708, -0.2591052876323757],
            [-4.774065582905656, -0.25286495960563504],
            [-4.788827322564012, -0.25211014510825985],
            [-4.817948563557865, -0.24889837569811454],
            [-4.845567852504714, -0.24826563277525385],
            [-4.8509958148447145, -0.24728318752029232],
            [-4.92819871518754, -0.2419662535735622],
            [-4.935171421157068, -0.24128569889335802],
            [-4.974272441426816, -0.23862254341944028],
            [-4.992039884036007, -0.23762629305204638],
            [-5.075572363202698, -0.23140689546376994],
            [-5.0825444970215585, -0.23130271992018733],
            [-5.100785513337925, -0.2298779184819377],
            [-5.284064903318246, -0.2164070917954293],
            [-5.3630270820084585, -0.21062866822460447],
            [-5.358166745621659, -0.15086376606207105],
            [-5.356860886660657, -0.13283619887625203],
            [-5.360919702958834, -0.1325545649158372],
            [-5.347707018258541, 0.017354298691380263],
            [-5.346549623499233, 0.026095507819143743],
            [-5.345252780317181, 0.0426130867599837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.74023520556632,
          "lat": 38.43263817099341
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08061"],
        "coty_name": ["Kiowa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kiowa County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00198146"
      },
      "bbox": [
        -5.3630270820084585, -0.28753924424205474, -4.210989341728457,
        0.11948839259386991
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.898068366329577, -0.48195950921332464],
            [-8.770425308902565, -0.49743844698612594],
            [-8.727209169122467, -0.5026504759794118],
            [-8.721528300381268, -0.5041376408390511],
            [-8.603841357096591, -0.5185739426658361],
            [-8.53271826154821, -0.5272576937001827],
            [-8.518384610653667, -0.5291283312887943],
            [-8.535129828284433, -0.668990129059477],
            [-8.535643023579478, -0.6711441864418289],
            [-8.544734519087262, -0.7464768146049893],
            [-8.550610841437528, -0.7942631668985517],
            [-8.550907046478276, -0.7980087714538427],
            [-8.556304017370193, -0.8406377495117671],
            [-8.557017446215704, -0.8476310046789975],
            [-8.56580153196037, -0.919161210791958],
            [-8.573762174301548, -0.9859031864399149],
            [-8.585599037962567, -1.0874282151721486],
            [-8.595859677603729, -1.1701312034340023],
            [-8.689128420237209, -1.1587527747599464],
            [-8.776953644506646, -1.1479302370676179],
            [-8.907039978496298, -1.1317069974264224],
            [-9.003153533422367, -1.1195724909484932],
            [-9.149218505211099, -1.1016398579020954],
            [-9.198423776931506, -1.0955334649141495],
            [-9.19935461445599, -1.0948570412146987],
            [-9.300287495806487, -1.081811657769058],
            [-9.301409105681467, -1.0796191631672172],
            [-9.297096265773822, -1.0749385144514942],
            [-9.297420874931268, -1.0722345894935474],
            [-9.291532953357112, -1.0607826209090536],
            [-9.292306464981241, -1.0571647024744106],
            [-9.290517701766369, -1.0529067831205379],
            [-9.280915493689312, -1.0573873765922375],
            [-9.275123834742981, -1.0506592036319051],
            [-9.27559506885941, -1.0449755322667436],
            [-9.272467779504387, -1.0434599567945597],
            [-9.269023932871466, -1.0386054575311667],
            [-9.257559023014299, -1.029977117004144],
            [-9.256846018894596, -1.023043155209208],
            [-9.255228594920563, -1.01848535818547],
            [-9.251161136190833, -1.017307567527313],
            [-9.251941974119948, -1.0116386903529064],
            [-9.248232467992603, -1.010526087376994],
            [-9.248663398782309, -1.0074155637433642],
            [-9.244015568774554, -0.9982436315250859],
            [-9.241733029807433, -0.9917361098091682],
            [-9.23889255962462, -0.989978444687005],
            [-9.237700172619446, -0.9852183861401892],
            [-9.232218396717458, -0.9828404841650236],
            [-9.231148454883373, -0.9771216520873768],
            [-9.232035544983253, -0.9712334459103246],
            [-9.229935961497553, -0.9684372875216533],
            [-9.229248674363037, -0.958845557601022],
            [-9.220632710979409, -0.9503572577838082],
            [-9.21467673917014, -0.9453696455728329],
            [-9.21152804250828, -0.9442234535181278],
            [-9.210229948197563, -0.9360173533273426],
            [-9.214301354938005, -0.9311904385807596],
            [-9.212067583063243, -0.9274370514882808],
            [-9.213692178131971, -0.9183009312082212],
            [-9.21157552915376, -0.9143510833954773],
            [-9.210095186019602, -0.9078718928366447],
            [-9.20990308304687, -0.8995401173215357],
            [-9.20714229227016, -0.8955701269580839],
            [-9.206069001464803, -0.8874231709716677],
            [-9.20887718144183, -0.8809816746089374],
            [-9.208107515829983, -0.8761916814857583],
            [-9.202693346564477, -0.8697139362205387],
            [-9.202580149913757, -0.8679815335048079],
            [-9.19391228506059, -0.862433349160898],
            [-9.185307696318649, -0.8628911094635768],
            [-9.182261225753022, -0.8593362670789172],
            [-9.177248268876147, -0.8580074892650623],
            [-9.17562266603594, -0.8538669799530617],
            [-9.17183990185711, -0.8498880684279296],
            [-9.167332794708948, -0.847805927480045],
            [-9.164266911732382, -0.8445625229148138],
            [-9.163057258505326, -0.8395890988354207],
            [-9.158978731642364, -0.8335008573214879],
            [-9.155790699254919, -0.8326522753048715],
            [-9.153662161019383, -0.8250214180185524],
            [-9.150142535216562, -0.8200791183911043],
            [-9.146189800106507, -0.8193393514628893],
            [-9.14503911223665, -0.8144131053231978],
            [-9.142192773043499, -0.809982058609817],
            [-9.137812476640518, -0.8097828376465075],
            [-9.135211723009773, -0.8001063248991063],
            [-9.131803830912226, -0.7996630433581019],
            [-9.130597703717816, -0.7945463304675066],
            [-9.132881477779494, -0.7912662549556119],
            [-9.132171065571175, -0.7858747359760124],
            [-9.129737540664028, -0.7846142428856433],
            [-9.126177601163535, -0.776337084664225],
            [-9.119720856972641, -0.7720316737334308],
            [-9.122712095183088, -0.7652520036656094],
            [-9.118879418049758, -0.7545400053581576],
            [-9.112771627455384, -0.7477743298179672],
            [-9.111963344763359, -0.7443775095531381],
            [-9.107457356389501, -0.7407532161926628],
            [-9.099840287235725, -0.7376234018558148],
            [-9.091168172291368, -0.7354024688604677],
            [-9.08629272122663, -0.7372660134965778],
            [-9.084872253123482, -0.7403308365239836],
            [-9.079837684973503, -0.739399571544119],
            [-9.075608189051461, -0.7412719125173132],
            [-9.071008385880692, -0.7390228755534922],
            [-9.0649271611416, -0.7322312108206857],
            [-9.05834335540749, -0.731182995062152],
            [-9.049074568333802, -0.7323342778136632],
            [-9.04299300849243, -0.7273816443031986],
            [-9.036715861347565, -0.7264328105491641],
            [-9.035652867494502, -0.7193903653827438],
            [-9.03646981567793, -0.7139893453692231],
            [-9.0332943399408, -0.7029440191387405],
            [-9.0278721146418, -0.6964575337445095],
            [-9.02621649340961, -0.6921527812365988],
            [-9.018939753409448, -0.6888490275875448],
            [-9.01636803270268, -0.6825154663493177],
            [-9.010534107632198, -0.6818177214001485],
            [-9.010909664566595, -0.6784848722453729],
            [-9.007734139970413, -0.6723076715632019],
            [-8.99494815605014, -0.6754007665448606],
            [-8.988397492334048, -0.676159869612413],
            [-8.984177341841471, -0.6715645716135595],
            [-8.981084880278463, -0.6718161126485438],
            [-8.97872925800008, -0.6663661698599564],
            [-8.9749749990553, -0.6626699672479149],
            [-8.973513202427037, -0.6561258794479925],
            [-8.969393179648977, -0.6506713530578841],
            [-8.971127045791338, -0.6441011069214757],
            [-8.96785556903153, -0.6354370375897508],
            [-8.968712143586805, -0.6241027520742379],
            [-8.966420428655349, -0.6182403434689139],
            [-8.968246089963673, -0.6118842735296435],
            [-8.963353138126434, -0.605660817618235],
            [-8.964319476714996, -0.6022602041711209],
            [-8.961840341745877, -0.5975768825065826],
            [-8.963123821926311, -0.5921408231087382],
            [-8.962025047152048, -0.5828447740746463],
            [-8.953853469212099, -0.5765323394965964],
            [-8.95149598142161, -0.5698341969711869],
            [-8.94967803506427, -0.5679552997798055],
            [-8.946986367819639, -0.5582642271537614],
            [-8.948035068204234, -0.5537539632772652],
            [-8.944785481623923, -0.5497728911839596],
            [-8.946239217507607, -0.5452070700500333],
            [-8.944863890739832, -0.5427537368258971],
            [-8.94458632348622, -0.5341745980700096],
            [-8.94363267188795, -0.5317948806108356],
            [-8.944930987091894, -0.5250348397042718],
            [-8.940953121218197, -0.5251660022374443],
            [-8.937676195785286, -0.5208228238778563],
            [-8.938352764986675, -0.5162764420549909],
            [-8.933291105740139, -0.5119064876453521],
            [-8.929374578782292, -0.5121280655976411],
            [-8.925534126031716, -0.5073918944015637],
            [-8.924707737405177, -0.5042955725835221],
            [-8.91902881540427, -0.5034547723438899],
            [-8.913250960674496, -0.4948791807285438],
            [-8.907045958933148, -0.4917255610364331],
            [-8.900822594631231, -0.49114997175792147],
            [-8.898068366329577, -0.48195950921332464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.84333018272237,
          "lat": 37.28654731607564
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08067"],
        "coty_name": ["La Plata"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["La Plata County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00198148"
      },
      "bbox": [
        -9.301409105681467, -1.1701312034340023, -8.518384610653667,
        -0.48195950921332464
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.830951294159217, 5.535505787278883],
            [17.88072305024713, 5.547322623244734],
            [17.933040978202946, 5.557700799283035],
            [17.98756288094156, 5.5712035682370935],
            [18.057139908668606, 5.586517663107996],
            [18.121689103721366, 5.602377393920277],
            [18.12662721117976, 5.587598911861518],
            [18.146006486554494, 5.517344355840045],
            [18.182276398413414, 5.393706286417135],
            [18.192820192933187, 5.358373751659383],
            [18.205244459147213, 5.314872800383828],
            [18.224750879380668, 5.248183266326044],
            [18.23806994653754, 5.19031487769427],
            [18.25817527904876, 5.101048853052154],
            [18.22237874642743, 5.09810566532932],
            [18.20562299254819, 5.096955491610242],
            [18.183177508782222, 5.15112222720531],
            [18.181121672486967, 5.15694472608463],
            [18.161792668720448, 5.204966230725922],
            [18.158568069093793, 5.215725120639671],
            [18.11182719227093, 5.196544612792795],
            [18.00519690720008, 5.192860821596248],
            [17.98437892241212, 5.19234827568696],
            [17.974504857102293, 5.226721576603068],
            [17.96967451261164, 5.2413374010808065],
            [17.96886534152225, 5.275459380526929],
            [17.960631704454816, 5.276328267336193],
            [17.935204757583165, 5.274726331547662],
            [17.934862244977417, 5.274875047490342],
            [17.908983507628395, 5.352347617318416],
            [17.870780697496254, 5.3428953925428715],
            [17.859075014903144, 5.390928621873362],
            [17.85741654650682, 5.399153493732761],
            [17.842632544163102, 5.453903270808563],
            [17.840636043637296, 5.462510353993884],
            [17.827962525964033, 5.458688967751107],
            [17.830266514648212, 5.484195513346449],
            [17.831668844664907, 5.503621508677503],
            [17.830951294159217, 5.535505787278883]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -71.97694092202292,
          "lat": 41.826987275616176
        },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09150"],
        "coty_name": ["Northeastern Connecticut"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Northeastern Connecticut Planning Region"],
        "coty_fp_code": "150",
        "coty_gnis_code": "02830250"
      },
      "bbox": [
        17.827962525964033, 5.096955491610242, 18.25817527904876,
        5.602377393920277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.828325177307269, -10.150808218691537],
            [12.921088317978471, -10.137355338621207],
            [12.955925479881182, -10.132074426970854],
            [12.983319436724791, -10.128251479561172],
            [13.036432967957024, -10.120450628179745],
            [13.10381757758935, -10.110375228612128],
            [13.17362324487998, -10.099757611879932],
            [13.260161812258985, -10.086596526912224],
            [13.268903088669049, -10.14252494789585],
            [13.273191493815194, -10.171300846329345],
            [13.294830645494294, -10.31099610447238],
            [13.300833079290827, -10.351292180099557],
            [13.30577007158167, -10.382880259870074],
            [13.219577244010349, -10.395881900094977],
            [13.17644239868682, -10.402716987377099],
            [13.061274903232944, -10.419846277575877],
            [13.045563147273809, -10.422023532229412],
            [13.045986362433345, -10.42547582517459],
            [12.965013901432641, -10.436788624961002],
            [12.871912426613656, -10.449417369582791],
            [12.852537042292054, -10.318855911661302],
            [12.83566348023306, -10.200387701530383],
            [12.828325177307269, -10.150808218691537]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.80998177466819,
          "lat": 27.492707896481893
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12049"],
        "coty_name": ["Hardee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardee County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00295746"
      },
      "bbox": [
        12.828325177307269, -10.449417369582791, 13.30577007158167,
        -10.086596526912224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.444982307546917, -4.125825389218907],
            [9.433204048917752, -4.008579074051821],
            [9.45022212563405, -4.006851516538107],
            [9.445765954469268, -3.96950268318495],
            [9.452524746169058, -3.9683811627088117],
            [9.451766030642027, -3.9613078216844304],
            [9.444943840778425, -3.962013604648002],
            [9.44003579854063, -3.91503487456392],
            [9.435270083372439, -3.8732191731906234],
            [9.449811542216894, -3.8715670904588437],
            [9.444094421790066, -3.8262987700427162],
            [9.4562018284107, -3.8248667951703568],
            [9.45882043466428, -3.8325566075122115],
            [9.465904714952693, -3.831537256449065],
            [9.487241473617022, -3.829642050256581],
            [9.48486392345059, -3.822192089373225],
            [9.49171314528086, -3.821677587467947],
            [9.490955153349313, -3.814323385226378],
            [9.532477735607479, -3.8097709512387024],
            [9.532673292246308, -3.812078196636765],
            [9.549967971145774, -3.809562869271576],
            [9.559807495588139, -3.80858802660097],
            [9.58057433791629, -3.8050177562865497],
            [9.66448033171415, -3.796328847236896],
            [9.662711753861586, -3.7798534267375894],
            [9.667646783790346, -3.7791736197846593],
            [9.728293884607655, -3.7724146456200165],
            [9.734531086300251, -3.8298268428406828],
            [9.74245678240808, -3.8288859958748467],
            [9.743140527868837, -3.8372497502158827],
            [9.735552982298909, -3.8380528493399506],
            [9.747801877634254, -3.934680892123048],
            [9.75012365830313, -3.957611884844487],
            [9.749838103641547, -3.9824382726760805],
            [9.751188643218212, -3.9926563352822804],
            [9.756927537846495, -4.0425461287880315],
            [9.763523289108065, -4.1067810416710095],
            [9.699241206279945, -4.113317632932402],
            [9.698896830269259, -4.110342284343423],
            [9.582542517710282, -4.1238246532292075],
            [9.56908034026757, -4.125477508908749],
            [9.569445008287186, -4.129280201599993],
            [9.558842980007045, -4.130621632088626],
            [9.559149395683026, -4.13392613951881],
            [9.555555493260497, -4.134346219749936],
            [9.554790312102963, -4.127036530308317],
            [9.547936263971824, -4.127950561394945],
            [9.542045922008247, -4.1285369963704035],
            [9.54247940454396, -4.132937738554664],
            [9.535108252686625, -4.133595205232442],
            [9.534586178970896, -4.129451704355299],
            [9.485616292560223, -4.134753469291479],
            [9.446407260486193, -4.139350977537957],
            [9.444982307546917, -4.125825389218907]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.84033727015202, "lat": 34.23765505408326 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13015"],
        "coty_name": ["Bartow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bartow County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00351604"
      },
      "bbox": [
        9.433204048917752, -4.139350977537957, 9.763523289108065,
        -3.7724146456200165
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.315762603531496, -4.828296939125266],
            [10.315389501327438, -4.82440159215991],
            [10.326860377718479, -4.823180776306705],
            [10.329849378681851, -4.826714341371403],
            [10.333704563723119, -4.822322262070048],
            [10.339392820839574, -4.82166608644538],
            [10.33768347246779, -4.8059101238136295],
            [10.345480459429632, -4.804929577004697],
            [10.346416105945034, -4.812703952294821],
            [10.348358941275448, -4.8126839786718705],
            [10.3535596171373, -4.803779237205374],
            [10.352115582384533, -4.792021821588057],
            [10.358486770665099, -4.791219311769095],
            [10.360269152987078, -4.783921071005569],
            [10.35980392540405, -4.779359264248796],
            [10.363074596902525, -4.777207572603103],
            [10.367332470819017, -4.776738360721856],
            [10.365317612854376, -4.757899988816636],
            [10.372151987277377, -4.757400620967713],
            [10.375269244981224, -4.76146405774317],
            [10.381961173880534, -4.7569627309098435],
            [10.385107766952407, -4.748624704364293],
            [10.40452653971117, -4.746325190837932],
            [10.409549086269767, -4.739061830507227],
            [10.419815329361805, -4.737342211102533],
            [10.419904147773229, -4.733940454259191],
            [10.417209510577559, -4.727585232080423],
            [10.411263063485945, -4.728273642930518],
            [10.408495380330155, -4.706002883758038],
            [10.41673142049141, -4.704931882907483],
            [10.415255681958676, -4.693380741218237],
            [10.42271605641224, -4.692377004015613],
            [10.421954588999087, -4.686421180266419],
            [10.430590594433216, -4.685258178703616],
            [10.428504445144398, -4.6688379207727015],
            [10.437454714498603, -4.667618759506266],
            [10.437115761367734, -4.664978829282184],
            [10.444296800489102, -4.664389608848345],
            [10.449046338590643, -4.668976918440645],
            [10.4497479305561, -4.673790314612277],
            [10.453707519561274, -4.676316938067304],
            [10.453544909136138, -4.680176044997633],
            [10.457544508013045, -4.680998748662907],
            [10.457042190245472, -4.689517415778456],
            [10.4605101010904, -4.688993439723428],
            [10.462858660477899, -4.692777122810722],
            [10.469736324942547, -4.695372944889218],
            [10.472617916467017, -4.697868261897348],
            [10.474067692949113, -4.708618218984541],
            [10.47664947681703, -4.711027194550893],
            [10.488367234587551, -4.713808795761658],
            [10.490351361089685, -4.720242149659717],
            [10.494385536909693, -4.724930265315372],
            [10.500734295360223, -4.724438990076727],
            [10.500567055118982, -4.729444665424291],
            [10.50405314962622, -4.733564068805684],
            [10.505873312206647, -4.736253682732045],
            [10.50594600246598, -4.741588654014767],
            [10.510820626707742, -4.747350867278703],
            [10.507131588774653, -4.759431675105833],
            [10.51475001811982, -4.765241943111135],
            [10.521869236863665, -4.766855907190607],
            [10.527745340125781, -4.77036140261148],
            [10.529000887141548, -4.774668379956294],
            [10.527166590396385, -4.781100052052099],
            [10.532731034485415, -4.787199157161296],
            [10.532883387194197, -4.791192197541351],
            [10.539380371022766, -4.796259881822753],
            [10.543137683397044, -4.805215774790936],
            [10.542773565014057, -4.811558750925725],
            [10.539985860178492, -4.815812401873056],
            [10.541668757047653, -4.825858263750004],
            [10.545814441341777, -4.831598018176488],
            [10.54915922185475, -4.833651716720061],
            [10.550790272275156, -4.839336639446269],
            [10.554125614412396, -4.843567793827098],
            [10.557163368816262, -4.84480295540767],
            [10.559911468345124, -4.848576297673923],
            [10.560567200355162, -4.853909826719354],
            [10.555947235582764, -4.868085005789488],
            [10.555286806648907, -4.875199149247694],
            [10.548721635247167, -4.884739182146295],
            [10.548039740609386, -4.887874446371758],
            [10.554624154550726, -4.886700140301995],
            [10.557277854764815, -4.892168031695918],
            [10.56066495367874, -4.895242152867029],
            [10.568055025067249, -4.897308488454542],
            [10.564652421245137, -4.9019248584482344],
            [10.572168865959505, -4.903679355527663],
            [10.56540204913156, -4.90953381842328],
            [10.561805949521798, -4.916342572772137],
            [10.553061341609844, -4.913301679537923],
            [10.545532859964903, -4.905902698144886],
            [10.545310916532335, -4.903443693667159],
            [10.54002589307807, -4.902012653365934],
            [10.535284421861613, -4.905027474607056],
            [10.528713423421893, -4.900101025822038],
            [10.52338464431941, -4.90106284497631],
            [10.521210773587006, -4.899606751754335],
            [10.51381451204927, -4.900093138418019],
            [10.471485851653664, -4.90597254162349],
            [10.417832113186854, -4.912268764933488],
            [10.378150408909082, -4.917064464947356],
            [10.310275957901899, -4.925391374442879],
            [10.305679495860545, -4.883824722450193],
            [10.309709549384081, -4.883412197071425],
            [10.309173885297922, -4.87912537375038],
            [10.30540811327325, -4.879527062284143],
            [10.304965649707501, -4.875672308657769],
            [10.328536669881927, -4.839377898034763],
            [10.315762603531496, -4.828296939125266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.95719167383947,
          "lat": 33.287889567679606
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13035"],
        "coty_name": ["Butts"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butts County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00352295"
      },
      "bbox": [
        10.304965649707501, -4.925391374442879, 10.572168865959505,
        -4.664389608848345
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.632982750188958, -5.626110643113468],
            [10.6372893189758, -5.63287126095844],
            [10.641297599248814, -5.632503404660298],
            [10.650110449448286, -5.6349723465361485],
            [10.652597828732414, -5.653226553691022],
            [10.661260912599246, -5.6513814240703475],
            [10.660355862539813, -5.644602638513192],
            [10.676499322180065, -5.642247846866471],
            [10.670131375682626, -5.593040313750848],
            [10.678406276511675, -5.592015046093195],
            [10.67667369000402, -5.575770507780148],
            [10.684478235816918, -5.574665561987392],
            [10.685349497731789, -5.58202238430061],
            [10.709507381721645, -5.579211422087729],
            [10.707307424846837, -5.561974798862862],
            [10.706572437100544, -5.5511834506253575],
            [10.711376728483899, -5.552170283707784],
            [10.714841485940655, -5.554988101874033],
            [10.719279597671491, -5.556223628229267],
            [10.720741218995832, -5.5597298747072506],
            [10.728964769000244, -5.560677655946087],
            [10.730313653438609, -5.549766049912065],
            [10.72337176704214, -5.497809177991628],
            [10.722318618633357, -5.4841622345302055],
            [10.725373764316707, -5.478300194386798],
            [10.726021398352556, -5.470757518941281],
            [10.721049399603826, -5.47133315991677],
            [10.717957263665943, -5.447159626731727],
            [10.709927264083477, -5.44770421390193],
            [10.708241048194008, -5.431811628167466],
            [10.723710568366718, -5.429935683490352],
            [10.720894367071795, -5.406709885798063],
            [10.724170468144532, -5.4025644600086045],
            [10.725647368694055, -5.398439831684522],
            [10.725172807041922, -5.389057073970816],
            [10.725047251259326, -5.388496699451876],
            [10.72963355417399, -5.39159249851834],
            [10.733320484135078, -5.391144857721061],
            [10.738198437698086, -5.394362953579036],
            [10.740909044971039, -5.394126441887387],
            [10.75001478665743, -5.400786274029898],
            [10.752588797149725, -5.399737009139704],
            [10.76117210988861, -5.402335099848149],
            [10.771672226511686, -5.401179598378134],
            [10.779825197995654, -5.404700287963914],
            [10.784427915171625, -5.404939033918906],
            [10.789914303596165, -5.402898080823432],
            [10.79661548186788, -5.40759508959358],
            [10.806039267445176, -5.4059220856952255],
            [10.809165815152552, -5.409394056066872],
            [10.814551160274316, -5.404958905302418],
            [10.819916983307547, -5.403125483739363],
            [10.825085967059929, -5.406160238829659],
            [10.825386154522002, -5.410015386914658],
            [10.829326812437754, -5.410493725894964],
            [10.835723373783672, -5.408587043219837],
            [10.838552841378705, -5.406181459867008],
            [10.844046885239626, -5.40581630701621],
            [10.845680750410937, -5.411322792363018],
            [10.850371901170144, -5.411969421945278],
            [10.852424497625085, -5.420216415023731],
            [10.858436855494427, -5.424562595546604],
            [10.85686578039213, -5.4275015727460145],
            [10.865014701588997, -5.4372812205497425],
            [10.864687381416452, -5.443586623514883],
            [10.862861670400601, -5.449932936251908],
            [10.866497694092715, -5.452161345607888],
            [10.870260217217202, -5.459973684852516],
            [10.869518780890862, -5.463491341292248],
            [10.872096426997723, -5.471871882927358],
            [10.87672867661912, -5.475353503631927],
            [10.876676379615823, -5.487478847393305],
            [10.872778932765117, -5.485152970768231],
            [10.871234606364677, -5.488533349672691],
            [10.867761869814817, -5.490276361946791],
            [10.868519032150198, -5.498639617833473],
            [10.870679774447916, -5.499618340744469],
            [10.871549796409935, -5.504095365575218],
            [10.87853797389713, -5.509830250677405],
            [10.881332863961182, -5.517428756147966],
            [10.879760402586943, -5.524494800053387],
            [10.883105477106781, -5.528061963376455],
            [10.88430141514751, -5.53793556796006],
            [10.88729106348157, -5.538790902512477],
            [10.889104264900737, -5.542841578458191],
            [10.893780713550708, -5.548831029044947],
            [10.898301312421328, -5.550331874936252],
            [10.896697007881194, -5.555161525206494],
            [10.901314851656814, -5.555129025025685],
            [10.901993057853254, -5.5601502870355874],
            [10.912383011503275, -5.565495293320773],
            [10.925507924652145, -5.569709487077451],
            [10.92078783269571, -5.575500024484014],
            [10.926056170403086, -5.576504206516305],
            [10.92315798300613, -5.584328113186715],
            [10.927863018352499, -5.589256633075484],
            [10.926523935750861, -5.593984790640258],
            [10.93111499087844, -5.596906090457851],
            [10.927423864165878, -5.600071457482254],
            [10.925290880612067, -5.604631398733735],
            [10.926584639113917, -5.609746420650908],
            [10.93327610373976, -5.61248987094858],
            [10.935603325625374, -5.619278385307967],
            [10.933392194704563, -5.622928982109034],
            [10.937161826280667, -5.626651519402907],
            [10.936974580054104, -5.629075478541473],
            [10.94203551572876, -5.636305707080638],
            [10.943603358597484, -5.64564736526446],
            [10.941910127047594, -5.650890868175401],
            [10.934332911909777, -5.652422028490456],
            [10.93185206486365, -5.654722850823732],
            [10.930008224696957, -5.657668401684026],
            [10.929610679965291, -5.6676476439139565],
            [10.921461560730199, -5.665809119885331],
            [10.913082283838902, -5.657770102067909],
            [10.910389894056149, -5.657070243822259],
            [10.872684974255915, -5.72850105121412],
            [10.867282593238393, -5.742324026045056],
            [10.862037482621702, -5.7529282616297674],
            [10.85639838695932, -5.762666037457627],
            [10.848776099926727, -5.779784167205228],
            [10.777893309804854, -5.787546318134868],
            [10.778881034105535, -5.794889939306995],
            [10.763448098402792, -5.796391376758228],
            [10.762800961240897, -5.789326471342609],
            [10.747229407648529, -5.79131988327709],
            [10.654325873979886, -5.802460302077446],
            [10.647057262306264, -5.736056597382546],
            [10.6389225048398, -5.737060522173725],
            [10.635807014203653, -5.712621837755313],
            [10.652077494972067, -5.710746072140704],
            [10.645055078548852, -5.654031373884739],
            [10.637111662543552, -5.654970471005112],
            [10.632982750188958, -5.626110643113468]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.66626185751068, "lat": 32.45903058132221 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13153"],
        "coty_name": ["Houston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Houston County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01671693"
      },
      "bbox": [
        10.632982750188958, -5.802460302077446, 10.943603358597484,
        -5.388496699451876
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.966721001296964, -5.641656960452148],
            [9.980512136155534, -5.645121638674807],
            [9.988745701443946, -5.639052202512784],
            [9.993673100084461, -5.638274130752972],
            [9.997080726232142, -5.641360328740289],
            [9.996783738388114, -5.643726463407574],
            [10.003510826718198, -5.648794144067086],
            [10.01082441557477, -5.648675248090868],
            [10.014256131569034, -5.646484930427185],
            [10.021455679014712, -5.6441187325522275],
            [10.023395518086913, -5.641573031518169],
            [10.030729635034676, -5.640832849923903],
            [10.03001494151538, -5.63388856675497],
            [10.026483935900536, -5.634211638223921],
            [10.025435585723665, -5.629369914962587],
            [10.028927104365705, -5.624638124349027],
            [10.03691737636344, -5.618690809664599],
            [10.037652983947243, -5.625217571397818],
            [10.044943062740032, -5.624487234390787],
            [10.044179702296288, -5.617189540778464],
            [10.05216618201498, -5.616303910327732],
            [10.052922489472582, -5.6234058885426785],
            [10.076157885369637, -5.621473974129644],
            [10.075511991151794, -5.615106686133638],
            [10.086212924862666, -5.613706732729895],
            [10.084322619009694, -5.60018613696254],
            [10.123997822383496, -5.595243531989489],
            [10.12700511803791, -5.6149028782416925],
            [10.119013849690203, -5.615722011812478],
            [10.120058395809426, -5.623699430349953],
            [10.128321228728531, -5.6228704651905295],
            [10.130402315465503, -5.638381044006858],
            [10.138287992589364, -5.637253311829439],
            [10.141330860465063, -5.66254208926993],
            [10.149406694856285, -5.661558817932454],
            [10.149979867947, -5.669653901693415],
            [10.163795665367111, -5.6678459232624245],
            [10.168366113165185, -5.70893730896133],
            [10.170405759357878, -5.707641193607156],
            [10.174830812471624, -5.71135409663885],
            [10.175663465100623, -5.716565671907703],
            [10.18297556709002, -5.7158281969881175],
            [10.185419034495895, -5.737000618518036],
            [10.19966073147963, -5.836649409165027],
            [10.201719819609554, -5.852723780162605],
            [10.182173686757787, -5.854812234616859],
            [10.183176404963385, -5.862802475078616],
            [10.185834583796924, -5.862503648615977],
            [10.186571916909806, -5.867450203491288],
            [10.192615224352448, -5.919701378077791],
            [10.176678533356604, -5.9213452037093],
            [10.180998355807647, -5.959091587811317],
            [10.189450534499397, -5.9605564005987075],
            [10.191202687221544, -5.977786404059317],
            [10.183273920841467, -5.978853236939266],
            [10.184080498360114, -5.986810615149647],
            [10.187177230922321, -6.018858117233052],
            [10.13407323619039, -6.024789872657286],
            [10.128976639557061, -6.02570832710909],
            [10.106905085637761, -6.028080946039894],
            [10.104645172653596, -6.011640219504128],
            [10.097202437523546, -6.012537694019805],
            [10.095936359095196, -6.004237735763128],
            [10.088052418359476, -6.005686027277554],
            [10.08645315950333, -5.98959128805908],
            [10.070581757820598, -5.9915979318028185],
            [10.068907429619562, -5.974622332170824],
            [10.039120195759022, -5.977641748212202],
            [10.040020299329333, -5.971613249021823],
            [10.03609586600709, -5.963138144502944],
            [10.03593789992148, -5.9598331489579195],
            [10.03077491455167, -5.95406773164331],
            [10.027479426045042, -5.9545631807020065],
            [10.026135782870487, -5.9462655210518145],
            [10.017350395829274, -5.9472174977082215],
            [10.01686569518753, -5.939720079840255],
            [9.992900388892775, -5.942686762992687],
            [9.98489051996106, -5.943744051653487],
            [9.982598405980356, -5.924356194419532],
            [9.976281751735591, -5.867285559776701],
            [9.968754925534553, -5.804716927179262],
            [9.961089961920473, -5.7364706978341395],
            [9.960066004604288, -5.7363913308348895],
            [9.954851168579676, -5.68330469010939],
            [9.970769042359812, -5.681503491320069],
            [9.966721001296964, -5.641656960452148]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.52461660111658, "lat": 32.3535164052548 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13197"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "00344107"
      },
      "bbox": [
        9.954851168579676, -6.028080946039894, 10.201719819609554,
        -5.595243531989489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.702182807433463, -5.0108668884677305],
            [9.710500270536079, -5.0100222770440395],
            [9.70662021809527, -4.977614548400234],
            [9.792992641560586, -4.967848630603499],
            [9.829705554585619, -4.963842952994343],
            [9.828798205847972, -4.955512511950057],
            [9.836409773248668, -4.954530797139057],
            [9.837356835140023, -4.962780782866968],
            [9.853405816655748, -4.961108520470384],
            [9.853037441827473, -4.957353793223087],
            [9.85720249282303, -4.95692555439904],
            [9.856789781486306, -4.952574088057508],
            [9.868960212266627, -4.951197523907288],
            [9.869700190750674, -4.957573433264235],
            [9.871516563728909, -4.959152227063504],
            [9.885529018575744, -4.9575682187303824],
            [9.94318765135788, -4.951559635779921],
            [9.995736153268705, -4.945698017432617],
            [9.9991562404191, -4.954232467666408],
            [10.002543923528902, -4.958889311365572],
            [10.002575168074687, -4.9644265432527],
            [10.006102000300812, -4.9657063761963025],
            [10.003837938979352, -4.974070366359311],
            [10.005879325121311, -4.978449585159221],
            [10.00485014833894, -4.982162384907224],
            [9.997023783780925, -4.992400405357706],
            [9.99946766564352, -4.998789417475437],
            [9.996525058955521, -5.005194994937208],
            [9.997953071286874, -5.009835132443668],
            [9.995977682802195, -5.01769194463101],
            [9.993890466677183, -5.019837241451921],
            [9.994658532140276, -5.027795139492183],
            [10.000157183578313, -5.040895983759577],
            [9.994689780895774, -5.045394177914921],
            [9.994340163058016, -5.053902716759308],
            [9.996436523829313, -5.057319260058626],
            [9.9967924658379, -5.066479414502226],
            [9.988987686438357, -5.070440233367245],
            [9.990390546347678, -5.076762074027344],
            [9.99442701826406, -5.073545662563266],
            [9.997612839336883, -5.077532182418018],
            [10.004595167607905, -5.081021945743386],
            [10.004283778628364, -5.08877780266614],
            [9.997285836883337, -5.086768292443296],
            [9.994213436678494, -5.089904514104239],
            [9.993515715549831, -5.09847209754334],
            [9.997083006465745, -5.1030989926450205],
            [9.998274442851466, -5.106709301256887],
            [9.996345959191158, -5.124288522596133],
            [9.990322823583359, -5.127014129340232],
            [9.98957191531349, -5.133420301689248],
            [9.993649561914104, -5.140716501151394],
            [9.992680706626967, -5.143450476136289],
            [9.99402183501398, -5.148477048099115],
            [9.991740131481484, -5.157950016731723],
            [9.996745361919626, -5.163955532895766],
            [10.002198446470814, -5.1680489918898065],
            [9.999447044219767, -5.174900060873726],
            [10.00210171338973, -5.1786842457926],
            [10.001086218338404, -5.182514914153055],
            [10.00596957598868, -5.186759621384795],
            [10.009548694958577, -5.191364587065022],
            [10.009573370260188, -5.1941720691486335],
            [10.005745506272438, -5.19746723268553],
            [10.002100851466745, -5.198310217630692],
            [10.000409721105378, -5.204528810067849],
            [10.002844613480057, -5.207792140226449],
            [10.00615255571838, -5.2068152295850405],
            [10.01033045846649, -5.2083737944141],
            [10.01430904912069, -5.2147733429171765],
            [10.015286998920356, -5.218771607179167],
            [10.013089219285792, -5.22953210338697],
            [10.013656452320848, -5.23527660844968],
            [10.010110367231242, -5.239992806562534],
            [10.013913992639909, -5.246645184444585],
            [10.01576979676264, -5.254212978085491],
            [10.02140810010739, -5.251701566269543],
            [10.025575265158256, -5.253825926419718],
            [10.029499458316625, -5.26240885900811],
            [10.030527556032323, -5.2812872351208275],
            [10.033181226681636, -5.283741614195831],
            [10.03356481216062, -5.288056131685115],
            [10.028244257772235, -5.292567056293718],
            [9.98475125707074, -5.326528899200235],
            [9.943547063134012, -5.331634889508384],
            [9.939825755168606, -5.332383248213968],
            [9.87714353361691, -5.339945124204182],
            [9.845414173865265, -5.330363562651494],
            [9.832773145685275, -5.32698643228597],
            [9.832103386989932, -5.320512251522617],
            [9.818523559043232, -5.322388225092335],
            [9.818572360778294, -5.323615248302615],
            [9.785500226474166, -5.327441342787622],
            [9.752408248612573, -5.330744315096677],
            [9.751844757447977, -5.326708976193689],
            [9.740168490355245, -5.328019046508096],
            [9.729974675738742, -5.240117868975295],
            [9.727494754210975, -5.240396469600648],
            [9.719614422982787, -5.165622494005395],
            [9.714621683641209, -5.1248826599768424],
            [9.709623454100145, -5.076513188216275],
            [9.702182807433463, -5.0108668884677305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.68827077698373, "lat": 33.04052773067412 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13199"],
        "coty_name": ["Meriwether"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meriwether County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "00346892"
      },
      "bbox": [
        9.702182807433463, -5.339945124204182, 10.03356481216062,
        -4.945698017432617
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.205125686414704, -4.490167712698336],
            [10.216612815331242, -4.488992793377836],
            [10.214809952210338, -4.494209264811445],
            [10.217595135614067, -4.495558828682765],
            [10.225277748781561, -4.4958761745358675],
            [10.226275150741634, -4.489225934182536],
            [10.229513664341525, -4.487539430409951],
            [10.232851873582636, -4.493936643784741],
            [10.239391941087938, -4.495845409010257],
            [10.244138214793955, -4.500803262174478],
            [10.252026124744848, -4.499273998190562],
            [10.253595402542691, -4.503735397177527],
            [10.261486771132983, -4.507248167315683],
            [10.26495526434559, -4.5106072304733935],
            [10.265139605973589, -4.514534580454258],
            [10.287149266845143, -4.440280505981141],
            [10.29955811245392, -4.396916127019548],
            [10.310536612293992, -4.38252742122887],
            [10.32319331659681, -4.367411951021675],
            [10.34983314373105, -4.333731940144209],
            [10.353100259762778, -4.329967431528417],
            [10.41345448881023, -4.364670676519465],
            [10.4137628880841, -4.369659536785847],
            [10.412207814879489, -4.372292821778716],
            [10.414106753110575, -4.377775461011072],
            [10.412736913651415, -4.381803557115232],
            [10.415435836850715, -4.3921228954767875],
            [10.418784586799328, -4.395890626004191],
            [10.415919622059354, -4.400559682059357],
            [10.41115940848121, -4.398511592638679],
            [10.409266092667695, -4.399648740463003],
            [10.415444159245034, -4.417372575601184],
            [10.417738841408244, -4.419519027103451],
            [10.4136529241373, -4.428481670210837],
            [10.415609757601047, -4.435900925820513],
            [10.414526407364038, -4.445487880919358],
            [10.41208442257934, -4.450754993326788],
            [10.411700280556767, -4.459355582626216],
            [10.398076367456278, -4.483356940200921],
            [10.358032643956976, -4.554553070569725],
            [10.363848750027735, -4.553852990831367],
            [10.365023028700056, -4.562461554354201],
            [10.358962066136053, -4.5631632415202],
            [10.35787659481994, -4.554827800705391],
            [10.334863228526446, -4.59571327363985],
            [10.331835007384091, -4.5914033690221085],
            [10.328859335362639, -4.592078799982813],
            [10.327940579823187, -4.586115810317182],
            [10.329853753045636, -4.583169242846947],
            [10.326357582090305, -4.579736575564607],
            [10.320599319037838, -4.582558149658349],
            [10.314880200814606, -4.5747293797505755],
            [10.311168254376847, -4.577200723004674],
            [10.30498759476458, -4.574105818360466],
            [10.301599469827464, -4.570802232829438],
            [10.293089070481086, -4.570667260360447],
            [10.27712359288621, -4.5614963706134555],
            [10.271762141730203, -4.562764304641361],
            [10.27038695695466, -4.566256189016904],
            [10.264452893144824, -4.568766891629526],
            [10.258915935126048, -4.5660028259552945],
            [10.255934010643337, -4.560897333176849],
            [10.25027723197809, -4.555709369864033],
            [10.249517239641527, -4.551412348295096],
            [10.240802808083895, -4.5457803870579605],
            [10.23597983559036, -4.535569963742936],
            [10.228757959889629, -4.526357726448761],
            [10.225420111269965, -4.523271411336068],
            [10.218019590045026, -4.513095934694449],
            [10.209345930615271, -4.5068262051072345],
            [10.210612828522493, -4.503149150866452],
            [10.205535985792078, -4.493308033879639],
            [10.205125686414704, -4.490167712698336]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.02658156163454,
          "lat": 33.654302513464245
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13247"],
        "coty_name": ["Rockdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockdale County"],
        "coty_fp_code": "247",
        "coty_gnis_code": "00357592"
      },
      "bbox": [
        10.205125686414704, -4.59571327363985, 10.418784586799328,
        -4.329967431528417
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.887759819177951, -6.037477040556911],
            [10.8868884640095, -6.029034992797667],
            [10.87687398976067, -5.947706294578063],
            [10.900081907472188, -5.944580427971296],
            [10.924975478355478, -5.941686580753572],
            [10.924080701418916, -5.933711565028381],
            [10.931892209542406, -5.932779369574764],
            [10.93282783685335, -5.940665371515919],
            [10.97576224795406, -5.935203150660064],
            [11.02147412490624, -5.9298855793469185],
            [11.02044463240891, -5.921777762073679],
            [11.036390053814129, -5.919918272427301],
            [11.03542716552507, -5.9120726599915345],
            [11.051745358650344, -5.910411563397055],
            [11.052732540835672, -5.918831864409774],
            [11.082831876250534, -5.914839782146207],
            [11.088227961016313, -5.920419098800207],
            [11.091733587685352, -5.928853797973976],
            [11.091280540382137, -5.93133860873001],
            [11.095461490384722, -5.934083782982705],
            [11.100634074744264, -5.928643528504543],
            [11.105140748697037, -5.930231417534743],
            [11.109451769102336, -5.934845563758645],
            [11.112128816735261, -5.931608125922572],
            [11.116200575382496, -5.930642294413585],
            [11.116089552537794, -5.936597456269212],
            [11.123951125937825, -5.947874327146921],
            [11.127565270285933, -5.947217251393713],
            [11.127254232005646, -5.940799181838205],
            [11.133294812069847, -5.942264399972137],
            [11.138589124476988, -5.949591722192773],
            [11.13632780030683, -5.958941268230498],
            [11.141193140592486, -5.961299224299479],
            [11.142593549997136, -5.976496001793028],
            [11.137215059396981, -5.981382613234012],
            [11.14173848756779, -5.987972028235545],
            [11.146644164165266, -5.989822064211396],
            [11.149723540875817, -5.9941335246019],
            [11.14647688893743, -5.999660892600102],
            [11.148933239977445, -6.003310393694712],
            [11.153143529847215, -6.002087845065215],
            [11.155669392843295, -6.003661757346575],
            [11.155904297704012, -6.009067290777004],
            [11.15244551568145, -6.010378971167564],
            [11.151554862863481, -6.019470953477927],
            [11.155279864060015, -6.024833908923302],
            [11.155140848992577, -6.027968036890478],
            [11.163727126826329, -6.026249527837867],
            [11.165319349464724, -6.030217689654607],
            [11.169325860544712, -6.03411458469974],
            [11.166640280408565, -6.039346994265237],
            [11.16353860500078, -6.03729701618796],
            [11.160386281700845, -6.038724033795771],
            [11.161353579912516, -6.046591757126575],
            [11.16430826240116, -6.044564121089632],
            [11.166765848758315, -6.047687296920167],
            [11.166892341042276, -6.053587438016414],
            [11.169313300898335, -6.054858319741191],
            [11.172936006728076, -6.060240845532727],
            [11.178257591050528, -6.06272700229786],
            [11.18101283667283, -6.066857261382023],
            [11.184922037435733, -6.068064365130688],
            [11.189095757822914, -6.074099111635246],
            [11.199253704472953, -6.075752871086779],
            [11.203958012778209, -6.079200357908514],
            [11.20519749464618, -6.07220571663002],
            [11.20850654926252, -6.07334815327589],
            [11.208543519312858, -6.082422587459162],
            [11.21349320222797, -6.082595424901238],
            [11.220641880458404, -6.0861399509226235],
            [11.2186084523491, -6.0895526264837665],
            [11.228113154769892, -6.094794010538084],
            [11.227539664849546, -6.098573936542133],
            [11.23010181965932, -6.1052304562198145],
            [11.233111520818287, -6.110161242637471],
            [11.238379420066416, -6.115467342419945],
            [11.24300815690864, -6.114786651979914],
            [11.242767790105034, -6.119056880936839],
            [11.242280415567663, -6.124250385669239],
            [11.24837085826095, -6.127095295656427],
            [11.245406866654077, -6.129872441789786],
            [11.25146907467812, -6.134189587338364],
            [11.250516616074814, -6.1381533285149885],
            [11.254909590492373, -6.139780970342497],
            [11.257282273892645, -6.1425556722334],
            [11.26615995644129, -6.139867650011495],
            [11.269035026909057, -6.142244661055739],
            [11.270891009841867, -6.149134764492916],
            [11.267136455952109, -6.157675746522127],
            [11.271218390441614, -6.159976482313032],
            [11.27353007245627, -6.16779643284503],
            [11.268756618303913, -6.164483434949875],
            [11.265215226431899, -6.166989987122956],
            [11.258257396359063, -6.1688803818358915],
            [11.248695117673192, -6.170338722782348],
            [11.247007506371167, -6.174607396178487],
            [11.163741712545946, -6.1845359209932225],
            [11.114208208085822, -6.1903323398133745],
            [11.108344417674754, -6.191694914328217],
            [11.019906379541986, -6.202162408235664],
            [10.963362505732665, -6.208936220304402],
            [10.967620283566943, -6.203199692329211],
            [10.908292217054116, -6.209958976109186],
            [10.897681520259194, -6.121849195800528],
            [10.897295226624902, -6.120579669214137],
            [10.892469174137638, -6.077270499894927],
            [10.887759819177951, -6.037477040556911]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.43238926618305, "lat": 31.97289081731767 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13315"],
        "coty_name": ["Wilcox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilcox County"],
        "coty_fp_code": "315",
        "coty_gnis_code": "00345499"
      },
      "bbox": [
        10.87687398976067, -6.209958976109186, 11.27353007245627,
        -5.910411563397055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.002845003132618, 5.496902668220433],
            [-12.895230907787827, 5.475652837863289],
            [-12.83909402146042, 5.46469037856164],
            [-12.844315916010038, 5.437976744504829],
            [-12.830245889540448, 5.435187527237948],
            [-12.83305014910812, 5.4209311713814134],
            [-12.727208123642702, 5.400206285395556],
            [-12.621370697473766, 5.379457638900893],
            [-12.6296995944001, 5.336749807124152],
            [-12.54492370768861, 5.32059869403157],
            [-12.547636213008028, 5.306829499615123],
            [-12.573313254951191, 5.173834938384178],
            [-12.588366079624063, 5.094453751223214],
            [-12.591684677567757, 5.094578819828679],
            [-12.602753856870095, 5.092040035696296],
            [-12.608095421038799, 5.094017563349369],
            [-12.607943351650686, 5.097426801461983],
            [-12.613462463313661, 5.098760996024777],
            [-12.619194874770127, 5.0978094291884775],
            [-12.623392655602634, 5.100285631532562],
            [-12.627696548875809, 5.100514629343858],
            [-12.633819689218148, 5.097980278195425],
            [-12.636288091265799, 5.0940249800920565],
            [-12.639373597923592, 5.095121280687369],
            [-12.648812824872461, 5.096186251081544],
            [-12.651180828611842, 5.099152654263271],
            [-12.656052014720274, 5.096885986940035],
            [-12.660326345852706, 5.0969091816434675],
            [-12.66312114246664, 5.100228193033842],
            [-12.669173121389047, 5.103259154799593],
            [-12.67816890252368, 5.102777660487994],
            [-12.683313783436573, 5.10042531508973],
            [-12.687902960544612, 5.100816759841023],
            [-12.695326530885389, 5.095163729365712],
            [-12.697667462040773, 5.095551386511556],
            [-12.711422281915347, 5.0902790511624],
            [-12.725098268752248, 5.091379558751306],
            [-12.734706256163179, 5.082515842676765],
            [-12.73883576441264, 5.082060352214364],
            [-12.743094726091833, 5.086193802476323],
            [-12.752390598210843, 5.087650314256662],
            [-12.756601210035168, 5.093499917724939],
            [-12.758276063996995, 5.099498310536523],
            [-12.763524929967069, 5.104773537535172],
            [-12.765157366193824, 5.109368237194924],
            [-12.76513014611604, 5.1202700494978],
            [-12.767008079923306, 5.125696142115545],
            [-12.778578443166694, 5.138064871941205],
            [-12.78661842901162, 5.14395572374205],
            [-12.792399830568915, 5.1466176819772755],
            [-12.798717723607423, 5.151250293508841],
            [-12.8038458278851, 5.158263007108704],
            [-12.808733051944646, 5.1612354701883145],
            [-12.817526783628368, 5.1650537529875455],
            [-12.825110123714579, 5.165916625337907],
            [-12.829359186693024, 5.169146879925277],
            [-12.838777980727748, 5.169675972788345],
            [-12.841061419664275, 5.173174071671576],
            [-12.846217669265554, 5.175669780946572],
            [-12.851314751952943, 5.182266280325234],
            [-12.853698269359638, 5.181730692325248],
            [-12.864364507078962, 5.1855549140127515],
            [-12.869540307549185, 5.186637060854831],
            [-12.871122474827203, 5.193202174515875],
            [-12.875585519422232, 5.200573013017001],
            [-12.879567747162623, 5.205249853147725],
            [-12.89036876078464, 5.211836512451226],
            [-12.894977836385749, 5.217696510815038],
            [-12.905079875048337, 5.221430357186925],
            [-12.90805335562474, 5.22158991831694],
            [-12.915112021720525, 5.2188720527364065],
            [-12.919511725328285, 5.220346059042024],
            [-12.92324781871467, 5.223473688144135],
            [-12.931915178263344, 5.226547467553347],
            [-12.942502003812852, 5.224667214613436],
            [-12.948032395308127, 5.230628124718487],
            [-12.953902567458698, 5.2319236653354],
            [-12.959638037469519, 5.2319085769849005],
            [-12.962449015492629, 5.236913219937862],
            [-12.969665287274475, 5.243591700140049],
            [-12.9734813247223, 5.2452389603227285],
            [-12.987103520735651, 5.2585425519565785],
            [-12.98830810251795, 5.260559271700742],
            [-12.986273954202716, 5.264736045355285],
            [-12.989615874983171, 5.266305579343415],
            [-12.99283988099105, 5.270451274387374],
            [-13.006349773232815, 5.275571186538523],
            [-13.008820919405446, 5.278310418097881],
            [-13.015118148506216, 5.280441541186496],
            [-13.023263692890257, 5.280201228522773],
            [-13.028641789456119, 5.285242182212329],
            [-13.032473221377565, 5.285782961049255],
            [-13.04190963731563, 5.290353760285616],
            [-13.046044180821223, 5.290854031410313],
            [-13.05135245392578, 5.294297082030101],
            [-13.054761031428685, 5.299365271843646],
            [-13.058126224755522, 5.301970683852848],
            [-13.057509754146176, 5.305838440727599],
            [-13.034401542419674, 5.422457984257252],
            [-13.019309943735406, 5.500139394955572],
            [-13.002845003132618, 5.496902668220433]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.26394540303244,
          "lat": 42.68987399434458
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16053"],
        "coty_name": ["Jerome"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jerome County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00395662"
      },
      "bbox": [
        -13.058126224755522, 5.082060352214364, -12.54492370768861,
        5.500139394955572
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.60850233643161, 0.5378596382369965],
            [4.612549258674078, 0.5462905533661379],
            [4.612917904816316, 0.5493198261019893],
            [4.610999057962375, 0.5550735263028835],
            [4.612679560758401, 0.5586051547757486],
            [4.616911552622706, 0.5597036108805497],
            [4.618032647335271, 0.5622428794149863],
            [4.622896934168692, 0.5657135853691281],
            [4.622324835216743, 0.5705619571277116],
            [4.618908698263188, 0.576150101596504],
            [4.619942559283211, 0.5829637416642596],
            [4.623080343225749, 0.5865888596779985],
            [4.627366741914952, 0.5891007037585024],
            [4.625828678331314, 0.5958140366842388],
            [4.622556484991971, 0.5973158663891203],
            [4.623893278605859, 0.6012336290654768],
            [4.622262347903294, 0.6066989313254262],
            [4.627863181923708, 0.6062119204778728],
            [4.628158027893637, 0.5995469217756733],
            [4.633412712447807, 0.6024178627955347],
            [4.633462037595128, 0.6057616234587095],
            [4.637841490970744, 0.6101531871992117],
            [4.64128190717654, 0.6119237887869968],
            [4.648869308534896, 0.6134645058982339],
            [4.648750687788837, 0.6072439357097493],
            [4.651554793764315, 0.6073605735643809],
            [4.652393058068553, 0.6131108742321901],
            [4.655628299217489, 0.6166622117392645],
            [4.658788584330166, 0.6114160431519352],
            [4.668240027984746, 0.6125019043347881],
            [4.6782592533585845, 0.6102181088845818],
            [4.68173715114105, 0.6068922654125309],
            [4.680233441963554, 0.6004770191741051],
            [4.683381714665035, 0.5888259161999951],
            [4.687144964785354, 0.5859060662588],
            [4.692153524177562, 0.586973131119567],
            [4.694540049847831, 0.5898055812446316],
            [4.695203586805121, 0.5970036583968236],
            [4.6940958534931125, 0.6008335931447845],
            [4.783709796084592, 0.60535264267908],
            [4.82777152892414, 0.6079937747162047],
            [4.824211420839491, 0.6591952497010426],
            [4.852949805855316, 0.6604610151980013],
            [4.866927724649472, 0.6619219995098145],
            [4.895889953907668, 0.6640223404888591],
            [4.910095814937732, 0.664763201304724],
            [4.907385223700478, 0.6976643743320317],
            [4.914258716273771, 0.6981279370033484],
            [4.913896689398806, 0.701873122446237],
            [4.948919594673792, 0.7040104577781877],
            [4.955748565031144, 0.6155439283554622],
            [4.961510351634329, 0.5275482572138405],
            [4.966877469787755, 0.43946151034398423],
            [4.949267504008198, 0.43812072277563874],
            [4.8685708071710225, 0.4331953795029944],
            [4.871815821578611, 0.3569357004064936],
            [4.865628145304642, 0.35716988958282925],
            [4.854131408039787, 0.3558180243048637],
            [4.845824642000394, 0.3560529328551642],
            [4.839351946746438, 0.3595006859365879],
            [4.826740646856824, 0.3643877460048217],
            [4.816374631039509, 0.37115425584718803],
            [4.787290452295815, 0.38425832809647303],
            [4.777261000817231, 0.38830187269771826],
            [4.768999841239836, 0.39036034293168015],
            [4.754812814078884, 0.3907708314525568],
            [4.742799204552732, 0.39368599357605155],
            [4.7345257672704895, 0.3936011050871203],
            [4.721405628565874, 0.39430116885305044],
            [4.711100807936022, 0.39307438618659407],
            [4.703079731134438, 0.39061218896246974],
            [4.696894606127666, 0.3866633765909686],
            [4.6895979611747824, 0.3798868749324607],
            [4.682412457741228, 0.37660159036445534],
            [4.674405192797459, 0.3785568653138227],
            [4.670604125772451, 0.38052846612260677],
            [4.663697893134692, 0.3864003185784179],
            [4.6552536001033475, 0.3972005189682044],
            [4.645938357033168, 0.40744295802701236],
            [4.64129343861548, 0.41403061387966694],
            [4.637452190279868, 0.4237700251951919],
            [4.635807743176905, 0.4299914268354521],
            [4.635475763570932, 0.43829818742503507],
            [4.636824297549137, 0.4442648233715902],
            [4.635999994414661, 0.4506371782905062],
            [4.633733962113412, 0.45672692240861945],
            [4.6302898600828755, 0.4613094326209126],
            [4.624503254303866, 0.4661195208008615],
            [4.622748506652992, 0.47100694212008365],
            [4.623137355203591, 0.4747282002794283],
            [4.6268496543828945, 0.47936401608393764],
            [4.62849279402605, 0.4865040536552713],
            [4.621860119011813, 0.49659807858734895],
            [4.619021722441042, 0.5072857479065899],
            [4.615029614336635, 0.5176802354603232],
            [4.6091338180252714, 0.5309213169059349],
            [4.60850233643161, 0.5378596382369965]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.35643590453876,
          "lat": 39.085468626144575
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17083"],
        "coty_name": ["Jersey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jersey County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00424243"
      },
      "bbox": [
        4.60850233643161, 0.3558180243048637, 4.966877469787755,
        0.7040104577781877
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.9097161594812695, 3.9755145206577724],
            [4.974702941863809, 3.9794474197184595],
            [5.024382809150973, 3.982461099354681],
            [5.044295700418984, 3.983828385477697],
            [5.098996148152486, 3.987023280048339],
            [5.138669084862254, 3.9886510572487786],
            [5.174573707125783, 3.9897485655295193],
            [5.205222094822162, 3.991085089840908],
            [5.2938461824206815, 3.99571102311372],
            [5.300166871000966, 3.9280372682601277],
            [5.305085320196417, 3.8704096841928726],
            [5.308353628217406, 3.827192721254494],
            [5.3099845402205395, 3.802284035134675],
            [5.311913770495373, 3.779360040658565],
            [5.318526507319295, 3.696880222714553],
            [5.275787772705511, 3.692971408836696],
            [5.2332975388854654, 3.689745379410921],
            [5.190034562472748, 3.6870117089178147],
            [5.147129431970709, 3.6837961564075523],
            [5.104157334278486, 3.6794989530353734],
            [5.0614669881118495, 3.6755197834104556],
            [5.004102035486943, 3.6716969657003062],
            [4.97788715530428, 3.6701407434761775],
            [4.97780847927423, 3.668772330954811],
            [4.934488892049339, 3.6661989025037185],
            [4.930258521411449, 3.7243983806400784],
            [4.9268351187247115, 3.7679124857658572],
            [4.923362084731183, 3.804470694653481],
            [4.920202137077202, 3.840819949161366],
            [4.920482822141546, 3.8409958821854837],
            [4.910782534866662, 3.9583990530770463],
            [4.9097161594812695, 3.9755145206577724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.66226243007942, "lat": 42.35179542373413 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17177"],
        "coty_name": ["Stephenson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stephenson County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "01785076"
      },
      "bbox": [
        4.9097161594812695, 3.6661989025037185, 5.318526507319295,
        3.99571102311372
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.527986536013801, 2.40276420828121],
            [7.570328671214561, 2.4066588095240973],
            [7.5746318971892865, 2.3635144488184854],
            [7.61748636614232, 2.367340217912901],
            [7.688049868393048, 2.3749817662139234],
            [7.692051567323197, 2.3334258679837294],
            [7.692458458641104, 2.33120210812675],
            [7.6978665044083385, 2.27496065214852],
            [7.700749083889394, 2.2434626857885545],
            [7.7062077802287225, 2.181883060099234],
            [7.7129482056346585, 2.1134764531443375],
            [7.643422172986946, 2.1055532483533526],
            [7.572076853724007, 2.098899373911753],
            [7.54011335078547, 2.095767270458151],
            [7.473493913813162, 2.0898766903114208],
            [7.460187023300291, 2.2199641788463294],
            [7.403245400752218, 2.2146095821524656],
            [7.398167820420725, 2.2602745527281547],
            [7.39826291959455, 2.261230654273128],
            [7.393759798931311, 2.300945514851888],
            [7.392811226649533, 2.3018070857255712],
            [7.3910780488758085, 2.316660234141909],
            [7.402975875031414, 2.318078063764413],
            [7.404530938872683, 2.324794272257435],
            [7.4115815411346375, 2.329387592083804],
            [7.41327672799248, 2.333345209490519],
            [7.401517238358011, 2.3307906491560084],
            [7.399019703050211, 2.3322220712076347],
            [7.3994002398664795, 2.3358932431847417],
            [7.403292683953492, 2.3373348020848614],
            [7.4046597933189595, 2.3410566310575533],
            [7.401791516738634, 2.349303685527989],
            [7.397383259898943, 2.3515988105401266],
            [7.398190572509499, 2.3641092911634525],
            [7.4007053726822205, 2.3676714352265376],
            [7.404218370308434, 2.3694690215313803],
            [7.405828686577955, 2.3727396214122023],
            [7.398869746906644, 2.375721148825462],
            [7.397604520000644, 2.3810936557120597],
            [7.400368431838224, 2.3882804489611926],
            [7.403681241376561, 2.3923234672074054],
            [7.45593101973414, 2.3966429970687617],
            [7.527986536013801, 2.40276420828121]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.56354148361423, "lat": 40.58284496753213 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18015"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00450406"
      },
      "bbox": [
        7.3910780488758085, 2.0898766903114208, 7.7129482056346585,
        2.4066588095240973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.700749083889394, 2.2434626857885545],
            [7.721495640370671, 2.245542054648246],
            [7.799689038024497, 2.2541868994919314],
            [7.85749101592228, 2.260858388086201],
            [7.914094888050086, 2.267520974410993],
            [8.02671549854721, 2.2808008943147198],
            [8.08290946877279, 2.2875254558224865],
            [8.083974009288182, 2.2733047584108177],
            [8.09435828259836, 2.186589975594007],
            [8.101088035082828, 2.1286450661145775],
            [8.016055828406838, 2.118926841004786],
            [7.945253307104803, 2.110286893876593],
            [7.8597237496298575, 2.0998597709706774],
            [7.815731406695458, 2.094660116772743],
            [7.818620630522312, 2.065308491236437],
            [7.7902466660699226, 2.0624669709609083],
            [7.788686939624529, 2.077109341481682],
            [7.767281849502835, 2.0749509187220143],
            [7.7628885411578255, 2.118424158558689],
            [7.7129482056346585, 2.1134764531443375],
            [7.7062077802287225, 2.181883060099234],
            [7.700749083889394, 2.2434626857885545]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.11694300692712, "lat": 40.48359479365635 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18067"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00450360"
      },
      "bbox": [
        7.700749083889394, 2.0624669709609083, 8.101088035082828,
        2.2875254558224865
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.964234125089441, 2.8374165663395154],
            [6.999448793371056, 2.8577632902732693],
            [7.004420888418732, 2.8648157043089175],
            [7.0218222268842485, 2.889871909909263],
            [7.045233561266215, 2.9032569574328946],
            [7.065271324548293, 2.9151842164741866],
            [7.072099425632077, 2.915944052730787],
            [7.120005946180349, 2.903408988118088],
            [7.158877268498724, 2.8781473873991175],
            [7.180176322315625, 2.8668105643259256],
            [7.1859831388674715, 2.8611416265163943],
            [7.19276873464271, 2.859874737271224],
            [7.202334039525196, 2.8664741112094445],
            [7.214361751920902, 2.8726050871491267],
            [7.219381908494971, 2.879748931397915],
            [7.2203842088844015, 2.8726769205863327],
            [7.225507998697581, 2.815115528432914],
            [7.236317640805961, 2.6987871043874434],
            [7.243675240940595, 2.6195265864259505],
            [7.2500376444621635, 2.5545019677552663],
            [7.20777670374364, 2.550229892203051],
            [7.2139372752698145, 2.49028421588613],
            [7.215613702945751, 2.475826196725699],
            [7.1309813506145225, 2.467516432551886],
            [7.13679681606062, 2.409863631175487],
            [7.138599394224817, 2.3953342684212595],
            [7.141561673962731, 2.366224286084785],
            [7.085864827016198, 2.3611940433895158],
            [7.015206489026043, 2.354520088662609],
            [7.012482387639321, 2.38365876148539],
            [7.002726580277047, 2.4842173793848765],
            [6.9995403219569585, 2.5147761750107476],
            [6.997712179277359, 2.529915981860082],
            [6.992194258859873, 2.529367904973209],
            [6.987115932596945, 2.5840046071057254],
            [6.984408947392191, 2.616623159669362],
            [6.97782611311946, 2.6895863874367136],
            [6.969027231511258, 2.787181987742416],
            [6.964234125089441, 2.8374165663395154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.11610117463646,
          "lat": 41.022983249591526
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18073"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00450494"
      },
      "bbox": [
        6.964234125089441, 2.354520088662609, 7.2500376444621635,
        2.915944052730787
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.46827265055841, 3.4325014308119903],
            [7.549014704015803, 3.4409524414960404],
            [7.658786953656775, 3.452544837348585],
            [7.687825171151937, 3.455337110640402],
            [7.760125624267612, 3.463404838855522],
            [7.808196477377203, 3.46835917858653],
            [7.815504475904068, 3.403749041144909],
            [7.816123959419336, 3.400053991637726],
            [7.820951367833052, 3.35949859214265],
            [7.820846791817196, 3.358599641901965],
            [7.82565402826779, 3.316905463892499],
            [7.8280094618908365, 3.294466295795465],
            [7.835652631915859, 3.2294464587758918],
            [7.840096045365942, 3.1871053082301706],
            [7.7969992725219655, 3.1824660938630904],
            [7.789852928060412, 3.182088106932785],
            [7.747273637590223, 3.1770934496557013],
            [7.6723786480206995, 3.169273493526715],
            [7.672397142495958, 3.167842043500215],
            [7.6577546599805775, 3.1661266997678617],
            [7.657507114819258, 3.167258575873779],
            [7.6402666855031525, 3.1653805854953427],
            [7.569480045161965, 3.1567430146027826],
            [7.562517084121358, 3.1562378512933864],
            [7.538904184374848, 3.153462612708982],
            [7.540689706614125, 3.138957939656758],
            [7.543666880313255, 3.1099543256957394],
            [7.5006650094954965, 3.1055631622205504],
            [7.495022137018497, 3.161773682107337],
            [7.494656676974368, 3.162237761943562],
            [7.491790318335638, 3.192446360835069],
            [7.50757174594186, 3.193881625410935],
            [7.50988212375033, 3.19560549067429],
            [7.509142960823759, 3.202823370981943],
            [7.510422623416632, 3.2061752458287547],
            [7.5074247923217, 3.235880549155827],
            [7.515134657707986, 3.246220514415501],
            [7.510497852782313, 3.2921135872196614],
            [7.507557415086962, 3.317408183332759],
            [7.506365289747064, 3.3249911856646754],
            [7.477390476757646, 3.3232196175305586],
            [7.4727435485419695, 3.3821994384810763],
            [7.46827265055841, 3.4325014308119903]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.28983374943178, "lat": 41.61664158487312 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18141"],
        "coty_name": ["St. Joseph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Joseph County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00452855"
      },
      "bbox": [
        7.46827265055841, 3.1055631622205504, 7.840096045365942,
        3.46835917858653
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.260671537568358, 0.448458484530389],
            [8.266230299846615, 0.43981580764541733],
            [8.268227531667684, 0.4440951118015167],
            [8.277996569382552, 0.44509933646685435],
            [8.281863949188924, 0.4481667592813997],
            [8.285557668525763, 0.44800792610879],
            [8.286636400507529, 0.45168172917494903],
            [8.29585212013388, 0.45902369831837614],
            [8.294108394882366, 0.4625177751672808],
            [8.30058331994081, 0.46940103850766934],
            [8.302841216214286, 0.4775176492775796],
            [8.302161536784796, 0.481509667016407],
            [8.304961069807849, 0.4880039179435627],
            [8.307505827836948, 0.49016623467119935],
            [8.310504638221218, 0.4979038401565698],
            [8.316538886471394, 0.4983387692912186],
            [8.319881177009918, 0.5006026597778845],
            [8.317017942771844, 0.5102839737089724],
            [8.31836721096143, 0.5166228253110607],
            [8.324184186011099, 0.5294681039952206],
            [8.334013145486919, 0.5305311655227504],
            [8.335810697078864, 0.5359764739065497],
            [8.338591809123146, 0.5365082814668132],
            [8.341371529837652, 0.5334602775295625],
            [8.343873827347405, 0.5351005835222135],
            [8.34418769602572, 0.5393642296018468],
            [8.349101930868333, 0.5384290104928166],
            [8.352649798404991, 0.5402741200389747],
            [8.35139619390232, 0.5439051895920887],
            [8.35663695284978, 0.5458392258070176],
            [8.35932030223691, 0.5482522638141365],
            [8.36292310341013, 0.5450138698068908],
            [8.367618163845245, 0.5473618529521487],
            [8.371815277954315, 0.5519798031209514],
            [8.368410386895231, 0.5559318405484373],
            [8.370959945488602, 0.5584913327606008],
            [8.377868306960128, 0.5510350106218184],
            [8.38061414989297, 0.5545880860894633],
            [8.385376030094186, 0.5573619898075103],
            [8.39075538592557, 0.5538334923260562],
            [8.391705654859917, 0.5482422937181428],
            [8.403303846446757, 0.5466229768990303],
            [8.408884748489466, 0.5466682237172232],
            [8.40902533601541, 0.5439890554937599],
            [8.417875052277774, 0.4677412543188904],
            [8.432434497337265, 0.46948874982509886],
            [8.433251112532787, 0.4626000821285987],
            [8.44713583858757, 0.4639557759356255],
            [8.449885395192785, 0.44207212394968676],
            [8.478390236139028, 0.44503285746803567],
            [8.48197340647578, 0.4158488557796542],
            [8.51064222601675, 0.41871207973035646],
            [8.519364650492701, 0.3462280601255615],
            [8.471158714762696, 0.3403507723820194],
            [8.442210481840059, 0.3373367223294174],
            [8.401070088993759, 0.3326604676343353],
            [8.380932277274026, 0.3307963848114533],
            [8.34748094548469, 0.3261324303695589],
            [8.349013539708901, 0.31159083144535915],
            [8.341699202212064, 0.31072959847619674],
            [8.342597906410626, 0.3034623726193405],
            [8.335412666402377, 0.3025883389221062],
            [8.336349951316558, 0.2952165698945573],
            [8.32920928797998, 0.29428303294643365],
            [8.33094445516111, 0.28028001824973847],
            [8.310378895511404, 0.27792069185846696],
            [8.308239409368783, 0.29292135140519227],
            [8.27979517126109, 0.2890100687009594],
            [8.271009576619608, 0.36258173889061684],
            [8.270029238349261, 0.36248211604533176],
            [8.266916152588072, 0.39434698352039],
            [8.260671537568358, 0.448458484530389]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.74750092941954, "lat": 38.68516158338777 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18143"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00450386"
      },
      "bbox": [
        8.260671537568358, 0.27792069185846696, 8.519364650492701,
        0.5584913327606008
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1999447329749744, 3.240742792571311],
            [3.243252635113125, 3.242720897963071],
            [3.250141260717004, 3.2426643710798326],
            [3.2823362279019244, 3.2438094550481535],
            [3.326277271794475, 3.2456990788942615],
            [3.372583700831747, 3.2478780803574088],
            [3.379942211475337, 3.2478899391137555],
            [3.420088622872928, 3.249318650014644],
            [3.4303011963496943, 3.2494618622238023],
            [3.4877221319455614, 3.2513480511641717],
            [3.5448000470462038, 3.2540724795953273],
            [3.5469546137336185, 3.2083603300501746],
            [3.5477993642796513, 3.1957652542705652],
            [3.5480591711505745, 3.1763903535695985],
            [3.548928746939286, 3.1491191073048768],
            [3.550458902490488, 3.0779695343502818],
            [3.553825754725042, 3.020483558960162],
            [3.5550892014582334, 2.9912672628352652],
            [3.559549277508831, 2.9915010779255473],
            [3.5610194199160494, 2.931195404440683],
            [3.561873860783916, 2.9019546837354184],
            [3.4903542025305314, 2.898367913800818],
            [3.475187292735222, 2.897493129861229],
            [3.374329783217133, 2.8928501614892244],
            [3.2684074441662614, 2.888128059536308],
            [3.2142909181663324, 2.885888949968249],
            [3.2104529937753203, 2.9781404449503555],
            [3.2092064232987285, 2.978092947010467],
            [3.205435804818999, 3.066064039645267],
            [3.2036478741488894, 3.113402129205048],
            [3.202005481325706, 3.1755716967722303],
            [3.1999447329749744, 3.240742792571311]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.0655042079411, "lat": 41.68631593719636 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19095"],
        "coty_name": ["Iowa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iowa County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00465236"
      },
      "bbox": [
        3.1999447329749744, 2.885888949968249, 3.561873860783916,
        3.2540724795953273
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.0784968214520627, 3.206704581086067],
            [2.1654845680142127, 3.208705448343008],
            [2.2231859213353706, 3.2099688008574647],
            [2.3243961060369167, 3.212464997063081],
            [2.3388753635486474, 3.2129550580452335],
            [2.4242422192439523, 3.2151724839055524],
            [2.427234739559599, 3.097888153498282],
            [2.429373572045682, 3.0170028990285562],
            [2.431054825984033, 2.951575214905997],
            [2.4458869854146466, 2.9521400875408577],
            [2.447617905961989, 2.884896504250388],
            [2.448579605286028, 2.8582563449140945],
            [2.4492157211000443, 2.8411263085547196],
            [2.4443669895181195, 2.837574764882157],
            [2.441324013435016, 2.8327790813358016],
            [2.4357272592355277, 2.8327264931581504],
            [2.4311208179972867, 2.846757708467094],
            [2.426274565104774, 2.846067192587073],
            [2.4271303814395804, 2.842754007328431],
            [2.4258871683900405, 2.8374622986824845],
            [2.4169328832720653, 2.8354723785779865],
            [2.414668666099813, 2.842673862512969],
            [2.41128586662235, 2.8439560514079747],
            [2.4049801709700396, 2.8428995663043652],
            [2.401753831387575, 2.837385756839301],
            [2.3982483123707743, 2.835253750160675],
            [2.392664368124509, 2.8354798048200753],
            [2.3933601835257883, 2.839835610698455],
            [2.3968134380054718, 2.841456428903748],
            [2.3983767168105308, 2.845265046978605],
            [2.3956132277533393, 2.8509338644330087],
            [2.3924172690004415, 2.8504418268647687],
            [2.388639503922945, 2.8436993461516833],
            [2.385380809336388, 2.840939364667832],
            [2.380650870315475, 2.840978115080713],
            [2.3800800137062144, 2.8453497340582876],
            [2.384327130664099, 2.848914624060839],
            [2.3852830530128437, 2.856095561255365],
            [2.3770795487808534, 2.855944528917013],
            [2.3684391829936358, 2.8504733884552658],
            [2.3643974628697944, 2.8526693647677988],
            [2.364891366031308, 2.855719390353032],
            [2.3493523340939446, 2.8557925224614378],
            [2.2853432549503476, 2.8573702240956442],
            [2.227834615028831, 2.8566607192416407],
            [2.1671554047974384, 2.855192603510998],
            [2.105287583106345, 2.853570790724132],
            [2.104147528530214, 2.905669525847819],
            [2.103199596514331, 2.9426231317243112],
            [2.0856525276182882, 2.9422490854128496],
            [2.084006339346095, 3.007830213521486],
            [2.082818337315199, 3.0609564336125787],
            [2.0817963180800017, 3.092947298425973],
            [2.0791794027073713, 3.18887938590002],
            [2.0784968214520627, 3.206704581086067]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.57344743087076, "lat": 41.68538884687828 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19153"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00465265"
      },
      "bbox": [
        2.0784968214520627, 2.8327264931581504, 2.4492157211000443,
        3.2151724839055524
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.6099182707852848, 2.226957426345764],
            [1.63457000796397, 2.22712727900018],
            [1.6949693536016954, 2.2280582487757297],
            [1.7379144864429128, 2.2283876514444385],
            [1.7811079202977502, 2.228332288801931],
            [1.7948993796996382, 2.2286116801413955],
            [1.8877804330684285, 2.2297616738431647],
            [1.9516884038349598, 2.230781832937118],
            [1.9520101775822922, 2.2164664756196357],
            [1.9531355655027578, 2.14367610568842],
            [1.9548534789659233, 2.0570882886759327],
            [1.9571171231939781, 1.9566858303956804],
            [1.956989468477328, 1.9554832849895254],
            [1.9579760623949924, 1.9051685117877724],
            [1.909264252654974, 1.903144913248134],
            [1.7948331644479925, 1.899926078240064],
            [1.753347894225956, 1.8987772429575036],
            [1.7161884023321754, 1.8980480096889114],
            [1.6149248974299026, 1.8957160833449502],
            [1.6149535367831314, 1.9013760866932614],
            [1.6139091369542753, 1.9503613734246334],
            [1.6131203311239406, 2.004933377795679],
            [1.6107552250482375, 2.132934291023825],
            [1.6098219939194842, 2.193720214421298],
            [1.6099182707852848, 2.226957426345764]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.24398229860972, "lat": 40.73515820320575 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19159"],
        "coty_name": ["Ringgold"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ringgold County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00465268"
      },
      "bbox": [
        1.6098219939194842, 1.8957160833449502, 1.9579760623949924,
        2.230781832937118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8481011023372165, 0.35965519442758775],
            [0.8530632871547393, 0.35695344593871775],
            [0.8618607359420872, 0.35994893620979523],
            [0.873806438827131, 0.36741653006385283],
            [0.8815632539783503, 0.3715534692864395],
            [0.8964354466416964, 0.3731786669107268],
            [0.910191176023079, 0.3706585894489892],
            [0.9246667262044891, 0.36353869533863825],
            [0.9315715352660415, 0.35466650424994134],
            [0.9346515277987992, 0.35225406978088397],
            [0.9515100106782833, 0.34332632007743635],
            [0.9573879270323581, 0.33871333721812363],
            [0.9622505912791559, 0.3385565143556461],
            [0.9676067177000302, 0.3356804006708175],
            [0.9806163527073023, 0.3352552725630609],
            [0.9868562370571612, 0.33804588547341713],
            [0.990700718849908, 0.3383763843047378],
            [1.0038003368523332, 0.3461452749142613],
            [1.0084987656317488, 0.3453724151218868],
            [1.0137597191994168, 0.3396830638869217],
            [1.015600324678245, 0.34249769638074773],
            [1.0133375082716838, 0.3466202025723113],
            [1.014164229655907, 0.3506397591017376],
            [1.017891618432895, 0.35119596076485554],
            [1.0216337724307851, 0.3480965415333457],
            [1.0611262526706364, 0.348543857977951],
            [1.0890531455246606, 0.34865117460873746],
            [1.0904440717658814, 0.2683266086085325],
            [1.1000901760745965, 0.26900050809167514],
            [1.1032486538409263, 0.2703850591363119],
            [1.1068076703278744, 0.2755141571726616],
            [1.1055067581509028, 0.2799382866571896],
            [1.1072846120003477, 0.2857262618674996],
            [1.1128300373911022, 0.2830026510454552],
            [1.1209878595068519, 0.27649231004552566],
            [1.1262070356261429, 0.2735345337165409],
            [1.1374935059913538, 0.2721704859263669],
            [1.139915136744357, 0.2742041255804646],
            [1.1483684177320874, 0.2736880070568734],
            [1.1509970784330863, 0.27102282071861616],
            [1.1533702946448046, 0.26336640585483106],
            [1.1562354040802583, 0.260515815409335],
            [1.1595953729652477, 0.2606486495358429],
            [1.1682913567273694, 0.25822474600657813],
            [1.1750015868273749, 0.26434279854876186],
            [1.1764894847293823, 0.2689392881030133],
            [1.1747638756377612, 0.2715285337496638],
            [1.16688571412711, 0.27890093818032285],
            [1.166914004948411, 0.2848513245426458],
            [1.1720293816996714, 0.2889353834120322],
            [1.180648529985785, 0.2919353101386601],
            [1.1868603215761133, 0.29050310565266935],
            [1.1903227572311252, 0.28699843501350386],
            [1.1904223603147637, 0.2619205407091612],
            [1.191401155421248, 0.2027730954494365],
            [1.1920733543450281, 0.11466775590427582],
            [1.1926453764929699, 0.04111702783888576],
            [1.149656754913643, 0.04083711136022596],
            [1.1068004350411353, 0.040197795447426285],
            [1.0496012666094263, 0.03992809748045692],
            [1.013612983400512, 0.039599252398987476],
            [0.9204885735595478, 0.0392143005597269],
            [0.8494146610689427, 0.03873485260853703],
            [0.8491780766934772, 0.03965550304425819],
            [0.8491913662747319, 0.10445709271025208],
            [0.8490371866642183, 0.15243992937436612],
            [0.8487306006300872, 0.1710118149368648],
            [0.849021912460339, 0.18556208254311335],
            [0.8485806647929028, 0.207916348892794],
            [0.8482176060624226, 0.24417610714050478],
            [0.8484782945445916, 0.28821400828032606],
            [0.8479465316192649, 0.2965277349848924],
            [0.8472192612046496, 0.34653853097259096],
            [0.8481465819191013, 0.35100596312726917],
            [0.8481011023372165, 0.35965519442758775]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.29260176874901, "lat": 38.88468359130725 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20045"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00484992"
      },
      "bbox": [
        0.8472192612046496, 0.03873485260853703, 1.1926453764929699,
        0.3731786669107268
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.324631466181476, -0.7437653433813793],
            [-2.3217735579060594, -0.6707738046088098],
            [-2.317750291819731, -0.5678419387462764],
            [-2.2323178243560746, -0.5702072783088339],
            [-2.1470283035677666, -0.573834986057493],
            [-2.150064648999131, -0.6614796671779511],
            [-2.1063511443292247, -0.6632294701157434],
            [-2.064615027171393, -0.6652285430313497],
            [-2.0227262946827635, -0.6667939426940929],
            [-1.9800506556634099, -0.668178718958692],
            [-1.8941558866826944, -0.6705755677257084],
            [-1.8975776176085688, -0.7732503648477672],
            [-1.9001541122057901, -0.8470550865489557],
            [-1.8928770061776896, -0.8473084380081438],
            [-1.8960153122536698, -0.9405178345729822],
            [-1.9819458566340893, -0.9372500212176421],
            [-1.989487082996774, -0.9372219919543546],
            [-2.0386126510276594, -0.935278914828984],
            [-2.0670945862712817, -0.9345721552088855],
            [-2.1807351663983567, -0.9300458727308392],
            [-2.237505034193255, -0.9275758927551958],
            [-2.240082419884768, -0.9275934043453462],
            [-2.3233260981361417, -0.9237999467717829],
            [-2.3204375623934896, -0.8322646484853878],
            [-2.328489852113893, -0.8319149781830883],
            [-2.324631466181476, -0.7437653433813793]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.31215905849254,
          "lat": 37.887610295083526
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20047"],
        "coty_name": ["Edwards"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edwards County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00484993"
      },
      "bbox": [
        -2.328489852113893, -0.9405178345729822, -1.8928770061776896,
        -0.5678419387462764
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0270592149715636, -0.16534570234472062],
            [-1.0256851312005348, -0.07737989420448861],
            [-0.9874047577839443, -0.07792914507880025],
            [-0.9864356534825901, -0.07847646760012345],
            [-0.8545017348204653, -0.08143452659878089],
            [-0.7910538603490412, -0.0827161709051813],
            [-0.7120544127306755, -0.08377019522612697],
            [-0.5979014685555119, -0.08533195753994828],
            [-0.5991885611190073, -0.17336578422387175],
            [-0.6008701745582474, -0.29060681358793483],
            [-0.601523754631729, -0.34922532886268026],
            [-0.6027604495674039, -0.43722523280576836],
            [-0.6041263513542464, -0.5252270506262626],
            [-0.6229554605313726, -0.5250084326040599],
            [-0.7331601960095535, -0.522953194529063],
            [-0.7756740509412475, -0.5220572726420678],
            [-0.8610649888752293, -0.5209299264662055],
            [-0.9756007667364275, -0.5191174643559331],
            [-0.9896292022407047, -0.5186169668032357],
            [-1.0325345501410044, -0.517762634308362],
            [-1.0309822429122835, -0.43725061787464287],
            [-1.0309996626249465, -0.43019145212541837],
            [-1.033144389671063, -0.43010157550922357],
            [-1.0307566570720779, -0.34188183418613594],
            [-1.029165455718116, -0.2560276786904968],
            [-1.0270592149715636, -0.16534570234472062]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.64802903741267, "lat": 38.39164927258317 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20113"],
        "coty_name": ["McPherson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McPherson County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00485021"
      },
      "bbox": [
        -1.033144389671063, -0.5252270506262626, -0.5979014685555119,
        -0.07737989420448861
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.817933399708942, 0.07001940922694036],
            [-2.7458668364697627, 0.0659994724505865],
            [-2.6746874838311108, 0.06205205502534476],
            [-2.648036536642896, 0.060700017318276255],
            [-2.548886748922535, 0.05678888978574931],
            [-2.4774863235564997, 0.05400433568037425],
            [-2.4734614228499368, 0.05427669650900452],
            [-2.4456546026195234, 0.052975282204896605],
            [-2.4446758252216796, 0.05264950501678059],
            [-2.363725840756015, 0.049398961991442426],
            [-2.316891508077201, 0.04765953251779183],
            [-2.306667272653698, 0.0472962143758149],
            [-2.3131816956271507, -0.09753839942893341],
            [-2.3161503710837184, -0.18733386556901546],
            [-2.3177040522554084, -0.2443351406378321],
            [-2.3196594040146006, -0.30300498474456455],
            [-2.3225239886783595, -0.39102009461900955],
            [-2.3939706227293738, -0.3884132162064849],
            [-2.4138773704230685, -0.38791809944099653],
            [-2.4827816099901336, -0.3851958686489952],
            [-2.493907571675864, -0.38463891137101847],
            [-2.5467161090218235, -0.3826797292705885],
            [-2.548799941800913, -0.3828271894287067],
            [-2.608372653640174, -0.38034545845207735],
            [-2.6367843016321233, -0.3789952000371292],
            [-2.645914998674193, -0.37881640138198264],
            [-2.6816719042621875, -0.3771926984393558],
            [-2.8220129959473037, -0.37042462255272746],
            [-2.835414793793041, -0.3697733951769937],
            [-2.830006144287581, -0.22337987091873288],
            [-2.827134053366136, -0.13576971368068727],
            [-2.826607468476858, -0.12987511609610464],
            [-2.824703525690442, -0.07704691052320867],
            [-2.82163504775086, 0.010754732552189764],
            [-2.820328231458855, 0.02589909284225219],
            [-2.817933399708942, 0.07001940922694036]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.916155501992, "lat": 38.47941317754198 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20135"],
        "coty_name": ["Ness"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ness County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00485031"
      },
      "bbox": [
        -2.835414793793041, -0.39102009461900955, -2.306667272653698,
        0.07001940922694036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.453935095707185, -0.9704312382614224],
            [7.45235292414244, -0.9656219364245744],
            [7.452322421691466, -0.9584257916848399],
            [7.448413337217987, -0.9508453458083519],
            [7.4488493811803504, -0.9410052440038444],
            [7.445694039609495, -0.9250505001139551],
            [7.443801808697923, -0.9231603199790246],
            [7.437641314891719, -0.921652111814091],
            [7.432138899432235, -0.9180728711595924],
            [7.429706430602879, -0.9127019381654411],
            [7.423735512476897, -0.9065263823096171],
            [7.424778380845708, -0.9029879926043994],
            [7.428096616892191, -0.9009513506584202],
            [7.430954675829144, -0.9034217010664737],
            [7.433908807481058, -0.9092304797908496],
            [7.434949264885564, -0.9150836679231791],
            [7.438101883614704, -0.9156703982898422],
            [7.442097250324154, -0.9071514137452559],
            [7.445222834208758, -0.9054768659271629],
            [7.480526798563146, -0.8301885248195924],
            [7.488365042955003, -0.820377794690863],
            [7.511624582669655, -0.7982315908300828],
            [7.52418721030451, -0.7793220433719452],
            [7.548678654206269, -0.7464722852669626],
            [7.551971675992451, -0.7435996997388097],
            [7.557164223794186, -0.74493338699742],
            [7.559988727252174, -0.7478250278434707],
            [7.564151698564204, -0.7468091106908546],
            [7.566170594619036, -0.7491335139041132],
            [7.571161297952557, -0.7467558485481324],
            [7.57602875873699, -0.7462844454096028],
            [7.578002291456676, -0.7411056477332532],
            [7.585938508374211, -0.741080788024139],
            [7.586661125463308, -0.7365441343088482],
            [7.592600618302333, -0.7310590519917458],
            [7.5942121489921925, -0.727056628643763],
            [7.604732817968702, -0.7259940211793694],
            [7.605264829006225, -0.7217340556731212],
            [7.615272198067085, -0.7182217951139711],
            [7.623063987256197, -0.7120014256888536],
            [7.631612171207971, -0.7005657984619706],
            [7.6424989178542395, -0.6976238761068501],
            [7.644873480125613, -0.69355929965504],
            [7.649855366942579, -0.6902858828045179],
            [7.608202577819514, -0.6587691274117506],
            [7.6390163251792345, -0.6264700383939998],
            [7.692576440218686, -0.6485173258312235],
            [7.7903468419981685, -0.688648771591452],
            [7.793266698434552, -0.7317955850690934],
            [7.794224803673529, -0.7317760154048054],
            [7.802717539008765, -0.7403707284872894],
            [7.806919548108207, -0.7457101675255785],
            [7.80752253358148, -0.7530138621129049],
            [7.812386232987386, -0.7578117195421266],
            [7.812381767652747, -0.7623375365721775],
            [7.8171368381040285, -0.7675984474702752],
            [7.822257118635117, -0.7706576137869465],
            [7.827627223674285, -0.7784565805332281],
            [7.833486674550344, -0.7832600614456241],
            [7.836060534719157, -0.7830684650621775],
            [7.835254560422679, -0.7872254581369138],
            [7.840730318829242, -0.789958049731205],
            [7.849506685765808, -0.7924442584802277],
            [7.846797551573851, -0.7992533169543337],
            [7.839698096039961, -0.79850778364921],
            [7.833754322410585, -0.8030439224851643],
            [7.834678505848994, -0.8101847385679664],
            [7.8249947757285545, -0.805242861490655],
            [7.824790713383764, -0.7980590403120272],
            [7.815754429546457, -0.7956251191398045],
            [7.810512186175105, -0.7840514335582301],
            [7.805660018105828, -0.78578648917228],
            [7.802151456832821, -0.7846134118362588],
            [7.797188611713355, -0.788040067839997],
            [7.7969888928595, -0.7919995743269875],
            [7.794628886538923, -0.7960922049863358],
            [7.780518198331008, -0.7963860240559966],
            [7.778009412049511, -0.8036632798630817],
            [7.779664426439876, -0.8068007406630012],
            [7.784327405765166, -0.8109404529888744],
            [7.7846644257682875, -0.8158320819132596],
            [7.787220983084898, -0.8194568462771923],
            [7.819119837493702, -0.903900047636474],
            [7.837848965056227, -0.9546048629933015],
            [7.738917916037251, -1.0496826107405681],
            [7.731328000028993, -1.0574184170288763],
            [7.7220845937247535, -1.0524155407637266],
            [7.718298339737576, -1.043816127663787],
            [7.71863655939806, -1.0395217912387638],
            [7.716859308224556, -1.036685154287418],
            [7.705186734678976, -1.0330093954053512],
            [7.701286927949611, -1.0302803305327077],
            [7.6957197578550085, -1.0301007640107223],
            [7.687037632009071, -1.034891894379674],
            [7.683849125974934, -1.0381790462296416],
            [7.681313830331335, -1.0467736341747156],
            [7.6847167709904, -1.0607480067109614],
            [7.694371693911818, -1.0739081311297705],
            [7.687084856382403, -1.0722207786642843],
            [7.681522776619743, -1.0730871628622514],
            [7.67740613957478, -1.0814621213331752],
            [7.678783486274847, -1.0855828157827294],
            [7.675279581311508, -1.0929630300643274],
            [7.669965318497731, -1.0986445709195036],
            [7.669727299155087, -1.103029980328439],
            [7.665696946436153, -1.105636506612086],
            [7.662928255290152, -1.1184258980421968],
            [7.656169139567521, -1.1176407588389112],
            [7.648817256763231, -1.1237278068815817],
            [7.640759766447725, -1.1361487433040034],
            [7.63961731070255, -1.1411684409119298],
            [7.640475512929992, -1.148886191868337],
            [7.637984416868061, -1.1538833540215137],
            [7.6306267125454985, -1.1602606473787782],
            [7.624990507033611, -1.152466095732276],
            [7.620761361102814, -1.1498140570807733],
            [7.613681724750377, -1.1488254177311663],
            [7.612553538639158, -1.1438981335976843],
            [7.615916351229329, -1.1401002779805365],
            [7.6090120873070175, -1.1327386299512379],
            [7.6009311198810305, -1.1349299403304494],
            [7.598161374867293, -1.1380588440935755],
            [7.593758460884736, -1.1380426251483644],
            [7.590429248781435, -1.1354368969996738],
            [7.5887188179380685, -1.1297202006801694],
            [7.584286996193637, -1.1265420851224284],
            [7.582650479090385, -1.11890654389992],
            [7.57950237051991, -1.115921077437153],
            [7.575844976738466, -1.1162344088011087],
            [7.573878720648163, -1.1201671006352873],
            [7.569513452088196, -1.119809280292948],
            [7.562390898006087, -1.1111564221364594],
            [7.559662194145278, -1.1089132061562104],
            [7.558144658847546, -1.1041390350757423],
            [7.5594267874260925, -1.091995450684938],
            [7.5573719004164355, -1.0831955197909744],
            [7.552094414062876, -1.076109658167325],
            [7.550776287515176, -1.0682577166635732],
            [7.552595340722068, -1.0619876622669957],
            [7.552264125767328, -1.05761671780151],
            [7.549735703458925, -1.0541230416861342],
            [7.544048243307457, -1.052153581211522],
            [7.540421499770881, -1.0463847893356089],
            [7.535279678572588, -1.042429955318501],
            [7.529381894588692, -1.0346187363666408],
            [7.525438011675455, -1.0274707803024088],
            [7.519894202071394, -1.022414273152477],
            [7.513169921934964, -1.0183260805819958],
            [7.504960785350618, -1.0156321973123692],
            [7.495872269083682, -1.0137141504906464],
            [7.481131481060332, -1.0140852190953673],
            [7.4689828401211305, -1.0260083922172285],
            [7.467327826409083, -1.0308652185646237],
            [7.467045709251781, -1.0382416690140446],
            [7.462712179739945, -1.0480602836901083],
            [7.461932361294716, -1.0543486128522168],
            [7.460013704200274, -1.0585098810387148],
            [7.452672220500159, -1.063585367577468],
            [7.445746175004797, -1.0626282753254614],
            [7.438986679111514, -1.0556580999272693],
            [7.434870879143429, -1.0569750744745665],
            [7.432389803221823, -1.054099174498624],
            [7.431671009171014, -1.048333805420014],
            [7.439880219405555, -1.0332811647121956],
            [7.440373327017124, -1.0277166267910092],
            [7.450274450979339, -1.0205685602670291],
            [7.4613635574844075, -1.0104101861922343],
            [7.462017798647066, -1.008137023919604],
            [7.456654712480143, -0.9982232375242794],
            [7.458132183210178, -0.9898755315020006],
            [7.456240084050042, -0.982318865169518],
            [7.45554341225733, -0.9744744513942278],
            [7.453935095707185, -0.9704312382614224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.84885822144747, "lat": 37.4781846783674 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21183"],
        "coty_name": ["Ohio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ohio County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00516938"
      },
      "bbox": [
        7.423735512476897, -1.1602606473787782, 7.849506685765808,
        -0.6264700383939998
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9208755399510418, -6.516116069176149],
            [3.9242634999550083, -6.512536213910321],
            [3.9238673217575224, -6.510195385620065],
            [3.928545460134092, -6.503305286385584],
            [3.9293438417871394, -6.499014811516132],
            [3.9458863748812463, -6.492577219610128],
            [3.9499672102406853, -6.493733009846685],
            [3.956356622428115, -6.490946991642642],
            [3.9603998085965215, -6.492144880664201],
            [3.9619832535923725, -6.489703000980501],
            [3.967411153739329, -6.487759526903421],
            [3.972540727924182, -6.481605201420497],
            [3.973874351391041, -6.476345829140318],
            [3.9776705687167073, -6.46926434518202],
            [3.9780069541735057, -6.46201078612615],
            [3.9821392079461413, -6.459801719972298],
            [3.980502705359153, -6.453747886007308],
            [3.981216103243469, -6.45140226256086],
            [3.9886875270147306, -6.445227503545762],
            [3.9998126085201027, -6.439136252472265],
            [4.002198199093402, -6.4350680381314245],
            [4.009168371548706, -6.4283950326517365],
            [4.007738369600142, -6.424815589969447],
            [4.011747529135456, -6.423059975580384],
            [4.016285112024502, -6.424722367905958],
            [4.017493788701867, -6.416461898212582],
            [4.020235021053062, -6.415311773676953],
            [4.019574513405957, -6.411358344581125],
            [4.021821765119651, -6.406106271966946],
            [4.0211061888497515, -6.403142114973518],
            [4.017439335151288, -6.399952483418114],
            [4.017838012766514, -6.394621027202533],
            [4.016759038629666, -6.386167810586821],
            [4.0210211788682635, -6.379925123967074],
            [4.021739925257009, -6.374608087521804],
            [4.025775914766916, -6.3698949787234405],
            [4.020167501220986, -6.368335329125305],
            [4.021311229502243, -6.365910508670394],
            [4.022073991662528, -6.357657946314362],
            [4.025662060034246, -6.358416014179047],
            [4.0274867461212285, -6.343544074155605],
            [4.025371992937336, -6.336268617347789],
            [4.022582337553318, -6.3332377062676635],
            [4.025313821327221, -6.3277784926773535],
            [4.030718139366797, -6.328824853965734],
            [4.039625964001308, -6.323865572495356],
            [4.040711745928635, -6.327758110474064],
            [4.046057167341128, -6.328984112420233],
            [4.049783635343563, -6.327074364090482],
            [4.052926662471626, -6.328263224005655],
            [4.060551018893484, -6.324710260636328],
            [4.0641362679715485, -6.3181999256815775],
            [4.071313967469935, -6.317747650535094],
            [4.074671223801914, -6.316047275797926],
            [4.076025874304652, -6.310606762318342],
            [4.072460207457281, -6.301623274924331],
            [4.077834262690208, -6.297485127637664],
            [4.0758254634185604, -6.2912723171374525],
            [4.082216199744254, -6.290526225182581],
            [4.091294954100136, -6.286518933217821],
            [4.092544512611248, -6.280640085904075],
            [4.090796540536012, -6.276159210051077],
            [4.099241447458549, -6.276671360921529],
            [4.098355039172051, -6.272174538042757],
            [4.1039234766181645, -6.270821562687634],
            [4.109074190672566, -6.2731858487354595],
            [4.116310045871646, -6.269666269868189],
            [4.1161014584230315, -6.265595849265939],
            [4.121542634144902, -6.264960730957875],
            [4.122899530202364, -6.2598803776103],
            [4.131120723309463, -6.254512332865946],
            [4.127654980951724, -6.252731717786209],
            [4.167054569162828, -6.251271260958742],
            [4.19271040224809, -6.249936362274205],
            [4.260677049244938, -6.246748209513133],
            [4.261166201619827, -6.249482736162121],
            [4.255213724684773, -6.250315704889341],
            [4.254229708455947, -6.254876896576926],
            [4.2583685916082334, -6.255964932831779],
            [4.26224343365669, -6.267101925936582],
            [4.269233928971806, -6.273187070609839],
            [4.279491067800087, -6.279148246910958],
            [4.283249314555545, -6.282704324606211],
            [4.284439464014973, -6.289477025268524],
            [4.282978543790877, -6.2930762440965955],
            [4.274583543149073, -6.299756180469333],
            [4.2721334462051965, -6.300744864302458],
            [4.263202029352204, -6.300092723258564],
            [4.259696065665803, -6.297145268971353],
            [4.257426735009471, -6.291910178456901],
            [4.257395614462785, -6.286549142504939],
            [4.255180362364242, -6.2862876722515315],
            [4.250962099433145, -6.295312925846506],
            [4.248146290493126, -6.29718852538919],
            [4.243270798858993, -6.305445640068723],
            [4.243493874242576, -6.310408100219659],
            [4.248418368469322, -6.31413457352477],
            [4.252042086251079, -6.313483457907786],
            [4.26233144461063, -6.3093487677085305],
            [4.265300549862022, -6.310649776473329],
            [4.266888575151016, -6.314378039402439],
            [4.264937174955791, -6.3190241790626045],
            [4.268944786223852, -6.331124603014102],
            [4.268991286824164, -6.334444467228002],
            [4.258969339812194, -6.334716721817747],
            [4.251777348163758, -6.337167966530907],
            [4.2440733200895595, -6.337306961528596],
            [4.241970569499754, -6.338940370158419],
            [4.243706989611204, -6.347864093613357],
            [4.243433968999152, -6.357981342400304],
            [4.242031031185416, -6.360498872352598],
            [4.235388757858258, -6.354437646916883],
            [4.228273611928234, -6.351834775471659],
            [4.22351272055982, -6.353431096697441],
            [4.221609385249107, -6.3588123078312275],
            [4.22187290469164, -6.362971806208238],
            [4.227004995756106, -6.376982954372095],
            [4.2263973759831215, -6.39302726178201],
            [4.22835460546336, -6.4008411894738115],
            [4.226015910767604, -6.4041508679990775],
            [4.221078362158028, -6.404414832658065],
            [4.218060586838741, -6.399715599986287],
            [4.2117846123543545, -6.395654243167845],
            [4.203779417509102, -6.3973082572249815],
            [4.200190369538033, -6.404507515693017],
            [4.2132324826240595, -6.4162534241828055],
            [4.216764850006499, -6.417968589831907],
            [4.228012412751191, -6.419576723733448],
            [4.233208487575241, -6.417090261602801],
            [4.236026023269878, -6.413271051496377],
            [4.238433655968654, -6.407019832672119],
            [4.240689632554396, -6.409113950979119],
            [4.2368192375298275, -6.418067884876161],
            [4.23681119304855, -6.42272024142013],
            [4.23282724731252, -6.43021289805822],
            [4.228101810741838, -6.433066131955291],
            [4.22543874572049, -6.431952822768101],
            [4.219489683327845, -6.432938868389766],
            [4.216208351303466, -6.435587900555407],
            [4.2104891882153295, -6.446275622291919],
            [4.212686150539456, -6.44857897271178],
            [4.217863441955771, -6.446643671038505],
            [4.220375428306092, -6.450149971006561],
            [4.250440189880842, -6.449066093815818],
            [4.255991980009703, -6.449339467442127],
            [4.2582795675014475, -6.485342770110321],
            [4.258493292436198, -6.496349990819938],
            [4.25698565599133, -6.498278558949599],
            [4.25736792351719, -6.503847963910986],
            [4.2498593357744, -6.507915356421674],
            [4.250821637767531, -6.514374994754972],
            [4.25018167031839, -6.522488276119453],
            [4.248651775389611, -6.524230594171618],
            [4.250549997067086, -6.532663063357994],
            [4.250065126115106, -6.536830172015425],
            [4.2530581289091245, -6.541546346658406],
            [4.253827413503646, -6.5472935977630735],
            [4.247740024038772, -6.548709295094137],
            [4.2474278938099586, -6.555111945665831],
            [4.256781165202201, -6.555154841367801],
            [4.2596878554198145, -6.558183395668549],
            [4.2644820126301575, -6.5597314827490845],
            [4.262201705982027, -6.569220250995883],
            [4.265252082179225, -6.57222071707245],
            [4.264451801569872, -6.5760514083524395],
            [4.260830652264325, -6.576090200568254],
            [4.263464156606936, -6.582358464521801],
            [4.256917307492691, -6.584408874866485],
            [4.255641628199283, -6.586177902353523],
            [4.25594397227338, -6.596964070834466],
            [4.253927658047311, -6.600560670404335],
            [4.256637749036162, -6.606627138917015],
            [4.2544770875580085, -6.610088503873193],
            [4.253510035989122, -6.615120528970096],
            [4.251558986292451, -6.617351707503809],
            [4.25415623426604, -6.62365003743088],
            [4.250615993973945, -6.631449678126572],
            [4.261994211776631, -6.641661274909753],
            [4.264444747884049, -6.6490318158843005],
            [4.262254213732903, -6.653853089997115],
            [4.263229674727697, -6.659773097429892],
            [4.262023813873463, -6.661472461921345],
            [4.255355424239122, -6.66018950899764],
            [4.248486146513754, -6.667435947763582],
            [4.248938815865417, -6.673738985705181],
            [4.251158049871085, -6.677342434096278],
            [4.24711368136998, -6.679740079998068],
            [4.24715241567291, -6.683400794756444],
            [4.244039154652488, -6.684998290419166],
            [4.239231218412044, -6.689808885917587],
            [4.23839986101402, -6.69393672187231],
            [4.244634210426037, -6.6944501380300725],
            [4.251638409190482, -6.698562312933291],
            [4.253500922724339, -6.703519767713497],
            [4.254550155377517, -6.712684905159316],
            [4.253986208544237, -6.722493839151707],
            [4.2462627158812865, -6.728636560634009],
            [4.245716788664575, -6.733222967508507],
            [4.243161218367521, -6.737490829025661],
            [4.236587353519841, -6.738057869350122],
            [4.227880910166926, -6.739962331583286],
            [4.224852333524645, -6.7421010549959],
            [4.221330865782417, -6.748157892702684],
            [4.214231525065721, -6.753681457235167],
            [4.206882433473475, -6.761112425529191],
            [4.202193018266075, -6.771610311369984],
            [4.183875977605706, -6.772478594260664],
            [4.180331075338292, -6.6855845233716185],
            [4.137234236409206, -6.687433722302588],
            [4.13892185299967, -6.696731137841502],
            [4.1371270015918356, -6.698849671251606],
            [4.13686119022353, -6.704705468286062],
            [4.131171868137103, -6.7088348671743],
            [4.1280615238170215, -6.717339691174978],
            [4.123898252015596, -6.724789122510063],
            [4.121591186580955, -6.726677561102049],
            [4.1225311738439485, -6.730776071285547],
            [4.120076352405419, -6.733374264576232],
            [4.115261389212589, -6.7331196722536335],
            [4.11016318134438, -6.735617262973895],
            [4.105047175908808, -6.740692120139882],
            [4.104680498190893, -6.743179577273983],
            [4.100118689631982, -6.746554087051832],
            [4.100343331025336, -6.752420489739407],
            [4.099043025198755, -6.755955520735905],
            [4.094815313138278, -6.758292839186631],
            [4.090545823890746, -6.7644936557232205],
            [4.082022314117333, -6.765058543640036],
            [4.077737840227061, -6.767470295419506],
            [4.076597776779791, -6.774511728534712],
            [4.069426623401127, -6.779689241446493],
            [4.065897159633359, -6.7787441749566195],
            [4.057573562855752, -6.780359985990887],
            [4.053227285280591, -6.776623659688506],
            [4.048935736863733, -6.777178647722591],
            [4.04120863854595, -6.782131541642841],
            [4.040914775544818, -6.783501611294111],
            [4.030045760476138, -6.7907441279299885],
            [4.025742864841279, -6.7862167271850735],
            [4.02547129977626, -6.78335883392951],
            [4.029534744541413, -6.781195501632749],
            [4.030332894694355, -6.774964049551054],
            [4.027884187299788, -6.773858784497323],
            [4.024159143991296, -6.776506493452867],
            [4.0216621683761895, -6.7752094474560405],
            [4.0216336070905525, -6.770325539490748],
            [4.019117743122332, -6.77009774222162],
            [4.01702272561051, -6.774640660950572],
            [4.012385724378622, -6.771465160593193],
            [4.007955129467118, -6.770449296929263],
            [4.010209857625364, -6.767110874550183],
            [4.0100004298837195, -6.763697778576008],
            [4.0160649682497285, -6.759933139946252],
            [4.011412299744123, -6.758115304511179],
            [4.011937491809567, -6.752701457507937],
            [4.0068955398847095, -6.745256843537001],
            [4.002710660156216, -6.747758258434231],
            [4.000763016456682, -6.742901017116647],
            [3.9973754520844804, -6.742254313544826],
            [3.995681751904294, -6.745937682312504],
            [3.991098698738293, -6.746597335101032],
            [3.989039183793026, -6.740609175811576],
            [3.9824379940517205, -6.737823984763995],
            [3.9815343122174176, -6.734938098850721],
            [3.986045547701742, -6.731101096463136],
            [3.9752777293236465, -6.7300369391174355],
            [3.974185194990504, -6.725160605181465],
            [3.968859735265877, -6.7223147499114795],
            [3.9688365951939244, -6.715181475147509],
            [3.965819354116514, -6.708889101241418],
            [3.9637497126687316, -6.707262884008142],
            [3.959690869353528, -6.709244598124036],
            [3.9580067550950835, -6.706789507250169],
            [3.958347614418211, -6.700689882221003],
            [3.9549403393032265, -6.701527507686587],
            [3.956115696758197, -6.70684037022897],
            [3.945409923654383, -6.699314168635465],
            [3.9374834768377878, -6.6958850216444805],
            [3.9328182706638577, -6.695314541024219],
            [3.9321093187718468, -6.690155938628676],
            [3.929001512014488, -6.683190393692008],
            [3.926602712825086, -6.682723987943967],
            [3.9238269994974373, -6.6784448881872445],
            [3.9214595713223406, -6.671713759459332],
            [3.9252411500713893, -6.668531834138465],
            [3.9224012649854627, -6.662492067867909],
            [3.9272890814506662, -6.656733060736815],
            [3.922524148835166, -6.646544845084884],
            [3.9195318642789436, -6.642187453302058],
            [3.922752817236697, -6.635135937492671],
            [3.9186848340109295, -6.632462965575153],
            [3.9180808513477614, -6.628061909093072],
            [3.9225331100554577, -6.6273235634971375],
            [3.91808776713231, -6.622834326602222],
            [3.913408603825465, -6.621702834221194],
            [3.9095395117751552, -6.614827465039],
            [3.9095037628253557, -6.61125406859186],
            [3.903774747684897, -6.608704108219975],
            [3.9015082483078247, -6.602141360525239],
            [3.892831844215585, -6.603504090671224],
            [3.8928696344294194, -6.600699804111129],
            [3.897769519866705, -6.593120154378838],
            [3.90360212972636, -6.589977705718236],
            [3.9071637983144445, -6.590782867210546],
            [3.909988482966785, -6.583050953716416],
            [3.916147513428547, -6.5900797884424875],
            [3.9196108438111223, -6.591531119200276],
            [3.92058982441205, -6.583123504090926],
            [3.929619901254705, -6.5771916932951315],
            [3.9365139725717384, -6.579066310257251],
            [3.9401306957573805, -6.578544626527789],
            [3.945820841729139, -6.575000289576894],
            [3.943403212802757, -6.570562897712189],
            [3.9459736108365147, -6.566947237918938],
            [3.93999965854972, -6.562751203722287],
            [3.9387023067625613, -6.559938062158823],
            [3.939948395949341, -6.555847905982924],
            [3.9437078983925336, -6.551308330108682],
            [3.943384180716689, -6.548345143819818],
            [3.939654865175423, -6.544388651873254],
            [3.939347841961194, -6.54089697003832],
            [3.934668526775567, -6.541904296246873],
            [3.933304695105127, -6.54665924746898],
            [3.9303074379634295, -6.547406925039276],
            [3.931516697712787, -6.534851227054554],
            [3.927114455602514, -6.532029369792657],
            [3.925644894274639, -6.5293081015468415],
            [3.9217537066185963, -6.529634210524621],
            [3.9189518402676042, -6.525745672959133],
            [3.918218825370625, -6.52032800899564],
            [3.9208755399510418, -6.516116069176149]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.67387113921616, "lat": 32.13321215553114 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22041"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Franklin Parish"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00558557"
      },
      "bbox": [
        3.892831844215585, -6.7907441279299885, 4.284439464014973,
        -6.246748209513133
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.026915517298198, -6.9913625980650025],
            [3.0373815310433265, -6.990898368192484],
            [3.100739258740369, -6.989179385362922],
            [3.1138397953697163, -6.988960641901793],
            [3.2741242414413434, -6.982646536664727],
            [3.3254534178428927, -6.980679071951562],
            [3.32363487984134, -6.893276448703119],
            [3.3683615733032513, -6.891809715513313],
            [3.4375410986862636, -6.889357756379622],
            [3.483538262121102, -6.888137874634094],
            [3.486766537951156, -6.887771885299426],
            [3.5407139225297053, -6.885969697868167],
            [3.5419299394555117, -6.889658814109649],
            [3.5401527004581297, -6.892694257408137],
            [3.542418037363998, -6.901146357127367],
            [3.5463638600860516, -6.904150585390529],
            [3.5494853182173056, -6.901840289558934],
            [3.5546817943806084, -6.912875290317721],
            [3.5577937531090678, -6.915625298967107],
            [3.554924548199037, -6.918945952693277],
            [3.5587445834520377, -6.9218175168654765],
            [3.5638967542238467, -6.921092601354033],
            [3.5612127477307145, -6.927569406775929],
            [3.557277811146754, -6.926988399456142],
            [3.552740987638611, -6.930905315790142],
            [3.5519271481006016, -6.933476725641889],
            [3.5464542443114877, -6.939543117321401],
            [3.552799780094465, -6.9463285546832125],
            [3.5485654481737896, -6.946134700113677],
            [3.5464706376283335, -6.950720171370778],
            [3.549888502498463, -6.95348542320574],
            [3.546876328395761, -6.959207153253482],
            [3.5384106281332044, -6.962758292410645],
            [3.537307993315713, -6.96793407158361],
            [3.539743286843127, -6.96965240321044],
            [3.536112692157931, -6.975993377673865],
            [3.5354980005602368, -6.9803542778609655],
            [3.53840209955314, -6.982570567735214],
            [3.5424882958672543, -6.979445613406475],
            [3.5433142154162662, -6.984661597812649],
            [3.547145830175993, -6.986121057990917],
            [3.550505142332915, -6.981608788951902],
            [3.5560263632329936, -6.9840300152803945],
            [3.5579329006957208, -6.991093963054573],
            [3.5560255839981485, -6.995287653938874],
            [3.5477760604859356, -6.999062346916028],
            [3.5502035888755774, -7.0034688151935],
            [3.5556025905967936, -7.002432186826134],
            [3.5536402029938365, -7.007296053301305],
            [3.5490878433142306, -7.0120379093944845],
            [3.5459184773768047, -7.007553015263281],
            [3.542850429678403, -7.009955828300695],
            [3.5434483260725256, -7.014795839105781],
            [3.5461710231699572, -7.022913433272627],
            [3.541056618379374, -7.023581423872378],
            [3.546804508186241, -7.028141825429865],
            [3.5429161264796045, -7.031533110583867],
            [3.5465256749826928, -7.034282495685331],
            [3.548333955913125, -7.039042113061745],
            [3.543674386963364, -7.042028739053378],
            [3.541469458805737, -7.050380430893108],
            [3.547183451239702, -7.049572070769702],
            [3.552514972061181, -7.044226947559374],
            [3.5548021633096547, -7.047775198376539],
            [3.5562513964057074, -7.054420073979629],
            [3.547922085290729, -7.058532848018232],
            [3.54708034003586, -7.055212879064111],
            [3.5429135671260936, -7.0562158221338205],
            [3.543380326398613, -7.063595053305139],
            [3.539690717374271, -7.065277766765458],
            [3.5369010826782175, -7.062780555357422],
            [3.533917597655508, -7.065969073217852],
            [3.540819875816397, -7.071969466584616],
            [3.550408509163709, -7.078006672356292],
            [3.5602115805823487, -7.082265418217818],
            [3.5650760673349398, -7.085365533753508],
            [3.57849943930544, -7.088979048588673],
            [3.5901644146321305, -7.0895358529153265],
            [3.5959338772932417, -7.090467231884745],
            [3.5974000434565503, -7.093803103843028],
            [3.5937609031759608, -7.099498729160548],
            [3.5900985470470066, -7.102116755982505],
            [3.583266055848783, -7.102488216014706],
            [3.585414691066717, -7.10861181392129],
            [3.5937067501354094, -7.106791962593142],
            [3.601962304995658, -7.11173120493884],
            [3.6038661439740247, -7.116357989698009],
            [3.602320532510441, -7.123997570457907],
            [3.599291803917071, -7.126596232302411],
            [3.601231499162069, -7.1312892296561206],
            [3.604918650562958, -7.134055099025036],
            [3.611292601936694, -7.136273054841907],
            [3.617894385203869, -7.136008041581648],
            [3.6197019384293245, -7.139600907167892],
            [3.614928697072927, -7.142514990362],
            [3.612204405330394, -7.14005829840828],
            [3.6075029755919714, -7.140656103209012],
            [3.6059205839767325, -7.144360348821484],
            [3.6215590246754163, -7.144896630460118],
            [3.624964185046317, -7.142620666067758],
            [3.628679161129649, -7.148631494913971],
            [3.626051341547937, -7.152027813889351],
            [3.6271445011973036, -7.155500558126133],
            [3.6269160335456307, -7.162530916234833],
            [3.6224987549668395, -7.1632988777075495],
            [3.621882051141894, -7.167330443510617],
            [3.6262236293925754, -7.17081229151812],
            [3.624151887235232, -7.174151696488386],
            [3.620312527162961, -7.175302739363366],
            [3.625262625388288, -7.183185949150107],
            [3.634208841895632, -7.185423375514267],
            [3.6412959661767275, -7.182613695624089],
            [3.646448078391978, -7.1784346641862165],
            [3.645879551875881, -7.173050817644745],
            [3.6482410975061548, -7.171783988572311],
            [3.656568521053766, -7.17613874244218],
            [3.657452984531569, -7.177941255812878],
            [3.654305138354201, -7.18257569915069],
            [3.649756773957057, -7.193100252734525],
            [3.652089761324565, -7.197291100626502],
            [3.6614558028610085, -7.201525535620952],
            [3.6649917476316354, -7.200738501631641],
            [3.6650409607942076, -7.19710123266233],
            [3.6622591278238814, -7.193693946657912],
            [3.65645244513115, -7.190571832422396],
            [3.6572546175342224, -7.186878944347492],
            [3.664516378986339, -7.185919511733584],
            [3.670816209131022, -7.19004042780677],
            [3.6746706545560364, -7.185553004348668],
            [3.6795076235548265, -7.186511205033916],
            [3.6800327288896693, -7.194734298807389],
            [3.6833194068323656, -7.196468284636071],
            [3.6900434101748707, -7.195246816781509],
            [3.694275630063627, -7.1979257067278235],
            [3.6240441931209, -7.217130764594732],
            [3.605585954167112, -7.2203076726195325],
            [3.5374734839923456, -7.23917577684757],
            [3.4294174654857703, -7.269641388749694],
            [3.3827881384143974, -7.282478287071491],
            [3.327423419014378, -7.298759217735235],
            [3.3239235384189496, -7.296092652778363],
            [3.3201893915152425, -7.297039669671781],
            [3.3124461908217553, -7.300949251555149],
            [3.3048141600863445, -7.301942123191545],
            [3.301264011175891, -7.300287589779344],
            [3.297691478814593, -7.2960712864122215],
            [3.2973292462227493, -7.290617310911893],
            [3.293385066886045, -7.290675762725856],
            [3.287106960831385, -7.294523127551579],
            [3.282045415788653, -7.29424316743819],
            [3.2753093793421546, -7.291489196887748],
            [3.272754042643411, -7.288812705156353],
            [3.2735308357863837, -7.283936921939519],
            [3.287764219426251, -7.275973997630247],
            [3.2866296304807836, -7.272890785853571],
            [3.278946871089114, -7.270431797117744],
            [3.2748447839890686, -7.267754836478711],
            [3.273007876623107, -7.263109355237472],
            [3.2755499158305312, -7.257894093187708],
            [3.2829020131778144, -7.250344889493177],
            [3.284569644605722, -7.246843360401391],
            [3.28089830209276, -7.243185968305121],
            [3.2732182749727996, -7.24656046374746],
            [3.2680232766710633, -7.246435738644915],
            [3.262190913552539, -7.241041380185621],
            [3.260174163898227, -7.230528940700009],
            [3.260895461601147, -7.22136492965646],
            [3.2623006083782173, -7.220220388406235],
            [3.2725854925995783, -7.220163861968872],
            [3.2731750202578054, -7.21516164177227],
            [3.2687544042498793, -7.212723094139673],
            [3.2667646894270543, -7.209304603425361],
            [3.267130995195879, -7.1998151068209175],
            [3.271059376940276, -7.198490586847],
            [3.2794553412517353, -7.198496301507352],
            [3.281041495536022, -7.196259685484609],
            [3.279962158984574, -7.192273531316192],
            [3.275921098808392, -7.1904758579600765],
            [3.270117965609265, -7.19667927984227],
            [3.2643064336512353, -7.197421820521141],
            [3.25577424045425, -7.187950916505428],
            [3.2491194474341976, -7.174923987062818],
            [3.2512225355771585, -7.169227271443876],
            [3.2477712966435437, -7.166821763627324],
            [3.241586583737101, -7.166860932514512],
            [3.2324474825526783, -7.159932222727589],
            [3.2270345686943105, -7.15736232469232],
            [3.2194169498568983, -7.150226696473593],
            [3.212106913395328, -7.146368355349294],
            [3.2119845361733366, -7.1435973033529345],
            [3.216187246957988, -7.138336198896126],
            [3.21532667772499, -7.134845401034803],
            [3.2016129798619213, -7.127077429292807],
            [3.1922947597301192, -7.1175733224250015],
            [3.1889403969335977, -7.115973202183671],
            [3.1834107545447887, -7.104748338816424],
            [3.1764091507867906, -7.098097296282534],
            [3.172296538160891, -7.096703184870957],
            [3.1597270996077453, -7.096799476871943],
            [3.1529609802603074, -7.095251178691836],
            [3.142755099333222, -7.095006315883203],
            [3.132490265822095, -7.089863783425359],
            [3.1243035826463346, -7.083534122414648],
            [3.118393915164055, -7.079890943410547],
            [3.106536429866467, -7.080870096997678],
            [3.090783251485519, -7.076863796557038],
            [3.0866030115712966, -7.074511309158813],
            [3.0833293944086, -7.069708427168234],
            [3.0840422010353032, -7.059880898310765],
            [3.0884933644043713, -7.044551392033084],
            [3.088412247266102, -7.038673558212959],
            [3.0867089779036636, -7.037549946719922],
            [3.0773424916191496, -7.036923847711971],
            [3.0696738765889724, -7.032864578193338],
            [3.0676453009735023, -7.028069218410032],
            [3.0682428277403218, -7.024394125738183],
            [3.065256665291648, -7.021114236404687],
            [3.0555199282105856, -7.023850296504211],
            [3.0470906243530345, -7.023615601477828],
            [3.035711675744364, -7.019690038873354],
            [3.034767897501846, -7.012730066726564],
            [3.0387348137383685, -6.998595893978441],
            [3.037153065411381, -6.994933977282752],
            [3.026915517298198, -6.9913625980650025]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.55947559983096, "lat": 31.59968687985311 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22043"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Grant Parish"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00558567"
      },
      "bbox": [
        3.026915517298198, -7.301942123191545, 3.694275630063627,
        -6.885969697868167
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1679400313778134, -6.2429773277486],
            [3.2344910683232095, -6.240917424529682],
            [3.2667391358331517, -6.240225719707712],
            [3.2982075889671068, -6.239021497045982],
            [3.297059791066701, -6.212026358451659],
            [3.2960544871876696, -6.195745642158395],
            [3.328186374542938, -6.19468252853497],
            [3.42622193819438, -6.1917243209460775],
            [3.4694918046630048, -6.190226930375244],
            [3.4727602440153156, -6.277709679203894],
            [3.5630989357525618, -6.3613369046957535],
            [3.5646268756291883, -6.404887676620091],
            [3.5699372004774284, -6.535929457149976],
            [3.555547015841288, -6.537017818244623],
            [3.4450046392404077, -6.540707127120368],
            [3.4257437923261085, -6.540900221431601],
            [3.332881996957805, -6.543907169166532],
            [3.288966185882053, -6.545560516792453],
            [3.2210006138519756, -6.547849903141942],
            [3.17053303930914, -6.549367870366107],
            [3.146077617520549, -6.549785355707754],
            [3.1421327608953606, -6.545604693639279],
            [3.1421909382793825, -6.539176694922063],
            [3.1472597458711946, -6.528751098166725],
            [3.1509798946194914, -6.527745800625741],
            [3.1528089388253235, -6.522105520543133],
            [3.1588456106308436, -6.51547702986577],
            [3.156736109227209, -6.513818036765924],
            [3.156283923119577, -6.504650502652704],
            [3.15783393577806, -6.4930714194234955],
            [3.1560442642149265, -6.486193369331583],
            [3.16130707299933, -6.483926611307654],
            [3.1626726823958666, -6.481359590920085],
            [3.167227884515897, -6.481576420523528],
            [3.170248047735877, -6.475423035896959],
            [3.170848356200841, -6.471292577326117],
            [3.1779978808463643, -6.461835583544532],
            [3.1756613524594197, -6.413849246792149],
            [3.1747465654144507, -6.374168332742738],
            [3.1732232132348446, -6.360863609130407],
            [3.172810923588874, -6.344457443024731],
            [3.1679400313778134, -6.2429773277486]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.55785652034757, "lat": 32.30202358214688 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22049"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Jackson Parish"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00558592"
      },
      "bbox": [
        3.1421327608953606, -6.549785355707754, 3.5699372004774284,
        -6.190226930375244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.059780505408214, -8.910061006850373],
            [4.071392855887913, -8.8980930134999],
            [4.104807755788863, -8.867311641078784],
            [4.179563412621755, -8.79860404687597],
            [4.208971893438944, -8.756799332496298],
            [4.250258411346558, -8.697057012140403],
            [4.381519152232543, -8.680233069569098],
            [4.38191067043925, -8.68847643760954],
            [4.4344815432456794, -8.728546626880208],
            [4.437361606695782, -8.732403510620715],
            [4.446756928410571, -8.75912383452832],
            [4.471111385500473, -8.795280215526116],
            [4.4724503192244285, -8.79663264653204],
            [4.463788188934689, -8.847262077722869],
            [4.4942054433620156, -8.862751758791084],
            [4.540870483591154, -8.862052072884515],
            [4.601624895724181, -8.8749392051896],
            [4.613818531115095, -8.872067372341354],
            [4.631614854134569, -8.881861638000046],
            [4.644680152167637, -8.892957092669844],
            [4.6633089658913285, -8.896699539938348],
            [4.68546970226759, -8.895331197036029],
            [4.705491038463201, -8.915243779441946],
            [4.716307376650284, -8.91818164100001],
            [4.720547975398873, -8.921017449644678],
            [4.7177806782870935, -8.930755941288657],
            [4.718701529823439, -8.940275193704428],
            [4.718328520781369, -8.960621503141146],
            [4.714455517315936, -8.971616355327656],
            [4.717075647104335, -8.975493881063294],
            [4.723553356806132, -8.976582405159052],
            [4.728501106470912, -8.978689478512043],
            [4.734242528939657, -8.984727893586014],
            [4.7351492867677445, -8.989044454490271],
            [4.729236477687176, -8.993982543144133],
            [4.723593261958177, -8.992854899644714],
            [4.716592099630347, -8.998400460733901],
            [4.705637399456722, -8.999740041460276],
            [4.704222091762601, -9.0079463345595],
            [4.7011598022004435, -9.009662692416931],
            [4.694989936413773, -9.00958173532803],
            [4.689234567389023, -9.008244841536184],
            [4.686735725477014, -9.009216967628538],
            [4.687277709995613, -9.014233401461437],
            [4.685784873951182, -9.016129909124265],
            [4.678032129416252, -9.014801202949744],
            [4.674792599742286, -9.016285080525835],
            [4.671685019447547, -9.023580227328155],
            [4.666510255807632, -9.026252116846786],
            [4.6618699807233455, -9.024738636283939],
            [4.657168510789618, -9.020391180709314],
            [4.656978455487406, -9.014143429758718],
            [4.655588625487303, -9.010863878598323],
            [4.652513451785892, -9.010248558272892],
            [4.6483732701400635, -9.012043664548084],
            [4.641551400057141, -9.018287307162177],
            [4.637264164404619, -9.019993174179206],
            [4.6255020600033125, -9.030264991746806],
            [4.618965891909918, -9.037377036013288],
            [4.613933872853509, -9.04512071487591],
            [4.613757045025931, -9.04982214342175],
            [4.616171845530441, -9.056051218002677],
            [4.616143780079421, -9.059278460746173],
            [4.6058766235336925, -9.071165785383117],
            [4.59746035451236, -9.075414009744307],
            [4.5847228533045925, -9.07800154416557],
            [4.578194808540701, -9.082607404381166],
            [4.576458888653116, -9.086096121099787],
            [4.575401074111516, -9.093345153622726],
            [4.577695772202322, -9.100877951119752],
            [4.5818923206239, -9.107899609254874],
            [4.582330640575162, -9.114544386815291],
            [4.578038897491372, -9.125491590662794],
            [4.576900767760657, -9.142940859883097],
            [4.570105105468366, -9.139915287195015],
            [4.5594940053830575, -9.145190698922327],
            [4.547924495611077, -9.143761303468455],
            [4.542415540105081, -9.142343616885075],
            [4.539992567830889, -9.13746098498762],
            [4.534978272006862, -9.134399546743133],
            [4.518808894053649, -9.134622091731636],
            [4.509975244728574, -9.129506160354875],
            [4.514849883297477, -9.127115365865231],
            [4.5142773655317505, -9.122640315929177],
            [4.506749537935947, -9.112126198838892],
            [4.503047453678007, -9.111102887023979],
            [4.494500216649056, -9.113738438613977],
            [4.489978505630169, -9.112134202839528],
            [4.483656915217271, -9.107362745768263],
            [4.475818251175436, -9.107472113581562],
            [4.474520985001978, -9.114078741202313],
            [4.4665983838509025, -9.115258886225527],
            [4.452378181362784, -9.114869370651508],
            [4.443643365296882, -9.110477958908493],
            [4.440125570433652, -9.104902552512499],
            [4.442422917401859, -9.099318386657737],
            [4.440194101091204, -9.089676291746617],
            [4.4339494659243845, -9.086367248131742],
            [4.4210185800517054, -9.084576612925098],
            [4.406617859894211, -9.085925140869211],
            [4.380392599364308, -9.093336439840794],
            [4.362457590897191, -9.103260498890213],
            [4.348293252871254, -9.105453670135496],
            [4.346967931982595, -9.101528335294882],
            [4.35222323086491, -9.09253711258922],
            [4.354250399828262, -9.08762128837129],
            [4.354245425410013, -9.081731094820752],
            [4.350721102597082, -9.075276710455961],
            [4.343230583722795, -9.06841682839224],
            [4.342096631694846, -9.059880124133466],
            [4.343980744771929, -9.049644613414449],
            [4.3406490351841995, -9.040500079202594],
            [4.337623291552206, -9.037083388399022],
            [4.334587126958818, -9.028989456641861],
            [4.3293105149028035, -9.01096254570022],
            [4.325084770248411, -9.000146037441864],
            [4.321364492666902, -8.998551471832178],
            [4.304482485806023, -8.997315755187106],
            [4.29834199675143, -8.998619604839172],
            [4.289132067065234, -9.002822062081528],
            [4.279044075900643, -9.005939973620302],
            [4.263310166691354, -9.00992675818705],
            [4.254482806610494, -9.006853470994855],
            [4.2502678881734175, -9.007351228224705],
            [4.244433460039922, -9.004142130655842],
            [4.247407187266219, -9.000502398030324],
            [4.2532409532535, -8.997920609429867],
            [4.253973307358483, -8.991451569771144],
            [4.2591171644006955, -8.984271538132607],
            [4.261662150421719, -8.983440694874778],
            [4.260719488701386, -8.978982040020737],
            [4.264047239431461, -8.968112018537932],
            [4.261836026593141, -8.95615797650546],
            [4.264111380754935, -8.95176693643938],
            [4.263820972659682, -8.938912247977864],
            [4.266848091255892, -8.932952979324247],
            [4.267161938949441, -8.9197647946115],
            [4.2623894667622, -8.904436704623368],
            [4.256594853660144, -8.89910965276308],
            [4.252249630437157, -8.897825829995215],
            [4.238564211582048, -8.895434270981674],
            [4.226257957120679, -8.894970202121504],
            [4.217314267388868, -8.895780932671375],
            [4.196251301869938, -8.900198499773381],
            [4.187160376948018, -8.903652478887487],
            [4.182280960972094, -8.906356702448553],
            [4.178551647311742, -8.905542328611919],
            [4.1667122470005244, -8.897188245347486],
            [4.161503564556288, -8.894292532607741],
            [4.147820554445238, -8.895306808298159],
            [4.130701785373534, -8.900246807316938],
            [4.118979282119268, -8.905866961420774],
            [4.114274282718493, -8.909135294805163],
            [4.100023418818972, -8.91598601120003],
            [4.088356496091307, -8.92292654888356],
            [4.086278227896976, -8.924956898018568],
            [4.079061374525411, -8.927515694568234],
            [4.077158300094823, -8.931171497255518],
            [4.071921239557366, -8.935266221382191],
            [4.063923295401644, -8.940116748137022],
            [4.058348857832165, -8.94250171875304],
            [4.056116259087195, -8.938717075257198],
            [4.051361160458337, -8.9386159690286],
            [4.047511698871376, -8.93561577545388],
            [4.044718190066373, -8.937830942422702],
            [4.03869329429924, -8.938651165230032],
            [4.040563723775339, -8.933379406013422],
            [4.053528810369913, -8.924534303835024],
            [4.059052320271233, -8.918680999276392],
            [4.060503454166651, -8.914125766764974],
            [4.059780505408214, -8.910061006850373]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.44859215636072,
          "lat": 29.720727695001862
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22101"],
        "coty_name": ["St. Mary"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Mary Parish"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01629492"
      },
      "bbox": [
        4.03869329429924, -9.145190698922327, 4.7351492867677445,
        -8.680233069569098
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.202193018266075, -6.771610311369984],
            [4.206882433473475, -6.761112425529191],
            [4.214231525065721, -6.753681457235167],
            [4.221330865782417, -6.748157892702684],
            [4.224852333524645, -6.7421010549959],
            [4.227880910166926, -6.739962331583286],
            [4.236587353519841, -6.738057869350122],
            [4.243161218367521, -6.737490829025661],
            [4.245716788664575, -6.733222967508507],
            [4.2462627158812865, -6.728636560634009],
            [4.253986208544237, -6.722493839151707],
            [4.254550155377517, -6.712684905159316],
            [4.253500922724339, -6.703519767713497],
            [4.251638409190482, -6.698562312933291],
            [4.244634210426037, -6.6944501380300725],
            [4.23839986101402, -6.69393672187231],
            [4.239231218412044, -6.689808885917587],
            [4.244039154652488, -6.684998290419166],
            [4.24715241567291, -6.683400794756444],
            [4.24711368136998, -6.679740079998068],
            [4.251158049871085, -6.677342434096278],
            [4.248938815865417, -6.673738985705181],
            [4.248486146513754, -6.667435947763582],
            [4.255355424239122, -6.66018950899764],
            [4.262023813873463, -6.661472461921345],
            [4.263229674727697, -6.659773097429892],
            [4.262254213732903, -6.653853089997115],
            [4.264444747884049, -6.6490318158843005],
            [4.261994211776631, -6.641661274909753],
            [4.250615993973945, -6.631449678126572],
            [4.25415623426604, -6.62365003743088],
            [4.251558986292451, -6.617351707503809],
            [4.253510035989122, -6.615120528970096],
            [4.2544770875580085, -6.610088503873193],
            [4.256637749036162, -6.606627138917015],
            [4.253927658047311, -6.600560670404335],
            [4.25594397227338, -6.596964070834466],
            [4.255641628199283, -6.586177902353523],
            [4.256917307492691, -6.584408874866485],
            [4.263464156606936, -6.582358464521801],
            [4.260830652264325, -6.576090200568254],
            [4.264451801569872, -6.5760514083524395],
            [4.265252082179225, -6.57222071707245],
            [4.262201705982027, -6.569220250995883],
            [4.2644820126301575, -6.5597314827490845],
            [4.2596878554198145, -6.558183395668549],
            [4.256781165202201, -6.555154841367801],
            [4.2474278938099586, -6.555111945665831],
            [4.247740024038772, -6.548709295094137],
            [4.253827413503646, -6.5472935977630735],
            [4.2530581289091245, -6.541546346658406],
            [4.250065126115106, -6.536830172015425],
            [4.250549997067086, -6.532663063357994],
            [4.248651775389611, -6.524230594171618],
            [4.25018167031839, -6.522488276119453],
            [4.250821637767531, -6.514374994754972],
            [4.2498593357744, -6.507915356421674],
            [4.25736792351719, -6.503847963910986],
            [4.25698565599133, -6.498278558949599],
            [4.258493292436198, -6.496349990819938],
            [4.2582795675014475, -6.485342770110321],
            [4.255991980009703, -6.449339467442127],
            [4.400810074988047, -6.442711625201202],
            [4.403028697039704, -6.437601917390998],
            [4.407015957871788, -6.43239032900256],
            [4.410489047837257, -6.432357941715985],
            [4.4200223634372255, -6.424949012103878],
            [4.425924416403952, -6.4249113958071415],
            [4.433556677658483, -6.423139793284524],
            [4.436602073395339, -6.419989073160711],
            [4.437498287140205, -6.415638302061221],
            [4.440738509585097, -6.41275272732231],
            [4.443374708232451, -6.414159463306035],
            [4.44480392272295, -6.418716253220746],
            [4.44899442173848, -6.417087466740856],
            [4.45475128067249, -6.420790344578713],
            [4.457282954409774, -6.42042660200403],
            [4.460866133855289, -6.425232063467622],
            [4.467381056406262, -6.430373418829594],
            [4.473223438754387, -6.432010465344045],
            [4.478478667860173, -6.419697982872124],
            [4.482633643038157, -6.41389760535707],
            [4.488272604558866, -6.408229617196881],
            [4.49877195981257, -6.401264016187008],
            [4.514484140244185, -6.3945403355539225],
            [4.53452486857258, -6.394354909329628],
            [4.544472563099617, -6.389937383975697],
            [4.551366771983379, -6.388439681088936],
            [4.556140267946498, -6.388524817145679],
            [4.5672517702691255, -6.398128931120231],
            [4.565097854568277, -6.403618175425226],
            [4.566789627687591, -6.407265678191846],
            [4.565682811052929, -6.416880100516061],
            [4.568404464163851, -6.424206482506504],
            [4.566292569871393, -6.426250573511069],
            [4.560987337627787, -6.423958704752278],
            [4.558149665856857, -6.424337299867842],
            [4.5381928806817795, -6.436828480519177],
            [4.533285488019805, -6.442145411369102],
            [4.5305283249618435, -6.452538463431094],
            [4.528544271608475, -6.462747942380836],
            [4.526969697541596, -6.4751222087685845],
            [4.5266947067431, -6.484388525377229],
            [4.529639810910162, -6.494966751381397],
            [4.535407350558063, -6.504633898960221],
            [4.537702030842639, -6.506113559222326],
            [4.54427107488949, -6.506231763349621],
            [4.553322156647742, -6.5076251709855],
            [4.564474137202493, -6.5112342281995526],
            [4.579257146269979, -6.510961765061905],
            [4.581457504602852, -6.511544145900135],
            [4.589652215683666, -6.5050253537998515],
            [4.5975392521629965, -6.502152969230072],
            [4.605955431350905, -6.501332338896348],
            [4.616645660682057, -6.503295258926098],
            [4.623217081205222, -6.507526495936554],
            [4.630408490768517, -6.50982429685256],
            [4.642534908512698, -6.513079301706451],
            [4.649431121156811, -6.512508215744361],
            [4.6498362860984015, -6.518715354432691],
            [4.6503289871581845, -6.524872732404829],
            [4.6471664835073705, -6.532135896398875],
            [4.6440303601190935, -6.535097224655238],
            [4.610171851610678, -6.555942766900341],
            [4.6089171508893285, -6.559406328353065],
            [4.612432605384192, -6.5847154977166085],
            [4.60987748948829, -6.587545910459258],
            [4.596021386164478, -6.587457885310073],
            [4.591711299421275, -6.585779549762082],
            [4.582368607162282, -6.5782607717473836],
            [4.573413705999772, -6.565123992843732],
            [4.569382199977571, -6.5606311322024915],
            [4.560104903285156, -6.555905103042544],
            [4.552186897776678, -6.5579068327155765],
            [4.546528116504399, -6.562792250729648],
            [4.542042837474968, -6.570816555691483],
            [4.542704546972767, -6.578778885076768],
            [4.547279299802703, -6.585644197267975],
            [4.557026389911946, -6.591247045371329],
            [4.5992818770041195, -6.598185943542991],
            [4.60567184418262, -6.600856488927102],
            [4.608944863708427, -6.6036858627857224],
            [4.612393833722899, -6.61150461385479],
            [4.613402578456986, -6.61659012310871],
            [4.616867504003476, -6.617898956945158],
            [4.605768982618348, -6.635131664321035],
            [4.600983952015165, -6.640674116366789],
            [4.594473419113247, -6.645505028082701],
            [4.5834313306591365, -6.6493676314193735],
            [4.544038524494297, -6.655866749025788],
            [4.533552419524544, -6.665689752216634],
            [4.524987061295564, -6.678410935971814],
            [4.524717223016256, -6.693012618974113],
            [4.5221398463112905, -6.703833008808896],
            [4.52398759491808, -6.705238770807811],
            [4.529340836473152, -6.704070153245005],
            [4.530281117733697, -6.70592111633144],
            [4.529746991252064, -6.715338516182667],
            [4.533141471955589, -6.718864079113869],
            [4.531568097887877, -6.722839683763425],
            [4.526601947809816, -6.724987880870192],
            [4.523941253352814, -6.7292177255673415],
            [4.516903565665089, -6.730570256073636],
            [4.510761801683049, -6.739569501801278],
            [4.4962256947069825, -6.755634206286731],
            [4.489931455073374, -6.764180967894404],
            [4.479101850574616, -6.771726816950422],
            [4.465586186898657, -6.776780095007698],
            [4.462939797540298, -6.779707753352718],
            [4.46238581803835, -6.787225063158365],
            [4.464443686371776, -6.791118296735107],
            [4.483072111537587, -6.8081674481213],
            [4.48364580232201, -6.8098546963097695],
            [4.482144194955925, -6.819041296390034],
            [4.48005491918326, -6.823699946021911],
            [4.475663829984525, -6.829010922231281],
            [4.4704215639402465, -6.832566213603929],
            [4.464347065944522, -6.833066621699709],
            [4.4579001135546195, -6.831188325175863],
            [4.453083503869968, -6.828030780750723],
            [4.4506229409237585, -6.824557088322552],
            [4.446308503322346, -6.814484660226237],
            [4.445449096582363, -6.80953663100834],
            [4.44548719413541, -6.796348865405796],
            [4.44136231435797, -6.783269544508224],
            [4.429639235230271, -6.787540045630785],
            [4.412494976511342, -6.790077273790604],
            [4.403800088456421, -6.79399709401581],
            [4.398047987685686, -6.802666298842517],
            [4.388524594063002, -6.846566900181975],
            [4.385905732061278, -6.865663864616074],
            [4.385288746139526, -6.884398772975869],
            [4.3941849655997105, -6.8875264391745326],
            [4.4187387861731855, -6.882889051376864],
            [4.43932657885811, -6.8766507709952736],
            [4.451971419408869, -6.870722932675712],
            [4.462304324237675, -6.871095679729225],
            [4.471669687031877, -6.87480893009165],
            [4.474856770177653, -6.8803471186447425],
            [4.4719896017627265, -6.887300319798185],
            [4.462172496838686, -6.896724283340415],
            [4.448504527049417, -6.897652756307794],
            [4.43223922051513, -6.89464701270958],
            [4.426176569282348, -6.894224740413297],
            [4.408576087103465, -6.89487109271438],
            [4.393626608379453, -6.896495668462202],
            [4.386365516739108, -6.89776826171943],
            [4.380896508256094, -6.903260155999865],
            [4.3742367228833094, -6.91327133088445],
            [4.375436915707446, -6.898895020888265],
            [4.3607750531572895, -6.9000732917952945],
            [4.357844513097897, -6.897168501935498],
            [4.357998238245905, -6.894118269992823],
            [4.346430742559547, -6.894455259764589],
            [4.337489126895635, -6.893134590750812],
            [4.333952828376941, -6.8941942158081],
            [4.329230683597185, -6.8979128452447895],
            [4.271796711402746, -6.899898975847693],
            [4.260730951502587, -6.899772841140132],
            [4.234197910859853, -6.9009369897627035],
            [4.234181839134971, -6.901457811767451],
            [4.226242677973432, -6.893489919877108],
            [4.2226542505313365, -6.887744948360342],
            [4.209604586383826, -6.869465144430848],
            [4.204329349492621, -6.858792223035875],
            [4.20319387712874, -6.852767575518259],
            [4.2047917673803195, -6.845970450782915],
            [4.207714556244413, -6.8388282377061245],
            [4.210415117519031, -6.827455447411752],
            [4.207525769929642, -6.801561384751393],
            [4.207404278646125, -6.791856583864545],
            [4.200272450839916, -6.791016185236695],
            [4.19912775750602, -6.783115953125002],
            [4.202283208156543, -6.779701444170567],
            [4.2011395699000476, -6.7757596500490145],
            [4.202193018266075, -6.771610311369984]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.34002186457207, "lat": 32.00188591652331 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22107"],
        "coty_name": ["Tensas"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Tensas Parish"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00559509"
      },
      "bbox": [
        4.19912775750602, -6.91327133088445, 4.6503289871581845,
        -6.388439681088936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0418688511267375, -6.552681632606426],
            [3.146077617520549, -6.549785355707754],
            [3.17053303930914, -6.549367870366107],
            [3.2210006138519756, -6.547849903141942],
            [3.288966185882053, -6.545560516792453],
            [3.332881996957805, -6.543907169166532],
            [3.4257437923261085, -6.540900221431601],
            [3.4450046392404077, -6.540707127120368],
            [3.555547015841288, -6.537017818244623],
            [3.5699372004774284, -6.535929457149976],
            [3.5723357423396678, -6.605293451471261],
            [3.5779599269178113, -6.753754197738796],
            [3.5793147603572826, -6.785060244902615],
            [3.5771840066136105, -6.789228596573294],
            [3.5729223396660226, -6.788516092630825],
            [3.569307510089681, -6.7953728115612275],
            [3.573858793996956, -6.798492264884318],
            [3.572375718574218, -6.8006537272073615],
            [3.572789572979015, -6.805994623349224],
            [3.5693864382319243, -6.81014344647819],
            [3.5724304531899893, -6.813641151075219],
            [3.5687052990775827, -6.824694892718095],
            [3.565477318857441, -6.824064118564485],
            [3.5600998261500134, -6.826559058578199],
            [3.560157505322135, -6.830353956987204],
            [3.5644485191395914, -6.8349458630679205],
            [3.561677891275351, -6.83962757081721],
            [3.5636521506394514, -6.844218234802649],
            [3.557770885970739, -6.848948896764931],
            [3.5565336448817493, -6.858556918693648],
            [3.559227227652472, -6.863554025203276],
            [3.553296724081125, -6.86817306591367],
            [3.551932543245918, -6.87280008738758],
            [3.5449464999376685, -6.873092315800269],
            [3.544900130502523, -6.880068104823099],
            [3.5409846627676633, -6.882758919545552],
            [3.5407139225297053, -6.885969697868167],
            [3.486766537951156, -6.887771885299426],
            [3.483538262121102, -6.888137874634094],
            [3.4375410986862636, -6.889357756379622],
            [3.3683615733032513, -6.891809715513313],
            [3.32363487984134, -6.893276448703119],
            [3.3254534178428927, -6.980679071951562],
            [3.2741242414413434, -6.982646536664727],
            [3.1138397953697163, -6.988960641901793],
            [3.100739258740369, -6.989179385362922],
            [3.0373815310433265, -6.990898368192484],
            [3.026915517298198, -6.9913625980650025],
            [3.0246820013785847, -6.9879413813604385],
            [3.028786389161925, -6.976021301122859],
            [3.030378718312451, -6.969226200728881],
            [3.0296043901609, -6.950142810951627],
            [3.026388460551849, -6.945799585933365],
            [3.0283925128996265, -6.941529499753792],
            [3.026737359293069, -6.93569423043925],
            [3.0285510313315624, -6.9332835205632355],
            [3.030232467181414, -6.9241041435518635],
            [3.029744013997443, -6.919104510929758],
            [3.034817173852398, -6.921719045289412],
            [3.0380067017386434, -6.920898427590848],
            [3.042267875025803, -6.916295387450625],
            [3.0431476207925336, -6.912156980562201],
            [3.0425148621202474, -6.903397447854388],
            [3.046781960766329, -6.899826287877935],
            [3.047271864604396, -6.897099827446143],
            [3.0447398618799055, -6.889822208588804],
            [3.0500346911230594, -6.8856571432132085],
            [3.0430111662331263, -6.879367696447072],
            [3.042058437277214, -6.87521125456376],
            [3.044805417481256, -6.8728566472234895],
            [3.0517030609505618, -6.877756171977374],
            [3.0527378096748774, -6.870342182417466],
            [3.049539598610588, -6.863336760020529],
            [3.0439212916446183, -6.862215888367737],
            [3.0456450117989027, -6.857567692335615],
            [3.0414182193126607, -6.851633281398545],
            [3.04534973110729, -6.850824358108519],
            [3.045479115130343, -6.842904705980333],
            [3.0487053331297864, -6.845665746051531],
            [3.052549983473265, -6.846309212648036],
            [3.062321237654223, -6.8448622785999325],
            [3.0692450721898377, -6.84619635198171],
            [3.070730215816078, -6.847943783252012],
            [3.079726256315242, -6.846642478386413],
            [3.085758259629451, -6.839336791321537],
            [3.078734086903311, -6.830293944600818],
            [3.0814545895896557, -6.823760790365323],
            [3.082188168213721, -6.805026458998629],
            [3.0864883779874144, -6.801419671065484],
            [3.089125296428744, -6.797278735097938],
            [3.086871464754939, -6.781667937117638],
            [3.089305737783871, -6.772142926944656],
            [3.091440835968567, -6.771684222522677],
            [3.0940480918686353, -6.763970884035782],
            [3.094581261447349, -6.759079027327983],
            [3.102485388298195, -6.755815451996225],
            [3.104303724692593, -6.750556929546886],
            [3.0954725087644563, -6.746637245157178],
            [3.093685575661772, -6.742111146648826],
            [3.094770993735559, -6.7288535770564275],
            [3.093162032568573, -6.7234637585526285],
            [3.0941748320007987, -6.717556124945859],
            [3.091604780870954, -6.716128195444802],
            [3.091114688102582, -6.712102486776127],
            [3.0870378458198804, -6.710921101898044],
            [3.0791386129192357, -6.711202334749102],
            [3.0784936009596193, -6.704265012699672],
            [3.0825249442797324, -6.702203299017137],
            [3.0854352907233107, -6.698519292249401],
            [3.092137826883232, -6.6867615153474835],
            [3.0904167420239834, -6.682450924298462],
            [3.0889715868976726, -6.67237147464512],
            [3.087477389763106, -6.6679653474678116],
            [3.082548693699118, -6.660527017649219],
            [3.081776227926496, -6.655697720414707],
            [3.079460798773757, -6.654375723169921],
            [3.0810561840181254, -6.650150590660392],
            [3.081336924007061, -6.644215340999119],
            [3.0768102779344817, -6.641741555498781],
            [3.0759329603997867, -6.631853768474471],
            [3.067958854840481, -6.62476094690904],
            [3.0688779241382873, -6.617145626440528],
            [3.0728638067770038, -6.618073450069985],
            [3.072503637341485, -6.609328674954476],
            [3.066181323860901, -6.6017352157280795],
            [3.065489823800039, -6.596374762308956],
            [3.058423976685072, -6.591399462405217],
            [3.0549741902199528, -6.587855564188075],
            [3.0534352253073496, -6.5810436309663],
            [3.0489231112300197, -6.577013057581366],
            [3.0475058281187493, -6.570266786074109],
            [3.0483693337205966, -6.565838711082924],
            [3.0428386629933053, -6.55758262901398],
            [3.0418688511267375, -6.552681632606426]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.63685710426351, "lat": 31.9442630106424 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22127"],
        "coty_name": ["Winn"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Winn Parish"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00559594"
      },
      "bbox": [
        3.0246820013785847, -6.9913625980650025, 3.5793147603572826,
        -6.535929457149976
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [19.51555558996434, 8.324673568789212],
              [19.515305386541453, 8.329703250510626],
              [19.52058779286512, 8.335517282796003],
              [19.519892357276746, 8.345438157799803],
              [19.525639339343346, 8.356252474502899],
              [19.528564223602796, 8.358345220584505],
              [19.525900805302953, 8.361969823087248],
              [19.531114156993013, 8.368228290836031],
              [19.531418645665983, 8.370778536205806],
              [19.525377013007283, 8.374475945148767],
              [19.52266943752747, 8.372284941668847],
              [19.520843525924587, 8.367713008529742],
              [19.516176887998235, 8.379895772677534],
              [19.520271274644063, 8.38336725793967],
              [19.521266399069233, 8.38940102069588],
              [19.51957568314877, 8.395119268960006],
              [19.516882546206606, 8.396485920677142],
              [19.513807083614708, 8.407570105502543],
              [19.51491951737305, 8.417017567009617],
              [19.517829001757995, 8.418746995791393],
              [19.515519170381733, 8.422110970072747],
              [19.51852480921662, 8.424682934654896],
              [19.528070100915617, 8.424981867842396],
              [19.529866636515752, 8.427259507752819],
              [19.528111464997604, 8.43377467832968],
              [19.529907235764718, 8.43605106852414],
              [19.53332558536555, 8.432511076841504],
              [19.53871681276412, 8.431763378482085],
              [19.543238314264208, 8.426222845631408],
              [19.54530250970868, 8.418645307548795],
              [19.54886056892758, 8.417615876598358],
              [19.547216802674136, 8.410601072132762],
              [19.549188050186576, 8.407340638178082],
              [19.54658878519521, 8.395304372417794],
              [19.54060320855798, 8.387472888183728],
              [19.536219470304687, 8.384468086733023],
              [19.535976751926352, 8.379872988633544],
              [19.538767226568098, 8.375195011490296],
              [19.534452767439, 8.373861871243836],
              [19.539402373161508, 8.365938512407405],
              [19.535703351691545, 8.362877181910315],
              [19.536921698445315, 8.359362105009586],
              [19.542669536095506, 8.354873301712336],
              [19.54814627632766, 8.354878971258733],
              [19.546928206806903, 8.347199657291428],
              [19.544764763834326, 8.345531691963885],
              [19.546044898114566, 8.341091056557849],
              [19.544264410490644, 8.334735619535651],
              [19.545899198146607, 8.332812494572885],
              [19.543665344586717, 8.328243949261559],
              [19.545272636321933, 8.316792536910915],
              [19.544963582465304, 8.312360031820264],
              [19.54730774866086, 8.307544571704565],
              [19.544308928482344, 8.299366672379264],
              [19.54713844128345, 8.29263215699697],
              [19.544391584756063, 8.286375507256079],
              [19.541426372016442, 8.283472229926122],
              [19.540853774717103, 8.278918514870522],
              [19.536996428702697, 8.277891934379628],
              [19.536397848403784, 8.281407020482503],
              [19.537594398800486, 8.290217630883758],
              [19.537054930656232, 8.296224741587732],
              [19.535125283279758, 8.30394185438639],
              [19.53123271996354, 8.30932760055618],
              [19.53433553131637, 8.311986921812194],
              [19.53312558828244, 8.317268606427051],
              [19.529253906747694, 8.32019451317939],
              [19.52800581143133, 8.327399779163251],
              [19.525305052142357, 8.326968890079156],
              [19.518526275001708, 8.320606295597338],
              [19.51555558996434, 8.324673568789212]
            ]
          ],
          [
            [
              [19.527176891525386, 8.26108429776837],
              [19.5283012159212, 8.269162329627116],
              [19.531110093558205, 8.281647138696782],
              [19.527983409925966, 8.287433518884464],
              [19.532792431170197, 8.292700868535995],
              [19.53427125988133, 8.285908816743207],
              [19.532846562000753, 8.27757007084345],
              [19.533654048284895, 8.270053517894528],
              [19.53235264765742, 8.26368654194465],
              [19.527176891525386, 8.26108429776837]
            ]
          ],
          [
            [
              [19.507743618763666, 8.292492204196458],
              [19.508020898191482, 8.298733909510814],
              [19.512371035216777, 8.300168543526333],
              [19.511066177258147, 8.304698964368779],
              [19.510999018788294, 8.311387885302821],
              [19.517444833031128, 8.315893997211724],
              [19.5220712733097, 8.317585359846719],
              [19.525751416802624, 8.312316013136316],
              [19.519977972690327, 8.302546369099055],
              [19.522929071898048, 8.300936386491072],
              [19.526138798046652, 8.302041746650183],
              [19.52722257351906, 8.297779173183125],
              [19.52475159285728, 8.294773759706933],
              [19.5232775890236, 8.28959356143674],
              [19.518994115036442, 8.28852929985915],
              [19.51556598051291, 8.285759226910368],
              [19.50815894447772, 8.287921355677948],
              [19.507743618763666, 8.292492204196458]
            ]
          ],
          [
            [
              [19.039769234396505, 8.610146922149355],
              [19.074947908607754, 8.628456409138272],
              [19.072573290002936, 8.635146859197423],
              [19.072599399316378, 8.643229987695612],
              [19.07160965098481, 8.645773027904609],
              [19.07582583291723, 8.656360092101732],
              [19.081231706469207, 8.662412531913972],
              [19.07710626064994, 8.669776020072087],
              [19.075361714292193, 8.675783439137327],
              [19.08161235170238, 8.67834522541361],
              [19.08013472742842, 8.682121817333748],
              [19.08370450394777, 8.68581206452596],
              [19.090917958289072, 8.688247822578317],
              [19.098300018231875, 8.687034441567496],
              [19.108331721885058, 8.687572711252036],
              [19.111369148665013, 8.68915286103017],
              [19.13217840483287, 8.658612858634568],
              [19.1714026792988, 8.677521276327369],
              [19.211218079233603, 8.6968034279455],
              [19.224450828087484, 8.669671225721197],
              [19.249710268132908, 8.619577828638784],
              [19.310265760057167, 8.652737592028732],
              [19.36563294406849, 8.6837805427975],
              [19.366773961314102, 8.684587684548992],
              [19.431872927792355, 8.721298458676744],
              [19.43314415446325, 8.719111123229842],
              [19.452523467292067, 8.72985921496161],
              [19.45132693770877, 8.732342504490871],
              [19.46923065378359, 8.742871942997843],
              [19.471379783992344, 8.738843539138365],
              [19.471315537700235, 8.735100272203605],
              [19.473587184366547, 8.73298305356837],
              [19.485800260647505, 8.732602224401772],
              [19.489216314661206, 8.729713204642641],
              [19.495420157545063, 8.71870676585271],
              [19.49516662609571, 8.715414704679816],
              [19.4902905107996, 8.709634991688064],
              [19.48752161224335, 8.69603107369106],
              [19.488250847886704, 8.686848524214696],
              [19.487070410505158, 8.678847796976754],
              [19.484518002468057, 8.667999094353352],
              [19.486419652472076, 8.660955990409606],
              [19.48934733151835, 8.657201331911741],
              [19.502153771460097, 8.650746696301555],
              [19.50869002159894, 8.644773957898584],
              [19.514331813812866, 8.637800662141741],
              [19.51967809630751, 8.629199092185093],
              [19.52649561255958, 8.62431528511137],
              [19.533867000906664, 8.623252011680098],
              [19.5342374839735, 8.618410316924917],
              [19.532628607752226, 8.607951109459732],
              [19.537436419498295, 8.598731996563995],
              [19.541355570544617, 8.584948379773762],
              [19.543309806043425, 8.58139081327478],
              [19.541084336532656, 8.580094775195859],
              [19.543202271104576, 8.571254204258896],
              [19.541882785032286, 8.569119948177157],
              [19.54345372742387, 8.565023030886014],
              [19.546827123283983, 8.561976351548138],
              [19.545689028008436, 8.556915527235644],
              [19.546335800356854, 8.552372803069643],
              [19.543061508329753, 8.55212110604485],
              [19.5384483430569, 8.545699568252587],
              [19.535701804355348, 8.543674502089983],
              [19.532577972218604, 8.536983751296411],
              [19.533259565931548, 8.533501900980868],
              [19.54204568011374, 8.525890744792372],
              [19.543653557147568, 8.522852596790027],
              [19.551422241502557, 8.527565231666088],
              [19.553967978538157, 8.523747846802314],
              [19.547071676746494, 8.520643561396426],
              [19.542736351598872, 8.516453129733488],
              [19.54247332681352, 8.511990398227937],
              [19.536147499476208, 8.50357676479521],
              [19.53091848015287, 8.498926196912207],
              [19.527247762711653, 8.49405373847704],
              [19.52205186578939, 8.48182657692187],
              [19.520448548184916, 8.476551128251232],
              [19.514698034820405, 8.473057386490709],
              [19.50745328258273, 8.481149455186733],
              [19.504603783375654, 8.487639926487459],
              [19.49959576119681, 8.49194180494685],
              [19.49657885228761, 8.492533525656782],
              [19.492230240544366, 8.490208678051907],
              [19.4884395741135, 8.492626647501618],
              [19.48570818705329, 8.491133602762396],
              [19.48116024585411, 8.492796173171897],
              [19.47911740175352, 8.486594683274337],
              [19.480187752612046, 8.48089174382918],
              [19.479165469337513, 8.473670205842168],
              [19.475768045561892, 8.468086048547704],
              [19.47400874625799, 8.46150987612434],
              [19.469029930339982, 8.462281452232874],
              [19.464326238729964, 8.458901423093135],
              [19.458589376020342, 8.456500222820868],
              [19.45530532896431, 8.45322567154444],
              [19.44523120462021, 8.45031388067652],
              [19.44063483568336, 8.452142505609055],
              [19.437431238346814, 8.448060541422386],
              [19.441052653474536, 8.445623462247013],
              [19.456512723731368, 8.425854514749268],
              [19.453766485198873, 8.41961983933962],
              [19.459281866791343, 8.413490742746202],
              [19.461848159433607, 8.414560150305853],
              [19.4711975044802, 8.411853966032288],
              [19.48271430986793, 8.40218802952655],
              [19.49139036393059, 8.39162375175404],
              [19.49468829468237, 8.376152877458729],
              [19.496040986178212, 8.360062030564881],
              [19.495742113289975, 8.349950023637675],
              [19.494322860752302, 8.34329875011684],
              [19.486644979792707, 8.327133686969917],
              [19.483999830701155, 8.32979227335418],
              [19.475693578923057, 8.326799146524559],
              [19.47062631298319, 8.322248014972715],
              [19.47349715919875, 8.319016231004698],
              [19.471630203424624, 8.310035059007944],
              [19.474923597619348, 8.306059636992758],
              [19.475439909519828, 8.302431722060732],
              [19.47200288360534, 8.283876734272091],
              [19.466514824755397, 8.273938583586563],
              [19.453452429915174, 8.28107094338257],
              [19.400719355722778, 8.261845130130741],
              [19.356620221862837, 8.287323984248632],
              [19.341828736998632, 8.295501634743236],
              [19.291207363974976, 8.324736782427166],
              [19.269380085709397, 8.336826258937668],
              [19.231768790936258, 8.267923343679417],
              [19.18944579714082, 8.291602069040394],
              [19.188448558953677, 8.288874196322288],
              [19.18399140797822, 8.29017974943363],
              [19.181165489010834, 8.282500133727574],
              [19.185217661818584, 8.280080507481422],
              [19.183113994165073, 8.274378018107905],
              [19.112677581439254, 8.269745241172522],
              [19.12096235718934, 8.39694683421939],
              [19.15670920635634, 8.400125351547965],
              [19.15349098331345, 8.439661088427924],
              [19.15283409183526, 8.443387096979773],
              [19.148575577038105, 8.48810689670846],
              [19.116425345877232, 8.485665938286495],
              [19.109232002548143, 8.55994126175031],
              [19.107900664078112, 8.575336739804252],
              [19.060005668463262, 8.568625564060415],
              [19.057674800354423, 8.576786249914733],
              [19.059728526129078, 8.584795062510702],
              [19.06382046602557, 8.584896867254805],
              [19.065032399479012, 8.5877436401253],
              [19.065063072187257, 8.596169398529726],
              [19.04159620758695, 8.59394542279714],
              [19.036177468421076, 8.608265536881303],
              [19.039769234396505, 8.610146922149355]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -69.14544515615921, "lat": 44.50281990469487 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23027"],
        "coty_name": ["Waldo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Waldo County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00581299"
      },
      "bbox": [
        19.036177468421076, 8.26108429776837, 19.553967978538157,
        8.742871942997843
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.433685536803887, 5.959342559037182],
              [9.443449027935245, 5.95524774787042],
              [9.444832786470945, 5.951402983193516],
              [9.439544336736262, 5.948999498333796],
              [9.43487023216257, 5.9491900519562835],
              [9.435244292142038, 5.9538161278357915],
              [9.433685536803887, 5.959342559037182]
            ]
          ],
          [
            [
              [8.903286289306946, 6.015785990171754],
              [8.987403216282617, 6.02640533650438],
              [9.022615531654859, 6.03093325203235],
              [9.103414147846927, 6.040993066181721],
              [9.157148647755019, 6.048150481489103],
              [9.211663679579074, 6.054992143683007],
              [9.293267015578364, 6.066559649433833],
              [9.329308150436335, 6.071911537564124],
              [9.32841239100542, 6.064126707773995],
              [9.328971549423867, 6.054316805606294],
              [9.33037295196898, 6.0497270292777126],
              [9.331398653216242, 6.035166964327387],
              [9.337343317668713, 6.014610834709152],
              [9.334157858559898, 6.01344519902044],
              [9.327721516998086, 6.000311953121901],
              [9.322900413029837, 5.992776111872963],
              [9.321682763592577, 5.986091510958855],
              [9.323601747987656, 5.976610332340435],
              [9.33373829058223, 5.95767061401525],
              [9.31792314584129, 5.960887185697761],
              [9.311096567839572, 5.961564087670856],
              [9.303593724203061, 5.960528831822895],
              [9.285531023448604, 5.955192498787442],
              [9.280596392619106, 5.9523074327819545],
              [9.26966021107436, 5.941677948718969],
              [9.264570692943776, 5.935504481713131],
              [9.265313774292006, 5.930413557463088],
              [9.263458163574274, 5.926584219086699],
              [9.259067563950996, 5.925128341626849],
              [9.259238299600728, 5.922230104170648],
              [9.263913864515468, 5.9107847211349585],
              [9.269718743195028, 5.893719454606681],
              [9.272333879829755, 5.8903676042909145],
              [9.270245080182216, 5.887193035611777],
              [9.26573528598148, 5.887736078542113],
              [9.257906648591334, 5.890396790360552],
              [9.255961395303002, 5.89418716669205],
              [9.25026874721556, 5.897342543926147],
              [9.242711296071379, 5.894695971560214],
              [9.234121595735354, 5.898348932593741],
              [9.225534435316103, 5.899081702301925],
              [9.219402560470416, 5.89556069444305],
              [9.220285604217864, 5.884107416495311],
              [9.215333263401927, 5.8822620700119],
              [9.212022447303447, 5.877777431059041],
              [9.201847203107066, 5.8770586895967964],
              [9.191820026896629, 5.87904737025832],
              [9.18681269295321, 5.8753095859638345],
              [9.18400900529805, 5.878573670301234],
              [9.183477869849847, 5.8835810953283],
              [9.177995035005738, 5.884676313879534],
              [9.173622487280058, 5.883836622560889],
              [9.170570481468072, 5.878057789605172],
              [9.166384153834375, 5.877211274093987],
              [9.162831938838552, 5.879109779030081],
              [9.162788927365007, 5.882580135943232],
              [9.158026205568525, 5.881622046160272],
              [9.150846058986682, 5.873719511673034],
              [9.1495626204748, 5.868494062707972],
              [9.151919469520188, 5.866213385990454],
              [9.148548929691353, 5.8621685446174485],
              [9.145571183491846, 5.854960751800521],
              [9.144486051776159, 5.849080965368782],
              [9.141996443538932, 5.845414684275985],
              [9.13494120551475, 5.843914081975704],
              [9.13310837819853, 5.837043025783821],
              [9.133320681910973, 5.833045215083953],
              [9.129816047449689, 5.827609888365453],
              [9.129804741878997, 5.82286965226191],
              [9.128223193130719, 5.816112946794899],
              [9.129069854441042, 5.804774473530629],
              [9.122593055052562, 5.80364729850918],
              [9.124094683632153, 5.7995444235509295],
              [9.118626283146337, 5.7977839500918416],
              [9.11728214408085, 5.794964908776447],
              [9.117598883873896, 5.789890027762483],
              [9.091124263579937, 5.786574012719355],
              [9.020870145952793, 5.778321677691548],
              [9.009659766423962, 5.8632995979026745],
              [8.923642682788042, 5.852461597709495],
              [8.908111223865339, 5.974758853782597],
              [8.903286289306946, 6.015785990171754]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.89527112848295, "lat": 44.06554532041875 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26011"],
        "coty_name": ["Arenac"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Arenac County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01622948"
      },
      "bbox": [
        8.903286289306946, 5.778321677691548, 9.444832786470945,
        6.071911537564124
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.5897656086822, 5.976184389462582],
            [8.675519894097159, 5.986520194272785],
            [8.760154104826636, 5.996867002618385],
            [8.846193549697556, 6.008578429325503],
            [8.903286289306946, 6.015785990171754],
            [8.908111223865339, 5.974758853782597],
            [8.923642682788042, 5.852461597709495],
            [8.934537611726899, 5.768576538554103],
            [8.936192097969988, 5.754803266583911],
            [8.944288955558504, 5.6829136107316565],
            [8.915688481448305, 5.680247121851044],
            [8.80193566887585, 5.66788602799667],
            [8.80364134605351, 5.6531217193049645],
            [8.741268389524892, 5.646295274431118],
            [8.675464090477895, 5.6389025606485],
            [8.63265882662897, 5.634224577284736],
            [8.621967945242108, 5.719966399654703],
            [8.61172875165706, 5.806187433661564],
            [8.608022929145095, 5.834707210642264],
            [8.594051753956359, 5.94663755612212],
            [8.5897656086822, 5.976184389462582]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.388275140686, "lat": 43.990648043983406 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26051"],
        "coty_name": ["Gladwin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gladwin County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01622968"
      },
      "bbox": [
        8.5897656086822, 5.634224577284736, 8.944288955558504, 6.015785990171754
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.304126393980851, 7.9130514485399575],
            [5.404310130595569, 7.920700130650289],
            [5.433077312549333, 7.923004764776776],
            [5.519041471575199, 7.929559212566369],
            [5.56221815140069, 7.93267162767742],
            [5.645731727857534, 7.939154146262607],
            [5.735147374536246, 7.946254576229067],
            [5.821001547220806, 7.953218311132625],
            [5.90685751517416, 7.960160170027553],
            [5.913790650634833, 7.874862691131054],
            [5.920605733275194, 7.789422439087333],
            [5.9347215196565255, 7.618685545100942],
            [5.945686805441628, 7.489590667738956],
            [5.947866508616169, 7.469062686962534],
            [5.9412643966314045, 7.468316232222718],
            [5.939770607864231, 7.473261257577284],
            [5.930366011547078, 7.476471531337201],
            [5.9263102845148845, 7.479701673854203],
            [5.924848030357918, 7.482912322851012],
            [5.919310973288912, 7.482426184296242],
            [5.915542861653365, 7.485184566897061],
            [5.913796983541867, 7.482794930127032],
            [5.907561461955565, 7.484942251189616],
            [5.903327710492405, 7.4906527826612015],
            [5.898093397617583, 7.492080885158505],
            [5.894735564316243, 7.4950147640411116],
            [5.889225924400049, 7.495433433998606],
            [5.885365853410755, 7.490010919459829],
            [5.8747563799374545, 7.488711817029497],
            [5.871442289062531, 7.489643475770542],
            [5.865049407006856, 7.4878255035607015],
            [5.858301303061423, 7.4902166877794985],
            [5.854976213645205, 7.4961404737288575],
            [5.855080938516113, 7.502246775873114],
            [5.848697156173131, 7.5025272848597355],
            [5.845885214615545, 7.498282208623057],
            [5.829596725459723, 7.492591946626488],
            [5.823641973870168, 7.488161844756734],
            [5.820196713012362, 7.490921295979259],
            [5.811083230840714, 7.49535081050911],
            [5.803395864876846, 7.495323276051852],
            [5.7993342539541395, 7.490137578452352],
            [5.797653381855008, 7.498926418363694],
            [5.792840502615657, 7.503083201910167],
            [5.789974820030501, 7.503795310915845],
            [5.780907911174305, 7.510657616793182],
            [5.768499777881097, 7.517564952727243],
            [5.7594735807717825, 7.5232893632779865],
            [5.754772791610406, 7.514485753797722],
            [5.749883220909571, 7.511339650092559],
            [5.744589188860019, 7.51171657252485],
            [5.739044990624298, 7.509235420237575],
            [5.735299844437728, 7.50514822107134],
            [5.730791067931274, 7.507993156193497],
            [5.728212281873333, 7.513306239471364],
            [5.7227177383808066, 7.514360241631896],
            [5.717533462883139, 7.519163539647971],
            [5.712069261680308, 7.5176593983185045],
            [5.7079581633024326, 7.520965933258954],
            [5.708015500564217, 7.524538732702023],
            [5.704436574111802, 7.526612158400379],
            [5.695850816193127, 7.527537757467528],
            [5.6933643704259795, 7.52512358000868],
            [5.693894326662069, 7.520062722076959],
            [5.6856176283146915, 7.516747654300073],
            [5.681541313499064, 7.517627325113789],
            [5.6778919725680685, 7.520312390591213],
            [5.67293997142669, 7.531935202942424],
            [5.6703535819760305, 7.5355755307654295],
            [5.670068023186947, 7.5415309263027694],
            [5.667612488412368, 7.543359313468486],
            [5.658145876182478, 7.542965376711253],
            [5.651577218494863, 7.544134401467626],
            [5.646153710223585, 7.536314888988857],
            [5.639511061961685, 7.534936460256469],
            [5.636414755275444, 7.536761784998126],
            [5.632521396088446, 7.535763877114723],
            [5.629078769560386, 7.5369171774454475],
            [5.625019344631093, 7.534718267049771],
            [5.6192300548515925, 7.527481213217583],
            [5.613601139865993, 7.525160291756186],
            [5.609889363471413, 7.534176780243599],
            [5.606320597973974, 7.537054087172357],
            [5.602361117167874, 7.535316125864413],
            [5.600355696441642, 7.530007898571916],
            [5.600898576715555, 7.527530766403523],
            [5.5980346380393735, 7.522558248722242],
            [5.598439877136598, 7.51776466459497],
            [5.595840958188769, 7.512127330061812],
            [5.598033988667676, 7.5096075131327815],
            [5.595942648218091, 7.5065394526751374],
            [5.590638641448972, 7.507056827031547],
            [5.583675938730347, 7.505890811173003],
            [5.581521026539955, 7.502707099302027],
            [5.574031991973688, 7.505812355486763],
            [5.571665409561038, 7.504537222620284],
            [5.567132600452058, 7.505898192189983],
            [5.563366978664558, 7.504002630003357],
            [5.5599576168607046, 7.511068551171058],
            [5.557013717983343, 7.514792986195171],
            [5.556620180546399, 7.52037986585174],
            [5.553057354413216, 7.523942647767674],
            [5.553810450847464, 7.526006932796091],
            [5.547498872352256, 7.529069826454626],
            [5.53236880274472, 7.5319015124562885],
            [5.526990035015173, 7.526044937269512],
            [5.520345316766506, 7.530187649408496],
            [5.520675579622312, 7.534842226057759],
            [5.513708745048035, 7.5388019428692585],
            [5.5071885802749305, 7.5390743195078915],
            [5.49902558218482, 7.534758448047256],
            [5.493856422150105, 7.530625356643922],
            [5.490345366980867, 7.5331911631767925],
            [5.482956835849755, 7.5259455905308],
            [5.478806022557934, 7.526254825938003],
            [5.4771536095714195, 7.533872731172813],
            [5.480209497737977, 7.538588424318834],
            [5.479644939425219, 7.541517997988222],
            [5.4759830307973845, 7.542075632453782],
            [5.47417598353795, 7.538115499112949],
            [5.467746256381526, 7.542450698659618],
            [5.464912470760816, 7.538588297895144],
            [5.468223244794324, 7.5356776777651415],
            [5.462016180049265, 7.529950223761953],
            [5.456729466972897, 7.528685302306322],
            [5.4524256819659, 7.533955194638934],
            [5.448736163941524, 7.533915674890218],
            [5.44353724012377, 7.536570590377908],
            [5.438606272914174, 7.536701686254529],
            [5.432234995675588, 7.5423944927722575],
            [5.4297537321712435, 7.546115034018598],
            [5.3700922382647525, 7.5748383463062945],
            [5.328068252356011, 7.595216060958231],
            [5.321181477327769, 7.687863934498137],
            [5.310703407438049, 7.826947557595075],
            [5.304126393980851, 7.9130514485399575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.53054827922041,
          "lat": 46.208690204072255
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26071"],
        "coty_name": ["Iron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iron County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01622978"
      },
      "bbox": [
        5.304126393980851, 7.468316232222718, 5.947866508616169,
        7.960160170027553
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.081846622205763, 4.641621797243576],
            [9.145448477124006, 4.650880553992981],
            [9.216427597522904, 4.661635471517198],
            [9.251913949215714, 4.667291119354197],
            [9.279695311841385, 4.671712813300175],
            [9.336613623853825, 4.678449805446556],
            [9.422385894708443, 4.691681365673365],
            [9.428371976952684, 4.653513584727563],
            [9.436471944873503, 4.604846427518972],
            [9.441791026292378, 4.574180723534802],
            [9.456671700605655, 4.4914192569539475],
            [9.465458326873685, 4.444759349473488],
            [9.476096721362254, 4.3871313164797305],
            [9.483925196257212, 4.343512731040269],
            [9.426088153338688, 4.333277626051202],
            [9.411243800567691, 4.332255623588821],
            [9.377431437531213, 4.32636754302574],
            [9.309423472273494, 4.3149493865002295],
            [9.281295557860528, 4.310329586749468],
            [9.230094621658772, 4.303589971899478],
            [9.145558467101006, 4.293626319267234],
            [9.138583995216338, 4.292798125980379],
            [9.133033001549839, 4.33621233566973],
            [9.127967283145745, 4.377768397503038],
            [9.122943227784448, 4.41114196283787],
            [9.113680275249925, 4.466614418100627],
            [9.112500369735791, 4.472871862991065],
            [9.096612909497859, 4.565049682359127],
            [9.089257761434878, 4.6048674909236045],
            [9.081846622205763, 4.641621797243576]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.9115389888652, "lat": 42.60292098566732 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26093"],
        "coty_name": ["Livingston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Livingston County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01622989"
      },
      "bbox": [
        9.081846622205763, 4.292798125980379, 9.483925196257212,
        4.691681365673365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.048206203620021, 5.988376207414301],
            [2.05147830276308, 5.987219411925524],
            [2.05396844455746, 5.983282652742054],
            [2.05855054970278, 5.986369357968379],
            [2.053704551636021, 5.989952531279661],
            [2.062887539896489, 5.993643970791659],
            [2.0692196525909154, 5.994443606038405],
            [2.077350717339302, 6.005587347870485],
            [2.0802711081684953, 6.002987044124051],
            [2.0830914466827006, 6.004099148857906],
            [2.0851115845600083, 6.0078520989932125],
            [2.08076782360074, 6.01233428150746],
            [2.086167489924215, 6.016237600154181],
            [2.094450995606216, 6.017470112261077],
            [2.0974415940394313, 6.0188440655711455],
            [2.1106755499832905, 6.036328390243605],
            [2.112856333138421, 6.041927746953679],
            [2.1195933156066697, 6.045441269598261],
            [2.123799836877656, 6.045295962999213],
            [2.1270531680414626, 6.039783579315453],
            [2.1302456658722035, 6.0419343943275425],
            [2.1393660529532497, 6.043632547244473],
            [2.1407992230309985, 6.047783819251796],
            [2.1454158075875274, 6.049082407551304],
            [2.147851448924907, 6.05344303343331],
            [2.1530601404751986, 6.057605612614525],
            [2.1469888004011053, 6.065780346635751],
            [2.147216975131825, 6.073694911368955],
            [2.143063327412569, 6.073240000035664],
            [2.1423400169360707, 6.076855992032102],
            [2.1449515457931323, 6.081830333978814],
            [2.1427285803755614, 6.087301602882911],
            [2.1435587017539737, 6.090084835241589],
            [2.149128290113043, 6.0972682084919505],
            [2.1498220994654695, 6.103646648102077],
            [2.1544312645801047, 6.099265989139729],
            [2.1585528704601074, 6.104114705160089],
            [2.156812403109958, 6.106914364242376],
            [2.149657508840941, 6.1101550225523376],
            [2.148866448888838, 6.112517048505729],
            [2.1531388292871196, 6.116596627354413],
            [2.1601703972121147, 6.118119703920254],
            [2.1640854274006647, 6.120349425727454],
            [2.168089402711196, 6.1268425654256085],
            [2.164455575332332, 6.133119567248981],
            [2.1715440469544722, 6.1342247039205],
            [2.1765818833784722, 6.1329858442558205],
            [2.177770762943806, 6.144286536730066],
            [2.181609255305949, 6.146545035182547],
            [2.187554459339242, 6.14746440069022],
            [2.1957887401254115, 6.150878000417986],
            [2.2001732234388407, 6.1469399989480875],
            [2.2051162582275676, 6.150067138581115],
            [2.205469300005217, 6.156074421633115],
            [2.219833742985503, 6.156715625840033],
            [2.219903431090521, 6.1538717856177945],
            [2.2260785218231502, 6.15683809266816],
            [2.2317521270897376, 6.156725017500545],
            [2.2345955083172377, 6.162362053460239],
            [2.2367383510612253, 6.161644988587141],
            [2.2398744477597696, 6.156846018832238],
            [2.2455730218894066, 6.160134382589731],
            [2.247401235520125, 6.157142606086356],
            [2.251319990637244, 6.156845450755376],
            [2.259792913642375, 6.159374400043964],
            [2.26479056687758, 6.156026840396828],
            [2.2693188366498216, 6.156517155955336],
            [2.2737761416918474, 6.158685789346094],
            [2.2755272017661676, 6.164373116305124],
            [2.280552353572053, 6.1643872793407555],
            [2.290337706092192, 6.160473883160049],
            [2.2952153018572163, 6.161258338391297],
            [2.3023724015937996, 6.15735921190251],
            [2.3077241712643897, 6.151123738946907],
            [2.31389446158635, 6.1528156675047265],
            [2.3158715762965967, 6.151553453463037],
            [2.318894639933232, 6.140220779875447],
            [2.320854130533275, 6.139635758657753],
            [2.3290081028336935, 6.143566865043042],
            [2.331533182628874, 6.143614569210719],
            [2.3365550375085977, 6.14031544251435],
            [2.339367675626397, 6.145127615213158],
            [2.341705925494828, 6.146351344547922],
            [2.3452567111238243, 6.143588065302922],
            [2.350763418211522, 6.1417443834906225],
            [2.355125405395599, 6.146460919248478],
            [2.355443761947376, 6.133869022789864],
            [2.3561807910771657, 6.131240825701172],
            [2.358055821241159, 6.073253317331514],
            [2.3651874402038415, 6.073439129334268],
            [2.3662037013655683, 6.03733107263719],
            [2.3673860743378383, 5.986805608133578],
            [2.39615419108781, 5.987791594500148],
            [2.3972627865172544, 5.95176872260951],
            [2.3984291824870425, 5.901292236746454],
            [2.396263000282709, 5.90123055557903],
            [2.347707847323672, 5.899978832512075],
            [2.3117301623003224, 5.89873886492663],
            [2.223705930093765, 5.896201060538505],
            [2.2059101381205712, 5.89566539601263],
            [2.136482263065945, 5.894274919406816],
            [2.0786822169838204, 5.892260455134622],
            [1.9924644919378995, 5.890124394664188],
            [1.9492844841616392, 5.88924298874852],
            [1.9485372455496304, 5.891648293050753],
            [1.9517321936932608, 5.897147884617997],
            [1.9544595034773646, 5.898447409259826],
            [1.9575252563733436, 5.896224845214489],
            [1.957009368303028, 5.891664489849597],
            [1.9625646021569632, 5.892501984040509],
            [1.9624107143592173, 5.898508719741007],
            [1.9562128306985447, 5.901559739863819],
            [1.9577897991830266, 5.908214667826614],
            [1.9623400941613554, 5.911906242927567],
            [1.9611896236450665, 5.914848801606033],
            [1.9558159652321734, 5.915521340417656],
            [1.9554107848976094, 5.9181771576139965],
            [1.9594645949100915, 5.920708651678341],
            [1.958972980269592, 5.926219592810469],
            [1.9609455059386594, 5.931155471477283],
            [1.9575600655741547, 5.935352925005875],
            [1.962851442476443, 5.942879670325038],
            [1.968032884285755, 5.942510688071455],
            [1.9679946818302845, 5.946626138737415],
            [1.971637290921632, 5.94664614851429],
            [1.971006339233163, 5.952056608311844],
            [1.9747334525965456, 5.952634072586269],
            [1.9774550550870593, 5.948930513202845],
            [1.9833401542297062, 5.952806313477212],
            [1.9876801109734805, 5.963813072553196],
            [1.9850183146792544, 5.967697801595006],
            [1.993730012514721, 5.969194877980839],
            [1.9968469262677673, 5.971311223794797],
            [2.000088497309282, 5.965429006700934],
            [2.003215110815276, 5.968670605261992],
            [2.0130102814061197, 5.976231972492575],
            [2.0146787648015514, 5.980224366310874],
            [2.026350214687001, 5.982411504344539],
            [2.029494417040791, 5.981342403542275],
            [2.0322733409215843, 5.976245888276516],
            [2.037984750564962, 5.979332451764284],
            [2.043928840474608, 5.985726054381536],
            [2.0479535743644313, 5.979464818725336],
            [2.051459946393267, 5.982232836236392],
            [2.048206203620021, 5.988376207414301]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.53584061331122,
          "lat": 44.648484179411845
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27139"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00659514"
      },
      "bbox": [
        1.9485372455496304, 5.88924298874852, 2.3984291824870425,
        6.1643872793407555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5287930127687424, 6.054767389081312],
            [1.5294128431137135, 6.026078510037598],
            [1.5303443435149282, 5.967826068613434],
            [1.6167602028303518, 5.969768009303106],
            [1.6813223245434235, 5.970942812497407],
            [1.7029423396363106, 5.971147833667519],
            [1.7026686826784636, 5.98458349144206],
            [1.7017873498037126, 6.0583886331367784],
            [1.7213354802591967, 6.058808377575261],
            [1.7896536292097998, 6.0595635146463485],
            [1.8744976176758856, 6.061374381222969],
            [1.9609025990612043, 6.062809720998903],
            [1.961735528471395, 6.0193346470294955],
            [1.989553683394194, 6.020249037930506],
            [2.047329247075497, 6.021390443561754],
            [2.048206203620021, 5.988376207414301],
            [2.051459946393267, 5.982232836236392],
            [2.0479535743644313, 5.979464818725336],
            [2.043928840474608, 5.985726054381536],
            [2.037984750564962, 5.979332451764284],
            [2.0322733409215843, 5.976245888276516],
            [2.029494417040791, 5.981342403542275],
            [2.026350214687001, 5.982411504344539],
            [2.0146787648015514, 5.980224366310874],
            [2.0130102814061197, 5.976231972492575],
            [2.003215110815276, 5.968670605261992],
            [2.000088497309282, 5.965429006700934],
            [1.9968469262677673, 5.971311223794797],
            [1.993730012514721, 5.969194877980839],
            [1.9850183146792544, 5.967697801595006],
            [1.9876801109734805, 5.963813072553196],
            [1.9833401542297062, 5.952806313477212],
            [1.9774550550870593, 5.948930513202845],
            [1.9747334525965456, 5.952634072586269],
            [1.971006339233163, 5.952056608311844],
            [1.971637290921632, 5.94664614851429],
            [1.9679946818302845, 5.946626138737415],
            [1.968032884285755, 5.942510688071455],
            [1.962851442476443, 5.942879670325038],
            [1.9575600655741547, 5.935352925005875],
            [1.9609455059386594, 5.931155471477283],
            [1.958972980269592, 5.926219592810469],
            [1.9594645949100915, 5.920708651678341],
            [1.9554107848976094, 5.9181771576139965],
            [1.9558159652321734, 5.915521340417656],
            [1.9611896236450665, 5.914848801606033],
            [1.9623400941613554, 5.911906242927567],
            [1.9577897991830266, 5.908214667826614],
            [1.9562128306985447, 5.901559739863819],
            [1.9624107143592173, 5.898508719741007],
            [1.9625646021569632, 5.892501984040509],
            [1.957009368303028, 5.891664489849597],
            [1.9575252563733436, 5.896224845214489],
            [1.9544595034773646, 5.898447409259826],
            [1.9517321936932608, 5.897147884617997],
            [1.9485372455496304, 5.891648293050753],
            [1.9492844841616392, 5.88924298874852],
            [1.9481207832280438, 5.88406997449488],
            [1.9536394208600407, 5.884697488659302],
            [1.956299030246924, 5.882085803178708],
            [1.956257804185539, 5.875678385031932],
            [1.9604776483019695, 5.872723014788366],
            [1.9654422926854627, 5.872937315597969],
            [1.96759577865959, 5.865421085484636],
            [1.9660030695724489, 5.858663654842174],
            [1.9665791783847204, 5.850936513468726],
            [1.9640809330281657, 5.8502947462082],
            [1.9648793687293933, 5.844650198763087],
            [1.9629081771572228, 5.840082633203895],
            [1.9550760875720838, 5.833759079593543],
            [1.9546583541846148, 5.825984334351935],
            [1.953227942600664, 5.8199550346686255],
            [1.951184375993071, 5.81772038641546],
            [1.9422464095407612, 5.8198849082422415],
            [1.9390811352588901, 5.815901254496263],
            [1.9433315680016565, 5.813496408718263],
            [1.9465105314354516, 5.809325419357647],
            [1.944974562705851, 5.806292791638714],
            [1.9412550846379366, 5.806965142904578],
            [1.9338066432189975, 5.802562342281167],
            [1.8806712089932984, 5.801289627759261],
            [1.8025005198540627, 5.800063779025029],
            [1.7654160028962653, 5.799059406186516],
            [1.7649052051036094, 5.799404808180299],
            [1.7089933130129955, 5.798012695425556],
            [1.6158020492276, 5.796416845949834],
            [1.5799556920999633, 5.795562584455437],
            [1.5299433137660374, 5.794789963097848],
            [1.4796185066143015, 5.793490790150942],
            [1.4431493017313128, 5.793095428292178],
            [1.441795509411235, 5.879139761671496],
            [1.438281863007572, 5.879107211012293],
            [1.4370957702600777, 5.965802160933829],
            [1.4356174878729895, 6.052860897484713],
            [1.5287930127687424, 6.054767389081312]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.23216595510719, "lat": 44.579495412304 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27143"],
        "coty_name": ["Sibley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sibley County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00659516"
      },
      "bbox": [
        1.4356174878729895, 5.793095428292178, 2.051459946393267,
        6.062809720998903
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0644025022162447, 7.08468356161396],
            [1.0642285442880373, 7.099085697363915],
            [1.1505930179533315, 7.100505258871786],
            [1.2157711394038784, 7.101498227488803],
            [1.2373374007921976, 7.101495412564912],
            [1.2697868575253228, 7.102295278488128],
            [1.2878501782321126, 7.102247774057466],
            [1.3565720519646123, 7.102560079812851],
            [1.3886345806180334, 7.102991028415774],
            [1.410240902702863, 7.1036187174380085],
            [1.4293763411797469, 7.104110555677376],
            [1.4797692236838895, 7.104834671521282],
            [1.5014492536269517, 7.105398763637833],
            [1.5271707799830172, 7.106507092822804],
            [1.545376216589403, 7.10700744582522],
            [1.6276696335568053, 7.108253831444273],
            [1.6699994767065878, 7.109048922849943],
            [1.6693992290842834, 7.101608068546043],
            [1.6751414425108233, 7.097085318004837],
            [1.673948127583924, 7.088689016319463],
            [1.6774142803315273, 7.081968714336272],
            [1.67900949699102, 7.076630725296527],
            [1.6875373484510137, 7.069707093643575],
            [1.6948345716195392, 7.064991495446156],
            [1.710379899836489, 7.061233268544215],
            [1.711004162875409, 7.0566748845891345],
            [1.7039791434814695, 7.050268877429427],
            [1.7049078236105848, 7.045148391034116],
            [1.7073697579010088, 7.041668366900607],
            [1.7144849156918012, 7.036362457321015],
            [1.718098025551405, 7.022898549539321],
            [1.7197973950709446, 7.013691258020423],
            [1.7234332786507405, 7.012178016042828],
            [1.7320123473738889, 7.016059804516827],
            [1.731664421200752, 7.010448231346257],
            [1.725098593740369, 7.007762243225441],
            [1.723458887059139, 7.0043230164593115],
            [1.7242467171535885, 6.990980737058655],
            [1.7237921728852972, 6.988231387376319],
            [1.7194961234345834, 6.98225020389708],
            [1.7191596424472488, 6.973024690334772],
            [1.7212800845605845, 6.9597727930955084],
            [1.7204731326781175, 6.955555494525879],
            [1.7289461101390098, 6.937149627049803],
            [1.7439211839587963, 6.926331740987969],
            [1.7462204422870184, 6.921025310410085],
            [1.7473597983160387, 6.9127651420717084],
            [1.751500547271905, 6.903343153661531],
            [1.759563965526071, 6.896255287246839],
            [1.7624038093258525, 6.890750535571114],
            [1.7614256995269946, 6.886233081868515],
            [1.761860452443217, 6.874442237526559],
            [1.7607599289156286, 6.8711115843222785],
            [1.7571018774979763, 6.871028016935422],
            [1.7605025740200015, 6.863014199077433],
            [1.767405450093254, 6.8540106660852445],
            [1.76497258667387, 6.846360883571592],
            [1.766086323521783, 6.831022648142392],
            [1.7690015234241738, 6.8294257684490445],
            [1.7713683846076762, 6.825497359876074],
            [1.7781211577413474, 6.8198640560765424],
            [1.785185664236449, 6.817325215462367],
            [1.7917633717428223, 6.808844990309902],
            [1.7957890005030823, 6.8053004637190195],
            [1.7956019410448283, 6.797622810346832],
            [1.7944073064325725, 6.7915876975113925],
            [1.801649181378043, 6.788125907737839],
            [1.8093675319403646, 6.7857342715836575],
            [1.8114196106074723, 6.781984809413731],
            [1.8110417265710925, 6.777108707156335],
            [1.8180887676027142, 6.777666730588034],
            [1.8221524739416077, 6.771401009052397],
            [1.8282960645457038, 6.774451183361678],
            [1.8310119455467075, 6.773900461788601],
            [1.8335878770806122, 6.762444033230556],
            [1.8299082227719456, 6.763180722597842],
            [1.8273763484874077, 6.760535325956528],
            [1.827725551856602, 6.755542229929339],
            [1.821161403721135, 6.748262920499519],
            [1.8191012378335858, 6.743413592588529],
            [1.8203581064344312, 6.73884574713886],
            [1.8170683171239133, 6.734156257092997],
            [1.813031902683717, 6.723417544899347],
            [1.8076061467287599, 6.719123544217926],
            [1.8076819347929574, 6.713620120736951],
            [1.8108226073530411, 6.705412409499765],
            [1.8070262867372424, 6.703689806913895],
            [1.8059782956947927, 6.698862134992531],
            [1.802933106041171, 6.692831825265471],
            [1.8033679467153718, 6.68768866758401],
            [1.8058142884169495, 6.686140418457496],
            [1.8029212392441578, 6.681765548112213],
            [1.7992726321210855, 6.6827841807472534],
            [1.7920071655191239, 6.676904773513788],
            [1.7870388313741596, 6.667281505136958],
            [1.7594445651453774, 6.64282375801395],
            [1.7565889336871263, 6.64294871478278],
            [1.7544090627673057, 6.639961605856068],
            [1.7477459367233044, 6.640083561647043],
            [1.742972949209254, 6.65165101116878],
            [1.738178901182423, 6.6565316746430545],
            [1.732738980216701, 6.657218959978344],
            [1.7263918240233171, 6.655462473447371],
            [1.724131593417779, 6.65358725405887],
            [1.7160180913470364, 6.653574815522417],
            [1.7138652619065293, 6.6500480032529365],
            [1.7019846787883983, 6.647435739442137],
            [1.6989467928735236, 6.645929679439483],
            [1.6919565608723113, 6.645883154133864],
            [1.6889226448978916, 6.6438040931495514],
            [1.6906752749286569, 6.638258788253967],
            [1.6858902351536178, 6.635219470858381],
            [1.6864153077756519, 6.621563890019011],
            [1.671943058213373, 6.62035405976202],
            [1.6004362199472768, 6.618918935300542],
            [1.5995750102449633, 6.662477594234981],
            [1.571140703216015, 6.661503343179033],
            [1.5208777614393485, 6.660461721637384],
            [1.4936780002330916, 6.660263184954193],
            [1.4778183276921748, 6.659792539757213],
            [1.4193726978999566, 6.65864725848864],
            [1.3329479251310878, 6.657970394798913],
            [1.3319208853768378, 6.744163297629473],
            [1.2452760976976565, 6.7431965365469075],
            [1.1593606240424439, 6.7415643446887605],
            [1.0730050015579404, 6.740951981166395],
            [1.0725116195819038, 6.82324248438913],
            [1.0717083910841847, 6.912259593974659],
            [1.06584543685357, 6.912192766436868],
            [1.0657435304392915, 6.9552922363504885],
            [1.0653619612823506, 6.99865381185722],
            [1.0644025022162447, 7.08468356161396]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.6131461978801, "lat": 45.55214335750581 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27145"],
        "coty_name": ["Stearns"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stearns County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00659517"
      },
      "bbox": [
        1.0642285442880373, 6.618918935300542, 1.8335878770806122,
        7.109048922849943
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.858732677163797, -3.55145797464716],
            [5.968271712355204, -3.5431090988176708],
            [5.983800402242607, -3.5422468502892053],
            [6.017431371180028, -3.5403963522748367],
            [6.031847106356529, -3.538949507502817],
            [6.1305296762288, -3.5311423754268434],
            [6.132846728431354, -3.5574574693244077],
            [6.136601972440448, -3.616268138305268],
            [6.140269866821597, -3.6679058548189793],
            [6.126099583922162, -3.668905965730071],
            [6.129042677399155, -3.7125851311204436],
            [6.086226764650085, -3.715662311979751],
            [6.0900417271197105, -3.7740705156547367],
            [6.097211687744042, -3.8706526109108634],
            [6.101784632953563, -3.933482639358486],
            [6.059008042276052, -3.9369396323243],
            [5.973876640811129, -3.943323863948985],
            [5.974877443146156, -3.957739507284998],
            [5.931979896586256, -3.9610845461385598],
            [5.9279578650649745, -3.903255539420618],
            [5.925552092577055, -3.8732225754106158],
            [5.922004878419401, -3.8240109551379065],
            [5.9209996431686, -3.812510372586682],
            [5.912679329108287, -3.6987192910673268],
            [5.86926206922486, -3.701749590468062],
            [5.867936745886733, -3.685170844067583],
            [5.864006054371379, -3.6286512134967683],
            [5.858732677163797, -3.55145797464716]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.18845705690613,
          "lat": 34.817300436282295
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28009"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00695729"
      },
      "bbox": [
        5.858732677163797, -3.9610845461385598, 6.140269866821597,
        -3.5311423754268434
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.173871759112406, -7.889232065350867],
            [6.175577305194259, -7.9120550894075805],
            [6.183910971666665, -8.034189500430035],
            [6.186955236449289, -8.075308261829104],
            [6.193579038603472, -8.161242226989357],
            [6.1864102748752074, -8.163630149253741],
            [6.183298936079418, -8.166033001570979],
            [6.174619133225614, -8.177322693508087],
            [6.1738238880896175, -8.181478161258452],
            [6.168823113975295, -8.183441374242378],
            [6.165117176089884, -8.186540403786093],
            [6.163589420354659, -8.192710273106854],
            [6.165749249385367, -8.19943330666483],
            [6.169355610360122, -8.20218377799999],
            [6.174275249461739, -8.198553562306396],
            [6.179252533819111, -8.198236839810104],
            [6.191349949886892, -8.19054657570211],
            [6.197480778131237, -8.190695342826517],
            [6.203253729172773, -8.195363420127238],
            [6.206581911508122, -8.206594311291004],
            [6.209538506549419, -8.207589225292816],
            [6.2133285302723404, -8.213148734689394],
            [6.213466020923453, -8.217512343959807],
            [6.207946647233086, -8.229822936664021],
            [6.196815033495084, -8.23894656070963],
            [6.183977647324214, -8.245051068545756],
            [6.176826455765508, -8.250967863424355],
            [6.169498297831093, -8.262220134697618],
            [6.161390511553172, -8.268998921320144],
            [6.155138648148317, -8.272551769326235],
            [6.1504486132425304, -8.273833536418522],
            [6.138622817193283, -8.279454522110797],
            [6.134444337407079, -8.283171113593156],
            [6.130523367211768, -8.292311178802295],
            [6.1310722170844345, -8.298531465741304],
            [6.135140986149273, -8.302834200283385],
            [6.1349633794669876, -8.307864228556129],
            [6.127512927688205, -8.313229811829457],
            [6.122263115287059, -8.321584948259536],
            [6.1120464735867035, -8.334737676677772],
            [6.112821302340991, -8.341243303082022],
            [6.115192249721174, -8.347895940478288],
            [6.114477613325554, -8.351899744636746],
            [6.108042798786872, -8.357143127376409],
            [6.106367527456188, -8.361089047537634],
            [6.102197049118128, -8.360991032161822],
            [6.104532718870287, -8.35613909287581],
            [6.103232812983715, -8.349289275659872],
            [6.096620166335834, -8.345863360120994],
            [6.090165706214187, -8.348539389596093],
            [6.086235394873739, -8.346631530787976],
            [6.080865164954095, -8.349564823879405],
            [6.077573784075303, -8.352976389306649],
            [6.076189277307033, -8.35731611179712],
            [6.071959554790945, -8.359017210766918],
            [6.065340545049005, -8.35772469178798],
            [6.05676531034157, -8.357829196898146],
            [6.050366000368266, -8.35952585957548],
            [6.045336092595074, -8.354143940186885],
            [6.040410359754156, -8.348695003937546],
            [6.035778791389547, -8.348013975874958],
            [6.028814761064346, -8.351164343520566],
            [6.022679905302652, -8.35882668494066],
            [6.0163655997816, -8.362627271010428],
            [6.009703475484349, -8.36515960376783],
            [6.005905517382824, -8.364023810061992],
            [6.0001757640158955, -8.359938589507959],
            [5.995471551409841, -8.354394995777522],
            [5.992248595318871, -8.346466816685526],
            [5.984756397614796, -8.335545864949067],
            [5.980506519718377, -8.331558735751017],
            [5.974929688900696, -8.33093739848473],
            [5.97054921647974, -8.328845531741216],
            [5.967459808059207, -8.325377302019346],
            [5.966137844505063, -8.321194370297153],
            [5.967778674863242, -8.307179237967048],
            [5.965574791634745, -8.301465345924031],
            [5.956018240958435, -8.297779893669992],
            [5.95148286610705, -8.292936567825496],
            [5.952117681390371, -8.287768575352251],
            [5.955931240468992, -8.287264875022858],
            [5.955953557481158, -8.283709984781982],
            [5.950246193846335, -8.281415852624592],
            [5.951257548135738, -8.273442911302174],
            [5.950283161659114, -8.270427888096771],
            [5.9445590706880935, -8.265472854273888],
            [5.943614902689935, -8.262465590379671],
            [5.93939876722466, -8.263182305623285],
            [5.935751845964837, -8.259835436799802],
            [5.94146051799849, -8.25527532941706],
            [5.9398118744732304, -8.24714214794852],
            [5.941154953230604, -8.24359344006239],
            [5.948093700641619, -8.24109505933288],
            [5.952425598457017, -8.235915668973485],
            [5.948828347921862, -8.229435691362415],
            [5.947580160717252, -8.21767787191773],
            [5.9477315346895905, -8.21135368724099],
            [5.941768465790333, -8.207095935438305],
            [5.9338403887173685, -8.203491679573368],
            [5.932257586053145, -8.19924979773878],
            [5.922972789680194, -8.19587445390937],
            [5.919857643318974, -8.189151651909121],
            [5.9176797416703355, -8.18156357207343],
            [5.910121529272617, -8.17096922767978],
            [5.907407337185425, -8.1643430664633],
            [5.901203505980575, -8.154102132407408],
            [5.896918412178125, -8.148537954945366],
            [5.896096745947846, -8.141859681954688],
            [5.9008187361772695, -8.140190619211431],
            [5.8981075228880435, -8.125545879916771],
            [5.893710052837941, -8.115310935494763],
            [5.894996821691097, -8.10896397229993],
            [5.894099904958285, -8.103074881159085],
            [5.8881345537669425, -8.096026123188828],
            [5.92491336681506, -8.093980563045763],
            [5.921883466998937, -8.05058292397179],
            [5.940794598745661, -8.049750911559387],
            [5.965941933686265, -8.047899401827305],
            [5.964838015408733, -8.033471995793498],
            [6.008904935796039, -8.03072142871466],
            [6.008721207934833, -8.023996283994345],
            [6.00486338767965, -7.9625130597122435],
            [6.000197574310876, -7.9004744110548195],
            [6.038024310739483, -7.897921742880938],
            [6.042237900511549, -7.897921384748204],
            [6.121838822740906, -7.892839193825467],
            [6.173871759112406, -7.889232065350867]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.48901356441223, "lat": 30.4165424859077 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28045"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00711756"
      },
      "bbox": [
        5.8881345537669425, -8.36515960376783, 6.213466020923453,
        -7.889232065350867
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.443894447372682, -6.188011167599769],
            [5.445248782657898, -6.183257764487373],
            [5.442612976295289, -6.18097179567441],
            [5.434960644002492, -6.170564888787776],
            [5.442774543630799, -6.171312549738682],
            [5.444954896442363, -6.167460048283649],
            [5.442809753815412, -6.165237627123942],
            [5.438040880927284, -6.154027182892346],
            [5.439456590774131, -6.1491472915613565],
            [5.448521945208782, -6.152077335686179],
            [5.449746327882581, -6.1478020986838695],
            [5.4538256851295435, -6.1491186340829485],
            [5.457555082481431, -6.148084806667105],
            [5.4622228586036465, -6.144652265854624],
            [5.465183269339004, -6.140396464251942],
            [5.461570094893592, -6.136871633543243],
            [5.469103594240247, -6.12620820735015],
            [5.47287077073336, -6.1228149717722715],
            [5.474317211323034, -6.117402921104724],
            [5.473545517822537, -6.1139248610786385],
            [5.478680170152501, -6.111535546730317],
            [5.477823880560385, -6.107998633946008],
            [5.4822736030964645, -6.104890517776643],
            [5.487943425243145, -6.104270275335749],
            [5.48825603289114, -6.09987450437418],
            [5.496151670043234, -6.097794381417176],
            [5.499734429079838, -6.101076572905549],
            [5.505919696078962, -6.092273164981244],
            [5.508135016402195, -6.0851531258376],
            [5.5127508750609735, -6.086896893983701],
            [5.515038229748249, -6.089524856838191],
            [5.517842579135341, -6.086403077660651],
            [5.522131987269247, -6.08792546932633],
            [5.524880530374356, -6.091016952574931],
            [5.527498978807581, -6.084680326727477],
            [5.529926172135351, -6.083578815720362],
            [5.530838219471754, -6.078858909111918],
            [5.537822759746048, -6.075443311574783],
            [5.538002165808659, -6.070970034356095],
            [5.5403693753568675, -6.068052272258304],
            [5.549206729029811, -6.06838268378434],
            [5.551922487173749, -6.065025519194867],
            [5.5551840868587155, -6.055090008904387],
            [5.554954846429062, -6.05139891954361],
            [5.5650303474478475, -6.050982277264481],
            [5.565311043746573, -6.047155390280512],
            [5.563179859877725, -6.0442258800784945],
            [5.565436987096424, -6.041842158069343],
            [5.56969084170866, -6.042205968057169],
            [5.577475407724748, -6.034321652886931],
            [5.57901246723133, -6.0290110437212165],
            [5.5762108624432525, -6.024548156025406],
            [5.581179509303153, -6.020073085018011],
            [5.583650917428727, -6.015182338546309],
            [5.591498137045959, -6.018347419418726],
            [5.5963112309066325, -6.016603299935884],
            [5.599750357935138, -6.012844467871839],
            [5.6020660168320955, -6.007877774357267],
            [5.60339221910427, -5.993937844219252],
            [5.606409318897058, -5.9928105512546415],
            [5.613509946591234, -5.993860696553324],
            [5.6165844076245195, -5.992713277737725],
            [5.619804363585164, -5.987337494097364],
            [5.620983601149394, -5.982753786997677],
            [5.627061138863201, -5.989199290624822],
            [5.63195394913505, -5.990661097892959],
            [5.639304117539291, -5.988079352598069],
            [5.641296747787737, -5.992147096135064],
            [5.648355798387008, -5.989351844677031],
            [5.648709417155397, -5.986257646272495],
            [5.65536821317712, -5.983770326791223],
            [5.657721731686828, -5.988756538633361],
            [5.660841466352927, -5.985983566329761],
            [5.661268422776642, -5.982237934275228],
            [5.664399398555173, -5.98113401277428],
            [5.663415086264212, -5.987328696877701],
            [5.66755293994093, -5.986046874957245],
            [5.679231002847916, -6.028357225471886],
            [5.698450239644301, -6.101786676513564],
            [5.728267215238099, -6.216705556378559],
            [5.729628857254977, -6.2341022240466355],
            [5.734960668899084, -6.3190019899648915],
            [5.736624970559796, -6.34703541960846],
            [5.736097854314193, -6.347163136512985],
            [5.739738949908276, -6.404052992651969],
            [5.741824083269778, -6.434533558692334],
            [5.743008232966349, -6.434461830789699],
            [5.744537092410222, -6.457265585016933],
            [5.748517676852118, -6.5213750174583],
            [5.708010371508735, -6.5239535358900005],
            [5.620623461580018, -6.529237397562019],
            [5.574223213132391, -6.531769342006875],
            [5.574045870915895, -6.530549097383301],
            [5.533779893011403, -6.532892267466455],
            [5.455435458401827, -6.537737518922403],
            [5.4068971270105965, -6.5405373060800045],
            [5.327234927140625, -6.5452631667411865],
            [5.3255537025566, -6.54128988257177],
            [5.32728152622833, -6.538124926319668],
            [5.321333106559478, -6.530658198735542],
            [5.322137715637034, -6.526530660729595],
            [5.327306866206598, -6.526001546123887],
            [5.327556511247719, -6.5174501364600905],
            [5.323856642096611, -6.509329062431256],
            [5.320381052302452, -6.505695593249021],
            [5.3258282506866985, -6.502996962958162],
            [5.325714961638234, -6.4996686523787615],
            [5.3176358575464535, -6.50126664657843],
            [5.3156019273531125, -6.50404216053447],
            [5.31053949181098, -6.5018663258050315],
            [5.309764621581386, -6.496971289496896],
            [5.312170577777278, -6.4952278225186255],
            [5.315015360486935, -6.498764715714331],
            [5.318232305180705, -6.494469285639322],
            [5.314045523872037, -6.492381852591743],
            [5.310726338916828, -6.492566814734128],
            [5.305847182431244, -6.483866098599738],
            [5.31119506481328, -6.479559499838204],
            [5.3138744602433725, -6.474062762014107],
            [5.312965037653805, -6.468556096350039],
            [5.308487922099811, -6.462972116719272],
            [5.307632856383344, -6.458640500955577],
            [5.3090389204895265, -6.455718416261157],
            [5.31072169419347, -6.447029595534261],
            [5.308665181332048, -6.444861279866692],
            [5.305099103317982, -6.447608371414833],
            [5.301527738484846, -6.44405227016186],
            [5.311053949115586, -6.44084521996495],
            [5.307166116199789, -6.424756985732478],
            [5.309570513091935, -6.418021995872109],
            [5.314383615991042, -6.417677700225685],
            [5.317739141565174, -6.421918991398584],
            [5.322731665986078, -6.416300005511681],
            [5.324353426991454, -6.417461785839574],
            [5.334164717171649, -6.4145504564195805],
            [5.337321308607266, -6.405572149860071],
            [5.341617420144829, -6.407093796660822],
            [5.346130325767622, -6.405869138177528],
            [5.347737738291042, -6.400816948461435],
            [5.3466521551308235, -6.398129907771135],
            [5.348850265476938, -6.394950080135197],
            [5.351820268087129, -6.398240063082698],
            [5.358850623152759, -6.391398347557864],
            [5.351993881138491, -6.39051372880977],
            [5.35053463981554, -6.3838412523480015],
            [5.352003031470761, -6.378640871225478],
            [5.354535118091605, -6.375256156328568],
            [5.348532970555107, -6.367943956639178],
            [5.345013016202233, -6.368524217580793],
            [5.337364406481396, -6.3630025620067086],
            [5.3390481235096345, -6.3574326809827335],
            [5.337672396202188, -6.353674802442188],
            [5.341648606430517, -6.353067091058316],
            [5.341202138073826, -6.349891342256055],
            [5.336298869250197, -6.348386348100875],
            [5.335931621833074, -6.342407155664095],
            [5.338877229212018, -6.338123561273752],
            [5.34235153075195, -6.337110798921404],
            [5.3448044519964695, -6.331718715145278],
            [5.351522640693189, -6.332749423568709],
            [5.353305767373712, -6.327769097139772],
            [5.349987505080316, -6.3271342877002965],
            [5.350399718338083, -6.319942040143015],
            [5.355931856925542, -6.316950390807555],
            [5.356591664948444, -6.309903899876384],
            [5.355493364740067, -6.306072721237075],
            [5.360212651272807, -6.302352269601768],
            [5.362718181789186, -6.305228633212586],
            [5.371212320792252, -6.306326460541891],
            [5.373822953792552, -6.2981560663944105],
            [5.3789053615286315, -6.299946273505355],
            [5.368367340445156, -6.286080756513059],
            [5.373460413337845, -6.281461305342083],
            [5.376653887902387, -6.28126282122191],
            [5.374701896317314, -6.275573504981926],
            [5.376088158835943, -6.268084765050036],
            [5.381319724651882, -6.2661042044803725],
            [5.384573896329587, -6.270175841531573],
            [5.387771152915393, -6.26496152686554],
            [5.3940889651800825, -6.2609689782691085],
            [5.39672251947834, -6.256630803140857],
            [5.40346298878606, -6.250115129117024],
            [5.405030813430456, -6.243917586373815],
            [5.410124580417548, -6.245266737762776],
            [5.410194758466782, -6.241049843471149],
            [5.406974972320596, -6.235363534652417],
            [5.408391048968678, -6.226947876529786],
            [5.412758455439268, -6.229890805801815],
            [5.417339195396245, -6.2224670172346155],
            [5.414177932571178, -6.218133942935616],
            [5.419142914425499, -6.213167534196015],
            [5.415641914974806, -6.206977678553761],
            [5.419868155234671, -6.207312314020912],
            [5.419828671014474, -6.199902896147314],
            [5.4280264743280915, -6.202761472657852],
            [5.429135915474284, -6.198027825448675],
            [5.4316941776757846, -6.197265368316726],
            [5.430926448841429, -6.1930074925886895],
            [5.435541443673623, -6.194222551475014],
            [5.434426108598862, -6.20049102265442],
            [5.442541870761611, -6.1957939352903875],
            [5.4437331900469035, -6.193408411900838],
            [5.441355718905237, -6.189292641947581],
            [5.443894447372682, -6.188011167599769]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.94585390840491, "lat": 32.26413084289116 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28121"],
        "coty_name": ["Rankin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rankin County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00695781"
      },
      "bbox": [
        5.301527738484846, -6.5452631667411865, 5.748517676852118,
        -5.98113401277428
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3138801899841717, 10.325280704707595],
            [-2.225627329252955, 10.321431045365374],
            [-2.1354676492108844, 10.317623843701679],
            [-2.0741838997215027, 10.315330180304782],
            [-1.9662327173352592, 10.311199066312533],
            [-1.8779014173322854, 10.307954113834606],
            [-1.8805863135316845, 10.231954212180225],
            [-1.8807640255867737, 10.23154819054286],
            [-1.8849946419889922, 10.119277925376085],
            [-1.8882782744514721, 10.034894203848314],
            [-1.8663471796406035, 10.034072072265058],
            [-1.8695714864767212, 9.949786541514241],
            [-1.8727791080664287, 9.865124717044417],
            [-1.9664897727893187, 9.868723284785045],
            [-2.0619776258767737, 9.872212625911855],
            [-2.178341003524718, 9.87707495628962],
            [-2.243702171511179, 9.879932268967456],
            [-2.3090640221143652, 9.882775155732618],
            [-2.30520336765569, 9.96745562508706],
            [-2.3013304030431407, 10.051795769434937],
            [-2.326352242136472, 10.052909079693569],
            [-2.3205507838216506, 10.181757338391938],
            [-2.3201610649564364, 10.187250086987579],
            [-2.316120278337195, 10.27783141810687],
            [-2.3138801899841717, 10.325280704707595]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.84095768800502,
          "lat": 48.772444046536286
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38079"],
        "coty_name": ["Rolette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rolette County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01034228"
      },
      "bbox": [
        -2.326352242136472, 9.865124717044417, -1.8663471796406035,
        10.325280704707595
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.908928220212929, 8.673421947692473],
            [-1.8496384733984923, 8.671249977729413],
            [-1.7625293702421494, 8.668255088025187],
            [-1.7509918385889571, 8.667757773446722],
            [-1.6505242939180196, 8.664406618643929],
            [-1.5636304515070165, 8.661592945686364],
            [-1.446386934948124, 8.657953545413418],
            [-1.3271252420654729, 8.654460079725842],
            [-1.2399102873069174, 8.652126320048104],
            [-1.2180823324875711, 8.651555493103618],
            [-1.2186026520927162, 8.623949602948707],
            [-1.220437397671179, 8.568089646560944],
            [-1.220202261636613, 8.566902090419916],
            [-1.2220139473765594, 8.502842385473961],
            [-1.2248678503497854, 8.395895806247522],
            [-1.2272554812954692, 8.310299811311413],
            [-1.2082101762171606, 8.309849651664605],
            [-1.2085984710415518, 8.288911168744189],
            [-1.2111496198501888, 8.180871800630378],
            [-1.2121094492936062, 8.136037227325827],
            [-1.2138553217554047, 8.08090244723737],
            [-1.2154777077393653, 8.009158782602121],
            [-1.216652880486679, 7.9663176548312915],
            [-1.3036193543293573, 7.968384201309186],
            [-1.390779540167058, 7.970739498336937],
            [-1.5147587091073709, 7.97415452121672],
            [-1.6269411556782154, 7.977431012490593],
            [-1.6282519782506613, 7.977165384829711],
            [-1.6359516639533378, 7.977637646877808],
            [-1.714626040023304, 7.980501827742088],
            [-1.8257773353844418, 7.98482081367806],
            [-1.9126726164512438, 7.988181662905438],
            [-1.9102419094075613, 8.03767109721855],
            [-1.9085519921635585, 8.076006403736955],
            [-1.906950547020296, 8.117095579614888],
            [-1.9021696892464803, 8.225854951036856],
            [-1.8974516343469354, 8.331522458125802],
            [-1.9214918218513306, 8.332898203792208],
            [-1.9185282930902234, 8.417980841088996],
            [-1.915288859393624, 8.503425768172871],
            [-1.9118413013357398, 8.588814134021213],
            [-1.9117725238460925, 8.597784969077916],
            [-1.908928220212929, 8.673421947692473]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.95883750476136, "lat": 46.97923922409426 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38093"],
        "coty_name": ["Stutsman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stutsman County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01034224"
      },
      "bbox": [
        -1.9214918218513306, 7.9663176548312915, -1.2082101762171606,
        8.673421947692473
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.275939734919326, 3.6114500886515115],
              [10.28267975931293, 3.6179391882678424],
              [10.282770132992512, 3.625892174075021],
              [10.285788758314832, 3.628986638815783],
              [10.293601616793433, 3.630155961752338],
              [10.298521792682157, 3.623556852996312],
              [10.302473463004334, 3.62256061851486],
              [10.307647464589254, 3.6240103832010977],
              [10.313956550435298, 3.6328024255974913],
              [10.316860161949364, 3.632922867809528],
              [10.313754979039043, 3.6251583083673253],
              [10.315632925879278, 3.619177867452722],
              [10.316924222629929, 3.6090350464048453],
              [10.31393726859386, 3.600670422752161],
              [10.304633965568748, 3.596907063599009],
              [10.301893591225111, 3.597893931461755],
              [10.301545695413814, 3.6025584313143133],
              [10.291317069661025, 3.604928864763557],
              [10.284075594151561, 3.6047431549601416],
              [10.27622987505464, 3.609074838101432],
              [10.275939734919326, 3.6114500886515115]
            ]
          ],
          [
            [
              [10.585080187618521, 3.4774393511598394],
              [10.5896989293796, 3.451538003430675],
              [10.610096679768274, 3.334586088589911],
              [10.536209882764116, 3.3235764945780617],
              [10.464473351180057, 3.315125530949581],
              [10.430105449613963, 3.3108926428889407],
              [10.402478526956145, 3.3069266042472543],
              [10.39369174807803, 3.306103074684292],
              [10.374564046149438, 3.3033802978024127],
              [10.35990886579917, 3.3017976370372586],
              [10.325639961742574, 3.2975736032812453],
              [10.283578971521614, 3.292678709441757],
              [10.240897901525374, 3.28811523320743],
              [10.233688596791128, 3.3303322122271024],
              [10.21676720982797, 3.4274674846970683],
              [10.17681598832631, 3.4219038499271814],
              [10.177401429359097, 3.423241060582806],
              [10.196007534084444, 3.4324258484352748],
              [10.196666837859269, 3.4351012720192875],
              [10.20381717341996, 3.435637697807313],
              [10.209540885037836, 3.4385372724174155],
              [10.214325441689365, 3.442557155678138],
              [10.215323142440305, 3.445653647063865],
              [10.221409684053603, 3.447769826426916],
              [10.224785776990881, 3.451495037367291],
              [10.227285552872894, 3.4574965532775606],
              [10.223906365967323, 3.4714775825790722],
              [10.2264322807089, 3.4725524240936623],
              [10.23087788845344, 3.468830467875438],
              [10.237104537328575, 3.470240517805353],
              [10.237034475563346, 3.4758385095515822],
              [10.246450282786004, 3.465935954981449],
              [10.26039581885142, 3.4581121794206657],
              [10.274594786448029, 3.4510492685043492],
              [10.283422140564744, 3.4504744435925017],
              [10.290461448851199, 3.45792741332949],
              [10.300263503970273, 3.458958304234536],
              [10.308467332738886, 3.4677977814299754],
              [10.319835866956224, 3.4748898924034615],
              [10.32210262225965, 3.4710180129418986],
              [10.32790763024996, 3.4673532626899672],
              [10.33711265406674, 3.4673342266441822],
              [10.341663846204316, 3.468286122939676],
              [10.341446766709206, 3.477516851153912],
              [10.332855386823677, 3.491337159478539],
              [10.328594861152188, 3.49451444125873],
              [10.322823104817063, 3.496568085713293],
              [10.321880734430232, 3.5005151785577895],
              [10.326641533856806, 3.504701853185128],
              [10.331574749739154, 3.497668630229367],
              [10.352193806529394, 3.477257007211583],
              [10.366010464642335, 3.465766593138171],
              [10.373440582403028, 3.46021312328156],
              [10.383915358739674, 3.4533797498646743],
              [10.381123097056395, 3.4439001139036947],
              [10.39189159567572, 3.442478907114364],
              [10.398688729423595, 3.4395231777675486],
              [10.400088481049048, 3.442062613704463],
              [10.40642112665189, 3.4381445009096576],
              [10.41444886711956, 3.435016996234344],
              [10.42398089379515, 3.433445214852078],
              [10.430238058011257, 3.4285872511279223],
              [10.439637762245598, 3.4247993948776037],
              [10.441842978582814, 3.4264727423908723],
              [10.45126110364171, 3.421738658142148],
              [10.47066995679308, 3.4149895000269845],
              [10.478878101280534, 3.414584261069597],
              [10.49375039684781, 3.4165755120329537],
              [10.508230029869521, 3.4237024981654813],
              [10.515530211796092, 3.429144024984341],
              [10.528294458926052, 3.437301367728383],
              [10.554861231361889, 3.460701289200076],
              [10.56798679400256, 3.4682733474186582],
              [10.573911558815354, 3.4744932574514418],
              [10.583153041993182, 3.476219904379005],
              [10.585080187618521, 3.4774393511598394]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.6193239717015, "lat": 41.3639697680185 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39043"],
        "coty_name": ["Erie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Erie County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01074034"
      },
      "bbox": [
        10.17681598832631, 3.28811523320743, 10.610096679768274,
        3.632922867809528
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.876235179403063, 2.3836458653536288],
            [8.867986504552894, 2.4545318462390804],
            [8.857916147175795, 2.539713715124469],
            [8.94235082476557, 2.549301401326452],
            [8.98321051088113, 2.554123118366161],
            [9.030095104177994, 2.5601056759671175],
            [9.116076656266369, 2.5708791444429266],
            [9.121379612713524, 2.527426727620197],
            [9.134128832814003, 2.4242401437284764],
            [9.141973442747618, 2.3649622034160975],
            [9.149056040522566, 2.3083326616738216],
            [9.160494853890897, 2.2114741139479044],
            [9.161828278132225, 2.201069203017038],
            [9.17809214781404, 2.198936401001377],
            [9.177942887018173, 2.198638853993854],
            [9.132894081290722, 2.1931026606072934],
            [9.0543798785499, 2.1825818881544947],
            [9.054472585362328, 2.181125711735023],
            [9.040318720786438, 2.179385896029811],
            [8.971816950054915, 2.171526904619554],
            [8.901198790585289, 2.1638415343631627],
            [8.893878219003986, 2.2241458037630673],
            [8.884327920699254, 2.313221459900367],
            [8.876235179403063, 2.3836458653536288]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.6293677621839, "lat": 40.54000236253609 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39107"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01074066"
      },
      "bbox": [
        8.857916147175795, 2.1638415343631627, 9.17809214781404,
        2.5708791444429266
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.3117295952363421, -2.982984377558403],
            [-1.275879552099588, -2.983902261002744],
            [-1.261644829483918, -2.984001671041784],
            [-1.2192663324159332, -2.9848876949220933],
            [-1.1340095520947429, -2.986457639362102],
            [-1.1121467971507062, -2.986467339835644],
            [-1.0404506744371962, -2.987980268141542],
            [-0.9758967834386798, -2.9895157905047887],
            [-0.8829409806541927, -2.9909393355124543],
            [-0.8841741161758988, -3.064498848924191],
            [-0.8860650418523717, -3.167074794742807],
            [-0.88396599320486, -3.167132844439649],
            [-0.8854537460036845, -3.247465232777027],
            [-0.8869926154866962, -3.342336328753527],
            [-0.8877338303036444, -3.3822974537859873],
            [-0.8877599689581706, -3.3838269673150028],
            [-0.8988174990093525, -3.3852889191816256],
            [-0.9081777159073388, -3.392036216735759],
            [-0.9161571233522252, -3.3943753786011195],
            [-0.9216638208475854, -3.3937819435077112],
            [-0.9221695614244015, -3.391285022513477],
            [-0.927206183377542, -3.39060899457584],
            [-0.9310338128118643, -3.3932421068106597],
            [-0.9412580636635357, -3.395141134266406],
            [-0.9503417665270287, -3.3893323776198123],
            [-0.9566141454007678, -3.3797539234099916],
            [-0.9624477615603324, -3.377541916428808],
            [-0.9655503264101348, -3.373217636218609],
            [-0.9692314039176001, -3.3726526105316146],
            [-0.9712082869878302, -3.378816442947104],
            [-0.9765105684966375, -3.3820554341194575],
            [-0.9822649585721408, -3.3814076680053193],
            [-0.9853337461703399, -3.385319511211363],
            [-0.9890093016780853, -3.3788008246076355],
            [-0.9974380545737456, -3.3768876466781124],
            [-1.0014694737667023, -3.379421823326241],
            [-1.0015699225287635, -3.383918297445692],
            [-1.0077661749908866, -3.3822297960938195],
            [-1.0119456765086954, -3.38376743244926],
            [-1.0189595031169132, -3.3819998979964825],
            [-1.0251672068907935, -3.3827181133049606],
            [-1.0350116712393516, -3.3759123662861237],
            [-1.037504827337668, -3.3719777153136175],
            [-1.0380134305268742, -3.3605763729842146],
            [-1.0419875602813435, -3.354892058779399],
            [-1.0477072530724572, -3.3540828613165514],
            [-1.050382950144181, -3.3556963491722964],
            [-1.0505971244672627, -3.3597455351870806],
            [-1.0533456633691143, -3.361063343408814],
            [-1.0600135982207004, -3.3605901249458126],
            [-1.059453032992042, -3.367459909568931],
            [-1.0619283062448797, -3.369043697068889],
            [-1.0675666591871193, -3.3692993788632672],
            [-1.072134403682126, -3.372141583818698],
            [-1.0748746578217778, -3.370787451047819],
            [-1.0734836972501296, -3.362718602003435],
            [-1.077837291212167, -3.3601847661057374],
            [-1.084024703297754, -3.363553907612076],
            [-1.089057074960547, -3.3623293837522477],
            [-1.0919148833870125, -3.3571152304529916],
            [-1.0966488360153055, -3.351503274622764],
            [-1.0978778716796973, -3.3421403221038153],
            [-1.0998940258171281, -3.3401179173182793],
            [-1.1068149539807588, -3.3381203843282963],
            [-1.1099362387753704, -3.3404127985918586],
            [-1.1091739714684141, -3.3529083295477973],
            [-1.1100191419832626, -3.358988381627938],
            [-1.1169620300122143, -3.369282831551128],
            [-1.1209713784412871, -3.369312191287053],
            [-1.1244578460660435, -3.3649451620413156],
            [-1.1284734461234411, -3.3635718167335735],
            [-1.1318378828725186, -3.3578419945724836],
            [-1.1379585994486334, -3.35848544212501],
            [-1.1415421313325649, -3.35615938650029],
            [-1.1521883801294897, -3.3520018847444315],
            [-1.154017779153024, -3.35007064299057],
            [-1.1580705444707402, -3.3539925367973824],
            [-1.161648240808426, -3.3535261969670502],
            [-1.1625931232540268, -3.3505375864511486],
            [-1.1599259549092482, -3.347490272873749],
            [-1.1621233567137035, -3.3427969314313373],
            [-1.1681199020105675, -3.335595217487202],
            [-1.1715453576306252, -3.33614402664954],
            [-1.2301100996488956, -3.334940234475428],
            [-1.290612428845779, -3.33407682733589],
            [-1.3222031594348205, -3.3338062342974384],
            [-1.359004973253084, -3.332971207628926],
            [-1.386706851333131, -3.331760745877981],
            [-1.4000501150189506, -3.3315282626501626],
            [-1.3990415420237243, -3.287981946468513],
            [-1.3976918897857487, -3.2370488247327356],
            [-1.396294901360281, -3.1714139774941783],
            [-1.3976246489661, -3.1627686642595427],
            [-1.397455016388278, -3.156194229585918],
            [-1.4013659616913996, -3.1558876396882236],
            [-1.3999078546839987, -3.0936006058962997],
            [-1.3970351267972612, -2.981407758946728],
            [-1.3117295952363421, -2.982984377558403]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.98235930223237, "lat": 35.54243894453999 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40017"],
        "coty_name": ["Canadian"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Canadian County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01101796"
      },
      "bbox": [
        -1.4013659616913996, -3.395141134266406, -0.8829409806541927,
        -2.981407758946728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0980074948868603, -2.6485584225038266],
            [1.1697307938688846, -2.6481574567138138],
            [1.1688170776813769, -2.5603541754362986],
            [1.1858957527452083, -2.5603372047654998],
            [1.2545354045560033, -2.559377533310013],
            [1.3256949976530266, -2.5588265959843666],
            [1.4256329227691469, -2.5575189894401564],
            [1.4271251760472974, -2.674124323080702],
            [1.427979502604583, -2.74472866309676],
            [1.428970569730032, -2.8203626071092867],
            [1.4208990423780161, -2.820463184467071],
            [1.4225941093471848, -2.953202333048396],
            [1.422568040278895, -2.9610478488167127],
            [1.4239786721629069, -3.084861430824028],
            [1.3815192396638238, -3.085335192418737],
            [1.2590688890723953, -3.0866752229055554],
            [1.1666934894370058, -3.087408681448004],
            [1.165877610435854, -2.9910793142466994],
            [1.1651216099896633, -2.912106314834804],
            [1.1077916522373448, -2.9123959700074513],
            [1.0538133948422828, -2.912531185233067],
            [1.0521236479126381, -2.9097463190966013],
            [1.0530985985415764, -2.905304096763316],
            [1.0617586586695988, -2.9009653885689475],
            [1.0642960371433543, -2.897191059912551],
            [1.0637073233796044, -2.891600771104696],
            [1.0682552255689226, -2.8878497582571407],
            [1.0763923098870807, -2.877461764912292],
            [1.081001231937248, -2.874087393227499],
            [1.0840924889838441, -2.863004132163976],
            [1.0825561573866687, -2.8560747374326434],
            [1.079994303187926, -2.852366953241593],
            [1.0766841314596052, -2.8511255466201364],
            [1.069028971929599, -2.8508448712753274],
            [1.0597186181649005, -2.8479465452655885],
            [1.0539329373942365, -2.841431501096986],
            [1.051417847917173, -2.8354230948350647],
            [1.0436681017926301, -2.826709676371483],
            [1.0391415602489205, -2.8169087018351044],
            [1.0409611255122, -2.806119119730557],
            [1.0449089053962335, -2.8004945342588994],
            [1.0500179210558866, -2.7954968693010316],
            [1.0505374252740782, -2.793046324065585],
            [1.049374305891692, -2.7773283572893526],
            [1.0463243997032639, -2.7685148052490764],
            [1.0427009343403038, -2.7640210676628305],
            [1.0421943597452337, -2.760578208484865],
            [1.0453135263768296, -2.7537830276273705],
            [1.0481876374878696, -2.750025991805805],
            [1.055007091973186, -2.7448955263771935],
            [1.0632678049727018, -2.736479669043459],
            [1.0743040358384883, -2.7365090782066797],
            [1.0774705615024565, -2.7328845911956137],
            [1.0775167361524303, -2.7218116529860503],
            [1.0806985722645341, -2.7217527106743873],
            [1.0806802700825766, -2.7147501229141264],
            [1.0846255427091414, -2.714775569464166],
            [1.084363099909453, -2.6838896388024436],
            [1.0981998068705723, -2.683133491988409],
            [1.0980074948868603, -2.6485584225038266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.99968168506, "lat": 35.906662888118746 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40021"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01101798"
      },
      "bbox": [
        1.0391415602489205, -3.087408681448004, 1.428970569730032,
        -2.5575189894401564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7831575443717487, -3.6355763544352535],
            [-2.742072392759931, -3.6372871852498556],
            [-2.6923479559620027, -3.639004158214831],
            [-2.692355272083685, -3.639380622974387],
            [-2.692653523544437, -3.6532299250226603],
            [-2.6957221730434258, -3.7258631480211193],
            [-2.5681032624390716, -3.7308082844343704],
            [-2.5697840067086415, -3.7746046914459783],
            [-2.5696915745957436, -3.7766194022942363],
            [-2.5713624673145086, -3.8183669971746723],
            [-2.5623713899134524, -3.8187016914100393],
            [-2.5634089113797867, -3.844266530786373],
            [-2.565026687200731, -3.876910673692735],
            [-2.564835492147994, -3.8805941089360414],
            [-2.565858803142713, -3.907725796649584],
            [-2.537404351841681, -3.9089056846922494],
            [-2.5378728984989496, -3.923620265729503],
            [-2.523569795122237, -3.924174448114584],
            [-2.5244639351396287, -3.953522298609357],
            [-2.5256763471975696, -3.9901296768878813],
            [-2.5273914898836676, -4.033740156152292],
            [-2.5309139039350836, -4.12861405502497],
            [-2.5326441735946914, -4.172037635502709],
            [-2.678101657979496, -4.166509539334235],
            [-2.6781666691802415, -4.166635780352193],
            [-2.6848375107568025, -4.161530017992425],
            [-2.6971552795148783, -4.144907772362271],
            [-2.7012159292109876, -4.135202680849415],
            [-2.7111279029363287, -4.122770777739265],
            [-2.7180925118360055, -4.115961792481935],
            [-2.7204776423047075, -4.11558842996155],
            [-2.733790757810522, -4.104805994502191],
            [-2.7385340137122123, -4.100305290362388],
            [-2.739505816790343, -4.09593855611624],
            [-2.744412225783318, -4.093560319873542],
            [-2.7576760291055415, -4.090436362222133],
            [-2.764940054865681, -4.0912200321184775],
            [-2.7675969868724595, -4.096631142860541],
            [-2.774468573698195, -4.1032546175562965],
            [-2.779476261526876, -4.106734568544172],
            [-2.7912177722050284, -4.108357562509203],
            [-2.8007263360961336, -4.107611898698249],
            [-2.8030728865587426, -4.107427701059519],
            [-2.800706259794063, -4.051375477423122],
            [-2.795188356897902, -3.9206720578837504],
            [-2.7906511269870213, -3.813163743199963],
            [-2.7831575443717487, -3.6355763544352535]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.84624015159427, "lat": 34.74408243002534 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40057"],
        "coty_name": ["Harmon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harmon County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01101816"
      },
      "bbox": [
        -2.8030728865587426, -4.172037635502709, -2.523569795122237,
        -3.6355763544352535
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2399625464765172, -4.035999005035591],
            [-1.1649421532944644, -4.036965092975997],
            [-1.0403113755881517, -4.03978459819552],
            [-0.8970031650437496, -4.042584551376079],
            [-0.8109674464828796, -4.044199589588102],
            [-0.81277314233096, -4.160843947918531],
            [-0.8139510337054011, -4.210762806762672],
            [-0.8132980674193976, -4.219303302320638],
            [-0.8150709244414389, -4.321681078110865],
            [-0.8166804809565887, -4.4091092817187185],
            [-0.817062497718967, -4.438238819839236],
            [-0.8818805798391774, -4.437212734984544],
            [-0.9746787742112265, -4.435418737819519],
            [-1.0893131769005062, -4.433289507106882],
            [-1.1747765200040245, -4.431660502411349],
            [-1.1893222551002633, -4.43093697675164],
            [-1.2467057787373068, -4.429304715253073],
            [-1.2897164080248604, -4.428416543688496],
            [-1.2887995584255754, -4.384651502921419],
            [-1.2872036246482084, -4.319223638436944],
            [-1.2865411763848174, -4.297384900572124],
            [-1.2847976915854151, -4.210178663350692],
            [-1.2871768433525719, -4.210134263353262],
            [-1.2851111493936984, -4.122426236136209],
            [-1.2835883274489988, -4.057063510917909],
            [-1.2829350651441778, -4.035049781025322],
            [-1.2399625464765172, -4.035999005035591]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.85151650470753, "lat": 34.48557145175671 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40137"],
        "coty_name": ["Stephens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stephens County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01101856"
      },
      "bbox": [
        -1.2897164080248604, -4.438238819839236, -0.8109674464828796,
        -4.035049781025322
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.08186617848979, 8.377259421143723],
            [-16.078444216903584, 8.37593538277685],
            [-16.035065048279233, 8.364909451612924],
            [-16.02784273973361, 8.36388588943622],
            [-16.000129400178686, 8.356943402785332],
            [-15.994334087856599, 8.355879234825865],
            [-15.912810386122237, 8.335750831607067],
            [-15.831291138512613, 8.315603611941338],
            [-15.8309742049731, 8.31522178828362],
            [-15.73280310408918, 8.291546200091238],
            [-15.62256704407631, 8.264842971924999],
            [-15.584197470785256, 8.256380410361686],
            [-15.515938123715866, 8.240059534744496],
            [-15.447681777338422, 8.223725534553045],
            [-15.398072361868394, 8.211528452108988],
            [-15.290968337328962, 8.18401799348809],
            [-15.256931142559694, 8.175177423976539],
            [-15.257842034702605, 8.171888497062872],
            [-15.255036479080099, 8.169267133237293],
            [-15.24731224977014, 8.166882632411621],
            [-15.243731796198759, 8.167389551496129],
            [-15.243120436564006, 8.163312715819739],
            [-15.237723769205122, 8.160002655379014],
            [-15.240324848515447, 8.152806420276871],
            [-15.240622570491917, 8.147320757735427],
            [-15.243429557212176, 8.142468192920925],
            [-15.24210159021265, 8.138246872083629],
            [-15.234204502537139, 8.137783082946997],
            [-15.222869701817853, 8.142613558488982],
            [-15.217973872977659, 8.145363109131129],
            [-15.208003715897199, 8.140313055614142],
            [-15.207316770023347, 8.14540813224922],
            [-15.204728260839213, 8.146675981535061],
            [-15.203075878572134, 8.15067195949701],
            [-15.199848963118415, 8.147436461243572],
            [-15.192603056369412, 8.14688205282493],
            [-15.186096295894703, 8.15382767730489],
            [-15.182468780210668, 8.154534568836612],
            [-15.181271504792418, 8.150084631807204],
            [-15.174892930414476, 8.147322067524573],
            [-15.171439025183966, 8.138965426036375],
            [-15.167278727907346, 8.13414063201685],
            [-15.166525669843802, 8.13039659317685],
            [-15.1632547425153, 8.129173119510783],
            [-15.158476109838722, 8.132159201066107],
            [-15.154693588202719, 8.126818368532872],
            [-15.149024052873363, 8.122409261312336],
            [-15.148339171532418, 8.114165108212493],
            [-15.138565180737181, 8.116354215965034],
            [-15.133897238832045, 8.11191239020165],
            [-15.133151084922437, 8.107786299906577],
            [-15.129241860404946, 8.106268127926292],
            [-15.124081231902236, 8.10666229252995],
            [-15.122750442419942, 8.10406377546053],
            [-15.116546980154657, 8.102288916723012],
            [-15.111491454347233, 8.103179767092405],
            [-15.111163699670607, 8.101195446441317],
            [-15.114818631174998, 8.090513059206813],
            [-15.110091683807996, 8.0868462096455],
            [-15.108158957249382, 8.083749232779068],
            [-15.105058018380406, 8.084639377773591],
            [-15.10189590320991, 8.079016373877163],
            [-15.107742422080202, 8.069307189811548],
            [-15.111093813755106, 8.065509636606908],
            [-15.109186535052025, 8.06182829688755],
            [-15.111353768083093, 8.057745108694384],
            [-15.118111118947906, 8.053764183228148],
            [-15.117306763847983, 8.049280420327017],
            [-15.119664642947683, 8.04419907544334],
            [-15.11735197312225, 8.038984070088622],
            [-15.118703323769681, 8.036208664473445],
            [-15.119046062938773, 8.027440897036367],
            [-15.11713229490775, 8.020075714627714],
            [-15.12005274546364, 8.017465186517395],
            [-15.121642201119986, 8.010918925806774],
            [-15.128591037870954, 8.008598179856005],
            [-15.139510581473488, 8.01443008334582],
            [-15.142911790765567, 8.013703927999341],
            [-15.14808090133325, 8.021079300185638],
            [-15.159906776837586, 8.019409809439527],
            [-15.163916948341669, 8.021800352965226],
            [-15.168739758356155, 8.019496657273052],
            [-15.169633161595364, 8.009484342906063],
            [-15.180209541821121, 8.005456519399065],
            [-15.183201103548255, 8.000548186510898],
            [-15.190835964473788, 7.997427111014719],
            [-15.188433732028036, 7.992929062099417],
            [-15.185077945033909, 7.99028913862418],
            [-15.188691694365211, 7.983620341569017],
            [-15.187069586248024, 7.979330477785898],
            [-15.183255165688385, 7.975386610859952],
            [-15.18007511157975, 7.974366626754164],
            [-15.18066998759604, 7.967550689301255],
            [-15.182213303016818, 7.966348110700249],
            [-15.186865290601972, 7.9558557634851645],
            [-15.184829496394933, 7.94897247333597],
            [-15.185911765881064, 7.943614624324251],
            [-15.181588622178724, 7.9283659579300325],
            [-15.187456447390185, 7.924366354040559],
            [-15.18675331153983, 7.917914037207209],
            [-15.187789988518498, 7.90968768680978],
            [-15.193202595200589, 7.907309541604087],
            [-15.21072637162272, 7.9079868601475205],
            [-15.217783424254709, 7.907244944122884],
            [-15.220085345525817, 7.909790750724146],
            [-15.22484122019465, 7.90992759656698],
            [-15.229251819045789, 7.912846357560322],
            [-15.234474235693224, 7.913628321657509],
            [-15.24531951697655, 7.9194860513717025],
            [-15.254372306574814, 7.918721995480713],
            [-15.256088990940604, 7.916766305370579],
            [-15.264932923959087, 7.9109966291109535],
            [-15.265585111866567, 7.908161203886529],
            [-15.269730512740944, 7.903642470095184],
            [-15.275369105914042, 7.903761887624306],
            [-15.284379097061882, 7.9081291953452135],
            [-15.287298040493948, 7.903577464940279],
            [-15.291639865049866, 7.90125091276586],
            [-15.29964380588753, 7.906212764753369],
            [-15.30298833001169, 7.909690416439235],
            [-15.315782683431756, 7.904166906638411],
            [-15.318803087018676, 7.899871727879904],
            [-15.319353641360328, 7.896593208206634],
            [-15.328082305574751, 7.896397226332795],
            [-15.329574291692222, 7.90074528078878],
            [-15.33692253150523, 7.904281414635236],
            [-15.33921002972582, 7.9075609133933344],
            [-15.345364073042708, 7.904369456447563],
            [-15.350909217430283, 7.905539588520982],
            [-15.355645695366835, 7.903810056533526],
            [-15.358413155472974, 7.900757251127968],
            [-15.362112087742712, 7.888992528640861],
            [-15.359988607581222, 7.886910121032752],
            [-15.36010945627778, 7.87734227368573],
            [-15.357776116582938, 7.867384465407494],
            [-15.358611520925793, 7.862771202746771],
            [-15.354293267248027, 7.862231362415198],
            [-15.351573016764963, 7.859404175041958],
            [-15.3482077837828, 7.859537706523324],
            [-15.341066668665873, 7.854703464066277],
            [-15.339026384738263, 7.849326972243903],
            [-15.32781237331822, 7.845389073789257],
            [-15.322373174835581, 7.8386369693681806],
            [-15.314762151047724, 7.84123620890033],
            [-15.312098764035927, 7.838782953673051],
            [-15.306622071293075, 7.839768661575164],
            [-15.303867964562922, 7.8328319671040685],
            [-15.299067115757731, 7.825907478449716],
            [-15.295801387247035, 7.823515872516213],
            [-15.292948419808756, 7.824956846008895],
            [-15.285825697714488, 7.822732634964803],
            [-15.276829597648454, 7.824056268393007],
            [-15.274064333202887, 7.823102985922256],
            [-15.265773133394037, 7.812825219770881],
            [-15.261707787951627, 7.813185209065375],
            [-15.26168826187047, 7.809441577112921],
            [-15.25575362426745, 7.804173479205673],
            [-15.255930431649, 7.7989417599618465],
            [-15.25805746174563, 7.789357238485612],
            [-15.254017152828892, 7.7798203697977755],
            [-15.251196616290338, 7.779556787613108],
            [-15.245157617376858, 7.774725669679954],
            [-15.242670367082747, 7.770222231398572],
            [-15.240713696288594, 7.763703314791086],
            [-15.243138741505552, 7.759684858785613],
            [-15.239602037780559, 7.7564257167803365],
            [-15.24501240545948, 7.74976697281909],
            [-15.2491392785232, 7.74670918193567],
            [-15.252438504438375, 7.738109976670094],
            [-15.260136913061306, 7.733086383469813],
            [-15.26114026982961, 7.7359675258155685],
            [-15.268920539658188, 7.739075633635722],
            [-15.273917146228742, 7.7348503107897395],
            [-15.27906767140305, 7.724727159765818],
            [-15.283632511880352, 7.722526033618976],
            [-15.28387168757264, 7.719674700640789],
            [-15.288861621046356, 7.714215945936341],
            [-15.29274146312603, 7.717253193018227],
            [-15.29850469453413, 7.711552554848943],
            [-15.29989310842938, 7.704322787791253],
            [-15.298943703777331, 7.701506372611884],
            [-15.304387351433094, 7.695423953316546],
            [-15.306050190558446, 7.689542068500523],
            [-15.302502198757118, 7.674127276740484],
            [-15.302944684682712, 7.668704786650835],
            [-15.300075604843279, 7.664105781264612],
            [-15.304070488265907, 7.660677527214723],
            [-15.307621804586864, 7.66030644437875],
            [-15.304940671924781, 7.652299042857721],
            [-15.312225337588425, 7.648382285801218],
            [-15.317985713773362, 7.642658599972835],
            [-15.320504099577477, 7.6463691069583275],
            [-15.323225197900424, 7.64442461107858],
            [-15.330059191694914, 7.6431162277537075],
            [-15.334479699731494, 7.6450960741124385],
            [-15.342660464312784, 7.641801703363643],
            [-15.348998640558653, 7.647519917012863],
            [-15.352786088675304, 7.64046868854401],
            [-15.354083658305836, 7.623896822569283],
            [-15.359110207476434, 7.618694713609131],
            [-15.359337873236527, 7.614195133459084],
            [-15.365037220446565, 7.610426960992895],
            [-15.36577914438285, 7.605472144346936],
            [-15.37082784174001, 7.602010000019306],
            [-15.373365883960345, 7.5972521356288105],
            [-15.371203992054864, 7.593335467232966],
            [-15.368253528110614, 7.591481055208834],
            [-15.369905971879799, 7.58847261151516],
            [-15.367868861608333, 7.58499063346643],
            [-15.367013951241505, 7.579252941685799],
            [-15.360685264473275, 7.570422148984422],
            [-15.36141025159519, 7.564757035771578],
            [-15.364327806079043, 7.566100125120284],
            [-15.377009425351282, 7.565378996017994],
            [-15.379803010995944, 7.564256730549337],
            [-15.380051959569641, 7.558912296323233],
            [-15.38368940832019, 7.552905275769751],
            [-15.383508996051146, 7.550665865820681],
            [-15.38837194049451, 7.548715992890519],
            [-15.393583269485454, 7.549734185680495],
            [-15.40078035236803, 7.547066802387539],
            [-15.40610272413613, 7.538236686450706],
            [-15.411979048426037, 7.537628249311073],
            [-15.41426556957062, 7.528901356895761],
            [-15.414239249495932, 7.525347164481776],
            [-15.423108537307247, 7.521195250587807],
            [-15.428384297116772, 7.510815113070202],
            [-15.43043214906821, 7.509341670540625],
            [-15.437613873095838, 7.4973810878788445],
            [-15.440971261178184, 7.497467818260261],
            [-15.445643756379662, 7.48834514501318],
            [-15.445239559817947, 7.486713939065128],
            [-15.45048881467858, 7.465678730136125],
            [-15.415571490919794, 7.457298807221238],
            [-15.350934575962082, 7.442084132851455],
            [-15.350581994860539, 7.443473190973556],
            [-15.265770693624951, 7.4239081595443235],
            [-15.266083516154987, 7.4227407176772315],
            [-15.277394210734933, 7.380845928857478],
            [-15.273873464029968, 7.3800160411041515],
            [-15.280478322300054, 7.351597563112631],
            [-15.313195164077284, 7.212629310542016],
            [-15.39712967047736, 7.2317162073706385],
            [-15.39682477639069, 7.232987935563531],
            [-15.479319267114377, 7.252632554306415],
            [-15.563472291943246, 7.272686426723168],
            [-15.561915231011728, 7.279204593815946],
            [-15.641743158242763, 7.298921148776068],
            [-15.721575026948749, 7.318621395137835],
            [-15.742387481702155, 7.234406590179948],
            [-15.770551602566611, 7.240733448797072],
            [-15.777510483116988, 7.242667738678844],
            [-15.822632016519956, 7.253575795420565],
            [-15.941344532946156, 7.2828551999758835],
            [-16.06006553927635, 7.312098858385633],
            [-16.17879496987316, 7.341306753822718],
            [-16.297532758934313, 7.370478870225619],
            [-16.32748920273291, 7.377331900836929],
            [-16.262643187231692, 7.62927382815514],
            [-16.26136598964814, 7.628951055855663],
            [-16.240289243517786, 7.712641718417828],
            [-16.21970963977202, 7.791699963385458],
            [-16.21874332408445, 7.7914197383807045],
            [-16.202588056732484, 7.854785694060996],
            [-16.200915833245112, 7.860848578169552],
            [-16.183074284016747, 7.930992676387465],
            [-16.153541949151283, 8.044533445147984],
            [-16.126169927044312, 8.150701033617267],
            [-16.110700132050496, 8.208811501501456],
            [-16.12379649518522, 8.212151924331293],
            [-16.08186617848979, 8.377259421143723]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.00732004260469,
          "lat": 44.49153961143549
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41023"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01135851"
      },
      "bbox": [
        -16.32748920273291, 7.212629310542016, -15.10189590320991,
        8.377259421143723
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.58070211910334, 7.083984727283796],
            [-16.55954896859078, 7.168149653549964],
            [-16.475988681016556, 7.146658331516585],
            [-16.409603526611274, 7.398254892027261],
            [-16.32748920273291, 7.377331900836929],
            [-16.297532758934313, 7.370478870225619],
            [-16.17879496987316, 7.341306753822718],
            [-16.06006553927635, 7.312098858385633],
            [-15.941344532946156, 7.2828551999758835],
            [-15.822632016519956, 7.253575795420565],
            [-15.777510483116988, 7.242667738678844],
            [-15.770551602566611, 7.240733448797072],
            [-15.742387481702155, 7.234406590179948],
            [-15.721575026948749, 7.318621395137835],
            [-15.641743158242763, 7.298921148776068],
            [-15.561915231011728, 7.279204593815946],
            [-15.563472291943246, 7.272686426723168],
            [-15.479319267114377, 7.252632554306415],
            [-15.39682477639069, 7.232987935563531],
            [-15.39712967047736, 7.2317162073706385],
            [-15.313195164077284, 7.212629310542016],
            [-15.374157931431826, 6.9601049199827605],
            [-15.376687942102159, 6.960724775450095],
            [-15.416013411829763, 6.7989099567957645],
            [-15.45672311653752, 6.628549007341224],
            [-15.477064382257437, 6.543248164755678],
            [-15.47428845007327, 6.542596228053822],
            [-15.533419585429213, 6.297654325875486],
            [-15.546035375894233, 6.24518810587317],
            [-15.575996191281346, 6.1205347657977995],
            [-15.567505081591122, 6.118604115729218],
            [-15.59253569431714, 6.012666490055059],
            [-15.714873018262033, 5.496132241937555],
            [-15.701008213169018, 5.492767573492788],
            [-15.73488104145012, 5.355996133168544],
            [-15.76747697388009, 5.221181707966136],
            [-15.8766015099354, 5.2464298816673205],
            [-15.98573106261739, 5.271655180210401],
            [-16.058401095164054, 5.287554116258993],
            [-16.126740580199296, 5.301915929805751],
            [-16.183494998701992, 5.316625204198532],
            [-16.19771911089636, 5.319779559122828],
            [-16.344587955390303, 5.3571528343548165],
            [-16.493186262726507, 5.3932067687792005],
            [-16.50982965544695, 5.398406940670156],
            [-16.523635854812692, 5.401455359783325],
            [-16.575915318489272, 5.414844092459247],
            [-16.60159666902098, 5.421436605259312],
            [-16.56611256871326, 5.560205053511516],
            [-16.5690644935598, 5.560943153285254],
            [-16.548810066018394, 5.6414943522184515],
            [-16.483584329742108, 5.900892081744548],
            [-16.441685564862592, 6.070740732383036],
            [-16.42047870642978, 6.155319234862081],
            [-16.54098594402551, 6.185538972658823],
            [-16.66150076462416, 6.215727028147038],
            [-16.662147592251028, 6.213634795359465],
            [-16.746247019312836, 6.234929280873149],
            [-16.830350171223554, 6.25620830881495],
            [-16.828280665831286, 6.263216817728114],
            [-16.78735438240057, 6.421432166667855],
            [-16.778974742136278, 6.419213051661178],
            [-16.764328977715834, 6.4767963179157215],
            [-16.714064355141982, 6.672825052722851],
            [-16.689010334824882, 6.666483737611117],
            [-16.644946601574755, 6.835381303708113],
            [-16.59039189577916, 7.04215977299876],
            [-16.584314737145057, 7.065949153379634],
            [-16.58070211910334, 7.083984727283796]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.96796753477838,
          "lat": 43.064129694235184
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41025"],
        "coty_name": ["Harney"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harney County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01135852"
      },
      "bbox": [
        -16.830350171223554, 5.221181707966136, -15.313195164077284,
        7.398254892027261
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.47095825202447, 3.585328951792291],
            [15.511345944606212, 3.562886035441195],
            [15.568865256404708, 3.531645076792826],
            [15.60347305741325, 3.5136101819974175],
            [15.653335253189585, 3.486999546094537],
            [15.734023905737354, 3.443750381752878],
            [15.786450896968683, 3.416358024381119],
            [15.780390794640606, 3.39814151184783],
            [15.760139993349231, 3.339413138488173],
            [15.74604157407702, 3.2994074567690577],
            [15.74128018326813, 3.2852484769518076],
            [15.72261001373584, 3.231446307151059],
            [15.71728572199676, 3.216737919488195],
            [15.707679664080631, 3.188282839161726],
            [15.707171183433653, 3.1876552151575472],
            [15.686422778109335, 3.1652553075757286],
            [15.678233144570392, 3.1554777467053086],
            [15.630674333099368, 3.0967704379956227],
            [15.615150081103458, 3.0770245154993288],
            [15.610157807951586, 3.0713124945420653],
            [15.598800321461095, 3.0563094332924843],
            [15.597219085347461, 3.057005785474494],
            [15.525487283855545, 3.0965580554927032],
            [15.50496967292344, 3.1075187312593338],
            [15.449243741221458, 3.1377760761566447],
            [15.372597858643184, 3.179145834382119],
            [15.355518687657826, 3.1887203383966494],
            [15.349547925417191, 3.1925831141442194],
            [15.306038801731468, 3.224279852827077],
            [15.285365779558319, 3.225718057322277],
            [15.22696605568441, 3.2566946266728003],
            [15.104706605598912, 3.3212976243057715],
            [15.120700938615519, 3.3242860707690953],
            [15.129448203885797, 3.3293155454666903],
            [15.133624456310626, 3.3328184115771027],
            [15.143881464943734, 3.3395430169590945],
            [15.148392285966978, 3.340766873019205],
            [15.154242090810543, 3.3456788836122917],
            [15.16441225970555, 3.348994411617476],
            [15.171509766683817, 3.3528399253810863],
            [15.175874042229513, 3.356318334754732],
            [15.181544245160623, 3.357891400001214],
            [15.187727002678912, 3.3573868172311103],
            [15.193238467732575, 3.360343508176727],
            [15.202534981085595, 3.3610059271601482],
            [15.217137511942772, 3.365594699206693],
            [15.224179078592533, 3.3685658718217995],
            [15.231114311790888, 3.369109365570902],
            [15.236191867484699, 3.3705583330330557],
            [15.251140762688028, 3.378858548099588],
            [15.253052498934116, 3.381465794018782],
            [15.260756092130725, 3.3877031670537816],
            [15.277009060747233, 3.393772460869342],
            [15.284219119352732, 3.399710123788667],
            [15.29467568782769, 3.401293325335023],
            [15.299536896806668, 3.4075105593349475],
            [15.301992069018107, 3.4085041812139525],
            [15.304708025698213, 3.413997604867973],
            [15.3117980440496, 3.4198670631980916],
            [15.316363739496412, 3.4225369895811615],
            [15.317977914000808, 3.4253007528265362],
            [15.337429938123787, 3.438394259125808],
            [15.35598949598233, 3.4463254316351364],
            [15.363612525914627, 3.461945872511039],
            [15.369009855784213, 3.4630424957967656],
            [15.37297012772299, 3.458178126335179],
            [15.375162794584401, 3.4597582258523696],
            [15.37690740588237, 3.4649914202108167],
            [15.376302827483165, 3.467729897637607],
            [15.379515607644786, 3.469725850018767],
            [15.384782337858661, 3.466087140209701],
            [15.389070515233128, 3.4645989863385944],
            [15.39243524616754, 3.466961466698049],
            [15.39736270485788, 3.4630278150119573],
            [15.400250158354336, 3.4643634954868086],
            [15.403138660626846, 3.4683331202127654],
            [15.404072598427845, 3.532360578042967],
            [15.47095825202447, 3.585328951792291]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.92598544923483, "lat": 40.41631345813093 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42011"],
        "coty_name": ["Berks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Berks County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01209172"
      },
      "bbox": [
        15.104706605598912, 3.0563094332924843, 15.786450896968683,
        3.585328951792291
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.142432184885374, 3.3674797840551625],
            [14.155154343063547, 3.3781500320627327],
            [14.160706405978296, 3.38659776689094],
            [14.179819225513832, 3.3978601677642506],
            [14.20119324779703, 3.411259967444999],
            [14.215405429418293, 3.4223398758668635],
            [14.228094581878777, 3.4333008920689987],
            [14.25543467555585, 3.4554602342354745],
            [14.302805939728525, 3.495521869915023],
            [14.319375168158528, 3.5082103862840976],
            [14.345790008897186, 3.5259784328231722],
            [14.353213479794274, 3.52913476416379],
            [14.358895005255826, 3.5277440185715463],
            [14.366553854952356, 3.491136857003487],
            [14.376931493756791, 3.444011892332195],
            [14.389190518929587, 3.3871680701928093],
            [14.439551943113322, 3.3888907813877895],
            [14.415736287069722, 3.3733600625985805],
            [14.401556859490569, 3.3627589339150843],
            [14.39364850390945, 3.3575780372724475],
            [14.388623816438358, 3.3532358321082936],
            [14.374959738007698, 3.343252574094107],
            [14.35956103993652, 3.3305231826237893],
            [14.351477292233806, 3.3224842407229755],
            [14.336641841745267, 3.3104924253378893],
            [14.30648018282716, 3.2820870058689704],
            [14.301248208062844, 3.275165175562118],
            [14.306849417696, 3.2477899168250888],
            [14.297291361735248, 3.2370024724179696],
            [14.295833624663995, 3.233129307157637],
            [14.285367257247712, 3.2207119145642906],
            [14.268109995307055, 3.2024835476324096],
            [14.263534507822396, 3.198288193308112],
            [14.244987850929888, 3.1770860837453507],
            [14.234987759397752, 3.164349972426213],
            [14.239537494967097, 3.141357781495864],
            [14.231093805098919, 3.1315333197164956],
            [14.219087888652128, 3.114227987995732],
            [14.206684638771286, 3.0938057472119285],
            [14.189745963833808, 3.0670829549949783],
            [14.185882369360707, 3.0619625605640963],
            [14.175174049289653, 3.0453583178317527],
            [14.165302864883888, 3.0267020423080844],
            [14.157830739123474, 3.0100970261544444],
            [14.152603051733436, 2.999012023995482],
            [14.116546175258916, 2.9918801371959955],
            [14.114525185878714, 2.9852269862697103],
            [14.11197875362304, 2.9827363499262263],
            [14.103030414846286, 2.984447230051435],
            [14.095739434915101, 2.988307934585907],
            [14.091084460105115, 2.9873226234367323],
            [14.086796302073408, 2.9826978187435724],
            [14.081301710671493, 2.9824408237015496],
            [14.078634459641894, 2.9858388858731506],
            [14.074670091159224, 2.9875861027546398],
            [14.067752320363255, 2.9961417391521166],
            [14.067609197343465, 3.0067167736642983],
            [14.061868626588831, 3.0069326474542035],
            [14.054863194965158, 3.003333581444659],
            [14.052482045328766, 3.0102634551512932],
            [14.034098350820047, 3.006847835391724],
            [14.033406502618934, 3.0170453843303124],
            [14.035465123566778, 3.0228483543026137],
            [14.043136174855187, 3.027782443287428],
            [14.046218222594334, 3.038513777986155],
            [14.057554196269432, 3.0591406224312276],
            [14.071442897132295, 3.090756783719014],
            [14.075493741712753, 3.102604534050488],
            [14.07973650880338, 3.110940795764819],
            [14.085605634820444, 3.118858309388912],
            [14.086513360109606, 3.121481887222688],
            [14.058482235460293, 3.166827740703634],
            [14.062951326633645, 3.1805132046632725],
            [14.068207399003125, 3.1990772698646515],
            [14.06927542038917, 3.1997392414934898],
            [14.073354042905354, 3.2098611835260598],
            [14.07892249679082, 3.221594099743399],
            [14.090932155933588, 3.244525099641734],
            [14.095171985295208, 3.251786116009564],
            [14.109354368179789, 3.261069758669569],
            [14.119127437563673, 3.2757304310079807],
            [14.12352008666145, 3.2805151216581505],
            [14.128091766492371, 3.2875611771296307],
            [14.127213918320912, 3.2908713801948632],
            [14.133737498853504, 3.29627948646821],
            [14.146155484612306, 3.3120670671321997],
            [14.14843260320174, 3.314268974411364],
            [14.150506381979417, 3.3207946123843994],
            [14.1481372801553, 3.3225767758774523],
            [14.13548784588286, 3.3150173901988715],
            [14.130080279326059, 3.3247902404104503],
            [14.133560693941627, 3.3277160971019],
            [14.135345099947196, 3.3335876243861717],
            [14.132585503329079, 3.3401463345528786],
            [14.148486365805283, 3.3550095163478546],
            [14.142432184885374, 3.3674797840551625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.61703824315731, "lat": 40.61040092478703 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42087"],
        "coty_name": ["Mifflin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mifflin County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01213679"
      },
      "bbox": [
        14.033406502618934, 2.9824408237015496, 14.439551943113322,
        3.52913476416379
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.091083868682757, 3.6059376996593806],
            [15.13937978870603, 3.6431638217354134],
            [15.138964554781268, 3.7271788335113465],
            [15.15790456147546, 3.764277001738515],
            [15.181500845482693, 3.804157404154208],
            [15.260228575262577, 3.793501271338241],
            [15.323229456220805, 3.7853961009104835],
            [15.343185005574583, 3.8009082717733165],
            [15.34571743579844, 3.798744162035],
            [15.408374640968617, 3.7515099346222223],
            [15.425065604399189, 3.738438168067408],
            [15.445507805162284, 3.7229663910430357],
            [15.508840307099282, 3.6892499249892112],
            [15.531474961988927, 3.6768861373372443],
            [15.556811231993024, 3.663665589989626],
            [15.551790232132733, 3.6579605762223775],
            [15.543462799823192, 3.6547312290443696],
            [15.54296071779676, 3.6499767562955956],
            [15.532294826014876, 3.6394528120320326],
            [15.525721293784283, 3.628012899939619],
            [15.502028869767168, 3.6081946432091843],
            [15.494531949815736, 3.6067808285551757],
            [15.47095825202447, 3.585328951792291],
            [15.404072598427845, 3.532360578042967],
            [15.403138660626846, 3.4683331202127654],
            [15.400250158354336, 3.4643634954868086],
            [15.39736270485788, 3.4630278150119573],
            [15.39243524616754, 3.466961466698049],
            [15.389070515233128, 3.4645989863385944],
            [15.384782337858661, 3.466087140209701],
            [15.379515607644786, 3.469725850018767],
            [15.376302827483165, 3.467729897637607],
            [15.37690740588237, 3.4649914202108167],
            [15.375162794584401, 3.4597582258523696],
            [15.37297012772299, 3.458178126335179],
            [15.369009855784213, 3.4630424957967656],
            [15.363612525914627, 3.461945872511039],
            [15.35598949598233, 3.4463254316351364],
            [15.337429938123787, 3.438394259125808],
            [15.317977914000808, 3.4253007528265362],
            [15.316363739496412, 3.4225369895811615],
            [15.3117980440496, 3.4198670631980916],
            [15.304708025698213, 3.413997604867973],
            [15.301992069018107, 3.4085041812139525],
            [15.299536896806668, 3.4075105593349475],
            [15.29467568782769, 3.401293325335023],
            [15.284219119352732, 3.399710123788667],
            [15.277009060747233, 3.393772460869342],
            [15.260756092130725, 3.3877031670537816],
            [15.253052498934116, 3.381465794018782],
            [15.251140762688028, 3.378858548099588],
            [15.236191867484699, 3.3705583330330557],
            [15.231114311790888, 3.369109365570902],
            [15.224179078592533, 3.3685658718217995],
            [15.217137511942772, 3.365594699206693],
            [15.202534981085595, 3.3610059271601482],
            [15.193238467732575, 3.360343508176727],
            [15.187727002678912, 3.3573868172311103],
            [15.181544245160623, 3.357891400001214],
            [15.175874042229513, 3.356318334754732],
            [15.171509766683817, 3.3528399253810863],
            [15.16441225970555, 3.348994411617476],
            [15.154242090810543, 3.3456788836122917],
            [15.148392285966978, 3.340766873019205],
            [15.143881464943734, 3.3395430169590945],
            [15.133624456310626, 3.3328184115771027],
            [15.129448203885797, 3.3293155454666903],
            [15.120700938615519, 3.3242860707690953],
            [15.104706605598912, 3.3212976243057715],
            [15.0527917745751, 3.3485492390530425],
            [15.02227861087592, 3.3650634034789726],
            [14.986331044128901, 3.383863134776158],
            [14.932166892604322, 3.4129409467827605],
            [14.888841758881806, 3.436060978497465],
            [14.878746854555322, 3.441262606881084],
            [14.878517421423862, 3.446388030051783],
            [14.882841850953735, 3.4470209860216054],
            [14.891041077686063, 3.4531911279263987],
            [14.945581072261026, 3.495108465569524],
            [14.964245348920022, 3.507529529457929],
            [15.056709401906309, 3.579639277867179],
            [15.091083868682757, 3.6059376996593806]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.21598572115988, "lat": 40.70579070858404 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42107"],
        "coty_name": ["Schuylkill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schuylkill County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01213685"
      },
      "bbox": [
        14.878517421423862, 3.3212976243057715, 15.556811231993024,
        3.804157404154208
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.750238351696188, -5.237242774909365],
            [12.791478604886763, -5.18278238921565],
            [12.803155618124679, -5.174164467258836],
            [12.816831575001276, -5.157516097746775],
            [12.82939435803786, -5.1429090868926135],
            [12.838634277361884, -5.1328926870566],
            [12.852362630115643, -5.1158971943192295],
            [12.880570632613438, -5.0827078079957],
            [12.929672437262163, -5.021311418084573],
            [12.939961356716037, -5.008068591451623],
            [12.942955949054115, -5.014509503255705],
            [12.951726948579978, -5.019619862450925],
            [12.959443917406002, -5.027822870455573],
            [12.966656770470587, -5.0309992599342905],
            [12.971582550361179, -5.031796405415441],
            [12.976535918701991, -5.034913548771815],
            [12.97813190132147, -5.041288034890935],
            [12.980121514940416, -5.042526561034406],
            [12.986189091552877, -5.050443124828438],
            [12.986733836584525, -5.053982947066845],
            [12.990877378106008, -5.059204424847361],
            [12.995366673622193, -5.058420883953207],
            [12.99920542589858, -5.062459660684684],
            [13.002781215543996, -5.061425269298572],
            [13.007155590026363, -5.064076716045401],
            [13.008104530098107, -5.06727304455327],
            [13.00771076509127, -5.07440359177246],
            [13.009096574164031, -5.076460921984649],
            [13.00781407472564, -5.090218810598925],
            [13.002745109604502, -5.094257231257637],
            [12.99860147987867, -5.101053729701714],
            [13.000331684211885, -5.106404185727376],
            [13.003683569427759, -5.11012317150873],
            [13.00885332188858, -5.109858186889849],
            [13.01593353354449, -5.111915471142565],
            [13.029158724360283, -5.112344386478696],
            [13.031575128472355, -5.115237410403212],
            [13.036071403964526, -5.117077633466108],
            [13.039602977188627, -5.120770716263959],
            [13.04305220402286, -5.119801872799382],
            [13.052460058431263, -5.1220521208287595],
            [13.053494105163692, -5.123440386508487],
            [13.074289619022837, -5.080168713608642],
            [13.078134330644557, -5.085928196997979],
            [13.081852218012184, -5.093900493414107],
            [13.097238888342522, -5.108144181415992],
            [13.099827290937876, -5.114080351982725],
            [13.097344477346429, -5.119827116764781],
            [13.09921826032282, -5.122933143805415],
            [13.110013474452124, -5.127303608079496],
            [13.112331215100605, -5.136639900308473],
            [13.116622652488315, -5.141926912189895],
            [13.115288357682692, -5.150577933278317],
            [13.115273569243973, -5.156977992369322],
            [13.117468494997258, -5.163224650083008],
            [13.11836036854992, -5.171270740248943],
            [13.116015505417932, -5.178424183275543],
            [13.120305661590942, -5.18839549268634],
            [13.12004998600697, -5.196271821894229],
            [13.113343306791485, -5.206699692245775],
            [13.124944997070083, -5.21690794138204],
            [13.133812591489239, -5.231149771893441],
            [13.138799714205918, -5.235960183008554],
            [13.142390199382072, -5.241875761742924],
            [13.1455650686992, -5.251002043809454],
            [13.147619041571753, -5.259495458315631],
            [13.147958618275334, -5.268218042293482],
            [13.138747039038837, -5.271563350132685],
            [13.136460106171471, -5.277206596234615],
            [13.129480148051037, -5.3066169105181675],
            [13.128796097543033, -5.312911987517864],
            [13.129458949325068, -5.319482092675041],
            [13.13204711213926, -5.323798034950026],
            [13.1344736501934, -5.3238840721349305],
            [13.138059504601472, -5.320249553231208],
            [13.14240139323742, -5.318821839039759],
            [13.147603727538447, -5.3214803708068885],
            [13.144025180818263, -5.33085235116995],
            [13.139169905998362, -5.3411633288016125],
            [13.141716483977952, -5.346790388258683],
            [13.141321684578603, -5.349427949464066],
            [13.136567699944841, -5.351159457921226],
            [13.13505340910162, -5.35604342382821],
            [13.12816214101909, -5.356806464436174],
            [13.12690555646756, -5.363281154865794],
            [13.117492122399007, -5.369300615650201],
            [13.122678574160101, -5.373878225246475],
            [13.118539705800988, -5.379102746862324],
            [13.117823642161877, -5.383059307774508],
            [13.11796350212476, -5.392701901298971],
            [13.106681133585363, -5.392840034201869],
            [13.10471964447904, -5.386879281474937],
            [13.090100439733375, -5.388588756042857],
            [13.080272644613379, -5.392700105527672],
            [13.078380646897592, -5.394567519794248],
            [13.07684907949379, -5.400114710429367],
            [13.077709752115688, -5.414537955557447],
            [13.074984480338472, -5.424642002822401],
            [13.076752599513688, -5.441284066349773],
            [13.077647128745854, -5.445545231920408],
            [13.037932194296785, -5.446015612366885],
            [13.017325276148005, -5.448621930627905],
            [13.01984003539257, -5.454022988235926],
            [13.025068973961277, -5.455991466278493],
            [13.029944778082594, -5.462798481927326],
            [13.028634262353117, -5.4723568474195785],
            [13.030005389161362, -5.476340615329481],
            [13.034214667643573, -5.480192691425259],
            [13.03325920034037, -5.491212114896188],
            [13.02734155430859, -5.503601632290686],
            [13.022934112157662, -5.505160645300129],
            [13.019056550457302, -5.5113982593688595],
            [13.023148284605021, -5.52119384568132],
            [13.022653534518035, -5.5243377467497865],
            [13.026018912127546, -5.533076730031456],
            [13.026281661885983, -5.536657808606817],
            [13.031824078134944, -5.538173236074687],
            [13.031891817019531, -5.54087949095448],
            [13.035134586293188, -5.547153311285734],
            [13.037888753010218, -5.546279489154227],
            [13.042553910828804, -5.551944774154949],
            [13.039940390962531, -5.5568930159489955],
            [13.048933932255459, -5.561434540583072],
            [13.05261828751105, -5.55862389762614],
            [13.05850250630303, -5.560336722261072],
            [13.059529644969475, -5.5640515879173],
            [13.065766895671386, -5.563541096895526],
            [13.067971865950454, -5.565637555074611],
            [13.071029940000349, -5.562846448421371],
            [13.073819760758745, -5.565765682726386],
            [13.068691129591333, -5.568407416386765],
            [13.068715891868338, -5.57250003829301],
            [13.075515247308367, -5.568857612567027],
            [13.076636633848038, -5.573532823664753],
            [13.081500757392872, -5.571329774877504],
            [13.086104649336768, -5.579311031520437],
            [13.080870469367133, -5.5806775579647985],
            [13.081066706807455, -5.58301269462828],
            [13.086723828531834, -5.584781002089722],
            [13.087631330176261, -5.5894696450861],
            [13.08548801051091, -5.597485285556038],
            [13.088862765846402, -5.600489222573507],
            [13.087765089209233, -5.604580578793843],
            [13.081032843128567, -5.6003980908272055],
            [13.0810566287763, -5.596854177277004],
            [13.076226121045067, -5.596068426263455],
            [13.073849297153112, -5.59893040009537],
            [13.073952931979383, -5.605118912966266],
            [13.078946640421771, -5.609139389379254],
            [13.084223146970869, -5.609019602272846],
            [13.08168615227661, -5.61395510805391],
            [13.083161047358304, -5.620839204146832],
            [13.08899901376599, -5.6145063100534855],
            [13.094860540287124, -5.616321722409577],
            [13.098166471632718, -5.607207810350023],
            [13.10457129750952, -5.608480318211979],
            [13.109655115659603, -5.604572780826207],
            [13.11276593859659, -5.6112187888210725],
            [13.116095040201774, -5.611724987781641],
            [13.120406825509246, -5.606190339903633],
            [13.125087033635822, -5.605547978780483],
            [13.127510537601571, -5.608931993307701],
            [13.123590020425157, -5.613019995643647],
            [13.112384031329501, -5.618410469685796],
            [13.112974814950064, -5.622957495227053],
            [13.136153086626875, -5.627202102271548],
            [13.140865109163311, -5.630416185592512],
            [13.14089877733204, -5.635634306551395],
            [13.13187416577032, -5.651890871606747],
            [13.131180645524203, -5.657164612140125],
            [13.1351946672151, -5.6612294164146855],
            [13.138986723679597, -5.661923427516242],
            [13.142634999336032, -5.660509280913428],
            [13.148815251885276, -5.655778186476445],
            [13.158714619003117, -5.654581759085621],
            [13.155640424276264, -5.656032018285977],
            [13.154069476999448, -5.664543291559873],
            [13.147908617770018, -5.674467977990344],
            [13.14561666153024, -5.682007691849101],
            [13.140015676250838, -5.6880450186713265],
            [13.14000312094916, -5.690716456134704],
            [13.146179466744792, -5.695403043704834],
            [13.151824621813553, -5.692082579814612],
            [13.1574693464052, -5.696437978205046],
            [13.157134880924124, -5.698826592320656],
            [13.144674225518697, -5.698422752350614],
            [13.141932123094664, -5.700685574429015],
            [13.130503247573877, -5.700643709790127],
            [13.126813710855686, -5.699257421194842],
            [13.098360299552066, -5.675222239903963],
            [13.093193563733669, -5.673296532857506],
            [13.082631697521798, -5.67317155108486],
            [13.072200236832101, -5.6698478980811355],
            [13.068700569220722, -5.665777948467255],
            [13.062587040161754, -5.65581111463044],
            [13.055539811108291, -5.651338553944451],
            [13.051281273597974, -5.650055397638919],
            [13.045745647816458, -5.651252649409669],
            [13.040983026892425, -5.655312489854087],
            [13.038550099539423, -5.662888925365578],
            [13.03524816688612, -5.6670097639212935],
            [13.026063209444013, -5.672911415561746],
            [13.021178500719927, -5.671283114655752],
            [13.00745283418333, -5.6708986389256815],
            [12.993789733336556, -5.6641808904246975],
            [12.981763619559118, -5.663497097586048],
            [12.982208657116496, -5.659339518068732],
            [12.977566469559187, -5.653063564319244],
            [12.974314087601822, -5.652630705093971],
            [12.967471127023432, -5.654399720298],
            [12.964884694065407, -5.656263421634441],
            [12.956887032177184, -5.652450888894652],
            [12.954540998286642, -5.647655707372378],
            [12.955298330588775, -5.641766312670208],
            [12.950054407607986, -5.633989612970407],
            [12.949457374417534, -5.625875486538933],
            [12.951070079442502, -5.620460888477944],
            [12.954070172054724, -5.617857850043498],
            [12.951927415070493, -5.615447361607229],
            [12.94586495116002, -5.613883510774937],
            [12.943957447705268, -5.606791908623701],
            [12.938225706222651, -5.605060158548021],
            [12.937739140106698, -5.600377090714977],
            [12.94260454563295, -5.593718196647885],
            [12.94605685476098, -5.596987583588836],
            [12.951318381711934, -5.594597085659301],
            [12.949821189953623, -5.589466069620074],
            [12.946408691200478, -5.5918586923044185],
            [12.9426894934581, -5.590292057992815],
            [12.943685541071664, -5.583038435190258],
            [12.942824749807903, -5.579224004244407],
            [12.939568177181755, -5.576695362498472],
            [12.945508620768072, -5.574021021095341],
            [12.943639095856943, -5.571762651174837],
            [12.938654684563236, -5.573498797541235],
            [12.936835866012435, -5.567882087405796],
            [12.93142319854699, -5.561333748716122],
            [12.923613774748231, -5.557460233665294],
            [12.921319098495484, -5.552161815812028],
            [12.917020884691986, -5.550329462125983],
            [12.910705395246485, -5.551861713859217],
            [12.915011527528145, -5.545977376408107],
            [12.913172347516701, -5.54018506524551],
            [12.907060430784961, -5.537135642669017],
            [12.902372745003005, -5.530162680194332],
            [12.904832782932916, -5.525829960581935],
            [12.909367568972606, -5.5233392925444145],
            [12.907482085897897, -5.5180296100517285],
            [12.909900421302064, -5.5139278712992095],
            [12.908581717186804, -5.508847215216554],
            [12.91290938280557, -5.5085886703434275],
            [12.915234333818871, -5.505653965046536],
            [12.910203258574429, -5.500743458483866],
            [12.915363197345007, -5.499194268492435],
            [12.919476107279102, -5.495181391915777],
            [12.924877593215735, -5.493138716317788],
            [12.921052969273179, -5.489878813896974],
            [12.921800387310844, -5.486854017542252],
            [12.92626327230846, -5.483572665864941],
            [12.925551261764186, -5.479898718750392],
            [12.922162650959041, -5.476476068888041],
            [12.921207045890792, -5.464923908735887],
            [12.911738783890518, -5.462747500936524],
            [12.91370261729506, -5.457416107018276],
            [12.911257766299052, -5.452191271167659],
            [12.911166781913966, -5.446224900861501],
            [12.90654304823104, -5.447365182845018],
            [12.904614513636709, -5.443956678344643],
            [12.908917864052242, -5.4359730536469355],
            [12.909644862795785, -5.430106903556877],
            [12.905898329298843, -5.431042706740271],
            [12.90085945688048, -5.427911487656018],
            [12.898246442201831, -5.423008214067657],
            [12.893458070490663, -5.423959031717254],
            [12.893085140633858, -5.428885972671341],
            [12.887970047362955, -5.43086028402297],
            [12.887303589688914, -5.425501649225842],
            [12.8815508071376, -5.425528921033886],
            [12.8811996711326, -5.42002655870838],
            [12.875675473896662, -5.418041905754286],
            [12.873121597855652, -5.4119563500945755],
            [12.873528513275021, -5.408665487622564],
            [12.865839634607733, -5.402262124969294],
            [12.860236496106014, -5.399556301410832],
            [12.862217432616037, -5.394057402004295],
            [12.862364973707729, -5.388649766788488],
            [12.860602854359149, -5.385012272592128],
            [12.854088159050278, -5.379528410668488],
            [12.84921917447858, -5.373193872000936],
            [12.844364262913276, -5.369471184140406],
            [12.833701996753947, -5.358853097269877],
            [12.83379162956159, -5.356947183158258],
            [12.829180132664257, -5.345990696665003],
            [12.835760584485465, -5.340310947728507],
            [12.833868511802411, -5.335913573376183],
            [12.828924850440307, -5.334791018228357],
            [12.830963237349236, -5.329506725815878],
            [12.8353940174903, -5.333347285979284],
            [12.835234048941881, -5.327942285326826],
            [12.840296435373784, -5.325823067283677],
            [12.837845228044607, -5.321656946710035],
            [12.841851893310555, -5.319460390397403],
            [12.841175397108247, -5.315426087710925],
            [12.836087891742293, -5.316449822766627],
            [12.831325458174103, -5.314256282716997],
            [12.819758576864327, -5.304906052638509],
            [12.81510317221698, -5.301771607759135],
            [12.806909927077932, -5.293845819011534],
            [12.798764308455455, -5.288425325073841],
            [12.797547268442692, -5.284298515631728],
            [12.79435797247965, -5.282392751604162],
            [12.7929447755187, -5.277470376211336],
            [12.797232586619268, -5.275282409731139],
            [12.795870522062419, -5.269137713946234],
            [12.79050492934549, -5.27159406363479],
            [12.787482880118887, -5.268145665029286],
            [12.782517155480681, -5.271326674673779],
            [12.779690765095092, -5.271287547161283],
            [12.767403790339966, -5.264096777767947],
            [12.761621258949827, -5.261844307027828],
            [12.759654796580243, -5.258752744841041],
            [12.754470643121772, -5.256702690593129],
            [12.757199545960841, -5.254285710673393],
            [12.757293587703794, -5.247923046250097],
            [12.753661637236481, -5.2469704902879695],
            [12.751505612346058, -5.243900032369592],
            [12.75297580192725, -5.240973254632241],
            [12.750238351696188, -5.237242774909365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.03166713632478, "lat": 32.43748071140265 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45053"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01248006"
      },
      "bbox": [
        12.750238351696188, -5.700685574429015, 13.158714619003117,
        -5.008068591451623
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.77976320904963, -3.2996819909658894],
            [12.784032258204336, -3.2963183879216],
            [12.798273362631411, -3.2811568918770635],
            [12.87625745656812, -3.20041521519711],
            [12.880899092650449, -3.2000919349468675],
            [12.88174518931153, -3.2158761333415304],
            [12.878827190748982, -3.2278615302591813],
            [12.884114136009623, -3.2323230813868853],
            [12.885236078242963, -3.23955114180098],
            [12.882293710475277, -3.249137809009157],
            [12.886440933734264, -3.2548121686519993],
            [12.892405300455632, -3.2575456519472494],
            [12.903491256645705, -3.2521984404577697],
            [12.90871588392265, -3.2488502450319006],
            [12.909673591652753, -3.235340895936782],
            [12.90942943404428, -3.230531970245969],
            [12.911021924007523, -3.2255140847289203],
            [12.917308782935239, -3.219607552705166],
            [12.924001870260597, -3.2177591872735882],
            [12.930411768618074, -3.2251979784432154],
            [12.931860177911643, -3.2310413922400962],
            [12.935762229340357, -3.2339412241663217],
            [12.93809738304315, -3.23811708827777],
            [12.951142947418802, -3.246041840338407],
            [12.954686157391452, -3.2502116087508215],
            [12.958561888463255, -3.2488604859912082],
            [12.964484738637525, -3.243382671369907],
            [12.962363629571103, -3.2384526393421513],
            [12.96293234444448, -3.235679173201179],
            [12.973754358683559, -3.234034796740601],
            [12.975576885848705, -3.241863552636403],
            [12.979294818136548, -3.2409285619122414],
            [12.979781409160333, -3.2333171379802876],
            [12.975863742563742, -3.2339349698003304],
            [12.974686693436459, -3.226468034620331],
            [12.978465065093923, -3.2293891869876887],
            [12.987367287428716, -3.2231419762151985],
            [12.988653015379256, -3.2342839841751965],
            [12.991817667704845, -3.2337821991697138],
            [12.995819449973517, -3.2265963657782697],
            [13.00073045304746, -3.225808180440314],
            [13.001423030636515, -3.218610130677914],
            [13.010190655398674, -3.2226306013875314],
            [13.013629056365533, -3.225994370402502],
            [13.017511030977708, -3.233896363872275],
            [13.020283197316127, -3.2325865717435187],
            [13.019323277678836, -3.2286578407249604],
            [13.026564948024271, -3.227367683132192],
            [13.032065503076026, -3.2222749256428593],
            [13.040674110293812, -3.221238995844559],
            [13.04256561867086, -3.213902745014821],
            [13.04155280748952, -3.209957148137196],
            [13.045070952904513, -3.2079507989849683],
            [13.05121721846553, -3.2085326666518443],
            [13.05593059568168, -3.2077853852497733],
            [13.057196640493183, -3.1983261899088475],
            [13.054893167126306, -3.1969974773227365],
            [13.053341351095254, -3.1907563920744355],
            [13.046530043603578, -3.185563170297335],
            [13.044465409890352, -3.1791254336393],
            [13.040005798686812, -3.1798786852890104],
            [13.037801080530194, -3.176641189089758],
            [13.035018357488642, -3.1649920876030997],
            [13.03213753697386, -3.162801591969164],
            [13.031681379338574, -3.159324432869796],
            [13.028371584183061, -3.1552159594687503],
            [13.034128606544662, -3.150861854414365],
            [13.062723031809275, -3.130963854399834],
            [13.134038048882026, -3.0819233217216504],
            [13.13651532818653, -3.0833108142579855],
            [13.135615576638672, -3.0871617303057293],
            [13.144034142423365, -3.0905678094577707],
            [13.146676179861997, -3.095803428255167],
            [13.151449297824904, -3.094673856767658],
            [13.157891700682608, -3.101010851295075],
            [13.160696714121746, -3.1102712657674676],
            [13.160551045528582, -3.1138505726573102],
            [13.162536640073583, -3.1190525117763634],
            [13.166973187981764, -3.1200137256984317],
            [13.16830610688801, -3.1258940461815596],
            [13.171266679883516, -3.12823934555633],
            [13.170355079728793, -3.1342597557584084],
            [13.174279879665663, -3.144648185637288],
            [13.177767630317785, -3.1463039088056464],
            [13.184140509847738, -3.1524433755649586],
            [13.191020533243682, -3.1578360487273445],
            [13.192304318840897, -3.1646015076737966],
            [13.194797612550438, -3.1681194318042647],
            [13.20369217673622, -3.17444220190693],
            [13.206229957344899, -3.172619930982419],
            [13.209703157653426, -3.175712525906876],
            [13.214340671328372, -3.1760187740715904],
            [13.212586098015894, -3.1795530117989994],
            [13.21845359360865, -3.1873270128118043],
            [13.219589056589705, -3.1944033715962363],
            [13.219009433995693, -3.1999524368855004],
            [13.221230356545343, -3.204116843129482],
            [13.220537072665001, -3.212233453776763],
            [13.22267241595228, -3.2117195297130183],
            [13.223747131136449, -3.225933474167425],
            [13.227552538406576, -3.230565921516647],
            [13.226790833238702, -3.2346726199192064],
            [13.230465047669608, -3.235192541649313],
            [13.228720106283989, -3.2424009997068466],
            [13.229519875961865, -3.2470745629663047],
            [13.235062739433777, -3.2561661885866577],
            [13.23985461056987, -3.2568499861181137],
            [13.243702555740013, -3.2591494674934047],
            [13.246062330558864, -3.2672556659283933],
            [13.252716049981965, -3.270269498005204],
            [13.254428179191533, -3.27294533426382],
            [13.254856295710216, -3.2797341614686863],
            [13.257957508911462, -3.2803953791705354],
            [13.261130729442998, -3.2851539941381462],
            [13.265940381630818, -3.2833818695132924],
            [13.269633185697884, -3.285008248188814],
            [13.271424355893078, -3.292407555896253],
            [13.269575662698449, -3.2961016363990447],
            [13.273550546440399, -3.3006334187280593],
            [13.270725207068352, -3.308618872093149],
            [13.271720484118312, -3.3126868876943587],
            [13.271985946203273, -3.314752410075794],
            [13.245037586756684, -3.3395406868232995],
            [13.246681374579383, -3.3443097427285347],
            [13.241161541773955, -3.346225289870682],
            [13.231606652343563, -3.3465670847513587],
            [13.215403495699903, -3.3492389471916364],
            [13.215657299362087, -3.360818425097148],
            [13.219736187776268, -3.366921040979228],
            [13.227683788202013, -3.375182748559944],
            [13.23005570019495, -3.3837495418052974],
            [13.221899248521854, -3.3840920790166478],
            [13.21295153424456, -3.386150745617763],
            [13.206323727669995, -3.3857866388505102],
            [13.198729981433122, -3.3913225555320454],
            [13.192673102083324, -3.398235149569144],
            [13.177202734555202, -3.4029551479783824],
            [13.176054743028446, -3.401893420644192],
            [13.164963813608669, -3.413716137013833],
            [13.171371527869345, -3.420684346154471],
            [13.175980478155898, -3.4397438416913335],
            [13.1812803508375, -3.4454889412028304],
            [13.174355565153201, -3.4485149863167655],
            [13.176324657550087, -3.458223500566316],
            [13.179720357291707, -3.4699181944476702],
            [13.171533887239374, -3.4926294740392843],
            [13.163623818245268, -3.4919784390287267],
            [13.163344502974935, -3.4960842006318678],
            [13.166859764275689, -3.5005925149092447],
            [13.162549894097742, -3.51728390827458],
            [13.16027842380478, -3.5224483031475926],
            [13.149562697205756, -3.534324060043206],
            [13.130769775211867, -3.556307488505653],
            [13.082154742353787, -3.6123475294067338],
            [13.079531068307267, -3.615871061534586],
            [13.059550165977036, -3.6173776066671177],
            [13.046873342259664, -3.611802583051567],
            [13.046151910712627, -3.6188339902979076],
            [13.050329849377016, -3.6209860197408474],
            [13.034903923581528, -3.6254740309987876],
            [13.026495219681028, -3.630587653593805],
            [13.017907404131773, -3.6372983432590797],
            [13.017955548118408, -3.6402473036168437],
            [13.009988692300666, -3.643544559068585],
            [13.003901533440313, -3.6438155396875977],
            [12.998513387791618, -3.647753491796],
            [12.982445404960512, -3.6509881040697367],
            [12.977854103925724, -3.655721301807251],
            [12.977536106327335, -3.658144458606524],
            [12.972768549364742, -3.6610444871419556],
            [12.971622441200427, -3.6649789108860937],
            [12.907897068162928, -3.6202749279617947],
            [12.8476369525205, -3.5778920494199973],
            [12.832532229300782, -3.572537256993513],
            [12.83243447198134, -3.569438770662214],
            [12.842181976390124, -3.5261714890847164],
            [12.845709612089486, -3.5121330198622176],
            [12.85310083079948, -3.4805423102432806],
            [12.881003330246925, -3.365625594492943],
            [12.87028774028749, -3.3584412247631845],
            [12.868055795227551, -3.35576866329065],
            [12.866500585768186, -3.3500656572928555],
            [12.867249418233516, -3.3419158203121224],
            [12.865547679869792, -3.3381770900696583],
            [12.856154215658915, -3.3327462475952045],
            [12.842053656072158, -3.3336792326080236],
            [12.830388165462427, -3.3383533670531826],
            [12.823802042702106, -3.33639484937546],
            [12.81880385230703, -3.3329556582616564],
            [12.808608751960861, -3.323249334171638],
            [12.801929788071012, -3.319037280618806],
            [12.791530228669197, -3.3112392730061155],
            [12.788373153972877, -3.306631750839418],
            [12.77976320904963, -3.2996819909658894]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.59025787755384, "lat": 34.33878641231247 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45055"],
        "coty_name": ["Kershaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kershaw County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01248007"
      },
      "bbox": [
        12.77976320904963, -3.6649789108860937, 13.273550546440399,
        -3.0819233217216504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.615905478163027, -3.4500782746282046],
            [11.650475506406758, -3.412963642022992],
            [11.671443456185772, -3.390141529060517],
            [11.664702120471883, -3.336743533306127],
            [11.682015047663286, -3.244519876377984],
            [11.693767062039454, -3.1914792158376577],
            [11.708003056273961, -3.1306092525357108],
            [11.717195227592976, -3.1364225050793686],
            [11.718031847977368, -3.141492854147786],
            [11.722159211984442, -3.141581298915412],
            [11.72978255892417, -3.1539573006094948],
            [11.7321531307092, -3.1550227079711983],
            [11.737782297212501, -3.163183667025849],
            [11.740293397092874, -3.162712949258941],
            [11.742910958825908, -3.1581935458106627],
            [11.74696890236174, -3.161454910677897],
            [11.749939806206841, -3.1663515603177],
            [11.753108385867261, -3.164334596379225],
            [11.76092544705554, -3.163598417848587],
            [11.762881485698008, -3.1688618507822266],
            [11.768318627780756, -3.177461367638246],
            [11.7712848335487, -3.179888145373036],
            [11.77153279183163, -3.188196350840037],
            [11.778561914415588, -3.1867881664129203],
            [11.781926823299827, -3.1909367157794586],
            [11.782075130413853, -3.198448482976757],
            [11.779752771143333, -3.2028918427526025],
            [11.783939843069323, -3.205105692288615],
            [11.791250735383043, -3.2044650985127583],
            [11.792551376144324, -3.209817300156737],
            [11.80022456422923, -3.2110234344171587],
            [11.80151535187527, -3.213755535400903],
            [11.80595656615406, -3.214831745338204],
            [11.807689930756439, -3.219230415449408],
            [11.812975091739618, -3.221942130328582],
            [11.817198602610812, -3.2202218921550148],
            [11.818294955357567, -3.223055776667685],
            [11.827176326739455, -3.227369915907722],
            [11.82875768247837, -3.2306407463277678],
            [11.83600155254844, -3.23216975503417],
            [11.839744553606815, -3.236226541607372],
            [11.850970053286305, -3.2351902189876682],
            [11.853384702180477, -3.237185119234291],
            [11.867125447683813, -3.236070672632186],
            [11.868648143982973, -3.2378159182555386],
            [11.868900690340453, -3.2440586424319116],
            [11.879959032284189, -3.2439295312865877],
            [11.884246309569948, -3.2426582939227075],
            [11.887615468065956, -3.2461987616716588],
            [11.891572586120114, -3.2477505464367087],
            [11.894952157325049, -3.2570840593954564],
            [11.897542390130422, -3.2545044828003755],
            [11.904809068513503, -3.2629293889592605],
            [11.90743606713527, -3.2643406121805816],
            [11.909384433146725, -3.2708029707225816],
            [11.915719197657845, -3.2761680975405767],
            [11.919871391723492, -3.2767074839404846],
            [11.9236944004742, -3.2793108104171966],
            [11.924706720785835, -3.2839593834231238],
            [11.933817241397888, -3.286725303089865],
            [11.93699764910655, -3.283337973160309],
            [11.938670620587748, -3.287624248692691],
            [11.94214567633805, -3.2889322649354975],
            [11.941892262479653, -3.2921290987227967],
            [11.948397539937266, -3.2887760787348155],
            [11.952262862890613, -3.289826910647598],
            [11.957819619057519, -3.289355562229939],
            [11.959963169032529, -3.294568533782348],
            [11.965026978138908, -3.3005750945245786],
            [11.967931052148607, -3.2885015727656484],
            [11.973120318928425, -3.2851376252558113],
            [11.977322724710957, -3.283362274212067],
            [11.979526098182005, -3.2782139147173304],
            [11.982896954577658, -3.280756161727426],
            [11.983465099972337, -3.2851554894615664],
            [11.989922246041669, -3.2859646718890794],
            [11.992857405642972, -3.284278704098811],
            [11.99512038010885, -3.288677235192639],
            [12.00131255436308, -3.287601578891464],
            [12.006233032554738, -3.2950503814407477],
            [12.015221482053992, -3.293038788781023],
            [12.017782553835616, -3.2987579402642324],
            [12.028788869210468, -3.2977942896026615],
            [12.034976690159121, -3.3010914820295874],
            [12.038463301624645, -3.2996536595097177],
            [12.044288991780464, -3.3013475917563904],
            [12.04930070008606, -3.300594627306327],
            [12.051736107220405, -3.30263391449774],
            [12.059665442016405, -3.299035199061108],
            [12.063898045850479, -3.300251370800666],
            [12.065822390016654, -3.303888137485395],
            [12.070483416094522, -3.306561129989957],
            [12.07369598497881, -3.3044861498281715],
            [12.079375937974481, -3.3079972830496254],
            [12.083036511940096, -3.307934885908097],
            [12.089208786187355, -3.311772050688291],
            [12.09235614171219, -3.30774252821081],
            [12.10023253059985, -3.3020485098750183],
            [12.109554791004546, -3.3074148812724053],
            [12.11542333621159, -3.3018939578821347],
            [12.119610690007141, -3.300529380779343],
            [12.11875650412157, -3.30527350472059],
            [12.127031312268342, -3.3062676082492723],
            [12.12896440313816, -3.308929679574462],
            [12.13428543117177, -3.307735446162179],
            [12.137866157765083, -3.3154725300488583],
            [12.13989930308283, -3.3145937776810803],
            [12.146875681105199, -3.3220286538320845],
            [12.150572399815161, -3.3205884599123228],
            [12.147707056662917, -3.3344910046382985],
            [12.14802163192632, -3.3372060419483778],
            [12.14223084733567, -3.342549143744544],
            [12.14025547276253, -3.348899674867858],
            [12.137736721035811, -3.3513635573063616],
            [12.11490442334907, -3.4050264372943415],
            [12.114288533817945, -3.4077647889468095],
            [12.10995668667755, -3.409346213433349],
            [12.105995204832986, -3.4131622955984247],
            [12.09946917847414, -3.4138239553017287],
            [12.0983047738936, -3.4183841735920413],
            [12.091589751117024, -3.4271499732854203],
            [12.092243908523677, -3.429550616577323],
            [12.089877850975837, -3.4362141798313797],
            [12.083799920039366, -3.4467904950598434],
            [12.085628431386338, -3.452035227944395],
            [12.079960402187623, -3.459240665536027],
            [12.080242662633408, -3.463743603473069],
            [12.07854517545801, -3.4689834446060996],
            [12.075123310599091, -3.470015965177417],
            [12.073110320217914, -3.4770827214156785],
            [12.067192011721021, -3.485563402403078],
            [12.064875760168752, -3.4910594351198805],
            [12.063707152586229, -3.4970236237993992],
            [12.06478425973223, -3.5024341460585053],
            [12.06353175948846, -3.505300479029563],
            [12.052799040704858, -3.5149110446741365],
            [12.046343054929178, -3.522637287711976],
            [12.041563954059175, -3.52643739289881],
            [12.0331976410417, -3.528399772476177],
            [12.026434546932528, -3.5314118576046534],
            [12.022946234977539, -3.534064878371761],
            [12.01774784599718, -3.5426461375580365],
            [12.013919639425572, -3.545407461212071],
            [12.013879069395832, -3.5493604479115204],
            [12.016426489162491, -3.554651196512672],
            [12.013489867042233, -3.5561548183535554],
            [12.00721854190944, -3.5641495502127682],
            [12.002010235110385, -3.5640688956786235],
            [11.999575906363502, -3.5684760799001376],
            [11.99010640634302, -3.5703496182343746],
            [11.987055321535218, -3.578045162015724],
            [11.981882763628104, -3.583240578833173],
            [11.98221954862934, -3.587917792424055],
            [11.979317905571971, -3.6111124079849515],
            [11.98104618391775, -3.6212109890470305],
            [11.97730278614837, -3.6295938255001152],
            [11.976957219216256, -3.639049235138098],
            [11.969174781536484, -3.6559200537079284],
            [11.96844259610708, -3.6673917436230252],
            [11.9625992829894, -3.6726673674792134],
            [11.957732776461807, -3.6803005602556644],
            [11.956059302999568, -3.6860859044662706],
            [11.95087910658551, -3.6831587353969186],
            [11.948696637689338, -3.67920736220763],
            [11.941055675489375, -3.6726623597817043],
            [11.932088520078825, -3.6703176689573715],
            [11.93013545859381, -3.6662331634022216],
            [11.92395458989801, -3.6611528426712985],
            [11.92380435828774, -3.65532640034122],
            [11.918322581203805, -3.655553497030471],
            [11.91345631883868, -3.6531561444029204],
            [11.908549454958269, -3.652507334807721],
            [11.899931117585803, -3.655394941036815],
            [11.891196250978458, -3.6509668260449395],
            [11.882513795957932, -3.640760882115218],
            [11.87742016693394, -3.637534898761368],
            [11.867914761200076, -3.636736335684173],
            [11.86056783009307, -3.633578620260887],
            [11.859078742849448, -3.6282203032697695],
            [11.848731749197077, -3.6221142089402463],
            [11.845931471427551, -3.6189661971513374],
            [11.839815085217829, -3.6165231998688125],
            [11.836515128941144, -3.6120148395893428],
            [11.832452194542393, -3.6103019457467624],
            [11.829374583495198, -3.6071200063737714],
            [11.824125824522097, -3.6055141393839176],
            [11.820254299925164, -3.606377459336309],
            [11.814386245631828, -3.60348027836198],
            [11.806155641529351, -3.6015622019908937],
            [11.79923701302036, -3.606895219667469],
            [11.79671864819283, -3.606552139137941],
            [11.793262526855578, -3.6006976749346573],
            [11.792567130057153, -3.5950043312413564],
            [11.787203978210973, -3.5918024435699585],
            [11.78494242927269, -3.588682286149159],
            [11.77681942797026, -3.5878690899173997],
            [11.7667552672268, -3.5833344622561265],
            [11.758086098131994, -3.5866641760704137],
            [11.755333149270644, -3.5859505587192846],
            [11.753285517142032, -3.5766747193521944],
            [11.749271294665906, -3.566413335945652],
            [11.744278412216598, -3.5597211422852544],
            [11.741449529030197, -3.5587813381782873],
            [11.737645167681098, -3.5537126436847823],
            [11.731181019884612, -3.5491837257009116],
            [11.727295929915012, -3.5507117839347546],
            [11.726506968698873, -3.545181007911565],
            [11.723020961461433, -3.5437264880347135],
            [11.716454523709473, -3.5458506728066985],
            [11.705470878099318, -3.537703557895],
            [11.704945890806039, -3.532779778957642],
            [11.698640496025533, -3.532817886440058],
            [11.695783144801863, -3.5306799801405413],
            [11.697013032842374, -3.5215840898022757],
            [11.683719842242615, -3.5225002515722417],
            [11.681404714345724, -3.516484493587724],
            [11.675461408332476, -3.5127795619358917],
            [11.673349360931045, -3.5070054970425315],
            [11.669351694045615, -3.5082809536630024],
            [11.666651526378944, -3.505484810072638],
            [11.667720245661176, -3.5020281780906326],
            [11.662007007674143, -3.495351525497682],
            [11.656236603832417, -3.4956353043388204],
            [11.652000038149547, -3.4932457563843426],
            [11.650326553074416, -3.4887322844327158],
            [11.645971281636257, -3.482349618334613],
            [11.641356686726064, -3.4776565497951792],
            [11.636297423150165, -3.4767093572471426],
            [11.62640238898077, -3.4719927533485118],
            [11.617488718946571, -3.464805667952162],
            [11.618200253061639, -3.457883316207682],
            [11.615905478163027, -3.4500782746282046]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.00568027352203, "lat": 34.48339662135269 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45059"],
        "coty_name": ["Laurens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Laurens County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01248009"
      },
      "bbox": [
        11.615905478163027, -3.6860859044662706, 12.150572399815161,
        -3.1306092525357108
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9433056741965489, 5.307453325588936],
            [-1.93962156636539, 5.306704778883831],
            [-1.8677162577486301, 5.303589390486488],
            [-1.865016279062316, 5.303719485018329],
            [-1.8078388545547255, 5.301914864010986],
            [-1.765834905884667, 5.301127672846805],
            [-1.7297003531940154, 5.300671113324087],
            [-1.7229015404920824, 5.300292561738078],
            [-1.6645742944255741, 5.298728973977974],
            [-1.6357746584537614, 5.298100492250092],
            [-1.5713159531997691, 5.296128632107008],
            [-1.550277709041146, 5.295611353342107],
            [-1.5505089849387375, 5.281359608439354],
            [-1.551970427949012, 5.223486727254768],
            [-1.5521438259904028, 5.208921413181497],
            [-1.5450882175014877, 5.208802236195155],
            [-1.5470114927493694, 5.098237942550219],
            [-1.5483941397187824, 5.033220227268051],
            [-1.5510216319831274, 4.946073530650744],
            [-1.5536975790507757, 4.8593585941139725],
            [-1.6393689736862709, 4.862066850706374],
            [-1.7243459251935989, 4.864955900151301],
            [-1.8106361569356435, 4.867854125439896],
            [-1.9168719287578, 4.87163074267482],
            [-1.9124421904148061, 4.876214388694957],
            [-1.9053321606323994, 4.889721208199101],
            [-1.9040966009658504, 4.897174357739029],
            [-1.9052944911744254, 4.902571820459704],
            [-1.9137951188436573, 4.913855669889421],
            [-1.923565962435915, 4.9233936981277004],
            [-1.9250876191498274, 4.926264650222138],
            [-1.9333959837097634, 4.933573889759935],
            [-1.9389005513206796, 4.9433926785731614],
            [-1.9423440600214932, 4.947683926475359],
            [-1.9441137312349097, 4.953774221096052],
            [-1.9447504483966362, 4.966052109887728],
            [-1.9444166821204052, 4.9748940764538645],
            [-1.9456542795841885, 4.988910304258665],
            [-1.948745064856892, 5.0018255259211255],
            [-1.9534925422512963, 5.015599558620775],
            [-1.9611759719800679, 5.026414469977282],
            [-1.9671898497829157, 5.03062154558256],
            [-1.9786261701915224, 5.032592012509185],
            [-1.9878076000732763, 5.0316306611378305],
            [-2.0005971686365998, 5.028035715941506],
            [-2.0062551987365356, 5.027119651391008],
            [-2.0157431637696654, 5.027440462556461],
            [-2.025025942937533, 5.030360175603517],
            [-2.028765498641999, 5.033223923708905],
            [-2.034072232159319, 5.0489731966457585],
            [-2.033740035241651, 5.051823238485966],
            [-2.024316428742798, 5.062754115079391],
            [-2.020115964328421, 5.065479001927125],
            [-2.0079099759466925, 5.069424946226063],
            [-1.9991751770038797, 5.071250163212768],
            [-1.9919241278058941, 5.075054412685761],
            [-1.988183709431224, 5.0798264643736815],
            [-1.9898760567364218, 5.08647319396128],
            [-1.9875253757645805, 5.094091314406222],
            [-1.987889188536683, 5.103026289282893],
            [-1.9937578236821165, 5.113351944835147],
            [-1.9954186935052713, 5.119669679367562],
            [-1.993294457063272, 5.126664298519523],
            [-1.992396601020719, 5.134747498453403],
            [-1.989898627376562, 5.144979824725288],
            [-1.9879799088133234, 5.149219315814463],
            [-1.9831040958999957, 5.153881577133084],
            [-1.9663134971751124, 5.159969030439475],
            [-1.955793715171274, 5.165901097449877],
            [-1.9432640308015023, 5.182559319692729],
            [-1.935315466186148, 5.192347172295266],
            [-1.9318505460890478, 5.197521715336519],
            [-1.9137820983991864, 5.227247001655731],
            [-1.9115705184802676, 5.232329237729838],
            [-1.912456255114541, 5.238974317705245],
            [-1.9175856428048055, 5.247164114487334],
            [-1.9260518860381637, 5.255218386397879],
            [-1.9421861648579648, 5.265347021007718],
            [-1.9487090134933749, 5.276366209248537],
            [-1.9492468815694168, 5.288064595910117],
            [-1.9477498695615971, 5.294162917645949],
            [-1.9448969792355286, 5.299935355940185],
            [-1.9433056741965489, 5.307453325588936]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.08093973457869, "lat": 43.71806193926162 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46015"],
        "coty_name": ["Brule"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brule County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01265768"
      },
      "bbox": [
        -2.034072232159319, 4.8593585941139725, -1.5450882175014877,
        5.307453325588936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.3698371422775337, 6.907263593761311],
            [-3.312492027581508, 6.9042914654224985],
            [-3.3035324647034146, 6.903479990486641],
            [-3.250726905462213, 6.900837037744716],
            [-3.1684342444852294, 6.896186983212411],
            [-3.1106983557333834, 6.89307740554307],
            [-3.0246357561132053, 6.888705677459659],
            [-2.93842136253121, 6.8842192552416455],
            [-2.851900030515733, 6.879855621242165],
            [-2.778408860923284, 6.87640765569231],
            [-2.763932152716998, 6.875567037259723],
            [-2.7044625210256394, 6.872985089943086],
            [-2.6965109251050583, 6.872490560797008],
            [-2.579733710152209, 6.867222669202534],
            [-2.5737107702210107, 6.838625517074049],
            [-2.5668500043034603, 6.827086945431214],
            [-2.562116608172528, 6.822442477943194],
            [-2.5559019985431424, 6.814485662025086],
            [-2.5509185556584293, 6.806025749022412],
            [-2.5448950614187926, 6.789734245544344],
            [-2.5397618912819206, 6.78178665358643],
            [-2.5363724063250355, 6.77474440824725],
            [-2.5367241725531806, 6.767943798680111],
            [-2.5398032750501147, 6.761383240504281],
            [-2.5417485126149737, 6.751995333019533],
            [-2.543282805452649, 6.748678863604475],
            [-2.562518035903727, 6.726423874445844],
            [-2.566014080697297, 6.721205612026754],
            [-2.5690757359470062, 6.712623740735071],
            [-2.563742050519628, 6.686525505928623],
            [-2.560662868133012, 6.6816487077817275],
            [-2.5483380897301515, 6.666540006139387],
            [-2.5410589157084345, 6.6593367362865905],
            [-2.5375007284439164, 6.654708747122431],
            [-2.5334891624415676, 6.644501948893394],
            [-2.5326389538748577, 6.640264339039248],
            [-2.530945067337628, 6.631963334723199],
            [-2.5344350487712974, 6.617947438392627],
            [-2.5452039626588707, 6.592534708739759],
            [-2.544924300329768, 6.5868684063573655],
            [-2.5462750261277036, 6.5782462811758],
            [-2.547720627395187, 6.562651853905294],
            [-2.5497965641208307, 6.553538659373495],
            [-2.558969591834035, 6.533526543049623],
            [-2.568553710533549, 6.52062543443389],
            [-2.585199964499607, 6.495841355206619],
            [-2.5865047911013717, 6.482992136080823],
            [-2.5852239298768267, 6.470776973898865],
            [-2.580719352039565, 6.455760606197701],
            [-2.5779045719194724, 6.4507737647987575],
            [-2.5709103669625772, 6.44216188319631],
            [-2.5572675300308347, 6.4289269400882105],
            [-2.555018948890527, 6.423152255087905],
            [-2.5570740628596114, 6.413983493917503],
            [-2.563737389451868, 6.410347915314078],
            [-2.5822180282794926, 6.412345249344501],
            [-2.603284690615913, 6.4223687397749405],
            [-2.6150013044404186, 6.427255140289489],
            [-2.6251590990785165, 6.4287136324315],
            [-2.6303017947527967, 6.42790754817117],
            [-2.6353391764326637, 6.4251009714221565],
            [-2.647675872417486, 6.411533774221729],
            [-2.655047555246973, 6.400911801263081],
            [-2.6596514261577844, 6.390362057939532],
            [-2.6603385010587193, 6.373560366306306],
            [-2.6577721260298266, 6.349581492248669],
            [-2.6569657547905856, 6.324019428198792],
            [-2.6547876956032757, 6.311351680108631],
            [-2.650413029194933, 6.297956177676025],
            [-2.6443229451017363, 6.27971725613492],
            [-2.643163512814285, 6.274986475519043],
            [-2.643780776123804, 6.268738556122558],
            [-2.646701782013474, 6.262946309299249],
            [-2.6508722378375005, 6.257260420343313],
            [-2.6627827879845185, 6.2443761863249785],
            [-2.6769962028345446, 6.235790998287098],
            [-2.6919791206197776, 6.2279071493875495],
            [-2.7039656637268052, 6.219442065624463],
            [-2.713107250156271, 6.211142046515785],
            [-2.7201200624747965, 6.2034724576565115],
            [-2.7240510179704027, 6.197423820769014],
            [-2.731873749663435, 6.1900472855142885],
            [-2.737866381425221, 6.180485632315473],
            [-2.7449097454023232, 6.1713856924188315],
            [-2.7549613973357374, 6.166663428206253],
            [-2.7598729278208327, 6.166126334221602],
            [-2.7677770211616792, 6.168665386060853],
            [-2.784484315789029, 6.171676238346082],
            [-2.8009585903903518, 6.177185113776951],
            [-2.808072515551131, 6.183833299443423],
            [-2.817479636424828, 6.193893042954608],
            [-2.8230096638461357, 6.200606294442229],
            [-2.8328730581716592, 6.217609884576205],
            [-2.8360466591590066, 6.222350308968178],
            [-2.8459791890532524, 6.232953994933435],
            [-2.8526399554534714, 6.236725168450517],
            [-2.8609629213746155, 6.239371295591516],
            [-2.8639980768738513, 6.239032075595508],
            [-2.872139661868123, 6.233955489887234],
            [-2.880583356280305, 6.2191697612790104],
            [-2.884195644283443, 6.206848015131426],
            [-2.8851679481721626, 6.199727208410627],
            [-2.8842736252228156, 6.191694031723212],
            [-2.882044952626104, 6.18701229532608],
            [-2.877751301265819, 6.18243198611704],
            [-2.882270855045232, 6.178555430867449],
            [-2.8868033131274227, 6.176372191017921],
            [-2.891362182889872, 6.175931875544418],
            [-2.893532739172686, 6.180962327937779],
            [-2.8908739573003484, 6.184518477509574],
            [-2.89277667846069, 6.188052499710995],
            [-2.8970806620287055, 6.18832202378975],
            [-2.902718164677146, 6.185452861763114],
            [-2.9006602498220424, 6.17807307747008],
            [-2.904621657937757, 6.173408117210959],
            [-2.9152224941877685, 6.171576887017804],
            [-2.9195898482948532, 6.174838083971509],
            [-2.9157337192006407, 6.180852861426514],
            [-2.9163658995442145, 6.184179606315698],
            [-2.920205531447916, 6.185737871499537],
            [-2.9236817909400497, 6.181987358205853],
            [-2.9317973838676723, 6.178617213071769],
            [-2.9360815708496752, 6.185053792518812],
            [-2.9420539866410382, 6.182256437922902],
            [-2.9446820668238503, 6.182869506371091],
            [-2.947713321567687, 6.194338951770772],
            [-2.9517325300518777, 6.197066925157542],
            [-2.95747096021486, 6.1987960088135265],
            [-2.961310938027104, 6.197907270582269],
            [-2.966454302458658, 6.19289609320231],
            [-2.9697667483578853, 6.19333740466365],
            [-2.973507763912359, 6.196992080749218],
            [-2.977711949645906, 6.193900710214054],
            [-2.982799959047416, 6.192967929942967],
            [-2.9879608471584422, 6.18999466544327],
            [-2.9984052134042734, 6.187299882968267],
            [-3.001944152479604, 6.189604493175621],
            [-3.0033471079845877, 6.195688458162802],
            [-3.0117400763739672, 6.201800992995151],
            [-3.0145508489002792, 6.2015804517783755],
            [-3.014882933656691, 6.194338843009211],
            [-3.0190352861456455, 6.188255052977423],
            [-3.029221890721994, 6.1858737975866935],
            [-3.035434107497611, 6.182013616201687],
            [-3.046134599974402, 6.185559185815695],
            [-3.048534719104589, 6.181420694365163],
            [-3.0466608278790885, 6.174478867434021],
            [-3.0552295081555103, 6.171954431508883],
            [-3.061637937086586, 6.171914938911608],
            [-3.0645387640717225, 6.166896023576588],
            [-3.0659246651543715, 6.15990771020099],
            [-3.0709153163620604, 6.153376704272019],
            [-3.076169754972526, 6.160838846324041],
            [-3.0794440583540315, 6.160311898282361],
            [-3.0843125203903714, 6.1508763770735255],
            [-3.0960390123960186, 6.1469040077934745],
            [-3.1053052379475714, 6.150663210306163],
            [-3.1185077304933744, 6.164045305093869],
            [-3.123602047197635, 6.166667463244952],
            [-3.128435106185928, 6.166798148043251],
            [-3.138206352447277, 6.163381021390791],
            [-3.1502454572532903, 6.165409554939924],
            [-3.159057089639008, 6.167863957692108],
            [-3.1681943785275872, 6.172050873904216],
            [-3.175676035793648, 6.174057995842557],
            [-3.161837018263717, 6.419535219554493],
            [-3.219888164545575, 6.422168493400738],
            [-3.262286020969166, 6.424589147760312],
            [-3.3205819090059654, 6.428327388397972],
            [-3.3337343813265603, 6.428916215057819],
            [-3.419111411674607, 6.43343305361038],
            [-3.4165167824320797, 6.477818764337163],
            [-3.4063783419605023, 6.477273692536887],
            [-3.401966293216656, 6.549361785443658],
            [-3.397166215737588, 6.63705255762826],
            [-3.3954002580783493, 6.670989502245674],
            [-3.393895727371161, 6.680893765640742],
            [-3.3940443893873833, 6.685655018940202],
            [-3.386158489388695, 6.821834916359032],
            [-3.375446433872978, 6.821212166199991],
            [-3.3698371422775337, 6.907263593761311]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.87183632538911,
          "lat": 45.15664675119357
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46041"],
        "coty_name": ["Dewey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dewey County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01266994"
      },
      "bbox": [
        -3.419111411674607, 6.1469040077934745, -2.530945067337628,
        6.907263593761311
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.087589442450587, 4.877692244377395],
            [-2.0013319189705143, 4.874450595452891],
            [-1.9169621488652955, 4.871446556151405],
            [-1.9204758783861025, 4.863729211394068],
            [-1.9222269218373809, 4.857406163050462],
            [-1.925343957484484, 4.85243062335384],
            [-1.9270169286187928, 4.846044613464074],
            [-1.925833273304965, 4.836879595159544],
            [-1.922904470918404, 4.832302113339828],
            [-1.9113356259864234, 4.821965396699392],
            [-1.9064537375987525, 4.8161169395857275],
            [-1.888746556507016, 4.807788814012133],
            [-1.8854950595845739, 4.807107805482284],
            [-1.8642327543516561, 4.805849013172005],
            [-1.856247915055403, 4.806480287443883],
            [-1.8411136664735062, 4.80509166628095],
            [-1.8322413323003521, 4.80670986537675],
            [-1.8266468748642355, 4.804791498922933],
            [-1.8184883032268808, 4.799006705476666],
            [-1.8116437760743613, 4.790158455042794],
            [-1.8057442654734457, 4.775159119379831],
            [-1.8062185419208887, 4.7687324269740285],
            [-1.8034191840172873, 4.760529600644687],
            [-1.801061131931688, 4.757404134806028],
            [-1.7970595440297097, 4.748143794941204],
            [-1.784673324707913, 4.740104516418091],
            [-1.7799489654747152, 4.73360484135802],
            [-1.7734982017156111, 4.720405715636925],
            [-1.76939623295167, 4.705862720324632],
            [-1.7577291431549125, 4.686807127505991],
            [-1.7492011783235872, 4.67788927842306],
            [-1.735511417085347, 4.664613312548057],
            [-1.7284384924285925, 4.660003517698035],
            [-1.7232105251545102, 4.655564091639598],
            [-1.7092919982499708, 4.640175625120971],
            [-1.7029184742837207, 4.630659854795332],
            [-1.6959812586906051, 4.622965116940394],
            [-1.687094605652677, 4.617554723149019],
            [-1.6739257376129189, 4.612157093459732],
            [-1.6687783413221744, 4.6114055659633975],
            [-1.6444352205863602, 4.610401618047766],
            [-1.6351762011645252, 4.609026045625384],
            [-1.6287948316310397, 4.605119664349599],
            [-1.6243722228532427, 4.597438910952949],
            [-1.6219941926475592, 4.588309340278462],
            [-1.6214906603657757, 4.570119757903365],
            [-1.6234391764662015, 4.54548056923541],
            [-1.6233104152531337, 4.541573705112061],
            [-1.6194009824631497, 4.527378426546617],
            [-1.6174548585414752, 4.523378531289393],
            [-1.611322980593329, 4.517589539575651],
            [-1.6066750005866566, 4.515649479004036],
            [-1.5959385908832933, 4.513659469406528],
            [-1.5751953159694738, 4.512004032071528],
            [-1.5609946057334294, 4.5097680267658165],
            [-1.5487690486503753, 4.505213122695509],
            [-1.5431290890121057, 4.500411969501458],
            [-1.532528578996395, 4.488313754695637],
            [-1.519387198118435, 4.463518390234729],
            [-1.5163239793427299, 4.458433863794203],
            [-1.507725565706594, 4.446870856855571],
            [-1.5027955733033875, 4.441928122165277],
            [-1.490569818129495, 4.433991438238995],
            [-1.485326211369719, 4.432039491263528],
            [-1.471160174988574, 4.428791020217457],
            [-1.4577725507865398, 4.427792379747633],
            [-1.4384215195172856, 4.430145173308824],
            [-1.4093149142598478, 4.419916893497468],
            [-1.3944727555754592, 4.413704439223656],
            [-1.3843007069576152, 4.405802376296637],
            [-1.371311446658597, 4.393412181091178],
            [-1.3642530227388057, 4.383255429440799],
            [-1.3586674617511294, 4.372963351373757],
            [-1.353438218044515, 4.35943907422793],
            [-1.3532640882319567, 4.352028186162179],
            [-1.4747260382794767, 4.355295199739195],
            [-1.573383038176305, 4.357829249333578],
            [-1.6450963365469424, 4.359855182529204],
            [-1.6591159336116568, 4.360402633640811],
            [-1.734040436237222, 4.362734507013244],
            [-1.816661783942083, 4.3654685724385995],
            [-1.8351394622813155, 4.366243690035676],
            [-1.8597288325180323, 4.366704730842184],
            [-1.9027999520999714, 4.368195349764271],
            [-1.970271935267108, 4.370610243006759],
            [-2.060460515964137, 4.373586550440904],
            [-2.106026649696285, 4.375335521659958],
            [-2.102949980008307, 4.458334830786676],
            [-2.0995924296149893, 4.546501462768509],
            [-2.0963170041223322, 4.633355156960833],
            [-2.0918033606326096, 4.752772058640615],
            [-2.0889923981052263, 4.828849137353306],
            [-2.087589442450587, 4.877692244377395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.18566782795293,
          "lat": 43.192412261640385
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46053"],
        "coty_name": ["Gregory"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gregory County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01265765"
      },
      "bbox": [
        -2.106026649696285, 4.352028186162179, -1.3532640882319567,
        4.877692244377395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.13424037015335, 6.2759455004877465],
            [-2.062477881180554, 6.272985558703042],
            [-1.9761249679182942, 6.269833616560479],
            [-1.8780452928136764, 6.266307080470394],
            [-1.8796774617610361, 6.223397421111322],
            [-1.8806594958001805, 6.191937412132558],
            [-1.8841803114469236, 6.091919713301213],
            [-1.8878111215586189, 6.004475421244016],
            [-1.8907718713859862, 5.918072003783115],
            [-1.882257890599527, 5.917672511523006],
            [-1.8855841309329509, 5.826548719756797],
            [-1.8867751258500352, 5.783156339061805],
            [-1.8894141588823006, 5.711021398459438],
            [-1.890327710516587, 5.681602598571856],
            [-1.8924506046088507, 5.62115567664827],
            [-1.8927167507649116, 5.619651559695859],
            [-1.8943078239126685, 5.566102333427169],
            [-1.980249817403902, 5.568271150473205],
            [-2.0661921044619507, 5.570422216257769],
            [-2.0917962960160668, 5.570809273199395],
            [-2.103760773047289, 5.5828732101645855],
            [-2.1172258747263006, 5.589701221089462],
            [-2.130741511015189, 5.595500643775361],
            [-2.1415229122743384, 5.5978451022712425],
            [-2.152914034217982, 5.598202417529082],
            [-2.1511227859709483, 5.6604812326707785],
            [-2.150693143791747, 5.663457406552313],
            [-2.1470842695747563, 5.75343372639678],
            [-2.146745070596812, 5.755246998781398],
            [-2.141723602406868, 5.892060144793701],
            [-2.1402544333977596, 5.927785805930516],
            [-2.1492956445851856, 5.928155182909662],
            [-2.145381703077669, 6.014552014537594],
            [-2.1438864026114377, 6.05219904288245],
            [-2.138412901749375, 6.173257369576918],
            [-2.136842978931318, 6.214627008009778],
            [-2.13424037015335, 6.2759455004877465]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.48706728311485, "lat": 44.54732870897576 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46069"],
        "coty_name": ["Hyde"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hyde County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01266984"
      },
      "bbox": [
        -2.152914034217982, 5.566102333427169, -1.8780452928136764,
        6.2759455004877465
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.650413029194933, 6.297956177676025],
            [-2.6109903006832114, 6.29674834534186],
            [-2.581729300249387, 6.295254501474637],
            [-2.502185930090532, 6.2915843986285305],
            [-2.422643360642308, 6.2878979206673735],
            [-2.3219033358815895, 6.283547896990014],
            [-2.2357442956566995, 6.279959139357919],
            [-2.1915595715213474, 6.2781785232585845],
            [-2.162993494244606, 6.2771945649751615],
            [-2.13424037015335, 6.2759455004877465],
            [-2.136842978931318, 6.214627008009778],
            [-2.138412901749375, 6.173257369576918],
            [-2.1438864026114377, 6.05219904288245],
            [-2.145381703077669, 6.014552014537594],
            [-2.1492956445851856, 5.928155182909662],
            [-2.2475357726160667, 5.932106764331774],
            [-2.312710536736087, 5.934925972112197],
            [-2.401117278929512, 5.938158773525013],
            [-2.4070923572225724, 5.938709623616264],
            [-2.4415312127144873, 5.940160067557484],
            [-2.514268820193995, 5.9434314243838955],
            [-2.606555722728187, 5.9473367723846255],
            [-2.698843475236126, 5.951220842411714],
            [-2.753131431183279, 5.953401277298949],
            [-2.7550691279447457, 5.956215111021542],
            [-2.760352818838732, 5.958915385713355],
            [-2.7672970416031446, 5.960287747941543],
            [-2.7762847956377343, 5.960956870946275],
            [-2.79157253596418, 5.963913458483192],
            [-2.7999357030219953, 5.964773367899992],
            [-2.811798129137513, 5.970210945981617],
            [-2.8192271075945015, 5.975807185605779],
            [-2.826990888096152, 5.98504148788469],
            [-2.831998787212067, 5.993418883663418],
            [-2.835198852425484, 6.007778344046351],
            [-2.8351183541743863, 6.011670569013073],
            [-2.83289595310622, 6.027217246155182],
            [-2.8317886098048195, 6.031373559789395],
            [-2.8252905073452452, 6.040826121165981],
            [-2.8178653376551854, 6.060420286072916],
            [-2.814818544234949, 6.073347077926103],
            [-2.8080465760256605, 6.096438559709066],
            [-2.8067332972305516, 6.110949616096025],
            [-2.807362672582571, 6.115364154077802],
            [-2.8108096991316365, 6.124911262426732],
            [-2.8174408955551087, 6.145853415800466],
            [-2.8225073341902696, 6.150073808290017],
            [-2.8308943929985655, 6.152842343548456],
            [-2.8411479815470093, 6.153601557644809],
            [-2.8524905699140892, 6.157704057557102],
            [-2.8555680480755496, 6.165308220109632],
            [-2.8597216331934034, 6.170303301561341],
            [-2.8657997401696482, 6.17502323528213],
            [-2.877751301265819, 6.18243198611704],
            [-2.882044952626104, 6.18701229532608],
            [-2.8842736252228156, 6.191694031723212],
            [-2.8851679481721626, 6.199727208410627],
            [-2.884195644283443, 6.206848015131426],
            [-2.880583356280305, 6.2191697612790104],
            [-2.872139661868123, 6.233955489887234],
            [-2.8639980768738513, 6.239032075595508],
            [-2.8609629213746155, 6.239371295591516],
            [-2.8526399554534714, 6.236725168450517],
            [-2.8459791890532524, 6.232953994933435],
            [-2.8360466591590066, 6.222350308968178],
            [-2.8328730581716592, 6.217609884576205],
            [-2.8230096638461357, 6.200606294442229],
            [-2.817479636424828, 6.193893042954608],
            [-2.808072515551131, 6.183833299443423],
            [-2.8009585903903518, 6.177185113776951],
            [-2.784484315789029, 6.171676238346082],
            [-2.7677770211616792, 6.168665386060853],
            [-2.7598729278208327, 6.166126334221602],
            [-2.7549613973357374, 6.166663428206253],
            [-2.7449097454023232, 6.1713856924188315],
            [-2.737866381425221, 6.180485632315473],
            [-2.731873749663435, 6.1900472855142885],
            [-2.7240510179704027, 6.197423820769014],
            [-2.7201200624747965, 6.2034724576565115],
            [-2.713107250156271, 6.211142046515785],
            [-2.7039656637268052, 6.219442065624463],
            [-2.6919791206197776, 6.2279071493875495],
            [-2.6769962028345446, 6.235790998287098],
            [-2.6627827879845185, 6.2443761863249785],
            [-2.6508722378375005, 6.257260420343313],
            [-2.646701782013474, 6.262946309299249],
            [-2.643780776123804, 6.268738556122558],
            [-2.643163512814285, 6.274986475519043],
            [-2.6443229451017363, 6.27971725613492],
            [-2.650413029194933, 6.297956177676025]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.13221130327402,
          "lat": 44.71557825066759
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46119"],
        "coty_name": ["Sully"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sully County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01266982"
      },
      "bbox": [
        -2.8851679481721626, 5.928155182909662, -2.13424037015335,
        6.297956177676025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.956209908453982, -2.5291980507839593],
            [9.95848299551326, -2.528421636711093],
            [9.97899192009003, -2.512688222267341],
            [9.983398352784029, -2.5085809086237925],
            [9.98733143416835, -2.499612213252517],
            [9.987012541889149, -2.493792001843238],
            [9.994632777436404, -2.4869544212536048],
            [9.990841734121208, -2.4762850518215953],
            [9.993995718973807, -2.473833212747687],
            [9.992287816592043, -2.4698044264364185],
            [9.9860098145679, -2.4659602493316495],
            [9.981428726992608, -2.4665300586698917],
            [9.975850582806814, -2.4624166229622926],
            [9.96912783275351, -2.453670744447647],
            [9.967572776968538, -2.449677231552824],
            [9.96774164663576, -2.4414648719379093],
            [9.955807070243816, -2.425410134377552],
            [9.955686798394057, -2.412546678882482],
            [9.95394601442372, -2.4060317891955836],
            [9.956072206616088, -2.3960807120609275],
            [9.959662856127519, -2.3897057835047435],
            [9.965627352333778, -2.3823465377807613],
            [9.96683866664802, -2.3785114151753413],
            [9.956529380741413, -2.3720260552228525],
            [9.943496446295802, -2.3703597865380304],
            [9.944397680362957, -2.365647246745836],
            [9.947809618211425, -2.35832036808617],
            [9.948031970643957, -2.351917294337567],
            [9.946547534633135, -2.340003475286386],
            [9.944115010824028, -2.3383137932254425],
            [9.944379634847861, -2.3336988240704453],
            [9.94945940074481, -2.332365651159917],
            [9.953179215586081, -2.3352080691638233],
            [9.955969884980723, -2.3416216058564108],
            [9.961947914138856, -2.342285882672277],
            [9.969419504453912, -2.338151068295922],
            [9.971454320481124, -2.3346990724185464],
            [9.972178744945653, -2.3285922609710763],
            [9.966649154383948, -2.3165692428613327],
            [9.96666775091272, -2.3114593084282364],
            [9.97115776737408, -2.30301850064616],
            [9.971339872139307, -2.300091186841189],
            [9.967971713795972, -2.2960866277227616],
            [9.959715797791581, -2.290584567566183],
            [9.960308630388823, -2.285806011418539],
            [9.969156590360864, -2.2829724076799565],
            [9.972683923506308, -2.283755653206722],
            [9.974623725780818, -2.2868111807680043],
            [9.979034446212973, -2.288733364650442],
            [9.979806151073166, -2.29232157711128],
            [9.977254166071635, -2.297525100340235],
            [9.979355852065941, -2.3017878577858926],
            [9.98505881833375, -2.3001613265810823],
            [9.992365205139343, -2.289533649603341],
            [9.994888223157025, -2.2870994857306113],
            [10.005494446152252, -2.280477163480105],
            [10.013310604945783, -2.277923574996239],
            [10.021204216609444, -2.2837617312859915],
            [10.021968396347843, -2.2903195220903783],
            [10.024568652482758, -2.2959698638764103],
            [10.032770545024936, -2.2993380052058683],
            [10.035371307393834, -2.298733269206206],
            [10.03848529880225, -2.291853548748245],
            [10.03798573233343, -2.287443522206674],
            [10.035390275764138, -2.2813649687482527],
            [10.03637559676766, -2.2744591042907025],
            [10.044269734026594, -2.270929747299561],
            [10.051052995993539, -2.271952372622738],
            [10.054321229367698, -2.274967322012786],
            [10.057296774465998, -2.281655992173438],
            [10.061293561766867, -2.2834959717693253],
            [10.064527969035208, -2.2829308695827395],
            [10.069602813277067, -2.2775299228482444],
            [10.071036977780452, -2.272168260875274],
            [10.069781321128168, -2.2645544721851394],
            [10.066233745224709, -2.257747455272316],
            [10.059487412136795, -2.25360305547938],
            [10.05208892444794, -2.2525890480881885],
            [10.050235153294471, -2.248467038956306],
            [10.054697261106835, -2.2456731841552764],
            [10.059403454599627, -2.2470451879152824],
            [10.066316087085212, -2.2465353086824256],
            [10.070353970860197, -2.2426160883175417],
            [10.072442324214387, -2.2375217722883263],
            [10.076887649609448, -2.236929328365562],
            [10.07845402643331, -2.240370729126564],
            [10.082972088728686, -2.2417041980287595],
            [10.086816184032712, -2.24541734594833],
            [10.088583575407666, -2.2501098010009652],
            [10.094201193131678, -2.25485374508028],
            [10.09910053186276, -2.2505774411640957],
            [10.101870346822173, -2.2499212051974475],
            [10.104071736118659, -2.243280534056395],
            [10.107088566752445, -2.243135480575647],
            [10.115379784761329, -2.2390390378869376],
            [10.119439145938994, -2.2449821756485293],
            [10.122622688218364, -2.247016185851306],
            [10.125952187797985, -2.2450260900987797],
            [10.15001380951545, -2.2569274439170632],
            [10.150424125656045, -2.264755761596398],
            [10.153996799380074, -2.262561619015288],
            [10.159832958530426, -2.261767323004756],
            [10.166298280708627, -2.2649260165601297],
            [10.1942192821677, -2.2647244549644565],
            [10.201286077914379, -2.257926024395597],
            [10.210485858402297, -2.2411385206931835],
            [10.214169390530937, -2.2359651072961904],
            [10.222710108775079, -2.2265450424706628],
            [10.22258469595938, -2.2232017514876565],
            [10.23542548229159, -2.212663231823237],
            [10.240236919286588, -2.2150988098089486],
            [10.244482532133592, -2.219547299952964],
            [10.245636607326473, -2.2300352066212996],
            [10.250866321399453, -2.2389716030441247],
            [10.250654246420563, -2.2423707244636235],
            [10.253224088318984, -2.246184203088645],
            [10.256126769157943, -2.2444963893184724],
            [10.2606732795599, -2.249687139117738],
            [10.258349046575912, -2.251790423298627],
            [10.27389590178109, -2.278458092617073],
            [10.274811750150343, -2.2772790435043415],
            [10.280928160687129, -2.286498404687485],
            [10.289446042789082, -2.287336895044865],
            [10.284786247383403, -2.2927002951114805],
            [10.284322486658578, -2.2965590467336368],
            [10.300692523701718, -2.32547704142339],
            [10.303848799191528, -2.3306109747438706],
            [10.303879303117286, -2.3388589209133444],
            [10.308510066014165, -2.339428382196452],
            [10.308753953984095, -2.3427957035734046],
            [10.313549938346629, -2.3442900422914015],
            [10.31793642459943, -2.3627242761679965],
            [10.321017645314464, -2.364577168320055],
            [10.324720367762827, -2.3636680766882936],
            [10.325666328631234, -2.3702311630425252],
            [10.331267532383237, -2.3709143393315277],
            [10.331269074392862, -2.3749881715861116],
            [10.329152951947446, -2.3790139309920257],
            [10.331932598639645, -2.381055105830225],
            [10.337567964205876, -2.3820618778433325],
            [10.343489782296452, -2.378703743076861],
            [10.3472833262012, -2.3785413274426452],
            [10.350003626429663, -2.3814538718473766],
            [10.348720239662795, -2.387541483157452],
            [10.353227632609233, -2.399943161132658],
            [10.357274370674393, -2.4018733815192053],
            [10.362354259368807, -2.4001264306703147],
            [10.365750828914946, -2.395561648215754],
            [10.374306472277127, -2.4610682656101686],
            [10.374995673024918, -2.469290505143458],
            [10.38144924104867, -2.5170132214502967],
            [10.37342196081592, -2.518231481165328],
            [10.37071231936398, -2.5172477393893233],
            [10.364596225591603, -2.519509069492691],
            [10.346214585375279, -2.522220026833839],
            [10.33408106200131, -2.530564389580811],
            [10.326329550878853, -2.5302738680898886],
            [10.323853844390362, -2.5282508799022048],
            [10.313039681717376, -2.534031805552639],
            [10.307105750568573, -2.5323015303104435],
            [10.301225655221275, -2.535162131852273],
            [10.295449591745244, -2.5353193777034857],
            [10.294967670749209, -2.5401109629711947],
            [10.290256362665932, -2.5479136011065773],
            [10.285331971170669, -2.5517886001714345],
            [10.273554885433354, -2.5590115727784988],
            [10.268604221794021, -2.567046352508933],
            [10.257322817736023, -2.5791505586526773],
            [10.25215786649592, -2.578862708702984],
            [10.239580033875452, -2.5860755501443276],
            [10.230638446758968, -2.584589291137195],
            [10.220032554616342, -2.5866667869009468],
            [10.21259336596155, -2.5916469658082257],
            [10.211801856974127, -2.5962479142076567],
            [10.206789461643652, -2.6067105893124167],
            [10.204068752283202, -2.6082993647786634],
            [10.200177964009123, -2.6141976337851576],
            [10.200769034054213, -2.61973810721292],
            [10.197750864792193, -2.62212157696527],
            [10.196022993146672, -2.631838733278604],
            [10.194486829447698, -2.6357802308650466],
            [10.190770300421741, -2.638709692187078],
            [10.18425492847796, -2.639264973454234],
            [10.174853801108107, -2.642875005048706],
            [10.170892347044402, -2.6499097791224755],
            [10.166265835468444, -2.65448178107704],
            [10.163536003072787, -2.6553667975201143],
            [10.161146954917138, -2.6528047964672457],
            [10.156592516790646, -2.653081901686929],
            [10.152643477733477, -2.6503967097462366],
            [10.152374893551332, -2.6461373332428897],
            [10.168247678455698, -2.6343389263756767],
            [10.171189038126691, -2.6293127165750554],
            [10.17052453602696, -2.62572135255262],
            [10.166619565800145, -2.6243900412151873],
            [10.15599611383501, -2.6268227016803793],
            [10.152443422334096, -2.625214218472348],
            [10.145791575222637, -2.618663505126123],
            [10.140039628467527, -2.6176642736243427],
            [10.138577392423189, -2.6219343986867565],
            [10.13782420326013, -2.6309271403526524],
            [10.135019902677582, -2.632524779314833],
            [10.1305544191708, -2.6298506527736527],
            [10.130133017656078, -2.6250853352829626],
            [10.127320364021353, -2.6205513030233325],
            [10.118885359068322, -2.616605233533589],
            [10.111530680716669, -2.61084712526675],
            [10.110021025290195, -2.605796925916777],
            [10.111811748534802, -2.601154537763325],
            [10.115688553268983, -2.5969212240634025],
            [10.121454214755776, -2.5940350727908537],
            [10.122935279414083, -2.5893187236245265],
            [10.11788518757853, -2.5794393007069547],
            [10.119394650376396, -2.5701785284238907],
            [10.113925869488325, -2.5660905982895006],
            [10.106950148272018, -2.5683658105279785],
            [10.105889352690431, -2.574012230310928],
            [10.10342557798607, -2.576003813915662],
            [10.090869931593705, -2.577225156273818],
            [10.084373119032355, -2.58205266821762],
            [10.081061437376766, -2.5829832137255457],
            [10.07350657919123, -2.5796926292527655],
            [10.068084802075267, -2.581142978140399],
            [10.060431910449225, -2.5813015490946207],
            [10.053931669275105, -2.5846210189651075],
            [10.050305644477197, -2.587821774703188],
            [10.04420577936929, -2.586072261783842],
            [10.041030049503474, -2.5799019440359765],
            [10.038183193707217, -2.5770660422176332],
            [10.041521967771196, -2.570074913038899],
            [10.03511762326664, -2.5616731859470514],
            [10.034299600418835, -2.5550342392112744],
            [10.027728026019554, -2.5562110226488555],
            [10.025909859541816, -2.5580701074691445],
            [10.022628789265523, -2.554401345298679],
            [10.02224476178906, -2.547510706202482],
            [10.019876412013936, -2.5446872292682396],
            [10.013627033015368, -2.5506786008475952],
            [10.01018017277739, -2.551091854514507],
            [10.008878456886205, -2.5553482986593474],
            [10.004374885965735, -2.5540123526063354],
            [9.99833669651453, -2.554123116556438],
            [9.99820795285082, -2.551292693909898],
            [9.991234876597163, -2.552003637382408],
            [9.990136900188837, -2.5445472948426957],
            [9.972305534484846, -2.5445725158396293],
            [9.962826311118558, -2.540214116431584],
            [9.956209908453982, -2.5291980507839593]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.92548084201229,
          "lat": 35.687222948045395
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47009"],
        "coty_name": ["Blount"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blount County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01639726"
      },
      "bbox": [
        9.943496446295802, -2.6553667975201143, 10.38144924104867,
        -2.212663231823237
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.118690011106837, -1.8204197570634146],
            [9.132314156766135, -1.8160345127124817],
            [9.132627950449793, -1.7724588522452025],
            [9.133280702412483, -1.7243827913786376],
            [9.140643217030492, -1.7068173170249987],
            [9.14522873940782, -1.6990983109265647],
            [9.1489492631119, -1.694544491725369],
            [9.15821989534113, -1.6978095227955174],
            [9.161814600878968, -1.6885215471795878],
            [9.160786661118227, -1.6851521085482983],
            [9.16088718219772, -1.6766521441027553],
            [9.156213583082922, -1.673164958677871],
            [9.156752644246135, -1.6691022306565702],
            [9.159935511990208, -1.666649503847689],
            [9.161689537280266, -1.6614474968275719],
            [9.166301396223725, -1.665641416481894],
            [9.171821055557327, -1.6588773626111064],
            [9.178466782563804, -1.6590984790879637],
            [9.180419965901317, -1.6517058292666689],
            [9.18548051275687, -1.6518327963386594],
            [9.184709114711184, -1.6470124479648078],
            [9.186156071534976, -1.643081540030292],
            [9.19596532919764, -1.6505906904133898],
            [9.213515564765201, -1.6396055887491339],
            [9.228214957278217, -1.6331160238844322],
            [9.238704342043288, -1.6296552502068427],
            [9.25120974404842, -1.6283986141248832],
            [9.265594359724188, -1.6281348974803083],
            [9.27326422276897, -1.6286582715490534],
            [9.293526028086486, -1.6313607518413304],
            [9.303882528577766, -1.6335954355840543],
            [9.341230541018176, -1.6493089003041035],
            [9.371080845309415, -1.6712822658152553],
            [9.41237966773242, -1.6666803238125392],
            [9.428664917358683, -1.6909586906481424],
            [9.45413530867017, -1.752352741305816],
            [9.471056002811943, -1.7723738991894082],
            [9.478700328852277, -1.771770673764066],
            [9.480469453818076, -1.7785635217220288],
            [9.476762605060578, -1.7791100961952873],
            [9.485442043460276, -1.789499674435215],
            [9.471972931408835, -1.796549071133737],
            [9.465063503990722, -1.799266498667605],
            [9.462294483110856, -1.8035117039597044],
            [9.463900045574443, -1.8119509907913338],
            [9.459707454768335, -1.8161069718727032],
            [9.455345738566074, -1.8178969845576627],
            [9.451413606631965, -1.8212266944962785],
            [9.44369628566494, -1.8185034551069033],
            [9.440691477632415, -1.8157188592078692],
            [9.435766488911778, -1.8146728706415423],
            [9.437541391161044, -1.8210822873796084],
            [9.433086308121771, -1.8221270984352178],
            [9.430778238279755, -1.8254623497435338],
            [9.43152586584307, -1.8330101525050977],
            [9.436643363424997, -1.8372393038083121],
            [9.435719612851804, -1.8399372506583875],
            [9.43208932143234, -1.8413591390516926],
            [9.424366230891536, -1.838694491005751],
            [9.422294865889123, -1.841893464383786],
            [9.424164988086194, -1.844090270897106],
            [9.425303212182081, -1.8497900255987412],
            [9.428471028168923, -1.854520829037706],
            [9.420960485647042, -1.8612825251431562],
            [9.41656476418308, -1.859218101501905],
            [9.411881293782047, -1.8660959395293926],
            [9.406137996527306, -1.8616438190399478],
            [9.402650943583927, -1.8606554528847212],
            [9.399021852018588, -1.869404682943187],
            [9.393606608957832, -1.8707678266341161],
            [9.393087609996753, -1.8729719817225676],
            [9.397206477965828, -1.8773320883036684],
            [9.391567282583448, -1.8796044093526763],
            [9.390454623033161, -1.8850678665787453],
            [9.387970946397171, -1.8898655732446625],
            [9.391566610365448, -1.8953637649500736],
            [9.388865398079776, -1.900106908867388],
            [9.381086802843656, -1.9018663950564763],
            [9.374053559330397, -1.906224007574823],
            [9.3722478734573, -1.9027517025675031],
            [9.367589974393061, -1.9007692614994518],
            [9.36133430684935, -1.906049686531121],
            [9.360405449032681, -1.9088726666186142],
            [9.356911050240893, -1.910281407124281],
            [9.352512403388593, -1.9152504459083255],
            [9.349001396622626, -1.9124927197274155],
            [9.341367098270394, -1.909838420596377],
            [9.340424199749437, -1.9114091708018495],
            [9.333586485012404, -1.9114660733355797],
            [9.327228743781728, -1.9196604773204582],
            [9.325213775237142, -1.9253754408863162],
            [9.32838209995137, -1.935649653185302],
            [9.324771872183547, -1.9437469590688066],
            [9.323936493437033, -1.956954456108204],
            [9.325769305634573, -1.9600769909020277],
            [9.325471297454595, -1.967560439041682],
            [9.320712705866596, -1.9669397734910394],
            [9.318769076392842, -1.9715913384877948],
            [9.319919531808104, -1.9741520854599495],
            [9.31684589310316, -1.9833473285121213],
            [9.313291477442991, -1.9841622584208165],
            [9.312531851913075, -1.9910330944983547],
            [9.310308482618098, -1.9925368607541425],
            [9.305423046637245, -2.0007419349602116],
            [9.308852778169882, -2.0107436906931486],
            [9.31123188880689, -2.0123876352590697],
            [9.309342352909479, -2.0176710006069296],
            [9.310933998741266, -2.0223667884821825],
            [9.316248481637649, -2.024377659718075],
            [9.318332455560228, -2.031164723424323],
            [9.320902071804992, -2.0353505914455776],
            [9.31756801737864, -2.0412695286595914],
            [9.318316669751546, -2.049015315731435],
            [9.316617221079342, -2.052240996323412],
            [9.311098973876648, -2.058241588349364],
            [9.306445413690911, -2.0590005796407493],
            [9.302378247658966, -2.0635427902556507],
            [9.29761037275795, -2.064655794413856],
            [9.2973027714437, -2.0600871457950234],
            [9.293713146722837, -2.0566332812357446],
            [9.282124937497672, -2.0589391024775376],
            [9.28024567962199, -2.057330388649522],
            [9.276934636391145, -2.06553631123522],
            [9.266862748444597, -2.0564574217372225],
            [9.26421564871356, -2.0549865482762244],
            [9.258614100900628, -2.057454485117368],
            [9.254217489025676, -2.0544229334784267],
            [9.246688734213913, -2.0561362045629976],
            [9.245827937234623, -2.0646973840962097],
            [9.243412937057403, -2.066257500926174],
            [9.239827469569518, -2.064027601304848],
            [9.234254676473713, -2.058394830773666],
            [9.231941636138046, -2.0608942635328193],
            [9.228076428416072, -2.0584617469914033],
            [9.224975353535122, -2.0538211647661613],
            [9.221824560092397, -2.0543478898889846],
            [9.218777052547935, -2.0491372955646816],
            [9.21497568904291, -2.0544803399855116],
            [9.211405604418424, -2.0573358914069444],
            [9.208390593327284, -2.06796618741067],
            [9.198539905954775, -2.068874829795978],
            [9.19117348152588, -2.076225421698595],
            [9.192449469380039, -2.0792857146517267],
            [9.189973692179809, -2.0836331206079306],
            [9.18422562501019, -2.083599897522944],
            [9.18059925426285, -2.08640021039892],
            [9.181159703188914, -2.0918540881489713],
            [9.16574024586235, -2.087769947090337],
            [9.149633612920221, -2.083369907282559],
            [9.173157030858325, -2.0284189389037928],
            [9.142291866225277, -1.9585445769663197],
            [9.12908801970385, -1.9233858357273654],
            [9.11976446383684, -1.830332532996695],
            [9.118690011106837, -1.8204197570634146]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.93247787114683, "lat": 36.38049992019575 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47049"],
        "coty_name": ["Fentress"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fentress County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01639743"
      },
      "bbox": [
        9.118690011106837, -2.0918540881489713, 9.485442043460276,
        -1.6281348974803083
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.248401117150612, -1.9287990402447073],
            [10.261481337026748, -1.9177421902356526],
            [10.255394106798592, -1.9155826455773424],
            [10.249536676797234, -1.9108496567736328],
            [10.248927165850066, -1.9055371870732747],
            [10.25449328028553, -1.9036956606712063],
            [10.258240421125125, -1.8996484712162152],
            [10.254930838607667, -1.8965177702633769],
            [10.256353587953361, -1.8919585758630413],
            [10.266696192714354, -1.8853243272881028],
            [10.268577151663493, -1.8824346196000699],
            [10.269990455312884, -1.8518315688132747],
            [10.266124306332, -1.8351417678087092],
            [10.259619798585188, -1.8402608790193984],
            [10.258050361212433, -1.8170648540321694],
            [10.267735580154426, -1.8098018395350575],
            [10.26899723857071, -1.8046521161187565],
            [10.26870094395225, -1.799215817150389],
            [10.271873990302485, -1.796080852947922],
            [10.270509108672881, -1.7909240975452512],
            [10.265848997992492, -1.7928536666202919],
            [10.272397316514455, -1.7609665133851835],
            [10.266587722882772, -1.7565342670644233],
            [10.271752827747376, -1.749857900742742],
            [10.275100061415873, -1.7514565556290351],
            [10.27670732875663, -1.7421919700863713],
            [10.281013928305565, -1.7462080467708314],
            [10.2819831081758, -1.7523902988338909],
            [10.285133223240413, -1.753709009868831],
            [10.288366017568809, -1.7519641867151476],
            [10.289030604712593, -1.7471966966184063],
            [10.293384493254939, -1.7447964111827716],
            [10.299236084009275, -1.7476939141179724],
            [10.305106782060946, -1.7445858360420727],
            [10.309515798038676, -1.7395315929038864],
            [10.31816807597074, -1.7355494435757806],
            [10.321086794845598, -1.72773840805502],
            [10.323355704934068, -1.7254057758476575],
            [10.330489376920205, -1.7221297540418234],
            [10.331756096096628, -1.7195212040670056],
            [10.33158821360077, -1.7115037170354017],
            [10.334607461364833, -1.709377442447369],
            [10.338666892009103, -1.7096576190226562],
            [10.344480252787232, -1.7134736135362756],
            [10.348197438028516, -1.7135957591214068],
            [10.351849132480847, -1.7113856314007267],
            [10.3516653721288, -1.7063212829893721],
            [10.35655556072644, -1.703744443060609],
            [10.359454260468889, -1.7074339068218356],
            [10.360429455279402, -1.7117835216218171],
            [10.365174997421137, -1.7123811473886932],
            [10.365570176813556, -1.706221749243001],
            [10.37204359525188, -1.715647167031685],
            [10.378622480893197, -1.7203776874749066],
            [10.382682296836236, -1.7169927130491356],
            [10.380702874515443, -1.7074833724674863],
            [10.385487979288083, -1.7083788196932717],
            [10.387229159401056, -1.7124236657646177],
            [10.393096761589117, -1.7141936002876976],
            [10.393448762929774, -1.705903177741104],
            [10.396307101411747, -1.6995207508411962],
            [10.400286488772739, -1.6973664997525937],
            [10.402833062091574, -1.702627812991711],
            [10.406460153102728, -1.7069309420427088],
            [10.411151126122311, -1.7040713802863274],
            [10.410252070086976, -1.6997119452215126],
            [10.406584519280928, -1.6938876070601672],
            [10.406411281653567, -1.6907552902706309],
            [10.410087199528528, -1.6893520058232439],
            [10.414832509167613, -1.6905561493915509],
            [10.418243793824967, -1.687763521010867],
            [10.421948371765438, -1.6883925327684168],
            [10.424903449540137, -1.6918688741224064],
            [10.432749706776173, -1.696427110581655],
            [10.445356928997674, -1.6895632714252022],
            [10.434838094723727, -1.6757927639640433],
            [10.440243555574972, -1.678332764789377],
            [10.443350122498142, -1.676156378372526],
            [10.441090318960335, -1.6695682571580692],
            [10.436727521212411, -1.6682132822638014],
            [10.43399241402096, -1.663419510241089],
            [10.43706357815317, -1.662264869082006],
            [10.439835449828564, -1.666782915067753],
            [10.443063621545074, -1.6668633019068109],
            [10.447825968334984, -1.6609376202789379],
            [10.446539978564568, -1.652294232520886],
            [10.448202718517106, -1.6499264873122597],
            [10.45592526671657, -1.6542197185490712],
            [10.457318664500194, -1.652131872777896],
            [10.455063040666609, -1.6446048038382366],
            [10.45795924643081, -1.643405240207617],
            [10.465818420198687, -1.6491024382920485],
            [10.468002924286129, -1.646954831666428],
            [10.46493690574119, -1.6430712334268294],
            [10.467727716490456, -1.6394584309433347],
            [10.47540107764551, -1.643287007074108],
            [10.483935862715333, -1.6427946428474953],
            [10.489497305971934, -1.6440897671862233],
            [10.486979207347924, -1.6459456258507297],
            [10.488079767758956, -1.649393388456032],
            [10.515888274631992, -1.6339449881993675],
            [10.526331649592251, -1.6440501758655994],
            [10.531180199911285, -1.6442161397591615],
            [10.538908908506999, -1.6428197272483582],
            [10.541096011723578, -1.6462709910561018],
            [10.544526953625269, -1.6447671850808476],
            [10.547926318142938, -1.650922629036193],
            [10.553116576207488, -1.6494164876342907],
            [10.554899825116326, -1.6561002178198903],
            [10.55812630250001, -1.660350208322778],
            [10.566400461368449, -1.6548603698934639],
            [10.57590461191668, -1.651342053262803],
            [10.579123372284446, -1.6573232090339272],
            [10.582388920468944, -1.6606507527438343],
            [10.57605876948188, -1.6638445300343943],
            [10.571484769006185, -1.6681251083604942],
            [10.573090265637472, -1.6716762487278203],
            [10.577053026453754, -1.6748074026944662],
            [10.584975205230858, -1.6750646539756247],
            [10.586040708679104, -1.6787901132606555],
            [10.592103730421206, -1.6915147190874387],
            [10.594178536883856, -1.6931696397267264],
            [10.595353547735623, -1.699566056154726],
            [10.596741674283216, -1.716600535645609],
            [10.591060816511568, -1.722604836833629],
            [10.591549789406677, -1.726209221710237],
            [10.601225758131156, -1.7388486498290434],
            [10.610151186326698, -1.7542393855829812],
            [10.603906693709504, -1.7556970620051557],
            [10.601203585399615, -1.7595226954505556],
            [10.603723225004801, -1.7674214076760413],
            [10.602823112684133, -1.7702904065807177],
            [10.598671256846224, -1.7711580639822293],
            [10.593380298528139, -1.7701447589481831],
            [10.595236896558452, -1.7814912870227921],
            [10.593884169871426, -1.783403977971723],
            [10.586113092727773, -1.7843526057461538],
            [10.583988343372058, -1.780566254646126],
            [10.584460399206188, -1.7751032488818812],
            [10.583233981928384, -1.7713976437709018],
            [10.580322918746056, -1.769550364371742],
            [10.57733285825297, -1.771889483804305],
            [10.573568303925057, -1.780445544266219],
            [10.569193631443987, -1.7791008212306634],
            [10.566746336239783, -1.7729121920204596],
            [10.562318501025894, -1.77116707748045],
            [10.559677663125603, -1.7665322315985457],
            [10.56005482272936, -1.759758833364818],
            [10.556334065434887, -1.7554723599399653],
            [10.550890643366573, -1.755022400192889],
            [10.548963628413999, -1.7575803071131422],
            [10.548932728084553, -1.7675605652096298],
            [10.543613144714067, -1.7729557831935725],
            [10.541120393226969, -1.7735949553151233],
            [10.531957186455143, -1.7713602586216646],
            [10.526264958826145, -1.7757859856321445],
            [10.525558156671766, -1.778934207449567],
            [10.528344655387668, -1.7871121278799345],
            [10.525972872439747, -1.7892613952742287],
            [10.511259415159465, -1.7913292798598854],
            [10.508635228714242, -1.7927990996768046],
            [10.505580572776344, -1.7976851480304792],
            [10.5027140807064, -1.8051922896597157],
            [10.493481237916887, -1.810901011084159],
            [10.486910129931504, -1.8244983111283226],
            [10.486097068774548, -1.8292882945684557],
            [10.49120368945859, -1.8373615907242278],
            [10.492172856797584, -1.8409983513248485],
            [10.48490507094277, -1.8500056784833228],
            [10.47909601844868, -1.852406425886777],
            [10.475131808739443, -1.8504906800118304],
            [10.473723596769714, -1.8417217082742474],
            [10.469773634099626, -1.8411269097504412],
            [10.465895125355706, -1.8459163724074286],
            [10.465489690635549, -1.8507534681719493],
            [10.466515662402527, -1.8608961432563478],
            [10.470523474625915, -1.8673862299233086],
            [10.469894328085278, -1.873575939056212],
            [10.46130920025991, -1.8769540537950256],
            [10.456764339866078, -1.876743612396295],
            [10.455009388186198, -1.8805380660113693],
            [10.458303253791872, -1.8871232514168503],
            [10.457697718391033, -1.8910706016373915],
            [10.445703121014828, -1.9003935760481694],
            [10.438382362425937, -1.902379981306066],
            [10.427901521423227, -1.9006976888612797],
            [10.418859097810085, -1.8927847996486589],
            [10.416168163228384, -1.89300473485018],
            [10.41440826604944, -1.8967975104491448],
            [10.413368606223939, -1.907443039708614],
            [10.410806504992255, -1.9096136491230737],
            [10.406298694217728, -1.9070812273430138],
            [10.403756925336708, -1.9022726614840126],
            [10.402463241092853, -1.8936923006163369],
            [10.399596329691537, -1.8915263059187009],
            [10.39519622867124, -1.8924113300544934],
            [10.39187831783691, -1.8947816400302024],
            [10.385575308666176, -1.8959176409041052],
            [10.383581218183437, -1.8930257229343403],
            [10.382684901213374, -1.8874455243400576],
            [10.379374452091428, -1.8838211023334608],
            [10.376224914786507, -1.8861584246571357],
            [10.37774100247051, -1.8933869184335992],
            [10.382692179922568, -1.9021985571164517],
            [10.381632525846769, -1.90946044394766],
            [10.378102471716142, -1.9108403710267887],
            [10.369558370054685, -1.9090165716181144],
            [10.366934465345825, -1.911662717778932],
            [10.36936307299899, -1.9172796602718156],
            [10.36999058161173, -1.922174662790565],
            [10.364909198716012, -1.9239112271566419],
            [10.362710370110522, -1.9217355858912482],
            [10.362899688964365, -1.9152255008801322],
            [10.360640955294738, -1.9121867351037931],
            [10.35547502249707, -1.915240248305258],
            [10.354350032508302, -1.9192123493257494],
            [10.354021564532644, -1.9289586470198408],
            [10.356821989532857, -1.936750117640123],
            [10.353751937217647, -1.941800184223248],
            [10.348618308596711, -1.9394340141661854],
            [10.3467399246979, -1.9410841156244654],
            [10.351574353300418, -1.9463363032651346],
            [10.349589276790335, -1.95017662109283],
            [10.345781511158085, -1.9455966443695865],
            [10.34250883130662, -1.9384904666332763],
            [10.340632319111842, -1.937994493302785],
            [10.337140289579756, -1.9423624075991712],
            [10.333688194663775, -1.943729735609125],
            [10.331471255845692, -1.9397467825813135],
            [10.328049252234248, -1.9382613061307041],
            [10.326299317522047, -1.942152601634733],
            [10.326370671447025, -1.9512994464525546],
            [10.327481687218343, -1.955114742613793],
            [10.337116922397767, -1.959568084595721],
            [10.338580732609111, -1.976653079543002],
            [10.33743641783436, -1.9826605397432087],
            [10.329714724628746, -1.9868909306594806],
            [10.326492495363029, -1.9871685379384227],
            [10.321192401437603, -1.9850459539546976],
            [10.318083320225206, -1.9796594294439551],
            [10.321283962628552, -1.975502931244851],
            [10.322286635538827, -1.970719817942253],
            [10.317845284018743, -1.9627839152676783],
            [10.3179466188642, -1.9598611519174032],
            [10.31148096547316, -1.95962988473033],
            [10.311715071968528, -1.9642077365175608],
            [10.30657071642361, -1.9647639089342572],
            [10.305647112524001, -1.959934198012682],
            [10.299940321047622, -1.9623557716935593],
            [10.29946794075955, -1.967796731713873],
            [10.308618226550044, -1.9876593491351067],
            [10.315607525979077, -1.9946253171673645],
            [10.316883057109056, -2.0003030620763793],
            [10.315191228312209, -2.0038746676909596],
            [10.311119479625726, -2.0060862796810035],
            [10.310726040486424, -2.000389113985509],
            [10.302319788154444, -1.9894244740253566],
            [10.297446275597068, -1.9863129238357706],
            [10.292606724807653, -1.9863999807178034],
            [10.291400022722103, -1.976889172595795],
            [10.285585265341439, -1.9781902590998897],
            [10.284600741507758, -1.9685639826246306],
            [10.279737576996002, -1.967151985170005],
            [10.27690319113071, -1.969785978528417],
            [10.274223186296311, -1.9659738915407077],
            [10.27401835575479, -1.962471706380068],
            [10.269003180097675, -1.9625406195571014],
            [10.261284207726124, -1.9553046253236135],
            [10.257316013427067, -1.950224993417847],
            [10.257825549064536, -1.9404950693574827],
            [10.250763415811164, -1.9346540371670078],
            [10.248401117150612, -1.9287990402447073]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.5095526454336, "lat": 36.276304289496345 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47057"],
        "coty_name": ["Grainger"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grainger County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01648575"
      },
      "bbox": [
        10.248401117150612, -2.0060862796810035, 10.610151186326698,
        -1.6339449881993675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.514969539947847, -1.7490392612973982],
            [7.5577251988124825, -1.7442061579389372],
            [7.596681659600322, -1.7397810331434589],
            [7.6794823917209865, -1.729546868870282],
            [7.720806158431313, -1.7249337157515516],
            [7.753346562179164, -1.7210135033893719],
            [7.792568194240441, -1.715924159722848],
            [7.831683301292815, -1.7116623357619491],
            [7.929340074136872, -1.6988411973257278],
            [7.9517867259280095, -1.715810710025047],
            [7.9465651330602585, -1.7306715982440548],
            [7.932852643779759, -1.763026957961466],
            [7.927107507686846, -1.7799125449990614],
            [7.920388072808849, -1.7899062388749873],
            [7.906017800779477, -1.8189027711563066],
            [7.902447090918731, -1.8430432287841143],
            [7.9024259327086295, -1.8487546388704963],
            [7.904618442775415, -1.8596849918248677],
            [7.902045419359843, -1.868913941534908],
            [7.902080408676904, -1.8754733255411942],
            [7.898386238836369, -1.8868899212914645],
            [7.890748921519649, -1.8962634241035994],
            [7.881881788121427, -1.9088429220999092],
            [7.878268498895562, -1.9213719785529604],
            [7.87474347836288, -1.9263950158545835],
            [7.869249172726265, -1.936736772373864],
            [7.8696987141230155, -1.9426312453530035],
            [7.873548978840799, -1.9504757679958051],
            [7.871787066208597, -1.9531942960060966],
            [7.86743976588239, -1.9534496546200013],
            [7.865240776735399, -1.9509455240313847],
            [7.860150125926565, -1.9508891857992867],
            [7.8568428303687075, -1.947674376895228],
            [7.85091401317939, -1.948412216019609],
            [7.849658872214791, -1.9441791102980528],
            [7.845690642101437, -1.9460323101454189],
            [7.844027224229447, -1.94908515247508],
            [7.839440816052116, -1.9491352441067147],
            [7.837223926004233, -1.945380207465872],
            [7.82700113546432, -1.9461464451138526],
            [7.828078333395436, -1.9484326240924488],
            [7.826583270257852, -1.954257234127761],
            [7.82315641178245, -1.9597116380221264],
            [7.821107738651794, -1.9656173604609533],
            [7.816297781928337, -1.9662331048860244],
            [7.816687834106287, -1.971702308908897],
            [7.803700539731278, -1.9771213218250303],
            [7.804427759775343, -1.9801137956723602],
            [7.802173946891485, -1.9838684638735504],
            [7.801944448061594, -1.988187506904831],
            [7.79720602127692, -1.9913654395207308],
            [7.797208422750237, -1.9989053963104577],
            [7.801528437578295, -2.002088019849055],
            [7.8017975166773885, -2.008272174509836],
            [7.794106214400436, -2.00904858074331],
            [7.789938242749101, -2.0123650610245547],
            [7.779990921560956, -2.017362362991722],
            [7.772224684227296, -2.02020220944455],
            [7.7610987859272775, -2.0124815746843145],
            [7.755913111649901, -2.0071344056234466],
            [7.750186874015455, -2.005706728970953],
            [7.747657138493751, -2.0032203460072764],
            [7.747749917816718, -1.9927324298352147],
            [7.739808531779222, -1.992448178218884],
            [7.741453584328693, -2.0040485874557943],
            [7.734632087981904, -2.000022289432512],
            [7.729017801894701, -2.002588726049842],
            [7.727499268168294, -1.996207813641412],
            [7.723530355106053, -1.9948645544956765],
            [7.7182706828317, -1.9889475233661504],
            [7.714034659689554, -1.9868946822501863],
            [7.708473195840299, -1.9874610414964318],
            [7.703745550487641, -1.986557521342277],
            [7.700972749154194, -1.9891179440509026],
            [7.699627985810968, -1.9948402743519562],
            [7.694157062766546, -1.9908331537339445],
            [7.687965037561127, -1.9960666029801484],
            [7.680037143664592, -1.9929401754776392],
            [7.680192466264585, -1.999502660919434],
            [7.677449181078435, -2.001361999243391],
            [7.671274106367112, -2.0008399568936537],
            [7.665892195933245, -2.0038647871764588],
            [7.6611913224901675, -2.00408094327956],
            [7.658736171140602, -2.007403825773583],
            [7.65482491535525, -2.008474637361173],
            [7.6547710554020965, -2.015381063536065],
            [7.65035698354594, -2.0151992805991314],
            [7.646009715108091, -2.0116119672369175],
            [7.643221970291099, -2.0121233071757065],
            [7.644726967197552, -2.01784064800659],
            [7.625551324283095, -1.9920013185621581],
            [7.607006304690474, -1.985476960435777],
            [7.549833754797045, -1.950630951274075],
            [7.528250865608987, -1.9372612529643256],
            [7.52838931870008, -1.9315259339265443],
            [7.521108358908472, -1.9313532311599035],
            [7.5223266786522185, -1.9042657354019281],
            [7.52285597712418, -1.8815417073027643],
            [7.5252867813417, -1.881761955160711],
            [7.527591398092302, -1.8688327978015942],
            [7.523267351953834, -1.8686086171716647],
            [7.523767364519398, -1.852808141617068],
            [7.520701854075637, -1.8534986468960333],
            [7.518873433509075, -1.8499647798693206],
            [7.521138809582648, -1.8443996733595087],
            [7.517883136982574, -1.842545953458947],
            [7.5147911112211165, -1.8454571387999534],
            [7.51081407414067, -1.8450478787058056],
            [7.510741594224013, -1.8408509696323754],
            [7.5070786556330615, -1.8413951754180937],
            [7.50238675718407, -1.8389018495986396],
            [7.505134138426401, -1.8349542168913202],
            [7.5043354205065045, -1.8314737637358944],
            [7.501023914999005, -1.830191107718675],
            [7.494610759742461, -1.8303977748833007],
            [7.495801479732969, -1.8257049383982433],
            [7.505131936589618, -1.8303189946365441],
            [7.508061841830174, -1.8266024082843946],
            [7.506407153744281, -1.8226598001768153],
            [7.509873099070403, -1.8205935227376144],
            [7.512929576106214, -1.778490520423794],
            [7.507609872553663, -1.7709829159512709],
            [7.507563695754687, -1.763339344916272],
            [7.5143690602355155, -1.7635848490215322],
            [7.514969539947847, -1.7490392612973982]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.87055250436612, "lat": 36.52541391107011 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47147"],
        "coty_name": ["Robertson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Robertson County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01639786"
      },
      "bbox": [
        7.494610759742461, -2.02020220944455, 7.9517867259280095,
        -1.6988411973257278
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.2126157387366625, -3.461910583726217],
            [-3.2069029989763993, -3.4623774491090895],
            [-3.0996200309721305, -3.467455983720641],
            [-3.0528869660376037, -3.4696297480802105],
            [-2.926954172732326, -3.4753342113468],
            [-2.7766748413309297, -3.4819172305871073],
            [-2.7831575443717487, -3.6355763544352535],
            [-2.7906511269870213, -3.813163743199963],
            [-2.795188356897902, -3.9206720578837504],
            [-2.7955356163861, -3.920570876402809],
            [-3.0186772622669613, -3.910181836043786],
            [-3.1004553243355515, -3.9064684475185874],
            [-3.106051231167554, -3.905812255079331],
            [-3.1334019207404613, -3.90454735699182],
            [-3.1666735740293515, -3.903023003416685],
            [-3.2349833828751997, -3.8995691534607455],
            [-3.2351105248090395, -3.897217439720081],
            [-3.231927841460257, -3.840892979860903],
            [-3.2276534379478017, -3.749387556570138],
            [-3.2261231658498164, -3.7247702116775843],
            [-3.2221408875397826, -3.6498561097012163],
            [-3.215474219501775, -3.5202187676041192],
            [-3.2126157387366625, -3.461910583726217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.27002016243392,
          "lat": 34.96482517067768
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48087"],
        "coty_name": ["Collingsworth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Collingsworth County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01383829"
      },
      "bbox": [
        -3.2351105248090395, -3.9206720578837504, -2.7766748413309297,
        -3.461910583726217
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.006279743365491, -7.088513247982393],
            [-3.9914075829450573, -7.0895013681681],
            [-3.8913255207200352, -7.095341857146641],
            [-3.791242452356646, -7.101166779312913],
            [-3.6551871948617713, -7.109893449931252],
            [-3.519129601169742, -7.118591312732813],
            [-3.522687857076662, -7.204076619407765],
            [-3.526160714073469, -7.295456043256919],
            [-3.528018143310035, -7.336415265543174],
            [-3.5301789142295523, -7.392850210402835],
            [-3.529971445862621, -7.394028139405616],
            [-3.5371288725133625, -7.55360813462272],
            [-3.6537825696700534, -7.54977773867853],
            [-3.770435968319846, -7.545924320214915],
            [-3.8933654024569355, -7.540916285821448],
            [-4.016294150002831, -7.535882647985108],
            [-4.037101416601013, -7.53477219364889],
            [-4.022679229604327, -7.3216603432147895],
            [-4.018711780261119, -7.268475265698913],
            [-4.009741261397373, -7.142416877570467],
            [-4.006279743365491, -7.088513247982393]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.98238600099022,
          "lat": 31.30391516368902
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48235"],
        "coty_name": ["Irion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Irion County"],
        "coty_fp_code": "235",
        "coty_gnis_code": "01383903"
      },
      "bbox": [
        -4.037101416601013, -7.55360813462272, -3.519129601169742,
        -7.088513247982393
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.065257223570834, -7.949523220164354],
            [-2.9558057916125557, -7.95395800160439],
            [-2.8463534963839705, -7.958371089990586],
            [-2.7695915394811164, -7.961256097201446],
            [-2.64460879570055, -7.966322276548656],
            [-2.6382396321576382, -7.96609180004871],
            [-2.549292026246525, -7.969645833834719],
            [-2.5233576968323215, -7.970589816007843],
            [-2.5266563529711235, -8.05548649772954],
            [-2.531046463440889, -8.162826943180926],
            [-2.531649066795682, -8.179948431367917],
            [-2.3765452475895747, -8.185243945765917],
            [-2.3773088155272464, -8.212658354509127],
            [-2.3818195912280746, -8.382662151892902],
            [-2.382005855065054, -8.396532700560273],
            [-2.4841057207306814, -8.39192913376528],
            [-2.532681819314218, -8.389692907361518],
            [-2.6365396436672976, -8.38481732361999],
            [-2.771598852045942, -8.378208268211724],
            [-2.8760152871242357, -8.374525948827836],
            [-2.928881602210685, -8.3721738883674],
            [-2.9487302550433254, -8.371609595236727],
            [-3.0836779978646676, -8.365815670774662],
            [-3.074620315600377, -8.157570848396865],
            [-3.065257223570834, -7.949523220164354]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.74867506368625,
          "lat": 30.486792997115334
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48267"],
        "coty_name": ["Kimble"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kimble County"],
        "coty_fp_code": "267",
        "coty_gnis_code": "01383919"
      },
      "bbox": [
        -3.0836779978646676, -8.396532700560273, -2.3765452475895747,
        -7.949523220164354
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.4423003176063025, -6.121652378578962],
            [-3.32767856736688, -6.12795501213143],
            [-3.2827016599391206, -6.130359734881912],
            [-3.173589057548195, -6.135713921289209],
            [-3.0644756581626686, -6.141053473832513],
            [-3.0118515335998506, -6.144017498981479],
            [-3.013420674436179, -6.172124779549346],
            [-3.0180359170894495, -6.247994784650753],
            [-3.0201770122527534, -6.287979268767622],
            [-3.0249705935789204, -6.385155573102188],
            [-3.0330216785362367, -6.539344647011284],
            [-3.0339249910727055, -6.548316159543322],
            [-3.035671568589503, -6.583160162424095],
            [-3.1057840011374447, -6.580350858429744],
            [-3.118651940055035, -6.580559307784459],
            [-3.1815848496463257, -6.577914863208794],
            [-3.2543075268706634, -6.573706659706831],
            [-3.3393118958186587, -6.568732854224723],
            [-3.428602445864909, -6.562988259409533],
            [-3.434300182981956, -6.562113047090754],
            [-3.46795785937562, -6.560458468580107],
            [-3.4656276471608733, -6.522120878226387],
            [-3.4649655236043784, -6.520895547661622],
            [-3.463310385918482, -6.487667757660276],
            [-3.4502834607236994, -6.2586725109548835],
            [-3.444449712747608, -6.1616930620014285],
            [-3.4423003176063025, -6.121652378578962]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.40596319204364,
          "lat": 32.303506148372634
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48353"],
        "coty_name": ["Nolan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nolan County"],
        "coty_fp_code": "353",
        "coty_gnis_code": "01383962"
      },
      "bbox": [
        -3.46795785937562, -6.583160162424095, -3.0118515335998506,
        -6.121652378578962
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.547441220553924, -5.72811228383143],
            [-2.4301603090441306, -5.732399602610492],
            [-2.4088073757073034, -5.73321212205183],
            [-2.229894485307644, -5.739414221704073],
            [-2.1419162396784768, -5.742967551474825],
            [-2.137500643940732, -5.742424752958769],
            [-2.117447477381332, -5.743141570612936],
            [-2.121414623108436, -5.867525684678376],
            [-2.123700009881753, -5.9405070892720575],
            [-2.12462387098693, -5.964085377074571],
            [-2.1280915069566024, -6.068049510267379],
            [-2.1319658092123728, -6.18539386229014],
            [-2.147253733251473, -6.18485410784624],
            [-2.193792581037647, -6.1831529135500904],
            [-2.337242026340124, -6.1782461495385705],
            [-2.384210382512435, -6.176482182348699],
            [-2.4782729267435872, -6.17341313357291],
            [-2.5643673042953545, -6.170330999595773],
            [-2.559774263834416, -6.0512483540006],
            [-2.5565275017009106, -5.964289088832738],
            [-2.5551935200862, -5.9349969442011],
            [-2.550413182628538, -5.801051194632075],
            [-2.547441220553924, -5.72811228383143]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.3540321096229, "lat": 32.73595095335096 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48417"],
        "coty_name": ["Shackelford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shackelford County"],
        "coty_fp_code": "417",
        "coty_gnis_code": "01383994"
      },
      "bbox": [
        -2.5643673042953545, -6.18539386229014, -2.117447477381332,
        -5.72811228383143
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3915968709515756, -12.044113155703386],
            [-2.3196356275966847, -11.996769916483233],
            [-2.2892731610402306, -11.976946197742823],
            [-2.2832401552934147, -11.973361916826846],
            [-2.2663611538226838, -11.961812003686576],
            [-2.256066371713958, -11.955712341719009],
            [-2.2457383171266345, -11.948343051637266],
            [-2.191155568932721, -11.842426835382662],
            [-2.125869842265814, -11.844637524476486],
            [-2.060583617219644, -11.846835366376737],
            [-1.9860516973246025, -11.849430379424842],
            [-1.911519073845277, -11.8520086464003],
            [-1.7910793361019792, -11.855626995446844],
            [-1.7851283887461082, -11.855647355216739],
            [-1.7135762997357518, -11.857750795297198],
            [-1.6219823609011224, -11.860429457942871],
            [-1.673342794585315, -11.965042340171983],
            [-1.7247323126570582, -12.069574126506787],
            [-1.7602476360478434, -12.137389599459421],
            [-1.771702119365532, -12.16101360834405],
            [-1.7788269361203972, -12.172450301835962],
            [-1.7881220521671009, -12.191384723120716],
            [-1.8182409187595316, -12.251455757823338],
            [-1.8187790315656995, -12.252937155120255],
            [-1.8442852810315047, -12.303643966758655],
            [-1.8748711046013742, -12.363490785653891],
            [-1.8750541655525823, -12.36418427809391],
            [-1.8839137398067576, -12.36350863415128],
            [-1.8941623806381414, -12.367294766818597],
            [-1.8990439930242997, -12.36818609774072],
            [-1.9008854136102264, -12.3729816408621],
            [-1.9040242169271726, -12.37285748717624],
            [-1.9049633049093375, -12.36615473936808],
            [-1.9067808434992741, -12.362118140235387],
            [-1.9095754560881597, -12.361609606250854],
            [-1.916722296069917, -12.368722102281643],
            [-1.917794105114637, -12.37579002902606],
            [-1.9204430146893354, -12.378132947835343],
            [-1.927830288493647, -12.378548704598892],
            [-1.936852293995312, -12.38340933229733],
            [-1.9438878645621416, -12.383908908914083],
            [-1.950564501306798, -12.382685326077985],
            [-1.9557146029595343, -12.378988780488475],
            [-1.9590274291995577, -12.37350523676199],
            [-1.9593181355749312, -12.368531026160214],
            [-1.9575940493670807, -12.36384082953927],
            [-1.958545957442287, -12.359457647553768],
            [-1.9627628037042426, -12.355146144144062],
            [-1.976376295142134, -12.353581331469478],
            [-1.9872137386437048, -12.350301770371896],
            [-1.9938882181963062, -12.347474503083989],
            [-1.9947419072393855, -12.34277426983612],
            [-1.9880208925088472, -12.340311119692915],
            [-1.980000508033715, -12.342285770505514],
            [-1.9769535859957044, -12.339622662265988],
            [-1.9784582372904091, -12.333612249955776],
            [-1.9851981235410001, -12.330491724350697],
            [-1.990210190849968, -12.333368371102418],
            [-1.9932637712756598, -12.332143215324795],
            [-1.9963345464935527, -12.324752642951745],
            [-2.001563182688393, -12.320747192994263],
            [-2.009101859145363, -12.321411734229539],
            [-2.014117883980335, -12.324899712540052],
            [-2.0219239543556773, -12.323155522060091],
            [-2.0270279082032765, -12.314718020176906],
            [-2.0251992683740014, -12.311203340955814],
            [-2.0217170914810723, -12.311564601486934],
            [-2.016390643533004, -12.315820519846353],
            [-2.010371209783208, -12.315024649797184],
            [-2.0089581956634937, -12.309420467057555],
            [-2.0106560915707945, -12.305891390320339],
            [-2.0152978188154673, -12.30472712130479],
            [-2.019422142762699, -12.299099134180565],
            [-2.020277800143753, -12.289955481983583],
            [-2.021626605710898, -12.288128472410841],
            [-2.0266953800813603, -12.28881101392245],
            [-2.033509894283997, -12.29298837751574],
            [-2.03736693413725, -12.29400818932956],
            [-2.0478737992163882, -12.292512041719572],
            [-2.056678271613799, -12.287380029656148],
            [-2.0549466296142573, -12.281852488798057],
            [-2.059266491281334, -12.275728323265996],
            [-2.0619741971730368, -12.27023090861873],
            [-2.063420136122582, -12.259462008252354],
            [-2.066901307798701, -12.254231526783633],
            [-2.0713985364563046, -12.250256426700311],
            [-2.0784562084531086, -12.252906590801826],
            [-2.083181930151736, -12.248382072996124],
            [-2.0894947489842157, -12.250063750311687],
            [-2.0946540902665083, -12.2554813715328],
            [-2.1025965979145105, -12.259511884350305],
            [-2.1063357820614637, -12.259415136548519],
            [-2.110623246358756, -12.254688783703637],
            [-2.1165785687694987, -12.252351256889558],
            [-2.123306466026402, -12.252776894131996],
            [-2.1307731551554285, -12.255990752561434],
            [-2.13588874215041, -12.256834487205229],
            [-2.143747375378071, -12.25951672777243],
            [-2.15257919023691, -12.263480382051506],
            [-2.1558167624003355, -12.25834094320773],
            [-2.154876496191268, -12.251295994908402],
            [-2.157830329235066, -12.245251834656898],
            [-2.1649524490289735, -12.245229948705994],
            [-2.169086885190782, -12.24349407730159],
            [-2.1748692459801404, -12.23742425307285],
            [-2.176169926823016, -12.234056229709287],
            [-2.1758375649710584, -12.225193593676373],
            [-2.180210958918214, -12.223510861121937],
            [-2.185633011616028, -12.229119027461003],
            [-2.186958337203852, -12.233920258710663],
            [-2.186219628195439, -12.242334580080994],
            [-2.189939381225408, -12.246440365649628],
            [-2.1971758403387214, -12.245970138939956],
            [-2.2054590015854267, -12.238387968529674],
            [-2.2026992790344093, -12.231501587474742],
            [-2.2022371981805757, -12.22475554533255],
            [-2.2051373385552457, -12.220792993895685],
            [-2.209563885292747, -12.218392161879654],
            [-2.216070253420481, -12.21728474493663],
            [-2.2219664554121654, -12.215011976887787],
            [-2.225547063098324, -12.216081973243094],
            [-2.2322173390939306, -12.222805667464705],
            [-2.2366603817138375, -12.223795315384868],
            [-2.2453606738815894, -12.222754048017944],
            [-2.247870048540718, -12.221434858977746],
            [-2.255105870579629, -12.222377026297972],
            [-2.259427571805079, -12.21364306970423],
            [-2.26390191608173, -12.207158322568104],
            [-2.272570836870787, -12.20197727324267],
            [-2.277476449755331, -12.200997513955745],
            [-2.285073257122552, -12.204640668063304],
            [-2.292286838250614, -12.21199145191835],
            [-2.3004731919957493, -12.216230554828853],
            [-2.306734530405035, -12.21577310959528],
            [-2.3184668633069716, -12.216497205788434],
            [-2.3212128398664027, -12.214205951545871],
            [-2.3247809266231574, -12.205052537694758],
            [-2.330901360721832, -12.200746973422364],
            [-2.333174617171223, -12.19652185941314],
            [-2.3393071954619122, -12.189694202011827],
            [-2.343537503022771, -12.186816790680687],
            [-2.345761857333026, -12.180678932579575],
            [-2.345330273759718, -12.178121249386153],
            [-2.3394121206482716, -12.17560708579105],
            [-2.33551593930725, -12.171389894148296],
            [-2.3351705570252976, -12.166023669774773],
            [-2.332805493696999, -12.159893854491056],
            [-2.3317743821365937, -12.152665248255815],
            [-2.326631183205032, -12.146575722794616],
            [-2.324563165692571, -12.138219488795762],
            [-2.327876886726837, -12.133550933086896],
            [-2.3358834229749332, -12.11518446990175],
            [-2.341928596233296, -12.10815068031819],
            [-2.348041901192889, -12.098501234944901],
            [-2.350149332608329, -12.09724224774765],
            [-2.355577383367241, -12.090412859854574],
            [-2.369794692852951, -12.087330452700307],
            [-2.3863597699743564, -12.079952100104332],
            [-2.390322486083247, -12.078722838147335],
            [-2.393751699029781, -12.074496596866407],
            [-2.394066694829088, -12.065229703524436],
            [-2.3901331954513036, -12.055497733001657],
            [-2.3915968709515756, -12.044113155703386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.73867871016051, "lat": 26.56209784531897 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48427"],
        "coty_name": ["Starr"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Starr County"],
        "coty_fp_code": "427",
        "coty_gnis_code": "01383999"
      },
      "bbox": [
        -2.394066694829088, -12.383908908914083, -1.6219823609011224,
        -11.842426835382662
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.0118515335998506, -6.144017498981479],
            [-2.9941991717371637, -6.1450629690555765],
            [-2.989027029012234, -6.144796766038256],
            [-2.94478409593012, -6.147252666945305],
            [-2.8917544669009114, -6.150392945040474],
            [-2.889468742582814, -6.150320564408071],
            [-2.778763160271794, -6.155689953421519],
            [-2.684061888067208, -6.159544073970035],
            [-2.6522310925836217, -6.161044911242851],
            [-2.578893199435462, -6.163718338509862],
            [-2.579075441503858, -6.169770649467121],
            [-2.5808320065511934, -6.209819204547278],
            [-2.582258075811891, -6.247751309390816],
            [-2.5852615686406795, -6.311801744940954],
            [-2.587613794486735, -6.370240689728644],
            [-2.5884191479580685, -6.3847283356294735],
            [-2.5902524166181626, -6.426593575490374],
            [-2.590183330219186, -6.434932052061436],
            [-2.5946647651770416, -6.5387269165753406],
            [-2.5972543290579435, -6.602365716024672],
            [-2.6667771765904167, -6.598881469400673],
            [-2.792054706237451, -6.594486983842532],
            [-2.876288676333082, -6.590492771828242],
            [-3.035671568589503, -6.583160162424095],
            [-3.0339249910727055, -6.548316159543322],
            [-3.0330216785362367, -6.539344647011284],
            [-3.0249705935789204, -6.385155573102188],
            [-3.0201770122527534, -6.287979268767622],
            [-3.0180359170894495, -6.247994784650753],
            [-3.013420674436179, -6.172124779549346],
            [-3.0118515335998506, -6.144017498981479]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.89013261420374, "lat": 32.30146717135621 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48441"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "441",
        "coty_gnis_code": "01384006"
      },
      "bbox": [
        -3.035671568589503, -6.602365716024672, -2.578893199435462,
        -6.144017498981479
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.1259662773096375, -5.291274195606035],
            [-1.0942782361002608, -5.291787413699804],
            [-1.0610703945596123, -5.292621091122736],
            [-0.9845446331913231, -5.293949021369555],
            [-0.8705969614445951, -5.295856056256953],
            [-0.7811593106057975, -5.297388415157246],
            [-0.7687070505128218, -5.297840104348768],
            [-0.6824905793349808, -5.299929539289827],
            [-0.6825926287291164, -5.302374621345655],
            [-0.6836512284907605, -5.328054144862538],
            [-0.6839794528343072, -5.3286679958529],
            [-0.6857149607639288, -5.370058130166246],
            [-0.6885148092367065, -5.425294259649312],
            [-0.6888743761721664, -5.438086504233531],
            [-0.6917097158150934, -5.487031596775342],
            [-0.6969289578204418, -5.620330205095373],
            [-0.7010548798812523, -5.720176277064832],
            [-0.7018232788752848, -5.74170514040879],
            [-0.7414836916355427, -5.740608891502746],
            [-0.7612855883150168, -5.73943142843237],
            [-0.7989333080285592, -5.737957948249504],
            [-0.8232269673463071, -5.73738664393325],
            [-0.8273650141536315, -5.7366336749705145],
            [-0.852330418815608, -5.735975486845228],
            [-0.935861461240093, -5.733288815623095],
            [-1.008798273659339, -5.730232399713882],
            [-1.0882227818865775, -5.7266613288225905],
            [-1.1376311040704052, -5.724564891609442],
            [-1.134578567792606, -5.626419740138299],
            [-1.1305582632645719, -5.488537597303964],
            [-1.1293021633021092, -5.417975633874257],
            [-1.1287556311211344, -5.4037607483214805],
            [-1.1261421869797892, -5.302446750387366],
            [-1.1259662773096375, -5.291274195606035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.65447467376137, "lat": 33.21590552561488 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48497"],
        "coty_name": ["Wise"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wise County"],
        "coty_fp_code": "497",
        "coty_gnis_code": "01384034"
      },
      "bbox": [
        -1.1376311040704052, -5.74170514040879, -0.6824905793349808,
        -5.291274195606035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.934092611650817, -0.01355986159609417],
            [12.94108210456953, -0.005067036539418232],
            [12.945841043406201, -0.000996236253186316],
            [12.949084809854044, 0.000004681171956724881],
            [12.954702992794587, 0.007557397655460515],
            [12.957396865579579, 0.009021449779879186],
            [12.969212038043565, 0.02429754466680087],
            [12.976772242795777, 0.03092240696205266],
            [12.980034155992715, 0.035814577323533166],
            [12.981852249633553, 0.041544584434119326],
            [12.986285384049356, 0.04808336833583884],
            [12.991355475072423, 0.04727042578131683],
            [12.99999225815631, 0.04910337290573628],
            [13.004450798360134, 0.05415222784013097],
            [13.00720870698173, 0.06080503616506819],
            [13.009587317063977, 0.07100240997785039],
            [13.013231399380581, 0.07798032065009854],
            [13.019298431745957, 0.09379245737602862],
            [13.030380386553553, 0.10133503537097943],
            [13.035445940465314, 0.10744045379113297],
            [13.038488392041836, 0.11423018729865574],
            [13.045272996418605, 0.1259181381844613],
            [13.045876149514706, 0.1303463656183085],
            [13.048481767277579, 0.1362156124589953],
            [13.048645483596982, 0.14019862316937193],
            [13.046493962302964, 0.14379039666771445],
            [13.05558546084103, 0.15278895637370637],
            [13.065361930629438, 0.16614979899089835],
            [13.120022843135052, 0.15740090835566867],
            [13.120767273258803, 0.15708674871430903],
            [13.181819289168399, 0.14744470553441566],
            [13.18187679194601, 0.1330773839183777],
            [13.179985386409843, 0.12390249325475967],
            [13.175439826669292, 0.11728698802946372],
            [13.191234003677213, 0.08318703988520036],
            [13.198635562418795, 0.0799329647249233],
            [13.198194990238198, 0.0698175153932732],
            [13.198942752699367, 0.059415331849443365],
            [13.197104659360383, 0.0530802807958935],
            [13.19205514069607, 0.04536754065050396],
            [13.257632455041024, 0.010628887437936326],
            [13.287962243822825, -0.005238244632171789],
            [13.28829944158602, -0.01969243307788957],
            [13.287665715323156, -0.021041325717302748],
            [13.357312379014855, -0.058010960139997875],
            [13.353097884577029, -0.062290020210814714],
            [13.354771708994676, -0.07072309494420546],
            [13.352666050103986, -0.07422317552915333],
            [13.348135127024674, -0.07624436637805859],
            [13.345897364802154, -0.08497520224711884],
            [13.335479333049234, -0.09006850326298002],
            [13.333233386930374, -0.09462154795220387],
            [13.332870623869155, -0.10033454234440982],
            [13.32860020889135, -0.10741370378006701],
            [13.31938126083307, -0.09938421011459292],
            [13.317023320699027, -0.1023538830619852],
            [13.31483188969285, -0.1089170186737855],
            [13.312027227712198, -0.11215000789891609],
            [13.311377392521221, -0.11725868414690725],
            [13.308673721546747, -0.12027803350263754],
            [13.30592341863897, -0.1277397765505121],
            [13.30397776553253, -0.13841383015696013],
            [13.307278493255637, -0.14589785180522735],
            [13.306342074487434, -0.14987953423777825],
            [13.298375046007873, -0.15435853193434487],
            [13.290943205756856, -0.1508343376095116],
            [13.278608425077058, -0.14842056364876877],
            [13.270867908229187, -0.1542909025852828],
            [13.265595512489279, -0.15170575820645327],
            [13.261576815303233, -0.1478804755549887],
            [13.258851626613632, -0.13845131591298154],
            [13.246344099834765, -0.1294921108872971],
            [13.241713439740085, -0.1271693459894721],
            [13.237342194864613, -0.12994116252709517],
            [13.227523597353075, -0.13120719870135605],
            [13.22697570993298, -0.13369529307896347],
            [13.218998001499424, -0.13996080988622667],
            [13.209592737579726, -0.15802828745399447],
            [13.20631583047302, -0.15925144627389967],
            [13.206034907192107, -0.16433492618262743],
            [13.203080989861668, -0.16711295791764721],
            [13.196247671979124, -0.1760597012740169],
            [13.190305218211584, -0.18086731635085088],
            [13.188498948280808, -0.1846646303123738],
            [13.182542038601396, -0.19115549439857496],
            [13.178859248528326, -0.1926808498582944],
            [13.176547415059776, -0.19955611553854724],
            [13.17076243663147, -0.20288345769235322],
            [13.168247111263524, -0.20695701602319205],
            [13.160775682387607, -0.21265533457756086],
            [13.152804514639362, -0.22065303200229433],
            [13.145854523520837, -0.22175125743675647],
            [13.135300480885418, -0.22892778033150127],
            [13.140674574336332, -0.23380682108975442],
            [13.143948108123332, -0.23471906389999636],
            [13.144557162700183, -0.2387782971927092],
            [13.156283274644714, -0.2487110517808063],
            [13.160776287387558, -0.24646171929854593],
            [13.166641176816972, -0.2459419611410334],
            [13.169938087600777, -0.2499477769578858],
            [13.169957496343619, -0.2533217217771147],
            [13.165152480539819, -0.25910195874466435],
            [13.164290645107704, -0.2695603938140279],
            [13.165307993777052, -0.2740564691446429],
            [13.164396530416138, -0.2795610411071705],
            [13.160291450611965, -0.284595976582467],
            [13.155121614960223, -0.2872400136917254],
            [13.149675897937797, -0.2965212486762767],
            [13.134388927687798, -0.30970692276716855],
            [13.126718868681227, -0.3184158600964341],
            [13.127138709753547, -0.323180554329318],
            [13.12560858995307, -0.32721028762134174],
            [13.108674581781129, -0.31058251946365273],
            [13.039946591345867, -0.2867255195776357],
            [13.029099973332613, -0.2832602515591766],
            [12.978233572917745, -0.26821762310473896],
            [12.94187131812171, -0.25714537952779665],
            [12.930572170397237, -0.24457200345546634],
            [12.935144709226167, -0.23977561910088327],
            [12.93599725696833, -0.23582564444321677],
            [12.941537504732736, -0.22748519040366716],
            [12.947660063082086, -0.22054686409702218],
            [12.95019745088855, -0.21405270366959844],
            [12.955552493079344, -0.19148297634797024],
            [12.955470703935772, -0.18603779671737544],
            [12.958112911442772, -0.18019602016691808],
            [12.960412247910417, -0.17175949231416432],
            [12.96461942878909, -0.16467451233672314],
            [12.965741459999022, -0.1481153774870511],
            [12.973017012773639, -0.13869220296687812],
            [12.977582994621919, -0.13089546952824654],
            [12.98005022717461, -0.1246568083609165],
            [12.98902247449541, -0.11089037371320401],
            [12.991354875046298, -0.10936237080005899],
            [12.93255220274007, -0.03760842954728565],
            [12.926718177377252, -0.023905348063537932],
            [12.934092611650817, -0.01355986159609417]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.81235860393329,
          "lat": 37.557107466587375
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51023"],
        "coty_name": ["Botetourt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Botetourt County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01674418"
      },
      "bbox": [
        12.926718177377252, -0.32721028762134174, 13.357312379014855,
        0.16614979899089835
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.737664284129352, -0.1524765763175489],
            [14.73775446099995, -0.14992885612264986],
            [14.745640203768064, -0.14636265214717334],
            [14.762249680928694, -0.1457474947510366],
            [14.767567332421848, -0.1470328115260945],
            [14.774992216245248, -0.14508755618553512],
            [14.782138427171184, -0.13562570715437028],
            [14.787621489615292, -0.13248281360856815],
            [14.790565352997996, -0.12336636200180984],
            [14.795994199179656, -0.11839174247340915],
            [14.798389165439739, -0.11421247938814423],
            [14.802201124150468, -0.11302216242252691],
            [14.805446930645232, -0.10811193848603284],
            [14.814301257807644, -0.10785331417871784],
            [14.817166277926606, -0.10271728763778742],
            [14.813805843332686, -0.10101801842904856],
            [14.813422957039089, -0.0967080278492596],
            [14.815046360362375, -0.09298497012310698],
            [14.818456136705182, -0.09374858071338875],
            [14.822658029242008, -0.09031829455048705],
            [14.822002305352687, -0.08653166574619232],
            [14.832573236225626, -0.08446812771390408],
            [14.831529633959113, -0.07934054480287893],
            [14.835288013691438, -0.0779342883700092],
            [14.83379013585933, -0.07340579336075194],
            [14.835969979087807, -0.06912769088015576],
            [14.839319982757345, -0.06809211019840396],
            [14.836011260628707, -0.06319642611739616],
            [14.836144145657475, -0.05869999753621096],
            [14.8427381711507, -0.058580422851950815],
            [14.84918291959192, -0.05147128324909261],
            [14.855833097467224, -0.05303411078237984],
            [14.859264163025976, -0.05246106914734042],
            [14.86093596423509, -0.04885956024462018],
            [14.86384555958005, -0.04734710119863716],
            [14.872983033129257, -0.05272223148102085],
            [14.87710129108322, -0.062380646445733975],
            [14.884962335726966, -0.06530494164245086],
            [14.886851547222216, -0.06792874956944733],
            [14.891376738026956, -0.06744430284486315],
            [14.894726892470418, -0.07003956729325911],
            [14.896887618730187, -0.07477291993653416],
            [14.899841412353469, -0.07573148098705097],
            [14.905857356085669, -0.07303954590876645],
            [14.906955421787607, -0.07888803489025235],
            [14.910804649709439, -0.07942440605440103],
            [14.913596012413889, -0.08411387450979295],
            [14.923545647808009, -0.08084924223099968],
            [14.932255279373551, -0.07975156166939523],
            [14.94060231004293, -0.08179205913131485],
            [14.944537094613583, -0.08679493907149384],
            [14.950244952532318, -0.0847013889278528],
            [14.954125620769284, -0.0808864268137082],
            [14.95918519176698, -0.07876851614736906],
            [14.96082204710951, -0.0762547091527482],
            [14.971143260913328, -0.07310040778961666],
            [14.976336008972456, -0.07291865064862273],
            [14.986329861076353, -0.07018384274883273],
            [14.99682082257303, -0.07075008485000772],
            [15.001524390806901, -0.06945383378184555],
            [15.002967511302593, -0.07653312085489594],
            [15.006306878484754, -0.07575956217255014],
            [15.008307121110366, -0.0809870667892866],
            [15.006797665860718, -0.08770224608385847],
            [15.00834633145311, -0.09498501480905537],
            [15.006796906716945, -0.10342996843996069],
            [15.023944468677385, -0.10418090045670367],
            [15.02866630697701, -0.1071977916153957],
            [15.03161162413424, -0.11443144305932787],
            [15.029557770250827, -0.11515409525547919],
            [15.031411156120068, -0.12321124198959434],
            [15.040385327450506, -0.11976846423940118],
            [15.044527287141287, -0.11400060426495372],
            [15.049067835103138, -0.11378926004348741],
            [15.054112398055397, -0.12995624109914478],
            [15.063175772314455, -0.1713840262971481],
            [15.073045562593002, -0.2252847375948813],
            [15.079132799871491, -0.2469130062910017],
            [15.084538798677297, -0.28984455862190067],
            [15.050312803508508, -0.32437259630363846],
            [15.025497412482778, -0.3490972652966388],
            [14.93765704819395, -0.4358799929804188],
            [14.93572418968642, -0.4376556755326271],
            [14.929087670620785, -0.4354304009513909],
            [14.924361902793775, -0.4298328373326299],
            [14.919338383027407, -0.4324834253913085],
            [14.919931398385273, -0.43622839178242445],
            [14.925264620037174, -0.438813384629184],
            [14.92512005101058, -0.4425051569095024],
            [14.920858307879952, -0.4447751258370798],
            [14.915788229617766, -0.44268562818848417],
            [14.912454039258957, -0.4384407326404275],
            [14.912912347344518, -0.4311251597616603],
            [14.911814435266493, -0.4269141359875642],
            [14.90793117616061, -0.4222107098039787],
            [14.90483794005142, -0.42650959097816454],
            [14.902167223861367, -0.42707062162358944],
            [14.897573367451665, -0.4278097422394043],
            [14.885881653281906, -0.4200866259682323],
            [14.878166309041031, -0.41942694993406004],
            [14.874272894009753, -0.4216224956829595],
            [14.871393122697228, -0.42065451510630353],
            [14.864618458289748, -0.4118544784388591],
            [14.855227214930931, -0.4160412017345113],
            [14.85233544717939, -0.41406379156838014],
            [14.852788386186266, -0.40825540380734],
            [14.851035757340975, -0.40339503946877775],
            [14.8439638190005, -0.3988443082433522],
            [14.838499602110964, -0.38922389671829205],
            [14.830053221769344, -0.3880008220883181],
            [14.82854402924154, -0.38379949378537437],
            [14.821666811052673, -0.37648053553470007],
            [14.81471931380982, -0.38076770300567936],
            [14.808608821883203, -0.3762815989084245],
            [14.807201788137045, -0.3692595022946054],
            [14.803157130174815, -0.36392436341724893],
            [14.797994324677767, -0.36325461106421536],
            [14.795484708060027, -0.3653648632986359],
            [14.79154829082591, -0.3649749497800778],
            [14.789523745393458, -0.3616487704029423],
            [14.785497979065005, -0.36186422512251726],
            [14.778549378348133, -0.3586228774857496],
            [14.766861063596329, -0.36199409229782625],
            [14.75824417548528, -0.3571295123043842],
            [14.747836781314406, -0.35751513653603345],
            [14.742827528484115, -0.35432032412434716],
            [14.739501729163665, -0.35435378006613855],
            [14.733988989003407, -0.3609986360644673],
            [14.729893894370958, -0.36193822252490737],
            [14.724646985050914, -0.36110716009366883],
            [14.721989939291745, -0.36405652733373756],
            [14.717519965558072, -0.3629381391248961],
            [14.71477342741866, -0.3651414577806072],
            [14.70898287151665, -0.364655905713987],
            [14.706535874024702, -0.36865507515887563],
            [14.703911316647652, -0.36856905968174025],
            [14.700560084159308, -0.3575639528205442],
            [14.672340374544435, -0.2427511951543039],
            [14.666099140689584, -0.2164079229378769],
            [14.671631781720116, -0.21297498945681223],
            [14.675452732306463, -0.21383193069155257],
            [14.687902816660426, -0.20555405059678775],
            [14.692035404981509, -0.19827604174795072],
            [14.696128275847107, -0.19359689072009778],
            [14.697043132637823, -0.18956251750018915],
            [14.704775115798629, -0.18674317991658432],
            [14.708607867028215, -0.18244246045437282],
            [14.714025533336432, -0.17997499515557439],
            [14.720028991087132, -0.18200846578201965],
            [14.723100413379587, -0.1814641899846723],
            [14.728175258602722, -0.17788333521180205],
            [14.732835952675492, -0.17082361825199394],
            [14.73293476829769, -0.1622265608492043],
            [14.736336944231976, -0.16022893891120568],
            [14.735761928613853, -0.1557541563913161],
            [14.737664284129352, -0.1524765763175489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.63226329091604, "lat": 37.0759422720605 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51053"],
        "coty_name": ["Dinwiddie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dinwiddie County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01690739"
      },
      "bbox": [
        14.666099140689584, -0.4447751258370798, 15.084538798677297,
        -0.04734710119863716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.189705143078612, 0.5795179350820083],
            [14.21568513030431, 0.5690694523388413],
            [14.223495851876578, 0.5672540699657753],
            [14.242450843637263, 0.5648752096262293],
            [14.253669227303051, 0.5628960848237817],
            [14.276868033921236, 0.5454898235056345],
            [14.287072093503705, 0.5423875411688757],
            [14.302144467724327, 0.5429400370961718],
            [14.320423548770359, 0.5362808673058912],
            [14.343839305863298, 0.5293766431101091],
            [14.394316723263874, 0.5148835552035298],
            [14.395541199688731, 0.5143741319048916],
            [14.395570048566698, 0.5114867394960411],
            [14.352293726345824, 0.3604356064548393],
            [14.351350459705296, 0.34500085831876465],
            [14.347830148675117, 0.34519773670542486],
            [14.340156917330733, 0.3419258937025666],
            [14.333706747381688, 0.33659492682123915],
            [14.329771507929665, 0.32840014455954497],
            [14.315259435738575, 0.31234269266569414],
            [14.308806672333157, 0.3026607543985033],
            [14.307531753865621, 0.2987176107624598],
            [14.307454678022603, 0.28447625782472846],
            [14.304721786544912, 0.2798556304338442],
            [14.300367251155619, 0.2756941921804792],
            [14.286310339510482, 0.27421866077397017],
            [14.27992592111988, 0.27521946365303934],
            [14.2633991575449, 0.2840760247143021],
            [14.258316772443845, 0.28600323482807877],
            [14.249800527834015, 0.2868551953966915],
            [14.243830625581834, 0.2851141500585322],
            [14.23347776495192, 0.28717263597058035],
            [14.223940626720152, 0.28702256202714166],
            [14.208991877624202, 0.29039425435721505],
            [14.197107238286165, 0.29806205505227457],
            [14.185954216507369, 0.29891290545531113],
            [14.18139270131061, 0.29753041909857175],
            [14.175196173955026, 0.29789041871442296],
            [14.164586642582586, 0.29598708327186174],
            [14.161508758258881, 0.29856577855193195],
            [14.15057327631103, 0.2988799863665707],
            [14.14072141720942, 0.30228607886844355],
            [14.136698905144675, 0.30500334248638294],
            [14.128714028419369, 0.30626241564284645],
            [14.125169173384968, 0.30895538056548816],
            [14.114628971068731, 0.31242385878629636],
            [14.108953120665495, 0.3172087499183161],
            [14.097584803790024, 0.33333197654592767],
            [14.093195441158201, 0.3419095379568261],
            [14.090903934523933, 0.3444921112637214],
            [14.086899302726902, 0.345009281354044],
            [14.099739931885027, 0.37374926409723536],
            [14.126515206006431, 0.4347034258922963],
            [14.156546119124606, 0.5032244619857523],
            [14.189705143078612, 0.5795179350820083]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.27728522794764, "lat": 37.84192820797797 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51065"],
        "coty_name": ["Fluvanna"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fluvanna County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01494061"
      },
      "bbox": [
        14.086899302726902, 0.27421866077397017, 14.395570048566698,
        0.5795179350820083
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.938543392316529, -0.5499920786270752],
            [12.942678008135807, -0.5442368175228657],
            [12.942127592305907, -0.5403413868291534],
            [12.945770614105793, -0.5393952391867236],
            [12.949934539112382, -0.5361410648061425],
            [12.952947642145295, -0.5318295548840206],
            [12.951065207861387, -0.5221338572631649],
            [12.952837917932149, -0.5194989307307727],
            [12.957244941286204, -0.5190865947953706],
            [12.963602991307864, -0.5152016933671538],
            [12.962603638220923, -0.5110594785034552],
            [12.965173136984859, -0.5054611554759808],
            [12.971254511469626, -0.5061022297291113],
            [12.975388510057439, -0.5081485235392607],
            [12.975928422439942, -0.5043747412524404],
            [12.98407659904543, -0.4990368793078383],
            [12.991650825924042, -0.4978054805555456],
            [12.999614527545523, -0.493285438683902],
            [13.003811516438258, -0.48944009429148183],
            [13.006112751094854, -0.48541520942562816],
            [13.012496960714122, -0.4888126801398176],
            [13.023143542829942, -0.48467321873477315],
            [13.026998053341892, -0.48902868896312324],
            [13.030852335249241, -0.49070481658992654],
            [13.028416658592064, -0.49696362143221423],
            [13.032941238210803, -0.5045602591870241],
            [13.040460152663767, -0.5021616908338578],
            [13.041270988886144, -0.5083471582480881],
            [13.043348647158458, -0.5112364380535808],
            [13.054754037994742, -0.5094700702199273],
            [13.05736797384045, -0.5128054887915529],
            [13.061877352242599, -0.5122916617900674],
            [13.065232194429727, -0.5138055808864702],
            [13.0718799504911, -0.5103447131511004],
            [13.075910475684786, -0.4988608009350945],
            [13.081715727592368, -0.49688729772882373],
            [13.082364123817449, -0.4939670446615337],
            [13.087272734954258, -0.4884697797548207],
            [13.09384095740567, -0.48486938895177384],
            [13.097487008696966, -0.4798582940366764],
            [13.099332292669255, -0.47458208877483776],
            [13.098172772734173, -0.46754017642921214],
            [13.101225789794137, -0.46450457867770845],
            [13.105999707431055, -0.46364119900611506],
            [13.110331192151879, -0.4604633157656297],
            [13.111768243540647, -0.4548834718956846],
            [13.108338530800902, -0.4429041453180091],
            [13.113263964041389, -0.44106348547268137],
            [13.11534478335349, -0.43104710063414065],
            [13.12029891716889, -0.4274450292313053],
            [13.122520913537919, -0.42386199821627163],
            [13.130834765630478, -0.42041275472871803],
            [13.132766569859886, -0.42416091298570013],
            [13.13821031942553, -0.4216505993190909],
            [13.136791290248002, -0.4130108199964289],
            [13.140146389141165, -0.4107181332825834],
            [13.140418420310965, -0.41282082091261885],
            [13.145188305969716, -0.4189287419989395],
            [13.15278905531266, -0.41813386588763723],
            [13.154361315160216, -0.41417350592269025],
            [13.159613970025386, -0.4068932793509338],
            [13.16259243130242, -0.4060483195888738],
            [13.170192463730674, -0.41091531315699886],
            [13.1722154549013, -0.4142413735954218],
            [13.175725818500135, -0.4147275418536096],
            [13.179791263849937, -0.4091539649433292],
            [13.180112136644809, -0.39804144582920425],
            [13.183271004601982, -0.39554667733368265],
            [13.18825233270839, -0.3946681188350758],
            [13.191425554901198, -0.3956428812197162],
            [13.192229247140716, -0.4025721513090038],
            [13.196723161384021, -0.4061552945043384],
            [13.198461499342585, -0.4111324118387006],
            [13.194499196042464, -0.4136494143031632],
            [13.198929661313668, -0.4239464710091868],
            [13.20528200296061, -0.4275942347583202],
            [13.212064585469138, -0.4284930375093059],
            [13.21579746557043, -0.4340080175087699],
            [13.229911269907255, -0.43228518635983154],
            [13.235610694317014, -0.4335935385771098],
            [13.23942351940969, -0.428471872166243],
            [13.242872480694725, -0.4269337431461263],
            [13.246492602868903, -0.42895847313852625],
            [13.248350599159664, -0.4363838689423184],
            [13.257394832204296, -0.44923652788095236],
            [13.256371573820164, -0.45325941785494706],
            [13.260691493461232, -0.4597984427553225],
            [13.261211592479361, -0.46250179766012567],
            [13.265364038781152, -0.46696384697393606],
            [13.269936715028045, -0.4626898088254938],
            [13.268712096299442, -0.4599629921937261],
            [13.26371409527366, -0.4550634639559253],
            [13.267668267019, -0.45351680132025085],
            [13.276773163516767, -0.46468498421257676],
            [13.27867181053125, -0.46409763831109235],
            [13.281107383620334, -0.4577593961037643],
            [13.283742168601663, -0.45791632027248086],
            [13.290565445490106, -0.4624140502728907],
            [13.296038194346862, -0.4672594787745679],
            [13.298114560426418, -0.47337680114734815],
            [13.30952188047055, -0.4825621282561208],
            [13.311559451954084, -0.4893675091338028],
            [13.316322964381058, -0.4961378084097632],
            [13.319157461272246, -0.49863253331783114],
            [13.321486275313307, -0.5047056543464792],
            [13.327149845203552, -0.5094733275548908],
            [13.334792208977445, -0.5136135574713072],
            [13.340567111174023, -0.5117978684835972],
            [13.34336301388018, -0.5127131412149828],
            [13.347277016310237, -0.5172574173162535],
            [13.348088406483514, -0.5206222081762193],
            [13.34573878610706, -0.5225850691530685],
            [13.340167821722025, -0.5219099719357406],
            [13.340250094884631, -0.5265525876433895],
            [13.352306598519533, -0.5355517053078171],
            [13.35611441183042, -0.5374024023717426],
            [13.364951843459798, -0.5453332373323648],
            [13.368526610282688, -0.5502639077803559],
            [13.363462600206315, -0.5573369813440572],
            [13.368623060747893, -0.5589207634214362],
            [13.366437686174047, -0.6024096412120724],
            [13.366049043775304, -0.6282293974219292],
            [13.364986027575656, -0.7194825724852183],
            [13.364521358882815, -0.7503163074582613],
            [13.354419524543482, -0.7676466608011576],
            [13.354119309467274, -0.7742566399374105],
            [13.349769379796003, -0.7774709560073461],
            [13.34715324361216, -0.7823319540769246],
            [13.342303008005306, -0.7817389272423265],
            [13.33737901686094, -0.785359309337768],
            [13.333612220369403, -0.7859098416452329],
            [13.329951276294654, -0.7842901880768659],
            [13.319215776855888, -0.7919897041667954],
            [13.314809282314794, -0.7967481746139581],
            [13.308168409713694, -0.7978970718391184],
            [13.301249010692537, -0.8044209757074082],
            [13.29603580114022, -0.8077806799127348],
            [13.295229314095893, -0.8124277772214906],
            [13.292728643701862, -0.8137817575160692],
            [13.29194594497815, -0.8190393260805714],
            [13.289102498152591, -0.8216816852209962],
            [13.290629877262035, -0.8263364453346533],
            [13.285101125306234, -0.8297494785046803],
            [13.282140817681764, -0.8340507135020078],
            [13.279343767901207, -0.8304354758587668],
            [13.280704683366203, -0.8271273926374021],
            [13.277966820651892, -0.8243204499217057],
            [13.274684477968128, -0.8290877250648956],
            [13.272223397416735, -0.8269509998591564],
            [13.267459619164338, -0.825928199463212],
            [13.264226389022049, -0.8277146393146132],
            [13.259926228685647, -0.8251773435560994],
            [13.255752891354705, -0.8280472656339725],
            [13.249440639796388, -0.8357922217033257],
            [13.179873732005134, -0.8306939992593841],
            [13.0956277243804, -0.8245557399478493],
            [13.088332437320748, -0.8238082042367044],
            [13.085696116547327, -0.8663359428822885],
            [13.080428854255254, -0.8630431856104099],
            [13.075427735406267, -0.8639369535199133],
            [13.073565945779677, -0.8667379256902448],
            [13.08065128751371, -0.8707178650272577],
            [13.084020255109154, -0.8695152301162101],
            [13.085783996278554, -0.8723583167878721],
            [13.083412291060162, -0.8755256469787248],
            [13.076917606500297, -0.87693091687124],
            [13.071704252736474, -0.8756301674637295],
            [13.067706919034105, -0.8727734057786722],
            [13.061860282717939, -0.8655455038633092],
            [13.059458922044717, -0.8596697258979049],
            [13.055973720226962, -0.8569796565661634],
            [13.045404909470541, -0.8511763340208773],
            [13.041796893377521, -0.8467147284603589],
            [13.035283383532768, -0.843865757814023],
            [13.032610241378972, -0.8408941085747319],
            [13.033313703549979, -0.8337840619460859],
            [13.02749448193643, -0.8334485166007871],
            [13.026587963779757, -0.8279080488664208],
            [13.03346723478519, -0.829198723001498],
            [13.034227375849149, -0.8218567822264813],
            [13.027337141606559, -0.8179080768031287],
            [13.019430965744679, -0.8166790007459016],
            [13.015288429877804, -0.8209994410594317],
            [13.00578236833047, -0.8214040069592998],
            [12.929466051442569, -0.8160147958169575],
            [12.928514414103498, -0.8162379577286826],
            [12.897193077037697, -0.8136687387385053],
            [12.92088273137958, -0.7796096485939221],
            [12.918488845635515, -0.7603881405346898],
            [12.92287855989756, -0.7585632223856132],
            [12.9253171479744, -0.7494429993085884],
            [12.926328840000242, -0.7377591970804105],
            [12.929335335341381, -0.7364147088327018],
            [12.930669937034658, -0.7280885106903576],
            [12.933135058300294, -0.7243951276384509],
            [12.938301514766192, -0.7220441498609779],
            [12.944671579852528, -0.7273345615285174],
            [12.94729363085854, -0.7272619828701364],
            [12.949156022249328, -0.7234820060512555],
            [12.954819235305097, -0.7248875579572822],
            [12.953722732449782, -0.7193388182522158],
            [12.954581463863217, -0.7163981849850931],
            [12.9594761802884, -0.709714425577028],
            [12.958303877730799, -0.7054572022385921],
            [12.953166247566383, -0.6996665987074832],
            [12.950579798801382, -0.6940850867061218],
            [12.955136458928045, -0.6903577546713737],
            [12.954555731483174, -0.6876584369837324],
            [12.966392683799834, -0.680013780908598],
            [12.962067562899684, -0.675586779762391],
            [12.95992544381815, -0.6765079208007709],
            [12.953880414359253, -0.6752894305068226],
            [12.95421484006881, -0.6669828386152847],
            [12.962710270272348, -0.6668635274774724],
            [12.96625031361906, -0.6637610993344435],
            [12.966917086554767, -0.6594219982798813],
            [12.969390167525937, -0.6564777963664006],
            [12.96561043159708, -0.6535164254199205],
            [12.968452143084575, -0.650990244798013],
            [12.966521671559716, -0.6455185819334803],
            [12.97222003850836, -0.6442559563054585],
            [12.971782431977454, -0.6409416607813327],
            [12.967189671915214, -0.6390801527644451],
            [12.966764783768642, -0.6337639984207369],
            [12.963536637656848, -0.6302744279255169],
            [12.964617426344482, -0.6244646275481243],
            [12.954411121523561, -0.6161845674857106],
            [12.956098464801519, -0.6081828077451422],
            [12.960684607803334, -0.6048637017216251],
            [12.960091828555356, -0.6021059303284434],
            [12.963243634968398, -0.5966591704154264],
            [12.962014545287932, -0.5920028852053802],
            [12.954010196591266, -0.579705396948039],
            [12.956136584642246, -0.5759932524932035],
            [12.95489445244553, -0.5726200561888176],
            [12.946399321183762, -0.5659761320286488],
            [12.944486868889648, -0.5634080443650795],
            [12.946126145982511, -0.5602052439509609],
            [12.944341503404488, -0.5548325650062532],
            [12.941236779188525, -0.5499414812224394],
            [12.938543392316529, -0.5499920786270752]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.88099366439499, "lat": 36.99195065146413 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51067"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01494434"
      },
      "bbox": [
        12.897193077037697, -0.87693091687124, 13.368623060747893,
        -0.3946681188350758
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.97563454014695, 0.9658453193633746],
            [13.977086284252517, 0.975383893221993],
            [13.980675524859723, 0.9776377858271106],
            [13.978607102889153, 0.9838539683845615],
            [13.98079550010955, 0.9933770946596648],
            [13.985194067353886, 0.9943239147428404],
            [13.987514871535376, 1.0020984149571879],
            [13.986208619528615, 1.0067927768478224],
            [13.98900193010415, 1.012732926737252],
            [13.989258702288591, 1.0207180661828033],
            [13.990756740947619, 1.024073842095246],
            [13.996357108778014, 1.016793146859559],
            [13.999287138939465, 1.0109991751444385],
            [14.007202999011671, 1.0057948825589238],
            [14.009122525275345, 1.001402198599163],
            [14.007801787533419, 0.9986460914507469],
            [14.009423569248552, 0.991169771844383],
            [14.01250580692868, 0.9872830053713173],
            [14.01410857475048, 0.9807963392384152],
            [14.015092978848674, 0.9711331916036035],
            [14.012506553498476, 0.9663522634736446],
            [14.012115360360594, 0.9604378726981517],
            [14.015396903064241, 0.9545051659361976],
            [14.018095529859236, 0.9464174803289936],
            [14.023370833981692, 0.945003168232136],
            [14.027153031812356, 0.9415298535371607],
            [14.030226486853545, 0.9361059910506464],
            [14.028563985943158, 0.92981999787205],
            [14.028546315034465, 0.9200328913546663],
            [14.041248318876438, 0.9104061717618829],
            [14.045193870669127, 0.9031600853034779],
            [14.048647572950259, 0.9001219399676603],
            [14.053619679137114, 0.8923368406014766],
            [14.06263323307339, 0.8880722897882176],
            [14.063758920946755, 0.8855620060866318],
            [14.070005254653651, 0.8834300097029401],
            [14.074184112730546, 0.877796036711167],
            [14.077948264727766, 0.8775362600442868],
            [14.08653338648448, 0.8796133403679424],
            [14.088418727146491, 0.8776937327961053],
            [14.087680269077639, 0.8733184626307104],
            [14.091319367097066, 0.8713736160884091],
            [14.09146379562477, 0.8674208543769071],
            [14.095573460398507, 0.8654607120505308],
            [14.090001055197398, 0.8626065457072027],
            [14.09165536449205, 0.8548977166269428],
            [14.095192332166492, 0.85546814659986],
            [14.09921551332824, 0.8521573032439587],
            [14.105112452973295, 0.8534107646085343],
            [14.106363862726738, 0.8459806939822158],
            [14.11653897123238, 0.8446053027447118],
            [14.120544776473322, 0.8389228616241948],
            [14.12732666858852, 0.8392686435055147],
            [14.130940057401242, 0.837955328550552],
            [14.133901436856258, 0.8426357675962225],
            [14.142167014509745, 0.8405066222588339],
            [14.141094021697553, 0.8456103192385003],
            [14.146322322660039, 0.8466815205940594],
            [14.147873812737902, 0.8495517922388225],
            [14.153650272850932, 0.8462295593244946],
            [14.153971565342463, 0.8458976276388502],
            [14.115380960886354, 0.7636599232921556],
            [14.10889945042039, 0.7468755600371203],
            [14.091365920034514, 0.750314492459033],
            [14.086216164118552, 0.7507682475523545],
            [14.069490018015598, 0.7550576007101671],
            [14.048420533362394, 0.759332682725994],
            [14.029554653806954, 0.7627445325932336],
            [13.982101293042565, 0.7717969381536147],
            [13.924190918700129, 0.7837005351395605],
            [13.90168698677778, 0.7895460152294632],
            [13.866612170372163, 0.798123443642745],
            [13.868574649544216, 0.8029579611836509],
            [13.868739060034672, 0.8073530134057373],
            [13.87288651567349, 0.8152265974885607],
            [13.881777745351927, 0.8140353214282187],
            [13.886048710293856, 0.8161847635671233],
            [13.889023586679041, 0.824942727089748],
            [13.895447988093073, 0.8296143692887332],
            [13.907480358064833, 0.8354087111781426],
            [13.907028716746785, 0.8421506033673943],
            [13.910304708077781, 0.8463932093989649],
            [13.91065145247474, 0.8495595666733436],
            [13.915805752268776, 0.8553713367998906],
            [13.920398589077529, 0.8570387428327466],
            [13.92431274152272, 0.8606313612761136],
            [13.928543979524044, 0.8608685866363595],
            [13.932144963922948, 0.8643707828844508],
            [13.937788124862466, 0.866786774342688],
            [13.941128263224229, 0.8718647189058135],
            [13.937183025900623, 0.8836414542596601],
            [13.941449460078744, 0.8883616140129545],
            [13.943020559586413, 0.8948920952392299],
            [13.941684524906954, 0.8988739465062335],
            [13.944122854160192, 0.9022259402537819],
            [13.950680976618099, 0.9042270989021637],
            [13.956987102638399, 0.9088984117073594],
            [13.953673428211724, 0.9112933627155373],
            [13.955732942467275, 0.919223602267481],
            [13.957986884120132, 0.9211442673551244],
            [13.95763423705695, 0.9294260315258368],
            [13.958355127799686, 0.9340162488360465],
            [13.964808848358382, 0.9355109580357901],
            [13.969281642643535, 0.9420877754619912],
            [13.969151993622107, 0.9452206873529387],
            [13.972762332246123, 0.9496037598299711],
            [13.971379952383256, 0.9521890620663833],
            [13.975898911806363, 0.9602736190825538],
            [13.97563454014695, 0.9658453193633746]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.46680243297817, "lat": 38.29756717566683 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51079"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01480129"
      },
      "bbox": [
        13.866612170372163, 0.7468755600371203, 14.153971565342463,
        1.024073842095246
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.012608230891683, -0.6023908596028125],
              [15.015140527069205, -0.6042484073215942],
              [15.0206132022122, -0.617628354646907],
              [15.023835238897234, -0.6291910669928309],
              [15.030900934903991, -0.6308630537861202],
              [15.03629258597188, -0.6262038346242622],
              [15.042702187184796, -0.6249922273045673],
              [15.045241679824704, -0.6264463351172783],
              [15.049362194249262, -0.6197972206511703],
              [15.050187814326161, -0.6132306730298467],
              [15.059101473410141, -0.6138929252905636],
              [15.059682182126522, -0.6064462066923337],
              [15.057704594091945, -0.6063152330719088],
              [15.055840801485997, -0.594819668499324],
              [15.049428561475692, -0.5987549901171022],
              [15.050235520915166, -0.5876326615251986],
              [15.052489735477838, -0.5808285855191571],
              [15.046308611919672, -0.5778449960955944],
              [15.043471991630089, -0.5862791222611791],
              [15.035634424174832, -0.5880389671557685],
              [15.02886595563217, -0.587290147991462],
              [15.02607781898446, -0.5916289209339729],
              [15.016245520297069, -0.5907755709933791],
              [15.016053110974248, -0.5962529448753325],
              [15.01275130590777, -0.5986044007528566],
              [15.012608230891683, -0.6023908596028125]
            ]
          ],
          [
            [
              [14.884554671328482, -0.789560014496757],
              [14.90683740377642, -0.715109030260629],
              [14.938921143195794, -0.6060555465373302],
              [14.931347941655138, -0.5698775014616447],
              [14.902167223861367, -0.42707062162358944],
              [14.90483794005142, -0.42650959097816454],
              [14.90793117616061, -0.4222107098039787],
              [14.911814435266493, -0.4269141359875642],
              [14.912912347344518, -0.4311251597616603],
              [14.912454039258957, -0.4384407326404275],
              [14.915788229617766, -0.44268562818848417],
              [14.920858307879952, -0.4447751258370798],
              [14.92512005101058, -0.4425051569095024],
              [14.925264620037174, -0.438813384629184],
              [14.919931398385273, -0.43622839178242445],
              [14.919338383027407, -0.4324834253913085],
              [14.924361902793775, -0.4298328373326299],
              [14.929087670620785, -0.4354304009513909],
              [14.93572418968642, -0.4376556755326271],
              [14.940936162966777, -0.4386646525598825],
              [14.945421089230548, -0.4362056017838379],
              [14.947716858613488, -0.43770736800591653],
              [14.947760146526264, -0.4424016996261689],
              [14.953422899039992, -0.4400889189127954],
              [14.95592642610225, -0.44065567415979007],
              [14.96148694182805, -0.44577837225343825],
              [14.964642694681745, -0.4511863943256325],
              [14.970141846681713, -0.4530725334054004],
              [14.973942606922048, -0.457199313120624],
              [14.980162722296189, -0.4542103598668014],
              [14.984026859377888, -0.45796932814742575],
              [14.9898130610748, -0.4602485115897502],
              [14.998369605195652, -0.45100890316219094],
              [15.009985586178445, -0.4487967410863471],
              [15.013358703001334, -0.4501588861377227],
              [15.022830864128466, -0.45131173964153115],
              [15.026598766285158, -0.45351452093138417],
              [15.033707501730772, -0.45211871763581796],
              [15.040802303985851, -0.44722406225278094],
              [15.043786333804622, -0.44162588513726],
              [15.050807479521911, -0.43222875105322267],
              [15.056523426509306, -0.4310034029023064],
              [15.063288078689627, -0.42787435850489935],
              [15.064425964583203, -0.467075509790915],
              [15.065633769235617, -0.5274674891303567],
              [15.066674658707585, -0.5732875593349263],
              [15.071459960999457, -0.5712712904824793],
              [15.075189452438439, -0.5727950672471913],
              [15.080619252155984, -0.572215121394872],
              [15.085487042852769, -0.5755378448229304],
              [15.093391532651015, -0.5742089106407431],
              [15.108145066796443, -0.5764479208311242],
              [15.111497221055291, -0.5740888122401916],
              [15.115924242980167, -0.5772964004087916],
              [15.094898701756627, -0.5985952857312034],
              [15.067252410371646, -0.6251402400921527],
              [15.074605518132202, -0.6226254943096946],
              [15.078703582083877, -0.6228749657437405],
              [15.081883436822896, -0.6262719859069784],
              [15.086371599170041, -0.6227932175374982],
              [15.088974720995699, -0.6258346075574067],
              [15.089945385395787, -0.6314363025282574],
              [15.094665641629552, -0.6305259758087316],
              [15.09803838148432, -0.6348979955076852],
              [15.102579172854972, -0.6365664223763716],
              [15.106167571286335, -0.6329596346731292],
              [15.107539946232533, -0.6361737993106225],
              [15.114528757698343, -0.6353325518599394],
              [15.126635969806333, -0.6315247161625533],
              [15.130432776169979, -0.6296669522657827],
              [15.13662890999653, -0.6287704989186088],
              [15.1450386728503, -0.6310400180608198],
              [15.145761199098464, -0.6331815562175089],
              [15.154354814893527, -0.6326586802215531],
              [15.157583031983219, -0.6374608359615407],
              [15.160280170017666, -0.638999744800232],
              [15.16347695811775, -0.636435932063927],
              [15.165169992037548, -0.6476650148237654],
              [15.171220255339549, -0.6431237801212932],
              [15.175001301911449, -0.6453229868174181],
              [15.17710979182079, -0.6488606868968823],
              [15.175563113684348, -0.6549786032340128],
              [15.179210526601858, -0.6565424561217317],
              [15.182448838571016, -0.661126826889559],
              [15.181507303625885, -0.6677215967249117],
              [15.185658053929586, -0.6675303614365046],
              [15.188448846386779, -0.6722991725945203],
              [15.193592157135646, -0.6718867320451024],
              [15.192900905556233, -0.676735846988708],
              [15.195137640886394, -0.6802230772730133],
              [15.196536721970304, -0.6871290399594501],
              [15.19876940183113, -0.6917491589225112],
              [15.195756896098164, -0.6989222510445975],
              [15.198584007586327, -0.7051461492971061],
              [15.197952164478584, -0.7080978474661367],
              [15.203895211310435, -0.7133207528166114],
              [15.204468532620373, -0.7173524563725941],
              [15.208766952593857, -0.7188272867622567],
              [15.214034103577127, -0.7162702870983816],
              [15.216787177526594, -0.7188784314496057],
              [15.220054250054103, -0.7181802470324841],
              [15.219490600533979, -0.7144296230837028],
              [15.227457831467422, -0.7135256910074892],
              [15.232406556089511, -0.7157200005857345],
              [15.238425536683794, -0.7152038300796665],
              [15.241879071695433, -0.717978448985763],
              [15.249393161287456, -0.7156103334759816],
              [15.251866393202851, -0.7179755930715447],
              [15.192651291263486, -0.7296209117850849],
              [15.113197651571857, -0.7451692479095163],
              [14.979522843167071, -0.7711288850206726],
              [14.898140271204092, -0.7868110483209715],
              [14.884554671328482, -0.789560014496757]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.55960091648677, "lat": 36.67593266281054 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51081"],
        "coty_name": ["Greensville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greensville County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01501122"
      },
      "bbox": [
        14.884554671328482, -0.789560014496757, 15.251866393202851,
        -0.4222107098039787
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [13.650848715169472, 0.877923712479377],
              [13.65654048981906, 0.874455931091968],
              [13.66037627705417, 0.8781825776144631],
              [13.662859505613172, 0.8774898203405115],
              [13.67273408712366, 0.8784763195298085],
              [13.672312137396172, 0.8919061513972275],
              [13.676014974988448, 0.89105614995034],
              [13.67544018319981, 0.8983190950678882],
              [13.680411004769105, 0.9021460698030174],
              [13.69015873068869, 0.9044671218868566],
              [13.692492344711374, 0.9076563795093067],
              [13.698297715888291, 0.9066818762502448],
              [13.71521904089147, 0.9166623198771253],
              [13.71259224749018, 0.9183656562812806],
              [13.71485503558745, 0.9315859503776013],
              [13.712910979068592, 0.9358125201588511],
              [13.708845764984316, 0.9386900089097929],
              [13.705880320939452, 0.938672992328082],
              [13.70539579568582, 0.9448401037903496],
              [13.703315152398323, 0.9504786963588467],
              [13.700533693527433, 0.9498713852498162],
              [13.693218129474609, 0.9452881682523081],
              [13.693168296251276, 0.9528922756378629],
              [13.69070778558679, 0.9576981282379783],
              [13.68192153464366, 0.9669704621458614],
              [13.671060646195029, 0.9696945297003289],
              [13.670158853145606, 0.9769695806098906],
              [13.667742469157258, 0.9774140365537014],
              [13.664355788383999, 0.9645275097770433],
              [13.662241233111464, 0.952786223222297],
              [13.661849495398544, 0.942732736632386],
              [13.652289256313283, 0.9449547935607219],
              [13.647964141429505, 0.9365560393750637],
              [13.646955629226381, 0.9291996062352038],
              [13.644885153022939, 0.9212767290021155],
              [13.649031723985425, 0.920069180834367],
              [13.657180465765173, 0.9098547995556234],
              [13.655669802440531, 0.9013539530778928],
              [13.657720302015887, 0.9004388374660866],
              [13.654283231243985, 0.8941841800883623],
              [13.650729922635403, 0.8800274041910603],
              [13.650848715169472, 0.877923712479377]
            ]
          ],
          [
            [
              [13.478636826459523, 1.2235723755678634],
              [13.478151013614417, 1.233229427002882],
              [13.480962171194472, 1.2354796903212624],
              [13.479919031791605, 1.2408307565994172],
              [13.475984387236434, 1.2452505423134477],
              [13.476032756816158, 1.2480287386823616],
              [13.48126808094833, 1.2555368952631991],
              [13.49164562927396, 1.2562798528498398],
              [13.495930370222363, 1.2581812859494035],
              [13.497954790961654, 1.2652142504536095],
              [13.4959766974486, 1.2700876803597396],
              [13.495293867975493, 1.2756062173883693],
              [13.497150366194644, 1.2848656139599348],
              [13.502473508636156, 1.288391335990484],
              [13.506141356125532, 1.2932597093909362],
              [13.506871239644756, 1.3057012004360813],
              [13.508765366257213, 1.3096974544322386],
              [13.506866691467069, 1.3148299819754243],
              [13.510771751568264, 1.320346950756571],
              [13.62119099540673, 1.2510156056598523],
              [13.67429417279576, 1.2167795634632883],
              [13.682561643050418, 1.212183227077795],
              [13.726585669010634, 1.1846493195299366],
              [13.76627094700255, 1.1604654719542125],
              [13.799181490457197, 1.1406115635876144],
              [13.823021640996284, 1.1255890015035062],
              [13.818126619688366, 1.1191866703183049],
              [13.815794387488289, 1.1109375072573253],
              [13.812732289584353, 1.0900250882637568],
              [13.811982145884874, 1.079447128458696],
              [13.812334875769018, 1.0710025693819092],
              [13.810113818313656, 1.0505896303161428],
              [13.80754500163057, 1.0406910241927834],
              [13.802635790838089, 1.024598351357543],
              [13.836161995559472, 1.0133207063281553],
              [13.84029982151936, 1.0126861517114643],
              [13.847700217730555, 1.020225322153065],
              [13.851607399430195, 1.018331151072318],
              [13.850613540392658, 1.0123855881010144],
              [13.852596091461281, 1.0083123693773874],
              [13.856020404669632, 1.0051277983160134],
              [13.86460763482264, 1.0007663595088354],
              [13.865538111014533, 0.9963200953694713],
              [13.86316631159568, 0.9903853627828557],
              [13.881947242887353, 0.9883142685566122],
              [13.88575072046089, 0.9843126566492963],
              [13.893840422498204, 0.9857340868034479],
              [13.900726601026081, 0.9845181877965176],
              [13.903405361379235, 0.98201231209252],
              [13.910404248450842, 0.9804525405700594],
              [13.915460736075946, 0.9808515944314808],
              [13.919261349435336, 0.9772871724934777],
              [13.921188576084605, 0.971262765164773],
              [13.927415937189963, 0.9616117894726903],
              [13.932217842009292, 0.9622684470546464],
              [13.934257813577974, 0.9664583486469135],
              [13.97563454014695, 0.9658453193633746],
              [13.975898911806363, 0.9602736190825538],
              [13.971379952383256, 0.9521890620663833],
              [13.972762332246123, 0.9496037598299711],
              [13.969151993622107, 0.9452206873529387],
              [13.969281642643535, 0.9420877754619912],
              [13.964808848358382, 0.9355109580357901],
              [13.958355127799686, 0.9340162488360465],
              [13.95763423705695, 0.9294260315258368],
              [13.957986884120132, 0.9211442673551244],
              [13.955732942467275, 0.919223602267481],
              [13.953673428211724, 0.9112933627155373],
              [13.956987102638399, 0.9088984117073594],
              [13.950680976618099, 0.9042270989021637],
              [13.944122854160192, 0.9022259402537819],
              [13.941684524906954, 0.8988739465062335],
              [13.943020559586413, 0.8948920952392299],
              [13.941449460078744, 0.8883616140129545],
              [13.937183025900623, 0.8836414542596601],
              [13.941128263224229, 0.8718647189058135],
              [13.937788124862466, 0.866786774342688],
              [13.932144963922948, 0.8643707828844508],
              [13.928543979524044, 0.8608685866363595],
              [13.92431274152272, 0.8606313612761136],
              [13.920398589077529, 0.8570387428327466],
              [13.915805752268776, 0.8553713367998906],
              [13.91065145247474, 0.8495595666733436],
              [13.910304708077781, 0.8463932093989649],
              [13.907028716746785, 0.8421506033673943],
              [13.907480358064833, 0.8354087111781426],
              [13.895447988093073, 0.8296143692887332],
              [13.889023586679041, 0.824942727089748],
              [13.886048710293856, 0.8161847635671233],
              [13.881777745351927, 0.8140353214282187],
              [13.87288651567349, 0.8152265974885607],
              [13.868739060034672, 0.8073530134057373],
              [13.868574649544216, 0.8029579611836509],
              [13.866612170372163, 0.798123443642745],
              [13.869744314609457, 0.7895405220627105],
              [13.866301034561726, 0.785868338627893],
              [13.874311874355644, 0.7817122002149665],
              [13.871824049319882, 0.773973520202364],
              [13.867337794098455, 0.7702702469068944],
              [13.867124112733467, 0.7667933115102239],
              [13.861437778225394, 0.7714414381187241],
              [13.8571514114152, 0.7727358110181273],
              [13.851565548758813, 0.7654778329422409],
              [13.846046440915114, 0.7612789488962441],
              [13.83917070541718, 0.7607323566025669],
              [13.83702107839329, 0.7523299555442611],
              [13.834211158143122, 0.7489673137080479],
              [13.82674102253822, 0.7435779390457052],
              [13.82697213041845, 0.7415845837051618],
              [13.820353042412313, 0.7294063448379118],
              [13.81819526409934, 0.7286518465264874],
              [13.815474505978978, 0.7235182560637203],
              [13.81366216998072, 0.7151955820374751],
              [13.759121281863942, 0.7473690634028517],
              [13.727178256069354, 0.7673280459272451],
              [13.725049204254312, 0.768043001793464],
              [13.709991340402237, 0.7786772226260801],
              [13.705487711406592, 0.7793109495840996],
              [13.69798743845514, 0.7878273791501168],
              [13.69349204599452, 0.7887546776647418],
              [13.68981990122249, 0.7921730287896493],
              [13.68483082434258, 0.7942578712867242],
              [13.678726830716908, 0.7922178289420784],
              [13.671922698926661, 0.788462454872042],
              [13.655619043373436, 0.7959450978007437],
              [13.574316081912464, 0.8353251872901547],
              [13.536933571591174, 0.8535560194435327],
              [13.40196171769228, 0.9187933795513068],
              [13.40399756796448, 0.9221606609397814],
              [13.402904795160197, 0.9263214197270515],
              [13.40972501060498, 0.9358210546661855],
              [13.410613397047065, 0.9468602884143328],
              [13.40686963595927, 0.950191861516614],
              [13.40772530095281, 0.9678813053702161],
              [13.410495293201068, 0.9717604017082324],
              [13.414003951426084, 0.9873610375951992],
              [13.41955426162987, 0.9976851064634653],
              [13.420500727398458, 1.006469592593565],
              [13.422706674426152, 1.0126076098136434],
              [13.426588947884389, 1.0159687357917322],
              [13.425432913551104, 1.0193516550136892],
              [13.426931622622256, 1.026798271887679],
              [13.429636468391502, 1.031897759332158],
              [13.431657452816289, 1.041695543309815],
              [13.429691657607826, 1.0504718718780028],
              [13.432405810572087, 1.0563928027008775],
              [13.430807597427137, 1.0609343281871135],
              [13.43225655617626, 1.0708277738669527],
              [13.434769657189163, 1.0766124196444424],
              [13.436348072802454, 1.0857138774851558],
              [13.439589975103951, 1.0899873578831707],
              [13.44182936609619, 1.1059790750044622],
              [13.446641644789045, 1.1098167583384873],
              [13.448803021312276, 1.1144088741647873],
              [13.452327831263005, 1.1135983599115145],
              [13.455514154251748, 1.1151017300082886],
              [13.460097021630693, 1.1123347338857923],
              [13.46970791359885, 1.1174465313620874],
              [13.468711423469394, 1.1260856769604375],
              [13.47103403352138, 1.1323520092100525],
              [13.471427131892217, 1.1454496091399082],
              [13.465485741664656, 1.1505346565013876],
              [13.462213150022729, 1.159998417755943],
              [13.464480625981164, 1.1744583998639757],
              [13.463215629680452, 1.1784353463614485],
              [13.466384667125268, 1.1939807788775267],
              [13.469470887391992, 1.2021264165809975],
              [13.4694934001219, 1.2076683619758917],
              [13.476665326485824, 1.2183962855002457],
              [13.478636826459523, 1.2235723755678634]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.8756916878475, "lat": 38.512022046627706 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51165"],
        "coty_name": ["Rockingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockingham County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "01488970"
      },
      "bbox": [
        13.40196171769228, 0.7151955820374751, 13.975898911806363,
        1.320346950756571
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.07900537388657, 9.390726927018662],
            [-14.071569877263586, 9.383955354281316],
            [-14.067412799681824, 9.37464079848351],
            [-14.076458025807282, 9.35988140928729],
            [-14.075541471618745, 9.35215793532048],
            [-14.069247615277376, 9.346097216452359],
            [-14.0597251478601, 9.344721393525013],
            [-14.055162208369245, 9.344977363357051],
            [-14.043161271939134, 9.348042082198049],
            [-14.03442120497029, 9.348788772820255],
            [-14.029691756179444, 9.347389901557406],
            [-14.021901395254973, 9.342418084092273],
            [-14.013200981118642, 9.334527562030733],
            [-14.003228328158954, 9.330978608074885],
            [-13.999916571554257, 9.328126428095523],
            [-13.99320570086633, 9.32627617309417],
            [-13.978538091549451, 9.332736582809213],
            [-13.971449831188144, 9.333924568018084],
            [-13.965110099431167, 9.331927650899031],
            [-13.96008214046162, 9.327536700287045],
            [-13.958293010687129, 9.319487179020676],
            [-13.960684017677869, 9.31163933601966],
            [-13.963399795376947, 9.308235463856228],
            [-13.96891374179547, 9.295457189346187],
            [-13.975019909818236, 9.284118174641936],
            [-13.983966262896221, 9.27785168032792],
            [-13.988861338690782, 9.272775577966085],
            [-13.991555411514323, 9.26049299228858],
            [-13.988600784908217, 9.252780800447358],
            [-13.982168806392101, 9.248282297750041],
            [-13.972654482037806, 9.24397402025545],
            [-13.968993796103009, 9.238782457356452],
            [-13.969754275991859, 9.231900851922136],
            [-13.971840911431435, 9.223467336776485],
            [-13.971481468393481, 9.217955481316054],
            [-13.964656328903333, 9.20686157573741],
            [-13.958217796188903, 9.203262720090528],
            [-13.953994269611407, 9.198535444904344],
            [-13.951966692670105, 9.191333512603629],
            [-13.952804187151685, 9.18852422673952],
            [-13.958895175063336, 9.180419723641473],
            [-13.959938220999668, 9.176582729273452],
            [-13.958168070788432, 9.172680409529978],
            [-13.952001832035267, 9.164394106478264],
            [-13.949153578332062, 9.158940829010634],
            [-13.946887427641926, 9.150412160568195],
            [-13.945508100223726, 9.13903967327902],
            [-13.945612486448248, 9.127512361434965],
            [-13.947201585432278, 9.122912465009886],
            [-13.957641290319437, 9.10853894727516],
            [-13.95876375133359, 9.102692057217494],
            [-13.957634110227652, 9.098668068211607],
            [-13.951839864764258, 9.091158657662254],
            [-13.946452753503637, 9.081402896266573],
            [-13.946304798444773, 9.075817551284583],
            [-13.943422843743068, 9.069203357001792],
            [-13.939489744133008, 9.067891566049731],
            [-13.937502156952592, 9.06516978341726],
            [-13.937008759056733, 9.058874610173739],
            [-13.938832929597472, 9.05518613465552],
            [-13.948198644126334, 9.0506758300337],
            [-13.951508165621116, 9.03950739189667],
            [-13.951245201462715, 9.035885388414718],
            [-13.953227224369513, 9.033054702033645],
            [-13.965678521098882, 9.023463923979076],
            [-13.969033978374384, 9.011776417294193],
            [-13.973691582405774, 9.003790553295348],
            [-13.97728996751204, 9.001375003851859],
            [-13.987419744355021, 9.00225349945627],
            [-13.991081234011949, 9.001068122232711],
            [-13.994530474067915, 8.997402479390384],
            [-13.995573205519115, 8.991133699147548],
            [-13.994595997618463, 8.985957139029011],
            [-13.989249939139633, 8.981500214968618],
            [-13.9809701372165, 8.978332514809768],
            [-13.976638462364798, 8.969778039177221],
            [-13.974144947053112, 8.962219629658938],
            [-13.976133358107118, 8.95600441014711],
            [-13.975204932004292, 8.946218596574578],
            [-13.971374955633136, 8.94002977269084],
            [-13.971085036047139, 8.934939208890414],
            [-13.973619595924614, 8.924284932728968],
            [-13.970128585761405, 8.918165774001952],
            [-13.969915344904903, 8.9133049572181],
            [-13.97120851603345, 8.899785939173215],
            [-13.970354314944897, 8.895086305804204],
            [-13.986929866485346, 8.89962216415433],
            [-14.017460911068879, 8.907092860325736],
            [-14.061892970680189, 8.916835263889066],
            [-14.074468250336954, 8.920302510164104],
            [-14.171027555133966, 8.942697816222982],
            [-14.25577620460146, 8.962101749717604],
            [-14.267318236016017, 8.96236597235918],
            [-14.291780684144948, 8.97016872545435],
            [-14.325137898544309, 8.977756476643734],
            [-14.352423765564994, 8.983174700631904],
            [-14.32469018520555, 9.10245535105088],
            [-14.283750469930524, 9.093135637397966],
            [-14.265062603194337, 9.174428097427226],
            [-14.24900565918272, 9.242583705513676],
            [-14.245402072565104, 9.25850454768622],
            [-14.246207628821773, 9.258685818750829],
            [-14.236297102413774, 9.301397823848733],
            [-14.225414211438054, 9.343852142834963],
            [-14.211190826936443, 9.34095728305383],
            [-14.20801288686392, 9.354917897559318],
            [-14.179332264406037, 9.348088918395444],
            [-14.176247740766568, 9.362072659239182],
            [-14.09071283511696, 9.341953197921075],
            [-14.07900537388657, 9.390726927018662]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.20301999377547,
          "lat": 46.19180708861896
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53003"],
        "coty_name": ["Asotin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Asotin County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01533502"
      },
      "bbox": [
        -14.352423765564994, 8.895086305804204, -13.937008759056733,
        9.390726927018662
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.134913320735297, 11.737816533957956],
            [-16.135389292944144, 11.741376040510728],
            [-16.150307664057056, 11.749780278017974],
            [-16.149575859999583, 11.75334954997049],
            [-16.15229644382423, 11.757945579228965],
            [-16.16065496387848, 11.757840775670905],
            [-16.16421211182654, 11.764038480339092],
            [-16.16741375391134, 11.766952523421914],
            [-16.172485118952594, 11.766942084078753],
            [-16.172304958730898, 11.771767732829272],
            [-16.1683077228683, 11.778822057700507],
            [-16.170382344018336, 11.781726577716345],
            [-16.167584703149423, 11.789659754852446],
            [-16.16551080232605, 11.78830916120809],
            [-16.163019796822287, 11.793010189261423],
            [-16.159307616705615, 11.795143070980945],
            [-16.156066114968077, 11.7926277597523],
            [-16.148918143316358, 11.79144066213917],
            [-16.146801722089638, 11.79306473758495],
            [-16.14640230208576, 11.79880198869702],
            [-16.144740882260734, 11.801068192958212],
            [-16.14451224873004, 11.808618192258331],
            [-16.14790319336309, 11.819194885363547],
            [-16.152346013577034, 11.826404202039132],
            [-16.14968094846905, 11.828464734798253],
            [-16.148954143760722, 11.833754764190104],
            [-16.151755062259696, 11.83843592395192],
            [-16.14934890819529, 11.845289340717288],
            [-16.146056611762756, 11.850473911131122],
            [-16.139704609696025, 11.856178839676463],
            [-16.13482177096743, 11.852695330872793],
            [-16.131078983771225, 11.85252911412927],
            [-16.13212985354639, 11.860454960414186],
            [-16.126413335051005, 11.870861557075495],
            [-16.12318377502801, 11.871328641331369],
            [-16.122018368336608, 11.877035612057247],
            [-16.12180802900313, 11.884668006941926],
            [-16.125739689227043, 11.887149767525957],
            [-16.131649049976605, 11.89398397021646],
            [-16.132225213404585, 11.901933970684839],
            [-16.12859466614372, 11.907980710203624],
            [-16.125377092052897, 11.911367446273177],
            [-16.123959323196612, 11.915968765141569],
            [-16.11722119354283, 11.923246640504422],
            [-16.105954980759076, 11.930200953876895],
            [-16.097768990975727, 11.92818698730099],
            [-16.092863448548506, 11.92575817407774],
            [-16.083515938749084, 11.92318725412809],
            [-16.07699514868549, 11.926325366553666],
            [-16.072335384590797, 11.923849708628918],
            [-16.070070492474855, 11.92496321017341],
            [-16.061138630265706, 11.923216057880246],
            [-16.058279894045242, 11.92092667096953],
            [-16.055421706083024, 11.921619826155757],
            [-16.049778081065703, 11.919756635118997],
            [-16.04695299155121, 11.924497765740007],
            [-16.045096145810096, 11.934206666457511],
            [-16.046024649511246, 11.941562247363558],
            [-16.041721588913713, 11.947661256985684],
            [-16.031982365341385, 11.944830974497627],
            [-16.02490496571176, 11.938861792852343],
            [-16.01357206008082, 11.934325039560806],
            [-16.011339537121422, 11.937366088996399],
            [-16.01066206877749, 11.943333081224235],
            [-16.007031016245406, 11.941774014027454],
            [-16.003798015671723, 11.944013258745741],
            [-15.997440972852422, 11.94466261993136],
            [-15.992526351565747, 11.940678117675565],
            [-15.990493798587842, 11.935691148768097],
            [-15.985176932384093, 11.93331688623387],
            [-15.979751344861441, 11.939244606210334],
            [-15.980597021791572, 11.94413049772367],
            [-15.976932940815649, 11.948799253328461],
            [-15.967943418805755, 11.949327990420025],
            [-15.957154971593038, 11.942464874599683],
            [-15.958392252918092, 11.938250820313279],
            [-15.953375556393816, 11.93267484883517],
            [-15.953574076223157, 11.930208299283127],
            [-15.950904587463894, 11.92485932808784],
            [-15.951534841609364, 11.922038472633087],
            [-15.957715021342887, 11.918185788392378],
            [-15.95782757323543, 11.915640334724586],
            [-15.950502436838473, 11.90457858580439],
            [-15.942371710743869, 11.899093823630295],
            [-15.92749266913495, 11.896987053014954],
            [-15.91759298618853, 11.898439929564224],
            [-15.915823957704669, 11.900624462932136],
            [-15.909755541806117, 11.901619076244652],
            [-15.902718874973742, 11.899537935659913],
            [-15.893386223426036, 11.90198742738928],
            [-15.88749438960013, 11.901061839345907],
            [-15.882202628907079, 11.90414863552331],
            [-15.880602019914264, 11.907533630941899],
            [-15.876383218210954, 11.907372880392408],
            [-15.87153066912797, 11.904110954218645],
            [-15.86485946711003, 11.902805370095598],
            [-15.84704563497927, 11.904171634570188],
            [-15.845956312144429, 11.899784361828052],
            [-15.847474589028726, 11.89424356240543],
            [-15.853883111823855, 11.890075551236857],
            [-15.85606047147701, 11.885096215156544],
            [-15.855682558357143, 11.881173454388183],
            [-15.857747555033722, 11.87726479465606],
            [-15.85211920998108, 11.873712976385907],
            [-15.842132368972166, 11.86538636727118],
            [-15.843099727149053, 11.86179745615357],
            [-15.848424006223839, 11.86382339159048],
            [-15.851414864627092, 11.860838788292265],
            [-15.856921313842308, 11.859272945035983],
            [-15.861955268268686, 11.852803156087008],
            [-15.861480376629943, 11.84856461707034],
            [-15.853810910332193, 11.842379017196158],
            [-15.852253537227675, 11.83656155596464],
            [-15.857593534953217, 11.836447091615875],
            [-15.86545155838101, 11.832582548637802],
            [-15.869919086964988, 11.826169627978798],
            [-15.87801286706522, 11.826545270465303],
            [-15.879890568663836, 11.82531198631026],
            [-15.877846748668606, 11.817662902875883],
            [-15.872493843036644, 11.811574271733672],
            [-15.873111877746837, 11.806092275922147],
            [-15.876084012780439, 11.804623465027234],
            [-15.875688931481506, 11.797741937393841],
            [-15.876739912482975, 11.789458881852001],
            [-15.872099180944085, 11.784572684469863],
            [-15.88076110882437, 11.773803843436072],
            [-15.874627224812352, 11.771152902332899],
            [-15.86487468178608, 11.769131965938087],
            [-15.861912898617359, 11.769545808960281],
            [-15.856146930400303, 11.763572772836527],
            [-15.851228199284897, 11.753670260894593],
            [-15.844604394264485, 11.750473501877986],
            [-15.842751021719518, 11.745789448661215],
            [-15.832945585181896, 11.738719369850019],
            [-15.831441343668516, 11.733646646089758],
            [-15.83198471160603, 11.723958804086994],
            [-15.836714027658052, 11.722276372280886],
            [-15.841236179108916, 11.714148211852205],
            [-15.846950565823576, 11.712870585172505],
            [-15.851124818374812, 11.71053227069617],
            [-15.854848265323092, 11.70556532695735],
            [-15.855835227563817, 11.696753040517006],
            [-15.859841282946274, 11.693492109602362],
            [-15.857496689780932, 11.688514235628187],
            [-15.84625901270197, 11.684064685452814],
            [-15.842181203461484, 11.677786011202878],
            [-15.839848732840316, 11.67598043843321],
            [-15.83729307311855, 11.670828379555937],
            [-15.824410911412189, 11.667379617916833],
            [-15.817876860749443, 11.67045833830572],
            [-15.813283549192617, 11.669969822584152],
            [-15.81106167097748, 11.667689446642772],
            [-15.808823559542141, 11.651790797365013],
            [-15.806436600696749, 11.648912100888706],
            [-15.80412984475332, 11.642881690554532],
            [-15.80090790275588, 11.638649915982118],
            [-15.798439523845506, 11.632345095161776],
            [-15.791607611821613, 11.627109433097106],
            [-15.791342244522513, 11.624669014684242],
            [-15.796114437956579, 11.622330453896186],
            [-15.79169045119803, 11.618714242527236],
            [-15.786451948181291, 11.611816939547463],
            [-15.781159327591347, 11.609666529855595],
            [-15.774052048724823, 11.602537879038188],
            [-15.774033330347404, 11.600577325235413],
            [-15.76976016849726, 11.59601130504104],
            [-15.764366993911658, 11.593373089078478],
            [-15.759713002805201, 11.588634617667125],
            [-15.75279537011829, 11.584799683089114],
            [-15.75046232003247, 11.579540845775753],
            [-15.750420410844939, 11.5746289939857],
            [-15.755720414384918, 11.571604901384564],
            [-15.753440296618633, 11.567510298597313],
            [-15.75243455215955, 11.561783234017982],
            [-15.746833209935055, 11.55828155081462],
            [-15.73595735001476, 11.557121305468101],
            [-15.734349144369553, 11.55419856085768],
            [-15.735397941439052, 11.550916111154434],
            [-15.733355978012748, 11.542190455903103],
            [-15.733604707634012, 11.537010176609424],
            [-15.738232534769718, 11.53138575664798],
            [-15.740449712720892, 11.52600359073085],
            [-15.743879259693264, 11.52283768934237],
            [-15.7463830301899, 11.516359236737209],
            [-15.750085891670325, 11.513658903160824],
            [-15.752854223675142, 11.506583295313735],
            [-15.754024322886803, 11.499672106513339],
            [-15.75002470653223, 11.496420159586737],
            [-15.750664363861668, 11.489524940381955],
            [-15.749085477914662, 11.485065142686414],
            [-15.744878942898858, 11.482631996716636],
            [-15.740844631443203, 11.477482108473902],
            [-15.737795127321089, 11.469238309709084],
            [-15.738831674581716, 11.467126331817687],
            [-15.735202104400583, 11.461561365878888],
            [-15.728049235538798, 11.462300434685744],
            [-15.724203365661463, 11.461112085123432],
            [-15.720193607149609, 11.463040903145878],
            [-15.715010019472329, 11.4611198732995],
            [-15.714599127317172, 11.456967178578022],
            [-15.709706568934559, 11.454048829795141],
            [-15.706487417485858, 11.448228512428875],
            [-15.706535758851693, 11.445326908111596],
            [-15.703747699974432, 11.440110971386046],
            [-15.698936085238444, 11.43821849236736],
            [-15.695462959734858, 11.429974914601882],
            [-15.692096500666315, 11.42702263340999],
            [-15.690786614948879, 11.422276425105109],
            [-15.688082835493045, 11.418303747485739],
            [-15.68908735564749, 11.414552516715533],
            [-15.685417409611471, 11.41286274365069],
            [-15.683549455109489, 11.408477080076734],
            [-15.679360993532889, 11.406926445540341],
            [-15.677113404673152, 11.401128456237018],
            [-15.67095570639162, 11.397666834415173],
            [-15.663122361944136, 11.395797067321224],
            [-15.660327899449024, 11.396319636401463],
            [-15.658834050307966, 11.391386544497694],
            [-15.64812327744991, 11.38291252977627],
            [-15.643979947937042, 11.382457655436024],
            [-15.643390604329923, 11.37931291785557],
            [-15.635416364561575, 11.376841778895662],
            [-15.634093592959061, 11.372530343506366],
            [-15.630232405507249, 11.367259651204673],
            [-15.632564948533823, 11.363168169072855],
            [-15.635243725686784, 11.36546977646607],
            [-15.642021434319327, 11.365256719765847],
            [-15.641920472085072, 11.361367303233132],
            [-15.644665400316159, 11.35816016974401],
            [-15.642898902034347, 11.355976828291638],
            [-15.644024126526322, 11.350810326495964],
            [-15.637212240493275, 11.34499651392254],
            [-15.629251458354156, 11.341867479037765],
            [-15.629045113281464, 11.336695397364156],
            [-15.622671292559328, 11.331035977511082],
            [-15.614682169414914, 11.32645451826769],
            [-15.612139600996375, 11.323279453726173],
            [-15.60931720517857, 11.315405821168477],
            [-15.608986442316636, 11.303681384493945],
            [-15.612391497061013, 11.298253172761328],
            [-15.603983750543282, 11.284502437138235],
            [-15.604132694289772, 11.281927083433096],
            [-15.6105450508232, 11.275677400273969],
            [-15.609389095057235, 11.27071187912292],
            [-15.606658598109364, 11.270391770597618],
            [-15.602861510165903, 11.264679915678375],
            [-15.599265924102914, 11.262369340462033],
            [-15.575157113191862, 11.256130805663535],
            [-15.482902331414923, 11.232799387890754],
            [-15.481698582891777, 11.230731738370201],
            [-15.480259515531122, 11.21865287565009],
            [-15.480361484243916, 11.213564661641106],
            [-15.483960744600259, 11.209536905753934],
            [-15.499938070196059, 11.199416455307238],
            [-15.505825335183959, 11.195077847538629],
            [-15.517446847885541, 11.191338470396685],
            [-15.526569892601081, 11.184442041440859],
            [-15.528116056369607, 11.177641604559149],
            [-15.526995199895188, 11.166894917623855],
            [-15.527655010787202, 11.162639081832856],
            [-15.534857638095925, 11.152677536417206],
            [-15.538989478117815, 11.1483279611468],
            [-15.549183123138397, 11.14337091979588],
            [-15.567294660641716, 11.140891526306872],
            [-15.569815478563406, 11.13950669138866],
            [-15.57765573068923, 11.121767777779887],
            [-15.58593825721555, 11.11174127655737],
            [-15.588240112391818, 11.109961091008564],
            [-15.592016198931622, 11.101457380025568],
            [-15.598481488189924, 11.094513596961875],
            [-15.6005127142165, 11.093707922455014],
            [-15.606665286778233, 11.085815799325223],
            [-15.610170960479433, 11.083889655203775],
            [-15.614673991808566, 11.083779462726412],
            [-15.619632535989062, 11.086108797973209],
            [-15.625821046951637, 11.086821763453703],
            [-15.638325144998472, 11.08659352754354],
            [-15.64419663130645, 11.084995261607355],
            [-15.657256728252017, 11.084175888924023],
            [-15.661117902852514, 11.083026311343573],
            [-15.673651197331807, 11.082743204534758],
            [-15.677721462340715, 11.08409587991925],
            [-15.684710138213703, 11.09341216831549],
            [-15.690456364432128, 11.098822769602132],
            [-15.698896226658453, 11.102642653366958],
            [-15.70746318270807, 11.102395494860824],
            [-15.72124651465293, 11.099552359380828],
            [-15.74280794519779, 11.09663254618962],
            [-15.755861129082307, 11.090458232835267],
            [-15.763363377282987, 11.083169389532973],
            [-15.768253729882431, 11.076753113873789],
            [-15.772478829811384, 11.067781319800883],
            [-15.772439625038363, 11.063449847373363],
            [-15.770001177889908, 11.05862174169579],
            [-15.769305820991747, 11.052012871211524],
            [-15.766228893803419, 11.044782142505634],
            [-15.766139744255128, 11.03064924823752],
            [-15.767128320367929, 11.025090013129725],
            [-15.773419144427653, 11.015926015139312],
            [-15.78341475069378, 11.010522837712779],
            [-15.78706226811743, 11.005849953017856],
            [-15.789451024695117, 10.998573404883157],
            [-15.794501156290213, 10.99684086600863],
            [-15.801078039339194, 10.989151303710816],
            [-15.804636605960955, 10.983814420419746],
            [-15.807100496605214, 10.977464691374207],
            [-15.806077939834204, 10.973516266901502],
            [-15.810049700159855, 10.962581135467413],
            [-15.811151012238698, 10.956639444830252],
            [-15.810990739226737, 10.95103069281269],
            [-15.814439041855277, 10.94755357079439],
            [-15.817008058724312, 10.94116043981425],
            [-15.82008173335415, 10.937246576437834],
            [-15.830420508118554, 10.930752125309393],
            [-15.837791471333803, 10.91844336261132],
            [-15.848686095282009, 10.914943918834258],
            [-15.858669847362993, 10.909846944235985],
            [-15.864831993626439, 10.904892292512804],
            [-15.866668241740948, 10.9012808306134],
            [-15.876034886583797, 10.889503007021053],
            [-15.88125079664266, 10.877369701397726],
            [-15.883192462198663, 10.875258134914843],
            [-15.888000511410118, 10.862912901652088],
            [-15.893808225143042, 10.85351061380167],
            [-15.897287184497124, 10.845754072699151],
            [-15.901669233732672, 10.83323512773897],
            [-15.90217836044419, 10.826303450938356],
            [-15.900833508099948, 10.821316742560363],
            [-15.901806091755159, 10.808569486404116],
            [-15.899468876974892, 10.799024803429255],
            [-15.898608477203037, 10.787439067035855],
            [-15.899457869857203, 10.774836225612308],
            [-15.897136472159769, 10.766846551744155],
            [-15.877974222068936, 10.750349621981423],
            [-15.867756146706427, 10.74482002098766],
            [-15.860715407458061, 10.743657094901087],
            [-15.855587844274414, 10.740580559699723],
            [-15.845333760092602, 10.736813947665668],
            [-15.831477359653732, 10.728231218690407],
            [-15.828726155047578, 10.727694904494674],
            [-15.82377524130908, 10.722427062086334],
            [-15.813322523712925, 10.718289590118053],
            [-15.810023207015085, 10.718255117396872],
            [-15.800659767723149, 10.71506080192473],
            [-15.794763689953973, 10.70699858863399],
            [-15.78888407545161, 10.693794386397533],
            [-15.78822362930191, 10.68989215947669],
            [-15.785711767023818, 10.68713316661848],
            [-15.780264302969876, 10.684740148706668],
            [-15.777975359501498, 10.676422976685492],
            [-15.786216470847235, 10.66394130524769],
            [-15.785439806580309, 10.659095508300839],
            [-15.787246389229344, 10.653443486606381],
            [-15.788128386537267, 10.645303776887467],
            [-15.7926052761892, 10.636553295569527],
            [-15.796466481131468, 10.624023014241562],
            [-15.798833670883562, 10.622280325374913],
            [-15.80319563543926, 10.610633546138704],
            [-15.912204885606167, 10.638158864151269],
            [-15.92635510223499, 10.641072151385703],
            [-15.99813122505836, 10.659351468801015],
            [-16.00180372409171, 10.668289766620061],
            [-16.00592984669705, 10.674632405224504],
            [-16.01363135040432, 10.67775080486672],
            [-16.019221761031446, 10.67820821029461],
            [-16.0228889839759, 10.683776955147813],
            [-16.02338551765595, 10.68660898628481],
            [-16.02940597536172, 10.695308980531134],
            [-16.029407924210844, 10.700750095474753],
            [-16.034829494154334, 10.708605657730375],
            [-16.038132035303363, 10.710235720371738],
            [-16.04384541858994, 10.717842318902779],
            [-16.047197788172948, 10.717119727966821],
            [-16.051715087479007, 10.720540081593866],
            [-16.050405190517488, 10.723525813613815],
            [-16.055307320896922, 10.731359968330672],
            [-16.06264639062965, 10.733611834766128],
            [-16.066355096410774, 10.736814803439502],
            [-16.067155863036955, 10.744616500362689],
            [-16.069175125242175, 10.750834660384276],
            [-16.07194518137578, 10.752143943249461],
            [-16.075033454911562, 10.748165459911148],
            [-16.076142775007806, 10.740405268437382],
            [-16.075714521649953, 10.735718458028572],
            [-16.08974719204702, 10.734507390840584],
            [-16.090665521578096, 10.730383748941643],
            [-16.094270557093434, 10.73254220451017],
            [-16.097458253398564, 10.73116202060545],
            [-16.104970843015646, 10.73742799140146],
            [-16.1025350176408, 10.741740319032589],
            [-16.101915323167642, 10.747124476759149],
            [-16.10539393117104, 10.75311661400571],
            [-16.103926062344264, 10.763976222946821],
            [-16.10834766904609, 10.765829649074217],
            [-16.116041582896273, 10.770699539601186],
            [-16.12161965903519, 10.770581520611929],
            [-16.122134906890757, 10.773537480651717],
            [-16.128343591959126, 10.778424782298764],
            [-16.134482400223792, 10.776730272631461],
            [-16.138679277785304, 10.77758482649995],
            [-16.14426691874743, 10.78076828784039],
            [-16.14916338086004, 10.780288212669898],
            [-16.154191469236306, 10.783957324300527],
            [-16.1587254511308, 10.78426358584231],
            [-16.16149084328615, 10.787267505542003],
            [-16.164915456562177, 10.794064987319455],
            [-16.168306004018522, 10.795896575653536],
            [-16.1727286182521, 10.80184857103869],
            [-16.173112111749546, 10.80621566653149],
            [-16.176863216438303, 10.811197409673854],
            [-16.18202835706975, 10.812527464784692],
            [-16.1833581830352, 10.815161462336983],
            [-16.187786385139955, 10.817644350108855],
            [-16.1897850772776, 10.821784024008386],
            [-16.190509042045566, 10.830446232078277],
            [-16.188266723310733, 10.836485649544423],
            [-16.19205930070291, 10.843955297334768],
            [-16.200465125746756, 10.846112831013503],
            [-16.205826333863197, 10.851505629656176],
            [-16.213026354327763, 10.855379113671544],
            [-16.22190368344088, 10.85742990358711],
            [-16.223695949379344, 10.863185629099249],
            [-16.227082841291658, 10.867970182288046],
            [-16.226269726011342, 10.873463101108486],
            [-16.228557402530093, 10.877196738840185],
            [-16.229336509084508, 10.882836140878435],
            [-16.237363827933187, 10.881977702163859],
            [-16.24637105667953, 10.888461562094092],
            [-16.253041480818432, 10.88449171116823],
            [-16.25428153397243, 10.88165399230481],
            [-16.259154120076488, 10.879574370712215],
            [-16.26520546289304, 10.885740493710363],
            [-16.268875485917235, 10.891147833454854],
            [-16.276851936239645, 10.88790225127257],
            [-16.280178077260018, 10.893526175795676],
            [-16.283470019517093, 10.896907251550902],
            [-16.286570398312083, 10.903049039522708],
            [-16.289120854129735, 10.902018887061775],
            [-16.293424570338356, 10.904081587789165],
            [-16.298218156393283, 10.903708148272818],
            [-16.30352003018082, 10.909197226585656],
            [-16.306525086132318, 10.914131936706655],
            [-16.301794345806606, 10.92806599185308],
            [-16.305758115202213, 10.933843065613418],
            [-16.30452064161586, 10.93808234292755],
            [-16.317533536930934, 10.945632166196093],
            [-16.31578481770599, 10.9505797946963],
            [-16.311132589545615, 10.95475623744508],
            [-16.315384566120937, 10.960517848084462],
            [-16.31605962434785, 10.966916653623425],
            [-16.321532203815522, 10.973288673422344],
            [-16.327839174140564, 10.977069352210254],
            [-16.32995907220771, 10.980298124870727],
            [-16.33459962428165, 10.993533587413136],
            [-16.33059524474955, 10.998870146426084],
            [-16.33214286639676, 11.006790654022351],
            [-16.338303254843954, 11.011077429080425],
            [-16.342810738433467, 11.012582468435944],
            [-16.348437041275403, 11.016365532205425],
            [-16.348663398714617, 11.021595673590628],
            [-16.35647506144647, 11.030452355941721],
            [-16.36184198075917, 11.031911861814827],
            [-16.364825869493735, 11.035226184365284],
            [-16.36751107951399, 11.043532619518437],
            [-16.372547358693232, 11.050216036761144],
            [-16.375326735686276, 11.051102302852206],
            [-16.375487375918794, 11.059384909351186],
            [-16.379571482390602, 11.067809890433889],
            [-16.380226629942086, 11.071322286703834],
            [-16.37725314293937, 11.075142481868562],
            [-16.37854582336777, 11.08290840042038],
            [-16.377568040109338, 11.086085255793973],
            [-16.379155662589937, 11.090790785222824],
            [-16.384845950182324, 11.092774335678742],
            [-16.388489160514162, 11.101235686159477],
            [-16.38622576631919, 11.103151996466154],
            [-16.388054017507603, 11.108096146886474],
            [-16.389060941693767, 11.115827889432838],
            [-16.387869293171132, 11.119707417376578],
            [-16.383227231519434, 11.120750493932874],
            [-16.382282834270974, 11.124088766032921],
            [-16.38419123880062, 11.130063092912948],
            [-16.387925729264197, 11.131421278304936],
            [-16.388720238859342, 11.136771762534842],
            [-16.38634480846373, 11.142211841072491],
            [-16.389137189263305, 11.150187264608443],
            [-16.385126260176985, 11.157839849311479],
            [-16.380859925137973, 11.159650930316221],
            [-16.37765192721533, 11.165023369012172],
            [-16.37801172766407, 11.178092660484854],
            [-16.37359943477695, 11.180984869478566],
            [-16.372026843612982, 11.184299114955518],
            [-16.361869490601606, 11.186569665878574],
            [-16.359478268853618, 11.185922039199317],
            [-16.350313955566627, 11.19013748570291],
            [-16.34449920507606, 11.196403880969912],
            [-16.338964032597143, 11.193749126825859],
            [-16.331041942252668, 11.195968979768141],
            [-16.328285162883958, 11.198299522372489],
            [-16.327205295654064, 11.20237556607],
            [-16.328537024423838, 11.206811877410015],
            [-16.33356353059471, 11.210523387123525],
            [-16.336371116230904, 11.214022439292338],
            [-16.336882261054164, 11.218994895248633],
            [-16.3347550692558, 11.223233538981415],
            [-16.32907871887061, 11.22868188570994],
            [-16.33048880990922, 11.233303922075239],
            [-16.334296044559878, 11.237032336394288],
            [-16.333982660162388, 11.249138893456855],
            [-16.33715127827088, 11.25079402214246],
            [-16.342473801966754, 11.250001059196627],
            [-16.344931388530515, 11.252277880894283],
            [-16.341694777802584, 11.25983342730854],
            [-16.34605218988124, 11.270145765627193],
            [-16.34479198830556, 11.27393991550997],
            [-16.344405762146526, 11.278219016081257],
            [-16.3378826634713, 11.27999723992121],
            [-16.335044434239286, 11.28429708918805],
            [-16.331547202633647, 11.286319738734608],
            [-16.322017761950164, 11.28886445298799],
            [-16.32075302141661, 11.292969361833356],
            [-16.315066885345797, 11.294061384667975],
            [-16.31098318684722, 11.301351805209752],
            [-16.301018702578812, 11.30940158568017],
            [-16.300217216989, 11.312784804552043],
            [-16.305304264395335, 11.318103642660882],
            [-16.30926283021241, 11.317769556199032],
            [-16.315852702822415, 11.319456689784573],
            [-16.324080049239583, 11.317890389135814],
            [-16.33130927007032, 11.321848537079392],
            [-16.332597658337875, 11.32964901925432],
            [-16.33857755010298, 11.332596227613845],
            [-16.3383299415649, 11.33585497670805],
            [-16.346422348128346, 11.338422481143793],
            [-16.35025507213875, 11.341308680402438],
            [-16.348582663284414, 11.346644329882698],
            [-16.342982324024852, 11.351695211179521],
            [-16.34334188126524, 11.36330309348705],
            [-16.34522326745903, 11.371552398157023],
            [-16.353975488160604, 11.383185219804753],
            [-16.35236507194099, 11.392307639417446],
            [-16.35416270322762, 11.396226114174652],
            [-16.350188874792106, 11.401909774149242],
            [-16.34666245026273, 11.404318507564776],
            [-16.34424982595727, 11.408228482460991],
            [-16.34810922567942, 11.412985783198664],
            [-16.347601640855224, 11.415414083990317],
            [-16.340795832208055, 11.418501204828603],
            [-16.34089888990007, 11.42383510395428],
            [-16.338098882004523, 11.429895110377975],
            [-16.33456818857961, 11.43070854210163],
            [-16.330272835335478, 11.43552671464651],
            [-16.328975480572826, 11.439427914539213],
            [-16.32938358302731, 11.445792729894517],
            [-16.32667652118151, 11.448993669486113],
            [-16.32372124769444, 11.449324501979527],
            [-16.31441704152924, 11.458123576578085],
            [-16.312659976541248, 11.465265654036177],
            [-16.310770259161654, 11.468013652637332],
            [-16.306066446521704, 11.468811119589205],
            [-16.303120529776017, 11.467349445762524],
            [-16.29859803541729, 11.470139001804991],
            [-16.293049145317973, 11.475638896171754],
            [-16.287857618511946, 11.477668222455655],
            [-16.285317349116596, 11.486237317607472],
            [-16.288997375442808, 11.491256648790259],
            [-16.290245501762055, 11.49515276139478],
            [-16.289157831017768, 11.500890611131627],
            [-16.2984867873006, 11.513071185738161],
            [-16.29829768156951, 11.517742327611037],
            [-16.29965510851685, 11.523676594690409],
            [-16.297109968598253, 11.525339185046134],
            [-16.293081415360508, 11.524580742622625],
            [-16.283432498303217, 11.524894004580796],
            [-16.281163328262593, 11.527259305565924],
            [-16.276367788623887, 11.52884686803173],
            [-16.270657095635592, 11.534371767606403],
            [-16.266999786977244, 11.532111024070218],
            [-16.263693281116858, 11.532330679083485],
            [-16.26008123736476, 11.536306804475348],
            [-16.25204197732418, 11.536462611122234],
            [-16.248298237609298, 11.53206490598501],
            [-16.239582681338366, 11.53592142484951],
            [-16.234070618856286, 11.536943340464632],
            [-16.223666358260665, 11.53426424255093],
            [-16.218220760387474, 11.535319056066815],
            [-16.213878994741048, 11.538337033821392],
            [-16.206339385342215, 11.53768335698288],
            [-16.201213466029028, 11.53293630781799],
            [-16.196972245325224, 11.53622519163878],
            [-16.19216680978871, 11.537219449063015],
            [-16.186602275761185, 11.542625004574953],
            [-16.18238557377214, 11.543196615645071],
            [-16.17768340360451, 11.545909703150286],
            [-16.172863883799142, 11.54597280454438],
            [-16.16960016668575, 11.551090086309241],
            [-16.16522070418452, 11.552868743784593],
            [-16.164243237076665, 11.557122933286916],
            [-16.15825263782598, 11.556738403965172],
            [-16.153746386232356, 11.553893172154664],
            [-16.145510683490823, 11.558873098490752],
            [-16.14909387298927, 11.561870872665667],
            [-16.15036968984214, 11.56765516655385],
            [-16.14969076834944, 11.57407389989565],
            [-16.15227243317977, 11.57697405415155],
            [-16.151594932753664, 11.585767744705146],
            [-16.150131439561438, 11.588046743147428],
            [-16.143415401716453, 11.59101969955285],
            [-16.142062206810767, 11.594968470894166],
            [-16.136632853169825, 11.596606516362066],
            [-16.13002825287215, 11.594904678503488],
            [-16.126301883944755, 11.595636398291932],
            [-16.124228748082686, 11.599965621691387],
            [-16.113870381326645, 11.59529491400205],
            [-16.107889299752856, 11.597242292568986],
            [-16.107243639098773, 11.607533167065638],
            [-16.11009214286494, 11.614477194678402],
            [-16.110247555816397, 11.622112235333828],
            [-16.108601463748105, 11.6247719644227],
            [-16.11231734306388, 11.627143796390348],
            [-16.11556653553208, 11.633387004092748],
            [-16.123892789265156, 11.639507947954575],
            [-16.125248653048228, 11.647968798812345],
            [-16.13277310605653, 11.65217571878466],
            [-16.131747257235084, 11.658395387277965],
            [-16.12534798335913, 11.666741936015438],
            [-16.132038474657147, 11.676068961528026],
            [-16.13194428135925, 11.679521686938324],
            [-16.13437173622725, 11.688097683091156],
            [-16.133980734081174, 11.69269970017869],
            [-16.138016578205136, 11.698071374778515],
            [-16.14230154731279, 11.706548079935123],
            [-16.1441737427175, 11.714215792238013],
            [-16.14339150990872, 11.7182408137671],
            [-16.145733645587686, 11.722772347975763],
            [-16.144549904777993, 11.727790157103827],
            [-16.139419674977464, 11.728314506556952],
            [-16.13566876998679, 11.732515519643314],
            [-16.134913320735297, 11.737816533957956]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.61891246623236,
          "lat": 47.86925136503458
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53007"],
        "coty_name": ["Chelan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chelan County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01531932"
      },
      "bbox": [
        -16.389137189263305, 10.610633546138704, -15.480259515531122,
        11.949327990420025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.938611627373667, 5.1175844117979805],
            [4.986044084356569, 5.122803026742487],
            [5.071760519081522, 5.127987876482289],
            [5.099478509952815, 5.1301141247946145],
            [5.099794450092426, 5.129822645232151],
            [5.14385768301743, 5.132765721483057],
            [5.226056818574077, 5.1385710090023275],
            [5.257723768410949, 5.14043914461709],
            [5.267097008564453, 5.141510112869428],
            [5.326252851112729, 5.146005614240554],
            [5.381259470421937, 5.150134402277796],
            [5.4113807290189495, 5.152683076162067],
            [5.41206868441783, 5.14075123176196],
            [5.4368008438081645, 5.142723623201474],
            [5.476946267389076, 5.146705587604688],
            [5.498446039585765, 5.148362837083937],
            [5.503818356734164, 5.071937869146631],
            [5.50901919197644, 5.0113664647748],
            [5.51184348546085, 4.974472233965045],
            [5.519307793989971, 4.887621230677409],
            [5.516332256161828, 4.887212942827124],
            [5.519373272521155, 4.839204449569024],
            [5.522510645164152, 4.800635557560814],
            [5.493769947945917, 4.797007759471527],
            [5.437370959439369, 4.7920819054902335],
            [5.4159791735075355, 4.790754968450606],
            [5.3586447384313765, 4.786226362539987],
            [5.3448651540999865, 4.7847568794069675],
            [5.280505040144487, 4.779621654303465],
            [5.267060802989202, 4.778814792821968],
            [5.266114555010622, 4.791530924772546],
            [5.226797023121018, 4.78893633901489],
            [5.18052139634664, 4.785676809787029],
            [5.094445229473593, 4.7788730842114875],
            [5.008021942251187, 4.773072008578025],
            [5.002852653394601, 4.780003504937452],
            [5.004314895903293, 4.794274280328618],
            [5.006796782271838, 4.799751389286333],
            [5.015501832995599, 4.808008067031213],
            [5.017563943957788, 4.811051942526326],
            [5.022146857552163, 4.823253156580074],
            [5.029494369741112, 4.836409309759847],
            [5.03443517784013, 4.843182034393072],
            [5.039645171058212, 4.844109144111103],
            [5.045535838958743, 4.84275465907144],
            [5.055264479211874, 4.844407301879892],
            [5.070617860922997, 4.851077030927637],
            [5.08085061484364, 4.858191413189294],
            [5.088617035561043, 4.866338785284676],
            [5.0848124465099565, 4.920467432209749],
            [5.080390517667099, 4.991434627189179],
            [5.077628337248222, 5.043367485381992],
            [5.072666647833738, 5.0477540885522565],
            [5.063906138722147, 5.049963778621602],
            [5.052764720539866, 5.047048043231942],
            [5.046426810965914, 5.046614768487212],
            [5.036051858773147, 5.048617935350275],
            [5.031572798710285, 5.051031598784605],
            [5.0236765363267235, 5.051359211207414],
            [5.013179449053511, 5.047651387720942],
            [5.008869304488, 5.04689664044922],
            [4.9994007683416495, 5.047082903469017],
            [4.984414501563406, 5.048821387680544],
            [4.981056401923108, 5.050954998204999],
            [4.978924306583495, 5.056470536961866],
            [4.979931822514973, 5.060057560477028],
            [4.9862929007829795, 5.067475589561552],
            [4.9898185098317125, 5.074938739079357],
            [4.989231958497809, 5.078285276844794],
            [4.98601347855159, 5.0793887284002],
            [4.980986760055753, 5.0778113699595995],
            [4.973500797410236, 5.07693611103184],
            [4.967339546930918, 5.080447140272882],
            [4.964091216271363, 5.083847754657713],
            [4.956619859459604, 5.081502344365296],
            [4.951569350959735, 5.087320257697092],
            [4.947262358061404, 5.090788641936886],
            [4.948607820323887, 5.096144342228634],
            [4.947048649728566, 5.098630201828857],
            [4.941455852609355, 5.10232454837291],
            [4.9456440006801765, 5.107129637197016],
            [4.93795893049308, 5.117539838071974],
            [4.938611627373667, 5.1175844117979805]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.33376970656727, "lat": 43.46664122895635 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55021"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01581070"
      },
      "bbox": [
        4.93795893049308, 4.773072008578025, 5.522510645164152,
        5.152683076162067
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0257305451532353, 7.783220495805177],
            [3.0230207380435137, 7.860590938234026],
            [3.022966129259856, 7.868903310359259],
            [3.018524763055728, 7.988230213672524],
            [3.0165996439827722, 8.02666144501984],
            [3.0197700280119806, 8.030153352921246],
            [3.020868273181484, 8.023283392691244],
            [3.029102254014842, 8.020737842976157],
            [3.0319794213779887, 8.014233016884972],
            [3.035133130103164, 8.014651967385646],
            [3.041301562678315, 8.022496535364443],
            [3.051378703351945, 8.013508645824071],
            [3.056097083478339, 8.014483702823544],
            [3.060869279679647, 8.017535136901323],
            [3.064322435878763, 8.0173747130729],
            [3.0693201151037233, 8.014806391426685],
            [3.0720692854887255, 8.015013639188503],
            [3.0788179099330657, 8.020317140709066],
            [3.0787314766636156, 8.024165215511678],
            [3.076229770911781, 8.02979392574309],
            [3.0846964823746434, 8.041979226000722],
            [3.0921938343151867, 8.045733279372016],
            [3.095595519795556, 8.051892052964742],
            [3.0951640730380126, 8.055725701309825],
            [3.09042422714128, 8.060473813630818],
            [3.0797962063686564, 8.060940454460944],
            [3.0750997823488677, 8.062926670500403],
            [3.074588874151701, 8.067053195346089],
            [3.082770304136059, 8.0759666368998],
            [3.085406756794856, 8.08229092961002],
            [3.095594769120749, 8.082400209707536],
            [3.1002992842268666, 8.085253479336728],
            [3.1087796771603524, 8.081642858244537],
            [3.1148990878698304, 8.081888366877864],
            [3.1179608679791992, 8.091192613655672],
            [3.116399965432271, 8.093992708111024],
            [3.1162066905412327, 8.100401501882725],
            [3.1197202037904046, 8.105379774647783],
            [3.1339898041431433, 8.11493830722498],
            [3.1525888167537928, 8.11628593370485],
            [3.1924033350941334, 8.078134816954382],
            [3.2020286596569982, 8.073695404159762],
            [3.205364789869224, 8.07623315619551],
            [3.2103166432541252, 8.075882142306675],
            [3.2247838329781775, 8.063485558976744],
            [3.2350223145265673, 8.057693526927464],
            [3.2430973987922536, 8.054181725466165],
            [3.2562092800475844, 8.052167397627299],
            [3.267625832601297, 8.054678594541729],
            [3.2944366975580803, 8.063347435701385],
            [3.314501154184949, 8.066926387051243],
            [3.3264285723635214, 8.064806865462849],
            [3.3403419409645054, 8.065888605453921],
            [3.360703375075298, 8.071221780498146],
            [3.3878981989548445, 8.086693802015343],
            [3.4239282959541306, 8.102232416155468],
            [3.4583321204654256, 8.11513351814865],
            [3.4795114766181965, 8.127626076489],
            [3.4950981672217996, 8.136161614623301],
            [3.499909089913335, 8.137073963983257],
            [3.50621365493197, 8.139790122169277],
            [3.522018141664709, 8.138722307190312],
            [3.521937143368414, 8.132765325869489],
            [3.5259806999258627, 8.04584429966255],
            [3.5272524163655765, 8.013808166751359],
            [3.52711450260899, 8.008482475276852],
            [3.5296361231466533, 7.94628517951564],
            [3.5300633542871203, 7.9409579393312875],
            [3.5314095398357264, 7.903958170252147],
            [3.5324058155793314, 7.889400357735979],
            [3.5336840102273714, 7.888970254809735],
            [3.5354729034070234, 7.848196607931107],
            [3.5389023908857067, 7.782242479265569],
            [3.542048523722381, 7.719925352120557],
            [3.5449030827572883, 7.659270943941871],
            [3.5462542844627634, 7.63397069522285],
            [3.550034802884403, 7.548037121104734],
            [3.5427863555321557, 7.548494346550796],
            [3.4608580407796263, 7.544821655514348],
            [3.378930609113347, 7.541129556001912],
            [3.316781670723712, 7.5382309403358265],
            [3.2923073500503386, 7.536969097441472],
            [3.2044908832055303, 7.533438014622991],
            [3.1583567181272194, 7.530887492030052],
            [3.125335331809118, 7.529851355666442],
            [3.1249374641383936, 7.530070128500235],
            [3.0352555417776004, 7.526403063910387],
            [3.034265284735042, 7.54889363732395],
            [3.0319414472796717, 7.612131726248786],
            [3.029592661520545, 7.68652651473047],
            [3.02934210808933, 7.689071413241451],
            [3.0257305451532353, 7.783220495805177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.9161551842579, "lat": 46.43287612722696 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55031"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01581075"
      },
      "bbox": [
        3.0165996439827722, 7.526403063910387, 3.550034802884403,
        8.139790122169277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.547498872352256, 7.529069826454626],
            [5.553810450847464, 7.526006932796091],
            [5.553057354413216, 7.523942647767674],
            [5.556620180546399, 7.52037986585174],
            [5.557013717983343, 7.514792986195171],
            [5.5599576168607046, 7.511068551171058],
            [5.563366978664558, 7.504002630003357],
            [5.567132600452058, 7.505898192189983],
            [5.571665409561038, 7.504537222620284],
            [5.574031991973688, 7.505812355486763],
            [5.581521026539955, 7.502707099302027],
            [5.583675938730347, 7.505890811173003],
            [5.590638641448972, 7.507056827031547],
            [5.595942648218091, 7.5065394526751374],
            [5.598033988667676, 7.5096075131327815],
            [5.595840958188769, 7.512127330061812],
            [5.598439877136598, 7.51776466459497],
            [5.5980346380393735, 7.522558248722242],
            [5.600898576715555, 7.527530766403523],
            [5.600355696441642, 7.530007898571916],
            [5.602361117167874, 7.535316125864413],
            [5.606320597973974, 7.537054087172357],
            [5.609889363471413, 7.534176780243599],
            [5.613601139865993, 7.525160291756186],
            [5.6192300548515925, 7.527481213217583],
            [5.625019344631093, 7.534718267049771],
            [5.629078769560386, 7.5369171774454475],
            [5.632521396088446, 7.535763877114723],
            [5.636414755275444, 7.536761784998126],
            [5.639511061961685, 7.534936460256469],
            [5.646153710223585, 7.536314888988857],
            [5.651577218494863, 7.544134401467626],
            [5.658145876182478, 7.542965376711253],
            [5.667612488412368, 7.543359313468486],
            [5.670068023186947, 7.5415309263027694],
            [5.6703535819760305, 7.5355755307654295],
            [5.67293997142669, 7.531935202942424],
            [5.6778919725680685, 7.520312390591213],
            [5.681541313499064, 7.517627325113789],
            [5.6856176283146915, 7.516747654300073],
            [5.693894326662069, 7.520062722076959],
            [5.6933643704259795, 7.52512358000868],
            [5.695850816193127, 7.527537757467528],
            [5.704436574111802, 7.526612158400379],
            [5.708015500564217, 7.524538732702023],
            [5.7079581633024326, 7.520965933258954],
            [5.712069261680308, 7.5176593983185045],
            [5.717533462883139, 7.519163539647971],
            [5.7227177383808066, 7.514360241631896],
            [5.728212281873333, 7.513306239471364],
            [5.730791067931274, 7.507993156193497],
            [5.735299844437728, 7.50514822107134],
            [5.739044990624298, 7.509235420237575],
            [5.744589188860019, 7.51171657252485],
            [5.749883220909571, 7.511339650092559],
            [5.754772791610406, 7.514485753797722],
            [5.7594735807717825, 7.5232893632779865],
            [5.768499777881097, 7.517564952727243],
            [5.780907911174305, 7.510657616793182],
            [5.789974820030501, 7.503795310915845],
            [5.792840502615657, 7.503083201910167],
            [5.797653381855008, 7.498926418363694],
            [5.7993342539541395, 7.490137578452352],
            [5.803395864876846, 7.495323276051852],
            [5.811083230840714, 7.49535081050911],
            [5.820196713012362, 7.490921295979259],
            [5.823641973870168, 7.488161844756734],
            [5.829596725459723, 7.492591946626488],
            [5.845885214615545, 7.498282208623057],
            [5.848697156173131, 7.5025272848597355],
            [5.855080938516113, 7.502246775873114],
            [5.854976213645205, 7.4961404737288575],
            [5.858301303061423, 7.4902166877794985],
            [5.865049407006856, 7.4878255035607015],
            [5.871442289062531, 7.489643475770542],
            [5.8747563799374545, 7.488711817029497],
            [5.885365853410755, 7.490010919459829],
            [5.889225924400049, 7.495433433998606],
            [5.894735564316243, 7.4950147640411116],
            [5.898093397617583, 7.492080885158505],
            [5.903327710492405, 7.4906527826612015],
            [5.907561461955565, 7.484942251189616],
            [5.913796983541867, 7.482794930127032],
            [5.915542861653365, 7.485184566897061],
            [5.919310973288912, 7.482426184296242],
            [5.924848030357918, 7.482912322851012],
            [5.9263102845148845, 7.479701673854203],
            [5.930366011547078, 7.476471531337201],
            [5.939770607864231, 7.473261257577284],
            [5.9412643966314045, 7.468316232222718],
            [5.947866508616169, 7.469062686962534],
            [5.95752659334265, 7.470024752226333],
            [5.963492038473178, 7.4645251496606555],
            [5.963215666473266, 7.462042660293001],
            [5.959113954324045, 7.458907208731825],
            [5.956962698629621, 7.453417592894292],
            [5.956521971068724, 7.447983611746929],
            [5.960248822332885, 7.440785477574389],
            [5.961466758734355, 7.432220992144882],
            [5.965462213511801, 7.428930093584083],
            [5.973456947693526, 7.430393477540029],
            [5.979704252105549, 7.426283810705023],
            [5.983531873283189, 7.425240270820583],
            [5.980676552825656, 7.418621886853389],
            [5.979965082960254, 7.414190065911271],
            [5.976359847333361, 7.415003823439153],
            [5.972783152015926, 7.405677553672158],
            [5.966656632905188, 7.399486639452962],
            [5.961644058986411, 7.390055739961759],
            [5.958252558003756, 7.387910801904617],
            [5.944350582382089, 7.3707906418257],
            [5.942972083112289, 7.3666018348173825],
            [5.9483992558438405, 7.357363074326961],
            [5.958172712083245, 7.352988825680274],
            [5.963572610411861, 7.35282377860156],
            [5.968111249713378, 7.341162446750434],
            [5.974982708396613, 7.336059045245951],
            [5.986009324268337, 7.33557056857036],
            [5.987610492452212, 7.333074836375307],
            [5.9917974013522945, 7.33176215531792],
            [6.000286491572268, 7.333245207183096],
            [6.005201608395437, 7.266358813143594],
            [5.940610958048993, 7.2645123641948315],
            [5.92201618088638, 7.264503323565181],
            [5.895841461821279, 7.263080039915373],
            [5.890292471165466, 7.263066097965453],
            [5.791431475275723, 7.2579802904504],
            [5.7760932083032746, 7.256509547502954],
            [5.749595055565608, 7.254928030436205],
            [5.723870647470029, 7.253096836980022],
            [5.647418626627203, 7.2472039312951155],
            [5.639885476231463, 7.246509740041866],
            [5.575090925237357, 7.241803352848853],
            [5.568608367289856, 7.327346484366307],
            [5.562452768787281, 7.406236235161205],
            [5.556202200666879, 7.496700048378752],
            [5.549316339912336, 7.4977431456684105],
            [5.547498872352256, 7.529069826454626]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.39815245231115, "lat": 45.84845081160957 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55037"],
        "coty_name": ["Florence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Florence County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01581078"
      },
      "bbox": [
        5.547498872352256, 7.241803352848853, 6.005201608395437,
        7.544134401467626
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.529166916067423, 4.713634446470967],
            [5.5635495699435005, 4.716493647921264],
            [5.625871148702655, 4.72089306429773],
            [5.627761047254202, 4.721378139032861],
            [5.70028781367434, 4.726421154220116],
            [5.7275018328438385, 4.728582471328563],
            [5.752816585186488, 4.729897508884002],
            [5.8391195217105, 4.736159268903953],
            [5.871319205914399, 4.73793142382602],
            [5.873091076672109, 4.692934097241617],
            [5.874290270637265, 4.669595672964549],
            [5.880298398008144, 4.5773501417369795],
            [5.8810958987743, 4.561121585736791],
            [5.884631914117355, 4.516545064415953],
            [5.885570191650542, 4.501846013916399],
            [5.8896991298346535, 4.44675492452967],
            [5.89284051336021, 4.407867625964566],
            [5.895034585700024, 4.384811806925715],
            [5.845919707032641, 4.380439247498705],
            [5.781263330406695, 4.3756213259971934],
            [5.727754878961383, 4.371727236797949],
            [5.723871149687173, 4.371300506197041],
            [5.6805616407006605, 4.36931542547501],
            [5.638028120717425, 4.368095264112466],
            [5.595075677882232, 4.365073982051413],
            [5.551585424103891, 4.363399588921569],
            [5.549969550179087, 4.388612190118358],
            [5.546469470986072, 4.435929293438701],
            [5.54114567521483, 4.515828857217465],
            [5.540805792164261, 4.518544006521211],
            [5.53650138974779, 4.590084570940171],
            [5.533255255281479, 4.626452268031687],
            [5.533109868011058, 4.633739583640224],
            [5.530719105426347, 4.6846131120936985],
            [5.529166916067423, 4.713634446470967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.7758775333558, "lat": 43.02082572796174 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55055"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01581087"
      },
      "bbox": [
        5.529166916067423, 4.363399588921569, 5.895034585700024,
        4.73793142382602
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.405333353431299, 3.315217241491225],
            [-6.2857654879004246, 3.303405587873475],
            [-6.284297745701643, 3.3033535530457887],
            [-6.1844469676971965, 3.292378855278901],
            [-6.084598175231412, 3.2813870941664156],
            [-6.045459869575927, 3.277348808052953],
            [-5.944354342346074, 3.2679880408227335],
            [-5.946074947329453, 3.250288443571232],
            [-5.952159970967806, 3.1798064867049676],
            [-5.90745604426083, 3.1754144732407634],
            [-5.856942162362253, 3.1708554828670312],
            [-5.837395768914943, 3.1685899571043716],
            [-5.8131371405722945, 3.1666732895329344],
            [-5.6787665605765, 3.1548538355506697],
            [-5.603435129594887, 3.148034602077291],
            [-5.602478105884692, 3.1480531394587032],
            [-5.5081139673190815, 3.1399934151641316],
            [-5.511642323085879, 3.097948663772616],
            [-5.522515291723276, 2.9684465122424597],
            [-5.528154881664822, 2.9056389628600066],
            [-5.5324480382855405, 2.8530942842436104],
            [-5.532857998999933, 2.8501473619105178],
            [-5.5435550343579525, 2.731819398069153],
            [-5.546929988731617, 2.6888487979110303],
            [-5.5551230725120915, 2.592090107871653],
            [-5.556656276441772, 2.5753996714605933],
            [-5.609091871367918, 2.5800907441235066],
            [-5.677027237787765, 2.5859697081892836],
            [-5.793775888602429, 2.596056895800268],
            [-5.865661957523721, 2.602364174275008],
            [-5.887604787161485, 2.6046847200818934],
            [-6.021001766054384, 2.6158757099714456],
            [-6.1355671374760625, 2.6247386442670964],
            [-6.154886238636301, 2.62530309182903],
            [-6.220535746314002, 2.6314978097201194],
            [-6.3365399338280435, 2.642699908803119],
            [-6.452546078389735, 2.653881702359018],
            [-6.4689988941390695, 2.6554518655035344],
            [-6.464313473533631, 2.7030739466793516],
            [-6.465738576537381, 2.7031111393275906],
            [-6.45888120024398, 2.774098144893503],
            [-6.452310436785659, 2.8486496496366036],
            [-6.439099854165982, 2.9892610275040465],
            [-6.4324515874366845, 3.0537190881251415],
            [-6.43006764450349, 3.0570496670374525],
            [-6.405333353431299, 3.315217241491225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.68954700395565,
          "lat": 41.30700465344853
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56021"],
        "coty_name": ["Laramie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Laramie County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01605075"
      },
      "bbox": [
        -6.4689988941390695, 2.5753996714605933, -5.5081139673190815,
        3.315217241491225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.030977565173371, 4.2405819696054765],
            [-6.016691437557745, 4.240204049589627],
            [-5.946121514051488, 4.233688210909114],
            [-5.858465341958809, 4.22518762344488],
            [-5.86610672002948, 4.138033623105488],
            [-5.873902571374793, 4.051674752744096],
            [-5.87383453363876, 4.050704747181885],
            [-5.879669331509257, 3.9905303997392014],
            [-5.890018254329858, 3.871291749154202],
            [-5.890843051205292, 3.8605932945154886],
            [-5.8939627926377245, 3.832508264982274],
            [-5.8960712478258195, 3.8049161686861916],
            [-5.901398126136852, 3.7405536379835653],
            [-5.901737229967298, 3.738747148924973],
            [-5.911037229010166, 3.6320408848760013],
            [-5.912892423056756, 3.615454708547947],
            [-5.916847285435211, 3.571000276565709],
            [-5.918534893924048, 3.554124798693581],
            [-5.925951305681419, 3.4722782032344295],
            [-5.929678284827144, 3.4283561992574922],
            [-5.940404884495302, 3.3109151338690275],
            [-5.944354342346074, 3.2679880408227335],
            [-6.045459869575927, 3.277348808052953],
            [-6.084598175231412, 3.2813870941664156],
            [-6.1844469676971965, 3.292378855278901],
            [-6.284297745701643, 3.3033535530457887],
            [-6.2857654879004246, 3.303405587873475],
            [-6.405333353431299, 3.315217241491225],
            [-6.397496235525239, 3.4006964557600345],
            [-6.392212378342254, 3.400214423940343],
            [-6.384802308761964, 3.4748030358291366],
            [-6.368220522840323, 3.644429984399227],
            [-6.367327594553969, 3.66561615470066],
            [-6.359613868616808, 3.74732409181928],
            [-6.3650269102373365, 3.7479176422350977],
            [-6.352122246763999, 3.8807860053729657],
            [-6.338924065643096, 4.019620848644737],
            [-6.338307902226097, 4.0396936894929825],
            [-6.3334294737067784, 4.090500548735647],
            [-6.332231080768804, 4.090308777005663],
            [-6.326019717791818, 4.166032313887585],
            [-6.31820371122621, 4.264920850193083],
            [-6.289815843026249, 4.2621659481852445],
            [-6.2364412165104275, 4.258297954262036],
            [-6.22310592021891, 4.256635532052034],
            [-6.179447896058287, 4.254204292438782],
            [-6.163892497246798, 4.252361007062346],
            [-6.087068478758581, 4.245757981341045],
            [-6.081463127471597, 4.244785602249828],
            [-6.047621897762207, 4.241782721689944],
            [-6.030977565173371, 4.2405819696054765]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.96589140220196,
          "lat": 42.133133475491945
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56031"],
        "coty_name": ["Platte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Platte County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01605080"
      },
      "bbox": [
        -6.405333353431299, 3.2679880408227335, -5.858465341958809,
        4.264920850193083
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -67.12066252546948,
          "lat": 18.459741358473682
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72005"],
        "coty_name": ["Aguadilla"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Aguadilla Municipio"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01804482"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.95686984068533,
          "lat": 18.374968528048235
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72031"],
        "coty_name": ["Carolina"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Carolina Municipio"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01804495"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.32800909415587, "lat": 18.30435470725734 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72047"],
        "coty_name": ["Corozal"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Corozal Municipio"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01804503"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.13345235156916, "lat": 18.00775425929675 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72057"],
        "coty_name": ["Guayama"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Guayama Municipio"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01804509"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.58829634409405,
          "lat": 18.210627523411087
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72073"],
        "coty_name": ["Jayuya"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Jayuya Municipio"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01804517"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.85822632277052,
          "lat": 18.079559659682147
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72153"],
        "coty_name": ["Yauco"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Yauco Municipio"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01804557"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8323185802178021, 0.7733346363988964],
            [1.8321194585076286, 0.7741587193054623],
            [1.8326357669564826, 0.846549305655138],
            [1.872608645340545, 0.8462901679117458],
            [1.91799239563359, 0.8469435515782525],
            [1.961014129598132, 0.8469617582157298],
            [2.003711528300678, 0.8471489855323153],
            [2.047591779692184, 0.8485117487894911],
            [2.0910562752073, 0.8505328100083638],
            [2.16145802656138, 0.8511946307101882],
            [2.1758935899563507, 0.8511640526548666],
            [2.1777801515171284, 0.7785336466365653],
            [2.18105338582073, 0.6380281640758084],
            [2.1826644050952257, 0.5738833527679533],
            [2.184002989516245, 0.5307349178430392],
            [2.168762916616413, 0.5238668006365899],
            [2.1611006712104777, 0.52414855873712],
            [2.1523463127648137, 0.5281622949818437],
            [2.1501925539154523, 0.5301976998860147],
            [2.137772235035319, 0.5363580798841402],
            [2.13340168164846, 0.5375120430025764],
            [2.1211320137621037, 0.5378077284698396],
            [2.114383114423649, 0.5367195928057968],
            [2.1050490355244724, 0.532679816974031],
            [2.0944797826966277, 0.5257084736129941],
            [2.076347938084071, 0.5055731252916239],
            [2.0689369444169987, 0.5033547702005895],
            [2.0565597826496913, 0.5049334265998061],
            [2.0511319077071186, 0.504230459973004],
            [2.0452705725337412, 0.4999963808107548],
            [2.042164976324025, 0.49036848558291624],
            [2.0425235184534354, 0.48196166400964396],
            [2.0439250426962534, 0.47814872357696686],
            [2.0379036433859947, 0.4707097067089587],
            [2.029846707351844, 0.46318305460886455],
            [2.0240425544152623, 0.46177632000533547],
            [2.016030688541424, 0.4648095866477942],
            [2.0083471543884, 0.4720382503902754],
            [2.0099717682444034, 0.4751333117634533],
            [2.010187054228879, 0.48063513860956547],
            [2.0122574277931724, 0.488013082211576],
            [2.018318843812496, 0.49239616411070913],
            [2.0239486499147583, 0.497966101912903],
            [2.027996784690456, 0.5033389633801914],
            [2.0283162495582907, 0.5121823445627663],
            [2.024354457357425, 0.5183035192243182],
            [2.016038314577577, 0.5254216032335334],
            [2.013968963847758, 0.5257643284587302],
            [2.0074785694217345, 0.521350336330923],
            [1.9871043793944438, 0.514430251313199],
            [1.9768712974844667, 0.5105670018276578],
            [1.9725941335323605, 0.5067927989676062],
            [1.9714641964845225, 0.5037643978251458],
            [1.972059834248814, 0.49623682285157766],
            [1.9798167224510232, 0.483774465582095],
            [1.9811918604110934, 0.47323675798992443],
            [1.971685097134041, 0.4657521638000221],
            [1.9650735934103376, 0.459072513679292],
            [1.956678946381533, 0.45355256089026774],
            [1.9522306709992832, 0.4521853704144576],
            [1.9398305980892059, 0.451900288972531],
            [1.933253603621663, 0.4530762795703469],
            [1.9257450694892073, 0.45657686575821277],
            [1.9195067063355555, 0.46084267072589813],
            [1.912309469029558, 0.46696709697524025],
            [1.9058276324171455, 0.47652535226264725],
            [1.904151155897177, 0.4805110635771313],
            [1.8997274440465814, 0.48609463934570846],
            [1.894323498965807, 0.4896882086259989],
            [1.886372912822286, 0.4921661786080784],
            [1.8695065345411346, 0.4944555190253829],
            [1.8635309440759564, 0.4946960646627389],
            [1.8565587525328942, 0.49750297839789526],
            [1.8554805351968875, 0.5003227711677665],
            [1.8577782350624357, 0.5070267948199559],
            [1.8643159067867785, 0.5139686654241463],
            [1.8680790558884206, 0.5214079462224316],
            [1.8685861070275298, 0.5276052647467134],
            [1.8653807158139222, 0.5307898265632328],
            [1.8567902198831836, 0.5310937394829341],
            [1.8535896941067282, 0.5301925965960822],
            [1.845513882339396, 0.5247240268336866],
            [1.839638500638882, 0.5227217664560737],
            [1.8355867927328366, 0.5234148475995473],
            [1.8349977811901943, 0.5711644318907514],
            [1.834110768646665, 0.6117486181298013],
            [1.8329018446812362, 0.7038090963301517],
            [1.8327534230165792, 0.7440645331760682],
            [1.8323185802178021, 0.7733346363988964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.98990478896317, "lat": 39.35233097330092 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29177"],
        "coty_name": ["Ray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ray County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00758543"
      },
      "bbox": [
        1.8321194585076286, 0.451900288972531, 2.184002989516245,
        0.8511946307101882
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.278395248244213, -0.4037891449368927],
            [4.345988815699837, -0.4002612344266397],
            [4.360855378483227, -0.3992700103165256],
            [4.375844273515709, -0.39605880177595226],
            [4.37590481254762, -0.39724578637972563],
            [4.442252058132696, -0.394387165855018],
            [4.462861285423549, -0.3930000141723415],
            [4.4932945452373225, -0.3922003145567797],
            [4.5236214777139745, -0.39068700925434047],
            [4.534144122045491, -0.40369392332905424],
            [4.552739387256885, -0.42507606634953266],
            [4.588184802956193, -0.467068765895893],
            [4.59614412758973, -0.4775278008206048],
            [4.606104826836669, -0.48869119649616655],
            [4.61059977388663, -0.4961408716694301],
            [4.609445423949173, -0.4989969718077138],
            [4.604928916178894, -0.4994977837181665],
            [4.603445243605155, -0.5031833269052701],
            [4.609883267937016, -0.5043984309021136],
            [4.616044267772599, -0.5024821525136012],
            [4.620814241461231, -0.5029737579522426],
            [4.623786710478376, -0.49296487715153486],
            [4.630080350707656, -0.4980518415801988],
            [4.628448151176001, -0.5012406315434554],
            [4.6221049148390385, -0.5044364799513023],
            [4.624597259072315, -0.508774713039311],
            [4.631235569577015, -0.5093001267976461],
            [4.639817196067095, -0.5132258082303274],
            [4.640770896923962, -0.5374362341840947],
            [4.6436404620883875, -0.5983618617017217],
            [4.646574621815381, -0.655264053124154],
            [4.647715966317799, -0.6865640967247992],
            [4.650004376805078, -0.7397981151663533],
            [4.653003134508557, -0.7991807051046638],
            [4.654867000946539, -0.8425848045992937],
            [4.655237754655143, -0.8579723003835494],
            [4.582190819061833, -0.8596540030147874],
            [4.563762996979334, -0.8606758389417222],
            [4.563578651820758, -0.8593390315648852],
            [4.547236445978501, -0.8621418058799405],
            [4.503136572355507, -0.8664332916312817],
            [4.476201063453137, -0.86847657980026],
            [4.475318831468828, -0.8665898170521784],
            [4.461528724844223, -0.8685845732359204],
            [4.404696929167184, -0.8679255897611053],
            [4.391080010245125, -0.8681659795266519],
            [4.391127173164632, -0.8668176941013217],
            [4.376989466762906, -0.8691780400289889],
            [4.310243753319318, -0.871756773944211],
            [4.299240444679713, -0.8719370592959939],
            [4.295923387890915, -0.7707116262479753],
            [4.295292058316007, -0.7398667280970526],
            [4.294243103488297, -0.707101849082513],
            [4.293307712154403, -0.6914457800109056],
            [4.290370394150544, -0.608237660570586],
            [4.287435984193077, -0.5584105761906232],
            [4.285885861967229, -0.5268646509017083],
            [4.283335544893734, -0.49119632520390877],
            [4.282535052284773, -0.48349138934446706],
            [4.278395248244213, -0.4037891449368927]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.87740743620378,
          "lat": 37.961693599011696
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29221"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "221",
        "coty_gnis_code": "00758563"
      },
      "bbox": [
        4.278395248244213, -0.8719370592959939, 4.655237754655143,
        -0.39068700925434047
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.222085826778022, 7.193848192837498],
            [-9.144795176589247, 7.182681926732112],
            [-9.131324808008523, 7.275145946832141],
            [-9.076080122558297, 7.267227124746757],
            [-9.070112988245702, 7.3098806607316735],
            [-9.055741919035636, 7.3078692838598736],
            [-9.051629248949576, 7.336387397740515],
            [-9.037327305514173, 7.33434002468898],
            [-9.035246911479515, 7.348558598207667],
            [-9.031283362964086, 7.347988707228047],
            [-9.029222025077466, 7.36219897344997],
            [-9.014935750856894, 7.360195040249406],
            [-9.012885207013458, 7.374415908409661],
            [-8.998622653491278, 7.372397476045056],
            [-8.996575254295733, 7.386627852230562],
            [-8.982284268181488, 7.384592523743442],
            [-8.980232845736941, 7.398813351004525],
            [-8.965906898697668, 7.396816338117901],
            [-8.963853545645335, 7.411027912740989],
            [-8.935258805737362, 7.406922244267657],
            [-8.933257948760566, 7.421167388397282],
            [-8.919170592330687, 7.419206499469625],
            [-8.917164179821455, 7.433412816867089],
            [-8.874165228149876, 7.427448138645932],
            [-8.872110697123052, 7.4416658784642555],
            [-8.757739706562859, 7.4259011771486865],
            [-8.749487675263525, 7.483419047876139],
            [-8.705551568193293, 7.477278441286421],
            [-8.696910066032677, 7.539850886289468],
            [-8.695399425525073, 7.540710401209567],
            [-8.685507640645366, 7.535765879602599],
            [-8.677190428439719, 7.533890212346644],
            [-8.666570581579062, 7.535619690684389],
            [-8.655847184979896, 7.530706712030454],
            [-8.642717916799095, 7.534319956332242],
            [-8.634859834769731, 7.5355311518727355],
            [-8.632096336680362, 7.539449112350332],
            [-8.625849984611822, 7.544713512162149],
            [-8.620466027302097, 7.543748358454492],
            [-8.614036838328087, 7.54907856671956],
            [-8.605230136582275, 7.55028121977627],
            [-8.595634187010058, 7.550472054711453],
            [-8.5885381855033, 7.554678862451026],
            [-8.585962617629411, 7.554591176262676],
            [-8.579071855146402, 7.551030434814638],
            [-8.577089789360931, 7.548272017464642],
            [-8.57153134450683, 7.546581874070832],
            [-8.55980519618284, 7.537223498652121],
            [-8.55053299335501, 7.538846356124144],
            [-8.544004809916325, 7.5345624041074615],
            [-8.530398302528162, 7.532915134311493],
            [-8.513238945151334, 7.535968027648906],
            [-8.51095659148087, 7.540027742510954],
            [-8.507856732094856, 7.540853514190864],
            [-8.495722229872163, 7.536744415312189],
            [-8.490272369701403, 7.538323466484499],
            [-8.484303168612028, 7.5430933887729825],
            [-8.476025005287335, 7.546989940804567],
            [-8.469895734446046, 7.547178884975944],
            [-8.461114041616135, 7.556286324968948],
            [-8.454904724565182, 7.556310723621649],
            [-8.449715246252808, 7.558157404133647],
            [-8.452757464564135, 7.535583056210723],
            [-8.457252321881645, 7.528441328625134],
            [-8.462385327758765, 7.526089902671159],
            [-8.460250135826291, 7.522105709561921],
            [-8.461615818922347, 7.518218333605994],
            [-8.465924277622005, 7.5181086960097145],
            [-8.465474910448549, 7.512635244148121],
            [-8.470699326000224, 7.5098481933052215],
            [-8.475048187858977, 7.474867704555266],
            [-8.44665922923194, 7.470924393749472],
            [-8.450177482012156, 7.442383702004272],
            [-8.407829009110126, 7.436523473302044],
            [-8.414809168544247, 7.378862322371229],
            [-8.378125664130932, 7.3739840142709605],
            [-8.40788938620377, 7.346975733366458],
            [-8.415824609352477, 7.306714225606323],
            [-8.431205423979845, 7.265804851870979],
            [-8.433899612128672, 7.244912361968397],
            [-8.432773419416248, 7.237392744095717],
            [-8.435711130624021, 7.23090442763019],
            [-8.448696482088671, 7.136687753480088],
            [-8.343644760133753, 7.123759758659788],
            [-8.238596494335454, 7.110801804985339],
            [-8.133551746613986, 7.097813897008027],
            [-8.028510578888355, 7.084796039604953],
            [-8.037223213529693, 7.081887206222494],
            [-8.045891457969486, 7.082800530583575],
            [-8.048822898034508, 7.084624479988429],
            [-8.049220732692575, 7.077434914671916],
            [-8.057340387977016, 7.072561287988799],
            [-8.055163803012364, 7.061515455852686],
            [-8.063258121821994, 7.062756170541368],
            [-8.057325856589094, 7.049770969942999],
            [-8.061671368480146, 7.0504838613474075],
            [-8.064186674154946, 7.053750699940814],
            [-8.067732415009786, 7.054338022869521],
            [-8.072471569309362, 7.039282479049363],
            [-8.075802311525598, 7.038482655932736],
            [-8.078459967640756, 7.0432486421413065],
            [-8.083968421404863, 7.042090369851668],
            [-8.083231906317865, 7.038361701502316],
            [-8.078375453867215, 7.03517253599177],
            [-8.079804272862845, 7.032538589227887],
            [-8.085186603041207, 7.032890522542652],
            [-8.089530444547115, 7.030183488017586],
            [-8.087362695678328, 7.022543608571391],
            [-8.089710554622982, 7.016679554681046],
            [-8.085763560014785, 7.014414315166489],
            [-8.085056359024883, 7.009347693968518],
            [-8.089865782281231, 7.004715253074982],
            [-8.0927982267813, 7.004103359574022],
            [-8.102505601294904, 7.005309920270009],
            [-8.103628503752969, 7.002721881091805],
            [-8.099143821253229, 6.997603081881431],
            [-8.104043479636758, 6.985521173753941],
            [-8.110595177940706, 6.989727065715857],
            [-8.110534023883455, 6.985872196363068],
            [-8.106289513938647, 6.982776067591553],
            [-8.105303716049178, 6.979146419853236],
            [-8.107560795652445, 6.97384985425582],
            [-8.11048642414757, 6.972695509812453],
            [-8.114095314150788, 6.974626492093826],
            [-8.114560381079654, 6.979338845533085],
            [-8.117923065402337, 6.9782458698318015],
            [-8.120473123716929, 6.970186716104809],
            [-8.122391748519426, 6.9692614219317],
            [-8.12812709987367, 6.970910809223702],
            [-8.131256717974882, 6.963102273733994],
            [-8.132028842390486, 6.955607154789526],
            [-8.136375743275115, 6.952922565301054],
            [-8.13976830610409, 6.948973224829325],
            [-8.138538821175176, 6.944331014990872],
            [-8.141648088607491, 6.941843311245237],
            [-8.147634801100944, 6.941742778343363],
            [-8.148477481658825, 6.9364556141701765],
            [-8.145246122514063, 6.932750248625865],
            [-8.136634101116433, 6.930403549492211],
            [-8.1364352389552, 6.925194862014736],
            [-8.138565899239962, 6.924258743454383],
            [-8.14635357126604, 6.9269256347351735],
            [-8.151960482695232, 6.924500466482957],
            [-8.155390873779421, 6.91713627100892],
            [-8.158740635348213, 6.91224217031163],
            [-8.159696719655296, 6.907688509862987],
            [-8.158397622923035, 6.902623090823505],
            [-8.1634878023718, 6.8992346707593795],
            [-8.16353615053721, 6.8945468634985385],
            [-8.167522526491778, 6.890845033038812],
            [-8.166985237183246, 6.888090436231543],
            [-8.160850906270657, 6.8876187139309675],
            [-8.159620601192874, 6.8837666130432105],
            [-8.162555270170923, 6.880916740629752],
            [-8.177909679929085, 6.883219562910048],
            [-8.263222303283287, 6.894062611191682],
            [-8.348537331889501, 6.904886294493064],
            [-8.362039651387246, 6.907347874549674],
            [-8.422891210419161, 6.915274836049984],
            [-8.466672587969116, 6.9210127927581615],
            [-8.578042598277067, 6.935739726458469],
            [-8.619974112775589, 6.941333208092057],
            [-8.661118645598515, 6.946535819875665],
            [-8.66349814383012, 6.947070688730585],
            [-8.74593521903593, 6.958202286419536],
            [-8.75932810005148, 6.966330868063272],
            [-8.835495008635469, 6.976718193839018],
            [-8.897997405359439, 6.9850807588664],
            [-8.962387592851487, 6.9934832859419584],
            [-9.034047614259174, 7.002751082129807],
            [-9.10570924734232, 7.012005182372292],
            [-9.219811266666012, 7.027329686697665],
            [-9.245864727604461, 7.031559371986253],
            [-9.222085826778022, 7.193848192837498]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -109.0280168768791, "lat": 45.22738643561408 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30009"],
        "coty_name": ["Carbon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carbon County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01720111"
      },
      "bbox": [
        -9.245864727604461, 6.880916740629752, -8.028510578888355,
        7.558157404133647
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.290992209036068, 11.00954405035699],
            [-9.192068184631207, 10.994883828607124],
            [-9.152212307290746, 10.988231835931046],
            [-9.090723497239578, 10.979743311442325],
            [-9.017811625138574, 10.968905342967176],
            [-8.94490259598933, 10.958048492816806],
            [-8.915640511306123, 10.953748493338054],
            [-8.799964595069556, 10.937167674309933],
            [-8.684028203619253, 10.920669541453552],
            [-8.579280436018406, 10.906055539557089],
            [-8.474538043898828, 10.891402692242618],
            [-8.467160298408109, 10.890529337447642],
            [-8.479314580187944, 10.807331179189712],
            [-8.489784024284377, 10.808745637734509],
            [-8.531948514932083, 10.517400472842168],
            [-8.538112159153789, 10.475904993422105],
            [-8.532516592449296, 10.475122012745624],
            [-8.5384970301905, 10.43398166033753],
            [-8.516916209003451, 10.431003079291326],
            [-8.527064964484653, 10.361011844598936],
            [-8.54854970230424, 10.36412019351296],
            [-8.556873211540163, 10.308234676907285],
            [-8.571314690154734, 10.31025492623908],
            [-8.585731617130252, 10.212590338763768],
            [-8.607378640698924, 10.215666627206428],
            [-8.617605724643864, 10.146079017665523],
            [-8.605752882198939, 10.144349978343035],
            [-8.618192113965407, 10.060598063612794],
            [-8.660629006660738, 10.067015130714857],
            [-8.661014485272208, 10.064617557337016],
            [-8.746795090453265, 10.077201793267662],
            [-8.73416742059897, 10.162808099311968],
            [-8.809492236439494, 10.173729069481395],
            [-8.81361787464766, 10.171747062804165],
            [-8.801190587942274, 10.255653003828444],
            [-8.901039081185871, 10.270187092667],
            [-8.974060414875675, 10.280976160868398],
            [-9.060575450479707, 10.293968031705052],
            [-9.147094436103478, 10.306934246841115],
            [-9.190408966818211, 10.313635668057284],
            [-9.254545357275594, 10.323320806014594],
            [-9.318683887398926, 10.332991832766224],
            [-9.331945451806563, 10.249446437979843],
            [-9.418556584821788, 10.262597495822407],
            [-9.415970166797901, 10.278537102095603],
            [-9.367701735585257, 10.58354161347971],
            [-9.365644900510373, 10.59636980906718],
            [-9.361634366210229, 10.595776552564766],
            [-9.308832593717963, 10.929373744352752],
            [-9.30364255624055, 10.928577655898609],
            [-9.297965109746327, 10.963210610981642],
            [-9.290992209036068, 11.00954405035699]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.1111885322472,
          "lat": 48.628227597439235
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30041"],
        "coty_name": ["Hill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hill County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01720048"
      },
      "bbox": [
        -9.418556584821788, 10.060598063612794, -8.467160298408109,
        11.00954405035699
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.931934734707575, 10.42620636059882],
            [-10.8498726631356, 10.411654686102057],
            [-10.849639117620486, 10.412929797672993],
            [-10.807071183859241, 10.405428430335895],
            [-10.806929082641913, 10.406209603376322],
            [-10.745376970640692, 10.395232970657762],
            [-10.683827252910874, 10.384243315592192],
            [-10.622279953617031, 10.373240641531064],
            [-10.560735096918783, 10.362224951825599],
            [-10.497479164128228, 10.351081505104759],
            [-10.434225762736743, 10.339924326426736],
            [-10.376935847409992, 10.329588434294621],
            [-10.384246984720408, 10.28772243955432],
            [-10.298165250366877, 10.272679667957734],
            [-10.30567485510954, 10.230685353896819],
            [-10.263012779519558, 10.223402095970824],
            [-10.272761215623426, 10.167438471244074],
            [-10.22971883785189, 10.160024520149678],
            [-10.13236134674681, 10.14398289231085],
            [-10.021537741069297, 10.127272396685518],
            [-9.91071976080686, 10.11052042570871],
            [-9.88907953376421, 10.107049062586094],
            [-9.899125511263621, 10.046178703051282],
            [-9.907774105964734, 9.995434643400399],
            [-9.921552456692492, 9.912407863507195],
            [-9.935603540685324, 9.828279638196465],
            [-10.0217860047784, 9.842119550774077],
            [-10.107972386268987, 9.85593476402538],
            [-10.121920089304533, 9.772408415777967],
            [-10.151099921885194, 9.77699611700063],
            [-10.179117150303933, 9.78182143278449],
            [-10.187158431639475, 9.782529163884341],
            [-10.208207279366846, 9.78648026164655],
            [-10.279169369313523, 9.798242835781435],
            [-10.293495195718442, 9.800773469089721],
            [-10.29603633746954, 9.78686099632985],
            [-10.307681924709154, 9.716568336777764],
            [-10.311238886515516, 9.698283678609888],
            [-10.313071435484654, 9.694776824616953],
            [-10.316291359488323, 9.694606474742773],
            [-10.32172781629246, 9.700687653257296],
            [-10.332322423982513, 9.703927573990226],
            [-10.337839509653625, 9.70175506619116],
            [-10.342263891388649, 9.709685519579352],
            [-10.34661351437378, 9.706513034920057],
            [-10.3551201382847, 9.707918586161208],
            [-10.358968109401408, 9.712279093934805],
            [-10.362244618643743, 9.709017249592796],
            [-10.365107555768038, 9.710614470545169],
            [-10.368199778731011, 9.715346656104883],
            [-10.374132863578131, 9.71812257177606],
            [-10.379139948239148, 9.722512886635407],
            [-10.393183371495248, 9.722895087087826],
            [-10.399019717215372, 9.722513992045837],
            [-10.403470566520458, 9.725524441128295],
            [-10.41117467505165, 9.721830470597748],
            [-10.415627946600315, 9.726918603458492],
            [-10.421160194760581, 9.72644060573959],
            [-10.421869145978285, 9.72400279458882],
            [-10.426016702425345, 9.723510438229258],
            [-10.429105816246047, 9.725187579345917],
            [-10.432601471648423, 9.723930011506889],
            [-10.43369789778484, 9.720442762434805],
            [-10.437763786012868, 9.723212074175926],
            [-10.443474758235583, 9.723418739905982],
            [-10.44361385283293, 9.72718297590619],
            [-10.448991719948156, 9.72781682434589],
            [-10.450818122571363, 9.73000613245321],
            [-10.45713646715384, 9.732333637525743],
            [-10.459320832964664, 9.734722807906612],
            [-10.46958239325146, 9.729202323501498],
            [-10.472902002598923, 9.73153974846755],
            [-10.477029329378464, 9.730492721621768],
            [-10.480307187427186, 9.735232042087473],
            [-10.48466732551576, 9.734594604968105],
            [-10.487604076418643, 9.73167119640271],
            [-10.494019324088974, 9.730052117254527],
            [-10.496545953010251, 9.731132542750274],
            [-10.500885505555553, 9.727501455668449],
            [-10.50649201876466, 9.729923853177668],
            [-10.508676153439835, 9.735164980466402],
            [-10.512907419472366, 9.734760834583156],
            [-10.517526604246099, 9.736800886650135],
            [-10.522420549199953, 9.734629822261487],
            [-10.52980747543094, 9.74009694263981],
            [-10.543411106379482, 9.740470537741182],
            [-10.549183166170932, 9.738952853173458],
            [-10.551938192941607, 9.741181622799303],
            [-10.551046209101063, 9.746695144661476],
            [-10.555468663532872, 9.751509957227299],
            [-10.55624222187771, 9.75681039992653],
            [-10.566072612002774, 9.764262012922986],
            [-10.566501189653714, 9.77148881567117],
            [-10.569852229226214, 9.775061188139874],
            [-10.570701448126695, 9.779817822241796],
            [-10.5740308953477, 9.780072902145017],
            [-10.577795029749714, 9.782798165617395],
            [-10.580481396131873, 9.779899066162404],
            [-10.587082359987601, 9.77879069586258],
            [-10.587693786659393, 9.782302686216882],
            [-10.585278467442155, 9.786682705533716],
            [-10.585791799556985, 9.790335697246645],
            [-10.593463762808815, 9.790751974667542],
            [-10.605734923466029, 9.789157382992256],
            [-10.609499267489275, 9.790890022692873],
            [-10.61142813600499, 9.795391379017397],
            [-10.61974409751122, 9.797943460858553],
            [-10.626666242422575, 9.79872094030667],
            [-10.627989923018395, 9.8011941176955],
            [-10.624723118185774, 9.805716462408016],
            [-10.622514049086922, 9.811000682153738],
            [-10.624671216944916, 9.816344207339059],
            [-10.622592163057767, 9.819724835099926],
            [-10.623063116948815, 9.823783889330768],
            [-10.627788038456142, 9.824110972043238],
            [-10.629950862157788, 9.830369420228683],
            [-10.62806641649581, 9.83215169098154],
            [-10.629738018146824, 9.836514340825612],
            [-10.6276936693374, 9.842901438058885],
            [-10.629227411726303, 9.846343085114661],
            [-10.63374585270726, 9.850572284807447],
            [-10.633499220789627, 9.853219957498357],
            [-10.639490552624718, 9.852802555267225],
            [-10.642353017471066, 9.856770223822412],
            [-10.644506531642227, 9.856299636093908],
            [-10.650142122699268, 9.860666814658762],
            [-10.655607632302885, 9.861762761527247],
            [-10.661516719700627, 9.866450351654866],
            [-10.667580220644078, 9.866944226608362],
            [-10.670171818406665, 9.868955186203385],
            [-10.67527726653767, 9.867773428990157],
            [-10.678094187803381, 9.871308823104986],
            [-10.678864679735257, 9.875883443451269],
            [-10.683944924925736, 9.874788528060456],
            [-10.68819284343397, 9.87907043789776],
            [-10.686401110832175, 9.887281728360719],
            [-10.690614008314059, 9.890373555917506],
            [-10.687642612198852, 9.895538345490765],
            [-10.688287123875979, 9.899400466892235],
            [-10.694343303290287, 9.89957030527605],
            [-10.702836396059608, 9.905658668924719],
            [-10.704049825777608, 9.910382290980618],
            [-10.708607652034198, 9.911934933653095],
            [-10.712505921459867, 9.906469221126233],
            [-10.71623933874998, 9.905463722821526],
            [-10.716505215134768, 9.900745764043673],
            [-10.719493282105507, 9.901314697190333],
            [-10.721085488530486, 9.898192572906556],
            [-10.729363390558113, 9.896625148247724],
            [-10.733784478473062, 9.899267466787553],
            [-10.740827161624072, 9.900046029478702],
            [-10.745016754815234, 9.898509229657195],
            [-10.748056220694092, 9.901776727759097],
            [-10.752956720648172, 9.903143804504747],
            [-10.760736259714621, 9.902024093419477],
            [-10.763136870139137, 9.89734735567806],
            [-10.770223979497946, 9.897899327308778],
            [-10.773141353690347, 9.893692239581123],
            [-10.775912661530192, 9.892375887557979],
            [-10.785603804288826, 9.896099004918845],
            [-10.789720686355107, 9.892296410614561],
            [-10.793771178752397, 9.897155978251948],
            [-10.803702545490664, 9.891621136116767],
            [-10.810041619098131, 9.899930562940632],
            [-10.817078583215313, 9.899688872201216],
            [-10.82118306529894, 9.896361773700544],
            [-10.825596056260155, 9.89655401850235],
            [-10.833854022536562, 9.898974468335414],
            [-10.841153117956408, 9.892045177391152],
            [-10.849101481687336, 9.891381055116199],
            [-10.85157645484155, 9.892988115274246],
            [-10.854148909804515, 9.887975285120827],
            [-10.862823483638232, 9.885655999116741],
            [-10.870868075858793, 9.887699784923651],
            [-10.876825328446538, 9.892633649444024],
            [-10.881569254308205, 9.900637478608068],
            [-10.885502981137352, 9.902207500542726],
            [-10.888899254329841, 9.899119998505382],
            [-10.892816486883406, 9.899850672850553],
            [-10.899238837182455, 9.907757072895901],
            [-10.902659628685697, 9.915299646444348],
            [-10.906596498929268, 9.917912224938808],
            [-10.908236855138757, 9.923207766110464],
            [-10.915091183854186, 9.92554760775547],
            [-10.916399278656492, 9.930439758880562],
            [-10.915012317464926, 9.936064341695209],
            [-10.919634757636684, 9.94021296956687],
            [-10.919749042609178, 9.944592856946956],
            [-10.925099282914468, 9.947831960687957],
            [-10.922712514342045, 9.950223400434018],
            [-10.924810771585294, 9.95309550013939],
            [-10.923850421583566, 9.955922786029586],
            [-10.929530696521153, 9.963739905989403],
            [-10.931622056418798, 9.969417992883704],
            [-10.929449486337674, 9.975509094809237],
            [-10.933823529524892, 9.976876188929074],
            [-10.934683599979433, 9.980389743421746],
            [-10.938159739639985, 9.984866146675866],
            [-10.937432972683757, 9.989345582087811],
            [-10.941237184032088, 9.997451810305233],
            [-10.934485160484723, 10.00544069898849],
            [-10.933487714291427, 10.009878512467116],
            [-10.93075859304089, 10.013494088650086],
            [-10.932002590220565, 10.019906826767452],
            [-10.927584851316398, 10.025873331332736],
            [-10.927161445901037, 10.029735688045356],
            [-10.92985145087348, 10.033363407926153],
            [-10.929332216240033, 10.036923567564253],
            [-10.933138765634595, 10.039906799798116],
            [-10.93212999670009, 10.046371546351969],
            [-10.933843437588012, 10.051582171887551],
            [-10.938412698731995, 10.05561147605205],
            [-10.938413255930774, 10.06084822599508],
            [-10.933085491437787, 10.06694794238807],
            [-10.930678347408447, 10.075877553603535],
            [-10.931405328197945, 10.082935125293218],
            [-10.929894288064528, 10.087887127737945],
            [-10.927452620837494, 10.088862506467926],
            [-10.926588644593838, 10.094994230216738],
            [-10.924259793359164, 10.096373812752473],
            [-10.923593885392924, 10.103627350711278],
            [-10.920726141187306, 10.112026320483329],
            [-10.921766221230284, 10.115661103622955],
            [-10.918154897878026, 10.121486798410613],
            [-10.92011483562122, 10.124133771437242],
            [-10.918340059193012, 10.128512525107872],
            [-10.920197045864088, 10.134868282498818],
            [-10.919627937588476, 10.138293983759505],
            [-10.923260786571998, 10.144531372941202],
            [-10.921603674846457, 10.151515590952801],
            [-10.921700684077948, 10.155775450567926],
            [-10.92574577222949, 10.158904916432096],
            [-10.930660521095387, 10.168217666605294],
            [-10.92997643346338, 10.171575561935576],
            [-10.932830365174015, 10.18394594645626],
            [-10.93067751148026, 10.186356244710817],
            [-10.930756357911562, 10.20175837901391],
            [-10.934433437456574, 10.206705961146552],
            [-10.942891946247297, 10.210625828731896],
            [-10.943727964084212, 10.217913648539035],
            [-10.94235055138525, 10.225193780341037],
            [-10.941566028726987, 10.237135025945344],
            [-10.94239948691662, 10.239979267258592],
            [-10.941804666412295, 10.247057084465853],
            [-10.943222819687305, 10.25264646766412],
            [-10.941004115404045, 10.253609994431343],
            [-10.933976494597557, 10.251616601793618],
            [-10.93115757651271, 10.248663187459861],
            [-10.925953408707139, 10.24715123898995],
            [-10.922829417977622, 10.23999509278985],
            [-10.919433829956372, 10.241541189903653],
            [-10.91400512524486, 10.238175371495831],
            [-10.89660387900603, 10.236928128050826],
            [-10.892619663102098, 10.240762522909177],
            [-10.889387075536927, 10.251430919855832],
            [-10.88528431616908, 10.253133865801468],
            [-10.882269011231623, 10.260222407236272],
            [-10.877871640750739, 10.263318184580196],
            [-10.874948797995069, 10.261406486263299],
            [-10.868690556139853, 10.262493277483316],
            [-10.871351248544558, 10.271144339185232],
            [-10.872828703912132, 10.289590476839855],
            [-10.873896907705197, 10.29629751412488],
            [-10.873281592437356, 10.304801303960927],
            [-10.877186835191765, 10.310632559011912],
            [-10.878734519604567, 10.316244162473676],
            [-10.884392949100205, 10.316207490832468],
            [-10.887430650369106, 10.320362221596778],
            [-10.891199648500564, 10.32051016052299],
            [-10.896353575201296, 10.324876595199271],
            [-10.904638241490227, 10.32221046667039],
            [-10.906156897567445, 10.325003540425723],
            [-10.906152078178684, 10.332168390043753],
            [-10.903719331179325, 10.340875709646319],
            [-10.899802298462975, 10.343321126181989],
            [-10.893730058094034, 10.34460277821066],
            [-10.893205019462194, 10.34986453918482],
            [-10.8958840923018, 10.35300029031543],
            [-10.90015854338742, 10.354174282576032],
            [-10.906243419354318, 10.360920305716153],
            [-10.907952268953512, 10.366338156628096],
            [-10.913078478354855, 10.365119346368846],
            [-10.920132460667867, 10.367361136833532],
            [-10.919239684678312, 10.371130949418886],
            [-10.91661583606285, 10.373121563777136],
            [-10.918623875250121, 10.37965396947101],
            [-10.917645429445463, 10.383424070064343],
            [-10.920239358616005, 10.388521410485371],
            [-10.924035224247614, 10.392584913909225],
            [-10.92392591031104, 10.400075191287673],
            [-10.920059430338474, 10.40108319721866],
            [-10.920495496360823, 10.408149735257602],
            [-10.91506573928316, 10.40881857539973],
            [-10.913996943613288, 10.41254009086147],
            [-10.920068218348302, 10.418597335063916],
            [-10.922586785490378, 10.42425016319594],
            [-10.929199861739397, 10.42294675307443],
            [-10.931934734707575, 10.42620636059882]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.24083103675497,
          "lat": 47.83712553536459
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30099"],
        "coty_name": ["Teton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Teton County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01720018"
      },
      "bbox": [
        -10.943727964084212, 9.694606474742773, -9.88907953376421,
        10.42620636059882
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.322224604238734, 8.751622500797193],
            [-9.31951507540155, 8.752817830755015],
            [-9.311963904963898, 8.751004056886666],
            [-9.308552136871599, 8.74885513368345],
            [-9.30078053569405, 8.74635845768036],
            [-9.29286433731079, 8.745801161523161],
            [-9.287510926890524, 8.747013937484368],
            [-9.279938361044001, 8.743314586183356],
            [-9.27463610912488, 8.747697872899218],
            [-9.273933113917705, 8.75121612502575],
            [-9.264335906749132, 8.758049691101478],
            [-9.255903609392009, 8.752739785176582],
            [-9.249772594077493, 8.750104693796116],
            [-9.243186736495911, 8.745628273475344],
            [-9.237419737246473, 8.746572425276188],
            [-9.228317454893489, 8.74631897877971],
            [-9.221515750229452, 8.74502716931863],
            [-9.21674196950129, 8.748124393189306],
            [-9.216865824262769, 8.754311907408091],
            [-9.210770775769808, 8.763288944182046],
            [-9.206665182050644, 8.763576992235055],
            [-9.20126260487813, 8.766977902830313],
            [-9.194790128019923, 8.7650523688093],
            [-9.189468441178558, 8.768131519728286],
            [-9.179262130784952, 8.764889190836495],
            [-9.16633612963791, 8.767437940735947],
            [-9.163366327490358, 8.76511547894693],
            [-9.160719461936432, 8.760541147148874],
            [-9.15707641797657, 8.760031229367963],
            [-9.153567126027538, 8.755776333660927],
            [-9.15216252794271, 8.75199810535491],
            [-9.145682869705519, 8.753667285871586],
            [-9.141580823212667, 8.756357931097051],
            [-9.139049085646741, 8.755189966448917],
            [-9.133110615008485, 8.755405703803726],
            [-9.126574374583662, 8.75804472678732],
            [-9.123177730816392, 8.76169664633248],
            [-9.11791228148723, 8.761766375327806],
            [-9.114362791051715, 8.759837243712896],
            [-9.10917145238815, 8.762360061123946],
            [-9.108382893174108, 8.760179394196914],
            [-9.094819300330792, 8.751769661472578],
            [-9.088751664125713, 8.744304363972653],
            [-9.0739591112757, 8.734136120234773],
            [-9.07080886699196, 8.735171172401044],
            [-9.062986689159267, 8.728722820535973],
            [-9.051135305351673, 8.71522544993856],
            [-9.045685665065955, 8.710677872527912],
            [-9.039699584029563, 8.70775111065934],
            [-9.03073068024325, 8.708993143377846],
            [-9.023200715228663, 8.702890719996942],
            [-9.021343279020437, 8.697969975084535],
            [-9.022840443003854, 8.694140332743908],
            [-9.016013616437146, 8.689571991880522],
            [-8.978532313584587, 8.684210934948577],
            [-8.965432693228422, 8.682917861238868],
            [-8.965505069735064, 8.682426610433371],
            [-8.897491352877525, 8.672674262766737],
            [-8.829479703671218, 8.662907646295329],
            [-8.722536091907166, 8.64793575215921],
            [-8.744472005772897, 8.49230849536111],
            [-8.750523722613844, 8.449782282182932],
            [-8.760773132962543, 8.451239679753588],
            [-8.776980059205526, 8.337100855909261],
            [-8.798323930612, 8.186406470670338],
            [-8.884466705538532, 8.198485828891341],
            [-8.970612540054216, 8.21054312662686],
            [-9.023907989966348, 8.217888117728466],
            [-9.13748262617914, 8.234591550493898],
            [-9.250709623611204, 8.252073311574922],
            [-9.363942811605298, 8.26951679512791],
            [-9.401229644662568, 8.274828165422623],
            [-9.361800192720654, 8.529907692068857],
            [-9.36068637721303, 8.537442888635391],
            [-9.354900979095039, 8.536580913636753],
            [-9.352772460789673, 8.550829530277646],
            [-9.322224604238734, 8.751622500797193]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.84456246581388,
          "lat": 46.466293843486746
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30107"],
        "coty_name": ["Wheatland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wheatland County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01719560"
      },
      "bbox": [
        -9.401229644662568, 8.186406470670338, -8.722536091907166,
        8.768131519728286
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.470941054522105, 3.578368502623251],
            [-5.463529600848609, 3.577779106743769],
            [-5.338846239460603, 3.5659586510710226],
            [-5.324453379987495, 3.5648007761433345],
            [-5.2812484774822215, 3.5620881855246873],
            [-5.1890436172495695, 3.555535020118241],
            [-5.122910024666325, 3.551230911055995],
            [-5.034987467161118, 3.5452685060933464],
            [-4.99190463260439, 3.541234242580234],
            [-4.963862352861026, 3.5384438483456964],
            [-4.971110104170293, 3.431309111420429],
            [-4.9759948533199925, 3.3652096915038774],
            [-4.977904271748556, 3.351501621844636],
            [-4.98056647203698, 3.322265564164865],
            [-4.983347849851364, 3.284833014720651],
            [-4.98354025440805, 3.278814047456361],
            [-4.98932076082186, 3.278548982604834],
            [-4.991382563211481, 3.2596381363471165],
            [-4.992753155268664, 3.2343517938608186],
            [-5.077520372349296, 3.2412962086289037],
            [-5.1618572987046365, 3.2470819125505246],
            [-5.276865324787767, 3.255655248296307],
            [-5.348334097073738, 3.2615508828483155],
            [-5.447555837915091, 3.269914363675058],
            [-5.449244950361115, 3.269894901663386],
            [-5.496940738084436, 3.2738847251393453],
            [-5.4874898895009645, 3.3855816777637986],
            [-5.481088001073683, 3.4619246288133323],
            [-5.470941054522105, 3.578368502623251]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.70795870764042,
          "lat": 41.850552809738254
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31157"],
        "coty_name": ["Scotts Bluff"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scotts Bluff County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00835900"
      },
      "bbox": [
        -5.496940738084436, 3.2343517938608186, -4.963862352861026,
        3.578368502623251
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.019115159256557, 2.796187196249616],
            [16.010794285063273, 2.800087211570629],
            [16.01799966067705, 2.807444267883387],
            [16.026118631665565, 2.817281439327005],
            [16.037344374621394, 2.8324491607761395],
            [16.047623142825895, 2.8474158654231867],
            [16.055668009635635, 2.855553746404493],
            [16.063447642148013, 2.860294808458113],
            [16.078612320484453, 2.864848017658004],
            [16.091021929716398, 2.8661484638145613],
            [16.106725965854537, 2.869940462750889],
            [16.126843458948976, 2.8800821146906923],
            [16.132643738609776, 2.883449533227624],
            [16.141703820990443, 2.890549535005842],
            [16.147814449500622, 2.8975935553826284],
            [16.155117792265276, 2.90558667574211],
            [16.161294973996014, 2.914694118610729],
            [16.165685791676054, 2.9170124390411356],
            [16.190639103134664, 2.9243343626200224],
            [16.194179484091762, 2.926435367054352],
            [16.196490152156972, 2.930293989567743],
            [16.207021262123586, 2.9256638713056873],
            [16.205031718309634, 2.9209460008623593],
            [16.210281079579755, 2.9188072969824352],
            [16.214517109003875, 2.911604478025808],
            [16.218411137488697, 2.912426419852578],
            [16.22173501857821, 2.910609679525127],
            [16.222595742489705, 2.9062874131799528],
            [16.226327841299508, 2.9077025762096618],
            [16.23828044666357, 2.9021380111702264],
            [16.24226866923788, 2.8985884393392287],
            [16.24371113702187, 2.895387530799299],
            [16.2485089165458, 2.8942406610059472],
            [16.246592446741612, 2.8900611312658278],
            [16.250487362103744, 2.8859506788039946],
            [16.249807473065417, 2.882584432733141],
            [16.25218713620066, 2.8795350220032985],
            [16.24934713001232, 2.8720772611049075],
            [16.25349601582691, 2.8648926100370726],
            [16.264071218488507, 2.857442845155501],
            [16.263100145062943, 2.852930764087102],
            [16.265482809839977, 2.8494409526514812],
            [16.2648256342475, 2.844139553841863],
            [16.260680794892895, 2.844529317528141],
            [16.259567883261088, 2.8391912922905287],
            [16.259457999791568, 2.832114731210694],
            [16.265924206241213, 2.834889962607185],
            [16.27010047390227, 2.828693674952506],
            [16.27313369999425, 2.831583409837436],
            [16.27060770841074, 2.8348222054021273],
            [16.274588502459135, 2.838331931493075],
            [16.275278204915782, 2.8409250938460393],
            [16.28603549907659, 2.8387067122057825],
            [16.289606466927893, 2.830253847835828],
            [16.294037482454502, 2.8268396002015166],
            [16.29804478596181, 2.8214793349229277],
            [16.303586680250376, 2.816438004489253],
            [16.315019796481156, 2.810270404169726],
            [16.316965686618964, 2.8020392625147905],
            [16.31869442920822, 2.8007116323257746],
            [16.31695833455733, 2.7943652597210673],
            [16.32434310822325, 2.7913225010623863],
            [16.337663490795443, 2.7880557190314046],
            [16.342384219891212, 2.7850212165467796],
            [16.344164243961586, 2.779618866381997],
            [16.34952910675084, 2.7769957600333806],
            [16.362228363179504, 2.775237086456892],
            [16.371311244499914, 2.778125675726916],
            [16.37685412305872, 2.7752549548344403],
            [16.384004467654563, 2.776125399447721],
            [16.390084654603303, 2.773949944605947],
            [16.399309065109513, 2.765733294163921],
            [16.407247975285216, 2.7600997808743695],
            [16.416863797793496, 2.746916483460037],
            [16.419481907504824, 2.738492957552384],
            [16.42286269662578, 2.7304293405402467],
            [16.42374963121672, 2.7255337374178663],
            [16.429397463046993, 2.7174363431731585],
            [16.438416195981354, 2.71256550430006],
            [16.44005775412617, 2.706272950867356],
            [16.447079972837656, 2.7033618339002605],
            [16.450065986537517, 2.6999671415690782],
            [16.453418175913676, 2.698739068372052],
            [16.393668251265712, 2.5887617268465544],
            [16.324696860705696, 2.6288809431955653],
            [16.259555391787103, 2.667690494778498],
            [16.205298407021733, 2.699543720627838],
            [16.200210096281626, 2.702668582319551],
            [16.197745066483126, 2.7004653168373833],
            [16.191039621177385, 2.697957850570037],
            [16.186910672233243, 2.6943331952584315],
            [16.183243122605845, 2.6948154707628715],
            [16.176679704029674, 2.6916810740201242],
            [16.167098790977246, 2.6922987328969334],
            [16.162096809864877, 2.695850964553778],
            [16.15979474991755, 2.7037649133848443],
            [16.15084837154619, 2.706883576183841],
            [16.145891009545632, 2.706350694915822],
            [16.13277180554672, 2.7009441504829983],
            [16.12518310760136, 2.7057869543237665],
            [16.109263161408432, 2.707677356062865],
            [16.100609376090926, 2.7050859031699654],
            [16.099484477167735, 2.710572305354464],
            [16.092266026155105, 2.713064782859834],
            [16.090870740182154, 2.716511099391651],
            [16.081701082531172, 2.7178211890551407],
            [16.078698687813286, 2.721432501355246],
            [16.070745732174018, 2.7217421416896923],
            [16.069633201398368, 2.7245705147842894],
            [16.064576810256437, 2.7249698845487322],
            [16.064782775341083, 2.7276066249196664],
            [16.055799616806297, 2.7320525547313483],
            [16.054791733555703, 2.7429111028450337],
            [16.052972539764657, 2.7434086495709775],
            [16.051648921720474, 2.7502611181834538],
            [16.04835713567731, 2.7528831937563707],
            [16.044447335929632, 2.750766156274425],
            [16.04149296464073, 2.7542473036480706],
            [16.03932976087148, 2.752777158325768],
            [16.036286178994583, 2.757831644572718],
            [16.03845668628054, 2.763426349173701],
            [16.028434692566996, 2.7619886656799473],
            [16.025901366687044, 2.763734588762566],
            [16.02546639395645, 2.769377279214494],
            [16.031043842783316, 2.770801100350818],
            [16.026964050752145, 2.779399519341866],
            [16.02434402997369, 2.7831040392464304],
            [16.022097209755806, 2.7811049665750143],
            [16.019052813425542, 2.7872142672778426],
            [16.015615505495333, 2.7836943879117526],
            [16.01259104299654, 2.7836645059709104],
            [16.01026631591132, 2.7873846594404617],
            [16.019115159256557, 2.796187196249616]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.14133358469378, "lat": 39.71723786447556 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34015"],
        "coty_name": ["Gloucester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gloucester County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00882277"
      },
      "bbox": [
        16.01026631591132, 2.5887617268465544, 16.453418175913676,
        2.930293989567743
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.588345617448553, 3.216079438635202],
            [16.604879307070064, 3.231393332200516],
            [16.638882169127704, 3.2788116119120985],
            [16.675317920552764, 3.3325079261541637],
            [16.78369744267032, 3.352056227550515],
            [16.787397708206385, 3.3460260227951313],
            [16.787238258050664, 3.34154782780109],
            [16.789024111360785, 3.3346971183318055],
            [16.79395637981276, 3.334425635462485],
            [16.798203181887484, 3.3313989366382684],
            [16.801963462606864, 3.323855037595898],
            [16.806430797208435, 3.3200306335821037],
            [16.807337273765, 3.3069819968678384],
            [16.812329839096286, 3.3021884494686073],
            [16.81856283771945, 3.3010145470199994],
            [16.82432340821013, 3.301461737396259],
            [16.833049832228486, 3.304654653437902],
            [16.84007485898111, 3.3087484215005882],
            [16.84597712467667, 3.309821191921249],
            [16.854573159750302, 3.3097403306365467],
            [16.85705213154496, 3.3111038736793974],
            [16.863369818932114, 3.3092469056271514],
            [16.872088722584888, 3.3105696281064554],
            [16.87812308356796, 3.304425389070971],
            [16.881334782664766, 3.304304545486597],
            [16.904026740814018, 3.3490655940154177],
            [16.90781340646597, 3.3472640816816606],
            [16.912517941148234, 3.3415047566206533],
            [16.91899086337261, 3.328505893259674],
            [16.920744551744765, 3.3224557942335835],
            [16.931401608757742, 3.3125895246049697],
            [16.942610159461957, 3.308848122855932],
            [16.95013582435484, 3.3187878142115506],
            [16.95042000737964, 3.3225085521180753],
            [16.957044885380316, 3.328678069669272],
            [16.96295480766672, 3.3290589978418317],
            [16.96665382613032, 3.3275044481136664],
            [16.967051728320033, 3.3261477752836788],
            [16.96688340096546, 3.3063373193465617],
            [16.97256307402055, 3.2015056701800853],
            [16.976684203415243, 3.164971249155055],
            [16.97868879503014, 3.131911415956728],
            [16.984041165032252, 3.0839803033674236],
            [16.993290108789502, 3.0217214680014735],
            [16.99629920465409, 2.9894707119056747],
            [16.995879070976557, 2.982404763224165],
            [16.997976317049453, 2.977579825749817],
            [16.99646306629437, 2.9714949175214884],
            [16.992399242139754, 2.964813814284533],
            [16.989413140042966, 2.9533238189451265],
            [16.98156319928192, 2.9043315209615734],
            [16.95968673568312, 2.8324376417936024],
            [16.939053849811334, 2.755653680407367],
            [16.93423269962941, 2.7467528586746024],
            [16.928095101548994, 2.7279477181185947],
            [16.92593417477587, 2.7263065460056133],
            [16.91567829172034, 2.705071930279406],
            [16.913328426011947, 2.701598607762302],
            [16.899710221047407, 2.698705586472049],
            [16.888431036178726, 2.6948638874821857],
            [16.88654796485132, 2.692297036458822],
            [16.877340539306825, 2.6907045587149323],
            [16.865998091991713, 2.68674966594826],
            [16.86177665484458, 2.6821032512292473],
            [16.84780564357397, 2.6752591142317894],
            [16.823293064837653, 2.710355808037589],
            [16.815362938419963, 2.7180308927628123],
            [16.809768194195144, 2.7195282556712543],
            [16.8072053925168, 2.7266483809788733],
            [16.808588282204337, 2.7308192469390566],
            [16.803537477180697, 2.736744110214116],
            [16.80524842272704, 2.7398616095953567],
            [16.809283832976394, 2.74137371791814],
            [16.813504274943895, 2.7408705011641996],
            [16.81613094963169, 2.744218484473724],
            [16.817213543224234, 2.7502058025219878],
            [16.81641646458351, 2.753881662092579],
            [16.817390747495494, 2.7676053135389544],
            [16.818434230973786, 2.7695446285577137],
            [16.811463810652732, 2.7998560918602404],
            [16.77865539731616, 2.943582731573528],
            [16.73281685560938, 3.007608559762801],
            [16.72703842616761, 3.0163653930728898],
            [16.685074040311637, 3.0763770484871737],
            [16.642725816263805, 3.137756522539718],
            [16.616254631783093, 3.1785951667463013],
            [16.610825883996345, 3.186214612786386],
            [16.588345617448553, 3.216079438635202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.28145578367365, "lat": 39.8855984725049 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34029"],
        "coty_name": ["Ocean"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ocean County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00882279"
      },
      "bbox": [
        16.588345617448553, 2.6752591142317894, 16.997976317049453,
        3.352056227550515
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.10445448991683, -3.0491844879940375],
            [-9.879606162827047, -3.0800691900739476],
            [-9.801457454764572, -3.090465377409929],
            [-9.681706761116171, -3.1070155172226683],
            [-9.64032627086952, -3.1125198184364202],
            [-9.638828470815227, -3.098208863198888],
            [-9.625372445438641, -2.9963266775888995],
            [-9.621320806677923, -2.9675592691389294],
            [-9.617581737614092, -2.9385866592547023],
            [-9.612207083339396, -2.9041642638980893],
            [-9.608061996698966, -2.8731171855933644],
            [-9.59391109461773, -2.765474647357693],
            [-9.571866764285136, -2.768338086896302],
            [-9.41602857345484, -2.788825201901028],
            [-9.345349836016217, -2.7979960660993113],
            [-9.326217672371326, -2.8003054061694166],
            [-9.317083553626093, -2.8019403013046094],
            [-9.27427225683008, -2.8075250025304626],
            [-9.210238513167834, -2.8164510563347758],
            [-9.086015607698087, -2.8323300785293877],
            [-9.004763870563048, -2.8425032368863263],
            [-8.999415817686991, -2.799346737114616],
            [-8.942951829959727, -2.8064122618118894],
            [-8.914397304864519, -2.809664661884661],
            [-8.920193562477516, -2.8536012103631236],
            [-8.836779917635695, -2.8646671281677216],
            [-8.66352261076533, -2.8833122057267913],
            [-8.606916363518549, -2.8902326288597293],
            [-8.583663462697631, -2.9802823826440745],
            [-8.573021427228737, -3.019364572557685],
            [-8.5341405808953, -3.1634142219079693],
            [-8.519296293856108, -3.2175697847203018],
            [-8.509284182555737, -3.2549832955360825],
            [-8.61926105439152, -3.241673314663548],
            [-8.62606971685541, -3.3004219142712405],
            [-8.629799696844387, -3.329602197729131],
            [-8.636706931100214, -3.387677553978435],
            [-8.640326573733855, -3.4161290865961123],
            [-8.661833647792696, -3.59015188310652],
            [-8.659879450138556, -3.5903929835439574],
            [-8.663257207995391, -3.6204289253863453],
            [-8.745370354906434, -3.6101228287501903],
            [-8.76845043106499, -3.6071055322559737],
            [-8.775700109980624, -3.6067704695293146],
            [-8.818859846055421, -3.600992147859454],
            [-8.917207176266503, -3.589190436591188],
            [-8.932155913931014, -3.586281809568066],
            [-8.946363283689815, -3.5861792437764493],
            [-9.06030093210412, -3.5717956538015048],
            [-9.0751117756574, -3.571591880158701],
            [-9.087392685068563, -3.5697587858452082],
            [-9.17201141407112, -3.5581873300838693],
            [-9.185997942424056, -3.5566626713968135],
            [-9.318837233407145, -3.539618063044064],
            [-9.35909151217676, -3.5339409905802603],
            [-9.609606920369464, -3.5026289266383683],
            [-9.623996490216637, -3.5006238728631],
            [-9.923271318590386, -3.4606570569957213],
            [-9.936184386716397, -3.458517346099515],
            [-9.943275693827376, -3.458461738055179],
            [-9.95036060225398, -3.456620054705179],
            [-9.9572235281394, -3.4559735363538375],
            [-10.013877026564955, -3.447516661689251],
            [-10.034689356764655, -3.445374200866804],
            [-10.106431025271943, -3.435506430688444],
            [-10.157203945374619, -3.4286384161786323],
            [-10.141001259186295, -3.3117986783033304],
            [-10.130696103689495, -3.237479201332402],
            [-10.128127277128716, -3.223208681989411],
            [-10.12671408057465, -3.20859037063916],
            [-10.124361409711893, -3.1944366309518104],
            [-10.122744058142024, -3.1800845389447563],
            [-10.10445448991683, -3.0491844879940375]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.99979837967612,
          "lat": 34.91248491086317
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35006"],
        "coty_name": ["Cibola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cibola County"],
        "coty_fp_code": "006",
        "coty_gnis_code": "00933051"
      },
      "bbox": [
        -10.157203945374619, -3.6204289253863453, -8.509284182555737,
        -2.765474647357693
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.960578936348764, -2.007911671977885],
            [-9.954391282648594, -2.0091080302995663],
            [-9.89192801098703, -2.0173612755200394],
            [-9.786822878143953, -2.0316651132558063],
            [-9.653335831784966, -2.049638911785774],
            [-9.426804771865017, -2.0799980236047437],
            [-9.34557569115901, -2.0907866343423454],
            [-9.290452903196014, -2.097606336941216],
            [-9.261115142883552, -2.1010305636072006],
            [-9.131300695033987, -2.118233826472674],
            [-9.035395546280013, -2.130897597213775],
            [-8.975026188453965, -2.138891364936168],
            [-8.832674344848705, -2.157493817827975],
            [-8.777385094373411, -2.1642983709627006],
            [-8.676628600714464, -2.1773669258180024],
            [-8.579955154509108, -2.1898723053659266],
            [-8.593478112578925, -2.303192643781325],
            [-8.602286823623224, -2.37695654102294],
            [-8.610957799409338, -2.448746523280686],
            [-8.617580117963492, -2.5059926147235263],
            [-8.629423457894758, -2.6054516938844454],
            [-8.635905154958335, -2.663313580838731],
            [-8.6473270685888, -2.7701959505519467],
            [-8.65064999538895, -2.7693171086651542],
            [-8.66352261076533, -2.8833122057267913],
            [-8.836779917635695, -2.8646671281677216],
            [-8.920193562477516, -2.8536012103631236],
            [-8.914397304864519, -2.809664661884661],
            [-8.942951829959727, -2.8064122618118894],
            [-8.999415817686991, -2.799346737114616],
            [-9.004763870563048, -2.8425032368863263],
            [-9.086015607698087, -2.8323300785293877],
            [-9.210238513167834, -2.8164510563347758],
            [-9.27427225683008, -2.8075250025304626],
            [-9.317083553626093, -2.8019403013046094],
            [-9.326217672371326, -2.8003054061694166],
            [-9.345349836016217, -2.7979960660993113],
            [-9.41602857345484, -2.788825201901028],
            [-9.571866764285136, -2.768338086896302],
            [-9.59391109461773, -2.765474647357693],
            [-9.608061996698966, -2.8731171855933644],
            [-9.612207083339396, -2.9041642638980893],
            [-9.617581737614092, -2.9385866592547023],
            [-9.621320806677923, -2.9675592691389294],
            [-9.625372445438641, -2.9963266775888995],
            [-9.638828470815227, -3.098208863198888],
            [-9.64032627086952, -3.1125198184364202],
            [-9.681706761116171, -3.1070155172226683],
            [-9.801457454764572, -3.090465377409929],
            [-9.879606162827047, -3.0800691900739476],
            [-10.10445448991683, -3.0491844879940375],
            [-10.09617983698568, -2.9890764570272124],
            [-10.076010042035977, -2.8425490420739465],
            [-10.064588828462691, -2.7595703230917983],
            [-10.049480446590534, -2.646114848484998],
            [-10.029289875331507, -2.5015729948036562],
            [-10.014476336783357, -2.395906363342901],
            [-10.003235368523328, -2.315080303546561],
            [-9.98782069141684, -2.2042454710324333],
            [-9.977592270249964, -2.1306952455917916],
            [-9.960578936348764, -2.007911671977885]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.26179288507188,
          "lat": 35.580662872999255
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35031"],
        "coty_name": ["McKinley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McKinley County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00929107"
      },
      "bbox": [
        -10.10445448991683, -3.1125198184364202, -8.579955154509108,
        -2.007911671977885
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.115245390732076, -3.310036633831942],
            [-5.889013227563341, -3.205690186369662],
            [-5.890718050434362, -3.227514046595248],
            [-5.878926035686545, -3.229386096332887],
            [-5.803068718080865, -3.235596091388397],
            [-5.712996261585523, -3.243612442406209],
            [-5.705254494406514, -3.1464869718106394],
            [-5.700881732774678, -3.094176637147985],
            [-5.607627890987336, -3.101747347761579],
            [-5.501028405600336, -3.1100248517398628],
            [-5.493037469958135, -3.1033971886137066],
            [-5.485234240579611, -3.0050514775302757],
            [-5.479817365238697, -2.9362151606012468],
            [-5.472753186780379, -2.846526511394471],
            [-5.469380556738185, -2.846790520345418],
            [-5.4625150745328055, -2.759376129583604],
            [-5.194763548030378, -2.7797820051532574],
            [-5.2037247213138835, -2.8973036363886826],
            [-5.221133009920525, -3.126105551170803],
            [-5.232192875195737, -3.2714258196018164],
            [-5.2331816834436955, -3.2802586536031493],
            [-5.237198034996244, -3.3386192984884726],
            [-5.240336500395075, -3.37717446639794],
            [-5.242250612388868, -3.396900009054364],
            [-5.242880962809674, -3.4121443463788377],
            [-5.2466468604177665, -3.463101900449124],
            [-5.254439233341931, -3.5685356120350944],
            [-5.450222724726033, -3.553749927095874],
            [-5.457245122857884, -3.643236618397205],
            [-5.542778319969375, -3.6361907972500127],
            [-5.550003261727681, -3.723754024102759],
            [-5.635535834438633, -3.716599071472481],
            [-5.642467182478313, -3.80404401410369],
            [-5.75590180511275, -3.794516833349358],
            [-5.813194012531491, -3.7893288986329097],
            [-5.820577696963148, -3.8769793161579633],
            [-5.846665615429802, -3.8747276922930074],
            [-5.846707489249521, -3.875199633171619],
            [-5.847679000112077, -3.8749297898660995],
            [-6.018032863686573, -3.860669476152127],
            [-6.164529113070665, -3.848132855124614],
            [-6.1497440541277415, -3.673555415147751],
            [-6.141913662961403, -3.581707782263251],
            [-6.134545087037829, -3.4978209905087243],
            [-6.1323294110685165, -3.4980166353522755],
            [-6.120307013789654, -3.368848571152375],
            [-6.115245390732076, -3.310036633831942]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.54975989617812,
          "lat": 35.10430357225026
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35037"],
        "coty_name": ["Quay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Quay County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00929110"
      },
      "bbox": [
        -6.164529113070665, -3.8769793161579633, -5.194763548030378,
        -2.759376129583604
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.345345643616248, 5.047938022077164],
            [13.408616989180672, 5.060362404707502],
            [13.450184992244761, 5.06814013932836],
            [13.503608512782227, 5.077730617585091],
            [13.53917082014741, 5.084545764480881],
            [13.539972981565159, 5.085043539024626],
            [13.537225455572877, 5.0815706787332715],
            [13.613784447701844, 5.095868935980284],
            [13.682774840078597, 5.1085731536664705],
            [13.691363417372399, 5.066124567170398],
            [13.757029360962063, 5.075900425852187],
            [13.776375234161714, 5.07912671476975],
            [13.783290746498121, 5.036806569110461],
            [13.787030625300075, 5.012580925548936],
            [13.783453167933121, 5.011967949700573],
            [13.79311666295595, 4.9524550944513015],
            [13.805203478214857, 4.8759574572869795],
            [13.80976899964679, 4.845649009268595],
            [13.824108223754614, 4.75455706749674],
            [13.831088539526434, 4.712717552720665],
            [13.847747634590911, 4.610130401929836],
            [13.788325086143125, 4.598377870833863],
            [13.66837904469005, 4.57558782351628],
            [13.643854053519025, 4.571577137074462],
            [13.575850911326695, 4.559700884943559],
            [13.516815197403123, 4.547681282771006],
            [13.469938790318691, 4.538174668966248],
            [13.443081214722634, 4.533583855818049],
            [13.432229415314902, 4.590372741912217],
            [13.427489471947643, 4.61384119743693],
            [13.420132587283575, 4.652870889864637],
            [13.409853900272058, 4.705946249963164],
            [13.393539795986717, 4.7915601900275755],
            [13.374947300806864, 4.890532462582143],
            [13.370330235958107, 4.916864612442257],
            [13.361480249547517, 4.964513271095321],
            [13.345345643616248, 5.047938022077164]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.02757814803884, "lat": 42.25742806457233 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36003"],
        "coty_name": ["Allegany"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allegany County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00974100"
      },
      "bbox": [
        13.345345643616248, 4.533583855818049, 13.847747634590911,
        5.1085731536664705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.36272682664123, 7.984274681351659],
            [15.364531917978665, 7.9879349437464215],
            [15.37751544241374, 7.996213276031917],
            [15.390747679392579, 7.995507217049047],
            [15.397991077113169, 7.998417272728072],
            [15.398714015112514, 8.003922309595751],
            [15.406256708680873, 7.99891287525184],
            [15.483868565503865, 8.015603216035084],
            [15.547207196545333, 8.028339684578919],
            [15.632546225262498, 8.04266713077392],
            [15.702002386011772, 8.058906517831852],
            [15.762205397957716, 8.072170071973623],
            [15.84333858307973, 8.09536896353746],
            [15.865978955531562, 8.035845990757506],
            [15.879719604687422, 8.001779120961327],
            [15.882791295484967, 7.99276321089091],
            [15.88930840942609, 7.967465165553153],
            [15.894049470396471, 7.945370880468756],
            [15.904496024966472, 7.918598380921136],
            [15.908589729012355, 7.906544639725614],
            [15.919449728405814, 7.8776182340227985],
            [15.937749089530772, 7.823876023944964],
            [15.951406895672228, 7.8284405795352665],
            [15.996323662970882, 7.7019732009458615],
            [16.004989462648844, 7.705358523756539],
            [16.030318383144266, 7.6380627049524685],
            [16.03293412676974, 7.629756909318279],
            [16.054890328431007, 7.567474771619244],
            [15.977125830855837, 7.537882223367695],
            [15.899369386730445, 7.508272088298778],
            [15.920425655670927, 7.451917475338851],
            [15.928082143523055, 7.432298947858333],
            [15.93557814089829, 7.414327935336561],
            [15.950576284097659, 7.371054046171508],
            [15.994409103607483, 7.2548586415158995],
            [15.90891577752324, 7.223158210481694],
            [15.90380526928671, 7.220998671775945],
            [15.867077901946702, 7.207907183312214],
            [15.804325329668723, 7.184977662653476],
            [15.797329420211737, 7.182670959468729],
            [15.695307187797354, 7.146744405761555],
            [15.67304100681405, 7.213336816500364],
            [15.685868556762752, 7.217508765749966],
            [15.670325029801198, 7.263887139566563],
            [15.625808481757717, 7.388855640786797],
            [15.614783629736106, 7.420277577878412],
            [15.577719135988737, 7.5274564781962505],
            [15.51877809839163, 7.695631084746509],
            [15.504729227510543, 7.7352296567632495],
            [15.473985721242189, 7.82656205275407],
            [15.430235375386621, 7.95655731878248],
            [15.376109335175478, 7.944724132240624],
            [15.36272682664123, 7.984274681351659]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.30382982096862,
          "lat": 44.592865814087425
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36033"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00974115"
      },
      "bbox": [
        15.36272682664123, 7.146744405761555, 16.054890328431007,
        8.09536896353746
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.15345879279374, 5.463485975785925],
            [16.19528036572007, 5.492500355285389],
            [16.198064506466846, 5.489832291598494],
            [16.20136652477681, 5.490068827676613],
            [16.213019622421918, 5.487110347746353],
            [16.222982910178143, 5.4801880169098975],
            [16.226009667709434, 5.483754423246258],
            [16.234558817583213, 5.484592962075469],
            [16.23723212624899, 5.487739930181695],
            [16.242442681067057, 5.489121884477181],
            [16.246624199435633, 5.487087770755149],
            [16.24888913386692, 5.4904165906543785],
            [16.25475175328052, 5.494609465969194],
            [16.25968664799425, 5.49434694375347],
            [16.265973000568447, 5.496368596794285],
            [16.27089297324087, 5.499141273435099],
            [16.274824273179906, 5.5052005616746875],
            [16.276404880251782, 5.511951014373988],
            [16.27996456978166, 5.517498706143308],
            [16.288458992864413, 5.519468829918362],
            [16.290582362433998, 5.517910903523977],
            [16.276624739707657, 5.546614045862855],
            [16.33096939305402, 5.56823292326335],
            [16.364566489686624, 5.5822610185156805],
            [16.370943193545006, 5.584390298969483],
            [16.431664439597572, 5.60979459418711],
            [16.454301014673792, 5.618999509502181],
            [16.48727535125942, 5.631801619479145],
            [16.499161718293898, 5.636643749926361],
            [16.536375969702075, 5.653326527511279],
            [16.563063794425823, 5.665507280945289],
            [16.59957107136973, 5.679951572363804],
            [16.603515581953406, 5.679919542022025],
            [16.604862207027153, 5.674840795092012],
            [16.609336122823166, 5.669123559359721],
            [16.611446779964314, 5.66197811460293],
            [16.6132042654076, 5.647874897741311],
            [16.61218562505898, 5.624336046726587],
            [16.612690535110225, 5.610996201336059],
            [16.611410179749562, 5.602110999147124],
            [16.612782377660764, 5.591290811967553],
            [16.615494264564358, 5.587947856698912],
            [16.618721562001596, 5.577399754748264],
            [16.617948520173304, 5.573052968121678],
            [16.62166166509111, 5.5683908847961705],
            [16.632978827754698, 5.544464432935198],
            [16.632772973108963, 5.539382130076683],
            [16.63880084683501, 5.5259837192334285],
            [16.640037020825748, 5.513122860448185],
            [16.642134521290902, 5.500792198343502],
            [16.6416687254617, 5.489728482901488],
            [16.63970099357312, 5.482268618689156],
            [16.63488294880601, 5.471456372577005],
            [16.626790831614343, 5.466603730978466],
            [16.622327902467326, 5.460759610119102],
            [16.617817981892987, 5.459203477292796],
            [16.614537440013248, 5.454718220703151],
            [16.608246506969817, 5.441144699176946],
            [16.6080248432218, 5.4310639201153075],
            [16.611873657994114, 5.420670362888055],
            [16.61197190961701, 5.4019179903563765],
            [16.607879356163526, 5.391727596656784],
            [16.60207055140715, 5.3815516815074735],
            [16.596748791398447, 5.376198505122108],
            [16.59151074366184, 5.373904766465742],
            [16.590935513961156, 5.370322996686195],
            [16.592349304391348, 5.3617479505365235],
            [16.590468011581073, 5.355941831925746],
            [16.590165862083968, 5.343655693960848],
            [16.587161196870685, 5.330000780016239],
            [16.580915125560924, 5.3304515985621235],
            [16.521021983370666, 5.357781555638999],
            [16.509896685153826, 5.363027949088071],
            [16.51222797054158, 5.349539656844382],
            [16.497257555406943, 5.344760998929662],
            [16.482803941617902, 5.349873294127982],
            [16.476575501491936, 5.272408444562929],
            [16.366386153348518, 5.2584548740296935],
            [16.30550427827303, 5.250903826617281],
            [16.220173356569315, 5.2728995279802096],
            [16.189633417572733, 5.2806761834606695],
            [16.154402143239686, 5.289566403206223],
            [16.1512925050316, 5.290078985518523],
            [16.12097347702664, 5.298063855680466],
            [16.148804318081602, 5.398965395320071],
            [16.165756073841898, 5.460201203396495],
            [16.15345879279374, 5.463485975785925]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.12278199509858,
          "lat": 42.276504778535795
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36039"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00974118"
      },
      "bbox": [
        16.12097347702664, 5.250903826617281, 16.642134521290902,
        5.679951572363804
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.772668043817669, 6.087737661176059],
            [15.849077614397679, 6.076223036163078],
            [15.89103322487205, 6.070032561175723],
            [15.910833911529505, 6.066633309744626],
            [15.94072551170401, 6.06243728931376],
            [15.978763010899057, 6.0707133561439965],
            [16.05010804954631, 6.086526035421462],
            [16.13503863516695, 6.105869379134919],
            [16.192218915647757, 6.118129966893694],
            [16.19772235549199, 6.119504022490923],
            [16.245972644595028, 6.130089715433877],
            [16.256578333511438, 6.132681990237638],
            [16.265974525940692, 6.107075656229281],
            [16.2758829358489, 6.080056974121887],
            [16.285869669018854, 6.0516115760364935],
            [16.261332605590102, 6.024546705861778],
            [16.229235937531723, 5.990414015018991],
            [16.182628377997823, 5.940140188436624],
            [16.18493726251554, 5.936838068390656],
            [16.183663414764624, 5.93028375405159],
            [16.179920662886992, 5.926615686476864],
            [16.18159809416619, 5.9237937348983145],
            [16.16593154145817, 5.907092105461727],
            [16.140951640917656, 5.900933038197382],
            [16.050771385100315, 5.869445696964906],
            [15.99838286423163, 5.882751562039918],
            [15.965294358561945, 5.890891325372883],
            [15.938737828135478, 5.891719031133082],
            [15.900557413788782, 5.89322845903898],
            [15.811297024954571, 5.907556475625255],
            [15.805699940735831, 5.97065812514749],
            [15.804361203244271, 5.978718503780096],
            [15.798821479696732, 6.032979957703211],
            [15.79765551777971, 6.043030311704653],
            [15.794842606005757, 6.043516977245619],
            [15.795202635199587, 6.052142077068849],
            [15.792918116141065, 6.062493479087972],
            [15.787791342380777, 6.074051459329809],
            [15.785346351929197, 6.077260743971938],
            [15.779875459655392, 6.0810583674712895],
            [15.77420770089864, 6.083153741694604],
            [15.772668043817669, 6.087737661176059]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.43967327100684, "lat": 42.90228972669386 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36057"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00974127"
      },
      "bbox": [
        15.772668043817669, 5.869445696964906, 16.285869669018854,
        6.132681990237638
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.987658036457587, 5.0773844730525],
            [16.01302480597345, 5.069301345190815],
            [16.074405519389977, 5.051063379351165],
            [16.133800013362677, 5.032694613279549],
            [16.153985923527753, 5.026006624604873],
            [16.254684744987028, 4.993359805770661],
            [16.25470138672783, 4.992845626251253],
            [16.23941152838264, 4.94738816457826],
            [16.21179960580402, 4.883976871892386],
            [16.202404859233923, 4.859744665671033],
            [16.196576293245503, 4.845813433087594],
            [16.24290422997819, 4.8241549462715865],
            [16.26808982654461, 4.812668470633822],
            [16.323836613673155, 4.7877791130281775],
            [16.349283547077803, 4.777440321792111],
            [16.35196555626125, 4.774311274878249],
            [16.35448875823844, 4.766869497529495],
            [16.35987652564006, 4.760530272484232],
            [16.360040286129195, 4.757024551702142],
            [16.36402006190945, 4.750249238144148],
            [16.366637493378228, 4.749748044530901],
            [16.37010099975306, 4.741703315403574],
            [16.37226857148652, 4.741202551189483],
            [16.373574459397286, 4.7349224049628855],
            [16.37622830065814, 4.733549492756859],
            [16.381425817659018, 4.734088372463365],
            [16.38178138176281, 4.729382328997134],
            [16.380130250658798, 4.726540655147542],
            [16.371492099697573, 4.719691434843895],
            [16.36797559834713, 4.718636125048571],
            [16.36359956789585, 4.714587380183362],
            [16.36329065801913, 4.708744801510754],
            [16.360155390829753, 4.708267506526466],
            [16.357165883871854, 4.704474956340091],
            [16.35596919413075, 4.69996893467262],
            [16.350333232617114, 4.698355391609927],
            [16.35016538157552, 4.6926629675216605],
            [16.348157397917088, 4.689575253304196],
            [16.34377231003092, 4.686621813660693],
            [16.339925468667357, 4.674745538936428],
            [16.340225006830945, 4.670374892783612],
            [16.337635275007734, 4.667614534446218],
            [16.337881564743824, 4.663867596875003],
            [16.334607210180298, 4.658704897041307],
            [16.330814446672353, 4.656728947873032],
            [16.32941096665901, 4.648955878901624],
            [16.325829699311765, 4.646283672644162],
            [16.32727901639461, 4.640452598435635],
            [16.32119006859097, 4.632206311249628],
            [16.32350560719405, 4.629295285051084],
            [16.322962208022727, 4.626133734577036],
            [16.31685119335596, 4.625042824551186],
            [16.264367549438415, 4.60991652715146],
            [16.261939765057267, 4.60869125648995],
            [16.21929015259682, 4.596704173420611],
            [16.12474253593225, 4.570388104867891],
            [16.123373954884336, 4.5676693256539815],
            [16.119419171764537, 4.566139694929935],
            [16.119021712809946, 4.563242356774756],
            [16.12214372781388, 4.557553029286448],
            [16.126550826521278, 4.555453702979726],
            [16.12949669991809, 4.549727559162567],
            [16.130070936529123, 4.545163790502814],
            [16.132588226529453, 4.541227867449766],
            [16.126690245747604, 4.536778827563998],
            [16.129038958100434, 4.530715062733579],
            [16.12732136051964, 4.525416545355948],
            [16.128590522800298, 4.520374268162884],
            [16.13103416790065, 4.519110402740107],
            [16.135413140338112, 4.511199454284586],
            [16.13881645782618, 4.510456130249206],
            [16.136511909626353, 4.505330143464778],
            [16.138428172933544, 4.502657174093497],
            [16.13221263008913, 4.499825520266326],
            [16.12658664009055, 4.50124874580478],
            [16.12148456325637, 4.498933405079342],
            [16.117510550195, 4.495244833904719],
            [16.11326504528639, 4.4935248517895054],
            [16.10913509381991, 4.4949809165996495],
            [16.104494271454154, 4.501462706679218],
            [16.101758010948817, 4.507860016048135],
            [16.09765265222831, 4.511053809092225],
            [16.09276456939865, 4.510856580398839],
            [16.089056882285053, 4.5074669651230135],
            [16.083553089926642, 4.496120602850618],
            [16.077308081296, 4.495665651332965],
            [16.06692579432887, 4.5021347696627485],
            [16.058743906607535, 4.504665380464603],
            [16.054407871935073, 4.503240760200544],
            [16.046490246821833, 4.497691569702651],
            [16.038267260102515, 4.4936980891135105],
            [16.034329412998577, 4.493502737052562],
            [16.031804549380386, 4.496281003129362],
            [16.03199953910374, 4.500362571190453],
            [16.035105459062937, 4.506362228531712],
            [16.033269167368445, 4.510150219015483],
            [16.029215718645055, 4.51218973159301],
            [16.019990810828755, 4.513143141064149],
            [16.015819289958856, 4.523848236037078],
            [16.012697073436403, 4.526409830840038],
            [16.003962794176264, 4.5260250221057134],
            [15.996654634226262, 4.529722630455305],
            [15.98699453448624, 4.528469630976249],
            [15.985793695235836, 4.525534891339595],
            [15.979346687347421, 4.51973291309736],
            [15.970683201753145, 4.518862590119737],
            [15.961595795823294, 4.519406903938707],
            [15.95742800284698, 4.524566820476178],
            [15.957355473621492, 4.535469543525124],
            [15.953729167383932, 4.545101953827652],
            [15.950886134357468, 4.54665500524835],
            [15.94250542758762, 4.543400218651347],
            [15.93871610519927, 4.546379930396114],
            [15.93928516144253, 4.553220343252439],
            [15.935755663846537, 4.559033913175914],
            [15.930649109920916, 4.5624302342317575],
            [15.924723564134558, 4.564861102685855],
            [15.919854519722326, 4.564839565958595],
            [15.91709651702876, 4.571073036660628],
            [15.921647120031714, 4.5751103647587685],
            [15.92175647844548, 4.579012922811574],
            [15.918995420278366, 4.583852513355085],
            [15.910015835447291, 4.593928904431147],
            [15.905457926583152, 4.594506536955783],
            [15.899135697066031, 4.5978246427767075],
            [15.895489068504482, 4.602574608421453],
            [15.891603041649423, 4.610110005054482],
            [15.886191635848778, 4.6135477163070435],
            [15.88034030061496, 4.615371354971756],
            [15.870920431107065, 4.624464321184725],
            [15.865994227236145, 4.629761773634941],
            [15.8704480307772, 4.633058772664881],
            [15.87614648029068, 4.6350077863193935],
            [15.873706900819718, 4.639266574232751],
            [15.878670329710268, 4.643654727518461],
            [15.88321490370572, 4.6419226185928055],
            [15.885788455708665, 4.6445477111229],
            [15.885019940210483, 4.650203524319024],
            [15.87981878593419, 4.657657214266641],
            [15.87686527869737, 4.6671359898039695],
            [15.874113375473787, 4.681397650931244],
            [15.871843840781947, 4.687311445181493],
            [15.867656570797923, 4.692178469735587],
            [15.86412380040423, 4.69289120796298],
            [15.862833475386807, 4.6975004737347525],
            [15.866368559759016, 4.702430590474242],
            [15.866513210123525, 4.7065821789245295],
            [15.864115327210385, 4.712173647229638],
            [15.856492024129166, 4.722123249573123],
            [15.849846640719663, 4.726523916703124],
            [15.84812418704286, 4.728945557664094],
            [15.848740502886583, 4.7336381542985615],
            [15.852608919720012, 4.734858426193535],
            [15.859417378309336, 4.734794702174961],
            [15.860430022879742, 4.738824892058178],
            [15.85500693813415, 4.750019952734985],
            [15.852307911518999, 4.7576671716319625],
            [15.851655753335443, 4.767354614830803],
            [15.849484782423005, 4.774908423782157],
            [15.841525609550255, 4.785580646004482],
            [15.832007031689697, 4.787746034610059],
            [15.829042382063095, 4.789873824147595],
            [15.817550113655155, 4.784064418082751],
            [15.81147303621558, 4.783492452562715],
            [15.807719351333072, 4.787884289809114],
            [15.806793398166246, 4.795706844464875],
            [15.806995857779011, 4.801854926041596],
            [15.811341863345168, 4.811509932359535],
            [15.81437403136299, 4.813366471422115],
            [15.819597620359358, 4.8134496481393665],
            [15.822420524776902, 4.816163108270533],
            [15.823669532043425, 4.826541039422458],
            [15.822477381609087, 4.831834986155563],
            [15.816718780082658, 4.831664916987878],
            [15.813108953222379, 4.827579996823965],
            [15.807130119771603, 4.828046734278083],
            [15.801353716508908, 4.831874100574557],
            [15.790769933708864, 4.83407926085374],
            [15.787917754835235, 4.841176816479542],
            [15.787724597942683, 4.847302717626972],
            [15.785433408922765, 4.854285217295649],
            [15.781774003598462, 4.855770516420042],
            [15.773120880401146, 4.8531525701151885],
            [15.764918183036817, 4.858458858888576],
            [15.761851772048797, 4.857146619327229],
            [15.761756231033981, 4.857343758098064],
            [15.85343587918036, 4.946497573375425],
            [15.90551255675272, 4.997563483755703],
            [15.948618046166985, 5.03870566147965],
            [15.987658036457587, 5.0773844730525]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.76809040474987,
          "lat": 41.716445704011406
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36105"],
        "coty_name": ["Sullivan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sullivan County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00974150"
      },
      "bbox": [
        15.761756231033981, 4.493502737052562, 16.38178138176281,
        5.0773844730525
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.178262582537139, -1.8247787849362789],
            [12.179986705459132, -1.8263012680143946],
            [12.186395351984759, -1.8232715139351916],
            [12.18807977800002, -1.8154688144066815],
            [12.195081457878292, -1.8141528495592658],
            [12.202654921829188, -1.810106880415411],
            [12.209068401007489, -1.8037477241285982],
            [12.21229184379785, -1.7971617621285565],
            [12.219147114059622, -1.7925620972649945],
            [12.221260214954949, -1.7890822585696295],
            [12.235709190891042, -1.7845156439735923],
            [12.240432487382291, -1.7861712961319711],
            [12.242727389402676, -1.784599214441287],
            [12.24445373067639, -1.779470745737132],
            [12.250937163907244, -1.7779237816209794],
            [12.260210384790385, -1.7777566666831006],
            [12.265203725416967, -1.7727464463826665],
            [12.270096620956425, -1.772472322012188],
            [12.271626932775183, -1.7697549375409185],
            [12.277121486666896, -1.7700742060825947],
            [12.278951869485734, -1.768122376862139],
            [12.28580825439452, -1.768740867578675],
            [12.293702750889056, -1.7714810481211516],
            [12.295246936803274, -1.7756866684788628],
            [12.30173246358037, -1.7757708700566948],
            [12.316951068428606, -1.7651118726016886],
            [12.321491709356023, -1.7604881974299937],
            [12.323163167486387, -1.7614125498835576],
            [12.334020178315335, -1.7582903900865834],
            [12.33590863391542, -1.7602230030389907],
            [12.340818052030253, -1.7607647931135584],
            [12.34334675277222, -1.7568860307172192],
            [12.349050884269236, -1.7582679887378352],
            [12.354796847034503, -1.7620716815779203],
            [12.355582295200405, -1.764719472904959],
            [12.38716929947041, -1.756253858918853],
            [12.392815887993594, -1.7456471983139907],
            [12.407659796206913, -1.7386220406820196],
            [12.435539057829384, -1.7841573286298744],
            [12.439940901264263, -1.8227317794673],
            [12.427472087210125, -1.9272857950483269],
            [12.41590607867035, -1.9523473757989334],
            [12.415024094009414, -1.9612200727438984],
            [12.41038915931524, -1.9712606298718962],
            [12.407001703325651, -1.9743372959485939],
            [12.405092498610637, -1.9805128104222336],
            [12.406335293011823, -1.9868798559612735],
            [12.400929696037572, -1.993914411175414],
            [12.395999791178884, -1.9974403879083824],
            [12.391207703374999, -2.0048915501617044],
            [12.391273562766706, -2.0085191071630764],
            [12.38815539055172, -2.0114926582904817],
            [12.38619536709851, -2.016794898685543],
            [12.380335980805391, -2.011885652071507],
            [12.374263563002184, -2.01015738601069],
            [12.368945601301974, -2.0060298593725676],
            [12.366424717859218, -1.9954311125755955],
            [12.364250824710105, -1.9919521767144925],
            [12.358053353910488, -1.9887161910923334],
            [12.354954258717763, -1.9839840427649054],
            [12.352186149715289, -1.9705220922841835],
            [12.346125667190083, -1.969647854554468],
            [12.34206231310731, -1.9709480590262605],
            [12.337124704096782, -1.975342329906083],
            [12.332710292994577, -1.9750656741059511],
            [12.326153203074854, -1.9788173278427557],
            [12.313252527431953, -1.9817215921981017],
            [12.310463887035754, -1.9832138991152763],
            [12.305517517925304, -1.9818175144307006],
            [12.303019107309742, -1.9827086303861916],
            [12.295112295353068, -1.9895866240141877],
            [12.292304826214702, -1.9948144136445638],
            [12.288681363557409, -1.9985139875874067],
            [12.283169571870593, -1.9964165814543424],
            [12.276142746275367, -1.9970854859160765],
            [12.269308033577326, -1.9952196388634813],
            [12.267239910716912, -1.9975172386837785],
            [12.265669721514142, -2.0033873016356623],
            [12.255373315241775, -2.0088921877080526],
            [12.246923272443155, -2.008363636038641],
            [12.24347557236201, -2.0104428581111153],
            [12.239100095474223, -2.0160472085287617],
            [12.233070151074603, -2.018763188249852],
            [12.227370399738794, -2.0152060490213826],
            [12.223673620930708, -2.015947145817408],
            [12.219110846245565, -2.0223008370316764],
            [12.20461976275671, -2.025142731465152],
            [12.205869163778033, -2.0206383138804482],
            [12.20346115554267, -2.0180068415275745],
            [12.199189628573126, -2.009299111678248],
            [12.200623831652257, -2.0071543094657525],
            [12.196422074622772, -1.9987815785314893],
            [12.19246320474745, -1.9980350933902011],
            [12.192474961891321, -1.9424468028238029],
            [12.178097293585093, -1.8996298565386858],
            [12.178262582537139, -1.8247787849362789]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.176983470527, "lat": 35.92109897822779 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37003"],
        "coty_name": ["Alexander"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alexander County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01008532"
      },
      "bbox": [
        12.178097293585093, -2.025142731465152, 12.439940901264263,
        -1.7386220406820196
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.565676018355136, -1.8061766968828081],
            [11.575683708359962, -1.7983183384965042],
            [11.5801138179017, -1.79654162739688],
            [11.583188937370636, -1.78833711611095],
            [11.583793003579778, -1.782027089362687],
            [11.592075232667103, -1.7822309106325034],
            [11.59746021394759, -1.785818899629974],
            [11.601363728487554, -1.7859553683724803],
            [11.604271352695749, -1.7815477420218564],
            [11.605061417897003, -1.7754136789303328],
            [11.643183550195069, -1.6698934109801895],
            [11.655787635195063, -1.6395196092768825],
            [11.659125248473003, -1.630069863348903],
            [11.667584854495459, -1.6060884844419154],
            [11.672596200958312, -1.6110968535354706],
            [11.678305407771997, -1.6132449585502437],
            [11.68239269998717, -1.610018657685513],
            [11.687793963634286, -1.6183712016014533],
            [11.690366465661185, -1.6265045635854156],
            [11.68852423403054, -1.6366320232560152],
            [11.685161899680047, -1.6368884570968483],
            [11.68412643069705, -1.6403097647003424],
            [11.687722645123396, -1.642373066289763],
            [11.690859689836966, -1.6478847362411242],
            [11.68748506244862, -1.651899344531641],
            [11.68300288914177, -1.6532409926785059],
            [11.683555796595158, -1.657789997208593],
            [11.681668130253417, -1.6629910047661436],
            [11.68545681479586, -1.6680729730710695],
            [11.685319325413735, -1.6755895557300866],
            [11.693222429817144, -1.685460595067096],
            [11.704624483099487, -1.6928890360431985],
            [11.708018675125475, -1.6996817535384343],
            [11.730003066669616, -1.6920764199841791],
            [11.748557287393961, -1.7104982289284307],
            [11.750898691828564, -1.7143379078708683],
            [11.755369582015595, -1.7134392597373451],
            [11.761203317707446, -1.7251731872255438],
            [11.762536971835386, -1.7303422918256606],
            [11.778130969093677, -1.7687348568982089],
            [11.778919413328092, -1.7685632746453335],
            [11.781465804062314, -1.7685201282716478],
            [11.79047059141364, -1.771335104904798],
            [11.794662726305345, -1.774702359783057],
            [11.80020603747416, -1.7766386100280522],
            [11.803586112871109, -1.7754102006224397],
            [11.808492560047059, -1.7765940132713571],
            [11.813755805257733, -1.7805641070372116],
            [11.821220133142727, -1.7840069811365455],
            [11.824827196781971, -1.7912156354098259],
            [11.825250123840878, -1.796626476625146],
            [11.829767512864738, -1.8005500905102931],
            [11.836542582069894, -1.7992281387523248],
            [11.844783312769383, -1.8034506396656953],
            [11.804031017648546, -1.9173520791479841],
            [11.799369988006527, -1.9159066596248562],
            [11.794924718274737, -1.9121794163494785],
            [11.783824537233473, -1.9151398018743706],
            [11.77939459180975, -1.9108005357221003],
            [11.775675372621421, -1.911271821134701],
            [11.772440043162282, -1.9088144069302173],
            [11.766604334824166, -1.9098341605136901],
            [11.752023860510382, -1.9105167558811225],
            [11.745362360599355, -1.9065638807175302],
            [11.743989678252474, -1.898724971181725],
            [11.740535838626553, -1.8952781214690109],
            [11.72483924646537, -1.8905082254309558],
            [11.69642502397324, -1.9353964771883592],
            [11.683431982158895, -1.955957985241758],
            [11.684280339951037, -1.959586545199014],
            [11.691414345047015, -1.9644145182443795],
            [11.692334127694723, -1.9700667753598298],
            [11.688612235766795, -1.9760973827275858],
            [11.685076193233572, -1.9771289376257353],
            [11.679836661308618, -1.9840024510614829],
            [11.676998520075891, -1.9839030286528074],
            [11.672893901891415, -1.9885454715535034],
            [11.626958908963227, -1.964053794629121],
            [11.612341947650895, -1.9437942014725755],
            [11.60073629410082, -1.921940650381545],
            [11.600126455159169, -1.9136930469945328],
            [11.601814731014429, -1.9092233514825276],
            [11.60645055935961, -1.9059974624868676],
            [11.60587391107787, -1.8995526456324798],
            [11.610431344767461, -1.9012549136312331],
            [11.613227350696441, -1.8990754074741705],
            [11.582069983894314, -1.8463653568659604],
            [11.578100829463894, -1.8409397709575472],
            [11.579319079483996, -1.8353269598540167],
            [11.576848339988949, -1.8305785886172488],
            [11.57197077403878, -1.8263452322554397],
            [11.570709742705846, -1.8187843239097266],
            [11.571210403009257, -1.815592136220703],
            [11.566339548990571, -1.8109965380557675],
            [11.565676018355136, -1.8061766968828081]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.92258222884423, "lat": 36.07657046549036 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37011"],
        "coty_name": ["Avery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Avery County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01008536"
      },
      "bbox": [
        11.565676018355136, -1.9885454715535034, 11.844783312769383,
        -1.6060884844419154
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.69642502397324, -1.9353964771883592],
            [11.72483924646537, -1.8905082254309558],
            [11.740535838626553, -1.8952781214690109],
            [11.743989678252474, -1.898724971181725],
            [11.745362360599355, -1.9065638807175302],
            [11.752023860510382, -1.9105167558811225],
            [11.766604334824166, -1.9098341605136901],
            [11.772440043162282, -1.9088144069302173],
            [11.775675372621421, -1.911271821134701],
            [11.77939459180975, -1.9108005357221003],
            [11.783824537233473, -1.9151398018743706],
            [11.794924718274737, -1.9121794163494785],
            [11.799369988006527, -1.9159066596248562],
            [11.804031017648546, -1.9173520791479841],
            [11.802988699125688, -1.9207402482970315],
            [11.810610397017722, -1.9254265451118062],
            [11.81134938340418, -1.9278073109810747],
            [11.815827214501322, -1.927534402178775],
            [11.821009448077316, -1.9289637163793234],
            [11.828604265303532, -1.9291917845328708],
            [11.831236719486355, -1.9344778854179008],
            [11.82924437387931, -1.9359042253622922],
            [11.833493430843536, -1.94181576154898],
            [11.832222561218934, -1.945788590030658],
            [11.834323349996762, -1.9484995099618805],
            [11.838770507215488, -1.9456156605206583],
            [11.84394814728482, -1.94826431948346],
            [11.846297904522183, -1.947037709414574],
            [11.853018012728272, -1.9482534793421276],
            [11.859621074150889, -1.9554661148226837],
            [11.861688441305885, -1.9630033827144113],
            [11.865542010983566, -1.9639513821327468],
            [11.874237571114438, -1.9719831933433196],
            [11.876990654083045, -1.9787738266301815],
            [11.887420347092947, -1.9850599957231074],
            [11.894360382585162, -1.9923875083485272],
            [11.928859858052508, -2.002453234918308],
            [11.95446312664801, -2.010490217112022],
            [11.962023170928784, -2.0222009486188157],
            [11.967131327868167, -2.0237256689646137],
            [11.964461469992365, -2.027299892645083],
            [11.981730042294924, -2.0356510172926425],
            [11.988501080654252, -2.029023475199785],
            [12.00669575644545, -2.0470233689056134],
            [12.031359364424432, -2.070993956230489],
            [12.037807569814426, -2.0707770409966675],
            [12.041916477843102, -2.0679765871025815],
            [12.062505070204681, -2.062832000886982],
            [12.083127060705925, -2.059982346120407],
            [12.095098615892427, -2.05508457321543],
            [12.117536101275325, -2.0498895479707113],
            [12.119153561587305, -2.0506033462867252],
            [12.12229866067899, -2.0601949021077623],
            [12.134167011351563, -2.0605303369977532],
            [12.147171894838024, -2.0646925801907186],
            [12.150496139479923, -2.0650480230574924],
            [12.158861521039707, -2.070736066952478],
            [12.165160146631539, -2.0688426981378973],
            [12.172603068650911, -2.070004463380026],
            [12.176571797519548, -2.0689394562430645],
            [12.179918991810162, -2.0594889422340295],
            [12.185579392777537, -2.0571649927780395],
            [12.173543847043558, -2.0867571062174335],
            [12.1655139712763, -2.1050797974271847],
            [12.144530286556218, -2.155310403559564],
            [12.136450083838708, -2.1688640070587364],
            [12.096437664301495, -2.234018172364905],
            [12.080380636601504, -2.2748565780369225],
            [12.079755876566642, -2.2771942651798502],
            [12.078603830971813, -2.2813579159721105],
            [12.07239230621066, -2.281806604121428],
            [12.064582418617343, -2.285528657502952],
            [12.06010451610739, -2.2855120877202957],
            [12.056187026600032, -2.2892924113416044],
            [12.051089562399211, -2.2912283026597193],
            [12.045862356371815, -2.2883890933557187],
            [12.046686576455672, -2.284027483654132],
            [12.043878897544577, -2.2833151770777653],
            [12.036492440828283, -2.286962346628358],
            [12.033170701878435, -2.2858314471770074],
            [12.029512783933798, -2.281992934846926],
            [12.022745092435581, -2.2872413644606557],
            [12.014803645347657, -2.2898541371559555],
            [12.00822813777017, -2.289928733070838],
            [12.001005418156995, -2.2920103591145145],
            [11.990244120755195, -2.297514293190809],
            [11.978272595244515, -2.2933065708973177],
            [11.971924726630837, -2.2950352330537025],
            [11.966107575768827, -2.290341036183425],
            [11.96286777798553, -2.286399699681836],
            [11.959647508215056, -2.2863099263889115],
            [11.954156339812233, -2.2809608201188003],
            [11.953162383347857, -2.2843481290602194],
            [11.949325301264805, -2.2861716351687513],
            [11.945069744693651, -2.2839100983217597],
            [11.94209566555187, -2.2848285489639464],
            [11.937726508253087, -2.277019278082096],
            [11.931505443731956, -2.272361547317517],
            [11.931471581239027, -2.2661147797939334],
            [11.929294520746804, -2.2629404192349516],
            [11.925516746155658, -2.261748803567843],
            [11.917221494576369, -2.2676222386840497],
            [11.912049700445102, -2.26594724902199],
            [11.905595139520972, -2.2653904748571847],
            [11.899159195341172, -2.258307537733146],
            [11.896637527211285, -2.2629410706990107],
            [11.890023117021663, -2.2664092812568173],
            [11.888867504413355, -2.2707099853182613],
            [11.889620640124967, -2.275708884036725],
            [11.887317902956195, -2.2811428613421803],
            [11.880755377652756, -2.2833469502864046],
            [11.874973396861472, -2.2816859431229783],
            [11.869830789399865, -2.2834754473545558],
            [11.868645871733415, -2.2894795587818924],
            [11.86969334178161, -2.2912652596242506],
            [11.868058668867201, -2.2972726940562143],
            [11.865097290135722, -2.299556318779983],
            [11.858819475505657, -2.297284479023972],
            [11.853917730877031, -2.3011754314398245],
            [11.849365879535497, -2.2995264507998034],
            [11.84860881493879, -2.3052780006613407],
            [11.82108343479626, -2.2395351965015196],
            [11.790904442593243, -2.1664578486339368],
            [11.770910481437271, -2.1527895821984644],
            [11.740843713804407, -2.130933054428229],
            [11.684420046611098, -2.093320412782903],
            [11.688781547443382, -2.0856992135251526],
            [11.689372333073454, -2.0822367302884808],
            [11.69294989610668, -2.0775179547406615],
            [11.697023995873217, -2.0784807102454477],
            [11.705680582392228, -2.0775271218022326],
            [11.711120535586224, -2.071903191948375],
            [11.717090388406637, -2.057407375631854],
            [11.720987161658506, -2.056774949813196],
            [11.728283767701972, -2.0499396070053755],
            [11.732884896450908, -2.040479949557194],
            [11.731242418804955, -2.0322174500425856],
            [11.733358543561888, -2.0250981240053303],
            [11.733737696645667, -2.016876462804855],
            [11.736838924722607, -2.0075620638382166],
            [11.735255279379837, -2.001251531733758],
            [11.732700374072598, -1.9967665176112435],
            [11.732495171915293, -1.9933676221817571],
            [11.728075505167572, -1.990494661312835],
            [11.73062583815105, -1.9859033853148862],
            [11.725370271711087, -1.9755576231677385],
            [11.720432000084534, -1.9735938590443858],
            [11.718716190163235, -1.9698236064401315],
            [11.71234503495386, -1.9621083152683045],
            [11.713780350673037, -1.9563007570357713],
            [11.708011449807673, -1.9529396776991046],
            [11.708270512872934, -1.9484679946321184],
            [11.702618065600381, -1.9422878410075906],
            [11.702034484201066, -1.939919086652728],
            [11.69642502397324, -1.9353964771883592]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.70478719968, "lat": 35.7495883469149 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37023"],
        "coty_name": ["Burke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burke County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01008539"
      },
      "bbox": [
        11.684420046611098, -2.3052780006613407, 12.185579392777537,
        -1.8905082254309558
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9261762287100685, 7.615193306408325],
            [-0.8586910396449837, 7.613518372967098],
            [-0.7717801430069283, 7.6120225707723845],
            [-0.6847003396353226, 7.610301329699445],
            [-0.6121644978075234, 7.609194391898779],
            [-0.5103650371208314, 7.607586621881574],
            [-0.42326393335765844, 7.606341472304923],
            [-0.4086140644856322, 7.606107867835945],
            [-0.40909841724010054, 7.56308463467393],
            [-0.41050375362077796, 7.463492805968762],
            [-0.41209573297801294, 7.363300700317908],
            [-0.41248782020135216, 7.323499956718897],
            [-0.3909752974359474, 7.318810808240983],
            [-0.3915363101803638, 7.262168563236061],
            [-0.3915455591918164, 7.26216866017695],
            [-0.4791310466106111, 7.263280795045988],
            [-0.5666244819745044, 7.264638931019307],
            [-0.6740450669094472, 7.2665599207599065],
            [-0.7735960350117022, 7.268410680591494],
            [-0.8469501020965572, 7.27005301916031],
            [-0.9140335644187116, 7.271702708052723],
            [-0.9344446906564982, 7.272284266435693],
            [-0.9326017779013699, 7.3579816569866665],
            [-0.9303213799207024, 7.444070182815937],
            [-0.9281658413597302, 7.53003472939234],
            [-0.9261762287100685, 7.615193306408325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.63058123147187,
          "lat": 46.107821113299124
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38081"],
        "coty_name": ["Sargent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sargent County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01035303"
      },
      "bbox": [
        -0.9344446906564982, 7.262168563236061, -0.3909752974359474,
        7.615193306408325
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.991034458565995, 1.3305806916247418],
            [8.985933183521443, 1.3764790361931085],
            [9.020022933904318, 1.3804262342086762],
            [9.025386050891163, 1.3800273863841594],
            [9.056705527717957, 1.3847300500927862],
            [9.124657450728469, 1.392646270209577],
            [9.183986343971373, 1.4002321627172571],
            [9.226173176393802, 1.405860832617098],
            [9.240582421279248, 1.4081295041250874],
            [9.237651819631889, 1.4303746096193235],
            [9.241522103538705, 1.4299626404088859],
            [9.288080336959645, 1.4353511156459868],
            [9.324161200868888, 1.4397734818520294],
            [9.324213397268572, 1.4394118614108184],
            [9.330547084138216, 1.3937446010721497],
            [9.332841477261768, 1.3923573777319072],
            [9.35366424231227, 1.4016055428724667],
            [9.354553556463426, 1.4001311093349624],
            [9.356511526445644, 1.36279631489222],
            [9.359576316663428, 1.3087427434500338],
            [9.362313896334687, 1.3083664184746473],
            [9.365826447718035, 1.2197736232383725],
            [9.369996710490657, 1.1428383524129198],
            [9.356386318206939, 1.1433105071839738],
            [9.340528090841056, 1.1445973486010719],
            [9.311432024954577, 1.1422362997371698],
            [9.283286721376614, 1.1430279472992333],
            [9.268471509341175, 1.1398238843862358],
            [9.253098850409978, 1.142439226623445],
            [9.23893674432775, 1.1379958540970614],
            [9.224341340234982, 1.139254485644283],
            [9.208935640284384, 1.139243712185786],
            [9.181181282413352, 1.1363785038380247],
            [9.167471853696899, 1.1374430329926408],
            [9.156941173138662, 1.1370194605247632],
            [9.14988889221625, 1.1328947994822],
            [9.14883123538552, 1.1289169809800779],
            [9.102885104276831, 1.1230203396651506],
            [9.053939033476523, 1.1174090092181412],
            [9.031605492771355, 1.115555802007244],
            [9.013619605957546, 1.112922169767891],
            [9.004723046361786, 1.1999503561004565],
            [8.995918472456845, 1.2868663097200062],
            [8.991034458565995, 1.3305806916247418]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.57560628377314,
          "lat": 39.438624883961474
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39017"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01074021"
      },
      "bbox": [
        8.985933183521443, 1.112922169767891, 9.369996710490657,
        1.4397734818520294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.746600665920422, 1.1444603953585644],
            [9.77060418504167, 1.145898536711828],
            [9.772377360351356, 1.1233192628630362],
            [9.785367019726824, 1.1245246090976402],
            [9.79318309875797, 1.1274026952639995],
            [9.793879354381826, 1.1332375860147004],
            [9.797587986950932, 1.1349769906470104],
            [9.795988543233722, 1.1404282037303977],
            [9.800706941186169, 1.1449055491776223],
            [9.802052973142123, 1.1538929297489806],
            [9.805165454176171, 1.1597510014056263],
            [9.806126505503851, 1.1679559884694335],
            [9.846328275813736, 1.2090980754670277],
            [9.86379564698924, 1.2274515853326273],
            [9.907262229388586, 1.272086562330402],
            [9.938372641339889, 1.3030921415711276],
            [9.973367545963942, 1.3072539618841328],
            [10.028690038373117, 1.3140501036814176],
            [10.097387692199517, 1.3229751731905681],
            [10.10414940238275, 1.3237041685901192],
            [10.103079883193935, 1.3209383881082037],
            [10.104808910532133, 1.3147943839247116],
            [10.101207733106596, 1.3021243821371538],
            [10.10627339637001, 1.294322234163834],
            [10.105039630804969, 1.2895071971127579],
            [10.102021157884396, 1.2846096801037858],
            [10.10170669712502, 1.276587864919404],
            [10.103148272741096, 1.272664624725476],
            [10.100714273320504, 1.2668382219486098],
            [10.10420814390963, 1.2617949044592254],
            [10.104206166655985, 1.253519375498723],
            [10.106815911350589, 1.2501847662243886],
            [10.107034977063492, 1.2421066648113264],
            [10.108365770001187, 1.2393405489983147],
            [10.112531930894772, 1.238114948313265],
            [10.109461846839897, 1.2294152252982442],
            [10.110872752850545, 1.2237403939707208],
            [10.103819914630968, 1.2205262665910213],
            [10.101984623472621, 1.2166798365307891],
            [10.103566162047121, 1.2108463785754826],
            [10.112628172429636, 1.2080682058054957],
            [10.115997111110996, 1.2043094907504828],
            [10.11484480171895, 1.1950021351292341],
            [10.12218477049992, 1.193696479076009],
            [10.124992414721929, 1.1901552498867078],
            [10.130328985520544, 1.1878636288309647],
            [10.134570565279583, 1.195669315623528],
            [10.134081411756453, 1.1980285224637794],
            [10.140355775106316, 1.2016779066204368],
            [10.142105438049814, 1.199783846128365],
            [10.141342357726275, 1.1948557140214233],
            [10.14297577909009, 1.1881221323122009],
            [10.142393235009614, 1.1816070988423608],
            [10.1456654381124, 1.18242104284437],
            [10.142793671473447, 1.1457510104347868],
            [10.140776191776224, 1.0780259404195114],
            [10.139032989758551, 1.0342771774214063],
            [10.137389334047894, 1.00001979148775],
            [10.064666531737451, 0.9753823725266394],
            [10.040993935622634, 0.9671842452633352],
            [9.988558065583957, 0.9481504250276284],
            [9.969865895408361, 0.9408891418139704],
            [9.922795403286349, 0.9363029508699006],
            [9.898117047465018, 0.9340223603637214],
            [9.863388231927654, 0.9286158444173704],
            [9.813061620055882, 0.9218150256259274],
            [9.77066830904216, 0.9175152998831677],
            [9.762887564098765, 1.0008224642909043],
            [9.758782256046658, 1.0389356679053756],
            [9.754366119977583, 1.0760442255449922],
            [9.746600665920422, 1.1444603953585644]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.60095349564904, "lat": 39.18471904249521 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39071"],
        "coty_name": ["Highland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Highland County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01074048"
      },
      "bbox": [
        9.746600665920422, 0.9175152998831677, 10.1456654381124,
        1.3237041685901192
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.582528384509885, 3.180076032726013],
            [11.645130220094828, 3.1897409965574175],
            [11.637625330410682, 3.236050078651091],
            [11.635997801930916, 3.2436097951947094],
            [11.62149354085039, 3.335215450550093],
            [11.648087031574708, 3.339428716881325],
            [11.728486935061968, 3.352508001334549],
            [11.845212268191426, 3.3707767996673437],
            [11.90639975790554, 3.380192126048272],
            [11.977946062565136, 3.391775014075635],
            [11.97938703285413, 3.3837240806420716],
            [11.982480822350684, 3.364102924451264],
            [11.988300531983446, 3.3299653110236416],
            [11.997386831317526, 3.2747720617249247],
            [12.012689630747683, 3.1810464546623725],
            [12.015572947204685, 3.160360397499572],
            [11.932601169382027, 3.1462432816471364],
            [11.897589437653382, 3.140698718005952],
            [11.820490997445859, 3.1290736795056304],
            [11.791943713350056, 3.1246540212626845],
            [11.787532133111478, 3.1533574570333793],
            [11.732593844206749, 3.1449639820135236],
            [11.737090224952903, 3.1159150991280318],
            [11.664376580268298, 3.104867694806476],
            [11.636379697556448, 3.100355287780114],
            [11.595875023754958, 3.0940871707040354],
            [11.582528384509885, 3.180076032726013]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.77627358660871, "lat": 41.01462775826561 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39099"],
        "coty_name": ["Mahoning"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mahoning County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01074062"
      },
      "bbox": [
        11.582528384509885, 3.0940871707040354, 12.015572947204685,
        3.391775014075635
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8869926154866962, -3.342336328753527],
            [-0.8014843988242863, -3.3438384277278193],
            [-0.7155595735004971, -3.3449647790897243],
            [-0.6155961693578261, -3.3465479227535853],
            [-0.5585996396202002, -3.3471823593139134],
            [-0.4592990643954156, -3.348949408627551],
            [-0.4601228742268824, -3.4366724190145796],
            [-0.46051422800953895, -3.4584275983097537],
            [-0.46108855833758344, -3.523969008568317],
            [-0.46159773394486553, -3.538201106662606],
            [-0.462615593433867, -3.625966799913453],
            [-0.46376456017696244, -3.7063443357039536],
            [-0.4649284815402085, -3.8006108887659433],
            [-0.4748123211168376, -3.7972623318846783],
            [-0.4846474124910103, -3.7977503299369024],
            [-0.4925814256981895, -3.7997771601486647],
            [-0.5014234479479416, -3.7986389547995145],
            [-0.50868049987781, -3.799999321992373],
            [-0.5081776830803236, -3.792168077645371],
            [-0.5103547821687933, -3.7883104518077952],
            [-0.5159393060875591, -3.7880427341230356],
            [-0.5217704074991565, -3.7846828778489017],
            [-0.526132820840061, -3.7836490086683425],
            [-0.5311212981551136, -3.7869192271307113],
            [-0.5327660136335074, -3.7932875758691704],
            [-0.5385426477104146, -3.790325715555804],
            [-0.538186590845915, -3.7858861318653374],
            [-0.5491064204131315, -3.7784224895901874],
            [-0.5525162208346824, -3.778672675561758],
            [-0.5551367347697779, -3.7821153481331575],
            [-0.5616301146898354, -3.7820155215809024],
            [-0.5657439020730463, -3.776655147963652],
            [-0.5701348470591457, -3.76546255826171],
            [-0.5713558770085739, -3.764220397663622],
            [-0.5775520831639773, -3.766355463549417],
            [-0.5922820225155895, -3.762310268208219],
            [-0.5962666411767836, -3.7705347479530364],
            [-0.5989920813536175, -3.772914812186243],
            [-0.610333849903846, -3.772532817688237],
            [-0.6137782458256333, -3.7715942544768795],
            [-0.6201497194051343, -3.7676244786980604],
            [-0.6263149954394497, -3.762452323162061],
            [-0.6275885321423554, -3.751959126078759],
            [-0.631253545263745, -3.747069212307925],
            [-0.6314163778713581, -3.740805542826551],
            [-0.6262539712426768, -3.736028130084155],
            [-0.6264193479162412, -3.730837247891031],
            [-0.6298884675754675, -3.727722427949927],
            [-0.6292549968388953, -3.721549295046219],
            [-0.6314071887515731, -3.720104670620669],
            [-0.6347193041134677, -3.7071134750228465],
            [-0.6364342786588146, -3.697213612478432],
            [-0.6387167310248119, -3.6921078996738186],
            [-0.6368163825127684, -3.6852619159662265],
            [-0.6323507056151126, -3.6746240330796156],
            [-0.6317885149781512, -3.668717035736882],
            [-0.6353285026691, -3.6603790578286275],
            [-0.6338669378952086, -3.6533310572681694],
            [-0.6350011598297259, -3.648934906316255],
            [-0.6398789968174169, -3.6428293143842487],
            [-0.6429479508322283, -3.640868673526256],
            [-0.6504664907856701, -3.640265312667552],
            [-0.660300935456174, -3.6429607275681697],
            [-0.6653164122380119, -3.6425251854017198],
            [-0.6737051626466308, -3.638595805539638],
            [-0.6721423720539466, -3.6334241843182125],
            [-0.673087954055443, -3.6229645101598575],
            [-0.6758751977317727, -3.6158410117517388],
            [-0.6725169203963742, -3.599852763702302],
            [-0.6746900323040492, -3.5985189874623438],
            [-0.6750518758284015, -3.5925605208020395],
            [-0.6769929293282139, -3.586423616993026],
            [-0.6858982333826855, -3.5827344529143987],
            [-0.6906468883465202, -3.5836965764494835],
            [-0.6979732962594176, -3.5804222430469923],
            [-0.7021258417891496, -3.577092492917641],
            [-0.7054862522693628, -3.563546978452747],
            [-0.7141593694410379, -3.5600914476726624],
            [-0.7183225225800591, -3.5535626862495144],
            [-0.7418488671171517, -3.535430995799692],
            [-0.7616728137287299, -3.5214354566353117],
            [-0.7682431614312593, -3.5163745795540056],
            [-0.7749734304507542, -3.5098806212202094],
            [-0.7846815315335134, -3.508211595560185],
            [-0.7953087655345105, -3.4978038195423293],
            [-0.7954304049088072, -3.494700281424049],
            [-0.8011525346839304, -3.4873350086000756],
            [-0.7965598196940886, -3.4830780372958534],
            [-0.7979720136469729, -3.4798707221146055],
            [-0.8019657559083343, -3.4785001362721983],
            [-0.8043917843197496, -3.4743857943494842],
            [-0.8019343249277446, -3.4677998302541693],
            [-0.7946786105232508, -3.4599004582524358],
            [-0.7960282965865471, -3.4332288136148876],
            [-0.7989712350969557, -3.429520763924224],
            [-0.8117206585637383, -3.4204298189141005],
            [-0.8155107265318473, -3.4187877608027035],
            [-0.8329232401381247, -3.4174279820101456],
            [-0.8449390533878212, -3.4155226484672836],
            [-0.8525470054788328, -3.405909513416534],
            [-0.8610867617191845, -3.399216371858236],
            [-0.8644420273604132, -3.394256553015067],
            [-0.8725426232477829, -3.386676141439233],
            [-0.8809169900412465, -3.3832709593752215],
            [-0.8877338303036444, -3.3822974537859873],
            [-0.8869926154866962, -3.342336328753527]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.32648940760399, "lat": 35.20308738971992 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40027"],
        "coty_name": ["Cleveland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cleveland County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01101801"
      },
      "bbox": [
        -0.8877338303036444, -3.8006108887659433, -0.4592990643954156,
        -3.342336328753527
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.409743835468387, 6.939565828262912],
            [-18.390090320105045, 7.007920571032898],
            [-18.245824596210856, 6.967475422160457],
            [-18.254539521776206, 6.976025076104204],
            [-18.255753721369327, 6.9790768703014585],
            [-18.25172033753388, 6.988918742682247],
            [-18.246836000706068, 6.992370323901358],
            [-18.244175998444437, 7.000903613707521],
            [-18.240222882992683, 7.004275386667544],
            [-18.23975174770211, 7.008042702620128],
            [-18.23523527458865, 7.014453035367904],
            [-18.232933593959043, 7.01566452950293],
            [-18.229133625165037, 7.023771774063205],
            [-18.22330852681503, 7.026868467963397],
            [-18.219567329783615, 7.030590803053684],
            [-18.21686819343727, 7.03779338293523],
            [-18.217039282426583, 7.044668437561698],
            [-18.214892842564357, 7.04667684766102],
            [-18.205381243435703, 7.049706576313037],
            [-18.20277096187914, 7.055830720992987],
            [-18.201967453791514, 7.06341959947554],
            [-18.196137077711946, 7.068462485596458],
            [-18.1860475283852, 7.079167147386325],
            [-18.185805884782024, 7.085380272247574],
            [-18.17921044874129, 7.091492660663979],
            [-18.178171600599693, 7.093818252266292],
            [-18.180467169143, 7.103541210545784],
            [-18.17082477687916, 7.104233470739101],
            [-18.166097023434816, 7.107781098565143],
            [-18.160334277636935, 7.108580952680295],
            [-18.154620494645265, 7.1149550072926075],
            [-18.149446167418883, 7.113137843240059],
            [-18.138375628167584, 7.12468705647034],
            [-18.137606004287584, 7.127372241047451],
            [-18.130647368666203, 7.131854779383874],
            [-18.122783304176924, 7.133427993561165],
            [-18.125295358147834, 7.138476010222601],
            [-18.125834308416263, 7.147274597252304],
            [-18.126946555760675, 7.151854481298319],
            [-18.13089025810614, 7.1558376447209415],
            [-18.135304469928926, 7.158368436262447],
            [-18.137582140788968, 7.163430529769702],
            [-18.13795608180126, 7.168796289848652],
            [-18.134988084424958, 7.1784605717120735],
            [-18.12647088943467, 7.184180809092375],
            [-18.127212074996606, 7.188087503954376],
            [-18.13075196684487, 7.1939095992205315],
            [-18.13309718667088, 7.195344656501915],
            [-18.133957621099782, 7.20196487781078],
            [-18.12717042044507, 7.208128400739699],
            [-18.12497734740969, 7.213156349176491],
            [-18.125484178570012, 7.221863496403847],
            [-18.127605805086382, 7.229801477891697],
            [-18.127747307506354, 7.239472099331477],
            [-18.132568869195268, 7.241966026346336],
            [-18.134470705358723, 7.248047385304831],
            [-18.139188781558985, 7.253221975460086],
            [-18.140014706967605, 7.256578433497478],
            [-18.14450000601335, 7.263657105960714],
            [-18.14643621824273, 7.264788493674217],
            [-18.14726392809694, 7.2705313312435935],
            [-18.147010524426513, 7.27925590537817],
            [-18.143870869660077, 7.281782362947767],
            [-18.145133028276273, 7.290402390076321],
            [-18.147347393257682, 7.291492493785809],
            [-18.15487163279224, 7.30131927428193],
            [-18.15505017145471, 7.309770468585483],
            [-18.15710055135207, 7.311448918041299],
            [-18.159297664297764, 7.317899188437588],
            [-18.16264458160734, 7.314707112279345],
            [-18.168219962800734, 7.320927671549584],
            [-18.172121152034077, 7.32128095794811],
            [-18.176533280700554, 7.329048279140749],
            [-18.182080150207934, 7.330428904607271],
            [-18.184882791970583, 7.33334502882226],
            [-18.183184039824976, 7.335901553505521],
            [-18.18790477703647, 7.342116102102736],
            [-18.193188358553414, 7.341039521120234],
            [-18.19570604446827, 7.3471113068227565],
            [-18.19018545615605, 7.348942314753419],
            [-18.188451912047114, 7.352564607463883],
            [-18.1836944356493, 7.351491912627832],
            [-18.18183664104036, 7.362957591575487],
            [-18.17778504418178, 7.363591166941108],
            [-18.17303446100363, 7.372368783851326],
            [-18.17226956002054, 7.376944006167097],
            [-18.170191055954973, 7.37868773847967],
            [-18.170665995415472, 7.383902655653545],
            [-18.168022198276827, 7.385236624509357],
            [-18.165424386454358, 7.389601143958977],
            [-18.165928121437506, 7.392730668760747],
            [-18.163770095984184, 7.398255290447305],
            [-18.16433725061268, 7.403320607500939],
            [-18.172279027233223, 7.408795326596317],
            [-18.173389836988306, 7.416473522405362],
            [-18.168096978305833, 7.422980168339073],
            [-18.16407332331257, 7.424302175747156],
            [-18.164236743276042, 7.4309051277275255],
            [-18.157724512180966, 7.436777482596222],
            [-18.155528758993956, 7.441227492649968],
            [-18.150541722494953, 7.447953926643492],
            [-18.147594190493177, 7.448173822316622],
            [-18.14463964836798, 7.451119916648777],
            [-18.139183425391238, 7.450121226682626],
            [-18.130303556370574, 7.454703466742866],
            [-18.12678536412193, 7.459114997092305],
            [-18.121937958070436, 7.457897487728709],
            [-18.118534022433348, 7.4617036619980155],
            [-18.113733362081167, 7.46074498669672],
            [-18.111394097473667, 7.458054528404718],
            [-18.10175555818581, 7.459504498497207],
            [-18.10095211651308, 7.465627037256971],
            [-18.096069638323996, 7.463905897345085],
            [-18.089642793491457, 7.466786888719909],
            [-18.083997377407258, 7.467965925679029],
            [-18.081661397080456, 7.47072882678782],
            [-18.07457905154481, 7.472617962713596],
            [-18.067217590790587, 7.4726299095603155],
            [-18.060060092923308, 7.4737421197537035],
            [-18.057038228378893, 7.476319605429415],
            [-18.05306511263224, 7.47454952825674],
            [-18.045405259581727, 7.4788559749485755],
            [-17.90558155009422, 7.440779973538142],
            [-17.76577029430331, 7.40265529995114],
            [-17.671508488514487, 7.377090812419381],
            [-17.625775973178015, 7.364254989154442],
            [-17.58010342719072, 7.352311572335831],
            [-17.61784602667052, 7.214215307747911],
            [-17.648514841832583, 7.1022303075105215],
            [-17.65969877557032, 7.105354473545742],
            [-17.72516495930554, 6.869640116758615],
            [-17.730977379392247, 6.84870476982336],
            [-17.777410764210778, 6.685387119667499],
            [-17.776883971560885, 6.685244157397626],
            [-17.7993231164132, 6.602180132260049],
            [-17.798866693223278, 6.602056252443522],
            [-17.822228050455177, 6.517996290120049],
            [-17.745504763150468, 6.497336764726044],
            [-17.6687847945807, 6.476664203011046],
            [-17.573614557281022, 6.450690307315421],
            [-17.574318281800576, 6.448123786016231],
            [-17.505578287955597, 6.429892740939168],
            [-17.494254437023926, 6.42729874217859],
            [-17.495974934110485, 6.419982136226694],
            [-17.560493911495637, 6.178158511362003],
            [-17.560170437283393, 6.174658079167193],
            [-17.574458215802057, 6.121820931528268],
            [-17.687349717581696, 5.701082049897043],
            [-17.73038165828701, 5.712286085367723],
            [-17.759163510979672, 5.719498309781153],
            [-17.788801553235032, 5.72773554691078],
            [-17.830197466493594, 5.74093279024397],
            [-17.896075494586736, 5.760664288106146],
            [-17.983732131896854, 5.784513515659188],
            [-18.017925489438298, 5.792611276779058],
            [-18.0262068331784, 5.795152305070853],
            [-18.090634080424675, 5.813717487232642],
            [-18.192324107076384, 5.843313453155064],
            [-18.26559707846328, 5.864972023544853],
            [-18.340764312829346, 5.887312971327721],
            [-18.43898483871931, 5.916336840044659],
            [-18.451578300544956, 5.919508331614938],
            [-18.5060448841706, 5.935967054816943],
            [-18.514869952531296, 5.939103165547288],
            [-18.583301333401078, 5.959537386038018],
            [-18.596919077738093, 5.964102493426899],
            [-18.665809229229577, 5.983861182863991],
            [-18.686303410955936, 5.9901471192129705],
            [-18.659364120150943, 6.083424103663112],
            [-18.653720095058837, 6.104885686825738],
            [-18.651944033083904, 6.104396859462023],
            [-18.6310867481077, 6.177420757075827],
            [-18.607287551486188, 6.260017398138803],
            [-18.57926853464954, 6.359498248636642],
            [-18.556707287768624, 6.438824251623998],
            [-18.554501330078907, 6.4382020509104985],
            [-18.489625130299896, 6.661990941443485],
            [-18.43398353489615, 6.8575866190225945],
            [-18.43322357211692, 6.857374552290437],
            [-18.409743835468387, 6.939565828262912]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.65004980992695,
          "lat": 42.68633435470749
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41035"],
        "coty_name": ["Klamath"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Klamath County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01155134"
      },
      "bbox": [
        -18.686303410955936, 5.701082049897043, -17.494254437023926,
        7.4788559749485755
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.62580982388217, 8.591419298010823],
            [-16.499134933056812, 8.558033020610258],
            [-16.378136479229756, 8.526416425536377],
            [-16.37638496489987, 8.524022458791455],
            [-16.30823052893233, 8.506337094431634],
            [-16.227024738512842, 8.48738275135355],
            [-16.226772540923346, 8.48834203035341],
            [-16.186086948093138, 8.47786465137547],
            [-16.14490654618452, 8.467477852630624],
            [-16.16334533091609, 8.397445487567403],
            [-16.14892390339963, 8.394247218298654],
            [-16.08186617848979, 8.377259421143723],
            [-16.12379649518522, 8.212151924331293],
            [-16.110700132050496, 8.208811501501456],
            [-16.126169927044312, 8.150701033617267],
            [-16.153541949151283, 8.044533445147984],
            [-16.183074284016747, 7.930992676387465],
            [-16.200915833245112, 7.860848578169552],
            [-16.202588056732484, 7.854785694060996],
            [-16.21874332408445, 7.7914197383807045],
            [-16.21970963977202, 7.791699963385458],
            [-16.240289243517786, 7.712641718417828],
            [-16.32449688372914, 7.733755158280154],
            [-16.40870900536075, 7.754849832167186],
            [-16.38820317876987, 7.834732895686441],
            [-16.4303948272661, 7.845363624933048],
            [-16.437526298115486, 7.846682108339265],
            [-16.458252185677562, 7.852115965290801],
            [-16.47196869222654, 7.85622170048684],
            [-16.460285532304372, 7.903608705627935],
            [-16.51526990926684, 7.917100430853318],
            [-16.54459604124433, 7.924164041274941],
            [-16.621486527987944, 7.9436620596305065],
            [-16.69838082361237, 7.963144166325074],
            [-16.712128411415193, 7.965757913557608],
            [-16.70160725596304, 8.004640582365706],
            [-16.702578577679073, 8.00489294024152],
            [-16.67991680183484, 8.088681669030002],
            [-16.67565856629615, 8.102551664140748],
            [-16.65713844377385, 8.174121104543163],
            [-16.62917376308895, 8.277702010271287],
            [-16.630317899754285, 8.280104479957632],
            [-16.62839997872845, 8.286409496995807],
            [-16.63400870354501, 8.295150664207855],
            [-16.629006480328588, 8.303142662107911],
            [-16.63417650140712, 8.311308541703141],
            [-16.628620121163056, 8.317182855724415],
            [-16.62438291989819, 8.31903089084133],
            [-16.62400586137768, 8.311832764497522],
            [-16.61616608101857, 8.314857191900865],
            [-16.613120196791215, 8.319798422292049],
            [-16.61691408414977, 8.321528161336998],
            [-16.616748508844733, 8.32552695856586],
            [-16.610838959465358, 8.325068122738717],
            [-16.60962595153415, 8.32761445253994],
            [-16.611334386696143, 8.331246802524344],
            [-16.60401172567724, 8.333272403177864],
            [-16.608747281612068, 8.339730163556492],
            [-16.612823102652005, 8.343231966525968],
            [-16.621788628187595, 8.346433083373057],
            [-16.623955530706432, 8.350756683697748],
            [-16.622724265621216, 8.355456826505948],
            [-16.625725185203187, 8.357981554965173],
            [-16.62444875547892, 8.369733751348896],
            [-16.62806946335034, 8.372301878606136],
            [-16.63431002591553, 8.373846394572075],
            [-16.637581702782995, 8.37783679077325],
            [-16.63808791140663, 8.383671680708076],
            [-16.644376958595636, 8.386068178228195],
            [-16.650199617886646, 8.390195520210856],
            [-16.64807333250885, 8.396819706625784],
            [-16.650989922288076, 8.399293222678205],
            [-16.648660845975577, 8.40577104680244],
            [-16.639692224755116, 8.40691202082901],
            [-16.63325590865656, 8.408743434350239],
            [-16.629905351015413, 8.414071171766418],
            [-16.630759540148713, 8.419994539355333],
            [-16.63634423276264, 8.43070250386304],
            [-16.642570416309592, 8.427275580019932],
            [-16.651917215436306, 8.435779734496725],
            [-16.647385659449316, 8.438417615909678],
            [-16.647974928657785, 8.442178196786346],
            [-16.645642686874226, 8.449349227838237],
            [-16.648557701599174, 8.455221335852432],
            [-16.648181741809662, 8.457893343548808],
            [-16.64448177647276, 8.460269992414485],
            [-16.647933927514448, 8.471462950353732],
            [-16.645895212144197, 8.472806270817077],
            [-16.651546004236288, 8.478337127427952],
            [-16.647458520532002, 8.482570551058659],
            [-16.646471233227405, 8.488742572283355],
            [-16.639616805568725, 8.490638762663144],
            [-16.638307296110764, 8.49413224359275],
            [-16.641721432874874, 8.500494961278811],
            [-16.6355706151455, 8.505492155821612],
            [-16.635425731394157, 8.524130745916304],
            [-16.637409280241638, 8.526221561622737],
            [-16.63578252493308, 8.530405835097572],
            [-16.631170419825878, 8.532147192181297],
            [-16.628750144082343, 8.537892007756192],
            [-16.628132817117567, 8.543772496325005],
            [-16.632089406970444, 8.550844558103055],
            [-16.63155361874534, 8.552855167296153],
            [-16.626524088207624, 8.556664165269424],
            [-16.623661777944804, 8.560833032099811],
            [-16.627367589631596, 8.566098643346818],
            [-16.62750785295115, 8.570230512946571],
            [-16.62173836557554, 8.575177209640067],
            [-16.62064094824765, 8.578474499271028],
            [-16.623959240339897, 8.580260416158442],
            [-16.62403980285207, 8.585707294012622],
            [-16.627281245269604, 8.586961545830631],
            [-16.62580982388217, 8.591419298010823]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.02751742380187,
          "lat": 44.726009335594085
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41069"],
        "coty_name": ["Wheeler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wheeler County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01135865"
      },
      "bbox": [
        -16.712128411415193, 7.712641718417828, -16.08186617848979,
        8.591419298010823
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.328021845289426, 2.9809652091053938],
            [12.343402963914127, 2.9833842214417325],
            [12.367082922208233, 2.9879619807829103],
            [12.384964861147836, 2.991753054679221],
            [12.385123295409139, 2.991002410661221],
            [12.411206692359308, 2.9953283115728015],
            [12.447163146126705, 3.000912253882139],
            [12.468068585056987, 3.0031308002390222],
            [12.501485839031806, 3.0098529125094364],
            [12.52942359511406, 3.0137562841456744],
            [12.555350589335076, 3.0177411123236824],
            [12.564992805002507, 3.0185280382965467],
            [12.572828906068585, 3.0204513095682777],
            [12.601129585549145, 3.0248251120775542],
            [12.639667172064877, 3.029451053083579],
            [12.65553732366544, 3.03280201872474],
            [12.666446987835469, 3.034443587191525],
            [12.665661307091568, 3.0260214414481346],
            [12.670730239831146, 3.017660467340972],
            [12.673503237093708, 3.0109507702535594],
            [12.673323214805285, 3.006255968947884],
            [12.67129207799649, 3.0000304356379113],
            [12.66625760636604, 2.9895173668930033],
            [12.659416183770128, 2.979456132814116],
            [12.65669298986308, 2.971298020811335],
            [12.654777926030633, 2.9684104783143863],
            [12.64603569040697, 2.9618449364264237],
            [12.636678790821334, 2.9569840821165934],
            [12.62813769374388, 2.950880051710477],
            [12.624455538324499, 2.9453471487458844],
            [12.621808171278388, 2.9372683850226133],
            [12.622329772797647, 2.927868626114937],
            [12.623586543234588, 2.9235584218921757],
            [12.630027242715443, 2.910989375686981],
            [12.633577547102195, 2.9057144777626287],
            [12.636991438178903, 2.908169453498711],
            [12.645549633895051, 2.909849276870998],
            [12.650352831595411, 2.9078754958809587],
            [12.655421717723065, 2.909250090849932],
            [12.658905471619091, 2.9058171361081446],
            [12.667597942318157, 2.903326825226915],
            [12.67403722122583, 2.895969715205759],
            [12.677209647234271, 2.89592606869046],
            [12.684780867993876, 2.8902314339379305],
            [12.68507158993342, 2.8865128833607283],
            [12.690580403847086, 2.8545001843066635],
            [12.695525557999654, 2.8211457847791848],
            [12.69949602593441, 2.791415949871436],
            [12.698582266568128, 2.7871622740418496],
            [12.692667899612715, 2.7811227998533736],
            [12.692396620785471, 2.777369900917007],
            [12.685143603238501, 2.776816345742411],
            [12.689452385106474, 2.771523036689973],
            [12.683493809713598, 2.770395739283782],
            [12.683504471039448, 2.761973198289375],
            [12.67504417487925, 2.756348963898641],
            [12.673575973958346, 2.750684009699154],
            [12.66955212425062, 2.747604325815588],
            [12.662657529867682, 2.7507414692042156],
            [12.661090696506983, 2.7476685594949717],
            [12.662379010834263, 2.744236816634705],
            [12.658925791827913, 2.7323575234078565],
            [12.659697411459886, 2.669572323302034],
            [12.659157366985903, 2.6529568219756405],
            [12.662484726925593, 2.6518194298484588],
            [12.670068795795732, 2.646113234060352],
            [12.670893129945561, 2.6419586598204527],
            [12.66854772769048, 2.63877911969283],
            [12.657386190419329, 2.6362325910221975],
            [12.656427284303456, 2.6337788417195642],
            [12.658755928635836, 2.6267584652695604],
            [12.66461304595681, 2.6207326627463092],
            [12.665980133816234, 2.617424051133149],
            [12.660880621803717, 2.607327689128372],
            [12.660053969754333, 2.601185014321244],
            [12.655572785417325, 2.5901134222217057],
            [12.65868932040827, 2.5855915002606427],
            [12.675683916493897, 2.584093250117745],
            [12.663254016893267, 2.575932581803259],
            [12.653818116796188, 2.569137629782475],
            [12.636651373103241, 2.558085449950823],
            [12.61458570163915, 2.5426822165649368],
            [12.607482362248778, 2.5407057768630468],
            [12.60211949287339, 2.5378311357494256],
            [12.593449082010643, 2.5364595813045727],
            [12.585288922710005, 2.537250154410992],
            [12.57881133092715, 2.5395211153045563],
            [12.56976412985613, 2.544933389646214],
            [12.553266878798613, 2.546700759444449],
            [12.547170277449258, 2.5484234959560337],
            [12.539197238436989, 2.5550718761548987],
            [12.53534947398774, 2.559330408017066],
            [12.534915607553232, 2.5658117805449305],
            [12.539545807558934, 2.5721864562270564],
            [12.543598553825653, 2.5743384657378923],
            [12.557726197862113, 2.5780958698129712],
            [12.56632267994949, 2.583183578184787],
            [12.571362705644551, 2.588527424705389],
            [12.573117888357945, 2.5918915965826343],
            [12.529623945091576, 2.6010381198236687],
            [12.48390382832771, 2.6104588209508126],
            [12.443778170471635, 2.6193206195782204],
            [12.417801108178189, 2.6246675511528585],
            [12.412507735236646, 2.6262110426391843],
            [12.3908992130324, 2.630744346342359],
            [12.358163092547958, 2.638004416202052],
            [12.34420461926156, 2.6499850840498516],
            [12.324123380080438, 2.6657758571683394],
            [12.259683671232667, 2.715890687027728],
            [12.202981677173028, 2.7597029063245504],
            [12.202956476777661, 2.759849897259037],
            [12.254724221171884, 2.828720805947828],
            [12.271286063884775, 2.851185719599331],
            [12.285413124564279, 2.8709621680314132],
            [12.291056561540296, 2.8810211044057943],
            [12.294602314567394, 2.880591118486483],
            [12.298194292897472, 2.8884114818517572],
            [12.300959918473092, 2.8893936673175875],
            [12.30764264021111, 2.89905843058446],
            [12.312797359210148, 2.899098431852922],
            [12.312862192730208, 2.90672872174069],
            [12.316982751410036, 2.913443838300958],
            [12.326533546797776, 2.9115209126986654],
            [12.329635212031569, 2.9155774075710736],
            [12.334196250298703, 2.914833946358586],
            [12.336666654453474, 2.9189287709820464],
            [12.340636153382343, 2.9214676462158087],
            [12.328021845289426, 2.9809652091053938]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.98122034787089, "lat": 40.46880220285746 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42003"],
        "coty_name": ["Allegheny"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allegheny County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01213657"
      },
      "bbox": [
        12.202956476777661, 2.5364595813045727, 12.69949602593441,
        3.034443587191525
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4482323139989797, 6.597642453316964],
            [-1.3646423543510484, 6.594568540542081],
            [-1.3211056364872247, 6.593043736401809],
            [-1.2920211423793782, 6.591802304970409],
            [-1.234125427745559, 6.589950791927254],
            [-1.1616278039318761, 6.5878436159302325],
            [-1.0818751947218, 6.585490477101154],
            [-1.0168211347109317, 6.583645124469133],
            [-0.9303942138585195, 6.581624404680974],
            [-0.9318563162762453, 6.513772670579657],
            [-0.9324478034674529, 6.495024330194229],
            [-0.9346755573271593, 6.401250291746927],
            [-0.9357602921013205, 6.343340756295765],
            [-0.9360580831490597, 6.342478934356322],
            [-0.9384230547326152, 6.249777428862089],
            [-0.9386255304438563, 6.235379613834641],
            [-0.9346454347102406, 6.2352742712019875],
            [-0.9363213958803581, 6.148964493793378],
            [-0.937137786888151, 6.112961818612174],
            [-0.9373594046109319, 6.093628186517965],
            [-0.9382453804493445, 6.062466023490557],
            [-0.9398201364334104, 5.996189393672611],
            [-0.9405019938127048, 5.9756502836782115],
            [-1.026626097935006, 5.97787751100626],
            [-1.0985388050021285, 5.979924248792149],
            [-1.1989139184886763, 5.982618285401762],
            [-1.2851300898878646, 5.985129315379411],
            [-1.371267647716869, 5.987864549250241],
            [-1.4571714516725818, 5.990863189615764],
            [-1.4545380889757125, 6.07747510301232],
            [-1.4520513349040625, 6.164039090782803],
            [-1.4493928724797396, 6.252459081965537],
            [-1.4572676789320578, 6.252737201037583],
            [-1.4542964139460204, 6.360875253442129],
            [-1.4528296906699567, 6.425616486820356],
            [-1.4526099952373273, 6.440286833954241],
            [-1.4506373994396984, 6.512098731372725],
            [-1.4482323139989797, 6.597642453316964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.34619337930393, "lat": 44.93801318003163 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46115"],
        "coty_name": ["Spink"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spink County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01266987"
      },
      "bbox": [
        -1.4572676789320578, 5.9756502836782115, -0.9303942138585195,
        6.597642453316964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.347456307237929, -2.364209925908278],
            [8.34834840535336, -2.3598500650855203],
            [8.34551866024872, -2.3555929767194437],
            [8.373841793705324, -2.356634156811744],
            [8.392631378388915, -2.352926140307548],
            [8.395213505863916, -2.348268104545802],
            [8.395378272696691, -2.3388853826247233],
            [8.397823637685201, -2.339008874237262],
            [8.397879944930631, -2.3461886068664835],
            [8.402022051044758, -2.3478044449611137],
            [8.450502052817066, -2.343010390401994],
            [8.457126658852268, -2.3459823270375164],
            [8.4720574090138, -2.352655683140064],
            [8.476530041043299, -2.3562192181390214],
            [8.51990353263904, -2.39871299871366],
            [8.551781099010881, -2.4257555582981545],
            [8.564875598040691, -2.441500760367374],
            [8.568764331062559, -2.442525853751011],
            [8.56320445320359, -2.450575636780007],
            [8.56581987776959, -2.453061902553818],
            [8.572745254598663, -2.4536058079021656],
            [8.573574095341131, -2.456733703386189],
            [8.574200927633147, -2.4659132381726785],
            [8.56443778907616, -2.4672759805137],
            [8.55247435110585, -2.4763737180061054],
            [8.533699028248957, -2.5145918925761666],
            [8.53894725325198, -2.515338582155889],
            [8.540163007468285, -2.519250655280363],
            [8.533516989694933, -2.5203768838187757],
            [8.532195132352648, -2.5238749190107757],
            [8.52567211361826, -2.535413318376055],
            [8.519269213482085, -2.541922908266712],
            [8.505062553189749, -2.5705696316036613],
            [8.504236383525692, -2.5742424073756065],
            [8.503732476807663, -2.594224772077564],
            [8.50097036366183, -2.596766761405875],
            [8.501098632172729, -2.6001135140307823],
            [8.506753731720956, -2.601401750423681],
            [8.507374775579805, -2.6083314199338066],
            [8.503910199817831, -2.6083465936951122],
            [8.506241544538591, -2.6249562309223595],
            [8.512169862190234, -2.638708265252453],
            [8.512826782980698, -2.6452110957922597],
            [8.505464273677147, -2.64563890367434],
            [8.505976660635984, -2.6524042381435127],
            [8.500400734183987, -2.654104463979108],
            [8.494630844395635, -2.6500757499713887],
            [8.491192224355412, -2.653558882139065],
            [8.48977462001297, -2.6584628074358143],
            [8.475997795275179, -2.658182547749058],
            [8.47591193500516, -2.663515644077112],
            [8.472325712637302, -2.6668176231321445],
            [8.4670809703665, -2.6629902340161458],
            [8.45996112701773, -2.6630018522092676],
            [8.459926745849877, -2.6671182476912585],
            [8.446310011469116, -2.666668784742358],
            [8.431079031490963, -2.6672674222235133],
            [8.404473043745988, -2.655748797426348],
            [8.393417075067282, -2.6560438209466475],
            [8.385873002779565, -2.6569521767971582],
            [8.37917283457692, -2.652258140911305],
            [8.379049067415133, -2.6481848907099192],
            [8.371339335275039, -2.643624496536014],
            [8.36629779459519, -2.6435770692170353],
            [8.365834718780768, -2.638873190663437],
            [8.362105028669557, -2.6369838474945495],
            [8.357842775246034, -2.6369463128191417],
            [8.356271270171677, -2.634351651639122],
            [8.349608160639805, -2.6307874420243897],
            [8.345017967535636, -2.6299704288830386],
            [8.342883784757904, -2.620655010857609],
            [8.337912860342751, -2.6197716202922825],
            [8.336480652462948, -2.621417508243511],
            [8.330440973804007, -2.6199935035581143],
            [8.328249150495411, -2.6114944215930516],
            [8.329523348830591, -2.606736546421887],
            [8.328864633895774, -2.599286964050085],
            [8.331292669129935, -2.595647151054432],
            [8.326864885563655, -2.591484303664903],
            [8.329306735831803, -2.5862306582824894],
            [8.335882887806454, -2.581283151273276],
            [8.337501695717991, -2.570650475603334],
            [8.34030253913406, -2.5680630542896057],
            [8.338766930719453, -2.565331467902421],
            [8.340262409415725, -2.5582361800619413],
            [8.343175877225477, -2.5582203584788585],
            [8.34319887636273, -2.5531675893094663],
            [8.337186899038374, -2.550412881616064],
            [8.337820452301607, -2.544799258555395],
            [8.335473286966833, -2.5397788680699036],
            [8.336923675600744, -2.534484023426124],
            [8.33571241019642, -2.526061074199649],
            [8.34027539188469, -2.5251173665859112],
            [8.340367812763175, -2.5203156313822985],
            [8.342005777216132, -2.515973062751798],
            [8.342199709927472, -2.5013186850762934],
            [8.339864755043829, -2.4971199856195887],
            [8.339932717597513, -2.470576108894215],
            [8.340311556820716, -2.4475022508012736],
            [8.342735696679341, -2.442420649995243],
            [8.342452997742399, -2.435730144835628],
            [8.347244803547596, -2.435953748120203],
            [8.35086715798969, -2.4384901358129514],
            [8.350771420959285, -2.431439529476077],
            [8.352199371729458, -2.430882715932226],
            [8.352429099433538, -2.4095915607064873],
            [8.358319865366887, -2.409565315394222],
            [8.360771475143785, -2.4034031365808284],
            [8.348056008459238, -2.3862890741023945],
            [8.348436952837465, -2.369836099727506],
            [8.347456307237929, -2.364209925908278]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.06168657243884, "lat": 35.80862862582399 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47015"],
        "coty_name": ["Cannon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cannon County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01648572"
      },
      "bbox": [
        8.326864885563655, -2.6672674222235133, 8.574200927633147,
        -2.3388853826247233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.824167637241088, -2.5228195871644874],
              [9.829417538943966, -2.518470061954981],
              [9.823369916238052, -2.51141508347902],
              [9.818949080262467, -2.515351478838255],
              [9.824167637241088, -2.5228195871644874]
            ]
          ],
          [
            [
              [9.684634244558314, -2.548750514580479],
              [9.691415185875487, -2.547923313681646],
              [9.694913484350135, -2.552268453693103],
              [9.70207607046447, -2.55121938178585],
              [9.704623958628229, -2.5410407197875364],
              [9.697811542596652, -2.5418587811272206],
              [9.696862329226324, -2.534574328270331],
              [9.69242959127023, -2.5322628568463377],
              [9.691938624303972, -2.527710171560136],
              [9.6848707414808, -2.528618133822107],
              [9.68427618648265, -2.521165625520386],
              [9.698363353328189, -2.5198219921638176],
              [9.696814166868963, -2.504948144543903],
              [9.700153791901172, -2.5046654196884472],
              [9.700732722309658, -2.510128646639762],
              [9.7047191584856, -2.5115920635021216],
              [9.705022964777564, -2.514533648014386],
              [9.711608328322544, -2.513669120196635],
              [9.711730233757015, -2.510741766195369],
              [9.731976456361785, -2.508163027554962],
              [9.735234588299756, -2.507163602139966],
              [9.734410547058802, -2.500478005652906],
              [9.751545214558014, -2.4981938250792313],
              [9.749412103585476, -2.4932503892071596],
              [9.752740313020476, -2.49194802661131],
              [9.760611060770202, -2.4912134121415024],
              [9.761131183037433, -2.4978285901821837],
              [9.767672374244585, -2.500005222816752],
              [9.771649596387533, -2.4949785053379645],
              [9.775007865406025, -2.4956601155738753],
              [9.779734520204821, -2.5061800889357833],
              [9.776756103788896, -2.5101057439552297],
              [9.78365463069883, -2.5094565691850517],
              [9.784841731025708, -2.520266704858363],
              [9.799143816432982, -2.5181224534062245],
              [9.805833541679602, -2.514397189627587],
              [9.805408589993688, -2.510819392095909],
              [9.812602960506533, -2.509768663974257],
              [9.811741885877575, -2.502501635418645],
              [9.818903748724912, -2.5016735943214723],
              [9.815025101909303, -2.4985754477046846],
              [9.814113318281656, -2.4913277443092112],
              [9.838672217865787, -2.488509282739943],
              [9.838146529850581, -2.4812148953854436],
              [9.84520171112535, -2.4804429861980535],
              [9.846770426828847, -2.4923746685211783],
              [9.854108694746547, -2.4938810662989934],
              [9.861435076652523, -2.493099700594176],
              [9.861765612185925, -2.4958471722103703],
              [9.868795339254316, -2.494980914032481],
              [9.869283970849777, -2.499591079140249],
              [9.86583558281257, -2.5001171354477396],
              [9.864854469913531, -2.507427093458208],
              [9.877337011664492, -2.507717288397841],
              [9.878333270387271, -2.513459087833966],
              [9.894754100445594, -2.5117128458737183],
              [9.89911255752329, -2.5145914065270696],
              [9.900501411167143, -2.5104726288181842],
              [9.90297208937839, -2.5089652756765495],
              [9.90513976874079, -2.5134004504218392],
              [9.90283713666877, -2.515894680666787],
              [9.901676001930191, -2.5215972893266376],
              [9.902354331926437, -2.5265697601408936],
              [9.906132673346796, -2.5286788916902188],
              [9.91194123280645, -2.5267589305046685],
              [9.917583740767519, -2.522770598437617],
              [9.924427673260226, -2.522668243483762],
              [9.929124666817847, -2.5277247863598085],
              [9.951801481162326, -2.521933986071788],
              [9.956209908453982, -2.5291980507839593],
              [9.962826311118558, -2.540214116431584],
              [9.972305534484846, -2.5445725158396293],
              [9.990136900188837, -2.5445472948426957],
              [9.991234876597163, -2.552003637382408],
              [9.99820795285082, -2.551292693909898],
              [9.99833669651453, -2.554123116556438],
              [10.004374885965735, -2.5540123526063354],
              [10.008878456886205, -2.5553482986593474],
              [10.01018017277739, -2.551091854514507],
              [10.013627033015368, -2.5506786008475952],
              [10.019876412013936, -2.5446872292682396],
              [10.02224476178906, -2.547510706202482],
              [10.022628789265523, -2.554401345298679],
              [10.025909859541816, -2.5580701074691445],
              [10.027728026019554, -2.5562110226488555],
              [10.034299600418835, -2.5550342392112744],
              [10.03511762326664, -2.5616731859470514],
              [10.041521967771196, -2.570074913038899],
              [10.038183193707217, -2.5770660422176332],
              [10.041030049503474, -2.5799019440359765],
              [10.04420577936929, -2.586072261783842],
              [10.050305644477197, -2.587821774703188],
              [10.053931669275105, -2.5846210189651075],
              [10.060431910449225, -2.5813015490946207],
              [10.068084802075267, -2.581142978140399],
              [10.07350657919123, -2.5796926292527655],
              [10.081061437376766, -2.5829832137255457],
              [10.084373119032355, -2.58205266821762],
              [10.090869931593705, -2.577225156273818],
              [10.10342557798607, -2.576003813915662],
              [10.105889352690431, -2.574012230310928],
              [10.106950148272018, -2.5683658105279785],
              [10.113925869488325, -2.5660905982895006],
              [10.119394650376396, -2.5701785284238907],
              [10.11788518757853, -2.5794393007069547],
              [10.122935279414083, -2.5893187236245265],
              [10.121454214755776, -2.5940350727908537],
              [10.115688553268983, -2.5969212240634025],
              [10.111811748534802, -2.601154537763325],
              [10.110021025290195, -2.605796925916777],
              [10.111530680716669, -2.61084712526675],
              [10.118885359068322, -2.616605233533589],
              [10.127320364021353, -2.6205513030233325],
              [10.130133017656078, -2.6250853352829626],
              [10.1305544191708, -2.6298506527736527],
              [10.135019902677582, -2.632524779314833],
              [10.13782420326013, -2.6309271403526524],
              [10.138577392423189, -2.6219343986867565],
              [10.140039628467527, -2.6176642736243427],
              [10.145791575222637, -2.618663505126123],
              [10.152443422334096, -2.625214218472348],
              [10.15599611383501, -2.6268227016803793],
              [10.166619565800145, -2.6243900412151873],
              [10.17052453602696, -2.62572135255262],
              [10.171189038126691, -2.6293127165750554],
              [10.168247678455698, -2.6343389263756767],
              [10.152374893551332, -2.6461373332428897],
              [10.152643477733477, -2.6503967097462366],
              [10.156592516790646, -2.653081901686929],
              [10.156859591743165, -2.657373599443206],
              [10.154315098204794, -2.6618596377298864],
              [10.149373793107578, -2.662745899383807],
              [10.148870402740974, -2.6691331100971967],
              [10.14482217440471, -2.670766000543277],
              [10.141555509737467, -2.676737953943203],
              [10.134622254537408, -2.6819710902221265],
              [10.13192386273034, -2.6866857600553273],
              [10.130790649246212, -2.69457143039077],
              [10.12019551003773, -2.710295293918181],
              [10.11497346950752, -2.7108538033308105],
              [10.113755078996006, -2.71344593312241],
              [10.115735002640498, -2.7187832889721513],
              [10.119107050229045, -2.723537019511672],
              [10.122478225642627, -2.7244307041563913],
              [10.128146897502939, -2.7312295458581124],
              [10.12650350583267, -2.737532465353998],
              [10.129526671833217, -2.742736261074151],
              [10.131021629049197, -2.749882743982869],
              [10.1258416620683, -2.7574388880820893],
              [10.120508108954708, -2.7689325393491444],
              [10.11348735892887, -2.7714690594935734],
              [10.110176830729314, -2.773839721662089],
              [10.109391886375612, -2.7768427719516495],
              [10.113521399041646, -2.781441879131894],
              [10.112386941275817, -2.786762181189152],
              [10.116492073619067, -2.7874985697801344],
              [10.118423011923053, -2.7905461826435567],
              [10.115455041068282, -2.80657674598984],
              [10.116590903749097, -2.812323843573903],
              [10.123754274975395, -2.814160232911436],
              [10.128848831078841, -2.8215391611379497],
              [10.127873376555074, -2.8273500959948596],
              [10.123854140439285, -2.8315093044857607],
              [10.118738586458765, -2.835716075239757],
              [10.114663983843398, -2.8466913623577916],
              [10.105515821727595, -2.8582058942706965],
              [10.099281523110688, -2.8605155532014974],
              [10.094107025531683, -2.8641128044720845],
              [10.086003653012746, -2.867810368116665],
              [10.085074014468539, -2.8720542944010004],
              [10.07850006176489, -2.8800923077837717],
              [10.07414652776925, -2.8834545872808905],
              [10.070657190778192, -2.882973228952813],
              [10.066671408032057, -2.880026699063986],
              [10.060781073750771, -2.8832329306016162],
              [10.056764014094826, -2.880487867792288],
              [10.05174622121167, -2.884062103411491],
              [10.052495526335363, -2.890669688790715],
              [10.047130101079068, -2.892056287592966],
              [10.043648923166273, -2.8897490684655853],
              [10.0379960487215, -2.8883259992275017],
              [10.025435552565964, -2.8909124032349376],
              [10.023808366271561, -2.8935527136819146],
              [10.016209957136953, -2.892168277337469],
              [10.010341167974154, -2.898079446562966],
              [10.002474231091503, -2.8997720443398323],
              [9.999033752698637, -2.897053809036052],
              [9.993415419971049, -2.897145144051768],
              [9.990814520788632, -2.893306641285881],
              [9.988882792595156, -2.8854321472708793],
              [9.980416244950767, -2.876023074220672],
              [9.976564978856231, -2.8745734441012982],
              [9.970484521104115, -2.874213182018785],
              [9.964514744047861, -2.879321174859834],
              [9.958962216418328, -2.889757547090688],
              [9.956961885611916, -2.8920364491344808],
              [9.949549457260646, -2.896713861041344],
              [9.946023107528601, -2.900501476877236],
              [9.944468630518408, -2.9050595843977014],
              [9.93321661396611, -2.9136615620006356],
              [9.928367253148332, -2.921266380459989],
              [9.924400443861243, -2.925217742020559],
              [9.922448870585814, -2.924338422515646],
              [9.923117922349025, -2.9434238755383277],
              [9.89469799303031, -2.934053593581988],
              [9.890665263835201, -2.9463261849839575],
              [9.88393161879184, -2.944007997061591],
              [9.881610211994452, -2.950993913450027],
              [9.874969412438261, -2.94876603907627],
              [9.879222452319148, -2.9349459701344753],
              [9.865504302905682, -2.9302386327840333],
              [9.86785637623381, -2.9228442522986278],
              [9.814626058840188, -2.9056750754379683],
              [9.750145757739856, -2.8846587746900267],
              [9.757747093600736, -2.873619883709825],
              [9.759403730863358, -2.8693057430738675],
              [9.764274673794604, -2.862809937691679],
              [9.771188632223101, -2.8572026614067325],
              [9.77985072613244, -2.8469853082267402],
              [9.812887572055246, -2.831229082396431],
              [9.820537526262195, -2.83049437505636],
              [9.819152591784508, -2.8165493585308337],
              [9.812171536732032, -2.817406272655976],
              [9.80560880560008, -2.7632855438041846],
              [9.801130975994873, -2.7612883862007456],
              [9.791466449223613, -2.7614662888465022],
              [9.790669874986897, -2.7549646893404622],
              [9.787073621749837, -2.755505718615574],
              [9.786552425745393, -2.7519145828921068],
              [9.790162662130722, -2.7513363130302526],
              [9.789175211227734, -2.7449239322298724],
              [9.786322035918777, -2.7409172283819885],
              [9.780727386150106, -2.741560095363785],
              [9.777256713205244, -2.7245784487089715],
              [9.780349784865631, -2.723960063507439],
              [9.779626925603358, -2.7184877032868653],
              [9.771494489925466, -2.709430475327378],
              [9.764164942954192, -2.710585705965224],
              [9.76352206573635, -2.7059918272859966],
              [9.769271040629738, -2.705197032847891],
              [9.770419209036067, -2.7022364218156416],
              [9.761011889709218, -2.688888801649816],
              [9.748740563495227, -2.663413852608695],
              [9.735581237973243, -2.640898004070909],
              [9.711981596937077, -2.599356422138753],
              [9.70704203441996, -2.5921835293542546],
              [9.706109250414137, -2.5847635919861434],
              [9.691835987156198, -2.5865135170488895],
              [9.689139168533927, -2.564860318817859],
              [9.68809082334159, -2.553978299109144],
              [9.687537509356076, -2.5503451728018356],
              [9.684634244558314, -2.548750514580479]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.25274474708101,
          "lat": 35.442670720116794
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47123"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01639776"
      },
      "bbox": [
        9.68427618648265, -2.950993913450027, 10.171189038126691,
        -2.4804429861980535
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.667730737389936, -2.503803934008974],
              [9.667108014760391, -2.4974056439590857],
              [9.663553239016506, -2.497782049778549],
              [9.663748110650632, -2.50152993877626],
              [9.667730737389936, -2.503803934008974]
            ]
          ],
          [
            [
              [9.45597065533266, -2.372247818689097],
              [9.460423050478788, -2.369938186635523],
              [9.469468766777497, -2.361827640990178],
              [9.470754534908302, -2.3542981124530566],
              [9.477084678132528, -2.347515801099223],
              [9.48578088252247, -2.3410302334955833],
              [9.49060074927007, -2.334278769807374],
              [9.494273219523807, -2.332948034550923],
              [9.495740336320031, -2.327740609963904],
              [9.501098208371449, -2.3160404897077767],
              [9.507879355942427, -2.293911770997145],
              [9.509660624368797, -2.295856304510552],
              [9.514354131027025, -2.2895063810467007],
              [9.523855334729646, -2.285093116313161],
              [9.5267561540046, -2.279076228717449],
              [9.530792199884356, -2.2768385490651992],
              [9.53384621874451, -2.268924987543088],
              [9.540893107557574, -2.2698962520350863],
              [9.541394451646873, -2.265054528333359],
              [9.544478630939366, -2.2656956058479447],
              [9.547464869369346, -2.2560829526676796],
              [9.554394722539838, -2.2566169633609965],
              [9.557523808064042, -2.252025357577796],
              [9.561574615577861, -2.25285745401946],
              [9.565666378674575, -2.251704811798907],
              [9.56624415733671, -2.24800422910769],
              [9.571502240289613, -2.2495947333901074],
              [9.57466157585164, -2.240608584843932],
              [9.581836098370015, -2.2357636419845455],
              [9.580549029708942, -2.2292622771640653],
              [9.584490945711961, -2.2284057887405186],
              [9.593627747256559, -2.2294503635463205],
              [9.601151265297954, -2.226339879360296],
              [9.605587869377539, -2.2275517112411207],
              [9.614955503152126, -2.226731340384668],
              [9.621789628823784, -2.2250855523057065],
              [9.620844131643588, -2.210813503503534],
              [9.626969897570516, -2.205641286437936],
              [9.637378691740805, -2.2002188461203156],
              [9.646229969621679, -2.197211602102594],
              [9.654697573699043, -2.1932846894677938],
              [9.66559115172476, -2.1866266330560094],
              [9.67156421846613, -2.183671295582614],
              [9.674701615309038, -2.184635763622794],
              [9.680105794286836, -2.183184505172219],
              [9.68715721059666, -2.183345696100268],
              [9.692703146625236, -2.1808998547280383],
              [9.696014921212289, -2.181794459967491],
              [9.704170045691813, -2.178884155062581],
              [9.708527463292066, -2.1754228434628415],
              [9.712587492643504, -2.1699898443423344],
              [9.722857504745628, -2.1611643163627923],
              [9.726283733461761, -2.1574925128997715],
              [9.732831347678724, -2.1529311539033062],
              [9.741075482800648, -2.1424707637369167],
              [9.749931424778692, -2.134372759798018],
              [9.75629256838906, -2.1237346468562386],
              [9.764278908407467, -2.1132006477047733],
              [9.775984371455525, -2.105990939432541],
              [9.779343429396965, -2.105655439502446],
              [9.803624528685415, -2.160703248424423],
              [9.839569157577419, -2.2197193929649965],
              [9.85241738157134, -2.23768829180254],
              [9.85590579136158, -2.24498081584572],
              [9.860595305860071, -2.250113240806972],
              [9.858340934917894, -2.2532776793475806],
              [9.854265457039926, -2.25118253954009],
              [9.849055790681737, -2.2464170296018096],
              [9.845685123338868, -2.24581936740084],
              [9.843226261066764, -2.248113425353052],
              [9.843059217793993, -2.254985916701052],
              [9.850275422426934, -2.2675540753499956],
              [9.850623579782654, -2.2713976197466526],
              [9.845599875414688, -2.2741870175345276],
              [9.838147079275165, -2.2667304128798587],
              [9.825284944797438, -2.2633110065336735],
              [9.817459019075386, -2.266248551009392],
              [9.810540778225377, -2.263990925559071],
              [9.80805063726244, -2.26071231625744],
              [9.807000166508116, -2.276861980149657],
              [9.806221957069903, -2.3042299360002096],
              [9.8082858672721, -2.3145724429710492],
              [9.805369554103882, -2.3230341493397724],
              [9.801457137193292, -2.3230313193282455],
              [9.788442597354024, -2.3318547844911253],
              [9.783191262368668, -2.3318865318384456],
              [9.780857792312302, -2.3378501134653513],
              [9.777743982284063, -2.3411125682914875],
              [9.778005569530233, -2.3531025009954343],
              [9.779989288602465, -2.360772654459803],
              [9.778530705920534, -2.3622662440661957],
              [9.783015354891083, -2.3676513633264955],
              [9.774837303985734, -2.3769353198595904],
              [9.781732120781761, -2.3808392899059196],
              [9.776651535436722, -2.3911121455922304],
              [9.764419987949562, -2.384892533807438],
              [9.761148629818047, -2.384180971928689],
              [9.753465191869925, -2.3857260514316425],
              [9.749549924597293, -2.3907507150050202],
              [9.748482998714481, -2.3944719721395904],
              [9.749353761074188, -2.4050117016335006],
              [9.748651792023514, -2.4098766508096494],
              [9.744916993593984, -2.4147689467998847],
              [9.741960641812053, -2.4158168323098996],
              [9.736898828445499, -2.414026812771099],
              [9.732242339323353, -2.4104338807572914],
              [9.729897535328025, -2.4058994297857415],
              [9.716625233501613, -2.4257362916810985],
              [9.69848238552788, -2.453463849823694],
              [9.685705179895324, -2.454928340526031],
              [9.681114236469822, -2.459962015155918],
              [9.678241332875563, -2.467406112753713],
              [9.679237014351187, -2.4777251445365396],
              [9.675860484084325, -2.478107033691406],
              [9.676233887818206, -2.4817430535404728],
              [9.672717123402094, -2.4821732572869664],
              [9.672524197969182, -2.489481894905922],
              [9.68060117676559, -2.4887752049787735],
              [9.68139306931652, -2.495921823835862],
              [9.674324244633686, -2.496763294464756],
              [9.674923565830914, -2.5030171908136816],
              [9.667730737389936, -2.503803934008974],
              [9.667994001487878, -2.5084422107513076],
              [9.661193806153294, -2.509065998447513],
              [9.661588136367671, -2.5127348566105288],
              [9.657992227671206, -2.5131656441395394],
              [9.658440751167129, -2.5167477076037454],
              [9.640646588473333, -2.5188320065689607],
              [9.64160309354157, -2.5260792696033305],
              [9.634485863497147, -2.526969227868889],
              [9.635304748648588, -2.534163964986352],
              [9.606977865125314, -2.5373435384073217],
              [9.605252642669582, -2.5231189030644674],
              [9.60046506364943, -2.523690130308006],
              [9.598323144994314, -2.5205155671335313],
              [9.594948147703906, -2.4926248520346506],
              [9.60145939313227, -2.487049831938129],
              [9.59754541979187, -2.4824015912259956],
              [9.600613443072948, -2.4784708128851776],
              [9.600022979593495, -2.47397851343921],
              [9.596885314511306, -2.4743129735264033],
              [9.596355506336225, -2.4704642396363115],
              [9.58465083009902, -2.463128196380132],
              [9.584243796734308, -2.4592108360048472],
              [9.577225516974217, -2.4599025980923734],
              [9.57794446274082, -2.4672755154261377],
              [9.570674630985279, -2.467942933525194],
              [9.571505864055656, -2.475231224020457],
              [9.564448135375518, -2.4758887836774255],
              [9.565077625422422, -2.483291514323715],
              [9.55811733849237, -2.484016940301909],
              [9.55742955265608, -2.4765481062886034],
              [9.553829401365205, -2.476870112733757],
              [9.55292183777058, -2.4698569907502788],
              [9.535150292475656, -2.4716066369068774],
              [9.534440784933269, -2.4644266350031305],
              [9.537015272064933, -2.464219815372955],
              [9.536258605182034, -2.456431078940715],
              [9.53362957920737, -2.4567215814898695],
              [9.532534708588432, -2.4476064646420808],
              [9.52007904234349, -2.4489175499202127],
              [9.512807915013594, -2.439377735529089],
              [9.51089545887602, -2.438934379444],
              [9.504001469807426, -2.444069211732015],
              [9.499165182515567, -2.441906238619314],
              [9.492487468746306, -2.442884936344655],
              [9.48626595199994, -2.4403466874450457],
              [9.483032941740548, -2.434198143644025],
              [9.486507797300105, -2.427114839770111],
              [9.484915838144921, -2.4243107642726427],
              [9.486946712740712, -2.4199787469409433],
              [9.494644745538666, -2.418522568503702],
              [9.496423018555257, -2.413856724102758],
              [9.494181109581994, -2.4057963763961108],
              [9.48757072047296, -2.3999702127274554],
              [9.478744181410754, -2.399605364762925],
              [9.472147716557641, -2.396372613844887],
              [9.466147075200395, -2.3881148036921],
              [9.457634335239163, -2.3837973429487977],
              [9.455061194220436, -2.3851621907115126],
              [9.451380203894182, -2.3832729823485908],
              [9.455923357442316, -2.379348737175602],
              [9.453581826407804, -2.374610261588195],
              [9.45597065533266, -2.372247818689097]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.52319762587854, "lat": 35.84782855479827 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47145"],
        "coty_name": ["Roane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roane County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01639785"
      },
      "bbox": [
        9.451380203894182, -2.5373435384073217, 9.860595305860071,
        -2.105655439502446
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.829372136578288, -2.7413546028855444],
            [8.869143922367908, -2.735638306471798],
            [8.87230765958282, -2.733037670759893],
            [8.877919089937327, -2.7313167241317142],
            [8.878343579524792, -2.7249336698337068],
            [8.887847431750286, -2.7247099269506427],
            [8.890488658928858, -2.7258255595625434],
            [8.900444565314054, -2.721120172675848],
            [8.917043242864656, -2.715498824109204],
            [8.924599068231634, -2.7152044252435594],
            [8.93410297464205, -2.7135896298773696],
            [8.945898023448066, -2.713073612567171],
            [8.945253518989508, -2.709504752617486],
            [8.949146101507827, -2.7067524655795214],
            [8.94971563163114, -2.7012099121422897],
            [8.972486141947519, -2.689248690075371],
            [8.970362627767452, -2.694611176906763],
            [8.968135022448735, -2.7048519293199424],
            [8.968381470811865, -2.711651476231512],
            [8.965398122846437, -2.7156622938373696],
            [8.971210567139757, -2.7282774760735435],
            [8.980357586319961, -2.7295262313516053],
            [8.983624037082249, -2.736004564874802],
            [8.991559764791106, -2.7375942482923783],
            [8.98907914881646, -2.743711662235605],
            [8.989069778736122, -2.7492455320501197],
            [8.99140447827032, -2.7505625225504557],
            [8.997350688210458, -2.762673007776345],
            [9.03644745316456, -2.7956956197898477],
            [9.077188782922105, -2.829838026952018],
            [9.130698555662969, -2.8677250027725774],
            [9.155371205943371, -2.8847989992190013],
            [9.14321237461828, -2.9218729155509533],
            [9.123155491936323, -2.9607630828847293],
            [9.074263014703941, -3.0573304678302207],
            [9.049144847614542, -3.1067478775866344],
            [9.048439146964984, -3.0988292556482895],
            [9.046893857530023, -3.095258313217565],
            [9.041497835443128, -3.0890655376947693],
            [9.040974580391557, -3.080769496878274],
            [9.044440809895335, -3.0732146821012467],
            [9.036773406441881, -3.0611528015571197],
            [9.039560740757322, -3.0528882974466653],
            [9.037247010245256, -3.048199856654966],
            [9.0343415731714, -3.046379134620001],
            [9.029815017856997, -3.0387349961933845],
            [9.027874217694578, -3.032160783138889],
            [9.023669340014516, -3.0299862690060966],
            [9.007408952103951, -3.0142236714839683],
            [9.00667400963034, -3.010821825687344],
            [9.002756840120332, -3.0096592274529064],
            [8.999999247727505, -3.005562472675742],
            [8.995313777665359, -3.0051379494717896],
            [8.99325867916111, -2.999450359638185],
            [8.989778707378921, -2.9960611720190546],
            [8.983747267778087, -2.9944134355207304],
            [8.98073707070174, -2.992068342497536],
            [8.977436916540931, -2.993036497703183],
            [8.969409572628376, -2.9917190941621867],
            [8.964294802027458, -2.9933139774277735],
            [8.960600397349095, -2.9914576837107134],
            [8.953034422896547, -2.990752335322752],
            [8.950286310287689, -2.989258917775691],
            [8.94766016013903, -2.983374170037441],
            [8.894624793426347, -2.9606040714890254],
            [8.891965891448942, -2.9497496606394322],
            [8.896870330174595, -2.9397969267649744],
            [8.902537876239979, -2.926121429703562],
            [8.908147220416067, -2.9232499892406136],
            [8.913093318463329, -2.9235592605018406],
            [8.914642318951643, -2.917722716057406],
            [8.919673370650303, -2.9147499730539344],
            [8.929543493486962, -2.9068934669023374],
            [8.929366815729525, -2.897586769789186],
            [8.93384174068257, -2.8867468521878923],
            [8.940550157671248, -2.879299154802533],
            [8.935927767168119, -2.8768777783898734],
            [8.935727473299798, -2.8714904348231984],
            [8.93738745169762, -2.863845875191311],
            [8.940902341511084, -2.8561322427527553],
            [8.918871726959495, -2.8572501615549433],
            [8.918282173660465, -2.8436787575277997],
            [8.912753808531114, -2.8414233092881593],
            [8.911230704076345, -2.8439579652818314],
            [8.897807286149362, -2.8353669990022246],
            [8.89130207611493, -2.8081706074545396],
            [8.890063734191216, -2.8058973753963534],
            [8.891492117507525, -2.7857626287702315],
            [8.890966553814048, -2.7797515529837433],
            [8.887702740730923, -2.7764800918804924],
            [8.872411254706746, -2.7684198858014897],
            [8.862501432321618, -2.763949014612166],
            [8.855848206917159, -2.757884985099638],
            [8.849018792211497, -2.7547577256918823],
            [8.844532991573576, -2.7500311572914082],
            [8.829372136578288, -2.7413546028855444]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.41054462276382, "lat": 35.37106840389016 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47153"],
        "coty_name": ["Sequatchie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sequatchie County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01652643"
      },
      "bbox": [
        8.829372136578288, -3.1067478775866344, 9.155371205943371,
        -2.689248690075371
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.077979299903916, -1.3788157787861406],
            [11.13532447758715, -1.3695960028288074],
            [11.178245404391092, -1.3628400439327475],
            [11.19016647209001, -1.3624334404264],
            [11.325746942006635, -1.3416275478608122],
            [11.36878313090005, -1.3353362256943726],
            [11.391560028108616, -1.3319758581781969],
            [11.420463563927871, -1.328936486204878],
            [11.442802094309622, -1.3255552123102945],
            [11.546184449981784, -1.310624233913799],
            [11.609209292864897, -1.3014502808149806],
            [11.614977264733234, -1.2781399077131737],
            [11.69068273284338, -1.2688469285556638],
            [11.689750215228663, -1.2735349613603502],
            [11.684732105873241, -1.274743608801929],
            [11.681394468432234, -1.2782022976695748],
            [11.675332079891543, -1.2822756257672356],
            [11.668921235917175, -1.2824203038919093],
            [11.666483723629916, -1.28064237986272],
            [11.657929235056494, -1.2858019502229068],
            [11.655756529819515, -1.2884745152139616],
            [11.656223216576398, -1.2932012552513263],
            [11.654728155217063, -1.2955681852302656],
            [11.656566347969285, -1.3004539505558061],
            [11.653953181277375, -1.3048618738965632],
            [11.648836917234469, -1.3087817065242406],
            [11.643607704335992, -1.3092554077291851],
            [11.639461455757282, -1.3116038353206378],
            [11.6355026839967, -1.3103594201988567],
            [11.633734007638324, -1.313576889353837],
            [11.623319866639186, -1.3215838476994934],
            [11.617924054470324, -1.3269877963332113],
            [11.614887268049527, -1.3330529115944134],
            [11.618848431638401, -1.340727855119662],
            [11.61294765806604, -1.3470155598084457],
            [11.609991513412382, -1.3525579627064113],
            [11.60748942663747, -1.3546652696708126],
            [11.606052525098562, -1.3595433981831226],
            [11.594789692667081, -1.3666517468872061],
            [11.593379886849846, -1.373396698947829],
            [11.589514210054636, -1.3766242282940957],
            [11.589706570229554, -1.3833297853999378],
            [11.582857456855486, -1.393019926761263],
            [11.5800741669444, -1.3910865339825078],
            [11.576430227316344, -1.3974430811344545],
            [11.570628454179705, -1.4039153500769481],
            [11.573644533936834, -1.4070317310804843],
            [11.574099095783199, -1.4102403566251984],
            [11.570498743370209, -1.4111784119935606],
            [11.565871787439484, -1.4147211338207233],
            [11.553562070267926, -1.4169539256902504],
            [11.549367483547876, -1.4212476076513028],
            [11.543054961560376, -1.4215704994892049],
            [11.533096959237565, -1.4293677808587213],
            [11.532125719698954, -1.436958412883649],
            [11.523887839082763, -1.448784309969353],
            [11.518714180984055, -1.4513839754181932],
            [11.516053043899113, -1.4546338234101734],
            [11.508942378304143, -1.4532503330030955],
            [11.499372859853269, -1.455664978749678],
            [11.496109756792958, -1.4593167960577142],
            [11.494198121230713, -1.465913296981222],
            [11.49119603203585, -1.4669446437737834],
            [11.486784424536372, -1.4710790209584326],
            [11.486499175931622, -1.4751888095714831],
            [11.480264076263472, -1.4781627731482965],
            [11.47569120549479, -1.4830166307814479],
            [11.473089391113804, -1.487785702160107],
            [11.466742972176613, -1.4950411350713437],
            [11.463571748101108, -1.4970363604595833],
            [11.457703200417063, -1.5037106657999222],
            [11.45392889127535, -1.5059977836204126],
            [11.449130696322689, -1.5111894338293526],
            [11.44510902720955, -1.517285836827177],
            [11.437751935836513, -1.5242778987808974],
            [11.433330960216454, -1.5238027201532924],
            [11.427185402741582, -1.5253141423659675],
            [11.406707049436497, -1.5186172187550746],
            [11.401016099471674, -1.517713638700414],
            [11.394051524437153, -1.5094844652916297],
            [11.384564223763332, -1.512128090310069],
            [11.359198685069337, -1.5412735136351303],
            [11.350132289871462, -1.5412283096950383],
            [11.331663851813627, -1.5411445591549224],
            [11.326800373911754, -1.5441440936757118],
            [11.319643500912967, -1.5401491202086162],
            [11.313547273361136, -1.5458547451288864],
            [11.310841368093302, -1.541591480169141],
            [11.294298472573486, -1.5426283413483397],
            [11.292246028924604, -1.5461658020535591],
            [11.283666302790905, -1.5549970940683329],
            [11.281161960299713, -1.5539114213856078],
            [11.28140733060699, -1.549447162694717],
            [11.288326092656524, -1.5405926247566546],
            [11.287184223631703, -1.5381625648967678],
            [11.282166044279775, -1.53569614916646],
            [11.28738156259195, -1.5282381043715672],
            [11.280679172670197, -1.5286074173452173],
            [11.278210276265037, -1.5273096573850709],
            [11.275005403960561, -1.5218020977835536],
            [11.273737413180084, -1.5163384950728576],
            [11.271143109138299, -1.5168367567340095],
            [11.26919204837543, -1.521115556067699],
            [11.269203410328739, -1.5263951992968654],
            [11.264433572693797, -1.527485881492026],
            [11.260055512259253, -1.5238830279949929],
            [11.262711800656696, -1.5175985100207598],
            [11.261384178118474, -1.513240430861977],
            [11.24771363633618, -1.5127492728827114],
            [11.24840651450318, -1.506061432115851],
            [11.246784555425862, -1.5044126178217023],
            [11.241966245030822, -1.5100367346265413],
            [11.24016596761204, -1.5137760638455282],
            [11.235791790625958, -1.5158317548330766],
            [11.233779135853574, -1.5079280920689369],
            [11.181697822439105, -1.5244680278682263],
            [11.132361864998128, -1.5408447727898387],
            [11.10799304037245, -1.5484970044960358],
            [11.100906177180736, -1.5432378972641758],
            [11.0615021791343, -1.5395395821503985],
            [11.05709908708464, -1.536288663500204],
            [11.048806498815143, -1.5436758191902111],
            [11.04456247704954, -1.5489623565608892],
            [11.042284787969734, -1.5498990425930472],
            [11.038009608871896, -1.5458270277357404],
            [11.038142602513263, -1.5416228237552223],
            [11.035969037121806, -1.5376407425908944],
            [11.03219382253934, -1.5376681933130791],
            [11.029430583111262, -1.5346892813712156],
            [11.027928000503367, -1.5303139236056733],
            [11.02413556675947, -1.5273829756743311],
            [11.029170903348776, -1.5237185003505513],
            [11.04333910699232, -1.5077530158007573],
            [11.050303655605857, -1.5030053325567696],
            [11.057011885536262, -1.496962017538068],
            [11.059363676012708, -1.4965278001852982],
            [11.068366819480326, -1.4885271271785745],
            [11.072296371964649, -1.4838942605626166],
            [11.078094692751995, -1.4794042172668267],
            [11.074065398782217, -1.474391197441424],
            [11.074275907154279, -1.462627704044128],
            [11.076803288570538, -1.4595076171659322],
            [11.082035843054472, -1.4578490584778736],
            [11.087795829100493, -1.4536690197280548],
            [11.082073177800947, -1.42515982587847],
            [11.077567699940136, -1.4165286853667869],
            [11.079650706383307, -1.409774994227906],
            [11.075431464081356, -1.4049878459365825],
            [11.074246521462252, -1.4008297055146572],
            [11.074665419714732, -1.3938908316466316],
            [11.077527323995369, -1.3948837416770297],
            [11.081494337494854, -1.4013150640090428],
            [11.087688281918433, -1.3953091540811091],
            [11.081126771715187, -1.3831655604851436],
            [11.077979299903916, -1.3788157787861406]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.30418601305973, "lat": 36.51291148478787 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47163"],
        "coty_name": ["Sullivan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sullivan County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01639793"
      },
      "bbox": [
        11.02413556675947, -1.5549970940683329, 11.69068273284338,
        -1.2688469285556638
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.169566674355, -2.0042194827302957],
            [6.177934838899836, -2.0036243028055423],
            [6.23290845596762, -1.9994249926529506],
            [6.301539788838476, -1.9947476178263805],
            [6.3936128060189406, -1.9880059356317759],
            [6.416541422820902, -1.9865885183325644],
            [6.418351936267484, -2.0247170557205973],
            [6.423172509757799, -2.120400777202479],
            [6.42723169500715, -2.195443967271294],
            [6.430165353935471, -2.260832400651058],
            [6.433138416314132, -2.3388287649251094],
            [6.434514552501951, -2.3757524633119615],
            [6.410823008382602, -2.377384870723768],
            [6.368466959387513, -2.379820767444301],
            [6.336015441266881, -2.3814926538799583],
            [6.3414620634646175, -2.4347223828782982],
            [6.332722178812293, -2.4340995000010714],
            [6.324404878257255, -2.4385455052148632],
            [6.321276745300336, -2.434073693329369],
            [6.3105465146993085, -2.438673813532386],
            [6.303452629985827, -2.434605587646704],
            [6.298082606808958, -2.432585879134213],
            [6.293139019297574, -2.429109071753596],
            [6.292304922574955, -2.4263038146168086],
            [6.2868800780244385, -2.424624354676913],
            [6.282695285420105, -2.4214669803584985],
            [6.279251531879728, -2.423799000086484],
            [6.270928284160652, -2.4174655417576356],
            [6.268167834681831, -2.413463220250021],
            [6.263695259434093, -2.413241617070132],
            [6.262075428372336, -2.4110755847909986],
            [6.263814524798213, -2.4067202961002496],
            [6.259243226157737, -2.4028812407877935],
            [6.258232027400221, -2.397520238405556],
            [6.253288164085681, -2.3973997985526507],
            [6.247503580231474, -2.3933309691744404],
            [6.243113407954267, -2.393824087263871],
            [6.240615899151606, -2.395947905534548],
            [6.231933996061378, -2.394856342651035],
            [6.226703685398486, -2.393221732664846],
            [6.221534326491064, -2.3937909482374846],
            [6.218061434664675, -2.3910252657235995],
            [6.213323938296899, -2.3904183757880473],
            [6.210401355712667, -2.3918340630385724],
            [6.199968984494972, -2.3887627750947074],
            [6.192259861103648, -2.388865532460941],
            [6.186307702879117, -2.3823585402858645],
            [6.182394650228255, -2.38103935951217],
            [6.180767645622984, -2.3748127704707205],
            [6.175584252871775, -2.3740490972218575],
            [6.171639244401317, -2.375343052534405],
            [6.1684638884651966, -2.3736774570852637],
            [6.161381993540604, -2.362133161538634],
            [6.15615865129848, -2.3578002115916252],
            [6.155373826467286, -2.3527467653678635],
            [6.150548739061953, -2.3495496502745357],
            [6.1497235484550075, -2.344893575629716],
            [6.142389885239096, -2.3389500242592893],
            [6.139281926477555, -2.3350188919750874],
            [6.134885907419807, -2.335235410668076],
            [6.125034257815303, -2.327726835740879],
            [6.119399686816826, -2.3244406123173795],
            [6.109738771197322, -2.321567106982787],
            [6.099218251070995, -2.309858538356532],
            [6.096979751918248, -2.3065458377338026],
            [6.093186895001784, -2.3048665204072813],
            [6.089783529985672, -2.2987193199820144],
            [6.085247339991035, -2.2937896934741535],
            [6.08371958073657, -2.238442598627499],
            [6.078981121018327, -2.10570314984732],
            [6.08147629370079, -2.10270663030095],
            [6.084462505350973, -2.1066858137175677],
            [6.086337487379063, -2.1031889672734647],
            [6.091650736961144, -2.1057343798173345],
            [6.0963435380256294, -2.103450786813403],
            [6.09849562172306, -2.10578605289466],
            [6.108303169806959, -2.106229043479107],
            [6.113015348156407, -2.1133144654806997],
            [6.118275837903523, -2.114340591477825],
            [6.119100973698859, -2.1173298881182108],
            [6.124171882195889, -2.1179975327191074],
            [6.127028905239225, -2.1166739074233525],
            [6.131327085591854, -2.1183488432606814],
            [6.143087558966151, -2.108213213139329],
            [6.145945611215204, -2.1085690670869686],
            [6.149159877553969, -2.1036516473467985],
            [6.154035153740816, -2.099796728905837],
            [6.15832923674244, -2.0993722706578186],
            [6.161112957910037, -2.095598458872804],
            [6.166073791141381, -2.0960236821324645],
            [6.183210239641097, -2.095614484985947],
            [6.185228162958489, -2.0962367586492467],
            [6.185148466492901, -2.084308801091177],
            [6.182558751574044, -2.035664492771484],
            [6.179923683016163, -2.029301660655313],
            [6.177157095124299, -2.028041896203915],
            [6.174469830140915, -2.018797259483801],
            [6.170291850015861, -2.0113011865693466],
            [6.169566674355, -2.0042194827302957]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.7178355496645, "lat": 36.29818606131689 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47183"],
        "coty_name": ["Weakley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Weakley County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "01639799"
      },
      "bbox": [
        6.078981121018327, -2.438673813532386, 6.434514552501951,
        -1.9865885183325644
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.4993856566103556, -5.030752184427442],
            [1.5028906829618336, -5.032256559772542],
            [1.5079920314785542, -5.041819901187545],
            [1.5164850705697628, -5.0428768774226755],
            [1.520511097429656, -5.0442307657730545],
            [1.5238544038394344, -5.0380570606768345],
            [1.5227774068126732, -5.031366664018153],
            [1.5197186958772706, -5.028685390715669],
            [1.511542558530471, -5.026263857726236],
            [1.508539719744466, -5.01943709761815],
            [1.5105945953634572, -5.017339669463752],
            [1.5142682529190812, -5.017714233488298],
            [1.527990538583302, -5.024202083124146],
            [1.53601888837983, -5.029615204149433],
            [1.5357226189387227, -5.035600690338234],
            [1.5269183911843132, -5.035620624192114],
            [1.5233187940194814, -5.044255279740837],
            [1.5242885426486135, -5.045337945275267],
            [1.5331575464709704, -5.045081642021635],
            [1.5502723949619812, -5.0485450689557885],
            [1.5559311554889248, -5.044986078021105],
            [1.5609010509960415, -5.0394133498705935],
            [1.5641213676233103, -5.038064006273271],
            [1.569222745246628, -5.039468641870374],
            [1.5764981206517243, -5.045298419906344],
            [1.5797905738203513, -5.045125437583858],
            [1.581173328034386, -5.039783748384439],
            [1.5799405647119444, -5.034448942271038],
            [1.5834549076699247, -5.030708435278901],
            [1.5882272163845612, -5.036522627065482],
            [1.5846008136151626, -5.042074039941583],
            [1.5827410732091374, -5.047096427032464],
            [1.5799249280404513, -5.048460842666089],
            [1.582856931778259, -5.058947747474089],
            [1.578141743876816, -5.062137006698776],
            [1.5693913127268957, -5.057530368034394],
            [1.5636193224333996, -5.060877060381174],
            [1.5618508144507015, -5.064403417674407],
            [1.563342771045462, -5.0684220819219385],
            [1.5684427742713796, -5.071639716415993],
            [1.5744912936705313, -5.07247579482931],
            [1.5892147670086552, -5.067840277180517],
            [1.5949337560058892, -5.058864674168031],
            [1.5970766604950712, -5.051177101660529],
            [1.6018581981301871, -5.049748607498043],
            [1.605802800347581, -5.050881577056612],
            [1.6094435221748917, -5.056419608424275],
            [1.6108504654011966, -5.06192069755709],
            [1.6142471360821466, -5.066484638600553],
            [1.6181545233382846, -5.0689459263884995],
            [1.6262821274475, -5.066448561991828],
            [1.6271354598927814, -5.058976966398233],
            [1.6286820668875857, -5.055957033998612],
            [1.6260001328743505, -5.048585566432051],
            [1.6281000308486755, -5.045558399719489],
            [1.630974078625789, -5.045919259787744],
            [1.6366800151440961, -5.052859370594541],
            [1.637223992712602, -5.065545979459875],
            [1.6388738991906548, -5.0660080322713394],
            [1.646110413389702, -5.063010152108485],
            [1.65180442885475, -5.062520190415769],
            [1.653350157607647, -5.064878871197671],
            [1.6510036014156615, -5.068834358839146],
            [1.6408739428606909, -5.072272201538994],
            [1.6315787649181281, -5.0816701151198105],
            [1.6284709209885835, -5.08634834106032],
            [1.6347431696991874, -5.08803129230061],
            [1.6392085796934095, -5.086195042325506],
            [1.6451176851460112, -5.079415656601041],
            [1.653613491784761, -5.074531131072114],
            [1.6622844050222199, -5.070678405243911],
            [1.6675704887644034, -5.075604550504792],
            [1.668247191108336, -5.079883450721808],
            [1.6659775990761638, -5.085118273710786],
            [1.6547977276243493, -5.089558970328441],
            [1.6471471406805571, -5.094457811019324],
            [1.6455535091551752, -5.101761428724044],
            [1.6508760464099579, -5.105375489757898],
            [1.6613166949086051, -5.102984427726394],
            [1.6697152115169192, -5.09479217550968],
            [1.680884666299391, -5.089789747948418],
            [1.6855674147198525, -5.090335371502962],
            [1.6880243825592114, -5.093873007313747],
            [1.6748765745430925, -5.106164389170798],
            [1.6748402057908336, -5.109371327311029],
            [1.6813777917365884, -5.115376385916251],
            [1.687574882778432, -5.113029245073753],
            [1.6889703797737818, -5.10809069297945],
            [1.6870545021364929, -5.101271180840348],
            [1.6894760636481556, -5.098300019112853],
            [1.6943775105293926, -5.107879113468309],
            [1.7001193286591927, -5.110220203054148],
            [1.7056996320929203, -5.1067907183545636],
            [1.7108885221497157, -5.105603262926602],
            [1.714124861013874, -5.101715539573024],
            [1.7110364747711062, -5.0944465035267275],
            [1.7153364813237575, -5.092739001057705],
            [1.7231381430772157, -5.091531244073183],
            [1.7317281073505368, -5.094087467273142],
            [1.7354285660189661, -5.086649568040318],
            [1.7408895286006565, -5.085270044972878],
            [1.7460346874483217, -5.0873306468390656],
            [1.7475368541590446, -5.089902784827524],
            [1.746324360763717, -5.095622274022462],
            [1.7345751628509471, -5.099411248531596],
            [1.7367062348221414, -5.105887125031163],
            [1.7429978628392735, -5.10759121850135],
            [1.7433793515872715, -5.111401415059478],
            [1.7414187386373994, -5.115106071453628],
            [1.729407084548146, -5.1231649734569435],
            [1.727212605125957, -5.126327149399691],
            [1.7306636619709908, -5.131050055335242],
            [1.7388314529509423, -5.132088223514802],
            [1.7424335071751038, -5.138096192996021],
            [1.7464945241067362, -5.139363509663212],
            [1.7527492798753235, -5.138651669618635],
            [1.754375201730225, -5.135964663259101],
            [1.7622647347602243, -5.13887488186274],
            [1.765698366751609, -5.143532214433017],
            [1.7765940977365662, -5.160462345019935],
            [1.7847279544488368, -5.161273606387208],
            [1.7896374917957956, -5.157997355965928],
            [1.7989045425872794, -5.147528829217761],
            [1.8013953493853656, -5.146102292095772],
            [1.8041192074437387, -5.148725495085531],
            [1.8057847606183375, -5.154714085834607],
            [1.8051785239400497, -5.15801467773476],
            [1.8019651362854638, -5.162354566045777],
            [1.7974266118380644, -5.163982183916482],
            [1.7894650994557866, -5.164726166558227],
            [1.786309014375964, -5.170321234989754],
            [1.790032789186424, -5.175868032009057],
            [1.7939311208019464, -5.178454590578029],
            [1.7965359232825546, -5.182788052062095],
            [1.8030771315396465, -5.185428773289782],
            [1.8182627140530387, -5.184244956391224],
            [1.8243775194029486, -5.185922276508394],
            [1.8300796171257496, -5.18062895228812],
            [1.831381878214098, -5.176756592564836],
            [1.8267975058572767, -5.168395817859903],
            [1.8269522721361502, -5.166827292398869],
            [1.8325872474233997, -5.161572756707943],
            [1.8384574881254827, -5.161702477939862],
            [1.841881547103198, -5.166202975173705],
            [1.844151122416056, -5.175379843510562],
            [1.8544420983257357, -5.179697109717489],
            [1.862591933643558, -5.176735490942125],
            [1.8651457924911647, -5.1727349966849685],
            [1.8644328871561102, -5.168553650867832],
            [1.8672621638768359, -5.159993882681118],
            [1.8714083607854202, -5.151957047923505],
            [1.8789630011164322, -5.145877164036528],
            [1.883555551602593, -5.146048489532664],
            [1.885901717442957, -5.150725187319202],
            [1.8848837968277403, -5.1549547967502125],
            [1.8781928347075885, -5.1601749731662725],
            [1.8771850665932228, -5.164630887779689],
            [1.8779187870526792, -5.169241135553215],
            [1.8807037753674498, -5.170890478264935],
            [1.8877242876931202, -5.170916649640601],
            [1.8915145247990242, -5.169217136438536],
            [1.8985240474793992, -5.154106156250524],
            [1.9048677522055364, -5.145043271083602],
            [1.9090558442344654, -5.141319074472151],
            [1.9145617735982867, -5.138238533188661],
            [1.9193117735176124, -5.137727714082736],
            [1.9225339016197724, -5.141223589657676],
            [1.9206351022916128, -5.1505582301191515],
            [1.91614642654507, -5.153824011068728],
            [1.9107227378046354, -5.162218691175754],
            [1.9097743969404881, -5.165671809688351],
            [1.9116342499097265, -5.170743630037739],
            [1.921881427516732, -5.174657794696015],
            [1.9314020970059507, -5.174243670206997],
            [1.9372753387096318, -5.170940356505535],
            [1.9417894647889538, -5.163795926552832],
            [1.9462893823460319, -5.159922654150998],
            [1.9500057322529105, -5.160218927420643],
            [1.9521217613657438, -5.168926477021422],
            [1.9561794332782165, -5.171561339264232],
            [1.9603188795374829, -5.168932029212794],
            [1.9614258821692434, -5.164108001740813],
            [1.9574759098493237, -5.152923343940505],
            [1.9518865964890169, -5.15084900444173],
            [1.9434699178642638, -5.153090833122663],
            [1.9394400383885377, -5.150539955767245],
            [1.9384836621774455, -5.1461989846507254],
            [1.9435917652120793, -5.143689685198134],
            [1.949739089627726, -5.145908629406112],
            [1.9555545780686352, -5.14489303853454],
            [1.9657455450069916, -5.131695008891224],
            [1.9720884807892871, -5.135190689485618],
            [1.9837590739081268, -5.137144779351379],
            [1.9841271468008916, -5.145192515919843],
            [1.988551358426551, -5.1502515754143605],
            [1.9919855919347533, -5.150010604128639],
            [1.9973076928063045, -5.143835994470886],
            [2.0008250885396626, -5.14616022752321],
            [1.9931988558500757, -5.15413027180844],
            [1.9931009530161323, -5.15754899130902],
            [1.995582836137128, -5.160218456877361],
            [1.9998201360992223, -5.160309671100483],
            [2.0051202703678133, -5.1546939152994335],
            [2.007269991536796, -5.156448608286895],
            [2.0085349328618127, -5.167715473195528],
            [2.0100126395195943, -5.172721311258131],
            [2.0137680346956928, -5.174941841780517],
            [2.0170443790400987, -5.172404736528349],
            [2.019230880958327, -5.158430857525312],
            [2.0250705074606676, -5.158323603528553],
            [2.0329998893468706, -5.15479668094703],
            [2.037676789876847, -5.151323802617758],
            [2.049881932248935, -5.149300808295203],
            [2.058195878090874, -5.152401750689949],
            [2.0615691924771413, -5.151000280886738],
            [2.0630814387887733, -5.155638551091289],
            [2.072008043697476, -5.1571194848142445],
            [2.072476751808829, -5.162492020277439],
            [2.0690671525308537, -5.165207793380499],
            [2.063377565327832, -5.163612871965711],
            [2.0575921740842364, -5.1664073321820165],
            [2.058996261346948, -5.170813930668637],
            [2.0675692418101046, -5.174753159953135],
            [2.0828087337429153, -5.172619597878362],
            [2.08437259427663, -5.231308979311551],
            [2.0841906778908488, -5.233327700724877],
            [2.0859832487978753, -5.304299696920689],
            [2.087057651568523, -5.365910792200888],
            [2.0889860794815487, -5.453601059841812],
            [2.0827880360629925, -5.448676231507612],
            [2.0838032768503933, -5.445060035194594],
            [2.0815854220920005, -5.44013458282143],
            [2.0819515703449962, -5.4369836406977505],
            [2.072952948088422, -5.425236272964042],
            [2.0700056755975518, -5.427338988049949],
            [2.0656530587533366, -5.42455216433149],
            [2.0636235703610044, -5.429402732941303],
            [2.059455604523453, -5.427605248333004],
            [2.056491795537379, -5.4314118496153],
            [2.053197449580213, -5.427722992317698],
            [2.0539966195518833, -5.4240060529262815],
            [2.0508305530949515, -5.42093294740741],
            [2.0469924787044134, -5.427265803265654],
            [2.042594362701664, -5.419652981633718],
            [2.040845941207686, -5.4221878450084215],
            [2.042968847563972, -5.425021499672214],
            [2.04079549465543, -5.4278635028461055],
            [2.0378562781038765, -5.422210199717122],
            [2.0381907878736283, -5.4199260490207],
            [2.033902053907981, -5.417762699763084],
            [2.030977951026692, -5.421061433033146],
            [2.027756182436415, -5.420850424060184],
            [2.029994488305985, -5.431412674825771],
            [2.026564426372304, -5.4291017085724205],
            [2.0271019486534843, -5.4255676638540455],
            [2.0213612398047203, -5.427438921773641],
            [2.0242088104331875, -5.433630811136665],
            [2.0159194567469547, -5.433650245573704],
            [2.008558001934683, -5.432626299612139],
            [2.0038053849006285, -5.4255146063893935],
            [2.0006604887309414, -5.424779753610522],
            [1.9950102782606587, -5.419265611857643],
            [1.9857776495010346, -5.415557100417218],
            [1.980521304239132, -5.425447447542941],
            [1.978833176261357, -5.422649962525039],
            [1.9709149545590956, -5.422036124403341],
            [1.968094940391762, -5.425622164664119],
            [1.9652977392465902, -5.424421218673675],
            [1.9643048687970863, -5.42951812872329],
            [1.9554180249752278, -5.429304991476272],
            [1.9467929169620677, -5.431514717000152],
            [1.9427486092193211, -5.4307112134357585],
            [1.9436563786266556, -5.435213940151018],
            [1.941389039442901, -5.442002056952051],
            [1.930836800615179, -5.4517181269996415],
            [1.9273000581705535, -5.451676252141211],
            [1.9314485088149855, -5.458007257906648],
            [1.9280639224789842, -5.466145187209333],
            [1.928207230038891, -5.473834836594705],
            [1.934316403095731, -5.479689089279767],
            [1.9303984981562878, -5.481330118149471],
            [1.934754456634833, -5.484891497926806],
            [1.9328197383175867, -5.487103147313748],
            [1.927801214494523, -5.487408406267587],
            [1.9254240427235707, -5.485102079960339],
            [1.9170656697947699, -5.484942986490104],
            [1.9129862856645856, -5.486060924522333],
            [1.9089483216169367, -5.489211346337112],
            [1.9061405942957326, -5.4836110490923895],
            [1.9028887863904342, -5.482641853891811],
            [1.89864735124917, -5.484990703820926],
            [1.892074288531953, -5.483061844064234],
            [1.8933898989157827, -5.478826838881607],
            [1.8862243851606106, -5.478374398068693],
            [1.8838507851299868, -5.479951330350309],
            [1.8804512349937526, -5.477628857343615],
            [1.8701302314580404, -5.478704530624881],
            [1.865979580275908, -5.480359517633809],
            [1.8601000904944933, -5.4786272020991555],
            [1.8534002733870216, -5.4743742070919925],
            [1.8473922244574092, -5.474215676616894],
            [1.8399320526682164, -5.4768630624362125],
            [1.8346711239680464, -5.474817454805063],
            [1.831535767288304, -5.468433276433868],
            [1.8251077778475207, -5.464910765798426],
            [1.8206188454389807, -5.467044313167128],
            [1.818758551670341, -5.469678931686717],
            [1.81015031062881, -5.4725025063732335],
            [1.8098963560373111, -5.474458138398577],
            [1.7967240842162369, -5.468600160804419],
            [1.7957568104752628, -5.465496455688138],
            [1.7924148659900603, -5.465056416940767],
            [1.7928396434789318, -5.461390096194506],
            [1.7886325143549457, -5.459236506525811],
            [1.7831577541352726, -5.459684606061184],
            [1.7838605668698078, -5.456723257053432],
            [1.7808543334805076, -5.4540350618270494],
            [1.781420601248367, -5.4506559980799025],
            [1.7792454274773783, -5.446542653638574],
            [1.7682814233361615, -5.445266509582518],
            [1.7637841005968793, -5.443297713167559],
            [1.761376387720182, -5.444795507707537],
            [1.7622138755674097, -5.4489873990258575],
            [1.7556371062945666, -5.449707244615255],
            [1.7491586892029554, -5.447561431351563],
            [1.74634853870082, -5.443968638059874],
            [1.74333594844072, -5.445520764476253],
            [1.740773615732614, -5.443818097420734],
            [1.7376799691386602, -5.437715742792303],
            [1.7353198528130735, -5.436939763487929],
            [1.730290028856554, -5.441464522728683],
            [1.725881507018332, -5.441482722870959],
            [1.7214850249623472, -5.443549176992695],
            [1.7184834020409494, -5.447479599785705],
            [1.7204194428383244, -5.4512265032616405],
            [1.71615131612682, -5.451801193326545],
            [1.7091292799005702, -5.448357767299107],
            [1.7035294017701403, -5.447740945130104],
            [1.7009605096500175, -5.45005122599415],
            [1.6944789612156335, -5.449829386482573],
            [1.6846733356768318, -5.46476010107693],
            [1.6806976503415754, -5.462502071507888],
            [1.6767811087140967, -5.462607187472205],
            [1.6770219045037067, -5.466528201255071],
            [1.667104496668458, -5.466702379222996],
            [1.6644934933912305, -5.463322394415151],
            [1.6603592036194381, -5.471440657746809],
            [1.652315577410419, -5.46828042148279],
            [1.6507148484998815, -5.471746957054296],
            [1.6517845121103072, -5.478044710779995],
            [1.649151324416841, -5.480608585062896],
            [1.6438229665124735, -5.481698230030513],
            [1.6447306244045015, -5.485040951809265],
            [1.638359945827625, -5.483126231699818],
            [1.6345468726166845, -5.473459530783348],
            [1.623258793520987, -5.4758321881466],
            [1.6224254418044448, -5.47915053789196],
            [1.611470280692151, -5.486420127771895],
            [1.6072757366587274, -5.48149100141982],
            [1.6031010717404943, -5.482767701132608],
            [1.5977996043689495, -5.4820840492282805],
            [1.5923505635311725, -5.4799109305669464],
            [1.5921699919724472, -5.4767666995415665],
            [1.5858474608122224, -5.474879124709748],
            [1.584862699528795, -5.4660066506975955],
            [1.583078753764459, -5.464745025274482],
            [1.580823932479527, -5.457293280902645],
            [1.5746457422157332, -5.456026080442566],
            [1.57664302382576, -5.453081567798422],
            [1.5733609237021076, -5.449913381797541],
            [1.566235888942173, -5.449001524158489],
            [1.560724602555241, -5.440239041538931],
            [1.5537081814727554, -5.440496199589317],
            [1.55085024995721, -5.433672824676045],
            [1.5501118901550412, -5.426153649493372],
            [1.5468821460818045, -5.426863394297937],
            [1.5439014614579403, -5.422566048217769],
            [1.53991656031495, -5.420989482601972],
            [1.5340492188964823, -5.422471201252848],
            [1.5284123203114044, -5.422595247488768],
            [1.526969117351474, -5.426310161407764],
            [1.5211372335610203, -5.427079782729604],
            [1.516238361052622, -5.4229503198803855],
            [1.5161244791532922, -5.4170541406419],
            [1.5116156536740684, -5.417766415337888],
            [1.5124615351083588, -5.413289801619697],
            [1.509446921194509, -5.4102524305210755],
            [1.5098173591617587, -5.407653436459544],
            [1.50366397889779, -5.405612439059745],
            [1.5024086949438955, -5.292358746378388],
            [1.5019982463964379, -5.277760550090799],
            [1.50158184163189, -5.207170102847179],
            [1.5011810285475533, -5.179660641552318],
            [1.4993856566103556, -5.030752184427442]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.42346382536209, "lat": 33.44583756390005 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48037"],
        "coty_name": ["Bowie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bowie County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01383804"
      },
      "bbox": [
        1.4993856566103556, -5.489211346337112, 2.0889860794815487,
        -5.017339669463752
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.267782140480462, -6.886271147016718],
            [-5.175180455195586, -6.892744032147407],
            [-5.082577850427828, -6.899203890875638],
            [-4.989974311639767, -6.905650724450197],
            [-4.8973698242714425, -6.91208453380076],
            [-4.887941721587578, -6.912657227207224],
            [-4.8950909298112695, -7.037037116350628],
            [-4.9007492647559605, -7.156781549986191],
            [-4.902277953560394, -7.18818637654573],
            [-4.909043704046822, -7.363715511477449],
            [-4.908271841020552, -7.434379316294556],
            [-4.911278524122137, -7.475118076285593],
            [-4.985820269080015, -7.469235564562918],
            [-4.988685824447637, -7.468005395254241],
            [-4.9949281962743415, -7.469518393621665],
            [-5.00054809261501, -7.467539303054543],
            [-5.000410427307848, -7.46052865879064],
            [-5.003072008011065, -7.460154044338019],
            [-5.003731686801983, -7.454580347517774],
            [-5.006590096048177, -7.449893125436437],
            [-5.008385270976732, -7.441673510806656],
            [-5.010408651974976, -7.436630042682245],
            [-5.014581012377547, -7.435095655716246],
            [-5.016829911906922, -7.428604804354745],
            [-5.015964712212083, -7.422335878272663],
            [-5.013898310238419, -7.420400499603222],
            [-5.016490761648618, -7.410898487456045],
            [-5.011409831776572, -7.405052819164961],
            [-5.0127753455987, -7.402576703795906],
            [-5.010667028646573, -7.39910514233899],
            [-5.011956141152092, -7.388375437579019],
            [-5.013493828240339, -7.386673455446663],
            [-5.013904194243013, -7.380118285900679],
            [-5.010941231134042, -7.375200816534721],
            [-5.0139158831108785, -7.371532111014629],
            [-5.012654379633251, -7.368802212137306],
            [-5.013425246397229, -7.36364965460468],
            [-5.01862602468508, -7.357144825570324],
            [-5.020464309945705, -7.346373084430926],
            [-5.026444017137787, -7.339355905474233],
            [-5.029482994496223, -7.340483797105007],
            [-5.031631983522296, -7.337451027007348],
            [-5.031399784303592, -7.333677985643921],
            [-5.034876002266975, -7.330883705482964],
            [-5.042502731894066, -7.333442159317176],
            [-5.044561897648009, -7.329385485879205],
            [-5.041648750891132, -7.326805098916245],
            [-5.050785914158267, -7.323161384218202],
            [-5.055140944010817, -7.31622721315778],
            [-5.0623502188013, -7.31094267694688],
            [-5.064780085754954, -7.311107018557854],
            [-5.066390548363638, -7.30650111834018],
            [-5.07092419997643, -7.300418400622136],
            [-5.074760017939471, -7.296862105607723],
            [-5.074821361480211, -7.294216897577577],
            [-5.078185552152171, -7.291119447289167],
            [-5.088084118916917, -7.287254237003407],
            [-5.096800923781823, -7.288626065758176],
            [-5.099076143131396, -7.283864800235882],
            [-5.11335287808046, -7.279791830302443],
            [-5.1196432231259035, -7.280231796300593],
            [-5.121094561538471, -7.27870034153892],
            [-5.128244972507742, -7.277236601936097],
            [-5.131489098968461, -7.274375337398663],
            [-5.1383447864364475, -7.28155847506053],
            [-5.141657293666678, -7.2829948936576105],
            [-5.150082925629806, -7.281716871057413],
            [-5.151986243987048, -7.276981441969486],
            [-5.1563773993242865, -7.274197669536796],
            [-5.156320029088848, -7.268865837068581],
            [-5.160747474869332, -7.261562525945415],
            [-5.166125549833772, -7.258821549947218],
            [-5.165513892097886, -7.255305097513597],
            [-5.170249638026363, -7.254555247676398],
            [-5.171442578756965, -7.251966702200694],
            [-5.1760832869325615, -7.2529366324003615],
            [-5.1785000503418495, -7.249900852980829],
            [-5.18162030525708, -7.249667488076294],
            [-5.1812071276351, -7.245513448956412],
            [-5.182809078582987, -7.23865053802118],
            [-5.1850139296751765, -7.233697779846267],
            [-5.18922343817442, -7.229513845158596],
            [-5.194749426520589, -7.22993414761116],
            [-5.201470432238949, -7.227909343347987],
            [-5.2043572475744835, -7.225113138802622],
            [-5.204048629420754, -7.220741841348466],
            [-5.206652424825792, -7.215087464939307],
            [-5.211091306595908, -7.213494228817662],
            [-5.224654106395374, -7.218554853315472],
            [-5.230946625989827, -7.221441453166558],
            [-5.235914543853431, -7.2252528405454015],
            [-5.242081702824733, -7.228270114333893],
            [-5.256321440447821, -7.229977114977923],
            [-5.257610882998113, -7.233678380175184],
            [-5.263326793358932, -7.242261303663971],
            [-5.264034022968758, -7.245692882185371],
            [-5.262123893865013, -7.250244805224278],
            [-5.272728212182784, -7.254013253740858],
            [-5.279126532806629, -7.2549622864311205],
            [-5.282499758952068, -7.257344094113771],
            [-5.285304369236401, -7.253050961875732],
            [-5.283709853666051, -7.245179868755257],
            [-5.291059469892922, -7.241708982208623],
            [-5.293445298491992, -7.241946446317892],
            [-5.288771467725416, -7.174597060840826],
            [-5.28363662300971, -7.103874700094171],
            [-5.277614789757138, -7.021508327676307],
            [-5.269880420358459, -6.913336094209188],
            [-5.26909567574538, -6.8993374887342],
            [-5.267782140480462, -6.886271147016718]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.51560092013635,
          "lat": 31.42862908339057
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48103"],
        "coty_name": ["Crane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crane County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01383837"
      },
      "bbox": [
        -5.293445298491992, -7.475118076285593, -4.887941721587578,
        -6.886271147016718
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.586604815460678, -8.3447233909276],
            [-3.539261170725254, -8.347133467946971],
            [-3.42536675547887, -8.351841867458255],
            [-3.3114714389092708, -8.356525031197426],
            [-3.1975751950400477, -8.3611829641918],
            [-3.0836779978646676, -8.365815670774662],
            [-2.9487302550433254, -8.371609595236727],
            [-2.928881602210685, -8.3721738883674],
            [-2.8760152871242357, -8.374525948827836],
            [-2.771598852045942, -8.378208268211724],
            [-2.7831678637654096, -8.592431000369345],
            [-2.921717690463755, -8.587386606734336],
            [-2.921040675777325, -8.582499543222516],
            [-2.9641839863975554, -8.577004130557647],
            [-2.9712808823686276, -8.633943462146634],
            [-2.9855984168021137, -8.632204950885926],
            [-2.999290925437526, -8.736672603172678],
            [-2.999471557882701, -8.74091189132342],
            [-3.0019440625344687, -8.759202204985899],
            [-3.007741190594719, -8.758670498459148],
            [-3.008996207062215, -8.76191009861573],
            [-3.0147205905323573, -8.764293691404669],
            [-3.0183162366913487, -8.7701271044896],
            [-3.0209836419390736, -8.772318251914733],
            [-3.0215590921778137, -8.780564543389477],
            [-3.0180284020739645, -8.785497737602164],
            [-3.0180822509299916, -8.789631437443953],
            [-3.0206413583784446, -8.792742608832047],
            [-3.0209438900519876, -8.800734221175697],
            [-3.022766722893401, -8.805478555657388],
            [-3.0287359234000326, -8.806149994726784],
            [-3.0323323900805397, -8.810164353478449],
            [-3.029496391832395, -8.813313201006585],
            [-3.029715435404214, -8.81728204730784],
            [-3.0272075512643983, -8.818906522801067],
            [-3.0249276770297993, -8.825323711099005],
            [-3.026620219871237, -8.829907588511364],
            [-3.022932693583858, -8.839187127534442],
            [-3.0198587617147816, -8.839143495874445],
            [-3.0183154403666848, -8.842480871860666],
            [-3.017827080830769, -8.853966282679677],
            [-3.0157836847981474, -8.86007134804073],
            [-3.0202686087200643, -8.86245888416271],
            [-3.0293366979134206, -8.864406830352717],
            [-3.029351672580122, -8.8686791143973],
            [-3.0321773017826104, -8.87249507122589],
            [-3.036189126245567, -8.874492811781453],
            [-3.035598276392893, -8.879853046754597],
            [-3.032626576342477, -8.882508831835453],
            [-3.030330158928467, -8.894994003778214],
            [-3.028179924670635, -8.895519412996956],
            [-3.0268888578729953, -8.900244441179069],
            [-3.0274879022034713, -8.905059419649824],
            [-3.0257005253334066, -8.909558625244127],
            [-3.0308324908246713, -8.911936842775761],
            [-3.0323736507608574, -8.916635869795138],
            [-3.031141288180355, -8.921943667297436],
            [-3.0286101740276488, -8.923428723700649],
            [-3.030131576818271, -8.92987339831329],
            [-3.0337308474512694, -8.931832663523739],
            [-3.0399469831456085, -8.931464042662757],
            [-3.0417332886200867, -8.933805728807846],
            [-3.0630589575980607, -8.940481604402216],
            [-3.0558306346729975, -8.942980828608327],
            [-3.0530199480916185, -8.942304996646318],
            [-3.0480985624387213, -8.945636098509997],
            [-3.0494059958182818, -8.949656452686863],
            [-3.0481770932171592, -8.957070352391408],
            [-3.043910974328293, -8.959215109392662],
            [-3.0424985755939495, -8.962261539287548],
            [-3.0351000392892726, -8.963890423472424],
            [-3.033346565644515, -8.969306855701552],
            [-3.024003891022567, -8.97662487971407],
            [-3.027954144072314, -8.982877421135212],
            [-3.033883304510001, -8.984785269325672],
            [-3.036083931157294, -8.988899164517242],
            [-3.032811972221681, -8.99509054508916],
            [-3.0286762204356816, -8.999622734059292],
            [-3.022537151161535, -9.011364971900756],
            [-3.018211259306951, -9.01555115238259],
            [-3.017496044480778, -9.02030747317106],
            [-3.0237777133473918, -9.028731943382892],
            [-3.1087992937975173, -9.025369471449403],
            [-3.2267714514436143, -9.02015490288866],
            [-3.228819319335026, -9.019887408341324],
            [-3.336261443235155, -9.014999371066557],
            [-3.3373334198302356, -9.014723142660648],
            [-3.4242435917147875, -9.010851012978055],
            [-3.5111530522035843, -9.006962602861007],
            [-3.6190804958268106, -9.001362274467624],
            [-3.619116761284278, -9.000036997207276],
            [-3.6119089890372447, -8.861559319838566],
            [-3.608165257955697, -8.78375638318957],
            [-3.586604815460678, -8.3447233909276]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.30475077195632,
          "lat": 29.982709366943023
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48137"],
        "coty_name": ["Edwards"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edwards County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01383854"
      },
      "bbox": [
        -3.619116761284278, -9.028731943382892, -2.771598852045942,
        -8.3447233909276
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.31399142425070525, -4.786354073949798],
            [-0.3058553134910134, -4.7812716106991395],
            [-0.2953681541721596, -4.776132268693774],
            [-0.29059936621051136, -4.77796647741938],
            [-0.2865499806447767, -4.781858862599636],
            [-0.28160677147509927, -4.788674217155201],
            [-0.27695101185026816, -4.802263492516804],
            [-0.27469676557541006, -4.8227758394732225],
            [-0.2753925057894359, -4.83317407209816],
            [-0.2742469053901539, -4.839750423802049],
            [-0.2640346596246908, -4.86835039578225],
            [-0.2577343276849468, -4.875951141991662],
            [-0.25051299970950847, -4.883400994008804],
            [-0.24203414845685053, -4.889157927850534],
            [-0.23750497096093734, -4.889478497361806],
            [-0.2336169617889794, -4.8877424209167355],
            [-0.23003387707597037, -4.883840311208085],
            [-0.22840054443855756, -4.868293754723129],
            [-0.22206272301620933, -4.861885629805246],
            [-0.20611122434836612, -4.864220570233034],
            [-0.19089480840903741, -4.868123139095374],
            [-0.1820456152293456, -4.873568729413616],
            [-0.17887982643075312, -4.879210912879708],
            [-0.17699361418434545, -4.889040227210426],
            [-0.17668510877276983, -4.8952519690304355],
            [-0.17071224571928517, -4.909853414639236],
            [-0.16431330404762728, -4.912987135539189],
            [-0.151479838129469, -4.911790765604972],
            [-0.12371414310567114, -4.9060470265096106],
            [-0.11712112873096929, -4.902695395980822],
            [-0.1130650489889052, -4.898682234680934],
            [-0.10567520977117725, -4.887785217433719],
            [-0.10065063988302889, -4.874826543784765],
            [-0.09849586588392986, -4.863829199985979],
            [-0.09945522946674518, -4.853441657171955],
            [-0.0972946595289443, -4.841423767462305],
            [-0.09100238989240324, -4.825331711840507],
            [-0.08581128574549743, -4.820687876216924],
            [-0.07980781835422535, -4.821004719538736],
            [-0.06682894875391228, -4.831839386681672],
            [-0.05392582028556337, -4.843455108528097],
            [-0.03684282360429431, -4.843306779903455],
            [-0.024796667983944063, -4.842498175929478],
            [-0.021152125649306373, -4.843258535206604],
            [-0.018586279194806543, -4.849230302178088],
            [-0.022553603601530633, -4.857520699523124],
            [-0.028551726200846856, -4.863068654812365],
            [-0.04064144623520854, -4.869100212911209],
            [-0.051792066912856934, -4.881549146472883],
            [-0.05476243139795073, -4.885680192887098],
            [-0.05507319961029933, -4.892623106791096],
            [-0.05004177197416214, -4.896676107055918],
            [-0.032033876956813846, -4.903974312475721],
            [-0.02037199416922077, -4.910388342348806],
            [-0.00877425154723377, -4.919402660222952],
            [-0.003302504062409934, -4.9200244861210205],
            [0.009133759741896036, -4.919477064150483],
            [0.024295754565487063, -4.915672985454638],
            [0.029405178318786102, -4.917823125625833],
            [0.03491433953196383, -4.927432251301017],
            [0.0376136608669234, -4.935655631833757],
            [0.03808392464540299, -4.951086541946293],
            [0.041348192417910365, -4.9574436915259446],
            [0.050910320248223076, -4.96642100487278],
            [0.06263710170349315, -4.966053114058279],
            [0.07335058148090307, -4.963663345821064],
            [0.08485091384197813, -4.963933290818713],
            [0.09404541428038503, -4.958157416027976],
            [0.10874733781719552, -4.9606105390988064],
            [0.11498283131106776, -4.963260680188716],
            [0.12030015303775558, -4.9732611509795595],
            [0.12252303682914378, -4.981685204424355],
            [0.13064617665192266, -4.993184715980862],
            [0.1504607139623175, -5.013809002511217],
            [0.14809587793496892, -5.12130698423155],
            [0.14753339920153513, -5.141628162140821],
            [0.1467104229142245, -5.2402003223977465],
            [0.14563626652747658, -5.287790504141087],
            [0.1448320714169376, -5.342743581429484],
            [0.1364005183862347, -5.34220892313881],
            [0.11158030147843603, -5.342192609003224],
            [0.0942497757648145, -5.341555221023375],
            [0.005376784226523046, -5.340246352044076],
            [-0.0193979447354277, -5.339477452833335],
            [-0.042142512974034124, -5.339102767645381],
            [-0.0783765051993233, -5.338071903607002],
            [-0.1742656757332063, -5.334813626371796],
            [-0.22782052009484155, -5.332673506673921],
            [-0.23367383192627172, -5.332530911150576],
            [-0.23354391660277835, -5.324724203184547],
            [-0.25605848805134057, -5.323973204382912],
            [-0.2624180852380288, -5.324321139139458],
            [-0.2983954323668992, -5.32253910746616],
            [-0.31870231823606876, -5.320887177069872],
            [-0.3176975479131248, -5.253281514230631],
            [-0.31638124762897085, -5.130768317999371],
            [-0.3157979577383236, -5.016376223777595],
            [-0.3155812416763886, -4.938126197953607],
            [-0.31399142425070525, -4.786354073949798]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.67771793710874,
          "lat": 33.626733967071246
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48181"],
        "coty_name": ["Grayson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grayson County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "01383876"
      },
      "bbox": [
        -0.31870231823606876, -5.342743581429484, 0.1504607139623175,
        -4.776132268693774
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.665806797424163, -4.316130474654799],
            [-3.58775738749559, -4.319906470854069],
            [-3.4434596282863863, -4.326766268546912],
            [-3.325224512255342, -4.332455346647469],
            [-3.3240675957912247, -4.331714599876868],
            [-3.236736172265214, -4.335995181717023],
            [-3.2400367626453854, -4.400262103108187],
            [-3.244582754738474, -4.482863732339915],
            [-3.249546138761572, -4.590277611709233],
            [-3.249426568587804, -4.59075588505691],
            [-3.252203765783193, -4.647271212249216],
            [-3.260754611070187, -4.815973073136383],
            [-3.4288882729610743, -4.808351766845715],
            [-3.5970210797725746, -4.800707813704551],
            [-3.6218133949101285, -4.799670338317255],
            [-3.691119019421722, -4.796422454402304],
            [-3.6847471767975373, -4.671690532005356],
            [-3.6847119511668427, -4.666789117948609],
            [-3.683025026444398, -4.639872062635777],
            [-3.6783105052090668, -4.550959043513675],
            [-3.6728888998099234, -4.451290252418974],
            [-3.6688210792994833, -4.372477996197517],
            [-3.665806797424163, -4.316130474654799]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.77979959568472,
          "lat": 34.07407115239286
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48345"],
        "coty_name": ["Motley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Motley County"],
        "coty_fp_code": "345",
        "coty_gnis_code": "01383958"
      },
      "bbox": [
        -3.691119019421722, -4.815973073136383, -3.236736172265214,
        -4.316130474654799
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7427461992812746, -5.781083908661577],
            [0.7761247441318854, -5.780740746838598],
            [0.8634764415622033, -5.779642454402253],
            [0.9414294779248151, -5.778679477956038],
            [1.0399276458933848, -5.777348053716725],
            [1.153335861807365, -5.777190802375849],
            [1.1508957388602505, -5.773711705622711],
            [1.1542418733266433, -5.766486036243421],
            [1.1598109288510785, -5.763625096948745],
            [1.1618501844211118, -5.758733193798411],
            [1.1627411879638008, -5.749314480198793],
            [1.161621745322561, -5.746209301954733],
            [1.1641268037862076, -5.744184716481878],
            [1.1670321357365814, -5.738088181760592],
            [1.170318721667574, -5.736084475314571],
            [1.1701658722860375, -5.725356479822202],
            [1.1715765289294489, -5.727384704412011],
            [1.1718664225785764, -5.738688169709311],
            [1.1703388027162924, -5.748550521944204],
            [1.1709302670405313, -5.816196827395669],
            [1.1712405715570577, -5.8362869219489015],
            [1.1714329528357847, -5.873750662836282],
            [1.1719127518928378, -5.925674113460061],
            [1.172453301505987, -6.010379652255526],
            [1.1731773817023368, -6.131945885543438],
            [1.1731353540376077, -6.1689515173034515],
            [1.1683386758878598, -6.174692326816485],
            [1.1657735236878437, -6.1851985894738055],
            [1.168104189194697, -6.1886566358346995],
            [1.163395742013487, -6.194789913327906],
            [1.1578977028401038, -6.190498439257979],
            [1.1548036242727802, -6.183748168396727],
            [1.1524889888678942, -6.189277309308841],
            [1.1494162249744753, -6.19238417542896],
            [1.150060407394298, -6.197462785907427],
            [1.1481338207576106, -6.198312111053622],
            [1.142618566663877, -6.196440370605169],
            [1.1434073547964518, -6.192725320384444],
            [1.1333343381643637, -6.185592240050491],
            [1.1285626537261422, -6.179495787553465],
            [1.1322999347616542, -6.175552136806195],
            [1.130488559800355, -6.167648986939347],
            [1.1270033009892553, -6.170831645436209],
            [1.1222740864547922, -6.170382708497289],
            [1.1215166895518063, -6.173830595095752],
            [1.1184506602144333, -6.1763024475027395],
            [1.1141224719229317, -6.176245713001745],
            [1.110479959802197, -6.179386834634696],
            [1.1020671475612942, -6.1789593675215055],
            [1.0953787846856282, -6.170285326961205],
            [1.0914014767639029, -6.161802271580108],
            [1.0885483216575862, -6.164336402976247],
            [1.08049401234179, -6.164635808368892],
            [1.0789681603286951, -6.167333325633966],
            [1.0717826726044901, -6.166020307289582],
            [1.0684839660212626, -6.168139101127968],
            [1.065935367536656, -6.159939921879269],
            [1.0583417272476778, -6.159160707603799],
            [1.058831473648084, -6.154871294843587],
            [1.0527853496713122, -6.153126069643734],
            [1.0522031710788262, -6.148630495256295],
            [1.0490217008192564, -6.1496927831471675],
            [1.0452082215751137, -6.147870611749744],
            [1.0442883148027564, -6.1435213542081115],
            [1.0391076052325394, -6.146694703483283],
            [1.0375547596410943, -6.143847888058443],
            [1.034187751348486, -6.144620936832112],
            [1.0312231187871954, -6.140767027553302],
            [1.0277736911393076, -6.140543400463522],
            [1.023111008121941, -6.136004075514028],
            [1.0171129941052317, -6.137102769413356],
            [1.013050965467401, -6.13656473438953],
            [1.0078339646256809, -6.132864288966639],
            [1.0052316400684749, -6.135072977122076],
            [0.9982815767372117, -6.133761655471722],
            [0.9963524994278268, -6.137105561902937],
            [0.9910169613460672, -6.135739861238481],
            [0.9873851833067784, -6.137778716478456],
            [0.9879528390559007, -6.140649007019544],
            [0.9814650850225153, -6.142044211000863],
            [0.9768038245640106, -6.140036224572556],
            [0.9689934067837365, -6.138566890723426],
            [0.9617232572271974, -6.1357194181650225],
            [0.9573087987908873, -6.136075756958734],
            [0.9557230466809993, -6.133893486956649],
            [0.9504408113913194, -6.135456793906762],
            [0.9497539330470448, -6.1316298972900505],
            [0.9416771887385713, -6.134236570769997],
            [0.936730207631182, -6.134061946059109],
            [0.9344793616178209, -6.130638139707967],
            [0.9297072332004491, -6.128254984097401],
            [0.9264863564245697, -6.134739817357782],
            [0.9185035223155291, -6.133465539707381],
            [0.9151984116974065, -6.131255201090698],
            [0.9111076570644447, -6.132412188646251],
            [0.9084145555568457, -6.135333233437669],
            [0.9025529605040373, -6.132893541883354],
            [0.9031814706672198, -6.1299370290962925],
            [0.8970597136708582, -6.129438383112675],
            [0.890348639398008, -6.12664933432157],
            [0.8899589441912225, -6.123491275546554],
            [0.8805422583194822, -6.120902723916451],
            [0.8732846808551091, -6.120834178923812],
            [0.8688711564665424, -6.116370355952272],
            [0.8717973392821947, -6.1130282382457235],
            [0.8702411229011834, -6.107405644998025],
            [0.8679315062712553, -6.106023199938917],
            [0.862003638926961, -6.097551911540217],
            [0.8545434795849939, -6.095182365788835],
            [0.8473916732612822, -6.094504875242086],
            [0.8469184585671625, -6.086335871879567],
            [0.8372344735649621, -6.080671649617669],
            [0.8315295570047045, -6.079076772981337],
            [0.8310496061245451, -6.076296430124145],
            [0.8244664189274584, -6.068845789822022],
            [0.8190710738770223, -6.065497160509997],
            [0.8131617476671532, -6.067496654800195],
            [0.8115787218934969, -6.059578630830684],
            [0.8055038158256844, -6.059025673118641],
            [0.8029939635961544, -6.054454145894215],
            [0.8024625146302924, -6.05110346704297],
            [0.7972968577565855, -6.044574255901349],
            [0.7950180856137093, -6.045216921761827],
            [0.7937936563427896, -6.039098071901771],
            [0.7829257161501394, -6.0338774573323075],
            [0.7763526861375506, -6.032879081181626],
            [0.775887284332342, -6.027504012412086],
            [0.7733764747238443, -6.024559700376543],
            [0.7693454713928396, -6.0246832530316485],
            [0.768998395529702, -6.0212262841873905],
            [0.7661125504602707, -5.995992616958628],
            [0.7618967783981222, -5.955862271164714],
            [0.7518464354981985, -5.8639500513777385],
            [0.7427461992812746, -5.781083908661577]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.38208339920376,
          "lat": 32.786272289509846
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48499"],
        "coty_name": ["Wood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wood County"],
        "coty_fp_code": "499",
        "coty_gnis_code": "01384035"
      },
      "bbox": [
        0.7427461992812746, -6.198312111053622, 1.1731773817023368,
        -5.725356479822202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.537159939211268, 0.4303527580603783],
            [15.539023875232663, 0.42882485981665436],
            [15.549675620247973, 0.4242727699589907],
            [15.552821262188376, 0.42087136662503993],
            [15.559391525020803, 0.42289202932245934],
            [15.565793424313947, 0.4189370720672925],
            [15.567984888812278, 0.42348696987095774],
            [15.572322143048202, 0.4243325051754808],
            [15.571122283810418, 0.4175777034936066],
            [15.573473666661233, 0.41591513800015006],
            [15.578161423275153, 0.41829151464424],
            [15.5806120334983, 0.4238401164096677],
            [15.585049986085249, 0.4246876599192537],
            [15.590734206747602, 0.4210541441595636],
            [15.59202828160061, 0.41759226590837284],
            [15.597114385196093, 0.4173217676442042],
            [15.599002716211947, 0.41478432709062046],
            [15.603986493624625, 0.4138763575500267],
            [15.604006516295682, 0.40971531409779477],
            [15.607288369700687, 0.4033768927876822],
            [15.610251840636613, 0.4024350729081709],
            [15.616584719869943, 0.40434748076753224],
            [15.620955411619706, 0.40282239051237273],
            [15.62070572601628, 0.39955091919468144],
            [15.624350583982094, 0.3990912736060019],
            [15.625188958497628, 0.4053241187677604],
            [15.623072046120512, 0.4101856695812808],
            [15.625946333559659, 0.41233947154173384],
            [15.630466405153038, 0.40955064855133416],
            [15.631639920766824, 0.40485635183778396],
            [15.638318370804765, 0.40536766265747515],
            [15.644583103259821, 0.40221790616546144],
            [15.646263676759068, 0.39866861412008586],
            [15.649903301292964, 0.39713025704888066],
            [15.657504843760478, 0.399151057288484],
            [15.661393738482307, 0.39868715826835716],
            [15.665387597442075, 0.3953759152069711],
            [15.669229342089988, 0.38972176299815237],
            [15.68373831568913, 0.39169557395273136],
            [15.691438127547377, 0.38759992353334843],
            [15.70018095826841, 0.38603290451387295],
            [15.70607748718206, 0.38057945425103185],
            [15.71656809006338, 0.37754354600370416],
            [15.721811973477429, 0.3770898203594947],
            [15.724190784455844, 0.37248029358244794],
            [15.720462843341862, 0.3535066759586802],
            [15.717806162421166, 0.3498938223565601],
            [15.716979406837176, 0.34538068757771057],
            [15.719810068433569, 0.3424290207575881],
            [15.720057695458705, 0.3392685190480493],
            [15.72293874246095, 0.3346532467773105],
            [15.723748239642557, 0.3285886359860619],
            [15.726306861138221, 0.32232271488675057],
            [15.728039502066858, 0.321977709358333],
            [15.730999802616699, 0.3147280365506154],
            [15.726813559801577, 0.3115860519576355],
            [15.730083709646406, 0.3075770645198344],
            [15.729508108184374, 0.3046584015067883],
            [15.732184128275627, 0.30162713556582793],
            [15.729849835205236, 0.29850959949672334],
            [15.730134374041286, 0.28973500217277964],
            [15.733278554550393, 0.28221313747296767],
            [15.736063060609697, 0.28122113770972423],
            [15.760338134730377, 0.2811866333927736],
            [15.76001713255775, 0.27669456461138187],
            [15.762218031795783, 0.2697601140115255],
            [15.760377871931505, 0.2649056144791592],
            [15.762993353366822, 0.2615404559454184],
            [15.767028838203826, 0.24772602437719635],
            [15.76623236894865, 0.24536328195095158],
            [15.772066032096294, 0.24360973409426512],
            [15.773221308201226, 0.23754610505005885],
            [15.76968624381237, 0.23647489090102392],
            [15.761261311209315, 0.242274704627165],
            [15.756048495408034, 0.24723174871011866],
            [15.749620099526854, 0.24403869939895959],
            [15.738896856205997, 0.24335829361671543],
            [15.737839378627204, 0.2488852708308243],
            [15.734545771875672, 0.24956184111696397],
            [15.729942113007834, 0.24782190174732086],
            [15.726738362856736, 0.23936211241909114],
            [15.728008985222399, 0.23280788028386565],
            [15.726814100303974, 0.2298315973739475],
            [15.729351704120576, 0.22636667187845486],
            [15.73608845733294, 0.2233864159754249],
            [15.739203763704708, 0.22082095489263673],
            [15.74466052572321, 0.22351792256655034],
            [15.747245997017528, 0.22990413622318295],
            [15.756798798637869, 0.21951578305741215],
            [15.764959148994018, 0.2172053442911672],
            [15.764567674536929, 0.21499853181524728],
            [15.769953576717137, 0.21074314489659188],
            [15.776236499785737, 0.20916064294453493],
            [15.784187534161843, 0.20887759145417956],
            [15.785488804423526, 0.2065098533262947],
            [15.78328364718127, 0.20276812348521747],
            [15.778505155517884, 0.20242199082750634],
            [15.776360658098607, 0.19758738482953528],
            [15.780404116335125, 0.19151062918088133],
            [15.77771849194961, 0.18880457801537434],
            [15.7742174539242, 0.18817091973021213],
            [15.770556569444503, 0.1901355628580933],
            [15.761026826061197, 0.18678058789352772],
            [15.762428917021133, 0.1786889816270764],
            [15.778632954001305, 0.1757357500253339],
            [15.784516865886705, 0.17686866655437505],
            [15.785245195197504, 0.1788736897217026],
            [15.790338884372206, 0.18149867649192888],
            [15.792762876557575, 0.18454041624396364],
            [15.796433050335187, 0.18482138582453225],
            [15.802057400934325, 0.18147576996771664],
            [15.800588497959012, 0.17730481799207806],
            [15.796817001306302, 0.17475976070318958],
            [15.800576503486093, 0.17096289352526384],
            [15.810329382146126, 0.16698376966954545],
            [15.811000251666984, 0.16046591814469827],
            [15.814417774058672, 0.1605955810389086],
            [15.81730712526071, 0.1559330311862192],
            [15.823460289766452, 0.15488120974043496],
            [15.8247376405947, 0.1564467399923896],
            [15.836086652381015, 0.157507384100391],
            [15.83578975209341, 0.1512516971855003],
            [15.830519083117494, 0.14631080133680088],
            [15.817763357508133, 0.14324829423724547],
            [15.810216193805713, 0.13678951567428882],
            [15.805379254587548, 0.13765484855063082],
            [15.800016530505484, 0.13567259540845178],
            [15.788980931784701, 0.13400688249441645],
            [15.784707234812165, 0.13018724162969686],
            [15.784623888648444, 0.1264624022290357],
            [15.786679820530644, 0.12300091326094462],
            [15.78218322325615, 0.12041001534144163],
            [15.777731928224963, 0.12326612805644001],
            [15.773813519065197, 0.12006929166712932],
            [15.76956439148672, 0.11910397912866509],
            [15.759823185105546, 0.11463118961035448],
            [15.755549457067671, 0.11134598357735592],
            [15.75195916484043, 0.11180022824762002],
            [15.745749124722268, 0.1095747044916923],
            [15.740432227701126, 0.11327048724205624],
            [15.733461871008261, 0.10628965667046288],
            [15.729375307173347, 0.10459952314861147],
            [15.724682370878737, 0.0981886932399876],
            [15.716047360135514, 0.10192611848992479],
            [15.711590300959543, 0.10700606538070262],
            [15.705264115097926, 0.11183593596715315],
            [15.695745324462775, 0.12077491384441318],
            [15.688252200633576, 0.12479725202792008],
            [15.680673131889199, 0.12781128767421232],
            [15.674025080849093, 0.1290720641450572],
            [15.666155853177179, 0.1331821440048206],
            [15.659349185017469, 0.1398065138955912],
            [15.65086235137744, 0.1440115177254484],
            [15.638620274262419, 0.15190381856525845],
            [15.627571086343643, 0.16198191047339333],
            [15.621402782776238, 0.16926964063663633],
            [15.613485801495473, 0.17508458879183011],
            [15.608494141838225, 0.18093756222182086],
            [15.600647847441229, 0.1881878667407753],
            [15.587394160522862, 0.20471851072039682],
            [15.579161235493405, 0.20905810880168937],
            [15.575657000638678, 0.211699365531519],
            [15.56537654218317, 0.22244310086568372],
            [15.540220657298025, 0.24120636794257833],
            [15.52739423093878, 0.25114685813347365],
            [15.530826871912643, 0.257900796163484],
            [15.531591537254053, 0.2657449813152876],
            [15.529830369394166, 0.26889180273629043],
            [15.533581869240322, 0.2726941498146081],
            [15.540309089443522, 0.27058257991799745],
            [15.543502911251093, 0.2715498666233175],
            [15.54370800526487, 0.27726259618950033],
            [15.55078157953306, 0.28690787148207514],
            [15.553822792557375, 0.28594204909028875],
            [15.557021537954105, 0.2822167772927606],
            [15.560877861801156, 0.28625389556080455],
            [15.55949751785186, 0.2887271636243091],
            [15.565870211847331, 0.30218098190967135],
            [15.565392994160737, 0.30918038337548187],
            [15.567671944457377, 0.3108397429190926],
            [15.56749815911934, 0.3161500337017792],
            [15.565100136090086, 0.3163663379274721],
            [15.563727723659458, 0.32522041750057096],
            [15.561401299735458, 0.3258608986784309],
            [15.554369185870264, 0.33490881032617226],
            [15.54381596214239, 0.34607643271485533],
            [15.540629061260018, 0.3552408050460582],
            [15.541112205244405, 0.36592098166858633],
            [15.540699932684289, 0.38446902742521166],
            [15.538515596537724, 0.39308233818804805],
            [15.537936857562814, 0.4000472945404016],
            [15.537159939211268, 0.4303527580603783]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.54341992724108, "lat": 37.41593266195961 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51073"],
        "coty_name": ["Gloucester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gloucester County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01480126"
      },
      "bbox": [
        15.52739423093878, 0.0981886932399876, 15.836086652381015,
        0.4303527580603783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.515707465848418, 0.6293799458935644],
            [15.514518448974739, 0.6340027286809005],
            [15.516904598290507, 0.6361415433831433],
            [15.5223073026873, 0.6355107268304114],
            [15.526578317495579, 0.6394131540672193],
            [15.530724749566529, 0.6380199269612016],
            [15.532225190574104, 0.6415527349913309],
            [15.536621446130239, 0.6428090385309428],
            [15.53762534200969, 0.6474725367776607],
            [15.541595514355395, 0.6500516751138706],
            [15.546999913437281, 0.6475308726918674],
            [15.54850187461034, 0.6564340184052908],
            [15.546786873959633, 0.6611522313323245],
            [15.54918625182222, 0.6682646057093268],
            [15.552682596921608, 0.6688995321445265],
            [15.557792091207375, 0.6760297381940767],
            [15.562174917644873, 0.6750237136953242],
            [15.5680589673921, 0.6772076949533814],
            [15.577721885966776, 0.6780719320368066],
            [15.583483347488825, 0.6810795379276589],
            [15.591025530530652, 0.6802571453186089],
            [15.594693276704868, 0.6810123292928156],
            [15.598060487862615, 0.6856553130873809],
            [15.601053618355664, 0.686588248144665],
            [15.601978774907668, 0.6810772113917936],
            [15.606534828003195, 0.6841094122169565],
            [15.610507846533368, 0.691019337516116],
            [15.614826516754494, 0.6896327529304103],
            [15.624460010526212, 0.6899959782372376],
            [15.635752873230903, 0.6765423084422155],
            [15.641172603774205, 0.6759115022121392],
            [15.655669644465679, 0.6809741760207557],
            [15.661497099024528, 0.6861797448342933],
            [15.66293480738253, 0.6894075094231882],
            [15.672542901941314, 0.6851130018809644],
            [15.673415656919964, 0.675537773406813],
            [15.675335060106093, 0.6686291599937528],
            [15.681054158692026, 0.6632801144187649],
            [15.684232264870568, 0.6549768806832805],
            [15.688380077838024, 0.6515051908364432],
            [15.692573743112005, 0.6504613386036846],
            [15.69490481506125, 0.6457547340405226],
            [15.703589916295714, 0.6457459352572612],
            [15.709714783844817, 0.6481164742062414],
            [15.715108885384145, 0.6470651427002121],
            [15.72156498141712, 0.6442981358377204],
            [15.72639113326415, 0.6372106693623856],
            [15.724188424692034, 0.6323365100865579],
            [15.724809999428919, 0.6273320163384677],
            [15.729840169607778, 0.6233204872283932],
            [15.730596911131663, 0.6179316132348976],
            [15.733950856443215, 0.6090995370177399],
            [15.733775490008945, 0.6003541397862445],
            [15.72787901474256, 0.5834896500738198],
            [15.740456146775445, 0.5812016685090641],
            [15.750737555249934, 0.5755348603564422],
            [15.751961693108747, 0.5701149660653766],
            [15.757257898150517, 0.5661466503152096],
            [15.76770348265953, 0.5630089334094066],
            [15.766462880140955, 0.5596777112100519],
            [15.774931912112244, 0.5537886307204254],
            [15.771155159359928, 0.550472866324624],
            [15.76793023452024, 0.5413518327281862],
            [15.769718688659825, 0.5359224339414198],
            [15.767535229149496, 0.5327496103139252],
            [15.775265029608667, 0.5239004975257029],
            [15.77917806319271, 0.5081783086494769],
            [15.784045211293014, 0.5067724396278868],
            [15.788976831305193, 0.5073232944571201],
            [15.789485600155535, 0.511702927888744],
            [15.793166304253932, 0.5127672699458697],
            [15.793811346698964, 0.5164966944953409],
            [15.789700756613728, 0.5188367399133342],
            [15.791074105131944, 0.5234775589996106],
            [15.796715892396032, 0.523515954620879],
            [15.804142979222059, 0.5208047156757474],
            [15.808000739779597, 0.5207514519802274],
            [15.821761738851462, 0.5052043164695155],
            [15.820685180429999, 0.5007871430186557],
            [15.812646730786378, 0.5000016296957558],
            [15.806373729761344, 0.5034040446579456],
            [15.800317986386334, 0.5027530154084284],
            [15.798039818774756, 0.5067998033694453],
            [15.794899828846079, 0.5063338616806811],
            [15.788669994068973, 0.5001692587873084],
            [15.779724191756792, 0.5028554419822812],
            [15.771305378079573, 0.500311685084064],
            [15.763615174125547, 0.49520210064982795],
            [15.762089999791286, 0.4929395592058115],
            [15.759772411173657, 0.4840761122342871],
            [15.747837748180105, 0.4938031750935498],
            [15.741905367503982, 0.49749530038454826],
            [15.734348872215975, 0.4993416092118498],
            [15.730244586240337, 0.4981175151759846],
            [15.725901899654893, 0.4945319187792199],
            [15.71360628175728, 0.5031581160698401],
            [15.71061048159785, 0.5043022005910521],
            [15.705586014237497, 0.5028067007023996],
            [15.702079437688242, 0.5038660552929011],
            [15.691630143788455, 0.5132107562521294],
            [15.687343136082328, 0.5125336270760078],
            [15.686956408413996, 0.5097276220777903],
            [15.682903166320843, 0.5076337894064057],
            [15.67696584185631, 0.5123224280498396],
            [15.674856163650189, 0.5171235294618782],
            [15.663834973439828, 0.5211799762916772],
            [15.664833787302264, 0.525999845693815],
            [15.675345127174804, 0.5353717187610935],
            [15.672572839758773, 0.5409051545443178],
            [15.669760253586889, 0.5407064403098807],
            [15.666287007807956, 0.5468705301048238],
            [15.66049415316691, 0.5513855879600198],
            [15.65409149785433, 0.5487898976353011],
            [15.64849379465177, 0.5382151490534712],
            [15.650259954118997, 0.5356732475590659],
            [15.657174177071045, 0.5321655504131585],
            [15.653723710859408, 0.5286330121001601],
            [15.64938576022897, 0.5159445545279132],
            [15.642790877598658, 0.5048169269146912],
            [15.649210198760933, 0.5050326835178478],
            [15.64836825591808, 0.49865450562377256],
            [15.646007541067435, 0.49476578902470975],
            [15.639651185874861, 0.4919603590686796],
            [15.637775284922034, 0.49433331061133257],
            [15.626016664691612, 0.5006812557055561],
            [15.620557632596302, 0.5064363409910947],
            [15.61740207595146, 0.5065367898559461],
            [15.613066696472407, 0.5138756318159132],
            [15.613111538129106, 0.519699554561335],
            [15.611088655496726, 0.5326330287874006],
            [15.607274846155489, 0.543573286594704],
            [15.60176898677485, 0.5517788589312452],
            [15.589344309111745, 0.5582198108730364],
            [15.586464221894872, 0.56199491603149],
            [15.583504520748383, 0.5684802331684459],
            [15.579963180457145, 0.5719945490205673],
            [15.575195745617961, 0.5735315399357162],
            [15.572186173603097, 0.5807141314433821],
            [15.571235007745582, 0.5854215339457566],
            [15.565222304826703, 0.5952826763507509],
            [15.555109036063602, 0.6077016275049342],
            [15.547328316200604, 0.6062058260387075],
            [15.542448951639095, 0.6062795670403512],
            [15.527220038852926, 0.614355247971151],
            [15.525141326223213, 0.6182664806388085],
            [15.51949964668564, 0.6177859118851989],
            [15.517420934539949, 0.6152116124444107],
            [15.513139733529377, 0.6175409568014484],
            [15.518523040979327, 0.6227076483863416],
            [15.5196967670974, 0.6257579700663308],
            [15.515707465848418, 0.6293799458935644]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.4633555564819, "lat": 37.73458051469466 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51103"],
        "coty_name": ["Lancaster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lancaster County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01480139"
      },
      "bbox": [
        15.513139733529377, 0.4840761122342871, 15.821761738851462,
        0.691019337516116
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.340359573778285, 1.765477233615973],
            [14.34352440913825, 1.773862828669371],
            [14.341511336057112, 1.7814596675263148],
            [14.345486672325988, 1.799978123944872],
            [14.34983180118155, 1.810274896849798],
            [14.349125202700982, 1.8154797949085253],
            [14.351651140996973, 1.8297496725189244],
            [14.34995123856427, 1.836356203118879],
            [14.351575726549616, 1.8475158736450983],
            [14.354259496510714, 1.8532966925881518],
            [14.356419400650505, 1.862799702090943],
            [14.363185176021007, 1.8771610091568738],
            [14.36387557682801, 1.890250215010833],
            [14.361092397874668, 1.8901005902914692],
            [14.360189423330029, 1.8955805824923566],
            [14.361738042336178, 1.8983428642774716],
            [14.365468327724532, 1.899877003493909],
            [14.36539545735558, 1.904576622960652],
            [14.367741811839501, 1.9168979172708915],
            [14.36916098485789, 1.9200156349726447],
            [14.368284102032371, 1.9260463579330043],
            [14.370137007124097, 1.9383582923924145],
            [14.376102209979065, 1.95741088144332],
            [14.379124143271738, 1.9613463755252636],
            [14.384904082984317, 1.965377764449518],
            [14.385953816308806, 1.9684806934736008],
            [14.394789579520921, 1.9704528043953038],
            [14.40306288731875, 1.9690568772126291],
            [14.410590335110982, 1.9718409749815857],
            [14.41393988034207, 1.9763510639802062],
            [14.417307123469994, 1.9774307793322496],
            [14.4221204394507, 1.9759003942862783],
            [14.426942805288698, 1.972044020555653],
            [14.439530242663565, 1.96810392644456],
            [14.451316444846762, 1.9673214480297607],
            [14.467463640899398, 1.9652785329426963],
            [14.474827420544033, 1.9677136464385483],
            [14.480449269853217, 1.9669592245297596],
            [14.488451282240892, 1.9686016905614416],
            [14.495143959582851, 1.9732794625687977],
            [14.503916611889755, 1.9759191382868913],
            [14.508323054968237, 1.9724574986351113],
            [14.509057002167223, 1.9649803904284069],
            [14.512121710935295, 1.956997413319138],
            [14.519284833604448, 1.9513257990552342],
            [14.526259214011407, 1.944744526865205],
            [14.529124824243452, 1.9405796535033983],
            [14.536613555196821, 1.9373464427111216],
            [14.546263393110324, 1.9358769633201145],
            [14.558102972012632, 1.9315686011976554],
            [14.567308467629676, 1.9317521131993007],
            [14.575354134758161, 1.929780784169245],
            [14.581031683788314, 1.9248100126676218],
            [14.589651687766638, 1.919152028471194],
            [14.5991369464103, 1.914699263407586],
            [14.601694857468667, 1.9117702059474646],
            [14.601676228900303, 1.9069493644565858],
            [14.60127677777862, 1.905168903267885],
            [14.5949133144388, 1.8968755749948538],
            [14.592951628723904, 1.8929576035833118],
            [14.592453514889048, 1.8862944008664757],
            [14.594529631619354, 1.8794119235421252],
            [14.59295845521285, 1.873171558778515],
            [14.58808828374079, 1.8686081594152812],
            [14.574338561594182, 1.8621803076939263],
            [14.570914730288024, 1.857838493236514],
            [14.568030526769414, 1.8494615842654833],
            [14.566335236980755, 1.8390141240767912],
            [14.566042423065795, 1.825995960595709],
            [14.56465875210062, 1.8234415761967864],
            [14.5668158875427, 1.814691140526016],
            [14.57030240230637, 1.8056129001316732],
            [14.575138101253943, 1.7994721714313897],
            [14.579068465458521, 1.7978453709794837],
            [14.595507433210496, 1.795372295828058],
            [14.603140130281169, 1.7930354293570265],
            [14.61152212059368, 1.7854603304107175],
            [14.619955796955203, 1.7727816891740469],
            [14.627088077831623, 1.7637604008795544],
            [14.63521291402363, 1.7614768198579558],
            [14.647213990621104, 1.7619385596882213],
            [14.658672649015093, 1.7603650035554128],
            [14.664605833280048, 1.7610836379077077],
            [14.673161296673088, 1.7607831308925315],
            [14.677169980472122, 1.7618736312733956],
            [14.687921196339687, 1.7611272330358276],
            [14.691963097217009, 1.7627735296606366],
            [14.696053692494377, 1.7620304826078679],
            [14.721964375468852, 1.7689194026926538],
            [14.732044034230618, 1.7655774124658155],
            [14.674253125462378, 1.645955777224282],
            [14.616347708723906, 1.526201355084552],
            [14.609664139400403, 1.5278517802282252],
            [14.602113012053152, 1.532609547049456],
            [14.60405219889812, 1.53983425538083],
            [14.600243104874881, 1.5409557705581005],
            [14.60234466619152, 1.544540069459262],
            [14.598809646328977, 1.5513945687577504],
            [14.599469052047002, 1.5562445606684723],
            [14.59641164275881, 1.5626260888706585],
            [14.593391426652847, 1.5640292299247605],
            [14.58767890342525, 1.5604920177620656],
            [14.578869176434836, 1.5639815924005689],
            [14.574095328662986, 1.5627846180642353],
            [14.56941189751514, 1.5661457357048945],
            [14.564701826842908, 1.5667587280616082],
            [14.564444708970132, 1.5691459464598134],
            [14.558461152690619, 1.571844341162954],
            [14.553116513544497, 1.5793017101722644],
            [14.54960040601826, 1.5796032858915097],
            [14.545505596553342, 1.5844445320759397],
            [14.543050486562036, 1.591121908810265],
            [14.538411293348775, 1.5964820071082446],
            [14.532559659844601, 1.596632443461017],
            [14.527149962685872, 1.5987168381578876],
            [14.521225838838715, 1.604570859987426],
            [14.507684101266364, 1.6029070224888835],
            [14.448563166768281, 1.6090534869802717],
            [14.338548304398524, 1.6204467195274672],
            [14.261948591565112, 1.6283784547233928],
            [14.264975573260328, 1.6362800415859537],
            [14.275943496975012, 1.6410782233835994],
            [14.283191135060994, 1.6494246061872972],
            [14.284577294972786, 1.6548885713797417],
            [14.290786637050365, 1.6599622995932652],
            [14.297689830464812, 1.6681909707037277],
            [14.302157503902645, 1.6763838844561727],
            [14.306063723117989, 1.6797144365310523],
            [14.308403621880773, 1.689454753380138],
            [14.313579888436278, 1.7044096303468423],
            [14.315929388663362, 1.7070275354952293],
            [14.32416871763168, 1.709472126428137],
            [14.327216896888043, 1.7222159735110978],
            [14.327185500248465, 1.7306586900005378],
            [14.331101020338526, 1.7506584166573063],
            [14.334371926401802, 1.7534204423090065],
            [14.340359573778285, 1.765477233615973]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.6357414696249, "lat": 39.09071445816931 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51107"],
        "coty_name": ["Loudoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Loudoun County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01480141"
      },
      "bbox": [
        14.261948591565112, 1.526201355084552, 14.732044034230618,
        1.9774307793322496
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.240942304531076, 0.7172904174575881],
            [14.258603253028852, 0.7170824239513057],
            [14.26248442743557, 0.7202542803058771],
            [14.270265554043652, 0.7213699650081642],
            [14.27199753857133, 0.7255734318499075],
            [14.276525806902994, 0.7307519669448406],
            [14.28176508599332, 0.7309002438955579],
            [14.285291759926691, 0.7335272928957998],
            [14.288479631461346, 0.7385106719386927],
            [14.293196137407675, 0.738188399585199],
            [14.297235802458736, 0.7357570117984417],
            [14.301956182438012, 0.7366622173419821],
            [14.311424109369197, 0.7411276053477928],
            [14.31311678017174, 0.7451194947865938],
            [14.312161216354252, 0.7478012020979519],
            [14.319258967519799, 0.7542033793130354],
            [14.322374473751422, 0.7530887409209515],
            [14.32623872305449, 0.7545007106835688],
            [14.332560956644604, 0.7506406716015787],
            [14.33555218536981, 0.7517673768067316],
            [14.340654059577924, 0.7469863542413969],
            [14.344782354579333, 0.7489317878099738],
            [14.354617801044945, 0.7486985121378851],
            [14.363629741063228, 0.7455210978448195],
            [14.370685417340002, 0.7458060950744618],
            [14.374404987190744, 0.7477902605945428],
            [14.376462008875176, 0.7518642320760889],
            [14.381306507455811, 0.7496269484289013],
            [14.38246146200028, 0.7555815639428259],
            [14.39005457835517, 0.7539204151368574],
            [14.39147317744902, 0.7552911678812883],
            [14.398442942117809, 0.753930887778022],
            [14.403787627289468, 0.7493469515093191],
            [14.4094971957361, 0.7460772967572156],
            [14.415344698672017, 0.7399751464098326],
            [14.418431149230631, 0.7391741668666776],
            [14.42692140101786, 0.7437207747087532],
            [14.432467249480373, 0.7410905101600695],
            [14.443091873301807, 0.7423979462911647],
            [14.443776886420732, 0.7445912302557504],
            [14.453015484767322, 0.7421130014223833],
            [14.454727452126242, 0.7406007365955726],
            [14.462679566681697, 0.7425732198023207],
            [14.467309360868612, 0.7473721180555559],
            [14.473370850226718, 0.7422670002865293],
            [14.481634054474648, 0.7409800413173513],
            [14.489955114120804, 0.7463893747213506],
            [14.495424644613756, 0.7431254411596464],
            [14.502100213143072, 0.741842863637715],
            [14.513347722022035, 0.7427819202803131],
            [14.522721398808848, 0.7410957996214167],
            [14.524459716697349, 0.7440050388728935],
            [14.529680024538132, 0.7469696940271998],
            [14.532188337456686, 0.7422097663712139],
            [14.537355621649054, 0.7397117459318199],
            [14.542291916183446, 0.7388148803458292],
            [14.54648358056142, 0.7360256720472854],
            [14.546641894824683, 0.7327610160299006],
            [14.54939451023073, 0.7295996633285178],
            [14.55307542779264, 0.7299587918014464],
            [14.554066774826106, 0.7259771092193585],
            [14.559254472891931, 0.7242041661254734],
            [14.569049800081665, 0.7261029881559103],
            [14.57496463158875, 0.7246788086402952],
            [14.579737394017975, 0.7168619113191155],
            [14.578362196824413, 0.7141264895506568],
            [14.584492039899713, 0.7087330438390832],
            [14.58979409343268, 0.7084251104005392],
            [14.59349393845873, 0.7032804495931463],
            [14.603660938380372, 0.7016553240409278],
            [14.608515645062383, 0.7073307306915196],
            [14.610072415339905, 0.7025929687901007],
            [14.613236791698485, 0.683458913611055],
            [14.616993552529575, 0.6804861630587529],
            [14.619298873004762, 0.689061057906817],
            [14.626192772120016, 0.6883439224513335],
            [14.628897291410357, 0.6854765901171461],
            [14.627854164209552, 0.6785870099514152],
            [14.634436414612692, 0.6819256806007127],
            [14.637105423244448, 0.6771988939474338],
            [14.643263421476783, 0.6747524312858053],
            [14.653511310379866, 0.674644655504789],
            [14.657526940116744, 0.670247701896238],
            [14.664022733207302, 0.6718160446810826],
            [14.647366598688574, 0.5123578828897166],
            [14.644464357867127, 0.4969116366420063],
            [14.645693912246331, 0.4837149602222689],
            [14.644494008273234, 0.4787817575640909],
            [14.646308253254222, 0.46917461663166715],
            [14.645059022835495, 0.4573130418924806],
            [14.641626618083794, 0.4567276242745977],
            [14.633560926781197, 0.3807366663211663],
            [14.623062587655562, 0.38451024132902434],
            [14.618619254683955, 0.3900944494099123],
            [14.614792643628125, 0.3905782901161875],
            [14.610905396326052, 0.3936785270439429],
            [14.598567325122612, 0.3957688775959723],
            [14.598517583239598, 0.39326406185314416],
            [14.593305859285271, 0.3919773190322742],
            [14.591056808073562, 0.39474519591135215],
            [14.581097469909167, 0.394695150595362],
            [14.58099157220759, 0.4003025149578568],
            [14.574419448171565, 0.39518440079840295],
            [14.566127584932692, 0.3937789200639918],
            [14.563147406985054, 0.3975242151833724],
            [14.549911428879959, 0.4047965152445611],
            [14.543258987658339, 0.4068265539028027],
            [14.542397576328657, 0.41083679493942543],
            [14.538488216972885, 0.4093368616690632],
            [14.536362760346284, 0.41707101894418047],
            [14.53814373498331, 0.41833044858721236],
            [14.536570259439367, 0.4251641698504987],
            [14.537393129779826, 0.4285281768582087],
            [14.541882790053693, 0.43388653706922237],
            [14.542075578442098, 0.4390985704675129],
            [14.5349319768998, 0.44198530252032586],
            [14.533503429479342, 0.4453340087617619],
            [14.534753650234071, 0.4486775463468364],
            [14.531871750156078, 0.45086177669101296],
            [14.531251655302324, 0.4548403485817456],
            [14.522417306831768, 0.4569455497346825],
            [14.516015162145594, 0.45994659041463454],
            [14.504979177400743, 0.4667024950662963],
            [14.502740136084073, 0.465967447687934],
            [14.497179304447377, 0.4702442207242424],
            [14.494903482513067, 0.47947564986278307],
            [14.492823702559019, 0.47783983610693753],
            [14.486940895874469, 0.47784138228850837],
            [14.482372279820279, 0.4761626918175478],
            [14.475555193779375, 0.4757440687338974],
            [14.46022335231075, 0.4778291357863513],
            [14.461324956868083, 0.48529640662550183],
            [14.450961477766878, 0.4922523876096129],
            [14.441919476810979, 0.4960645511217096],
            [14.426528013425568, 0.5014926446617082],
            [14.41624801868905, 0.506768928064114],
            [14.412936841329905, 0.5069674615619665],
            [14.406544184523218, 0.5120659941276097],
            [14.401705056610002, 0.5142470085221875],
            [14.395541199688731, 0.5143741319048916],
            [14.394316723263874, 0.5148835552035298],
            [14.343839305863298, 0.5293766431101091],
            [14.320423548770359, 0.5362808673058912],
            [14.302144467724327, 0.5429400370961718],
            [14.287072093503705, 0.5423875411688757],
            [14.276868033921236, 0.5454898235056345],
            [14.253669227303051, 0.5628960848237817],
            [14.242450843637263, 0.5648752096262293],
            [14.223495851876578, 0.5672540699657753],
            [14.21568513030431, 0.5690694523388413],
            [14.189705143078612, 0.5795179350820083],
            [14.202087646328634, 0.6058261506200746],
            [14.20750188937891, 0.6198184922189327],
            [14.219608668522639, 0.6430508040940284],
            [14.240942304531076, 0.7172904174575881]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.96303282355528, "lat": 37.97864806606721 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51109"],
        "coty_name": ["Louisa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Louisa County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01494707"
      },
      "bbox": [
        14.189705143078612, 0.3807366663211663, 14.664022733207302,
        0.7555815639428259
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.74526843750658, -1.006137056681714],
            [12.744084448924184, -0.9982765303756898],
            [12.744705849374355, -0.9896639574721893],
            [12.75034342950572, -0.9845186704189993],
            [12.750446877207125, -0.9809196631395041],
            [12.744790504206984, -0.9758902458980058],
            [12.746929983678939, -0.9747177505056447],
            [12.750973637113644, -0.9679863385086779],
            [12.754801011651669, -0.9645182991955737],
            [12.76320431947502, -0.9657863200692881],
            [12.766902973117697, -0.9672643792584737],
            [12.769519552163228, -0.9658270925288153],
            [12.780907827402487, -0.9663571826333278],
            [12.787523876146578, -0.9629015280512211],
            [12.789832201628816, -0.9641073392225142],
            [12.793763967347594, -0.9615733850553434],
            [12.794353374695799, -0.9574840973696453],
            [12.790357684105583, -0.9532406045832597],
            [12.788428649924695, -0.9421070150493956],
            [12.795106014119789, -0.935237729002599],
            [12.794351895454968, -0.9315377543268251],
            [12.790697778102615, -0.9296946220565149],
            [12.79035541434176, -0.9260471477937081],
            [12.794428611958924, -0.9198505454244152],
            [12.789599985464182, -0.9158035708895164],
            [12.791116719325382, -0.9075368890721133],
            [12.795475791620083, -0.9046725073709073],
            [12.799826922173802, -0.8990922524299689],
            [12.802694103298837, -0.9003838450570898],
            [12.80623509434979, -0.8982807036366444],
            [12.810024465641693, -0.8988602357382258],
            [12.818163531963528, -0.8914881446945913],
            [12.818416781371964, -0.8883637134381323],
            [12.821728365099247, -0.8862926707052599],
            [12.822805340010234, -0.8791997437880393],
            [12.819938920966994, -0.8714390427343014],
            [12.820400396365072, -0.8662730535311578],
            [12.83141534622137, -0.8669894477203716],
            [12.831616133559775, -0.8610734684996393],
            [12.835681000885733, -0.8593080501899382],
            [12.835525452313902, -0.8560088289342025],
            [12.837943062385307, -0.8526291781332742],
            [12.843764531777692, -0.8510988123609045],
            [12.846899927287291, -0.8517830978607567],
            [12.853933954419203, -0.8457666107007336],
            [12.856991947419726, -0.8352796998225053],
            [12.868711027380147, -0.8289720164627602],
            [12.882978364667697, -0.8236814881885036],
            [12.883485016859588, -0.8174390098532953],
            [12.892445978567274, -0.8167304426035047],
            [12.897193077037697, -0.8136687387385053],
            [12.928514414103498, -0.8162379577286826],
            [12.929466051442569, -0.8160147958169575],
            [13.00578236833047, -0.8214040069592998],
            [13.015288429877804, -0.8209994410594317],
            [13.019430965744679, -0.8166790007459016],
            [13.027337141606559, -0.8179080768031287],
            [13.034227375849149, -0.8218567822264813],
            [13.03346723478519, -0.829198723001498],
            [13.026587963779757, -0.8279080488664208],
            [13.02749448193643, -0.8334485166007871],
            [13.033313703549979, -0.8337840619460859],
            [13.032610241378972, -0.8408941085747319],
            [13.035283383532768, -0.843865757814023],
            [13.041796893377521, -0.8467147284603589],
            [13.045404909470541, -0.8511763340208773],
            [13.055973720226962, -0.8569796565661634],
            [13.059458922044717, -0.8596697258979049],
            [13.061860282717939, -0.8655455038633092],
            [13.054297729114586, -0.8687701944736225],
            [13.053028885167429, -0.8703837296621659],
            [13.046464850867888, -0.868894428323238],
            [13.045584382360477, -0.8726270190646418],
            [13.036247536847034, -0.8735718749426243],
            [13.035005765729965, -0.8759565243358233],
            [13.030883042581449, -0.8773088075955168],
            [13.029641021151019, -0.8809639384744763],
            [13.022984989001145, -0.8872895568188186],
            [13.023283053401872, -0.8919016242842024],
            [13.026563434674092, -0.8975538093733075],
            [13.027972657282042, -0.9031647324156634],
            [13.030161194733, -0.9042293204241411],
            [13.030975210994221, -0.9129077515260399],
            [13.028952732287713, -0.9215493095003476],
            [13.034660603687096, -0.9252074066248045],
            [13.036612757117096, -0.9280983756468445],
            [13.034427117537012, -0.931923003729418],
            [13.035436006933208, -0.9351248933352552],
            [13.032372068232597, -0.9419827790767725],
            [13.037775711011315, -0.9530705927376675],
            [13.042035802439035, -0.9590308602985903],
            [13.045899917351218, -0.9615647605465173],
            [13.051144243472775, -0.9761720241165748],
            [13.054170624476436, -0.9830908599297952],
            [13.059430506234172, -0.98656047347368],
            [13.06093903250365, -0.9908754449657461],
            [13.06457706658659, -0.99572179080546],
            [13.069129657413422, -0.9973193104274786],
            [13.071794952789435, -1.0046735266428146],
            [13.07168379681457, -1.0125509489851738],
            [13.074009152833371, -1.0169250686570477],
            [13.074988590761311, -1.028625894034133],
            [13.077973696466755, -1.02913405407617],
            [13.080617311480873, -1.0382679616688661],
            [13.083317556663273, -1.0406424466823467],
            [13.082566949204548, -1.0470023086328981],
            [13.086245113003194, -1.0508583811356575],
            [13.094960402618478, -1.1177649064703814],
            [13.041014022433837, -1.1267682724654227],
            [12.95981742787143, -1.1392845488450638],
            [12.90496477016735, -1.1482202999794364],
            [12.789955401028472, -1.1604834941758395],
            [12.653943404436935, -1.1754233394609792],
            [12.654117083246923, -1.170559504051927],
            [12.650473493071232, -1.1672886360759935],
            [12.650933877803146, -1.1598479002147544],
            [12.64866980744244, -1.1553627557189248],
            [12.646682942158693, -1.1453597365703205],
            [12.640579701478158, -1.1432888457207149],
            [12.6379186978873, -1.1377933848298716],
            [12.635451522381503, -1.1290262751121374],
            [12.63737146873892, -1.1274274378087945],
            [12.639256870362665, -1.1214088183154503],
            [12.636254792904813, -1.1149421555329981],
            [12.640459473017998, -1.1080262849692908],
            [12.642720356996628, -1.102405249780512],
            [12.64694601354717, -1.0956908808953185],
            [12.647226019214598, -1.0892251302920688],
            [12.645088881459117, -1.0821212837230967],
            [12.649206328070317, -1.0806260862878414],
            [12.65359053148967, -1.0736886171765725],
            [12.650517745834993, -1.0701273975647965],
            [12.654477951137874, -1.0681675539059647],
            [12.663568817265467, -1.0672294622283778],
            [12.671033562684343, -1.0717527026720997],
            [12.681014755879978, -1.0753361870142002],
            [12.685393313814368, -1.073889148936934],
            [12.688385012814775, -1.078735000993091],
            [12.68894892520531, -1.0831595802184704],
            [12.69929820550081, -1.082511305218115],
            [12.703018919740822, -1.0780319187055194],
            [12.70777834626266, -1.0783970768487214],
            [12.721255782061178, -1.0679208608920752],
            [12.72481074069511, -1.062812580221527],
            [12.731094624082338, -1.0660168409116557],
            [12.73613712618219, -1.0638026482338172],
            [12.733684351104424, -1.0602004014089896],
            [12.733272082114775, -1.0560442963098162],
            [12.736097223207024, -1.0516661082408234],
            [12.744229754779777, -1.0477268551749492],
            [12.74968964076292, -1.0418763236672002],
            [12.75009539826052, -1.0326121075179737],
            [12.75184903610779, -1.0261384191038236],
            [12.750981061464794, -1.022044004954099],
            [12.75242890782044, -1.015423169309545],
            [12.754784141071019, -1.0130292960597502],
            [12.75282220431606, -1.0083306570312387],
            [12.74526843750658, -1.006137056681714]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.28438548303848, "lat": 36.67832780747028 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51141"],
        "coty_name": ["Patrick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Patrick County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01497999"
      },
      "bbox": [
        12.635451522381503, -1.1754233394609792, 13.094960402618478,
        -0.8136687387385053
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.635352167685623, -0.9557982012302768],
            [11.637696238065232, -0.9554565109951801],
            [11.642050689998259, -0.9473625455371926],
            [11.645660713524112, -0.9433389877885039],
            [11.646998567759596, -0.9354496498330448],
            [11.656500289932916, -0.9291235615786816],
            [11.669188722765334, -0.9236861779650123],
            [11.675173459598666, -0.919600099446202],
            [11.681868296565847, -0.9164263036952857],
            [11.690951966612872, -0.9154488798686313],
            [11.711398663822012, -0.9024434837801256],
            [11.71472449749869, -0.9022783788885201],
            [11.728544559628629, -0.8927671055745384],
            [11.755563724017229, -0.9336770831389265],
            [11.762288052061352, -0.9310173353602877],
            [11.768069521626645, -0.9250538528571751],
            [11.773747981357348, -0.9227887254108103],
            [11.786074153031107, -0.9131383955174681],
            [11.789472752319826, -0.9082543535852778],
            [11.795257675404105, -0.9029207373925465],
            [11.796591200913, -0.9000674861304607],
            [11.81134589480712, -0.8851029077995961],
            [11.815473512604656, -0.8822239995804455],
            [11.820497987204666, -0.8736714301228425],
            [11.826771112634365, -0.8691852540810082],
            [11.830364500187118, -0.8643187834888177],
            [11.84146019986461, -0.8620165589937617],
            [11.850046927163136, -0.8565763789926775],
            [11.856263200734087, -0.8536729502106606],
            [11.862505697794523, -0.8528883856093353],
            [11.867297808254152, -0.8478939859259477],
            [11.874552905393305, -0.8461807515968082],
            [11.879671026658023, -0.8427317995864684],
            [11.881076643830337, -0.8374290769555668],
            [11.885327101577895, -0.8359351819232306],
            [11.889909395619219, -0.8293531533549077],
            [11.901880776295886, -0.8265569673782195],
            [11.905385645914631, -0.8234063124084131],
            [11.909965479927624, -0.8245436130396371],
            [11.91067259393261, -0.8267177396819286],
            [11.90639744039126, -0.833423596209323],
            [11.909337661666253, -0.838219189153711],
            [11.907056755084742, -0.8402130559040002],
            [11.910195686503304, -0.8435285334525211],
            [11.902495712245361, -0.8526919249120976],
            [11.90565711080622, -0.8562411268393186],
            [11.91774732801454, -0.846413151447353],
            [11.920845870727229, -0.8413703419675485],
            [11.92716783021615, -0.8358004559097224],
            [11.933988464505235, -0.8278738009125078],
            [11.936219921230473, -0.8271717048246154],
            [11.98995064710816, -0.8777968265371406],
            [12.03927330671597, -0.9242664772156068],
            [12.050859077174154, -0.9459159111696404],
            [12.066443841914001, -0.9710706281292428],
            [12.090892901427084, -1.0113995423286666],
            [12.0985805715912, -1.0247002657419941],
            [12.111310795990336, -1.0524185471659406],
            [12.106638006110556, -1.0537014669739888],
            [12.083907601779863, -1.0673010109286905],
            [12.08227890964928, -1.0666272526315788],
            [12.019188014769275, -1.090299865847523],
            [12.008714696334371, -1.0982205510855167],
            [12.00654477892885, -1.1005942565388491],
            [11.997025602370357, -1.106369312382619],
            [11.98915804485589, -1.114781352332325],
            [11.979816628311223, -1.1199716439738592],
            [11.974575494037747, -1.1216375389310382],
            [11.966253641433259, -1.1203842094089398],
            [11.963375900204836, -1.1235814410396743],
            [11.947865771361998, -1.1284535937577118],
            [11.938113628575225, -1.1326758962444816],
            [11.93124127576766, -1.133206593376964],
            [11.926354223891567, -1.1386829299856243],
            [11.913724353266723, -1.1397040876647182],
            [11.908900097309509, -1.143551793082735],
            [11.899615740076591, -1.1480184276116765],
            [11.900979320277669, -1.152416010005443],
            [11.910640776478754, -1.1542096378944198],
            [11.910056341265706, -1.1575017551756324],
            [11.912161136849074, -1.1629496932857815],
            [11.912038711640909, -1.1718569032055615],
            [11.909256494668263, -1.1839208355777509],
            [11.903934909300155, -1.193346809632332],
            [11.893596734177132, -1.1926937720255941],
            [11.890522941417906, -1.1936186334396348],
            [11.886144483566692, -1.1976480000330287],
            [11.882637768230719, -1.20359511223561],
            [11.879102069332848, -1.2073694323647355],
            [11.87393908589007, -1.2088262038615099],
            [11.8629652581616, -1.2145013910700877],
            [11.860680030208897, -1.2187494616107608],
            [11.85095717843027, -1.2244001054150262],
            [11.832542634140603, -1.1935266490368257],
            [11.794421446800254, -1.1300325658155435],
            [11.777472504716712, -1.1012047449769824],
            [11.769309294850657, -1.0881480182469196],
            [11.764168929101897, -1.0790125319110497],
            [11.760474839434412, -1.0756171166561366],
            [11.7064218718731, -1.023630842956099],
            [11.635352167685623, -0.9557982012302768]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.53699983239146,
          "lat": 36.843737716455955
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51173"],
        "coty_name": ["Smyth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Smyth County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "01500545"
      },
      "bbox": [
        11.635352167685623, -1.2244001054150262, 12.111310795990336,
        -0.8234063124084131
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.86887536697947, -0.2606324578313067],
            [15.883493939465218, -0.25736981209490745],
            [15.88594477839851, -0.2574760131297786],
            [15.887047030713173, -0.266223602227607],
            [15.89300861376246, -0.26569412304759976],
            [15.897841499630623, -0.2701496118278464],
            [15.898200652944011, -0.2765730146564735],
            [15.903455605418644, -0.28310616763945434],
            [15.896088834464011, -0.29434429310819815],
            [15.892640133830312, -0.3096096539352223],
            [15.896853246827334, -0.31657893040325774],
            [15.900956493718052, -0.3156554733034187],
            [15.908197106950418, -0.3201980514092642],
            [15.90878342515049, -0.32222083845336474],
            [15.920154268598873, -0.3327182414075115],
            [15.95510489030585, -0.31823247851919656],
            [15.961461824165921, -0.31468863528997776],
            [15.982569478323935, -0.3052908906017296],
            [15.981906322623008, -0.29635742799560655],
            [15.978956782802697, -0.28696403152855876],
            [15.979217093242513, -0.28319502904658894],
            [15.98359861545617, -0.28233182467017265],
            [15.98871087826821, -0.27826254981554743],
            [15.989804090533124, -0.27478539127118595],
            [16.004690668094696, -0.27916282490799027],
            [16.011283429584967, -0.26525792036650453],
            [16.011971435798127, -0.261010210644506],
            [16.025060437911673, -0.25506503216480897],
            [16.026363264010424, -0.25778247268526333],
            [16.024984185537388, -0.2623796511186267],
            [16.034672027424577, -0.27963781617708305],
            [16.05705895691125, -0.32075060817875206],
            [16.071639056045786, -0.3238541602015272],
            [16.10663743691423, -0.32335880823019075],
            [16.150714415739287, -0.3563132776700359],
            [16.163431341201708, -0.3573253990054302],
            [16.166244542337925, -0.36365081244229547],
            [16.174072827963816, -0.3714731078295056],
            [16.17860343207108, -0.3746077356988109],
            [16.181978743333104, -0.38114454845481993],
            [16.180884229172708, -0.38973820121084135],
            [16.172472889195713, -0.3902892703646017],
            [16.168010343349188, -0.3941283494840436],
            [16.15794383354546, -0.39882572408328315],
            [16.157872931027917, -0.4018555610755265],
            [16.142307657468272, -0.4100128209253829],
            [16.15713146190971, -0.47975986713081503],
            [16.158789693143692, -0.4863770748015648],
            [16.159765297144002, -0.495302215480537],
            [16.166159735002726, -0.5238960323019209],
            [16.111334390076202, -0.5355375459966785],
            [16.0174774402241, -0.5552373504809934],
            [15.899035192169965, -0.5796153077211272],
            [15.878658712751243, -0.5840862474563279],
            [15.857629551323233, -0.38684672257269764],
            [15.850715137135301, -0.31754804882401255],
            [15.853530855743385, -0.30472157055073257],
            [15.858243735883896, -0.28842715760997895],
            [15.8577296383661, -0.2875082320208289],
            [15.86887536697947, -0.2606324578313067]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.30224615631354, "lat": 36.67780238456674 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51550"],
        "coty_name": ["Chesapeake"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Chesapeake city"],
        "coty_fp_code": "550",
        "coty_gnis_code": "01498558"
      },
      "bbox": [
        15.850715137135301, -0.5840862474563279, 16.181978743333104,
        -0.25506503216480897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.09044055557299, 10.75746731787648],
            [-18.083885981790367, 10.75528568192329],
            [-18.077159971440466, 10.755012350861938],
            [-18.063315663829357, 10.751146287416633],
            [-18.028500161936, 10.740513856009002],
            [-18.021116437906628, 10.739083356249152],
            [-17.994305112179685, 10.730871104168155],
            [-17.97898828037399, 10.727481903375613],
            [-17.951407328144484, 10.718448247908464],
            [-17.95977731170503, 10.691225831609193],
            [-17.931669325273134, 10.68266735828915],
            [-17.875353968593792, 10.667110092536364],
            [-17.848920713611257, 10.659530776214456],
            [-17.785946794689348, 10.640669267806151],
            [-17.730780078476283, 10.62522447283156],
            [-17.72395376851313, 10.622592085217043],
            [-17.70953246059794, 10.618892803690619],
            [-17.695696057254267, 10.614836276537437],
            [-17.647116914144334, 10.601169467545756],
            [-17.621144031622748, 10.59333426872002],
            [-17.6004343108139, 10.586341912667049],
            [-17.570522737697335, 10.579037487043886],
            [-17.530124380936414, 10.567028067354666],
            [-17.515184095140466, 10.562183098465288],
            [-17.511256724620857, 10.562109351346345],
            [-17.419273596973028, 10.536404042719797],
            [-17.32729809546866, 10.51067021894358],
            [-17.325970171654177, 10.507960702877313],
            [-17.32068272026665, 10.508067083879748],
            [-17.312727281873563, 10.4986196089938],
            [-17.306572346760987, 10.4972505644544],
            [-17.303322699849904, 10.498296131525555],
            [-17.29949124674211, 10.49351293077615],
            [-17.287204570830124, 10.491052319065506],
            [-17.285408471991595, 10.488396266733607],
            [-17.280543495228947, 10.489136341738721],
            [-17.273184919903958, 10.481231548776039],
            [-17.262528740329916, 10.480545086998477],
            [-17.250268649691204, 10.47826120350394],
            [-17.245849590011233, 10.475395505078477],
            [-17.24017918359436, 10.470022437925124],
            [-17.236523891393514, 10.471378393711744],
            [-17.235037744264748, 10.468950374043922],
            [-17.230618900602654, 10.467150435102209],
            [-17.225740211719668, 10.461607053773477],
            [-17.21704168860352, 10.460317782372908],
            [-17.21385030534647, 10.458118456894262],
            [-17.208699386042674, 10.461690277556373],
            [-17.205046541441668, 10.461693187297586],
            [-17.20104970399616, 10.465008984318246],
            [-17.197131823148307, 10.464637917299322],
            [-17.19598610895533, 10.461768892342125],
            [-17.189015094027464, 10.455680257127277],
            [-17.187649855946546, 10.452935027274924],
            [-17.180274568940206, 10.452364758704165],
            [-17.178075501058405, 10.454351090709574],
            [-17.17250076364092, 10.454701132040448],
            [-17.170233184748852, 10.457987235007995],
            [-17.163943597361573, 10.456920071988694],
            [-17.16102161058652, 10.45191677856399],
            [-17.156661785740415, 10.448196488121269],
            [-17.15346651903287, 10.439854601491332],
            [-17.150016615986974, 10.436948911093506],
            [-17.14513344506304, 10.435834564715705],
            [-17.14182315436907, 10.432780606437595],
            [-17.13461558533741, 10.431487869417143],
            [-17.127653154290087, 10.424791098639293],
            [-17.12204921478312, 10.422986287019821],
            [-17.116503222373524, 10.41895372621625],
            [-17.09741484142133, 10.411966707999044],
            [-17.091406037187912, 10.411452538427723],
            [-17.087619736117098, 10.416144676794284],
            [-17.084281549550404, 10.418056574882394],
            [-17.076149365665014, 10.425293865996544],
            [-17.071060648586965, 10.424442251354206],
            [-17.065354733541138, 10.428092244351507],
            [-17.065835804592496, 10.431462078601104],
            [-17.06057053646226, 10.434980472823966],
            [-17.053859956357325, 10.43637174458593],
            [-17.050455801604592, 10.441174583774615],
            [-17.041143287431748, 10.445508346717606],
            [-17.02764168140951, 10.448919673123763],
            [-16.92702658123406, 10.421727365274387],
            [-16.82642025561075, 10.394501138987302],
            [-16.826503361692588, 10.387288604390772],
            [-16.82430250810124, 10.383071502173259],
            [-16.825077601608484, 10.377835631470308],
            [-16.822716599601105, 10.377064471440361],
            [-16.82126404463096, 10.370152452966602],
            [-16.813522130476468, 10.364227866872978],
            [-16.813895783371038, 10.359152598681073],
            [-16.821516169116784, 10.350593631216263],
            [-16.820757024889904, 10.347681742020834],
            [-16.810752195765357, 10.341261322744208],
            [-16.809749235792975, 10.333575757523734],
            [-16.801385267090577, 10.329897998031527],
            [-16.793298364812337, 10.329375066734071],
            [-16.784292427784916, 10.324595145094293],
            [-16.781492285289325, 10.320600407020889],
            [-16.779759272418158, 10.313810694747538],
            [-16.780860165460744, 10.30945760908468],
            [-16.788748327884495, 10.308221620764348],
            [-16.794448652951697, 10.30609576602372],
            [-16.798932816661917, 10.301100986709885],
            [-16.796800117727006, 10.294117808766662],
            [-16.799928733075582, 10.288473104200342],
            [-16.81429664488029, 10.293961950283261],
            [-16.81835041097759, 10.291481111543579],
            [-16.822055956394628, 10.291375677683064],
            [-16.82288699846781, 10.288631371998823],
            [-16.826985390792164, 10.284967286613451],
            [-16.82855879279112, 10.27499452116915],
            [-16.833448770221246, 10.270090687676046],
            [-16.835483406002673, 10.262914221934073],
            [-16.83448284069065, 10.25938174930145],
            [-16.822917373440877, 10.253327842281754],
            [-16.825831880059198, 10.25001447936496],
            [-16.820860389632326, 10.245536641320678],
            [-16.819639871284238, 10.242497270567954],
            [-16.82370053040892, 10.23616413793508],
            [-16.823929677498658, 10.228187697366048],
            [-16.82687791243949, 10.224785027167664],
            [-16.831653195366638, 10.2238524275938],
            [-16.835634369542554, 10.22132915918217],
            [-16.83689992220389, 10.217250402406645],
            [-16.840461884162217, 10.21680583498882],
            [-16.842831918368443, 10.213595194422567],
            [-16.84122919457584, 10.205823158084902],
            [-16.84332284317017, 10.199906479612874],
            [-16.846619984479908, 10.195158168724092],
            [-16.85089848082198, 10.19484374738196],
            [-16.85410278825924, 10.191243227450187],
            [-16.857154180252817, 10.1921047319954],
            [-16.86243218008254, 10.186875510228665],
            [-16.86161809035844, 10.181737333535866],
            [-16.857509975560042, 10.174009837216381],
            [-16.863156672374696, 10.170918938163057],
            [-16.864865257721906, 10.16846092619748],
            [-16.8628753909359, 10.164847662331923],
            [-16.86591897598504, 10.162116748059464],
            [-16.874208459123572, 10.158668567336738],
            [-16.876720395270862, 10.159521443739086],
            [-16.8817119552757, 10.157488577466134],
            [-16.88949402483162, 10.15743465967055],
            [-16.890118769710494, 10.154287106436419],
            [-16.894523897399093, 10.148804436086598],
            [-16.898036751731574, 10.138750301660611],
            [-16.896584158595076, 10.135484925592795],
            [-16.896954952207984, 10.128545401751781],
            [-16.89387721452137, 10.125065020178504],
            [-16.88488474450469, 10.120061601140732],
            [-16.881888199522106, 10.113503769717212],
            [-16.886235802587155, 10.111440361828757],
            [-16.89254281640865, 10.105669778086781],
            [-16.8945946557398, 10.102144061144713],
            [-16.894184242418838, 10.098102180806897],
            [-16.891954260821333, 10.09407401432851],
            [-16.89085926167864, 10.08675482385442],
            [-16.887110646365723, 10.084206312893148],
            [-16.885465331905635, 10.080937686291959],
            [-16.887048592310464, 10.07283823554423],
            [-16.88582136142642, 10.067106700838155],
            [-16.885985793473107, 10.059677624660283],
            [-16.88782245089757, 10.051137421583633],
            [-16.885665918618304, 10.045327865052574],
            [-16.882749179608783, 10.042271099893547],
            [-16.88176730358181, 10.03655834569753],
            [-16.879077024535075, 10.029127662223438],
            [-16.88343188798798, 10.024592171344281],
            [-16.883742290040168, 10.021055995451848],
            [-16.889293424410393, 10.010944753034913],
            [-16.89163375132058, 10.009737547386836],
            [-16.924475477634896, 10.018381240427413],
            [-16.926361607634824, 10.015538960443525],
            [-16.931540106030308, 10.02090823781696],
            [-16.951796248919727, 10.025868378291316],
            [-16.975513467922596, 10.032397383760141],
            [-16.975406824598586, 10.032778999037115],
            [-17.045059142379586, 10.051741270963628],
            [-17.114715582361285, 10.070687744432083],
            [-17.20083800926327, 10.094357425272701],
            [-17.286966802921874, 10.118002900358462],
            [-17.287144260503066, 10.117395170052973],
            [-17.31531310936674, 10.125004219441477],
            [-17.36998382891909, 10.140665056901625],
            [-17.370362578901425, 10.138898319449135],
            [-17.398065456454432, 10.146308302036145],
            [-17.426011006688245, 10.154235180829337],
            [-17.454851681694606, 10.161773650358096],
            [-17.45497247234837, 10.161294078606932],
            [-17.524564135543045, 10.18100977306511],
            [-17.536354524550855, 10.184929213004128],
            [-17.536087747229075, 10.185995581801127],
            [-17.57844166678457, 10.197676494899191],
            [-17.619778277438996, 10.209442634868939],
            [-17.67571935615982, 10.225799062623611],
            [-17.758431832371596, 10.248476113456038],
            [-17.826363188525942, 10.268032223688717],
            [-17.894298751742674, 10.28757311875357],
            [-17.929086853838, 10.297480969096455],
            [-18.03453501322902, 10.328457176486141],
            [-18.04833112354525, 10.33101485262022],
            [-18.062186343369003, 10.334697113370087],
            [-18.07665159647182, 10.3377520429698],
            [-18.104040064778555, 10.346070351863021],
            [-18.121666667663842, 10.350164293609767],
            [-18.131926712567275, 10.351946497274866],
            [-18.197606539804863, 10.371618801703871],
            [-18.185054961615936, 10.41228478828474],
            [-18.181308667532736, 10.425433468338452],
            [-18.168638184127676, 10.46621339216968],
            [-18.167222127046454, 10.472808596176877],
            [-18.153080838755066, 10.519616641788165],
            [-18.147821359010127, 10.539785581267877],
            [-18.15138072305512, 10.541139654477755],
            [-18.147736172501954, 10.55456795939255],
            [-18.14319513379181, 10.56734058883995],
            [-18.135469670896676, 10.59487320324346],
            [-18.132935985818495, 10.601901511305526],
            [-18.11666428882578, 10.663098271257788],
            [-18.106350091479012, 10.703495744566602],
            [-18.107851090903793, 10.703897928144515],
            [-18.09044055557299, 10.75746731787648]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.39276283781844,
          "lat": 46.57777788610804
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53041"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01531927"
      },
      "bbox": [
        -18.197606539804863, 10.009737547386836, -16.779759272418158,
        10.75746731787648
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.95744809286186, 2.826503759972248],
            [11.959980321114157, 2.836208119983583],
            [11.967044246251204, 2.8436284057119456],
            [11.971103466436649, 2.8503154149598955],
            [11.974012969819462, 2.8585793223111824],
            [11.976963005209537, 2.8639745831489263],
            [11.981674920566059, 2.8686629139505566],
            [11.989683900887607, 2.8717650916060755],
            [11.998141414944408, 2.8765828517015484],
            [12.001905242392713, 2.877400405592308],
            [12.0073422715234, 2.8754638174597376],
            [12.014728489250004, 2.869549546342933],
            [12.020061964044274, 2.86909844151106],
            [12.026126220854435, 2.8734876254565833],
            [12.030414128881745, 2.880444998862051],
            [12.03669486438637, 2.886748041298525],
            [12.040441502188822, 2.8882346099338263],
            [12.049246579853982, 2.8956886573085785],
            [12.054422430192162, 2.8970255704068495],
            [12.058926407137232, 2.9005546949258045],
            [12.062522439393513, 2.878260443120732],
            [12.08533105647404, 2.7400575612784683],
            [12.088739406776849, 2.725405379026047],
            [12.098796425525542, 2.6628991706272043],
            [12.068042889765234, 2.65776114759013],
            [12.057215498827228, 2.6561985998032296],
            [12.035549145379349, 2.6498447324511023],
            [12.016331634287456, 2.6446746820891716],
            [12.02634778293022, 2.6512707854513082],
            [12.028230209940004, 2.6556624009370817],
            [12.026941815267987, 2.659332460175073],
            [12.0254671998253, 2.6702219817931683],
            [12.023189631417694, 2.6808782005111715],
            [12.023163944505196, 2.689451064058613],
            [12.02640680004802, 2.699067812347683],
            [12.026274671205305, 2.702211549144037],
            [12.02941692648853, 2.71150468553041],
            [12.030240568428555, 2.716744481332293],
            [12.029905768362802, 2.724858192759114],
            [12.02480842954946, 2.7354612842953547],
            [12.016339824422534, 2.7411646944463723],
            [12.007645480301859, 2.752552430540526],
            [12.003843995972677, 2.7623543227675507],
            [12.001529075588554, 2.7703893039569896],
            [11.995093575755044, 2.784955945258948],
            [11.990456656725499, 2.7871731707810636],
            [11.982728945456541, 2.7958290761712563],
            [11.972218006509642, 2.808539335118243],
            [11.959651981628758, 2.817846787738127],
            [11.95744809286186, 2.826503759972248]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.57385572865735, "lat": 40.52183968809908 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54029"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01560574"
      },
      "bbox": [
        11.95744809286186, 2.6446746820891716, 12.098796425525542,
        2.9005546949258045
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.826049018334379, 1.5894691209059517],
            [12.826676245223965, 1.590063372383449],
            [12.887662644787536, 1.6301376442258622],
            [12.91158066141568, 1.6460890065502432],
            [12.966895662504692, 1.6341671843715657],
            [13.05688187326869, 1.6148995290734995],
            [13.076097566062748, 1.596415253956121],
            [13.07898833822966, 1.5914930110878494],
            [13.086463916194816, 1.5879893364071824],
            [13.089826721697621, 1.5843787406941254],
            [13.093806009956378, 1.583028307207593],
            [13.09640693099121, 1.586866626113145],
            [13.105313452992037, 1.5911997603207295],
            [13.109237667950405, 1.5914789814335233],
            [13.111324837458335, 1.5937930585644957],
            [13.11044988925358, 1.5987626286715098],
            [13.11661457067767, 1.6000523605525938],
            [13.121520354785584, 1.596099809735734],
            [13.123972938922128, 1.600323188089856],
            [13.128381037780962, 1.6014070867010233],
            [13.13222689747132, 1.5999327806736354],
            [13.13829122940098, 1.6035636736621366],
            [13.142153572923407, 1.6033225039404375],
            [13.147745349938532, 1.6069734303445486],
            [13.14715418464143, 1.6107622691057133],
            [13.150285042574973, 1.6151065436687257],
            [13.154001125004863, 1.615250195985777],
            [13.153787310024441, 1.619106671254898],
            [13.157012965062163, 1.6207011207406106],
            [13.161631279541478, 1.620594645860312],
            [13.167620035677073, 1.6171437901312704],
            [13.171643371771784, 1.622159413874259],
            [13.171544533378452, 1.626241289136895],
            [13.178831623068518, 1.6269143766938017],
            [13.180204201719627, 1.634127309952772],
            [13.189021484578037, 1.636713215058235],
            [13.194915303475623, 1.6346826296841188],
            [13.19715353657177, 1.6312871218596323],
            [13.200592132278707, 1.6347652677241695],
            [13.207039943358453, 1.636213957083851],
            [13.211138319568773, 1.6337646870682168],
            [13.21949873584652, 1.6253083695104154],
            [13.222731375818148, 1.6198349417641684],
            [13.22022788629958, 1.6124207650275355],
            [13.213644969132767, 1.6077668545306159],
            [13.210891266055157, 1.6017447673268341],
            [13.21311403449293, 1.5984481037484066],
            [13.21239229395551, 1.593299879764179],
            [13.206268630855186, 1.5878069950893972],
            [13.206254899340333, 1.5821673716522517],
            [13.204240190713557, 1.5794529960583166],
            [13.201880483167958, 1.5703229702482735],
            [13.203801595601803, 1.5625662111356375],
            [13.208255546494838, 1.5581280194888432],
            [13.207906406473848, 1.5543762999247601],
            [13.202331565300414, 1.54928901063718],
            [13.20349851390459, 1.545962656854354],
            [13.207332091965458, 1.5415978143311273],
            [13.197685417310243, 1.528528206059398],
            [13.198693163561781, 1.5216036507983406],
            [13.19705422859226, 1.5193447055971083],
            [13.198963100093238, 1.514392699669775],
            [13.195028301287795, 1.506221590096861],
            [13.203480819049412, 1.5049077470566443],
            [13.211594659910837, 1.505266038098011],
            [13.21735221978379, 1.4981546152773482],
            [13.220098674344996, 1.4967234605251478],
            [13.228460451064016, 1.4955385774484538],
            [13.232430136247375, 1.5026706515470396],
            [13.234725031040215, 1.5033053459648207],
            [13.240461858031564, 1.5007018883515622],
            [13.240784149929905, 1.4962139507987655],
            [13.239098096345131, 1.4894178505643714],
            [13.240370184316937, 1.4873566683351074],
            [13.239907136993114, 1.477123221803469],
            [13.240788234272308, 1.4738547884624904],
            [13.238183648397973, 1.4675651551624953],
            [13.23416051644838, 1.467557882792029],
            [13.232259647465323, 1.461062274810025],
            [13.238885825741976, 1.4564292632351226],
            [13.239309374080921, 1.4450952433389395],
            [13.23437597941295, 1.437034726048208],
            [13.236676590317744, 1.4268319670930705],
            [13.232764647855486, 1.4234877669859116],
            [13.230939639580924, 1.4195571642931726],
            [13.231966574033398, 1.4063239568235202],
            [13.227915164090922, 1.399182238099643],
            [13.226423452245399, 1.3917077746081739],
            [13.224925944384802, 1.3900075747692113],
            [13.214529766281428, 1.384682886501788],
            [13.208914334925856, 1.3863560486114408],
            [13.199757250443557, 1.383302775328999],
            [13.189901451706785, 1.385969815382168],
            [13.174220523678379, 1.3871239128628314],
            [13.168988407404868, 1.3858992858486705],
            [13.16528828902573, 1.3833419754546026],
            [13.150976471203716, 1.3857168802981588],
            [13.143269491939996, 1.3819187543775004],
            [13.134444329037242, 1.3822755100253687],
            [13.132731152481453, 1.380801007357427],
            [13.126314381486651, 1.382633443746073],
            [13.121966642942606, 1.38212002269429],
            [13.115647095850095, 1.379498170603671],
            [13.114069986206678, 1.3776432579987044],
            [13.108386411482096, 1.3792932976513768],
            [13.104809005040721, 1.3758950132933883],
            [13.10294324850346, 1.3706295801825972],
            [13.098987644831011, 1.3724388078970713],
            [13.098073534701344, 1.375111056897754],
            [12.99165066328484, 1.3873177649512287],
            [12.87733143527913, 1.400517368149355],
            [12.879536000480226, 1.403561043175049],
            [12.880077589793338, 1.408570538935763],
            [12.882363464801168, 1.4107055447518977],
            [12.879101036450198, 1.4196685385944794],
            [12.880804492493558, 1.422010457906121],
            [12.878502134335651, 1.4340055032500676],
            [12.879867719277016, 1.4364940607058263],
            [12.87848968109254, 1.4408654463304673],
            [12.873893972694372, 1.4480622047769292],
            [12.864688243604009, 1.4562042139052291],
            [12.864677941581844, 1.459890405736881],
            [12.859574482415116, 1.4628021892134844],
            [12.854850583650705, 1.468952287606938],
            [12.8415063655263, 1.4712658450264717],
            [12.837552322926024, 1.476116323489912],
            [12.834048107649943, 1.473363686079906],
            [12.829039895486261, 1.4761901106536046],
            [12.830581623887122, 1.479015030898626],
            [12.828583744270688, 1.4833815332171751],
            [12.823262577444002, 1.4834919340913508],
            [12.821604394740696, 1.4867914239652593],
            [12.822826049509182, 1.4896636214575227],
            [12.822445677597978, 1.4968689545418659],
            [12.823312895266358, 1.4999875400298095],
            [12.821552288558582, 1.5038837717214737],
            [12.821724296379042, 1.512412704438643],
            [12.824606279314757, 1.5174133487913504],
            [12.822556237577718, 1.5316023332470365],
            [12.820762023833549, 1.5346979856655025],
            [12.823474904563986, 1.539849860133045],
            [12.82314906039665, 1.54808837491244],
            [12.81944876803964, 1.5510356986493445],
            [12.823574505978705, 1.5569658971349638],
            [12.82428716676657, 1.5632334261120169],
            [12.826316034380774, 1.5681901797162217],
            [12.822907605284707, 1.5771265016686742],
            [12.827833861684818, 1.5828885994578406],
            [12.826049018334379, 1.5894691209059517]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.56499806261287,
          "lat": 39.113607011762674
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54093"],
        "coty_name": ["Tucker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tucker County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01689423"
      },
      "bbox": [
        12.81944876803964, 1.3706295801825972, 13.240788234272308,
        1.6460890065502432
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5528345188296893, 5.996591846296177],
            [3.638829044107582, 6.000112220347232],
            [3.6430471426345266, 5.913716049471442],
            [3.646314305287066, 5.839634168012174],
            [3.6493656667568137, 5.779730507585851],
            [3.6496092473238737, 5.77768930470736],
            [3.654746892545135, 5.659193338315366],
            [3.654848013996968, 5.651916957383165],
            [3.6502047952014767, 5.649689945702792],
            [3.648103095887766, 5.643156799123146],
            [3.6487291763428655, 5.639799162992638],
            [3.6440658208988244, 5.638963726264142],
            [3.6400421360402806, 5.636385508629507],
            [3.636371755241628, 5.628582058682121],
            [3.6316924130547625, 5.628480308795335],
            [3.6262746247836977, 5.622969705019641],
            [3.6237000082726585, 5.626314296041309],
            [3.620060015450504, 5.621525270326251],
            [3.616175944694022, 5.619010821500467],
            [3.612253102106349, 5.618778523434338],
            [3.6057058960715804, 5.613925922153287],
            [3.604676572554812, 5.606793262947675],
            [3.6020836014368207, 5.601496485454416],
            [3.6076944719087987, 5.596685485705945],
            [3.6094538355583157, 5.5907854240167625],
            [3.608518132686967, 5.583789326343209],
            [3.605537280638635, 5.582676336231605],
            [3.6016063554878945, 5.577304504880726],
            [3.598953014158493, 5.576080916488618],
            [3.5995427968357268, 5.571422887505944],
            [3.6045010847731542, 5.566513967293139],
            [3.6116678184085833, 5.567163251627892],
            [3.6124078778806137, 5.563600683794724],
            [3.6155496524562, 5.5587484646176755],
            [3.621641948639011, 5.556320097864524],
            [3.6279602266305555, 5.55539026398235],
            [3.633819862935263, 5.552735182017876],
            [3.639091461036125, 5.546057238391089],
            [3.6400094446422666, 5.538909722406825],
            [3.642988947786795, 5.537115925534419],
            [3.6470259638532436, 5.528470928724085],
            [3.6454393730542867, 5.526040359533911],
            [3.6457008640421735, 5.520590456307315],
            [3.6485102774764178, 5.515827208589161],
            [3.6478790289912952, 5.512803142735256],
            [3.653782629084759, 5.5066525077133495],
            [3.657323812472547, 5.504805277246261],
            [3.6586735365769987, 5.501227722197337],
            [3.655857743329524, 5.4962013021261615],
            [3.6528978391934106, 5.48680431872837],
            [3.652375544342095, 5.481752982078491],
            [3.6486393380612325, 5.477795595583252],
            [3.648718126201842, 5.472741170522019],
            [3.643133404579414, 5.467085732337312],
            [3.642961668115133, 5.4577241393318685],
            [3.6390416979793367, 5.456052668430515],
            [3.635004715814687, 5.449146477067616],
            [3.6350702284707417, 5.442099664997049],
            [3.642278348972353, 5.436314738883065],
            [3.646247093660641, 5.434531164111287],
            [3.644352779523588, 5.430016160831369],
            [3.6273664830092156, 5.431293919747972],
            [3.620406349037072, 5.434963632636243],
            [3.6162698368080726, 5.438366145215305],
            [3.6116197982532916, 5.446868729846131],
            [3.608738350090885, 5.450412338792868],
            [3.6027926553683467, 5.454380151943998],
            [3.5936378236075814, 5.458169250444665],
            [3.585985972053421, 5.4652972056237585],
            [3.581286680635796, 5.46457952669037],
            [3.570181166036443, 5.475494254347912],
            [3.5642372046441433, 5.487984219816398],
            [3.5533759908367517, 5.497926597583943],
            [3.543470730119304, 5.498648842923018],
            [3.5345201987001644, 5.503580748147969],
            [3.533779578469121, 5.510569099183739],
            [3.5315494371015053, 5.520017694614508],
            [3.5250960158011573, 5.528098718220515],
            [3.5166588955145697, 5.5317665585000055],
            [3.5014969872806634, 5.532975304416417],
            [3.497853703872048, 5.534830559955495],
            [3.484679281918622, 5.544977228952378],
            [3.468528940449784, 5.551057325411905],
            [3.46017045537385, 5.5556145946808995],
            [3.4533518201128106, 5.5602862014224375],
            [3.4442554354306463, 5.573996241310639],
            [3.43283769445874, 5.580022714537239],
            [3.422743268511654, 5.587704418005036],
            [3.418307554420384, 5.5910808723215],
            [3.4104432210980233, 5.594739091242793],
            [3.4091963196730006, 5.603679469427786],
            [3.4061025064803134, 5.610521184016277],
            [3.3988818619140697, 5.619934002976262],
            [3.396597678583431, 5.624651122138885],
            [3.3962333254940353, 5.628676392229273],
            [3.399354507268368, 5.640050965882511],
            [3.399738435591665, 5.645437128106741],
            [3.3980600289496774, 5.64964924409549],
            [3.3928601068822, 5.656230632253886],
            [3.3926750733801345, 5.666350625839855],
            [3.3903232804573107, 5.670409700054861],
            [3.385073875162895, 5.6746221646853146],
            [3.374528949204346, 5.679047964693265],
            [3.3712120781579604, 5.684220024536908],
            [3.37134937147913, 5.689500557904134],
            [3.3778147682620516, 5.700900376413072],
            [3.3782672332857473, 5.704078373169959],
            [3.374152863409487, 5.715168993322356],
            [3.3687216851271855, 5.725801559159336],
            [3.3667621549631908, 5.727640699577028],
            [3.357201606057932, 5.732732029324435],
            [3.3509625893229584, 5.7402755185082786],
            [3.3434406669657086, 5.750551413645488],
            [3.335514924812099, 5.756646064642273],
            [3.329490476615551, 5.758918696370877],
            [3.323252065578041, 5.759402208207722],
            [3.313835189693234, 5.764846166357105],
            [3.3076399807229153, 5.769240492731297],
            [3.29993674899534, 5.770507665060719],
            [3.286211512874187, 5.777440139567003],
            [3.2801809217481264, 5.7828489636885125],
            [3.2747189431902877, 5.789589712061335],
            [3.268847128418601, 5.792092142834205],
            [3.2567376952369793, 5.79233758929611],
            [3.2530578627280695, 5.794502807460532],
            [3.2527138031636915, 5.799292542701564],
            [3.2549814848585306, 5.806760097203611],
            [3.253258725487808, 5.811739390416129],
            [3.2547910625429375, 5.820458328985061],
            [3.2579987803159716, 5.82458657017983],
            [3.2648306540613494, 5.846734915651749],
            [3.2679149406793337, 5.854117478113472],
            [3.266989661731136, 5.861751692709601],
            [3.269251713877791, 5.876777907843019],
            [3.2718385780881456, 5.88249935938647],
            [3.2732669412045308, 5.890797879806625],
            [3.27694669607103, 5.900491869812837],
            [3.2767389239000386, 5.908582405606551],
            [3.2736081587221744, 5.91496581542462],
            [3.2743339196516263, 5.922404903569482],
            [3.277930130796289, 5.929979685408102],
            [3.2791092672577586, 5.93510605916315],
            [3.279107210473336, 5.94436950366639],
            [3.2778587043172256, 5.952258743860975],
            [3.2814491511676827, 5.96015392995772],
            [3.28432332809416, 5.974560722855578],
            [3.290642724918315, 5.979978154965783],
            [3.2960654541347814, 5.980588481930412],
            [3.3023609111900307, 5.985831338443485],
            [3.32983758687708, 5.986786216530901],
            [3.3946262442718664, 5.989470964972135],
            [3.4880631455028333, 5.993613800773133],
            [3.5134872324594006, 5.99494982090092],
            [3.5528345188296893, 5.996591846296177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.75447178067274,
          "lat": 44.379843635548326
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55011"],
        "coty_name": ["Buffalo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buffalo County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01581065"
      },
      "bbox": [
        3.2527138031636915, 5.430016160831369, 3.6586735365769987,
        6.000112220347232
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.896707760262945, 6.013465230132183],
            [3.926404676790938, 6.014556058787294],
            [4.00762563996435, 6.018815443576647],
            [4.06933349261591, 6.021732551764672],
            [4.070213832348843, 6.006220826221288],
            [4.073578278441589, 5.93564484516727],
            [4.159719472267113, 5.9401241074292965],
            [4.162500987250581, 5.889162492244636],
            [4.1642942315276885, 5.853236446604317],
            [4.250664017914116, 5.857792443050607],
            [4.334652229583216, 5.862473642118723],
            [4.3809647166868455, 5.865553751011187],
            [4.424250453981266, 5.867997437701928],
            [4.45176898659299, 5.870338707077233],
            [4.46719930630332, 5.87130724734378],
            [4.509665548310005, 5.874984315169449],
            [4.512523789190467, 5.815855922472333],
            [4.514152542486381, 5.788229988415817],
            [4.518793757390235, 5.699806529683188],
            [4.522606245192413, 5.700075699087845],
            [4.528331738012265, 5.606853348843727],
            [4.526495181377541, 5.606742867490717],
            [4.4400325019052085, 5.607578171207883],
            [4.356076137593896, 5.6018186346124965],
            [4.27117872557911, 5.5963213652562],
            [4.1981875138800495, 5.5918282839220455],
            [4.185479316586728, 5.590944413517591],
            [4.105476879496227, 5.5860555659164834],
            [4.097543531480654, 5.579998388849451],
            [4.093848590306238, 5.574555559173362],
            [4.088491564482643, 5.572659592251751],
            [4.082129760160925, 5.573899781359242],
            [4.078118133400197, 5.5699030033701105],
            [4.0761281682418495, 5.5735386184635445],
            [4.07263198191723, 5.567488438398828],
            [4.068766814524027, 5.567173026352691],
            [4.068045450897993, 5.562945774416416],
            [4.062037349471233, 5.561102496612003],
            [4.060864758620362, 5.555276358444246],
            [4.056479484677748, 5.554935246940258],
            [4.054927415589354, 5.5514793040707415],
            [4.060010608484129, 5.548509827763318],
            [4.062382249606943, 5.543741414048865],
            [4.058362141462635, 5.541841304097554],
            [4.061182432386641, 5.496277836952507],
            [4.025230033609694, 5.494846884122897],
            [3.9333777165055874, 5.489775932452442],
            [3.9328719090616895, 5.498421810618791],
            [3.9284453026647634, 5.576906019281631],
            [3.9257348288796243, 5.627127431828827],
            [3.9231188702878463, 5.665817598660506],
            [3.9145784236372188, 5.665246462619818],
            [3.9139368201309974, 5.672365332732994],
            [3.911226493626497, 5.7213506423116005],
            [3.9078419040541146, 5.7961552100588],
            [3.906203648553164, 5.839792853748632],
            [3.9030725729550237, 5.897190683475461],
            [3.900877422147852, 5.926703296323595],
            [3.8990421458932696, 5.966790560563363],
            [3.896707760262945, 6.013465230132183]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.80525168637077, "lat": 44.31915625486949 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55053"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01581086"
      },
      "bbox": [
        3.896707760262945, 5.489775932452442, 4.528331738012265,
        6.021732551764672
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.030109708241462, 6.713114531329013],
            [4.025364274286063, 6.799707878257845],
            [4.068691556822421, 6.8012442902991666],
            [4.097311470775084, 6.802681272297973],
            [4.111653739112947, 6.803145972858768],
            [4.198322387811591, 6.807674281004103],
            [4.321127774127395, 6.8138888940813125],
            [4.411100676945306, 6.82108662696192],
            [4.413188120075129, 6.820973653967983],
            [4.470199260790065, 6.826329912436212],
            [4.484926490703723, 6.82722094350102],
            [4.573131390701226, 6.833350965694284],
            [4.57715390115246, 6.83421147176121],
            [4.595011995771122, 6.835633270047226],
            [4.644233442745834, 6.83791539142072],
            [4.6449542616242745, 6.824219673608708],
            [4.643967161131031, 6.807956267455877],
            [4.644124000681057, 6.796548621377893],
            [4.650959825980177, 6.689695628823465],
            [4.652910591067642, 6.665474965626003],
            [4.659641749931652, 6.578329536410362],
            [4.584284969381458, 6.573863545293181],
            [4.551213574603294, 6.5720464820902444],
            [4.556700657473118, 6.485721112516299],
            [4.473891497087007, 6.4809310549520545],
            [4.409655272210896, 6.474816496354567],
            [4.390360507704131, 6.4731744255882],
            [4.3035210141938185, 6.468310974633352],
            [4.217781396858757, 6.46364187061135],
            [4.1014134982650745, 6.4575629193481685],
            [4.045358204903302, 6.454122181241613],
            [4.041034512975767, 6.541714302685485],
            [4.038814901481871, 6.542387185474719],
            [4.033155295149582, 6.6480549371554964],
            [4.030109708241462, 6.713114531329013]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.50122236541608, "lat": 45.21159257453381 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55119"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01581119"
      },
      "bbox": [
        4.025364274286063, 6.454122181241613, 4.659641749931652,
        6.83791539142072
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.07293376592573, 5.810030453072952],
            [-9.044173045835983, 5.806262592382035],
            [-9.043786256730055, 5.808799870942018],
            [-8.944602565186756, 5.794882579607555],
            [-8.916213429077322, 5.792593501468942],
            [-8.912534965459376, 5.812702336774831],
            [-8.903723252574327, 5.878446297040186],
            [-8.842304634379387, 5.8706345653764735],
            [-8.838109668165398, 5.869661877100266],
            [-8.775633319149144, 5.861186967101643],
            [-8.766201784654115, 5.946669678081786],
            [-8.677954862653406, 5.934926667541508],
            [-8.66638201770277, 6.02257121549545],
            [-8.572205595287292, 6.009812408176818],
            [-8.569225158955357, 6.009653950832697],
            [-8.495045743109864, 5.999503668076506],
            [-8.45206029669441, 5.994198586567594],
            [-8.463034109975743, 5.9071451622137054],
            [-8.418687887042234, 5.901519094508366],
            [-8.432074224517581, 5.813939810506269],
            [-8.346542047279291, 5.802701685798669],
            [-8.350708805811712, 5.774738774137167],
            [-8.35066677476407, 5.7725596558540015],
            [-8.354123207792146, 5.746637032927235],
            [-8.312049714073522, 5.741334886426652],
            [-8.28782217859203, 5.739315719123325],
            [-8.269901241176388, 5.736819013503049],
            [-8.26534657487406, 5.736827884951845],
            [-8.26873842264411, 5.7308308903471366],
            [-8.271341229233792, 5.7284040391847],
            [-8.273183929457026, 5.723622369730217],
            [-8.277786898086278, 5.721059560544674],
            [-8.275611011503967, 5.718117877554079],
            [-8.268777499734696, 5.712740282607469],
            [-8.262039509300607, 5.710842790668805],
            [-8.261670820452212, 5.7068680641479546],
            [-8.138929797447089, 5.6907879015443665],
            [-8.137457798136806, 5.690861783566156],
            [-8.105958171686598, 5.686787597513169],
            [-8.116786699695815, 5.6023159667788445],
            [-8.038409551685794, 5.592573811049743],
            [-7.960034170173143, 5.5828174002193],
            [-7.944947442170679, 5.580803299356342],
            [-7.95600638038736, 5.493955062035107],
            [-7.896782581257207, 5.487255157522301],
            [-7.869360594304032, 5.483990468793434],
            [-7.887052730963905, 5.34002732807184],
            [-7.890635829225683, 5.311118252796853],
            [-7.9912234927795405, 5.323316232874242],
            [-8.09181386500694, 5.335491484658374],
            [-8.192406913226705, 5.347644005684702],
            [-8.293002604727512, 5.359773793862953],
            [-8.294481744316235, 5.348852566671477],
            [-8.305657452722741, 5.35040754249167],
            [-8.42448309856991, 5.365778364224102],
            [-8.422558573828615, 5.379950103676899],
            [-8.507896290220613, 5.391315528829674],
            [-8.504096754655611, 5.419950158954505],
            [-8.589400816932196, 5.4312997628796165],
            [-8.585517233675354, 5.460346498919807],
            [-8.67060929242718, 5.471370799394622],
            [-8.664503867276034, 5.514442930631503],
            [-8.709475284001291, 5.520138729420624],
            [-8.750014156325953, 5.525732135637572],
            [-8.746004034728408, 5.555156684219667],
            [-8.831473822681883, 5.566209629248884],
            [-8.82972694521783, 5.580545980154374],
            [-8.91446553414613, 5.592513279576452],
            [-8.999206485798389, 5.60446405653296],
            [-8.988050052903148, 5.683077244271708],
            [-8.995158439332993, 5.6882415445761945],
            [-8.995207895319616, 5.6903188986375834],
            [-8.999633540459353, 5.694859852545524],
            [-9.002746834389189, 5.696222921520936],
            [-9.004931757522632, 5.700081434411854],
            [-9.00627126039036, 5.706091596606388],
            [-9.009842907850842, 5.710724299179501],
            [-9.009857119837456, 5.717834364863346],
            [-9.014085105198415, 5.7292346394716365],
            [-9.017918112815483, 5.735928924637542],
            [-9.020477359749565, 5.745297932954703],
            [-9.024274748170523, 5.753386751368745],
            [-9.031158833423868, 5.757421098362487],
            [-9.03263837396188, 5.761452149014421],
            [-9.042237383993513, 5.7662410250975595],
            [-9.045821801301424, 5.773793815974365],
            [-9.048048984263481, 5.787101744261942],
            [-9.053873220445459, 5.796760599812598],
            [-9.057165877183593, 5.795764868889692],
            [-9.062603633291824, 5.796596053315062],
            [-9.065259416754804, 5.799864399520279],
            [-9.071895268147971, 5.8025560267356155],
            [-9.07293376592573, 5.810030453072952]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.44213309772361,
          "lat": 43.71895881199236
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56017"],
        "coty_name": ["Hot Springs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hot Springs County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01605074"
      },
      "bbox": [
        -9.07293376592573, 5.311118252796853, -7.869360594304032,
        6.02257121549545
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.483141722720369, 6.087568624518341],
            [-8.451237849874804, 6.083302182896111],
            [-8.316164353899946, 6.065711347553412],
            [-8.181096690809397, 6.048075932629904],
            [-8.038402650927393, 6.029692786037752],
            [-8.027670595199703, 6.028448255723824],
            [-7.895676632392879, 6.0119823937732875],
            [-7.889348429439188, 6.009767841139646],
            [-7.868918559653451, 6.007205071881668],
            [-7.7593828196210675, 5.994683757009814],
            [-7.649850262678183, 5.982133249905439],
            [-7.622588276724339, 5.978789594839021],
            [-7.487662794595148, 5.960703985786529],
            [-7.474719451121825, 5.959214596830788],
            [-7.479331268802216, 5.918829267690521],
            [-7.479969697305084, 5.9151666551201405],
            [-7.5054428831229645, 5.698210931834099],
            [-7.515039043561688, 5.612299413971228],
            [-7.5050547301497375, 5.611263256353866],
            [-7.512733649324284, 5.545619598350186],
            [-7.514690629684063, 5.531032593805535],
            [-7.515550598606024, 5.52063317229296],
            [-7.53554330474902, 5.352804398225666],
            [-7.533533079810776, 5.35235783983398],
            [-7.539964445606257, 5.297429452521153],
            [-7.623144780025498, 5.307377591166338],
            [-7.625790279539857, 5.308727854415462],
            [-7.765568156510742, 5.325553309851073],
            [-7.782748336419392, 5.3278787996715895],
            [-7.8193590724119755, 5.331697832679678],
            [-7.843908861537985, 5.334739075789842],
            [-7.887052730963905, 5.34002732807184],
            [-7.869360594304032, 5.483990468793434],
            [-7.896782581257207, 5.487255157522301],
            [-7.95600638038736, 5.493955062035107],
            [-7.944947442170679, 5.580803299356342],
            [-7.960034170173143, 5.5828174002193],
            [-8.038409551685794, 5.592573811049743],
            [-8.116786699695815, 5.6023159667788445],
            [-8.105958171686598, 5.686787597513169],
            [-8.137457798136806, 5.690861783566156],
            [-8.138929797447089, 5.6907879015443665],
            [-8.261670820452212, 5.7068680641479546],
            [-8.262039509300607, 5.710842790668805],
            [-8.268777499734696, 5.712740282607469],
            [-8.275611011503967, 5.718117877554079],
            [-8.277786898086278, 5.721059560544674],
            [-8.273183929457026, 5.723622369730217],
            [-8.271341229233792, 5.7284040391847],
            [-8.26873842264411, 5.7308308903471366],
            [-8.26534657487406, 5.736827884951845],
            [-8.269901241176388, 5.736819013503049],
            [-8.28782217859203, 5.739315719123325],
            [-8.312049714073522, 5.741334886426652],
            [-8.354123207792146, 5.746637032927235],
            [-8.35066677476407, 5.7725596558540015],
            [-8.350708805811712, 5.774738774137167],
            [-8.346542047279291, 5.802701685798669],
            [-8.432074224517581, 5.813939810506269],
            [-8.418687887042234, 5.901519094508366],
            [-8.463034109975743, 5.9071451622137054],
            [-8.45206029669441, 5.994198586567594],
            [-8.495045743109864, 5.999503668076506],
            [-8.483141722720369, 6.087568624518341]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.68279868881972,
          "lat": 43.90497377189546
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56043"],
        "coty_name": ["Washakie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washakie County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01605085"
      },
      "bbox": [
        -8.495045743109864, 5.297429452521153, -7.474719451121825,
        6.087568624518341
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.0168208612597756, 5.814989478635213],
            [-6.008721022970198, 5.814497583613849],
            [-5.960699332439385, 5.810379845542605],
            [-5.864622931937818, 5.802572931521351],
            [-5.76854814351861, 5.794743703255407],
            [-5.672475002447674, 5.786892161088132],
            [-5.576403544002097, 5.779018305639073],
            [-5.5153439563116855, 5.774500247739541],
            [-5.510224417254036, 5.773338961170142],
            [-5.39866465010851, 5.763474791833852],
            [-5.287107619735032, 5.753580515005293],
            [-5.2903179262235085, 5.714476878259264],
            [-5.2996564270887, 5.605113843687786],
            [-5.307841624656563, 5.512057117556423],
            [-5.315297123431519, 5.428261669156212],
            [-5.324226905915554, 5.322187026944294],
            [-5.330324105621542, 5.248682365042791],
            [-5.337805795275852, 5.159866773033575],
            [-5.340172222017612, 5.133303139017688],
            [-5.344658077640066, 5.079298887503976],
            [-5.348058607851036, 5.079323553012314],
            [-5.485266774332036, 5.0906378417500315],
            [-5.607707358362058, 5.1009129425860875],
            [-5.72571480016897, 5.111191543375849],
            [-5.843724883607499, 5.121439014533992],
            [-5.8451449405330695, 5.121286205217869],
            [-5.952702059044354, 5.129760689590224],
            [-6.024758830141276, 5.136184152811262],
            [-6.082093574312701, 5.140785650304872],
            [-6.082261475539434, 5.144777267013106],
            [-6.0595934163230565, 5.38129384481426],
            [-6.0498906466838935, 5.467808784627294],
            [-6.051775713056783, 5.467895230189987],
            [-6.037985858772297, 5.606392163733584],
            [-6.0168208612597756, 5.814989478635213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.56765659125345,
          "lat": 43.84040868735359
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56045"],
        "coty_name": ["Weston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Weston County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01605086"
      },
      "bbox": [
        -6.082261475539434, 5.079298887503976, -5.287107619735032,
        5.814989478635213
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.8602800941913, "lat": 18.418741484989354 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72027"],
        "coty_name": ["Camuy"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Camuy Municipio"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01804493"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.51631284105204, "lat": 18.2890613182851 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72039"],
        "coty_name": ["Ciales"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Ciales Municipio"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01804499"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.25253360969886,
          "lat": 18.288430890662447
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72105"],
        "coty_name": ["Naranjito"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Naranjito Municipio"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01804533"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.81371520494753, "lat": 18.34623635218529 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72119"],
        "coty_name": ["Río Grande"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Río Grande Municipio"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01804540"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.39799289599884,
          "lat": 18.428315800798785
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72145"],
        "coty_name": ["Vega Baja"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Vega Baja Municipio"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01804553"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.2410610776502455, 10.616285582237397],
            [-6.200429931851826, 10.611962890326208],
            [-6.12893146060402, 10.60483739660959],
            [-6.057434719141928, 10.5976940423338],
            [-5.996681974489871, 10.59142947582802],
            [-5.9359306376753915, 10.585152012170628],
            [-5.91099378693774, 10.582912177678905],
            [-5.8515597074710275, 10.576901697719833],
            [-5.778411006888561, 10.569706494929294],
            [-5.7413577366953135, 10.565878925487256],
            [-5.681383360245906, 10.560224308535966],
            [-5.612775238061925, 10.553578772588823],
            [-5.544168800038942, 10.546916816198776],
            [-5.552577629675061, 10.46115824943174],
            [-5.539618403220626, 10.459931622745232],
            [-5.564312655972343, 10.207843841599509],
            [-5.52091917267279, 10.203746830695215],
            [-5.5290681283762435, 10.119536722705918],
            [-5.598716944207056, 10.126099666053799],
            [-5.668367349213283, 10.13264605820495],
            [-5.743631630038886, 10.139963853425247],
            [-5.818897847280832, 10.147262307766685],
            [-5.834221306445435, 10.148665345529373],
            [-5.948885376795262, 10.160163763038096],
            [-6.015541167159628, 10.166921126576373],
            [-6.082198539398677, 10.173663303331786],
            [-6.167228793036072, 10.182258079225377],
            [-6.169085934548695, 10.182683858331293],
            [-6.2254867064907184, 10.18829098809185],
            [-6.2259171462619864, 10.19188770479856],
            [-6.217053600919155, 10.27323504257688],
            [-6.210365295666891, 10.337380918986215],
            [-6.199299984504879, 10.440678488389015],
            [-6.285849220234893, 10.449698537044585],
            [-6.276728875663229, 10.533472387345832],
            [-6.250318222070062, 10.530703590611996],
            [-6.2410610776502455, 10.616285582237397]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -105.5485370379899, "lat": 48.7837920170482 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30019"],
        "coty_name": ["Daniels"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Daniels County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01637566"
      },
      "bbox": [
        -6.285849220234893, 10.119536722705918, -5.52091917267279,
        10.616285582237397
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5743619302756096, 3.0938735565700424],
            [-1.4176660837931767, 3.0896385094720293],
            [-1.378852724358027, 3.088645163411973],
            [-1.3108986610284525, 3.087368088826339],
            [-1.236389101491184, 3.0857203634046524],
            [-1.2328217781449495, 3.085666595703845],
            [-1.2347754165955684, 3.0071737529864824],
            [-1.2365768798845773, 2.939965512410307],
            [-1.2391740065875418, 2.838181453681823],
            [-1.2394458391328584, 2.8236269700620045],
            [-1.2416112629147613, 2.736242590782824],
            [-1.3230201953991898, 2.73819185240273],
            [-1.3411058744314908, 2.7388973206810006],
            [-1.436220701665952, 2.741409129254212],
            [-1.5155884668509578, 2.7434587434292674],
            [-1.5695338189157304, 2.745306819180123],
            [-1.5785886966349307, 2.7454476154528584],
            [-1.5839690114951563, 2.7455083655349086],
            [-1.5825392180575388, 2.781501882284226],
            [-1.5826506326339889, 2.784153736964279],
            [-1.5809738662291086, 2.832654309229124],
            [-1.5789590107793352, 2.9055687538428616],
            [-1.576559431934729, 3.007092173008568],
            [-1.5753764049085102, 3.0504915272216278],
            [-1.5743619302756096, 3.0938735565700424]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.52119302257879, "lat": 41.56744603370327 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31077"],
        "coty_name": ["Greeley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greeley County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00835860"
      },
      "bbox": [
        -1.5839690114951563, 2.736242590782824, -1.2328217781449495,
        3.0938735565700424
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.599141883284616, 4.307854333418603],
            [16.623002650232728, 4.300878155983547],
            [16.696987132502056, 4.277726629370518],
            [16.793775152734142, 4.2469608454644145],
            [16.855250125765608, 4.227187024259033],
            [16.861613442729684, 4.228558884927271],
            [16.863595181696823, 4.21321862649404],
            [16.862537906327454, 4.181577752365613],
            [16.862921523675787, 4.157341884315765],
            [16.862338982346962, 4.146605853318911],
            [16.860685568355123, 4.1162188869556156],
            [16.85929473750707, 4.1091981014845365],
            [16.852611213214338, 4.075477485943749],
            [16.850663097860256, 4.049998935219695],
            [16.841637561476716, 4.01768220366323],
            [16.834589386455498, 4.01974076100013],
            [16.833663036096716, 4.024146222973612],
            [16.819600005743332, 4.029895155402229],
            [16.81701634645647, 4.031544234889322],
            [16.816869481643625, 4.035783376270619],
            [16.811584895308904, 4.037128651859346],
            [16.810775263635303, 4.032084073835813],
            [16.8058078812175, 4.027822155664761],
            [16.803292615545217, 4.021445065436127],
            [16.800604986023078, 4.018270778429775],
            [16.785336076336126, 4.013236947403555],
            [16.782399379826238, 4.010448511737071],
            [16.779998434393676, 4.003956905168445],
            [16.77577810343761, 4.001119161619787],
            [16.774024867776617, 3.993577745189474],
            [16.769285426819916, 3.980363184276623],
            [16.773911247442644, 3.9674192086524713],
            [16.768530838079087, 3.9645266997442468],
            [16.765314680408864, 3.9688182042415483],
            [16.764403715612293, 3.9735479231422177],
            [16.758291351973174, 3.976907507837159],
            [16.755292163691944, 3.9768941166055622],
            [16.7492541566065, 3.969844902265491],
            [16.74365432391982, 3.9674735337849634],
            [16.739906216118303, 3.973027117186486],
            [16.725301934560214, 3.978840087886092],
            [16.729333718132295, 3.991901068216439],
            [16.726773357627263, 3.9986413016350797],
            [16.72576613617384, 4.006606978540185],
            [16.726435173820988, 4.011974954724375],
            [16.730410045310993, 4.014593029594856],
            [16.7343497130176, 4.018485429822914],
            [16.733929008957798, 4.028972761086123],
            [16.730459218758035, 4.03400771643649],
            [16.73102181800662, 4.046856065097444],
            [16.728150555807744, 4.052975016465946],
            [16.73304487277652, 4.0562869794272585],
            [16.73724755031527, 4.05274852562305],
            [16.738318794603547, 4.057111318768908],
            [16.73690878478688, 4.060831689859403],
            [16.733789915043726, 4.062335984976792],
            [16.72803947582776, 4.071125716403374],
            [16.722589316747353, 4.075806611698634],
            [16.715369417538287, 4.078426350342867],
            [16.71431010186931, 4.087919909427758],
            [16.71061951032498, 4.089663034424801],
            [16.708971593524776, 4.094736772565535],
            [16.70950082462951, 4.098298436202922],
            [16.706518032191635, 4.1050643108242335],
            [16.707789794305175, 4.112905682108433],
            [16.705143005780158, 4.114577497560394],
            [16.700196991496224, 4.114213451442846],
            [16.696140055181555, 4.119842039270764],
            [16.69608425300904, 4.126494783276476],
            [16.692633054334298, 4.130374388496676],
            [16.689025214121585, 4.131378972044481],
            [16.688692063299705, 4.156100478176709],
            [16.663350946731942, 4.168319662616562],
            [16.664289343518817, 4.161476225448382],
            [16.624390184062577, 4.156559954336122],
            [16.604423061648575, 4.163061536419516],
            [16.588354582907748, 4.1798693195720436],
            [16.581243624947405, 4.184361149421911],
            [16.587300375369438, 4.230039797725599],
            [16.599141883284616, 4.307854333418603]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.07418803945907, "lat": 40.95961509253147 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34003"],
        "coty_name": ["Bergen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bergen County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00882271"
      },
      "bbox": [
        16.581243624947405, 3.9645266997442468, 16.863595181696823,
        4.307854333418603
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.235155967092576, -5.546801506514677],
            [-9.11572833301715, -5.561279020748454],
            [-8.978351383473436, -5.577833919309258],
            [-8.9878040980821, -5.664452848816675],
            [-8.987186794060749, -5.66452319389295],
            [-8.990396467218806, -5.689309157309311],
            [-9.020570717609184, -5.937925663985535],
            [-9.02317435381016, -5.960630531018764],
            [-9.029400561399875, -6.010653355647341],
            [-9.0399754127654, -6.097324495478888],
            [-9.03933669888058, -6.100157773248884],
            [-9.073916250019852, -6.3936237660253585],
            [-9.179554311684726, -6.3811800024918695],
            [-9.36248227336575, -6.359014014706789],
            [-9.457215397375045, -6.347318302790261],
            [-9.551946865764988, -6.335609086447188],
            [-9.69572777298454, -6.317428454831606],
            [-9.839504771845418, -6.299216675127125],
            [-9.840835622626457, -6.298945138082704],
            [-9.836115804144674, -6.262502641600498],
            [-9.8420919211621, -6.261759196718669],
            [-9.83647674412926, -6.218515008063317],
            [-9.808541816451157, -6.004791956743833],
            [-9.819400354678434, -6.003388349139572],
            [-9.802866200447678, -5.87721134698767],
            [-9.765102023632426, -5.5870827072651705],
            [-9.762525620366905, -5.570029175910065],
            [-9.722641229489989, -5.574990586151212],
            [-9.580567792643823, -5.592974001758948],
            [-9.508286372455464, -5.601770218296311],
            [-9.497535026307984, -5.515383854349824],
            [-9.36846831463355, -5.5309843724524415],
            [-9.239399239443237, -5.546564359975229],
            [-9.235155967092576, -5.546801506514677]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -107.74985909921828, "lat": 32.1822512688506 },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35029"],
        "coty_name": ["Luna"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Luna County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00933057"
      },
      "bbox": [
        -9.8420919211621, -6.3936237660253585, -8.978351383473436,
        -5.515383854349824
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.98230660905448, 4.114881673304354],
              [16.98817231982564, 4.112263720853905],
              [16.98582489190382, 4.102920705181521],
              [16.98230660905448, 4.114881673304354]
            ]
          ],
          [
            [
              [16.96876591328642, 4.107432043520456],
              [16.972282545372888, 4.106856162450975],
              [16.978187056984062, 4.100648136790827],
              [16.980465574080675, 4.09315498245033],
              [16.97768776083622, 4.091536723955469],
              [16.97154339892149, 4.099553418582561],
              [16.971692746140548, 4.102875916581046],
              [16.96876591328642, 4.107432043520456]
            ]
          ],
          [
            [
              [16.862338982346962, 4.146605853318911],
              [16.90933789981659, 4.139805699940777],
              [16.910229205263168, 4.145996608716365],
              [16.914430444031765, 4.148365899279503],
              [16.92158632823073, 4.1466262975107275],
              [16.926115113930315, 4.137244599285688],
              [16.93756609856796, 4.135621195392247],
              [16.937840942643426, 4.137064416871043],
              [16.96174569417508, 4.134624115502771],
              [16.96097555473412, 4.131552727379181],
              [16.968076318210002, 4.131406409261535],
              [16.968292075142486, 4.127060325116886],
              [16.97087777370009, 4.123012274495252],
              [16.9664000231198, 4.120832426705944],
              [16.96614644394902, 4.108933540215232],
              [16.964272603559937, 4.105102599048602],
              [16.959950343115135, 4.1044895137140465],
              [16.958475288941447, 4.111372930362819],
              [16.95536921383571, 4.109447058623246],
              [16.94976932638163, 4.1123848073430675],
              [16.94938488561922, 4.109065831350778],
              [16.95318521450407, 4.107103148174416],
              [16.954191613357867, 4.102881521525606],
              [16.951452631293904, 4.101302485572098],
              [16.954607139417792, 4.093450348541775],
              [16.953655400039082, 4.091908455738284],
              [16.957728369699943, 4.079618028508436],
              [16.961056603731354, 4.073527276864388],
              [16.965062518093468, 4.07533262708922],
              [16.968453007670814, 4.069207104955768],
              [16.97339440278031, 4.068579474544299],
              [16.97116775564188, 4.063652258862701],
              [16.972328987183232, 4.0616167330871225],
              [16.981221561083707, 4.05985183661314],
              [16.980254076371022, 4.053388035606668],
              [16.966570358723036, 4.055164059010245],
              [16.96201063886168, 4.054489025238304],
              [16.949710334896935, 4.047860358812904],
              [16.937297172242552, 4.042763619141417],
              [16.93064072111472, 4.038662228181319],
              [16.92692471520393, 4.030792670198778],
              [16.92599624611247, 4.02534757912017],
              [16.92229957648079, 4.023958445449755],
              [16.91461088970863, 4.023845676478401],
              [16.912236518142816, 4.026491628492754],
              [16.894857742651194, 4.028577323097729],
              [16.888692325724627, 4.03048911001282],
              [16.885670178399362, 4.0329517120118],
              [16.88255106628406, 4.032353269600896],
              [16.877269720891373, 4.037626296663903],
              [16.87491039187095, 4.0480676591948095],
              [16.870909118396906, 4.061266004681848],
              [16.871922091932625, 4.07422741929471],
              [16.875276956209156, 4.0865825865920495],
              [16.87805484273929, 4.0932768669888535],
              [16.880906274212304, 4.104759021943436],
              [16.88004528969545, 4.10808151359062],
              [16.876304717081286, 4.110184564163126],
              [16.874394371672803, 4.1059122859393895],
              [16.85929473750707, 4.1091981014845365],
              [16.860685568355123, 4.1162188869556156],
              [16.862338982346962, 4.146605853318911]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.8675226312176, "lat": 40.85007275189591 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36005"],
        "coty_name": ["Bronx"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bronx County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00974101"
      },
      "bbox": [
        16.85929473750707, 4.023845676478401, 16.98817231982564,
        4.148365899279503
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.34107876064715, 4.611228174705898],
            [12.356603508396525, 4.620763448174321],
            [12.39331123131562, 4.649335967529983],
            [12.417630585937216, 4.671051506864057],
            [12.438555287871539, 4.6916418974157175],
            [12.442180135008062, 4.69895584853053],
            [12.44580192274127, 4.701440318727323],
            [12.45252511648653, 4.703761262567777],
            [12.466172691551929, 4.715699523672161],
            [12.476840262892484, 4.728811269934049],
            [12.481052661681822, 4.730735751907862],
            [12.485801364438075, 4.737329733851197],
            [12.490429762374841, 4.740237869507271],
            [12.50325527733904, 4.753914187771249],
            [12.525607272306452, 4.780143692438701],
            [12.533853712414626, 4.784419825905461],
            [12.539771748932461, 4.789616976830735],
            [12.55440177747268, 4.809723115691244],
            [12.55633887011074, 4.8130908786272615],
            [12.55793045681554, 4.834444766306873],
            [12.56222161365142, 4.834686306538079],
            [12.567136219070724, 4.837318855928049],
            [12.574500382898568, 4.8472413755335335],
            [12.581799275871278, 4.853350722519336],
            [12.59369721549294, 4.869401984820756],
            [12.595607468462456, 4.88121655979985],
            [12.603730462625121, 4.884269203379945],
            [12.605776279679578, 4.8781665315668565],
            [12.614402891361944, 4.8819376403339],
            [12.61931012914014, 4.888789351219401],
            [12.621745478907423, 4.896903306142517],
            [12.62839807628131, 4.899691251405647],
            [12.635157955904997, 4.903904268201691],
            [12.637441257444651, 4.907213731962891],
            [12.648909400507138, 4.91076247194205],
            [12.65232732380482, 4.919496940192298],
            [12.656476320804032, 4.9242519084802066],
            [12.663722459554663, 4.929162359684889],
            [12.665745632787928, 4.934638770128409],
            [12.669507064975196, 4.93691737387042],
            [12.671608144745532, 4.935125170762018],
            [12.675192130148915, 4.936831832290983],
            [12.677637612071653, 4.943166847133562],
            [12.68114621174823, 4.941099454141447],
            [12.686516180655618, 4.945498078086454],
            [12.69646971903177, 4.950648334203299],
            [12.699636449415983, 4.95412049767675],
            [12.708297387543693, 4.957040381019418],
            [12.71253779853297, 4.963367751053106],
            [12.71559054603636, 4.960961231340258],
            [12.720245106161673, 4.961873391157984],
            [12.725774535829636, 4.967455874707239],
            [12.732602239708761, 4.96741423086093],
            [12.73461782183278, 4.969228422732799],
            [12.74001789636523, 4.981182271493064],
            [12.740277522698197, 4.986664064985879],
            [12.74910622947139, 4.983447866272399],
            [12.751559476946364, 4.984264305479718],
            [12.75605506910466, 4.989736103004942],
            [12.760617370439705, 4.990710182693965],
            [12.764104430749839, 4.989284945421089],
            [12.763434548429073, 4.98500430548323],
            [12.767207299546344, 4.9839388846668005],
            [12.770794062998602, 4.986711915842138],
            [12.772326698253385, 4.983427498840317],
            [12.776724538659133, 4.979094780030502],
            [12.78120712961086, 4.980593672711385],
            [12.78322841052513, 4.978156778664053],
            [12.779244796018041, 4.975466773029764],
            [12.783221734777284, 4.97048324095653],
            [12.78735506912939, 4.970575256878064],
            [12.800803430923875, 4.964961303031986],
            [12.80505916238806, 4.940436717130928],
            [12.816739326382965, 4.874943146598794],
            [12.834769512826842, 4.7773745909558825],
            [12.850593193400936, 4.691109225421314],
            [12.854024889443068, 4.673590254251619],
            [12.86782387248334, 4.598508016510396],
            [12.88254531324091, 4.519762278428555],
            [12.896577580779935, 4.43305275806662],
            [12.811345848766242, 4.418002727569611],
            [12.75973907517958, 4.408155669377745],
            [12.663865587947312, 4.3908670830819405],
            [12.598018203730179, 4.379072203781372],
            [12.550020841275092, 4.370959577558588],
            [12.497319793512606, 4.362258053009725],
            [12.45415554271507, 4.355128126029702],
            [12.387857959324206, 4.3434164872075876],
            [12.384129310538132, 4.363130614057905],
            [12.367081129950476, 4.462033817217496],
            [12.364683105776251, 4.474106924056771],
            [12.359565954867294, 4.505242574709046],
            [12.34552149749032, 4.584694094908852],
            [12.34107876064715, 4.611228174705898]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.36632542238998, "lat": 42.22813451559912 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36013"],
        "coty_name": ["Chautauqua"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chautauqua County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00974105"
      },
      "bbox": [
        12.34107876064715, 4.3434164872075876, 12.896577580779935,
        4.990710182693965
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.025472082777613, -1.7489898236260237],
            [15.030813488263917, -1.7449788332806535],
            [15.038721412085584, -1.7483855784391915],
            [15.074182941684207, -1.7081338268168982],
            [15.108935702093548, -1.6640331594269613],
            [15.113674655860581, -1.6635791556821242],
            [15.118796748999637, -1.6650375925686638],
            [15.123881656257511, -1.669368048875729],
            [15.127619189389192, -1.6744944657159448],
            [15.126849951397874, -1.679133245002406],
            [15.128170196597907, -1.682410754065061],
            [15.13594124495822, -1.6886233143382874],
            [15.145563555287373, -1.6908441088357957],
            [15.171723242389287, -1.7129527247370175],
            [15.180833520598492, -1.7202768984403176],
            [15.184877595878078, -1.7210814917316992],
            [15.19691861706464, -1.7339741343340174],
            [15.20139416951769, -1.7330645723491838],
            [15.211129329348768, -1.7346510192813374],
            [15.21723456189231, -1.7382340010892334],
            [15.222432354028511, -1.743297798078752],
            [15.23167664684492, -1.7463462241126815],
            [15.234092392917097, -1.751104425985283],
            [15.24297897673965, -1.7599045466870022],
            [15.24701179456814, -1.7609089924141341],
            [15.250938504901665, -1.7589699359700435],
            [15.25836393887641, -1.7573799240695],
            [15.260057564305566, -1.7589268181033515],
            [15.266799605280223, -1.7584200619540797],
            [15.271806030845463, -1.7595349599105188],
            [15.274840557053391, -1.763972192873745],
            [15.273660466383529, -1.768528553530135],
            [15.279286404824356, -1.7694492342467085],
            [15.289509983725095, -1.766417391869702],
            [15.290659891592984, -1.774434416620036],
            [15.288897191703452, -1.7768260370909397],
            [15.291641619356739, -1.7799097010714249],
            [15.28820250922895, -1.7870522131246311],
            [15.292772591874602, -1.7905677696825344],
            [15.295246670063573, -1.7906847848892418],
            [15.30207383857982, -1.8033296521541864],
            [15.30631745013307, -1.805070117429233],
            [15.30687890288743, -1.8088580806537933],
            [15.311141411269485, -1.8136812536823796],
            [15.310586208221988, -1.8206289308994545],
            [15.31614209207427, -1.8230836992839186],
            [15.317892777030238, -1.8277461122420866],
            [15.321114109418797, -1.8299856716797585],
            [15.321643855452574, -1.8330397406314765],
            [15.326329184256398, -1.8340262410821304],
            [15.325478937370615, -1.8406364896030063],
            [15.329512593419128, -1.8398838378546984],
            [15.328995999627535, -1.8482793859664055],
            [15.330967056888321, -1.852390325240478],
            [15.326041943458812, -1.8573292656817675],
            [15.32862539748876, -1.864338086571965],
            [15.326891222774481, -1.8665435097489547],
            [15.320331201001968, -1.8698513799831902],
            [15.317026044275284, -1.8696590237290482],
            [15.312292368460497, -1.864532130328335],
            [15.304722884825866, -1.8628443278126823],
            [15.297928011328741, -1.8691501294423758],
            [15.297309070355334, -1.8714702239004357],
            [15.291509001869066, -1.8728252600461182],
            [15.292293094388878, -1.8778978344618933],
            [15.289850558714331, -1.882905207815823],
            [15.291262542692909, -1.8860784054446789],
            [15.290045865028736, -1.8897942810327142],
            [15.285227486604814, -1.8929768408610101],
            [15.270516972316262, -1.9047580150689651],
            [15.26842256538739, -1.9084235770215296],
            [15.263224414247425, -1.9112328941969132],
            [15.260228450380083, -1.9142653115014034],
            [15.25358834178036, -1.9158657852209944],
            [15.251048862399701, -1.9224640735084506],
            [15.24588065535183, -1.9216081480866942],
            [15.239762160871903, -1.923237570969966],
            [15.23595020654399, -1.9195312082359257],
            [15.230437346776847, -1.9225978712981557],
            [15.23012234234963, -1.9253144724709421],
            [15.222558689894361, -1.934909378751625],
            [15.219224444002318, -1.9415883373657485],
            [15.216724309312287, -1.9490223471062922],
            [15.207975131975362, -1.9498890944083407],
            [15.204481803562977, -1.953431749123573],
            [15.200612953359418, -1.9527214580076746],
            [15.195365044579601, -1.9557772069154111],
            [15.191544034453315, -1.9597795944866958],
            [15.184767479376339, -1.9623931169695312],
            [15.18191470084128, -1.9606546487094527],
            [15.179162642796747, -1.9563303484527519],
            [15.1729455126395, -1.9507595340997892],
            [15.172789916310679, -1.9474009222740845],
            [15.169321653795738, -1.9465936224044325],
            [15.165927754157952, -1.941418171486084],
            [15.164585463269113, -1.9359393934016937],
            [15.10281126455197, -1.9576398327998554],
            [15.079924203043715, -1.9609567992143544],
            [15.081828084794846, -1.9563525585451544],
            [15.082394913167064, -1.946584444201391],
            [15.076721709891874, -1.9343184686200716],
            [15.07305103805367, -1.9224900436908408],
            [15.06671277667504, -1.9180480950804677],
            [15.061603291098866, -1.9165209567849812],
            [15.057496437132409, -1.9114359055479195],
            [15.053050041046955, -1.9093270476482267],
            [15.043917444433667, -1.8562311862505154],
            [15.025472082777613, -1.7489898236260237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.67574023072933, "lat": 35.48502845394145 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37079"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01008557"
      },
      "bbox": [
        15.025472082777613, -1.9623931169695312, 15.330967056888321,
        -1.6635791556821242
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.82326534287781, -2.526234069282279],
            [13.82650509572682, -2.532147105387233],
            [13.833583909805743, -2.541358957741318],
            [13.840692854449486, -2.5448133329753286],
            [13.849360701719355, -2.5460776850144744],
            [13.852671961906545, -2.550716851487706],
            [13.864902033508116, -2.5604459393452585],
            [13.869525135654577, -2.560767257915999],
            [13.879920989633478, -2.5657960960909416],
            [13.882027331469772, -2.5689135334703352],
            [13.888196514247847, -2.5738425017050277],
            [13.896477297090394, -2.5820304906387683],
            [13.899356563759255, -2.5823796969381383],
            [13.903297354589256, -2.586952052476621],
            [13.910827798726052, -2.593839914050698],
            [13.916495433238282, -2.597843746000842],
            [13.91525014487107, -2.601806321101035],
            [13.923458064442991, -2.6090246804442287],
            [13.926158204956641, -2.6144261618379807],
            [13.924936990685165, -2.6218671445972834],
            [13.927020127725466, -2.6275453735063925],
            [13.931351689718454, -2.631256627348489],
            [13.9324838720747, -2.644763547605583],
            [13.936464151476795, -2.6519628946804628],
            [13.93579492631592, -2.6544598089790816],
            [13.93890939376409, -2.6642049562950425],
            [13.938573180297594, -2.665705852333581],
            [13.945997394648085, -2.678537150246225],
            [13.945985837121729, -2.6822332859108475],
            [13.948469398527001, -2.6883892848408615],
            [13.952399918977031, -2.692465192748203],
            [13.95378490882004, -2.6975212970460003],
            [13.95317327727061, -2.7009930932217703],
            [13.947129309973404, -2.709805955841401],
            [13.947957356367402, -2.7140633248469386],
            [13.946099729445843, -2.7179566969785274],
            [13.946718650842193, -2.7251775527046136],
            [13.945572730862484, -2.7307718643473913],
            [13.943343789796998, -2.733544022356451],
            [13.945978687888312, -2.7382347546656636],
            [13.949444644917566, -2.7401056975705784],
            [13.95217489577, -2.743829136056835],
            [13.951985419334775, -2.7473189603135135],
            [13.954363786072449, -2.7514584491028793],
            [13.959705820287759, -2.757465220494442],
            [13.961711907645723, -2.7622820312318095],
            [13.964557325110292, -2.7630756754313093],
            [13.969529718821596, -2.7728244840946603],
            [13.972452751832785, -2.7767760652696434],
            [13.948977570223976, -2.8241579166127706],
            [13.893181795155648, -2.936684346493202],
            [13.883910615555259, -2.931255327531762],
            [13.876419589197804, -2.9249631859305856],
            [13.866063095900914, -2.9173948366198053],
            [13.805305150973139, -2.8743056051237583],
            [13.798515305285104, -2.869732026222728],
            [13.732564923840552, -2.823109789051489],
            [13.69128321028691, -2.7935645327073],
            [13.677085088250877, -2.7957887359303073],
            [13.679642730631961, -2.7888380203083787],
            [13.687077035677806, -2.7849091517433875],
            [13.691092854669492, -2.784860467317002],
            [13.702461604944919, -2.780874690744253],
            [13.706221286181115, -2.7806120053984014],
            [13.712945555527133, -2.774272224541489],
            [13.718544578918662, -2.7702269298691258],
            [13.720372871080068, -2.7673064933357243],
            [13.725520471265984, -2.771513669194057],
            [13.732032924540588, -2.7745345616733057],
            [13.72948093737528, -2.7643701719464815],
            [13.73173601845054, -2.7597342270391483],
            [13.73030876208263, -2.7558539854689483],
            [13.73178562069778, -2.751225420197853],
            [13.726758523948318, -2.7477593776451075],
            [13.728306528687122, -2.742316867485786],
            [13.7221689777471, -2.739603940044795],
            [13.728272601157599, -2.7245927484383046],
            [13.74114832953562, -2.706604801484313],
            [13.763961149383078, -2.6729518859744483],
            [13.760302366864057, -2.672185193383323],
            [13.760936031243542, -2.665711778914304],
            [13.7557533965001, -2.656844544510683],
            [13.748243297150779, -2.655705012922761],
            [13.743691724361657, -2.6508268857246304],
            [13.739520415139706, -2.6413857000569876],
            [13.740329031875342, -2.638967328141631],
            [13.737232865813924, -2.6322122509407597],
            [13.739828595635357, -2.6295979471065514],
            [13.738624248892485, -2.622943622074498],
            [13.741236757988883, -2.6171701828185077],
            [13.740278565307886, -2.613640150785346],
            [13.744207728941612, -2.610642650018481],
            [13.748124177409164, -2.6050830893096326],
            [13.740498068089945, -2.59332725019157],
            [13.743026523594304, -2.5917203105431623],
            [13.754627530492783, -2.578010296876535],
            [13.777580053601941, -2.559111713576541],
            [13.782813145267282, -2.552771371059485],
            [13.788798871630148, -2.548883636303263],
            [13.805380072442334, -2.539561551491492],
            [13.813515391068906, -2.5364565828382246],
            [13.822037104946729, -2.5292540034318285],
            [13.82326534287781, -2.526234069282279]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.48038783631142, "lat": 34.84086933714393 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37165"],
        "coty_name": ["Scotland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scotland County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "01008585"
      },
      "bbox": [
        13.677085088250877, -2.936684346493202, 13.972452751832785,
        -2.526234069282279
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.10375820597945, -1.1721749571195361],
            [16.113033200045404, -1.166452385647186],
            [16.11615445933566, -1.1618296516082625],
            [16.118899576570392, -1.162841626821036],
            [16.12728255937602, -1.1628685052432568],
            [16.135013387718853, -1.1616426109602505],
            [16.142013074896653, -1.153228328007597],
            [16.14222671959316, -1.1496118127849664],
            [16.159204145324637, -1.1293785806130454],
            [16.16260330542964, -1.1260256417338015],
            [16.168969286691386, -1.1239514714790708],
            [16.17018103289472, -1.1195303344007006],
            [16.179345885240835, -1.116806943006256],
            [16.189960219858172, -1.110800517807536],
            [16.190292200455975, -1.1077553226712906],
            [16.196378842825712, -1.1070666334486174],
            [16.20625962731276, -1.1022052799341275],
            [16.207936204234812, -1.0990739825656854],
            [16.219002602782645, -1.0934775721344645],
            [16.224460261583243, -1.0934009487259178],
            [16.23830793660225, -1.088886320336784],
            [16.24038065031492, -1.0848769568117755],
            [16.244897476565654, -1.0808215168515587],
            [16.25660933075725, -1.0796555165661055],
            [16.26225242183207, -1.0768734118342738],
            [16.275681315075428, -1.07958110184825],
            [16.285490200096042, -1.0753172096124113],
            [16.299614724997973, -1.072119959453076],
            [16.319376844942568, -1.0706962448499906],
            [16.320866542144373, -1.068198400660869],
            [16.33038233905541, -1.0665685669009357],
            [16.33785940922658, -1.0687464692363797],
            [16.35507659666354, -1.0763890271847536],
            [16.36424114372249, -1.0809845628450467],
            [16.372164288732286, -1.0866230976214788],
            [16.378149418294207, -1.094095450079738],
            [16.375427143631313, -1.095719537280646],
            [16.375643842953266, -1.117064889764091],
            [16.380922355293542, -1.121696904751852],
            [16.383841774132982, -1.1262368213594511],
            [16.380638289680707, -1.1295028611253546],
            [16.379065321518024, -1.134008721313736],
            [16.373881674937476, -1.1398808336298083],
            [16.375916001962704, -1.145627990267472],
            [16.372468611098466, -1.1497150186972445],
            [16.368102569553127, -1.1575981052735458],
            [16.366144050071135, -1.1685444886844505],
            [16.368662344203656, -1.1827056954485722],
            [16.36072146058808, -1.1925476333088647],
            [16.358704546290642, -1.2022003525016371],
            [16.3607203185732, -1.2066763953451987],
            [16.361758650208294, -1.2129944660012542],
            [16.361112345179855, -1.2218775375569126],
            [16.364340771922723, -1.226955713937616],
            [16.36467125910071, -1.231258081560808],
            [16.36720268355704, -1.2348938973163521],
            [16.37267396449735, -1.2394943783879147],
            [16.37423179219299, -1.2431392819203406],
            [16.37852378626544, -1.2461998129981409],
            [16.37978680875739, -1.251297964588815],
            [16.37840081480243, -1.2553758127206291],
            [16.382996806075056, -1.277865320735139],
            [16.384062674529222, -1.2929551447514849],
            [16.3888872557391, -1.299090458780927],
            [16.39256658961504, -1.3062658280032373],
            [16.394871104798913, -1.3145209610330488],
            [16.393373861934936, -1.319227769093748],
            [16.39384250205171, -1.3250981103964166],
            [16.392098684781157, -1.3334302084691452],
            [16.389259483005755, -1.3366225244089982],
            [16.39390571428768, -1.345585716539623],
            [16.39689695374819, -1.3495273650104471],
            [16.399858322666628, -1.3469060577463137],
            [16.402687002512163, -1.3500869210562465],
            [16.406363289063943, -1.3499009754189895],
            [16.40963037528483, -1.3569696711906902],
            [16.414493857487628, -1.3605118833515983],
            [16.413667672512453, -1.3755552308811305],
            [16.41203903169004, -1.3783601269509311],
            [16.41241094558143, -1.3845344096218994],
            [16.40131161673881, -1.3782075742333848],
            [16.397812594066725, -1.37769724507565],
            [16.391655585569822, -1.3816540374645208],
            [16.386327119988607, -1.3833836657909269],
            [16.37990569213289, -1.381686086726503],
            [16.377337506396728, -1.3832015009662304],
            [16.37412899470075, -1.3883634702828638],
            [16.368273877357556, -1.3882327954078435],
            [16.365379141013257, -1.383306567487616],
            [16.35991129183379, -1.3817225151007977],
            [16.355090893326235, -1.3839329021508664],
            [16.350136999916874, -1.382290662931116],
            [16.349205038760743, -1.379680325528535],
            [16.349998531967696, -1.3726055699082749],
            [16.344753522967814, -1.3705144369833164],
            [16.34023881653686, -1.3738863213708281],
            [16.332848930586763, -1.3660959876762024],
            [16.32868779896973, -1.3639700465241005],
            [16.32267873756223, -1.3684836135710554],
            [16.312231607925792, -1.3745230703550786],
            [16.308506463586834, -1.3722347049933492],
            [16.306019950888132, -1.3740695399764182],
            [16.30952056751848, -1.3806817341648279],
            [16.30420208907574, -1.3816041661189813],
            [16.30458388089738, -1.386116030117691],
            [16.308615278624142, -1.388741969080813],
            [16.306968456463544, -1.3922374658001901],
            [16.308319611218273, -1.3950047012986235],
            [16.31243748894466, -1.397341035811923],
            [16.30805993831565, -1.3999966323991007],
            [16.308576841564836, -1.4042921556920585],
            [16.304803661003422, -1.4074454326992871],
            [16.31013774649011, -1.4169753724958383],
            [16.30592008378964, -1.424784004282603],
            [16.300273149343823, -1.4281525441137695],
            [16.299663723889733, -1.433478835457035],
            [16.301124951418906, -1.4389509351774832],
            [16.29800233311549, -1.4413451199722653],
            [16.300246040505783, -1.4439856084185652],
            [16.30319590137274, -1.4545887846367949],
            [16.299753219898196, -1.460383701415216],
            [16.30039203398561, -1.4630777379911277],
            [16.2958247612308, -1.4752255174808613],
            [16.293649328002097, -1.47898912710459],
            [16.288220194122747, -1.4795982892849315],
            [16.28360513892704, -1.477572413744048],
            [16.28096574551457, -1.4802489265367458],
            [16.27028198368337, -1.479243798804533],
            [16.266798704284934, -1.4804121894390887],
            [16.261248298006972, -1.4788389574488974],
            [16.259076897763453, -1.4807572325972975],
            [16.251911624857083, -1.482792353769923],
            [16.247497504808603, -1.4788553813547516],
            [16.242463827744814, -1.4828033762039328],
            [16.238616648052346, -1.4824276139590606],
            [16.235511329013693, -1.485000296423431],
            [16.22509036880917, -1.4824885837592483],
            [16.230648076997703, -1.3970723968057113],
            [16.192518562224553, -1.4027264799685426],
            [16.121539496399205, -1.4129303690140702],
            [16.103503546883548, -1.3252673426230586],
            [16.12891961355956, -1.242629236028556],
            [16.120724252213854, -1.2296373263225207],
            [16.11173258446383, -1.2236216931570905],
            [16.105705812498044, -1.2083961404304402],
            [16.097087505958257, -1.194285022668016],
            [16.10353064904877, -1.1772101324800146],
            [16.10375820597945, -1.1721749571195361]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.20893266578518,
          "lat": 35.817161791659686
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37177"],
        "coty_name": ["Tyrrell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tyrrell County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "01026332"
      },
      "bbox": [
        16.097087505958257, -1.485000296423431, 16.414493857487628,
        -1.0665685669009357
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.37752628206303, 7.775333881681328],
            [-4.32862171799721, 7.772638608631247],
            [-4.318952081442849, 7.772058005218713],
            [-4.241893219218158, 7.766436707275164],
            [-4.155234987163844, 7.761326868187503],
            [-4.062188336721082, 7.755244083232634],
            [-4.033529293244755, 7.753620481649489],
            [-4.038448330700446, 7.677350025046255],
            [-3.997944502693365, 7.674688495660052],
            [-3.9964044603248285, 7.674369852746255],
            [-3.909376228404104, 7.668407931023459],
            [-3.7797551144180295, 7.659684769810556],
            [-3.693038043171647, 7.6542406142816874],
            [-3.6986430652232074, 7.568494413037555],
            [-3.7028851055917285, 7.504109523245269],
            [-3.7100150584209572, 7.396696546065375],
            [-3.711368907281353, 7.396739336652239],
            [-3.8338662231163085, 7.404638401539142],
            [-3.938922568573945, 7.411684564118803],
            [-4.041562503738933, 7.418925170122712],
            [-4.093615117153223, 7.422301316053969],
            [-4.1635072995445785, 7.427554600282923],
            [-4.200517123576962, 7.429762245948918],
            [-4.279031371380885, 7.435308261508162],
            [-4.3652349745489465, 7.441528250135048],
            [-4.402154223408948, 7.444291684756747],
            [-4.401227383273899, 7.45909277669072],
            [-4.390427246853287, 7.601949046636455],
            [-4.389499765697552, 7.615877283638182],
            [-4.383091444139896, 7.701479123527795],
            [-4.37752628206303, 7.775333881681328]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.52844283244214,
          "lat": 46.09680529585017
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01034210"
      },
      "bbox": [
        -4.402154223408948, 7.396696546065375, -3.693038043171647,
        7.775333881681328
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.847807648242572, -0.33942552844489365],
            [3.8449123427441707, -0.2698965197197636],
            [3.8438850206527646, -0.24985097995587047],
            [3.840225000107093, -0.142254721680463],
            [3.83957118782714, -0.120782166779375],
            [3.83788437627905, -0.08312107793882582],
            [3.8363680136995355, -0.04321342079069709],
            [3.834669758296946, 0.008379719259212378],
            [3.834091591766943, 0.016337600668799992],
            [3.83328575268683, 0.05190938047316758],
            [3.8319623082079795, 0.07962847817188055],
            [3.843842037006171, 0.07707965831263001],
            [3.851092377248105, 0.07316150294042581],
            [3.858705089791817, 0.06708146270311868],
            [3.8736668292296783, 0.05971374466116215],
            [3.882757593240815, 0.058780104319605044],
            [3.8966947434024615, 0.05517700259454056],
            [3.9066241917110642, 0.05589174180895701],
            [3.923528739221986, 0.06816895801625318],
            [3.9387442652849525, 0.07572029831347779],
            [3.938518679623407, 0.08367019359955212],
            [3.9427383276710564, 0.09053075318241231],
            [3.9471857854568393, 0.09360254213587646],
            [3.951378826483647, 0.09482576635652253],
            [3.9559473272591057, 0.09344085454993943],
            [3.9615030836531724, 0.08955990573925977],
            [3.9690063758485223, 0.09040423597938596],
            [3.9729459480409415, 0.0887406152118799],
            [3.984195188825455, 0.09222324737286228],
            [4.002852704649933, 0.09372340244314911],
            [4.01312156456066, 0.09365439261880443],
            [4.021082087243485, 0.09279753598651329],
            [4.041533109103222, 0.08503126734830747],
            [4.042680618512741, 0.07379910780547812],
            [4.043789078076928, 0.051023082531764324],
            [4.045448050051533, 0.010129225939773296],
            [4.048991941492534, -0.046137768220633],
            [4.049358547350701, -0.061856588079109674],
            [4.051395177404626, -0.10652710622285576],
            [4.051956715481801, -0.10649163085123879],
            [4.053521566065704, -0.13583675322954664],
            [4.056370686713843, -0.1963324604353015],
            [4.057102392990247, -0.19668195237675076],
            [4.061295094214186, -0.2858731095603118],
            [4.062538339498208, -0.2858336797684066],
            [4.064385486808833, -0.33251812953693094],
            [4.064269273564959, -0.33466609367455596],
            [4.065966028719548, -0.375249474428184],
            [4.06693987687601, -0.4086860070182197],
            [4.026982193083683, -0.4102309806545534],
            [4.02227515892401, -0.4089323408793711],
            [4.010486424029892, -0.41079231254325066],
            [3.9870456184904355, -0.4114095848873895],
            [3.9364255655471756, -0.4137286880436138],
            [3.9399303062100843, -0.47254304118189905],
            [3.904241551656701, -0.47401024450665497],
            [3.897005363679323, -0.4738856620807014],
            [3.865078601018698, -0.4750883905111885],
            [3.853917017744096, -0.47543928738132246],
            [3.850628226320177, -0.40074684823402196],
            [3.847807648242572, -0.33942552844489365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.50793723743801, "lat": 38.44084828235518 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29073"],
        "coty_name": ["Gasconade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gasconade County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00758491"
      },
      "bbox": [
        3.8319623082079795, -0.47543928738132246, 4.06693987687601,
        0.09482576635652253
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.906334520175094, 0.02296557618529653],
            [2.9063365943406385, 0.023949675653757822],
            [2.979388491188431, 0.024987321184203163],
            [2.993750468561308, 0.026029348737524553],
            [2.993772403870551, 0.025078365030150426],
            [3.064477018967485, 0.02482652416525595],
            [3.0785310122476948, 0.024893167840868185],
            [3.078394066016803, 0.039491300263414846],
            [3.09357626059795, 0.08362436317148275],
            [3.1092239667936865, 0.1282220883911739],
            [3.114194246356926, 0.14152223952453685],
            [3.1457257886379906, 0.23105513753284282],
            [3.159999228262063, 0.2696939928516089],
            [3.161290956715387, 0.2724725666071904],
            [3.166934962112896, 0.2681574637748185],
            [3.1685349714305215, 0.2654673987069413],
            [3.1765695604654645, 0.2586851504305044],
            [3.1806294882035484, 0.25248759851299796],
            [3.180062096847744, 0.2461396213818486],
            [3.1767218984771795, 0.23184230668483707],
            [3.1789350539921712, 0.22465065002246773],
            [3.1863406846355207, 0.21938062535745842],
            [3.1956961355791877, 0.21129226760742476],
            [3.201096654441743, 0.20072107835446715],
            [3.205664865431309, 0.1895117878522116],
            [3.2097454049142935, 0.18259379558976221],
            [3.2160176355115286, 0.176486772568271],
            [3.224623133517384, 0.17144011624022445],
            [3.2279786494855838, 0.17067238203314009],
            [3.2430822503213954, 0.17221463142865434],
            [3.2481685317626865, 0.17146598240109778],
            [3.2531542308926387, 0.1682100010112872],
            [3.255794339619917, 0.1614840281574307],
            [3.257430495643729, 0.1528000137724696],
            [3.255705880244221, 0.14417587861842046],
            [3.252841494520599, 0.13696648254537694],
            [3.249562930173634, 0.13283342179631796],
            [3.2388804558208064, 0.12600702008869327],
            [3.236239252162761, 0.12180272045913787],
            [3.235815249557775, 0.11580691870712469],
            [3.238264442575305, 0.10415415308846236],
            [3.2414492671161, 0.097139924148448],
            [3.2480005381659804, 0.09085873465402665],
            [3.244607266932882, 0.07397774792997318],
            [3.2226298696306324, -0.033257766749447824],
            [3.2145155971802857, -0.07146346761333412],
            [3.186976783100706, -0.20373048356503637],
            [3.1821482868332094, -0.22616438895346275],
            [3.178271039010174, -0.2264093846016134],
            [3.0812519323639607, -0.2268377958987826],
            [3.0112973426956526, -0.16158485349115598],
            [3.002459883464143, -0.153183743010798],
            [2.9076875623084564, -0.06507008133060545],
            [2.906334520175094, 0.02296557618529653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.58309199889408,
          "lat": 38.632775144513005
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29135"],
        "coty_name": ["Moniteau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moniteau County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00758522"
      },
      "bbox": [
        2.906334520175094, -0.2268377958987826, 3.257430495643729,
        0.2724725666071904
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5672373357207507, -0.6325926382690762],
            [3.5956169706594783, -0.6324263553927109],
            [3.6100218307734906, -0.63175443238412],
            [3.611767062817695, -0.6259063064629382],
            [3.611929077357738, -0.6184739687980549],
            [3.6151395871562038, -0.6046164424169589],
            [3.6185569371141173, -0.6005939714840332],
            [3.6220791053521064, -0.598708503778304],
            [3.6277301580157593, -0.5987502916653827],
            [3.633339613424943, -0.6093470975701695],
            [3.6413532715887507, -0.6046031709300396],
            [3.6494612914548172, -0.5964138334335696],
            [3.659240371307759, -0.591538323789132],
            [3.6624483149768685, -0.5909197389073381],
            [3.663714650397999, -0.5874942958739905],
            [3.684755798260653, -0.586566869116322],
            [3.7361534617107184, -0.58360371589744],
            [3.757667608534993, -0.5821716813668059],
            [3.774079472468287, -0.5805765533666458],
            [3.825394261776262, -0.5793268893555762],
            [3.8683764697124534, -0.578617345417568],
            [3.8675948666048674, -0.5513726559461821],
            [3.865078601018698, -0.4750883905111885],
            [3.897005363679323, -0.4738856620807014],
            [3.904241551656701, -0.47401024450665497],
            [3.9399303062100843, -0.47254304118189905],
            [3.9472179019700553, -0.4723617784363626],
            [3.9486019760883715, -0.5014207367251614],
            [3.9505232872742395, -0.5475445700473678],
            [3.9531596939550426, -0.6144395844501743],
            [3.9561803388513352, -0.6852450387265712],
            [3.958523846795986, -0.7538311738598054],
            [3.9615431987543643, -0.8390843556410523],
            [3.8900633370137068, -0.8412371307207255],
            [3.886184249792612, -0.8418222302450118],
            [3.8186043918026766, -0.8435789090471691],
            [3.776976497899729, -0.8451150824371989],
            [3.7445603599211736, -0.8466594213927899],
            [3.745012215467443, -0.8548695759765592],
            [3.748054049560426, -0.9344781351599764],
            [3.746902530985554, -0.9345259250775958],
            [3.7508694080884384, -1.0408559827976387],
            [3.708874124492436, -1.0426866738297793],
            [3.651736199374294, -1.0435069299568944],
            [3.6069285570627665, -1.0436541529535943],
            [3.5922915014127987, -1.0443691705737808],
            [3.5781404568995656, -1.04455775352455],
            [3.5742879256696023, -0.939319851258804],
            [3.575639691581591, -0.9390551526944826],
            [3.5748125803004944, -0.8956421064595537],
            [3.572663070432725, -0.8089955892676975],
            [3.5714011597334103, -0.7636990405830625],
            [3.571713529836271, -0.7636859621967779],
            [3.5701139371820614, -0.7160987920852457],
            [3.568700503634216, -0.6679686945374101],
            [3.5672373357207507, -0.6325926382690762]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.79233844468882,
          "lat": 37.877174528843625
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29161"],
        "coty_name": ["Phelps"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Phelps County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00758535"
      },
      "bbox": [
        3.5672373357207507, -1.04455775352455, 3.9615431987543643,
        -0.4723617784363626
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0669952553297026, -1.1863996061939266],
            [3.145196887245847, -1.186069567050655],
            [3.179805844786495, -1.1854115557570712],
            [3.196113916694621, -1.1863005620937197],
            [3.2387832468521114, -1.1861148917121096],
            [3.283261214151992, -1.1854213465040802],
            [3.3147844847616543, -1.185331512191578],
            [3.324078841501703, -1.184760808682307],
            [3.366151889106959, -1.1840574538388324],
            [3.3662814925323348, -1.1833451753395885],
            [3.4084833293922863, -1.1824007694073486],
            [3.411461814849756, -1.2788152435072286],
            [3.4126661068048985, -1.2843456840574947],
            [3.4139161002450757, -1.3137234692306632],
            [3.4154295164305957, -1.3579635980486056],
            [3.4165989636893928, -1.4024292709398898],
            [3.421168657842262, -1.4021832694226322],
            [3.421084502178673, -1.4070610050957406],
            [3.4234611962815946, -1.4983516801863146],
            [3.4245308587697956, -1.5264123315250713],
            [3.4256472179357838, -1.5992482375110564],
            [3.3966847830954228, -1.5997356195325345],
            [3.382886325430317, -1.5993086953485778],
            [3.296814866040692, -1.6012742497712762],
            [3.2476661206477586, -1.6027004170860244],
            [3.1933583189854664, -1.6035316822112646],
            [3.124389810786925, -1.6035629352618774],
            [3.0822180384934046, -1.6045373194907795],
            [3.0820870029659133, -1.5530949860884362],
            [3.0815900526784503, -1.5161994479346175],
            [3.080747698488735, -1.4065289933861553],
            [3.070232576544026, -1.4065270401821572],
            [3.0695240840901308, -1.3624424961913553],
            [3.0686125338455916, -1.3185709202876972],
            [3.069320621681635, -1.3185462570404152],
            [3.0686210212357556, -1.290024374612475],
            [3.0674358201658434, -1.2306292152256095],
            [3.067602223798129, -1.2158869904570095],
            [3.0669952553297026, -1.1863996061939266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.46872454201318, "lat": 37.27016016264532 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29229"],
        "coty_name": ["Wright"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wright County"],
        "coty_fp_code": "229",
        "coty_gnis_code": "00758567"
      },
      "bbox": [
        3.0669952553297026, -1.6045373194907795, 3.4256472179357838,
        -1.1824007694073486
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.642595220076045, -6.592939259457478],
            [7.772020145570573, -6.579740372860586],
            [7.80729775710853, -6.5761814249724075],
            [7.853771676136234, -6.571730058654283],
            [7.8583102386201, -6.570884728161883],
            [7.87204557409545, -6.570000816654447],
            [7.884274200321409, -6.57180196555991],
            [7.927444540519691, -6.567896654755067],
            [7.960417070200658, -6.564625877837689],
            [7.979699012166608, -6.562473517164253],
            [8.126518343626994, -6.546953837067859],
            [8.142737841763719, -6.5454442028998985],
            [8.151025926844845, -6.6224355445674155],
            [8.146330314843665, -6.623156690567039],
            [8.141201952788208, -6.627132022494756],
            [8.12831599269558, -6.631396603294844],
            [8.125100018705341, -6.634478339669873],
            [8.117443631132776, -6.639327344582253],
            [8.116718381497682, -6.643770673614157],
            [8.111912864663385, -6.64473257396916],
            [8.111179020114202, -6.646868600497541],
            [8.106465392835183, -6.649276544050245],
            [8.101991568692704, -6.649718335915312],
            [8.091221536516473, -6.655028458238621],
            [8.08911673033337, -6.659226780703174],
            [8.083999769695435, -6.663343759764521],
            [8.078852082790256, -6.662689444933038],
            [8.071577320911484, -6.668226618851619],
            [8.065066156626017, -6.670258132827655],
            [8.059023103989448, -6.670055639232784],
            [8.055208233498591, -6.672072953743102],
            [8.037575556942604, -6.669767045010917],
            [8.031928903905216, -6.668467239380631],
            [8.028626029945283, -6.676449048839322],
            [8.024892434335793, -6.68264527547137],
            [8.025477800806797, -6.694507088802626],
            [8.029074960351336, -6.7048529247636806],
            [8.031682974797324, -6.709476422683012],
            [8.024957817353473, -6.717722268160188],
            [8.020176363901312, -6.718358207075646],
            [8.01364432892478, -6.722536520682339],
            [8.01038847549362, -6.730202671808514],
            [8.004198304501973, -6.737260918848081],
            [7.992962710541873, -6.738793880800816],
            [7.984670046426576, -6.742813853722036],
            [7.979916871173917, -6.747455149112495],
            [7.974473173009846, -6.748200855617243],
            [7.968239087736625, -6.750471951985567],
            [7.966111526389216, -6.7676572249857045],
            [7.968871714467317, -6.778427652756356],
            [7.966750750019488, -6.785737119579198],
            [7.967006154289804, -6.792585400336548],
            [7.964896278125622, -6.806114036716488],
            [7.959752171548973, -6.813513583007308],
            [7.957998262074554, -6.8175083008840245],
            [7.955201852339196, -6.828068913564883],
            [7.954258551988085, -6.834874854700478],
            [7.956086860792717, -6.843575582907376],
            [7.955502875898179, -6.846732463987648],
            [7.951824045353166, -6.850422103293611],
            [7.950679822218214, -6.859865009428748],
            [7.953845323413903, -6.8732205766391585],
            [7.941854833285259, -6.897426647990235],
            [7.938171976283345, -6.907391178175695],
            [7.933598755051646, -6.911637828091443],
            [7.930420460614869, -6.918489005814875],
            [7.931553129008564, -6.924129731327398],
            [7.927378192164916, -6.931728840258429],
            [7.925576190977059, -6.937663708535903],
            [7.9233664836351325, -6.939978957989867],
            [7.909573459128169, -6.943626779127567],
            [7.905936764487872, -6.945168885619271],
            [7.902643232036335, -6.95130181691952],
            [7.898965109278179, -6.954566600351656],
            [7.895237918560238, -6.961177029114108],
            [7.875960719852845, -6.980961179406992],
            [7.873739021498228, -6.98808839507692],
            [7.870920739595788, -6.9917618884454855],
            [7.8629673315588, -6.994828448510897],
            [7.853904878073896, -7.002386477485814],
            [7.849233542561279, -7.011339163409875],
            [7.847143008491498, -7.013510425027135],
            [7.84461158388263, -7.020422742400008],
            [7.837550515046482, -7.027310496110636],
            [7.833238166621586, -7.040434893052205],
            [7.828087831217458, -7.05077953323313],
            [7.823240015633462, -7.054673297130508],
            [7.816752935938243, -7.056569709279739],
            [7.81649251186717, -7.064206055627757],
            [7.814791350645834, -7.069735243894424],
            [7.810791568706867, -7.076608529148401],
            [7.807935512059404, -7.090367709718327],
            [7.799381611769391, -7.094980347533766],
            [7.789022943808571, -7.103181890571416],
            [7.785014256183399, -7.107901481394277],
            [7.781317808062368, -7.109414645612285],
            [7.774981718808121, -7.11704713810731],
            [7.77325349001734, -7.121626465064631],
            [7.762778443112591, -7.131971566401189],
            [7.760076051131456, -7.135857876809456],
            [7.7557899085491755, -7.148199776108652],
            [7.755936208791628, -7.152159878428747],
            [7.703576810180938, -7.157151372670471],
            [7.701022603522011, -7.162128526121152],
            [7.68888209961743, -7.169800574016545],
            [7.679535930558795, -7.172437169113545],
            [7.675984757559999, -7.171765686636254],
            [7.670550163345396, -7.177560710114626],
            [7.667433745011623, -7.178935500674393],
            [7.665885427038357, -7.183287978209598],
            [7.655529153313521, -7.191440561139046],
            [7.651296307834091, -7.192318615365428],
            [7.647036791500675, -7.19493996764011],
            [7.637185435157347, -7.192466277298864],
            [7.633715975010657, -7.190665301528944],
            [7.628444374108661, -7.190145470237871],
            [7.627596781425986, -7.1878152942206555],
            [7.6173209528081856, -7.184667983007335],
            [7.611820547762982, -7.184901892600791],
            [7.608598408937024, -7.18280324564775],
            [7.60384557181704, -7.185009957104011],
            [7.597473712862092, -7.182144950044523],
            [7.59363267303242, -7.182040116505905],
            [7.583744710508764, -7.1848747307963],
            [7.5791802274333815, -7.183049452694105],
            [7.576400493382581, -7.184116283321383],
            [7.571607221670108, -7.179952772175192],
            [7.563981958777174, -7.179883480609426],
            [7.557193738209943, -7.177147731489311],
            [7.553171862210724, -7.172687915644863],
            [7.5444210947200006, -7.168913815378322],
            [7.533493941038473, -7.156783934560819],
            [7.530686681423062, -7.1495382259974996],
            [7.520646714826766, -7.1476858814135005],
            [7.520679524600864, -7.144957116840103],
            [7.517177890937051, -7.139144515101289],
            [7.513337777455232, -7.136729827256363],
            [7.510642811428316, -7.133070035626401],
            [7.502987898452389, -7.132155252492276],
            [7.500386344193495, -7.134717783720112],
            [7.495180521425792, -7.1331092835007945],
            [7.488592230394235, -7.133407352261075],
            [7.483429413362632, -7.134864235714607],
            [7.480160365128276, -7.1396838249557035],
            [7.466200028535282, -7.140697307330825],
            [7.463772266127107, -7.138277622995914],
            [7.454070603178741, -7.133353339809537],
            [7.449990147381007, -7.127393861398694],
            [7.447169938218403, -7.115019949887021],
            [7.447156812777165, -7.110780475798216],
            [7.449060821605085, -7.106202094071277],
            [7.459740680326909, -7.094548560478527],
            [7.461652238532958, -7.089669919428545],
            [7.460223101795045, -7.0823476467110105],
            [7.460497319281273, -7.076309103024581],
            [7.462172984524213, -7.07417597102267],
            [7.4664859989304295, -7.07378498487847],
            [7.4695485780018585, -7.075446407342798],
            [7.472411637445708, -7.082583998605524],
            [7.472258058883705, -7.096976197051933],
            [7.473337470326106, -7.100052235839739],
            [7.478980193347222, -7.103691873465025],
            [7.48541137488837, -7.103296980082094],
            [7.493009789151113, -7.099154414370696],
            [7.497006511547489, -7.0949761599903844],
            [7.498118950947903, -7.091678438979608],
            [7.497382616040966, -7.075747877326806],
            [7.493754882464158, -7.067708158437882],
            [7.492880318567389, -7.062016445733569],
            [7.494872819536348, -7.058460085568356],
            [7.501461378722548, -7.05086525851797],
            [7.5072706148807375, -7.033552978859221],
            [7.511240333251693, -7.030444039283828],
            [7.519936566837632, -7.028156910388506],
            [7.524068707442251, -7.025493136847346],
            [7.53663551912123, -7.011018434064751],
            [7.539601394136712, -7.008527313838217],
            [7.548875145541482, -7.005037040127255],
            [7.557426816183422, -7.003781250078426],
            [7.561411829409, -7.005018861351894],
            [7.570629008343129, -7.013037336857796],
            [7.57832885019434, -7.018287282106527],
            [7.583365843749474, -7.019688582749711],
            [7.588372308716734, -7.019606000443537],
            [7.596294106246293, -7.015674081001516],
            [7.600224566166302, -7.011306444852092],
            [7.604773387683076, -7.002060834760431],
            [7.615579570147099, -6.99119745210661],
            [7.6186275039998215, -6.981833428703334],
            [7.620036390926808, -6.97006860999997],
            [7.622456032764638, -6.959709569820321],
            [7.62246329444663, -6.949031910943199],
            [7.618957549259699, -6.94302344150167],
            [7.60828397889537, -6.937680241054583],
            [7.592142727284397, -6.931474294785808],
            [7.584423237857519, -6.927740945308658],
            [7.569344369493869, -6.916038087396742],
            [7.569847406481648, -6.909960420817622],
            [7.573965718769449, -6.9062728740235455],
            [7.586516188427684, -6.900098529924769],
            [7.596760679214414, -6.886796054252216],
            [7.607790019288533, -6.875531686432202],
            [7.612810203678101, -6.8716296871406675],
            [7.610539974493764, -6.85066071260976],
            [7.602489210289027, -6.7660271261550236],
            [7.59883008473051, -6.729170604021635],
            [7.641557431253315, -6.724674246389083],
            [7.635808584009844, -6.669529361834989],
            [7.629240121101269, -6.609020118126222],
            [7.643942352977455, -6.608080669733902],
            [7.642595220076045, -6.592939259457478]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.36546186855047,
          "lat": 31.570840642827328
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01099"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00161576"
      },
      "bbox": [
        7.447156812777165, -7.19493996764011, 8.151025926844845,
        -6.5454442028998985
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.745326833155495, -9.200463989383719],
            [-15.74348820472583, -9.202903940985896],
            [-15.74254982653981, -9.20557954165761],
            [-15.744195573392066, -9.20859814981119],
            [-15.744304374123656, -9.210617834584632],
            [-15.74678738605302, -9.211640013487532],
            [-15.749208299524748, -9.210464738310176],
            [-15.751018320260675, -9.212973060593395],
            [-15.752514904628194, -9.213450238214376],
            [-15.753892193963377, -9.212049318734895],
            [-15.755977448769887, -9.211627233214536],
            [-15.757690920015541, -9.212861575057113],
            [-15.758255793637316, -9.214317648834156],
            [-15.759493002010258, -9.215188574530798],
            [-15.760024038715933, -9.216983424507683],
            [-15.761050154203307, -9.217639222270202],
            [-15.763043100966895, -9.216924157987476],
            [-15.764229056253784, -9.215556834515867],
            [-15.76624342492908, -9.21538326798869],
            [-15.767813565205767, -9.215754524222755],
            [-15.76933166364997, -9.217134830558601],
            [-15.772462586203684, -9.21723308148272],
            [-15.7736704187033, -9.218430766415004],
            [-15.776807090356696, -9.219347826642954],
            [-15.779357128555539, -9.21941779691343],
            [-15.779136418499393, -9.222677495451146],
            [-15.780409246563233, -9.223804964965485],
            [-15.780723368368607, -9.225158580553732],
            [-15.778636071677132, -9.226750609249317],
            [-15.779024630630825, -9.228407535769],
            [-15.782082251365535, -9.229804294203115],
            [-15.783395110495736, -9.231033763584387],
            [-15.784234572642335, -9.232724001177397],
            [-15.789913432563274, -9.236672369039638],
            [-15.791925303487005, -9.238598561817023],
            [-15.792760537253175, -9.23833863044912],
            [-15.796998328342793, -9.240109206652376],
            [-15.7981682680446, -9.243214646161103],
            [-15.800065293457292, -9.243521966317754],
            [-15.801685405233371, -9.243112234960538],
            [-15.804107018391967, -9.241479960819138],
            [-15.804857103595895, -9.241889402559726],
            [-15.806292470134347, -9.24117090277745],
            [-15.807440802407033, -9.241786855087494],
            [-15.811407989793151, -9.24252414417582],
            [-15.81276499581159, -9.239216451271426],
            [-15.814114626601512, -9.239943541691542],
            [-15.817867767822644, -9.240502167669236],
            [-15.818714452592486, -9.241518793568998],
            [-15.82062542881983, -9.242176535283308],
            [-15.822840022068505, -9.241474570290388],
            [-15.824662969292474, -9.243143949558043],
            [-15.825380593888243, -9.24542704736433],
            [-15.827288441651197, -9.24550963051489],
            [-15.82965154204783, -9.247786868626083],
            [-15.832553311854799, -9.246178705739574],
            [-15.838611478230032, -9.24763816158473],
            [-15.83916850701016, -9.246781577735307],
            [-15.841430467620702, -9.245970134947402],
            [-15.844796315961815, -9.24859953047425],
            [-15.84547302519593, -9.25030239075138],
            [-15.846812801093638, -9.251081519428544],
            [-15.84704695826039, -9.254530228662667],
            [-15.84767068577923, -9.255379805303056],
            [-15.851686302321493, -9.256599704489194],
            [-15.854407535287454, -9.256580094955813],
            [-15.855898067680522, -9.257031544937563],
            [-15.856648017392105, -9.256570473875557],
            [-15.859366966021488, -9.256804688133785],
            [-15.862225819762859, -9.256148148651702],
            [-15.863814996102986, -9.256472597616037],
            [-15.866739083740661, -9.254902156813856],
            [-15.869768264448043, -9.255147820606103],
            [-15.870491405564168, -9.256304374530416],
            [-15.87368931700095, -9.257851439778372],
            [-15.874617809811394, -9.2579020780697],
            [-15.875550456147991, -9.25906828014061],
            [-15.875916974125422, -9.262309413739597],
            [-15.877456259839438, -9.263965258794],
            [-15.877418807332731, -9.265801323063513],
            [-15.878925330933598, -9.26880330856348],
            [-15.88231873312774, -9.269281213973231],
            [-15.882378461079556, -9.271232057795888],
            [-15.8816160290378, -9.273667242085608],
            [-15.882529238440174, -9.273606751655633],
            [-15.884897190554197, -9.276308994829773],
            [-15.886104604738359, -9.279321396967264],
            [-15.887088536980592, -9.280620242382698],
            [-15.887181762795969, -9.281999439785396],
            [-15.890550952698788, -9.28279580654053],
            [-15.892314220462318, -9.283914360144932],
            [-15.893971886990437, -9.2837024937917],
            [-15.896514026897579, -9.284207062260645],
            [-15.898078575022867, -9.286280037970867],
            [-15.902266363165912, -9.284456131850689],
            [-15.903855297452639, -9.285213992701697],
            [-15.905830436800194, -9.28408919430149],
            [-15.909157377739664, -9.288400695437025],
            [-15.914359761769296, -9.291313130273467],
            [-15.917388101934762, -9.291440699811787],
            [-15.919968829464421, -9.290895186085956],
            [-15.921418855008532, -9.292126022583965],
            [-15.926756254550673, -9.293660929383448],
            [-15.927647434537832, -9.294986547407825],
            [-15.929554145198768, -9.295754794100116],
            [-15.928614213411109, -9.301050803555064],
            [-15.92744070795508, -9.302037772923534],
            [-15.928094817962652, -9.303622373578746],
            [-15.927948120674124, -9.305112745115737],
            [-15.930602332807727, -9.306194423051807],
            [-15.93248319036769, -9.308090113061516],
            [-15.934669203570744, -9.307883997497715],
            [-15.93685038222118, -9.310439146579563],
            [-15.939398172806664, -9.309334969644796],
            [-15.941270809760418, -9.314276749483785],
            [-15.943180459599507, -9.314507832764788],
            [-15.944615224702368, -9.3167577290367],
            [-15.945388121462605, -9.318934441686709],
            [-15.946626295099838, -9.319228623461381],
            [-15.948273527619898, -9.3204943177875],
            [-15.950754366205922, -9.321583518013778],
            [-15.954414942529805, -9.319736432965923],
            [-15.955400060770204, -9.320476802094026],
            [-15.958481719217442, -9.319882904314566],
            [-15.960634343720686, -9.320471104178596],
            [-15.963500548536551, -9.320122603941424],
            [-15.964640441779462, -9.318621157744696],
            [-15.964187029221, -9.317263203940852],
            [-15.966626566335849, -9.31578169552739],
            [-15.968866662314479, -9.31565505600439],
            [-15.97019026655469, -9.316140641751533],
            [-15.972849817097774, -9.314548629270988],
            [-15.974006993306675, -9.31504019733717],
            [-15.97538828815221, -9.31365946353167],
            [-15.97707105496106, -9.313134753506565],
            [-15.978161266061374, -9.31190300113598],
            [-15.979755942660976, -9.312282956559171],
            [-15.981118246124305, -9.3113556571882],
            [-15.98322338072999, -9.310785707250599],
            [-15.984268096151611, -9.314392483095615],
            [-15.985512520512325, -9.315025118103005],
            [-15.98567731429459, -9.317031167473973],
            [-15.987006575429795, -9.318980059058097],
            [-15.990988602193742, -9.320810136953147],
            [-15.991558813629588, -9.321983540310743],
            [-15.996184197295866, -9.322517613584845],
            [-15.999109980506644, -9.323581377314614],
            [-16.001046949374324, -9.323047713688881],
            [-16.003417349605446, -9.324515350828383],
            [-16.004485769742423, -9.324095863200787],
            [-16.00611425587019, -9.325528655713782],
            [-16.007743813790828, -9.32638729114209],
            [-16.009530781221255, -9.326395317307847],
            [-16.00983148433362, -9.328394082674896],
            [-16.00861316037985, -9.330506121886815],
            [-16.01075254667039, -9.330890674855805],
            [-16.011889557734072, -9.33184068413159],
            [-16.01237564701975, -9.334200092977024],
            [-16.015091934265723, -9.335118543920574],
            [-16.015497615779978, -9.337776250110705],
            [-16.01647901232022, -9.339163844655074],
            [-16.01769927952448, -9.339471783012538],
            [-16.01880688365373, -9.34099362953907],
            [-16.01936659323096, -9.342703430259743],
            [-16.021855307078308, -9.34274916332905],
            [-16.02292259994026, -9.343811566313725],
            [-16.024062686440004, -9.343472928520479],
            [-16.02492520500318, -9.344734284535292],
            [-16.027635877344864, -9.34403679753781],
            [-16.03008866731641, -9.341901467547583],
            [-16.031254398953244, -9.342404582735702],
            [-16.032582843207965, -9.341834194675256],
            [-16.037324177974714, -9.342686790961663],
            [-16.039322769853626, -9.3444085633506],
            [-16.04086794122711, -9.34520254972215],
            [-16.042523585472964, -9.344870467278659],
            [-16.043895153186483, -9.346896538812661],
            [-16.04477648179906, -9.348897490152806],
            [-16.047496133793786, -9.348348307027186],
            [-16.048462514119965, -9.350695713461928],
            [-16.05272023076131, -9.352671193511618],
            [-16.05382277273698, -9.354283212041887],
            [-16.054220802137493, -9.355720591773547],
            [-16.050384099322486, -9.359783179454475],
            [-16.051335205060095, -9.361697385824076],
            [-16.0510867349482, -9.365187107933298],
            [-16.05140545901366, -9.36738642348981],
            [-16.050694423729595, -9.369800877703923],
            [-16.050802398174785, -9.370877527187444],
            [-16.054780849228294, -9.372252708891711],
            [-16.05558057801527, -9.37392358711255],
            [-16.058523376306066, -9.374097485811834],
            [-16.060887522640705, -9.375406936867627],
            [-16.061071212979982, -9.376394581108464],
            [-16.06284188982456, -9.37861123149402],
            [-16.063657199048674, -9.380151832700347],
            [-16.065407232910836, -9.380080678982294],
            [-16.065247299294665, -9.382060457821908],
            [-16.066326059552434, -9.3846471431584],
            [-16.068067099045848, -9.384974993699084],
            [-16.071033914870995, -9.384398716277682],
            [-16.07977506076721, -9.384371223789637],
            [-16.082421413555387, -9.38451970393537],
            [-16.087911258382068, -9.385209342263892],
            [-16.09256971073259, -9.387150693731344],
            [-16.096972679969053, -9.389371660434248],
            [-16.099332719047396, -9.390843704533841],
            [-16.10199918589803, -9.392900082650396],
            [-16.10655621220382, -9.394889246929214],
            [-16.109957955643225, -9.395372601034287],
            [-16.112396887393306, -9.39646590732077],
            [-16.120433129453303, -9.397343121498235],
            [-16.164434930056693, -9.4020377430284],
            [-16.22179217397161, -9.407689124475038],
            [-16.27914789032431, -9.413355483964684],
            [-16.281383317563105, -9.413228704711509],
            [-16.28416968712659, -9.412237149255711],
            [-16.28692886692242, -9.409521273442007],
            [-16.2891908624051, -9.405950071293535],
            [-16.29664283978272, -9.404403463092164],
            [-16.299084767826372, -9.402824082799071],
            [-16.300560190115547, -9.401417711880152],
            [-16.30115220133507, -9.398323520711365],
            [-16.30361587354675, -9.397145170280215],
            [-16.306016303579554, -9.396685740835963],
            [-16.307205926834097, -9.393421570264985],
            [-16.311473800001753, -9.392938015490818],
            [-16.313702599208543, -9.391763763611435],
            [-16.316720500948144, -9.389343849963812],
            [-16.317235155604333, -9.38772449624365],
            [-16.318866765232954, -9.38592972165451],
            [-16.32103392985417, -9.386964432492672],
            [-16.32245319753145, -9.38718728973372],
            [-16.323627946076446, -9.386687460741632],
            [-16.325332107693352, -9.387486038882177],
            [-16.32827897063823, -9.38597584165768],
            [-16.32916754237733, -9.383881726005209],
            [-16.33062710330088, -9.384256614991479],
            [-16.33142481954683, -9.382812024580167],
            [-16.333203067384446, -9.382913040903402],
            [-16.335230150678083, -9.381970499687359],
            [-16.335431755542178, -9.378578827301256],
            [-16.335106268843628, -9.376614440748899],
            [-16.33769282369587, -9.376234627761697],
            [-16.337035539838848, -9.374724698222098],
            [-16.338033889934827, -9.37383975540216],
            [-16.33928194062522, -9.37373552318795],
            [-16.339787708436027, -9.372611283863865],
            [-16.34136977256969, -9.372618934871479],
            [-16.341937427161692, -9.370509269692468],
            [-16.343042214547914, -9.369769230362225],
            [-16.34552673941499, -9.370266736594619],
            [-16.346598328330717, -9.369527620105458],
            [-16.346434590069844, -9.367534784050529],
            [-16.346825869122622, -9.36636323654832],
            [-16.349168232591598, -9.365972108298044],
            [-16.348622292830004, -9.36435676911522],
            [-16.349110002912525, -9.363201503026682],
            [-16.350472068039107, -9.362622196199833],
            [-16.350734384089353, -9.361140309312702],
            [-16.352069997011892, -9.361429475143145],
            [-16.3534815181358, -9.359226378482365],
            [-16.354808476766546, -9.358297604881171],
            [-16.3543054977503, -9.355442402278358],
            [-16.353302883367636, -9.353481623074252],
            [-16.354613764716024, -9.352663980447886],
            [-16.35417596449742, -9.35114676032865],
            [-16.356082242734026, -9.351325749115372],
            [-16.355462127123015, -9.349693688060867],
            [-16.35774810397537, -9.348712183400083],
            [-16.357041070257438, -9.346707066119874],
            [-16.358702739636275, -9.34489213844799],
            [-16.35852562382091, -9.343558489770945],
            [-16.360014623139747, -9.342578996147953],
            [-16.358890160435323, -9.341465322038612],
            [-16.36273671924599, -9.340576072763207],
            [-16.36360001750923, -9.339469463435968],
            [-16.36498439170213, -9.3403944868259],
            [-16.367553460953363, -9.341323186594423],
            [-16.36879307153469, -9.338054504473256],
            [-16.37120312875243, -9.33744409730673],
            [-16.371065565153053, -9.335539312443657],
            [-16.372324099817572, -9.335413309361215],
            [-16.372628129253517, -9.333152826346108],
            [-16.374598919252882, -9.331629365934758],
            [-16.376318260838744, -9.332051012584804],
            [-16.37649084958549, -9.33006772288656],
            [-16.37822324003227, -9.3300391957576],
            [-16.37961997650952, -9.328974173097789],
            [-16.380739743775123, -9.330305344158651],
            [-16.381850940831526, -9.328569877090809],
            [-16.38461097577106, -9.327528996160948],
            [-16.38324393016157, -9.326268509689173],
            [-16.384968037450484, -9.32533389925718],
            [-16.387230098416044, -9.321941460692667],
            [-16.387985981947054, -9.319142657243175],
            [-16.388042852113482, -9.31735965296492],
            [-16.39185762368137, -9.315985754510768],
            [-16.390527559472208, -9.313974164186844],
            [-16.389157209241898, -9.312798752440832],
            [-16.392312977463945, -9.310816192053101],
            [-16.394471430050015, -9.308067218079499],
            [-16.395702164652054, -9.308207583290729],
            [-16.398288015838375, -9.306051208341358],
            [-16.40376331490786, -9.304040125907118],
            [-16.404497161433266, -9.302862615489836],
            [-16.40605202344148, -9.30272857099173],
            [-16.40763546246607, -9.301641880617128],
            [-16.409201421598574, -9.299754892798545],
            [-16.410597348548592, -9.300020669550191],
            [-16.413044851796155, -9.302453311621484],
            [-16.415931776184838, -9.300624798521362],
            [-16.41746705726771, -9.301844025898298],
            [-16.419438760075092, -9.30404185075785],
            [-16.421203489231956, -9.307393692704037],
            [-16.420092077523, -9.309129844756873],
            [-16.42104862345018, -9.310997337143545],
            [-16.42286890236044, -9.311894348884675],
            [-16.425274181952183, -9.310206716340701],
            [-16.423206332302357, -9.307773010813433],
            [-16.42420289649897, -9.295604535280589],
            [-16.42813393341526, -9.247573629201174],
            [-16.430712196796275, -9.216103757637459],
            [-16.43262635872575, -9.216256162685312],
            [-16.442367959000823, -9.096946699268855],
            [-16.366154498197563, -9.090583270019103],
            [-16.34256652503995, -9.088491864090393],
            [-16.281012425378368, -9.0827706773549],
            [-16.27804315957948, -9.08001307762296],
            [-16.27740049972652, -9.078935418056085],
            [-16.275509527357176, -9.077251789343029],
            [-16.273638771627684, -9.074112094017357],
            [-16.269265675106126, -9.070967343650972],
            [-16.267630358832893, -9.070954411626829],
            [-16.262733950177594, -9.067781044977865],
            [-16.26119723485511, -9.067496153011835],
            [-16.259451924173604, -9.066548893968884],
            [-16.255455101313604, -9.062525716290791],
            [-16.252551933314926, -9.06150520438862],
            [-16.251156806828188, -9.058625503761165],
            [-16.248105618450698, -9.056866603475452],
            [-16.244453696423708, -9.05618162251158],
            [-16.242772903159533, -9.05476041692777],
            [-16.240636803890418, -9.055397062543078],
            [-16.23877170742552, -9.054856997221941],
            [-16.235784416632598, -9.05451894189557],
            [-16.2334042482444, -9.0549227928535],
            [-16.230250784659084, -9.052869408486886],
            [-16.22943976935346, -9.052831791487135],
            [-16.224710066285834, -9.05004372079304],
            [-16.22222444425382, -9.050930692375863],
            [-16.220362191432443, -9.05436787529123],
            [-16.219275537519938, -9.054906544748784],
            [-16.21487827881296, -9.051134860547073],
            [-16.210126614345725, -9.050488899885677],
            [-16.208436631722652, -9.0508749089685],
            [-16.207967213967812, -9.049123717514869],
            [-16.207056580520753, -9.048182872741007],
            [-16.204150022141516, -9.049478451846385],
            [-16.203305118449975, -9.051193580214628],
            [-16.201896527291584, -9.050969371666007],
            [-16.199232301584637, -9.049489988697278],
            [-16.196421460734797, -9.050880343492848],
            [-16.19534310596761, -9.052118795435925],
            [-16.193549438455737, -9.052909064682252],
            [-16.19149858276871, -9.053307448552578],
            [-16.188607020552322, -9.0520491755115],
            [-16.187862460263332, -9.050965178759345],
            [-16.188147052843597, -9.047873184212584],
            [-16.185414158516174, -9.046858152845603],
            [-16.183405689644946, -9.045578928652649],
            [-16.17899529001623, -9.045237024483775],
            [-16.17788892396046, -9.044310097269891],
            [-16.17663719848491, -9.042081744984817],
            [-16.175009795949638, -9.042582715540712],
            [-16.172539509270504, -9.04233496811735],
            [-16.172514714546296, -9.041153220816511],
            [-16.171613454799132, -9.038158689758998],
            [-16.168340772602264, -9.03852595624195],
            [-16.166161804579392, -9.036255119075907],
            [-16.16452823521289, -9.036558678566685],
            [-16.162946396276237, -9.038102411632972],
            [-16.162262015407162, -9.036316050853047],
            [-16.16335151164269, -9.034623413645356],
            [-16.162901321160543, -9.033237521492612],
            [-16.160837076389598, -9.032990011890684],
            [-16.15844462051581, -9.031886357368803],
            [-16.156922247835936, -9.029215185789289],
            [-16.155181015222745, -9.027956561498044],
            [-16.153657054299735, -9.027741894541727],
            [-16.150884455402803, -9.026435269899553],
            [-16.14885291176346, -9.023138886011026],
            [-16.146804568672923, -9.022719591293905],
            [-16.143826307346476, -9.023626968131442],
            [-16.142593144426698, -9.02260667315306],
            [-16.138966423748943, -9.021114002970627],
            [-16.13624377668007, -9.014313931285665],
            [-16.136270960365934, -9.012520717155912],
            [-16.134182242590313, -9.010840364909683],
            [-16.13198128826885, -9.00718509327441],
            [-16.13193210674445, -9.004876723792805],
            [-16.134362732699955, -9.003952537652939],
            [-16.135086351194996, -9.002862331918456],
            [-16.135693354801123, -8.998984935935685],
            [-16.135716668081074, -8.997139531568086],
            [-16.138176714039034, -8.99722956133776],
            [-16.139077820533238, -8.994125448025656],
            [-16.136588712205253, -8.990220592709564],
            [-16.134837871781514, -8.990754550371559],
            [-16.13371280523279, -8.992277242561043],
            [-16.131796159183057, -8.99121451238613],
            [-16.130359359361506, -8.989053955406511],
            [-16.128676194196487, -8.989199163888246],
            [-16.127263207167694, -8.988608338627467],
            [-16.12534523933558, -8.989686042406786],
            [-16.125089971139094, -8.990766604488565],
            [-16.12320961240893, -8.993636709585974],
            [-16.11989113260595, -8.993444673443186],
            [-16.119094177309147, -8.993051282252527],
            [-16.117492781432905, -8.99082566420351],
            [-16.116404441371834, -8.991013592791907],
            [-16.1156613706978, -8.988508796837243],
            [-16.112705618722746, -8.988186838540422],
            [-16.1076290438766, -8.988813640464583],
            [-16.10680638380774, -8.986376291511853],
            [-16.104812892370152, -8.984213637129445],
            [-16.101409495112954, -8.983004621487314],
            [-16.098479092376742, -8.983430547508535],
            [-16.09584314548378, -8.981708809457997],
            [-16.093614076014493, -8.97839895850962],
            [-16.09100216375736, -8.978342065051411],
            [-16.088650922301973, -8.979136537029502],
            [-16.088089423316113, -8.980098335806163],
            [-16.087732982513234, -8.982361358971522],
            [-16.086852625958613, -8.983853484886879],
            [-16.086966460660705, -8.986829695634922],
            [-16.083301193842324, -8.987923977488656],
            [-16.08019491768836, -8.989339543997742],
            [-16.079007872423013, -8.990949570761963],
            [-16.0787702254716, -8.992753498576496],
            [-16.077734336509266, -8.993518861323551],
            [-16.075467394542255, -8.99353902739904],
            [-16.07283162418124, -8.992733962694482],
            [-16.070689956207996, -8.992615457870118],
            [-16.069446726775862, -8.993381177372472],
            [-16.06709613457802, -8.991003027552251],
            [-16.063671852834272, -8.99084292249263],
            [-16.061851003114125, -8.989693556046625],
            [-16.060141653793757, -8.989944825555137],
            [-16.059281037661048, -8.99198345468387],
            [-16.058047550809768, -8.992916037318025],
            [-16.057551434874725, -8.994614147945525],
            [-16.058023579773657, -8.996706423578514],
            [-16.05907850582348, -8.998149554243952],
            [-16.05985117134833, -9.00007166899842],
            [-16.061414047499945, -9.002417994309091],
            [-16.061102365148415, -9.007113074039811],
            [-16.0630607460819, -9.0083516723891],
            [-16.064816573779623, -9.00739625015982],
            [-16.06736098589556, -9.008801787356276],
            [-16.06912451120956, -9.011988675023035],
            [-16.07163199875445, -9.01563678816731],
            [-16.073015038364858, -9.017151186571063],
            [-16.074733709426813, -9.020680697669023],
            [-16.078282360648178, -9.024540730706535],
            [-16.077265053233322, -9.02750639062342],
            [-16.073361469239053, -9.02828093487838],
            [-16.073487540256274, -9.02962763860444],
            [-16.072009121908597, -9.032181357456405],
            [-16.072443761299414, -9.034506338232644],
            [-16.074578273309704, -9.03725273459621],
            [-16.07150033526817, -9.039916394741194],
            [-16.06879134612513, -9.041026899281134],
            [-16.067317683624182, -9.04101368395412],
            [-16.06661518201859, -9.041807707787337],
            [-16.067191533085232, -9.044541978624885],
            [-16.067148236985346, -9.04593076868532],
            [-16.064760105389432, -9.047434728319406],
            [-16.064045344942397, -9.048551865836224],
            [-16.061105231282383, -9.048917129033159],
            [-16.059547772399288, -9.049849577289157],
            [-16.0571734063473, -9.052314816080816],
            [-16.05386573560292, -9.05172490175844],
            [-16.05151846198205, -9.053425563937767],
            [-16.04957464323549, -9.05621414417261],
            [-16.047834063509754, -9.057116817901244],
            [-16.046179013117477, -9.058901052958579],
            [-16.044470218275322, -9.058920196382001],
            [-16.040624709187192, -9.058255332193331],
            [-16.03927643860535, -9.057546126136105],
            [-16.037402624375325, -9.057735509298949],
            [-16.037212707801444, -9.05615266645826],
            [-16.036169001420983, -9.054254929884292],
            [-16.033602210964474, -9.054544236581592],
            [-16.030353235703508, -9.056831530740684],
            [-16.029337844313112, -9.057176950057586],
            [-16.028173846622884, -9.059011914693409],
            [-16.026362016508116, -9.06042084648093],
            [-16.024518184481412, -9.05941182833545],
            [-16.020941975306126, -9.061544007504756],
            [-16.01960550906127, -9.060738406805386],
            [-16.01758444370222, -9.06109862898139],
            [-16.016364989344023, -9.06221611698166],
            [-16.01329939475761, -9.062845391200884],
            [-16.00884517914868, -9.06112344576233],
            [-16.007510024660505, -9.0598847837441],
            [-16.005557247259798, -9.06110498156277],
            [-16.005207473743905, -9.062004165984098],
            [-16.005444448706218, -9.064374563967663],
            [-16.003156324781123, -9.06721253907173],
            [-16.004231558233396, -9.06965256046486],
            [-16.001984048543722, -9.070617693726563],
            [-15.999410229994114, -9.071240023108384],
            [-15.99784894200831, -9.070969665364034],
            [-15.997579360403035, -9.073504213708361],
            [-15.996511438269563, -9.074703869506429],
            [-15.997115641134803, -9.076795019375297],
            [-16.000717284032756, -9.07841530841261],
            [-16.002165445716543, -9.08009120140304],
            [-16.002602194395713, -9.081748286366977],
            [-16.002039059528745, -9.082708725576394],
            [-16.002294622547485, -9.084723921923448],
            [-16.005240752173417, -9.08752957202348],
            [-16.007273878577276, -9.088793996084746],
            [-16.00886084142194, -9.090317225744208],
            [-16.011308362567036, -9.090587245778584],
            [-16.012529812484935, -9.091717135069521],
            [-16.01333877000924, -9.093439193784064],
            [-16.01329475564416, -9.095554086395973],
            [-16.01465537205405, -9.096877988754718],
            [-16.015811576595226, -9.098892813729154],
            [-16.015244873504674, -9.100778039181511],
            [-16.01421373561884, -9.102055627013103],
            [-16.013076686715483, -9.101727333184149],
            [-16.008115170634973, -9.099277937729982],
            [-16.005687770536614, -9.098524777199728],
            [-16.0032992305289, -9.098524928603139],
            [-16.00233719236594, -9.09961918560263],
            [-16.000439459745085, -9.099806074276591],
            [-16.000324260400586, -9.101904772930158],
            [-16.001542601027094, -9.102804004632274],
            [-16.00025793610294, -9.104601642303788],
            [-15.9984765022598, -9.105283746830859],
            [-15.99706588513509, -9.106538433936885],
            [-15.997247508079846, -9.107960539556032],
            [-15.995792792101907, -9.111712209593357],
            [-15.994177035572617, -9.112063324885693],
            [-15.99201002976377, -9.10977635562671],
            [-15.990016907376006, -9.110469681108956],
            [-15.988197635396228, -9.108200221345399],
            [-15.986131747904693, -9.106535047135294],
            [-15.984428874257427, -9.106808421738961],
            [-15.981771109098704, -9.10608315194095],
            [-15.979861603148885, -9.106166281696842],
            [-15.979033972454095, -9.105542179396934],
            [-15.977009256898281, -9.105188273722835],
            [-15.977101933105441, -9.10009397336341],
            [-15.975480414432798, -9.098222565912149],
            [-15.973402479623143, -9.09682722647719],
            [-15.972618345258166, -9.099004331650761],
            [-15.972065798419, -9.099193923172049],
            [-15.969316759701835, -9.09780281725475],
            [-15.96771299336974, -9.098147178592745],
            [-15.965763779502183, -9.097251238181538],
            [-15.96541119738039, -9.09635764353686],
            [-15.966109067790077, -9.0951486573363],
            [-15.964780292106838, -9.09379659166494],
            [-15.96419233680535, -9.090609573189436],
            [-15.961373576194921, -9.090930732607802],
            [-15.960017337833989, -9.089845454003308],
            [-15.957572229434223, -9.091645166434366],
            [-15.955511603235772, -9.092420326678393],
            [-15.955905214843295, -9.095008844986422],
            [-15.954158973952111, -9.095921972382737],
            [-15.952591839074815, -9.094422972312078],
            [-15.951349149123745, -9.095005536412456],
            [-15.948771418441414, -9.09506181821977],
            [-15.947982928997824, -9.093789480655616],
            [-15.945796556555385, -9.09288603292002],
            [-15.943920561855807, -9.094138537500365],
            [-15.9431576991211, -9.092981993704681],
            [-15.94151714353871, -9.093825237623202],
            [-15.939757328011126, -9.093269891057782],
            [-15.937115774250612, -9.091883147323811],
            [-15.935538565383219, -9.09161756357307],
            [-15.934452826501401, -9.092315259362824],
            [-15.93208001278988, -9.089920675634998],
            [-15.931359642309914, -9.087743321437658],
            [-15.928695413876412, -9.084951631614883],
            [-15.928311011172333, -9.083891996669886],
            [-15.926337681319938, -9.081548297460648],
            [-15.92466063924633, -9.080708309022079],
            [-15.922725808187069, -9.081460982604499],
            [-15.920578526668614, -9.080915636867068],
            [-15.91999308484946, -9.080219344293653],
            [-15.91739674846443, -9.080525024954197],
            [-15.915393256611953, -9.079639884681658],
            [-15.91518080794678, -9.077235237482963],
            [-15.91362417874777, -9.076539291666087],
            [-15.912045641785166, -9.07408232503693],
            [-15.909829971763088, -9.072390497538729],
            [-15.908354600321374, -9.072170005693131],
            [-15.907056274592435, -9.070907001901356],
            [-15.907250372601952, -9.069598141357828],
            [-15.90561409957822, -9.069198982476781],
            [-15.903929806860434, -9.066417080977585],
            [-15.90283056262646, -9.066040873152497],
            [-15.902212185875483, -9.06439508029834],
            [-15.90055467338785, -9.064494639699879],
            [-15.895552521831709, -9.067206164662522],
            [-15.891808073547073, -9.066893251927844],
            [-15.889907589083709, -9.062272818779807],
            [-15.886725100048293, -9.062545962198357],
            [-15.885464789341786, -9.063999419560346],
            [-15.882019694134623, -9.066223061760454],
            [-15.881917667230338, -9.067996977376856],
            [-15.878444439883886, -9.06684050533437],
            [-15.873128897352686, -9.068933638301244],
            [-15.868233662241295, -9.07141598031464],
            [-15.866750018789949, -9.0726438150951],
            [-15.860290951657499, -9.073691167126391],
            [-15.860505593012858, -9.069630753909886],
            [-15.859834487288824, -9.068950427758045],
            [-15.857164991606593, -9.06897713078471],
            [-15.85550452045314, -9.070600728692826],
            [-15.854097961073718, -9.07136476543605],
            [-15.85077918578712, -9.071449214267176],
            [-15.844211479803423, -9.07457522053108],
            [-15.84271106299847, -9.076719875563382],
            [-15.84042807073535, -9.075901820755922],
            [-15.83821695673226, -9.076337835395513],
            [-15.834143287467723, -9.079035177049848],
            [-15.832252061446733, -9.075900204268699],
            [-15.829344083525294, -9.073639284265289],
            [-15.826622206399962, -9.073892216401102],
            [-15.823691190550566, -9.076105157926385],
            [-15.822086587414182, -9.079885899589192],
            [-15.81958528327044, -9.080322706549035],
            [-15.818426010417562, -9.076606183911501],
            [-15.816939518286892, -9.07479937443084],
            [-15.815815655203048, -9.074794901989247],
            [-15.813239153561463, -9.071779716093625],
            [-15.809616213263437, -9.070468217464652],
            [-15.809535283026664, -9.069110226513825],
            [-15.808363676416985, -9.069306081746069],
            [-15.806036631470612, -9.068632409070748],
            [-15.805446986796273, -9.067442741203037],
            [-15.805728702116873, -9.066202073584885],
            [-15.804864545380722, -9.065184264546934],
            [-15.805683397438761, -9.061115191014295],
            [-15.804723949769516, -9.059626315861554],
            [-15.803358544733799, -9.060158330344658],
            [-15.801172544410193, -9.05936808351366],
            [-15.799414066526039, -9.05775789229615],
            [-15.796782908693942, -9.058400304714828],
            [-15.795837622829962, -9.057258565132743],
            [-15.793830206502129, -9.056004220544022],
            [-15.791446293799785, -9.056937742728392],
            [-15.789148211303312, -9.057424999290411],
            [-15.787834351682125, -9.055195282615989],
            [-15.787027659362437, -9.05546049982816],
            [-15.785798466913679, -9.05441635794371],
            [-15.782832416171127, -9.055558973261693],
            [-15.780661171664551, -9.055138469699807],
            [-15.778765435610786, -9.05708833938514],
            [-15.777474896432382, -9.056354777249329],
            [-15.776728429100116, -9.052689484498671],
            [-15.773767441130765, -9.05316702353402],
            [-15.771872450426349, -9.05439704621541],
            [-15.768310311818288, -9.053221437094697],
            [-15.767788570893417, -9.051477912406584],
            [-15.766237906984424, -9.051407089924956],
            [-15.760846682279437, -9.053213247548147],
            [-15.758147658362695, -9.052923676525714],
            [-15.75711367828884, -9.050249714291668],
            [-15.755481758631182, -9.049373302904895],
            [-15.754159941281003, -9.049462828186268],
            [-15.752795197701657, -9.050906882820918],
            [-15.750374394332889, -9.05207789635536],
            [-15.74766766566249, -9.052135226537924],
            [-15.74673051287448, -9.054322050795202],
            [-15.744129287635719, -9.054041004146116],
            [-15.742003654524705, -9.056768729491159],
            [-15.740903785769213, -9.057243394354302],
            [-15.741214266810232, -9.060657934833428],
            [-15.741832185812536, -9.061964614737368],
            [-15.741605998095642, -9.063236905825338],
            [-15.743040718695863, -9.06583888584523],
            [-15.74382376731916, -9.066595901669954],
            [-15.74330719236208, -9.06898574832349],
            [-15.747424695351727, -9.07139902982118],
            [-15.74856469406292, -9.073586268352585],
            [-15.752800473884756, -9.073787273043783],
            [-15.753758694086287, -9.075511244910883],
            [-15.755970723749131, -9.076803699271332],
            [-15.757638277727251, -9.07682479857678],
            [-15.760292392658128, -9.080907705359659],
            [-15.759993511456729, -9.082142002506599],
            [-15.760607674400914, -9.086725457177735],
            [-15.761420400757622, -9.086983858472419],
            [-15.763553064252697, -9.085652603922847],
            [-15.76537246788992, -9.085281672372528],
            [-15.767199456518776, -9.085982342454951],
            [-15.765298135625573, -9.089816360038528],
            [-15.765983880361059, -9.092333389733195],
            [-15.763386854516593, -9.094004905777254],
            [-15.760886323064064, -9.09446138059572],
            [-15.759686809830733, -9.09514783221931],
            [-15.758128542918332, -9.097302512330248],
            [-15.755461592453672, -9.097683018485121],
            [-15.753624290588549, -9.09827885682543],
            [-15.752439596712938, -9.097658429619653],
            [-15.749528714860917, -9.101055465782263],
            [-15.748104816659632, -9.101708557471586],
            [-15.749050597759327, -9.103702781187486],
            [-15.749459037264566, -9.106106819768799],
            [-15.74873417736512, -9.107693298281164],
            [-15.750209530186856, -9.112279665674851],
            [-15.752820467071894, -9.113117060075313],
            [-15.755072390079429, -9.115339939552516],
            [-15.755876578053813, -9.117623774261123],
            [-15.757913957053916, -9.118869381604348],
            [-15.757974130353244, -9.119684333753595],
            [-15.760136307747633, -9.121463121578637],
            [-15.759540913927035, -9.12240507216677],
            [-15.754699747247397, -9.12501772327995],
            [-15.754030477984857, -9.126486409743242],
            [-15.754399900500376, -9.128887237896615],
            [-15.755605134335475, -9.132500167119845],
            [-15.756720255125428, -9.134650271303611],
            [-15.755662961305289, -9.136096408060661],
            [-15.754292011855332, -9.139356431484725],
            [-15.757696626880714, -9.142009163116741],
            [-15.75852954936132, -9.144239636433696],
            [-15.75922090496857, -9.144616844129427],
            [-15.75635843497762, -9.147238014891533],
            [-15.754877399066178, -9.149583313172677],
            [-15.755286733629044, -9.151361742494972],
            [-15.753626970359555, -9.153654939877024],
            [-15.755039230347304, -9.155447093463946],
            [-15.755498460122462, -9.157251750163793],
            [-15.757389479011096, -9.158154656929186],
            [-15.757544040035924, -9.160124057914564],
            [-15.75826896342371, -9.161180009123203],
            [-15.760013727720224, -9.162252850963869],
            [-15.759103052217402, -9.164156193914804],
            [-15.758243978492999, -9.164807823890136],
            [-15.75410921736104, -9.16476971677804],
            [-15.752881995721197, -9.166303107053771],
            [-15.751078963459483, -9.16756975374316],
            [-15.748062654603023, -9.167464157877683],
            [-15.74733085091149, -9.16817977376186],
            [-15.745239539371106, -9.167707417411805],
            [-15.744064678506113, -9.169249923192137],
            [-15.743923762430935, -9.170878282255348],
            [-15.746106729056317, -9.173082346246558],
            [-15.747299372327607, -9.17375087649508],
            [-15.749339873359427, -9.177479999272428],
            [-15.751186350576821, -9.177448495972923],
            [-15.753372617949339, -9.17917807178421],
            [-15.75361748256414, -9.180038943314452],
            [-15.752249583260724, -9.181164406385959],
            [-15.753405672503202, -9.183122342851993],
            [-15.752946021810349, -9.18517597068125],
            [-15.754493746849274, -9.187291323145095],
            [-15.75461313484356, -9.188980830474836],
            [-15.75378507534468, -9.191240046108838],
            [-15.752693231701414, -9.192040328871581],
            [-15.748732976532592, -9.19148161844544],
            [-15.747383446199427, -9.191577532399908],
            [-15.745125465462532, -9.193093382742013],
            [-15.744765312162501, -9.195970732488352],
            [-15.745950165525311, -9.197360779717414],
            [-15.745326833155495, -9.200463989383719]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -146.5654548595111, "lat": 64.80775019103393 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02090"],
        "coty_name": ["Fairbanks North Star"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Fairbanks North Star Borough"],
        "coty_fp_code": "090",
        "coty_gnis_code": "01419969"
      },
      "bbox": [
        -16.442367959000823, -9.413355483964684, -15.740903785769213,
        -8.978342065051411
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.164434930056693, -9.4020377430284],
            [-16.120433129453303, -9.397343121498235],
            [-16.112396887393306, -9.39646590732077],
            [-16.109957955643225, -9.395372601034287],
            [-16.10655621220382, -9.394889246929214],
            [-16.10199918589803, -9.392900082650396],
            [-16.099332719047396, -9.390843704533841],
            [-16.096972679969053, -9.389371660434248],
            [-16.09256971073259, -9.387150693731344],
            [-16.087911258382068, -9.385209342263892],
            [-16.082421413555387, -9.38451970393537],
            [-16.07977506076721, -9.384371223789637],
            [-16.071033914870995, -9.384398716277682],
            [-16.068067099045848, -9.384974993699084],
            [-16.066326059552434, -9.3846471431584],
            [-16.065247299294665, -9.382060457821908],
            [-16.065407232910836, -9.380080678982294],
            [-16.063657199048674, -9.380151832700347],
            [-16.06284188982456, -9.37861123149402],
            [-16.061071212979982, -9.376394581108464],
            [-16.060887522640705, -9.375406936867627],
            [-16.058523376306066, -9.374097485811834],
            [-16.05558057801527, -9.37392358711255],
            [-16.054780849228294, -9.372252708891711],
            [-16.050802398174785, -9.370877527187444],
            [-16.050694423729595, -9.369800877703923],
            [-16.05140545901366, -9.36738642348981],
            [-16.0510867349482, -9.365187107933298],
            [-16.051335205060095, -9.361697385824076],
            [-16.050384099322486, -9.359783179454475],
            [-16.054220802137493, -9.355720591773547],
            [-16.05382277273698, -9.354283212041887],
            [-16.05272023076131, -9.352671193511618],
            [-16.048462514119965, -9.350695713461928],
            [-16.047496133793786, -9.348348307027186],
            [-16.04477648179906, -9.348897490152806],
            [-16.043895153186483, -9.346896538812661],
            [-16.042523585472964, -9.344870467278659],
            [-16.04086794122711, -9.34520254972215],
            [-16.039322769853626, -9.3444085633506],
            [-16.037324177974714, -9.342686790961663],
            [-16.032582843207965, -9.341834194675256],
            [-16.031254398953244, -9.342404582735702],
            [-16.03008866731641, -9.341901467547583],
            [-16.027635877344864, -9.34403679753781],
            [-16.02492520500318, -9.344734284535292],
            [-16.024062686440004, -9.343472928520479],
            [-16.02292259994026, -9.343811566313725],
            [-16.021855307078308, -9.34274916332905],
            [-16.01936659323096, -9.342703430259743],
            [-16.01880688365373, -9.34099362953907],
            [-16.01769927952448, -9.339471783012538],
            [-16.01647901232022, -9.339163844655074],
            [-16.015497615779978, -9.337776250110705],
            [-16.015091934265723, -9.335118543920574],
            [-16.01237564701975, -9.334200092977024],
            [-16.011889557734072, -9.33184068413159],
            [-16.01075254667039, -9.330890674855805],
            [-16.00861316037985, -9.330506121886815],
            [-16.00983148433362, -9.328394082674896],
            [-16.009530781221255, -9.326395317307847],
            [-16.007743813790828, -9.32638729114209],
            [-16.00611425587019, -9.325528655713782],
            [-16.004485769742423, -9.324095863200787],
            [-16.003417349605446, -9.324515350828383],
            [-16.001046949374324, -9.323047713688881],
            [-15.999109980506644, -9.323581377314614],
            [-15.996184197295866, -9.322517613584845],
            [-15.991558813629588, -9.321983540310743],
            [-15.990988602193742, -9.320810136953147],
            [-15.987006575429795, -9.318980059058097],
            [-15.98567731429459, -9.317031167473973],
            [-15.985512520512325, -9.315025118103005],
            [-15.984268096151611, -9.314392483095615],
            [-15.98322338072999, -9.310785707250599],
            [-15.981118246124305, -9.3113556571882],
            [-15.979755942660976, -9.312282956559171],
            [-15.978161266061374, -9.31190300113598],
            [-15.97707105496106, -9.313134753506565],
            [-15.97538828815221, -9.31365946353167],
            [-15.974006993306675, -9.31504019733717],
            [-15.972849817097774, -9.314548629270988],
            [-15.97019026655469, -9.316140641751533],
            [-15.968866662314479, -9.31565505600439],
            [-15.966626566335849, -9.31578169552739],
            [-15.964187029221, -9.317263203940852],
            [-15.964640441779462, -9.318621157744696],
            [-15.963500548536551, -9.320122603941424],
            [-15.960634343720686, -9.320471104178596],
            [-15.958481719217442, -9.319882904314566],
            [-15.955400060770204, -9.320476802094026],
            [-15.954414942529805, -9.319736432965923],
            [-15.950754366205922, -9.321583518013778],
            [-15.948273527619898, -9.3204943177875],
            [-15.946626295099838, -9.319228623461381],
            [-15.945388121462605, -9.318934441686709],
            [-15.944615224702368, -9.3167577290367],
            [-15.943180459599507, -9.314507832764788],
            [-15.941270809760418, -9.314276749483785],
            [-15.939398172806664, -9.309334969644796],
            [-15.93685038222118, -9.310439146579563],
            [-15.934669203570744, -9.307883997497715],
            [-15.93248319036769, -9.308090113061516],
            [-15.930602332807727, -9.306194423051807],
            [-15.927948120674124, -9.305112745115737],
            [-15.928094817962652, -9.303622373578746],
            [-15.92744070795508, -9.302037772923534],
            [-15.928614213411109, -9.301050803555064],
            [-15.929554145198768, -9.295754794100116],
            [-15.927647434537832, -9.294986547407825],
            [-15.926756254550673, -9.293660929383448],
            [-15.921418855008532, -9.292126022583965],
            [-15.919968829464421, -9.290895186085956],
            [-15.917388101934762, -9.291440699811787],
            [-15.914359761769296, -9.291313130273467],
            [-15.909157377739664, -9.288400695437025],
            [-15.905830436800194, -9.28408919430149],
            [-15.903855297452639, -9.285213992701697],
            [-15.902266363165912, -9.284456131850689],
            [-15.898078575022867, -9.286280037970867],
            [-15.896514026897579, -9.284207062260645],
            [-15.893971886990437, -9.2837024937917],
            [-15.892314220462318, -9.283914360144932],
            [-15.890550952698788, -9.28279580654053],
            [-15.887181762795969, -9.281999439785396],
            [-15.887088536980592, -9.280620242382698],
            [-15.886104604738359, -9.279321396967264],
            [-15.884897190554197, -9.276308994829773],
            [-15.882529238440174, -9.273606751655633],
            [-15.8816160290378, -9.273667242085608],
            [-15.882378461079556, -9.271232057795888],
            [-15.88231873312774, -9.269281213973231],
            [-15.878925330933598, -9.26880330856348],
            [-15.877418807332731, -9.265801323063513],
            [-15.877456259839438, -9.263965258794],
            [-15.875916974125422, -9.262309413739597],
            [-15.875550456147991, -9.25906828014061],
            [-15.874617809811394, -9.2579020780697],
            [-15.87368931700095, -9.257851439778372],
            [-15.870491405564168, -9.256304374530416],
            [-15.869768264448043, -9.255147820606103],
            [-15.866739083740661, -9.254902156813856],
            [-15.863814996102986, -9.256472597616037],
            [-15.862225819762859, -9.256148148651702],
            [-15.859366966021488, -9.256804688133785],
            [-15.856648017392105, -9.256570473875557],
            [-15.855898067680522, -9.257031544937563],
            [-15.854407535287454, -9.256580094955813],
            [-15.851686302321493, -9.256599704489194],
            [-15.84767068577923, -9.255379805303056],
            [-15.84704695826039, -9.254530228662667],
            [-15.846812801093638, -9.251081519428544],
            [-15.84547302519593, -9.25030239075138],
            [-15.844796315961815, -9.24859953047425],
            [-15.841430467620702, -9.245970134947402],
            [-15.83916850701016, -9.246781577735307],
            [-15.838611478230032, -9.24763816158473],
            [-15.832553311854799, -9.246178705739574],
            [-15.82965154204783, -9.247786868626083],
            [-15.827288441651197, -9.24550963051489],
            [-15.825380593888243, -9.24542704736433],
            [-15.824662969292474, -9.243143949558043],
            [-15.822840022068505, -9.241474570290388],
            [-15.82062542881983, -9.242176535283308],
            [-15.818714452592486, -9.241518793568998],
            [-15.817867767822644, -9.240502167669236],
            [-15.814114626601512, -9.239943541691542],
            [-15.81276499581159, -9.239216451271426],
            [-15.811407989793151, -9.24252414417582],
            [-15.807440802407033, -9.241786855087494],
            [-15.806292470134347, -9.24117090277745],
            [-15.804857103595895, -9.241889402559726],
            [-15.804107018391967, -9.241479960819138],
            [-15.801685405233371, -9.243112234960538],
            [-15.800065293457292, -9.243521966317754],
            [-15.7981682680446, -9.243214646161103],
            [-15.796998328342793, -9.240109206652376],
            [-15.792760537253175, -9.23833863044912],
            [-15.791925303487005, -9.238598561817023],
            [-15.789913432563274, -9.236672369039638],
            [-15.784234572642335, -9.232724001177397],
            [-15.783395110495736, -9.231033763584387],
            [-15.782082251365535, -9.229804294203115],
            [-15.779024630630825, -9.228407535769],
            [-15.778636071677132, -9.226750609249317],
            [-15.780723368368607, -9.225158580553732],
            [-15.780409246563233, -9.223804964965485],
            [-15.779136418499393, -9.222677495451146],
            [-15.779357128555539, -9.21941779691343],
            [-15.776807090356696, -9.219347826642954],
            [-15.7736704187033, -9.218430766415004],
            [-15.772462586203684, -9.21723308148272],
            [-15.76933166364997, -9.217134830558601],
            [-15.767813565205767, -9.215754524222755],
            [-15.76624342492908, -9.21538326798869],
            [-15.764229056253784, -9.215556834515867],
            [-15.763043100966895, -9.216924157987476],
            [-15.761050154203307, -9.217639222270202],
            [-15.760024038715933, -9.216983424507683],
            [-15.759493002010258, -9.215188574530798],
            [-15.758255793637316, -9.214317648834156],
            [-15.757690920015541, -9.212861575057113],
            [-15.755977448769887, -9.211627233214536],
            [-15.753892193963377, -9.212049318734895],
            [-15.752514904628194, -9.213450238214376],
            [-15.751018320260675, -9.212973060593395],
            [-15.749208299524748, -9.210464738310176],
            [-15.74678738605302, -9.211640013487532],
            [-15.744304374123656, -9.210617834584632],
            [-15.744195573392066, -9.20859814981119],
            [-15.74254982653981, -9.20557954165761],
            [-15.74348820472583, -9.202903940985896],
            [-15.745326833155495, -9.200463989383719],
            [-15.744156485365071, -9.200331813950772],
            [-15.7424861004342, -9.20228379410127],
            [-15.742021427863806, -9.203449360064132],
            [-15.73810881258138, -9.202153378413543],
            [-15.731830339540537, -9.202868514348252],
            [-15.727154614058835, -9.202381601914452],
            [-15.722736548604681, -9.20275249674457],
            [-15.722066184798392, -9.203442683542837],
            [-15.719029409117597, -9.20418285114101],
            [-15.716044111654767, -9.203011620285078],
            [-15.713606010026735, -9.20358145198902],
            [-15.712049697720166, -9.205034029455506],
            [-15.71059311226102, -9.205335449822083],
            [-15.708555654644856, -9.204562848015645],
            [-15.705282068567655, -9.205024487663133],
            [-15.702822421110959, -9.204792783809998],
            [-15.699955190551153, -9.205882689794745],
            [-15.698011357697276, -9.20542238340498],
            [-15.696594872655995, -9.20566435997554],
            [-15.694543553043756, -9.203975609473211],
            [-15.692464509173009, -9.20375716272791],
            [-15.690566725495104, -9.202228237702807],
            [-15.69024322133113, -9.201365195291901],
            [-15.688290043072284, -9.201514764159503],
            [-15.688273307480124, -9.199289578669381],
            [-15.687569377364888, -9.198055153368427],
            [-15.685655597339101, -9.197533811670715],
            [-15.682199876737949, -9.1957893210242],
            [-15.681964327415907, -9.19206857341065],
            [-15.682854539359269, -9.19047137208483],
            [-15.682186103853793, -9.18931430444941],
            [-15.682176030378551, -9.18782968185691],
            [-15.680571117875736, -9.18644019978281],
            [-15.680580837382067, -9.183549699485487],
            [-15.679467070549546, -9.182200572302557],
            [-15.680268007175654, -9.181340423248518],
            [-15.679092877027081, -9.178421873903204],
            [-15.677934467880792, -9.174090748276763],
            [-15.673522433302088, -9.17067320432362],
            [-15.670858290030056, -9.16762258972765],
            [-15.669905889899482, -9.165858969075622],
            [-15.668144101469634, -9.165658032804542],
            [-15.666033929560134, -9.163667889785106],
            [-15.666740298834583, -9.162158304214303],
            [-15.664765535513864, -9.159344703269294],
            [-15.665842319745657, -9.157786425004572],
            [-15.667391848098415, -9.157428518715694],
            [-15.669479077145844, -9.157730650473388],
            [-15.67143097780292, -9.155874637501448],
            [-15.671507436809572, -9.154799497742989],
            [-15.669653217752058, -9.153779998774699],
            [-15.669284002158653, -9.152069170403017],
            [-15.671380926040342, -9.150446492731923],
            [-15.672062149826514, -9.148079545449038],
            [-15.670935077172034, -9.147125894480238],
            [-15.668636837746252, -9.146649442578825],
            [-15.666514499199163, -9.14762446891878],
            [-15.66445729822517, -9.14706285623994],
            [-15.662861398511554, -9.144998357531911],
            [-15.661016372135663, -9.141954846202509],
            [-15.659699321446638, -9.141937928024857],
            [-15.659011428033734, -9.140252212886123],
            [-15.65904225954188, -9.1387748280015],
            [-15.660320882500574, -9.137987286617093],
            [-15.660231251994972, -9.136441844496442],
            [-15.661475062466547, -9.13648853587859],
            [-15.665896960181051, -9.13377628991168],
            [-15.667576593831537, -9.131783824249034],
            [-15.669883395751903, -9.13266077466544],
            [-15.671033787503296, -9.130187278678871],
            [-15.671379216854572, -9.128041775199028],
            [-15.670764600818393, -9.126215589086652],
            [-15.671419881815275, -9.124197990463719],
            [-15.670792454709307, -9.121882168399484],
            [-15.671072538754512, -9.121273497686811],
            [-15.67068195803659, -9.118783169449193],
            [-15.6711524694837, -9.116131001859314],
            [-15.671071528786591, -9.114377245656984],
            [-15.67155452985234, -9.112602120766834],
            [-15.670450240198203, -9.109461211696217],
            [-15.670341754325804, -9.107327841418002],
            [-15.672543797994548, -9.105182659621534],
            [-15.67274674197492, -9.10385030053247],
            [-15.674439537546428, -9.101794369178611],
            [-15.675869022025344, -9.101368754599545],
            [-15.675826730301074, -9.099478780826255],
            [-15.674639063046168, -9.098380378227123],
            [-15.675130941965826, -9.096175508970028],
            [-15.677185044470681, -9.094766756617723],
            [-15.67950099916833, -9.095269085757604],
            [-15.68025054318936, -9.094443283537396],
            [-15.678934171010308, -9.092323518343719],
            [-15.676286746196794, -9.091578702105233],
            [-15.675008698161909, -9.090484506007115],
            [-15.67319316950632, -9.087402626400042],
            [-15.673241643001296, -9.08495530149112],
            [-15.671635906915242, -9.084261300651484],
            [-15.670133245835185, -9.084716712931195],
            [-15.668858978629105, -9.084265791172125],
            [-15.66640031100032, -9.0851296700095],
            [-15.664084078486532, -9.084627634279315],
            [-15.662440362700908, -9.082243909265493],
            [-15.662402245326112, -9.080664606834324],
            [-15.665735287894995, -9.078910806401165],
            [-15.665516138920726, -9.077893749839122],
            [-15.661671448636884, -9.077421062052368],
            [-15.658696260430029, -9.077463687898765],
            [-15.657933039068826, -9.076344127272431],
            [-15.659773749775756, -9.0747440824884],
            [-15.66092841874962, -9.072470866071086],
            [-15.661127243845977, -9.070163986066175],
            [-15.65875931516311, -9.069363719486933],
            [-15.657761060768658, -9.067661047882675],
            [-15.660345425508684, -9.064519837793053],
            [-15.66186955049275, -9.06506467167335],
            [-15.661745279858604, -9.063247195631858],
            [-15.659804018929947, -9.061225534613806],
            [-15.658439142895869, -9.061221069785024],
            [-15.655661123204064, -9.063328372941601],
            [-15.653232639644726, -9.063268845563456],
            [-15.65006412695792, -9.061004382629223],
            [-15.648794478785899, -9.058761329587748],
            [-15.646495532686373, -9.056956640839475],
            [-15.64452780236162, -9.056390803414331],
            [-15.643959716695495, -9.05565865212035],
            [-15.644063391690342, -9.053820083997495],
            [-15.643331669117897, -9.052679389612305],
            [-15.643370865059275, -9.050495962525419],
            [-15.640981758971304, -9.046814291106418],
            [-15.638221400174482, -9.04717617503441],
            [-15.637700623310243, -9.046099539027855],
            [-15.638424685759064, -9.042856197877262],
            [-15.63662907706785, -9.041660178106223],
            [-15.635888301728135, -9.042554159989947],
            [-15.635121344318437, -9.045235703708776],
            [-15.633243669869056, -9.045440432378948],
            [-15.632748954043246, -9.042907792575797],
            [-15.630863401087831, -9.03894951614366],
            [-15.631324403751746, -9.036782939642714],
            [-15.630075467957464, -9.03675756898795],
            [-15.629536765118974, -9.039085897934724],
            [-15.628236107809911, -9.040422581358818],
            [-15.62700467456837, -9.038984226726171],
            [-15.628404907163329, -9.03417021399689],
            [-15.627603908762534, -9.0332592419116],
            [-15.62657037897496, -9.03371904499015],
            [-15.626958376687039, -9.030365011397674],
            [-15.62569231909674, -9.02876504342354],
            [-15.624529541577616, -9.02853536858949],
            [-15.622005863671985, -9.03071501150609],
            [-15.620149644457227, -9.031034596266363],
            [-15.618698394945088, -9.030238722225533],
            [-15.618655545820422, -9.027685007176684],
            [-15.620494471434494, -9.026233476463428],
            [-15.620585174772774, -9.024790283481574],
            [-15.619697898192303, -9.023752133842754],
            [-15.61820795541603, -9.023147929640842],
            [-15.617324999135258, -9.023858836342043],
            [-15.617221520088515, -9.025586919998164],
            [-15.61614483930458, -9.025706348722673],
            [-15.614960643889228, -9.024033667555036],
            [-15.614715080870448, -9.022701700527504],
            [-15.613130224176276, -9.021127265233327],
            [-15.611739193284082, -9.021804257912141],
            [-15.612776998674269, -9.024200307062877],
            [-15.612652089986987, -9.025924244725822],
            [-15.611411771877213, -9.026409654014785],
            [-15.610093948597038, -9.026060778678554],
            [-15.60870727611596, -9.024171485058751],
            [-15.607811419954164, -9.020740807974816],
            [-15.604766264291483, -9.01653202047252],
            [-15.603129592289136, -9.015766284580321],
            [-15.601669553965063, -9.015788017254252],
            [-15.601105362184336, -9.014924157884723],
            [-15.59982194142096, -9.01495853200171],
            [-15.598280172654308, -9.015827251920884],
            [-15.597199257196701, -9.015636075051658],
            [-15.595071666844476, -9.016743419669325],
            [-15.594076790175542, -9.016679850957631],
            [-15.591918854607655, -9.01450564212094],
            [-15.5915482620281, -9.013347866716394],
            [-15.592870280984096, -9.011793870480746],
            [-15.592182925498518, -9.010414488330873],
            [-15.592245522490671, -9.008350630060976],
            [-15.591801774670815, -9.007444159889188],
            [-15.590104682282703, -9.006533929543458],
            [-15.588937075094266, -9.003891238860945],
            [-15.58761895683362, -9.002767844681179],
            [-15.588419883370605, -9.001686766322196],
            [-15.5866622916611, -8.9999677006322],
            [-15.586851644266757, -8.999031337385707],
            [-15.585589394911857, -8.997520786690217],
            [-15.585529059251316, -8.99660127913158],
            [-15.584305536523997, -8.99556324983215],
            [-15.584167463685931, -8.994252343354841],
            [-15.584955375664684, -8.992958361664746],
            [-15.584141232884791, -8.99227773295073],
            [-15.584097904436662, -8.990719865134771],
            [-15.583167364153535, -8.990005104733257],
            [-15.583727127033963, -8.988898158209613],
            [-15.582133109583602, -8.988141393840406],
            [-15.58199080959468, -8.98696218962295],
            [-15.584514816006271, -8.985888920336778],
            [-15.583674530711876, -8.984506094610339],
            [-15.58198140439875, -8.983574330028308],
            [-15.581782995393427, -8.982672398721071],
            [-15.583264672425244, -8.981990937556017],
            [-15.583540201700782, -8.98051809327843],
            [-15.580370021177448, -8.981685262049663],
            [-15.580191322218893, -8.980380262680766],
            [-15.581183565326553, -8.978866386931443],
            [-15.580616233062079, -8.976721179886919],
            [-15.580730685728467, -8.975092075757386],
            [-15.581536023834271, -8.973176756223072],
            [-15.582446101332195, -8.972382074445786],
            [-15.583993087780515, -8.972317273935657],
            [-15.582717607736477, -8.969783237406928],
            [-15.583288911799787, -8.966828825002276],
            [-15.58169143357173, -8.966053923976865],
            [-15.582626673053808, -8.963408690052512],
            [-15.585121403007102, -8.962043588901928],
            [-15.584502150467557, -8.959930458066417],
            [-15.585952431709325, -8.958870587663647],
            [-15.585786778277463, -8.957880995473811],
            [-15.584125550236674, -8.957628341625693],
            [-15.584780502857434, -8.956326400097169],
            [-15.586583286107128, -8.957306123535643],
            [-15.589166359375813, -8.956923859246578],
            [-15.588222369623924, -8.955719528883659],
            [-15.589484691942904, -8.954425321977569],
            [-15.590325648531707, -8.956232239242546],
            [-15.59127492158167, -8.956654834925352],
            [-15.59239194744833, -8.955841264267717],
            [-15.591187071199668, -8.954231216875666],
            [-15.588052175364318, -8.951785005870146],
            [-15.585306128587796, -8.951042603505304],
            [-15.583029340422524, -8.949129469684692],
            [-15.58303824404892, -8.948042784799993],
            [-15.581619685972553, -8.947357604884578],
            [-15.57997398182258, -8.94576411509576],
            [-15.57898238491261, -8.943085946897655],
            [-15.579216552554291, -8.937264383864706],
            [-15.578735016510128, -8.93294185050128],
            [-15.578344680164921, -8.932177662883522],
            [-15.574520259459874, -8.927330809154821],
            [-15.570988579440693, -8.924937802378933],
            [-15.568657489914498, -8.92478663223338],
            [-15.566720386686116, -8.925319757006957],
            [-15.562106242638375, -8.92740520022108],
            [-15.559206802339002, -8.929124138685276],
            [-15.556467130920904, -8.927774262101007],
            [-15.553359297561068, -8.928578787478386],
            [-15.551075711602618, -8.926504956202454],
            [-15.550304168948463, -8.926220052596268],
            [-15.548725722788287, -8.923789206760226],
            [-15.547638780973989, -8.922976403818277],
            [-15.548586415952977, -8.921501284973335],
            [-15.548552451302566, -8.920477702561357],
            [-15.54662408874648, -8.92053312675373],
            [-15.546869920283937, -8.918745649319987],
            [-15.545294908939077, -8.916992622224107],
            [-15.546982421881893, -8.915386850557207],
            [-15.545527660776804, -8.915158667181565],
            [-15.544959156187579, -8.913859162211924],
            [-15.542777300615759, -8.912788156698397],
            [-15.540886829406508, -8.91272109256881],
            [-15.53984220718689, -8.911236609703726],
            [-15.538376476157161, -8.91017339909566],
            [-15.536806407357238, -8.907850570124696],
            [-15.536417495100881, -8.906114700028594],
            [-15.533801497827058, -8.905643460225809],
            [-15.534257052407101, -8.903719728152618],
            [-15.532614221509295, -8.902311956305464],
            [-15.531665894012788, -8.900680611234366],
            [-15.52886759553588, -8.899671064266506],
            [-15.52785829154134, -8.898454499067883],
            [-15.52572035097686, -8.897723774229307],
            [-15.525214763080351, -8.896009245590895],
            [-15.521706545667078, -8.895517407491969],
            [-15.519744897753935, -8.894467485842702],
            [-15.520459380058366, -8.8932584725416],
            [-15.519100473007482, -8.891442089354639],
            [-15.514424215500577, -8.890853219523063],
            [-15.514087237112879, -8.889857798599522],
            [-15.515586511819834, -8.889311968299127],
            [-15.515275191158414, -8.888078244831723],
            [-15.51333584815032, -8.888028277632078],
            [-15.512328361003371, -8.889135228361418],
            [-15.510724063031805, -8.887867961581481],
            [-15.509539694985715, -8.88885188833866],
            [-15.508298133116607, -8.88823126901864],
            [-15.508546918030994, -8.886886446195904],
            [-15.506769991683734, -8.885363924858678],
            [-15.50539591129778, -8.886177611357269],
            [-15.504229729879166, -8.888182780154155],
            [-15.503200186433654, -8.888732409175045],
            [-15.501772250109601, -8.886924450991847],
            [-15.500359497551761, -8.88792972797618],
            [-15.498582384565998, -8.886130909751419],
            [-15.497536499783468, -8.887706267023768],
            [-15.494865141631681, -8.888286745095224],
            [-15.495030064943407, -8.889580259417794],
            [-15.493884038732055, -8.890040684110646],
            [-15.49213337692973, -8.888833212086636],
            [-15.49148784261172, -8.889923278090077],
            [-15.491808203422622, -8.891557130295487],
            [-15.490511274496564, -8.891655722577966],
            [-15.489687115738448, -8.89063090293294],
            [-15.488493692036256, -8.890882743095135],
            [-15.487241068861525, -8.892428554420974],
            [-15.485732889414974, -8.892574114808857],
            [-15.485115653657463, -8.891634347559876],
            [-15.482881770520038, -8.889933775542925],
            [-15.479149946153939, -8.890106807277594],
            [-15.477265538841998, -8.889005947674324],
            [-15.477229670026519, -8.88762728486521],
            [-15.47566738895614, -8.885372867785405],
            [-15.476475783570592, -8.883695573439441],
            [-15.475655823926292, -8.88253890426904],
            [-15.474315009205583, -8.882075993801008],
            [-15.472609204997633, -8.882924254700795],
            [-15.47263742906728, -8.885175417910775],
            [-15.473592979437173, -8.888106611358255],
            [-15.47143099915092, -8.889495801137013],
            [-15.469404782789148, -8.888765491729169],
            [-15.467339028601009, -8.88734163136513],
            [-15.466773244365335, -8.886256878088249],
            [-15.467503545947796, -8.884077333855684],
            [-15.465798883227388, -8.881861552596224],
            [-15.463660684281844, -8.88124201499827],
            [-15.462935235170104, -8.880059816091501],
            [-15.463187745223973, -8.878361441148916],
            [-15.460168384627828, -8.876108714558057],
            [-15.46016974727855, -8.873542592026839],
            [-15.461681873725503, -8.869260479956612],
            [-15.461355738378632, -8.866652178760697],
            [-15.460104294704815, -8.865299728126082],
            [-15.458331926713178, -8.864531169261536],
            [-15.456880736949135, -8.865617629085428],
            [-15.455898206841464, -8.865712097319642],
            [-15.453658342576375, -8.863258717104273],
            [-15.454565797002504, -8.861645028039451],
            [-15.452974325491507, -8.860812383126843],
            [-15.449000513040588, -8.857343499094064],
            [-15.447905662530262, -8.857327645991303],
            [-15.44508407129751, -8.858542911281809],
            [-15.444385489789866, -8.8582286734143],
            [-15.443796012646729, -8.855701710952308],
            [-15.442838440952842, -8.855115259730844],
            [-15.440314316384779, -8.856411182444546],
            [-15.438981258591252, -8.85546367854771],
            [-15.439733483924808, -8.853841411040275],
            [-15.440319923713181, -8.850815428043884],
            [-15.44202127760716, -8.849933038884176],
            [-15.442032813443355, -8.848873516308162],
            [-15.440988816544406, -8.848159553268816],
            [-15.437639714681684, -8.848209527680892],
            [-15.438271904230861, -8.84707270179034],
            [-15.437011401366922, -8.845652637812984],
            [-15.435624080345384, -8.846087903823422],
            [-15.434063263383047, -8.845825676040295],
            [-15.432104268733655, -8.844312835646061],
            [-15.431765228163885, -8.842210998907033],
            [-15.432090580209993, -8.840593664300881],
            [-15.431592824253851, -8.839168813194199],
            [-15.431998872360381, -8.836704446555531],
            [-15.431389546723935, -8.835611657481245],
            [-15.428842332965882, -8.835907663872252],
            [-15.42743549990605, -8.8377772371004],
            [-15.42636936147649, -8.836838039920872],
            [-15.426719054934408, -8.8350326019717],
            [-15.426141629512244, -8.834293495104086],
            [-15.426160421146385, -8.832571419698908],
            [-15.426780155680287, -8.831675904723898],
            [-15.42668719849052, -8.830020743958368],
            [-15.426015648637705, -8.82767679717857],
            [-15.424924458945885, -8.827307812315802],
            [-15.423080150418484, -8.827786011932764],
            [-15.420973848261402, -8.828898869813214],
            [-15.419563590369261, -8.82844514162919],
            [-15.417341055975049, -8.82400516506965],
            [-15.415894644293278, -8.822504507203895],
            [-15.415637898811196, -8.82088359389124],
            [-15.414264798358987, -8.8194639775324],
            [-15.412815659452114, -8.819035697321246],
            [-15.411654283001504, -8.817956182915044],
            [-15.411354123549511, -8.816216283889451],
            [-15.411388603386369, -8.813480056826252],
            [-15.414887152893096, -8.812242403661227],
            [-15.415242329347615, -8.810586927162134],
            [-15.414029724416933, -8.809817913949054],
            [-15.41287193611603, -8.808329922022798],
            [-15.413299009954818, -8.805759837505068],
            [-15.410817380617978, -8.80416683288212],
            [-15.411397249058988, -8.802842980793413],
            [-15.409705996788821, -8.799436541175332],
            [-15.41021487316415, -8.79690424053176],
            [-15.409280205541071, -8.79486302439617],
            [-15.409127073945264, -8.793506157427478],
            [-15.410589659586448, -8.791581402571449],
            [-15.410945547412812, -8.790368393745906],
            [-15.411138359589446, -8.78577994075542],
            [-15.410557330376673, -8.785161165941638],
            [-15.410640557382276, -8.783297459038385],
            [-15.409127633922738, -8.78368627697435],
            [-15.408687898957501, -8.781189327813951],
            [-15.40727501529849, -8.779518783221848],
            [-15.406888901237576, -8.778093991066747],
            [-15.404866788488528, -8.775773001675011],
            [-15.405100175835388, -8.773607176555926],
            [-15.402555298741413, -8.770763738350416],
            [-15.401782858131938, -8.768024806504727],
            [-15.401992457996558, -8.76709288972902],
            [-15.400486408098823, -8.76644362195385],
            [-15.40113001735696, -8.764634545674832],
            [-15.399530442818783, -8.764840757542013],
            [-15.399041833262563, -8.764037045435863],
            [-15.399823958911472, -8.762598105919361],
            [-15.398325951713078, -8.761685269011249],
            [-15.399876104400478, -8.760441340497108],
            [-15.399158739205445, -8.759659377416847],
            [-15.394701752526503, -8.758409111951947],
            [-15.391679761644788, -8.754366698296863],
            [-15.39151111697816, -8.751801593696662],
            [-15.389982406182273, -8.75076102817667],
            [-15.390297880862466, -8.748854764683461],
            [-15.386983193561322, -8.747497111836537],
            [-15.389291523788463, -8.745826657643367],
            [-15.387412815263318, -8.744463479704416],
            [-15.386802083635784, -8.740916088862292],
            [-15.386140289465203, -8.739968165743212],
            [-15.383741932442545, -8.739741274370916],
            [-15.38364517528042, -8.738771370811346],
            [-15.38199871341649, -8.737143895681987],
            [-15.378421379249385, -8.736088776315555],
            [-15.378552708538331, -8.734986852891893],
            [-15.375803907045656, -8.732148213834263],
            [-15.37444775807215, -8.731441456847573],
            [-15.372102125812555, -8.730871172668675],
            [-15.371733492925987, -8.732709040818452],
            [-15.337530815384989, -8.902691238469808],
            [-15.314858167742164, -9.015316642745791],
            [-15.313827487814713, -9.020435485016842],
            [-15.247150991555452, -9.352439710949747],
            [-15.184835300480858, -9.66249464085696],
            [-15.169062466817289, -9.740928516375874],
            [-15.165647296072361, -9.757909616071144],
            [-15.145884751293945, -9.856157275678298],
            [-15.137613343131589, -9.897269290293982],
            [-15.126703835494519, -9.95150015809043],
            [-15.110254773576699, -10.033252546211383],
            [-15.104025248841825, -10.064207921811683],
            [-15.10382222128971, -10.06570356583839],
            [-15.237660521714147, -10.090971384986215],
            [-15.247173477113094, -10.040428900588612],
            [-15.251298801000306, -10.018507985613503],
            [-15.280718561020619, -10.02367044392435],
            [-15.283639313924716, -10.007907605562453],
            [-15.277606001878652, -10.006821138230329],
            [-15.281970844598005, -9.983338683675402],
            [-15.299518078590639, -9.888920700942625],
            [-15.323046751581668, -9.89313753053135],
            [-15.328502169574552, -9.86365941758295],
            [-15.358130446382935, -9.868891782702754],
            [-15.363455948330804, -9.839390822070467],
            [-15.393747525977231, -9.844655213179117],
            [-15.394215325271373, -9.845520851490866],
            [-15.396930454307894, -9.845645004654084],
            [-15.397301966537405, -9.84499757263789],
            [-15.399575066056293, -9.84491414316061],
            [-15.402201424419792, -9.845357378119541],
            [-15.404052827899346, -9.844978847889836],
            [-15.406145966822024, -9.843462606064515],
            [-15.407681432435128, -9.843935132961],
            [-15.408465111671912, -9.847131737713859],
            [-15.410746578272091, -9.848093003942859],
            [-15.413339444136092, -9.848145405871515],
            [-15.413085874041215, -9.846293892404889],
            [-15.414344023598007, -9.843593603260075],
            [-15.41521513259086, -9.842580883735257],
            [-15.417558152367416, -9.843080286302644],
            [-15.41889865589262, -9.842499162495628],
            [-15.42146981998085, -9.842311399203506],
            [-15.42226462888508, -9.840976468786893],
            [-15.423815667217633, -9.840212257705776],
            [-15.4292591273703, -9.840294106937185],
            [-15.430795858837714, -9.842387471871097],
            [-15.431486319719093, -9.84560868786506],
            [-15.430527573157493, -9.846597849783745],
            [-15.430435732542906, -9.848744551755482],
            [-15.429761983480047, -9.849743885074705],
            [-15.430616455426643, -9.850855816073242],
            [-15.43246880982347, -9.851646348143495],
            [-15.432381175089047, -9.853528415460188],
            [-15.431761761570815, -9.856155266941572],
            [-15.429377252691115, -9.85878911719094],
            [-15.4295817956334, -9.859891701797647],
            [-15.431256638032508, -9.860328368913793],
            [-15.433097769893429, -9.860013476308378],
            [-15.435487617078884, -9.860937804656697],
            [-15.437105171692608, -9.862410427489408],
            [-15.43775780805112, -9.865546585806081],
            [-15.438661856708126, -9.866617016619102],
            [-15.437911546541596, -9.867816964671942],
            [-15.439633258929211, -9.869205021137567],
            [-15.439570569049193, -9.871135215687287],
            [-15.441307725134754, -9.873464540713739],
            [-15.441477706866133, -9.875090505977164],
            [-15.440777378395953, -9.877257399680271],
            [-15.441901257991148, -9.879051610272171],
            [-15.440279375692889, -9.881848803094842],
            [-15.442985484230132, -9.882231601019026],
            [-15.445121810133218, -9.881736120947298],
            [-15.446390836660992, -9.880332465446365],
            [-15.448495525405843, -9.881862332787307],
            [-15.451478576173416, -9.881524141771703],
            [-15.454439798856399, -9.879972280374025],
            [-15.456096359806063, -9.880608996509824],
            [-15.45644749825845, -9.882719524676931],
            [-15.456329480660497, -9.885112091617437],
            [-15.458060758461295, -9.886503834565955],
            [-15.46171884037337, -9.886413265554877],
            [-15.462819181782619, -9.885332212531214],
            [-15.463992856775688, -9.88516788013329],
            [-15.467161638873108, -9.882870668115276],
            [-15.468653377194642, -9.88217447179939],
            [-15.468837777433812, -9.880858732696588],
            [-15.470655866532775, -9.881619241800383],
            [-15.471896234184053, -9.881320661840427],
            [-15.47418162945671, -9.882880942432191],
            [-15.477396380289687, -9.882998021242397],
            [-15.479975758239679, -9.8836865250691],
            [-15.480390977315636, -9.884701991629557],
            [-15.48191131959304, -9.883754970441396],
            [-15.484419066780061, -9.884034884884947],
            [-15.485292043495784, -9.881859779236972],
            [-15.486853525575112, -9.880809194390007],
            [-15.488248446361286, -9.880493723208327],
            [-15.490972637650211, -9.880727203902659],
            [-15.492615191865161, -9.879839459755168],
            [-15.493466313618923, -9.87805968277852],
            [-15.494645566709865, -9.87710036177459],
            [-15.494868202264056, -9.87511901164561],
            [-15.496269746111185, -9.87383428968658],
            [-15.49732830104688, -9.873556891587107],
            [-15.497185683351367, -9.871760653828124],
            [-15.495220023482437, -9.868285930785621],
            [-15.493584755059885, -9.86807819241728],
            [-15.491136043418495, -9.868704976980968],
            [-15.48907386278255, -9.867142363477587],
            [-15.490523916502243, -9.865728544259673],
            [-15.491682356389974, -9.863840898467783],
            [-15.491817039978987, -9.860308425152702],
            [-15.493746708429924, -9.860014186697747],
            [-15.494626120492738, -9.85924859420755],
            [-15.494272943381407, -9.857422801767576],
            [-15.49331145536934, -9.85562524820858],
            [-15.491477079947105, -9.854179292278799],
            [-15.488884202810844, -9.854191616616648],
            [-15.487354197781844, -9.853056706136657],
            [-15.487761833042587, -9.850496829283388],
            [-15.486299090774548, -9.849564750344099],
            [-15.485371951332226, -9.84728686519403],
            [-15.485640351787715, -9.845501772930353],
            [-15.484854342131035, -9.84417063116633],
            [-15.485312816482066, -9.842859790024217],
            [-15.484826708103522, -9.840897879294756],
            [-15.483493247679359, -9.840992531334333],
            [-15.482741895000586, -9.839375090424069],
            [-15.48069648034312, -9.836644410315253],
            [-15.480551187199955, -9.834706139848144],
            [-15.479908376317184, -9.832286723750261],
            [-15.478091282563453, -9.829586711040088],
            [-15.48007715901929, -9.82746203529505],
            [-15.481776039157323, -9.82760131553164],
            [-15.48267964355862, -9.828934444902995],
            [-15.485480499235877, -9.829705849517227],
            [-15.487026545816448, -9.829479467255899],
            [-15.489228223201021, -9.828463662960864],
            [-15.490445436664631, -9.826638054792726],
            [-15.49327935688293, -9.82483657151321],
            [-15.496009703847335, -9.823827750831411],
            [-15.49693774540475, -9.822317355475395],
            [-15.498442636775163, -9.822089527680742],
            [-15.500844225932378, -9.820529467398902],
            [-15.504347183315888, -9.821905223647],
            [-15.506692089867093, -9.82045224692943],
            [-15.507050958957864, -9.818266855088972],
            [-15.511210842075283, -9.816676989194768],
            [-15.51270521483301, -9.814840871251675],
            [-15.51282813974565, -9.81357204735976],
            [-15.510373937622505, -9.811921932008906],
            [-15.50863997857422, -9.812364284949021],
            [-15.506343363683747, -9.810602279537935],
            [-15.506403824018012, -9.8080021775915],
            [-15.506986043676747, -9.804656004280558],
            [-15.506171033770393, -9.802495281854604],
            [-15.50481738241615, -9.80121015492169],
            [-15.502278706783265, -9.80174304641331],
            [-15.501887544043184, -9.795066980602446],
            [-15.500583639825406, -9.79512408856231],
            [-15.499641454043113, -9.794162406645134],
            [-15.4980040351144, -9.793454866500783],
            [-15.498306651866393, -9.790740336434062],
            [-15.49738523061824, -9.787765175616789],
            [-15.49572242173612, -9.787333762768082],
            [-15.495523990781878, -9.785784965388672],
            [-15.494569959359312, -9.78449845436613],
            [-15.494234203456452, -9.782223068073744],
            [-15.495735491115834, -9.78046872051667],
            [-15.494975057486675, -9.778482473844894],
            [-15.492430369748508, -9.776512738490117],
            [-15.491954487437416, -9.774587877135964],
            [-15.491184386343576, -9.774044520640773],
            [-15.491178306309765, -9.77109922457834],
            [-15.493299559635705, -9.770560430883945],
            [-15.492799390916193, -9.769532338442376],
            [-15.49323942749493, -9.76767926166857],
            [-15.492460527067818, -9.766613771258118],
            [-15.493207739598587, -9.763615483028648],
            [-15.494328361789934, -9.761431653009312],
            [-15.491834872503615, -9.76016154288209],
            [-15.48988007005573, -9.75984486985921],
            [-15.488869980718798, -9.758878339312522],
            [-15.48847033836843, -9.75585987400082],
            [-15.489690037888217, -9.753385943073448],
            [-15.490114492536035, -9.75148582043857],
            [-15.491978133503073, -9.75135606504552],
            [-15.494356095785582, -9.750626069552903],
            [-15.496862621680082, -9.751184227844204],
            [-15.498569036966508, -9.751094881476956],
            [-15.499956842891258, -9.750237491947168],
            [-15.50226494093244, -9.750648620702494],
            [-15.504075650752315, -9.749295488877975],
            [-15.505989674305242, -9.749787617347675],
            [-15.504952703400354, -9.746128553805661],
            [-15.505280831147704, -9.74549010698285],
            [-15.504744925522408, -9.743438526552659],
            [-15.505465895181764, -9.741191981279826],
            [-15.506152349919155, -9.740326711265315],
            [-15.51029254114538, -9.739513458683058],
            [-15.511758831901526, -9.73897692928284],
            [-15.512669766969129, -9.737344093610428],
            [-15.511336791559568, -9.733672531386844],
            [-15.513232417584572, -9.730424246573001],
            [-15.513006071090462, -9.729315016262934],
            [-15.513977928279283, -9.727586956147574],
            [-15.51353585162533, -9.726538997397693],
            [-15.51466612852273, -9.723370702748097],
            [-15.514351141537523, -9.72127037884367],
            [-15.516621833192515, -9.719434753160686],
            [-15.517763446283055, -9.717465665247001],
            [-15.518548865335148, -9.715342553253654],
            [-15.517456166084472, -9.713414507965746],
            [-15.59300222111012, -9.725435922520543],
            [-15.668169423606823, -9.736558562193059],
            [-15.743333417303473, -9.747701870948385],
            [-15.744041505569617, -9.74282795201864],
            [-15.755752581645991, -9.744470195479686],
            [-15.833784084913074, -9.755074642272552],
            [-15.837822392527311, -9.725380991244466],
            [-15.840706182598637, -9.725761422083512],
            [-15.913953399729632, -9.734888040773052],
            [-15.987198003220458, -9.744034759599026],
            [-15.986441320377425, -9.750299351240196],
            [-15.987981034857105, -9.752188152699084],
            [-15.987943091277133, -9.753531419670969],
            [-15.990325234114254, -9.756054599415119],
            [-15.9914436719434, -9.75662611479152],
            [-15.993535427534791, -9.756772237130136],
            [-15.994994637712676, -9.756141072299185],
            [-15.998020998007249, -9.758320959148566],
            [-16.00267542016688, -9.757339885236116],
            [-16.003710648994307, -9.757972440541122],
            [-16.00579437465691, -9.757332832525812],
            [-16.00972360488845, -9.75776163227593],
            [-16.011738827486457, -9.757315637971647],
            [-16.013501314834205, -9.757629819848024],
            [-16.018316236903292, -9.757261113541412],
            [-16.020123909949767, -9.757324184583714],
            [-16.021205770746413, -9.758374505849105],
            [-16.02279604686407, -9.758090615380878],
            [-16.02333891407498, -9.759154026853071],
            [-16.02838149157334, -9.760158309063154],
            [-16.038927800598284, -9.76347571527992],
            [-16.041801532608442, -9.765231411530928],
            [-16.04368329422309, -9.765992238131686],
            [-16.045090048077142, -9.767661488980261],
            [-16.057305712529658, -9.661608187997938],
            [-16.135687910949855, -9.670087771850469],
            [-16.147194939973584, -9.562802599331118],
            [-16.149412447834955, -9.542124235060122],
            [-16.164434930056693, -9.4020377430284]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -143.21296811693776,
          "lat": 63.87615362883283
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02240"],
        "coty_name": ["Southeast Fairbanks"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Southeast Fairbanks Census Area"],
        "coty_fp_code": "240",
        "coty_gnis_code": "01419983"
      },
      "bbox": [
        -16.164434930056693, -10.090971384986215, -15.10382222128971,
        -8.730871172668675
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.836573483391657, 2.0157373775529366],
            [-19.823387795122592, 2.013711622544147],
            [-19.81901313074859, 2.0110309684155476],
            [-19.809786800778927, 2.011756262106597],
            [-19.808438881020155, 2.013903271260924],
            [-19.802597893674324, 2.01505225890891],
            [-19.797945683365764, 2.011584125409748],
            [-19.79650139347188, 2.006836152751632],
            [-19.793608555963317, 2.006228336564526],
            [-19.79015588737333, 1.9961104948033601],
            [-19.791388268260114, 1.9921000603595735],
            [-19.78729475056978, 1.985648724864667],
            [-19.784434368430112, 1.9863052248288544],
            [-19.77766886828829, 1.9819754313288385],
            [-19.774419152819387, 1.9784786247504693],
            [-19.771578379575626, 1.9677198938368092],
            [-19.77536027302713, 1.964275392685925],
            [-19.77094459925451, 1.9528458694064628],
            [-19.770667510591867, 1.9494908351842324],
            [-19.766511100213325, 1.9475299340193397],
            [-19.765839727266474, 1.943864231927783],
            [-19.76258136362525, 1.938461463667587],
            [-19.76343538759575, 1.936928227017545],
            [-19.756628578885604, 1.9270756355214584],
            [-19.760913974090794, 1.9211377351019094],
            [-19.762297441155795, 1.9158073382108907],
            [-19.757105907994408, 1.9083006077813962],
            [-19.749620720435242, 1.903146417408471],
            [-19.741240142625934, 1.905529500323262],
            [-19.735927722600763, 1.8996342172898721],
            [-19.73201919716065, 1.8890315182533657],
            [-19.68694434499681, 1.8717343654820138],
            [-19.662387405997315, 1.8625361582368711],
            [-19.653927287907976, 1.849257678945095],
            [-19.643439985354966, 1.838347493842604],
            [-19.63566394052845, 1.8185881963562411],
            [-19.647980852710656, 1.8134123493359129],
            [-19.650835974357694, 1.806142318641442],
            [-19.645061016659728, 1.7957163651741104],
            [-19.640989352709003, 1.7938648248598108],
            [-19.636881674038058, 1.787260012202003],
            [-19.631411437909343, 1.7835841833662822],
            [-19.625466055614204, 1.7810996983673917],
            [-19.619705517255756, 1.7671247543972088],
            [-19.605184734177232, 1.7676879679426905],
            [-19.578818550383435, 1.7681907435365092],
            [-19.498790637692505, 1.7707751663044007],
            [-19.472426760752583, 1.7714065821180986],
            [-19.438656186192173, 1.77281212538308],
            [-19.36984895025723, 1.7752734024224566],
            [-19.352901413442048, 1.7751177865772747],
            [-19.340368603872925, 1.7760812041156882],
            [-19.289233122305443, 1.7779628221652035],
            [-19.318445482909738, 1.6721135802622478],
            [-19.337674047327546, 1.6018429294413024],
            [-19.362416650134204, 1.5114923319605138],
            [-19.358634447121915, 1.5068905315528989],
            [-19.356899842353947, 1.4992928775440384],
            [-19.354552413656112, 1.49622055976691],
            [-19.348686823120033, 1.4932155442167083],
            [-19.34126010000632, 1.48679352358912],
            [-19.325389021844558, 1.4827414617281287],
            [-19.3236499112075, 1.4795666321086902],
            [-19.327816521776366, 1.4765691092609898],
            [-19.325532295356552, 1.4696524681598082],
            [-19.32662607186512, 1.4620750035671417],
            [-19.325152890035934, 1.4590351349444333],
            [-19.316993148383602, 1.4557656262696086],
            [-19.31627077273937, 1.4503800010330443],
            [-19.313969717190055, 1.44847936626726],
            [-19.310487013418257, 1.4413342908793911],
            [-19.314567284203118, 1.4345224056407868],
            [-19.315011682693417, 1.4350495365960902],
            [-19.31519846264549, 1.435271450855702],
            [-19.384426481662903, 1.4544173351087841],
            [-19.46466879729032, 1.4768989714899274],
            [-19.51465424809183, 1.4919502723455382],
            [-19.61169498112224, 1.5197399232896744],
            [-19.61753475732625, 1.5157140998962164],
            [-19.623309420394325, 1.5131187908032395],
            [-19.626590813194568, 1.5101789009487394],
            [-19.630964017786983, 1.5112184524458898],
            [-19.635498857383954, 1.5089872557365038],
            [-19.652649932321314, 1.5076975996451372],
            [-19.65408045511768, 1.5064350498260815],
            [-19.665217684699293, 1.5027733204809655],
            [-19.668954158502153, 1.5071767966329832],
            [-19.671153865445078, 1.5135982516207271],
            [-19.673478011293795, 1.5136877102325739],
            [-19.67633508872107, 1.5176979777866386],
            [-19.680608853347202, 1.515107818341998],
            [-19.68358601873439, 1.5155386748027249],
            [-19.688621787503486, 1.5191018291132685],
            [-19.70102887490037, 1.5196682142436058],
            [-19.705005026869145, 1.5209418313430265],
            [-19.713561311584726, 1.5272687687840145],
            [-19.715784073783958, 1.530408268641026],
            [-19.73476847371581, 1.5337430817005853],
            [-19.74640132336474, 1.5368283833452283],
            [-19.75052534209785, 1.535782258390381],
            [-19.756430174748697, 1.54081227640824],
            [-19.757169764494314, 1.548614967903114],
            [-19.752776814279514, 1.5703533274300772],
            [-19.771536607798275, 1.5822739388451728],
            [-19.779474937297913, 1.5835111476825616],
            [-19.787763295195546, 1.5823025938984203],
            [-19.792149566594517, 1.5867021613501144],
            [-19.79159755151456, 1.594229683304879],
            [-19.786264796283124, 1.6150348279015854],
            [-19.790178837552546, 1.6494285005872489],
            [-19.79350663441894, 1.6527695795495105],
            [-19.793760235765003, 1.6584017689527302],
            [-19.796211862308127, 1.6734398193674829],
            [-19.796393798852087, 1.6803556203816572],
            [-19.790693549476646, 1.6986537732574472],
            [-19.790887684033297, 1.7125014374071812],
            [-19.786226784252644, 1.73361079853397],
            [-19.785556089114927, 1.7572558233551046],
            [-19.787561468776918, 1.7709638108480996],
            [-19.793610516800104, 1.7786118117630938],
            [-19.796209994009363, 1.7879165245235742],
            [-19.798795662200966, 1.787904531507096],
            [-19.802513222740828, 1.7944210006011665],
            [-19.805520304724652, 1.8052431517300493],
            [-19.80568260755921, 1.812192036277272],
            [-19.81267731764267, 1.8114094459334737],
            [-19.814053135150836, 1.804499970490709],
            [-19.81705816074793, 1.8024485868157105],
            [-19.823920715819163, 1.8120259538349717],
            [-19.838195458108437, 1.8353975950962005],
            [-19.834553100170698, 1.837324102027898],
            [-19.838118672416492, 1.846623971545571],
            [-19.84078320382464, 1.8515124251656834],
            [-19.84028481869394, 1.8553146920265826],
            [-19.82576693273966, 1.8584620028428422],
            [-19.824611546904816, 1.859692584602568],
            [-19.842990728936297, 1.8751071225197637],
            [-19.844148111824488, 1.8798709375245897],
            [-19.846809741343925, 1.8831415380206964],
            [-19.850751953227125, 1.8797725433852226],
            [-19.85501978065175, 1.881771192553264],
            [-19.853701281179344, 1.8857343169699055],
            [-19.861063015753817, 1.8916004612378192],
            [-19.8649636010681, 1.8966579854284926],
            [-19.87157225065311, 1.8990487563056604],
            [-19.872513057611993, 1.902550762640758],
            [-19.879768047480056, 1.906388136410378],
            [-19.880897885575667, 1.9126866366418784],
            [-19.878161214435245, 1.920373796977852],
            [-19.878896181820433, 1.9270199556276542],
            [-19.883796688556238, 1.9329102769369007],
            [-19.875398035219746, 1.9360262890957216],
            [-19.867882693100718, 1.9331867096759925],
            [-19.862059972903744, 1.9379633624126977],
            [-19.862713504442453, 1.941104637699199],
            [-19.870704283503745, 1.94495092535339],
            [-19.858108241963, 1.9484630528018994],
            [-19.850959659732982, 1.9450544798194243],
            [-19.84313294855314, 1.9453938429175432],
            [-19.8420309996249, 1.9533525625234127],
            [-19.855346282509775, 1.9576187398102514],
            [-19.852535975357018, 1.9625901141221997],
            [-19.84178616340276, 1.9576160442173496],
            [-19.841611112482976, 1.9636702974466829],
            [-19.839253003339238, 1.9726489011505317],
            [-19.842449347071742, 1.981363043914859],
            [-19.85004950868078, 1.9791934578640835],
            [-19.84929734801858, 1.9869200814784704],
            [-19.851982139673407, 1.9959703807668938],
            [-19.84678765164423, 1.9955764591684515],
            [-19.84407612052, 1.9893967983021843],
            [-19.840369304250043, 1.9891090759839138],
            [-19.84012729365882, 1.9983726180050212],
            [-19.842248141983244, 2.004367615398814],
            [-19.849288022896832, 2.0103512038576175],
            [-19.848244148951206, 2.0140205797697965],
            [-19.839691850977786, 2.0113173205140558],
            [-19.835018086305865, 2.0107769869807512],
            [-19.836573483391657, 2.0157373775529366]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.88874061384263,
          "lat": 37.64683793722775
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06001"],
        "coty_name": ["Alameda"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alameda County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01675839"
      },
      "bbox": [
        -19.883796688556238, 1.4345224056407868, -19.289233122305443,
        2.0157373775529366
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.471621723029635, 3.202134319950285],
            [-18.46808207350816, 3.2048437796569456],
            [-18.460236514496813, 3.2058689851272737],
            [-18.46368063213394, 3.2115407419790185],
            [-18.46208442801304, 3.2143858795831113],
            [-18.456754572010887, 3.2120316422434723],
            [-18.446562518549072, 3.217595835385585],
            [-18.443591578799577, 3.218434977655291],
            [-18.439709646477077, 3.2143304295166337],
            [-18.434162432797834, 3.214089507311056],
            [-18.43384587441548, 3.218364149597158],
            [-18.427323670183494, 3.218826143193106],
            [-18.417343299169683, 3.2127997708005216],
            [-18.405898286356866, 3.21390376116488],
            [-18.403839079451494, 3.2113080807277807],
            [-18.398318503756858, 3.209130711471748],
            [-18.396153729279227, 3.2115851601697813],
            [-18.38939559370843, 3.21124426380023],
            [-18.38479058723773, 3.2084732812683803],
            [-18.382163605778253, 3.2128505656956574],
            [-18.36836830117425, 3.2084199386020793],
            [-18.36004684515811, 3.211613883255106],
            [-18.35722244129727, 3.210089250268217],
            [-18.35219145385968, 3.2113386077819412],
            [-18.345218696787427, 3.208559122698961],
            [-18.341832368307877, 3.2112035267672856],
            [-18.33625375173942, 3.21206437559717],
            [-18.32739085911795, 3.209553726556578],
            [-18.322082973845667, 3.2130398436395824],
            [-18.319990394167988, 3.209075793857299],
            [-18.31556778435784, 3.205687630440794],
            [-18.3124933795, 3.2072645838143474],
            [-18.30895535865587, 3.20540244961605],
            [-18.304951999197037, 3.2081850664657585],
            [-18.303223560648597, 3.2036115758275887],
            [-18.298976763289154, 3.2050526475753154],
            [-18.29539627545486, 3.2030558016819852],
            [-18.291808389640256, 3.20646407858604],
            [-18.28829238458557, 3.2049312738877274],
            [-18.278665599508102, 3.207877273315515],
            [-18.27413039723058, 3.211040017646729],
            [-18.26638288216894, 3.209111639036576],
            [-18.262357891259626, 3.211223733452759],
            [-18.25920346649814, 3.2088540396397],
            [-18.2551980397906, 3.2138807356027095],
            [-18.25017966411892, 3.2134301740216746],
            [-18.246754931521135, 3.2147231864461787],
            [-18.24628775780783, 3.219823393970808],
            [-18.240798286123823, 3.2224083324826123],
            [-18.236917807141918, 3.221041847831146],
            [-18.231183076992405, 3.22271216534989],
            [-18.22561555456979, 3.227066926359773],
            [-18.219924769758023, 3.2300281769113175],
            [-18.220859629894807, 3.236551680408827],
            [-18.21734893024175, 3.236069642488208],
            [-18.211828333016154, 3.2387583417344326],
            [-18.211167001315346, 3.2415111037780107],
            [-18.20627205469874, 3.2461150244965897],
            [-18.193189286718788, 3.248451363267354],
            [-18.18963668108655, 3.2527071676753243],
            [-18.186616435463872, 3.2528090756676113],
            [-18.183454425008275, 3.2575752795692092],
            [-18.172073100977062, 3.2596546394198396],
            [-18.168864517473118, 3.259242214109451],
            [-18.165306452315747, 3.2613284001647163],
            [-18.16318094429982, 3.2575256750832504],
            [-18.15062018786769, 3.2541065302444845],
            [-18.147413368532682, 3.2547121307120648],
            [-18.14457593162713, 3.248382185274069],
            [-18.14232056327774, 3.2498111802697855],
            [-18.124243793810557, 3.2442195908824614],
            [-18.116469508339375, 3.2451373620106283],
            [-18.114005800505474, 3.2423420645988092],
            [-18.108694750773125, 3.2426969063340687],
            [-18.104902014008513, 3.2377559305576233],
            [-18.103885013218584, 3.233967043221119],
            [-18.09828841921259, 3.232668091907756],
            [-18.095485738313464, 3.2292713494715577],
            [-18.097622889546958, 3.222696638921582],
            [-18.09403665461884, 3.2184344914205774],
            [-18.09556523499105, 3.214220778153069],
            [-18.09521655392522, 3.2091980515809513],
            [-18.090356769381284, 3.2041833905624384],
            [-18.09018500392356, 3.199822450213495],
            [-18.08761569886955, 3.1958760089854565],
            [-18.08922444732997, 3.1861229016881447],
            [-18.091132295524005, 3.1831253530789563],
            [-18.092032903070162, 3.177275948612514],
            [-18.090233381547815, 3.1739703074834487],
            [-18.082263440974554, 3.164759712975473],
            [-18.07672412679261, 3.1634737029281683],
            [-18.075176166653915, 3.1611074015568805],
            [-18.075409639003436, 3.153573996108749],
            [-18.03805922787867, 3.143746902477415],
            [-17.9238320587793, 3.1134440863174446],
            [-17.809608536040397, 3.083126680371821],
            [-17.794703558559902, 3.079818757636615],
            [-17.79055667043221, 3.078158291289592],
            [-17.704410556664772, 3.055824460178251],
            [-17.732287980772835, 2.955190160162996],
            [-17.738653946894697, 2.9307981931242177],
            [-17.835161557400024, 2.95548234785811],
            [-17.885587651645995, 2.968553614926976],
            [-17.973101408287537, 2.9915705161421227],
            [-18.058232080436454, 3.013620690108515],
            [-18.067898158764898, 3.0162438664803513],
            [-18.105694237443625, 3.0256745210108438],
            [-18.21310475062198, 3.0533884754760305],
            [-18.2162446842208, 3.050356110453231],
            [-18.225060975110157, 3.0492244806466053],
            [-18.22683538350881, 3.0517193293353477],
            [-18.23182998247529, 3.050978353023657],
            [-18.233335012877433, 3.0537607995737335],
            [-18.237665617768037, 3.051652970451665],
            [-18.242237950433843, 3.0525217204189503],
            [-18.25151317192527, 3.0497739504350228],
            [-18.258969702201558, 3.04956198711243],
            [-18.26676378233942, 3.0440378368525587],
            [-18.270403027060627, 3.0447000370413617],
            [-18.2809429010263, 3.043149911445599],
            [-18.28319481847758, 3.0411697068504093],
            [-18.298686880467827, 3.0341321685139597],
            [-18.301269310859045, 3.030241247992875],
            [-18.30840604046647, 3.025576914252685],
            [-18.3145451292186, 3.025761952047261],
            [-18.31945440701611, 3.020236122665821],
            [-18.323081498833357, 3.0203246135698865],
            [-18.33124437139271, 3.015913186248906],
            [-18.34026329785795, 3.009889885356208],
            [-18.346769096067277, 3.0084396371894386],
            [-18.351784416885717, 3.004820460099261],
            [-18.361844350059254, 3.004020861144998],
            [-18.367437157456397, 3.0009436953454776],
            [-18.371650319294677, 3.0002806983495995],
            [-18.3777697793803, 2.996058973335228],
            [-18.387016735813802, 2.99346618174451],
            [-18.392506648418067, 2.993533537703015],
            [-18.395546569837947, 2.9911491969922914],
            [-18.399724633110043, 2.9842911130439878],
            [-18.400848055191084, 2.980535585427814],
            [-18.404355536280217, 2.976288067056738],
            [-18.41245834267793, 2.9708980470962363],
            [-18.41338386061347, 2.9664507544998346],
            [-18.422272445959948, 2.966120903019492],
            [-18.43566031533791, 2.9679204288175094],
            [-18.445921039146516, 2.96413288251802],
            [-18.444561664459396, 2.960656931500352],
            [-18.44726930539571, 2.9577902299934236],
            [-18.456875305296997, 2.9588683073765103],
            [-18.45976737831384, 2.9547558082009466],
            [-18.467105501396272, 2.951846856774567],
            [-18.471536769284995, 2.9513951376823973],
            [-18.47491928140508, 2.946734800414441],
            [-18.47903479368756, 2.9471425140972802],
            [-18.48407749145177, 2.94191093421031],
            [-18.490416111112715, 2.936965733417607],
            [-18.499021374370134, 2.9345631140668638],
            [-18.50226281538923, 2.9290938199644745],
            [-18.506893743523182, 2.927785837082493],
            [-18.510294803236423, 2.9225213549162805],
            [-18.51374851471577, 2.9199284091389126],
            [-18.52168178976368, 2.9211489323608464],
            [-18.521111105588915, 2.913378206212136],
            [-18.527697852554912, 2.896625599162062],
            [-18.53373919283064, 2.8946002221677816],
            [-18.53165448408415, 2.889735383692925],
            [-18.53809809508308, 2.886424231993201],
            [-18.537903566521383, 2.8823692815296753],
            [-18.54238317564137, 2.882862854596372],
            [-18.54376764975419, 2.878171529095442],
            [-18.547262837299034, 2.877579739032814],
            [-18.5505832155195, 2.8689040601549416],
            [-18.55453085722118, 2.8697939081657577],
            [-18.556414290306364, 2.865715088085566],
            [-18.561471173167437, 2.86482761658012],
            [-18.563639119948483, 2.859244249628176],
            [-18.569543361672228, 2.8597748265043563],
            [-18.57382678961889, 2.849985113861293],
            [-18.580626614586066, 2.844355207943401],
            [-18.580979381457997, 2.8410506070650734],
            [-18.58537883121296, 2.8383097153126706],
            [-18.5914462725249, 2.8387790218327855],
            [-18.594046940602528, 2.837402483106914],
            [-18.60123475135148, 2.8387626215223345],
            [-18.607713587539653, 2.835315424906012],
            [-18.615325344155064, 2.839145710575843],
            [-18.615580264467866, 2.8421789731867326],
            [-18.62096360141203, 2.8485759334610083],
            [-18.625674525474547, 2.846737017254343],
            [-18.62688379859042, 2.848966822484325],
            [-18.63301508519417, 2.8494120766669058],
            [-18.634193360896653, 2.8560942755936516],
            [-18.63873558816953, 2.8577311047525966],
            [-18.64318395556597, 2.8650237754694987],
            [-18.64248389144825, 2.87321270911187],
            [-18.64812420525726, 2.8767488086294284],
            [-18.651790890656088, 2.8810511656305855],
            [-18.65682016426815, 2.8783541528651466],
            [-18.66132200654111, 2.877896620675959],
            [-18.66431747503461, 2.873202609602325],
            [-18.671984112480896, 2.8728124221159645],
            [-18.67366096139061, 2.87128139389502],
            [-18.682324293638725, 2.869320078215687],
            [-18.685987817214627, 2.87198329848646],
            [-18.693519882644534, 2.866406569045569],
            [-18.7012101171639, 2.873544486189937],
            [-18.706133322354415, 2.872773221653782],
            [-18.70794615691739, 2.869417611801534],
            [-18.71330827965789, 2.8719893947479687],
            [-18.719704419700008, 2.872724204002909],
            [-18.722885821804965, 2.8852778739155007],
            [-18.724828624480313, 2.8874763408526336],
            [-18.731228209702646, 2.885750391282536],
            [-18.735355559265518, 2.891761321626763],
            [-18.74764023373463, 2.899559829985384],
            [-18.752587741898136, 2.904541213877839],
            [-18.756573422202486, 2.906419785169321],
            [-18.73676960351964, 2.9796469975574578],
            [-18.70457874157056, 3.097002008607803],
            [-18.701788013776174, 3.0971633771424916],
            [-18.694049257804892, 3.104286490045386],
            [-18.691986002791765, 3.113802372986923],
            [-18.69011797989355, 3.11692083950272],
            [-18.68403989476698, 3.11677499612436],
            [-18.682651571803973, 3.118082805281582],
            [-18.682859088851373, 3.126633961486874],
            [-18.684439582085737, 3.1292763726303727],
            [-18.684343105865025, 3.134410108189523],
            [-18.68086295124235, 3.1368321939784685],
            [-18.67007135213077, 3.1377940350346627],
            [-18.6649027153411, 3.1407033598251983],
            [-18.66125675976099, 3.1410784619938834],
            [-18.65685648015523, 3.138686438191981],
            [-18.6464869011291, 3.1361068592135832],
            [-18.643257488455724, 3.1385962594642987],
            [-18.64160189290797, 3.143375162234504],
            [-18.63659032182219, 3.1455901158934965],
            [-18.633699483574752, 3.1485924968170553],
            [-18.626800249655787, 3.1509258283533694],
            [-18.62891483937249, 3.157258635924026],
            [-18.627661523388745, 3.165880644880362],
            [-18.619707250027894, 3.1715303863471425],
            [-18.61625532302208, 3.1764843587598213],
            [-18.609281339988964, 3.175377627197669],
            [-18.606561901738473, 3.1764361676491464],
            [-18.6055662377419, 3.1802605234435175],
            [-18.601575970994894, 3.1818835083287],
            [-18.591235430876996, 3.1791647466472672],
            [-18.59097687537943, 3.1728056227239088],
            [-18.58732910314062, 3.171662680257901],
            [-18.58565598876308, 3.1782643974092375],
            [-18.58102123266564, 3.1868090429423437],
            [-18.57351618007447, 3.185638017824041],
            [-18.572005971098907, 3.19186488630587],
            [-18.56405637205126, 3.197581352714908],
            [-18.562634934918364, 3.202166539101519],
            [-18.559355137729074, 3.204995118488763],
            [-18.554858571931614, 3.2043131612572116],
            [-18.550996766099487, 3.2114057730607097],
            [-18.543529052169443, 3.208251879829777],
            [-18.538306119683334, 3.209576766370687],
            [-18.535548859662452, 3.2075687485620863],
            [-18.527541835575185, 3.213172034559591],
            [-18.524832972743415, 3.210522874955969],
            [-18.52013517955914, 3.2105915586386415],
            [-18.517780039668697, 3.216292518378275],
            [-18.50608763091688, 3.213027100082477],
            [-18.50076421675165, 3.210125132146744],
            [-18.498828106439355, 3.2126726067334346],
            [-18.49281612541042, 3.2121068793655194],
            [-18.48999699934116, 3.2106061434091835],
            [-18.490906584724122, 3.205429918856213],
            [-18.48688880694594, 3.2026972142933774],
            [-18.47797067031954, 3.2081993871585217],
            [-18.474024696832185, 3.2003790128657146],
            [-18.471621723029635, 3.202134319950285]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.76891153595511,
          "lat": 39.30129078103877
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06057"],
        "coty_name": ["Nevada"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nevada County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01682927"
      },
      "bbox": [
        -18.756573422202486, 2.835315424906012, -17.704410556664772,
        3.2613284001647163
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-20.03138560860325, 1.8727541922327986],
            [-19.98526069000517, 1.8597583530729134],
            [-19.94920194662777, 1.8494293145342313],
            [-19.949962218722423, 1.8489830964710436],
            [-19.952951385540217, 1.8198441378194725],
            [-19.948988526984056, 1.816827401976718],
            [-19.951053794045677, 1.8075441268104433],
            [-19.947562538099014, 1.8006215336492934],
            [-19.950957430386467, 1.7942869516074231],
            [-19.955907880868946, 1.7877960917779236],
            [-19.964696088333778, 1.788917091461998],
            [-19.96498100421555, 1.782479673763332],
            [-19.961164796997224, 1.781590982183204],
            [-19.95957249202168, 1.7755121664735327],
            [-19.950029148231643, 1.7655801156412996],
            [-19.954158753833056, 1.759248710659839],
            [-19.946459539152844, 1.7510748392277387],
            [-19.9507520516144, 1.7460289091793664],
            [-19.95781734871624, 1.7533982694560142],
            [-19.96022007466937, 1.7533959289555163],
            [-19.966433807052812, 1.746579259951584],
            [-19.960645240084077, 1.7419275340686584],
            [-19.95622583879418, 1.7299347296767869],
            [-19.937116366599277, 1.7237546927111882],
            [-19.93797863221007, 1.7200646369331412],
            [-19.93364468478703, 1.7196240096308433],
            [-19.930004213777522, 1.7214552485555876],
            [-19.92238426425214, 1.7189934533374942],
            [-19.925074358527514, 1.7118068628777288],
            [-19.919920591250143, 1.7017577415931768],
            [-19.903602639010067, 1.6970602702165283],
            [-19.89687661255772, 1.690013450097656],
            [-19.887866416254194, 1.6910166988885784],
            [-19.88127009330469, 1.6828230437213443],
            [-19.87900228825579, 1.6663114932041274],
            [-19.868561702362204, 1.6617762782568675],
            [-19.866399148322785, 1.652694001817168],
            [-19.859090124334667, 1.6474850688775997],
            [-19.85244494475646, 1.6456055489344894],
            [-19.847908345329763, 1.6411852863135485],
            [-19.84769297874247, 1.6363536345351561],
            [-19.85348108747535, 1.6316635964373445],
            [-19.850719151524583, 1.6265315201023147],
            [-19.845728288339583, 1.6199798575308297],
            [-19.84251311671443, 1.622433212685743],
            [-19.841998941575124, 1.6128925269568053],
            [-19.83198469060058, 1.597903130002481],
            [-19.821892721873837, 1.597623331550287],
            [-19.813200152455973, 1.5997449191700694],
            [-19.810571868773543, 1.5987875561652285],
            [-19.806032037711606, 1.5904038715748225],
            [-19.80720030897413, 1.5758488360453853],
            [-19.80684039216066, 1.5666785798616292],
            [-19.809717380423923, 1.5641187376942554],
            [-19.80579954888685, 1.5549177069815263],
            [-19.813749381189346, 1.5518465589432646],
            [-19.814099822345973, 1.5446310817010425],
            [-19.81911542003244, 1.5444676272698823],
            [-19.82680998398219, 1.548803345840837],
            [-19.830537763523285, 1.5534189388738995],
            [-19.83744669795225, 1.5537711007156154],
            [-19.84741780633147, 1.5525644541654267],
            [-19.851632573279048, 1.5480600332483925],
            [-19.856322929343243, 1.546620810121423],
            [-19.858296704440765, 1.5441416412433653],
            [-19.863853732779244, 1.5431878193818247],
            [-19.86713679837826, 1.5384667738407312],
            [-19.87249875740315, 1.5366914855919118],
            [-19.874672006633926, 1.531374704100096],
            [-19.87320239792401, 1.5278123141140039],
            [-19.874694324739334, 1.5204073948760168],
            [-19.878600782544247, 1.5204908760502622],
            [-19.881894756165597, 1.5148572991034226],
            [-19.882046042041555, 1.501521952070322],
            [-19.885669919807448, 1.4915777762876352],
            [-19.887710437094608, 1.4904090148904643],
            [-19.89643144905723, 1.4815734577000705],
            [-19.900978851356918, 1.470593857308389],
            [-19.898594777938065, 1.4597523305199065],
            [-19.89838730462399, 1.4538368884704587],
            [-19.89439694590698, 1.4461043162182787],
            [-19.893554055102587, 1.4397356954317873],
            [-19.889712775272933, 1.431185735359411],
            [-19.89576090498798, 1.433412775583481],
            [-19.89940212324293, 1.4300317370599818],
            [-19.90483601101302, 1.4281730021055676],
            [-19.901446848456533, 1.4239504324636294],
            [-19.901531335318907, 1.4197645821707352],
            [-19.899656313375687, 1.4169877159692272],
            [-19.89384264933094, 1.4187239563286878],
            [-19.890259601617327, 1.4169072647156293],
            [-19.88880204653248, 1.4098189181251672],
            [-19.885907708361096, 1.4077386817391748],
            [-19.88713005694458, 1.4044030378781747],
            [-19.891843946757817, 1.399789679130363],
            [-19.88474409073569, 1.3941924166555901],
            [-19.883324017724654, 1.3877528835199433],
            [-19.89512169616135, 1.3470065971440637],
            [-19.89807354620287, 1.3331420399170173],
            [-19.90130409964341, 1.3261039419497327],
            [-19.90307280405823, 1.3192605701423972],
            [-19.97130719953875, 1.3382294563958825],
            [-19.978282314969427, 1.3138710151550719],
            [-19.998237877285533, 1.3193254343789091],
            [-20.014044132051076, 1.3205585953395709],
            [-20.03607545876511, 1.3270245149667836],
            [-20.04247129325365, 1.2874934953110186],
            [-20.034856977735473, 1.2495751160906123],
            [-20.039282746356523, 1.2443737215111328],
            [-20.046784451158803, 1.2560162200217608],
            [-20.052194805323587, 1.2594189106397753],
            [-20.065431864025427, 1.2578115118166342],
            [-20.066119765946265, 1.2617149482171202],
            [-20.070005631710938, 1.2636635954150175],
            [-20.070402356005165, 1.2674203458533118],
            [-20.066311140516433, 1.2766902337963535],
            [-20.065459051967817, 1.2818435056141968],
            [-20.068276588790212, 1.2875450238742445],
            [-20.067908776632738, 1.2911074835039755],
            [-20.07365496951521, 1.294585145070273],
            [-20.07906950143376, 1.3006674728202658],
            [-20.07670418274239, 1.3056536282413989],
            [-20.076004558739438, 1.3138711207219564],
            [-20.077472938923556, 1.3239705648649518],
            [-20.080439785730334, 1.3273752668196541],
            [-20.0844212878192, 1.3346725414258556],
            [-20.088342014176067, 1.3377070968592357],
            [-20.096099033705887, 1.3384048589477398],
            [-20.097190949979428, 1.3424676604755268],
            [-20.095840521787423, 1.3501800712275214],
            [-20.099940364325303, 1.3544864187648649],
            [-20.097754923629637, 1.3731896173847518],
            [-20.09498292349323, 1.377923855211737],
            [-20.095391024960808, 1.383434728744191],
            [-20.097830894353375, 1.392775106621743],
            [-20.09793476151392, 1.4018650666032295],
            [-20.09547999109855, 1.4085665569126875],
            [-20.08555230355485, 1.4239194471675674],
            [-20.0579923450749, 1.4907630424802625],
            [-20.051482612338383, 1.512226792127136],
            [-20.055403795323603, 1.5182844275479108],
            [-20.053531765548133, 1.5291648891771343],
            [-20.0592324730363, 1.5494094021967464],
            [-20.05749320365948, 1.558014254563736],
            [-20.059421165986116, 1.5635190692522025],
            [-20.057621409939266, 1.5668737617071027],
            [-20.060293653027994, 1.5702890134578193],
            [-20.060399900638984, 1.5803496412732276],
            [-20.061785763054434, 1.5843511359484659],
            [-20.06263086586519, 1.595937189446259],
            [-20.057269360720138, 1.6212803248386358],
            [-20.056609036445114, 1.641036368604723],
            [-20.058885520646996, 1.6544846135395517],
            [-20.06639572905306, 1.6648288013624104],
            [-20.078231615087216, 1.6620198135406394],
            [-20.084839027548313, 1.661495059434256],
            [-20.08511910422447, 1.6649695218298564],
            [-20.08850474300381, 1.6685032000331952],
            [-20.086186967972832, 1.670800727206214],
            [-20.089885502517745, 1.6784411370880676],
            [-20.092829759579317, 1.6866429836679204],
            [-20.09407293980852, 1.6945848452443837],
            [-20.091780989976183, 1.7106879964821724],
            [-20.083215260401648, 1.723918405079201],
            [-20.08042418499237, 1.7378667037091255],
            [-20.082289385664517, 1.7398087445146189],
            [-20.081825027734077, 1.7477782050413766],
            [-20.079693032484535, 1.74856830858915],
            [-20.075177793736717, 1.761932510452715],
            [-20.07695759497715, 1.7661599949966809],
            [-20.0724038596638, 1.7663112555831253],
            [-20.071193137015666, 1.768821450735359],
            [-20.066471589308673, 1.76514427164792],
            [-20.060756630046306, 1.7672536535336916],
            [-20.055962683422617, 1.774942328975194],
            [-20.052340216583804, 1.7870837616903246],
            [-20.050180359803328, 1.7885119907913756],
            [-20.04291299799491, 1.8087600074384493],
            [-20.033165674982556, 1.8504822505701632],
            [-20.03138560860325, 1.8727541922327986]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.32907523939495,
          "lat": 37.42277821831054
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06081"],
        "coty_name": ["San Mateo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Mateo County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00277305"
      },
      "bbox": [
        -20.099940364325303, 1.2443737215111328, -19.80579954888685,
        1.8727541922327986
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-6.424245470816311, 1.5989351958321991],
              [-6.419591481108385, 1.601559010821821],
              [-6.40984112173748, 1.6099977900495819],
              [-6.403973657805771, 1.6125935655145816],
              [-6.404581728282539, 1.6065380043885948],
              [-6.40112639440392, 1.6034272310263356],
              [-6.40194667547997, 1.5953316706340008],
              [-6.422471560824546, 1.5973981608145378],
              [-6.424245470816311, 1.5989351958321991]
            ]
          ],
          [
            [
              [-6.8248316366155395, 1.9437760382212736],
              [-6.755813159168162, 1.9378436630236975],
              [-6.735980032340215, 1.9356195295429903],
              [-6.709838298342891, 1.9319737713960048],
              [-6.706010533597919, 1.9310317832939665],
              [-6.681534003499439, 1.9282373200568592],
              [-6.627677841796785, 1.9213609775766647],
              [-6.6154695956746075, 1.9236049062890277],
              [-6.600007096751471, 1.9225768047415057],
              [-6.585277733436221, 1.9211216629737868],
              [-6.55059087338939, 1.9187273619322118],
              [-6.511607775813673, 1.91402028716596],
              [-6.4930870113651675, 1.9114986391368936],
              [-6.415925349081811, 1.904142232439262],
              [-6.3744316076203535, 1.9006826922629634],
              [-6.382186977204692, 1.8204375212053951],
              [-6.386518065026961, 1.7766905246850828],
              [-6.399861437095678, 1.638124228271589],
              [-6.397824088474323, 1.6379387538782393],
              [-6.399972155783804, 1.6152564724681877],
              [-6.412161201093538, 1.6095893753646793],
              [-6.419296838759936, 1.6028502432534903],
              [-6.422113418783368, 1.6009350978453727],
              [-6.4283314890298335, 1.5998092072441266],
              [-6.424804680136613, 1.597487918486715],
              [-6.416412925945483, 1.5965566037143382],
              [-6.4170537064465565, 1.589045768376687],
              [-6.420551531069566, 1.5897251706358524],
              [-6.421297432699054, 1.582490867660586],
              [-6.432218268769128, 1.5834887797861625],
              [-6.432749491968532, 1.5762125575733976],
              [-6.446644380289418, 1.5776316429537725],
              [-6.450220980506482, 1.5736428680508794],
              [-6.454075803550371, 1.575133486241872],
              [-6.453009454490463, 1.585416933417554],
              [-6.446037416148249, 1.5848712232154007],
              [-6.445316899380623, 1.592204216977723],
              [-6.453782126976688, 1.5929037177318377],
              [-6.454511288732931, 1.596655766246697],
              [-6.459091156616074, 1.5971098312876801],
              [-6.460622961868942, 1.5825063128692318],
              [-6.467732284212804, 1.5832865739303104],
              [-6.468796363953665, 1.572462694957769],
              [-6.475933260838756, 1.5731581594893955],
              [-6.477469819857731, 1.5580540385456456],
              [-6.526857601108986, 1.5631889888848964],
              [-6.566551889370307, 1.5670075461974966],
              [-6.57999748352466, 1.56781736433816],
              [-6.598264120295678, 1.5699118763715212],
              [-6.623018314312115, 1.57214427489895],
              [-6.667203154021633, 1.5755998322472382],
              [-6.665105502057133, 1.5976754098771604],
              [-6.6715170136418696, 1.5951445016457857],
              [-6.675570507535702, 1.5965069727577295],
              [-6.681691950374586, 1.5931908109039632],
              [-6.683644414786084, 1.5962305838337936],
              [-6.689176823634037, 1.5963580892860738],
              [-6.69655534840914, 1.6043706689534374],
              [-6.702765204051769, 1.6030683613914505],
              [-6.708973461194821, 1.5994224611662757],
              [-6.837494654324741, 1.6124634846222696],
              [-6.839870140465144, 1.6124006366461223],
              [-6.875381959482685, 1.6163821363437079],
              [-6.880644761762362, 1.618282633561609],
              [-6.883043182979169, 1.6222594844864924],
              [-6.887632125139014, 1.626551749898729],
              [-6.886057158245421, 1.63146291428574],
              [-6.88764254378999, 1.6351164536233553],
              [-6.883500292973099, 1.6385684163060328],
              [-6.881949907132195, 1.6446532681980994],
              [-6.882525907335981, 1.6549588526644958],
              [-6.880504177244675, 1.6604893941355938],
              [-6.877477574626187, 1.664138656054451],
              [-6.878772611015495, 1.6704442557954593],
              [-6.874746700456136, 1.6776001440919623],
              [-6.880005833926382, 1.6815853337476556],
              [-6.879586085636879, 1.6891300267073766],
              [-6.877489181033903, 1.700418052063156],
              [-6.868607376109037, 1.698935435210827],
              [-6.862447664428714, 1.7006771717344584],
              [-6.8560498340849785, 1.6996057961007363],
              [-6.854787942163296, 1.7013863700436629],
              [-6.848275139420037, 1.703314285048736],
              [-6.848648440791471, 1.7062592025028245],
              [-6.83654828438038, 1.720251154064766],
              [-6.834816252063221, 1.7268902587380466],
              [-6.83713809341908, 1.7287780331002711],
              [-6.8422660138495, 1.7361932596328427],
              [-6.843794051777697, 1.740919392116021],
              [-6.839804608262325, 1.7473820914647857],
              [-6.835853322594801, 1.7496666600576587],
              [-6.834806249896124, 1.7547611471020934],
              [-6.8303132134414355, 1.756278098635535],
              [-6.8276825839319635, 1.769628312957748],
              [-6.827847443330945, 1.7751896061484962],
              [-6.825472054171261, 1.778337279959019],
              [-6.828386281653195, 1.7840523221892686],
              [-6.8258174879174085, 1.7946346398938813],
              [-6.822194978642012, 1.7952051915961298],
              [-6.819167374007374, 1.799455505479014],
              [-6.820342359583868, 1.80449975605957],
              [-6.81792169465299, 1.8081405938089492],
              [-6.820541297198201, 1.811537223192344],
              [-6.81988936810168, 1.8192413854185248],
              [-6.823656532969584, 1.8219741823185749],
              [-6.8232274599507, 1.827596384715593],
              [-6.829914057086246, 1.8303750477136966],
              [-6.832631183919868, 1.8331140413219682],
              [-6.838016851301298, 1.8344492756664448],
              [-6.841509405649791, 1.8401203729817939],
              [-6.846141891090462, 1.8423689199890159],
              [-6.848017118528157, 1.8508943621711713],
              [-6.845143523035571, 1.8550221042583888],
              [-6.846688294822275, 1.8664788735029734],
              [-6.845545523856153, 1.8697977852583378],
              [-6.850444383456254, 1.8734546376101016],
              [-6.849619452393194, 1.8821938658564894],
              [-6.847202642004131, 1.888031406972579],
              [-6.843198385603692, 1.8922745795543958],
              [-6.842771610711731, 1.9016350591549185],
              [-6.841115154684488, 1.9044685631154423],
              [-6.838412579762847, 1.915260125666342],
              [-6.835941580960218, 1.9172928913635277],
              [-6.836323137744224, 1.9214442084591439],
              [-6.83157491841581, 1.9289749744478435],
              [-6.83018401632127, 1.9331269613260507],
              [-6.821288990572982, 1.9319361148479628],
              [-6.823870126586563, 1.9373835701294155],
              [-6.8248316366155395, 1.9437760382212736]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.35775857645969,
          "lat": 40.092477209059716
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08013"],
        "coty_name": ["Boulder"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boulder County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00198122"
      },
      "bbox": [
        -6.88764254378999, 1.5580540385456456, -6.3744316076203535,
        1.9437760382212736
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.804169926612653, -7.614122334462498],
            [11.80786028081755, -7.624146914603794],
            [11.811172924539422, -7.626196016754799],
            [11.818665162537172, -7.624212295821213],
            [11.820452415208958, -7.625666643153126],
            [11.825383458492897, -7.622374407401989],
            [11.831350110460932, -7.6164654388132425],
            [11.835296838419543, -7.619413172628273],
            [11.834818855242494, -7.622670922246785],
            [11.842094233250245, -7.626448034219165],
            [11.847727268623176, -7.62772293232898],
            [11.853049441907695, -7.622809455871138],
            [11.85490172284839, -7.615770684811336],
            [11.864306215797296, -7.609001090634553],
            [11.864811716047813, -7.614257994407366],
            [11.871894275059011, -7.620381783825643],
            [11.87404157687185, -7.619343398213303],
            [11.877287904963035, -7.612642806753177],
            [11.882824740345994, -7.607603559959664],
            [11.887655274535433, -7.6060898443852505],
            [11.890981459540974, -7.607037177458436],
            [11.898259008625525, -7.600082781165785],
            [11.899872190486724, -7.5950026305667775],
            [11.893728016023084, -7.585300566452414],
            [11.896875699891138, -7.583298099703086],
            [11.897795394267668, -7.579271293180571],
            [11.90281083593792, -7.5726355729733115],
            [11.909876738493338, -7.569367027403357],
            [11.91238350127531, -7.565626013445433],
            [11.908495631457978, -7.55899496628146],
            [11.909163623124943, -7.5561511868228655],
            [11.912803165379893, -7.553961450412663],
            [11.913734216619586, -7.551158938023995],
            [11.91322948793057, -7.544305496278996],
            [11.919876844238562, -7.542956731774793],
            [11.921896727268038, -7.5394395661677756],
            [11.921082158019138, -7.533894138502259],
            [11.921585571930452, -7.528159764391193],
            [11.917291168971246, -7.525059139438679],
            [11.915204680476505, -7.519834094232095],
            [11.916417403763973, -7.516275288330583],
            [11.912286832679053, -7.513818505517118],
            [11.912225091023572, -7.506375142673089],
            [11.908800386495225, -7.504086080749083],
            [11.909035893260727, -7.5013242092085894],
            [11.905236379594271, -7.496061610829332],
            [11.90281996835157, -7.497960181797838],
            [11.89524190742329, -7.49378910397045],
            [11.892379450468507, -7.4899608584490736],
            [11.896393706790969, -7.488636477735578],
            [11.893817433543047, -7.485261774218388],
            [11.88409971604485, -7.478173432011785],
            [11.886051788096953, -7.474406716229221],
            [11.886056382296585, -7.4689818559383925],
            [11.87000198711644, -7.467934379894272],
            [11.863680041884486, -7.4647337205871365],
            [11.865202187704103, -7.462309704430092],
            [11.862369396505557, -7.459327910769064],
            [11.867059510274306, -7.457349361402988],
            [11.866420278133065, -7.452606202793038],
            [11.857996147531301, -7.450798463016953],
            [11.858393667540813, -7.448020658670906],
            [11.855318065865859, -7.445794899868082],
            [11.856795989336776, -7.440945604769487],
            [11.854801362677927, -7.4373847643261],
            [11.848552918815894, -7.438995296856642],
            [11.84661185292776, -7.432204614671194],
            [11.841936000357876, -7.424026951888987],
            [11.838924206912353, -7.427733411525241],
            [11.83414432734168, -7.420694724863149],
            [11.83431512525207, -7.4158127981196404],
            [11.840341611890837, -7.415380017780596],
            [11.845284192124756, -7.412984503782422],
            [11.841975161720837, -7.405241795185968],
            [11.837740862390689, -7.40096386224662],
            [11.831167493518079, -7.387209100136513],
            [11.837137489782675, -7.382887799614566],
            [11.839698157977526, -7.379532493036158],
            [11.837876677274748, -7.376073843022601],
            [11.845997697322836, -7.370297082504126],
            [11.847752812024945, -7.363381845576884],
            [11.84465214442899, -7.360402886888665],
            [11.848819049657783, -7.354715489212203],
            [11.855898230311425, -7.348494135636065],
            [11.857333853165848, -7.345163605580611],
            [11.947911158508209, -7.338410393705546],
            [12.054587332453874, -7.330845181719742],
            [12.055347805506585, -7.334256711565244],
            [12.077040370154839, -7.469740405240079],
            [12.075981698321794, -7.4698909906468485],
            [12.094622684903593, -7.594914165734584],
            [12.103064581857495, -7.652174598679411],
            [12.119508453508118, -7.7709268081028],
            [12.120660667445824, -7.7782402553764545],
            [12.126293133087112, -7.782553194909459],
            [12.125931592180502, -7.800948507256329],
            [12.123656367377915, -7.805284611577373],
            [12.116733043829143, -7.810890073959759],
            [12.106646816675287, -7.815086637654568],
            [12.099139787895501, -7.820663731155233],
            [12.091485748722096, -7.82263436005228],
            [12.088344641037343, -7.827368998916691],
            [12.081547400261725, -7.8318103437863495],
            [12.076206842339761, -7.837633988090481],
            [12.0651396719829, -7.860188097801802],
            [12.065486375483063, -7.863863865406883],
            [12.063498581986346, -7.871240325855879],
            [12.064509303105302, -7.88057410902524],
            [12.069545110990939, -7.884112055479312],
            [12.068357943409596, -7.889523685402399],
            [12.061923009351098, -7.895769290551271],
            [12.05496879077687, -7.8979727030905815],
            [12.051137081313685, -7.901625205114384],
            [12.047359872371583, -7.901695060680609],
            [12.040440093289863, -7.908102846560027],
            [12.039264249853023, -7.911523532702118],
            [12.041453762592, -7.9160014274234],
            [12.041217105143815, -7.925519987056451],
            [12.039459867183533, -7.928119935575727],
            [12.042605029871677, -7.931795953468617],
            [12.042383408235178, -7.934592156501171],
            [12.046195377696108, -7.938642718178803],
            [12.047446769785456, -7.942894659524241],
            [12.059094361855662, -7.947481526706792],
            [12.060965725701834, -7.952009250919538],
            [12.06519484210782, -7.952657387830017],
            [12.071086012795945, -7.951155050412569],
            [12.08062002775798, -7.954860711837152],
            [12.084379036380941, -7.961187066428658],
            [12.083901541956115, -7.964354750453916],
            [12.086172226153494, -7.9715759791234095],
            [12.087333937953927, -7.978024454988599],
            [12.083215942037482, -7.983606598498927],
            [12.079413044294718, -7.98455916513338],
            [12.078190598291284, -7.9881089398329665],
            [12.07253939640199, -7.98883044983173],
            [12.06935291277037, -7.986135177694762],
            [12.06646173673726, -7.986714194120316],
            [12.061742447195668, -7.991008995107143],
            [12.056813842349909, -7.999432610149091],
            [12.05349291902177, -7.998819194116069],
            [12.048079283474033, -8.00201526881818],
            [12.050438673478912, -8.00443616126254],
            [12.053084371689962, -8.022313185259367],
            [12.04952482903966, -8.022828293983004],
            [12.050567935199044, -8.029899733385674],
            [12.039816716507, -8.031537376346874],
            [12.04201081318363, -8.045536214901597],
            [12.047551688941505, -8.050314900078709],
            [12.043972404460604, -8.052445747114884],
            [12.043121314744171, -8.056677959626931],
            [12.039881519029189, -8.06017196129396],
            [12.035550761053383, -8.062022578993073],
            [12.032917621278145, -8.067188311210655],
            [12.028643370524536, -8.06836099511448],
            [12.023494696641446, -8.063585464020866],
            [12.020488340298172, -8.062681313271327],
            [12.01846985916847, -8.068074459334802],
            [12.022731538856773, -8.070592884091068],
            [12.020004743434185, -8.07335624884377],
            [12.013684003404897, -8.07338110482858],
            [12.01160522358042, -8.076240387813963],
            [12.013467822128597, -8.07988101531948],
            [12.01054099000489, -8.083545508793616],
            [12.011201311290284, -8.089516962730176],
            [12.00636507686848, -8.096371438366063],
            [11.997405953451027, -8.099419936047761],
            [11.993914123440002, -8.095843217672334],
            [11.99123985615479, -8.095766106468998],
            [11.977741517412712, -8.094437474824097],
            [11.970194201872731, -8.096107065060886],
            [11.960530179696509, -8.095982143762733],
            [11.954835846281785, -8.094050948989507],
            [11.939028494421702, -8.08254733669908],
            [11.934530711136606, -8.080445122045438],
            [11.925734397504087, -8.078267462413082],
            [11.920381819965504, -8.07564306521457],
            [11.918932034257063, -8.07126496088388],
            [11.916411313334187, -8.071297277226709],
            [11.908617993656861, -8.063861286591088],
            [11.908183758198708, -8.060902714689059],
            [11.903330964424194, -8.057927566527198],
            [11.900803243454117, -8.044976663742835],
            [11.89727647411297, -8.043086777474592],
            [11.887080947872436, -8.043026872957533],
            [11.88827144671126, -8.039159073986461],
            [11.887196031091252, -8.034007432838749],
            [11.880562044250988, -8.029569710914132],
            [11.881993230968252, -8.025648365240704],
            [11.881860948853426, -8.018829313347252],
            [11.88008409893371, -8.01299981979307],
            [11.873303349966438, -8.016514211734657],
            [11.869608136660565, -8.010437012938466],
            [11.865323118574569, -8.010873641104524],
            [11.8633634964342, -8.008630030983005],
            [11.855277523179304, -8.012633020414366],
            [11.858590304936982, -8.004190829693707],
            [11.861631622615683, -8.001765922571455],
            [11.863267509906821, -7.99249430683105],
            [11.869960834923376, -7.984691209080262],
            [11.876986255140801, -7.981184362288841],
            [11.88361106970015, -7.97642509535416],
            [11.885141298283605, -7.964870811796185],
            [11.882115604162326, -7.95478150986144],
            [11.874752121793232, -7.955448268592046],
            [11.853355787813978, -7.958772928981086],
            [11.843170704699565, -7.889105450607213],
            [11.830292880030527, -7.80125276479273],
            [11.817990762350895, -7.711405204164436],
            [11.81727733858899, -7.70795434629885],
            [11.811884495691602, -7.66920610186782],
            [11.811075064769172, -7.664820649109247],
            [11.804169926612653, -7.614122334462498]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.62152257229242,
          "lat": 30.224328769461415
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12023"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00306909"
      },
      "bbox": [
        11.804169926612653, -8.099419936047761, 12.126293133087112,
        -7.330845181719742
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.890226584893785, -10.575744465679254],
            [12.884510040210376, -10.53512801557284],
            [12.878222417365421, -10.494218698383596],
            [12.871912426613656, -10.449417369582791],
            [12.965013901432641, -10.436788624961002],
            [13.045986362433345, -10.42547582517459],
            [13.045563147273809, -10.422023532229412],
            [13.061274903232944, -10.419846277575877],
            [13.17644239868682, -10.402716987377099],
            [13.219577244010349, -10.395881900094977],
            [13.30577007158167, -10.382880259870074],
            [13.326091796965164, -10.507131300850219],
            [13.326305170185968, -10.509396796283415],
            [13.35320017277083, -10.67915230106145],
            [13.260574945712545, -10.692958751904246],
            [13.167945787055285, -10.7067390231986],
            [13.085050782191658, -10.718390990411487],
            [13.002152924427596, -10.73002205550805],
            [12.980240207325165, -10.733024806919616],
            [12.972531692545436, -10.737654052652255],
            [12.914857433416715, -10.745632716973853],
            [12.902220651996398, -10.660850389179744],
            [12.901203669747437, -10.655585163177719],
            [12.890226584893785, -10.575744465679254]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.8094864674938, "lat": 27.186366270855117 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12027"],
        "coty_name": ["DeSoto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeSoto County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00294452"
      },
      "bbox": [
        12.871912426613656, -10.745632716973853, 13.35320017277083,
        -10.382880259870074
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [11.768724832002256, -8.132648597289483],
              [11.781363917565832, -8.130703540531142],
              [11.777033988725266, -8.134409155850646],
              [11.773842903673549, -8.135028973587977],
              [11.768724832002256, -8.132648597289483]
            ]
          ],
          [
            [
              [11.367571657152034, -8.342125962327156],
              [11.37641277976044, -8.335477150910393],
              [11.379791490107948, -8.337452779410627],
              [11.38376363088382, -8.337057188366323],
              [11.387816120056867, -8.339010438740871],
              [11.391343137673951, -8.337841471581037],
              [11.399131525643739, -8.340448845001491],
              [11.40515086437483, -8.339902363413216],
              [11.407561703702664, -8.337049915530516],
              [11.404634672121745, -8.329851657090192],
              [11.40696288985038, -8.326974035022523],
              [11.414702091452321, -8.309077082530465],
              [11.41264577594454, -8.297970333982585],
              [11.412948036521996, -8.292234989216954],
              [11.415327282495687, -8.28924780882192],
              [11.414152385974267, -8.280973986799378],
              [11.415541261031475, -8.277492522391222],
              [11.412248527096084, -8.270891463728594],
              [11.41557703191764, -8.267179710000855],
              [11.412660134212192, -8.261212858255039],
              [11.41480928353035, -8.259030868890443],
              [11.415195902827692, -8.252858610363836],
              [11.418209709529153, -8.243262558885103],
              [11.422255112560675, -8.241571886935317],
              [11.422709846297417, -8.238506223022572],
              [11.426038875996303, -8.232236387570902],
              [11.428762889182096, -8.224419846031976],
              [11.430569829521435, -8.22402996184266],
              [11.4251918598322, -8.180480399207475],
              [11.531208835779902, -8.165319193690822],
              [11.637222128713688, -8.150133722653912],
              [11.698052754473926, -8.141119037776326],
              [11.71143906406718, -8.139481131918263],
              [11.733770817963991, -8.136107780698014],
              [11.734073091332172, -8.137465508219565],
              [11.767084975300317, -8.1328134277833],
              [11.762835616550587, -8.135234044137524],
              [11.75977308343412, -8.139452918429766],
              [11.7564349256685, -8.148961388812495],
              [11.757269171863085, -8.153578115490753],
              [11.761109342693581, -8.157390076153318],
              [11.76582490650453, -8.157048018612182],
              [11.771177646020167, -8.159082288274444],
              [11.771343184865755, -8.161723508232342],
              [11.75990227207594, -8.171542452583852],
              [11.758241661930276, -8.174584508071979],
              [11.75640924423034, -8.185574749597942],
              [11.75183481666529, -8.192928321861078],
              [11.751191578012273, -8.201206347749492],
              [11.753722394496481, -8.205938825912513],
              [11.760286566819982, -8.204714756751576],
              [11.762606578095495, -8.213074751218063],
              [11.759657054488795, -8.222470457415193],
              [11.755514092752893, -8.23224268091366],
              [11.755859019260438, -8.234719471394799],
              [11.762265994470571, -8.23719565638229],
              [11.759994601917796, -8.242992999940485],
              [11.754153963250866, -8.237488541929967],
              [11.750607917880675, -8.238614021550942],
              [11.751766935146016, -8.242768645656875],
              [11.759998595790432, -8.246447859602654],
              [11.763938156056067, -8.25246577736321],
              [11.7686391663284, -8.25216230584642],
              [11.767904552232022, -8.255887051119597],
              [11.762866729578715, -8.25757083601982],
              [11.756182003684271, -8.254509061008026],
              [11.753583568555916, -8.256231554099866],
              [11.752481787997409, -8.260671825353343],
              [11.75438854780887, -8.266986526115293],
              [11.75282399484608, -8.27308782606225],
              [11.754103645367271, -8.27667963895895],
              [11.75760937503021, -8.279159659596102],
              [11.7581460718955, -8.282740951302648],
              [11.755090861005469, -8.28852988504363],
              [11.759730599817923, -8.29173717305864],
              [11.76249050190919, -8.295671876093875],
              [11.762253597530446, -8.299131799185739],
              [11.75870520770102, -8.301498394377445],
              [11.761877328605431, -8.315711522697526],
              [11.761199414506464, -8.318816697332611],
              [11.753223516343338, -8.3274007299451],
              [11.749968817553334, -8.332715660563156],
              [11.750283985865037, -8.337676028336974],
              [11.754398161479179, -8.340868920750033],
              [11.752229190186286, -8.34992348821367],
              [11.76027493681649, -8.354423495125596],
              [11.767272154866301, -8.367933773801457],
              [11.772801241849882, -8.371583517418044],
              [11.775545515127249, -8.37026738758565],
              [11.778860015146437, -8.363051208763904],
              [11.782778474118219, -8.36149821474199],
              [11.784655430201084, -8.363247358171998],
              [11.78490142561633, -8.367229577099534],
              [11.780510916821028, -8.369778187808905],
              [11.780274930705147, -8.378837738667013],
              [11.778287671327224, -8.389383874245684],
              [11.780115412792053, -8.393983339250747],
              [11.778504892721001, -8.399135639284648],
              [11.770873723344078, -8.403039891268053],
              [11.76332972219441, -8.4126351053189],
              [11.757538618260945, -8.417454980158794],
              [11.756410930815436, -8.423194301235467],
              [11.759300950454609, -8.428409472395883],
              [11.764789518879716, -8.431225739113627],
              [11.766449748334816, -8.434533254181948],
              [11.76431330364727, -8.4398666596146],
              [11.758318393032603, -8.43953402471511],
              [11.756323073703001, -8.441062283077239],
              [11.755847091302337, -8.447254222201199],
              [11.757044750475384, -8.454803425685903],
              [11.757355021320247, -8.462831755621583],
              [11.760744276509845, -8.472153331373935],
              [11.757693228270147, -8.479293332196429],
              [11.76055085738399, -8.48657020161954],
              [11.75679516718444, -8.494728035039737],
              [11.75020149539759, -8.495386473239101],
              [11.747554125258265, -8.497199358692116],
              [11.747326364382026, -8.50282054804981],
              [11.739415904747055, -8.514508578775795],
              [11.740279298766302, -8.520509824888276],
              [11.734217021809751, -8.529890686627153],
              [11.734806061657372, -8.533857812058013],
              [11.739789127034504, -8.537608891683986],
              [11.738718049381168, -8.541822479874439],
              [11.73151794934295, -8.541413571952882],
              [11.731941845529878, -8.544914889470531],
              [11.73560780603343, -8.54643779922339],
              [11.733644992179165, -8.555428732031253],
              [11.737081843826763, -8.561376574273076],
              [11.735209033279961, -8.563870314537837],
              [11.730010450589345, -8.563394781997216],
              [11.727815346781316, -8.566350174251532],
              [11.72900419009405, -8.569977733756344],
              [11.727392425708965, -8.573727923165835],
              [11.717597597318802, -8.58409080968349],
              [11.710604866261624, -8.585840795900058],
              [11.704464004803068, -8.591023752847928],
              [11.704108108379982, -8.596560366301592],
              [11.70786460510498, -8.600290885517492],
              [11.707315850942285, -8.602770604607425],
              [11.701546712850742, -8.60800615806801],
              [11.70278532056481, -8.61236974545804],
              [11.710150531988322, -8.611500258507128],
              [11.711354451313465, -8.61455553542266],
              [11.705194926748268, -8.620880315327637],
              [11.6939326566353, -8.626489905504815],
              [11.687818942160375, -8.634402572975475],
              [11.67999658430543, -8.631357525724514],
              [11.676597275528993, -8.643212382044297],
              [11.670332153009896, -8.644811773638668],
              [11.67030107483255, -8.65134189682695],
              [11.664751088066213, -8.653075658832696],
              [11.656424721490085, -8.651950648971786],
              [11.655356979006676, -8.65060342960924],
              [11.646503338249362, -8.648719686853907],
              [11.643633141108074, -8.651835679413413],
              [11.642505115783456, -8.661905690672713],
              [11.639287361226815, -8.66819539999823],
              [11.633448916072547, -8.67216243011559],
              [11.629370114734531, -8.68575156508079],
              [11.62760161033167, -8.68655556852477],
              [11.625316028432177, -8.68420797107543],
              [11.628545645127874, -8.678222044750747],
              [11.627538358316396, -8.675499399133159],
              [11.623261529020573, -8.674695603231479],
              [11.61849348058493, -8.669307569291009],
              [11.618975476225422, -8.666464615361464],
              [11.626428145571925, -8.65895379972974],
              [11.62621532732451, -8.656893080920055],
              [11.631954459667373, -8.652441847595588],
              [11.629974879767348, -8.648345601249492],
              [11.624762884125754, -8.650802191674487],
              [11.620564226426014, -8.646778409477209],
              [11.617158322350335, -8.646575474091982],
              [11.616938447874599, -8.63422974687219],
              [11.613726769808371, -8.630394047737864],
              [11.608315311832953, -8.629165378879662],
              [11.600302569253556, -8.620210073774953],
              [11.596030820403067, -8.611412675047806],
              [11.593522418903955, -8.609889614011111],
              [11.589693818803193, -8.61246845500126],
              [11.585759109330295, -8.609689938480408],
              [11.586975286201989, -8.606971475814994],
              [11.585661289657834, -8.600829293797373],
              [11.582752423711126, -8.5980547644917],
              [11.584024778759725, -8.593179922649933],
              [11.582708573655367, -8.587026632204664],
              [11.57451216446479, -8.584230572422157],
              [11.574412875452369, -8.577718513149838],
              [11.570194125881516, -8.572984756407166],
              [11.570462604430846, -8.569922951559022],
              [11.565716815253376, -8.563292962266976],
              [11.556577176864248, -8.563804929019964],
              [11.554121152380409, -8.557876753717034],
              [11.544650962185798, -8.553452181569458],
              [11.529878232872019, -8.555602452941155],
              [11.524051858551974, -8.55357887773072],
              [11.517573342993552, -8.557983960595326],
              [11.510331503487063, -8.557794154584073],
              [11.505858300884265, -8.553968024161433],
              [11.498206201607319, -8.555810132940008],
              [11.497656701636505, -8.553004018899147],
              [11.500637329970955, -8.547742936803456],
              [11.494391699119085, -8.5458479701982],
              [11.492731783484555, -8.54314645126566],
              [11.483299216859125, -8.53246347347617],
              [11.481786548110756, -8.526223977934784],
              [11.475305049372984, -8.520879714122673],
              [11.469255864104928, -8.519517574685027],
              [11.460783423144989, -8.52229386436815],
              [11.451836548577596, -8.513337550044204],
              [11.442616205003615, -8.510967894216192],
              [11.435476104945902, -8.501393204709117],
              [11.423773050096633, -8.502941213969558],
              [11.415553994058563, -8.500378425814416],
              [11.410234095703027, -8.491664622990825],
              [11.406509122721872, -8.492693295577107],
              [11.395630872817199, -8.489354056052083],
              [11.393710059256174, -8.483571386871736],
              [11.398321288920751, -8.479946549198383],
              [11.397241456006583, -8.476580420793818],
              [11.393906231850108, -8.473815112998878],
              [11.38972575915698, -8.464158584532644],
              [11.391191750501775, -8.457118147441355],
              [11.38690286185358, -8.442837174443456],
              [11.382636355308762, -8.437856464424955],
              [11.383243879635895, -8.430034124002466],
              [11.380464483671487, -8.420193605457957],
              [11.381126107805763, -8.413094147266175],
              [11.383331514111685, -8.407436889869913],
              [11.383642672476107, -8.395406737405944],
              [11.379247964562925, -8.375590477173917],
              [11.372710450991445, -8.35954050656229],
              [11.367280604918799, -8.353550688634215],
              [11.36378306119088, -8.34750350677938],
              [11.367169964365564, -8.346247305368907],
              [11.367571657152034, -8.342125962327156]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.15871282331106,
          "lat": 29.608609986451086
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12029"],
        "coty_name": ["Dixie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dixie County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00295725"
      },
      "bbox": [
        11.36378306119088, -8.68655556852477, 11.78490142561633,
        -8.130703540531142
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.369927674511118, -10.227411796637021],
              [12.373252575198034, -10.225170795568108],
              [12.376686059013425, -10.228363034987682],
              [12.373181493246264, -10.230728721828326],
              [12.369927674511118, -10.227411796637021]
            ]
          ],
          [
            [
              [12.388339510153724, -10.214220530189632],
              [12.41406429280315, -10.210987731483467],
              [12.437360196405235, -10.207638737133037],
              [12.53729504333927, -10.19262809729888],
              [12.62708200502952, -10.179566678765461],
              [12.640087202544077, -10.177993439475172],
              [12.747418669609374, -10.162634833357181],
              [12.82658517050587, -10.151212890922817],
              [12.828325177307269, -10.150808218691537],
              [12.83566348023306, -10.200387701530383],
              [12.852537042292054, -10.318855911661302],
              [12.871912426613656, -10.449417369582791],
              [12.878222417365421, -10.494218698383596],
              [12.884510040210376, -10.53512801557284],
              [12.890226584893785, -10.575744465679254],
              [12.840242309648284, -10.582575129194813],
              [12.715642468057116, -10.599788302180471],
              [12.704405826066157, -10.521514911969224],
              [12.694242066182866, -10.449190773399225],
              [12.691399170645422, -10.42802345367392],
              [12.583097361874934, -10.443104258748436],
              [12.519318310427483, -10.45261597169688],
              [12.518640421139903, -10.450276363450376],
              [12.504427599459978, -10.452624751525676],
              [12.470818379297233, -10.45715475350996],
              [12.454508745232546, -10.458879224899166],
              [12.446533724025906, -10.460352446061245],
              [12.419729023887218, -10.463733858662808],
              [12.345850682558648, -10.47335632078914],
              [12.32654644218747, -10.453447134909947],
              [12.312510731108235, -10.443820225793583],
              [12.297901688084428, -10.435869176152922],
              [12.295966676484806, -10.433367541502506],
              [12.29570051574944, -10.42637531082106],
              [12.274843737026838, -10.386485731410682],
              [12.267154423653489, -10.374897699306004],
              [12.25649825966952, -10.36332431818225],
              [12.237758224278364, -10.34864156151969],
              [12.234276614846635, -10.34146232847186],
              [12.23712509476574, -10.340548903646445],
              [12.244437828306328, -10.344008352393667],
              [12.257683668395712, -10.348865095081749],
              [12.269723591487077, -10.352110239631504],
              [12.269689956353629, -10.361761827922539],
              [12.268569186237476, -10.366276606337063],
              [12.270416453110181, -10.373161098200539],
              [12.274228254810836, -10.375895407915596],
              [12.288981523434153, -10.375828118632917],
              [12.292528350041463, -10.373642891233636],
              [12.29045915677939, -10.36415586631013],
              [12.292662748099772, -10.358808245097983],
              [12.299701187141798, -10.351406117107494],
              [12.310374750760982, -10.34675969532971],
              [12.31623967237188, -10.34747898021504],
              [12.322389505490571, -10.34555191134111],
              [12.32824057718626, -10.341611255060883],
              [12.322660117815706, -10.336134681677356],
              [12.323002580595926, -10.334398135251185],
              [12.331991397958333, -10.327543081240817],
              [12.332756369815195, -10.314876359081481],
              [12.336483227195524, -10.307448121048036],
              [12.347726156580185, -10.293678533403165],
              [12.345236762142507, -10.282546003370676],
              [12.346028758214066, -10.280015994844318],
              [12.35419221722573, -10.274321260088875],
              [12.358229173536218, -10.26964517492447],
              [12.366024469280354, -10.26846880514226],
              [12.371167829846303, -10.265599943653005],
              [12.374239278426938, -10.26195506789598],
              [12.37316832317084, -10.25633506980078],
              [12.377529548629381, -10.253996405746857],
              [12.382359477947483, -10.244833143616319],
              [12.382578569703213, -10.238800437377602],
              [12.380828089036308, -10.236325494795645],
              [12.381866785252857, -10.229340567333704],
              [12.381660607399219, -10.222874060316856],
              [12.3854196233204, -10.221680482186162],
              [12.388339510153724, -10.214220530189632]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.3152965122455, "lat": 27.47188430830604 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12081"],
        "coty_name": ["Manatee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Manatee County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00295744"
      },
      "bbox": [
        12.234276614846635, -10.599788302180471, 12.890226584893785,
        -10.150808218691537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.78663848184072, -7.6885875131612424],
            [12.811958066380958, -7.684472001117995],
            [12.82866949728303, -7.671942597341324],
            [12.833042064391746, -7.669152027265342],
            [12.842859560571592, -7.668363068076169],
            [12.852699509194549, -7.669284185159044],
            [12.862546995988911, -7.6725119888327695],
            [12.870729540349577, -7.671012604848718],
            [12.877684961051651, -7.6755070700720225],
            [12.883169334462858, -7.677470371048778],
            [12.889947702719807, -7.677223156896793],
            [12.907415866109476, -7.671628057137093],
            [12.910131441181456, -7.687473032478705],
            [12.96097985235713, -7.678689654966854],
            [12.998754174535199, -7.672421237506558],
            [12.999421511105277, -7.671564997074219],
            [12.97433330553037, -7.52845158308096],
            [12.980172162179889, -7.52764985071583],
            [13.02286942819349, -7.520424318555948],
            [13.057453769250131, -7.605877566171765],
            [13.094488654893645, -7.703988970345858],
            [13.103575752937946, -7.729420919317066],
            [13.115340323726324, -7.759082370278748],
            [13.126988933759192, -7.7890781584795254],
            [13.13947721502078, -7.816723406101787],
            [13.145009535827837, -7.827270761341031],
            [13.152483233820398, -7.839597683336759],
            [13.164127740568127, -7.849036591681246],
            [13.1668507052603, -7.853775366061627],
            [13.167655736794947, -7.858742499017562],
            [13.171072478280543, -7.868295544318902],
            [13.180082636823583, -7.8902930565356],
            [13.181226598134373, -7.891795561132671],
            [13.183823903358068, -7.904826737228177],
            [13.193601537894954, -7.94252368053002],
            [13.197390077046787, -7.953734286861066],
            [13.203888090049936, -7.970423205181902],
            [13.22125177514523, -8.005225419216798],
            [13.234821575935857, -8.027965237232818],
            [13.255486131936356, -8.068901137890697],
            [13.243123027039621, -8.070949404024939],
            [13.24045141266391, -8.078512864208614],
            [13.23557990653555, -8.080032153337434],
            [13.227772999602541, -8.084802843721375],
            [13.213478978362273, -8.079888683359052],
            [13.206012883127686, -8.08665039664133],
            [13.206143768003187, -8.092383944599462],
            [13.199192734805699, -8.097923097225063],
            [13.195132348185606, -8.097617334578091],
            [13.192143415416464, -8.09974694926889],
            [13.185681600444974, -8.099300423019317],
            [13.182192413362596, -8.101158049692227],
            [13.179964832257095, -8.108679171707509],
            [13.175201151568839, -8.10921356345597],
            [13.16781174188099, -8.101886792432165],
            [13.162475420868567, -8.100520278329716],
            [13.167008334697845, -8.1277515668587],
            [13.127991633724553, -8.134211025774885],
            [13.052202119027216, -8.147639912673974],
            [12.996066546681053, -8.157092970450021],
            [12.985464871536642, -8.092324115154218],
            [12.984956945151307, -8.090271931806006],
            [12.97391533035992, -8.023111575272354],
            [12.966217092441596, -8.019846721081388],
            [12.958596836414392, -8.01490939077882],
            [12.95458651219829, -8.00636815647422],
            [12.948776289658454, -8.00096862235768],
            [12.936830363354707, -7.992538278525623],
            [12.931930873455443, -7.985972845937409],
            [12.925561893330935, -7.974523772930787],
            [12.913707626797061, -7.951363798225599],
            [12.893126678487036, -7.9191371004312305],
            [12.884373855037074, -7.899332534856627],
            [12.880136844816148, -7.8869808319963735],
            [12.879044412712537, -7.880878768996233],
            [12.879950519333198, -7.873347105833845],
            [12.88316292492908, -7.859334930126406],
            [12.883183051966972, -7.852914378055478],
            [12.88079856671231, -7.843960407995542],
            [12.874811863997381, -7.83357058306444],
            [12.869278164846387, -7.827648890847994],
            [12.8554628953903, -7.818672001382168],
            [12.811575400626289, -7.799227120846456],
            [12.804706325837003, -7.795253663162909],
            [12.800133152425179, -7.791466119578825],
            [12.79583748524008, -7.785803653583295],
            [12.793160517552387, -7.780603875366754],
            [12.789665376064834, -7.766814120961212],
            [12.787615685901864, -7.746928210742298],
            [12.792142793448125, -7.726484918797535],
            [12.791333266988133, -7.71935809004753],
            [12.787603137018976, -7.703560606761373],
            [12.78663848184072, -7.6885875131612424]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.44066064177673, "lat": 29.90163047961782 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12109"],
        "coty_name": ["St. Johns"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Johns County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00308371"
      },
      "bbox": [
        12.78663848184072, -8.157092970450021, 13.255486131936356,
        -7.520424318555948
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.396871437092065, -5.699805448005725],
            [12.486700085427117, -5.6593899849595735],
            [12.521301813530622, -5.643718876355838],
            [12.569381648299728, -5.619379608454162],
            [12.614512882634058, -5.596726105410555],
            [12.67062426558944, -5.5687888968186385],
            [12.677614909409956, -5.574643323311218],
            [12.68076550076095, -5.580669854815884],
            [12.678348692209784, -5.586862157726701],
            [12.682916105428045, -5.592133041404621],
            [12.693278245925171, -5.598557574805721],
            [12.694821105421358, -5.602209101148167],
            [12.69333206572477, -5.608605802591664],
            [12.695397976270977, -5.617924953131876],
            [12.699048049163908, -5.621126342043014],
            [12.696655118427087, -5.623711368784856],
            [12.699466051011779, -5.632931545512384],
            [12.703288007262255, -5.637732714801543],
            [12.702651157348248, -5.641502729508449],
            [12.705407575427074, -5.648733838857832],
            [12.709415579734024, -5.653722534760185],
            [12.713164416250322, -5.654702648741513],
            [12.710975407944504, -5.662578703713086],
            [12.710585800804294, -5.667479283739583],
            [12.71298569587692, -5.675629839372193],
            [12.715566852495172, -5.6890448230508115],
            [12.719437380961516, -5.694227881513985],
            [12.721794151483653, -5.69925032667911],
            [12.729453543629907, -5.702909952483856],
            [12.729695879542806, -5.706860586860482],
            [12.734360971790018, -5.711865712653665],
            [12.733331231955885, -5.715245366568318],
            [12.738022576960264, -5.722140414592683],
            [12.743800954516876, -5.726511803498181],
            [12.75029385249929, -5.728592942160795],
            [12.747913075531553, -5.733590678195766],
            [12.752410238036322, -5.735888578093051],
            [12.756166489228798, -5.742123385991693],
            [12.75397821389558, -5.745035321107831],
            [12.75766504806094, -5.751123811839037],
            [12.762801245466346, -5.752508996793297],
            [12.769520395469323, -5.757798653011074],
            [12.782164969465475, -5.764094816188067],
            [12.783937771856518, -5.762206743042323],
            [12.787759465417832, -5.766882832990792],
            [12.787723327698718, -5.772654578161276],
            [12.792444744081857, -5.774452289750458],
            [12.798264901091747, -5.7729875881265205],
            [12.802747208646625, -5.778624043298902],
            [12.800024236366232, -5.781268667129268],
            [12.803662203948642, -5.78548573054282],
            [12.807427459379248, -5.782242436917536],
            [12.808448645505871, -5.787145023766051],
            [12.813036849506682, -5.787045993229027],
            [12.81748904782196, -5.791143336133817],
            [12.813215265253884, -5.795924733364129],
            [12.816318178737166, -5.800971774613882],
            [12.81627286601374, -5.808373328923372],
            [12.821361202940645, -5.8101601648432935],
            [12.828260045503468, -5.808963552593492],
            [12.833934417617547, -5.810822603348273],
            [12.835311312410571, -5.813663194517929],
            [12.83493106070461, -5.827551807860372],
            [12.83938049193592, -5.83683181783925],
            [12.838611373395556, -5.841764454695681],
            [12.841872578469573, -5.844195873581342],
            [12.845715572032514, -5.841258261228707],
            [12.851424270635428, -5.843203969042736],
            [12.853475800153891, -5.846676711143978],
            [12.851390681389995, -5.854022149475579],
            [12.852124968253989, -5.857626608566181],
            [12.85503695428533, -5.860348453934394],
            [12.859372290934475, -5.860176422640796],
            [12.86297521055473, -5.856986191775051],
            [12.867294527191707, -5.856718076360008],
            [12.868173642845887, -5.859601934837211],
            [12.86370383104612, -5.864360555724966],
            [12.862473638657216, -5.868455388790357],
            [12.863411795092793, -5.873632225926416],
            [12.867725243232503, -5.877326265585084],
            [12.871975974335244, -5.877577529020327],
            [12.876623755017182, -5.871450718576943],
            [12.883830754403224, -5.869049111097191],
            [12.888886785233002, -5.870157293402048],
            [12.891344788344693, -5.875980331205558],
            [12.889602178785776, -5.880308136058328],
            [12.885908498665781, -5.884746448022809],
            [12.885124883583444, -5.888730413814635],
            [12.88955664714986, -5.893332452680585],
            [12.892086950105272, -5.89234761597643],
            [12.897087302518722, -5.882658958288064],
            [12.898114045640687, -5.876280858847192],
            [12.904668646850105, -5.862587348441958],
            [12.90763216533185, -5.8579246062202],
            [12.9154008187777, -5.853465430635963],
            [12.921717221012088, -5.853629119846268],
            [12.924758934952177, -5.856162624825623],
            [12.925340214430802, -5.859502420500735],
            [12.923773619025036, -5.865917367732174],
            [12.917659410763164, -5.873491462361691],
            [12.90588021140636, -5.880017445883749],
            [12.902048621168083, -5.885329848537937],
            [12.903887261374681, -5.889120671194652],
            [12.90799364092211, -5.890141190505735],
            [12.914451266866655, -5.888010822643073],
            [12.922164093039509, -5.880484307036216],
            [12.927400830297717, -5.876451335179896],
            [12.936114957066318, -5.872286946983297],
            [12.942135644133147, -5.872315413263105],
            [12.946191419552482, -5.874420370399968],
            [12.954230106501594, -5.882744380541066],
            [12.955992204851695, -5.893030852105978],
            [12.960287160481279, -5.901779263323517],
            [12.965337356881747, -5.906655064215876],
            [12.978094932158205, -5.911022307084714],
            [12.977949319598935, -5.914386356179737],
            [12.971453587056626, -5.924812888891634],
            [12.967305762187479, -5.929407571936321],
            [12.965324550063183, -5.934674101494587],
            [12.965441072893688, -5.945682618841222],
            [12.963161860894202, -5.949065601510551],
            [12.954378798627648, -5.952567955066969],
            [12.95215538040055, -5.955349067834239],
            [12.953627249905805, -5.965731945875106],
            [12.951687017662529, -5.973532166491141],
            [12.95229970623145, -5.978481678159035],
            [12.955383734887855, -5.980629800837223],
            [12.967059932571715, -5.981326281599414],
            [12.97030862211408, -5.983439011601895],
            [12.97054456034391, -5.9897852453998555],
            [12.965515139457922, -5.997045332146856],
            [12.963560939714231, -6.006337643199847],
            [12.963970472275212, -6.011641931399264],
            [12.966632840756644, -6.015471355170976],
            [12.977725395891856, -6.0222190119875005],
            [12.983038170413684, -6.0297886981973186],
            [12.98487281991309, -6.0411487866344045],
            [12.97956383361189, -6.040017074181804],
            [12.968481447596547, -6.042415377456856],
            [12.951902950723708, -6.039184893539585],
            [12.94832747572293, -6.0469973309215765],
            [12.941171173614508, -6.044334235722796],
            [12.932768444350371, -6.035715954741178],
            [12.928432390115217, -6.033225589186697],
            [12.920245801294564, -6.032141870904151],
            [12.914614289375484, -6.030301552266681],
            [12.891629085157492, -6.027278438325988],
            [12.886016768986737, -6.023930935202627],
            [12.88213218418396, -6.018472613353631],
            [12.880654125529725, -6.008153251630838],
            [12.880655189273632, -5.99834580448733],
            [12.877857945676537, -5.993624925758238],
            [12.87158049912507, -5.989645680654521],
            [12.8662600569952, -5.990673990322491],
            [12.853997692349786, -5.997126260305112],
            [12.848618583998105, -5.998870108148419],
            [12.844215180814212, -5.998642570396562],
            [12.842774445839668, -5.988352047642947],
            [12.834746552045692, -5.983023698580469],
            [12.833753267325589, -5.981054277536656],
            [12.836635072498497, -5.974732574181409],
            [12.835469329031405, -5.971508766308818],
            [12.829307567546914, -5.968749155829292],
            [12.824724315260466, -5.968196748302282],
            [12.825298373515528, -5.960923929955853],
            [12.820433944973582, -5.9526776273827045],
            [12.81775914099697, -5.951625327057022],
            [12.812167992234164, -5.9524082494661865],
            [12.808163275166896, -5.956579518775372],
            [12.809805085782925, -5.9589798843992146],
            [12.815910039031012, -5.956471621422868],
            [12.819417209580573, -5.957892677806694],
            [12.811725717196866, -5.965222744740947],
            [12.816165958984822, -5.972200148881136],
            [12.815167304626428, -5.975668842855163],
            [12.80850980239315, -5.979598647721345],
            [12.803662666816841, -5.980136245689326],
            [12.801828405004274, -5.976975017036191],
            [12.804857852654415, -5.974617406455064],
            [12.810282351500613, -5.974780072059721],
            [12.810589870559395, -5.968591340680559],
            [12.80532802554812, -5.968590661402027],
            [12.798509417090735, -5.963952706739696],
            [12.799382794270965, -5.956122414789133],
            [12.794212021928855, -5.958771280585937],
            [12.789877017723732, -5.949879597239588],
            [12.786927574194584, -5.952431864532578],
            [12.78458010417178, -5.950219852118969],
            [12.779088138178075, -5.949297662779346],
            [12.777502360389153, -5.944493797559866],
            [12.775228418127744, -5.944556298122613],
            [12.77241401296929, -5.938191490235975],
            [12.773742907579177, -5.931222053044958],
            [12.770828657672563, -5.922859092432271],
            [12.7669566329481, -5.919451746939075],
            [12.761958540539972, -5.919960142075271],
            [12.758466959794465, -5.917608124479845],
            [12.758500950367623, -5.913300277532158],
            [12.760920048588416, -5.906713647159134],
            [12.756822876678283, -5.896070623284265],
            [12.750467042541633, -5.890444097101815],
            [12.75041258618147, -5.887578438766557],
            [12.74620471664027, -5.882547029930455],
            [12.74853198574931, -5.879813113098325],
            [12.747344199182942, -5.874949575179466],
            [12.748522522565077, -5.872337874537625],
            [12.743117363799302, -5.8656610285047135],
            [12.739879930945479, -5.8587451662603955],
            [12.734500809499826, -5.861635222109946],
            [12.731910420924626, -5.86468651168196],
            [12.724502459894126, -5.866695470927075],
            [12.691923160282304, -5.860232491229488],
            [12.682259622967075, -5.839298102216975],
            [12.67752062883204, -5.837898442434725],
            [12.672192124795139, -5.840487496042053],
            [12.66987800189723, -5.847096788857493],
            [12.662300058504963, -5.846098465561333],
            [12.657443472040589, -5.852547954678283],
            [12.652114165546198, -5.849814272981189],
            [12.650282806866324, -5.8474093070520485],
            [12.646672334011631, -5.849264576919372],
            [12.647424457934385, -5.8548550802081225],
            [12.641748335431616, -5.858872079573086],
            [12.638221785373302, -5.85603717112142],
            [12.628885826231672, -5.8570747010049375],
            [12.625029549808621, -5.861191915100866],
            [12.618583892957407, -5.861190748566218],
            [12.616689508704468, -5.8642995635535335],
            [12.612315177602044, -5.862976113069193],
            [12.606687204796378, -5.863674503917341],
            [12.601807565882778, -5.856442520429602],
            [12.59325914445014, -5.8525075913655895],
            [12.591431666208333, -5.854270935840805],
            [12.5812124544483, -5.854426155896274],
            [12.580984635639298, -5.8475981981994565],
            [12.578144731352348, -5.845098429015682],
            [12.576748056573114, -5.835579155096485],
            [12.573850646469745, -5.8361002571517435],
            [12.56828741183588, -5.826927366664705],
            [12.565363011417258, -5.8249829599927345],
            [12.565330089024155, -5.817929645117502],
            [12.55348372713402, -5.809388788142104],
            [12.55383777375438, -5.805963559282194],
            [12.549559718486078, -5.798782330696546],
            [12.54644269368462, -5.7990467668471934],
            [12.543302677903915, -5.7959743367714855],
            [12.540085121332046, -5.795330493445467],
            [12.534851998368813, -5.789936568117443],
            [12.532307872264429, -5.79011673383144],
            [12.528266406875806, -5.783014787208231],
            [12.525028115814239, -5.7805683698284644],
            [12.522211501571752, -5.7811343741913825],
            [12.519137667956025, -5.7769941897667705],
            [12.511796643721894, -5.779129383334827],
            [12.50762008647438, -5.77781732770053],
            [12.50593657537455, -5.774636526028473],
            [12.50030796332166, -5.774258629191336],
            [12.499643215227815, -5.769988277804977],
            [12.49569309519317, -5.764231119952442],
            [12.489590339808293, -5.763679468056066],
            [12.48538239995055, -5.760877385435728],
            [12.483644253309443, -5.756089254192606],
            [12.480035370256317, -5.752603820276653],
            [12.477392582966873, -5.753877415031011],
            [12.474758496413, -5.750933392142404],
            [12.470836356599019, -5.753754922372366],
            [12.465767569531002, -5.751186868419216],
            [12.458238145928787, -5.754840631689852],
            [12.455053632062738, -5.753854928185786],
            [12.45102927170267, -5.747604348546036],
            [12.444922432448921, -5.747609373166921],
            [12.441694483506133, -5.7442137302027145],
            [12.437303515308459, -5.7426716475213935],
            [12.431372468445772, -5.744599020322603],
            [12.423881601298426, -5.744079382310378],
            [12.422028938086651, -5.737279738619212],
            [12.413760937018386, -5.728526728256604],
            [12.41195534173524, -5.723256786652607],
            [12.408338199238793, -5.720015346855336],
            [12.404078210536843, -5.720441213239348],
            [12.401055126782119, -5.712501661326188],
            [12.40172770993842, -5.710726972723169],
            [12.397061860728668, -5.704982454222196],
            [12.396871437092065, -5.699805448005725]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.44366390833166,
          "lat": 32.014582436912114
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13029"],
        "coty_name": ["Bryan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bryan County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00350496"
      },
      "bbox": [
        12.396871437092065, -6.0469973309215765, 12.98487281991309,
        -5.5687888968186385
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.17463558112211, -5.605423799575558],
            [12.196244329073208, -5.604960495409497],
            [12.22230980148899, -5.607987938443688],
            [12.222941418520332, -5.60850435709218],
            [12.227458764098259, -5.604721430211163],
            [12.23642215519686, -5.608481438599273],
            [12.25154439384178, -5.603305024611778],
            [12.264381519580207, -5.59669572205827],
            [12.271509175861532, -5.594963943767302],
            [12.285563410899982, -5.593141766994526],
            [12.298404105860918, -5.599309451014738],
            [12.303471719364245, -5.601107648193286],
            [12.30851749368492, -5.605460024881385],
            [12.310733641416727, -5.6048514235509215],
            [12.319776315933295, -5.609720836929767],
            [12.325707625524775, -5.613774166476435],
            [12.333057035303725, -5.620304048856844],
            [12.339842455894177, -5.618119897768629],
            [12.343981157705244, -5.621141988035611],
            [12.354725646934968, -5.620566862002943],
            [12.359070420949182, -5.624614532547897],
            [12.360109878694784, -5.62997210744131],
            [12.367674615739245, -5.636453657257325],
            [12.366826020366245, -5.640805007705092],
            [12.367534264189722, -5.651361534519101],
            [12.369208462612848, -5.651967604503687],
            [12.372732560481847, -5.658945216066306],
            [12.378178251112837, -5.662058079797178],
            [12.381039316526657, -5.6612550861462445],
            [12.385976216166789, -5.668725350856389],
            [12.389447006982806, -5.675787978989881],
            [12.393495503891517, -5.677603280555612],
            [12.393971769992524, -5.686375943288202],
            [12.396666344454891, -5.68844269532934],
            [12.395462610347892, -5.692147044489286],
            [12.396871437092065, -5.699805448005725],
            [12.397061860728668, -5.704982454222196],
            [12.40172770993842, -5.710726972723169],
            [12.401055126782119, -5.712501661326188],
            [12.404078210536843, -5.720441213239348],
            [12.408338199238793, -5.720015346855336],
            [12.41195534173524, -5.723256786652607],
            [12.413760937018386, -5.728526728256604],
            [12.422028938086651, -5.737279738619212],
            [12.423881601298426, -5.744079382310378],
            [12.431372468445772, -5.744599020322603],
            [12.437303515308459, -5.7426716475213935],
            [12.441694483506133, -5.7442137302027145],
            [12.444922432448921, -5.747609373166921],
            [12.45102927170267, -5.747604348546036],
            [12.455053632062738, -5.753854928185786],
            [12.458238145928787, -5.754840631689852],
            [12.428547400604664, -5.801220559502745],
            [12.32191793835303, -5.814593935097021],
            [12.303575213263146, -5.810749814488661],
            [12.24147884040486, -5.795124244322707],
            [12.228450865329055, -5.758103834425521],
            [12.206339042803446, -5.696003222113564],
            [12.178359728633277, -5.617312368863953],
            [12.17463558112211, -5.605423799575558]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.88693431842476,
          "lat": 32.156751992592675
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13109"],
        "coty_name": ["Evans"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Evans County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00345923"
      },
      "bbox": [
        12.17463558112211, -5.814593935097021, 12.458238145928787,
        -5.593141766994526
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.08476212582701, -3.9744243467488363],
            [9.145677981380048, -3.967926481143651],
            [9.151494747981712, -3.9570383707236987],
            [9.151087945956718, -3.954470433822798],
            [9.147439935567398, -3.9503408075636006],
            [9.151168338151884, -3.941629557083911],
            [9.153388124742207, -3.9301241348208293],
            [9.155865328104424, -3.92603993870977],
            [9.15938873710018, -3.9135336368512412],
            [9.161450542557994, -3.9122095665407737],
            [9.167513639086987, -3.9028428730603544],
            [9.168923778494353, -3.897849453543032],
            [9.172956126475986, -3.8903644095267844],
            [9.176402128007048, -3.885825012107995],
            [9.17898124661463, -3.879546026679026],
            [9.18828283727105, -3.872514487992828],
            [9.203458284909864, -3.864184823702195],
            [9.207102897439063, -3.860791086860859],
            [9.221218246079035, -3.8547530172531657],
            [9.225867646027938, -3.8499369418139477],
            [9.232577306108086, -3.8472912401934822],
            [9.233650255388543, -3.8441272130573796],
            [9.242511539140217, -3.8391113457559864],
            [9.245054492458825, -3.8397179433378787],
            [9.244417332205558, -3.833246225728115],
            [9.250622688451745, -3.832472775144706],
            [9.249882951953673, -3.825213927528744],
            [9.265253170838262, -3.823453755473852],
            [9.264754881672292, -3.81817164285941],
            [9.270823268084836, -3.815458259504519],
            [9.269633121165603, -3.8087301892560013],
            [9.278103164424378, -3.8080216850089026],
            [9.279402706828918, -3.805651700403619],
            [9.297119104724704, -3.798786581301711],
            [9.29867789104916, -3.789782785284596],
            [9.303334252070904, -3.7795149102384977],
            [9.307189002602946, -3.7611846307615053],
            [9.308265670746012, -3.7439049030111526],
            [9.30963420992921, -3.737396896338175],
            [9.3120346456736, -3.732518373008002],
            [9.314640959344159, -3.7171340014503467],
            [9.329185926009206, -3.6791140141812746],
            [9.334467062004425, -3.6550139330093314],
            [9.33764915591822, -3.6462426110019224],
            [9.338683863912452, -3.6409595833386166],
            [9.37002204572458, -3.6376560086437895],
            [9.371317265743379, -3.6498115259702795],
            [9.375493427015206, -3.649481895195662],
            [9.379773539512392, -3.681738731294215],
            [9.358345573829153, -3.684848275154566],
            [9.367339772600161, -3.763191754891058],
            [9.350022456851706, -3.765331947684618],
            [9.353696789822587, -3.771276690804583],
            [9.358658029196075, -3.774761814999724],
            [9.361057257936112, -3.779610370358765],
            [9.36042525577006, -3.783816018853813],
            [9.365837292134229, -3.786260705521162],
            [9.370841225918161, -3.7972588862864494],
            [9.371573060279283, -3.8027371990357923],
            [9.363318995177588, -3.8067803115051873],
            [9.35883560766483, -3.813194843369989],
            [9.359014174194868, -3.8173920573284392],
            [9.362489880942482, -3.8237374534606214],
            [9.365881497177195, -3.8233831630959654],
            [9.377216758600413, -3.8250955583507866],
            [9.421971316367625, -3.819842246174795],
            [9.426101951426974, -3.821094740344702],
            [9.426629651130115, -3.8267552501903666],
            [9.432230761948846, -3.829040121506551],
            [9.433412083261615, -3.8276681069117187],
            [9.444094421790066, -3.8262987700427162],
            [9.449811542216894, -3.8715670904588437],
            [9.435270083372439, -3.8732191731906234],
            [9.44003579854063, -3.91503487456392],
            [9.444943840778425, -3.962013604648002],
            [9.451766030642027, -3.9613078216844304],
            [9.452524746169058, -3.9683811627088117],
            [9.445765954469268, -3.96950268318495],
            [9.45022212563405, -4.006851516538107],
            [9.433204048917752, -4.008579074051821],
            [9.444982307546917, -4.125825389218907],
            [9.38364441533816, -4.132541756738836],
            [9.384790245142733, -4.146172977268007],
            [9.356133836592651, -4.14913137392323],
            [9.354681083497535, -4.135333105166151],
            [9.31163486811776, -4.13988022857693],
            [9.311323144639312, -4.1371895185203735],
            [9.272431147679352, -4.141248416667772],
            [9.274514342918042, -4.16279473004367],
            [9.230534263621038, -4.167239038277728],
            [9.179596214642466, -4.172109961677655],
            [9.178914735628457, -4.172382456664154],
            [9.14054646216413, -4.176135878360598],
            [9.131588121262126, -4.143180413171522],
            [9.129372492275989, -4.132607080628627],
            [9.094468839657502, -4.009457590821525],
            [9.08476212582701, -3.9744243467488363]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.2142452079572, "lat": 34.263218583625665 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13115"],
        "coty_name": ["Floyd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Floyd County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00353665"
      },
      "bbox": [
        9.08476212582701, -4.176135878360598, 9.452524746169058,
        -3.6376560086437895
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.303752005649645, -3.781035804606828],
            [10.298178341266372, -3.7729670915871596],
            [10.295091986780118, -3.7764403029311557],
            [10.293156861068647, -3.7721328087732906],
            [10.289534731903624, -3.768257421404652],
            [10.285309998936233, -3.760500169592214],
            [10.280929847639259, -3.759785555651831],
            [10.284217232893171, -3.7524385001430174],
            [10.279898309321913, -3.747982918017562],
            [10.279953689462008, -3.7403390935801766],
            [10.281628270247587, -3.73799329854966],
            [10.27538068852253, -3.735010044355645],
            [10.275567223607753, -3.73178337223287],
            [10.27909797077006, -3.7266287052998037],
            [10.279858686050277, -3.7192458252647462],
            [10.282732551206667, -3.7178133091128185],
            [10.28252786555108, -3.7112504014840555],
            [10.275878315261783, -3.705978995992096],
            [10.271345618917042, -3.7064779611825416],
            [10.271899074283771, -3.7008936461864685],
            [10.273867744157315, -3.699277016985259],
            [10.277657404787691, -3.6984401886715097],
            [10.281245915577118, -3.6926295305694206],
            [10.277869403842617, -3.685891992931309],
            [10.285547772279516, -3.679762320415771],
            [10.291107425252461, -3.6779249955190196],
            [10.309729995781527, -3.661438311751431],
            [10.318364138793896, -3.66041890509397],
            [10.31723439378253, -3.651447528211317],
            [10.308065193813905, -3.652195367405404],
            [10.30694952935262, -3.643396472816649],
            [10.324852102561856, -3.641275790111695],
            [10.325964863069839, -3.650647088706284],
            [10.344059039784886, -3.648202591627436],
            [10.342943580301831, -3.639367118201822],
            [10.350111587752359, -3.6314962732625107],
            [10.352965474038893, -3.6294340574106068],
            [10.375239496232204, -3.606591235631926],
            [10.374077106160238, -3.5981465143492675],
            [10.418703529469164, -3.593156117647386],
            [10.417395508667072, -3.5838474123250497],
            [10.42636318530919, -3.5830963859966545],
            [10.427434225074116, -3.591986245920522],
            [10.445673371548889, -3.5899994634426573],
            [10.51780529881851, -3.581481947370345],
            [10.559177387685736, -3.6359140786448414],
            [10.568720523529437, -3.6477780615168074],
            [10.56607908625336, -3.652418173221235],
            [10.564094643433366, -3.6608346405238836],
            [10.550382404012058, -3.6671249686330203],
            [10.548244685271456, -3.6699158479063323],
            [10.547513601651099, -3.676199644862101],
            [10.542164988165256, -3.6807735145944385],
            [10.54016119006097, -3.6839371110820505],
            [10.537599672748073, -3.693319767903294],
            [10.53883975282186, -3.7055807394267277],
            [10.535223255765851, -3.7168347440603724],
            [10.533406134035173, -3.7180897766691117],
            [10.539197278516003, -3.727220540569526],
            [10.545033796002363, -3.7289635196988495],
            [10.550130706991228, -3.7340576001487693],
            [10.550824120522552, -3.7393848164856918],
            [10.554852260044916, -3.7480757776852287],
            [10.554461605188296, -3.755653968470397],
            [10.555747425175454, -3.7623865799091125],
            [10.562673576090026, -3.7692363487026332],
            [10.571223774676122, -3.7739960457689645],
            [10.576711545894906, -3.773790444934009],
            [10.577826706420943, -3.7788744363595907],
            [10.582756346372362, -3.784242882443852],
            [10.538089801137742, -3.8446600149442753],
            [10.505503443190115, -3.8889109045097556],
            [10.44363248970317, -3.972507127912759],
            [10.436235850392823, -3.978708134301542],
            [10.42527717754852, -3.989394162757407],
            [10.406462876243431, -4.00650735259204],
            [10.399897423276933, -4.004912338398144],
            [10.343493317072415, -3.987970707314072],
            [10.315064217583881, -3.979208825123482],
            [10.311442630908374, -3.9787603415471104],
            [10.3008457579802, -3.975080616537834],
            [10.270807462603091, -3.9663798270595465],
            [10.249956436100378, -3.95942554447899],
            [10.239214572622368, -3.9569226207600274],
            [10.24052854489811, -3.9496981313238284],
            [10.240084515801929, -3.943550282656366],
            [10.243767662926746, -3.938934289905033],
            [10.245877995789147, -3.934269090169801],
            [10.253020612373836, -3.92976845855676],
            [10.261466820408616, -3.9269863796260966],
            [10.267149082989246, -3.9266505263415548],
            [10.275841952440217, -3.929347841933088],
            [10.28197893608648, -3.9267683720728166],
            [10.283791664883832, -3.9237569077986647],
            [10.29014630847136, -3.9249395957597715],
            [10.29470475691065, -3.9229623479429296],
            [10.298156324470213, -3.9174541967398198],
            [10.30071796009626, -3.9059084567048425],
            [10.302161733736023, -3.9029714594191813],
            [10.30670597241625, -3.9021464475919783],
            [10.310955090693028, -3.8996892703998722],
            [10.312187984860083, -3.8952462133387002],
            [10.307199580722441, -3.8933963732852206],
            [10.305688721640731, -3.887626190215759],
            [10.31343320390594, -3.8825557141352367],
            [10.32165071939426, -3.874230103503172],
            [10.320417188183907, -3.8662512562837263],
            [10.316762776664937, -3.8604128558108193],
            [10.318184577832008, -3.8517392812158113],
            [10.314630716847436, -3.847071911799086],
            [10.316399109349268, -3.843935645897302],
            [10.323069213590717, -3.838642887069069],
            [10.334937307182091, -3.8324337697377104],
            [10.335418633572925, -3.8252566141886177],
            [10.332595034516878, -3.8220691199442047],
            [10.32961510312041, -3.822282481466421],
            [10.32566427169013, -3.818102873584665],
            [10.329275751612323, -3.8145021330608024],
            [10.32446380738899, -3.8134522935016655],
            [10.320199922127482, -3.819254666559359],
            [10.316788950694955, -3.8163390958404495],
            [10.319538678744893, -3.8123040431187345],
            [10.317622961374079, -3.8078721154901514],
            [10.309344118242077, -3.7986186652451215],
            [10.310149937932955, -3.791604865949865],
            [10.313922649315817, -3.7899651159318744],
            [10.314034098051005, -3.7843544151574044],
            [10.308012748682907, -3.7836543012069397],
            [10.303752005649645, -3.781035804606828]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.81948741800205, "lat": 34.3170748872588 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13139"],
        "coty_name": ["Hall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hall County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01686953"
      },
      "bbox": [
        10.239214572622368, -4.00650735259204, 10.582756346372362,
        -3.581481947370345
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.318963718524529, -4.815734886619013],
            [9.341698349324636, -4.8132761772486825],
            [9.398419883364422, -4.807600279172088],
            [9.465513827690783, -4.800379728178826],
            [9.548638225900378, -4.792103801715907],
            [9.570869795423176, -4.84085808661125],
            [9.612655513171111, -4.934607051061563],
            [9.61208763941257, -4.9293091631689965],
            [9.620154687058143, -4.928459681717813],
            [9.622100308782837, -4.945019687460899],
            [9.617347039645209, -4.94561810409136],
            [9.634968685631524, -4.98487871376275],
            [9.594712794743204, -5.00821105529886],
            [9.55519054623848, -5.030864024499812],
            [9.552712413882965, -5.037533246638093],
            [9.54881230897302, -5.038516913136997],
            [9.543288016456783, -5.036895624961277],
            [9.540547286766644, -5.037750344730845],
            [9.536697757761795, -5.042907268290688],
            [9.51806550481358, -5.051894022061713],
            [9.516616499430398, -5.03703491784421],
            [9.508462966774657, -5.037930757119109],
            [9.50750209067522, -5.029500108121303],
            [9.498896315934878, -5.030479259331135],
            [9.50091815841744, -5.047042213192885],
            [9.49291003598865, -5.047921657296219],
            [9.494730855890227, -5.062692259378495],
            [9.400192496055682, -5.107864373328422],
            [9.363134182351887, -4.974781116197336],
            [9.336622111646502, -4.879373256881904],
            [9.318963718524529, -4.815734886619013]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.12833892937938, "lat": 33.29703821845357 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13149"],
        "coty_name": ["Heard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Heard County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00347067"
      },
      "bbox": [
        9.318963718524529, -5.107864373328422, 9.634968685631524,
        -4.792103801715907
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.036062928892875, -6.455115756053485],
            [11.033396211123385, -6.42983260737108],
            [11.040328048971588, -6.428969418255868],
            [11.031041360582549, -6.352993778510249],
            [11.05635921188093, -6.350366507472177],
            [11.05534660166241, -6.346418079241747],
            [11.056696334110702, -6.341141012278959],
            [11.061095125487617, -6.336443232476862],
            [11.057697038637695, -6.328915461022417],
            [11.056466551472665, -6.322677387119051],
            [11.04980540663977, -6.317308569567313],
            [11.04770329291564, -6.304689677903062],
            [11.055956230464071, -6.2932470012394415],
            [11.053982106973239, -6.287770985955961],
            [11.124040854243658, -6.279304281199658],
            [11.122893272102647, -6.266769970041318],
            [11.148056214784374, -6.263522038243854],
            [11.149612966520522, -6.2763627149583705],
            [11.16184161177281, -6.274748094627023],
            [11.165033613378476, -6.295797046691954],
            [11.170166999295672, -6.336273233768767],
            [11.171718501962633, -6.349959126933434],
            [11.211214479917427, -6.345634088258179],
            [11.222190505038347, -6.3439630058414025],
            [11.225021616724414, -6.3694221498477654],
            [11.243951716913333, -6.367834842586333],
            [11.300241913816706, -6.36184036086353],
            [11.29734355729735, -6.335346881282385],
            [11.324149130195424, -6.332507424609002],
            [11.403508500137868, -6.32473364837681],
            [11.44751616382265, -6.32019982534366],
            [11.448890619753344, -6.332804692554542],
            [11.436563985821602, -6.334153647083148],
            [11.439362165089733, -6.359044442072226],
            [11.42654173257846, -6.36032171937947],
            [11.42755346073221, -6.372772710398635],
            [11.41553039638393, -6.373937083441896],
            [11.416996525227203, -6.387189676332512],
            [11.405212129396379, -6.388385134818151],
            [11.410404490362248, -6.4337247643366515],
            [11.406258157146985, -6.454761022473229],
            [11.403833499747954, -6.460388526084927],
            [11.403351623866817, -6.465244136756348],
            [11.397384176942639, -6.4759462796681495],
            [11.396529929629526, -6.4875728763434175],
            [11.391728520394937, -6.490797469978428],
            [11.387617473968415, -6.496533600399168],
            [11.385145872495187, -6.509475756750075],
            [11.379425097054428, -6.521666738690325],
            [11.378851616030914, -6.525874876044752],
            [11.370417572819619, -6.53187778863817],
            [11.364237839576253, -6.532187068212997],
            [11.35597779887016, -6.535246479921981],
            [11.351100369031975, -6.5356241825891175],
            [11.350706598011405, -6.535866655494473],
            [11.233931101125354, -6.54800840762757],
            [11.187995774589703, -6.553767966423534],
            [11.182444362868033, -6.554181823547937],
            [11.169549287828556, -6.549979830955793],
            [11.168103127663564, -6.548150428170075],
            [11.160040132819379, -6.548892519246959],
            [11.15511922887613, -6.551842098677084],
            [11.149887969972673, -6.547569449697474],
            [11.144857770441678, -6.533100296154875],
            [11.143126633121604, -6.524724874558715],
            [11.140211759316584, -6.52120784969567],
            [11.13539013420351, -6.51833996471087],
            [11.131582631865493, -6.505828203436592],
            [11.127748913351336, -6.504020473418104],
            [11.123714407370942, -6.4967059379891765],
            [11.117698348295198, -6.492871992896891],
            [11.11632705222998, -6.490729672674985],
            [11.108769189820372, -6.486303055740433],
            [11.066118882240591, -6.489437527917248],
            [11.064434198498512, -6.476139637891313],
            [11.038996867832203, -6.478756242086147],
            [11.036062928892875, -6.455115756053485]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.2763660259072, "lat": 31.60220595281954 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13155"],
        "coty_name": ["Irwin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Irwin County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00352302"
      },
      "bbox": [
        11.031041360582549, -6.554181823547937, 11.448890619753344,
        -6.263522038243854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.672615150541697, -6.151195440352316],
            [9.673418293177887, -6.143906545486348],
            [9.671481696290435, -6.139875634472673],
            [9.672931583384356, -6.1335078576253865],
            [9.677654143987937, -6.1291995253261495],
            [9.678674428535654, -6.126547264929644],
            [9.674310432249152, -6.1185043897173745],
            [9.66934773760609, -6.106680256986392],
            [9.667594729088023, -6.100859214441369],
            [9.659550387457582, -6.082856334163729],
            [9.661913984740016, -6.079031308063273],
            [9.67203048411749, -6.07008047983016],
            [9.68028479879097, -6.056462728355709],
            [9.685352010684161, -6.046062379998419],
            [9.698622224787593, -6.028633258345944],
            [9.708820516987373, -6.024486912916122],
            [9.726609526672524, -6.015685009977775],
            [9.733800628802284, -6.011228343457251],
            [9.735818337951304, -6.00747394292573],
            [9.734144769643628, -6.004045074003796],
            [9.73079466823455, -6.002218554634782],
            [9.72444929231249, -6.003759281730327],
            [9.719289116978876, -6.000230914847524],
            [9.71998521480729, -5.9953205379201036],
            [9.72484078285578, -5.989020212328247],
            [9.728641999274423, -5.9874723970885375],
            [9.733809416077928, -5.988181375728267],
            [9.743768589065924, -5.986562196661981],
            [9.75229664520061, -5.986134766630025],
            [9.759860036045403, -5.984147886688922],
            [9.76521272729952, -5.977787650353943],
            [9.764412446340078, -5.971739021033381],
            [9.855602154737294, -5.961069763972124],
            [9.856675269708548, -5.970809180144878],
            [9.866298175157265, -5.969777624925912],
            [9.86512932515998, -5.959948779090491],
            [9.910693048351005, -5.953939421290868],
            [9.98489051996106, -5.943744051653487],
            [9.992900388892775, -5.942686762992687],
            [9.993833677955863, -5.9504295330398485],
            [10.001342140542866, -5.949432340662575],
            [10.006255850331117, -5.9901262648526234],
            [10.01397127024132, -5.989405739584631],
            [10.014728435030152, -5.997067620450408],
            [10.007178656180256, -5.997768338541853],
            [10.008125689085995, -6.0063133923633485],
            [10.006286043734708, -6.0065330848994885],
            [10.007387878675932, -6.014254023348449],
            [9.999694009407289, -6.015172370792144],
            [10.00085497555279, -6.0233893896180355],
            [10.008466007387637, -6.022480931355407],
            [10.014075979771295, -6.0754255343697166],
            [10.019886784583267, -6.129009619966098],
            [10.021189700693638, -6.136556340415869],
            [10.021443503370254, -6.144724173937642],
            [10.013365963928905, -6.146090390853374],
            [10.015104167699754, -6.160385751991641],
            [10.014849715445028, -6.164025291385854],
            [10.017760223600133, -6.189941386583946],
            [10.026454717552406, -6.18894345359187],
            [10.02717329467836, -6.196218257040779],
            [10.018619305062932, -6.197175261236165],
            [10.01962793689294, -6.20451385500254],
            [10.02792955546618, -6.20345316339999],
            [10.028724933119769, -6.2116318964057315],
            [10.020624879426029, -6.212558863108023],
            [10.024880423780548, -6.253522181581404],
            [10.008068848009104, -6.255300267020054],
            [10.00713089793972, -6.247215235364721],
            [9.998775964746555, -6.247904289111746],
            [9.999968047278534, -6.256482120601507],
            [9.951085867308121, -6.26107915012878],
            [9.903075678404731, -6.26539264452114],
            [9.902055004846895, -6.256786507810891],
            [9.894079126159333, -6.257409905786467],
            [9.894895815609292, -6.266289419765866],
            [9.81366178112391, -6.274239903151921],
            [9.805031746088662, -6.275046133958635],
            [9.804097407889106, -6.266684475365343],
            [9.788135307992308, -6.2678697967647485],
            [9.787509294408835, -6.259815959373302],
            [9.771109859189965, -6.261294254301893],
            [9.770464504039438, -6.253300832173267],
            [9.754398943781894, -6.255239900806884],
            [9.753648775241295, -6.24618657550342],
            [9.761640638142408, -6.2454956568506885],
            [9.760940894684587, -6.237670004789424],
            [9.769273739904822, -6.236863262595303],
            [9.768620329881434, -6.2288821436328705],
            [9.728627822268729, -6.232331023606675],
            [9.727795135949178, -6.22448319771184],
            [9.71883461221743, -6.22561871238431],
            [9.719666409523978, -6.233466613181462],
            [9.694446099853788, -6.236574167377717],
            [9.693478210018377, -6.2275363753120905],
            [9.677496920608913, -6.22902972141729],
            [9.676726440733038, -6.2223239579725815],
            [9.670715148575757, -6.223014578088844],
            [9.673203099833168, -6.210377621755831],
            [9.679457774108236, -6.203047915205534],
            [9.679487669900878, -6.193040501033359],
            [9.682906537015242, -6.190603737352599],
            [9.676435869835014, -6.185674032832131],
            [9.676833549112889, -6.1772227918888865],
            [9.67579323577303, -6.173434250530678],
            [9.672161531331314, -6.167741052586105],
            [9.673139179371182, -6.160086576813471],
            [9.672615150541697, -6.151195440352316]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.8351862168872, "lat": 32.078497114600154 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13259"],
        "coty_name": ["Stewart"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stewart County"],
        "coty_fp_code": "259",
        "coty_gnis_code": "00347360"
      },
      "bbox": [
        9.659550387457582, -6.275046133958635, 10.028724933119769,
        -5.942686762992687
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.237131009365497, -3.126529007381914],
            [10.322025502779361, -3.1158622976892403],
            [10.38739499698396, -3.107022536015105],
            [10.49218307561353, -3.094504465177479],
            [10.491301635364279, -3.089034529460623],
            [10.548272045231066, -3.0811535961859713],
            [10.556344932577598, -3.126816091767897],
            [10.528336756760874, -3.1342390121493775],
            [10.520985286685775, -3.1366545523835434],
            [10.519691217093914, -3.138765073680091],
            [10.513237377922783, -3.141059063646942],
            [10.513811182629933, -3.147198412734509],
            [10.516077659622159, -3.1486605175220994],
            [10.517186167727358, -3.1570706662653416],
            [10.522277895076302, -3.156623771130393],
            [10.52229253956055, -3.1602901764470173],
            [10.518763433630088, -3.1659961134485037],
            [10.505910995228469, -3.1661952522610117],
            [10.503682974359972, -3.172133177128378],
            [10.4968794572133, -3.1715838692282223],
            [10.495711956681259, -3.1751892529413235],
            [10.497098984748956, -3.182014982284116],
            [10.495695213357719, -3.1875805887040727],
            [10.484298311471838, -3.1922068876984477],
            [10.485284888410849, -3.19467972284738],
            [10.48176329956267, -3.2030841652646598],
            [10.476736374297074, -3.2061911057990966],
            [10.478562266999463, -3.2080447575145707],
            [10.477842214059686, -3.2121485400730814],
            [10.479852951049269, -3.2190012652274445],
            [10.478394960807911, -3.2283745660752095],
            [10.477012440094995, -3.2299326716269445],
            [10.47667760616369, -3.2371123017013943],
            [10.479383522100552, -3.244642760443079],
            [10.481097653580303, -3.254692464674476],
            [10.483850668874618, -3.259176615662501],
            [10.487613462699123, -3.2612363655668255],
            [10.48522896031221, -3.265287785975521],
            [10.48350732838406, -3.2719046065237216],
            [10.480194719655941, -3.274395393504522],
            [10.478254338449794, -3.2786474115253603],
            [10.469641731557243, -3.2830452568946655],
            [10.466760779617006, -3.2864019685957713],
            [10.464165582023172, -3.2861172846619477],
            [10.458823974243067, -3.2896190747807883],
            [10.455734465548753, -3.2954185432000744],
            [10.443032442626173, -3.299469171102606],
            [10.440112848067313, -3.2968766542212555],
            [10.43277966589125, -3.2936352172374908],
            [10.417309329200188, -3.2922856250117176],
            [10.388047425625917, -3.3047007676459508],
            [10.384372717190852, -3.279201733790664],
            [10.380997027770118, -3.2786425287364267],
            [10.375992603816208, -3.27425612480682],
            [10.372208420569917, -3.2743309080193392],
            [10.370574280490608, -3.2710566696882073],
            [10.370524052880556, -3.26052102776324],
            [10.372608861345332, -3.2551439945358305],
            [10.364229618797067, -3.2495708134726913],
            [10.3635006697837, -3.2470801557217457],
            [10.355955710135632, -3.2402870654549547],
            [10.356053295917702, -3.237009732946544],
            [10.352708588820871, -3.2295017436866225],
            [10.352894254577205, -3.2132986777430523],
            [10.355094020891645, -3.2091869759919347],
            [10.354714129462906, -3.2037719473783803],
            [10.350981347749732, -3.196618125243122],
            [10.347334385117431, -3.192270371691158],
            [10.340757328588873, -3.1880913822488717],
            [10.335362067123533, -3.191702120705197],
            [10.328254011712929, -3.1942726116580955],
            [10.330800791749253, -3.1970346335144275],
            [10.331806532057849, -3.2036402486992706],
            [10.312948428402446, -3.2068137344997516],
            [10.312323529139377, -3.2021418903645764],
            [10.304463173955634, -3.1967409751865272],
            [10.303380655196476, -3.191962217202359],
            [10.262200780665623, -3.1847592624364665],
            [10.259266538910282, -3.18294005950715],
            [10.260231603327616, -3.1751465158506],
            [10.256053705244891, -3.167737145647359],
            [10.252202600290627, -3.164906856711045],
            [10.248907079172218, -3.1573347996895604],
            [10.242813186433292, -3.154173855960679],
            [10.240288836041012, -3.148441099242225],
            [10.231581409226566, -3.1444266297184185],
            [10.232416305001687, -3.1406190180857285],
            [10.235355045811632, -3.13711190059193],
            [10.237630993508994, -3.1317723763010097],
            [10.237131009365497, -3.126529007381914]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.73730617228449,
          "lat": 34.916722797935826
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13281"],
        "coty_name": ["Towns"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Towns County"],
        "coty_fp_code": "281",
        "coty_gnis_code": "00351252"
      },
      "bbox": [
        10.231581409226566, -3.3047007676459508, 10.556344932577598,
        -3.0811535961859713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.079515815304203, 7.989795025837481],
            [-14.077698944706425, 7.9994109578075605],
            [-14.07482889813192, 8.006560285135553],
            [-14.067450607638822, 8.014833758329232],
            [-14.05171469668655, 8.019940078742101],
            [-14.04878263465966, 8.027211343393471],
            [-14.043819862191508, 8.029278690063734],
            [-14.041313427010035, 8.037012698266023],
            [-14.029967348886561, 8.041522529457875],
            [-14.027312418449467, 8.045454308170187],
            [-14.023893419686457, 8.056522053592266],
            [-14.020154069672115, 8.062706594649182],
            [-14.018308682077798, 8.071007597465258],
            [-14.001402549662513, 8.09928398921138],
            [-13.99978291968763, 8.103334215010376],
            [-13.998471484458815, 8.11307971600277],
            [-13.992348466675924, 8.12262454883112],
            [-13.988862349766443, 8.134876451764825],
            [-13.984729605633477, 8.138792344056093],
            [-13.980521085949317, 8.14781404127992],
            [-13.972064853481882, 8.158430093641854],
            [-13.882227309244518, 8.138993066655893],
            [-13.792394606213717, 8.119533081640693],
            [-13.735471941200164, 8.107307790678812],
            [-13.735545466801522, 8.101186233311585],
            [-13.732772578015378, 8.093672512016541],
            [-13.731615535531356, 8.083075471469055],
            [-13.733127857587244, 8.078043462178655],
            [-13.730594059867427, 8.07348357810627],
            [-13.731084470179814, 8.069097444336553],
            [-13.728875421738934, 8.065191406918206],
            [-13.729902755703879, 8.06232282098437],
            [-13.728311423076446, 8.057591370038821],
            [-13.726742133294815, 8.048163848732386],
            [-13.72770889934506, 8.043447617282663],
            [-13.726579209482207, 8.039924513490835],
            [-13.727954574725239, 8.035880988035485],
            [-13.727301906306035, 8.031481714800748],
            [-13.724961373364824, 8.02863537398152],
            [-13.724428336357034, 8.02042138014947],
            [-13.728937446527015, 8.00833191498551],
            [-13.728890450737321, 7.99031449019974],
            [-13.73028175670941, 7.988372813464262],
            [-13.728079977929553, 7.98395748746065],
            [-13.722919483472342, 7.981640537935288],
            [-13.724356812166633, 7.978298693060613],
            [-13.722069150707876, 7.9719419934584845],
            [-13.725853801970441, 7.964144665998177],
            [-13.740409653815536, 7.957564800469229],
            [-13.741757172731736, 7.954054202048719],
            [-13.740694139385, 7.949603605368748],
            [-13.743021993248766, 7.947605071087341],
            [-13.636133225061888, 7.923907938598754],
            [-13.632751559134256, 7.922849398525152],
            [-13.631057324943686, 7.91440010511845],
            [-13.635178717199375, 7.904179464075703],
            [-13.63350794666578, 7.901914559802842],
            [-13.63602231837839, 7.897612178258006],
            [-13.635982704277586, 7.893791939969447],
            [-13.631914403751713, 7.893236527961902],
            [-13.62893017397641, 7.889229295791544],
            [-13.617906250156043, 7.886018244902747],
            [-13.608319599428212, 7.878573852581612],
            [-13.603903399787319, 7.872048279465366],
            [-13.609783589059168, 7.865940434964461],
            [-13.61471238288674, 7.862718102880643],
            [-13.618667913436079, 7.8474788666936295],
            [-13.621557545672673, 7.842490605796135],
            [-13.624598044535436, 7.841466613638629],
            [-13.62746770343619, 7.843751223605684],
            [-13.62924117529237, 7.839495368867396],
            [-13.62845516510718, 7.83655433476036],
            [-13.632462598793385, 7.8349693514135845],
            [-13.64011671795502, 7.836453114907681],
            [-13.640984071497034, 7.830540111450612],
            [-13.64672361638095, 7.8248825585482],
            [-13.648764894786893, 7.817858593893513],
            [-13.645129326497273, 7.809991265025202],
            [-13.646652220756113, 7.8033231088253965],
            [-13.6417402442344, 7.799929915901289],
            [-13.641669358069967, 7.79530376293226],
            [-13.638779658165156, 7.79054427188651],
            [-13.642236202531327, 7.783867978718783],
            [-13.643407665197675, 7.777299707016906],
            [-13.650264603010116, 7.771533832338151],
            [-13.649781439292637, 7.769499572260287],
            [-13.658192981350298, 7.760116794343953],
            [-13.660993923631695, 7.759336286195008],
            [-13.66678811781584, 7.760630167462436],
            [-13.66930623626876, 7.763809129783613],
            [-13.675331809292157, 7.763960518136286],
            [-13.674772104281617, 7.759259255259892],
            [-13.678587099967684, 7.757641057603877],
            [-13.678018402104517, 7.750391842882595],
            [-13.682411058901701, 7.742783781532729],
            [-13.685835773679058, 7.730513238780265],
            [-13.688220188711332, 7.72581299417153],
            [-13.695630818992303, 7.7270386362208265],
            [-13.700498914260955, 7.713370664577622],
            [-13.702599341067488, 7.715440775927446],
            [-13.708150083938316, 7.715776846060285],
            [-13.710602987098646, 7.708219689815146],
            [-13.713910781124941, 7.704889407419829],
            [-13.713043408337933, 7.700078752629305],
            [-13.715823076511539, 7.694444082965947],
            [-13.72043360303717, 7.694519866035306],
            [-13.721707530362659, 7.683391103383082],
            [-13.725500494207942, 7.675344408375033],
            [-13.725332844876075, 7.672938174194255],
            [-13.728150186994093, 7.666074870684354],
            [-13.729824595791879, 7.655696433972385],
            [-13.736065113495597, 7.6390557851711804],
            [-13.738193360073044, 7.636149810896178],
            [-13.738633163803044, 7.629072277309691],
            [-13.742849293242964, 7.620985999985575],
            [-13.747876456213262, 7.615737779269583],
            [-13.747402619629632, 7.601515798134074],
            [-13.744601960895787, 7.601160446664547],
            [-13.743149568502798, 7.59492462678839],
            [-13.74038253854227, 7.591718750117141],
            [-13.740459691388976, 7.5864266674737255],
            [-13.736677935232239, 7.580486317273242],
            [-13.731402562208238, 7.576012212904339],
            [-13.735147865809557, 7.5677026559641725],
            [-13.734818112478345, 7.562281546277339],
            [-13.74023232528717, 7.558507429478314],
            [-13.732796892899163, 7.54178031777837],
            [-13.728053022881934, 7.538751254661707],
            [-13.727050413671092, 7.532124180320953],
            [-13.730045631523355, 7.528078959053757],
            [-13.730329080474661, 7.523978071361413],
            [-13.734215377565379, 7.5195975933126675],
            [-13.735248005276611, 7.510912468048718],
            [-13.738107573775194, 7.505898850253541],
            [-13.739792497510923, 7.500368996264375],
            [-13.743494118251013, 7.494359064706491],
            [-13.745295710013528, 7.489329515610035],
            [-13.751879516405, 7.485537163357707],
            [-13.753059060488475, 7.47972394916047],
            [-13.7500026747504, 7.475399289087796],
            [-13.752287859496933, 7.470488880993929],
            [-13.752451853170616, 7.457715422698165],
            [-13.755839508220927, 7.4483545540756015],
            [-13.760732345472777, 7.443991609862289],
            [-13.761611025480883, 7.436940683572326],
            [-13.764822101247786, 7.431800270401957],
            [-13.766979664997383, 7.425365951540235],
            [-13.770387541581433, 7.422141328537827],
            [-13.768403553686111, 7.416405466140293],
            [-13.766315438745, 7.414223462845643],
            [-13.766684798087162, 7.40429182452765],
            [-13.770127479035267, 7.397018818045687],
            [-13.768894007493142, 7.394122481921118],
            [-13.769488312209791, 7.383456008666974],
            [-13.766988740395377, 7.374737581328861],
            [-13.767803568772432, 7.365741572965887],
            [-13.767793857986058, 7.356470435708268],
            [-13.769242630767472, 7.350096866343286],
            [-13.77181598227857, 7.348874831337684],
            [-13.768904210650641, 7.341353988743151],
            [-13.769825929783982, 7.3338268848727575],
            [-13.772230850717147, 7.333469851946498],
            [-13.78304751578981, 7.33840948586158],
            [-13.785945262856819, 7.337674131372826],
            [-13.790444068452963, 7.333910298256265],
            [-13.796153919020838, 7.334102278494725],
            [-13.797711572077487, 7.3391045994536395],
            [-13.80603895171868, 7.347359705049195],
            [-13.807157935929988, 7.352923362709597],
            [-13.810048899783647, 7.352223280764698],
            [-13.814216466513551, 7.3417597205121305],
            [-13.81642566309392, 7.338939141884944],
            [-13.820082370622922, 7.3382293901788165],
            [-13.827015166232462, 7.328093566365118],
            [-13.82660080674503, 7.323520169653232],
            [-13.831220589199084, 7.3173044585032585],
            [-13.832094609884276, 7.312345719142027],
            [-13.83644705099704, 7.310500493718199],
            [-13.838158767154923, 7.3132149575346395],
            [-13.846296415083183, 7.316971750666295],
            [-13.855105761586653, 7.315227806385809],
            [-13.857235648419481, 7.313375530616279],
            [-13.86399681041859, 7.312773832825585],
            [-13.873152421400293, 7.308951016173696],
            [-13.87885130791278, 7.305583170829023],
            [-13.880717691181506, 7.302298751635508],
            [-13.955731500685825, 7.3183381696269025],
            [-14.029948182208598, 7.382391192246936],
            [-14.00357910186373, 7.502440331110725],
            [-14.054933488477952, 7.513671375975954],
            [-14.049306254599866, 7.522777054021216],
            [-14.047524013223363, 7.534101231404879],
            [-14.051436440575223, 7.549701845677991],
            [-14.056839233652715, 7.557270790150257],
            [-14.059367433707646, 7.563135607706514],
            [-14.0584610597415, 7.566351526240085],
            [-14.021795682027403, 7.733990135945994],
            [-14.115480930275785, 7.755415814687594],
            [-14.209171718793494, 7.776817394963681],
            [-14.2112003039238, 7.77733525506823],
            [-14.207170056075958, 7.784296391229245],
            [-14.208001614180157, 7.78819745064093],
            [-14.20524198028875, 7.791417171472129],
            [-14.20127806761393, 7.7899488472429335],
            [-14.19626167303459, 7.791988004221216],
            [-14.18917796392495, 7.798978697736247],
            [-14.1809602363455, 7.801142330320117],
            [-14.168343196956291, 7.81561604532521],
            [-14.160096957066814, 7.831760373087381],
            [-14.150857618517149, 7.848375558977022],
            [-14.144824013146991, 7.854943660861795],
            [-14.145240119204033, 7.864447324219773],
            [-14.15028999742766, 7.876628294797286],
            [-14.151802723418701, 7.883662035578443],
            [-14.148387664534484, 7.889671328103848],
            [-14.139525337993808, 7.892258541847873],
            [-14.133323552982903, 7.8969202755550025],
            [-14.129621571342904, 7.903541995981792],
            [-14.134870723134696, 7.9080158205755815],
            [-14.140823956935721, 7.904250961985242],
            [-14.143726357340698, 7.898917431840344],
            [-14.146973642619004, 7.896613176393521],
            [-14.152378322392599, 7.9011270116453804],
            [-14.152526250881328, 7.9048059697244915],
            [-14.15024440657748, 7.9099286625216765],
            [-14.138149190921698, 7.924671264275177],
            [-14.135243985582454, 7.938129750242007],
            [-14.135824966053006, 7.94566474150366],
            [-14.130742346845295, 7.951495985672938],
            [-14.117600701378517, 7.95656009512511],
            [-14.107294121269813, 7.965280025233822],
            [-14.102598632888657, 7.966831388924946],
            [-14.092761991162424, 7.974430807071359],
            [-14.079754149208695, 7.9885335720895005],
            [-14.079515815304203, 7.989795025837481]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.45378575282194,
          "lat": 44.88954512780205
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16003"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00395067"
      },
      "bbox": [
        -14.2112003039238, 7.302298751635508, -13.603903399787319,
        8.158430093641854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.637334422036181, 0.7395779543943728],
            [6.687461727892383, 0.7451961777379484],
            [6.752668834000675, 0.7529636722588335],
            [6.793183697299966, 0.757371966538981],
            [6.793076353769735, 0.7504426816189196],
            [6.862077107552825, 0.756266946914915],
            [6.8632687349613395, 0.741860851082254],
            [6.884453541641475, 0.7433954171375265],
            [6.88525137602458, 0.7398026724946097],
            [6.880983425299566, 0.7389212519623973],
            [6.878341555449512, 0.7420872269771808],
            [6.874692452854487, 0.7420937926669834],
            [6.867965711443627, 0.7349189486068957],
            [6.867416972462372, 0.7281729340211056],
            [6.863882112624907, 0.7197585043312339],
            [6.866894103631386, 0.7162597002828991],
            [6.876480128579159, 0.7133330763087128],
            [6.878719352033761, 0.7076646718788373],
            [6.8831935018555575, 0.7075768978217608],
            [6.88293103304849, 0.7035313459477113],
            [6.878915032226423, 0.6993392155404549],
            [6.871524951424064, 0.7006105542597453],
            [6.868936078291292, 0.6947904578922739],
            [6.8710170503018375, 0.6908367795785121],
            [6.877498527063138, 0.6889683508118849],
            [6.881981045918678, 0.690845220100074],
            [6.886608691285332, 0.6902542313371812],
            [6.897589604132235, 0.6905918167805042],
            [6.900417255160975, 0.6891909024067303],
            [6.9005824578484125, 0.6822286883524645],
            [6.8971913470727255, 0.67762256589637],
            [6.897043328521221, 0.6741372851433998],
            [6.901374894262098, 0.668915641340538],
            [6.905527941147358, 0.6679330598995048],
            [6.912861117807282, 0.6687556688328745],
            [6.917321861891005, 0.6666912028125005],
            [6.920936174660779, 0.6611363365026196],
            [6.927507216088141, 0.6564146388775642],
            [6.931775920145023, 0.6504601407036017],
            [6.936853968368082, 0.6464396415031733],
            [6.937525654953502, 0.6391713874971574],
            [6.932387906233379, 0.6304888906277714],
            [6.932582364690883, 0.627908433589368],
            [6.9370612413585295, 0.62291931012047],
            [6.941989334392283, 0.6122517935862495],
            [6.9424567310313545, 0.6085512573217927],
            [6.940300069601572, 0.5974849029770066],
            [6.9369291727111735, 0.590829262123261],
            [6.94011767941574, 0.5850969925948963],
            [6.9467724051916075, 0.5827148241231245],
            [6.951977659737899, 0.5820438378092861],
            [6.9486480796089, 0.5780681603348111],
            [6.942117854908073, 0.5801571992104161],
            [6.938364239866063, 0.5781208310980835],
            [6.940140207661391, 0.5751993615096316],
            [6.953081341346177, 0.5709327291951599],
            [6.962728394834564, 0.5688912744485946],
            [6.967282479871848, 0.5663407253044996],
            [6.9775363556883345, 0.5635443541075735],
            [6.981738703318888, 0.5557297641201563],
            [6.985435345425611, 0.5520037340414214],
            [6.991356483233279, 0.5486381377920484],
            [6.992206169815782, 0.5427670768515815],
            [6.986265049642183, 0.5320339906741375],
            [6.990909274780283, 0.5252788481553596],
            [6.989714481256192, 0.519950550518672],
            [6.990103496225078, 0.5152829584561219],
            [6.984719465697311, 0.5129261845894181],
            [6.983718910761028, 0.5098910526734795],
            [6.985435305908793, 0.5051353004813067],
            [6.984408154565788, 0.5005782969373509],
            [6.9891483613201455, 0.4941026876207253],
            [6.980690277314808, 0.49188948617452133],
            [6.978951037330741, 0.4862695202973736],
            [6.973236685104619, 0.48528010571573005],
            [6.973631643023565, 0.47909147820756826],
            [6.978531083996153, 0.47633156839083757],
            [6.981733846925654, 0.46959785458660175],
            [6.98040867759464, 0.46799348956836706],
            [6.974028540099468, 0.46673689816774283],
            [6.972557135516916, 0.46233410594632657],
            [6.976928246579948, 0.4567686758955312],
            [6.974861088000097, 0.4529239226786237],
            [6.969853048765373, 0.453978692167133],
            [6.97025805022088, 0.44976449443037303],
            [6.982215236258361, 0.44401306229284365],
            [6.98629582588818, 0.4432740261365947],
            [6.9527050196302005, 0.4401661717334704],
            [6.9527614015601555, 0.4394707531290661],
            [6.869380651369496, 0.43258239689859906],
            [6.869236353112972, 0.43215317325014463],
            [6.816168733015843, 0.4253054659770833],
            [6.790733108343713, 0.42237297164584436],
            [6.790969912027054, 0.42359847886206337],
            [6.697560348390725, 0.4156283039845053],
            [6.668501807175463, 0.4131957344733936],
            [6.664168870733409, 0.4722796710019138],
            [6.659395316140262, 0.5243463288596873],
            [6.653205673113185, 0.5887976702773863],
            [6.647878025934198, 0.6482470238827723],
            [6.64681302667516, 0.6481312516905097],
            [6.640422469097343, 0.7087639592280801],
            [6.637334422036181, 0.7395779543943728]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.75964083273008, "lat": 39.00273917949932 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17033"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00424218"
      },
      "bbox": [
        6.637334422036181, 0.4131957344733936, 6.992206169815782,
        0.757371966538981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.028970236782959, -1.205099314728352],
            [6.030688437242965, -1.2045814994038755],
            [6.043647538376367, -1.1931819364180547],
            [6.052372678323685, -1.1885274700444233],
            [6.0507535445711245, -1.184697337945996],
            [6.053400451754715, -1.179579031405985],
            [6.052322483950869, -1.1757934392324223],
            [6.045099804502229, -1.1705936117360631],
            [6.09742234972314, -1.1666952732030964],
            [6.112000987422368, -1.1658617803085696],
            [6.183617816871391, -1.1605383171460908],
            [6.197576161380279, -1.1576811258744284],
            [6.228366019526238, -1.1842605181949404],
            [6.266322620097002, -1.2195604157488804],
            [6.289751081693766, -1.2409625406148064],
            [6.323963848993859, -1.2712464074169183],
            [6.351961719292022, -1.2956669009288637],
            [6.384752929117004, -1.3229370629249124],
            [6.391978128375223, -1.4120721460547105],
            [6.391909678970133, -1.4147338917755383],
            [6.381233412741269, -1.4182792971885891],
            [6.367729083237786, -1.4193409407747035],
            [6.359613053676138, -1.4183520932264706],
            [6.348085760090303, -1.4158413483510588],
            [6.332787895975206, -1.4103338229634808],
            [6.331441675318288, -1.4118705974982173],
            [6.325772295384051, -1.4080391734664044],
            [6.324660130894005, -1.4039172506521678],
            [6.316523058208417, -1.396613653651778],
            [6.311513987586914, -1.389917533344408],
            [6.3016725457238065, -1.3825035954353462],
            [6.293120911683532, -1.3774352387500428],
            [6.281218557026999, -1.3715643762859586],
            [6.277384699994705, -1.370297965146552],
            [6.271556732902492, -1.3704405812057212],
            [6.2660083884481415, -1.369316744691342],
            [6.230953468233795, -1.3552862812990096],
            [6.219061476615051, -1.3528931715579304],
            [6.205306994709339, -1.3559796529440682],
            [6.195699011799084, -1.353360049173941],
            [6.184124865626809, -1.3465433546235646],
            [6.1783717912592895, -1.3438070600848082],
            [6.168088637553227, -1.3365320859189904],
            [6.159283312699399, -1.3310091509950663],
            [6.14987921536319, -1.3217991274111716],
            [6.1411966962657925, -1.316111028992408],
            [6.134344108880593, -1.3128435804532927],
            [6.122099411009518, -1.3101183454795118],
            [6.110668922663624, -1.3066463611945678],
            [6.082545117153624, -1.2953765543932951],
            [6.044779566675667, -1.2837491699427224],
            [6.035367486726785, -1.2822518252853332],
            [6.033336057670425, -1.260084558291579],
            [6.028970236782959, -1.205099314728352]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.70753588871696, "lat": 37.21887543830799 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17127"],
        "coty_name": ["Massac"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Massac County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01784730"
      },
      "bbox": [
        6.028970236782959, -1.4193409407747035, 6.391978128375223,
        -1.1576811258744284
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.775381127009528, -1.1907216020079128],
            [5.79646929886485, -1.1892720490813775],
            [5.848164022594723, -1.1866772691866705],
            [5.8926220179747215, -1.184048864534612],
            [5.935823286524666, -1.1847839838414091],
            [5.9371341981702, -1.1991723491822057],
            [5.93853843730232, -1.220627345055361],
            [5.945921946283826, -1.2173962490477204],
            [5.949096378243249, -1.2147793194541154],
            [5.95809514142315, -1.204015416093776],
            [5.9695970561299285, -1.2010030101618832],
            [5.97301471438629, -1.2025143580173372],
            [5.978903014162003, -1.2017254145277507],
            [5.988988395141016, -1.2055676528280503],
            [5.997718697446819, -1.2071300922762256],
            [6.002396782217322, -1.2124887035631138],
            [6.008162897353645, -1.2120750501369535],
            [6.018460519735117, -1.2046993611090155],
            [6.028970236782959, -1.205099314728352],
            [6.033336057670425, -1.260084558291579],
            [6.035367486726785, -1.2822518252853332],
            [6.030392520846735, -1.2837122607454021],
            [6.015641534240955, -1.285088601459926],
            [6.005407552277389, -1.2842970859222296],
            [5.998323541515711, -1.2814155853107292],
            [5.991677005101856, -1.2829428889718284],
            [5.978069788452338, -1.288284233440276],
            [5.968434702780536, -1.2974068583721996],
            [5.956233185115891, -1.303310481995472],
            [5.950798193603427, -1.3110094535156507],
            [5.947969019978464, -1.3122807839667712],
            [5.935813650135587, -1.3274569716204976],
            [5.9225071317225675, -1.3422369408753547],
            [5.915095759010052, -1.3524158636824222],
            [5.910723669234213, -1.3620083385072161],
            [5.908533664634252, -1.372530750463831],
            [5.9041134182100885, -1.3870995161845037],
            [5.8992605107823355, -1.397647782987283],
            [5.888899122007435, -1.4117949585191547],
            [5.875605775044434, -1.4226687167226706],
            [5.871983529203966, -1.423044698513993],
            [5.868706314691823, -1.4322589906499466],
            [5.866338971765681, -1.4347634865644654],
            [5.857522457319219, -1.4490720487455817],
            [5.854969942698095, -1.4553621773189436],
            [5.8535185297476255, -1.453518464576845],
            [5.848790668563763, -1.4548895878349046],
            [5.844130277435649, -1.445138825671306],
            [5.837364061229072, -1.44012218981568],
            [5.83373235993953, -1.4390518094807458],
            [5.83177799010015, -1.4360536821700276],
            [5.827297546091824, -1.4391959980432474],
            [5.8204944723461995, -1.4361296553290293],
            [5.808877753504911, -1.4348524418155069],
            [5.806242669234514, -1.43689331496508],
            [5.798152645797744, -1.430507485880026],
            [5.795790648976087, -1.4267988127753783],
            [5.788027527036417, -1.4285663545858858],
            [5.781825846023841, -1.4207928627624944],
            [5.777994733232298, -1.4177769380526057],
            [5.777803515501045, -1.4111024811219164],
            [5.770569585114224, -1.4019006446001632],
            [5.774111470944218, -1.395267085667428],
            [5.775445030023128, -1.3879389200080403],
            [5.781017506010172, -1.384193701221018],
            [5.78157092691857, -1.381268213683726],
            [5.779508641569324, -1.376413451778244],
            [5.779414016816217, -1.368711848027894],
            [5.772784108431245, -1.369448555865144],
            [5.773437449339263, -1.3647076003094203],
            [5.776396656208004, -1.36430735111442],
            [5.776788534136261, -1.358006175267107],
            [5.77309393860695, -1.3573940170467607],
            [5.775077860956444, -1.3524776207645213],
            [5.771720656933306, -1.3476204186551113],
            [5.773478113105147, -1.3435954689270229],
            [5.776664126085516, -1.3446849164788188],
            [5.783091781098557, -1.3363213564906653],
            [5.779639119213997, -1.330421790883385],
            [5.775890920791847, -1.327545729566682],
            [5.774111439681158, -1.3236138823667623],
            [5.775618445331326, -1.3214292011779163],
            [5.773175782818752, -1.3142259961361098],
            [5.773640076201414, -1.307483292282318],
            [5.770288963480652, -1.3039685531934289],
            [5.770995071693501, -1.3011758407144647],
            [5.775796066808523, -1.2985396456238554],
            [5.780556894567023, -1.2834446188718098],
            [5.781530594084214, -1.27530421565932],
            [5.780850947757373, -1.2668542841362014],
            [5.78256739465991, -1.2624278379570295],
            [5.788216370287955, -1.2551576608569195],
            [5.796212150784838, -1.2518488372478689],
            [5.8010978173662275, -1.245755391248677],
            [5.809232327636619, -1.2439411551879367],
            [5.814699948963746, -1.2343931997356319],
            [5.812948489023633, -1.2169269461918462],
            [5.809368590726816, -1.2023697376836855],
            [5.804528917896124, -1.2009954014947932],
            [5.796495101855545, -1.195124346132485],
            [5.79597915979345, -1.1925438365118668],
            [5.784092936212134, -1.1940212581696932],
            [5.77863685692533, -1.19387340207833],
            [5.775381127009528, -1.1907216020079128]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.12639975126909, "lat": 37.22321869766432 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17153"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "01784966"
      },
      "bbox": [
        5.770288963480652, -1.4553621773189436, 6.035367486726785,
        -1.184048864534612
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.428388288348009, 0.3905441968958782],
            [6.511705163390431, 0.3968096074860752],
            [6.568710831697785, 0.4036207205636974],
            [6.599393220920881, 0.4070362186547097],
            [6.632511914303962, 0.40972405981934085],
            [6.668501807175463, 0.4131957344733936],
            [6.697560348390725, 0.4156283039845053],
            [6.703568840294043, 0.3413868768452894],
            [6.70582716523552, 0.31166376902381443],
            [6.712962789298604, 0.22259033611918524],
            [6.719514598856443, 0.1386423912446655],
            [6.718382998261278, 0.1336530168481831],
            [6.685669201688206, 0.13099754899549557],
            [6.666013038784053, 0.1291043426604032],
            [6.64775269461131, 0.12798978429954808],
            [6.620979514439569, 0.1257673015747214],
            [6.606789726111412, 0.12399968398663362],
            [6.536755388487194, 0.11730550801788543],
            [6.53404143232219, 0.14641335872235128],
            [6.462417826887099, 0.14206715961031918],
            [6.452316730914395, 0.14122721401472393],
            [6.4558907138382295, 0.1435515492882939],
            [6.452905396598717, 0.14749078142122007],
            [6.441112630350283, 0.15369502142117134],
            [6.438090642480697, 0.15267871080606676],
            [6.436312834555245, 0.16036610161247505],
            [6.433496424121426, 0.15627576346341823],
            [6.428910436706356, 0.15702999194037465],
            [6.426045219646489, 0.15918371116429547],
            [6.427743665844407, 0.16537710695133373],
            [6.422109145162247, 0.16503938969882762],
            [6.422593086491563, 0.16980880505877585],
            [6.415837048426706, 0.17394729204468684],
            [6.416710630662962, 0.17780207306463078],
            [6.419929029512255, 0.18154654324105007],
            [6.427996396669548, 0.19367285376578788],
            [6.430313856974457, 0.1943154091120662],
            [6.432748595890983, 0.19881327146457994],
            [6.4308104584303045, 0.20303190361483425],
            [6.4329320762478845, 0.20454101130977692],
            [6.429292006679215, 0.21013960248208147],
            [6.426948878573811, 0.21027603373538975],
            [6.426675261750411, 0.21745774324852596],
            [6.422008297243383, 0.22196194103602376],
            [6.420633484001309, 0.2352762706236352],
            [6.421507167504529, 0.23979774750997515],
            [6.419007848967021, 0.24242896966085106],
            [6.419200774866906, 0.24852201423811462],
            [6.420913255937939, 0.256919814596072],
            [6.417683412381576, 0.26071331873808296],
            [6.419930947901036, 0.2663231171966449],
            [6.417922210395157, 0.2680601702792228],
            [6.418700878769051, 0.2725232160911701],
            [6.438572108853139, 0.27324723276438856],
            [6.433100692326576, 0.3349430254079838],
            [6.428388288348009, 0.3905441968958782]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.08516412162682, "lat": 38.71242697777309 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17159"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richland County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00424281"
      },
      "bbox": [
        6.415837048426706, 0.11730550801788543, 6.719514598856443,
        0.4156283039845053
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.313781481651123, 1.6085819877160035],
            [4.310522784097033, 1.700627395108776],
            [4.398979728790095, 1.7020636610230615],
            [4.421306785448949, 1.703300154637682],
            [4.485860194152658, 1.704346696870795],
            [4.571936146515374, 1.7089495487740625],
            [4.634530733172047, 1.7113339869484443],
            [4.657892664685836, 1.711942657980293],
            [4.661770280907939, 1.6237372204723677],
            [4.748292546538832, 1.6277728259721707],
            [4.777948411214576, 1.6280800289751243],
            [4.852737259238791, 1.6301041812250205],
            [4.85103947665091, 1.6200248337761827],
            [4.85186505983228, 1.6066859090451964],
            [4.847109793614557, 1.5987754073548772],
            [4.842312043538257, 1.5957647082029491],
            [4.835034440409973, 1.5949125637357842],
            [4.827943282061466, 1.5950749127599106],
            [4.820089601446817, 1.5970510785990712],
            [4.810942813644475, 1.5982344268497546],
            [4.802740175338413, 1.5975125159435108],
            [4.7935532285370686, 1.5915161300750735],
            [4.78383210722691, 1.5878665442193554],
            [4.776142465498846, 1.5822969319830134],
            [4.7717230924980285, 1.580220222931269],
            [4.76217875961325, 1.5800976886496847],
            [4.756080892129903, 1.57838848723275],
            [4.750916532459085, 1.5752005633948236],
            [4.744583065729733, 1.5656886048124485],
            [4.739246020424592, 1.5630450205427542],
            [4.7314602919854165, 1.56342028455759],
            [4.724448999452732, 1.559070855954137],
            [4.719713517205623, 1.5480694385821079],
            [4.718199583133743, 1.5407307317936283],
            [4.711739340556735, 1.5287254229823393],
            [4.713811092114929, 1.5210285629686244],
            [4.7109000978161655, 1.513307255701246],
            [4.695213522923708, 1.5018316462437602],
            [4.689670878872916, 1.4985705272879681],
            [4.686957747813079, 1.4954151640744686],
            [4.686414030204457, 1.4911260116697944],
            [4.687792934772815, 1.481046189854228],
            [4.687473318186528, 1.4734929802307715],
            [4.6858947580092245, 1.4670168921336852],
            [4.685436438465417, 1.4590088048966574],
            [4.682840003428223, 1.4539605851007888],
            [4.6710369419479205, 1.444615916687833],
            [4.658925898547712, 1.4394228078476239],
            [4.6552946374871045, 1.4372550405985698],
            [4.649836325836953, 1.4362464731316205],
            [4.6333245096056395, 1.4283122970812416],
            [4.628555891858653, 1.4247916987152327],
            [4.626733605321672, 1.4186929388665692],
            [4.625455482883745, 1.4150428325080522],
            [4.621418601214027, 1.418810509651894],
            [4.616839130124145, 1.4178319952053933],
            [4.61159141883486, 1.4123316124958594],
            [4.607597115393385, 1.4133750909428855],
            [4.606146988444447, 1.4102641952892019],
            [4.599251126646466, 1.4126208178613722],
            [4.591363784187461, 1.4113602351275019],
            [4.586214604598346, 1.4122447689775335],
            [4.577690743788108, 1.4092374973446837],
            [4.5728412747832845, 1.40644368831078],
            [4.556304567528224, 1.4083604436792665],
            [4.5566113651359155, 1.4180168371170105],
            [4.558487175435333, 1.4235557083478205],
            [4.5589959404171525, 1.4303992164998993],
            [4.545379094683449, 1.4417347297240353],
            [4.546665748109309, 1.447074049902897],
            [4.551096174928553, 1.4443465247393572],
            [4.553950297614151, 1.4478146949465736],
            [4.554919927842968, 1.4521924216815167],
            [4.55347232089948, 1.4565480406424507],
            [4.549939737143792, 1.4597890546267809],
            [4.546880884904167, 1.453974364676395],
            [4.539438679049977, 1.451881618717418],
            [4.536283411433185, 1.4496711883490343],
            [4.532464265022129, 1.455302655386265],
            [4.524344005384532, 1.45572952203185],
            [4.518347126415589, 1.45823697814796],
            [4.518018559674294, 1.4657287601070499],
            [4.513292145392315, 1.4661347411380206],
            [4.51138803893957, 1.4714827576990306],
            [4.501168558160612, 1.4702411985036556],
            [4.498555556359612, 1.4769359470288221],
            [4.500183207198061, 1.4809797132943605],
            [4.498491745262262, 1.4841433139836633],
            [4.498835158256988, 1.4893163752345404],
            [4.50208285178352, 1.5020005078655552],
            [4.500920584123302, 1.5054017771336556],
            [4.49100099257337, 1.5028375442360902],
            [4.48456688248212, 1.5030567618224677],
            [4.475712209289695, 1.508129514593597],
            [4.475978945428535, 1.5118421166035378],
            [4.472676412792999, 1.5151011969032293],
            [4.479614335115578, 1.5180077058238752],
            [4.48204654902455, 1.5277584988127355],
            [4.4269647445867255, 1.5259109043785533],
            [4.406073720502811, 1.5255109014184833],
            [4.377709395036988, 1.5231402084976549],
            [4.317431626813669, 1.519247538965824],
            [4.313781481651123, 1.6085819877160035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.61502378475804, "lat": 40.15806793417567 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17169"],
        "coty_name": ["Schuyler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schuyler County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "01785037"
      },
      "bbox": [
        4.310522784097033, 1.40644368831078, 4.852737259238791,
        1.711942657980293
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.686813249107734, -0.18641989034711315],
            [6.691388547224661, -0.18651044400809752],
            [6.6996352932333725, -0.19534382077905096],
            [6.701740984441922, -0.19889997138063298],
            [6.7030080657765225, -0.20483771927365446],
            [6.709807379506, -0.2045361439569529],
            [6.711283896830171, -0.20139293025474816],
            [6.710032726885395, -0.19484079549026567],
            [6.713248396457378, -0.18811648533814784],
            [6.71922629028123, -0.18529122586264477],
            [6.7218980779934006, -0.18001524096360344],
            [6.714690541294082, -0.1740218284123978],
            [6.712955457823299, -0.16780168625714825],
            [6.7141120891623, -0.1639639198461953],
            [6.720058700285483, -0.1608137337417376],
            [6.722174977758881, -0.15706550891958812],
            [6.722705725578615, -0.14777469595955378],
            [6.725445282221884, -0.1436399021144172],
            [6.733466118126966, -0.13961063893795458],
            [6.738363710139874, -0.13901691167515434],
            [6.744032031473544, -0.1418890451844026],
            [6.74554642815046, -0.1455400700709162],
            [6.739556363077666, -0.15846907776256955],
            [6.7381840989974116, -0.16419153114645849],
            [6.740004316888279, -0.16856557046923887],
            [6.7452191987664465, -0.17019542869712836],
            [6.7483886323142315, -0.16830036157726008],
            [6.754543263273909, -0.15779395122458592],
            [6.761752346538094, -0.15128205526492003],
            [6.766038964332541, -0.13059044542211282],
            [6.769065745163041, -0.1256913437536394],
            [6.772837656140847, -0.12304811581812673],
            [6.777819650823653, -0.12415827530536168],
            [6.780507617904515, -0.1268434619402275],
            [6.781431107496177, -0.13154089265573626],
            [6.778722840295411, -0.13960173582942081],
            [6.7780777279731295, -0.14513918263003867],
            [6.78141514241964, -0.1547933750173693],
            [6.784332757165355, -0.15805071507627427],
            [6.791070274850372, -0.15908445654597297],
            [6.796754738457678, -0.15550235346099908],
            [6.799857806290789, -0.15102407483535407],
            [6.8030469314538555, -0.1423502600228217],
            [6.8045967826135, -0.1333472170551171],
            [6.804136117744577, -0.127059345318907],
            [6.801202608470468, -0.11612051903308403],
            [6.801407094906297, -0.10564010739715884],
            [6.804122103492002, -0.09825761633765423],
            [6.806392912704745, -0.08595804742608194],
            [6.81315712738568, -0.07744430356566527],
            [6.818313948293569, -0.06752103285253704],
            [6.835604818736849, -0.060227912776780974],
            [6.84490406018951, -0.047427491466180395],
            [6.8613473925320205, -0.01731188493472585],
            [6.86208602139326, -0.011781991534149518],
            [6.868950573649781, -0.008501975622668924],
            [6.8787888752596595, -0.008293296719511236],
            [6.88879274873859, -0.0051221570592238025],
            [6.89510366831999, -0.00132117635083583],
            [6.900840064741436, 0.005252079328978796],
            [6.909126746879247, 0.009941194708641915],
            [6.915809933392909, 0.0077423913270917456],
            [6.922099886040125, 0.010180642750037511],
            [6.923575976669037, 0.015179191218580393],
            [6.921091009685845, 0.01810308324908913],
            [6.915584143974936, 0.019309903850934472],
            [6.913519916790441, 0.02524104061570592],
            [6.9205036201765155, 0.028635300659292234],
            [6.921746801011826, 0.03390427664651887],
            [6.925322496450114, 0.0386192823518411],
            [6.930218427877332, 0.03632856487696356],
            [6.92692634433793, 0.033080748643720334],
            [6.929823983035051, 0.02939462738221581],
            [6.934539344757475, 0.03576954954019231],
            [6.937207524434855, 0.037038724360479565],
            [6.9407405420846535, 0.03493667670416407],
            [6.940481124585475, 0.028106752250865067],
            [6.942272222389354, 0.024431919585315227],
            [6.94585259035292, 0.024483298278985197],
            [6.947805474547885, 0.029914866841236638],
            [6.953431639645722, 0.03202067869586203],
            [6.95898279829764, 0.02958488633600685],
            [6.962807228388551, 0.029894898007756382],
            [6.970193645853438, 0.03442559025068528],
            [6.972416574344097, 0.03727963621609982],
            [6.976443421366092, 0.047002759709441164],
            [6.976712279989352, 0.055237985608825924],
            [6.982447485610675, 0.06975010184943899],
            [6.9781027477391975, 0.07366666644909009],
            [6.97585880189895, 0.07920429847824083],
            [6.976609003948296, 0.0828240641168183],
            [6.981463171759978, 0.08394139684380553],
            [6.983129416089668, 0.07969885181550276],
            [6.986455727607921, 0.07702312763439187],
            [6.997324433733644, 0.07668531085556157],
            [7.005903995545736, 0.07784001079807591],
            [7.012344744428431, 0.08097636581814971],
            [7.010529325202056, 0.08676632490126159],
            [7.00756244796277, 0.09061255442035827],
            [7.00349110422059, 0.099267102050663],
            [7.0062565686632805, 0.10529731325855293],
            [7.012666705471624, 0.10698753927286826],
            [7.0176585697615925, 0.10414970814523283],
            [7.018960600162783, 0.09911190398217778],
            [7.016944141026892, 0.08965956832111006],
            [7.021505040029005, 0.08774852028268733],
            [7.026485502573322, 0.09314629043491199],
            [7.031815082768304, 0.09346305069278535],
            [7.039634736464162, 0.08785754692167594],
            [7.045255995411648, 0.08532717616731342],
            [7.04839115450515, 0.08694267360855833],
            [7.046897532027349, 0.09332860834175365],
            [7.048604830148904, 0.09685587040927111],
            [7.056558076809128, 0.10134573952227663],
            [7.061781856914256, 0.1056376216994927],
            [7.0625396586532485, 0.11259896372106942],
            [7.057066916689611, 0.1164571994890875],
            [7.0586352756150035, 0.1207985705500027],
            [7.06223114785454, 0.11523256518711823],
            [7.06512835086707, 0.11502284858125429],
            [7.063436969972872, 0.12230317661391368],
            [7.063996122007152, 0.12524297484190042],
            [7.068325711159374, 0.12725292563210008],
            [7.071907945845602, 0.0936396358248205],
            [7.074285511026672, 0.06087369176070756],
            [7.074770046868665, 0.05909844906833423],
            [7.088688995803429, 0.060115189628314365],
            [7.091318968420062, 0.030580684168724597],
            [7.1200572107277225, 0.033377984045227314],
            [7.125404069638796, -0.027803737007316694],
            [7.132991380249575, -0.02776953230514357],
            [7.137337895446772, -0.024925222905072802],
            [7.135515083925139, -0.021196160581824504],
            [7.140563516724015, -0.018962160413225636],
            [7.1420928110391, -0.023232884754900058],
            [7.145979412651837, -0.01795168482300246],
            [7.150252340952406, -0.020425395267847524],
            [7.157915955067783, -0.021745425389077533],
            [7.163378989005784, -0.017342668964613388],
            [7.162903175754142, -0.01192777296608037],
            [7.166722635649831, -0.013706756448059252],
            [7.170352149285163, -0.012821897829070212],
            [7.17120678134043, -0.016326325124582226],
            [7.176133545454747, -0.014691028139650824],
            [7.180583975770706, -0.018778385958251004],
            [7.19001087390507, -0.014398391319593935],
            [7.189063016711363, -0.01935548731299122],
            [7.196261416056271, -0.021556840176056174],
            [7.198916765914577, -0.055670879681337396],
            [7.203351234306003, -0.10762521554764522],
            [7.2074443487829845, -0.15156159725196774],
            [7.2114216435492375, -0.19614347474371704],
            [7.095434205698583, -0.20715075323045046],
            [7.098264392184965, -0.24327751883859658],
            [7.051820438384302, -0.2464794036004107],
            [7.0438033636011985, -0.24661666763321077],
            [7.012301445426543, -0.2494181623001164],
            [6.9977336905231775, -0.2501777300062257],
            [6.9456224543847105, -0.25388147196893357],
            [6.926536467949291, -0.25547721325158596],
            [6.923791530031845, -0.2226900630543307],
            [6.866052449697208, -0.22718018584277982],
            [6.837290615322132, -0.22926709890694377],
            [6.8353665027244, -0.20243584722144672],
            [6.692188068904631, -0.21288323299929368],
            [6.694262478489493, -0.2075814599667439],
            [6.694476228395406, -0.20235646694625609],
            [6.691635555076729, -0.19434145864746347],
            [6.686813249107734, -0.18641989034711315]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.58460103607013, "lat": 38.31188624172175 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18051"],
        "coty_name": ["Gibson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gibson County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00450354"
      },
      "bbox": [
        6.686813249107734, -0.25547721325158596, 7.2114216435492375,
        0.12725292563210008
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.59518341233986, 2.0815841979224334],
            [8.612787528856195, 2.0836788876006764],
            [8.689223502578201, 2.0935538841660732],
            [8.746055167077172, 2.101246498921081],
            [8.83359409749456, 2.111874903273829],
            [8.906432048383381, 2.121145002150761],
            [8.911450691261308, 2.0735531127369504],
            [8.917982079935063, 2.008657519670674],
            [8.92688333593095, 1.9175321968130745],
            [8.932176911604737, 1.8656140503873742],
            [8.93712545847927, 1.8150390718932738],
            [8.875226461396055, 1.8090468693427242],
            [8.875121310425818, 1.8078209226079565],
            [8.825659691156599, 1.8021523381122881],
            [8.754298882672758, 1.793388719704809],
            [8.699099525815171, 1.7864143543718396],
            [8.642733249962099, 1.7802840167774332],
            [8.633682085871317, 1.7791091410215882],
            [8.626733976945793, 1.8370992627036185],
            [8.624725233802385, 1.851696139594902],
            [8.614268921843891, 1.9325018383792765],
            [8.604380344797224, 2.0097912517050163],
            [8.60331404663048, 2.017093717683165],
            [8.59518341233986, 2.0815841979224334]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.011328878797, "lat": 40.15760059453009 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18135"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00446853"
      },
      "bbox": [
        8.59518341233986, 1.7791091410215882, 8.93712545847927,
        2.121145002150761
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.844522301894536, 2.076198192317737],
            [6.913295073730138, 2.0822120116972442],
            [6.941696964653521, 2.0849524896768616],
            [6.998712261748254, 2.0896578782884863],
            [7.0417136321466165, 2.09345700079808],
            [7.0846698951005935, 2.096830525148578],
            [7.169702512006495, 2.104847712449632],
            [7.170380433255228, 2.10490328533688],
            [7.1785434344970485, 2.0169996048169554],
            [7.180513864734206, 2.004757906186855],
            [7.181153346700563, 1.9954108984409575],
            [7.177996597369753, 1.9951741666409175],
            [7.173130749195678, 1.9893753870878303],
            [7.171651290947759, 1.9826164627605203],
            [7.163374657127362, 1.974954188297298],
            [7.157885073064459, 1.9713463591470348],
            [7.153991523828188, 1.9665139852033464],
            [7.137526424135942, 1.9590304148328892],
            [7.134117352773434, 1.9600917714162578],
            [7.125493192783626, 1.9580202907221507],
            [7.113128726216158, 1.9483290946744405],
            [7.103669941266791, 1.9440005183755256],
            [7.09943561711366, 1.943039613205256],
            [7.081529484508718, 1.9304953099687985],
            [7.071616734350277, 1.9271216788907553],
            [7.069634793630329, 1.9243463326859858],
            [7.069204262330689, 1.917133944517016],
            [7.058699309461456, 1.9044104144434157],
            [7.050898177467914, 1.899357041950446],
            [7.0470133214863155, 1.8936032824212021],
            [7.042525621829575, 1.8799715189825548],
            [7.037836424493081, 1.8696258548656872],
            [7.03409212532855, 1.8685632921547897],
            [7.02665091727236, 1.8630203016011675],
            [7.023624694921675, 1.8593486434003512],
            [7.021020281727743, 1.8512852861795717],
            [7.01545445920655, 1.8471699641481185],
            [7.012775959731707, 1.840173584598199],
            [7.0084891339792525, 1.8341554803866715],
            [7.005311674223337, 1.8330623017921561],
            [7.002553439095295, 1.8271618618021641],
            [6.998727776961002, 1.8259227747103828],
            [6.995231043096415, 1.8201436714753145],
            [6.987111641819615, 1.8163105243402815],
            [6.969873072503432, 1.8099366675906194],
            [6.962276837708318, 1.8024679293599217],
            [6.9538497577294045, 1.7996711501931193],
            [6.950539384938378, 1.7975811994759088],
            [6.9490181411180325, 1.7905808703463018],
            [6.94361881173412, 1.7793545757418523],
            [6.939622473984039, 1.7737611986908952],
            [6.9387342311854505, 1.7696141612200444],
            [6.941420461750591, 1.7613989054758257],
            [6.943826923226731, 1.75772960022458],
            [6.9476435984921725, 1.755180219733103],
            [6.955557429014558, 1.7525034029725806],
            [6.964567076001176, 1.748127074733103],
            [6.967026422504308, 1.7416538141114581],
            [6.966415888037449, 1.7334469782929032],
            [6.917706568852904, 1.7288612254616404],
            [6.903226036696275, 1.7276454399068641],
            [6.901295941221354, 1.7487540721761263],
            [6.8703863863871035, 1.7456886313043714],
            [6.867071262046399, 1.7881523653848048],
            [6.858834347146405, 1.8921161111147948],
            [6.852572368567168, 1.9729633687489712],
            [6.844522301894536, 2.076198192317737]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.35332408003815, "lat": 40.34693357103479 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18171"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00450400"
      },
      "bbox": [
        6.844522301894536, 1.7276454399068641, 7.181153346700563,
        2.10490328533688
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.229147665128145, 3.372382133967582],
            [4.224512147054277, 3.4600308776735478],
            [4.274401358789123, 3.462521895986637],
            [4.281655400880515, 3.4625621091910928],
            [4.317425693888592, 3.464239971508882],
            [4.338801628892472, 3.4656294524417217],
            [4.4247456855948455, 3.4702657849056604],
            [4.482078520656635, 3.4736037446753008],
            [4.560428408954523, 3.478807807632261],
            [4.58689716639839, 3.480191364239353],
            [4.653522674001167, 3.484381304693482],
            [4.725068084866599, 3.488316376480662],
            [4.772461099177268, 3.491086640830898],
            [4.774557080303633, 3.4887581169617934],
            [4.777779168998047, 3.478261445602956],
            [4.781278177848431, 3.4733070467187965],
            [4.784735252928372, 3.4618073884086975],
            [4.784778784317055, 3.4545047450776933],
            [4.781274099558558, 3.4463720665174025],
            [4.781554835848896, 3.4395299964175137],
            [4.776396002067515, 3.431947260494621],
            [4.771068510081369, 3.4187036073217407],
            [4.769915263976913, 3.413480484328021],
            [4.769774919087973, 3.4061013596741527],
            [4.7708224797285625, 3.4022098734567625],
            [4.779804269294231, 3.390798370922361],
            [4.78066568541126, 3.386680154939202],
            [4.780367480232716, 3.373238975959996],
            [4.780759763404033, 3.364217481860894],
            [4.778758438778339, 3.3554355327074368],
            [4.773704132337143, 3.3407768891450638],
            [4.770486343141974, 3.3331865994728282],
            [4.769111678162505, 3.3227351401841534],
            [4.769473695351426, 3.3139445205759337],
            [4.764064245919556, 3.300762005695657],
            [4.762878939568498, 3.2890248406845517],
            [4.765187570015044, 3.278615546137771],
            [4.766637432127687, 3.2680033363267924],
            [4.765957776053532, 3.2630152410708813],
            [4.7617700189732375, 3.2588222398931963],
            [4.740889519532064, 3.249661137194928],
            [4.737054614184233, 3.247209142224885],
            [4.722813961841552, 3.236098915314866],
            [4.7112805794364325, 3.2276731687888818],
            [4.708027721721111, 3.2242693982724036],
            [4.69697516725473, 3.218812923579354],
            [4.680174542155683, 3.2003438325699816],
            [4.674786766470007, 3.192143952887687],
            [4.6719298805998895, 3.183961671445519],
            [4.671412554963752, 3.1785099268607073],
            [4.6657468762734835, 3.1828052194254526],
            [4.661808805592332, 3.183514453544904],
            [4.657829007869493, 3.1882996263942367],
            [4.65140046292616, 3.1878684457506776],
            [4.650040100199588, 3.181843042172937],
            [4.647299721114287, 3.1780613913208917],
            [4.6446040493051886, 3.179950915860286],
            [4.640623801652683, 3.179090828953852],
            [4.641037721159575, 3.175590401641601],
            [4.6354986480355675, 3.175420110788045],
            [4.628092965689378, 3.1813573233197214],
            [4.622856316795187, 3.183053994188142],
            [4.61674348418487, 3.183388332786912],
            [4.6171640391830175, 3.1769851072873534],
            [4.610103354951075, 3.1776561232228935],
            [4.606837312974748, 3.175414168342423],
            [4.6028426106996125, 3.1751811700197403],
            [4.599895842171718, 3.1864369592488764],
            [4.590790791931333, 3.181020350925718],
            [4.591791723752539, 3.185572196017346],
            [4.5885562942930145, 3.190543657058644],
            [4.590499758581198, 3.1940906133634765],
            [4.588909270586968, 3.1975855251136336],
            [4.582619595412072, 3.2014541105328784],
            [4.578109139123844, 3.2029212959243694],
            [4.573059417313839, 3.207925135381982],
            [4.569266301545516, 3.2079435053782817],
            [4.564010632742426, 3.2015431471546205],
            [4.559594926412397, 3.202298601993693],
            [4.557049028213641, 3.2059278737993275],
            [4.557480410446562, 3.2120820216064923],
            [4.554815903016854, 3.216187990368002],
            [4.548594971511822, 3.214510646601385],
            [4.543676979131329, 3.208762319058253],
            [4.540979410940949, 3.2095721893321265],
            [4.536572815747315, 3.2078620578857624],
            [4.531492230645048, 3.2088316105018224],
            [4.528333435914407, 3.21100065927035],
            [4.525234956085198, 3.2073678721974543],
            [4.522000231057929, 3.210454715655927],
            [4.50469229194392, 3.216004327293177],
            [4.501809622070433, 3.2058905930252717],
            [4.49726081588661, 3.2089716238405153],
            [4.494162915770441, 3.204140363666811],
            [4.489508214666554, 3.2028824912077285],
            [4.485592643765817, 3.204873098776793],
            [4.475357350009874, 3.197536437243887],
            [4.471416381317737, 3.2014809729261597],
            [4.467738500053058, 3.2024221647440827],
            [4.467422881186499, 3.2074447209471297],
            [4.464874299773171, 3.208535934222151],
            [4.4615946467258905, 3.2052958037193493],
            [4.460470915559836, 3.201591881267109],
            [4.4575541539580605, 3.199927110497109],
            [4.451328057740107, 3.201043943894288],
            [4.45048818894679, 3.195192153810671],
            [4.447018780465376, 3.1940697898382764],
            [4.4447634211500535, 3.1982260469761186],
            [4.436896857717768, 3.201625997529163],
            [4.432943860665296, 3.196983083982224],
            [4.4284640326698925, 3.197308834492013],
            [4.426657384789183, 3.1931761235460447],
            [4.421783018683798, 3.1908304075059526],
            [4.4185127228608865, 3.1930211953500542],
            [4.41719017217667, 3.1992365428512453],
            [4.414362793866636, 3.2003924879426995],
            [4.4094691720310575, 3.1991970933914766],
            [4.404171497085184, 3.196321138607529],
            [4.399754657662471, 3.188655973633694],
            [4.39780961312539, 3.190621602017189],
            [4.395055964225685, 3.185605661939158],
            [4.390760456725018, 3.1824874888327996],
            [4.393082993433465, 3.176773678630048],
            [4.388725858628015, 3.176429831669168],
            [4.385621858893128, 3.170917087846214],
            [4.381861432936074, 3.1732455636747834],
            [4.377889176046594, 3.1716100536330942],
            [4.377101606324574, 3.167269288881216],
            [4.372494708024751, 3.1692953216277195],
            [4.367583974548884, 3.1745347652523166],
            [4.363863920656458, 3.1693858486600694],
            [4.360312153678803, 3.172378839828677],
            [4.354719515125256, 3.1730296008145005],
            [4.350352215389287, 3.175719040821566],
            [4.34735965351469, 3.180149868896125],
            [4.347182769035264, 3.1841497354228903],
            [4.340049790436896, 3.1936665409650473],
            [4.3285598518773565, 3.197532617448234],
            [4.32363130758883, 3.1982070335070305],
            [4.321591456504953, 3.2012694356797433],
            [4.287334929949261, 3.1995860021440334],
            [4.238679237503182, 3.196795822640561],
            [4.2340309387754385, 3.284506968276928],
            [4.229147665128145, 3.372382133967582]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.53195489482235,
          "lat": 41.898019705401886
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19045"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00465211"
      },
      "bbox": [
        4.224512147054277, 3.167269288881216, 4.784778784317055,
        3.491086640830898
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.95184296822753, 4.875784267063681],
            [3.0270035015300496, 4.878729864562153],
            [3.080217148907216, 4.880961606964],
            [3.11605649597245, 4.882263390569806],
            [3.1816769365352426, 4.8848618029908355],
            [3.22686565464259, 4.886850731047097],
            [3.2933067699875656, 4.889504097755734],
            [3.29436567667171, 4.859888466720592],
            [3.2975918596230565, 4.781655251525771],
            [3.302628713936746, 4.64421531961042],
            [3.3043816371527672, 4.601498084235351],
            [3.2188050176686422, 4.598062974707294],
            [3.1615771456083994, 4.596535254845094],
            [3.1468674711295366, 4.595067906335447],
            [3.132965130283952, 4.594660687453242],
            [3.0610788377948372, 4.592027793454548],
            [2.9971331153481193, 4.58932937604815],
            [2.961407187811837, 4.588111759258915],
            [2.9595526642772914, 4.6356516159607954],
            [2.955292796387252, 4.761047812793002],
            [2.95184296822753, 4.875784267063681]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.3171958903857, "lat": 43.35677789821184 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19089"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00465233"
      },
      "bbox": [
        2.95184296822753, 4.588111759258915, 3.3043816371527672,
        4.889504097755734
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6296426783740374, 2.5140757914490135],
            [2.7153296930301245, 2.516670508488759],
            [2.794026338517643, 2.519265937811537],
            [2.8008948617627, 2.5197063252806746],
            [2.886734853980926, 2.522883980167995],
            [2.9720895134221994, 2.5258863737344495],
            [2.9752428521544076, 2.446225625970002],
            [2.978962349699774, 2.350462241560661],
            [2.9824065182248587, 2.26162550212806],
            [2.8964118962808283, 2.2583452507379924],
            [2.8388028833594676, 2.2563553839190953],
            [2.806430290552794, 2.254953045025578],
            [2.8055406286044575, 2.25541478648972],
            [2.724523118498132, 2.2525251257055685],
            [2.7119054949561487, 2.2519545560383896],
            [2.6389321000260266, 2.2498742401870273],
            [2.638703030640453, 2.2526576928557946],
            [2.635653071380837, 2.3383896632740164],
            [2.6328688314215016, 2.4269108971353663],
            [2.6296426783740374, 2.5140757914490135]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.86902034552845, "lat": 41.02980208585853 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19135"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00465256"
      },
      "bbox": [
        2.6296426783740374, 2.2498742401870273, 2.9824065182248587,
        2.5258863737344495
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.07241038934757564, 4.239290325460863],
            [0.13575464637445633, 4.239564580964746],
            [0.18594407999627097, 4.239247254617056],
            [0.2220166250561391, 4.239199507801003],
            [0.32177485610857576, 4.238880635188806],
            [0.39394368960615206, 4.23943852940163],
            [0.4658818235959902, 4.239551909528321],
            [0.48022028437776887, 4.239172697713801],
            [0.5661492634906407, 4.238569276505625],
            [0.5668665604610909, 4.1517121432720145],
            [0.5663153587859111, 4.107917735975309],
            [0.565383085472802, 4.0496393957267385],
            [0.5658132144306945, 4.02783032435528],
            [0.566342581061408, 3.9544377914923894],
            [0.5665094705288118, 3.914341480033829],
            [0.5662492956629902, 3.8888726280708426],
            [0.479705814842567, 3.889265961031181],
            [0.44398432490250184, 3.8892257681225444],
            [0.33613770190623177, 3.889722250042978],
            [0.307045252631155, 3.89028255300146],
            [0.29273923485857467, 3.889811161435455],
            [0.17021344605792052, 3.890909054785913],
            [0.14246920653974393, 3.891010287725036],
            [0.09866844200947351, 3.8901779830612093],
            [0.1081300881473582, 3.902659564198421],
            [0.10765359223413422, 3.9052100657191167],
            [0.10152428539853796, 3.9080436971376975],
            [0.1011289574675756, 3.9119300397127454],
            [0.10352034973892364, 3.9170296960367144],
            [0.09858644072615685, 3.917668771335769],
            [0.09781391825061399, 3.9233761054795475],
            [0.09460124503723571, 3.9343305317112076],
            [0.09112167463907855, 3.9421079904051557],
            [0.08560204939510736, 3.945375170977412],
            [0.08375064919240946, 3.9446514251701665],
            [0.07925210425931833, 3.9387412541351794],
            [0.07616961922120395, 3.9398826675442318],
            [0.07494546098959476, 3.944623709288484],
            [0.07746440700325997, 3.9479214082056515],
            [0.08256365164256388, 3.9481151739923055],
            [0.08595887701828865, 3.9518038678864422],
            [0.08619387580551764, 3.9599074762642315],
            [0.0806246103291585, 3.9640805991001278],
            [0.07888644735943724, 3.9707664087325942],
            [0.0735722365501175, 3.9731327765884794],
            [0.07053297710052989, 3.9760658311664363],
            [0.07058706307561922, 3.985084281880725],
            [0.0677816312263309, 3.9900656660456004],
            [0.06408034877524399, 3.9912039615910198],
            [0.05565022552255148, 3.9873443177824495],
            [0.05453365949247658, 3.9925923584016956],
            [0.05717293585897894, 3.9946014043003615],
            [0.051141682573614025, 4.001429988015109],
            [0.049654313123649416, 4.005792842296342],
            [0.045547857044451974, 4.000632297770563],
            [0.04242235370538675, 4.000646122559306],
            [0.04584469771714592, 4.007561014762066],
            [0.04196295333852764, 4.007411790448736],
            [0.0434040887031401, 4.012736609590768],
            [0.03599125250446114, 4.013048740361551],
            [0.03507494164878445, 4.020122140189783],
            [0.029118759363104225, 4.01946856468882],
            [0.0288201666608397, 4.0240410266684075],
            [0.025221667156952208, 4.028105233585258],
            [0.021395306716971037, 4.024332705639741],
            [0.021388194337308174, 4.032139963692714],
            [0.018417562023653945, 4.032504152404643],
            [0.014534158369594024, 4.029193076901378],
            [0.011723177656874745, 4.029857610562416],
            [0.008407042054674577, 4.037230692304205],
            [0.005950050391632278, 4.0342630883272],
            [0.003137871342754322, 4.036132298660473],
            [0.006145902579184779, 4.040577469030618],
            [0.007648117033457723, 4.045874567061779],
            [0.007586379508055435, 4.055790181559556],
            [0.0011403261149643001, 4.054519093856282],
            [0.0034334110069094204, 4.06025520385706],
            [0.000059486853631150533, 4.070634966404761],
            [0.003086125942397956, 4.074885758568835],
            [0.0035312480600822884, 4.080785320599556],
            [0.01080517058398021, 4.083904530699574],
            [0.009385086475030458, 4.088845806468519],
            [0.005490274305628685, 4.0868233051630725],
            [0.00022059140888398723, 4.093700761462283],
            [0.002161620514179973, 4.097815982326257],
            [0.0004206529391344419, 4.101233183116609],
            [0.006646246062313908, 4.102924878017866],
            [0.009446779679382974, 4.107351617358037],
            [0.011777372946622039, 4.114502640314651],
            [0.02266406821985878, 4.113429335366115],
            [0.024141727012016556, 4.118168948428194],
            [0.023538481897769283, 4.122768159932069],
            [0.028208597343165893, 4.122278202239168],
            [0.027012630740041205, 4.128236556180907],
            [0.030088552165233793, 4.1284450551323015],
            [0.03158052975375089, 4.131522013958231],
            [0.032782141850277446, 4.13940563762381],
            [0.029326313812123764, 4.140870906955168],
            [0.02910456996218444, 4.1455055066763515],
            [0.03273014638008614, 4.145804979904873],
            [0.037529699959203806, 4.149401232977966],
            [0.04235965482467037, 4.158066045696677],
            [0.03915730833704922, 4.164117025088523],
            [0.04108585931853484, 4.168555573044259],
            [0.047217570069639746, 4.167577518296035],
            [0.05136764307520181, 4.160810046979953],
            [0.055090101669486344, 4.169755898917415],
            [0.05828901933815735, 4.167030473871536],
            [0.061843988156243264, 4.166940594866083],
            [0.06282211859860372, 4.171047122999989],
            [0.059758043419632347, 4.1740173072186195],
            [0.060094794700819985, 4.1778806604862835],
            [0.06613691651099805, 4.180308632008661],
            [0.0691272713820659, 4.18804207057376],
            [0.06541101230403006, 4.18765299286622],
            [0.0626154769198954, 4.193585670307532],
            [0.06322524204271282, 4.200714421035218],
            [0.06562847938127031, 4.204896632410999],
            [0.07187581125549211, 4.208884539056559],
            [0.07149165222663861, 4.216546267301282],
            [0.0702896414472816, 4.2201310147967686],
            [0.07930999384403484, 4.220993263961764],
            [0.0801850129987064, 4.224165099584539],
            [0.07851640649727083, 4.228382109735249],
            [0.07334649052687406, 4.231370946309647],
            [0.07087210722918977, 4.230445066878944],
            [0.06838101238214203, 4.2342436319268275],
            [0.07296780965721467, 4.23614244885348],
            [0.07241038934757564, 4.239290325460863]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.21399403484713, "lat": 42.73782308244351 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19149"],
        "coty_name": ["Plymouth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Plymouth County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00465263"
      },
      "bbox": [
        0.000059486853631150533, 3.8888726280708426, 0.5668665604610909,
        4.239564580964746
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.010124087896604, 3.6703790195407535],
            [3.0956958077137773, 3.673831966201429],
            [3.1824361759276787, 3.6773950063119685],
            [3.1857977974618175, 3.5902893706817944],
            [3.1873131420172993, 3.542431419597313],
            [3.190733829871844, 3.4584532857814803],
            [3.195170992668736, 3.3715363928492],
            [3.1960645047716625, 3.3570881868821356],
            [3.198243658461137, 3.2853475126144733],
            [3.1999447329749744, 3.240742792571311],
            [3.1497975777952947, 3.2385379195307933],
            [3.1058533077068162, 3.236875357392313],
            [3.026398337917967, 3.2336224727658145],
            [2.911557921150229, 3.2296146330845272],
            [2.8543024680362348, 3.227737017223491],
            [2.852636150770633, 3.2829842951653645],
            [2.8499233467268077, 3.3584894300293886],
            [2.8458902969177555, 3.459351352571132],
            [2.8430951228253782, 3.5335979001137257],
            [2.841311285030106, 3.5771102714738694],
            [2.8378881752972602, 3.6639968971201924],
            [2.866872771554983, 3.6651145483783063],
            [2.981646848058113, 3.6692272190404474],
            [3.010124087896604, 3.6703790195407535]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.53255682134544,
          "lat": 42.079796079644254
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19171"],
        "coty_name": ["Tama"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tama County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00465274"
      },
      "bbox": [
        2.8378881752972602, 3.227737017223491, 3.1999447329749744,
        3.6773950063119685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8453721041559074, -0.3132225437697124],
            [0.8853278959997664, -0.3131676055711201],
            [0.9173113839837819, -0.31286075936201474],
            [1.0039502248041359, -0.31241453692529714],
            [1.0768842138008565, -0.31147380395691454],
            [1.1030249681273374, -0.31164068384257876],
            [1.1319735504269086, -0.31154066299659894],
            [1.1352440662424852, -0.3112272053574089],
            [1.1888297521915199, -0.3109825279395806],
            [1.189266241122643, -0.35515224101045584],
            [1.1906989427538557, -0.44355185215103515],
            [1.1826459128687268, -0.4435639785487556],
            [1.1828074926819117, -0.4508200448212627],
            [1.1823872847642538, -0.5203627998810169],
            [1.183219016855989, -0.6074223726616073],
            [1.1829922137766082, -0.6079830026774055],
            [1.1829318258092911, -0.6667393736923161],
            [1.163595487070453, -0.666745713176617],
            [1.0969975543508743, -0.6675273137719624],
            [1.0246242864368005, -0.6677830560642442],
            [0.9818812730371322, -0.668036573992532],
            [0.9251717337949228, -0.6680447047248746],
            [0.8485366745103459, -0.6687820099609779],
            [0.8389111834001103, -0.6687495566272071],
            [0.8387650575217706, -0.6026221295647417],
            [0.8390713422349331, -0.5660543335736083],
            [0.8395021314794767, -0.44551756202610443],
            [0.8467206317846716, -0.4455289784029426],
            [0.8458799513844177, -0.3573428847573396],
            [0.8453721041559074, -0.3132225437697124]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.29332184315595, "lat": 38.2141883794586 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20003"],
        "coty_name": ["Anderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anderson County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00484971"
      },
      "bbox": [
        0.8387650575217706, -0.6687820099609779, 1.1906989427538557,
        -0.3109825279395806
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4611299490536351, -0.5088174819696517],
            [-1.382208338411356, -0.5100321123168543],
            [-1.3750137801884557, -0.5099779712686714],
            [-1.346746920659376, -0.5108782431904828],
            [-1.289459724461382, -0.512318771783284],
            [-1.275713327035193, -0.5129250946729069],
            [-1.261282384725892, -0.5129993968429929],
            [-1.2615455215485571, -0.5278895087586939],
            [-1.2257035091355688, -0.5284135769273043],
            [-1.2041222712473083, -0.5284103062949378],
            [-1.2038627183755315, -0.5138918691650858],
            [-1.175592240684369, -0.514581330653076],
            [-1.075533408743315, -0.5175096798192417],
            [-1.0468059595613066, -0.5175029080286815],
            [-1.0325345501410044, -0.517762634308362],
            [-0.9896292022407047, -0.5186169668032357],
            [-0.9756007667364275, -0.5191174643559331],
            [-0.8610649888752293, -0.5209299264662055],
            [-0.8625466003381389, -0.6088848240538712],
            [-0.8630864987792981, -0.6310652770546059],
            [-0.8640027114101093, -0.6821791692059276],
            [-0.8644659563054318, -0.6968015197280456],
            [-0.864833910041361, -0.7261479997682297],
            [-0.8659110042884077, -0.7859360869567094],
            [-0.8675723318819513, -0.8729249112861472],
            [-0.8656781827335168, -0.8729608282114862],
            [-0.8657442327000984, -0.8902586753603656],
            [-0.8665323445016611, -0.9639335296389888],
            [-0.8740835539579173, -0.9644323707395976],
            [-0.9307239337455703, -0.9640481850545363],
            [-0.9348641982985727, -0.9636150343403704],
            [-0.9520076173890444, -0.9635696517587251],
            [-1.002188847070273, -0.9629759457624493],
            [-1.0382770042218907, -0.9618494558017288],
            [-1.1238929850925656, -0.9606733495959027],
            [-1.2520056322149344, -0.9584140504266562],
            [-1.2805387323334714, -0.9576205282805351],
            [-1.3096203621816416, -0.9572645457655118],
            [-1.380876205414425, -0.9554719885181089],
            [-1.4664354447384997, -0.9531981400530446],
            [-1.4648786311672923, -0.8944254026456012],
            [-1.4641049554212098, -0.8604998316842853],
            [-1.4698588869465419, -0.860365518157957],
            [-1.468503741854384, -0.8163399365334878],
            [-1.4673246067766614, -0.7724607675968834],
            [-1.4653282176125368, -0.6845633873233288],
            [-1.4631959722565668, -0.5968034372262015],
            [-1.4611299490536351, -0.5088174819696517]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.08597448563421, "lat": 37.952946312813 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20155"],
        "coty_name": ["Reno"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Reno County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00485041"
      },
      "bbox": [
        -1.4698588869465419, -0.9644323707395976, -0.8610649888752293,
        -0.5088174819696517
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9520076173890444, -0.9635696517587251],
            [-0.9348641982985727, -0.9636150343403704],
            [-0.9307239337455703, -0.9640481850545363],
            [-0.8740835539579173, -0.9644323707395976],
            [-0.8665323445016611, -0.9639335296389888],
            [-0.8657442327000984, -0.8902586753603656],
            [-0.8656781827335168, -0.8729608282114862],
            [-0.8675723318819513, -0.8729249112861472],
            [-0.8659110042884077, -0.7859360869567094],
            [-0.8657905483069686, -0.7847950433186007],
            [-0.772710208219931, -0.7864882211905891],
            [-0.6940750065324348, -0.7878499326498836],
            [-0.6015166639453875, -0.7893304012461188],
            [-0.5084028352696293, -0.7904260524910035],
            [-0.4366323579401937, -0.7909603705439012],
            [-0.4373311667691318, -0.8574803380597142],
            [-0.43744558351974694, -0.8793660261706173],
            [-0.4384663896141036, -0.8793627335435702],
            [-0.4385803841530435, -0.9086115509347769],
            [-0.43908869613811846, -0.9674735120774062],
            [-0.43966576695604337, -1.0038648056498696],
            [-0.440576198205596, -1.0781825768435986],
            [-0.44113000692409887, -1.1440049070734941],
            [-0.4426574246612262, -1.2323304747304713],
            [-0.48573288475591697, -1.23164500232593],
            [-0.5260358500781437, -1.2313016263656573],
            [-0.6121249470779302, -1.2283354308839727],
            [-0.6979094430556869, -1.2285783736566025],
            [-0.784078840198771, -1.2277895016271205],
            [-0.8704581037174624, -1.2269600841684456],
            [-0.9568197404601764, -1.2256958797453181],
            [-0.9552325213961316, -1.137232943769491],
            [-0.9550487249423245, -1.1102880035702245],
            [-0.9540914531317494, -1.0514541794898804],
            [-0.9526736436867802, -1.0441588714942873],
            [-0.9522554799305486, -0.9784502540527398],
            [-0.9520076173890444, -0.9635696517587251]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.4609823497493, "lat": 37.68475993335046 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20173"],
        "coty_name": ["Sedgwick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sedgwick County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00485049"
      },
      "bbox": [
        -0.9568197404601764, -1.2323304747304713, -0.4366323579401937,
        -0.7847950433186007
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.179203854447333, 0.5836176248985563],
            [-4.08394000544919, 0.5777106214714721],
            [-4.020259456807603, 0.5738359389047305],
            [-3.926626931048114, 0.5684051458253851],
            [-3.8706689288093177, 0.5656378692644642],
            [-3.847871278818464, 0.564315224552839],
            [-3.742753967202443, 0.5587564412047215],
            [-3.74572510546357, 0.5158084013597116],
            [-3.751722933790424, 0.42439809846989435],
            [-3.7521052180211143, 0.4230245661787547],
            [-3.7545100849629702, 0.3844908137967534],
            [-3.7590059525194137, 0.32054578420138935],
            [-3.7632784162616653, 0.25234352903841495],
            [-3.7665318650024315, 0.20896207498521985],
            [-3.7685100095010893, 0.17973272849109898],
            [-3.772806595575521, 0.12097027634624509],
            [-3.836655578864926, 0.12418388534658599],
            [-3.9664437990414547, 0.13066582478843777],
            [-4.058714656867944, 0.13576459751298148],
            [-4.201615648932304, 0.14462831188063338],
            [-4.2056423509174214, 0.14462666004407662],
            [-4.200312017546688, 0.2311837487198303],
            [-4.198344278634931, 0.2613491345296642],
            [-4.184257398984513, 0.49683040895674296],
            [-4.179203854447333, 0.5836176248985563]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.76362378592937,
          "lat": 38.91665183498899
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20199"],
        "coty_name": ["Wallace"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wallace County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "00485060"
      },
      "bbox": [
        -4.2056423509174214, 0.12097027634624509, -3.742753967202443,
        0.5836176248985563
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5755496678444934, 1.3203210182940965],
            [-0.5755492061096577, 1.320321012418645],
            [-0.49004751282210446, 1.3186389371303135],
            [-0.4034503381358379, 1.3174775707822974],
            [-0.3999686224578325, 1.3177576696793682],
            [-0.33302555264591926, 1.3164920614269722],
            [-0.30228449433853394, 1.316300432900598],
            [-0.23187676614854122, 1.3156306081789535],
            [-0.14789735439524943, 1.3147338524526675],
            [-0.14878783674077242, 1.2274718548871202],
            [-0.14954614004512515, 1.1543949713743378],
            [-0.15015572637612665, 1.1099995403848184],
            [-0.15080310482949777, 1.029857372874243],
            [-0.15103335826834105, 1.0220349863312543],
            [-0.15167827968647873, 0.9343705758317871],
            [-0.1522115942622962, 0.8758496497264913],
            [-0.2684227898717633, 0.8769378452743992],
            [-0.38962528041703615, 0.878426054378306],
            [-0.4379000314940918, 0.8789298988608947],
            [-0.4514600543876656, 0.8793378109101078],
            [-0.4955413895697008, 0.8798090771665457],
            [-0.5813975047030122, 0.881360913964847],
            [-0.5811105617964868, 0.8913689119448058],
            [-0.5802058956717061, 0.969183102448584],
            [-0.5789468550555128, 1.0493992564205432],
            [-0.5773481763443788, 1.1730208107198883],
            [-0.5771989235956752, 1.2031227924171006],
            [-0.5755496678444934, 1.3203210182940965]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.08752124095082, "lat": 39.78418063842121 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20201"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "201",
        "coty_gnis_code": "00485061"
      },
      "bbox": [
        -0.5813975047030122, 0.8758496497264913, -0.14789735439524943,
        1.3203210182940965
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.942300539309471, -0.8630998086910896],
            [9.94184381482991, -0.8608710078402645],
            [9.947929219159438, -0.8541017515693894],
            [9.95307566763934, -0.8517226283075731],
            [9.960096543258361, -0.8500105239543362],
            [9.96745491757466, -0.8541999470543645],
            [9.974846210340008, -0.8556963126851287],
            [9.976595438789214, -0.8523078384206362],
            [9.974488398688292, -0.8424536250493905],
            [9.975907907076017, -0.8391307134895507],
            [9.98116206296869, -0.8337653772639755],
            [9.982191520587, -0.8304281071222643],
            [9.981101331733122, -0.8223481390451454],
            [9.988931662023802, -0.8122472996602136],
            [9.987102753877632, -0.8074623882803756],
            [9.984131452133251, -0.8047732361247042],
            [9.983336796306588, -0.8004644030127692],
            [9.99806232621268, -0.7989428458372625],
            [10.027299399296302, -0.7700546644469689],
            [10.047062462158715, -0.7690340604710466],
            [10.050745889655733, -0.7679832424469452],
            [10.05160046428345, -0.7641314597332024],
            [10.056042120745632, -0.7631870321731399],
            [10.054750812315543, -0.7600268101835764],
            [10.056729037277407, -0.7540922832199991],
            [10.053715234320808, -0.7488690671356422],
            [10.107312630869632, -0.7520034199565071],
            [10.130717459696285, -0.7510366682551654],
            [10.13832259975433, -0.7497615758674783],
            [10.1408052694811, -0.7460451272048868],
            [10.140407551380406, -0.7388257392764409],
            [10.144079516225018, -0.7305021878585011],
            [10.155079716358276, -0.7261406372163033],
            [10.155917415448975, -0.7320298641456137],
            [10.162336592402218, -0.736951479645505],
            [10.16860678474942, -0.7385663910918646],
            [10.175167776217469, -0.7472657608467225],
            [10.174927988205624, -0.751616747598329],
            [10.177775203771963, -0.7541595214781215],
            [10.180892119869883, -0.7526527521778313],
            [10.184213463691648, -0.7566301475761202],
            [10.185098081997653, -0.7663307490411309],
            [10.188552406820826, -0.7659281841285276],
            [10.190501269794556, -0.7725983649735946],
            [10.193385120900372, -0.7735442655563382],
            [10.196503617442172, -0.7712017053176625],
            [10.197063516542126, -0.7785131338459982],
            [10.205859417754324, -0.7831792124206242],
            [10.207662613575136, -0.786311225929272],
            [10.21150459554042, -0.7845197708861861],
            [10.213639842344666, -0.7866080736158708],
            [10.218624316959685, -0.7824329681785931],
            [10.22062674603444, -0.785256481416819],
            [10.226269049899184, -0.7877664615622076],
            [10.22594078556063, -0.7949401525917859],
            [10.229821995709433, -0.7991244669196612],
            [10.234687331983203, -0.7999417765902194],
            [10.234172684914942, -0.8079975204614838],
            [10.238659205316948, -0.8065782449033275],
            [10.245053665681718, -0.807840365490079],
            [10.250022673277986, -0.807524934674496],
            [10.254512276657584, -0.8050624485920266],
            [10.262754561611997, -0.815541503598827],
            [10.267088395612253, -0.8128360900942806],
            [10.272112901430347, -0.8154826500791159],
            [10.275899755464648, -0.8134589525488859],
            [10.279770378832627, -0.8146809240195876],
            [10.27902730708373, -0.8181429979652572],
            [10.281999847297024, -0.8222353580045659],
            [10.281889632710879, -0.8286568745612711],
            [10.28494969250819, -0.8335462320250138],
            [10.269116549471986, -0.84034037102269],
            [10.291308424366527, -0.8649530363872142],
            [10.260027395848219, -0.9064585126385303],
            [10.266468979133096, -0.9549518163082655],
            [10.28106646204961, -0.9692801834808624],
            [10.27025413106407, -0.9949560378347775],
            [10.27628724243926, -0.9930828900174158],
            [10.28236700909499, -1.002701750798972],
            [10.283138452817251, -1.0075418392219828],
            [10.281618173921318, -1.0113368342329707],
            [10.284244435207906, -1.0146523866525377],
            [10.28247114116277, -1.0178117085828478],
            [10.285051039167412, -1.0222371853256575],
            [10.282807421639552, -1.0256407542702335],
            [10.280174536264733, -1.0249012382805058],
            [10.279300979568571, -1.0301178937991882],
            [10.28500855023532, -1.0304094272730453],
            [10.286747370633552, -1.037614652102019],
            [10.291641084518046, -1.0359693521715492],
            [10.29438352491418, -1.04306958264974],
            [10.298745300165638, -1.0500660178275862],
            [10.302702921121433, -1.0497513299943095],
            [10.307385760809229, -1.0541826647059753],
            [10.307223389967698, -1.0575420936385307],
            [10.313357108384228, -1.0663658926305595],
            [10.304483082821523, -1.0727139215487087],
            [10.323361336148805, -1.1312942151316072],
            [10.314381289969218, -1.1334569573890263],
            [10.305682622871053, -1.1290169196890345],
            [10.257959247521036, -1.1223179700789565],
            [10.253498034422158, -1.123248738283889],
            [10.245210188106567, -1.12707675416783],
            [10.240793049120004, -1.124881406836384],
            [10.239548054922633, -1.1207368866537277],
            [10.236092644434411, -1.1187502358795918],
            [10.230483810738383, -1.123030923395635],
            [10.22196058310184, -1.1205932173314084],
            [10.21701181850232, -1.1238844128254084],
            [10.213633528353526, -1.120779045739463],
            [10.210700458023036, -1.1203998215258182],
            [10.204321025710502, -1.1125408637125997],
            [10.199370020192456, -1.1088900300570252],
            [10.18953414851265, -1.110450228997042],
            [10.188601360827247, -1.1057768482915757],
            [10.18456113246944, -1.1076382322755964],
            [10.180940606499219, -1.1041447879910806],
            [10.178619315640017, -1.1063947131002934],
            [10.172705276054927, -1.1053008573365142],
            [10.170933966312095, -1.1021811229576164],
            [10.167174882700927, -1.1028311863385145],
            [10.162408259495956, -1.0973686310271709],
            [10.159483151015806, -1.0983812025372697],
            [10.157574764184382, -1.0941897830731673],
            [10.150488664846996, -1.096180569562529],
            [10.148302497198243, -1.0885455564874604],
            [10.1428300327387, -1.0900970224949031],
            [10.137960139500573, -1.0887521213040503],
            [10.13629031501839, -1.0865785512259918],
            [10.13775537166267, -1.0761159832377465],
            [10.132081850289884, -1.0728839254487792],
            [10.126932066479114, -1.0682388546057067],
            [10.122323026466187, -1.0680065739269708],
            [10.116043156766734, -1.0750142950763943],
            [10.11190874621332, -1.0743971884805399],
            [10.111428711686795, -1.0774948272593068],
            [10.104777326412274, -1.0817551952329316],
            [10.102892978824315, -1.0770629203971271],
            [10.099513067475915, -1.0745346524389106],
            [10.099557744374208, -1.0676110344174092],
            [10.10220934403292, -1.0660578807338636],
            [10.102544844540306, -1.0597897901029139],
            [10.09786094250306, -1.060413715654461],
            [10.093764998042255, -1.063606965664142],
            [10.089295733083109, -1.0640733138306953],
            [10.079102116129006, -1.0670166383191235],
            [10.07764172863378, -1.0693894122837373],
            [10.07157906952066, -1.0741805248792153],
            [10.065896625444797, -1.075796198491575],
            [10.058248052002444, -1.0716347051323394],
            [10.058441504194533, -1.0691129962983699],
            [10.062049487458195, -1.0627713167235668],
            [10.058917015529314, -1.062616851980486],
            [10.054813907947976, -1.059596692923216],
            [10.051952876527453, -1.06328403990453],
            [10.046997702455604, -1.0606387577979293],
            [10.037521985902151, -1.0627155786998967],
            [10.036985321088595, -1.0576892468512655],
            [10.034813397369234, -1.0518937779096973],
            [10.024054466218676, -1.0517612830233019],
            [10.023399450502769, -1.0484081437021942],
            [10.017938842293255, -1.0442209277187624],
            [10.012847190325994, -1.046250682583247],
            [10.012227847702093, -1.0407728421375595],
            [10.008602053914107, -1.0331825060818702],
            [10.009780278671059, -1.0307089124431885],
            [10.013988021884561, -1.029982362554626],
            [10.017668942918785, -1.024379551569401],
            [10.01948518255676, -1.0263542693853458],
            [10.024282599643174, -1.0190912280309938],
            [10.026258368541193, -1.0143865647132622],
            [10.021665206579549, -1.009157090040715],
            [10.021324172900476, -1.0021145929974378],
            [10.0159074047089, -0.9987748416695884],
            [10.008027920188054, -0.9987540683982592],
            [10.008911147444993, -0.9935700099745846],
            [10.004603334154577, -0.9892690692793887],
            [9.999994254021008, -0.9916793846346298],
            [9.991403030548186, -0.9994010027874501],
            [9.986624702226152, -0.9976132495384101],
            [9.982282936427575, -0.9983098198521853],
            [9.97932702700974, -1.0016452607714186],
            [9.974375874822607, -1.0002594851400128],
            [9.967571920410968, -0.9936261710017732],
            [9.9649890212759, -0.9897503836912325],
            [9.96634425280247, -0.9842097191372214],
            [9.961037459737307, -0.9749106932499225],
            [9.951229652578235, -0.9623258787940892],
            [9.936870554033808, -0.9499877957145074],
            [9.933201421327023, -0.9488630184835642],
            [9.932195507114539, -0.9414912569548856],
            [9.941385027509963, -0.9334005308002283],
            [9.942215026065702, -0.9267688423233309],
            [9.945163701452934, -0.9254984699046171],
            [9.94405847567471, -0.9188812576207019],
            [9.945780952426999, -0.9137600462704442],
            [9.949742901044079, -0.9128009380481392],
            [9.950529998367696, -0.9084115424079366],
            [9.942300539309471, -0.8630998086910896]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.71462671652752, "lat": 37.15967781043844 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21051"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00516872"
      },
      "bbox": [
        9.932195507114539, -1.1334569573890263, 10.323361336148805,
        -0.7261406372163033
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.357446403991625, 0.07211748067768206],
            [10.359951675953965, 0.07730757721240232],
            [10.367312486776457, 0.08849346982231637],
            [10.371382906335462, 0.08920095931934734],
            [10.377485874487409, 0.09266659453247544],
            [10.384510763831514, 0.09182783157489338],
            [10.387008878093695, 0.09354746026665482],
            [10.38794861733091, 0.10771970693297762],
            [10.386333839476746, 0.11006509459091328],
            [10.388095733090816, 0.11420020056707336],
            [10.386412076739687, 0.11978488026320483],
            [10.390547116877373, 0.12660842495145747],
            [10.398350999687455, 0.13068364952542993],
            [10.399300098281897, 0.1341394213023638],
            [10.39410375861528, 0.1383401117872912],
            [10.386026260101945, 0.13883521303917884],
            [10.377746669872248, 0.1343728827820372],
            [10.374999506115179, 0.13620355411859308],
            [10.368599471066386, 0.13714130925350893],
            [10.364657722432273, 0.13495410817976167],
            [10.359766628185186, 0.13852459565613287],
            [10.352450706124543, 0.14095308124110548],
            [10.351580581102024, 0.1453721252317568],
            [10.360596263706999, 0.1439872070402865],
            [10.361700113426437, 0.15114576506486085],
            [10.370117863777738, 0.15301038326929112],
            [10.369887112678114, 0.15875077449111652],
            [10.37737824719345, 0.1710643539842333],
            [10.375827317768602, 0.17258077087105111],
            [10.374031236505822, 0.1824993649725274],
            [10.37579540226584, 0.19376771660217298],
            [10.377644312660152, 0.19900899883780018],
            [10.38144044379769, 0.20460160358556623],
            [10.386640931545681, 0.20884903813145694],
            [10.385790635188746, 0.21337043371620368],
            [10.389996939825613, 0.2125147249332985],
            [10.395052709426471, 0.21447691982953165],
            [10.398616287270329, 0.21746401133903046],
            [10.398023397181772, 0.2231595750320187],
            [10.40384751806983, 0.22686640078993742],
            [10.404487554392711, 0.23282207082587583],
            [10.41383437390911, 0.23289107100502304],
            [10.418988538375226, 0.2311794244181695],
            [10.421508907147407, 0.22692700626679704],
            [10.439228267788522, 0.21226207561034674],
            [10.45165832635769, 0.20587108387155392],
            [10.454724920970653, 0.20842542718036888],
            [10.462561688990036, 0.20678885195838537],
            [10.467282386735684, 0.19978035778631661],
            [10.47423398359086, 0.202707171973741],
            [10.481422121948073, 0.19833183097231724],
            [10.481108330000195, 0.19553299319657344],
            [10.488117803857188, 0.18713940938548876],
            [10.48967892149886, 0.18299074442611774],
            [10.493262385268343, 0.18130611267275282],
            [10.501136999764585, 0.1754983592713338],
            [10.503817647894428, 0.16970933156966697],
            [10.50956051030713, 0.16837216641121613],
            [10.508147986152967, 0.16327596373285228],
            [10.511519654615613, 0.1613989001485216],
            [10.514870736322335, 0.1664511606810011],
            [10.513298416177463, 0.1728811435674721],
            [10.516153274225228, 0.17506251800234113],
            [10.518397213593884, 0.17992039227330778],
            [10.5211307500412, 0.180224166762369],
            [10.527447512906413, 0.1770641988965293],
            [10.531095180734034, 0.1788750202352547],
            [10.539419385732113, 0.18899008056832484],
            [10.539960871483956, 0.1823676480897929],
            [10.544651938286817, 0.1759510024352707],
            [10.549459039368978, 0.17691721832113488],
            [10.55908770817157, 0.17458052896238238],
            [10.558591415372586, 0.16977015548533006],
            [10.559811610092048, 0.16527573010618254],
            [10.57162415582833, 0.15901596921844416],
            [10.574483189303276, 0.16104434308341437],
            [10.585727617954735, 0.1635769538239684],
            [10.591437037154755, 0.16185382379362487],
            [10.59581853079904, 0.1586243189767166],
            [10.597409705103146, 0.16033263427483263],
            [10.610465757004839, 0.16756230387525073],
            [10.6111395762926, 0.1660275366274272],
            [10.618454064709702, 0.16573977287313207],
            [10.616616801492832, 0.1628214021446009],
            [10.618939549306775, 0.15575107479263448],
            [10.626104267080423, 0.1509727755604398],
            [10.626776841366034, 0.1398426294127544],
            [10.630028964912386, 0.1375388632533803],
            [10.629339240537567, 0.13295753421063825],
            [10.630224907010861, 0.1273916389134057],
            [10.634536642317586, 0.1267794103258822],
            [10.64020488812994, 0.11566624540879304],
            [10.643465772028518, 0.11642054656132216],
            [10.644187321438562, 0.11101233221800726],
            [10.64691995196798, 0.10811701323719168],
            [10.641685929980795, 0.10271312146615551],
            [10.640824352251606, 0.09851255393395326],
            [10.635599718443522, 0.09852502469433656],
            [10.634095848969597, 0.0943293339376569],
            [10.634796046247482, 0.09000491982532965],
            [10.626968751804448, 0.09234870703031238],
            [10.624277154247089, 0.08511799248634996],
            [10.62176667626119, 0.08544628943662337],
            [10.618535004102563, 0.08079271606780064],
            [10.620445066117556, 0.07865219323012981],
            [10.618509698233908, 0.07511905237744597],
            [10.61069075423926, 0.06816862950803201],
            [10.612399387867097, 0.0625329548259324],
            [10.610909674965255, 0.05921364732773629],
            [10.612557735446094, 0.05474498556615277],
            [10.60955146778411, 0.05096122081358917],
            [10.605980207193438, 0.04926480368772159],
            [10.608106788379947, 0.04587139996634727],
            [10.603744068100005, 0.03868124014017163],
            [10.599326931292216, 0.03774103659748141],
            [10.595752719469171, 0.04004187415242122],
            [10.592520843420402, 0.039098472217722835],
            [10.58885671274799, 0.03531269579995814],
            [10.58420681336676, 0.03639130116896374],
            [10.582104059903372, 0.03124011811229292],
            [10.583308359652099, 0.029430542836090277],
            [10.578208078493477, 0.02428443922379206],
            [10.5731299912657, 0.023004155264686636],
            [10.570096030274508, 0.018751781557940026],
            [10.572361054673161, 0.013226738662127995],
            [10.571362217401443, 0.00797726223621458],
            [10.566492688257995, -0.000009449578449753416],
            [10.563459820355051, -0.0003918408360088229],
            [10.563349482711452, -0.007826678861411472],
            [10.558524582696586, -0.010925974177353217],
            [10.553988525832894, -0.008647128656813918],
            [10.550694213543084, -0.011704838919279668],
            [10.548207574276864, -0.018543176814058347],
            [10.539442456681469, -0.02400926288679917],
            [10.536011822658987, -0.022219861175885466],
            [10.530121305209457, -0.016018631566805507],
            [10.52498605575336, -0.014607061614962044],
            [10.518182555300264, -0.020747722925576608],
            [10.51584467775354, -0.016634943345849102],
            [10.503417411998068, -0.017635890084803364],
            [10.500345998804457, -0.015726617952838733],
            [10.49664054044864, -0.016646485944730033],
            [10.494878957595036, -0.020511259462726444],
            [10.491151271977374, -0.023359089728700096],
            [10.4831376195773, -0.024082241332239733],
            [10.475223918076827, -0.025740749336174974],
            [10.470584041988978, -0.025770422945609404],
            [10.467375908455887, -0.03337891442304196],
            [10.46294836816433, -0.03109935013013336],
            [10.457669570430348, -0.021250124411167182],
            [10.45279028205236, -0.0242004836444606],
            [10.446063540287614, -0.02155894279190277],
            [10.439882698399517, -0.017059333706454263],
            [10.438403501067832, -0.02142211576424987],
            [10.432549436469854, -0.02194955360716519],
            [10.42480754819826, -0.025504309990020627],
            [10.42269927848016, -0.0228979770911082],
            [10.417998042253318, -0.023152842819708152],
            [10.410029335696771, -0.015694410368951035],
            [10.408701890801158, -0.010895090823679196],
            [10.401826720768526, -0.011761205037934031],
            [10.40072031671277, -0.00046316336169653063],
            [10.398305853238298, 0.0048484993133422905],
            [10.391972653955682, 0.006371596714907638],
            [10.389546869384985, 0.011714513438820713],
            [10.384880971340168, 0.01271449384591427],
            [10.38357388078449, 0.010245204838994592],
            [10.376462440681069, 0.008278336212157683],
            [10.371023575089168, 0.011970926497985977],
            [10.361772849410308, 0.015194845560617207],
            [10.361202488582634, 0.01894822776479977],
            [10.3578388933536, 0.0251110269076755],
            [10.357368191472698, 0.032352455716628266],
            [10.359412911951358, 0.037631062578845],
            [10.359271161896402, 0.044313625986394434],
            [10.360771158898313, 0.04641210997121009],
            [10.35973177582703, 0.05125775192295265],
            [10.361305206185195, 0.0556211314752216],
            [10.3607730386884, 0.05922374966822937],
            [10.353438796424893, 0.06514976535603255],
            [10.357446403991625, 0.07211748067768206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.0975300197593, "lat": 38.11789910915031 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21063"],
        "coty_name": ["Elliott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elliott County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00516878"
      },
      "bbox": [
        10.351580581102024, -0.03337891442304196, 10.64691995196798,
        0.23289107100502304
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.582033780170395, -0.8498122621907479],
            [8.578514112314672, -0.8411875694313047],
            [8.575425019176246, -0.8403182224110456],
            [8.57411551679503, -0.8356854371610684],
            [8.576179169433614, -0.8334104995332079],
            [8.580991486603851, -0.8240879705890486],
            [8.589011352420773, -0.8212549886563487],
            [8.59344596462705, -0.8159817125945223],
            [8.591377590951929, -0.8105809730114873],
            [8.593807699095196, -0.8051571656508939],
            [8.594540627231627, -0.7979790108296992],
            [8.599216564309076, -0.7979788448115894],
            [8.603450877137625, -0.8011044983776037],
            [8.607835241330825, -0.8001372913557251],
            [8.608662041953462, -0.8032056026951788],
            [8.614256667554486, -0.8073201853348284],
            [8.617168264784008, -0.8063251359061813],
            [8.619236742388292, -0.799576819009895],
            [8.626857763303134, -0.7958648558487628],
            [8.629132853782592, -0.7967656157234366],
            [8.634465032685826, -0.7953888437765484],
            [8.63463703541465, -0.8089388209557286],
            [8.637934362441797, -0.8126483066823774],
            [8.637332727973435, -0.8186009865128985],
            [8.6348508768734, -0.8220249703255438],
            [8.6355191895291, -0.8275747999489661],
            [8.637876847022312, -0.8334365104670399],
            [8.728669906963187, -0.892897172048111],
            [8.72742123803642, -0.8931771538250723],
            [8.763440639149707, -0.9375391995375372],
            [8.767565868825159, -0.9489730898509517],
            [8.771879971801818, -0.9475731997834006],
            [8.808256725810459, -1.0001823223744029],
            [8.810172776804242, -1.0022656215480676],
            [8.812008429503564, -1.0088807863354545],
            [8.810516729037207, -1.0117452400799514],
            [8.801058844895355, -1.0139616423948996],
            [8.798513188103556, -1.016466281939871],
            [8.796300231692237, -1.0256049443035897],
            [8.800586549449974, -1.0287226594955163],
            [8.812538514193479, -1.027133268098253],
            [8.816000906049249, -1.0251887780746054],
            [8.827773701268644, -1.0264514167857626],
            [8.846020803659734, -1.053741167820817],
            [8.827186696661938, -1.0803587022207244],
            [8.787796609629893, -1.1086460234072129],
            [8.751987167140038, -1.129873402773766],
            [8.718722869852789, -1.1522349227299635],
            [8.667663898676986, -1.1509104523220395],
            [8.63423671606843, -1.1456834712636481],
            [8.609827313961391, -1.1300898561944572],
            [8.585441900033553, -1.092749360984522],
            [8.583924046848372, -1.0242947515521146],
            [8.584117731577155, -1.0205078728774264],
            [8.581756468401958, -1.0151704202150738],
            [8.582620167788216, -1.012903951382087],
            [8.588159316946996, -1.0073397998770357],
            [8.588938387006612, -1.004286220040406],
            [8.581088688526183, -1.0036279730115392],
            [8.580695308928945, -0.9960722122156324],
            [8.577123141792562, -0.9859897575966695],
            [8.572201930239078, -0.9827214687322982],
            [8.5699154371573, -0.977896583277474],
            [8.563891954551709, -0.9738267095589049],
            [8.565244418677295, -0.9225339046758635],
            [8.56666023439534, -0.9131294214129871],
            [8.576685196410411, -0.8941338611911089],
            [8.581522072213243, -0.891894607240002],
            [8.58429508298222, -0.8872498604677806],
            [8.584666850354122, -0.8833639405927245],
            [8.589369672323622, -0.8796385547878323],
            [8.589465936200678, -0.8747273814857138],
            [8.587966570985255, -0.8682659676401566],
            [8.582173560253615, -0.8589198481794936],
            [8.583468671755815, -0.8544505507606863],
            [8.582033780170395, -0.8498122621907479]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.55312622356006, "lat": 37.26402969997414 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21087"],
        "coty_name": ["Green"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Green County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00516890"
      },
      "bbox": [
        8.563891954551709, -1.1522349227299635, 8.846020803659734,
        -0.7953888437765484
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.592369546496762, -0.15692892770593822],
            [10.61071987590818, -0.1724833637616276],
            [10.609291178845462, -0.17553241198311903],
            [10.613570156789459, -0.1783056131920033],
            [10.610231761569992, -0.18446188004129493],
            [10.612921162699168, -0.18814733925924873],
            [10.609624103672653, -0.1967870610498494],
            [10.611705457797855, -0.20029336136515866],
            [10.615684859750166, -0.20326181936759555],
            [10.643161559847957, -0.21568868566826277],
            [10.654897642008619, -0.28634405658294965],
            [10.655312657544592, -0.2903255864097898],
            [10.661616223766178, -0.2930558066903058],
            [10.66269759135109, -0.31179090412687516],
            [10.662960240186063, -0.3320152719888439],
            [10.666952059959716, -0.3354666392770537],
            [10.667014805308689, -0.3404530522146208],
            [10.670611036709964, -0.3403706634699065],
            [10.67238376605235, -0.343947247998892],
            [10.684003088645186, -0.350715794292662],
            [10.687060304565573, -0.3531254228613035],
            [10.692301924903575, -0.3527672706855495],
            [10.695628780956039, -0.356776470360823],
            [10.693212616399146, -0.3600300130518586],
            [10.700286802983578, -0.3659816767642914],
            [10.700024127651139, -0.3748220909431374],
            [10.70426564528933, -0.37823020567910554],
            [10.704496877791518, -0.3840253459262247],
            [10.702290705970277, -0.38672085691964336],
            [10.703615980782688, -0.39911811685303095],
            [10.70753810037766, -0.40576545642057327],
            [10.706970207602941, -0.4107181885666923],
            [10.713674488610595, -0.4161832933634436],
            [10.714339104987145, -0.42432521911716664],
            [10.710918964201813, -0.4283432355687355],
            [10.716962224058223, -0.4375995132349214],
            [10.722964917882676, -0.4392243247343362],
            [10.722530876015362, -0.44777259422313737],
            [10.724949922845147, -0.44906893640073103],
            [10.724976354178358, -0.4598388965108282],
            [10.728880362589207, -0.4623266982627744],
            [10.734242091408321, -0.46261977737894566],
            [10.734621420411095, -0.46739834392961144],
            [10.724657528746807, -0.4718086939778288],
            [10.725745508807584, -0.47743082552917454],
            [10.724593459789872, -0.4825217598513979],
            [10.727145452490195, -0.4850658703644351],
            [10.723283600509196, -0.49017497174882474],
            [10.724997288332524, -0.495718434482226],
            [10.720528866367955, -0.49742090769109243],
            [10.717200877361282, -0.5019671800121165],
            [10.715132050089938, -0.5069830069070685],
            [10.71701171343848, -0.5145923439247727],
            [10.712036635273154, -0.5182695968368424],
            [10.708134372026358, -0.5165215315911947],
            [10.705314266682326, -0.5212821135698458],
            [10.70229982907077, -0.5173221254612178],
            [10.69628531097113, -0.5176588656341073],
            [10.692737364201816, -0.5198569541679146],
            [10.69134390648386, -0.5132270169372608],
            [10.688256770564044, -0.5125661193079495],
            [10.68866187151862, -0.5083878320050801],
            [10.68504552792831, -0.5071210922799357],
            [10.67972697739539, -0.5043238065841524],
            [10.682296430405751, -0.4980963747239427],
            [10.676512257707891, -0.4968719146231543],
            [10.674097692860098, -0.49325942731500827],
            [10.669675446000426, -0.4938841129193567],
            [10.667038277479291, -0.4914937704991756],
            [10.659628687875987, -0.4930212823493338],
            [10.6439060923019, -0.4871440191221687],
            [10.637752213023296, -0.4767074948518697],
            [10.638344927829266, -0.47046332263069096],
            [10.632425283725008, -0.4664188566141924],
            [10.629817863324131, -0.46749604970846254],
            [10.625023723947248, -0.46488839891619727],
            [10.623510062363994, -0.46236277184781],
            [10.627104658319194, -0.457447042367422],
            [10.62208843155267, -0.4497541211387956],
            [10.625792978605759, -0.4468821829524229],
            [10.627277551648291, -0.44010061492583313],
            [10.62380969055575, -0.4357195860043676],
            [10.619332551795816, -0.4326432124249767],
            [10.617658044966763, -0.4351452824352778],
            [10.611791014776234, -0.42901720937519444],
            [10.603702562815748, -0.43562034230861696],
            [10.599300346144721, -0.4291497616670143],
            [10.595796613119079, -0.43046809874000647],
            [10.590836551596004, -0.42624152690859657],
            [10.588003089077526, -0.42871107643614964],
            [10.585597706881975, -0.42659451035973434],
            [10.587647825851557, -0.42333853455030873],
            [10.585036527312706, -0.42059075353942366],
            [10.581300993131292, -0.4112119845756288],
            [10.578905090771068, -0.4155435403032878],
            [10.574416247432445, -0.4139412629246345],
            [10.573909938237442, -0.40796874048098397],
            [10.571115815957516, -0.4029636364358227],
            [10.566298283377392, -0.40375519968433304],
            [10.565273135307358, -0.39900941575483145],
            [10.562397741637703, -0.3948917066614556],
            [10.556509240940287, -0.3950535412220967],
            [10.557210054797261, -0.4002279228247173],
            [10.555654294528091, -0.404519229764371],
            [10.548961277499467, -0.4056290474690599],
            [10.544647618829948, -0.40963712227296656],
            [10.540976678122696, -0.41658404627788825],
            [10.536395066085115, -0.4152959573970421],
            [10.533045191123202, -0.42169002241127207],
            [10.526340345145185, -0.42353089756756945],
            [10.523831616342166, -0.41859153932366805],
            [10.518695327806133, -0.4117769707269798],
            [10.51129123525832, -0.40589842755351974],
            [10.509191020484257, -0.4001816683360784],
            [10.50597489297836, -0.40319422414822637],
            [10.5019840426796, -0.3994953204428573],
            [10.496083280276864, -0.3985238842413118],
            [10.484955014139034, -0.3912025506623027],
            [10.482031789443981, -0.392129059058712],
            [10.480946178636096, -0.3958633289900025],
            [10.47607166724475, -0.3940317622881448],
            [10.472867641054915, -0.38894091304663697],
            [10.469771125312198, -0.3927925875890408],
            [10.465815767810094, -0.3928178522249273],
            [10.461514838115004, -0.388414228037707],
            [10.455923229304535, -0.3899862136899776],
            [10.446692804650624, -0.3839977589604638],
            [10.44194123778183, -0.3789041756759088],
            [10.437887571175596, -0.37302319303549347],
            [10.431065674817235, -0.3751172663990685],
            [10.428929385308978, -0.37246390962619247],
            [10.428159306404634, -0.3698818878295399],
            [10.422855700900811, -0.36743367810777394],
            [10.419980683764399, -0.3628001224847188],
            [10.419990881393378, -0.35752266879679817],
            [10.424054531286126, -0.35341322789758267],
            [10.424770774921504, -0.3496035068975297],
            [10.42889101939777, -0.3423700663293855],
            [10.424277073303358, -0.34119446169081147],
            [10.418843194697121, -0.3353635770722613],
            [10.414475899927174, -0.3358476531745054],
            [10.412650293008845, -0.3308034660213724],
            [10.411396018682455, -0.3243382499081232],
            [10.41199792838407, -0.31741285388533585],
            [10.417639434902984, -0.31796331344206524],
            [10.419660121358888, -0.3128719977685494],
            [10.417857329814971, -0.3076882988182639],
            [10.424545454097471, -0.3030540160467724],
            [10.422528638368238, -0.29674989829089227],
            [10.398965339076252, -0.2774337104787781],
            [10.40318272246735, -0.2743465064860867],
            [10.40496745018533, -0.26879614973057175],
            [10.407093120894674, -0.2685930540751087],
            [10.413116146248031, -0.26331233050963077],
            [10.414334891381888, -0.25642670469773987],
            [10.418283018200947, -0.25573876741918367],
            [10.419339404348191, -0.2525676865840057],
            [10.423216983897731, -0.2513122348006014],
            [10.424598963442975, -0.2480634157562655],
            [10.431970478983597, -0.24772410420575228],
            [10.429707977444222, -0.24364731404088674],
            [10.434472037803822, -0.23574043979767215],
            [10.434766074188518, -0.22882839198690988],
            [10.437132758730783, -0.22645273215245618],
            [10.440399373078478, -0.21858584376759768],
            [10.447169759825004, -0.21699821476418038],
            [10.452762625762064, -0.21898853486723216],
            [10.460416009326812, -0.215541420097027],
            [10.462862358104914, -0.21311523643606245],
            [10.465470547714915, -0.2051496563037348],
            [10.464980407218468, -0.2024524462761472],
            [10.477803237405027, -0.1905650568729444],
            [10.507560808691414, -0.16358039407333136],
            [10.48968305007113, -0.13687767531034023],
            [10.493163252362143, -0.13440389116327758],
            [10.50631553670792, -0.1350675178557271],
            [10.508382095044752, -0.13267576717720225],
            [10.513999827763758, -0.13586733436032472],
            [10.522463402832429, -0.13482314040435656],
            [10.526242406740606, -0.13746509028203502],
            [10.534886332542, -0.1401282952062119],
            [10.535005468144279, -0.14239405914422543],
            [10.544986882352172, -0.14942312821240764],
            [10.550484060032563, -0.15156677094552637],
            [10.561238508074167, -0.147941611241751],
            [10.558806364134373, -0.14215751287889103],
            [10.561939368540335, -0.14162885105231646],
            [10.561738433977226, -0.13565079120878154],
            [10.565589493237555, -0.13307349590599757],
            [10.568419641300316, -0.13808111539109508],
            [10.576469193283186, -0.1431046010384385],
            [10.57812434809769, -0.1500510934460593],
            [10.584345527744585, -0.15366062288901142],
            [10.592369546496762, -0.15692892770593822]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.06495618522824, "lat": 37.70648237059447 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21153"],
        "coty_name": ["Magoffin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Magoffin County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00516920"
      },
      "bbox": [
        10.398965339076252, -0.5212821135698458, 10.734621420411095,
        -0.13267576717720225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.406990146251981, -1.541271064371087],
            [6.405197408653821, -1.5263675770659284],
            [6.4013756485150575, -1.481965165579352],
            [6.402256710269123, -1.4712010716599844],
            [6.401475076797243, -1.4602314328219246],
            [6.409981322717128, -1.457371915231018],
            [6.417500487072198, -1.4533068972365544],
            [6.427328804411609, -1.4456601162709275],
            [6.435271825569405, -1.4338778606147518],
            [6.4437502905551325, -1.429010380976309],
            [6.454340830164713, -1.4251131724662665],
            [6.469111858550945, -1.4212995663768522],
            [6.478727181091029, -1.4175741220611275],
            [6.486848589614313, -1.4121913054270512],
            [6.493336602262545, -1.4109917608857898],
            [6.501817684666385, -1.4127206727932844],
            [6.511570845082119, -1.4122871458013706],
            [6.5242161623559936, -1.4177239606993322],
            [6.5329645724415135, -1.4203291558031135],
            [6.539621480923269, -1.424993796324303],
            [6.549934295173659, -1.4383457852246726],
            [6.566415244136324, -1.4525059016844717],
            [6.5733591326634055, -1.4627569646238698],
            [6.581285237693734, -1.4713889762800785],
            [6.5873923918689075, -1.4761382194393102],
            [6.596022882238713, -1.4857361664554805],
            [6.602400439248525, -1.4947095581218812],
            [6.609549923771344, -1.502602429701873],
            [6.617567637853168, -1.509059309939],
            [6.628401601724234, -1.5163888760134583],
            [6.634368377701486, -1.5221103319727782],
            [6.640065076158503, -1.529073945346299],
            [6.642856970879104, -1.534699657516921],
            [6.646266447075092, -1.5470687812091535],
            [6.646359875082348, -1.5505144733490932],
            [6.650130629141247, -1.5634085627453684],
            [6.655701222381189, -1.5708068517750344],
            [6.663269837695323, -1.584007707776602],
            [6.671034601564275, -1.5957546159433766],
            [6.677705176282722, -1.6091266090139653],
            [6.680093350035663, -1.6160685235163368],
            [6.686125964502181, -1.627611005792166],
            [6.698140973815151, -1.655207254555506],
            [6.700484899480254, -1.662963328997324],
            [6.703698789885182, -1.678580364073164],
            [6.710846742964371, -1.6940840359800124],
            [6.713831428262266, -1.6982157450911657],
            [6.714078655757999, -1.7049870857466045],
            [6.717814581906869, -1.713430856550966],
            [6.716012856637085, -1.7144515424938789],
            [6.697696272192702, -1.7135721136498037],
            [6.687269199138841, -1.7144610231050772],
            [6.628564367416474, -1.7178591111449437],
            [6.607874461158598, -1.7198984396356298],
            [6.568392419589794, -1.7227923610365978],
            [6.4926432411072765, -1.7286873182759628],
            [6.478060372312062, -1.7294173467235676],
            [6.464079422724293, -1.731452086735505],
            [6.449467831236895, -1.7316706344764818],
            [6.421024140390063, -1.7343051109292045],
            [6.41911190863688, -1.7097982987233298],
            [6.413760328426006, -1.6302133912185084],
            [6.409134255216986, -1.5716351510786561],
            [6.406990146251981, -1.541271064371087]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.32937382958431, "lat": 36.88343220458651 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21157"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00516922"
      },
      "bbox": [
        6.4013756485150575, -1.7343051109292045, 6.717814581906869,
        -1.4109917608857898
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.54152235152275, -1.110329074691228],
            [8.585441900033553, -1.092749360984522],
            [8.609827313961391, -1.1300898561944572],
            [8.63423671606843, -1.1456834712636481],
            [8.667663898676986, -1.1509104523220395],
            [8.718722869852789, -1.1522349227299635],
            [8.726654540619558, -1.1941282376737823],
            [8.748301077969469, -1.2523233880575793],
            [8.802936569120547, -1.3006920398519648],
            [8.796794063079497, -1.3175644737892473],
            [8.784123500666118, -1.3639821973207464],
            [8.760947522030717, -1.3932782614815424],
            [8.738221804084837, -1.4011956088613884],
            [8.720779637251255, -1.4146281866482875],
            [8.707796856148416, -1.403064695778453],
            [8.703172525918191, -1.3981866942462517],
            [8.69779505129889, -1.3969118337560633],
            [8.69597922540079, -1.3946439662014862],
            [8.688287142253156, -1.3952872103366505],
            [8.687927444734886, -1.400101269593427],
            [8.691279738111945, -1.4017141171890621],
            [8.693668319658372, -1.4109022469987653],
            [8.69768238065469, -1.4132636189000418],
            [8.701370985001764, -1.419048074066317],
            [8.71117108803335, -1.4284976758065855],
            [8.707721673822155, -1.4444661281085311],
            [8.69643675185687, -1.450631584371874],
            [8.690273128183405, -1.4395959991633283],
            [8.681405729944123, -1.4373615325953157],
            [8.581139436417825, -1.4394153167015715],
            [8.56456559291405, -1.3374099103659705],
            [8.55449115513282, -1.2753604313751283],
            [8.548267521622163, -1.2548293254048741],
            [8.540702111129301, -1.2132185737414958],
            [8.537978133240987, -1.1821732717207607],
            [8.538724974081962, -1.1715353665201669],
            [8.53350814828873, -1.170132700549716],
            [8.526422938781081, -1.1729687183199382],
            [8.519247127741865, -1.1447084416985092],
            [8.531805042580554, -1.131253928172862],
            [8.54152235152275, -1.110329074691228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.6292247776566, "lat": 36.9905334869895 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21169"],
        "coty_name": ["Metcalfe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Metcalfe County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00516931"
      },
      "bbox": [
        8.519247127741865, -1.450631584371874, 8.802936569120547,
        -1.092749360984522
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5699372004774284, -6.535929457149976],
            [3.5646268756291883, -6.404887676620091],
            [3.6846938338762647, -6.400657710469136],
            [3.6884828051799006, -6.400664746740082],
            [3.6896585530081176, -6.405486564286184],
            [3.6936948285415365, -6.409496557232392],
            [3.6995010838580864, -6.413174142025813],
            [3.6994419085909036, -6.41808431854754],
            [3.73837458692367, -6.41661087745565],
            [3.737483396429823, -6.3984948062952505],
            [3.797994079208524, -6.395656243373597],
            [3.832554761658728, -6.394656906434241],
            [3.8340090069866966, -6.401071145661282],
            [3.834145358293049, -6.407633477749987],
            [3.827635375026089, -6.41295632384706],
            [3.8278826977962987, -6.418792872770249],
            [3.833545270940238, -6.419619510218223],
            [3.8363391822299215, -6.417932659033892],
            [3.8390339546788086, -6.421026936923275],
            [3.8307983533716423, -6.425137465220384],
            [3.8299084622221575, -6.435711207653956],
            [3.827924539322238, -6.438503515993411],
            [3.8235493086489436, -6.43914830432973],
            [3.824464100323797, -6.442872029885651],
            [3.8306236923424994, -6.442747357184157],
            [3.835314462504465, -6.444233365662852],
            [3.8365239865512737, -6.449567064770531],
            [3.8352250839864026, -6.452068765875407],
            [3.829436702669363, -6.455464168119053],
            [3.829623578150496, -6.4598738637217465],
            [3.835570100753276, -6.458747125986377],
            [3.8393370261919624, -6.45595601014889],
            [3.842004270714412, -6.447955478678453],
            [3.845842302096839, -6.44748426779023],
            [3.8480633127983013, -6.45461264630652],
            [3.8461717068799146, -6.4575332949165345],
            [3.8388176131944847, -6.459176745060294],
            [3.8311982453620015, -6.466810471211872],
            [3.824784414269466, -6.470130529673098],
            [3.8228449626329173, -6.478325294423065],
            [3.825061002541472, -6.481347452012263],
            [3.8305240215386185, -6.481121062531686],
            [3.8383198310243096, -6.473776327816819],
            [3.847059632968937, -6.467441519946953],
            [3.850859775522973, -6.466375943245],
            [3.8532637134961223, -6.471945620478203],
            [3.8499112403257914, -6.475651414201978],
            [3.845390644629146, -6.477599836503732],
            [3.8445555443255093, -6.481045542030524],
            [3.8476253484214564, -6.482839709423697],
            [3.8514639105748376, -6.493449516376324],
            [3.8473274487194242, -6.501750696423656],
            [3.8503654223132155, -6.504756399191881],
            [3.854455928696189, -6.503756604111523],
            [3.8582183041591116, -6.500563492765807],
            [3.863774042192451, -6.5006978263365385],
            [3.86933434181939, -6.496315680827842],
            [3.8726414490103553, -6.495596940413488],
            [3.87659015097655, -6.497708563150499],
            [3.881191918541444, -6.494694572458128],
            [3.881420255509791, -6.498944950051696],
            [3.8882833810522985, -6.5038298294607895],
            [3.892652371650098, -6.503528890321485],
            [3.8976397502671785, -6.500683500322593],
            [3.902683546044002, -6.502324310903819],
            [3.9067732972620584, -6.4992188080501085],
            [3.909536935561159, -6.502764878353791],
            [3.9125218403548523, -6.501380616201022],
            [3.921933140956285, -6.504827069571573],
            [3.9192744463108635, -6.507412090310385],
            [3.9214874656167917, -6.511596012903348],
            [3.9208755399510418, -6.516116069176149],
            [3.918218825370625, -6.52032800899564],
            [3.9189518402676042, -6.525745672959133],
            [3.9217537066185963, -6.529634210524621],
            [3.925644894274639, -6.5293081015468415],
            [3.927114455602514, -6.532029369792657],
            [3.931516697712787, -6.534851227054554],
            [3.9303074379634295, -6.547406925039276],
            [3.933304695105127, -6.54665924746898],
            [3.934668526775567, -6.541904296246873],
            [3.939347841961194, -6.54089697003832],
            [3.939654865175423, -6.544388651873254],
            [3.943384180716689, -6.548345143819818],
            [3.9437078983925336, -6.551308330108682],
            [3.939948395949341, -6.555847905982924],
            [3.9387023067625613, -6.559938062158823],
            [3.93999965854972, -6.562751203722287],
            [3.9459736108365147, -6.566947237918938],
            [3.943403212802757, -6.570562897712189],
            [3.945820841729139, -6.575000289576894],
            [3.9401306957573805, -6.578544626527789],
            [3.9365139725717384, -6.579066310257251],
            [3.929619901254705, -6.5771916932951315],
            [3.92058982441205, -6.583123504090926],
            [3.9196108438111223, -6.591531119200276],
            [3.916147513428547, -6.5900797884424875],
            [3.909988482966785, -6.583050953716416],
            [3.9071637983144445, -6.590782867210546],
            [3.90360212972636, -6.589977705718236],
            [3.897769519866705, -6.593120154378838],
            [3.8928696344294194, -6.600699804111129],
            [3.892831844215585, -6.603504090671224],
            [3.9015082483078247, -6.602141360525239],
            [3.903774747684897, -6.608704108219975],
            [3.9095037628253557, -6.61125406859186],
            [3.9095395117751552, -6.614827465039],
            [3.913408603825465, -6.621702834221194],
            [3.91808776713231, -6.622834326602222],
            [3.9225331100554577, -6.6273235634971375],
            [3.9180808513477614, -6.628061909093072],
            [3.9186848340109295, -6.632462965575153],
            [3.922752817236697, -6.635135937492671],
            [3.9195318642789436, -6.642187453302058],
            [3.922524148835166, -6.646544845084884],
            [3.9272890814506662, -6.656733060736815],
            [3.9224012649854627, -6.662492067867909],
            [3.9252411500713893, -6.668531834138465],
            [3.9214595713223406, -6.671713759459332],
            [3.9238269994974373, -6.6784448881872445],
            [3.926602712825086, -6.682723987943967],
            [3.929001512014488, -6.683190393692008],
            [3.9321093187718468, -6.690155938628676],
            [3.9328182706638577, -6.695314541024219],
            [3.920449999205123, -6.696135805973943],
            [3.923141816546402, -6.739908023555651],
            [3.837008449561861, -6.743624928257611],
            [3.7142128461027757, -6.748109223968926],
            [3.670833697939474, -6.750006794448348],
            [3.5779599269178113, -6.753754197738796],
            [3.5723357423396678, -6.605293451471261],
            [3.5699372004774284, -6.535929457149976]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.11658636958884, "lat": 32.09246977840239 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22021"],
        "coty_name": ["Caldwell"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Caldwell Parish"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00558477"
      },
      "bbox": [
        3.5646268756291883, -6.753754197738796, 3.9459736108365147,
        -6.394656906434241
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.497859749479481, -7.986742409125567],
            [4.501062519882485, -7.981130758798698],
            [4.501480351328807, -7.973135930621666],
            [4.5032907467747245, -7.968438039332744],
            [4.503562622564403, -7.958171633323748],
            [4.519407021151414, -7.95456668542876],
            [4.521610284475526, -7.94869346246387],
            [4.521203267330494, -7.940791686269137],
            [4.523282499158065, -7.93719175919614],
            [4.531882101796583, -7.9300333392585145],
            [4.5339307386909935, -7.929721163436574],
            [4.65760405643864, -7.918422357440707],
            [4.776892474650397, -7.9073440643137145],
            [4.8788034201493575, -7.897664137065652],
            [4.8803118431793315, -7.904082915507742],
            [4.883351298003611, -7.908767415141787],
            [4.8797115996347955, -7.91252015067292],
            [4.877559683869875, -7.911541898395662],
            [4.876482836392957, -7.921433335531581],
            [4.869915550630328, -7.921965651159133],
            [4.861457678801641, -7.92694195583334],
            [4.860411669321001, -7.930886757642673],
            [4.8568700439716155, -7.931525545777868],
            [4.854823041323907, -7.9356161414010575],
            [4.856663965639708, -7.937756948818846],
            [4.849550414977012, -7.943497899695411],
            [4.845683979715016, -7.944763943726494],
            [4.840633650981783, -7.950721006360921],
            [4.842302677840383, -7.954651780416769],
            [4.8382504314295165, -7.957811286734228],
            [4.837137384342088, -7.963672535796563],
            [4.830849548789075, -7.963999709797657],
            [4.828303137650797, -7.967288349080904],
            [4.829532034695018, -7.969969943444874],
            [4.825649623840311, -7.972860078690789],
            [4.824700029409125, -7.979795613253082],
            [4.821468747062931, -7.983023655378158],
            [4.81818651884276, -7.981107905976752],
            [4.809831181485925, -7.991987310782322],
            [4.805419863807445, -8.000003302589205],
            [4.807364657128742, -8.00230313297844],
            [4.811503866889164, -7.999497178120904],
            [4.806718489058066, -8.011369370254634],
            [4.799941745469175, -8.010858001710446],
            [4.799034105725748, -8.016611954435511],
            [4.795681368118202, -8.015349296577758],
            [4.789632336822558, -8.017941517797379],
            [4.785282490255956, -8.023975316573612],
            [4.779567446859966, -8.024788989875127],
            [4.778709691709086, -8.029222831089777],
            [4.77533088353098, -8.03108045207401],
            [4.7731408722926565, -8.037180914595384],
            [4.76913868003114, -8.0365515285726],
            [4.771002378677217, -8.042045157686282],
            [4.769051835173295, -8.045228878428308],
            [4.768387165540629, -8.050525582211206],
            [4.771764762069189, -8.050577512666433],
            [4.777378457327806, -8.053161527510184],
            [4.781478590099946, -8.057197847011677],
            [4.780928750672322, -8.066802985302592],
            [4.782209928158956, -8.070422354413136],
            [4.779245857287304, -8.073696786190691],
            [4.781936845874838, -8.078028147155253],
            [4.781075537125951, -8.081732803735516],
            [4.776045533103453, -8.083751947180867],
            [4.775997316456989, -8.087087983939641],
            [4.77266015027231, -8.090984518640816],
            [4.777096778706286, -8.091688328433479],
            [4.778887573017144, -8.096192755830117],
            [4.776675360410899, -8.102962257707306],
            [4.779196206032317, -8.10606218691679],
            [4.784744089121216, -8.109063962917956],
            [4.785379806923317, -8.11341587433921],
            [4.788210249453068, -8.116255780018292],
            [4.78274598307058, -8.119725297829302],
            [4.786488081608964, -8.12315520215753],
            [4.7869520099290925, -8.128252951908731],
            [4.7802995962383195, -8.141786592827865],
            [4.7835527447013275, -8.144690621209985],
            [4.7845012288756585, -8.149591652137573],
            [4.782768983512218, -8.15340926193333],
            [4.7789029361629325, -8.154340706629572],
            [4.776068568798745, -8.152702028129257],
            [4.771923866098143, -8.155402848508341],
            [4.770200063327295, -8.159343779464297],
            [4.773065433388193, -8.165957144327674],
            [4.779347465601381, -8.169732737645472],
            [4.7748207025289435, -8.172603420364485],
            [4.779996118252207, -8.178766703159479],
            [4.78697378686895, -8.182554819243913],
            [4.781363391231614, -8.187137021712058],
            [4.78272075004826, -8.191865788120797],
            [4.779807404896221, -8.19506806068207],
            [4.781161745987952, -8.198191019512775],
            [4.784375192447099, -8.199377421192438],
            [4.790210254996921, -8.199124366722097],
            [4.793148013589358, -8.201001173372036],
            [4.801390423809086, -8.211881380368304],
            [4.801595413093321, -8.214031451707791],
            [4.797556813164629, -8.216653643137642],
            [4.792173922713313, -8.214620347758068],
            [4.7900315775022, -8.21753295410148],
            [4.790045958970255, -8.222297592568477],
            [4.793243134748227, -8.226332274284443],
            [4.799961641851183, -8.23108649642038],
            [4.806155034188439, -8.229273552818364],
            [4.810110596343135, -8.224296153794041],
            [4.814794389025093, -8.226742418320471],
            [4.813720057600216, -8.238556568354307],
            [4.818862839791734, -8.24395306274998],
            [4.825274536007106, -8.245039506820547],
            [4.8257866201287465, -8.248042776516982],
            [4.821886005649169, -8.251358393652314],
            [4.827163965670414, -8.253256096807199],
            [4.828855891570425, -8.255648848934394],
            [4.836482387759419, -8.251200501689253],
            [4.842697009345169, -8.258093366155085],
            [4.849573897108909, -8.255368480792123],
            [4.8543058679058975, -8.263969345021968],
            [4.854402320057525, -8.268321710073842],
            [4.858713899355965, -8.267987212879728],
            [4.86216504851595, -8.27039180272684],
            [4.859915203818497, -8.26990097602873],
            [4.85137909856742, -8.275552004157431],
            [4.846680137772354, -8.27670581921237],
            [4.840364010392912, -8.275877103618999],
            [4.837230580194455, -8.271248902031292],
            [4.834590972860957, -8.272961159031892],
            [4.8245589274707115, -8.27576570198641],
            [4.821403955431117, -8.277447103576506],
            [4.813435577048729, -8.275372187407712],
            [4.809328508513494, -8.27254946284616],
            [4.801371972341401, -8.273510613850647],
            [4.790582091721703, -8.27254754199503],
            [4.788287309297284, -8.27561118995922],
            [4.782313262606668, -8.275836297916252],
            [4.77137806829251, -8.278881002271255],
            [4.768779396428848, -8.283935291673231],
            [4.762720645738548, -8.282949299075648],
            [4.7573964272071345, -8.28629152988159],
            [4.757923450688897, -8.290825448524352],
            [4.752193912047656, -8.299753900377661],
            [4.746238155238309, -8.30554083347358],
            [4.7389768449432035, -8.307131622960636],
            [4.727372078255739, -8.30672453819433],
            [4.7244088337082335, -8.305184997550016],
            [4.720048463412308, -8.30579078298175],
            [4.709186434037917, -8.303789544303195],
            [4.692379266605865, -8.304943879689208],
            [4.690290034444141, -8.303832864072172],
            [4.673372033838777, -8.310352655703099],
            [4.671372381925304, -8.312637995550585],
            [4.656521012793755, -8.312680931915654],
            [4.647898475637409, -8.306683346881108],
            [4.6478965860247135, -8.303308827772389],
            [4.644991765676231, -8.295515360279323],
            [4.639691204105928, -8.289697809570683],
            [4.636758072677458, -8.288090061216108],
            [4.622573354576611, -8.284472410113677],
            [4.607837919018689, -8.282282516534506],
            [4.601600960216017, -8.282115641981017],
            [4.593161408734471, -8.284319556174587],
            [4.577747500838391, -8.289659210215651],
            [4.571097163227253, -8.289493727108958],
            [4.566193358860937, -8.286362572219772],
            [4.562631921369044, -8.279500840961648],
            [4.560632456382193, -8.273636348868346],
            [4.561139980428038, -8.268485163976266],
            [4.5662814590373095, -8.255785660326605],
            [4.58137945169107, -8.236451710427811],
            [4.587037690049114, -8.22655769536375],
            [4.593394608138586, -8.2109493205678],
            [4.595613469681648, -8.19534793114304],
            [4.595720209571097, -8.190676400621065],
            [4.5911887363129225, -8.123889681148544],
            [4.5875474727520045, -8.113318927046407],
            [4.579982253470305, -8.108432178832476],
            [4.5350022624417585, -8.128298699528782],
            [4.523220758386184, -8.129425961604648],
            [4.518863097619769, -8.12822302424098],
            [4.516384254174244, -8.124848585128909],
            [4.515930746434099, -8.11920511914507],
            [4.518758690074416, -8.11585366321783],
            [4.531142344943238, -8.107289744514594],
            [4.544959466535335, -8.099470127989587],
            [4.5477880231818775, -8.097256730308516],
            [4.549888536567662, -8.092425835630467],
            [4.550394547340025, -8.08506402151956],
            [4.549468820839937, -8.079997437351567],
            [4.544955143365905, -8.07272212046181],
            [4.53905880827587, -8.067196867577012],
            [4.532755065933863, -8.063009687656555],
            [4.527878695130521, -8.06180878806015],
            [4.5160110481256215, -8.061968301731413],
            [4.503424836735491, -8.063303942011599],
            [4.4946207143372625, -8.062941446984452],
            [4.490572489688, -8.061498127109788],
            [4.486997065578052, -8.05756151092664],
            [4.484842906540463, -8.051280968432343],
            [4.48548151095345, -8.042263516010495],
            [4.489739574327507, -8.035090893563831],
            [4.4962388707752385, -8.026624524939196],
            [4.501645613498996, -8.010747680189926],
            [4.5028996785681485, -8.004393405660744],
            [4.501030718071334, -7.993838165791257],
            [4.497859749479481, -7.986742409125567]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.09565204074835, "lat": 30.5382167634836 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22033"],
        "coty_name": ["East Baton Rouge"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["East Baton Rouge Parish"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00558530"
      },
      "bbox": [
        4.484842906540463, -8.312680931915654, 4.883351298003611,
        -7.897664137065652
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.158669549145042, -8.153460516517558],
            [4.259987783154266, -8.149644396853997],
            [4.260629013676712, -8.163880530769285],
            [4.283924441264496, -8.16253085676088],
            [4.2824096014612225, -8.157037157570432],
            [4.308934384037029, -8.148038074010723],
            [4.308858095794834, -8.14710416430514],
            [4.331937326999164, -8.146418073095443],
            [4.344376967537533, -8.145392681033218],
            [4.36708210062498, -8.170986765275597],
            [4.372919831865649, -8.166094797095615],
            [4.408537622851261, -8.207427844343481],
            [4.40990273870643, -8.20667751650357],
            [4.426541729386985, -8.229499512125981],
            [4.42714912007729, -8.243196915429094],
            [4.454263871129224, -8.25244353530262],
            [4.4785140968794, -8.28178852725344],
            [4.493969408096522, -8.289736803838956],
            [4.50234097587222, -8.311363177970316],
            [4.539195753449629, -8.309172346675817],
            [4.552629417032387, -8.308172508739062],
            [4.6478965860247135, -8.303308827772389],
            [4.647898475637409, -8.306683346881108],
            [4.656521012793755, -8.312680931915654],
            [4.671372381925304, -8.312637995550585],
            [4.673372033838777, -8.310352655703099],
            [4.690290034444141, -8.303832864072172],
            [4.692379266605865, -8.304943879689208],
            [4.709186434037917, -8.303789544303195],
            [4.720048463412308, -8.30579078298175],
            [4.7244088337082335, -8.305184997550016],
            [4.727372078255739, -8.30672453819433],
            [4.7389768449432035, -8.307131622960636],
            [4.746238155238309, -8.30554083347358],
            [4.752193912047656, -8.299753900377661],
            [4.753801830499812, -8.302576810656902],
            [4.735260581174427, -8.369628209371964],
            [4.725041181498347, -8.408733293860774],
            [4.725256532735689, -8.409821447788707],
            [4.717310614775781, -8.439924073506754],
            [4.715239464975254, -8.46098123654259],
            [4.710916644075696, -8.461145419774956],
            [4.701361695692968, -8.468820409837738],
            [4.703976655219903, -8.513346881170172],
            [4.689555681009541, -8.514262567203621],
            [4.692399297142144, -8.55949761478997],
            [4.592197314499551, -8.601405721486179],
            [4.594046635895852, -8.595189493658927],
            [4.593585421255859, -8.589239662542484],
            [4.590305093107089, -8.584934511969886],
            [4.586364267012744, -8.585497076632723],
            [4.582671393142554, -8.589854278991865],
            [4.579459920616339, -8.597122123814522],
            [4.574213860139843, -8.596800233164242],
            [4.564096333519308, -8.58870827874523],
            [4.556528089739414, -8.578153904519295],
            [4.556030639718723, -8.57404006875635],
            [4.551773071461892, -8.56995583783987],
            [4.493817060926247, -8.573062114197304],
            [4.489878933571995, -8.570845605238013],
            [4.480873399944868, -8.572641952985375],
            [4.467685109099799, -8.578623735090295],
            [4.465670622466687, -8.574632283906993],
            [4.462704073046246, -8.571180218192435],
            [4.464788838674363, -8.567263563546332],
            [4.465002118919023, -8.561006505608564],
            [4.462036871396465, -8.55226865172563],
            [4.458032492790445, -8.548262396661135],
            [4.455982055366907, -8.539386603117139],
            [4.452890950535112, -8.537239345236122],
            [4.446080165907495, -8.53549567112424],
            [4.446278288014541, -8.532324679606912],
            [4.381491820645585, -8.53517521037276],
            [4.3748395574873795, -8.527541527204788],
            [4.373832334616549, -8.524158870639614],
            [4.377311833058529, -8.517081712539808],
            [4.381079640322279, -8.512871663358846],
            [4.382357419142148, -8.506815973525468],
            [4.376008864458256, -8.498805193467506],
            [4.372187435703208, -8.495937564236808],
            [4.375585165089359, -8.489575278436906],
            [4.37430174312461, -8.475621901613305],
            [4.374822717369389, -8.472177229827723],
            [4.37013349228959, -8.458290153151497],
            [4.370506105186861, -8.452341218372359],
            [4.366218620925288, -8.44758964461054],
            [4.361114804461999, -8.445741337644822],
            [4.35545842685592, -8.440963246701466],
            [4.354194382908221, -8.43415954088016],
            [4.356881986429462, -8.426122553020962],
            [4.360943167363905, -8.42149699003638],
            [4.360575188512979, -8.418605182400196],
            [4.364192777967931, -8.41518347362516],
            [4.365640514434656, -8.410434499296436],
            [4.362706574842004, -8.408404409274004],
            [4.3529356099572984, -8.404466833451389],
            [4.336688346763652, -8.400817447643375],
            [4.328919496510851, -8.400297745104414],
            [4.317907625573895, -8.400778465085816],
            [4.312690400141096, -8.402270048204556],
            [4.304351098407177, -8.402626626465803],
            [4.296497896050321, -8.401102003871262],
            [4.289660329387486, -8.401365740627565],
            [4.278278477600198, -8.396114078552031],
            [4.267174937722618, -8.387360263964467],
            [4.265082802879058, -8.384410036522457],
            [4.264314934556039, -8.377870363326771],
            [4.266687828401475, -8.371342935056578],
            [4.264594826166643, -8.367704045576083],
            [4.2519495935672476, -8.355970334150406],
            [4.236295937031262, -8.336367642342802],
            [4.22978054477511, -8.316657297640484],
            [4.231934902992268, -8.308222856556846],
            [4.22918882284143, -8.297729983712289],
            [4.230443304708473, -8.29270499949138],
            [4.2104690189901985, -8.282836526362653],
            [4.214261436905566, -8.275318441503627],
            [4.220343505585062, -8.273352956895668],
            [4.226296913656696, -8.269349329681225],
            [4.226394480855154, -8.264051875151981],
            [4.228292049739037, -8.260836993715094],
            [4.229134351030954, -8.25248997882255],
            [4.227254161769798, -8.24545885723521],
            [4.224105516624621, -8.240515167560726],
            [4.2254521163770296, -8.233673142342573],
            [4.219484044757309, -8.22817348690156],
            [4.21962116850616, -8.225449292480034],
            [4.21488584883776, -8.219147517393141],
            [4.21667737378401, -8.21327452716459],
            [4.213820652760018, -8.205653918028647],
            [4.208900186429299, -8.20434052063381],
            [4.20694875186468, -8.19960311443733],
            [4.193282634387799, -8.188707167360915],
            [4.195071587145541, -8.187969029825712],
            [4.1825523980577755, -8.175424404851428],
            [4.180101887972499, -8.174128888145773],
            [4.173258308430208, -8.174058598018492],
            [4.167048974506102, -8.169414750747782],
            [4.158924497599718, -8.1586036054676],
            [4.158669549145042, -8.153460516517558]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.34946964673861,
          "lat": 30.258621522413907
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22047"],
        "coty_name": ["Iberville"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Iberville Parish"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00558582"
      },
      "bbox": [
        4.158669549145042, -8.601405721486179, 4.753801830499812,
        -8.145392681033218
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.739812937659832, -9.27761857374118],
              [5.746131231807284, -9.277729925651368],
              [5.753428292163427, -9.268255271717793],
              [5.758006128206803, -9.266736710288535],
              [5.773179329870184, -9.257171260938769],
              [5.775855008417138, -9.259972375292412],
              [5.769166953112998, -9.266442574541184],
              [5.758206113605392, -9.273910309360517],
              [5.75222408581815, -9.27693774973364],
              [5.7453879931070615, -9.28253299999926],
              [5.739812937659832, -9.27761857374118]
            ]
          ],
          [
            [
              [5.71439025008462, -9.275215777414616],
              [5.720771391990584, -9.271025379967474],
              [5.724952461731864, -9.273017838604083],
              [5.7265837111493, -9.280599499758798],
              [5.723656113221064, -9.283549654868304],
              [5.721749905281059, -9.279775874636325],
              [5.714303237656815, -9.278705389292211],
              [5.71439025008462, -9.275215777414616]
            ]
          ],
          [
            [
              [5.707605895724732, -9.23637132196311],
              [5.716452963171225, -9.235780802606884],
              [5.719773982097969, -9.239471742245287],
              [5.721205535639781, -9.244819259184744],
              [5.718323536592183, -9.255266099409374],
              [5.71507396867215, -9.25325142058934],
              [5.710496672187941, -9.248065387330868],
              [5.707605895724732, -9.23637132196311]
            ]
          ],
          [
            [
              [5.679242439085365, -9.315525290924887],
              [5.685445220859208, -9.306839490339538],
              [5.688093121374747, -9.309236190222768],
              [5.691857867678546, -9.31771184227163],
              [5.68847227848862, -9.316795153237805],
              [5.680143303083273, -9.318236230779638],
              [5.679242439085365, -9.315525290924887]
            ]
          ],
          [
            [
              [5.672168058403751, -9.294242025859118],
              [5.6773821590463465, -9.291253665884224],
              [5.679906165602655, -9.293351115492392],
              [5.678290398430639, -9.297345459043825],
              [5.6741047436189875, -9.2985275722356],
              [5.672168058403751, -9.294242025859118]
            ]
          ],
          [
            [
              [5.660834079688055, -9.203065590306936],
              [5.667077514971043, -9.201340036567862],
              [5.670950126411933, -9.205094038822311],
              [5.677821250236779, -9.205383554468845],
              [5.680603969992108, -9.200192299346462],
              [5.6833136862276445, -9.192239608429869],
              [5.6863165014886485, -9.188877278775415],
              [5.692706995512576, -9.188172038449292],
              [5.703444410853289, -9.200200625484845],
              [5.711687852688021, -9.204088742363275],
              [5.710427028734775, -9.210312912483682],
              [5.70747790926711, -9.216130362136164],
              [5.6957974548535955, -9.2169633023856],
              [5.689215366439095, -9.214710420537047],
              [5.6858479191987685, -9.215638155229634],
              [5.679283688924065, -9.208774911805651],
              [5.676575212642191, -9.208635966160374],
              [5.665738819038711, -9.215155415923567],
              [5.661138096030831, -9.210244560018886],
              [5.660834079688055, -9.203065590306936]
            ]
          ],
          [
            [
              [5.663970109595315, -9.355857902579812],
              [5.6747197160561225, -9.34298452851474],
              [5.6792358842678805, -9.338250880168948],
              [5.686108348586184, -9.32771822768721],
              [5.694572619803828, -9.323044871293916],
              [5.694499564403853, -9.320290443863016],
              [5.697690778568004, -9.317157552665888],
              [5.6967260280575704, -9.31079432099938],
              [5.697735419937291, -9.308839884268494],
              [5.703468235575976, -9.30745729514881],
              [5.705501302957034, -9.300260219040009],
              [5.71065462024036, -9.294712921393716],
              [5.720564474028339, -9.298498490669651],
              [5.7232693540839294, -9.292077800643614],
              [5.731617212350961, -9.290323521749906],
              [5.734623480773979, -9.287765574300138],
              [5.738845497842483, -9.287975592338949],
              [5.741793535804333, -9.292494773190626],
              [5.736643109637931, -9.30181042787478],
              [5.700964587699062, -9.326539621409621],
              [5.681952587228543, -9.34108382600271],
              [5.666430140413533, -9.35820707392408],
              [5.663970109595315, -9.355857902579812]
            ]
          ],
          [
            [
              [5.64540701333169, -9.35148003682556],
              [5.652711130018722, -9.350983150510766],
              [5.652915625879065, -9.354108365872436],
              [5.6602487528304755, -9.364698282492622],
              [5.660259376954433, -9.369010881136079],
              [5.64469938603481, -9.379051660736053],
              [5.625980451532783, -9.393484841159273],
              [5.627752162730121, -9.387367460572024],
              [5.626932144732643, -9.383254268288317],
              [5.6236412158829445, -9.379825237817743],
              [5.628306227704208, -9.375860816411574],
              [5.629687874069845, -9.369728112701665],
              [5.639781135137008, -9.359180073278866],
              [5.646121675206939, -9.35543292098885],
              [5.64540701333169, -9.35148003682556]
            ]
          ],
          [
            [
              [5.416571082847341, -8.419542929224004],
              [5.4318067870365025, -8.41263669160167],
              [5.462663267667231, -8.400986055547552],
              [5.485264690728608, -8.393705236491027],
              [5.504266278427132, -8.388242237032193],
              [5.514848920038355, -8.397118270223249],
              [5.519212045078428, -8.399488241871868],
              [5.547264651235498, -8.410103091289756],
              [5.545510738434571, -8.537520688340459],
              [5.5466493119835825, -8.544188215249138],
              [5.54503259820119, -8.551728568480414],
              [5.544602481956699, -8.578102855661447],
              [5.544524259182922, -8.59999279990947],
              [5.533117778791908, -8.626279044694723],
              [5.534654198242421, -8.635604587354516],
              [5.535227678065713, -8.648954214314267],
              [5.536208880277445, -8.654940919142785],
              [5.541839264887776, -8.660347051798457],
              [5.548343301076651, -8.662731129092371],
              [5.555904803967605, -8.663747253858544],
              [5.566393538146107, -8.662982943693327],
              [5.58229078373757, -8.656477235763523],
              [5.593999952578396, -8.650898077171297],
              [5.601532431237317, -8.643789774536009],
              [5.604109126017835, -8.639267780458221],
              [5.604639201198746, -8.63199284873258],
              [5.603715615234215, -8.624488338714146],
              [5.6094240619801425, -8.63026873259468],
              [5.640914227872075, -8.660356532641783],
              [5.650312913306414, -8.669618207718322],
              [5.6504787047757645, -8.670964084824886],
              [5.649195084345632, -8.675029518324369],
              [5.643197014842687, -8.688294775073967],
              [5.639302616909264, -8.698744442542914],
              [5.63969901750337, -8.704394582544099],
              [5.637595628742485, -8.70776872339866],
              [5.636390150466248, -8.71414766183758],
              [5.6309341268361, -8.71944359022481],
              [5.626089085269871, -8.721531465248729],
              [5.622291660121484, -8.726404492905605],
              [5.616334984211089, -8.730255382452192],
              [5.611023157183597, -8.73155647232836],
              [5.60574093295577, -8.73567492864871],
              [5.602293444290016, -8.740067133292175],
              [5.6035378612478, -8.7451177687981],
              [5.60089112342826, -8.758465042238365],
              [5.60233359850203, -8.764929932353741],
              [5.604081220819556, -8.76677706314394],
              [5.607208969641874, -8.775880239256344],
              [5.6122570163791075, -8.78293705553677],
              [5.602120453520776, -8.795122797443312],
              [5.599725559115005, -8.796686334412616],
              [5.609515521095112, -8.8146478535232],
              [5.609014661770408, -8.828776470700852],
              [5.613968675755622, -8.836266240625733],
              [5.63407494371942, -8.857827820878306],
              [5.6368969486951706, -8.865820972540488],
              [5.645018656427213, -8.877841246412629],
              [5.657632855199053, -8.88961212038907],
              [5.668981222666311, -8.925869435175164],
              [5.672710023742197, -8.939164808883099],
              [5.679228054127492, -8.940961631614407],
              [5.685542683350064, -8.940273668010184],
              [5.688507837338903, -8.944970185197109],
              [5.685433142596484, -8.947203148850226],
              [5.688398981923395, -8.951947988593128],
              [5.692952611864798, -8.953580520037622],
              [5.69025913642603, -8.959450735919315],
              [5.693912251417998, -8.964795581182827],
              [5.692323076790517, -8.968305574414439],
              [5.694000004899558, -8.980666734561217],
              [5.689915590331147, -8.985583841864216],
              [5.6923828884051035, -8.988403943588423],
              [5.693246391221014, -8.993671297641804],
              [5.688544986358237, -8.998423699094797],
              [5.689151270711847, -9.011915006800434],
              [5.692999162497711, -9.020279875213557],
              [5.698560744143927, -9.026418030552366],
              [5.699799625032208, -9.053973197060229],
              [5.7010283198079925, -9.073808697217128],
              [5.702864292523601, -9.073670924447368],
              [5.704574704928413, -9.099283452062245],
              [5.701885120230915, -9.100771800456865],
              [5.692660609786458, -9.108923809187864],
              [5.693154201212793, -9.113396994735753],
              [5.699935392287768, -9.11563490224177],
              [5.702461080039023, -9.120718660370471],
              [5.71244616334114, -9.12631793789579],
              [5.708162675249603, -9.130681645988275],
              [5.704579935330159, -9.139506584649432],
              [5.700259395206292, -9.146534457522359],
              [5.699438251153331, -9.15313929504484],
              [5.686340234470634, -9.156004697798599],
              [5.685981293126111, -9.160123544477583],
              [5.6886994942872535, -9.166916367653835],
              [5.684270798436004, -9.17231335127],
              [5.682285725282634, -9.180219798177832],
              [5.676691946496183, -9.183639612726685],
              [5.663510154549059, -9.185543090202907],
              [5.6651047949128275, -9.181076960197672],
              [5.662778520022233, -9.17624236201062],
              [5.6641920795967335, -9.173126561126162],
              [5.6601807805268205, -9.16767540424576],
              [5.666083930031354, -9.147521033455018],
              [5.668990820879437, -9.132330941826062],
              [5.6673499666746325, -9.12977321215587],
              [5.661308232662158, -9.129427586830179],
              [5.653778787053202, -9.125478378701967],
              [5.6493954656973, -9.118744868683311],
              [5.649281737327532, -9.116324452331972],
              [5.653210774296636, -9.114149932148099],
              [5.648096371030003, -9.110045214882796],
              [5.642958946770391, -9.10745211720061],
              [5.642215031188866, -9.101287664542747],
              [5.6377011055825035, -9.101593689451875],
              [5.631601213757599, -9.104284605335762],
              [5.624481782431029, -9.102547778333015],
              [5.619506218980329, -9.099126092933517],
              [5.614630505774209, -9.09864594488905],
              [5.610162083176295, -9.102296298320827],
              [5.602119986239779, -9.103861018370075],
              [5.5853921921333995, -9.100669768952494],
              [5.575678391159103, -9.096789635839592],
              [5.564369623826468, -9.090598746130691],
              [5.561747444135897, -9.086228704382997],
              [5.559314146879437, -9.076684690869516],
              [5.55487822568855, -9.067557967216569],
              [5.551269144257413, -9.064094166726496],
              [5.54254968745287, -9.053010527570224],
              [5.536183548369067, -9.043496486751584],
              [5.531482878489795, -9.031419604887862],
              [5.528448297983049, -9.027749267387302],
              [5.517918515644603, -9.025642783717545],
              [5.5146328020796895, -9.023376443271516],
              [5.512246517518533, -9.018984395267964],
              [5.512316412476535, -9.014429945299266],
              [5.516810900749362, -9.008217404751127],
              [5.526549454715917, -9.003852135476569],
              [5.534063974094863, -9.003300328329036],
              [5.540456263006652, -9.000161673923126],
              [5.540832201060658, -8.996547134415176],
              [5.534721375851175, -8.992948568580474],
              [5.535807538061253, -8.988859265573396],
              [5.545204028093387, -8.982216678085134],
              [5.542761512928618, -8.976041353634496],
              [5.544335566614713, -8.9706251689779],
              [5.540403942991785, -8.967995714873354],
              [5.54362932925736, -8.963714271719436],
              [5.542605276301296, -8.960280254952707],
              [5.538701506323548, -8.961275949185088],
              [5.53894544378995, -8.95716882297724],
              [5.536242537144384, -8.954331664660566],
              [5.534808018023917, -8.947655494931462],
              [5.535568109340048, -8.938386559059552],
              [5.5353623633614815, -8.930610482175409],
              [5.5334698799273685, -8.925158367515223],
              [5.534778087220747, -8.918015519614311],
              [5.537756463581557, -8.91381054393562],
              [5.5372983643277855, -8.909113426915484],
              [5.535028680418181, -8.904978882949212],
              [5.534919675412232, -8.899289929150815],
              [5.536150490402184, -8.894003552184872],
              [5.528925426024865, -8.895031899895177],
              [5.523144311567436, -8.888859179991659],
              [5.518315205678306, -8.88955507826152],
              [5.51196815015422, -8.892417135436043],
              [5.507986384409114, -8.891373767714645],
              [5.501211843438361, -8.883273144689232],
              [5.494749998933169, -8.882771078353217],
              [5.472552455410466, -8.883491592747642],
              [5.491346932785446, -8.824282065222054],
              [5.513906380147386, -8.769868625176038],
              [5.516394802754269, -8.76756551722542],
              [5.514694690391039, -8.760687147406708],
              [5.517562343204804, -8.755532865726241],
              [5.511876684124933, -8.746896312825472],
              [5.504221328161141, -8.747287077784637],
              [5.451830090388561, -8.716237087492528],
              [5.450169225289346, -8.71010984110732],
              [5.45114837876795, -8.707181934442643],
              [5.448368352651282, -8.701909452657366],
              [5.447951641585285, -8.697819282026266],
              [5.437528451566165, -8.689480505896253],
              [5.432743831738342, -8.682269316154091],
              [5.429011680675318, -8.681531854453095],
              [5.424935307156162, -8.675356146024217],
              [5.419417675107712, -8.659058831491098],
              [5.412977721200628, -8.619877139491312],
              [5.4104731940152, -8.609170300758823],
              [5.409393615395005, -8.589277994334982],
              [5.406609300388267, -8.530150890550539],
              [5.40769166911294, -8.525656455853639],
              [5.407972733068198, -8.504812060179033],
              [5.407562518170107, -8.494037006491604],
              [5.4092367682648055, -8.486726556729355],
              [5.408966928021722, -8.475179226621991],
              [5.4108999430734235, -8.463328112556612],
              [5.412386987022236, -8.449754492695925],
              [5.413004188054249, -8.43906211576302],
              [5.416571082847341, -8.419542929224004]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.1276556077508, "lat": 29.78855115496481 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22051"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Jefferson Parish"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00558027"
      },
      "bbox": [
        5.406609300388267, -9.393484841159273, 5.775855008417138,
        -8.388242237032193
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.15585573740826, 10.290272714947424],
            [18.256086682959186, 10.318374185697717],
            [18.356326664592505, 10.34644228013212],
            [18.406544504337372, 10.17694479028814],
            [18.39787439976844, 10.174420639036448],
            [18.51397506362863, 9.780680708845864],
            [18.542265621614728, 9.795501576073118],
            [18.59973945962863, 9.689164335748268],
            [18.595230785215545, 9.687730670323262],
            [18.594043011074344, 9.683802928839219],
            [18.58659565093949, 9.683427640425062],
            [18.58318432716932, 9.677826541481584],
            [18.583741737616766, 9.673646928006468],
            [18.57860964769286, 9.669945266753421],
            [18.573476015154252, 9.671609351177139],
            [18.568498021610345, 9.68061646210068],
            [18.560680890417384, 9.687041996532143],
            [18.558216241175955, 9.69243340274024],
            [18.560439595620128, 9.694850182287652],
            [18.559407747450987, 9.698823530953247],
            [18.556793343808373, 9.699716054059065],
            [18.55251372849682, 9.698158978337363],
            [18.537757724754613, 9.68516050996653],
            [18.544445386193747, 9.683969102950423],
            [18.547414551765463, 9.67612760295051],
            [18.551745483251164, 9.677552003455416],
            [18.558673118927874, 9.669787987749213],
            [18.562843687948135, 9.668445045467218],
            [18.562171552089705, 9.664135314975901],
            [18.56587468397138, 9.661447345053663],
            [18.56447912815871, 9.646798031129636],
            [18.56237360028046, 9.642923303400417],
            [18.566852243183522, 9.637631910633244],
            [18.568003874027756, 9.634153427506886],
            [18.572453680443882, 9.627181610041148],
            [18.570016923326214, 9.613151712039178],
            [18.570783625868785, 9.60397561819283],
            [18.569277348932214, 9.598354892558545],
            [18.560786298787306, 9.595102494790975],
            [18.562939751962205, 9.592001540484176],
            [18.568059852305925, 9.590336524779252],
            [18.57165146402448, 9.586704851327923],
            [18.574182747783347, 9.58145324760988],
            [18.57396018054068, 9.577820577916972],
            [18.57151079807617, 9.570651041298758],
            [18.569119178836463, 9.568623031603444],
            [18.55753660381179, 9.574402037007106],
            [18.55527863686353, 9.571626448524423],
            [18.551795525379603, 9.571543220342605],
            [18.545909970027996, 9.568969287940549],
            [18.538724872370228, 9.573710703807544],
            [18.533695906421823, 9.580105871415862],
            [18.5279291266096, 9.58210904120861],
            [18.534527912267368, 9.574301487892571],
            [18.529609915102654, 9.571237260814105],
            [18.529286543096408, 9.564566525659615],
            [18.532670276517464, 9.556594965961832],
            [18.535718998012378, 9.551562062382303],
            [18.530062606511382, 9.549493286223749],
            [18.526091856077795, 9.550737072482582],
            [18.521991863972474, 9.546970967446207],
            [18.517298009815292, 9.546004392960144],
            [18.513828255781068, 9.540431971370118],
            [18.52698533164146, 9.53445343847808],
            [18.532374951943495, 9.536328439290873],
            [18.539897114818647, 9.530788380393746],
            [18.533148879558844, 9.52693807244732],
            [18.532164541130697, 9.522950579898517],
            [18.53391771591898, 9.519505301990444],
            [18.538899262566368, 9.519413790592525],
            [18.545190522237064, 9.516552592263642],
            [18.548332279884068, 9.50858179003255],
            [18.551070318787016, 9.507303328976835],
            [18.55332328943808, 9.50083173925991],
            [18.5635070489641, 9.496444258299606],
            [18.569780744410505, 9.494941688770455],
            [18.573044418406575, 9.495798261501358],
            [18.577495936194836, 9.493888556824249],
            [18.581156642793488, 9.496741827966252],
            [18.588520659269268, 9.496581566740545],
            [18.59107248160632, 9.485428173971973],
            [18.588633541891152, 9.48094844361358],
            [18.593798305295604, 9.475554505975486],
            [18.591732890573102, 9.47095148470894],
            [18.59821014458514, 9.47069087987903],
            [18.59939218057626, 9.475837228133233],
            [18.604459596656522, 9.478857993720831],
            [18.611953938427753, 9.47912746023797],
            [18.62066954513953, 9.477656166457894],
            [18.62922307891329, 9.473037788374784],
            [18.62843974390689, 9.468436457999742],
            [18.62301708852661, 9.471075619596922],
            [18.62039211937394, 9.470240956479104],
            [18.615602016227488, 9.474089762685786],
            [18.612088409886155, 9.471463090823072],
            [18.61292804578284, 9.463150266769695],
            [18.620192266639666, 9.4629230943028],
            [18.622314985197857, 9.4586908509137],
            [18.627299987096507, 9.454853289542026],
            [18.628352487898447, 9.447771679320999],
            [18.62399568460604, 9.43979914344886],
            [18.621072390622825, 9.437089323238272],
            [18.620292209223628, 9.432524427087266],
            [18.62139193761022, 9.4270146204287],
            [18.629485361414613, 9.419214271632876],
            [18.62972779486519, 9.413326520351744],
            [18.625268296406382, 9.407330033587028],
            [18.624481688124657, 9.403984838690453],
            [18.625161984885004, 9.395405900180318],
            [18.623875032130304, 9.391660124277516],
            [18.61685390839823, 9.385282782868735],
            [18.61656617737247, 9.383505392369885],
            [18.60858242017447, 9.374655488876163],
            [18.598481904360447, 9.371058676208673],
            [18.599053822102377, 9.366638419407066],
            [18.601485887614505, 9.363414467950612],
            [18.597755508032407, 9.35948806217482],
            [18.656042605664382, 9.25160504383384],
            [18.676580032223313, 9.213714740643177],
            [18.719726901793425, 9.136774874662558],
            [18.71468890683927, 9.13422566836725],
            [18.722564147576687, 9.117671617838237],
            [18.752977659120518, 9.063864871655953],
            [18.751827343723985, 9.059253630629868],
            [18.75834405829199, 9.047368854181327],
            [18.803326094612, 8.96247543931262],
            [18.80906428511412, 8.965459874303273],
            [18.850667063409325, 8.884232022065351],
            [18.918290894302267, 8.917797970738796],
            [18.91374640402376, 8.92600439981625],
            [18.928781724801354, 8.933428162417057],
            [18.92108747021422, 8.94815073515074],
            [19.013426750602694, 8.994596228601534],
            [19.042862756412145, 8.938790021186339],
            [19.0966786562797, 8.835578411517982],
            [19.10654983867359, 8.816839534724503],
            [19.13742401302692, 8.757221697675222],
            [19.13416643525122, 8.75560261771072],
            [19.1714026792988, 8.677521276327369],
            [19.13217840483287, 8.658612858634568],
            [19.111369148665013, 8.68915286103017],
            [19.108331721885058, 8.687572711252036],
            [19.098300018231875, 8.687034441567496],
            [19.090917958289072, 8.688247822578317],
            [19.08370450394777, 8.68581206452596],
            [19.08013472742842, 8.682121817333748],
            [19.08161235170238, 8.67834522541361],
            [19.075361714292193, 8.675783439137327],
            [19.07710626064994, 8.669776020072087],
            [19.081231706469207, 8.662412531913972],
            [19.07582583291723, 8.656360092101732],
            [19.07160965098481, 8.645773027904609],
            [19.072599399316378, 8.643229987695612],
            [19.072573290002936, 8.635146859197423],
            [19.074947908607754, 8.628456409138272],
            [19.039769234396505, 8.610146922149355],
            [19.038454682332993, 8.625323705045416],
            [19.034381544136597, 8.624948623327647],
            [19.033701760540456, 8.634462954394978],
            [19.02424842588272, 8.633959312227041],
            [18.946573057779975, 8.59588493645388],
            [18.927619638239502, 8.58616966939916],
            [18.93150092389045, 8.575128234452933],
            [18.93418600292761, 8.57153753332421],
            [18.9383114368888, 8.560387797480264],
            [18.94466666228208, 8.55506300527735],
            [18.95074181069092, 8.547258402031895],
            [18.959965881010422, 8.544456211700126],
            [18.96615172165804, 8.539425354733911],
            [18.972321646416813, 8.535993825451506],
            [18.97866970894724, 8.530340185900622],
            [18.98465876351357, 8.526609694517159],
            [18.985586913626612, 8.521197388681038],
            [18.982306277842167, 8.506437643358137],
            [18.982079420707578, 8.499814601440685],
            [18.98808945238224, 8.488668689134517],
            [18.987607208293216, 8.48150700728978],
            [18.984124156985878, 8.479046205625316],
            [18.980117420646003, 8.474089558597427],
            [18.936755086430956, 8.471297170105704],
            [18.881183191452518, 8.46789542563827],
            [18.878493509135144, 8.471634952525358],
            [18.85507754158186, 8.470873193450444],
            [18.851393835040664, 8.455290295295836],
            [18.852221489465556, 8.438228816473908],
            [18.833592687268883, 8.437120612599712],
            [18.834100790201163, 8.440254791601253],
            [18.831887340858597, 8.443067919116462],
            [18.8304203299454, 8.451790280204909],
            [18.82579416494293, 8.454943527778445],
            [18.826337494303147, 8.457617433650247],
            [18.820140034428057, 8.460779664682848],
            [18.798848293602216, 8.468821337212397],
            [18.78522392745785, 8.461677811508741],
            [18.748986579030888, 8.443948571813017],
            [18.727531749744394, 8.476256894769621],
            [18.710831800389848, 8.48229974210913],
            [18.709101059770475, 8.484844715692702],
            [18.715593829850658, 8.486378440222136],
            [18.714356797902372, 8.493626630272653],
            [18.710743581536065, 8.497560980651533],
            [18.7095980791446, 8.505456998835236],
            [18.68598728472544, 8.495060141504496],
            [18.65244188639437, 8.568296502684294],
            [18.660859750396888, 8.572014398947038],
            [18.65477655456605, 8.585251640174503],
            [18.6567442587102, 8.586074303019151],
            [18.6512426191934, 8.59943892060391],
            [18.64311875840383, 8.595804182939155],
            [18.633450754932692, 8.616599873653676],
            [18.62928816029218, 8.61472096008329],
            [18.620161281390637, 8.63356133804175],
            [18.624516834144384, 8.635636312637246],
            [18.610090419741923, 8.666461923906782],
            [18.547930702093964, 8.635111085681258],
            [18.527868410726985, 8.675846500530666],
            [18.522672863892428, 8.674753027587709],
            [18.516468939573038, 8.687635387384926],
            [18.521474114796405, 8.69023435760427],
            [18.5083053267412, 8.717808504447653],
            [18.53525178799878, 8.730857746113609],
            [18.512834588730286, 8.778876669254819],
            [18.509930481373015, 8.783755982248744],
            [18.49548529743894, 8.811717646881167],
            [18.4532007546197, 8.894242601775563],
            [18.366845843482796, 8.851537265722385],
            [18.342641100329825, 8.89958840102177],
            [18.339529346647243, 8.900273703975504],
            [18.30582718396751, 8.883792151675298],
            [18.308101058570557, 8.879155937609836],
            [18.273038465871917, 8.860898725577774],
            [18.231772971395422, 8.94462081475262],
            [18.202951837434117, 9.003352385885565],
            [18.15518673572799, 9.098271249318836],
            [18.107418592106523, 9.193132171380263],
            [18.115713259375553, 9.197068200218917],
            [18.073494360449804, 9.27595027424839],
            [18.04316976735761, 9.335040308123586],
            [18.047353039468444, 9.334403338157564],
            [18.05116105705099, 9.336065557174269],
            [18.054867856858536, 9.34119746373129],
            [18.061114091380524, 9.338505148430961],
            [18.065041211410673, 9.34318714594793],
            [18.064833279222796, 9.34546787457093],
            [18.068886175198745, 9.3537639792035],
            [18.08211133762634, 9.371696097627728],
            [18.085604251386968, 9.374599779075005],
            [18.090130080069052, 9.382352830397068],
            [18.09152403222262, 9.387453400136737],
            [18.09759082703208, 9.389850242518687],
            [18.10176211210271, 9.388369645225403],
            [18.11027892943385, 9.39063896127589],
            [18.114976205169032, 9.394816121677257],
            [18.114992863652407, 9.397863479627746],
            [18.124052461640833, 9.40526977913297],
            [18.1244679143396, 9.406935471424275],
            [18.13208712062552, 9.412372918443548],
            [18.13297066192931, 9.41659633500724],
            [18.131660760444344, 9.421714489115885],
            [18.136522108634033, 9.42248439112688],
            [18.13943428340788, 9.429752038931118],
            [18.135087840390316, 9.429771504949068],
            [18.129845188760154, 9.435304953801982],
            [18.13261354360026, 9.44089945502616],
            [18.13215229798344, 9.442953102261699],
            [18.12527645414935, 9.447766110748027],
            [18.121064597139636, 9.448280834683947],
            [18.1167891544987, 9.451138539479254],
            [18.115161334433697, 9.459332680215843],
            [18.113046323836, 9.461542188067432],
            [18.11346340226566, 9.46527938624537],
            [18.107953744448036, 9.47191620251812],
            [18.104787300323682, 9.471234399298083],
            [18.103660777400417, 9.477125524289086],
            [18.10091462722776, 9.48103506367027],
            [18.10630296669567, 9.484860017849337],
            [18.112289383994607, 9.485108568843684],
            [18.114091576972108, 9.488308593098791],
            [18.111184902800733, 9.492869048257733],
            [18.111058993395876, 9.497298199960822],
            [18.11525295079463, 9.504022215943856],
            [18.11410430741598, 9.50891989065408],
            [18.119972732118086, 9.519380765496178],
            [18.123350595291644, 9.523824093540481],
            [18.120887494317437, 9.526274587486151],
            [18.12884408921056, 9.529698099794947],
            [18.132638363099737, 9.542624474915932],
            [18.135847314200465, 9.548733626691806],
            [18.1439483224857, 9.552583343317382],
            [18.144915200510564, 9.554223212902995],
            [18.151702751234758, 9.557412884046075],
            [18.15820947928268, 9.562555760809866],
            [18.159393873591377, 9.566557394797382],
            [18.162410671847265, 9.568460416270113],
            [18.169678016333183, 9.578258276230343],
            [18.17140634762433, 9.582946584518163],
            [18.174631190652434, 9.587430023976248],
            [18.174467259757737, 9.590333147000907],
            [18.179923727079682, 9.59723169529791],
            [18.18152373306984, 9.600636018324012],
            [18.176343040077896, 9.601989976055188],
            [18.178684772569003, 9.608278170241451],
            [18.18189014039997, 9.613232929935991],
            [18.179904181948572, 9.61817878279898],
            [18.175865169431667, 9.619541272511265],
            [18.175036442281364, 9.626847744829673],
            [18.169868939295224, 9.631252423359461],
            [18.17379250523133, 9.638606331296646],
            [18.174610287432728, 9.642099405793934],
            [18.180814639156676, 9.64984735430344],
            [18.180074016342097, 9.654380003559462],
            [18.168421905345024, 9.66294532406804],
            [18.167460517923164, 9.660038720124444],
            [18.16298160709933, 9.663743849938522],
            [18.163556044962338, 9.665795429844954],
            [18.156632799681244, 9.667708773705604],
            [18.153955677755015, 9.665079003638915],
            [18.149694904293128, 9.669712636890939],
            [18.141699185083997, 9.66377467609422],
            [18.13577097404816, 9.661895872509184],
            [18.130725278832767, 9.662488941860838],
            [18.126403851129204, 9.658221190118214],
            [18.124434394232008, 9.667580419632316],
            [18.123686228800747, 9.676228702503149],
            [18.127965421951636, 9.68265132365058],
            [18.13136288351462, 9.68420895282059],
            [18.135320988211557, 9.69126764363392],
            [18.13040434382434, 9.69562048355538],
            [18.123167955435328, 9.695255950126436],
            [18.12000570219469, 9.699853500803549],
            [18.11788101702521, 9.705349204255095],
            [18.114449932061785, 9.706047236263878],
            [18.11248885980127, 9.71016373680585],
            [18.107936933157436, 9.712050008207138],
            [18.115458169087447, 9.721566358763567],
            [18.117696979564773, 9.725813635242227],
            [18.114805614590843, 9.72746649274873],
            [18.115232517198027, 9.733439740778795],
            [18.119507539997795, 9.740401108001752],
            [18.119629664144817, 9.743223310445673],
            [18.124638189775652, 9.750010750878484],
            [18.122889748486315, 9.758169453166044],
            [18.11878813515465, 9.759196515451956],
            [18.113536955314064, 9.75563849058591],
            [18.10405735644302, 9.753727799175783],
            [18.10060893939783, 9.756053359918967],
            [18.10387865817825, 9.766451787246202],
            [18.10200414705075, 9.77553667249101],
            [18.10654890567031, 9.779340801996494],
            [18.106613665610947, 9.7880984547259],
            [18.11592581626668, 9.79878350652688],
            [18.129140398016006, 9.79964403313262],
            [18.128449216633562, 9.806214386498237],
            [18.125607644980786, 9.809498878013086],
            [18.126072253670355, 9.817534565368398],
            [18.12829428806168, 9.829215496931898],
            [18.127279445305643, 9.843195498762714],
            [18.128605591329713, 9.845778641538153],
            [18.12485813261312, 9.849997919799492],
            [18.119868990807447, 9.85051124262983],
            [18.116498672444145, 9.8538683373995],
            [18.108114769269797, 9.85902875909652],
            [18.10447895293382, 9.859446712749971],
            [18.10232772455002, 9.863503724949917],
            [18.092947746744745, 9.866705804309083],
            [18.085542400040854, 9.87274717429603],
            [18.081458497796362, 9.874624059091282],
            [18.078692274005434, 9.879746398370132],
            [18.082073343652674, 9.886171462569907],
            [18.087830994104284, 9.90299675386134],
            [18.084846482908933, 9.90548329039554],
            [18.08787324874924, 9.909857938230617],
            [18.086929368839318, 9.916315618768698],
            [18.089502198789692, 9.923359306849642],
            [18.08922656837098, 9.938018058479503],
            [18.091053232945708, 9.941333071158647],
            [18.087463948390603, 9.946037834528564],
            [18.08815452788737, 9.959324167553824],
            [18.091384957529865, 9.969949359984014],
            [18.09060542303555, 9.97229186825133],
            [18.094023744114303, 9.978631825894707],
            [18.09315978937183, 9.985294596766655],
            [18.10329826186945, 9.992273777438307],
            [18.1039325145495, 9.995731413391288],
            [18.1078884983963, 9.99817274931951],
            [18.1049747504629, 10.007297039204573],
            [18.105740793027135, 10.012386547888184],
            [18.101819915498066, 10.016275176840065],
            [18.101144365577447, 10.021254863349021],
            [18.098097246611125, 10.025160417856538],
            [18.09834643592574, 10.027629960740077],
            [18.10354856837148, 10.03866966306535],
            [18.10304088179542, 10.040889865540683],
            [18.105802324176203, 10.048716700450031],
            [18.10976130958138, 10.051981150163472],
            [18.10949821612375, 10.054241767035428],
            [18.114490917412336, 10.060582668958988],
            [18.118999984279867, 10.059986738617765],
            [18.12112426081686, 10.064126022511205],
            [18.12432474165127, 10.065465404727572],
            [18.130212310064028, 10.064519722617536],
            [18.134116525806462, 10.06941149699193],
            [18.13533066782881, 10.077097314927615],
            [18.139932590632053, 10.077856106688188],
            [18.140700192084285, 10.080676190413751],
            [18.13888218890689, 10.087113642428744],
            [18.139571249760873, 10.089958915293012],
            [18.145274658133356, 10.096737633623519],
            [18.148299549881784, 10.09720955237626],
            [18.148330354241494, 10.102506291508263],
            [18.151827114193996, 10.110745334841827],
            [18.14990316001391, 10.116926144722683],
            [18.15146652622484, 10.121855039244279],
            [18.155820714155375, 10.12431327985422],
            [18.15792558743883, 10.123377736543414],
            [18.161819878516013, 10.125827083513867],
            [18.164899036152786, 10.125510696497443],
            [18.176117067709875, 10.134479317148825],
            [18.158143579090613, 10.274296441838139],
            [18.15585573740826, 10.290272714947424]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -69.95888514214676,
          "lat": 45.513906234642626
        },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23025"],
        "coty_name": ["Somerset"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Somerset County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00581298"
      },
      "bbox": [
        18.04316976735761, 8.437120612599712, 19.1714026792988,
        10.34644228013212
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.842005906502678, 2.276540772060152],
            [13.85105419652146, 2.278394747757142],
            [13.946819212641897, 2.2961782248718685],
            [14.024512726779598, 2.3108346037806475],
            [14.102023216825446, 2.3255933011399543],
            [14.192489334234475, 2.3429245105773986],
            [14.305414346467852, 2.3634380451801733],
            [14.346210798427688, 2.371254362701285],
            [14.417504202898744, 2.3847440500388624],
            [14.49625722005113, 2.3999274248985003],
            [14.493872482487122, 2.3929420397315995],
            [14.48648545779143, 2.38217152918261],
            [14.485039206306118, 2.372582929263843],
            [14.48129902075249, 2.366529646578239],
            [14.47683653657066, 2.364453152627789],
            [14.473952124100428, 2.3585823167122277],
            [14.482572073219728, 2.359314795657969],
            [14.487029985106233, 2.353297890031107],
            [14.484598229074225, 2.343686694775595],
            [14.48064612631918, 2.3395901524379066],
            [14.481201850051786, 2.3370054188670384],
            [14.476998719051338, 2.3284818542531402],
            [14.476967902884612, 2.324068087589282],
            [14.473584550017028, 2.3139053308916444],
            [14.47000626926188, 2.3099665314035667],
            [14.467706540934882, 2.303510225764825],
            [14.463887232076658, 2.302718138259889],
            [14.459613686807996, 2.303842388683207],
            [14.454254561820319, 2.3003882140842085],
            [14.453669660830556, 2.2941955140086354],
            [14.440164577931379, 2.2860820913209907],
            [14.43802770422421, 2.2750925439311778],
            [14.438493594461447, 2.2639588225300407],
            [14.436896710596187, 2.245980959223405],
            [14.437200521496674, 2.2355131560370776],
            [14.436122173736456, 2.2309096910008424],
            [14.433244042674774, 2.2270841833284925],
            [14.434565961783695, 2.2188972637834414],
            [14.434279841281132, 2.2141201825758317],
            [14.431921415261801, 2.2122190779068327],
            [14.434940277070663, 2.203633673510702],
            [14.429455332914117, 2.198384021573626],
            [14.42546069536021, 2.1893254859222626],
            [14.425722923864269, 2.182681294070442],
            [14.423944226220899, 2.1786574949367874],
            [14.422708708100666, 2.1671307469663126],
            [14.424394208093673, 2.164050064856563],
            [14.423745610245478, 2.159958628731482],
            [14.431968832309865, 2.152448513496448],
            [14.428156867713335, 2.1416320789026377],
            [14.43251765335122, 2.135358963256631],
            [14.435156725411023, 2.1292453945418535],
            [14.431825778345448, 2.1240613697529898],
            [14.432566002118726, 2.119798469329886],
            [14.429344863385865, 2.11652853893468],
            [14.429152948443393, 2.107747480072408],
            [14.426061449611431, 2.1053121339343113],
            [14.425291423970991, 2.096640109724957],
            [14.425907828074108, 2.0883264962185324],
            [14.427397536913649, 2.082963088016555],
            [14.426963995287215, 2.0725064360973624],
            [14.429711091939327, 2.0605076093892327],
            [14.42766773786137, 2.0443712441575004],
            [14.426653622063208, 2.0317172931641],
            [14.422121457186138, 2.0185037588617454],
            [14.41984707767176, 2.0053264036716683],
            [14.41617788396583, 1.9979213974934864],
            [14.416014992596496, 1.9915152712513557],
            [14.417307123469994, 1.9774307793322496],
            [14.41393988034207, 1.9763510639802062],
            [14.410590335110982, 1.9718409749815857],
            [14.40306288731875, 1.9690568772126291],
            [14.394789579520921, 1.9704528043953038],
            [14.385953816308806, 1.9684806934736008],
            [14.37997377948207, 1.9676788650969514],
            [14.373203221107959, 1.9718599807456783],
            [14.356247612054835, 1.9756402309413381],
            [14.352709218366945, 1.97848041180682],
            [14.350604566293159, 1.9834089952537195],
            [14.35139764494359, 1.9864304995036413],
            [14.357314505032202, 1.991830723484234],
            [14.35993917449998, 1.996216547882199],
            [14.360188819298523, 2.0031780165218103],
            [14.358985255497505, 2.0082803817335266],
            [14.349582755898716, 2.020000466116359],
            [14.348769382098405, 2.0237212022241016],
            [14.35113057954001, 2.026314564579619],
            [14.357618407398013, 2.028847798055897],
            [14.360511062348339, 2.0318100302093742],
            [14.359489526033506, 2.0366886157562347],
            [14.355045297677314, 2.0450847346183014],
            [14.34765598447247, 2.05314080881382],
            [14.34196719911579, 2.0615357995631656],
            [14.34106440997766, 2.0645339889687686],
            [14.332384638604454, 2.06816568681471],
            [14.323837016883202, 2.065899432226317],
            [14.309862285364764, 2.0660134367965757],
            [14.301474998198596, 2.0699126690020004],
            [14.301802364530662, 2.074982509444942],
            [14.310658020015225, 2.07874157899729],
            [14.311658163669636, 2.0834240935477846],
            [14.305599930258023, 2.0865748750403488],
            [14.30093315709296, 2.090371726343617],
            [14.299788924562618, 2.094968324031944],
            [14.30351293725636, 2.0970998076949545],
            [14.31345603193397, 2.096792561654911],
            [14.31418923298143, 2.1008355762999216],
            [14.305037751018565, 2.103339920312154],
            [14.299881932494191, 2.10586727203605],
            [14.297097858863559, 2.109910724318566],
            [14.297963522748246, 2.1163516833678027],
            [14.302572501991044, 2.120557851257366],
            [14.314378656944324, 2.1271213561054463],
            [14.317448799375953, 2.1299018374184686],
            [14.317424659621427, 2.1344093347800572],
            [14.313057652891661, 2.137017587991783],
            [14.30506364875774, 2.1354462747074616],
            [14.301838017355006, 2.132283765391682],
            [14.30026713189228, 2.1274672420576324],
            [14.296355223102491, 2.1240538780118046],
            [14.28708738905801, 2.122893577843986],
            [14.276657972293078, 2.1246343163504853],
            [14.273048666443476, 2.124303617588658],
            [14.26814410654621, 2.1238545345614286],
            [14.257074456679193, 2.125705274318894],
            [14.25470965664535, 2.1301008862357445],
            [14.256113864502774, 2.1329346161852376],
            [14.26651849861631, 2.1437615290697303],
            [14.268591984727266, 2.146700411198926],
            [14.268785828119078, 2.1541170606126325],
            [14.266455478761952, 2.1589061865131134],
            [14.259678255781566, 2.1611410743523365],
            [14.255064837024468, 2.156723102597213],
            [14.256560996462905, 2.148530996285264],
            [14.256082535188227, 2.145899769456021],
            [14.250047124437833, 2.141582504372644],
            [14.243164158316683, 2.1391456908626942],
            [14.238070532884754, 2.1415897410754416],
            [14.236713398319498, 2.1485871746360177],
            [14.23615022354882, 2.1588404083485266],
            [14.234690006149147, 2.1622241435086966],
            [14.228926385533866, 2.1671700839419095],
            [14.216279065489347, 2.1726092793921654],
            [14.213631924497257, 2.176211210116459],
            [14.21374365307937, 2.1795693494056025],
            [14.220059260767417, 2.1851993032866535],
            [14.229585186007744, 2.1870927013608235],
            [14.236796080241326, 2.1895738175035624],
            [14.247101109550131, 2.1912831556181547],
            [14.251092518230765, 2.1941474283886957],
            [14.252535684166508, 2.1991996291770763],
            [14.252417570327538, 2.209616912287034],
            [14.251290234076212, 2.2195409946649183],
            [14.247817860072368, 2.2291994642044766],
            [14.24221271365306, 2.233272965889115],
            [14.238416297178366, 2.2337000652997907],
            [14.230460976958772, 2.232021373172957],
            [14.218268108419023, 2.233798153871069],
            [14.213138923253457, 2.2360495021106828],
            [14.205057639292404, 2.236013397383068],
            [14.20415024547359, 2.233325903093267],
            [14.208912168048444, 2.228884976423268],
            [14.210540868509318, 2.220906161989832],
            [14.206068992643628, 2.2172745907052986],
            [14.184086304688144, 2.2186625001185387],
            [14.178534916742516, 2.219685634041963],
            [14.172729868957, 2.2278708484101255],
            [14.168920506559871, 2.2310085370371335],
            [14.161904936882856, 2.2308041942812946],
            [14.161056868457024, 2.226355146214987],
            [14.165770359896488, 2.2251687693805455],
            [14.168811713576774, 2.221127258505032],
            [14.17070866538819, 2.207555802722058],
            [14.170105309954756, 2.1998708221186396],
            [14.165201253673711, 2.19654032241401],
            [14.162024071119895, 2.19828823706706],
            [14.159368578438766, 2.2035289986898157],
            [14.15824445358816, 2.2148526106652797],
            [14.156656409369747, 2.217027004496492],
            [14.148723410128303, 2.2179112845357793],
            [14.143370801287892, 2.2131753323869963],
            [14.139488755592815, 2.2069389645898267],
            [14.133456307791935, 2.2054494691377284],
            [14.12012251927845, 2.203991409063868],
            [14.11268274626612, 2.2062589645783346],
            [14.10144709249488, 2.220044744401493],
            [14.094155717763421, 2.2267234575781405],
            [14.0882037823868, 2.234065738656491],
            [14.078050933880759, 2.2397112426111745],
            [14.073892483507846, 2.244153948015947],
            [14.050804336607866, 2.26097520257711],
            [14.046824937482084, 2.262563653482929],
            [14.0410557094621, 2.261979484133767],
            [14.034372887090175, 2.2673728583504786],
            [14.025595189949088, 2.2697836158190925],
            [14.012868955138996, 2.270970946246459],
            [14.006052569304519, 2.2710352187309892],
            [13.997336812010133, 2.272905432049929],
            [13.989310821089513, 2.271503367592213],
            [13.98276129948229, 2.273454923737814],
            [13.97547393908384, 2.2740936921913795],
            [13.96703166384969, 2.2719776791592268],
            [13.960908018622174, 2.264666377603837],
            [13.959039545327078, 2.2570816619988543],
            [13.955380514019724, 2.2508240467067013],
            [13.95264460198437, 2.249625550192939],
            [13.937208365747484, 2.2468399195607174],
            [13.933467881118043, 2.2428009603268753],
            [13.934013248694194, 2.2404364201828697],
            [13.942343817885783, 2.2339390921515125],
            [13.94057681775035, 2.2276400514953765],
            [13.933680220242833, 2.2214967069251226],
            [13.928559819072662, 2.213012605719201],
            [13.923921300012246, 2.2073442283347906],
            [13.919642636360782, 2.196657054217456],
            [13.920402357250346, 2.1877788372959777],
            [13.918341254495434, 2.1844573916693877],
            [13.905879132298056, 2.1838033501774965],
            [13.885339570716567, 2.1893124234080656],
            [13.864763389142148, 2.1925042624185025],
            [13.864062438618507, 2.1969314886886697],
            [13.85727446596081, 2.198686930379823],
            [13.853287286809849, 2.203370245971652],
            [13.85759331323381, 2.2037263463973815],
            [13.857124266545735, 2.2077587569634827],
            [13.846788000760272, 2.2084144007628193],
            [13.84344889298969, 2.210216858461864],
            [13.845240263505545, 2.2144271008686722],
            [13.848721576931151, 2.2142082773641008],
            [13.85590435580128, 2.219065929008949],
            [13.859736110321737, 2.2181519954858615],
            [13.859697338030767, 2.2222631544350446],
            [13.856915021771405, 2.225786948531306],
            [13.850286671039775, 2.229859930577684],
            [13.854797853125232, 2.2360201763531453],
            [13.862623410958188, 2.2331425425387454],
            [13.868443471469602, 2.238383037958285],
            [13.868077025649235, 2.2473094765824766],
            [13.864232500627283, 2.253935548233724],
            [13.865378840791312, 2.2569589905137644],
            [13.862087605618282, 2.260250086572493],
            [13.856203431036487, 2.2637537264895444],
            [13.853158880524072, 2.2670524378020502],
            [13.849970895977037, 2.274031956983558],
            [13.846241116517515, 2.271125914781959],
            [13.842906248671305, 2.2712271284825554],
            [13.842005906502678, 2.276540772060152]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.81380759492211,
          "lat": 39.603627466951096
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24043"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01714220"
      },
      "bbox": [
        13.842005906502678, 1.9676788650969514, 14.49625722005113,
        2.3999274248985003
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.978244109783878, 1.3245835466029638],
            [15.980372172572139, 1.3290212117712188],
            [15.984216842524129, 1.3316738660004168],
            [15.995675056651756, 1.3335604540497388],
            [15.996604498377115, 1.336540503945214],
            [15.99235478401126, 1.341414690143763],
            [15.984088913650364, 1.3471389166592922],
            [15.983431237901641, 1.3513220638058616],
            [15.983828535183855, 1.3693051327956425],
            [15.985333535563884, 1.3705346930497766],
            [15.996168490627268, 1.3735617683467214],
            [15.998717292228667, 1.3761297455094754],
            [16.000489439959548, 1.381430256745947],
            [16.00037132474178, 1.3873437620088604],
            [15.998505892848582, 1.3904270512192316],
            [15.993857575604787, 1.3924925312480065],
            [15.988680354181907, 1.3926289344549674],
            [15.984950939924126, 1.3966224505841602],
            [15.985640486492189, 1.4066140500268014],
            [15.99691561952412, 1.4149160333348971],
            [15.996320391199356, 1.4210519259553769],
            [15.989504148603043, 1.4264367093869128],
            [15.987828485666416, 1.4312512932583985],
            [15.992625609517766, 1.4403109148135962],
            [16.007421272341485, 1.4471978751491206],
            [16.014998420982476, 1.4583581662284912],
            [16.02688759325381, 1.4659692971083222],
            [16.030079199729037, 1.4704214969654177],
            [16.03179717587419, 1.4761571384533285],
            [16.030965504856333, 1.489838222916431],
            [16.035431363026287, 1.5001383903653096],
            [16.045012902921144, 1.5024617338954682],
            [16.050137313277713, 1.5068896786534853],
            [16.057610116842184, 1.5184712483127787],
            [16.05993904956883, 1.528961656190778],
            [16.063317166901307, 1.5298922586314851],
            [16.07371830816584, 1.4921384504509954],
            [16.090842820310915, 1.4318920773046542],
            [16.114486652600082, 1.4356597697359719],
            [16.139210924512437, 1.4401518983577317],
            [16.193145422846147, 1.4495063915018467],
            [16.23875307799007, 1.457997823673759],
            [16.29316757226496, 1.4684150958630784],
            [16.32700455988805, 1.4752947622144101],
            [16.359572691777377, 1.4823191598792258],
            [16.360581254895987, 1.479375378871395],
            [16.365815338162587, 1.4736864319289744],
            [16.36643653311811, 1.4677190691305124],
            [16.368679135067925, 1.466860057183357],
            [16.37383115446892, 1.4567925832973274],
            [16.380363854465497, 1.452301742989724],
            [16.38430837616911, 1.4470955146008986],
            [16.388262949633006, 1.4393162537175972],
            [16.388048855222006, 1.4328166269612337],
            [16.386097845926454, 1.4199089275442263],
            [16.383506513544564, 1.4153726491233323],
            [16.387170688850176, 1.4100111313692174],
            [16.39210171924516, 1.4056574802137753],
            [16.396500599956077, 1.4049921059644366],
            [16.400335379754424, 1.3960469026377327],
            [16.406704067263764, 1.3922339731397515],
            [16.403305374090777, 1.384365029697728],
            [16.39940798545201, 1.3669829910171547],
            [16.39699307748126, 1.3648902844832904],
            [16.39373775845393, 1.3657498264225314],
            [16.388680271217847, 1.3571197921483122],
            [16.388487151451255, 1.3524837519221597],
            [16.384779927433684, 1.3508062076825225],
            [16.379967595671502, 1.3461691620047553],
            [16.378398997298223, 1.3429769586606348],
            [16.378133536069644, 1.3275982640032769],
            [16.377012589615827, 1.3190950020386374],
            [16.3711225631297, 1.3171253748478216],
            [16.30816904803423, 1.299647314251893],
            [16.27915570107295, 1.290820466009192],
            [16.275938844523857, 1.2901395182648447],
            [16.19115281433195, 1.266234215781289],
            [16.18040256999451, 1.267678270781626],
            [16.173490544031296, 1.2730923990879963],
            [16.165294384380385, 1.271530678810472],
            [16.158974113951235, 1.2754648707099852],
            [16.15386718755772, 1.2753838951397853],
            [16.14890129569913, 1.2779332282464297],
            [16.141992300841178, 1.2710305241604611],
            [16.13589787932596, 1.269055604566209],
            [16.132164477849166, 1.265106933532273],
            [16.13366745375047, 1.262027037907375],
            [16.128565439886064, 1.2480524076196393],
            [16.13162449066312, 1.2411849154873345],
            [16.128241383269884, 1.2383881845437206],
            [16.12255192851008, 1.2385833454151534],
            [16.119383951975312, 1.2361983999133441],
            [16.11628444647513, 1.2380586591237426],
            [16.111530849794498, 1.2370721829253015],
            [16.104734932170146, 1.2441431660241473],
            [16.103422799492737, 1.2483493987281737],
            [16.097718459935358, 1.2505046187540962],
            [16.09402574038671, 1.2459051609679257],
            [16.083809932899296, 1.2464799821358534],
            [16.082093422557296, 1.249609338200152],
            [16.07520638154723, 1.2486606048705158],
            [16.070511229666554, 1.2455667421537187],
            [16.071396893431892, 1.2380848414883525],
            [16.06900691505889, 1.2309302253693215],
            [16.06553894865659, 1.227517452743973],
            [16.054869886252238, 1.2238013785228172],
            [16.052704363176726, 1.2127362262461419],
            [16.04533386661847, 1.2116341634942878],
            [16.04061540296064, 1.2146643936347554],
            [16.03585179105132, 1.2152756509766776],
            [16.032683657213408, 1.2119914515683456],
            [16.027409261111092, 1.208831100246297],
            [16.018756893117796, 1.2068721529719824],
            [16.016222594268697, 1.1966894486120483],
            [16.00703457090303, 1.1941346934465922],
            [16.003428173494935, 1.189432003600078],
            [16.000264454538097, 1.1913294636826122],
            [16.001424410903105, 1.1973617280235718],
            [15.995711238812024, 1.1993133011563366],
            [15.992765358864926, 1.1936688814961773],
            [15.992747980792927, 1.1880093782198122],
            [15.989527632216602, 1.1841970238982125],
            [15.990084338334274, 1.1793103976357806],
            [15.993462748977478, 1.1726258257521467],
            [15.99024997363897, 1.1700368109377],
            [15.986797667900921, 1.1703291944316019],
            [15.982831927809663, 1.1738984772727221],
            [15.973517483758382, 1.1870033241308457],
            [15.97073146469923, 1.1950472339736218],
            [15.96322439758712, 1.2010862031843372],
            [15.96405641731677, 1.2045615963251064],
            [15.968352825685697, 1.2118417908103967],
            [15.97029351638781, 1.2261298644374978],
            [15.969036880551338, 1.2284612239577233],
            [15.96373061491411, 1.231175092243696],
            [15.968464628866831, 1.2412435292822017],
            [15.971710557571411, 1.2503177000780918],
            [15.971788997624122, 1.2530306262568858],
            [15.975513151625595, 1.2717377321632888],
            [15.979138106261418, 1.270687830487728],
            [15.983114975500982, 1.2732752325805627],
            [15.979921706866772, 1.2764044455041506],
            [15.982180232350208, 1.2868391564370485],
            [15.987298514376008, 1.2933289460604431],
            [15.991033771686894, 1.2961532367019686],
            [15.991857441675487, 1.3085528921989904],
            [15.99307033912375, 1.3125665479535187],
            [15.986113664035567, 1.3185740297262956],
            [15.980392135957684, 1.321481187034895],
            [15.978244109783878, 1.3245835466029638]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.62076278519261, "lat": 38.37328506431039 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24045"],
        "coty_name": ["Wicomico"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wicomico County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01668606"
      },
      "bbox": [
        15.96322439758712, 1.1700368109377, 16.406704067263764,
        1.5298922586314851
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.86363637075567, 8.170145745037455],
              [6.8704356439360925, 8.180203425648406],
              [6.875406502318054, 8.182546702787478],
              [6.879144763582596, 8.186012669880126],
              [6.883045800384389, 8.187579223248191],
              [6.88519394911485, 8.184049686728489],
              [6.891626552766807, 8.184256259867421],
              [6.8986550076365845, 8.18695669830331],
              [6.900354658758017, 8.189076835338666],
              [6.906065491303721, 8.182869823607607],
              [6.906805873659773, 8.179881367811735],
              [6.9120575363688435, 8.176134199070363],
              [6.917085720116644, 8.168099556686675],
              [6.921437940146724, 8.165561729850717],
              [6.920163889920836, 8.158812735701213],
              [6.9210564611774466, 8.148339537281037],
              [6.9188196231554615, 8.135609504711695],
              [6.915461665460541, 8.131971329550193],
              [6.9120257575447965, 8.117625575119604],
              [6.914124860003366, 8.114710279153101],
              [6.9204699140779775, 8.109555937846089],
              [6.92574395678998, 8.109330274193445],
              [6.9306835369803625, 8.1199021577792],
              [6.93502585991309, 8.1264826417639],
              [6.937004150034273, 8.125982425454016],
              [6.939390259837809, 8.116754790160766],
              [6.940547069492235, 8.108724357814664],
              [6.939403151970621, 8.101662131918822],
              [6.931370465914511, 8.08877441255764],
              [6.926925145085983, 8.087851833879538],
              [6.9233343571417985, 8.084982411305068],
              [6.919405514382946, 8.08549088283357],
              [6.913783177215349, 8.09306305011738],
              [6.918181617199779, 8.095279707299856],
              [6.921085775503466, 8.102546498670373],
              [6.906985641419398, 8.100843841570843],
              [6.9046970790833235, 8.09980800390835],
              [6.902609437258289, 8.08929152117241],
              [6.898529720372606, 8.07971626108096],
              [6.894952127160409, 8.080017389749608],
              [6.887039793068672, 8.084171403768883],
              [6.885656257969515, 8.091444029089928],
              [6.885810844205185, 8.105615041401363],
              [6.8850299956338, 8.1141981244433],
              [6.885978744689918, 8.121076600284592],
              [6.884772426807377, 8.127012117895065],
              [6.876320080821148, 8.130039939395417],
              [6.872021437479617, 8.137252506087966],
              [6.8715792627332055, 8.142153107405834],
              [6.868418282466985, 8.151366837996425],
              [6.868566692303763, 8.154493910499061],
              [6.863672726454054, 8.166818780863796],
              [6.86363637075567, 8.170145745037455]
            ]
          ],
          [
            [
              [6.839626460028097, 8.138459501706029],
              [6.842766189238398, 8.138992157435725],
              [6.847544926475267, 8.134810577654557],
              [6.848496189419358, 8.127784285320189],
              [6.843385959795148, 8.128600899951612],
              [6.84005894588086, 8.134806431355718],
              [6.839626460028097, 8.138459501706029]
            ]
          ],
          [
            [
              [6.738002907656307, 8.101178265844354],
              [6.741097643915162, 8.10264969593466],
              [6.744637120400444, 8.10021874267742],
              [6.742080532364609, 8.096032502037264],
              [6.7389435765604855, 8.097617357161683],
              [6.738002907656307, 8.101178265844354]
            ]
          ],
          [
            [
              [6.588399878873013, 8.094043117791587],
              [6.596324074854058, 8.097835633765564],
              [6.5974894431901845, 8.102233845915086],
              [6.608679072728662, 8.112007201699571],
              [6.611199261896215, 8.119154747705982],
              [6.6135348168530665, 8.11673541560216],
              [6.623661064507997, 8.119196901726964],
              [6.625370889870098, 8.120460951607015],
              [6.635942518506012, 8.123950392494086],
              [6.6395927959152905, 8.130138007271997],
              [6.641243863847324, 8.129211060078516],
              [6.648360019647319, 8.130607499530118],
              [6.651760372538346, 8.132952706817182],
              [6.650000929131865, 8.138856527708608],
              [6.659007282243042, 8.138223830788286],
              [6.661238108856177, 8.139652733280062],
              [6.665668044315861, 8.134826950194022],
              [6.669504118606211, 8.133485586807522],
              [6.677437791143266, 8.135667994561173],
              [6.681409796504782, 8.134242950461473],
              [6.686351240260761, 8.12797034449742],
              [6.690894617605932, 8.125191776449853],
              [6.692710618277068, 8.11851910838931],
              [6.698627737393778, 8.11102493440733],
              [6.701113263773633, 8.104187034587625],
              [6.708411227814911, 8.09060176715151],
              [6.7049792621894415, 8.088573434296318],
              [6.707107766021141, 8.082613349359717],
              [6.710408760002796, 8.080158765159444],
              [6.717324479316684, 8.078609955819532],
              [6.721125977170945, 8.076504696915725],
              [6.72767166572153, 8.077116597582208],
              [6.733746717242219, 8.079649162427524],
              [6.737467420114891, 8.079614912384482],
              [6.739941473239418, 8.077230787291219],
              [6.748020352157341, 8.073446974125869],
              [6.748432349605513, 8.069511872970553],
              [6.752506233396465, 8.06600772889121],
              [6.751613283526987, 8.05922338312332],
              [6.756364694920586, 8.054477310613288],
              [6.759884757279663, 8.053125546820539],
              [6.777412499241275, 8.051658561000572],
              [6.786116335887335, 8.0525627992675],
              [6.796543847246863, 8.055471706927158],
              [6.800495476179036, 8.057617616221007],
              [6.8027659688701965, 8.066086961673253],
              [6.801674154840873, 8.072471480906376],
              [6.8032346642699135, 8.074348275831797],
              [6.8032665685263165, 8.080419840672532],
              [6.80545436818012, 8.08205435919631],
              [6.806299683746181, 8.08672003274114],
              [6.815993453978283, 8.098622111694759],
              [6.820161324356215, 8.098851858464599],
              [6.829191363526407, 8.101225896850877],
              [6.830941790230534, 8.100601309378357],
              [6.838769482978671, 8.102667279563356],
              [6.8418070384653005, 8.102480759156078],
              [6.847932028521646, 8.099557922221583],
              [6.851962946168967, 8.099616732597452],
              [6.855622058031237, 8.096528218998216],
              [6.855356842796159, 8.090390361762035],
              [6.859070717997903, 8.08626257308711],
              [6.865972617313572, 8.081482749267593],
              [6.872342648634407, 8.071512936490008],
              [6.877930843658711, 8.066569439835972],
              [6.881505568506911, 8.066168801889926],
              [6.891624253999968, 8.067670133871129],
              [6.9007176745115615, 8.074974144286415],
              [6.907375246399495, 8.074405380851253],
              [6.910583268636566, 8.072849453699904],
              [6.913390039775434, 8.06223567966085],
              [6.907625059109895, 8.05216344327725],
              [6.908191203323594, 8.048967117018517],
              [6.916354212406419, 8.043259896761572],
              [6.920979346253803, 8.042411070734163],
              [6.925422274312264, 8.043723846058585],
              [6.930110968996672, 8.052492266062345],
              [6.930207395486723, 8.056484643392508],
              [6.932679925077062, 8.059002064144352],
              [6.943353884343887, 8.076870637685142],
              [6.94376605625245, 8.079348825193511],
              [6.9418641185428855, 8.085985992071246],
              [6.94391855205523, 8.087718491552845],
              [6.950516548014051, 8.087078880144812],
              [6.9534390749102375, 8.091671942602554],
              [6.958182961713438, 8.102747857161244],
              [6.966937168760011, 8.112836923503043],
              [6.972321494799141, 8.122532835671981],
              [6.976814033586604, 8.13199200172842],
              [6.979049221187601, 8.13180406938455],
              [6.989707690656903, 8.137787574604307],
              [6.989880686298547, 8.14020410797545],
              [6.993972689369903, 8.143426115127033],
              [6.99476142755664, 8.147292198000299],
              [7.0003266704601605, 8.154740931638248],
              [7.005979963593126, 8.157977535178977],
              [7.012574371241351, 8.164604878037373],
              [7.015561582710566, 8.172785355278029],
              [7.019057773242084, 8.176249009395145],
              [7.019791022950653, 8.183010178551614],
              [7.022605113765806, 8.18640210700532],
              [7.026877619042749, 8.188710620408742],
              [7.02857389621809, 8.193550383967327],
              [7.032691424685495, 8.194970161181855],
              [7.038562065865505, 8.19411065789255],
              [7.04547952080809, 8.190126162804479],
              [7.062280768558524, 8.199514691426124],
              [7.06962946435537, 8.20459154560274],
              [7.080573650758743, 8.209399435912665],
              [7.106878433580822, 8.226763514691617],
              [7.1260340099194925, 8.242031209613781],
              [7.168067448157848, 8.277314422455989],
              [7.210111052283776, 8.312586152028352],
              [7.219525962459906, 8.322776355869046],
              [7.226566310008789, 8.32960796675429],
              [7.2422269984167595, 8.334649465936657],
              [7.24757893422909, 8.329361336723004],
              [7.25100476896819, 8.327988750795326],
              [7.256472637995078, 8.32057551569866],
              [7.266428031950749, 8.31873286510243],
              [7.278541486554685, 8.320938059200426],
              [7.298308900096381, 8.329028157887558],
              [7.312173334593828, 8.336631541827657],
              [7.319453216844771, 8.338634003692073],
              [7.34025227913269, 8.345557735960371],
              [7.355602509841844, 8.353368491858202],
              [7.356064020435017, 8.35028599939366],
              [7.348106297957465, 8.346219640127634],
              [7.3516129689636545, 8.3434339806438],
              [7.37145618373163, 8.351011376031451],
              [7.382208474820712, 8.357396095606186],
              [7.397658595739923, 8.364680256125649],
              [7.418632398383912, 8.37088952840605],
              [7.427853976900565, 8.3711402309197],
              [7.44726272692803, 8.189261836574444],
              [7.318427498427023, 8.176141019242275],
              [7.189597302412226, 8.162970369031607],
              [7.103827008310521, 8.154862807402715],
              [7.119826877126327, 7.998397614262621],
              [7.121355982684395, 7.98400591296589],
              [7.051840675340506, 7.9776307741027415],
              [6.948767488482947, 7.968173404033892],
              [6.9574587435768445, 7.882160359154987],
              [6.965798469571255, 7.796453093045314],
              [6.922592978846595, 7.792098743093142],
              [6.8506773968463905, 7.7853657368116025],
              [6.8127861807226, 7.7815155801104625],
              [6.713965237173336, 7.7725205496311105],
              [6.706618409675938, 7.771713813908478],
              [6.62000300040652, 7.763781359443774],
              [6.613309271440326, 7.832111214386838],
              [6.607859664492934, 7.892206124920942],
              [6.60237182052884, 7.949284649765778],
              [6.598127961256416, 7.992173766191275],
              [6.596438894491413, 8.011175816538918],
              [6.588399878873013, 8.094043117791587]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.60390939105338, "lat": 46.40864048968027 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26003"],
        "coty_name": ["Alger"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alger County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01622944"
      },
      "bbox": [
        6.588399878873013, 7.763781359443774, 7.44726272692803, 8.3711402309197
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.918432829173213, 6.948424670900609],
            [7.992452352770517, 6.9551651375126085],
            [8.034796203973496, 6.95927141612345],
            [8.039153572655716, 6.919305666697684],
            [8.044046167150835, 6.8726141950005175],
            [8.110004508482382, 6.8803738918106285],
            [8.190436873590318, 6.889399780065952],
            [8.2155436655768, 6.892800638073893],
            [8.272895796412277, 6.897882800253194],
            [8.300633242252822, 6.900964046191614],
            [8.310908369050555, 6.8151423981149],
            [8.316387284558196, 6.815659228695017],
            [8.316566413150326, 6.812695035101089],
            [8.322701082808894, 6.7608407159102395],
            [8.326439106049417, 6.732144285301244],
            [8.330745168435453, 6.703449433337016],
            [8.332332536524998, 6.68908493646501],
            [8.338058807660632, 6.646352113528827],
            [8.252510824162666, 6.637299714540133],
            [8.194582871015962, 6.630578459328102],
            [8.166442010482427, 6.627137708038808],
            [8.108679417228466, 6.620863773944559],
            [8.107061764642525, 6.620821166857837],
            [8.025466396648357, 6.612058006417383],
            [8.011239812542494, 6.604408376561908],
            [8.001230080553663, 6.600478523431674],
            [8.004899674306921, 6.596137138702923],
            [8.00862797999013, 6.5835195455915425],
            [8.008318002052546, 6.578508541897399],
            [8.012060710715266, 6.574407458707529],
            [8.011428896357563, 6.5702915382432625],
            [8.007909634517594, 6.569700742282312],
            [8.001851043355632, 6.562104571741571],
            [7.9963512132931385, 6.567168537997207],
            [7.993440247006591, 6.573871242283765],
            [7.989069026990384, 6.576136398708609],
            [7.982388331245927, 6.573140598826627],
            [7.974690917714972, 6.572478550210491],
            [7.970242890169574, 6.575550431519387],
            [7.968480878699332, 6.58048310634967],
            [7.96199475946343, 6.6049144135301345],
            [7.918978388470883, 6.600384874374215],
            [7.923608257244497, 6.609306011614851],
            [7.928721913732782, 6.623318669092867],
            [7.929432409073705, 6.628614319703922],
            [7.928746140760177, 6.636511786607038],
            [7.930353171429355, 6.639306951833224],
            [7.935516097403763, 6.642759382045379],
            [7.93944711463562, 6.653432832531258],
            [7.939893023434822, 6.662216092593734],
            [7.944310089479462, 6.674473643814934],
            [7.944588389084366, 6.6831665141328385],
            [7.94700616701633, 6.69182801657254],
            [7.945235721911767, 6.697017469254179],
            [7.94653946296811, 6.706280060360287],
            [7.948167948060423, 6.7094758108838795],
            [7.948800262611911, 6.721740505761029],
            [7.945784303370495, 6.732477351326818],
            [7.950230637364582, 6.747461229751755],
            [7.949687638252899, 6.751542239093532],
            [7.944491270540368, 6.761947481372244],
            [7.944546207213166, 6.766925268166003],
            [7.9430723519419395, 6.776367895927595],
            [7.943741935804103, 6.783446760598913],
            [7.942372331835839, 6.789106695422161],
            [7.943694608377951, 6.799196033450401],
            [7.949490522167578, 6.812474797979957],
            [7.949528044137007, 6.8156000005359],
            [7.946103088243791, 6.819929428009719],
            [7.947496609112067, 6.826596667582673],
            [7.946812240064811, 6.855455119723328],
            [7.9388174958538995, 6.869181889450143],
            [7.934023754402357, 6.884412904157444],
            [7.930781985664525, 6.887604638134579],
            [7.931577266933963, 6.8937359027833365],
            [7.929620688788692, 6.911759927186305],
            [7.927191377136166, 6.922517340970632],
            [7.923818145107825, 6.929647994871619],
            [7.920630911239457, 6.93243938781922],
            [7.921205662267095, 6.9382907597138255],
            [7.920010529287331, 6.946299209562611],
            [7.918432829173213, 6.948424670900609]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.14014852096854, "lat": 44.99905425946403 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26009"],
        "coty_name": ["Antrim"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Antrim County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01622947"
      },
      "bbox": [
        7.918432829173213, 6.562104571741571, 8.338058807660632,
        6.95927141612345
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.20689009201242, 4.8831157753251535],
            [8.270467925588829, 4.891163953542768],
            [8.300140377753257, 4.894429911941419],
            [8.378031916713779, 4.90401891052722],
            [8.464151075159387, 4.913369896706708],
            [8.549923744302596, 4.92263580689237],
            [8.555660965666222, 4.8723871383407324],
            [8.559553405125035, 4.83680296841574],
            [8.57002169485516, 4.748340208568523],
            [8.584874550564678, 4.626293977235963],
            [8.590836687392802, 4.575877855846595],
            [8.504778851084593, 4.56579102686834],
            [8.418908056632992, 4.556180461845094],
            [8.333050759586541, 4.545316730955115],
            [8.276186774689439, 4.538851808100215],
            [8.248358111599362, 4.5358488366465295],
            [8.244258190344423, 4.567354120765029],
            [8.243029802830964, 4.5791149522654795],
            [8.239073100867058, 4.607895826612654],
            [8.234755455749958, 4.6430439019499925],
            [8.222299551192759, 4.750809101945431],
            [8.217025179737885, 4.7944594415401145],
            [8.20689009201242, 4.8831157753251535]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.07461486955377,
          "lat": 42.945079102202044
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26067"],
        "coty_name": ["Ionia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ionia County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01622976"
      },
      "bbox": [
        8.20689009201242, 4.5358488366465295, 8.590836687392802,
        4.92263580689237
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5297080219777732, 5.246315519997562],
            [3.5940220859303853, 5.249223740059553],
            [3.643942042812657, 5.251615636180149],
            [3.7006872233084884, 5.254175084134652],
            [3.76479860568859, 5.257175353227763],
            [3.7943947464100263, 5.258806585974316],
            [3.849927421544077, 5.261530078502435],
            [3.85501488514999, 5.252448554577394],
            [3.85706211268745, 5.239661602056597],
            [3.8602717093162053, 5.228708658015059],
            [3.86405405852743, 5.219285509143566],
            [3.8663977809893457, 5.215597499670764],
            [3.868243892526943, 5.207479597530223],
            [3.8822632390049927, 5.190657072885054],
            [3.8824739317749137, 5.18904453721531],
            [3.8756431312112998, 5.160497274366583],
            [3.8765909539123293, 5.149185777469666],
            [3.8749224341413773, 5.141219453401209],
            [3.872685129856336, 5.134928520882322],
            [3.8692087163281648, 5.129204762729893],
            [3.8680367208780506, 5.125017517969159],
            [3.8692216893724125, 5.110882993051053],
            [3.866613973894046, 5.091680856533302],
            [3.8667450117881113, 5.08168523807407],
            [3.8684102454542835, 5.070054487019993],
            [3.8744526106400254, 5.06307513939992],
            [3.875413759151736, 5.053647624244386],
            [3.8721570787408104, 5.042615864981719],
            [3.8725475836576306, 5.030609718879155],
            [3.8754488798913846, 5.025372963904551],
            [3.8806870388447376, 5.019128323118625],
            [3.8846891392227465, 5.016200671972408],
            [3.8951712357914787, 5.0061003036322305],
            [3.9007878572833268, 4.998427678772984],
            [3.9013716430909446, 4.9922176759211965],
            [3.90096097413512, 4.981422744848167],
            [3.8958102264334435, 4.971298444463091],
            [3.8938201742063403, 4.965322107357292],
            [3.8947225025041776, 4.956527852829446],
            [3.899747967163442, 4.949384300971899],
            [3.9029267202414246, 4.940561097589038],
            [3.910678213911817, 4.934861054839985],
            [3.9147439465526, 4.9296351062294],
            [3.915091965080603, 4.917702139268153],
            [3.8932456049742616, 4.916570410527588],
            [3.886389495572894, 4.916702985907932],
            [3.7572172624203195, 4.910113821050103],
            [3.6603129520728674, 4.9053796624097705],
            [3.63157949499294, 4.904158843781277],
            [3.616195735619868, 4.903246834796598],
            [3.545473051108448, 4.900301461291438],
            [3.5441293912558254, 4.923371443590087],
            [3.5413289899231373, 4.986862353186823],
            [3.537307773170829, 5.073131478439954],
            [3.535004724970094, 5.13062916034646],
            [3.530140553783743, 5.235268055151018],
            [3.5297080219777732, 5.246315519997562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.4928880565165, "lat": 43.67143554264629 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27055"],
        "coty_name": ["Houston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Houston County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00659473"
      },
      "bbox": [
        3.5297080219777732, 4.900301461291438, 3.915091965080603,
        5.261530078502435
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.35246367901907194, 10.271623053199017],
            [-0.2845992631596356, 10.27067607511839],
            [-0.21963874436231354, 10.269990477779116],
            [-0.15467838609941373, 10.26929033822707],
            [-0.15468210393006357, 10.26885013600537],
            [-0.06787109583073067, 10.268072139983344],
            [0.019222458772877194, 10.26740964707887],
            [0.10758078032658408, 10.266858345235155],
            [0.1944283863048518, 10.266435046511335],
            [0.19401318039334522, 10.161887463758953],
            [0.19410490891934074, 10.077090680060762],
            [0.19357295420206586, 10.020544413737596],
            [0.19356077521652118, 9.991213852168194],
            [0.20520540771672838, 9.991195261328413],
            [0.20570831474152915, 9.977417663026818],
            [0.20506392654704875, 9.971367114224229],
            [0.2045316063281089, 9.935381805125775],
            [0.20448751427251188, 9.907502241148578],
            [0.20380030368557703, 9.89470903333387],
            [0.20426573509644802, 9.822823209465803],
            [0.1359963855329247, 9.822280646014885],
            [0.11219836002216921, 9.822558980556357],
            [0.09952023032319962, 9.822402100589526],
            [0.02924670367803317, 9.823152902069092],
            [-0.05840984175659407, 9.823651486158045],
            [-0.14615674691691408, 9.824138358507023],
            [-0.22682926046094418, 9.825693276883625],
            [-0.23318433781555806, 9.826038523718436],
            [-0.3144424651406278, 9.826658940948748],
            [-0.31629360976366566, 9.83177143493358],
            [-0.3138813395766978, 9.836546384894296],
            [-0.3094224803659072, 9.833627153685397],
            [-0.2994900796411982, 9.833648334662463],
            [-0.2977144145775021, 9.836629497764125],
            [-0.3028385492974986, 9.839546001668516],
            [-0.3159626402149258, 9.83954824310681],
            [-0.3202736504126251, 9.841502719211537],
            [-0.32235357994372404, 9.844789357943634],
            [-0.31934876445507054, 9.847367671290867],
            [-0.3064471743483624, 9.849637043055232],
            [-0.30387316258329594, 9.856427819595512],
            [-0.3049837860563986, 9.85867741870726],
            [-0.31202486961721415, 9.860846952050911],
            [-0.31083506126805477, 9.863994078155173],
            [-0.3041410044590697, 9.862671117038419],
            [-0.3004221411378802, 9.865263872169637],
            [-0.29944871909190834, 9.872160740101208],
            [-0.30184267927455793, 9.875355142127832],
            [-0.30679981850702054, 9.87526894330093],
            [-0.30566165069939544, 9.879315137461447],
            [-0.3008543982340115, 9.879526008183445],
            [-0.29471611090054683, 9.887243256389892],
            [-0.29649810033955404, 9.889724271892858],
            [-0.303706080583013, 9.889301870575338],
            [-0.3046769791369699, 9.89357259289675],
            [-0.3014982089286441, 9.895375830691396],
            [-0.2933974622383167, 9.894078495910623],
            [-0.2912548527599843, 9.897665241208113],
            [-0.2944669159937016, 9.900745567678047],
            [-0.2913601657656632, 9.903004187715819],
            [-0.2871981731740266, 9.898608039430023],
            [-0.2847542090198045, 9.902066620556493],
            [-0.29179354503364635, 9.909504482567757],
            [-0.2917402765796119, 9.912310397135183],
            [-0.28680900310235174, 9.913886010698729],
            [-0.28022058843113684, 9.910498344191998],
            [-0.2774160011410871, 9.912659601104098],
            [-0.2775455690493409, 9.918752407918308],
            [-0.2815306332674936, 9.924257029619826],
            [-0.27621652879747854, 9.927350845556962],
            [-0.27461881184565, 9.933447529279219],
            [-0.2704728300456681, 9.93834671743079],
            [-0.271209512962147, 9.941868358641903],
            [-0.27518039034204234, 9.941711126787458],
            [-0.27060056124117776, 9.950327505565527],
            [-0.2717966197630743, 9.959906509589262],
            [-0.2664292491573741, 9.96065787265107],
            [-0.2655389581670954, 9.964746851374265],
            [-0.27492065651263914, 9.968540663582678],
            [-0.2769692853082639, 9.97018406177896],
            [-0.283776522265451, 9.979757518568203],
            [-0.2840183291674122, 9.982083277597484],
            [-0.27854449202435433, 9.983627001577943],
            [-0.27697769436319125, 9.985855874682407],
            [-0.28293171036706743, 9.98940158235418],
            [-0.28776905382344176, 9.998958134768946],
            [-0.29469573105068136, 10.00384426778279],
            [-0.2904207370329938, 10.007128364135731],
            [-0.29013486037587977, 10.011741696912495],
            [-0.29516272929205206, 10.011805641456139],
            [-0.29804888508114785, 10.015010262300665],
            [-0.29455780102289403, 10.019317688881959],
            [-0.2940843358989503, 10.024087085404371],
            [-0.2953297746333783, 10.027416099565189],
            [-0.3025982655731044, 10.027619070179842],
            [-0.30513375246451385, 10.030072698297031],
            [-0.3062811249412491, 10.034535834592718],
            [-0.3011815687692975, 10.038673107619214],
            [-0.30026128307775485, 10.042436640345196],
            [-0.30462415155318556, 10.049302217744868],
            [-0.308411232789497, 10.050472902838976],
            [-0.30783431404533196, 10.053563566363104],
            [-0.30186659226808105, 10.055716612364385],
            [-0.30275861227569595, 10.058966810172878],
            [-0.3077653199655974, 10.059141518237912],
            [-0.30910757685579027, 10.062015555206468],
            [-0.3074175609314356, 10.066294702552646],
            [-0.3168149742320357, 10.068315827306877],
            [-0.3168461897080993, 10.072743917163962],
            [-0.31152787047470815, 10.072366189222471],
            [-0.31095023066658767, 10.076159999305803],
            [-0.31581213765534044, 10.07725140196904],
            [-0.31986752668025775, 10.073783169665143],
            [-0.3219138114382256, 10.077251672138916],
            [-0.31311588363172355, 10.081205305037079],
            [-0.3083134554774515, 10.08232803424562],
            [-0.3082765472728576, 10.086653610138749],
            [-0.3184451980239032, 10.08792195193048],
            [-0.3280676276357994, 10.092769425622697],
            [-0.32204084393788773, 10.095773620330561],
            [-0.3207558309059573, 10.10031609968409],
            [-0.32477885406816753, 10.105683299879894],
            [-0.3251194462843583, 10.108718589090394],
            [-0.3210451025185156, 10.110247991476554],
            [-0.3179694938560937, 10.113412777304868],
            [-0.3201217840278344, 10.120477638189872],
            [-0.317468489875479, 10.125056163647425],
            [-0.31790987677689236, 10.127877175852062],
            [-0.3212232562519991, 10.131892826306458],
            [-0.3214009064951521, 10.137554154003784],
            [-0.3284382489621949, 10.138065641378342],
            [-0.32742332104359084, 10.141757670729868],
            [-0.32175881807650425, 10.146811898636162],
            [-0.32134551600665084, 10.15113465708327],
            [-0.32782561617014955, 10.150749181167756],
            [-0.3338891858407543, 10.154411610070925],
            [-0.33306758038591905, 10.160672409354081],
            [-0.33588605739932925, 10.165596005426936],
            [-0.33078868790322286, 10.165167052631848],
            [-0.32788948008975255, 10.168180461063494],
            [-0.33089092507366896, 10.17237928812222],
            [-0.339721377524104, 10.176251046733672],
            [-0.3429901059015363, 10.181654614079708],
            [-0.3418552905198794, 10.189912387691395],
            [-0.34751684526478993, 10.195225114742671],
            [-0.3449040188564567, 10.205514993227686],
            [-0.34924092676950097, 10.205607675476163],
            [-0.352021903938723, 10.211154088078246],
            [-0.351686637549973, 10.218211492567262],
            [-0.35668442605041134, 10.220206043352896],
            [-0.35348440701790135, 10.236128410165179],
            [-0.3587744908773113, 10.237469450490982],
            [-0.3591142318545304, 10.254280512457154],
            [-0.35626036320935545, 10.260401358332746],
            [-0.3512093334312052, 10.264182910643612],
            [-0.35481017041857005, 10.266226003088507],
            [-0.355683973187029, 10.26934037799691],
            [-0.35246367901907194, 10.271623053199017]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.78282721151601, "lat": 48.77662294387787 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27069"],
        "coty_name": ["Kittson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kittson County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00659480"
      },
      "bbox": [
        -0.3591142318545304, 9.822280646014885, 0.20570831474152915,
        10.271623053199017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.4059025287206985, -5.080957105884312],
            [4.408907967209344, -5.075974180796123],
            [4.412751079115176, -5.0739538331544765],
            [4.420688538587796, -5.072254205677041],
            [4.427529496176742, -5.071775999652597],
            [4.44455795215359, -5.072930911806567],
            [4.450128975023213, -5.072842289887477],
            [4.4570900749663185, -5.071404266935603],
            [4.467754441938361, -5.06576392830369],
            [4.474009214306282, -5.060178690384272],
            [4.484549790149479, -5.048007895251551],
            [4.4877979662847824, -5.042901971961213],
            [4.490031156311685, -5.036266556250056],
            [4.4903637825641844, -5.0293463512877885],
            [4.4876032727966635, -5.020839099641361],
            [4.482180674716267, -5.011280988536157],
            [4.475043933389819, -5.00523335217698],
            [4.462744101012219, -4.99617326654299],
            [4.4524986997380305, -4.9898693631137485],
            [4.443629220587862, -4.9864843966327745],
            [4.434740896416945, -4.985170963319512],
            [4.42508885571899, -4.985336614809375],
            [4.418905152795043, -4.984263054496089],
            [4.413273240706978, -4.981365050405416],
            [4.408379079713438, -4.97651784138049],
            [4.404368342809985, -4.97062141839783],
            [4.402691104094116, -4.964790853975605],
            [4.402923138651851, -4.957546489648481],
            [4.407396960936048, -4.9478851933174015],
            [4.4121635148266085, -4.943368042787489],
            [4.417994597273076, -4.940661868488944],
            [4.42611340349721, -4.939320085529269],
            [4.440842305249345, -4.93834901298512],
            [4.450669044124267, -4.936968567648434],
            [4.4591637966059565, -4.9323497425186575],
            [4.473383716027726, -4.948713851142893],
            [4.4829309805582875, -4.961093767359801],
            [4.487419822037903, -4.964479488356905],
            [4.50282852298785, -4.971470044771937],
            [4.512421846783311, -4.976305329749964],
            [4.51862989753532, -4.978379092739171],
            [4.5248124603861735, -4.978346807640052],
            [4.5311657442292335, -4.9763309444988035],
            [4.5450714755542165, -4.968182298374319],
            [4.555145944055215, -4.965702104983443],
            [4.562906671130702, -4.962469947708977],
            [4.565200700620715, -4.96009773289814],
            [4.567310250760014, -4.954105706091264],
            [4.567353166889962, -4.945709224161247],
            [4.562598761499043, -4.944302025731767],
            [4.561194183129432, -4.939729811818449],
            [4.557755483375719, -4.933983194297309],
            [4.552251737337648, -4.927218237489566],
            [4.541066713667978, -4.919578775632898],
            [4.534807399542533, -4.918829706584191],
            [4.528751979942718, -4.921152572645143],
            [4.517270015457179, -4.9286121625446455],
            [4.507504639008733, -4.931582509180413],
            [4.494712882173926, -4.931885142063886],
            [4.487186533298073, -4.928328417269859],
            [4.475313800666252, -4.916579155783081],
            [4.467426737069983, -4.907051905307149],
            [4.468303032295221, -4.898427573025488],
            [4.4707973478470775, -4.89015572418943],
            [4.469558957288415, -4.887816040001077],
            [4.472142302874035, -4.882093933702176],
            [4.472536613145593, -4.877879165768576],
            [4.469092435008323, -4.874230821173442],
            [4.468708113994186, -4.870090828268653],
            [4.47084628970874, -4.864208237234737],
            [4.476931231729417, -4.854779378302165],
            [4.480691147000009, -4.853750128356802],
            [4.488299939552156, -4.856689552823573],
            [4.498632037835188, -4.8649055341979075],
            [4.529272940820777, -4.85994390608645],
            [4.543648374393348, -4.85597789117875],
            [4.5596343728685875, -4.865137767363991],
            [4.56702696237168, -4.868353321121464],
            [4.573249636774721, -4.868659454952819],
            [4.5782370886306705, -4.867386504637884],
            [4.587065031214126, -4.863473604770331],
            [4.5929627005351, -4.858108501942662],
            [4.594954136377533, -4.854797630010087],
            [4.596812652110809, -4.846921417732491],
            [4.593681276930345, -4.838977695502177],
            [4.589280682836359, -4.834843533632963],
            [4.581595313807168, -4.830114388174814],
            [4.568428576784057, -4.82775069654093],
            [4.559772725259044, -4.825482491510812],
            [4.551897277760846, -4.822066067026469],
            [4.545214630006697, -4.8179606802924715],
            [4.534436960059343, -4.803545810009459],
            [4.528136151223918, -4.793774853715296],
            [4.5262956156012555, -4.78947526499844],
            [4.523092619470346, -4.774748221608459],
            [4.523026992576544, -4.7675749730967185],
            [4.525208726318624, -4.762006413680972],
            [4.530688739179461, -4.755825533493192],
            [4.543451216045483, -4.745240494379814],
            [4.55281220895354, -4.734893600862078],
            [4.558719066113028, -4.72645789097023],
            [4.569220445702533, -4.7088919647942955],
            [4.5711355225980705, -4.70042915234636],
            [4.569500192242126, -4.695469215347085],
            [4.565693446361594, -4.691532792275957],
            [4.5598904154517985, -4.689327388638883],
            [4.5402620216544305, -4.686137198115752],
            [4.5137911002679605, -4.680818340419084],
            [4.508669739057312, -4.678767043153765],
            [4.505906615547167, -4.6759432989971925],
            [4.504044352310342, -4.670825685318781],
            [4.50199118330195, -4.643861871894352],
            [4.502722433682364, -4.635864838182222],
            [4.5047291155768345, -4.628636529116345],
            [4.506991905472257, -4.626013736919994],
            [4.514051322802134, -4.625540481159595],
            [4.5200606455142465, -4.6284717790905985],
            [4.530808921182936, -4.637857305008595],
            [4.536252968372438, -4.640819700323662],
            [4.546783349152944, -4.638673767143618],
            [4.560155410123157, -4.628969201410329],
            [4.565317823637662, -4.6385354477501295],
            [4.57758462303267, -4.665060192553959],
            [4.582077446362864, -4.668152757105112],
            [4.588952670563427, -4.670396720244498],
            [4.597007059689882, -4.669996605331321],
            [4.601873368742031, -4.668367251795604],
            [4.607429021376969, -4.66222117985559],
            [4.609030530371726, -4.653625925083424],
            [4.608560038787208, -4.649835419925263],
            [4.600199034962349, -4.638269683695422],
            [4.593564916120693, -4.633304652135413],
            [4.584583363002108, -4.611610964821591],
            [4.598293206419486, -4.604494973120834],
            [4.608809159549749, -4.602759366875647],
            [4.632192379228386, -4.606374170858743],
            [4.640882053785373, -4.606479471378574],
            [4.651872803584305, -4.6044753839466415],
            [4.659774505892314, -4.6015771838887005],
            [4.66374203955075, -4.598624700319667],
            [4.665884707942697, -4.594602167584327],
            [4.6672307988265525, -4.58710588888581],
            [4.666637737960602, -4.581143881387882],
            [4.664546005365055, -4.574632540720672],
            [4.666100652551921, -4.567697050828647],
            [4.6750646490528185, -4.553658626891051],
            [4.677406605404235, -4.5443422752576605],
            [4.676419650019818, -4.53888777662223],
            [4.672236508368703, -4.532816493865311],
            [4.667093790773001, -4.52936679248592],
            [4.658087061633837, -4.528663112293265],
            [4.6520163153324186, -4.532135023153107],
            [4.641503674653782, -4.534619457933559],
            [4.635531204023074, -4.534175617438745],
            [4.613010225580126, -4.519217493359252],
            [4.606039819218252, -4.510228845576273],
            [4.60512704076182, -4.509051571154442],
            [4.748696392177395, -4.500696395789666],
            [4.762534305296343, -4.501150346923104],
            [4.820426846468255, -4.498042186240769],
            [4.848955795640561, -4.4969949568388685],
            [4.851243552094197, -4.540895966355091],
            [4.85564546774861, -4.628692337711319],
            [4.858402022807272, -4.6285367596337865],
            [4.86122775126954, -4.678218377212504],
            [4.865117271571103, -4.76578660259364],
            [4.86857634056616, -4.832497008846375],
            [4.871598617337155, -4.893173109898803],
            [4.872503164103605, -4.899774528439107],
            [4.872797668742724, -4.910205370262616],
            [4.874642201436424, -4.938065346109124],
            [4.8780987933085465, -5.00074076872155],
            [4.791525202215067, -5.005653525160689],
            [4.792282211937414, -5.016589237365767],
            [4.796304450609248, -5.092572265755043],
            [4.747828893582666, -5.094726038982951],
            [4.704070543000085, -5.097638150748661],
            [4.696306681155645, -5.096943191689473],
            [4.645841399504821, -5.099876157687277],
            [4.6097434615531885, -5.101580917888045],
            [4.566357012889386, -5.1041858775206945],
            [4.420010532425063, -5.112348938407224],
            [4.410492165275112, -5.096641650393677],
            [4.406645158161258, -5.088840642448339],
            [4.4059025287206985, -5.080957105884312]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.88052131906389, "lat": 33.79708225403245 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28011"],
        "coty_name": ["Bolivar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bolivar County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00695730"
      },
      "bbox": [
        4.402691104094116, -5.112348938407224, 4.8780987933085465,
        -4.4969949568388685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.289636357326278, 0.7074187679620272],
            [3.3350718922709994, 0.7074510426235205],
            [3.353156883319153, 0.7070890998946426],
            [3.3872779046529273, 0.7068337511495539],
            [3.4501107422385817, 0.7068963401695699],
            [3.4941565398195644, 0.7080932201644304],
            [3.530473328589701, 0.7096483068070056],
            [3.5333526901947994, 0.7094100544709449],
            [3.5982333871008, 0.7104891185813391],
            [3.637190580021424, 0.7117303873535997],
            [3.668059209806563, 0.7131117320504398],
            [3.713586669813827, 0.7160962470471313],
            [3.7280571093857815, 0.7172240899968952],
            [3.743163212350993, 0.7176862588500954],
            [3.74344582101566, 0.7029289791090978],
            [3.815534318677851, 0.7059201069928733],
            [3.871206445971137, 0.7068953227106108],
            [3.91171055147036, 0.7072503124673079],
            [3.938275979554393, 0.7069719487401381],
            [3.9582275010575345, 0.7070775596969024],
            [3.9737606761957824, 0.6186565766254579],
            [3.9891679319987974, 0.5305136278514918],
            [3.956712745199804, 0.530124430249114],
            [3.9308148493552384, 0.5300560359657227],
            [3.8760430635147527, 0.5287553823672185],
            [3.8611707171979592, 0.5286543191275578],
            [3.819670836608874, 0.5278850668808956],
            [3.8204113299029516, 0.43817791617465673],
            [3.808103104248154, 0.4376374288513428],
            [3.7610198588846635, 0.43629164064559445],
            [3.735132440295854, 0.43535371194730077],
            [3.7124114334746454, 0.4350407471231124],
            [3.68966403423001, 0.4341849328151661],
            [3.644106582941133, 0.4327869438439241],
            [3.5571613215545113, 0.42957069692525696],
            [3.5135394227952186, 0.4287363940712982],
            [3.4688559118179114, 0.4281603050880164],
            [3.4541581841097, 0.4274630346294902],
            [3.4536298168202477, 0.44996815550723984],
            [3.4530570404182948, 0.5124603550023316],
            [3.453299924794521, 0.5240333351539379],
            [3.4528212186063754, 0.5324303085447399],
            [3.452322906162749, 0.5604440389762378],
            [3.451978810431806, 0.5634964272017846],
            [3.4515138333191397, 0.6047861107961175],
            [3.3791602445579163, 0.6044181461293401],
            [3.2902016808992616, 0.6050629997915543],
            [3.290550163947511, 0.608644757661833],
            [3.289636357326278, 0.7074187679620272]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.84156496239335, "lat": 39.2157296401855 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29007"],
        "coty_name": ["Audrain"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Audrain County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00758458"
      },
      "bbox": [
        3.289636357326278, 0.4274630346294902, 3.9891679319987974,
        0.7176862588500954
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8303512080598217, 1.067204258916906],
            [1.8304686662248901, 1.0823259013927877],
            [1.8300038545419834, 1.0887069900759927],
            [1.8296189523024693, 1.1107041468537078],
            [1.863671725087304, 1.110265921494003],
            [1.915421906741462, 1.1092437996069846],
            [1.9663526995954315, 1.110010951073082],
            [1.9988283188239466, 1.1108954817333987],
            [2.084903686400267, 1.1137972219147891],
            [2.169849459481429, 1.113606384689772],
            [2.171962981350406, 1.0264910977641237],
            [2.17329659792583, 0.9900049308202604],
            [2.174457151161926, 0.9388098495157137],
            [2.1758935899563507, 0.8511640526548666],
            [2.16145802656138, 0.8511946307101882],
            [2.0910562752073, 0.8505328100083638],
            [2.047591779692184, 0.8485117487894911],
            [2.003711528300678, 0.8471489855323153],
            [1.961014129598132, 0.8469617582157298],
            [1.91799239563359, 0.8469435515782525],
            [1.872608645340545, 0.8462901679117458],
            [1.8326357669564826, 0.846549305655138],
            [1.8329200888987545, 0.8611347565999432],
            [1.8323609605267919, 0.912272860885973],
            [1.8322283873404408, 0.9463598996431956],
            [1.8316403419926097, 0.9829699522312527],
            [1.8312952646726035, 1.022978933911469],
            [1.8303512080598217, 1.067204258916906]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.98271094640467, "lat": 39.6557450404636 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29025"],
        "coty_name": ["Caldwell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caldwell County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00758467"
      },
      "bbox": [
        1.8296189523024693, 0.8462901679117458, 2.1758935899563507,
        1.1137972219147891
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.901546201015435, -4.528890937252938],
            [7.904696322686345, -4.5274826982041585],
            [7.901064311914374, -4.519483006481312],
            [7.9064867996044494, -4.521084841272448],
            [7.909789969749114, -4.519126072639432],
            [7.910056633520673, -4.51468390437017],
            [7.9151833496333115, -4.518685141332848],
            [7.926141485375657, -4.517397389317639],
            [7.930467161496557, -4.513202288761327],
            [7.935498385297358, -4.510288375139242],
            [7.931948241833839, -4.507582559181861],
            [7.93473224989424, -4.499096979886228],
            [7.93264897107426, -4.488910907638201],
            [7.92723770087102, -4.486465315127302],
            [7.927437414479858, -4.478290748699768],
            [7.928626001371709, -4.474855683477042],
            [7.935759150714809, -4.467486507742895],
            [7.941941453648207, -4.470007122975553],
            [7.947929598315996, -4.4670194253460185],
            [7.958863930055123, -4.464184706803657],
            [7.960914891015393, -4.456129407418077],
            [7.957684246800958, -4.447608756179074],
            [7.964521704356773, -4.444032401703616],
            [7.971045034437149, -4.446241574858007],
            [7.977536863976572, -4.449950780431387],
            [7.978622331429877, -4.44470797069206],
            [7.982308306956435, -4.438907085677039],
            [7.991314037694322, -4.429176455336048],
            [7.9969104536369535, -4.4265288210354115],
            [8.004737163713164, -4.432218441585282],
            [8.010597236357473, -4.434531829863579],
            [8.012134639798294, -4.432177215059094],
            [8.006661697221944, -4.423458477956266],
            [8.008284295141399, -4.418858185128084],
            [8.017002594086728, -4.421625676243626],
            [8.023114901386744, -4.419819298325039],
            [8.028795838062674, -4.42153407924071],
            [8.034597989728685, -4.4195509341149855],
            [8.03556631148069, -4.414119082236277],
            [8.032324783778337, -4.4132786457093065],
            [8.032147185471965, -4.410065171356565],
            [8.037317160687348, -4.40690151672952],
            [8.03907377353433, -4.403722437026066],
            [8.04705626218861, -4.406694280710985],
            [8.048351071026195, -4.402855296757416],
            [8.044134935299152, -4.402034300373208],
            [8.044929362054352, -4.39897364345222],
            [8.053786237498452, -4.397237201422947],
            [8.054891451311832, -4.39505053087483],
            [8.053925570751291, -4.386357000057648],
            [8.057632748900973, -4.380782088926129],
            [8.05390121650066, -4.375776045521851],
            [8.062065135975631, -4.372647099780289],
            [8.06957531043254, -4.370875007101563],
            [8.070088283299135, -4.366223039849014],
            [8.066764920994528, -4.362796775365475],
            [8.067826048986072, -4.360490797060768],
            [8.075807804563114, -4.355027822943042],
            [8.082973160065736, -4.348466509738275],
            [8.080899118721836, -4.343581115112629],
            [8.083867292108657, -4.335590699190688],
            [8.085756658737907, -4.334987190774577],
            [8.092834688688244, -4.338052895693438],
            [8.095017814430848, -4.336747081782783],
            [8.098778189498468, -4.3308953114520135],
            [8.098571400616812, -4.326804607783625],
            [8.093341984501238, -4.3231214753155625],
            [8.091226989348087, -4.319679707592377],
            [8.094396332014474, -4.308534744185921],
            [8.098005793156203, -4.30519505721741],
            [8.108607092392493, -4.313295693882074],
            [8.11114984838285, -4.310594052693783],
            [8.10982520594039, -4.306007950713441],
            [8.104015213672, -4.300543778771507],
            [8.102475466306952, -4.2976010719148015],
            [8.095311679452607, -4.288626013747362],
            [8.092522079478638, -4.286926131139189],
            [8.09350432710229, -4.283739421535885],
            [8.098900898733598, -4.278810899756264],
            [8.10073103573256, -4.273312535751071],
            [8.104125595509819, -4.272781991885448],
            [8.105788441123902, -4.284600083276536],
            [8.115271726730553, -4.279010173769215],
            [8.117307910188801, -4.275726625096799],
            [8.121104163848596, -4.279972274403429],
            [8.129966725825776, -4.27120916706717],
            [8.131125139115381, -4.263735111494891],
            [8.131183470114681, -4.25536034166175],
            [8.138178217262736, -4.253330826572336],
            [8.143337205309361, -4.252875114530562],
            [8.141445496074455, -4.2489485525239905],
            [8.153671497130338, -4.238009099738766],
            [8.156421293909183, -4.237784102686797],
            [8.160649945279244, -4.241609912711556],
            [8.162953916084165, -4.2456378108663255],
            [8.165344537189197, -4.245342991711256],
            [8.168790964688709, -4.240761861656572],
            [8.172773378634467, -4.239323731069091],
            [8.173620190491745, -4.236533459950378],
            [8.169588098450768, -4.233436142593416],
            [8.173128710113673, -4.224915747942177],
            [8.176387553212956, -4.222403654054852],
            [8.180935133001055, -4.221213984503914],
            [8.181914979051971, -4.218936451835383],
            [8.17868040342967, -4.211578293314097],
            [8.183144662264112, -4.211679305855652],
            [8.18354885804238, -4.206501552155106],
            [8.186374376671914, -4.200838212338129],
            [8.189795572874923, -4.198595011121239],
            [8.190362706531626, -4.190723290755804],
            [8.19552585665181, -4.1848101012792105],
            [8.198124974462614, -4.184844848941838],
            [8.202910263225139, -4.175928240997651],
            [8.208372814192089, -4.172953704868452],
            [8.211673004232967, -4.166551581294441],
            [8.207145128207479, -4.167656714120288],
            [8.203659199076535, -4.166692331075482],
            [8.201711097277583, -4.16166079301492],
            [8.206905247199012, -4.156029973575428],
            [8.207224943976593, -4.153932454007804],
            [8.202434895540557, -4.149404759045818],
            [8.206464708845091, -4.147898794519129],
            [8.210811882875419, -4.142857783364113],
            [8.207719474676693, -4.139099720694795],
            [8.211390755476723, -4.136069380605186],
            [8.213763121887055, -4.1294082883166565],
            [8.225074826041382, -4.125963108694644],
            [8.225436119379905, -4.117884620093627],
            [8.222696701880361, -4.113791674959759],
            [8.22407570523068, -4.107822897281357],
            [8.226502942038847, -4.103333472412543],
            [8.226115664524853, -4.099958394313413],
            [8.232845714921247, -4.0961018209499676],
            [8.239491436285613, -4.097512694469022],
            [8.242673302807134, -4.101130595902455],
            [8.248522478447036, -4.0945449782321],
            [8.248245671501962, -4.092023636854903],
            [8.25178280251048, -4.088901091430992],
            [8.279686616973654, -4.086962766511806],
            [8.286958163034301, -4.086435502991848],
            [8.287360717185564, -4.095509625980821],
            [8.2949715443758, -4.105565493297321],
            [8.321103528043906, -4.137666295342852],
            [8.349355331374078, -4.166339602706064],
            [8.365420326440013, -4.182189003135135],
            [8.40052460079373, -4.218080398276864],
            [8.407015028857735, -4.221931358191365],
            [8.413681020345797, -4.230368338905896],
            [8.41810798664737, -4.234829994921245],
            [8.405186650377471, -4.263278109990221],
            [8.399886396756434, -4.289811628764113],
            [8.402555865648843, -4.3148411103714235],
            [8.405788851505108, -4.350182195079885],
            [8.403615448067534, -4.3527745153643185],
            [8.403175027885194, -4.359660050093901],
            [8.399345082119936, -4.359900101068939],
            [8.401869111447676, -4.365349991876245],
            [8.397901289506283, -4.369779547571571],
            [8.398232498105747, -4.3727439947163536],
            [8.393052941383564, -4.377719413658459],
            [8.395006040932241, -4.380418077410611],
            [8.391683234013264, -4.384271585188386],
            [8.387987307806611, -4.385503064020748],
            [8.386583257703554, -4.391725235069194],
            [8.379867285910318, -4.399607704455247],
            [8.4163079462001, -4.395524473967942],
            [8.414964256048094, -4.398576477283652],
            [8.419849774681197, -4.403205404742193],
            [8.4155605631286, -4.406241318411985],
            [8.41032609978873, -4.4166511203565975],
            [8.406540463592748, -4.4158871209775],
            [8.401933979920855, -4.421799623931441],
            [8.400133294602695, -4.430656608732292],
            [8.401914093209133, -4.436121637098075],
            [8.405139131314844, -4.439931412753569],
            [8.409703294743315, -4.441940004393303],
            [8.407808102150574, -4.45058625114463],
            [8.403935984571643, -4.45663249259191],
            [8.399619214661971, -4.4587458254585055],
            [8.397353413741726, -4.46234478753036],
            [8.390082511474253, -4.466118176548807],
            [8.387223154361822, -4.4725955081723185],
            [8.379250148078862, -4.4813883978584155],
            [8.371218759855786, -4.4883629280928785],
            [8.371568506125275, -4.491677958672185],
            [8.366540524346094, -4.499698522348273],
            [8.3627147719698, -4.502531871176606],
            [8.36106016367285, -4.506377260366071],
            [8.349228014401028, -4.51719448090124],
            [8.34401767877892, -4.521232084456332],
            [8.342838919716115, -4.524756327068499],
            [8.336635296956985, -4.524903466161874],
            [8.328878829672995, -4.5210730741804],
            [8.325141387896172, -4.523087889525451],
            [8.321059701099893, -4.52327287941048],
            [8.30977760391296, -4.526748796861706],
            [8.30218373566835, -4.533237626026999],
            [8.297374288092083, -4.535499628003536],
            [8.287708426250656, -4.537108632662489],
            [8.282551196441506, -4.541770036492627],
            [8.279331038588007, -4.539423359694978],
            [8.276073725162815, -4.540475274344309],
            [8.269475150623045, -4.549879452434643],
            [8.223700232348207, -4.55435489283372],
            [8.227132798676983, -4.591008005170117],
            [8.196972782122698, -4.594117386632032],
            [8.169614017266184, -4.596104022014167],
            [8.16882483981265, -4.589056477851016],
            [8.167136794614859, -4.586605323141053],
            [8.10455477667441, -4.550079356337722],
            [8.079231147971216, -4.535505029594664],
            [8.070826452581985, -4.53037558414022],
            [8.03479195581015, -4.533232177985448],
            [7.9681530827948235, -4.53764725669984],
            [7.927670958377126, -4.5696913141843085],
            [7.913610457669784, -4.5710437813747795],
            [7.912220406342325, -4.556114606206114],
            [7.910253877065584, -4.541539334531417],
            [7.903150195524316, -4.542211989222211],
            [7.901546201015435, -4.528890937252938]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.5674800921982, "lat": 33.98081573354594 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01009"],
        "coty_name": ["Blount"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blount County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00161530"
      },
      "bbox": [
        7.901064311914374, -4.596104022014167, 8.419849774681197,
        -4.086435502991848
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.639847943961419, -4.471360156829791],
            [8.653194717999078, -4.470568960152497],
            [8.65227206576642, -4.459456103183111],
            [8.674945309719286, -4.458289242299063],
            [8.673239982275101, -4.443723423034222],
            [8.69492631666662, -4.442655002746872],
            [8.693533281109136, -4.427953784231914],
            [8.699662318859687, -4.427704828948994],
            [8.700320828557983, -4.425545658140434],
            [8.699005388444691, -4.4131355418950164],
            [8.713265230749402, -4.412438798953684],
            [8.710962226304396, -4.390762698121262],
            [8.725322126326576, -4.390254795820168],
            [8.724546032018416, -4.38296271874769],
            [8.738704813479375, -4.381362291504896],
            [8.740423495660519, -4.395928699798655],
            [8.768849444662358, -4.392909541743149],
            [8.764856293313139, -4.356359217247114],
            [8.779419538517933, -4.354707801546822],
            [8.778730612690378, -4.347506876163665],
            [8.80772558574681, -4.344693745191702],
            [8.807122151843577, -4.33744307841103],
            [8.818145702926099, -4.340568832544198],
            [8.836667245939688, -4.344507585697319],
            [8.888027536215507, -4.348837626273395],
            [8.895618904532798, -4.350118513986573],
            [8.893650794348629, -4.316823497177787],
            [8.953352344847122, -4.315109240957255],
            [8.963723889375304, -4.314289940389856],
            [9.030571672750403, -4.311941836788914],
            [9.066492578666647, -4.310564493412593],
            [9.0675632356389, -4.3251602967072875],
            [9.071396905187632, -4.377567473281923],
            [9.014510362535683, -4.383214407335374],
            [9.016114088920693, -4.398080349519395],
            [8.987228670230037, -4.400148145721979],
            [8.990364994455398, -4.4295597101498],
            [9.032982000353824, -4.425479739880021],
            [9.037167162483092, -4.469301181937625],
            [9.022867389455966, -4.4706166450495495],
            [9.02440777690313, -4.485187204136182],
            [9.010099417151546, -4.486561548033645],
            [9.011393056305561, -4.501003935699973],
            [8.99762719344892, -4.502678012383074],
            [9.010795523801649, -4.626668413444537],
            [9.003891759030138, -4.62781107646341],
            [9.004561546023655, -4.635052415944271],
            [9.001577712988826, -4.638969572879879],
            [8.998065013826398, -4.639195707659208],
            [8.999049636454467, -4.650156961816118],
            [8.983324052307703, -4.651779151896373],
            [8.970319235407164, -4.65265153516082],
            [8.972541670979155, -4.667435083781331],
            [8.943701615629404, -4.66992401729954],
            [8.945593263888016, -4.683964520691318],
            [8.930908965437903, -4.684970054727484],
            [8.932328882142933, -4.698398748579334],
            [8.934178871529504, -4.72896747604653],
            [8.891434100155255, -4.733424005433457],
            [8.889496985032656, -4.704009395360872],
            [8.831832316393966, -4.70964470461103],
            [8.81335715124795, -4.711869892870638],
            [8.762923063530902, -4.717266352899643],
            [8.724585106319902, -4.720631553355626],
            [8.722335682279283, -4.709965295047947],
            [8.722525653708752, -4.706304799157368],
            [8.701110323299659, -4.70827620619166],
            [8.7010173743049, -4.697425165823215],
            [8.700063877637378, -4.693542637016058],
            [8.694032922187734, -4.677976351989697],
            [8.692887394075807, -4.6635972248351045],
            [8.686191231145854, -4.658349659913903],
            [8.683288126401873, -4.6544036449424295],
            [8.674774884989885, -4.6486713962631985],
            [8.672850696218418, -4.642590473363241],
            [8.66946320405879, -4.637482334392218],
            [8.591012169079479, -4.641108171074462],
            [8.591160605076931, -4.63057255245319],
            [8.58806175442926, -4.618120551944593],
            [8.589401501585163, -4.610957286065639],
            [8.593940449658742, -4.604211795492669],
            [8.59756412519636, -4.603920338258006],
            [8.60065856430953, -4.6067462895177265],
            [8.605517182963407, -4.6076141960360815],
            [8.609032327211064, -4.604657505639506],
            [8.608721679567314, -4.597676192628771],
            [8.61014888389748, -4.5939966475820455],
            [8.623136038754799, -4.57988843532225],
            [8.633862236986301, -4.5745085709368],
            [8.636873341987405, -4.57185815811526],
            [8.64057446223934, -4.564277433741223],
            [8.644646476325773, -4.558652529656915],
            [8.650709665867906, -4.553327858418971],
            [8.657895790559907, -4.549902270277116],
            [8.662989279551226, -4.549931164918303],
            [8.665575276028651, -4.548035649702147],
            [8.663980086783273, -4.539818538100136],
            [8.660145525194396, -4.533354454772022],
            [8.654829748767716, -4.5269291146348545],
            [8.651209383729208, -4.524164881041242],
            [8.64526204008466, -4.51565123943403],
            [8.64361223303842, -4.504546060689727],
            [8.646047858380529, -4.499068801012752],
            [8.651815569521675, -4.49131381399828],
            [8.652552499433883, -4.485267690775868],
            [8.648373306445475, -4.479464625095728],
            [8.645081109621296, -4.477151359651419],
            [8.63978493135864, -4.475748390598814],
            [8.639847943961419, -4.471360156829791]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.82603199893873,
          "lat": 33.771407134516515
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01015"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00161533"
      },
      "bbox": [
        8.58806175442926, -4.733424005433457, 9.071396905187632,
        -4.310564493412593
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.09199840085031, -4.493052079178924],
            [-15.085518144377062, -4.482451154216914],
            [-15.072200379500671, -4.469597910450658],
            [-15.069773561586294, -4.470798072959917],
            [-15.062974016304938, -4.479481917463895],
            [-15.059309984292385, -4.4803506169332845],
            [-15.046194715599496, -4.4863390879591964],
            [-15.038706062535141, -4.488260809768793],
            [-15.018309326279175, -4.4953212200851835],
            [-15.007078384501119, -4.500203157930851],
            [-15.004681419185387, -4.499468846691959],
            [-15.001194922946436, -4.494955482060847],
            [-14.975754241477777, -4.499542858815712],
            [-14.974273644705521, -4.492295488230172],
            [-14.96014740753528, -4.495106596218066],
            [-14.958680692626112, -4.487978012453254],
            [-14.937942988756818, -4.491801736765706],
            [-14.936443959910035, -4.484801043041114],
            [-14.92637971002104, -4.486634456301012],
            [-14.925697076374872, -4.476360080566615],
            [-14.927087816237607, -4.466224111036734],
            [-14.92368236184937, -4.452313995273612],
            [-14.920372361938751, -4.447729112551617],
            [-14.913737600776546, -4.4435469448074745],
            [-14.906391645488531, -4.435009848677992],
            [-14.901183445769759, -4.430944856293647],
            [-14.886650910640816, -4.426776921037586],
            [-14.868721727782443, -4.414547569558945],
            [-14.861795505491239, -4.409301405606764],
            [-14.85322909268107, -4.380663860973527],
            [-14.852471804934408, -4.376097933915858],
            [-14.845989094416522, -4.354400713365417],
            [-14.844649935259369, -4.3484669620605665],
            [-14.844886334174662, -4.343118742141823],
            [-14.852826165076605, -4.330824498022854],
            [-14.85406932567209, -4.318693442975413],
            [-14.851021936193284, -4.313868738496567],
            [-14.843078039721032, -4.306451337459471],
            [-14.839180902322939, -4.30006774100737],
            [-14.837079405010986, -4.28970308737234],
            [-14.837148347290313, -4.284132164406323],
            [-14.842411585753764, -4.280160718843102],
            [-14.847234993825033, -4.282388179696279],
            [-14.854868568909465, -4.28311723549861],
            [-14.856797425927807, -4.2807990502687865],
            [-14.85745233511179, -4.272186332958574],
            [-14.856155324182696, -4.248068104862719],
            [-14.858781656166327, -4.234146577003786],
            [-14.861787889259356, -4.226962402388475],
            [-14.86545901735193, -4.22176225653307],
            [-14.74681020254809, -4.244820191193769],
            [-14.746435551593658, -4.242911440672492],
            [-14.66223177839825, -4.259303169639102],
            [-14.612400600384504, -4.003905042785802],
            [-14.611738778248446, -4.004033527846266],
            [-14.57869365213524, -3.831096870341829],
            [-14.536529594481797, -3.8392161759698564],
            [-14.417339523582386, -3.8622122357895257],
            [-14.325887575638435, -3.879745967025995],
            [-14.341860031534512, -3.965508553168209],
            [-14.17404839671433, -3.9976050604108204],
            [-14.08700423613751, -4.013944067392216],
            [-13.960751459042275, -4.037321347694455],
            [-13.834495837541438, -4.06068258613352],
            [-13.833583817919475, -4.060895305581273],
            [-13.857085858043531, -4.186640518863429],
            [-13.8570242329333, -4.189112215230012],
            [-13.864673245227147, -4.231586009650875],
            [-13.881050891081953, -4.317979977278207],
            [-13.898092422889196, -4.410329870228522],
            [-13.909989715115826, -4.474668610231551],
            [-13.934294343375825, -4.606012357807288],
            [-13.944743954557774, -4.662850003746172],
            [-13.97646041943651, -4.8342706600107626],
            [-13.9927447311618, -4.921354492710982],
            [-14.008500567543358, -5.006612569487533],
            [-14.077714581734472, -5.380584444891297],
            [-14.200688610187923, -5.3068495810100496],
            [-14.299933360174904, -5.24756313889014],
            [-14.399161122011925, -5.188255417387286],
            [-14.422876679252155, -5.1735714201156835],
            [-14.561166589243335, -5.09075875746824],
            [-14.672107939149837, -5.023909286750367],
            [-14.783028476993534, -4.9570341260227995],
            [-14.878746245434092, -4.8995103964273605],
            [-14.974448851839604, -4.8419680341240054],
            [-15.088213120517748, -4.773762289187417],
            [-15.140638695089981, -4.7422370395873985],
            [-15.213475143654543, -4.698339111631054],
            [-15.211266152780814, -4.692875558462943],
            [-15.213348429353777, -4.68539691344462],
            [-15.211141135957263, -4.683732440368151],
            [-15.205777243290992, -4.685108147045843],
            [-15.201156513402413, -4.6829413266977875],
            [-15.199982784320342, -4.68004379851163],
            [-15.204523920776568, -4.677122659566187],
            [-15.207238725605956, -4.668709802287856],
            [-15.195745482592788, -4.6588090349379865],
            [-15.195009465009123, -4.655842241739712],
            [-15.197090823234157, -4.649409175280503],
            [-15.19485386719297, -4.647140922777006],
            [-15.187491616721237, -4.645591757945861],
            [-15.18293677693148, -4.640299062169313],
            [-15.183405366676938, -4.6351419806198555],
            [-15.180976366334884, -4.629631070864065],
            [-15.18924577735365, -4.632715920901443],
            [-15.192903182635298, -4.6353640214740555],
            [-15.196895495293308, -4.636034279054726],
            [-15.199762042021307, -4.634367375452148],
            [-15.20000041396221, -4.628951256583798],
            [-15.198247786796824, -4.625295941886487],
            [-15.190365871746716, -4.622540461792047],
            [-15.18689207123335, -4.617802619497389],
            [-15.188349617740664, -4.61481840709409],
            [-15.184104028314557, -4.608314535510862],
            [-15.182386262209334, -4.60299246803472],
            [-15.182935744483432, -4.597801169451621],
            [-15.187328770339313, -4.592637141858885],
            [-15.18571509680867, -4.578301145968346],
            [-15.183237377936145, -4.574488490366414],
            [-15.175848802670092, -4.572096690916474],
            [-15.169827782630701, -4.576655158880932],
            [-15.161550538966951, -4.575018287168787],
            [-15.160828659603276, -4.569881228118804],
            [-15.157684976384676, -4.567068963892215],
            [-15.153347170583979, -4.565593001356545],
            [-15.14371424450475, -4.560564486054974],
            [-15.142853717134818, -4.553859783138134],
            [-15.136261849418368, -4.5492567745642924],
            [-15.131378088696275, -4.547033801916186],
            [-15.126023961872072, -4.54208829324364],
            [-15.122267540346904, -4.534653410077872],
            [-15.120288761638058, -4.528417458115479],
            [-15.104796346155329, -4.510875301166289],
            [-15.103420899210413, -4.505570926069487],
            [-15.095672339008766, -4.498141765369877],
            [-15.09199840085031, -4.493052079178924]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.90563522149819,
          "lat": 32.769476946298965
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04027"],
        "coty_name": ["Yuma"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yuma County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00023901"
      },
      "bbox": [
        -15.213475143654543, -5.380584444891297, -13.833583817919475,
        -3.831096870341829
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2818145350956502, -4.887204950298864],
            [3.3659899374899727, -4.886927398956859],
            [3.450451794775546, -4.8864254113773695],
            [3.4871714961210114, -4.886843176817911],
            [3.489560867740562, -4.8935983397944876],
            [3.489748720956748, -4.90055456162343],
            [3.493721298488822, -4.903957128462449],
            [3.4926693951153203, -4.909133979380729],
            [3.4901671616230834, -4.910882457296566],
            [3.4882894964738265, -4.91630683778034],
            [3.4889332286659163, -4.923032193135179],
            [3.483010730857888, -4.936424064509797],
            [3.4862649163912187, -4.942575865859069],
            [3.4851296137954786, -4.945392230330181],
            [3.49077768527006, -4.950170366125197],
            [3.488136126606735, -4.954268796562023],
            [3.4919200345878685, -4.957259539478075],
            [3.493289198369476, -4.960794955685876],
            [3.4914438112441277, -4.970966260697395],
            [3.493312089811434, -4.974302608960103],
            [3.49407527967563, -4.98134463950458],
            [3.496490211815508, -4.985083546687675],
            [3.4953814045372598, -4.9871646717278715],
            [3.5009788183041133, -4.992931683205454],
            [3.503230093246953, -4.999439948835785],
            [3.502388829203033, -5.008107732930089],
            [3.498549996397389, -5.017426994794803],
            [3.499157312580888, -5.024613742989611],
            [3.50167193984661, -5.027390408128309],
            [3.501233353958612, -5.031791940831103],
            [3.5042615091860663, -5.03515310506213],
            [3.502158047221727, -5.041988219476888],
            [3.5045800072957527, -5.047812355586806],
            [3.5019718430550024, -5.055062245916208],
            [3.501974679976236, -5.059864071993776],
            [3.499471632275428, -5.063529528967973],
            [3.498424040232362, -5.0698855948399375],
            [3.4993581470055917, -5.078326663624768],
            [3.502351380586925, -5.088804385420779],
            [3.506298952080233, -5.096470273025632],
            [3.5041359877663587, -5.10972797555439],
            [3.50279705847461, -5.111174864705835],
            [3.5087188706324692, -5.11796711263385],
            [3.5096446455702868, -5.124159860295342],
            [3.5117087197073955, -5.128721588882338],
            [3.510346613721564, -5.134196476219567],
            [3.511043222892599, -5.140964889584332],
            [3.508600029869416, -5.144358422424153],
            [3.5067747446509663, -5.151997767631547],
            [3.506982411695835, -5.157810146226156],
            [3.5115483319225973, -5.162221797834204],
            [3.5141445562121927, -5.167976890973486],
            [3.512731934951628, -5.170618862886124],
            [3.517833383962843, -5.182043758491335],
            [3.516081334637613, -5.189059451435428],
            [3.509122802237866, -5.201215407893456],
            [3.5119247363303177, -5.206993154580377],
            [3.5114282974539903, -5.2134329056761155],
            [3.504872619730579, -5.2237857960572],
            [3.5066484882488256, -5.22980254545402],
            [3.504429694802465, -5.240495496210107],
            [3.5010666552292062, -5.241906197949756],
            [3.496051143850373, -5.252829330395493],
            [3.49788942324279, -5.259284869355358],
            [3.4960010336087692, -5.2684980255246305],
            [3.4923000636520474, -5.270001421014279],
            [3.4895991146867593, -5.273729910859236],
            [3.4873919657093007, -5.279555391172729],
            [3.4844545186615887, -5.282609370590968],
            [3.4848791669508956, -5.289001239764011],
            [3.4817952113669515, -5.2986761985879385],
            [3.4820672007747153, -5.3039539812860355],
            [3.479574528066269, -5.305545888731484],
            [3.475429469265487, -5.303275948282021],
            [3.4686492044250685, -5.307235734852996],
            [3.4683767882405143, -5.31113157845381],
            [3.4721082481125087, -5.315685834480731],
            [3.469388326457878, -5.318792795579133],
            [3.4676703273341274, -5.326000732779974],
            [3.4691683789535226, -5.327960234022566],
            [3.4660621842482437, -5.332899343461929],
            [3.465249269976843, -5.338063288008486],
            [3.465930443048022, -5.346730563365424],
            [3.4695573710063714, -5.346655115012626],
            [3.467622277494329, -5.353462425805496],
            [3.467340063162526, -5.358934949764917],
            [3.469789964195525, -5.367429240475197],
            [3.468966362958655, -5.369565911410991],
            [3.476525683083289, -5.372967863819376],
            [3.480410273066128, -5.378289533700917],
            [3.4868730775728833, -5.376568623666304],
            [3.4900167344696773, -5.378487722623086],
            [3.4931429531484226, -5.384687252378444],
            [3.488699132420529, -5.38204564596482],
            [3.4854470562226836, -5.38333429650586],
            [3.48508002487134, -5.39078758622544],
            [3.4823916723928674, -5.394041474274398],
            [3.4760282606787936, -5.39620542475336],
            [3.472807381773675, -5.403141964358172],
            [3.46918663404608, -5.405748661840429],
            [3.455057605677732, -5.408008440632868],
            [3.4493671855434966, -5.410672223005792],
            [3.4358136605771996, -5.41224889671816],
            [3.427846142326534, -5.416349355335396],
            [3.4267152040275253, -5.411575729721913],
            [3.423364374501189, -5.409373218065898],
            [3.420679276415808, -5.412044928524745],
            [3.415235853157937, -5.412093444472848],
            [3.4140936680305014, -5.404654269180902],
            [3.408438080659071, -5.399341567234508],
            [3.4057046934330653, -5.399862353042024],
            [3.40263778331912, -5.403772264300595],
            [3.400745073868243, -5.3999139998648],
            [3.391489615186639, -5.3937064358722395],
            [3.3950437244004745, -5.389558164778295],
            [3.40232626022866, -5.3843286262524614],
            [3.401202165024555, -5.380885967107684],
            [3.3965409260401027, -5.383555139125192],
            [3.392984811110955, -5.381539368053992],
            [3.3972116733844744, -5.3760500094986385],
            [3.402463644287843, -5.372043854596872],
            [3.402219235808023, -5.368222394338492],
            [3.399598114461029, -5.366741862829218],
            [3.395825407570783, -5.371917815094406],
            [3.3912657604848415, -5.371955123680339],
            [3.390393971685961, -5.36695321119211],
            [3.3857848580976766, -5.360121276285376],
            [3.3838668092899793, -5.359708577197815],
            [3.380185566491089, -5.364814296055889],
            [3.3808135556926358, -5.371297728762948],
            [3.375293873742368, -5.370821839607645],
            [3.3748007985050603, -5.3677396639167965],
            [3.3707013287036545, -5.362275362868044],
            [3.367948657299571, -5.360515760037418],
            [3.3638555163663857, -5.361649770107581],
            [3.360606963582389, -5.365350484539765],
            [3.3481487538986854, -5.371946676335304],
            [3.3459283458052136, -5.368299391513497],
            [3.3486679025556283, -5.360672009340547],
            [3.351624678857229, -5.358331470854647],
            [3.3507121843511296, -5.355446917460493],
            [3.345416490197797, -5.356418213886915],
            [3.34328241944832, -5.350515719563614],
            [3.3431457185445566, -5.345047995984509],
            [3.337711510618217, -5.340950335057087],
            [3.3398867722977914, -5.335966229139349],
            [3.338630547178825, -5.332813995946428],
            [3.334090243692371, -5.3331533361257755],
            [3.3281762045299064, -5.33002025982202],
            [3.327869304216576, -5.323797008115593],
            [3.3175254405279824, -5.328216278605032],
            [3.315464639323547, -5.3279755924833765],
            [3.310721099140543, -5.322890081018476],
            [3.3098613198350124, -5.319050954323368],
            [3.310442044066325, -5.312319053185589],
            [3.3072443822209956, -5.31136067102551],
            [3.3051279060649836, -5.317130546568895],
            [3.302010615795304, -5.3181442444760725],
            [3.298592952011871, -5.3156255187],
            [3.297976826854919, -5.310702097718907],
            [3.294323482960841, -5.305664632020647],
            [3.2966253173690996, -5.29963944171112],
            [3.2942295366682974, -5.292255441755598],
            [3.28905479834771, -5.287494645966754],
            [3.2818526950056435, -5.289347701127482],
            [3.2760776455861627, -5.289033600759562],
            [3.272130681435804, -5.286942719875865],
            [3.270449294042542, -5.283150067884286],
            [3.2673361795845626, -5.281885076964805],
            [3.264177001738849, -5.283717527557172],
            [3.2613844720188996, -5.2882966834306],
            [3.256462149265694, -5.290813104118776],
            [3.2527495656980894, -5.294505407392202],
            [3.247980525470735, -5.296028709596515],
            [3.2447765280913328, -5.294378847542288],
            [3.2434508091623533, -5.288625040970185],
            [3.2462652927895976, -5.285220535825484],
            [3.2509713243679643, -5.287754438322432],
            [3.2534749276843473, -5.286161367100308],
            [3.25373221662751, -5.280475117101813],
            [3.2519265741539036, -5.276844927725516],
            [3.245233621532749, -5.277185968550416],
            [3.243081316627423, -5.275158878977778],
            [3.2460495027924354, -5.2679425107657805],
            [3.243384705656783, -5.266847382227196],
            [3.2369478268705354, -5.269666810018354],
            [3.2388875258088166, -5.261362013850598],
            [3.235100758857259, -5.257117563106714],
            [3.2271838825947325, -5.2583076798746955],
            [3.2219605308656756, -5.261904203465337],
            [3.2182738523602206, -5.262558443162145],
            [3.2091698554887733, -5.26174644421297],
            [3.199615133589963, -5.263386900607322],
            [3.194526156818012, -5.263145485465067],
            [3.193287490025002, -5.260559745883837],
            [3.1937663846691935, -5.254760410214683],
            [3.1918696673677496, -5.248368789720266],
            [3.195440170853135, -5.240019411276461],
            [3.185393762188789, -5.242780958179684],
            [3.1837154394244322, -5.23732856326659],
            [3.1808692145130006, -5.234672357093513],
            [3.177783595925115, -5.234864669281045],
            [3.177539565249498, -5.2287035754173825],
            [3.180003350219451, -5.2269844817109865],
            [3.17904592618914, -5.219951767066169],
            [3.1828527103330857, -5.214642443573975],
            [3.182922059623515, -5.211338918061605],
            [3.1787437639218576, -5.20573114965942],
            [3.1720118560974835, -5.204766171255731],
            [3.1666170183607005, -5.199747259845935],
            [3.164756430809775, -5.201205648874198],
            [3.1667588210202755, -5.206163214728254],
            [3.162604564407078, -5.210929874555534],
            [3.15331485584986, -5.211216577697689],
            [3.1492322389331204, -5.206836221083449],
            [3.142266441538603, -5.20338022952188],
            [3.1424896570992056, -5.196458182645321],
            [3.145945844031123, -5.194065132983699],
            [3.149902215904107, -5.194521697461683],
            [3.1506055744075803, -5.191378109760801],
            [3.1449142688958776, -5.191910678295158],
            [3.1351721748783463, -5.184306612237947],
            [3.139415591510881, -5.1797718273057],
            [3.1437845236741193, -5.177128045747446],
            [3.142232191288135, -5.1697188227732],
            [3.1457851296736625, -5.164841617605252],
            [3.14379233207616, -5.162567096975399],
            [3.1374754106186518, -5.1624962876098826],
            [3.1315320768607173, -5.158609029753128],
            [3.13227990228716, -5.150078817083595],
            [3.1402532573991233, -5.142241017941755],
            [3.1450564303230504, -5.142960124633493],
            [3.1477123663548805, -5.14744108663829],
            [3.1516635720802575, -5.150974622970252],
            [3.1556963492440895, -5.149957078291217],
            [3.1600086351906445, -5.138423364273492],
            [3.171450928117612, -5.130598922335411],
            [3.171891492882057, -5.136274255665718],
            [3.1743939743707794, -5.139965872260455],
            [3.1786143171405783, -5.142302681805817],
            [3.1816481002200616, -5.137407114339363],
            [3.182784580319664, -5.131460726917588],
            [3.182278230462002, -5.126988966805366],
            [3.1840890450595603, -5.122421235433314],
            [3.184745209469081, -5.112244608048018],
            [3.1841751171093455, -5.099203255478238],
            [3.1815937781339607, -5.0938169817873735],
            [3.1804682611073476, -5.088643395919917],
            [3.1721488412067287, -5.085730637211319],
            [3.1658476247696004, -5.08050248033092],
            [3.1628700674337717, -5.074753541128803],
            [3.1634682305645527, -5.065380835889774],
            [3.165828910380178, -5.062643909974043],
            [3.165400267611213, -5.058927448507213],
            [3.169496623939615, -5.0537216692067295],
            [3.1700500622090084, -5.048513841051137],
            [3.1683348843825248, -5.046126341998891],
            [3.171159654479824, -5.042102274116762],
            [3.179003034538153, -5.038772645460911],
            [3.1874708193283525, -5.044129217273214],
            [3.1922801772110034, -5.042143856538393],
            [3.201102827384511, -5.034894049392646],
            [3.2047298092703156, -5.032842501100966],
            [3.2120679212329026, -5.034725223093239],
            [3.2146007812612676, -5.032114038678998],
            [3.218417167098058, -5.032846087326504],
            [3.223626486855548, -5.031102730172125],
            [3.2295048025749313, -5.0311897705622695],
            [3.2331930073808492, -5.028088626245227],
            [3.23391129190216, -5.022479500592958],
            [3.2364513204834453, -5.019961610204839],
            [3.237159587544586, -5.015478115315158],
            [3.2419526643058916, -5.006368826104814],
            [3.244196530619167, -4.998452427281828],
            [3.248794701842935, -4.995085144214784],
            [3.2548634371306977, -4.993029925260429],
            [3.25721957038649, -4.987702294144953],
            [3.265942462956482, -4.984802931808505],
            [3.270936055587702, -4.975235991721881],
            [3.2729577260753913, -4.9647202327439555],
            [3.2778934585149893, -4.96386315791032],
            [3.281203372506577, -4.958592585516214],
            [3.2823039657763373, -4.953305534044201],
            [3.282074716812826, -4.938136708430904],
            [3.2818145350956502, -4.887204950298864]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.50292238104508, "lat": 33.55810828252908 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05013"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00063758"
      },
      "bbox": [
        3.1315320768607173, -5.416349355335396, 3.517833383962843,
        -4.8864254113773695
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.151369248958641, -2.4707697689021977],
            [2.165776778928328, -2.4707470535626284],
            [2.1648435143891724, -2.4107828582240214],
            [2.164836812721026, -2.3976031469720995],
            [2.2078814209158963, -2.3974456557159414],
            [2.2502526368578692, -2.3983913413102997],
            [2.306891244761885, -2.3976155439203835],
            [2.3336502774966563, -2.398015456232355],
            [2.3359837133807697, -2.401825875348894],
            [2.331773049959725, -2.4066802219963477],
            [2.3347617501368148, -2.4134737812828715],
            [2.3338077188137474, -2.4158256595859817],
            [2.3289855472475236, -2.417683466693781],
            [2.3294667160114484, -2.4244791664392435],
            [2.336275401099398, -2.425212481780971],
            [2.3390802189906377, -2.4238832646238415],
            [2.339494729884703, -2.4202624539446744],
            [2.342690231072101, -2.418493678920627],
            [2.345864806305698, -2.4229346108670144],
            [2.3473049083143795, -2.4179395176372034],
            [2.351719049319807, -2.4215242422866257],
            [2.3555487638923633, -2.42280195762762],
            [2.3512090551080003, -2.4289245217960977],
            [2.3512570553209837, -2.43319565946528],
            [2.3567427647018646, -2.4398776940048155],
            [2.360120395775038, -2.4416022416201995],
            [2.366135417974783, -2.4417413814564184],
            [2.366188733880518, -2.49987341136212],
            [2.373241111766836, -2.4998650786163887],
            [2.373253488303083, -2.514502379132613],
            [2.39470389150955, -2.5148645535145446],
            [2.394956776375899, -2.5451232438497153],
            [2.422781634990961, -2.5451027920770337],
            [2.4232212267879456, -2.5740545055402024],
            [2.4805431360704295, -2.5737846841703957],
            [2.481104609756446, -2.6176458157187708],
            [2.508767706306307, -2.617681612143478],
            [2.507507325250328, -2.6452291674818804],
            [2.507918483502182, -2.673523547909408],
            [2.5080686621874193, -2.7030370605887355],
            [2.5077935179255944, -2.7319657644618687],
            [2.49392754901258, -2.732250356822307],
            [2.4940651691097573, -2.7467935683903093],
            [2.4797573176961025, -2.746973315944709],
            [2.479980051949523, -2.7762335743813398],
            [2.4655638933991537, -2.7757972512836173],
            [2.465962964459997, -2.7904274031422784],
            [2.465822383276806, -2.820272022978474],
            [2.4516473538369614, -2.820153268707582],
            [2.4512331640546097, -2.8785138746651677],
            [2.4584692496648874, -2.878638935165893],
            [2.458336230116829, -2.9389773280495555],
            [2.316194590434821, -2.9373767624039195],
            [2.232218800929877, -2.936000255954902],
            [2.1434629611461, -2.935640807485896],
            [2.1435838391032287, -2.9503010888628167],
            [2.101576084185961, -2.9499488093814157],
            [2.1019611910578155, -2.8771022691052717],
            [2.108997601137826, -2.8770912604861665],
            [2.109271091183299, -2.7858112028113062],
            [2.109617954627681, -2.716212847072617],
            [2.1094633521164563, -2.6746824668940037],
            [2.109601451403963, -2.6169308997352827],
            [2.1399821973124893, -2.510994578919495],
            [2.151369248958641, -2.4707697689021977]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.72458122516703, "lat": 36.01104839562387 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05087"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00069165"
      },
      "bbox": [
        2.101576084185961, -2.9503010888628167, 2.508767706306307,
        -2.3974456557159414
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.597907953193896, 1.2933103166295672],
            [-17.733557907316023, 1.2104693423630335],
            [-17.783788398800056, 1.1796213530375805],
            [-17.860302223571658, 1.1327733635544264],
            [-17.877064564248435, 1.068655401121668],
            [-17.90062348463672, 1.0746117665696922],
            [-17.909122143199735, 1.042228815511858],
            [-17.93634651758972, 1.0489621572510541],
            [-17.947184023153582, 1.0063812476800635],
            [-18.020308628530692, 1.0249119893278986],
            [-18.031675090330538, 1.02715240985649],
            [-18.14107943688884, 0.9601699226950936],
            [-18.141983538599785, 0.9597327241823403],
            [-18.31194026161272, 0.8552296455467132],
            [-18.31474857510254, 0.8610835990996278],
            [-18.315929170029992, 0.8717237711570495],
            [-18.319388799367168, 0.8752823650122789],
            [-18.320895241502186, 0.8802629952587782],
            [-18.326388250180116, 0.8900687806823341],
            [-18.328754844118205, 0.8967441085260809],
            [-18.33335536996196, 0.9019760044755205],
            [-18.342223223626178, 0.9067862510617866],
            [-18.346909888295666, 0.9116902115320228],
            [-18.355957712428797, 0.9179051934311502],
            [-18.367802936323443, 0.9281971411155892],
            [-18.384482961150155, 0.9507806104962345],
            [-18.387927759584105, 0.9567229879566113],
            [-18.3903180822287, 0.9666978204342414],
            [-18.390026601571467, 0.9768329509056057],
            [-18.38421496347679, 0.9869272614461377],
            [-18.385558567845813, 0.9973613707116618],
            [-18.394505098149992, 1.012467666007906],
            [-18.395740369141365, 1.0249046252778926],
            [-18.39828215652415, 1.0385051920107002],
            [-18.402061836307276, 1.0525267547456123],
            [-18.403597658682077, 1.0548246730508288],
            [-18.404347542593936, 1.0618319291014566],
            [-18.409741285319846, 1.0797748003604983],
            [-18.410598774631246, 1.086452629707207],
            [-18.41512756743901, 1.0930488450839888],
            [-18.416273852549956, 1.0987776773114666],
            [-18.419865217866143, 1.1101456737941562],
            [-18.422678911092156, 1.1299007838365234],
            [-18.426300369692704, 1.1338932290857662],
            [-18.427038266552607, 1.1368062274250121],
            [-18.42545780701654, 1.1448590896472488],
            [-18.419837346178582, 1.1475892490644797],
            [-18.415704979190206, 1.153955332669679],
            [-18.416711376247424, 1.1600081216080098],
            [-18.415562909150463, 1.168852997749895],
            [-18.417659394243117, 1.174564497291095],
            [-18.418430647793663, 1.180685475707512],
            [-18.421680875008036, 1.1934750137231291],
            [-18.424536752949418, 1.1986853312064059],
            [-18.422574513319603, 1.2029256540605646],
            [-18.42514417421349, 1.2056685750494862],
            [-18.42979938919489, 1.2135619338564105],
            [-18.43151656087417, 1.222739055499449],
            [-18.42920431080227, 1.2312600833656027],
            [-18.429494231166167, 1.2386385851119586],
            [-18.45045717159797, 1.3499498673433117],
            [-18.452808485470907, 1.3616609854614756],
            [-18.452678112856496, 1.361981645993849],
            [-18.45083310165126, 1.3624871386214898],
            [-18.44682998006219, 1.3690885409229758],
            [-18.441843559338864, 1.3728616131527192],
            [-18.438479680628184, 1.3775705838307852],
            [-18.44082708401799, 1.3832457283933663],
            [-18.443974165076558, 1.385056247188965],
            [-18.446351221368698, 1.3910662022576363],
            [-18.44866010651134, 1.401164402736654],
            [-18.445711840565203, 1.4036253019237939],
            [-18.44538070025922, 1.4080659920221896],
            [-18.443174558851744, 1.4115221307327452],
            [-18.43883193007176, 1.4117220352883852],
            [-18.43077850257286, 1.4048657805430944],
            [-18.424460212470382, 1.4037294525844215],
            [-18.423586236090394, 1.3951775698847675],
            [-18.417556887983952, 1.3963959216011215],
            [-18.41301700983228, 1.3907529200090782],
            [-18.411503381083147, 1.3818974235173158],
            [-18.40554602815697, 1.3726617425830618],
            [-18.405886334275568, 1.3701951684929237],
            [-18.401992189813473, 1.3646317016616167],
            [-18.39863345543678, 1.3646880908529688],
            [-18.387984619948018, 1.3682844166430195],
            [-18.38808101264609, 1.3755826534209545],
            [-18.382883466483595, 1.3771581371754402],
            [-18.38406547117833, 1.3851532999576257],
            [-18.387499578183967, 1.395678380834133],
            [-18.3874968319146, 1.3999298839724161],
            [-18.390926048350583, 1.4070962061973644],
            [-18.39267648639004, 1.4134385366514752],
            [-18.39273652352957, 1.4223095520247124],
            [-18.395825137172196, 1.425779921321785],
            [-18.395080421541905, 1.4339165809997108],
            [-18.397380098530526, 1.4425465875374701],
            [-18.38947119293578, 1.4422440602453719],
            [-18.38599441359094, 1.4444835535394653],
            [-18.38241301076288, 1.4399641835127353],
            [-18.378392400898996, 1.4390084967823704],
            [-18.372205059692728, 1.445436632530299],
            [-18.362807423786222, 1.4437103795240258],
            [-18.3576208973525, 1.4411291022145398],
            [-18.35120643637546, 1.4356785791761795],
            [-18.348417274396272, 1.4389797398896575],
            [-18.348872706411914, 1.4460214805492722],
            [-18.3450389812213, 1.4486596388658581],
            [-18.341206776513268, 1.4426583119461576],
            [-18.333381296380455, 1.4374839410723494],
            [-18.327086512791016, 1.4428559368554377],
            [-18.325229796074947, 1.4465124857070708],
            [-18.320968184308025, 1.4496545128463942],
            [-18.317841649049203, 1.4476999797337864],
            [-18.309928188416883, 1.4496504876893488],
            [-18.309576608642327, 1.45478029435019],
            [-18.307322213028534, 1.4593077360188187],
            [-18.30046459392147, 1.4579286853607427],
            [-18.298575155006432, 1.4538707746444952],
            [-18.29554939007062, 1.4564876578449772],
            [-18.290265388641448, 1.4542916775789514],
            [-18.28644461592087, 1.4557202230733253],
            [-18.284638615953607, 1.4531658680163684],
            [-18.278449257854028, 1.451532157448704],
            [-18.27541619074449, 1.4529846917027998],
            [-18.274375207763615, 1.456983371309215],
            [-18.26783661855329, 1.4537596604503116],
            [-18.26192386433846, 1.459536306408298],
            [-18.264489836903213, 1.4657068563512348],
            [-18.258599910038015, 1.4684519929929924],
            [-18.256267735815292, 1.4721076704976388],
            [-18.256830200060083, 1.4773492916014699],
            [-18.25300606447892, 1.4777831043261975],
            [-18.25016014324095, 1.4807514347095905],
            [-18.246956884056257, 1.4733822413697748],
            [-18.242307724612793, 1.4674348951333416],
            [-18.236194980902482, 1.4668434152045902],
            [-18.231353398237953, 1.4635004337589923],
            [-18.228502833687074, 1.4592957929096073],
            [-18.21723437691424, 1.4550601801584429],
            [-18.214041626857462, 1.4583214252306451],
            [-18.210559767811514, 1.4575875119609347],
            [-18.209880196211152, 1.46137224131987],
            [-18.203129501240216, 1.4640096103817226],
            [-18.197233391647554, 1.467864825275952],
            [-18.192686044964244, 1.46839062471962],
            [-18.18938808638586, 1.4749018245671726],
            [-18.180914647687107, 1.4774322879522133],
            [-18.181370566742682, 1.4812491813627207],
            [-18.179533847365796, 1.487099218407737],
            [-18.175304893430724, 1.487715473697178],
            [-18.17387308356447, 1.49100914905876],
            [-18.169480275002375, 1.491729227432408],
            [-18.160548397029093, 1.484595333425535],
            [-18.156580615869487, 1.4855001898513183],
            [-18.154066499854657, 1.4826019270134256],
            [-18.15506965394825, 1.471301804939717],
            [-18.150747107005778, 1.468522262488881],
            [-18.14829566981187, 1.4700803685490087],
            [-18.143394144459446, 1.4662205879744754],
            [-18.14181383801468, 1.4627468666031809],
            [-18.138290570603164, 1.4649417543889012],
            [-18.13368677806123, 1.4648214419216257],
            [-18.126341783243788, 1.4552244080279595],
            [-18.11763021467369, 1.4469660776416267],
            [-18.11629097903648, 1.4440142237945457],
            [-18.10979864975338, 1.4387953796382769],
            [-18.101384215166814, 1.430371498826801],
            [-18.099209270385685, 1.4268921301510973],
            [-18.094282203319928, 1.4243719909149473],
            [-18.08919646527236, 1.4130547789392565],
            [-18.08429197155807, 1.4088735257382698],
            [-18.08355312347082, 1.402950019290573],
            [-18.079179223634544, 1.3998440553026792],
            [-18.071346661046892, 1.3994973506482764],
            [-18.06391273706962, 1.395084500990952],
            [-18.061689171956406, 1.3949299594892168],
            [-18.056653056879995, 1.388736940925429],
            [-18.044576956766853, 1.3901174351509547],
            [-18.039190770276996, 1.3871713895192745],
            [-18.031663719423495, 1.388470879419307],
            [-18.02823349839384, 1.3914471660452454],
            [-18.02910075682391, 1.3968808130412171],
            [-18.02614562715001, 1.3970596976517065],
            [-18.020733830112654, 1.3942126440914095],
            [-18.019834695781725, 1.3860624097546546],
            [-18.01555654001531, 1.3816307083316623],
            [-18.01499337063415, 1.3778387408868336],
            [-18.01017343279352, 1.3808764742404798],
            [-18.004517286658142, 1.3827612339027795],
            [-18.00470363341692, 1.3870817643707223],
            [-18.001165492234833, 1.3873228507242945],
            [-17.994084530183493, 1.383424314058852],
            [-17.994581498438354, 1.3795915367065308],
            [-17.990728261549357, 1.373811545284647],
            [-17.985187210961612, 1.3708304951684502],
            [-17.98335867080234, 1.3669238763217686],
            [-17.979670819306307, 1.3674394456710564],
            [-17.979242539384863, 1.3706571713204696],
            [-17.973057917558616, 1.370885623665354],
            [-17.967379645280403, 1.3728413895842253],
            [-17.96298314623824, 1.3729681290071112],
            [-17.959791008518845, 1.3696516908862815],
            [-17.956763846854372, 1.3713790650326856],
            [-17.95206167966687, 1.3711189012911302],
            [-17.948686395330288, 1.3748425613475987],
            [-17.93448704564983, 1.3735050735834384],
            [-17.928297895128335, 1.3819281658750544],
            [-17.922438361885145, 1.38210062128352],
            [-17.917873187647977, 1.3844788327002833],
            [-17.909454690128122, 1.3820203881928954],
            [-17.903957943608336, 1.384891184437406],
            [-17.89820015884162, 1.385299696613078],
            [-17.89305572696786, 1.3801351258672354],
            [-17.890147916055206, 1.3791864929535118],
            [-17.88275138203406, 1.3876170724530685],
            [-17.874894476500995, 1.386763901601481],
            [-17.8668035478847, 1.3842895726551332],
            [-17.86397636575339, 1.3846124623663767],
            [-17.85640045550786, 1.3912283536634935],
            [-17.851602430932665, 1.3910497529231838],
            [-17.846741159842193, 1.4006475229564472],
            [-17.846722513122902, 1.4089756603537544],
            [-17.84858786895741, 1.4149701831940307],
            [-17.84337659035915, 1.418645848907511],
            [-17.83671281878215, 1.4251817551936934],
            [-17.830001346267707, 1.4258731084222638],
            [-17.823273436730847, 1.4221863892996571],
            [-17.818684623639445, 1.4223165981423633],
            [-17.814593304743546, 1.4262050085554063],
            [-17.80886496416033, 1.4257956857544474],
            [-17.796571312797038, 1.4297329209688778],
            [-17.785029276355807, 1.4386099807435855],
            [-17.782653172516042, 1.4420894040319452],
            [-17.78415540575833, 1.4450734435359152],
            [-17.78153068367519, 1.4506570327020956],
            [-17.7806458503378, 1.4560564894782575],
            [-17.776115980902294, 1.4586582020812078],
            [-17.769963334697874, 1.4590789156972432],
            [-17.762239720423054, 1.4634761813979642],
            [-17.756363135014237, 1.4634470720124293],
            [-17.755468911235845, 1.460929939857389],
            [-17.737777000433628, 1.4585391974563509],
            [-17.738909452657246, 1.4527860843739173],
            [-17.73751452332761, 1.4461860578910763],
            [-17.734056986249932, 1.440731067747038],
            [-17.728184258225255, 1.4368530339936016],
            [-17.724039022537756, 1.4254985652872583],
            [-17.723810292736488, 1.4203389737039933],
            [-17.716016573688446, 1.41160579289746],
            [-17.70947877169729, 1.4113103831233988],
            [-17.708169486382417, 1.407232150502293],
            [-17.70520600694324, 1.4052356737309335],
            [-17.704222466262543, 1.4008232663757667],
            [-17.69870914288312, 1.4076585158750057],
            [-17.695707814202507, 1.4080474379733858],
            [-17.692344260851602, 1.411156139352217],
            [-17.683136983996977, 1.4115439315563585],
            [-17.681554457966364, 1.408542856056241],
            [-17.676797713809425, 1.4063043960823929],
            [-17.67922586982486, 1.3989006730461488],
            [-17.6765502296987, 1.3986436664486115],
            [-17.671475060190094, 1.4024675408706497],
            [-17.66547059537242, 1.4026226121098353],
            [-17.66432579301912, 1.4010854956050145],
            [-17.664047889359665, 1.392895960895478],
            [-17.65988279305888, 1.3886216964495397],
            [-17.653590987762378, 1.387352506340415],
            [-17.6535718381808, 1.3803744492608865],
            [-17.655975563395295, 1.3695281448827719],
            [-17.653481092791342, 1.3662990493069822],
            [-17.646624833223346, 1.3679077550808538],
            [-17.64025628976545, 1.3647972508223492],
            [-17.635791034421086, 1.3683374189451618],
            [-17.63195229527602, 1.366057328177238],
            [-17.6327038757486, 1.3591649774399293],
            [-17.618903317331263, 1.348878921846418],
            [-17.61868278730778, 1.3462216282770507],
            [-17.624513772511953, 1.3351937846202129],
            [-17.62020628651954, 1.333073105199334],
            [-17.619564950125817, 1.3282297983786515],
            [-17.614221221766893, 1.3260580472692298],
            [-17.610074501951825, 1.3184623887352243],
            [-17.606306224429645, 1.3177267907382433],
            [-17.603683954207423, 1.3114501995328136],
            [-17.59644698119213, 1.309743841815495],
            [-17.595472895324413, 1.3078349494767962],
            [-17.597164740907118, 1.3010774311944693],
            [-17.59542174617359, 1.2977273306604034],
            [-17.597907953193896, 1.2933103166295672]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.90541121700281,
          "lat": 37.58150016342986
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06043"],
        "coty_name": ["Mariposa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mariposa County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00277286"
      },
      "bbox": [
        -18.452808485470907, 0.8552296455467132, -17.59542174617359,
        1.491729227432408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.063228627177246, 5.236362539363816],
            [-18.975405991931197, 5.211626954265789],
            [-18.932955367873447, 5.201629371357822],
            [-18.91183671425672, 5.195732820323716],
            [-18.84564659125284, 5.176549944732601],
            [-18.810841827565117, 5.166875023737962],
            [-18.79581970181166, 5.161000247234687],
            [-18.718507964273293, 5.139601567324366],
            [-18.57541469153373, 5.099914584203741],
            [-18.572461975857777, 5.098983904729109],
            [-18.502483637708483, 5.079714378102309],
            [-18.40467859908662, 5.052898147014982],
            [-18.30687779737851, 5.0260654670810245],
            [-18.2241737872297, 5.003936862958094],
            [-18.243870540596877, 4.932087552089034],
            [-18.260455404529047, 4.869714022382165],
            [-18.29355373660856, 4.749039367619122],
            [-18.298529880960956, 4.734142254462481],
            [-18.289461098762416, 4.73218781417071],
            [-18.294898207898537, 4.715765213340612],
            [-18.329047503640304, 4.590717757815464],
            [-18.35748843588703, 4.489217818277672],
            [-18.376793585524403, 4.421459454126147],
            [-18.388324454662072, 4.379074887686613],
            [-18.40005994626149, 4.336745064704977],
            [-18.40275462019976, 4.337462816763071],
            [-18.417457380016845, 4.287026031552231],
            [-18.424520940635194, 4.2890712372290665],
            [-18.429913473833995, 4.294952291112494],
            [-18.445168448724782, 4.295159353179725],
            [-18.54094438508006, 4.320992215067176],
            [-18.553478426396598, 4.323731257281257],
            [-18.569025898192077, 4.329462838743154],
            [-18.589980558127905, 4.334667425461328],
            [-18.59956611501154, 4.333814560781066],
            [-18.604847909348308, 4.328337297901845],
            [-18.6117512712433, 4.325508207260245],
            [-18.619421968989432, 4.328121265658805],
            [-18.622692759037214, 4.332421754570737],
            [-18.62382133412131, 4.336243163251894],
            [-18.62833411968826, 4.3381935711133774],
            [-18.63164065564657, 4.337361560161232],
            [-18.638169292987413, 4.339810631721106],
            [-18.646500893722617, 4.340897639836735],
            [-18.65218395685976, 4.340491139806171],
            [-18.657022043620973, 4.349044004399364],
            [-18.66614643119993, 4.357481110527161],
            [-18.666344173983056, 4.360267175876782],
            [-18.67037303049192, 4.361416079749976],
            [-18.675800643990225, 4.365968092820424],
            [-18.679960256061616, 4.365874070167467],
            [-18.684582891729672, 4.36395421651619],
            [-18.68835241634399, 4.364496028960783],
            [-18.693499236176493, 4.368423017112625],
            [-18.698363642817426, 4.367375631181163],
            [-18.701900590931125, 4.368320495509905],
            [-18.704098818827973, 4.365554739866925],
            [-18.713253582877254, 4.359508884175853],
            [-18.716002053685447, 4.358824743670161],
            [-18.74585031901158, 4.369252188059076],
            [-18.752578770955914, 4.37737205117642],
            [-18.75892303778433, 4.377868752466236],
            [-18.765708687279165, 4.382324657730602],
            [-18.77201936520015, 4.380219613090789],
            [-18.778180881347676, 4.380904335498044],
            [-18.78530673371289, 4.380151308588961],
            [-18.791048906624233, 4.381937132397046],
            [-18.795663924397793, 4.3850422509454665],
            [-18.79926645270332, 4.3890472424761935],
            [-18.808828328507627, 4.389544311973966],
            [-18.816138714846943, 4.387185236268607],
            [-18.819226352673972, 4.388802885829086],
            [-18.8327717314374, 4.382149897068978],
            [-18.834741946600797, 4.383095611340108],
            [-18.84149778206929, 4.378425211421534],
            [-18.84884797991707, 4.383350341762149],
            [-18.849034230843674, 4.385776344413256],
            [-18.854839107059885, 4.384632326769872],
            [-18.861083654735882, 4.380942604172434],
            [-18.86737918611225, 4.381862407575262],
            [-18.87155918509218, 4.380888660648846],
            [-18.877638826323434, 4.386331711363245],
            [-18.884606933546838, 4.388626589628574],
            [-18.888880506322874, 4.392778827062202],
            [-18.897521379753602, 4.395815247861756],
            [-18.90780509143144, 4.40176424153637],
            [-18.910586729306278, 4.399557620885644],
            [-18.914925240328298, 4.404529287786665],
            [-18.91877109345734, 4.405778977648316],
            [-18.925237519747185, 4.402373673177464],
            [-18.926683857908763, 4.405481428482902],
            [-18.938983611619353, 4.404260297156927],
            [-18.945966189513932, 4.404953741092241],
            [-18.95115444069424, 4.408252255828783],
            [-18.955413340965034, 4.405643026663472],
            [-18.96071791920323, 4.405800528981497],
            [-18.966693148454546, 4.4074464742306345],
            [-18.973402341898367, 4.406173500260337],
            [-18.97995460377213, 4.4079177697587095],
            [-18.98611566453825, 4.412331504667465],
            [-18.991810445556233, 4.409110552890232],
            [-18.995784857686584, 4.4085489238090805],
            [-18.99917195856451, 4.4058796371579065],
            [-19.002718444889755, 4.408316571513808],
            [-19.0057510174177, 4.405934534436996],
            [-19.0119807558179, 4.407352853504208],
            [-19.012877690930424, 4.40313718481195],
            [-19.02783488317178, 4.406635643974509],
            [-19.035216887198025, 4.4075326998096145],
            [-19.038855092536128, 4.40460830849899],
            [-19.041460588240742, 4.405964018128107],
            [-19.04998044523819, 4.406344741932535],
            [-19.053478384276833, 4.408022463070348],
            [-19.0589290704402, 4.402077527596836],
            [-19.052331730501493, 4.398594784145242],
            [-19.051108047536896, 4.393884819295678],
            [-19.057610609633738, 4.395428718152868],
            [-19.061205758430393, 4.400714394834178],
            [-19.061259284753135, 4.410017245119392],
            [-19.06819065686854, 4.4001917998959135],
            [-19.072809281663332, 4.399069207765347],
            [-19.07381504984618, 4.4025570359929915],
            [-19.079118214744835, 4.404889642286771],
            [-19.080747407738546, 4.408169927109202],
            [-19.088341439212364, 4.414257013354978],
            [-19.09227473309873, 4.411730615947811],
            [-19.097721694519137, 4.414460953772315],
            [-19.105448369787172, 4.416878373221274],
            [-19.109993643216523, 4.4108203872112135],
            [-19.116159838374767, 4.4124245653255265],
            [-19.120185492338166, 4.411483330029994],
            [-19.12411037421891, 4.412714735251458],
            [-19.12921710046725, 4.411936525380474],
            [-19.134760513489493, 4.41523051921162],
            [-19.13694559596192, 4.418935725399976],
            [-19.14279471059662, 4.41547221415269],
            [-19.151991509611243, 4.413445555773574],
            [-19.159611214398844, 4.419589771157526],
            [-19.162651640071587, 4.418810763175629],
            [-19.170409792945552, 4.4219180165542085],
            [-19.17645383274019, 4.420161239028384],
            [-19.184459196418484, 4.423552584230013],
            [-19.19073018629336, 4.427674156378897],
            [-19.194559399556148, 4.427011610465404],
            [-19.207994597341095, 4.432696892690675],
            [-19.213106599381653, 4.43183086468711],
            [-19.218395245935103, 4.435765076650453],
            [-19.2252391976865, 4.43786820825722],
            [-19.22663952142388, 4.442831205137001],
            [-19.231019176565297, 4.444437038865288],
            [-19.239718623976817, 4.441953647348883],
            [-19.249106072920224, 4.443470559752622],
            [-19.252358023542065, 4.44909999425978],
            [-19.255353412441735, 4.450455459230502],
            [-19.261579398574685, 4.449475151009989],
            [-19.261971155670953, 4.454421992640115],
            [-19.264675711584694, 4.458926543285779],
            [-19.270946619009894, 4.460901790731213],
            [-19.274483840464846, 4.458150674522981],
            [-19.27696770566724, 4.461131459628404],
            [-19.287560502131775, 4.464865474170937],
            [-19.288223909606323, 4.471377136593756],
            [-19.29489585929875, 4.472208627627358],
            [-19.297898493023567, 4.478599763948671],
            [-19.300857232449328, 4.473627706395208],
            [-19.30371185059241, 4.473917969208781],
            [-19.312056492608093, 4.4678765534066045],
            [-19.315646819399777, 4.471897352104282],
            [-19.318397661510307, 4.466506142311072],
            [-19.322580090107856, 4.4698585085048945],
            [-19.325381279412245, 4.466781707323616],
            [-19.33833663566346, 4.460682916684396],
            [-19.339392822798494, 4.462565278660741],
            [-19.347567567523484, 4.465933837391985],
            [-19.355270906812674, 4.459015250396471],
            [-19.362489318603394, 4.459739136921061],
            [-19.36960088614607, 4.454469745992907],
            [-19.376505055256462, 4.451632181455014],
            [-19.38355264774325, 4.455564017367298],
            [-19.38711326479936, 4.455768842385186],
            [-19.386714194205148, 4.448254529902096],
            [-19.39518484078109, 4.44831474195971],
            [-19.397200173822654, 4.44472399133587],
            [-19.40616111800027, 4.446297245017432],
            [-19.4105837124441, 4.4428000411980495],
            [-19.415269000202166, 4.44489182052202],
            [-19.41915702468313, 4.449004504948725],
            [-19.42478421847651, 4.448250229529059],
            [-19.427414058614282, 4.449726182925787],
            [-19.427112063921495, 4.454670439476358],
            [-19.436436878434623, 4.46003422622434],
            [-19.438426264591445, 4.464373990498851],
            [-19.446373767668568, 4.470408107233189],
            [-19.448371477078084, 4.474150874611762],
            [-19.458198520085045, 4.476736835860835],
            [-19.46467942198387, 4.477682990775361],
            [-19.462444504383136, 4.485592847603689],
            [-19.460453682240704, 4.488409421807408],
            [-19.465804513283235, 4.496756983695079],
            [-19.47252871636018, 4.499054905643735],
            [-19.476070557491276, 4.4949424883944635],
            [-19.479182436960052, 4.498861261967887],
            [-19.49719280187658, 4.49914901346972],
            [-19.503140972930566, 4.497330841760248],
            [-19.515673957156544, 4.501602300872737],
            [-19.52273679702983, 4.498650965668695],
            [-19.529139053544224, 4.498941951007858],
            [-19.534026951551724, 4.500711038817512],
            [-19.540110996343298, 4.500853418829016],
            [-19.54330316570978, 4.498611861171251],
            [-19.54638183089407, 4.499576804351863],
            [-19.554692002789768, 4.499440678720916],
            [-19.560306394843515, 4.503197189722715],
            [-19.56061298720581, 4.505930495300542],
            [-19.565492745387235, 4.5083699345028805],
            [-19.570684418043804, 4.50802507898194],
            [-19.575361829526216, 4.505062824063032],
            [-19.57665843993686, 4.502056421663653],
            [-19.584060963119377, 4.497751532489279],
            [-19.591141567284563, 4.49164844992067],
            [-19.599586298174714, 4.486115138688451],
            [-19.60229448031493, 4.482701021845189],
            [-19.60778111633444, 4.48143486078683],
            [-19.61379455022556, 4.478503287448199],
            [-19.6195508525579, 4.481222662999968],
            [-19.62171335646814, 4.487604010461612],
            [-19.63379675421936, 4.485698063349169],
            [-19.638148963327108, 4.489879354492761],
            [-19.648149730707388, 4.49245517733156],
            [-19.651425369588534, 4.498273352310961],
            [-19.657051732275303, 4.497956795382005],
            [-19.66249469578459, 4.49591186420214],
            [-19.669412681158008, 4.4955266740526065],
            [-19.673366781209246, 4.497161792367296],
            [-19.679300501664112, 4.497310410084639],
            [-19.681400476085084, 4.4945268830806855],
            [-19.687047251618406, 4.495479002409651],
            [-19.689760374573435, 4.497399086920993],
            [-19.69735125324683, 4.494520366258439],
            [-19.704979346333616, 4.48853219037365],
            [-19.709616531664814, 4.4904030950754725],
            [-19.713198295554523, 4.4872944445245135],
            [-19.717747537785836, 4.486395432330987],
            [-19.723650204449605, 4.489790380215055],
            [-19.72228441775018, 4.496826694776821],
            [-19.719990766213435, 4.501038072643762],
            [-19.721086372025198, 4.505723912653635],
            [-19.720092325975084, 4.51105856470444],
            [-19.7140401685878, 4.513805163320421],
            [-19.71279509362348, 4.525155201371082],
            [-19.71325959248752, 4.53419329481387],
            [-19.70871241410853, 4.537707905838552],
            [-19.70667562208459, 4.54292337220528],
            [-19.707732901874294, 4.544877139708708],
            [-19.70232728983876, 4.547661377366857],
            [-19.69685555023036, 4.544725035421498],
            [-19.6910758394028, 4.543210446739329],
            [-19.688951955391904, 4.550352688506251],
            [-19.684143227390514, 4.55659893003591],
            [-19.681195474025323, 4.558589732855321],
            [-19.67707300423188, 4.556516500697242],
            [-19.670137436184547, 4.558649115446703],
            [-19.666375143723567, 4.561875141842465],
            [-19.66211784816852, 4.57016213512112],
            [-19.662079885432302, 4.572795500857916],
            [-19.656760824595917, 4.576239790965474],
            [-19.651705473385753, 4.576445226060465],
            [-19.642755274068236, 4.580860394098203],
            [-19.643037284937723, 4.5884674769628],
            [-19.64086369322746, 4.590889716618814],
            [-19.637793370401727, 4.60228229044423],
            [-19.63188877384551, 4.601849573709053],
            [-19.626159928054633, 4.598972204319342],
            [-19.62049928577864, 4.598719321807968],
            [-19.613130679761703, 4.599936548737863],
            [-19.60882766899005, 4.60198549161277],
            [-19.606048323425533, 4.596177409238439],
            [-19.60200875573822, 4.597904228444969],
            [-19.591587910482716, 4.600007030884162],
            [-19.589771888844467, 4.601716973116656],
            [-19.588713530487674, 4.607619510519667],
            [-19.582083865098454, 4.611035405765957],
            [-19.578690156714366, 4.6154043271126195],
            [-19.569063777471268, 4.613969676958571],
            [-19.560654556176505, 4.608120169781611],
            [-19.555418076794805, 4.6117188842590515],
            [-19.549270000775785, 4.620992144884084],
            [-19.54546572246182, 4.625251176396863],
            [-19.545148900966986, 4.628128033065715],
            [-19.540353988113974, 4.630125173647805],
            [-19.538830697771473, 4.632790664879721],
            [-19.528276762842374, 4.636852020923303],
            [-19.517040421010698, 4.634727023909432],
            [-19.512082201848152, 4.636714975751977],
            [-19.507773395131974, 4.64055570656896],
            [-19.50675550540231, 4.647151316500887],
            [-19.508611162275386, 4.651455139434391],
            [-19.502989059330293, 4.654253079529568],
            [-19.49835071825162, 4.654466219137193],
            [-19.490049394626134, 4.652413613797325],
            [-19.482223528069916, 4.65430053969402],
            [-19.46841292069713, 4.65060125442851],
            [-19.462216595189595, 4.652245762063955],
            [-19.459980915015695, 4.6609332299964965],
            [-19.449365743195788, 4.666700840201654],
            [-19.45055376666904, 4.671929585518345],
            [-19.448977768276, 4.676056132594352],
            [-19.443115415552214, 4.680168417303117],
            [-19.432980475430817, 4.684450164199063],
            [-19.432143842537712, 4.686122088283709],
            [-19.425824921038103, 4.685727812754606],
            [-19.424606208616726, 4.683891443633479],
            [-19.419160591422568, 4.6826223930846265],
            [-19.41550228399766, 4.679886569002921],
            [-19.411774329419245, 4.6855176664730935],
            [-19.41072249813248, 4.689309633711504],
            [-19.402527315973014, 4.69420456941386],
            [-19.39374175060266, 4.696148732122071],
            [-19.389328917615217, 4.690300702308016],
            [-19.378508824380614, 4.6854532456392874],
            [-19.372683658144645, 4.6901034240212205],
            [-19.371188729398654, 4.695333191558187],
            [-19.374873614616316, 4.701620198033109],
            [-19.372833829018173, 4.7117907606872365],
            [-19.3745921709092, 4.716963019086776],
            [-19.374248190979895, 4.722070483606332],
            [-19.37235721751662, 4.726241148905588],
            [-19.374973881323722, 4.72969644675976],
            [-19.374066468187497, 4.735149171520904],
            [-19.369051615891117, 4.747505658100787],
            [-19.372568688038225, 4.751495180630041],
            [-19.378014517888705, 4.754013465277658],
            [-19.38458445189103, 4.75535237130209],
            [-19.386796305380166, 4.757928083988014],
            [-19.381205475749823, 4.765780914765682],
            [-19.37621687301853, 4.769727769592097],
            [-19.379273092742114, 4.777395742424539],
            [-19.377609365744803, 4.78263967637481],
            [-19.382286394614326, 4.787094943741989],
            [-19.381482632773867, 4.7945889477282435],
            [-19.379518868389006, 4.800331078856566],
            [-19.382839844909597, 4.804763298474852],
            [-19.384144443559855, 4.808804131943018],
            [-19.383235543727604, 4.8129856030827485],
            [-19.374258300129096, 4.8160689321243],
            [-19.372271429871315, 4.812893831739725],
            [-19.366665368259362, 4.810614349586194],
            [-19.360246110217137, 4.812214753714523],
            [-19.356339806448375, 4.817993950030394],
            [-19.353836440885516, 4.823808571892394],
            [-19.349005726196488, 4.824184513912432],
            [-19.346997843428113, 4.8287012173563415],
            [-19.340499268472836, 4.838126020788143],
            [-19.343039522477923, 4.846982111234217],
            [-19.34615215766486, 4.854080505104275],
            [-19.34220225506919, 4.861113280179898],
            [-19.333518824965832, 4.861098613509819],
            [-19.327246879072682, 4.866040338501784],
            [-19.32767547516041, 4.8683662730782435],
            [-19.32067464217949, 4.869087650629462],
            [-19.316320117986287, 4.871720517129728],
            [-19.30389677527118, 4.8749639276695556],
            [-19.300501308685675, 4.876722501516915],
            [-19.295046367855033, 4.884054637104924],
            [-19.288175700444842, 4.887907014201846],
            [-19.288804433499443, 4.8950592917309],
            [-19.28669753372552, 4.901164772927316],
            [-19.28364639283655, 4.901559493632501],
            [-19.280284454363976, 4.908835534719597],
            [-19.2829506521704, 4.926624097649704],
            [-19.274145269523594, 4.933793619724881],
            [-19.271106428419845, 4.939370701721073],
            [-19.26738400890049, 4.940041333153174],
            [-19.25863356778873, 4.9396651274798975],
            [-19.25589524370837, 4.947408052272292],
            [-19.251837781367357, 4.950057436481215],
            [-19.250447382157123, 4.954084258012971],
            [-19.243096217417495, 4.958045625696034],
            [-19.239995606159564, 4.967982190564543],
            [-19.22658972107382, 4.971362297925343],
            [-19.220243531815502, 4.978397491104772],
            [-19.218620931142798, 4.9832638312865365],
            [-19.215284835424956, 4.984214071895997],
            [-19.215049255156455, 4.993693054096736],
            [-19.218014663347116, 4.999832425114673],
            [-19.218149728064148, 5.007503610039516],
            [-19.211955659750437, 5.0145909589085615],
            [-19.20900067995854, 5.023041785278399],
            [-19.205866170481595, 5.024236626765461],
            [-19.204987371187038, 5.029299690679593],
            [-19.204972516298024, 5.038554523832203],
            [-19.203807035674885, 5.041925803848882],
            [-19.200566153273527, 5.042333427901133],
            [-19.19713734916, 5.048526416338949],
            [-19.196494492801982, 5.0528415228359425],
            [-19.19269876387883, 5.057283316860837],
            [-19.185262491531425, 5.059035139953761],
            [-19.18217784957498, 5.0642261360696725],
            [-19.178648646421085, 5.060692649741488],
            [-19.174078873479612, 5.059605949164696],
            [-19.169036200071318, 5.060065701161415],
            [-19.164698075088626, 5.062168172500424],
            [-19.159883214301068, 5.069592159556119],
            [-19.15511981658421, 5.0712358446310155],
            [-19.153283091017023, 5.075033638058078],
            [-19.148243456472148, 5.075267510327303],
            [-19.141675052618517, 5.0704239311387775],
            [-19.138075999571914, 5.075370453865753],
            [-19.134017675103706, 5.076849825270149],
            [-19.131054463974955, 5.079940624671684],
            [-19.128720600603774, 5.086263875992539],
            [-19.12868490665498, 5.0897640568068026],
            [-19.12404346668918, 5.105332355937977],
            [-19.122051620045326, 5.11010218906994],
            [-19.116652433954428, 5.115414231289563],
            [-19.115308494723717, 5.122262808679411],
            [-19.116133458206072, 5.12650133345044],
            [-19.11992597654554, 5.129439229072728],
            [-19.123751449520217, 5.129856622602741],
            [-19.123525814772123, 5.138603919419731],
            [-19.11980568611456, 5.140951344256806],
            [-19.114509417325536, 5.140360661307936],
            [-19.107289067944162, 5.144906976863716],
            [-19.10332727941095, 5.145678689346534],
            [-19.100197887741317, 5.148264248348591],
            [-19.095690255139502, 5.144699349518117],
            [-19.090774806374704, 5.144949044272443],
            [-19.08640491631711, 5.141991319908086],
            [-19.075732251427862, 5.144809310049242],
            [-19.072731397454515, 5.144361753169727],
            [-19.065313446535736, 5.147314430126651],
            [-19.060889918842868, 5.146938473954811],
            [-19.057476423974922, 5.144847207360159],
            [-19.05438403100149, 5.150875396186287],
            [-19.050461998459784, 5.154990235898086],
            [-19.05015965619946, 5.160392039534671],
            [-19.045325505227243, 5.163976815132636],
            [-19.04009989577684, 5.180936737304578],
            [-19.03883860806835, 5.192100807369204],
            [-19.0331879435635, 5.199911683984491],
            [-19.03494037813931, 5.203747436860917],
            [-19.035926894197672, 5.2114803755097014],
            [-19.037818133866647, 5.214137217480328],
            [-19.042085934266293, 5.2142117662576855],
            [-19.04535847735406, 5.217233935207722],
            [-19.047980818181784, 5.224639520298394],
            [-19.056001395236837, 5.228434211689307],
            [-19.059871747324678, 5.227983271522268],
            [-19.063906886875778, 5.232271333636703],
            [-19.063228627177246, 5.236362539363816]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.04049540646132,
          "lat": 40.76377626842771
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06089"],
        "coty_name": ["Shasta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shasta County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01682610"
      },
      "bbox": [
        -19.723650204449605, 4.287026031552231, -18.2241737872297,
        5.236362539363816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-20.500931836079268, 3.124145297419724],
            [-20.492736456999786, 3.1121941856735775],
            [-20.488389238163858, 3.119756922803984],
            [-20.483276155637235, 3.1183120263083794],
            [-20.479848827141282, 3.123263929641235],
            [-20.474167394003953, 3.122165037842667],
            [-20.470988273987498, 3.125965388828734],
            [-20.389969577710467, 3.1002519658079706],
            [-20.37609576210449, 3.0962134982070326],
            [-20.36773233569491, 3.1248376575329653],
            [-20.303308994981702, 3.106723662160879],
            [-20.29570944589145, 3.1054259228923016],
            [-20.24921313934993, 3.092312044328961],
            [-20.19971370396071, 3.077711697120305],
            [-20.195177232369737, 3.0766561133383616],
            [-20.186840489570695, 3.1060635928062745],
            [-20.173035082164137, 3.102126817638571],
            [-20.14612156965404, 3.093046599175862],
            [-20.14196652901715, 3.1065730882741414],
            [-20.128031398047536, 3.1023287602166048],
            [-20.102358836666717, 3.0955030726548],
            [-20.087465014381284, 3.0894047298076686],
            [-20.06950482677365, 3.084418355745067],
            [-20.040009854924865, 3.0747298224387674],
            [-19.961455435439547, 3.051782673255781],
            [-19.950527677666543, 3.04845091271181],
            [-19.947692786403838, 3.047314201388782],
            [-19.949661050643545, 3.04236841975882],
            [-19.94599921540311, 3.039932182998341],
            [-19.94678420902009, 3.0350553656746597],
            [-19.944751043184898, 3.0326099005890583],
            [-19.938078527361917, 3.031030959542118],
            [-19.935124945148292, 3.028991444563603],
            [-19.933691348744176, 3.0228872902638257],
            [-19.930664706341766, 3.018768454385865],
            [-19.926398001515086, 3.0170142895180967],
            [-19.92391745684416, 3.0109480791599466],
            [-19.922172803891193, 3.0102161005870824],
            [-19.920849812744315, 3.004663087456559],
            [-19.916413278288225, 2.9970109574905175],
            [-19.916416039956083, 2.994799073192742],
            [-19.909440176606555, 2.988337241316044],
            [-19.908939732892765, 2.9830054856147648],
            [-19.91365076533208, 2.9723440461162616],
            [-19.91074979962453, 2.9657807791891675],
            [-19.908410972436304, 2.9645987494653396],
            [-19.90687416489518, 2.959989272969288],
            [-19.908229280527443, 2.956825242741915],
            [-19.904589024426066, 2.9517894562953715],
            [-19.90251677464158, 2.943228264633191],
            [-19.902379780738787, 2.933141918386346],
            [-19.89693702573892, 2.928652480215091],
            [-19.89598722683913, 2.9238003773094023],
            [-19.899796926702713, 2.9205166792486863],
            [-19.90118903624385, 2.9102709009054553],
            [-19.89507047941248, 2.9051317590495715],
            [-19.89405582539743, 2.895636683498129],
            [-19.8953863938358, 2.8938369662922065],
            [-19.893338581753387, 2.8858243402051817],
            [-19.883021866276025, 2.8797463395522516],
            [-19.8801619909613, 2.8771261918229385],
            [-19.877401528444935, 2.878531346547976],
            [-19.872725227734104, 2.8746352179679353],
            [-19.866410057835694, 2.8739411862424533],
            [-19.861058086417582, 2.8715276216653347],
            [-19.861006144521504, 2.86394096190965],
            [-19.859095690424645, 2.8615949987047222],
            [-19.858756135667484, 2.8566112121407294],
            [-19.860587674901666, 2.8534269749376384],
            [-19.857481426636365, 2.8485713367660854],
            [-19.857761345068305, 2.8454111622992375],
            [-19.854254672740193, 2.836226265535887],
            [-19.856237813412402, 2.8329951475569364],
            [-19.857520231738597, 2.8311326031635957],
            [-19.855426765277993, 2.826017463387165],
            [-19.857988027476065, 2.8202039510304577],
            [-19.858724223052782, 2.814577503031742],
            [-19.86384377867783, 2.8079805264852116],
            [-19.870337043043772, 2.803636068411967],
            [-19.871044564118282, 2.786647894775274],
            [-19.875557295909108, 2.7852341550057966],
            [-19.876446746950908, 2.781510126736093],
            [-19.88223071133482, 2.7786684591172337],
            [-19.88256668130943, 2.775940783104909],
            [-19.891002284791288, 2.7677756327319143],
            [-19.88852735579428, 2.757510856024978],
            [-19.885915348350558, 2.752956329932413],
            [-19.88691736323021, 2.7496969419428847],
            [-19.884550687654503, 2.7443167926865772],
            [-19.888223481010133, 2.738156921485079],
            [-19.88353553235615, 2.734888863612626],
            [-19.88086021098384, 2.729759339590161],
            [-19.882668962052776, 2.7246620003911146],
            [-19.875930323027337, 2.7207321033076117],
            [-19.870081322583367, 2.7195110488643337],
            [-19.868497050184033, 2.7156107734862216],
            [-19.861706402348418, 2.7117883270401975],
            [-19.856911151210344, 2.7058085409786745],
            [-19.855199563695344, 2.6978761329112286],
            [-19.85337056590932, 2.695379700352729],
            [-19.852119378651214, 2.687523954176379],
            [-19.85306132494256, 2.68380318654495],
            [-19.844911014512864, 2.677493646151041],
            [-19.842543773616235, 2.6773167983158883],
            [-19.838306079421795, 2.6723531907963385],
            [-19.836621556955045, 2.667633373208911],
            [-19.836803516283876, 2.6622793139352923],
            [-19.841783323058984, 2.6604812546394885],
            [-19.83955097357173, 2.6568563203377686],
            [-19.83888305714176, 2.6519849179179364],
            [-19.835317307136688, 2.649554421031097],
            [-19.838112235677613, 2.6466958201078423],
            [-19.842405282071383, 2.648326346158401],
            [-19.84250311867367, 2.642690990488188],
            [-19.841404568299414, 2.6314567633858656],
            [-19.839028875411294, 2.6272212637374266],
            [-19.840012550714796, 2.6172183054131777],
            [-19.82939573699546, 2.6154616562036517],
            [-19.825250981770967, 2.6076295582125537],
            [-19.82725090803425, 2.6057683986857603],
            [-19.827361309440576, 2.60112328717637],
            [-19.82033258312408, 2.5967143012493157],
            [-19.816738382296297, 2.5971922773485994],
            [-19.80809598383638, 2.58892393319671],
            [-19.81217918138948, 2.583040036283236],
            [-19.81818790506119, 2.5762124400799813],
            [-19.82143511140299, 2.575182807810954],
            [-19.82873272534392, 2.5664639217140874],
            [-19.823449110705045, 2.5570889330841924],
            [-19.818439129174696, 2.5507496679002535],
            [-19.81647471155479, 2.5433546426224223],
            [-19.81336959217035, 2.536656955364052],
            [-19.81591755047334, 2.534503578069403],
            [-19.81433076222466, 2.526347917983502],
            [-19.807477600461432, 2.5193411602046902],
            [-19.80828215681577, 2.5169037756897077],
            [-19.80424275185788, 2.5124667522221373],
            [-19.806095761197533, 2.5084348015396007],
            [-19.809864026629082, 2.508415082070691],
            [-19.814384449223557, 2.5031469935443624],
            [-19.812257820638543, 2.4967649481968093],
            [-19.80905571199137, 2.492410601599384],
            [-19.802573707272497, 2.488369208057243],
            [-19.79682250209131, 2.4779157821770177],
            [-19.794549806273707, 2.4664584010383037],
            [-19.789879081634957, 2.460640901211389],
            [-19.792234498244866, 2.4577106028923867],
            [-19.790409961895154, 2.4523478279082744],
            [-19.791554350540824, 2.4476067004130497],
            [-19.7882672973585, 2.447631004323732],
            [-19.787702463960624, 2.4388170161833287],
            [-19.785051867731013, 2.4331217235127585],
            [-19.785299202550153, 2.4283526929915045],
            [-19.790959313922134, 2.427836414761131],
            [-19.79313860600411, 2.425815636108283],
            [-19.792986939277206, 2.420542534968033],
            [-19.794970303077474, 2.4125257378906197],
            [-19.7988718550561, 2.4087116706922624],
            [-19.797497751833482, 2.399996284106978],
            [-19.79566513382312, 2.3964831494301073],
            [-19.788603664155524, 2.3976760276750873],
            [-19.793570518927016, 2.3849662479944995],
            [-19.787251677829765, 2.370219209958764],
            [-19.779344887256933, 2.365294066372309],
            [-19.780377034564978, 2.3573106338969065],
            [-19.782433333611397, 2.35536215550387],
            [-19.782156855438803, 2.3508407043799724],
            [-19.785790040639565, 2.3428911390056726],
            [-19.786974920337652, 2.335253146032639],
            [-19.783793827812655, 2.327618462551659],
            [-19.78074593888295, 2.318029836030312],
            [-19.783040841164457, 2.310449402536627],
            [-19.785311603179146, 2.3154571405897753],
            [-19.78986381017574, 2.314861474172212],
            [-19.788472812656572, 2.3098225865558635],
            [-19.792000460189048, 2.3017408830920187],
            [-19.79764651880154, 2.3052879332576914],
            [-19.79985389715121, 2.303895428992965],
            [-19.80206183026474, 2.2982048444819174],
            [-19.80166338004676, 2.2877617795146525],
            [-19.803568282013135, 2.282875592128272],
            [-19.808105600873873, 2.2808776687312196],
            [-19.817435901317722, 2.286937137176736],
            [-19.82632270385381, 2.289979118649489],
            [-19.83198827717475, 2.290500029623969],
            [-19.835395225952077, 2.286458656962538],
            [-19.832465572059782, 2.272159356442205],
            [-19.835037651786646, 2.268473333575243],
            [-19.863985649506517, 2.2606847720917163],
            [-19.87360399787186, 2.256802576863373],
            [-19.87749300686554, 2.258688175002899],
            [-19.878237423969754, 2.261650153935765],
            [-19.87471573311676, 2.266707209025118],
            [-19.867113746903634, 2.273700665682803],
            [-19.86863923344609, 2.2778004734488344],
            [-19.884987479668805, 2.2745747197699884],
            [-19.914585824929937, 2.2665692520672986],
            [-19.916610260243758, 2.2631214823694488],
            [-19.91862055721043, 2.264879063326349],
            [-19.921554665131858, 2.271673852079783],
            [-19.922178469869806, 2.2790116083161513],
            [-19.921533935715665, 2.2863852595052383],
            [-19.923843392558364, 2.2950463288756144],
            [-19.926497447309913, 2.2997621387446854],
            [-19.93217265464538, 2.3062240365524755],
            [-19.93722833513953, 2.318115377619685],
            [-19.941864766586665, 2.318627409217429],
            [-19.946858351776307, 2.322460511481298],
            [-19.94716175146352, 2.3250625853741416],
            [-19.942169070223162, 2.328506081748859],
            [-19.949095037903753, 2.3347704014511907],
            [-19.948021815444534, 2.3390677263359776],
            [-19.95046679367464, 2.341611184267716],
            [-19.94650522304467, 2.3461235389196426],
            [-19.948735494892603, 2.34918486635952],
            [-19.955931677267696, 2.350261457893868],
            [-19.95940298275709, 2.3559709837021288],
            [-19.96494384261521, 2.3553768213980977],
            [-19.965256983412292, 2.358388268742882],
            [-19.97245753262618, 2.3567689031268855],
            [-19.97562415323033, 2.353047596203073],
            [-19.983886319855266, 2.356996952171609],
            [-19.99157926663828, 2.359250969552686],
            [-19.994634391535662, 2.3564472643008907],
            [-19.99901051048203, 2.3572477488947263],
            [-20.001558927541254, 2.359868387609065],
            [-20.009758204320015, 2.3631489054756343],
            [-20.01228880408969, 2.367841787313086],
            [-20.015754280515267, 2.371015816615911],
            [-20.01929606770908, 2.3715397991880853],
            [-20.02076665864716, 2.3753158753843358],
            [-20.030894980173695, 2.3782812323432485],
            [-20.035180601665967, 2.3847085927804788],
            [-20.044343690085327, 2.388710710286731],
            [-20.05282133783424, 2.3966561405656823],
            [-20.05273292298575, 2.398915747084866],
            [-20.057637818533482, 2.4042521713707385],
            [-20.070307399160896, 2.4077896323276926],
            [-20.104296189035765, 2.461071430548823],
            [-20.11037263702458, 2.4709562914827106],
            [-20.145178227275974, 2.5251234319276192],
            [-20.16024915291722, 2.5493088804124513],
            [-20.165799858041435, 2.5481346416101354],
            [-20.167101973261783, 2.551218494898304],
            [-20.166202470822682, 2.555520999166853],
            [-20.170018264388816, 2.555630048009179],
            [-20.174622647810235, 2.5533745013512945],
            [-20.17239986822249, 2.5489184960921847],
            [-20.177373830027907, 2.5454875506131724],
            [-20.17927424352949, 2.550419466711563],
            [-20.1907537107584, 2.551828959170952],
            [-20.195460095857833, 2.5535244522656493],
            [-20.201160576967713, 2.5576270491855095],
            [-20.204797224593317, 2.5618447337773813],
            [-20.208281454993305, 2.5633114333757083],
            [-20.2122081033118, 2.5579697090886397],
            [-20.22148046385436, 2.561025849378413],
            [-20.22418912606239, 2.5587552833918945],
            [-20.22969286394989, 2.5578713714781487],
            [-20.232685612200246, 2.5590961153151257],
            [-20.233539013436857, 2.5529229093265715],
            [-20.241738050405328, 2.5507210988471436],
            [-20.242272340503014, 2.552247017291504],
            [-20.253508391932947, 2.5697783668735785],
            [-20.26340389948445, 2.575824459846943],
            [-20.267941496112357, 2.576728687496378],
            [-20.27340843539058, 2.575717550376442],
            [-20.276619106462583, 2.5714310591956084],
            [-20.278436965225588, 2.56530167826139],
            [-20.282260854453746, 2.5653368559220078],
            [-20.285228012879713, 2.5702227881100828],
            [-20.28835320913434, 2.5881839595353666],
            [-20.287653721400485, 2.5923709740188405],
            [-20.27941079397027, 2.6032418804721202],
            [-20.272287507087967, 2.627073261008638],
            [-20.27653907772395, 2.6467288257425414],
            [-20.276480855117182, 2.660526390210797],
            [-20.2814694042082, 2.6665104498936616],
            [-20.28215233235522, 2.6704597319034113],
            [-20.281693575595025, 2.6786934293839617],
            [-20.282881788803664, 2.688694913368233],
            [-20.285456703668046, 2.694577523685877],
            [-20.288379554215453, 2.6966046734809312],
            [-20.28906391367708, 2.704327248869506],
            [-20.292204980276672, 2.7066309592228803],
            [-20.29059579167456, 2.7138413442881553],
            [-20.291884434104766, 2.720322096636902],
            [-20.291667787911937, 2.727930058951445],
            [-20.29636310145286, 2.7338791889035523],
            [-20.301112876676164, 2.7364483296961666],
            [-20.301384767528653, 2.7402441137682176],
            [-20.308110353749576, 2.7476877503457953],
            [-20.31097996909879, 2.752306991200901],
            [-20.312665708569032, 2.759874646167842],
            [-20.324365000941683, 2.7748627418503666],
            [-20.33198609962443, 2.782574219270358],
            [-20.333809062561276, 2.7864459538963686],
            [-20.33872052267413, 2.7897885942510134],
            [-20.34197033082027, 2.794310496643141],
            [-20.34597988811526, 2.7945498215512328],
            [-20.353092801778736, 2.800799795589783],
            [-20.355091590660567, 2.8084158448458756],
            [-20.361029948943603, 2.813021821885331],
            [-20.365267215792006, 2.812392634957205],
            [-20.36789845283301, 2.815052883064677],
            [-20.366605445454827, 2.81877287250796],
            [-20.368924988713182, 2.8204466032307414],
            [-20.374600821198445, 2.830932653440873],
            [-20.37306331752758, 2.835401739777615],
            [-20.37628592179713, 2.8393283665789295],
            [-20.380078063509817, 2.839153851190729],
            [-20.379056049281, 2.8434457111917184],
            [-20.381861663067188, 2.8443895988442267],
            [-20.383786159732686, 2.8494314625370274],
            [-20.390287672052676, 2.8547446293424166],
            [-20.395423893538208, 2.8623825394673568],
            [-20.39479307189799, 2.8658086628344543],
            [-20.396484286285773, 2.869962157152799],
            [-20.404606880093407, 2.877766620736117],
            [-20.40436791647061, 2.8802158110577376],
            [-20.40977204957765, 2.883727005115658],
            [-20.41395057035588, 2.891993065365962],
            [-20.410318177452584, 2.9022243123501896],
            [-20.411255996440826, 2.9098957944688344],
            [-20.413965050210283, 2.917844788405126],
            [-20.417403410572938, 2.9203430791358684],
            [-20.41962810263644, 2.9192455282448804],
            [-20.42186357212668, 2.9246161694427575],
            [-20.426001057319667, 2.928163173125743],
            [-20.42254274930818, 2.9378837110264167],
            [-20.427341119037813, 2.9414655950178257],
            [-20.428785655391945, 2.9486768345460237],
            [-20.434478881427307, 2.960360047335539],
            [-20.432832217605537, 2.963838814443408],
            [-20.441153537697957, 2.9867993596565703],
            [-20.43958298606834, 2.994163723778476],
            [-20.44300991964302, 3.000617996835455],
            [-20.442006548103162, 3.002376971730557],
            [-20.44357370060518, 3.0085106734257407],
            [-20.44700332135863, 3.0105853315989584],
            [-20.452876860405286, 3.0187534988313094],
            [-20.44956176695473, 3.0235777613867887],
            [-20.452759798423788, 3.0376006767219406],
            [-20.455190045308417, 3.039459680872218],
            [-20.459105209950195, 3.0471744790054505],
            [-20.459583035324513, 3.052669316336119],
            [-20.46225488517396, 3.0585702993814725],
            [-20.46554033995548, 3.062627696123353],
            [-20.470391177091134, 3.0658342384165826],
            [-20.476207080695993, 3.0739501820371595],
            [-20.479153077898747, 3.079590875742393],
            [-20.48033691852793, 3.084465091872302],
            [-20.48979069044607, 3.0922692138612486],
            [-20.49467741476013, 3.0944662616040053],
            [-20.49736213610991, 3.103391859271461],
            [-20.49964821887568, 3.103709059625421],
            [-20.499447194297872, 3.1119088962493535],
            [-20.502062222921605, 3.11511630418798],
            [-20.500355530767695, 3.119524634853279],
            [-20.500931836079268, 3.124145297419724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.88818929247255,
          "lat": 38.529010315476775
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06097"],
        "coty_name": ["Sonoma"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sonoma County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01657246"
      },
      "bbox": [
        -20.502062222921605, 2.256802576863373, -19.779344887256933,
        3.125965388828734
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.52341349044877, -0.011975490337473946],
            [-8.518836766194367, -0.012691858359971761],
            [-8.323825634255273, -0.0359921211624054],
            [-8.128817277331521, -0.05931558773243264],
            [-8.084591373050252, -0.06452297020501453],
            [-8.097869734712052, -0.17505376148517823],
            [-8.106469303156475, -0.25618580689073145],
            [-8.11028494333875, -0.25505079052319307],
            [-8.112040124747804, -0.2624896212999875],
            [-8.114072635563701, -0.26497874097891133],
            [-8.120427855626206, -0.26170149845250174],
            [-8.12403983506008, -0.2564273532136918],
            [-8.130054964101248, -0.2564654563328445],
            [-8.134776626581264, -0.2596612542823872],
            [-8.141469125558146, -0.25893828584788225],
            [-8.14677792683133, -0.2544529576004931],
            [-8.150175039331408, -0.2549385450379855],
            [-8.15319852732675, -0.24696910797700403],
            [-8.157952514923807, -0.24483625723133978],
            [-8.161922590832468, -0.2504079434622384],
            [-8.164926199056284, -0.25152045861581],
            [-8.172666785070628, -0.2511843039383314],
            [-8.175193022609704, -0.25388965332152147],
            [-8.180165215553656, -0.2544272006581373],
            [-8.186838357562928, -0.24906392541904443],
            [-8.1893485351863, -0.25555915134070856],
            [-8.193325349368582, -0.2589457281477137],
            [-8.202380993370344, -0.2604002564507072],
            [-8.208678877146458, -0.26273946120335423],
            [-8.215202292890629, -0.26094481305929096],
            [-8.222724846679672, -0.3249811252971057],
            [-8.224143069393856, -0.33410553534536874],
            [-8.227548596282857, -0.37139872509715266],
            [-8.238009981284963, -0.44295891815806226],
            [-8.239456308818037, -0.4501062979264086],
            [-8.251704026336594, -0.5244157256998415],
            [-8.235202265797305, -0.5268335802328667],
            [-8.240997008846243, -0.5770159397487649],
            [-8.245344293238944, -0.601424476038131],
            [-8.262718378134513, -0.728386563904811],
            [-8.268686344711712, -0.7791919479712024],
            [-8.333427513856659, -0.7715293084564834],
            [-8.544734519087262, -0.7464768146049893],
            [-8.535643023579478, -0.6711441864418289],
            [-8.535129828284433, -0.668990129059477],
            [-8.518384610653667, -0.5291283312887943],
            [-8.502754692476497, -0.39995751655411077],
            [-8.499670966195934, -0.39940106594839264],
            [-8.492749017212713, -0.40336559452903703],
            [-8.487418722910967, -0.3929396421897844],
            [-8.482333217990004, -0.38845466911358795],
            [-8.48301831489913, -0.3841991770710738],
            [-8.48173974654906, -0.37633356485310804],
            [-8.483349758000466, -0.37137396795074923],
            [-8.485844602459848, -0.3689110675080076],
            [-8.48731066221524, -0.3597463686271056],
            [-8.4911847873778, -0.35330751787028036],
            [-8.494256323357089, -0.3518250339558879],
            [-8.498684311347596, -0.34545270287531826],
            [-8.502211451778061, -0.34313835499869993],
            [-8.507091411354871, -0.3437548459269896],
            [-8.51256977847306, -0.3424549945279236],
            [-8.522318536939697, -0.3384792843306553],
            [-8.521064024175471, -0.33039624188696526],
            [-8.522941004700995, -0.3234058655563125],
            [-8.524952208086672, -0.3222412567548557],
            [-8.523270711829714, -0.3170972599713032],
            [-8.521131690391059, -0.31549720022361316],
            [-8.519610609762399, -0.30775483702832407],
            [-8.52156929177991, -0.3049018818292013],
            [-8.523311132366192, -0.29751073342456963],
            [-8.525645111071682, -0.2934053785388023],
            [-8.53068563279638, -0.28807566695506887],
            [-8.531224985255857, -0.28280741719638586],
            [-8.527650379101726, -0.27923826851621464],
            [-8.52781328802366, -0.27411768189741553],
            [-8.522628195646892, -0.27239376463707987],
            [-8.52146876651938, -0.2676154643284456],
            [-8.515988685767253, -0.2630960168736689],
            [-8.521088127357814, -0.25750422186699595],
            [-8.522299940974975, -0.24655183096927077],
            [-8.525893577344986, -0.2427524456725675],
            [-8.52428606922606, -0.2383218179120653],
            [-8.526286360736588, -0.2365793469615653],
            [-8.525512885036923, -0.2280266064079698],
            [-8.522454164405115, -0.22586253411526513],
            [-8.520420704397287, -0.21922643265976358],
            [-8.523651779355772, -0.21506019853470904],
            [-8.534017363529275, -0.2116850404409902],
            [-8.54280307656667, -0.20425308558904243],
            [-8.543353447862236, -0.19881523854919284],
            [-8.5459573291318, -0.19463187344458008],
            [-8.554383163384069, -0.1900806087144644],
            [-8.559580733083536, -0.18944093926171487],
            [-8.560298515442609, -0.1874871287453809],
            [-8.556454982615115, -0.182151860690254],
            [-8.559067603446776, -0.17304574469046183],
            [-8.560040857316451, -0.16519744954306445],
            [-8.556309695627784, -0.1641163992857845],
            [-8.555575540618463, -0.15846428850685357],
            [-8.550543498430883, -0.15792082726866893],
            [-8.545331205373463, -0.15437449213175095],
            [-8.539044134265104, -0.1545047657017855],
            [-8.532189579630545, -0.16157595611781111],
            [-8.527194365233035, -0.1630692077162001],
            [-8.524093596986209, -0.1608719632455512],
            [-8.521214255976558, -0.15619788783228863],
            [-8.516642312697194, -0.15354818971736378],
            [-8.516691107124906, -0.1445939686665125],
            [-8.51387840779348, -0.13982105494612637],
            [-8.515874363023727, -0.13513698978108032],
            [-8.513355495680988, -0.13383999313616984],
            [-8.513195079594263, -0.12976794420616602],
            [-8.5076681532415, -0.12407874034437756],
            [-8.503154584219448, -0.12455159425824423],
            [-8.498716796452783, -0.11791936054179655],
            [-8.498588962780257, -0.10661047336164621],
            [-8.49355251198512, -0.10655349466066681],
            [-8.489451814050872, -0.10434876477349306],
            [-8.491946112051608, -0.09955283738726664],
            [-8.49284089889949, -0.09457517872553829],
            [-8.498310343505619, -0.09083164572330828],
            [-8.504222743983632, -0.08308038946396966],
            [-8.512811065010883, -0.08096134596626396],
            [-8.517693814628208, -0.0829023820739086],
            [-8.520482605933937, -0.08124531256508713],
            [-8.523760736964988, -0.07303668815894822],
            [-8.523428889714122, -0.06853585089115208],
            [-8.526506791609616, -0.06274425103786724],
            [-8.521915664647405, -0.04956026061790756],
            [-8.52348282852308, -0.04065920264394779],
            [-8.522175635739737, -0.036599098435747504],
            [-8.522781853376076, -0.03174956756743126],
            [-8.526029794287412, -0.024440456490826025],
            [-8.52871327348564, -0.023854722781314796],
            [-8.527047457730852, -0.01769298660378227],
            [-8.52341349044877, -0.011975490337473946]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.30028960026873,
          "lat": 37.821270188572925
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08053"],
        "coty_name": ["Hinsdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hinsdale County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00198142"
      },
      "bbox": [
        -8.560298515442609, -0.7791919479712024, -8.084591373050252,
        -0.011975490337473946
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.737256609977008, -1.0750087682882907],
            [-6.732142967564634, -1.0722172952797935],
            [-6.728253115911323, -1.0730318728483206],
            [-6.719083974266786, -1.0688780704154968],
            [-6.716434231721437, -1.073271554512933],
            [-6.706561388866699, -1.0747573752274808],
            [-6.702410544254876, -1.0718967297298259],
            [-6.6921155752980965, -1.0681766246470834],
            [-6.68928034030842, -1.0643208293179853],
            [-6.6899692293501305, -1.0606085366915396],
            [-6.686478647089132, -1.0573571580246302],
            [-6.6802708210385084, -1.0583571498425361],
            [-6.67212771143313, -1.0567315382744387],
            [-6.671595612585245, -1.0543067803279231],
            [-6.666543954763707, -1.0484210159652538],
            [-6.652382495239538, -1.0447006505073182],
            [-6.647718212816105, -1.0403386540669863],
            [-6.640595809531063, -1.0352585101258973],
            [-6.634633757743844, -1.0378622310403194],
            [-6.630593700215711, -1.0368738204015244],
            [-6.630329204152385, -1.0291151840072879],
            [-6.628758312230929, -1.02080039409072],
            [-6.619206322520285, -1.019752911531526],
            [-6.614898113749624, -1.0161797984797218],
            [-6.604951241352063, -1.0040833240579266],
            [-6.6005209789629395, -1.0040807861741137],
            [-6.59577310246302, -1.007147507037251],
            [-6.58938512588434, -1.0043462268154282],
            [-6.585865218776525, -1.0051906247922473],
            [-6.5784361890410095, -1.000142326046424],
            [-6.573461600749565, -0.9950784802471847],
            [-6.565233354794496, -0.9917230848352615],
            [-6.560657864254229, -0.9943818551885065],
            [-6.557865687698201, -0.9939130089767251],
            [-6.553750682328238, -0.9887841816849908],
            [-6.5482662174939925, -0.9876418042790628],
            [-6.545727518347787, -0.9906493313142447],
            [-6.537121192369652, -0.991845372577816],
            [-6.533496923640629, -0.9960638797121322],
            [-6.523266022271719, -0.9977232190406462],
            [-6.516823390139307, -1.0019851259204375],
            [-6.508475245819239, -0.9998659822037846],
            [-6.506429885577291, -0.9974675843260974],
            [-6.50124440964048, -0.9983979290830732],
            [-6.496170882913929, -0.9959873622431674],
            [-6.486863722824133, -0.9947758978630068],
            [-6.4796001726694925, -0.9924267029109831],
            [-6.47715305494, -0.9961126207940432],
            [-6.470781762515696, -0.9963148057926573],
            [-6.466954316511689, -0.9941178895105839],
            [-6.463240358412631, -0.9951418331302683],
            [-6.461566345499216, -0.9923762307916276],
            [-6.456203909306591, -0.9935916551621055],
            [-6.452122816773091, -0.9906642159804195],
            [-6.449948497250465, -0.9935815653757579],
            [-6.4429918439015115, -0.9930803465120488],
            [-6.43615573666298, -0.9946104489928477],
            [-6.43293241150508, -0.9915853088298465],
            [-6.418235538542246, -0.9912528267158569],
            [-6.4162676204805305, -0.9898681525295573],
            [-6.40883173965285, -0.9905213912183665],
            [-6.408738186863843, -0.9841949986058738],
            [-6.402547179051351, -0.9781625134559361],
            [-6.392580857689278, -0.9715253354846435],
            [-6.389676657379498, -0.9725085922947974],
            [-6.3880617277711735, -0.9691562113628573],
            [-6.384997269687336, -0.9700191922483626],
            [-6.380294289358795, -0.9650800701231667],
            [-6.3636053056136435, -0.9613394741106108],
            [-6.367092374294086, -0.9506088495041755],
            [-6.364439299049726, -0.9419432069416107],
            [-6.365251488245852, -0.9370323588382701],
            [-6.360859907547302, -0.9255604809375959],
            [-6.357405602068917, -0.9222485342440695],
            [-6.360217596661465, -0.9155077137397535],
            [-6.356765647763959, -0.9146086445053576],
            [-6.356550866780705, -0.9099613282388591],
            [-6.3511282222373815, -0.9056271334708124],
            [-6.336166689603682, -0.908213212542248],
            [-6.322622495899533, -0.9089149433363871],
            [-6.304313739143536, -0.8947854533387052],
            [-6.296839566326644, -0.8760491516122167],
            [-6.236721822481181, -0.836229044240649],
            [-6.23338858973293, -0.801326276412939],
            [-6.148552301656437, -0.6757078829651643],
            [-6.149319031112192, -0.6685015940089015],
            [-6.079245465729972, -0.6214753333392978],
            [-6.0607757851666735, -0.6057875862506863],
            [-5.9038400874380885, -0.6793996530803009],
            [-5.889919587564356, -0.685822263755399],
            [-5.841859019450202, -0.708639037511736],
            [-5.840467120823648, -0.7092964742403935],
            [-5.847320204785176, -0.8000421063390741],
            [-5.606928142469997, -0.8205761512743688],
            [-5.592527768374616, -0.821675561362985],
            [-5.456584078971108, -0.8327860652076534],
            [-5.3363485243230055, -0.8421736373353386],
            [-5.123016843439324, -0.8584299414313431],
            [-5.109935087104274, -0.8596621910268207],
            [-5.079598293800602, -0.861925837149753],
            [-5.080732569981526, -0.880895514446792],
            [-5.098251379594937, -1.1254588800434866],
            [-5.104440941186673, -1.1251398796777592],
            [-5.125325153377508, -1.3647045605803112],
            [-5.126463349452617, -1.3730607635440368],
            [-5.1359276654412875, -1.5089139165892804],
            [-5.190993485281601, -1.5047230305346424],
            [-5.3899755438579655, -1.4904327974154257],
            [-5.440215575690302, -1.4867408028458098],
            [-5.6472966178118105, -1.4711360546518002],
            [-5.863036259101317, -1.4550594123417042],
            [-6.026430989935079, -1.4424644776069346],
            [-6.054436429031441, -1.4402697696471807],
            [-6.12411375218037, -1.435298967181331],
            [-6.199080295153653, -1.4285455039830843],
            [-6.266253749140408, -1.4224298126443413],
            [-6.349154299249158, -1.414315783822781],
            [-6.350004598344923, -1.4150269785008813],
            [-6.365373820397578, -1.4138511608283093],
            [-6.452282887857225, -1.405787574346482],
            [-6.645407195430993, -1.3879043989663464],
            [-6.66803871802045, -1.3862944332760028],
            [-6.739885136192615, -1.3766785843471137],
            [-6.766854837337173, -1.3741684298891101],
            [-6.737256609977008, -1.0750087682882907]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.03864328932599,
          "lat": 37.315795262202364
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08071"],
        "coty_name": ["Las Animas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Las Animas County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00198151"
      },
      "bbox": [
        -6.766854837337173, -1.5089139165892804, -5.079598293800602,
        -0.6057875862506863
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.072783955291262, -9.418958277509619],
            [13.080692681880716, -9.417951611874665],
            [13.181014035855142, -9.402459562006714],
            [13.22079842430443, -9.396630060382064],
            [13.246795400937494, -9.392483797710948],
            [13.255267217854351, -9.390576165190518],
            [13.30707569121213, -9.382693824439901],
            [13.390337863680191, -9.369733644286121],
            [13.461723820492114, -9.358704752527373],
            [13.493899518462744, -9.353619593731459],
            [13.629606456522998, -9.332706304936588],
            [13.765305980144895, -9.311744243839088],
            [13.76542908274729, -9.311989872772468],
            [13.78242930571621, -9.409607121780944],
            [13.80687586928099, -9.566869726843512],
            [13.801253499023336, -9.567777985937592],
            [13.804381386654418, -9.586822819502501],
            [13.80490319247941, -9.594720051901781],
            [13.806789350264292, -9.602971193528234],
            [13.816813881291925, -9.666969542521075],
            [13.817878956382087, -9.671436761378457],
            [13.822651463683439, -9.700567530152357],
            [13.843045206589853, -9.821968713903189],
            [13.831925357104028, -9.823738133806033],
            [13.847245195239374, -9.909567205095728],
            [13.85273076236117, -9.908546063927059],
            [13.86774532225043, -9.997115275385088],
            [13.7361881772295, -10.018101980661237],
            [13.696148791491844, -10.023983246631138],
            [13.631185722338168, -10.033226808065711],
            [13.632512532263458, -10.02961892521392],
            [13.635727249143798, -10.031456981609075],
            [13.63905149716466, -10.027807718055453],
            [13.638467628498505, -10.01614860919834],
            [13.637424791107527, -10.014125091933717],
            [13.631939945643007, -10.012286138591964],
            [13.62545411856536, -10.008275722730238],
            [13.620913064913951, -9.99187143646796],
            [13.617616285102306, -9.986903653475844],
            [13.618520375454013, -9.983016094096094],
            [13.615674651842655, -9.976172312445332],
            [13.61810416485486, -9.972497507467173],
            [13.617644714836741, -9.968888718340624],
            [13.610387722367136, -9.961963370544842],
            [13.603764525256723, -9.96201960065476],
            [13.602369952302835, -9.957742477001519],
            [13.59502438146574, -9.956692911869203],
            [13.594153773687207, -9.950639637537579],
            [13.597268749328036, -9.946374138600678],
            [13.595784964738462, -9.940499949268293],
            [13.590413592013675, -9.938117390109626],
            [13.58243668115421, -9.932885264899724],
            [13.581785284443642, -9.926042547140687],
            [13.586030917010186, -9.923837858201512],
            [13.583546917945588, -9.92032521395517],
            [13.579746773386214, -9.919520633738438],
            [13.579822743740445, -9.914828835141092],
            [13.577056977217831, -9.912072517412502],
            [13.573769169888738, -9.913376977685992],
            [13.570715919940131, -9.911348172185594],
            [13.572053652903115, -9.908430118283361],
            [13.568140481171586, -9.90497222534516],
            [13.567567324148364, -9.902038025606963],
            [13.56080417733004, -9.897672147805656],
            [13.556529517624922, -9.892187977488703],
            [13.55496531952819, -9.885779834588753],
            [13.544759733263302, -9.873863280340379],
            [13.54574786968361, -9.869851870803474],
            [13.541058971566247, -9.86836362243202],
            [13.539088501855693, -9.863506174722225],
            [13.532485240733442, -9.858190161373269],
            [13.523789083466962, -9.85267616740774],
            [13.51261149229399, -9.849089627222414],
            [13.507845077829682, -9.848225422133194],
            [13.501086687101068, -9.849227434852708],
            [13.495553220531145, -9.85194135385246],
            [13.478738800298645, -9.849517604863612],
            [13.47594509409347, -9.844513144929042],
            [13.468673669627133, -9.845805089649353],
            [13.461774411501619, -9.844595789262035],
            [13.460653878513249, -9.840887223259362],
            [13.45462189743745, -9.8349640214199],
            [13.451304108658832, -9.828383157173565],
            [13.452144395389455, -9.825939601492504],
            [13.449806720371734, -9.82001747020635],
            [13.443408928732252, -9.812903451546303],
            [13.439780662489275, -9.806587720184158],
            [13.440662323729562, -9.797846837242467],
            [13.442652316531433, -9.792178261673662],
            [13.442233395644847, -9.786008966752323],
            [13.434477172831924, -9.780250455881877],
            [13.434293671374217, -9.784155615713741],
            [13.419145324744507, -9.780782819241375],
            [13.414379317326748, -9.77852856020585],
            [13.41102188691915, -9.779131411026835],
            [13.405388609327666, -9.774419245847204],
            [13.406486201202231, -9.771745274027616],
            [13.413197428442583, -9.772175736971608],
            [13.413322838117962, -9.762620467675802],
            [13.401938672118572, -9.760643198846473],
            [13.4017166317467, -9.753379517951288],
            [13.399605970337879, -9.750633138406291],
            [13.38479216770381, -9.743820615862553],
            [13.381551808283852, -9.743407950361256],
            [13.37925152007549, -9.739667442809786],
            [13.374026547455097, -9.740144273032938],
            [13.370754153020725, -9.730450260126451],
            [13.365595495070654, -9.722015881909096],
            [13.360973704273599, -9.71692777462537],
            [13.355993784654316, -9.716751098445224],
            [13.338184361019156, -9.723182389429995],
            [13.336746846625905, -9.726038071411786],
            [13.332364094302113, -9.723106594013876],
            [13.326225769694176, -9.71203656765875],
            [13.32136667708367, -9.705716346578239],
            [13.318308569446526, -9.704786661636517],
            [13.312990091595386, -9.697375884583002],
            [13.30969316165249, -9.694678286295218],
            [13.30289086450385, -9.697272712896062],
            [13.300420828333756, -9.696127722080666],
            [13.292560694312497, -9.689377420198003],
            [13.290455572547824, -9.68438674744714],
            [13.291456582005324, -9.676368221009122],
            [13.294191574992936, -9.673496180280928],
            [13.297187851743985, -9.673926193241927],
            [13.303161697918831, -9.670511392404007],
            [13.307777613605708, -9.67198583620894],
            [13.311071008273826, -9.675506359890448],
            [13.315062154359193, -9.684529642243557],
            [13.31958763937703, -9.687729854207701],
            [13.328703800374157, -9.687659735936093],
            [13.33553162391232, -9.69100713609995],
            [13.340597149917773, -9.694846513232378],
            [13.348073081325674, -9.69331898185682],
            [13.35113619408835, -9.69417035863008],
            [13.354101475249406, -9.702092730703912],
            [13.360032577044686, -9.703546458015072],
            [13.363590031055836, -9.707839415103757],
            [13.36697459851279, -9.707936424250704],
            [13.368309033617969, -9.703653308050562],
            [13.36514763090148, -9.697986853450981],
            [13.367279060213578, -9.694993161836118],
            [13.366997381380981, -9.690075076877173],
            [13.376125772782874, -9.680672685558454],
            [13.376841581887524, -9.674643174444885],
            [13.374083438267704, -9.671925734077249],
            [13.372227936194923, -9.663943120007636],
            [13.369769860773557, -9.657880717192205],
            [13.370344645477768, -9.65127551386983],
            [13.380596847198966, -9.650860505811334],
            [13.386460305170978, -9.647369253253679],
            [13.384025783287882, -9.637165505953018],
            [13.384088692862147, -9.63279055859232],
            [13.359205249410685, -9.636191733938794],
            [13.297805549623211, -9.645423539476326],
            [13.288408586916516, -9.64720186464108],
            [13.279156475525799, -9.590666446030939],
            [13.264296674856196, -9.593328607345102],
            [13.219745445190947, -9.600035639524396],
            [13.211067876587334, -9.543462268707728],
            [13.179994557943104, -9.500380641601778],
            [13.173097980412397, -9.491158373232958],
            [13.124099146888401, -9.498447051552898],
            [13.086027418057295, -9.50440750563161],
            [13.081816771223876, -9.476001471580178],
            [13.076674774909002, -9.444164535583958],
            [13.07600526989138, -9.437956379525064],
            [13.072783955291262, -9.418958277509619]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.14943862694443,
          "lat": 28.062649011071418
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12097"],
        "coty_name": ["Osceola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osceola County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00295748"
      },
      "bbox": [
        13.072783955291262, -10.033226808065711, 13.86774532225043,
        -9.311744243839088
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.568720523529437, -3.6477780615168074],
            [10.572678680735278, -3.6427930177155656],
            [10.572655209589215, -3.637338498668544],
            [10.57461730287296, -3.6333884914892223],
            [10.57992692451193, -3.630577820868042],
            [10.591042269346566, -3.6221951793000744],
            [10.595799356377475, -3.6102695169283763],
            [10.601817517387108, -3.603469401254829],
            [10.605952879383617, -3.596159938423023],
            [10.61057229626733, -3.5910067757594377],
            [10.612525939885066, -3.587111951778553],
            [10.61833081024228, -3.585966022227519],
            [10.623828788197613, -3.579651945544977],
            [10.651688267288039, -3.5802667232414707],
            [10.679961028025193, -3.580101444325065],
            [10.688262776155682, -3.5817364849497833],
            [10.68898194384085, -3.578956726112912],
            [10.727989765666267, -3.590370424655504],
            [10.731537251412178, -3.593018728529095],
            [10.736176087354725, -3.593377047141024],
            [10.740979463998015, -3.5953300619010493],
            [10.741242828236958, -3.5966956771260237],
            [10.749374879506629, -3.6103938702379845],
            [10.753265353382176, -3.6196171325739064],
            [10.75780307947701, -3.625522315693582],
            [10.762560931603147, -3.64351701317479],
            [10.763214046312582, -3.6502662868432836],
            [10.761166797610938, -3.6663324769897963],
            [10.760715668151168, -3.6754327302618344],
            [10.761528575874765, -3.6842395810516475],
            [10.762486478064218, -3.7306849493348793],
            [10.785944594016717, -3.755343900122562],
            [10.790809694784572, -3.7609969152904865],
            [10.814677937433741, -3.7850988691918297],
            [10.816548181804412, -3.7897961781615828],
            [10.81498920178464, -3.797540247693264],
            [10.815655717471346, -3.8003285817404784],
            [10.813565716686693, -3.804306187248283],
            [10.815067988032634, -3.8095537450488073],
            [10.809652030934204, -3.815719627913385],
            [10.807383856110137, -3.827236339330481],
            [10.804721567068189, -3.829438228505801],
            [10.805406014765707, -3.8335053580362315],
            [10.801735422304557, -3.8358822529125733],
            [10.8012281297537, -3.8404725565530367],
            [10.793510993417453, -3.847620094121054],
            [10.787648518327973, -3.8482015836562113],
            [10.78166863413744, -3.8504365704243866],
            [10.773997110197447, -3.8552363934502942],
            [10.772528437410784, -3.858502378353614],
            [10.763123378073404, -3.8507745306524797],
            [10.753967448042536, -3.8457869446628368],
            [10.753022593627174, -3.841980599102404],
            [10.739980748777228, -3.8331780040905112],
            [10.727728389103685, -3.8240720095525655],
            [10.70167069944803, -3.8037776251738014],
            [10.69451234826197, -3.8091282446485377],
            [10.688928079840373, -3.8049277185722197],
            [10.683322583463793, -3.810515423057695],
            [10.659948468501181, -3.8136247500925595],
            [10.635827587086336, -3.8205666516026198],
            [10.632113630388, -3.817387718607963],
            [10.626205027734324, -3.816162069683262],
            [10.609156116559829, -3.805064830101952],
            [10.605150444024716, -3.8009106976496727],
            [10.603886992840279, -3.7967685178859902],
            [10.594678299986226, -3.791471436251593],
            [10.58666258850934, -3.7881341793564216],
            [10.582756346372362, -3.784242882443852],
            [10.577826706420943, -3.7788744363595907],
            [10.576711545894906, -3.773790444934009],
            [10.571223774676122, -3.7739960457689645],
            [10.562673576090026, -3.7692363487026332],
            [10.555747425175454, -3.7623865799091125],
            [10.554461605188296, -3.755653968470397],
            [10.554852260044916, -3.7480757776852287],
            [10.550824120522552, -3.7393848164856918],
            [10.550130706991228, -3.7340576001487693],
            [10.545033796002363, -3.7289635196988495],
            [10.539197278516003, -3.727220540569526],
            [10.533406134035173, -3.7180897766691117],
            [10.535223255765851, -3.7168347440603724],
            [10.53883975282186, -3.7055807394267277],
            [10.537599672748073, -3.693319767903294],
            [10.54016119006097, -3.6839371110820505],
            [10.542164988165256, -3.6807735145944385],
            [10.547513601651099, -3.676199644862101],
            [10.548244685271456, -3.6699158479063323],
            [10.550382404012058, -3.6671249686330203],
            [10.564094643433366, -3.6608346405238836],
            [10.56607908625336, -3.652418173221235],
            [10.568720523529437, -3.6477780615168074]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.49725706895359, "lat": 34.35432050171919 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13011"],
        "coty_name": ["Banks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Banks County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00349230"
      },
      "bbox": [
        10.533406134035173, -3.858502378353614, 10.816548181804412,
        -3.578956726112912
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.8519834629412, -5.088931444340357],
            [11.865064237800206, -5.033689723412925],
            [11.873704656603772, -4.982460749377247],
            [11.867390546562326, -4.960526157951158],
            [11.855644422128384, -4.913723179614957],
            [11.846394690734632, -4.885526500091215],
            [11.840079817720836, -4.860655735390294],
            [11.841303343164236, -4.838248917764661],
            [11.841544085133133, -4.812280647950361],
            [11.847018891245753, -4.768512443712011],
            [11.851019917564441, -4.747978610655448],
            [11.852843117740226, -4.740741900288954],
            [11.857723965397867, -4.7133200333946],
            [11.864072093797086, -4.690047616341533],
            [11.863926593634535, -4.686523240100053],
            [11.856681686218588, -4.685572812213718],
            [11.856712068834733, -4.681641641832005],
            [11.84673339490622, -4.666672028641033],
            [11.842255657853526, -4.66392652489127],
            [11.8414248518365, -4.661239580981978],
            [11.834354307724121, -4.6558870187267996],
            [11.829880699091891, -4.654777757288249],
            [11.874104850891522, -4.629989334030223],
            [11.90230669953522, -4.614451574394013],
            [11.909946866607784, -4.614119478342379],
            [11.914185074499631, -4.620208828920309],
            [11.922640096423095, -4.6260615908044835],
            [11.9310748232418, -4.6260870486885315],
            [11.93862795421785, -4.630327905106132],
            [11.941213897842063, -4.637750132619093],
            [11.943100379186331, -4.638980829159541],
            [11.943782780554486, -4.644974889662087],
            [11.948563512952514, -4.652420978957548],
            [11.949383290623558, -4.655337134134562],
            [11.954378159908504, -4.656539963009511],
            [11.960018091886088, -4.660472226274137],
            [11.963927180977002, -4.661682638875716],
            [11.969848929740937, -4.669226778710655],
            [11.975351702910487, -4.670849756834398],
            [11.98247588028505, -4.670144045555478],
            [11.991899868239244, -4.663094679330347],
            [11.994838041363789, -4.659329915344283],
            [12.004095002832667, -4.654499939754657],
            [12.017295106587353, -4.65882313979967],
            [12.02519851593033, -4.660460085986146],
            [12.033163204763802, -4.661081112915469],
            [12.036839149603335, -4.658679327635778],
            [12.04038763049353, -4.659189853708078],
            [12.045267715404169, -4.657210215003042],
            [12.05778820675641, -4.658252923635611],
            [12.063860028092629, -4.660535389081713],
            [12.066052245963078, -4.659342682073561],
            [12.073057496575561, -4.65990905687249],
            [12.07608863947286, -4.656771074458345],
            [12.081000331735606, -4.6550846645045025],
            [12.086070115996705, -4.651261562102179],
            [12.087097356013548, -4.64893644316809],
            [12.093142867354551, -4.64538491732517],
            [12.101696346799667, -4.635636562837865],
            [12.102633652032722, -4.631888963267551],
            [12.105669136227164, -4.628929228531982],
            [12.111640736546946, -4.626245014291979],
            [12.11341466667319, -4.623759523586699],
            [12.121134347833967, -4.620363035387503],
            [12.128128636960232, -4.619347268118107],
            [12.131625567075533, -4.61665030315157],
            [12.142668509390829, -4.6158345705998],
            [12.1434133675132, -4.614384281508452],
            [12.1517119152339, -4.6162328379287],
            [12.15794304673276, -4.6215638516433515],
            [12.16516639695429, -4.625805708930468],
            [12.169404766343177, -4.626762401196325],
            [12.174513053209433, -4.6240090494513835],
            [12.179663178958013, -4.6292792542944845],
            [12.187237419696201, -4.63159589158118],
            [12.193049401030665, -4.635596112406115],
            [12.196889726632444, -4.639891190503412],
            [12.210935541812571, -4.642757334074678],
            [12.214552883756342, -4.646679234348856],
            [12.215570979875798, -4.652310741893796],
            [12.21921789210426, -4.654197804044906],
            [12.223857818936668, -4.653197351150435],
            [12.230912787488426, -4.655385157240643],
            [12.23564356136325, -4.654979138436908],
            [12.239991209042907, -4.65260116291868],
            [12.240234302211551, -4.646984169232899],
            [12.236764902409218, -4.642939571679065],
            [12.242322290075338, -4.640785391241498],
            [12.248055887526872, -4.644793747170308],
            [12.25357942898352, -4.65684799474283],
            [12.259712774476624, -4.661532222986887],
            [12.258204595239961, -4.665183336363505],
            [12.25812653977182, -4.670774396386967],
            [12.25397971493898, -4.672818590257286],
            [12.25298044648555, -4.676215510229083],
            [12.256048289112357, -4.680927425271639],
            [12.253171328963134, -4.682476078170536],
            [12.25578474666483, -4.689184909941701],
            [12.255114057097499, -4.69253226147335],
            [12.258562153781687, -4.694752940787706],
            [12.260547472555219, -4.700642882746102],
            [12.269286585963696, -4.708356047898467],
            [12.276378646755628, -4.7118535790533995],
            [12.278445744808675, -4.715498811476629],
            [12.292049492508108, -4.721970604271678],
            [12.299565448040896, -4.728241897968117],
            [12.309009517733312, -4.731686261191563],
            [12.315141619937908, -4.736036696722269],
            [12.321461722515787, -4.734979409393484],
            [12.338726969169167, -4.738355143938516],
            [12.34344371524814, -4.740582339150111],
            [12.355165251297548, -4.743472860457021],
            [12.36634161846822, -4.75050363002917],
            [12.369927663017316, -4.751380057857199],
            [12.39206145493293, -4.7455851367215836],
            [12.392887309431469, -4.745827579342167],
            [12.396585411655778, -4.747475489127632],
            [12.398572497434326, -4.751219542153721],
            [12.39550511934476, -4.75680040187904],
            [12.397966856796724, -4.760519919790003],
            [12.400874873849752, -4.758280932073129],
            [12.404604721287205, -4.752303815900982],
            [12.409657762834106, -4.7587953370961795],
            [12.407072869309093, -4.76636981201551],
            [12.413974815472777, -4.765068829622242],
            [12.418652468403891, -4.76752107117125],
            [12.42116835690006, -4.767179492109885],
            [12.422955376696583, -4.771921308902286],
            [12.426350692691424, -4.7701510162369685],
            [12.433894399858058, -4.77845907301688],
            [12.438533050695995, -4.7812449086849975],
            [12.440883233634436, -4.778471758433841],
            [12.44399883165833, -4.77891563730893],
            [12.443280187717296, -4.788217262762803],
            [12.452020760496177, -4.789373095180945],
            [12.455524237855913, -4.78331072752199],
            [12.459947343514342, -4.785833283313016],
            [12.364658844832906, -4.879268601410915],
            [12.327143297903994, -4.916827824604268],
            [12.294454049373895, -4.949120713587623],
            [12.290288480906385, -4.94724979936836],
            [12.288822996911293, -4.941219969710713],
            [12.28433067435097, -4.936489264788628],
            [12.274591461264851, -4.931136836642008],
            [12.272017817372491, -4.932230731417987],
            [12.267535951847686, -4.92891488624728],
            [12.259306237200075, -4.9278446777598015],
            [12.258645708347698, -4.929480603119453],
            [12.250827936711477, -4.927203225594016],
            [12.250102723560202, -4.922224671409637],
            [12.246931318081375, -4.919506251943408],
            [12.24230374023098, -4.920942306648112],
            [12.2389580430874, -4.924129629302262],
            [12.233874975544882, -4.922276716070759],
            [12.229899275556628, -4.922952483667477],
            [12.224805557010278, -4.919889177243909],
            [12.217470711724776, -4.9191828758666025],
            [12.213239382543453, -4.916213070510722],
            [12.136467084347457, -4.958199987631743],
            [12.12977511097688, -4.9599419996312815],
            [12.094543607570643, -4.967568058438963],
            [12.034420596847689, -4.980318698402322],
            [12.00427616361755, -5.0182830503752385],
            [11.993629003622864, -5.0845673829052425],
            [11.997104909040637, -5.091166201201768],
            [11.995182282918666, -5.0892808983202835],
            [11.989105936401218, -5.089247459085933],
            [11.984276562174074, -5.090537465624516],
            [11.983455704007186, -5.092646517522371],
            [11.97837442481187, -5.095794910570349],
            [11.97253171306554, -5.094204857841648],
            [11.969611538954059, -5.096951165995521],
            [11.963071134886182, -5.099419041590364],
            [11.960014305224892, -5.103261341930755],
            [11.955274143377043, -5.10204812144889],
            [11.951557916943605, -5.106048849171864],
            [11.94578419375495, -5.105892963543968],
            [11.941226705682437, -5.10846207010398],
            [11.938960858142543, -5.104192095099856],
            [11.922337810276257, -5.100085928233109],
            [11.919135864125735, -5.1028548280583665],
            [11.904828958017156, -5.096952582969793],
            [11.90345583805072, -5.093415027844388],
            [11.899269490551433, -5.094802884555418],
            [11.893294609993589, -5.093678084491323],
            [11.89138551937513, -5.098042745467598],
            [11.88523043914268, -5.094370353657456],
            [11.86624643279297, -5.095993154704034],
            [11.85647397117831, -5.094161007417172],
            [11.8519834629412, -5.088931444340357]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.00061192628475,
          "lat": 33.061103953448615
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13033"],
        "coty_name": ["Burke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burke County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00347944"
      },
      "bbox": [
        11.829880699091891, -5.10846207010398, 12.459947343514342,
        -4.614119478342379
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.165874069109181, -3.2578757550144926],
            [9.233964893317589, -3.2491205996173615],
            [9.343118524891967, -3.2357633386903],
            [9.395739873118334, -3.228888070669579],
            [9.397638018507685, -3.2437639022440488],
            [9.383333279264901, -3.2457503787460014],
            [9.386457973605012, -3.273280839002405],
            [9.38673061078771, -3.2780244546412574],
            [9.381890727025077, -3.291794577925697],
            [9.38181913447983, -3.3010255593839277],
            [9.37899988047373, -3.3079407174946844],
            [9.377200899426287, -3.308182715782607],
            [9.378398399626134, -3.3189507331728194],
            [9.370709786203369, -3.3198516908000326],
            [9.37422958512811, -3.349486224579066],
            [9.366606387112187, -3.3504051633624545],
            [9.367469486811267, -3.3577683541335923],
            [9.344112758192079, -3.360624396033274],
            [9.349218514091271, -3.4047224906790805],
            [9.313909706206244, -3.409092701624512],
            [9.314624646911216, -3.416001992007695],
            [9.300653572517852, -3.417809005889323],
            [9.299917669905962, -3.410699502122279],
            [9.29249924112017, -3.4110437511619103],
            [9.293016662187712, -3.4162531866388766],
            [9.290317528015544, -3.4291262566500587],
            [9.289428071563286, -3.4477690910750782],
            [9.287933485868855, -3.4642911047801386],
            [9.275694578417855, -3.4653946712001833],
            [9.274901327363812, -3.4581252352238545],
            [9.240893441311044, -3.462124729754255],
            [9.237513612655224, -3.430442711480052],
            [9.231557815358924, -3.382775291995071],
            [9.210102447813897, -3.3854764464081692],
            [9.180977999946494, -3.388695851243182],
            [9.178601140055232, -3.3682756647175753],
            [9.179003474478225, -3.3675796551747115],
            [9.165874069109181, -3.2578757550144926]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.13823426238866, "lat": 34.90362849811936 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13047"],
        "coty_name": ["Catoosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Catoosa County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00353230"
      },
      "bbox": [
        9.165874069109181, -3.4653946712001833, 9.397638018507685,
        -3.228888070669579
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.891330600248326, -3.2888721062213198],
            [8.997334920000657, -3.2788132434218067],
            [9.06931058104359, -3.2708653695304664],
            [9.086259203201118, -3.2685726024257478],
            [9.086249606547751, -3.273716847593128],
            [9.082780774790244, -3.2793270269312935],
            [9.08185093211602, -3.28795332059828],
            [9.080191469126671, -3.2932873292027334],
            [9.07301642507785, -3.308476903713878],
            [9.052501656986767, -3.3557528164588613],
            [9.051645764796486, -3.3571125817964895],
            [9.042031788340132, -3.3832336106191376],
            [9.03325534321305, -3.4281702175018434],
            [9.041469214963676, -3.500617012957499],
            [9.035074387895278, -3.509026500708466],
            [9.036078056332034, -3.5188896014450086],
            [9.035183064096222, -3.5291336344245843],
            [9.030834746414724, -3.5382167651102296],
            [9.01567132282531, -3.564370380301083],
            [9.018756649801404, -3.5940599295038997],
            [8.98870721482279, -3.643538264415538],
            [8.96496750645273, -3.5625271561202614],
            [8.952588687962006, -3.519729757374934],
            [8.922824102440405, -3.4113177820526173],
            [8.906074334039607, -3.3485415105036713],
            [8.900865599071697, -3.328102427563287],
            [8.899623034607721, -3.321299536337922],
            [8.891330600248326, -3.2888721062213198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.5044167576012, "lat": 34.85463523775496 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13083"],
        "coty_name": ["Dade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dade County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00347465"
      },
      "bbox": [
        8.891330600248326, -3.643538264415538, 9.086259203201118,
        -3.2685726024257478
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.131273147858973, -7.0076633605273155],
            [11.171877191917545, -7.003778843519105],
            [11.197350688174415, -7.001013368863119],
            [11.271394141557288, -6.993751692880079],
            [11.284783709777944, -6.992027909328024],
            [11.297217625988255, -6.991068534864399],
            [11.30889578616487, -6.9893664461073195],
            [11.367222983666394, -6.982863311362687],
            [11.381898272394391, -6.980804556315956],
            [11.385203993136441, -7.000265645868371],
            [11.393043117737951, -7.055014019545562],
            [11.432334392620653, -7.050834361314507],
            [11.50911002560782, -7.042141798589127],
            [11.510790726435285, -7.051547073449126],
            [11.514495189620657, -7.052985704810069],
            [11.517033304512253, -7.058311396948981],
            [11.514079503430073, -7.061923536134273],
            [11.517571040202752, -7.06447201232898],
            [11.51953410625894, -7.0690208156878],
            [11.518929647553687, -7.072235536352025],
            [11.526362224860979, -7.07205365727588],
            [11.52559501149884, -7.076518217026678],
            [11.534385745492584, -7.084843305098341],
            [11.533163630384783, -7.0898328560231265],
            [11.53560063940598, -7.095425342443127],
            [11.532877983781587, -7.099018057277224],
            [11.536579193651642, -7.104226039850031],
            [11.535313243164698, -7.108059995716687],
            [11.536502046733567, -7.111423603572965],
            [11.536296522380857, -7.1197794760330275],
            [11.535123222623076, -7.124828902089462],
            [11.537427713673942, -7.126870093596643],
            [11.537109418989452, -7.13404559803264],
            [11.542382125123694, -7.135895909090785],
            [11.484249659123938, -7.144600327039464],
            [11.486607143935169, -7.161819108393104],
            [11.473733412644176, -7.163330137191877],
            [11.476534817219784, -7.190787113229686],
            [11.459141746915131, -7.193189231721028],
            [11.45478422648764, -7.2032799423756675],
            [11.454274219850316, -7.212085063307551],
            [11.455379138885455, -7.2167504617029765],
            [11.453336109730698, -7.222511694882321],
            [11.454092898408108, -7.227753965836461],
            [11.45848742670199, -7.238575660948457],
            [11.458635788986145, -7.245868185215853],
            [11.459982117977814, -7.247350509395971],
            [11.458953361221692, -7.253581270679624],
            [11.459707865933145, -7.261931642760594],
            [11.46188531981159, -7.268488626200971],
            [11.460931631214494, -7.274948552252028],
            [11.46526879562905, -7.300732002120995],
            [11.471584903497652, -7.350899274518248],
            [11.47347258682764, -7.3715685200711],
            [11.456632286633498, -7.37232136008107],
            [11.44098820574465, -7.373486300140935],
            [11.325210163050304, -7.381006946200827],
            [11.318207961639263, -7.378884198903876],
            [11.31433998811506, -7.374921702906431],
            [11.3093815282655, -7.374027835817119],
            [11.307259031218031, -7.377556830026039],
            [11.300697412767066, -7.377974901503572],
            [11.298066037140831, -7.382681033909282],
            [11.28359306576909, -7.383576977234475],
            [11.27616937094057, -7.380460084326261],
            [11.280229738006442, -7.377312892516269],
            [11.278647159882354, -7.369688740695589],
            [11.275329811968282, -7.3667076133982325],
            [11.27043601357489, -7.366140911695596],
            [11.265534868871857, -7.363642161001738],
            [11.264870058968027, -7.3615928915723865],
            [11.257404802570909, -7.359798485293209],
            [11.254471416201989, -7.357428655860471],
            [11.248667248329701, -7.357757552623919],
            [11.250231037775881, -7.353347055335777],
            [11.245481552343053, -7.348553219005558],
            [11.238834801465483, -7.352002985841476],
            [11.232140545155909, -7.353736268800383],
            [11.22622842602459, -7.3500138033126845],
            [11.22803755317588, -7.348281412108729],
            [11.22605876415075, -7.342593910577106],
            [11.222128656929778, -7.339458856093793],
            [11.220135179532539, -7.34289257002565],
            [11.214473096287444, -7.341204448677965],
            [11.207080050273738, -7.342339957702495],
            [11.202917773008876, -7.33592774841719],
            [11.199329196724321, -7.336540058696675],
            [11.195726475351877, -7.332419840275893],
            [11.192013707193144, -7.322685806550955],
            [11.188329898796052, -7.319840678283151],
            [11.180964853059725, -7.316401485140102],
            [11.17832355137159, -7.316198265565738],
            [11.178514095771764, -7.308728273536913],
            [11.17754742222671, -7.303225948688517],
            [11.169874574598639, -7.295254904788042],
            [11.165163242071015, -7.292108344055403],
            [11.16034076362667, -7.284486894751272],
            [11.161699156712617, -7.279734835114983],
            [11.16765517668116, -7.275410580346969],
            [11.170167293307017, -7.276365387276649],
            [11.171815072038623, -7.271714306326526],
            [11.180764272586725, -7.269705894820495],
            [11.183859318954559, -7.263368859539868],
            [11.179281640345636, -7.257791209110732],
            [11.179934076366742, -7.252395618133155],
            [11.178759162468271, -7.248414468101502],
            [11.183207450029823, -7.245505794642676],
            [11.182196429558342, -7.238308113800574],
            [11.185877853629252, -7.234466576101142],
            [11.186011531121732, -7.228450313643987],
            [11.181252988522377, -7.223055522274167],
            [11.18128706577545, -7.216294478639968],
            [11.18590432483621, -7.215501300535133],
            [11.19223529315787, -7.218089508309643],
            [11.202355032856014, -7.215582970515646],
            [11.203843924360303, -7.211294883258201],
            [11.208449002676998, -7.204941101196261],
            [11.209738387028496, -7.201391582407475],
            [11.214650142677915, -7.200397122248184],
            [11.226300494612458, -7.202467121565272],
            [11.22984854824941, -7.199516456142244],
            [11.23625595644712, -7.198394890305353],
            [11.239663809288812, -7.195599769481339],
            [11.243930510410191, -7.185681630940481],
            [11.245862023897189, -7.187585526718599],
            [11.255995189947612, -7.1872247359769705],
            [11.262251919979818, -7.180069225070684],
            [11.260620604259005, -7.177505416208574],
            [11.264434616789256, -7.169207150335907],
            [11.259710818217602, -7.163388071451008],
            [11.256339589529896, -7.162060004711715],
            [11.251342437692204, -7.151170946288841],
            [11.246183660872946, -7.148408273479692],
            [11.244166127708434, -7.144855121424939],
            [11.239494988541626, -7.141111753607361],
            [11.236135614418181, -7.145106029653876],
            [11.230437384857353, -7.142554467571726],
            [11.226738202929639, -7.142325784998256],
            [11.21697823329754, -7.143874062115624],
            [11.216084429221533, -7.145156838114637],
            [11.202064446274266, -7.137289492177956],
            [11.199265897548425, -7.141856513715698],
            [11.192597325590656, -7.137641780274347],
            [11.186795575608201, -7.1321546225329016],
            [11.179595007325466, -7.130367177077702],
            [11.177600598458067, -7.120859290018296],
            [11.175664111244247, -7.119919032103616],
            [11.17823906273696, -7.106560121375451],
            [11.176047059584349, -7.104740943024583],
            [11.178334003899504, -7.098447326824316],
            [11.175923476877983, -7.0954852471234],
            [11.180213414093762, -7.089290459340614],
            [11.181532742716206, -7.084621074234751],
            [11.177887999092206, -7.077623727028588],
            [11.174559548418962, -7.079047002462044],
            [11.175258450052892, -7.072657006579285],
            [11.171385206263947, -7.065994554624304],
            [11.167147990016852, -7.061903271334734],
            [11.165034021099517, -7.050385972457077],
            [11.161903732265793, -7.046775905655264],
            [11.157200847256192, -7.04612052221387],
            [11.141137328571201, -7.024521157079553],
            [11.141278894369588, -7.019866716773277],
            [11.135976973202101, -7.015183507446922],
            [11.131273147858973, -7.0076633605273155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.26766957120836,
          "lat": 30.833847158698543
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13185"],
        "coty_name": ["Lowndes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lowndes County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00326720"
      },
      "bbox": [
        11.131273147858973, -7.383576977234475, 11.542382125123694,
        -6.980804556315956
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.32712405912555, 0.11418367745333202],
            [5.413367771607291, 0.12089353705832331],
            [5.405723341068689, 0.20871561627100008],
            [5.4428673045325695, 0.20986076787971963],
            [5.494754724459486, 0.21201669421279443],
            [5.5794553321318405, 0.2185587614040759],
            [5.65632644241326, 0.22480070353632592],
            [5.6702305738947745, 0.2258081348895507],
            [5.67747709560969, 0.22610807164968175],
            [5.73920696625609, 0.2262832930014457],
            [5.759860246601178, 0.22647820971342567],
            [5.7621423083799295, 0.19174105866430272],
            [5.7653100802504715, 0.1382970776967275],
            [5.767458267849816, 0.09427286026152332],
            [5.772617951469767, -0.00873051100010608],
            [5.745560659728904, -0.00882907130582242],
            [5.714998059277787, -0.009433584426715732],
            [5.6864072444014475, -0.009375058739192537],
            [5.679259079861592, -0.00795236901566944],
            [5.67654129933402, -0.011178154673619187],
            [5.671497095163647, -0.014041344766553538],
            [5.669663116618366, -0.011721528983631288],
            [5.660962256774728, -0.010451621350416095],
            [5.654287639915314, -0.013302372487814244],
            [5.645482772729127, -0.010464904057378136],
            [5.64287717625745, -0.008590661472370555],
            [5.6358565680283625, -0.011937842070247753],
            [5.633468667765075, -0.008616601647168522],
            [5.61746725111532, -0.012035628168651308],
            [5.614312927002826, -0.006544678610078451],
            [5.611153224599687, -0.00430737927204422],
            [5.605344539659789, -0.0059784482978583915],
            [5.603781557515476, -0.009184273946344291],
            [5.605718111012205, -0.014801352585415487],
            [5.604486440439721, -0.017749156783258647],
            [5.599260843437666, -0.01862069907738244],
            [5.60188209098906, -0.022988489274797023],
            [5.58871440345802, -0.027500455331208932],
            [5.586373620953999, -0.030846113793908114],
            [5.57990741041022, -0.030484759464987375],
            [5.574368695920656, -0.032275103998233856],
            [5.570561026207405, -0.030590271812941185],
            [5.569329900458457, -0.03736147897407526],
            [5.566211249705372, -0.03835037517572385],
            [5.561978204222533, -0.03274094586788477],
            [5.554807878338157, -0.030915020771760286],
            [5.553427170451721, -0.028198775025272578],
            [5.548510630898062, -0.033785323894956525],
            [5.549172826198207, -0.036842890064224434],
            [5.546099407227033, -0.03848773820538756],
            [5.540549958000926, -0.03825991672286276],
            [5.537145953477328, -0.040409007785398895],
            [5.532899078151017, -0.04649574505619862],
            [5.5335972164845675, -0.04921590698847073],
            [5.529556733972642, -0.05204009302089116],
            [5.524232644587342, -0.053381519341292816],
            [5.522785366586132, -0.056731212573424485],
            [5.516409131775254, -0.058894452819488026],
            [5.50781456350349, -0.05657266083342983],
            [5.504339429889822, -0.05824118943108906],
            [5.498328182062708, -0.05703670027019865],
            [5.492684395826299, -0.05724687656230498],
            [5.488690494572462, -0.059618138524415325],
            [5.483978107530339, -0.05791277547915002],
            [5.479908433596379, -0.05322101553074808],
            [5.475028294491741, -0.05429979241508333],
            [5.47276797922027, -0.052477166364365294],
            [5.4668414384789275, -0.05409631367814417],
            [5.468827158864933, -0.05793674540147718],
            [5.4631338226858475, -0.05947288348770619],
            [5.4597319304940415, -0.05653724824480455],
            [5.45401016373578, -0.05700177803921494],
            [5.4461400130788125, -0.05907397502087656],
            [5.446015369778842, -0.05393287069264253],
            [5.438582623999268, -0.051970794802587796],
            [5.437522865110955, -0.055359123065867745],
            [5.425821162373626, -0.06161006554513915],
            [5.421855200213651, -0.06054068179094728],
            [5.416422617832992, -0.062047457094038215],
            [5.410110963986458, -0.06564417830859795],
            [5.409488923594637, -0.07069877771843641],
            [5.404862113879247, -0.07716721779965353],
            [5.402740392053732, -0.07386976673484286],
            [5.400128405139207, -0.07560676423272404],
            [5.402284977337499, -0.08063965000890694],
            [5.402115020950661, -0.08754216988088871],
            [5.397643893490217, -0.09146844795908955],
            [5.3901141626861975, -0.09454782427798039],
            [5.38977924715658, -0.09745155562406499],
            [5.381528707175995, -0.09693694004303986],
            [5.37435515597808, -0.09484057550766534],
            [5.371620358333809, -0.09766956855150269],
            [5.371389597185308, -0.10489568763520782],
            [5.366233603014392, -0.10888480035106025],
            [5.364546328783709, -0.11401787881501743],
            [5.359219434460942, -0.11625993927050214],
            [5.35723616724598, -0.11418263683990934],
            [5.350618028053249, -0.11674674220422918],
            [5.352246075427355, -0.12099328753407707],
            [5.3515550197937705, -0.12591305735589858],
            [5.3452012732833625, -0.12672546282438768],
            [5.340623283495467, -0.061755876915796606],
            [5.334749468773036, 0.016695852742799527],
            [5.32712405912555, 0.11418367745333202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.42255677572788, "lat": 38.60649801355922 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17027"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00424215"
      },
      "bbox": [
        5.32712405912555, -0.12672546282438768, 5.772617951469767,
        0.22647820971342567
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.853504778182691, -0.18557780455818107],
            [4.858414107015335, -0.1788215636988623],
            [4.864489786128636, -0.17231734524280226],
            [4.874383628631356, -0.15768738577271318],
            [4.88867156880331, -0.14256725431686132],
            [4.891900256442707, -0.13167021684770416],
            [4.8940616622635815, -0.11877053363837696],
            [4.896516982833822, -0.0977844150022326],
            [4.89863938603365, -0.09047401712164944],
            [4.899006716292185, -0.08367405175769392],
            [4.901196242952843, -0.07362915293533748],
            [4.902515784190457, -0.06333219600071886],
            [4.905497934258035, -0.04862659437261546],
            [4.924535946984765, -0.06580521039404677],
            [4.929002552078873, -0.07041725391019729],
            [4.976617915058567, -0.11319866111111876],
            [5.00292022482832, -0.1376097041587918],
            [5.003703640840285, -0.15235354735248896],
            [5.017626150970732, -0.16639314404517314],
            [5.019272630566695, -0.16668686963362458],
            [5.04162237662204, -0.18790489229293236],
            [5.094086289618307, -0.2362827423803709],
            [5.095002335491339, -0.2509982889259122],
            [5.123858276978453, -0.2496531007473383],
            [5.190481188047178, -0.24577803979354299],
            [5.193367912071093, -0.2510600075976864],
            [5.198092754315592, -0.25692104249152087],
            [5.1962439865759125, -0.26008853696755185],
            [5.200965948884402, -0.266705498283388],
            [5.199705953749712, -0.2742399455151194],
            [5.194264921406913, -0.277871744856352],
            [5.1892347129466, -0.2765074951614626],
            [5.188696950314781, -0.27384127934317437],
            [5.192858196310754, -0.27180169965782625],
            [5.191533561105596, -0.2681022513904923],
            [5.187420209076923, -0.2684913788197578],
            [5.185294190805986, -0.2792136998189737],
            [5.183302182679309, -0.2815005407077537],
            [5.187707826032472, -0.2903333390131617],
            [5.192529782819686, -0.29554508394086765],
            [5.193670790118658, -0.29941316124420025],
            [5.19166659748302, -0.3038380576972385],
            [5.19581587322304, -0.3060915534566225],
            [5.198965896809076, -0.31102164690293754],
            [5.198392730070005, -0.31662678591435967],
            [5.204583905227229, -0.31878925771869276],
            [5.207482066240041, -0.32161635795598054],
            [5.207407052768077, -0.32517794887560797],
            [5.202891635292526, -0.3256320341326929],
            [5.2032683909323385, -0.3287304926707022],
            [5.207006873363354, -0.3331044506011291],
            [5.154738977918973, -0.3355531205020598],
            [5.100266212753732, -0.3373676897581792],
            [5.106057722307152, -0.42558170578718857],
            [5.092023622502952, -0.4315422520909058],
            [5.072052005319632, -0.4405617668315582],
            [5.050164424596066, -0.4498968556711967],
            [5.040373662982902, -0.45509800276763257],
            [5.022464480871318, -0.46213028722054705],
            [4.980125807567431, -0.4815319416542357],
            [4.977418787719767, -0.48316780833435846],
            [4.966553063372418, -0.4760317833989009],
            [4.946447071633164, -0.4587363764216987],
            [4.940245331292901, -0.4465830338000448],
            [4.938096643429673, -0.44392209061555227],
            [4.918973787190335, -0.4149288062208373],
            [4.905886050843102, -0.40272978327938963],
            [4.898038394028006, -0.398352669509214],
            [4.8806663043777325, -0.39297298717239154],
            [4.870914104641868, -0.3851199333910735],
            [4.854217502565941, -0.3619145179609136],
            [4.849184655731353, -0.35142015487926814],
            [4.842604218805874, -0.3302147919096554],
            [4.8403952479311085, -0.315870266712001],
            [4.835324199091878, -0.28982364051456144],
            [4.834970423898263, -0.2715109535877468],
            [4.833214479240679, -0.25239526739376283],
            [4.833923220686725, -0.24203526263372135],
            [4.8355386899822665, -0.2351619425953797],
            [4.843561737549436, -0.21435288417152476],
            [4.848105631112614, -0.19678056928226967],
            [4.853504778182691, -0.18557780455818107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.17729202141395,
          "lat": 38.278533297685335
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17133"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01784865"
      },
      "bbox": [
        4.833214479240679, -0.48316780833435846, 5.207482066240041,
        -0.04862659437261546
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.172566757468181, 0.8723390260479374],
            [7.164845772201307, 0.9604008518125496],
            [7.1559159025475525, 1.0593063441038437],
            [7.154359350684724, 1.078950824274528],
            [7.1513538583234615, 1.1111843195994056],
            [7.149342955302852, 1.1353164867375298],
            [7.178981506003157, 1.1372895492484976],
            [7.171668330170905, 1.2250710565936713],
            [7.2286246176134235, 1.228988078450181],
            [7.31320122627645, 1.2359691849140413],
            [7.320649710460189, 1.1477772101843287],
            [7.324586801720326, 1.1040309187752417],
            [7.335623321733956, 1.1052595632102198],
            [7.381360925121618, 1.1092057415611516],
            [7.382286026302895, 1.0913931859625363],
            [7.384234361538662, 1.0648359627577253],
            [7.383738086024188, 1.0648331425355644],
            [7.389502107651711, 1.006232620466462],
            [7.392076462127522, 0.9771001994478629],
            [7.307235391858189, 0.9696276673616204],
            [7.31031305593355, 0.9336651257535536],
            [7.313230038878727, 0.8964637166173695],
            [7.3148604971457765, 0.8822696761564974],
            [7.3183664681743394, 0.8471098802381046],
            [7.3185215157393335, 0.8417363989023747],
            [7.323084117682553, 0.7941588757791715],
            [7.26615090797058, 0.7897230593124982],
            [7.180403628866016, 0.7845705409348797],
            [7.172566757468181, 0.8723390260479374]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.11578684792605, "lat": 39.39277708252497 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18021"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00450341"
      },
      "bbox": [
        7.149342955302852, 0.7845705409348797, 7.392076462127522,
        1.2359691849140413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.494240475312798, 1.8712564761471422],
            [7.4916298232230565, 1.9004547109642451],
            [7.4845879458170135, 1.9731799681356599],
            [7.47778284587939, 2.046223121940521],
            [7.473493913813162, 2.0898766903114208],
            [7.54011335078547, 2.095767270458151],
            [7.572076853724007, 2.098899373911753],
            [7.643422172986946, 2.1055532483533526],
            [7.7129482056346585, 2.1134764531443375],
            [7.7628885411578255, 2.118424158558689],
            [7.767281849502835, 2.0749509187220143],
            [7.788686939624529, 2.077109341481682],
            [7.7902466660699226, 2.0624669709609083],
            [7.818620630522312, 2.065308491236437],
            [7.8292559246779465, 1.965050464318694],
            [7.831943176490741, 1.9412615039186925],
            [7.835126495749868, 1.9070232219454977],
            [7.8390361449285955, 1.8718859306847089],
            [7.808837131135823, 1.8676695702545543],
            [7.806957643443542, 1.867723212767584],
            [7.7675851219667305, 1.862644466629567],
            [7.74619632467987, 1.8593933414622292],
            [7.696711763541304, 1.853544823231281],
            [7.669605056306625, 1.8508528334666412],
            [7.584096203552209, 1.8429739358981125],
            [7.555689409733266, 1.840942134632317],
            [7.512375412338116, 1.837199356557399],
            [7.497636368600393, 1.8354034886294717],
            [7.494240475312798, 1.8712564761471422]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.47513368067993, "lat": 40.30169054309567 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18023"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00450342"
      },
      "bbox": [
        7.473493913813162, 1.8354034886294717, 7.8390361449285955,
        2.118424158558689
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.8899176699116405, 1.3222504826815997],
            [7.930425335339667, 1.3271868059673766],
            [7.959204974742765, 1.3308912718518482],
            [8.002282755744934, 1.3361406532138447],
            [8.04530018907226, 1.3420429241633556],
            [8.064901582566955, 1.3442254779189318],
            [8.086540998920759, 1.3471442446189894],
            [8.115407255914441, 1.3505832361960513],
            [8.118180637655987, 1.3212512775205372],
            [8.124721544585919, 1.2646541381671792],
            [8.126228738394975, 1.2497740785417832],
            [8.131625255469174, 1.2070574274044445],
            [8.135398028998491, 1.1662769412363794],
            [8.137820266840604, 1.147703947920259],
            [8.136614985566059, 1.1474035317834788],
            [8.138174931097122, 1.1311462271824237],
            [8.143924989108259, 1.0767041662193542],
            [8.1464583905615, 1.0585740170882885],
            [8.126785792784384, 1.0557262418283289],
            [8.11901307499138, 1.0549863540918458],
            [8.09572665865737, 1.0516190730347978],
            [8.045018579914329, 1.0446520145995313],
            [7.986427640960796, 1.0369567468813081],
            [7.9187289360523225, 1.0289897123317302],
            [7.9158149941823295, 1.0586714485175055],
            [7.905347357480846, 1.1617827080624132],
            [7.900689408810777, 1.2046900526332533],
            [7.901675271921793, 1.2048077432749953],
            [7.893786358304907, 1.279433801393505],
            [7.89278891135449, 1.2925192621330421],
            [7.8899176699116405, 1.3222504826815997]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.10158354449217,
          "lat": 39.489957921071145
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18081"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00450365"
      },
      "bbox": [
        7.8899176699116405, 1.0289897123317302, 8.1464583905615,
        1.3505832361960513
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.974730593688753, 2.7154288808723885],
            [7.975493713815328, 2.715571601924734],
            [7.970731299355388, 2.759245165218758],
            [7.985065093723449, 2.760470141423257],
            [7.999055304659931, 2.7623076304546954],
            [8.025241842328546, 2.765224056420268],
            [8.082033900490211, 2.7718596864468554],
            [8.117165709403773, 2.7769096268547173],
            [8.152912343233652, 2.781650068171656],
            [8.164710048401705, 2.7839775343696793],
            [8.170335421222555, 2.739196559631404],
            [8.19957524506443, 2.742786692840804],
            [8.201193655441827, 2.7288620715337406],
            [8.210292652839263, 2.65523061124473],
            [8.210563811978682, 2.655260247832877],
            [8.218441457132702, 2.590240830515305],
            [8.217966099059245, 2.588339324150201],
            [8.229085601961355, 2.4993548663849783],
            [8.229124798668234, 2.4979279378831794],
            [8.236292907462802, 2.4370365199583244],
            [8.241797583271266, 2.3935181077121137],
            [8.214212604152923, 2.3901906473070023],
            [8.094067179086318, 2.376297699208211],
            [8.078549665550222, 2.3740664902672006],
            [8.07279734291452, 2.373784491593026],
            [8.016975729615716, 2.3671249621112973],
            [8.012799598000807, 2.4025499918237583],
            [8.002339267288146, 2.4887248442451146],
            [7.996554081181015, 2.5397421403858593],
            [7.982019404155106, 2.6590663006782878],
            [7.974730593688753, 2.7154288808723885]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.79399768769657,
          "lat": 40.845658081597165
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18169"],
        "coty_name": ["Wabash"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wabash County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00450399"
      },
      "bbox": [
        7.970731299355388, 2.3671249621112973, 8.241797583271266,
        2.7839775343696793
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.869586306172871, 0.4731306087274863],
            [-1.7914021779189573, 0.4708528593924078],
            [-1.7559223597036842, 0.469694579924817],
            [-1.6429515547904716, 0.4662395680549768],
            [-1.5719108476426722, 0.4643763628345839],
            [-1.5706239469064542, 0.4645788371452429],
            [-1.4865489619356207, 0.46190038788206866],
            [-1.4491271492838524, 0.4604729025015944],
            [-1.4443283183306819, 0.4603210557653588],
            [-1.446319591523807, 0.40185677150095184],
            [-1.4475473016488993, 0.3719114963410934],
            [-1.448789316504062, 0.35726317584926276],
            [-1.44854792642777, 0.3492195423627583],
            [-1.4500695092310623, 0.2887513168313541],
            [-1.4520951332573835, 0.1960315873871219],
            [-1.4549113028664125, 0.108392965521159],
            [-1.4576491641159395, 0.02051468688774945],
            [-1.5379925427740087, 0.02264760220315195],
            [-1.6240383891676917, 0.024875836093248473],
            [-1.738325373953894, 0.028262621399136743],
            [-1.8016027578438447, 0.030269342016449822],
            [-1.8801656779398965, 0.03266546759844621],
            [-1.887623047556883, 0.03295239459557152],
            [-1.8849062358786477, 0.08649135808192161],
            [-1.8796891580644073, 0.2014341701305378],
            [-1.879873670239435, 0.20888222904864415],
            [-1.8765261626529992, 0.2966005323430731],
            [-1.8731436618052704, 0.38006194769460033],
            [-1.870086785905036, 0.464954811538659],
            [-1.869586306172871, 0.4731306087274863]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.76238512338352,
          "lat": 38.914802554712345
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20167"],
        "coty_name": ["Russell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Russell County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00485046"
      },
      "bbox": [
        -1.887623047556883, 0.02051468688774945, -1.4443283183306819,
        0.4731306087274863
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.07821773548063485, 0.34654624687241276],
            [0.09262026624691495, 0.34631522884428084],
            [0.16311769792852027, 0.34573493021579005],
            [0.16323207513756274, 0.3602709978903567],
            [0.16283057555085248, 0.375022119323865],
            [0.1633945897757358, 0.43362896333878653],
            [0.16452178811430485, 0.43363947982192547],
            [0.16499957087099323, 0.47659178339201874],
            [0.17238409343869657, 0.4682562595870347],
            [0.17742157054156601, 0.46775274441907777],
            [0.1847806941126706, 0.4756775799387795],
            [0.18912754427794945, 0.4766423870365976],
            [0.19009119523865517, 0.4731487178211428],
            [0.18743006083456903, 0.46272792777047594],
            [0.18855258569860447, 0.45998977874420016],
            [0.19749303093102602, 0.45731256407224213],
            [0.20468027426847987, 0.465604524619282],
            [0.20921837711706387, 0.4622973778919768],
            [0.21154403018648724, 0.4643104557918094],
            [0.20941134174542997, 0.46918395153057424],
            [0.21443251118495893, 0.48970504713643004],
            [0.21696365134993326, 0.4935286946448607],
            [0.2247619632755688, 0.49960948602624816],
            [0.23089445735266653, 0.5012331956468947],
            [0.2378963208161334, 0.4991204195983283],
            [0.24251200459915553, 0.4945077969107146],
            [0.24720460802169092, 0.4871603568051066],
            [0.2536837736260257, 0.48287505281084836],
            [0.2595416869691301, 0.484061813239726],
            [0.2683509640596486, 0.4947742474564585],
            [0.27204909990709986, 0.5012689304125927],
            [0.274231502681603, 0.5080867118654467],
            [0.27958338048873016, 0.5146794117406873],
            [0.28440634293924144, 0.5159777705312548],
            [0.2908266565079713, 0.5106702869475281],
            [0.29457170386267795, 0.504516448688649],
            [0.30621948363999585, 0.5032981038367716],
            [0.31016295987134884, 0.5060053563469786],
            [0.3126999361037614, 0.5101603623635875],
            [0.31739441998526174, 0.5114571326943613],
            [0.32303616349462705, 0.5105404797641088],
            [0.3264939621145785, 0.5061151507726943],
            [0.32609739291852086, 0.49567623747682366],
            [0.3296398601659243, 0.4921372449209385],
            [0.3354074823847763, 0.4941974494385844],
            [0.34640674202052235, 0.49596077725625537],
            [0.3536177670790934, 0.4951217124574694],
            [0.36689094223840135, 0.49046100314463836],
            [0.3727040610006826, 0.4915811811364054],
            [0.3750640117328987, 0.4940940587715871],
            [0.3780620973753766, 0.5034559862324686],
            [0.38358963662247814, 0.5035446009185697],
            [0.3898431665498826, 0.4951618435007424],
            [0.39642246116078644, 0.49712004542536214],
            [0.3995964813566355, 0.4968314858413512],
            [0.4091729237281454, 0.48430937835158244],
            [0.41382881466929067, 0.4741832791431851],
            [0.41861199063813714, 0.4678452060860372],
            [0.4194565290106085, 0.46114323861526263],
            [0.4150499537471474, 0.46063318800041786],
            [0.40933085118474133, 0.4654497967211016],
            [0.3993315654180802, 0.4663019254658432],
            [0.393932092715897, 0.46171844310015475],
            [0.39380379496621365, 0.4576722436479972],
            [0.3959744554296256, 0.4552765223400216],
            [0.40410300041746994, 0.4530786754107787],
            [0.41060278826860014, 0.44981578731484045],
            [0.41669055858596926, 0.4452382696233274],
            [0.41994405399773155, 0.44419941833718524],
            [0.42995381222450574, 0.44398108138310605],
            [0.43289903940002467, 0.4400525498171319],
            [0.43162270048664786, 0.4324762534655579],
            [0.4337273697545176, 0.42919221732134455],
            [0.44113396473251915, 0.4249917247890007],
            [0.44811304678689196, 0.422835455769708],
            [0.4540926429116535, 0.42553807418711387],
            [0.45691935283061225, 0.4307703939987708],
            [0.4608296809731958, 0.4347115137051273],
            [0.46641602650486014, 0.43689319263896076],
            [0.46908052385833215, 0.43611192943205973],
            [0.4704333034015341, 0.42990012762815094],
            [0.4649603054834287, 0.4252668801463043],
            [0.45972734994539666, 0.4244118669088901],
            [0.4566823017684304, 0.41871099669137496],
            [0.46582668174202996, 0.4122392552091817],
            [0.47110736666066916, 0.41262424881867965],
            [0.47840179246456727, 0.4157903950553675],
            [0.4847924863289412, 0.41408777989465617],
            [0.4905115704031914, 0.40872168546376214],
            [0.4926983302250409, 0.4045347487456519],
            [0.4973584398740198, 0.40144639031612417],
            [0.5046686557178095, 0.4010886864342219],
            [0.5047832561167148, 0.3749613889758587],
            [0.5047521737483801, 0.28774105041761205],
            [0.5045890870372106, 0.26544796371640955],
            [0.5049267970489213, 0.1701717184133523],
            [0.5051515597786199, 0.08343653474969286],
            [0.5055132135146906, 0.038040720400936014],
            [0.4339589769448833, 0.03788139832970695],
            [0.36243805029032156, 0.03805530460082249],
            [0.2584065118635119, 0.0380857459944268],
            [0.20513308209965003, 0.03860141114130909],
            [0.19135042975826796, 0.0384422368635988],
            [0.16266328152197118, 0.038516911387238964],
            [0.16252224577422145, 0.1262361356130316],
            [0.14854771043210108, 0.12647055832200182],
            [0.13360011575549705, 0.1259809876917022],
            [0.10725051021468068, 0.12659405757544148],
            [0.07688165770057565, 0.12697112589260046],
            [0.0769908454345918, 0.1709089978837312],
            [0.07739696316060371, 0.25910381347151407],
            [0.07802763612114881, 0.3175009996665094],
            [0.07821773548063485, 0.34654624687241276]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.20497803747064, "lat": 38.95326325476283 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20197"],
        "coty_name": ["Wabaunsee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wabaunsee County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "00485059"
      },
      "bbox": [
        0.07688165770057565, 0.03788139832970695, 0.5055132135146906,
        0.5159777705312548
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.193636826580304, -0.5702252697041433],
            [10.201165332644555, -0.5256249902570282],
            [10.220452257317612, -0.431979734084017],
            [10.238797366635463, -0.42183323385357335],
            [10.242040885085002, -0.42833452511559694],
            [10.242873137327168, -0.43756994483744704],
            [10.240652494710588, -0.44142066672357383],
            [10.241812027920876, -0.44554428695585047],
            [10.244628545815647, -0.44855635861508475],
            [10.253211479129037, -0.4422037477165559],
            [10.256669945637757, -0.4432856799130113],
            [10.260703234984875, -0.43604453346473404],
            [10.267198340607374, -0.43333534144073055],
            [10.270956920575795, -0.433483430429788],
            [10.276417298205253, -0.4257501988581132],
            [10.276023783039347, -0.4213519628980681],
            [10.278548501088007, -0.41828354448274757],
            [10.278500059277496, -0.4116798834547711],
            [10.283288632512177, -0.41104452439973493],
            [10.286783795540197, -0.4041214032056703],
            [10.285197383366624, -0.4027839675266041],
            [10.284627140354583, -0.3967293758830594],
            [10.289242558780082, -0.39304008113083444],
            [10.28625891576322, -0.3873920808148989],
            [10.289142705060526, -0.3802677433291028],
            [10.288193384640815, -0.37756004677819627],
            [10.291767912147764, -0.37468632221252407],
            [10.294096150173681, -0.36910455705464573],
            [10.300081023197771, -0.3707747618914894],
            [10.301087468779011, -0.36757125639501215],
            [10.305347343193478, -0.3626107384062949],
            [10.31643699722277, -0.35661839248701405],
            [10.322432410737733, -0.3640199772341702],
            [10.328286555747058, -0.3607949353879136],
            [10.331453363939886, -0.3620119260057383],
            [10.331636307728695, -0.365823177666586],
            [10.344526511280502, -0.369897062476503],
            [10.346749109017358, -0.368047933288979],
            [10.35515198257738, -0.37382712896648745],
            [10.364579714603638, -0.3760743971837624],
            [10.364737554945503, -0.3707766831686342],
            [10.368170697644358, -0.36993107976197254],
            [10.373351241783743, -0.3664157258391037],
            [10.380041472715993, -0.3683620675907704],
            [10.388684049529758, -0.368697451789615],
            [10.391343863026057, -0.36451289935218495],
            [10.393949570629744, -0.3677764550708375],
            [10.398110269566466, -0.3698760222919181],
            [10.401036509603191, -0.368372628601624],
            [10.403857909022468, -0.3709017944303509],
            [10.407001496022518, -0.3673422754286832],
            [10.41229369092703, -0.3641777790915053],
            [10.416380209691615, -0.36934215181219654],
            [10.423498201330947, -0.3719149275561672],
            [10.428929385308978, -0.37246390962619247],
            [10.431065674817235, -0.3751172663990685],
            [10.437887571175596, -0.37302319303549347],
            [10.44194123778183, -0.3789041756759088],
            [10.446692804650624, -0.3839977589604638],
            [10.455923229304535, -0.3899862136899776],
            [10.461514838115004, -0.388414228037707],
            [10.465815767810094, -0.3928178522249273],
            [10.469771125312198, -0.3927925875890408],
            [10.472867641054915, -0.38894091304663697],
            [10.47607166724475, -0.3940317622881448],
            [10.480946178636096, -0.3958633289900025],
            [10.482031789443981, -0.392129059058712],
            [10.484955014139034, -0.3912025506623027],
            [10.496083280276864, -0.3985238842413118],
            [10.5019840426796, -0.3994953204428573],
            [10.50597489297836, -0.40319422414822637],
            [10.509191020484257, -0.4001816683360784],
            [10.51129123525832, -0.40589842755351974],
            [10.518695327806133, -0.4117769707269798],
            [10.523831616342166, -0.41859153932366805],
            [10.526340345145185, -0.42353089756756945],
            [10.533045191123202, -0.42169002241127207],
            [10.536395066085115, -0.4152959573970421],
            [10.540976678122696, -0.41658404627788825],
            [10.544647618829948, -0.40963712227296656],
            [10.548961277499467, -0.4056290474690599],
            [10.555654294528091, -0.404519229764371],
            [10.557210054797261, -0.4002279228247173],
            [10.556509240940287, -0.3950535412220967],
            [10.562397741637703, -0.3948917066614556],
            [10.565273135307358, -0.39900941575483145],
            [10.566298283377392, -0.40375519968433304],
            [10.571115815957516, -0.4029636364358227],
            [10.573909938237442, -0.40796874048098397],
            [10.574416247432445, -0.4139412629246345],
            [10.578905090771068, -0.4155435403032878],
            [10.581300993131292, -0.4112119845756288],
            [10.585036527312706, -0.42059075353942366],
            [10.587647825851557, -0.42333853455030873],
            [10.585597706881975, -0.42659451035973434],
            [10.588003089077526, -0.42871107643614964],
            [10.590836551596004, -0.42624152690859657],
            [10.595796613119079, -0.43046809874000647],
            [10.599300346144721, -0.4291497616670143],
            [10.603702562815748, -0.43562034230861696],
            [10.611791014776234, -0.42901720937519444],
            [10.617658044966763, -0.4351452824352778],
            [10.619332551795816, -0.4326432124249767],
            [10.62380969055575, -0.4357195860043676],
            [10.627277551648291, -0.44010061492583313],
            [10.625792978605759, -0.4468821829524229],
            [10.62208843155267, -0.4497541211387956],
            [10.627104658319194, -0.457447042367422],
            [10.623510062363994, -0.46236277184781],
            [10.625023723947248, -0.46488839891619727],
            [10.629817863324131, -0.46749604970846254],
            [10.632425283725008, -0.4664188566141924],
            [10.638344927829266, -0.47046332263069096],
            [10.637752213023296, -0.4767074948518697],
            [10.6439060923019, -0.4871440191221687],
            [10.659628687875987, -0.4930212823493338],
            [10.667038277479291, -0.4914937704991756],
            [10.669675446000426, -0.4938841129193567],
            [10.674097692860098, -0.49325942731500827],
            [10.676512257707891, -0.4968719146231543],
            [10.682296430405751, -0.4980963747239427],
            [10.67972697739539, -0.5043238065841524],
            [10.68504552792831, -0.5071210922799357],
            [10.67917054357448, -0.5111130411343863],
            [10.672108493408698, -0.5113581135963292],
            [10.666484015047159, -0.5151420925538819],
            [10.66234165916886, -0.513756209718573],
            [10.65593036562537, -0.5077187792371471],
            [10.652736646402577, -0.5125927021157801],
            [10.641312320969243, -0.5128413329187406],
            [10.63521339787128, -0.5114581970108805],
            [10.633439500184968, -0.5087533766907868],
            [10.628994895461304, -0.5124047271762937],
            [10.6251736184568, -0.5113315643609582],
            [10.620232419863179, -0.5128133131702478],
            [10.616604144543295, -0.5056294559464447],
            [10.613820121114717, -0.5047263018747699],
            [10.609674542875165, -0.50046295052074],
            [10.602889909113305, -0.49585495989021966],
            [10.599158156364814, -0.5013473092669493],
            [10.59103864906947, -0.49736459774784014],
            [10.587750564057776, -0.5065093849052382],
            [10.5824544577606, -0.505163126673773],
            [10.580014540720363, -0.506370293177975],
            [10.576892059177425, -0.5028123704008273],
            [10.572581338109833, -0.5032365490712699],
            [10.572733745459345, -0.5080984649419102],
            [10.569253286784384, -0.507621140217261],
            [10.570591251694466, -0.5178896374010376],
            [10.573496554009736, -0.5234668802477014],
            [10.573194754530265, -0.5276529605902046],
            [10.54641265030659, -0.573008993337659],
            [10.561604608248455, -0.6241424476816367],
            [10.554658028259595, -0.6216210935619289],
            [10.552143771610874, -0.6249146684489488],
            [10.548121961227533, -0.6267237686810283],
            [10.544762220813295, -0.6240586798332095],
            [10.531458895888349, -0.6240905076833458],
            [10.52902202505616, -0.6227076526637806],
            [10.526067084393084, -0.6256799828250338],
            [10.514966500586294, -0.6259639939188755],
            [10.51315379121709, -0.6220463649703399],
            [10.508606930449515, -0.6247498365432195],
            [10.501527889663013, -0.6224353822783829],
            [10.499874450201881, -0.6155399642636161],
            [10.495324676407732, -0.612167048037476],
            [10.497394902492266, -0.6069274074883141],
            [10.491806788998984, -0.6014553534402874],
            [10.48906199938313, -0.6006928554937047],
            [10.488098181566016, -0.5962869761983964],
            [10.485924525645288, -0.5951230587779904],
            [10.44906529051557, -0.645703966317896],
            [10.443510982236788, -0.6468484631733796],
            [10.439890938270569, -0.6526378268958777],
            [10.429655125618217, -0.6578710464787316],
            [10.425249368285339, -0.6618670777498427],
            [10.425163549169884, -0.6673250664941182],
            [10.420145100807513, -0.6710871746348375],
            [10.413348531083422, -0.6686336476567807],
            [10.410838818410861, -0.6713910231904425],
            [10.406747735633846, -0.6696771807199482],
            [10.402935728882907, -0.671310003136585],
            [10.397342010594059, -0.6792183809701937],
            [10.398161950964614, -0.6806559765890254],
            [10.39342352485459, -0.6907210128719301],
            [10.388047342293829, -0.6923952445057897],
            [10.386262763696894, -0.6956463573737444],
            [10.38286745546846, -0.6944930681713606],
            [10.377741116929112, -0.6967493829040161],
            [10.377937548224741, -0.700927236503434],
            [10.379926788636439, -0.7035920526504945],
            [10.378149456243623, -0.7085125361386355],
            [10.373516531332825, -0.7080141762371593],
            [10.370100627516864, -0.7178696743588515],
            [10.36539005767632, -0.7177325532251418],
            [10.363290198061934, -0.719919714145862],
            [10.351303068445754, -0.7197795704338916],
            [10.347158571242174, -0.7141905981388634],
            [10.343322868211038, -0.7123821773947611],
            [10.342931176656881, -0.708028833255171],
            [10.340156423686029, -0.7058650687337127],
            [10.338030454395147, -0.709413790001058],
            [10.332263028925851, -0.7063096566906185],
            [10.333064868115141, -0.7037420244262855],
            [10.327921604019862, -0.7012777733174121],
            [10.327735163472441, -0.6985808838604881],
            [10.3200268023885, -0.6933791281696339],
            [10.315820234145596, -0.692356253810908],
            [10.313511566916803, -0.6863273918646424],
            [10.305968163471983, -0.6866557654717287],
            [10.301845454635394, -0.6916437748941887],
            [10.2904388761718, -0.6894751972596992],
            [10.287962632330135, -0.694110667420431],
            [10.285019496862372, -0.6950800461486839],
            [10.286341665338435, -0.6990381013770838],
            [10.284064723357035, -0.7028993565491181],
            [10.285198595888025, -0.7081697579181715],
            [10.281317959262484, -0.7093373890444877],
            [10.280640252486494, -0.7143973887626858],
            [10.276197520989223, -0.7161687026922546],
            [10.27395030617785, -0.7203596082281336],
            [10.273994646834392, -0.726849643732043],
            [10.26752252790665, -0.7293347155143673],
            [10.264327186324186, -0.7286049876080993],
            [10.257766345966736, -0.7350280239040707],
            [10.252604404766249, -0.7378367168365287],
            [10.249607478410253, -0.7423087962909433],
            [10.240884708180056, -0.7390050400424346],
            [10.244011207852498, -0.7361345460580704],
            [10.243870296449346, -0.7268915417249376],
            [10.246472513172714, -0.724030888596725],
            [10.247257880556633, -0.7189379870740148],
            [10.243889465260704, -0.7165763568817373],
            [10.241465303199318, -0.7118781000341469],
            [10.239118287662713, -0.7112627058703443],
            [10.239493803550292, -0.7045353412734032],
            [10.234995750354054, -0.7016430023557505],
            [10.23543396341397, -0.6939633089791359],
            [10.237016788911333, -0.6882979191682593],
            [10.231778892920039, -0.6793801682051862],
            [10.235041575996355, -0.6736207200895744],
            [10.237060014602708, -0.6740156354638152],
            [10.23642079897574, -0.6613203408705414],
            [10.239625254147812, -0.6594607377018469],
            [10.240344255687434, -0.654554667854083],
            [10.235239106679284, -0.6548734680938901],
            [10.231561690369716, -0.6507181191511605],
            [10.232225901795626, -0.6472778140929001],
            [10.224085673773732, -0.6407802168018647],
            [10.224758511965778, -0.6373021903517111],
            [10.221757074913361, -0.635632091024871],
            [10.224572816383429, -0.6278988261195583],
            [10.223974296177099, -0.6241085581224469],
            [10.220032813674258, -0.6155329210808032],
            [10.21827272354685, -0.6069072081543747],
            [10.213263100124644, -0.6040225740840017],
            [10.20972487844957, -0.6042499164554535],
            [10.205191317165367, -0.5984413686554665],
            [10.203225907284486, -0.5881518940519166],
            [10.19415953376921, -0.580158593174342],
            [10.196452186063826, -0.5755360433890605],
            [10.193636826580304, -0.5702252697041433]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.32418974931501, "lat": 37.52159330147969 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21025"],
        "coty_name": ["Breathitt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Breathitt County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00516859"
      },
      "bbox": [
        10.193636826580304, -0.7423087962909433, 10.68504552792831,
        -0.35661839248701405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.759354956370121, -0.2730378187638759],
            [9.761853657924215, -0.27451614366896565],
            [9.760676098589693, -0.2815725020004716],
            [9.764237964942243, -0.2884475331288493],
            [9.763892559464011, -0.2919781124963251],
            [9.76634898530908, -0.30156043539258526],
            [9.769535779965661, -0.3035167320466342],
            [9.773145975085711, -0.3018357272507083],
            [9.77267683877973, -0.294514699232002],
            [9.777749511673038, -0.29112815099192474],
            [9.779349493161607, -0.28846697432823093],
            [9.77878548755745, -0.2805888987609686],
            [9.782695688852314, -0.28176614707188263],
            [9.785295842979728, -0.28513128486657496],
            [9.789708515171522, -0.2808602274193148],
            [9.79344154451883, -0.28842302555202237],
            [9.803633982145422, -0.2835662250423465],
            [9.808266795476207, -0.27829599453136744],
            [9.808267475684762, -0.2853743138591441],
            [9.811028354479685, -0.28711007979994374],
            [9.82005520936214, -0.28520092094174204],
            [9.822115659356152, -0.2808494966144223],
            [9.827593085447463, -0.2684103399539245],
            [9.831106744744282, -0.2676637073046294],
            [9.834289851154171, -0.27280697155515554],
            [9.838090856447057, -0.272638348595543],
            [9.838058790435142, -0.2685981308972666],
            [9.845808323419154, -0.269546501155454],
            [9.847837973564118, -0.26790376806652605],
            [9.851793709032112, -0.26989826316310156],
            [9.851125236012146, -0.2752727328561096],
            [9.853430750491935, -0.283875198307304],
            [9.853541139942418, -0.28806127145057076],
            [9.856421456773344, -0.2928464256698552],
            [9.855093485686421, -0.29577524330615373],
            [9.854821262140105, -0.30240122250613183],
            [9.857262451137897, -0.30627421965231816],
            [9.855222456990086, -0.3087673778747334],
            [9.85692136302002, -0.31455297991186515],
            [9.901151221364684, -0.34291440482583424],
            [9.903949566094775, -0.34399906792876284],
            [9.90667564719182, -0.34997741846698066],
            [9.914503014076812, -0.3478811880647189],
            [9.918771286376053, -0.34842181113727444],
            [9.921936988788726, -0.3506438229250155],
            [9.926216316110743, -0.34879322469915486],
            [9.930152325257607, -0.3541078260836574],
            [9.932423819886322, -0.3526711394115285],
            [9.938408108779297, -0.3527075149228797],
            [9.94289243988897, -0.34580326275198187],
            [9.94969640982319, -0.34482523222367],
            [9.95511292985749, -0.3400746919684653],
            [9.964579548660653, -0.33628780414021714],
            [9.968356893816715, -0.3386084223061973],
            [9.966434643563279, -0.3450004528694017],
            [9.972985372782604, -0.3545062164418697],
            [9.976375405761603, -0.3515769668935098],
            [9.981339827181126, -0.34964901451957814],
            [9.981513439464084, -0.34751800667253524],
            [9.986187597996029, -0.34215615074039696],
            [9.990754295062576, -0.3400944826817234],
            [9.996891353565328, -0.3420999724146295],
            [10.000613758738162, -0.3364934130306906],
            [10.00450003519819, -0.3359564547409949],
            [10.010893253273501, -0.34843468777896547],
            [10.01536753155909, -0.35432151606062295],
            [10.027974653738308, -0.35686078815108513],
            [10.032500245280794, -0.36153252163676053],
            [10.036625910652369, -0.36039991579020375],
            [10.041200077923326, -0.3618298922023634],
            [10.044380293438707, -0.35898050576766094],
            [10.050258283482588, -0.36316928532772774],
            [10.052913621349113, -0.3618254814651089],
            [10.05497119289164, -0.37431425079819886],
            [10.046442314046631, -0.3743321250243929],
            [10.041160843067376, -0.3752078131710732],
            [10.033812318268978, -0.3786624750310994],
            [10.027032648669383, -0.38842288499361044],
            [10.027072843080845, -0.3921861419383147],
            [10.019963018701855, -0.3953648650168078],
            [10.020017922077757, -0.39897648953503295],
            [10.016416878109315, -0.39890471036840763],
            [10.013087267132628, -0.40887680738177873],
            [10.008133115289844, -0.410890615897832],
            [10.006098480986527, -0.41585237763032046],
            [9.997694347464337, -0.42135015542532994],
            [9.997864846363633, -0.42588646893374693],
            [9.992829008225813, -0.432106417220754],
            [9.98553104917254, -0.43353691196742666],
            [9.982633759852849, -0.4380906382807645],
            [9.983697249510467, -0.4407748840738035],
            [9.992526475459332, -0.4554161475621533],
            [9.996816276420255, -0.4554708403353555],
            [9.998996099476411, -0.4577635560359113],
            [9.998526403242666, -0.4634697722505325],
            [9.99210185773251, -0.467284318312528],
            [9.979568713837882, -0.4656844205769119],
            [9.971621880941385, -0.47210383761075825],
            [9.960595287465871, -0.4833495226087142],
            [9.955951386477235, -0.49057949211155916],
            [9.960718505134873, -0.4958427068335501],
            [9.96310800079693, -0.49534442939252127],
            [9.9346715982736, -0.5665348713411729],
            [9.917056122687104, -0.5502025393935392],
            [9.904100840368192, -0.5395787046775148],
            [9.883274637745183, -0.5338367970693385],
            [9.862285585721759, -0.5446517145759692],
            [9.82342388338804, -0.5595969145965856],
            [9.78777731059918, -0.5613944749114879],
            [9.765555325244163, -0.5240710782437406],
            [9.749698398219953, -0.4886390863919643],
            [9.749516181375173, -0.4859609682322675],
            [9.755254823279241, -0.48310290775850795],
            [9.759389264968, -0.47903445303032643],
            [9.759247289558678, -0.47346190969398516],
            [9.771274974082592, -0.4663347840106134],
            [9.775894873365472, -0.46043923674712184],
            [9.769687812062042, -0.4572241767783841],
            [9.768768129343597, -0.4525422545559082],
            [9.765660395910222, -0.45018244192297635],
            [9.767586832983252, -0.4448094542543825],
            [9.77066838344599, -0.44112288222235374],
            [9.770428680534629, -0.4325224105192654],
            [9.767529149407768, -0.4209247271242021],
            [9.765189934473586, -0.41692124371331035],
            [9.767221933398222, -0.4136263166013941],
            [9.76190597241084, -0.41029070758083863],
            [9.762980474585476, -0.40607624595116676],
            [9.766798339163508, -0.4030042509913821],
            [9.761551493913997, -0.39283891290761463],
            [9.769253306556456, -0.3882170658051541],
            [9.77202363663138, -0.38402678802181545],
            [9.771916277334167, -0.37729643269087426],
            [9.766955355346157, -0.37421488198595354],
            [9.764476977706302, -0.370935366399006],
            [9.764910571424924, -0.36570225546945956],
            [9.768969601767902, -0.3591613391382517],
            [9.76367172106204, -0.35587588752928284],
            [9.757199476525196, -0.35589105797241777],
            [9.748267729524184, -0.35303557947284686],
            [9.74623375326113, -0.34996026923756507],
            [9.74705523715377, -0.34478239065046545],
            [9.754654756288655, -0.34292842547533553],
            [9.768220422481317, -0.32849278594424286],
            [9.770907676801881, -0.3244551568727051],
            [9.77032382677207, -0.32078325856530204],
            [9.76764457640138, -0.3169349262904271],
            [9.760105566503746, -0.31658148168067907],
            [9.754493182360358, -0.313003590383005],
            [9.749477756646247, -0.31240964557525164],
            [9.73965155406623, -0.3240524104245237],
            [9.73703958946334, -0.32532419178892447],
            [9.732875100423337, -0.32249297546951716],
            [9.732902225281597, -0.3126866123974366],
            [9.738028778049813, -0.3074511841397052],
            [9.741660790545456, -0.2993774800262319],
            [9.742662393282032, -0.2896945930607862],
            [9.744433683533796, -0.2878982263811993],
            [9.751963567003036, -0.2915598127359048],
            [9.753894449889401, -0.29117513686496455],
            [9.757218961561621, -0.28617414381606315],
            [9.7590016318944, -0.2809255828592288],
            [9.759354956370121, -0.2730378187638759]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.96423839127041, "lat": 37.69239183475387 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21065"],
        "coty_name": ["Estill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Estill County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00516879"
      },
      "bbox": [
        9.732875100423337, -0.5665348713411729, 10.05497119289164,
        -0.2676637073046294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.901415217747891, 0.37986297658015816],
            [8.906451294596662, 0.3773840670297205],
            [8.90924811714713, 0.3840285696189856],
            [8.905246234175367, 0.3878149390868183],
            [8.909739417327359, 0.39186328457999153],
            [8.911101326688938, 0.3953994309888618],
            [8.91733116364975, 0.3973580216233944],
            [8.919015293619461, 0.3997952356184593],
            [8.926137309556525, 0.3966433410976925],
            [8.935667348628503, 0.40004911758620415],
            [8.938056010299892, 0.4017533108019062],
            [8.93982889057011, 0.40801835370886275],
            [8.945834434414607, 0.41097817256889413],
            [8.945681941886171, 0.4138676900574799],
            [8.942452613246852, 0.4163572957005925],
            [8.942511171737658, 0.4205022881422873],
            [8.94609932166477, 0.4207562641382206],
            [8.949801143474927, 0.4233097705644755],
            [8.960798783587457, 0.4212155489486948],
            [8.965602665542102, 0.42421427535679684],
            [8.967882417116686, 0.4284940280317785],
            [8.973619785112412, 0.4286754114608415],
            [8.97693813999448, 0.4383362229103031],
            [8.97584177765256, 0.44124791651518147],
            [8.982980170003136, 0.4441369341332647],
            [8.98685721949372, 0.447131846550481],
            [8.98991375589464, 0.44320180157431543],
            [8.99398188489876, 0.4450666213365135],
            [9.00087553122787, 0.44630030957828304],
            [8.999876829934584, 0.449840232963418],
            [9.001428751405616, 0.4578555805544332],
            [9.002576220576966, 0.46248924213288395],
            [9.007097028022537, 0.46999310882402096],
            [9.010629037693185, 0.46737304936461627],
            [9.017084301823406, 0.46643754145720073],
            [9.022818712137017, 0.46771461276076975],
            [9.022854249757323, 0.47700363711297894],
            [9.029859287973887, 0.47803288279108075],
            [9.03225189517601, 0.47621234879844715],
            [9.035178801416048, 0.4780759189612947],
            [9.034122367268818, 0.48732226026630726],
            [9.039004679482145, 0.4854904330225319],
            [9.046154725529847, 0.49123027969268473],
            [9.046301577828805, 0.49998575607573253],
            [9.050022545882783, 0.5026958069512905],
            [9.055261516530758, 0.5032586753099003],
            [9.059169903637741, 0.5006425566977413],
            [9.066297814973117, 0.5007384267578061],
            [9.067582760672027, 0.5074100057084665],
            [9.075478863960896, 0.5167294958770088],
            [9.081234810274498, 0.511072081361778],
            [9.084443574699364, 0.5095102794198101],
            [9.090892666048253, 0.5092233915164345],
            [9.09187780422064, 0.5118959668072705],
            [9.08695807132881, 0.513934349019786],
            [9.088772172659825, 0.5188033967603222],
            [9.092391820124433, 0.5195893808563692],
            [9.099622654985769, 0.5248791378290169],
            [9.102212852281852, 0.5332557898000463],
            [9.10667046341148, 0.5329918897448672],
            [9.10873433133545, 0.5297917410252022],
            [9.129652670101548, 0.42869786069525756],
            [9.159950273057047, 0.40902032333399835],
            [9.20860209227121, 0.3782183522244254],
            [9.213625834417236, 0.3770308361662111],
            [9.214255372559007, 0.3742353386145152],
            [9.210741406644289, 0.3699096003026857],
            [9.214544258608912, 0.3651447538422208],
            [9.220256640347376, 0.36520444175911737],
            [9.218741876505552, 0.3540194089766283],
            [9.219623339535923, 0.3467244899543488],
            [9.222142676983323, 0.34735777963070374],
            [9.222584938037949, 0.3514684895130966],
            [9.229527564927459, 0.3533877551504845],
            [9.235010123103832, 0.34458322532032426],
            [9.23986464989728, 0.3423791739656763],
            [9.237559289197339, 0.33652730620221444],
            [9.24160133828396, 0.33494585473977495],
            [9.24974382825798, 0.32532535809907676],
            [9.252686421813646, 0.31772679383704344],
            [9.25706826043453, 0.3145646786860569],
            [9.259197713021388, 0.30845099598222236],
            [9.263903618775373, 0.30550307830443996],
            [9.276195364510619, 0.305821292962287],
            [9.279613169015697, 0.30673451810886443],
            [9.296150177179893, 0.3006037296745849],
            [9.268063165546133, 0.25465652792198773],
            [9.249891478087354, 0.23760030086687178],
            [9.211848378356686, 0.1857514435241584],
            [9.187335058870087, 0.16488328124174143],
            [9.183341888729348, 0.16142447942670857],
            [9.14823573539071, 0.1462624059408161],
            [9.139573231574069, 0.15353219532578888],
            [9.135133538775131, 0.1555276236904254],
            [9.125002260097876, 0.15462777973850494],
            [9.120555668890251, 0.1530186027453051],
            [9.116224770079157, 0.15686125454258537],
            [9.110288189160837, 0.1596636148813633],
            [9.103218892766495, 0.15724080868959436],
            [9.09506297246048, 0.15822609332935522],
            [9.086651614375896, 0.15737846652754317],
            [9.088670724613355, 0.1629448681238408],
            [9.086892638657742, 0.1694981243610258],
            [9.080601604533532, 0.17304277963124765],
            [9.06604426415844, 0.17382459732718444],
            [9.06231352686169, 0.1771069494694844],
            [9.061882816103447, 0.18782448263223686],
            [9.063451318373865, 0.19312470143618343],
            [9.067437693629644, 0.20112260736465987],
            [9.0683346298646, 0.20754285758213198],
            [9.072114617848834, 0.21609340913910724],
            [9.070179660812437, 0.21989430640654642],
            [9.059084219392927, 0.22338206624947865],
            [9.047658841102775, 0.22495179979740274],
            [9.042518586096161, 0.22748392529977418],
            [9.0360861071749, 0.22711395721884142],
            [9.032853725386786, 0.2319227080782532],
            [9.035777535626746, 0.23888957186114318],
            [9.045402040886906, 0.24671696811102645],
            [9.044926313431787, 0.2522275817643394],
            [9.040067209808647, 0.25873935334522125],
            [9.033765830227361, 0.26076058702906085],
            [9.02917867809948, 0.2576362616963828],
            [9.024402385198053, 0.250070742434965],
            [9.023448438463447, 0.24519413825999817],
            [9.02613612934208, 0.22660159783741962],
            [9.025280661079117, 0.2224146124987933],
            [9.017316063445069, 0.2198400504438542],
            [9.011328142965867, 0.2229198059409808],
            [9.00572437773248, 0.2295470727340578],
            [9.009572092576452, 0.23833340677399695],
            [9.010138951237593, 0.24545805543687912],
            [9.012185563713912, 0.25056566317524775],
            [9.010987092717764, 0.2585760857237112],
            [9.006360061483596, 0.26681655948573946],
            [8.99659467585036, 0.2729268998126341],
            [8.988178325760607, 0.2760399507636635],
            [8.980195231988443, 0.2774293384987197],
            [8.977897764628413, 0.2794615113048779],
            [8.976636471590405, 0.2853593421155142],
            [8.979044640121407, 0.29298128665786005],
            [8.98611154197785, 0.30445187316673344],
            [8.984254312661308, 0.30763093551050347],
            [8.979429377391822, 0.30917951930785587],
            [8.9713304746617, 0.3078813504377883],
            [8.962906293545785, 0.3027017033883315],
            [8.956130791137717, 0.2925911292131363],
            [8.950969232621224, 0.2915815352998455],
            [8.946906518422736, 0.2941884336225025],
            [8.945789452077193, 0.2975049466631425],
            [8.947849407796612, 0.310636431578474],
            [8.954832908492731, 0.32562136131941377],
            [8.955540845486999, 0.3371589302467129],
            [8.961890854686464, 0.3414128842989712],
            [8.961721948023836, 0.34331554410784043],
            [8.955858276268104, 0.3498649028230794],
            [8.937302716534663, 0.3565728410665012],
            [8.931694269716816, 0.3595955729378479],
            [8.9286442799317, 0.3596570533916997],
            [8.921195805806283, 0.3537053958524563],
            [8.91670054973491, 0.34900778340916216],
            [8.910860306638979, 0.35068995830301386],
            [8.902558950265306, 0.3608654804820966],
            [8.901415217747891, 0.37986297658015816]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.82809516539376, "lat": 38.51963017750696 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21187"],
        "coty_name": ["Owen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Owen County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "00516940"
      },
      "bbox": [
        8.901415217747891, 0.1462624059408161, 9.296150177179893,
        0.5332557898000463
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.065938961998592, -0.3728448950868645],
            [10.111411339844286, -0.2560030734010506],
            [10.116084920591437, -0.2567101280420225],
            [10.118245883408024, -0.24546157796348955],
            [10.120842735386166, -0.2444094753296622],
            [10.13468068578619, -0.24809578331573073],
            [10.13726852422975, -0.25598547103215735],
            [10.143921787807212, -0.2588998114662583],
            [10.146099461092664, -0.25732645020384687],
            [10.146763346111852, -0.2512332058754851],
            [10.149427732455676, -0.2517030365740769],
            [10.149833768083548, -0.25583774062673514],
            [10.155221048428189, -0.25601269829420614],
            [10.160189819931126, -0.25337113032909897],
            [10.164396805296445, -0.2543973311509484],
            [10.173678659725686, -0.2516535483476585],
            [10.177044684648925, -0.24790080314752472],
            [10.184614272779228, -0.24619700145637374],
            [10.19166254996715, -0.23715615087641675],
            [10.19115909654894, -0.23286411439764362],
            [10.195971943307843, -0.22186349654373055],
            [10.19637963605621, -0.21798177808203534],
            [10.208921060959867, -0.21111783312934176],
            [10.212025223971436, -0.20555087086828716],
            [10.215756473142644, -0.2092700585366216],
            [10.221426185791394, -0.21189506286311532],
            [10.222798945964701, -0.2224558021262463],
            [10.229923425927382, -0.22291755417168657],
            [10.238070032670178, -0.2208064091526154],
            [10.24539570954448, -0.22071333453723635],
            [10.248538604758867, -0.22680846278507993],
            [10.253304894969249, -0.22594312280973988],
            [10.25820576552893, -0.22810854582538104],
            [10.25617614566033, -0.23255290773447929],
            [10.258070598307903, -0.23565774784505686],
            [10.262608428846029, -0.23828583883431137],
            [10.265798522862388, -0.24200979381832305],
            [10.270264842508398, -0.24263606768303161],
            [10.274207436669132, -0.24122406083471418],
            [10.274936340561517, -0.24444094209619632],
            [10.279228797418615, -0.24196947794799226],
            [10.285022499064581, -0.2436884669994322],
            [10.302667712776833, -0.2426359685710828],
            [10.304429225509896, -0.24754154073567528],
            [10.305280600304561, -0.25408964828614566],
            [10.307080665059605, -0.2564206932497676],
            [10.310540186767703, -0.255252637012828],
            [10.321698230796374, -0.25478211980931936],
            [10.325700405702666, -0.2561427956177978],
            [10.332316331553251, -0.2610208647214684],
            [10.334192312179148, -0.2608206522939367],
            [10.336705581344223, -0.2665583618489826],
            [10.342586266862542, -0.2677165920285607],
            [10.346555123527976, -0.2722595500299206],
            [10.348780511581444, -0.2669943413813563],
            [10.352991355106099, -0.27061815696758384],
            [10.353101955217133, -0.27655343534029625],
            [10.349967602609635, -0.2872467691870318],
            [10.350646697825388, -0.29240073917158815],
            [10.35616627603807, -0.29348739527842393],
            [10.35733139715978, -0.29702038019389326],
            [10.364382763568118, -0.29686685148749536],
            [10.36916950783764, -0.2987794832473341],
            [10.371821071763392, -0.30353912770118435],
            [10.384572378316607, -0.3025037924787019],
            [10.38933334893595, -0.30375235150108243],
            [10.389397261128835, -0.31129181970807007],
            [10.393840829561876, -0.308833273300621],
            [10.396356431748256, -0.313754257871463],
            [10.395778027641779, -0.3198773563126456],
            [10.396995317019364, -0.32653001927526726],
            [10.40383979397596, -0.32969518596827385],
            [10.409875776108613, -0.3286342286401507],
            [10.412650293008845, -0.3308034660213724],
            [10.414475899927174, -0.3358476531745054],
            [10.418843194697121, -0.3353635770722613],
            [10.424277073303358, -0.34119446169081147],
            [10.42889101939777, -0.3423700663293855],
            [10.424770774921504, -0.3496035068975297],
            [10.424054531286126, -0.35341322789758267],
            [10.419990881393378, -0.35752266879679817],
            [10.419980683764399, -0.3628001224847188],
            [10.422855700900811, -0.36743367810777394],
            [10.428159306404634, -0.3698818878295399],
            [10.428929385308978, -0.37246390962619247],
            [10.423498201330947, -0.3719149275561672],
            [10.416380209691615, -0.36934215181219654],
            [10.41229369092703, -0.3641777790915053],
            [10.407001496022518, -0.3673422754286832],
            [10.403857909022468, -0.3709017944303509],
            [10.401036509603191, -0.368372628601624],
            [10.398110269566466, -0.3698760222919181],
            [10.393949570629744, -0.3677764550708375],
            [10.391343863026057, -0.36451289935218495],
            [10.388684049529758, -0.368697451789615],
            [10.380041472715993, -0.3683620675907704],
            [10.373351241783743, -0.3664157258391037],
            [10.368170697644358, -0.36993107976197254],
            [10.364737554945503, -0.3707766831686342],
            [10.364579714603638, -0.3760743971837624],
            [10.35515198257738, -0.37382712896648745],
            [10.346749109017358, -0.368047933288979],
            [10.344526511280502, -0.369897062476503],
            [10.331636307728695, -0.365823177666586],
            [10.331453363939886, -0.3620119260057383],
            [10.328286555747058, -0.3607949353879136],
            [10.322432410737733, -0.3640199772341702],
            [10.31643699722277, -0.35661839248701405],
            [10.305347343193478, -0.3626107384062949],
            [10.301087468779011, -0.36757125639501215],
            [10.300081023197771, -0.3707747618914894],
            [10.294096150173681, -0.36910455705464573],
            [10.291767912147764, -0.37468632221252407],
            [10.288193384640815, -0.37756004677819627],
            [10.289142705060526, -0.3802677433291028],
            [10.28625891576322, -0.3873920808148989],
            [10.289242558780082, -0.39304008113083444],
            [10.284627140354583, -0.3967293758830594],
            [10.285197383366624, -0.4027839675266041],
            [10.286783795540197, -0.4041214032056703],
            [10.283288632512177, -0.41104452439973493],
            [10.278500059277496, -0.4116798834547711],
            [10.278548501088007, -0.41828354448274757],
            [10.276023783039347, -0.4213519628980681],
            [10.276417298205253, -0.4257501988581132],
            [10.270956920575795, -0.433483430429788],
            [10.267198340607374, -0.43333534144073055],
            [10.260703234984875, -0.43604453346473404],
            [10.256669945637757, -0.4432856799130113],
            [10.253211479129037, -0.4422037477165559],
            [10.244628545815647, -0.44855635861508475],
            [10.241812027920876, -0.44554428695585047],
            [10.240652494710588, -0.44142066672357383],
            [10.242873137327168, -0.43756994483744704],
            [10.242040885085002, -0.42833452511559694],
            [10.238797366635463, -0.42183323385357335],
            [10.220452257317612, -0.431979734084017],
            [10.143376261238204, -0.41318374013833387],
            [10.132746837196168, -0.40239051242084206],
            [10.08663980365884, -0.3815693720811305],
            [10.083046285216811, -0.37749277565194195],
            [10.077106733759893, -0.37735899595730293],
            [10.072684486937332, -0.3745629868222285],
            [10.065938961998592, -0.3728448950868645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.49312247621681, "lat": 37.7393637492715 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21237"],
        "coty_name": ["Wolfe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wolfe County"],
        "coty_fp_code": "237",
        "coty_gnis_code": "00516965"
      },
      "bbox": [
        10.065938961998592, -0.44855635861508475, 10.428929385308978,
        -0.20555087086828716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.6425897229869895, -7.710589608991484],
            [3.6978609293357527, -7.708306148443367],
            [3.7012861790460287, -7.710716358468803],
            [3.7040690511253005, -7.708516437687225],
            [3.7069077975830873, -7.699577733755948],
            [3.7002876777793965, -7.697509811899903],
            [3.7006515201875367, -7.687758414185197],
            [3.696219643848578, -7.682326627901573],
            [3.6783973006309543, -7.5618684326502],
            [3.6772441303217875, -7.557229697019854],
            [3.6756836358873177, -7.543726021707835],
            [3.6787163751955005, -7.538306179373827],
            [3.6831822535742886, -7.533316416276757],
            [3.6812132318200197, -7.527810417134524],
            [3.6752685604454842, -7.523803534847294],
            [3.6723932324092408, -7.431618265174301],
            [3.6690025327840736, -7.354709275197641],
            [3.6723555714123597, -7.3547795670459974],
            [3.67302417326384, -7.3512028339445115],
            [3.679824581528763, -7.343234034801289],
            [3.684568177387709, -7.344749239648995],
            [3.6876191787808166, -7.3481402700868514],
            [3.6916593075456823, -7.347235177412393],
            [3.694628544966533, -7.343473317473751],
            [3.6995571814753294, -7.345512309316643],
            [3.7019926688026246, -7.341092890161106],
            [3.707029354926705, -7.343653172584218],
            [3.7069360340287654, -7.346462278546026],
            [3.714034402972857, -7.347232490665695],
            [3.7156757846715744, -7.351117022783207],
            [3.7174649073509967, -7.363088540590988],
            [3.7241720681447448, -7.367669838814244],
            [3.729719835589557, -7.3702927554079025],
            [3.730134606210826, -7.373404995242097],
            [3.739020340207285, -7.370554168038693],
            [3.7430830607967245, -7.371370050882078],
            [3.74917876268658, -7.368085361252436],
            [3.7503055977459896, -7.3657059294984055],
            [3.7561288402477486, -7.366882512602287],
            [3.7607783772479415, -7.366489382093873],
            [3.7640898832305316, -7.360789708511661],
            [3.7698630835078477, -7.360630463867575],
            [3.771278809687457, -7.3560193677931185],
            [3.774131620955025, -7.352422739557342],
            [3.779769474936397, -7.349293489293725],
            [3.7821501565610522, -7.3501101452886575],
            [3.7857389445765453, -7.347310919912225],
            [3.7867998970288097, -7.338649881209241],
            [3.7896244067649714, -7.335183086198502],
            [3.793033725423498, -7.335959459776191],
            [3.7948388848962282, -7.339472363168189],
            [3.7976744022596103, -7.340290921563368],
            [3.7990409833470267, -7.34478203219653],
            [3.8087102158949167, -7.343212094857033],
            [3.8145747927632914, -7.338723945607395],
            [3.8220801267405258, -7.334400799477579],
            [3.829517161156987, -7.334107875371834],
            [3.8325324346445604, -7.3323472807115015],
            [3.834810178277695, -7.3267841018814694],
            [3.842488636971782, -7.325607151091256],
            [3.847014719406835, -7.328822901444627],
            [3.846343251108614, -7.332992610576108],
            [3.848796412554844, -7.335294893824533],
            [3.8482295291847963, -7.338995881657452],
            [3.8603404946770175, -7.3427113526687915],
            [3.8650942183915427, -7.345670362859869],
            [3.86606840767516, -7.350599188132395],
            [3.860819619545907, -7.357637555633305],
            [3.8618951505600863, -7.3617450538573035],
            [3.871290652178726, -7.368315432398753],
            [3.871547906001029, -7.3707593279145875],
            [3.863954638229418, -7.370607177207385],
            [3.861553195682382, -7.37500983487452],
            [3.858171587599357, -7.372592504435649],
            [3.859061970448065, -7.367578425270977],
            [3.854096644190787, -7.366247934244868],
            [3.8513492546548678, -7.369832920564325],
            [3.851854408750657, -7.373862423640739],
            [3.856098532580524, -7.379508544857312],
            [3.850571017077297, -7.381509495817648],
            [3.8493054278367924, -7.3860118008926],
            [3.852218456474233, -7.388226714503792],
            [3.8603046884734384, -7.386940988244239],
            [3.8585627911208755, -7.390027791784448],
            [3.8603452606049973, -7.392608204218663],
            [3.864473636611953, -7.392212024124448],
            [3.8677319006072737, -7.397705045244084],
            [3.8753973329910867, -7.39366131595612],
            [3.87678271020929, -7.394767796180842],
            [3.8728375301753926, -7.401562777531492],
            [3.8676354015510475, -7.400995147125781],
            [3.86606488464625, -7.404466231904366],
            [3.8677487400399344, -7.409873254544108],
            [3.871422218312676, -7.411993824897075],
            [3.872132745011264, -7.414870544928165],
            [3.880578645969078, -7.415323005380712],
            [3.88061424354949, -7.418480877131555],
            [3.8741041078800476, -7.42197235298476],
            [3.867037782752064, -7.424466561592572],
            [3.869711955584647, -7.4272183963768565],
            [3.877480808021085, -7.428464364228958],
            [3.8789251397702205, -7.431763299592242],
            [3.8756386641934646, -7.4379471394556385],
            [3.879425785080314, -7.442121962446671],
            [3.8855138702579364, -7.44341855393544],
            [3.8936680529478527, -7.4414021174421645],
            [3.8964871933583134, -7.438774838481941],
            [3.90122024202056, -7.431673665302698],
            [3.9024687707239134, -7.424112358078343],
            [3.9081824970297596, -7.420463000781139],
            [3.912463278727661, -7.421536134024161],
            [3.916292054689468, -7.426171944155629],
            [3.9170698397688835, -7.4417278332149905],
            [3.921842532969488, -7.444012565875199],
            [3.9263285071357226, -7.438263034972931],
            [3.9308781354369584, -7.434889765379011],
            [3.936258853431459, -7.434805379532856],
            [3.939081869211164, -7.430313847302782],
            [3.936750520348819, -7.427071557250321],
            [3.931922646187254, -7.429161336662755],
            [3.9258601770662795, -7.426995557370183],
            [3.923988578288866, -7.423246323035372],
            [3.9240973990663854, -7.418138101566829],
            [3.920876043340835, -7.409121004791971],
            [3.9160190155884265, -7.40025440662502],
            [3.91494946313288, -7.394042097731894],
            [3.9183652523253847, -7.388204540300934],
            [3.9210218321748305, -7.380743229632064],
            [3.924577814326728, -7.375828572663021],
            [3.930702533653958, -7.370612173585224],
            [3.9341670849108445, -7.369397797266061],
            [3.9458701043809286, -7.368014085514146],
            [3.9662504839972406, -7.373820795009937],
            [3.9799561179276743, -7.382566401720689],
            [3.9884797972468338, -7.3933636040740245],
            [3.9932861397481787, -7.398358631739436],
            [3.9994093666004287, -7.400061780980886],
            [4.007062249926947, -7.394368355225357],
            [4.010701958375656, -7.395548977749481],
            [4.018216660663132, -7.4051932214659635],
            [4.027293587996029, -7.409383302182757],
            [4.029525234936561, -7.414085009861162],
            [4.0286027492414265, -7.419558962486383],
            [4.031804012921884, -7.423771819862073],
            [4.0427264980638755, -7.4282188936282845],
            [4.049052933987045, -7.434083688886206],
            [4.060934561639071, -7.437473139060699],
            [4.06856059441548, -7.436366690972098],
            [4.077191782296535, -7.436557659739462],
            [4.0893596118294715, -7.444974106491771],
            [4.091661260796626, -7.4511226248740146],
            [4.095115996145629, -7.453932993181501],
            [4.102700247541591, -7.455073230313153],
            [4.109379218945837, -7.457730207370537],
            [4.115889537162755, -7.450183524808144],
            [4.1206263542553, -7.447891793513001],
            [4.124023501986844, -7.448576149208128],
            [4.129194939930169, -7.452144770883365],
            [4.13558311006892, -7.454209158972834],
            [4.141077549464186, -7.4588102057030445],
            [4.14365691945564, -7.463977505183562],
            [4.147844837984796, -7.467459647244185],
            [4.147541533845549, -7.4702230842772535],
            [4.143103881165034, -7.478629411299705],
            [4.144699625328785, -7.488076958506506],
            [4.143500429750135, -7.492588359414456],
            [4.140550007011884, -7.493799716908769],
            [4.129725839018474, -7.493277539632498],
            [4.125669326159932, -7.496596317962843],
            [4.12086728933257, -7.505110311825951],
            [4.116031468741393, -7.517260560289854],
            [4.1147415810683645, -7.522153330356192],
            [4.115568426570431, -7.533896098299776],
            [4.118151814505079, -7.539558258026744],
            [4.123031235244172, -7.540390306110505],
            [4.12673812514198, -7.54255597869515],
            [4.12902480631552, -7.547253257999641],
            [4.129118082988023, -7.552424106125981],
            [4.125424746434772, -7.559244914481314],
            [4.118948482050747, -7.563057913315744],
            [4.11635553544242, -7.570712752075846],
            [4.117835371941426, -7.574992895852442],
            [4.124699954316738, -7.577747904873808],
            [4.125095743823446, -7.582626815883483],
            [4.121028311410764, -7.597158646839489],
            [4.114728037836909, -7.612109495113693],
            [4.11251289182905, -7.616554807083011],
            [4.107034538013172, -7.623166717614746],
            [4.096892858256711, -7.631834339819109],
            [4.09341621109531, -7.638376843893672],
            [4.088727607576789, -7.643167446525539],
            [4.078995582126347, -7.648717940711333],
            [4.07360648958307, -7.655351448186433],
            [4.072454363461009, -7.664616799786646],
            [4.070685938866482, -7.669285940504055],
            [4.067537044155324, -7.672346038793411],
            [4.055407141876382, -7.675849116810035],
            [4.049473078978828, -7.681014531742683],
            [4.048008543541338, -7.684573027491083],
            [4.048302490313867, -7.690535922208072],
            [4.051123206571903, -7.701634249285899],
            [4.051788752527242, -7.708478813058211],
            [4.051663713216482, -7.718401018830872],
            [4.054862253390694, -7.733796766164695],
            [4.05395662906013, -7.745298902800456],
            [4.055173486200168, -7.759656695408856],
            [4.054535333623437, -7.774940249614045],
            [4.05579546893818, -7.782929220014772],
            [4.054016761924055, -7.794415421125937],
            [4.049324552542442, -7.796468432264074],
            [4.039300116364757, -7.797676686304333],
            [4.0389877563337055, -7.80420909382079],
            [4.045355321354897, -7.810313773436207],
            [4.010764572004205, -7.811749708186127],
            [3.917993347110172, -7.814389842022666],
            [3.8616332186662325, -7.816779703302033],
            [3.8012741172313405, -7.818757582082936],
            [3.705455724433055, -7.823945634986252],
            [3.6839100569113485, -7.825120934870934],
            [3.6817523535588172, -7.781577151650247],
            [3.643751884068669, -7.739505181661685],
            [3.6425897229869895, -7.710589608991484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.00143314614483, "lat": 31.076257450335 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22009"],
        "coty_name": ["Avoyelles"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Avoyelles Parish"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00558424"
      },
      "bbox": [
        3.6425897229869895, -7.825120934870934, 4.147844837984796,
        -7.325607151091256
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.584237070552856, -7.634715921784135],
            [4.6421556314462205, -7.632041850972545],
            [4.683182484446143, -7.629864179954288],
            [4.759947265914221, -7.625503557474687],
            [4.824363651366938, -7.621788581221069],
            [4.883171502475499, -7.6189018314463075],
            [4.873459599035319, -7.625790495985802],
            [4.869874764559857, -7.634263242786123],
            [4.8697986207675115, -7.64694809254376],
            [4.8679655404870426, -7.654573019697492],
            [4.86916483007362, -7.655694157503845],
            [4.861446964014355, -7.66516412306129],
            [4.861808210916512, -7.66924902769762],
            [4.856485570561196, -7.67179441064064],
            [4.854527961689692, -7.677567382665896],
            [4.858408589520403, -7.680674950942441],
            [4.856612743061683, -7.684033220319095],
            [4.8603143862514475, -7.690080612302885],
            [4.858338949451802, -7.692240056117243],
            [4.8628428483873085, -7.696329070469227],
            [4.861336195494277, -7.699967292568158],
            [4.863915538311383, -7.707798249268288],
            [4.861782300314457, -7.711388327860173],
            [4.864151673499422, -7.713494508085623],
            [4.863991555480931, -7.718807837419024],
            [4.868921868321049, -7.722813520977764],
            [4.8699428893662535, -7.728080084288547],
            [4.872613931009792, -7.731409702937051],
            [4.868628355149478, -7.733216313534052],
            [4.866747660262801, -7.736655201519443],
            [4.866644185775873, -7.741813706795133],
            [4.864653213825407, -7.745671309943002],
            [4.861369038073897, -7.74555299844789],
            [4.860152266032733, -7.749106170550149],
            [4.86705327209326, -7.7524724410012515],
            [4.863872243350031, -7.756724110271051],
            [4.867936807605111, -7.763138042460588],
            [4.874740555773661, -7.763089742699137],
            [4.874079363006124, -7.7696906425193175],
            [4.878561348133462, -7.770884312470322],
            [4.878281471493443, -7.7794475417088815],
            [4.872746470131116, -7.779953228914601],
            [4.873544928215286, -7.78382257210049],
            [4.872027724616508, -7.787578532970066],
            [4.8765836544135945, -7.789134430902117],
            [4.876579274102166, -7.792372219322325],
            [4.880172835428468, -7.7935448788440045],
            [4.881516135283105, -7.79726919541169],
            [4.884675150374099, -7.797176624544534],
            [4.8857150033307555, -7.804071009767829],
            [4.88121748043921, -7.806319968098669],
            [4.880168270248305, -7.809039728676822],
            [4.881206001210673, -7.817231185730146],
            [4.884507118658655, -7.8208546560037435],
            [4.878319347153731, -7.824655642680162],
            [4.879334522812205, -7.833768930376858],
            [4.8812016633992625, -7.83619316005469],
            [4.879867036230003, -7.840196192384051],
            [4.883028580248975, -7.844468500070385],
            [4.880431535498599, -7.8470184409073545],
            [4.881078119005647, -7.853004520877968],
            [4.877333978302839, -7.85547570964558],
            [4.878554338556073, -7.868539322234608],
            [4.877632381294244, -7.873727963407606],
            [4.879958908563916, -7.876437456168245],
            [4.882237469971227, -7.883280824061348],
            [4.886713213960876, -7.892179685528813],
            [4.885128058597665, -7.89612566414455],
            [4.8788034201493575, -7.897664137065652],
            [4.776892474650397, -7.9073440643137145],
            [4.65760405643864, -7.918422357440707],
            [4.5339307386909935, -7.929721163436574],
            [4.531882101796583, -7.9300333392585145],
            [4.523282499158065, -7.93719175919614],
            [4.521203267330494, -7.940791686269137],
            [4.521610284475526, -7.94869346246387],
            [4.519407021151414, -7.95456668542876],
            [4.503562622564403, -7.958171633323748],
            [4.5032907467747245, -7.968438039332744],
            [4.501480351328807, -7.973135930621666],
            [4.501062519882485, -7.981130758798698],
            [4.497859749479481, -7.986742409125567],
            [4.494741297786583, -7.984883631244568],
            [4.487677757790687, -7.984808025325043],
            [4.487009722357847, -7.982887693911376],
            [4.491057259916581, -7.980625297111073],
            [4.490142974550192, -7.97110444972607],
            [4.490204804669699, -7.963427973100669],
            [4.4870560214725685, -7.956858662900399],
            [4.483380530007006, -7.954429112368623],
            [4.480427534673677, -7.943668737759914],
            [4.477020746002283, -7.9419115791967565],
            [4.477627360358936, -7.937517932473272],
            [4.482748360249802, -7.93879764909385],
            [4.484003548546428, -7.935380196713202],
            [4.4833771361175705, -7.9295326003025055],
            [4.488573375421098, -7.929522890509748],
            [4.490888964457618, -7.927969961773998],
            [4.4910064658998605, -7.922964604218719],
            [4.499135926006275, -7.918042344759873],
            [4.494931140364884, -7.911441392905207],
            [4.498682101867135, -7.905184526613173],
            [4.5035276316775255, -7.901991512399485],
            [4.502329156321668, -7.896231932011742],
            [4.502872195030998, -7.889957045608951],
            [4.506047181452554, -7.884895857949292],
            [4.507604973352034, -7.879954821861528],
            [4.5100398149361975, -7.878027154241244],
            [4.514587142191822, -7.880416212335036],
            [4.518287158382263, -7.878581014459113],
            [4.521259505343849, -7.873102336204027],
            [4.524088270387186, -7.864220598897316],
            [4.5276691270669405, -7.862627379592637],
            [4.532018585286388, -7.857821586038807],
            [4.531141865424713, -7.853727989385246],
            [4.532831658667185, -7.848931333706054],
            [4.539953856183614, -7.847848058638345],
            [4.543165335199937, -7.844705963187449],
            [4.543260754202147, -7.839797128737729],
            [4.53643877864897, -7.834944263900015],
            [4.537262687766918, -7.830628670198899],
            [4.541649959260349, -7.82912480133787],
            [4.547276445047397, -7.824187286451646],
            [4.547352341788265, -7.818833367439331],
            [4.543864825974134, -7.81458858381867],
            [4.5432663005021805, -7.808917858063428],
            [4.546029309812392, -7.804846407970524],
            [4.546557431520901, -7.8009894815513],
            [4.549482167057432, -7.794842624041619],
            [4.550380087338491, -7.787855419586016],
            [4.5462331692762135, -7.780780021121827],
            [4.551138810424264, -7.778282428934528],
            [4.553891417169748, -7.770190438734428],
            [4.552739887394318, -7.766519103976177],
            [4.549077513496659, -7.765854014840411],
            [4.552060054534335, -7.759039587949939],
            [4.550943774971405, -7.753324715299346],
            [4.553627491544126, -7.7502548148895976],
            [4.553736521474686, -7.7428737295155585],
            [4.556188914321886, -7.741868782956494],
            [4.561548142336906, -7.743032825331797],
            [4.563610027653988, -7.741427298123055],
            [4.563378435487928, -7.7345096816773005],
            [4.561008455977926, -7.729387383116624],
            [4.563238914028836, -7.723850823005454],
            [4.560583581708215, -7.71983118555147],
            [4.561322189607072, -7.71630448541499],
            [4.56761271329403, -7.715455303232667],
            [4.5696298378484705, -7.712435596959734],
            [4.570113654354597, -7.707500403931034],
            [4.572509946616587, -7.702168667096297],
            [4.576124942681876, -7.700850800863942],
            [4.578399340331885, -7.696412543921442],
            [4.574506852254191, -7.6935188969683495],
            [4.571087090624452, -7.688726356663502],
            [4.572048536716154, -7.683963744160602],
            [4.569611192034345, -7.677677558506032],
            [4.569786935461296, -7.671897144528273],
            [4.5718446549397065, -7.665190100424724],
            [4.574279860043936, -7.661672823482784],
            [4.58000526720819, -7.660319164711763],
            [4.581636614013952, -7.655604755624481],
            [4.581251746364603, -7.642641238843582],
            [4.583428425893233, -7.639829132706971],
            [4.584237070552856, -7.634715921784135]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.04550032644154,
          "lat": 30.845140050170958
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22037"],
        "coty_name": ["East Feliciana"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["East Feliciana Parish"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00558542"
      },
      "bbox": [
        4.477020746002283, -7.986742409125567, 4.886713213960876,
        -7.6189018314463075
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.92061176527382, 5.3766381177150615],
              [18.924139602336037, 5.379866897393695],
              [18.92972820827701, 5.376194318328523],
              [18.929505963297817, 5.3727934216544515],
              [18.932167128843354, 5.368738783551598],
              [18.936035568241586, 5.36883980677352],
              [18.934769214730487, 5.360207586020878],
              [18.929724914618934, 5.360646845854314],
              [18.924069260863973, 5.365644774114961],
              [18.920218422128848, 5.370410685240674],
              [18.92061176527382, 5.3766381177150615]
            ]
          ],
          [
            [
              [18.430678844270286, 5.643252757165724],
              [18.44283962263508, 5.6466769933654595],
              [18.48955484107524, 5.689270778005598],
              [18.562647965853987, 5.757098485030644],
              [18.581041593990836, 5.774040576471482],
              [18.616482775073187, 5.807103638853544],
              [18.636200446142357, 5.764821552932182],
              [18.664679471229803, 5.702926347537321],
              [18.673157491219932, 5.68483038241018],
              [18.67898250802041, 5.682674950872982],
              [18.706928494470937, 5.66998150530862],
              [18.72158544057462, 5.658311497023237],
              [18.720888687582917, 5.656108880040368],
              [18.722637524710905, 5.649903904310259],
              [18.72659703217403, 5.649844048394937],
              [18.72888250243895, 5.643741272155523],
              [18.732531774861048, 5.641267883037131],
              [18.747769408780897, 5.613524541434434],
              [18.75397029109407, 5.600371858288761],
              [18.751645242176828, 5.595975996734422],
              [18.747146968351394, 5.591459497919183],
              [18.74176042171242, 5.582709980242598],
              [18.720698169409424, 5.545404616633951],
              [18.740839748656914, 5.5331902640829105],
              [18.73789254728541, 5.510926978792992],
              [18.809337691696445, 5.542928938675843],
              [18.830469984232817, 5.514082302473711],
              [18.84274777553199, 5.519706163093827],
              [18.902648752366403, 5.415771904158736],
              [18.908391940151578, 5.400507395653562],
              [18.902116475297703, 5.397184850509333],
              [18.897743202833873, 5.393100494009327],
              [18.90158940696975, 5.391755651636255],
              [18.904707460614596, 5.384424331445459],
              [18.908566484533857, 5.3815999313033895],
              [18.911678756232895, 5.374865573280399],
              [18.91677037688098, 5.369589255668074],
              [18.91407743000257, 5.367654792582912],
              [18.910490073632374, 5.3545319833901175],
              [18.9050940644413, 5.364433360817155],
              [18.901861815351975, 5.366637327211491],
              [18.900719155863488, 5.372833587633433],
              [18.89361072934401, 5.382154458993214],
              [18.89189356805447, 5.390005977555074],
              [18.887454242906607, 5.394163752684785],
              [18.874613734743086, 5.395899343909231],
              [18.87359650473061, 5.388451717388004],
              [18.87209727456894, 5.386273029870374],
              [18.862673623111608, 5.383084720336594],
              [18.86067366665896, 5.378066643171929],
              [18.869232195412707, 5.3711157579121895],
              [18.878126713120125, 5.3551079520879],
              [18.87594088187849, 5.353406394873718],
              [18.86863084252568, 5.355515948927228],
              [18.861350745288657, 5.366003985413567],
              [18.855398990034296, 5.371525567498302],
              [18.84989063100121, 5.368936504706867],
              [18.851060683633065, 5.362602542383482],
              [18.857131262567552, 5.350923855054567],
              [18.856895994612856, 5.3406096598389325],
              [18.85416033386783, 5.33289155485062],
              [18.84961843111209, 5.335888984642631],
              [18.847423551612216, 5.339949563504675],
              [18.843242068753256, 5.337353452007164],
              [18.848675638111427, 5.326471774550166],
              [18.8572237459965, 5.320992467483147],
              [18.86389881782363, 5.305645770200889],
              [18.870587708563992, 5.298121398693853],
              [18.860985044211887, 5.295898249095066],
              [18.858417328287086, 5.2925505844022505],
              [18.859288536077834, 5.284717344890116],
              [18.854886967896793, 5.281211806773401],
              [18.858992917510182, 5.272496121063704],
              [18.856832687632632, 5.269153139311399],
              [18.849687130736875, 5.282029912868311],
              [18.845423221717315, 5.282918810613902],
              [18.8415655824648, 5.280958158929288],
              [18.836779089588955, 5.27634569366917],
              [18.83540599074808, 5.268579686288825],
              [18.839396064129573, 5.262621606866434],
              [18.83892873724457, 5.257526226335133],
              [18.831183546652696, 5.257897024302296],
              [18.82427793238622, 5.2567269774869025],
              [18.813540833201277, 5.250674370776353],
              [18.812582037333758, 5.245729560426482],
              [18.80451166295935, 5.238061305029427],
              [18.804273157476, 5.230863255941966],
              [18.80908331086415, 5.226560113917753],
              [18.80906976181078, 5.221190834825394],
              [18.80716208282806, 5.220125103832202],
              [18.802646030115763, 5.228722305467281],
              [18.800960820591232, 5.235538353294903],
              [18.794180009558193, 5.23904926931218],
              [18.786263776109198, 5.2403687699819175],
              [18.77669804375475, 5.240834448755497],
              [18.7658415903366, 5.238364024946769],
              [18.761864233094027, 5.2320252142072],
              [18.75244150740669, 5.227695938594829],
              [18.748043270063253, 5.224066803308983],
              [18.747559485303537, 5.220200409743361],
              [18.743876597347192, 5.2201933146006025],
              [18.736119538310273, 5.243794209586983],
              [18.7114371412628, 5.31008517777842],
              [18.704334516640106, 5.318840999496337],
              [18.701453057438027, 5.32071210620319],
              [18.697933566423814, 5.331171775727744],
              [18.69664287642146, 5.338946384026715],
              [18.698893293921703, 5.344229175650155],
              [18.693147837745073, 5.374208649719036],
              [18.69263776486263, 5.375482933498569],
              [18.682637754394925, 5.375614254482243],
              [18.659611068890683, 5.374993390994894],
              [18.658824101877617, 5.378210514586552],
              [18.643791199106325, 5.378040989551329],
              [18.613712283002545, 5.406808562578172],
              [18.576673768252675, 5.440371868958107],
              [18.53004669885784, 5.452782018967352],
              [18.521789251107307, 5.455105703980105],
              [18.519158933499636, 5.460946272650713],
              [18.513877699135413, 5.467539694557348],
              [18.509549227754956, 5.468263400731473],
              [18.5074683705766, 5.471759981747092],
              [18.506338256688508, 5.480591573307409],
              [18.496973961442603, 5.492746080390143],
              [18.497352325286606, 5.497929504505963],
              [18.502348571804642, 5.507030418284402],
              [18.494940483504234, 5.514720967014064],
              [18.496278540427063, 5.533228668964338],
              [18.486431028063645, 5.550647021652974],
              [18.4835897208797, 5.567321352008222],
              [18.459550937799854, 5.556826029693841],
              [18.45421653759287, 5.55417437076048],
              [18.435958087402057, 5.623611147702044],
              [18.430678844270286, 5.643252757165724]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.11444017634162, "lat": 41.79724523980528 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25005"],
        "coty_name": ["Bristol"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bristol County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00606929"
      },
      "bbox": [
        18.430678844270286, 5.220125103832202, 18.936035568241586,
        5.807103638853544
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.153167292236947, 5.90815309982648],
            [17.226794240870984, 5.910987026708591],
            [17.229224306871995, 5.901825998437466],
            [17.2314898956546, 5.896366074778196],
            [17.235324938936152, 5.896542614051607],
            [17.236228617661116, 5.878301619945032],
            [17.244713794577248, 5.856457312397162],
            [17.274715011074473, 5.855965991885955],
            [17.274615122064283, 5.8565829894804855],
            [17.318464468949593, 5.856905525187825],
            [17.32600605396908, 5.855560336625664],
            [17.326499608738786, 5.852061879487604],
            [17.330588452820326, 5.853871290747118],
            [17.331082356276777, 5.849420401122653],
            [17.326961359667703, 5.847768137436484],
            [17.327399834700586, 5.843539766335711],
            [17.33350002902021, 5.845809203405248],
            [17.33463037118805, 5.839351107866206],
            [17.37337042672866, 5.8562425026067135],
            [17.38244024850389, 5.8096063133941],
            [17.43850221919361, 5.833449434432975],
            [17.46265838956158, 5.847783920783956],
            [17.465984928716722, 5.848032807432885],
            [17.528082601489928, 5.875203904131017],
            [17.538978795267774, 5.850745261578307],
            [17.612956331905135, 5.88315540509936],
            [17.616328950619366, 5.878998041882458],
            [17.615852637652193, 5.876214692551998],
            [17.62324903898013, 5.867870084941335],
            [17.622064946271564, 5.864241483787613],
            [17.627336672355558, 5.853670871524932],
            [17.628801140814126, 5.845871938343783],
            [17.63106243760035, 5.844336594443088],
            [17.63248852456053, 5.839346171534505],
            [17.638420329053893, 5.833777962833917],
            [17.638263284407262, 5.8307595649583455],
            [17.64074358622284, 5.827028231755593],
            [17.64024574319743, 5.823801720939038],
            [17.64354552399884, 5.818407211198073],
            [17.642726137461274, 5.812929496886708],
            [17.64652547944268, 5.810943777215477],
            [17.651308843552858, 5.80357848398649],
            [17.651271236057944, 5.796619843420074],
            [17.6536870444456, 5.794328866400701],
            [17.652462085083325, 5.787110205499194],
            [17.65290155894273, 5.779152689394924],
            [17.651379776314226, 5.776082351383967],
            [17.656288026856167, 5.775145438369183],
            [17.661150179825537, 5.780802794663979],
            [17.662772418745863, 5.785720755543545],
            [17.667444223791332, 5.787740499509869],
            [17.66848137458255, 5.792412482289889],
            [17.67183424537152, 5.794354208361431],
            [17.670678333830853, 5.802340365034181],
            [17.671482414608306, 5.807757345912019],
            [17.675301070584233, 5.819228369875592],
            [17.67699896300042, 5.818742698514444],
            [17.682258411579387, 5.823128370656127],
            [17.683320675768023, 5.8259520169597145],
            [17.689609454456424, 5.831169632026301],
            [17.69459387835184, 5.832716228620975],
            [17.700569421499857, 5.817816879550105],
            [17.70254252655731, 5.81866652131543],
            [17.705302805000258, 5.812069979536196],
            [17.70330005263923, 5.811237578276137],
            [17.713863824323575, 5.785878159841429],
            [17.72209714103861, 5.7913728639468935],
            [17.72284500797897, 5.789570842590104],
            [17.75696296834071, 5.806559310066629],
            [17.756449958454027, 5.802486137438361],
            [17.758013720652713, 5.796627550725032],
            [17.756081875675363, 5.793854739316443],
            [17.757047108323125, 5.7886718443176495],
            [17.76117515010212, 5.790158988729185],
            [17.76734856717125, 5.788321019296195],
            [17.76610387700032, 5.781867536494832],
            [17.763237887022814, 5.778456745047808],
            [17.76591716605674, 5.765856326810464],
            [17.762357619093358, 5.7653305028937645],
            [17.76695126365894, 5.752050166189313],
            [17.77063512689479, 5.752449487132839],
            [17.773204394721414, 5.744343538873208],
            [17.76743576815547, 5.744323879122393],
            [17.766027648322115, 5.740499063146441],
            [17.748437264367062, 5.73276394777416],
            [17.743925763828, 5.7189843205162285],
            [17.736499865644884, 5.716517509355038],
            [17.73290456627474, 5.7236848118313155],
            [17.72883009559078, 5.718492088445264],
            [17.72577015534939, 5.719697864512851],
            [17.6904937289221, 5.695399406126531],
            [17.686651735372184, 5.693469233154433],
            [17.68424142875188, 5.689495908055565],
            [17.68527637803268, 5.6843915569784675],
            [17.682093611209876, 5.6796864915935625],
            [17.678024687502454, 5.680713953069913],
            [17.674295206667765, 5.673720029039411],
            [17.679370501856503, 5.667944329334176],
            [17.68068733401094, 5.661892659565165],
            [17.65658686363987, 5.651249342554817],
            [17.639137764266746, 5.69450676963923],
            [17.609493244402262, 5.682289373759176],
            [17.55656228033689, 5.660181304638242],
            [17.508993198558795, 5.640848128966314],
            [17.501038630361357, 5.641245196803581],
            [17.494721009942268, 5.645402492142255],
            [17.48978549658078, 5.651803159718802],
            [17.483718708764183, 5.65380054588536],
            [17.481337572580706, 5.658523542734969],
            [17.48244351203697, 5.672238781988258],
            [17.48674182970847, 5.685926365873505],
            [17.49094496588644, 5.691940515574264],
            [17.49084604540176, 5.69658155866431],
            [17.486353689378305, 5.7071889783884036],
            [17.482700337605298, 5.709584916146204],
            [17.476623638007712, 5.7099272402957455],
            [17.46435665730132, 5.69413640791785],
            [17.460018269835427, 5.6453304560799],
            [17.452562480679518, 5.641112890801638],
            [17.45313821509338, 5.632009720642661],
            [17.43936115821883, 5.625035703050142],
            [17.44833682160469, 5.602225987805123],
            [17.449226956038178, 5.596829319686229],
            [17.378000102705435, 5.59601796535091],
            [17.372967839734375, 5.612864372340115],
            [17.365911311782156, 5.611146257153682],
            [17.360133890008786, 5.629903238609885],
            [17.346922396358153, 5.624667165758805],
            [17.34387465551884, 5.634288954113597],
            [17.313425110312377, 5.622082810811421],
            [17.310676166232458, 5.612923065613266],
            [17.308876293061807, 5.596137971778942],
            [17.274735147458976, 5.6111387369124115],
            [17.29099517535826, 5.642247808916767],
            [17.27141070212192, 5.706803868470219],
            [17.26485414554002, 5.704028599639236],
            [17.262016395289383, 5.712834137913213],
            [17.219781085834104, 5.705684323845473],
            [17.194211034109497, 5.667139009763591],
            [17.191704204859004, 5.658508027508206],
            [17.189008578241605, 5.657694472746104],
            [17.18297460767605, 5.662848883947944],
            [17.18108710827746, 5.659440886255663],
            [17.172892993044087, 5.65850667179143],
            [17.166059351958104, 5.662663307406602],
            [17.163517976916907, 5.667434060933662],
            [17.16036057290167, 5.665848078669848],
            [17.154040055600397, 5.669347100025841],
            [17.145622879471315, 5.672094609702957],
            [17.14202946930345, 5.682336360636597],
            [17.129162100083374, 5.721465535395407],
            [17.129093369710247, 5.730103515719143],
            [17.16990213232938, 5.730383456930534],
            [17.169811907117438, 5.738666537987419],
            [17.16672014740497, 5.801199197576468],
            [17.165626951028457, 5.819343812952479],
            [17.166861310282513, 5.81939853897539],
            [17.164456972026017, 5.850934140389387],
            [17.16188762763401, 5.893773219031899],
            [17.154070452879655, 5.893506594433251],
            [17.153167292236947, 5.90815309982648]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.66374560175866, "lat": 42.34015346901446 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25015"],
        "coty_name": ["Hampshire"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hampshire County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00606934"
      },
      "bbox": [
        17.129093369710247, 5.59601796535091, 17.773204394721414,
        5.910987026708591
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.483222525770517, 6.471759158272277],
            [7.5155177988224136, 6.4756118597793],
            [7.565600467825786, 6.4808156238115995],
            [7.580097637692852, 6.482154675848084],
            [7.608905655308279, 6.484035570390847],
            [7.666429585065994, 6.487511149667803],
            [7.671390949401097, 6.430449569358805],
            [7.675416857564173, 6.387204994555871],
            [7.681715157760983, 6.329125946272486],
            [7.683792452345712, 6.314800900646358],
            [7.692569306675904, 6.228275320978225],
            [7.6421210952696965, 6.2229560920320255],
            [7.5782988361519985, 6.216647376412432],
            [7.549833542753906, 6.214205959890023],
            [7.489088165487944, 6.209589201687953],
            [7.435285658236292, 6.2061653223398885],
            [7.397116681796681, 6.202686796396319],
            [7.397075207210076, 6.208592758412182],
            [7.3990521481248175, 6.221275665934983],
            [7.401665713473699, 6.233948251775069],
            [7.40209296917059, 6.25315261255164],
            [7.40020534351893, 6.263449569101246],
            [7.3958033848002644, 6.278970900486176],
            [7.389803286781404, 6.292895241565851],
            [7.385063136320743, 6.301834590731688],
            [7.379310161190794, 6.30985290896561],
            [7.375753049917671, 6.319058319778264],
            [7.370477119162635, 6.3299971891808315],
            [7.36499116888479, 6.344978474192258],
            [7.3641971881092765, 6.3680404603608345],
            [7.3649376796747, 6.373288159612266],
            [7.368810379166899, 6.380803377849722],
            [7.3793744721592995, 6.388897040902289],
            [7.394180588367074, 6.396119542142968],
            [7.4146420016394945, 6.405160224265852],
            [7.424809429497644, 6.41196896246375],
            [7.431510524010769, 6.420325128542214],
            [7.446013417379905, 6.418159937383272],
            [7.455656258450515, 6.418706343560991],
            [7.465869753219101, 6.422885388258468],
            [7.472668033290132, 6.429350949857472],
            [7.476451816614544, 6.434892950416276],
            [7.482955484470995, 6.451836853650522],
            [7.484514568450584, 6.463652886454551],
            [7.483222525770517, 6.471759158272277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.01550856631044, "lat": 44.63872275844149 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26019"],
        "coty_name": ["Benzie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benzie County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01622952"
      },
      "bbox": [
        7.3641971881092765, 6.202686796396319, 7.692569306675904,
        6.487511149667803
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.370009074130722, 8.18131987963331],
              [6.372602297923813, 8.183781102938488],
              [6.376934990138197, 8.181687198716036],
              [6.372992602503998, 8.176140886843022],
              [6.370009074130722, 8.18131987963331]
            ]
          ],
          [
            [
              [5.9572449401648, 8.49316319307315],
              [5.9635926156619465, 8.493147203400193],
              [5.961926337639674, 8.48968743623183],
              [5.9572449401648, 8.49316319307315]
            ]
          ],
          [
            [
              [5.90685751517416, 7.960160170027553],
              [5.897081957854923, 8.075688418341695],
              [5.886012948929238, 8.21438437176485],
              [5.971235108753572, 8.222177291507155],
              [5.96844133963825, 8.25699322155702],
              [5.964127643864945, 8.306723799138],
              [5.927576669584317, 8.303871112921199],
              [5.924082611577088, 8.346550991679061],
              [5.921545244899243, 8.371725531786188],
              [5.921600941387822, 8.375449943581081],
              [5.9154993781590735, 8.447441465299251],
              [5.922213662058924, 8.445114734555428],
              [5.929796641824175, 8.446028896145775],
              [5.934440739275304, 8.44793954222291],
              [5.941201699233386, 8.446781172336197],
              [5.947367665443157, 8.443948852446843],
              [5.953562457496666, 8.444019461323245],
              [5.9559330844972305, 8.445263352353418],
              [5.976260932508509, 8.450024164059398],
              [5.989762047968926, 8.450529881435301],
              [5.999706949190983, 8.45148880941047],
              [6.003155830094621, 8.452835218917487],
              [6.013489904695696, 8.453918040821254],
              [6.016161546775624, 8.453242339113899],
              [6.033351696934855, 8.438555937570303],
              [6.042950141514506, 8.434454015956321],
              [6.053471847240873, 8.43169034908127],
              [6.056829440449746, 8.43242887386421],
              [6.05958677995958, 8.435322113588802],
              [6.06599082184976, 8.438498614472438],
              [6.072956845303056, 8.440517596799273],
              [6.075827304460147, 8.435822470447855],
              [6.082730184772594, 8.431692489452947],
              [6.097403245149775, 8.431442131412746],
              [6.101455233684833, 8.4286919722281],
              [6.100751525902033, 8.422398455633212],
              [6.102393565098445, 8.418980675726498],
              [6.106259291097163, 8.415701323987262],
              [6.11026538709099, 8.414211109468008],
              [6.117262975625172, 8.413959314883568],
              [6.120874256995973, 8.41808305928512],
              [6.1270093429788846, 8.419539001514142],
              [6.130760739424554, 8.408194660719799],
              [6.1325200987129485, 8.405055253220725],
              [6.131497360035549, 8.40209518251486],
              [6.1356685171023395, 8.387285793112964],
              [6.139780040393111, 8.38168254251548],
              [6.15292428769981, 8.38140617007642],
              [6.162581974020023, 8.384753884535224],
              [6.166944902285593, 8.38814102361216],
              [6.168205413338366, 8.392582519431505],
              [6.165586266374275, 8.397075010507304],
              [6.165885670461119, 8.399655625197889],
              [6.1702645401415515, 8.400781342865521],
              [6.1749385058377735, 8.395715929144602],
              [6.1766884310795165, 8.386599309305037],
              [6.176197844050141, 8.38305223881114],
              [6.181233577405739, 8.376610403518848],
              [6.1887986439408715, 8.373523574120654],
              [6.194640127869284, 8.372860210663607],
              [6.199313307972829, 8.374859312187208],
              [6.205333110947977, 8.373776201755987],
              [6.209514321789552, 8.367266122720741],
              [6.215298410577603, 8.362261383738577],
              [6.224739785851416, 8.352027792452567],
              [6.235975005965588, 8.345837566767177],
              [6.236438054646981, 8.342265721506783],
              [6.234542929681273, 8.338959865241883],
              [6.236997123988638, 8.332571292037963],
              [6.239646834486908, 8.31830778579517],
              [6.243291753753904, 8.31235756367949],
              [6.242685475945403, 8.31046357713296],
              [6.246386295873414, 8.303950992384841],
              [6.245179697112239, 8.302327781675226],
              [6.247123355410089, 8.296714613427095],
              [6.254371190951343, 8.287169040268871],
              [6.2626246649208905, 8.282626714981793],
              [6.266083023423612, 8.27836025892034],
              [6.2725774527445095, 8.27361621856332],
              [6.2763405615835595, 8.27232090004958],
              [6.278974728226861, 8.266282196814416],
              [6.28690968831643, 8.264063004646477],
              [6.2899703750921985, 8.260906352638889],
              [6.292839051230628, 8.251732055721142],
              [6.291591756454221, 8.246968296065054],
              [6.3021298912592565, 8.233692019381717],
              [6.303968484510632, 8.228733671110179],
              [6.309139127575833, 8.21998987633634],
              [6.316553057740268, 8.215759947470964],
              [6.3342544241632845, 8.210463643539004],
              [6.335597840961044, 8.206554466062222],
              [6.335369719015317, 8.201258235369504],
              [6.336741865166329, 8.196806661480176],
              [6.339516514270925, 8.19312578980356],
              [6.33876144760614, 8.190252443754071],
              [6.3483020968848205, 8.182299739968254],
              [6.354595143768531, 8.179744506637736],
              [6.3545334911291365, 8.175851936592855],
              [6.357428876831566, 8.172066054395057],
              [6.360759433224434, 8.172525350256992],
              [6.363528510363273, 8.16832412303327],
              [6.376148111889326, 8.170668161042713],
              [6.379757791231, 8.167188763144557],
              [6.388716777176619, 8.164595132829088],
              [6.394741450276923, 8.16618894489854],
              [6.394314826428854, 8.171733173280597],
              [6.398395118406818, 8.174491855679241],
              [6.400754976050975, 8.171562858920566],
              [6.399807216596538, 8.162822580182041],
              [6.3952740178548195, 8.163080397326803],
              [6.391315820931069, 8.157788545588122],
              [6.391650413518849, 8.151439009246882],
              [6.396089960280942, 8.142462045881121],
              [6.401141344661458, 8.137189349190981],
              [6.4014261243542, 8.13187202284389],
              [6.405139856712442, 8.128238719045969],
              [6.400118692867113, 8.12465526124005],
              [6.395936516016005, 8.123807353110276],
              [6.39425127083226, 8.114346564256456],
              [6.398263503760488, 8.106074434469662],
              [6.404369684122708, 8.09950790759624],
              [6.415296446665852, 8.090591934631249],
              [6.420702798706476, 8.087262624501536],
              [6.4390286505128564, 8.0817317259567],
              [6.455193984467269, 8.079049567815547],
              [6.472736699320768, 8.078231361596279],
              [6.491308754923652, 8.078608157900748],
              [6.5122114245910625, 8.081057573808831],
              [6.529802228842929, 8.084684426669568],
              [6.54491623631734, 8.090775480979195],
              [6.549059734317048, 8.094473586699653],
              [6.549989922034399, 8.099643072501259],
              [6.555845340509414, 8.101483043084523],
              [6.559326168064113, 8.095072089934659],
              [6.563918594071311, 8.093661354644535],
              [6.576151743336557, 8.092025192544913],
              [6.588399878873013, 8.094043117791587],
              [6.596438894491413, 8.011175816538918],
              [6.598127961256416, 7.992173766191275],
              [6.60237182052884, 7.949284649765778],
              [6.607859664492934, 7.892206124920942],
              [6.613309271440326, 7.832111214386838],
              [6.62000300040652, 7.763781359443774],
              [6.533369512534557, 7.755844052930974],
              [6.535897222713767, 7.726722807060654],
              [6.548398284324429, 7.584341209339747],
              [6.505001239649075, 7.580418472948288],
              [6.461792366847594, 7.576668501350712],
              [6.405184344539712, 7.572000739938841],
              [6.375383248681094, 7.569148814452794],
              [6.289001570576624, 7.561984129856306],
              [6.281645047237884, 7.647672024330354],
              [6.274525225305964, 7.733289311770913],
              [6.266896117305147, 7.818889316901721],
              [6.1804447769524895, 7.8115369249908095],
              [6.137014770848008, 7.807736466532605],
              [6.093820936568685, 7.8041474640421615],
              [6.035962003300507, 7.7991482538360755],
              [5.920605733275194, 7.789422439087333],
              [5.913790650634833, 7.874862691131054],
              [5.90685751517416, 7.960160170027553]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.64155659921711, "lat": 46.4312553993179 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26103"],
        "coty_name": ["Marquette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marquette County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01622994"
      },
      "bbox": [
        5.886012948929238, 7.561984129856306, 6.62000300040652, 8.49316319307315
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.152489892438685, 7.28817130178997],
            [6.1532826891178525, 7.2883712289219],
            [6.2279678062428, 7.29493032733809],
            [6.256432525136853, 7.297551224038694],
            [6.254015385825209, 7.325981423859521],
            [6.251915309376936, 7.343272192513759],
            [6.241248593433548, 7.471169910853049],
            [6.296458547168722, 7.475991372177841],
            [6.289001570576624, 7.561984129856306],
            [6.375383248681094, 7.569148814452794],
            [6.405184344539712, 7.572000739938841],
            [6.461792366847594, 7.576668501350712],
            [6.469736609077984, 7.491533089950766],
            [6.499100725241216, 7.4938888210153545],
            [6.5069975302001515, 7.408563948864765],
            [6.509488078819232, 7.380082415986762],
            [6.512376788718342, 7.351781097134822],
            [6.516547833522659, 7.300467511637492],
            [6.5190511817692665, 7.272261958282986],
            [6.523212277972883, 7.221833821376432],
            [6.529272897273449, 7.1508248896434985],
            [6.573728381878947, 7.1541203650222425],
            [6.573365771369535, 7.143752867389375],
            [6.569248147499674, 7.136070280443548],
            [6.566149379736523, 7.1220250589707605],
            [6.562598645033968, 7.115396498086711],
            [6.561265210500781, 7.103566235600944],
            [6.55869158006427, 7.100954866824032],
            [6.555000528963369, 7.090873362538422],
            [6.551263365586677, 7.084763882491723],
            [6.5511023061267455, 7.077343512704379],
            [6.548904684553257, 7.071903252097111],
            [6.544867667241041, 7.068746454842215],
            [6.541605405603631, 7.063706841303471],
            [6.539821543915422, 7.054078257715638],
            [6.537711860334849, 7.053385318664106],
            [6.534810024395555, 7.047651914377887],
            [6.535334579748261, 7.037156845487356],
            [6.541092726195106, 7.0309811135629205],
            [6.540576722405965, 7.026344850748702],
            [6.536953550508882, 7.020249151935925],
            [6.535610558625485, 7.015978312390527],
            [6.525787070510125, 7.009560087259039],
            [6.520854718854495, 7.003602665853184],
            [6.519608023289038, 6.991111818806083],
            [6.518325404048483, 6.987666897829512],
            [6.515243615263521, 6.986110135484439],
            [6.512516803724214, 6.978389193004292],
            [6.510305146067808, 6.977510466646504],
            [6.500636730838706, 6.966988808736773],
            [6.499239273874071, 6.961975235452211],
            [6.501062476748623, 6.9530071238806785],
            [6.499928242554442, 6.94711553974217],
            [6.493448171837356, 6.944186640951016],
            [6.490623686572947, 6.939111202560619],
            [6.492850969299059, 6.929885131692881],
            [6.483699838789637, 6.922133591095478],
            [6.477755603810854, 6.912070070883923],
            [6.477534755856308, 6.908721320643927],
            [6.474834218890998, 6.900954380422809],
            [6.476359524048558, 6.890002648828549],
            [6.47184744088966, 6.886622921819177],
            [6.463728699414799, 6.874954316308021],
            [6.4606137938014125, 6.8717920783123345],
            [6.456436376615338, 6.864457411680218],
            [6.453734311005096, 6.85552893973439],
            [6.451933954862796, 6.8543995920315615],
            [6.446381846751204, 6.846643195768448],
            [6.442133915623956, 6.838135454351904],
            [6.437942034789614, 6.8319890560532155],
            [6.4295197796047425, 6.81586440826562],
            [6.429789058045034, 6.811577482461479],
            [6.426744309261526, 6.809849263519397],
            [6.424477691497335, 6.805451669176732],
            [6.416685468920667, 6.796848299198521],
            [6.414960961055008, 6.7933889303529655],
            [6.4129815940648935, 6.784363477484167],
            [6.409537510618434, 6.783261122123101],
            [6.397275700067203, 6.77291588333989],
            [6.391321500870736, 6.760046987536367],
            [6.38801844783661, 6.759161779559362],
            [6.383243428661169, 6.754039830281844],
            [6.381778659130245, 6.748667944371972],
            [6.3836366439147945, 6.746340973103764],
            [6.37471222501974, 6.737402093874931],
            [6.374343870641255, 6.733745213265924],
            [6.378450774559728, 6.72644141358769],
            [6.370860238886872, 6.722141917415395],
            [6.369480261480106, 6.717327047497378],
            [6.371177709041801, 6.712746690172792],
            [6.3685368729307665, 6.709816891375003],
            [6.370718291374039, 6.700790575019463],
            [6.378690923238897, 6.690382863852074],
            [6.3856463792092475, 6.684668024164965],
            [6.384988582524139, 6.682703555915062],
            [6.359334456700279, 6.68899857388982],
            [6.356343865868928, 6.691626821513314],
            [6.344633227099281, 6.690744835291323],
            [6.342178687683333, 6.692715891317322],
            [6.335321175690323, 6.691837984320826],
            [6.334885448035893, 6.696078573556299],
            [6.327413184389088, 6.702914335097171],
            [6.321164266604412, 6.713481745679723],
            [6.322718870927387, 6.717464336802547],
            [6.31624819590397, 6.725957322200756],
            [6.307861285353482, 6.731600504659494],
            [6.303898469709048, 6.7319204176236465],
            [6.298840022078374, 6.7349642143319555],
            [6.298009092060802, 6.737894431880364],
            [6.2908683060921975, 6.740734873206201],
            [6.285649100932103, 6.746564134157337],
            [6.276776726503458, 6.751719056298009],
            [6.277318529679339, 6.7560091477666315],
            [6.275048673852642, 6.761927383438778],
            [6.272919879757889, 6.771614715242278],
            [6.270956808004088, 6.775968976821123],
            [6.272187031097587, 6.779990886806986],
            [6.275315750150677, 6.783781065463957],
            [6.28087907620348, 6.787990787292345],
            [6.279518731557064, 6.797407206096494],
            [6.282279886209742, 6.801995583727719],
            [6.282756466113796, 6.805565965443218],
            [6.279983909855411, 6.808447651074594],
            [6.280235917898956, 6.81172015288928],
            [6.28392261190554, 6.81712369196058],
            [6.288634733075553, 6.8191603692699125],
            [6.288077534722104, 6.824357322160785],
            [6.288892499953029, 6.833828251973825],
            [6.287570437309758, 6.838375995749988],
            [6.2902317492148985, 6.845140474131763],
            [6.294867125505011, 6.849078688239578],
            [6.2937364664476565, 6.856199603362713],
            [6.294184379026933, 6.8610781378632995],
            [6.29894214370412, 6.870225541404035],
            [6.300269189839482, 6.878104047460823],
            [6.304874215017975, 6.883236568753659],
            [6.3054800437390774, 6.886321639880948],
            [6.309590135254154, 6.891039333187545],
            [6.316431267312091, 6.902776794980903],
            [6.315618427997891, 6.907738952295859],
            [6.319609308393552, 6.912487460509296],
            [6.324212854514291, 6.921413333866149],
            [6.3234963501255415, 6.932641300089506],
            [6.319104789287376, 6.9357296451425245],
            [6.316573745442227, 6.939907819775236],
            [6.315818241335717, 6.948492678560239],
            [6.314154375393776, 6.950767675344444],
            [6.303157871310886, 6.95700808004184],
            [6.302020904555312, 6.961596821156078],
            [6.295915562244997, 6.964355164890494],
            [6.293441017216261, 6.967888435708429],
            [6.287727245704685, 6.968569403056023],
            [6.279296118251994, 6.961790601067487],
            [6.278430955365953, 6.959114989839768],
            [6.271369870274898, 6.954758556060519],
            [6.262346230346314, 6.940988770566686],
            [6.258684688464612, 6.932705352062147],
            [6.250903123537591, 6.930634192906902],
            [6.249165588091459, 6.924906773744083],
            [6.243640111809682, 6.923392189168685],
            [6.238468470880246, 6.925731480768973],
            [6.228864777131977, 6.923439141820386],
            [6.223471154296268, 6.926682482203868],
            [6.216360682018842, 6.926235111201428],
            [6.209835199249292, 6.923343665311483],
            [6.200651741193215, 6.923933351593699],
            [6.199539564874377, 6.9219073474280925],
            [6.193978667377595, 6.922962641063846],
            [6.192204232408603, 6.921545997525537],
            [6.190722396897597, 6.915559134829094],
            [6.183943186695944, 6.910569204800383],
            [6.181626152319355, 6.912025206041378],
            [6.181924204040643, 6.917191169050873],
            [6.17230246595862, 6.921880983951885],
            [6.170432154750443, 6.924971074067067],
            [6.16967577390226, 6.931798008234417],
            [6.166432332046584, 6.934753152220906],
            [6.162819875789399, 6.932245069106353],
            [6.167173741423189, 6.927426677470795],
            [6.167211146132937, 6.924683867542835],
            [6.1601156060272215, 6.919107533878489],
            [6.154968021792951, 6.9220780008833165],
            [6.156514935085203, 6.930277804599792],
            [6.160241088189925, 6.9335467083848075],
            [6.164897135644014, 6.941641051265695],
            [6.161709236404014, 6.944931825108739],
            [6.164540209897665, 6.951216209329516],
            [6.172138794982073, 6.956957001031978],
            [6.173531491728232, 6.961938043233881],
            [6.17142048792749, 6.9675989151113225],
            [6.176875584152849, 6.971011844923182],
            [6.1771349575906935, 6.9786005229329815],
            [6.171992536446998, 6.9847217413035345],
            [6.1684112702242375, 6.991793155560257],
            [6.168104327473271, 6.997825162928962],
            [6.166588576241912, 7.002567321664553],
            [6.170470463376267, 7.009779000329531],
            [6.175730747825879, 7.0130154732401735],
            [6.177194811232176, 7.017358878993887],
            [6.183138156110301, 7.020323451403964],
            [6.185021058526027, 7.025510730449015],
            [6.1936059826854555, 7.0308969357474576],
            [6.1980908459659165, 7.034835831888101],
            [6.198813994888238, 7.0387154611372145],
            [6.202350143475838, 7.044147299328139],
            [6.201056553265115, 7.0499667876779535],
            [6.206074695039165, 7.056429266294277],
            [6.206018164380932, 7.065287169193495],
            [6.209120654445223, 7.071453622169586],
            [6.208372754058698, 7.076430597044041],
            [6.204368732769654, 7.07734081366195],
            [6.201378547562673, 7.083829440360078],
            [6.19808179803369, 7.10165865415362],
            [6.198404818280619, 7.10868573461664],
            [6.195322386907192, 7.113650800499058],
            [6.186467659211596, 7.121433509429094],
            [6.180287371985824, 7.124409870820981],
            [6.175943687154709, 7.1278633049442295],
            [6.175245777468142, 7.130858690959485],
            [6.1776710928252125, 7.137286504588074],
            [6.191172157314313, 7.134989074617221],
            [6.1943935880731535, 7.132830582043996],
            [6.200434693319855, 7.1326130333459945],
            [6.2039570629047, 7.1338426022571655],
            [6.206200915142, 7.136915221633153],
            [6.206478472905992, 7.145860123864302],
            [6.205751436026664, 7.152239983218137],
            [6.206844507800422, 7.154906842910357],
            [6.21234411785192, 7.159899318903132],
            [6.211677455119437, 7.165154844050561],
            [6.212930651685734, 7.173415976898087],
            [6.210748239136858, 7.1752064293749065],
            [6.207547915352567, 7.1854722892581355],
            [6.199574706636322, 7.1869343414093265],
            [6.196701084857491, 7.188768217327759],
            [6.195521452646584, 7.193412526894763],
            [6.18983728309074, 7.198220756738747],
            [6.1850125640501155, 7.207561399129368],
            [6.1796302791603495, 7.212270410932782],
            [6.17459871926365, 7.215036884549914],
            [6.173677253139699, 7.221002759854807],
            [6.174812658902777, 7.223952485263372],
            [6.17391293558743, 7.230499198513669],
            [6.179895684230645, 7.233395045715421],
            [6.187433376766469, 7.2354016426259875],
            [6.192543457921702, 7.240657224985069],
            [6.201939807965346, 7.243401351071478],
            [6.201897183106423, 7.250433048168561],
            [6.196489577230881, 7.256766429559893],
            [6.186058969349616, 7.262520614505361],
            [6.180418455753473, 7.268480416670437],
            [6.182999335749418, 7.2719048645843545],
            [6.182165961506554, 7.275102253470808],
            [6.177277550937224, 7.279123274851663],
            [6.1689182514545875, 7.279752993377114],
            [6.167531352275586, 7.281170689584992],
            [6.159390039508179, 7.283181353190255],
            [6.152489892438685, 7.28817130178997]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.55664274450582,
          "lat": 45.580099076319186
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26109"],
        "coty_name": ["Menominee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Menominee County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01622997"
      },
      "bbox": [
        6.152489892438685, 6.682703555915062, 6.573728381878947,
        7.576668501350712
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.655047948083885, -5.357142100336482],
            [5.65955624503803, -5.351085140265058],
            [5.657595471926729, -5.343205618281319],
            [5.6598529699333815, -5.3410646622461595],
            [5.662079196770898, -5.333111912245916],
            [5.665977235524512, -5.330414921809586],
            [5.669093433505569, -5.3259148569847605],
            [5.670783011585964, -5.317826963231893],
            [5.672997625455294, -5.316736947077998],
            [5.67544979694732, -5.309938538810094],
            [5.681126474715308, -5.31159154865546],
            [5.6846808979883505, -5.306346378924751],
            [5.684428721077199, -5.300069414182702],
            [5.689531364293098, -5.292627013920494],
            [5.690069890039699, -5.283636290243429],
            [5.7366517526726994, -5.28038742771815],
            [5.756767102636154, -5.2788547474668635],
            [5.895250929525607, -5.269223620483609],
            [5.986592577409329, -5.263085944323365],
            [6.00909580933341, -5.2617087419393025],
            [6.0129780072486465, -5.326647057833894],
            [6.020390749870993, -5.438428880075356],
            [6.026404724788791, -5.533437358187379],
            [6.031830578987966, -5.615578951879893],
            [5.985529397880713, -5.6196117889384665],
            [5.967646697116153, -5.620044258243626],
            [5.910810173218646, -5.62452935026786],
            [5.844845715116074, -5.6292387367699535],
            [5.786491687335749, -5.633510244468544],
            [5.746239645443144, -5.636619021147261],
            [5.689921500517745, -5.640533342195638],
            [5.693011384182338, -5.685337453879681],
            [5.656075167512281, -5.687733962865267],
            [5.601038318902659, -5.69099326436587],
            [5.602146500374972, -5.6966475084663335],
            [5.576299265082487, -5.698499307641068],
            [5.496915785869849, -5.70350259489944],
            [5.501554185228074, -5.696190613395021],
            [5.503144337459845, -5.6909413444379355],
            [5.508021949278911, -5.692531331513626],
            [5.516972202019265, -5.6883024563808755],
            [5.522015563556323, -5.6810894615244205],
            [5.518588966761165, -5.6773503528081],
            [5.522668261816795, -5.673599509095216],
            [5.531041490074877, -5.669113373909934],
            [5.5356495490593955, -5.664306613496412],
            [5.533842439923765, -5.657677320364339],
            [5.535458035101232, -5.655622736039113],
            [5.546590921432086, -5.6518173768677675],
            [5.549748778555828, -5.649227344424609],
            [5.551882472790002, -5.643377388638159],
            [5.549505267521141, -5.642236096192217],
            [5.548426134240556, -5.635712575837972],
            [5.553363816702135, -5.633363573956164],
            [5.550788411367854, -5.630754890296679],
            [5.556410062349765, -5.61897725205805],
            [5.552221953822304, -5.6172405391249685],
            [5.553023395395116, -5.611312637434929],
            [5.558126038468604, -5.60725351098631],
            [5.559279794980952, -5.604828222171491],
            [5.555031106449478, -5.598439998399873],
            [5.558600562947378, -5.59124230836682],
            [5.563018596434951, -5.585486173834854],
            [5.559871431091043, -5.582209627508023],
            [5.560316743330307, -5.579711135139426],
            [5.565949787619245, -5.577250858169898],
            [5.57054921265725, -5.570142434234234],
            [5.5700120838742135, -5.5674510084223705],
            [5.57480016139659, -5.5657930240557345],
            [5.579689582951885, -5.559186994259851],
            [5.578633116215593, -5.556127497359774],
            [5.584569901899194, -5.5474278749208645],
            [5.591031615729683, -5.541320471592791],
            [5.59438623659893, -5.5344697099052365],
            [5.5907475646788605, -5.528540495875181],
            [5.591389225394316, -5.51607363613154],
            [5.597214052987861, -5.51269748718737],
            [5.602886157492406, -5.511498106811329],
            [5.604600382332376, -5.503768574387797],
            [5.603467334317854, -5.499443888454185],
            [5.600481432578657, -5.499333099231396],
            [5.601443903708556, -5.494604572541674],
            [5.598597554727668, -5.492144534511711],
            [5.598863937195878, -5.486798393153987],
            [5.6015830193579275, -5.484060223198593],
            [5.600701695105958, -5.4808634758316845],
            [5.604394655403688, -5.477753836280772],
            [5.604567034601028, -5.475275881085079],
            [5.600519799451477, -5.471611544225347],
            [5.601631676776441, -5.461574718373139],
            [5.608151475964752, -5.459547518446921],
            [5.614767592238522, -5.461766609966143],
            [5.614210098248725, -5.457549713069629],
            [5.619373401306919, -5.454010178420449],
            [5.622316351465531, -5.449757276422043],
            [5.623732039834891, -5.443305252057605],
            [5.621528697340914, -5.435997176472482],
            [5.6232906567345795, -5.434377318240663],
            [5.62403076394009, -5.4286638135187895],
            [5.621265264362705, -5.421296637775859],
            [5.621764460086641, -5.414556268500767],
            [5.625654851835702, -5.415121326082172],
            [5.626978708170499, -5.412082750202034],
            [5.630148342456889, -5.411410184595358],
            [5.632942720035407, -5.401797327236891],
            [5.635892326899087, -5.399069107244515],
            [5.632745715684981, -5.391476489688878],
            [5.6358704149746, -5.388680497023619],
            [5.63227054443401, -5.3817158048365465],
            [5.6338076586885855, -5.3792985643997016],
            [5.647261471344895, -5.376096123196398],
            [5.648758762375149, -5.3770446022312735],
            [5.654822601924552, -5.366215274727336],
            [5.655047948083885, -5.357142100336482]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.58150849974132,
          "lat": 33.086250415285164
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28007"],
        "coty_name": ["Attala"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Attala County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00695728"
      },
      "bbox": [
        5.496915785869849, -5.70350259489944, 6.031830578987966,
        -5.2617087419393025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.7533482552163229, 8.924025906867566],
            [-1.6667254508180331, 8.921360790550581],
            [-1.5799826910017716, 8.91817073924819],
            [-1.5373001493856695, 8.916896813549268],
            [-1.5084272056672008, 8.915862248698808],
            [-1.4072835286097198, 8.913161570575797],
            [-1.3356009552076906, 8.910838708691575],
            [-1.2336682121596985, 8.908083027297055],
            [-1.2344746846231474, 8.871189316833094],
            [-1.235870555497946, 8.822823563804363],
            [-1.2372800499251102, 8.76599330417513],
            [-1.237140633435324, 8.76491377585119],
            [-1.2386465065195962, 8.709382048434916],
            [-1.2399102873069174, 8.652126320048104],
            [-1.3271252420654729, 8.654460079725842],
            [-1.446386934948124, 8.657953545413418],
            [-1.5636304515070165, 8.661592945686364],
            [-1.6505242939180196, 8.664406618643929],
            [-1.7509918385889571, 8.667757773446722],
            [-1.7625293702421494, 8.668255088025187],
            [-1.7596064109613296, 8.754078374009728],
            [-1.7565526076017643, 8.838847161080228],
            [-1.7533482552163229, 8.924025906867566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.88296624795767,
          "lat": 47.457060265717374
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38031"],
        "coty_name": ["Foster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Foster County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01034223"
      },
      "bbox": [
        -1.7625293702421494, 8.652126320048104, -1.2336682121596985,
        8.924025906867566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2333703070322266, 8.001773125586237],
            [-2.1899645656572457, 7.999628404077885],
            [-2.1733320633626634, 7.999120543859614],
            [-2.1398747402005722, 7.997594238044634],
            [-2.086476040757047, 7.995412039100861],
            [-2.0170247045065506, 7.992345510493412],
            [-1.9126726164512438, 7.988181662905438],
            [-1.8257773353844418, 7.98482081367806],
            [-1.714626040023304, 7.980501827742088],
            [-1.6359516639533378, 7.977637646877808],
            [-1.6282519782506613, 7.977165384829711],
            [-1.6309540537408733, 7.8918481022727045],
            [-1.6333786686645617, 7.828540096524453],
            [-1.63708427281937, 7.720417638032066],
            [-1.6397758341106208, 7.634208176260762],
            [-1.640289185782253, 7.634321402346639],
            [-1.7170396562678576, 7.636884269952215],
            [-1.7744078854355223, 7.638906380774081],
            [-1.8054293834505373, 7.64015640368249],
            [-1.9005129644848373, 7.643475720732146],
            [-2.020107511845923, 7.647462081483277],
            [-2.1492314872290073, 7.651936663985779],
            [-2.2195108827426973, 7.65518694964366],
            [-2.221980310775838, 7.6551690609115415],
            [-2.248545646587481, 7.65658781092086],
            [-2.248145623381941, 7.671833344257504],
            [-2.2445901959068477, 7.756107973289796],
            [-2.2444427687782627, 7.756540127206485],
            [-2.2373588524987436, 7.913792480667367],
            [-2.2333703070322266, 8.001773125586237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.47736865869001, "lat": 46.4573342832444 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38047"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01035620"
      },
      "bbox": [
        -2.248545646587481, 7.634208176260762, -1.6282519782506613,
        8.001773125586237
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.121379612713524, 2.527426727620197],
            [9.165701111685962, 2.5329103044732024],
            [9.20858022098482, 2.5383386761391082],
            [9.208516651917831, 2.5388537035876135],
            [9.295386484363222, 2.5499733335880395],
            [9.299040163946039, 2.5209714104719865],
            [9.3419604869007, 2.526521224515207],
            [9.384621449664325, 2.5326782264047183],
            [9.386583406870917, 2.517823679888919],
            [9.437680983278032, 2.525157058636839],
            [9.485388759405067, 2.531457132317187],
            [9.556222880278378, 2.5409930045054745],
            [9.562625130046, 2.4902555134031656],
            [9.56993581524483, 2.435057829416129],
            [9.549064306647313, 2.429030269506879],
            [9.485317354303984, 2.420693232191669],
            [9.492012048502215, 2.36853880026888],
            [9.485572171040406, 2.3678347107977804],
            [9.40719239963779, 2.357986761209232],
            [9.393077489972324, 2.3558037968805334],
            [9.360924718324583, 2.3514201177159655],
            [9.322695103076548, 2.3464844876817232],
            [9.299908628516386, 2.343222208994451],
            [9.233877816597802, 2.334301035318843],
            [9.241322268446977, 2.2763002595722672],
            [9.246788841501143, 2.2319543788843195],
            [9.218375856817428, 2.2281025825037837],
            [9.17546479853559, 2.2226983189971246],
            [9.17809214781404, 2.198936401001377],
            [9.161828278132225, 2.201069203017038],
            [9.160494853890897, 2.2114741139479044],
            [9.149056040522566, 2.3083326616738216],
            [9.141973442747618, 2.3649622034160975],
            [9.134128832814003, 2.4242401437284764],
            [9.121379612713524, 2.527426727620197]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.22177745575367, "lat": 40.56091461039881 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39011"],
        "coty_name": ["Auglaize"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Auglaize County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01074019"
      },
      "bbox": [
        9.121379612713524, 2.198936401001377, 9.56993581524483,
        2.5499733335880395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.847624798536858, 2.5265807993039084],
            [10.864311042677642, 2.528098303692967],
            [10.921489196254727, 2.533905183367492],
            [10.921384629790031, 2.5350837271002113],
            [10.994335435963347, 2.542808531839712],
            [10.995145797593008, 2.5431437374180583],
            [11.059259771670968, 2.5502469402476993],
            [11.06551442749112, 2.5503514326923864],
            [11.116792934045042, 2.5570646272981787],
            [11.161098865539394, 2.562608125305191],
            [11.203847246837366, 2.567760445135704],
            [11.212604709109508, 2.4936403510754666],
            [11.221765393499856, 2.494844726814215],
            [11.284735084820753, 2.5019033599238094],
            [11.28918023543181, 2.464205738187593],
            [11.29367456067033, 2.4287363692160806],
            [11.297475559917457, 2.396018834764319],
            [11.302546021683247, 2.3549075149893404],
            [11.268525105828104, 2.3509190095069594],
            [11.270639843567345, 2.33651008903165],
            [11.276883949312124, 2.2792826912279605],
            [11.24272000971061, 2.275318609299213],
            [11.242615320880834, 2.2760043535221124],
            [11.172519455389445, 2.267814259672055],
            [11.14118189365723, 2.264389509552798],
            [11.00977048883476, 2.2493565231426826],
            [10.963435694829062, 2.2433414927166515],
            [10.958973254960895, 2.243574949393102],
            [10.887814567660941, 2.2375149388867195],
            [10.885730827731606, 2.253652738571386],
            [10.880536346446942, 2.3095546825385247],
            [10.870673514286581, 2.308567978194558],
            [10.865185174150916, 2.359947527127945],
            [10.8562101825398, 2.4453246821080765],
            [10.847624798536858, 2.5265807993039084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.92005097653173, "lat": 40.30165903628458 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39031"],
        "coty_name": ["Coshocton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coshocton County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01074028"
      },
      "bbox": [
        10.847624798536858, 2.2375149388867195, 11.302546021683247,
        2.567760445135704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.198743057099191, 2.0414784775057884],
            [9.227289909897305, 2.0455811703777926],
            [9.235320945947942, 2.04623332027303],
            [9.308813614426228, 2.05645245334712],
            [9.3368549036057, 2.0606031933443076],
            [9.35908914453602, 2.0642755764007874],
            [9.3592913324493, 2.059722964428509],
            [9.422005882821782, 2.062492401360562],
            [9.508139186767513, 2.066669750748122],
            [9.510436550989615, 2.0225293095847494],
            [9.516474291830052, 1.9215872132426401],
            [9.52181771768252, 1.8288039198474946],
            [9.523860494545684, 1.7883218526409417],
            [9.525520695510671, 1.7596819748120114],
            [9.444621280331594, 1.7557952928619955],
            [9.444069715158484, 1.7578977667824451],
            [9.438777367547624, 1.764071156726611],
            [9.433907923773491, 1.7810928879063754],
            [9.439641179285054, 1.7927620434212082],
            [9.383590916670261, 1.7851352859898566],
            [9.342998773969871, 1.779290565027621],
            [9.319548190944047, 1.7760941080520978],
            [9.237763474050098, 1.7643756703709441],
            [9.233957908436174, 1.7911747411270267],
            [9.230994474507671, 1.815472485692987],
            [9.22954162326319, 1.8225025824908518],
            [9.225871420909172, 1.8502257845460732],
            [9.223095748054428, 1.8665031743733635],
            [9.219518662455418, 1.8954362526068949],
            [9.213353616939923, 1.9390394205630388],
            [9.20094742449581, 2.0252934017839155],
            [9.197908308623507, 2.024882352201387],
            [9.199631788937538, 2.033331955534251],
            [9.198743057099191, 2.0414784775057884]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.22884489212575, "lat": 40.05347557420991 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39109"],
        "coty_name": ["Miami"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miami County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01074067"
      },
      "bbox": [
        9.197908308623507, 1.7557952928619955, 9.525520695510671,
        2.066669750748122
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8935902996637345, -3.867759512036335],
            [-0.8089051114373721, -3.8690946668353936],
            [-0.7525584835626329, -3.8701533346275148],
            [-0.7519757739812386, -3.8699984573383883],
            [-0.6950120552144105, -3.870835780344544],
            [-0.5942584157048323, -3.8723731390622675],
            [-0.5087577550180488, -3.8734759297218835],
            [-0.38059058220350045, -3.875370406454915],
            [-0.3366777051690998, -3.875911757111261],
            [-0.295015498584073, -3.8766024316460266],
            [-0.29591917920345234, -3.9640227428587944],
            [-0.29718192172372027, -4.095557710962035],
            [-0.35441408260003454, -4.094989643408586],
            [-0.35539354466041034, -4.094848588889187],
            [-0.4258981627650454, -4.094005478572297],
            [-0.46871859210415956, -4.093374008900243],
            [-0.46884006674597095, -4.107988571712904],
            [-0.5157410133974547, -4.107242045982077],
            [-0.5115523790049467, -4.113949384334897],
            [-0.5143391570119894, -4.116257640593579],
            [-0.5142393449962069, -4.121343609586258],
            [-0.5081194249862344, -4.1255656772698],
            [-0.51014799130105, -4.129560932114856],
            [-0.5073270166233596, -4.134250340140371],
            [-0.5001375270100505, -4.135320246268635],
            [-0.49639618651890294, -4.134739994617929],
            [-0.4927838345296109, -4.137191988535806],
            [-0.49076202687081066, -4.144678567489001],
            [-0.4945166448812046, -4.143657972980814],
            [-0.49306271338007657, -4.151959087125756],
            [-0.48713784275421323, -4.155594541067137],
            [-0.48975464221608295, -4.15823538349355],
            [-0.4953403055834546, -4.1562209303260715],
            [-0.496752766399666, -4.158939721506806],
            [-0.49449984730955776, -4.165526888146259],
            [-0.49162822922389793, -4.167489865628772],
            [-0.48168089807734044, -4.1679622681259145],
            [-0.4873338137576071, -4.170950309811939],
            [-0.48186541516422726, -4.178657097018217],
            [-0.48697418389188374, -4.183379215175309],
            [-0.48428879131446156, -4.196020129540347],
            [-0.48814370861947604, -4.200224345213182],
            [-0.48446411453928523, -4.201196299896272],
            [-0.48165661759351586, -4.209212946205355],
            [-0.47595348930914594, -4.209637903820687],
            [-0.4722372146513247, -4.212155096487268],
            [-0.4786963834861778, -4.214265091551134],
            [-0.4764801884893691, -4.217813986576952],
            [-0.47136714846584576, -4.221264899176499],
            [-0.47136478432552165, -4.2245909200662775],
            [-0.5835626621368971, -4.2229601602415014],
            [-0.6415461941676881, -4.2221710637208245],
            [-0.7699992992998127, -4.220049406857453],
            [-0.8132980674193976, -4.219303302320638],
            [-0.8139510337054011, -4.210762806762672],
            [-0.81277314233096, -4.160843947918531],
            [-0.8109674464828796, -4.044199589588102],
            [-0.8970031650437496, -4.042584551376079],
            [-0.8948475692747626, -3.9332956446779495],
            [-0.8935902996637345, -3.867759512036335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.30934016357993, "lat": 34.70457881867274 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40049"],
        "coty_name": ["Garvin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garvin County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01101812"
      },
      "bbox": [
        -0.8970031650437496, -4.2245909200662775, -0.295015498584073,
        -3.867759512036335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.5244639351396287, -3.953522298609357],
            [-2.43897762831792, -3.956250651862088],
            [-2.325981322165437, -3.9604431981424795],
            [-2.32731799983795, -3.9576170349003665],
            [-2.333452477324159, -3.9545365033360786],
            [-2.3394527806575005, -3.95840061839174],
            [-2.341333353669642, -3.952845840853583],
            [-2.3368380597761687, -3.948532950250231],
            [-2.338804086471202, -3.943650457734732],
            [-2.337608986554456, -3.9367832820866506],
            [-2.3388706260243435, -3.9232891916290944],
            [-2.33564995570417, -3.9190749135319947],
            [-2.3358709522275736, -3.9156825739641805],
            [-2.310144412729705, -3.9167156693849052],
            [-2.308643929648786, -3.872461958627119],
            [-2.2003292655871425, -3.8766569865153646],
            [-2.1821583693089694, -3.8771877506988632],
            [-2.1789755107382724, -3.878045289576151],
            [-2.1786627022134395, -3.8678653456261642],
            [-2.175970061193114, -3.87182679229142],
            [-2.172519141213157, -3.874155908320508],
            [-2.1683037840094213, -3.873950852688272],
            [-2.165830062134261, -3.864972673604096],
            [-2.1620120496583115, -3.86178003777946],
            [-2.157463728167523, -3.8611024774365954],
            [-2.152566933595429, -3.864172244539679],
            [-2.1500172842298824, -3.8596456209023735],
            [-2.1521042134676245, -3.8571319493597014],
            [-2.151151093346017, -3.852344011138731],
            [-2.1477170034666018, -3.851121902279899],
            [-2.1415588378214823, -3.853679857341422],
            [-2.1346107305530677, -3.8475708943031486],
            [-2.1341330900313995, -3.8347209420562165],
            [-2.132044107654613, -3.8331308506374038],
            [-2.124879339025495, -3.8319873346783933],
            [-2.117882494157141, -3.8365095135461402],
            [-2.116606744797707, -3.842985979361002],
            [-2.1114798888721165, -3.844587092643131],
            [-2.1025749415077613, -3.844192961571411],
            [-2.0970089634531446, -3.8421422298924637],
            [-2.0947237798745344, -3.845516697991879],
            [-2.0998480948764153, -3.8492190896195],
            [-2.1024988827916173, -3.856739901860969],
            [-2.1015189601564357, -3.8605544321858347],
            [-2.095974982151933, -3.8625386759938953],
            [-2.0969944670882334, -3.8666303016803147],
            [-2.1029744490019744, -3.8648167981215207],
            [-2.101894781045312, -3.8750902138665912],
            [-2.103784403284734, -3.887570262644872],
            [-2.1001508499688444, -3.894562628218451],
            [-2.1010175577858816, -3.898822066928168],
            [-2.1041797083678597, -3.9006762365411087],
            [-2.111396761471797, -3.899327628157206],
            [-2.113861136468488, -3.903971694636617],
            [-2.113706131476002, -3.914168428485068],
            [-2.1144721201662975, -3.9187771734964936],
            [-2.1129036857828356, -3.923946591576291],
            [-2.1087111890535426, -3.927775714580618],
            [-2.1035506447421963, -3.9290548691120466],
            [-2.1038911672359926, -3.9324557217452565],
            [-2.1096710514163384, -3.9314328125584392],
            [-2.114006872754541, -3.9338695917224316],
            [-2.111375117489746, -3.938384664712984],
            [-2.113878600842869, -3.941505252017974],
            [-2.121172833158986, -3.9370654079707865],
            [-2.12099192256333, -3.945811968716727],
            [-2.117939811241502, -3.9499013144328408],
            [-2.112025727572311, -3.950998661946593],
            [-2.113101477891444, -3.956749201035829],
            [-2.112191474781338, -3.961298457728179],
            [-2.106863997533998, -3.9704204457930214],
            [-2.1073394187483463, -3.974461650926749],
            [-2.1114441245807214, -3.9794654212626517],
            [-2.111031007926147, -3.9826604211995495],
            [-2.1067264092857116, -3.9885446352468046],
            [-2.103457890605372, -3.990936301038933],
            [-2.096633974442498, -3.992570583028423],
            [-2.0875574687647234, -3.991813662854083],
            [-2.075144047762735, -3.9955828853231883],
            [-2.068227344119014, -3.9958057222144756],
            [-2.0666187766557096, -3.9985542203729882],
            [-2.062507455405382, -3.999446885057967],
            [-2.0531273518674245, -3.9983425852662093],
            [-2.0484386823512066, -3.996787632564845],
            [-2.032242608705625, -3.994127841676701],
            [-2.0247591395330096, -3.994298608754315],
            [-2.019545729769945, -4.003802399799159],
            [-2.0145702715231413, -4.004585274357795],
            [-2.012787313471674, -4.009644601151408],
            [-2.017693778050239, -4.012343919308818],
            [-2.018066494616856, -4.018970632807564],
            [-2.028555569235745, -4.0207540480006605],
            [-2.038699026013032, -4.020289043023938],
            [-2.046650722114897, -4.021992740122001],
            [-2.0532672848226268, -4.019475167026819],
            [-2.0593964600599777, -4.023588356061588],
            [-2.060718659613708, -4.025989713848918],
            [-2.0614712687959518, -4.042260040218186],
            [-2.062871892138612, -4.049198964710719],
            [-2.0681205646965366, -4.056905027067605],
            [-2.067664562007921, -4.058862924196221],
            [-2.062461896029549, -4.060989331400077],
            [-2.060712948557451, -4.066393217405964],
            [-2.0578110463238577, -4.06970527557895],
            [-2.0519057123992543, -4.0711473351424585],
            [-2.0492369104121217, -4.077478094999316],
            [-2.0515241290772734, -4.08173774809866],
            [-2.056880410114304, -4.080113349696366],
            [-2.059684431993774, -4.083550048954912],
            [-2.0555572695857753, -4.086079596785749],
            [-2.0526886621966547, -4.0995613771928],
            [-2.0533234482284035, -4.105187245413292],
            [-2.056287856707814, -4.1072815735072625],
            [-2.06229386865338, -4.108263886582875],
            [-2.065733184161419, -4.105479824994344],
            [-2.0667213212202893, -4.101045835908785],
            [-2.0734680212781083, -4.10324878428759],
            [-2.0764807800265213, -4.102644340467013],
            [-2.084985944482977, -4.106726655021412],
            [-2.0874287366455686, -4.111580621648038],
            [-2.091190579585292, -4.110072700066016],
            [-2.0937707976575286, -4.106240039354699],
            [-2.0933483273184135, -4.102233381852458],
            [-2.100498215277513, -4.101534106769233],
            [-2.1131985764166323, -4.105717421897993],
            [-2.1188699229297505, -4.105458854848219],
            [-2.1255531147790894, -4.115099842677819],
            [-2.1313753580923644, -4.1267277263256466],
            [-2.137032171616692, -4.130732258494013],
            [-2.136291555462256, -4.135642616680206],
            [-2.1335136946456763, -4.138477992126966],
            [-2.1336163261588874, -4.142876157558898],
            [-2.127216704190758, -4.147077567696305],
            [-2.1308652009698883, -4.148568712493009],
            [-2.1324483288457547, -4.1532383296254105],
            [-2.1411104139835597, -4.152418674665725],
            [-2.1448207969943165, -4.14835465277249],
            [-2.1477420343005176, -4.150423731582323],
            [-2.149446505046651, -4.162071896196359],
            [-2.151869823527555, -4.1648254973948005],
            [-2.1584539499795143, -4.179560410322225],
            [-2.158014816522403, -4.187340445640694],
            [-2.159993321915233, -4.190984852797004],
            [-2.1688996068502053, -4.197901056793652],
            [-2.170115145532358, -4.201242992590246],
            [-2.1695368364732697, -4.207598010170687],
            [-2.172536132172556, -4.2112999901134165],
            [-2.169114481340036, -4.214525058002119],
            [-2.164579344639094, -4.211589030496408],
            [-2.1668831530130483, -4.221535234432381],
            [-2.170303120423651, -4.228333221644844],
            [-2.164135223340039, -4.233377820745658],
            [-2.1650953834020172, -4.237700865497164],
            [-2.1720571217097095, -4.2387582047452215],
            [-2.176773274864054, -4.241019644229709],
            [-2.1789418680276698, -4.250992613875545],
            [-2.176843379966884, -4.258573312532138],
            [-2.1728544590131493, -4.259767492485556],
            [-2.172021117898136, -4.267281943354288],
            [-2.1737138252472716, -4.271165410529118],
            [-2.1774413200710923, -4.272975356178242],
            [-2.1820448987277983, -4.263814262841313],
            [-2.1854642204869528, -4.267223493313357],
            [-2.183755031630859, -4.283708122261508],
            [-2.183899758713269, -4.291352024548872],
            [-2.1769290704041473, -4.291378209082684],
            [-2.177285931546319, -4.297262794138653],
            [-2.1795178043690884, -4.301703914119204],
            [-2.179220077762688, -4.304961483672152],
            [-2.1745356641111155, -4.305648096821026],
            [-2.169920306648016, -4.303015242420326],
            [-2.166706045787534, -4.298308320345952],
            [-2.163743703154886, -4.299743795577753],
            [-2.1630687884876916, -4.304580909544614],
            [-2.172779175983239, -4.316004885314799],
            [-2.1716003258599454, -4.319311191607259],
            [-2.1623117590977543, -4.319069318112127],
            [-2.158479719288381, -4.323572906668714],
            [-2.1585949223647356, -4.328337879690701],
            [-2.1558259629403724, -4.333476244055031],
            [-2.152553887004797, -4.335128688997614],
            [-2.150780450042866, -4.3389431675584555],
            [-2.1507081791881926, -4.347134334455985],
            [-2.153410566425283, -4.352315118349486],
            [-2.1558272762281345, -4.354098408415719],
            [-2.162933861006973, -4.3552120689497515],
            [-2.17136285521028, -4.3516667541607665],
            [-2.1812851229681436, -4.356363127113989],
            [-2.1852388351272642, -4.351855651652567],
            [-2.18037405220812, -4.3442783813516535],
            [-2.1848036772256982, -4.339205573540427],
            [-2.186485693195027, -4.334009601540455],
            [-2.1870586281332987, -4.325812082618867],
            [-2.1928025633302872, -4.328633708389893],
            [-2.195674566137923, -4.324782679539758],
            [-2.191185215912778, -4.3196628007032265],
            [-2.1960748398682868, -4.316169383453909],
            [-2.2008313337959486, -4.3195923519312265],
            [-2.2040764164704947, -4.319249117864225],
            [-2.2043704201844867, -4.315053336409297],
            [-2.2141387513886457, -4.309899185845961],
            [-2.2169505186918315, -4.30646559142683],
            [-2.216069565852956, -4.303825644823122],
            [-2.208372201134675, -4.303578854131662],
            [-2.2035695904656594, -4.299727357919296],
            [-2.2059340702460144, -4.296671450526275],
            [-2.2052315191343177, -4.288183763113262],
            [-2.210436216850673, -4.286541019882054],
            [-2.2120314212024703, -4.289548865388568],
            [-2.219665513822627, -4.290940997230468],
            [-2.2231242768179262, -4.288125409002224],
            [-2.22269894693485, -4.283579852324616],
            [-2.2254456098819553, -4.277908029598355],
            [-2.232079691021595, -4.275317265111212],
            [-2.2434125558905427, -4.280314658414635],
            [-2.25010087549472, -4.281901619390225],
            [-2.2527220430812034, -4.281142478747345],
            [-2.256300811635838, -4.275396208428964],
            [-2.259662445812562, -4.26730763139588],
            [-2.2638662882336824, -4.261977501332522],
            [-2.269711134417617, -4.258227072867056],
            [-2.2818900899911507, -4.246650748851321],
            [-2.281780965636057, -4.242230635655345],
            [-2.2798758265589596, -4.236951316595322],
            [-2.2831037359292985, -4.232807845296943],
            [-2.291843277249514, -4.229646378844128],
            [-2.2965423705174324, -4.229333154850699],
            [-2.301226012689425, -4.231087409020301],
            [-2.31315941863665, -4.245587947700931],
            [-2.3143637442818, -4.252716118066138],
            [-2.3119664482708093, -4.255868507464],
            [-2.312331607844268, -4.260188848039317],
            [-2.3153132814025628, -4.2630096879061465],
            [-2.3157583118471057, -4.268318881028041],
            [-2.31327694372936, -4.272566535646649],
            [-2.3082702483747806, -4.27605396462691],
            [-2.311638712706732, -4.282324177991885],
            [-2.315618240738987, -4.292145028779767],
            [-2.3169566572153824, -4.308500690375713],
            [-2.322179430402352, -4.314284514386775],
            [-2.3256545880581028, -4.315041354382004],
            [-2.330304444885321, -4.310442525789457],
            [-2.3364574876463955, -4.306828366729546],
            [-2.338692023885617, -4.3014405635478985],
            [-2.3418350233318637, -4.301857606185964],
            [-2.344040875294764, -4.305919055143154],
            [-2.343668098287994, -4.3111474400254455],
            [-2.345246344209119, -4.315834823646556],
            [-2.351157960890333, -4.3155744334564785],
            [-2.355383722865009, -4.310098252608284],
            [-2.3566268429928328, -4.306723154616705],
            [-2.3622992582867477, -4.297984589599858],
            [-2.3646886792554205, -4.300065480411541],
            [-2.365598112855991, -4.305770589183179],
            [-2.3694542176807647, -4.305355009289895],
            [-2.370222684704021, -4.294795246077942],
            [-2.3732554675488924, -4.289894194834903],
            [-2.38036713619649, -4.289536182775941],
            [-2.390224682165157, -4.287207897243495],
            [-2.392783774270361, -4.285365002965568],
            [-2.3956049468396703, -4.280170920234045],
            [-2.400145325058153, -4.275122742141635],
            [-2.4058968770926548, -4.274999746707967],
            [-2.4092127071727694, -4.271673853671132],
            [-2.414480159978531, -4.269679984237981],
            [-2.419494032799473, -4.271796187817521],
            [-2.4245407415083804, -4.27236780513309],
            [-2.4404058857539437, -4.270507882674058],
            [-2.450833108748326, -4.265487435120115],
            [-2.4607436557302593, -4.264148507272624],
            [-2.4654611655457956, -4.265609019650465],
            [-2.469417194352727, -4.274493451735639],
            [-2.4704558698704826, -4.28406174726518],
            [-2.4700848085230374, -4.291033410740955],
            [-2.47279527579567, -4.296300716816888],
            [-2.4773343808025525, -4.299609933936938],
            [-2.480268021043457, -4.304800088301978],
            [-2.4833913868912516, -4.307145437734838],
            [-2.4892273812965673, -4.304671580673903],
            [-2.503211908046801, -4.307511425731294],
            [-2.509309386440894, -4.303129043029552],
            [-2.518088872954956, -4.298919216963815],
            [-2.5224670330597703, -4.297990228371158],
            [-2.5276429398983082, -4.303618904616943],
            [-2.5347169899066606, -4.30620290957006],
            [-2.5416557269166957, -4.30187811186177],
            [-2.547224856119522, -4.299566008268502],
            [-2.5609350487699105, -4.3005100762028645],
            [-2.5657520709641806, -4.293412517924074],
            [-2.570197343827071, -4.292457077961357],
            [-2.5749308055558155, -4.287296436064029],
            [-2.577516963776495, -4.27523789778906],
            [-2.5805229317995892, -4.271619799196146],
            [-2.588578870270634, -4.266330184823565],
            [-2.59707446844739, -4.262452905076899],
            [-2.6077246458796113, -4.255468678229771],
            [-2.617975325749551, -4.245795368805967],
            [-2.616359611885866, -4.238830938784932],
            [-2.624382895630506, -4.231735405231426],
            [-2.6302981342778926, -4.231360859827896],
            [-2.6320802189275736, -4.225574429539288],
            [-2.6386598508065977, -4.2214401458267385],
            [-2.654618481269832, -4.198355683789884],
            [-2.6578797736231503, -4.1893987276197615],
            [-2.6560383191992907, -4.18470112042395],
            [-2.6602416926718226, -4.176098428120494],
            [-2.662748679654727, -4.1765049203508235],
            [-2.66883927141273, -4.173772648261939],
            [-2.6781666691802415, -4.166635780352193],
            [-2.678101657979496, -4.166509539334235],
            [-2.5326441735946914, -4.172037635502709],
            [-2.5309139039350836, -4.12861405502497],
            [-2.5273914898836676, -4.033740156152292],
            [-2.5256763471975696, -3.9901296768878813],
            [-2.5244639351396287, -3.953522298609357]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.41484018486473, "lat": 34.58794879485195 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40065"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01101820"
      },
      "bbox": [
        -2.6781666691802415, -4.356363127113989, -2.012787313471674,
        -3.8319873346783933
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8829409806541927, -2.9909393355124543],
            [-0.7969833095276149, -2.9925553376114453],
            [-0.7255575290219215, -2.994149754196953],
            [-0.6971608731959027, -2.994678336783468],
            [-0.626497271624102, -2.995640632482003],
            [-0.5103053320827607, -2.9978460024030475],
            [-0.454242280308407, -2.9988612151996166],
            [-0.4543884906577897, -3.0172473290772936],
            [-0.45521084510828314, -3.0644170622358957],
            [-0.4561272796171784, -3.1448424143227354],
            [-0.45622396045598945, -3.1734672303631357],
            [-0.45665515243839616, -3.1743859443294746],
            [-0.4572720163788498, -3.2324433383990527],
            [-0.4577392165437061, -3.261216667441817],
            [-0.4592990643954156, -3.348949408627551],
            [-0.5585996396202002, -3.3471823593139134],
            [-0.6155961693578261, -3.3465479227535853],
            [-0.7155595735004971, -3.3449647790897243],
            [-0.8014843988242863, -3.3438384277278193],
            [-0.8869926154866962, -3.342336328753527],
            [-0.8854537460036845, -3.247465232777027],
            [-0.88396599320486, -3.167132844439649],
            [-0.8860650418523717, -3.167074794742807],
            [-0.8841741161758988, -3.064498848924191],
            [-0.8829409806541927, -2.9909393355124543]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.40724425795038,
          "lat": 35.551508035690006
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40109"],
        "coty_name": ["Oklahoma"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oklahoma County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01101842"
      },
      "bbox": [
        -0.8869926154866962, -3.348949408627551, -0.454242280308407,
        -2.9909393355124543
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.870608416742229, 2.9274318883959465],
            [12.891624163479152, 2.9701079211569126],
            [12.922067080630619, 3.033040806187421],
            [12.960147155105979, 3.114296476529696],
            [13.001345913682844, 3.2020580466763824],
            [12.999984249772691, 3.210670329530369],
            [12.990292900131827, 3.2647178315800165],
            [12.977313845011578, 3.3361831762000116],
            [13.043541798296584, 3.3472114071793277],
            [13.124369717653012, 3.3603699797174063],
            [13.169404680826569, 3.3678809551682107],
            [13.235502380792726, 3.377447437092791],
            [13.28076054520659, 3.385428268750172],
            [13.290936421643123, 3.3249144114048375],
            [13.297985513451268, 3.2859427230504026],
            [13.311922250540691, 3.2107341231394035],
            [13.316213674274545, 3.2062724332192776],
            [13.319426306553567, 3.1991629407192343],
            [13.311559945786678, 3.2016695975647647],
            [13.302785276054486, 3.139371940235679],
            [13.297842146309824, 3.1024305275704505],
            [13.292064008239556, 3.0669092647465135],
            [13.280637918830745, 3.0035754938634325],
            [13.270959796330478, 2.9518707716101833],
            [13.248282509213814, 2.857864957152171],
            [13.24816551894682, 2.856851546912106],
            [13.245152391448805, 2.8593509797672487],
            [13.235510881075198, 2.87050598765398],
            [13.228009984749319, 2.8714711190969022],
            [13.211911938163079, 2.875756295555562],
            [13.202671074648734, 2.873039489702377],
            [13.200535291768245, 2.870858710844705],
            [13.20032143832691, 2.8653015996340776],
            [13.201807107099853, 2.861968407768339],
            [13.206044890674441, 2.8606466071574537],
            [13.20162317914706, 2.8490385615270193],
            [13.198968212045017, 2.8488438543615078],
            [13.197911633855115, 2.8436457599901566],
            [13.191266435757885, 2.840303170515583],
            [13.188278239912748, 2.8346531936424397],
            [13.187871436960753, 2.8310732552922677],
            [13.18369303889832, 2.8284109955453447],
            [13.179478298165034, 2.82909866206711],
            [13.175095331300563, 2.8338454952789287],
            [13.168120649133254, 2.8364435918633726],
            [13.164688509915267, 2.8327259152822415],
            [13.164169224346573, 2.826172437893405],
            [13.161123836763645, 2.819269787861778],
            [13.161229293481133, 2.8158999070445994],
            [13.15755895057856, 2.813339865087108],
            [13.151446357522765, 2.8167989617150444],
            [13.142774492231016, 2.8124366694944753],
            [13.137899454321731, 2.8161616429660503],
            [13.134959902301953, 2.8258600250531463],
            [13.138782103586495, 2.8309450239399445],
            [13.144333730164782, 2.8324778330145985],
            [13.141999764098971, 2.8365269215545412],
            [13.136042745258003, 2.83660356780975],
            [13.126525168174597, 2.8381875969894605],
            [13.117776713504929, 2.8356857419372146],
            [13.113178457032587, 2.838999590880917],
            [13.113371197065161, 2.8462661819421746],
            [13.110060709778462, 2.8487438253397213],
            [13.103960482551908, 2.8460754606715932],
            [13.096947745796795, 2.845229397628217],
            [13.08764154144127, 2.847280654383143],
            [13.08314166701925, 2.8474711730242492],
            [13.0790687123697, 2.8429141118641],
            [13.075239720771842, 2.8425595651881728],
            [13.071796488659414, 2.8452535451420946],
            [13.067452673337767, 2.8508433089793237],
            [13.063981628699652, 2.8535079790205184],
            [13.049185618029465, 2.857302734320301],
            [13.044139414778284, 2.8556368880516634],
            [13.038278080298866, 2.8567319707286853],
            [13.035147073147558, 2.8461535983255324],
            [13.029313024730891, 2.8394619914641535],
            [13.021907618524256, 2.8398328915197046],
            [13.020600620756193, 2.844220424832282],
            [13.022726373860477, 2.8503208996511824],
            [13.018442846632976, 2.8603721301012714],
            [13.01018359848671, 2.862678773927021],
            [13.006386035093362, 2.8557664572141768],
            [13.00089641403137, 2.8527285511332825],
            [12.997822452770196, 2.852752429436017],
            [12.996756280807906, 2.8567375598263998],
            [12.997142204165131, 2.8625580899947236],
            [12.994710018264318, 2.8681336941295426],
            [12.996905654680928, 2.8736538833695637],
            [12.99483523419011, 2.877621432656038],
            [12.99180002591664, 2.878730781913774],
            [12.98258051377391, 2.8746523674703695],
            [12.978182494013419, 2.8705775199993337],
            [12.976821334030761, 2.866925989736294],
            [12.973010430745676, 2.867430190735221],
            [12.970507554273174, 2.8752120529414373],
            [12.963622446651964, 2.8825940237035432],
            [12.959415115147575, 2.878696409886423],
            [12.961208908217143, 2.8663390784033336],
            [12.960642062168265, 2.8640962262335803],
            [12.955871966626201, 2.862199099765342],
            [12.950493333706659, 2.8636982551916947],
            [12.948146065743334, 2.8693879539882357],
            [12.94939835721247, 2.8806779214568974],
            [12.947741438485712, 2.8875851857900825],
            [12.942376550468978, 2.8861853003671465],
            [12.94194510849983, 2.883669927063158],
            [12.944094259410381, 2.8747141679525368],
            [12.9433196465164, 2.864998463542988],
            [12.940414148020611, 2.8615070700728915],
            [12.93497207270821, 2.8595276141712795],
            [12.924924929583952, 2.861114655270957],
            [12.921184816467004, 2.867448414441501],
            [12.918457791724956, 2.869749639256466],
            [12.914739949066998, 2.8762654147192563],
            [12.912706797657156, 2.8777058078623856],
            [12.906632613388076, 2.8728210294720085],
            [12.902450628832675, 2.8721114640776095],
            [12.900294890507599, 2.8745260398422947],
            [12.892306195764583, 2.88919950154028],
            [12.886894896674475, 2.8858857694528792],
            [12.881806779552095, 2.8789884736592763],
            [12.875965138721288, 2.8814208903597227],
            [12.876027494193407, 2.886730853013068],
            [12.872560122129427, 2.894124454556842],
            [12.872120773893855, 2.902513196955936],
            [12.8658552694109, 2.912877854730954],
            [12.867089639698689, 2.9197435081674863],
            [12.871721070975495, 2.9256756603126735],
            [12.870608416742229, 2.9274318883959465]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.08756344458169,
          "lat": 40.651993019654526
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42063"],
        "coty_name": ["Indiana"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Indiana County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01213673"
      },
      "bbox": [
        12.8658552694109, 2.8124366694944753, 13.319426306553567,
        3.385428268750172
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.97938703285413, 3.3837240806420716],
            [12.002683953236302, 3.3877662518024416],
            [12.110136835747811, 3.4071535876533217],
            [12.171327513259227, 3.418555897539226],
            [12.173126525240594, 3.407758572703303],
            [12.255217812993696, 3.4181249220328307],
            [12.29852788720809, 3.3816667359450907],
            [12.259982748068232, 3.303600471849011],
            [12.290242047499833, 3.159798060233354],
            [12.250930224426563, 3.1524736395432154],
            [12.198924845220665, 3.143188069103307],
            [12.137533477952356, 3.1318252737142855],
            [12.095393445224827, 3.124459513898092],
            [12.02414436814603, 3.1117810272119137],
            [12.019871887583495, 3.137819625966491],
            [12.015572947204685, 3.160360397499572],
            [12.012689630747683, 3.1810464546623725],
            [11.997386831317526, 3.2747720617249247],
            [11.988300531983446, 3.3299653110236416],
            [11.982480822350684, 3.364102924451264],
            [11.97938703285413, 3.3837240806420716]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.33472223906573, "lat": 40.99120742680207 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42073"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01213676"
      },
      "bbox": [
        11.97938703285413, 3.1117810272119137, 12.29852788720809,
        3.418555897539226
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.02227861087592, 3.3650634034789726],
            [15.0527917745751, 3.3485492390530425],
            [15.104706605598912, 3.3212976243057715],
            [15.22696605568441, 3.2566946266728003],
            [15.285365779558319, 3.225718057322277],
            [15.306038801731468, 3.224279852827077],
            [15.349547925417191, 3.1925831141442194],
            [15.355518687657826, 3.1887203383966494],
            [15.355384195185495, 3.1884076725460897],
            [15.313336088974506, 3.154282101298751],
            [15.252420975584858, 3.104260639378216],
            [15.209245433125833, 3.0873596747771312],
            [15.161363177790662, 3.067889521988842],
            [15.138493082999728, 3.0520011230703674],
            [15.116327065101895, 3.037139712695601],
            [15.07291374564272, 3.0067246875477207],
            [15.070856509328037, 3.005171881144755],
            [15.041971290698058, 3.0596282254320855],
            [15.015789835641854, 3.1096718423482486],
            [14.99989777117303, 3.1383768277172055],
            [14.986412954209708, 3.1635387812707285],
            [14.96033250256963, 3.2128119312991443],
            [14.933463774203942, 3.2639906151159948],
            [15.02227861087592, 3.3650634034789726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.45770711858056, "lat": 40.3672197869527 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42075"],
        "coty_name": ["Lebanon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lebanon County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01214034"
      },
      "bbox": [
        14.933463774203942, 3.005171881144755, 15.355518687657826,
        3.3650634034789726
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.919740512953155, 3.745069186289046],
            [11.97449253238329, 3.752038577416447],
            [11.97372373680337, 3.757161995294402],
            [11.983144976642134, 3.758531660185128],
            [11.984679014945986, 3.753554834154881],
            [12.022315755791192, 3.75865457735878],
            [12.038395013573208, 3.760465123549043],
            [12.062241227497756, 3.763643211089494],
            [12.10698537892844, 3.770260544597426],
            [12.183066054801811, 3.780819434355606],
            [12.18686913117937, 3.7810071061786767],
            [12.20996640244791, 3.7843931996330595],
            [12.208814519289529, 3.7901977734116103],
            [12.270150042627044, 3.80302601070156],
            [12.30038906363955, 3.809510812597334],
            [12.320723792608955, 3.6901190819011016],
            [12.336843967832856, 3.59545648160192],
            [12.347163154588895, 3.534861168905182],
            [12.349831239006468, 3.521437408842091],
            [12.354126731562385, 3.4939650990687854],
            [12.32794547072706, 3.437248497779617],
            [12.299794318964521, 3.3806043270742516],
            [12.29852788720809, 3.3816667359450907],
            [12.255217812993696, 3.4181249220328307],
            [12.173126525240594, 3.407758572703303],
            [12.171327513259227, 3.418555897539226],
            [12.110136835747811, 3.4071535876533217],
            [12.002683953236302, 3.3877662518024416],
            [11.97938703285413, 3.3837240806420716],
            [11.977946062565136, 3.391775014075635],
            [11.971751344515628, 3.4294983034980846],
            [11.959389051425998, 3.5066560439783636],
            [11.955987402947697, 3.525925056358338],
            [11.950053630775733, 3.562889392533264],
            [11.943889808390812, 3.5977964616778855],
            [11.928667984162825, 3.6918470987025604],
            [11.919740512953155, 3.745069186289046]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.25768789257226, "lat": 41.30220239612139 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42085"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01213678"
      },
      "bbox": [
        11.919740512953155, 3.3806043270742516, 12.354126731562385,
        3.809510812597334
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.00043370401079, -4.361258120581007],
            [12.051017052136519, -4.296771734612478],
            [12.085329354558397, -4.2528286064990075],
            [12.136322502452524, -4.187219615450628],
            [12.208468390935652, -4.094119249335108],
            [12.252934197152292, -4.036589551649006],
            [12.308814966025555, -3.9642370896535195],
            [12.311553519556611, -3.969383535128463],
            [12.31912599778774, -3.977186482683268],
            [12.331650287517604, -3.9796953885272695],
            [12.337638290224003, -3.985660824761487],
            [12.337456634316652, -3.9907415993321824],
            [12.345084031247598, -3.9992241976411087],
            [12.346649465675958, -4.004446248332649],
            [12.352195099952972, -4.005918528684365],
            [12.35867585891775, -4.01082999873894],
            [12.361320561589848, -4.016747572685794],
            [12.365096245021094, -4.017852713672894],
            [12.367131963277723, -4.020912025300496],
            [12.372626008806343, -4.021436279115742],
            [12.375476513322626, -4.024505696607344],
            [12.383206796803142, -4.021831444216971],
            [12.386259356090166, -4.026174948822363],
            [12.392095536568874, -4.028131804246881],
            [12.395760723064887, -4.027187648139884],
            [12.399755500692741, -4.030518730019272],
            [12.402457509769777, -4.029006500939288],
            [12.412861608899442, -4.031769574696628],
            [12.418485691272004, -4.035146070027044],
            [12.429136127924142, -4.045708144452769],
            [12.435080503784597, -4.048666202958733],
            [12.439295780014502, -4.054339589405238],
            [12.441154025060062, -4.065668885077986],
            [12.444330777220587, -4.0693547538585095],
            [12.447745556291965, -4.0756908412888055],
            [12.446865782116179, -4.077748960667053],
            [12.455807153471724, -4.086925037944123],
            [12.462195489767605, -4.089411256932038],
            [12.467913541739193, -4.08728422186627],
            [12.477259064769587, -4.091327687053098],
            [12.479917696317756, -4.090616929772217],
            [12.491606277767382, -4.0911795021399735],
            [12.49858445788059, -4.0863673131363445],
            [12.507073591105707, -4.090787106274095],
            [12.513772511650759, -4.092114093372612],
            [12.518052920047793, -4.090929004599562],
            [12.528263083216967, -4.094693503353599],
            [12.532275299906665, -4.094718533146398],
            [12.536972022575974, -4.097924271479906],
            [12.546723489792097, -4.099030822342673],
            [12.551510823170533, -4.102820581109914],
            [12.55463405253593, -4.102822071630519],
            [12.558739315577958, -4.107137410372583],
            [12.570004512849327, -4.111278871979957],
            [12.575221381709893, -4.10947220385139],
            [12.57854529215622, -4.106848686510697],
            [12.58326666086846, -4.109171619517172],
            [12.584089188653211, -4.112063355600047],
            [12.587563490781873, -4.114626151848937],
            [12.59498199330728, -4.115826376137239],
            [12.599701105900879, -4.11832976469339],
            [12.60635282701514, -4.119493051407411],
            [12.611994944910967, -4.123082033371903],
            [12.615929536005536, -4.123969305380963],
            [12.618524428889405, -4.127141083422683],
            [12.62642133592881, -4.127899785895175],
            [12.630286454623738, -4.1313474832281285],
            [12.634952843084408, -4.13160084194664],
            [12.639437114356873, -4.135242088273624],
            [12.64258865456397, -4.134127510160913],
            [12.654440524487232, -4.136419057730411],
            [12.656795280381264, -4.138562726986061],
            [12.589809713950642, -4.237836759428683],
            [12.552036942279871, -4.2930487821084],
            [12.530274963507763, -4.323461105479235],
            [12.52884130193761, -4.324460174931716],
            [12.467003759330627, -4.4026399527530256],
            [12.429433064680781, -4.448798580767538],
            [12.346468628540995, -4.553141778909355],
            [12.263478544388589, -4.657453571138281],
            [12.259712774476624, -4.661532222986887],
            [12.25357942898352, -4.65684799474283],
            [12.248055887526872, -4.644793747170308],
            [12.242322290075338, -4.640785391241498],
            [12.236764902409218, -4.642939571679065],
            [12.240234302211551, -4.646984169232899],
            [12.239991209042907, -4.65260116291868],
            [12.23564356136325, -4.654979138436908],
            [12.230912787488426, -4.655385157240643],
            [12.223857818936668, -4.653197351150435],
            [12.21921789210426, -4.654197804044906],
            [12.215570979875798, -4.652310741893796],
            [12.214552883756342, -4.646679234348856],
            [12.210935541812571, -4.642757334074678],
            [12.196889726632444, -4.639891190503412],
            [12.193049401030665, -4.635596112406115],
            [12.187237419696201, -4.63159589158118],
            [12.179663178958013, -4.6292792542944845],
            [12.174513053209433, -4.6240090494513835],
            [12.173266697067213, -4.620430499914942],
            [12.179200471158849, -4.618391732038391],
            [12.183076496391609, -4.615681230078057],
            [12.181455778289555, -4.61328563315454],
            [12.177333426458034, -4.61268464019442],
            [12.174943804713061, -4.606852653630629],
            [12.178144391025851, -4.604267589845617],
            [12.183149668216782, -4.607343062502755],
            [12.187141899259537, -4.611285210215897],
            [12.191170688729638, -4.606961316456043],
            [12.185032274139802, -4.606358184987696],
            [12.184262151406642, -4.598457479357108],
            [12.176093427151173, -4.592171941225329],
            [12.173587081198326, -4.586985217204882],
            [12.169275742278252, -4.588422330632897],
            [12.161415888997132, -4.587263139483759],
            [12.158773521195817, -4.584207920936111],
            [12.160006108063355, -4.573978207839936],
            [12.168485393415017, -4.572305005223552],
            [12.17072434043394, -4.56710041333764],
            [12.168992562504197, -4.564518058495068],
            [12.163578416226413, -4.562097513356073],
            [12.157846236906275, -4.570913727144027],
            [12.155602811051235, -4.570375145691518],
            [12.154088544705202, -4.56197604924132],
            [12.150262392678679, -4.560594023975903],
            [12.145796082164551, -4.567678888920048],
            [12.14359965152682, -4.573181632250777],
            [12.138302276992313, -4.566970397701327],
            [12.140132975071536, -4.561826702303574],
            [12.136588209845234, -4.55890535885442],
            [12.13262453747658, -4.562134641379296],
            [12.130535588416311, -4.560518084621898],
            [12.132823551766558, -4.555763985354731],
            [12.127507764355125, -4.555998262523987],
            [12.123880826946852, -4.552708126891401],
            [12.125033861727323, -4.547335819994482],
            [12.120122329086886, -4.542654928449974],
            [12.120417319731898, -4.548311790864855],
            [12.118234017884891, -4.5529150257170325],
            [12.11881542135861, -4.5573154820592086],
            [12.114252738284598, -4.560509183467344],
            [12.116346648244662, -4.552079877510481],
            [12.106627389689384, -4.5471337651027675],
            [12.109149747894103, -4.53823777277825],
            [12.112444687103054, -4.537236897824631],
            [12.112851379305305, -4.5331924154159475],
            [12.109398984369761, -4.533079237309426],
            [12.105240624679295, -4.540342577442464],
            [12.101130942705128, -4.53632673300806],
            [12.093719015162662, -4.538805727898887],
            [12.087766366730875, -4.538269662156064],
            [12.08726879390644, -4.535502395752359],
            [12.090499087228629, -4.528914799133057],
            [12.089638336348814, -4.525969063988524],
            [12.080829525465344, -4.519918731756989],
            [12.078537900452455, -4.513562667420965],
            [12.083752779961431, -4.5108600530650005],
            [12.088389195543877, -4.513824333656921],
            [12.091788454858516, -4.514105531336351],
            [12.095364179988376, -4.5105548673904545],
            [12.09565686729586, -4.507466925359693],
            [12.08983350944282, -4.502308879103969],
            [12.083820033556805, -4.485781053013814],
            [12.075164010252, -4.480540530671083],
            [12.075456987200313, -4.475057354812157],
            [12.08266343819353, -4.47625792801882],
            [12.086876870524824, -4.474657307177189],
            [12.091063107338673, -4.471290483012991],
            [12.09655691337889, -4.4737817582957895],
            [12.100838663612251, -4.472241211269422],
            [12.102412611545834, -4.467426502216889],
            [12.101119490520368, -4.4651506950248185],
            [12.092317539931779, -4.46404105047431],
            [12.082513421196445, -4.4583062499969754],
            [12.082614927839046, -4.453695518019621],
            [12.090589964431354, -4.45052824406301],
            [12.09342041697214, -4.4484770291504825],
            [12.095719498792501, -4.4423077755255544],
            [12.093569619827708, -4.437385282766089],
            [12.0889473521552, -4.4323890838538205],
            [12.081236405065376, -4.419489156083985],
            [12.074042995459616, -4.4150774609224905],
            [12.06345920897005, -4.413198829277718],
            [12.045261689304093, -4.406866644473319],
            [12.033615884279612, -4.405141722845888],
            [12.028902997622511, -4.403302276241221],
            [12.023668085257011, -4.396262840560079],
            [12.023158701885437, -4.389716256653871],
            [12.021340549665263, -4.386254146941859],
            [12.011320936970328, -4.371800572537769],
            [12.005688944835947, -4.369385331464184],
            [12.002674949581795, -4.3626239888811655],
            [12.00043370401079, -4.361258120581007]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.63472914876336, "lat": 33.54421464221079 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45003"],
        "coty_name": ["Aiken"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Aiken County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01247979"
      },
      "bbox": [
        12.00043370401079, -4.661532222986887, 12.656795280381264,
        -3.9642370896535195
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.379271758631458, 4.418147819754032],
            [-0.2859923229820673, 4.417387768499162],
            [-0.20755177522855925, 4.416859563081841],
            [-0.12150581044112073, 4.416015677132851],
            [-0.12214767962454225, 4.328712598463952],
            [-0.12269915515893284, 4.256462641775715],
            [-0.1241942809882835, 4.154400903846152],
            [-0.12508047364876004, 4.066866139993591],
            [-0.12513660979383304, 4.0353672820740485],
            [-0.13476762036141327, 4.03908254859749],
            [-0.14213983069607308, 4.039815755900775],
            [-0.1522341343881237, 4.0435003094362925],
            [-0.1645819208281535, 4.052415234942305],
            [-0.1735718057712307, 4.055807801711719],
            [-0.18382465300691392, 4.057032498577222],
            [-0.19831061779033698, 4.06577737668773],
            [-0.2067144683616991, 4.063902946670662],
            [-0.21787096925204763, 4.055936662039786],
            [-0.22093203321863428, 4.051742628263625],
            [-0.234279640972145, 4.051454750017987],
            [-0.23986480743611524, 4.052981269924945],
            [-0.2414797815436975, 4.059473733799642],
            [-0.23806708549915354, 4.068945932420319],
            [-0.23798130612553567, 4.073013413830347],
            [-0.24342576593127896, 4.086771537529242],
            [-0.24809815644735042, 4.0908763122081995],
            [-0.25307998505913554, 4.093168258265501],
            [-0.26084378252071977, 4.092171988216643],
            [-0.2776099516059527, 4.0944741462768715],
            [-0.28806939210502486, 4.0967067219803175],
            [-0.29026385893814116, 4.0989300898736],
            [-0.3040451866687848, 4.103378728543476],
            [-0.31380905746807575, 4.105496149886643],
            [-0.3183732029442128, 4.105663742518924],
            [-0.32833250017987575, 4.103524729369013],
            [-0.3361228723612163, 4.102890416262157],
            [-0.34742800306513494, 4.103071561297807],
            [-0.36177889489174675, 4.105788262228017],
            [-0.36403191242578425, 4.108388916857733],
            [-0.3666640325978574, 4.117385044682698],
            [-0.3756696233073524, 4.129672611853849],
            [-0.3826123133941894, 4.1339383459870955],
            [-0.3815321898079697, 4.244092441758563],
            [-0.3804018178305696, 4.331101573115853],
            [-0.379271758631458, 4.418147819754032]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.97563711523405, "lat": 42.91461685089892 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46027"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01265764"
      },
      "bbox": [
        -0.3826123133941894, 4.0353672820740485, -0.12150581044112073,
        4.418147819754032
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.972486141947519, -2.689248690075371],
            [9.017011781811302, -2.6251822173711896],
            [9.05476153729017, -2.5675390239475484],
            [9.06445268218074, -2.551941127327168],
            [9.08190479156204, -2.520917413574073],
            [9.080632498215714, -2.516414770154105],
            [9.076736537264159, -2.514032517621558],
            [9.077034817736308, -2.5047476468876875],
            [9.078783463264111, -2.4994785205553867],
            [9.079018149726833, -2.4918280684417704],
            [9.083177868352504, -2.4891507360805747],
            [9.07885461957791, -2.486980433754992],
            [9.082117725309594, -2.4815495124728306],
            [9.085694203828188, -2.4783749246685476],
            [9.08590618464225, -2.475440833725028],
            [9.156664752867133, -2.46465377105756],
            [9.205763346495061, -2.4573741936673055],
            [9.221579468411017, -2.4650674289405554],
            [9.230479795574213, -2.4641162991913337],
            [9.239799255801428, -2.4557758910980008],
            [9.249712951913375, -2.4547966719053007],
            [9.255281955481433, -2.4497842060055177],
            [9.263540997341416, -2.4615048113935107],
            [9.262967334693471, -2.4682698035613893],
            [9.265012266574148, -2.473844481882387],
            [9.268109957469761, -2.474164689617701],
            [9.2903694111834, -2.464757164401452],
            [9.295089065567613, -2.463160355615174],
            [9.34558732527632, -2.4425500215674636],
            [9.352757094620218, -2.448480110896853],
            [9.356325073789986, -2.4480037093061653],
            [9.347951564567005, -2.4629567963895784],
            [9.306692558882684, -2.5351315587671532],
            [9.313960462979653, -2.5366763937511494],
            [9.31417684340368, -2.54136233863877],
            [9.302955041032034, -2.541702895649218],
            [9.271424689443654, -2.596801794406342],
            [9.267854929237016, -2.6037170218063856],
            [9.225195694117573, -2.6566233670949195],
            [9.226986923682322, -2.686658921808105],
            [9.229528114960237, -2.679033731100509],
            [9.232844473161652, -2.6834033383805806],
            [9.236507936829614, -2.6935460990813764],
            [9.228959056436093, -2.6963348486520426],
            [9.231606994085258, -2.6982470704965107],
            [9.225668538838612, -2.70381453908308],
            [9.22085866175522, -2.7001123627107817],
            [9.218513226729728, -2.7033379113354257],
            [9.211874374809744, -2.71629873944791],
            [9.206621459600173, -2.7310807750866],
            [9.205365038128853, -2.738753689568491],
            [9.208627147254873, -2.743130242608594],
            [9.213431938736738, -2.7391932411772353],
            [9.216692870438141, -2.7483799318814635],
            [9.22047544280334, -2.7478647306885424],
            [9.22636799181233, -2.7522348701625847],
            [9.229673521481027, -2.7531840497281266],
            [9.216200207088988, -2.771996363118417],
            [9.219560522322693, -2.7722651893406516],
            [9.219838030072195, -2.7793642652276476],
            [9.216399523760623, -2.7794147762254164],
            [9.214251985398096, -2.7746876758132553],
            [9.206791726198544, -2.7863168095670963],
            [9.194957972408911, -2.7843666528685582],
            [9.189990658523504, -2.7780759494711442],
            [9.180469016480805, -2.8070137076539634],
            [9.175400034867035, -2.8251534122582274],
            [9.173802684360679, -2.832646924924137],
            [9.155371205943371, -2.8847989992190013],
            [9.130698555662969, -2.8677250027725774],
            [9.077188782922105, -2.829838026952018],
            [9.03644745316456, -2.7956956197898477],
            [8.997350688210458, -2.762673007776345],
            [8.99140447827032, -2.7505625225504557],
            [8.989069778736122, -2.7492455320501197],
            [8.98907914881646, -2.743711662235605],
            [8.991559764791106, -2.7375942482923783],
            [8.983624037082249, -2.736004564874802],
            [8.980357586319961, -2.7295262313516053],
            [8.971210567139757, -2.7282774760735435],
            [8.965398122846437, -2.7156622938373696],
            [8.968381470811865, -2.711651476231512],
            [8.968135022448735, -2.7048519293199424],
            [8.970362627767452, -2.694611176906763],
            [8.972486141947519, -2.689248690075371]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.20520170257153, "lat": 35.59628625929541 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47007"],
        "coty_name": ["Bledsoe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bledsoe County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01639725"
      },
      "bbox": [
        8.965398122846437, -2.8847989992190013, 9.356325073789986,
        -2.4425500215674636
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.325146811414578, -2.995594922485166],
            [8.32554795804156, -2.9916039632734597],
            [8.333426311001247, -2.991420387088577],
            [8.333105704000214, -2.9835708662539133],
            [8.341363488917468, -2.982872385467478],
            [8.341713468070482, -2.985775507429107],
            [8.347526474752874, -2.9855963463684816],
            [8.350998535050593, -2.98301049653999],
            [8.351056566645623, -2.978851970561608],
            [8.357620577304695, -2.978794130453855],
            [8.361252603068268, -2.977147345747333],
            [8.363966613475396, -2.9815850503827472],
            [8.366443035462034, -2.982460752674843],
            [8.368059468254625, -2.9868536187936217],
            [8.374532295516595, -2.986557704932177],
            [8.376558003748508, -2.9903996794429326],
            [8.38266201006978, -2.984200896951467],
            [8.378250786889877, -2.9790783402007017],
            [8.394640729449886, -2.9641180329191146],
            [8.394913773502052, -2.9690843362333026],
            [8.404506840948134, -2.969180470408918],
            [8.405349463495874, -2.9579144825848647],
            [8.447456542253743, -2.9614329037524447],
            [8.504998978416346, -2.9666220397643204],
            [8.51263482682005, -2.9657190249879894],
            [8.50837130828694, -2.97496049196928],
            [8.516331549563814, -2.9749429472742497],
            [8.53383915566901, -2.9883251073868844],
            [8.53595280556184, -2.992800724398282],
            [8.543529169979774, -2.991523329544061],
            [8.545461778862327, -2.99339101364111],
            [8.549217300439393, -2.98916006430928],
            [8.553226004384268, -2.9874145119513136],
            [8.556911467122998, -2.9930942378563823],
            [8.565107237087346, -2.994073199183983],
            [8.567649452528203, -2.989423596448937],
            [8.57071542411907, -2.9987647327511766],
            [8.57304740213821, -2.995445119786326],
            [8.581002249770842, -2.994854371432923],
            [8.582272115923445, -2.999261385832804],
            [8.580155678226737, -3.003543140189811],
            [8.584826459407767, -3.003956612891358],
            [8.587513514047753, -3.0020962265094706],
            [8.591986582683584, -3.0019588582404158],
            [8.595462742936043, -3.0087330371374095],
            [8.599735449025717, -3.0108270893391134],
            [8.604427345636102, -3.008622396195781],
            [8.60969224828964, -3.0108150822443807],
            [8.615617296226262, -3.023344642059738],
            [8.629819418735254, -3.0416871307633846],
            [8.635768757151528, -3.050394215557724],
            [8.649393828484337, -3.0732703052357753],
            [8.649706272428647, -3.0762405688207086],
            [8.657533958372124, -3.075522679265074],
            [8.661505986015978, -3.112136623833927],
            [8.667864897943055, -3.1753375845587786],
            [8.681941860440702, -3.307790181655701],
            [8.517727473593075, -3.3239131287858488],
            [8.448295736297805, -3.330623626587444],
            [8.32025238500137, -3.3428329973846953],
            [8.31419711692957, -3.343401563215087],
            [8.308693624546779, -3.3018196312935815],
            [8.307574944533068, -3.2717100273622415],
            [8.300743935656019, -3.2072777362909664],
            [8.304470468029983, -3.199471788383553],
            [8.297114406905287, -3.197546010692537],
            [8.286497873022014, -3.1889910026129122],
            [8.290503760646255, -3.185581058464689],
            [8.299738320942213, -3.187641636841818],
            [8.29929868775213, -3.1837777572311063],
            [8.296788055804338, -3.1812530070147247],
            [8.29576723717555, -3.173031355279936],
            [8.297464498678789, -3.1654504233500895],
            [8.301127399492163, -3.1613497370630625],
            [8.306019066841088, -3.16140479276151],
            [8.309854314101269, -3.1595781369132405],
            [8.30901978326572, -3.1554122485293905],
            [8.301136528670927, -3.152494127842837],
            [8.304180340127207, -3.145715659657713],
            [8.301314813571576, -3.143097652501889],
            [8.29882114657941, -3.1380977304295756],
            [8.300816156916396, -3.1352827985382037],
            [8.306578298124208, -3.133995281462949],
            [8.304531866245869, -3.1283321077017403],
            [8.30569626009103, -3.1261880941389855],
            [8.31220952098803, -3.1248080742831528],
            [8.309337031849582, -3.1141921959239958],
            [8.304859242341546, -3.1157710188612033],
            [8.29992843321244, -3.1156158744579625],
            [8.29832627820251, -3.118103251843586],
            [8.29449472239603, -3.1185067263817245],
            [8.292795340486109, -3.1141786855768347],
            [8.2989118658612, -3.1131874708315332],
            [8.298879715706375, -3.1108559119505528],
            [8.307635999666738, -3.110189563984436],
            [8.305304587096249, -3.101674708778228],
            [8.299796996665208, -3.1018874456335763],
            [8.301823490683217, -3.0981212523028034],
            [8.30592581556222, -3.0967884388724327],
            [8.311663600368854, -3.092945950348914],
            [8.315086130657027, -3.089182150366405],
            [8.31875290234697, -3.0892318025682286],
            [8.319870819800641, -3.080692535968348],
            [8.313111700935465, -3.0745783615662425],
            [8.312077108161473, -3.0717700546746776],
            [8.31505401034646, -3.0696434737478184],
            [8.313879902599805, -3.063180754382386],
            [8.316937531064514, -3.062057373517527],
            [8.317200546931073, -3.0582836951176353],
            [8.322602943105537, -3.057020966320193],
            [8.32622971394009, -3.0582691430380815],
            [8.326186856869825, -3.0531090369973106],
            [8.320588127667657, -3.0497542643581967],
            [8.320446567086796, -3.044122207278545],
            [8.32551739421203, -3.0440344232743732],
            [8.326076750583328, -3.0379698341466077],
            [8.325025177692876, -3.0319803817000155],
            [8.333651258372706, -3.0329518951554024],
            [8.336676099742146, -3.0224582325561173],
            [8.334176308866901, -3.0224984358064675],
            [8.334775827936097, -3.0132685962919306],
            [8.340566733264568, -3.012950657095576],
            [8.339072280637057, -3.009797747322621],
            [8.339142213152583, -3.0038061915677754],
            [8.33518178531958, -3.003536914781943],
            [8.330634701456953, -3.0008950855532253],
            [8.32676773851088, -3.001436117017793],
            [8.325146811414578, -2.995594922485166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.09227383467032,
          "lat": 35.155065893521346
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47051"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01639744"
      },
      "bbox": [
        8.286497873022014, -3.343401563215087, 8.681941860440702,
        -2.9579144825848647
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.797985463050065, -2.724110281388126],
            [5.798010774686345, -2.7274936301750734],
            [5.805637082829555, -2.7343727905840582],
            [5.809581413134358, -2.74229950046355],
            [5.807003475996131, -2.7445303338886955],
            [5.812914863036332, -2.750271828972276],
            [5.815720861315009, -2.74886552608224],
            [5.820127655822002, -2.7528618618067062],
            [5.824252210553972, -2.753106735795282],
            [5.829487639337434, -2.759393659042708],
            [5.838455935265673, -2.7664500978008877],
            [5.839971964599592, -2.7652166494685995],
            [5.848075574792675, -2.764774662154008],
            [5.851211046095375, -2.766735984312843],
            [5.855986056248119, -2.7649739739438197],
            [5.864270191131053, -2.774882957912713],
            [5.867976765191166, -2.7767799677726437],
            [5.870439739977714, -2.782380343012239],
            [5.895310069419801, -2.7826598813746117],
            [5.908885114092789, -2.7838218162289152],
            [5.924576694161527, -2.786366966304138],
            [5.9367306227384296, -2.7899902822537355],
            [5.950044128376343, -2.795317016099368],
            [5.96472795396052, -2.8028033261200376],
            [5.976446726230624, -2.810271660609674],
            [5.98815987480069, -2.81940905371684],
            [5.998245889926365, -2.8294892288743987],
            [6.003807627087894, -2.826911417302363],
            [6.007488628857987, -2.8293070299182155],
            [6.010878374169474, -2.826291105821792],
            [6.013563069546717, -2.828841654948776],
            [6.025435499427331, -2.8297616622112534],
            [6.03177681012965, -2.833090155005891],
            [6.036786247181812, -2.8333170047803873],
            [6.03808604511216, -2.855161426326156],
            [6.038707581193387, -2.8711999517898765],
            [6.042494630010738, -2.9546711362129323],
            [6.046032274437411, -3.027242161626031],
            [6.04606169262058, -3.032338565349623],
            [6.048473792032745, -3.096411709934071],
            [5.964861512452527, -3.101054530497316],
            [5.966319441083563, -3.13699635425831],
            [5.914940883298674, -3.139533377085628],
            [5.8342802031214696, -3.1431098009081953],
            [5.834303294517353, -3.1440039016368564],
            [5.760765175647042, -3.1475037677051207],
            [5.760781332790935, -3.146427259588885],
            [5.7319873893632, -3.1474748120205143],
            [5.728676914975669, -3.0747959809974907],
            [5.7255190445884425, -3.002977606019563],
            [5.716696822970609, -3.003148067390594],
            [5.71643334230235, -2.9934087615735208],
            [5.718475663798058, -2.989134719218731],
            [5.716948803649192, -2.985736848304595],
            [5.708188713832697, -2.979911921816649],
            [5.71209824433159, -2.975825118026082],
            [5.704200012930735, -2.9739534004649126],
            [5.700787329325666, -2.9753575830960313],
            [5.697221431468661, -2.9705221925159178],
            [5.701000083909035, -2.9691557246077567],
            [5.703203930147482, -2.965363766311183],
            [5.7072523115798806, -2.9641299919588593],
            [5.707496092415211, -2.9609054378185142],
            [5.711913951816855, -2.956050327141764],
            [5.722043028502188, -2.9540691218927377],
            [5.721345341686319, -2.923963178825102],
            [5.718905427790602, -2.8659190334683613],
            [5.729871848328562, -2.8653267681460064],
            [5.742867841440942, -2.8166126344557276],
            [5.742368203087944, -2.8063188529851093],
            [5.745945985191284, -2.805986567797389],
            [5.745622505275636, -2.7987407082993463],
            [5.735431890811123, -2.798898437451377],
            [5.73452601270446, -2.7807790977015956],
            [5.739816556154201, -2.775032449517365],
            [5.739197197008323, -2.76703580836306],
            [5.742897763279081, -2.7600871690139193],
            [5.7475960804296955, -2.757331997569233],
            [5.747349870556859, -2.750453094203276],
            [5.748706879820785, -2.746383163158186],
            [5.754677055955716, -2.7417276302891262],
            [5.759019101654817, -2.7357032923688647],
            [5.7609441819171625, -2.7216173887539603],
            [5.771316296799996, -2.72235538577348],
            [5.79177840307464, -2.7230637910997686],
            [5.797985463050065, -2.724110281388126]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.2837961150735, "lat": 35.58321657137878 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47075"],
        "coty_name": ["Haywood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haywood County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01639753"
      },
      "bbox": [
        5.697221431468661, -3.1475037677051207, 6.048473792032745,
        -2.7216173887539603
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.416541422820902, -1.9865885183325644],
            [6.438217359715151, -1.9852443341664423],
            [6.495960694675151, -1.9809675512448046],
            [6.563889457282864, -1.9757361244487448],
            [6.686822211140475, -1.967233542837435],
            [6.7254931733765595, -1.9645169496385155],
            [6.784402336641367, -1.9610328442504188],
            [6.782165670689982, -1.9689782350051008],
            [6.783070015993529, -1.9740082986649243],
            [6.786880164310426, -1.983025967347596],
            [6.787603544497827, -1.9869523527294168],
            [6.786660576516616, -1.9950497887134344],
            [6.782074508405527, -2.007412600707671],
            [6.782390551617981, -2.0148981848573806],
            [6.785163993327171, -2.0195954546089863],
            [6.800198483503355, -2.031997982846111],
            [6.804627893664995, -2.0371054025578226],
            [6.807716887287088, -2.0477768755707353],
            [6.815656167709249, -2.0575050589676556],
            [6.822548557421408, -2.061357618203061],
            [6.830978276127277, -2.075457040814543],
            [6.835480566580668, -2.0846952336960007],
            [6.838840061245846, -2.0895092941256004],
            [6.845534693654096, -2.094591481422212],
            [6.844809918352333, -2.0958108095610037],
            [6.812944339157218, -2.0976603501407953],
            [6.768699625020278, -2.1020167549510425],
            [6.763856573549616, -2.1013190860316464],
            [6.761170964603459, -2.106053489086539],
            [6.764186925236811, -2.111909265303297],
            [6.763899665080408, -2.116249479530879],
            [6.766627961243651, -2.1212717188601355],
            [6.762675563129891, -2.124527405577127],
            [6.764272140949067, -2.1322636116940967],
            [6.759920891978985, -2.1353356594976525],
            [6.762297932354909, -2.1383809679115156],
            [6.760826467446644, -2.151496324474902],
            [6.763742913349466, -2.153338708490106],
            [6.767079892799919, -2.1628043348800414],
            [6.771263970813535, -2.165370866849586],
            [6.769448204165835, -2.1689019250948856],
            [6.771905380608207, -2.17327634812907],
            [6.771396534533392, -2.180880840186455],
            [6.773440296096951, -2.184800751187007],
            [6.7739036877791, -2.1904576677917587],
            [6.776639132465739, -2.1924057973939988],
            [6.78079168783994, -2.2012783246126197],
            [6.780938389758534, -2.2042813379267185],
            [6.778043646539329, -2.208427708892489],
            [6.773929852140769, -2.2076926856384307],
            [6.770552043717795, -2.2097635748238424],
            [6.767316762931618, -2.208209069772357],
            [6.765614470788837, -2.2112151260873882],
            [6.769801464195798, -2.2193554065829213],
            [6.767841931574844, -2.2308887761002274],
            [6.764521226027434, -2.2313017064036305],
            [6.761289567696087, -2.2347393666857545],
            [6.759611825667281, -2.2403451913993977],
            [6.7517185119474865, -2.2403702276908213],
            [6.7521744749750106, -2.242449671948131],
            [6.7477039846567, -2.2456422967654146],
            [6.7421395318833985, -2.2464234372765413],
            [6.742040954898293, -2.2556829049729554],
            [6.739954884536038, -2.2667190752280972],
            [6.7377008486310475, -2.2690724895780554],
            [6.728945049166168, -2.2823165187996075],
            [6.726219082613578, -2.289303991495712],
            [6.718213613084966, -2.296659178383335],
            [6.717026938288717, -2.300343513804708],
            [6.721527636567929, -2.3049075983280307],
            [6.714757732530203, -2.3109518596798124],
            [6.715630501244287, -2.3204722203107933],
            [6.711671053057545, -2.3236977187557755],
            [6.708485682595699, -2.3225392964134826],
            [6.70515262614241, -2.3284308780402183],
            [6.705746639444025, -2.330416978094454],
            [6.702681965560869, -2.3371180541916248],
            [6.698180292093433, -2.3395089290841513],
            [6.695278977299869, -2.346178919808089],
            [6.6891434623634005, -2.3503597958232922],
            [6.687708271385087, -2.3244880162412165],
            [6.61339478025957, -2.328618003621101],
            [6.56090589211123, -2.332222971700576],
            [6.5572262217127255, -2.332255595654121],
            [6.478823876240561, -2.337360705509304],
            [6.478736291398707, -2.336359003880454],
            [6.462691937732201, -2.337501012340016],
            [6.433138416314132, -2.3388287649251094],
            [6.430165353935471, -2.260832400651058],
            [6.42723169500715, -2.195443967271294],
            [6.423172509757799, -2.120400777202479],
            [6.418351936267484, -2.0247170557205973],
            [6.416541422820902, -1.9865885183325644]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.30120854289345, "lat": 36.33174598567507 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47079"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01639755"
      },
      "bbox": [
        6.416541422820902, -2.3503597958232922, 6.845534693654096,
        -1.9610328442504188
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.110774119591982, -2.99590141371166],
            [8.115505243571743, -2.992894430046206],
            [8.118925515239301, -2.992649701263488],
            [8.124574504970393, -2.9890541723780024],
            [8.131041703721916, -2.9885869364583217],
            [8.136534428878528, -2.9858363589611066],
            [8.142530255451637, -2.9868228095621254],
            [8.146447535624427, -2.9941989965886693],
            [8.148137015605545, -3.0015160853387157],
            [8.152076698935137, -3.00258267508283],
            [8.151609814417371, -3.0072841165562756],
            [8.159538779193705, -3.008537999438071],
            [8.165821284381135, -3.0145920566198714],
            [8.166441460793779, -3.017702916567503],
            [8.174827024063463, -3.0199695198906515],
            [8.179484603845975, -3.02345231635442],
            [8.183695003093165, -3.0211153682333842],
            [8.193356067685905, -3.022173096975705],
            [8.197240309176642, -3.0235387635787365],
            [8.201074971751018, -3.0187721724184238],
            [8.204431493047169, -3.0123646664350443],
            [8.204923779585366, -2.994668484882624],
            [8.21204079697908, -2.9951778342220305],
            [8.21408774396235, -2.991325206946024],
            [8.217437577567168, -2.992302416307889],
            [8.220340463771356, -2.9896792975734163],
            [8.235423475032762, -2.990207258700322],
            [8.237144199375717, -2.986386981359958],
            [8.231840733230143, -2.9852190207237626],
            [8.232146564496407, -2.9817641775675523],
            [8.240043838875605, -2.9860610838370953],
            [8.242764522818272, -2.975239619489303],
            [8.253247065374177, -2.97438615609008],
            [8.25932892625709, -2.9679964674256216],
            [8.260801328636147, -2.9704795494483953],
            [8.266449349583379, -2.969296288582854],
            [8.26658500730941, -2.966649353461543],
            [8.261283528727443, -2.9648604277031185],
            [8.26599465437208, -2.9576961399097947],
            [8.276145040082568, -2.951292799273991],
            [8.279513203709307, -2.9477089228094715],
            [8.29271836481889, -2.939717792441861],
            [8.296225909342756, -2.92393631423108],
            [8.303480150524763, -2.9200359820639985],
            [8.320138618851797, -2.916200452360556],
            [8.3198724472856, -2.919640220092257],
            [8.325384365875971, -2.919143704983092],
            [8.325819472562863, -2.9246972182667292],
            [8.31835338580136, -2.924644903416724],
            [8.318877777488986, -2.931205091434919],
            [8.313869533443944, -2.9315288247268687],
            [8.304783795449517, -2.943121828698848],
            [8.326364656779534, -2.943087548726024],
            [8.326596709823686, -2.9480752742008645],
            [8.323782284442032, -2.9480342759850826],
            [8.324512486438808, -2.9578840047387196],
            [8.312563339543463, -2.9594144295240423],
            [8.312513801129741, -2.963673279439833],
            [8.321430923570528, -2.963467144931911],
            [8.325041022375055, -2.970897019395166],
            [8.336656130241847, -2.97162436709867],
            [8.336670760538304, -2.980434280613995],
            [8.320701458406814, -2.9910026728761356],
            [8.325146811414578, -2.995594922485166],
            [8.32676773851088, -3.001436117017793],
            [8.330634701456953, -3.0008950855532253],
            [8.33518178531958, -3.003536914781943],
            [8.339142213152583, -3.0038061915677754],
            [8.339072280637057, -3.009797747322621],
            [8.340566733264568, -3.012950657095576],
            [8.334775827936097, -3.0132685962919306],
            [8.334176308866901, -3.0224984358064675],
            [8.336676099742146, -3.0224582325561173],
            [8.333651258372706, -3.0329518951554024],
            [8.325025177692876, -3.0319803817000155],
            [8.326076750583328, -3.0379698341466077],
            [8.32551739421203, -3.0440344232743732],
            [8.320446567086796, -3.044122207278545],
            [8.320588127667657, -3.0497542643581967],
            [8.326186856869825, -3.0531090369973106],
            [8.32622971394009, -3.0582691430380815],
            [8.322602943105537, -3.057020966320193],
            [8.317200546931073, -3.0582836951176353],
            [8.316937531064514, -3.062057373517527],
            [8.313879902599805, -3.063180754382386],
            [8.31505401034646, -3.0696434737478184],
            [8.312077108161473, -3.0717700546746776],
            [8.313111700935465, -3.0745783615662425],
            [8.319870819800641, -3.080692535968348],
            [8.31875290234697, -3.0892318025682286],
            [8.315086130657027, -3.089182150366405],
            [8.311663600368854, -3.092945950348914],
            [8.30592581556222, -3.0967884388724327],
            [8.301823490683217, -3.0981212523028034],
            [8.299796996665208, -3.1018874456335763],
            [8.305304587096249, -3.101674708778228],
            [8.307635999666738, -3.110189563984436],
            [8.298879715706375, -3.1108559119505528],
            [8.2989118658612, -3.1131874708315332],
            [8.292795340486109, -3.1141786855768347],
            [8.29449472239603, -3.1185067263817245],
            [8.29832627820251, -3.118103251843586],
            [8.29992843321244, -3.1156158744579625],
            [8.304859242341546, -3.1157710188612033],
            [8.309337031849582, -3.1141921959239958],
            [8.31220952098803, -3.1248080742831528],
            [8.30569626009103, -3.1261880941389855],
            [8.304531866245869, -3.1283321077017403],
            [8.306578298124208, -3.133995281462949],
            [8.300816156916396, -3.1352827985382037],
            [8.29882114657941, -3.1380977304295756],
            [8.301314813571576, -3.143097652501889],
            [8.304180340127207, -3.145715659657713],
            [8.301136528670927, -3.152494127842837],
            [8.30901978326572, -3.1554122485293905],
            [8.309854314101269, -3.1595781369132405],
            [8.306019066841088, -3.16140479276151],
            [8.301127399492163, -3.1613497370630625],
            [8.297464498678789, -3.1654504233500895],
            [8.29576723717555, -3.173031355279936],
            [8.296788055804338, -3.1812530070147247],
            [8.29929868775213, -3.1837777572311063],
            [8.299738320942213, -3.187641636841818],
            [8.290503760646255, -3.185581058464689],
            [8.286497873022014, -3.1889910026129122],
            [8.297114406905287, -3.197546010692537],
            [8.304470468029983, -3.199471788383553],
            [8.300743935656019, -3.2072777362909664],
            [8.294546891226272, -3.2120422324831526],
            [8.289963863567722, -3.211973931910759],
            [8.285195841081833, -3.2069355645585538],
            [8.27902807197483, -3.2069318808935297],
            [8.2750995525652, -3.200901472501656],
            [8.273931785419203, -3.1912473632505898],
            [8.270432575063657, -3.191772331440656],
            [8.268536858428119, -3.1968029251123355],
            [8.26924209924515, -3.204454082490836],
            [8.270497476174725, -3.206414820521924],
            [8.2670291854066, -3.2147977713682376],
            [8.262261144816126, -3.2138315303554954],
            [8.259518200413144, -3.20976334913017],
            [8.257932408771813, -3.202490159477938],
            [8.259195480361315, -3.1974644707636712],
            [8.256729711022512, -3.1942800717178264],
            [8.256088500433549, -3.1794854272334323],
            [8.25353535714027, -3.1688599718816217],
            [8.255598964114345, -3.166727023991856],
            [8.25345798962356, -3.1632999069242755],
            [8.253301950198738, -3.159367551565557],
            [8.249700015360226, -3.1559873728328425],
            [8.24963293960325, -3.1505273898200588],
            [8.24404044821795, -3.1419833212849135],
            [8.243850392684305, -3.1345119249314415],
            [8.230703047166125, -3.111695447180805],
            [8.229995850406183, -3.104733728880895],
            [8.216626222644186, -3.1034199866622774],
            [8.215037405607132, -3.1070056222115556],
            [8.217423352224959, -3.113238757618623],
            [8.213036735731398, -3.1138289561016004],
            [8.208577319027084, -3.1070559977364223],
            [8.204359741176226, -3.105397335048564],
            [8.203893001689766, -3.101583137634291],
            [8.209798570729028, -3.0966839538491113],
            [8.210872233355856, -3.093507808545915],
            [8.20556571566989, -3.093335158280716],
            [8.205320143674504, -3.088500290276818],
            [8.212044847406641, -3.0874159097739207],
            [8.212402443553122, -3.082115020509632],
            [8.208576940472478, -3.081287707090738],
            [8.200233642346172, -3.0833350511185165],
            [8.19969566498378, -3.077208380015742],
            [8.193080319581087, -3.0793083723590358],
            [8.18986562892094, -3.0765030361023755],
            [8.191519629735408, -3.07286867232153],
            [8.18989547516302, -3.0686637006432007],
            [8.182947239753132, -3.069192754162565],
            [8.183286691189519, -3.0645013035180297],
            [8.176460730008191, -3.0605323536734996],
            [8.169672961087464, -3.0610147719678613],
            [8.170116957551102, -3.053741237347898],
            [8.168554418867474, -3.052834286154185],
            [8.123264451013842, -3.0393440129857248],
            [8.113781667842739, -3.03937026159008],
            [8.109872762273147, -3.0333084040553295],
            [8.1105838589179, -3.02980733262049],
            [8.10720301492241, -3.0263603344281864],
            [8.105454425540733, -3.021621490680214],
            [8.101301246130681, -3.016370192264684],
            [8.108186557197971, -3.0025900692070286],
            [8.110910737966815, -2.9994233630386256],
            [8.110774119591982, -2.99590141371166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.3587748761786, "lat": 35.28476755894806 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47127"],
        "coty_name": ["Moore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moore County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01648579"
      },
      "bbox": [
        8.101301246130681, -3.2147977713682376, 8.340566733264568,
        -2.916200452360556
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.019479209290186, -1.8505576259669143],
            [10.022168044924298, -1.8489260293416367],
            [10.022033522963019, -1.8390427267492673],
            [10.02697899833917, -1.8360800648864284],
            [10.032804422481583, -1.8375777539687812],
            [10.03388410244067, -1.8296095543540725],
            [10.039933377152249, -1.8195856797239631],
            [10.035902087429506, -1.812572005763846],
            [10.03890157022098, -1.8114787555381884],
            [10.039087532544903, -1.8053527524857218],
            [10.037961014903315, -1.7889177210304188],
            [10.038709926251043, -1.7840574245179104],
            [10.036347525814504, -1.7749853737778658],
            [10.037117055336862, -1.7709208102679745],
            [10.04267604616066, -1.7722477493204227],
            [10.043490914118722, -1.7698046784776604],
            [10.037192881702152, -1.7626725881416305],
            [10.045421458948692, -1.7590825448896903],
            [10.039534767417958, -1.7576958845400297],
            [10.04790314639439, -1.7520533967931973],
            [10.049868643597613, -1.7453949687764214],
            [10.046438250078603, -1.7399324680164505],
            [10.0419465154439, -1.736232425869509],
            [10.04512902382064, -1.7315550804223458],
            [10.042595021175568, -1.7261816809970436],
            [10.042385006875778, -1.7226483358256925],
            [10.045081716216988, -1.714167418318278],
            [10.055388782701057, -1.7199739672298866],
            [10.061461792628556, -1.720318167280121],
            [10.066648950116454, -1.7250462634940813],
            [10.070287734995818, -1.7245816162449925],
            [10.074411284709702, -1.717849778030633],
            [10.079927519883418, -1.7119567501509527],
            [10.082600211088964, -1.705206251526873],
            [10.079109524162623, -1.7006040490532293],
            [10.08055185327131, -1.692345563588966],
            [10.078498850813013, -1.6908787830430922],
            [10.08796297797339, -1.6899730301603901],
            [10.09073218916971, -1.6852441246039114],
            [10.09485194944998, -1.6874163531136745],
            [10.101007399249182, -1.6807738999967623],
            [10.100175488723336, -1.677421669448305],
            [10.104604469939789, -1.6762433511781607],
            [10.111730611643477, -1.6716665759709044],
            [10.116885924731264, -1.6742601769392162],
            [10.119944966681938, -1.6774279922797433],
            [10.129159540699328, -1.6768002004735452],
            [10.134295079997418, -1.6809599892175908],
            [10.13574860086551, -1.683865798029642],
            [10.14496832159375, -1.6732935596017173],
            [10.150403295093886, -1.669948059342696],
            [10.155605311332216, -1.6648007757856655],
            [10.159958710366453, -1.6673932805656162],
            [10.16176468987916, -1.6720439344796842],
            [10.155452521505214, -1.6785556218363866],
            [10.15852014727341, -1.6842645140393648],
            [10.161267413078583, -1.6820666141785932],
            [10.163037543177802, -1.6758262937734794],
            [10.16736306222134, -1.6762864627602803],
            [10.168094486016043, -1.679452905071661],
            [10.1655660225655, -1.6829383818277766],
            [10.166732250963781, -1.6863539228577908],
            [10.173505269917413, -1.6901657093917306],
            [10.177372031294897, -1.6895634502750054],
            [10.179348075214886, -1.6925476238098145],
            [10.183727949881243, -1.6927099931181064],
            [10.191425477270403, -1.6975139025776642],
            [10.192143484489305, -1.7005750896022607],
            [10.198061339906973, -1.705912889150423],
            [10.199644422574861, -1.7119805032437607],
            [10.202740601955322, -1.7116152180066115],
            [10.206176499018623, -1.7149988581334488],
            [10.208266599706453, -1.7225522604364216],
            [10.213276214486557, -1.7247621073489061],
            [10.212775508757458, -1.728832695044446],
            [10.21419395196715, -1.7331194957557796],
            [10.21210305993428, -1.7354314559453816],
            [10.215702939444077, -1.7413401496667378],
            [10.219047833893041, -1.7414182784056709],
            [10.224678349414031, -1.7482862629842624],
            [10.23388346771988, -1.7494947625283055],
            [10.23986038720154, -1.74719223191766],
            [10.241894770993843, -1.744892929466063],
            [10.24427153327355, -1.7347144084440667],
            [10.246866849232912, -1.7274579472991185],
            [10.252117583163992, -1.7245363194340395],
            [10.256197845929703, -1.7286858139169814],
            [10.263142110876505, -1.7307323021811931],
            [10.266804699759616, -1.7328996484297785],
            [10.27670732875663, -1.7421919700863713],
            [10.275100061415873, -1.7514565556290351],
            [10.271752827747376, -1.749857900742742],
            [10.266587722882772, -1.7565342670644233],
            [10.272397316514455, -1.7609665133851835],
            [10.265848997992492, -1.7928536666202919],
            [10.270509108672881, -1.7909240975452512],
            [10.271873990302485, -1.796080852947922],
            [10.26870094395225, -1.799215817150389],
            [10.26899723857071, -1.8046521161187565],
            [10.267735580154426, -1.8098018395350575],
            [10.258050361212433, -1.8170648540321694],
            [10.259619798585188, -1.8402608790193984],
            [10.266124306332, -1.8351417678087092],
            [10.269990455312884, -1.8518315688132747],
            [10.268577151663493, -1.8824346196000699],
            [10.266696192714354, -1.8853243272881028],
            [10.256353587953361, -1.8919585758630413],
            [10.254930838607667, -1.8965177702633769],
            [10.258240421125125, -1.8996484712162152],
            [10.25449328028553, -1.9036956606712063],
            [10.248927165850066, -1.9055371870732747],
            [10.249536676797234, -1.9108496567736328],
            [10.255394106798592, -1.9155826455773424],
            [10.261481337026748, -1.9177421902356526],
            [10.248401117150612, -1.9287990402447073],
            [10.195206514281333, -1.9339612797895738],
            [10.111974353671782, -1.9418988060267828],
            [10.115307380518523, -1.945995119251154],
            [10.112059022545747, -1.9500992373739843],
            [10.11027558115573, -1.9420824753409782],
            [10.09705595373118, -1.9433973572948782],
            [10.086468037432285, -1.934988701047212],
            [10.079812283066126, -1.928311863815187],
            [10.075380905836804, -1.9238294561853122],
            [10.062950273487614, -1.9149022645477523],
            [10.055032190270582, -1.9073377919246055],
            [10.046269976217717, -1.8910628606513264],
            [10.037064892257696, -1.8831905536569549],
            [10.027229223591425, -1.8704274283054596],
            [10.02795262829958, -1.866878968824723],
            [10.01797880537595, -1.855222556181001],
            [10.015180540138921, -1.8511718155006438],
            [10.019479209290186, -1.8505576259669143]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.83751318319861, "lat": 36.28779880424044 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47173"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "01648583"
      },
      "bbox": [
        10.015180540138921, -1.9500992373739843, 10.27670732875663,
        -1.6648007757856655
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3109351222155055, -7.309607755735493],
            [1.311193233295925, -7.309095253662759],
            [1.3507852593828344, -7.274427724591199],
            [1.3949807643464305, -7.2355238417517755],
            [1.4265876032111884, -7.207526139947814],
            [1.4282350530637755, -7.208819546178586],
            [1.4273933082606454, -7.213800256385019],
            [1.430656456764023, -7.219565909134247],
            [1.4400457595139229, -7.228547064302],
            [1.4417933560832927, -7.226236091283889],
            [1.4534231043657115, -7.231536984620076],
            [1.454477364665312, -7.234510330539213],
            [1.4532078254258045, -7.239339646012056],
            [1.45739347457778, -7.240423115677576],
            [1.463005007104141, -7.247328490311347],
            [1.4728299514365746, -7.246510046297348],
            [1.4796210385977868, -7.243194482054387],
            [1.4802243296324147, -7.246555464249611],
            [1.4850615426839362, -7.247712014461377],
            [1.4894419653573034, -7.2517942828403426],
            [1.4943782617727053, -7.253748784340616],
            [1.4993262042475548, -7.251985827779335],
            [1.5023909411882255, -7.252807302855113],
            [1.513629394755943, -7.264004139107741],
            [1.5158817409778125, -7.261601714010533],
            [1.5231349300381591, -7.262741612878834],
            [1.5266678230517208, -7.265496145529392],
            [1.535428907205375, -7.2684138836378995],
            [1.5395666714224228, -7.2675635541845045],
            [1.5440677676448789, -7.271860109823313],
            [1.5439761781560362, -7.275465515280786],
            [1.555792199743786, -7.275059887449624],
            [1.564897205673178, -7.275698109708238],
            [1.570028975737205, -7.279928809435925],
            [1.5735313041741679, -7.278892224990963],
            [1.5800304719829812, -7.281361805857997],
            [1.58641803810488, -7.280023142535102],
            [1.588260545503506, -7.277057832651808],
            [1.5967558421739518, -7.274563809997085],
            [1.6008100974601964, -7.2747323588476736],
            [1.6021716057452513, -7.279524535215936],
            [1.6116227375743795, -7.283547663033452],
            [1.618499226245823, -7.2877874425622196],
            [1.6257360850645421, -7.28693460008181],
            [1.630657624245619, -7.288827063154885],
            [1.631668893008849, -7.291204609324108],
            [1.6378167490798055, -7.292123997858399],
            [1.6442912867434385, -7.288956181197077],
            [1.6454825563760302, -7.291004309938837],
            [1.6499928035455855, -7.290615075488105],
            [1.6516056053662076, -7.285767588920407],
            [1.6545398771727686, -7.28355669556593],
            [1.6574797404956345, -7.286579957546979],
            [1.6680723247299967, -7.28717884158154],
            [1.6688909809115173, -7.291934921761138],
            [1.6666432233389121, -7.295819092614506],
            [1.6694256688659153, -7.297642146413279],
            [1.6773551428618616, -7.298260280259697],
            [1.6825287849381994, -7.297593482125733],
            [1.6882155608473706, -7.295354173716787],
            [1.6920148179301842, -7.295378616049204],
            [1.6973385778240444, -7.300284287440932],
            [1.7007934588605529, -7.3061241123683685],
            [1.700008398334896, -7.30984835512538],
            [1.7046553935445499, -7.319660691890175],
            [1.703046148452283, -7.325240408217664],
            [1.7038988722892148, -7.32835996748858],
            [1.7072631096459425, -7.3314859929586715],
            [1.7108487080702317, -7.329964514608162],
            [1.7145517489969273, -7.331454080509331],
            [1.7209987726348086, -7.327375983541897],
            [1.7247677479092138, -7.327753859166414],
            [1.7256422532696338, -7.320535185365086],
            [1.7366118498476215, -7.318948559339589],
            [1.7404890017199255, -7.324747849841037],
            [1.7479358850793272, -7.330485662138241],
            [1.7454451743974522, -7.334436008412145],
            [1.750252191974772, -7.33862677715224],
            [1.7580757451168632, -7.342915703932563],
            [1.7609025042178275, -7.341882058777338],
            [1.7656510006933628, -7.345743180771088],
            [1.7678641911344615, -7.351070332768875],
            [1.7641524024058022, -7.356084856421699],
            [1.7655998994176674, -7.359882881853432],
            [1.7760524869039196, -7.378864890234544],
            [1.7763121215284516, -7.388957098356423],
            [1.7796160304429178, -7.387974067755308],
            [1.7787024173044694, -7.394332959852857],
            [1.7833156268196564, -7.400183363031574],
            [1.7834657362994268, -7.407237493773533],
            [1.7893880736344974, -7.411206681956884],
            [1.791659425507113, -7.4101295477871725],
            [1.7932826174251537, -7.415764874967186],
            [1.7978104993224042, -7.4136344947641755],
            [1.800702022200573, -7.416159221616101],
            [1.8123897782214955, -7.419204782574555],
            [1.821750180762068, -7.424286082291074],
            [1.8319491461517734, -7.428686287193163],
            [1.8348180313018534, -7.434025800827546],
            [1.838492674715019, -7.4375112365059834],
            [1.8368830480571838, -7.444423698613954],
            [1.8401588065540309, -7.445427480806363],
            [1.8405037610667492, -7.45074029849472],
            [1.8451110214585162, -7.454459279195685],
            [1.848442417853127, -7.4610767492781624],
            [1.852287907485696, -7.462563940389133],
            [1.8546082945594484, -7.4659478938854384],
            [1.862653982261639, -7.467374848460114],
            [1.8645536788713672, -7.476496759707652],
            [1.8692723448787605, -7.483023331124672],
            [1.8715375912330956, -7.489749020447371],
            [1.8749205057136995, -7.490026974396914],
            [1.8772111004529184, -7.495299090181833],
            [1.8804106382303942, -7.495650637318559],
            [1.8835093499049453, -7.503648782584005],
            [1.889684258260729, -7.50157303063994],
            [1.8946710383712486, -7.503051022576004],
            [1.901679508013076, -7.502372712032819],
            [1.9062468556282137, -7.511326018663843],
            [1.9104617747276897, -7.514432504324789],
            [1.9173089892949993, -7.513130893121994],
            [1.9183109170301473, -7.517571623626271],
            [1.9231080522386097, -7.524289687772842],
            [1.9279166777310168, -7.523363913851035],
            [1.9385608774731806, -7.529076525409275],
            [1.9432868720835168, -7.5353208266422],
            [1.9425298408256255, -7.540655277938759],
            [1.9505415756000242, -7.542923524210671],
            [1.9581363687663669, -7.540403237106578],
            [1.9601627540602409, -7.548107336692523],
            [1.9657105937137853, -7.54638393943354],
            [1.9778859040824213, -7.548809635301014],
            [1.9811147793022645, -7.552738149131579],
            [1.982037222584754, -7.559938559021209],
            [1.9892103540596495, -7.5641006323927575],
            [1.988783564903536, -7.566961680279077],
            [1.9964245557026286, -7.57006280439293],
            [1.9934718462107215, -7.574263320480563],
            [1.9997312350274785, -7.578282181493124],
            [1.9988204796975695, -7.580894569480234],
            [2.0038050286092037, -7.584243617478569],
            [2.0053285910792895, -7.58760789708587],
            [2.011030156718909, -7.592085810590923],
            [2.014945681511278, -7.593792141027696],
            [2.017742564741029, -7.599511157877109],
            [2.0223279143105146, -7.597137169311422],
            [2.0323146292353336, -7.6007926559189345],
            [2.0382269746046116, -7.6069722246823686],
            [2.0467280854725534, -7.610198872826611],
            [2.0530268130542533, -7.617480649955592],
            [2.0561428378464566, -7.61495742736769],
            [2.0593966850935725, -7.618398015493269],
            [2.0599974738496853, -7.623247826315204],
            [2.006194098172626, -7.636637780953834],
            [1.895457215547342, -7.664585398970745],
            [1.8262832807258231, -7.682416593764896],
            [1.7810110228931713, -7.693797723614096],
            [1.775715789879347, -7.694517022421438],
            [1.7694169916308258, -7.700837434101701],
            [1.7636136283581294, -7.699383746835442],
            [1.7574346288870324, -7.696127108539516],
            [1.7582871675874225, -7.693096182796396],
            [1.7567136373895273, -7.688211498154407],
            [1.7527329126346078, -7.688960269870487],
            [1.7528529346711277, -7.684296331359444],
            [1.748551914808573, -7.685732015352562],
            [1.7378889015818115, -7.68460605947921],
            [1.7310461683894316, -7.679253693372527],
            [1.718324138205588, -7.673744345814091],
            [1.7084541189672906, -7.674991674938889],
            [1.7040248938615363, -7.669346596485694],
            [1.7030556697988204, -7.672844337634255],
            [1.699773335680726, -7.674055289258533],
            [1.6982282926869574, -7.671048955730044],
            [1.6950248261774465, -7.671609256242184],
            [1.691688043877072, -7.669705544150335],
            [1.692630633494345, -7.667676915242448],
            [1.6884561940326295, -7.664419398027843],
            [1.6832262701207836, -7.664234955776407],
            [1.676888215081916, -7.660162815628261],
            [1.6680630610945189, -7.6629619261064414],
            [1.6630414312493358, -7.658580965029198],
            [1.659975555461953, -7.6606214811716855],
            [1.6566622181928223, -7.656985745088488],
            [1.6554665211190032, -7.653337916140605],
            [1.652643033742087, -7.651500587000129],
            [1.6507555166312056, -7.647528535451804],
            [1.6444480800935917, -7.645859665504028],
            [1.6397623259267426, -7.642275637889932],
            [1.6329933459203738, -7.6459833215691555],
            [1.6285324595223403, -7.6407367516159015],
            [1.6246980480684914, -7.642892438533079],
            [1.6219488816525254, -7.641753001551061],
            [1.6156751168307564, -7.63145361684347],
            [1.6116992873905447, -7.6362510261624985],
            [1.6119626700448826, -7.641125015502193],
            [1.6088827908058936, -7.645099074441065],
            [1.6047886884665858, -7.641940328173291],
            [1.5984190747801539, -7.641809111648001],
            [1.5966890015304416, -7.637716161017423],
            [1.5914548632713086, -7.637080411547594],
            [1.5909896073780263, -7.634278521051575],
            [1.5801781008178928, -7.634736987818055],
            [1.5760783911085008, -7.631853222674063],
            [1.5691458524213338, -7.631625947616901],
            [1.5572630618044894, -7.623838792389419],
            [1.540260675122236, -7.62734998497127],
            [1.5343932132717322, -7.624507189762369],
            [1.5279102112511553, -7.624519160038619],
            [1.5265194593446505, -7.622099757166131],
            [1.521265346406524, -7.620271336318785],
            [1.5137256347982597, -7.614298965049774],
            [1.5108563407178643, -7.6148061442263675],
            [1.5041788030722925, -7.609746651581356],
            [1.4940067163322235, -7.6055232614686465],
            [1.490833542331017, -7.601064762530053],
            [1.48526636153659, -7.601817743366474],
            [1.476606600349054, -7.598619469740684],
            [1.4717490434819158, -7.599891862206416],
            [1.4680835916488968, -7.593745657028208],
            [1.462348993568301, -7.593563245053943],
            [1.4596093872487896, -7.59045369898186],
            [1.4518264101022107, -7.5891347526117885],
            [1.4506835608117308, -7.5858255208189505],
            [1.446568702488317, -7.583131876100288],
            [1.4427669989476588, -7.584484428561519],
            [1.4392835555930878, -7.582480088359011],
            [1.440014380013192, -7.578179452360216],
            [1.4446019300027981, -7.5776381644550685],
            [1.4436546727717265, -7.56941855663053],
            [1.4411037718554278, -7.565990509547909],
            [1.4442165114265884, -7.554097995005737],
            [1.4405127694735222, -7.543130111055859],
            [1.43757605677694, -7.542540418215276],
            [1.4349928212639438, -7.537758241950854],
            [1.435875397710373, -7.534251907245824],
            [1.433022746521178, -7.531909110293882],
            [1.4299705618492582, -7.524304701098331],
            [1.4327825267926964, -7.5131344551260435],
            [1.4330275354990503, -7.508437442427529],
            [1.431311959772476, -7.500939860657462],
            [1.4341053194434112, -7.500303766586328],
            [1.4214082077800299, -7.484441935785161],
            [1.4159621963742006, -7.483136442163295],
            [1.4143357093474482, -7.478093539134638],
            [1.4085162233934945, -7.479606908980085],
            [1.4027916529460671, -7.475706606260132],
            [1.4027838129800423, -7.469284395473553],
            [1.407082943364189, -7.465444459422263],
            [1.4107349811957843, -7.457039059177302],
            [1.4151925936747058, -7.45530441247914],
            [1.4202606479907833, -7.450068297763665],
            [1.4172474820792742, -7.444035858066691],
            [1.41441614524877, -7.446341928184751],
            [1.4121354813792155, -7.438044501460777],
            [1.4052927471143493, -7.442091685025138],
            [1.4048470392228793, -7.434438546250508],
            [1.4016545248236312, -7.4290840128738544],
            [1.4023239411977326, -7.427283836262851],
            [1.3992896344467407, -7.422098428896701],
            [1.4000681827607282, -7.418125212957295],
            [1.4029186462294956, -7.414742212030018],
            [1.4013154870210889, -7.412824742602897],
            [1.400762197321786, -7.406922746073578],
            [1.3972488949425148, -7.402776536074942],
            [1.3927560029612271, -7.4007285908640865],
            [1.391933448408227, -7.397237185037268],
            [1.381665659322972, -7.39679996053287],
            [1.3778181108054948, -7.394560729687767],
            [1.3658731715593326, -7.3914517020200545],
            [1.3578649301781798, -7.394535076280786],
            [1.3532850694661367, -7.392182256449562],
            [1.3517033321015073, -7.386670935516687],
            [1.3474137769067602, -7.3854324310029975],
            [1.3474229660160204, -7.382096605990592],
            [1.354721247461361, -7.376379885707134],
            [1.3540286104831547, -7.373231784837848],
            [1.3494562503415688, -7.36858883085396],
            [1.3517638975670454, -7.364021201478747],
            [1.3504267209657663, -7.358800254439706],
            [1.353708400021831, -7.34998364282558],
            [1.3498118283338378, -7.347805952287993],
            [1.3428393939568453, -7.343625297972171],
            [1.3443260481170975, -7.339602908410276],
            [1.3401279865949653, -7.337936693476217],
            [1.3343771405046072, -7.332968398531117],
            [1.3337691166944339, -7.328031470325786],
            [1.3268656112904016, -7.321249665514457],
            [1.3191433381983415, -7.320962713408926],
            [1.3091307783567174, -7.314240696235201],
            [1.3109351222155055, -7.309607755735493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.61191770290255,
          "lat": 31.254695293173185
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48005"],
        "coty_name": ["Angelina"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Angelina County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01383788"
      },
      "bbox": [
        1.3091307783567174, -7.700837434101701, 2.0599974738496853,
        -7.207526139947814
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9729716502499497, -8.999539247539298],
            [-1.948006488510994, -8.971141838153468],
            [-1.9448465199502034, -8.971705642881766],
            [-1.9336102948093048, -8.969733369422306],
            [-1.9213308451681332, -8.971524566642568],
            [-1.917948489437056, -8.975654795539208],
            [-1.9128633630342653, -8.975699844565895],
            [-1.909331932839305, -8.971066666037252],
            [-1.9047105762967689, -8.97026658351601],
            [-1.9076011017896677, -8.963038378912092],
            [-1.9020460306438902, -8.9649617919973],
            [-1.8995380989952328, -8.963187939558214],
            [-1.8948340906008105, -8.967580205474864],
            [-1.8886215601467076, -8.962273267476222],
            [-1.8838533786471168, -8.960148328596796],
            [-1.8791955696413378, -8.96070433376022],
            [-1.879520306266764, -8.956057186015425],
            [-1.8729103436123555, -8.958406779721628],
            [-1.8683206472302671, -8.955062773449406],
            [-1.8643001969295174, -8.954551123725697],
            [-1.8588415480370397, -8.956759725815504],
            [-1.8563255703001111, -8.952038351797981],
            [-1.8525937676745827, -8.950738987381987],
            [-1.847168797919825, -8.953370095213844],
            [-1.8447736881961958, -8.950771747864138],
            [-1.8474527925013002, -8.948173340122251],
            [-1.8453373911433175, -8.94539317671404],
            [-1.840697891190255, -8.94687799061375],
            [-1.8381112503276809, -8.94590425878923],
            [-1.8351420279752844, -8.94136954324291],
            [-1.831559200100069, -8.947049740792242],
            [-1.8322044343130117, -8.949675895597904],
            [-1.8301015370222342, -8.954503330643234],
            [-1.821806137969133, -8.953539493534127],
            [-1.8171673530588968, -8.95111153461195],
            [-1.8076941908413164, -8.951661557509881],
            [-1.8074249957582689, -8.955830369644385],
            [-1.7952710653430421, -8.955872480383196],
            [-1.7933218245282225, -8.951040001549877],
            [-1.7962483903878792, -8.94860664652691],
            [-1.7924152364359842, -8.946016043538448],
            [-1.7862066761947106, -8.9504361925728],
            [-1.7821468642172509, -8.94865114075728],
            [-1.780716007019111, -8.953775590653208],
            [-1.7774266669911725, -8.955163129890723],
            [-1.773958430231952, -8.952823978129016],
            [-1.7705647808880436, -8.946583123671344],
            [-1.7648460671835318, -8.948389185989315],
            [-1.763245741449209, -8.94487938170774],
            [-1.7567226869455455, -8.945488239538589],
            [-1.7529894283926823, -8.941856947301892],
            [-1.752794496987174, -8.938522083721066],
            [-1.748828773223546, -8.936570677029996],
            [-1.7457918946542916, -8.940024830108191],
            [-1.746724264413777, -8.942877415726288],
            [-1.7431881856648508, -8.94528366956783],
            [-1.7347638385387092, -8.945208413006105],
            [-1.7348636432411373, -8.95070603512258],
            [-1.7300259190603953, -8.953928944875662],
            [-1.725722787452562, -8.952476835104042],
            [-1.7139905038932424, -8.956721694847525],
            [-1.7090677456511738, -8.959435341091368],
            [-1.7029842380986562, -8.959745726468192],
            [-1.696814376104223, -8.963019880136788],
            [-1.6881696312147592, -8.963500219353188],
            [-1.6857945297600088, -8.965186714772008],
            [-1.6782875605643206, -8.961004981216032],
            [-1.6752340992312935, -8.960832164563575],
            [-1.6728966458399983, -8.965449611498858],
            [-1.6689272272642524, -8.967470009351159],
            [-1.6646447528677946, -8.966355401826613],
            [-1.6606254787523156, -8.963477094026812],
            [-1.6560564562168154, -8.967084042345967],
            [-1.657884543781692, -8.973104594899356],
            [-1.6573974782031426, -8.979541632837858],
            [-1.652721116227971, -8.983637171381485],
            [-1.6462805141617551, -8.983674623056883],
            [-1.6427669243464418, -8.980712732423047],
            [-1.645288650476616, -8.976254980035902],
            [-1.6416383491767743, -8.972659752056703],
            [-1.635257755001026, -8.970374664380156],
            [-1.6377330427987749, -8.961187538480772],
            [-1.6366752535410583, -8.956458793466682],
            [-1.6319736363923285, -8.953349986963154],
            [-1.6219608623088893, -8.95141880195825],
            [-1.6175786119849012, -8.956968791470407],
            [-1.6181596632585356, -8.962279081282224],
            [-1.6110866020291534, -8.964067612787982],
            [-1.6087992020042294, -8.966632519777663],
            [-1.6053776086251568, -8.965533053736984],
            [-1.5962737371509887, -8.97025330793942],
            [-1.596189264037038, -8.97477511166639],
            [-1.5978242187074674, -8.980712458927812],
            [-1.5931359698093248, -8.980118316662548],
            [-1.5838640881062644, -8.972097791129809],
            [-1.5806459635799046, -8.96719917971832],
            [-1.5754447659644948, -8.97330032154003],
            [-1.5660260625729572, -8.979701274800474],
            [-1.5686958540910791, -8.991632696224734],
            [-1.571653223604989, -8.993943848123042],
            [-1.5803013935953305, -8.99706864880113],
            [-1.5869929473461994, -8.994822941451702],
            [-1.5947824271260331, -8.995590110739045],
            [-1.5980411225688331, -8.994156531660193],
            [-1.6028171233373705, -8.996909948655677],
            [-1.6032921666029072, -9.003996108332618],
            [-1.599900559009757, -9.011237916217265],
            [-1.600780856216867, -9.017561441941023],
            [-1.6065884008359905, -9.02140072865191],
            [-1.6045594885006667, -9.025904331216665],
            [-1.602459283823976, -9.036961747182437],
            [-1.6009113003896795, -9.037218408385602],
            [-1.5892163078808577, -9.033549551220608],
            [-1.586681723602974, -9.035100097863936],
            [-1.583221245650443, -9.041685563086526],
            [-1.5733047746966378, -9.045475523389145],
            [-1.5719216958872884, -9.049526215454609],
            [-1.5757127326984188, -9.05530549411943],
            [-1.5739463420869615, -9.062313936294697],
            [-1.5705249078661319, -9.068324884093451],
            [-1.5702942926778687, -9.072739292405705],
            [-1.572042790444008, -9.078220942219101],
            [-1.57454081721612, -9.080046249554538],
            [-1.569195481087093, -9.087034155755054],
            [-1.565886595228838, -9.088891914132443],
            [-1.5600314857784667, -9.089897292832251],
            [-1.5594943991506676, -9.094462838002094],
            [-1.5575174100367126, -9.096929134765421],
            [-1.5522110331786148, -9.098420546145759],
            [-1.5460403439711379, -9.098755754361957],
            [-1.5450940437990932, -9.106018897619931],
            [-1.5461641780479982, -9.109568354279368],
            [-1.5394141189558912, -9.115773973886425],
            [-1.5413136205183147, -9.121755230578037],
            [-1.5385997283474013, -9.125752667814643],
            [-1.538684575478734, -9.128784133389072],
            [-1.5361341243678426, -9.133502445632475],
            [-1.5346834159173772, -9.139232415194094],
            [-1.5317275488858986, -9.13885253457849],
            [-1.5263999263823964, -9.140779010903799],
            [-1.522836072160871, -9.147264957483188],
            [-1.5184442611811337, -9.149457018590184],
            [-1.5138238640654387, -9.149442836886948],
            [-1.5110256656464522, -9.154976560926526],
            [-1.5018763796476926, -9.15960163766039],
            [-1.4967833090670877, -9.16000054857925],
            [-1.4967058662461932, -9.156813328409557],
            [-1.500083520136347, -9.155249751673244],
            [-1.5019509603300343, -9.150813842673891],
            [-1.5007603974975419, -9.146500970860226],
            [-1.4944525142050655, -9.151314518322945],
            [-1.4916934407077052, -9.145902380112028],
            [-1.4870810477321008, -9.144355625359884],
            [-1.4779154435347974, -9.147564367853033],
            [-1.475803786225687, -9.154697763667809],
            [-1.4726380815196582, -9.15200959764991],
            [-1.468536170340642, -9.153793246875724],
            [-1.468865266225123, -9.157806289186366],
            [-1.4751332764452212, -9.158081105495345],
            [-1.4694167230366366, -9.163123668170849],
            [-1.4687147277323347, -9.169859338947276],
            [-1.466503947617892, -9.174555748591391],
            [-1.4669729828566396, -9.177533195270566],
            [-1.4545160054905935, -9.179577222489426],
            [-1.4476970014678379, -9.18646286248289],
            [-1.4502871040856886, -9.188120920783694],
            [-1.449413203121565, -9.192318798603992],
            [-1.4463230197189316, -9.191056268859683],
            [-1.442730067236208, -9.192376375485695],
            [-1.4419514756218437, -9.196089059067182],
            [-1.4390121216606602, -9.199990979485717],
            [-1.4420298926317432, -9.20504199989802],
            [-1.4423038177697909, -9.208794676926845],
            [-1.4403462817328905, -9.213411584969615],
            [-1.4363151770631828, -9.216828400033808],
            [-1.4316814374595566, -9.214630907753575],
            [-1.4340313464779064, -9.209042685278167],
            [-1.4345881750764988, -9.204532616781172],
            [-1.4234145382702788, -9.20595409212981],
            [-1.423989358133747, -9.21488748429792],
            [-1.422458622745438, -9.22201080609102],
            [-1.420601006746913, -9.223850436582776],
            [-1.4128751119078193, -9.224302205398427],
            [-1.407958853669292, -9.222493868218704],
            [-1.4079285307058256, -9.226527549998977],
            [-1.4028368977981729, -9.224209468212878],
            [-1.4012248572972064, -9.220808634861411],
            [-1.395662501877407, -9.22337575708856],
            [-1.3887910354255573, -9.22011194175166],
            [-1.3837351707203358, -9.225257671870686],
            [-1.3860517978310065, -9.22703793646607],
            [-1.3804973734534733, -9.23408184961992],
            [-1.3793696310958958, -9.238792919229365],
            [-1.382309238926792, -9.244964241291326],
            [-1.3870623839945033, -9.244195075953193],
            [-1.388165447521206, -9.24762972328172],
            [-1.3833333416726596, -9.253351148956142],
            [-1.3830546693246841, -9.25539666913551],
            [-1.3900382049958397, -9.256840687495973],
            [-1.3948995005513025, -9.260298465085443],
            [-1.3975554215642971, -9.261545467598177],
            [-1.4429413691968487, -9.321117259318251],
            [-1.4581502140205873, -9.341293670116068],
            [-1.4882160195398673, -9.38055637134729],
            [-1.532418806228168, -9.438808884102059],
            [-1.5404368931171097, -9.448749245636515],
            [-1.5713553568533654, -9.488518300634667],
            [-1.6322390696869757, -9.566896470068952],
            [-1.6410351310547109, -9.577329943659914],
            [-1.7190701537690993, -9.544814519104111],
            [-1.808070962103027, -9.507714834821154],
            [-1.840904342373014, -9.493887237074459],
            [-1.9241853572760843, -9.459086162893541],
            [-1.9798453993323746, -9.435796994314321],
            [-1.984401098284554, -9.433700640752585],
            [-1.982675113343639, -9.372078132724775],
            [-1.982109395749406, -9.362094457717326],
            [-1.9784939375649362, -9.224293322901783],
            [-1.977085800733664, -9.165422153276596],
            [-1.975627654287718, -9.10898712847256],
            [-1.9741321304605821, -9.056274799645614],
            [-1.9729716502499497, -8.999539247539298]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.52007278508424,
          "lat": 29.448934198791225
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48029"],
        "coty_name": ["Bexar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bexar County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01383800"
      },
      "bbox": [
        -1.984401098284554, -9.577329943659914, -1.3793696310958958,
        -8.936570677029996
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.6555587914706043, -3.440515422879989],
            [-3.586856329798203, -3.4434503942228374],
            [-3.562581075886382, -3.4443054310959584],
            [-3.4848946414119903, -3.448557945064734],
            [-3.4410739076759316, -3.450573442043403],
            [-3.3771496325776464, -3.4537935017555026],
            [-3.3127160188598728, -3.4571325297672804],
            [-3.2126157387366625, -3.461910583726217],
            [-3.215474219501775, -3.5202187676041192],
            [-3.2221408875397826, -3.6498561097012163],
            [-3.2261231658498164, -3.7247702116775843],
            [-3.2276534379478017, -3.749387556570138],
            [-3.231927841460257, -3.840892979860903],
            [-3.2351105248090395, -3.897217439720081],
            [-3.2349833828751997, -3.8995691534607455],
            [-3.310332062731458, -3.89563308859941],
            [-3.397178278961373, -3.89125131183313],
            [-3.405641832073186, -3.8907034702023706],
            [-3.4908854182761764, -3.886308475291284],
            [-3.5639479038714, -3.882615497740889],
            [-3.6826011079535275, -3.8763949791735324],
            [-3.6745707555619034, -3.7498697901928435],
            [-3.66943536257239, -3.665817499585118],
            [-3.6647329605203818, -3.596354909401729],
            [-3.6615476368752313, -3.543116805327821],
            [-3.658413700692111, -3.486785342869516],
            [-3.6555587914706043, -3.440515422879989]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.81397657577271,
          "lat": 34.965441871002156
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48129"],
        "coty_name": ["Donley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Donley County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01383850"
      },
      "bbox": [
        -3.6826011079535275, -3.8995691534607455, -3.2126157387366625,
        -3.440515422879989
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [1.7924327930128319, -9.156580080316337],
              [1.8003309563665297, -9.15277406422819],
              [1.8039767296587859, -9.152687138883657],
              [1.81359838862005, -9.149296379038285],
              [1.8173128443113695, -9.150894489342855],
              [1.8210018116005071, -9.14781384646451],
              [1.823644476252433, -9.148873068309664],
              [1.8352434200474392, -9.146762045661873],
              [1.8362277630072041, -9.1433348334767],
              [1.839578157059152, -9.143704490485188],
              [1.8411675421814726, -9.140325485081117],
              [1.844187756947061, -9.139588358253192],
              [1.8425831558975307, -9.135420419715535],
              [1.8425333890003066, -9.130571954894661],
              [1.8384730206465907, -9.127207642722347],
              [1.8400715258888891, -9.120779234025042],
              [1.8432305543720267, -9.120837835272354],
              [1.8489540690165045, -9.114923689282246],
              [1.851293724209118, -9.11696703615008],
              [1.8562965843797519, -9.116250794405106],
              [1.8659295390915482, -9.118537474707045],
              [1.871881768827754, -9.117513015392198],
              [1.8746087063670385, -9.118985193160224],
              [1.8792725666716872, -9.11542076237336],
              [1.8806699549746706, -9.155892282776431],
              [1.777680580827723, -9.202058388764906],
              [1.7135131655319171, -9.232479208640155],
              [1.685987060799914, -9.246168230997577],
              [1.6553814289902513, -9.262509391091545],
              [1.6353293505774698, -9.274337980437272],
              [1.6237245441377752, -9.281917622069557],
              [1.6125128737080066, -9.289911327700054],
              [1.6014103480734079, -9.298953599849371],
              [1.5891106126584287, -9.311535537648044],
              [1.576113603716725, -9.332336647599664],
              [1.5719982647383688, -9.342096945344204],
              [1.5678475484926784, -9.34640753595057],
              [1.5635848726795605, -9.344049451237337],
              [1.5626832848624268, -9.33962871372704],
              [1.5602416193445992, -9.338726369930168],
              [1.5492716114827356, -9.34699208025456],
              [1.5497912015178004, -9.348434548279634],
              [1.5434523877342332, -9.352749359604385],
              [1.5417671713127168, -9.348858568681095],
              [1.5359640393076759, -9.349909512733735],
              [1.5284636724028111, -9.353335346411942],
              [1.5266637406028871, -9.349820596069653],
              [1.5295452418555553, -9.343872872982566],
              [1.5290699689859928, -9.339179020723797],
              [1.5241800612331204, -9.337606205556988],
              [1.5380985655056372, -9.324658737198876],
              [1.5323400983682909, -9.319931261403289],
              [1.5317717767873111, -9.316056970064505],
              [1.5384968968731407, -9.307695716808963],
              [1.5484322546833273, -9.299396706902881],
              [1.5548332461434724, -9.30574924402558],
              [1.5568175957415553, -9.306546345861252],
              [1.5633433420045373, -9.300644260031065],
              [1.5654822643940736, -9.299918564780446],
              [1.5756405216256184, -9.289186478641351],
              [1.5809571519837744, -9.285016573795925],
              [1.5866318170949218, -9.283674688446219],
              [1.5929796058345413, -9.278481505679322],
              [1.5929703554167909, -9.274661423277381],
              [1.597399854140701, -9.268331860493063],
              [1.5996903763734327, -9.262367405691116],
              [1.6028598294289007, -9.26006526475722],
              [1.6033515581461746, -9.255047707147993],
              [1.6068859594029397, -9.255329247693203],
              [1.6085481820536094, -9.249160499313316],
              [1.615853820162321, -9.241666514598323],
              [1.6201238642521218, -9.238963372634837],
              [1.62560554945358, -9.237664585408833],
              [1.6390431869611715, -9.239810697415209],
              [1.6429320765630124, -9.242244471481918],
              [1.6474187123792976, -9.242286854853461],
              [1.6579843346116545, -9.238602304169133],
              [1.6687571766749745, -9.23332807614598],
              [1.6767356766697916, -9.231620780218808],
              [1.6831438072142353, -9.224119337649455],
              [1.6873483571866796, -9.222245628344856],
              [1.6843753271373798, -9.219207033553968],
              [1.6865891836973939, -9.212128138964125],
              [1.6867245148006846, -9.207333174165433],
              [1.694633375808178, -9.196176729378736],
              [1.7039110858462467, -9.186946663622377],
              [1.7087410995616616, -9.184362200031876],
              [1.7148290379828988, -9.183597116396509],
              [1.721811316231173, -9.186046821497914],
              [1.7320599675693926, -9.192704877830414],
              [1.7427710675159576, -9.197053036396412],
              [1.7555364961663074, -9.196508642800529],
              [1.759939457430841, -9.19865909281355],
              [1.761956064115284, -9.201894796207766],
              [1.7670423629057814, -9.203041034594845],
              [1.7748506253199021, -9.199753974235644],
              [1.7785811065893773, -9.19377364456907],
              [1.7790894873219105, -9.180390956631758],
              [1.7835143802478004, -9.172663993452028],
              [1.789235027524788, -9.168387885014656],
              [1.7911142937465847, -9.163151223478247],
              [1.7939621265177985, -9.160248249627594],
              [1.7924327930128319, -9.156580080316337]
            ]
          ],
          [
            [
              [1.4900723673501624, -9.39086673385287],
              [1.4914842193171778, -9.387784074117196],
              [1.4909916725683574, -9.38155657197791],
              [1.49278111274857, -9.375506105884819],
              [1.4912582333033246, -9.369801779580483],
              [1.500832254259646, -9.362908442266116],
              [1.505505585553592, -9.365539591715835],
              [1.5170265668709735, -9.373593846530923],
              [1.5225508461349921, -9.379484982471672],
              [1.5266448739602922, -9.381975083065592],
              [1.5262430021466247, -9.390315508116116],
              [1.5191916909820207, -9.398170289416829],
              [1.5118790504963935, -9.401941490501661],
              [1.4968521358499085, -9.402434296955025],
              [1.4913444880585143, -9.40137752744282],
              [1.4900723673501624, -9.39086673385287]
            ]
          ],
          [
            [
              [1.4105293670252586, -9.44157343676977],
              [1.4157088992345326, -9.4410041959498],
              [1.4157564574781163, -9.445091655577052],
              [1.411711086515754, -9.44503481559968],
              [1.4105293670252586, -9.44157343676977]
            ]
          ],
          [
            [
              [1.3985531783954464, -9.428308999161546],
              [1.4037454417769129, -9.42686466010054],
              [1.4064189854305216, -9.428436128766892],
              [1.404493855566835, -9.433212531391316],
              [1.402353309235342, -9.433610172769358],
              [1.3985531783954464, -9.428308999161546]
            ]
          ],
          [
            [
              [1.2315547773642952, -9.623774835458331],
              [1.2335066184535197, -9.621301276466271],
              [1.2380683017756398, -9.620032103362403],
              [1.2419849112690453, -9.616518687395036],
              [1.253319993575135, -9.595545818579149],
              [1.2567144459877004, -9.591933676361478],
              [1.265293379233402, -9.587250470410442],
              [1.268511045016872, -9.586912404189206],
              [1.2756331288320415, -9.582139445034151],
              [1.2781906735328386, -9.578126317249627],
              [1.282131127757367, -9.577371821392243],
              [1.2870678353558564, -9.57241488006558],
              [1.2973814788596105, -9.565052418623747],
              [1.3029406876268785, -9.560190529809665],
              [1.3130962094177652, -9.557838082980522],
              [1.3164855986374573, -9.554224802653737],
              [1.3154219016705182, -9.551780853273975],
              [1.3169150122730422, -9.545527809944879],
              [1.322735452276764, -9.545980101253912],
              [1.3229049959055155, -9.54239911243187],
              [1.3208956638638807, -9.538942755995755],
              [1.3258479443205737, -9.53582429281304],
              [1.3298032490089964, -9.536704179532782],
              [1.3317554684903692, -9.53474161033231],
              [1.33273805271379, -9.5295159850826],
              [1.3464880677680524, -9.523954267845099],
              [1.3424881945582123, -9.518882828251654],
              [1.3444121911213196, -9.514364335036511],
              [1.3515656765628936, -9.51347110792803],
              [1.3550765984119992, -9.511797831398164],
              [1.3584127837116384, -9.513092074100493],
              [1.3616750635838242, -9.507638188927217],
              [1.359553156677463, -9.503468692808386],
              [1.3639912007336867, -9.501171970070036],
              [1.372537989001585, -9.504351642522092],
              [1.3729241835823351, -9.501689046785062],
              [1.36994873025501, -9.49548449209018],
              [1.3777423441311931, -9.49632087829441],
              [1.384763538226425, -9.49307418134374],
              [1.3854647509552547, -9.490817995324914],
              [1.3816752833060135, -9.486053776881942],
              [1.3756486416072489, -9.485403629807394],
              [1.3862665745968183, -9.479051671618887],
              [1.3942901303744544, -9.482030177705804],
              [1.3975849275052916, -9.479745030137325],
              [1.3976959037924677, -9.471258661227239],
              [1.4059154744718927, -9.464215542622014],
              [1.4056747793738578, -9.461356148467875],
              [1.4115309264301579, -9.456383393392766],
              [1.4157676320167, -9.454904933090369],
              [1.4314089261423266, -9.444197143844724],
              [1.4352450248840336, -9.444051351021344],
              [1.4411323350132623, -9.441939117929147],
              [1.4395004145169519, -9.43551827785678],
              [1.4406006522944383, -9.432132189181715],
              [1.4442906803811146, -9.428511737829465],
              [1.4459064492410019, -9.424916300722652],
              [1.4511885188429636, -9.424342628506986],
              [1.4569342012937778, -9.419267400899301],
              [1.4593231948632663, -9.419545826463642],
              [1.4645648289451034, -9.415701707608251],
              [1.4673823186645918, -9.41720157765827],
              [1.47782612121324, -9.414827784495087],
              [1.4898802695946718, -9.408650992391003],
              [1.4924257058441406, -9.404941330111141],
              [1.5122402249311127, -9.405820726746859],
              [1.5200752842898801, -9.402349725837082],
              [1.526831435055561, -9.395723723739298],
              [1.5325000358660064, -9.393198951358077],
              [1.5344099653868228, -9.38070766179081],
              [1.5393449295211983, -9.377007934657644],
              [1.5571187975848493, -9.379326228322741],
              [1.5700167967759746, -9.376900563416047],
              [1.5737792805168902, -9.382428755693924],
              [1.562272749813557, -9.390646106582002],
              [1.5390784089616305, -9.408281437204208],
              [1.5154362895766875, -9.42953127107491],
              [1.497804866750137, -9.441511691807658],
              [1.4793125935257991, -9.45333040412424],
              [1.452960679204084, -9.47133378468369],
              [1.450961398978118, -9.471927103065283],
              [1.431445956312098, -9.485131320867312],
              [1.3344553027295494, -9.552073038020701],
              [1.3125908751773858, -9.567354087706097],
              [1.277199842534812, -9.59341429255952],
              [1.2613010343095161, -9.606273149305842],
              [1.2506173486908727, -9.616961641986368],
              [1.244829530142699, -9.625089111651777],
              [1.2364944355564507, -9.629457726006047],
              [1.2315547773642952, -9.623774835458331]
            ]
          ],
          [
            [
              [1.1453276217538622, -9.165580141165668],
              [1.1518962593937976, -9.162166304197516],
              [1.1546815036196167, -9.16353264020763],
              [1.1589426363315518, -9.159663262313632],
              [1.1615502594661051, -9.163952590268476],
              [1.1596080696890387, -9.168853344005228],
              [1.1618747466270207, -9.171686974987793],
              [1.1601034673539041, -9.176553540768554],
              [1.162068156164112, -9.179042031452854],
              [1.166416357810678, -9.18048170277364],
              [1.1649455753166433, -9.18436722660085],
              [1.169916772809634, -9.185473681784313],
              [1.1679349569866146, -9.190121689608192],
              [1.1712486402101656, -9.193690347219677],
              [1.1727377878289056, -9.19904634518436],
              [1.1822283735253947, -9.20534482324457],
              [1.1862849527852868, -9.205591286837773],
              [1.1875465378130667, -9.209587365026366],
              [1.1857888325453718, -9.21345344607917],
              [1.188490923488371, -9.214602851201725],
              [1.191425193976297, -9.222166455416158],
              [1.1976983462359574, -9.221984412372533],
              [1.2011192978967993, -9.219794572616058],
              [1.2045145638854136, -9.221413114112742],
              [1.210692667224417, -9.213798810896785],
              [1.2174948513811767, -9.213674720616376],
              [1.221311306200772, -9.214902868416099],
              [1.2221018102542198, -9.211648963344023],
              [1.2277957651258615, -9.209648563358453],
              [1.2308924165111896, -9.213002299172146],
              [1.2355341297590503, -9.209166975030586],
              [1.2399541061374235, -9.210338395204847],
              [1.2435704259120954, -9.208633525926015],
              [1.2416044706198373, -9.203153129037736],
              [1.2456999348064721, -9.198724838891481],
              [1.249135994860894, -9.199603907772412],
              [1.2523515665105573, -9.194225819676626],
              [1.249375793810318, -9.186094952680069],
              [1.2519026272183404, -9.184768967876542],
              [1.2547254479732086, -9.188587857774184],
              [1.2587787156837735, -9.185334865222115],
              [1.2647936246702933, -9.185285452964417],
              [1.2652456403303578, -9.182232324360571],
              [1.263234620706512, -9.174459506533129],
              [1.2693872590630206, -9.171875860804796],
              [1.271687620709491, -9.169453393925757],
              [1.2740487098261326, -9.162736033897252],
              [1.2775698253324268, -9.161359984022775],
              [1.2900814296873744, -9.161599819092919],
              [1.2970755108060708, -9.16536165569092],
              [1.3078204307917771, -9.167627732072262],
              [1.3085983203865998, -9.172104569848495],
              [1.3134848118994689, -9.170291676388064],
              [1.3186891241339718, -9.170980920268711],
              [1.3204671008258528, -9.179549078298946],
              [1.3311526067981687, -9.193175404779842],
              [1.3385147529664012, -9.19926324890451],
              [1.3495955095732244, -9.205728620754446],
              [1.3543993857349523, -9.20756324578817],
              [1.3809843960959165, -9.214788880019228],
              [1.3915869765129985, -9.216831068136692],
              [1.3948905434603094, -9.218546616538605],
              [1.4107378764128609, -9.22174504750459],
              [1.4120410912665906, -9.225805150437859],
              [1.4031633437845277, -9.23991765200834],
              [1.3993102197938623, -9.24693997590353],
              [1.3965876990349972, -9.238116690257149],
              [1.3938835660204119, -9.236819156174244],
              [1.3865509861069065, -9.238023465770533],
              [1.3749428993170278, -9.245502821245845],
              [1.3763438592984167, -9.250490667445495],
              [1.388470529542936, -9.261387047373876],
              [1.3946927361622175, -9.265575774212534],
              [1.4076499804205314, -9.272563212966242],
              [1.428821872966735, -9.283305919025077],
              [1.4326555923998807, -9.299904806012728],
              [1.4318507126754847, -9.303377526782016],
              [1.4338706781327324, -9.329311195333515],
              [1.4313964708190932, -9.338022555639883],
              [1.4356618817982496, -9.339505385695096],
              [1.4381046963167936, -9.337846310065085],
              [1.4516534087634985, -9.341733770708167],
              [1.45366901150602, -9.345344377119313],
              [1.451925967868546, -9.348488185088721],
              [1.4301029154039469, -9.360003668740644],
              [1.4170260086231043, -9.360102822233127],
              [1.4153914220823933, -9.369416303623863],
              [1.415841699622348, -9.375958723468406],
              [1.4293196332034477, -9.390258385866755],
              [1.4296647734087302, -9.401905014342942],
              [1.4233662337886466, -9.412912090191753],
              [1.4157572568223684, -9.417787377878753],
              [1.412585016294418, -9.422028099632875],
              [1.40750136191038, -9.422107025329732],
              [1.3995222429761083, -9.41865801919635],
              [1.400843756185893, -9.414815087559061],
              [1.4086641391288284, -9.41414273866388],
              [1.4146790944207113, -9.415861809211208],
              [1.4190295524556873, -9.412803707898474],
              [1.4169722591710419, -9.406593416444554],
              [1.3913380414069219, -9.40091272985302],
              [1.3866532722854499, -9.402362772100833],
              [1.3849261166152995, -9.410121383400417],
              [1.3761547855356826, -9.422430446560313],
              [1.3694565136544403, -9.428469748822748],
              [1.361745202309807, -9.432468155069712],
              [1.3580019280300184, -9.437548718293897],
              [1.3463169734862745, -9.450347192192849],
              [1.3278057063811568, -9.474216847529226],
              [1.3175179632451852, -9.48160907243718],
              [1.3130296990552555, -9.48707829958911],
              [1.3069776921244314, -9.503748708405459],
              [1.3003379076705637, -9.508370756655191],
              [1.2891060590887633, -9.514461556310755],
              [1.2873602090325096, -9.514759636092153],
              [1.2742506843493966, -9.492771044551082],
              [1.270024049945119, -9.484988662242651],
              [1.2455866416643453, -9.44412083650208],
              [1.209854040553437, -9.38501016649825],
              [1.1911891410750162, -9.35461932603829],
              [1.18789067172897, -9.348574234496484],
              [1.1315029772442935, -9.254733640127924],
              [1.1453276217538622, -9.165580141165668]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.96428978501193, "lat": 29.39442695794118 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48167"],
        "coty_name": ["Galveston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Galveston County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "01383869"
      },
      "bbox": [
        1.1315029772442935, -9.629457726006047, 1.8806699549746706,
        -9.114923689282246
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4018634830838645, -6.802349637862236],
            [-1.3315362382624016, -6.763223463675379],
            [-1.2612180099842594, -6.7240844356839125],
            [-1.228335663928094, -6.705981865060863],
            [-1.224178616764285, -6.712810571357483],
            [-1.2084085207232902, -6.741528876688486],
            [-1.1589615801116062, -6.830165015307016],
            [-1.1364948769681167, -6.870594809215984],
            [-1.0876276982314528, -6.957488789694734],
            [-1.0331309488911569, -7.054406338802619],
            [-1.125239887833113, -7.10690843881855],
            [-1.1425579490292725, -7.116564010179891],
            [-1.2319068575509735, -7.167167903462516],
            [-1.2989219481792678, -7.204820394916228],
            [-1.359884731335106, -7.238898125328868],
            [-1.3883452509449343, -7.255097395834657],
            [-1.4483560517451624, -7.2891779817492255],
            [-1.4668317495657066, -7.300406086357384],
            [-1.5272776810910842, -7.196610733459525],
            [-1.5403145335340256, -7.173502751774293],
            [-1.558211388003397, -7.142519057224972],
            [-1.5897884349651517, -7.087171805098248],
            [-1.6236124732812856, -7.029870099574264],
            [-1.6094408642495162, -7.021718448785764],
            [-1.5052690848286043, -6.962503065562095],
            [-1.4817917363986042, -6.9488513654717865],
            [-1.4314265015986192, -6.919949066351947],
            [-1.3598238709991395, -6.878934007123438],
            [-1.4018634830838645, -6.802349637862236]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.1106900071004, "lat": 31.704816180480474 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48193"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "01383882"
      },
      "bbox": [
        -1.6236124732812856, -7.300406086357384, -1.0331309488911569,
        -6.705981865060863
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5300388165091473, -8.270268878540662],
            [-0.5051101861264048, -8.255503067086002],
            [-0.44034439931312497, -8.217529060619539],
            [-0.36421577465356303, -8.173055504742445],
            [-0.3626000829350253, -8.178408067396223],
            [-0.3586923306590889, -8.177944138649336],
            [-0.3561363601514958, -8.181127291899951],
            [-0.3489056471184464, -8.186838546743154],
            [-0.3454380332900825, -8.184014591096082],
            [-0.33800958095475464, -8.187479836740497],
            [-0.3317653253089418, -8.186978789673635],
            [-0.32662313048362956, -8.190896054737427],
            [-0.321050534343106, -8.200375038030165],
            [-0.3205096495357188, -8.206909159078243],
            [-0.3177168741661553, -8.207721254564849],
            [-0.31368156150160387, -8.2219136863305],
            [-0.31548645293286515, -8.227202078761604],
            [-0.3114987245651743, -8.230716975167928],
            [-0.3066031005611386, -8.242952940951762],
            [-0.3074975475804745, -8.246205499002494],
            [-0.3118934380716041, -8.248386838566041],
            [-0.3137269308778562, -8.256515628900663],
            [-0.3103309004802438, -8.26971103990896],
            [-0.30529568342604724, -8.270163646999887],
            [-0.2995766535195646, -8.268263137972534],
            [-0.29533493184611187, -8.268379569510424],
            [-0.2896535453660362, -8.274639222188505],
            [-0.2882517147909301, -8.28043307682738],
            [-0.29089310253776396, -8.282369374118886],
            [-0.28692541939243776, -8.285487346159076],
            [-0.28693058813382766, -8.29096071720438],
            [-0.2854704383394931, -8.294505835374858],
            [-0.28022119971919884, -8.297412814025327],
            [-0.27478169883909503, -8.296014967828548],
            [-0.2691465921781587, -8.298462621778498],
            [-0.26448076563418244, -8.298774545784767],
            [-0.263933521343177, -8.30242115674744],
            [-0.25956182956965884, -8.30572350302153],
            [-0.2587351078601408, -8.30923558490189],
            [-0.2544976211133562, -8.307357987709258],
            [-0.2536940548904137, -8.310401822427435],
            [-0.25023354404915377, -8.311809904290785],
            [-0.2435766043369856, -8.31730715053749],
            [-0.24134972394243298, -8.32313089131848],
            [-0.23337349351233222, -8.325760283699974],
            [-0.23425827986328612, -8.3290342843394],
            [-0.23209189622952217, -8.333598925023193],
            [-0.22715683992177738, -8.33560217690663],
            [-0.22412328760244396, -8.339105061400023],
            [-0.21959197479548373, -8.338713382235579],
            [-0.21438459994140996, -8.341275189703694],
            [-0.21622170829591555, -8.346671625489925],
            [-0.209872566168212, -8.353869664954543],
            [-0.20843055237416666, -8.35807040513523],
            [-0.2036104568176373, -8.36079269165317],
            [-0.19929201005819713, -8.36539096322417],
            [-0.198243586087537, -8.372314873844731],
            [-0.1958479152471294, -8.37630262004146],
            [-0.1942356127130354, -8.383116642523946],
            [-0.1902212447924396, -8.390059443656378],
            [-0.18616862464010395, -8.389314350600147],
            [-0.18486932921019342, -8.391990566967287],
            [-0.1862737394453434, -8.400696921838245],
            [-0.18045508708054525, -8.40265609916465],
            [-0.17730511389219275, -8.406068861825702],
            [-0.178399221856591, -8.408101865347936],
            [-0.1744041720051192, -8.411264313356297],
            [-0.16605114441300253, -8.406610118129635],
            [-0.16167465029864508, -8.406738434117331],
            [-0.1583728706503868, -8.411153446861613],
            [-0.15355242185607415, -8.409937904384048],
            [-0.14555175615516772, -8.412426088497252],
            [-0.1390418578327044, -8.409516626092461],
            [-0.1348749022473624, -8.41003740361864],
            [-0.12815252593668938, -8.41311320194571],
            [-0.1270188486863451, -8.418607292524912],
            [-0.1243945617728378, -8.420980469075513],
            [-0.12050619545438261, -8.42042829391091],
            [-0.11800039320171417, -8.425173685542081],
            [-0.11335052980835801, -8.426879884060106],
            [-0.11227429861608014, -8.43262172851912],
            [-0.10836398600206033, -8.434643483236416],
            [-0.10390395354618259, -8.43082160021498],
            [-0.09583423741027414, -8.431060826652983],
            [-0.08867454701471858, -8.433551435538014],
            [-0.08985662872729197, -8.436750016829965],
            [-0.09518180371695706, -8.4380697558186],
            [-0.1034004205115209, -8.442378596255034],
            [-0.1065701766364969, -8.45130594833121],
            [-0.11279030230919858, -8.454268968906165],
            [-0.11579374219840421, -8.462520948950827],
            [-0.11978099913934769, -8.463238998577545],
            [-0.12254422445417312, -8.47068663741533],
            [-0.12722983769584195, -8.473681947524142],
            [-0.12628119674700222, -8.479135512212642],
            [-0.12886723253687282, -8.48154123139401],
            [-0.13830516476113347, -8.480090234725859],
            [-0.14650581010472796, -8.48411575308532],
            [-0.14939430504008666, -8.483985462829445],
            [-0.1529456064154585, -8.479711141839937],
            [-0.15587228011100182, -8.47895522055088],
            [-0.16288585915346568, -8.485527058845697],
            [-0.16754366575693255, -8.485532329526366],
            [-0.17200181634028683, -8.497256944846955],
            [-0.17630207229990222, -8.501059407551997],
            [-0.17468448690332716, -8.508293072357464],
            [-0.17784425530557696, -8.510829224733477],
            [-0.17760362939810678, -8.51444253933228],
            [-0.17467878614641869, -8.522147414129664],
            [-0.17475937305419934, -8.5256976361611],
            [-0.1783685397822732, -8.532807926874634],
            [-0.22226878763835173, -8.567511038652105],
            [-0.26696064843450024, -8.611210187166902],
            [-0.2822328334118619, -8.619114635856599],
            [-0.386280994043064, -8.675832876834223],
            [-0.41756937464925326, -8.692926497701452],
            [-0.42194085465949854, -8.67364428244958],
            [-0.4505492744854086, -8.547959996384156],
            [-0.4691697125472068, -8.46722575473578],
            [-0.5691407866733115, -8.388654934663391],
            [-0.6384328583510295, -8.349234740657666],
            [-0.6849909835003248, -8.32230153904643],
            [-0.6607877642064659, -8.314374348748633],
            [-0.603251438233582, -8.295179638679553],
            [-0.5300388165091473, -8.270268878540662]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.96571363323676, "lat": 30.31068325005346 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48287"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "287",
        "coty_gnis_code": "01383929"
      },
      "bbox": [
        -0.6849909835003248, -8.692926497701452, -0.08867454701471858,
        -8.173055504742445
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9987412202910864, -10.027497899227004],
            [-1.9772284469283348, -10.027799102590736],
            [-1.8405091579879147, -10.030914862261923],
            [-1.7400001315652858, -10.033626449431509],
            [-1.6394903986411073, -10.036313267242406],
            [-1.5892798827899703, -10.037441823273445],
            [-1.5901390107823459, -10.072431088341462],
            [-1.5935488571510246, -10.233992047343456],
            [-1.5950779444119652, -10.297785609982492],
            [-1.5974118782116016, -10.38382551720095],
            [-1.5980261712850443, -10.41248792773513],
            [-1.6005609276158543, -10.51508775896586],
            [-1.603105409746373, -10.616627820059458],
            [-1.676568289069526, -10.614956805353778],
            [-1.7500308615557885, -10.613271590287434],
            [-1.8841491255845824, -10.609614310655159],
            [-2.0182660451205883, -10.605909682782798],
            [-2.0162083080300266, -10.561304970599117],
            [-2.010468119649396, -10.428826212406019],
            [-2.0107299111480232, -10.41709348253421],
            [-2.004779999291779, -10.226809853616325],
            [-2.0037560682125273, -10.198776286522733],
            [-2.000089291027363, -10.049102894441983],
            [-1.9987412202910864, -10.027497899227004]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.56788282351461,
          "lat": 28.352645806365015
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48311"],
        "coty_name": ["McMullen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McMullen County"],
        "coty_fp_code": "311",
        "coty_gnis_code": "01383947"
      },
      "bbox": [
        -2.0182660451205883, -10.616627820059458, -1.5892798827899703,
        -10.027497899227004
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5438900580850925, -5.85559667828384],
            [1.5871879552940946, -5.8546690828109],
            [1.6917791798663415, -5.852784528489498],
            [1.7164795711557808, -5.852209090256317],
            [1.7886124384829654, -5.850978101630559],
            [1.8323392283939754, -5.849969257509498],
            [1.9777354518213965, -5.847144750544377],
            [2.0316297079725723, -5.845756746743584],
            [2.090028820082942, -5.844555877880636],
            [2.097157669834274, -5.844268422978633],
            [2.09744066216796, -5.853875934858309],
            [2.0987725794534184, -5.927931570797418],
            [2.09944930998283, -5.957426832945579],
            [2.1008346045909247, -6.032408022657316],
            [2.0903017512121314, -6.03502726332078],
            [2.080768060417778, -6.036610367645199],
            [2.074329544886105, -6.038886406052412],
            [2.0674561066990695, -6.036118119021063],
            [2.061160061492433, -6.037010549699352],
            [2.0592385127267994, -6.034309538031023],
            [2.057709933785194, -6.0264809316779555],
            [2.0535611443477535, -6.020813431601846],
            [2.04671325639079, -6.0236748290040385],
            [2.0429173453738065, -6.022892446569627],
            [2.037972384522484, -6.018017253876051],
            [2.0402202377326377, -6.012635922150554],
            [2.0488195756977543, -6.012340762075124],
            [2.0495260856380177, -6.014822181432951],
            [2.056431064312138, -6.014131562857183],
            [2.059491583126962, -6.00734356919443],
            [2.06292279488975, -6.0048885432100745],
            [2.0598965024828595, -6.001131711508137],
            [2.0512389149553516, -6.000548710450778],
            [2.056747399570652, -5.997119009897368],
            [2.058732854497512, -5.993832335573552],
            [2.053630179093146, -5.993095496262387],
            [2.0498583033970506, -5.988358336116635],
            [2.045587488468924, -5.9924726285426155],
            [2.042366642316525, -5.988540738319956],
            [2.036000633317735, -5.989140580759151],
            [2.03332717078479, -5.987346939824569],
            [2.025968560567557, -5.988457801962069],
            [2.01599896095878, -5.985622141768035],
            [2.0137277841978283, -5.988362001390877],
            [2.015479953304535, -5.994157723598132],
            [2.0116867771907283, -5.996797906981746],
            [2.0102531498818403, -6.001499535210187],
            [2.0067240170648635, -6.001409662660395],
            [2.0011712887787536, -6.005953336359762],
            [1.9995542017924308, -6.0145153350559895],
            [1.997035487586557, -6.017161138995484],
            [1.993985024465367, -6.024934752039534],
            [1.9928618876970816, -6.030674193886321],
            [1.9893369615430179, -6.032948647529214],
            [1.976012989910721, -6.029941169191326],
            [1.9645378860236962, -6.024525542684572],
            [1.9577164952107784, -6.026614335016859],
            [1.9505054871072853, -6.024999880407347],
            [1.9489964359484093, -6.019050792750803],
            [1.941694159890504, -6.0151919948537005],
            [1.9458540927548176, -6.003972656451807],
            [1.9452451100596153, -5.9998655160153],
            [1.9412421468181125, -5.996339463951644],
            [1.9416165154199665, -5.989166097263315],
            [1.9393469765753966, -5.9845640805218006],
            [1.935444010771861, -5.982535713180097],
            [1.932745337722883, -5.977940322611479],
            [1.9279268088309318, -5.979496762214015],
            [1.9221615276222077, -5.97720363651556],
            [1.919707432783429, -5.979612970493377],
            [1.9116049714726047, -5.98323449665655],
            [1.9052160840978714, -5.978693000805158],
            [1.9012250943762574, -5.979664508588446],
            [1.8991988062900325, -5.982553797898021],
            [1.8951914281884774, -5.99357655688626],
            [1.8968137083248835, -5.999237884453564],
            [1.8921518290110035, -6.002071962929549],
            [1.882483807234004, -6.004646574189361],
            [1.871093216773131, -5.999958180384797],
            [1.8681151920629289, -6.00511049754152],
            [1.864757764257466, -6.007851930553708],
            [1.8620878196062824, -6.007053223191541],
            [1.8614519241289955, -6.013855054148775],
            [1.8588477251736626, -6.0151792347333854],
            [1.852748707533452, -6.013576554600699],
            [1.8472085549573298, -6.017268540772226],
            [1.8455274807715836, -6.021265659780837],
            [1.8410440042850194, -6.025198967649833],
            [1.8383879116113262, -6.024589364482112],
            [1.8302659090632813, -6.029776071841287],
            [1.8258376763742057, -6.027856691118619],
            [1.8239446370481336, -6.032400062427284],
            [1.8158248651547595, -6.037426033957783],
            [1.8100117184060514, -6.036486666486459],
            [1.71253272603283, -6.038707952123784],
            [1.6706491208179608, -6.014130632659019],
            [1.6673114374510978, -6.011923831813065],
            [1.6347664171414455, -5.992808915672704],
            [1.5481925204766365, -5.941700876441756],
            [1.5478174106985305, -5.914258120060818],
            [1.5724961443849998, -5.899666222151279],
            [1.5674012832133517, -5.896505080727808],
            [1.566098700150053, -5.8982035351842095],
            [1.5607951657705643, -5.894424305212454],
            [1.5600700177078304, -5.891822991136669],
            [1.5501203487715527, -5.889659071534138],
            [1.549083063020646, -5.884370461478312],
            [1.5507225532221565, -5.875536079116079],
            [1.5471034929526477, -5.87210907089479],
            [1.5437665670084018, -5.873413505514155],
            [1.5421843606855294, -5.8596687517841755],
            [1.5438900580850925, -5.85559667828384]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.35720085610374, "lat": 32.79800053313034 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48315"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "315",
        "coty_gnis_code": "01383940"
      },
      "bbox": [
        1.5421843606855294, -6.038886406052412, 2.1008346045909247,
        -5.844268422978633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6638070097036637, -7.975790480324054],
            [-0.6406550908662604, -7.912622087280784],
            [-0.6135370624870696, -7.840170818583067],
            [-0.6060662116386728, -7.834771041685451],
            [-0.5456538208697795, -7.80041840033999],
            [-0.4508140762730231, -7.746296270373826],
            [-0.38157729380362104, -7.706020069569205],
            [-0.33921633385764727, -7.680737267387967],
            [-0.31434522074365767, -7.665275286899848],
            [-0.24422023555361702, -7.624684870131704],
            [-0.24502863786679685, -7.629839938101215],
            [-0.24523633091284497, -7.634616257252694],
            [-0.23363533260326952, -7.644462783969802],
            [-0.22713645553576672, -7.654767461587784],
            [-0.23346548920142599, -7.661401444201521],
            [-0.23652573362513268, -7.666524663114357],
            [-0.23740179876409237, -7.672402127584186],
            [-0.23467595870971955, -7.675731235594088],
            [-0.2290257110454459, -7.676667068195578],
            [-0.22281524019866153, -7.6748144416901765],
            [-0.2171969865195195, -7.6709629640649455],
            [-0.2110309304438176, -7.670755504760531],
            [-0.20823237970685632, -7.67408931853482],
            [-0.20779771961125287, -7.682987074890712],
            [-0.20676692372479458, -7.6859601762102585],
            [-0.2011467703860731, -7.687042917364449],
            [-0.19491387856053033, -7.685282884173287],
            [-0.19121496919059042, -7.688007750655343],
            [-0.19147215559461875, -7.692320341745937],
            [-0.19544416381684956, -7.696112936989488],
            [-0.2012523231901427, -7.699399301862292],
            [-0.2021457798869735, -7.7037293530789],
            [-0.20036450709556064, -7.706606809119262],
            [-0.19426866451236033, -7.708312142150791],
            [-0.19447172156473938, -7.712248039291071],
            [-0.19758891194710662, -7.715435739168229],
            [-0.19733835623924886, -7.723208143948957],
            [-0.19550069059423839, -7.732106336031031],
            [-0.1939730868358127, -7.734864966024313],
            [-0.19045151605240737, -7.735197304151704],
            [-0.18200030695866945, -7.72962448059076],
            [-0.17467143139313202, -7.734082254517844],
            [-0.17298621200506994, -7.740237037483343],
            [-0.17702850315214472, -7.745698022998185],
            [-0.18324068873754512, -7.74669284764174],
            [-0.18551229332383531, -7.756524429512355],
            [-0.19534888797144784, -7.762517477036172],
            [-0.19662581552555955, -7.770095155669279],
            [-0.1938740601344407, -7.776101985488127],
            [-0.19032848107055356, -7.7759117037868695],
            [-0.18659292751823287, -7.779192095589266],
            [-0.18219816789640955, -7.79104557522621],
            [-0.18416311006801103, -7.803771362698775],
            [-0.1831548608104438, -7.807304860079006],
            [-0.17027056547471975, -7.819658936960475],
            [-0.16127055861180967, -7.818499871981829],
            [-0.1603074728180421, -7.8215019317324925],
            [-0.16451596801907384, -7.827248532221774],
            [-0.1635866658932123, -7.832829534806592],
            [-0.15761332060810448, -7.83600463625944],
            [-0.14894825163555847, -7.837359377719453],
            [-0.13990688900203702, -7.828844087482027],
            [-0.13540834750407826, -7.826661384966909],
            [-0.1281726203596193, -7.82578986053782],
            [-0.1221868950099443, -7.828788689804374],
            [-0.12082018312439143, -7.832863078362844],
            [-0.1240977287869654, -7.838218683502509],
            [-0.13046192731275538, -7.835984112583157],
            [-0.13293378510170986, -7.837936356209124],
            [-0.1315631411581665, -7.8421220673806635],
            [-0.12794357282911326, -7.846092434621601],
            [-0.12169684805967769, -7.850009817155035],
            [-0.12161970931240199, -7.855294602733253],
            [-0.12975189265617418, -7.855287884567201],
            [-0.1318861262602756, -7.859423042518345],
            [-0.13156278523310155, -7.868485344868863],
            [-0.12913042796796226, -7.873420201884824],
            [-0.1203116377667038, -7.882884494586962],
            [-0.11776156286352392, -7.890410083035935],
            [-0.1099620129851442, -7.8927763207998565],
            [-0.11014166747710287, -7.900572268378412],
            [-0.10184918997531107, -7.9051093130303345],
            [-0.09402268980756563, -7.907564444964361],
            [-0.08905199445147208, -7.911284858196378],
            [-0.08549189703602544, -7.916453496224721],
            [-0.08265873010560053, -7.923292494530484],
            [-0.0810150988964973, -7.930155094387749],
            [-0.08159132014857491, -7.937585707038776],
            [-0.08342300619685722, -7.939737481478785],
            [-0.08963451372132884, -7.942759558544569],
            [-0.09276541791582135, -7.949504138571347],
            [-0.09048861584640722, -7.95508943539282],
            [-0.08663412728526387, -7.957326768760461],
            [-0.08385645571434736, -7.9561338369763135],
            [-0.07880738958674428, -7.951269703370273],
            [-0.0713286201877794, -7.954350426961682],
            [-0.06768442563892386, -7.965689262867389],
            [-0.061957518773832654, -7.974048016659773],
            [-0.0609243721707803, -7.97781681630328],
            [-0.06328771642316774, -7.984017301270274],
            [-0.06677151491887091, -7.985861540090609],
            [-0.07306166161231636, -7.984420764178715],
            [-0.0786824140218066, -7.992969272380613],
            [-0.06905758609884502, -8.003237478435752],
            [-0.13750484797774928, -8.043188721702595],
            [-0.16222677330314136, -8.057314955498699],
            [-0.2238679851305708, -8.09216560796443],
            [-0.28970875535962787, -8.130207321215064],
            [-0.36421577465356303, -8.173055504742445],
            [-0.44034439931312497, -8.217529060619539],
            [-0.5051101861264048, -8.255503067086002],
            [-0.5300388165091473, -8.270268878540662],
            [-0.5577315928700624, -8.189293564923052],
            [-0.5854149792834029, -8.108287426025719],
            [-0.597685663804793, -8.073602011135936],
            [-0.6105235788368961, -8.034972742518224],
            [-0.6250066571731309, -7.993194284499161],
            [-0.6638070097036637, -7.975790480324054]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.97686241604832, "lat": 30.78629504048557 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48331"],
        "coty_name": ["Milam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Milam County"],
        "coty_fp_code": "331",
        "coty_gnis_code": "01383951"
      },
      "bbox": [
        -0.6638070097036637, -8.270268878540662, -0.0609243721707803,
        -7.624684870131704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.14190237531726585, -6.4125044485106875],
            [0.1487692000178982, -6.416572791281563],
            [0.1550496403306627, -6.4237571772408275],
            [0.16167388493814377, -6.424844287368816],
            [0.1669175733463638, -6.429855825264038],
            [0.1734402919938915, -6.428770755918936],
            [0.1759102940956114, -6.43385249100913],
            [0.18545378113284136, -6.438089751115552],
            [0.1909932626367683, -6.438458366550292],
            [0.192081638750866, -6.435392226374457],
            [0.19818747957884533, -6.439073829125523],
            [0.20088329814233316, -6.438492300752053],
            [0.20337329959777412, -6.441692062365733],
            [0.2079212787997095, -6.439605860133213],
            [0.21115109150602882, -6.440299354935939],
            [0.21437306785443117, -6.44350604464602],
            [0.21361447859501076, -6.448360506630998],
            [0.22082393928378882, -6.4484625181523745],
            [0.21911292000521915, -6.452495957507538],
            [0.22227705391928745, -6.456187479433039],
            [0.22487617231041204, -6.462446271968717],
            [0.2242502871639121, -6.469750093124105],
            [0.22035315747415044, -6.471203707223919],
            [0.2243397905201295, -6.478008729369128],
            [0.2232230674685799, -6.485659258497967],
            [0.2301024183853449, -6.4810191172275236],
            [0.23100850250512622, -6.485874918036066],
            [0.2344025196161579, -6.486070437451301],
            [0.23772165986490953, -6.482723868059256],
            [0.24106354741153072, -6.48947003392631],
            [0.24533682223447037, -6.491844846605635],
            [0.24788066141497547, -6.496634783243002],
            [0.25252712999602706, -6.494632617120021],
            [0.2543103298442893, -6.4906791598371125],
            [0.2668940454561533, -6.491741655998224],
            [0.26642484019082935, -6.494345289254002],
            [0.27072561527558453, -6.505560599973057],
            [0.27833606346378226, -6.508802342937632],
            [0.28100543953290147, -6.5084099611409885],
            [0.282881805457728, -6.517752992418127],
            [0.28607695725723664, -6.515330312605927],
            [0.28815343192979204, -6.5182580084341915],
            [0.2877471341633294, -6.52310565215218],
            [0.29148657829007313, -6.523549153861217],
            [0.29291758973658705, -6.527393011805695],
            [0.2983824550275173, -6.528811504714914],
            [0.2979355815372611, -6.53482232416241],
            [0.304180007916542, -6.5394545016422665],
            [0.3093714289683172, -6.5400188422250345],
            [0.3110251460204544, -6.5372249077963],
            [0.3157061955651215, -6.5378557804596396],
            [0.3228856425203171, -6.531975824114909],
            [0.33294475202342033, -6.526869791053909],
            [0.3370787379549995, -6.527718256026495],
            [0.3406675915510457, -6.5305978964593185],
            [0.3396682294481607, -6.534501982101458],
            [0.3308225628611742, -6.53606767619517],
            [0.3290830267448968, -6.541246535237905],
            [0.3324271213074162, -6.546220014484502],
            [0.33078837724280913, -6.550469228602466],
            [0.3261839952909393, -6.5512593458374],
            [0.31513458201792716, -6.560382365478158],
            [0.3160965337929288, -6.568379210851146],
            [0.31931154448374505, -6.573198748101839],
            [0.323546878155931, -6.575651493056281],
            [0.3244233566741817, -6.579178589558307],
            [0.3230958002124701, -6.583069242746977],
            [0.32980180159639466, -6.586844774017076],
            [0.33553288662675734, -6.5833455901813025],
            [0.3413058882005629, -6.588947785524738],
            [0.3534067097956514, -6.588825480885626],
            [0.3621923786435831, -6.585053981617852],
            [0.3662937213562631, -6.580893539557596],
            [0.36883081051874983, -6.58502113716168],
            [0.3757720816056826, -6.589150525508758],
            [0.3769954422856939, -6.591250524559841],
            [0.377452312489255, -6.5995227472333235],
            [0.37444857634821194, -6.606535029570784],
            [0.3697373688883188, -6.609790293415106],
            [0.367089193587247, -6.615267033578459],
            [0.36738231932162874, -6.62162465798943],
            [0.3697469433879385, -6.625936095763722],
            [0.3649573017655729, -6.637660011819937],
            [0.3644141339227409, -6.646719277476346],
            [0.369544314569358, -6.651167444382242],
            [0.37204907497722806, -6.656184228275209],
            [0.3716616835063605, -6.6645613741995735],
            [0.37489832173323906, -6.666335712464252],
            [0.3791834577695145, -6.663909830910742],
            [0.3798793805045746, -6.660412016936702],
            [0.3860600938896943, -6.659801339112007],
            [0.39495970171844735, -6.660224653695473],
            [0.4080884762442566, -6.655909700585334],
            [0.41060513652460784, -6.660854337525983],
            [0.41029964481442427, -6.665036400484359],
            [0.40511062316226404, -6.6652024815209305],
            [0.40741228017044767, -6.670273656282946],
            [0.4058891367834937, -6.6752851278586025],
            [0.4092169009524095, -6.67627257670055],
            [0.41113983490975886, -6.6797632071268005],
            [0.4076192969147396, -6.681632253046617],
            [0.4097570304694343, -6.690576414197012],
            [0.4079844109255679, -6.693756984304534],
            [0.4092093153072067, -6.69720004485465],
            [0.4076736360176743, -6.703872731330403],
            [0.41127325390918973, -6.710222386296371],
            [0.41014127739811435, -6.712422182766261],
            [0.41513400020371166, -6.72097484549134],
            [0.4209100550302469, -6.724815175154859],
            [0.41751379585690823, -6.7290584542462515],
            [0.33406275572077343, -6.776639696991603],
            [0.25366297557120493, -6.822688043535242],
            [0.17997541735525627, -6.864815610811149],
            [0.14420631098096764, -6.885734892433052],
            [0.043453342428858795, -6.943778147047301],
            [0.04045396027665982, -6.94325698925665],
            [-0.023652658639140123, -6.9365668123593105],
            [-0.14458300948217578, -6.923941212603657],
            [-0.20244140046825024, -6.8226920016136905],
            [-0.2440064829474424, -6.7501178801089745],
            [-0.291935134198182, -6.664203349238946],
            [-0.22435399034710904, -6.625384099040246],
            [-0.175629499586127, -6.5973087153280074],
            [-0.1282364712455553, -6.570558465033916],
            [-0.06260572637429686, -6.533631411968185],
            [0.0028240271893186994, -6.494796472796118],
            [0.10280212975522206, -6.4354995854842105],
            [0.13165224474902668, -6.417742713417611],
            [0.14190237531726585, -6.4125044485106875]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.47244291479674, "lat": 32.04698079674166 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48349"],
        "coty_name": ["Navarro"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Navarro County"],
        "coty_fp_code": "349",
        "coty_gnis_code": "01383960"
      },
      "bbox": [
        -0.291935134198182, -6.943778147047301, 0.4209100550302469,
        -6.4125044485106875
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.24961314677276, -5.720181784682422],
            [-1.1376311040704052, -5.724564891609442],
            [-1.0882227818865775, -5.7266613288225905],
            [-1.008798273659339, -5.730232399713882],
            [-0.935861461240093, -5.733288815623095],
            [-0.852330418815608, -5.735975486845228],
            [-0.8273650141536315, -5.7366336749705145],
            [-0.8232269673463071, -5.73738664393325],
            [-0.8243338656632709, -5.77860978716888],
            [-0.8273731052669171, -5.8649285370624575],
            [-0.827688617463485, -5.867933414889286],
            [-0.8289812496499401, -5.909759997461784],
            [-0.8320854733569968, -6.028979442500321],
            [-0.832852629703886, -6.050611317107412],
            [-0.8343699077847526, -6.120614230117176],
            [-0.8345448714373211, -6.1219866126691835],
            [-0.8357624509589413, -6.176275492946309],
            [-0.8645349848771308, -6.175897598368943],
            [-0.8914229906240337, -6.175260272130378],
            [-0.9635475661395426, -6.172999709152946],
            [-1.0105868935222369, -6.171674776566955],
            [-1.0438705392365213, -6.1710302837896345],
            [-1.107839003054388, -6.169435804201142],
            [-1.1447245233354295, -6.168957654048981],
            [-1.210454921769803, -6.166824742866276],
            [-1.2125643868260232, -6.166446595966538],
            [-1.2682868105275968, -6.164660002271198],
            [-1.2653478940116063, -6.106090561010406],
            [-1.2597239061753658, -5.974349503088746],
            [-1.2599149919066424, -5.973448719266442],
            [-1.2559593457085723, -5.881021913517968],
            [-1.2517869081938044, -5.777487375851843],
            [-1.24961314677276, -5.720181784682422]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.80507357416396,
          "lat": 32.777633050311245
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48367"],
        "coty_name": ["Parker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Parker County"],
        "coty_fp_code": "367",
        "coty_gnis_code": "01383969"
      },
      "bbox": [
        -1.2682868105275968, -6.176275492946309, -0.8232269673463071,
        -5.720181784682422
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.497294013242287, -8.29532387904478],
            [-4.402506403942117, -8.300479470887078],
            [-4.389410011978686, -8.301726083505041],
            [-4.316114410768899, -8.305874921395636],
            [-4.16768639197934, -8.314477887006522],
            [-4.059761743378025, -8.3202201023606],
            [-4.056647136940416, -8.320598905693252],
            [-3.9058879054791804, -8.329054971083282],
            [-3.849032733277328, -8.332390167410342],
            [-3.8448845012101374, -8.331866024452044],
            [-3.820535102657956, -8.33361049083184],
            [-3.8106909421597694, -8.333941273051805],
            [-3.6727326047786897, -8.340676937093026],
            [-3.586604815460678, -8.3447233909276],
            [-3.608165257955697, -8.78375638318957],
            [-3.6119089890372447, -8.861559319838566],
            [-3.619116761284278, -9.000036997207276],
            [-3.6190804958268106, -9.001362274467624],
            [-3.6250687527164063, -9.11984179168249],
            [-3.6284838648540374, -9.202738394647067],
            [-3.630666934052535, -9.208038878891902],
            [-3.6312372352263176, -9.21643566243547],
            [-3.6354090290692875, -9.220447846624293],
            [-3.6378186336161895, -9.234567594190503],
            [-3.636803029299193, -9.238045623697515],
            [-3.638783950229801, -9.248208666998027],
            [-3.6409653603343246, -9.251498386487981],
            [-3.637482250150438, -9.25746485992912],
            [-3.6418107674206373, -9.268632201415132],
            [-3.641614871933161, -9.27425358370068],
            [-3.6438985270114026, -9.282861916209523],
            [-3.6490693239401755, -9.285864185724714],
            [-3.653382356047024, -9.285751383426401],
            [-3.65775107314263, -9.288282783639662],
            [-3.6647615757661125, -9.290260228873152],
            [-3.6698959778128146, -9.290134807959744],
            [-3.67443258379222, -9.293395858280718],
            [-3.6744689653755747, -9.297614552170971],
            [-3.672501422974091, -9.30462040381936],
            [-3.677243142797872, -9.313704938227445],
            [-3.6745757608705603, -9.323802304791997],
            [-3.669669327611381, -9.328494967825058],
            [-3.6694172126789666, -9.336691936927517],
            [-3.673387328947704, -9.339365044467602],
            [-3.6736595426044274, -9.348938892845643],
            [-3.676380244710235, -9.353345961668326],
            [-3.677106677997601, -9.363271924437885],
            [-3.6812365859345864, -9.363722816545941],
            [-3.6853663791563105, -9.36162115889083],
            [-3.691895192352971, -9.366004149321244],
            [-3.6925289856810477, -9.368671218363936],
            [-3.6880960248826478, -9.375669434941464],
            [-3.6886181077528337, -9.378978721258628],
            [-3.6930244205014753, -9.379311703381818],
            [-3.699795238913559, -9.373131508911666],
            [-3.706604026848355, -9.369891942505731],
            [-3.712703229821807, -9.369951237176354],
            [-3.7207469247036666, -9.374153777720819],
            [-3.7229320524042175, -9.368766632039874],
            [-3.7315750874112257, -9.362659891361018],
            [-3.7383495519038137, -9.361374279201689],
            [-3.7386401608039113, -9.358389601545872],
            [-3.73580753100911, -9.353100431162147],
            [-3.7388993460106374, -9.350799019846516],
            [-3.7447307912361603, -9.353064458036432],
            [-3.7539074945648445, -9.352941736959968],
            [-3.758150693388218, -9.35089280581786],
            [-3.766144988209877, -9.34243053490488],
            [-3.770341183975852, -9.340839447769202],
            [-3.772731402527319, -9.337908343281518],
            [-3.779848529714426, -9.337142011272357],
            [-3.7913405864019007, -9.331835769549718],
            [-3.792904094312344, -9.326387922077183],
            [-3.7938288879258892, -9.313749546344152],
            [-3.79755027523546, -9.304865929760794],
            [-3.804468794025318, -9.302041985475439],
            [-3.806027029267438, -9.303193427181188],
            [-3.8130115355402663, -9.29996830195463],
            [-3.8158583196692586, -9.294966275422524],
            [-3.822913404319547, -9.292356884124647],
            [-3.824100357140395, -9.28741346449413],
            [-3.8285942450081887, -9.28457772767118],
            [-3.8328566364280516, -9.28417083072093],
            [-3.837589887176055, -9.28029984233325],
            [-3.8430859083605493, -9.277587635559577],
            [-3.844872522076508, -9.268727193307473],
            [-3.8496287545791, -9.263285099663403],
            [-3.862992785488526, -9.262501766677147],
            [-3.869241571613682, -9.25819850691371],
            [-3.8700969921785253, -9.25501836624001],
            [-3.8788514832434204, -9.250044164259855],
            [-3.889388529113149, -9.245266828949651],
            [-3.896803549163394, -9.24352878020943],
            [-3.902175992164029, -9.239398527547355],
            [-3.905074590411543, -9.233858269528206],
            [-3.9038097398157787, -9.228766034844215],
            [-3.906515273255711, -9.220786704276549],
            [-3.910296539867401, -9.214930855583855],
            [-3.9125206699924187, -9.214125922810053],
            [-3.9228182400247626, -9.201322891304661],
            [-3.924310982705946, -9.196692486750331],
            [-3.925511885213574, -9.184626817000504],
            [-3.9274396335246764, -9.177585095108999],
            [-3.9333995687170673, -9.172586126955402],
            [-3.9386844705661517, -9.166227302300916],
            [-3.940510630668195, -9.148448168883395],
            [-3.955026529439475, -9.142217130741107],
            [-3.963411519316488, -9.136609356308806],
            [-3.9777395605442987, -9.134727096541546],
            [-3.9878980424916604, -9.136254714669722],
            [-4.0002142360812645, -9.125750177265981],
            [-4.006967191855942, -9.13021269028272],
            [-4.012924415777186, -9.13018689563532],
            [-4.0192757452240615, -9.126130253164654],
            [-4.027531871349347, -9.112913472636263],
            [-4.032006357817406, -9.102282385656157],
            [-4.03501057223743, -9.098641991851233],
            [-4.03630830691812, -9.088073842523256],
            [-4.04162640807743, -9.087036913741255],
            [-4.052417497417104, -9.081549590056797],
            [-4.082451686609036, -9.077879895548481],
            [-4.0891391365314025, -9.075039523051158],
            [-4.101951982709246, -9.078282212050935],
            [-4.106433746587492, -9.078558610249738],
            [-4.111065580718761, -9.068819302988361],
            [-4.110980517235896, -9.062054579269997],
            [-4.105163016694718, -9.049978789575714],
            [-4.098409741071631, -9.04023516002093],
            [-4.092007460804774, -9.034748962430879],
            [-4.09724782912703, -9.009455435106377],
            [-4.099545956166984, -8.996012560139514],
            [-4.094539058066597, -8.982442349775114],
            [-4.096779958542127, -8.976370023030535],
            [-4.100380568632771, -8.973182879430738],
            [-4.107202118408804, -8.969254184599793],
            [-4.112797989625636, -8.969698701669296],
            [-4.120665831199653, -8.97817503140014],
            [-4.12342110599035, -8.984148854909947],
            [-4.121307121757747, -8.991921609743821],
            [-4.122485001900588, -9.007931204406106],
            [-4.129213692950287, -9.016081007615112],
            [-4.134920078466084, -9.026355904933911],
            [-4.13978652186768, -9.02459011275114],
            [-4.1472149151354385, -9.019358491632655],
            [-4.1522064863858485, -9.011618072755274],
            [-4.152779174891608, -8.997765187320644],
            [-4.151924051770347, -8.986329482964978],
            [-4.149727368545017, -8.980774955453112],
            [-4.14587641685846, -8.97439227040122],
            [-4.140383220824625, -8.963227973173796],
            [-4.138988091252998, -8.957898542784301],
            [-4.139800027030478, -8.95118640358749],
            [-4.141616275942793, -8.945758678261159],
            [-4.146960937030148, -8.940449625714553],
            [-4.150869571223496, -8.938797456950958],
            [-4.177168662350434, -8.934307274033449],
            [-4.1814475170184355, -8.9355894868463],
            [-4.18799839110809, -8.946500856126054],
            [-4.193080286056842, -8.942881023106],
            [-4.19439479289168, -8.928381512811049],
            [-4.195420777024131, -8.924676692652797],
            [-4.199748852679824, -8.917555334475368],
            [-4.200054299373102, -8.915218957918482],
            [-4.198256830403204, -8.901695127517257],
            [-4.198723319285036, -8.896249954860092],
            [-4.2008539122203805, -8.893775620029515],
            [-4.211552401962403, -8.887573974020118],
            [-4.218855375010341, -8.880747628543668],
            [-4.219907499933483, -8.877665820209494],
            [-4.2175443569209135, -8.867843002841612],
            [-4.217771697710919, -8.860990279499363],
            [-4.2206805927584705, -8.856751266801261],
            [-4.228620185302373, -8.85291912927059],
            [-4.233150459936245, -8.847677142687491],
            [-4.2321339242571625, -8.84163050281032],
            [-4.222422032049034, -8.837335812085614],
            [-4.219013606470074, -8.835055683065349],
            [-4.217294879786503, -8.82785565689921],
            [-4.220890549533408, -8.823706041417395],
            [-4.226764204270718, -8.824185631157942],
            [-4.239778465333007, -8.832668920426789],
            [-4.250129314874948, -8.840856034305867],
            [-4.258884077455774, -8.843387589347769],
            [-4.262958168066972, -8.839294462220385],
            [-4.266037807625008, -8.820722052016487],
            [-4.263040203346753, -8.810050136894132],
            [-4.265509874460091, -8.804859606006008],
            [-4.270561480472442, -8.802676810847693],
            [-4.282492436006952, -8.805885314522687],
            [-4.287590967190819, -8.809298936561586],
            [-4.292501397660951, -8.81624890391739],
            [-4.308029726971129, -8.825549156557148],
            [-4.311478232439014, -8.826085433014391],
            [-4.321975122060152, -8.824736308961738],
            [-4.332892982319963, -8.829380269558614],
            [-4.336614623516432, -8.829500661306863],
            [-4.339345539872779, -8.82653053201028],
            [-4.337921695678711, -8.815528711391268],
            [-4.336967337483496, -8.80226165175828],
            [-4.333633177978684, -8.791296290727656],
            [-4.338835026823229, -8.77801745893484],
            [-4.344151744030205, -8.778432737673397],
            [-4.34837920048975, -8.783952952525905],
            [-4.361915365276851, -8.78862376983372],
            [-4.367715096043598, -8.797927773889558],
            [-4.367448387851658, -8.813725222383487],
            [-4.371691893993661, -8.8173844233612],
            [-4.386660301400868, -8.81374571699314],
            [-4.390341510738904, -8.811636431305878],
            [-4.398202887560575, -8.811325477636348],
            [-4.407039029893241, -8.814521627916784],
            [-4.413944975761568, -8.812995240640179],
            [-4.417859789888438, -8.815077737925133],
            [-4.420314863899772, -8.8222277815068],
            [-4.422620500023661, -8.824756924632384],
            [-4.432658501390054, -8.828496817368361],
            [-4.437573578891602, -8.823759619656263],
            [-4.439080218403918, -8.817363510134106],
            [-4.442489080569703, -8.815638390939306],
            [-4.4455357548432906, -8.81092422483396],
            [-4.453756308479492, -8.813501028445177],
            [-4.456740156218364, -8.81650836737037],
            [-4.457268672456864, -8.820331228156324],
            [-4.4626050792101095, -8.820312951396852],
            [-4.467159499238569, -8.811323825305749],
            [-4.4693872718109, -8.809581255198035],
            [-4.477853699666372, -8.814874094281205],
            [-4.48631200146906, -8.818057643669182],
            [-4.4890003849828535, -8.816773577697822],
            [-4.494045818785049, -8.80462518087497],
            [-4.4983489604450435, -8.802696745211199],
            [-4.503857897852945, -8.806911233266561],
            [-4.5085133132047135, -8.806879085122189],
            [-4.511882169133814, -8.804753133967472],
            [-4.51436483141751, -8.799453511007824],
            [-4.524702939637592, -8.799897808079978],
            [-4.530163595296238, -8.795410214272371],
            [-4.5241743269503445, -8.706404296324937],
            [-4.523682481173204, -8.70331281471829],
            [-4.516946712512915, -8.59213961522446],
            [-4.5156021324020275, -8.579875015077384],
            [-4.49912741805376, -8.323510981167242],
            [-4.497294013242287, -8.29532387904478]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.15173233857179,
          "lat": 29.89293350856645
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48465"],
        "coty_name": ["Val Verde"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Val Verde County"],
        "coty_fp_code": "465",
        "coty_gnis_code": "01384018"
      },
      "bbox": [
        -4.530163595296238, -9.379311703381818, -3.586604815460678,
        -8.29532387904478
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.958446753868543, -4.488196670741622],
            [-1.9487692072393377, -4.497434688526267],
            [-1.9392059538401096, -4.50878277413101],
            [-1.9333880564392674, -4.5182627106962885],
            [-1.9242545987492004, -4.524508341977679],
            [-1.910296769206324, -4.530113341743998],
            [-1.9054192103762946, -4.534712634472128],
            [-1.896249751341338, -4.535385737107027],
            [-1.893612605954502, -4.537972839420344],
            [-1.8943150861949787, -4.5425557767150515],
            [-1.8966564909455412, -4.5459173779691255],
            [-1.8953789455320873, -4.549408164548207],
            [-1.8912681199813197, -4.5535128399296365],
            [-1.8867151659508965, -4.554176332771763],
            [-1.8832144764013765, -4.55064224933656],
            [-1.8820607399715108, -4.542272831690533],
            [-1.8652574505203068, -4.547396845728426],
            [-1.8605199271194082, -4.541850284265379],
            [-1.8476356201119069, -4.546305256670983],
            [-1.8457252988858524, -4.546016938087855],
            [-1.8388492591826293, -4.55075514233741],
            [-1.8324410121608141, -4.562154995891289],
            [-1.8259242245195508, -4.558433550910425],
            [-1.8187421536222943, -4.565111268025689],
            [-1.8074806071359377, -4.569313906348879],
            [-1.8034823770050479, -4.57343748555116],
            [-1.8028995200907967, -4.578957317810775],
            [-1.8008180825315188, -4.5813077438446665],
            [-1.7944690101810787, -4.581888061779353],
            [-1.7884165270515335, -4.580764058374209],
            [-1.786305443179626, -4.578951608590864],
            [-1.781814527659367, -4.570675407399647],
            [-1.772328947793752, -4.5714262768560365],
            [-1.7668802335088498, -4.570912444310946],
            [-1.765360725861676, -4.574777429466168],
            [-1.7619621473188203, -4.575472046564953],
            [-1.7587204423115628, -4.5721102532974465],
            [-1.7538063289912413, -4.571235647667692],
            [-1.7508687701772863, -4.573804961874719],
            [-1.7460212616771034, -4.574493635519455],
            [-1.740539266413161, -4.568801600405215],
            [-1.7348984684134157, -4.5651947915493505],
            [-1.7166209780854522, -4.549907389083944],
            [-1.710223993715362, -4.543871660745412],
            [-1.7062408394504336, -4.543891769168692],
            [-1.6887518037979843, -4.551747133596193],
            [-1.679166432214752, -4.552051333131109],
            [-1.6741485898664186, -4.549078318232284],
            [-1.6707013678424905, -4.548848821785278],
            [-1.6592317005580486, -4.5574444580607665],
            [-1.6524248840954163, -4.561011334622519],
            [-1.6486843976082985, -4.565002356374031],
            [-1.644575921102834, -4.572133276057447],
            [-1.638941959257343, -4.577211690662115],
            [-1.6328928554743851, -4.5770061411170015],
            [-1.631578595806599, -4.582819251604517],
            [-1.6343032022181427, -4.583965171496283],
            [-1.6377640530773092, -4.582215359875106],
            [-1.6395179873363006, -4.586877984213499],
            [-1.6341216159051895, -4.591067210802625],
            [-1.631702098950611, -4.591340998368074],
            [-1.6199849640609776, -4.603702328191757],
            [-1.6136989561108568, -4.616310448007927],
            [-1.6046348247475568, -4.62556990456011],
            [-1.5945425896259056, -4.639597250178806],
            [-1.5863941944808595, -4.6422844056695105],
            [-1.5820932529743712, -4.646163353224741],
            [-1.580153361993446, -4.649708212858895],
            [-1.576637830802397, -4.650129347708687],
            [-1.5678575974384454, -4.646946611476117],
            [-1.5631740372376974, -4.639617208850618],
            [-1.560647137136041, -4.638923993266548],
            [-1.55387085627715, -4.6403636591963835],
            [-1.5492205075384966, -4.639594115325044],
            [-1.5464625450583511, -4.636284151490562],
            [-1.5446318461685815, -4.630981095429137],
            [-1.5415916999022892, -4.6288898109604295],
            [-1.5325607563914394, -4.627861545160132],
            [-1.528023753486, -4.6307108093176215],
            [-1.5296837430228754, -4.695162955590051],
            [-1.5312040776259384, -4.769567310818753],
            [-1.533926397972496, -4.878428852230614],
            [-1.534399765999676, -4.878425860582166],
            [-1.588491834978617, -4.877125989895033],
            [-1.617873981211125, -4.876712045480943],
            [-1.6850948745107164, -4.875345418986916],
            [-1.7971947676203417, -4.872696731282332],
            [-1.8768887621026782, -4.870657731627349],
            [-1.9709892071960635, -4.868148273462713],
            [-1.9688895780544717, -4.802634496353969],
            [-1.9640059050054528, -4.650844379073666],
            [-1.958446753868543, -4.488196670741622]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.7035389647991, "lat": 33.987948081539244 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48485"],
        "coty_name": ["Wichita"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wichita County"],
        "coty_fp_code": "485",
        "coty_gnis_code": "01384028"
      },
      "bbox": [
        -1.9709892071960635, -4.878428852230614, -1.528023753486,
        -4.488196670741622
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2959788273352122, -8.091989257168363],
            [-1.2494166363102215, -7.9976088728684935],
            [-1.2282305601087178, -7.954009640030297],
            [-1.2179393073189706, -7.933275542405295],
            [-1.1975470724611539, -7.9129299410734175],
            [-1.1447529641118461, -7.860963410840987],
            [-1.1409783857249383, -7.857500124914028],
            [-1.1002077937844672, -7.817599357890078],
            [-0.9742270312447714, -7.845071966181086],
            [-0.9262506319168424, -7.854920931214183],
            [-0.8319452423958688, -7.898478888827129],
            [-0.7378818328848031, -7.9417526408652],
            [-0.7147958186462104, -7.952291156881206],
            [-0.7135048792744098, -7.9533285683008295],
            [-0.6638070097036637, -7.975790480324054],
            [-0.6250066571731309, -7.993194284499161],
            [-0.6105235788368961, -8.034972742518224],
            [-0.597685663804793, -8.073602011135936],
            [-0.5854149792834029, -8.108287426025719],
            [-0.5577315928700624, -8.189293564923052],
            [-0.5300388165091473, -8.270268878540662],
            [-0.603251438233582, -8.295179638679553],
            [-0.6607877642064659, -8.314374348748633],
            [-0.6849909835003248, -8.32230153904643],
            [-0.7149416226873847, -8.305302150460188],
            [-0.7184089844949851, -8.30708498574981],
            [-0.7211672296481112, -8.305577035779901],
            [-0.7233896881836837, -8.30087992412821],
            [-0.7267946335234184, -8.300584052208372],
            [-0.7302810106325732, -8.291341816193386],
            [-0.7335914294941498, -8.287884768907272],
            [-0.7432773193384037, -8.284540911599496],
            [-0.746188859487015, -8.282316726562417],
            [-0.7484255120454998, -8.286347666769908],
            [-0.754001160193159, -8.286119921978024],
            [-0.7596381625239705, -8.280104656666275],
            [-0.7639811661963022, -8.27222386331328],
            [-0.7692935534022859, -8.271441638510034],
            [-0.7699054534823715, -8.264679938512844],
            [-0.7745657999536928, -8.264051868460031],
            [-0.7766150692230069, -8.268930138142203],
            [-0.7792807755020513, -8.268103645998492],
            [-0.7797843884224697, -8.262860751220853],
            [-0.7864622178072866, -8.26285714733241],
            [-0.7920078876604929, -8.265737319399872],
            [-0.7955407965118366, -8.263376773193109],
            [-0.7980371227514147, -8.258829205186192],
            [-0.8053905580316734, -8.256777653696757],
            [-0.8093136290713784, -8.253457314458212],
            [-0.8147520061932333, -8.254324433076597],
            [-0.8169823373039563, -8.250502235525438],
            [-0.8274591614851186, -8.246371872925405],
            [-0.8303587930113285, -8.242554567560218],
            [-0.8355137684084188, -8.238337625790377],
            [-0.8455405471369484, -8.246990750121395],
            [-0.8469961012587617, -8.251139213172054],
            [-0.8505384193701129, -8.247850618004286],
            [-0.8633687313120212, -8.243948907102817],
            [-0.86595618044776, -8.24761771345905],
            [-0.869369221573191, -8.246508385026784],
            [-0.868655229453363, -8.241910850309175],
            [-0.8716335173541601, -8.232772288448503],
            [-0.8806293058649931, -8.231101774799125],
            [-0.8808370076764396, -8.227403549690745],
            [-0.8852263567628713, -8.226731842553562],
            [-0.884624945392373, -8.223207441352884],
            [-0.8957169861427136, -8.22200781114959],
            [-0.903233642474765, -8.225210638294769],
            [-0.9044290664636401, -8.221707163926123],
            [-0.9085872297379185, -8.221070756024341],
            [-0.9172295923916466, -8.22721847645152],
            [-0.9179501267526773, -8.231992382046712],
            [-0.9271712318481659, -8.232722337404548],
            [-0.9281067270588832, -8.23175831823591],
            [-0.9361286005803113, -8.236688296120395],
            [-0.9477684243689621, -8.239694900708056],
            [-0.9496669052671226, -8.243592179228278],
            [-0.9565724843835086, -8.246630748895381],
            [-0.9671571355474214, -8.23980359067088],
            [-0.9723827294273976, -8.24286601997609],
            [-0.9760745525240051, -8.240445064844959],
            [-0.9835280378444663, -8.241032888011535],
            [-0.9889260054141402, -8.259450593983443],
            [-0.9951186788909016, -8.259341456943151],
            [-1.0020515121709512, -8.262094898397738],
            [-1.0116890939049916, -8.261777532353761],
            [-1.0277587645675867, -8.270362269491402],
            [-1.039049524029802, -8.270509732987868],
            [-1.0415175401059786, -8.272226138987929],
            [-1.0459812549532574, -8.279430888151275],
            [-1.0452233596685472, -8.286323106022857],
            [-1.0575839977144919, -8.286806513560204],
            [-1.0648241350253624, -8.28945256367079],
            [-1.0672838788148862, -8.280845807299103],
            [-1.0723638090814844, -8.27851620844913],
            [-1.0752531289517973, -8.274956694008404],
            [-1.0800857524663467, -8.274218932440933],
            [-1.0846153034314812, -8.271858118954654],
            [-1.09512602825651, -8.271730882613966],
            [-1.1045753342031164, -8.265235476314151],
            [-1.1075012744773276, -8.261132371019063],
            [-1.1243760343190745, -8.245046323991172],
            [-1.1237754937244537, -8.242850931852631],
            [-1.1374138974505181, -8.221088331194416],
            [-1.1320268735926469, -8.215733667171236],
            [-1.1316430947901288, -8.211188701091208],
            [-1.1349541220937425, -8.206249740779697],
            [-1.1412859361756094, -8.201172473583526],
            [-1.1447942388101293, -8.195741919977252],
            [-1.1412748837851423, -8.172212043231633],
            [-1.1581099784393831, -8.161848317762633],
            [-1.1587383598313428, -8.154579464640799],
            [-1.1611424661696566, -8.151959111385938],
            [-1.1648937276891997, -8.15347378808931],
            [-1.1704952910207094, -8.147001272115869],
            [-1.1872750824379883, -8.153709492698885],
            [-1.1916378149177518, -8.150225370099852],
            [-1.1811883752007124, -8.137620356464616],
            [-1.1855799657798105, -8.131372897553188],
            [-1.1867935770270053, -8.127196376314233],
            [-1.1823631383223063, -8.113477052671422],
            [-1.1974883229068756, -8.107799245236214],
            [-1.2118392271532323, -8.092714890798915],
            [-1.215939843110363, -8.08959608391452],
            [-1.224254489058133, -8.093965241545938],
            [-1.234205975972166, -8.095311177456022],
            [-1.2457490497823456, -8.107246077244495],
            [-1.2516691641291813, -8.103971796684554],
            [-1.2548878034048434, -8.095566299624222],
            [-1.25847645747721, -8.08944553300131],
            [-1.2642534271710915, -8.099993795747952],
            [-1.278854739700892, -8.101715108371986],
            [-1.2847520427005654, -8.104564852227018],
            [-1.2878739084749857, -8.09806879805506],
            [-1.2959788273352122, -8.091989257168363]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.60039534696237, "lat": 30.64751341034978 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48491"],
        "coty_name": ["Williamson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Williamson County"],
        "coty_fp_code": "491",
        "coty_gnis_code": "01384031"
      },
      "bbox": [
        -1.2959788273352122, -8.32230153904643, -0.5300388165091473,
        -7.817599357890078
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.22539971289208, 2.8529965222032407],
            [-11.222321787174897, 2.855781927784133],
            [-11.211215214292961, 2.857032600547877],
            [-11.20867200920109, 2.8554403485944393],
            [-11.201818911008168, 2.8572590856148086],
            [-11.197990307537568, 2.8624966373762217],
            [-11.198138125647372, 2.8655332515979897],
            [-11.195661446798109, 2.873057429153224],
            [-11.189929205423235, 2.880070094715413],
            [-11.184853647520288, 2.8799673909217045],
            [-11.179408878276634, 2.8823128669013918],
            [-11.170674630850083, 2.879692998459155],
            [-11.168910782045227, 2.876270188152921],
            [-11.165560713137042, 2.876246684236077],
            [-11.159318498506014, 2.8723313932377685],
            [-11.15126779729343, 2.870416692571332],
            [-11.144017197503667, 2.862432032812318],
            [-11.140912087069493, 2.8643622511046867],
            [-11.137514777698375, 2.871165526841861],
            [-11.139415986795544, 2.8782984977729007],
            [-11.13874593853645, 2.883420720732136],
            [-11.131550223731136, 2.888008708404496],
            [-11.127400043907528, 2.8934081573591777],
            [-11.128497687132384, 2.8958249884883163],
            [-11.125311637396443, 2.903931678768988],
            [-11.123491586485319, 2.905583976256438],
            [-11.117661318845506, 2.904577880109508],
            [-11.113942550655706, 2.9115050740973256],
            [-11.1066337311227, 2.911467143878685],
            [-11.101458724323557, 2.9167300957476905],
            [-11.093525103773505, 2.9169942952372336],
            [-11.089567447548205, 2.920530884919908],
            [-11.09241536447022, 2.930200887459878],
            [-11.091597911006064, 2.9405000263015846],
            [-11.084183946209533, 2.9402935357614934],
            [-11.081774044011363, 2.935735994553954],
            [-11.073459894647435, 2.9342893361787734],
            [-11.066502934359574, 2.938010419986357],
            [-11.062391504251645, 2.9419668304223783],
            [-11.05817618835349, 2.941193112514697],
            [-11.059605612518471, 2.9349381114193007],
            [-11.057260914406111, 2.9282631999763558],
            [-11.059596051862172, 2.921714875837465],
            [-11.06047482326605, 2.911237038839448],
            [-11.058638480560955, 2.908290825844665],
            [-11.058840484927046, 2.9034438408142966],
            [-11.055642612239602, 2.901094261171856],
            [-11.056211674026713, 2.895818184814222],
            [-11.053152142857202, 2.8916397731097576],
            [-11.053739280937679, 2.8815998505093017],
            [-11.04760439627479, 2.8784097847244587],
            [-11.041879202775439, 2.8768548010902917],
            [-11.036431929059168, 2.8709504654389018],
            [-11.024453283515317, 2.866592560101656],
            [-11.01908453264597, 2.8660079523582334],
            [-11.016433244366048, 2.8608138939715535],
            [-11.011593780309298, 2.858310320447522],
            [-11.006594720692105, 2.851250604556406],
            [-11.004510861552491, 2.8462992232113122],
            [-11.000716355702897, 2.848228242969128],
            [-10.997694411767176, 2.847464727212682],
            [-10.996310009198039, 2.8396356012507042],
            [-10.992936296799472, 2.835617701195656],
            [-10.98814077375612, 2.833215009415655],
            [-10.979627012355646, 2.823193147261025],
            [-10.97379122538507, 2.819988449873525],
            [-10.97112123288275, 2.8162979188132966],
            [-10.961121185155438, 2.8103076286744137],
            [-10.955464623403842, 2.8104259935456577],
            [-10.949135404336877, 2.8050793223702066],
            [-10.943816967380066, 2.8044786148232426],
            [-10.940755207070163, 2.8006467049375425],
            [-10.93418673404686, 2.7960529304423454],
            [-10.929423944374221, 2.7949418316776584],
            [-10.926629089235053, 2.792091515727466],
            [-10.922101885549482, 2.78483654619633],
            [-10.915956452280142, 2.783940779563824],
            [-10.91063266917163, 2.7809284414862794],
            [-10.908846367203719, 2.774840764343353],
            [-10.901142057180309, 2.7708426053417434],
            [-10.897859944774678, 2.7715912162403904],
            [-10.888899428305775, 2.7791251257917198],
            [-10.886544053083622, 2.7886588592185175],
            [-10.883532324818443, 2.792633006085657],
            [-10.881370416592425, 2.798291446010546],
            [-10.876822586205327, 2.8012224337630944],
            [-10.871736702543933, 2.809090730703704],
            [-10.860619495442128, 2.8109914277969867],
            [-10.851927796277373, 2.8092545065785903],
            [-10.847422355897864, 2.8069748375037196],
            [-10.840039064881866, 2.8081953472551646],
            [-10.837291477244785, 2.8066390944851536],
            [-10.834313334596892, 2.802198500832333],
            [-10.824578333017723, 2.7927943489768934],
            [-10.81928413723483, 2.790560218487344],
            [-10.816050940410932, 2.787780698168512],
            [-10.807357643678609, 2.784015066504867],
            [-10.802451953124887, 2.7848070094240267],
            [-10.796466801219848, 2.7897715828844705],
            [-10.794147913627773, 2.795089230402854],
            [-10.786815325898264, 2.797899480609398],
            [-10.776284352264522, 2.796010255978448],
            [-10.768180359619357, 2.793392894221162],
            [-10.76343565327235, 2.7945596864056745],
            [-10.761535542260562, 2.7971849273320406],
            [-10.753190696613476, 2.803137730989201],
            [-10.750199940672172, 2.8072345816845417],
            [-10.750403133251108, 2.815032684133332],
            [-10.744200906511644, 2.8275530535516817],
            [-10.739944060844728, 2.8308321523923814],
            [-10.737501857684437, 2.8365735387873627],
            [-10.734122874556853, 2.8400806173208677],
            [-10.731219765519665, 2.853684480979102],
            [-10.732634168760429, 2.859231746676788],
            [-10.727591319688154, 2.8699311051889267],
            [-10.722994762053876, 2.8719194890639494],
            [-10.718271246877675, 2.8763419473026492],
            [-10.711769618326846, 2.8750830080386707],
            [-10.701440656578272, 2.8753657445691028],
            [-10.694531078596155, 2.8744774051362105],
            [-10.72791343456105, 2.66802343351293],
            [-10.734779732953369, 2.6248949934014245],
            [-10.730066826463295, 2.6241498101403633],
            [-10.750897219480207, 2.4929042850655003],
            [-10.784766462545132, 2.2767128470660594],
            [-10.781407821804553, 2.276199944686246],
            [-10.810084818409052, 2.0941552946697164],
            [-10.861360461321741, 2.1022793319931936],
            [-10.953745484713432, 2.11739689991397],
            [-10.946834673680936, 2.160350948677457],
            [-10.973314372606355, 2.164882946235561],
            [-10.982189202872714, 2.1702303713864604],
            [-10.980069231327466, 2.174279098606817],
            [-10.972403299906397, 2.178814220315976],
            [-10.970108158879542, 2.183306842978943],
            [-10.970007110708131, 2.18955142355398],
            [-10.973439841475049, 2.192525462869266],
            [-10.976959062391943, 2.19290098137364],
            [-10.980547069625006, 2.199409681125054],
            [-10.979204106264884, 2.201707692246833],
            [-10.98408713079805, 2.2081967010862784],
            [-10.984822234541193, 2.2111285373751426],
            [-10.991987196318396, 2.210342880773521],
            [-10.994443249320092, 2.2158862378495066],
            [-10.997435336083822, 2.2183026685563143],
            [-11.00134093216301, 2.216931814860861],
            [-11.00303587351077, 2.223341871082702],
            [-11.00106390375571, 2.230691090697395],
            [-11.002475380864476, 2.2381738920801477],
            [-11.005831105179837, 2.244383420397706],
            [-11.012170927986421, 2.2493914568058013],
            [-11.013937206118595, 2.253085258288416],
            [-11.014119520663016, 2.259339868970165],
            [-11.018692468059118, 2.2617455773501667],
            [-11.019671803533782, 2.268047990932738],
            [-11.019025043590302, 2.2717258706750125],
            [-11.02140420274485, 2.279292656494791],
            [-11.029281322305762, 2.2753591816172607],
            [-11.036544593195423, 2.27374088420292],
            [-11.039686539410123, 2.2697427043027503],
            [-11.047829552923538, 2.274164174862508],
            [-11.048954091557208, 2.2795235299513186],
            [-11.05239573626157, 2.2838213551697986],
            [-11.051986063222078, 2.2901094245874436],
            [-11.053346764924678, 2.292278321146519],
            [-11.045790498447449, 2.301354627583673],
            [-11.041145998373887, 2.3050175479611763],
            [-11.04375752785021, 2.310363627073244],
            [-11.040925272115958, 2.3157604829089973],
            [-11.043299987097985, 2.321668848672101],
            [-11.041648217600056, 2.3274647147502963],
            [-11.038010399889743, 2.329893946563064],
            [-11.034761457208957, 2.336124223251096],
            [-11.03464103555333, 2.3388899486735006],
            [-11.030843203158447, 2.340836991692222],
            [-11.02512154919728, 2.3535567795468113],
            [-11.021402961910756, 2.3579210030033635],
            [-11.022070166052243, 2.3664123638125596],
            [-11.020869644954022, 2.371487299863873],
            [-11.021491414850678, 2.378054307437028],
            [-11.025125375863254, 2.381714072398471],
            [-11.020368449482758, 2.389305925409996],
            [-11.021790567835103, 2.3923725666322984],
            [-11.018288359575209, 2.397366720601285],
            [-11.01780959226417, 2.401029166588397],
            [-11.02354731404647, 2.410475864761621],
            [-11.023140193082316, 2.4156837064289096],
            [-11.030037838528838, 2.429494290567777],
            [-11.037121992927979, 2.4353693293886978],
            [-11.035315184557597, 2.43758925659865],
            [-11.039584242687038, 2.4431696470949436],
            [-11.040158435183125, 2.4473270720097204],
            [-11.044574382343777, 2.4607235994920993],
            [-11.042502164352506, 2.466238584403332],
            [-11.042446110071207, 2.474984315587904],
            [-11.03791560665471, 2.4751259196941757],
            [-11.034913117889346, 2.4799490510061357],
            [-11.038808669446192, 2.4893077078051355],
            [-11.04174350130978, 2.4910982834634257],
            [-11.042813512666019, 2.4982115459787844],
            [-11.049756452599357, 2.506792361197424],
            [-11.053234657876038, 2.5076565634430126],
            [-11.052279442968537, 2.511621126422259],
            [-11.054627656776791, 2.5146049715906997],
            [-11.061888697384196, 2.5173384180732685],
            [-11.060327795615539, 2.5265831777196714],
            [-11.06521617670051, 2.5311562282991833],
            [-11.070311634268972, 2.5316162337508827],
            [-11.075701735807801, 2.5273697024940858],
            [-11.081123188103598, 2.534444819174107],
            [-11.08857319266123, 2.534633462495137],
            [-11.09191859519085, 2.537426721493583],
            [-11.09858932706713, 2.537555978123916],
            [-11.10405059727867, 2.541898621910834],
            [-11.107566544960589, 2.547685292410173],
            [-11.110108526598829, 2.5485491022046127],
            [-11.114166919962814, 2.5462502628941928],
            [-11.121310635787685, 2.5491163353097583],
            [-11.125386157671302, 2.5458965679815853],
            [-11.128481823478602, 2.5497622225731247],
            [-11.135081767774468, 2.5501970081992],
            [-11.137769901029685, 2.5448167064200793],
            [-11.148435829046763, 2.544122761273265],
            [-11.153170527561839, 2.549882854539522],
            [-11.161024596717876, 2.549625437401533],
            [-11.166114777349955, 2.5535490614053984],
            [-11.165674368404524, 2.557309212121689],
            [-11.169081379538317, 2.5614905140776147],
            [-11.163016608987046, 2.5653278243896986],
            [-11.1607269447021, 2.5689922773830967],
            [-11.155532034139016, 2.5739621993438067],
            [-11.153900745121588, 2.578737504168664],
            [-11.151242467604938, 2.580148868388898],
            [-11.155512116924552, 2.585721852165729],
            [-11.155731044369873, 2.5891700180754533],
            [-11.160602080247015, 2.5943710638736523],
            [-11.159513529762664, 2.600338099694707],
            [-11.166446032290489, 2.6015306460380683],
            [-11.16514202803427, 2.608614355317606],
            [-11.172055919916126, 2.60985048511495],
            [-11.174722585522153, 2.6139915004064593],
            [-11.174055480301783, 2.6176150722632956],
            [-11.177527110887224, 2.6182788612556593],
            [-11.176198914388106, 2.6254268257324074],
            [-11.21108514114981, 2.630671225771428],
            [-11.231926905430603, 2.635135879249216],
            [-11.230909921066935, 2.6423247101726886],
            [-11.234448630122227, 2.6428462657428575],
            [-11.231426859081468, 2.660665356492569],
            [-11.234985308448923, 2.6612332412006365],
            [-11.234356341137016, 2.6648781206066467],
            [-11.241345580838166, 2.6659831332507187],
            [-11.237845522713712, 2.6874007221417697],
            [-11.24486016502547, 2.688496324474507],
            [-11.243742476342973, 2.6958354749520566],
            [-11.246962371706829, 2.6974810541180907],
            [-11.248566183116628, 2.7068420400235818],
            [-11.253384895237225, 2.7123100355526177],
            [-11.259863959225427, 2.7099409821971174],
            [-11.263151532824155, 2.7109847300663863],
            [-11.26584330984753, 2.719699154262387],
            [-11.263630968815628, 2.7235737854836026],
            [-11.266519362492181, 2.729803934157197],
            [-11.264964732890524, 2.7353910393987415],
            [-11.255909428140074, 2.742123069236317],
            [-11.252963274668843, 2.745436008597562],
            [-11.244319427892426, 2.744370564081166],
            [-11.234689200705027, 2.752319908095641],
            [-11.233940308207401, 2.754907774465467],
            [-11.229767798562563, 2.7566460245100552],
            [-11.226077187290894, 2.760995866665729],
            [-11.224851358117935, 2.7670621125023174],
            [-11.227066873213648, 2.774936570150323],
            [-11.223861804252257, 2.7772993988603725],
            [-11.221560987983839, 2.7905879474742856],
            [-11.218441107371792, 2.7932620657315845],
            [-11.215758860020674, 2.79988815310584],
            [-11.214911698514213, 2.807627994132984],
            [-11.216096103798257, 2.8111343233655277],
            [-11.214030576392659, 2.8169102634276966],
            [-11.210952891352628, 2.820402152415261],
            [-11.215278278060218, 2.8280940987973255],
            [-11.219251081508697, 2.842737502016954],
            [-11.223984029790767, 2.8476402284349636],
            [-11.22539971289208, 2.8529965222032407]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.16819030593257,
          "lat": 40.330798527446355
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49051"],
        "coty_name": ["Wasatch"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wasatch County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01448039"
      },
      "bbox": [
        -11.266519362492181, 2.0941552946697164, -10.694531078596155,
        2.9419668304223783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.056815394216823, 7.888693569588225],
            [17.059094975834846, 7.895963525741703],
            [17.079093838167896, 7.9743247000646],
            [17.084985060859502, 7.972343233110832],
            [17.134886938768076, 7.961043509625445],
            [17.165844207668005, 7.953497779885557],
            [17.185815237317883, 8.03460935061402],
            [17.18835642995597, 8.047082917156665],
            [17.204957835208052, 8.122549709011851],
            [17.20605479398245, 8.129630042222082],
            [17.24982516637741, 8.120866745947962],
            [17.21647207907618, 8.178676919739743],
            [17.29986797680157, 8.147707936183187],
            [17.304977213075137, 8.161520424280772],
            [17.331709817112664, 8.22817387287523],
            [17.41520026714007, 8.195235286931997],
            [17.382476018833938, 8.11556033310241],
            [17.438145979686873, 8.09299204263198],
            [17.40820369203417, 8.0207578516455],
            [17.45716862337482, 7.980370285661506],
            [17.435538611574938, 7.932209545865303],
            [17.41830896584053, 7.913835124032463],
            [17.507663966714883, 7.840924019877905],
            [17.499132117216256, 7.83170006868544],
            [17.492896425624956, 7.829311978804083],
            [17.48650399394592, 7.824095331349379],
            [17.463155702542664, 7.82925595731868],
            [17.45803978845486, 7.828865563157408],
            [17.45297358498963, 7.825653617500769],
            [17.448823759604277, 7.819959449451408],
            [17.4471646261475, 7.814969893316009],
            [17.44327934157271, 7.812119194505007],
            [17.4360393169458, 7.812289572739901],
            [17.42392998314504, 7.807968669850047],
            [17.411273244635368, 7.8056980485037615],
            [17.409173692378825, 7.803870983034908],
            [17.40914428627896, 7.798706696885035],
            [17.398915767453527, 7.788776381191877],
            [17.38951142810794, 7.78239784319395],
            [17.381947154185966, 7.782705222470954],
            [17.37984184259412, 7.780164640333249],
            [17.38167267678819, 7.775713529825992],
            [17.384402920646195, 7.762882827153609],
            [17.38135068127581, 7.755404264159132],
            [17.378140586711776, 7.753579316024906],
            [17.377644796284887, 7.750394529503178],
            [17.373141034283094, 7.7477246303360126],
            [17.370387778271844, 7.742649500342744],
            [17.368108394830106, 7.732826611948052],
            [17.367520108895455, 7.726581399771431],
            [17.36918129047577, 7.723865350633273],
            [17.374900455049893, 7.726185768366358],
            [17.374517468522665, 7.720237843207105],
            [17.377104303348705, 7.714234214034476],
            [17.383598323372865, 7.7056683115435485],
            [17.387000524831315, 7.703580017192844],
            [17.389926915056368, 7.6986265258825455],
            [17.389103596400933, 7.685632975416045],
            [17.391642407753956, 7.678926261079287],
            [17.391169340505567, 7.672601789995038],
            [17.388916360310056, 7.6694420849218545],
            [17.39099573019798, 7.665611327142827],
            [17.391016460186684, 7.659845799699323],
            [17.3887694699874, 7.655682500596923],
            [17.38946352283596, 7.648492004714369],
            [17.398047550292166, 7.640076189149753],
            [17.404032026926362, 7.629752693981187],
            [17.409316797190705, 7.6248354356629715],
            [17.41296595956938, 7.625664166133298],
            [17.413284520603657, 7.62099818831582],
            [17.316556239821107, 7.6322006534292655],
            [17.313841067207946, 7.632218704042674],
            [17.283070369639184, 7.620898384721622],
            [17.225610821842043, 7.6000634449136015],
            [17.176361957862408, 7.608995103956741],
            [17.188069007779927, 7.655364940857522],
            [17.18897613721353, 7.656927074457822],
            [17.195625918596814, 7.683953255168791],
            [17.18893190089263, 7.709499810294911],
            [17.2109182247136, 7.757717202274289],
            [17.22996113099745, 7.835262720376744],
            [17.225807598784574, 7.837215288952274],
            [17.22662043866776, 7.841417623718237],
            [17.221947179696276, 7.84715406166901],
            [17.148286823473203, 7.865719925776583],
            [17.14169124755239, 7.8674888229026205],
            [17.056815394216823, 7.888693569588225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.10215229433692, "lat": 44.4647371404763 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50005"],
        "coty_name": ["Caledonia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caledonia County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01461759"
      },
      "bbox": [
        17.056815394216823, 7.6000634449136015, 17.507663966714883,
        8.22817387287523
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [12.923568643439419, 0.10299864040905234],
              [12.924176519820833, 0.10118238204278159],
              [12.93075867858439, 0.09548708741385462],
              [12.933727839438154, 0.09507291600613371],
              [12.938664660501884, 0.0904669654224942],
              [12.945353448176125, 0.09460178395167394],
              [12.948196765286813, 0.09783183664117368],
              [12.957275550692058, 0.10271480945355832],
              [12.951989085667517, 0.10468077587945801],
              [12.946908741937708, 0.10900739896060957],
              [12.948080433749631, 0.11818111047724211],
              [12.94280424321347, 0.12478848060947684],
              [12.947026567755508, 0.12967006663861022],
              [12.946009565652878, 0.13292543540962115],
              [12.951321811845336, 0.13793763493517613],
              [12.94899273510129, 0.14872802855252557],
              [12.936490345859465, 0.14515248406937367],
              [12.933624313386375, 0.15531896977044837],
              [12.924082004295295, 0.14772155701702924],
              [12.924840538121655, 0.14515451434948348],
              [12.930330079128824, 0.14186964854921025],
              [12.929385853430764, 0.13783924529364755],
              [12.925363919455155, 0.13320688214891108],
              [12.924841279067829, 0.13070993269176637],
              [12.93030780045448, 0.12385741979595648],
              [12.92855173650932, 0.12152669761060834],
              [12.929487068387479, 0.11707937753796746],
              [12.928516934930716, 0.10984681638924877],
              [12.92700210529711, 0.10610270350645722],
              [12.923568643439419, 0.10299864040905234]
            ]
          ],
          [
            [
              [12.85503984772421, 0.28525621323546907],
              [12.878848204642049, 0.27979154520436916],
              [12.883362608887808, 0.28551702225389947],
              [12.883465345875038, 0.2875389322679471],
              [12.889883573250906, 0.29364243624980996],
              [12.895584008979556, 0.30056192388796776],
              [12.897767704751722, 0.2998800574234802],
              [12.904092094880522, 0.30207581567803643],
              [12.909603674711008, 0.2989928057809113],
              [12.917351402614758, 0.2973314505905687],
              [12.947804364075234, 0.3031670536740971],
              [12.949579067488651, 0.30235741289875734],
              [12.954097846391019, 0.2959240026140563],
              [12.989078743692675, 0.25249903311536864],
              [12.995293680469928, 0.24837558352401076],
              [13.02122786937752, 0.24754196576223014],
              [13.058379152250742, 0.2467114674318672],
              [13.102955844895574, 0.2591816111511541],
              [13.127618898334513, 0.24583600129146585],
              [13.153419853274874, 0.2259105936021452],
              [13.16082333999251, 0.23599249203282904],
              [13.167922492589778, 0.24889037978328912],
              [13.173467646073602, 0.2577222158361395],
              [13.178644521446172, 0.25427859294199734],
              [13.183048255638903, 0.26188104201842666],
              [13.188484902433302, 0.25994889679500655],
              [13.191355139931453, 0.2629262847226586],
              [13.19461752444289, 0.26175015016468106],
              [13.197084372194906, 0.26470069924750983],
              [13.209159879910272, 0.2573170058665696],
              [13.21249460745922, 0.2573062714973948],
              [13.21710963470158, 0.25473885536932195],
              [13.215271962299074, 0.24906503764448779],
              [13.210736838884294, 0.24380212480597674],
              [13.21053044367146, 0.23604276820974973],
              [13.208329212547332, 0.22870089329277404],
              [13.207865709119334, 0.22026549989404223],
              [13.204509064304045, 0.21497169349739098],
              [13.200987445692409, 0.20344528899203923],
              [13.197591668632093, 0.20286312923821148],
              [13.195394290105115, 0.19235977083323072],
              [13.19020784150508, 0.17809761139181388],
              [13.190777446392467, 0.17620815999492276],
              [13.186154880550394, 0.1575821303011514],
              [13.183232245453254, 0.15364352859715144],
              [13.181819289168399, 0.14744470553441566],
              [13.120767273258803, 0.15708674871430903],
              [13.120022843135052, 0.15740090835566867],
              [13.065361930629438, 0.16614979899089835],
              [13.05558546084103, 0.15278895637370637],
              [13.046493962302964, 0.14379039666771445],
              [13.048645483596982, 0.14019862316937193],
              [13.048481767277579, 0.1362156124589953],
              [13.045876149514706, 0.1303463656183085],
              [13.045272996418605, 0.1259181381844613],
              [13.038488392041836, 0.11423018729865574],
              [13.035445940465314, 0.10744045379113297],
              [13.030380386553553, 0.10133503537097943],
              [13.019298431745957, 0.09379245737602862],
              [13.013231399380581, 0.07798032065009854],
              [13.009587317063977, 0.07100240997785039],
              [13.00720870698173, 0.06080503616506819],
              [13.004450798360134, 0.05415222784013097],
              [12.99999225815631, 0.04910337290573628],
              [12.991355475072423, 0.04727042578131683],
              [12.986285384049356, 0.04808336833583884],
              [12.981852249633553, 0.041544584434119326],
              [12.980034155992715, 0.035814577323533166],
              [12.976772242795777, 0.03092240696205266],
              [12.969212038043565, 0.02429754466680087],
              [12.957396865579579, 0.009021449779879186],
              [12.954702992794587, 0.007557397655460515],
              [12.949084809854044, 0.000004681171956724881],
              [12.945841043406201, -0.000996236253186316],
              [12.94108210456953, -0.005067036539418232],
              [12.934092611650817, -0.01355986159609417],
              [12.922529983050927, -0.002362102846417427],
              [12.91759191516481, -0.010217394939504914],
              [12.910901900008044, -0.017680705656192536],
              [12.904529586341543, -0.023246880977003507],
              [12.89816939974665, -0.027512673403659947],
              [12.897853018454352, -0.03133514129094807],
              [12.893756638283579, -0.03605918886665437],
              [12.887635011860358, -0.03989631622585384],
              [12.885862769326621, -0.04300199482582036],
              [12.87312509191276, -0.0492305487820831],
              [12.861447063998392, -0.06687546470059579],
              [12.851657825712298, -0.07390370698019172],
              [12.846870432739706, -0.08034734541226442],
              [12.833204205424593, -0.07582952688164663],
              [12.826979713581768, -0.0717748151217902],
              [12.825128765743187, -0.0648065146750226],
              [12.818959279030931, -0.06438436294154522],
              [12.815084157842668, -0.068134987782014],
              [12.812603958760018, -0.06694602055085497],
              [12.796536619593184, -0.06866904619756933],
              [12.782409437827539, -0.0592891382863158],
              [12.766599779354944, -0.05179517596647308],
              [12.743410217433992, -0.0470356567555255],
              [12.732369908280209, -0.037649273920477254],
              [12.713640416555066, -0.0052429470165962395],
              [12.719853044148707, 0.0005231167694284644],
              [12.727302049250762, 0.013479612386787172],
              [12.733672852227153, 0.02574628643002636],
              [12.738207726016986, 0.028373684464975138],
              [12.741241138875735, 0.03429385272373366],
              [12.741400716576038, 0.03834014118039351],
              [12.734382929597162, 0.04094690595228463],
              [12.731686769905119, 0.04543013629660774],
              [12.732867225340227, 0.06379835943392613],
              [12.738581187477665, 0.06580526567884264],
              [12.736426604376865, 0.07143136438853441],
              [12.738081965963508, 0.07739365760674521],
              [12.74320681073057, 0.07778725861857035],
              [12.743334972931853, 0.08256558181585015],
              [12.746642299760278, 0.0835553173696068],
              [12.749974292402127, 0.0894117619692063],
              [12.752723197050075, 0.0903933021192188],
              [12.761536545570255, 0.09050519243213952],
              [12.760603373605376, 0.09496456372225405],
              [12.753820467212316, 0.09545902696110646],
              [12.753928107479593, 0.09916001254300646],
              [12.748382891794504, 0.10350626667807479],
              [12.749139410477339, 0.11034455448690322],
              [12.753865622509883, 0.12229379948815607],
              [12.759295195002448, 0.12608625903877368],
              [12.762190864445662, 0.1300245120940462],
              [12.763609031550706, 0.1387302958244037],
              [12.768680174698302, 0.1472802512370129],
              [12.774058660538532, 0.1543085489164517],
              [12.779112700387182, 0.15721566755526947],
              [12.774720481310128, 0.16370604586097803],
              [12.775072948556593, 0.16982100735904704],
              [12.778789484526962, 0.17178171681566273],
              [12.78135365298672, 0.17839445513190413],
              [12.782578080139498, 0.18581942597537332],
              [12.786444731466052, 0.19466778171863225],
              [12.79177347478688, 0.20242723142783667],
              [12.794685958995714, 0.20810719722708174],
              [12.800801035118925, 0.2047580606644851],
              [12.807365419488363, 0.21291352239009323],
              [12.808418712380494, 0.21783654194274452],
              [12.812352650247313, 0.22240040784966184],
              [12.816915521646965, 0.22294154318749415],
              [12.814985558598618, 0.2286519645002507],
              [12.81614064499591, 0.23158929538224454],
              [12.822482327919769, 0.24126793275545233],
              [12.824769161688842, 0.2459685484434966],
              [12.829808795987338, 0.2460013287896609],
              [12.835286214778623, 0.2586377075024696],
              [12.84245520371438, 0.27017524421239103],
              [12.842732502888087, 0.2728767666380065],
              [12.848016188018535, 0.2788403222845259],
              [12.85503984772421, 0.28525621323546907]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.00620423438491, "lat": 37.78779474308481 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51005"],
        "coty_name": ["Alleghany"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alleghany County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01673675"
      },
      "bbox": [
        12.713640416555066, -0.08034734541226442, 13.21710963470158,
        0.3031670536740971
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.882397628975683, 1.626265253549331],
            [14.913863712788537, 1.6749240686738776],
            [14.913897606654318, 1.6749028482263562],
            [14.920520488803593, 1.6668343606034128],
            [14.927099734497107, 1.6618788869923207],
            [14.93052682495547, 1.6561859413171696],
            [14.939251410711972, 1.6507366651794082],
            [14.94873835959038, 1.6485306178975034],
            [14.958120787806617, 1.6491875005418573],
            [14.96053598303627, 1.648130402997801],
            [14.965525366435251, 1.638223221992917],
            [14.971196249223583, 1.6305727014168814],
            [14.973516397278795, 1.6309824752046933],
            [14.979986231743151, 1.6227131444267142],
            [14.98631055376111, 1.6245057723482559],
            [14.98867374062085, 1.6178783753951895],
            [14.99411110182207, 1.611594345367585],
            [14.997181433714161, 1.6053879502387811],
            [14.997041391170091, 1.5950220722851538],
            [14.98969551917532, 1.5926371508204882],
            [14.986578318512436, 1.5937170244750356],
            [14.983143295774898, 1.5920923537296052],
            [14.974057019772623, 1.5949470646337403],
            [14.971945890262901, 1.5934810235254828],
            [14.962705920906709, 1.5906151272761724],
            [14.957657604740758, 1.5906670121884774],
            [14.95956107518092, 1.5854567590352016],
            [14.960568923270962, 1.577145858177658],
            [14.959383743275987, 1.573914802871334],
            [14.947821800197785, 1.5808371872599456],
            [14.94190973206406, 1.585923940124804],
            [14.938784941403561, 1.5863305385705837],
            [14.938981824566467, 1.5877590777108581],
            [14.902955326466667, 1.6123002460570224],
            [14.882397628975683, 1.626265253549331]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.10121160215265, "lat": 38.8785358402098 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51013"],
        "coty_name": ["Arlington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Arlington County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01480097"
      },
      "bbox": [
        14.882397628975683, 1.573914802871334, 14.997181433714161,
        1.6749240686738776
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.341866158959293, 0.198270360566054],
            [13.346863800238769, 0.20709319451952457],
            [13.351955427620478, 0.2060991852197744],
            [13.359074416653314, 0.21087311337004847],
            [13.365713973564263, 0.21075959248243908],
            [13.372643137454485, 0.20736725847567222],
            [13.371246077309463, 0.20426950490363877],
            [13.367260252893168, 0.20157502811151734],
            [13.36586110735774, 0.19692570400377313],
            [13.360681733452388, 0.19001036229440343],
            [13.349947312539038, 0.1789902161159072],
            [13.3465574366443, 0.18148958430644196],
            [13.344760716092528, 0.18564712096952438],
            [13.34741236788872, 0.19309363719393247],
            [13.341866158959293, 0.198270360566054]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.444319863, "lat": 37.7823941081902 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51678"],
        "coty_name": ["Lexington"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Lexington city"],
        "coty_fp_code": "678",
        "coty_gnis_code": "01789071"
      },
      "bbox": [
        13.341866158959293, 0.1789902161159072, 13.372643137454485,
        0.21087311337004847
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.685176600978782, 0.545833136514028],
            [13.684599118137726, 0.5508658123938303],
            [13.692129136836979, 0.5592420514847541],
            [13.695005377193631, 0.5603140964383727],
            [13.696032701952419, 0.5725993524179898],
            [13.69719873653282, 0.5755440347860734],
            [13.703287413910907, 0.5737453519141157],
            [13.704322418298963, 0.5781422199488381],
            [13.709234103780362, 0.5787103673540178],
            [13.714776498187211, 0.5874584071072726],
            [13.722375260926203, 0.5855757117880728],
            [13.725176807325207, 0.5878877412024476],
            [13.730505574062839, 0.5852540769347181],
            [13.736605939847925, 0.5841016997110219],
            [13.743981118453354, 0.5846067175180564],
            [13.748080967156495, 0.5834324978059766],
            [13.747286472337954, 0.575438734685986],
            [13.750113927611274, 0.5714070791450436],
            [13.755973671371303, 0.5688644544689387],
            [13.75690780970744, 0.5636727351557691],
            [13.750807262223958, 0.5555090914459913],
            [13.75075290571168, 0.549867267737019],
            [13.753588519857423, 0.5399105195078755],
            [13.750765354681775, 0.532682330026414],
            [13.745393144374896, 0.534469889000622],
            [13.739354387554261, 0.5298929849219846],
            [13.734907891116881, 0.5291658440987792],
            [13.726813772890974, 0.5319579209595006],
            [13.721788327538539, 0.5305669177815882],
            [13.715047580252401, 0.5215408177679872],
            [13.711847947925925, 0.5191153251296503],
            [13.708263645467529, 0.5282573543069049],
            [13.703573380844903, 0.53384675139459],
            [13.699990863647031, 0.5319525926580848],
            [13.690419510811328, 0.5339609061924463],
            [13.688034446192562, 0.5395432316578671],
            [13.691375122097796, 0.5444327514939388],
            [13.685176600978782, 0.545833136514028]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.90169774120481, "lat": 38.06736690001028 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51820"],
        "coty_name": ["Waynesboro"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Waynesboro city"],
        "coty_fp_code": "820",
        "coty_gnis_code": "01498443"
      },
      "bbox": [
        13.684599118137726, 0.5191153251296503, 13.75690780970744,
        0.5878877412024476
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.857477729634432, 12.37033403489378],
            [-15.770881176573168, 12.347670054609086],
            [-15.661501859589812, 12.319723374094636],
            [-15.552133723649183, 12.291731368551785],
            [-15.442759098895683, 12.263348226448326],
            [-15.333396340038282, 12.234919760334204],
            [-15.311356733211573, 12.229240314381927],
            [-15.230683707335254, 12.209977194695329],
            [-15.118116434659854, 12.181659136817718],
            [-15.030358614834702, 12.15995481331917],
            [-14.942607838641932, 12.138221523849884],
            [-14.862708265169298, 12.118704700889726],
            [-14.782814443695944, 12.099163919505047],
            [-14.751473337380574, 12.091517858645217],
            [-14.677519810046597, 12.073682004307404],
            [-14.603571143185198, 12.055825671356857],
            [-14.560884110319398, 12.045592250054662],
            [-14.576374979732883, 11.98436905681167],
            [-14.610199051525653, 11.849621960664878],
            [-14.642619911600516, 11.720214185656168],
            [-14.663794507625868, 11.725254916916773],
            [-14.66789261233355, 11.709502822321866],
            [-14.704270886992854, 11.563410313204935],
            [-14.687639423442265, 11.559217792158275],
            [-14.708141824119545, 11.479058015016685],
            [-14.72887477224553, 11.397532373123417],
            [-14.729371752378968, 11.39762679119545],
            [-14.758953389680446, 11.278724563917716],
            [-14.790553450259642, 11.152322309678793],
            [-14.811110658868598, 11.070506171504416],
            [-14.814983555403334, 11.071385802209328],
            [-14.816475527119882, 11.066212292784748],
            [-14.828167633018941, 11.067666627076145],
            [-14.83422011352416, 11.06739135199873],
            [-14.846208349132459, 11.0648304184953],
            [-14.850744408732673, 11.064478627688468],
            [-14.866564237053979, 11.065871645584519],
            [-14.889422297999813, 11.066715918855236],
            [-14.899603496900346, 11.071742058948074],
            [-14.902175138847126, 11.07423223310611],
            [-14.90415573084734, 11.079228389151321],
            [-14.900906877373123, 11.090716484508924],
            [-14.899351566386224, 11.097449773998374],
            [-14.885254826187616, 11.107936721534912],
            [-14.879721280243654, 11.116130565552924],
            [-14.878583381850886, 11.121007983810989],
            [-14.874221267941019, 11.124936424371496],
            [-14.870054223448738, 11.130340058300474],
            [-14.8668052376732, 11.139458560723993],
            [-14.86971203572793, 11.14581254960313],
            [-14.875096733857411, 11.151982147953825],
            [-14.880921114001817, 11.16089683727766],
            [-14.889600460742878, 11.165883019377388],
            [-14.896096670779368, 11.17199001674581],
            [-14.897534860137261, 11.17722196012905],
            [-14.89781974135611, 11.191087243211179],
            [-14.899240746588184, 11.198306223210269],
            [-14.898414334150987, 11.212824007558192],
            [-14.896083192865818, 11.220937694583021],
            [-14.895138327666762, 11.23070193175946],
            [-14.895706271872735, 11.241932864546039],
            [-14.909038080447349, 11.268500922689316],
            [-14.91597259127771, 11.273097562009653],
            [-14.921879545710816, 11.273799223365312],
            [-14.927618043102576, 11.273043416058684],
            [-14.935078364691387, 11.27500510752928],
            [-14.93907054948339, 11.277758588220612],
            [-14.946593421207908, 11.28804633410426],
            [-14.950426654814029, 11.291642240166409],
            [-14.956122171852721, 11.29322330607159],
            [-14.960716180999988, 11.291444940865281],
            [-14.967480216540357, 11.29130129717883],
            [-14.979029853316705, 11.285275947181669],
            [-14.983312809902472, 11.281579706959644],
            [-14.988747255403503, 11.2786773344492],
            [-14.99508606224853, 11.281253145504465],
            [-14.998678768098861, 11.281374952101078],
            [-15.00462261789244, 11.27945854718019],
            [-15.011666333243866, 11.274089404037499],
            [-15.016868594764732, 11.272548500740243],
            [-15.020890745737827, 11.27472302872262],
            [-15.02892315487557, 11.273473251931001],
            [-15.032840804415434, 11.27051900670357],
            [-15.044267992554769, 11.266499100891862],
            [-15.049354698215168, 11.267267758403309],
            [-15.054819040589964, 11.271062494542768],
            [-15.065060058241905, 11.283020354400511],
            [-15.0712484579114, 11.286037307969638],
            [-15.07783040392387, 11.283941624063589],
            [-15.085646260279017, 11.280088917773483],
            [-15.094689024465874, 11.272921985113719],
            [-15.099975184214488, 11.258233548031223],
            [-15.101314341949939, 11.248105282959791],
            [-15.108129866890224, 11.23550614780272],
            [-15.1129391494459, 11.231561905692681],
            [-15.116530427560399, 11.230949867377909],
            [-15.130868604319652, 11.237851898630588],
            [-15.150892712567245, 11.239797341096118],
            [-15.154683111370721, 11.241331215245854],
            [-15.157937946029097, 11.246467539676964],
            [-15.165488450624652, 11.256173184878476],
            [-15.170570909425411, 11.271591280380976],
            [-15.175773112826365, 11.275397336299719],
            [-15.179119256442776, 11.275158927920684],
            [-15.189720599744954, 11.279933139372327],
            [-15.194116919399299, 11.278919333069542],
            [-15.201394615950235, 11.281225537340662],
            [-15.206222872272251, 11.285728097834449],
            [-15.211481349198516, 11.287460765152508],
            [-15.21778238862586, 11.285592455919623],
            [-15.223214158687426, 11.282699974472067],
            [-15.227123153773602, 11.271464479343024],
            [-15.232763718071057, 11.267273735419423],
            [-15.237586761120275, 11.265435126114733],
            [-15.243536356686482, 11.26567754907384],
            [-15.255822311241902, 11.260280476694945],
            [-15.260330392050449, 11.256076644492898],
            [-15.269444183480086, 11.251228706811698],
            [-15.278695684244513, 11.248539640399875],
            [-15.287961273215648, 11.244673066343589],
            [-15.298571510880327, 11.237124938764927],
            [-15.305672695927116, 11.228239349777466],
            [-15.310584466704924, 11.226142934223258],
            [-15.321728828086156, 11.229083574752377],
            [-15.330096807848518, 11.234240825113782],
            [-15.333812788285593, 11.237733483917635],
            [-15.336511985375179, 11.244145283341702],
            [-15.346707403592701, 11.258230238281659],
            [-15.349282931593688, 11.263163374103037],
            [-15.349684427494907, 11.271289843260469],
            [-15.346304716402612, 11.275651130634671],
            [-15.339237945205381, 11.282334106281445],
            [-15.331832513450099, 11.293634001396788],
            [-15.325726794738356, 11.30129665093131],
            [-15.323444437791329, 11.308061614769771],
            [-15.323955747255553, 11.314020285680959],
            [-15.32824340756579, 11.327107723231462],
            [-15.331869393980348, 11.32659727636019],
            [-15.34164947165386, 11.321423271572526],
            [-15.352172249481322, 11.321895029441054],
            [-15.357508926231608, 11.325122848661637],
            [-15.359155638264417, 11.329045674554184],
            [-15.360669804785726, 11.337876850736617],
            [-15.363587702680432, 11.343334311220186],
            [-15.368962489457163, 11.347344234212969],
            [-15.378946306621653, 11.351481425097289],
            [-15.384011494367932, 11.35252626201797],
            [-15.386700985735475, 11.35016441596357],
            [-15.386910214968543, 11.342997805441874],
            [-15.389996565932583, 11.338522006441554],
            [-15.393130581302197, 11.337250530310024],
            [-15.39934245668401, 11.33756029298153],
            [-15.412840912217671, 11.34194792499275],
            [-15.416503652931816, 11.341380038246799],
            [-15.425913317721, 11.33774474614405],
            [-15.434842263106614, 11.33834274390822],
            [-15.443113725634763, 11.336396297610055],
            [-15.450362536416538, 11.332050810893405],
            [-15.457381135102889, 11.329897952377642],
            [-15.467359023815037, 11.32791234582285],
            [-15.47412478173382, 11.32465627494269],
            [-15.476987308539195, 11.321266657518654],
            [-15.476946717531758, 11.315787620227212],
            [-15.473610254905905, 11.301921276130145],
            [-15.467732050197212, 11.287085467618315],
            [-15.469122850430075, 11.276125137391762],
            [-15.471871292983392, 11.270094306977967],
            [-15.476059229409092, 11.263898241602382],
            [-15.480439180510478, 11.261371465457817],
            [-15.48474844588361, 11.256068349751361],
            [-15.488542301618391, 11.246775702088193],
            [-15.488109275846346, 11.243568267737121],
            [-15.482902331414923, 11.232799387890754],
            [-15.575157113191862, 11.256130805663535],
            [-15.599265924102914, 11.262369340462033],
            [-15.602861510165903, 11.264679915678375],
            [-15.606658598109364, 11.270391770597618],
            [-15.609389095057235, 11.27071187912292],
            [-15.6105450508232, 11.275677400273969],
            [-15.604132694289772, 11.281927083433096],
            [-15.603983750543282, 11.284502437138235],
            [-15.612391497061013, 11.298253172761328],
            [-15.608986442316636, 11.303681384493945],
            [-15.60931720517857, 11.315405821168477],
            [-15.612139600996375, 11.323279453726173],
            [-15.614682169414914, 11.32645451826769],
            [-15.622671292559328, 11.331035977511082],
            [-15.629045113281464, 11.336695397364156],
            [-15.629251458354156, 11.341867479037765],
            [-15.637212240493275, 11.34499651392254],
            [-15.644024126526322, 11.350810326495964],
            [-15.642898902034347, 11.355976828291638],
            [-15.644665400316159, 11.35816016974401],
            [-15.641920472085072, 11.361367303233132],
            [-15.642021434319327, 11.365256719765847],
            [-15.635243725686784, 11.36546977646607],
            [-15.632564948533823, 11.363168169072855],
            [-15.630232405507249, 11.367259651204673],
            [-15.634093592959061, 11.372530343506366],
            [-15.635416364561575, 11.376841778895662],
            [-15.643390604329923, 11.37931291785557],
            [-15.643979947937042, 11.382457655436024],
            [-15.64812327744991, 11.38291252977627],
            [-15.658834050307966, 11.391386544497694],
            [-15.660327899449024, 11.396319636401463],
            [-15.663122361944136, 11.395797067321224],
            [-15.67095570639162, 11.397666834415173],
            [-15.677113404673152, 11.401128456237018],
            [-15.679360993532889, 11.406926445540341],
            [-15.683549455109489, 11.408477080076734],
            [-15.685417409611471, 11.41286274365069],
            [-15.68908735564749, 11.414552516715533],
            [-15.688082835493045, 11.418303747485739],
            [-15.690786614948879, 11.422276425105109],
            [-15.692096500666315, 11.42702263340999],
            [-15.695462959734858, 11.429974914601882],
            [-15.698936085238444, 11.43821849236736],
            [-15.703747699974432, 11.440110971386046],
            [-15.706535758851693, 11.445326908111596],
            [-15.706487417485858, 11.448228512428875],
            [-15.709706568934559, 11.454048829795141],
            [-15.714599127317172, 11.456967178578022],
            [-15.715010019472329, 11.4611198732995],
            [-15.720193607149609, 11.463040903145878],
            [-15.724203365661463, 11.461112085123432],
            [-15.728049235538798, 11.462300434685744],
            [-15.735202104400583, 11.461561365878888],
            [-15.738831674581716, 11.467126331817687],
            [-15.737795127321089, 11.469238309709084],
            [-15.740844631443203, 11.477482108473902],
            [-15.744878942898858, 11.482631996716636],
            [-15.749085477914662, 11.485065142686414],
            [-15.750664363861668, 11.489524940381955],
            [-15.75002470653223, 11.496420159586737],
            [-15.754024322886803, 11.499672106513339],
            [-15.752854223675142, 11.506583295313735],
            [-15.750085891670325, 11.513658903160824],
            [-15.7463830301899, 11.516359236737209],
            [-15.743879259693264, 11.52283768934237],
            [-15.740449712720892, 11.52600359073085],
            [-15.738232534769718, 11.53138575664798],
            [-15.733604707634012, 11.537010176609424],
            [-15.733355978012748, 11.542190455903103],
            [-15.735397941439052, 11.550916111154434],
            [-15.734349144369553, 11.55419856085768],
            [-15.73595735001476, 11.557121305468101],
            [-15.746833209935055, 11.55828155081462],
            [-15.75243455215955, 11.561783234017982],
            [-15.753440296618633, 11.567510298597313],
            [-15.755720414384918, 11.571604901384564],
            [-15.750420410844939, 11.5746289939857],
            [-15.75046232003247, 11.579540845775753],
            [-15.75279537011829, 11.584799683089114],
            [-15.759713002805201, 11.588634617667125],
            [-15.764366993911658, 11.593373089078478],
            [-15.76976016849726, 11.59601130504104],
            [-15.774033330347404, 11.600577325235413],
            [-15.774052048724823, 11.602537879038188],
            [-15.781159327591347, 11.609666529855595],
            [-15.786451948181291, 11.611816939547463],
            [-15.79169045119803, 11.618714242527236],
            [-15.796114437956579, 11.622330453896186],
            [-15.791342244522513, 11.624669014684242],
            [-15.791607611821613, 11.627109433097106],
            [-15.798439523845506, 11.632345095161776],
            [-15.80090790275588, 11.638649915982118],
            [-15.80412984475332, 11.642881690554532],
            [-15.806436600696749, 11.648912100888706],
            [-15.808823559542141, 11.651790797365013],
            [-15.81106167097748, 11.667689446642772],
            [-15.813283549192617, 11.669969822584152],
            [-15.817876860749443, 11.67045833830572],
            [-15.824410911412189, 11.667379617916833],
            [-15.83729307311855, 11.670828379555937],
            [-15.839848732840316, 11.67598043843321],
            [-15.842181203461484, 11.677786011202878],
            [-15.84625901270197, 11.684064685452814],
            [-15.857496689780932, 11.688514235628187],
            [-15.859841282946274, 11.693492109602362],
            [-15.855835227563817, 11.696753040517006],
            [-15.854848265323092, 11.70556532695735],
            [-15.851124818374812, 11.71053227069617],
            [-15.846950565823576, 11.712870585172505],
            [-15.841236179108916, 11.714148211852205],
            [-15.836714027658052, 11.722276372280886],
            [-15.83198471160603, 11.723958804086994],
            [-15.831441343668516, 11.733646646089758],
            [-15.832945585181896, 11.738719369850019],
            [-15.842751021719518, 11.745789448661215],
            [-15.844604394264485, 11.750473501877986],
            [-15.851228199284897, 11.753670260894593],
            [-15.856146930400303, 11.763572772836527],
            [-15.861912898617359, 11.769545808960281],
            [-15.86487468178608, 11.769131965938087],
            [-15.874627224812352, 11.771152902332899],
            [-15.88076110882437, 11.773803843436072],
            [-15.872099180944085, 11.784572684469863],
            [-15.876739912482975, 11.789458881852001],
            [-15.875688931481506, 11.797741937393841],
            [-15.876084012780439, 11.804623465027234],
            [-15.873111877746837, 11.806092275922147],
            [-15.872493843036644, 11.811574271733672],
            [-15.877846748668606, 11.817662902875883],
            [-15.879890568663836, 11.82531198631026],
            [-15.87801286706522, 11.826545270465303],
            [-15.869919086964988, 11.826169627978798],
            [-15.86545155838101, 11.832582548637802],
            [-15.857593534953217, 11.836447091615875],
            [-15.852253537227675, 11.83656155596464],
            [-15.853810910332193, 11.842379017196158],
            [-15.861480376629943, 11.84856461707034],
            [-15.861955268268686, 11.852803156087008],
            [-15.856921313842308, 11.859272945035983],
            [-15.851414864627092, 11.860838788292265],
            [-15.848424006223839, 11.86382339159048],
            [-15.843099727149053, 11.86179745615357],
            [-15.842132368972166, 11.86538636727118],
            [-15.85211920998108, 11.873712976385907],
            [-15.857747555033722, 11.87726479465606],
            [-15.855682558357143, 11.881173454388183],
            [-15.85606047147701, 11.885096215156544],
            [-15.853883111823855, 11.890075551236857],
            [-15.847474589028726, 11.89424356240543],
            [-15.845956312144429, 11.899784361828052],
            [-15.84704563497927, 11.904171634570188],
            [-15.86485946711003, 11.902805370095598],
            [-15.87153066912797, 11.904110954218645],
            [-15.876383218210954, 11.907372880392408],
            [-15.880602019914264, 11.907533630941899],
            [-15.882757150808862, 11.913350626770054],
            [-15.882276754720003, 11.918202085223191],
            [-15.875587446357867, 11.925750553198059],
            [-15.872609277438636, 11.93293683428667],
            [-15.863597086642983, 11.934530638303631],
            [-15.86140174612613, 11.937509757715569],
            [-15.860624336825557, 11.946531553411837],
            [-15.862934706175631, 11.948943187068243],
            [-15.86607186031678, 11.956035950549989],
            [-15.86840931076228, 11.963633743163351],
            [-15.871961593375323, 11.965219121422962],
            [-15.875188626622283, 11.971079631967816],
            [-15.877441143338395, 11.97137662218423],
            [-15.88043294562309, 11.964949566576665],
            [-15.886180158809712, 11.95979166677621],
            [-15.89410890916572, 11.958425606547465],
            [-15.901613978846905, 11.962062615364514],
            [-15.905316305185346, 11.965236721703198],
            [-15.907211963631797, 11.97199157988171],
            [-15.911325629151326, 11.977140446652426],
            [-15.915432759120545, 11.987010484532634],
            [-15.91485929679517, 11.993296893190244],
            [-15.911563678486672, 11.998095303424984],
            [-15.912503425507657, 12.009531931009441],
            [-15.907738614359042, 12.011775143513661],
            [-15.902911655687761, 12.01724965245123],
            [-15.900144050842181, 12.018767511576828],
            [-15.89731271633319, 12.023103375763244],
            [-15.893453020236581, 12.02383583851229],
            [-15.88772932702357, 12.022540657535618],
            [-15.880887823893726, 12.02993106039074],
            [-15.880879057639444, 12.033210415262046],
            [-15.87893027607104, 12.0349750112281],
            [-15.870581330811904, 12.036209408641353],
            [-15.866391461416613, 12.038635734180628],
            [-15.859037313807791, 12.034421862882008],
            [-15.856654313410415, 12.034433275813452],
            [-15.85497792370421, 12.043972256694332],
            [-15.849498656111804, 12.05035614746195],
            [-15.84727193980352, 12.055357256974913],
            [-15.839421822351701, 12.062369942803647],
            [-15.834373242477069, 12.060790042742221],
            [-15.827721449037298, 12.056618519134586],
            [-15.823286001671852, 12.057453387395395],
            [-15.821769555803714, 12.062265635689029],
            [-15.822583837918794, 12.065025670347861],
            [-15.821874728409094, 12.071547153532789],
            [-15.817863111180497, 12.077685552037368],
            [-15.81233979120852, 12.079014237317896],
            [-15.80553038407077, 12.076255924835838],
            [-15.801743509457582, 12.080574122484984],
            [-15.804502631258574, 12.083734125404378],
            [-15.807227216226611, 12.090723577732627],
            [-15.810850969026008, 12.091266434338028],
            [-15.813469429900945, 12.093777131318204],
            [-15.81272666654077, 12.097735511028853],
            [-15.818784565245185, 12.108026919345491],
            [-15.817181459716792, 12.111690302814187],
            [-15.817543431188987, 12.116181307267343],
            [-15.821555069712472, 12.118117223806314],
            [-15.824597476193462, 12.133439611329193],
            [-15.834250220744266, 12.137526943329767],
            [-15.837298858913652, 12.15141868922287],
            [-15.834871431874419, 12.15679296952755],
            [-15.836090993162287, 12.160450432105076],
            [-15.83285294692298, 12.167532114528866],
            [-15.835254130710213, 12.175700469004212],
            [-15.832736369951421, 12.185810112206639],
            [-15.82858893788099, 12.188333541618505],
            [-15.825243856908413, 12.196629196249736],
            [-15.826149765007873, 12.20340175127889],
            [-15.82334508745862, 12.205763496222552],
            [-15.817247337372313, 12.21471284468531],
            [-15.819472509880061, 12.218441357555434],
            [-15.817395932011392, 12.22410560112916],
            [-15.82511300804451, 12.228587164626262],
            [-15.834700516817465, 12.240643189357046],
            [-15.835428818518595, 12.246243727681605],
            [-15.829737775388324, 12.250718885710057],
            [-15.829962692420565, 12.256146730363472],
            [-15.826090508004567, 12.261490120078294],
            [-15.83018558995776, 12.26732838848924],
            [-15.829451397770795, 12.271168781203325],
            [-15.826387564460621, 12.273464782916633],
            [-15.827669493067768, 12.279044237213718],
            [-15.826023980426257, 12.286134480834544],
            [-15.823914355698383, 12.288784644568553],
            [-15.816003629825081, 12.288985527843588],
            [-15.812976966968243, 12.290768627002954],
            [-15.811176784249993, 12.294315564349976],
            [-15.811293379764782, 12.302396945451209],
            [-15.813873386744106, 12.30721212303924],
            [-15.815833180791653, 12.31373554607042],
            [-15.819340603763735, 12.316943696105863],
            [-15.826994382378063, 12.319881635499275],
            [-15.82971149523848, 12.322263152907585],
            [-15.83568390865236, 12.323134752589487],
            [-15.836947789149905, 12.31837729475917],
            [-15.844341280217353, 12.317360809778679],
            [-15.847336910158104, 12.313434689479385],
            [-15.850886474860308, 12.312718023348218],
            [-15.852365180999337, 12.30993126819281],
            [-15.859299686598254, 12.308753128549869],
            [-15.86268866001078, 12.31079338440459],
            [-15.863026846357597, 12.321545387083301],
            [-15.867148316114045, 12.328546503449324],
            [-15.872012364467729, 12.33059538223313],
            [-15.874143314726897, 12.334681995915734],
            [-15.881072813050412, 12.339004125930565],
            [-15.885497060499233, 12.345944905225403],
            [-15.883471805653905, 12.348547426804663],
            [-15.885754494462649, 12.352694022597394],
            [-15.882759881218123, 12.35464207078737],
            [-15.8717458378511, 12.353644037429278],
            [-15.868950617421467, 12.355309082917488],
            [-15.858902473559516, 12.364265135472204],
            [-15.860500155281507, 12.368564560479168],
            [-15.857477729634432, 12.37033403489378]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.74082997247092,
          "lat": 48.548805186325026
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53047"],
        "coty_name": ["Okanogan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Okanogan County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01531928"
      },
      "bbox": [
        -15.915432759120545, 11.064478627688468, -14.560884110319398,
        12.37033403489378
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.288546521088595, 0.9826086842828002],
            [11.29683009162396, 0.9798877130807551],
            [11.303973383716023, 0.9806463074483944],
            [11.31390514550975, 0.9891705986103035],
            [11.324706452896102, 0.9999919954482144],
            [11.3308542988259, 1.012364179402212],
            [11.33210038576095, 1.021412813276125],
            [11.331057681741177, 1.0244250107105088],
            [11.329934519737227, 1.0401342197379526],
            [11.333567998321422, 1.049243027254168],
            [11.337574823882907, 1.0565431517552355],
            [11.342082728077287, 1.0601867363423465],
            [11.350367845090984, 1.0609878421819947],
            [11.357145573881628, 1.0578665801486133],
            [11.366026292935757, 1.0493883730058815],
            [11.375148619177335, 1.0443254589460396],
            [11.384427656495117, 1.0424284754965574],
            [11.390433659368504, 1.0433149205325971],
            [11.39474752458962, 1.0469082233406348],
            [11.396528055274777, 1.0550556210455513],
            [11.395341381022847, 1.0585590094286013],
            [11.392134888242252, 1.0589438314156738],
            [11.386259157181088, 1.0665574859479514],
            [11.375861005116914, 1.0747524586956225],
            [11.372234511771747, 1.0834377966915816],
            [11.372529902426624, 1.0914839861116614],
            [11.374490042098394, 1.0999097534415518],
            [11.373074007363332, 1.1041932548015736],
            [11.373218766638521, 1.1092837310058734],
            [11.374926258510335, 1.1164198536886436],
            [11.379254904900353, 1.1229264991903842],
            [11.378026471380789, 1.1357063347383918],
            [11.369840366078956, 1.1455990189483016],
            [11.35785237432084, 1.1544089944324603],
            [11.346091040277729, 1.1612119347857035],
            [11.343403349287499, 1.1635636491733814],
            [11.335303023293317, 1.1744925355693456],
            [11.333064218025598, 1.1805867376209007],
            [11.330672147528597, 1.1939052482046204],
            [11.334528151310291, 1.1992826540741237],
            [11.342068051753495, 1.1992942760779821],
            [11.34816095680866, 1.1970471622554417],
            [11.355487451767516, 1.1964154972784005],
            [11.359928044047276, 1.197391049377695],
            [11.36752073924393, 1.2022110910877948],
            [11.375833222615105, 1.2115303607598293],
            [11.37888049413485, 1.217605697202085],
            [11.403199884495026, 1.2086341823146045],
            [11.441600632775245, 1.1941706790243312],
            [11.459957367327041, 1.1877054522095458],
            [11.515447415636816, 1.1677047922567405],
            [11.555984059628416, 1.1531186916819876],
            [11.555127199267467, 1.1477104645573974],
            [11.556090917009602, 1.1433729067290475],
            [11.554700825214837, 1.1367677031172674],
            [11.558342400649055, 1.134657583592076],
            [11.562291168091768, 1.1249137274748053],
            [11.556220918061582, 1.1212151439000382],
            [11.548814013687418, 1.1128106798927841],
            [11.54952215748915, 1.1054446070681412],
            [11.557219476359975, 1.0971202078053255],
            [11.559857544582053, 1.0919708888523647],
            [11.563117337566375, 1.093322462054854],
            [11.571483397325165, 1.0862546794078454],
            [11.576473666576126, 1.0850586750491025],
            [11.575915434409215, 1.0825422357718437],
            [11.579702605957271, 1.0801383518811203],
            [11.577607207401702, 1.0764493145597216],
            [11.583900523821237, 1.072490831094544],
            [11.584022094008981, 1.0685385273847736],
            [11.588962597832428, 1.0701564713590976],
            [11.592001367601979, 1.0688800197674613],
            [11.589550330886174, 1.0636294281839385],
            [11.587372974285278, 1.0542099648399643],
            [11.581261272938448, 1.0501267180178913],
            [11.57569180259305, 1.0497723965453238],
            [11.57457221369892, 1.0425759200724893],
            [11.575833378787015, 1.0398259201450228],
            [11.579938273740874, 1.0232747443079049],
            [11.580164228779116, 1.0204557689989564],
            [11.59183287532998, 0.9738480385738205],
            [11.597758157769304, 0.896517972232198],
            [11.597101439322426, 0.8867770913916098],
            [11.598124095835901, 0.8455622292596934],
            [11.596041810072077, 0.8187114774280173],
            [11.606916566182093, 0.793540076347095],
            [11.623877595767985, 0.7620597085130603],
            [11.586460933703641, 0.7198837994863628],
            [11.548098304578339, 0.6908460394994683],
            [11.545247640710055, 0.6956135571700159],
            [11.544872931582267, 0.7000125746503086],
            [11.537890075610104, 0.7021840181796607],
            [11.496033659346695, 0.7469904105012395],
            [11.488560887867848, 0.7553880147679757],
            [11.440585874420195, 0.807054609369347],
            [11.421848808453317, 0.800866071400326],
            [11.38567398426702, 0.8300496296346549],
            [11.399906092380595, 0.8509194047467971],
            [11.362740925787424, 0.8925271175673467],
            [11.32488732093862, 0.9351072782418022],
            [11.295223191020385, 0.9681559321877263],
            [11.287422490564119, 0.9798992017842337],
            [11.288546521088595, 0.9826086842828002]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.67477972490028, "lat": 38.83445066415054 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54035"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01559963"
      },
      "bbox": [
        11.287422490564119, 0.6908460394994683, 11.623877595767985,
        1.217605697202085
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.961029071188193, 2.0790491700685494],
            [11.964181040001929, 2.082672454276517],
            [11.975650911133181, 2.0905273472026638],
            [11.979954091688317, 2.096164735961951],
            [11.980820676298764, 2.1049892036320403],
            [11.976249287429276, 2.1150144452225557],
            [11.96856369875567, 2.122788767993401],
            [11.961690248792891, 2.133547539867835],
            [11.960347687628566, 2.140571868345485],
            [11.96085427570996, 2.1453770055071137],
            [11.963409156524646, 2.149694981534828],
            [11.969021983959987, 2.1515477231500757],
            [11.979080539919698, 2.1505877574290206],
            [11.991227958761367, 2.1448667536956085],
            [11.99706092677862, 2.14505731469977],
            [11.998580717644758, 2.1468558009208176],
            [11.999369741758679, 2.1532437602329275],
            [11.998083731336871, 2.157154962444866],
            [11.993315443491413, 2.165080027289748],
            [11.98809627974623, 2.1821181604824003],
            [11.987834724069884, 2.1891368387772263],
            [11.990547125169124, 2.1954255680289414],
            [11.998609542812353, 2.2038719303262555],
            [12.00247996826545, 2.2091564577570435],
            [12.001225709476765, 2.223582084260265],
            [11.99755635565947, 2.2349851505752243],
            [11.995420009975922, 2.243612461288372],
            [11.995024754285797, 2.2533385962242924],
            [11.996157268462461, 2.2591768843343094],
            [11.995366509738894, 2.266027725217714],
            [11.99752338413185, 2.2722651610145483],
            [12.029527316262582, 2.274487851626154],
            [12.057827963916424, 2.275819066560618],
            [12.058985101240362, 2.2761769922584496],
            [12.11171631922765, 2.2785003196884497],
            [12.117268144469692, 2.279163118286848],
            [12.160658558971544, 2.281549950292263],
            [12.169457398605486, 2.227596800236717],
            [12.173563378568563, 2.2024846565574534],
            [12.181359791673948, 2.15674970467619],
            [12.194836206671331, 2.072307095781067],
            [12.208772513519158, 1.9879362656961566],
            [12.142351805856721, 1.9775610467617655],
            [12.125324487084887, 1.9743566202754403],
            [12.048233410634243, 1.96171788114704],
            [11.972594260245188, 1.948943563422997],
            [11.969737018557955, 1.9516642706907703],
            [11.96036879433179, 1.9643464901318748],
            [11.95311457354906, 1.9680645694646097],
            [11.943418959762774, 1.9773975432297746],
            [11.938315310999362, 1.9871052880244866],
            [11.939715900186398, 1.9956898583286888],
            [11.94162917389113, 1.9995306907655261],
            [11.959998305116846, 2.0183101058240625],
            [11.965670887067564, 2.0272874675860644],
            [11.966494166633465, 2.0408278987060045],
            [11.964140971013109, 2.0539988877480964],
            [11.959587403286113, 2.0643310273191835],
            [11.958095348116368, 2.0700713163104627],
            [11.961029071188193, 2.0790491700685494]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.6633942942154, "lat": 39.86059982873188 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54051"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01717539"
      },
      "bbox": [
        11.938315310999362, 1.948943563422997, 12.208772513519158,
        2.281549950292263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.887609391867532, 7.059480295149824],
              [6.888930707593261, 7.062116294234311],
              [6.897178541039904, 7.061337430936929],
              [6.902496599611913, 7.057516970304927],
              [6.906359618048674, 7.048198980782513],
              [6.9072150660242375, 7.042717119450515],
              [6.905318905011816, 7.041280830267826],
              [6.898292692161281, 7.04267921658738],
              [6.8904830876277865, 7.039707465042571],
              [6.889453159340791, 7.044527432950723],
              [6.889755143794646, 7.050179316587326],
              [6.887609391867532, 7.059480295149824]
            ]
          ],
          [
            [
              [6.8071271250725385, 6.977980166648687],
              [6.8075969036646455, 6.984571199060505],
              [6.812319963355415, 6.982139134929557],
              [6.813414755152833, 6.98524339459159],
              [6.811829867339072, 6.992817443901319],
              [6.805842789840547, 7.005457626405407],
              [6.804807538273112, 7.009393876839882],
              [6.810308125844409, 7.041358661428872],
              [6.8137095747310905, 7.047381424754078],
              [6.818843882988755, 7.044448561522565],
              [6.822052105762966, 7.036390580979807],
              [6.821527991414097, 7.02618848168713],
              [6.82567290235808, 7.024918904666047],
              [6.828128016853288, 7.032474543954689],
              [6.831079649422017, 7.036328609838109],
              [6.837553218432656, 7.036714614751798],
              [6.839788513876168, 7.038411543956841],
              [6.845941507260993, 7.038495567640335],
              [6.856214919214871, 7.0444637765344185],
              [6.867596924998236, 7.043643499021343],
              [6.8740407460579025, 7.037758083373938],
              [6.872342314468685, 7.0315324967419786],
              [6.875917647315464, 7.029142220729769],
              [6.881888145435692, 7.031274531181048],
              [6.885862944219842, 7.027090825515273],
              [6.882488497550109, 7.020915214179723],
              [6.879880481161471, 7.005355060229516],
              [6.8769346734560735, 7.003682238610735],
              [6.8701970815941396, 6.997078939423257],
              [6.871501248577128, 6.987990441668669],
              [6.868878331288573, 6.9849153364933905],
              [6.868620718798556, 6.981383187064116],
              [6.8716074395974465, 6.973121386160049],
              [6.871447343587019, 6.96782152530626],
              [6.8658508223008035, 6.962483509375408],
              [6.8577980926382835, 6.965697852663233],
              [6.853701926997713, 6.968627016158874],
              [6.847643900206201, 6.965881401221372],
              [6.846015126354599, 6.9628270331161595],
              [6.842829020141632, 6.952219641133575],
              [6.843745035422182, 6.946161052492038],
              [6.850033368991036, 6.941642890705629],
              [6.852955061425156, 6.9335392243254],
              [6.853823224984663, 6.926604452334984],
              [6.848273329000216, 6.926851694376668],
              [6.849076453582664, 6.932130759432811],
              [6.845707221939593, 6.940193959485896],
              [6.842647190152618, 6.943449459200635],
              [6.8370361716263535, 6.945918508098055],
              [6.832101798586249, 6.952699373417778],
              [6.829553973950477, 6.957851469201623],
              [6.8260947510271555, 6.960204393299343],
              [6.814388758278986, 6.961999395720482],
              [6.808101077004814, 6.968357511298952],
              [6.8071271250725385, 6.977980166648687]
            ]
          ],
          [
            [
              [6.808258174906589, 6.937952652144794],
              [6.809441165906628, 6.94134932205418],
              [6.816914679572521, 6.939317999734527],
              [6.820751645255279, 6.931998513063177],
              [6.820434975919611, 6.927989437958628],
              [6.81090189359102, 6.931200367868909],
              [6.808258174906589, 6.937952652144794]
            ]
          ],
          [
            [
              [6.527657572066481, 6.784420585030981],
              [6.529389999972367, 6.790007855501934],
              [6.528010871493735, 6.798691696381925],
              [6.532182496561311, 6.799096698273412],
              [6.5360185003109095, 6.8034671015538555],
              [6.5389137678949805, 6.799182773618446],
              [6.543779929109866, 6.799954732973361],
              [6.548314962254609, 6.804580829313008],
              [6.549084734809507, 6.809947334680765],
              [6.5535398173860075, 6.81445467079832],
              [6.557313155621993, 6.809519524854754],
              [6.554016297519342, 6.80520775444696],
              [6.5563806219463485, 6.798609638616202],
              [6.557063588125435, 6.783901850855401],
              [6.555707854005107, 6.778868632939326],
              [6.556676505659368, 6.773161992220753],
              [6.56129560569997, 6.765785470684612],
              [6.559757248439776, 6.764261444787408],
              [6.528584720466724, 6.778762096766927],
              [6.527657572066481, 6.784420585030981]
            ]
          ],
          [
            [
              [6.575543295533887, 6.280672086400762],
              [6.5596272202703805, 6.2793557271458775],
              [6.473630508367049, 6.271340724280642],
              [6.423530095394781, 6.267172921666242],
              [6.380383200822232, 6.263784854929542],
              [6.32023797792051, 6.259701816086904],
              [6.324225814948977, 6.265036642135448],
              [6.330354514273018, 6.276798116766013],
              [6.33149130618829, 6.281640139767084],
              [6.330053295441397, 6.291334552283294],
              [6.3266734417068555, 6.30219666775824],
              [6.326841977233841, 6.307788850379825],
              [6.331292638087435, 6.314629515143969],
              [6.3355869238932, 6.317793895348396],
              [6.336269456864943, 6.322280872155798],
              [6.348052097659638, 6.346584241980306],
              [6.356218120678884, 6.358388843060901],
              [6.3629340890278, 6.366236174072025],
              [6.363439384535839, 6.374951149895987],
              [6.373003969727091, 6.385974739215696],
              [6.378186182928871, 6.401256455029988],
              [6.3858916101084615, 6.411539612777127],
              [6.391950746196773, 6.423890238676044],
              [6.395069619847749, 6.427532188823139],
              [6.406381849295629, 6.433145910432709],
              [6.408882242604099, 6.437406499742572],
              [6.414158463181957, 6.442611538933172],
              [6.419001315629924, 6.444503045309139],
              [6.427611823559333, 6.443911054677158],
              [6.4348033578142125, 6.444701423718095],
              [6.436009052175332, 6.441478486869933],
              [6.431018373048107, 6.438977038629116],
              [6.429711260180163, 6.4356895003652275],
              [6.42674957780736, 6.422305900564936],
              [6.433290801840907, 6.421853160669492],
              [6.431713365970529, 6.417706926238547],
              [6.436015487816642, 6.417268188385927],
              [6.440263461271939, 6.422630569070582],
              [6.443855854144881, 6.424355170225922],
              [6.444806399677698, 6.436095288202144],
              [6.448536896244643, 6.443325779198035],
              [6.447041531170674, 6.448713316227826],
              [6.448893430729687, 6.451665746729343],
              [6.45194145473487, 6.444635383306024],
              [6.461487506455967, 6.44467339198737],
              [6.468535681172607, 6.4503084422668175],
              [6.4685263590444, 6.453767284323399],
              [6.4634363612094505, 6.457574159160457],
              [6.461392962182758, 6.462179899290331],
              [6.456223602032997, 6.465554325159677],
              [6.457696499771107, 6.467569861969679],
              [6.470974928264431, 6.46020512092347],
              [6.470467607772836, 6.454246008100581],
              [6.47582488897798, 6.451020005346251],
              [6.481369026503372, 6.451345732530463],
              [6.48414272375797, 6.454287600265421],
              [6.485580278887367, 6.460725760120493],
              [6.489847138204188, 6.463427463440881],
              [6.489987211528786, 6.4666037841557396],
              [6.4989391137901835, 6.477774283178479],
              [6.50838475498312, 6.4847582411744655],
              [6.5086730063634315, 6.489136779668627],
              [6.514918712451213, 6.492501181698544],
              [6.524400651064908, 6.488212223003822],
              [6.525461116834356, 6.486091239833916],
              [6.513071455724399, 6.487175280319221],
              [6.5114575049112675, 6.484506318276094],
              [6.512156345839182, 6.480530014880302],
              [6.516403505984621, 6.480238803121879],
              [6.519737637375767, 6.482557865305575],
              [6.525718051242377, 6.476683059190446],
              [6.530257091303968, 6.4708806418740235],
              [6.53398007819662, 6.463485754118809],
              [6.53730882901686, 6.461843780976427],
              [6.542089667890829, 6.45224651894067],
              [6.544665270438536, 6.44439413237624],
              [6.54788712197905, 6.440971668022756],
              [6.55083680380349, 6.434169294130513],
              [6.554020802953135, 6.434456776157024],
              [6.5560759616315245, 6.437843917578246],
              [6.551823664232653, 6.447397883634277],
              [6.551029814580078, 6.452379504703213],
              [6.553541954256927, 6.456311332943771],
              [6.552047692673489, 6.46341719804915],
              [6.5512217198194405, 6.472593932843702],
              [6.549653334558628, 6.476668584637562],
              [6.55047668929375, 6.488083262486209],
              [6.548793673947976, 6.4927768074342245],
              [6.542410225099852, 6.5004294860854],
              [6.532825563443715, 6.50585147149518],
              [6.53300476015979, 6.513177602713071],
              [6.539081906270486, 6.5226168310035995],
              [6.536463878469933, 6.526897758902785],
              [6.5391279415938675, 6.536296674718263],
              [6.543003061201976, 6.541669666305911],
              [6.55020337272927, 6.559513275917655],
              [6.557600133355761, 6.591161102586242],
              [6.560790895704169, 6.598677758551052],
              [6.566944651255899, 6.607661655984947],
              [6.567848470709657, 6.616709708620329],
              [6.574835810751354, 6.620649966580814],
              [6.578518630345591, 6.633740419318375],
              [6.580669250997462, 6.6372925963917355],
              [6.5803700466599855, 6.643736803313926],
              [6.585164259921234, 6.646628727648973],
              [6.588799009066767, 6.650791513046578],
              [6.589220924410199, 6.6571662497819695],
              [6.594805337733114, 6.6605252706344364],
              [6.596723412286175, 6.656172449945294],
              [6.599657180229686, 6.6535899799901035],
              [6.60582152550342, 6.654320538716641],
              [6.605974600495918, 6.665401340374629],
              [6.604088223928728, 6.671342395293871],
              [6.605735693641582, 6.683217883932291],
              [6.60791093531885, 6.685267947845055],
              [6.612887793011396, 6.6856801367218],
              [6.6160961749501705, 6.690081647180507],
              [6.617864611951414, 6.6951501906484765],
              [6.618109061403565, 6.701472967515303],
              [6.616523033497475, 6.721947997425208],
              [6.617609011467953, 6.730439600388162],
              [6.621747916102966, 6.7403478104233585],
              [6.626511948073941, 6.73722978712432],
              [6.629650575206028, 6.737974061252017],
              [6.628579141257199, 6.746413147586391],
              [6.625250093582269, 6.758825287217672],
              [6.627444608638255, 6.7658464074074],
              [6.627229868237703, 6.769270413663438],
              [6.630343354191023, 6.772637646408675],
              [6.627199033570388, 6.777762856121841],
              [6.631297978308772, 6.782847465967363],
              [6.636818112951719, 6.7850865977686565],
              [6.638481796610249, 6.775106493924975],
              [6.645721055077472, 6.777230033230028],
              [6.6513303970764985, 6.775050720590112],
              [6.65791607645996, 6.774789585293958],
              [6.659036101695842, 6.7706305871954395],
              [6.664260469953905, 6.763295643869365],
              [6.67045982802009, 6.761984665478862],
              [6.676247944040168, 6.76700616665551],
              [6.674116472609366, 6.770651246986855],
              [6.673214719423542, 6.779057708851745],
              [6.670660157561106, 6.786638223904408],
              [6.675213489163703, 6.797583844477337],
              [6.681805358562882, 6.8013113656341515],
              [6.685985889615116, 6.799680618911849],
              [6.689084233287487, 6.8071713410074635],
              [6.692470313198312, 6.806684061829946],
              [6.698296048625618, 6.8089557600427115],
              [6.705120423110249, 6.806642679837253],
              [6.707613163589109, 6.808085291381905],
              [6.706671938228446, 6.822307359783616],
              [6.704721642395372, 6.826460435853295],
              [6.702640209953543, 6.839454470407738],
              [6.704559060498608, 6.847210463574807],
              [6.705385890129055, 6.858194634261636],
              [6.709369277896469, 6.865349086575511],
              [6.709325174431335, 6.87401126722705],
              [6.715441228444469, 6.877177596592964],
              [6.721150782009705, 6.873961349920828],
              [6.731603880925656, 6.871765493123337],
              [6.7333346022629605, 6.874765237227171],
              [6.731142141496176, 6.878399988219939],
              [6.729817780633626, 6.884624362925938],
              [6.732446493871184, 6.8912081314991775],
              [6.73354305070026, 6.899572190217312],
              [6.733368977459511, 6.908676120389144],
              [6.73460572456555, 6.9151012313384665],
              [6.739735322613331, 6.9185575042389145],
              [6.741756762978641, 6.912795660550075],
              [6.7465592757908235, 6.906311567621873],
              [6.75212867200254, 6.9057154209769],
              [6.755746272405703, 6.909223786941131],
              [6.761601497358634, 6.9094594668662435],
              [6.764952004138069, 6.907772904540893],
              [6.767107455448941, 6.90981047425087],
              [6.765667450577192, 6.914346482824141],
              [6.767537560519154, 6.920206388145456],
              [6.771510834590039, 6.921490198720729],
              [6.776667019856932, 6.917741429482233],
              [6.780186475925559, 6.918631811996916],
              [6.783217348197084, 6.922088366096171],
              [6.7881714300309905, 6.920391679143392],
              [6.793503950802022, 6.9201877806962715],
              [6.797850110730928, 6.915924923230846],
              [6.802196992084432, 6.90978339133355],
              [6.804207944048951, 6.904323903387498],
              [6.801915767478417, 6.897489326373673],
              [6.79571206620016, 6.889461813029644],
              [6.795847467509924, 6.883794497476785],
              [6.798637087029176, 6.873578556002299],
              [6.805078003439553, 6.871829160226712],
              [6.803729943040064, 6.867130829875587],
              [6.797732632346878, 6.86390037116537],
              [6.797232884040299, 6.8586254908846485],
              [6.802779703552536, 6.850893555924141],
              [6.799609649923933, 6.84135257631751],
              [6.794437247962474, 6.842964248725073],
              [6.792127836969047, 6.8387548647463605],
              [6.787796899344434, 6.836226408854409],
              [6.785826110273271, 6.837958038453491],
              [6.783500427805567, 6.846155831446782],
              [6.780833199652033, 6.850496660548724],
              [6.768332668439346, 6.856202804725244],
              [6.762084784082405, 6.853568851750132],
              [6.760645572997356, 6.84922707949466],
              [6.763425915765829, 6.84715676209101],
              [6.761803140258487, 6.8435531299511645],
              [6.766099772528406, 6.840931564589458],
              [6.765934132595308, 6.836281909568854],
              [6.7606371788658635, 6.833211408386028],
              [6.763683885200393, 6.820561679657094],
              [6.760862115433427, 6.794377114829463],
              [6.762671571731562, 6.780886051156566],
              [6.774508530967681, 6.77145689723602],
              [6.7750794125667415, 6.768734983771306],
              [6.768215638254679, 6.760219560798315],
              [6.761434722590337, 6.758756556351814],
              [6.76105232932272, 6.761891708398299],
              [6.757101179935666, 6.764319822502716],
              [6.756579350417798, 6.769110129361318],
              [6.751574605951887, 6.773345546879031],
              [6.748581404968075, 6.778261642375361],
              [6.739305943025409, 6.776296791214281],
              [6.7392311760744175, 6.767999582587506],
              [6.736445922876808, 6.764701297541387],
              [6.742566877718886, 6.7557486748459885],
              [6.743922510560352, 6.749402576549047],
              [6.748258108099061, 6.747587572884563],
              [6.757803800140393, 6.746304802449192],
              [6.76298404127337, 6.738451890616844],
              [6.765517501492504, 6.728268578422783],
              [6.763154403877709, 6.7237230522625975],
              [6.764549400864713, 6.719934332039459],
              [6.767850097742085, 6.7167617440012855],
              [6.767780099764598, 6.710527585778646],
              [6.764589616698821, 6.712098814772378],
              [6.76119554504122, 6.709619535584986],
              [6.757950398454165, 6.701175291460566],
              [6.754521502283939, 6.701099896725317],
              [6.7526579576500865, 6.706590933920499],
              [6.748292736170221, 6.708877881238209],
              [6.7433205076770815, 6.716191252605089],
              [6.738972977538658, 6.715519433431431],
              [6.7350817051045135, 6.713057062400502],
              [6.7328804433756995, 6.707342307391528],
              [6.733829813441511, 6.701252316960039],
              [6.737578146641504, 6.6980778714582625],
              [6.742004128069497, 6.698412313862195],
              [6.7468106602924784, 6.692795437839381],
              [6.745891634730874, 6.686649276256858],
              [6.7481714601108775, 6.6804184412309375],
              [6.740040448255017, 6.676493665601718],
              [6.7357888124533245, 6.68413777251456],
              [6.734188540442895, 6.689557312182646],
              [6.7285542887896375, 6.6902842658810835],
              [6.722172748098181, 6.689315227702912],
              [6.716683205468766, 6.685100157540435],
              [6.716566376551994, 6.677126546266884],
              [6.717855359284932, 6.660532037748347],
              [6.714634061413872, 6.654451331072891],
              [6.715363401905931, 6.649186317752915],
              [6.710641551273919, 6.630091250480575],
              [6.700628605915683, 6.625717773750158],
              [6.694381478876776, 6.620916339000621],
              [6.691468292771101, 6.614111410922911],
              [6.68796632573386, 6.601336866983316],
              [6.683691289728115, 6.595948419578066],
              [6.679548014937851, 6.583322094026004],
              [6.68183790525184, 6.570486117921265],
              [6.682179666039404, 6.563027950082149],
              [6.689831644252777, 6.557900844397374],
              [6.694403536916803, 6.551709849401822],
              [6.6954555935618165, 6.5476672742271305],
              [6.693535282965291, 6.543765281966836],
              [6.685432885205321, 6.540731835270009],
              [6.673909955750775, 6.531030369437675],
              [6.668698689215313, 6.524851966742086],
              [6.666590206182189, 6.520140772308898],
              [6.6665419901646645, 6.511383913921523],
              [6.675327348265287, 6.500289326905794],
              [6.675155451993983, 6.4970862311764614],
              [6.677509514157473, 6.490161025955098],
              [6.674045010922395, 6.486233470565018],
              [6.670912682566508, 6.486372668000141],
              [6.6642896099421725, 6.48179894095797],
              [6.663804439130769, 6.478563858976419],
              [6.656583149843235, 6.472608458169702],
              [6.639661045197008, 6.462124965788909],
              [6.633439508313906, 6.4533188621498745],
              [6.631043787355142, 6.443499520211778],
              [6.629049674809178, 6.427119800142131],
              [6.628132675779778, 6.424788673324096],
              [6.621847176549484, 6.421089424095226],
              [6.613360526393604, 6.413317162032818],
              [6.613031436235034, 6.408160537285273],
              [6.60891475433993, 6.403309530752837],
              [6.605158828501045, 6.396475025909055],
              [6.60403619165581, 6.389157331222695],
              [6.6064152324970795, 6.379423524993736],
              [6.605217518257963, 6.375317065779741],
              [6.596946333308795, 6.356965672756532],
              [6.596351557882157, 6.344927111480557],
              [6.593857322148355, 6.326177187313334],
              [6.589136502246573, 6.3128327476683745],
              [6.5881729285009465, 6.308346848053267],
              [6.583951954784278, 6.300791276259469],
              [6.583140362891642, 6.296614093603392],
              [6.575543295533887, 6.280672086400762]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.31557293865674, "lat": 44.94498457323964 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55029"],
        "coty_name": ["Door"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Door County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01581074"
      },
      "bbox": [
        6.32023797792051, 6.259701816086904, 6.9072150660242375,
        7.062116294234311
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.528331738012265, 5.606853348843727],
            [4.531103422510936, 5.563406491797497],
            [4.536006573779126, 5.477824777638074],
            [4.5386437063179095, 5.433493475367307],
            [4.542249707898389, 5.379400153417365],
            [4.5437764279902835, 5.352883593168536],
            [4.547750515564176, 5.2931315050243395],
            [4.550566017085732, 5.240956149339122],
            [4.55400339727921, 5.184194280343939],
            [4.525671855638346, 5.180852488329497],
            [4.5096709871009155, 5.178642877027071],
            [4.467677883815526, 5.173501436998707],
            [4.381753669418911, 5.168292769096898],
            [4.356776083181206, 5.167048280745873],
            [4.356560338028888, 5.170741534890127],
            [4.342324447828099, 5.17001884628137],
            [4.34250574888451, 5.166397768786489],
            [4.300758068947954, 5.164487519254232],
            [4.236087238860062, 5.16012571887815],
            [4.199785626919955, 5.157937877814627],
            [4.124400401600818, 5.153754920840178],
            [4.11909251008652, 5.248138572764931],
            [4.116666831819264, 5.298683996104572],
            [4.115449916820831, 5.327419317124034],
            [4.114186107330022, 5.348424341810573],
            [4.108626647219963, 5.420537992093392],
            [4.106273472033095, 5.456609205636415],
            [4.104180793372143, 5.499197472135869],
            [4.061182432386641, 5.496277836952507],
            [4.058362141462635, 5.541841304097554],
            [4.062382249606943, 5.543741414048865],
            [4.060010608484129, 5.548509827763318],
            [4.054927415589354, 5.5514793040707415],
            [4.056479484677748, 5.554935246940258],
            [4.060864758620362, 5.555276358444246],
            [4.062037349471233, 5.561102496612003],
            [4.068045450897993, 5.562945774416416],
            [4.068766814524027, 5.567173026352691],
            [4.07263198191723, 5.567488438398828],
            [4.0761281682418495, 5.5735386184635445],
            [4.078118133400197, 5.5699030033701105],
            [4.082129760160925, 5.573899781359242],
            [4.088491564482643, 5.572659592251751],
            [4.093848590306238, 5.574555559173362],
            [4.097543531480654, 5.579998388849451],
            [4.105476879496227, 5.5860555659164834],
            [4.185479316586728, 5.590944413517591],
            [4.1981875138800495, 5.5918282839220455],
            [4.27117872557911, 5.5963213652562],
            [4.356076137593896, 5.6018186346124965],
            [4.4400325019052085, 5.607578171207883],
            [4.526495181377541, 5.606742867490717],
            [4.528331738012265, 5.606853348843727]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.61779264622635, "lat": 43.94573717856728 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55081"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01581101"
      },
      "bbox": [
        4.054927415589354, 5.153754920840178, 4.55400339727921,
        5.607578171207883
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.985964525242343, 4.100296674632275],
            [-7.9650981508847, 4.272324406166469],
            [-7.85918400398693, 4.259564046686085],
            [-7.753272489684498, 4.246781827714456],
            [-7.6473636337073945, 4.233977752349947],
            [-7.541457461715312, 4.22115182420169],
            [-7.5210013890645016, 4.218634356723441],
            [-7.416500258648185, 4.205490712110986],
            [-7.312001943140462, 4.1923257790866035],
            [-7.3115582764259335, 4.192130647359585],
            [-7.172366982399546, 4.178333343642515],
            [-7.033179186304111, 4.164498477809458],
            [-6.910964619231034, 4.151204843442771],
            [-6.909176951322844, 4.151033308156371],
            [-6.939921307785979, 3.869979601186201],
            [-6.940410815993822, 3.8668127444255944],
            [-6.947201023111819, 3.805013927029701],
            [-6.956283889062053, 3.707569993755536],
            [-6.965656382960107, 3.620297138967042],
            [-6.96588572735663, 3.6165143149008525],
            [-6.974939275687277, 3.5331670760160843],
            [-6.979123122767319, 3.4926420547787322],
            [-6.990034904109549, 3.384553468578609],
            [-7.003855086522969, 3.2489045101414993],
            [-7.016103915201654, 3.1128935907383],
            [-7.1196040651123, 3.1226832243646427],
            [-7.119515365461579, 3.123962242873391],
            [-7.204409894429803, 3.1332559179298656],
            [-7.20644430974251, 3.1130558416755956],
            [-7.210857607060023, 3.0728941512820964],
            [-7.246406076305771, 2.7367605669255215],
            [-7.29468959523666, 2.744082912496167],
            [-7.344809283207848, 2.7505186576008445],
            [-7.494980508764134, 2.767730701451386],
            [-7.645155652885323, 2.784908548505112],
            [-7.751262832458146, 2.7979412700785105],
            [-7.837141581032237, 2.8076551413353825],
            [-7.9301751190782035, 2.8182973445971453],
            [-7.987083810334168, 2.8252402957941523],
            [-8.023966758867122, 2.8297648859520534],
            [-8.119936278120374, 2.840941747788259],
            [-8.215907393206912, 2.8521046310531797],
            [-8.264755834450005, 2.8580993227364075],
            [-8.43338678720787, 2.879056896434331],
            [-8.382426215349533, 3.2749007774805987],
            [-8.391856203954648, 3.2761195403277656],
            [-8.379315645590781, 3.374695611659197],
            [-8.37913548463946, 3.377377257964972],
            [-8.358814406252666, 3.536660414139613],
            [-8.24803997809051, 3.5214827010023098],
            [-8.247092385217703, 3.521226045851841],
            [-8.106296842189504, 3.50334075896313],
            [-8.050003255903917, 3.4962864258392576],
            [-8.040139206771943, 3.579231341597533],
            [-8.036781646383762, 3.578840830050537],
            [-8.025641184374777, 3.669025542515291],
            [-7.993301496467419, 3.925331635439085],
            [-8.006835143447978, 3.9269752288511843],
            [-7.996662330839187, 4.01331714721741],
            [-7.985964525242343, 4.100296674632275]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.93057430458185,
          "lat": 41.694436297071036
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56007"],
        "coty_name": ["Carbon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carbon County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01605069"
      },
      "bbox": [
        -8.43338678720787, 2.7367605669255215, -6.909176951322844,
        4.272324406166469
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.570629205896717, 6.078249637628482],
            [-9.567535276390846, 6.078560322428219],
            [-9.564638796149302, 6.073810993522899],
            [-9.55749132164699, 6.0707233610006535],
            [-9.55775195944094, 6.064363774385059],
            [-9.553018099378354, 6.053371712082468],
            [-9.553487416042671, 6.050716626849313],
            [-9.550516429391434, 6.046342224197713],
            [-9.552011934800953, 6.035362265968936],
            [-9.55122544736551, 6.033833304155844],
            [-9.540357779945632, 6.0323295354725035],
            [-9.540116803305828, 6.02630694505047],
            [-9.54212310052019, 6.020985188362368],
            [-9.540942592584669, 6.0176523564463515],
            [-9.537197544342979, 6.014312592623234],
            [-9.533092840105516, 6.014000964093499],
            [-9.528183978750539, 6.017704461755956],
            [-9.520764783980106, 6.018016201746832],
            [-9.516254420082861, 6.02317052351267],
            [-9.510149977164527, 6.02547898753559],
            [-9.501395177467876, 6.017784184570589],
            [-9.497249184564202, 6.017125525821018],
            [-9.494114407520705, 6.010173850300053],
            [-9.490119888538526, 6.00782253345465],
            [-9.486752489948234, 6.0033879449294165],
            [-9.479127155379459, 6.002258429109884],
            [-9.466345633245039, 6.001372537896846],
            [-9.457818162998885, 6.0021666880783355],
            [-9.453875821416432, 6.004539316702223],
            [-9.449338735322907, 6.005194668253532],
            [-9.440093192992322, 6.008567668737935],
            [-9.438505762687445, 6.000539717745676],
            [-9.44081640770879, 5.999614921097283],
            [-9.441876679362425, 5.993381905557816],
            [-9.44684276349429, 5.991592926009062],
            [-9.454438352503697, 5.9860566617085995],
            [-9.454226795359155, 5.980320493278971],
            [-9.446363501115341, 5.977345917324113],
            [-9.441800323429389, 5.974586683295586],
            [-9.438944747379756, 5.971134540960016],
            [-9.43885220373376, 5.966993916235468],
            [-9.440590671205639, 5.96284096013088],
            [-9.439645283240784, 5.958187209618417],
            [-9.448810092668063, 5.952094060595543],
            [-9.440730168049729, 5.950381479699861],
            [-9.433956473992863, 5.943788427144426],
            [-9.430679583812706, 5.943708222549714],
            [-9.430175586077981, 5.938305400204821],
            [-9.425443434169935, 5.934980845089495],
            [-9.4217446386712, 5.930504294149549],
            [-9.421426764229718, 5.927689831911248],
            [-9.430855824718117, 5.9236905384809715],
            [-9.433601226036279, 5.920213278170998],
            [-9.432033642741482, 5.915242330612302],
            [-9.426768002864215, 5.915134087627649],
            [-9.424151950940331, 5.910600014263637],
            [-9.426400932441302, 5.907289185884446],
            [-9.431602862653886, 5.903738443653319],
            [-9.440316433071438, 5.904298245534546],
            [-9.442978969970861, 5.902753794571524],
            [-9.4475232426338, 5.903902405353105],
            [-9.450618153183292, 5.900403640855375],
            [-9.453548738844768, 5.899795966301919],
            [-9.455449204202003, 5.893453048069827],
            [-9.453921823784563, 5.888122453086],
            [-9.455622293605515, 5.886490255862677],
            [-9.457383785011363, 5.880283168028045],
            [-9.454885337811021, 5.876007719212994],
            [-9.44989411202722, 5.871060640131663],
            [-9.44716002866145, 5.8699096661992005],
            [-9.443072259537537, 5.872059097893927],
            [-9.436918779464825, 5.872757887237626],
            [-9.437424290269256, 5.86505996456862],
            [-9.429118082504008, 5.861545426514527],
            [-9.42654584041313, 5.856747576606707],
            [-9.421770651919827, 5.8553985493793865],
            [-9.419701727121764, 5.852479089072182],
            [-9.413694275579173, 5.848563113532835],
            [-9.40651705683389, 5.85142974129438],
            [-9.404915372792432, 5.856205771259649],
            [-9.39900751113072, 5.856458285072372],
            [-9.394676063891026, 5.8591020587475455],
            [-9.392706186434163, 5.863027270675026],
            [-9.38836936314789, 5.859081557398617],
            [-9.38518958358774, 5.858731580545729],
            [-9.38325875812351, 5.862062092100139],
            [-9.375716743842004, 5.8678608938267685],
            [-9.371695221432349, 5.86667198588597],
            [-9.368011939251303, 5.872145965659185],
            [-9.361455834876303, 5.8709834720943475],
            [-9.35912325630266, 5.875170508660743],
            [-9.349427811354476, 5.872967910970393],
            [-9.346179151848823, 5.876911876144767],
            [-9.340963743930491, 5.874421093637073],
            [-9.336704949792514, 5.874205157622962],
            [-9.33366911239124, 5.878343747220984],
            [-9.327374956442007, 5.875878101982452],
            [-9.323865310965147, 5.8778073452942685],
            [-9.31937567952814, 5.877784218691639],
            [-9.31763445709378, 5.889044130703979],
            [-9.319979236040755, 5.892234496652805],
            [-9.320840401519922, 5.900568181120716],
            [-9.316717423191076, 5.9063804707800305],
            [-9.315026133286374, 5.912327028435677],
            [-9.311469814250943, 5.909794958840765],
            [-9.307377848335872, 5.911956414769088],
            [-9.304323292813677, 5.917027757099695],
            [-9.305166084306995, 5.926434109826204],
            [-9.30333545596511, 5.930807561716348],
            [-9.302356278919476, 5.93727578068193],
            [-9.297066308412528, 5.9424478120973685],
            [-9.295254910220596, 5.947042747919845],
            [-9.29118696554472, 5.95147662836235],
            [-9.287411792504638, 5.950903802270053],
            [-9.285031862029271, 5.953213909051133],
            [-9.279117136747608, 5.954277041823469],
            [-9.275413446897264, 5.952183866893287],
            [-9.270562026516101, 5.953250031929118],
            [-9.264055132696114, 5.961504143322095],
            [-9.262837029941194, 5.964407978911216],
            [-9.263432439336619, 5.970516008595235],
            [-9.25834116063909, 5.97313388170573],
            [-9.254680881254748, 5.969240658724369],
            [-9.25058944226987, 5.961353229082586],
            [-9.248195160206226, 5.960539453590994],
            [-9.243432503554317, 5.962671007368938],
            [-9.240293185240548, 5.967416288354949],
            [-9.2352987596342, 5.9718539640858515],
            [-9.233443383261367, 5.975512040027903],
            [-9.228479700214379, 5.974617138890023],
            [-9.222478257806467, 5.979746591106989],
            [-9.215040564400605, 5.979471624424451],
            [-9.213772121700794, 5.974844183478659],
            [-9.210910953689666, 5.971894661998405],
            [-9.209372275793918, 5.966664944000194],
            [-9.203734778265408, 5.961857606841869],
            [-9.202038858791948, 5.95886068611308],
            [-9.196862247345315, 5.954468563969793],
            [-9.190451068601508, 5.953244524241351],
            [-9.186623775205435, 5.95633685202064],
            [-9.177810507316364, 5.961526235771136],
            [-9.17153293318847, 5.9599074200715805],
            [-9.167931553091488, 5.956406040221369],
            [-9.16727352110759, 5.9499370603130535],
            [-9.169528116712645, 5.943571697265507],
            [-9.157620259819712, 5.937324137111426],
            [-9.155092864125299, 5.938868962783407],
            [-9.14844427520241, 5.938824619119796],
            [-9.146968549731596, 5.9278932796665185],
            [-9.144752766038291, 5.921768489029576],
            [-9.140317940313265, 5.917105810530841],
            [-9.1308767109402, 5.914977210449262],
            [-9.129856290264469, 5.909524088511327],
            [-9.125887104239633, 5.90694025949273],
            [-9.12723565083464, 5.904166592422429],
            [-9.125024515478412, 5.896759058116697],
            [-9.126062650777524, 5.893264648024844],
            [-9.123764784553542, 5.888848336817601],
            [-9.11920572551236, 5.886530642423838],
            [-9.11097805652755, 5.885489297607494],
            [-9.107360533043485, 5.879581465606552],
            [-9.10980164050454, 5.868795318655013],
            [-9.108472403613451, 5.858757456293227],
            [-9.10950966640027, 5.855216855943847],
            [-9.107303109324516, 5.850821802381996],
            [-9.10704350104, 5.8448005498925015],
            [-9.09870200454609, 5.842137425341132],
            [-9.095075198230447, 5.839987038889258],
            [-9.089096274115542, 5.839412656278397],
            [-9.085290878863885, 5.840822619391332],
            [-9.078648874821402, 5.835503941178263],
            [-9.07618667387477, 5.831408985312446],
            [-9.07722749340382, 5.826572062496629],
            [-9.074800311712863, 5.822400299946629],
            [-9.074834864083092, 5.815522525817872],
            [-9.07293376592573, 5.810030453072952],
            [-9.071895268147971, 5.8025560267356155],
            [-9.065259416754804, 5.799864399520279],
            [-9.062603633291824, 5.796596053315062],
            [-9.057165877183593, 5.795764868889692],
            [-9.053873220445459, 5.796760599812598],
            [-9.048048984263481, 5.787101744261942],
            [-9.045821801301424, 5.773793815974365],
            [-9.042237383993513, 5.7662410250975595],
            [-9.03263837396188, 5.761452149014421],
            [-9.031158833423868, 5.757421098362487],
            [-9.024274748170523, 5.753386751368745],
            [-9.020477359749565, 5.745297932954703],
            [-9.017918112815483, 5.735928924637542],
            [-9.014085105198415, 5.7292346394716365],
            [-9.009857119837456, 5.717834364863346],
            [-9.009842907850842, 5.710724299179501],
            [-9.00627126039036, 5.706091596606388],
            [-9.004931757522632, 5.700081434411854],
            [-9.002746834389189, 5.696222921520936],
            [-8.999633540459353, 5.694859852545524],
            [-8.995207895319616, 5.6903188986375834],
            [-8.995158439332993, 5.6882415445761945],
            [-8.988050052903148, 5.683077244271708],
            [-8.999206485798389, 5.60446405653296],
            [-8.91446553414613, 5.592513279576452],
            [-8.82972694521783, 5.580545980154374],
            [-8.831473822681883, 5.566209629248884],
            [-8.746004034728408, 5.555156684219667],
            [-8.750014156325953, 5.525732135637572],
            [-8.709475284001291, 5.520138729420624],
            [-8.664503867276034, 5.514442930631503],
            [-8.67060929242718, 5.471370799394622],
            [-8.585517233675354, 5.460346498919807],
            [-8.589400816932196, 5.4312997628796165],
            [-8.504096754655611, 5.419950158954505],
            [-8.507896290220613, 5.391315528829674],
            [-8.422558573828615, 5.379950103676899],
            [-8.42448309856991, 5.365778364224102],
            [-8.305657452722741, 5.35040754249167],
            [-8.294481744316235, 5.348852566671477],
            [-8.293002604727512, 5.359773793862953],
            [-8.192406913226705, 5.347644005684702],
            [-8.09181386500694, 5.335491484658374],
            [-7.9912234927795405, 5.323316232874242],
            [-7.890635829225683, 5.311118252796853],
            [-7.887052730963905, 5.34002732807184],
            [-7.843908861537985, 5.334739075789842],
            [-7.847484771733168, 5.3063478882071164],
            [-7.834590425890108, 5.304682417080044],
            [-7.865189486289344, 5.046649968933883],
            [-7.866041002123449, 5.046854122635911],
            [-7.876249448949613, 4.962138644285614],
            [-7.865859634227306, 4.96097991413116],
            [-7.896457865403688, 4.70867847227493],
            [-7.897025792236656, 4.7031520080949525],
            [-7.907287243803242, 4.616094346479277],
            [-7.937791059174064, 4.619697584823414],
            [-7.977155293508004, 4.289505379067606],
            [-7.979002267161736, 4.274015130976602],
            [-7.9650981508847, 4.272324406166469],
            [-7.985964525242343, 4.100296674632275],
            [-8.0680402026742, 4.109959586126053],
            [-8.157329009977886, 4.121455145862083],
            [-8.246619794796624, 4.132935540976284],
            [-8.335912542859498, 4.144400769132436],
            [-8.425207239856269, 4.155850828257212],
            [-8.58035065760263, 4.1769064566341685],
            [-8.655088260508053, 4.1865405328038],
            [-8.72349660456988, 4.195226202845723],
            [-8.843146161162505, 4.211228828390492],
            [-8.93474909562469, 4.223872451928332],
            [-9.026354244556385, 4.236500060460811],
            [-9.094564575326551, 4.245943671382147],
            [-9.093661601840282, 4.250277791114216],
            [-9.071112207177105, 4.414932591467479],
            [-9.089785744212689, 4.417337288326922],
            [-9.081036295092877, 4.483468336060218],
            [-9.079722634682094, 4.4999092227937805],
            [-9.078017373539435, 4.509678649233929],
            [-9.063580850919429, 4.619719227705707],
            [-9.057407652592875, 4.664922297683684],
            [-9.056357318303016, 4.676064855192286],
            [-9.086932107070021, 4.68058138034659],
            [-9.100834733096583, 4.683000109130614],
            [-9.099777394936714, 4.687051907070284],
            [-9.10167439473971, 4.694078528950422],
            [-9.094501272912291, 4.696394730246262],
            [-9.097024960970183, 4.69860714065203],
            [-9.097489586557188, 4.7063530899301265],
            [-9.099575552234816, 4.71029267528828],
            [-9.105944738910855, 4.717392677547742],
            [-9.101813727553385, 4.722553228628084],
            [-9.098232066546451, 4.722071721276364],
            [-9.094784324594388, 4.724079906269078],
            [-9.099709264659946, 4.727858214169152],
            [-9.099838713144452, 4.730436172018218],
            [-9.104644628001285, 4.733077791543132],
            [-9.110343721898968, 4.733266553124132],
            [-9.112591256993129, 4.734735681352005],
            [-9.112877469033178, 4.739324559353945],
            [-9.116983945405224, 4.7396946186967215],
            [-9.125502206861603, 4.7438812242303525],
            [-9.12793115115655, 4.7536149634505325],
            [-9.133184732995074, 4.759638217652179],
            [-9.134481792343024, 4.762837334402749],
            [-9.139992274369414, 4.763617041276054],
            [-9.144727040467048, 4.766174894825174],
            [-9.147950353018219, 4.763002424323306],
            [-9.149402571359548, 4.758091906914334],
            [-9.151703911748463, 4.756644404279386],
            [-9.156099029217906, 4.759324741270438],
            [-9.164007094138192, 4.766875202016295],
            [-9.163761760954484, 4.77522468117814],
            [-9.159760618977165, 4.78059261806692],
            [-9.154501109257136, 4.785331471570124],
            [-9.153535130972937, 4.788168517460117],
            [-9.14941560907763, 4.786907391843602],
            [-9.14195599212872, 4.7887852480464215],
            [-9.143768646891402, 4.79580944962742],
            [-9.15755283784155, 4.803445780930398],
            [-9.158835461099143, 4.807720187215869],
            [-9.164399673032152, 4.804185743476847],
            [-9.167319282647647, 4.805497743526105],
            [-9.174913085944981, 4.816442898933574],
            [-9.174616965072012, 4.819933955505909],
            [-9.176618024871452, 4.8250764613974955],
            [-9.17979393837264, 4.825785263074878],
            [-9.181761652317485, 4.836545725100853],
            [-9.18409935321244, 4.83820316587511],
            [-9.186769023900952, 4.849742055817349],
            [-9.19347957548113, 4.849521077473076],
            [-9.1994877872388, 4.856086683694334],
            [-9.208971125041165, 4.86191843055346],
            [-9.2137956919008, 4.8704273382316465],
            [-9.216014909970403, 4.884065707715114],
            [-9.215390478340264, 4.902584452452607],
            [-9.219872217068325, 4.9053322691790475],
            [-9.221709611457221, 4.916208972588806],
            [-9.222630587218013, 4.9286443667703885],
            [-9.228930315237662, 4.93416772265575],
            [-9.228917263499639, 4.9389099346308365],
            [-9.231073824020482, 4.946002044850137],
            [-9.236241395276188, 4.956432184389017],
            [-9.241486202230844, 4.953317910524725],
            [-9.248382629272612, 4.951197179106141],
            [-9.251748706725353, 4.953168408131402],
            [-9.25780300122351, 4.953742851373216],
            [-9.26014797220061, 4.964744570132978],
            [-9.264086157577436, 4.97021371644971],
            [-9.27080627989139, 4.973010847081723],
            [-9.275995178679734, 4.977165270261267],
            [-9.277533013378232, 4.984961594026034],
            [-9.283800994256346, 4.985556839672039],
            [-9.285232915883942, 4.988280680757223],
            [-9.292987130729356, 4.9893001606800835],
            [-9.293285559451549, 4.994210979710636],
            [-9.297876687462079, 5.001151163336117],
            [-9.295162016359583, 5.002461530007854],
            [-9.294743309071663, 5.007548614723607],
            [-9.298857075625591, 5.012071338249588],
            [-9.303319589348078, 5.01121203668592],
            [-9.304530413835474, 5.014817572339054],
            [-9.307434743557494, 5.016191901870549],
            [-9.313238880228424, 5.016142381769897],
            [-9.316663530285643, 5.018047552694649],
            [-9.317169666802661, 5.023532321144858],
            [-9.319481699507024, 5.026711082687224],
            [-9.319598187612009, 5.0302601922780825],
            [-9.32195626535878, 5.034138723830411],
            [-9.324651003666043, 5.034643131075918],
            [-9.330697799939704, 5.032008039224591],
            [-9.332934399957788, 5.03624208341472],
            [-9.336926332716576, 5.035148033572541],
            [-9.340639657242152, 5.040189127379461],
            [-9.348422360604994, 5.040527531060182],
            [-9.351307000073437, 5.038187275160381],
            [-9.357781799753802, 5.041303778427608],
            [-9.358510806268608, 5.05065304063463],
            [-9.356250989153716, 5.060730112882111],
            [-9.351540647238608, 5.064873053077972],
            [-9.353484228168124, 5.068436445998244],
            [-9.35949154384037, 5.068845484490132],
            [-9.35796611090024, 5.076968914890763],
            [-9.361535536169288, 5.0800973589877225],
            [-9.354487400283023, 5.084347257058513],
            [-9.350759442805696, 5.088151649208619],
            [-9.352156452020806, 5.0906775276931615],
            [-9.349328901224688, 5.0961161396793635],
            [-9.34954682059588, 5.100597999658586],
            [-9.353254454864858, 5.10325803985545],
            [-9.354943364307728, 5.106916341506061],
            [-9.353296661113076, 5.112502205798142],
            [-9.356546467876484, 5.114575906934505],
            [-9.359009634291585, 5.121864819087068],
            [-9.357421695769435, 5.124041265049067],
            [-9.359032331567906, 5.130095137405337],
            [-9.363105374536945, 5.1301544560423675],
            [-9.371094458118762, 5.147266739748332],
            [-9.373649881846726, 5.1505559194667985],
            [-9.379489901560824, 5.152110173048924],
            [-9.384423314180964, 5.158861120177574],
            [-9.39052790344003, 5.160396739780491],
            [-9.392401265036533, 5.16893926840187],
            [-9.394547724813735, 5.184873315378461],
            [-9.393127526229854, 5.187239521442812],
            [-9.392909690594678, 5.1988088178222736],
            [-9.39499510541218, 5.201822755232287],
            [-9.401834131477685, 5.198973128315285],
            [-9.40641180296681, 5.204414941963614],
            [-9.408431094847579, 5.214020164387591],
            [-9.406539259452478, 5.222017806470317],
            [-9.407222211053737, 5.23315055227437],
            [-9.408705424791988, 5.237894663623254],
            [-9.407686129964512, 5.241096693457826],
            [-9.411444238510635, 5.243122208225287],
            [-9.414226686805195, 5.248741495096147],
            [-9.41397243519522, 5.251905009653561],
            [-9.417408435658462, 5.254804845875583],
            [-9.415955660587136, 5.263651442809837],
            [-9.411209107367108, 5.267660604736825],
            [-9.412497889541957, 5.272365286795326],
            [-9.415598943654228, 5.275540324550556],
            [-9.413154598138071, 5.28803465797888],
            [-9.415997556930803, 5.294605824580141],
            [-9.415793605737692, 5.29886832116725],
            [-9.422194995588798, 5.3059867830093514],
            [-9.415255446163549, 5.308694021731587],
            [-9.410839092023114, 5.3143627187049125],
            [-9.414590832359728, 5.321969619531531],
            [-9.414153298348573, 5.325763189512067],
            [-9.40962103693022, 5.328965670236014],
            [-9.410141762378663, 5.332768002042466],
            [-9.40392376186337, 5.33535023763047],
            [-9.402116344353873, 5.339339355761267],
            [-9.40312124986872, 5.3429878341300725],
            [-9.401126812382465, 5.34843415648015],
            [-9.404402646191656, 5.352416204458825],
            [-9.405215309278955, 5.3572511810224075],
            [-9.409189960580207, 5.3579866148349575],
            [-9.414619607317746, 5.36533764779901],
            [-9.417001250686905, 5.371538847155837],
            [-9.417672289755064, 5.379918315934054],
            [-9.416640857130469, 5.383847733160643],
            [-9.412076711264131, 5.388602202708456],
            [-9.4092467940541, 5.402877702479771],
            [-9.40919772489397, 5.406354294655776],
            [-9.415821308374134, 5.4098731221421685],
            [-9.417406891866571, 5.415699848483682],
            [-9.42075949597448, 5.416086622704276],
            [-9.425759786001263, 5.413764085330279],
            [-9.430889219267602, 5.413307555981318],
            [-9.436387406864306, 5.410174159719207],
            [-9.443367943961075, 5.410010920243406],
            [-9.445322902289243, 5.411854308551535],
            [-9.451843279246937, 5.412278335537127],
            [-9.43792658934523, 5.508608842795001],
            [-9.543884540692034, 5.524960671858202],
            [-9.649846520925923, 5.541287043257527],
            [-9.60876368794025, 5.814527666085076],
            [-9.598018026479584, 5.886917060554301],
            [-9.599567082686448, 5.887247537274545],
            [-9.570629205896717, 6.078249637628482]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.63044629489946,
          "lat": 43.04053177925648
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56013"],
        "coty_name": ["Fremont"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fremont County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01605072"
      },
      "bbox": [
        -9.649846520925923, 4.100296674632275, -7.834590425890108,
        6.078560322428219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.828307446864462, 4.358119030948287],
            [-9.790859778403767, 4.351875411080503],
            [-9.786842655765554, 4.35094723593085],
            [-9.697671766850736, 4.335853837735253],
            [-9.608503626016557, 4.320745100447991],
            [-9.602952512946532, 4.320033214571416],
            [-9.515033637573314, 4.306239274069529],
            [-9.427117169915013, 4.292430490395481],
            [-9.424221698639418, 4.291774235366102],
            [-9.336103215749347, 4.279818088386324],
            [-9.285158475733716, 4.272392601800824],
            [-9.154148081351195, 4.25407679813385],
            [-9.151210557253103, 4.253507528994997],
            [-9.094564575326551, 4.245943671382147],
            [-9.026354244556385, 4.236500060460811],
            [-8.93474909562469, 4.223872451928332],
            [-8.843146161162505, 4.211228828390492],
            [-8.72349660456988, 4.195226202845723],
            [-8.655088260508053, 4.1865405328038],
            [-8.58035065760263, 4.1769064566341685],
            [-8.425207239856269, 4.155850828257212],
            [-8.335912542859498, 4.144400769132436],
            [-8.246619794796624, 4.132935540976284],
            [-8.157329009977886, 4.121455145862083],
            [-8.0680402026742, 4.109959586126053],
            [-7.985964525242343, 4.100296674632275],
            [-7.996662330839187, 4.01331714721741],
            [-8.006835143447978, 3.9269752288511843],
            [-7.993301496467419, 3.925331635439085],
            [-8.025641184374777, 3.669025542515291],
            [-8.036781646383762, 3.578840830050537],
            [-8.040139206771943, 3.579231341597533],
            [-8.050003255903917, 3.4962864258392576],
            [-8.106296842189504, 3.50334075896313],
            [-8.247092385217703, 3.521226045851841],
            [-8.24803997809051, 3.5214827010023098],
            [-8.358814406252666, 3.536660414139613],
            [-8.37913548463946, 3.377377257964972],
            [-8.379315645590781, 3.374695611659197],
            [-8.391856203954648, 3.2761195403277656],
            [-8.382426215349533, 3.2749007774805987],
            [-8.43338678720787, 2.879056896434331],
            [-8.528513625240134, 2.8911269625129794],
            [-8.628712102590624, 2.9023175116758044],
            [-8.680288600482735, 2.9086285604364357],
            [-8.717079887973021, 2.9134004012631483],
            [-8.86583283172655, 2.9328922141929854],
            [-8.885197670693213, 2.934941352023809],
            [-8.962613634909033, 2.945790625978963],
            [-9.05645936004316, 2.958422111695891],
            [-9.150306875384137, 2.9710401708504883],
            [-9.27327646575219, 2.988473635073093],
            [-9.364885832817475, 3.001378482748694],
            [-9.407935875336277, 3.0086092727599927],
            [-9.421980690416571, 3.0095084068374383],
            [-9.514733132886537, 3.021679985761781],
            [-9.60748723855648, 3.033838453821618],
            [-9.63299175375873, 3.0364845327812207],
            [-9.737781487500882, 3.0518237510865207],
            [-9.791174849595297, 3.05923415925064],
            [-9.870384280599879, 3.0703427346067134],
            [-9.959371409187849, 3.083749692174041],
            [-9.978096430940214, 3.085951609559799],
            [-9.98231258624934, 3.087047720782087],
            [-10.013437520958417, 3.091403348659782],
            [-10.007242474967617, 3.1337723646646904],
            [-9.97942344021356, 3.3220476823975735],
            [-9.953624531091021, 3.4942249409996298],
            [-9.953137221326696, 3.496255878046227],
            [-9.944357758832963, 3.5566440814946603],
            [-9.926912261881938, 3.669070361969158],
            [-9.866016566364571, 4.069289789884587],
            [-9.86211438395022, 4.095314494689564],
            [-9.867938352940364, 4.096281134386592],
            [-9.828307446864462, 4.358119030948287]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.87957859982932,
          "lat": 41.65953824200593
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56037"],
        "coty_name": ["Sweetwater"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sweetwater County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01609192"
      },
      "bbox": [
        -10.013437520958417, 2.879056896434331, -7.985964525242343,
        4.358119030948287
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.26446706888429, "lat": 18.13121293491365 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72009"],
        "coty_name": ["Aibonito"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Aibonito Municipio"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01804484"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.66824624006564,
          "lat": 18.252826076389294
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72037"],
        "coty_name": ["Ceiba"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Ceiba Municipio"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01804498"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.89873281489672,
          "lat": 18.425561930711545
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72087"],
        "coty_name": ["Loíza"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Loíza Municipio"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01804524"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.43398856854941,
          "lat": 18.214895101657014
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72107"],
        "coty_name": ["Orocovis"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Orocovis Municipio"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01804534"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.8809354676505814, 0.5698969965878653],
            [2.886195954899183, 0.5840095782701722],
            [2.904929110694053, 0.6389626675376697],
            [2.9220699369412064, 0.6898208014065728],
            [2.950465633969904, 0.6807771339261498],
            [2.9863862333838513, 0.6698289519433656],
            [3.1010148284361665, 0.6348562938947679],
            [3.2013796272381465, 0.6040363193579744],
            [3.1699541467991192, 0.5161873430252192],
            [3.1521496012630537, 0.46485288868861435],
            [3.1388759085976248, 0.42811798731649475],
            [3.1278880181650766, 0.3991468151356271],
            [3.1093487399355975, 0.35250940579150253],
            [3.109306908451175, 0.3461733609279824],
            [3.1071873736654494, 0.3397975166656282],
            [3.1098644020206145, 0.3355995732803321],
            [3.1039188566223688, 0.3286187088784508],
            [3.107322052388935, 0.32322136780772104],
            [3.112604444249192, 0.3223102539627415],
            [3.113536201209107, 0.31983743726149705],
            [3.110415216100034, 0.32106005531956416],
            [3.1038155529975624, 0.3207023141575408],
            [3.0910444179669545, 0.3160870870013418],
            [3.0831146518442325, 0.31569963041823584],
            [3.0718576543219847, 0.31738563148396337],
            [3.058399482670484, 0.3210834681783237],
            [3.0380318537545468, 0.3231682466019413],
            [3.0187319267692705, 0.321286228169025],
            [3.0095274530470695, 0.3214623054655073],
            [2.9983959321254114, 0.3270715031435613],
            [2.9889084336356873, 0.32913554714860244],
            [2.9779851186304285, 0.3278327990302645],
            [2.962136624612079, 0.32310326231810266],
            [2.9542824207159364, 0.31801659499337187],
            [2.947161081005191, 0.3155044765214921],
            [2.9403458537513556, 0.31465615381053724],
            [2.9336266915607214, 0.31490679242211084],
            [2.91141732794382, 0.320492201827127],
            [2.895034401702256, 0.3214701550185979],
            [2.8864823800243995, 0.3235724426066077],
            [2.8792207513572605, 0.3283225855654579],
            [2.8678435930018016, 0.34180029217781077],
            [2.861171341735782, 0.34642398491157433],
            [2.8471184526098154, 0.35150023588932994],
            [2.8415028516643726, 0.3559014857479656],
            [2.83761170653125, 0.36137129193386947],
            [2.8303277959937163, 0.3809814757355889],
            [2.8242096354525437, 0.3907950794068627],
            [2.820605865275167, 0.3989244598689033],
            [2.8207474612517167, 0.4046241359249502],
            [2.823758944733417, 0.40874671946088637],
            [2.833369994855069, 0.4141610286617366],
            [2.838547109639699, 0.42056671219592184],
            [2.8410138203578774, 0.4251389982861151],
            [2.84137894810747, 0.42963584622043266],
            [2.8394058891951723, 0.4365424953675383],
            [2.8333750824386494, 0.43875365714791736],
            [2.825062953507912, 0.4384894431049961],
            [2.8200114674337358, 0.43973436207637],
            [2.8131657761992943, 0.44375825143260317],
            [2.811171271290905, 0.4472880524813013],
            [2.810859537722769, 0.45495075882094993],
            [2.8117574140054833, 0.46210385119581115],
            [2.813312144639399, 0.46634981379445545],
            [2.816853044794915, 0.46842750197044236],
            [2.8279897540243453, 0.4719035327830623],
            [2.8318824864403385, 0.47441861582274786],
            [2.8359133783373944, 0.4794858723000286],
            [2.839115552759023, 0.48598091706984214],
            [2.840105444629263, 0.4929676510325815],
            [2.840287048948336, 0.5078925894827369],
            [2.846152854019509, 0.517933258021952],
            [2.8545465976450144, 0.5253007078660523],
            [2.8623265621190637, 0.5296762854671831],
            [2.866919921958293, 0.5348324689369642],
            [2.8727144337448784, 0.5432952270244745],
            [2.8769355963955774, 0.5524548281302715],
            [2.8795436844235507, 0.5614379614837905],
            [2.8809354676505814, 0.5698969965878653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.69628930106498,
          "lat": 39.142523009561124
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29089"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00758499"
      },
      "bbox": [
        2.810859537722769, 0.31465615381053724, 3.2013796272381465,
        0.6898208014065728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.334325473594547, -1.7963723914332899],
            [4.40613356455833, -1.7941866086229064],
            [4.419810009494253, -1.7912854445494817],
            [4.420176113930906, -1.7955438207568422],
            [4.4361852785878835, -1.7948241419401216],
            [4.449963858044635, -1.7956117340767037],
            [4.468518343424588, -1.795132375208436],
            [4.468742390377534, -1.7978489978222192],
            [4.509255724709436, -1.7981085192978417],
            [4.513441470088985, -1.7976813831860206],
            [4.557809165173717, -1.7955204322285754],
            [4.621566983657289, -1.793162424605691],
            [4.693899620206643, -1.789376566757864],
            [4.721717159685126, -1.788312742017512],
            [4.725033126356716, -1.8496908916309822],
            [4.728026777934966, -1.9072049588955162],
            [4.728522730601979, -1.9207437838506087],
            [4.757259498163826, -1.919291222177714],
            [4.761583762935165, -2.0068908203231244],
            [4.7761054529966875, -2.0066641971270944],
            [4.780355667122403, -2.1008089978237776],
            [4.687472800050051, -2.105990178527885],
            [4.672996842226744, -2.1069913806850615],
            [4.614930530224716, -2.1099935250473982],
            [4.562300589650925, -2.1128397040723677],
            [4.543767247545839, -2.114320765223204],
            [4.539421172920268, -2.1142479857695236],
            [4.474670463093403, -2.1176613470654178],
            [4.4291047377230965, -2.120431875853026],
            [4.342796797041927, -2.1252612096054966],
            [4.342459593432086, -2.1229026275007494],
            [4.340200255346304, -2.0279179755495877],
            [4.3395491128281485, -2.0225758165184917],
            [4.338663328513282, -1.9928959744094776],
            [4.336294614866086, -1.9280427574964625],
            [4.33527697290513, -1.8903656935021016],
            [4.333661089310737, -1.840453408328831],
            [4.335319838928764, -1.8403944554954856],
            [4.3352011150071466, -1.8199167571265635],
            [4.334325473594547, -1.7963723914332899]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.86383189396051, "lat": 36.65279547679283 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29181"],
        "coty_name": ["Ripley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ripley County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "00758545"
      },
      "bbox": [
        4.333661089310737, -2.1252612096054966, 4.780355667122403,
        -1.788312742017512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.277111613143765, 8.629579515010223],
            [-11.191772624138862, 8.61409582272368],
            [-11.177737908200072, 8.610962402847413],
            [-11.0861520242156, 8.595246608935035],
            [-11.018628894106334, 8.583131572490773],
            [-10.951108298523955, 8.571002714381581],
            [-10.953387389941632, 8.566680896981637],
            [-10.95887721404374, 8.56261647313134],
            [-10.963666091664901, 8.555115854891406],
            [-10.969634528600121, 8.550187240560456],
            [-10.97478059428571, 8.548518219690118],
            [-10.981338637136963, 8.548745120770688],
            [-10.982993239795473, 8.54565299036815],
            [-10.980171018264542, 8.542462211843114],
            [-10.9820986134859, 8.538490648926956],
            [-10.972980740175597, 8.5297591322815],
            [-10.970676730732256, 8.5202926937876],
            [-10.975435214891728, 8.511393008245275],
            [-10.978781355660015, 8.508553751992292],
            [-10.977366078865867, 8.50347738982896],
            [-10.97750278222883, 8.493941745350348],
            [-10.97877469834351, 8.488803151189758],
            [-10.99157165040077, 8.483359594693912],
            [-10.992981453012257, 8.477504989745855],
            [-10.997216101371524, 8.478762185376247],
            [-10.999300009661253, 8.48357763661044],
            [-11.00317864404843, 8.483286545073433],
            [-11.007178894266072, 8.480136918900424],
            [-11.01038046178054, 8.488521235255742],
            [-11.014001182725952, 8.48855363420788],
            [-11.016965543151708, 8.491012596035578],
            [-11.022645379976447, 8.49181156761304],
            [-11.037376028280676, 8.47286029262942],
            [-11.044914011396504, 8.468797886539717],
            [-11.04643634093767, 8.466788704966017],
            [-11.055434314366316, 8.463666784075697],
            [-11.057303566271214, 8.459115528140895],
            [-11.122971936715443, 8.47082218215487],
            [-11.138722028633378, 8.385816823635443],
            [-11.190054214806581, 8.395017723995098],
            [-11.195777916090854, 8.385415605807172],
            [-11.19938320022293, 8.385087666255266],
            [-11.205483333688079, 8.377464052233243],
            [-11.206151140217077, 8.368107329961529],
            [-11.208307426074112, 8.366233791271183],
            [-11.207280998988876, 8.359836827540954],
            [-11.215902591054926, 8.352702114282685],
            [-11.220316567994805, 8.349888526796702],
            [-11.223484425685307, 8.353478751743998],
            [-11.232105193354238, 8.35344322084314],
            [-11.239070199531579, 8.35641773551395],
            [-11.245217842180798, 8.360499285520902],
            [-11.249958044494331, 8.355376562594273],
            [-11.255231820556403, 8.352266380547775],
            [-11.258889099386918, 8.351631104418985],
            [-11.261922052591602, 8.34597348078432],
            [-11.259609592857304, 8.340042590363954],
            [-11.261397599928548, 8.335507005527878],
            [-11.2603011034497, 8.331065668514762],
            [-11.262812064970307, 8.327628584502799],
            [-11.259401051843, 8.32160291597166],
            [-11.261176337064686, 8.313864491108383],
            [-11.260135406890287, 8.30398422274695],
            [-11.258450957291561, 8.300807294783391],
            [-11.259060325970827, 8.292271833716626],
            [-11.261447084941075, 8.291823273569547],
            [-11.26345572257217, 8.286231017494451],
            [-11.272963462745507, 8.284485809432445],
            [-11.278517330219376, 8.286428286979685],
            [-11.285873741079191, 8.285725225959387],
            [-11.290285683005091, 8.28211883108199],
            [-11.293637832964755, 8.273559435115258],
            [-11.292354108081328, 8.269760524507957],
            [-11.305524591021525, 8.263652702227475],
            [-11.307209839797462, 8.259303043861566],
            [-11.312115079282888, 8.25783843861659],
            [-11.316143952325369, 8.260312939084706],
            [-11.329318861911778, 8.254647351222724],
            [-11.334433624670838, 8.25027502309355],
            [-11.33876061862724, 8.243758307418952],
            [-11.346913777257667, 8.242074978144673],
            [-11.35406397710094, 8.243960317040075],
            [-11.35919567808252, 8.243055598188155],
            [-11.364225507504132, 8.246641385741714],
            [-11.368012072831895, 8.245018531212342],
            [-11.375144734378354, 8.244003206786164],
            [-11.382812006399165, 8.24087002971923],
            [-11.38217661796275, 8.252192709503062],
            [-11.38494499007817, 8.257071615703598],
            [-11.38766033398403, 8.258724768609486],
            [-11.389166390904228, 8.263183739913476],
            [-11.408312035994475, 8.26829776430247],
            [-11.416360972482686, 8.268529647460241],
            [-11.42820983583952, 8.273779581999294],
            [-11.434865375121635, 8.27392391165657],
            [-11.443092249430816, 8.276221118639524],
            [-11.450747671261336, 8.270292281309812],
            [-11.456727012605205, 8.268182791810647],
            [-11.460251814022646, 8.268471277049548],
            [-11.464367319199523, 8.271396484302366],
            [-11.467981468781439, 8.270933785889433],
            [-11.474843657198775, 8.26795763287347],
            [-11.480053769835525, 8.264271243543558],
            [-11.483889122032487, 8.257928415934884],
            [-11.489269184412839, 8.252811624965398],
            [-11.496982252690398, 8.252298131407834],
            [-11.501787673840205, 8.247234325841402],
            [-11.49938813044106, 8.240799276274418],
            [-11.507140927811005, 8.235572010846372],
            [-11.510752898227558, 8.230089061218063],
            [-11.520744872078392, 8.222925061653601],
            [-11.528748705832996, 8.223330815779603],
            [-11.53151849868502, 8.228271940052279],
            [-11.536238201911882, 8.226385662996957],
            [-11.545399015655484, 8.215766944293733],
            [-11.54928657300421, 8.218347875068249],
            [-11.554002687074789, 8.218946475902392],
            [-11.554902228169645, 8.2220245472935],
            [-11.56310354932329, 8.22588513242369],
            [-11.566120916722042, 8.223980521059278],
            [-11.567946632665011, 8.220173045516074],
            [-11.572460839512951, 8.218906955228885],
            [-11.575469904617808, 8.212196220227831],
            [-11.578092301870294, 8.20949657552515],
            [-11.580325862336764, 8.199912360028696],
            [-11.583890338431988, 8.194654231298962],
            [-11.590328411623341, 8.188416831608217],
            [-11.589984635014812, 8.178863105426554],
            [-11.591672407068872, 8.175571798192964],
            [-11.60102766955635, 8.178890634178101],
            [-11.605905551909162, 8.182370669620607],
            [-11.613235039802992, 8.189204183545632],
            [-11.613118170344643, 8.192808872480876],
            [-11.61657047947596, 8.198413412476999],
            [-11.618466950078645, 8.205508079549881],
            [-11.621886400157909, 8.210063756719395],
            [-11.625419072420911, 8.212223478156242],
            [-11.630487874793749, 8.225341581853558],
            [-11.628811334612877, 8.238190488600807],
            [-11.625741624705043, 8.238359153056557],
            [-11.624823666851862, 8.246441967881548],
            [-11.62654002753071, 8.248287563034184],
            [-11.624165874503916, 8.255001560598307],
            [-11.626641629876165, 8.256612445215668],
            [-11.625885096417406, 8.260035272650029],
            [-11.62918450772899, 8.263550163467317],
            [-11.627076254305118, 8.27270543407245],
            [-11.629013861625483, 8.284185859658159],
            [-11.63312326270535, 8.288921423041241],
            [-11.632521351101813, 8.290602496526576],
            [-11.636233000745507, 8.298362810523527],
            [-11.634548258924593, 8.301736863503471],
            [-11.640440533432441, 8.313182566888967],
            [-11.639102329373433, 8.317276442925403],
            [-11.640184464928147, 8.325017255188351],
            [-11.643618752326525, 8.330970049507696],
            [-11.648118255214195, 8.342723266533568],
            [-11.648159760070548, 8.350468952797858],
            [-11.650109250023375, 8.365437829853903],
            [-11.653212341901797, 8.370656137109654],
            [-11.663741149371793, 8.370593878060037],
            [-11.664373671478202, 8.371992077907828],
            [-11.661168554724227, 8.376481835663814],
            [-11.65749912616358, 8.375117816287112],
            [-11.654134365488336, 8.378142036264794],
            [-11.650822898639474, 8.377886611986035],
            [-11.645215588881038, 8.373792353226712],
            [-11.638958586699456, 8.366901556435865],
            [-11.632606331855866, 8.37449568626892],
            [-11.630505596600683, 8.378944291967716],
            [-11.624335032096944, 8.380805360630095],
            [-11.620644080781915, 8.386121279395997],
            [-11.62554707174067, 8.393014948042053],
            [-11.624919098998555, 8.396157305108721],
            [-11.620520862172791, 8.398498869102497],
            [-11.62001149964803, 8.401779487628978],
            [-11.615933247588876, 8.407266728783561],
            [-11.612596076005259, 8.404942338406704],
            [-11.605315757169782, 8.402222569980927],
            [-11.599612735289668, 8.406408440825928],
            [-11.595948701302307, 8.405070931859058],
            [-11.591389820017463, 8.407163398550512],
            [-11.585282687447037, 8.40741095430234],
            [-11.580727655183003, 8.416495026236085],
            [-11.575813351059196, 8.415146501279784],
            [-11.57252027452786, 8.415784004040864],
            [-11.567996689285982, 8.421645164974901],
            [-11.568506116827994, 8.428562303082739],
            [-11.555340170745337, 8.430841707931998],
            [-11.547002983705697, 8.418226757891977],
            [-11.538894768826042, 8.41946653041815],
            [-11.531991816819161, 8.41602644456045],
            [-11.528217190619646, 8.412622501774813],
            [-11.521209757224277, 8.421507119699784],
            [-11.512564213381753, 8.423337790519728],
            [-11.507095891919992, 8.428746085618409],
            [-11.496322872544877, 8.432799002061008],
            [-11.4909516079693, 8.437199222880311],
            [-11.487854986472, 8.438136150372763],
            [-11.485840060627869, 8.442084676644338],
            [-11.48148215291592, 8.444166098336689],
            [-11.481243431216049, 8.45612504522618],
            [-11.476447510764034, 8.457366670703209],
            [-11.462652159761577, 8.53162663827904],
            [-11.469942681968895, 8.532942044823553],
            [-11.453893707662814, 8.61731653583789],
            [-11.368887044527849, 8.602415194811156],
            [-11.284845110781077, 8.587353530851884],
            [-11.277111613143765, 8.629579515010223]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.06772689003104,
          "lat": 46.060854964323006
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30023"],
        "coty_name": ["Deer Lodge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Deer Lodge County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01719617"
      },
      "bbox": [
        -11.664373671478202, 8.175571798192964, -10.951108298523955,
        8.629579515010223
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.513966350083656, 8.027952472970696],
            [-10.512033956245284, 8.024675876898744],
            [-10.506437655304705, 8.023495415444573],
            [-10.503191227873042, 8.02035000935814],
            [-10.492144112094262, 8.02467539594571],
            [-10.48517576445867, 8.024794976341406],
            [-10.47899047444179, 8.028094440441524],
            [-10.472273346347391, 8.024334788561497],
            [-10.467955751735795, 8.019784244474986],
            [-10.46372711850572, 8.019139774327414],
            [-10.460899744402255, 8.014301593438459],
            [-10.44571090623898, 8.014068632877917],
            [-10.439603017992953, 8.017871909290433],
            [-10.43681469120889, 8.022792939087541],
            [-10.43405516436289, 8.024867164933712],
            [-10.432183053814333, 8.030369519422141],
            [-10.428029033777698, 8.03119279946737],
            [-10.424514919178268, 8.036492484094804],
            [-10.41569017296408, 8.037994676884924],
            [-10.409837083235093, 8.041160453336625],
            [-10.408265917399467, 8.04576745230569],
            [-10.405838410825544, 8.046187125424481],
            [-10.403609457061798, 8.051644407961474],
            [-10.403916707217324, 8.054521748298002],
            [-10.400830599358251, 8.057111328516537],
            [-10.39881344612181, 8.06169272561581],
            [-10.391442604767258, 8.062151898355113],
            [-10.386771744305738, 8.071332294279722],
            [-10.379088194342355, 8.072874081911761],
            [-10.375063117705023, 8.07766802069327],
            [-10.369126125105216, 8.080457913359334],
            [-10.363801202132139, 8.09376718028005],
            [-10.358314562460764, 8.097009214173537],
            [-10.35073629780255, 8.103670567205072],
            [-10.346545504375174, 8.10899982466515],
            [-10.338587575385189, 8.108751918502401],
            [-10.336456153085162, 8.110868604093312],
            [-10.331714989090429, 8.109511392052694],
            [-10.325790407398738, 8.113782015411935],
            [-10.319244981980692, 8.10769983829043],
            [-10.314639077465722, 8.110299716476966],
            [-10.314677897837305, 8.114463176127725],
            [-10.311547417722045, 8.116286905802076],
            [-10.310065439561109, 8.112526245599447],
            [-10.306955332380532, 8.114410647271972],
            [-10.307309876524272, 8.120083584648977],
            [-10.300606342356716, 8.119486523626644],
            [-10.294391942304129, 8.120230549013149],
            [-10.28758996289429, 8.123499762582941],
            [-10.278627686668404, 8.125713219010105],
            [-10.276274466267013, 8.129997410879998],
            [-10.271309863036754, 8.132451721029533],
            [-10.267646028282392, 8.135773180741094],
            [-10.25927946625485, 8.139644479573189],
            [-10.255544570654923, 8.143813323895644],
            [-10.252407329707223, 8.150710109268742],
            [-10.250331082284598, 8.160066108145584],
            [-10.25058618501835, 8.165782502148748],
            [-10.247792862268064, 8.176252256143034],
            [-10.244600603873323, 8.182905495197872],
            [-10.241867846548423, 8.184263546686397],
            [-10.236476202050925, 8.180392278588268],
            [-10.233443096324129, 8.174736604257122],
            [-10.229452259334504, 8.175692781209268],
            [-10.222815919062429, 8.175335844621614],
            [-10.216550573783724, 8.177634783944399],
            [-10.2130497246908, 8.182539220877985],
            [-10.214770535008238, 8.196761038105224],
            [-10.219744869015372, 8.200840034277066],
            [-10.213833457971344, 8.207884515444078],
            [-10.212656607299277, 8.212575681356936],
            [-10.21279878577982, 8.222265917810562],
            [-10.210980628096705, 8.227486609960408],
            [-10.208855389445798, 8.242109239717735],
            [-10.204789375901168, 8.246042095516465],
            [-10.199437839905201, 8.25415892895547],
            [-10.192759744724135, 8.262675565295975],
            [-10.183795944402664, 8.265584141614008],
            [-10.181649377464593, 8.267875778961214],
            [-10.184426455412408, 8.282100405842177],
            [-10.180847799402184, 8.284666624112951],
            [-10.174790054150936, 8.278910976610316],
            [-10.172591740120579, 8.280987045663698],
            [-10.169592093372058, 8.287162475909621],
            [-10.16190195651167, 8.288097629907227],
            [-10.151747416682579, 8.291055122697943],
            [-10.148046241325202, 8.292998376337902],
            [-10.145733659877008, 8.307232497588164],
            [-10.143848732085079, 8.306928659366193],
            [-10.135723396404794, 8.356229691034207],
            [-10.007601085393985, 8.33569121541781],
            [-10.006799404056656, 8.340626346487984],
            [-9.939961973476098, 8.330027779761423],
            [-9.892900055864546, 8.322564152273817],
            [-9.821169998140226, 8.311313714355245],
            [-9.749442362043077, 8.300047917276371],
            [-9.757444247781065, 8.250429520336379],
            [-9.762060551912143, 8.251166105416115],
            [-9.776587384801038, 8.158508964907206],
            [-9.78238130073091, 8.13093677488943],
            [-9.786871635696833, 8.101903874003016],
            [-9.789339328207845, 8.074098440035188],
            [-9.791595665057093, 8.059422067538836],
            [-9.79715197669226, 8.019562592010823],
            [-9.816150457858912, 7.903723989251262],
            [-9.820192451579175, 7.9043631984340355],
            [-9.827045598948033, 7.861897723016401],
            [-9.833641025816199, 7.819421516703141],
            [-9.836211870431395, 7.806019497042411],
            [-9.844998523863158, 7.748657780921562],
            [-9.84658295436708, 7.735161461804304],
            [-9.85016926454342, 7.712932191956724],
            [-9.864548054516973, 7.715865853040759],
            [-9.864737867173044, 7.714677943692149],
            [-9.893464940423518, 7.719647562033128],
            [-9.904305055132026, 7.655366780169521],
            [-9.94650326721857, 7.661954296909663],
            [-9.959861554265366, 7.577526145530961],
            [-9.958788897970583, 7.57735786473102],
            [-9.972726672941436, 7.491824882414748],
            [-10.056147721813446, 7.50508637522347],
            [-10.070103115143985, 7.418616365727028],
            [-10.0840497848867, 7.333647282473949],
            [-10.089620005057322, 7.334476774756064],
            [-10.101634681473266, 7.26033958986955],
            [-10.101657009657815, 7.253190086058927],
            [-10.116225224486602, 7.162299677319227],
            [-10.12283903070833, 7.163371842579349],
            [-10.144936273838875, 7.025408051675661],
            [-10.165843306793162, 6.8936286777377545],
            [-10.175059913337176, 6.834662304207684],
            [-10.203932989888141, 6.649873288870813],
            [-10.206540948675213, 6.648660392322336],
            [-10.212497424988896, 6.651461408923223],
            [-10.215792793407822, 6.6555738742837525],
            [-10.236517862307322, 6.664502318974822],
            [-10.24107629294758, 6.664366696182497],
            [-10.244466278531599, 6.668473627630965],
            [-10.245491833642348, 6.672047718009896],
            [-10.248653731251467, 6.673056743910242],
            [-10.25545121301433, 6.679971402017791],
            [-10.258382864585549, 6.697303392802676],
            [-10.258029903092696, 6.699262908803653],
            [-10.25082597964994, 6.711803613876385],
            [-10.25689955129241, 6.716215920611843],
            [-10.263894052026098, 6.716452056416609],
            [-10.265900720793907, 6.724265538393886],
            [-10.267939335914193, 6.7284853414032995],
            [-10.277881556328332, 6.733168979724931],
            [-10.281904257602521, 6.739408602651247],
            [-10.279677866892749, 6.750679046283547],
            [-10.279815379358208, 6.7535413158193665],
            [-10.29310795661757, 6.762389344857309],
            [-10.297309065551259, 6.762246800980039],
            [-10.30549015108694, 6.763894172317875],
            [-10.311153546587786, 6.76656927140385],
            [-10.31308930505717, 6.774816087354007],
            [-10.311236951627759, 6.787127707832838],
            [-10.313013748772889, 6.790928543079206],
            [-10.311957666110489, 6.7951738289570445],
            [-10.313886407250365, 6.804992469455599],
            [-10.304377509923054, 6.806990423485388],
            [-10.298784944877477, 6.809851428300737],
            [-10.30366380666018, 6.819742001310611],
            [-10.311040324273119, 6.832942026104924],
            [-10.315681673382922, 6.834774300750176],
            [-10.317315660796979, 6.842162514160525],
            [-10.324140798680467, 6.841764957388584],
            [-10.328916207383813, 6.839999956413622],
            [-10.33382139598797, 6.843185474341163],
            [-10.335859742654538, 6.848779586083305],
            [-10.332150772545782, 6.85009165807372],
            [-10.328524015052796, 6.855424860007703],
            [-10.32498555104662, 6.856973272077976],
            [-10.326044409598342, 6.861365926632224],
            [-10.329931904502319, 6.869099487064806],
            [-10.329079678345787, 6.871408517693632],
            [-10.331216663833093, 6.876452383034043],
            [-10.337846701501133, 6.880591262642789],
            [-10.34114855588813, 6.886201075647402],
            [-10.33923736462214, 6.892452249867587],
            [-10.339173811906603, 6.896963182502242],
            [-10.342120748120058, 6.901136932563967],
            [-10.345801944589509, 6.903728026630185],
            [-10.352464894604287, 6.91162793280847],
            [-10.354999682657033, 6.916369635345042],
            [-10.353824336574794, 6.926034898367129],
            [-10.357405059216765, 6.929586969182966],
            [-10.363091040246179, 6.93218244668363],
            [-10.371852588124822, 6.925681700268218],
            [-10.37650846951126, 6.928330478335642],
            [-10.379983278971995, 6.936694111917874],
            [-10.382763925364907, 6.940760153699761],
            [-10.381862579525464, 6.944353019135934],
            [-10.387027690110152, 6.951456677877733],
            [-10.388033698564971, 6.954345362440203],
            [-10.362345459839048, 7.112002729751319],
            [-10.358673636797162, 7.111410140251818],
            [-10.344484746495635, 7.197615672248087],
            [-10.344714046343391, 7.19765279125043],
            [-10.331702558458353, 7.276960565698539],
            [-10.319418532795487, 7.352010054010141],
            [-10.305451077807486, 7.439035254299006],
            [-10.288514637191321, 7.541385391977062],
            [-10.272563777321936, 7.5388342482532185],
            [-10.258586561240792, 7.625166922232189],
            [-10.259238131543107, 7.625272145473397],
            [-10.249547262216717, 7.683185737142519],
            [-10.233586408147524, 7.781529906839486],
            [-10.226638611107376, 7.824004155218615],
            [-10.354178296217968, 7.845037618501212],
            [-10.351858967808653, 7.859286995792393],
            [-10.366174129260878, 7.861220044532215],
            [-10.363826839522444, 7.875455691341433],
            [-10.378135756025, 7.877573459244224],
            [-10.375766673676077, 7.891716082763335],
            [-10.38996017282385, 7.893912333101467],
            [-10.387591202363762, 7.908416059027139],
            [-10.401891142296842, 7.910663947100552],
            [-10.399519671109942, 7.924823912425686],
            [-10.413783117603597, 7.9271100217376285],
            [-10.411425342266279, 7.941291143008583],
            [-10.425202895129766, 7.943567532754611],
            [-10.422821791961034, 7.957733612792248],
            [-10.451551750242093, 7.962150896067127],
            [-10.465503759845603, 7.964709929351979],
            [-10.460829952203957, 7.993124176062821],
            [-10.489320863763487, 7.99802621107328],
            [-10.487001270612092, 8.01196202693058],
            [-10.515961246132509, 8.0166885933765],
            [-10.513966350083656, 8.027952472970696]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.17041080395224,
          "lat": 45.54043199485318
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30031"],
        "coty_name": ["Gallatin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gallatin County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01720053"
      },
      "bbox": [
        -10.515961246132509, 6.648660392322336, -9.749442362043077,
        8.356229691034207
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.230289877195576, 9.096210645879344],
            [-10.149808683666635, 9.082997633493061],
            [-10.135788183226463, 9.167571912314608],
            [-10.049840382056342, 9.153934705470258],
            [-9.963896238692845, 9.140274047789278],
            [-9.962147021813502, 9.150666232703683],
            [-9.87637687113607, 9.137011915246534],
            [-9.864397949785435, 9.211265439456644],
            [-9.858709625216587, 9.210044130285223],
            [-9.811986006555312, 9.202698299425986],
            [-9.810182735372466, 9.193775716548465],
            [-9.816409454230687, 9.18797244649022],
            [-9.815684542198115, 9.183452588312504],
            [-9.817762425446737, 9.179422179216413],
            [-9.817064259971632, 9.171143371839824],
            [-9.815676279049638, 9.167909348613007],
            [-9.81592536175694, 9.160788629924289],
            [-9.824029053782203, 9.15460600717772],
            [-9.8306400100698, 9.152760394036363],
            [-9.835886227378813, 9.14840457573718],
            [-9.834528476987616, 9.144804220430395],
            [-9.834785151244224, 9.139862900449042],
            [-9.831518770030765, 9.134786245014014],
            [-9.828807218808842, 9.132911491030432],
            [-9.82643807205301, 9.12794799712672],
            [-9.819094026158242, 9.121861368289935],
            [-9.806872287966227, 9.123323432398307],
            [-9.80119241274736, 9.117755301048645],
            [-9.797478637874447, 9.11925304193269],
            [-9.790283513020864, 9.11831380500993],
            [-9.785963887903202, 9.114942794674137],
            [-9.779536428275879, 9.112761211466195],
            [-9.775056507234313, 9.114152638392996],
            [-9.767461579106511, 9.113145177654092],
            [-9.76900807238103, 9.10783602134535],
            [-9.764324057567976, 9.105210435703304],
            [-9.756635361777827, 9.107815067162836],
            [-9.74851245544298, 9.1041526091566],
            [-9.740000336949938, 9.09538176166613],
            [-9.734296880874496, 9.093154123150464],
            [-9.732231723133022, 9.09000952024701],
            [-9.72559033393706, 9.086440689796017],
            [-9.722945025002877, 9.08634748068629],
            [-9.715255600038297, 9.080567811543206],
            [-9.712988423310941, 9.072237988717914],
            [-9.709750490389595, 9.068366476625455],
            [-9.702942511907885, 9.0638763647194],
            [-9.701077621106572, 9.055414216625053],
            [-9.698502861509269, 9.054222448810169],
            [-9.69309231157608, 9.046772217106895],
            [-9.692488021156352, 9.041572942100606],
            [-9.684029397171837, 9.041362490720518],
            [-9.68214163494576, 9.038009975556323],
            [-9.681833650352614, 9.031664357941889],
            [-9.685464557197397, 9.023290623619669],
            [-9.686464182515131, 9.018479873465887],
            [-9.682803000062462, 9.015655337626026],
            [-9.67886635022754, 9.014922479090663],
            [-9.674786149295015, 9.012179590272721],
            [-9.671705757159799, 9.006476456539067],
            [-9.665817537650874, 9.00748094712062],
            [-9.661108024206982, 9.005636704798496],
            [-9.661140417546282, 9.00240441744447],
            [-9.654625632793179, 8.99270961286196],
            [-9.65026628131837, 8.99586527068178],
            [-9.647212872941463, 8.994607438712798],
            [-9.64296831146213, 8.99919977346936],
            [-9.63779378753909, 8.99760679446756],
            [-9.639650335805989, 8.990326708302026],
            [-9.631336431860582, 8.984660368246713],
            [-9.625130867348796, 8.982986617315463],
            [-9.620623496975059, 8.975906510435308],
            [-9.621440529064571, 8.973472273587882],
            [-9.628321129893434, 8.969526454692858],
            [-9.625554242233521, 8.965767312667259],
            [-9.62829341044637, 8.964441605776045],
            [-9.628816879141935, 8.959065495356883],
            [-9.625219372425246, 8.959369457676706],
            [-9.624927352676448, 8.94607486295512],
            [-9.6301159630194, 8.936229476427325],
            [-9.626526390985317, 8.931318941002534],
            [-9.61564330229905, 8.933608857431254],
            [-9.608842683296409, 8.928535340220423],
            [-9.609117743991098, 8.923356890811606],
            [-9.60421501866507, 8.92159094631072],
            [-9.602522157093173, 8.924649857322054],
            [-9.59784174629683, 8.923717286078128],
            [-9.590651231875514, 8.926330636111517],
            [-9.589540739116964, 8.921095291635245],
            [-9.584641055563377, 8.916553185584972],
            [-9.580604754594953, 8.90460901934052],
            [-9.570738351960852, 8.897383218743528],
            [-9.566803595637259, 8.896636391962284],
            [-9.56310007214014, 8.900775891188996],
            [-9.558648567627099, 8.892973579943899],
            [-9.564211333444453, 8.878885235118295],
            [-9.562134525620522, 8.875045860903032],
            [-9.56147192450523, 8.868384813532243],
            [-9.555568866090402, 8.861049252639088],
            [-9.556216352035149, 8.857834815308266],
            [-9.553822846288467, 8.854062430660083],
            [-9.549146252665771, 8.85177993587433],
            [-9.549093254841011, 8.847427064690143],
            [-9.543138257568977, 8.844809728155303],
            [-9.536446442108351, 8.843273492401021],
            [-9.525782871002889, 8.842347933163259],
            [-9.52010044081458, 8.840549380388023],
            [-9.513111190305573, 8.84161255639299],
            [-9.507605726025114, 8.832486652471792],
            [-9.510543530710116, 8.821891537230641],
            [-9.515875108531283, 8.809124803137951],
            [-9.514972553862732, 8.802236821773143],
            [-9.506601821701045, 8.799352120291779],
            [-9.503583973367764, 8.792742403132726],
            [-9.497806351380671, 8.789140401626918],
            [-9.492642912403817, 8.779606033328976],
            [-9.487877813444804, 8.777709277109897],
            [-9.482564370819253, 8.778917558015182],
            [-9.480384440327162, 8.777727347031258],
            [-9.475635819676311, 8.766846599370528],
            [-9.471973306934663, 8.768035766899242],
            [-9.466271631544503, 8.764321700936698],
            [-9.467471502937144, 8.76225119316465],
            [-9.4657919937993, 8.757543736181956],
            [-9.46612989197595, 8.75201548348709],
            [-9.462925853383695, 8.747612623971014],
            [-9.457640477063078, 8.744970769733506],
            [-9.4586455714152, 8.740572642342306],
            [-9.450198042546077, 8.740039694356273],
            [-9.445912575991548, 8.742198405559186],
            [-9.441320950724414, 8.742613208535921],
            [-9.4368897093589, 8.744961533413207],
            [-9.4306563340302, 8.739224476407209],
            [-9.427698909426221, 8.734839891291829],
            [-9.41927487469587, 8.740518569794236],
            [-9.415128314380505, 8.740184419320556],
            [-9.410478631071376, 8.74287798320467],
            [-9.394236001356843, 8.74490324113364],
            [-9.385112635638581, 8.740398503382636],
            [-9.381969661527414, 8.735132833338612],
            [-9.37823697402774, 8.732083853578521],
            [-9.376353722886604, 8.727138307670993],
            [-9.376152683674425, 8.721908586916882],
            [-9.369093951894857, 8.72034379186677],
            [-9.365352593560358, 8.720899712439932],
            [-9.36359310999072, 8.723348311906513],
            [-9.365100786340264, 8.727672158147481],
            [-9.361880352624334, 8.732740432999709],
            [-9.35741766098172, 8.731438064343603],
            [-9.353620024272278, 8.734411654057283],
            [-9.347848424033614, 8.732796079135703],
            [-9.340748163201, 8.737505520100164],
            [-9.339927916066712, 8.741574143640255],
            [-9.327191664374944, 8.751144473344102],
            [-9.322224604238734, 8.751622500797193],
            [-9.352772460789673, 8.550829530277646],
            [-9.354900979095039, 8.536580913636753],
            [-9.36068637721303, 8.537442888635391],
            [-9.361800192720654, 8.529907692068857],
            [-9.401229644662568, 8.274828165422623],
            [-9.406601308460987, 8.239465877583601],
            [-9.493957563839293, 8.252585890929574],
            [-9.49278919945854, 8.260099478821443],
            [-9.606884872337805, 8.277686741180908],
            [-9.714864788840217, 8.294804655739647],
            [-9.749442362043077, 8.300047917276371],
            [-9.821169998140226, 8.311313714355245],
            [-9.892900055864546, 8.322564152273817],
            [-9.939961973476098, 8.330027779761423],
            [-9.937639182113704, 8.335894348090886],
            [-9.938655360822029, 8.339847821334326],
            [-9.936304533330995, 8.346932487017012],
            [-9.937020780692341, 8.353896896299075],
            [-9.935430396516578, 8.35721787783041],
            [-9.937717058799349, 8.36058697641244],
            [-9.937196794771467, 8.364423970758745],
            [-9.939667327223592, 8.369523796380383],
            [-9.947709534464613, 8.373032158253833],
            [-9.945800944157597, 8.380309218283555],
            [-9.94233858986982, 8.38582447146268],
            [-9.948159815659604, 8.390877906133992],
            [-9.952402226604086, 8.396696366836501],
            [-9.961420569414482, 8.399652525962486],
            [-9.95980487480052, 8.404391666605276],
            [-9.964290948835458, 8.406322829171316],
            [-9.971712336961124, 8.415315017432452],
            [-9.966834519266737, 8.427793254774247],
            [-9.962780863107621, 8.43566787012091],
            [-9.963049746395352, 8.441668486567872],
            [-9.96207257796335, 8.447139340721646],
            [-9.960155883070733, 8.449565619427878],
            [-9.958560256959466, 8.457432542140818],
            [-9.952026079736571, 8.46206137342389],
            [-9.950300740891105, 8.465517242479322],
            [-9.942062625259208, 8.474369024233631],
            [-9.938570706101522, 8.476078044684359],
            [-9.938668375034181, 8.48053898486813],
            [-9.93223914319368, 8.484758438016007],
            [-9.924968008856743, 8.48170225653977],
            [-9.920015614886543, 8.485386017089393],
            [-9.92096151546426, 8.489902698971953],
            [-9.91823029357903, 8.4933521823145],
            [-9.919843475882251, 8.503996339635588],
            [-9.917505947938716, 8.509116111720504],
            [-9.911479598022028, 8.514525621870865],
            [-9.911885599760117, 8.522630052077597],
            [-9.90902693612591, 8.526616168379043],
            [-9.904253705882851, 8.529551609033726],
            [-9.90357918937735, 8.534723788678457],
            [-9.906993210877316, 8.54182933106154],
            [-9.910072281830479, 8.542639689439772],
            [-9.915950642309136, 8.547084092437414],
            [-9.916819582379716, 8.550709255564115],
            [-9.919997103971582, 8.552906999042598],
            [-9.92253097432007, 8.557435931557203],
            [-9.92551172064739, 8.558161620920755],
            [-9.926744077587301, 8.567708794607846],
            [-9.929393051767727, 8.569835251590245],
            [-9.935425698343904, 8.571561462019488],
            [-9.938459126760135, 8.57513845064386],
            [-9.943449364473636, 8.576802997937213],
            [-9.944678209788048, 8.579498725021129],
            [-9.939175129357984, 8.586025540847949],
            [-9.940337482842832, 8.589712115785211],
            [-9.94716220623354, 8.588358675131174],
            [-9.952647691047057, 8.588807402688746],
            [-9.95906074979369, 8.590791167021267],
            [-9.962495838515, 8.589127218205537],
            [-9.965513471817875, 8.590770570847],
            [-9.975606707522797, 8.589522419822664],
            [-9.978527559813056, 8.586886441627476],
            [-9.979449053933738, 8.581224422393138],
            [-9.98858265136618, 8.575300347644198],
            [-9.99282086881887, 8.574389782075269],
            [-10.003637260253106, 8.574347206755698],
            [-10.011832627769715, 8.578171922665371],
            [-10.016054940744008, 8.577906547534107],
            [-10.020102678596153, 8.58537189878196],
            [-10.027271967955468, 8.589051639743461],
            [-10.029082181213008, 8.595253523931241],
            [-10.028909609092828, 8.599561827005443],
            [-10.024912518360406, 8.607994228709927],
            [-10.026133303198748, 8.61467041987649],
            [-10.025161509452444, 8.626696969872505],
            [-10.02749463984426, 8.632414178082476],
            [-10.023746971708986, 8.639536568766438],
            [-10.025056744326658, 8.648994896025446],
            [-10.033712213273018, 8.649707040961024],
            [-10.03444663958756, 8.658059662377946],
            [-10.036738300664656, 8.662017576363843],
            [-10.035765450131134, 8.670716128015254],
            [-10.037554461580646, 8.674434572669375],
            [-10.0438542454915, 8.680908333543787],
            [-10.059430478191915, 8.686137955898687],
            [-10.06247317271908, 8.68990380229374],
            [-10.074115141774042, 8.69729052620462],
            [-10.077067162441992, 8.704216380435188],
            [-10.075735472656545, 8.706440049265444],
            [-10.068586048064015, 8.709485620089316],
            [-10.064516330969369, 8.712652600545473],
            [-10.059136879453554, 8.713809255157738],
            [-10.056510740204454, 8.724841080131988],
            [-10.061653917272189, 8.729809494055226],
            [-10.064619845198177, 8.735058890043755],
            [-10.064354044135335, 8.73935019156041],
            [-10.059939821598807, 8.74273958205477],
            [-10.0590429527697, 8.750466409989835],
            [-10.060757010960327, 8.753944903327389],
            [-10.060483439917318, 8.763091870632072],
            [-10.052576373631178, 8.770494832477144],
            [-10.054811599270835, 8.772559695969948],
            [-10.052079338702718, 8.776976343214828],
            [-10.053199301331366, 8.78812018190046],
            [-10.05951051852989, 8.791489304919445],
            [-10.064854893060343, 8.792636850251426],
            [-10.070305763373248, 8.791982864863872],
            [-10.078118191284522, 8.794528987126343],
            [-10.078348819643132, 8.7991624116241],
            [-10.084215372850004, 8.806066677792261],
            [-10.08657250508885, 8.80516670652915],
            [-10.098171354969152, 8.80603732224084],
            [-10.107215056972407, 8.804115813697791],
            [-10.107061913554293, 8.810973635882819],
            [-10.102879613063722, 8.817652840180784],
            [-10.104838539603717, 8.827758064541902],
            [-10.104354446765612, 8.837251334760001],
            [-10.108549277544403, 8.83951712415702],
            [-10.110097023165958, 8.84494768373411],
            [-10.114884046195703, 8.846701118291614],
            [-10.118105874707078, 8.845876777670377],
            [-10.126428131693544, 8.847932218074007],
            [-10.12528570260061, 8.85170908203275],
            [-10.120847817539458, 8.856205079280404],
            [-10.12046213684643, 8.860951353362847],
            [-10.122487893288604, 8.862182399060847],
            [-10.121896595642905, 8.867178531965232],
            [-10.126473045092531, 8.868605532481952],
            [-10.131429581272045, 8.872034894743056],
            [-10.123744879611348, 8.879345362835668],
            [-10.12028708229122, 8.881082391189395],
            [-10.122287342749399, 8.886020082924434],
            [-10.124908162697775, 8.885219913991198],
            [-10.12866123004532, 8.891846439991271],
            [-10.123605022361295, 8.894683428782422],
            [-10.12061381075203, 8.907939172188627],
            [-10.124254027873906, 8.91357305491454],
            [-10.125586956494693, 8.917879373252088],
            [-10.133305308317063, 8.920725386703436],
            [-10.135042464060312, 8.92419289230995],
            [-10.138115023209252, 8.923536830530221],
            [-10.142589420089582, 8.929465726055001],
            [-10.146365989832436, 8.93203517492043],
            [-10.143181634512418, 8.938607534813658],
            [-10.142071193981018, 8.94337654114874],
            [-10.140473784513405, 8.958772131382615],
            [-10.14363270941166, 8.968515061049763],
            [-10.14808245355279, 8.977980158665103],
            [-10.143222680052668, 8.982991718392912],
            [-10.14520945358042, 8.985439445901559],
            [-10.154977506266816, 8.987854259052288],
            [-10.156258395652866, 8.980214874387414],
            [-10.16278765431324, 8.976471960368515],
            [-10.167481888301992, 8.978003499192948],
            [-10.171765197534958, 8.977245770082565],
            [-10.176742650983517, 8.978399381006744],
            [-10.181519018078381, 8.981133985653848],
            [-10.18355613071134, 8.983941356591297],
            [-10.18897913650799, 8.986450034933682],
            [-10.194805795534606, 8.985365554845494],
            [-10.198385348868337, 8.983244121363775],
            [-10.20162382066215, 8.987470078509954],
            [-10.20591085235471, 8.986639425460185],
            [-10.209920212069706, 8.989716517153926],
            [-10.218100356039034, 9.002266826186522],
            [-10.217757452881152, 9.007461575871101],
            [-10.222800505481429, 9.014322263678748],
            [-10.230941409130574, 9.015281952050104],
            [-10.23333551141764, 9.026868939981709],
            [-10.23031608563691, 9.028048673055968],
            [-10.229648285385242, 9.031995051813842],
            [-10.225112377615964, 9.033120625088438],
            [-10.224626424114952, 9.036048861285627],
            [-10.227737063908897, 9.040984476177146],
            [-10.227356351720543, 9.047850756695516],
            [-10.218643204577166, 9.049050071492031],
            [-10.214783007360799, 9.051820866675914],
            [-10.21034960612169, 9.052267979244116],
            [-10.20817903491811, 9.05517018623857],
            [-10.203086992629897, 9.055866728331754],
            [-10.201492913238166, 9.060336585318115],
            [-10.19637290790436, 9.06869376755814],
            [-10.200263087189722, 9.070202378619214],
            [-10.202978679450244, 9.075130989221778],
            [-10.208806239844224, 9.08223474993739],
            [-10.215946924254748, 9.084634717595689],
            [-10.225706815251487, 9.090068528457667],
            [-10.230289877195576, 9.096210645879344]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.88573264865836,
          "lat": 46.598221458677614
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30059"],
        "coty_name": ["Meagher"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meagher County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01719600"
      },
      "bbox": [
        -10.23333551141764, 8.239465877583601, -9.322224604238734,
        9.211265439456644
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.642434695157599, 10.7791755180368],
            [-7.555425161201525, 10.768326879418677],
            [-7.4684189828777905, 10.757451593547623],
            [-7.4104336150612795, 10.750319597592442],
            [-7.292005506900306, 10.73591917775815],
            [-7.205101966772746, 10.725235329911936],
            [-7.118201885213589, 10.714524933486281],
            [-7.067054164646798, 10.709107802807523],
            [-7.00644889660861, 10.701972458013952],
            [-6.945845197509066, 10.694824218912567],
            [-6.955967650100961, 10.610704390481812],
            [-6.973276302653629, 10.612758289073176],
            [-7.013536392353799, 10.280099468768768],
            [-7.004505950711805, 10.278991687898422],
            [-7.011320103446713, 10.22221500256525],
            [-7.016099174507428, 10.223941692518594],
            [-7.018422011751174, 10.222367516520423],
            [-7.021923611813635, 10.224161560021754],
            [-7.027987527910668, 10.222360997731537],
            [-7.029431735387041, 10.225407221041026],
            [-7.033339950722182, 10.224994518098569],
            [-7.03741856592077, 10.231254676509652],
            [-7.043180993906829, 10.229697006959535],
            [-7.049182537541058, 10.234307564761394],
            [-7.054119422302117, 10.232527752414475],
            [-7.058019283406917, 10.199798023030159],
            [-7.0871356517915265, 10.203169872973511],
            [-7.096915022196407, 10.118994978995072],
            [-7.069741662813087, 10.115883478627628],
            [-7.0803156059117125, 10.029421475259777],
            [-7.152810222395422, 10.038348290870879],
            [-7.163390226337842, 9.954313693734035],
            [-7.186603758786405, 9.957132058609862],
            [-7.20207935995647, 9.831587594419604],
            [-7.217747123348647, 9.70401675212029],
            [-7.228010544986372, 9.619618698626624],
            [-7.234536760752584, 9.620398796937105],
            [-7.256123915991224, 9.446698087590143],
            [-7.259559915841801, 9.443981781551916],
            [-7.267116890226947, 9.433003256585234],
            [-7.267858057263106, 9.42782766059947],
            [-7.26429500456119, 9.4227457938056],
            [-7.262898065327118, 9.41845878710858],
            [-7.264080435804211, 9.414100976168658],
            [-7.269393566650728, 9.408457020980725],
            [-7.276131105462485, 9.407618329431557],
            [-7.277493165727543, 9.402722165319634],
            [-7.275167223112068, 9.397868491698798],
            [-7.276647997340554, 9.389615703123003],
            [-7.282993506891408, 9.382738462945676],
            [-7.289078068672761, 9.381953864188679],
            [-7.307438213703729, 9.385984628287025],
            [-7.321082367362044, 9.387624806916998],
            [-7.32585611825207, 9.3912012884841],
            [-7.328097836379086, 9.394547070900776],
            [-7.3332570706932705, 9.407755171216742],
            [-7.341616116960736, 9.40933962315774],
            [-7.350689795707068, 9.413006941861248],
            [-7.354989676571898, 9.413754981721212],
            [-7.364757778570096, 9.411592914975188],
            [-7.368479973126306, 9.41276763121227],
            [-7.377444622765272, 9.418426363837412],
            [-7.381905149815083, 9.420343542934253],
            [-7.390230559375325, 9.421105225343373],
            [-7.394720400456346, 9.416952628124687],
            [-7.398779790985923, 9.405446252298933],
            [-7.401214852822991, 9.404519290676916],
            [-7.403503464976844, 9.411364166013923],
            [-7.408795877938531, 9.417828102661115],
            [-7.412038173887388, 9.423891401413675],
            [-7.417815785889587, 9.427443761539013],
            [-7.4225347626410825, 9.425975106442248],
            [-7.418491193523068, 9.419543378253953],
            [-7.417830921329986, 9.4144505952246],
            [-7.419668325432694, 9.404895998995844],
            [-7.4216320518761805, 9.401116682809352],
            [-7.425690751176033, 9.397641340391013],
            [-7.431016988512655, 9.397832040895194],
            [-7.433472460428778, 9.404285347180465],
            [-7.436110002259731, 9.40733807888896],
            [-7.4461341188618695, 9.409920779345411],
            [-7.452716657651802, 9.408467801054535],
            [-7.453289321255463, 9.40065429543225],
            [-7.463149712712485, 9.389395773493266],
            [-7.465552684508596, 9.381672451773287],
            [-7.471754650081979, 9.3765895397978],
            [-7.474522987972876, 9.372219590397306],
            [-7.4821900403523705, 9.369042560147184],
            [-7.482565172829772, 9.36294075303623],
            [-7.484348959365596, 9.355938546125179],
            [-7.488116933044477, 9.353552486074468],
            [-7.498674708891618, 9.353375740120661],
            [-7.506065611262451, 9.350475867682466],
            [-7.504896556677631, 9.340036848906756],
            [-7.5072563740941725, 9.335214489261544],
            [-7.515156694547797, 9.33126509504166],
            [-7.518546879064526, 9.332251701128216],
            [-7.522439697483748, 9.341038221692129],
            [-7.527469344578285, 9.34280782238644],
            [-7.530632642031344, 9.33595020423794],
            [-7.538528866043013, 9.333840451566411],
            [-7.542496068416662, 9.337347503212195],
            [-7.548136718348754, 9.33740892759503],
            [-7.55445830953345, 9.331701284473532],
            [-7.56119770643313, 9.328377204448294],
            [-7.563984177722046, 9.32287044312936],
            [-7.56426128671088, 9.319370398524336],
            [-7.568346012649418, 9.315323230794418],
            [-7.5728481856488195, 9.312836661349909],
            [-7.577751023087711, 9.312730953774942],
            [-7.581429137344014, 9.309628990304095],
            [-7.581581926199683, 9.304758351799439],
            [-7.577559485845704, 9.299370671174819],
            [-7.573890872774507, 9.287991542789495],
            [-7.574956170746267, 9.283737215175275],
            [-7.581629830129534, 9.282432246276818],
            [-7.585677421916226, 9.280156183578272],
            [-7.588139806523262, 9.275632952802393],
            [-7.5879645352694745, 9.268861299611364],
            [-7.58478987199078, 9.26494428544686],
            [-7.584292719904353, 9.25773797986407],
            [-7.587149678433672, 9.254153475804994],
            [-7.602627772030379, 9.25340403086284],
            [-7.616127266067822, 9.251148749969495],
            [-7.618582635890639, 9.25275498032411],
            [-7.620381069488312, 9.25547186949742],
            [-7.618698349869912, 9.261514426958401],
            [-7.6187101125051795, 9.267621131680094],
            [-7.614864084761787, 9.271496372396042],
            [-7.612735123745309, 9.275871679549214],
            [-7.614582945122131, 9.284405182400265],
            [-7.613947303990868, 9.289068481680692],
            [-7.609108058920705, 9.29409873877558],
            [-7.603907671589375, 9.303697511668599],
            [-7.6037803693147525, 9.309607221751293],
            [-7.606074569651107, 9.311947676807732],
            [-7.61266740497935, 9.31507055599531],
            [-7.616689726489894, 9.321604740448624],
            [-7.614460751580264, 9.330773200431707],
            [-7.615089693430857, 9.335833458040003],
            [-7.6171412775053975, 9.337863317152294],
            [-7.621171716545276, 9.34561638918478],
            [-7.619828008023881, 9.351213214109741],
            [-7.615461827876467, 9.356259757149738],
            [-7.615879586597605, 9.36556768926894],
            [-7.618698162201958, 9.369759499436832],
            [-7.622024878001859, 9.370340758086416],
            [-7.627959373369377, 9.36819952735461],
            [-7.6391337403883295, 9.373099558716786],
            [-7.640977346708343, 9.381836430456497],
            [-7.646969861749336, 9.389939553436452],
            [-7.655229363095875, 9.393858801470202],
            [-7.66090646190911, 9.390179371604555],
            [-7.672466480090503, 9.388616615291712],
            [-7.679667035392887, 9.390492850236347],
            [-7.694091581957289, 9.398367310774702],
            [-7.697722720454437, 9.404771893704847],
            [-7.702759440200569, 9.408853240836848],
            [-7.7055239186645075, 9.409497622344206],
            [-7.715855354028119, 9.40459349712041],
            [-7.720100937665643, 9.404569709261647],
            [-7.724102511445817, 9.407742892100122],
            [-7.727664317174685, 9.408087768868604],
            [-7.7344597130727175, 9.406349816985472],
            [-7.738339197350518, 9.40676405985588],
            [-7.7423150709539375, 9.409950031593702],
            [-7.7507906133355755, 9.410945545814158],
            [-7.75465296305218, 9.409907321212195],
            [-7.7626828204591645, 9.40224444825115],
            [-7.772064452343857, 9.400576154222234],
            [-7.78401827281252, 9.40141768876388],
            [-7.788578127538892, 9.404674172894095],
            [-7.791074291682752, 9.409075368027905],
            [-7.79694855281297, 9.412608354740744],
            [-7.802384980443755, 9.41178907765674],
            [-7.8071433381471325, 9.409588398309616],
            [-7.8237476164558535, 9.40875774724282],
            [-7.8284143452242585, 9.410054617202015],
            [-7.832038567828777, 9.415168055991073],
            [-7.837606361388334, 9.416080866208059],
            [-7.8428798935489645, 9.411865571926587],
            [-7.854000999966652, 9.40990787569286],
            [-7.8691403625166, 9.412960371238972],
            [-7.874139056463729, 9.416480297178726],
            [-7.87612427384744, 9.418528082032974],
            [-7.881219153774879, 9.419159564590421],
            [-7.887678708380444, 9.417301880228534],
            [-7.887793264465353, 9.414903339629486],
            [-7.883366848935536, 9.410678111375057],
            [-7.884774106817017, 9.40511032083665],
            [-7.891561203301002, 9.402662217790025],
            [-7.896694584245602, 9.402558474929],
            [-7.901365828165919, 9.403969010698516],
            [-7.900812667717362, 9.410968204483023],
            [-7.903683740539348, 9.416881772116602],
            [-7.911289096826036, 9.413780500971175],
            [-7.918554094952305, 9.416231901954935],
            [-7.919987723400359, 9.420336784757191],
            [-7.918432869410047, 9.425243268700351],
            [-7.922411469452496, 9.430961647010985],
            [-7.931523133751021, 9.435281993051653],
            [-7.935415277580557, 9.433980400595543],
            [-7.9358387853159, 9.429948787884815],
            [-7.940912041920175, 9.426332582962734],
            [-7.949053996887621, 9.42723685375661],
            [-7.951558514008687, 9.431229376194135],
            [-7.947978162796393, 9.434070771313184],
            [-7.945414121375607, 9.43883077329246],
            [-7.946959363954084, 9.44614338013683],
            [-7.952190802541269, 9.444636171256976],
            [-7.956732884307288, 9.445757452965465],
            [-7.957797570759558, 9.448558959271598],
            [-7.955539055395549, 9.451522782793077],
            [-7.955750773260334, 9.456580060477787],
            [-7.962737759714398, 9.460271350085561],
            [-7.966836081568559, 9.460160829949823],
            [-7.97023053300746, 9.456743461848696],
            [-7.971175222982219, 9.45231961555152],
            [-7.974950922974887, 9.448559470293786],
            [-7.981877442074762, 9.444244083620585],
            [-7.991321799947607, 9.448567153142607],
            [-7.997735397545022, 9.4483333823667],
            [-8.0039337680976, 9.450638787530403],
            [-8.004394870792439, 9.453892208398942],
            [-8.00173159532981, 9.458206134780333],
            [-8.00490329242989, 9.464412428400308],
            [-8.013339205899008, 9.471538120904087],
            [-8.01802678784303, 9.467011491666868],
            [-8.02198028293945, 9.46558988763916],
            [-8.028327767217277, 9.466579135231822],
            [-8.045376972201577, 9.464251589512044],
            [-8.047925031229168, 9.465743398995224],
            [-8.051142810345754, 9.470921718655465],
            [-8.060236967745206, 9.472581362319284],
            [-8.062639939939125, 9.47757303839837],
            [-8.065585790548491, 9.480668491441756],
            [-8.069364161020752, 9.482076978612781],
            [-8.07410947899018, 9.480565173750334],
            [-8.08372126484377, 9.479220787013997],
            [-8.100552724187951, 9.483870840069379],
            [-8.105793577554008, 9.482409897798762],
            [-8.110640405375301, 9.48280674916483],
            [-8.114593704051451, 9.49013865816244],
            [-8.118956368147332, 9.495330769640484],
            [-8.126511021166454, 9.494767178106294],
            [-8.129914707504781, 9.495534699002748],
            [-8.134939660434695, 9.499911460705457],
            [-8.135663863738397, 9.507946620443423],
            [-8.142610118329127, 9.516073350225417],
            [-8.144610798246003, 9.517286871513278],
            [-8.151785032517067, 9.515679909381632],
            [-8.159510499622062, 9.516332131258597],
            [-8.163937960598368, 9.513883514127674],
            [-8.171325942107073, 9.514943831675085],
            [-8.174593771274703, 9.516964717891673],
            [-8.183033601135339, 9.528357068353133],
            [-8.184509168040751, 9.535503433873494],
            [-8.179557592126562, 9.541632435502521],
            [-8.17725058733236, 9.547025281458106],
            [-8.178086386304775, 9.553580325753682],
            [-8.185221383629601, 9.56249683953658],
            [-8.189845134853194, 9.565744830099804],
            [-8.193814445453503, 9.571370782112632],
            [-8.196262942518091, 9.578857339335311],
            [-8.199604684422651, 9.583113109879802],
            [-8.208159883872504, 9.58991273783464],
            [-8.210744912289728, 9.593148839286544],
            [-8.216260033976036, 9.596900412838028],
            [-8.22199473884257, 9.598938260814734],
            [-8.22497736619154, 9.60187262203128],
            [-8.242983143498796, 9.61399974170348],
            [-8.224680331632511, 9.74597790752002],
            [-8.222954796066787, 9.745745843640245],
            [-8.215846416569692, 9.79621610827406],
            [-8.14330491167786, 9.786817740361133],
            [-8.07076562302405, 9.777401847619952],
            [-8.06752476043959, 9.776465595710455],
            [-8.064138225190483, 9.778213890791521],
            [-8.060778147842441, 9.772850230451148],
            [-8.049283452505845, 9.771982874928485],
            [-8.047966401093118, 9.774013744396184],
            [-8.040269154348364, 9.770572238889223],
            [-8.033872157954267, 9.806053311793711],
            [-8.018950817654122, 9.837371649353924],
            [-8.012289153180031, 9.83740905606441],
            [-8.006127061279445, 9.831346321730832],
            [-7.994794764677383, 9.824613109619747],
            [-7.904689704205721, 9.808214599902],
            [-7.895735846771203, 9.874816144558736],
            [-7.873176566118481, 10.04346533627124],
            [-7.858185820383812, 10.041527890804952],
            [-7.845725339615343, 10.13427277719065],
            [-7.8289955758504375, 10.25941303818881],
            [-7.825619501026054, 10.260626419308585],
            [-7.825327110855861, 10.254803713324533],
            [-7.8180183711290345, 10.250909597913802],
            [-7.814162909352644, 10.253656419581855],
            [-7.812945276958409, 10.250696285450612],
            [-7.806013970382762, 10.252405378025772],
            [-7.8008985273220075, 10.252299531491698],
            [-7.799698563316947, 10.246197995711038],
            [-7.802138272516164, 10.243282599283878],
            [-7.796437905326184, 10.239623709966835],
            [-7.792761348213995, 10.24254040637202],
            [-7.791701221613693, 10.23749431784353],
            [-7.788725567166859, 10.232423869366457],
            [-7.769985739370941, 10.3730576206859],
            [-7.751962125802191, 10.370725491090106],
            [-7.739046327124564, 10.468409365205007],
            [-7.729817685679602, 10.538344008841774],
            [-7.690306486569945, 10.533308796807388],
            [-7.668512543136899, 10.698396155976415],
            [-7.653339203768677, 10.696393623383548],
            [-7.642434695157599, 10.7791755180368]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.9132335125981,
          "lat": 48.259179195360765
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30071"],
        "coty_name": ["Phillips"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Phillips County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01720023"
      },
      "bbox": [
        -8.242983143498796, 9.251148749969495, -6.945845197509066,
        10.7791755180368
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.054410806846936374, 3.342677149426017],
            [0.10753041937186883, 3.342666147999202],
            [0.12412348523416432, 3.343489825017399],
            [0.1791279044352771, 3.3424802704753427],
            [0.23530922366336268, 3.341164099968096],
            [0.23560136217233066, 3.372837297891569],
            [0.2625083987456632, 3.3733474023931014],
            [0.265638713614673, 3.368344757499552],
            [0.2691353736480179, 3.365865855723242],
            [0.27488196533354586, 3.3640626543205534],
            [0.2817165411146268, 3.367599505728452],
            [0.2879391785015013, 3.3670528284279624],
            [0.2925559552630249, 3.3650880355413233],
            [0.2973172164147857, 3.361127567550948],
            [0.3000732436657165, 3.3554317399211695],
            [0.29879564348632753, 3.348491587387111],
            [0.2956465930456738, 3.344476483163339],
            [0.2875219685203946, 3.338126158555501],
            [0.28524115405145073, 3.3327529308327617],
            [0.28612111663427137, 3.325095328662787],
            [0.28923209486214163, 3.322148612832461],
            [0.2942066416156755, 3.3201074303208937],
            [0.3000625227063037, 3.323081742155328],
            [0.3049451039818932, 3.3324401910695967],
            [0.3116957472166954, 3.3350051655272006],
            [0.32019890009495355, 3.3343789957137915],
            [0.32498174147510306, 3.3320177022836943],
            [0.3282888343617732, 3.3256408278126695],
            [0.32738270871427144, 3.321090929679575],
            [0.3219313824536074, 3.3100426233989957],
            [0.3230596780400405, 3.3062798545168954],
            [0.327745293069904, 3.3022235301630563],
            [0.33294100572010477, 3.3018406281184025],
            [0.3396863693884832, 3.3045140676030944],
            [0.3482007948540118, 3.3056468137954176],
            [0.35949785326416017, 3.303543762420152],
            [0.3659079595825295, 3.3000776526575657],
            [0.3681419758601341, 3.297106333540602],
            [0.36836850629585827, 3.290532980073107],
            [0.36376766470949706, 3.277554872650744],
            [0.35843878760988995, 3.271212542546736],
            [0.3569655332903891, 3.266826446378338],
            [0.3577641761900989, 3.262645031585136],
            [0.36283055883128806, 3.2523603533583985],
            [0.36272534503276, 3.245983876880397],
            [0.3586379267406219, 3.240512187085077],
            [0.3497411750806883, 3.2375513552783777],
            [0.3461931281605296, 3.2351798422514992],
            [0.3440501692364606, 3.2306539784878665],
            [0.3442151901249433, 3.2268995455989837],
            [0.3468320429783204, 3.2222217714885306],
            [0.3512761277721245, 3.217097589992881],
            [0.35483351246530065, 3.209776521203102],
            [0.3552604869169809, 3.202461273360968],
            [0.35693267306161547, 3.196742128485857],
            [0.36097070680903065, 3.191151216370363],
            [0.36716543855082107, 3.1856188090565043],
            [0.3726374524743167, 3.183369657924917],
            [0.3778181458431288, 3.179630715491989],
            [0.38221508784394215, 3.1735716652097463],
            [0.3839320442424107, 3.1650093201272855],
            [0.3817050939416848, 3.15543544679708],
            [0.3841455551674886, 3.145240423274059],
            [0.3869846458774129, 3.1416825623124165],
            [0.394314860390561, 3.1372833310240806],
            [0.40378951638216753, 3.1346181080681736],
            [0.4078407795320179, 3.132268052850305],
            [0.4121927562896701, 3.1279373959760113],
            [0.415726993375775, 3.120612932642165],
            [0.41458662114642053, 3.113253409152964],
            [0.4063399978830396, 3.1021047789135894],
            [0.4053012152011568, 3.095596068847369],
            [0.40576617296256756, 3.0857823730492044],
            [0.40456727873230325, 3.082058178774584],
            [0.4010401235440382, 3.0774527338024753],
            [0.39152927059009096, 3.0731983583241647],
            [0.38625789775849967, 3.0683096589242083],
            [0.3849154809893754, 3.061952003863378],
            [0.38553286872836784, 3.0556705568028932],
            [0.3877303521877505, 3.052015152596733],
            [0.398843784818875, 3.0461326260735375],
            [0.4047060735802109, 3.04188382694669],
            [0.41002439933991464, 3.0326556952763823],
            [0.40745416976989723, 3.0254810958593827],
            [0.4026536009485678, 3.0219616416886965],
            [0.3966130981180782, 3.0212286328797204],
            [0.3858404670216567, 3.0237469778650286],
            [0.38076239747590335, 3.0215956322990283],
            [0.376472278560918, 3.018027023274587],
            [0.3737598526695004, 3.01229641808886],
            [0.3735222402477425, 3.006730525006108],
            [0.34903757982904493, 3.0067702519953525],
            [0.2591257400084161, 3.0073681522782953],
            [0.19167187055907334, 3.007528631843408],
            [0.13405158562748357, 3.008090318382056],
            [0.13474638740546063, 3.0665841169556662],
            [0.05257374603021461, 3.067259996231964],
            [0.05295819841127226, 3.1429706075320203],
            [0.05360927388150875, 3.242121294744806],
            [0.05406146330450183, 3.3294979751705633],
            [0.054410806846936374, 3.342677149426017]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.32864045394138, "lat": 41.85154082092595 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31021"],
        "coty_name": ["Burt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burt County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00835832"
      },
      "bbox": [
        0.05257374603021461, 3.006730525006108, 0.415726993375775,
        3.3733474023931014
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.957069182661222, 4.470101884763057],
            [-3.957025662667998, 4.470099097290037],
            [-3.872642627032079, 4.464805089666701],
            [-3.78826052938638, 4.459496228911805],
            [-3.689397575272638, 4.450771931790908],
            [-3.6254211206721316, 4.446578953104414],
            [-3.5346093303370076, 4.4421543981224305],
            [-3.4777709891286004, 4.439122745214259],
            [-3.336748808254025, 4.431772394303199],
            [-3.2024882177874177, 4.4246173667131625],
            [-3.171484934555088, 4.422550896450455],
            [-3.140919054503653, 4.421219890364201],
            [-3.0897316759059814, 4.418659305448088],
            [-3.0748760194663682, 4.418285012889661],
            [-2.9880126729228906, 4.413811816160736],
            [-2.9036388610405046, 4.4095713990145295],
            [-2.899027988419633, 4.409841209578923],
            [-2.846510737921243, 4.407448416700922],
            [-2.8328417272947526, 4.407093492893726],
            [-2.7880824528883883, 4.405249320199809],
            [-2.698605215690079, 4.4005557713682855],
            [-2.5888035534246074, 4.395430687556932],
            [-2.5888030523564733, 4.395430667108472],
            [-2.5921922125136936, 4.3093767741816515],
            [-2.5926189351067714, 4.308958897546006],
            [-2.595621306939211, 4.242705619602852],
            [-2.5985829413809634, 4.177483976832275],
            [-2.587427833940686, 4.176977015466491],
            [-2.5946396901379183, 4.011956941775413],
            [-2.598157642646116, 3.9297804997323698],
            [-2.599536676493724, 3.900932287613967],
            [-2.6027380899121004, 3.8284899671109525],
            [-2.591298843095777, 3.827771098476417],
            [-2.6032636287381976, 3.5590159564448323],
            [-2.6066800895828917, 3.479036455527443],
            [-2.6803036443266643, 3.482600496838964],
            [-2.7596291403978475, 3.4868581775302347],
            [-2.8558582565713904, 3.4915733626637246],
            [-2.9520882131057355, 3.496271680756598],
            [-2.9950173456431335, 3.498807720820673],
            [-3.106050526638178, 3.5050223779400165],
            [-3.1276117807313435, 3.506183354859327],
            [-3.1372566811825373, 3.507494516594826],
            [-3.2256665827700317, 3.513043362113855],
            [-3.3140774533291606, 3.5185779428898054],
            [-3.4024892802616233, 3.5240982567149652],
            [-3.4909020509392064, 3.5296043016306724],
            [-3.495361893819666, 3.529598472317113],
            [-3.532938316826724, 3.532125684851934],
            [-3.5651332712385786, 3.5341439647577197],
            [-3.690446775941325, 3.542697596205584],
            [-3.7540124465370335, 3.546341271750414],
            [-3.8480693775186126, 3.5528377043235975],
            [-3.95921766076689, 3.5618072713882607],
            [-3.9840787426352398, 3.56390255588683],
            [-3.97810023620401, 3.650618325880132],
            [-3.9745886348828177, 3.704939604965697],
            [-3.974368270413626, 3.7055528032982616],
            [-3.965794207351666, 3.831938758473778],
            [-3.9603753235221553, 3.911261496113794],
            [-3.9812333504769817, 3.912745411874249],
            [-3.970739170035075, 4.075774925762227],
            [-3.964398730761391, 4.170924485623638],
            [-3.959437843628063, 4.255337870653612],
            [-3.9725826833345153, 4.256196118066756],
            [-3.966393590847827, 4.343195276036],
            [-3.957069182661222, 4.470101884763057]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.11860231296228,
          "lat": 42.54497994791865
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31031"],
        "coty_name": ["Cherry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherry County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00835837"
      },
      "bbox": [
        -3.9840787426352398, 3.479036455527443, -2.587427833940686,
        4.470101884763057
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5785886966349307, 2.7454476154528584],
            [-1.5695338189157304, 2.745306819180123],
            [-1.5155884668509578, 2.7434587434292674],
            [-1.436220701665952, 2.741409129254212],
            [-1.3411058744314908, 2.7388973206810006],
            [-1.3230201953991898, 2.73819185240273],
            [-1.2416112629147613, 2.736242590782824],
            [-1.2380134908212856, 2.73616005328844],
            [-1.2409119766121024, 2.62137852790262],
            [-1.2429733588486507, 2.539431910936976],
            [-1.245901973589699, 2.4227913100981477],
            [-1.2468780785203337, 2.3862771698789627],
            [-1.3147516121141283, 2.387692901239799],
            [-1.3432966661496, 2.388640084588819],
            [-1.4152326775904676, 2.390744829884316],
            [-1.5058312881712255, 2.3933248652717],
            [-1.5570534945254983, 2.394631722154426],
            [-1.5719880347180533, 2.395152342934995],
            [-1.5918406489099077, 2.3956890725463205],
            [-1.5906116510961645, 2.4546910796460124],
            [-1.5886848061052907, 2.4687229569682914],
            [-1.588458109053601, 2.476169164879283],
            [-1.589378525090677, 2.483412625448703],
            [-1.5880117545187968, 2.5272618006703085],
            [-1.586681211470103, 2.5564795147159853],
            [-1.5824730139172567, 2.6627264554049135],
            [-1.5815284198318058, 2.7024011515011805],
            [-1.5785886966349307, 2.7454476154528584]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.51712354741542, "lat": 41.22006245617797 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31093"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00835868"
      },
      "bbox": [
        -1.5918406489099077, 2.3862771698789627, -1.2380134908212856,
        2.7454476154528584
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5701004158784942, 1.671635411006606],
            [-0.48449478549512737, 1.6701152296153818],
            [-0.3636085489420131, 1.6682729486025174],
            [-0.31229726567760996, 1.6676709407576653],
            [-0.22822308809385158, 1.6668570997828425],
            [-0.2294423480353855, 1.5646519392938747],
            [-0.2301643326426086, 1.4912897203522313],
            [-0.2308960758446078, 1.4132222336025113],
            [-0.23150481142646556, 1.3966489245134617],
            [-0.2313591654317932, 1.3450649172903832],
            [-0.23187676614854122, 1.3156306081789535],
            [-0.30228449433853394, 1.316300432900598],
            [-0.33302555264591926, 1.3164920614269722],
            [-0.3999686224578325, 1.3177576696793682],
            [-0.4034503381358379, 1.3174775707822974],
            [-0.49004751282210446, 1.3186389371303135],
            [-0.5755492061096577, 1.320321012418645],
            [-0.5742236502151301, 1.4080666598318314],
            [-0.5734298828312608, 1.4666708829332498],
            [-0.572271365029497, 1.5437491343301373],
            [-0.5717063689383916, 1.5611132212818923],
            [-0.5718599109961064, 1.569149785195173],
            [-0.5708813874346624, 1.6317525252101794],
            [-0.5702305637675105, 1.6500141785508855],
            [-0.5701004158784942, 1.671635411006606]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.14272990162397, "lat": 40.17573075191731 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31095"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00835869"
      },
      "bbox": [
        -0.5755492061096577, 1.3156306081789535, -0.22822308809385158,
        1.671635411006606
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5381424334080482, 3.1809331653115995],
            [-3.513787896706185, 3.1799415536435442],
            [-3.366406710932008, 3.1706080972269546],
            [-3.330374903999908, 3.1686568413917695],
            [-3.1959989397623207, 3.159087149026172],
            [-3.1456019335215033, 3.156390830856714],
            [-3.12118857952651, 3.1556481841748147],
            [-3.052203379276988, 3.1517757430008584],
            [-3.0491061256527727, 3.1512374057528394],
            [-3.0242835282453124, 3.1501313055811457],
            [-3.029722504232703, 3.0621954915126057],
            [-3.034626434444737, 2.976231606105635],
            [-3.0375972984956494, 2.919107153376209],
            [-3.0407934306318336, 2.8523423129444687],
            [-3.0429356852952805, 2.8021876374787658],
            [-3.116137723685043, 2.8061265046513117],
            [-3.1868529373398617, 2.8103395429965037],
            [-3.2722905757644107, 2.8152948238430953],
            [-3.328661872671979, 2.8184997071461533],
            [-3.4564573118517257, 2.8253330963164154],
            [-3.5284162157250614, 2.8298831193151606],
            [-3.5586571225333943, 2.831558553674348],
            [-3.556103597725825, 2.8747831569499733],
            [-3.548298742329836, 3.0058409712434306],
            [-3.5457132017904525, 3.0475303532290114],
            [-3.5433391732515402, 3.0934192651495427],
            [-3.5381424334080482, 3.1809331653115995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.06043197434022, "lat": 41.5681529896564 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31117"],
        "coty_name": ["McPherson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McPherson County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00835881"
      },
      "bbox": [
        -3.5586571225333943, 2.8021876374787658, -3.0242835282453124,
        3.1809331653115995
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9022196283311018, 2.379043764922026],
            [-0.7968114232786909, 2.377143272856331],
            [-0.7312991847688306, 2.3760368213493717],
            [-0.6455487169881684, 2.3748123218041712],
            [-0.5595573738600743, 2.373658513530874],
            [-0.5608494317329286, 2.28595472438548],
            [-0.5622458601987192, 2.1981891711773054],
            [-0.5635849166818334, 2.110410337325789],
            [-0.5648261973761607, 2.022694689267501],
            [-0.686865263901603, 2.024524747957116],
            [-0.7012534911674898, 2.0249009605335573],
            [-0.7649569357467254, 2.0259263084721884],
            [-0.8584119295131495, 2.0274779974703936],
            [-0.9078308478434189, 2.0283648844048003],
            [-0.9085392050031429, 2.0283966279700594],
            [-0.9062364129199869, 2.152045889395796],
            [-0.9054257031901758, 2.203573612735484],
            [-0.9037994664748403, 2.291257250096079],
            [-0.9022196283311018, 2.379043764922026]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.5971056692914, "lat": 40.87273618162427 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31185"],
        "coty_name": ["York"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["York County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "00835914"
      },
      "bbox": [
        -0.9085392050031429, 2.022694689267501, -0.5595573738600743,
        2.379043764922026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.34700396489143, -4.7925540596340435],
            [-10.28657512886212, -4.801293569441999],
            [-10.272420810544505, -4.804153009352641],
            [-10.191280767922514, -4.814113028753001],
            [-10.159016154544512, -4.817953158657622],
            [-10.103812528687598, -4.826756240678045],
            [-10.098906006862867, -4.826205517816705],
            [-10.01697291798312, -4.83682674764468],
            [-10.017175566525824, -4.838428973970965],
            [-9.931949636307461, -4.849523204414059],
            [-9.856073248159039, -4.866560961551398],
            [-9.661427578161115, -4.891914449142321],
            [-9.634737951906244, -4.895203524074933],
            [-9.485559810692083, -4.9140507275788385],
            [-9.37389567935637, -4.929385279674732],
            [-9.367825918878546, -4.933080048546551],
            [-9.369023790127297, -4.939214931045573],
            [-9.362492389357593, -4.942098580951822],
            [-9.362116255323892, -4.945623259679624],
            [-9.355917771542925, -4.948680944751677],
            [-9.35763474462656, -4.9507538035476095],
            [-9.357135249390124, -4.955853130766888],
            [-9.358921958641535, -4.959079451588239],
            [-9.367773569622944, -4.959503505100127],
            [-9.371045995013478, -4.964767382346721],
            [-9.371529584614404, -4.971326462391289],
            [-9.370074951886886, -4.972869434299696],
            [-9.372941189603406, -4.980150411668572],
            [-9.370786740058238, -4.9850074816138745],
            [-9.371867135169019, -4.996111788109173],
            [-9.366513744443479, -5.000068336719265],
            [-9.37003023804115, -5.005071943151298],
            [-9.372092751760162, -5.010720733639214],
            [-9.370566132036174, -5.0285820670483785],
            [-9.368050235613106, -5.035371727389137],
            [-9.372311066029868, -5.044723652410163],
            [-9.363822328340236, -5.0538259480346905],
            [-9.363566709641068, -5.057935498227281],
            [-9.366655470613257, -5.063891123815286],
            [-9.37489374166211, -5.07213097489454],
            [-9.380742524249456, -5.073822611626683],
            [-9.379868265153629, -5.077914317390972],
            [-9.381949860350526, -5.0807953938744115],
            [-9.381377996456353, -5.0856766754685605],
            [-9.385695850735852, -5.0884350047459055],
            [-9.387592584966667, -5.092725042330525],
            [-9.381743117094004, -5.103845572841384],
            [-9.382782903360834, -5.111529628819861],
            [-9.381247151650202, -5.114173997773119],
            [-9.384807811233697, -5.123685732252149],
            [-9.38945721337159, -5.122537562427057],
            [-9.391743879639346, -5.126651189842756],
            [-9.387952521129039, -5.133698552123381],
            [-9.385084831968612, -5.136115101454789],
            [-9.379022554001779, -5.151890183022363],
            [-9.380225977343548, -5.157038794831189],
            [-9.374734514963468, -5.157286040235649],
            [-9.37333231109404, -5.161981611217555],
            [-9.374324634725657, -5.167834130912757],
            [-9.368151946951574, -5.170324034170689],
            [-9.363659620930706, -5.175204915453724],
            [-9.359622815643235, -5.175842550860511],
            [-9.355921925638937, -5.174414280120567],
            [-9.351477070829496, -5.176824182940385],
            [-9.350163423092564, -5.180396955886547],
            [-9.344884016387315, -5.1875010771181325],
            [-9.337137929643882, -5.185868357414367],
            [-9.334984608213029, -5.1839784532564845],
            [-9.329893685535318, -5.186840764252934],
            [-9.328633289087987, -5.195501019927706],
            [-9.332916431301236, -5.19962221878303],
            [-9.333711967201564, -5.206306525237327],
            [-9.32949374930495, -5.21125449260846],
            [-9.327261427535685, -5.218348168876946],
            [-9.327482055571911, -5.2262706030793895],
            [-9.335396940261331, -5.233631954119586],
            [-9.336596621126528, -5.23695865717968],
            [-9.340572209042124, -5.239733018077833],
            [-9.338784490716485, -5.243533157924863],
            [-9.34085745368392, -5.253362813472218],
            [-9.339698112999011, -5.263065993119533],
            [-9.34111487576385, -5.266323064603038],
            [-9.340108868408766, -5.2724055672072305],
            [-9.341118964716577, -5.283181903303404],
            [-9.338782402725677, -5.2867021621974635],
            [-9.335505291962324, -5.287411134695441],
            [-9.330317885026256, -5.291689030603896],
            [-9.32854336565389, -5.298368653978731],
            [-9.324347635599564, -5.308578997847558],
            [-9.324603653865637, -5.31197950034933],
            [-9.321394423686964, -5.314597264798197],
            [-9.323167134500505, -5.318012001071365],
            [-9.327816885326156, -5.33368736799651],
            [-9.325565258439983, -5.335883740667071],
            [-9.322520492024243, -5.351299629756081],
            [-9.318603623229373, -5.357031157662234],
            [-9.315074624733978, -5.35776992037308],
            [-9.30789396100015, -5.362997420432908],
            [-9.306719073967173, -5.369802492589783],
            [-9.306987182426157, -5.378046121060364],
            [-9.308609909332773, -5.38228542586398],
            [-9.307424437142462, -5.386973081446752],
            [-9.311206530092448, -5.393364819699297],
            [-9.310514547689118, -5.397984389685682],
            [-9.314061676187253, -5.405285816235838],
            [-9.311466308506487, -5.415045385626206],
            [-9.309339675697794, -5.416043351267389],
            [-9.309569171920872, -5.420521637949163],
            [-9.31271259623661, -5.421590995431082],
            [-9.314762219672597, -5.427290641182868],
            [-9.314445716383808, -5.438180998489263],
            [-9.316111917333766, -5.444028557585742],
            [-9.323317167787822, -5.448548602446534],
            [-9.325479819773406, -5.460276469019148],
            [-9.323003690456162, -5.467082857194681],
            [-9.323581209318624, -5.4733648487314595],
            [-9.325393791052917, -5.479602233294876],
            [-9.33094886657931, -5.4868735947645435],
            [-9.330534057952017, -5.492689560889455],
            [-9.334687503739932, -5.497187671094745],
            [-9.334238046933335, -5.504986091949641],
            [-9.336647411717852, -5.50804993787962],
            [-9.3353527801806, -5.5123994660506295],
            [-9.327441687761189, -5.514994176506335],
            [-9.32318473042958, -5.5187413820434035],
            [-9.235155967092576, -5.546801506514677],
            [-9.239399239443237, -5.546564359975229],
            [-9.36846831463355, -5.5309843724524415],
            [-9.497535026307984, -5.515383854349824],
            [-9.508286372455464, -5.601770218296311],
            [-9.580567792643823, -5.592974001758948],
            [-9.722641229489989, -5.574990586151212],
            [-9.762525620366905, -5.570029175910065],
            [-9.765102023632426, -5.5870827072651705],
            [-9.802866200447678, -5.87721134698767],
            [-9.819400354678434, -6.003388349139572],
            [-9.808541816451157, -6.004791956743833],
            [-9.83647674412926, -6.218515008063317],
            [-9.921901756828014, -6.207641004065315],
            [-10.094226049834594, -6.1855019586474045],
            [-10.088887992550537, -6.144163374386486],
            [-10.07898410820605, -6.070436275967568],
            [-10.06575791575121, -5.9713415500359615],
            [-10.076661542866793, -5.969899368460637],
            [-10.07196180444589, -5.933032407904692],
            [-10.066586113147283, -5.893097370161322],
            [-10.064541066864189, -5.883402968599744],
            [-10.060393180085295, -5.851743683878454],
            [-10.021341489782557, -5.559276542671173],
            [-10.018353383701857, -5.53688602480259],
            [-10.109595058748809, -5.524881163115319],
            [-10.097754136144339, -5.438376380146227],
            [-10.132963268243195, -5.433569748137295],
            [-10.173768944265856, -5.428437633152774],
            [-10.269126457503488, -5.41571190624638],
            [-10.246919509560353, -5.242947506088771],
            [-10.406271297758622, -5.220665706554359],
            [-10.400962318404844, -5.182098383840862],
            [-10.37912508016368, -5.023439445500565],
            [-10.366552966737945, -4.932081245026099],
            [-10.362793963602945, -4.9078017053920115],
            [-10.34700396489143, -4.7925540596340435]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.38241141695944,
          "lat": 32.738887912724955
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35017"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00915980"
      },
      "bbox": [
        -10.406271297758622, -6.218515008063317, -9.235155967092576,
        -4.7925540596340435
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.738815108434473, -2.318310462482464],
            [-7.739691778958842, -2.3252559568066706],
            [-7.737535051609702, -2.325527737075131],
            [-7.740676303578183, -2.3542026183300258],
            [-7.744916237238194, -2.3934525523260954],
            [-7.749232815749156, -2.4120618407538266],
            [-7.7509823059886624, -2.4292454776997143],
            [-7.773859573503014, -2.4268742942341897],
            [-7.769352063728156, -2.4303133023791554],
            [-7.76527903659064, -2.4314838665675804],
            [-7.762062003642839, -2.437097897696036],
            [-7.75313572827632, -2.44205158737426],
            [-7.752701212132685, -2.4457667456777896],
            [-7.7469858487264425, -2.4510384764824797],
            [-7.737258286411774, -2.454492495238077],
            [-7.735569063776996, -2.4581886626420526],
            [-7.725514247476481, -2.45981243688255],
            [-7.71584910168192, -2.4587492233643906],
            [-7.7099959615768165, -2.4592989374641387],
            [-7.702221491201769, -2.4616812289820933],
            [-7.701767565688028, -2.46415256423024],
            [-7.695846322814515, -2.4633131456924526],
            [-7.694192868184762, -2.464558443568242],
            [-7.69899908752192, -2.4708881002582324],
            [-7.6994259486771295, -2.47649241212879],
            [-7.70188187256449, -2.4820176557775624],
            [-7.7058657286979635, -2.484201704333434],
            [-7.711924666891316, -2.4848918396678097],
            [-7.71645662810719, -2.4938874527335866],
            [-7.716169319957537, -2.498646718053996],
            [-7.720011961792909, -2.5018856771282043],
            [-7.727345146062023, -2.5104787054557214],
            [-7.732074668462806, -2.5113694590267888],
            [-7.734318902446733, -2.515587175437286],
            [-7.740809549781054, -2.519823422769527],
            [-7.754850303416437, -2.521990348551201],
            [-7.758645790324985, -2.528328461776452],
            [-7.763546804772378, -2.5291278847401792],
            [-7.766572015314011, -2.5303662658304598],
            [-7.7678675850542165, -2.51462601136727],
            [-7.769529801033988, -2.514337563944757],
            [-7.773392670201546, -2.504050288814676],
            [-7.785284000433771, -2.4901780698515217],
            [-7.798088894574757, -2.4833547603754274],
            [-7.817426205205192, -2.47126993961032],
            [-7.828334701173386, -2.469204265374879],
            [-7.833112113069823, -2.464404877208949],
            [-7.84206647645962, -2.4591780665464467],
            [-7.843090010986285, -2.4686061092921494],
            [-7.846724837974821, -2.4636852123617974],
            [-7.853086915171874, -2.4613258180346285],
            [-7.863222574146423, -2.465376422746845],
            [-7.874595065521769, -2.46360303119059],
            [-7.877920209965645, -2.4641834201014663],
            [-7.885902767568864, -2.4599646433026003],
            [-7.89052647237849, -2.451783145157337],
            [-7.890164125897503, -2.4445533007155436],
            [-7.888936828135168, -2.4424810554347673],
            [-7.8748340253653355, -2.444005938569827],
            [-7.861537501549039, -2.322431475167353],
            [-7.8601279585217165, -2.3114167407313615],
            [-7.849264749208387, -2.312767650131097],
            [-7.850299159957545, -2.3199837889092536],
            [-7.821537959774407, -2.323254961077635],
            [-7.808802609235754, -2.3254860301527738],
            [-7.793971090004584, -2.326432734260547],
            [-7.794408126246505, -2.320179164207004],
            [-7.7811355749005315, -2.321715508800478],
            [-7.779671782436909, -2.30671682499955],
            [-7.765423780837825, -2.3088497063459292],
            [-7.750936682516783, -2.3104833676861514],
            [-7.751709700293797, -2.3177860211725654],
            [-7.738815108434473, -2.318310462482464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.3073388508171, "lat": 35.86929819230673 },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35028"],
        "coty_name": ["Los Alamos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Los Alamos County"],
        "coty_fp_code": "028",
        "coty_gnis_code": "01702366"
      },
      "bbox": [
        -7.89052647237849, -2.5303662658304598, -7.694192868184762,
        -2.30671682499955
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.3278191063798666, -2.458074743652034],
            [-7.246163613000834, -2.46639406646899],
            [-7.239483020064021, -2.467677559518917],
            [-7.171132675392272, -2.474447954973426],
            [-7.131313258361133, -2.4785144092177864],
            [-7.035737017916727, -2.4881184986003912],
            [-7.030111325618411, -2.488508138408632],
            [-6.945328397895102, -2.529596589833116],
            [-6.942702710368529, -2.528800846639887],
            [-6.93796735025005, -2.5323259957226187],
            [-6.934424547024423, -2.532024388551034],
            [-6.931474829286474, -2.5348030687802123],
            [-6.931345991682945, -2.539993741754757],
            [-6.9249003012875505, -2.542727945209379],
            [-6.915413620895857, -2.5432131516685432],
            [-6.9131298426280905, -2.5452214012228667],
            [-6.905645319653105, -2.5453947221570012],
            [-6.898115306617747, -2.5469543008352433],
            [-6.894800376044423, -2.550804868543677],
            [-6.891016517244627, -2.5513510179745156],
            [-6.884823279096334, -2.5549940785993512],
            [-6.88070956711658, -2.5600361747456115],
            [-6.878090418874786, -2.565662014075649],
            [-6.86905139508813, -2.5645331890853282],
            [-6.863807609965088, -2.566522057419018],
            [-6.860598667417779, -2.565452531442443],
            [-6.852010734842452, -2.5701565854746473],
            [-6.845886879895801, -2.570028959711016],
            [-6.839917068099795, -2.5772620908669897],
            [-6.834098351295045, -2.5807177154148513],
            [-6.829002683737404, -2.587689680234671],
            [-6.818797335054296, -2.5984171027974012],
            [-6.813955924806668, -2.6016123039292034],
            [-6.80703879366377, -2.6018559263636467],
            [-6.801965930330839, -2.6090643583882898],
            [-6.798097075365049, -2.6113270975914102],
            [-6.795404125932918, -2.6155696772406745],
            [-6.791581743498729, -2.6129182603003116],
            [-6.786807151543676, -2.6223784222202786],
            [-6.785319283376852, -2.629095035839239],
            [-6.7784054110643455, -2.6213834303769223],
            [-6.776835935392489, -2.6155925834890943],
            [-6.773624428904904, -2.6168963091574526],
            [-6.767468360329852, -2.614663984866422],
            [-6.651289481751267, -2.6188370426942105],
            [-6.486331407219937, -2.62856735363614],
            [-6.3972174307654095, -2.636286816899183],
            [-6.397571966797412, -2.6393115957044184],
            [-6.269090595951238, -2.652703243021605],
            [-6.256571110391921, -2.65328428653132],
            [-6.04596628131355, -2.6690976167721625],
            [-6.01300692837393, -2.67226689148644],
            [-5.977321283464305, -2.6751807960674543],
            [-5.939719526158592, -2.6578610447032074],
            [-5.90874049412372, -2.730218423391284],
            [-5.838321860354369, -2.8927692266424394],
            [-5.767884038872271, -3.055280077313446],
            [-5.765488133243671, -3.0558418088038275],
            [-5.698213833344073, -3.061365059959655],
            [-5.700881732774678, -3.094176637147985],
            [-5.705254494406514, -3.1464869718106394],
            [-5.712996261585523, -3.243612442406209],
            [-5.803068718080865, -3.235596091388397],
            [-5.878926035686545, -3.229386096332887],
            [-5.890718050434362, -3.227514046595248],
            [-5.889013227563341, -3.205690186369662],
            [-6.115245390732076, -3.310036633831942],
            [-6.108915248920274, -3.2361487496775263],
            [-6.209138016018343, -3.2272034188651832],
            [-6.294518571738948, -3.21967432749599],
            [-6.516794844821753, -3.199556582112158],
            [-6.726764633430614, -3.1800960665794324],
            [-6.833369775022739, -3.1699923386329574],
            [-6.948890983516152, -3.1588762844250997],
            [-7.049257504435014, -3.1490821828676108],
            [-7.0661270473866535, -3.323962710981844],
            [-7.186922259275276, -3.312158317479031],
            [-7.382838802414066, -3.2926991695718293],
            [-7.408336507024301, -3.2901208591142965],
            [-7.391217768428846, -3.115807788506636],
            [-7.382383022823648, -3.0269464760645723],
            [-7.3837138280067265, -3.026744314224493],
            [-7.367797320849502, -2.8663428219158376],
            [-7.3545397947124425, -2.7379368666037003],
            [-7.354735585361265, -2.7364831903507465],
            [-7.35157609916953, -2.705726822388561],
            [-7.351197159327224, -2.6992396105017877],
            [-7.348646003967099, -2.6768402885443328],
            [-7.346821744197465, -2.676016036128782],
            [-7.342531508343755, -2.5959487906915544],
            [-7.3344475450288575, -2.517266648710538],
            [-7.33524790580488, -2.5172099118556797],
            [-7.3278191063798666, -2.458074743652034]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -104.8158078299481, "lat": 35.48050812271177 },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35047"],
        "coty_name": ["San Miguel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Miguel County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00929114"
      },
      "bbox": [
        -7.408336507024301, -3.323962710981844, -5.698213833344073,
        -2.458074743652034
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.78733466540236, 5.563790257462832],
            [13.857380469328303, 5.576695089157061],
            [13.849945045169996, 5.609344120960155],
            [13.837517231889478, 5.66602840429202],
            [13.896486631586953, 5.677872522702939],
            [13.918741182732989, 5.6821605983782675],
            [14.007629495333598, 5.699748922666239],
            [14.006766758075178, 5.704781046638611],
            [14.086774364237211, 5.720871764978472],
            [14.092860897604494, 5.694101193741501],
            [14.182834400225888, 5.7125507387225465],
            [14.213512905283132, 5.719070355589856],
            [14.220658724068942, 5.685082160528239],
            [14.235959902696147, 5.611137698549792],
            [14.241967402600098, 5.581632818013372],
            [14.235275908010724, 5.578909328144399],
            [14.232355579951738, 5.5751552278675565],
            [14.231481586156741, 5.567531392133277],
            [14.232801792942917, 5.563559829379453],
            [14.23911524366529, 5.550594754443772],
            [14.242189530906838, 5.545540913149459],
            [14.242603924270513, 5.541720191818572],
            [14.24008136411885, 5.53633995277172],
            [14.243349702498382, 5.530525072912894],
            [14.242481582467665, 5.5275710097340625],
            [14.243992604022711, 5.522395141495631],
            [14.24644880207466, 5.520369757781398],
            [14.245669502456309, 5.516628452056231],
            [14.24786604842857, 5.509849903406432],
            [14.247159942320334, 5.506569739347883],
            [14.250214851983893, 5.498625854492321],
            [14.25184977218706, 5.491645592011762],
            [14.250613645563165, 5.4886117183651875],
            [14.251535582302354, 5.481705896992412],
            [14.256297967069736, 5.477237969529011],
            [14.257984976427833, 5.473795012688374],
            [14.225355835579606, 5.466774624859707],
            [14.201903342075024, 5.462098948638032],
            [14.14960393507931, 5.451088884752866],
            [14.149876639664209, 5.449489681390095],
            [14.070603644524123, 5.433310350487739],
            [14.024010470051572, 5.424254935844484],
            [14.014153544125934, 5.421970776706208],
            [14.010376802381261, 5.409785910528109],
            [14.00824142054521, 5.406503381822239],
            [14.002157866192807, 5.390388708884804],
            [13.999448587100767, 5.376372095777469],
            [13.997112412258115, 5.3559950735901225],
            [13.997588448952826, 5.3457741104050225],
            [14.000665091570616, 5.324016254611546],
            [13.993731212238016, 5.322541623229267],
            [13.995879419013765, 5.31843969236529],
            [13.99566778523658, 5.3131274576708],
            [14.0120964563951, 5.232706768168323],
            [13.955044037421974, 5.221877841680425],
            [13.922628207163765, 5.216012314561807],
            [13.909888679719682, 5.284019606395323],
            [13.910155620513269, 5.288761386978026],
            [13.907399191111356, 5.307990663611836],
            [13.886312641214495, 5.304157061145211],
            [13.826806803323205, 5.293929362370992],
            [13.81292860561321, 5.340218456460825],
            [13.809716328438476, 5.347639102417233],
            [13.808873989635599, 5.352247587947125],
            [13.804066625416748, 5.369536801804636],
            [13.799946356956253, 5.38178468278423],
            [13.816782267763077, 5.384861603251525],
            [13.799308556292035, 5.474361107968517],
            [13.825095420375721, 5.479456069094702],
            [13.821144456739612, 5.488022574637397],
            [13.82634517357231, 5.490355521210657],
            [13.825820541106395, 5.494936315091385],
            [13.821774184314442, 5.495845368557991],
            [13.819668139096704, 5.4991248713913095],
            [13.822073831982292, 5.504381937625697],
            [13.817115697857359, 5.510765104284101],
            [13.81701284681488, 5.518169523604323],
            [13.815013123051223, 5.521788906929884],
            [13.810054491535226, 5.523439966496853],
            [13.810215589703775, 5.530835400952943],
            [13.804809326131585, 5.540210539957122],
            [13.80585318562789, 5.544425929024186],
            [13.803863660517685, 5.548185803655506],
            [13.799792726853601, 5.5506542759801665],
            [13.798412489875284, 5.557923025965785],
            [13.794341965518237, 5.556391933665009],
            [13.789922032880806, 5.559607561951376],
            [13.78733466540236, 5.563790257462832]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.29978586246115,
          "lat": 42.852843100704426
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36069"],
        "coty_name": ["Ontario"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ontario County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00974133"
      },
      "bbox": [
        13.78733466540236, 5.216012314561807, 14.257984976427833,
        5.720871764978472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.601116299823648, 6.008648434099067],
            [16.601818375638175, 6.016015117940872],
            [16.601313152833054, 6.0215678365408865],
            [16.603828063831397, 6.02667808261468],
            [16.60742829010383, 6.0304154822998015],
            [16.60805618196538, 6.036839639635755],
            [16.604884862226513, 6.04626854083842],
            [16.598869846750574, 6.056526812790528],
            [16.59226019349749, 6.064620282717282],
            [16.58634767451341, 6.079382419556996],
            [16.584097859147413, 6.082045400917185],
            [16.583662582581045, 6.090361258718702],
            [16.582061676291907, 6.0988057049360505],
            [16.57576997902805, 6.104494640315412],
            [16.569963391011704, 6.113915552279389],
            [16.5686039918899, 6.122308668906213],
            [16.56941175040518, 6.133706329868975],
            [16.576994249858757, 6.150521415694907],
            [16.578081995918854, 6.157518036438095],
            [16.583317176858618, 6.163817214992942],
            [16.59062590464812, 6.166730678326535],
            [16.593364638874053, 6.169308200245977],
            [16.601097505550584, 6.17108196059214],
            [16.7234170696296, 6.203824110670927],
            [16.72278515709672, 6.210497953215433],
            [16.7283232450262, 6.214366087854243],
            [16.73251923110949, 6.220063712908624],
            [16.736921068832462, 6.221404683430096],
            [16.742151265645397, 6.218948110488788],
            [16.747615936217993, 6.222814827649615],
            [16.758555092887626, 6.221031790315499],
            [16.762898758844067, 6.221562197058874],
            [16.76619495121468, 6.217882834345818],
            [16.77309798061102, 6.218852894990872],
            [16.773389713591726, 6.214990290559287],
            [16.781921201673658, 6.217367283357057],
            [16.848339800768446, 6.233019813707802],
            [16.85832403752625, 6.187686188104525],
            [16.87149820224348, 6.125169840636767],
            [16.866579156434458, 6.124681058401],
            [16.86871488308419, 6.110835119326239],
            [16.87255658167878, 6.105305027487333],
            [16.87211084292984, 6.099199357373017],
            [16.870302813781333, 6.092463025852894],
            [16.893911768776178, 6.040627719186864],
            [16.902060924292833, 6.042522196775324],
            [16.89919581992571, 5.925154702651294],
            [16.895985226551087, 5.798022559834962],
            [16.877757795523692, 5.791179558342979],
            [16.79466903002889, 5.757916109453575],
            [16.75740337318361, 5.74218899311783],
            [16.72061633248091, 5.727050198507847],
            [16.631266945773522, 5.692085860992681],
            [16.59957107136973, 5.679951572363804],
            [16.596428388001506, 5.686826361820279],
            [16.593342969485263, 5.698658014333234],
            [16.59295397464668, 5.704857788717292],
            [16.595464216782975, 5.721789401273664],
            [16.600795522168255, 5.739738578100577],
            [16.601354902253377, 5.752418072004214],
            [16.59929539074981, 5.766818686023137],
            [16.598144537588006, 5.785113749334927],
            [16.595679561915688, 5.794780096786853],
            [16.58974144450962, 5.804178047128825],
            [16.58372182799461, 5.816745751936763],
            [16.58148212577403, 5.826093970987725],
            [16.583116485197564, 5.845313294138775],
            [16.582669421998688, 5.852823045457299],
            [16.58358412748769, 5.863431927151163],
            [16.585681193376036, 5.874116441412117],
            [16.59075350633994, 5.882729070793402],
            [16.59333549234852, 5.890442018391959],
            [16.59659767779614, 5.903768991534719],
            [16.60089727618889, 5.916829124810137],
            [16.602180669998194, 5.92426657784115],
            [16.59935633794716, 5.932307758246666],
            [16.59934297015969, 5.952243508738461],
            [16.602853909571838, 5.9600414398426675],
            [16.601201196945585, 5.976163355000833],
            [16.601667820829114, 5.982651576160594],
            [16.600263840075183, 5.988488923274272],
            [16.60024741207784, 5.9965274652384],
            [16.601116299823648, 6.008648434099067]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.50971517320264,
          "lat": 42.711060968712836
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36083"],
        "coty_name": ["Rensselaer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rensselaer County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00974140"
      },
      "bbox": [
        16.5686039918899, 5.679951572363804, 16.902060924292833,
        6.233019813707802
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.81193691335464, -1.2771767341724631],
            [11.87233408404559, -1.26910409391499],
            [11.936148152496818, -1.2659724801190404],
            [11.961256536920281, -1.2636398639288497],
            [11.98265588932225, -1.2612414330173873],
            [11.9986703576767, -1.2601256451794316],
            [12.051989587307812, -1.2540717361472706],
            [12.068933250417876, -1.2513908614775082],
            [12.07345820575552, -1.2799476146686832],
            [12.076034875048274, -1.2731830773803516],
            [12.078323437215975, -1.2736231927384178],
            [12.079469462105363, -1.2805704377585811],
            [12.078072284511741, -1.2834727671085286],
            [12.080032116942384, -1.2869668488983106],
            [12.084450679420126, -1.2909755762268131],
            [12.089059792162542, -1.297785801534069],
            [12.093541550392777, -1.3005422666691302],
            [12.097429803982456, -1.3055807460149],
            [12.100730912785535, -1.3177918398640247],
            [12.105303505112309, -1.3263229786003974],
            [12.119286729783532, -1.3395046085018552],
            [12.126509425596366, -1.3442236624578616],
            [12.130231283521276, -1.3536799536155937],
            [12.13418597599588, -1.3539478631890436],
            [12.138828653198996, -1.3562103515626809],
            [12.143509246849737, -1.362633118356743],
            [12.14727977409882, -1.366085415899095],
            [12.152663989938127, -1.3689668876865133],
            [12.156763433962988, -1.3782550534595508],
            [12.162007672045466, -1.3858105656163968],
            [12.162416363328616, -1.3913503332035948],
            [12.164323528455194, -1.3945129549254185],
            [12.162118785711929, -1.3993660481938142],
            [12.164284076434694, -1.4045301771709164],
            [12.16999759450259, -1.4115553949100275],
            [12.173237193019416, -1.4127332971869775],
            [12.18002806494709, -1.418150269804928],
            [12.182234887087612, -1.4211676239615831],
            [12.181800591825436, -1.4250087627834667],
            [12.184766575097624, -1.4305691654688644],
            [12.183462660831148, -1.4368026638919495],
            [12.179766588998, -1.4466766211371498],
            [12.1786400182573, -1.4501947894843847],
            [12.1695533008764, -1.4518262606389936],
            [12.164709188079563, -1.451631926407297],
            [12.160354100974232, -1.453316861876383],
            [12.154148044699049, -1.4486903467307484],
            [12.149863656080901, -1.4510602072818548],
            [12.14412451130557, -1.4500727120123584],
            [12.13887516261939, -1.4527066882699837],
            [12.133172415081019, -1.4501429585685344],
            [12.12808744144745, -1.4504332209368809],
            [12.127073364387153, -1.4453998098709226],
            [12.12467754638353, -1.4445287671262816],
            [12.121503061745397, -1.4472052429470668],
            [12.102258071514456, -1.469711665583457],
            [12.10246485795422, -1.5126187803477333],
            [12.105376680540372, -1.5138385010596032],
            [12.106271199579176, -1.5207518442009906],
            [12.10054116130416, -1.525360080033995],
            [12.103109548267051, -1.5410711473192895],
            [12.097419371876994, -1.543219869436541],
            [12.094892038381346, -1.550484790780825],
            [12.087691787066966, -1.5468340670456657],
            [12.086888168989033, -1.5446059552596334],
            [12.077247709167722, -1.5417050512810548],
            [12.071765983724111, -1.5410156335215568],
            [12.069341808087493, -1.5383682986256155],
            [12.064549634205617, -1.5379393192475264],
            [12.063315920650082, -1.540754192037042],
            [12.06713101193932, -1.5511640892794571],
            [12.064255714143693, -1.5551332871617702],
            [12.055090582228948, -1.5570028711852062],
            [12.056311180851592, -1.5679423448819165],
            [12.04709300914265, -1.5763235489569505],
            [12.043864077644969, -1.5758691844416939],
            [12.037824672830428, -1.5824587786645574],
            [12.036610686322158, -1.589611834552528],
            [12.030391456645985, -1.5873972034886346],
            [12.023846306204954, -1.5867728692701482],
            [12.021887742808165, -1.5922922970755826],
            [12.022641059515825, -1.6000995489158891],
            [12.015534575751108, -1.6001661577304211],
            [11.990383235696473, -1.5880673330323751],
            [11.985448668473888, -1.5904224041044766],
            [11.975226724322512, -1.5813932384574971],
            [11.963054762923486, -1.5766041191052058],
            [11.958104673306748, -1.573117780554683],
            [11.954231039693397, -1.574656128933267],
            [11.947809771933812, -1.5791339736576808],
            [11.939670167809759, -1.5684521171475923],
            [11.932236388513225, -1.56204491877119],
            [11.928063966917158, -1.5547888300445394],
            [11.923965413473402, -1.5501201626499623],
            [11.917545200012439, -1.5462947127728077],
            [11.909177939577306, -1.5378141791650608],
            [11.879122246765718, -1.5104368652634017],
            [11.801527547154857, -1.479737317947953],
            [11.799227903209825, -1.477339355689938],
            [11.79299756433945, -1.4773688188193852],
            [11.792080358819563, -1.470973520711942],
            [11.789649132167268, -1.469336460159998],
            [11.788706611795996, -1.4593013466944371],
            [11.796817625231983, -1.4557471200207632],
            [11.798313003867472, -1.450925000561882],
            [11.802986172318239, -1.4475520213153026],
            [11.804299315662812, -1.4393328927474935],
            [11.800872911614782, -1.4362260484018086],
            [11.805646468728764, -1.432278174768261],
            [11.805286603620686, -1.427891660223517],
            [11.802161025843784, -1.424587270654449],
            [11.804786153338398, -1.4221944102676098],
            [11.802349371105814, -1.4122481903125195],
            [11.806826683968614, -1.406469703824369],
            [11.81453579251636, -1.4027252792138991],
            [11.816154112760168, -1.3992431906666183],
            [11.815953854459423, -1.393791131206041],
            [11.814241803465194, -1.3917887148624486],
            [11.812051274500131, -1.3826900736804282],
            [11.812102340344575, -1.3756983100827618],
            [11.807346308763455, -1.3673395553614653],
            [11.80899946135735, -1.3625853607977816],
            [11.808103134536392, -1.3590862639892354],
            [11.802529717303623, -1.3478154007647534],
            [11.79769596293141, -1.3426435955219682],
            [11.79586034002067, -1.3326036555684184],
            [11.80206256522794, -1.3310310105829004],
            [11.801626007834262, -1.3281521846811104],
            [11.805021705807354, -1.318073492695103],
            [11.807557370560378, -1.3145540274540386],
            [11.807708129493836, -1.3106949012405915],
            [11.803551320585417, -1.3012844655665117],
            [11.804887131293185, -1.2980500076858053],
            [11.813003666650244, -1.296920613816309],
            [11.814966336236663, -1.2944788907165194],
            [11.810284710510532, -1.2800807670357168],
            [11.81193691335464, -1.2771767341724631]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.5003779552125, "lat": 36.43408299174539 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37009"],
        "coty_name": ["Ashe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ashe County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01008535"
      },
      "bbox": [
        11.788706611795996, -1.6001661577304211, 12.184766575097624,
        -1.2513908614775082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.687454573464299, -2.3280111846589775],
            [10.690175694272536, -2.3227350672810427],
            [10.695998439588909, -2.319287141523374],
            [10.697685477654282, -2.314758841173872],
            [10.704652792734969, -2.314491828698312],
            [10.714200276955557, -2.3126901241213087],
            [10.71886235349537, -2.3142646580900696],
            [10.72714486491742, -2.3109881048107495],
            [10.731661056149209, -2.311454251935128],
            [10.738967374002737, -2.306085220120184],
            [10.741095265098654, -2.305703227297529],
            [10.74571743277434, -2.290807637153695],
            [10.75125825911658, -2.287823405298607],
            [10.754407928626767, -2.2787352969868593],
            [10.753329817027867, -2.2747278707789658],
            [10.757443646811302, -2.2678682725368615],
            [10.767162714858179, -2.266311446892924],
            [10.782105586680558, -2.261256929409085],
            [10.788353277333337, -2.2622978077278892],
            [10.793006054286442, -2.2576164280856763],
            [10.801378082803094, -2.251528681586264],
            [10.80532613122044, -2.2499762721420944],
            [10.813165638956177, -2.2412117231917934],
            [10.813545612007193, -2.2389543542104993],
            [10.818197983264652, -2.234575270436674],
            [10.830337799711259, -2.235794192563793],
            [10.83893755923086, -2.2316601130871536],
            [10.844517082386258, -2.2346564923926135],
            [10.847477964391992, -2.234704625214166],
            [10.85234618575462, -2.2320035287009157],
            [10.872368158818865, -2.2369773902133168],
            [10.877588097158563, -2.237699238567197],
            [10.881886965288464, -2.2418432683488163],
            [10.889362801987259, -2.2406153285480315],
            [10.895241025118, -2.235671464129663],
            [10.901602044853265, -2.2258579494259463],
            [10.905040047867953, -2.2224595680463457],
            [10.91012909753158, -2.2196488443358557],
            [10.915825197030538, -2.2255079280421515],
            [10.920656198728723, -2.23399043682798],
            [10.92238878172485, -2.242353844306513],
            [10.922765819505223, -2.2511282275567615],
            [10.919664239408354, -2.25343231367341],
            [10.922055136023628, -2.2601167558404494],
            [10.920577414452513, -2.263141281553707],
            [10.924198222208586, -2.264689584705619],
            [10.925034847981776, -2.2678222137197253],
            [10.929380449281291, -2.2707278856114548],
            [10.933591385141543, -2.2682326132410613],
            [10.937924903461994, -2.26355092794505],
            [10.945481065542355, -2.262372813747449],
            [10.9477507812628, -2.2602886288845694],
            [10.952654209459181, -2.261542150032352],
            [10.955316717421985, -2.268517091234567],
            [10.96287600876822, -2.2772425968837138],
            [10.964769582957025, -2.284878507089012],
            [10.962388493300603, -2.28933195245015],
            [10.97001015903208, -2.2952590867556757],
            [10.973580437646431, -2.300723216033572],
            [10.973137821703858, -2.3087833855448214],
            [10.975418131734102, -2.312636694938488],
            [10.975653995873053, -2.318315478298072],
            [10.980519160365876, -2.322422084630074],
            [10.98877593967337, -2.324302978118789],
            [10.986153839991212, -2.329986377026492],
            [10.994812729000373, -2.3341317840569373],
            [10.995635517599975, -2.3393412077049116],
            [11.000989551790978, -2.343654684650936],
            [10.999832925141366, -2.349646861818993],
            [11.00575494015903, -2.3561775610901154],
            [11.007693217363101, -2.3627077606819884],
            [11.009961234041928, -2.365704802746573],
            [11.018735415830392, -2.3622974750382246],
            [11.021420605985488, -2.366177775381882],
            [11.022965565004117, -2.381606834466197],
            [11.028498373730505, -2.3816115795604076],
            [11.035442855320518, -2.3757526425671327],
            [11.03848183573281, -2.3770414324412132],
            [11.042463606166521, -2.373132510212201],
            [11.046468955472822, -2.3723359298306845],
            [11.05160437068552, -2.366780346925473],
            [11.05533290880309, -2.3692304733611276],
            [11.056351643311482, -2.3760521146726896],
            [11.062091027202486, -2.382481429190988],
            [11.064733916647599, -2.3908015555563695],
            [11.067393968897301, -2.3949497056684135],
            [11.08018351465369, -2.3999490180599072],
            [11.08334990960917, -2.40217324110651],
            [11.08728101956945, -2.4081219307769137],
            [11.086670498094433, -2.4122679201097346],
            [11.09347762994181, -2.4138480317028805],
            [11.098342548626007, -2.421668838375596],
            [11.093523734686224, -2.4277506785409204],
            [11.090752465087816, -2.434906576700756],
            [11.09419087283773, -2.4368704983920826],
            [11.102153837111535, -2.4485020867565557],
            [11.100679391431475, -2.4551935485971725],
            [11.096772970307697, -2.4582280060764656],
            [11.093322345775762, -2.463000078537098],
            [11.095354222016098, -2.4708729850223388],
            [11.092761729458267, -2.4786363414034995],
            [11.09188442950302, -2.4848069647975044],
            [11.093999851849231, -2.4866944046377153],
            [11.091641229598663, -2.493773327730365],
            [11.092623905295568, -2.496292428476227],
            [11.088095718519641, -2.508105743323081],
            [11.086250767874937, -2.522879830985894],
            [11.094312212761738, -2.532108118278872],
            [11.097329136809144, -2.5339407425374123],
            [11.100760486481215, -2.545841850914823],
            [11.103660530602431, -2.551246573081818],
            [11.115149719358072, -2.5568670532488054],
            [11.117208400276036, -2.5565381383250902],
            [11.12656941750134, -2.562785791066976],
            [11.132138484242173, -2.561520792938794],
            [11.135216475245374, -2.563696720698159],
            [11.133337878642768, -2.574623086877605],
            [11.137022553522089, -2.5793427382974112],
            [11.133507937598687, -2.5805031220721912],
            [11.131651287021542, -2.583768691546],
            [11.126371850327553, -2.5859698226080208],
            [11.123387432928729, -2.592557063399651],
            [11.11645764462935, -2.5959287587178044],
            [11.114386724104136, -2.6009160305859185],
            [11.110912565957538, -2.6045566454760194],
            [11.111139567377055, -2.6074811589729694],
            [11.106983634127749, -2.6103650656186046],
            [11.105638656769178, -2.6182777888393742],
            [11.105829488827661, -2.624338448747099],
            [11.102820624534194, -2.6275012219858023],
            [11.102297578385782, -2.6333572124884626],
            [11.10000870368765, -2.6356957134939094],
            [11.100169313464223, -2.639206283992584],
            [11.097888252163816, -2.6449289766005193],
            [11.090530050003075, -2.6499077877449637],
            [11.09234737942147, -2.6542881135789784],
            [11.090246334136564, -2.6602853485341202],
            [11.08560942576164, -2.6632659735156743],
            [11.084780644776828, -2.6719477058463923],
            [11.082399554929149, -2.672545052745453],
            [11.080574770516376, -2.6775487973131753],
            [11.069592442155654, -2.6786361724416468],
            [11.057437440780198, -2.685016768910059],
            [11.050139886666875, -2.6846530313237187],
            [11.045241435295257, -2.686540798223293],
            [11.04095782989126, -2.692375761081876],
            [11.036589546898089, -2.6954498064771237],
            [11.028054360123301, -2.698196623621307],
            [11.021069335849639, -2.7059608277294216],
            [11.016438995493575, -2.7091928340247],
            [11.015149544632164, -2.714083334846096],
            [11.012746575099895, -2.713978349546192],
            [11.006096196473788, -2.7039470565332846],
            [11.001542100731013, -2.702206328403688],
            [10.997278750203469, -2.7027700023422585],
            [10.986649710514333, -2.702401514098065],
            [10.985789023007587, -2.6973597495034354],
            [10.981891995546464, -2.693471387415422],
            [10.974399420882275, -2.695620656976361],
            [10.973008387154177, -2.6916691723238975],
            [10.974061526110766, -2.686232212952229],
            [10.971796114750836, -2.6775295166840967],
            [10.964686590445748, -2.668808652327382],
            [10.959554227247915, -2.6671586411011714],
            [10.959275711427322, -2.6615338174316165],
            [10.951562502444316, -2.6574626168911903],
            [10.950467156863867, -2.6528759032509854],
            [10.940419272735317, -2.6415635694587856],
            [10.932341667321058, -2.63830072036833],
            [10.923108453057539, -2.6368895309539515],
            [10.920501319473358, -2.638580064849853],
            [10.914444992766386, -2.6348416627803286],
            [10.912012746890035, -2.6307665364436015],
            [10.90025154456903, -2.6253416229122344],
            [10.899394082727072, -2.61549815594355],
            [10.89749646924609, -2.6115782328317887],
            [10.896900225292779, -2.6047414565488003],
            [10.889257728386292, -2.599665308906376],
            [10.885873712001603, -2.5951856818147414],
            [10.882147900491583, -2.596521655759971],
            [10.877335498082951, -2.5937254252233175],
            [10.871513960516817, -2.593175672416282],
            [10.865622502774206, -2.5890299114012456],
            [10.866167452350929, -2.5852414394025254],
            [10.864485384747093, -2.582296413412225],
            [10.864363037390689, -2.5761647597617574],
            [10.85584026750212, -2.57650491887783],
            [10.85515669845075, -2.570835454659273],
            [10.85343188270395, -2.5675196564368354],
            [10.845840140630493, -2.564570083630075],
            [10.837295589615195, -2.5634495475720853],
            [10.828976881632498, -2.5634488493659333],
            [10.820178650458786, -2.566400402566783],
            [10.815491881867933, -2.565734000936477],
            [10.814473186479935, -2.550807524164156],
            [10.810631036082157, -2.546325340295743],
            [10.81239651550535, -2.5412848465265445],
            [10.808453085377185, -2.5370899754519467],
            [10.798427027012217, -2.537388705154707],
            [10.79200228719689, -2.535472048791799],
            [10.792544631780725, -2.530587939462383],
            [10.787474629636417, -2.5234313590152366],
            [10.77992020262596, -2.524896857698684],
            [10.772050034416301, -2.5245235570773383],
            [10.769817590563056, -2.5210756525954814],
            [10.774017850973705, -2.515832218847178],
            [10.778688892392063, -2.5124339412817727],
            [10.778634498741702, -2.4959658729389145],
            [10.78349662633219, -2.4943070830763228],
            [10.782986363010423, -2.4878921779795737],
            [10.786638160396828, -2.4839273792447014],
            [10.78865002213128, -2.4782776498521457],
            [10.785411627939952, -2.474212818496562],
            [10.784602346545833, -2.4706329042438244],
            [10.781354212625105, -2.4683414162748556],
            [10.782099736966043, -2.4655798975362964],
            [10.779110917545774, -2.4583557014385464],
            [10.776556317986417, -2.454728751314691],
            [10.769689541618645, -2.4535525312431754],
            [10.76366625918281, -2.4505288933469234],
            [10.760713023613935, -2.443808958533911],
            [10.761251159612685, -2.4392312768866744],
            [10.75908000226482, -2.4371785641515866],
            [10.760426340129879, -2.4299418278334213],
            [10.764772681540563, -2.4219817151765466],
            [10.75941322371934, -2.416363128530156],
            [10.759678452718383, -2.411719481687761],
            [10.762528398813707, -2.4067446030812483],
            [10.761232836970763, -2.402617756867407],
            [10.757011378467354, -2.3982710666484968],
            [10.751716755856693, -2.394888612322938],
            [10.74703553453062, -2.3962268492928978],
            [10.739990937652475, -2.394503977580997],
            [10.738619997080292, -2.387066324438058],
            [10.743113811592604, -2.38108608526123],
            [10.743034831201658, -2.3763170140410765],
            [10.748666858276447, -2.369332498071858],
            [10.750220119066531, -2.364136546654743],
            [10.736066685277216, -2.356060567259865],
            [10.730377362884077, -2.3565294005239648],
            [10.727615013359008, -2.351867897001465],
            [10.722704554840291, -2.3464020498992424],
            [10.702495414730993, -2.3460950804358953],
            [10.695828541919836, -2.347993565086984],
            [10.689915033231596, -2.3470399553519403],
            [10.688449749435394, -2.33920021753494],
            [10.689205518887455, -2.333485450339403],
            [10.687454573464299, -2.3280111846589775]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.98221112307888, "lat": 35.55606514777368 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37087"],
        "coty_name": ["Haywood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haywood County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01008561"
      },
      "bbox": [
        10.687454573464299, -2.714083334846096, 11.137022553522089,
        -2.2196488443358557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.354953579577684, -0.6957382625548776],
            [15.364508549983675, -0.6961122226458403],
            [15.386277823009708, -0.6918295763885933],
            [15.409359452626994, -0.6865219955595218],
            [15.549133414768741, -0.6590252854452887],
            [15.549910940957128, -0.6641328199762195],
            [15.546003917118243, -0.6652121800475955],
            [15.54795996180558, -0.6692685592549089],
            [15.54532557654688, -0.6716660132590011],
            [15.54741058614905, -0.674879263848449],
            [15.551306580751545, -0.6719272979405796],
            [15.561994244208133, -0.678318403527429],
            [15.564095644956382, -0.6824572340800246],
            [15.562228212473652, -0.6858497456378979],
            [15.563295138798779, -0.6902867931494817],
            [15.561567455684159, -0.6958398420101148],
            [15.559250713109266, -0.6978865564115991],
            [15.554299655219777, -0.6975663241051134],
            [15.553142729480397, -0.7154590248279971],
            [15.550358446849769, -0.71887150903566],
            [15.546631729392535, -0.7204564758444678],
            [15.546710969518529, -0.72692576817596],
            [15.549956327026367, -0.7322167170940307],
            [15.548299212907832, -0.7345849437493005],
            [15.539313006583017, -0.7346612090484963],
            [15.537161240249176, -0.737792958701343],
            [15.541107936101689, -0.7421938960423141],
            [15.540632618805569, -0.7484243630496495],
            [15.543923515178408, -0.7559610289341673],
            [15.547194858465453, -0.7661724648641919],
            [15.547515131543431, -0.7733227389488374],
            [15.54926941939144, -0.7799941423576241],
            [15.55077565766147, -0.7909884098604514],
            [15.554980400052187, -0.7962347913748864],
            [15.567203233057702, -0.8035898687148811],
            [15.57674538478207, -0.8057411669303993],
            [15.586346239423014, -0.8091670354514948],
            [15.595604415103319, -0.8075781087511451],
            [15.599841190934264, -0.8083125281405119],
            [15.606436056261996, -0.8124362198141916],
            [15.614275353565233, -0.8112445421617233],
            [15.618378242064152, -0.8116581608221309],
            [15.629908559380144, -0.8146205147475332],
            [15.635055572478223, -0.8152847263163305],
            [15.643338431745887, -0.8143621142551896],
            [15.647862457908456, -0.8153536971591482],
            [15.659271066330424, -0.8216924193906611],
            [15.670598552403677, -0.820949791532404],
            [15.681131430955844, -0.8217756485732102],
            [15.684717903641774, -0.8206555488207347],
            [15.689734873226035, -0.8166662156418975],
            [15.695724602489038, -0.81800175664622],
            [15.701406233435598, -0.822811621253314],
            [15.707516417932304, -0.8235467125195396],
            [15.71128688011317, -0.8253571552033323],
            [15.71647200641596, -0.8309697620020627],
            [15.728794366891822, -0.8413718276663557],
            [15.734706995534065, -0.8475080135530857],
            [15.743218238080305, -0.851705192568881],
            [15.751944976364818, -0.859657583237067],
            [15.758514470961815, -0.8636943113334024],
            [15.76761260946887, -0.8658745370596649],
            [15.770692402881732, -0.8688790565261071],
            [15.775696553840536, -0.8822030429852776],
            [15.770215019962967, -0.8800519283510958],
            [15.769450808519041, -0.881986819181373],
            [15.773115907961278, -0.8875500585108986],
            [15.774747894523303, -0.8932649477585675],
            [15.76969216969365, -0.9001020284446585],
            [15.769368917674456, -0.911550758058826],
            [15.761216779159426, -0.9229774556579647],
            [15.761269990521498, -0.924742455139236],
            [15.670960470916052, -0.943801220598295],
            [15.619630351358301, -0.9545725551491321],
            [15.600753612482832, -0.9613536082445295],
            [15.588189807016915, -0.9626305750789379],
            [15.567349256741606, -0.9702010206092403],
            [15.555268664023284, -0.968560812480692],
            [15.538188271935006, -0.9750995645846507],
            [15.400562625325918, -0.9990144094715263],
            [15.379979108108516, -0.9992771158908302],
            [15.383169152929907, -0.9768709866441095],
            [15.389429121794265, -0.9249517357785312],
            [15.402315180471259, -0.7979115799985199],
            [15.401504889573983, -0.7945306331680204],
            [15.39632332104128, -0.7891294620468811],
            [15.394226716918684, -0.7814614114116977],
            [15.396690845019341, -0.7759268634774423],
            [15.40087544474445, -0.7712918403706167],
            [15.402218126194144, -0.7635494726647539],
            [15.404349157011035, -0.7602745749413947],
            [15.408225063165183, -0.7595890265896477],
            [15.40914498136381, -0.7555188081779178],
            [15.412880908643897, -0.7567166646014754],
            [15.41501347835096, -0.7547106341909013],
            [15.421255007632446, -0.753834019457373],
            [15.42339049381812, -0.757155925011571],
            [15.426676484826807, -0.7580741812407876],
            [15.430985225400324, -0.7535107152427197],
            [15.434007347133507, -0.7536240798097433],
            [15.434442752489359, -0.7491608203268985],
            [15.438426528474832, -0.749095430068689],
            [15.441498173537314, -0.7466847874364704],
            [15.442875319692336, -0.7418222186463493],
            [15.440433317698286, -0.7371754534702857],
            [15.441708943440517, -0.7344876583504684],
            [15.437119152281891, -0.7295349699577134],
            [15.43095349153562, -0.7318705803804508],
            [15.425786192673545, -0.7292046070188102],
            [15.42487405122683, -0.7243077063622911],
            [15.426383641059054, -0.7218252983155169],
            [15.425797961736341, -0.7173516698900833],
            [15.423117649150404, -0.7151324470137616],
            [15.416062133784205, -0.7123669484224228],
            [15.414429193931063, -0.7144909477103873],
            [15.404597116570013, -0.716191842513486],
            [15.3995041940657, -0.7156213950611308],
            [15.398062338548273, -0.7120461747804542],
            [15.393430503391627, -0.7122835361420834],
            [15.389568421835335, -0.7177900966236307],
            [15.385347255025152, -0.7141767043122117],
            [15.381588244786046, -0.7134644642933029],
            [15.371681299939732, -0.7142823785309338],
            [15.368686839265587, -0.7115913666027551],
            [15.368447940611048, -0.7029904189259184],
            [15.363949840943626, -0.6991527675246878],
            [15.36235742500513, -0.7007133889509883],
            [15.355514755459641, -0.6975501563143409],
            [15.354953579577684, -0.6957382625548776]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.98202612080017,
          "lat": 36.359120879533755
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37091"],
        "coty_name": ["Hertford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hertford County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01026127"
      },
      "bbox": [
        15.354953579577684, -0.9992771158908302, 15.775696553840536,
        -0.6590252854452887
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5378567083907875, 0.0448661704516648],
            [1.5379886641176557, 0.13520492674117787],
            [1.5373833832002781, 0.15503570637245678],
            [1.5708863906741504, 0.15351444957132027],
            [1.613788084318675, 0.1512414389215454],
            [1.669488792272, 0.14959267415416738],
            [1.7056807106846594, 0.1489446744765561],
            [1.7847394549393691, 0.14683354653394665],
            [1.8429945976903477, 0.14767412562925553],
            [1.8789760069973915, 0.1480650192884087],
            [1.9147449197841417, 0.14735545273876868],
            [1.914379026925074, 0.14705029246703324],
            [1.9135914453737428, 0.11729314765708686],
            [1.9136930580115945, 0.08750283182410652],
            [1.913370639088124, 0.07129741187455108],
            [1.911911109180538, 0.05757509809045679],
            [1.910342016945107, -0.03179541994083177],
            [1.9203729676577355, -0.031944703483863274],
            [1.920026649725024, -0.08422252824906254],
            [1.9195893490106337, -0.11963019770797884],
            [1.9624632890213207, -0.1201146602873991],
            [1.9618625473279467, -0.18919114576635584],
            [1.9618320976154275, -0.22250302719357515],
            [1.9640068548269354, -0.22266077485081073],
            [1.963854486602637, -0.2415799066660489],
            [1.9557587280876223, -0.24115744357701813],
            [1.955220371131956, -0.2370183151126413],
            [1.9506723535418944, -0.23597600830803103],
            [1.946926459764332, -0.2331962756953801],
            [1.9307911627511478, -0.23459185646311992],
            [1.929432856232842, -0.236652977676623],
            [1.9229927556184505, -0.23761400961527823],
            [1.9117198326107865, -0.23580833674322396],
            [1.9074211255180917, -0.23636534025944309],
            [1.9038366290143338, -0.23858266907210737],
            [1.8942912150124043, -0.23999568492286158],
            [1.891381563912525, -0.23935623891599914],
            [1.8848740864555704, -0.2426472415523969],
            [1.8810834764347912, -0.2404084277048698],
            [1.87983698675908, -0.24489339959185685],
            [1.8650132851715961, -0.2429810681333883],
            [1.859349353805987, -0.24537912337191709],
            [1.8538270267220975, -0.24000345607749293],
            [1.8482342052813572, -0.24272350879302862],
            [1.8461939157152263, -0.24114385972034288],
            [1.8415958388777034, -0.24273479747909477],
            [1.841868078889532, -0.23808694997076893],
            [1.838463185873555, -0.23373604011438978],
            [1.832145700523301, -0.23310524747378047],
            [1.828591521654766, -0.23103511674981084],
            [1.8247623092959369, -0.2356466699493871],
            [1.8200889621652074, -0.23580655735066164],
            [1.8153406653552315, -0.2414384046891309],
            [1.8132545379351899, -0.23858414646789844],
            [1.809051786973002, -0.23827417647911184],
            [1.8029447894701454, -0.2333508360980576],
            [1.800015125506164, -0.23500679736432986],
            [1.7921670705511044, -0.23068373957271535],
            [1.7908527846306093, -0.22751399119837773],
            [1.7838941967570447, -0.23311386385543695],
            [1.7769681375849482, -0.22667100830496564],
            [1.7738768220109578, -0.22679673259172783],
            [1.7723204473670018, -0.22068903499318857],
            [1.728111253790992, -0.22013996277203282],
            [1.6248895501036782, -0.21911628953807014],
            [1.6179388919089732, -0.21896191916881488],
            [1.5609160629715015, -0.21873842233100552],
            [1.5391032683771961, -0.2181840949627819],
            [1.5391524854769578, -0.212576871375543],
            [1.5381785657733629, -0.11827679099362651],
            [1.5383493043089909, -0.11464583952389751],
            [1.5377767575323258, -0.07391019630184857],
            [1.5378567083907875, 0.0448661704516648]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.35488722395203,
          "lat": 38.646993896416646
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29037"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00758473"
      },
      "bbox": [
        1.5373833832002781, -0.24537912337191709, 1.9640068548269354,
        0.15503570637245678
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5348687633870444, 0.3538001599875658],
            [1.5347669434999052, 0.37562702673753695],
            [1.5339684473667157, 0.42381851940964943],
            [1.5366593269164799, 0.4213054985168907],
            [1.5429558315208, 0.4204774228802809],
            [1.565748016116932, 0.4341921780315833],
            [1.5714612753872703, 0.4368099177434314],
            [1.578100073316455, 0.44209872431702896],
            [1.5858612007067034, 0.45413999529515164],
            [1.5922772552384548, 0.4586603108614515],
            [1.5998498120219338, 0.4609354680527849],
            [1.6109448956875785, 0.46282040767870525],
            [1.6193975808502503, 0.4624286978509142],
            [1.6277671077093165, 0.4576242814853652],
            [1.6397485163411225, 0.44287274227294654],
            [1.6412154686617788, 0.4369148850704536],
            [1.6458634500094533, 0.43253917978222745],
            [1.6617861889399907, 0.4433077419251363],
            [1.669560425187915, 0.4507520646347681],
            [1.6747440802204687, 0.4569395189027815],
            [1.678866536706395, 0.46415167711998884],
            [1.6881729174894295, 0.4758642311836831],
            [1.6906431272890043, 0.4781028183562713],
            [1.6923154030530607, 0.48826526427041034],
            [1.6901408418857307, 0.49468767646069084],
            [1.6850387824586142, 0.5056117030548368],
            [1.68636398458035, 0.5088638695250906],
            [1.6902495624134863, 0.5106455496005737],
            [1.6957108631109878, 0.5100307972565232],
            [1.6998266266357165, 0.5072733047544008],
            [1.7036956978536937, 0.5009789440916986],
            [1.7088478160606944, 0.4840644400450161],
            [1.715934489072572, 0.47743179472147346],
            [1.72043376405941, 0.4774889346268822],
            [1.72755133458941, 0.48447278599159266],
            [1.7336026863743654, 0.48804212912498673],
            [1.740017450836591, 0.49508060058496034],
            [1.7514761272035284, 0.5133605846958931],
            [1.7536375902961348, 0.5194205796336385],
            [1.754854699627196, 0.5283758395446763],
            [1.7574527079022808, 0.5363054961462889],
            [1.7644767825133347, 0.5466726510786137],
            [1.7756778483943811, 0.5526244634221453],
            [1.792947782285824, 0.5512097009066093],
            [1.8021191937268393, 0.5522084502029803],
            [1.8114894654104055, 0.5481252230515056],
            [1.8153053758527025, 0.5443741736504077],
            [1.8200733566558809, 0.5345979684208253],
            [1.8223504497081853, 0.5315173490188281],
            [1.8288069293225617, 0.5263652325128173],
            [1.8355867927328366, 0.5234148475995473],
            [1.839638500638882, 0.5227217664560737],
            [1.845513882339396, 0.5247240268336866],
            [1.8535896941067282, 0.5301925965960822],
            [1.8567902198831836, 0.5310937394829341],
            [1.8653807158139222, 0.5307898265632328],
            [1.8685861070275298, 0.5276052647467134],
            [1.8680790558884206, 0.5214079462224316],
            [1.8643159067867785, 0.5139686654241463],
            [1.8577782350624357, 0.5070267948199559],
            [1.8554805351968875, 0.5003227711677665],
            [1.8565587525328942, 0.49750297839789526],
            [1.8635309440759564, 0.4946960646627389],
            [1.8695065345411346, 0.4944555190253829],
            [1.886372912822286, 0.4921661786080784],
            [1.894323498965807, 0.4896882086259989],
            [1.8997274440465814, 0.48609463934570846],
            [1.904151155897177, 0.4805110635771313],
            [1.9058276324171455, 0.47652535226264725],
            [1.912309469029558, 0.46696709697524025],
            [1.9195067063355555, 0.46084267072589813],
            [1.9190577027683386, 0.4085230921416608],
            [1.9185865386796752, 0.3788528673008424],
            [1.9181328988213162, 0.330382706290004],
            [1.9181005278671424, 0.3037093246112309],
            [1.9176179366953507, 0.2985848911297119],
            [1.91694195572732, 0.27639726953079924],
            [1.916556889705394, 0.24370864930488542],
            [1.9168551940970573, 0.2323657064703261],
            [1.917278817778011, 0.2320307592611076],
            [1.9164066972877123, 0.18559351474219604],
            [1.915831132260934, 0.16801008058628247],
            [1.9147449197841417, 0.14735545273876868],
            [1.8789760069973915, 0.1480650192884087],
            [1.8429945976903477, 0.14767412562925553],
            [1.7847394549393691, 0.14683354653394665],
            [1.7056807106846594, 0.1489446744765561],
            [1.669488792272, 0.14959267415416738],
            [1.613788084318675, 0.1512414389215454],
            [1.5708863906741504, 0.15351444957132027],
            [1.5373833832002781, 0.15503570637245678],
            [1.5360999149105088, 0.24555737228883517],
            [1.5351613805201714, 0.290918226034501],
            [1.5348687633870444, 0.3538001599875658]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.34615669904736, "lat": 39.00847111347709 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29095"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00758502"
      },
      "bbox": [
        1.5339684473667157, 0.14683354653394665, 1.9195067063355555,
        0.5526244634221453
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3551168578955877, -1.7719679551231875],
            [2.353958401177456, -1.6983218901303616],
            [2.3970422398790703, -1.6979149779599096],
            [2.4400267168312766, -1.697851468982772],
            [2.53988896177726, -1.696226485771164],
            [2.569664954778934, -1.6959375349748307],
            [2.5700900584666013, -1.766085001946685],
            [2.5709815827435634, -1.8727706755316058],
            [2.6008605370741678, -1.8723685262874623],
            [2.600912981448865, -1.9159344131484926],
            [2.6006874188561184, -1.9600777309545216],
            [2.599220627924959, -1.9601061306146605],
            [2.5993158904661815, -1.9878359266007966],
            [2.5998652630015964, -2.0176990510508412],
            [2.6000125092363264, -2.050890344960169],
            [2.6003975826844288, -2.078147187702431],
            [2.6008959208407822, -2.134082229420346],
            [2.6012508204953066, -2.193792387163512],
            [2.5123610113599755, -2.196071182062483],
            [2.4483380160712334, -2.197447493422765],
            [2.387160704266452, -2.19904151094914],
            [2.3867235896918633, -2.1785091316288834],
            [2.386894499296494, -2.111079865416945],
            [2.3866670868078406, -2.067739756600744],
            [2.3872963876956055, -1.9596363349484665],
            [2.387213473935876, -1.8749275318057288],
            [2.356185430425978, -1.875177958167222],
            [2.3558965000742416, -1.8313564481789764],
            [2.355376317958414, -1.8090613050353117],
            [2.3551168578955877, -1.7719679551231875]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.45597972704986, "lat": 36.74692473020117 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29209"],
        "coty_name": ["Stone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stone County"],
        "coty_fp_code": "209",
        "coty_gnis_code": "00758557"
      },
      "bbox": [
        2.353958401177456, -2.19904151094914, 2.6012508204953066,
        -1.6959375349748307
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.663741149371793, 8.370593878060037],
            [-11.653212341901797, 8.370656137109654],
            [-11.650109250023375, 8.365437829853903],
            [-11.648159760070548, 8.350468952797858],
            [-11.648118255214195, 8.342723266533568],
            [-11.643618752326525, 8.330970049507696],
            [-11.640184464928147, 8.325017255188351],
            [-11.639102329373433, 8.317276442925403],
            [-11.640440533432441, 8.313182566888967],
            [-11.634548258924593, 8.301736863503471],
            [-11.636233000745507, 8.298362810523527],
            [-11.632521351101813, 8.290602496526576],
            [-11.63312326270535, 8.288921423041241],
            [-11.629013861625483, 8.284185859658159],
            [-11.627076254305118, 8.27270543407245],
            [-11.62918450772899, 8.263550163467317],
            [-11.625885096417406, 8.260035272650029],
            [-11.626641629876165, 8.256612445215668],
            [-11.624165874503916, 8.255001560598307],
            [-11.62654002753071, 8.248287563034184],
            [-11.624823666851862, 8.246441967881548],
            [-11.625741624705043, 8.238359153056557],
            [-11.628811334612877, 8.238190488600807],
            [-11.630487874793749, 8.225341581853558],
            [-11.625419072420911, 8.212223478156242],
            [-11.621886400157909, 8.210063756719395],
            [-11.618466950078645, 8.205508079549881],
            [-11.61657047947596, 8.198413412476999],
            [-11.613118170344643, 8.192808872480876],
            [-11.613235039802992, 8.189204183545632],
            [-11.605905551909162, 8.182370669620607],
            [-11.60102766955635, 8.178890634178101],
            [-11.591672407068872, 8.175571798192964],
            [-11.589984635014812, 8.178863105426554],
            [-11.590328411623341, 8.188416831608217],
            [-11.583890338431988, 8.194654231298962],
            [-11.580325862336764, 8.199912360028696],
            [-11.578092301870294, 8.20949657552515],
            [-11.575469904617808, 8.212196220227831],
            [-11.572460839512951, 8.218906955228885],
            [-11.567946632665011, 8.220173045516074],
            [-11.566120916722042, 8.223980521059278],
            [-11.56310354932329, 8.22588513242369],
            [-11.554902228169645, 8.2220245472935],
            [-11.554002687074789, 8.218946475902392],
            [-11.54928657300421, 8.218347875068249],
            [-11.545399015655484, 8.215766944293733],
            [-11.536238201911882, 8.226385662996957],
            [-11.53151849868502, 8.228271940052279],
            [-11.528748705832996, 8.223330815779603],
            [-11.520744872078392, 8.222925061653601],
            [-11.510752898227558, 8.230089061218063],
            [-11.507140927811005, 8.235572010846372],
            [-11.49938813044106, 8.240799276274418],
            [-11.501787673840205, 8.247234325841402],
            [-11.496982252690398, 8.252298131407834],
            [-11.489269184412839, 8.252811624965398],
            [-11.483889122032487, 8.257928415934884],
            [-11.480053769835525, 8.264271243543558],
            [-11.474843657198775, 8.26795763287347],
            [-11.467981468781439, 8.270933785889433],
            [-11.464367319199523, 8.271396484302366],
            [-11.460251814022646, 8.268471277049548],
            [-11.456727012605205, 8.268182791810647],
            [-11.450747671261336, 8.270292281309812],
            [-11.443092249430816, 8.276221118639524],
            [-11.434865375121635, 8.27392391165657],
            [-11.42820983583952, 8.273779581999294],
            [-11.416360972482686, 8.268529647460241],
            [-11.408312035994475, 8.26829776430247],
            [-11.389166390904228, 8.263183739913476],
            [-11.38766033398403, 8.258724768609486],
            [-11.38494499007817, 8.257071615703598],
            [-11.38217661796275, 8.252192709503062],
            [-11.382812006399165, 8.24087002971923],
            [-11.383165606727703, 8.235594742067494],
            [-11.37633540999632, 8.2300236495729],
            [-11.370452240512249, 8.22864198095902],
            [-11.365366172262094, 8.221391764478417],
            [-11.362868996538351, 8.220250093197828],
            [-11.360310343229196, 8.215907937749598],
            [-11.356236542099694, 8.212592404386236],
            [-11.355418028609584, 8.207436046969452],
            [-11.346595140014008, 8.203307742027016],
            [-11.344353003902036, 8.199864041735081],
            [-11.345188640137257, 8.195632191919037],
            [-11.342685660139534, 8.19141817496755],
            [-11.338401532274792, 8.187925442078438],
            [-11.333509579201966, 8.187043679203558],
            [-11.334033281848303, 8.179465360510692],
            [-11.330321034764426, 8.176918733635333],
            [-11.326117121312548, 8.178388800098835],
            [-11.320981681403042, 8.175263630938817],
            [-11.315700600525835, 8.173646474027596],
            [-11.312403352688904, 8.170343996319195],
            [-11.30800940722079, 8.169828640470925],
            [-11.295692792263024, 8.163744554942758],
            [-11.288923439981508, 8.165755401542327],
            [-11.284599992211238, 8.163737782735456],
            [-11.27936227631142, 8.156712880247632],
            [-11.280737555177039, 8.15038638399894],
            [-11.27752648851081, 8.144663070753671],
            [-11.27031172675323, 8.139962086771988],
            [-11.266652140017047, 8.14448873128279],
            [-11.262882194792253, 8.14700799101463],
            [-11.257676460552224, 8.146757861779793],
            [-11.251888838182257, 8.1399320834202],
            [-11.250242396581598, 8.1355967713738],
            [-11.247179313840991, 8.132835939151418],
            [-11.23973958409976, 8.134024815969648],
            [-11.231880863590904, 8.130239215318266],
            [-11.228311096335414, 8.130749963633008],
            [-11.218299001535469, 8.12469223272823],
            [-11.210357934725216, 8.111506888020529],
            [-11.204283089556434, 8.106643710939986],
            [-11.199043573618166, 8.109513011578262],
            [-11.192848742040873, 8.108553979623458],
            [-11.19204235612175, 8.10125853429159],
            [-11.187204127175754, 8.098816337554132],
            [-11.18403309817805, 8.094708141898103],
            [-11.178729944665927, 8.091527345906568],
            [-11.178045553317835, 8.083387061324391],
            [-11.1804717149435, 8.077639329937737],
            [-11.175861352884242, 8.075792057555606],
            [-11.174056861804164, 8.071821685966684],
            [-11.175189921281637, 8.064373084683078],
            [-11.178641534932469, 8.060643759321318],
            [-11.181258445838942, 8.0550394378571],
            [-11.177378009573712, 8.048298270312362],
            [-11.17055279877672, 8.046042034763406],
            [-11.171881593130944, 8.041815312199734],
            [-11.175243119586343, 8.03977010246128],
            [-11.176078058523295, 8.036159855858333],
            [-11.173757917077083, 8.028324484182185],
            [-11.166997109752256, 8.022400045219342],
            [-11.167077321044438, 8.016469110644733],
            [-11.162381922934133, 8.01771944852701],
            [-11.156611597719001, 8.014542907471618],
            [-11.151275050609904, 8.014658919301782],
            [-11.150382033708588, 8.00645595733962],
            [-11.151472856218744, 8.002510009747777],
            [-11.150591233016058, 7.997028979580133],
            [-11.148652294590315, 7.993958789524165],
            [-11.15305916354507, 7.983695595277059],
            [-11.155758554323988, 7.9837579281525155],
            [-11.155695186282538, 7.972282039194335],
            [-11.15071027601111, 7.9661977438730025],
            [-11.150568230195054, 7.962572218854304],
            [-11.148624364439728, 7.960088068218464],
            [-11.149068964543703, 7.951189050400197],
            [-11.14743087463342, 7.949201017269201],
            [-11.15231147967354, 7.940428029969174],
            [-11.154863065992009, 7.93913461515472],
            [-11.157263585337333, 7.930447475563077],
            [-11.158401804140935, 7.918682934432114],
            [-11.16020494032941, 7.912684830547525],
            [-11.160085675138035, 7.908582538305529],
            [-11.161942023748155, 7.901303017353951],
            [-11.164173309163349, 7.896672087875825],
            [-11.169117927121192, 7.890984089525722],
            [-11.168419360350505, 7.887109352522324],
            [-11.169732244175302, 7.883374894646714],
            [-11.178842444308838, 7.875396395167922],
            [-11.177507081543064, 7.864530111048984],
            [-11.17894908395445, 7.860117735407776],
            [-11.178329705503623, 7.855568063332072],
            [-11.173155891336622, 7.853317304886757],
            [-11.172403591467845, 7.848115471342044],
            [-11.17461133490455, 7.841253535857628],
            [-11.174617407959673, 7.83553169780821],
            [-11.178330864042769, 7.83059923181236],
            [-11.17689056590326, 7.818719290560166],
            [-11.174965631557919, 7.818553061231874],
            [-11.16757955387233, 7.812290819358843],
            [-11.167073169242038, 7.809548438236421],
            [-11.160292441383032, 7.8027070938236935],
            [-11.160553025504457, 7.797113666240784],
            [-11.156192820261213, 7.79433821176389],
            [-11.151998373148059, 7.794505309609544],
            [-11.148047504463275, 7.791541588033428],
            [-11.144672203921823, 7.786883760481377],
            [-11.14585353581334, 7.782483908834947],
            [-11.142991877188997, 7.780660303627697],
            [-11.14207735012914, 7.775600361833888],
            [-11.136128453053647, 7.773860393332603],
            [-11.13396204535393, 7.77048339065962],
            [-11.129606744108129, 7.769985011946536],
            [-11.124781580061022, 7.762060628267501],
            [-11.117854804982336, 7.761112551497478],
            [-11.115312836684339, 7.762937656412848],
            [-11.112733346667412, 7.760273196634281],
            [-11.108750691424245, 7.7590836262006215],
            [-11.102123927597887, 7.76294526675726],
            [-11.090888331970817, 7.767081302862846],
            [-11.084797725516662, 7.76832793685957],
            [-11.079401537201795, 7.770624689701298],
            [-11.07643824633581, 7.768141583845444],
            [-11.056950511685827, 7.76331242468231],
            [-11.036911370697458, 7.710430262841013],
            [-11.044718946043679, 7.6675008100134185],
            [-11.040169878664832, 7.666712062082527],
            [-11.04257697084589, 7.65187297527631],
            [-11.057003252723486, 7.568199495652721],
            [-11.069947685411174, 7.4955112859238024],
            [-11.0844038401963, 7.411108404403318],
            [-10.998992628869539, 7.396264145949251],
            [-11.01428627375696, 7.310305386735018],
            [-10.914737661677941, 7.293236055895337],
            [-10.917648428256879, 7.279018237799364],
            [-10.926538479887999, 7.221507931387451],
            [-10.929254661859138, 7.207232771597114],
            [-10.912800098277126, 7.204277542567249],
            [-10.927441850088416, 7.120203858250192],
            [-10.913323995415098, 7.117193035458144],
            [-10.856786339481234, 7.107440458852614],
            [-10.864033884325465, 7.0657952897769345],
            [-10.835635595605115, 7.061003792984496],
            [-10.835869558681786, 7.05965653583294],
            [-10.75058070590784, 7.045304065128473],
            [-10.750761743307542, 7.044240313731712],
            [-10.66560812419971, 7.030021694991453],
            [-10.677521076675244, 6.959217354298965],
            [-10.621097116510931, 6.949423019126847],
            [-10.59180075143218, 6.944675234687685],
            [-10.507119927529153, 6.930264515475629],
            [-10.507039949384755, 6.93075449333639],
            [-10.463314350853182, 6.923643158296746],
            [-10.466815717380799, 6.922450555987822],
            [-10.470718997499402, 6.9240591926618285],
            [-10.47351850201376, 6.922371868759874],
            [-10.475121973502121, 6.917508348911679],
            [-10.471546774139403, 6.907463450059425],
            [-10.473735060050757, 6.904195152056366],
            [-10.469075912675091, 6.897479670768903],
            [-10.463797767059486, 6.894339479251919],
            [-10.46656248460714, 6.890354134208547],
            [-10.470114235975105, 6.889636775298296],
            [-10.47036636302045, 6.885423135605618],
            [-10.468243064824227, 6.882447352893393],
            [-10.473471510596589, 6.878211356552894],
            [-10.477039261792473, 6.872722456624327],
            [-10.48107739361238, 6.871220637124638],
            [-10.48803550841032, 6.8629164164737215],
            [-10.490781767670745, 6.867899687479877],
            [-10.49438862688637, 6.864161004919309],
            [-10.49682695240643, 6.865584041440362],
            [-10.502713267954046, 6.865048932120725],
            [-10.503434431788977, 6.861977211679907],
            [-10.50042620175881, 6.859443229375908],
            [-10.499644403749096, 6.853982747945741],
            [-10.496193746671246, 6.849200378820333],
            [-10.495937510685694, 6.846556649102842],
            [-10.500289977842195, 6.845354869243528],
            [-10.506408867665183, 6.841775670720158],
            [-10.510677992400455, 6.834300686047439],
            [-10.51537284961723, 6.827930063100961],
            [-10.511824168776453, 6.823887882209875],
            [-10.515591706725681, 6.821207096709648],
            [-10.51602062833101, 6.812956894302951],
            [-10.51401248180188, 6.811077006111085],
            [-10.513950291555027, 6.804463969311822],
            [-10.50726388291223, 6.797921590352915],
            [-10.503974591057013, 6.793072770950776],
            [-10.511223687060214, 6.786862563498473],
            [-10.509924913819253, 6.78354322593906],
            [-10.499341633456822, 6.78053390125553],
            [-10.492665337033428, 6.774537381126656],
            [-10.483944956396167, 6.774734866946806],
            [-10.483999851134975, 6.764077213124556],
            [-10.482576982037173, 6.758410900647653],
            [-10.486985389991606, 6.757559959155668],
            [-10.493772083938714, 6.760740184861166],
            [-10.496805254674575, 6.759980233055001],
            [-10.508728004864613, 6.761545067435865],
            [-10.51506554743528, 6.7582377407861465],
            [-10.51952198463794, 6.759828094712955],
            [-10.520680672681879, 6.7666268327011645],
            [-10.523593813777852, 6.7714385885017325],
            [-10.532107635427655, 6.775586651369444],
            [-10.536925543640374, 6.779694110801298],
            [-10.538528625775758, 6.783279002799409],
            [-10.54456799266117, 6.782197903794048],
            [-10.549904608502462, 6.783160011458215],
            [-10.550904195646407, 6.785743323962379],
            [-10.561298133665085, 6.78957944370744],
            [-10.565302563127888, 6.79320244116605],
            [-10.57692793126043, 6.786465151084886],
            [-10.58592492162464, 6.782580810304149],
            [-10.588924680465926, 6.784600872167844],
            [-10.599256746053456, 6.789317163223058],
            [-10.602161684408099, 6.789053374227823],
            [-10.608262311753196, 6.792233833456451],
            [-10.612693219145918, 6.7931777906008355],
            [-10.617963767792297, 6.791792561891163],
            [-10.6203092325365, 6.794973882907901],
            [-10.627359787609581, 6.797417066398455],
            [-10.634704701530266, 6.802833955555546],
            [-10.639718262298581, 6.799340405503517],
            [-10.646550674950548, 6.8038737462233225],
            [-10.648288423089268, 6.803854694558725],
            [-10.653493149297748, 6.795204783170233],
            [-10.659034576991406, 6.789207114291659],
            [-10.667145865984923, 6.791184462870268],
            [-10.674193225446707, 6.79140889419111],
            [-10.68103108145045, 6.79022873315239],
            [-10.691270924663424, 6.784059429500658],
            [-10.694001502935857, 6.778287855931455],
            [-10.701173418848171, 6.782814040869662],
            [-10.70552136414194, 6.778484587707623],
            [-10.711260345453683, 6.777926624966925],
            [-10.717714400483459, 6.782025365478979],
            [-10.72185387403234, 6.782100272277967],
            [-10.72480974441672, 6.780257132173658],
            [-10.728116867349186, 6.775475666654382],
            [-10.72697166413989, 6.77299639536114],
            [-10.73149669917473, 6.768918553933897],
            [-10.739000389145307, 6.767754465811009],
            [-10.74424054127625, 6.7766099621838185],
            [-10.743171968782477, 6.7791046216340485],
            [-10.750700951669408, 6.787103068653971],
            [-10.75333508094931, 6.801335922305919],
            [-10.757208446477469, 6.808057924032924],
            [-10.757353856819364, 6.8113112158661435],
            [-10.761440419150677, 6.814301099586849],
            [-10.761396605888523, 6.820124798567094],
            [-10.764162087899845, 6.827062391114138],
            [-10.771056344603554, 6.825065371148338],
            [-10.777535957218506, 6.830427352969744],
            [-10.785676435336445, 6.824632368127338],
            [-10.797743773455979, 6.825425311644446],
            [-10.799470338632808, 6.826856800500685],
            [-10.810375219485207, 6.829251691432624],
            [-10.814975314936623, 6.828137201070705],
            [-10.82041927424954, 6.829203044653269],
            [-10.823064328746204, 6.823204396128359],
            [-10.830348190520642, 6.82351448145332],
            [-10.831607768131727, 6.819921580180985],
            [-10.83478352922515, 6.819976739943467],
            [-10.839482161850624, 6.813541560013064],
            [-10.843857953923061, 6.81248977514787],
            [-10.863045494787752, 6.818334807732635],
            [-10.86609946626013, 6.823635092935991],
            [-10.870155864581985, 6.8230733009350475],
            [-10.876605917296999, 6.828129097775838],
            [-10.880771586401272, 6.829629977048286],
            [-10.883061218768662, 6.826028021152828],
            [-10.882792801972975, 6.818321149839033],
            [-10.883561989742192, 6.812011275490839],
            [-10.887365773063918, 6.8167753017919095],
            [-10.890206042074762, 6.816714632966034],
            [-10.898003109568696, 6.822058237462353],
            [-10.908258822579189, 6.824448022087643],
            [-10.912542288127284, 6.821821776087982],
            [-10.916669786035111, 6.822771156789665],
            [-10.92605036180743, 6.820499417443816],
            [-10.929297004406655, 6.814193833142086],
            [-10.933387620565263, 6.812500165716844],
            [-10.937029759561902, 6.81310068594593],
            [-10.937778286241047, 6.816184773326549],
            [-10.949334118546329, 6.823272471879606],
            [-10.950130248243754, 6.830612243056854],
            [-10.954200848875544, 6.8324995722133295],
            [-10.955076721634809, 6.835294448006469],
            [-10.960789306697917, 6.835842943836972],
            [-10.96386418472467, 6.833750114465619],
            [-10.974099791977006, 6.840318732820604],
            [-10.984240982430114, 6.83561760135305],
            [-10.989054426207069, 6.834320355364688],
            [-10.995454996544783, 6.839264332825542],
            [-11.013737254412606, 6.849095222332264],
            [-11.018169813885496, 6.855888370145873],
            [-11.015292255532477, 6.863510492966668],
            [-11.017438720514043, 6.8663895880428205],
            [-11.015585930179423, 6.870204839660378],
            [-11.019802705162457, 6.871909497439627],
            [-11.024322717973181, 6.875723533568697],
            [-11.0300258548834, 6.876281854562685],
            [-11.033692882301853, 6.880571460512332],
            [-11.04116216546654, 6.8763568326902815],
            [-11.047668954517698, 6.8774130802704105],
            [-11.054528995514469, 6.88142518687184],
            [-11.058948096063336, 6.878684017575025],
            [-11.060463843177955, 6.8754520188900505],
            [-11.064700680738978, 6.873407917774311],
            [-11.068988302120625, 6.874319995061426],
            [-11.07591739083191, 6.869883204688884],
            [-11.078018999444254, 6.866722808104757],
            [-11.07938704788705, 6.858727021853461],
            [-11.082800216948723, 6.856496347469141],
            [-11.09944445565497, 6.858029661454192],
            [-11.1036058124601, 6.859658484440756],
            [-11.10792395911393, 6.857319321751097],
            [-11.112387487574894, 6.851229191258018],
            [-11.111583613840125, 6.846754468463183],
            [-11.113450713347302, 6.842336529416972],
            [-11.116896453314979, 6.8159188695835855],
            [-11.119485525749253, 6.8088977812821625],
            [-11.12471781294691, 6.80341607004975],
            [-11.124955626123665, 6.800371147174685],
            [-11.12844294321639, 6.791609036272876],
            [-11.131035503405226, 6.790629959468113],
            [-11.138564397898044, 6.781823177350445],
            [-11.145508665618832, 6.775066078474238],
            [-11.148156012016408, 6.778407274340942],
            [-11.153273622001759, 6.781840487142924],
            [-11.155468058247084, 6.785370428629383],
            [-11.160019546673826, 6.786924480475706],
            [-11.1657206341356, 6.784069430421736],
            [-11.170026132691506, 6.78625062225764],
            [-11.173460247473093, 6.785659345910023],
            [-11.177981840943842, 6.78870225958011],
            [-11.177223505686317, 6.79409405841122],
            [-11.1813322885231, 6.799778234697859],
            [-11.185147375133559, 6.802312036288593],
            [-11.190631583068148, 6.801960417983928],
            [-11.190042309805854, 6.806364617012515],
            [-11.192730834771444, 6.810847862675904],
            [-11.195578627419671, 6.811165738585492],
            [-11.201561349463656, 6.81647954985987],
            [-11.210767628802673, 6.809690030584587],
            [-11.215156761980275, 6.8099271829257475],
            [-11.219758109622623, 6.807829388453763],
            [-11.222763912594523, 6.803789243888029],
            [-11.229945947545472, 6.8091803916123075],
            [-11.23001656609923, 6.8169248746829645],
            [-11.244283003845574, 6.823082754677658],
            [-11.248263414011788, 6.829266809995938],
            [-11.253489416763676, 6.83090303966451],
            [-11.260539287403711, 6.830462926868559],
            [-11.268041327601704, 6.831651102990288],
            [-11.27372735655384, 6.830319844878916],
            [-11.278959820364456, 6.831940047797052],
            [-11.289275112872703, 6.843448269084902],
            [-11.30210538735256, 6.842024253573953],
            [-11.306570923905149, 6.838777385831682],
            [-11.309272514893081, 6.838958324173261],
            [-11.309092432198097, 6.844536010671821],
            [-11.310963396781695, 6.847598780257809],
            [-11.317830545094088, 6.847633085056783],
            [-11.32728195747146, 6.846480623136036],
            [-11.33322642756243, 6.846659528970163],
            [-11.338218038431211, 6.852711537351915],
            [-11.347614499637888, 6.85632791348604],
            [-11.348696766534895, 6.861436636255178],
            [-11.354978490833915, 6.864264018889412],
            [-11.361285726551719, 6.8685583316517445],
            [-11.368965445194837, 6.871248540389615],
            [-11.380157651088906, 6.868617631980943],
            [-11.385434341028484, 6.860715731314768],
            [-11.389342118704098, 6.858567334118365],
            [-11.392345986263795, 6.860956621440813],
            [-11.403039122506772, 6.860067550739089],
            [-11.409765384065835, 6.857492794137584],
            [-11.414976603922257, 6.859434840396406],
            [-11.415635463015475, 6.85714002245957],
            [-11.419921909951498, 6.8546920943117255],
            [-11.423857449488244, 6.848793690264922],
            [-11.430278674650834, 6.8442581845677655],
            [-11.431406218498207, 6.839372635366805],
            [-11.440049105272955, 6.832035877817381],
            [-11.443310879289827, 6.833971899200412],
            [-11.448467233946289, 6.827391350674674],
            [-11.45438595236448, 6.825340663104218],
            [-11.456818101579511, 6.822043782812362],
            [-11.457566762514475, 6.814737904726653],
            [-11.467420012990676, 6.807218122479511],
            [-11.465170276052135, 6.804995494478294],
            [-11.462737748385129, 6.798410266912144],
            [-11.45805942780618, 6.789025794654295],
            [-11.45796826189126, 6.781688093766766],
            [-11.452002416379047, 6.779293655025582],
            [-11.455560597998621, 6.775704076530846],
            [-11.454525731622459, 6.768641616569602],
            [-11.456789185993697, 6.7648270658923035],
            [-11.457899440305725, 6.757385866039229],
            [-11.463514878599913, 6.753081370363653],
            [-11.471098492279237, 6.748967509288073],
            [-11.480309850794429, 6.745849886429048],
            [-11.483132392921318, 6.743431936079562],
            [-11.489731662734984, 6.746637797370641],
            [-11.49396771457809, 6.756988574417461],
            [-11.500307245951355, 6.761045811852151],
            [-11.501807620917292, 6.76649637413418],
            [-11.504797674479184, 6.769211633580699],
            [-11.504483910367838, 6.786561132363922],
            [-11.503022098674561, 6.791635001010411],
            [-11.50703519066924, 6.795809438117822],
            [-11.512400030924741, 6.791623177320926],
            [-11.516174197596364, 6.790941025145507],
            [-11.525004787438261, 6.797647035268235],
            [-11.525577897140046, 6.802594371909421],
            [-11.530355285338906, 6.804970594335094],
            [-11.533219710385133, 6.80836285568331],
            [-11.539680442472626, 6.808698712085177],
            [-11.546884352543616, 6.814985487700314],
            [-11.546896863601775, 6.822307219406921],
            [-11.554931670234124, 6.822845625058851],
            [-11.563828402726877, 6.834326127167483],
            [-11.570992142340433, 6.847808513415228],
            [-11.576759385849847, 6.853133954139589],
            [-11.578228662591027, 6.857305672640394],
            [-11.578667752812255, 6.8696673535272135],
            [-11.576179911397347, 6.875076504887013],
            [-11.583333322589667, 6.888545417058287],
            [-11.585665546062462, 6.901577920892337],
            [-11.577653028897814, 6.908041331722418],
            [-11.575780557286876, 6.912304808079053],
            [-11.57444260551566, 6.919826785136119],
            [-11.5666217295858, 6.92240589863123],
            [-11.567146371973898, 6.929617731430202],
            [-11.570675810505941, 6.9312487313745414],
            [-11.576099007869246, 6.938948244416265],
            [-11.577487691031427, 6.942423840272524],
            [-11.581421909985053, 6.942089490800277],
            [-11.585928240142064, 6.9453593909382425],
            [-11.589630979052219, 6.950032302363717],
            [-11.591232352235403, 6.955288914691211],
            [-11.587988279504982, 6.9624927517998145],
            [-11.581422008427314, 6.965738552232131],
            [-11.581253158672748, 6.970482013261701],
            [-11.599294544488316, 6.9878650929442845],
            [-11.594853405979018, 6.994518165687854],
            [-11.601321495478727, 7.003266007959399],
            [-11.60987442995015, 7.010448223308678],
            [-11.602218603511957, 7.017668833962174],
            [-11.59828564129504, 7.022990684912883],
            [-11.590195066855852, 7.025786141520154],
            [-11.585194875885431, 7.025310247359332],
            [-11.58199908770607, 7.0281762017616],
            [-11.578213888858043, 7.03462498325405],
            [-11.57798886140753, 7.042554382860521],
            [-11.585626516800337, 7.056366280245697],
            [-11.584100242651491, 7.0602580210521255],
            [-11.58579714395077, 7.0655106437981585],
            [-11.584973911110435, 7.076248494556906],
            [-11.582339078601086, 7.080633495169072],
            [-11.581857192951897, 7.085538662213781],
            [-11.58747199611868, 7.088416195591811],
            [-11.590561803135328, 7.09174255050152],
            [-11.58855255964215, 7.096943227605597],
            [-11.590266344523425, 7.1005672538644005],
            [-11.597179684364493, 7.104998838913708],
            [-11.599250611434604, 7.1089715471807375],
            [-11.598219883270179, 7.111409234669188],
            [-11.60033695463146, 7.116598987291434],
            [-11.598669623716273, 7.126441656801348],
            [-11.59721352351655, 7.127653309283533],
            [-11.597518302170652, 7.135886888038671],
            [-11.596404401152464, 7.139301574393072],
            [-11.603039590058328, 7.144440639801907],
            [-11.60670599480117, 7.145125137993669],
            [-11.604918063229897, 7.1509653801601365],
            [-11.607097298278847, 7.159204658718327],
            [-11.615092308478044, 7.165797313498925],
            [-11.616070762538405, 7.173898392044972],
            [-11.610760703728559, 7.178155063250616],
            [-11.60965372124556, 7.185801729118788],
            [-11.615121234314005, 7.190488517858887],
            [-11.627479877517166, 7.196954830878718],
            [-11.630632571516129, 7.195398925350318],
            [-11.640363674751603, 7.205635677183107],
            [-11.64189859555849, 7.212380488776988],
            [-11.6456118614811, 7.21934354989365],
            [-11.648637486010974, 7.222424486568533],
            [-11.654211521529334, 7.225291274424722],
            [-11.657068626037884, 7.230760830032165],
            [-11.665509828812812, 7.233925159791722],
            [-11.671924466499247, 7.238812522412103],
            [-11.67607435632909, 7.239107621855792],
            [-11.680593505841363, 7.248812025108435],
            [-11.690009802732488, 7.247095334588611],
            [-11.693531508628576, 7.244833015512388],
            [-11.705807854891638, 7.242703731237417],
            [-11.710243213962526, 7.23965479879033],
            [-11.72106074128298, 7.235954113876734],
            [-11.722660830138295, 7.233086332248042],
            [-11.736559051131518, 7.23046359322166],
            [-11.744578233048404, 7.226109809852607],
            [-11.75259269312255, 7.223732689107966],
            [-11.76054401521437, 7.231287996069075],
            [-11.76071244255969, 7.235917368403288],
            [-11.753973083748262, 7.2399222914583],
            [-11.75742107917471, 7.259943750109545],
            [-11.76454788087823, 7.266582358854888],
            [-11.769483858117814, 7.272858380085339],
            [-11.769342293924634, 7.277318105666142],
            [-11.773880989574318, 7.280852813710135],
            [-11.780926934133525, 7.2815770962927],
            [-11.790743053112784, 7.287237247307638],
            [-11.799795444018725, 7.2856644504813195],
            [-11.799429698125454, 7.2906914223853345],
            [-11.801743650883111, 7.302857303548503],
            [-11.808916236065322, 7.305485758647072],
            [-11.810743766046928, 7.312135823928349],
            [-11.816324162396945, 7.314767155500077],
            [-11.818007681279559, 7.317180136488832],
            [-11.817593647908888, 7.324075158727537],
            [-11.820207483491677, 7.334191444766944],
            [-11.818368495158978, 7.338799526192695],
            [-11.821691156131763, 7.3434596284268325],
            [-11.828492804255665, 7.349222300661018],
            [-11.82633219971442, 7.352262100253044],
            [-11.824153870647802, 7.35890757326678],
            [-11.821686837515458, 7.362348444236797],
            [-11.824569601942287, 7.3652250293244075],
            [-11.828548815678335, 7.374312304401475],
            [-11.831128922251283, 7.375478489152829],
            [-11.832543797606762, 7.379591866113598],
            [-11.832141580054458, 7.385630718229241],
            [-11.833715143780058, 7.386747619051012],
            [-11.83414827503442, 7.397207695103493],
            [-11.831775799980953, 7.402461022407067],
            [-11.825743246800897, 7.400943358183673],
            [-11.820382883445939, 7.4033797177956595],
            [-11.814953824507022, 7.400227852785834],
            [-11.80997335687901, 7.398991523188195],
            [-11.805858544895711, 7.402664573726236],
            [-11.80016970830635, 7.401604499420089],
            [-11.795792785431916, 7.404002471752677],
            [-11.79295250482337, 7.408279312068289],
            [-11.794968840154562, 7.418601125056369],
            [-11.791519889375039, 7.420619363172159],
            [-11.79002662630014, 7.43478150973514],
            [-11.787911003056628, 7.439601065724427],
            [-11.787381079532215, 7.446774506138192],
            [-11.78011846518471, 7.453562896454052],
            [-11.782347043592946, 7.461664462252972],
            [-11.785215017856833, 7.467999471871057],
            [-11.78114681746784, 7.480124391804987],
            [-11.786548211407569, 7.487891766609908],
            [-11.781440103595495, 7.492334597458148],
            [-11.780474628020913, 7.5059610343062255],
            [-11.784831428637952, 7.512282641548419],
            [-11.788808866953737, 7.511172965109109],
            [-11.796000181075396, 7.5114666379602495],
            [-11.802747842023134, 7.5144808811552535],
            [-11.803568724750734, 7.523131989938183],
            [-11.8019546570105, 7.525545857913438],
            [-11.80696337317734, 7.532694980951871],
            [-11.811105321820055, 7.533889718262741],
            [-11.818832817414506, 7.538917120739626],
            [-11.823291538650569, 7.547686203303013],
            [-11.814354673258178, 7.5533120512472784],
            [-11.808683807004822, 7.561622064137999],
            [-11.81053202433798, 7.568339807199318],
            [-11.812349001091455, 7.570049249599566],
            [-11.817534502747923, 7.569152225273783],
            [-11.823769767407823, 7.57172121159622],
            [-11.83087648034586, 7.568879984367051],
            [-11.838566831498706, 7.57106857477292],
            [-11.840566967619022, 7.5771383377375345],
            [-11.84864274755958, 7.584259125969464],
            [-11.850182211593086, 7.584582820882894],
            [-11.853572463873304, 7.592498447535089],
            [-11.844493720407883, 7.603313644459758],
            [-11.84262764911042, 7.607856026622202],
            [-11.852775862699243, 7.6093446748674065],
            [-11.854483078547203, 7.615170266545667],
            [-11.858834467272999, 7.618070936058717],
            [-11.857887736946527, 7.623853207550584],
            [-11.859285602711395, 7.629139887850836],
            [-11.854072595707985, 7.639118756471312],
            [-11.854455169675447, 7.645821207266224],
            [-11.857716118222138, 7.648735454874005],
            [-11.858411060674024, 7.654167670105566],
            [-11.862211908751076, 7.655867446614023],
            [-11.865016487450825, 7.661057753966556],
            [-11.867520101810191, 7.6622585687118185],
            [-11.869424513081196, 7.667265644207757],
            [-11.880384489276931, 7.6796542611673155],
            [-11.879616134665005, 7.683400427393067],
            [-11.885199485438328, 7.694373920052761],
            [-11.884857603754796, 7.701737916554236],
            [-11.8894686959002, 7.710044160033959],
            [-11.897892324908431, 7.7190612092874495],
            [-11.90237132231305, 7.720771076449287],
            [-11.90585176667138, 7.726982825432006],
            [-11.90938715211241, 7.736015957918373],
            [-11.90658104403875, 7.744966241945247],
            [-11.901399801659949, 7.744125758403584],
            [-11.898059979149409, 7.746099783298034],
            [-11.898397361449224, 7.749971187821361],
            [-11.902325701340333, 7.7581855632338685],
            [-11.909588478083736, 7.765390227545472],
            [-11.910553640198247, 7.772289147421208],
            [-11.914553101133249, 7.7748892440759],
            [-11.917800081777253, 7.790410608619091],
            [-11.924111006896238, 7.796281972384889],
            [-11.928831808256769, 7.805155031300246],
            [-11.92739283469217, 7.820642339237318],
            [-11.922611782632341, 7.824368475133488],
            [-11.92173574120187, 7.828796754859229],
            [-11.917954356447188, 7.8307018244896],
            [-11.919165082202037, 7.838374313206233],
            [-11.922019652968034, 7.843981100784068],
            [-11.917245933267198, 7.847792866573692],
            [-11.917016637400016, 7.852734844717708],
            [-11.914265137720438, 7.860945264424729],
            [-11.914434949390396, 7.866990086461687],
            [-11.920195710225302, 7.872336175898472],
            [-11.922639416570517, 7.8790907301145285],
            [-11.92514447490623, 7.879496111540639],
            [-11.93010161286105, 7.884188520885612],
            [-11.939216627373677, 7.885942705593413],
            [-11.940161113793739, 7.888065903994554],
            [-11.93905439542882, 7.896281193711601],
            [-11.933959119068295, 7.899141698467281],
            [-11.929450127589096, 7.89995153448256],
            [-11.925674909796312, 7.904468266905343],
            [-11.928370331290017, 7.908628998899264],
            [-11.934119005106407, 7.910354421883319],
            [-11.935747254774036, 7.914031168051784],
            [-11.932090984861407, 7.925574355433063],
            [-11.937238360048793, 7.9313785128343355],
            [-11.936559593722016, 7.934985427962964],
            [-11.929053283035477, 7.940965749701853],
            [-11.928862568674049, 7.948399814627018],
            [-11.922490865007811, 7.9507511384892835],
            [-11.915661677842019, 7.956324450878467],
            [-11.914825622747433, 7.962176338098731],
            [-11.91601038726573, 7.967211082041495],
            [-11.91578824808624, 7.976828187560301],
            [-11.918191292112748, 7.984106622518583],
            [-11.916788765699055, 7.9880919078801815],
            [-11.918167327738162, 7.990578488620367],
            [-11.912721561281332, 7.996261179835875],
            [-11.920129754697594, 8.000054753086097],
            [-11.922878326024193, 7.999146948399174],
            [-11.937288926854588, 8.003137992236471],
            [-11.94222801281932, 8.000788685046885],
            [-11.949832433265287, 8.005283855201446],
            [-11.953159412918476, 8.004226891226107],
            [-11.959280493490875, 8.004615560366615],
            [-11.953162480167425, 8.015358137380142],
            [-11.953001534024478, 8.020110952176319],
            [-11.94606476959993, 8.028824555273555],
            [-11.94144087605983, 8.037677250857506],
            [-11.940351222760162, 8.04153448230956],
            [-11.941700606981577, 8.047199007972761],
            [-11.9371717554848, 8.049779291836145],
            [-11.92936679395739, 8.05718661682423],
            [-11.922380301060628, 8.059748532853062],
            [-11.922437671838285, 8.064113706698715],
            [-11.925156404074597, 8.07248718767838],
            [-11.925596630707858, 8.081174342990296],
            [-11.928506680657271, 8.08546418985327],
            [-11.932066657838277, 8.0875158740942],
            [-11.934518548673621, 8.092237749189001],
            [-11.938583142328268, 8.093501139886833],
            [-11.942478514139195, 8.091773192331086],
            [-11.94828323007351, 8.095115249964769],
            [-11.950713525944977, 8.103348624926374],
            [-11.958719228143469, 8.108361068182925],
            [-11.964215407035882, 8.10816601227253],
            [-11.968252491342502, 8.106644694541394],
            [-11.97671933600999, 8.105552568787918],
            [-11.981347197732433, 8.10952223996253],
            [-11.98826891174407, 8.111918255160756],
            [-11.98738067317492, 8.115743234053307],
            [-11.98451659217812, 8.117994419767976],
            [-11.984227027219996, 8.127420590719375],
            [-11.97838473715368, 8.132015060068547],
            [-11.979206827143113, 8.13545610009404],
            [-11.98266287430392, 8.14065327044286],
            [-11.98840003107719, 8.144353250246642],
            [-11.992329537332019, 8.149222314105948],
            [-11.992336987453642, 8.15587493699063],
            [-11.996610169536584, 8.162613144244721],
            [-11.996637346628294, 8.16994804377695],
            [-11.99788420461497, 8.174820970577965],
            [-11.99596294148126, 8.183949554926977],
            [-11.998143474256235, 8.188176403136618],
            [-11.997227785998447, 8.189846833521923],
            [-11.990622039559446, 8.191487754265376],
            [-11.985630331251905, 8.194404898146184],
            [-11.980162817781213, 8.18840245873208],
            [-11.97476393948965, 8.192553690205218],
            [-11.974251372518841, 8.198264533383249],
            [-11.976721975922908, 8.19895339887739],
            [-11.974720361646645, 8.203789888088645],
            [-11.969129829717042, 8.208942897055627],
            [-11.972489159214527, 8.214790778644767],
            [-11.968255972328572, 8.2183347741615],
            [-11.970039471006684, 8.229552689032193],
            [-11.972781657403129, 8.232533072789742],
            [-11.96916842373045, 8.23945557910965],
            [-11.965128157591268, 8.242037656253425],
            [-11.958580311034233, 8.248973175092441],
            [-11.955468998711199, 8.253645433716981],
            [-11.946081734903585, 8.257349086299259],
            [-11.941850497605177, 8.25758468220077],
            [-11.935409937148151, 8.26314409350436],
            [-11.930505115421575, 8.259634855493307],
            [-11.926464504997263, 8.252889368208777],
            [-11.926610127412852, 8.244987660872033],
            [-11.924877872432143, 8.236437490639418],
            [-11.926411533801373, 8.232233110625744],
            [-11.919332880343312, 8.230394768303468],
            [-11.913721942018917, 8.227921927439118],
            [-11.911090625270335, 8.23009828319037],
            [-11.902870563265168, 8.23038477216985],
            [-11.898230607291678, 8.234591224190513],
            [-11.893663867957102, 8.23658198188606],
            [-11.888937769187095, 8.245496129757113],
            [-11.885821479199247, 8.245660592003981],
            [-11.879054327630055, 8.249274480119041],
            [-11.881558663565151, 8.254855595889573],
            [-11.88174203397072, 8.259248792411217],
            [-11.879789248660394, 8.263235405297944],
            [-11.870465817287304, 8.261361608581831],
            [-11.862084327479725, 8.268363133649157],
            [-11.858772866495647, 8.269898807868877],
            [-11.855104595281757, 8.26844159994317],
            [-11.848364847565554, 8.27255641626709],
            [-11.842648920251522, 8.279372426644775],
            [-11.835867029999417, 8.27955496417253],
            [-11.831815075052301, 8.281839665983902],
            [-11.830702627474006, 8.287545868433808],
            [-11.826449153152405, 8.2903101372927],
            [-11.820178169806544, 8.290781502942654],
            [-11.816724349291016, 8.297983058927162],
            [-11.812252650437731, 8.297016112006451],
            [-11.808672713739618, 8.300909623403678],
            [-11.805570694682068, 8.301094812871527],
            [-11.798449999000951, 8.29485375928837],
            [-11.788639900592282, 8.294350786788728],
            [-11.786683458770293, 8.289356322167853],
            [-11.782738181245401, 8.289254965892544],
            [-11.77672626938723, 8.292533627888627],
            [-11.770834091015598, 8.289604483649208],
            [-11.7678513178775, 8.290680712840276],
            [-11.761012968925098, 8.290449455800902],
            [-11.758084456466415, 8.288726806307679],
            [-11.754519748818407, 8.289345509538217],
            [-11.744893513284321, 8.296762517523677],
            [-11.739704858292633, 8.296899617710583],
            [-11.734528200222403, 8.295265204704936],
            [-11.729205505378122, 8.306368552125866],
            [-11.719097769935098, 8.314546910538548],
            [-11.715030824964318, 8.312624614446689],
            [-11.709143787527028, 8.312735045717183],
            [-11.70484480304671, 8.315265344758053],
            [-11.698115942903815, 8.313182799565904],
            [-11.685915238792939, 8.313955691270934],
            [-11.682814685242878, 8.316153404862394],
            [-11.685014306862701, 8.318849916080593],
            [-11.683421230881665, 8.32756854335631],
            [-11.685943496724038, 8.32951724675106],
            [-11.68504460236107, 8.336927888928459],
            [-11.68273516292134, 8.3411461917744],
            [-11.681416103842173, 8.348105787558547],
            [-11.676338876770764, 8.353413309780313],
            [-11.675140361081136, 8.35720706716348],
            [-11.670155701944694, 8.363265422035852],
            [-11.663800598120014, 8.367793462402375],
            [-11.663741149371793, 8.370593878060037]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.89884616764537,
          "lat": 45.132736385674654
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30001"],
        "coty_name": ["Beaverhead"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beaverhead County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01719627"
      },
      "bbox": [
        -11.998143474256235, 6.743431936079562, -10.463314350853182,
        8.370656137109654
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.795348723735435, 7.403442089196602],
            [-5.765716853258817, 7.400645553602174],
            [-5.745242242593442, 7.615544345387346],
            [-5.732867987686559, 7.7452148008341615],
            [-5.69574350753541, 7.741775060345361],
            [-5.5919001125767, 7.732018882389674],
            [-5.488059800109178, 7.7222313180314694],
            [-5.440430655655975, 7.718153483937352],
            [-5.447664527365323, 7.63798896971581],
            [-5.42472864379893, 7.635788684519291],
            [-5.36089380786775, 7.630301653882683],
            [-5.368421374606062, 7.5470347749645175],
            [-5.353603530431426, 7.546192385980076],
            [-5.324846297058825, 7.543557473254433],
            [-5.325030764294163, 7.54091602401573],
            [-5.238998487575506, 7.5334369422415515],
            [-5.238925651139715, 7.534271401074823],
            [-5.191034667041668, 7.530187375208513],
            [-5.198443756062934, 7.444441594327733],
            [-5.135393746316046, 7.439154266429731],
            [-5.145543324027559, 7.308769559680804],
            [-5.161310507585421, 7.11893167967082],
            [-5.165366985177654, 7.064952673896709],
            [-5.166862254823573, 7.052550947295631],
            [-5.168573087568616, 7.0247237428914255],
            [-5.17414053890202, 6.9562128219922545],
            [-5.1755613336562964, 6.937139115999535],
            [-5.178966820331904, 6.8992850585928025],
            [-5.189214905096545, 6.77745491789973],
            [-5.196537189640807, 6.690384217570571],
            [-5.196326681133535, 6.689419620679886],
            [-5.199472475698056, 6.656466693460461],
            [-5.207074053444822, 6.564602139308387],
            [-5.219909595290242, 6.5652203539821645],
            [-5.269988766588422, 6.569823577752362],
            [-5.3642170230129205, 6.578080724676638],
            [-5.454282051469559, 6.586154405437918],
            [-5.5356296966382095, 6.593507834961731],
            [-5.623186374359991, 6.601685500844445],
            [-5.718904952804778, 6.611077131443781],
            [-5.80440012990138, 6.619540855058967],
            [-5.9092068232017585, 6.629466085449044],
            [-5.892340029936975, 6.8055842260749495],
            [-5.884051614963775, 6.891638537041892],
            [-5.875730315522396, 6.977638160181929],
            [-5.8401440370549595, 6.974283488009401],
            [-5.831567652167512, 7.063944614951231],
            [-5.827478639363031, 7.06355987155915],
            [-5.819339837040623, 7.14941854209981],
            [-5.802699729608737, 7.3231054944563745],
            [-5.798369053740603, 7.372098624553857],
            [-5.795348723735435, 7.403442089196602]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.53615738935082,
          "lat": 45.516758557432006
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30011"],
        "coty_name": ["Carter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carter County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01688746"
      },
      "bbox": [
        -5.9092068232017585, 6.564602139308387, -5.135393746316046,
        7.7452148008341615
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.777398588790313, 9.384893710428347],
            [-5.769851428720413, 9.460454168774707],
            [-5.7432496698633555, 9.457925680945088],
            [-5.734776430921757, 9.542692451425566],
            [-5.72512276255044, 9.639124305209368],
            [-5.724000673761086, 9.651183871235737],
            [-5.718920260073388, 9.653568453577755],
            [-5.713884748020185, 9.66309843302773],
            [-5.713030162835676, 9.680646338982353],
            [-5.709067804257492, 9.685579392795127],
            [-5.705571747585919, 9.68384075254514],
            [-5.702636693727106, 9.678474068487983],
            [-5.7056521939846885, 9.676921815074193],
            [-5.709572269885229, 9.67127626384363],
            [-5.708177463168824, 9.6646351370848],
            [-5.697020092375395, 9.65867340366192],
            [-5.69400456939658, 9.655881280873036],
            [-5.688207062588436, 9.654025517096752],
            [-5.680918838270028, 9.654388238268703],
            [-5.673095265698239, 9.657844035262933],
            [-5.668173216427981, 9.657416429762334],
            [-5.665082661865543, 9.652633243732497],
            [-5.665483533049198, 9.647528855397072],
            [-5.668007901857859, 9.644341068290071],
            [-5.672805970824516, 9.642372546150169],
            [-5.6713453987157925, 9.638707609819212],
            [-5.658133972896676, 9.639070365087193],
            [-5.650479514476389, 9.641915876780304],
            [-5.640442124000573, 9.651061954780017],
            [-5.63554878406501, 9.653733431945126],
            [-5.6306274740186115, 9.65317230004827],
            [-5.626393978352693, 9.649773954610389],
            [-5.625496237776645, 9.645958307908513],
            [-5.629303470759642, 9.636831470251485],
            [-5.62905456088824, 9.631922721100437],
            [-5.6237747357779835, 9.628856795727001],
            [-5.621648266457692, 9.634692942204875],
            [-5.618506063954321, 9.638034535558246],
            [-5.606310813467892, 9.64015385548264],
            [-5.602350312598497, 9.642326370984387],
            [-5.602390263533339, 9.648051353688762],
            [-5.599343514072838, 9.653915708243888],
            [-5.5957336105564615, 9.65744751627456],
            [-5.588733695676607, 9.656111677636959],
            [-5.586959972061503, 9.652037310545655],
            [-5.588218836532993, 9.648389933119836],
            [-5.592436935871267, 9.643209950171096],
            [-5.592179435268846, 9.639171025062316],
            [-5.58685331352746, 9.638044222055068],
            [-5.58077329058314, 9.643595626863705],
            [-5.574745648212293, 9.654601867806543],
            [-5.574805098758234, 9.660034352889582],
            [-5.579303701002628, 9.669528184806538],
            [-5.579035820991083, 9.671807047954754],
            [-5.5724788480414045, 9.672885916578512],
            [-5.5652523637457145, 9.668224377248055],
            [-5.560107384123514, 9.667196147333906],
            [-5.555395106724049, 9.662355691680922],
            [-5.552014860441447, 9.661451181967495],
            [-5.549159184602383, 9.663395261023236],
            [-5.542566974224441, 9.67457143759255],
            [-5.5394728287060016, 9.676853727653592],
            [-5.535182417841345, 9.701690066946718],
            [-5.529176888486914, 9.708849996205256],
            [-5.513075481837481, 9.713729195042395],
            [-5.506504673332033, 9.711964965850465],
            [-5.50021227381116, 9.705949887656713],
            [-5.494950736125762, 9.692548822763449],
            [-5.48932387261985, 9.686485771238457],
            [-5.478357058069445, 9.680731898249592],
            [-5.469449316806929, 9.678697882636808],
            [-5.465377320977213, 9.679481369003454],
            [-5.461644306699587, 9.682150916093612],
            [-5.452892950508196, 9.683563305619321],
            [-5.446224236278669, 9.68571080286274],
            [-5.4339612233590495, 9.686142307089826],
            [-5.427297578378312, 9.682141491001921],
            [-5.4198748106945995, 9.666810424801312],
            [-5.415507851370942, 9.665575137835564],
            [-5.410250563546545, 9.667582171659348],
            [-5.403747231640836, 9.66730674704383],
            [-5.396841433271088, 9.672064978930587],
            [-5.385862772154002, 9.67095700049057],
            [-5.378669360944054, 9.667120386474105],
            [-5.377124751675792, 9.664754262630172],
            [-5.37634023924565, 9.65489055160447],
            [-5.368273458905117, 9.655045848643764],
            [-5.361319943345489, 9.657248402723532],
            [-5.352934415442288, 9.657515209685172],
            [-5.347230089024192, 9.659919820009764],
            [-5.338309143160494, 9.659943107016073],
            [-5.333798952721548, 9.663672661907029],
            [-5.334060966867913, 9.666806668929821],
            [-5.338324551476155, 9.671056063417282],
            [-5.338975140641115, 9.675148119885064],
            [-5.337129263821799, 9.677037050017146],
            [-5.332003393848554, 9.677155257538145],
            [-5.325777892813918, 9.680241419331182],
            [-5.3235443516803596, 9.68825218092956],
            [-5.315461772914168, 9.680276991127954],
            [-5.311385471564018, 9.673028225100092],
            [-5.3110956815788954, 9.670317910664448],
            [-5.315920332820297, 9.658808675538127],
            [-5.31663890299741, 9.655282467967599],
            [-5.310728438622785, 9.653251164408077],
            [-5.300256139515092, 9.659563454497663],
            [-5.292335145424689, 9.66584003743318],
            [-5.285000025843613, 9.667562867180116],
            [-5.282286380837813, 9.669259393559145],
            [-5.276883606355728, 9.668555817957415],
            [-5.271637040441909, 9.666066207590656],
            [-5.267208337127981, 9.66087679833369],
            [-5.261750939289977, 9.651092841255457],
            [-5.258742115357011, 9.650826555468653],
            [-5.254009202469991, 9.653031667246859],
            [-5.247261430500419, 9.659480109323516],
            [-5.244185723282876, 9.661295393913088],
            [-5.236920783892067, 9.662592220303097],
            [-5.2317289143398495, 9.661265505829297],
            [-5.226191329763867, 9.65748255372923],
            [-5.223571548713399, 9.651987442188375],
            [-5.221751726739567, 9.641252413631925],
            [-5.217142345029565, 9.632573734705097],
            [-5.2099146732046835, 9.62818711425366],
            [-5.200753810654276, 9.6206498288872],
            [-5.1863806537854735, 9.612112723834253],
            [-5.181602881455546, 9.610846870206998],
            [-5.173975699121391, 9.610822732684465],
            [-5.168188078551535, 9.607050925142026],
            [-5.16383141889247, 9.602077219214294],
            [-5.162041578167304, 9.594844795446848],
            [-5.1607655117654385, 9.582167332673954],
            [-5.154857973751955, 9.5787215950595],
            [-5.149837218568341, 9.578972105561931],
            [-5.139203535846091, 9.576815198151905],
            [-5.125909430608463, 9.581281944334398],
            [-5.118396205199832, 9.580701360230693],
            [-5.113455513614753, 9.576849297824797],
            [-5.107505584414474, 9.57026170294036],
            [-5.090217817157552, 9.558724835648336],
            [-5.085970440929677, 9.557230929036974],
            [-5.075547914099887, 9.556913705542481],
            [-5.064566776955007, 9.559476311479981],
            [-5.059286204605622, 9.56225768941666],
            [-5.057788645834579, 9.565418807062686],
            [-5.057770839425727, 9.573052679108457],
            [-5.06159170580846, 9.580244306452576],
            [-5.06084758267895, 9.587549526251262],
            [-5.058507494405394, 9.590384950737594],
            [-5.048832800820444, 9.59195649697443],
            [-5.045045373216528, 9.589286894201743],
            [-5.045179452949187, 9.586340766853866],
            [-5.048131674743455, 9.581059521940528],
            [-5.049958970547304, 9.572943358592756],
            [-5.046263399327309, 9.564879624667563],
            [-5.039316503772418, 9.558674045831465],
            [-5.036948770977193, 9.558590643645937],
            [-5.028350834750372, 9.566499228292125],
            [-5.0236343014282845, 9.572621417255197],
            [-5.018664846975188, 9.576180624820717],
            [-5.012234878966784, 9.575684511474142],
            [-5.010492000643773, 9.571676659291443],
            [-5.007431422921663, 9.558166652714949],
            [-5.003254325501641, 9.552288476776258],
            [-4.997019815959472, 9.549449211273739],
            [-4.993034786984946, 9.550164433107636],
            [-4.990878023048899, 9.553919209918636],
            [-4.987132204809993, 9.551109061632813],
            [-4.98921705533202, 9.545110331848358],
            [-4.994088226962296, 9.540326632725142],
            [-4.998118769187657, 9.533979242248424],
            [-4.997950665884511, 9.530553158318435],
            [-4.995236605389064, 9.527330559926252],
            [-4.995938709408256, 9.521774920119658],
            [-4.994054726374821, 9.520134894616639],
            [-4.985697561807996, 9.51911335538187],
            [-4.9838099323180645, 9.51999513064352],
            [-4.971758883091955, 9.521581240923771],
            [-4.966855816120323, 9.520325891584926],
            [-4.957541286682093, 9.513229177883794],
            [-4.957543507839851, 9.513205784949491],
            [-4.960912334765136, 9.467806559779378],
            [-4.967107759192593, 9.382604828306123],
            [-4.972250437167509, 9.329926219632293],
            [-4.9725448551739575, 9.325055168609595],
            [-4.977834424493673, 9.270298449419618],
            [-4.988419327142259, 9.151091293022395],
            [-4.9971840522145285, 9.05199063733067],
            [-5.008462402212574, 8.928294857945263],
            [-5.067088749474142, 8.933567419782444],
            [-5.071025026957593, 8.891022309795074],
            [-5.157068531502793, 8.898221947489219],
            [-5.243113956657834, 8.905398100910274],
            [-5.243029668120384, 8.906316583609895],
            [-5.266822889834541, 8.908435705209671],
            [-5.329884078745005, 8.914280376767028],
            [-5.31537208687466, 9.071675273001743],
            [-5.314186616540112, 9.085084853762842],
            [-5.369020826822217, 9.089865577286902],
            [-5.360962524664799, 9.174779821117255],
            [-5.458061196775649, 9.183592847780126],
            [-5.463101914843471, 9.183866680486794],
            [-5.548946814298642, 9.19173999685668],
            [-5.621078858642073, 9.19856350495638],
            [-5.612615207225674, 9.283446733513879],
            [-5.712064996510685, 9.293184592780856],
            [-5.785934591952827, 9.300169178014578],
            [-5.777567612457486, 9.38221210585136],
            [-5.777398588790313, 9.384893710428347]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.56143169797689,
          "lat": 47.787882956234164
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30083"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richland County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01715338"
      },
      "bbox": [
        -5.785934591952827, 8.891022309795074, -4.957541286682093,
        9.713729195042395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.945845197509066, 10.694824218912567],
            [-6.830985714595906, 10.681631704342673],
            [-6.716131733028775, 10.66839291823629],
            [-6.645475296937434, 10.660453658775985],
            [-6.574820905945339, 10.652496904392349],
            [-6.509240335891266, 10.645282362814022],
            [-6.48378081545104, 10.642319589530985],
            [-6.414426786039177, 10.635050727345854],
            [-6.410169896504127, 10.634481048198783],
            [-6.329666407507563, 10.625627505377492],
            [-6.3215762073500255, 10.62492856805495],
            [-6.2410610776502455, 10.616285582237397],
            [-6.250318222070062, 10.530703590611996],
            [-6.276728875663229, 10.533472387345832],
            [-6.285849220234893, 10.449698537044585],
            [-6.199299984504879, 10.440678488389015],
            [-6.210365295666891, 10.337380918986215],
            [-6.217053600919155, 10.27323504257688],
            [-6.2259171462619864, 10.19188770479856],
            [-6.2254867064907184, 10.18829098809185],
            [-6.169085934548695, 10.182683858331293],
            [-6.167228793036072, 10.182258079225377],
            [-6.082198539398677, 10.173663303331786],
            [-6.0857166582481845, 10.14124883911263],
            [-6.108603098490858, 9.923920505839218],
            [-6.117415414544294, 9.839708684922567],
            [-6.143650084239539, 9.842387150961896],
            [-6.158717889877642, 9.700061992368855],
            [-6.161435454586526, 9.675685380590677],
            [-6.16508904560855, 9.63954254954024],
            [-6.170695257043972, 9.63838038901777],
            [-6.173987711170831, 9.63958022666829],
            [-6.174727955306084, 9.644202391285523],
            [-6.178127433047629, 9.647415669421068],
            [-6.186320115478145, 9.652683615806653],
            [-6.18897654290832, 9.656590610792334],
            [-6.189892875595636, 9.665593560800541],
            [-6.191425157359308, 9.668199468272721],
            [-6.196249954308414, 9.670161614616948],
            [-6.199785320878287, 9.66662891438149],
            [-6.199959419455405, 9.647122275945831],
            [-6.201006528289584, 9.644013820303092],
            [-6.204989863450529, 9.640472641527161],
            [-6.211402116073966, 9.638561391930576],
            [-6.216511983797927, 9.638550169470617],
            [-6.219389480475306, 9.640644438892819],
            [-6.22605494758871, 9.648816375683388],
            [-6.230493513260823, 9.650657743748884],
            [-6.237191518158245, 9.650071452152462],
            [-6.24371543940551, 9.651080948930327],
            [-6.252209314921042, 9.654005156913398],
            [-6.258365474552413, 9.65942028164979],
            [-6.26110066781866, 9.66539817369455],
            [-6.267105155785926, 9.670875821483074],
            [-6.271531764465517, 9.673541529659314],
            [-6.280369614832792, 9.673694086599122],
            [-6.285017492950603, 9.667475054914185],
            [-6.2841186506246185, 9.663592673512111],
            [-6.27887824999738, 9.657374844408919],
            [-6.277197872138781, 9.65207682466624],
            [-6.279884257423941, 9.647668378088603],
            [-6.284013102574483, 9.64615727898736],
            [-6.290179596802728, 9.646357483272162],
            [-6.295052459433458, 9.650027352480675],
            [-6.299616067093971, 9.651680262055619],
            [-6.301510228166074, 9.662891210397385],
            [-6.30696148567204, 9.672543192362989],
            [-6.311897833349707, 9.67692944733058],
            [-6.320272176586085, 9.68045680393235],
            [-6.324779341545162, 9.6801100774813],
            [-6.327283171688144, 9.675730186996445],
            [-6.325105604421488, 9.671296980645012],
            [-6.327529687091896, 9.664399515011928],
            [-6.333887056758487, 9.657343832002597],
            [-6.338920621490532, 9.655009058889313],
            [-6.350899900453192, 9.652735494884956],
            [-6.3586205423589295, 9.655375357367395],
            [-6.36546290378313, 9.656571451862396],
            [-6.36763678635837, 9.659886460115137],
            [-6.3654930211524965, 9.662819119256984],
            [-6.354819696357079, 9.667624323261734],
            [-6.350788613327753, 9.67248076066023],
            [-6.350251218053382, 9.676435171265576],
            [-6.355939995050074, 9.681207151637343],
            [-6.365558983606565, 9.679619307809366],
            [-6.373173480088559, 9.68116239534746],
            [-6.385566539156006, 9.679728292008674],
            [-6.389092682912132, 9.681733954880137],
            [-6.394897740988302, 9.681986761269375],
            [-6.405034165850464, 9.680555848242015],
            [-6.4219211511303556, 9.682233223140003],
            [-6.431936669708501, 9.686768453530917],
            [-6.437261048854858, 9.692923003809822],
            [-6.442304996200069, 9.696202713892982],
            [-6.446987577933352, 9.702952925564466],
            [-6.4508106112570465, 9.705139265460845],
            [-6.4576134311461875, 9.704611002798897],
            [-6.460882575243745, 9.701029612551899],
            [-6.4683727869226155, 9.701906249187159],
            [-6.470347616885947, 9.710685109167901],
            [-6.47534307261914, 9.715937200062013],
            [-6.480579305861615, 9.717043322624685],
            [-6.493124516745153, 9.709187620731019],
            [-6.5019621018723655, 9.70786053547309],
            [-6.510335466992904, 9.711780976249564],
            [-6.511298816718353, 9.714660440828705],
            [-6.510371124835178, 9.720898630240836],
            [-6.511821127255032, 9.724846012344745],
            [-6.514799822211728, 9.727526089530432],
            [-6.528308970418898, 9.731319469282019],
            [-6.532928863578586, 9.729061996990062],
            [-6.536982454334859, 9.724734848186452],
            [-6.543955812532832, 9.713837885476819],
            [-6.5465075052007204, 9.711852180694196],
            [-6.552661756940134, 9.696171383385977],
            [-6.555254593824079, 9.694718193886244],
            [-6.557275949782978, 9.68879335352623],
            [-6.5545220261573665, 9.685217488898951],
            [-6.553876883027934, 9.681546015177583],
            [-6.554533174208351, 9.673975455109261],
            [-6.552644222400992, 9.666589564895487],
            [-6.554572709266619, 9.658438230089905],
            [-6.551761667919187, 9.643475491349438],
            [-6.552111508696318, 9.637906105179253],
            [-6.556332787580248, 9.628861567169436],
            [-6.559422530151723, 9.625790837780945],
            [-6.563612308326342, 9.62686660570683],
            [-6.56626328519106, 9.63378273831435],
            [-6.565511035066149, 9.63716399037164],
            [-6.56177262473765, 9.64199251794576],
            [-6.561237372435924, 9.647809243401055],
            [-6.563068307443895, 9.6514274923552],
            [-6.5703978263279765, 9.655254012207436],
            [-6.57476492593224, 9.65498252424592],
            [-6.576256566735633, 9.65234033209258],
            [-6.576363663900742, 9.645860305604259],
            [-6.577600419997895, 9.643925083344866],
            [-6.5849801299401785, 9.639718363348555],
            [-6.590689488037742, 9.638355382161807],
            [-6.603790744615452, 9.638780951641829],
            [-6.612011046421606, 9.63574405631587],
            [-6.618123847331908, 9.628229564156388],
            [-6.617006527154418, 9.624172348755284],
            [-6.609325800697945, 9.620722688445008],
            [-6.606079573174751, 9.609797497688412],
            [-6.607135886658942, 9.604800621151464],
            [-6.612905915213488, 9.594743572189856],
            [-6.6171303413738105, 9.59250301121274],
            [-6.62460543996058, 9.593060395082246],
            [-6.6335161134445135, 9.589791851580275],
            [-6.637530227082607, 9.5846847452362],
            [-6.633915618415711, 9.577910980990866],
            [-6.624954717574325, 9.571094016719147],
            [-6.624002028248212, 9.562679567960261],
            [-6.626460049699377, 9.559289571538796],
            [-6.634340010801564, 9.562397397759534],
            [-6.639931652330882, 9.56256268485484],
            [-6.648565978653893, 9.558594072382787],
            [-6.64864681992327, 9.552849496560166],
            [-6.639736692097088, 9.543003758338465],
            [-6.639941004852757, 9.538766852140112],
            [-6.642365647437016, 9.532507717830143],
            [-6.645932973906226, 9.53071322447472],
            [-6.657531230082137, 9.531790309764293],
            [-6.662873283261073, 9.530314878460514],
            [-6.666211410589876, 9.525965391476516],
            [-6.663693508772304, 9.513736116194869],
            [-6.666665530943308, 9.506382341013591],
            [-6.671110571692261, 9.501135620605417],
            [-6.674503615257481, 9.49951482453629],
            [-6.686989805581045, 9.499777441807241],
            [-6.697364130030173, 9.497493340383768],
            [-6.701741733234501, 9.494613423884957],
            [-6.701575237470139, 9.492039857383986],
            [-6.698214766483115, 9.486875183767225],
            [-6.697805350406575, 9.482030654540884],
            [-6.699220128497278, 9.474473505813812],
            [-6.704549053886284, 9.467664881190812],
            [-6.706940702275984, 9.467787501453017],
            [-6.711098906019891, 9.481808363457779],
            [-6.713012128774674, 9.483245658647572],
            [-6.724971574777342, 9.485510773161014],
            [-6.731492211869274, 9.484005919379818],
            [-6.733089146975978, 9.482206984444588],
            [-6.733799511154767, 9.476179675616951],
            [-6.737426146169563, 9.469147869613668],
            [-6.740110398886649, 9.466190746015393],
            [-6.744812621499193, 9.46407379534217],
            [-6.751314957250217, 9.471964123846565],
            [-6.761055344976581, 9.47345291221314],
            [-6.766769392249921, 9.472803203186274],
            [-6.77384912519411, 9.470319031948186],
            [-6.77464936787503, 9.456538226008496],
            [-6.775980337630235, 9.452607118352587],
            [-6.780464213209485, 9.446703290887438],
            [-6.78741263498829, 9.440817709766257],
            [-6.789759416123791, 9.436978217818895],
            [-6.793222485348764, 9.435079047983278],
            [-6.801699323911947, 9.433228925448454],
            [-6.810849321855964, 9.434389581873052],
            [-6.826780437412454, 9.447073563598794],
            [-6.845120784317927, 9.45102457501752],
            [-6.859301756656689, 9.451616237223732],
            [-6.872802492646853, 9.45010452809014],
            [-6.878488833972387, 9.447846254163155],
            [-6.888756945732251, 9.437240756173848],
            [-6.892489593795298, 9.430430071714925],
            [-6.8888914524904905, 9.420157472193567],
            [-6.888013113176532, 9.41431888777337],
            [-6.889020946346109, 9.406419182707232],
            [-6.892819720771613, 9.398721027557096],
            [-6.897236373283573, 9.392374593298111],
            [-6.9065119968338715, 9.389350773002443],
            [-6.92299012410617, 9.386664232334969],
            [-6.929219237853752, 9.38665952284932],
            [-6.9364003877854055, 9.392986872729766],
            [-6.941236366011256, 9.394754494899978],
            [-6.952623905348926, 9.391980946031836],
            [-6.964626426564732, 9.39382420774436],
            [-6.974411422016751, 9.396919526172958],
            [-6.977860483592014, 9.396651233951415],
            [-6.98228744225891, 9.391278915246673],
            [-6.987748865599292, 9.387081729600503],
            [-6.991717222894345, 9.385960334326594],
            [-6.999923702732408, 9.385843265346885],
            [-7.005174697789256, 9.388148851135904],
            [-7.0185224558309764, 9.390321644218053],
            [-7.0276820827142465, 9.39097396072993],
            [-7.034595831155432, 9.392892018860142],
            [-7.043013544092498, 9.39713218260634],
            [-7.056280399640083, 9.400821646621948],
            [-7.078419441533381, 9.402821120389934],
            [-7.086535853042675, 9.403114027718354],
            [-7.092464774046565, 9.401817486640091],
            [-7.098179104984491, 9.398671407750367],
            [-7.111334873728872, 9.399596229209529],
            [-7.115185072942752, 9.402286217885775],
            [-7.125397593512955, 9.401774185490742],
            [-7.1480009695160405, 9.404157499096737],
            [-7.152235285377308, 9.40686826103991],
            [-7.157073002737356, 9.41258418304395],
            [-7.161385767336323, 9.419218276990575],
            [-7.165727038969696, 9.423557338627187],
            [-7.169542805126693, 9.425314341867944],
            [-7.18783388936141, 9.428117552054914],
            [-7.20147649928503, 9.429315973372082],
            [-7.205904290443258, 9.430749964678922],
            [-7.213044576042899, 9.435427374607036],
            [-7.219398564406964, 9.441827578303473],
            [-7.231395556614024, 9.4448580217169],
            [-7.252178936494534, 9.446990185994045],
            [-7.256123915991224, 9.446698087590143],
            [-7.234536760752584, 9.620398796937105],
            [-7.228010544986372, 9.619618698626624],
            [-7.217747123348647, 9.70401675212029],
            [-7.20207935995647, 9.831587594419604],
            [-7.186603758786405, 9.957132058609862],
            [-7.163390226337842, 9.954313693734035],
            [-7.152810222395422, 10.038348290870879],
            [-7.0803156059117125, 10.029421475259777],
            [-7.069741662813087, 10.115883478627628],
            [-7.096915022196407, 10.118994978995072],
            [-7.0871356517915265, 10.203169872973511],
            [-7.058019283406917, 10.199798023030159],
            [-7.054119422302117, 10.232527752414475],
            [-7.049182537541058, 10.234307564761394],
            [-7.043180993906829, 10.229697006959535],
            [-7.03741856592077, 10.231254676509652],
            [-7.033339950722182, 10.224994518098569],
            [-7.029431735387041, 10.225407221041026],
            [-7.027987527910668, 10.222360997731537],
            [-7.021923611813635, 10.224161560021754],
            [-7.018422011751174, 10.222367516520423],
            [-7.016099174507428, 10.223941692518594],
            [-7.011320103446713, 10.22221500256525],
            [-7.004505950711805, 10.278991687898422],
            [-7.013536392353799, 10.280099468768768],
            [-6.973276302653629, 10.612758289073176],
            [-6.955967650100961, 10.610704390481812],
            [-6.945845197509066, 10.694824218912567]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.66746306721988,
          "lat": 48.36525493707413
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30105"],
        "coty_name": ["Valley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Valley County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01678923"
      },
      "bbox": [
        -7.256123915991224, 9.385843265346885, -6.082198539398677,
        10.694824218912567
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.481678266712946, 8.05558542610235],
            [-8.382016720227345, 8.042246409214602],
            [-8.303132865446962, 8.031841901409537],
            [-8.224251426118007, 8.021419079410217],
            [-8.190419534288159, 8.017204520735753],
            [-8.123929089482978, 8.008681495285312],
            [-8.110591453211935, 8.109609579131831],
            [-8.081831328523995, 8.105503914820103],
            [-8.07995265472727, 8.119652717045776],
            [-8.05115500520957, 8.115565088552582],
            [-8.049210045997546, 8.129591802918346],
            [-7.936476845794992, 8.114994383440235],
            [-7.932874840724162, 8.114268966948645],
            [-7.848918344257984, 8.104109363046964],
            [-7.843381290087278, 8.1470075235673],
            [-7.831203076586238, 8.14545575078284],
            [-7.827798734889797, 8.173886153726155],
            [-7.81327653108848, 8.172261377687036],
            [-7.811645364282288, 8.186444465434189],
            [-7.7971658099868115, 8.184632215721575],
            [-7.7954570061271165, 8.19884126272819],
            [-7.781140001828175, 8.197141177490439],
            [-7.779372049481612, 8.21138448220756],
            [-7.765008803042908, 8.209788282306835],
            [-7.763232231292148, 8.223981619768713],
            [-7.66275434855357, 8.211410927551498],
            [-7.649723394268656, 8.310080530958952],
            [-7.631638479296794, 8.307882252847953],
            [-7.6333837303814365, 8.293940284873173],
            [-7.622235284421119, 8.292571831602846],
            [-7.623906205440148, 8.278608610044293],
            [-7.609571614856851, 8.276801544974473],
            [-7.612974989774402, 8.248380915145976],
            [-7.598599914971493, 8.24658985632956],
            [-7.601996411939529, 8.218169559693527],
            [-7.587653970892508, 8.216366672675909],
            [-7.589343923243227, 8.20215420359713],
            [-7.574999162407284, 8.200355143341483],
            [-7.578525224131755, 8.172001143092455],
            [-7.564255486538978, 8.170303780084039],
            [-7.566007202710959, 8.156124104947114],
            [-7.551613620038217, 8.154404809623449],
            [-7.556884538278578, 8.111820806545577],
            [-7.542476325113711, 8.110113684914582],
            [-7.544225952561951, 8.095891218207454],
            [-7.529839791676966, 8.094149096096656],
            [-7.533328505706893, 8.065764005876558],
            [-7.518942001363943, 8.064034851330858],
            [-7.52069726614427, 8.049820452532892],
            [-7.506310708431786, 8.048105352677595],
            [-7.509848133362735, 8.019648380447155],
            [-7.495568641448602, 8.017993026057152],
            [-7.499042142869546, 7.9895306377779525],
            [-7.484647535465094, 7.987810694008523],
            [-7.4864565723190575, 7.973589916120513],
            [-7.47200660342355, 7.971833570049018],
            [-7.4739658603847445, 7.9551482985019915],
            [-7.480354132732297, 7.950340418576846],
            [-7.4808996158151615, 7.946081322231589],
            [-7.474719884364453, 7.940591195749971],
            [-7.4739745333950065, 7.935877179636237],
            [-7.475985079107713, 7.933504481141059],
            [-7.482275294381055, 7.93252121785583],
            [-7.482696761455078, 7.927749852702189],
            [-7.47834205073461, 7.925017908034183],
            [-7.480683599471159, 7.920310637443355],
            [-7.4837341124746795, 7.919354512479398],
            [-7.489661426249613, 7.921892515972751],
            [-7.49090515134663, 7.9194038421655595],
            [-7.4871736870090855, 7.9120552040930265],
            [-7.485578679637718, 7.902717276919851],
            [-7.486750983542383, 7.899137967093491],
            [-7.491366407567118, 7.89648545060231],
            [-7.4955981091599835, 7.896321032748696],
            [-7.49535092845073, 7.886385074856745],
            [-7.5018560273923, 7.887769482189494],
            [-7.504881902877845, 7.886254079142928],
            [-7.502596213693079, 7.88219846724854],
            [-7.509340632089038, 7.878901447690703],
            [-7.50859170421444, 7.87021187671649],
            [-7.5119082097040355, 7.86990012204972],
            [-7.51438356744465, 7.86296951313445],
            [-7.518596971621661, 7.860507502879207],
            [-7.5228880051044795, 7.850735839458085],
            [-7.5194831473449035, 7.843710185067046],
            [-7.631877673616853, 7.857565109650981],
            [-7.6389650418487935, 7.800770104406366],
            [-7.72479402780208, 7.811245567545859],
            [-7.7284216915214685, 7.782821111642974],
            [-7.757116740918215, 7.78646382644998],
            [-7.760686623213481, 7.758190649415763],
            [-7.7893451198927925, 7.761883553680886],
            [-7.7929277468519915, 7.73348618428253],
            [-7.90731465784406, 7.747913273179361],
            [-7.922087991450015, 7.63416424795122],
            [-7.937324066785882, 7.636121469264204],
            [-7.95032404879987, 7.535888094941328],
            [-7.9709934374441485, 7.375661147580592],
            [-8.056794596244758, 7.386584532164521],
            [-8.060496589679126, 7.358047887046867],
            [-8.14604673591984, 7.3690256006116455],
            [-8.149883393556266, 7.340520886043003],
            [-8.239495476379064, 7.352104247749676],
            [-8.23902668862078, 7.356028773915243],
            [-8.321620098592907, 7.366386209058811],
            [-8.378125664130932, 7.3739840142709605],
            [-8.414809168544247, 7.378862322371229],
            [-8.407829009110126, 7.436523473302044],
            [-8.450177482012156, 7.442383702004272],
            [-8.44665922923194, 7.470924393749472],
            [-8.475048187858977, 7.474867704555266],
            [-8.470699326000224, 7.5098481933052215],
            [-8.465474910448549, 7.512635244148121],
            [-8.465924277622005, 7.5181086960097145],
            [-8.461615818922347, 7.518218333605994],
            [-8.460250135826291, 7.522105709561921],
            [-8.462385327758765, 7.526089902671159],
            [-8.457252321881645, 7.528441328625134],
            [-8.452757464564135, 7.535583056210723],
            [-8.449715246252808, 7.558157404133647],
            [-8.454904724565182, 7.556310723621649],
            [-8.461114041616135, 7.556286324968948],
            [-8.469895734446046, 7.547178884975944],
            [-8.476025005287335, 7.546989940804567],
            [-8.484303168612028, 7.5430933887729825],
            [-8.490272369701403, 7.538323466484499],
            [-8.495722229872163, 7.536744415312189],
            [-8.4919848534466, 7.564659572213288],
            [-8.506240324506676, 7.566546394704132],
            [-8.504406103292537, 7.580566047964099],
            [-8.518662920862027, 7.58256411781773],
            [-8.514631776890957, 7.611192109853436],
            [-8.528795684907813, 7.6129935735184215],
            [-8.526702877605068, 7.627255935385046],
            [-8.515160453785764, 7.71255203163024],
            [-8.513137823398473, 7.7122782332083615],
            [-8.49741238735314, 7.826433799975799],
            [-8.489271693017152, 7.884007604224372],
            [-8.503522589861992, 7.8859651746151025],
            [-8.500007021969935, 7.914494834081446],
            [-8.496535076414128, 7.950340260149168],
            [-8.481678266712946, 8.05558542610235]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.27436677540304,
          "lat": 45.93735308269492
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30111"],
        "coty_name": ["Yellowstone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yellowstone County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01719558"
      },
      "bbox": [
        -8.528795684907813, 7.340520886043003, -7.47200660342355,
        8.310080530958952
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2227480392913241, 3.784940013084762],
            [-1.1562496631882933, 3.7835905312718805],
            [-1.0561869085724147, 3.7814873688771273],
            [-0.9701314360296754, 3.7797144323519403],
            [-0.9259147541874239, 3.778925946260416],
            [-0.9245578403041155, 3.7790797678441077],
            [-0.881262315249259, 3.7783017203906035],
            [-0.882958023307864, 3.6907568491555054],
            [-0.8851485123140694, 3.596326569491757],
            [-0.8862887845011012, 3.5380324763639015],
            [-0.8881911142732817, 3.429367398102784],
            [-0.8881001100078585, 3.4287754780215485],
            [-0.8879675796936447, 3.4280058073315582],
            [-0.8893077863137192, 3.342016074190181],
            [-0.8905501724990922, 3.254386589260797],
            [-0.947967161033659, 3.255331836968485],
            [-1.0616595716365682, 3.2568262686118574],
            [-1.175724799928432, 3.2594507413097684],
            [-1.232044386295385, 3.260453580088288],
            [-1.2295573489061258, 3.362438244882715],
            [-1.2276933270860837, 3.435259888303958],
            [-1.2314908881028441, 3.4353314507545205],
            [-1.2293191680470332, 3.5226523055996273],
            [-1.2271694056122857, 3.610186898568504],
            [-1.225013262571336, 3.69758527029849],
            [-1.2227480392913241, 3.784940013084762]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.06667870731472,
          "lat": 42.176904512733095
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31003"],
        "coty_name": ["Antelope"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Antelope County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00835824"
      },
      "bbox": [
        -1.232044386295385, 3.254386589260797, -0.881262315249259,
        3.784940013084762
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.6949030694174554, 2.436090351776356],
            [-2.620251899048051, 2.4331876370917636],
            [-2.619786202132371, 2.4333257401845825],
            [-2.5626226236277225, 2.430504238127261],
            [-2.5392391069121087, 2.429584233623978],
            [-2.5237528898711137, 2.429505468857579],
            [-2.4958107247753434, 2.427986897145486],
            [-2.4341885143058226, 2.4255461653009815],
            [-2.4110680326806264, 2.4241256008390453],
            [-2.353648134656529, 2.4219087092871048],
            [-2.2858181648007503, 2.4188832841208834],
            [-2.27742270073786, 2.4187022758615524],
            [-2.169443021416137, 2.4143392368101675],
            [-2.0983110466293335, 2.4119614849767625],
            [-2.101417480341498, 2.3141398766584382],
            [-2.1044341317255726, 2.2373814561529652],
            [-2.1061947387952498, 2.2010955877112086],
            [-2.1083620429612564, 2.150308531840436],
            [-2.111335574995125, 2.0628433179928307],
            [-2.103721998896483, 2.062537020013404],
            [-2.105447873670749, 2.0334366867621214],
            [-2.1102398485630847, 2.03612064213085],
            [-2.117132693668294, 2.03623205451089],
            [-2.125543628183905, 2.0412900596702332],
            [-2.138615151024392, 2.0400088121145568],
            [-2.141197447582128, 2.0386484100322857],
            [-2.153383089069521, 2.0399651130561387],
            [-2.1587252019899084, 2.0392117966202594],
            [-2.1661678465278023, 2.0397576441016283],
            [-2.17508499849563, 2.042242903571487],
            [-2.1888860713188847, 2.040825271244108],
            [-2.197403744174853, 2.0462963146078335],
            [-2.211718487346887, 2.0473331732601068],
            [-2.223305589434575, 2.044533080022512],
            [-2.2300611418815284, 2.0444495130173985],
            [-2.2426036628408226, 2.047546063752543],
            [-2.2477225717548084, 2.050987134491036],
            [-2.2589010936400764, 2.0545311193405844],
            [-2.2721214315515783, 2.0534776633456904],
            [-2.274842519058915, 2.0539359645241726],
            [-2.282741740867785, 2.0565370178196],
            [-2.290872938736936, 2.0573836603792373],
            [-2.2927131950024644, 2.0599935677339563],
            [-2.3023069039301625, 2.064807740944651],
            [-2.3068923300847546, 2.0655382049038526],
            [-2.312467583087595, 2.069886332675873],
            [-2.3161774515843714, 2.0707215746240455],
            [-2.3587731788423545, 2.0724121257189236],
            [-2.4436414910423836, 2.0760248592636157],
            [-2.446819526724003, 2.0759606010205918],
            [-2.4990862383572314, 2.0780691545111387],
            [-2.521423013330612, 2.0787459833586137],
            [-2.5283290857605154, 2.0793275080110263],
            [-2.613767153341667, 2.083106069288424],
            [-2.709727337774703, 2.0874104245115954],
            [-2.70957666113675, 2.092910448420415],
            [-2.7054380078080946, 2.192774614438986],
            [-2.705288127007081, 2.1938634720337014],
            [-2.70157061643, 2.2904291273667132],
            [-2.6982140566547956, 2.3622981306505664],
            [-2.6949030694174554, 2.436090351776356]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.81956776893838, "lat": 40.86993394593271 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31047"],
        "coty_name": ["Dawson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dawson County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00835845"
      },
      "bbox": [
        -2.709727337774703, 2.0334366867621214, -2.0983110466293335,
        2.436090351776356
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.009094136624238, 3.4773153731731896],
            [-3.9663429302894464, 3.4743048162923578],
            [-3.95921766076689, 3.5618072713882607],
            [-3.8480693775186126, 3.5528377043235975],
            [-3.7540124465370335, 3.546341271750414],
            [-3.690446775941325, 3.542697596205584],
            [-3.5651332712385786, 3.5341439647577197],
            [-3.532938316826724, 3.532125684851934],
            [-3.5379689580690425, 3.4458626780373014],
            [-3.5378780983698497, 3.439576121207522],
            [-3.552534829325025, 3.1816108948573523],
            [-3.71099423925942, 3.1902102272420403],
            [-3.7524599270109817, 3.1929755127877657],
            [-3.8305912564149502, 3.197353386743448],
            [-3.8329358145885917, 3.1971619207776922],
            [-3.8693812967198573, 3.1995347977729143],
            [-3.9662805456110006, 3.2056654890922642],
            [-4.027080627789878, 3.209303202896472],
            [-4.009094136624238, 3.4773153731731896]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.74056888612984,
          "lat": 41.91499395881536
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31075"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00835859"
      },
      "bbox": [
        -4.027080627789878, 3.1816108948573523, -3.532938316826724,
        3.5618072713882607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8881001100078585, 3.4287754780215485],
            [-0.8868085482094634, 3.428863205828475],
            [-0.8023182327664976, 3.4276534911617342],
            [-0.689246471682843, 3.4257593447115844],
            [-0.6877772938528715, 3.4259111501527064],
            [-0.5446256965067543, 3.424176053434084],
            [-0.545009572448694, 3.380077060536393],
            [-0.5457632586415462, 3.3367650457981206],
            [-0.5472930201258149, 3.2271978495497047],
            [-0.5483774354015516, 3.1473692131248203],
            [-0.5494207316582581, 3.0745384643526172],
            [-0.6711313036892175, 3.0761113667920776],
            [-0.807488782993227, 3.0780213029530734],
            [-0.8918622465114399, 3.079317934967707],
            [-0.8931574151120416, 3.0793388334315206],
            [-0.8924608124717162, 3.1376866391707887],
            [-0.8905501724990922, 3.254386589260797],
            [-0.8893077863137192, 3.342016074190181],
            [-0.8879675796936447, 3.4280058073315582],
            [-0.8881001100078585, 3.4287754780215485]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.60076235806571, "lat": 41.91668100838047 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31119"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00835880"
      },
      "bbox": [
        -0.8931574151120416, 3.0745384643526172, -0.5446256965067543,
        3.428863205828475
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2394458391328584, 2.8236269700620045],
            [-1.2183265967146648, 2.8233621331116727],
            [-1.1541168048196855, 2.8214663657023125],
            [-1.0968859259771715, 2.820387695736267],
            [-1.0967642541737408, 2.8350964205390334],
            [-1.0534037941122358, 2.8347558340897274],
            [-1.0529908927255827, 2.8493912983881367],
            [-1.0246158165542933, 2.848857685377637],
            [-0.9810952027268621, 2.8485508258592462],
            [-0.9378872684606158, 2.8478793013853396],
            [-0.9369121753638113, 2.8624329022490893],
            [-0.9026122825687518, 2.8622115217192996],
            [-0.8955743648458606, 2.861933883921358],
            [-0.8670679338219216, 2.8615736307723614],
            [-0.8319534693386672, 2.8614809304541353],
            [-0.8018108407697445, 2.8608190546173318],
            [-0.8034028033246963, 2.786709645961032],
            [-0.8042965183022553, 2.728049200507247],
            [-0.8048959495587092, 2.697099456985165],
            [-0.8061695813662357, 2.6527108236090657],
            [-0.807136152724165, 2.6417581298376906],
            [-0.8710466258356652, 2.642031332860827],
            [-0.8784127086623672, 2.642316439896041],
            [-0.9281708085870295, 2.6426404805680543],
            [-0.9355246240429013, 2.6432787393932267],
            [-0.9507824914443702, 2.64356241717322],
            [-0.950834087086125, 2.6288653447327572],
            [-1.0001141291864142, 2.629952270396017],
            [-1.0664969460518947, 2.6307566518639196],
            [-1.0668116621744184, 2.6160674704139586],
            [-1.1029786004202495, 2.6169801639899792],
            [-1.1032193135136767, 2.602266790389969],
            [-1.111263654267363, 2.6027622472687724],
            [-1.157922865417342, 2.6045087156389806],
            [-1.232823621566649, 2.6055506896884637],
            [-1.2285705170406203, 2.7358904144766836],
            [-1.2380134908212856, 2.73616005328844],
            [-1.2416112629147613, 2.736242590782824],
            [-1.2394458391328584, 2.8236269700620045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.99218012460996,
          "lat": 41.397346390363744
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31125"],
        "coty_name": ["Nance"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nance County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00835884"
      },
      "bbox": [
        -1.2416112629147613, 2.602266790389969, -0.8018108407697445,
        2.8624329022490893
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2535014772841868, 1.6846927571985084],
            [-1.1875631255969246, 1.683208636534304],
            [-1.0831590697200624, 1.6811206569949784],
            [-1.0011424115036376, 1.6792282102081495],
            [-0.9496839182812826, 1.6781454834382463],
            [-0.9140672590242117, 1.6775612143985672],
            [-0.9115764096936968, 1.6775175014653736],
            [-0.9131363817258483, 1.589739454556607],
            [-0.9149221518712077, 1.5018180833902468],
            [-0.9170094193268004, 1.3992047638035627],
            [-0.9188296066337726, 1.3260235623718557],
            [-1.002560858719469, 1.3277252514661213],
            [-1.1299265476541214, 1.3306047676203487],
            [-1.201118714166523, 1.3326030259853543],
            [-1.2440207419311118, 1.3332960084274887],
            [-1.2622336008626902, 1.333940348971236],
            [-1.2607623788846125, 1.3846879968940644],
            [-1.2608265624058221, 1.3938612884864898],
            [-1.2598723162174894, 1.4215590245073517],
            [-1.2588417180842633, 1.4655680487365474],
            [-1.2564541067035386, 1.560418063496432],
            [-1.2535014772841868, 1.6846927571985084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.04719368888584, "lat": 40.17637543915802 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31129"],
        "coty_name": ["Nuckolls"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nuckolls County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00835886"
      },
      "bbox": [
        -1.2622336008626902, 1.3260235623718557, -0.9115764096936968,
        1.6846927571985084
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.12903139965285, 1.439036930752514],
            [-14.00434771376764, 1.413906542565188],
            [-13.929417346232253, 1.3989152120499335],
            [-13.847537116386246, 1.382669127250275],
            [-13.669529168270595, 1.347834676069965],
            [-13.491526122591427, 1.3129747068789002],
            [-13.490184361429272, 1.3125671880695875],
            [-13.40771527878534, 1.296718899298638],
            [-13.427819180809179, 1.1932693558318979],
            [-13.433140131339396, 1.1642831222012804],
            [-13.441990142968608, 1.120925316919056],
            [-13.459901294755632, 1.0262681792258475],
            [-13.48602076340965, 0.8875164871930613],
            [-13.489381124540223, 0.8730070247636372],
            [-13.508492660002727, 0.7726298636480258],
            [-13.537256525186326, 0.6251551448946355],
            [-13.559277080236818, 0.5074428599775407],
            [-13.564985833413429, 0.47886412994452054],
            [-13.57029510959211, 0.45020542895374493],
            [-13.571997651199778, 0.43635885315467127],
            [-13.581548623667883, 0.3926674239487792],
            [-13.586673862949054, 0.37350950161327817],
            [-13.614170087053147, 0.23357878906592155],
            [-13.616834138704448, 0.22175861855196285],
            [-13.635844864374363, 0.121793534932297],
            [-13.647197939168526, 0.06168889177103749],
            [-13.649216870253005, 0.048342304636840985],
            [-13.658368622566499, 0.001413955350946733],
            [-13.6730810481051, -0.07564335999358121],
            [-13.67496876886508, -0.08473627275030551],
            [-13.684058848969125, -0.13439490529242362],
            [-13.69598747952014, -0.195323561634908],
            [-13.701194637246603, -0.22029328193916276],
            [-13.70339626748691, -0.2330496756538629],
            [-13.709922866621769, -0.26298150811477006],
            [-13.71204656811846, -0.2785380944619556],
            [-13.727936259507592, -0.36600235568978384],
            [-13.735591139326464, -0.4083579186641035],
            [-13.757924611240085, -0.5219156821934922],
            [-13.796716749519796, -0.5141985528730624],
            [-13.849864751969404, -0.5039250145326467],
            [-14.311339169469553, -0.4126474559934234],
            [-14.309594898193739, -0.40309446149017214],
            [-14.341938045362374, -0.3967571656094357],
            [-14.460029077612383, -0.3729384170836705],
            [-14.76460137126432, -0.310210652177098],
            [-15.069177384124863, -0.24750038318445974],
            [-15.071429912847096, -0.2585655111074752],
            [-15.192502563150072, -0.23275590827990741],
            [-15.186472564912247, -0.21377327650608346],
            [-15.156360953852708, -0.06633234306973763],
            [-15.106427063534635, 0.1699755355012948],
            [-15.099994388025923, 0.19466805738404927],
            [-15.081078105447784, 0.2868976630866605],
            [-15.080147725210495, 0.29374237563010536],
            [-15.00861666464172, 0.6254678479391996],
            [-14.936569271471559, 0.9603158164963649],
            [-14.69225307424414, 0.9093632995494689],
            [-14.447944201590554, 0.8583750007363462],
            [-14.445629404696474, 0.8580058140265566],
            [-14.25467843748804, 0.8190604305474742],
            [-14.24705493717522, 0.8566803097309637],
            [-14.16459843094441, 1.2635496161181967],
            [-14.12903139965285, 1.439036930752514]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.87752807915004,
          "lat": 37.64330684918546
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32017"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00863992"
      },
      "bbox": [
        -15.192502563150072, -0.5219156821934922, -13.40771527878534,
        1.439036930752514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.126616933288915, 3.0936071516049672],
            [-17.159632847153144, 3.0565356318347585],
            [-17.242435467388482, 2.963501774567067],
            [-17.299406679359496, 2.8993374654816932],
            [-17.341660322500623, 2.8518601942614117],
            [-17.384742723463955, 2.840152297045784],
            [-17.41904394947364, 2.8313170056326284],
            [-17.484482834938987, 2.8140533415942817],
            [-17.536570441261414, 2.810913271115685],
            [-17.537010243970197, 2.810843099583107],
            [-17.535999380978062, 2.819226605531985],
            [-17.522963117181735, 2.8158788208887735],
            [-17.517124798213324, 2.8370330940502995],
            [-17.503400526350738, 2.833511100467964],
            [-17.490714165280256, 2.883122977981879],
            [-17.476697714172516, 2.879447614575045],
            [-17.473318129333716, 2.8937197650943967],
            [-17.48020045294623, 2.895600525083107],
            [-17.47654866470224, 2.909842797473384],
            [-17.483581967991963, 2.9114723591103004],
            [-17.479985897775403, 2.9255890867390666],
            [-17.485847447779097, 2.9270453350464147],
            [-17.482270648029203, 2.9412332456165267],
            [-17.47619194823558, 2.939688551783766],
            [-17.472283434417786, 2.9541913805390565],
            [-17.457644258121174, 2.950099230436242],
            [-17.45042754931754, 2.9767071344009914],
            [-17.44532032995436, 2.9920813724844675],
            [-17.475735384321414, 2.9997913186632643],
            [-17.457331471877097, 3.070588560498754],
            [-17.45186034354531, 3.0692029780230197],
            [-17.445585465581, 3.0601300961384412],
            [-17.44033557856455, 3.0572666375886133],
            [-17.43744490552887, 3.0535673260312906],
            [-17.42882110195093, 3.0510152759950184],
            [-17.419737614597437, 3.0535468079642594],
            [-17.41306295431131, 3.0518249661325925],
            [-17.408580100427248, 3.0486833994327682],
            [-17.40243280033145, 3.050250527577558],
            [-17.400794831603054, 3.054862586250464],
            [-17.397578753370947, 3.058133632541448],
            [-17.39122284728765, 3.061306163257591],
            [-17.390251471583788, 3.0651583931353383],
            [-17.387424562138616, 3.066422415834573],
            [-17.37803742389512, 3.0739712798409404],
            [-17.36902321744711, 3.0767477790222517],
            [-17.35949700512503, 3.0772443932479967],
            [-17.339774676368695, 3.0832756510022907],
            [-17.33186662174943, 3.0842248310064946],
            [-17.329451293790907, 3.0807839620729998],
            [-17.324024176586367, 3.08460290998634],
            [-17.312813243201596, 3.0798249384271146],
            [-17.31066353196654, 3.07739276397443],
            [-17.30451115982216, 3.0759298629766665],
            [-17.30069395273107, 3.0767869159386185],
            [-17.29441578687893, 3.0739365944366153],
            [-17.290630021565814, 3.075749090234445],
            [-17.28318783697362, 3.075552598527193],
            [-17.28080747235564, 3.0736882195973294],
            [-17.27737553824956, 3.0769344304134356],
            [-17.27730865114032, 3.083076511374721],
            [-17.27465442218902, 3.0851307733177156],
            [-17.27245373057324, 3.090679545184869],
            [-17.268419431085004, 3.091037378066494],
            [-17.26386536275053, 3.0933809232460616],
            [-17.26035541308452, 3.0901073483611183],
            [-17.25454813602028, 3.0868820906538597],
            [-17.248369436180564, 3.0883212592441125],
            [-17.245990747851334, 3.086954314867232],
            [-17.237911152344243, 3.085750660221373],
            [-17.23088711889456, 3.086805316890188],
            [-17.224699190430112, 3.084390329475508],
            [-17.21643781545001, 3.078097921044496],
            [-17.21373405672397, 3.0796582755100235],
            [-17.20782625706957, 3.0786786935152675],
            [-17.201791190225805, 3.07569426104766],
            [-17.198821771911874, 3.075673363403844],
            [-17.19302018894683, 3.082472900546034],
            [-17.187959035735773, 3.08353072454897],
            [-17.174427800107072, 3.0790498344757755],
            [-17.168387153691, 3.0814235183171372],
            [-17.165435392070144, 3.0808149903411928],
            [-17.160018980124335, 3.082541155895596],
            [-17.155667071554202, 3.085599826445469],
            [-17.153149326864426, 3.0847584375457107],
            [-17.149285535521244, 3.08794666336364],
            [-17.140214725431264, 3.0893363560091993],
            [-17.133191079835708, 3.0935519750171863],
            [-17.126616933288915, 3.0936071516049672]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -119.5294571907159, "lat": 39.44695406963854 },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32029"],
        "coty_name": ["Storey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Storey County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00858642"
      },
      "bbox": [
        -17.537010243970197, 2.810843099583107, -17.126616933288915,
        3.0936071516049672
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.131340221050095, -5.223208358654733],
            [-8.122280464399118, -5.1403450793042955],
            [-8.123001710651517, -5.14025955264264],
            [-8.098698766133793, -4.8860149288449435],
            [-7.874438316104517, -4.9112691849653665],
            [-7.757347832552904, -4.923134275100118],
            [-7.730133191924191, -4.925975205593573],
            [-7.588621041581814, -4.939895869878477],
            [-7.590544713899401, -4.965998481757332],
            [-7.596440671343201, -5.025549446716272],
            [-7.533122852659595, -5.031615764960363],
            [-7.519272509987304, -5.033102766517959],
            [-7.438120301054635, -5.040923833645484],
            [-7.343311471281884, -5.050763100264893],
            [-7.258834511542548, -5.058201839366575],
            [-7.275607576043281, -5.231517142815771],
            [-7.287754394841479, -5.360812006832508],
            [-7.291607661979111, -5.401325550449877],
            [-7.321875924053391, -5.398450146993264],
            [-7.33108921799119, -5.493546140846389],
            [-7.332828876128197, -5.521731698038842],
            [-7.34272099443939, -5.610948134020969],
            [-7.356740438015946, -5.754453651926904],
            [-7.35795923613309, -5.754361084304129],
            [-7.366928777271394, -5.839905138415067],
            [-7.19606642603685, -5.856424557177761],
            [-7.1958858721694225, -5.854564499687543],
            [-7.071624512370288, -5.86640590062057],
            [-6.947361304456647, -5.87822804926503],
            [-6.9721257414193785, -6.14411400210271],
            [-6.969074233163218, -6.144389283194465],
            [-6.975163971713507, -6.206717762104886],
            [-6.992837139441498, -6.396451616899237],
            [-7.052145858525018, -6.390588315961066],
            [-7.185458663792875, -6.377844341629774],
            [-7.250110648675626, -6.371745282159311],
            [-7.349390813651889, -6.362040640385677],
            [-7.4486696019536955, -6.352322016474289],
            [-7.518251339520916, -6.345322562731393],
            [-7.626568852459522, -6.333993998031215],
            [-7.734884540210316, -6.3226487564267915],
            [-7.7509082650282455, -6.320366190750254],
            [-7.837807758456237, -6.311281927080422],
            [-7.864790909863241, -6.308868267285372],
            [-7.8768990508674435, -6.307480438322443],
            [-7.95862954802789, -6.298716321352866],
            [-8.065636238855756, -6.2872081849329255],
            [-8.128790575452108, -6.2812212753086065],
            [-8.223304776780065, -6.271317257456889],
            [-8.2769290669185, -6.265828154652152],
            [-8.268148637863755, -6.18631533500928],
            [-8.258737320279318, -6.099117003581301],
            [-8.235690089043846, -5.893811491094674],
            [-8.2329900217716, -5.8699991809307255],
            [-8.220286540776884, -5.75376961282405],
            [-8.215201703172275, -5.709060454795299],
            [-8.176677530161761, -5.3617721409037316],
            [-8.171589525866041, -5.3143128165444296],
            [-8.141815568911174, -5.317222104064309],
            [-8.131340221050095, -5.223208358654733]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -105.74144734829613, "lat": 32.6131890000119 },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35035"],
        "coty_name": ["Otero"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Otero County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00929104"
      },
      "bbox": [
        -8.2769290669185, -6.396451616899237, -6.947361304456647,
        -4.8860149288449435
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.951908608582118, 6.018036738422652],
            [14.958011563462362, 6.016101483599278],
            [14.965629457618695, 6.011834825329343],
            [14.972627050054838, 6.0169908569625985],
            [14.973924094985836, 6.02366513631189],
            [14.978348092119905, 6.025691022245198],
            [14.982275247770271, 6.029595815294617],
            [14.990809348637985, 6.0298368409217185],
            [14.997089092167105, 6.033637302919741],
            [15.006781529820623, 6.03516781588551],
            [15.01303890434908, 6.034751436331812],
            [15.018535811658367, 6.041001287005412],
            [15.018911353664405, 6.043784030530494],
            [15.024281590565964, 6.0463161436322395],
            [15.025608142689858, 6.050244189529817],
            [15.030787349846154, 6.049599056725381],
            [15.038009687740132, 6.045822999545679],
            [15.040091715333354, 6.043232964162913],
            [15.04469220228412, 6.041161116227752],
            [15.048462028186538, 6.041349251125297],
            [15.05388922759782, 6.049227225467806],
            [15.056139321840986, 6.047822424496605],
            [15.065039957849066, 6.047123821299627],
            [15.066510270263972, 6.043257919383664],
            [15.070968923848541, 6.039925403631436],
            [15.078822113249256, 6.04081418074014],
            [15.078220550376347, 6.0361414668201006],
            [15.080431537274182, 6.0342704281224],
            [15.082678007626113, 6.027874112342888],
            [15.085656699029848, 6.027477102579788],
            [15.088036836151367, 6.030978769124105],
            [15.091681447138168, 6.025629896895836],
            [15.096463281976103, 6.026535982976806],
            [15.097426469287592, 6.022976908092794],
            [15.104192260429247, 6.0214286369668795],
            [15.10173791658834, 6.017780261747241],
            [15.104059759051117, 6.016121750853136],
            [15.107751313222558, 6.017533840585652],
            [15.109343037267541, 6.013477080498418],
            [15.112835136670906, 6.011282662016631],
            [15.120122260024063, 6.011305158803431],
            [15.124852966604498, 6.0126491285954735],
            [15.12368139303952, 6.008137208142631],
            [15.138185125026112, 5.998189632063347],
            [15.136964884941243, 5.9958442237574925],
            [15.141405680088203, 5.980347763856663],
            [15.143972340066716, 5.978426590777874],
            [15.148326408966925, 5.979760923538339],
            [15.15084927433841, 5.9775418625522],
            [15.158662633720057, 5.976145205131142],
            [15.162407839851301, 5.971488236799373],
            [15.17150715939794, 5.971709076543864],
            [15.174045600516035, 5.969519499797913],
            [15.169805137211876, 5.960113257538189],
            [15.174868528559777, 5.956480015528738],
            [15.179128465981451, 5.95165836735314],
            [15.179601985541657, 5.946840647733699],
            [15.181472940108723, 5.9445164065123235],
            [15.212333554755029, 5.953422168146925],
            [15.21488994040529, 5.945298765652073],
            [15.235409949590276, 5.87526248331089],
            [15.242133744149104, 5.8515935758813],
            [15.311989111253824, 5.868170630060408],
            [15.328488871831711, 5.812341800462959],
            [15.332034248065902, 5.801078780585428],
            [15.411521532809216, 5.824066807604883],
            [15.464865453759142, 5.8387513485525],
            [15.467762835738137, 5.836345870686277],
            [15.46761502543505, 5.832531202080093],
            [15.469885995620858, 5.829297607579491],
            [15.469166050074055, 5.823047261797442],
            [15.470113300733287, 5.817621999124997],
            [15.478997610362379, 5.803566389290261],
            [15.476086176524559, 5.799450588308748],
            [15.4736626218733, 5.791731852181927],
            [15.480110461121871, 5.784228659321655],
            [15.477217863014411, 5.782561857293626],
            [15.47840114361963, 5.776063345591008],
            [15.478015855726293, 5.766272130027464],
            [15.480752658826878, 5.760817393486696],
            [15.479321709136538, 5.758685932207386],
            [15.4811282149128, 5.752490533132486],
            [15.477686120815482, 5.750790774462195],
            [15.477742474158186, 5.744609867695664],
            [15.471632547266449, 5.741705753830235],
            [15.468328443065213, 5.7368834675267575],
            [15.468245666052988, 5.731818055299961],
            [15.465692823729048, 5.728589700184501],
            [15.467632718048314, 5.724966608485216],
            [15.467498628924005, 5.719337127987874],
            [15.464754414564158, 5.714866059160244],
            [15.461816784869592, 5.714265923649843],
            [15.458497566598565, 5.706650137159867],
            [15.405715282892313, 5.691147493381785],
            [15.36561653152621, 5.680113981628107],
            [15.363552360281462, 5.68715500808904],
            [15.320970954895424, 5.6745959695334625],
            [15.276538774047532, 5.6620062522026915],
            [15.23004662326215, 5.649452808577774],
            [15.225622664925549, 5.648444948145382],
            [15.099913930311846, 5.612589826249613],
            [15.08752090681095, 5.608630205107836],
            [15.039148344122953, 5.594883060573438],
            [15.030987264865567, 5.624074861475852],
            [15.020512110210268, 5.659629125472361],
            [15.011384492746702, 5.693076503037282],
            [14.996495456168995, 5.746402510169567],
            [14.976236818608946, 5.821649221019328],
            [14.972221298077127, 5.837435634797485],
            [14.95030696670308, 5.919104430964416],
            [14.943218825062408, 5.944965923131494],
            [14.940596177266986, 5.948332815574123],
            [14.934278016779913, 5.946035208576216],
            [14.92792445725593, 5.942559678462405],
            [14.918986558043107, 5.943463802244796],
            [14.918681108216656, 5.9411355178875525],
            [14.9137703526631, 5.939595867658269],
            [14.911796087917848, 5.941265931781318],
            [14.905627676767006, 5.940386724866082],
            [14.900635486163905, 5.94136789951876],
            [14.900063000667707, 5.94701476420378],
            [14.897653047381498, 5.953021250938549],
            [14.90112814588947, 5.9611333772634785],
            [14.902497932554093, 5.967782191344147],
            [14.90895673238512, 5.9674349902136825],
            [14.910300356546125, 5.969582183632516],
            [14.9060578956218, 5.9757050021876355],
            [14.906529361665832, 5.978950738009311],
            [14.910043036095141, 5.984771766248351],
            [14.908420561353497, 5.988259712304935],
            [14.902635656340276, 5.9842938361295195],
            [14.89779849972976, 5.985143730220295],
            [14.892591589004764, 5.989964251088451],
            [14.890127534692617, 5.9978773379049],
            [14.89014629359276, 6.004218304132661],
            [14.885631203089902, 6.006038874725083],
            [14.886376065586774, 6.01185005952073],
            [14.880721418434593, 6.01527781774736],
            [14.881177598100363, 6.018435711540719],
            [14.878298037722292, 6.020821951975711],
            [14.873518648365154, 6.017655069534059],
            [14.871181327651168, 6.019532166476251],
            [14.872077060504395, 6.025592528490693],
            [14.868641726418806, 6.028731819250432],
            [14.873134326395638, 6.030261093691541],
            [14.87569808385394, 6.026432724584497],
            [14.879760860043271, 6.024987117253203],
            [14.883528286528184, 6.02834105493898],
            [14.893227335656462, 6.030148168177255],
            [14.897805806173487, 6.023490857664561],
            [14.90232756320321, 6.023553980669989],
            [14.904235932585115, 6.026426452163591],
            [14.909718330209513, 6.028211977037958],
            [14.913067339418511, 6.031241465184317],
            [14.917869435502016, 6.024858653542163],
            [14.919762035140181, 6.018512898691464],
            [14.923136618965978, 6.0176230832658755],
            [14.93701504952664, 6.017230307906822],
            [14.951908608582118, 6.018036738422652]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.66962983919638, "lat": 42.9127178581053 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36053"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00974125"
      },
      "bbox": [
        14.868641726418806, 5.594883060573438, 15.4811282149128,
        6.050244189529817
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.110106530904886, 6.879582551350165],
            [16.17162345905921, 6.903147233273309],
            [16.228651703737754, 6.924645407295341],
            [16.23772061517139, 6.928229386463916],
            [16.29419687532075, 6.949581269334622],
            [16.407343144946225, 6.992960230671545],
            [16.48746726648534, 7.024317588763652],
            [16.49015974739907, 7.025594873823281],
            [16.529223792644302, 7.039440823923486],
            [16.53083663967929, 7.037502846130929],
            [16.524979029258944, 7.028703364330574],
            [16.522737242483984, 7.021656906736247],
            [16.519134809591716, 7.014720828737728],
            [16.516559689402186, 7.013819120180995],
            [16.513157582499282, 7.008197719690295],
            [16.51358363188584, 7.002872978925132],
            [16.521952522149547, 7.001980518297926],
            [16.524907146629968, 6.998835065110098],
            [16.52539185832879, 6.995413825248882],
            [16.521889353140054, 6.991783532846531],
            [16.525261300829136, 6.985229027118427],
            [16.525247273711347, 6.982532914966689],
            [16.528781986941574, 6.974861517811588],
            [16.52811533211521, 6.968768211979275],
            [16.53013903709955, 6.966883792849271],
            [16.529396612068055, 6.9590902846514275],
            [16.525961055869587, 6.953260738676041],
            [16.527570499592176, 6.950483965730267],
            [16.52614065196799, 6.943936531267505],
            [16.52840946952715, 6.94002653610234],
            [16.526049646052538, 6.93615731769213],
            [16.526827194217194, 6.931926524579274],
            [16.52433202094707, 6.930840172190793],
            [16.523324924337963, 6.923653409055533],
            [16.52458249620929, 6.911260529907964],
            [16.522332759929714, 6.903688452871503],
            [16.52000714443597, 6.90041531315271],
            [16.522996147724974, 6.898466662361918],
            [16.52546790965655, 6.888256048552011],
            [16.525232361955034, 6.884944936554069],
            [16.520388656982167, 6.876720373961922],
            [16.520746500778976, 6.873688786309471],
            [16.51567207551598, 6.871146449932023],
            [16.515448819292626, 6.8658216149296205],
            [16.510318772282808, 6.864687159996063],
            [16.506713766575835, 6.862097247994365],
            [16.506233153384322, 6.858616779993369],
            [16.500565741898875, 6.8500215513405545],
            [16.496450178524967, 6.834681942853317],
            [16.494187541452266, 6.832249663668173],
            [16.494188472197525, 6.826929039940568],
            [16.489347113933366, 6.818498431782077],
            [16.48974217806529, 6.812857364843],
            [16.487767914467067, 6.81027984292151],
            [16.486007894467132, 6.803181331190973],
            [16.481193627507793, 6.798714558796462],
            [16.483610796477606, 6.7930736722453435],
            [16.479103844867737, 6.789162632407732],
            [16.4787803027819, 6.786998802141944],
            [16.472780360151475, 6.78367282660535],
            [16.468391177339537, 6.783108381968839],
            [16.463862995127766, 6.771744755037116],
            [16.469995435564993, 6.767921056498086],
            [16.46857021542429, 6.756384401550335],
            [16.466708908169732, 6.751063486473349],
            [16.467288419061784, 6.742521916255714],
            [16.469183185539467, 6.734765430791832],
            [16.465323275230343, 6.734713810735422],
            [16.462585498275942, 6.731199157558734],
            [16.462096195764133, 6.720138145077771],
            [16.464031612514383, 6.713078114162077],
            [16.462241666588326, 6.7091160888736345],
            [16.465430844672245, 6.7072333380244435],
            [16.470198208874894, 6.699876685204333],
            [16.491167460919335, 6.645842641088176],
            [16.53230826750641, 6.540987832950997],
            [16.53658656189163, 6.530455202752352],
            [16.525798793932456, 6.528512172443156],
            [16.513183256604062, 6.522929557659813],
            [16.507308569513807, 6.524573548981541],
            [16.503168582946486, 6.52068580657522],
            [16.50635543708262, 6.510253181807233],
            [16.500401671409456, 6.50555592703702],
            [16.488394717898853, 6.504379922206476],
            [16.48638435447339, 6.5023852050928586],
            [16.4868654061021, 6.494167996236687],
            [16.497186529965546, 6.4868225855928445],
            [16.49453386408562, 6.478120086976734],
            [16.48898671050602, 6.475386858950894],
            [16.48450094534217, 6.479166274339318],
            [16.4832738094877, 6.482966610208526],
            [16.478072284110446, 6.492791277164498],
            [16.473345216590666, 6.492501770950127],
            [16.47233488228028, 6.487694583582455],
            [16.465301520857142, 6.485871148324417],
            [16.462099080422984, 6.4795005375100505],
            [16.45494705228832, 6.47689450092221],
            [16.447730376905017, 6.472305702044531],
            [16.443821456224875, 6.466938189214324],
            [16.44771550284791, 6.456742516977037],
            [16.446236184154703, 6.444056765626547],
            [16.44256625575259, 6.437666772404512],
            [16.437302959088907, 6.430789724810764],
            [16.43585849703176, 6.421121843765917],
            [16.433279403132957, 6.420061379220468],
            [16.427226331262666, 6.424409473264563],
            [16.423005610953272, 6.43053238611552],
            [16.415015039740844, 6.437003670061755],
            [16.410919097301846, 6.43931523085828],
            [16.40263233127506, 6.441541699157474],
            [16.39111250315463, 6.439151260110948],
            [16.39071793164731, 6.43632928331275],
            [16.387247836115122, 6.433157781538425],
            [16.382025612015337, 6.435382497026976],
            [16.37891253441725, 6.439466498775814],
            [16.37627886497953, 6.451244648751149],
            [16.377167855173568, 6.456608664994179],
            [16.380585494394847, 6.462786250134765],
            [16.380527374134473, 6.4656785730164295],
            [16.37760971034624, 6.470790371514077],
            [16.376144813276355, 6.485362950672524],
            [16.373961971075893, 6.4912564753002036],
            [16.368692162246965, 6.489522855563175],
            [16.365856236588137, 6.4906394576139945],
            [16.358595798144574, 6.501489792358599],
            [16.353072254420933, 6.505385086183183],
            [16.348845315552495, 6.505823045391171],
            [16.344805661825596, 6.5100070187354815],
            [16.347058683111168, 6.515156207617063],
            [16.34610625927897, 6.519473667409024],
            [16.337731204143108, 6.523913081475255],
            [16.33431226680424, 6.533081443016493],
            [16.32786763745697, 6.536209232107336],
            [16.325211118285633, 6.541720406721439],
            [16.326578628052673, 6.5490176100940936],
            [16.32127643328144, 6.56005202605209],
            [16.31149737260255, 6.5716395083559584],
            [16.297298464285692, 6.56615315420711],
            [16.21508293009823, 6.535065619992461],
            [16.12323781463807, 6.500419503475603],
            [16.095718801384425, 6.578393243483412],
            [16.0732762653822, 6.641910120436285],
            [16.026864985167606, 6.772436939530408],
            [16.003306085378235, 6.838560761245471],
            [16.110106530904886, 6.879582551350165]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.84596853062834,
          "lat": 43.560971185249905
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36113"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00974154"
      },
      "bbox": [
        16.003306085378235, 6.420061379220468, 16.53658656189163,
        7.039440823923486
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.617358885389882, -1.7438017901687461],
            [13.704046066530232, -1.7282045972616613],
            [13.833064223274512, -1.704985221849376],
            [13.858540381405604, -1.7002699666500853],
            [13.858116919523209, -1.6946187527704633],
            [13.854642846565824, -1.6924526413515084],
            [13.848204424082502, -1.691590855080026],
            [13.845946714241768, -1.6894681069410928],
            [13.84531903142831, -1.6798008620176519],
            [13.843363717699525, -1.676915197365262],
            [13.843113662082594, -1.6696520282423037],
            [13.867945104673947, -1.6683886933880168],
            [13.938192770512043, -1.664451709229347],
            [13.978438243251649, -1.6618670104516733],
            [14.029873984023594, -1.650108071519549],
            [14.116095615569602, -1.6294802970139923],
            [14.117982408370757, -1.654867379429125],
            [14.114928557444017, -1.6792410144905676],
            [14.111872477726147, -1.6984969249153552],
            [14.109775472002587, -1.7062086714865043],
            [14.109571523811562, -1.7292903848062129],
            [14.10406381115708, -1.7875076214302648],
            [14.099180548378307, -1.829050699907899],
            [14.095459240172179, -1.8624808009150116],
            [14.09211496922307, -1.8982249713683166],
            [14.130419874124508, -1.9059146965719163],
            [14.159433356687725, -1.9127409999287244],
            [14.128174038861683, -1.9823938596885244],
            [14.114370045051864, -1.9706330847209834],
            [14.10386568442456, -1.965834552330808],
            [14.092973566258948, -1.96719880959814],
            [14.086844988577276, -1.9667067886269505],
            [14.08023503434227, -1.9636892241084467],
            [14.072558768662955, -1.9571992164048626],
            [14.070548195665193, -1.9543494114519617],
            [14.06383506633062, -1.948951541812101],
            [14.059501004175111, -1.9469281093180015],
            [14.05724713208539, -1.9424168257006509],
            [14.056957522893114, -1.937492146316139],
            [14.05180764030337, -1.9313127639650784],
            [14.049031712517186, -1.9203834290210218],
            [14.04056427041462, -1.9154506213494285],
            [14.033950247124883, -1.9099693759941574],
            [14.025848850054105, -1.9062061350377453],
            [14.014903197437908, -1.9042720930342323],
            [14.006379721182284, -1.8998933227989276],
            [13.996891639003609, -1.902278232384934],
            [13.993222825782393, -1.8981752904195333],
            [13.988930772528134, -1.8989074228544651],
            [13.985060615988395, -1.903603572653508],
            [13.975388212834646, -1.9050668937254103],
            [13.968906118539792, -1.911597691298229],
            [13.965492449048217, -1.92134862164788],
            [13.9641535603085, -1.927973972527843],
            [13.958306613782103, -1.9366607204595194],
            [13.954780080099534, -1.9400646579906768],
            [13.946695513594818, -1.9519078038719793],
            [13.944594477746135, -1.9562199841426144],
            [13.935267774942645, -1.9602949458267585],
            [13.934496794416047, -1.963449333487562],
            [13.93852760382221, -1.973195654691754],
            [13.939196726167783, -1.9779060182725732],
            [13.927788960735176, -1.9835483375167227],
            [13.921133046241344, -1.9897685672165746],
            [13.918654787107217, -1.9858181576999865],
            [13.921421194291858, -1.9815627818252854],
            [13.922505357365504, -1.9740518014285657],
            [13.917532757201888, -1.9719862650766584],
            [13.911297064050823, -1.9737264548302529],
            [13.903971082059254, -1.9725761450481019],
            [13.90146236714284, -1.9742724489280172],
            [13.904090902753751, -1.981277512685367],
            [13.903854442932671, -1.9906055228764634],
            [13.900116081909918, -1.9962159613873305],
            [13.894155524893312, -2.00853659613718],
            [13.889637499296255, -2.013900682009079],
            [13.883508514920589, -2.0159189571557374],
            [13.879442064563898, -2.0142520883136052],
            [13.868676640751223, -2.007347981808562],
            [13.870369841984255, -2.0017740361584613],
            [13.874793705213575, -1.9972440562738425],
            [13.872217074640165, -1.9941437239710356],
            [13.865940534558067, -1.9973126173968554],
            [13.860345748635869, -1.9980054519277906],
            [13.857822395269611, -1.9996964292229882],
            [13.857799791234049, -2.003599290999606],
            [13.848366048029964, -2.0103044934246714],
            [13.843315092647615, -2.0120259995531047],
            [13.85051590903406, -2.016067960529101],
            [13.854995441988619, -2.020003052613207],
            [13.854719438308507, -2.02237973781526],
            [13.847929424412474, -2.029545367885392],
            [13.842351481862776, -2.030926746278746],
            [13.838482501423055, -2.0305346089808944],
            [13.835147753842678, -2.0351668095444793],
            [13.826740864913274, -2.040091959116611],
            [13.75606776442278, -2.0538313769969174],
            [13.663800043953499, -2.0717650763325546],
            [13.651207878807057, -1.987731179834224],
            [13.647049227374094, -1.955490843385226],
            [13.64374975649571, -1.9281452527660217],
            [13.6373344532601, -1.8778308561581767],
            [13.632401465435242, -1.8442868330170548],
            [13.617358885389882, -1.7438017901687461]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.25540045939489, "lat": 35.70260787177777 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37037"],
        "coty_name": ["Chatham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chatham County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01008544"
      },
      "bbox": [
        13.617358885389882, -2.0717650763325546, 14.159433356687725,
        -1.6294802970139923
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.38619536709851, -2.016794898685543],
            [12.38815539055172, -2.0114926582904817],
            [12.391273562766706, -2.0085191071630764],
            [12.391207703374999, -2.0048915501617044],
            [12.395999791178884, -1.9974403879083824],
            [12.400929696037572, -1.993914411175414],
            [12.406335293011823, -1.9868798559612735],
            [12.405092498610637, -1.9805128104222336],
            [12.407001703325651, -1.9743372959485939],
            [12.41038915931524, -1.9712606298718962],
            [12.415024094009414, -1.9612200727438984],
            [12.41590607867035, -1.9523473757989334],
            [12.427472087210125, -1.9272857950483269],
            [12.439940901264263, -1.8227317794673],
            [12.435539057829384, -1.7841573286298744],
            [12.407659796206913, -1.7386220406820196],
            [12.447625167509882, -1.7188242994094294],
            [12.468858057929332, -1.7171615372692486],
            [12.522531899301494, -1.7100098764686398],
            [12.562462409613484, -1.7047476619334785],
            [12.67222748949601, -1.6904093127269049],
            [12.683134137855816, -1.796409490162777],
            [12.692723738719339, -1.889736099577184],
            [12.677865465506551, -2.020208063778884],
            [12.67128300444487, -2.0779202938671255],
            [12.717194698844557, -2.201258931141278],
            [12.715862163370671, -2.2049635472232714],
            [12.718309481593684, -2.213324637172469],
            [12.722293326852567, -2.2200928397219144],
            [12.72468574894795, -2.2299813045305816],
            [12.72540911501479, -2.2390919134475635],
            [12.68800483329862, -2.2449160215100266],
            [12.643583780267893, -2.2479558724982005],
            [12.588977953214124, -2.251875373454875],
            [12.560805532801382, -2.2832412914971387],
            [12.559198062816364, -2.2802349676220155],
            [12.551421303534095, -2.2784373149737025],
            [12.547393781155726, -2.2749846682974106],
            [12.54513376935348, -2.267887247404283],
            [12.549430009493, -2.25910118887787],
            [12.546917683169868, -2.2495354576862523],
            [12.547296995720135, -2.2404456496446845],
            [12.556876109683497, -2.2455493918166742],
            [12.560476624974232, -2.2422945149441436],
            [12.559140722567607, -2.239579629077155],
            [12.5484398159644, -2.2317566220798155],
            [12.542747806980934, -2.228807273635502],
            [12.54139100701664, -2.226565129818633],
            [12.545423880506913, -2.2184768969768442],
            [12.541469235679426, -2.2093357226459354],
            [12.540584943085205, -2.199302391760934],
            [12.542893482715144, -2.1913529765728588],
            [12.546901218758984, -2.1866190061054245],
            [12.553269202658626, -2.1833671651342437],
            [12.555408757039622, -2.17949147229708],
            [12.552370494143974, -2.1732069937465472],
            [12.547995219069572, -2.170597385053686],
            [12.545312989352478, -2.166810584742789],
            [12.546659369361397, -2.160625312769611],
            [12.548814661182975, -2.157025860254673],
            [12.55310952092969, -2.1552706974324423],
            [12.557009107040983, -2.151480013720257],
            [12.557090146808841, -2.148576227239995],
            [12.552012865748738, -2.1437815816179415],
            [12.545517132724267, -2.1400954641350505],
            [12.539892772782265, -2.1344011155979263],
            [12.53383792238796, -2.13186197831675],
            [12.531253707305009, -2.1292201303088922],
            [12.528806732322797, -2.1231325019767047],
            [12.52526724004227, -2.1194951301018703],
            [12.5227035817337, -2.114256116815596],
            [12.518285627670984, -2.110449157067714],
            [12.516388722701969, -2.103948780737612],
            [12.509976614536273, -2.0989245199351503],
            [12.502922917322909, -2.095218136891309],
            [12.50073277317237, -2.089983388996958],
            [12.497049962286138, -2.0856805671688785],
            [12.493436275642802, -2.0839878160937038],
            [12.489376411543859, -2.076495497285392],
            [12.482591519922337, -2.07139694513056],
            [12.478290571001795, -2.0695106371587584],
            [12.469186087146653, -2.0688631540920412],
            [12.460801728384471, -2.0724204799205626],
            [12.455694771991235, -2.0757580594826885],
            [12.445352476456145, -2.0775656630520416],
            [12.43578968101563, -2.0766856068417616],
            [12.431202957820663, -2.0726264978210045],
            [12.429673089891166, -2.0663321893697155],
            [12.429899550677963, -2.059006208659552],
            [12.426159905410525, -2.0511074105644203],
            [12.423967894374917, -2.0486486163394226],
            [12.416516402400472, -2.0440835049142896],
            [12.411459681950749, -2.038823578026492],
            [12.404300067986409, -2.0335394767409745],
            [12.404451795450827, -2.0258516556656554],
            [12.40119109270713, -2.0229997081146385],
            [12.394108808331405, -2.024290266272672],
            [12.391348524809686, -2.0226382468738273],
            [12.38619536709851, -2.016794898685543]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.87345602397995, "lat": 35.80705222824899 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37097"],
        "coty_name": ["Iredell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iredell County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01008565"
      },
      "bbox": [
        12.38619536709851, -2.2832412914971387, 12.72540911501479,
        -1.6904093127269049
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.335487212842462, -1.9468385737855467],
            [14.345080717622162, -1.9341840587214478],
            [14.40786967086719, -1.846098166657277],
            [14.48245439250612, -1.7403744348933572],
            [14.488336817602429, -1.7318056440569483],
            [14.48941224844099, -1.7281371761115432],
            [14.49481757837358, -1.7238098455280126],
            [14.498401803999542, -1.7256488206725955],
            [14.530660784592442, -1.6942682626607295],
            [14.563786844839013, -1.661549804286802],
            [14.592124910067543, -1.632857230485981],
            [14.63044358401934, -1.5934518344311892],
            [14.63873472371489, -1.5839184244730236],
            [14.643442183577223, -1.592643672872292],
            [14.64645645183135, -1.6028444870770404],
            [14.648198784976026, -1.6055838988455329],
            [14.653191258986832, -1.608055202550783],
            [14.652177422084204, -1.6110647862039682],
            [14.652025741819337, -1.6197517325667872],
            [14.652727453791217, -1.6282198725239259],
            [14.66226763763734, -1.6318068089964657],
            [14.663060515244059, -1.6357776766073806],
            [14.66640860855812, -1.6388713093649472],
            [14.666989627885977, -1.6432096726962502],
            [14.669606046208393, -1.6466560825388499],
            [14.67443621586641, -1.6465793657167505],
            [14.679152544883305, -1.6410078975299105],
            [14.682285373916166, -1.6437115511957539],
            [14.684017126814064, -1.6495702137160906],
            [14.686310705984514, -1.65003645719704],
            [14.685331837883373, -1.656109350378804],
            [14.688801569434498, -1.6609593552966966],
            [14.696598604324045, -1.6653799869198667],
            [14.704680692728921, -1.6635563687756219],
            [14.705611125629511, -1.6611748207442698],
            [14.713680990786688, -1.6613636953687856],
            [14.71596310156535, -1.6645478881147449],
            [14.719088098600949, -1.6644541645732878],
            [14.720633983632823, -1.6707768000329335],
            [14.725126109960534, -1.671312643317572],
            [14.728050490009249, -1.6746190531120877],
            [14.733330578037938, -1.6740624275221616],
            [14.734424937396868, -1.675757123205682],
            [14.736032978335754, -1.6886601121611957],
            [14.741481935674516, -1.700861393661811],
            [14.782231753801069, -1.7774561396864583],
            [14.7906103406787, -1.7786112376708747],
            [14.83373835957179, -1.7859656924074945],
            [14.818108950471892, -1.856714983564394],
            [14.815520623909386, -1.8678298634082857],
            [14.800207414298983, -1.9377553963652125],
            [14.793916307997291, -1.965443963931955],
            [14.799761881477945, -1.990836462899367],
            [14.802803529983619, -1.9904343079220448],
            [14.80804246683132, -1.9939599818934715],
            [14.807637038788641, -1.9986872026853018],
            [14.799650013175459, -2.0082747262120395],
            [14.797459633703356, -2.016684005381009],
            [14.801780125259208, -2.0218489636021113],
            [14.801482239279633, -2.0268838026241225],
            [14.806932374663932, -2.0268414286243384],
            [14.807883289878449, -2.0316956124192247],
            [14.804077485330415, -2.035684694357002],
            [14.798912505029108, -2.0378153743761827],
            [14.790076783951235, -2.0395335664484415],
            [14.788809484789594, -2.0420089012506013],
            [14.783800876043388, -2.0416531488899547],
            [14.783324300902214, -2.044081080288566],
            [14.77503801838785, -2.045214021280093],
            [14.772035555824669, -2.048124321328627],
            [14.765392410192815, -2.0509325174166895],
            [14.760164856232718, -2.050124088181699],
            [14.759046610637089, -2.0594134283647314],
            [14.74875368137828, -2.071087727680031],
            [14.743067014335512, -2.075491733045038],
            [14.737846617049408, -2.076026349341983],
            [14.73035967640749, -2.072120171662561],
            [14.721122814760244, -2.0766824779587147],
            [14.719273111465581, -2.07874674326941],
            [14.716988486201556, -2.0853567828154516],
            [14.706128396957974, -2.087464169074071],
            [14.70182129026169, -2.101909377970949],
            [14.697849370998417, -2.1172066584699847],
            [14.694981483351523, -2.1184777831515453],
            [14.62994488292751, -2.1552309099032096],
            [14.620291782522358, -2.1655373355605962],
            [14.58902426850126, -2.167325915487883],
            [14.554920545358815, -2.1688464519492854],
            [14.537305068263416, -2.1533363598896003],
            [14.524967084122213, -2.141918971712413],
            [14.519974138622942, -2.134656135494831],
            [14.508202328794805, -2.123118116364202],
            [14.509743614087178, -2.1192184523322477],
            [14.506799472155864, -2.1124593183088303],
            [14.511544334771132, -2.10350190705394],
            [14.50543364850139, -2.0942833390826356],
            [14.501500982649192, -2.0928500175790727],
            [14.48978490678537, -2.0852402105972274],
            [14.480436283399273, -2.0812945995587553],
            [14.478997685483336, -2.077447487378497],
            [14.474244485928494, -2.075207414922813],
            [14.474053535432544, -2.0709987254668776],
            [14.46970175717356, -2.0646245062709876],
            [14.468152955671753, -2.058696605953472],
            [14.455919129973157, -2.0508710547681552],
            [14.451435109286262, -2.0508235667313186],
            [14.44735978253968, -2.0466889283777627],
            [14.441440839153202, -2.031058251187409],
            [14.430926803990488, -2.023844434418336],
            [14.43221673908844, -2.0185548235499384],
            [14.419828575645926, -2.007181928602124],
            [14.41759079640418, -2.0024060143747078],
            [14.411492495853366, -1.995569642874285],
            [14.402068503573314, -1.9939098996932882],
            [14.396410305136346, -1.990261227019029],
            [14.390631410465069, -1.9849159832412018],
            [14.388580877421113, -1.9745966604954321],
            [14.385994520478683, -1.9739417651139697],
            [14.383014965139887, -1.9679792138547114],
            [14.378091986472194, -1.962795323864078],
            [14.366214667918584, -1.964849975723192],
            [14.354988139214457, -1.9588869675708165],
            [14.352960606270502, -1.9493811679464812],
            [14.350835106907947, -1.947724817187956],
            [14.335487212842462, -1.9468385737855467]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.36569248248546,
          "lat": 35.517827781447494
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37101"],
        "coty_name": ["Johnston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnston County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01026327"
      },
      "bbox": [
        14.335487212842462, -2.1688464519492854, 14.83373835957179,
        -1.5839184244730236
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.495780475675, -2.104554471478125],
            [13.598584621623134, -2.0844789119814426],
            [13.663800043953499, -2.0717650763325546],
            [13.75606776442278, -2.0538313769969174],
            [13.826740864913274, -2.040091959116611],
            [13.826030713818593, -2.042433479907372],
            [13.83738374356677, -2.0513753075507744],
            [13.841546838870578, -2.058205685383072],
            [13.839916283208776, -2.0640791390321933],
            [13.835896520127259, -2.0683303730088483],
            [13.832430860724905, -2.0805816278698064],
            [13.828652393346626, -2.080763426643103],
            [13.82946911034631, -2.086358096321608],
            [13.832063341280833, -2.09379683301313],
            [13.83783745258426, -2.094163024805981],
            [13.835814625826236, -2.098346166629892],
            [13.845710581142791, -2.1056324525665726],
            [13.847092188478419, -2.1088569638291474],
            [13.85190018670745, -2.1105554362814716],
            [13.856802733050934, -2.1148571275846715],
            [13.859952113814803, -2.1193104167677763],
            [13.858945054692686, -2.130078087415444],
            [13.862313376774548, -2.1328911300765583],
            [13.868191085415885, -2.1319388759311955],
            [13.875592542208997, -2.139033383183839],
            [13.877673471580074, -2.14317993670121],
            [13.882777253863363, -2.1459210486499902],
            [13.892492357433195, -2.149700991784151],
            [13.895553219489791, -2.148279124589688],
            [13.90274038171523, -2.1619710158216696],
            [13.90972154640917, -2.1701666006809184],
            [13.913099688238503, -2.1804416222554783],
            [13.916405334758052, -2.1837461735770742],
            [13.91659181746711, -2.1927389152672316],
            [13.924271274771947, -2.1996574668253492],
            [13.933734971710997, -2.2000099867407044],
            [13.962796384699121, -2.2142428517210635],
            [13.965019911016782, -2.214668723875073],
            [13.996434828768185, -2.2258279699466392],
            [13.971920786801794, -2.270165684651279],
            [13.980930946434457, -2.27418967893438],
            [13.990591561391435, -2.277480281535597],
            [13.99841960578375, -2.2837694966418227],
            [14.004132853474122, -2.2856366661188527],
            [14.011746484530404, -2.2843664171966624],
            [14.017844574883446, -2.2877540720932736],
            [14.022898440587703, -2.288922794871857],
            [14.029025116187864, -2.295938652323894],
            [14.034261917843784, -2.299788565217885],
            [14.035273524177102, -2.3077398446721964],
            [14.03842492191011, -2.3137157870778893],
            [14.049801416259172, -2.3143336462259447],
            [14.053252973734343, -2.318407099018295],
            [14.061302489390776, -2.317583798139428],
            [14.082425221604572, -2.3241035806947306],
            [14.086844800717186, -2.3274910259260984],
            [14.085602617180292, -2.3312705730025143],
            [14.087015606312942, -2.339304209765574],
            [14.08901865986227, -2.3416519674290464],
            [14.088637489592665, -2.345432453477886],
            [14.08648739775712, -2.3481450708010554],
            [14.082285236050216, -2.345142449051888],
            [14.07982953518924, -2.345775725672944],
            [14.07795346985031, -2.351567108717994],
            [14.071284709031222, -2.3511383750563155],
            [14.068282870074553, -2.3569284743302377],
            [14.064697028172931, -2.3524618694695483],
            [14.058023169999016, -2.3489703534140687],
            [14.057131911908577, -2.354206646720805],
            [14.053551666451552, -2.3570995303539672],
            [14.050627379648166, -2.354635460673347],
            [14.04524184699882, -2.3532600235487084],
            [14.04291777609117, -2.3494759832094023],
            [14.038166611397818, -2.346042221588028],
            [14.031539558201219, -2.3487951877586895],
            [14.026034938973414, -2.343466207326731],
            [14.025871506535411, -2.3389914019780926],
            [14.02211059121149, -2.338409426109789],
            [14.019507602243264, -2.3418868073799985],
            [14.015651954885305, -2.338723918338686],
            [14.012499896002087, -2.338769896767481],
            [14.004948223799888, -2.3420880841534504],
            [13.994367281954457, -2.342088050170903],
            [13.988035702439666, -2.3387522792130166],
            [13.986331462668309, -2.3350653339558853],
            [13.982027686979276, -2.3331091347108144],
            [13.976662143062546, -2.3281753084274],
            [13.971196712981062, -2.3290423207655917],
            [13.963802461708125, -2.328153534831663],
            [13.96146803956106, -2.3341699340996653],
            [13.957443141286141, -2.3395030391860505],
            [13.954732215807976, -2.3384137757546823],
            [13.95071773214603, -2.344682238406373],
            [13.945789036992972, -2.345213269373182],
            [13.941856121336373, -2.349555329140531],
            [13.93574059386783, -2.353684777706196],
            [13.933889666222456, -2.3586064756568152],
            [13.930558919070876, -2.359112696309199],
            [13.929690934063066, -2.363034693937802],
            [13.91895251287341, -2.3770084820637023],
            [13.918337384541212, -2.3817020686450383],
            [13.909781599912838, -2.3846142131513015],
            [13.9038075789777, -2.3916065039530556],
            [13.901089470012213, -2.3918235965207386],
            [13.883252771859391, -2.4237737429329287],
            [13.881392765952643, -2.4261696146721463],
            [13.869536869319788, -2.4469411530864362],
            [13.858172847106829, -2.4661549680816823],
            [13.84128403243119, -2.4936997238983607],
            [13.82326534287781, -2.526234069282279],
            [13.809517204492602, -2.520645378669031],
            [13.80613243048402, -2.5155245271265403],
            [13.7930638623189, -2.514093435848619],
            [13.78565586657714, -2.5117608631179342],
            [13.781031438623671, -2.5153677423147047],
            [13.77246515559499, -2.5139293557836764],
            [13.76071529410567, -2.514286640574346],
            [13.759473026402064, -2.515608632782685],
            [13.74666042726874, -2.516391975978954],
            [13.734729221003002, -2.5212480062962332],
            [13.72799861207775, -2.516806566658614],
            [13.725017320626273, -2.5165603607609737],
            [13.720447298641284, -2.5081379752907544],
            [13.71710644539466, -2.5035619589796845],
            [13.716311246166542, -2.4975939176699935],
            [13.719134329264485, -2.4909193172163038],
            [13.720259134689908, -2.4846132653676407],
            [13.71811243715557, -2.4753802150683315],
            [13.71760828467227, -2.4646074470655446],
            [13.716509396020733, -2.462671331043099],
            [13.709117750828536, -2.4598815407777663],
            [13.706169253035082, -2.4530168568245028],
            [13.702537477433856, -2.44982591999924],
            [13.69436962307862, -2.4467784062086584],
            [13.68708533898045, -2.4422526542035596],
            [13.684569776889433, -2.442728317621194],
            [13.682418686431989, -2.436657108138135],
            [13.67869745909427, -2.432729972738316],
            [13.678115560905592, -2.4288059162206026],
            [13.676609663075377, -2.42507429499912],
            [13.672066795330162, -2.4221634312091767],
            [13.666601473840817, -2.4243207679292897],
            [13.665573923640919, -2.419964712942158],
            [13.657771146149576, -2.419626701220617],
            [13.655289503122269, -2.4162177465280323],
            [13.645786444579047, -2.408822260817546],
            [13.641598179326826, -2.4087789606424517],
            [13.637386944203056, -2.4048984147212846],
            [13.632825192100276, -2.394564572245281],
            [13.630826324980251, -2.385866590379795],
            [13.627309501808448, -2.377221035680107],
            [13.627322918496375, -2.373234341910882],
            [13.623891728716508, -2.3715134263253743],
            [13.62097891956811, -2.360960386466729],
            [13.617617466797517, -2.356130684376231],
            [13.606854214024244, -2.3552399496393654],
            [13.60272622683645, -2.3537238447806357],
            [13.596153780440833, -2.35317179216573],
            [13.59167136571598, -2.3494609641283173],
            [13.588675586024554, -2.343409065373758],
            [13.587473554360601, -2.3375817527963627],
            [13.580818714810832, -2.3309053451879644],
            [13.578976748160212, -2.323348298234712],
            [13.579142925354539, -2.3140772230415343],
            [13.577309733492063, -2.307400273474214],
            [13.578096340973548, -2.305400383842278],
            [13.542906788883515, -2.2223490376290815],
            [13.520265599376078, -2.16938332671932],
            [13.509116518544676, -2.1466800843208382],
            [13.50490528319633, -2.1395578080969098],
            [13.499700467255185, -2.1219824219079655],
            [13.495780475675, -2.104554471478125]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.48138286676541, "lat": 35.31068132045009 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37125"],
        "coty_name": ["Moore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moore County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01008573"
      },
      "bbox": [
        13.495780475675, -2.526234069282279, 14.08901865986227,
        -2.040091959116611
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.50027628499905, -1.5290466701254803],
            [12.503162107560032, -1.5262892643336499],
            [12.51291294741241, -1.522399596888796],
            [12.517771469896012, -1.5216721057157883],
            [12.528225076784437, -1.5157479541566308],
            [12.536147566720265, -1.5092800967482094],
            [12.541337539559278, -1.5079415806339038],
            [12.548539655502118, -1.5028524313987968],
            [12.553633575918084, -1.5038251023862084],
            [12.55839043121144, -1.5077872924908036],
            [12.568013828505213, -1.5012537969040702],
            [12.57176576212483, -1.4964623991755543],
            [12.568631769647759, -1.485985508269659],
            [12.569126524499847, -1.4817168411882815],
            [12.572497425401483, -1.4781652211753076],
            [12.576465293009552, -1.4772267183576455],
            [12.584352276958903, -1.4817946891240696],
            [12.58705362830607, -1.48514304643778],
            [12.591267779948435, -1.4867879649405351],
            [12.59624861078217, -1.4785904709661373],
            [12.597236890771, -1.4710102001976444],
            [12.600392612546875, -1.4678772511756166],
            [12.604858909474315, -1.4704506379799023],
            [12.604431583703223, -1.4784421970261585],
            [12.608336496306727, -1.48020885577735],
            [12.616057518608446, -1.4759276185784835],
            [12.621712960524157, -1.4783717695783778],
            [12.635752330041496, -1.4764900382987494],
            [12.64381666095015, -1.4727040421272763],
            [12.64781424320371, -1.4751867542078907],
            [12.651857859640286, -1.4835320144435793],
            [12.654696530278992, -1.4871147793484218],
            [12.65835655589813, -1.488451741299135],
            [12.671102315957722, -1.4847416833949736],
            [12.674731108542273, -1.4793690589181807],
            [12.673696228399303, -1.4736855308905552],
            [12.675977011319862, -1.4634856946767285],
            [12.687329674300551, -1.4612423225439797],
            [12.688618887515107, -1.4576385830915448],
            [12.683213382599613, -1.4504777592559344],
            [12.685141710887502, -1.4463690035783074],
            [12.688445751342242, -1.4469618665465553],
            [12.695852099917508, -1.45235926436922],
            [12.705850625932305, -1.4554779009505483],
            [12.711022516023485, -1.4589661027942868],
            [12.715994722949223, -1.4598056980823555],
            [12.725011500373903, -1.450294029675215],
            [12.732128516824837, -1.4457312239195241],
            [12.740047031388663, -1.4424729778055112],
            [12.744898767584647, -1.4420899617963796],
            [12.748757769574656, -1.4385317017547656],
            [12.755442813010626, -1.4403649678145347],
            [12.758298543939334, -1.4425521006104114],
            [12.760555975369668, -1.4487487839211313],
            [12.761355164186902, -1.4612169654764668],
            [12.766007918673642, -1.4637235889889189],
            [12.789839067736809, -1.4589478329925838],
            [12.804761011309736, -1.4593759557551247],
            [12.80871189509236, -1.4539820109552488],
            [12.817005277245174, -1.453489711611761],
            [12.821164381447822, -1.4566401716947204],
            [12.823160532284863, -1.4640069031736387],
            [12.831083161024852, -1.4697495863216785],
            [12.845041215424317, -1.4795411228586075],
            [12.851070835519078, -1.4906429860963777],
            [12.851357780780807, -1.4924569484810997],
            [12.844499094140753, -1.496054560353982],
            [12.841875469368773, -1.4999168517751709],
            [12.841809758438405, -1.5038794042303103],
            [12.849804605774432, -1.5189920707673708],
            [12.850008014483139, -1.5225573256921743],
            [12.847920258505729, -1.5266675632921958],
            [12.848962786302371, -1.5308632916400422],
            [12.85267265958935, -1.533325894181651],
            [12.855561710628422, -1.540555642074196],
            [12.855063795260502, -1.5483978871753254],
            [12.852945837575724, -1.5524731553288],
            [12.853850418408976, -1.5594005392326007],
            [12.858845336164412, -1.5702492412446873],
            [12.85873353868703, -1.572286393899227],
            [12.852202278496089, -1.5807090933556363],
            [12.849611979040864, -1.5885892451725703],
            [12.84324667872497, -1.5943122851465408],
            [12.83499066297162, -1.5947681102620461],
            [12.828133795780149, -1.598254542674656],
            [12.823805288397361, -1.5993506375938784],
            [12.810457359186644, -1.6092275695168243],
            [12.808969939480047, -1.6211978294613094],
            [12.805720869340496, -1.6258563669504544],
            [12.806405585288461, -1.6349745129729238],
            [12.807948325898508, -1.6383261584980409],
            [12.812698041029016, -1.643338757801788],
            [12.81555803262177, -1.651562457211814],
            [12.817108286882064, -1.6598950302537574],
            [12.819319094217718, -1.6636816207285896],
            [12.82866958400304, -1.6696587244160797],
            [12.747770152748714, -1.6816984607393306],
            [12.695739940339072, -1.6878374992167648],
            [12.67222748949601, -1.6904093127269049],
            [12.562462409613484, -1.7047476619334785],
            [12.522531899301494, -1.7100098764686398],
            [12.517799997768597, -1.6747819876077201],
            [12.509669421420503, -1.6046469118734001],
            [12.50027628499905, -1.5290466701254803]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.66523469103205, "lat": 36.16050524235413 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37197"],
        "coty_name": ["Yadkin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yadkin County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "01008597"
      },
      "bbox": [
        12.50027628499905, -1.7100098764686398, 12.858845336164412,
        -1.4385317017547656
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.747059862144836, 8.026396050214682],
            [-2.694135192022773, 8.024165733845912],
            [-2.60874765969553, 8.019605402835024],
            [-2.5474385868463485, 8.01662918740061],
            [-2.521002523421195, 8.015209180776427],
            [-2.43424863272641, 8.01118363015169],
            [-2.377639049304894, 8.008285145759807],
            [-2.376319893150691, 8.008486245519423],
            [-2.34735736202616, 8.006988787744843],
            [-2.3056284090620855, 8.004859056846525],
            [-2.2333703070322266, 8.001773125586237],
            [-2.2373588524987436, 7.913792480667367],
            [-2.2444427687782627, 7.756540127206485],
            [-2.2445901959068477, 7.756107973289796],
            [-2.248145623381941, 7.671833344257504],
            [-2.248545646587481, 7.65658781092086],
            [-2.221980310775838, 7.6551690609115415],
            [-2.2238645269607873, 7.612224271381121],
            [-2.2245475458270705, 7.602346917803237],
            [-2.226449622755367, 7.548857821190248],
            [-2.2267908115284896, 7.546710960774701],
            [-2.231877130201313, 7.43251908319501],
            [-2.2370614263411186, 7.317845374857636],
            [-2.2966832588547907, 7.320438393301646],
            [-2.3684898993563324, 7.323795668340434],
            [-2.4392916708021604, 7.327182705223109],
            [-2.5115669884852534, 7.330797127883779],
            [-2.5250208955589146, 7.331720335334095],
            [-2.6058733419559137, 7.335577486081824],
            [-2.619921350309769, 7.336409433125914],
            [-2.6677404638797215, 7.338632826211404],
            [-2.676498798160559, 7.339067090584871],
            [-2.676203192519295, 7.343201301021701],
            [-2.6729779644134517, 7.350474743999821],
            [-2.6719912136667445, 7.361556826208537],
            [-2.674431474543472, 7.368974384005695],
            [-2.681235181744648, 7.384670132518083],
            [-2.6872819962391117, 7.3954411657666155],
            [-2.6930029536455513, 7.396604354406299],
            [-2.7001099044887322, 7.399420087990192],
            [-2.706957584163272, 7.4047026415349295],
            [-2.7118636013770114, 7.412668905361365],
            [-2.7161021933963196, 7.422883325673848],
            [-2.7191144780256242, 7.426794085242367],
            [-2.7269107538470414, 7.439656777836462],
            [-2.732604166218348, 7.447066451380487],
            [-2.7377031355115635, 7.456628262928129],
            [-2.7416098401883247, 7.469204911229821],
            [-2.7427908579399314, 7.479172106867898],
            [-2.7426339365717176, 7.485209562546937],
            [-2.739878988173113, 7.494589888277724],
            [-2.739455861821571, 7.506062827920487],
            [-2.74059274657948, 7.512657156802695],
            [-2.747136719947536, 7.5241569729258995],
            [-2.748655970175358, 7.531233000506387],
            [-2.748456648587771, 7.540220007119169],
            [-2.746229479535731, 7.548389406247038],
            [-2.740756357303523, 7.56031767090111],
            [-2.7374208222027243, 7.56600118755408],
            [-2.7240396919796517, 7.5853645792982025],
            [-2.7207163711617013, 7.590850518312911],
            [-2.7144023055489654, 7.597876865756446],
            [-2.7088323291698617, 7.602463221953995],
            [-2.7029808893042055, 7.612879092448707],
            [-2.6961126305691323, 7.627543801289622],
            [-2.6939896885990238, 7.635126396974582],
            [-2.694036785059762, 7.642751517408051],
            [-2.6993440745776285, 7.650628765555782],
            [-2.7078835778222783, 7.666183557457463],
            [-2.708886881380116, 7.669795406514235],
            [-2.707861381247439, 7.675191081750342],
            [-2.703908267193413, 7.682327568111029],
            [-2.6976252925367503, 7.690342739735846],
            [-2.6918507819018216, 7.700757734635152],
            [-2.687294735509441, 7.711824240036299],
            [-2.6839870817715683, 7.721464072649636],
            [-2.683396554119435, 7.749442223515219],
            [-2.683736845663992, 7.755296375263012],
            [-2.6885328689146757, 7.773531883686819],
            [-2.694260851947654, 7.786765049556865],
            [-2.7016688116476106, 7.808090836698981],
            [-2.7075863898086365, 7.820145042858061],
            [-2.711878822894082, 7.831428783198353],
            [-2.7125137972170816, 7.836739871472303],
            [-2.711911689125694, 7.843496757488182],
            [-2.707515601820271, 7.857032805205064],
            [-2.7056140786137837, 7.870489648192814],
            [-2.7019840991627557, 7.883961654464372],
            [-2.6959456833452293, 7.896390286523072],
            [-2.68466726585662, 7.902254374844984],
            [-2.6759222768991937, 7.909358389399022],
            [-2.672311162861365, 7.914677795669834],
            [-2.6710298391191523, 7.9230939798310835],
            [-2.6915114065867938, 7.9526159165914825],
            [-2.6983960108130667, 7.963607317984722],
            [-2.6972293210221054, 7.969282781821101],
            [-2.6938201427185553, 7.970518283080817],
            [-2.687442792305371, 7.9672767315616015],
            [-2.6832372752417357, 7.967839353984227],
            [-2.67999844251113, 7.973439998090282],
            [-2.679802710132035, 7.976963697859333],
            [-2.6844006613759386, 7.983287826167278],
            [-2.6955706611504584, 7.989202611324211],
            [-2.7070967542688864, 7.993907989354957],
            [-2.722949351192039, 8.00307980882939],
            [-2.7256597060532024, 8.005227361748101],
            [-2.733183189461599, 8.013991852086212],
            [-2.7414635468895168, 8.020816517815845],
            [-2.747059862144836, 8.026396050214682]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.23874551025614,
          "lat": 46.285068732087694
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38029"],
        "coty_name": ["Emmons"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Emmons County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01035615"
      },
      "bbox": [
        -2.748655970175358, 7.317845374857636, -2.221980310775838,
        8.026396050214682
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.488427706461014, 3.0635234526935253],
            [9.602401000434952, 3.0789226214314285],
            [9.6601339485046, 3.085551298782594],
            [9.710130163417018, 3.091600106224282],
            [9.737780865184012, 3.094364629502344],
            [9.770977306905491, 3.098165866716004],
            [9.797000851392275, 3.102301770432592],
            [9.829225036659627, 3.1069292567966027],
            [9.834919947254816, 3.06321265201463],
            [9.84100458888786, 3.01963038285309],
            [9.84989268438508, 2.9541928327445492],
            [9.853039694268796, 2.932455131301168],
            [9.825219037483784, 2.9285401862888523],
            [9.83107010253966, 2.885476420886959],
            [9.816897201579566, 2.8834588127026684],
            [9.822687641120824, 2.840118257988044],
            [9.794442786096415, 2.8365386704785363],
            [9.805073149845159, 2.7495680355041285],
            [9.7598297403351, 2.7443693298933716],
            [9.704049798336213, 2.7376847626841734],
            [9.668455821246614, 2.7331530322720017],
            [9.618594197177169, 2.72635153892234],
            [9.533844894037344, 2.716117481406796],
            [9.520687067878447, 2.816501896384132],
            [9.514177218877643, 2.8662198232289584],
            [9.500451388483867, 2.9721871670102926],
            [9.488427706461014, 3.0635234526935253]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.66654678686352, "lat": 41.00193465270213 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39063"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01074044"
      },
      "bbox": [
        9.488427706461014, 2.716117481406796, 9.853039694268796,
        3.1069292567966027
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.556222880278378, 2.5409930045054745],
            [9.545235205190192, 2.628728312241081],
            [9.533844894037344, 2.716117481406796],
            [9.618594197177169, 2.72635153892234],
            [9.668455821246614, 2.7331530322720017],
            [9.704049798336213, 2.7376847626841734],
            [9.7598297403351, 2.7443693298933716],
            [9.805073149845159, 2.7495680355041285],
            [9.819670348602354, 2.751298686963756],
            [9.821532385587194, 2.735339590657413],
            [9.830861323114368, 2.6638956678931573],
            [9.831708003079456, 2.6640035165376283],
            [9.83551794084223, 2.6350539170763483],
            [9.84881474248289, 2.636792539173877],
            [9.862472560744264, 2.6392838659751097],
            [9.876803918764592, 2.6412473320679064],
            [9.878661671426517, 2.6266646609082116],
            [9.894000618743434, 2.62790212436848],
            [9.89956251394907, 2.586478216483751],
            [9.903387426264102, 2.5551071435257455],
            [9.907344850684405, 2.527560316551438],
            [9.910993849014153, 2.508177656765982],
            [9.919971979208043, 2.4570551584772904],
            [9.919046216620702, 2.4466252668153468],
            [9.84331570335943, 2.435420592335571],
            [9.842956802216635, 2.441011355454253],
            [9.754864831953297, 2.4372543659522123],
            [9.689825279784689, 2.43397189814123],
            [9.570836695437771, 2.4282628051604576],
            [9.56993581524483, 2.435057829416129],
            [9.562625130046, 2.4902555134031656],
            [9.556222880278378, 2.5409930045054745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.65947542398673, "lat": 40.66153618801079 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39065"],
        "coty_name": ["Hardin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardin County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01074045"
      },
      "bbox": [
        9.533844894037344, 2.4282628051604576, 9.919971979208043,
        2.751298686963756
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.1525016545205, 1.6539853490228047],
            [10.148736382713818, 1.704274394412864],
            [10.145970499011678, 1.7357502176352633],
            [10.145707924697007, 1.7420689945852268],
            [10.143288728979055, 1.7719147890929348],
            [10.181363954128043, 1.774786503339213],
            [10.1878949446565, 1.7747300707233662],
            [10.200942050458593, 1.775883389941217],
            [10.236952370311107, 1.779853315639552],
            [10.271623540907415, 1.782871293560879],
            [10.294536236599006, 1.785137229627115],
            [10.299643112047725, 1.7861277432564515],
            [10.375608973324503, 1.7919450211053052],
            [10.408389936080466, 1.7940898816106763],
            [10.462001084763022, 1.797818259250244],
            [10.470246250375393, 1.6779287029082055],
            [10.472183993771061, 1.6511393614486527],
            [10.474652784423466, 1.6513193509633937],
            [10.480426459086262, 1.562510033889923],
            [10.494706513272181, 1.5634447901429573],
            [10.565702465248567, 1.567269729111189],
            [10.570820164296386, 1.480258781564482],
            [10.563840975302497, 1.478985965368958],
            [10.486600905489402, 1.4736412945904986],
            [10.436359126962666, 1.4699738816762762],
            [10.374181851481056, 1.4648590075519727],
            [10.375414705053736, 1.4732796406693442],
            [10.379260568522968, 1.476756040963414],
            [10.386264754583351, 1.476913111259153],
            [10.386057764708474, 1.4876751453534496],
            [10.381618974527495, 1.4902977008225913],
            [10.380838355524723, 1.4929659394635044],
            [10.374803270618772, 1.4917620033616343],
            [10.283951816302466, 1.4832704107800116],
            [10.25072825907709, 1.4802763371751506],
            [10.165855990870929, 1.4733453369100689],
            [10.163329456967022, 1.510120626492798],
            [10.158021164745403, 1.5824815644059336],
            [10.155075924600844, 1.616949695743065],
            [10.1525016545205, 1.6539853490228047]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.02434948125396,
          "lat": 39.641900877436214
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39129"],
        "coty_name": ["Pickaway"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pickaway County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01074077"
      },
      "bbox": [
        10.143288728979055, 1.4648590075519727, 10.570820164296386,
        1.797818259250244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2897164080248604, -4.428416543688496],
            [-1.2467057787373068, -4.429304715253073],
            [-1.1893222551002633, -4.43093697675164],
            [-1.1747765200040245, -4.431660502411349],
            [-1.0893131769005062, -4.433289507106882],
            [-0.9746787742112265, -4.435418737819519],
            [-0.8818805798391774, -4.437212734984544],
            [-0.817062497718967, -4.438238819839236],
            [-0.818986236636182, -4.555033533653387],
            [-0.82053324701062, -4.657245676808041],
            [-0.8192353955976907, -4.657266931805101],
            [-0.8204546684102415, -4.725716807753608],
            [-0.8168101290188626, -4.7267706149133915],
            [-0.8155799198692985, -4.730531601978469],
            [-0.8110382044211658, -4.735114657952929],
            [-0.8077702457320189, -4.741376940980034],
            [-0.8053661659215039, -4.741026212826762],
            [-0.8009773515053128, -4.745215428382468],
            [-0.8206631262845947, -4.744808342348813],
            [-0.8221864703139008, -4.829506500815126],
            [-0.8285962860854094, -4.82760394549095],
            [-0.8317520113834835, -4.829683504529225],
            [-0.8388087071806974, -4.8291421389179225],
            [-0.8454722887922705, -4.824771313947301],
            [-0.8467578741279231, -4.819046947214754],
            [-0.851100500779694, -4.814790503256396],
            [-0.8515594564831167, -4.808297560028738],
            [-0.8469243249090319, -4.80037048543691],
            [-0.8466251060639536, -4.797318000417174],
            [-0.8499586827551121, -4.789558757566412],
            [-0.8487322435609098, -4.783874804213348],
            [-0.8443136823829877, -4.776634339164892],
            [-0.8455884119484822, -4.774381851736034],
            [-0.8529956391755287, -4.772029727154471],
            [-0.8541584875868106, -4.767659126620262],
            [-0.8607177605609587, -4.760080564175118],
            [-0.8660111275857265, -4.758521918388053],
            [-0.8733263214667115, -4.752077113733166],
            [-0.880807893172628, -4.746519413650486],
            [-0.8991223607158108, -4.737937477638548],
            [-0.9034424788087821, -4.736526649408723],
            [-0.9118933559562736, -4.735824592182807],
            [-0.9253494739080365, -4.740370878819227],
            [-0.9295873621534131, -4.743216141911583],
            [-0.9336607189602575, -4.749538787329558],
            [-0.9390468987688001, -4.763496849663686],
            [-0.9437454659376234, -4.771786757077046],
            [-0.9497133871104807, -4.779041179583578],
            [-0.956845922679699, -4.785561021011036],
            [-0.9626708510897031, -4.789827496410528],
            [-0.9677711903037406, -4.789001658627344],
            [-0.9796991683433295, -4.789156854768807],
            [-0.9878264976756798, -4.791671049807765],
            [-0.9878047248267897, -4.795236152773617],
            [-0.9855820990023227, -4.800936469754421],
            [-0.9853430594701417, -4.8073571598220335],
            [-0.989028311824362, -4.8118868561466535],
            [-0.9963571446264756, -4.811609395747292],
            [-0.9986365864729986, -4.807820692550757],
            [-1.0020461563559644, -4.806142533376061],
            [-1.0065473074754567, -4.80897634535178],
            [-1.0074170464139656, -4.812545702392188],
            [-1.002852506167948, -4.821076398738161],
            [-1.002807456118394, -4.83055857548002],
            [-1.006713931955934, -4.835258781284716],
            [-1.0094265895766201, -4.834019191136419],
            [-1.0115762604122764, -4.827460575180134],
            [-1.0173074168723457, -4.826374797162641],
            [-1.0208788444345256, -4.831359802118534],
            [-1.0205849349058438, -4.8393454534904174],
            [-1.0216871990990388, -4.845685092511562],
            [-1.0257673275639594, -4.849192177463885],
            [-1.0298033093356627, -4.844344525791189],
            [-1.0330135619494374, -4.8433517213380055],
            [-1.0353864018229182, -4.846308504262045],
            [-1.035387948503945, -4.855528215180037],
            [-1.045308617570164, -4.863485680713424],
            [-1.0482418673767655, -4.86756766278457],
            [-1.0556121641797436, -4.868261865759067],
            [-1.060809382273698, -4.870693232551211],
            [-1.0743106525348425, -4.8753727141123955],
            [-1.0790018023641443, -4.875674352065491],
            [-1.0838732779266307, -4.874338738223896],
            [-1.0885855097473884, -4.870103515316742],
            [-1.0996672809179535, -4.866246538209016],
            [-1.1067492897058, -4.86053727963283],
            [-1.132201762815818, -4.84428863865407],
            [-1.1371213687779362, -4.843544988410722],
            [-1.1441416427303572, -4.844828416479206],
            [-1.1500771802351653, -4.8439487018987935],
            [-1.1577039220125223, -4.8405275420045335],
            [-1.1658119199376233, -4.832876128739645],
            [-1.1705688349113401, -4.8254307834068895],
            [-1.1711302399169334, -4.82190172602405],
            [-1.1671538273896895, -4.811241272897281],
            [-1.1646409606826593, -4.810141660076877],
            [-1.1589386800508432, -4.816836700575921],
            [-1.1544520624504755, -4.8155244833475885],
            [-1.148288345417261, -4.80856607349637],
            [-1.1442911276515977, -4.793557536191623],
            [-1.1447365006293964, -4.786556270059386],
            [-1.146442537763915, -4.784772997277115],
            [-1.1529986220144361, -4.786595468253859],
            [-1.1593606369206941, -4.78556847642231],
            [-1.1616713818134698, -4.782347388263682],
            [-1.1604301947566196, -4.778117208570018],
            [-1.1546696882686456, -4.775359062292375],
            [-1.1501417187753702, -4.770897078136018],
            [-1.147178673642182, -4.764356030974335],
            [-1.1375353609200396, -4.73453111787997],
            [-1.1388150258135306, -4.731836484184153],
            [-1.1430435593220485, -4.732693075535946],
            [-1.1476661551674123, -4.731863103710902],
            [-1.1514649449752519, -4.728381278625225],
            [-1.1583406136680894, -4.716991565650859],
            [-1.1637483859615716, -4.716926765177827],
            [-1.1713880447677416, -4.7223562351364246],
            [-1.1865069572945461, -4.725915515363446],
            [-1.197920832991371, -4.7278440282742125],
            [-1.2157247568697866, -4.7278144588819115],
            [-1.2272562555600224, -4.725171345513706],
            [-1.2498511316845942, -4.718081246512002],
            [-1.2541955529550166, -4.714903714114394],
            [-1.2495319556250208, -4.709667256649103],
            [-1.2550022171390498, -4.701036026205506],
            [-1.2622075508634212, -4.696209103163337],
            [-1.2684090040480678, -4.6857905990464905],
            [-1.2660724462945312, -4.681446531763598],
            [-1.2615263687234555, -4.681837999215654],
            [-1.2569888626307213, -4.6862680524758344],
            [-1.249893433538574, -4.683684215686976],
            [-1.2498054352906611, -4.67860039501133],
            [-1.2621952838918902, -4.671377410125289],
            [-1.2746245390241082, -4.657399833455167],
            [-1.27902337336067, -4.647410121288752],
            [-1.2795008290993717, -4.638218490432976],
            [-1.278095881199423, -4.635026938068197],
            [-1.2653752511638106, -4.621519142209146],
            [-1.2575356869220604, -4.608641242575373],
            [-1.2536345875802863, -4.597886277670483],
            [-1.252753246546144, -4.591645249312026],
            [-1.2545264824422757, -4.587855726558582],
            [-1.2615056266183386, -4.588279983634723],
            [-1.2636162727704743, -4.584390342049852],
            [-1.2613151431618195, -4.577467124509586],
            [-1.2623428177907574, -4.572727116511825],
            [-1.2683583995356325, -4.565278455111499],
            [-1.2797725803014692, -4.5645939948189715],
            [-1.2859702931923251, -4.568482898331078],
            [-1.292869910713662, -4.577096650847338],
            [-1.292241508453101, -4.5376601571284025],
            [-1.2897164080248604, -4.428416543688496]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.83585713088115, "lat": 34.11105917920838 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40067"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01101821"
      },
      "bbox": [
        -1.292869910713662, -4.875674352065491, -0.8009773515053128,
        -4.428416543688496
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3338527471238233, -3.6703795589078547],
            [1.3327929158965806, -3.5759014984880495],
            [1.3322822690707514, -3.525060353805086],
            [1.4242187623803892, -3.5242512213409705],
            [1.4229891278318816, -3.407170524447473],
            [1.4232190905849782, -3.402403014481539],
            [1.433486207051418, -3.400654943313228],
            [1.4387428828640836, -3.398439356092335],
            [1.441798484120954, -3.3941223137365744],
            [1.446127787866052, -3.383137663591583],
            [1.4513162417771266, -3.3742998920903435],
            [1.4583054300862701, -3.3697561641892233],
            [1.474049040181666, -3.3678872360000685],
            [1.4841068430311213, -3.3700922221325103],
            [1.4904541426146167, -3.3727251867748733],
            [1.4981784700065397, -3.3786849570932076],
            [1.5030901185075205, -3.3849045143153176],
            [1.5117548583662956, -3.3920526566009115],
            [1.5224120221494504, -3.3945314733587173],
            [1.5272795612011019, -3.397061813190811],
            [1.5309429262950565, -3.4016751823951035],
            [1.5322527727685888, -3.4059373237904733],
            [1.5328860617390718, -3.4196343614376428],
            [1.5351632959461803, -3.4239060499172314],
            [1.5407457831114204, -3.4293651793528634],
            [1.545364528249065, -3.4317839325912693],
            [1.557650796945783, -3.43295287691747],
            [1.5693732270159024, -3.430228521640841],
            [1.5759611810592784, -3.426354053635005],
            [1.5834216992731878, -3.419610145248389],
            [1.5928817416159866, -3.4017747535978873],
            [1.5968883984932116, -3.3969198418810027],
            [1.6001155632041302, -3.3953323348190216],
            [1.614923515279349, -3.3942129504218546],
            [1.6208948590210033, -3.3973725353378676],
            [1.6328715032110872, -3.412723824839245],
            [1.6385790855775746, -3.4165315374737313],
            [1.6425761364468365, -3.417871372363205],
            [1.650030797142428, -3.4183913960544396],
            [1.6616171134924145, -3.4143225132631767],
            [1.668108622299657, -3.4179204691056437],
            [1.676244368623764, -3.4164684314788643],
            [1.6816062999397463, -3.421126408459863],
            [1.6890111400861998, -3.4173168158788014],
            [1.6923170008872461, -3.412515482062678],
            [1.6904380197153823, -3.403885940227405],
            [1.6832803993933785, -3.3966463238784272],
            [1.6809523098405512, -3.392248572555847],
            [1.6807695231395876, -3.3794027300314644],
            [1.690619371784044, -3.3726934528230443],
            [1.6921333195156203, -3.3694270654339897],
            [1.6876869397974943, -3.3613675559907974],
            [1.6869459407680847, -3.3568296361226793],
            [1.6893662699547192, -3.3522192233026766],
            [1.6979914818094572, -3.3456731617284934],
            [1.7077932592081897, -3.342638528618449],
            [1.7125074964888067, -3.342705185610013],
            [1.7195735196965993, -3.3409724803685976],
            [1.727891920963043, -3.3347713738381803],
            [1.7300412619766188, -3.3426190318527036],
            [1.731395137162928, -3.351418407406057],
            [1.730969992927193, -3.357439741292562],
            [1.730407167016378, -3.4149339360922597],
            [1.7298029491879494, -3.430049878773359],
            [1.7293370711875795, -3.471750741770883],
            [1.7285621875348418, -3.4826625881366366],
            [1.7288590718105843, -3.4910511942121314],
            [1.7281969888361746, -3.524934730058889],
            [1.7285460132791441, -3.5351141580825134],
            [1.7279776525904595, -3.5939015213140295],
            [1.7277403575024934, -3.6030492108647705],
            [1.7265978984705226, -3.694737989232404],
            [1.7254044561340345, -3.789955471748375],
            [1.7249202919865427, -3.828422019604886],
            [1.7251662945880435, -3.8337647126814556],
            [1.724788567770862, -3.8691352865377264],
            [1.7233279364914402, -3.996397455723483],
            [1.7223279836894358, -4.0829099452310835],
            [1.7224836199564721, -4.0909699035473315],
            [1.7218236025300133, -4.1785522228958865],
            [1.7215870668980238, -4.219192257712347],
            [1.547371280687954, -4.222005771839346],
            [1.45681347843574, -4.223195811713996],
            [1.3321574570702421, -4.22466915552198],
            [1.3319043204357415, -4.19333677333372],
            [1.331219308122041, -4.137907940870506],
            [1.3302422467429944, -4.050219243064328],
            [1.2306965250718405, -4.051321837595993],
            [1.2298373047088327, -3.992799206154692],
            [1.2295726812160177, -3.963726671229777],
            [1.2290423827298005, -3.8760118451163326],
            [1.2792324878481434, -3.875604708812574],
            [1.2783211185407743, -3.7992927469066577],
            [1.2780687198000091, -3.788022313228693],
            [1.3353367038013337, -3.787337363112552],
            [1.3338527471238233, -3.6703795589078547]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.7033857601783, "lat": 34.90030848123637 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40079"],
        "coty_name": ["Le Flore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Le Flore County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01101827"
      },
      "bbox": [
        1.2290423827298005, -4.22466915552198, 1.731395137162928,
        -3.3347713738381803
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.617203276073536, 8.462605485315473],
            [-17.61380715537891, 8.461685066862438],
            [-17.607295227001984, 8.46540962964718],
            [-17.612802229760135, 8.481916771999321],
            [-17.61146710596254, 8.489653717272912],
            [-17.606612480129716, 8.49120399373083],
            [-17.602387445164485, 8.501715595438364],
            [-17.607189931717436, 8.50634970383251],
            [-17.60401880923818, 8.509155168195731],
            [-17.603804196589532, 8.511939182972641],
            [-17.595022761254647, 8.520634082860578],
            [-17.588141338106535, 8.521450055749144],
            [-17.582027067642592, 8.52509705286632],
            [-17.57817176026583, 8.53009448276784],
            [-17.569096480356816, 8.530029057109521],
            [-17.569994970496293, 8.535382821791197],
            [-17.572407489510702, 8.535657179658536],
            [-17.574406918596544, 8.541582032472292],
            [-17.57918108344076, 8.546393209554143],
            [-17.583609390792976, 8.543819565173882],
            [-17.58659885949231, 8.546157794168064],
            [-17.59085345787145, 8.546832779415631],
            [-17.590418025846553, 8.550648634745201],
            [-17.596308739546107, 8.557909763248308],
            [-17.599380878144743, 8.559460087430285],
            [-17.60211499905031, 8.567366531483987],
            [-17.60011553546126, 8.577442821697154],
            [-17.591543807073098, 8.581502014743128],
            [-17.59154375128333, 8.586845875136726],
            [-17.58064155198439, 8.584285082551904],
            [-17.577443647943912, 8.584435461552852],
            [-17.568775397905412, 8.588172878798007],
            [-17.556879966219878, 8.586248562246025],
            [-17.554132300888202, 8.58998208349543],
            [-17.54621654670867, 8.593241595172774],
            [-17.52716646074324, 8.58801198925563],
            [-17.52834496507132, 8.58381234778453],
            [-17.40110866806232, 8.548769409628225],
            [-17.27388456848637, 8.51368043307813],
            [-17.177378085847884, 8.488052545779723],
            [-17.096087177541023, 8.466296403701145],
            [-17.094912472073297, 8.464108122387609],
            [-16.98137797568948, 8.433576413360296],
            [-16.90150184342626, 8.412222180928632],
            [-16.821630364241575, 8.390849930751846],
            [-16.71281677525083, 8.3620778445774],
            [-16.60401172567724, 8.333272403177864],
            [-16.611334386696143, 8.331246802524344],
            [-16.60962595153415, 8.32761445253994],
            [-16.610838959465358, 8.325068122738717],
            [-16.616748508844733, 8.32552695856586],
            [-16.61691408414977, 8.321528161336998],
            [-16.613120196791215, 8.319798422292049],
            [-16.61616608101857, 8.314857191900865],
            [-16.62400586137768, 8.311832764497522],
            [-16.62438291989819, 8.31903089084133],
            [-16.628620121163056, 8.317182855724415],
            [-16.63417650140712, 8.311308541703141],
            [-16.629006480328588, 8.303142662107911],
            [-16.63400870354501, 8.295150664207855],
            [-16.62839997872845, 8.286409496995807],
            [-16.630317899754285, 8.280104479957632],
            [-16.62917376308895, 8.277702010271287],
            [-16.65713844377385, 8.174121104543163],
            [-16.67565856629615, 8.102551664140748],
            [-16.67991680183484, 8.088681669030002],
            [-16.69378468123374, 8.092313176528894],
            [-16.824996344223262, 8.12551225116038],
            [-16.904110867130598, 8.14624372687377],
            [-16.983229671159467, 8.166958037447223],
            [-17.005120660878465, 8.084103449678395],
            [-17.11643059870364, 8.113647684535236],
            [-17.138590379011042, 8.030912214025062],
            [-17.199351148144935, 8.047301577194352],
            [-17.220483858941428, 8.053135741450005],
            [-17.30420986789196, 8.075663165337783],
            [-17.303588683061157, 8.077954980133109],
            [-17.34612547403108, 8.089271934285442],
            [-17.42468137139319, 8.110787710932684],
            [-17.471189475049986, 8.123734491610026],
            [-17.512367203884622, 8.134654795497903],
            [-17.556332860961565, 8.146028354181324],
            [-17.583245236322874, 8.153217757202528],
            [-17.608875794087226, 8.161236502771121],
            [-17.679335767393773, 8.180608464267907],
            [-17.67948969758221, 8.180060503300421],
            [-17.725408588841308, 8.19251061363355],
            [-17.725314259088208, 8.202345425674736],
            [-17.722803721563444, 8.206982582337297],
            [-17.719213934047115, 8.209759867395197],
            [-17.721124661489377, 8.214000396564446],
            [-17.719478344772746, 8.216883200477334],
            [-17.718053573663923, 8.225462642285377],
            [-17.718714690364465, 8.227881771264373],
            [-17.71668512801148, 8.232602612397821],
            [-17.711020594347474, 8.23937890423824],
            [-17.70995032773959, 8.242110210027693],
            [-17.711674262871316, 8.252713183344815],
            [-17.709383941699468, 8.266111941894895],
            [-17.704639821178443, 8.268375989779795],
            [-17.702079419033897, 8.275087654926748],
            [-17.70291457656224, 8.279785133022408],
            [-17.70494133642138, 8.281529937894124],
            [-17.701459226136027, 8.287332762106985],
            [-17.690869807421457, 8.292902988708404],
            [-17.688336532025023, 8.295963319356934],
            [-17.68260495283684, 8.298497074238691],
            [-17.67975149182061, 8.30205925322433],
            [-17.675969695104182, 8.302847773963583],
            [-17.669977946751175, 8.302052375742973],
            [-17.66866826222825, 8.305536536806233],
            [-17.66912578917748, 8.313499665735396],
            [-17.667676614346313, 8.31971909039938],
            [-17.668641731606893, 8.323085326060099],
            [-17.664547841956185, 8.33115589338452],
            [-17.65956097219552, 8.333280506077326],
            [-17.657850431770203, 8.337877807444242],
            [-17.654311089696236, 8.340475395581093],
            [-17.65169422197245, 8.346648201197734],
            [-17.651623607976408, 8.349626580460885],
            [-17.64673732278597, 8.35670798566646],
            [-17.646430482905892, 8.360004075937415],
            [-17.640862946606664, 8.37142670290068],
            [-17.637471548312906, 8.375712695172492],
            [-17.637379581528926, 8.379440178587343],
            [-17.640133515539432, 8.382819999224294],
            [-17.637729076681236, 8.38725181600986],
            [-17.640850324807058, 8.39689387759809],
            [-17.64349966492468, 8.398301872370068],
            [-17.638084717936394, 8.411034997658343],
            [-17.62956683783202, 8.419953207897176],
            [-17.62781343127673, 8.420661124053824],
            [-17.6273340197661, 8.426610926693959],
            [-17.625122101907383, 8.429381359351845],
            [-17.62431450250763, 8.43401704757381],
            [-17.625359033807, 8.437626251837731],
            [-17.62109781675326, 8.450814358369618],
            [-17.619576583962573, 8.457749195935197],
            [-17.617203276073536, 8.462605485315473]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.17605610997956,
          "lat": 44.629393498365026
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41031"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01155132"
      },
      "bbox": [
        -17.725408588841308, 8.030912214025062, -16.60401172567724,
        8.593241595172774
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.82540776582656, 9.179410080182404],
            [-18.816054304896127, 9.20944573099647],
            [-18.716249599558285, 9.179688316330706],
            [-18.666242007847085, 9.16408138708065],
            [-18.543854814551484, 9.128657321804782],
            [-18.495213094468568, 9.114010094268266],
            [-18.37274028182926, 9.078265801151769],
            [-18.373594543209126, 9.070011313016007],
            [-18.380732743168476, 9.052556171711013],
            [-18.382604160124508, 9.046739578407129],
            [-18.388559356555422, 9.037974140981026],
            [-18.394667576240057, 9.022429254164637],
            [-18.393808469715253, 9.01639387473598],
            [-18.394475691528392, 8.997853604295285],
            [-18.391531399393813, 8.995394808632014],
            [-18.381957247946918, 8.994568376144263],
            [-18.378080120826198, 8.99047233996487],
            [-18.377655733060056, 8.985723931547735],
            [-18.381749494695402, 8.970174571744527],
            [-18.38482708761907, 8.964597548392968],
            [-18.38555392927549, 8.960083114669606],
            [-18.390226692865053, 8.95271764224098],
            [-18.39332136580447, 8.94960949358828],
            [-18.4014385856188, 8.948309509966787],
            [-18.41233442585459, 8.942718477413052],
            [-18.416181913825135, 8.939690271964002],
            [-18.424284074075825, 8.940972421108421],
            [-18.42906677269524, 8.945583336209685],
            [-18.441374263784017, 8.949730583189462],
            [-18.444488146561252, 8.945631345539944],
            [-18.442565066365994, 8.9392233770266],
            [-18.444505641556102, 8.93686562544936],
            [-18.458018040503884, 8.932293148059298],
            [-18.463740627190635, 8.92514297086576],
            [-18.46988258232747, 8.915207201652366],
            [-18.476212635996077, 8.911239009516825],
            [-18.480396031097914, 8.905816007623015],
            [-18.4879328147242, 8.891447926749365],
            [-18.492381108301423, 8.891454629748445],
            [-18.50077110905394, 8.898396685896298],
            [-18.50283622267799, 8.89886022869934],
            [-18.51030320612169, 8.894047875548377],
            [-18.51551520784557, 8.87321786821636],
            [-18.513933025901277, 8.867899211226128],
            [-18.50870752567877, 8.863931475245737],
            [-18.500183659844772, 8.862989969812235],
            [-18.49764045027333, 8.858421558731068],
            [-18.494216900982728, 8.856285201914984],
            [-18.485746190200643, 8.854943400191956],
            [-18.4821347822159, 8.853483636589562],
            [-18.477811028257854, 8.848850906450403],
            [-18.473281578182082, 8.846391196563928],
            [-18.463161431021433, 8.835571647775764],
            [-18.464101478074415, 8.82862923923361],
            [-18.468485161988426, 8.823500799251951],
            [-18.473789220653796, 8.821626531839431],
            [-18.488400011343337, 8.821973232614116],
            [-18.491455495425832, 8.82098858318148],
            [-18.497440398225553, 8.815443003998626],
            [-18.499705139652406, 8.81090269036268],
            [-18.504218693889417, 8.80747065314873],
            [-18.511186488844142, 8.804290613112896],
            [-18.515625614207366, 8.795617728478948],
            [-18.517863685154808, 8.78684330098006],
            [-18.515864889514695, 8.783650243108502],
            [-18.512248370604233, 8.78068968243989],
            [-18.509852603807012, 8.776177369433778],
            [-18.51174299008533, 8.771874228470802],
            [-18.522619830096247, 8.767726218752932],
            [-18.52635892369994, 8.764709868041878],
            [-18.52748916460093, 8.757414544678074],
            [-18.549980395729342, 8.76380238313833],
            [-18.596761698251, 8.777552341085576],
            [-18.631577331444475, 8.787312782704337],
            [-18.704733935430806, 8.809434311025285],
            [-18.74600665500245, 8.821745197972623],
            [-18.79394021243826, 8.836415066240745],
            [-18.82141170276768, 8.842598392138504],
            [-18.835618234078975, 8.848589041905923],
            [-18.904811213068683, 8.869062029050832],
            [-18.8997535132601, 8.88598745644479],
            [-18.913601651560803, 8.89016237635011],
            [-18.906443654878622, 8.914168664511392],
            [-18.871532827164945, 9.029509007449143],
            [-18.86374037020004, 9.053796963370084],
            [-18.85344446463316, 9.087695545852801],
            [-18.83793978633824, 9.138051221042234],
            [-18.838736479629713, 9.138272961877396],
            [-18.82540776582656, 9.179410080182404]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.41320671752615,
          "lat": 44.90353681881381
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41053"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01135862"
      },
      "bbox": [
        -18.913601651560803, 8.757414544678074, -18.37274028182926,
        9.20944573099647
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.69218116005161, 9.22093020931879],
            [-15.645597235243681, 9.212785759216793],
            [-15.614490191376388, 9.216856687573937],
            [-15.568705228149337, 9.212407457641095],
            [-15.549229062515979, 9.200293100421524],
            [-15.529984582714185, 9.190626190789537],
            [-15.512455266326414, 9.186048367321698],
            [-15.481874375302063, 9.183886849675437],
            [-15.457263263641334, 9.187902676032763],
            [-15.432012536114572, 9.197758043157483],
            [-15.406222029760867, 9.20223323236999],
            [-15.391296977907942, 9.208886062729135],
            [-15.371956948223605, 9.225008677915897],
            [-15.340730381661205, 9.218208223667991],
            [-15.237617944796753, 9.193450228011997],
            [-15.135537367157593, 9.169088340331472],
            [-15.040490006254123, 9.146024321818594],
            [-14.917392736009846, 9.116660389185371],
            [-14.896032488999872, 9.111957839340235],
            [-14.859181806164553, 9.102907119583296],
            [-14.803003514323171, 9.090000788841573],
            [-14.789677181044784, 9.086454725675388],
            [-14.702062110386306, 9.06651501288797],
            [-14.689017573042511, 9.06341646246679],
            [-14.721075134363817, 8.928863448121618],
            [-14.717915296635171, 8.928121465869856],
            [-14.727896946217216, 8.886133177151688],
            [-14.776778522264216, 8.897700295207644],
            [-14.786844946669987, 8.855889076190888],
            [-14.801403074785332, 8.859209252981648],
            [-14.820879561558385, 8.777438535440679],
            [-14.855388870261956, 8.785726909178804],
            [-14.875408028596715, 8.701189476099254],
            [-14.896285823805691, 8.618654355324452],
            [-14.89489008260051, 8.618315105968833],
            [-14.905122047416722, 8.576082487684785],
            [-14.960798043781113, 8.588816950915623],
            [-14.970742714389516, 8.54724422096122],
            [-15.000591203330579, 8.554463445521467],
            [-15.000252855773143, 8.555858020222727],
            [-15.017902493194013, 8.560287467424232],
            [-15.08529912588795, 8.576075607539915],
            [-15.08394990095308, 8.582222988836214],
            [-15.095968803637447, 8.585008577021172],
            [-15.09432744053294, 8.592077996877228],
            [-15.108406105081583, 8.595389591546136],
            [-15.111538960459397, 8.582365336549072],
            [-15.12774483538037, 8.586153396884235],
            [-15.144851626650231, 8.51517884819944],
            [-15.172954835188216, 8.521841888311004],
            [-15.218667581306459, 8.532092491101515],
            [-15.271075458689038, 8.545079963554636],
            [-15.27472086098496, 8.53061594632044],
            [-15.303988408378942, 8.538103407114596],
            [-15.302842150973355, 8.542724115308603],
            [-15.331063243991204, 8.550022180143806],
            [-15.351341664458833, 8.465352199719547],
            [-15.323392848670396, 8.458642644041491],
            [-15.33768474763946, 8.400138203003301],
            [-15.26285839318462, 8.382164961270218],
            [-15.290878720464425, 8.270522192532942],
            [-15.27103532047683, 8.265713122373638],
            [-15.28783692758237, 8.197845542218788],
            [-15.290968337328962, 8.18401799348809],
            [-15.398072361868394, 8.211528452108988],
            [-15.447681777338422, 8.223725534553045],
            [-15.515938123715866, 8.240059534744496],
            [-15.584197470785256, 8.256380410361686],
            [-15.62256704407631, 8.264842971924999],
            [-15.73280310408918, 8.291546200091238],
            [-15.711904657950756, 8.37491133769368],
            [-15.70053423732486, 8.372112180064832],
            [-15.679520073199125, 8.456831896346168],
            [-15.659355463241212, 8.538466388188029],
            [-15.66002311943237, 8.538633508496172],
            [-15.61657965124285, 8.703915614637054],
            [-15.59520357243085, 8.787611922013395],
            [-15.66524812098853, 8.805019883667233],
            [-15.644684808584158, 8.887374523226708],
            [-15.770755564755758, 8.919662264600793],
            [-15.746013156897597, 9.01677739158786],
            [-15.733297207989454, 9.066556312643478],
            [-15.716564770938858, 9.133388300624404],
            [-15.706888807147694, 9.170330227692636],
            [-15.704995066533325, 9.170396664446297],
            [-15.69218116005161, 9.22093020931879]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.73687634312198,
          "lat": 45.59188255792349
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41059"],
        "coty_name": ["Umatilla"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Umatilla County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01156673"
      },
      "bbox": [
        -15.770755564755758, 8.18401799348809, -14.689017573042511,
        9.225008677915897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.516815197403123, 4.547681282771006],
            [13.575850911326695, 4.559700884943559],
            [13.643854053519025, 4.571577137074462],
            [13.66837904469005, 4.57558782351628],
            [13.788325086143125, 4.598377870833863],
            [13.847747634590911, 4.610130401929836],
            [13.948926810977415, 4.630567512929282],
            [13.9738604004507, 4.515756829446727],
            [13.989292736488075, 4.442755229860449],
            [14.006470892062271, 4.363015952899891],
            [14.021199088627515, 4.294203358543755],
            [14.045337343156369, 4.181385071146426],
            [14.046169120782851, 4.176399169513595],
            [14.058525287845859, 4.118724209270362],
            [14.039205203058993, 4.114576843198761],
            [13.996158347291113, 4.105933684027722],
            [13.953879855849292, 4.097205062145447],
            [13.936879594191742, 4.093919326275255],
            [13.892436027365106, 4.0848284645054385],
            [13.879696777450281, 4.081966455901688],
            [13.773834962225841, 4.059809192094355],
            [13.728991572347951, 4.051899689312004],
            [13.655322317562216, 4.115428557014955],
            [13.591231750676746, 4.170469845303821],
            [13.590442584722497, 4.171030570226735],
            [13.567651760587536, 4.288188810515658],
            [13.551425354678821, 4.369022524587352],
            [13.538214461054555, 4.43456136168316],
            [13.533200284708043, 4.4622729015239155],
            [13.516815197403123, 4.547681282771006]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.8958299149895, "lat": 41.7449011780998 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42105"],
        "coty_name": ["Potter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Potter County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01213684"
      },
      "bbox": [
        13.516815197403123, 4.051899689312004, 14.058525287845859,
        4.630567512929282
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.026999556178922, -3.7444412244164775],
            [12.029102242327607, -3.74256413829896],
            [12.02889504163483, -3.7384953931658185],
            [12.023263538890088, -3.734372029856968],
            [12.024078646828258, -3.729992852450768],
            [12.0192063447206, -3.724836559929703],
            [12.0166959683608, -3.7242750675671625],
            [12.018158936031366, -3.7188290472591863],
            [12.017059101085273, -3.7129035150812393],
            [12.02443231091778, -3.707513543142164],
            [12.028152508197664, -3.6995116384529685],
            [12.0338869039913, -3.697932778637548],
            [12.043791288761875, -3.7035390068726164],
            [12.046806460891698, -3.704030089488728],
            [12.049762322408219, -3.6976768478410547],
            [12.053564728611747, -3.698396463984118],
            [12.054800943713186, -3.701369779526643],
            [12.059017182362679, -3.701946782703118],
            [12.069142453943865, -3.6974297181639275],
            [12.078377858643549, -3.699044083640774],
            [12.084041419822402, -3.701358018578472],
            [12.087616631257072, -3.698047278078948],
            [12.091183256029714, -3.6968641837488785],
            [12.096739282347642, -3.704178821179238],
            [12.10064597657954, -3.7016342542370118],
            [12.101674060665486, -3.694092821179102],
            [12.107892734106889, -3.693049706880906],
            [12.115029634418569, -3.6881604638602634],
            [12.118921418564424, -3.6881962880100185],
            [12.12285633423666, -3.6855067151822003],
            [12.126748884953447, -3.6783032019347854],
            [12.131592487388897, -3.675588808136793],
            [12.136394962886724, -3.678183682578755],
            [12.143820591589849, -3.6849377738662605],
            [12.152095166734263, -3.6871728992069035],
            [12.159227308884283, -3.686283430638869],
            [12.162003676784087, -3.684789220379621],
            [12.166362369729196, -3.685254515147011],
            [12.173300159801192, -3.690517623291477],
            [12.179874929397885, -3.693093891774446],
            [12.184210666297005, -3.69977571674446],
            [12.194986170400577, -3.701914360039741],
            [12.199804316902153, -3.705165534303711],
            [12.206223058987813, -3.706576418316573],
            [12.214690176303067, -3.70514677789737],
            [12.219941647744815, -3.7089911634216355],
            [12.227189441511516, -3.7209795237711125],
            [12.231765124572982, -3.7243766909656686],
            [12.240903478479993, -3.724191204510345],
            [12.245150089543092, -3.7268433350570924],
            [12.247464469451002, -3.7321231079487838],
            [12.250520108928391, -3.733331912963782],
            [12.252744371638808, -3.7275549155262726],
            [12.257555205025438, -3.7280900507952284],
            [12.261699575645999, -3.7331179586472016],
            [12.275039881351915, -3.7432220210795473],
            [12.281553868153278, -3.7426891318768583],
            [12.289871269541006, -3.746695722853014],
            [12.29445558302038, -3.7461647721604407],
            [12.297298682438244, -3.7486851258764813],
            [12.300955207268373, -3.7550268656716397],
            [12.304143736650033, -3.757053683939465],
            [12.311059144590558, -3.754826420941648],
            [12.320498922676697, -3.7549065042873315],
            [12.324416463580324, -3.7534312721896685],
            [12.32865442499344, -3.758174241968472],
            [12.334937887252375, -3.7603357212273343],
            [12.345908063714239, -3.7533355793414978],
            [12.350225600482501, -3.749828998201861],
            [12.354722426365342, -3.7530742013754717],
            [12.359312100304258, -3.7538744517644056],
            [12.355281077171094, -3.7745250305108438],
            [12.34735097186305, -3.8056018803751335],
            [12.32983483164475, -3.8712948477106215],
            [12.320656127103904, -3.912047303543934],
            [12.311247348658663, -3.9486706820776525],
            [12.308795543260329, -3.9544672975985478],
            [12.308814966025555, -3.9642370896535195],
            [12.252934197152292, -4.036589551649006],
            [12.146380307908572, -4.020689728984323],
            [12.118863479929706, -4.011894990428036],
            [12.113252404547548, -4.007961528130261],
            [12.104076430135278, -4.005400552866072],
            [12.099943546079613, -4.008396892847319],
            [12.09425185733363, -4.007672333538444],
            [12.084904345954493, -4.000698135912574],
            [12.076149041957724, -3.9969319869992526],
            [12.071052987346347, -3.9937724072189322],
            [12.066192448775066, -3.988133337134385],
            [12.063096441088767, -3.9864354811004654],
            [12.030918889387195, -3.906449601150028],
            [12.000210896702088, -3.909500386500744],
            [11.947858602470985, -3.930219387939466],
            [11.94038861633961, -3.933890650600841],
            [11.940794359630706, -3.924074513586263],
            [11.94420617043387, -3.919749792259554],
            [11.943843769472064, -3.9167701082614372],
            [11.946478034341075, -3.911495248309282],
            [11.947296350005887, -3.905715766511479],
            [11.949732440637773, -3.9017585134485744],
            [11.95080406614503, -3.894996157557411],
            [11.954923454858777, -3.89070581336657],
            [11.974844607951182, -3.8591512310565252],
            [11.979545953828604, -3.849529618140965],
            [11.987524748053684, -3.8169430816729957],
            [11.99304715228537, -3.812902821504213],
            [11.99164402852208, -3.8097387814798664],
            [11.996212429282089, -3.806242706569553],
            [11.995507328927909, -3.8018178530531377],
            [11.99648032027525, -3.7941125464659526],
            [12.004861802678104, -3.7891976772163476],
            [12.008489393532185, -3.7882582934355966],
            [12.01152010248939, -3.782991430935734],
            [12.010557724334753, -3.774044970705879],
            [12.014055182831507, -3.77207029907655],
            [12.015412438535183, -3.7638998524217886],
            [12.02044686559474, -3.760767062000982],
            [12.021830527330888, -3.7551279855834796],
            [12.027504438136974, -3.749874659394359],
            [12.026999556178922, -3.7444412244164775]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.72675757235773, "lat": 34.00605952875774 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45081"],
        "coty_name": ["Saluda"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saluda County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01248016"
      },
      "bbox": [
        11.94038861633961, -4.036589551649006, 12.359312100304258,
        -3.675588808136793
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.315297123431519, 5.428261669156212],
            [-5.229822904994059, 5.421801839079397],
            [-5.144349878987415, 5.4153250071270955],
            [-5.1221660274303185, 5.413561332752421],
            [-5.043602981575759, 5.4076225828945885],
            [-4.973430821855849, 5.402553846993671],
            [-4.831292493723388, 5.3922087617612915],
            [-4.801651520516564, 5.3896797100233105],
            [-4.7091452137553995, 5.3828462188003465],
            [-4.616393700722887, 5.376023049544959],
            [-4.515773475640273, 5.3683930498611145],
            [-4.4584695353423776, 5.363994806879753],
            [-4.352584880457343, 5.355776485131532],
            [-4.335350579484693, 5.354572021948471],
            [-4.335268986748024, 5.351564125213831],
            [-4.340558869092472, 5.347240751192235],
            [-4.340268131284015, 5.344137894300002],
            [-4.336943039753026, 5.341739919371929],
            [-4.337526750955906, 5.338642280501079],
            [-4.341422273716958, 5.333072385565549],
            [-4.345974247506504, 5.3227633141337645],
            [-4.348232839733462, 5.311760567301799],
            [-4.34764044592407, 5.302190609157157],
            [-4.3453823309622335, 5.2977031249632835],
            [-4.353375000596781, 5.296637470932937],
            [-4.352807615501417, 5.29261944709874],
            [-4.354701053674487, 5.289683646735052],
            [-4.368606004636136, 5.276942696479973],
            [-4.37331555005293, 5.276154609443396],
            [-4.378507421892071, 5.27156777716256],
            [-4.375093088160896, 5.265759003818258],
            [-4.3784369148496385, 5.262234263155871],
            [-4.385653534464882, 5.258708077446567],
            [-4.389593921385825, 5.254305690299424],
            [-4.39074503113349, 5.249309670371013],
            [-4.394672301251004, 5.244033232437886],
            [-4.401607736878395, 5.24291145816141],
            [-4.4056642219635895, 5.237358879009112],
            [-4.403947995085774, 5.234420704736036],
            [-4.406031148596446, 5.230821137907752],
            [-4.409076457766219, 5.230728888423203],
            [-4.409877347792368, 5.225306673628576],
            [-4.419603864698366, 5.226462489602309],
            [-4.422927787279628, 5.218125998616447],
            [-4.428985748902102, 5.215488188083452],
            [-4.429652260838251, 5.21223499669641],
            [-4.42811596269609, 5.203931332873523],
            [-4.435065895397296, 5.203068117892744],
            [-4.440093599395845, 5.197207769771082],
            [-4.439597281896541, 5.194831854059312],
            [-4.4349827053760205, 5.19318526747505],
            [-4.434159142549321, 5.191250262208021],
            [-4.440138295171718, 5.181235859108143],
            [-4.440937805563649, 5.1777591784023524],
            [-4.439546106931522, 5.173487908643614],
            [-4.447156135619926, 5.170549761614547],
            [-4.448669156035994, 5.165988876135831],
            [-4.453326424979062, 5.1638325924395385],
            [-4.458525526961085, 5.169671269397491],
            [-4.4634287403846375, 5.172953822765738],
            [-4.465370190447422, 5.167748111905524],
            [-4.468026764739494, 5.166249299686925],
            [-4.473765095477588, 5.167129644125138],
            [-4.475351069237495, 5.1711069733513],
            [-4.474146619496469, 5.175828950224273],
            [-4.47770745884582, 5.1774674615474705],
            [-4.481237480247644, 5.17587372929624],
            [-4.488181156513141, 5.180251013359381],
            [-4.491736385029413, 5.180890015463797],
            [-4.502767310572432, 5.185355801987969],
            [-4.5091134185812205, 5.183698850459318],
            [-4.507812141813334, 5.177043612181431],
            [-4.510292097427557, 5.1742388738167495],
            [-4.516011540906121, 5.172606130643874],
            [-4.5153004179074525, 5.167926983333632],
            [-4.518878588769865, 5.164445948488723],
            [-4.520195847757911, 5.160703366267846],
            [-4.518182630003053, 5.1559504196485175],
            [-4.519591172562568, 5.151366806090075],
            [-4.52519386134638, 5.148400053587977],
            [-4.527694759366795, 5.14306739752019],
            [-4.523832023775275, 5.137991854966501],
            [-4.528474460486795, 5.130873811825199],
            [-4.532125077231581, 5.1294313399419345],
            [-4.53874627828925, 5.130121520895032],
            [-4.54770235543405, 5.127103870175799],
            [-4.550941745958575, 5.130104175099741],
            [-4.5585982985563245, 5.133089856612469],
            [-4.562088238393961, 5.1315629430659175],
            [-4.562370321623319, 5.127587166001024],
            [-4.566696374005899, 5.1250112119108975],
            [-4.569916127439449, 5.126959758894886],
            [-4.57497590035149, 5.122718716454237],
            [-4.578630859474685, 5.121611918513095],
            [-4.588090829831606, 4.992901146679106],
            [-4.694237102272662, 5.0007827067361275],
            [-4.746778749148218, 5.005082247811531],
            [-4.8338197342460445, 5.012381890156183],
            [-4.922546418703342, 5.01907732762448],
            [-5.008593004217952, 5.025934440874708],
            [-5.086941253352255, 5.032498306735973],
            [-5.17484150371055, 5.039573169680069],
            [-5.261353099271913, 5.0476788562301245],
            [-5.307672772106581, 5.050859253346832],
            [-5.346785900119545, 5.0538585826508164],
            [-5.344658077640066, 5.079298887503976],
            [-5.340172222017612, 5.133303139017688],
            [-5.337805795275852, 5.159866773033575],
            [-5.330324105621542, 5.248682365042791],
            [-5.324226905915554, 5.322187026944294],
            [-5.315297123431519, 5.428261669156212]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.45152967895054,
          "lat": 43.677628901793916
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46033"],
        "coty_name": ["Custer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Custer County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01265788"
      },
      "bbox": [
        -5.346785900119545, 4.992901146679106, -4.335268986748024,
        5.428261669156212
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.022592103841114, -8.038364038976963],
            [0.042893750043003546, -8.004939532598447],
            [0.06738470667474199, -7.9929209366263],
            [0.07144068502663098, -7.990415554342666],
            [0.07558725021319891, -7.981857771020068],
            [0.08257866757799416, -7.971252352592834],
            [0.08773382445690175, -7.961139929636352],
            [0.09475259044279927, -7.950560458118091],
            [0.10100358463605699, -7.942654828544036],
            [0.10449573548628574, -7.930718339217599],
            [0.11276410719617513, -7.909201480695371],
            [0.11774347865174156, -7.901342359665678],
            [0.12226708189098333, -7.895741460821837],
            [0.12897638091242866, -7.881366291014164],
            [0.13212608751216698, -7.871968104540738],
            [0.13682960896830862, -7.865041240557428],
            [0.14354013324191986, -7.8591906769264455],
            [0.15083650356468395, -7.851641863505325],
            [0.15415428232433967, -7.839407826348542],
            [0.16164364199576897, -7.830303255142645],
            [0.1651053232935279, -7.824726180231813],
            [0.17515338036005787, -7.815548599543833],
            [0.18517947659292497, -7.80810127599689],
            [0.20651900379080493, -7.793765755331002],
            [0.22306654123208025, -7.784221630314106],
            [0.23870384177401824, -7.772861618342363],
            [0.2509043559503321, -7.766144304612251],
            [0.25771017733483365, -7.763357128873294],
            [0.2604019824204013, -7.767099607305803],
            [0.2584154808997484, -7.771373961635641],
            [0.2601633531527459, -7.77593778900547],
            [0.26313762469079605, -7.777710050051604],
            [0.26560603451957826, -7.7821939091857475],
            [0.26915760670967426, -7.7851130730053075],
            [0.2753305260843534, -7.78500624921895],
            [0.28632515481169835, -7.789913918640917],
            [0.28816371373811345, -7.796939337142747],
            [0.2912100302503797, -7.799263055042333],
            [0.28958955483302723, -7.808292929755813],
            [0.29110299123832456, -7.811296882263447],
            [0.2867870949565518, -7.813184503235026],
            [0.28713825369352636, -7.818044969752622],
            [0.28390825595056346, -7.819950612473057],
            [0.28138093367219197, -7.825411671570883],
            [0.2840368815546632, -7.83361624925775],
            [0.28978281785686144, -7.835640508409052],
            [0.28900072725059167, -7.840015248622857],
            [0.29397143078180954, -7.850031977073819],
            [0.29803107698989123, -7.854201817855544],
            [0.298532664899081, -7.8574950568662825],
            [0.2954768937998438, -7.861819144004192],
            [0.3010376215953343, -7.869811225804253],
            [0.3037773788625413, -7.869029857229824],
            [0.31089604153948797, -7.877291247918901],
            [0.31429068505052, -7.889970154151665],
            [0.3129706363925153, -7.895374121448445],
            [0.3135013554252788, -7.901422976484603],
            [0.3170729973502973, -7.9070451072573995],
            [0.31954531998337177, -7.91325000889547],
            [0.3156084518894769, -7.918797813828848],
            [0.3148038423529775, -7.924566542915117],
            [0.3160694660477622, -7.927558141505807],
            [0.31481118635217825, -7.9349674173126274],
            [0.31152758294867733, -7.935004105804605],
            [0.3064130307829583, -7.940895338353976],
            [0.3120794364179862, -7.949490862228332],
            [0.31712102182608914, -7.952703487770212],
            [0.32435737557108296, -7.966375543141839],
            [0.32246475888396525, -7.9710083651068295],
            [0.3223516238862304, -7.975902285092344],
            [0.31907328565402443, -7.977333323545934],
            [0.3176190161061115, -7.982886985223909],
            [0.31789210311689736, -7.986871868218879],
            [0.3221718055846511, -7.991437536968181],
            [0.3243552642701016, -7.995876256309543],
            [0.32478318086588487, -8.007751846957119],
            [0.3226656612646274, -8.013459595439718],
            [0.3167458080673239, -8.01852609275231],
            [0.31610597642852073, -8.023274099211442],
            [0.31116681715225974, -8.026163773587502],
            [0.313308715189262, -8.0392808064503],
            [0.31758149539012936, -8.045751457418241],
            [0.31748128530995556, -8.049927137694926],
            [0.315545364143761, -8.055376892024046],
            [0.3192163711084203, -8.064041390333045],
            [0.3185867645527162, -8.071578395762957],
            [0.3227005190507708, -8.073038547484497],
            [0.3229188650301043, -8.076262495153355],
            [0.32027418086105813, -8.080052122911653],
            [0.31981766171529835, -8.087254457068862],
            [0.3210288612844325, -8.090549403380859],
            [0.31524528125226214, -8.099140234916813],
            [0.3178743437242135, -8.10257553375749],
            [0.31446298044019366, -8.107201698768733],
            [0.31471693104399745, -8.111941506538582],
            [0.30885458158109885, -8.113447943943195],
            [0.3070726441945161, -8.127851445761205],
            [0.3033509585977509, -8.12876012971906],
            [0.30446401138604184, -8.135645358401767],
            [0.3070532652959628, -8.141388199492438],
            [0.305023869330938, -8.146173544630381],
            [0.31153330770293775, -8.149425207243002],
            [0.3128106078362383, -8.152604394199939],
            [0.32478183348671463, -8.164161679523323],
            [0.32504257855659735, -8.171914124500521],
            [0.3274668321033333, -8.175667086297574],
            [0.32594789632557136, -8.177601002035878],
            [0.3265707865537765, -8.182187126254634],
            [0.3249190213665727, -8.192334309679838],
            [0.32781859745706066, -8.198969284432648],
            [0.3363050422067054, -8.20593018072759],
            [0.3325353483168621, -8.212697836571667],
            [0.33944096713104555, -8.221906904827378],
            [0.3424197284514437, -8.224831250797095],
            [0.34114754297441774, -8.228094393840482],
            [0.3414867504387863, -8.23347731765003],
            [0.34627227415686074, -8.234230076736281],
            [0.3450753317160193, -8.23778879154443],
            [0.35014431038515875, -8.243248516941648],
            [0.34935038484264247, -8.24948233717664],
            [0.3437059458830498, -8.254917710307092],
            [0.34340770445012736, -8.26114690488405],
            [0.3469213374022872, -8.264674258166606],
            [0.35240572105280304, -8.267756864655777],
            [0.3521587764549997, -8.273422571482511],
            [0.3580789873459479, -8.278684747023755],
            [0.3548974060822088, -8.283943808131694],
            [0.3578994212014173, -8.28639681339268],
            [0.36009807884434775, -8.291473226999626],
            [0.36644652005672207, -8.292783787813947],
            [0.3694349610835892, -8.289745289845275],
            [0.37367803993712084, -8.289420838057842],
            [0.37322029871908413, -8.29634501391749],
            [0.37715403352597254, -8.292710430133962],
            [0.3801252935885944, -8.295915040561178],
            [0.38387183049308926, -8.293304166299949],
            [0.3897368698719197, -8.297812989438226],
            [0.389051025849757, -8.303433019201446],
            [0.3936088551434802, -8.302104488642678],
            [0.3923641441242494, -8.310317547210081],
            [0.38849840996515383, -8.315613230786274],
            [0.3817077356031904, -8.316278941659121],
            [0.37917169497506487, -8.313386436824233],
            [0.3768133871595865, -8.31586151764507],
            [0.372147935592721, -8.31476891000924],
            [0.3674042936470343, -8.317287625570122],
            [0.365959364173575, -8.319969620122881],
            [0.36743524337431943, -8.32527617962885],
            [0.370606274555299, -8.326892747523557],
            [0.3659888941605446, -8.33186890413802],
            [0.36179651541813557, -8.334575110928856],
            [0.3632195096669508, -8.340173756922653],
            [0.3589742118477295, -8.34211934129527],
            [0.36070396692627277, -8.345457155344947],
            [0.3583102912693769, -8.348815501423413],
            [0.3555294378115323, -8.345351420441789],
            [0.3498748050615853, -8.345013736441436],
            [0.34819459658009355, -8.348301405855445],
            [0.343658359462644, -8.349648003349046],
            [0.33854178956160064, -8.348094063287082],
            [0.33710291878777027, -8.352546531552523],
            [0.3396234584096301, -8.355825369898504],
            [0.3383728417372731, -8.361561585373689],
            [0.3418036205266157, -8.367393867990074],
            [0.3410606903693097, -8.379689843516273],
            [0.3347414488156295, -8.380354189089333],
            [0.33637883455568235, -8.388088228645008],
            [0.34265854691627917, -8.390057988739132],
            [0.3401128138564359, -8.39516805834444],
            [0.331046696046872, -8.398408576188766],
            [0.33050905317615736, -8.402088353972555],
            [0.3255141346172442, -8.393085571931971],
            [0.3257636757224489, -8.390732229432219],
            [0.33226448705349493, -8.382247265244029],
            [0.33249774359277334, -8.379702474775359],
            [0.3298666970187804, -8.369527229951471],
            [0.33466942005652117, -8.36393573583102],
            [0.3333173242446752, -8.361262358340543],
            [0.328375194073654, -8.357035847511842],
            [0.32730833352724426, -8.354430156370762],
            [0.32235720551696107, -8.355282225912557],
            [0.316015288324438, -8.358948552228059],
            [0.31257121898860923, -8.357731072078213],
            [0.31179378179007267, -8.354425911296921],
            [0.3145512015477603, -8.346396883328214],
            [0.31353387164378155, -8.342005680556763],
            [0.3099250217096038, -8.338192483281713],
            [0.3054877958484301, -8.338617309739378],
            [0.2962993361717145, -8.33303894503846],
            [0.2930800168618572, -8.337762916368472],
            [0.2919213583734154, -8.34986201767292],
            [0.28727680000853206, -8.352629701043313],
            [0.2810281674793926, -8.358988700645238],
            [0.2759844354122865, -8.35598988684786],
            [0.27083613257474, -8.357282484900477],
            [0.26128505257342366, -8.362866896782199],
            [0.25429301861289816, -8.362850481880674],
            [0.2469226167267615, -8.367128263707569],
            [0.24221267967838145, -8.366105780804528],
            [0.23783281603566062, -8.367823533030094],
            [0.23232714884138866, -8.373738397279954],
            [0.2255239986039027, -8.372142178761305],
            [0.2230748018355358, -8.367970243016275],
            [0.21763582545573348, -8.367735195038357],
            [0.21469557974893458, -8.360990305302892],
            [0.20612352263134923, -8.353364389179994],
            [0.21052275833589532, -8.352304462982953],
            [0.2097895076292176, -8.34696134958434],
            [0.199978864770843, -8.340891778518289],
            [0.19949310174117482, -8.338044209922325],
            [0.20332496402366496, -8.33328119757757],
            [0.20754560488213553, -8.332285208775177],
            [0.20528253468337423, -8.325489426680612],
            [0.20648664486965188, -8.32228808589488],
            [0.2096471424283793, -8.320448934884935],
            [0.21705686581731445, -8.321171291021304],
            [0.22357921605143766, -8.325392916272959],
            [0.2288872355176381, -8.323802151927717],
            [0.22830285199264205, -8.31459742062926],
            [0.22178403292306503, -8.318042560367424],
            [0.21766061481105392, -8.315957372880137],
            [0.21588276057864011, -8.311624537802931],
            [0.22056678835960114, -8.306357069374567],
            [0.21724495260546184, -8.299266193652949],
            [0.2168860081255307, -8.294504974530508],
            [0.21917431347393507, -8.286432874265675],
            [0.21763359574327515, -8.284939996315808],
            [0.2134505045112951, -8.289098822474637],
            [0.2041040885516133, -8.28525059282154],
            [0.19797724650577347, -8.277945128110234],
            [0.19572445738959185, -8.277583858076266],
            [0.19191231265832542, -8.28224466630618],
            [0.1876131959433514, -8.283495636313166],
            [0.18633668317122112, -8.274385746511976],
            [0.17916083163856047, -8.269362660522296],
            [0.1735936134180167, -8.263828846675327],
            [0.1707347009205679, -8.259490197545334],
            [0.17853693074690277, -8.258697399728343],
            [0.17997800523602353, -8.25539216237063],
            [0.17658666590080113, -8.249852751675636],
            [0.1715694595314598, -8.239125478495252],
            [0.16719218931582613, -8.233615496027213],
            [0.1611169983925026, -8.232136527562913],
            [0.1579876928802192, -8.227021216916945],
            [0.1587354526855166, -8.222067865560161],
            [0.156861914301828, -8.219410737706536],
            [0.15137738900055864, -8.22291018678393],
            [0.1481529507415946, -8.222816594244723],
            [0.14471820655685447, -8.220027252317221],
            [0.14742748048110438, -8.215310521646808],
            [0.15347738408844586, -8.215369189043665],
            [0.1579431378910112, -8.2124310835288],
            [0.1584214283854651, -8.203688331178528],
            [0.1553796687823295, -8.191955288547014],
            [0.1464644337989447, -8.189748086855142],
            [0.14288715466131854, -8.187083682310227],
            [0.13978426889287007, -8.18961103033617],
            [0.14209079114811604, -8.195230595169111],
            [0.13782779824424707, -8.195931048580215],
            [0.13699878598564963, -8.19095607436268],
            [0.13269918778688514, -8.189516448366732],
            [0.13162703034121387, -8.194038481809251],
            [0.13399349477905073, -8.195601369273756],
            [0.1339710808509462, -8.200043182887304],
            [0.13030108405056168, -8.201092774598894],
            [0.11970492085511247, -8.197952472092574],
            [0.11597448221363411, -8.193450249708581],
            [0.10875747518487731, -8.193968073214196],
            [0.10345409100539614, -8.187590517635236],
            [0.10092542419353852, -8.180993543781312],
            [0.09986289537442092, -8.170980193349006],
            [0.10105902136281743, -8.163668896592196],
            [0.0994505309243141, -8.155723932176963],
            [0.1025478805739244, -8.152509147003494],
            [0.10293314249287619, -8.149524465097297],
            [0.09778878457026986, -8.143109245601382],
            [0.09378307904111739, -8.143277901965241],
            [0.09384070831645001, -8.147950304790813],
            [0.09717548325676999, -8.15486359647973],
            [0.09649843752560372, -8.158678276387674],
            [0.09257573634254145, -8.16099316837454],
            [0.08720508290746164, -8.158548075582344],
            [0.08323769302719386, -8.150228675414056],
            [0.07756545832002995, -8.14477714677971],
            [0.0775672679417754, -8.139725920832152],
            [0.07583798965493853, -8.13695351652791],
            [0.06746878240540125, -8.13557025777465],
            [0.06381129700994856, -8.130164781854234],
            [0.05897562446373413, -8.126585945422981],
            [0.053146774496686804, -8.129115152122994],
            [0.04721587632589434, -8.1298791987611],
            [0.04347192984933243, -8.126877488077485],
            [0.0461924390186377, -8.11638701481634],
            [0.04378140903920316, -8.112110789274926],
            [0.04094068142320221, -8.113217590092358],
            [0.04021416296331136, -8.116689928721526],
            [0.03486518333484681, -8.12087654946659],
            [0.02859748724091251, -8.118408618023242],
            [0.02759335609186068, -8.116734260885396],
            [0.027562805555395344, -8.108558351893468],
            [0.025495823282910772, -8.105967285510467],
            [0.018748983241219503, -8.107522861193361],
            [0.009607908054989844, -8.105639134876956],
            [-0.006885033950209226, -8.105734157815911],
            [-0.012259985950469367, -8.101355736464656],
            [-0.016979100055606794, -8.10168659066612],
            [-0.021713174877762247, -8.104071288101585],
            [-0.024463042309226187, -8.097993604403168],
            [-0.02961868503927123, -8.096313538971026],
            [-0.03726860569936464, -8.096164173123954],
            [-0.04371204955949295, -8.093488915250836],
            [-0.050332773992409326, -8.094189206635516],
            [-0.052823882519712664, -8.0915228871028],
            [-0.04832039704514346, -8.087228964677692],
            [-0.046299986582437794, -8.0809811022756],
            [-0.03928965303057375, -8.07679824384733],
            [-0.03635842177254566, -8.069923179421394],
            [-0.03741189309947829, -8.050662155765393],
            [-0.0351018538424424, -8.045019286737316],
            [-0.027800790565959636, -8.045453295875443],
            [-0.02291028417454146, -8.041343075426932],
            [-0.022592103841114, -8.038364038976963]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.3023469992829, "lat": 30.660790413828096 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48041"],
        "coty_name": ["Brazos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brazos County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01383806"
      },
      "bbox": [
        -0.052823882519712664, -8.402088353972555, 0.3936088551434802,
        -7.763357128873294
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.36421577465356303, -8.173055504742445],
            [-0.28970875535962787, -8.130207321215064],
            [-0.2238679851305708, -8.09216560796443],
            [-0.16222677330314136, -8.057314955498699],
            [-0.13750484797774928, -8.043188721702595],
            [-0.06905758609884502, -8.003237478435752],
            [-0.06471872404452941, -8.005535999517223],
            [-0.05698075279620914, -8.004659044431914],
            [-0.05024660318479445, -8.005471794111012],
            [-0.04742115907011723, -8.007468030973754],
            [-0.0459795619538788, -8.012862790742028],
            [-0.04818210302581851, -8.016585860476924],
            [-0.03681948565020319, -8.024860668159238],
            [-0.031637749995986335, -8.027109723478931],
            [-0.02411203750392139, -8.032679979390155],
            [-0.022592103841114, -8.038364038976963],
            [-0.02291028417454146, -8.041343075426932],
            [-0.027800790565959636, -8.045453295875443],
            [-0.0351018538424424, -8.045019286737316],
            [-0.03741189309947829, -8.050662155765393],
            [-0.03635842177254566, -8.069923179421394],
            [-0.03928965303057375, -8.07679824384733],
            [-0.046299986582437794, -8.0809811022756],
            [-0.04832039704514346, -8.087228964677692],
            [-0.052823882519712664, -8.0915228871028],
            [-0.050332773992409326, -8.094189206635516],
            [-0.04371204955949295, -8.093488915250836],
            [-0.03726860569936464, -8.096164173123954],
            [-0.02961868503927123, -8.096313538971026],
            [-0.024463042309226187, -8.097993604403168],
            [-0.021713174877762247, -8.104071288101585],
            [-0.016979100055606794, -8.10168659066612],
            [-0.012259985950469367, -8.101355736464656],
            [-0.006885033950209226, -8.105734157815911],
            [0.009607908054989844, -8.105639134876956],
            [0.018748983241219503, -8.107522861193361],
            [0.025495823282910772, -8.105967285510467],
            [0.027562805555395344, -8.108558351893468],
            [0.02759335609186068, -8.116734260885396],
            [0.02859748724091251, -8.118408618023242],
            [0.03486518333484681, -8.12087654946659],
            [0.04021416296331136, -8.116689928721526],
            [0.04094068142320221, -8.113217590092358],
            [0.04378140903920316, -8.112110789274926],
            [0.0461924390186377, -8.11638701481634],
            [0.04347192984933243, -8.126877488077485],
            [0.04721587632589434, -8.1298791987611],
            [0.053146774496686804, -8.129115152122994],
            [0.05897562446373413, -8.126585945422981],
            [0.06381129700994856, -8.130164781854234],
            [0.06746878240540125, -8.13557025777465],
            [0.07583798965493853, -8.13695351652791],
            [0.0775672679417754, -8.139725920832152],
            [0.07756545832002995, -8.14477714677971],
            [0.08323769302719386, -8.150228675414056],
            [0.08720508290746164, -8.158548075582344],
            [0.09257573634254145, -8.16099316837454],
            [0.09649843752560372, -8.158678276387674],
            [0.09717548325676999, -8.15486359647973],
            [0.09384070831645001, -8.147950304790813],
            [0.09378307904111739, -8.143277901965241],
            [0.09778878457026986, -8.143109245601382],
            [0.10293314249287619, -8.149524465097297],
            [0.1025478805739244, -8.152509147003494],
            [0.0994505309243141, -8.155723932176963],
            [0.10105902136281743, -8.163668896592196],
            [0.09986289537442092, -8.170980193349006],
            [0.10092542419353852, -8.180993543781312],
            [0.10345409100539614, -8.187590517635236],
            [0.10875747518487731, -8.193968073214196],
            [0.11597448221363411, -8.193450249708581],
            [0.11970492085511247, -8.197952472092574],
            [0.13030108405056168, -8.201092774598894],
            [0.1339710808509462, -8.200043182887304],
            [0.13399349477905073, -8.195601369273756],
            [0.13162703034121387, -8.194038481809251],
            [0.13269918778688514, -8.189516448366732],
            [0.13699878598564963, -8.19095607436268],
            [0.13782779824424707, -8.195931048580215],
            [0.14209079114811604, -8.195230595169111],
            [0.13978426889287007, -8.18961103033617],
            [0.14288715466131854, -8.187083682310227],
            [0.1464644337989447, -8.189748086855142],
            [0.1553796687823295, -8.191955288547014],
            [0.1584214283854651, -8.203688331178528],
            [0.1579431378910112, -8.2124310835288],
            [0.15347738408844586, -8.215369189043665],
            [0.14742748048110438, -8.215310521646808],
            [0.14471820655685447, -8.220027252317221],
            [0.1481529507415946, -8.222816594244723],
            [0.15137738900055864, -8.22291018678393],
            [0.156861914301828, -8.219410737706536],
            [0.1587354526855166, -8.222067865560161],
            [0.1579876928802192, -8.227021216916945],
            [0.1611169983925026, -8.232136527562913],
            [0.16719218931582613, -8.233615496027213],
            [0.1715694595314598, -8.239125478495252],
            [0.17658666590080113, -8.249852751675636],
            [0.17997800523602353, -8.25539216237063],
            [0.17853693074690277, -8.258697399728343],
            [0.1707347009205679, -8.259490197545334],
            [0.1735936134180167, -8.263828846675327],
            [0.17916083163856047, -8.269362660522296],
            [0.18633668317122112, -8.274385746511976],
            [0.1876131959433514, -8.283495636313166],
            [0.19191231265832542, -8.28224466630618],
            [0.19572445738959185, -8.277583858076266],
            [0.19797724650577347, -8.277945128110234],
            [0.2041040885516133, -8.28525059282154],
            [0.2134505045112951, -8.289098822474637],
            [0.21763359574327515, -8.284939996315808],
            [0.21917431347393507, -8.286432874265675],
            [0.2168860081255307, -8.294504974530508],
            [0.21724495260546184, -8.299266193652949],
            [0.22056678835960114, -8.306357069374567],
            [0.21588276057864011, -8.311624537802931],
            [0.21766061481105392, -8.315957372880137],
            [0.22178403292306503, -8.318042560367424],
            [0.22830285199264205, -8.31459742062926],
            [0.2288872355176381, -8.323802151927717],
            [0.22357921605143766, -8.325392916272959],
            [0.21705686581731445, -8.321171291021304],
            [0.2096471424283793, -8.320448934884935],
            [0.20648664486965188, -8.32228808589488],
            [0.20528253468337423, -8.325489426680612],
            [0.20754560488213553, -8.332285208775177],
            [0.20332496402366496, -8.33328119757757],
            [0.19949310174117482, -8.338044209922325],
            [0.199978864770843, -8.340891778518289],
            [0.2097895076292176, -8.34696134958434],
            [0.21052275833589532, -8.352304462982953],
            [0.20612352263134923, -8.353364389179994],
            [0.20191554649520543, -8.349299960735399],
            [0.19868000555513807, -8.350781487549426],
            [0.1940175162637876, -8.348386417568708],
            [0.19023717737542584, -8.353073508630555],
            [0.18432985623122772, -8.353374926183704],
            [0.18142675464644903, -8.358160615574352],
            [0.17595213518678707, -8.358476781490369],
            [0.1705097922364, -8.36437414006133],
            [0.16680345452290438, -8.364276669740901],
            [0.159677365565445, -8.361159251817483],
            [0.15810309881664752, -8.358653626711869],
            [0.15460299743607456, -8.35964570873899],
            [0.1532629038182166, -8.364391500009617],
            [0.14904899917418046, -8.365041655439622],
            [0.14350990621469709, -8.369530242610242],
            [0.13864250696671004, -8.376260982582506],
            [0.13206210949522465, -8.374921611872622],
            [0.12293118206684676, -8.37673991391083],
            [0.11551189471577307, -8.379042136277],
            [0.11369182827542315, -8.380828379737025],
            [0.11044784638088471, -8.37350996403355],
            [0.10321978106287844, -8.37908563487787],
            [0.1031561056837659, -8.38487541373532],
            [0.09955738664947991, -8.388427570286764],
            [0.08633183508704924, -8.3888103377464],
            [0.0842660234830431, -8.390273628927245],
            [0.07976998953976117, -8.389332184828538],
            [0.07671547073405012, -8.390703477607198],
            [0.07165752770566296, -8.387148458940182],
            [0.07036892948006242, -8.391017457801828],
            [0.06284377034366927, -8.395337055794457],
            [0.060160066967460867, -8.393596607499653],
            [0.05414448205838574, -8.397915775569174],
            [0.047898197720873996, -8.398374203458005],
            [0.04512651828487552, -8.393359404801611],
            [0.04114534350917672, -8.395835638569372],
            [0.04020947909457643, -8.39999420917909],
            [0.036316108096690336, -8.406968770729472],
            [0.032905020019120365, -8.407069017520797],
            [0.02402444246508527, -8.40961277760252],
            [0.02002971243251039, -8.405173601353512],
            [0.013656536397235351, -8.408944630281281],
            [0.012239192387262218, -8.407677360835377],
            [0.007160241540065756, -8.410907875680756],
            [-0.0012433337652888274, -8.41000093021325],
            [-0.002379538329784536, -8.413075493926181],
            [-0.00899335935614042, -8.409651815408388],
            [-0.02083880376539649, -8.408537833068072],
            [-0.021022490210127708, -8.411586023509093],
            [-0.02613500802959822, -8.413975890267741],
            [-0.025919779462972956, -8.417290938283612],
            [-0.030530525909679123, -8.420132335616161],
            [-0.03409035302781049, -8.418522524409264],
            [-0.038426307556871285, -8.422023099731337],
            [-0.04174863958740491, -8.421727405066521],
            [-0.049673390670899105, -8.423225491841652],
            [-0.05337139330304649, -8.421831031478318],
            [-0.05626692474714585, -8.423395415390035],
            [-0.05872455224673484, -8.428541627020534],
            [-0.06752707593826818, -8.429409144972572],
            [-0.07325177240625673, -8.43222599854082],
            [-0.08206746046837268, -8.430867325922852],
            [-0.08867454701471858, -8.433551435538014],
            [-0.09583423741027414, -8.431060826652983],
            [-0.10390395354618259, -8.43082160021498],
            [-0.10836398600206033, -8.434643483236416],
            [-0.11227429861608014, -8.43262172851912],
            [-0.11335052980835801, -8.426879884060106],
            [-0.11800039320171417, -8.425173685542081],
            [-0.12050619545438261, -8.42042829391091],
            [-0.1243945617728378, -8.420980469075513],
            [-0.1270188486863451, -8.418607292524912],
            [-0.12815252593668938, -8.41311320194571],
            [-0.1348749022473624, -8.41003740361864],
            [-0.1390418578327044, -8.409516626092461],
            [-0.14555175615516772, -8.412426088497252],
            [-0.15355242185607415, -8.409937904384048],
            [-0.1583728706503868, -8.411153446861613],
            [-0.16167465029864508, -8.406738434117331],
            [-0.16605114441300253, -8.406610118129635],
            [-0.1744041720051192, -8.411264313356297],
            [-0.178399221856591, -8.408101865347936],
            [-0.17730511389219275, -8.406068861825702],
            [-0.18045508708054525, -8.40265609916465],
            [-0.1862737394453434, -8.400696921838245],
            [-0.18486932921019342, -8.391990566967287],
            [-0.18616862464010395, -8.389314350600147],
            [-0.1902212447924396, -8.390059443656378],
            [-0.1942356127130354, -8.383116642523946],
            [-0.1958479152471294, -8.37630262004146],
            [-0.198243586087537, -8.372314873844731],
            [-0.19929201005819713, -8.36539096322417],
            [-0.2036104568176373, -8.36079269165317],
            [-0.20843055237416666, -8.35807040513523],
            [-0.209872566168212, -8.353869664954543],
            [-0.21622170829591555, -8.346671625489925],
            [-0.21438459994140996, -8.341275189703694],
            [-0.21959197479548373, -8.338713382235579],
            [-0.22412328760244396, -8.339105061400023],
            [-0.22715683992177738, -8.33560217690663],
            [-0.23209189622952217, -8.333598925023193],
            [-0.23425827986328612, -8.3290342843394],
            [-0.23337349351233222, -8.325760283699974],
            [-0.24134972394243298, -8.32313089131848],
            [-0.2435766043369856, -8.31730715053749],
            [-0.25023354404915377, -8.311809904290785],
            [-0.2536940548904137, -8.310401822427435],
            [-0.2544976211133562, -8.307357987709258],
            [-0.2587351078601408, -8.30923558490189],
            [-0.25956182956965884, -8.30572350302153],
            [-0.263933521343177, -8.30242115674744],
            [-0.26448076563418244, -8.298774545784767],
            [-0.2691465921781587, -8.298462621778498],
            [-0.27478169883909503, -8.296014967828548],
            [-0.28022119971919884, -8.297412814025327],
            [-0.2854704383394931, -8.294505835374858],
            [-0.28693058813382766, -8.29096071720438],
            [-0.28692541939243776, -8.285487346159076],
            [-0.29089310253776396, -8.282369374118886],
            [-0.2882517147909301, -8.28043307682738],
            [-0.2896535453660362, -8.274639222188505],
            [-0.29533493184611187, -8.268379569510424],
            [-0.2995766535195646, -8.268263137972534],
            [-0.30529568342604724, -8.270163646999887],
            [-0.3103309004802438, -8.26971103990896],
            [-0.3137269308778562, -8.256515628900663],
            [-0.3118934380716041, -8.248386838566041],
            [-0.3074975475804745, -8.246205499002494],
            [-0.3066031005611386, -8.242952940951762],
            [-0.3114987245651743, -8.230716975167928],
            [-0.31548645293286515, -8.227202078761604],
            [-0.31368156150160387, -8.2219136863305],
            [-0.3177168741661553, -8.207721254564849],
            [-0.3205096495357188, -8.206909159078243],
            [-0.321050534343106, -8.200375038030165],
            [-0.32662313048362956, -8.190896054737427],
            [-0.3317653253089418, -8.186978789673635],
            [-0.33800958095475464, -8.187479836740497],
            [-0.3454380332900825, -8.184014591096082],
            [-0.3489056471184464, -8.186838546743154],
            [-0.3561363601514958, -8.181127291899951],
            [-0.3586923306590889, -8.177944138649336],
            [-0.3626000829350253, -8.178408067396223],
            [-0.36421577465356303, -8.173055504742445]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.62141774647439, "lat": 30.4924802049465 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48051"],
        "coty_name": ["Burleson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burleson County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01383811"
      },
      "bbox": [
        -0.36421577465356303, -8.434643483236416, 0.2288872355176381,
        -8.003237478435752
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.779297787973674, -6.55883711840712],
            [-0.7756659622109553, -6.556835883255598],
            [-0.7790844578179981, -6.550632511866848],
            [-0.6962459867837246, -6.529966889513787],
            [-0.5824152137376456, -6.502514403419247],
            [-0.5128365241489817, -6.485639539829603],
            [-0.4897637951138404, -6.4816491068914175],
            [-0.4506453125548932, -6.471558972472552],
            [-0.4506213859270735, -6.469991971003009],
            [-0.4253302273668201, -6.5150345025214405],
            [-0.37793095948806504, -6.6005691011683885],
            [-0.32962895056618047, -6.685691077748825],
            [-0.291935134198182, -6.664203349238946],
            [-0.2440064829474424, -6.7501178801089745],
            [-0.20244140046825024, -6.8226920016136905],
            [-0.14458300948217578, -6.923941212603657],
            [-0.16588030350028266, -6.936281207821631],
            [-0.17320290797286006, -6.9408966422259155],
            [-0.2461624776439973, -6.982555259631095],
            [-0.27619270191422607, -6.9995751215668776],
            [-0.27863692697088444, -7.001256535806752],
            [-0.32589155347766996, -7.0280619028472255],
            [-0.35313032642469894, -6.981115165219669],
            [-0.3849242340732516, -6.924362180266687],
            [-0.4131812670954279, -6.873414616229486],
            [-0.4621456086363966, -6.900554622757523],
            [-0.5409607567972631, -6.944643217063609],
            [-0.6076515392411416, -6.982858585653932],
            [-0.6176564755321566, -6.98820341480049],
            [-0.6275799741935523, -6.982655548635111],
            [-0.6337979753817072, -6.97796321874103],
            [-0.6381579504692574, -6.9763486419519465],
            [-0.6454310604084005, -6.971815431692463],
            [-0.6517574688802039, -6.961261964262119],
            [-0.6564772757876898, -6.954916863855965],
            [-0.6587630931772639, -6.944900547325077],
            [-0.6573299759384411, -6.9413823354063044],
            [-0.6531976252164695, -6.9397471567250815],
            [-0.6433619028559519, -6.932806890591406],
            [-0.6298069800718561, -6.916742626012479],
            [-0.6206325284684352, -6.910545086932658],
            [-0.6172717985849154, -6.905872682660711],
            [-0.6160039583666693, -6.9004441100272595],
            [-0.6172716079474524, -6.8944958696675185],
            [-0.6203927104027298, -6.890779774189532],
            [-0.6386549242686418, -6.88530873814635],
            [-0.6447088681934712, -6.886085831217618],
            [-0.658538799017192, -6.891955480828979],
            [-0.6622567440567689, -6.8901614024696585],
            [-0.6649868404347112, -6.885385694419549],
            [-0.6700658142136736, -6.880138062697527],
            [-0.6796026122797711, -6.87322522289921],
            [-0.688061967752667, -6.868102929248495],
            [-0.6936090935705231, -6.867506089746885],
            [-0.7052111235449064, -6.862033621097475],
            [-0.7068199412359906, -6.858688631383763],
            [-0.7069699792215005, -6.852553616179787],
            [-0.7041455040146333, -6.848615197674362],
            [-0.6940030123349887, -6.848572440970456],
            [-0.6879227261740213, -6.846927459436867],
            [-0.6858764179592524, -6.842478462046745],
            [-0.6984210887025986, -6.834575807587495],
            [-0.7088435323928914, -6.828890560998074],
            [-0.71772413974016, -6.822928072016048],
            [-0.7257059078367174, -6.824770467036277],
            [-0.7296773062301233, -6.822714648464251],
            [-0.7381346869037531, -6.809282234429596],
            [-0.7462689763918383, -6.807367013853649],
            [-0.7521746761351649, -6.802494292023008],
            [-0.7515216235591733, -6.798781516512003],
            [-0.7456378963592828, -6.794451664583404],
            [-0.7414482389584414, -6.789830671437891],
            [-0.7220553124426691, -6.779056857551732],
            [-0.7172557005246769, -6.775242589687676],
            [-0.709209541170623, -6.766898007573687],
            [-0.7013098720566944, -6.760372425620143],
            [-0.6989004626316618, -6.7558866627150715],
            [-0.7001207087288873, -6.750526258145173],
            [-0.7022280265824624, -6.747530021309415],
            [-0.7209722293049087, -6.74637910923523],
            [-0.7263934648880421, -6.739066222748923],
            [-0.7334640884591671, -6.7318251348621505],
            [-0.7368657496887665, -6.724773581179736],
            [-0.7368333851996207, -6.712661758605919],
            [-0.7389264657625371, -6.704746737947492],
            [-0.7426716013577107, -6.7040500777380485],
            [-0.7472408833630667, -6.707559842133879],
            [-0.7485382531071794, -6.711578615216659],
            [-0.7529830722835518, -6.717999174503655],
            [-0.7578506962963932, -6.71985890320743],
            [-0.7708847112049289, -6.721383295487817],
            [-0.7808823722053114, -6.721920464168113],
            [-0.788027087975948, -6.717060289805837],
            [-0.7900675588202757, -6.714262985963018],
            [-0.790595875831975, -6.70296135271688],
            [-0.7891867625148283, -6.6925058325334925],
            [-0.7894169261965157, -6.689011698725866],
            [-0.794570037127179, -6.672158824328555],
            [-0.7934855664374352, -6.668434347231265],
            [-0.7897425419309598, -6.663939571592579],
            [-0.7816372576463086, -6.651564657648095],
            [-0.7760820413492359, -6.645503634191826],
            [-0.7753882583471395, -6.64058553954696],
            [-0.7774027876907967, -6.634660304941111],
            [-0.7868372989410037, -6.623334663255658],
            [-0.7966566922855866, -6.603810026457595],
            [-0.7976555974982638, -6.599681648785327],
            [-0.7956952995896264, -6.592910501185715],
            [-0.7872519637877559, -6.589194697109081],
            [-0.7797176741109142, -6.586824953934207],
            [-0.7739003448667863, -6.584039709437837],
            [-0.7711163053815188, -6.577885393363593],
            [-0.7635745309763443, -6.569797296313003],
            [-0.7632477936161336, -6.565491315353415],
            [-0.7678621590641718, -6.560008395108711],
            [-0.779297787973674, -6.55883711840712]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.13243697766839, "lat": 31.99067641037482 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48217"],
        "coty_name": ["Hill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hill County"],
        "coty_fp_code": "217",
        "coty_gnis_code": "01383894"
      },
      "bbox": [
        -0.7976555974982638, -7.0280619028472255, -0.14458300948217578,
        -6.469991971003009
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.712457824601933, -5.2337432899841305],
            [-3.681798942959816, -5.235392604944786],
            [-3.586543445189314, -5.239589707839552],
            [-3.473528097163651, -5.244931883882251],
            [-3.326994323474414, -5.251878115588698],
            [-3.280679890039239, -5.254722858386963],
            [-3.2890045441323763, -5.434373161569768],
            [-3.29105724515561, -5.471377067404137],
            [-3.296417237212342, -5.578723627670595],
            [-3.299203825397135, -5.628298000522241],
            [-3.3002908863997504, -5.652817130218396],
            [-3.301283338734138, -5.659264641540112],
            [-3.30294550066394, -5.689958356532307],
            [-3.3638996916114983, -5.687037720944997],
            [-3.416734486285031, -5.683944455011196],
            [-3.607400570146102, -5.673296697022205],
            [-3.6127208219966342, -5.672787546347928],
            [-3.6950392799576766, -5.668320855096695],
            [-3.7062825972657247, -5.66600536100799],
            [-3.722774639461371, -5.661902910759574],
            [-3.7351262594378487, -5.660997943791234],
            [-3.734778727545072, -5.656922929837333],
            [-3.7305365939912027, -5.575326975358734],
            [-3.7259855662958805, -5.490976905368178],
            [-3.7203125051069508, -5.381564869655692],
            [-3.7174186178239306, -5.32534941546052],
            [-3.712457824601933, -5.2337432899841305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.7776281476551, "lat": 33.18130047248909 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48263"],
        "coty_name": ["Kent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kent County"],
        "coty_fp_code": "263",
        "coty_gnis_code": "01383917"
      },
      "bbox": [
        -3.7351262594378487, -5.689958356532307, -3.280679890039239,
        -5.2337432899841305
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.551545772903932, -4.755174163443257],
            [-4.460096593870179, -4.7596876012321525],
            [-4.375013384757314, -4.764020925440806],
            [-4.262659945126497, -4.769108786645718],
            [-4.176947927896434, -4.772869542445425],
            [-4.121410943712244, -4.775667043140814],
            [-4.122890040134081, -4.808068197625826],
            [-4.13030890062533, -4.968101996011531],
            [-4.136525486422133, -5.106851278053954],
            [-4.1364407833075765, -5.108204516691844],
            [-4.1415387995135635, -5.212364795109934],
            [-4.170095729485071, -5.210757265490387],
            [-4.250210382790334, -5.206628151484152],
            [-4.3209463620694235, -5.203386987127802],
            [-4.3995977405445, -5.199700878562449],
            [-4.493154684986066, -5.195253418855353],
            [-4.5089801047140226, -5.1949991309099675],
            [-4.571470124523009, -5.191327415841979],
            [-4.568236518844263, -5.112358781788634],
            [-4.565943295110048, -5.0746251930355815],
            [-4.565646018755441, -5.061213882643456],
            [-4.562759781320019, -4.9978482158334545],
            [-4.56011550146455, -4.944592156336807],
            [-4.554746062986133, -4.824592001216099],
            [-4.551545772903932, -4.755174163443257]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.82051968128629,
          "lat": 33.61020352405131
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48303"],
        "coty_name": ["Lubbock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lubbock County"],
        "coty_fp_code": "303",
        "coty_gnis_code": "01383937"
      },
      "bbox": [
        -4.571470124523009, -5.212364795109934, -4.121410943712244,
        -4.755174163443257
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.451893111671942, -5.371493495309941],
            [1.4584823116083592, -5.369688761936335],
            [1.4590922533548412, -5.373170664607358],
            [1.4634625079885168, -5.3749069973934445],
            [1.4667146981644255, -5.379641522573456],
            [1.463083420080672, -5.382602504420864],
            [1.471983051725062, -5.391764069001903],
            [1.4700244172546466, -5.396085248964607],
            [1.478493657199362, -5.403233446306354],
            [1.472954736205322, -5.41113061380765],
            [1.4821942713457126, -5.4148022425323825],
            [1.489607554536513, -5.411862961528069],
            [1.496081437004513, -5.417061208587278],
            [1.4992283619671978, -5.415232981637537],
            [1.5015720936761323, -5.407536343468835],
            [1.50366397889779, -5.405612439059745],
            [1.5098173591617587, -5.407653436459544],
            [1.509446921194509, -5.4102524305210755],
            [1.5124615351083588, -5.413289801619697],
            [1.5116156536740684, -5.417766415337888],
            [1.5161244791532922, -5.4170541406419],
            [1.516238361052622, -5.4229503198803855],
            [1.5211372335610203, -5.427079782729604],
            [1.526969117351474, -5.426310161407764],
            [1.5284123203114044, -5.422595247488768],
            [1.5340492188964823, -5.422471201252848],
            [1.53991656031495, -5.420989482601972],
            [1.5439014614579403, -5.422566048217769],
            [1.5468821460818045, -5.426863394297937],
            [1.5501118901550412, -5.426153649493372],
            [1.55085024995721, -5.433672824676045],
            [1.5537081814727554, -5.440496199589317],
            [1.560724602555241, -5.440239041538931],
            [1.566235888942173, -5.449001524158489],
            [1.5733609237021076, -5.449913381797541],
            [1.57664302382576, -5.453081567798422],
            [1.5746457422157332, -5.456026080442566],
            [1.580823932479527, -5.457293280902645],
            [1.583078753764459, -5.464745025274482],
            [1.583401292621763, -5.483536298363816],
            [1.5827905746995075, -5.486158511087442],
            [1.5845717102836523, -5.583838827518607],
            [1.5843733587724749, -5.627230731682884],
            [1.5852512072888092, -5.705740234610691],
            [1.585721603239789, -5.728362055936185],
            [1.5863898123172335, -5.779800477859392],
            [1.5871879552940946, -5.8546690828109],
            [1.5438900580850925, -5.85559667828384],
            [1.5421428413761726, -5.852660379359783],
            [1.5445916242449447, -5.845020517000482],
            [1.54163786481759, -5.838732958806698],
            [1.530421444567494, -5.834067768290457],
            [1.531808960599046, -5.830408316161044],
            [1.528835130400377, -5.828823366594164],
            [1.5251068061128363, -5.821451042999427],
            [1.5185324227246324, -5.820750457866554],
            [1.51690468729675, -5.817387249009423],
            [1.5097705998244486, -5.8156581809252055],
            [1.5016069337653142, -5.816881154369801],
            [1.499347044429992, -5.814047368325374],
            [1.4952649252513364, -5.812464481536086],
            [1.488977348851547, -5.808008507002547],
            [1.4878677441598502, -5.800680363528812],
            [1.4842336528950073, -5.797098774361184],
            [1.4869489332874, -5.794671144073038],
            [1.4812276194011458, -5.789030652713256],
            [1.4798616928103185, -5.785877289139955],
            [1.476327952274714, -5.783340171805648],
            [1.475723643451424, -5.77641338409125],
            [1.4723633692368543, -5.773378202676912],
            [1.4672982302390083, -5.773624412063099],
            [1.4654081686867388, -5.770762616156169],
            [1.4618848199176926, -5.769877691067404],
            [1.4602118784552727, -5.76616194693392],
            [1.4565765423115682, -5.764175782847129],
            [1.4474900886897404, -5.753017079669174],
            [1.4485763993397633, -5.698612246419526],
            [1.4488107297788888, -5.659742842705979],
            [1.449593785617223, -5.613375087190346],
            [1.4499057430294138, -5.610378015329295],
            [1.450641111822516, -5.525042190753679],
            [1.4514470224980491, -5.4659627966917],
            [1.451666956350503, -5.463173981557525],
            [1.451893111671942, -5.371493495309941]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.73266264344939, "lat": 33.1135028009644 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48343"],
        "coty_name": ["Morris"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morris County"],
        "coty_fp_code": "343",
        "coty_gnis_code": "01383957"
      },
      "bbox": [
        1.4474900886897404, -5.85559667828384, 1.5871879552940946,
        -5.369688761936335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.270052286213107, -3.776046320012268],
            [-5.134093923985778, -3.785772404374417],
            [-5.133569464615611, -3.7858970797131133],
            [-5.040798712267289, -3.792525483544769],
            [-4.920005843794774, -3.8013576169490126],
            [-4.849384536493172, -3.8064915606547163],
            [-4.857856821392557, -3.9287922102796036],
            [-4.866555515560126, -4.054178967010931],
            [-4.867554884771336, -4.062874433369434],
            [-4.874389317884475, -4.162607711237253],
            [-4.879757410026338, -4.241780346235965],
            [-4.95295225209058, -4.23687023536492],
            [-5.040556181750862, -4.230693923644703],
            [-5.063596413586963, -4.229166408252947],
            [-5.174097981910599, -4.221247373122306],
            [-5.190548716188985, -4.220158764808755],
            [-5.303477909700239, -4.211850567607836],
            [-5.298465073021847, -4.144879541839831],
            [-5.297789923963394, -4.1394716244836856],
            [-5.291975124539865, -4.061573718455434],
            [-5.2871478446966735, -3.998999243959871],
            [-5.279822061195952, -3.9040212942805375],
            [-5.277509236540184, -3.8705865511304998],
            [-5.275785535690646, -3.852467294450726],
            [-5.270052286213107, -3.776046320012268]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.78447940877437,
          "lat": 34.53007222460799
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48369"],
        "coty_name": ["Parmer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Parmer County"],
        "coty_fp_code": "369",
        "coty_gnis_code": "01383970"
      },
      "bbox": [
        -5.303477909700239, -4.241780346235965, -4.849384536493172,
        -3.776046320012268
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6410351310547109, -9.577329943659914],
            [-1.6322390696869757, -9.566896470068952],
            [-1.5713553568533654, -9.488518300634667],
            [-1.5404368931171097, -9.448749245636515],
            [-1.532418806228168, -9.438808884102059],
            [-1.4882160195398673, -9.38055637134729],
            [-1.4581502140205873, -9.341293670116068],
            [-1.4429413691968487, -9.321117259318251],
            [-1.3975554215642971, -9.261545467598177],
            [-1.3948995005513025, -9.260298465085443],
            [-1.3956629788770938, -9.263718551864878],
            [-1.39295935781429, -9.268960509881241],
            [-1.3966171571638755, -9.270153719307672],
            [-1.3920685721036266, -9.283674788850924],
            [-1.3951209848732966, -9.287303372582075],
            [-1.390367709394661, -9.290825360928926],
            [-1.3922960705042962, -9.296375594447118],
            [-1.3896021162513454, -9.300528787193755],
            [-1.390785292734055, -9.303810652529096],
            [-1.3891071108408792, -9.310834622197508],
            [-1.3834628705798753, -9.318169689447304],
            [-1.386171363426863, -9.323014337529498],
            [-1.3797903475181699, -9.330709281540814],
            [-1.3783083411317405, -9.335751372698068],
            [-1.3531714673676423, -9.322556996135118],
            [-1.3389660330990765, -9.323116906172837],
            [-1.2411273732468262, -9.32605029953269],
            [-1.1808455131934985, -9.328436126648393],
            [-1.1403329594650709, -9.329660162960792],
            [-1.1568347103550094, -9.352924658711958],
            [-1.096163951252944, -9.424597415009153],
            [-1.0706153429230452, -9.455792782158253],
            [-1.0455956106075923, -9.484331297458574],
            [-1.0987773961760723, -9.526717022895262],
            [-1.1628274472916658, -9.577565651016624],
            [-1.2305520653394746, -9.63135707168793],
            [-1.2826975652959243, -9.672540149338062],
            [-1.35366496461765, -9.728937506632745],
            [-1.3647268155753587, -9.737557522289483],
            [-1.3901044595708394, -9.75827195896273],
            [-1.3986187148024085, -9.765724379481982],
            [-1.4572601066520152, -9.810306848971583],
            [-1.5055044841165328, -9.74941680204911],
            [-1.5115853640227508, -9.742100012896488],
            [-1.5245970490179124, -9.7235516121286],
            [-1.549857198408566, -9.692053464746094],
            [-1.5527424632374431, -9.688106011925044],
            [-1.5761332647353115, -9.658641936296222],
            [-1.6410351310547109, -9.577329943659914]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.08656315357474,
          "lat": 29.173981192778065
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48493"],
        "coty_name": ["Wilson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilson County"],
        "coty_fp_code": "493",
        "coty_gnis_code": "01384032"
      },
      "bbox": [
        -1.6410351310547109, -9.810306848971583, -1.0455956106075923,
        -9.260298465085443
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.6226113056564624, -11.361231412401471],
            [-2.547520037265884, -11.31173694405816],
            [-2.5464085512721804, -11.311106122220682],
            [-2.51497199861212, -11.357032647983718],
            [-2.433972257300097, -11.3606317311177],
            [-2.35297146491512, -11.364211960120596],
            [-2.329072601198127, -11.36560354334998],
            [-2.2528405254132755, -11.3686816737352],
            [-2.176607618009883, -11.371743109648072],
            [-2.181955789883631, -11.548117708476841],
            [-2.184703696806785, -11.633755376198007],
            [-2.1870367422986634, -11.697481011941735],
            [-2.191155568932721, -11.842426835382662],
            [-2.2457383171266345, -11.948343051637266],
            [-2.256066371713958, -11.955712341719009],
            [-2.2663611538226838, -11.961812003686576],
            [-2.2832401552934147, -11.973361916826846],
            [-2.2892731610402306, -11.976946197742823],
            [-2.3196356275966847, -11.996769916483233],
            [-2.3915968709515756, -12.044113155703386],
            [-2.397719745017963, -11.996435920295767],
            [-2.416733012919362, -11.960931286077903],
            [-2.4239561240912946, -11.92424997163928],
            [-2.4219868342095396, -11.894350321377111],
            [-2.449244427675346, -11.872938742664608],
            [-2.449983558529428, -11.83166816401293],
            [-2.4668028057705116, -11.804445423054926],
            [-2.4716135810743376, -11.777484330481531],
            [-2.4817496364763136, -11.762702102532499],
            [-2.494666483663765, -11.755075928534744],
            [-2.5084871937420465, -11.755288692555363],
            [-2.514044006819843, -11.754035270073196],
            [-2.5244605494127583, -11.740121632775631],
            [-2.5221311155501844, -11.73459736039699],
            [-2.521710778515572, -11.730278580692481],
            [-2.517166573962161, -11.714008513362879],
            [-2.5194193552999384, -11.705046610318917],
            [-2.530495359602531, -11.698060107145531],
            [-2.5388859130302843, -11.69539368560585],
            [-2.5432841906110593, -11.695301238205753],
            [-2.5516656193193907, -11.691330214498455],
            [-2.5569615042837444, -11.691036562032163],
            [-2.567615088541864, -11.685354160487162],
            [-2.5754341419755336, -11.675610680549932],
            [-2.5789702645958603, -11.664653442963345],
            [-2.5790880230993527, -11.65619102335465],
            [-2.568082544060512, -11.649965924280846],
            [-2.564579479547152, -11.647163469270085],
            [-2.5653665252362337, -11.64108337399478],
            [-2.573287831630898, -11.638503808371162],
            [-2.577418825506587, -11.63339917306961],
            [-2.587387784696307, -11.623442518854851],
            [-2.5912669578777834, -11.611457836181312],
            [-2.5972348577776807, -11.603727659700901],
            [-2.601712012409291, -11.604224501394613],
            [-2.6099200289009508, -11.60952128533624],
            [-2.6148818171921406, -11.608335534313362],
            [-2.621746588702462, -11.601950134655096],
            [-2.6244361070379436, -11.596824905991868],
            [-2.622338124260913, -11.589188458380407],
            [-2.622070999109604, -11.584126909005972],
            [-2.6233178001499975, -11.577279083903397],
            [-2.6276056225615076, -11.565227729042723],
            [-2.628596992423916, -11.558355911402629],
            [-2.6265942081027815, -11.55351983331786],
            [-2.6120496961136017, -11.543499886465385],
            [-2.6068932234154776, -11.531534434088583],
            [-2.607707813565294, -11.527714370556708],
            [-2.614104668010802, -11.52205903960921],
            [-2.6176529906585912, -11.517106541457771],
            [-2.6168584212193906, -11.512604296773983],
            [-2.609603773988084, -11.50391720048161],
            [-2.606843057524263, -11.496807283499816],
            [-2.6071419613371702, -11.48610453280984],
            [-2.6130640310611253, -11.478863666540569],
            [-2.614483543462235, -11.47459471864186],
            [-2.6124477451553685, -11.469790124030789],
            [-2.6051418187650905, -11.465146628202174],
            [-2.601276776839807, -11.448597031675272],
            [-2.604642628304419, -11.42875402806997],
            [-2.606322848519352, -11.421545860821633],
            [-2.6062170591021245, -11.414258212090894],
            [-2.613705625847653, -11.4074665194032],
            [-2.6164708008231776, -11.402144074726898],
            [-2.6125642061404517, -11.389195304906],
            [-2.6122172370855488, -11.376367757185992],
            [-2.6166420016700975, -11.368737477892767],
            [-2.6226113056564624, -11.361231412401471]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.16864359527379,
          "lat": 27.000783296707283
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48505"],
        "coty_name": ["Zapata"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Zapata County"],
        "coty_fp_code": "505",
        "coty_gnis_code": "01384038"
      },
      "bbox": [
        -2.628596992423916, -12.044113155703386, -2.176607618009883,
        -11.311106122220682
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.272417712629712, 0.9166216379779769],
            [-12.096598524486787, 0.8869333413433552],
            [-11.923962232721633, 0.8563768585013178],
            [-11.925241348057927, 0.848005666957467],
            [-11.86209412509284, 0.8370794328919401],
            [-11.783637558598919, 0.8241409196731831],
            [-11.699348971454908, 0.8099852257978485],
            [-11.750584735399668, 0.7724822302621291],
            [-11.75651649395911, 0.7588266610507903],
            [-11.761503459296875, 0.7564531394139898],
            [-11.766681933000179, 0.7461257845258464],
            [-11.77151737378027, 0.7462962101933954],
            [-11.775261329634837, 0.7435760264600622],
            [-11.793972666349205, 0.6157194658634452],
            [-11.816876839418326, 0.47032440935231573],
            [-11.899831456589576, 0.4843279363082065],
            [-11.900725276787366, 0.4792110100641457],
            [-11.942249791490973, 0.4859621895804046],
            [-11.985109871589776, 0.4932317983294637],
            [-11.98452807010404, 0.496947308531446],
            [-12.046907976534003, 0.5078723852743048],
            [-12.060543940212712, 0.5106311532588265],
            [-12.10215298244973, 0.5178227542361971],
            [-12.173403205187538, 0.5297812824647349],
            [-12.278374353279805, 0.5482098253573962],
            [-12.26811442964359, 0.5520912515984802],
            [-12.267643508085362, 0.561571752580031],
            [-12.261602780931447, 0.5626173579863858],
            [-12.258066192492555, 0.5660079743529551],
            [-12.257712295803575, 0.576320574202132],
            [-12.247536305575101, 0.5820246857258873],
            [-12.244525460895195, 0.5857656815975615],
            [-12.234246991515562, 0.5910935620681171],
            [-12.230957329893958, 0.5973200740216233],
            [-12.22668795923333, 0.5974885992223841],
            [-12.221604669532518, 0.600454194851494],
            [-12.21653831961315, 0.5994636731888907],
            [-12.206282638536765, 0.6023901306454166],
            [-12.198643743579831, 0.6112393997235515],
            [-12.202916452409847, 0.6140453165200641],
            [-12.207863632258306, 0.6228529273149704],
            [-12.207372292630875, 0.6263167522101253],
            [-12.212663803181515, 0.6336535850070592],
            [-12.212325670908893, 0.6398222290994445],
            [-12.20653851529209, 0.6450087078393313],
            [-12.2008459095506, 0.647755237225565],
            [-12.199024870585742, 0.6526163431559332],
            [-12.194522800449514, 0.658991365778434],
            [-12.18871575403847, 0.662541637253398],
            [-12.18384673963269, 0.6668271056495481],
            [-12.179492332283404, 0.6755014583005562],
            [-12.179676246252003, 0.6846044411975327],
            [-12.177897822577059, 0.689937343637726],
            [-12.16953220184359, 0.6952997946598765],
            [-12.171180112266176, 0.6983673260336867],
            [-12.168728131078225, 0.7090129088366234],
            [-12.16647814416407, 0.7133836421245885],
            [-12.163484888849634, 0.7150930380786109],
            [-12.164319084879166, 0.7235614764524628],
            [-12.167010108401898, 0.7309985924368139],
            [-12.172912289895194, 0.7337189034348012],
            [-12.180013405553748, 0.743042314328123],
            [-12.179505651848537, 0.748074256857649],
            [-12.181873262045796, 0.753806056190188],
            [-12.184548199130479, 0.7565639730570682],
            [-12.186739177096067, 0.7650130237284049],
            [-12.189565849162726, 0.7683531176133163],
            [-12.197883346957667, 0.7705638583549581],
            [-12.201967853863136, 0.777330626277302],
            [-12.203080514578659, 0.7838257376407552],
            [-12.20492099049761, 0.7862660674662901],
            [-12.203985186855903, 0.7919409252233833],
            [-12.199625614318053, 0.7938346424409745],
            [-12.201031970262457, 0.8061512052622207],
            [-12.207301259808252, 0.8119015409773126],
            [-12.210548539197777, 0.8126780657164218],
            [-12.215173897349477, 0.8049267600756003],
            [-12.219451964460275, 0.8011410089281694],
            [-12.228591686315836, 0.7978446463141304],
            [-12.234029459124773, 0.802919226334229],
            [-12.237189730412691, 0.8169913776965401],
            [-12.236554315849615, 0.8271241842339492],
            [-12.239960872983517, 0.8330376409525653],
            [-12.247846212895988, 0.8402537817123599],
            [-12.249122913882378, 0.8444215860796015],
            [-12.253311228483145, 0.8493442589153306],
            [-12.259777728078069, 0.8517952319819453],
            [-12.263499058743248, 0.8547947921878382],
            [-12.267364220233786, 0.8672074817053586],
            [-12.267031558599193, 0.8694945250171572],
            [-12.27332129512806, 0.873031358742711],
            [-12.274570877556327, 0.8815508220535982],
            [-12.27762826931586, 0.8836661035234809],
            [-12.277882251677509, 0.8876839920147956],
            [-12.272022794709564, 0.8905878246100728],
            [-12.269792012368647, 0.8939799862304706],
            [-12.273252301948514, 0.9001401336167829],
            [-12.27448054402654, 0.906339207424959],
            [-12.271559216919155, 0.9072246430447336],
            [-12.272417712629712, 0.9166216379779769]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -112.12733081991774, "lat": 38.3365878092664 },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49031"],
        "coty_name": ["Piute"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Piute County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01448029"
      },
      "bbox": [
        -12.278374353279805, 0.47032440935231573, -11.699348971454908,
        0.9166216379779769
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.309757524628914, 8.221168207735548],
            [16.37378761284432, 8.237968461822916],
            [16.379318971464244, 8.239887159361293],
            [16.412531682653327, 8.24879969703224],
            [16.408861942525267, 8.226104025057529],
            [16.404294569131874, 8.209458175338158],
            [16.40189249460417, 8.196526292392644],
            [16.399802796850608, 8.190314209769014],
            [16.39478531408933, 8.182884302695722],
            [16.394567538964733, 8.1784144821955],
            [16.398582164563702, 8.170969454136355],
            [16.40198537993777, 8.168086851781158],
            [16.40405410109388, 8.163494821486157],
            [16.411702509595386, 8.152669314471321],
            [16.41370057102629, 8.151382887392156],
            [16.427754919853697, 8.14787710077177],
            [16.434985835023483, 8.149102244837955],
            [16.438939816667904, 8.14497790203584],
            [16.44158993264005, 8.132262442705315],
            [16.44133699644132, 8.122454666788263],
            [16.442610194755186, 8.115056789852177],
            [16.44011386548143, 8.10482147378915],
            [16.440988790188687, 8.100754766836653],
            [16.44089418238047, 8.09067886882519],
            [16.441943689244596, 8.08495729724809],
            [16.44589142662091, 8.079824929934073],
            [16.447888868637005, 8.073670913587517],
            [16.446308125177143, 8.068781286701302],
            [16.44677858540022, 8.064175830575103],
            [16.44540843035616, 8.061288391017735],
            [16.437192427531087, 8.05527510818653],
            [16.430336564369377, 8.04494193775411],
            [16.42673357898167, 8.03378338884508],
            [16.423636819606404, 8.016270976168737],
            [16.423744406890627, 8.007030680562341],
            [16.42686799298888, 7.997060228104104],
            [16.43543942174457, 7.985476480404845],
            [16.456608263341078, 7.962597507042504],
            [16.458365019274844, 7.953163528870675],
            [16.461521360321964, 7.9436314748160735],
            [16.465132531175513, 7.9293692813095165],
            [16.465542597937954, 7.912438280566614],
            [16.470814567886112, 7.893104641991097],
            [16.46879441106574, 7.886961957502487],
            [16.460589787960124, 7.880501259448356],
            [16.459554954137708, 7.873594585731364],
            [16.45983600148125, 7.868224948223392],
            [16.465577812177184, 7.850195360196243],
            [16.46594474334625, 7.844362436652225],
            [16.46356430737883, 7.836275122880628],
            [16.453693654287353, 7.824754770216318],
            [16.44288660412837, 7.815116763624575],
            [16.424616229493804, 7.801867105054028],
            [16.40191761791355, 7.787464525420811],
            [16.39794699928483, 7.789810044602481],
            [16.391163783811972, 7.796262555637675],
            [16.388725951926798, 7.802403649607082],
            [16.382737285029183, 7.808401293243921],
            [16.384394326272407, 7.813430473523613],
            [16.383758976705685, 7.819153150415626],
            [16.379749510209628, 7.823953320853724],
            [16.376585822989767, 7.830289033222274],
            [16.37064427746011, 7.833996589225154],
            [16.370082630294295, 7.847995215103921],
            [16.368214798576187, 7.85298654623581],
            [16.372681453400247, 7.859276086047967],
            [16.36849723829509, 7.86265213610709],
            [16.370383235836425, 7.87041350767744],
            [16.368713130166547, 7.873949104054274],
            [16.3727293386008, 7.884413414188548],
            [16.3702677130152, 7.886546964530139],
            [16.369314784088775, 7.895297484422787],
            [16.371757878421324, 7.896888908095296],
            [16.36823697177868, 7.902518216692093],
            [16.37094084793801, 7.9059189217233685],
            [16.372041385810668, 7.91330977154404],
            [16.36810505111249, 7.9154640752012195],
            [16.362092211996355, 7.942703083216176],
            [16.357937481008616, 7.958185921236341],
            [16.358337030714605, 7.961823250914324],
            [16.362458100905386, 7.973068245545075],
            [16.363293283475766, 7.991333696503528],
            [16.36445432090091, 7.994976288294223],
            [16.36896118462437, 8.001986901024923],
            [16.369143530172916, 8.008843850839435],
            [16.366136335465352, 8.01877962438954],
            [16.36381875510735, 8.023736672497396],
            [16.350874310225663, 8.032659715754088],
            [16.34767895802981, 8.035966142944165],
            [16.337847086348756, 8.039793031517368],
            [16.332945276254478, 8.042994780170512],
            [16.32886778302221, 8.047695046541442],
            [16.325640218063345, 8.048657826457799],
            [16.32267271376719, 8.055100540665705],
            [16.320892284845105, 8.066935987253231],
            [16.325024142079616, 8.073416003252502],
            [16.32598572069884, 8.078000594312696],
            [16.32479859120653, 8.108895972695985],
            [16.32590753611177, 8.116566333216563],
            [16.330055045858867, 8.124519362097052],
            [16.333894063095432, 8.128833406340638],
            [16.334634263817076, 8.132122475475212],
            [16.333454536969622, 8.138400218556317],
            [16.328129531176316, 8.1567668591776],
            [16.325233585998816, 8.173587141757206],
            [16.32340092680699, 8.17859863722098],
            [16.318194104067135, 8.182020078214418],
            [16.310196551996793, 8.190476566360124],
            [16.307412030099883, 8.196649020155167],
            [16.308819553035296, 8.204077935814883],
            [16.309757524628914, 8.221168207735548]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.29486096736564, "lat": 44.79799651872768 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50013"],
        "coty_name": ["Grand Isle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grand Isle County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01461763"
      },
      "bbox": [
        16.307412030099883, 7.787464525420811, 16.470814567886112,
        8.24879969703224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.942435853658115, 7.302733076970489],
            [16.956038301127354, 7.357161693830175],
            [16.96000514269131, 7.376220700048738],
            [17.005367530918917, 7.370205748250662],
            [17.020323894269474, 7.452409862594321],
            [17.024419513561366, 7.4519148222850795],
            [17.036229260958873, 7.529144023796823],
            [17.053223441052086, 7.527763972412559],
            [17.054197716941644, 7.536346937980262],
            [17.083047670524184, 7.532419947517964],
            [17.133690131925963, 7.525899048579431],
            [17.143242564518943, 7.523632411290605],
            [17.13841218257817, 7.59843673842551],
            [17.13734867392157, 7.616517610131062],
            [17.176361957862408, 7.608995103956741],
            [17.225610821842043, 7.6000634449136015],
            [17.283070369639184, 7.620898384721622],
            [17.313841067207946, 7.632218704042674],
            [17.316556239821107, 7.6322006534292655],
            [17.413284520603657, 7.62099818831582],
            [17.416667657328865, 7.621188181109981],
            [17.415327890054215, 7.615244290947889],
            [17.41932232476904, 7.60256022237098],
            [17.426821391887295, 7.597775785064293],
            [17.42584899157346, 7.591540782534457],
            [17.419602235085268, 7.5885491993793925],
            [17.416511908724388, 7.583631773561857],
            [17.416942283837685, 7.5740111659204485],
            [17.42118168764428, 7.565511064994785],
            [17.425040016998253, 7.562199223172009],
            [17.428561369780365, 7.5634432479143285],
            [17.42916790730259, 7.5698750939080925],
            [17.43441502482496, 7.569601366982258],
            [17.43642059753305, 7.567995578728613],
            [17.437458426354812, 7.559845789031736],
            [17.435562082082104, 7.55672765513158],
            [17.430405008296667, 7.555348183559584],
            [17.430508393686065, 7.552389491639387],
            [17.439352251633082, 7.550039592953343],
            [17.441068675172833, 7.547429058766524],
            [17.437274357423533, 7.544406455141872],
            [17.433112573574597, 7.546141036532394],
            [17.427207423192364, 7.542014213239488],
            [17.431605311852, 7.535222638890552],
            [17.429520958213768, 7.530291799465899],
            [17.428476890603996, 7.52345986961243],
            [17.4213967888818, 7.521340350746872],
            [17.421134446074255, 7.517968629629853],
            [17.42645771975408, 7.516197249515472],
            [17.424997299096116, 7.513127954883316],
            [17.41763331468301, 7.505324406478145],
            [17.4175603089687, 7.502429253314174],
            [17.42264408634342, 7.495926688786636],
            [17.41972329349204, 7.491302598109199],
            [17.420240376104804, 7.485708710172969],
            [17.418194686544002, 7.482745113845137],
            [17.412108090933085, 7.4840255646412945],
            [17.411378276533856, 7.479385894829064],
            [17.412600013840088, 7.476598504513554],
            [17.40799171086401, 7.4735917334343265],
            [17.40668013467539, 7.4693700038725375],
            [17.40988701895734, 7.463131356055014],
            [17.403012513368225, 7.451362323921326],
            [17.408254232789194, 7.4448519050247395],
            [17.41077980609033, 7.432214081070491],
            [17.41110714011881, 7.426555364648749],
            [17.414556356409644, 7.426320687121473],
            [17.417372892028194, 7.4297466872078415],
            [17.422678802763333, 7.429718172094509],
            [17.42801777519732, 7.427903180908156],
            [17.422278095742772, 7.424112122818591],
            [17.424703115792273, 7.418764393960622],
            [17.422609460567408, 7.411556338405209],
            [17.418945943126705, 7.407301884633168],
            [17.414790581655257, 7.406078459776873],
            [17.41421901308478, 7.401738004760336],
            [17.418049773039176, 7.393445365895496],
            [17.41989356598095, 7.382828455060747],
            [17.41750885398705, 7.375472049613799],
            [17.412316939404818, 7.370011002852746],
            [17.411347470572284, 7.366225709475083],
            [17.402293772160945, 7.355840823441295],
            [17.39947349568685, 7.3459334135990515],
            [17.398848303862, 7.339601468191785],
            [17.39278307195145, 7.3374726115546425],
            [17.392309138564467, 7.330657024518264],
            [17.39888293981293, 7.3214716698890685],
            [17.394781571842678, 7.317819031323456],
            [17.389382961792236, 7.315374012619989],
            [17.388194881406424, 7.305412356987714],
            [17.39445292688822, 7.2956764062219],
            [17.397670807456073, 7.2851064915394765],
            [17.39594687681213, 7.273623744233123],
            [17.398161304258387, 7.268067953095978],
            [17.40164662559704, 7.264004667926647],
            [17.40313338470395, 7.256336162377644],
            [17.399988574558165, 7.251537345760813],
            [17.399083308565295, 7.2425899513795295],
            [17.393729965238776, 7.233269528179928],
            [17.397321500153428, 7.220480817599085],
            [17.35862472010947, 7.225729656147785],
            [17.29410946105752, 7.234666767264363],
            [17.28911426331441, 7.234579828410069],
            [17.20309910650832, 7.238755965340706],
            [17.20357978106393, 7.24028913438353],
            [17.11845395615918, 7.253764974696661],
            [17.092021593609164, 7.257730167345317],
            [17.070102330674136, 7.260213505543018],
            [17.011726145840495, 7.267550769683992],
            [17.010451510532732, 7.263867851540596],
            [16.963799563930056, 7.269323885481258],
            [16.96528340371713, 7.276951503719785],
            [16.96044110543513, 7.277851230182945],
            [16.961958145128346, 7.283775059786969],
            [16.947298667933744, 7.286564621577105],
            [16.948927975020318, 7.294022816205474],
            [16.9439350770168, 7.294610999117275],
            [16.945577084121567, 7.302076108481615],
            [16.942435853658115, 7.302733076970489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.37684005186577,
          "lat": 44.005585650977174
        },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50017"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01461765"
      },
      "bbox": [
        16.942435853658115, 7.220480817599085, 17.441068675172833,
        7.632218704042674
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.191806115194707, -0.10514834119299184],
            [14.208082402946966, -0.056807836447604364],
            [14.23605932539011, 0.025769041446162738],
            [14.238430608324968, 0.03221593223072011],
            [14.24874469206506, 0.06343995487707434],
            [14.256281920169357, 0.0840523944893999],
            [14.273154333205364, 0.1329423876836334],
            [14.288295518277987, 0.17544572471842199],
            [14.303530320512513, 0.21982164415465186],
            [14.300367251155619, 0.2756941921804792],
            [14.304721786544912, 0.2798556304338442],
            [14.307454678022603, 0.28447625782472846],
            [14.307531753865621, 0.2987176107624598],
            [14.308806672333157, 0.3026607543985033],
            [14.315259435738575, 0.31234269266569414],
            [14.329771507929665, 0.32840014455954497],
            [14.333706747381688, 0.33659492682123915],
            [14.340156917330733, 0.3419258937025666],
            [14.347830148675117, 0.34519773670542486],
            [14.351350459705296, 0.34500085831876465],
            [14.36177094597119, 0.34123093574116636],
            [14.372286430769476, 0.3381721095345909],
            [14.38021166141321, 0.33343227103371564],
            [14.389638271879669, 0.32498024431441214],
            [14.396173622344497, 0.32456172798723737],
            [14.404159507051268, 0.3200698044677955],
            [14.410181652470003, 0.3147815902535131],
            [14.413788555294602, 0.30826412330158043],
            [14.41384927059708, 0.3035078275703856],
            [14.406730925680295, 0.2908121711898946],
            [14.403532664591955, 0.2873614790660668],
            [14.402307987446642, 0.28205929621338494],
            [14.4057789533402, 0.2763748695916094],
            [14.410868105381834, 0.2758478479635858],
            [14.417892318834486, 0.2779167389601887],
            [14.424248071134135, 0.27649927342585534],
            [14.432558501377255, 0.27057528578059087],
            [14.435645268269086, 0.2673617741190014],
            [14.430632900128805, 0.26277824294569124],
            [14.431090504005077, 0.2573347904272912],
            [14.428375020600248, 0.2556231844353837],
            [14.43082801216066, 0.25216310474908793],
            [14.427062451910134, 0.24405237051286754],
            [14.429403195834174, 0.23600746580748477],
            [14.428345341133186, 0.12164912350550447],
            [14.427789203394525, 0.057495428880078844],
            [14.421658381917569, 0.0614482271599574],
            [14.41455885681132, 0.05276975592472556],
            [14.40838534213772, 0.052882580420918264],
            [14.404479290179868, 0.04463333288030982],
            [14.39967344702368, 0.039664085534649125],
            [14.392673914070244, 0.04078712594573398],
            [14.388798371630637, 0.0396726989011143],
            [14.388981650800028, 0.034267358030867806],
            [14.390888399877605, 0.028860003476162393],
            [14.389351942413768, 0.020032850012256735],
            [14.384433557797715, 0.02169447050140548],
            [14.379302621808433, 0.019140313562929803],
            [14.380888053865155, 0.01185897456240353],
            [14.37891628180342, 0.008437071295621342],
            [14.379925953912306, 0.0024906440577923575],
            [14.377203132530099, -0.004534834418446194],
            [14.373868008163267, -0.00820745264609345],
            [14.372083507796768, -0.021431840171439925],
            [14.37011174703657, -0.02424069380663934],
            [14.364514990500323, -0.02762427903231918],
            [14.359984899041601, -0.03834569673119455],
            [14.365263341665237, -0.04177268945374314],
            [14.364489758378719, -0.043501623221991595],
            [14.362468924412488, -0.04843738908082891],
            [14.356838343668505, -0.054235173875224536],
            [14.347307807769761, -0.05441205601580162],
            [14.346987934627629, -0.05905978550113484],
            [14.350974281334924, -0.06219852475583451],
            [14.35173274143523, -0.06774936284046497],
            [14.350695193861103, -0.07207227737128367],
            [14.339134908751372, -0.06849596821149107],
            [14.335296798438186, -0.07101535685088328],
            [14.335875324524618, -0.07703370684888301],
            [14.334264744657135, -0.08286999480336284],
            [14.328987921203039, -0.0822898024427381],
            [14.325474310405843, -0.08700791516861017],
            [14.328244062106522, -0.094721675707733],
            [14.32232273490936, -0.09594238830292022],
            [14.315363286542512, -0.10123389863029032],
            [14.314971998172805, -0.10577417752595514],
            [14.312498625015186, -0.11013305127452094],
            [14.307908293263244, -0.11477815957541848],
            [14.29904401610098, -0.11650107009498438],
            [14.297122600120067, -0.11460708066778875],
            [14.29695653758112, -0.10903966358483211],
            [14.289921347713415, -0.10813261646746032],
            [14.285888630156967, -0.11539099198785145],
            [14.282933948740986, -0.1232263293852787],
            [14.278013864544095, -0.11915082262077772],
            [14.275321599536241, -0.11965316564578858],
            [14.270726275736363, -0.12347142017247097],
            [14.262091434485335, -0.1245599994466425],
            [14.256619126443326, -0.12627736930719693],
            [14.252260255514178, -0.12916436056524222],
            [14.249859942421876, -0.12744024430487724],
            [14.244931233590698, -0.11978941205336283],
            [14.236853514700403, -0.11700776726543673],
            [14.234948174064112, -0.11300556175070522],
            [14.231396321022403, -0.11484143296301867],
            [14.22335493938683, -0.11281602945601588],
            [14.213018899465109, -0.11396149708413969],
            [14.207701956302314, -0.10728967062113644],
            [14.200690733200313, -0.10792945234885293],
            [14.198335698595463, -0.10951656905944986],
            [14.191806115194707, -0.10514834119299184]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.24483668054101, "lat": 37.512279461519 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51049"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01494109"
      },
      "bbox": [
        14.191806115194707, -0.12916436056524222, 14.435645268269086,
        0.34519773670542486
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.236639445105732, 1.588280711731253],
            [14.237612494178439, 1.5924666797365647],
            [14.240592369607766, 1.5963322747934385],
            [14.244682143440595, 1.6040898038443194],
            [14.244011057012374, 1.6072198234253507],
            [14.249674232708635, 1.6143843906862543],
            [14.254795271815858, 1.6163390362921677],
            [14.26040486362805, 1.622945669158151],
            [14.261948591565112, 1.6283784547233928],
            [14.338548304398524, 1.6204467195274672],
            [14.448563166768281, 1.6090534869802717],
            [14.507684101266364, 1.6029070224888835],
            [14.507377278442682, 1.5949491942139096],
            [14.505837768329098, 1.5932272694233007],
            [14.50510180066959, 1.5757472926225375],
            [14.498165489776497, 1.5502258503473028],
            [14.490124365895392, 1.5422499134630072],
            [14.48841044830021, 1.529731030831291],
            [14.489136080871514, 1.5147959681929162],
            [14.49020719395949, 1.5058503787600033],
            [14.489280917487587, 1.4969906379122138],
            [14.481138300661364, 1.4954786627102745],
            [14.483242474806266, 1.4844862770210583],
            [14.489216302912824, 1.477037333268454],
            [14.560069443238408, 1.3865299921493572],
            [14.626158167653687, 1.3021025529660837],
            [14.675313009642743, 1.2393016228796214],
            [14.676579641883535, 1.2388573546627326],
            [14.659873293139647, 1.2052304631466044],
            [14.622020357202942, 1.1442947377667816],
            [14.61991335880303, 1.138218062832743],
            [14.616065645405191, 1.1347431242707544],
            [14.617045267760309, 1.1291646093334475],
            [14.619589217587949, 1.1243262711584823],
            [14.622962686885732, 1.1208467230870265],
            [14.623101261299981, 1.1149636630582755],
            [14.620668396887346, 1.110276969529964],
            [14.625181487134563, 1.1076077658393604],
            [14.626832217946308, 1.1025432036340208],
            [14.625273217320535, 1.0971735418434685],
            [14.627707224575637, 1.0916572995722809],
            [14.625318684058406, 1.0881201155731053],
            [14.626215812883094, 1.0784257249286155],
            [14.62310984932859, 1.0773109864148966],
            [14.611176290212086, 1.081755135887445],
            [14.59969601407685, 1.0833185707715411],
            [14.593085514371019, 1.0860315615653136],
            [14.58747002230732, 1.0855291949166945],
            [14.580767123094452, 1.0868086818595464],
            [14.574755116614618, 1.0836923345755514],
            [14.573556884676764, 1.0798205463143205],
            [14.565559772587925, 1.079711572345839],
            [14.555655332530337, 1.0735482738274948],
            [14.552733529895743, 1.0669429936404131],
            [14.549056091156169, 1.0663540120923494],
            [14.54213032457581, 1.0779562555352724],
            [14.535197965597314, 1.0775917108914894],
            [14.531021490536297, 1.0795940156875203],
            [14.526039291221919, 1.0851785428896548],
            [14.523554849031862, 1.0901520376755391],
            [14.523616995460285, 1.0954474249044925],
            [14.52024119086054, 1.1077576845607386],
            [14.509464945600495, 1.1103724504174597],
            [14.505796438916006, 1.115435132138431],
            [14.507104717455686, 1.1203879745138732],
            [14.50243781291771, 1.123557941125202],
            [14.49969471699637, 1.1307532536454383],
            [14.499638670651265, 1.1338286626257092],
            [14.494935243273527, 1.1329645459297772],
            [14.493828308111942, 1.137814732413985],
            [14.485877830082764, 1.1418685245341773],
            [14.481781164182154, 1.1458347832618125],
            [14.48016637119167, 1.154936517105705],
            [14.469783844611976, 1.165770971757246],
            [14.466613383483516, 1.1710800931739798],
            [14.462286641410907, 1.1687666254965698],
            [14.455831778638943, 1.1743585022445795],
            [14.451373830654013, 1.176726772189845],
            [14.448155331683244, 1.1755293377857041],
            [14.441567689909716, 1.1808424541230569],
            [14.435469037861974, 1.1899017692953457],
            [14.428874086800251, 1.1917829697671398],
            [14.423009189257748, 1.1984603815626405],
            [14.42080001498885, 1.205326786567081],
            [14.416346006367911, 1.2099408304590282],
            [14.413744255865144, 1.21077209461939],
            [14.408273594260638, 1.21572279855047],
            [14.409302392606085, 1.2225540801999866],
            [14.414934543547645, 1.2254674440732958],
            [14.416904327517623, 1.2314093214803263],
            [14.409795488065022, 1.2349811544355864],
            [14.406418768455245, 1.2382260903117304],
            [14.406487094864849, 1.2421781687647586],
            [14.409607998182302, 1.2456430773512395],
            [14.414631035414763, 1.2470079143147625],
            [14.41448254834732, 1.2538526382497839],
            [14.40744737918628, 1.2551189406505678],
            [14.402861484035187, 1.263363665599157],
            [14.399776451936585, 1.261390520079058],
            [14.39586016450518, 1.2664006202193447],
            [14.40063689218956, 1.2706196669565304],
            [14.399515180660144, 1.274425251882235],
            [14.400245336889055, 1.2796225876395535],
            [14.393224405048374, 1.2877623619195808],
            [14.387332414575436, 1.2957275143922868],
            [14.379118081908365, 1.2894307291089118],
            [14.374558623947953, 1.2920998324336643],
            [14.372006724639647, 1.2962806480717364],
            [14.373080246156231, 1.301286524953175],
            [14.377383017789155, 1.3066856732892962],
            [14.376627363696818, 1.3088480233392736],
            [14.369734074006388, 1.3103723006478116],
            [14.369228395256046, 1.3164945894578466],
            [14.365071687237005, 1.321514483541345],
            [14.358554786769075, 1.3223235332091978],
            [14.345403861209896, 1.3202703287646178],
            [14.342878571900306, 1.317187871786734],
            [14.337190920459312, 1.3190289967136317],
            [14.33620913163389, 1.3163052794968806],
            [14.330025142015964, 1.3170533752406408],
            [14.326355462209225, 1.3140046061883162],
            [14.322000558991231, 1.3163475380574405],
            [14.30867284912299, 1.3189194704931766],
            [14.303239289393646, 1.3217101004024525],
            [14.294328046638658, 1.3228486360168643],
            [14.288740358431614, 1.329178231032312],
            [14.284087923236276, 1.3301277219481018],
            [14.276970466872646, 1.3366314942507345],
            [14.280265909324518, 1.3397467880084202],
            [14.277276549149688, 1.3425393303017303],
            [14.277182208421932, 1.346989120529697],
            [14.274937542989994, 1.3495049544931523],
            [14.271883001398242, 1.3482592699247615],
            [14.272254523188327, 1.356341997883512],
            [14.269323333369547, 1.3577511044943935],
            [14.270275193398943, 1.3630537241849254],
            [14.263862281759591, 1.3623689234488785],
            [14.260774121227383, 1.3648016972624113],
            [14.260364620657317, 1.3719350941184105],
            [14.26255217027132, 1.378129682929894],
            [14.258775767433072, 1.3819630497020616],
            [14.26294131312461, 1.385584484775803],
            [14.260933119976665, 1.389367662006497],
            [14.256708669835524, 1.3890197053038182],
            [14.251200203225501, 1.400321284572623],
            [14.255225817120795, 1.4031037287173729],
            [14.246559761050307, 1.4060409499641076],
            [14.244418589594074, 1.4038176257740376],
            [14.237422991824907, 1.4060783648076522],
            [14.230701013761347, 1.4114862409208588],
            [14.217840786199288, 1.4182373262355765],
            [14.21463393529383, 1.418303553791154],
            [14.207805428957926, 1.4240964575776882],
            [14.205664489309447, 1.4228105594115217],
            [14.200496796920257, 1.4259273365734226],
            [14.192654321426453, 1.4267179499413514],
            [14.186610102162701, 1.433248474193458],
            [14.184462639477356, 1.4375486767045833],
            [14.178598551187035, 1.4404784716313563],
            [14.175144805990287, 1.4459182813397586],
            [14.17073599148859, 1.4490864677602693],
            [14.167978216340975, 1.458078333228031],
            [14.162773416761087, 1.45645115112184],
            [14.162192387925662, 1.4616280062855882],
            [14.164440564576383, 1.4650497179288362],
            [14.172900112476855, 1.4707295237031033],
            [14.17374877537418, 1.474357872349586],
            [14.181894450792884, 1.4746937052388467],
            [14.186953663982116, 1.4764396766504646],
            [14.188090182770212, 1.482562559842724],
            [14.201764880258605, 1.4861950222929166],
            [14.201302939890601, 1.4906898311212504],
            [14.205424268288317, 1.4929150003333689],
            [14.209580669946563, 1.4931772533578476],
            [14.208197648532098, 1.5014667997086604],
            [14.199704535045747, 1.5032930662414519],
            [14.196615583292859, 1.50647272257779],
            [14.195762245568059, 1.5110366328557607],
            [14.202166170276628, 1.5246861120013242],
            [14.200928883830723, 1.5276599865733171],
            [14.204093955546455, 1.5339200170545901],
            [14.209255920325504, 1.538104839682265],
            [14.216301164227271, 1.541905110672394],
            [14.217500745774506, 1.5439162869044483],
            [14.21809003034311, 1.5516167242853605],
            [14.220825556048863, 1.555717952099645],
            [14.223537447398705, 1.5556848546625093],
            [14.22420360883264, 1.5615566321524175],
            [14.226028593759068, 1.5629478156641419],
            [14.227734083719703, 1.570837443675476],
            [14.229461314176374, 1.5732243154723022],
            [14.230442617891377, 1.5790044840332578],
            [14.236639445105732, 1.588280711731253]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.80919722997274,
          "lat": 38.738609155591355
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51061"],
        "coty_name": ["Fauquier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fauquier County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01480120"
      },
      "bbox": [
        14.162192387925662, 1.0663540120923494, 14.676579641883535,
        1.6283784547233928
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.050528993335158, 1.759044413607133],
              [14.059838882715251, 1.7554932079625352],
              [14.058507438054914, 1.7454578180582245],
              [14.058789597480772, 1.73469183779494],
              [14.056022625688504, 1.732331215002138],
              [14.060593583385549, 1.721909269321634],
              [14.065392979459455, 1.7216118329387775],
              [14.072291726686025, 1.7185224350411958],
              [14.072856632128136, 1.7128467177761835],
              [14.078639543803364, 1.724483099727652],
              [14.081829447800498, 1.7391306841237641],
              [14.087095279633614, 1.750246922693097],
              [14.089112314641193, 1.7591760576923778],
              [14.09784042575424, 1.7723441636919137],
              [14.080599783178673, 1.7810452902410476],
              [14.080613279241758, 1.7861208836150526],
              [14.076808953280572, 1.7875853084606974],
              [14.074275793009805, 1.7826477687358677],
              [14.055404538501676, 1.785229970049197],
              [14.051274228066053, 1.7730530152317172],
              [14.053049205291009, 1.7691690916303564],
              [14.050528993335158, 1.759044413607133]
            ]
          ],
          [
            [
              [13.835296478680828, 1.6246500234107561],
              [13.842564139283882, 1.6366276679624825],
              [13.84281479348491, 1.6387397876326257],
              [13.849853487513764, 1.6466004151977534],
              [13.853821478955677, 1.6498765832857956],
              [13.858077765664731, 1.648924836769555],
              [13.862151047499399, 1.6545248818855764],
              [13.867191648343985, 1.6559713649471706],
              [13.87914695132933, 1.6774990332638373],
              [13.87946904707916, 1.6873585107866194],
              [13.884491916581373, 1.6996262813925713],
              [13.893515161081233, 1.7071544461712018],
              [13.89957071636067, 1.7175647488714658],
              [13.896461784058483, 1.7205268993051195],
              [13.891300482784215, 1.7223689895973961],
              [13.889228051662311, 1.7262901281912704],
              [13.886222987323187, 1.7252341978073122],
              [13.877031544750277, 1.733641217258807],
              [13.879438911589302, 1.7391617302951594],
              [13.876042256972625, 1.7390164211209058],
              [13.873737878700458, 1.7422753194226812],
              [13.867510578937585, 1.7429821417546414],
              [13.872523096316742, 1.7531221718218173],
              [13.879562688221867, 1.7652074399597897],
              [13.886303815848702, 1.7805045845526557],
              [13.885472314145169, 1.7906540890073968],
              [13.888270119278113, 1.7941704446300724],
              [13.879667286666916, 1.8012195257571906],
              [13.870985101123393, 1.8046378398186362],
              [13.873723926812405, 1.811755058779177],
              [13.88018463816396, 1.8248323160637523],
              [13.880857435997703, 1.8305541491167978],
              [13.885880498756787, 1.8336156980024514],
              [13.888297867086857, 1.839801017285477],
              [13.888556918226186, 1.8448367360464581],
              [13.895806832330958, 1.8582129595158965],
              [13.900512930257266, 1.8642409073773623],
              [13.901104029844547, 1.8717064409038975],
              [13.90452160674446, 1.872818910887982],
              [13.91088768447201, 1.8959190538280808],
              [13.90925292763701, 1.900020354409449],
              [13.914405695901015, 1.9076479438422775],
              [13.912587970506667, 1.9110053599490475],
              [13.90616819506348, 1.9110848937771054],
              [13.891644164789053, 1.9130258745534416],
              [13.898402869348141, 1.9269475882974758],
              [13.903944879753382, 1.945636076563014],
              [13.89744448889502, 1.9470772534494463],
              [13.897224100419768, 1.95374852858402],
              [13.889991531159227, 1.958809828707024],
              [13.887382032869214, 1.9668833994289117],
              [13.89198438563461, 1.9760220691343555],
              [13.89407308584704, 1.983623564374751],
              [13.892544735575044, 1.9866840618085038],
              [13.8874685725029, 1.991800792545484],
              [13.890862886999187, 1.9963295687885843],
              [13.889874642151598, 2.0034075689929387],
              [13.889316477671976, 2.015441117514234],
              [13.885552263951793, 2.017527346628306],
              [13.886638285955508, 2.021639097559692],
              [13.9380297148285, 1.9930595283862362],
              [13.95967686167564, 1.9823245383807173],
              [13.989592239760087, 1.9642676209418606],
              [14.010199027557356, 1.9515996967271614],
              [14.025854135679207, 1.943156608035218],
              [14.051687123665621, 1.9269048724063704],
              [14.066506735385198, 1.9198122415621],
              [14.094743961451103, 1.9033221643890954],
              [14.160700539844694, 1.8667669667174551],
              [14.160701666084481, 1.866766343330964],
              [14.158095096905932, 1.861962520314875],
              [14.158776392631449, 1.8592512205320044],
              [14.159024918365821, 1.8475051311846307],
              [14.156401073714393, 1.8415917462200535],
              [14.159158482131271, 1.8377895872753363],
              [14.154985094534995, 1.835175783315231],
              [14.15499808539743, 1.8301207876366115],
              [14.14906180695254, 1.8266405751577912],
              [14.147877904260879, 1.8230459942063624],
              [14.149731825109967, 1.8176748021491496],
              [14.144559638691717, 1.8094562657611708],
              [14.145667832244444, 1.8026327993110391],
              [14.14483504752402, 1.7925511323319276],
              [14.141915607813997, 1.7899878215876697],
              [14.14299636130925, 1.7842746676965113],
              [14.147071782298905, 1.7754950779812235],
              [14.1416589308687, 1.7674429393335356],
              [14.14475334330443, 1.7643542864890303],
              [14.139203386469688, 1.7591887653196474],
              [14.140967823610218, 1.7562521533078694],
              [14.139337540901138, 1.7512208525237978],
              [14.140293851176027, 1.7468973587271044],
              [14.139654831894063, 1.7411150440942054],
              [14.140857809482505, 1.7385192202805635],
              [14.137797102737615, 1.7249824611049094],
              [14.132270100338346, 1.7135969450893591],
              [14.13527076272665, 1.7093338838938723],
              [14.135714526436912, 1.7035667962071075],
              [14.137813015023125, 1.6980994298903846],
              [14.13254435118569, 1.696447874569454],
              [14.13609523447219, 1.6933147053447253],
              [14.133241493835813, 1.6840956028432184],
              [14.1286471618237, 1.6846994291300457],
              [14.124406202362957, 1.6796466478602967],
              [14.122296513045887, 1.6728997416963676],
              [14.121895177303998, 1.667462982654964],
              [14.118392893878251, 1.6632539251771103],
              [14.116813435169925, 1.649283556189794],
              [14.114457397300257, 1.6237350579080778],
              [14.113934218507294, 1.6184622344396407],
              [14.109117056941908, 1.6072879885192821],
              [14.108449819806012, 1.6033583218241179],
              [14.099022655795945, 1.6007333185643695],
              [14.091867255831236, 1.6025516430227016],
              [14.092266964938721, 1.5990289968206843],
              [13.996994002843797, 1.5721137715911926],
              [13.992075896899003, 1.5783444260202442],
              [13.991314758790153, 1.5834932530291916],
              [13.993933465853194, 1.5888384815004595],
              [13.99076909571197, 1.5943083594718004],
              [13.994961233031237, 1.5973443125407898],
              [13.993011027507897, 1.5993978477227144],
              [13.98780543962873, 1.5997451717947977],
              [13.98584942583015, 1.6041679649468723],
              [13.981430936542827, 1.607181797004231],
              [13.979599093394459, 1.6030859138767024],
              [13.976523992571176, 1.6057508323361893],
              [13.97701423399157, 1.6115609447463517],
              [13.972521834675264, 1.6115729183911527],
              [13.962308622075936, 1.6187164100213978],
              [13.966267069003836, 1.6234382171683066],
              [13.964637086489992, 1.6291978236159252],
              [13.970762973277324, 1.6311151181017758],
              [13.968381994812143, 1.6344137253347515],
              [13.976487387298885, 1.6378168577471286],
              [13.970962934322392, 1.6428604396751192],
              [13.965626988991884, 1.6453129311556756],
              [13.970319633715787, 1.6505613858356365],
              [13.966468228370857, 1.6513869374106405],
              [13.964700855708614, 1.6546447329897955],
              [13.96522305906257, 1.6590619443916064],
              [13.96339536069689, 1.66162653148742],
              [13.957958429301808, 1.6618124714349065],
              [13.959376798172292, 1.6577466179955826],
              [13.958054045638146, 1.6549104158481602],
              [13.9534645386939, 1.656594987004007],
              [13.94889992990316, 1.6552306589014858],
              [13.946006880995618, 1.6526575615996075],
              [13.943425780140599, 1.6536199759972063],
              [13.938048143166663, 1.6486198563944199],
              [13.933446810889167, 1.6466110629719377],
              [13.92087504067828, 1.6542485933355953],
              [13.922548885144924, 1.6492712438521524],
              [13.921282465742284, 1.6447379960628363],
              [13.91728425894606, 1.6468415042619724],
              [13.913093868402042, 1.644579412159686],
              [13.909479558162166, 1.6405434011014142],
              [13.907024584862489, 1.634645400012875],
              [13.903829188648052, 1.6349059731408238],
              [13.902856523477347, 1.6300278017772312],
              [13.899085960923928, 1.6290937540460328],
              [13.900094520025894, 1.6257062687684667],
              [13.895819599381445, 1.6185558606297514],
              [13.897773230118851, 1.613410626384952],
              [13.890900030209263, 1.6084250143796264],
              [13.891787365734615, 1.6045198921576063],
              [13.886687640328136, 1.6008651540035648],
              [13.887722798486125, 1.5969085433861672],
              [13.890563196640086, 1.5964061288612694],
              [13.89082703257466, 1.5925036098382843],
              [13.886972153858977, 1.5868422613845576],
              [13.891114982244497, 1.5800171411694102],
              [13.886289358427872, 1.5746407944809115],
              [13.88737831140648, 1.5719035777386203],
              [13.813952463227402, 1.5877718127573208],
              [13.81621067053505, 1.5923601698918564],
              [13.821567182740127, 1.5993993917235443],
              [13.827518598826744, 1.6051690846084499],
              [13.830796191093972, 1.6124582335599882],
              [13.830248788816235, 1.6167017734092706],
              [13.835296478680828, 1.6246500234107561]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.2626163547732, "lat": 39.204627640106956 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51069"],
        "coty_name": ["Frederick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Frederick County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01480124"
      },
      "bbox": [
        13.813952463227402, 1.5719035777386203, 14.160701666084481,
        2.021639097559692
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.75578534867255, -0.4705867352958067],
            [13.766244086586925, -0.4744270018088653],
            [13.78072476283383, -0.4788374695698186],
            [13.784629898263766, -0.48120975763924884],
            [13.794381702423642, -0.48116458759663067],
            [13.799065079475271, -0.47908278001591326],
            [13.812571932232158, -0.48156103971057124],
            [13.819859386271041, -0.4821462616027169],
            [13.82568376264788, -0.4889040589699388],
            [13.831777908027547, -0.4882017793439275],
            [13.835396617453155, -0.4800358408575858],
            [13.843453273495125, -0.4750025436180309],
            [13.848212684933799, -0.467194491083859],
            [13.852459089444228, -0.46540767035304526],
            [13.854936535920196, -0.46856980797490505],
            [13.867461985566143, -0.4711053012923182],
            [13.870981687158949, -0.47270408574624145],
            [13.883794485470867, -0.47546103537822515],
            [13.895292094048354, -0.4816432951027954],
            [13.902515914900247, -0.48051955533347246],
            [13.908825030996619, -0.48314704929353064],
            [13.912363885771601, -0.493449223172697],
            [13.920702845173505, -0.4981584912585155],
            [13.922649581626969, -0.5023843618585696],
            [13.921061178431456, -0.509260756918015],
            [13.91713598582666, -0.5175492430749563],
            [13.917912641235493, -0.5216339384046058],
            [13.922714717205384, -0.5263934120719822],
            [13.926312691813779, -0.5267558099175614],
            [13.931757831670637, -0.5211180086148367],
            [13.940857529055412, -0.5147195292104979],
            [13.951125447165698, -0.5129179458989609],
            [13.963717434978754, -0.5131385760345303],
            [13.972774679931602, -0.5113024065010854],
            [13.979552945488509, -0.5089044260344965],
            [13.983553153058475, -0.5087984603195536],
            [13.994569909370703, -0.51443483853484],
            [13.99875425548956, -0.518251246914855],
            [14.00434462317855, -0.5263674476376307],
            [14.006231293698848, -0.5334225839583373],
            [14.01190170538838, -0.5356968327928463],
            [14.021086804824836, -0.5312226048945452],
            [14.021983449823743, -0.5263376552061847],
            [14.019977875685212, -0.5225233851466432],
            [14.018239320347764, -0.5146426202044635],
            [14.01736788332185, -0.5057345558963123],
            [14.01898154352473, -0.5012590731626664],
            [14.023437824759226, -0.4980238283543748],
            [14.031786288716214, -0.4997631691597968],
            [14.036770301638304, -0.4959344023155098],
            [14.032964006012351, -0.48850801717714404],
            [14.025584640214053, -0.48455367729781795],
            [14.025733127654341, -0.4787390158665372],
            [14.031800103569177, -0.47485228792101886],
            [14.036894788153852, -0.4770419472968263],
            [14.040285175621511, -0.4803973247919725],
            [14.040565132749258, -0.48622285115969366],
            [14.046861358547186, -0.5011319980543577],
            [14.047905108225239, -0.509951240018667],
            [14.051153429988563, -0.518083279179315],
            [14.052481691586792, -0.5255906582028503],
            [14.055088253189107, -0.5314702228179219],
            [14.059409166546907, -0.5358070474708753],
            [14.062024557154682, -0.5412537125022211],
            [14.058577374507117, -0.5481457902077774],
            [14.047218137335536, -0.5533099152243256],
            [14.045749970865733, -0.5593019935485798],
            [14.047619788783342, -0.5624283982004955],
            [14.063124606317349, -0.5686733729741922],
            [14.071063790422073, -0.5731817409062545],
            [14.08092482963205, -0.5812676733482464],
            [14.087407718065242, -0.5892936153570967],
            [14.09827986282714, -0.5963223562893989],
            [14.10247980111225, -0.6048416045442698],
            [14.106939723231603, -0.6095370788667657],
            [14.117040264932449, -0.6107013717574659],
            [14.120233549515053, -0.6131176005244067],
            [14.126164950926738, -0.6238289495364416],
            [14.127617296330405, -0.6283122816579803],
            [14.125152826281987, -0.6342149256889978],
            [14.114620126020103, -0.6406586318691625],
            [14.113888159529493, -0.6479137169631959],
            [14.116696249413794, -0.651082852179719],
            [14.121973597526381, -0.6543061055548379],
            [14.128893963327705, -0.6560209549552177],
            [14.132162264645471, -0.6582743019958341],
            [14.130226165005594, -0.6640198587232999],
            [14.125049279770433, -0.6673495917329724],
            [14.122623476399712, -0.6750204871658266],
            [14.125337520519063, -0.684571432371592],
            [14.133310697885532, -0.6953827633291202],
            [14.137745241343563, -0.699376746229101],
            [14.141515563428781, -0.7052700306199692],
            [14.139726003807597, -0.7109319915591538],
            [14.135951257478352, -0.711684321017861],
            [14.131614576151627, -0.7166163716130415],
            [14.129652310262339, -0.7242426149197512],
            [14.125981568258739, -0.7312460926041482],
            [14.129009984826535, -0.7366021072076093],
            [14.13577812911981, -0.7406203598568505],
            [14.14557380638335, -0.749223977922716],
            [14.147911738560712, -0.7567013571394087],
            [14.152315029857325, -0.7624079152239902],
            [14.162748949289295, -0.7654587294420947],
            [14.167432618781794, -0.7687076753817077],
            [14.170783291039347, -0.7681650220320194],
            [14.175155338392774, -0.7709260011252934],
            [14.187721792273027, -0.7870735140400955],
            [14.192221725876122, -0.79070019638893],
            [14.199837517351979, -0.7940378410582825],
            [14.210782503548154, -0.7976240873423016],
            [14.223871137707171, -0.803481127714842],
            [14.23307298204588, -0.8086626713206079],
            [14.24545033531604, -0.8110632019023798],
            [14.244146109138159, -0.8138185518276069],
            [14.232843014020347, -0.8175583221055741],
            [14.226108333848293, -0.813115588496012],
            [14.22224841141266, -0.8086111536517232],
            [14.217612066231371, -0.8056414799976626],
            [14.210313287790829, -0.8051725164923678],
            [14.20100173306107, -0.7981773911034393],
            [14.192640418130003, -0.796154107062264],
            [14.1875007197205, -0.7922801825967988],
            [14.176358431868083, -0.7806523632322809],
            [14.167848793857042, -0.7764778922045334],
            [14.164813394500525, -0.7764375945877494],
            [14.146494247994154, -0.782406898930754],
            [14.138322999260552, -0.7895168399351],
            [14.136451098563255, -0.7941018737337223],
            [14.13251908989455, -0.7948082808305417],
            [14.129698899119356, -0.7993304611373495],
            [14.133163956154485, -0.8010402410243843],
            [14.134746127290684, -0.8074886778642699],
            [14.133384420261951, -0.8191922799864788],
            [14.129356516065961, -0.8196480218516013],
            [14.130366447603162, -0.8278552451021349],
            [14.12848136379583, -0.8342208275087084],
            [14.131804348324607, -0.837075794340705],
            [14.128586708248951, -0.8400919558028529],
            [14.131773079864, -0.8437541905919482],
            [14.133753094341415, -0.865577489059404],
            [14.134872321249128, -0.8671965562650229],
            [14.131784689867928, -0.877444019721224],
            [14.13616773631874, -0.8808759575510317],
            [14.134983868084547, -0.8849733108868449],
            [14.13253207745962, -0.8854528218901014],
            [14.132854650398386, -0.8908793725436475],
            [14.136418305367213, -0.8953364604110787],
            [14.134484871029741, -0.9000621021859151],
            [14.129580204251125, -0.8984685332925657],
            [14.128251420998685, -0.9056640061765092],
            [14.124852995491674, -0.9077610724038221],
            [14.126854078122241, -0.9105299061739585],
            [14.125496114815173, -0.9202264728884417],
            [14.123618754975166, -0.9225622421349123],
            [14.127245476845957, -0.9286482022092377],
            [14.129956647113787, -0.9300262982264722],
            [14.129044877004048, -0.9359058333188465],
            [14.080429948067524, -0.9450124022644459],
            [13.98709837131439, -0.9617626069664441],
            [13.942912150619852, -0.9696244466881092],
            [13.823241686599047, -0.9917638870661799],
            [13.81256179860618, -0.9935048405808478],
            [13.749836761282628, -1.0049738463292361],
            [13.749675376221655, -1.004095820141161],
            [13.750643693686339, -0.9210812878237421],
            [13.751293660013, -0.8769603503094716],
            [13.752262404554733, -0.7703878816392811],
            [13.752751653103639, -0.7485331139900416],
            [13.753382088240329, -0.6917395968685797],
            [13.754286789803498, -0.6209786867125171],
            [13.755171867855445, -0.5598035199740004],
            [13.75578534867255, -0.4705867352958067]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.93667634171001, "lat": 36.76691658492482 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51083"],
        "coty_name": ["Halifax"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Halifax County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01496705"
      },
      "bbox": [
        13.749675376221655, -1.0049738463292361, 14.24545033531604,
        -0.46540767035304526
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.057961738989155, 0.9749568292812449],
            [13.121843878264475, 0.9569789540230261],
            [13.134781803560937, 0.9562663880357599],
            [13.145840759763562, 0.9510250515433939],
            [13.150589452314414, 0.9494982569838482],
            [13.155814042382527, 0.9421101275191389],
            [13.165299868704752, 0.93464927849282],
            [13.18817243258317, 0.9015531355698745],
            [13.212902240164583, 0.8643846088484343],
            [13.299383771232199, 0.8488805170827454],
            [13.346421554592625, 0.8414513963989656],
            [13.343002808255537, 0.8390792280554097],
            [13.339995011414803, 0.8309659039744255],
            [13.34798243928864, 0.8279092939947128],
            [13.352474343241218, 0.8239398405830108],
            [13.353909974189177, 0.812376072817279],
            [13.349152886365397, 0.8078775063408095],
            [13.342091663921131, 0.8093901703286578],
            [13.340689404408666, 0.8055813257804202],
            [13.336696098792052, 0.8041395316025718],
            [13.335617444183029, 0.7984706405550818],
            [13.333003128485048, 0.7926375041520469],
            [13.336541067920384, 0.7871638700345045],
            [13.332314516120695, 0.7820009840950141],
            [13.32693530626794, 0.7798757394272138],
            [13.323635730558154, 0.7731231346100923],
            [13.324568028666366, 0.7701052547654944],
            [13.320603718901781, 0.7664991078288205],
            [13.317539403054381, 0.7579705966960952],
            [13.320368592363456, 0.7569645404208535],
            [13.31987480340739, 0.7519994938034623],
            [13.316026350809183, 0.7521035704715385],
            [13.31157238624634, 0.7414022503901356],
            [13.310126772833692, 0.7343785017262555],
            [13.307010066102986, 0.7290396905883516],
            [13.306977704544018, 0.7116861471000501],
            [13.299728624748656, 0.711636176423447],
            [13.29626233045662, 0.6953127092231555],
            [13.29879460905076, 0.6928340682185141],
            [13.299112171169494, 0.6864643745173574],
            [13.306202685237695, 0.6791628905884678],
            [13.304288443266984, 0.6757276189937463],
            [13.304603508489532, 0.6691349264876856],
            [13.301567945612376, 0.6632831970070189],
            [13.301549888950968, 0.6604480605982306],
            [13.295252044778673, 0.656113193880961],
            [13.293433692314577, 0.6480834762334983],
            [13.285600836401436, 0.6436925254255511],
            [13.284102950160428, 0.6298438212366371],
            [13.278637972316828, 0.6293352294247095],
            [13.271731080885326, 0.6301667094305269],
            [13.263015706170071, 0.6322741633676221],
            [13.257680335469733, 0.6302038574476323],
            [13.256078971442307, 0.627264200067838],
            [13.25151055572118, 0.6243551918231138],
            [13.255273258416185, 0.6203870666322293],
            [13.251664044087711, 0.613023945408856],
            [13.248866158498217, 0.6124990304740101],
            [13.242872909402267, 0.606887480924899],
            [13.246699487386826, 0.6018659226261248],
            [13.245092224172833, 0.5983218271417582],
            [13.239183131423651, 0.5962408902524009],
            [13.238996219394979, 0.5905287001948921],
            [13.233907043056625, 0.5862680372660277],
            [13.234019180417798, 0.5843204193852406],
            [13.192592547971692, 0.5959200345020722],
            [13.120078625780893, 0.5981537287693365],
            [13.078191607786197, 0.5989698078378572],
            [13.033923904049072, 0.6156958486931299],
            [13.00180366662241, 0.6312376898261459],
            [13.001518832492962, 0.6320712531148591],
            [13.005877656632945, 0.6340928915559476],
            [13.006896203400975, 0.6400512462771772],
            [13.003824410658977, 0.6475848795114192],
            [12.997938225534963, 0.6558552939029278],
            [12.992007516033345, 0.6567248905405481],
            [12.98993008570652, 0.663077411355476],
            [12.984168285460706, 0.6686588427400049],
            [12.984491650232584, 0.6732143597229179],
            [12.990133468462208, 0.6820948103342345],
            [12.99139725652075, 0.6887989772105797],
            [12.998227877527336, 0.6975551525615733],
            [13.003231664275898, 0.6991662615415708],
            [13.00729161632683, 0.7038825533261497],
            [13.009987493287916, 0.7131089787550497],
            [13.007284134143376, 0.7164544238296409],
            [13.01000991757848, 0.7209061880359074],
            [13.0103168595575, 0.7259060510075864],
            [13.016958757914184, 0.7279311701609272],
            [13.026309435271102, 0.7260576049133203],
            [13.033108437534924, 0.7300603219754137],
            [13.034461155564852, 0.7338190351902595],
            [13.038775888428278, 0.7383153295885372],
            [13.036658041344323, 0.7451261325053751],
            [13.032465589532409, 0.7470081960646501],
            [13.032645097904943, 0.7541864108040726],
            [13.034200803050462, 0.7613402461526653],
            [13.036607434396942, 0.7642638277781613],
            [13.03857837962346, 0.776947238698712],
            [13.043625580039535, 0.786009059149701],
            [13.04434383912084, 0.7924630523755505],
            [13.05460081472038, 0.8103370600754208],
            [13.052225031278171, 0.8150459843163071],
            [13.052791682206777, 0.8213694437218485],
            [13.050663427899536, 0.8248649152218444],
            [13.052441408089102, 0.8294707580947528],
            [13.051216479852362, 0.8358106118198145],
            [13.047950600187288, 0.8422886339800282],
            [13.04359645316092, 0.8469796119621288],
            [13.040904225759379, 0.8473443246378852],
            [13.039935613042571, 0.8525859894426393],
            [13.043076996928544, 0.8563712908088765],
            [13.0389498789731, 0.8647885527368159],
            [13.040083391866157, 0.8721670504734593],
            [13.044452147930642, 0.8749232532084338],
            [13.047668219528632, 0.8807416225312527],
            [13.048049060485372, 0.8903375739495698],
            [13.052893740170822, 0.890972829389437],
            [13.061174917670385, 0.8976360306095804],
            [13.056067155731744, 0.905767279637115],
            [13.050574809468346, 0.9093231554656546],
            [13.053573365405434, 0.9196808436537834],
            [13.050555279952544, 0.9243822394487768],
            [13.049807382138422, 0.9305033010358593],
            [13.051043681774162, 0.9423997186119676],
            [13.05520977638079, 0.9446600012935407],
            [13.0510814186148, 0.9521411731929293],
            [13.055243577046884, 0.958790838424038],
            [13.05452080578686, 0.9640103433054159],
            [13.057961738989155, 0.9749568292812449]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.56858552047072, "lat": 38.3623398865077 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51091"],
        "coty_name": ["Highland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Highland County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01673774"
      },
      "bbox": [
        12.984168285460706, 0.5843204193852406, 13.353909974189177,
        0.9749568292812449
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.098802755906119, 0.27421921577566044],
            [15.100452765481416, 0.27503422522798016],
            [15.102484739651555, 0.28399106188199164],
            [15.111132589988456, 0.28940735023297803],
            [15.116442116704112, 0.30120450500962664],
            [15.116947815403742, 0.3050668060551104],
            [15.14112133398948, 0.34287900188650294],
            [15.148022466368104, 0.3412602876716794],
            [15.151565786546346, 0.34213162391832624],
            [15.157594211272986, 0.34111502307849756],
            [15.16356830915518, 0.3417040117765245],
            [15.1654121220514, 0.3473534917891025],
            [15.163475692957128, 0.35628668582750894],
            [15.1663692267002, 0.3575010099230324],
            [15.16802208054764, 0.36138187412556333],
            [15.162531650938329, 0.3670293374815687],
            [15.163736151448822, 0.3782092926388988],
            [15.169646667127427, 0.3774784298303542],
            [15.171432085962001, 0.3802387410841145],
            [15.174437836454919, 0.3786569405243621],
            [15.179338178166532, 0.378677318015787],
            [15.185757821374652, 0.3803946612726936],
            [15.193102393523851, 0.374779319439728],
            [15.199649222300886, 0.3750390692888454],
            [15.199439618578005, 0.36622748209930034],
            [15.201084381994056, 0.36277342829484294],
            [15.207508895423873, 0.3581261918161589],
            [15.211511049367259, 0.35695151481395226],
            [15.217849625830395, 0.35952236095198675],
            [15.219427680873792, 0.3662608417929143],
            [15.23570560431506, 0.3610527178327596],
            [15.243912114637189, 0.3540741930152364],
            [15.253482577784574, 0.35293550172561156],
            [15.258794639871011, 0.35381563251743076],
            [15.260840472217561, 0.3524741198009506],
            [15.256889036794927, 0.3444729756681654],
            [15.25735742659432, 0.3425340269083563],
            [15.263693624685043, 0.33760275689461283],
            [15.270894998780445, 0.3353763910992247],
            [15.27950031879642, 0.33502379256945025],
            [15.284019544095175, 0.3385555652624808],
            [15.291191042774203, 0.3408275554751778],
            [15.29299214099042, 0.34322569398184943],
            [15.290527552710431, 0.34978991522066133],
            [15.282857838775342, 0.3511496927157437],
            [15.28134987880417, 0.35508485346855945],
            [15.286623014897858, 0.35921500683304347],
            [15.293129504022232, 0.3626468939218847],
            [15.298830939161444, 0.36410981266230913],
            [15.303265500839712, 0.36175497122486894],
            [15.30643787939229, 0.3553398314293797],
            [15.310561986505775, 0.3517372825229873],
            [15.313705411028712, 0.3440211720473225],
            [15.31378595775348, 0.3370616944039633],
            [15.310267581365993, 0.3311437801960253],
            [15.3025329029364, 0.3246848223428858],
            [15.30121847130584, 0.32186799933050597],
            [15.303711591443102, 0.31875724264384386],
            [15.309214235878038, 0.3187384472354549],
            [15.320976630697558, 0.3166249975960541],
            [15.325536054780235, 0.3172761634474561],
            [15.32711196357004, 0.32097619670489996],
            [15.326757286326009, 0.326861035790563],
            [15.324011659845743, 0.33921537473528535],
            [15.324088073954098, 0.3417482506516217],
            [15.327521518193425, 0.34612585781677957],
            [15.338475919261029, 0.3543510959355105],
            [15.341829023426735, 0.35566924435755304],
            [15.349577164367595, 0.3562758293104166],
            [15.353282680786641, 0.354117189820412],
            [15.35484242357393, 0.34638856799192413],
            [15.355030806262493, 0.33713166828047425],
            [15.360205200246257, 0.3347725080930824],
            [15.36446865935547, 0.33565867971581764],
            [15.371085204826857, 0.3411490914781143],
            [15.37783174654923, 0.3454599933876049],
            [15.377928587148197, 0.3506450331040242],
            [15.370516843193906, 0.3598925524723437],
            [15.367361639712618, 0.3680234207772034],
            [15.371785301683419, 0.37216363944979913],
            [15.376782176493402, 0.3749762908649406],
            [15.384883609449306, 0.37473146692669324],
            [15.388129597995627, 0.3725960972867559],
            [15.390009968308357, 0.3686524800285134],
            [15.389751482168036, 0.36045981423587703],
            [15.386908006371907, 0.34382235561474267],
            [15.38466933873272, 0.33760133758204774],
            [15.380087960403905, 0.330494479258637],
            [15.379940178334781, 0.32306170115937066],
            [15.391204992604816, 0.31843440566793996],
            [15.397145651157555, 0.318858673093313],
            [15.401396446068736, 0.3230082388754233],
            [15.413041699290451, 0.34077662986961316],
            [15.414900735538687, 0.3513398971235944],
            [15.416807081041208, 0.3532366572810011],
            [15.421823085753768, 0.3523188892401096],
            [15.424692936568432, 0.3493305867842615],
            [15.435001097973334, 0.33495308411396374],
            [15.441360976813186, 0.32813214326402496],
            [15.448373382391267, 0.32386853856454034],
            [15.450808753899112, 0.3148278122219854],
            [15.453203906435864, 0.31070385643587195],
            [15.462715328999149, 0.3088334387618157],
            [15.474522048412457, 0.30445908526198645],
            [15.486364397217791, 0.29697116266200296],
            [15.490836373908458, 0.2919229204270413],
            [15.497265116989537, 0.28182454676626123],
            [15.486954785320941, 0.27418081623533797],
            [15.486655506610179, 0.2689342763999645],
            [15.483342558017588, 0.26568965200146893],
            [15.486388267851932, 0.2583453687740226],
            [15.484330133694064, 0.25152472307211576],
            [15.47865621236739, 0.24692203738751126],
            [15.478882877627667, 0.2446935520280929],
            [15.471627217708958, 0.2462600930605034],
            [15.467948286260196, 0.2457956895144962],
            [15.464892853757188, 0.24257825124635293],
            [15.460116613217002, 0.24430037058446916],
            [15.45068160220129, 0.25004114214503836],
            [15.437321385281207, 0.2526855035445554],
            [15.425684245052635, 0.24837991532173007],
            [15.422011918863449, 0.24624122554278224],
            [15.417856726490847, 0.24670541451352027],
            [15.410498671016331, 0.24319111215253564],
            [15.40581998109956, 0.23642666609111246],
            [15.39943616347787, 0.23430700116738404],
            [15.395311572484397, 0.23011134779971495],
            [15.392455536515616, 0.2251234474578891],
            [15.388686385202275, 0.22388527971682493],
            [15.387074667672358, 0.21919562593048628],
            [15.392478258013222, 0.21190000572940648],
            [15.390212265601917, 0.20612168437926823],
            [15.392437577288794, 0.20118134387296013],
            [15.391424652899925, 0.1991869639295882],
            [15.39356550231855, 0.19170667211807582],
            [15.390756659721644, 0.19043566768107456],
            [15.392850330018303, 0.1832569684761661],
            [15.397384896523814, 0.17983213247207325],
            [15.39849587649237, 0.17535003892710038],
            [15.393930896934828, 0.17353877246276278],
            [15.39181808124837, 0.1764400175300939],
            [15.390158369563691, 0.16776101181710026],
            [15.378449831945321, 0.17217442741390257],
            [15.377923983144425, 0.1771610573778524],
            [15.384611798357806, 0.18023000990369517],
            [15.385684374822658, 0.18224973264073396],
            [15.385161150456375, 0.1936972067777333],
            [15.381866665467513, 0.1943226849671483],
            [15.38071365877842, 0.18836145753581438],
            [15.377128170212915, 0.1833633304921917],
            [15.369356115777629, 0.18592954581779825],
            [15.365812599918081, 0.18202057841620775],
            [15.365858857376493, 0.17345049426595058],
            [15.360779187608603, 0.16803225756880544],
            [15.357755217877202, 0.16763302699575322],
            [15.35535188762977, 0.17450490610821034],
            [15.355342426673735, 0.17762926615001448],
            [15.359888451626308, 0.18413301122194645],
            [15.360004992306184, 0.18816406669357846],
            [15.357967622131788, 0.19180463930978228],
            [15.353801188146237, 0.1940851119370988],
            [15.348280113464044, 0.18634597510941703],
            [15.344735176408353, 0.18548065961600224],
            [15.334739448529158, 0.18621787557598388],
            [15.330981944569483, 0.18926460341521997],
            [15.332478436146708, 0.19475616234436832],
            [15.330163434826142, 0.19749079861332364],
            [15.320864179515775, 0.1975754069059596],
            [15.317555728888358, 0.19143866313936625],
            [15.309697678067248, 0.1931790295906351],
            [15.303354481186876, 0.1873123035958734],
            [15.300070988801929, 0.1890458537883183],
            [15.296777611112718, 0.18625464932813626],
            [15.292364526138465, 0.18741676936147025],
            [15.288909240076004, 0.19098896795252043],
            [15.28913898513835, 0.19379136809116937],
            [15.285629223289897, 0.19944297899803295],
            [15.282034939062818, 0.1991485686716027],
            [15.278869320402206, 0.19588949912973025],
            [15.276577972039613, 0.1977894984549757],
            [15.2694740557882, 0.19904540144235022],
            [15.26339030599538, 0.19789855566398015],
            [15.259853913459045, 0.19452228451027861],
            [15.25901579135887, 0.200126095409671],
            [15.24493537212116, 0.2038725596429646],
            [15.243436099082938, 0.20232256680682392],
            [15.23711764551487, 0.2024068019367726],
            [15.229983361456881, 0.1998147085823201],
            [15.216925547048378, 0.21012047664029432],
            [15.212569523881774, 0.20917217993611067],
            [15.20906019828295, 0.21161450410370117],
            [15.209705531979505, 0.21421241016209314],
            [15.204776454985069, 0.2182921274493563],
            [15.19990856504954, 0.226006985564682],
            [15.196450621750817, 0.22529064999301465],
            [15.189085714762763, 0.22053298402354685],
            [15.187323281717013, 0.22838151612194993],
            [15.183270515883073, 0.22694056005120053],
            [15.180708031034804, 0.22801995452301066],
            [15.175446798560056, 0.22412321138772154],
            [15.172140620535556, 0.22550564480040064],
            [15.173399678517148, 0.23536290332001358],
            [15.168186913971713, 0.23315104764934244],
            [15.165742464867282, 0.2287351219434807],
            [15.162592644144333, 0.23463155338436767],
            [15.157255905902982, 0.23702305956893419],
            [15.1438862126853, 0.2452963126644381],
            [15.14203240245425, 0.25044584466732484],
            [15.137540351773247, 0.2519830473673658],
            [15.132890084501279, 0.25524263669559816],
            [15.129855579385113, 0.25505789465996254],
            [15.12593922989699, 0.2614792282941261],
            [15.12145232857472, 0.26565667875451054],
            [15.116921871819272, 0.26665370805346045],
            [15.1149685714612, 0.2724498758679522],
            [15.110785041493797, 0.2722726110782128],
            [15.10553499771359, 0.2771620081258159],
            [15.098802755906119, 0.27421921577566044]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.99752698342651,
          "lat": 37.505270892954584
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51127"],
        "coty_name": ["New Kent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["New Kent County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01480150"
      },
      "bbox": [
        15.098802755906119, 0.16763302699575322, 15.497265116989537,
        0.3803946612726936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.813952463227402, 1.5877718127573208],
            [13.88737831140648, 1.5719035777386203],
            [13.886289358427872, 1.5746407944809115],
            [13.891114982244497, 1.5800171411694102],
            [13.886972153858977, 1.5868422613845576],
            [13.89082703257466, 1.5925036098382843],
            [13.890563196640086, 1.5964061288612694],
            [13.887722798486125, 1.5969085433861672],
            [13.886687640328136, 1.6008651540035648],
            [13.891787365734615, 1.6045198921576063],
            [13.890900030209263, 1.6084250143796264],
            [13.897773230118851, 1.613410626384952],
            [13.895819599381445, 1.6185558606297514],
            [13.900094520025894, 1.6257062687684667],
            [13.899085960923928, 1.6290937540460328],
            [13.902856523477347, 1.6300278017772312],
            [13.903829188648052, 1.6349059731408238],
            [13.907024584862489, 1.634645400012875],
            [13.909479558162166, 1.6405434011014142],
            [13.913093868402042, 1.644579412159686],
            [13.91728425894606, 1.6468415042619724],
            [13.921282465742284, 1.6447379960628363],
            [13.922548885144924, 1.6492712438521524],
            [13.92087504067828, 1.6542485933355953],
            [13.933446810889167, 1.6466110629719377],
            [13.938048143166663, 1.6486198563944199],
            [13.943425780140599, 1.6536199759972063],
            [13.946006880995618, 1.6526575615996075],
            [13.94889992990316, 1.6552306589014858],
            [13.9534645386939, 1.656594987004007],
            [13.958054045638146, 1.6549104158481602],
            [13.959376798172292, 1.6577466179955826],
            [13.957958429301808, 1.6618124714349065],
            [13.96339536069689, 1.66162653148742],
            [13.96522305906257, 1.6590619443916064],
            [13.964700855708614, 1.6546447329897955],
            [13.966468228370857, 1.6513869374106405],
            [13.970319633715787, 1.6505613858356365],
            [13.965626988991884, 1.6453129311556756],
            [13.970962934322392, 1.6428604396751192],
            [13.976487387298885, 1.6378168577471286],
            [13.968381994812143, 1.6344137253347515],
            [13.970762973277324, 1.6311151181017758],
            [13.964637086489992, 1.6291978236159252],
            [13.966267069003836, 1.6234382171683066],
            [13.962308622075936, 1.6187164100213978],
            [13.972521834675264, 1.6115729183911527],
            [13.97701423399157, 1.6115609447463517],
            [13.976523992571176, 1.6057508323361893],
            [13.979599093394459, 1.6030859138767024],
            [13.981430936542827, 1.607181797004231],
            [13.98584942583015, 1.6041679649468723],
            [13.98780543962873, 1.5997451717947977],
            [13.993011027507897, 1.5993978477227144],
            [13.994961233031237, 1.5973443125407898],
            [13.99076909571197, 1.5943083594718004],
            [13.993933465853194, 1.5888384815004595],
            [13.991314758790153, 1.5834932530291916],
            [13.992075896899003, 1.5783444260202442],
            [13.996994002843797, 1.5721137715911926],
            [13.992823531693874, 1.568878669117672],
            [13.98964845398528, 1.5623670612177902],
            [13.983900721710025, 1.5609793027264367],
            [13.988126214607592, 1.557495348196832],
            [13.98786616436287, 1.555031000041246],
            [13.999884180535945, 1.5473162993307443],
            [13.998129204874594, 1.5449618598334085],
            [13.998865800005339, 1.5410827762309567],
            [13.995999946242218, 1.5371904912276777],
            [13.989225324439676, 1.5422531104179518],
            [13.98581446833283, 1.5431852615414943],
            [13.983564984467236, 1.5401919744368533],
            [13.986054412644581, 1.5376569522211896],
            [13.992931495787744, 1.5236454991140191],
            [13.991811025765553, 1.5134215961571118],
            [14.004387113473797, 1.516135838066545],
            [14.009164316371072, 1.5145493814789273],
            [14.01250709304328, 1.518173509862072],
            [14.019369387793805, 1.5101831034000808],
            [14.017361518998353, 1.5045443032477333],
            [14.016328734999858, 1.4926576575014578],
            [14.015209031874488, 1.4898319533540678],
            [14.008178784067645, 1.4821001612287978],
            [14.006305181937792, 1.4673433334680421],
            [14.000470461290003, 1.4525641081658403],
            [14.00547808943063, 1.4513711780379224],
            [14.005260751951912, 1.4436941574984856],
            [14.001818051591988, 1.4341127849073858],
            [13.999054555035956, 1.428638071952438],
            [13.996280821653302, 1.4265261858051204],
            [13.989217213960048, 1.415453493279908],
            [13.98217875538552, 1.4016495875737083],
            [13.976615755430121, 1.3882188574652443],
            [13.970449737940243, 1.3769270668145506],
            [13.963650422571767, 1.368077780074045],
            [13.951960639373402, 1.348559712727325],
            [13.94674901585683, 1.3356349894824506],
            [13.938494363018174, 1.3221682708538403],
            [13.934148698849851, 1.3118631898991089],
            [13.930657754458261, 1.3067426256957013],
            [13.92627272461488, 1.296571688393173],
            [13.919576560567593, 1.2882726306403396],
            [13.914973188979443, 1.2836523218245115],
            [13.910612992762303, 1.282366672460657],
            [13.90801846233943, 1.2785708857663536],
            [13.90151353116646, 1.2642781649717254],
            [13.868990801428955, 1.271494947994476],
            [13.868269381510153, 1.2635845197274524],
            [13.863272713537311, 1.2504484004615297],
            [13.854769544467723, 1.2334430718971134],
            [13.847476237846855, 1.213976633425337],
            [13.843282498422761, 1.1957105123231861],
            [13.838557090014943, 1.1678149831333047],
            [13.836074139251233, 1.1590192029863258],
            [13.833837412007076, 1.1469725110212383],
            [13.831693485045824, 1.1396431981355097],
            [13.82332359560489, 1.1271836902780976],
            [13.823021640996284, 1.1255890015035062],
            [13.799181490457197, 1.1406115635876144],
            [13.76627094700255, 1.1604654719542125],
            [13.726585669010634, 1.1846493195299366],
            [13.682561643050418, 1.212183227077795],
            [13.67429417279576, 1.2167795634632883],
            [13.62119099540673, 1.2510156056598523],
            [13.63141557745487, 1.2857016619179389],
            [13.638287809477848, 1.3039083110608207],
            [13.639983569660536, 1.3071823934731341],
            [13.645397921177741, 1.3251990555437358],
            [13.649773092837052, 1.345119914451345],
            [13.650677318881733, 1.3520157735260208],
            [13.656406740250546, 1.3719768208705465],
            [13.659354803486446, 1.3755814373856032],
            [13.660699815870634, 1.3835546920345252],
            [13.666092651342389, 1.3919049319157268],
            [13.670686347356266, 1.3942282163371216],
            [13.679843598936014, 1.402871487806855],
            [13.683514425237956, 1.419451149112602],
            [13.690251242286308, 1.4322366419426225],
            [13.701979914431673, 1.4386210217174047],
            [13.704464887293494, 1.4420148821006447],
            [13.705142036947336, 1.4314620007191412],
            [13.7062878643805, 1.427974914078456],
            [13.707091177022258, 1.4174328051975809],
            [13.708636121292722, 1.4136762487712267],
            [13.71159346186119, 1.4131145127803475],
            [13.718671583937363, 1.4250907047327013],
            [13.723865790217701, 1.426427165229988],
            [13.729094462366048, 1.4368093126853587],
            [13.734915083112321, 1.4384283437570393],
            [13.740769809368224, 1.4482178557841354],
            [13.742976681640519, 1.4566087649194652],
            [13.747093538983922, 1.463316782948666],
            [13.748957724643173, 1.4702202269085467],
            [13.749729386690879, 1.477455889122481],
            [13.75272614057184, 1.4856667462201203],
            [13.759151767670305, 1.4854992525412938],
            [13.762205842489841, 1.4941924341692192],
            [13.763290929852147, 1.500681678547542],
            [13.769861925089145, 1.5036768994708019],
            [13.772771455947886, 1.4954706650739293],
            [13.778067067299345, 1.498556186622123],
            [13.781372537245646, 1.4926075886153183],
            [13.787400938403982, 1.488447003827073],
            [13.788582998857278, 1.4937396327507793],
            [13.792411955558876, 1.4968832788980555],
            [13.797751900762398, 1.5117278184209586],
            [13.798668484713355, 1.5171851011623974],
            [13.804217388272303, 1.5294896499735582],
            [13.810686758245804, 1.5412881733120476],
            [13.816305432525823, 1.5486829433560019],
            [13.810461870550611, 1.551014747366988],
            [13.808187724825101, 1.5537370168151075],
            [13.803159263941417, 1.554700256941112],
            [13.797523732760077, 1.5594980693174711],
            [13.806677361932138, 1.5740596471086055],
            [13.807906119183434, 1.577912206313401],
            [13.813952463227402, 1.5877718127573208]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.5708596363242, "lat": 38.8582785542437 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51171"],
        "coty_name": ["Shenandoah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shenandoah County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "01673918"
      },
      "bbox": [
        13.62119099540673, 1.1255890015035062, 14.019369387793805,
        1.6618124714349065
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.084538798677297, -0.28984455862190067],
            [15.095633999413463, -0.2802686524383891],
            [15.103100576506971, -0.27252797975549425],
            [15.145756019937071, -0.2319030144057158],
            [15.212400721167388, -0.16827878918895914],
            [15.221256771609667, -0.15966016434469973],
            [15.226160682078635, -0.1534990203042761],
            [15.236824218354537, -0.1438912005452906],
            [15.249430910787364, -0.13436054707348896],
            [15.252789415032524, -0.1417055800561055],
            [15.25698243126836, -0.14378787379603053],
            [15.265056051454307, -0.14157867069491073],
            [15.26959634996728, -0.14137508311834715],
            [15.270352284841564, -0.1444518976373077],
            [15.27826675933674, -0.14269966355060124],
            [15.280987673803372, -0.1392968424484991],
            [15.285791849335528, -0.13879811322064436],
            [15.287578809253896, -0.1404652411394888],
            [15.29046575779199, -0.14792080687645415],
            [15.294586171572256, -0.14928049834170523],
            [15.298282446609194, -0.15367337549193236],
            [15.302344908602779, -0.15018887205538164],
            [15.30554971318119, -0.15317259191316104],
            [15.310287329859445, -0.15212142582176302],
            [15.311964819140355, -0.14982494336494262],
            [15.315635399440493, -0.1522662821324583],
            [15.315360505344778, -0.15637708393813574],
            [15.319259948024547, -0.16120103780765402],
            [15.317661391870196, -0.16548415516911844],
            [15.320310936015131, -0.16697671079694174],
            [15.325447591000534, -0.16447834342447504],
            [15.333279465152257, -0.16650434922113352],
            [15.341719271409854, -0.1664959214982509],
            [15.343969366242886, -0.16193922945410563],
            [15.343578510433398, -0.15848179817236127],
            [15.355035271433954, -0.15979854798672807],
            [15.36772109768872, -0.16343723789080136],
            [15.369242832519845, -0.16595910263474703],
            [15.37531238611211, -0.16430971689172555],
            [15.377918178520282, -0.17029078350729665],
            [15.387943379951759, -0.17042081940288925],
            [15.392621651173377, -0.16967124202923092],
            [15.3973949781067, -0.16482943823300727],
            [15.399407925481544, -0.1672502343103118],
            [15.405130256460106, -0.16186498866039195],
            [15.408242572648785, -0.16153926887770026],
            [15.408584303610146, -0.16616290912271905],
            [15.411721038375232, -0.1719634556662154],
            [15.407746027929305, -0.17642681334574722],
            [15.409775307654167, -0.1822162546523935],
            [15.418452003572114, -0.21522820428180867],
            [15.439388009811529, -0.26861318759272323],
            [15.419835741038804, -0.2878715172043843],
            [15.406471565209724, -0.29970994997007083],
            [15.389755118129715, -0.316558154927766],
            [15.361068308476304, -0.3461608464679355],
            [15.326127808554947, -0.38083167268398715],
            [15.255172724975376, -0.44727911003977655],
            [15.173540378302866, -0.519625924795113],
            [15.115924242980167, -0.5772964004087916],
            [15.111497221055291, -0.5740888122401916],
            [15.108145066796443, -0.5764479208311242],
            [15.093391532651015, -0.5742089106407431],
            [15.085487042852769, -0.5755378448229304],
            [15.080619252155984, -0.572215121394872],
            [15.075189452438439, -0.5727950672471913],
            [15.071459960999457, -0.5712712904824793],
            [15.066674658707585, -0.5732875593349263],
            [15.065633769235617, -0.5274674891303567],
            [15.064425964583203, -0.467075509790915],
            [15.063288078689627, -0.42787435850489935],
            [15.056523426509306, -0.4310034029023064],
            [15.050807479521911, -0.43222875105322267],
            [15.043786333804622, -0.44162588513726],
            [15.040802303985851, -0.44722406225278094],
            [15.033707501730772, -0.45211871763581796],
            [15.026598766285158, -0.45351452093138417],
            [15.022830864128466, -0.45131173964153115],
            [15.013358703001334, -0.4501588861377227],
            [15.009985586178445, -0.4487967410863471],
            [14.998369605195652, -0.45100890316219094],
            [14.9898130610748, -0.4602485115897502],
            [14.984026859377888, -0.45796932814742575],
            [14.980162722296189, -0.4542103598668014],
            [14.973942606922048, -0.457199313120624],
            [14.970141846681713, -0.4530725334054004],
            [14.964642694681745, -0.4511863943256325],
            [14.96148694182805, -0.44577837225343825],
            [14.95592642610225, -0.44065567415979007],
            [14.953422899039992, -0.4400889189127954],
            [14.947760146526264, -0.4424016996261689],
            [14.947716858613488, -0.43770736800591653],
            [14.945421089230548, -0.4362056017838379],
            [14.940936162966777, -0.4386646525598825],
            [14.93572418968642, -0.4376556755326271],
            [14.93765704819395, -0.4358799929804188],
            [15.025497412482778, -0.3490972652966388],
            [15.050312803508508, -0.32437259630363846],
            [15.084538798677297, -0.28984455862190067]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.26183365540636, "lat": 36.92174250378888 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51183"],
        "coty_name": ["Sussex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sussex County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "01690257"
      },
      "bbox": [
        14.93572418968642, -0.5772964004087916, 15.439388009811529,
        -0.13436054707348896
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.87287559561918, -0.22765628885041117],
            [15.875224177162192, -0.22682595046782775],
            [15.885830172352987, -0.2267700179330615],
            [15.887448080414883, -0.222503272377065],
            [15.883862689688105, -0.19880613377279321],
            [15.884959923152712, -0.1973509284542332],
            [15.906496818843497, -0.1932305174800244],
            [15.908246245389607, -0.19420067814428707],
            [15.917190356821266, -0.22063999397822825],
            [15.925373779528053, -0.22061813491084736],
            [15.927578043946289, -0.22499707935216723],
            [15.927397227341489, -0.22974346416783478],
            [15.92417838475964, -0.23114926750996567],
            [15.919643845332036, -0.23597318475617285],
            [15.92511824560416, -0.24792340484157493],
            [15.929115764366678, -0.24968857496096616],
            [15.931100371039925, -0.25403003490946646],
            [15.919815088420306, -0.25982308031521056],
            [15.919819599365319, -0.26427448659718356],
            [15.915272571581607, -0.2759270815557801],
            [15.912061914244353, -0.2790910235529758],
            [15.910986424731957, -0.28255127116061257],
            [15.914178185197036, -0.284243826969615],
            [15.919036680646135, -0.2830555168236873],
            [15.923302306841547, -0.28035300983108613],
            [15.921813737935324, -0.2758372728362092],
            [15.9292861927404, -0.262696670064078],
            [15.932767385439897, -0.2621210337735459],
            [15.933835628074142, -0.25920431448836584],
            [15.949652793290875, -0.2525354298082344],
            [15.95564370083297, -0.25693232733603677],
            [15.955834338113608, -0.25935388766783335],
            [15.960448464702969, -0.26089214404071814],
            [15.964130202909619, -0.2565919390325521],
            [15.971807448157419, -0.26453291216106367],
            [15.972989255684833, -0.2728466457104636],
            [15.979217093242513, -0.28319502904658894],
            [15.978956782802697, -0.28696403152855876],
            [15.981906322623008, -0.29635742799560655],
            [15.982569478323935, -0.3052908906017296],
            [15.961461824165921, -0.31468863528997776],
            [15.95510489030585, -0.31823247851919656],
            [15.920154268598873, -0.3327182414075115],
            [15.90878342515049, -0.32222083845336474],
            [15.908197106950418, -0.3201980514092642],
            [15.900956493718052, -0.3156554733034187],
            [15.896853246827334, -0.31657893040325774],
            [15.892640133830312, -0.3096096539352223],
            [15.896088834464011, -0.29434429310819815],
            [15.903455605418644, -0.28310616763945434],
            [15.898200652944011, -0.2765730146564735],
            [15.897841499630623, -0.2701496118278464],
            [15.89300861376246, -0.26569412304759976],
            [15.887047030713173, -0.266223602227607],
            [15.88594477839851, -0.2574760131297786],
            [15.883493939465218, -0.25736981209490745],
            [15.86887536697947, -0.2606324578313067],
            [15.872619557879693, -0.25169204826119784],
            [15.876768511125675, -0.24701119771185137],
            [15.877598722630395, -0.23952944024886058],
            [15.873925372656112, -0.23420872772238277],
            [15.875443019251069, -0.23019754989186333],
            [15.87287559561918, -0.22765628885041117]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.35536452253291,
          "lat": 36.845342507736454
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51740"],
        "coty_name": ["Portsmouth"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Portsmouth city"],
        "coty_fp_code": "740",
        "coty_gnis_code": "01498556"
      },
      "bbox": [
        15.86887536697947, -0.3327182414075115, 15.982569478323935,
        -0.1932305174800244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.066648253323258, 9.706107844816284],
            [-17.002787161525248, 9.6891717061453],
            [-16.995787735626262, 9.687619710490582],
            [-16.887651829445232, 9.65871847523538],
            [-16.875318585027497, 9.655224989368904],
            [-16.79121679931257, 9.632227147992367],
            [-16.77777791005692, 9.627356270421918],
            [-16.762882048564776, 9.622602198743392],
            [-16.74986233032223, 9.619847727469283],
            [-16.68036989798475, 9.60088968679495],
            [-16.674034757214887, 9.598925382812794],
            [-16.566016409159555, 9.569957730649627],
            [-16.458007731908086, 9.540953300799133],
            [-16.44371945739721, 9.537022318021943],
            [-16.43018911270546, 9.534284385568974],
            [-16.374232570389694, 9.519916401157017],
            [-16.348973683090925, 9.51309819453227],
            [-16.333199363452078, 9.507667068361206],
            [-16.30490817139265, 9.501728464106177],
            [-16.267464482867467, 9.49200380417791],
            [-16.147147372582374, 9.461009924060258],
            [-16.143348177586866, 9.459772132263186],
            [-16.12111352577834, 9.454576549647328],
            [-16.066030580163776, 9.439902963894136],
            [-16.038128171522292, 9.432705006490579],
            [-15.954517580615358, 9.411371265924588],
            [-15.959177660850855, 9.397212014082053],
            [-15.977558786278546, 9.327448864214952],
            [-16.00301108520493, 9.230520909900608],
            [-16.00702087097825, 9.216159421391845],
            [-16.012641988335282, 9.216338274615271],
            [-16.03543266850763, 9.21541298194944],
            [-16.075739984152083, 9.221811595407937],
            [-16.101506123929774, 9.21626651354085],
            [-16.156066679364223, 9.202343795445469],
            [-16.20718253615969, 9.203195592686557],
            [-16.229659333167945, 9.197544053032425],
            [-16.265954543149725, 9.170169251831176],
            [-16.315404222463126, 9.178107234930625],
            [-16.320075464224928, 9.178190210397148],
            [-16.3496838770832, 9.176553499326078],
            [-16.403302531456937, 9.178392534459167],
            [-16.457511130043237, 9.187569885692682],
            [-16.471965820914797, 9.19704358031042],
            [-16.480346020013005, 9.209224870265354],
            [-16.498401230680567, 9.243009160508436],
            [-16.517708918727756, 9.256414416599894],
            [-16.54745591241678, 9.26347792581665],
            [-16.562191726161434, 9.258562086341982],
            [-16.574364597692643, 9.254504165339272],
            [-16.59187504015922, 9.244500968318071],
            [-16.617788115894935, 9.24170772756227],
            [-16.666678236520475, 9.233946706448181],
            [-16.715585186559803, 9.231836425667812],
            [-16.749933006597665, 9.211705503548686],
            [-16.7627768955588, 9.2121431991344],
            [-16.764018160973976, 9.213755322485435],
            [-16.779127627767465, 9.233230499224364],
            [-16.78519512659164, 9.235146163501861],
            [-16.8039317841607, 9.232558605172725],
            [-16.807906049420506, 9.232591316995467],
            [-16.822826853200862, 9.241535267107015],
            [-16.841049489142577, 9.244115270461505],
            [-16.861432611872527, 9.25112866963465],
            [-16.87652901024885, 9.250395301641612],
            [-16.9067114986604, 9.233145773885369],
            [-16.905987445100415, 9.227823932780955],
            [-16.90999966032033, 9.226800114017571],
            [-16.918233952559603, 9.222554948343657],
            [-16.92274493675936, 9.226009841569406],
            [-16.927897243891245, 9.223220459859439],
            [-16.943438736460806, 9.225550418983994],
            [-16.954147679707074, 9.228768449909357],
            [-16.9600505559015, 9.24082777400013],
            [-16.955798506344628, 9.252799436099194],
            [-16.953942765841205, 9.273071086842949],
            [-16.95873295001043, 9.296239480036432],
            [-16.980740008627333, 9.309455416493421],
            [-17.002847729042763, 9.324217060609389],
            [-17.01622673759806, 9.34100967232865],
            [-17.032143188213507, 9.350432106863794],
            [-17.056086921421283, 9.355009663807259],
            [-17.078442517864914, 9.350592742810063],
            [-17.092881079840783, 9.35562326201908],
            [-17.103889493208356, 9.361989302928055],
            [-17.117387647805185, 9.36979887160421],
            [-17.136689806400256, 9.394949106263187],
            [-17.152138888907867, 9.403289092332853],
            [-17.148806349503268, 9.409585212644494],
            [-17.14795817094173, 9.421717195844876],
            [-17.14564622707721, 9.424331812698819],
            [-17.149237577253437, 9.437470940920063],
            [-17.151478368313867, 9.439646896156455],
            [-17.149624657495334, 9.449667911209405],
            [-17.14381833981564, 9.451373791632294],
            [-17.141367402789896, 9.45401856663268],
            [-17.135410194649186, 9.45292585178272],
            [-17.132766711664036, 9.45639765936406],
            [-17.194430380264553, 9.47370529172413],
            [-17.177915030401753, 9.530638829292226],
            [-17.170647599217816, 9.557017205810057],
            [-17.1732416876167, 9.55778296624923],
            [-17.16571325025959, 9.58480521474686],
            [-17.126882382045544, 9.7225643862764],
            [-17.066648253323258, 9.706107844816284]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.78912367272174,
          "lat": 45.87380007323419
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53039"],
        "coty_name": ["Klickitat"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Klickitat County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01529219"
      },
      "bbox": [
        -17.194430380264553, 9.170169251831176, -15.954517580615358,
        9.7225643862764
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.548422573859416, 9.848761864273735],
            [-17.52831915203143, 9.919100633995878],
            [-17.509039164232988, 9.987716544799913],
            [-17.505303351859688, 9.997658263715275],
            [-17.502918858644136, 9.997291120326786],
            [-17.474947372708062, 10.092389538554],
            [-17.462598534413285, 10.13334514991743],
            [-17.453968563135735, 10.161073293371105],
            [-17.45497247234837, 10.161294078606932],
            [-17.454851681694606, 10.161773650358096],
            [-17.426011006688245, 10.154235180829337],
            [-17.398065456454432, 10.146308302036145],
            [-17.370362578901425, 10.138898319449135],
            [-17.36998382891909, 10.140665056901625],
            [-17.31531310936674, 10.125004219441477],
            [-17.287144260503066, 10.117395170052973],
            [-17.286966802921874, 10.118002900358462],
            [-17.20083800926327, 10.094357425272701],
            [-17.114715582361285, 10.070687744432083],
            [-17.045059142379586, 10.051741270963628],
            [-16.975406824598586, 10.032778999037115],
            [-16.975513467922596, 10.032397383760141],
            [-17.066648253323258, 9.706107844816284],
            [-17.126882382045544, 9.7225643862764],
            [-17.16571325025959, 9.58480521474686],
            [-17.1732416876167, 9.55778296624923],
            [-17.170647599217816, 9.557017205810057],
            [-17.177915030401753, 9.530638829292226],
            [-17.194430380264553, 9.47370529172413],
            [-17.132766711664036, 9.45639765936406],
            [-17.135410194649186, 9.45292585178272],
            [-17.141367402789896, 9.45401856663268],
            [-17.14381833981564, 9.451373791632294],
            [-17.149624657495334, 9.449667911209405],
            [-17.151478368313867, 9.439646896156455],
            [-17.149237577253437, 9.437470940920063],
            [-17.14564622707721, 9.424331812698819],
            [-17.14795817094173, 9.421717195844876],
            [-17.148806349503268, 9.409585212644494],
            [-17.152138888907867, 9.403289092332853],
            [-17.158048595735032, 9.406569801393138],
            [-17.22990729839733, 9.403743297367427],
            [-17.25484349630095, 9.410983216522602],
            [-17.283846195596492, 9.408399728992336],
            [-17.3027368700728, 9.412782170469342],
            [-17.350633867020264, 9.438937695419522],
            [-17.391856276614952, 9.436472750707114],
            [-17.42127494255298, 9.421481733091738],
            [-17.42294609693085, 9.413027815813214],
            [-17.42998321881668, 9.407176378791027],
            [-17.440661271706883, 9.404759520450092],
            [-17.450842444639488, 9.40245688228408],
            [-17.461871660759808, 9.406303864177355],
            [-17.464870787341578, 9.405706977577227],
            [-17.4730385020401, 9.396929042164418],
            [-17.48885811572064, 9.391089864187222],
            [-17.50462850525403, 9.388404925951322],
            [-17.51755818054276, 9.391188176774572],
            [-17.533769380640553, 9.389909081881635],
            [-17.57941589409585, 9.375941692348354],
            [-17.587184106996308, 9.375942264277873],
            [-17.605473664074704, 9.3842076082372],
            [-17.63625685952603, 9.385803327558477],
            [-17.652075346647713, 9.376321254273384],
            [-17.688346733448014, 9.369672770289267],
            [-17.670367372883042, 9.432480718574675],
            [-17.657100865088736, 9.480853439525124],
            [-17.65445411646365, 9.488470977252804],
            [-17.635201175495016, 9.556020426362785],
            [-17.63386050182841, 9.5625788429452],
            [-17.615816562735425, 9.623814055633948],
            [-17.61421188399517, 9.63069729808542],
            [-17.609847157099583, 9.643406054931454],
            [-17.602044673328567, 9.672213626917156],
            [-17.59852128002682, 9.671155592566455],
            [-17.57937027100921, 9.73945540450582],
            [-17.575834328212796, 9.754196581736318],
            [-17.554011183996245, 9.828569697764834],
            [-17.548422573859416, 9.848761864273735]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.91475185717651,
          "lat": 46.02304579250385
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53059"],
        "coty_name": ["Skamania"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Skamania County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01529220"
      },
      "bbox": [
        -17.688346733448014, 9.369672770289267, -16.975406824598586,
        10.161773650358096
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.696805412727297, 10.667559859711668],
            [-16.696556418126367, 10.667743332892162],
            [-16.69588789978932, 10.66145934169254],
            [-16.69108917576168, 10.65565902162848],
            [-16.689909527972688, 10.649445390136371],
            [-16.685184885584622, 10.648947759064255],
            [-16.677371449845253, 10.653712153112508],
            [-16.673378288005694, 10.653262630719244],
            [-16.670563227788406, 10.64894869658576],
            [-16.66554049871186, 10.646923779305991],
            [-16.654163882045594, 10.645636634921747],
            [-16.649684795829444, 10.649821739007647],
            [-16.645472293861495, 10.651693188283547],
            [-16.63824842566153, 10.65067407078919],
            [-16.630906747456358, 10.651382790513424],
            [-16.626278677437067, 10.645917191848412],
            [-16.61669097015241, 10.640769151800368],
            [-16.617244255957072, 10.638402474683351],
            [-16.611176894570587, 10.630678059931888],
            [-16.60682969300188, 10.628248918124175],
            [-16.602443957125605, 10.621222303880065],
            [-16.598119514874675, 10.620436917933992],
            [-16.5957812635143, 10.617893625258581],
            [-16.5965909957215, 10.615036657975612],
            [-16.59351327888081, 10.605673915459109],
            [-16.588346963271462, 10.599928927599713],
            [-16.582582713668057, 10.591623527240507],
            [-16.577109587498047, 10.592045949231554],
            [-16.576419658500864, 10.587476883696823],
            [-16.568741696639663, 10.580815684684552],
            [-16.56623328030231, 10.573666739050145],
            [-16.559834938750214, 10.567700585636977],
            [-16.55737849098473, 10.56208633001421],
            [-16.553793987743816, 10.55832089544062],
            [-16.553471939946125, 10.552853266156655],
            [-16.55136721447392, 10.549502182824678],
            [-16.55109696654298, 10.545256587721774],
            [-16.548886405187872, 10.54282426262007],
            [-16.550291975016847, 10.539982542362992],
            [-16.543236497623756, 10.533088197848341],
            [-16.539679881119955, 10.532761768660764],
            [-16.53749454256472, 10.52741382975306],
            [-16.530380879350247, 10.525506770904038],
            [-16.535956212156158, 10.504975616933589],
            [-16.53248531628694, 10.504014757665924],
            [-16.533435922785937, 10.500685139211066],
            [-16.52992108595513, 10.499656014717429],
            [-16.530855999825068, 10.496289687845563],
            [-16.527392385010227, 10.495324044271278],
            [-16.52829047324327, 10.49192553724511],
            [-16.52479934507116, 10.491030852146892],
            [-16.527602434663407, 10.480733921440132],
            [-16.524120469886633, 10.47976477817899],
            [-16.525047393434505, 10.476383720451889],
            [-16.52156964520976, 10.47540878881669],
            [-16.523439776906017, 10.46859090049076],
            [-16.519942432040995, 10.467644410653431],
            [-16.520898682382843, 10.46419887019314],
            [-16.513930900041913, 10.462346063432843],
            [-16.516738515441013, 10.452056543792143],
            [-16.51324290774415, 10.451139473431123],
            [-16.514166019717926, 10.44775272351369],
            [-16.510662625618632, 10.4467881450704],
            [-16.5116128880818, 10.443345625786659],
            [-16.5081100517696, 10.442453391139619],
            [-16.509066498736804, 10.439036757742285],
            [-16.438758355983037, 10.420317791416958],
            [-16.36845453202792, 10.401582186437523],
            [-16.36224685987864, 10.40027048372849],
            [-16.263049646750613, 10.37476577104475],
            [-16.24899704196251, 10.371479882503774],
            [-16.249890861964747, 10.365022333452917],
            [-16.259470780932904, 10.330846581171286],
            [-16.270651374635595, 10.289605545564347],
            [-16.26029349574212, 10.28693563012965],
            [-16.187614160829686, 10.267072691345337],
            [-16.19876602266773, 10.225455349607262],
            [-16.210621219867196, 10.184927400035875],
            [-16.17109646181745, 10.174321745504948],
            [-16.12568238272934, 10.162512927175658],
            [-16.05760447450218, 10.145009872413214],
            [-15.98953037780348, 10.127491510981384],
            [-15.921460117979244, 10.10995784865265],
            [-15.853393720364963, 10.09240889123871],
            [-15.856626700458879, 10.079162482523875],
            [-15.856148478669393, 10.070113493763008],
            [-15.853379231990946, 10.04822948859109],
            [-15.851033431503907, 10.036169728253174],
            [-15.850875337412019, 10.029779866381636],
            [-15.843542686398628, 10.014360376790354],
            [-15.83854393842061, 10.00920129844171],
            [-15.83653371375203, 10.005362638936104],
            [-15.83607060850538, 9.999475630750645],
            [-15.830896878163909, 9.983850593440485],
            [-15.827226812949254, 9.979607319788553],
            [-15.81882547317313, 9.975760005191853],
            [-15.814397588737716, 9.97226136890587],
            [-15.827728218753933, 9.923940978591576],
            [-15.832429684599068, 9.910379679876213],
            [-15.830750081711505, 9.909982452784668],
            [-15.842075182842626, 9.867216282674717],
            [-15.891285203839303, 9.675800750377139],
            [-15.895008307886245, 9.661761448935943],
            [-15.912869409379134, 9.59223470639125],
            [-15.916618087883244, 9.578377202744646],
            [-15.911906727044936, 9.577156834030534],
            [-15.918838699995103, 9.550953184976677],
            [-15.932954438761316, 9.493645713020761],
            [-15.954517580615358, 9.411371265924588],
            [-16.038128171522292, 9.432705006490579],
            [-16.066030580163776, 9.439902963894136],
            [-16.12111352577834, 9.454576549647328],
            [-16.143348177586866, 9.459772132263186],
            [-16.147147372582374, 9.461009924060258],
            [-16.267464482867467, 9.49200380417791],
            [-16.30490817139265, 9.501728464106177],
            [-16.333199363452078, 9.507667068361206],
            [-16.348973683090925, 9.51309819453227],
            [-16.374232570389694, 9.519916401157017],
            [-16.43018911270546, 9.534284385568974],
            [-16.44371945739721, 9.537022318021943],
            [-16.458007731908086, 9.540953300799133],
            [-16.566016409159555, 9.569957730649627],
            [-16.674034757214887, 9.598925382812794],
            [-16.68036989798475, 9.60088968679495],
            [-16.74986233032223, 9.619847727469283],
            [-16.762882048564776, 9.622602198743392],
            [-16.77777791005692, 9.627356270421918],
            [-16.79121679931257, 9.632227147992367],
            [-16.875318585027497, 9.655224989368904],
            [-16.887651829445232, 9.65871847523538],
            [-16.995787735626262, 9.687619710490582],
            [-17.002787161525248, 9.6891717061453],
            [-17.066648253323258, 9.706107844816284],
            [-16.975513467922596, 10.032397383760141],
            [-16.951796248919727, 10.025868378291316],
            [-16.931540106030308, 10.02090823781696],
            [-16.926361607634824, 10.015538960443525],
            [-16.924475477634896, 10.018381240427413],
            [-16.89163375132058, 10.009737547386836],
            [-16.889293424410393, 10.010944753034913],
            [-16.883742290040168, 10.021055995451848],
            [-16.88343188798798, 10.024592171344281],
            [-16.879077024535075, 10.029127662223438],
            [-16.88176730358181, 10.03655834569753],
            [-16.882749179608783, 10.042271099893547],
            [-16.885665918618304, 10.045327865052574],
            [-16.88782245089757, 10.051137421583633],
            [-16.885985793473107, 10.059677624660283],
            [-16.88582136142642, 10.067106700838155],
            [-16.887048592310464, 10.07283823554423],
            [-16.885465331905635, 10.080937686291959],
            [-16.887110646365723, 10.084206312893148],
            [-16.89085926167864, 10.08675482385442],
            [-16.891954260821333, 10.09407401432851],
            [-16.894184242418838, 10.098102180806897],
            [-16.8945946557398, 10.102144061144713],
            [-16.89254281640865, 10.105669778086781],
            [-16.886235802587155, 10.111440361828757],
            [-16.881888199522106, 10.113503769717212],
            [-16.88488474450469, 10.120061601140732],
            [-16.89387721452137, 10.125065020178504],
            [-16.896954952207984, 10.128545401751781],
            [-16.896584158595076, 10.135484925592795],
            [-16.898036751731574, 10.138750301660611],
            [-16.894523897399093, 10.148804436086598],
            [-16.890118769710494, 10.154287106436419],
            [-16.88949402483162, 10.15743465967055],
            [-16.8817119552757, 10.157488577466134],
            [-16.876720395270862, 10.159521443739086],
            [-16.874208459123572, 10.158668567336738],
            [-16.86591897598504, 10.162116748059464],
            [-16.8628753909359, 10.164847662331923],
            [-16.864865257721906, 10.16846092619748],
            [-16.863156672374696, 10.170918938163057],
            [-16.857509975560042, 10.174009837216381],
            [-16.86161809035844, 10.181737333535866],
            [-16.86243218008254, 10.186875510228665],
            [-16.857154180252817, 10.1921047319954],
            [-16.85410278825924, 10.191243227450187],
            [-16.85089848082198, 10.19484374738196],
            [-16.846619984479908, 10.195158168724092],
            [-16.84332284317017, 10.199906479612874],
            [-16.84122919457584, 10.205823158084902],
            [-16.842831918368443, 10.213595194422567],
            [-16.840461884162217, 10.21680583498882],
            [-16.83689992220389, 10.217250402406645],
            [-16.835634369542554, 10.22132915918217],
            [-16.831653195366638, 10.2238524275938],
            [-16.82687791243949, 10.224785027167664],
            [-16.823929677498658, 10.228187697366048],
            [-16.82370053040892, 10.23616413793508],
            [-16.819639871284238, 10.242497270567954],
            [-16.820860389632326, 10.245536641320678],
            [-16.825831880059198, 10.25001447936496],
            [-16.822917373440877, 10.253327842281754],
            [-16.83448284069065, 10.25938174930145],
            [-16.835483406002673, 10.262914221934073],
            [-16.833448770221246, 10.270090687676046],
            [-16.82855879279112, 10.27499452116915],
            [-16.826985390792164, 10.284967286613451],
            [-16.82288699846781, 10.288631371998823],
            [-16.822055956394628, 10.291375677683064],
            [-16.81835041097759, 10.291481111543579],
            [-16.81429664488029, 10.293961950283261],
            [-16.799928733075582, 10.288473104200342],
            [-16.796800117727006, 10.294117808766662],
            [-16.798932816661917, 10.301100986709885],
            [-16.794448652951697, 10.30609576602372],
            [-16.788748327884495, 10.308221620764348],
            [-16.780860165460744, 10.30945760908468],
            [-16.779759272418158, 10.313810694747538],
            [-16.781492285289325, 10.320600407020889],
            [-16.784292427784916, 10.324595145094293],
            [-16.793298364812337, 10.329375066734071],
            [-16.801385267090577, 10.329897998031527],
            [-16.809749235792975, 10.333575757523734],
            [-16.810752195765357, 10.341261322744208],
            [-16.820757024889904, 10.347681742020834],
            [-16.821516169116784, 10.350593631216263],
            [-16.813895783371038, 10.359152598681073],
            [-16.813522130476468, 10.364227866872978],
            [-16.82126404463096, 10.370152452966602],
            [-16.822716599601105, 10.377064471440361],
            [-16.825077601608484, 10.377835631470308],
            [-16.82430250810124, 10.383071502173259],
            [-16.826503361692588, 10.387288604390772],
            [-16.82642025561075, 10.394501138987302],
            [-16.824347717485313, 10.398393720640177],
            [-16.819818753612743, 10.400903032213316],
            [-16.815584734331427, 10.400914751688735],
            [-16.821475973412802, 10.411711335772187],
            [-16.822655167416325, 10.422107785355538],
            [-16.829466391016297, 10.432502088266927],
            [-16.827010767739704, 10.433368646864846],
            [-16.825096193819185, 10.437426591041026],
            [-16.826775776913873, 10.44295581041194],
            [-16.832310439292794, 10.447369130084855],
            [-16.831351982527238, 10.453956011099239],
            [-16.834375636834967, 10.46888664915347],
            [-16.83347131233761, 10.47672227287373],
            [-16.839703917188803, 10.480374546319654],
            [-16.84313074842518, 10.487561357055604],
            [-16.847881395546832, 10.490690884605232],
            [-16.844348176582216, 10.496228279642324],
            [-16.838216345914464, 10.500284737691796],
            [-16.837232160876543, 10.506296028808096],
            [-16.83323115925767, 10.51092457907972],
            [-16.826970487286115, 10.513962329525198],
            [-16.821230751950267, 10.519591058825217],
            [-16.817533870370543, 10.519370710041578],
            [-16.81208524028407, 10.52168139231212],
            [-16.805633509485478, 10.520382527324061],
            [-16.797550829798396, 10.525199896417574],
            [-16.79020601514339, 10.527208120209277],
            [-16.789606869212196, 10.530987948507489],
            [-16.782936944785394, 10.535656290937759],
            [-16.782948841264794, 10.54271050627966],
            [-16.779834170032377, 10.549024568549328],
            [-16.780881542321566, 10.552642029727977],
            [-16.7794704470435, 10.55769498745504],
            [-16.78202395668727, 10.561739968016624],
            [-16.778633552524497, 10.565376764255182],
            [-16.767650573302376, 10.571233027456246],
            [-16.7689169895349, 10.577904201985996],
            [-16.7623612325673, 10.580496699492997],
            [-16.753963861765104, 10.582365092068983],
            [-16.749785142612623, 10.581745596122937],
            [-16.74781308900304, 10.584593882462844],
            [-16.743148732813896, 10.586656196551573],
            [-16.740254147851804, 10.585886943075474],
            [-16.737558221745452, 10.588767624994949],
            [-16.738342713268867, 10.59388371169687],
            [-16.734658642106684, 10.598407309737416],
            [-16.733852294842226, 10.601395712363255],
            [-16.72531468312131, 10.606431651623097],
            [-16.72336948337609, 10.60982850243559],
            [-16.72403381581243, 10.620345502530176],
            [-16.711823487332886, 10.62987256236843],
            [-16.710683269989605, 10.632733944704299],
            [-16.707220043919676, 10.63296883362471],
            [-16.70088672890524, 10.637993278562968],
            [-16.70135902576403, 10.642704501635485],
            [-16.69745590276952, 10.653572131025204],
            [-16.69913733438486, 10.6564047626611],
            [-16.69965925485928, 10.665840219811582],
            [-16.696805412727297, 10.667559859711668]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.73850371302679,
          "lat": 46.45705601445396
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53077"],
        "coty_name": ["Yakima"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yakima County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01531929"
      },
      "bbox": [
        -17.066648253323258, 9.411371265924588, -15.814397588737716,
        10.667743332892162
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6644245807823257, 7.0883026430464104],
            [2.6684404481161343, 7.088843754166711],
            [2.673319286777735, 7.092615639796716],
            [2.6781307172268574, 7.093679755501564],
            [2.680104600013542, 7.096658383788114],
            [2.686523491401706, 7.102216600153608],
            [2.691143652865213, 7.104488743297832],
            [2.694165208553428, 7.107884570688422],
            [2.6959144104468384, 7.112303576280174],
            [2.6986359691843664, 7.114146677246498],
            [2.7080662128045123, 7.124921757003929],
            [2.7100324808958707, 7.133783677630926],
            [2.7109359195084015, 7.143239459103944],
            [2.712860473962549, 7.150695623541537],
            [2.715773937394678, 7.155967894306617],
            [2.7227045763434607, 7.16218134860047],
            [2.7253253179157477, 7.167543071418011],
            [2.725075101147218, 7.172138974060945],
            [2.722098187642817, 7.17869564618022],
            [2.719137607170207, 7.187843358111036],
            [2.7216793258019436, 7.194483957718895],
            [2.7301797977197184, 7.201571423018442],
            [2.732679489931637, 7.202388228077334],
            [2.736845491600349, 7.208604229258006],
            [2.738652083853358, 7.2201186486254185],
            [2.738251421024604, 7.22429664549595],
            [2.73979170525222, 7.229061309178372],
            [2.7482449905711657, 7.244914762752594],
            [2.757211757360641, 7.256224084284431],
            [2.763229361436727, 7.257968003658744],
            [2.773454310115643, 7.265745236048351],
            [2.7784637842405866, 7.268329046075514],
            [2.7785709803696648, 7.273985800216731],
            [2.789758233885059, 7.285146280795102],
            [2.7920885703779694, 7.286719571460509],
            [2.8039230649425093, 7.287245820293984],
            [2.8029480646100584, 7.295065885733838],
            [2.805515695084901, 7.297293251186455],
            [2.8105049537030014, 7.29525804911286],
            [2.8149575821101727, 7.29817270652931],
            [2.820830625329429, 7.2977287697769935],
            [2.828855407247693, 7.304244172868838],
            [2.8373950763039195, 7.305497283742369],
            [2.8477756787133117, 7.312142341323948],
            [2.851341908581011, 7.312312587593391],
            [2.857157964514225, 7.315356088076377],
            [2.8636207058575076, 7.316227774117998],
            [2.864868995382563, 7.321613428324212],
            [2.864508390698885, 7.332450890500638],
            [2.8672993884598896, 7.3346646089368335],
            [2.872564595933683, 7.342486362221245],
            [2.87741734217132, 7.346725444699586],
            [2.8832334428967163, 7.3492009876490885],
            [2.8969452775837725, 7.345529734597009],
            [2.9051328598246666, 7.341433569209362],
            [2.909546384224389, 7.341904634064324],
            [2.917910702538436, 7.339317991534167],
            [2.9235459598743154, 7.34281139590664],
            [2.925723945003885, 7.346805789579876],
            [2.923531498641093, 7.348912208268495],
            [2.924509154314679, 7.35432696395392],
            [2.930650514401945, 7.359571833716784],
            [2.9315838194398305, 7.367066921225439],
            [2.9363557611352227, 7.375885356723698],
            [2.937508044797488, 7.382880695303158],
            [2.9419279965882383, 7.388054141132522],
            [2.952095958526152, 7.3939199004958915],
            [2.9590589106585155, 7.3946659675688],
            [2.971836751380731, 7.387497067518735],
            [2.9859141231778468, 7.382734970687117],
            [2.9933062318454833, 7.381930171754173],
            [3.000422125503786, 7.3847595004136135],
            [3.001840551369004, 7.392680709164636],
            [3.005499256755175, 7.397676749963796],
            [3.0061825586282143, 7.403664048710991],
            [3.00514247047115, 7.411996084097531],
            [3.0082510659444246, 7.419170417774811],
            [3.0101536693031274, 7.428468271215332],
            [3.0150789605688266, 7.435352255955749],
            [3.0208885860437316, 7.4386553236994715],
            [3.0294982484433732, 7.442078639090969],
            [3.0382561042983802, 7.444365528315173],
            [3.037070040154123, 7.483395241278018],
            [3.0352555417776004, 7.526403063910387],
            [3.1249374641383936, 7.530070128500235],
            [3.125335331809118, 7.529851355666442],
            [3.1583567181272194, 7.530887492030052],
            [3.2044908832055303, 7.533438014622991],
            [3.205398523073384, 7.50118165745918],
            [3.207073665954056, 7.45639605038363],
            [3.2091436807210765, 7.415110207307396],
            [3.2106401725609066, 7.377478834336527],
            [3.2109927207847844, 7.361629183408166],
            [3.2229850998143452, 7.362028610443266],
            [3.225408789783095, 7.310124912189148],
            [3.227653340721682, 7.266189407767288],
            [3.2310087563103522, 7.195266780208402],
            [3.2320720369105236, 7.170477799305353],
            [3.2351453122864076, 7.106264195067848],
            [3.237422169680252, 7.049905821564653],
            [3.2387085038695087, 7.021493438638384],
            [3.152428757960113, 7.017786745809572],
            [3.149253434461372, 7.089037516261975],
            [3.1492679244648922, 7.102908929866523],
            [3.084394955777251, 7.100687668983429],
            [3.052282246481045, 7.099384938593237],
            [3.033820440220472, 7.099270107834346],
            [3.001528810411714, 7.097573042783448],
            [2.973179565192214, 7.096987231164404],
            [2.917097965042369, 7.096551112968702],
            [2.8882682879100297, 7.095974736229951],
            [2.8907941216584327, 7.010104803349502],
            [2.8300565075070203, 7.008946509881949],
            [2.8049867820862073, 7.008220754159851],
            [2.733205503019735, 7.005831820405404],
            [2.6405141140408395, 7.003554383106797],
            [2.641400776183966, 7.005438521538144],
            [2.6432014269749446, 7.018852002649541],
            [2.645496402283644, 7.025016292111781],
            [2.6466046600357913, 7.034663266378692],
            [2.6471340266802144, 7.048302459446795],
            [2.6506115414123994, 7.0561004986511335],
            [2.6493738226300003, 7.05905415016959],
            [2.6510061052373795, 7.071233329994311],
            [2.650591466555562, 7.0767520122083925],
            [2.6550422325229497, 7.081534758208743],
            [2.6633924073608406, 7.0839274642638355],
            [2.6644245807823257, 7.0883026430464104]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.36753724356345, "lat": 45.86267330588735 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55013"],
        "coty_name": ["Burnett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burnett County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01581066"
      },
      "bbox": [
        2.6405141140408395, 7.003554383106797, 3.2387085038695087,
        7.533438014622991
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.3700922382647525, 7.5748383463062945],
            [5.4297537321712435, 7.546115034018598],
            [5.432234995675588, 7.5423944927722575],
            [5.438606272914174, 7.536701686254529],
            [5.44353724012377, 7.536570590377908],
            [5.448736163941524, 7.533915674890218],
            [5.4524256819659, 7.533955194638934],
            [5.456729466972897, 7.528685302306322],
            [5.462016180049265, 7.529950223761953],
            [5.468223244794324, 7.5356776777651415],
            [5.464912470760816, 7.538588297895144],
            [5.467746256381526, 7.542450698659618],
            [5.47417598353795, 7.538115499112949],
            [5.4759830307973845, 7.542075632453782],
            [5.479644939425219, 7.541517997988222],
            [5.480209497737977, 7.538588424318834],
            [5.4771536095714195, 7.533872731172813],
            [5.478806022557934, 7.526254825938003],
            [5.482956835849755, 7.5259455905308],
            [5.490345366980867, 7.5331911631767925],
            [5.493856422150105, 7.530625356643922],
            [5.49902558218482, 7.534758448047256],
            [5.5071885802749305, 7.5390743195078915],
            [5.513708745048035, 7.5388019428692585],
            [5.520675579622312, 7.534842226057759],
            [5.520345316766506, 7.530187649408496],
            [5.526990035015173, 7.526044937269512],
            [5.53236880274472, 7.5319015124562885],
            [5.547498872352256, 7.529069826454626],
            [5.549316339912336, 7.4977431456684105],
            [5.556202200666879, 7.496700048378752],
            [5.562452768787281, 7.406236235161205],
            [5.568608367289856, 7.327346484366307],
            [5.575090925237357, 7.241803352848853],
            [5.639885476231463, 7.246509740041866],
            [5.647418626627203, 7.2472039312951155],
            [5.723870647470029, 7.253096836980022],
            [5.749595055565608, 7.254928030436205],
            [5.754380690243016, 7.190681801297363],
            [5.7656906406995665, 7.04768895527264],
            [5.766976936525903, 7.0343333566014286],
            [5.768460213596539, 7.010234661432177],
            [5.769995183555797, 6.9988859346918835],
            [5.773125227445864, 6.950209156717506],
            [5.7751308174750005, 6.913129673137054],
            [5.686701627472916, 6.906839206961083],
            [5.600168266292248, 6.901403813411559],
            [5.60006398754026, 6.901150797222159],
            [5.5128995660843305, 6.894058094229232],
            [5.426404211332889, 6.888023192411407],
            [5.424997076105571, 6.90179000579508],
            [5.4248715101784795, 6.915719469362185],
            [5.422873321996796, 6.961089550782169],
            [5.422042819759888, 6.973825025501671],
            [5.376860985149041, 6.970423138776142],
            [5.349819261156049, 6.967744869937184],
            [5.335772421049259, 6.966798113840051],
            [5.327838197539597, 7.073148123652458],
            [5.322836255912979, 7.137766658405566],
            [5.317633229755912, 7.209410260995673],
            [5.31670459370139, 7.216528488114404],
            [5.309877494325176, 7.309907890113918],
            [5.303518050329954, 7.392919034613265],
            [5.297033744259768, 7.4788296261214695],
            [5.309148004548824, 7.479820102206355],
            [5.376535400443385, 7.484713110288357],
            [5.375833194269807, 7.493084469499995],
            [5.3700922382647525, 7.5748383463062945]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.77042200006724, "lat": 45.66732936401328 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55041"],
        "coty_name": ["Forest"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Forest County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01581080"
      },
      "bbox": [
        5.297033744259768, 6.888023192411407, 5.7751308174750005,
        7.5748383463062945
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.329424247785173, 5.910428617521448],
            [6.327264088757664, 5.939265696143976],
            [6.3223513831580025, 5.9972397829423185],
            [6.318804912817316, 6.040651310992675],
            [6.312365129619262, 6.112811883502809],
            [6.308002193663292, 6.170753230117761],
            [6.304472230476384, 6.225851593790451],
            [6.309713054366912, 6.23234916555812],
            [6.311580713835974, 6.2381197367813686],
            [6.311247755212825, 6.242053901960838],
            [6.31303645176449, 6.250070390230386],
            [6.32023797792051, 6.259701816086904],
            [6.380383200822232, 6.263784854929542],
            [6.423530095394781, 6.267172921666242],
            [6.473630508367049, 6.271340724280642],
            [6.5596272202703805, 6.2793557271458775],
            [6.575543295533887, 6.280672086400762],
            [6.5736400093353335, 6.275389120451705],
            [6.574001438231245, 6.270302498051978],
            [6.570334596698074, 6.258654838802929],
            [6.565696691298014, 6.248629874696891],
            [6.565657934971149, 6.245035118552012],
            [6.558470307843935, 6.230917648631999],
            [6.550118043850114, 6.223841714976636],
            [6.548636627007941, 6.217783830996811],
            [6.541679225102413, 6.2116917258635205],
            [6.537775420527424, 6.20692596248078],
            [6.536684577959725, 6.198339855889866],
            [6.532768966983517, 6.1876700287493085],
            [6.530285621087654, 6.174062674786383],
            [6.520902606092989, 6.152236880963621],
            [6.5183745940970415, 6.139589060674885],
            [6.518751109502368, 6.131615835076373],
            [6.513494481060588, 6.110973001417491],
            [6.514516252863695, 6.0992221636571],
            [6.512601142296379, 6.090688628834846],
            [6.512070888234918, 6.076685183285023],
            [6.509827876712669, 6.069226875516004],
            [6.5112359586499675, 6.064425583410247],
            [6.508580409481321, 6.0631165498671145],
            [6.506619986283999, 6.055159684054068],
            [6.506146542769919, 6.043737318481585],
            [6.507401472565589, 6.034487803666412],
            [6.505270086717017, 6.0226013534147755],
            [6.502402351424916, 6.012573236975589],
            [6.50196471138073, 6.004453359276673],
            [6.499670576977658, 5.992618446200937],
            [6.501337458919524, 5.9821398990591925],
            [6.501599566990415, 5.974105381018869],
            [6.499880294371996, 5.965771127858456],
            [6.495594726129537, 5.957114381992619],
            [6.492444074234652, 5.948671693769709],
            [6.491799734736452, 5.943896579608176],
            [6.4934646935965645, 5.939052098227975],
            [6.488902390310026, 5.929957905346056],
            [6.487894701734359, 5.924633977449985],
            [6.415959304144248, 5.91831936506396],
            [6.329424247785173, 5.910428617521448]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.6152672287889, "lat": 44.51607573052108 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55061"],
        "coty_name": ["Kewaunee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kewaunee County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01581090"
      },
      "bbox": [
        6.304472230476384, 5.910428617521448, 6.575543295533887,
        6.280672086400762
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.646081071966268, 6.644221515685015],
            [5.7452828466013415, 6.651048893020371],
            [5.756753922419864, 6.652383711099358],
            [5.763718986718474, 6.5363048405475555],
            [5.763857286305881, 6.530687333073304],
            [5.769403813505794, 6.447658241280194],
            [5.773614198760815, 6.392794272873922],
            [5.7361292772557855, 6.390017519964967],
            [5.676143847021191, 6.38617684091454],
            [5.599237942486842, 6.380227261590284],
            [5.593580329055395, 6.460528231820714],
            [5.59290246348318, 6.466407886988645],
            [5.568975495077683, 6.464707256431704],
            [5.5024591981293725, 6.459322356755627],
            [5.472469029611088, 6.457403808625905],
            [5.419873339721937, 6.4530157969532596],
            [5.418341569019246, 6.466803683168525],
            [5.416369180539371, 6.49294461908566],
            [5.414541188153499, 6.524219368811439],
            [5.413252825596827, 6.538498453127076],
            [5.406124977595267, 6.626810790481437],
            [5.442628657429475, 6.629315407865677],
            [5.544567734822058, 6.636786028035529],
            [5.646081071966268, 6.644221515685015]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.71002902592619,
          "lat": 45.004363753336605
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55078"],
        "coty_name": ["Menominee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Menominee County"],
        "coty_fp_code": "078",
        "coty_gnis_code": "01581099"
      },
      "bbox": [
        5.406124977595267, 6.380227261590284, 5.773614198760815,
        6.652383711099358
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.559287768473193, 5.093832398111646],
            [4.62856147954583, 5.098978730355561],
            [4.645827590482567, 5.099822326307808],
            [4.666800615711537, 5.101437460717171],
            [4.761571334295414, 5.106846703839255],
            [4.830627731105228, 5.11069468743534],
            [4.8646326461444005, 5.112940558651984],
            [4.900532691017213, 5.114989037641388],
            [4.93795893049308, 5.117539838071974],
            [4.9456440006801765, 5.107129637197016],
            [4.941455852609355, 5.10232454837291],
            [4.947048649728566, 5.098630201828857],
            [4.948607820323887, 5.096144342228634],
            [4.947262358061404, 5.090788641936886],
            [4.951569350959735, 5.087320257697092],
            [4.956619859459604, 5.081502344365296],
            [4.964091216271363, 5.083847754657713],
            [4.967339546930918, 5.080447140272882],
            [4.973500797410236, 5.07693611103184],
            [4.980986760055753, 5.0778113699595995],
            [4.98601347855159, 5.0793887284002],
            [4.989231958497809, 5.078285276844794],
            [4.9898185098317125, 5.074938739079357],
            [4.9862929007829795, 5.067475589561552],
            [4.979931822514973, 5.060057560477028],
            [4.978924306583495, 5.056470536961866],
            [4.981056401923108, 5.050954998204999],
            [4.984414501563406, 5.048821387680544],
            [4.9994007683416495, 5.047082903469017],
            [5.008869304488, 5.04689664044922],
            [5.013179449053511, 5.047651387720942],
            [5.0236765363267235, 5.051359211207414],
            [5.031572798710285, 5.051031598784605],
            [5.036051858773147, 5.048617935350275],
            [5.046426810965914, 5.046614768487212],
            [5.052764720539866, 5.047048043231942],
            [5.063906138722147, 5.049963778621602],
            [5.072666647833738, 5.0477540885522565],
            [5.077628337248222, 5.043367485381992],
            [5.080390517667099, 4.991434627189179],
            [5.0848124465099565, 4.920467432209749],
            [5.088617035561043, 4.866338785284676],
            [5.08085061484364, 4.858191413189294],
            [5.070617860922997, 4.851077030927637],
            [5.055264479211874, 4.844407301879892],
            [5.045535838958743, 4.84275465907144],
            [5.039645171058212, 4.844109144111103],
            [5.03443517784013, 4.843182034393072],
            [5.029494369741112, 4.836409309759847],
            [5.022146857552163, 4.823253156580074],
            [5.017563943957788, 4.811051942526326],
            [5.015501832995599, 4.808008067031213],
            [5.006796782271838, 4.799751389286333],
            [5.004314895903293, 4.794274280328618],
            [5.002852653394601, 4.780003504937452],
            [5.008021942251187, 4.773072008578025],
            [5.010851176524799, 4.769573771042737],
            [5.01396146678378, 4.762430277649205],
            [5.011426053334192, 4.752778884072796],
            [5.008123167277323, 4.746888381621342],
            [5.006874217911578, 4.739908557520477],
            [5.003923900221545, 4.736492794783244],
            [5.001605798679329, 4.730731495950915],
            [4.994651703698102, 4.726767621274311],
            [4.988101719602354, 4.725833626068294],
            [4.986771762162316, 4.721371387305991],
            [4.981306287413755, 4.718620848458736],
            [4.975141961566, 4.718921083619538],
            [4.972701448242077, 4.716738619194267],
            [4.966546657953271, 4.715821517545673],
            [4.952529150869852, 4.7155623376751725],
            [4.950184052684857, 4.714850587286538],
            [4.945098814677816, 4.708793782112961],
            [4.942083523878426, 4.700338752073439],
            [4.93792637948947, 4.695616573852195],
            [4.928654461200951, 4.680523827252244],
            [4.92611052079785, 4.67676200792309],
            [4.914316949134958, 4.669079898082309],
            [4.909130992085884, 4.667812946343094],
            [4.901568280287232, 4.669197656640343],
            [4.897356688921431, 4.66770712476089],
            [4.88943744031448, 4.662327500696663],
            [4.882202899205156, 4.659545770731765],
            [4.8692206529182815, 4.659709870367564],
            [4.861967827897969, 4.661290400144021],
            [4.855511011211798, 4.661342075303962],
            [4.848626560775992, 4.662729542121823],
            [4.841575948233661, 4.661023019501776],
            [4.828796569131335, 4.661948428793383],
            [4.824699026743867, 4.663406115942106],
            [4.812160347419036, 4.661607066003858],
            [4.7949232980038285, 4.649176974256953],
            [4.792145252700584, 4.643192915120304],
            [4.787916938329755, 4.637905149862727],
            [4.778808412351613, 4.631662866573864],
            [4.779025927927207, 4.624448767238041],
            [4.776731829182938, 4.619041452518167],
            [4.77659040702666, 4.6112504309491795],
            [4.7703258062093195, 4.610128582845821],
            [4.7645345330711635, 4.615699461888162],
            [4.760152497910363, 4.6184136153713045],
            [4.754711211150056, 4.624399393573269],
            [4.750613307671748, 4.625385776332356],
            [4.743309354829757, 4.622880626555641],
            [4.732390034306096, 4.6222369122253],
            [4.725440292214753, 4.623216206766765],
            [4.716275440340255, 4.626640838040843],
            [4.698891521029634, 4.626626552216984],
            [4.694078050486743, 4.624350784072915],
            [4.685219150748214, 4.616872593721397],
            [4.681896997076078, 4.615888546144169],
            [4.6786736176713895, 4.620431229099315],
            [4.67381109878951, 4.622753790846029],
            [4.674581394032506, 4.6248537199146424],
            [4.669606650834623, 4.70721178191259],
            [4.666341843441983, 4.77060171035075],
            [4.66483981357166, 4.790127253354704],
            [4.6639178972359945, 4.813418090364378],
            [4.66193441818088, 4.838413025188519],
            [4.656690413578552, 4.925658768027933],
            [4.651812911786896, 5.00049549125782],
            [4.651182983032881, 5.013176227168925],
            [4.623184301050059, 5.011243801734146],
            [4.593951042741577, 5.0087854302195085],
            [4.565475421097508, 5.006998339532692],
            [4.5644420344905, 5.022674858036461],
            [4.559287768473193, 5.093832398111646]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.94824161578963, "lat": 43.4266455050172 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55111"],
        "coty_name": ["Sauk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sauk County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01581115"
      },
      "bbox": [
        4.559287768473193, 4.610128582845821, 5.088617035561043,
        5.117539838071974
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": 145.21458643564876, "lat": 14.15733582831155 },
        "year": "2023",
        "ste_code": ["69"],
        "ste_name": ["Commonwealth of the Northern Mariana Islands"],
        "coty_code": ["69100"],
        "coty_name": ["Rota"],
        "coty_area_code": "MNP",
        "coty_type": "municipality",
        "coty_name_long": ["Rota Municipality"],
        "coty_fp_code": "100",
        "coty_gnis_code": "01805246"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.56059967931206, "lat": 18.44564174576053 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72017"],
        "coty_name": ["Barceloneta"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Barceloneta Municipio"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01804488"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.90875430638779,
          "lat": 18.223403821219055
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72077"],
        "coty_name": ["Juncos"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Juncos Municipio"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01804519"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.515324140774007, -6.374599464861414],
            [8.543839195851954, -6.371520911040478],
            [8.551696178179183, -6.37180321968767],
            [8.543424647912133, -6.299315293294396],
            [8.551540615328793, -6.2983311476498525],
            [8.550708275324853, -6.291401494426839],
            [8.542620713172587, -6.292382782614111],
            [8.541823702262281, -6.285509641332573],
            [8.592972297926343, -6.279694111529308],
            [8.627871223880565, -6.275863241372429],
            [8.630114527545688, -6.290077510260702],
            [8.63790845477547, -6.361782337465907],
            [8.67888034523334, -6.356671881970857],
            [8.730859050265105, -6.350875772458338],
            [8.735946224204772, -6.354213100899018],
            [8.736580336548359, -6.358535925827695],
            [8.740728026279909, -6.367233093310069],
            [8.741037579495883, -6.372170383690072],
            [8.743994268954681, -6.3771108799412985],
            [8.74374306731932, -6.380172396172642],
            [8.748358306973877, -6.38506819054694],
            [8.748760585028432, -6.389605131426728],
            [8.746535867668868, -6.390764992397221],
            [8.749452537289045, -6.396819351700903],
            [8.750881056044436, -6.414621165824171],
            [8.753898269641265, -6.422850618374298],
            [8.753290555503522, -6.426868793786657],
            [8.750827068757834, -6.429284638801558],
            [8.750830526586626, -6.4399921565895974],
            [8.748440496959386, -6.445593671927109],
            [8.750859226379337, -6.448859076633733],
            [8.748564387442661, -6.451547244724412],
            [8.749244627350757, -6.458320488839935],
            [8.748688641215267, -6.465197805200719],
            [8.749885136164194, -6.469341542648486],
            [8.74858255224784, -6.478551276579279],
            [8.751825948125777, -6.483275757837025],
            [8.748243877021144, -6.492092576391142],
            [8.744255485269276, -6.497566232546202],
            [8.745536052530634, -6.504377917770472],
            [8.740515973986364, -6.509052174878697],
            [8.74234144440507, -6.526333276818449],
            [8.78524798938531, -6.521407646685014],
            [8.78763416213426, -6.536094538637941],
            [8.793980820001442, -6.59642140606796],
            [8.798581710242864, -6.636941564875046],
            [8.799577297646678, -6.6482767933302025],
            [8.789131577825119, -6.651928915692592],
            [8.788629389150417, -6.659242318221301],
            [8.791261534975355, -6.664639612198625],
            [8.789079450951242, -6.667815039655096],
            [8.789506945801593, -6.671071107355657],
            [8.78346558336129, -6.673696763992034],
            [8.784512935858748, -6.678506295504725],
            [8.776575065835784, -6.685556287820341],
            [8.775798969250348, -6.691815852137459],
            [8.77695565775278, -6.6973257576692795],
            [8.790962904981832, -6.694731889474897],
            [8.805308686008516, -6.693070147735791],
            [8.815271250765274, -6.772311895533937],
            [8.804464156553856, -6.773576404852008],
            [8.805399155947592, -6.780821359115004],
            [8.773149193638165, -6.784398032563329],
            [8.78314565694813, -6.873440515636404],
            [8.768818839103291, -6.873270787546377],
            [8.725608380451556, -6.878236435968351],
            [8.72554062119483, -6.86366735972622],
            [8.711315986585362, -6.865232657490861],
            [8.70450889723564, -6.808064567368272],
            [8.701202728225754, -6.793204471761964],
            [8.685384115087087, -6.794827926054856],
            [8.68585810862678, -6.799737469829019],
            [8.673320933761094, -6.810568861604836],
            [8.669676370069556, -6.816009411448287],
            [8.670601898059266, -6.819088058598644],
            [8.663835111131597, -6.822904936691829],
            [8.656066066235493, -6.838825636015563],
            [8.653785588565107, -6.839557553691071],
            [8.648948105502454, -6.83732184295794],
            [8.648428672525078, -6.841386277068199],
            [8.643465037168856, -6.842955421965398],
            [8.641191374045178, -6.840424926538775],
            [8.634701981819793, -6.841802091394875],
            [8.634438404357061, -6.847796207285037],
            [8.63259721007887, -6.848610343219069],
            [8.630635568782964, -6.855294673195362],
            [8.624844364191699, -6.857256602705769],
            [8.623825040323233, -6.863703160285215],
            [8.613869014725248, -6.8765318427859645],
            [8.609034623204835, -6.879876572075872],
            [8.600173799008509, -6.804820743730472],
            [8.587286952232631, -6.807675766475296],
            [8.516497933315005, -6.814998350214566],
            [8.513512126465324, -6.786637203898155],
            [8.50979033049276, -6.786895553293514],
            [8.508154739259744, -6.772375295309007],
            [8.512146928828697, -6.772200248266677],
            [8.50320944998814, -6.6861243326140585],
            [8.546098290740632, -6.681469677106937],
            [8.543339061793711, -6.6522355220594145],
            [8.543749563310861, -6.6360412294731415],
            [8.537649331667689, -6.5782498530915525],
            [8.540942590997041, -6.578004055925722],
            [8.539785528132372, -6.563194933420621],
            [8.536129838277994, -6.563593404298748],
            [8.530230574101916, -6.506521672322428],
            [8.533705811692718, -6.506155292415581],
            [8.533297085030275, -6.502323138837283],
            [8.536630167495566, -6.501989922283104],
            [8.53587505851421, -6.494741535779865],
            [8.532285730026006, -6.495084394750631],
            [8.528566883495055, -6.491873778989142],
            [8.524918064464737, -6.465635746611812],
            [8.52492665577228, -6.463426661998084],
            [8.51694993071085, -6.386381222371572],
            [8.515324140774007, -6.374599464861414]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.31356694403553,
          "lat": 31.731540290203068
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01041"],
        "coty_name": ["Crenshaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crenshaw County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00161546"
      },
      "bbox": [
        8.50320944998814, -6.879876572075872, 8.815271250765274,
        -6.275863241372429
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.834079571685108, -5.910294690225472],
            [6.835052247225148, -5.861206874144007],
            [6.836261385187079, -5.775908873887957],
            [6.837529958201746, -5.739829652415678],
            [6.838939249592509, -5.611686551167742],
            [6.839933577500794, -5.5574078811210725],
            [6.841069033320986, -5.494894309521547],
            [6.879636947618028, -5.490021486370889],
            [6.883835787467063, -5.4897159181237685],
            [6.980728153467694, -5.478857865554115],
            [6.981199869296995, -5.488156555927906],
            [6.984612429372071, -5.493389994731738],
            [6.985185074348944, -5.501179437135607],
            [6.986574082506941, -5.503815070212396],
            [6.995368848824717, -5.509090638842998],
            [6.995078418531432, -5.512805033727045],
            [6.9896321169979965, -5.519875174750706],
            [6.986018191475229, -5.5201160106764355],
            [6.979749968927071, -5.518223994981569],
            [6.974947881957736, -5.5133308650755435],
            [6.969783088142298, -5.516694135106089],
            [6.971601392844183, -5.523641220425373],
            [6.9761462092591335, -5.529657975190906],
            [6.984741675948188, -5.53176308307208],
            [6.985901712319813, -5.535367001994169],
            [6.983116769696919, -5.542748916595071],
            [6.979571111523142, -5.5438057812043615],
            [6.971775809162555, -5.54348355221441],
            [6.965388153604966, -5.540627475660499],
            [6.963177960009986, -5.541458651460014],
            [6.9623411763943865, -5.547334467258244],
            [6.957825616990184, -5.551316520526308],
            [6.95739316193088, -5.554280075766335],
            [6.959774187786266, -5.5587960670346375],
            [6.963787088524032, -5.56174245435346],
            [6.9728895500411125, -5.565054361921889],
            [6.97980121569186, -5.5821562847745865],
            [6.981103785935486, -5.596841663414685],
            [6.984258212361719, -5.603364817929674],
            [6.990085009181346, -5.605804137236755],
            [6.996098557217396, -5.612496735373825],
            [7.003513168127216, -5.612667507879501],
            [7.005486861987617, -5.614370804919445],
            [7.006610252024877, -5.6204170676670655],
            [7.004228354028038, -5.627727288981243],
            [6.9977974389492195, -5.636467245643518],
            [6.988623750706005, -5.6367034225119035],
            [6.985844604189563, -5.641006229306314],
            [6.989176332802616, -5.646302336553066],
            [6.995590102213413, -5.646990187336806],
            [7.003284463885135, -5.6437506600846845],
            [7.007119372998648, -5.648166834240465],
            [7.011457214200722, -5.649171939723121],
            [7.015338931506854, -5.647836487205939],
            [7.017089594694229, -5.641602144949051],
            [7.022784550892108, -5.637844238757183],
            [7.026821822668546, -5.638865280700028],
            [7.0339437193208365, -5.647262530881323],
            [7.0365856697332765, -5.6534285552186265],
            [7.040987027110312, -5.6586652950710805],
            [7.047142885660426, -5.6630211480963615],
            [7.052400238637154, -5.671349739514008],
            [7.058203543193407, -5.673408310185624],
            [7.071603794541227, -5.664722370637923],
            [7.0765724909305385, -5.662370412305226],
            [7.078668487347904, -5.662989733183899],
            [7.087005779016817, -5.674726847756916],
            [7.085553615691497, -5.682578017703749],
            [7.082377671921074, -5.685470281575858],
            [7.078986629019432, -5.693153815871156],
            [7.0762389619693735, -5.6949513135147924],
            [7.068941523530718, -5.690783051982446],
            [7.0602551716914705, -5.689085937356624],
            [7.056006288784679, -5.690123240084315],
            [7.051169095533236, -5.698998886135062],
            [7.0520245940732735, -5.704535024493726],
            [7.054837309403642, -5.711927906623002],
            [7.055279334256176, -5.719608341773554],
            [7.0606537103665845, -5.730081939392183],
            [7.071190035276295, -5.737218990285398],
            [7.078832161826572, -5.74735613400448],
            [7.076807432356404, -5.754093704463015],
            [7.076552687465123, -5.759101296799],
            [7.067585287178293, -5.765310830340377],
            [7.0621842393316845, -5.767536088323087],
            [7.056767230706551, -5.767535822635261],
            [7.051809321480162, -5.769201434822275],
            [7.051663151212589, -5.7729071444785705],
            [7.055166100184584, -5.777161488305515],
            [7.060066663132614, -5.780384070116818],
            [7.0720590615254215, -5.784836972487121],
            [7.084610729862954, -5.783590854133043],
            [7.100243230014705, -5.774914645709559],
            [7.104842477350912, -5.7685246007189965],
            [7.1114100689460304, -5.7714495529762],
            [7.114698684012111, -5.774076412223507],
            [7.11543089746044, -5.777341474477938],
            [7.113477952129636, -5.780169898201138],
            [7.106772554931209, -5.7860630126206205],
            [7.102297581555934, -5.7917775835784395],
            [7.1029886209472135, -5.796853554885213],
            [7.107527097828326, -5.803403218788134],
            [7.108078868508641, -5.808586995164595],
            [7.107128493608365, -5.819393624927087],
            [7.10248641434678, -5.825494897060348],
            [7.092379425887857, -5.825091989682307],
            [7.087750997487758, -5.82893085754058],
            [7.086869828593248, -5.8409625126876215],
            [7.089221259447481, -5.847791376628561],
            [7.103821525543081, -5.861522598259312],
            [7.10858873341036, -5.871423358329529],
            [7.112679796761734, -5.872577323744071],
            [7.121341740892989, -5.867941250903798],
            [7.128240656751636, -5.865501630290153],
            [7.141605284100773, -5.863521221850771],
            [7.148630146106075, -5.861872419476833],
            [7.156583974892865, -5.857828664733197],
            [7.1752223981052845, -5.849537751289018],
            [7.181435169983077, -5.843126404009373],
            [7.198648935100054, -5.831449679436209],
            [7.204978917870626, -5.83121686545256],
            [7.211188710933251, -5.825559966829213],
            [7.213708876513077, -5.82469584881624],
            [7.222513538493606, -5.8266631332253365],
            [7.228424285079141, -5.831000043478008],
            [7.232831960101894, -5.8360013978839],
            [7.235119708193585, -5.840662386255927],
            [7.247773543044022, -5.836941520908787],
            [7.254763373494362, -5.831942842507817],
            [7.272139825684896, -5.8308341530166725],
            [7.27478085023459, -5.831877910768892],
            [7.278425994350722, -5.837529595282149],
            [7.284990139796536, -5.839892548071578],
            [7.289242840213737, -5.84489718996128],
            [7.286278221111585, -5.850658029566117],
            [7.282342639293588, -5.851814106468523],
            [7.278475273542404, -5.861549819806261],
            [7.275711494949859, -5.8621052696992635],
            [7.270056518585231, -5.853941281896648],
            [7.271106684522559, -5.84513324557757],
            [7.267392039836736, -5.84373112577492],
            [7.25407150109127, -5.843923808546346],
            [7.249902711646819, -5.84983387513534],
            [7.244383985719351, -5.851772471809132],
            [7.2416249329339735, -5.85724367235905],
            [7.242437576399381, -5.862388035568875],
            [7.24900859185108, -5.8657754162281],
            [7.258909952650898, -5.874474464369861],
            [7.263679712388296, -5.881160858083015],
            [7.265169890378226, -5.885444702436242],
            [7.266689363599677, -5.895308445362066],
            [7.2660554172313665, -5.902399672025833],
            [7.2670490566270125, -5.9085226838330955],
            [7.275745867571532, -5.917799510882804],
            [7.279959389458802, -5.9196675728995185],
            [7.285129123995586, -5.91922791019989],
            [7.291393253699739, -5.920584778915991],
            [7.29564129703475, -5.924867635880902],
            [7.293715374473777, -5.932451607213978],
            [7.286862018529138, -5.936043400679538],
            [7.275516298080822, -5.9352835578925465],
            [7.2626645849928, -5.9317270437468474],
            [7.255799759476425, -5.9321718795190375],
            [7.245928051871628, -5.9315173953807125],
            [7.242880704563, -5.932269148027521],
            [7.235993066082284, -5.937363132094038],
            [7.230629801648022, -5.943982513051924],
            [7.2233794655840295, -5.956552979262104],
            [7.212052756446555, -5.9664303035595845],
            [7.208006378850806, -5.979530278028311],
            [7.204509072126966, -5.987990338926892],
            [7.189843740078718, -6.002118808153487],
            [7.185835357091187, -6.003784850287016],
            [7.1737261838025566, -6.005799086984188],
            [7.169459383933446, -6.009615493301766],
            [7.16395909217976, -6.016481367310096],
            [7.15224351649948, -6.023967287617146],
            [7.144560238101745, -6.029950262109664],
            [7.13958463603086, -6.038961363912649],
            [7.1375726732664715, -6.053952472925564],
            [7.13725691615936, -6.072750225780554],
            [7.137838468043985, -6.0788037334218545],
            [7.137004625934837, -6.087293711830705],
            [7.141371633477022, -6.091534265314963],
            [7.160045617401726, -6.092016235766514],
            [7.16212709336474, -6.093310778547904],
            [7.170626049938592, -6.102769758170164],
            [7.177795020700126, -6.107860927043741],
            [7.183452163857984, -6.1133602774741655],
            [7.194164575935558, -6.117106042601146],
            [7.202887387599623, -6.114618483167481],
            [7.206236533445229, -6.117609916894705],
            [7.209762362215369, -6.12564943016587],
            [7.220151724887677, -6.128644555958282],
            [7.223644872815037, -6.132270106682833],
            [7.229672460315603, -6.142151712817143],
            [7.239496010555736, -6.145408871622038],
            [7.079290776812758, -6.160751115033249],
            [7.0456632333502585, -6.164135340305522],
            [7.033928336175529, -6.165042616180358],
            [6.954140408819987, -6.171959436469843],
            [6.828435940357588, -6.181027235985083],
            [6.829603782972699, -6.115512238522623],
            [6.830218926604402, -6.10934268704427],
            [6.8318890808503525, -6.040277177041143],
            [6.832248827207829, -6.003466178280432],
            [6.834079571685108, -5.910294690225472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.19883980714248,
          "lat": 32.591028460823395
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01119"],
        "coty_name": ["Sumter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sumter County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00161585"
      },
      "bbox": [
        6.828435940357588, -6.181027235985083, 7.29564129703475,
        -5.478857865554115
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.76694137364517, -11.300200127367766],
            [-17.65965066642855, -11.304491057924333],
            [-17.642267036104997, -11.305098307024862],
            [-17.644210839435246, -11.35973784510962],
            [-17.645559982533914, -11.397724628290053],
            [-17.68129900344931, -11.396449087842043],
            [-17.747437185707504, -11.393820733970797],
            [-17.817253387809654, -11.390655235191101],
            [-17.81608812985565, -11.389492486117078],
            [-17.814816382659256, -11.389127186131772],
            [-17.81175875322903, -11.385434818530229],
            [-17.80966544739751, -11.383296222396403],
            [-17.80699635929794, -11.382165177618957],
            [-17.803410415979613, -11.378178713972481],
            [-17.80029822160011, -11.373680635196427],
            [-17.79751808856255, -11.371531527244917],
            [-17.79500751544604, -11.370030058449814],
            [-17.792538831232076, -11.36758965312997],
            [-17.78844467843499, -11.365862553653178],
            [-17.78497861342214, -11.361892619983394],
            [-17.78322496262352, -11.36082337184762],
            [-17.777954467148383, -11.359658218383121],
            [-17.776646201260856, -11.356568823322633],
            [-17.77885276139661, -11.35538496869389],
            [-17.779863766571182, -11.353063950749782],
            [-17.77989427378302, -11.348683197170322],
            [-17.779179583774635, -11.344018954158763],
            [-17.779363982811812, -11.34239668011184],
            [-17.778976043272973, -11.339694452741265],
            [-17.777430273606885, -11.336557751759498],
            [-17.77381240832309, -11.334618427550769],
            [-17.773293731689893, -11.333176627020093],
            [-17.770048180052807, -11.328100855923308],
            [-17.767453607559055, -11.324969949050457],
            [-17.76634057088481, -11.3241285074292],
            [-17.765618528301236, -11.322442340852],
            [-17.765440540430145, -11.317170301359173],
            [-17.764240866981638, -11.314891504912621],
            [-17.764405790802087, -11.31193806598562],
            [-17.765837708534786, -11.310412670365647],
            [-17.766986103884914, -11.307861616316549],
            [-17.76812852655185, -11.307514358399304],
            [-17.76902343175699, -11.305991707838471],
            [-17.767872160348503, -11.301044941471936],
            [-17.76694137364517, -11.300200127367766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -156.69995928863327,
          "lat": 58.74387040364267
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02060"],
        "coty_name": ["Bristol Bay"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Bristol Bay Borough"],
        "coty_fp_code": "060",
        "coty_gnis_code": "01419967"
      },
      "bbox": [
        -17.817253387809654, -11.397724628290053, -17.642267036104997,
        -11.300200127367766
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2716602403127393, -3.7303588593309915],
            [3.2849975000165736, -3.731980321707001],
            [3.303854329193644, -3.728832069846975],
            [3.3141683660083534, -3.7281163301188442],
            [3.32358047225773, -3.729833415093859],
            [3.3292645087784583, -3.734185072058169],
            [3.3333833780462525, -3.7401724195262203],
            [3.335611192575497, -3.753678728682822],
            [3.3384096203390965, -3.759955293807703],
            [3.3458708457455884, -3.768538437965486],
            [3.349077909761047, -3.7755222762718694],
            [3.349249409725638, -3.7841899850214165],
            [3.3457190377029886, -3.7967342129312196],
            [3.3403199007945363, -3.806554173422204],
            [3.339126487274974, -3.810528479109387],
            [3.3397177204690727, -3.818631212103811],
            [3.3447994327944746, -3.827483180038771],
            [3.3502388002161245, -3.8314128965111043],
            [3.36335769948267, -3.8376780502136376],
            [3.361680902426996, -3.833715334857281],
            [3.356162950892719, -3.827885339248343],
            [3.354029467412157, -3.823911257985233],
            [3.357614817930812, -3.8122181496899272],
            [3.3565029443068037, -3.803719978586376],
            [3.3525444451285495, -3.79536617731973],
            [3.353095184376244, -3.7898416230346843],
            [3.350245453388823, -3.779905439290274],
            [3.350350307546, -3.7774032114844367],
            [3.3586363437588034, -3.7773142981695553],
            [3.360896810666531, -3.773410206740995],
            [3.3675719140633684, -3.7688259258507326],
            [3.3707716287712057, -3.769779282139002],
            [3.375757903328518, -3.766498294196285],
            [3.3792258307229446, -3.7545613072899546],
            [3.3750061652908934, -3.7508460760536475],
            [3.3784543771070625, -3.748040523628642],
            [3.3993011934172914, -3.7477519107419184],
            [3.4135265241078043, -3.7480054744725475],
            [3.4562070961099947, -3.7474562244366934],
            [3.5279372158150744, -3.746192655948134],
            [3.52770118329591, -3.724245086248668],
            [3.526658312673504, -3.6585368122350945],
            [3.6124639442122417, -3.6574967008552726],
            [3.6536557780640817, -3.6564550121076],
            [3.653979120849859, -3.662863622012529],
            [3.6548893533254287, -3.7432210485385693],
            [3.6560956276649232, -3.7439176192873806],
            [3.656797322041246, -3.802333888560639],
            [3.656609358641193, -3.8171061808939823],
            [3.657636812308511, -3.8317674968037028],
            [3.6587104956871315, -3.9257694227163373],
            [3.65922685627628, -3.948064773838941],
            [3.6443200847248716, -3.9484688357819935],
            [3.644307252266779, -3.954793803268185],
            [3.6480991048029274, -3.956424270472096],
            [3.6479577922008564, -3.964535322654717],
            [3.645796100684684, -3.9737649884327135],
            [3.6464081154887813, -3.9834706466818277],
            [3.6450712180618665, -3.993522747664046],
            [3.6454090884217427, -4.0083519515269375],
            [3.638159748943761, -4.0260881319380655],
            [3.6387662114752914, -4.027770521623528],
            [3.6375303698725876, -4.037611988490795],
            [3.6386501296857383, -4.048391724565573],
            [3.703463722980356, -4.047012891038164],
            [3.7035764427394664, -4.047421894303755],
            [3.706935546557089, -4.132107217659767],
            [3.7085377447954766, -4.179770898927053],
            [3.6157504083316434, -4.181552379488262],
            [3.563164529243672, -4.182403912846068],
            [3.5322541416433166, -4.182848572699018],
            [3.5301077591864023, -4.095078269437448],
            [3.4447947248256385, -4.096987934963456],
            [3.444935801014509, -4.053359539391199],
            [3.4159704637649986, -4.05375782615629],
            [3.387463386297416, -4.054619208368935],
            [3.364338413149163, -4.054992662226416],
            [3.364215926324585, -4.009709092011755],
            [3.3176826818092, -4.009852877622379],
            [3.3181382489354094, -3.99536176791023],
            [3.2749553214913396, -3.995587530226822],
            [3.2745619249038276, -3.939386001562682],
            [3.2742297754923135, -3.9227806324598866],
            [3.188906720880659, -3.9229563795285363],
            [3.188315769019513, -3.835252292395791],
            [3.1162866884483758, -3.8358220347686878],
            [3.1035399917306505, -3.836110438736644],
            [3.102774853720074, -3.777908410839962],
            [3.1590112529503562, -3.7771245998969074],
            [3.1875397866920356, -3.7763877743543257],
            [3.1872730673346643, -3.7477597280129644],
            [3.188044262849202, -3.7471193323905494],
            [3.2719769125512164, -3.746989483674111],
            [3.2716602403127393, -3.7303588593309915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.31194795031057, "lat": 34.77001229996096 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05119"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00069177"
      },
      "bbox": [
        3.102774853720074, -4.182848572699018, 3.7085377447954766,
        -3.6564550121076
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.119863541954231, -2.1369640657237703],
            [4.18300900244827, -2.1336657689802068],
            [4.262582775859673, -2.1294283641331666],
            [4.270571356069662, -2.1291338056689795],
            [4.342796797041927, -2.1252612096054966],
            [4.4291047377230965, -2.120431875853026],
            [4.474670463093403, -2.1176613470654178],
            [4.539421172920268, -2.1142479857695236],
            [4.543767247545839, -2.114320765223204],
            [4.562300589650925, -2.1128397040723677],
            [4.614930530224716, -2.1099935250473982],
            [4.616490411973525, -2.1108390796911314],
            [4.619611485854534, -2.117557211799655],
            [4.626598594055735, -2.1202393539054962],
            [4.626131377997545, -2.126423130914657],
            [4.628921258341985, -2.130885804761879],
            [4.625206381889492, -2.133364536995299],
            [4.626435269685015, -2.1422605734001294],
            [4.625065395626441, -2.143984783196155],
            [4.625820097823326, -2.149472748937849],
            [4.624419071238965, -2.155648049779279],
            [4.625433418180215, -2.1626775401316487],
            [4.622417100907817, -2.169587079835307],
            [4.624818245181881, -2.1739862544693893],
            [4.630216327243421, -2.1741307868761743],
            [4.624850542208521, -2.183504370708029],
            [4.630663501976338, -2.1841827632133706],
            [4.634255648218748, -2.180403480871187],
            [4.641509898061446, -2.1851347064195017],
            [4.634747892105107, -2.1879645953355067],
            [4.63181615637257, -2.1877138776440717],
            [4.63021092804297, -2.194221511934616],
            [4.638011421564646, -2.195221360624991],
            [4.647966076629992, -2.194715292744356],
            [4.649720555316734, -2.2398514711898474],
            [4.652660763967214, -2.32480260903326],
            [4.646821931702819, -2.326562260846107],
            [4.645850426021724, -2.3233521298909836],
            [4.641723596981689, -2.3221340887392428],
            [4.638843040210401, -2.3246169989898506],
            [4.633945650508978, -2.324711678254085],
            [4.632044352225322, -2.3270899525360123],
            [4.6284087692329905, -2.3238956950111604],
            [4.624953136963272, -2.3167236623406424],
            [4.621337071644466, -2.3162442024339382],
            [4.621031653316515, -2.3225226264750067],
            [4.6158083264774765, -2.3247633052449186],
            [4.609058833702302, -2.322870886127567],
            [4.609857001193909, -2.3441279528110455],
            [4.611201317109673, -2.38704913236007],
            [4.611039514341273, -2.387807406290782],
            [4.61319528797511, -2.441115817275275],
            [4.613822267488789, -2.4624568920572614],
            [4.555812992563154, -2.46477965507445],
            [4.482313782280715, -2.468624990472783],
            [4.417970860086381, -2.4710245061900635],
            [4.41496899834102, -2.473879758251901],
            [4.409825693494114, -2.4815283477531693],
            [4.410522699031613, -2.4868418495817264],
            [4.412446821858841, -2.490498202331541],
            [4.4132256118219955, -2.4964707827354444],
            [4.4125716176918806, -2.5047694412546857],
            [4.40500949439717, -2.5087038972073596],
            [4.398542963570762, -2.502789635145442],
            [4.400685508166974, -2.498458064167583],
            [4.3984122884592045, -2.494891230269372],
            [4.394245665707283, -2.492077557166202],
            [4.395408199094094, -2.484437317542545],
            [4.394744566616998, -2.480133759867123],
            [4.39561801931671, -2.4728577145513517],
            [4.389335202364695, -2.4746042224867315],
            [4.37787155182026, -2.4730588206166098],
            [4.368578065604754, -2.4701047399660876],
            [4.363219129411218, -2.4696165243086705],
            [4.36065068437426, -2.4648207062892773],
            [4.355168989643036, -2.4650995850391886],
            [4.354992939391555, -2.4614805771321673],
            [4.351069681447988, -2.457798886938837],
            [4.347195945203546, -2.459159181336076],
            [4.341808851629093, -2.449924476137323],
            [4.343850294597144, -2.4441241847617774],
            [4.339467741582854, -2.4414387569867846],
            [4.33413003952507, -2.436488375398675],
            [4.335624118239606, -2.431991451619248],
            [4.334834964453155, -2.4288751097543324],
            [4.328653380996692, -2.4208056966781037],
            [4.325006151042384, -2.423311691571174],
            [4.31947276868357, -2.4191447276356097],
            [4.312794074696513, -2.421413189007863],
            [4.308703255648868, -2.419838152430829],
            [4.302566453844573, -2.415173443105947],
            [4.302537769893439, -2.4099290897774046],
            [4.30005733061005, -2.4068392941267787],
            [4.295510263143246, -2.409578190817379],
            [4.287063771468816, -2.4059385814365113],
            [4.281521790210044, -2.4061699695798375],
            [4.277708855042355, -2.404758065618355],
            [4.2751767812012105, -2.4000918089781105],
            [4.275864035000994, -2.3950154681035416],
            [4.272400574923069, -2.3893204220928874],
            [4.268201028580044, -2.3884737521185095],
            [4.266506719105488, -2.401089998752676],
            [4.264773281032751, -2.4039405320581078],
            [4.263991233531491, -2.371693791231901],
            [4.249580137518105, -2.372200946152541],
            [4.246252299649722, -2.2986424962843595],
            [4.232314374146604, -2.2993507000355655],
            [4.2310055966165585, -2.2552719528577616],
            [4.216999144966354, -2.255803420249852],
            [4.216985966629633, -2.2412298224258707],
            [4.20218744599081, -2.2413333569023095],
            [4.201742738904965, -2.210421741568334],
            [4.1696039506707425, -2.211509515168146],
            [4.169011595891359, -2.1967205428256342],
            [4.16544608005238, -2.196874754507793],
            [4.1648212881856725, -2.1819639163874633],
            [4.161350456758552, -2.182163839485241],
            [4.160802007792823, -2.1673328627655604],
            [4.157220583637747, -2.167671351535991],
            [4.156900262056933, -2.1603666029155786],
            [4.1419749970029764, -2.160879428370967],
            [4.141715933379325, -2.1535585230781358],
            [4.127399135048283, -2.153958165518325],
            [4.127261493495671, -2.1467616302459147],
            [4.120056120784438, -2.1469809054086526],
            [4.119863541954231, -2.1369640657237703]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.02764674280488, "lat": 36.34145842792626 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05121"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00069178"
      },
      "bbox": [
        4.119863541954231, -2.5087038972073596, 4.652660763967214,
        -2.1099935250473982
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3271175422798382, -3.691605471192176],
            [2.32690998314419, -3.664644374686929],
            [2.3231320861075173, -3.6644464023335375],
            [2.322788189425051, -3.5757468343122567],
            [2.358137233201754, -3.575945713386459],
            [2.3580892157494473, -3.561457880940207],
            [2.4088004684838467, -3.561292048925024],
            [2.4660582807460485, -3.5614721756532703],
            [2.466162233698948, -3.5468798854719914],
            [2.4806060982701945, -3.546777599501085],
            [2.4804850044298963, -3.532184658664574],
            [2.4943170368408545, -3.532097744051017],
            [2.49419023898102, -3.5251518214536346],
            [2.5020964359855142, -3.5251789618649765],
            [2.5016915479887323, -3.503745033778557],
            [2.5090946380655326, -3.5037967853590586],
            [2.509060979744446, -3.495594047120611],
            [2.523241769941471, -3.4963909561697584],
            [2.52373416777054, -3.4890704477021273],
            [2.580842615073611, -3.489516610542171],
            [2.6665557549886953, -3.4884718878906007],
            [2.665058463783369, -3.3878990148747476],
            [2.6835369378318217, -3.4110272030121784],
            [2.6919144653987415, -3.4198459676508],
            [2.6981720191083434, -3.4243350157552537],
            [2.7045825336517173, -3.4265222199314795],
            [2.7146942882100364, -3.427184412431915],
            [2.7274797081072544, -3.426579017521294],
            [2.730702376542118, -3.4274080309763972],
            [2.738089291794628, -3.4321426842542286],
            [2.7436200717307564, -3.4367331119763995],
            [2.753809519605311, -3.4493264632916896],
            [2.7639439359151536, -3.4598105030675965],
            [2.767884760885867, -3.4647769081870647],
            [2.779053254312214, -3.4860233911917495],
            [2.781952809913666, -3.496985422136981],
            [2.782102143878627, -3.504780388607022],
            [2.783798306400212, -3.509388044856312],
            [2.78922882372718, -3.5187774130645355],
            [2.795212615340914, -3.5241537952975266],
            [2.8019152131234413, -3.5263461474314837],
            [2.8060658613193867, -3.525878755775867],
            [2.81191677823526, -3.522259051542719],
            [2.8185619709354635, -3.5142329670695984],
            [2.8228516635760674, -3.5125879169158227],
            [2.826230809595368, -3.5131291340395703],
            [2.831121924894506, -3.5176448740309367],
            [2.832657265949021, -3.524241699060804],
            [2.8311454972043975, -3.5280935508867275],
            [2.8271143652685455, -3.532132360111082],
            [2.8263409929918284, -3.5362787040543897],
            [2.830419687736966, -3.546020540229689],
            [2.8279158061580585, -3.5529433550454756],
            [2.8201363833008894, -3.5579252391323153],
            [2.8247810247772582, -3.5672558946453568],
            [2.8339654048847316, -3.573803047024482],
            [2.8424937023828005, -3.5778433211996514],
            [2.8518719294148, -3.578627382948081],
            [2.8627446339057943, -3.575735023478765],
            [2.8693262918249927, -3.5709182725712316],
            [2.873117726158936, -3.5658294877255443],
            [2.8707641334349905, -3.5442194526754722],
            [2.871385943017575, -3.537145273441387],
            [2.874076418337937, -3.5337272246682008],
            [2.8892809801633415, -3.5270840968292325],
            [2.911157626919146, -3.5220284437134852],
            [2.916470951821273, -3.5220097470315235],
            [2.9235168671710996, -3.523912785165731],
            [2.928005097505265, -3.5231399539566963],
            [2.9373024887111874, -3.5175670387811984],
            [2.940464776781581, -3.5165206827135713],
            [2.95315148204066, -3.5157203624013262],
            [2.9620651309791253, -3.5167245282059194],
            [2.9747963337673786, -3.5219239071811064],
            [2.9616739041622426, -3.5231206155388346],
            [2.955390215255262, -3.5245789783824177],
            [2.950428457827368, -3.5287320692428974],
            [2.9454769352387564, -3.5362820531054435],
            [2.936852465035517, -3.5432151070933333],
            [2.9311635830686837, -3.5532855118293196],
            [2.9222545670208784, -3.557736837371487],
            [2.9186257224775223, -3.5587125440021525],
            [2.912711967732086, -3.5631348287064433],
            [2.916010419515918, -3.5687813058314095],
            [2.913849207711843, -3.5709721375720767],
            [2.911845641912259, -3.5771242474698335],
            [2.903998702910712, -3.5800065234313947],
            [2.899588431842112, -3.5781002231255035],
            [2.8865518327940745, -3.580715234967888],
            [2.8813957779152077, -3.5768290362979274],
            [2.8762495325283535, -3.583504467627929],
            [2.8680997795978938, -3.583973260610774],
            [2.863417379261938, -3.587725598324654],
            [2.8650805595484994, -3.592445771392399],
            [2.8685933442065923, -3.595008392447534],
            [2.874422716251522, -3.5965145750425176],
            [2.876530393913364, -3.6046921529030755],
            [2.874983442525693, -3.6083953290048396],
            [2.87056232826286, -3.6114065532560535],
            [2.8646054357412507, -3.619214742569674],
            [2.8559350809961783, -3.6195361478421697],
            [2.8561957546332692, -3.6341065337385294],
            [2.841803850362373, -3.6342749790020785],
            [2.842092077468352, -3.6489075142924157],
            [2.8276644189639377, -3.6491609471058286],
            [2.828057075254238, -3.663582398929765],
            [2.8131961687336573, -3.663698271258408],
            [2.8133796288065844, -3.6799543077836976],
            [2.7989284776915055, -3.6799119018339694],
            [2.7991040498839665, -3.6945122285787204],
            [2.784715758962801, -3.6944027648026427],
            [2.7848331612874557, -3.708973163251977],
            [2.7702118187500453, -3.7091166257326096],
            [2.77063552840142, -3.7236703617702895],
            [2.7534285930804954, -3.7238745537935483],
            [2.7535511411965823, -3.7383612709796625],
            [2.738687337388338, -3.738373897998102],
            [2.7387391703563853, -3.753207548554571],
            [2.725047680032826, -3.7534165758482967],
            [2.725400364375204, -3.7685922799371685],
            [2.7110932706936604, -3.7691157470519214],
            [2.711555217525955, -3.78370087615935],
            [2.6975053457167117, -3.7839887679718602],
            [2.697702913231829, -3.798497545672682],
            [2.683237548474686, -3.7990252817414394],
            [2.6834208805156674, -3.813673912141722],
            [2.669185954297554, -3.8143332543965776],
            [2.6694423454854532, -3.8280200148756567],
            [2.6553424165911435, -3.828223934215141],
            [2.655606391764525, -3.8427253954812772],
            [2.669911034269562, -3.8424995701559634],
            [2.6728373309570013, -3.930612492503371],
            [2.6153282219558402, -3.932108088308278],
            [2.6016635080043775, -3.932661991424921],
            [2.5859735626007767, -3.933864676341654],
            [2.5868450845134037, -3.963051439820331],
            [2.5579360081821587, -3.9637584000304305],
            [2.5015410392393047, -3.964851075313198],
            [2.4438853731296883, -3.9656189724144],
            [2.4150927809762552, -3.9661721260812444],
            [2.3296907282686834, -3.967058800023382],
            [2.328579656129615, -3.8794681168747576],
            [2.327892013757687, -3.8069859289124355],
            [2.3271175422798382, -3.691605471192176]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.41084261120199, "lat": 35.00258801009802 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05149"],
        "coty_name": ["Yell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yell County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00069908"
      },
      "bbox": [
        2.322788189425051, -3.967058800023382, 2.9747963337673786,
        -3.3878990148747476
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.75895590287005, 2.1647596539110823],
            [-19.755831274942707, 2.1634352940987798],
            [-19.738830054271265, 2.1626855803738265],
            [-19.727453774365078, 2.156749882611685],
            [-19.708636488991306, 2.1481912621036496],
            [-19.696327386831932, 2.1403891459762825],
            [-19.692252767399275, 2.132805853124169],
            [-19.68884939860893, 2.120160993401172],
            [-19.683834483029486, 2.115261982999669],
            [-19.675959692387057, 2.11128056381509],
            [-19.66892011410403, 2.109773289331804],
            [-19.65568468266236, 2.110136800879978],
            [-19.650979922239223, 2.112227108432804],
            [-19.63422550991059, 2.116021924124971],
            [-19.626013765199538, 2.116469993408676],
            [-19.61531986336984, 2.118203156923379],
            [-19.60718311348808, 2.1216409581257922],
            [-19.601970055681296, 2.122334923314821],
            [-19.59445621998732, 2.118190669281858],
            [-19.583851408719422, 2.115218138864155],
            [-19.578236577177858, 2.1125787812151806],
            [-19.567129372042935, 2.1139592849868483],
            [-19.54205450572221, 2.110928050620997],
            [-19.534368666765342, 2.106931346817655],
            [-19.527943423247926, 2.1007586953521935],
            [-19.518658497134584, 2.0892698981098734],
            [-19.51125820593787, 2.0829146851340656],
            [-19.504669177287617, 2.078642125522572],
            [-19.493312491923074, 2.073877483481153],
            [-19.47740048710885, 2.0712160305094556],
            [-19.46517024920838, 2.0720139054198685],
            [-19.460279082526327, 2.0745659330280777],
            [-19.45365987472593, 2.0810670763767645],
            [-19.451778837444834, 2.0843656313823606],
            [-19.44549331191734, 2.0812994278842267],
            [-19.441666443356983, 2.0751820069358153],
            [-19.43996815620271, 2.06634741551753],
            [-19.44096167811537, 2.0595996888610375],
            [-19.440704791351774, 2.052901706844826],
            [-19.438462988270626, 2.044060570990057],
            [-19.4303977634625, 2.0324795683835504],
            [-19.42424186673166, 2.0288083955219434],
            [-19.41784713404222, 2.0283922035113067],
            [-19.409321280558185, 2.022668037741573],
            [-19.400702848767512, 2.020792019114603],
            [-19.390257298336554, 2.022371044334286],
            [-19.377887389338976, 2.020144029061681],
            [-19.368807451278144, 2.0200143777847646],
            [-19.357651690698194, 2.024450448406611],
            [-19.343970529990212, 2.0270714750191337],
            [-19.33518501128305, 2.030162613525085],
            [-19.32685942206898, 2.036548696048199],
            [-19.3171161615572, 2.041939695641361],
            [-19.314790566061955, 2.0453537895769327],
            [-19.3120466852185, 2.0566671335739084],
            [-19.311812901367635, 2.0622267547978477],
            [-19.307892230171383, 2.0687858219025705],
            [-19.302103760202748, 2.071580875516604],
            [-19.293125785818084, 2.071296136970545],
            [-19.284780539554507, 2.0631448683973415],
            [-19.282804403270912, 2.0598511537096638],
            [-19.277819494031498, 2.057131251646113],
            [-19.273025642052385, 2.058403432828412],
            [-19.267993467304677, 2.066070048073848],
            [-19.266482478162988, 2.0668033687309695],
            [-19.249208605654953, 2.063623998844533],
            [-19.235398364511955, 2.0561380657229518],
            [-19.231970140325416, 2.053149467192462],
            [-19.231423207012153, 2.050198354320732],
            [-19.233866212054725, 2.0366909290319986],
            [-19.232052544307027, 2.0320517988245963],
            [-19.234128948624264, 2.0301126192178383],
            [-19.24058823039789, 2.0283159009352976],
            [-19.24413751098705, 2.0203686191215517],
            [-19.245226549018398, 2.0118110629650086],
            [-19.249160422743078, 2.004634521026909],
            [-19.25093114922577, 1.9972499575772342],
            [-19.249885097771788, 1.9931193966304055],
            [-19.246681885985826, 1.9937669610450375],
            [-19.247480696198114, 1.9991923433045953],
            [-19.243990976035256, 2.0025969875487437],
            [-19.240297810112736, 1.999958553569934],
            [-19.240197866926756, 1.9963622176788487],
            [-19.242721120762557, 1.9901198885323033],
            [-19.23746907574774, 1.986917188512393],
            [-19.238328387578953, 1.9810967807392936],
            [-19.235848841338523, 1.9732156255042772],
            [-19.23892078636829, 1.9723909662902612],
            [-19.244981881859268, 1.9774558424857858],
            [-19.247341297930923, 1.9762488516150447],
            [-19.24386874010404, 1.9717514077790375],
            [-19.245335729094933, 1.9699100459522139],
            [-19.25280454605263, 1.9713789741989964],
            [-19.255147623580477, 1.9688453767310456],
            [-19.25519304451456, 1.9651643680839312],
            [-19.249620343230763, 1.9626202946077536],
            [-19.250465542717098, 1.9583860935424897],
            [-19.255934565594167, 1.9598933850879883],
            [-19.25574064920481, 1.955474287935714],
            [-19.260889035189894, 1.9513133573007464],
            [-19.26347555214505, 1.9461604468892681],
            [-19.261903375586897, 1.9432436844675225],
            [-19.257763979030717, 1.9408034870532245],
            [-19.26367630511272, 1.9380402331349935],
            [-19.260469918874094, 1.9326546118779901],
            [-19.26158655645055, 1.9273309496414641],
            [-19.256900037182298, 1.9191455997954379],
            [-19.257791154803215, 1.9172302964945989],
            [-19.264728629262876, 1.918256325973123],
            [-19.264896638551882, 1.914970237722027],
            [-19.25826305565505, 1.9145650642692322],
            [-19.257512163167004, 1.9126799985572571],
            [-19.26230782285679, 1.9094566521104697],
            [-19.263370364721926, 1.9058632549106171],
            [-19.259776116624515, 1.90363131824021],
            [-19.25905312044297, 1.898833081388537],
            [-19.2605580021634, 1.8950652317905423],
            [-19.258385922679018, 1.8906582971319508],
            [-19.260768855698437, 1.8867909695977318],
            [-19.260141822067126, 1.8817773783188128],
            [-19.267797903021062, 1.8795636508934292],
            [-19.26922912922772, 1.8767397129686114],
            [-19.268232079920335, 1.8724008281933453],
            [-19.27026568458315, 1.8696025372028886],
            [-19.277349732772084, 1.867006660358968],
            [-19.274163104505874, 1.8588071982267618],
            [-19.276906887535105, 1.8540761559372878],
            [-19.283194731047438, 1.852688020130613],
            [-19.283996750832994, 1.8465696381885206],
            [-19.29116128691979, 1.8369282328273306],
            [-19.289060637652724, 1.8279983725044378],
            [-19.29423489633652, 1.8260198486168702],
            [-19.294520818645083, 1.8234026358807587],
            [-19.288582863410067, 1.8238452258049695],
            [-19.288337702853777, 1.821188476202956],
            [-19.276781385368157, 1.8180015715812199],
            [-19.27344180697973, 1.8195871780794823],
            [-19.27167872188123, 1.813684953607646],
            [-19.26619477540906, 1.814812430288499],
            [-19.268592229353498, 1.808739753479641],
            [-19.26312140927019, 1.805744343690706],
            [-19.266016114719456, 1.802743897681378],
            [-19.269433679233384, 1.7944309809171475],
            [-19.276591559464382, 1.7910756847997242],
            [-19.27896689115024, 1.7930184551507615],
            [-19.281815442434223, 1.7900715681148158],
            [-19.282516237242298, 1.7851303514824066],
            [-19.285826319554257, 1.7794712645721624],
            [-19.289233122305443, 1.7779628221652035],
            [-19.340368603872925, 1.7760812041156882],
            [-19.352901413442048, 1.7751177865772747],
            [-19.36984895025723, 1.7752734024224566],
            [-19.438656186192173, 1.77281212538308],
            [-19.472426760752583, 1.7714065821180986],
            [-19.498790637692505, 1.7707751663044007],
            [-19.578818550383435, 1.7681907435365092],
            [-19.605184734177232, 1.7676879679426905],
            [-19.619705517255756, 1.7671247543972088],
            [-19.625466055614204, 1.7810996983673917],
            [-19.631411437909343, 1.7835841833662822],
            [-19.636881674038058, 1.787260012202003],
            [-19.640989352709003, 1.7938648248598108],
            [-19.645061016659728, 1.7957163651741104],
            [-19.650835974357694, 1.806142318641442],
            [-19.647980852710656, 1.8134123493359129],
            [-19.63566394052845, 1.8185881963562411],
            [-19.643439985354966, 1.838347493842604],
            [-19.653927287907976, 1.849257678945095],
            [-19.662387405997315, 1.8625361582368711],
            [-19.68694434499681, 1.8717343654820138],
            [-19.73201919716065, 1.8890315182533657],
            [-19.735927722600763, 1.8996342172898721],
            [-19.741240142625934, 1.905529500323262],
            [-19.749620720435242, 1.903146417408471],
            [-19.757105907994408, 1.9083006077813962],
            [-19.762297441155795, 1.9158073382108907],
            [-19.760913974090794, 1.9211377351019094],
            [-19.756628578885604, 1.9270756355214584],
            [-19.76343538759575, 1.936928227017545],
            [-19.76258136362525, 1.938461463667587],
            [-19.765839727266474, 1.943864231927783],
            [-19.766511100213325, 1.9475299340193397],
            [-19.770667510591867, 1.9494908351842324],
            [-19.77094459925451, 1.9528458694064628],
            [-19.77536027302713, 1.964275392685925],
            [-19.771578379575626, 1.9677198938368092],
            [-19.774419152819387, 1.9784786247504693],
            [-19.77766886828829, 1.9819754313288385],
            [-19.784434368430112, 1.9863052248288544],
            [-19.78729475056978, 1.985648724864667],
            [-19.791388268260114, 1.9921000603595735],
            [-19.79015588737333, 1.9961104948033601],
            [-19.793608555963317, 2.006228336564526],
            [-19.79650139347188, 2.006836152751632],
            [-19.797945683365764, 2.011584125409748],
            [-19.802597893674324, 2.01505225890891],
            [-19.808438881020155, 2.013903271260924],
            [-19.809786800778927, 2.011756262106597],
            [-19.81901313074859, 2.0110309684155476],
            [-19.823387795122592, 2.013711622544147],
            [-19.836573483391657, 2.0157373775529366],
            [-19.84081927698912, 2.017540150853105],
            [-19.843993187453517, 2.0158838390281315],
            [-19.84566293148937, 2.0188332388819514],
            [-19.844045996714026, 2.0226639828902706],
            [-19.840806866748412, 2.0251242447687154],
            [-19.84258830015902, 2.0287621301169287],
            [-19.849923357263236, 2.0331893813031288],
            [-19.857521339136287, 2.0321261010483953],
            [-19.86313356003225, 2.034115537553358],
            [-19.86321874510813, 2.0362068194905603],
            [-19.868732455763208, 2.0377228247295593],
            [-19.867608755605726, 2.0456935390442417],
            [-19.8708049061022, 2.044855910332737],
            [-19.872143398145294, 2.0345811436767467],
            [-19.8759912186958, 2.0346373085194047],
            [-19.88306216929618, 2.0393930513882648],
            [-19.891472964806354, 2.043755852913956],
            [-19.88598542133737, 2.0541955334781106],
            [-19.8876718093259, 2.0597915411888974],
            [-19.89386660522547, 2.0678518039753833],
            [-19.89967684364304, 2.0704911413791858],
            [-19.901089289584192, 2.076039151918352],
            [-19.898365872733034, 2.0777897460995254],
            [-19.899128684540017, 2.083908129544443],
            [-19.905034180052954, 2.0875598294430535],
            [-19.90149727854827, 2.090484469443309],
            [-19.9014773171962, 2.094609371684178],
            [-19.904118192038585, 2.097525478866126],
            [-19.90621078944506, 2.1046311500057984],
            [-19.905330490476526, 2.106783280764277],
            [-19.897118402839975, 2.103789315852671],
            [-19.893072680272613, 2.101062702832152],
            [-19.891459285453877, 2.094578136122812],
            [-19.88809236914827, 2.0907935529665456],
            [-19.881158871090108, 2.094127758222919],
            [-19.88401176803828, 2.101036417613009],
            [-19.882875991000084, 2.1036625556619972],
            [-19.867540766239838, 2.102636494781653],
            [-19.855118071998, 2.105869233869949],
            [-19.847586919795383, 2.116131605658298],
            [-19.847197308480496, 2.12062062577298],
            [-19.8490155710773, 2.1254220713056795],
            [-19.847864040553794, 2.13505175064797],
            [-19.845859855494684, 2.1392890436139482],
            [-19.843296602822186, 2.138975151652409],
            [-19.842526056873545, 2.134236876857503],
            [-19.837645179206323, 2.13289981363013],
            [-19.822373497988696, 2.1210395808128655],
            [-19.815170418683177, 2.1233153873836588],
            [-19.80673710521825, 2.127207320441883],
            [-19.795966702140213, 2.123392196494781],
            [-19.78935731156658, 2.126974719361715],
            [-19.784263999428635, 2.132011528305407],
            [-19.77970001360431, 2.131135498343968],
            [-19.772539606631685, 2.137327841756414],
            [-19.76938166987285, 2.143698570449299],
            [-19.76561733518978, 2.14630373066438],
            [-19.762223156088716, 2.1454979340248927],
            [-19.75818660401037, 2.148035650237049],
            [-19.756293078791334, 2.154708183572427],
            [-19.75895590287005, 2.1647596539110823]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.92752960693537,
          "lat": 37.91914711828954
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06013"],
        "coty_name": ["Contra Costa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Contra Costa County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01675903"
      },
      "bbox": [
        -19.90621078944506, 1.7671247543972088, -19.231423207012153,
        2.1647596539110823
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.090634080424675, 5.813717487232642],
            [-18.0262068331784, 5.795152305070853],
            [-18.017925489438298, 5.792611276779058],
            [-17.983732131896854, 5.784513515659188],
            [-17.896075494586736, 5.760664288106146],
            [-17.830197466493594, 5.74093279024397],
            [-17.788801553235032, 5.72773554691078],
            [-17.759163510979672, 5.719498309781153],
            [-17.73038165828701, 5.712286085367723],
            [-17.687349717581696, 5.701082049897043],
            [-17.620496556750798, 5.683340436667757],
            [-17.545553136156137, 5.663234959345956],
            [-17.499262971175444, 5.650452409731392],
            [-17.40859041555332, 5.627215129470037],
            [-17.29277824810738, 5.5958838866022],
            [-17.292182178919486, 5.596305752366129],
            [-17.26250064029525, 5.588197104122395],
            [-17.193507793212262, 5.572038983905649],
            [-17.122087576064988, 5.553999657228429],
            [-17.058519470490573, 5.537740661654423],
            [-17.088704651853956, 5.421603307603182],
            [-17.11950966486665, 5.299620218069185],
            [-17.151380871792846, 5.178286139056497],
            [-17.152510418637508, 5.1722254513247075],
            [-17.183292870422193, 5.056919519400809],
            [-17.263133998680175, 4.749787601865479],
            [-17.265595054938863, 4.750308415848243],
            [-17.363596781839117, 4.775859716046731],
            [-17.414136553970458, 4.788917799434124],
            [-17.481328875657972, 4.806416380285407],
            [-17.59635698914858, 4.836775388340918],
            [-17.71139073916753, 4.867111867868838],
            [-17.715389859573385, 4.86772109302387],
            [-17.828158214293016, 4.897593739927994],
            [-17.900471459407726, 4.916836672158956],
            [-17.96440881939219, 4.934194340162173],
            [-18.08487913521984, 4.966720809638327],
            [-18.137021670755715, 4.980945454506917],
            [-18.2241737872297, 5.003936862958094],
            [-18.30687779737851, 5.0260654670810245],
            [-18.277812649707062, 5.131352667628924],
            [-18.241487100394355, 5.263768900838672],
            [-18.242887037654526, 5.2645676049810755],
            [-18.231452351799526, 5.30663817377864],
            [-18.219692946198176, 5.349109098287255],
            [-18.19204073936074, 5.4504649760960815],
            [-18.19149751765299, 5.453923783443791],
            [-18.182134595656187, 5.484661667071179],
            [-18.150578200575403, 5.600309826261335],
            [-18.15627099037775, 5.601770866114513],
            [-18.11018669919743, 5.769674282948142],
            [-18.103129292575463, 5.7684719038068195],
            [-18.090634080424675, 5.813717487232642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.72501113934986,
          "lat": 41.58982052312142
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06049"],
        "coty_name": ["Modoc"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Modoc County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00277289"
      },
      "bbox": [
        -18.30687779737851, 4.749787601865479, -17.058519470490573,
        5.813717487232642
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.594698936862313, -3.1976093468849096],
            [-14.598030126553633, -3.204943118376271],
            [-14.602095000931339, -3.218544930171813],
            [-14.602993055324655, -3.226251032612734],
            [-14.601967575504338, -3.234233811489518],
            [-14.602457985761227, -3.2390905236082586],
            [-14.605328327576956, -3.2484732051542693],
            [-14.608082484292819, -3.2535449689402407],
            [-14.61381608393364, -3.2590152524348355],
            [-14.623696387054748, -3.262415307229746],
            [-14.630330117031185, -3.2597890247637924],
            [-14.634549397916665, -3.2638905188129326],
            [-14.634335566184172, -3.267587472380206],
            [-14.629359373438929, -3.272531422706221],
            [-14.631306750359174, -3.2784313863286103],
            [-14.6378108186151, -3.278190275948606],
            [-14.64134052962899, -3.282455636895337],
            [-14.650990644064388, -3.287508671971632],
            [-14.654796888503808, -3.29264697818457],
            [-14.664776587641862, -3.299586803932703],
            [-14.669665587978974, -3.3037979159511615],
            [-14.678370056592644, -3.306723396810459],
            [-14.683287853022467, -3.3048915708324684],
            [-14.688733044638386, -3.3063644268147105],
            [-14.695650323610455, -3.3130041695886696],
            [-14.703712024917493, -3.3249130061541785],
            [-14.704790235682719, -3.334206248924012],
            [-14.697954038463665, -3.3387391995916476],
            [-14.69328402684797, -3.3445330701497227],
            [-14.688942492436446, -3.3519757840948867],
            [-14.68746050212834, -3.3597355638628583],
            [-14.688714828654446, -3.362735083747689],
            [-14.69541776946354, -3.364205331644661],
            [-14.700124888364636, -3.3599842313843684],
            [-14.702516282259685, -3.3596390481503713],
            [-14.702145340603431, -3.367267334622241],
            [-14.693743294245426, -3.382106054858309],
            [-14.689814757878716, -3.3868720528530107],
            [-14.690476435133819, -3.395848115543788],
            [-14.693321344354565, -3.399103200992171],
            [-14.701727097429812, -3.403227074598222],
            [-14.708690412431165, -3.400403823169161],
            [-14.712376919026989, -3.4008396961679397],
            [-14.715237153911477, -3.4038430669462967],
            [-14.715860034611762, -3.4112819870229014],
            [-14.713340616733873, -3.424837110425202],
            [-14.712497877282674, -3.435193411567035],
            [-14.715966829157606, -3.4410716925726526],
            [-14.721067917937825, -3.4441826429599165],
            [-14.717651608116043, -3.460731896514745],
            [-14.717102373292157, -3.4722449631502306],
            [-14.713274261649007, -3.493920665111517],
            [-14.712926722640063, -3.501639094660677],
            [-14.714463914146332, -3.5110379634539948],
            [-14.719313319632938, -3.519727270783494],
            [-14.724105500625134, -3.526339139315011],
            [-14.71868618852493, -3.533717200089089],
            [-14.71708154061907, -3.5400284327490867],
            [-14.714254123997069, -3.543708948201072],
            [-14.714523309295531, -3.5551658242750945],
            [-14.718527242909149, -3.565670520808613],
            [-14.726174974217704, -3.5681401540341673],
            [-14.732524475226228, -3.568673062584552],
            [-14.742939127546856, -3.5721579233950203],
            [-14.749411853480169, -3.577679931456584],
            [-14.752712861551979, -3.5868074090435944],
            [-14.74924086418355, -3.593456958826153],
            [-14.741874747615176, -3.5959356970595753],
            [-14.739923887959604, -3.5990841601363828],
            [-14.744223154010887, -3.60259394346963],
            [-14.74975542783272, -3.6014918378236964],
            [-14.754438376318578, -3.6020833581718654],
            [-14.75774685398214, -3.607597198394687],
            [-14.752921432488069, -3.616513096164765],
            [-14.752794627019954, -3.6226535275401686],
            [-14.755743680259808, -3.626622406065301],
            [-14.759178536911536, -3.627197509157698],
            [-14.760911570331906, -3.6321056104606337],
            [-14.759150100176486, -3.638026060194385],
            [-14.75563441694104, -3.6431250291185817],
            [-14.755958889133101, -3.646026954182728],
            [-14.76263381021155, -3.649452055690162],
            [-14.774882524743814, -3.6626483831611436],
            [-14.776732971369563, -3.673344488375677],
            [-14.775451568965979, -3.6853379682099874],
            [-14.77031984985954, -3.6983221969364015],
            [-14.769526436867833, -3.7038409331853583],
            [-14.785566132563348, -3.710666916213009],
            [-14.801360702104374, -3.718472643081477],
            [-14.804396259740184, -3.7255407821278053],
            [-14.805984338808809, -3.733007169568096],
            [-14.81441491189506, -3.739045639205513],
            [-14.82383555842804, -3.740005701852585],
            [-14.830932744864898, -3.742712700302272],
            [-14.834214621993395, -3.745147183383803],
            [-14.840589294811167, -3.7528906667118016],
            [-14.843804433124507, -3.7587470390140982],
            [-14.852266918383716, -3.7667844950359455],
            [-14.85682485774252, -3.7700473504126526],
            [-14.868098148954516, -3.7823679470470277],
            [-14.869346925327957, -3.7913425463298007],
            [-14.876028386845457, -3.804363341355568],
            [-14.949675919419283, -3.789686296382658],
            [-14.989281009039159, -3.781650439317351],
            [-15.041595535940008, -3.7712226413563754],
            [-15.04228254412235, -3.774788479054455],
            [-15.126830479741825, -3.7580377764180724],
            [-15.180517990584613, -3.747676722748004],
            [-15.226918863986514, -3.739072936357401],
            [-15.231462535106575, -3.738690581379195],
            [-15.37604060190722, -3.7087535387211217],
            [-15.384497719989847, -3.7073705675326236],
            [-15.463645983265014, -3.691269422735555],
            [-15.559659244294865, -3.671072954812098],
            [-15.559948821306026, -3.6724599627487535],
            [-15.644096130375933, -3.655076926049064],
            [-15.730272378729849, -3.6365833136027326],
            [-15.737192154138622, -3.6352998093677362],
            [-15.78887859080204, -3.624579773842941],
            [-15.892121047437973, -3.6033915096795277],
            [-15.984167178184759, -3.5837639822184006],
            [-15.990326020557806, -3.5827237749240544],
            [-16.02557878068809, -3.575257661199233],
            [-16.06109571485781, -3.5679514058477046],
            [-16.083348478813544, -3.563183428776567],
            [-16.151571454352254, -3.5454795227257083],
            [-16.207991308844168, -3.534073684472423],
            [-16.328209153163858, -3.508880469059054],
            [-16.411834817494732, -3.4910333764409995],
            [-16.492110650487547, -3.4729368222246495],
            [-16.54401374373089, -3.461638084154553],
            [-16.657417532765614, -3.4368792171601465],
            [-16.68601707351747, -3.4308252884200727],
            [-16.739483102173484, -3.4179792289839983],
            [-16.796348882669843, -3.405244437597636],
            [-16.803034512222123, -3.4043110837234103],
            [-16.826487668099155, -3.3990481191031154],
            [-16.825715429261425, -3.3960360511251313],
            [-16.88715844303629, -3.381599228762546],
            [-16.91063028298086, -3.3743941481543485],
            [-16.92460257042468, -3.371081098765084],
            [-16.955200000317788, -3.364629816298535],
            [-16.995468593800183, -3.3556875770187253],
            [-16.99201011440836, -3.339015379308798],
            [-17.08174737810831, -3.2782496425586554],
            [-17.0870945508264, -3.2744578929548895],
            [-17.07847399900267, -3.2614971518377125],
            [-17.195865526331104, -3.234610729125011],
            [-17.194954412824778, -3.2306490649226642],
            [-17.190164426782086, -3.2318707980380434],
            [-17.18711176251145, -3.2207492030598552],
            [-17.19250797316138, -3.219363357131245],
            [-17.189710903594197, -3.206126450838859],
            [-17.179743621651355, -3.1962273120755893],
            [-17.174609761023227, -3.190390005643177],
            [-17.135968991837736, -3.1530026641243665],
            [-17.13217017294154, -3.1489833856140312],
            [-17.08419262121072, -3.102749080900388],
            [-17.08335034732633, -3.101240451855338],
            [-17.09025205372669, -3.0917002446323663],
            [-17.113499623850558, -3.060887783634117],
            [-17.122650004585147, -3.046304018959902],
            [-17.14082298556538, -3.0403096121069235],
            [-17.16900126881353, -3.028894818634477],
            [-17.160266247534633, -2.982069603119074],
            [-17.18501286828909, -2.9691975773716752],
            [-17.19306100598662, -2.96385355637223],
            [-17.193248429637382, -2.9622729848279397],
            [-17.20821101366134, -2.93003362697511],
            [-17.224407695181924, -2.8926034581315094],
            [-17.238600654673842, -2.8608908373403135],
            [-17.248264962288758, -2.8581793351680234],
            [-17.24643132845907, -2.8474809956031017],
            [-17.244271315720837, -2.8455914992091733],
            [-17.241544278553423, -2.842892380818956],
            [-17.242697803806003, -2.840166672465143],
            [-17.238731555669236, -2.837052302345435],
            [-17.24049807061807, -2.8302624337152524],
            [-17.2428452594216, -2.827560501816427],
            [-17.225667253736475, -2.831540708544466],
            [-17.217808972739633, -2.7958657803417273],
            [-17.182152823143284, -2.804114849738679],
            [-17.17154479069947, -2.7583367927741866],
            [-17.125623991976063, -2.751776714278392],
            [-17.11536828519952, -2.707628748172711],
            [-17.06856894456542, -2.718389256567484],
            [-17.0314556809718, -2.7267537421414376],
            [-17.016684078889305, -2.729510617553422],
            [-16.999648285007837, -2.733331222618166],
            [-16.96861203243764, -2.740874981022019],
            [-16.96834108947222, -2.744061084854982],
            [-16.971922579925625, -2.7550640957468637],
            [-16.9153897635907, -2.7680612950759964],
            [-16.90854345989228, -2.7707028376562697],
            [-16.88801582011812, -2.7748946776576124],
            [-16.85203128987681, -2.783839596490163],
            [-16.854977273497713, -2.7973893782066885],
            [-16.813080670698042, -2.8069512491086335],
            [-16.785276445315482, -2.8130976357569124],
            [-16.771640594910465, -2.8169728776270064],
            [-16.75745833068023, -2.819253010606731],
            [-16.743635731587162, -2.8229411611540782],
            [-16.717542822359984, -2.8285119512908192],
            [-16.701610137075996, -2.831302969669329],
            [-16.68458786607007, -2.8356997795633334],
            [-16.663735801374692, -2.8399786761935366],
            [-16.617374843446513, -2.8501497499228154],
            [-16.61096522001242, -2.8214709816365384],
            [-16.52706253084661, -2.8404588398878463],
            [-16.442527508031596, -2.8592307178849143],
            [-16.3590701591296, -2.878177075072952],
            [-16.359211453142034, -2.8789281111336535],
            [-16.276143441677906, -2.8968266521317894],
            [-16.232374220286967, -2.9063938279627672],
            [-16.106297827691147, -2.9341616949342124],
            [-16.105737821629287, -2.932369848656197],
            [-16.021547412379032, -2.950633429976443],
            [-16.021762695236347, -2.9513261705005505],
            [-15.901425317805698, -2.9764480471608765],
            [-15.851841017338094, -2.9868920612071213],
            [-15.6634089426776, -3.026000131967893],
            [-15.66096817578652, -3.0263628514349525],
            [-15.568107970726723, -3.0459458270792994],
            [-15.313716072763691, -3.0999376735453557],
            [-15.304703342877545, -3.0568645574214357],
            [-15.205181698264703, -3.0773613579342136],
            [-15.204804138108498, -3.075732574556408],
            [-15.159399589265476, -3.0846800737598423],
            [-15.124136026551783, -3.091797054697569],
            [-14.991294606749227, -3.1187993642098264],
            [-14.912450844033192, -3.13473396077698],
            [-14.77203263126872, -3.16251270559966],
            [-14.631611576058463, -3.1902762656450308],
            [-14.594698936862313, -3.1976093468849096]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.99380842952749,
          "lat": 33.743651524445355
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06065"],
        "coty_name": ["Riverside"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Riverside County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00277297"
      },
      "bbox": [
        -17.248264962288758, -3.804363341355568, -14.594698936862313,
        -2.707628748172711
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.284064903318246, -0.2164070917954293],
            [-5.100785513337925, -0.2298779184819377],
            [-5.0825444970215585, -0.23130271992018733],
            [-5.075572363202698, -0.23140689546376994],
            [-4.992039884036007, -0.23762629305204638],
            [-4.974272441426816, -0.23862254341944028],
            [-4.935171421157068, -0.24128569889335802],
            [-4.92819871518754, -0.2419662535735622],
            [-4.8509958148447145, -0.24728318752029232],
            [-4.845567852504714, -0.24826563277525385],
            [-4.817948563557865, -0.24889837569811454],
            [-4.788827322564012, -0.25211014510825985],
            [-4.774065582905656, -0.25286495960563504],
            [-4.774945171755049, -0.2699829966436166],
            [-4.777245559343475, -0.29673784875203907],
            [-4.785754487310742, -0.4245492427071196],
            [-4.792378280851829, -0.5218227559149852],
            [-4.792326756389413, -0.5239604083278184],
            [-4.804311218555807, -0.6990846833056591],
            [-4.810242516238928, -0.6995215547943144],
            [-4.822814728052786, -0.8804057805205302],
            [-4.879869196996427, -0.8763855677043826],
            [-4.90473179729331, -0.8739464384084606],
            [-5.022733960615699, -0.8658967894180642],
            [-5.040570438557113, -0.8644080370502405],
            [-5.079598293800602, -0.861925837149753],
            [-5.109935087104274, -0.8596621910268207],
            [-5.123016843439324, -0.8584299414313431],
            [-5.3363485243230055, -0.8421736373353386],
            [-5.334502755862806, -0.8223284519008237],
            [-5.32175153351528, -0.6618020657104611],
            [-5.318764680161651, -0.6620148740578464],
            [-5.308977156127768, -0.5439348984873729],
            [-5.306581169946755, -0.523380619862016],
            [-5.305098280743035, -0.5021007526693245],
            [-5.3049611254974165, -0.4942405445253805],
            [-5.300633227883785, -0.44199954041697853],
            [-5.294194201089242, -0.3578494299824916],
            [-5.284064903318246, -0.2164070917954293]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.07172583108998,
          "lat": 37.95510637709507
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08011"],
        "coty_name": ["Bent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bent County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00198121"
      },
      "bbox": [
        -5.3363485243230055, -0.8804057805205302, -4.774065582905656,
        -0.2164070917954293
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.286227879331764, 0.15114987193274804],
            [-7.224146344143943, 0.2023889398245226],
            [-7.201317886736886, 0.20219082805588037],
            [-7.197860950333955, 0.20795335596943276],
            [-7.20016796444887, 0.21349344244436108],
            [-7.199255887326107, 0.2190906823398546],
            [-7.194828137083502, 0.224757757339284],
            [-7.195225253556224, 0.23312248421458057],
            [-7.193250555953767, 0.23933652431229502],
            [-7.192720149155415, 0.24487010078230487],
            [-7.18485651104693, 0.2464654978982802],
            [-7.183808874531306, 0.25424253986268475],
            [-7.181548266597389, 0.2563922484387415],
            [-7.177530736940111, 0.2562357161802883],
            [-7.176146604993453, 0.2603440892111956],
            [-7.176715936763914, 0.26474975960552233],
            [-7.1817125417997705, 0.2688319806957973],
            [-7.179773553914546, 0.2727584579252183],
            [-7.179552388065498, 0.2794369798764862],
            [-7.178208159585275, 0.282485464094198],
            [-7.170292753053277, 0.2895425267379486],
            [-7.167720640682792, 0.2950792642018851],
            [-7.167895304296978, 0.30193094885623134],
            [-7.172089517571151, 0.3107310350223175],
            [-7.172562474591943, 0.3166484221575629],
            [-7.177858997619665, 0.3196320591590303],
            [-7.1821373619992945, 0.3183025160576519],
            [-7.193590013736301, 0.3276988340414715],
            [-7.194848535439359, 0.3310865501573736],
            [-7.188431083922233, 0.3389824179160807],
            [-7.19004017545243, 0.3430991304906333],
            [-7.18514148015432, 0.3490302346547956],
            [-7.188988977232915, 0.35132832790534096],
            [-7.191616813297485, 0.35745940073465515],
            [-7.194490791836449, 0.3579929173947671],
            [-7.193501506353462, 0.36247821507815803],
            [-7.19732249262464, 0.3649608683211826],
            [-7.196275864391673, 0.3711487903376738],
            [-7.193972087651826, 0.37345869996586295],
            [-7.196457638599301, 0.3786187720421136],
            [-7.209824008179753, 0.3850415472717575],
            [-7.21005200233715, 0.39052357465677573],
            [-7.217446251918143, 0.3912324779325756],
            [-7.2231450719552255, 0.3928815856657169],
            [-7.2284902018804145, 0.39583614201637063],
            [-7.20911912018696, 0.3933302867464955],
            [-7.173608938275991, 0.3903003655148315],
            [-7.166177232755689, 0.39092901656885565],
            [-7.156006538486713, 0.38900783504382375],
            [-7.059870552080947, 0.37943759511743064],
            [-7.022572242891364, 0.3756266435982766],
            [-6.956448216590363, 0.3696030761118288],
            [-6.891311023995879, 0.36354324170621977],
            [-6.86558016543847, 0.3621653086893467],
            [-6.735887093327241, 0.3493586281458956],
            [-6.735332844932007, 0.3496632188703354],
            [-6.66465291047541, 0.34244269254719856],
            [-6.666442329721934, 0.3242961237261548],
            [-6.670600884388518, 0.30741527264770774],
            [-6.671752742736816, 0.2926090395654953],
            [-6.633573567522146, 0.2895946824060521],
            [-6.574780201789378, 0.28371887926160855],
            [-6.557349882480503, 0.28183645771893256],
            [-6.543497750120893, 0.2812989017588152],
            [-6.524901669392338, 0.28344706442569656],
            [-6.4966899218720116, 0.2810878336051188],
            [-6.4827567967219455, 0.27867862929518267],
            [-6.442275209686196, 0.2732995926267361],
            [-6.4463903344554945, 0.23156904023332353],
            [-6.450052333085605, 0.1902658510921261],
            [-6.45414260768937, 0.14199616209196522],
            [-6.455828452509113, 0.12230619372520796],
            [-6.463305707516087, 0.039673314998944595],
            [-6.467640588729269, -0.006378771424203413],
            [-6.478025416587236, -0.12077531813038013],
            [-6.562316442009633, -0.113080581561481],
            [-6.619674383029981, -0.1078725153082927],
            [-6.6214400358247945, -0.1078414698835645],
            [-6.691586996728551, -0.09996319827425232],
            [-6.727612952244421, -0.0960166494884422],
            [-6.759524787848348, -0.09372473501041084],
            [-6.809587642674325, -0.08759974923515387],
            [-6.905255135260629, -0.07496833939960687],
            [-6.9392322035069265, -0.07063391936171404],
            [-6.947349823577448, -0.06887736857998678],
            [-6.954073530449388, -0.06846526231682733],
            [-6.9816121289914275, -0.06479572208291921],
            [-7.01917130049229, -0.06069228156483422],
            [-7.031211037727886, -0.05957954081744517],
            [-7.113884414380779, -0.051294066657389774],
            [-7.140123437316383, -0.04842716587114115],
            [-7.142026648425938, -0.04328115644507944],
            [-7.156306414380259, -0.038071175307737556],
            [-7.162090604137355, -0.03242453199892932],
            [-7.164232716311331, -0.02560929127352033],
            [-7.168857029011962, -0.021729076110855033],
            [-7.1725065142309425, -0.016511236048841863],
            [-7.175949267941454, -0.01908742499308456],
            [-7.178255889214727, -0.01461496367680948],
            [-7.1841395900165015, -0.010040181589003577],
            [-7.186167122308109, -0.004688797254693491],
            [-7.189943379151741, -0.0019826765515617933],
            [-7.193417921599143, 0.0035928614261546547],
            [-7.194436862911004, 0.008071892548111866],
            [-7.198021290365457, 0.014015555326422312],
            [-7.199585350175996, 0.02114766337704769],
            [-7.201675656692045, 0.02278519670806393],
            [-7.203897432999766, 0.028570799085476856],
            [-7.203225520051198, 0.035050289373968604],
            [-7.2047107314635905, 0.03577700341454576],
            [-7.209116335069009, 0.04504703518963648],
            [-7.215467446178959, 0.04897735807541843],
            [-7.218171554506101, 0.05245344233586033],
            [-7.219372757079946, 0.05778366590485445],
            [-7.223696720365987, 0.06060717735448911],
            [-7.224467347351798, 0.064020184516179],
            [-7.233985708747093, 0.06834412101901127],
            [-7.242396289920821, 0.07755873099242484],
            [-7.2434344358988785, 0.08973824469404232],
            [-7.245448893440073, 0.09320612357697859],
            [-7.249244906167711, 0.09431991952521354],
            [-7.2519182094096575, 0.09729985484621903],
            [-7.252190576365186, 0.10342067765626302],
            [-7.25883231825768, 0.11117136196338688],
            [-7.2613347160874095, 0.11084494409534054],
            [-7.268666611352458, 0.12203944629872954],
            [-7.271086688685293, 0.12135947993119535],
            [-7.278226980377616, 0.12363703071205653],
            [-7.2802052056652995, 0.1272160214807044],
            [-7.280780489211083, 0.13488011628973082],
            [-7.284422072577813, 0.13669453150709607],
            [-7.288454616804336, 0.14484300229050184],
            [-7.286227879331764, 0.15114987193274804]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.43960060754601,
          "lat": 38.473080102118224
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08043"],
        "coty_name": ["Fremont"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fremont County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00198137"
      },
      "bbox": [
        -7.288454616804336, -0.12077531813038013, -6.442275209686196,
        0.39583614201637063
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.42030433604238, -7.249456589916426],
            [9.428521414273298, -7.248401005222135],
            [9.496967475123606, -7.239575306315386],
            [9.635869953032927, -7.221483692615826],
            [9.713488531194793, -7.212744128680402],
            [9.718923437138578, -7.212265084558058],
            [9.798520445174468, -7.20327809832982],
            [9.840603025130743, -7.1983393089815815],
            [9.841503692601755, -7.201033625664517],
            [9.842164351081943, -7.211967511361797],
            [9.8401042969358, -7.21931269103246],
            [9.842457894162326, -7.225388506011801],
            [9.856585620111707, -7.2284487153716475],
            [9.861627135854775, -7.231072078012681],
            [9.864164090730272, -7.235086463970785],
            [9.865354540100721, -7.241560259122823],
            [9.864051254383966, -7.249523991058832],
            [9.864010447367727, -7.259445027021166],
            [9.867057642590787, -7.263399005899508],
            [9.875736351700267, -7.266903189745008],
            [9.877815682201037, -7.272872653121333],
            [9.880655613913875, -7.277251614985642],
            [9.890790691469581, -7.285793843931774],
            [9.897500731251647, -7.295232339258209],
            [9.904570617041752, -7.303325414174651],
            [9.911512683153662, -7.306486292009869],
            [9.91230981486412, -7.309037724950838],
            [9.908959894263226, -7.316436433589048],
            [9.909270783571126, -7.319805248875104],
            [9.915193903702635, -7.324726202064112],
            [9.916018580382767, -7.327334316399157],
            [9.913021927978491, -7.331887749197105],
            [9.916786502818827, -7.3389613065273975],
            [9.921797692320936, -7.341983663347914],
            [9.924240265639824, -7.346911077087486],
            [9.923549548563491, -7.350488853706978],
            [9.919112872656326, -7.352108141813048],
            [9.916684236056454, -7.356523160574214],
            [9.91677847335867, -7.369600513254285],
            [9.917568350775129, -7.37191182931953],
            [9.92352024914531, -7.379231015427228],
            [9.926969762886351, -7.386538745284912],
            [9.92667478313642, -7.392079267827411],
            [9.92945934858149, -7.398864056027783],
            [9.938274000607551, -7.409953757468577],
            [9.93897385144716, -7.415878800929858],
            [9.937897838799081, -7.422110041948444],
            [9.942799703124711, -7.426344513367421],
            [9.94428231721928, -7.433779757111859],
            [9.94728665237372, -7.4358329730201],
            [9.951443158532769, -7.4359503868196954],
            [9.956484489954988, -7.434062802157023],
            [9.960126850178332, -7.434940273880553],
            [9.96847751215355, -7.442776640337911],
            [9.972704933819433, -7.451492900844562],
            [9.980454700410686, -7.455694400989834],
            [9.985937421067685, -7.460654105052065],
            [9.991459177131954, -7.470374028573082],
            [9.998766871914155, -7.4826650703127475],
            [9.995010863614743, -7.492005650563828],
            [9.991019415202734, -7.49880316246448],
            [9.987378954654773, -7.510430685838182],
            [9.980414858792548, -7.51654577925739],
            [9.975999705270777, -7.523764171013375],
            [9.975499944485348, -7.53412843024399],
            [9.973709220801624, -7.539439662175452],
            [9.968732380372021, -7.544120782106584],
            [9.966579895706285, -7.548572184653683],
            [9.967914427806138, -7.55912206201031],
            [9.96521573804653, -7.565538383571183],
            [9.958934040524337, -7.5701697134053045],
            [9.949488260905593, -7.574367232445232],
            [9.945934525361563, -7.580881477136683],
            [9.877181462379353, -7.589117306371401],
            [9.805395914252099, -7.596054593786919],
            [9.74512594232653, -7.6022824212900275],
            [9.7476070935394, -7.604412843932922],
            [9.74639678192921, -7.608317095233971],
            [9.74681601369325, -7.615053197659836],
            [9.744062671994705, -7.620001184409121],
            [9.743716393393886, -7.625283929131071],
            [9.746910948137984, -7.629148091186921],
            [9.744000798817822, -7.632765706929078],
            [9.744553446320744, -7.6413286220845675],
            [9.746539653744927, -7.645807487149269],
            [9.673877744622777, -7.6523525680537015],
            [9.659988968106617, -7.65423285493685],
            [9.60364948899721, -7.659936313212077],
            [9.580597438969546, -7.661901764612513],
            [9.565228638410344, -7.663646634251491],
            [9.521748811328726, -7.667764603073771],
            [9.515040983723717, -7.611325661677871],
            [9.51517609168437, -7.610883847989505],
            [9.511320631559247, -7.565965231863491],
            [9.508504040867155, -7.53568857883982],
            [9.502189219189376, -7.477182480096964],
            [9.49965330088411, -7.452333336008385],
            [9.45664971341348, -7.45664745085274],
            [9.452196192268323, -7.413504169949184],
            [9.351935273254712, -7.423445806626318],
            [9.352125757557662, -7.413541653726989],
            [9.350868574497895, -7.409596107414484],
            [9.352948048572085, -7.405330931373587],
            [9.352511497217689, -7.3999152513688085],
            [9.354799412306958, -7.38912911302301],
            [9.358554868463049, -7.384393442945867],
            [9.360593367817453, -7.3785751705384675],
            [9.359944514821066, -7.371081879272356],
            [9.363919085997304, -7.361452693924837],
            [9.365200960972526, -7.353917124924382],
            [9.36816108852294, -7.351513431302887],
            [9.3731039091277, -7.341804025075503],
            [9.377509276268569, -7.337233334331933],
            [9.381241329482313, -7.324581744601717],
            [9.385171900020923, -7.318124585228768],
            [9.394234782647594, -7.314815585483423],
            [9.399220664423593, -7.309448675432105],
            [9.39758303725137, -7.30691495842592],
            [9.397565103189093, -7.2955507094664895],
            [9.395260901612184, -7.290623646794813],
            [9.3955224516846, -7.277509270570935],
            [9.397162202182766, -7.273734731680218],
            [9.402213587153902, -7.272859914744358],
            [9.40759756267405, -7.265521495657634],
            [9.416723552278924, -7.256228144051179],
            [9.42030433604238, -7.249456589916426]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.21551383534018, "lat": 30.79544676936446 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12063"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00295734"
      },
      "bbox": [
        9.350868574497895, -7.667764603073771, 9.998766871914155,
        -7.1983393089815815
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.004050282439408, -7.390767464595101],
            [8.02348088340449, -7.3884605690430405],
            [8.03698047513656, -7.387937266093508],
            [8.042108674186016, -7.386836394655266],
            [8.097554235642116, -7.381960111549941],
            [8.109206891047792, -7.380405671128968],
            [8.12019834453158, -7.379712988748212],
            [8.13954522613648, -7.377832940148493],
            [8.144611343146792, -7.378010330233334],
            [8.204819447568024, -7.373272173876737],
            [8.251460452325647, -7.3689029743542465],
            [8.325778534850144, -7.362425557494656],
            [8.32584842126941, -7.36571727110623],
            [8.333749353176067, -7.458176825285286],
            [8.341010686176416, -7.557927436044808],
            [8.34227991193844, -7.576849804884305],
            [8.350315527990654, -7.671774000644506],
            [8.354811347634838, -7.730178792954297],
            [8.353688449900192, -7.730320830720778],
            [8.355177292664791, -7.749773750610721],
            [8.36936619560443, -7.923234545351396],
            [8.37312980526795, -7.9665138312623585],
            [8.342056651414818, -7.973400841842976],
            [8.308501862837305, -7.982225554110976],
            [8.27236588179621, -7.992386977967417],
            [8.270819933208191, -7.976996365843345],
            [8.225252872813702, -7.986691317143839],
            [8.175407390178737, -8.004639566765999],
            [8.140172483591304, -8.01703834389277],
            [8.117539050329427, -8.024649122543167],
            [8.087087667459002, -8.03101872522447],
            [8.073627178586918, -8.033473578747968],
            [8.052571516575888, -8.047815136877416],
            [8.037417577284435, -8.046775664481947],
            [8.02766456238756, -8.044234331968838],
            [8.006931423166913, -8.044657999395916],
            [8.002846720052428, -8.018112218047811],
            [8.01005939830915, -8.013067508539397],
            [8.016837080291639, -8.0098055022904],
            [8.061397635717288, -7.977572603724141],
            [8.06869137385485, -7.96993671283453],
            [8.07126693481549, -7.963321399781325],
            [8.075336641928947, -7.945516565364733],
            [8.078980505659086, -7.919706362449064],
            [8.07939554239574, -7.913087918099522],
            [8.084327371671213, -7.895823395326779],
            [8.08686344725063, -7.883706538620947],
            [8.072382893045393, -7.870867995970432],
            [8.055396046924148, -7.848852865296501],
            [8.05053767801511, -7.845356437081662],
            [8.03250409308439, -7.84153993600447],
            [8.023506301659062, -7.838334733322172],
            [8.01886376869598, -7.83865246523548],
            [8.01417025014713, -7.8356821655829165],
            [8.005943290159093, -7.833502991578596],
            [7.998864254031062, -7.8254262726195165],
            [7.993048714526925, -7.817404361497887],
            [7.990264268600057, -7.808888463789796],
            [7.985103510244451, -7.8053179758290145],
            [7.979142987653356, -7.794734939466545],
            [7.975973625591184, -7.795966643235177],
            [7.970603504329759, -7.794195443130523],
            [7.972495079238281, -7.789740034534171],
            [7.970657005868365, -7.786305064624896],
            [7.963391425190344, -7.784145353006993],
            [7.960974151109705, -7.7818930321148025],
            [7.958123775626668, -7.774541985173064],
            [7.959879358027011, -7.769691001531373],
            [7.958786081684729, -7.764736263320476],
            [7.956462761971329, -7.7635791884403],
            [7.958270275847246, -7.758048000997936],
            [7.951446502137981, -7.747124254290592],
            [7.949442730261717, -7.73234701660174],
            [7.94694733083378, -7.729569371249155],
            [7.9463592730045685, -7.717954722768957],
            [7.943980771075216, -7.716197679258319],
            [7.946004818047257, -7.706611455407671],
            [7.9415269460531075, -7.703618376410756],
            [7.938515417851847, -7.696656278916033],
            [7.941791658681763, -7.695373557479906],
            [7.940318545639768, -7.691877481022342],
            [7.941811507248983, -7.688777047347127],
            [7.94048887795984, -7.683480229431475],
            [7.937664570233059, -7.679259215412113],
            [7.931978182517997, -7.679480644916885],
            [7.929963145114577, -7.676781920984453],
            [7.924311201684529, -7.677306997767842],
            [7.918585747645855, -7.676091348096005],
            [7.918218730870836, -7.679406277271226],
            [7.909118891142192, -7.674602953128307],
            [7.905708413832442, -7.671459805301687],
            [7.901653140326031, -7.663985918529664],
            [7.9026805386769565, -7.658256098872256],
            [7.901885306599188, -7.647109866180279],
            [7.904239828437732, -7.644946078118593],
            [7.903711700056517, -7.639862057116563],
            [7.905849233353766, -7.632911976356046],
            [7.904080679851633, -7.628467393340956],
            [7.900016735926653, -7.626035602621902],
            [7.902185897608736, -7.62367990502073],
            [7.899735197681133, -7.62054554000413],
            [7.8997013123176485, -7.616439990428125],
            [7.896777316248613, -7.6137855954229545],
            [7.901190693018573, -7.611455392674207],
            [7.90174119652564, -7.60030732362218],
            [7.903786551885756, -7.5970323276602265],
            [7.906716963876155, -7.597046184036687],
            [7.908492832271446, -7.5896025438542045],
            [7.911036294844716, -7.58571290148001],
            [7.907548245620895, -7.583268657336083],
            [7.906673097106742, -7.5742392354377674],
            [7.902343370159563, -7.570890104629138],
            [7.899804495489926, -7.560648980521313],
            [7.900238893751962, -7.556861127635042],
            [7.895527405168838, -7.55651995781318],
            [7.896518343956928, -7.551460607962275],
            [7.892172806498544, -7.552999626508322],
            [7.889947200540437, -7.551338128258653],
            [7.892178315347834, -7.544906226294581],
            [7.892067547865495, -7.539878927981002],
            [7.893443889877568, -7.535317322666365],
            [7.8991513945875225, -7.535808527305856],
            [7.898854797069577, -7.5325490081546675],
            [7.901860447079977, -7.527256764144347],
            [7.900099089891993, -7.525666946608417],
            [7.900153046698388, -7.517924550895811],
            [7.9036078517039385, -7.514409104740202],
            [7.911424338846467, -7.510170412355023],
            [7.912196441422368, -7.506006348598983],
            [7.909475787451119, -7.503317892198134],
            [7.909163616008909, -7.494763316094677],
            [7.907905395071216, -7.490580390512838],
            [7.911331279934828, -7.4877986596278685],
            [7.90904341075037, -7.482620099365308],
            [7.909911253234273, -7.473519777419383],
            [7.915580964160017, -7.470787575766973],
            [7.914801840544975, -7.467816876946286],
            [7.92152711968663, -7.46256706729147],
            [7.926444436042751, -7.461702240861962],
            [7.9288029340305215, -7.464980918899476],
            [7.932109566257428, -7.464739401407888],
            [7.933708537303822, -7.459190281200012],
            [7.935624780292188, -7.457273183548704],
            [7.933902279495329, -7.453613802279289],
            [7.939119797373285, -7.452981321752062],
            [7.939033074705015, -7.449616573584923],
            [7.942642500488965, -7.446198796120558],
            [7.944302705668028, -7.437055709446122],
            [7.9409961438727, -7.43414464336098],
            [7.945807580860654, -7.431113692670519],
            [7.949805527303372, -7.430970730019932],
            [7.953108216768634, -7.433331505185246],
            [7.960742654628972, -7.429991520740843],
            [7.964470278996393, -7.431465818676938],
            [7.965033310502881, -7.426412847093865],
            [7.971656261472259, -7.422870985795401],
            [7.977652708128039, -7.415707231841476],
            [7.984350726840792, -7.415031075303937],
            [7.9856798772790025, -7.410025739268812],
            [7.995393825441522, -7.40196076187143],
            [7.995817514166108, -7.394681854949621],
            [7.999930352667414, -7.396964276457467],
            [8.004050282439408, -7.390767464595101]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.0218590197245, "lat": 30.70039793327087 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12113"],
        "coty_name": ["Santa Rosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Santa Rosa County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00306914"
      },
      "bbox": [
        7.889947200540437, -8.047815136877416, 8.37312980526795,
        -7.362425557494656
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.66370664191346, -7.331916378406946],
            [8.680150766559208, -7.3299637505343895],
            [8.748254724006893, -7.323745919031073],
            [8.776132892293043, -7.320851091763553],
            [8.791477915225688, -7.318766763985248],
            [8.83493980297823, -7.314632906189453],
            [8.894839500486016, -7.309587124600047],
            [8.964391787143988, -7.301954309267667],
            [8.970871847549153, -7.367317186174176],
            [8.974113692184664, -7.4023622509620095],
            [8.976489192529154, -7.4252771213312245],
            [8.982052627603471, -7.487687953488088],
            [8.992517715047525, -7.587713930351787],
            [9.024653602911702, -7.5845391454705515],
            [9.063493902533944, -7.581148464883825],
            [9.093492254168106, -7.578272025678385],
            [9.157420108716561, -7.571790034017461],
            [9.152224096862854, -7.574257271259561],
            [9.146390062307452, -7.578621813757146],
            [9.144825378493268, -7.583446154593849],
            [9.140649832831961, -7.586864446462186],
            [9.143195763605789, -7.590930549370161],
            [9.140286217985457, -7.596233976227572],
            [9.135150450565542, -7.5954874709553835],
            [9.133498966209626, -7.597933995670549],
            [9.13772663821528, -7.601897757169265],
            [9.13839948606724, -7.607284545862998],
            [9.137157959271635, -7.609285827239265],
            [9.140459039505657, -7.612542142081304],
            [9.137040967359507, -7.616047203359415],
            [9.133315594593933, -7.615737569520297],
            [9.130603464416534, -7.620903112256576],
            [9.126576106634618, -7.622069001789886],
            [9.121683881252153, -7.626191856685214],
            [9.118640993092773, -7.631197826944264],
            [9.114736297259705, -7.631816509549224],
            [9.11122394905462, -7.634879391310437],
            [9.109832354658495, -7.640086939466928],
            [9.10410384419201, -7.643546274417707],
            [9.108280992369735, -7.649206580106569],
            [9.107819261115214, -7.654925943090203],
            [9.109760646215255, -7.660560243245598],
            [9.107448967588153, -7.662533611932675],
            [9.112437914490114, -7.665576199016537],
            [9.111227031788422, -7.675853629761246],
            [9.107731883416907, -7.683309016976985],
            [9.113806152818613, -7.682699655463737],
            [9.112972176979477, -7.6866545149540855],
            [9.114851006608081, -7.688447891119016],
            [9.114303739097998, -7.692515219912915],
            [9.119869337649357, -7.693994933131612],
            [9.12640892496229, -7.69176231171334],
            [9.12859064693859, -7.697061371206175],
            [9.131654448224316, -7.698910780367609],
            [9.133968342011137, -7.708510565485641],
            [9.13211449489348, -7.711576328903578],
            [9.135785244089156, -7.717705076936968],
            [9.14057885818976, -7.717405366285422],
            [9.14287736491936, -7.7201293512950935],
            [9.143926633974408, -7.732284967289539],
            [9.14763920202052, -7.743849249016483],
            [9.139701722363561, -7.748677380194549],
            [9.140804073424249, -7.75197508472448],
            [9.144462936925661, -7.755169861636265],
            [9.145568716239007, -7.759651423523318],
            [9.148167984750264, -7.76355831453977],
            [9.144614058782839, -7.768244510330052],
            [9.149920358951025, -7.771153642022511],
            [9.156423550909315, -7.76900663569029],
            [9.161086725440903, -7.776050397921987],
            [9.167853923049915, -7.7767024849330655],
            [9.167064879882123, -7.7835473475084775],
            [9.161303966051712, -7.786651718318568],
            [9.157905014148263, -7.792506736648916],
            [9.155622312573827, -7.799043914198198],
            [9.15394007960146, -7.8081919381055265],
            [9.148699277069957, -7.81021945452887],
            [9.14378481445947, -7.804978757010537],
            [9.142973325749331, -7.813550865227449],
            [9.140722585319725, -7.817608590441916],
            [9.14163200700447, -7.821151365453691],
            [9.1387430154981, -7.8231100185414295],
            [9.136541469838802, -7.832990188104072],
            [9.133552934755269, -7.835154682909167],
            [9.130108459010398, -7.834803669454465],
            [9.124331753094893, -7.83961693706379],
            [9.110068212230463, -7.837984128369682],
            [9.106688779017308, -7.834745420211964],
            [9.100418532111028, -7.837006537476187],
            [9.092354097835832, -7.837326582385803],
            [9.087604337619167, -7.841420187831855],
            [9.083495700807047, -7.842484542124982],
            [9.081970949152973, -7.8461152255271935],
            [9.077243292407728, -7.847203274319143],
            [9.074118661043148, -7.851413754866739],
            [9.069035587722972, -7.854395017983296],
            [9.065640312176425, -7.860746260973321],
            [9.068621083499622, -7.865457197257436],
            [9.065981561065584, -7.870185964581436],
            [9.064389079920604, -7.875782922892908],
            [9.061584975641935, -7.879567459626663],
            [9.063980861351835, -7.895046247294598],
            [9.06425156956394, -7.8970316817700965],
            [9.070260558975903, -7.970384911386651],
            [9.070745185974546, -7.973773799065073],
            [9.073897361034424, -8.013905877567739],
            [9.070286345866931, -8.012647171321564],
            [8.989669442282777, -7.988336271723715],
            [8.901830458326783, -7.966854213940841],
            [8.886760258616956, -7.964069282454193],
            [8.853289344561299, -7.956373614678334],
            [8.835522919539473, -7.952763430958707],
            [8.791197896038199, -7.946013913846373],
            [8.766363648839882, -7.943617392926276],
            [8.747382183272586, -7.942327523270841],
            [8.718532248864117, -7.941102878191638],
            [8.716942454340812, -7.9217152445083],
            [8.713243803585463, -7.866435553339908],
            [8.710074425648001, -7.823747285190266],
            [8.703909140417561, -7.7589567614057655],
            [8.698866964022814, -7.701856459772094],
            [8.697814459232212, -7.694971407768476],
            [8.690070632307663, -7.6164027759217525],
            [8.68874925859939, -7.601528768428611],
            [8.685882811352691, -7.575421570355039],
            [8.680120353529896, -7.511566899073485],
            [8.675464702785867, -7.458548581783719],
            [8.675013436953735, -7.447790870294474],
            [8.670912408095885, -7.403804589446259],
            [8.66370664191346, -7.331916378406946]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.16966280667523,
          "lat": 30.643582085906676
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12131"],
        "coty_name": ["Walton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walton County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00295727"
      },
      "bbox": [
        8.66370664191346, -8.013905877567739, 9.167853923049915,
        -7.301954309267667
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.012746082258817, -4.850058440848393],
            [11.016252988835522, -4.849854844096184],
            [11.021860611493492, -4.84692280337255],
            [11.043748153014576, -4.849713762923265],
            [11.079092509783544, -4.852159247304949],
            [11.126340197156381, -4.859636636169028],
            [11.147627735241182, -4.862714085551091],
            [11.16299001511279, -4.865886161417406],
            [11.166108063898438, -4.872682795329323],
            [11.164520733216568, -4.8844700052006065],
            [11.161301227089718, -4.887515340394943],
            [11.157658215449747, -4.887642419344319],
            [11.155588444894784, -4.891531068818424],
            [11.158873486793603, -4.89942620563727],
            [11.155833023006767, -4.904920262687446],
            [11.15587365092175, -4.916541279714822],
            [11.157831311842742, -4.922040759141839],
            [11.154325944288837, -4.932391281496468],
            [11.155651219273961, -4.939035011850949],
            [11.164668942997142, -4.94664080697861],
            [11.170314418715796, -4.958107537472336],
            [11.168793261016534, -4.960715724752257],
            [11.174207044733084, -4.967258083674382],
            [11.17996290880462, -4.961393905879397],
            [11.186580764624855, -4.951368846906459],
            [11.19620348133352, -4.948884403427776],
            [11.20467120808267, -4.936725396179076],
            [11.21013290269368, -4.931173394158094],
            [11.217131036898406, -4.9410667944802595],
            [11.218936878810261, -4.950240173019228],
            [11.216478420204085, -4.957887903934149],
            [11.212034680072975, -4.965659657287152],
            [11.21364737595924, -4.974082654821712],
            [11.209098237656319, -4.978701786666091],
            [11.20461230969371, -4.98587708562743],
            [11.204849517762272, -4.988692208012806],
            [11.210124077636122, -4.997031040967374],
            [11.214017738132142, -4.999132584954103],
            [11.221455966226879, -5.008152743437573],
            [11.222665822121034, -5.016357496543213],
            [11.224988765616779, -5.019946908685244],
            [11.225700695520445, -5.02525985311363],
            [11.219927885285514, -5.0372829217623485],
            [11.211838799921967, -5.038034479910897],
            [11.209812697102441, -5.046314581285155],
            [11.210276545566684, -5.052281122817147],
            [11.21368952643559, -5.060470759657895],
            [11.213099635943191, -5.065941368970267],
            [11.210739011472397, -5.066802406988946],
            [11.203416722749795, -5.061444000451436],
            [11.198947750189355, -5.064199404619229],
            [11.197408504898258, -5.059103899045006],
            [11.193384160531265, -5.055817574713715],
            [11.191123662040534, -5.056406472004331],
            [11.18973808438416, -5.049469858501239],
            [11.185560512481722, -5.050516756520079],
            [11.18221753733749, -5.046902495157626],
            [11.178193895344787, -5.044870826470034],
            [11.172678723733661, -5.044516660781264],
            [11.170393118406155, -5.037127334713578],
            [11.162564633204608, -5.034734634809844],
            [11.165292044482475, -5.030849677610614],
            [11.160076493848834, -5.03040145399174],
            [11.16337314012365, -5.026570752129599],
            [11.161078029398134, -5.021895647460789],
            [11.156067607064971, -5.020027252242843],
            [11.155500867444166, -5.015341976629828],
            [11.15332391566154, -5.013352899426314],
            [11.141358225445218, -5.013403395128172],
            [11.139245872411108, -5.0155481805910656],
            [11.141800503505289, -5.021962151200023],
            [11.137584967170817, -5.025257803150581],
            [11.132104805804587, -5.020588563564764],
            [11.117769100484635, -5.038109459138661],
            [11.134317330805583, -5.053901380922804],
            [11.124223580606357, -5.053804399138526],
            [11.110801496410591, -5.050787335181329],
            [11.107608432799733, -5.045765295781422],
            [11.104059447889256, -5.0445916088043],
            [11.099489120962724, -5.0465518255946105],
            [11.096236531094995, -5.044865415284457],
            [11.073362170617486, -5.05967402476021],
            [11.047943005102034, -5.076547513570029],
            [11.053095918183946, -5.080496867567029],
            [11.044065779485384, -5.093888456426816],
            [11.033102486357837, -5.085430385300928],
            [10.97872537169439, -5.118729891597832],
            [10.934768305258755, -5.010703017077696],
            [10.928242065810602, -4.995614011806619],
            [10.906532204027844, -4.939517072099075],
            [10.902634936919908, -4.9275884050600665],
            [10.885280290950902, -4.868969551221928],
            [10.890462256265268, -4.871556565127314],
            [10.893197823233772, -4.874621609079471],
            [10.899576103875598, -4.8737904345961836],
            [10.903956645538177, -4.866578542100644],
            [10.906515558589362, -4.869103101340072],
            [10.911074906034242, -4.868628878807764],
            [10.919293949466459, -4.864446068592428],
            [10.92012091210818, -4.868778027502223],
            [10.926372415606917, -4.87291641098305],
            [10.93107698691851, -4.872101998461979],
            [10.932259451101643, -4.876271141165525],
            [10.936331003780802, -4.874788934751246],
            [10.941482515700159, -4.878046725469623],
            [10.942611695992728, -4.876289448263061],
            [10.939990086666336, -4.867209392922389],
            [10.949323004717195, -4.867302820685823],
            [10.95546264935676, -4.8740332860865125],
            [10.961519010829855, -4.872226136979887],
            [10.968822783851614, -4.8759234481396465],
            [10.97119659693133, -4.872377306870818],
            [10.969748514671602, -4.868070915432787],
            [10.974689497531692, -4.869249100075005],
            [10.977107780807142, -4.872763908125724],
            [10.980244724782954, -4.868551713033998],
            [10.97991897543056, -4.864801582333868],
            [10.976780895925042, -4.862214868079506],
            [10.981578785663979, -4.859617978538196],
            [10.989149355018366, -4.85977243698042],
            [10.99174387571099, -4.8547446156241145],
            [10.99558179346869, -4.85020576316743],
            [10.998755354392234, -4.848758312921064],
            [11.012746082258817, -4.850058440848393]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.24956472021547, "lat": 33.0692688838877 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13009"],
        "coty_name": ["Baldwin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baldwin County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00345255"
      },
      "bbox": [
        10.885280290950902, -5.118729891597832, 11.225700695520445,
        -4.84692280337255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.699241206279945, -4.113317632932402],
            [9.763523289108065, -4.1067810416710095],
            [9.792135053697356, -4.104002084402657],
            [9.791682839752603, -4.09982585451401],
            [9.798977774675443, -4.099123535498496],
            [9.799410540392296, -4.103265664169417],
            [9.821417251824936, -4.101347452762602],
            [9.880876286274736, -4.0956302113960605],
            [9.880413431730178, -4.0917123433302685],
            [9.883984607008795, -4.0913040461385295],
            [9.884445020243314, -4.095234362131222],
            [9.942895421795201, -4.089640031828525],
            [9.960198930914144, -4.087769437105101],
            [9.962279454263182, -4.106119308685614],
            [9.9646203899903, -4.1094177771896385],
            [9.969651360689824, -4.110867597556257],
            [9.970535568356178, -4.118631007347646],
            [9.979931398951166, -4.129191956816358],
            [9.9807635397769, -4.1352381208619144],
            [9.982923908604562, -4.136099723156069],
            [9.983399741237466, -4.14205066723583],
            [9.982351468799045, -4.147403312195685],
            [9.983595297752112, -4.1515257963094285],
            [9.987800427021313, -4.153830967529009],
            [9.993419842032615, -4.162855571214529],
            [9.996618970603699, -4.1652581614205015],
            [10.002173850129582, -4.165709529064483],
            [10.00706935756347, -4.170624276717704],
            [10.00762223718217, -4.178150800176384],
            [10.005378745037413, -4.1844264172350885],
            [10.000910419505162, -4.186533013804625],
            [10.00274228021933, -4.194228531016244],
            [9.99770829692686, -4.202135088464126],
            [9.991404092511887, -4.208855121950819],
            [9.987365688322983, -4.215909844752447],
            [9.978855658702278, -4.22832886468199],
            [9.968989692121887, -4.237205975690854],
            [9.964362373973865, -4.239697612435321],
            [9.962317035877579, -4.246095056813327],
            [9.95725074761794, -4.251424121231813],
            [9.957137787830499, -4.255881262282253],
            [9.962815357135222, -4.263202653484695],
            [9.961654840554862, -4.267516102358889],
            [9.964373358750947, -4.272352716223474],
            [9.962252825031728, -4.275709212445448],
            [9.964049836293986, -4.283985801502752],
            [9.958748767166357, -4.291489370375437],
            [9.955412733484348, -4.299188342754658],
            [9.957395374385825, -4.305480665576245],
            [9.953547159884636, -4.311893554024119],
            [9.955444153564974, -4.318640414928182],
            [9.955213775083367, -4.326586126505262],
            [9.960768091398363, -4.335879962179914],
            [9.958121117515306, -4.33999181427117],
            [9.95404201107866, -4.337920801344675],
            [9.947891734476995, -4.33946804997886],
            [9.941230686550288, -4.349219530859944],
            [9.937273381290943, -4.353444973147409],
            [9.932245631971911, -4.356323710249448],
            [9.927019317930352, -4.364540259881325],
            [9.924937127081662, -4.369612943101993],
            [9.919372326413502, -4.376580533630013],
            [9.908469100471178, -4.385180925676465],
            [9.903767218857954, -4.389703379590006],
            [9.899720330846334, -4.401171482859209],
            [9.886870168180392, -4.413057039913818],
            [9.874491615763922, -4.429393512834147],
            [9.870289935933094, -4.432536654946556],
            [9.870125564825198, -4.43059604527687],
            [9.854817916421172, -4.411629706548082],
            [9.832717373482495, -4.385217723005293],
            [9.826245824525547, -4.3759373677352595],
            [9.816873123234258, -4.376713880812063],
            [9.742971176338989, -4.384316656899588],
            [9.740978443905682, -4.373824275511684],
            [9.735264822628121, -4.323990229540389],
            [9.733525102623277, -4.3057074897744005],
            [9.729284562606527, -4.268357836033893],
            [9.727087812158862, -4.243361674442928],
            [9.713491460625585, -4.244762352006341],
            [9.711035981527898, -4.224294440543996],
            [9.707388752253616, -4.189793537569874],
            [9.704230781900156, -4.16271071509912],
            [9.699181882124774, -4.11431861538036],
            [9.699241206279945, -4.113317632932402]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.5767455701131, "lat": 33.9415421093984 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13067"],
        "coty_name": ["Cobb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cobb County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01686112"
      },
      "bbox": [
        9.699181882124774, -4.432536654946556, 10.00762223718217,
        -4.087769437105101
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.090285368135193, -4.189163468496562],
            [10.09216772901044, -4.192493765381621],
            [10.095092925160122, -4.190312480192188],
            [10.10045488826446, -4.197976008896551],
            [10.097606675000309, -4.200104372561713],
            [10.09885405772604, -4.205790126872593],
            [10.102996652841778, -4.212942013863997],
            [10.109201315772848, -4.226019384897026],
            [10.116157545467392, -4.232548673028477],
            [10.133880652941166, -4.240088661774764],
            [10.141011368205799, -4.248399422315941],
            [10.14814377668887, -4.25480493871895],
            [10.162883650876585, -4.266990069417446],
            [10.16618661074056, -4.2666832729983595],
            [10.169729213642382, -4.270021607576535],
            [10.181829782600081, -4.272294364489965],
            [10.185989901261989, -4.276481414732007],
            [10.197722798640289, -4.280805383174937],
            [10.200266859129307, -4.280806613280744],
            [10.204531186971552, -4.285837272823339],
            [10.208156519703786, -4.287644006482719],
            [10.213527274038768, -4.293741708072674],
            [10.220041981556342, -4.2954508402530305],
            [10.223274617824272, -4.2983296207698825],
            [10.224810639083467, -4.302286273548001],
            [10.235814854224769, -4.313614998782209],
            [10.24286046481667, -4.322146276961517],
            [10.25668610171135, -4.328725663709838],
            [10.262835201081918, -4.33482464885682],
            [10.266424998477646, -4.336904668514231],
            [10.277332011290042, -4.348187375014918],
            [10.281695625646874, -4.350143103590172],
            [10.292429056540136, -4.3510860389626504],
            [10.297866012497954, -4.356175730448413],
            [10.305942407335218, -4.359972530264786],
            [10.3089802172004, -4.364245321707228],
            [10.315651518715258, -4.365023357149572],
            [10.32319331659681, -4.367411951021675],
            [10.310536612293992, -4.38252742122887],
            [10.29955811245392, -4.396916127019548],
            [10.287149266845143, -4.440280505981141],
            [10.265139605973589, -4.514534580454258],
            [10.26495526434559, -4.5106072304733935],
            [10.261486771132983, -4.507248167315683],
            [10.253595402542691, -4.503735397177527],
            [10.252026124744848, -4.499273998190562],
            [10.244138214793955, -4.500803262174478],
            [10.239391941087938, -4.495845409010257],
            [10.232851873582636, -4.493936643784741],
            [10.229513664341525, -4.487539430409951],
            [10.226275150741634, -4.489225934182536],
            [10.225277748781561, -4.4958761745358675],
            [10.217595135614067, -4.495558828682765],
            [10.214809952210338, -4.494209264811445],
            [10.216612815331242, -4.488992793377836],
            [10.205125686414704, -4.490167712698336],
            [10.172422571838156, -4.4938150507452],
            [10.17417130998042, -4.5097006611824435],
            [10.156755012854783, -4.5117870812882135],
            [10.15448245165234, -4.495686218409355],
            [10.125001411081332, -4.498944455966886],
            [10.068736361341177, -4.5052284909596425],
            [10.063760043802992, -4.460646283128716],
            [10.055097959128592, -4.388513373990705],
            [10.05259432654646, -4.361651498161499],
            [10.050362117235474, -4.346324335202936],
            [10.040312791023355, -4.262860250814268],
            [10.035298806930426, -4.218496405959332],
            [10.03228642430584, -4.194604572042],
            [10.032591978064842, -4.187766517393466],
            [10.039429404181233, -4.182003301360865],
            [10.049876799696383, -4.1843938732619845],
            [10.053922802842735, -4.183772059626048],
            [10.059747243554071, -4.185045933887042],
            [10.069222574685034, -4.189283182081268],
            [10.07612269895343, -4.188776867166251],
            [10.08451036043105, -4.1911094992771405],
            [10.090285368135193, -4.189163468496562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.2264422095167, "lat": 33.77156394455938 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13089"],
        "coty_name": ["DeKalb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeKalb County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01687424"
      },
      "bbox": [
        10.03228642430584, -4.514534580454258, 10.32319331659681,
        -4.182003301360865
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.233506815118323, -6.528503805058207],
            [10.361929182630089, -6.512734827731772],
            [10.40089476786178, -6.507312003581098],
            [10.460300997105037, -6.499953227750547],
            [10.489397277347011, -6.495938017142055],
            [10.503383299235857, -6.494288117916482],
            [10.53544489673092, -6.48998249084201],
            [10.547748110526687, -6.487774045915345],
            [10.575940522557291, -6.484500847670593],
            [10.577296577542505, -6.472487929369316],
            [10.579380898397153, -6.470729326291933],
            [10.58046877434968, -6.465750730222817],
            [10.583941004697285, -6.464136225813541],
            [10.584846127507372, -6.458451176633516],
            [10.593439806471457, -6.455444270426133],
            [10.614518921791202, -6.453028317371923],
            [10.615533946560918, -6.461564754019028],
            [10.607578571812423, -6.4622796164307035],
            [10.608444288607403, -6.470289446198187],
            [10.60050111491338, -6.471306710427373],
            [10.601480140652694, -6.480264505717054],
            [10.615250886181261, -6.477961105626407],
            [10.61821323575116, -6.504982601396347],
            [10.61923321964101, -6.5105219074493625],
            [10.622776530833304, -6.538997279493765],
            [10.635395987622628, -6.537601499677792],
            [10.63616634111973, -6.549271229968854],
            [10.62419333353124, -6.550739171165909],
            [10.633083715226778, -6.625677103089919],
            [10.64578250859392, -6.624270635304115],
            [10.647226116552856, -6.636487816770739],
            [10.634579580534314, -6.638794316083775],
            [10.636885760479286, -6.6576212710550635],
            [10.582716772457195, -6.6651118621244585],
            [10.537426128542087, -6.671182031021486],
            [10.518998544187241, -6.673480442641904],
            [10.516481463771976, -6.676304231270708],
            [10.457418080268441, -6.683389804896454],
            [10.457589499907735, -6.687962308616573],
            [10.343158623634881, -6.7015918728521235],
            [10.338699467337003, -6.702433800167603],
            [10.278020221330124, -6.709116988569236],
            [10.273361468680315, -6.709751473676851],
            [10.274549512965025, -6.707322054837367],
            [10.275207060199525, -6.698253360597808],
            [10.278702983965994, -6.6973381888712975],
            [10.285528238753738, -6.687912493164982],
            [10.279117225873964, -6.675936844922929],
            [10.271544605934332, -6.652925166138978],
            [10.26942647966113, -6.649033479342477],
            [10.26622828392145, -6.647270227899974],
            [10.262347080077513, -6.639979760840167],
            [10.25773877065244, -6.638585394195336],
            [10.25637434737266, -6.635562207644882],
            [10.25478366913465, -6.626515069034887],
            [10.252373431456851, -6.620829536069595],
            [10.249528612876915, -6.617532646346223],
            [10.246189976180558, -6.609515869288137],
            [10.24553046646973, -6.605098468420353],
            [10.23864536091313, -6.601780822250404],
            [10.237303070402223, -6.593912109877435],
            [10.237227360777801, -6.586888396620965],
            [10.238227643872104, -6.583063149698987],
            [10.23800973992229, -6.576477432607622],
            [10.234986207986918, -6.569332442436406],
            [10.231993882590876, -6.566702618797128],
            [10.234353377326375, -6.557728717039779],
            [10.237459292680255, -6.552580291231495],
            [10.236320425762534, -6.549933626573752],
            [10.238192654148055, -6.545992938726062],
            [10.233506815118323, -6.528503805058207]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.21641100126254,
          "lat": 31.533458761246095
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13095"],
        "coty_name": ["Dougherty"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dougherty County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00351259"
      },
      "bbox": [
        10.231993882590876, -6.709751473676851, 10.647226116552856,
        -6.453028317371923
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.60054771819381, -4.427084232937821],
            [9.619715989307444, -4.430851740546864],
            [9.657628609412923, -4.425124064651363],
            [9.657335504631714, -4.422627316734353],
            [9.684091880177647, -4.418071017354212],
            [9.683477390213657, -4.415771960578022],
            [9.71275383511498, -4.407163739151719],
            [9.720239147644318, -4.406501466827962],
            [9.730999516110922, -4.403761831495482],
            [9.745110268561122, -4.402049690810654],
            [9.742971176338989, -4.384316656899588],
            [9.816873123234258, -4.376713880812063],
            [9.826245824525547, -4.3759373677352595],
            [9.832717373482495, -4.385217723005293],
            [9.854817916421172, -4.411629706548082],
            [9.870125564825198, -4.43059604527687],
            [9.870289935933094, -4.432536654946556],
            [9.867251775597747, -4.439269026164936],
            [9.864756627761873, -4.447916310199263],
            [9.858616565505582, -4.448762949128196],
            [9.853816806828233, -4.453363501196927],
            [9.853015139853893, -4.458841832721554],
            [9.849324931894218, -4.466162871135547],
            [9.84340863431572, -4.4702107091560945],
            [9.839512304456045, -4.475836272978369],
            [9.831079024255265, -4.481090936566078],
            [9.833591997096049, -4.490907431322297],
            [9.825924457407023, -4.498398418142488],
            [9.818946214433074, -4.497109784530038],
            [9.816187183064804, -4.499765786014588],
            [9.81637450706066, -4.508238165838196],
            [9.818726964204764, -4.515339064931766],
            [9.81605428334657, -4.524254193117848],
            [9.81223925007323, -4.5271370971015585],
            [9.802039637483244, -4.528897213263698],
            [9.792922702596437, -4.535408798326154],
            [9.773212240199502, -4.542508691433674],
            [9.768672262991235, -4.5476987340727115],
            [9.762005429500539, -4.551119956598811],
            [9.758387148447275, -4.55427964519653],
            [9.757775326120441, -4.5596097884574345],
            [9.755143037320657, -4.5666932010925905],
            [9.749522538442461, -4.5675764902300156],
            [9.743513058563128, -4.560796497279229],
            [9.74061096842913, -4.565083465499221],
            [9.733895556556854, -4.579728429737873],
            [9.72417610877479, -4.585477380499716],
            [9.714804870073396, -4.59705805173853],
            [9.708642557699678, -4.601536082904579],
            [9.702237993503461, -4.6115632509305895],
            [9.70120055194172, -4.615054665267186],
            [9.70100371503318, -4.624177107648209],
            [9.68844402063022, -4.626178539477117],
            [9.688113775837529, -4.623195224147243],
            [9.683414470644466, -4.623672597772666],
            [9.683697963290804, -4.626530013466633],
            [9.621506996920417, -4.63422404945577],
            [9.618506848624232, -4.602387133992244],
            [9.61557097026025, -4.567718811748575],
            [9.615021292521705, -4.557537161324377],
            [9.608484242863964, -4.493399051316945],
            [9.607540318897232, -4.485631441312549],
            [9.599767856961074, -4.486426775225005],
            [9.598870167822392, -4.4775748156123605],
            [9.605900361402112, -4.477120041635814],
            [9.60398188196455, -4.458716039592475],
            [9.60307979636098, -4.446239012373927],
            [9.60054771819381, -4.427084232937821]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.76793383267437, "lat": 33.70187262458273 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13097"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01686467"
      },
      "bbox": [
        9.598870167822392, -4.63422404945577, 9.870289935933094,
        -4.3759373677352595
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.997284697600884, -3.751105992686625],
            [11.00258380152344, -3.74492149792758],
            [11.002407591292004, -3.6758040969554426],
            [10.992703602287635, -3.679516298472419],
            [10.993487128682178, -3.6069148682044494],
            [11.010470962807105, -3.5479556625347946],
            [11.01742583470116, -3.5245944029412866],
            [11.019622903051284, -3.5246184858071463],
            [11.024442616132735, -3.5285421273087314],
            [11.033543231601149, -3.533385173148593],
            [11.036675071482852, -3.53188248713772],
            [11.048934973226215, -3.536669615012885],
            [11.062682283240713, -3.540196412294077],
            [11.067405724664955, -3.5326807407920833],
            [11.076994633041654, -3.5275733490592662],
            [11.081400380080726, -3.530611302735266],
            [11.090166762025582, -3.5243123965668746],
            [11.09463197597077, -3.5285816637410603],
            [11.097024164349257, -3.5289151926616102],
            [11.102862076057702, -3.526494178464703],
            [11.105603957151096, -3.521013870753058],
            [11.11101782676145, -3.5193860174881904],
            [11.116247645382057, -3.5194084092148192],
            [11.120580280957851, -3.5228709181642275],
            [11.127052113703838, -3.519419709740449],
            [11.139801362691678, -3.5150188752293046],
            [11.147828830084734, -3.5195693942351576],
            [11.152068499847706, -3.5192166156138533],
            [11.15867661382625, -3.527517170708627],
            [11.158701847659216, -3.529958742103095],
            [11.165314813133374, -3.534132862953922],
            [11.167408619863183, -3.5371722084724815],
            [11.172796062621172, -3.5373082829205935],
            [11.178776798349693, -3.541657509396616],
            [11.178064729955508, -3.544174043525572],
            [11.183378397814794, -3.554791672051276],
            [11.186356126967704, -3.5674236991532147],
            [11.190346477882672, -3.570058732882106],
            [11.193426876269736, -3.576028893283998],
            [11.194008408538282, -3.5833935412501425],
            [11.200687986305013, -3.5957476584855605],
            [11.201992694362556, -3.604542131407238],
            [11.207640550146, -3.61312744623914],
            [11.210621458270104, -3.627548823938659],
            [11.212156254414072, -3.6297220944494573],
            [11.219472134835339, -3.6322982426021575],
            [11.243269845022358, -3.647780547413907],
            [11.246739591763847, -3.6486411514427317],
            [11.250882495971023, -3.6577442861072793],
            [11.250808664550016, -3.662110751628706],
            [11.256955899471592, -3.677483489239584],
            [11.262564974518565, -3.685195794714443],
            [11.263157446889332, -3.6896792241766154],
            [11.270970395859075, -3.6979324522205794],
            [11.26312543671019, -3.7034195537613694],
            [11.25710324735114, -3.705278986420006],
            [11.251138633580393, -3.7106294336494248],
            [11.247468818137271, -3.7112021857030135],
            [11.238624128325172, -3.715258112108942],
            [11.232858784555663, -3.7216259870576383],
            [11.227496268749874, -3.7237737845746164],
            [11.22003998873172, -3.72518776733926],
            [11.213693178946285, -3.7301267440606916],
            [11.161546671333975, -3.7548085955126314],
            [11.130414553370061, -3.788693601584683],
            [11.12419711416339, -3.787570463507071],
            [11.113414918192639, -3.7981741193214975],
            [11.110249171870892, -3.798492737267724],
            [11.099790086913497, -3.7923272061351545],
            [11.105570635030567, -3.786126430267593],
            [11.095313170675956, -3.7807965130894208],
            [11.079523667782995, -3.7799080192295564],
            [11.049661822963412, -3.7901077551617406],
            [11.033894778397885, -3.7979915103018698],
            [11.032826410501299, -3.7969336019982816],
            [10.996817741145936, -3.7627457026435187],
            [10.997284697600884, -3.751105992686625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.96421845708558,
          "lat": 34.350910053486345
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13147"],
        "coty_name": ["Hart"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hart County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01687995"
      },
      "bbox": [
        10.992703602287635, -3.798492737267724, 11.270970395859075,
        -3.5150188752293046
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.344575615878567, -5.194544770142995],
            [10.401901933986522, -5.188046060808075],
            [10.400310299716264, -5.17154546655339],
            [10.408161187106671, -5.170715657714255],
            [10.403447660375594, -5.128756873018677],
            [10.38987647980618, -5.012697810557678],
            [10.388291188890117, -4.994115013454249],
            [10.387492412561084, -4.989700024532514],
            [10.383088654688207, -4.952111246432098],
            [10.378150408909082, -4.917064464947356],
            [10.417832113186854, -4.912268764933488],
            [10.471485851653664, -4.90597254162349],
            [10.51381451204927, -4.900093138418019],
            [10.521210773587006, -4.899606751754335],
            [10.52338464431941, -4.90106284497631],
            [10.528713423421893, -4.900101025822038],
            [10.535284421861613, -4.905027474607056],
            [10.54002589307807, -4.902012653365934],
            [10.545310916532335, -4.903443693667159],
            [10.545532859964903, -4.905902698144886],
            [10.553061341609844, -4.913301679537923],
            [10.561805949521798, -4.916342572772137],
            [10.56048065182345, -4.921161888955922],
            [10.561796014555153, -4.925648297189201],
            [10.562423523225632, -4.934405842929227],
            [10.564133550484476, -4.938674595114422],
            [10.572662234784381, -4.947079626721748],
            [10.570902657344051, -4.954302111963424],
            [10.573160481990342, -4.9638434528773505],
            [10.573834612702747, -4.9710897247201995],
            [10.577021461519198, -4.973310037863606],
            [10.583188824282004, -4.972939193341481],
            [10.58917990309035, -4.9771906227164795],
            [10.592872679155395, -4.983243670813174],
            [10.594227997672442, -4.988902682664618],
            [10.60299489181561, -4.995032232159342],
            [10.607109043314432, -4.99920953257627],
            [10.609209596639156, -5.004956183923766],
            [10.614198661817845, -5.011249514609685],
            [10.623599520321504, -5.015455269912886],
            [10.628329891628987, -5.019680383096578],
            [10.633481809523765, -5.020848361740654],
            [10.638987698668224, -5.024560313459792],
            [10.64384767215855, -5.034459244633041],
            [10.648245962121207, -5.038303528290908],
            [10.649519898138667, -5.042919393430703],
            [10.66083326310659, -5.052778372430953],
            [10.665474280646603, -5.061580906973542],
            [10.664730358674632, -5.065082703008977],
            [10.659946332801164, -5.070761739279082],
            [10.662878259470183, -5.077912021081419],
            [10.667842318430282, -5.080252654426777],
            [10.67020646828375, -5.0834945734947725],
            [10.666779677445952, -5.08840159766919],
            [10.667003870096691, -5.093530498088886],
            [10.66981235078171, -5.097129260209229],
            [10.670649296927207, -5.109102171597908],
            [10.674873506070922, -5.11127229579257],
            [10.676826335423442, -5.114383132929797],
            [10.683718027669721, -5.116579391333193],
            [10.686012982396305, -5.121585211335449],
            [10.683328808919347, -5.13060043783487],
            [10.667116396206865, -5.134492210572453],
            [10.66792321170709, -5.140424284939579],
            [10.671806004830307, -5.140062644742633],
            [10.642018037376756, -5.1671223859445385],
            [10.638114875817312, -5.1719522835684515],
            [10.633664815987716, -5.17515274000439],
            [10.59130469035338, -5.213306776395331],
            [10.546788827444072, -5.253672795171018],
            [10.483361081235437, -5.261223067026658],
            [10.482402592882142, -5.252986096628564],
            [10.474285820263571, -5.254014370892991],
            [10.475078082987475, -5.26219561202221],
            [10.451698038219627, -5.264922404784462],
            [10.354162084084754, -5.276780751866453],
            [10.344575615878567, -5.194544770142995]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.91860227408195, "lat": 33.01391760452451 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13207"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "207",
        "coty_gnis_code": "00343073"
      },
      "bbox": [
        10.344575615878567, -5.276780751866453, 10.686012982396305,
        -4.899606751754335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.532402233762628, -3.2129131831321103],
            [9.560310753532915, -3.209417135717603],
            [9.599341247718197, -3.2045599938219835],
            [9.682020761152119, -3.1947204201042183],
            [9.684760971513402, -3.1940353546854263],
            [9.699538146755657, -3.3253104545051326],
            [9.703071407472873, -3.3266433542855274],
            [9.70857822115569, -3.3301420913897766],
            [9.715703663052622, -3.340440294933032],
            [9.719332060226924, -3.3421585638206732],
            [9.72393133438071, -3.340666143651529],
            [9.728218615142056, -3.343526571199079],
            [9.729216581934438, -3.3488068904857524],
            [9.736235580374277, -3.3538900973589367],
            [9.73389376259667, -3.358346795364687],
            [9.732791957481261, -3.3639873588621847],
            [9.728202445833618, -3.366869035599038],
            [9.728829871421082, -3.3714180784546053],
            [9.727322096887852, -3.373995484533348],
            [9.722906205221243, -3.3738921256229424],
            [9.722741474621603, -3.380979924678168],
            [9.71906140985994, -3.3847277914635088],
            [9.718023496629543, -3.390205880854659],
            [9.708348288713205, -3.393202379782536],
            [9.707792162983834, -3.39672943635126],
            [9.704100690119562, -3.3982898160480515],
            [9.694059150486755, -3.4064956909686854],
            [9.699763016037462, -3.41570752912667],
            [9.698069925749964, -3.4187390366322847],
            [9.699248211958425, -3.423621051393663],
            [9.69835924434928, -3.430452993011533],
            [9.695362050326922, -3.430977496050095],
            [9.691734011280968, -3.4387334688453417],
            [9.690916112764269, -3.4471287770240187],
            [9.689392303900393, -3.453813167502986],
            [9.68718407685012, -3.4567921945907254],
            [9.696658413832633, -3.519836929421763],
            [9.702146998671381, -3.560353282080752],
            [9.702785155632535, -3.568584337032266],
            [9.70676433290119, -3.6021400258218486],
            [9.684498276837914, -3.6046521381722165],
            [9.683685699120616, -3.598162296788462],
            [9.66471625904035, -3.599480683919454],
            [9.66357263801708, -3.591825318219924],
            [9.642733839299801, -3.5941465758921716],
            [9.64099565340559, -3.580052006761855],
            [9.647652873440567, -3.57921159779177],
            [9.648796104311014, -3.5869037443642564],
            [9.655610726618821, -3.58604703787786],
            [9.654160787317464, -3.5721155541312855],
            [9.652426047752337, -3.56840635994765],
            [9.644552788792495, -3.570585725259866],
            [9.635333559806393, -3.569401740395846],
            [9.62886213795438, -3.5702343336546547],
            [9.628196083905873, -3.5721627926639377],
            [9.629184099112871, -3.5833411688978587],
            [9.627551495962145, -3.585321479623247],
            [9.62106172431263, -3.585168457637274],
            [9.61591529283177, -3.581340482011293],
            [9.612065150777362, -3.580720735958182],
            [9.602242723735353, -3.5844326179462787],
            [9.60231363655584, -3.5891035546317114],
            [9.534068077633027, -3.5968727902983524],
            [9.5331307310222, -3.589726592399445],
            [9.497178880492424, -3.5939111993915933],
            [9.49499414663404, -3.5756548257094085],
            [9.490806340006367, -3.5760768268501355],
            [9.490506033001687, -3.5708597671162727],
            [9.484053946017381, -3.567015402228362],
            [9.479877852441502, -3.5596595042370174],
            [9.476140647298118, -3.545841661429908],
            [9.474968898812334, -3.5444779864265303],
            [9.467343983584374, -3.544050024347673],
            [9.46086160246479, -3.5365923644904407],
            [9.460404831494996, -3.533111610798894],
            [9.46826842266351, -3.535909526886073],
            [9.472735440500132, -3.5358297437079225],
            [9.480366304080164, -3.5296998134040387],
            [9.487664301870119, -3.5285272135489287],
            [9.493443137104334, -3.53702082310004],
            [9.496571139105953, -3.5434757240700754],
            [9.50161118362037, -3.5440365066635446],
            [9.507083091818101, -3.540092129126351],
            [9.506092038857805, -3.5294434239156334],
            [9.500527971492847, -3.5285188337654274],
            [9.492311671533352, -3.524288026229074],
            [9.488597142015347, -3.5182712884798644],
            [9.481499444353593, -3.51351031148393],
            [9.47310256174686, -3.510949359500383],
            [9.465867754204387, -3.5053600431594494],
            [9.46547098257734, -3.49913723838262],
            [9.472694975471473, -3.495057033017931],
            [9.500666648195596, -3.5031641629771593],
            [9.503947517348276, -3.4984729182257803],
            [9.505674791343834, -3.4926300962933836],
            [9.516267574119961, -3.4957688118740444],
            [9.521494979721242, -3.498281096000433],
            [9.525276365235463, -3.489702398987256],
            [9.526988908462005, -3.480801063413275],
            [9.522014944935755, -3.4801666045115223],
            [9.512043518616684, -3.472300272598101],
            [9.513011824119179, -3.4683305622093616],
            [9.519158969553072, -3.4720392106555757],
            [9.524084255613129, -3.4683430761754557],
            [9.52496051155936, -3.4640231485307003],
            [9.522758559067675, -3.4594093865085416],
            [9.525373331813022, -3.4558335591468183],
            [9.521604610148978, -3.449663829790971],
            [9.518848308346062, -3.448352075787592],
            [9.515068209241534, -3.450512023724028],
            [9.512749537786004, -3.446091047247919],
            [9.512937327898818, -3.4391175979608923],
            [9.505041241805237, -3.434654043089158],
            [9.501849097396391, -3.4280386738239876],
            [9.506064213172133, -3.4241568571021594],
            [9.504224788973792, -3.4193681070478],
            [9.505572499820259, -3.417157533904469],
            [9.509645370768132, -3.42141237161255],
            [9.513549998794245, -3.4215729298887196],
            [9.514232323834912, -3.417963671999427],
            [9.518473096810691, -3.411862357369745],
            [9.531810979782918, -3.4069825858740286],
            [9.5321962418979, -3.402214949826467],
            [9.528309908388291, -3.398122590907159],
            [9.523472520399146, -3.3993659785447328],
            [9.51543061852041, -3.398897889757304],
            [9.510540733945911, -3.391381288479498],
            [9.516386694750452, -3.3847463334665218],
            [9.518113137841032, -3.380621645297491],
            [9.519767511820595, -3.372417391225143],
            [9.515223437626535, -3.362576375585598],
            [9.51873951634622, -3.3576864333201235],
            [9.518837872247174, -3.354195967212625],
            [9.52141242017914, -3.350247772779363],
            [9.526793478795843, -3.348369307918693],
            [9.521569829311193, -3.342244425888232],
            [9.52363393744769, -3.340291263560278],
            [9.528309342482043, -3.3435175855326458],
            [9.535156331490315, -3.340197547433508],
            [9.539717065071354, -3.33408916194548],
            [9.539020271153234, -3.326729464239768],
            [9.530216156890669, -3.316221120821388],
            [9.524697873215095, -3.3059451240676565],
            [9.529578903391414, -3.3034466479855356],
            [9.53156185641938, -3.300064989525798],
            [9.525284936405875, -3.2958191720603423],
            [9.520937631177517, -3.295187869970087],
            [9.52016116957915, -3.2901079591762],
            [9.51460999680314, -3.285457513763547],
            [9.515885155321968, -3.2774442227636906],
            [9.515824085350557, -3.270325206737861],
            [9.51767138562047, -3.2672556678412676],
            [9.517744163263435, -3.2600396101157947],
            [9.52137365021683, -3.2541400176771007],
            [9.524779019184859, -3.244995720386241],
            [9.527246394150303, -3.243019565890592],
            [9.525721078741304, -3.2382759435336452],
            [9.52943057978042, -3.2356735404270576],
            [9.531629729667735, -3.228686497531342],
            [9.53018577821048, -3.2249978704436497],
            [9.530674714899646, -3.2143716305820735],
            [9.532402233762628, -3.2129131831321103]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.74802237929553, "lat": 34.78846587280103 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13213"],
        "coty_name": ["Murray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Murray County"],
        "coty_fp_code": "213",
        "coty_gnis_code": "01688005"
      },
      "bbox": [
        9.460404831494996, -3.6046521381722165, 9.736235580374277,
        -3.1940353546854263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.914400362759544, -6.497186338141685],
            [10.91104006787401, -6.468957762089402],
            [10.927947329958117, -6.466485738161971],
            [10.935988153050188, -6.46585001522952],
            [10.947714284632648, -6.462722716700803],
            [10.961776426390317, -6.463648181220693],
            [10.9734075625468, -6.460510293761322],
            [10.999909214199944, -6.457949239485131],
            [11.010139733028657, -6.457962194472535],
            [11.036062928892875, -6.455115756053485],
            [11.038996867832203, -6.478756242086147],
            [11.064434198498512, -6.476139637891313],
            [11.066118882240591, -6.489437527917248],
            [11.108769189820372, -6.486303055740433],
            [11.11632705222998, -6.490729672674985],
            [11.117698348295198, -6.492871992896891],
            [11.123714407370942, -6.4967059379891765],
            [11.127748913351336, -6.504020473418104],
            [11.131582631865493, -6.505828203436592],
            [11.13539013420351, -6.51833996471087],
            [11.140211759316584, -6.52120784969567],
            [11.143126633121604, -6.524724874558715],
            [11.144857770441678, -6.533100296154875],
            [11.149887969972673, -6.547569449697474],
            [11.15511922887613, -6.551842098677084],
            [11.160040132819379, -6.548892519246959],
            [11.168103127663564, -6.548150428170075],
            [11.169549287828556, -6.549979830955793],
            [11.182444362868033, -6.554181823547937],
            [11.187995774589703, -6.553767966423534],
            [11.189066674983874, -6.564623834816036],
            [11.163528224881917, -6.568025561877325],
            [11.170871330224408, -6.6313513822747785],
            [11.159167110743914, -6.633020170853929],
            [11.160625298137932, -6.645164152762671],
            [11.148316305835307, -6.646240339950049],
            [11.149677703684171, -6.659026168313602],
            [11.136876893961714, -6.661285899489054],
            [11.1384505719892, -6.6738276611572545],
            [11.126060747413124, -6.6747385688158944],
            [11.127536965081214, -6.687861778556588],
            [11.123981560425081, -6.688636164853064],
            [11.115330898203837, -6.690506334732663],
            [11.116575918212794, -6.704028294462955],
            [11.104331983836907, -6.708727030783158],
            [11.105105690772957, -6.715359075337808],
            [11.061112357421901, -6.7199966622232505],
            [10.985351375930165, -6.727560896002377],
            [10.941300101500168, -6.73235710943203],
            [10.934402626682898, -6.671897426955358],
            [10.929835031884886, -6.630028489526579],
            [10.9172477629411, -6.631407705332247],
            [10.91137085655723, -6.580914633213386],
            [10.924183092127377, -6.579652826369258],
            [10.914400362759544, -6.497186338141685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.52660596793885,
          "lat": 31.457425951749634
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13277"],
        "coty_name": ["Tift"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tift County"],
        "coty_fp_code": "277",
        "coty_gnis_code": "00344090"
      },
      "bbox": [
        10.91104006787401, -6.73235710943203, 11.189066674983874,
        -6.455115756053485
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.0943366236484895, 0.342544914829724],
            [6.08874515037854, 0.4315501781374815],
            [6.176001217530355, 0.4391012551868743],
            [6.191815775431031, 0.44000691507370704],
            [6.22885593835145, 0.4416296602144663],
            [6.292957874635446, 0.4449708752997994],
            [6.343943462475875, 0.4478366550425168],
            [6.34869338113405, 0.38873692201832777],
            [6.414022994325088, 0.38999699804728144],
            [6.428388288348009, 0.3905441968958782],
            [6.433100692326576, 0.3349430254079838],
            [6.438572108853139, 0.27324723276438856],
            [6.418700878769051, 0.2725232160911701],
            [6.417922210395157, 0.2680601702792228],
            [6.419930947901036, 0.2663231171966449],
            [6.417683412381576, 0.26071331873808296],
            [6.420913255937939, 0.256919814596072],
            [6.419200774866906, 0.24852201423811462],
            [6.419007848967021, 0.24242896966085106],
            [6.421507167504529, 0.23979774750997515],
            [6.420633484001309, 0.2352762706236352],
            [6.422008297243383, 0.22196194103602376],
            [6.426675261750411, 0.21745774324852596],
            [6.426948878573811, 0.21027603373538975],
            [6.429292006679215, 0.21013960248208147],
            [6.4329320762478845, 0.20454101130977692],
            [6.4308104584303045, 0.20303190361483425],
            [6.432748595890983, 0.19881327146457994],
            [6.430313856974457, 0.1943154091120662],
            [6.427996396669548, 0.19367285376578788],
            [6.419929029512255, 0.18154654324105007],
            [6.416710630662962, 0.17780207306463078],
            [6.415837048426706, 0.17394729204468684],
            [6.422593086491563, 0.16980880505877585],
            [6.422109145162247, 0.16503938969882762],
            [6.427743665844407, 0.16537710695133373],
            [6.426045219646489, 0.15918371116429547],
            [6.428910436706356, 0.15702999194037465],
            [6.433496424121426, 0.15627576346341823],
            [6.436312834555245, 0.16036610161247505],
            [6.438090642480697, 0.15267871080606676],
            [6.441112630350283, 0.15369502142117134],
            [6.452905396598717, 0.14749078142122007],
            [6.4558907138382295, 0.1435515492882939],
            [6.452316730914395, 0.14122721401472393],
            [6.449656832405826, 0.1406402139299884],
            [6.367080062793954, 0.13708554061172035],
            [6.3241102397228115, 0.13428890181076017],
            [6.285162506570925, 0.13236549884199247],
            [6.270519433399325, 0.1320958091389693],
            [6.212459101205433, 0.1295913566969843],
            [6.196676712760163, 0.12870217182500057],
            [6.108869734320075, 0.12062739397855614],
            [6.107097153739915, 0.1445526190870435],
            [6.102921215187349, 0.20734334433143223],
            [6.101589794879496, 0.22387269254303868],
            [6.099854340947074, 0.253380086110837],
            [6.0943366236484895, 0.342544914829724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.4902523254371, "lat": 38.75416470450417 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17025"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00424214"
      },
      "bbox": [
        6.08874515037854, 0.12062739397855614, 6.4558907138382295,
        0.4478366550425168
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.9798124384691915, 0.7286463043386724],
            [5.980466070349201, 0.7285622418489519],
            [6.050907692272158, 0.7336689632956704],
            [6.075076913201422, 0.7356481471889055],
            [6.115607421095504, 0.7385405752670731],
            [6.151010738798238, 0.7408722917992692],
            [6.235781523145957, 0.7472618061814426],
            [6.2392935050045315, 0.7034224213707887],
            [6.323682832815014, 0.7098209036101467],
            [6.330383726298617, 0.6280743271701278],
            [6.331478035876443, 0.6114831454818526],
            [6.335824225435322, 0.5387303334779479],
            [6.343943462475875, 0.4478366550425168],
            [6.292957874635446, 0.4449708752997994],
            [6.22885593835145, 0.4416296602144663],
            [6.191815775431031, 0.44000691507370704],
            [6.176001217530355, 0.4391012551868743],
            [6.08874515037854, 0.4315501781374815],
            [6.001946339516856, 0.42184637074752257],
            [5.993836327238336, 0.5374447659723729],
            [5.98618036373061, 0.6416738726587727],
            [5.983166191896612, 0.6800846210932067],
            [5.983010932534893, 0.6847208473288454],
            [5.9798124384691915, 0.7286463043386724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.58987261528824,
          "lat": 39.059781453177315
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17049"],
        "coty_name": ["Effingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Effingham County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00424226"
      },
      "bbox": [
        5.9798124384691915, 0.42184637074752257, 6.343943462475875,
        0.7472618061814426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.385750629327054, 3.946753194607181],
            [4.404138694351501, 3.947384445463459],
            [4.4494169017248195, 3.949388727757112],
            [4.496319476805739, 3.952203373290105],
            [4.544131832376999, 3.9544195179305963],
            [4.559096463000489, 3.9551282184293055],
            [4.59073120776115, 3.957152999928944],
            [4.633722069257277, 3.960136587592871],
            [4.672618293690969, 3.962528147489869],
            [4.705176636783515, 3.9647303172026684],
            [4.735639724358197, 3.967119993919511],
            [4.786372268999952, 3.9698606482693584],
            [4.801944723596657, 3.9712211378898066],
            [4.856389487810362, 3.973264440714247],
            [4.888654485504942, 3.9740110975493192],
            [4.9097161594812695, 3.9755145206577724],
            [4.910782534866662, 3.9583990530770463],
            [4.920482822141546, 3.8409958821854837],
            [4.920202137077202, 3.840819949161366],
            [4.923362084731183, 3.804470694653481],
            [4.9268351187247115, 3.7679124857658572],
            [4.930258521411449, 3.7243983806400784],
            [4.934488892049339, 3.6661989025037185],
            [4.8987536248357255, 3.663896349356324],
            [4.873875316304774, 3.6625476145852947],
            [4.820717476862496, 3.659110069221929],
            [4.796434370456498, 3.6577968513072165],
            [4.761384487030666, 3.6552347163572194],
            [4.7181320812082115, 3.6516049466008402],
            [4.642721580649611, 3.6449014978939838],
            [4.634240319777457, 3.651844536119987],
            [4.626835957954199, 3.6536924350469255],
            [4.612905527681169, 3.6550026485382636],
            [4.606599342636707, 3.6597431714192163],
            [4.599007172783622, 3.663606893083392],
            [4.586640331153541, 3.673608190352068],
            [4.583754259801484, 3.677047370950144],
            [4.58267999127312, 3.6810844934494957],
            [4.578813009181691, 3.6870566339241138],
            [4.564209143450023, 3.7014701347987744],
            [4.560004604217235, 3.713196647790304],
            [4.554325481893937, 3.7248054420198917],
            [4.554082171609847, 3.7308100770622894],
            [4.558245845139446, 3.740226520147683],
            [4.560374372940356, 3.7524750954146415],
            [4.559305492866876, 3.763214628735542],
            [4.562662937700447, 3.7700427183306235],
            [4.560054357666966, 3.7757317924017104],
            [4.5511167757169035, 3.783614867505026],
            [4.540266927594551, 3.8014515633661086],
            [4.533541201305456, 3.8051691278196853],
            [4.524105739284824, 3.8148304961646287],
            [4.519565640953518, 3.823523521069857],
            [4.516791216159485, 3.8264843109205238],
            [4.511965080149885, 3.829381026766809],
            [4.506802055665361, 3.8296098615615746],
            [4.496692382039814, 3.839485285950277],
            [4.483522192018893, 3.8462499354795563],
            [4.460563367871125, 3.855086751425952],
            [4.455299664113878, 3.85782622463355],
            [4.452713891397454, 3.8625528803851727],
            [4.450365142543265, 3.874401547854397],
            [4.446508278414555, 3.8800603457683494],
            [4.442320830390637, 3.8827975659327136],
            [4.433824901788224, 3.885065263368161],
            [4.42758324932786, 3.887783912190741],
            [4.41570732352876, 3.8911450220929704],
            [4.402111761172791, 3.8978173769141193],
            [4.384982446403153, 3.90992621198767],
            [4.379267508618973, 3.9162415048442485],
            [4.377296272902024, 3.9212597215002307],
            [4.377130784396683, 3.9293962216401344],
            [4.385750629327054, 3.946753194607181]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.21257204591298,
          "lat": 42.365773386512764
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17085"],
        "coty_name": ["Jo Daviess"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jo Daviess County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00424244"
      },
      "bbox": [
        4.377130784396683, 3.6449014978939838, 4.934488892049339,
        3.9755145206577724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.755018167176303, 2.442885192187341],
            [5.752061159421241, 2.487266608611951],
            [5.746426872281761, 2.565722339100675],
            [5.742049681651384, 2.621880627110596],
            [5.800536814186271, 2.6265897707234607],
            [5.871196279477127, 2.6324889121168815],
            [5.914845973306359, 2.636296205377613],
            [5.998685320053413, 2.6438682318597806],
            [6.0844996616554505, 2.6512542474512863],
            [6.12899063922194, 2.6562643461694324],
            [6.212617139345961, 2.6658396218023426],
            [6.247565496962641, 2.669727140517607],
            [6.260524588495152, 2.549861821239515],
            [6.2761883908413365, 2.404221536130583],
            [6.279378132645658, 2.3752127000052807],
            [6.285359519174412, 2.3168893628475478],
            [6.294500969146738, 2.2295788101543352],
            [6.295031653217018, 2.2296303111657902],
            [6.300713207440307, 2.1726503962896073],
            [6.244142211852705, 2.167328169120575],
            [6.216593544988957, 2.164980055840963],
            [6.132366741020793, 2.1582029897356367],
            [6.046134592878904, 2.150600646449418],
            [6.041343063534272, 2.2048870604127035],
            [6.035990404109198, 2.2045828099574636],
            [6.031759406513984, 2.2481456092960928],
            [6.027715010090727, 2.2917614252501113],
            [5.9559529800008715, 2.2852264233196284],
            [5.898453834108473, 2.2798004685317173],
            [5.812576758071801, 2.2719706915831708],
            [5.769629013632432, 2.2677536736362596],
            [5.762065294774231, 2.3552474612981253],
            [5.756075643810553, 2.4282017219463468],
            [5.755018167176303, 2.442885192187341]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.55773107758655, "lat": 40.89156705778696 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17105"],
        "coty_name": ["Livingston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Livingston County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00424254"
      },
      "bbox": [
        5.742049681651384, 2.150600646449418, 6.300713207440307,
        2.669727140517607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.591595940711954, 1.266165648077632],
            [4.584969736810833, 1.275416602212916],
            [4.582334623364786, 1.2814159604685147],
            [4.579862382519891, 1.2904827900318254],
            [4.578590702249474, 1.2982203446743117],
            [4.5802252566465675, 1.3037071892722363],
            [4.58163834849292, 1.3035695086079044],
            [4.639648981150945, 1.3067359803539067],
            [4.711961410585026, 1.310018527099577],
            [4.726252372473417, 1.3105367636487004],
            [4.7846998747934695, 1.313330443509045],
            [4.8134670317577495, 1.314574520915739],
            [4.841767662324208, 1.3155409858028526],
            [4.898617797640264, 1.3189690792225042],
            [4.927660186408391, 1.320354534613604],
            [4.984943383843637, 1.3237614013127774],
            [5.027641286513206, 1.3266851278504894],
            [5.031147400288941, 1.2753101976124057],
            [5.033873638114721, 1.2386480682008216],
            [5.039937358043828, 1.238994543707315],
            [5.044852837672025, 1.1712817377664309],
            [5.05250854743962, 1.1497412257678685],
            [5.083536454703336, 1.0635809460367853],
            [5.101365492546605, 1.0136894841332653],
            [5.102136296899517, 0.976750269788695],
            [5.016080866644449, 0.9705965026051752],
            [4.962798481248539, 0.9665018796228384],
            [4.928552980668804, 0.9640431315155271],
            [4.843297781514788, 0.958513802738824],
            [4.815622045443835, 0.9572064448059657],
            [4.810636208514783, 1.045198024981774],
            [4.8094816243065415, 1.0743199863323474],
            [4.780946757569072, 1.072705780265016],
            [4.779446096075181, 1.101884003076031],
            [4.752669104656206, 1.1004923153819643],
            [4.748755441987266, 1.1885534067993488],
            [4.688535346460006, 1.1851007513254774],
            [4.66352563089426, 1.1838668205539837],
            [4.6616214708187345, 1.2199479962330384],
            [4.573373266915996, 1.2157037357710543],
            [4.574543485550281, 1.2206124989102451],
            [4.582418265358664, 1.231970293033068],
            [4.588727378271409, 1.24568335194152],
            [4.595670922558501, 1.2541919007871225],
            [4.5955960052837215, 1.2605335955717072],
            [4.591595940711954, 1.266165648077632]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.20151906230394, "lat": 39.71556926752664 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17137"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00424270"
      },
      "bbox": [
        4.573373266915996, 0.9572064448059657, 5.102136296899517,
        1.3266851278504894
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.310378895511404, 0.27792069185846696],
            [8.33094445516111, 0.28028001824973847],
            [8.32920928797998, 0.29428303294643365],
            [8.336349951316558, 0.2952165698945573],
            [8.335412666402377, 0.3025883389221062],
            [8.342597906410626, 0.3034623726193405],
            [8.341699202212064, 0.31072959847619674],
            [8.349013539708901, 0.31159083144535915],
            [8.34748094548469, 0.3261324303695589],
            [8.380932277274026, 0.3307963848114533],
            [8.401070088993759, 0.3326604676343353],
            [8.442210481840059, 0.3373367223294174],
            [8.471158714762696, 0.3403507723820194],
            [8.519364650492701, 0.3462280601255615],
            [8.57569411992687, 0.35304666191454703],
            [8.577475289554673, 0.33849695157105786],
            [8.591107622882136, 0.34022834029486315],
            [8.591758560901631, 0.3339448353754753],
            [8.61919340244813, 0.33682979953559394],
            [8.630336333411842, 0.33842030979709786],
            [8.639425313920691, 0.3241645518626684],
            [8.642720417797294, 0.31664441887793715],
            [8.644668087488641, 0.2997570666525055],
            [8.644226574349917, 0.2946305008890251],
            [8.641060649916634, 0.28534047749174163],
            [8.636866139986122, 0.27891989800547595],
            [8.63366381497282, 0.27613336080332895],
            [8.629977946304294, 0.272926497796858],
            [8.615297178084493, 0.26392078398077623],
            [8.609326130956335, 0.25935664826475907],
            [8.603762561892378, 0.2514724075683155],
            [8.601434846515318, 0.24191124389808463],
            [8.600755150333686, 0.23557823916227352],
            [8.594438733775235, 0.22098614596175295],
            [8.589421891708005, 0.21386618871936347],
            [8.581835351334254, 0.20819913775228158],
            [8.57062382716919, 0.2010081109647477],
            [8.560548610688198, 0.19743328543177086],
            [8.549781110931788, 0.1946104796847412],
            [8.532547045385922, 0.19166305530439984],
            [8.52424828522001, 0.1882271859048337],
            [8.516263912536093, 0.18228011625220905],
            [8.51106692365482, 0.17735930893175839],
            [8.502000750882958, 0.1616681260191186],
            [8.499084867763026, 0.14710029298693358],
            [8.495637368299732, 0.13654286603455207],
            [8.494071434734998, 0.12962624198619432],
            [8.491964670723812, 0.11373176003136479],
            [8.493126839344743, 0.09730278037333946],
            [8.490748634127835, 0.07882778090542159],
            [8.486978672928283, 0.06289885724181711],
            [8.484652805458897, 0.055642631988737194],
            [8.476393124413287, 0.041312659476086984],
            [8.472944308764053, 0.03250015339560582],
            [8.465973424100383, 0.024775886337589318],
            [8.424706307335239, -0.0077463567265910705],
            [8.416484502669723, -0.008502754238319553],
            [8.408741598093295, -0.005299045551852029],
            [8.403346695003671, -0.00045140259154766984],
            [8.403924013734857, 0.0026783856626909457],
            [8.398504104283438, 0.0074179505429151195],
            [8.391421947601073, 0.009587502138779874],
            [8.383731541190679, 0.008032361162394752],
            [8.382822890605887, 0.018536154771400002],
            [8.378291140005995, 0.025161274138813312],
            [8.383862324111934, 0.030082574347240352],
            [8.379170823912089, 0.03289382217283789],
            [8.37905199173427, 0.03547499660018369],
            [8.384708228255674, 0.04340894080240059],
            [8.37739317276092, 0.045012943625403874],
            [8.374201416769155, 0.05242140327247926],
            [8.376865414345312, 0.05456920989153066],
            [8.381601340630095, 0.05243513212115164],
            [8.384227399556005, 0.05653327128886157],
            [8.385285818139211, 0.06315892104362705],
            [8.39102459166508, 0.06476577024657625],
            [8.40011983022826, 0.07341818292561988],
            [8.38200681160364, 0.09502287094752672],
            [8.380966093930759, 0.09410208651941328],
            [8.358278430475634, 0.12000234713417321],
            [8.35826910353011, 0.12366368746043001],
            [8.299985430002492, 0.11725949277022618],
            [8.249095225783167, 0.11125093540202181],
            [8.235650497451589, 0.10990329320574754],
            [8.234753734879304, 0.11713672999381526],
            [8.213346480541391, 0.11486047183313601],
            [8.212559752296077, 0.12237261734418305],
            [8.211591805547569, 0.13684145932519237],
            [8.207305976706573, 0.1765884235741824],
            [8.20611611268982, 0.19296798601074386],
            [8.234687060061177, 0.1964152871767327],
            [8.23260415450375, 0.20938792742372125],
            [8.255255754232138, 0.21242451623556752],
            [8.274028092739616, 0.2144218106488361],
            [8.288179547275472, 0.21684719061129074],
            [8.286656967690982, 0.23159532465876523],
            [8.300834638896733, 0.23338856437726388],
            [8.297697541586757, 0.26216803622165197],
            [8.312134819096968, 0.2637603391949271],
            [8.310378895511404, 0.27792069185846696]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.70730130480372, "lat": 38.47718736218781 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18019"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00450340"
      },
      "bbox": [
        8.20611611268982, -0.008502754238319553, 8.644668087488641,
        0.35304666191454703
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.591822254208772, 1.554248379475868],
            [8.65259529541045, 1.5620251236224576],
            [8.681078040660331, 1.565220969974025],
            [8.683770576675956, 1.5359270048250235],
            [8.68486082594532, 1.5211935679820983],
            [8.68820720182215, 1.4920227236201726],
            [8.733805881859462, 1.4966119545547931],
            [8.736998499686479, 1.497120996287388],
            [8.802251759526927, 1.5043802945287137],
            [8.811121125237866, 1.4245116647589946],
            [8.812991431114877, 1.4027296777232823],
            [8.82117645949014, 1.3295703103421632],
            [8.823013045118723, 1.3152504951913502],
            [8.755424556822858, 1.3081133404852756],
            [8.751956532021111, 1.3075036864495695],
            [8.666929000649983, 1.2968205639448034],
            [8.624176505044666, 1.291746075739189],
            [8.614989388618673, 1.3650573868722524],
            [8.611679524918161, 1.3887003824124549],
            [8.602036432875597, 1.4664385629335708],
            [8.602170878875247, 1.467250870395939],
            [8.591822254208772, 1.554248379475868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.17877645306653,
          "lat": 39.640032347988964
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18041"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00450349"
      },
      "bbox": [
        8.591822254208772, 1.291746075739189, 8.823013045118723,
        1.565220969974025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.919700628900264, 0.14913946821216031],
            [6.92270946677572, 0.15275773321984976],
            [6.928395129843977, 0.15598470375158996],
            [6.929222199728885, 0.15977278654480342],
            [6.927539696148754, 0.1638514320639785],
            [6.926512632781694, 0.1716644902356779],
            [6.930409316778336, 0.17494485104786942],
            [6.935956928674954, 0.17078076007269355],
            [6.94018201547843, 0.16922495482668748],
            [6.946534093140961, 0.17111652762864105],
            [6.9484261588218645, 0.17746851081729983],
            [6.94207838800919, 0.17813667964192614],
            [6.938265221900495, 0.1799598470334832],
            [6.9350403893534, 0.188276092317295],
            [6.935359612999008, 0.19122369380735815],
            [6.939696971929022, 0.19550456566870694],
            [6.937543096532002, 0.20030052266559212],
            [6.938063505860488, 0.20289390140083882],
            [6.942090253559866, 0.20691742124484724],
            [6.94204818068577, 0.2110465060782845],
            [6.937282869547247, 0.2195820849466617],
            [6.939509155853507, 0.2258903895205409],
            [6.9465148641201955, 0.2293759233647123],
            [6.949768611685358, 0.2360016505074748],
            [6.9493788442950555, 0.24116432342277622],
            [6.95090213113925, 0.24748178270128793],
            [6.952907107371763, 0.2505505238889919],
            [6.959856542337196, 0.25589678456694204],
            [6.966016231535484, 0.2589728660698008],
            [6.991631949181173, 0.2664613921375047],
            [6.995720069202542, 0.2683771458176343],
            [7.0020723733743795, 0.2739046241606385],
            [7.008312460461601, 0.28390451053645416],
            [7.010067208296296, 0.2903224364877429],
            [7.008713565106243, 0.3012806553554848],
            [7.010349049328064, 0.30738482178874726],
            [7.015803931280104, 0.3174390311986905],
            [7.0174186793561075, 0.32691230562959633],
            [7.02381053603247, 0.33191148318144914],
            [7.023901597279288, 0.3347348750940199],
            [7.017882055793428, 0.3392304247979751],
            [7.017115695848859, 0.34182790873624125],
            [7.020279455466876, 0.35028647018932674],
            [7.02109991456652, 0.3579956605586909],
            [7.019892430433778, 0.3609296283609928],
            [7.016507252708345, 0.3615039997918731],
            [7.012316496011999, 0.359241871769687],
            [7.007388236108196, 0.3606860997343636],
            [7.008973664544, 0.3652742953269747],
            [7.014713227241089, 0.36608042951773817],
            [7.019673241703453, 0.37016652740514683],
            [7.020979124097146, 0.3748871141046898],
            [7.020124522736446, 0.3783129440369423],
            [7.01389920163997, 0.3852969362073021],
            [7.009735920909509, 0.3878049012165503],
            [6.997890206496284, 0.40427892858261577],
            [6.99301367866919, 0.4090209428607846],
            [6.996604099771306, 0.4179128461655687],
            [6.995844614676362, 0.4218054697235505],
            [6.991671918057352, 0.4296382996129123],
            [6.991369583217053, 0.43996820161530914],
            [6.98629582588818, 0.4432740261365947],
            [6.982215236258361, 0.44401306229284365],
            [6.97025805022088, 0.44976449443037303],
            [6.969853048765373, 0.453978692167133],
            [6.974861088000097, 0.4529239226786237],
            [6.976928246579948, 0.4567686758955312],
            [6.972557135516916, 0.46233410594632657],
            [6.974028540099468, 0.46673689816774283],
            [6.98040867759464, 0.46799348956836706],
            [6.981733846925654, 0.46959785458660175],
            [6.978531083996153, 0.47633156839083757],
            [6.973631643023565, 0.47909147820756826],
            [6.973236685104619, 0.48528010571573005],
            [6.978951037330741, 0.4862695202973736],
            [6.980690277314808, 0.49188948617452133],
            [6.9891483613201455, 0.4941026876207253],
            [7.045803616974831, 0.49909861973566244],
            [7.063608258240714, 0.5004221405437334],
            [7.118343989609731, 0.505005827425538],
            [7.150449273031041, 0.5081046318816412],
            [7.205254842075272, 0.5129368349252594],
            [7.2047017384645855, 0.5192563183314668],
            [7.290045316481815, 0.5266268828383919],
            [7.290378431790218, 0.5239860374134536],
            [7.314233406625983, 0.5255067612519301],
            [7.317601740350195, 0.5250940821441431],
            [7.32077961631565, 0.5223849836694636],
            [7.320307876410452, 0.5195549260855269],
            [7.315166491087492, 0.5186722650814563],
            [7.31226626754278, 0.522135784043827],
            [7.308751225701027, 0.5205311347370809],
            [7.308253911299861, 0.5163845541281652],
            [7.3031506082157165, 0.5154485378759646],
            [7.300630948108562, 0.519169227807893],
            [7.296426872385454, 0.5154623605754013],
            [7.299698190914532, 0.5123859253893532],
            [7.3038307310562125, 0.5110027282000031],
            [7.30138022898379, 0.5069053342640404],
            [7.295782573076913, 0.5106450474401864],
            [7.29214435200147, 0.5083543732141351],
            [7.2926538252188955, 0.5030275412822701],
            [7.295542230039809, 0.502835541759243],
            [7.297673660852881, 0.49732493812504625],
            [7.300618771868067, 0.4946133812113901],
            [7.299401376051724, 0.4896287258167126],
            [7.295161721835726, 0.48986244671882473],
            [7.292560372801447, 0.49413966094241707],
            [7.288800692968448, 0.4906615509364076],
            [7.2947335133308595, 0.4774425883556792],
            [7.285306621083943, 0.48293829521010073],
            [7.286180862829091, 0.4763454741908274],
            [7.284735864820462, 0.47302626424339844],
            [7.288013513238715, 0.4685584275150149],
            [7.286184457789272, 0.4651941572342068],
            [7.287836974594903, 0.46172130713618664],
            [7.285019686912238, 0.45743012880219786],
            [7.281601675691774, 0.45593351116683717],
            [7.276925730883288, 0.46037559656698923],
            [7.269550922517689, 0.46105866175826227],
            [7.264623294311893, 0.46302601438418856],
            [7.261459322290241, 0.4605572212283263],
            [7.254398409034036, 0.4625841801575181],
            [7.252866097964947, 0.4595192397287655],
            [7.255795417305246, 0.45752740441492135],
            [7.259425777671586, 0.4580102636081412],
            [7.2633859402207746, 0.45484408176896035],
            [7.26279227464008, 0.4506616561789671],
            [7.26524102777115, 0.44701508229701875],
            [7.260397102171145, 0.4456787584617929],
            [7.256780270410469, 0.44936585016938374],
            [7.253756625077777, 0.4494861444585806],
            [7.254266038120158, 0.44155108503510504],
            [7.249863571025531, 0.4453814371822308],
            [7.245759544999272, 0.44426901219575593],
            [7.245934286466222, 0.44062767625290417],
            [7.2515872540628274, 0.43830860749888245],
            [7.2524099013994245, 0.4347528295014823],
            [7.250845826790188, 0.42904347053615083],
            [7.2483800353673695, 0.42952417416314087],
            [7.245568887732729, 0.4383213206668056],
            [7.2410497837266, 0.4391966512508469],
            [7.240213461042033, 0.43425582663739964],
            [7.242381197338787, 0.43002068854254705],
            [7.235316891555846, 0.4207969398002122],
            [7.235857827877334, 0.43395216221032634],
            [7.231715262758248, 0.4363495283648137],
            [7.230169278496963, 0.43154996780433436],
            [7.233332879826867, 0.4253271512696176],
            [7.228420673109976, 0.42267669250273865],
            [7.226975762869317, 0.4171636054773885],
            [7.2235886109781875, 0.41811857012610604],
            [7.224923168264294, 0.4231934445107895],
            [7.220393255670585, 0.424901596630713],
            [7.215297564455037, 0.4230837909604282],
            [7.217012329834139, 0.42959900326663664],
            [7.213789715160162, 0.43024914636737444],
            [7.211898330051047, 0.4218935658995973],
            [7.209726948741879, 0.41814912513244407],
            [7.214752956099912, 0.41138376650024133],
            [7.213613422368809, 0.4085579366487937],
            [7.216310316093393, 0.40041335647916915],
            [7.216910442073105, 0.39191578324843723],
            [7.215253020769732, 0.3897315888210688],
            [7.207274350317883, 0.38942474665251464],
            [7.204650306389273, 0.38616704728590207],
            [7.204755496735746, 0.3780415702974395],
            [7.2089168807514, 0.3744425835110469],
            [7.21598615174155, 0.3793217085751689],
            [7.219281088998358, 0.3768975381866033],
            [7.215922812903259, 0.3710345296317612],
            [7.209563139113019, 0.36648257124313954],
            [7.210184696809824, 0.36401712153897753],
            [7.216590104414939, 0.358799376167217],
            [7.216636392342052, 0.3556784916552695],
            [7.221904455671797, 0.3539060972779552],
            [7.220055877777899, 0.3509010743462712],
            [7.214049224782064, 0.3516228489926415],
            [7.210353368760877, 0.3451520735263908],
            [7.210151675611136, 0.34215027772647433],
            [7.216735313229256, 0.338884526432873],
            [7.214738151831639, 0.33537213860340753],
            [7.211340871537872, 0.33941979532517513],
            [7.204428920732083, 0.3391817954111904],
            [7.2096128433374975, 0.3310195716204204],
            [7.209941480864373, 0.3280879884886203],
            [7.205902649215447, 0.32445856765360553],
            [7.204969305538874, 0.31965744339220775],
            [7.201221552486175, 0.31670209390702747],
            [7.203951644230409, 0.30914077185553684],
            [7.200027470381504, 0.3044698205358381],
            [7.19521968383479, 0.30145781810192357],
            [7.195465581083606, 0.2993338280986979],
            [7.201527785398228, 0.2969360845188548],
            [7.2082980251903015, 0.29669900545196176],
            [7.2077736754693555, 0.2929465030669623],
            [7.201374791241417, 0.291195944554081],
            [7.201583890926627, 0.2877280542012503],
            [7.2087704233394785, 0.2834134074865003],
            [7.2120228062303084, 0.27565185018688365],
            [7.216047740782263, 0.27934503556143914],
            [7.2174628140336905, 0.28625739515000526],
            [7.222385785351317, 0.28738018739583027],
            [7.221970330581947, 0.28296730186940605],
            [7.216344797605382, 0.27508212148946826],
            [7.213944652502337, 0.2702306910653891],
            [7.217896754129604, 0.26332980994878796],
            [7.228566946714215, 0.2707908430350149],
            [7.229769096492214, 0.2680444032614437],
            [7.228761029373532, 0.2575228327415106],
            [7.22168672887385, 0.26238167070629687],
            [7.220246870930457, 0.25686019485612066],
            [7.222191319152975, 0.2544934556423475],
            [7.227295414557582, 0.25395690488176675],
            [7.22902904876053, 0.24725912922295828],
            [7.2335825487218655, 0.24466020982716075],
            [7.2306310244921, 0.2420469352883457],
            [7.22450929572128, 0.24494536131876865],
            [7.221195953124709, 0.24049207508553924],
            [7.224821152813299, 0.23488751277531983],
            [7.230909747663779, 0.22956441843417297],
            [7.233844906096425, 0.2244683361278195],
            [7.234027310526296, 0.22047765772582273],
            [7.229783028418328, 0.21986639757440216],
            [7.224612335369424, 0.2241883565470566],
            [7.221182082969038, 0.22113284857056087],
            [7.228044365436872, 0.21706623123191104],
            [7.22961265168972, 0.2131041888656585],
            [7.227567387441221, 0.20751954501024356],
            [7.230581269455612, 0.2049828935513603],
            [7.228014507765613, 0.19932675371048952],
            [7.230046652532095, 0.19230551526119966],
            [7.237736999418585, 0.19089472249916417],
            [7.238029200226389, 0.18553097342109848],
            [7.235336898930109, 0.18148952328658438],
            [7.2310894823092315, 0.17854678821424946],
            [7.237982289435057, 0.17522170581118698],
            [7.239243866275314, 0.17035723457243582],
            [7.232212597378847, 0.1697115889934658],
            [7.231649785243876, 0.16708998894520302],
            [7.2405044793308555, 0.1620975687857939],
            [7.237602075046394, 0.15426737723941322],
            [7.233478640525476, 0.15249921971416702],
            [7.229772392982577, 0.14676529634561059],
            [7.2286542265123, 0.14139813414901306],
            [7.228670398896489, 0.13483968244143135],
            [7.222935533357379, 0.13122707120213253],
            [7.216271171061909, 0.12844199802354156],
            [7.210357910769908, 0.12338323085767149],
            [7.206630647066416, 0.11881394287107795],
            [7.202442682380682, 0.1166788083613424],
            [7.194350572328343, 0.11529590319051111],
            [7.190514494410541, 0.1221049224777408],
            [7.185820363434916, 0.12538880560371277],
            [7.176382353672885, 0.12745776300730768],
            [7.16537214286057, 0.1339856067167955],
            [7.153979106916515, 0.14321462884199754],
            [7.1465560169281455, 0.14509785954279636],
            [7.142057898206315, 0.14389709754481936],
            [7.139507225712089, 0.138271627410223],
            [7.141347179489498, 0.1331342047538359],
            [7.1467521390516096, 0.1266708954448337],
            [7.147574339559593, 0.12382969170806832],
            [7.145979767185385, 0.11653396655986686],
            [7.143732508712093, 0.11322148651327374],
            [7.139983086493063, 0.11208212295385155],
            [7.1360477175750425, 0.11344772129556405],
            [7.131977395612513, 0.1196539509856407],
            [7.132650591097251, 0.1314139751226024],
            [7.1289504188828365, 0.13705062066473112],
            [7.12100937294377, 0.13724272422161546],
            [7.113622830317153, 0.13934142489250723],
            [7.109513800521064, 0.1352407245573012],
            [7.110520381779338, 0.12879529402234274],
            [7.108782300674252, 0.12383691930252051],
            [7.10162134648312, 0.1255670042892402],
            [7.09932853554642, 0.12945665269398318],
            [7.098653334586935, 0.1361703953768258],
            [7.0941058784552204, 0.13613417775459555],
            [7.091487886746922, 0.13346720434372875],
            [7.092342150607659, 0.12637422143015867],
            [7.086946164490136, 0.12413468470365732],
            [7.081751805620431, 0.12754481985820917],
            [7.068325711159374, 0.12725292563210008],
            [7.063996122007152, 0.12524297484190042],
            [7.063436969972872, 0.12230317661391368],
            [7.06512835086707, 0.11502284858125429],
            [7.06223114785454, 0.11523256518711823],
            [7.0586352756150035, 0.1207985705500027],
            [7.057066916689611, 0.1164571994890875],
            [7.0625396586532485, 0.11259896372106942],
            [7.061781856914256, 0.1056376216994927],
            [7.056558076809128, 0.10134573952227663],
            [7.048604830148904, 0.09685587040927111],
            [7.046897532027349, 0.09332860834175365],
            [7.04839115450515, 0.08694267360855833],
            [7.045255995411648, 0.08532717616731342],
            [7.039634736464162, 0.08785754692167594],
            [7.031815082768304, 0.09346305069278535],
            [7.026485502573322, 0.09314629043491199],
            [7.021505040029005, 0.08774852028268733],
            [7.016944141026892, 0.08965956832111006],
            [7.018960600162783, 0.09911190398217778],
            [7.0176585697615925, 0.10414970814523283],
            [7.012666705471624, 0.10698753927286826],
            [7.0062565686632805, 0.10529731325855293],
            [7.00349110422059, 0.099267102050663],
            [7.00756244796277, 0.09061255442035827],
            [7.010529325202056, 0.08676632490126159],
            [7.012344744428431, 0.08097636581814971],
            [7.005903995545736, 0.07784001079807591],
            [6.997324433733644, 0.07668531085556157],
            [6.986455727607921, 0.07702312763439187],
            [6.983129416089668, 0.07969885181550276],
            [6.981463171759978, 0.08394139684380553],
            [6.976609003948296, 0.0828240641168183],
            [6.97585880189895, 0.07920429847824083],
            [6.9781027477391975, 0.07366666644909009],
            [6.982447485610675, 0.06975010184943899],
            [6.976712279989352, 0.055237985608825924],
            [6.976443421366092, 0.047002759709441164],
            [6.972416574344097, 0.03727963621609982],
            [6.970193645853438, 0.03442559025068528],
            [6.962807228388551, 0.029894898007756382],
            [6.95898279829764, 0.02958488633600685],
            [6.953431639645722, 0.03202067869586203],
            [6.947805474547885, 0.029914866841236638],
            [6.94585259035292, 0.024483298278985197],
            [6.942272222389354, 0.024431919585315227],
            [6.940481124585475, 0.028106752250865067],
            [6.9407405420846535, 0.03493667670416407],
            [6.937207524434855, 0.037038724360479565],
            [6.934539344757475, 0.03576954954019231],
            [6.929823983035051, 0.02939462738221581],
            [6.92692634433793, 0.033080748643720334],
            [6.930218427877332, 0.03632856487696356],
            [6.925322496450114, 0.0386192823518411],
            [6.921746801011826, 0.03390427664651887],
            [6.9205036201765155, 0.028635300659292234],
            [6.913519916790441, 0.02524104061570592],
            [6.915584143974936, 0.019309903850934472],
            [6.921091009685845, 0.01810308324908913],
            [6.923575976669037, 0.015179191218580393],
            [6.922099886040125, 0.010180642750037511],
            [6.915809933392909, 0.0077423913270917456],
            [6.909126746879247, 0.009941194708641915],
            [6.900840064741436, 0.005252079328978796],
            [6.89510366831999, -0.00132117635083583],
            [6.88879274873859, -0.0051221570592238025],
            [6.8787888752596595, -0.008293296719511236],
            [6.868950573649781, -0.008501975622668924],
            [6.86208602139326, -0.011781991534149518],
            [6.861616035188033, 0.0013001561212800223],
            [6.863049031477207, 0.01221186081911072],
            [6.869623725958256, 0.017783174688999943],
            [6.867947898591271, 0.025616228935910305],
            [6.860996237521315, 0.028999862458834597],
            [6.85310563974266, 0.02778679086743673],
            [6.848992237922022, 0.02913081700273784],
            [6.848730017750655, 0.037301918997407923],
            [6.855838615712757, 0.05140746006335496],
            [6.863313901972936, 0.05490904937506381],
            [6.879240017236666, 0.05609858903801436],
            [6.899906065312561, 0.07003412883970572],
            [6.905151150471136, 0.0771794030613625],
            [6.908985876821811, 0.08659652180904778],
            [6.9160823456040985, 0.08269419977005293],
            [6.921559517780118, 0.08198598555721376],
            [6.926440294209615, 0.08530369413701096],
            [6.929612668300242, 0.09121220052604982],
            [6.928495517981225, 0.09611224463108016],
            [6.920999002576532, 0.10124012712249464],
            [6.9172396196001396, 0.10690112037427883],
            [6.91559961243766, 0.11226513023095908],
            [6.908381575688427, 0.12135865033504441],
            [6.907425282136274, 0.1248173548858526],
            [6.910585861760541, 0.12986846877174288],
            [6.92139350358459, 0.1371995122025407],
            [6.9190910286700955, 0.14532811499518383],
            [6.919700628900264, 0.14913946821216031]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.41810817550027, "lat": 38.68912143927545 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18083"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00450366"
      },
      "bbox": [
        6.848730017750655, -0.011781991534149518, 7.32077961631565,
        0.5266268828383919
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.172039024186027, 3.3531052657889377],
            [7.179091555163663, 3.3570115053148055],
            [7.183421420296102, 3.3611257610630245],
            [7.185081059326857, 3.3675267339660016],
            [7.187763231204577, 3.372203930832026],
            [7.200822245052122, 3.378687634471989],
            [7.211551131824423, 3.385601557787923],
            [7.246690071478481, 3.4115212082293382],
            [7.303264098891888, 3.4167371420290453],
            [7.382076882258495, 3.424126860597102],
            [7.46827265055841, 3.4325014308119903],
            [7.4727435485419695, 3.3821994384810763],
            [7.477390476757646, 3.3232196175305586],
            [7.506365289747064, 3.3249911856646754],
            [7.507557415086962, 3.317408183332759],
            [7.510497852782313, 3.2921135872196614],
            [7.515134657707986, 3.246220514415501],
            [7.5074247923217, 3.235880549155827],
            [7.510422623416632, 3.2061752458287547],
            [7.509142960823759, 3.202823370981943],
            [7.50988212375033, 3.19560549067429],
            [7.50757174594186, 3.193881625410935],
            [7.491790318335638, 3.192446360835069],
            [7.494656676974368, 3.162237761943562],
            [7.495022137018497, 3.161773682107337],
            [7.5006650094954965, 3.1055631622205504],
            [7.413465743894328, 3.0966584726731234],
            [7.394148686894137, 3.075680356587472],
            [7.3869643528198985, 3.0731661376106674],
            [7.373895164302794, 3.062437366614427],
            [7.3706671882915185, 3.0501878065247787],
            [7.37029347840756, 3.040179678024054],
            [7.366734251801224, 3.031631357440316],
            [7.362130693194268, 3.0234603924528862],
            [7.360423897915152, 3.018350036917696],
            [7.360658765055098, 3.01049757959955],
            [7.3590640104129195, 3.0055589362739235],
            [7.354383461991937, 2.995980054764736],
            [7.353155991116502, 2.9903461219634826],
            [7.353677413656224, 2.982894485997748],
            [7.352194579136066, 2.9784573172044646],
            [7.346394136554187, 2.9713617375039596],
            [7.337746233017965, 2.962796843595649],
            [7.323490369640734, 2.9390050354844486],
            [7.301520337553535, 2.924773435076168],
            [7.291484635583776, 2.921408461203015],
            [7.283401741131006, 2.9215196004088644],
            [7.276824151504872, 2.9156021832936085],
            [7.261113672912402, 2.9118230147324993],
            [7.256533504233371, 2.9069666457500376],
            [7.242048734154233, 2.8999398344128067],
            [7.229465857118938, 2.88994272415052],
            [7.225671753373472, 2.888674329433403],
            [7.219381908494971, 2.879748931397915],
            [7.217371783221043, 2.902434092566218],
            [7.208373782589418, 2.9900505508096162],
            [7.198952186113496, 3.093070724508589],
            [7.1981773481752995, 3.1065615548686027],
            [7.19079654821078, 3.1795939084407525],
            [7.189179892557296, 3.1898886825755146],
            [7.181223702837857, 3.260777100285046],
            [7.174318407425389, 3.3318527651995913],
            [7.172039024186027, 3.3531052657889377]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.73996219100323, "lat": 41.54597359275138 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18091"],
        "coty_name": ["LaPorte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["LaPorte County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00450507"
      },
      "bbox": [
        7.172039024186027, 2.879748931397915, 7.515134657707986,
        3.4325014308119903
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.815998866151913, 0.7082067383888088],
            [8.81641469217946, 0.727031263647229],
            [8.821862258219408, 0.7305929230011341],
            [8.822771312485772, 0.7341170058750058],
            [8.828475086122696, 0.7370552506794386],
            [8.830045418830576, 0.7325164576367234],
            [8.82683191823359, 0.7284701346196475],
            [8.825733746009702, 0.7244130714961214],
            [8.828186088849492, 0.7173486104790147],
            [8.832163800307463, 0.7167390174662447],
            [8.8359828036114, 0.7204599271233838],
            [8.84023928499931, 0.7217660017539022],
            [8.844685152331875, 0.7175310983578791],
            [8.846808162006862, 0.722479029969908],
            [8.850034759383043, 0.7254790433159275],
            [8.85293588767523, 0.7343696431159591],
            [8.856345214077386, 0.7351613643314757],
            [8.85897559648025, 0.732256524959107],
            [8.863262368226996, 0.7338907301447152],
            [8.86303217892787, 0.7402129330886684],
            [8.86750795444116, 0.738637442283033],
            [8.866609342452687, 0.7348129361501394],
            [8.87289708110484, 0.7344694976123389],
            [8.87210840062758, 0.7436561869528979],
            [8.874289875524518, 0.7454207226612067],
            [8.880284459411753, 0.7426943825739188],
            [8.880918048982613, 0.7466510739621895],
            [8.877106815641506, 0.7497457713427027],
            [8.876445342630022, 0.7531104662801036],
            [8.879458157120098, 0.7555517029963672],
            [8.881508819754448, 0.760021027514709],
            [8.88649642377785, 0.7638519171608181],
            [8.895856586034308, 0.7630729872378508],
            [8.89762876044836, 0.770533179871714],
            [8.90153696272492, 0.7715192750742961],
            [8.909247019333435, 0.7681083218699737],
            [8.912949812055254, 0.7694888881894884],
            [8.911731535298365, 0.7780686840889769],
            [8.91405768490974, 0.7878765996270736],
            [8.918343633219022, 0.7864002653443807],
            [8.923855918706142, 0.7871331873700397],
            [8.92674113951202, 0.7891227496536503],
            [8.935798786725766, 0.7859203966420011],
            [8.939346173719333, 0.7917859621063527],
            [8.942485823211133, 0.7888946213074185],
            [8.94762019699084, 0.789824139508701],
            [8.948809750735158, 0.7934615106864469],
            [8.952768355395031, 0.7969100613906687],
            [8.952255409878564, 0.8019301915283837],
            [8.954355619867991, 0.8039766619981427],
            [8.961888769955475, 0.8030114822705074],
            [8.965755331490957, 0.8081312721946324],
            [8.966813908418752, 0.8118370716974627],
            [8.972178152558538, 0.8125768896817351],
            [8.976720983629766, 0.8176607142889033],
            [8.988397385601866, 0.8133742842650729],
            [8.994435824786985, 0.8241543303712379],
            [9.001781401790218, 0.8334808578657289],
            [9.006468527034421, 0.8301243378099757],
            [9.025406710979611, 0.8089099524447189],
            [9.028391398609408, 0.8024661509044767],
            [9.03768378804248, 0.7934482900139521],
            [9.044212055346351, 0.7808396776787879],
            [9.045447414033651, 0.7753811227244074],
            [9.044274754109118, 0.7671862924167326],
            [9.042743868018707, 0.7634486054076413],
            [9.036685602870575, 0.7556301612536276],
            [9.033061606670064, 0.7524500903380297],
            [9.030305558791005, 0.7467131453315882],
            [9.022848395012428, 0.7376538015955137],
            [9.018904066315168, 0.7314339949482882],
            [9.014591503340217, 0.7219060266532118],
            [9.013938853864339, 0.7175181315721312],
            [9.01648949095186, 0.7106004325004004],
            [9.021847846265112, 0.7037747286606186],
            [8.976038439281586, 0.69769201197198],
            [8.915678952456547, 0.6912235573947871],
            [8.889528641785825, 0.6885875384839563],
            [8.889239235675262, 0.6896394969692696],
            [8.846439887333588, 0.684708267696307],
            [8.815606885786648, 0.6813494882435897],
            [8.815998866151913, 0.7082067383888088]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.96520362054895,
          "lat": 38.950160651479216
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18115"],
        "coty_name": ["Ohio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ohio County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00450378"
      },
      "bbox": [
        8.815606885786648, 0.6813494882435897, 9.045447414033651,
        0.8334808578657289
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.219381908494971, 2.879748931397915],
            [7.225671753373472, 2.888674329433403],
            [7.229465857118938, 2.88994272415052],
            [7.242048734154233, 2.8999398344128067],
            [7.256533504233371, 2.9069666457500376],
            [7.261113672912402, 2.9118230147324993],
            [7.276824151504872, 2.9156021832936085],
            [7.283401741131006, 2.9215196004088644],
            [7.291484635583776, 2.921408461203015],
            [7.301520337553535, 2.924773435076168],
            [7.323490369640734, 2.9390050354844486],
            [7.337746233017965, 2.962796843595649],
            [7.346394136554187, 2.9713617375039596],
            [7.352194579136066, 2.9784573172044646],
            [7.353677413656224, 2.982894485997748],
            [7.353155991116502, 2.9903461219634826],
            [7.354383461991937, 2.995980054764736],
            [7.3590640104129195, 3.0055589362739235],
            [7.360658765055098, 3.01049757959955],
            [7.360423897915152, 3.018350036917696],
            [7.362130693194268, 3.0234603924528862],
            [7.366734251801224, 3.031631357440316],
            [7.37029347840756, 3.040179678024054],
            [7.3706671882915185, 3.0501878065247787],
            [7.373895164302794, 3.062437366614427],
            [7.3869643528198985, 3.0731661376106674],
            [7.394148686894137, 3.075680356587472],
            [7.413465743894328, 3.0966584726731234],
            [7.5006650094954965, 3.1055631622205504],
            [7.543666880313255, 3.1099543256957394],
            [7.550783605930466, 3.0417273312537763],
            [7.561200160581131, 2.9353376712554726],
            [7.56973573433448, 2.847983615285481],
            [7.510135458171818, 2.8425272811514093],
            [7.4264762988600435, 2.834363876836003],
            [7.354531527363348, 2.827331579644751],
            [7.334861926905224, 2.82465689178839],
            [7.3115898122213725, 2.823069297841606],
            [7.225507998697581, 2.815115528432914],
            [7.2203842088844015, 2.8726769205863327],
            [7.219381908494971, 2.879748931397915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.64764612007497,
          "lat": 41.280930617533585
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18149"],
        "coty_name": ["Starke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Starke County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00450389"
      },
      "bbox": [
        7.219381908494971, 2.815115528432914, 7.56973573433448,
        3.1099543256957394
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8223303693734105, 2.8255758265568116],
            [3.838771347463622, 2.826739516123578],
            [3.8532639654252483, 2.8267806424692266],
            [3.891022143544579, 2.8286479098852038],
            [3.908175093040214, 2.8290298299485994],
            [3.911848687476682, 2.7414041628299084],
            [3.9438433638782118, 2.7426209112903375],
            [3.9978267938502423, 2.7451228278423105],
            [4.015604085050589, 2.745634502058834],
            [4.083623019271537, 2.7483278927521404],
            [4.133230201772971, 2.750042508268218],
            [4.133231257989342, 2.749807406134691],
            [4.133321193620664, 2.729730152859923],
            [4.1325350670227605, 2.7217629271134753],
            [4.130748090166716, 2.717889572942838],
            [4.124158809513594, 2.7100303999708077],
            [4.120710484785167, 2.70233086897802],
            [4.114955327164883, 2.6821290574160166],
            [4.108707154072409, 2.6706346279862854],
            [4.106129751656908, 2.664392862706845],
            [4.106977437434836, 2.6557367693908813],
            [4.110271876743892, 2.6510319619679805],
            [4.117091289653539, 2.6452978079879763],
            [4.123321667519823, 2.6376562129993375],
            [4.132372915320064, 2.6298492947999548],
            [4.1390612784413445, 2.622856592581214],
            [4.144737968335294, 2.6154528398555605],
            [4.153531132698156, 2.602042787933746],
            [4.16465185169828, 2.582827813013477],
            [4.1754775828107835, 2.580604849463309],
            [4.1899659324553475, 2.584198226999573],
            [4.197376131289235, 2.5809379832155885],
            [4.203886906583641, 2.5743744677864138],
            [4.210810536147076, 2.5615710317011833],
            [4.219282231119473, 2.5493590702891558],
            [4.223535227867205, 2.5389454073559237],
            [4.230449358856799, 2.5307647926618464],
            [4.239148200873461, 2.5166486975460582],
            [4.238372136937457, 2.4924785037626616],
            [4.174129355545011, 2.4893298127743027],
            [4.0724048963442, 2.484218542623809],
            [4.009695407434991, 2.4821439780110217],
            [3.923680563326486, 2.477867566323523],
            [3.919710685133465, 2.5655426054385564],
            [3.8335631421553313, 2.5625671213962673],
            [3.831311730020155, 2.606445608871818],
            [3.8273150511956375, 2.708834065508719],
            [3.825991864209287, 2.738059928970767],
            [3.8223303693734105, 2.8255758265568116]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.25963898769018,
          "lat": 41.218535506165296
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19115"],
        "coty_name": ["Louisa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Louisa County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00465246"
      },
      "bbox": [
        3.8223303693734105, 2.477867566323523, 4.239148200873461,
        2.8290298299485994
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7704110695179693, 2.8382958569672057],
            [1.856879628264521, 2.839356787208313],
            [1.9404421536068084, 2.8411513375122674],
            [1.9942411142753254, 2.842368955931855],
            [2.0263647819514223, 2.842905530653666],
            [2.0435670430817243, 2.8453265475859526],
            [2.105287583106345, 2.853570790724132],
            [2.1066129761589445, 2.795516063786211],
            [2.10876961520716, 2.707247496962243],
            [2.109739485159587, 2.677777060006113],
            [2.1120338564774825, 2.5969092710751593],
            [2.1145420481152923, 2.5014110844510715],
            [2.100261895524008, 2.5002010962020624],
            [2.0589288312729144, 2.496112471613264],
            [2.0328258849472864, 2.494093415444611],
            [2.0187175084103144, 2.4937076010590093],
            [1.9466772159844414, 2.4923957608085416],
            [1.847456976921057, 2.4904289261004373],
            [1.8333173640926628, 2.4904117843309748],
            [1.7768403607811363, 2.4894279400626766],
            [1.7751745221131159, 2.57663303429676],
            [1.774201359625501, 2.63489136111466],
            [1.7726674306636931, 2.722081082948007],
            [1.7713231071950206, 2.79488569234268],
            [1.7704110695179693, 2.8382958569672057]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.01555629170639, "lat": 41.33070416657426 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19121"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00465249"
      },
      "bbox": [
        1.7704110695179693, 2.4894279400626766, 2.1145420481152923,
        2.853570790724132
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.19833301470326, 0.5982625775325858],
            [9.200859072937137, 0.6036865156101091],
            [9.199150322715974, 0.6070620966241559],
            [9.199811592684897, 0.6114804595573917],
            [9.208066814843292, 0.6152510912472259],
            [9.20850993502591, 0.6205352333698442],
            [9.218321238766967, 0.6267027636507072],
            [9.226951199702537, 0.6281798838804711],
            [9.229387408768465, 0.6273991582291418],
            [9.238692679587045, 0.6189155416948953],
            [9.244481398478959, 0.6179208740509357],
            [9.283278113407755, 0.6215136216203317],
            [9.294530759647483, 0.6247524018165571],
            [9.305470858275694, 0.5878072563130337],
            [9.330979508288644, 0.5000681034866961],
            [9.337066765224591, 0.4794043210979921],
            [9.351124587196784, 0.43326178723153663],
            [9.367870540021192, 0.3801820302777064],
            [9.365123689259214, 0.34508823309781034],
            [9.356540774597917, 0.3477616737255553],
            [9.351261770014398, 0.34689293287321854],
            [9.346917598477079, 0.3417347706494967],
            [9.343762485967012, 0.3427867592867101],
            [9.33738511666098, 0.3414591712079327],
            [9.327524597154456, 0.3326670818317825],
            [9.322001852271988, 0.3304385954660239],
            [9.315758280701713, 0.3235014565149689],
            [9.311569116570944, 0.3226853355523091],
            [9.309095897997485, 0.3218379478833633],
            [9.296150177179893, 0.3006037296745849],
            [9.279613169015697, 0.30673451810886443],
            [9.276195364510619, 0.305821292962287],
            [9.263903618775373, 0.30550307830443996],
            [9.259197713021388, 0.30845099598222236],
            [9.25706826043453, 0.3145646786860569],
            [9.252686421813646, 0.31772679383704344],
            [9.24974382825798, 0.32532535809907676],
            [9.24160133828396, 0.33494585473977495],
            [9.237559289197339, 0.33652730620221444],
            [9.23986464989728, 0.3423791739656763],
            [9.235010123103832, 0.34458322532032426],
            [9.229527564927459, 0.3533877551504845],
            [9.222584938037949, 0.3514684895130966],
            [9.222142676983323, 0.34735777963070374],
            [9.219623339535923, 0.3467244899543488],
            [9.218741876505552, 0.3540194089766283],
            [9.220256640347376, 0.36520444175911737],
            [9.214544258608912, 0.3651447538422208],
            [9.210741406644289, 0.3699096003026857],
            [9.214255372559007, 0.3742353386145152],
            [9.213625834417236, 0.3770308361662111],
            [9.20860209227121, 0.3782183522244254],
            [9.159950273057047, 0.40902032333399835],
            [9.129652670101548, 0.42869786069525756],
            [9.10873433133545, 0.5297917410252022],
            [9.107266473192201, 0.5751163024471408],
            [9.19833301470326, 0.5982625775325858]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.62459782052261, "lat": 38.64886434160694 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21081"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00516887"
      },
      "bbox": [
        9.107266473192201, 0.3006037296745849, 9.367870540021192,
        0.6281798838804711
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.199998431430174, -0.6512462621956416],
            [9.246584828077012, -0.6169021193421229],
            [9.273626991581692, -0.6047130593658908],
            [9.268946632465452, -0.6022108852785024],
            [9.266087936067038, -0.5948682926758513],
            [9.273114576427655, -0.5925277986812675],
            [9.274827089646887, -0.5959299129893891],
            [9.273871604647429, -0.6046036306414847],
            [9.291355354567242, -0.5966940096169869],
            [9.310875589678023, -0.5777071648302682],
            [9.310799952081997, -0.5756924835900988],
            [9.316388275669285, -0.5721851603050486],
            [9.309981160402453, -0.5689666183254507],
            [9.309941386745283, -0.5663201896411388],
            [9.313631545427613, -0.5624235181962138],
            [9.318858470004264, -0.5632608252598393],
            [9.32409459061794, -0.5595935262665208],
            [9.325779824227334, -0.5623999988228788],
            [9.324359666053853, -0.5654439668859124],
            [9.327837966324077, -0.5673696495958712],
            [9.333013086227336, -0.5651114453749388],
            [9.335412237500925, -0.5581108020523293],
            [9.339049594535567, -0.5641357379877591],
            [9.341255088480382, -0.5581069177747983],
            [9.34099223593988, -0.5540846701599268],
            [9.337102282566116, -0.5473355116529951],
            [9.342164653752862, -0.5452110012206449],
            [9.343531684405018, -0.5479017389016285],
            [9.348383790418362, -0.5486445879450853],
            [9.349345141946316, -0.5529674438181935],
            [9.351963582787004, -0.5565309486779095],
            [9.35571455449027, -0.5573212016014258],
            [9.352876487307533, -0.5614748944974223],
            [9.34913442896646, -0.556824857255249],
            [9.34352258231288, -0.5631335263566477],
            [9.35065767564124, -0.5678149168209906],
            [9.353470631041398, -0.5715340590501142],
            [9.361078044737992, -0.5785550248594961],
            [9.368853692628067, -0.5749657535224904],
            [9.373211651681018, -0.5793842888357723],
            [9.373111583851784, -0.5851660101220101],
            [9.421787219083091, -0.6184377271425103],
            [9.498453176161574, -0.670243269942241],
            [9.499931450958488, -0.6679228992389361],
            [9.505559270618456, -0.6710258003738034],
            [9.514752814388716, -0.6699975129397807],
            [9.52002101957277, -0.6763496453227382],
            [9.51136854499752, -0.7295662110920981],
            [9.495314965581022, -0.8391486376993701],
            [9.450202885794269, -0.8172314257019444],
            [9.39615787842814, -0.8798921970248302],
            [9.35785240069902, -0.9249197645119682],
            [9.335864858394794, -0.9503484117319319],
            [9.33502485334599, -0.9452152514048354],
            [9.336852738379235, -0.943113236117432],
            [9.335094881189164, -0.9389984985731413],
            [9.337878583550733, -0.9355470753406795],
            [9.334141637996876, -0.9307125702701942],
            [9.334640209147302, -0.9283968924069271],
            [9.332210049096085, -0.9201263607954905],
            [9.332466643268292, -0.9168339292819],
            [9.329723190227417, -0.914459388476516],
            [9.328837566640916, -0.9057799406512567],
            [9.327515758511554, -0.9020676011691974],
            [9.334776078601546, -0.8936664052932489],
            [9.3360071318838, -0.8888503567374407],
            [9.339924349692115, -0.8873243393880713],
            [9.319661170702245, -0.8285208904442327],
            [9.308733708598558, -0.8234015076340966],
            [9.258760220404298, -0.8047315008162399],
            [9.248038724919002, -0.7971436616706771],
            [9.211685214938594, -0.7730939445537571],
            [9.199662875314672, -0.733632150706541],
            [9.199411254804573, -0.716665745809272],
            [9.194813895615775, -0.6720126201085358],
            [9.199998431430174, -0.6512462621956416]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.6608102884584, "lat": 37.45531000067061 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21137"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00516915"
      },
      "bbox": [
        9.194813895615775, -0.9503484117319319, 9.52002101957277,
        -0.5452110012206449
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.733942893775925, 0.47760326637698464],
            [9.748552294501051, 0.5407966173276586],
            [9.757157015677958, 0.5752278881602226],
            [9.77891356670915, 0.6609033175538619],
            [9.792116250359536, 0.6599963512426038],
            [9.803201498691964, 0.6581785329923601],
            [9.814755693126378, 0.6539356789679921],
            [9.82076393378435, 0.6492513076172571],
            [9.82644413373148, 0.6406741447065404],
            [9.83336899280739, 0.6208202264175025],
            [9.839172614097285, 0.615556697385032],
            [9.849322909451791, 0.610314833518406],
            [9.855709569334136, 0.6089705229078313],
            [9.86161406114725, 0.6088839192263047],
            [9.87424112267247, 0.6054876854520185],
            [9.880430759012787, 0.6001433228489649],
            [9.884625357868476, 0.5897573911534387],
            [9.888561783447882, 0.5763164184671086],
            [9.89407261530669, 0.5637378052461514],
            [9.89660973616372, 0.5610829802436138],
            [9.902307580392108, 0.558646969420045],
            [9.921439958590932, 0.5568797892638585],
            [9.9349673613765, 0.5573855986519604],
            [9.941288937678815, 0.5530010860386733],
            [9.947733507724545, 0.5519762398647938],
            [9.9635503351618, 0.5459969897913125],
            [9.975331867010606, 0.5429649945785265],
            [9.98101417317523, 0.5430679708984065],
            [9.986233982940952, 0.5449265814575611],
            [9.992499356245702, 0.5497683516506012],
            [9.994333225091633, 0.5546962314983239],
            [9.998153410701006, 0.5536235014159763],
            [10.013362585702918, 0.5316873571723941],
            [10.01138738731449, 0.4438071551910188],
            [9.952793073779542, 0.41438006660315946],
            [9.935836391127921, 0.40191171495135236],
            [9.927833637381186, 0.3991986476483957],
            [9.853210161122105, 0.3530184495952745],
            [9.793948737345248, 0.38200671469237407],
            [9.783218630777274, 0.3930889230499163],
            [9.76523167339504, 0.4196666970954406],
            [9.753231250059404, 0.4689294669669626],
            [9.748220167741096, 0.4749426166872081],
            [9.745300796792268, 0.4741957145809769],
            [9.733942893775925, 0.47760326637698464]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.82413015299497, "lat": 38.59515506399023 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21161"],
        "coty_name": ["Mason"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mason County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00516924"
      },
      "bbox": [
        9.733942893775925, 0.3530184495952745, 10.013362585702918,
        0.6609033175538619
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.932374979324386, -8.272841201039052],
            [2.9889279237428052, -8.27038308952369],
            [2.9883186722945485, -8.256323752147175],
            [3.002584619027967, -8.255891452655558],
            [3.018111532997809, -8.254879000514347],
            [3.0325806878030295, -8.255643586767066],
            [3.062198123631184, -8.254634814476187],
            [3.1507293879735463, -8.251879558098388],
            [3.2376238764855882, -8.249240050631485],
            [3.2371206574202875, -8.23137714251013],
            [3.237799865528313, -8.223875528571423],
            [3.237219447072296, -8.205725370792019],
            [3.237413334057013, -8.199036092718746],
            [3.3258045775836136, -8.19584729148004],
            [3.360886289125632, -8.19499830184131],
            [3.3618863909484484, -8.196756568830319],
            [3.359664334778106, -8.201819639739139],
            [3.365093693193794, -8.213957687627662],
            [3.3653703708353766, -8.216655170469794],
            [3.369408732498053, -8.21792030644085],
            [3.368282393470119, -8.22075840172219],
            [3.3710153761181463, -8.228326035338462],
            [3.3739788537624316, -8.229653549724029],
            [3.3812900002821653, -8.23778543762541],
            [3.380894501685537, -8.240665103033514],
            [3.386363127254335, -8.242608093483973],
            [3.3860565414519965, -8.247325193532303],
            [3.3911933809014827, -8.252623365298332],
            [3.3914361100365684, -8.258664238804524],
            [3.3886652263571633, -8.262629925457366],
            [3.389634009357433, -8.265437183478202],
            [3.3851966169076593, -8.274329013395032],
            [3.387223759883807, -8.27994208112097],
            [3.385291125411997, -8.283149396252881],
            [3.384396100202606, -8.294726535218288],
            [3.3767817890198883, -8.296526942726441],
            [3.3728381539624745, -8.298942502929911],
            [3.368338777702324, -8.299443976638859],
            [3.364351952425125, -8.307420616307652],
            [3.3653700554653656, -8.310581952111358],
            [3.3699827337477597, -8.31549863493926],
            [3.3665044001261997, -8.319938640642375],
            [3.3689541489500496, -8.325498448344755],
            [3.368055516545007, -8.334588663199023],
            [3.3731901966613567, -8.338590722780149],
            [3.3764366475273953, -8.345158257425156],
            [3.376091758839282, -8.350693624432978],
            [3.370709610539763, -8.35375111400856],
            [3.370538653651837, -8.357803428767642],
            [3.3678671082933773, -8.36341914857139],
            [3.36919480203196, -8.368123746109411],
            [3.3750409510131782, -8.373099748963343],
            [3.3699325653424927, -8.381259080831498],
            [3.371839674241998, -8.382921472067096],
            [3.371823012599074, -8.388967867023963],
            [3.3737907636255553, -8.399420218075504],
            [3.3723137695650576, -8.406722162348146],
            [3.374167032833037, -8.413497343992418],
            [3.374475125465777, -8.42255438071543],
            [3.375472989182723, -8.426814159135754],
            [3.3733611015747695, -8.435388621318639],
            [3.376386639167315, -8.438717371312203],
            [3.373201401934199, -8.450101789122233],
            [3.376532200218964, -8.452710822997963],
            [3.383571845909195, -8.455799696587007],
            [3.386200078038044, -8.466634694958252],
            [3.391312388963149, -8.469029447837503],
            [3.3912001587954963, -8.470918718660831],
            [3.396285552581907, -8.473822569843168],
            [3.4027814859779286, -8.471821135128264],
            [3.4096536201896304, -8.475570706855324],
            [3.4049197281161523, -8.477494264605873],
            [3.4054642630196885, -8.48024530367409],
            [3.4020764498008167, -8.48207724515236],
            [3.4025456918990313, -8.486041111880503],
            [3.405605659577638, -8.486617443187281],
            [3.404322495946501, -8.492932900201026],
            [3.4055474973621354, -8.496559525106742],
            [3.401703559109227, -8.499958533318722],
            [3.3961849274537705, -8.499120225219885],
            [3.3946206421217524, -8.502703789855216],
            [3.385247585384558, -8.504928544528697],
            [3.388188315910177, -8.507980375213352],
            [3.3897195700350253, -8.515226267133778],
            [3.3920495257032943, -8.519771996469984],
            [3.3881662134394097, -8.523491432337293],
            [3.3866562750475926, -8.529446810775449],
            [3.3803374709317144, -8.531539159001445],
            [3.3799730413508833, -8.53596752028176],
            [3.3765211761276714, -8.538214301848445],
            [3.3749164618419516, -8.545824123660225],
            [3.3809731614035736, -8.546598257520351],
            [3.380484319570409, -8.55088601694244],
            [3.375702898107881, -8.552421333383842],
            [3.3758147104648875, -8.555536527552661],
            [3.3802526153248933, -8.557327598871252],
            [3.377805954810826, -8.561548175206342],
            [3.3798655973891107, -8.569190971402483],
            [3.3848626094730476, -8.574795229883232],
            [3.382952374129532, -8.579781360315332],
            [3.3851081583504365, -8.584378628012846],
            [3.379112519786319, -8.586707498287788],
            [3.3766224529359237, -8.587290251604085],
            [3.3749512379133715, -8.593924835055185],
            [3.375240995445223, -8.598868794372134],
            [3.3687126943890493, -8.607398632834409],
            [3.3650806702302045, -8.605112579420702],
            [3.358988894069102, -8.606476269678234],
            [3.3565430201198483, -8.601136088305301],
            [3.3540226215592526, -8.601319954265115],
            [3.3501390692490154, -8.610253323102238],
            [3.346276889518854, -8.610898607321408],
            [3.3405248628495956, -8.609006040784239],
            [3.338075937229081, -8.609627727495855],
            [3.328598120214159, -8.621303641194771],
            [3.3232867892926947, -8.62168874690269],
            [3.3193931918701565, -8.61944355435209],
            [3.318144361296049, -8.62678038088384],
            [3.312388245119421, -8.627245423402139],
            [3.3020783283727613, -8.633125039262435],
            [3.2956552755351325, -8.63286093851671],
            [3.292997803598426, -8.634998694724947],
            [3.287802764322891, -8.642410312372602],
            [3.2845064536139117, -8.644329729266282],
            [3.2670586757640274, -8.642947488661918],
            [3.2450700877370604, -8.644102494143082],
            [3.204138013620366, -8.645859850910762],
            [3.1713759934777896, -8.646731999343483],
            [3.1063378391123084, -8.649249934693602],
            [3.0602873318043624, -8.650623599720014],
            [3.0590171942850937, -8.606976205306891],
            [3.1135562110309998, -8.60540811550745],
            [3.1531229606584796, -8.603906158560218],
            [3.148620652987569, -8.595988941493255],
            [3.1456260945250034, -8.587785756804585],
            [3.141554773033119, -8.58588846395451],
            [3.14229519237543, -8.581736719519668],
            [3.138684224638769, -8.576380948719628],
            [3.1345515385060936, -8.574723953357895],
            [3.134269508183304, -8.56786179713208],
            [3.135854340700882, -8.557645179623954],
            [3.139884631464429, -8.556327398666355],
            [3.142065778160612, -8.551327063319851],
            [3.1495708702490677, -8.546243518740333],
            [3.1457104246645966, -8.536501972369123],
            [3.1457074864546324, -8.531187195835113],
            [3.115100315126895, -8.532238653264073],
            [3.056818989531326, -8.53337875378393],
            [3.0528178753699695, -8.430686085699142],
            [3.023865964342307, -8.431721965470066],
            [3.0231685222236933, -8.415707057198365],
            [3.0223110421541355, -8.385776867799438],
            [3.0199490338685977, -8.314021650654228],
            [2.933751344133283, -8.316029018409395],
            [2.9329364873794406, -8.293191680068228],
            [2.932374979324386, -8.272841201039052]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.81410014129779,
          "lat": 30.267705251913938
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22053"],
        "coty_name": ["Jefferson Davis"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Jefferson Davis Parish"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00558039"
      },
      "bbox": [
        2.932374979324386, -8.650623599720014, 3.4096536201896304,
        -8.19499830184131
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.956054561691449, 4.151163144420046],
            [8.001386412149307, 4.1563780378629],
            [8.032148767522312, 4.159586860387241],
            [8.117471388302377, 4.169482646497287],
            [8.13048475379536, 4.1709933747382095],
            [8.181898038364366, 4.175914113845737],
            [8.203641686162838, 4.17778201696858],
            [8.266957134933781, 4.184392508962164],
            [8.29572406044678, 4.187752706074181],
            [8.295279596466036, 4.187304552335274],
            [8.30091051978877, 4.144545167774327],
            [8.30637203028167, 4.101017874010193],
            [8.31675448531804, 4.014525487377649],
            [8.327894247820526, 3.9270096101792276],
            [8.338969642483391, 3.8406028705001747],
            [8.256749076020279, 3.83114400249943],
            [8.166530770901685, 3.8204956261408665],
            [8.116469794833526, 3.8145154202038114],
            [8.08144336587158, 3.810775815047775],
            [7.995364456850816, 3.8004253382268196],
            [7.987906516734799, 3.8619920321688834],
            [7.979748287805746, 3.928274533080956],
            [7.974099080392292, 3.9753303787561016],
            [7.96874640586614, 4.0259081754441866],
            [7.965093047242862, 4.062259195455533],
            [7.960314982643234, 4.112122534559469],
            [7.956352979063264, 4.150206788187552],
            [7.956054561691449, 4.151163144420046]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.53118853922986,
          "lat": 42.245451277044474
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26077"],
        "coty_name": ["Kalamazoo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kalamazoo County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01622981"
      },
      "bbox": [
        7.956054561691449, 3.8004253382268196, 8.338969642483391,
        4.187752706074181
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.98813952811747, 5.210711540263007],
            [8.05975393592682, 5.218562842393641],
            [8.074025918502848, 5.220268415163588],
            [8.134077630490298, 5.226922978277297],
            [8.159693377732607, 5.22946653663683],
            [8.245260802143706, 5.238684001286412],
            [8.302873170944281, 5.244263380198714],
            [8.331000338491421, 5.247273883929055],
            [8.388284050620538, 5.253739091691313],
            [8.416563649054298, 5.257190556090024],
            [8.502510641569001, 5.26715973993217],
            [8.513431529521398, 5.18080228297928],
            [8.52325490594547, 5.094325118796113],
            [8.530643453000962, 5.095161963235859],
            [8.543838817790482, 4.9752585412648855],
            [8.549923744302596, 4.92263580689237],
            [8.464151075159387, 4.913369896706708],
            [8.378031916713779, 4.90401891052722],
            [8.300140377753257, 4.894429911941419],
            [8.270467925588829, 4.891163953542768],
            [8.20689009201242, 4.8831157753251535],
            [8.200518519073732, 4.940832535967857],
            [8.189001783610262, 5.042577399698835],
            [8.187202748529744, 5.057681466769027],
            [8.151048512066058, 5.05382572294288],
            [8.047224255980323, 5.042071003786883],
            [8.007150795831272, 5.037733250420804],
            [8.004604615766082, 5.059380443505216],
            [7.992706123170809, 5.167981581514759],
            [7.98813952811747, 5.210711540263007]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.1525181436229, "lat": 43.31095061095782 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26117"],
        "coty_name": ["Montcalm"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montcalm County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01623001"
      },
      "bbox": [
        7.98813952811747, 4.8831157753251535, 8.549923744302596,
        5.26715973993217
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.610102300093039, 5.519649153384055],
            [7.6385656454834505, 5.5221311807739415],
            [7.6825326519437045, 5.526704621150645],
            [7.695299026375488, 5.5276442621776605],
            [7.744396085597489, 5.532325358678397],
            [7.781836587716604, 5.53647837679636],
            [7.841910481152875, 5.544281197473941],
            [7.949842201125833, 5.555950339134277],
            [7.959191900680799, 5.4695084993368095],
            [7.96703690333184, 5.398265378070313],
            [7.969055211008331, 5.383699855609835],
            [7.974598677737132, 5.331378758585945],
            [7.98813952811747, 5.210711540263007],
            [7.992706123170809, 5.167981581514759],
            [8.004604615766082, 5.059380443505216],
            [8.007150795831272, 5.037733250420804],
            [7.921360874541666, 5.027857056305021],
            [7.899269753223867, 5.025000920209752],
            [7.843212418929938, 5.018647882473864],
            [7.828715148410142, 5.017013565996195],
            [7.749906167706293, 5.008846893274225],
            [7.721268124346546, 5.006051472232655],
            [7.664204940570942, 5.000173734832329],
            [7.654916494520109, 5.0869002774396535],
            [7.647961022859189, 5.151700864363509],
            [7.645534196792943, 5.173269010284536],
            [7.636211539901904, 5.259548329412399],
            [7.628962494646734, 5.331836662965003],
            [7.620901058902523, 5.40730332747125],
            [7.6153267268615, 5.461668666058807],
            [7.610102300093039, 5.519649153384055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.80091522630441, "lat": 43.55418618603523 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26123"],
        "coty_name": ["Newaygo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newaygo County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01623004"
      },
      "bbox": [
        7.610102300093039, 5.000173734832329, 8.007150795831272,
        5.555950339134277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.886808340617424, 4.972764567246924],
            [8.946195655792751, 4.980543169860836],
            [8.99578862872719, 4.986430534107101],
            [9.030470252748355, 4.990701611647286],
            [9.115112216774168, 5.004413015666269],
            [9.202331475602898, 5.01653451428637],
            [9.214118611030665, 4.928899893777934],
            [9.224951398981409, 4.841429691433675],
            [9.224180673865083, 4.841295262546733],
            [9.237397144886348, 4.753896538784508],
            [9.251913949215714, 4.667291119354197],
            [9.216427597522904, 4.661635471517198],
            [9.145448477124006, 4.650880553992981],
            [9.081846622205763, 4.641621797243576],
            [9.060987164620265, 4.63872703107806],
            [8.933172189462494, 4.622355031772295],
            [8.92449840201908, 4.6886875943886235],
            [8.919707137858852, 4.726141279513704],
            [8.911078742529023, 4.789113539632359],
            [8.90965958980892, 4.800602698134636],
            [8.897771601810522, 4.886858140765734],
            [8.8881927081628, 4.962328148194208],
            [8.886808340617424, 4.972764567246924]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.14672388058833, "lat": 42.9537309182226 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26155"],
        "coty_name": ["Shiawassee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shiawassee County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "01623018"
      },
      "bbox": [
        8.886808340617424, 4.622355031772295, 9.251913949215714,
        5.01653451428637
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.986409514933093, 6.740463682015563],
            [1.0730050015579404, 6.740951981166395],
            [1.1593606240424439, 6.7415643446887605],
            [1.2452760976976565, 6.7431965365469075],
            [1.3319208853768378, 6.744163297629473],
            [1.3329479251310878, 6.657970394798913],
            [1.3337783944432606, 6.5714912530590555],
            [1.3379773350935182, 6.571554603141101],
            [1.3388450365233568, 6.515141867649872],
            [1.3395476597543825, 6.486379971470936],
            [1.3405597186051919, 6.399738875828074],
            [1.3413258275146531, 6.3132267667018755],
            [1.3421373981112195, 6.226343229753461],
            [1.2557451388875867, 6.225476294661706],
            [1.1739769569575353, 6.22409801953371],
            [1.1543115553058976, 6.223652362363121],
            [1.0875017635320452, 6.222919438616948],
            [1.046379206253862, 6.222321606302917],
            [0.9952704413075301, 6.221943378505999],
            [0.9947914010265507, 6.265106205883161],
            [0.9947003586886939, 6.308532565535686],
            [0.9950308295744373, 6.395204806595934],
            [0.9946334175299234, 6.452911506700021],
            [0.9946341814756868, 6.4817925507765555],
            [0.9939779644410912, 6.567553439801253],
            [0.9878230169928316, 6.567534071895338],
            [0.9876750233177279, 6.610273876618318],
            [0.987225803682989, 6.63931613891341],
            [0.9866843735343349, 6.6975276109937605],
            [0.986409514933093, 6.740463682015563]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.00471347718563, "lat": 45.15237946540788 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27067"],
        "coty_name": ["Kandiyohi"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kandiyohi County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00659479"
      },
      "bbox": [
        0.986409514933093, 6.221943378505999, 1.3421373981112195,
        6.744163297629473
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.395049283283499, -5.9452961468987],
            [6.463944305194539, -5.940190391345231],
            [6.495697034369055, -5.937643167743667],
            [6.529648053423192, -5.935305472655639],
            [6.5391146981488, -5.9337689576323065],
            [6.636852619042155, -5.92656249039173],
            [6.653177875274276, -5.924987233599134],
            [6.696011089531252, -5.9213923826621855],
            [6.754117452872502, -5.916910230997487],
            [6.834079571685108, -5.910294690225472],
            [6.832248827207829, -6.003466178280432],
            [6.8318890808503525, -6.040277177041143],
            [6.830218926604402, -6.10934268704427],
            [6.829603782972699, -6.115512238522623],
            [6.828435940357588, -6.181027235985083],
            [6.827399197393819, -6.239795353314662],
            [6.826667990946857, -6.2623956713042155],
            [6.708360507090549, -6.272595330220096],
            [6.665621144387327, -6.27629253032832],
            [6.584603825318025, -6.283709719235191],
            [6.543133584406095, -6.286497756674448],
            [6.511830796379438, -6.289552645147147],
            [6.422028343698391, -6.296941907320288],
            [6.417091256723208, -6.238535550480509],
            [6.41024269106308, -6.150044493550366],
            [6.408316064137259, -6.127916410272348],
            [6.403149938248011, -6.062057138109158],
            [6.403175336673171, -6.05877641091311],
            [6.4010790278341245, -6.0356683390325125],
            [6.3989348819718845, -6.0059841653664705],
            [6.3955366483616665, -5.963839581080954],
            [6.395049283283499, -5.9452961468987]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.6625453608551, "lat": 32.40425683998042 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28075"],
        "coty_name": ["Lauderdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lauderdale County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00695761"
      },
      "bbox": [
        6.395049283283499, -6.296941907320288, 6.834079571685108,
        -5.910294690225472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.2001167589177815, -4.03790063334736],
            [5.262350867911406, -4.034403026795343],
            [5.315969933464467, -4.031002003281285],
            [5.358957570495897, -4.028520666322164],
            [5.402085728056449, -4.02568506365565],
            [5.413295599459693, -4.0253777037226905],
            [5.517243937688899, -4.018584635468544],
            [5.518122640242729, -4.018388382197604],
            [5.589252384634566, -4.013350996746113],
            [5.59645595214367, -4.117018466630857],
            [5.597328696695198, -4.145839993464263],
            [5.5999860555288175, -4.1741801991025795],
            [5.600585584306256, -4.185358144607745],
            [5.603790570983155, -4.225963116652105],
            [5.6052428067861255, -4.2301809228372065],
            [5.613559685810807, -4.376175465062891],
            [5.615178989655738, -4.405303939363258],
            [5.543574423134146, -4.409615451727169],
            [5.504513587534984, -4.412104869275903],
            [5.482036633825081, -4.4132320496649715],
            [5.443021463330971, -4.415673559557906],
            [5.41461346795014, -4.417426940860356],
            [5.42112456585011, -4.421847549727662],
            [5.324562644474197, -4.427569225402244],
            [5.276140033320301, -4.4303898326303015],
            [5.27221107832138, -4.356756438901005],
            [5.270379407028364, -4.324493541026667],
            [5.269938502574744, -4.323914550492915],
            [5.219393176376228, -4.2915743139188285],
            [5.217551088560519, -4.252547919721987],
            [5.214101913510672, -4.252781410266129],
            [5.21292905411344, -4.229938232240592],
            [5.210965352159611, -4.198395965477953],
            [5.209596689994408, -4.166889677064861],
            [5.206308317512578, -4.123949287078369],
            [5.206015439387489, -4.123435272160477],
            [5.202859358514592, -4.081394335762027],
            [5.2001167589177815, -4.03790063334736]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.9506023294843, "lat": 34.36388343558979 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28107"],
        "coty_name": ["Panola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Panola County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00695776"
      },
      "bbox": [
        5.2001167589177815, -4.4303898326303015, 5.615178989655738,
        -4.013350996746113
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1888016243562447, 1.4456505214819766],
            [1.2472084764341789, 1.4454974171634274],
            [1.384395831467258, 1.444778654705158],
            [1.4276002290011445, 1.4451369742641922],
            [1.4705082631650328, 1.4453011725687102],
            [1.5200612971203824, 1.4457424164946093],
            [1.520851686879139, 1.3580562241987901],
            [1.5217762125567849, 1.358083906777559],
            [1.5232599540987328, 1.2844776621667804],
            [1.5251996575211886, 1.195622827927409],
            [1.5269618376914484, 1.1368608156043634],
            [1.4450067100256572, 1.1365644587211798],
            [1.3727396153418923, 1.1361863604396296],
            [1.3186353811955864, 1.1350797614318262],
            [1.3151733387831193, 1.143156292951761],
            [1.3106196807222668, 1.147316944963701],
            [1.3062344926085947, 1.1485574081459886],
            [1.2982674060574162, 1.1479322232091094],
            [1.2877715622223285, 1.1501207419471207],
            [1.2806888509587862, 1.1552716388639936],
            [1.2718411231652005, 1.163713307500725],
            [1.2680283010824474, 1.1705488126807473],
            [1.2680998617727348, 1.175054199845332],
            [1.2707835734642494, 1.1810256195228652],
            [1.2762921592176302, 1.1867866285540438],
            [1.2794070035985923, 1.1945472051002362],
            [1.2788499551504713, 1.2004480203165866],
            [1.2737532178520588, 1.2077104635611295],
            [1.2665738430923645, 1.2124374924762662],
            [1.2607145937112418, 1.2147973846991058],
            [1.2548218245925653, 1.215880929537977],
            [1.2408261345580236, 1.211492066344167],
            [1.2338216859010753, 1.2106078245933258],
            [1.228917913015685, 1.2116891353427033],
            [1.2287475425630539, 1.2290809215300464],
            [1.2232549959147536, 1.2315838857319104],
            [1.2197103957556314, 1.2350581160726255],
            [1.2223053438392608, 1.2375533880761227],
            [1.2194666931020322, 1.2414961438327343],
            [1.2216273563133695, 1.2467575867058918],
            [1.2252859894487684, 1.2517341650543994],
            [1.231932937879526, 1.2570715693219408],
            [1.229705244280553, 1.263024213813026],
            [1.2290780704741275, 1.2699422841086798],
            [1.2248340623510388, 1.2726126105573752],
            [1.2209805910964309, 1.2726951902486363],
            [1.2259562815273835, 1.2845193159051744],
            [1.224760171846024, 1.2884759919406785],
            [1.2190073212905106, 1.2948134238357623],
            [1.218479735778837, 1.302563765867952],
            [1.219717943488944, 1.3119236301726531],
            [1.2145115741018393, 1.315934302605273],
            [1.2145535147560191, 1.3208744926165883],
            [1.2167869777327327, 1.3231749291609345],
            [1.213760146210242, 1.3291344186603484],
            [1.215204818449897, 1.3324536756722387],
            [1.2149805209503768, 1.3376644236416069],
            [1.2193024700952666, 1.3422960844423406],
            [1.215096400387414, 1.346642922978798],
            [1.2168059006443392, 1.3486119737160618],
            [1.214040093781637, 1.351970035561574],
            [1.215925086863011, 1.3549255656405703],
            [1.210256747035693, 1.3577077214389806],
            [1.2143303391450442, 1.3618400503871515],
            [1.2105230066580082, 1.3654728738450839],
            [1.206717259503439, 1.367076025919619],
            [1.1943865970840652, 1.361002661350632],
            [1.1941531572853084, 1.3676427893882968],
            [1.1922998173103183, 1.3747093789885707],
            [1.1898340378222947, 1.377408456817149],
            [1.1776145551976662, 1.3809809018538348],
            [1.1784127499057404, 1.3853067349848693],
            [1.1772416421720326, 1.389687694704742],
            [1.1841678298931362, 1.3901934128570934],
            [1.189012445591215, 1.3935480018204338],
            [1.189803014883602, 1.398848378362285],
            [1.1888698120802093, 1.4041011056532522],
            [1.1914371421527208, 1.4070939731300371],
            [1.1882348645444516, 1.413556574140262],
            [1.192407257595379, 1.4163436607530404],
            [1.1900607382975918, 1.4206589216264238],
            [1.1939164128119848, 1.4235356981191793],
            [1.1910187484264891, 1.4266004323386794],
            [1.193710041461702, 1.4310321215085466],
            [1.1869151795180954, 1.4350522924293974],
            [1.1892868447190537, 1.4379552609511073],
            [1.1862136275033612, 1.444695420936567],
            [1.1888016243562447, 1.4456505214819766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.80213835101681, "lat": 39.98353592041212 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29003"],
        "coty_name": ["Andrew"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Andrew County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00758456"
      },
      "bbox": [
        1.1772416421720326, 1.1350797614318262, 1.5269618376914484,
        1.4457424164946093
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2013796272381465, 0.6040363193579744],
            [3.217698304051013, 0.6040219540008982],
            [3.2902016808992616, 0.6050629997915543],
            [3.3791602445579163, 0.6044181461293401],
            [3.4515138333191397, 0.6047861107961175],
            [3.451978810431806, 0.5634964272017846],
            [3.452322906162749, 0.5604440389762378],
            [3.4528212186063754, 0.5324303085447399],
            [3.453299924794521, 0.5240333351539379],
            [3.4530570404182948, 0.5124603550023316],
            [3.4536298168202477, 0.44996815550723984],
            [3.4541581841097, 0.4274630346294902],
            [3.4379143210049095, 0.4270826410570677],
            [3.437305073903263, 0.4219136962715161],
            [3.438705457462009, 0.4178066983692772],
            [3.4381905725871995, 0.4132488448472218],
            [3.4409003473336344, 0.4110574427991319],
            [3.437796986264352, 0.40752482065359485],
            [3.4358024446890845, 0.3945745933412118],
            [3.4321975174248327, 0.392142411232207],
            [3.432411060688625, 0.3893693189686306],
            [3.4370732210038444, 0.3895538274925215],
            [3.4402198946430276, 0.38758322257826866],
            [3.43822188160822, 0.38023365384019486],
            [3.4388471090603026, 0.37473189289760567],
            [3.434950227003565, 0.3677679191489323],
            [3.4366478148587456, 0.36150235154132815],
            [3.435110406509466, 0.35835085126848143],
            [3.4366095043138705, 0.35367372135985026],
            [3.4341075404206984, 0.3446556481254827],
            [3.429954438686861, 0.34235596443270394],
            [3.429523348942447, 0.3389261225974514],
            [3.432747451178317, 0.32909571364989665],
            [3.4288735738791885, 0.3221855372894806],
            [3.4304880518137857, 0.31976018193069006],
            [3.427624940495922, 0.31463415436043174],
            [3.426060922160417, 0.30443063229596723],
            [3.426976437152646, 0.3021749257986327],
            [3.426092016935024, 0.29379958211859436],
            [3.4273009487811055, 0.2921266705429512],
            [3.425758545352333, 0.2843228674981072],
            [3.426235472338012, 0.2784661725310445],
            [3.424133600669906, 0.2718957800662461],
            [3.4192820083880857, 0.26722120043716907],
            [3.418752545478146, 0.2610580488407065],
            [3.419970405159595, 0.2576816465284614],
            [3.425040076548564, 0.2528239598039777],
            [3.4241540116730627, 0.2490371454436166],
            [3.4273454581788796, 0.24454826772861407],
            [3.432014374944361, 0.24624003094907673],
            [3.4314381082932908, 0.24024154095346942],
            [3.426500827319839, 0.2408621199986989],
            [3.424357366241118, 0.23293995847266305],
            [3.424968983201956, 0.22960879397865902],
            [3.422375309184937, 0.22641584748723761],
            [3.4257836178906222, 0.22463668750144536],
            [3.4300440564778363, 0.22770020544380826],
            [3.4323749454372283, 0.2265345478720401],
            [3.4340166334019724, 0.21872919936310747],
            [3.4289348509782993, 0.21489452410938256],
            [3.4323822612064916, 0.21159638850560675],
            [3.4361418208386487, 0.21362539270785233],
            [3.434267326357085, 0.20563798526725452],
            [3.4400933102643028, 0.2058916491525707],
            [3.4394143182615307, 0.20257581650891038],
            [3.4323149436498728, 0.19872266212004722],
            [3.4366333601355867, 0.19289424285040682],
            [3.4309764723027443, 0.18784876366303918],
            [3.4320962773016572, 0.1844522682857004],
            [3.439215757342612, 0.18174177012831774],
            [3.4380433083474795, 0.174896321581327],
            [3.4428913700359347, 0.17795003013618804],
            [3.445331321643168, 0.17416577118963597],
            [3.4384862941827232, 0.16618934522757944],
            [3.4334585196366993, 0.1654498709184611],
            [3.435005053886093, 0.16150173753566643],
            [3.438477752148237, 0.15796827796468685],
            [3.4354475291483233, 0.15620829589664142],
            [3.4313696585556137, 0.1637201165255541],
            [3.4272680350231175, 0.15982328056251968],
            [3.4303183340621994, 0.15528507730229785],
            [3.4302619573286335, 0.15228756994741008],
            [3.427155618796162, 0.14953353070473496],
            [3.4287130871306077, 0.14412849475139056],
            [3.423769456830702, 0.1415721651784801],
            [3.4268001751679105, 0.1311425492971402],
            [3.4258282965558475, 0.12388499638884723],
            [3.4197767124763, 0.12402481835710188],
            [3.4175074760723168, 0.11900196265642353],
            [3.416336019139587, 0.11241054829487346],
            [3.411945834675874, 0.11063629153840934],
            [3.412156795424722, 0.10731100900206048],
            [3.4089451123357373, 0.10368754786632468],
            [3.412791225902216, 0.09987469318683419],
            [3.412296644387999, 0.09654226180039677],
            [3.409260036617243, 0.09387978179062197],
            [3.403473148602492, 0.0946299129189896],
            [3.40209877783493, 0.0925386245792928],
            [3.4047861785397164, 0.08384148485708055],
            [3.402775457988489, 0.08131945568558228],
            [3.3959030895639546, 0.07759252269812224],
            [3.3897770900738737, 0.07716306714111346],
            [3.386758741556943, 0.07136156397369983],
            [3.3885644766493757, 0.06398890191314992],
            [3.3877795662789474, 0.059267731741842994],
            [3.3839185822251356, 0.05819140355601029],
            [3.379933765454151, 0.05427177680879229],
            [3.383959745628291, 0.04669516878373669],
            [3.3861808067565975, 0.045626487337009476],
            [3.38632256937284, -0.0007356403156732748],
            [3.379452893273811, 0.0018815257690163775],
            [3.3667076128558238, -0.0006645519991877565],
            [3.3624285212673137, -0.0006486015769620339],
            [3.3540929862571542, 0.0012612759950740384],
            [3.3431054058303125, 0.012764038801482027],
            [3.3292039838418956, 0.020657138171705954],
            [3.3101440305681264, 0.024177199643991044],
            [3.295011187696877, 0.025978975801654845],
            [3.2845983748232817, 0.02886737081547256],
            [3.2789089073183852, 0.03180072206892879],
            [3.2741749822993023, 0.03838251563578611],
            [3.27563060158039, 0.04432934146309411],
            [3.289155428713447, 0.058018251038454774],
            [3.2893586861264814, 0.06479226003539573],
            [3.2867688531174832, 0.07065947488440172],
            [3.275095676336441, 0.08280081685318019],
            [3.272003984260364, 0.08423147067658017],
            [3.2535906791436235, 0.08733543702064654],
            [3.2480005381659804, 0.09085873465402665],
            [3.2414492671161, 0.097139924148448],
            [3.238264442575305, 0.10415415308846236],
            [3.235815249557775, 0.11580691870712469],
            [3.236239252162761, 0.12180272045913787],
            [3.2388804558208064, 0.12600702008869327],
            [3.249562930173634, 0.13283342179631796],
            [3.252841494520599, 0.13696648254537694],
            [3.255705880244221, 0.14417587861842046],
            [3.257430495643729, 0.1528000137724696],
            [3.255794339619917, 0.1614840281574307],
            [3.2531542308926387, 0.1682100010112872],
            [3.2481685317626865, 0.17146598240109778],
            [3.2430822503213954, 0.17221463142865434],
            [3.2279786494855838, 0.17067238203314009],
            [3.224623133517384, 0.17144011624022445],
            [3.2160176355115286, 0.176486772568271],
            [3.2097454049142935, 0.18259379558976221],
            [3.205664865431309, 0.1895117878522116],
            [3.201096654441743, 0.20072107835446715],
            [3.1956961355791877, 0.21129226760742476],
            [3.1863406846355207, 0.21938062535745842],
            [3.1789350539921712, 0.22465065002246773],
            [3.1767218984771795, 0.23184230668483707],
            [3.180062096847744, 0.2461396213818486],
            [3.1806294882035484, 0.25248759851299796],
            [3.1765695604654645, 0.2586851504305044],
            [3.1685349714305215, 0.2654673987069413],
            [3.166934962112896, 0.2681574637748185],
            [3.161290956715387, 0.2724725666071904],
            [3.1529810802503317, 0.28290265529434444],
            [3.1479075004855352, 0.28817624028885397],
            [3.1388468334658275, 0.2945752477232705],
            [3.1279867119052014, 0.3032132784422972],
            [3.1240514164405067, 0.30910469097495763],
            [3.113536201209107, 0.31983743726149705],
            [3.112604444249192, 0.3223102539627415],
            [3.107322052388935, 0.32322136780772104],
            [3.1039188566223688, 0.3286187088784508],
            [3.1098644020206145, 0.3355995732803321],
            [3.1071873736654494, 0.3397975166656282],
            [3.109306908451175, 0.3461733609279824],
            [3.1093487399355975, 0.35250940579150253],
            [3.1278880181650766, 0.3991468151356271],
            [3.1388759085976248, 0.42811798731649475],
            [3.1521496012630537, 0.46485288868861435],
            [3.1699541467991192, 0.5161873430252192],
            [3.2013796272381465, 0.6040363193579744]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.30967429809186, "lat": 38.99056711289162 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29019"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00758464"
      },
      "bbox": [
        3.1039188566223688, -0.0007356403156732748, 3.4541581841097,
        0.6050629997915543
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.349339922939877, 0.274137491104734],
            [4.348894867150654, 0.2967826574806048],
            [4.355218456129043, 0.2976273161627966],
            [4.359049405110534, 0.2951224467364801],
            [4.362641708817859, 0.29062529970520484],
            [4.364782835622118, 0.29237135083432164],
            [4.3683236490672925, 0.2903529707607956],
            [4.374058173598043, 0.2934175314688625],
            [4.376486437629839, 0.2923289559144642],
            [4.387346181193805, 0.29639382888385296],
            [4.392474238445793, 0.29510480667704697],
            [4.395667481470409, 0.2919689419467544],
            [4.406480260730946, 0.29325355131464625],
            [4.408278263207929, 0.29514523477847854],
            [4.415628418947396, 0.2957511853559963],
            [4.420791910509268, 0.29516270692436936],
            [4.425146205450346, 0.28931625726665877],
            [4.427653377784434, 0.29234899622870997],
            [4.437647160840339, 0.2916099658731312],
            [4.447061894093907, 0.2868203466396506],
            [4.450188607935514, 0.28775102642695666],
            [4.453608068554816, 0.2853366577607562],
            [4.457401643845567, 0.2851128422393318],
            [4.46076548462815, 0.2883179199528662],
            [4.466174914054327, 0.2886763091977263],
            [4.462732407884792, 0.2951507572285218],
            [4.464731186549086, 0.3050067955661289],
            [4.463410709328799, 0.30929174601207887],
            [4.4651291386855565, 0.3115900906265425],
            [4.469622446338288, 0.3111676361927552],
            [4.4708612629046875, 0.31652395885438683],
            [4.465784664972004, 0.32113706334171094],
            [4.475471569735403, 0.32849929030751884],
            [4.482619731950193, 0.3295631920324972],
            [4.485322613645533, 0.3336847235139193],
            [4.493346812698377, 0.3339656801874535],
            [4.499188296301272, 0.33173555597733967],
            [4.50395918306938, 0.3329515357631835],
            [4.507566842896301, 0.336625432202502],
            [4.510366646061823, 0.34214575266930886],
            [4.513489427286966, 0.343609952701161],
            [4.522821245736357, 0.3445066248166693],
            [4.527067084839162, 0.33947505322601224],
            [4.525424745413218, 0.3360468015968306],
            [4.519017861435424, 0.33273544293869345],
            [4.520049725003544, 0.3272947129819325],
            [4.525720496942044, 0.32855495384644035],
            [4.528104039147933, 0.3275376282527513],
            [4.527341419155816, 0.32316318491904555],
            [4.532674254867084, 0.3239956323305043],
            [4.538110087764371, 0.32206344571474765],
            [4.5394405280443655, 0.3170682737721242],
            [4.5419188971906745, 0.31754518116536706],
            [4.546836554131603, 0.3223225783334774],
            [4.543538858059611, 0.3265455002939945],
            [4.538359270169513, 0.3276350381720295],
            [4.535447001033862, 0.3259327398376928],
            [4.5324281502728345, 0.3290987288684428],
            [4.539917309583061, 0.33569842117516135],
            [4.544921415578394, 0.33428676350823794],
            [4.548017756502226, 0.33066650371555617],
            [4.550611910155641, 0.33026435607207133],
            [4.557844142635006, 0.3323000249775093],
            [4.553446709821068, 0.3386007062551211],
            [4.547113517086956, 0.3428357200514795],
            [4.547544216143236, 0.3475447940366715],
            [4.551308592908739, 0.34922245170561356],
            [4.572963497543947, 0.35042255533844036],
            [4.573323864577809, 0.3435285833859758],
            [4.586636528864503, 0.328816869079193],
            [4.595867792925572, 0.3210919614484054],
            [4.60227350684617, 0.30899110737389623],
            [4.605030894884782, 0.3061507172355879],
            [4.628722851727923, 0.29373795811899456],
            [4.638280458561846, 0.2881945143338114],
            [4.6434545909468055, 0.28778803271161185],
            [4.651248423449588, 0.2887504406529392],
            [4.659500037872121, 0.29118311420398935],
            [4.66823141981752, 0.2959977071192803],
            [4.677472302169452, 0.3086938235447548],
            [4.687683079622606, 0.3211559759881316],
            [4.694772351807941, 0.325559582953628],
            [4.6999693989776015, 0.3335882046089059],
            [4.70916971565093, 0.34987266981746895],
            [4.711926688252035, 0.35886196063266607],
            [4.7115909835593035, 0.36870111958258994],
            [4.718665606624931, 0.38365386599492096],
            [4.725809494803341, 0.38961644975357046],
            [4.7345257672704895, 0.3936011050871203],
            [4.742799204552732, 0.39368599357605155],
            [4.754812814078884, 0.3907708314525568],
            [4.768999841239836, 0.39036034293168015],
            [4.777261000817231, 0.38830187269771826],
            [4.787290452295815, 0.38425832809647303],
            [4.816374631039509, 0.37115425584718803],
            [4.826740646856824, 0.3643877460048217],
            [4.839351946746438, 0.3595006859365879],
            [4.845824642000394, 0.3560529328551642],
            [4.854131408039787, 0.3558180243048637],
            [4.865628145304642, 0.35716988958282925],
            [4.871815821578611, 0.3569357004064936],
            [4.881943891232123, 0.3544075863140089],
            [4.88637869966915, 0.35509956395776376],
            [4.8916532513135484, 0.3539835238063035],
            [4.898501835967675, 0.34983066015171166],
            [4.907488464929841, 0.34636261219718045],
            [4.9133129842175824, 0.3432058369048803],
            [4.921064077954075, 0.3366629396534431],
            [4.9340924508854105, 0.3245043401032164],
            [4.942487042776085, 0.3223878814050751],
            [4.95880046762667, 0.3145879845452957],
            [4.970839168100457, 0.30602217787618635],
            [5.001340646360758, 0.2898584724600936],
            [5.0047185140606905, 0.28424307822299866],
            [5.005330990549738, 0.2781101462505074],
            [5.002418804368142, 0.25526891949170527],
            [5.000688988310945, 0.24575348183293866],
            [4.995920608451409, 0.2558647948002247],
            [4.992728629427768, 0.26101975478585904],
            [4.980803716369263, 0.26849922537312737],
            [4.973624021709975, 0.2685390093468056],
            [4.9678682778272725, 0.2670333737659946],
            [4.961207858357394, 0.262421631995606],
            [4.956804604267939, 0.2578509247022868],
            [4.949587836546184, 0.25505232678939743],
            [4.945039292122115, 0.2552360338894984],
            [4.939670102178032, 0.25769040550573247],
            [4.907706347347852, 0.27729708319873747],
            [4.891223379877002, 0.28596724864868056],
            [4.8814088005129666, 0.29438468393094624],
            [4.874793695027696, 0.305380245042739],
            [4.8649607297854, 0.31424147672753433],
            [4.856263845316864, 0.3199009224881225],
            [4.848372297365427, 0.3220046649815343],
            [4.8395376876077725, 0.3223262097682596],
            [4.830729388567611, 0.31711462173626015],
            [4.827607441532948, 0.312939066592748],
            [4.824783362527349, 0.3035794410020086],
            [4.823777578266385, 0.2965039439874041],
            [4.824335088724999, 0.28844539806287195],
            [4.822999167557419, 0.2790835060944871],
            [4.820265993406606, 0.27115566065920343],
            [4.8110451175352535, 0.25661368566750314],
            [4.805287762897209, 0.2521957826447006],
            [4.795913336529021, 0.24973079312825272],
            [4.786037794299368, 0.25041644723817563],
            [4.769869146791697, 0.25520758879933414],
            [4.757930612289741, 0.2554469227456458],
            [4.75063156304951, 0.25283849107017253],
            [4.744203657374342, 0.24461577238698143],
            [4.727696140812753, 0.21440858264081172],
            [4.722009567601699, 0.1862577784306284],
            [4.720294456080549, 0.18186667744626542],
            [4.71277493912865, 0.1703320195336991],
            [4.698412691675738, 0.1608714422183043],
            [4.687630739619289, 0.1531958315527424],
            [4.684831319629258, 0.14708857256513602],
            [4.688430530836226, 0.12840691766922085],
            [4.688997609698807, 0.11876547656785798],
            [4.6867467976206365, 0.11184423411267322],
            [4.682797909408827, 0.10642138684388301],
            [4.674262625818474, 0.10145651760696783],
            [4.669564999197822, 0.10034150709160196],
            [4.660562828555189, 0.102266424523032],
            [4.652097800892136, 0.0993097841918341],
            [4.645089567246094, 0.0979158074253249],
            [4.639993842669313, 0.09888874830336034],
            [4.633206410999933, 0.0987302218697925],
            [4.627254900093784, 0.10067990853112575],
            [4.617368639111608, 0.10622906412930082],
            [4.610499132044067, 0.10664745127649153],
            [4.59918967018532, 0.10544464522148861],
            [4.5891392337736585, 0.10288740391341937],
            [4.5786764390790715, 0.09586973335566563],
            [4.577224999402514, 0.08323878650534683],
            [4.575969742721033, 0.07893905583729453],
            [4.571643431863935, 0.0758963764395505],
            [4.561825943436607, 0.07285658258028362],
            [4.557015818214154, 0.06768223988071939],
            [4.557739998578641, 0.06236468032077901],
            [4.556495977998275, 0.05929371355863835],
            [4.552582651848831, 0.056535189592963817],
            [4.53646238486523, 0.05013851342754872],
            [4.528938432054593, 0.0449289288845239],
            [4.527879751813376, 0.041155817841848456],
            [4.523061613312826, 0.03503689761025204],
            [4.519449395900632, 0.02024330028519294],
            [4.514585975135386, 0.011153372569784787],
            [4.507047988459051, 0.00332325461210135],
            [4.501316940602097, 0.0003200212642783819],
            [4.4902005708383435, -0.0021165056199866617],
            [4.477122631658531, -0.007482973733181534],
            [4.465136897573529, -0.0185143055929234],
            [4.460327855197378, -0.02434199497951192],
            [4.449910224955781, -0.03252357314927363],
            [4.432250944216618, -0.04193728512252684],
            [4.4178779774358645, -0.054554415582649826],
            [4.408779951999603, -0.059760574186326895],
            [4.399810855886792, -0.06306463209252151],
            [4.394621995508248, -0.06393986862406226],
            [4.387183845123363, -0.0634442774677621],
            [4.375475165161386, -0.060101236924493845],
            [4.3704475981565825, -0.05771822819859596],
            [4.36206619955295, -0.05211219593963795],
            [4.3605544141251364, -0.0156522133591595],
            [4.357398522027526, 0.05039411439377883],
            [4.352286724894036, 0.16249942689871705],
            [4.350335689711998, 0.21893821138393701],
            [4.349339922939877, 0.274137491104734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.67487085422927,
          "lat": 38.781975933804794
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29183"],
        "coty_name": ["St. Charles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Charles County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00758546"
      },
      "bbox": [
        4.348894867150654, -0.06393986862406226, 5.005330990549738,
        0.39368599357605155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.896089272567714, 11.466151800868449],
            [-11.861770126371267, 11.459537934705189],
            [-11.796719834120923, 11.44715922017012],
            [-11.731672390795266, 11.43476515304403],
            [-11.667151575621888, 11.422581511544962],
            [-11.585740716869587, 11.40653359585137],
            [-11.5689770801402, 11.402139850194288],
            [-11.553535258612833, 11.398771170894744],
            [-11.539822215947977, 11.396614174304306],
            [-11.466894724006442, 11.38204041142292],
            [-11.46627450482413, 11.375319472608918],
            [-11.4616346860489, 11.368404239038039],
            [-11.464055607494595, 11.362751105074032],
            [-11.463125992655046, 11.355073571803672],
            [-11.461685565832344, 11.353301151059942],
            [-11.461902753087632, 11.346042506974518],
            [-11.459885409202476, 11.344918732080778],
            [-11.447023912607083, 11.344586086983474],
            [-11.443246856614584, 11.340533163190713],
            [-11.44706517939473, 11.337181788653563],
            [-11.46000761166844, 11.328452628600063],
            [-11.46063147705319, 11.323379107690819],
            [-11.465077576016643, 11.320351315143425],
            [-11.462403410430781, 11.315262604321918],
            [-11.45862633822026, 11.313920768354699],
            [-11.45094576879588, 11.314482920361787],
            [-11.448724384731326, 11.307478663217365],
            [-11.446008624206636, 11.305417033849947],
            [-11.447261626392903, 11.302224886250201],
            [-11.448244212959278, 11.289357329940755],
            [-11.452577491379074, 11.284770154832943],
            [-11.466547346476963, 11.279835856523192],
            [-11.47218317899862, 11.279608215450443],
            [-11.477318443923298, 11.281558096130167],
            [-11.480789053164903, 11.27630595749635],
            [-11.464869192111632, 11.264291380419944],
            [-11.462387445028027, 11.254752206764907],
            [-11.458633345977193, 11.24813423662038],
            [-11.4516805192437, 11.247033444180731],
            [-11.450637999445572, 11.24375338719259],
            [-11.444789272644279, 11.23504577991604],
            [-11.443879066039536, 11.226609940568098],
            [-11.44494521588988, 11.222102256533661],
            [-11.447489591344445, 11.220635952025516],
            [-11.451592180691389, 11.221416027914383],
            [-11.455940442245163, 11.216505645059998],
            [-11.45157381558477, 11.21206288174492],
            [-11.442123183419385, 11.206561647857226],
            [-11.439557383021844, 11.200056247543],
            [-11.435985314771008, 11.202933414071069],
            [-11.431767066603891, 11.201975876477757],
            [-11.4279402479325, 11.195708245881779],
            [-11.425182731134349, 11.195842580287303],
            [-11.41787689806226, 11.19988127044062],
            [-11.40677646537177, 11.203340018522143],
            [-11.402613618438574, 11.207184673020663],
            [-11.399698568228859, 11.207757263634855],
            [-11.396198213515712, 11.21175859113743],
            [-11.395586091597272, 11.215171245632474],
            [-11.39182466032193, 11.219660418722167],
            [-11.389493280564858, 11.217244738112516],
            [-11.384793731731829, 11.216640347279434],
            [-11.380442003085253, 11.213138822435113],
            [-11.379902031072678, 11.210501703832081],
            [-11.371173200375459, 11.204622889258914],
            [-11.368742150590661, 11.20877765534711],
            [-11.36264045668827, 11.212892670585605],
            [-11.355639291924087, 11.215477510760612],
            [-11.350571361258794, 11.215643690358528],
            [-11.345425593428535, 11.218148014755554],
            [-11.344464535482146, 11.213965938119571],
            [-11.337431655480486, 11.209721650595748],
            [-11.331884827759643, 11.20803697795564],
            [-11.332452534372738, 11.202777806898151],
            [-11.330946871445098, 11.199529498211765],
            [-11.325027434855887, 11.197607471739381],
            [-11.320471331711888, 11.200406368805574],
            [-11.313929338262, 11.202113194249183],
            [-11.312328679393186, 11.196417618196953],
            [-11.312963760278068, 11.189513940009805],
            [-11.308031093359622, 11.181821701454774],
            [-11.302542873530255, 11.17623710284817],
            [-11.296941981351074, 11.172108374950904],
            [-11.299555345349635, 11.170034187739796],
            [-11.300520576723416, 11.16497291307422],
            [-11.304222572170483, 11.159036429946896],
            [-11.310538602070148, 11.157381894270548],
            [-11.3118135179587, 11.15404166877473],
            [-11.311551440076348, 11.143427590473127],
            [-11.309316523733306, 11.141649627594939],
            [-11.309472657965037, 11.135409408936646],
            [-11.308288997338446, 11.129783114227143],
            [-11.303757892361784, 11.124505243563133],
            [-11.297366140683362, 11.119777210143896],
            [-11.298500127623747, 11.117062248024661],
            [-11.297381032995638, 11.107529156884699],
            [-11.29554747773818, 11.103817777354942],
            [-11.291044490589632, 11.098866567877648],
            [-11.283288722720808, 11.094831189349632],
            [-11.280345850885686, 11.082661394571419],
            [-11.283234918620058, 11.076573105070905],
            [-11.279614518359475, 11.071710612052819],
            [-11.280149806291094, 11.068364225411704],
            [-11.283435877713144, 11.065233236967968],
            [-11.28709063243949, 11.057603833120014],
            [-11.29526317406785, 11.049937116092071],
            [-11.299250859232414, 11.049372703194875],
            [-11.304124638658212, 11.050944179827777],
            [-11.309219144342947, 11.050566675586962],
            [-11.309010242315273, 11.042264244243848],
            [-11.306394081586795, 11.035227238598248],
            [-11.306508079065914, 11.032528801244277],
            [-11.303539606831999, 11.028329725742132],
            [-11.313709857124246, 11.022000521524223],
            [-11.316650129748107, 11.0151079526065],
            [-11.319881562583523, 11.012896124387412],
            [-11.323051475312385, 11.000353095387302],
            [-11.320810606875776, 10.996046196894927],
            [-11.324554216841282, 10.992622585206135],
            [-11.326425249514617, 10.985681337665838],
            [-11.33172640858685, 10.981264708985398],
            [-11.330147361076602, 10.976815834890063],
            [-11.32223292461455, 10.969835191971933],
            [-11.32069931810095, 10.96971401310599],
            [-11.315705007582542, 10.960034523489403],
            [-11.312569178627118, 10.959984495134115],
            [-11.305813222430663, 10.95291304770188],
            [-11.2967300177191, 10.949223292228206],
            [-11.290974931507213, 10.949648870443367],
            [-11.287549607619146, 10.948227149816661],
            [-11.27832429869243, 10.938863267032795],
            [-11.27001622114603, 10.942479611746563],
            [-11.26095851656436, 10.950398869368595],
            [-11.255351491034128, 10.947652775262796],
            [-11.252867058767048, 10.944954625084184],
            [-11.247675170068916, 10.93613552488329],
            [-11.246783722721686, 10.92795093541344],
            [-11.244146106471119, 10.924006115125795],
            [-11.23886032755682, 10.921058804575344],
            [-11.231843205727863, 10.923175402004459],
            [-11.228057843412662, 10.927523102698963],
            [-11.222582559179846, 10.927216795379634],
            [-11.21941344557509, 10.921424366681737],
            [-11.209612480506792, 10.924397795446003],
            [-11.201949712108206, 10.923949872495013],
            [-11.199406894755207, 10.925715087314149],
            [-11.197685858263958, 10.919130197728027],
            [-11.188028622030131, 10.910713857902696],
            [-11.184252304723188, 10.90900256984658],
            [-11.18229621890464, 10.895691544394687],
            [-11.177179839363879, 10.893047623034274],
            [-11.171800117410788, 10.886367873398745],
            [-11.166200240359663, 10.886945634851644],
            [-11.159337230956158, 10.884246066485787],
            [-11.156274413650278, 10.878816145262151],
            [-11.160017837713244, 10.867981251175252],
            [-11.160238505149549, 10.862432540628506],
            [-11.1638531354909, 10.85791155739172],
            [-11.16491004047937, 10.850721735190227],
            [-11.168141834224242, 10.838711341849114],
            [-11.168076723987179, 10.836303771187376],
            [-11.164333444797068, 10.83146855599152],
            [-11.170051000574786, 10.822036221992372],
            [-11.168670076408192, 10.81315916514427],
            [-11.168962631141092, 10.808938507572039],
            [-11.174478672448299, 10.805314564373662],
            [-11.177934741075136, 10.799072351870155],
            [-11.181041358594015, 10.79643745624801],
            [-11.181120720036676, 10.789976464241354],
            [-11.17722118022608, 10.788260131821122],
            [-11.175104079030616, 10.783894291902804],
            [-11.171229022776846, 10.780280744698029],
            [-11.164792367534027, 10.779738163714063],
            [-11.161123109673415, 10.775396264948364],
            [-11.157958385579878, 10.767640953496018],
            [-11.155033842281872, 10.764705166580809],
            [-11.14929520016008, 10.761935428980248],
            [-11.143664099288747, 10.751264270026144],
            [-11.132656978454467, 10.745664696336785],
            [-11.127561411319823, 10.743816293858437],
            [-11.123348592039582, 10.743796535641504],
            [-11.119998909014459, 10.746265351434074],
            [-11.112828517528484, 10.747877257952394],
            [-11.105454706949791, 10.747492500920403],
            [-11.102225863997685, 10.735694716633068],
            [-11.105244244460057, 10.729499651923685],
            [-11.104530531124908, 10.71799345105116],
            [-11.09681188224867, 10.710183330854205],
            [-11.098281622985256, 10.704496633614493],
            [-11.10358184397553, 10.694960397457765],
            [-11.113446892771718, 10.687363822110068],
            [-11.122479511339021, 10.682814161884615],
            [-11.12727869145683, 10.68189932280541],
            [-11.131876895069793, 10.677219143334362],
            [-11.140015731277282, 10.671227784199715],
            [-11.135772362759381, 10.66577982331486],
            [-11.133712124238093, 10.660809835414534],
            [-11.13527706207556, 10.653797027277328],
            [-11.13079401244276, 10.651461285876804],
            [-11.130198238324569, 10.648547780812972],
            [-11.123763781418303, 10.644349661042524],
            [-11.12108311823501, 10.63769116570077],
            [-11.121677953457832, 10.630720914661088],
            [-11.113161511976031, 10.624285038959389],
            [-11.110976201974141, 10.620957579529053],
            [-11.111805496210263, 10.61711214554729],
            [-11.107655337729451, 10.612943547177231],
            [-11.100121559724496, 10.611093138927695],
            [-11.092003931427824, 10.606760984248664],
            [-11.090399509955494, 10.596488942196421],
            [-11.088351622891206, 10.591640365555104],
            [-11.089868542568293, 10.587560986335601],
            [-11.084625775730833, 10.584663632313283],
            [-11.081269818326382, 10.580099531429239],
            [-11.076309739860147, 10.579790798002836],
            [-11.070987451597183, 10.57404740667454],
            [-11.06538075247587, 10.573112955648575],
            [-11.061240769772459, 10.565189406057245],
            [-11.058207713971901, 10.563894974778925],
            [-11.058091114985716, 10.555316355849612],
            [-11.054240242170254, 10.551832816139704],
            [-11.053785204966905, 10.547692643664297],
            [-11.056190024671736, 10.545905654797048],
            [-11.056510524396483, 10.540882976803463],
            [-11.059396141928868, 10.53761876590482],
            [-11.063477192768268, 10.535918986371108],
            [-11.063721767674862, 10.530223525427466],
            [-11.065303890669155, 10.528947791424562],
            [-11.064473817451482, 10.522231221279382],
            [-11.065679534355207, 10.519311600897405],
            [-11.065052146640358, 10.513053124915427],
            [-11.066970092088946, 10.508903567197091],
            [-11.065412466107443, 10.504048118312573],
            [-11.065855497399012, 10.500688449642974],
            [-11.06871488387957, 10.499352317096179],
            [-11.069864253181663, 10.494289029265197],
            [-11.068045096310463, 10.489614785275602],
            [-11.065123434861977, 10.490483185541816],
            [-11.061283030665237, 10.487959420382339],
            [-11.056638515730901, 10.482625040494575],
            [-11.053866091117131, 10.481067815519149],
            [-11.04961780127121, 10.484921997395233],
            [-11.046103493450074, 10.483995476515275],
            [-11.042236874371254, 10.485764854760804],
            [-11.037454073990189, 10.485141707190705],
            [-11.034736662526086, 10.487888740325644],
            [-11.031275923277024, 10.481859942568493],
            [-11.026101714377353, 10.477144292692543],
            [-11.024350002311541, 10.469441173431488],
            [-11.019410856754995, 10.461860351327454],
            [-11.012176415237322, 10.462654202067199],
            [-11.006205455800654, 10.453762980768897],
            [-11.00683326350323, 10.443829799643735],
            [-11.002952418892614, 10.445908818641495],
            [-10.998177833773271, 10.44420464135139],
            [-10.995150535918155, 10.44523506234134],
            [-10.991054551186258, 10.442851375164796],
            [-10.984842956885345, 10.443713823589201],
            [-10.981060509180798, 10.440465498295714],
            [-10.976904783839354, 10.443223993656536],
            [-10.973633562752422, 10.44358560859236],
            [-10.964291628788242, 10.449193731193887],
            [-10.96052826707333, 10.44938184600876],
            [-10.955458222759036, 10.439621782799456],
            [-10.95882326612014, 10.433460502872963],
            [-10.958293404860832, 10.42794063508243],
            [-10.96007412190186, 10.425109613550982],
            [-10.957752535091805, 10.421176153577415],
            [-10.9495683522954, 10.423816778031155],
            [-10.948463484073933, 10.427725513392668],
            [-10.942009337812888, 10.430257967621307],
            [-10.939829383887572, 10.427020423863373],
            [-10.936415421529853, 10.425470345434613],
            [-10.931934734707575, 10.42620636059882],
            [-10.929199861739397, 10.42294675307443],
            [-10.922586785490378, 10.42425016319594],
            [-10.920068218348302, 10.418597335063916],
            [-10.913996943613288, 10.41254009086147],
            [-10.91506573928316, 10.40881857539973],
            [-10.920495496360823, 10.408149735257602],
            [-10.920059430338474, 10.40108319721866],
            [-10.92392591031104, 10.400075191287673],
            [-10.924035224247614, 10.392584913909225],
            [-10.920239358616005, 10.388521410485371],
            [-10.917645429445463, 10.383424070064343],
            [-10.918623875250121, 10.37965396947101],
            [-10.91661583606285, 10.373121563777136],
            [-10.919239684678312, 10.371130949418886],
            [-10.920132460667867, 10.367361136833532],
            [-10.913078478354855, 10.365119346368846],
            [-10.907952268953512, 10.366338156628096],
            [-10.906243419354318, 10.360920305716153],
            [-10.90015854338742, 10.354174282576032],
            [-10.8958840923018, 10.35300029031543],
            [-10.893205019462194, 10.34986453918482],
            [-10.893730058094034, 10.34460277821066],
            [-10.899802298462975, 10.343321126181989],
            [-10.903719331179325, 10.340875709646319],
            [-10.906152078178684, 10.332168390043753],
            [-10.906156897567445, 10.325003540425723],
            [-10.904638241490227, 10.32221046667039],
            [-10.896353575201296, 10.324876595199271],
            [-10.891199648500564, 10.32051016052299],
            [-10.887430650369106, 10.320362221596778],
            [-10.884392949100205, 10.316207490832468],
            [-10.878734519604567, 10.316244162473676],
            [-10.877186835191765, 10.310632559011912],
            [-10.873281592437356, 10.304801303960927],
            [-10.873896907705197, 10.29629751412488],
            [-10.872828703912132, 10.289590476839855],
            [-10.871351248544558, 10.271144339185232],
            [-10.868690556139853, 10.262493277483316],
            [-10.874948797995069, 10.261406486263299],
            [-10.877871640750739, 10.263318184580196],
            [-10.882269011231623, 10.260222407236272],
            [-10.88528431616908, 10.253133865801468],
            [-10.889387075536927, 10.251430919855832],
            [-10.892619663102098, 10.240762522909177],
            [-10.89660387900603, 10.236928128050826],
            [-10.91400512524486, 10.238175371495831],
            [-10.919433829956372, 10.241541189903653],
            [-10.922829417977622, 10.23999509278985],
            [-10.925953408707139, 10.24715123898995],
            [-10.93115757651271, 10.248663187459861],
            [-10.933976494597557, 10.251616601793618],
            [-10.941004115404045, 10.253609994431343],
            [-10.943222819687305, 10.25264646766412],
            [-10.94595688048039, 10.249280005455786],
            [-10.952706643994203, 10.24667333582254],
            [-10.954021595049511, 10.244812254712476],
            [-10.961228569947274, 10.245353767517788],
            [-10.964725084884162, 10.244137129078863],
            [-10.971923827014233, 10.234141723289596],
            [-10.972798785889294, 10.231303445538193],
            [-10.986829073814585, 10.232320390495591],
            [-10.988491611857373, 10.234121077039164],
            [-11.000644116043471, 10.234307018355535],
            [-11.012292675428984, 10.232232094807063],
            [-11.017261031684672, 10.230394777059399],
            [-11.018545649144674, 10.223118809455277],
            [-11.023804423887649, 10.219837140410323],
            [-11.023189370445559, 10.214370244173526],
            [-11.025086065943393, 10.20991028705781],
            [-11.021291816629722, 10.206265144940678],
            [-11.013882346373416, 10.20256943428307],
            [-11.010909323378948, 10.19809415500774],
            [-11.007499691059493, 10.196356609466724],
            [-11.010302742319316, 10.18864052946141],
            [-11.006703194477879, 10.181504469357924],
            [-11.010781126408267, 10.16924263777393],
            [-11.009457432796452, 10.165324484987924],
            [-11.011758867574972, 10.154292593014297],
            [-11.018021392093171, 10.151062981475542],
            [-11.018272794599946, 10.147514969532653],
            [-11.021525593173774, 10.14288387139414],
            [-11.018175864825418, 10.135096976455392],
            [-11.020808180301113, 10.12710758902957],
            [-11.019048732430266, 10.12140445758495],
            [-11.024512010307568, 10.115759168307772],
            [-11.025331112584135, 10.109753566917076],
            [-11.023589992691063, 10.102454060955626],
            [-11.0290133412136, 10.095398506146848],
            [-11.029006595907585, 10.091557621282867],
            [-11.03361107826517, 10.089653272629448],
            [-11.039064384204318, 10.08966996021766],
            [-11.042394742531128, 10.086163517095345],
            [-11.040933138497447, 10.081317983095522],
            [-11.042771454005116, 10.079755552893003],
            [-11.042343903790677, 10.073646483157349],
            [-11.043362440624028, 10.068003475224106],
            [-11.053199111796065, 10.063471344096891],
            [-11.05559399604279, 10.06475947862306],
            [-11.072076172147574, 10.06487253535824],
            [-11.075654475132549, 10.067734820650085],
            [-11.082073862201856, 10.070835964348406],
            [-11.085342779342458, 10.069721856190322],
            [-11.091271542806629, 10.062714752201645],
            [-11.095487961111658, 10.059999503891607],
            [-11.102298586519346, 10.058806976750756],
            [-11.10362304701779, 10.056998126001565],
            [-11.105255840047935, 10.049144275964947],
            [-11.10499872972661, 10.042264972009896],
            [-11.103490049228347, 10.037883452184433],
            [-11.104198936283478, 10.025126680415696],
            [-11.099966424654173, 10.015553193885301],
            [-11.100036564284757, 10.005179867642223],
            [-11.09714424597795, 9.999514461716112],
            [-11.095001970026722, 9.991267959760135],
            [-11.09081304126424, 9.988191051341008],
            [-11.09314269934207, 9.974255973958941],
            [-11.097472266467763, 9.967661007695993],
            [-11.101654454057872, 9.968476425079169],
            [-11.105742274517244, 9.967179296372972],
            [-11.107352894933515, 9.960663755865363],
            [-11.107260656188519, 9.955670631561185],
            [-11.104200225623782, 9.953679237220918],
            [-11.102928547654244, 9.949875251199044],
            [-11.10561853311065, 9.947891219307843],
            [-11.112241942371623, 9.938805552275014],
            [-11.113750231867808, 9.934062395537264],
            [-11.113098797541037, 9.927025559197222],
            [-11.234289050500154, 9.948912765159529],
            [-11.233451035071429, 9.953390398928118],
            [-11.327353199444698, 9.97040665394225],
            [-11.439201393045403, 9.99095196703069],
            [-11.434028610360036, 10.00010150836923],
            [-11.432045334205371, 10.007299296850844],
            [-11.429174204462532, 10.010985172278373],
            [-11.43092649802473, 10.016211759892277],
            [-11.425663627567632, 10.024397853810255],
            [-11.425127397373693, 10.035752950263147],
            [-11.420849511314474, 10.045901670006616],
            [-11.416829093468852, 10.048343729848929],
            [-11.40888290380758, 10.048193189909766],
            [-11.405742304786086, 10.056466219040367],
            [-11.400005360332944, 10.066419332633245],
            [-11.397744770509957, 10.080238279065705],
            [-11.399706444591398, 10.08516208804147],
            [-11.397732592677645, 10.093846021462662],
            [-11.39836041728026, 10.098347410307735],
            [-11.396876653899461, 10.10392293856705],
            [-11.405219801409721, 10.107678053801664],
            [-11.41225099766451, 10.105652982780802],
            [-11.416931158434165, 10.105533082525614],
            [-11.421138864150526, 10.108180322014036],
            [-11.426370910453116, 10.119688816187397],
            [-11.431341321733587, 10.124078835697523],
            [-11.432472444400055, 10.133813281863587],
            [-11.430965730558297, 10.137169700349801],
            [-11.426014493693987, 10.138361483465024],
            [-11.421085985463408, 10.142606181771338],
            [-11.417386932966034, 10.150854226518975],
            [-11.419748336884844, 10.16021645375763],
            [-11.429985917155253, 10.171396892048621],
            [-11.431236272194871, 10.181814608965055],
            [-11.43478047351053, 10.183662886441663],
            [-11.433303388582228, 10.193882938466636],
            [-11.429199509244606, 10.19972358025055],
            [-11.423933845686552, 10.19927540364801],
            [-11.421315067114607, 10.205352230841752],
            [-11.423272286642321, 10.207510396056781],
            [-11.423893170846645, 10.213428285926554],
            [-11.422058350214977, 10.21932161398168],
            [-11.416485087490697, 10.226047105413473],
            [-11.418193805720486, 10.228485878229137],
            [-11.417658302232914, 10.240371182163296],
            [-11.419196487503383, 10.246052168005013],
            [-11.417650684973076, 10.251258381293086],
            [-11.411381685548825, 10.254802351866346],
            [-11.408133936880544, 10.266477501468335],
            [-11.408212267318094, 10.273085114898448],
            [-11.410132112540218, 10.280209083530636],
            [-11.417620479695323, 10.286902902969205],
            [-11.419775756638815, 10.291561427616758],
            [-11.422970284916628, 10.294840192875832],
            [-11.424128350379869, 10.303061459958473],
            [-11.426228379696193, 10.302243975084998],
            [-11.430733911167723, 10.304739148782755],
            [-11.437256355940622, 10.305476408970472],
            [-11.441795069697637, 10.313516911542052],
            [-11.440541220233543, 10.32344347156832],
            [-11.445074820737215, 10.335182024474165],
            [-11.447059102949714, 10.336522911149613],
            [-11.449627073789392, 10.343752041013069],
            [-11.453657676762493, 10.34274454223085],
            [-11.459928539172187, 10.344512536041702],
            [-11.465980121935619, 10.341541934432492],
            [-11.468016011900795, 10.344691684881415],
            [-11.465390142337371, 10.351663014856998],
            [-11.469046897109715, 10.353428156029448],
            [-11.47061893457618, 10.359191578825113],
            [-11.474619825374324, 10.364141244169483],
            [-11.47827941901456, 10.365155783107795],
            [-11.478549265231285, 10.368167234335097],
            [-11.482368256158928, 10.372382392582653],
            [-11.482074652496474, 10.376861572236896],
            [-11.485236084873426, 10.376978427742914],
            [-11.48827066040254, 10.380967181044701],
            [-11.494286801255921, 10.377637244999168],
            [-11.499215646610523, 10.380920683877463],
            [-11.502183402803412, 10.37683452967289],
            [-11.507979244083133, 10.379740434809017],
            [-11.50926220597408, 10.38326709160782],
            [-11.508086449286028, 10.387750208144887],
            [-11.513427586440223, 10.398500453048628],
            [-11.513586531410466, 10.403789639534839],
            [-11.516147693161386, 10.410121680757523],
            [-11.516689540397234, 10.417010119039661],
            [-11.5151715863265, 10.421021027190351],
            [-11.511742786006895, 10.421134219343944],
            [-11.510509979126931, 10.427159017701543],
            [-11.51588975850543, 10.437031266914582],
            [-11.512371932565854, 10.443318737195696],
            [-11.517261083633214, 10.445527980311859],
            [-11.519380559685041, 10.444818887918839],
            [-11.524230489520125, 10.451745316515701],
            [-11.522390055428533, 10.455564631416719],
            [-11.560733147389618, 10.46246286260826],
            [-11.618120447612608, 10.473319857837483],
            [-11.620321771125921, 10.459527485350925],
            [-11.634610445968406, 10.462225876149514],
            [-11.637521440166424, 10.448528522762423],
            [-11.656063428350345, 10.452189488410433],
            [-11.654842590752382, 10.442951679642082],
            [-11.652554245118454, 10.435850376458342],
            [-11.65257474968692, 10.431714567762722],
            [-11.650823322256938, 10.422199594191792],
            [-11.64332713238237, 10.427445483183213],
            [-11.638420094831755, 10.422488356942614],
            [-11.636702935550604, 10.41315701181663],
            [-11.63766159821541, 10.408206749454601],
            [-11.642183196880898, 10.398278272537953],
            [-11.641082400048134, 10.38916515265713],
            [-11.737894807433666, 10.407388607270205],
            [-11.740053568252662, 10.407659801341763],
            [-11.82888537181739, 10.42461598982334],
            [-11.859598843094263, 10.430318009698667],
            [-11.94180687104449, 10.446158089710304],
            [-11.958383667516362, 10.363272177561937],
            [-11.948638840023378, 10.361371040775543],
            [-11.964915903774886, 10.279485693046665],
            [-12.049379472048356, 10.295836904697463],
            [-12.032912312013407, 10.377953788018706],
            [-12.11792424935209, 10.394751145538617],
            [-12.202941084999082, 10.41152376800329],
            [-12.20352096948504, 10.40867409218624],
            [-12.28849314155938, 10.425543466712746],
            [-12.262892285118962, 10.550154121070948],
            [-12.27694069907821, 10.552950422279107],
            [-12.274083212159463, 10.56678661489523],
            [-12.258356782857609, 10.643047665622362],
            [-12.256552896130314, 10.649876543904956],
            [-12.24976918556347, 10.682737646111242],
            [-12.256104939283192, 10.684022985259707],
            [-12.239250226044845, 10.766918383526123],
            [-12.217378845784589, 10.762726965143754],
            [-12.125872133654424, 10.744600129793756],
            [-12.100243214402003, 10.871434581171924],
            [-12.092396507457309, 10.909998720880619],
            [-12.09306113850995, 10.910129872748973],
            [-12.067953039855192, 11.033342040967094],
            [-12.05922714502678, 11.075935296574059],
            [-12.08470545560304, 11.081009152536698],
            [-12.068051187943551, 11.161861751877693],
            [-12.058309471838042, 11.160178232152525],
            [-11.981421138427173, 11.145159425704152],
            [-11.904536914640708, 11.130119494709525],
            [-11.905377675658345, 11.135580704778436],
            [-11.913360657683091, 11.143412261793644],
            [-11.92570617828185, 11.15175640716436],
            [-11.929361875521593, 11.151246675162865],
            [-11.933068071823389, 11.152883083189577],
            [-11.935433944016053, 11.157183275252656],
            [-11.930231287608324, 11.163844568916263],
            [-11.928977857120195, 11.168127539102928],
            [-11.925079735739565, 11.169500715674573],
            [-11.925040065599344, 11.17549648243093],
            [-11.929288256603392, 11.179211051827904],
            [-11.929100137662301, 11.18439606266827],
            [-11.92241851465179, 11.189748136340532],
            [-11.9222598803533, 11.193046341023805],
            [-11.918169234714945, 11.19750397556065],
            [-11.912190467522668, 11.199841483535184],
            [-11.906872809417102, 11.199327725823673],
            [-11.893109077632607, 11.200972838613906],
            [-11.890563334421307, 11.199656878855404],
            [-11.886341701856399, 11.201233290534146],
            [-11.884742732270093, 11.203817131332908],
            [-11.880603240389943, 11.204022456162573],
            [-11.875447182329196, 11.207263464033291],
            [-11.874180031015733, 11.213036301514304],
            [-11.868996533610742, 11.21516071022492],
            [-11.868843771398728, 11.217939825717751],
            [-11.87149253570966, 11.223259190014709],
            [-11.878017323703245, 11.223511202216656],
            [-11.88288667224065, 11.225285215707785],
            [-11.882681317424396, 11.228665969535012],
            [-11.884583391968818, 11.233317378828108],
            [-11.884061700091687, 11.236241851305316],
            [-11.887574275543285, 11.245969938939005],
            [-11.89197574168576, 11.24949921623467],
            [-11.89591185785596, 11.249272523157057],
            [-11.896991694539743, 11.253933600513461],
            [-11.90185787906421, 11.258684149078258],
            [-11.899155164951534, 11.26792364807503],
            [-11.905689027118934, 11.267083056185456],
            [-11.910513869150453, 11.271944739719121],
            [-11.915380804727686, 11.272493527482498],
            [-11.919228972330368, 11.275326517834367],
            [-11.926403601589628, 11.27553666553601],
            [-11.930723507796317, 11.281471621472765],
            [-11.93663455325122, 11.285153365374875],
            [-11.934113481755318, 11.291895964873344],
            [-11.931472375262327, 11.293533558767312],
            [-11.928844589406298, 11.300469299238067],
            [-11.925915484696288, 11.305099360023288],
            [-11.916168889555106, 11.304040574687395],
            [-11.913200930554957, 11.3094685793079],
            [-11.90394508682435, 11.310906678941473],
            [-11.903318227137621, 11.318903519888643],
            [-11.899608467673714, 11.32312105435107],
            [-11.897957519199336, 11.331527581478793],
            [-11.899146604702352, 11.33455480682829],
            [-11.89873177941505, 11.341866415288619],
            [-11.903117146574035, 11.348841329641278],
            [-11.90656374079789, 11.35731314471509],
            [-11.90654022536333, 11.35993710514327],
            [-11.902160763836733, 11.365036150644386],
            [-11.899382693492194, 11.370963668286263],
            [-11.898458502390612, 11.37744286358907],
            [-11.898963749292761, 11.385646957405038],
            [-11.89818244123516, 11.396851930966873],
            [-11.903576854449152, 11.39967441366733],
            [-11.902684361897554, 11.406324280400293],
            [-11.89555627753686, 11.411722837876273],
            [-11.891623208304814, 11.416800162604835],
            [-11.88552190781345, 11.417999237859592],
            [-11.881880249695111, 11.422505647150219],
            [-11.879794226115173, 11.427293044958486],
            [-11.876574517901005, 11.428076050317776],
            [-11.873927099513462, 11.434948082133282],
            [-11.880407591997102, 11.442708748869801],
            [-11.898486704018215, 11.446130365205248],
            [-11.904757306842372, 11.450281332483982],
            [-11.904288624231338, 11.45403443206751],
            [-11.906021382724646, 11.458461196937233],
            [-11.900736408058295, 11.4641889690531],
            [-11.896089272567714, 11.466151800868449]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.04960854212473,
          "lat": 48.29511205366152
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30029"],
        "coty_name": ["Flathead"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Flathead County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01719611"
      },
      "bbox": [
        -12.28849314155938, 9.927025559197222, -10.868690556139853,
        11.466151800868449
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.463559561004407, 9.474798449855172],
            [-9.406290668465463, 9.466034143543675],
            [-9.305965966028689, 9.451039160662065],
            [-9.205646150455278, 9.436011459162],
            [-9.176871720510908, 9.431710184340387],
            [-9.185235139853463, 9.37554583300701],
            [-9.127697058252302, 9.367265321085432],
            [-9.140353583812562, 9.28271527432908],
            [-9.054337216971803, 9.270282314973871],
            [-9.06049566555553, 9.22810026246818],
            [-8.974319686122572, 9.215703151028276],
            [-8.980290096622582, 9.173338954083642],
            [-8.902212921307266, 9.162424306011923],
            [-8.92064611104656, 9.034514956346673],
            [-8.930524360190384, 8.966880518650438],
            [-8.943017166853615, 8.880563792076515],
            [-8.957337177130196, 8.882609566385538],
            [-8.959350578210328, 8.868516946962123],
            [-8.970111893293495, 8.870055005465092],
            [-8.972152033945815, 8.85595212349012],
            [-8.975744012528006, 8.856463942452375],
            [-8.97976988349321, 8.828259554198164],
            [-8.981872652004116, 8.821441911665323],
            [-9.006851458196623, 8.824988155382158],
            [-9.009888569850443, 8.803838148824818],
            [-9.006300900779278, 8.80331747627244],
            [-9.007334614219618, 8.796276572297401],
            [-8.985793542669988, 8.793200273312387],
            [-8.986770083461655, 8.786134828844961],
            [-8.979558706034517, 8.785110157104812],
            [-8.981542979654858, 8.770986802597282],
            [-8.960471915348288, 8.768075275513855],
            [-8.965470924349237, 8.732825558337726],
            [-8.958267704362964, 8.731876777012541],
            [-8.965432693228422, 8.682917861238868],
            [-8.978532313584587, 8.684210934948577],
            [-9.016013616437146, 8.689571991880522],
            [-9.022840443003854, 8.694140332743908],
            [-9.021343279020437, 8.697969975084535],
            [-9.023200715228663, 8.702890719996942],
            [-9.03073068024325, 8.708993143377846],
            [-9.039699584029563, 8.70775111065934],
            [-9.045685665065955, 8.710677872527912],
            [-9.051135305351673, 8.71522544993856],
            [-9.062986689159267, 8.728722820535973],
            [-9.07080886699196, 8.735171172401044],
            [-9.0739591112757, 8.734136120234773],
            [-9.088751664125713, 8.744304363972653],
            [-9.094819300330792, 8.751769661472578],
            [-9.108382893174108, 8.760179394196914],
            [-9.10917145238815, 8.762360061123946],
            [-9.114362791051715, 8.759837243712896],
            [-9.11791228148723, 8.761766375327806],
            [-9.123177730816392, 8.76169664633248],
            [-9.126574374583662, 8.75804472678732],
            [-9.133110615008485, 8.755405703803726],
            [-9.139049085646741, 8.755189966448917],
            [-9.141580823212667, 8.756357931097051],
            [-9.145682869705519, 8.753667285871586],
            [-9.15216252794271, 8.75199810535491],
            [-9.153567126027538, 8.755776333660927],
            [-9.15707641797657, 8.760031229367963],
            [-9.160719461936432, 8.760541147148874],
            [-9.163366327490358, 8.76511547894693],
            [-9.16633612963791, 8.767437940735947],
            [-9.179262130784952, 8.764889190836495],
            [-9.189468441178558, 8.768131519728286],
            [-9.194790128019923, 8.7650523688093],
            [-9.20126260487813, 8.766977902830313],
            [-9.206665182050644, 8.763576992235055],
            [-9.210770775769808, 8.763288944182046],
            [-9.216865824262769, 8.754311907408091],
            [-9.21674196950129, 8.748124393189306],
            [-9.221515750229452, 8.74502716931863],
            [-9.228317454893489, 8.74631897877971],
            [-9.237419737246473, 8.746572425276188],
            [-9.243186736495911, 8.745628273475344],
            [-9.249772594077493, 8.750104693796116],
            [-9.255903609392009, 8.752739785176582],
            [-9.264335906749132, 8.758049691101478],
            [-9.273933113917705, 8.75121612502575],
            [-9.27463610912488, 8.747697872899218],
            [-9.279938361044001, 8.743314586183356],
            [-9.287510926890524, 8.747013937484368],
            [-9.29286433731079, 8.745801161523161],
            [-9.30078053569405, 8.74635845768036],
            [-9.308552136871599, 8.74885513368345],
            [-9.311963904963898, 8.751004056886666],
            [-9.31951507540155, 8.752817830755015],
            [-9.322224604238734, 8.751622500797193],
            [-9.327191664374944, 8.751144473344102],
            [-9.339927916066712, 8.741574143640255],
            [-9.340748163201, 8.737505520100164],
            [-9.347848424033614, 8.732796079135703],
            [-9.353620024272278, 8.734411654057283],
            [-9.35741766098172, 8.731438064343603],
            [-9.361880352624334, 8.732740432999709],
            [-9.365100786340264, 8.727672158147481],
            [-9.36359310999072, 8.723348311906513],
            [-9.365352593560358, 8.720899712439932],
            [-9.369093951894857, 8.72034379186677],
            [-9.376152683674425, 8.721908586916882],
            [-9.376353722886604, 8.727138307670993],
            [-9.37823697402774, 8.732083853578521],
            [-9.381969661527414, 8.735132833338612],
            [-9.385112635638581, 8.740398503382636],
            [-9.394236001356843, 8.74490324113364],
            [-9.410478631071376, 8.74287798320467],
            [-9.415128314380505, 8.740184419320556],
            [-9.41927487469587, 8.740518569794236],
            [-9.427698909426221, 8.734839891291829],
            [-9.4306563340302, 8.739224476407209],
            [-9.4368897093589, 8.744961533413207],
            [-9.441320950724414, 8.742613208535921],
            [-9.445912575991548, 8.742198405559186],
            [-9.450198042546077, 8.740039694356273],
            [-9.4586455714152, 8.740572642342306],
            [-9.457640477063078, 8.744970769733506],
            [-9.462925853383695, 8.747612623971014],
            [-9.46612989197595, 8.75201548348709],
            [-9.4657919937993, 8.757543736181956],
            [-9.467471502937144, 8.76225119316465],
            [-9.466271631544503, 8.764321700936698],
            [-9.471973306934663, 8.768035766899242],
            [-9.475635819676311, 8.766846599370528],
            [-9.480384440327162, 8.777727347031258],
            [-9.482564370819253, 8.778917558015182],
            [-9.487877813444804, 8.777709277109897],
            [-9.492642912403817, 8.779606033328976],
            [-9.497806351380671, 8.789140401626918],
            [-9.503583973367764, 8.792742403132726],
            [-9.506601821701045, 8.799352120291779],
            [-9.514972553862732, 8.802236821773143],
            [-9.515875108531283, 8.809124803137951],
            [-9.510543530710116, 8.821891537230641],
            [-9.507605726025114, 8.832486652471792],
            [-9.513111190305573, 8.84161255639299],
            [-9.52010044081458, 8.840549380388023],
            [-9.525782871002889, 8.842347933163259],
            [-9.536446442108351, 8.843273492401021],
            [-9.543138257568977, 8.844809728155303],
            [-9.549093254841011, 8.847427064690143],
            [-9.549146252665771, 8.85177993587433],
            [-9.553822846288467, 8.854062430660083],
            [-9.556216352035149, 8.857834815308266],
            [-9.555568866090402, 8.861049252639088],
            [-9.56147192450523, 8.868384813532243],
            [-9.562134525620522, 8.875045860903032],
            [-9.564211333444453, 8.878885235118295],
            [-9.558648567627099, 8.892973579943899],
            [-9.56310007214014, 8.900775891188996],
            [-9.561051609438561, 8.913939920840587],
            [-9.549833705883778, 8.912217660200515],
            [-9.536502451886438, 8.996546062315392],
            [-9.539677515548004, 8.997036905759098],
            [-9.526291089535842, 9.081286784791287],
            [-9.529241461848075, 9.081746185249985],
            [-9.51629971776367, 9.164468784817513],
            [-9.602341004671974, 9.177774885021519],
            [-9.601021959316183, 9.178188317609223],
            [-9.593697306321195, 9.229098319882768],
            [-9.588966049977897, 9.263119015371686],
            [-9.585037491981772, 9.262520521021827],
            [-9.57700482289692, 9.31162097890841],
            [-9.584305739513983, 9.312786620774688],
            [-9.582001776744868, 9.326856376047568],
            [-9.589239875909543, 9.32801108942519],
            [-9.580349555518948, 9.384949743323928],
            [-9.569567439089884, 9.383347517420095],
            [-9.571293158318513, 9.37292457134904],
            [-9.567678841233047, 9.372282486717566],
            [-9.558192744807032, 9.432435194809338],
            [-9.471885242244689, 9.419062519520242],
            [-9.463559561004407, 9.474798449855172]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.26602080401699,
          "lat": 47.04541581755967
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30045"],
        "coty_name": ["Judith Basin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Judith Basin County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01719602"
      },
      "bbox": [
        -9.602341004671974, 8.682917861238868, -8.902212921307266,
        9.474798449855172
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.455991070044309, 8.667868493723915],
            [-8.391608903518627, 8.658924329392152],
            [-8.327228587916462, 8.649967354222756],
            [-8.262850143748222, 8.640997570458444],
            [-8.19847359151561, 8.632014980365737],
            [-8.112493811432065, 8.620857550121412],
            [-8.026516990109297, 8.609677332165866],
            [-8.018305308540244, 8.609584872015878],
            [-7.9457670995410075, 8.603915012927361],
            [-7.8889240608196625, 8.59664957729657],
            [-7.77515574724269, 8.582260227160667],
            [-7.775067097388634, 8.582950126676632],
            [-7.64941710583543, 8.568211327760741],
            [-7.647637949797312, 8.563114781026842],
            [-7.6488444479539455, 8.560486144211492],
            [-7.6458087823900005, 8.556179253328962],
            [-7.641236719905403, 8.554734576661453],
            [-7.642997834771277, 8.548658572325282],
            [-7.638632858937639, 8.543571048167301],
            [-7.641592150601703, 8.540034495555199],
            [-7.650280734229098, 8.540818453547764],
            [-7.653127676982905, 8.538757761119838],
            [-7.6532425317226345, 8.534396040006397],
            [-7.650297656910006, 8.532524512269447],
            [-7.653430125645607, 8.527259840680198],
            [-7.652325393092376, 8.523891949528323],
            [-7.647905776606821, 8.520914621998108],
            [-7.651913802283977, 8.517503490002213],
            [-7.646548965235615, 8.508172820100583],
            [-7.638591548636151, 8.503715298635676],
            [-7.639328984232157, 8.499350212183675],
            [-7.6358285959171965, 8.496784016206249],
            [-7.635081329803457, 8.490930565802861],
            [-7.640355033193638, 8.486055198689753],
            [-7.63892783690453, 8.483572829090999],
            [-7.641860658676817, 8.480920354068742],
            [-7.6392570734510725, 8.47824503979542],
            [-7.642555236798977, 8.473617238023689],
            [-7.647940800494653, 8.475450354864847],
            [-7.648662883855064, 8.470556179625596],
            [-7.653389418560039, 8.46814135180334],
            [-7.653552728121011, 8.46366166620797],
            [-7.656176662850673, 8.458833350663252],
            [-7.653898981264776, 8.451659537384666],
            [-7.65409369987752, 8.446071626679199],
            [-7.656335240630497, 8.441601815925953],
            [-7.662349800356632, 8.436645673941713],
            [-7.65943045454396, 8.43028366025717],
            [-7.663277968749219, 8.425868028063187],
            [-7.669351663244184, 8.42448422577135],
            [-7.6669993460185415, 8.420756185938341],
            [-7.6696179983626855, 8.418583210051928],
            [-7.6738363862537415, 8.418285658107523],
            [-7.675982537500735, 8.41334953252136],
            [-7.647073889642667, 8.409780567954913],
            [-7.650512110667933, 8.381709675237028],
            [-7.651494887349941, 8.381830970197136],
            [-7.660388439846054, 8.31125707159426],
            [-7.649723394268656, 8.310080530958952],
            [-7.66275434855357, 8.211410927551498],
            [-7.763232231292148, 8.223981619768713],
            [-7.765008803042908, 8.209788282306835],
            [-7.779372049481612, 8.21138448220756],
            [-7.781140001828175, 8.197141177490439],
            [-7.7954570061271165, 8.19884126272819],
            [-7.7971658099868115, 8.184632215721575],
            [-7.811645364282288, 8.186444465434189],
            [-7.81327653108848, 8.172261377687036],
            [-7.827798734889797, 8.173886153726155],
            [-7.831203076586238, 8.14545575078284],
            [-7.843381290087278, 8.1470075235673],
            [-7.848918344257984, 8.104109363046964],
            [-7.932874840724162, 8.114268966948645],
            [-7.936476845794992, 8.114994383440235],
            [-8.049210045997546, 8.129591802918346],
            [-8.05115500520957, 8.115565088552582],
            [-8.07995265472727, 8.119652717045776],
            [-8.081831328523995, 8.105503914820103],
            [-8.110591453211935, 8.109609579131831],
            [-8.123929089482978, 8.008681495285312],
            [-8.190419534288159, 8.017204520735753],
            [-8.224251426118007, 8.021419079410217],
            [-8.303132865446962, 8.031841901409537],
            [-8.382016720227345, 8.042246409214602],
            [-8.370012322895645, 8.12724578280532],
            [-8.365691425446599, 8.155432008315502],
            [-8.36230964755003, 8.18410815795101],
            [-8.376634783691653, 8.18603478589929],
            [-8.372787686598436, 8.214453496303827],
            [-8.387144126020466, 8.216395333784805],
            [-8.385210930068714, 8.230640445212615],
            [-8.392382743151844, 8.231590238800358],
            [-8.388237993225307, 8.260017552040045],
            [-8.395415146698761, 8.260955812133728],
            [-8.39319758908992, 8.2751013176709],
            [-8.407553162888433, 8.2770569709088],
            [-8.39482565127154, 8.362067176452523],
            [-8.40918905203903, 8.364068231527733],
            [-8.402918158718244, 8.40106213040479],
            [-8.420112368934978, 8.403451447355518],
            [-8.408115297564494, 8.488521591324043],
            [-8.46543888385176, 8.497231132059783],
            [-8.460874526860643, 8.525617654457394],
            [-8.45936409103589, 8.539576786095049],
            [-8.473884037032782, 8.541485381211142],
            [-8.455991070044309, 8.667868493723915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -108.39812056466059, "lat": 46.4965784933436 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30065"],
        "coty_name": ["Musselshell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Musselshell County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01719593"
      },
      "bbox": [
        -8.473884037032782, 8.008681495285312, -7.635081329803457,
        8.667868493723915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.459092795947121, 3.5035319866256227],
            [-4.415435653825714, 3.501464582386748],
            [-4.368233923069408, 3.4989532330183835],
            [-4.313926222070466, 3.4957532346758016],
            [-4.229213807966187, 3.490350633368989],
            [-4.144502200532467, 3.4849351017224435],
            [-4.136397102631493, 3.4845971981769996],
            [-4.009094136624238, 3.4773153731731896],
            [-4.027080627789878, 3.209303202896472],
            [-3.9662805456110006, 3.2056654890922642],
            [-3.9760349757963342, 3.0426599570846338],
            [-3.976968351711831, 3.036819405231323],
            [-3.9771899638233266, 3.0255577928824398],
            [-3.9875943557392235, 2.8568562460192997],
            [-4.040092625628741, 2.8603330143744343],
            [-4.040931562243924, 2.8456342565191792],
            [-4.046742548512774, 2.7587595048287175],
            [-4.051489938759936, 2.685906669290247],
            [-4.079925822573145, 2.687713522631634],
            [-4.208134149798463, 2.6960624800039295],
            [-4.292851077256716, 2.70207890011515],
            [-4.356395372531056, 2.706429112996341],
            [-4.4645314235818105, 2.7135065523911726],
            [-4.4582193601410784, 2.800913800136646],
            [-4.45161502764165, 2.887709568879568],
            [-4.4719182917574845, 2.88923184630728],
            [-4.4686928813537845, 2.9329879691489036],
            [-4.464076447026905, 3.001085789276317],
            [-4.458295502392358, 3.0875422466435674],
            [-4.456784675485309, 3.1072311622829325],
            [-4.45074370560635, 3.1944130532334265],
            [-4.450417233997671, 3.209060515044498],
            [-4.448099864823126, 3.2237045904990524],
            [-4.446785333432777, 3.23811471305447],
            [-4.467821748424904, 3.239945616761282],
            [-4.470680633741598, 3.2549443405116816],
            [-4.472737457192983, 3.2697906715668914],
            [-4.474090224271524, 3.284522653618037],
            [-4.473409697703647, 3.312276432253388],
            [-4.459833882383587, 3.4888447117492167],
            [-4.459092795947121, 3.5035319866256227]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.33540724757981,
          "lat": 41.61938087553735
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31069"],
        "coty_name": ["Garden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garden County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00835856"
      },
      "bbox": [
        -4.474090224271524, 2.685906669290247, -3.9662805456110006,
        3.5035319866256227
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5552901740349077, 1.776887627987021],
            [-3.4705436543401693, 1.7725288918675064],
            [-3.3657798053016403, 1.7666162931103602],
            [-3.3000574527857607, 1.7630395250691582],
            [-3.2782870882929536, 1.7613794365555564],
            [-3.2282361790809957, 1.758200231652392],
            [-3.175586113966258, 1.755427013728128],
            [-3.143510106956352, 1.7538988024184756],
            [-3.129218243740198, 1.753222975919068],
            [-3.137374544659157, 1.624420710792037],
            [-3.139987823064394, 1.5774677476405852],
            [-3.139020777469444, 1.5586134755075973],
            [-3.1427739002209556, 1.4889797494464578],
            [-3.147050415012653, 1.403470713857097],
            [-3.282450458410086, 1.4102227253816777],
            [-3.375595450540829, 1.4152884314315888],
            [-3.4577368332249394, 1.4199540362058156],
            [-3.5526937897397866, 1.4251964128999006],
            [-3.5754567463542752, 1.4266072794563898],
            [-3.5738916702783348, 1.4518666377846696],
            [-3.5709731602823767, 1.513914873246975],
            [-3.5665702973702897, 1.6015465849921666],
            [-3.5660956332313205, 1.6068569500891112],
            [-3.5641530803476775, 1.6456524866708901],
            [-3.5599901463159767, 1.7190982768418184],
            [-3.5577559158741887, 1.755717623598256],
            [-3.5552901740349077, 1.776887627987021]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.04227319774458,
          "lat": 40.17632674203237
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31087"],
        "coty_name": ["Hitchcock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hitchcock County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00835865"
      },
      "bbox": [
        -3.5754567463542752, 1.403470713857097, -3.129218243740198,
        1.776887627987021
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.0242835282453124, 3.1501313055811457],
            [-2.9433539474448893, 3.146539558914039],
            [-2.9403312465423417, 3.146210071618212],
            [-2.8532328709695234, 3.1421170820046815],
            [-2.7661351102464753, 3.138011048085375],
            [-2.728668044829975, 3.1361616967087786],
            [-2.6943708885901914, 3.134660688186018],
            [-2.683829148070835, 3.1341494926882016],
            [-2.6901850623128105, 3.018659935263852],
            [-2.692798300737397, 2.960244022526105],
            [-2.6975153444947844, 2.850299289964224],
            [-2.697310629778755, 2.8473933288100537],
            [-2.699348954474753, 2.7857769801654997],
            [-2.7290172765830865, 2.787268751110192],
            [-2.7399642445896695, 2.7874421142741537],
            [-2.7542873637157728, 2.7885294771560902],
            [-2.7680882873515085, 2.788992253594875],
            [-2.9067609707278637, 2.7955353293992933],
            [-3.0429356852952805, 2.8021876374787658],
            [-3.0407934306318336, 2.8523423129444687],
            [-3.0375972984956494, 2.919107153376209],
            [-3.034626434444737, 2.976231606105635],
            [-3.029722504232703, 3.0621954915126057],
            [-3.0242835282453124, 3.1501313055811457]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.48273040940165,
          "lat": 41.56656399773527
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31113"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00835878"
      },
      "bbox": [
        -3.0429356852952805, 2.7857769801654997, -2.683829148070835,
        3.1501313055811457
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.113063584724984, 1.576078079351663],
            [0.1986108506690131, 1.5760839513428337],
            [0.2851020988274676, 1.5752240239578197],
            [0.30280955640170887, 1.5754626027349319],
            [0.37090822667332474, 1.5755885409033987],
            [0.3724024520726374, 1.5753949962569205],
            [0.4132665957450006, 1.5751045737380152],
            [0.45604373546397997, 1.574526498615888],
            [0.4559495329372769, 1.4868445424741195],
            [0.45581086295942896, 1.4240946602418614],
            [0.4556344911736761, 1.3114027947412705],
            [0.42450195409419456, 1.3115027978094382],
            [0.39558803434974044, 1.3113144627904254],
            [0.3465628395031638, 1.3113532004945987],
            [0.2821599042098261, 1.3116842188856839],
            [0.23255555313087561, 1.311763563476781],
            [0.11174288187901157, 1.3125940130214555],
            [0.11203372611988324, 1.385869760485844],
            [0.11264977715613926, 1.4883376825948684],
            [0.11313983036446872, 1.5596142253234881],
            [0.113063584724984, 1.576078079351663]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.23706433061808, "lat": 40.13145754574271 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31133"],
        "coty_name": ["Pawnee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pawnee County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00835888"
      },
      "bbox": [
        0.11174288187901157, 1.3113144627904254, 0.45604373546397997,
        1.5760839513428337
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.2099166101606423, 2.7788079372622225],
            [-0.19787128950947613, 2.7786741562064203],
            [-0.18335053750862007, 2.775010436857907],
            [-0.1773287518668365, 2.7744039626775545],
            [-0.17164181165273001, 2.770463816078569],
            [-0.16232017463353846, 2.7695955147875786],
            [-0.15926127639397364, 2.7708218575120527],
            [-0.14552463320458914, 2.764929850063967],
            [-0.13897615004184688, 2.7648073377935005],
            [-0.12964618505382342, 2.7693160247446884],
            [-0.12281248056694603, 2.7691050323169963],
            [-0.1173380770862238, 2.772819856080841],
            [-0.11211200489936306, 2.7746082935949365],
            [-0.10521142857270112, 2.77389612072199],
            [-0.091416934442294, 2.773940581238976],
            [-0.08037561680214944, 2.769088176970592],
            [-0.07490776833364, 2.76346826067777],
            [-0.07020618224408091, 2.7602856854722684],
            [-0.06458844196340305, 2.754713672164538],
            [-0.059580792849897445, 2.753939556792938],
            [-0.05305990127453304, 2.7498023520765895],
            [-0.03672137708404182, 2.7498883147721656],
            [-0.024075039311343645, 2.7531383120892543],
            [-0.02035968093869786, 2.7565154860212275],
            [-0.012568308612311329, 2.75988340349139],
            [-0.007874257621236403, 2.7580207820409823],
            [0.007630429607831155, 2.7578658174205417],
            [0.01162071497460553, 2.756594926180245],
            [0.013917762611912084, 2.75797557991373],
            [0.04017429976366354, 2.7566498422424437],
            [0.04778169651154939, 2.753158782177071],
            [0.05553482380585937, 2.7465629670146754],
            [0.06811832006796002, 2.738485031388102],
            [0.07656189199234886, 2.7312260620940543],
            [0.08456713552767246, 2.7271164722605565],
            [0.08844911643676921, 2.7194474157362287],
            [0.09461886247776238, 2.7168074481670534],
            [0.09740402088518364, 2.720240171336459],
            [0.1004005046850595, 2.71604663084405],
            [0.11337857991874051, 2.7159147899398604],
            [0.12165850431007237, 2.702862591100761],
            [0.1364179581580014, 2.692537489843859],
            [0.1477312283193857, 2.6884507764514374],
            [0.15073823666210387, 2.6853192769873955],
            [0.15505901469398578, 2.6772184151666862],
            [0.15898774324921688, 2.6639823373319014],
            [0.16057144013772048, 2.6563635275523794],
            [0.15978402663108232, 2.6437061369277757],
            [0.1584940961128111, 2.6421056517670554],
            [0.1600132753333577, 2.6365358892624813],
            [0.1653256814727567, 2.6312853443655064],
            [0.17445119751060367, 2.623738752914847],
            [0.17907951858814902, 2.622279074809591],
            [0.1900585871232493, 2.610145243842648],
            [0.1949353816200684, 2.6019539251195978],
            [0.20230997608612283, 2.586600766376999],
            [0.20212085407899294, 2.577594614464674],
            [0.19737407614008234, 2.5702729499115216],
            [0.19332212083903133, 2.562131112032657],
            [0.19103441063708163, 2.5553683185714924],
            [0.1940954923431351, 2.5403338390819274],
            [0.1993266304058734, 2.5284785325768664],
            [0.20202492652909956, 2.5251691769558997],
            [0.21552437250760764, 2.516423036081395],
            [0.2193475705580906, 2.5108140308952303],
            [0.2213630378876704, 2.506663658140725],
            [0.2235937658191647, 2.497448492421066],
            [0.22357087214385746, 2.4871631239693714],
            [0.22775521431434181, 2.4644100582346278],
            [0.2251970299675592, 2.456904519540067],
            [0.22541708715188907, 2.4492485822200925],
            [0.2299950892261987, 2.4400701715051243],
            [0.2313552409028214, 2.435573198084121],
            [0.22692645351336996, 2.4287059375363733],
            [0.21985757725535388, 2.4244104874246584],
            [0.21494455595367848, 2.419797872569797],
            [0.2104372802366815, 2.4115556912799025],
            [0.20969947073256398, 2.402570783590509],
            [0.21092134624518113, 2.398029290157865],
            [0.21639320094844247, 2.3889356656318186],
            [0.22077369924835671, 2.378923269348093],
            [0.22498358992393744, 2.3647368152068813],
            [0.203283994387946, 2.3647958113335044],
            [0.2026255603393879, 2.36433884070758],
            [0.2022248149313251, 2.3349178326207793],
            [0.1879546270687627, 2.3348296367436685],
            [0.11662807044516706, 2.3360383734152768],
            [0.11676486244940419, 2.36526787363432],
            [0.042266151367569546, 2.3659310911171385],
            [-0.024308396439871798, 2.3665852835081056],
            [-0.1443260320736437, 2.3678512696848104],
            [-0.21580813398571536, 2.368682445159018],
            [-0.21535172599026065, 2.42255831713914],
            [-0.2153566988202494, 2.44132820860277],
            [-0.21442736539923413, 2.5296881796237423],
            [-0.21410294946429312, 2.544249525479924],
            [-0.21403266590989042, 2.5921191089573927],
            [-0.21316703156704844, 2.64634376519855],
            [-0.21264690924016935, 2.660916166631889],
            [-0.21285324030495356, 2.675475964235666],
            [-0.21225084893828003, 2.7191351960969827],
            [-0.21041771235387585, 2.7191177216260938],
            [-0.2099166101606423, 2.7788079372622225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.6373978176555, "lat": 41.2263446427857 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31155"],
        "coty_name": ["Saunders"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saunders County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00835899"
      },
      "bbox": [
        -0.21580813398571536, 2.3348296367436685, 0.2313552409028214,
        2.7788079372622225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.674663412251384, 6.629577512427563],
            [17.677117952755555, 6.662500636407866],
            [17.662121707826856, 6.681703244858152],
            [17.680269622944838, 6.691928367152603],
            [17.686419780452937, 6.6957818042885915],
            [17.742741165081352, 6.7277798470650785],
            [17.78509990031162, 6.675411436627044],
            [17.806062994845913, 6.649229343088137],
            [17.83595156049162, 6.666371121908289],
            [17.8450200340421, 6.67213141529614],
            [17.886609494286514, 6.695491928625925],
            [17.92886032370303, 6.71961614481312],
            [17.953600220761224, 6.6690595471828304],
            [17.972519171799586, 6.62943289169353],
            [17.999511694178604, 6.641217761406023],
            [18.037277659466067, 6.657979738079765],
            [18.05577446246376, 6.666382840674226],
            [18.064019699005875, 6.648614063368834],
            [18.080090554588452, 6.655057417472676],
            [18.086561342693077, 6.646352602526768],
            [18.093086398601606, 6.643820497252254],
            [18.09495614995778, 6.641904869975765],
            [18.10493864823908, 6.6518735440054515],
            [18.106208270514788, 6.653869756878493],
            [18.11574281412831, 6.6316499108476705],
            [18.158981868382504, 6.631894284108177],
            [18.176623139002274, 6.594570399645106],
            [18.18893131292011, 6.567445749003959],
            [18.138717514843872, 6.545742115375443],
            [18.137873799135757, 6.544845828481313],
            [18.152015481646874, 6.5131400914219535],
            [18.182036743370052, 6.447292076211431],
            [18.21046784162332, 6.453445317659974],
            [18.235503008544704, 6.4346042846930835],
            [18.234275288212388, 6.42686380898736],
            [18.23640557687148, 6.420648196849949],
            [18.240918471465196, 6.421734107701693],
            [18.24668224619271, 6.41856746433558],
            [18.24645045395634, 6.4156808112650365],
            [18.249210604441792, 6.410522572260498],
            [18.31760483158139, 6.4115751462096044],
            [18.33127813863842, 6.401573112983805],
            [18.325999720543344, 6.394041023253082],
            [18.319817792096508, 6.381284134143938],
            [18.315824878876764, 6.365088688000709],
            [18.30873265850484, 6.3484506519775055],
            [18.2832645557439, 6.341930729586304],
            [18.26771719617815, 6.338826529903477],
            [18.210409702690704, 6.325713292005042],
            [18.11425554838685, 6.303824457527825],
            [17.987098409640016, 6.274888380341702],
            [17.87793468343578, 6.250945853170399],
            [17.85634202385226, 6.246230124679063],
            [17.831755896228504, 6.305835610974461],
            [17.82636120930778, 6.317197090625897],
            [17.80462050982262, 6.312636132377579],
            [17.786739614420693, 6.353895618030164],
            [17.77430120103085, 6.383029035805555],
            [17.766356025015433, 6.401051858190017],
            [17.753220937320144, 6.4337019344399655],
            [17.743597499482593, 6.456361644034607],
            [17.703849924179963, 6.447225118194756],
            [17.6992722273739, 6.467733507719231],
            [17.688282303410624, 6.51972329406312],
            [17.683653533680015, 6.583850196176338],
            [17.68264077529823, 6.583338392504878],
            [17.677537016383233, 6.630249948856048],
            [17.674663412251384, 6.629577512427563]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.71609825469837, "lat": 42.91532766628291 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33011"],
        "coty_name": ["Hillsborough"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hillsborough County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00873179"
      },
      "bbox": [
        17.662121707826856, 6.246230124679063, 18.33127813863842,
        6.7277798470650785
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.03996794331996, 4.137598571085249],
            [16.04337111037691, 4.15481189425455],
            [16.04902403865812, 4.161317515243713],
            [16.05510932258494, 4.16362079532562],
            [16.06498730491629, 4.1754475886559606],
            [16.065844479818352, 4.181300682158048],
            [16.075033465205596, 4.187833548129721],
            [16.07978802484164, 4.193807636258485],
            [16.088952780127894, 4.213929534459907],
            [16.090665943738983, 4.225150976496303],
            [16.096503904123814, 4.234112301106118],
            [16.10020197343096, 4.2424035327207354],
            [16.1008708955158, 4.25250358884011],
            [16.102168857440805, 4.261097250239276],
            [16.10481075538898, 4.272217029474749],
            [16.10789052782423, 4.281878318457131],
            [16.10799396233611, 4.28504826207651],
            [16.100497552740812, 4.29084341087558],
            [16.10041780243953, 4.295321000588209],
            [16.102207348416368, 4.301369195760895],
            [16.10159541661403, 4.30531859443624],
            [16.10324323419156, 4.313316674737368],
            [16.10868894489215, 4.31683008246501],
            [16.110039440928713, 4.324207887491589],
            [16.10798516418157, 4.328919919174144],
            [16.109995094206656, 4.3375182480298875],
            [16.11060653271121, 4.344155069970309],
            [16.112880916019133, 4.348610501421414],
            [16.114440683408517, 4.355237846410222],
            [16.11890392076422, 4.363086916276098],
            [16.125102396464467, 4.368938709266793],
            [16.12774986411067, 4.374688026535376],
            [16.136476273044785, 4.384363222135303],
            [16.13583603437554, 4.387784189770782],
            [16.132345086060937, 4.391557800058052],
            [16.134157146379202, 4.396037425366859],
            [16.14848862832135, 4.401975462286655],
            [16.152916140288923, 4.409665934825367],
            [16.153265723002143, 4.418770048096235],
            [16.157117249063553, 4.4256172351331164],
            [16.16982328384697, 4.428906654420402],
            [16.173754991660918, 4.429247338437675],
            [16.180304367218362, 4.432177802812394],
            [16.188117835298453, 4.439466223470801],
            [16.193460582959208, 4.442554907899856],
            [16.196942500218572, 4.446304334048551],
            [16.241202665258353, 4.431078640229874],
            [16.269433634895496, 4.421945685687195],
            [16.359082224677692, 4.390462580729339],
            [16.393944835200873, 4.378751175940339],
            [16.438592101713446, 4.362257101353275],
            [16.469669051446356, 4.350049934406317],
            [16.45723909668333, 4.328923698686774],
            [16.44024178899306, 4.2989408171738015],
            [16.41137278393682, 4.2398052887459015],
            [16.407922835014816, 4.233575156741658],
            [16.397486494506975, 4.212075418634267],
            [16.383294230397926, 4.186618499370893],
            [16.373565729720646, 4.167531389493935],
            [16.341862618482995, 4.108763919680165],
            [16.32858034008005, 4.080590547816976],
            [16.32886954957216, 4.078943805678158],
            [16.325329947334456, 4.070840991091412],
            [16.325248954107998, 4.065046727292038],
            [16.33179673081031, 4.057529373287634],
            [16.332600451720797, 4.049440690456275],
            [16.3308665272521, 4.039768204399493],
            [16.324200589969585, 4.035399792347877],
            [16.32354604083326, 4.03053629053704],
            [16.32577699752031, 4.02839294591749],
            [16.322321548680556, 4.0221018077907305],
            [16.317165749757194, 4.019958449765205],
            [16.314581661850255, 4.015722539056778],
            [16.30866699306586, 4.009440938159847],
            [16.303651048738736, 4.0091661642473575],
            [16.301745838218785, 4.005973739679158],
            [16.29635757419717, 4.0048523610020075],
            [16.292888329399016, 3.9982516497183016],
            [16.287633889532056, 3.9943644472990734],
            [16.28510734262683, 3.9958207672303123],
            [16.28461238392577, 4.002432048517597],
            [16.2794992516699, 4.006159569674424],
            [16.27112682639635, 4.008356894131227],
            [16.267773117698287, 4.012186320438731],
            [16.264069339295872, 4.009375143707169],
            [16.261391354143978, 4.010129140954225],
            [16.256216980602606, 4.008525981091517],
            [16.254731171482106, 4.004073846873347],
            [16.252099647858845, 4.001225032269299],
            [16.246441686697743, 3.999572918997541],
            [16.242555030939315, 3.9962605594438956],
            [16.208104091134285, 4.0236678494617815],
            [16.192660547222662, 4.0357271938288575],
            [16.15729594114407, 4.064344565866151],
            [16.132658348379426, 4.083843507479438],
            [16.083291649762927, 4.123501305702473],
            [16.05746865763584, 4.143641269818786],
            [16.055381006525735, 4.144961213970882],
            [16.05154736166935, 4.1420387421913425],
            [16.048091753846183, 4.136921398692031],
            [16.04338576298086, 4.1341780314022945],
            [16.03996794331996, 4.137598571085249]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.69089546184043, "lat": 41.13924566365448 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34037"],
        "coty_name": ["Sussex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sussex County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00882236"
      },
      "bbox": [
        16.03996794331996, 3.9943644472990734, 16.469669051446356,
        4.446304334048551
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.018032863686573, -3.860669476152127],
            [-5.847679000112077, -3.8749297898660995],
            [-5.846707489249521, -3.875199633171619],
            [-5.854648855570067, -3.9587510999482114],
            [-5.865595603916932, -4.090122737369504],
            [-5.872986379837336, -4.177359324333549],
            [-5.6545621745791035, -4.194583575295613],
            [-5.637536097216773, -4.1959719675152085],
            [-5.529467795232845, -4.204355142568783],
            [-5.429516936225948, -4.212122769818846],
            [-5.304196879580819, -4.221978601328367],
            [-5.307371698078218, -4.267848671286564],
            [-5.313760232219485, -4.354073444184341],
            [-5.320512649265036, -4.445746995507586],
            [-5.323841287063417, -4.487897427043312],
            [-5.326246717888332, -4.5216241961401336],
            [-5.328683777966648, -4.550655619364658],
            [-5.3316224558341485, -4.579655850897233],
            [-5.335528235169068, -4.623755268339753],
            [-5.340389528598706, -4.674984792404808],
            [-5.342662776108159, -4.700615205799001],
            [-5.349954251334393, -4.77900123250131],
            [-5.351010510722928, -4.78748254793605],
            [-5.356650210840658, -4.852843284663803],
            [-5.359113235082264, -4.874720317117041],
            [-5.360787184907047, -4.895725740038314],
            [-5.365966236346856, -4.954618668556399],
            [-5.519724852876481, -4.9430593670989165],
            [-5.673481910089951, -4.931478916375031],
            [-5.743425198490577, -4.926212787142712],
            [-5.736192581724998, -4.839063083002835],
            [-5.776657959511232, -4.8361247947134265],
            [-5.908100205104852, -4.826370069913976],
            [-5.903896405105284, -4.778948002331941],
            [-5.893563022469699, -4.66303610804045],
            [-5.975683454913704, -4.656690225451907],
            [-5.996377440731047, -4.6549903236860946],
            [-5.974365344629459, -4.392046606609898],
            [-6.059774699422927, -4.3843988771499145],
            [-6.044642538748016, -4.206983821688386],
            [-6.047438801965119, -4.2067480682733],
            [-6.036332207625407, -4.076035816742852],
            [-6.025233472985757, -3.944493071311015],
            [-6.018032863686573, -3.860669476152127]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.48005049103847,
          "lat": 34.02116934630515
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35041"],
        "coty_name": ["Roosevelt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roosevelt County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01702369"
      },
      "bbox": [
        -6.059774699422927, -4.954618668556399, -5.304196879580819,
        -3.860669476152127
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.932984992324647, 5.251174331791816],
            [15.009923809547779, 5.269958351044934],
            [15.011330402178581, 5.266410925580348],
            [15.045849358316001, 5.275261445795734],
            [15.083467311906174, 5.285560906503391],
            [15.122779539060982, 5.29704583854418],
            [15.127736923816414, 5.279723946341846],
            [15.133541026649853, 5.263714391146149],
            [15.146257279563665, 5.229925793307741],
            [15.170337633004603, 5.147276890549932],
            [15.17902506104724, 5.133122608367291],
            [15.184099253973589, 5.135869000054756],
            [15.18985506268065, 5.140469048542906],
            [15.218990340809182, 5.147057295204979],
            [15.259856805498403, 5.1558993955769745],
            [15.260296056416909, 5.154481889212691],
            [15.288256308934518, 5.160614318161032],
            [15.319800865220277, 5.168177559837509],
            [15.323681528982556, 5.156207786633866],
            [15.332553630477666, 5.116502644627734],
            [15.40764249164732, 5.132421505380551],
            [15.489877158112467, 5.1501740013692405],
            [15.498631289843296, 5.106299026976189],
            [15.514159871486433, 5.02733908982677],
            [15.517060861933961, 5.011315103421145],
            [15.520725308919467, 5.003229656294967],
            [15.520564023196805, 4.99976441160912],
            [15.531663004702713, 4.989661571887258],
            [15.537284713831694, 4.978664176690365],
            [15.541419423635558, 4.972150505156443],
            [15.546397279990993, 4.9690364810239105],
            [15.55162109763599, 4.970043129452927],
            [15.555710849857002, 4.967446673027583],
            [15.559848684315597, 4.967455202227258],
            [15.562909018972467, 4.969338687679915],
            [15.567421703406396, 4.975094352505391],
            [15.571593025048758, 4.972818750905151],
            [15.571743741951973, 4.969603022580505],
            [15.574549518053173, 4.967862620120026],
            [15.485591788625117, 4.948176944393716],
            [15.393978836608264, 4.9279193095701315],
            [15.299100430540065, 4.906266330875082],
            [15.206236773372428, 4.887296290748189],
            [15.12713681527813, 4.870610208056656],
            [15.036537607544977, 4.851189692661362],
            [15.029466081647882, 4.882845056769776],
            [15.030421796085951, 4.883451518960684],
            [15.011024038049385, 4.9507386808553635],
            [15.013976123218987, 4.952236128523553],
            [15.011548140776052, 4.962323967462442],
            [15.008733922181552, 4.961665942913643],
            [14.989984582330644, 5.032879680694148],
            [15.010988873410495, 5.038605032351824],
            [15.009117857961263, 5.045132199026445],
            [15.011659569233581, 5.045915670319032],
            [15.006729226009542, 5.06229423916194],
            [15.009372600647875, 5.063006989365317],
            [15.008358138513175, 5.070638931694825],
            [15.005842476495113, 5.082257851680264],
            [15.003426892165638, 5.081721515849928],
            [15.001069192934605, 5.085725107234684],
            [14.99860351122992, 5.094813542633848],
            [14.996162844238137, 5.094284369822908],
            [14.994804184396532, 5.099544114050332],
            [14.990917415865097, 5.098603306099825],
            [14.98905439233035, 5.106337612817363],
            [15.000420997168504, 5.109293221866122],
            [14.997460576334174, 5.115593279515164],
            [14.995526962315274, 5.122431611286255],
            [14.992818490074846, 5.121718525810176],
            [14.990994704533788, 5.128586150656495],
            [14.982018012194475, 5.126355634776491],
            [14.979505366853518, 5.134904087649294],
            [14.975641277447634, 5.134156164321393],
            [14.974356985776629, 5.140213113444662],
            [14.979946669879702, 5.1415220160964425],
            [14.977651613644875, 5.151025301747446],
            [14.975885513774662, 5.150579790440721],
            [14.97438606901422, 5.15750623175559],
            [14.971067969772015, 5.156753935016394],
            [14.969213231220778, 5.164956999376171],
            [14.964924310068739, 5.163917559853565],
            [14.963249479382414, 5.1716808669317516],
            [14.960417157187528, 5.171125989260955],
            [14.957939861838819, 5.181531735734936],
            [14.963246847098128, 5.182751427511913],
            [14.960701928744523, 5.192481447199953],
            [14.957169268788007, 5.201902857434207],
            [14.955243910316566, 5.201514146147774],
            [14.953176825738778, 5.211145825860938],
            [14.947558038053549, 5.210037886797168],
            [14.944417861049814, 5.223310882655974],
            [14.946325391826395, 5.223663872231536],
            [14.942017509607755, 5.2341933062251735],
            [14.938785739389905, 5.2438708720220175],
            [14.935083217737043, 5.243114123518485],
            [14.932984992324647, 5.251174331791816]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.81956099312585, "lat": 42.1602443829871 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36007"],
        "coty_name": ["Broome"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Broome County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00974102"
      },
      "bbox": [
        14.932984992324647, 4.851189692661362, 15.574549518053173,
        5.29704583854418
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.84333858307973, 8.09536896353746],
            [15.947093512157336, 8.125194042293828],
            [16.023305072805112, 8.145181054856712],
            [16.08349792193616, 8.159073615270122],
            [16.107911348221272, 8.165429180534204],
            [16.189779297575665, 8.188385961349255],
            [16.245474228628442, 8.20406624325561],
            [16.309757524628914, 8.221168207735548],
            [16.308819553035296, 8.204077935814883],
            [16.307412030099883, 8.196649020155167],
            [16.310196551996793, 8.190476566360124],
            [16.318194104067135, 8.182020078214418],
            [16.32340092680699, 8.17859863722098],
            [16.325233585998816, 8.173587141757206],
            [16.328129531176316, 8.1567668591776],
            [16.333454536969622, 8.138400218556317],
            [16.334634263817076, 8.132122475475212],
            [16.333894063095432, 8.128833406340638],
            [16.330055045858867, 8.124519362097052],
            [16.32590753611177, 8.116566333216563],
            [16.32479859120653, 8.108895972695985],
            [16.32598572069884, 8.078000594312696],
            [16.325024142079616, 8.073416003252502],
            [16.320892284845105, 8.066935987253231],
            [16.32267271376719, 8.055100540665705],
            [16.325640218063345, 8.048657826457799],
            [16.32886778302221, 8.047695046541442],
            [16.332945276254478, 8.042994780170512],
            [16.337847086348756, 8.039793031517368],
            [16.34767895802981, 8.035966142944165],
            [16.350874310225663, 8.032659715754088],
            [16.36381875510735, 8.023736672497396],
            [16.366136335465352, 8.01877962438954],
            [16.369143530172916, 8.008843850839435],
            [16.36896118462437, 8.001986901024923],
            [16.36445432090091, 7.994976288294223],
            [16.363293283475766, 7.991333696503528],
            [16.362458100905386, 7.973068245545075],
            [16.358337030714605, 7.961823250914324],
            [16.357937481008616, 7.958185921236341],
            [16.362092211996355, 7.942703083216176],
            [16.36810505111249, 7.9154640752012195],
            [16.372041385810668, 7.91330977154404],
            [16.37094084793801, 7.9059189217233685],
            [16.36823697177868, 7.902518216692093],
            [16.371757878421324, 7.896888908095296],
            [16.369314784088775, 7.895297484422787],
            [16.3702677130152, 7.886546964530139],
            [16.3727293386008, 7.884413414188548],
            [16.368713130166547, 7.873949104054274],
            [16.370383235836425, 7.87041350767744],
            [16.36849723829509, 7.86265213610709],
            [16.372681453400247, 7.859276086047967],
            [16.368214798576187, 7.85298654623581],
            [16.370082630294295, 7.847995215103921],
            [16.37064427746011, 7.833996589225154],
            [16.376585822989767, 7.830289033222274],
            [16.379749510209628, 7.823953320853724],
            [16.383758976705685, 7.819153150415626],
            [16.384394326272407, 7.813430473523613],
            [16.382737285029183, 7.808401293243921],
            [16.388725951926798, 7.802403649607082],
            [16.391163783811972, 7.796262555637675],
            [16.39794699928483, 7.789810044602481],
            [16.40191761791355, 7.787464525420811],
            [16.4074673569484, 7.782261390978051],
            [16.418461127652325, 7.778763867927719],
            [16.42263157291528, 7.7745931293722865],
            [16.338277012530593, 7.744971677236413],
            [16.33844779823436, 7.741058815808777],
            [16.341908069614934, 7.738257554194319],
            [16.34178981189544, 7.732583979826038],
            [16.345362113949648, 7.729424179109097],
            [16.341259726871534, 7.726581731625724],
            [16.338576707866803, 7.720878494420522],
            [16.340753149318317, 7.7159072520897105],
            [16.334855591610626, 7.71265193735682],
            [16.333492064979644, 7.706603382750858],
            [16.329293125599513, 7.70218735979502],
            [16.329622479450634, 7.69800424280586],
            [16.328294605885812, 7.691244652969391],
            [16.324461673146743, 7.691380882724268],
            [16.320499140432194, 7.689141783659888],
            [16.313016497477765, 7.688418711379612],
            [16.30827385067123, 7.6918122725207585],
            [16.306343818469088, 7.686592974921371],
            [16.297091960714432, 7.68265213952196],
            [16.293306960418967, 7.678028015477833],
            [16.288215137213225, 7.67666732595867],
            [16.286302874384802, 7.673229228113924],
            [16.286482756497076, 7.665975194664062],
            [16.284933715303826, 7.66218117377592],
            [16.280947488839292, 7.6573392456015865],
            [16.274466338731276, 7.654933461486191],
            [16.268020489624636, 7.649944030480899],
            [16.2637992653168, 7.6509830141697925],
            [16.261149447194875, 7.645261924850338],
            [16.253646333001242, 7.6396526042637944],
            [16.242605307933704, 7.641120201657392],
            [16.23711222346334, 7.633848907688636],
            [16.22713726398334, 7.627194987481501],
            [16.224943369398808, 7.621679100517723],
            [16.215294687458055, 7.616504783446929],
            [16.210279483754043, 7.616931959287186],
            [16.207594253163087, 7.614879984145106],
            [16.20070466548643, 7.614862487015285],
            [16.197321087132657, 7.612417632129543],
            [16.1957141595137, 7.616865043659123],
            [16.16285552385686, 7.605942129673855],
            [16.10214752256318, 7.5845099534988485],
            [16.054890328431007, 7.567474771619244],
            [16.03293412676974, 7.629756909318279],
            [16.030318383144266, 7.6380627049524685],
            [16.004989462648844, 7.705358523756539],
            [15.996323662970882, 7.7019732009458615],
            [15.951406895672228, 7.8284405795352665],
            [15.937749089530772, 7.823876023944964],
            [15.919449728405814, 7.8776182340227985],
            [15.908589729012355, 7.906544639725614],
            [15.904496024966472, 7.918598380921136],
            [15.894049470396471, 7.945370880468756],
            [15.88930840942609, 7.967465165553153],
            [15.882791295484967, 7.99276321089091],
            [15.879719604687422, 8.001779120961327],
            [15.865978955531562, 8.035845990757506],
            [15.84333858307973, 8.09536896353746]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.67817879727045,
          "lat": 44.746209796391085
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36019"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00974108"
      },
      "bbox": [
        15.84333858307973, 7.567474771619244, 16.42263157291528,
        8.221168207735548
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.754451923675337, 5.583152645823108],
            [14.809503718060382, 5.598237375535504],
            [14.858876047692679, 5.611970122604656],
            [14.866810998042538, 5.614438490080397],
            [14.891443966828714, 5.6209685842930766],
            [14.891142922086505, 5.622527129288453],
            [14.943956035280703, 5.637077653997739],
            [14.989911328657717, 5.650462051744419],
            [15.020512110210268, 5.659629125472361],
            [15.030987264865567, 5.624074861475852],
            [15.039148344122953, 5.594883060573438],
            [15.05784076060584, 5.529018133466326],
            [15.078490419837406, 5.455342168437095],
            [15.102954544865637, 5.369182179874712],
            [15.119748186109982, 5.30712370626093],
            [15.122779539060982, 5.29704583854418],
            [15.083467311906174, 5.285560906503391],
            [15.045849358316001, 5.275261445795734],
            [15.011330402178581, 5.266410925580348],
            [15.009923809547779, 5.269958351044934],
            [14.932984992324647, 5.251174331791816],
            [14.845159903126575, 5.229841595040268],
            [14.825273198796745, 5.3071441338650605],
            [14.82126994963191, 5.322343525620975],
            [14.811938469595868, 5.35986219744531],
            [14.79156884556502, 5.4398077640593],
            [14.77290028344809, 5.512398706942262],
            [14.754451923675337, 5.583152645823108]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.07030061831377, "lat": 42.59502808760242 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36023"],
        "coty_name": ["Cortland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cortland County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00974110"
      },
      "bbox": [
        14.754451923675337, 5.229841595040268, 15.122779539060982,
        5.659629125472361
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.12323781463807, 6.500419503475603],
            [16.21508293009823, 6.535065619992461],
            [16.297298464285692, 6.56615315420711],
            [16.31149737260255, 6.5716395083559584],
            [16.32127643328144, 6.56005202605209],
            [16.326578628052673, 6.5490176100940936],
            [16.325211118285633, 6.541720406721439],
            [16.32786763745697, 6.536209232107336],
            [16.33431226680424, 6.533081443016493],
            [16.337731204143108, 6.523913081475255],
            [16.34610625927897, 6.519473667409024],
            [16.347058683111168, 6.515156207617063],
            [16.344805661825596, 6.5100070187354815],
            [16.348845315552495, 6.505823045391171],
            [16.353072254420933, 6.505385086183183],
            [16.358595798144574, 6.501489792358599],
            [16.365856236588137, 6.4906394576139945],
            [16.368692162246965, 6.489522855563175],
            [16.373961971075893, 6.4912564753002036],
            [16.376144813276355, 6.485362950672524],
            [16.37760971034624, 6.470790371514077],
            [16.380527374134473, 6.4656785730164295],
            [16.380585494394847, 6.462786250134765],
            [16.377167855173568, 6.456608664994179],
            [16.37627886497953, 6.451244648751149],
            [16.37891253441725, 6.439466498775814],
            [16.382025612015337, 6.435382497026976],
            [16.387247836115122, 6.433157781538425],
            [16.39071793164731, 6.43632928331275],
            [16.39111250315463, 6.439151260110948],
            [16.40263233127506, 6.441541699157474],
            [16.410919097301846, 6.43931523085828],
            [16.415015039740844, 6.437003670061755],
            [16.423005610953272, 6.43053238611552],
            [16.427226331262666, 6.424409473264563],
            [16.433279403132957, 6.420061379220468],
            [16.43585849703176, 6.421121843765917],
            [16.437302959088907, 6.430789724810764],
            [16.44256625575259, 6.437666772404512],
            [16.446236184154703, 6.444056765626547],
            [16.44771550284791, 6.456742516977037],
            [16.443821456224875, 6.466938189214324],
            [16.447730376905017, 6.472305702044531],
            [16.45494705228832, 6.47689450092221],
            [16.462099080422984, 6.4795005375100505],
            [16.465301520857142, 6.485871148324417],
            [16.47233488228028, 6.487694583582455],
            [16.473345216590666, 6.492501770950127],
            [16.478072284110446, 6.492791277164498],
            [16.4832738094877, 6.482966610208526],
            [16.48450094534217, 6.479166274339318],
            [16.48898671050602, 6.475386858950894],
            [16.49453386408562, 6.478120086976734],
            [16.497186529965546, 6.4868225855928445],
            [16.4868654061021, 6.494167996236687],
            [16.48638435447339, 6.5023852050928586],
            [16.488394717898853, 6.504379922206476],
            [16.500401671409456, 6.50555592703702],
            [16.50635543708262, 6.510253181807233],
            [16.503168582946486, 6.52068580657522],
            [16.507308569513807, 6.524573548981541],
            [16.513183256604062, 6.522929557659813],
            [16.525798793932456, 6.528512172443156],
            [16.53658656189163, 6.530455202752352],
            [16.541998358597745, 6.526216845651171],
            [16.540529075316986, 6.520259985312732],
            [16.540000774683005, 6.508867948170856],
            [16.538974158081324, 6.504153478573215],
            [16.541049561714587, 6.4934273791393995],
            [16.544321134414098, 6.4944966479940565],
            [16.550453028411166, 6.490410968136746],
            [16.552714378859747, 6.486840373791116],
            [16.55372483467572, 6.480699073259632],
            [16.54935121996938, 6.470352291803523],
            [16.549889515677574, 6.466894956656868],
            [16.555022450823436, 6.459096234219373],
            [16.561185192216563, 6.455705664727819],
            [16.566299073006167, 6.448159209253798],
            [16.57024430568917, 6.43883771799503],
            [16.569041346823465, 6.4317309678418635],
            [16.569421644699766, 6.422423533108173],
            [16.57260710423302, 6.41961206323888],
            [16.575234631655217, 6.412890589888188],
            [16.574562833564425, 6.406929273858712],
            [16.57182718629342, 6.39972916292434],
            [16.581808114782355, 6.387686876376151],
            [16.582747310655137, 6.384263496366228],
            [16.580610537723313, 6.378655504033273],
            [16.578457333264442, 6.369475973316635],
            [16.580982892749724, 6.361869676888469],
            [16.58408438264954, 6.359163715394464],
            [16.585810841794657, 6.35497227365148],
            [16.592820953078274, 6.351828152041596],
            [16.595022215702958, 6.348114923950051],
            [16.595611503594167, 6.343746191816343],
            [16.59989685725398, 6.334577205820354],
            [16.59877630912124, 6.3241212516036285],
            [16.602296855802162, 6.318127647452374],
            [16.60287833722571, 6.31459627894067],
            [16.60087669578271, 6.306514174097606],
            [16.60146886252892, 6.302217422332501],
            [16.606526522223614, 6.293117265155834],
            [16.605852780910162, 6.286711781518302],
            [16.60301493226239, 6.283090954410425],
            [16.60385330393448, 6.276017627824031],
            [16.603128073366957, 6.2648556569779865],
            [16.605673478856374, 6.2564985110615385],
            [16.605815246920553, 6.24737176774055],
            [16.60475541683203, 6.239965666902174],
            [16.600732620218714, 6.232843301086193],
            [16.600533948711302, 6.226028204631253],
            [16.60240802930981, 6.215225127528672],
            [16.601750532866976, 6.212488716191182],
            [16.59040190840239, 6.20032745084905],
            [16.58952180806552, 6.1976419685124045],
            [16.5939571317827, 6.187813617196522],
            [16.5953723642556, 6.179014798588088],
            [16.59487566057572, 6.172844486495758],
            [16.593364638874053, 6.169308200245977],
            [16.59062590464812, 6.166730678326535],
            [16.583317176858618, 6.163817214992942],
            [16.578081995918854, 6.157518036438095],
            [16.576994249858757, 6.150521415694907],
            [16.56941175040518, 6.133706329868975],
            [16.5686039918899, 6.122308668906213],
            [16.569963391011704, 6.113915552279389],
            [16.57576997902805, 6.104494640315412],
            [16.582061676291907, 6.0988057049360505],
            [16.583662582581045, 6.090361258718702],
            [16.584097859147413, 6.082045400917185],
            [16.58634767451341, 6.079382419556996],
            [16.59226019349749, 6.064620282717282],
            [16.598869846750574, 6.056526812790528],
            [16.604884862226513, 6.04626854083842],
            [16.60805618196538, 6.036839639635755],
            [16.60742829010383, 6.0304154822998015],
            [16.603828063831397, 6.02667808261468],
            [16.601313152833054, 6.0215678365408865],
            [16.601818375638175, 6.016015117940872],
            [16.601116299823648, 6.008648434099067],
            [16.598609444003, 6.008154778412603],
            [16.59707730319378, 6.00301622115716],
            [16.594166133165057, 5.998868440648076],
            [16.58805458002596, 6.000470218053749],
            [16.57723843380368, 6.007496281442085],
            [16.573782374734332, 6.0143893387151515],
            [16.566326318651107, 6.018892231833228],
            [16.566889165363225, 6.0252041137267875],
            [16.562505231054775, 6.0301209112260645],
            [16.56039584234857, 6.036407770449612],
            [16.55652678061004, 6.038471554767351],
            [16.549588869919912, 6.033019714821457],
            [16.545171775255564, 6.0179843228735885],
            [16.54480478756072, 6.01388639180676],
            [16.54033805804505, 6.00655376851677],
            [16.538353369930974, 5.999192704339922],
            [16.535222179950225, 5.995674842810175],
            [16.527743673042266, 5.999970816323497],
            [16.524124457853635, 5.999113646195164],
            [16.521348549065408, 5.99629671398961],
            [16.518389166184754, 5.988294494968333],
            [16.515063494651297, 5.983703360858058],
            [16.508034758840473, 5.98203128222325],
            [16.498623103950965, 5.98125486613965],
            [16.493079700886494, 5.984676088117561],
            [16.49142468087448, 5.98973298792072],
            [16.48854615303472, 5.992033861314736],
            [16.480760020789393, 5.995129325243392],
            [16.476201532844268, 6.00073639661651],
            [16.469667206482928, 6.006512509237765],
            [16.46363397079918, 6.013811506944095],
            [16.455794437217218, 6.020598106264844],
            [16.44797380072706, 6.024816324042943],
            [16.441961097350823, 6.038100426839763],
            [16.439933668711873, 6.0399879126422205],
            [16.43568817942107, 6.038274010819637],
            [16.429838158342896, 6.037814825152001],
            [16.41761329258732, 6.073535085154046],
            [16.40992279478028, 6.09488357551937],
            [16.400119777889245, 6.091747151554336],
            [16.389891120741545, 6.084378997502568],
            [16.383099659862037, 6.077772993212431],
            [16.376932352308614, 6.072885687920632],
            [16.369219856571483, 6.075959968724597],
            [16.35747900181581, 6.087424854335671],
            [16.34174926644148, 6.095881724540789],
            [16.332245110700722, 6.1001815372258426],
            [16.322318931003043, 6.102742766755736],
            [16.311464337497505, 6.104625621627092],
            [16.303632857110493, 6.1081507356399465],
            [16.29304747529837, 6.110749184360444],
            [16.265974525940692, 6.107075656229281],
            [16.256578333511438, 6.132681990237638],
            [16.22038816976096, 6.233212678177599],
            [16.190300195673604, 6.31692632165126],
            [16.172896370719684, 6.365599570356073],
            [16.16422516845173, 6.389382379312706],
            [16.12323781463807, 6.500419503475603]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.86390700327586,
          "lat": 43.107383401330516
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36091"],
        "coty_name": ["Saratoga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saratoga County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00974143"
      },
      "bbox": [
        16.12323781463807, 5.98125486613965, 16.60805618196538,
        6.5716395083559584
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.216563468708966, 5.1787962647618455],
            [14.26401107978999, 5.189169637445081],
            [14.3010149619533, 5.196866513413196],
            [14.306319138189735, 5.1758764317686685],
            [14.32299557886884, 5.180268636408229],
            [14.324353650859743, 5.175363729119979],
            [14.376854357139875, 5.189956021955114],
            [14.366296266981209, 5.209498960439839],
            [14.362749220621232, 5.218555709937124],
            [14.358334967498472, 5.245090308290533],
            [14.356925259878583, 5.266185166318094],
            [14.498549418817456, 5.300446572119991],
            [14.512059723603336, 5.247284858172496],
            [14.526480838733047, 5.1924781616652504],
            [14.541258624559958, 5.13351881794203],
            [14.538173716192118, 5.130950107362412],
            [14.550907961919133, 5.072371760014203],
            [14.549967643264202, 5.072051853757217],
            [14.555617944222163, 5.043507450669997],
            [14.607806870497736, 5.052748225774248],
            [14.614611456063319, 5.01913728846971],
            [14.601293201665127, 5.001091702483281],
            [14.596183955180923, 5.0045191565003515],
            [14.569222200720851, 4.99855302475283],
            [14.566977272698951, 5.009003201718102],
            [14.53326030993024, 5.001802927474816],
            [14.523114796369521, 5.046482731205818],
            [14.515039329617267, 5.045117575405644],
            [14.47294416862811, 5.036911852459789],
            [14.44465193781978, 5.030502065298791],
            [14.409244948497356, 5.02046026259249],
            [14.358183559999684, 5.006494603930349],
            [14.359782782205473, 4.997664099478215],
            [14.336467204758987, 4.992668707519692],
            [14.329875690790079, 4.990781715257262],
            [14.281324065206553, 4.978755230378348],
            [14.271911082672402, 4.973327589169788],
            [14.26402461135562, 4.972087570478986],
            [14.23701812212398, 5.086284466710246],
            [14.233306805567652, 5.103493732911356],
            [14.216563468708966, 5.1787962647618455]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.87519576073521,
          "lat": 42.393808224228614
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36097"],
        "coty_name": ["Schuyler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schuyler County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00974146"
      },
      "bbox": [
        14.216563468708966, 4.972087570478986, 14.614611456063319,
        5.300446572119991
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.185579392777537, -2.0571649927780395],
            [12.19014157117971, -2.057226654490863],
            [12.193301852681062, -2.0548960731432113],
            [12.193344584046182, -2.0487690389123356],
            [12.190197302036092, -2.0437209262499914],
            [12.192856566535378, -2.0396788969745727],
            [12.19423121213759, -2.0317037622473375],
            [12.197672314349315, -2.0269510739625836],
            [12.20461976275671, -2.025142731465152],
            [12.219110846245565, -2.0223008370316764],
            [12.223673620930708, -2.015947145817408],
            [12.227370399738794, -2.0152060490213826],
            [12.233070151074603, -2.018763188249852],
            [12.239100095474223, -2.0160472085287617],
            [12.24347557236201, -2.0104428581111153],
            [12.246923272443155, -2.008363636038641],
            [12.255373315241775, -2.0088921877080526],
            [12.265669721514142, -2.0033873016356623],
            [12.267239910716912, -1.9975172386837785],
            [12.269308033577326, -1.9952196388634813],
            [12.276142746275367, -1.9970854859160765],
            [12.283169571870593, -1.9964165814543424],
            [12.288681363557409, -1.9985139875874067],
            [12.292304826214702, -1.9948144136445638],
            [12.295112295353068, -1.9895866240141877],
            [12.303019107309742, -1.9827086303861916],
            [12.305517517925304, -1.9818175144307006],
            [12.310463887035754, -1.9832138991152763],
            [12.313252527431953, -1.9817215921981017],
            [12.326153203074854, -1.9788173278427557],
            [12.332710292994577, -1.9750656741059511],
            [12.337124704096782, -1.975342329906083],
            [12.34206231310731, -1.9709480590262605],
            [12.346125667190083, -1.969647854554468],
            [12.352186149715289, -1.9705220922841835],
            [12.354954258717763, -1.9839840427649054],
            [12.358053353910488, -1.9887161910923334],
            [12.364250824710105, -1.9919521767144925],
            [12.366424717859218, -1.9954311125755955],
            [12.368945601301974, -2.0060298593725676],
            [12.374263563002184, -2.01015738601069],
            [12.380335980805391, -2.011885652071507],
            [12.38619536709851, -2.016794898685543],
            [12.391348524809686, -2.0226382468738273],
            [12.394108808331405, -2.024290266272672],
            [12.40119109270713, -2.0229997081146385],
            [12.404451795450827, -2.0258516556656554],
            [12.404300067986409, -2.0335394767409745],
            [12.411459681950749, -2.038823578026492],
            [12.416516402400472, -2.0440835049142896],
            [12.423967894374917, -2.0486486163394226],
            [12.426159905410525, -2.0511074105644203],
            [12.429899550677963, -2.059006208659552],
            [12.429673089891166, -2.0663321893697155],
            [12.431202957820663, -2.0726264978210045],
            [12.43578968101563, -2.0766856068417616],
            [12.445352476456145, -2.0775656630520416],
            [12.455694771991235, -2.0757580594826885],
            [12.460801728384471, -2.0724204799205626],
            [12.469186087146653, -2.0688631540920412],
            [12.478290571001795, -2.0695106371587584],
            [12.482591519922337, -2.07139694513056],
            [12.489376411543859, -2.076495497285392],
            [12.493436275642802, -2.0839878160937038],
            [12.497049962286138, -2.0856805671688785],
            [12.50073277317237, -2.089983388996958],
            [12.502922917322909, -2.095218136891309],
            [12.509976614536273, -2.0989245199351503],
            [12.516388722701969, -2.103948780737612],
            [12.518285627670984, -2.110449157067714],
            [12.5227035817337, -2.114256116815596],
            [12.52526724004227, -2.1194951301018703],
            [12.528806732322797, -2.1231325019767047],
            [12.531253707305009, -2.1292201303088922],
            [12.53383792238796, -2.13186197831675],
            [12.539892772782265, -2.1344011155979263],
            [12.545517132724267, -2.1400954641350505],
            [12.552012865748738, -2.1437815816179415],
            [12.557090146808841, -2.148576227239995],
            [12.557009107040983, -2.151480013720257],
            [12.55310952092969, -2.1552706974324423],
            [12.548814661182975, -2.157025860254673],
            [12.546659369361397, -2.160625312769611],
            [12.545312989352478, -2.166810584742789],
            [12.547995219069572, -2.170597385053686],
            [12.552370494143974, -2.1732069937465472],
            [12.555408757039622, -2.17949147229708],
            [12.553269202658626, -2.1833671651342437],
            [12.546901218758984, -2.1866190061054245],
            [12.542893482715144, -2.1913529765728588],
            [12.540584943085205, -2.199302391760934],
            [12.541469235679426, -2.2093357226459354],
            [12.545423880506913, -2.2184768969768442],
            [12.54139100701664, -2.226565129818633],
            [12.49690710811691, -2.23199217760556],
            [12.44917877107296, -2.2368659483510998],
            [12.439402563386688, -2.238159933446361],
            [12.36143662864221, -2.246823984448066],
            [12.348881589265623, -2.2484056857634442],
            [12.312590446449414, -2.252263012939811],
            [12.241511831451671, -2.2593984995650276],
            [12.191868493971116, -2.2647369257052983],
            [12.157430533638095, -2.2686231701269657],
            [12.130400295755578, -2.271460757559344],
            [12.079755876566642, -2.2771942651798502],
            [12.080380636601504, -2.2748565780369225],
            [12.096437664301495, -2.234018172364905],
            [12.136450083838708, -2.1688640070587364],
            [12.144530286556218, -2.155310403559564],
            [12.1655139712763, -2.1050797974271847],
            [12.173543847043558, -2.0867571062174335],
            [12.185579392777537, -2.0571649927780395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.21510523271748, "lat": 35.6620557255306 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37035"],
        "coty_name": ["Catawba"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Catawba County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01008543"
      },
      "bbox": [
        12.079755876566642, -2.2771942651798502, 12.557090146808841,
        -1.969647854554468
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.952645570861314, -2.6918207189930423],
            [11.953147223851952, -2.6486830272211175],
            [11.96056786605787, -2.6094960830447356],
            [11.978181796757363, -2.5076520774246496],
            [11.97313088481089, -2.4642230112529737],
            [11.97299216316809, -2.461563864414621],
            [11.964421298740973, -2.3786248536626666],
            [11.961465300529328, -2.3488809475649903],
            [11.953162383347857, -2.2843481290602194],
            [11.954156339812233, -2.2809608201188003],
            [11.959647508215056, -2.2863099263889115],
            [11.96286777798553, -2.286399699681836],
            [11.966107575768827, -2.290341036183425],
            [11.971924726630837, -2.2950352330537025],
            [11.978272595244515, -2.2933065708973177],
            [11.990244120755195, -2.297514293190809],
            [12.001005418156995, -2.2920103591145145],
            [12.00822813777017, -2.289928733070838],
            [12.014803645347657, -2.2898541371559555],
            [12.022745092435581, -2.2872413644606557],
            [12.029512783933798, -2.281992934846926],
            [12.033170701878435, -2.2858314471770074],
            [12.036492440828283, -2.286962346628358],
            [12.043878897544577, -2.2833151770777653],
            [12.046686576455672, -2.284027483654132],
            [12.045862356371815, -2.2883890933557187],
            [12.051089562399211, -2.2912283026597193],
            [12.056187026600032, -2.2892924113416044],
            [12.06010451610739, -2.2855120877202957],
            [12.064582418617343, -2.285528657502952],
            [12.07239230621066, -2.281806604121428],
            [12.078603830971813, -2.2813579159721105],
            [12.097185630451307, -2.284557988708935],
            [12.103346466815017, -2.2917162490346596],
            [12.10501455506902, -2.3019957161554445],
            [12.10540294934716, -2.3125235178839283],
            [12.104470678299862, -2.3191189445762372],
            [12.117497693982058, -2.3384724000677837],
            [12.123112106373327, -2.3460580072791366],
            [12.127078755889483, -2.3528684672027946],
            [12.137636112059978, -2.3668705939356696],
            [12.144099292123467, -2.3774382137778294],
            [12.153678783207308, -2.3942805302314096],
            [12.163003047603878, -2.4117404061504844],
            [12.166155064093111, -2.4152017953076554],
            [12.166516759530271, -2.4160782560969682],
            [12.221690764497252, -2.4746275762152137],
            [12.235638585755408, -2.479672313067289],
            [12.258926819590386, -2.4918417797287304],
            [12.254442837502637, -2.4995840622653183],
            [12.25343733304084, -2.5087539984288885],
            [12.260821883863667, -2.5207543290514476],
            [12.265776536063155, -2.527720559582427],
            [12.26589163869555, -2.5341229046251144],
            [12.267359432419482, -2.541299484965613],
            [12.26970994547399, -2.544481873144436],
            [12.297743956708034, -2.5573648620704312],
            [12.298717951395243, -2.5769287672755055],
            [12.307184441541525, -2.6281465493379867],
            [12.307748396903332, -2.65477626988769],
            [12.27663744734959, -2.658092309235345],
            [12.174299794414745, -2.6687269399957865],
            [12.103107358746263, -2.676442936999336],
            [11.994418930824974, -2.6870792466532754],
            [11.952645570861314, -2.6918207189930423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.5555413517872, "lat": 35.33407177263892 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37045"],
        "coty_name": ["Cleveland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cleveland County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01008547"
      },
      "bbox": [
        11.952645570861314, -2.6918207189930423, 12.307748396903332,
        -2.2809608201188003
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.511977180156197, -2.464226423192423],
            [11.524483989952316, -2.469672938366363],
            [11.530582569772575, -2.4614987950169893],
            [11.540657181703773, -2.429031059676111],
            [11.537439820767275, -2.422948805321552],
            [11.531817465466853, -2.418747090193861],
            [11.530778635245559, -2.413223164878325],
            [11.531763918676718, -2.4082456672432966],
            [11.540536766185166, -2.4068849354132786],
            [11.572725196213721, -2.395482598402332],
            [11.580477237096916, -2.3931150752655292],
            [11.596687266215117, -2.4007338557608833],
            [11.638207727071837, -2.380775160531058],
            [11.648625824882448, -2.377408546298672],
            [11.682860646976524, -2.3730660918563187],
            [11.697152740308784, -2.364964770338146],
            [11.702154784055148, -2.354821625363942],
            [11.70963963398107, -2.3496298832683955],
            [11.717391767122763, -2.356399444558612],
            [11.725131820648478, -2.3594419927513255],
            [11.72485526599645, -2.3613715680553047],
            [11.73250561787738, -2.36781759007831],
            [11.741476417275196, -2.371203877817244],
            [11.749426118276315, -2.3682212162374463],
            [11.767501908798893, -2.357071203894854],
            [11.777610599032792, -2.35802416040787],
            [11.789099039391042, -2.347894923561898],
            [11.838719479383261, -2.3401196545009992],
            [11.837118830641334, -2.3362054934002887],
            [11.839220888685489, -2.3260486330001675],
            [11.843704238369341, -2.3220434750384316],
            [11.842694865706475, -2.3185279076427756],
            [11.845518994038525, -2.3125897645270572],
            [11.845377356113644, -2.306848880080829],
            [11.84860881493879, -2.3052780006613407],
            [11.849365879535497, -2.2995264507998034],
            [11.853917730877031, -2.3011754314398245],
            [11.858819475505657, -2.297284479023972],
            [11.865097290135722, -2.299556318779983],
            [11.868058668867201, -2.2972726940562143],
            [11.86969334178161, -2.2912652596242506],
            [11.868645871733415, -2.2894795587818924],
            [11.869830789399865, -2.2834754473545558],
            [11.874973396861472, -2.2816859431229783],
            [11.880755377652756, -2.2833469502864046],
            [11.887317902956195, -2.2811428613421803],
            [11.889620640124967, -2.275708884036725],
            [11.888867504413355, -2.2707099853182613],
            [11.890023117021663, -2.2664092812568173],
            [11.896637527211285, -2.2629410706990107],
            [11.899159195341172, -2.258307537733146],
            [11.905595139520972, -2.2653904748571847],
            [11.912049700445102, -2.26594724902199],
            [11.917221494576369, -2.2676222386840497],
            [11.925516746155658, -2.261748803567843],
            [11.929294520746804, -2.2629404192349516],
            [11.931471581239027, -2.2661147797939334],
            [11.931505443731956, -2.272361547317517],
            [11.937726508253087, -2.277019278082096],
            [11.94209566555187, -2.2848285489639464],
            [11.945069744693651, -2.2839100983217597],
            [11.949325301264805, -2.2861716351687513],
            [11.953162383347857, -2.2843481290602194],
            [11.961465300529328, -2.3488809475649903],
            [11.964421298740973, -2.3786248536626666],
            [11.97299216316809, -2.461563864414621],
            [11.97313088481089, -2.4642230112529737],
            [11.978181796757363, -2.5076520774246496],
            [11.96056786605787, -2.6094960830447356],
            [11.953147223851952, -2.6486830272211175],
            [11.952645570861314, -2.6918207189930423],
            [11.925274267100239, -2.694914904969115],
            [11.866688250616782, -2.7009233921123132],
            [11.825673124147245, -2.7056351535865955],
            [11.790369298639986, -2.7091314810015903],
            [11.786275835028256, -2.6909487392624247],
            [11.785524252747196, -2.685035812156963],
            [11.786975430957995, -2.676066484332071],
            [11.789727459452752, -2.6688544990693814],
            [11.786802609758427, -2.665008390383781],
            [11.785075272242173, -2.651473204897679],
            [11.785522931856008, -2.646465664486565],
            [11.78096473768512, -2.644094751648446],
            [11.78035040316159, -2.6387641044585624],
            [11.776616606361271, -2.6375735250056476],
            [11.772448943414814, -2.6342466492453265],
            [11.768534006612311, -2.634806360446662],
            [11.756884039018166, -2.6291545903727687],
            [11.75308887761488, -2.6240458063043555],
            [11.751168399843824, -2.617852172040994],
            [11.747006187377512, -2.616948969323206],
            [11.742487324475169, -2.6122362819178044],
            [11.737626104191534, -2.6092203660712565],
            [11.735821416615426, -2.603202827766727],
            [11.730702913093884, -2.60483857034784],
            [11.725262416679781, -2.602371214764133],
            [11.722508737456002, -2.594754804906852],
            [11.717019535498402, -2.591228553250222],
            [11.711174710318106, -2.5849376661765517],
            [11.709082951512869, -2.585205957633604],
            [11.703788990984043, -2.5775475500476075],
            [11.70067810927377, -2.5714451113680705],
            [11.698134739365099, -2.570271064303929],
            [11.69207622856505, -2.573533714850204],
            [11.688931578113989, -2.569313433385815],
            [11.685296637679807, -2.5701479731419896],
            [11.681241805675594, -2.5676416792728225],
            [11.6789182998635, -2.564283091289853],
            [11.677552169710893, -2.5569743057648],
            [11.67340598894867, -2.557253115072007],
            [11.6699678823761, -2.5551974269259916],
            [11.66804680644562, -2.551265844625553],
            [11.661050072460895, -2.5421859862571536],
            [11.654348827642998, -2.545005710942443],
            [11.651031416099684, -2.5322460958616086],
            [11.644104984008743, -2.5268699134982997],
            [11.640462274836313, -2.526826644581239],
            [11.63770101696937, -2.5225726959664696],
            [11.631486038111158, -2.519055113778097],
            [11.629696996501524, -2.520550455120602],
            [11.620387800692367, -2.517111398540076],
            [11.612066683609886, -2.510974622712385],
            [11.605010490413846, -2.5102026246005154],
            [11.600807616123681, -2.51242576924036],
            [11.595766864960144, -2.5115930460192653],
            [11.594691161200226, -2.515838425792994],
            [11.589701445347524, -2.5188299964700938],
            [11.58679877325269, -2.5258411014647453],
            [11.583558228717552, -2.523810132178036],
            [11.5808706613375, -2.5259886637726368],
            [11.577402449628357, -2.524777108736897],
            [11.575160201184346, -2.5211514673003808],
            [11.570264079855146, -2.521115911394397],
            [11.567563406283007, -2.5275821282429054],
            [11.563188918096124, -2.527709285941835],
            [11.558791248476654, -2.5319515603233054],
            [11.553652687573589, -2.5318463328337417],
            [11.542789030263451, -2.5262160679139334],
            [11.535195258257096, -2.529867132341739],
            [11.529142083505842, -2.534691655926308],
            [11.52640842328991, -2.538132551559796],
            [11.521540271678903, -2.533491199786868],
            [11.518319486883835, -2.532018081388776],
            [11.518586411822705, -2.525631974902079],
            [11.515214697947327, -2.5233944099273744],
            [11.513563051991449, -2.5138831486465376],
            [11.510398779587401, -2.5092869345760427],
            [11.511272400136145, -2.502129092125879],
            [11.508013137523992, -2.495912832343161],
            [11.505504096146495, -2.4946700174518464],
            [11.503751976713225, -2.490300291943993],
            [11.50633203174291, -2.484294987427531],
            [11.511977180156197, -2.464226423192423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.919818699275, "lat": 35.402530781669675 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37161"],
        "coty_name": ["Rutherford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rutherford County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01008584"
      },
      "bbox": [
        11.503751976713225, -2.7091314810015903, 11.978181796757363,
        -2.258307537733146
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.220202261636613, 8.566902090419916],
            [-1.2060382092043305, 8.56668951596509],
            [-1.1339161354940992, 8.56490987559295],
            [-1.048325491076388, 8.563349249228633],
            [-1.0347978264654423, 8.562923711337321],
            [-0.9619648543228019, 8.561644552315599],
            [-0.9331695321811412, 8.560602026682249],
            [-0.8749783632469653, 8.558870236076073],
            [-0.8172075121934531, 8.557957696704475],
            [-0.7884507313783115, 8.557074908175707],
            [-0.7007538379466276, 8.555203799482637],
            [-0.7011352073602826, 8.525539232325956],
            [-0.7025954444597402, 8.44081316514046],
            [-0.7037695934930267, 8.368092021487511],
            [-0.7055861357297197, 8.29794318064304],
            [-0.6886844276124008, 8.297569224966242],
            [-0.689687265672537, 8.237950478351602],
            [-0.6918956781684742, 8.125552584056042],
            [-0.6934680116061623, 8.039777104503235],
            [-0.6951693653434579, 7.95394236242239],
            [-0.7650014355311883, 7.95539582693914],
            [-0.85147200545326, 7.957322079761235],
            [-0.9375488314333787, 7.959424215201725],
            [-1.0239150527817256, 7.961677574605336],
            [-1.1105944312961078, 7.963801507556369],
            [-1.216652880486679, 7.9663176548312915],
            [-1.2154777077393653, 8.009158782602121],
            [-1.2138553217554047, 8.08090244723737],
            [-1.2121094492936062, 8.136037227325827],
            [-1.2111496198501888, 8.180871800630378],
            [-1.2085984710415518, 8.288911168744189],
            [-1.2082101762171606, 8.309849651664605],
            [-1.2272554812954692, 8.310299811311413],
            [-1.2248678503497854, 8.395895806247522],
            [-1.2220139473765594, 8.502842385473961],
            [-1.220202261636613, 8.566902090419916]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.0715470309951, "lat": 46.936092511709894 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38003"],
        "coty_name": ["Barnes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barnes County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01034225"
      },
      "bbox": [
        -1.2272554812954692, 7.95394236242239, -0.6886844276124008,
        8.566902090419916
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1217722560901113, 8.667440027944938],
            [-3.117343859788956, 8.665981791068623],
            [-3.1069513897355057, 8.658924810809152],
            [-3.103212483830018, 8.654902636774517],
            [-3.0943307787278256, 8.649780878357214],
            [-3.085742449271143, 8.647902028758292],
            [-3.080560373826131, 8.649354553476995],
            [-3.0752769440570233, 8.660832446659509],
            [-3.0752951277702727, 8.668502318669404],
            [-3.072915950420135, 8.67567018811435],
            [-3.068849350262852, 8.679997122843004],
            [-3.0448053341348014, 8.684033495559948],
            [-3.0286364039028655, 8.69032781819768],
            [-3.017530401074387, 8.691743591180833],
            [-3.009791479070295, 8.69123912476514],
            [-3.0048777784569665, 8.69228194268289],
            [-2.998496361596886, 8.69004446361213],
            [-2.9863045209598273, 8.688121380024347],
            [-2.982240095855886, 8.684954328016358],
            [-2.970816677726078, 8.681432663444161],
            [-2.963697271300346, 8.676598490459028],
            [-2.9591012294163734, 8.671828898437028],
            [-2.9482102870990334, 8.664664999416871],
            [-2.942578945110226, 8.658626592668117],
            [-2.9418634498894485, 8.65407941408708],
            [-2.939066900116781, 8.650507980186081],
            [-2.934788906383593, 8.648046126052805],
            [-2.932163551090855, 8.642664295776493],
            [-2.931550859858386, 8.633475777069924],
            [-2.9320203120048083, 8.627198363872822],
            [-2.935247951668737, 8.619192725052995],
            [-2.939777218192439, 8.611155886343314],
            [-2.94492013678475, 8.598029619326098],
            [-2.94544274667589, 8.589488313866752],
            [-2.9440808224846897, 8.581636562342455],
            [-2.939950986753616, 8.56792767787874],
            [-2.9351003791939663, 8.559993706516178],
            [-2.9286786292250393, 8.551032800430795],
            [-2.925574749721246, 8.546003819841403],
            [-2.920646696541545, 8.54210433088299],
            [-2.915445389635345, 8.532969491071677],
            [-2.9128673909432456, 8.517228183840345],
            [-2.91287640146143, 8.487645861711783],
            [-2.9120066044089117, 8.483755704065619],
            [-2.9055205474776096, 8.470778973053815],
            [-2.890353781387832, 8.453573230043505],
            [-2.8843223900084, 8.447774275131604],
            [-2.878866842225295, 8.44022774691789],
            [-2.875477156936975, 8.431163753659089],
            [-2.877072793397981, 8.415375762738314],
            [-2.879096053950907, 8.408525997705558],
            [-2.8890059490080353, 8.396802707733835],
            [-2.893186644959061, 8.394332119186634],
            [-2.904081539791716, 8.390348613360837],
            [-2.911988734288206, 8.385832619871985],
            [-2.917575321050959, 8.378669539305582],
            [-2.991141224536958, 8.38208397821601],
            [-3.064707784713182, 8.385481773685683],
            [-3.1115071625054314, 8.387454836025855],
            [-3.1549647302886252, 8.389509011529109],
            [-3.2543948286456312, 8.395121545451115],
            [-3.293404327507125, 8.39747863431923],
            [-3.4123271338438976, 8.404353049396022],
            [-3.4845101687079194, 8.408761910109028],
            [-3.4810443353391216, 8.465621240110602],
            [-3.474393165443917, 8.574778546553578],
            [-3.4720657122642615, 8.609989769259457],
            [-3.469005799712535, 8.66400737346007],
            [-3.444465455638206, 8.66279777823864],
            [-3.440201340774505, 8.662979873790881],
            [-3.425797548196526, 8.66163454208381],
            [-3.3579754228426184, 8.657600618774087],
            [-3.2911623634400486, 8.653878422679584],
            [-3.2243500736079125, 8.650142242941655],
            [-3.123477456528989, 8.644342144868391],
            [-3.1217722560901113, 8.667440027944938]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.34030724928259,
          "lat": 47.115251528431386
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38065"],
        "coty_name": ["Oliver"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oliver County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01034205"
      },
      "bbox": [
        -3.4845101687079194, 8.378669539305582, -2.875477156936975,
        8.69228194268289
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.080545343548998, 8.088372982528677],
            [-5.000736672174209, 8.081720371402708],
            [-4.920929632029972, 8.075048675859593],
            [-4.9126416639929085, 8.07429489034439],
            [-4.905390982861732, 8.16184448995084],
            [-4.854177758901411, 8.157734839475868],
            [-4.773764797696932, 8.15138709406744],
            [-4.704031929709147, 8.146052984467792],
            [-4.634300170721197, 8.140704226108635],
            [-4.561673698425375, 8.134924844975439],
            [-4.514368226894873, 8.131240751523045],
            [-4.475149617959101, 8.128423298372327],
            [-4.441744427657703, 8.12578724675159],
            [-4.375921815153234, 8.121010599483226],
            [-4.305320937654855, 8.116050305489182],
            [-4.308410312588249, 8.073101937813828],
            [-4.310645702427606, 8.027899748546925],
            [-4.316475726610698, 7.944157603255923],
            [-4.323123798929574, 7.858537586509587],
            [-4.32862171799721, 7.772638608631247],
            [-4.37752628206303, 7.775333881681328],
            [-4.415305725229279, 7.7773523302796495],
            [-4.501987707015059, 7.783779594209361],
            [-4.567445534062407, 7.78866012733191],
            [-4.664662855409462, 7.796242881602913],
            [-4.721932443983058, 7.800777334567615],
            [-4.847841554723062, 7.810752646026221],
            [-4.934386009009495, 7.817748486977473],
            [-5.035138445604757, 7.826299123831747],
            [-5.102754061112613, 7.8317398840300365],
            [-5.095477674361352, 7.9172008454216245],
            [-5.094468886116539, 7.934015320088174],
            [-5.083127726587173, 8.057808441352563],
            [-5.080545343548998, 8.088372982528677]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -103.45989258255398, "lat": 46.4472278162965 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38087"],
        "coty_name": ["Slope"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Slope County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01035896"
      },
      "bbox": [
        -5.102754061112613, 7.772638608631247, -4.305320937654855,
        8.16184448995084
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.266083516154987, 7.4227407176772315],
            [-15.239068396746044, 7.41643589493703],
            [-15.235742713783742, 7.430484772313879],
            [-15.207647787579125, 7.423840287720167],
            [-15.200630199040187, 7.451654206821186],
            [-15.186531858324477, 7.448310638912704],
            [-15.18324311121807, 7.462691756727784],
            [-15.169191801836163, 7.459349162851552],
            [-15.165826114527954, 7.473359758226698],
            [-15.151987168188349, 7.470089648843793],
            [-15.14861900867856, 7.4840896444711165],
            [-15.14511953406342, 7.483243877183003],
            [-15.141765422808795, 7.497234004134794],
            [-15.131281451723668, 7.494689076982828],
            [-15.127974090736023, 7.508673993833377],
            [-15.114091981260088, 7.505415488358425],
            [-15.109972361940766, 7.522867448082425],
            [-15.096017379582342, 7.519519457381596],
            [-15.090108042684081, 7.54391652904969],
            [-15.076118309254177, 7.540620897547516],
            [-15.07273598877509, 7.554583834609182],
            [-15.04545879671546, 7.547887156121806],
            [-15.04200450562517, 7.561941872008864],
            [-14.973105526396647, 7.545557514420067],
            [-14.958343371123673, 7.542675844887564],
            [-14.88785523637665, 7.526453174371859],
            [-14.777690973487852, 7.501556375897798],
            [-14.780958787554777, 7.487568645934696],
            [-14.766237034669446, 7.484126932269364],
            [-14.76951278835036, 7.470200171084779],
            [-14.741527771129707, 7.463843675788138],
            [-14.744802491509233, 7.449906352138156],
            [-14.730743746873364, 7.446829720528685],
            [-14.733973722011825, 7.43295768284697],
            [-14.71834554472283, 7.429496493430414],
            [-14.738075048449213, 7.345282069922901],
            [-14.6810581393449, 7.333042817471426],
            [-14.610657026087047, 7.31751104969975],
            [-14.552136115895395, 7.304245591850295],
            [-14.554785615729207, 7.3009390895741415],
            [-14.55288548821509, 7.291103777352311],
            [-14.543005649493573, 7.274056914374129],
            [-14.526958605197692, 7.255208337823241],
            [-14.51801957901173, 7.251772132506428],
            [-14.50833176252825, 7.2503851244321815],
            [-14.504694418511933, 7.250699403497314],
            [-14.500736644714115, 7.253486306874826],
            [-14.497158363711963, 7.2592954002407515],
            [-14.488490059362135, 7.265647480529875],
            [-14.481250375570657, 7.267168963713746],
            [-14.476252609564094, 7.265307906615991],
            [-14.47327325733671, 7.260145449531883],
            [-14.471182346221969, 7.2534040552980965],
            [-14.470805816106171, 7.241946932934452],
            [-14.464879915418987, 7.232104156396863],
            [-14.45846693395685, 7.224676839010109],
            [-14.45443246754421, 7.216872859249881],
            [-14.453856411844603, 7.210245828359881],
            [-14.45182771656166, 7.2079582957353034],
            [-14.447522140860599, 7.207675879908011],
            [-14.441320933584922, 7.2195859704169365],
            [-14.432770057438828, 7.2236545136514305],
            [-14.428210970109586, 7.222504554768618],
            [-14.423074444862312, 7.2181824542495],
            [-14.402117009408673, 7.213599591900505],
            [-14.395054791001598, 7.209341780109747],
            [-14.393877921951258, 7.201769916691718],
            [-14.39740249985379, 7.192614615086773],
            [-14.39594146687396, 7.187484198081649],
            [-14.3966581675128, 7.183841030518321],
            [-14.401166282552081, 7.17517824254432],
            [-14.402116553291076, 7.16441239627877],
            [-14.398496290515581, 7.160413815032498],
            [-14.386636210032457, 7.154856664226356],
            [-14.381178224141198, 7.156138735673045],
            [-14.377572500331041, 7.155594641529057],
            [-14.371092571484303, 7.151688896270763],
            [-14.370821294171938, 7.148462389914886],
            [-14.366197201121297, 7.142041731750908],
            [-14.357945223134505, 7.136451816764598],
            [-14.354859582237546, 7.1274028936693625],
            [-14.356114928583613, 7.1163825420535725],
            [-14.360389997085292, 7.109643543245944],
            [-14.366017207510447, 7.102491561244858],
            [-14.372494895945087, 7.099409180607806],
            [-14.37738028015161, 7.087548089459274],
            [-14.387178264552729, 7.081178105393678],
            [-14.391213962104722, 7.075637845428117],
            [-14.391581240023209, 7.070316301165853],
            [-14.396948198668314, 7.064072562691445],
            [-14.404843772772747, 7.059725719420109],
            [-14.415044137343077, 7.059629366156385],
            [-14.422340978576354, 7.060429311854923],
            [-14.427844861044749, 7.058959053136534],
            [-14.430652485511002, 7.056592742006617],
            [-14.435286510788066, 7.025267555580267],
            [-14.435304475756185, 7.020277962385667],
            [-14.425233746023332, 7.012031562402395],
            [-14.41781672215009, 7.002988651244288],
            [-14.414984045309993, 6.995959706279556],
            [-14.414768735251387, 6.987615800065522],
            [-14.417651012042677, 6.979480233503529],
            [-14.422675083630002, 6.975267019112893],
            [-14.425202915377625, 6.971498361905082],
            [-14.425101419114165, 6.967645306216019],
            [-14.422381881656975, 6.958299501089829],
            [-14.42540276977776, 6.952554203006991],
            [-14.44093156573905, 6.954307944535324],
            [-14.448334447645244, 6.950392943683943],
            [-14.454143187611214, 6.948870192475946],
            [-14.451844931131145, 6.941805955564068],
            [-14.445439398289947, 6.9402432401011875],
            [-14.445083224063234, 6.935719097966142],
            [-14.453447610994527, 6.933444338826685],
            [-14.454821268726604, 6.930890945936296],
            [-14.447818041061437, 6.928347565105528],
            [-14.450244191460689, 6.920817237702598],
            [-14.455783019495536, 6.915702376793409],
            [-14.456939073110682, 6.908720188552854],
            [-14.452494738443292, 6.903500879663871],
            [-14.453251616051597, 6.896107838267823],
            [-14.457222580862842, 6.891102811482152],
            [-14.469590866240127, 6.891582442769902],
            [-14.47183861875141, 6.889248907992887],
            [-14.470091615503309, 6.882051153413251],
            [-14.471667631810732, 6.871112469026717],
            [-14.480213052897705, 6.858045705435691],
            [-14.48111297313585, 6.84917988999396],
            [-14.48344567688128, 6.8451700789161185],
            [-14.489179192818964, 6.843454732485688],
            [-14.494366740077997, 6.845401079754853],
            [-14.5030923266674, 6.844928283793428],
            [-14.510313851539037, 6.843155255802358],
            [-14.511314555033712, 6.838144519454535],
            [-14.505798968573167, 6.8327459744870795],
            [-14.506665997161232, 6.82788095067774],
            [-14.509438969290287, 6.823593383923145],
            [-14.517784097875161, 6.826818311412151],
            [-14.524083513541216, 6.820890826745499],
            [-14.525690627765023, 6.817028692629125],
            [-14.520537326927135, 6.809528072602865],
            [-14.520087383245357, 6.80492230012969],
            [-14.522363122310274, 6.799748869925907],
            [-14.526139706217975, 6.794734740257234],
            [-14.542495177517782, 6.722576313899777],
            [-14.542855523767765, 6.721603920382074],
            [-14.554184930495765, 6.670870001531256],
            [-14.571667509156171, 6.59410195632967],
            [-14.584036752385039, 6.5394039989505925],
            [-14.611564209578452, 6.417725016034443],
            [-14.634818466837654, 6.314911899014345],
            [-14.69879092753657, 6.031967765700701],
            [-14.746546691853846, 5.8194535211898435],
            [-14.746697546589303, 5.8190441608463805],
            [-14.787144119729161, 5.641215506329828],
            [-14.803162847191029, 5.57022267013895],
            [-14.830012477310783, 5.451209049419269],
            [-14.841459174727527, 5.400463045737311],
            [-14.845875823439721, 5.379507098231641],
            [-14.888070478072866, 5.192916489985554],
            [-14.89567778499254, 5.16055072046479],
            [-14.898773570926311, 5.145196961047391],
            [-14.92486600987085, 5.029971282100715],
            [-14.935454818899457, 5.032344472556],
            [-14.94141728776955, 5.032748817207591],
            [-14.945889931275431, 5.034684885630962],
            [-14.955367601961225, 5.0369611169227735],
            [-15.048267081621049, 5.058238267867252],
            [-15.062590936688602, 5.0609687439461934],
            [-15.196580276910494, 5.090791398848757],
            [-15.224869741425534, 5.097632381192724],
            [-15.355046397872105, 5.126294422887366],
            [-15.356741049712493, 5.12630940423575],
            [-15.437090736697089, 5.144997482932877],
            [-15.53455249245739, 5.167798136321453],
            [-15.624620419840486, 5.1884126065861915],
            [-15.714691735932275, 5.209011521551251],
            [-15.76747697388009, 5.221181707966136],
            [-15.73488104145012, 5.355996133168544],
            [-15.701008213169018, 5.492767573492788],
            [-15.714873018262033, 5.496132241937555],
            [-15.59253569431714, 6.012666490055059],
            [-15.567505081591122, 6.118604115729218],
            [-15.575996191281346, 6.1205347657977995],
            [-15.546035375894233, 6.24518810587317],
            [-15.533419585429213, 6.297654325875486],
            [-15.47428845007327, 6.542596228053822],
            [-15.477064382257437, 6.543248164755678],
            [-15.45672311653752, 6.628549007341224],
            [-15.416013411829763, 6.7989099567957645],
            [-15.376687942102159, 6.960724775450095],
            [-15.374157931431826, 6.9601049199827605],
            [-15.313195164077284, 7.212629310542016],
            [-15.280478322300054, 7.351597563112631],
            [-15.273873464029968, 7.3800160411041515],
            [-15.277394210734933, 7.380845928857478],
            [-15.266083516154987, 7.4227407176772315]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.62314984914767,
          "lat": 43.193409118726166
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41045"],
        "coty_name": ["Malheur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Malheur County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01135858"
      },
      "bbox": [
        -15.76747697388009, 5.029971282100715, -14.354859582237546,
        7.561941872008864
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.451000445991761, 2.62127782001323],
            [14.49148045446051, 2.6810924707807207],
            [14.52680388741855, 2.6971422904456777],
            [14.581456691997325, 2.7223191148020502],
            [14.615434080976247, 2.7371863353175856],
            [14.646732990353097, 2.7479904575171785],
            [14.659849197614534, 2.77343868619008],
            [14.674547301066793, 2.7951494280633185],
            [14.68209331093412, 2.795299264182511],
            [14.68568862202966, 2.793530807408442],
            [14.699711692173073, 2.789736034086899],
            [14.701551193959288, 2.7882534262941507],
            [14.711588867984958, 2.785831229537421],
            [14.721967316911876, 2.7772138632507732],
            [14.72470831778409, 2.7722609486641576],
            [14.73009639059326, 2.7693788561414436],
            [14.73238515748886, 2.765905045318283],
            [14.743532993648309, 2.761621594124972],
            [14.756182812581432, 2.761593762895245],
            [14.762265142761994, 2.7601525999761933],
            [14.767521126365395, 2.760858772820962],
            [14.77405384110784, 2.7576224015557336],
            [14.78281454286178, 2.745485469036543],
            [14.801545237406026, 2.721274231974655],
            [14.808200482910143, 2.7135553245218365],
            [14.82887457819982, 2.6877201153493706],
            [14.82584691437524, 2.689308591307681],
            [14.824360090327852, 2.685602431774114],
            [14.826107683533609, 2.682800819543208],
            [14.82611173100727, 2.677849764465444],
            [14.830790670434258, 2.674646664447591],
            [14.832109101273065, 2.668822234027972],
            [14.828137910383356, 2.6653786567676776],
            [14.82740953284357, 2.6601905906846266],
            [14.823505653792472, 2.656007019344172],
            [14.822380428299539, 2.652319698084054],
            [14.824651888158664, 2.6479852775877797],
            [14.824166839669001, 2.643944136785732],
            [14.830515251053471, 2.6367324779694243],
            [14.830631032981113, 2.63311745001079],
            [14.836657124894778, 2.6252336675915906],
            [14.843088316710253, 2.6276465682970773],
            [14.84595403118562, 2.618807537617471],
            [14.852889586004075, 2.612128353053765],
            [14.84683826626796, 2.604519401240812],
            [14.840170916946384, 2.602023684689495],
            [14.837216729632585, 2.5994168597671954],
            [14.835157468636979, 2.5924619513693257],
            [14.830880524113772, 2.5843893186036238],
            [14.82431239455955, 2.579840649626928],
            [14.827127965931144, 2.568492697483845],
            [14.847378827352832, 2.469912567503313],
            [14.802818313525426, 2.4611843426147186],
            [14.684705226192923, 2.4373481286593126],
            [14.584892791025185, 2.417462399707703],
            [14.503741401767966, 2.4014036088502153],
            [14.500516176447823, 2.416602993753968],
            [14.491333410274283, 2.454718567157864],
            [14.481071323979972, 2.500183748688497],
            [14.471308897981789, 2.5386389625225902],
            [14.457555485238732, 2.5938920727230133],
            [14.451000445991761, 2.62127782001323]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.21784896792286, "lat": 39.87150657415307 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01213656"
      },
      "bbox": [
        14.451000445991761, 2.4014036088502153, 14.852889586004075,
        2.795299264182511
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.556321019473092, 2.3138068269097474],
            [12.561103789468541, 2.3179250022483946],
            [12.55675068372882, 2.328083371766129],
            [12.554350897526023, 2.3357434397279118],
            [12.55592548289552, 2.3404620393592643],
            [12.560897625585955, 2.345042146280129],
            [12.571072771828426, 2.347497537622409],
            [12.578204763847564, 2.3427348233413645],
            [12.582676965725797, 2.3353737796607748],
            [12.586775264739408, 2.331211030328751],
            [12.59285196192738, 2.3311987494060338],
            [12.601075855157408, 2.3380995607084163],
            [12.6025624372158, 2.3507494394048156],
            [12.605515922457018, 2.355732492589564],
            [12.612553719739228, 2.361959147607282],
            [12.61977728013421, 2.3647231130857964],
            [12.630537273548518, 2.3664895867503333],
            [12.636997263041085, 2.373548089319124],
            [12.638889065935379, 2.3794693750555793],
            [12.636285929080278, 2.3835902935535325],
            [12.626264396326615, 2.389174590528621],
            [12.625013236895851, 2.394394293369198],
            [12.63114306304843, 2.4027421135677667],
            [12.631866643405123, 2.408217725792694],
            [12.62630984840825, 2.412913419136442],
            [12.615848461863052, 2.4139070058770353],
            [12.612719013789448, 2.4189528747663815],
            [12.618382715699816, 2.4236194704182346],
            [12.629235937503147, 2.4235108206786653],
            [12.635265311471896, 2.421499669829244],
            [12.641166723766842, 2.4224835892903074],
            [12.652203771054918, 2.429246032523052],
            [12.655574899269935, 2.433737821191148],
            [12.656490604977298, 2.4425508925601873],
            [12.6456881469274, 2.461302743635117],
            [12.642547313728324, 2.4643321514952943],
            [12.63646360420477, 2.4660882471568852],
            [12.621778924005143, 2.471878384310641],
            [12.623258861352912, 2.4747612786011914],
            [12.629591184444983, 2.474040019762689],
            [12.6676544400424, 2.481192060104651],
            [12.666540159751587, 2.4855178097497],
            [12.671487399347152, 2.486049680500308],
            [12.676770640651213, 2.483153516711092],
            [12.694372613779665, 2.4857593184747],
            [12.719953913031842, 2.4902798726353854],
            [12.725147453219657, 2.487905473963227],
            [12.729593910652307, 2.4843619215788895],
            [12.735083805335032, 2.484861925632677],
            [12.737055829308904, 2.4877756516459906],
            [12.742190273443766, 2.4830574042022415],
            [12.740326234216463, 2.4803238210641383],
            [12.749336574939914, 2.4750991551414354],
            [12.75314113815013, 2.4746286207159103],
            [12.755884172113886, 2.4780282965343976],
            [12.758593839615736, 2.4776837679660564],
            [12.763219718913842, 2.4820358217920666],
            [12.76799214485321, 2.4833993958230867],
            [12.76986054714265, 2.478612290609094],
            [12.779263552807206, 2.4778136274172358],
            [12.784038468507958, 2.474967151287214],
            [12.782892045134902, 2.4708709469732786],
            [12.786794301317629, 2.469383512071087],
            [12.791756429797589, 2.4701040992400776],
            [12.794485455208756, 2.4675467941567724],
            [12.795385645162884, 2.4632631247870793],
            [12.80012349582932, 2.4623960755827476],
            [12.808127985164887, 2.4588999427559965],
            [12.809705014180597, 2.4622816457963475],
            [12.81612339117386, 2.466664474953797],
            [12.81601539818492, 2.4695467628862025],
            [12.8197095287928, 2.470984174252423],
            [12.824484877642472, 2.470354489739532],
            [12.825282923672024, 2.4726985853648102],
            [12.832770025281711, 2.4713419475536202],
            [12.836315454290736, 2.46527571931672],
            [12.842591371203227, 2.4644540338626437],
            [12.840461250135625, 2.472390658790692],
            [12.841015257752767, 2.4754600264269726],
            [12.8458206150917, 2.4807735409999614],
            [12.844478341304935, 2.484930846211255],
            [12.848203063172754, 2.4885887837751843],
            [12.851562550273718, 2.4875136294172155],
            [12.858092750712029, 2.4913360335350947],
            [12.862441506317504, 2.4912271303371227],
            [12.86251845524804, 2.4973205445551945],
            [12.864489928766586, 2.4994566825909863],
            [12.87057602646463, 2.49787302046927],
            [12.87603158251621, 2.502626165090392],
            [12.874312406389176, 2.5092634442789317],
            [12.87824016322244, 2.5179356548212986],
            [12.880644524575658, 2.517937480020031],
            [12.884411515915, 2.5135088454982757],
            [12.889796273223238, 2.522782709972529],
            [12.88952541401555, 2.5246695955272593],
            [12.89393467110797, 2.52821695769312],
            [12.897655435889948, 2.5335640469864273],
            [12.90380168110442, 2.535860748953122],
            [12.909979590297256, 2.5363909323975635],
            [12.913504541225752, 2.539898305528203],
            [12.92962206023106, 2.5427831785584583],
            [12.930323918965799, 2.5400927855744646],
            [12.942000251384071, 2.5338371923068213],
            [12.942949695136098, 2.527388793865912],
            [12.948641733693371, 2.5206716710603754],
            [12.95228485298202, 2.517944698428011],
            [12.964107755126806, 2.514944783506317],
            [12.970960373972671, 2.5096235805308647],
            [12.979182594405717, 2.50869722264184],
            [12.981573653834209, 2.5094974092876234],
            [12.986072465390048, 2.502592328739503],
            [12.989714740575257, 2.4987609780431517],
            [13.007040585191533, 2.4922055466251285],
            [13.011022336203911, 2.491708912402384],
            [13.020972583277139, 2.4874175721251994],
            [13.02530275037499, 2.481610205398227],
            [13.033361230296306, 2.46565151825471],
            [13.035865722838416, 2.459214161381633],
            [13.038790022018446, 2.457755473067628],
            [13.050655769964939, 2.4583612348449386],
            [13.05578631112533, 2.4624033621537675],
            [13.060542597366494, 2.462949404686787],
            [13.072972187229315, 2.4619755123005658],
            [13.069999023762861, 2.45283337050305],
            [13.057891742043417, 2.4214661926206738],
            [13.049953194021398, 2.398063688625205],
            [13.04686621622036, 2.397560470368821],
            [13.047913674593227, 2.3918548897055625],
            [13.041033322437121, 2.3720642059740173],
            [13.03221031258519, 2.3483443962294417],
            [13.028133281060944, 2.347756602492538],
            [13.028784341632734, 2.3442712731341784],
            [13.026003930967907, 2.3380718591446366],
            [13.026037034571583, 2.3349382098992346],
            [13.021221583778766, 2.328978966153215],
            [13.024836989120157, 2.3257175228513263],
            [13.019164783762596, 2.3091955919555947],
            [13.01328111358076, 2.2602748352125666],
            [13.019890969858306, 2.256853746107327],
            [13.032991327325, 2.253201344491804],
            [13.036713585050636, 2.249925560198153],
            [13.043377387476209, 2.2476995493525274],
            [13.04362873637663, 2.239450768469479],
            [13.052396658119804, 2.2398313942598476],
            [13.057969675390327, 2.2341283296852943],
            [13.061692100183434, 2.2206845150462486],
            [13.058960025000141, 2.2147542675577343],
            [13.060384438925894, 2.2092900358965357],
            [13.06365267853178, 2.2039272538336157],
            [13.065958091258846, 2.2026959564293036],
            [13.07210565388524, 2.203782689426799],
            [13.074308572762357, 2.2000753917492832],
            [13.071537229279008, 2.1965127328573435],
            [13.06073464491306, 2.1990077286590424],
            [13.052556282469931, 2.201967400835492],
            [13.052215617856083, 2.1951478115771756],
            [13.050551798261552, 2.1936251447510244],
            [13.043902480287013, 2.19450019116996],
            [13.042418747406712, 2.192395025520092],
            [13.045982682607669, 2.188415036526962],
            [13.05537382097422, 2.1851563784524433],
            [13.057328764601417, 2.1810975381432147],
            [13.052857918438463, 2.173139066929328],
            [13.044264016136577, 2.1679359915154874],
            [13.043973516445215, 2.1644302569437595],
            [13.049494260734857, 2.157592518303713],
            [13.050271079147253, 2.1536327907058967],
            [13.04259553953424, 2.151972041555682],
            [13.03955249549289, 2.1494897559915467],
            [13.039796258986186, 2.143286303082483],
            [13.042892972564985, 2.14239823234897],
            [13.049783394629051, 2.14412521072781],
            [13.053180400256988, 2.14329051878586],
            [13.056564259890694, 2.1381519342226456],
            [13.055304504942592, 2.132145438293504],
            [12.992170407303297, 2.120675400225142],
            [12.93832566183859, 2.1109392178191744],
            [12.891581688321084, 2.1032657174791747],
            [12.776667140409213, 2.082879555602098],
            [12.709738530141058, 2.071309054919308],
            [12.662186184111713, 2.0633576993852127],
            [12.665105141658223, 2.0698217305107183],
            [12.668511496878564, 2.081747851233971],
            [12.667976521495694, 2.087047096795233],
            [12.664418769187012, 2.090942641801388],
            [12.658213505123214, 2.094691056966555],
            [12.65190996357297, 2.094945124275768],
            [12.645591921659268, 2.0975516762790343],
            [12.640831436832562, 2.1046142972240403],
            [12.640970215354093, 2.111496458237635],
            [12.638231282281692, 2.121056558032324],
            [12.641224772562063, 2.1266840956755755],
            [12.650579652183673, 2.1292209956564117],
            [12.6540084001328, 2.13193477335235],
            [12.655432261604858, 2.1367865145742786],
            [12.65330831917875, 2.142354207532289],
            [12.643103594872947, 2.154770552859777],
            [12.639364356652303, 2.1717642911130484],
            [12.63609631079458, 2.17890869695828],
            [12.62642678068548, 2.1808401406163607],
            [12.624453125764502, 2.1856190896549093],
            [12.633023106690809, 2.195654429018908],
            [12.63229471933839, 2.1993432291880737],
            [12.626916320867872, 2.205989303893242],
            [12.62788106261615, 2.212087727680121],
            [12.635211148352345, 2.218073548144914],
            [12.635758927589674, 2.221948401059874],
            [12.634069488992019, 2.2256213308279538],
            [12.629906771275232, 2.230263454039229],
            [12.622702331604593, 2.2412278177226237],
            [12.620365857503442, 2.247392992872005],
            [12.62336684726024, 2.2581352417536853],
            [12.621161585392821, 2.264109818228225],
            [12.613518415940069, 2.2707383244206647],
            [12.60360263082417, 2.2816405861245954],
            [12.594921890298705, 2.287853091361847],
            [12.590392439685981, 2.289471311939623],
            [12.581794720107522, 2.28964463424067],
            [12.57534431067358, 2.286938492459176],
            [12.567481998930253, 2.2813847724709335],
            [12.56424144750834, 2.2805723684294956],
            [12.55568259280182, 2.2846504661909606],
            [12.551984943753205, 2.287983203022667],
            [12.549870482097619, 2.294694026128151],
            [12.548583975322833, 2.302919932388446],
            [12.55097904241923, 2.309708667822338],
            [12.556321019473092, 2.3138068269097474]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.64740242081517,
          "lat": 39.920124996179574
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42051"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01209179"
      },
      "bbox": [
        12.548583975322833, 2.0633576993852127, 13.074308572762357,
        2.5427831785584583
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.751527289447575, 3.9431731089771884],
            [14.753515973140757, 3.9434176748915504],
            [14.794579634406064, 3.933666239046039],
            [14.822065622647235, 3.940912112196193],
            [14.850253467465475, 3.878827475002833],
            [14.851388963823505, 3.8741588971897616],
            [14.856245583625169, 3.8695307861119126],
            [14.856000347189225, 3.8633106119140503],
            [14.85791016782744, 3.858974231780941],
            [14.856781826627827, 3.853616436816846],
            [14.894750756201654, 3.851189412242375],
            [14.904357236311196, 3.8330942626399627],
            [14.906134181846557, 3.822399431933141],
            [14.906714142349546, 3.807251158615572],
            [14.909204915742936, 3.798804701788051],
            [14.941261214461617, 3.7779094734407757],
            [14.955199924866132, 3.7640308621799554],
            [14.955680263433585, 3.757195507088235],
            [14.958955420082615, 3.7538659205901777],
            [14.947729437225812, 3.745413184488991],
            [14.95149263042534, 3.740462900254467],
            [14.955056913415243, 3.7382072735753784],
            [14.957291429894745, 3.7335124673245517],
            [14.95654791944226, 3.7293592157056454],
            [14.952909010674928, 3.7248820158631326],
            [14.956021049297693, 3.722253908591092],
            [14.960537515574561, 3.688940868242772],
            [14.944034271918738, 3.6854909903350395],
            [14.937757547954625, 3.690604578396218],
            [14.933520929390339, 3.700043060736028],
            [14.92911743561376, 3.7046525901527194],
            [14.924386502406838, 3.7152054496145777],
            [14.92508403770528, 3.721199362144501],
            [14.927203119043597, 3.7253704633975273],
            [14.928306237018358, 3.7314750649772077],
            [14.927812924483007, 3.739710401614423],
            [14.922898112845152, 3.7396991324690996],
            [14.916272306525743, 3.7380404490322436],
            [14.901241658300338, 3.736106385478997],
            [14.894468932793453, 3.736491059116679],
            [14.882218667720412, 3.745113605049968],
            [14.872281183095971, 3.7513653153533566],
            [14.867635015747178, 3.753040487183734],
            [14.857734822227949, 3.751762093833911],
            [14.853078506124984, 3.747945544427707],
            [14.84525866044589, 3.7528622323802963],
            [14.83585549559834, 3.7483646977603047],
            [14.830642913774929, 3.746737710552309],
            [14.827406132343466, 3.7438027273563854],
            [14.794117558542531, 3.7284353613728336],
            [14.788100275499003, 3.7272385519077784],
            [14.771182152247354, 3.7189446839941183],
            [14.765137171402491, 3.717385845791231],
            [14.753117831484346, 3.711960840449921],
            [14.752128619822454, 3.7154121824131296],
            [14.754664343566578, 3.717904851392039],
            [14.752309819549106, 3.7210050638922567],
            [14.756075455300579, 3.7252242883314977],
            [14.754004778935851, 3.731226564876992],
            [14.754847991260423, 3.7332098577524326],
            [14.755939071329959, 3.767504235682255],
            [14.753194899799606, 3.7751797819058224],
            [14.753410675883734, 3.7816307066708563],
            [14.754849621394289, 3.7864144365689527],
            [14.75971801357178, 3.7948110083020326],
            [14.757109255273893, 3.7980553295444324],
            [14.758803914125142, 3.807743185701213],
            [14.758737923809502, 3.8198453703226702],
            [14.762989708523412, 3.8360054083514106],
            [14.766218180752496, 3.863027627305442],
            [14.764262849444911, 3.8757130387110608],
            [14.7621458436904, 3.8817454811639984],
            [14.759913810493495, 3.8993498893815155],
            [14.756178782503655, 3.9090026097274553],
            [14.755785340483738, 3.9195302379087695],
            [14.75658128778733, 3.9252855701410336],
            [14.751527289447575, 3.9431731089771884]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.6586448614253, "lat": 41.02792008084827 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42093"],
        "coty_name": ["Montour"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montour County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01213681"
      },
      "bbox": [
        14.751527289447575, 3.6854909903350395, 14.960537515574561,
        3.9434176748915504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.205244459147213, 5.314872800383828],
            [18.254834554452586, 5.3289179957286],
            [18.308821558021215, 5.344507765974074],
            [18.378658084249956, 5.365141890711178],
            [18.397217709795225, 5.370370757428471],
            [18.44298216008805, 5.384383246082122],
            [18.444003993661152, 5.392265740838849],
            [18.448609634791143, 5.393945176283117],
            [18.447798825305313, 5.397937644197756],
            [18.445034594550744, 5.402063501296596],
            [18.448431565756007, 5.406345463883717],
            [18.44738189366642, 5.408724013840133],
            [18.448645008047446, 5.41436274991686],
            [18.456451743257517, 5.417660531906452],
            [18.458563699722514, 5.421904712057051],
            [18.464430565095178, 5.4217620000539055],
            [18.466137125235594, 5.425947459672398],
            [18.47364370015984, 5.4297588190136725],
            [18.478653037477155, 5.426635778888258],
            [18.482731680293835, 5.427438361967303],
            [18.486158484328893, 5.422787151117157],
            [18.48746253021918, 5.423225201826675],
            [18.49015950439023, 5.421019313851401],
            [18.49301704435741, 5.411653623263255],
            [18.496707497674052, 5.410787608718271],
            [18.494677330290383, 5.404730848072739],
            [18.4974820920052, 5.3935079071589715],
            [18.502180808007772, 5.388857815803923],
            [18.507816772552584, 5.386847082782786],
            [18.51727293194926, 5.387595007549558],
            [18.512517552931218, 5.3811746185057086],
            [18.51523685271764, 5.3747206328409405],
            [18.517226501020552, 5.363827282927199],
            [18.519728711143234, 5.362645808192378],
            [18.519112846886113, 5.3588000497676],
            [18.515124154272918, 5.354615080862322],
            [18.51550266709804, 5.347714990426514],
            [18.51738843542341, 5.341945275848571],
            [18.515391631334417, 5.335265020420704],
            [18.512252137628213, 5.335133063381028],
            [18.505456660031246, 5.338099946435495],
            [18.50183025641673, 5.349797098628018],
            [18.49655374048212, 5.347690792232877],
            [18.482083440676814, 5.344708710431392],
            [18.470092064224, 5.344403587625535],
            [18.464834191835184, 5.342489511605903],
            [18.463511485961565, 5.345855040525668],
            [18.460337837134897, 5.346181047016319],
            [18.458480283010488, 5.340831255875105],
            [18.462481835096593, 5.332971942161927],
            [18.465641030836093, 5.330096720912689],
            [18.464682653348785, 5.326646547235355],
            [18.466498136321828, 5.322033483965869],
            [18.47475274588644, 5.324157094681563],
            [18.481218784375905, 5.330022801857767],
            [18.48725539821186, 5.326448040081299],
            [18.49427754721087, 5.3260878060034935],
            [18.49649649276732, 5.3169928368390895],
            [18.489972530082646, 5.316427230590081],
            [18.48572817603242, 5.314205104196942],
            [18.482957759723167, 5.31003125823423],
            [18.479999744225566, 5.310034915246919],
            [18.47445402026199, 5.3028624942679],
            [18.47548302888433, 5.300494332334258],
            [18.471933186551098, 5.2927682801104385],
            [18.473397910722507, 5.289674079833625],
            [18.472313931925235, 5.285318840439044],
            [18.46456589127368, 5.292092322805453],
            [18.456456793178408, 5.283870149546055],
            [18.458099965108673, 5.281187903619288],
            [18.45358823095491, 5.274942387982484],
            [18.45150671491919, 5.273752120652463],
            [18.449456225793003, 5.26539755242064],
            [18.452102979460086, 5.262902888366812],
            [18.45550646862727, 5.253022234345973],
            [18.429652875268836, 5.246261376967576],
            [18.412330957593866, 5.241073594557636],
            [18.341860537412508, 5.221576655379185],
            [18.33510387348938, 5.217468522457142],
            [18.258269255123267, 5.196792142091402],
            [18.23806994653754, 5.19031487769427],
            [18.224750879380668, 5.248183266326044],
            [18.205244459147213, 5.314872800383828]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.59312970706814, "lat": 41.67216984173794 },
        "year": "2023",
        "ste_code": ["44"],
        "ste_name": ["Rhode Island"],
        "coty_code": ["44003"],
        "coty_name": ["Kent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kent County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01219778"
      },
      "bbox": [
        18.205244459147213, 5.19031487769427, 18.519728711143234,
        5.4297588190136725
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.460008926562905, -3.5725237695109016],
            [12.4657350465792, -3.5741806076813787],
            [12.471918279054965, -3.572021693956087],
            [12.476787703615594, -3.5720183015049267],
            [12.487589658531821, -3.5747728985902145],
            [12.491648788181154, -3.5765980254093264],
            [12.498078852738436, -3.583548755232622],
            [12.501167464473793, -3.5840496033316422],
            [12.508313957607527, -3.5910792620712786],
            [12.5114574503296, -3.5955802178727754],
            [12.518893062694948, -3.6005207025152948],
            [12.523078673156123, -3.598857197253767],
            [12.53862223598789, -3.59464728736301],
            [12.542735412959408, -3.596719138208837],
            [12.54623410981904, -3.602508278975826],
            [12.554990920456625, -3.6036532425332446],
            [12.561336764501755, -3.60829752841747],
            [12.569893550869352, -3.612402380546318],
            [12.57658728504595, -3.616896351657425],
            [12.58250581977246, -3.619471176437097],
            [12.579627954866435, -3.6076116611779674],
            [12.583769731368168, -3.6044245014048575],
            [12.587037421815378, -3.5985774053976236],
            [12.584839453225156, -3.5898882522169893],
            [12.5820704993918, -3.589218218404624],
            [12.580720465969923, -3.582944289398944],
            [12.57425229320759, -3.578836818227433],
            [12.57299456152512, -3.574400338789886],
            [12.619410938755179, -3.5717636608259897],
            [12.622847176199189, -3.570874139611748],
            [12.64316331576811, -3.5698897671540135],
            [12.644708343156562, -3.5658464761728195],
            [12.648369358507713, -3.5635200217868834],
            [12.651631198595558, -3.5574720852197044],
            [12.660562681909564, -3.5560710781088822],
            [12.661335042018239, -3.5483077929083695],
            [12.669004884876667, -3.55141613149461],
            [12.671095662629888, -3.5453291157533857],
            [12.67631009015988, -3.543855135226623],
            [12.682661330669585, -3.540436720028487],
            [12.686116838807989, -3.5440896056195887],
            [12.706924462130885, -3.5336972688492563],
            [12.73018321299376, -3.5225561584037117],
            [12.745670125568093, -3.5147843031194395],
            [12.85310083079948, -3.4805423102432806],
            [12.845709612089486, -3.5121330198622176],
            [12.842181976390124, -3.5261714890847164],
            [12.83243447198134, -3.569438770662214],
            [12.832532229300782, -3.572537256993513],
            [12.8476369525205, -3.5778920494199973],
            [12.907897068162928, -3.6202749279617947],
            [12.971622441200427, -3.6649789108860937],
            [12.972768549364742, -3.6610444871419556],
            [12.977536106327335, -3.658144458606524],
            [12.977854103925724, -3.655721301807251],
            [12.982445404960512, -3.6509881040697367],
            [12.998513387791618, -3.647753491796],
            [13.003901533440313, -3.6438155396875977],
            [13.009988692300666, -3.643544559068585],
            [13.017955548118408, -3.6402473036168437],
            [13.017907404131773, -3.6372983432590797],
            [13.026495219681028, -3.630587653593805],
            [13.034903923581528, -3.6254740309987876],
            [13.050329849377016, -3.6209860197408474],
            [13.051186993871394, -3.623741265627001],
            [13.04964027569457, -3.628874183916189],
            [13.045328855201307, -3.632333826653811],
            [13.038818657506212, -3.6332919823806225],
            [13.036529432627656, -3.640171414185346],
            [13.039610414502716, -3.644393623239785],
            [13.045477925036803, -3.644363512943857],
            [13.046704312578658, -3.639660140409868],
            [13.05101384294212, -3.641063235905908],
            [13.047644186113057, -3.64845318679664],
            [13.043268654670829, -3.654097126700557],
            [13.053394910981343, -3.6574925293859053],
            [13.05775985220349, -3.6564888442059726],
            [13.061810818344854, -3.6704344444022516],
            [13.06576185371012, -3.6728928374311405],
            [13.067064512720856, -3.676294404937665],
            [13.072473041005786, -3.6787349170622132],
            [13.072966602085009, -3.682175644295114],
            [13.070574591144235, -3.6842041135485193],
            [13.068377529456823, -3.6896892321198744],
            [13.072153623245963, -3.6948493197140895],
            [13.06373326582789, -3.6947477714896597],
            [13.061784906129919, -3.703613045788395],
            [13.059349061748376, -3.706949052909909],
            [13.054941850229975, -3.709608553076692],
            [13.058514011184748, -3.717363393864959],
            [13.057082299215786, -3.718304561080477],
            [13.0499855167763, -3.714407853807838],
            [13.048654556905724, -3.717720389113197],
            [13.050671810175535, -3.7209383254745743],
            [13.046456558383117, -3.7236769007404305],
            [13.049179100920666, -3.7321557988431073],
            [13.04570546684009, -3.7343038918731435],
            [13.048955137133635, -3.739685688454849],
            [13.05885855529374, -3.745768179670111],
            [13.058155309510743, -3.7552716907355363],
            [13.06187072419147, -3.756540207666675],
            [13.065881774156518, -3.7522565564204573],
            [13.072456493233727, -3.7540398548444625],
            [13.07333520437068, -3.7570036473926582],
            [13.06890377918192, -3.759564297457523],
            [13.06725829460795, -3.7684042165501843],
            [13.065008322773144, -3.77225529365637],
            [13.065499531708012, -3.779310702991463],
            [13.07263171033452, -3.7775279207066372],
            [13.071255257356942, -3.7810941933624647],
            [13.073233307019615, -3.784010172206614],
            [13.066190409051924, -3.7887516054183963],
            [13.069746873696086, -3.790717015343407],
            [13.065636122298981, -3.7977950310515913],
            [13.067357890489681, -3.7995009698962834],
            [13.065369245071961, -3.804228820589526],
            [13.075082718490425, -3.8147029422506056],
            [13.074871187694168, -3.820697761850183],
            [13.079249657496991, -3.8245965648143216],
            [13.082781801301614, -3.8236117619488392],
            [13.084774036326193, -3.828153640823427],
            [13.082169675773422, -3.83068724540965],
            [13.076692787035922, -3.831457989831899],
            [13.083426106901658, -3.840606342297752],
            [13.080451488245082, -3.8426256339053495],
            [13.081745314201685, -3.847237340262603],
            [13.08068905825668, -3.8531910448831597],
            [13.083520684181103, -3.8584117878868565],
            [13.079767384516298, -3.859116598581159],
            [13.077827393541916, -3.8634489965800647],
            [13.07728720444053, -3.87054650631382],
            [13.082517591568367, -3.875376724171627],
            [13.083698004595567, -3.8783445767461804],
            [13.09024388637791, -3.8796443169173815],
            [13.093144072218557, -3.8836181286814573],
            [13.090599209075522, -3.8880144849822718],
            [13.094103885414018, -3.8916626775377186],
            [13.094524190261627, -3.8975036924564583],
            [13.097279741872418, -3.9022238707454147],
            [13.10551847156135, -3.908339495848585],
            [13.108670857151637, -3.916221673104392],
            [13.111409218232362, -3.9163647782846285],
            [13.113010534728044, -3.927776529566217],
            [13.117448057356437, -3.929056807627836],
            [13.114392326805461, -3.9331589193726666],
            [13.1176681014574, -3.9381030249806765],
            [13.112115911438933, -3.9448592884133333],
            [13.11406449653854, -3.9495982145739683],
            [13.110991901891355, -3.9656735965782164],
            [13.10695970723239, -3.9668742535576493],
            [13.10467988055538, -3.9697014192226234],
            [13.104995118521078, -3.9750676943020644],
            [13.102449065197424, -3.9730285511078223],
            [13.094595916942827, -3.9763227354623356],
            [13.08775269112694, -3.9734846264810995],
            [13.08591297151029, -3.968977244532146],
            [13.08109118046808, -3.9677921729986814],
            [13.078665211047824, -3.964577256940692],
            [13.072484989049787, -3.9618653943835422],
            [13.071899905563013, -3.9575590748243044],
            [13.074890946510857, -3.952740845921076],
            [13.071924341391181, -3.949626799336525],
            [13.068448744935973, -3.950722930298467],
            [13.063300801536844, -3.9562769927039163],
            [13.059125180306463, -3.958865824373628],
            [13.058501760449822, -3.9622880504798395],
            [13.055009705830777, -3.9630918905029118],
            [13.048762310508222, -3.971218406540931],
            [13.045810714453715, -3.9704294451643505],
            [13.037912586084774, -3.971968934305065],
            [13.032836841915653, -3.969928336396152],
            [13.032571553793339, -3.963159615100872],
            [13.026745734081878, -3.95955631330271],
            [13.024358043769837, -3.9606513529192706],
            [13.02519391112078, -3.969287384229173],
            [13.02275224611617, -3.970505052457684],
            [13.017646482209553, -3.964699739206378],
            [13.013465034328014, -3.9653149028592893],
            [13.014083574430998, -3.9709024347497515],
            [13.00961004729415, -3.9734997322022494],
            [13.007285145579804, -3.977296843781401],
            [13.004377258530011, -3.9752482512559912],
            [13.00705769661057, -3.9682960508748804],
            [13.002622123288647, -3.9656055726814095],
            [13.001078818557835, -3.960748671780515],
            [12.99556129021724, -3.959654750052999],
            [12.993473435781379, -3.965330118218548],
            [12.996180731253414, -3.9665278646065163],
            [12.995868815421167, -3.971010431287852],
            [12.99064127594823, -3.971635417932426],
            [12.988230208723943, -3.9636131844281595],
            [12.986276204041785, -3.962997057510931],
            [12.982048417700259, -3.97098383111918],
            [12.980006482211953, -3.966688667774226],
            [12.976805894270138, -3.9666591257887776],
            [12.972268492863812, -3.977758909106363],
            [12.96789078890321, -3.9791828206205913],
            [12.968165184909834, -3.971106439794625],
            [12.959603121773725, -3.971848110549757],
            [12.95249475545194, -3.96932678001002],
            [12.94725260569167, -3.969065687176281],
            [12.944984319812853, -3.96508926119008],
            [12.939555468607672, -3.9633227813725695],
            [12.935564678597295, -3.970766494396598],
            [12.93031496553612, -3.969757386477686],
            [12.933390535807234, -3.960753063071744],
            [12.931255468174594, -3.958761107500949],
            [12.927624613762703, -3.9613311818987125],
            [12.92436562618176, -3.961244815907543],
            [12.919756841286866, -3.9534367658506544],
            [12.913127252645978, -3.952379441317204],
            [12.901949978852823, -3.9484882512326602],
            [12.895308327153778, -3.948387195430612],
            [12.893924313242927, -3.943879059409674],
            [12.890544246553425, -3.939305860545769],
            [12.885896554969282, -3.9368979079532673],
            [12.881802936065696, -3.9374189050149426],
            [12.871790397473028, -3.9448172666211008],
            [12.867648704397457, -3.946658077102981],
            [12.853361949547313, -3.9462415381859377],
            [12.851566360984135, -3.944171113043886],
            [12.850869634905049, -3.9329036654757386],
            [12.853537605370187, -3.927426268981339],
            [12.851935461529544, -3.924571731742436],
            [12.84561326946423, -3.923630050675918],
            [12.843757344979037, -3.9258092077093836],
            [12.843727878584502, -3.9315053634432244],
            [12.83417663606493, -3.9340691537760075],
            [12.830267155976516, -3.9325602707017087],
            [12.826592737262766, -3.9276785798832727],
            [12.819956138393099, -3.921570014023801],
            [12.806542193349106, -3.916629362228222],
            [12.800939779887154, -3.9183908890980375],
            [12.796816430297653, -3.917491570691062],
            [12.790314109729339, -3.918312544733501],
            [12.786519979576198, -3.9148822571269712],
            [12.788513955149995, -3.9097098416940197],
            [12.776972654133548, -3.9083495702844817],
            [12.774714297654993, -3.9062106452609466],
            [12.777173717436503, -3.901851024803495],
            [12.777494297614018, -3.8948265413925407],
            [12.773835886416498, -3.8906942616468383],
            [12.763678036523201, -3.890636309359942],
            [12.758468215354776, -3.8893447549361935],
            [12.755012816598594, -3.8838747911618707],
            [12.755254941450534, -3.8785176526655976],
            [12.756951805574857, -3.8749459293592987],
            [12.76190504482278, -3.872544990220444],
            [12.76278697928295, -3.8663288284717847],
            [12.75766153774886, -3.8630240091478982],
            [12.750625579179037, -3.8630334669958666],
            [12.745092407448285, -3.861059694949064],
            [12.744188375785294, -3.856706374342932],
            [12.751417183616887, -3.8507757223639922],
            [12.752463370818232, -3.8458260114090557],
            [12.751835214388318, -3.840836426694006],
            [12.731549765943623, -3.811749767843124],
            [12.72847539776945, -3.806654614434762],
            [12.721172256475986, -3.799087616914745],
            [12.718867842225213, -3.7878644739378324],
            [12.710161943226279, -3.7762523752453228],
            [12.698939223758344, -3.769622089888494],
            [12.693844683882753, -3.772901839543325],
            [12.687833449984431, -3.768519600772026],
            [12.682538973989283, -3.767277055144384],
            [12.676850806839022, -3.7674165233203185],
            [12.672595458210159, -3.764660644406598],
            [12.670323574756063, -3.7598612930068116],
            [12.666684600326347, -3.7601888615879133],
            [12.661661879715576, -3.7512973973612223],
            [12.653100777395574, -3.7400427006393753],
            [12.644177289754062, -3.73073041155839],
            [12.630809245590692, -3.7200073266466678],
            [12.618303242845572, -3.712544610040941],
            [12.61119421498731, -3.70919288693604],
            [12.600541807699477, -3.705208889872058],
            [12.600046712018568, -3.7023315640971783],
            [12.593802603823178, -3.703221759995856],
            [12.578716977347801, -3.6997715487545304],
            [12.57195797707554, -3.6989817921324253],
            [12.557528941695677, -3.698485640363746],
            [12.540706116716958, -3.699668720689324],
            [12.529114146033564, -3.701752182165957],
            [12.520592964282214, -3.7053987928901657],
            [12.515384503033879, -3.708522036645798],
            [12.502131864334945, -3.6900805707398994],
            [12.499994847572127, -3.690792931892905],
            [12.47931229872475, -3.669559465120513],
            [12.476000417465354, -3.665025031320205],
            [12.477467408284632, -3.656324780194282],
            [12.483840772660647, -3.647262168426174],
            [12.470149691105478, -3.6244432927758616],
            [12.466632707384127, -3.6262714076345985],
            [12.464360772094901, -3.623518892940837],
            [12.457481165518004, -3.622837763671344],
            [12.453478163601986, -3.618813737364116],
            [12.448620513935708, -3.616914123386008],
            [12.442305048677314, -3.6103179825143306],
            [12.452256941908407, -3.5860689803320316],
            [12.460008926562905, -3.5725237695109016]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.9032221098834, "lat": 34.02192796355193 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45079"],
        "coty_name": ["Richland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richland County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01249299"
      },
      "bbox": [
        12.442305048677314, -3.9791828206205913, 13.1176681014574,
        -3.4805423102432806
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.6677404638797215, 7.338632826211404],
            [-2.619921350309769, 7.336409433125914],
            [-2.6058733419559137, 7.335577486081824],
            [-2.5250208955589146, 7.331720335334095],
            [-2.5115669884852534, 7.330797127883779],
            [-2.4392916708021604, 7.327182705223109],
            [-2.3684898993563324, 7.323795668340434],
            [-2.2966832588547907, 7.320438393301646],
            [-2.2370614263411186, 7.317845374857636],
            [-2.208287560025362, 7.316312177015984],
            [-2.1468812302931313, 7.313524315062611],
            [-2.12439406536905, 7.312619777790694],
            [-2.1310251949447867, 7.140665286212871],
            [-2.1331391196443508, 7.085809304436458],
            [-2.132992576377515, 7.0837450872260295],
            [-2.1375491113699336, 6.968342642822882],
            [-2.1623544591723864, 6.969005895625721],
            [-2.1664276159534306, 6.969413037959519],
            [-2.2098217471967287, 6.971124510864067],
            [-2.2902071830921202, 6.974734788036189],
            [-2.3833020017897386, 6.978868693600531],
            [-2.490870694355456, 6.98404058438389],
            [-2.562458014921096, 6.987322449191818],
            [-2.618438621851362, 6.989958689831825],
            [-2.635801509050796, 6.990939108927378],
            [-2.633092842787463, 6.999396397380283],
            [-2.6301236791381366, 7.011850267644779],
            [-2.6300387971485994, 7.020449923304582],
            [-2.6271979702894197, 7.020334544814711],
            [-2.62461119662977, 7.0299833112312875],
            [-2.6217683382300594, 7.036516299124511],
            [-2.6167159150608694, 7.044873028037112],
            [-2.606539901403679, 7.05239256984941],
            [-2.597948645004714, 7.054673077703608],
            [-2.5796394767485267, 7.053608176736934],
            [-2.5678077265847246, 7.055718306961918],
            [-2.5575550347063394, 7.061936249059863],
            [-2.5537174707177153, 7.065289014101349],
            [-2.546745735446948, 7.081032146255124],
            [-2.545755162982941, 7.092433004743282],
            [-2.546035479882162, 7.0990774887207175],
            [-2.551819223779205, 7.115853350971529],
            [-2.5636922985308006, 7.1416836173725855],
            [-2.572561108664993, 7.163807583345371],
            [-2.5734068308379903, 7.167842694882679],
            [-2.5820201459680323, 7.194172181257756],
            [-2.587500000477496, 7.208258998490581],
            [-2.59076800598506, 7.2222451176417515],
            [-2.591214431081528, 7.2309153325866085],
            [-2.589108088763392, 7.250228450009118],
            [-2.5930582851650623, 7.261285906596844],
            [-2.601908173809942, 7.267545740641487],
            [-2.6135910159515, 7.276974615048475],
            [-2.6225767870976355, 7.290612949967748],
            [-2.643184512701732, 7.313625241212146],
            [-2.6492715775646887, 7.316095067362438],
            [-2.6609487410618513, 7.325073259485896],
            [-2.6677404638797215, 7.338632826211404]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.05162786494404,
          "lat": 45.77118040354253
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46021"],
        "coty_name": ["Campbell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Campbell County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01266974"
      },
      "bbox": [
        -2.6677404638797215, 6.968342642822882, -2.12439406536905,
        7.338632826211404
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.753131431183279, 5.953401277298949],
            [-2.698843475236126, 5.951220842411714],
            [-2.606555722728187, 5.9473367723846255],
            [-2.514268820193995, 5.9434314243838955],
            [-2.4415312127144873, 5.940160067557484],
            [-2.4070923572225724, 5.938709623616264],
            [-2.401117278929512, 5.938158773525013],
            [-2.312710536736087, 5.934925972112197],
            [-2.2475357726160667, 5.932106764331774],
            [-2.1492956445851856, 5.928155182909662],
            [-2.1402544333977596, 5.927785805930516],
            [-2.141723602406868, 5.892060144793701],
            [-2.146745070596812, 5.755246998781398],
            [-2.1470842695747563, 5.75343372639678],
            [-2.150693143791747, 5.663457406552313],
            [-2.1511227859709483, 5.6604812326707785],
            [-2.152914034217982, 5.598202417529082],
            [-2.167685498335482, 5.595716553527951],
            [-2.180493237124278, 5.585125125779966],
            [-2.1872447610433006, 5.575228102238111],
            [-2.1878892316853795, 5.566643474024392],
            [-2.182684119101707, 5.559039530371324],
            [-2.1776932615063473, 5.554050361516953],
            [-2.1706839395252735, 5.551723695059176],
            [-2.1508484419391425, 5.549289709813878],
            [-2.141702090364687, 5.5457958962504375],
            [-2.134735357093958, 5.54214643733418],
            [-2.126304622544082, 5.536217511804098],
            [-2.1175514121281114, 5.528275593236905],
            [-2.11259618766879, 5.518489074500962],
            [-2.1102553647670628, 5.502905291896245],
            [-2.1112276625177238, 5.497449766376765],
            [-2.115179347620469, 5.489369905641968],
            [-2.1206593802950584, 5.483223995071415],
            [-2.1260631679727022, 5.480031208037434],
            [-2.133266615170104, 5.477995762172731],
            [-2.1412766847766007, 5.479429413982585],
            [-2.150976315222542, 5.482374090483499],
            [-2.158633348904983, 5.486060316945781],
            [-2.1648850095337218, 5.490472921045493],
            [-2.175220097050291, 5.495349645682009],
            [-2.189426877179862, 5.500332297415873],
            [-2.204567286650063, 5.507735259715764],
            [-2.218291169283, 5.51610132546222],
            [-2.2312471060449606, 5.519534228135401],
            [-2.2490082256471555, 5.5177331441543975],
            [-2.256649539019739, 5.516525028460786],
            [-2.2795128200311114, 5.51123400142772],
            [-2.2972565397083016, 5.510073268598247],
            [-2.3023559787414443, 5.511000432263104],
            [-2.3142658047870053, 5.5167048957072575],
            [-2.31953502813485, 5.521753424329604],
            [-2.324212691054156, 5.52871620746487],
            [-2.3316988298232086, 5.542460752898493],
            [-2.335830431374824, 5.555851900993336],
            [-2.345257226956781, 5.571306415188929],
            [-2.347990998348474, 5.576749672301607],
            [-2.349943695750672, 5.583743651092494],
            [-2.349770288492461, 5.588884979135436],
            [-2.34705335367255, 5.594516870311796],
            [-2.3258009268258135, 5.613148080335595],
            [-2.3168022476490555, 5.624283839806504],
            [-2.3150969949798736, 5.628964183223988],
            [-2.3192645443111464, 5.6404960915111815],
            [-2.3225195586293097, 5.645641482528307],
            [-2.334768355806629, 5.653726339902856],
            [-2.349836017283618, 5.6548994331502636],
            [-2.3594363881408187, 5.653209570226137],
            [-2.3630100722740157, 5.653545581035028],
            [-2.3798601451123944, 5.658069244648383],
            [-2.387095576555623, 5.661682523443694],
            [-2.4017260991407037, 5.671422614977362],
            [-2.419181911201641, 5.677720776079484],
            [-2.4325221700821658, 5.6861249444618265],
            [-2.450104148996852, 5.701111277040478],
            [-2.459181121774682, 5.704840801922493],
            [-2.4659300662423846, 5.705086935781423],
            [-2.478306742600661, 5.71062031247475],
            [-2.495792134522614, 5.716647540857267],
            [-2.5066830847125185, 5.719721092982159],
            [-2.5255336199893805, 5.718534500697974],
            [-2.5313706524647697, 5.719370465225143],
            [-2.5441495612376728, 5.72285282832041],
            [-2.554219188257225, 5.722735169074471],
            [-2.5613358372997994, 5.724192868544688],
            [-2.584045046423205, 5.730351471915692],
            [-2.5919700169773203, 5.734660554046522],
            [-2.6040518741671907, 5.738320722698405],
            [-2.6203725743767405, 5.741472799169966],
            [-2.629006464068801, 5.744044271591149],
            [-2.63844637074976, 5.74811996824979],
            [-2.645579428187834, 5.752543000099045],
            [-2.6475521333438117, 5.7568724048483615],
            [-2.649491746496335, 5.772762717809478],
            [-2.6523889322303806, 5.781654756463721],
            [-2.652305148321944, 5.784420494282274],
            [-2.6549202681139095, 5.805642297193881],
            [-2.655878047099203, 5.824116138119325],
            [-2.65859016962878, 5.841752567945517],
            [-2.6635323283047367, 5.849722342728137],
            [-2.6729023736575113, 5.859560007968442],
            [-2.679418948184505, 5.861542591003045],
            [-2.7095253762365594, 5.865332445602193],
            [-2.7205741218733595, 5.864957762518291],
            [-2.739028826036009, 5.859759291774309],
            [-2.7613950223331387, 5.8521398454346665],
            [-2.7648928760689415, 5.85132335486457],
            [-2.7757027264281913, 5.852738562686691],
            [-2.7826457401789293, 5.856120586700376],
            [-2.7912679156969373, 5.86342319793821],
            [-2.795281695243846, 5.869973333712587],
            [-2.7952160016115877, 5.882601248695759],
            [-2.790827099971874, 5.899584941146243],
            [-2.7851894966956348, 5.908084784346815],
            [-2.7741151406890294, 5.91602372577118],
            [-2.758416832900207, 5.921401464476087],
            [-2.7541969944557656, 5.925250326659196],
            [-2.7477093905352543, 5.934529261620426],
            [-2.746778477049627, 5.940151085705019],
            [-2.753131431183279, 5.953401277298949]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.99602246267261, "lat": 44.38904190590386 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46065"],
        "coty_name": ["Hughes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hughes County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01265774"
      },
      "bbox": [
        -2.795281695243846, 5.477995762172731, -2.1102553647670628,
        5.953401277298949
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.175676035793648, 6.174057995842557],
            [-3.1681943785275872, 6.172050873904216],
            [-3.159057089639008, 6.167863957692108],
            [-3.1502454572532903, 6.165409554939924],
            [-3.138206352447277, 6.163381021390791],
            [-3.128435106185928, 6.166798148043251],
            [-3.123602047197635, 6.166667463244952],
            [-3.1185077304933744, 6.164045305093869],
            [-3.1053052379475714, 6.150663210306163],
            [-3.0960390123960186, 6.1469040077934745],
            [-3.0843125203903714, 6.1508763770735255],
            [-3.0794440583540315, 6.160311898282361],
            [-3.076169754972526, 6.160838846324041],
            [-3.0709153163620604, 6.153376704272019],
            [-3.0659246651543715, 6.15990771020099],
            [-3.0645387640717225, 6.166896023576588],
            [-3.061637937086586, 6.171914938911608],
            [-3.0552295081555103, 6.171954431508883],
            [-3.0466608278790885, 6.174478867434021],
            [-3.048534719104589, 6.181420694365163],
            [-3.046134599974402, 6.185559185815695],
            [-3.035434107497611, 6.182013616201687],
            [-3.029221890721994, 6.1858737975866935],
            [-3.0190352861456455, 6.188255052977423],
            [-3.014882933656691, 6.194338843009211],
            [-3.0145508489002792, 6.2015804517783755],
            [-3.0117400763739672, 6.201800992995151],
            [-3.0033471079845877, 6.195688458162802],
            [-3.001944152479604, 6.189604493175621],
            [-2.9984052134042734, 6.187299882968267],
            [-2.9879608471584422, 6.18999466544327],
            [-2.982799959047416, 6.192967929942967],
            [-2.977711949645906, 6.193900710214054],
            [-2.973507763912359, 6.196992080749218],
            [-2.9697667483578853, 6.19333740466365],
            [-2.966454302458658, 6.19289609320231],
            [-2.961310938027104, 6.197907270582269],
            [-2.95747096021486, 6.1987960088135265],
            [-2.9517325300518777, 6.197066925157542],
            [-2.947713321567687, 6.194338951770772],
            [-2.9446820668238503, 6.182869506371091],
            [-2.9420539866410382, 6.182256437922902],
            [-2.9360815708496752, 6.185053792518812],
            [-2.9317973838676723, 6.178617213071769],
            [-2.9236817909400497, 6.181987358205853],
            [-2.920205531447916, 6.185737871499537],
            [-2.9163658995442145, 6.184179606315698],
            [-2.9157337192006407, 6.180852861426514],
            [-2.9195898482948532, 6.174838083971509],
            [-2.9152224941877685, 6.171576887017804],
            [-2.904621657937757, 6.173408117210959],
            [-2.9006602498220424, 6.17807307747008],
            [-2.902718164677146, 6.185452861763114],
            [-2.8970806620287055, 6.18832202378975],
            [-2.89277667846069, 6.188052499710995],
            [-2.8908739573003484, 6.184518477509574],
            [-2.893532739172686, 6.180962327937779],
            [-2.891362182889872, 6.175931875544418],
            [-2.8868033131274227, 6.176372191017921],
            [-2.882270855045232, 6.178555430867449],
            [-2.877751301265819, 6.18243198611704],
            [-2.8657997401696482, 6.17502323528213],
            [-2.8597216331934034, 6.170303301561341],
            [-2.8555680480755496, 6.165308220109632],
            [-2.8524905699140892, 6.157704057557102],
            [-2.8411479815470093, 6.153601557644809],
            [-2.8308943929985655, 6.152842343548456],
            [-2.8225073341902696, 6.150073808290017],
            [-2.8174408955551087, 6.145853415800466],
            [-2.8108096991316365, 6.124911262426732],
            [-2.807362672582571, 6.115364154077802],
            [-2.8067332972305516, 6.110949616096025],
            [-2.8080465760256605, 6.096438559709066],
            [-2.814818544234949, 6.073347077926103],
            [-2.8178653376551854, 6.060420286072916],
            [-2.8252905073452452, 6.040826121165981],
            [-2.8317886098048195, 6.031373559789395],
            [-2.83289595310622, 6.027217246155182],
            [-2.8351183541743863, 6.011670569013073],
            [-2.835198852425484, 6.007778344046351],
            [-2.831998787212067, 5.993418883663418],
            [-2.826990888096152, 5.98504148788469],
            [-2.8192271075945015, 5.975807185605779],
            [-2.811798129137513, 5.970210945981617],
            [-2.7999357030219953, 5.964773367899992],
            [-2.79157253596418, 5.963913458483192],
            [-2.7762847956377343, 5.960956870946275],
            [-2.7672970416031446, 5.960287747941543],
            [-2.760352818838732, 5.958915385713355],
            [-2.7550691279447457, 5.956215111021542],
            [-2.753131431183279, 5.953401277298949],
            [-2.746778477049627, 5.940151085705019],
            [-2.7477093905352543, 5.934529261620426],
            [-2.7541969944557656, 5.925250326659196],
            [-2.758416832900207, 5.921401464476087],
            [-2.7741151406890294, 5.91602372577118],
            [-2.7851894966956348, 5.908084784346815],
            [-2.790827099971874, 5.899584941146243],
            [-2.7952160016115877, 5.882601248695759],
            [-2.795281695243846, 5.869973333712587],
            [-2.7912679156969373, 5.86342319793821],
            [-2.7826457401789293, 5.856120586700376],
            [-2.7757027264281913, 5.852738562686691],
            [-2.7648928760689415, 5.85132335486457],
            [-2.7613950223331387, 5.8521398454346665],
            [-2.739028826036009, 5.859759291774309],
            [-2.7205741218733595, 5.864957762518291],
            [-2.7095253762365594, 5.865332445602193],
            [-2.679418948184505, 5.861542591003045],
            [-2.6729023736575113, 5.859560007968442],
            [-2.6635323283047367, 5.849722342728137],
            [-2.65859016962878, 5.841752567945517],
            [-2.655878047099203, 5.824116138119325],
            [-2.6549202681139095, 5.805642297193881],
            [-2.652305148321944, 5.784420494282274],
            [-2.6523889322303806, 5.781654756463721],
            [-2.649491746496335, 5.772762717809478],
            [-2.6475521333438117, 5.7568724048483615],
            [-2.645579428187834, 5.752543000099045],
            [-2.63844637074976, 5.74811996824979],
            [-2.629006464068801, 5.744044271591149],
            [-2.6203725743767405, 5.741472799169966],
            [-2.6040518741671907, 5.738320722698405],
            [-2.5919700169773203, 5.734660554046522],
            [-2.584045046423205, 5.730351471915692],
            [-2.5613358372997994, 5.724192868544688],
            [-2.554219188257225, 5.722735169074471],
            [-2.5441495612376728, 5.72285282832041],
            [-2.5313706524647697, 5.719370465225143],
            [-2.5255336199893805, 5.718534500697974],
            [-2.5066830847125185, 5.719721092982159],
            [-2.495792134522614, 5.716647540857267],
            [-2.478306742600661, 5.71062031247475],
            [-2.4659300662423846, 5.705086935781423],
            [-2.459181121774682, 5.704840801922493],
            [-2.450104148996852, 5.701111277040478],
            [-2.4325221700821658, 5.6861249444618265],
            [-2.419181911201641, 5.677720776079484],
            [-2.4017260991407037, 5.671422614977362],
            [-2.387095576555623, 5.661682523443694],
            [-2.3798601451123944, 5.658069244648383],
            [-2.3630100722740157, 5.653545581035028],
            [-2.3594363881408187, 5.653209570226137],
            [-2.349836017283618, 5.6548994331502636],
            [-2.334768355806629, 5.653726339902856],
            [-2.3225195586293097, 5.645641482528307],
            [-2.3192645443111464, 5.6404960915111815],
            [-2.3150969949798736, 5.628964183223988],
            [-2.3168022476490555, 5.624283839806504],
            [-2.3258009268258135, 5.613148080335595],
            [-2.34705335367255, 5.594516870311796],
            [-2.349770288492461, 5.588884979135436],
            [-2.349943695750672, 5.583743651092494],
            [-2.3553101359258464, 5.583750441454275],
            [-2.44113471631752, 5.5872407339347845],
            [-2.57018803998687, 5.592673125958507],
            [-2.656288159022503, 5.596499903686352],
            [-2.6574543988809385, 5.570637820707096],
            [-2.6599283672641074, 5.570580153377606],
            [-2.7174349731321086, 5.573329270227958],
            [-2.8385277321249807, 5.578858531500519],
            [-2.9251030122103865, 5.583022028093012],
            [-2.9362056087648036, 5.583962616849078],
            [-2.9532056111598326, 5.584116516437082],
            [-2.9709709475087736, 5.585373986456141],
            [-3.03796642161758, 5.588386690927072],
            [-3.040689007178816, 5.588717538012426],
            [-3.142820185998504, 5.594371331868021],
            [-3.2283948714155595, 5.598552901013288],
            [-3.225468797641076, 5.648638559946283],
            [-3.2252787179191924, 5.65658942587817],
            [-3.220812431501682, 5.73682290650848],
            [-3.2188922834904603, 5.773002767182674],
            [-3.210618566627483, 5.772589307287515],
            [-3.204714377961451, 5.880355174734504],
            [-3.1912942607042343, 6.11785079269571],
            [-3.1790005527523073, 6.117203298556808],
            [-3.176168710465398, 6.169244113648456],
            [-3.175676035793648, 6.174057995842557]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.73592155363781,
          "lat": 44.41233588336203
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46117"],
        "coty_name": ["Stanley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stanley County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01266998"
      },
      "bbox": [
        -3.2283948714155595, 5.570580153377606, -2.3150969949798736,
        6.201800992995151
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.12150581044112073, 4.416015677132851],
            [-0.0350689840001727, 4.41533806230482],
            [-0.028112385245684914, 4.41548879475773],
            [0.007558266898039478, 4.415016042895637],
            [0.06497597305073112, 4.414779872697358],
            [0.13381448177678243, 4.414036917331762],
            [0.13303291860006958, 4.405693800841975],
            [0.12888106543217703, 4.394666079266455],
            [0.12352466287555831, 4.3925136805449085],
            [0.11993049773857553, 4.39422570832666],
            [0.11720708646083546, 4.393069325144115],
            [0.11003838038329893, 4.3862030372236145],
            [0.10736660087267032, 4.381495659867291],
            [0.09908261576573457, 4.37937621731446],
            [0.09290621733941473, 4.38069731450372],
            [0.08692196056087122, 4.372860301492812],
            [0.08885453153309139, 4.370162841107799],
            [0.09364566341846492, 4.368040625284296],
            [0.09073363500392388, 4.359172963464748],
            [0.09223282690600787, 4.355419022210487],
            [0.09786734138558606, 4.350480024262504],
            [0.10078849977572604, 4.3498710848804],
            [0.10423300630205884, 4.345178657954783],
            [0.10620450266432004, 4.340311429407075],
            [0.1042209505986674, 4.332412315920673],
            [0.10167144158533185, 4.328739559153674],
            [0.09474099634533248, 4.3271476592537095],
            [0.09067745891502645, 4.322060413298019],
            [0.09111978567752936, 4.316555874953153],
            [0.08524814431446144, 4.308270586650706],
            [0.08836796347894957, 4.3034832895239905],
            [0.09547097986957409, 4.301902878173349],
            [0.0976485748543677, 4.2987264484337455],
            [0.09965677943070013, 4.289889899199391],
            [0.09632114213177931, 4.28516196141891],
            [0.09291126792804533, 4.275644718943677],
            [0.08896108906160016, 4.274178650264921],
            [0.08522304536228578, 4.270279589014349],
            [0.08780173704115982, 4.265930955419736],
            [0.08116529368344823, 4.266040445906532],
            [0.06977366794042913, 4.255056786065052],
            [0.07241038934757564, 4.239290325460863],
            [0.07296780965721467, 4.23614244885348],
            [0.06838101238214203, 4.2342436319268275],
            [0.07087210722918977, 4.230445066878944],
            [0.07334649052687406, 4.231370946309647],
            [0.07851640649727083, 4.228382109735249],
            [0.0801850129987064, 4.224165099584539],
            [0.07930999384403484, 4.220993263961764],
            [0.0702896414472816, 4.2201310147967686],
            [0.07149165222663861, 4.216546267301282],
            [0.07187581125549211, 4.208884539056559],
            [0.06562847938127031, 4.204896632410999],
            [0.06322524204271282, 4.200714421035218],
            [0.0626154769198954, 4.193585670307532],
            [0.06541101230403006, 4.18765299286622],
            [0.0691272713820659, 4.18804207057376],
            [0.06613691651099805, 4.180308632008661],
            [0.060094794700819985, 4.1778806604862835],
            [0.059758043419632347, 4.1740173072186195],
            [0.06282211859860372, 4.171047122999989],
            [0.061843988156243264, 4.166940594866083],
            [0.05828901933815735, 4.167030473871536],
            [0.055090101669486344, 4.169755898917415],
            [0.05136764307520181, 4.160810046979953],
            [0.047217570069639746, 4.167577518296035],
            [0.04108585931853484, 4.168555573044259],
            [0.03915730833704922, 4.164117025088523],
            [0.04235965482467037, 4.158066045696677],
            [0.037529699959203806, 4.149401232977966],
            [0.03273014638008614, 4.145804979904873],
            [0.02910456996218444, 4.1455055066763515],
            [0.029326313812123764, 4.140870906955168],
            [0.032782141850277446, 4.13940563762381],
            [0.03158052975375089, 4.131522013958231],
            [0.030088552165233793, 4.1284450551323015],
            [0.027012630740041205, 4.128236556180907],
            [0.028208597343165893, 4.122278202239168],
            [0.023538481897769283, 4.122768159932069],
            [0.024141727012016556, 4.118168948428194],
            [0.02266406821985878, 4.113429335366115],
            [0.011777372946622039, 4.114502640314651],
            [0.009446779679382974, 4.107351617358037],
            [0.006646246062313908, 4.102924878017866],
            [0.0004206529391344419, 4.101233183116609],
            [0.002161620514179973, 4.097815982326257],
            [0.00022059140888398723, 4.093700761462283],
            [0.005490274305628685, 4.0868233051630725],
            [0.009385086475030458, 4.088845806468519],
            [0.01080517058398021, 4.083904530699574],
            [0.0035312480600822884, 4.080785320599556],
            [0.003086125942397956, 4.074885758568835],
            [0.000059486853631150533, 4.070634966404761],
            [0.0034334110069094204, 4.06025520385706],
            [0.0011403261149643001, 4.054519093856282],
            [0.007586379508055435, 4.055790181559556],
            [0.007648117033457723, 4.045874567061779],
            [0.006145902579184779, 4.040577469030618],
            [0.003137871342754322, 4.036132298660473],
            [0.005950050391632278, 4.0342630883272],
            [0.008407042054674577, 4.037230692304205],
            [0.011723177656874745, 4.029857610562416],
            [0.014534158369594024, 4.029193076901378],
            [0.018417562023653945, 4.032504152404643],
            [0.021388194337308174, 4.032139963692714],
            [0.021395306716971037, 4.024332705639741],
            [0.025221667156952208, 4.028105233585258],
            [0.0288201666608397, 4.0240410266684075],
            [0.029118759363104225, 4.01946856468882],
            [0.03507494164878445, 4.020122140189783],
            [0.03599125250446114, 4.013048740361551],
            [0.0434040887031401, 4.012736609590768],
            [0.04196295333852764, 4.007411790448736],
            [0.04584469771714592, 4.007561014762066],
            [0.04242235370538675, 4.000646122559306],
            [0.045547857044451974, 4.000632297770563],
            [0.049654313123649416, 4.005792842296342],
            [0.051141682573614025, 4.001429988015109],
            [0.05717293585897894, 3.9946014043003615],
            [0.05453365949247658, 3.9925923584016956],
            [0.05565022552255148, 3.9873443177824495],
            [0.06408034877524399, 3.9912039615910198],
            [0.0677816312263309, 3.9900656660456004],
            [0.07058706307561922, 3.985084281880725],
            [0.07053297710052989, 3.9760658311664363],
            [0.0735722365501175, 3.9731327765884794],
            [0.07888644735943724, 3.9707664087325942],
            [0.0806246103291585, 3.9640805991001278],
            [0.08619387580551764, 3.9599074762642315],
            [0.08595887701828865, 3.9518038678864422],
            [0.08256365164256388, 3.9481151739923055],
            [0.07746440700325997, 3.9479214082056515],
            [0.07494546098959476, 3.944623709288484],
            [0.07616961922120395, 3.9398826675442318],
            [0.07925210425931833, 3.9387412541351794],
            [0.08375064919240946, 3.9446514251701665],
            [0.08560204939510736, 3.945375170977412],
            [0.09112167463907855, 3.9421079904051557],
            [0.09460124503723571, 3.9343305317112076],
            [0.09781391825061399, 3.9233761054795475],
            [0.09858644072615685, 3.917668771335769],
            [0.10352034973892364, 3.9170296960367144],
            [0.1011289574675756, 3.9119300397127454],
            [0.10152428539853796, 3.9080436971376975],
            [0.10765359223413422, 3.9052100657191167],
            [0.1081300881473582, 3.902659564198421],
            [0.09866844200947351, 3.8901779830612093],
            [0.10101301650728259, 3.8855439802490617],
            [0.10904874682475309, 3.88594943014296],
            [0.11461718415781542, 3.8851120894956157],
            [0.11395946565173565, 3.8645484869305],
            [0.11239136739025228, 3.858531867188088],
            [0.11229070127950955, 3.8531102388498826],
            [0.10429347450541648, 3.8492710969170556],
            [0.10268980444463195, 3.8462178101944167],
            [0.10477470273475151, 3.841346045782578],
            [0.10952265192264352, 3.8392170983672265],
            [0.11260889149758875, 3.8399977842639506],
            [0.11699849844499963, 3.83234326963228],
            [0.1136101511218108, 3.8231308127572907],
            [0.11540916061460674, 3.818376992439604],
            [0.1196631651357091, 3.8201383417598778],
            [0.12413298562154124, 3.819180536844126],
            [0.12983015676877158, 3.8212618552824025],
            [0.1373248837675174, 3.819284287914901],
            [0.12686986859489582, 3.815609383539929],
            [0.11524952431595231, 3.808752401422278],
            [0.10504074000538462, 3.8088804380727357],
            [0.09639028943447953, 3.8115735670941624],
            [0.09108730922984844, 3.815560296227759],
            [0.085776964127211, 3.823199686202415],
            [0.08232402298620295, 3.833753283267842],
            [0.079088136831482, 3.8392667838685544],
            [0.07437394601389288, 3.8442493704710956],
            [0.0696887293486129, 3.8472489049534384],
            [0.06182601773427439, 3.849719720852641],
            [0.055245560096835025, 3.8495902539279765],
            [0.04781833738120521, 3.8471208138278143],
            [0.044426154803187276, 3.844992277587753],
            [0.035707055553366396, 3.8371094585083902],
            [0.030730746389881308, 3.8347060776966746],
            [0.021680343360863132, 3.8338088703800954],
            [0.0158153245591771, 3.835481054888788],
            [0.005266350378499618, 3.843068676713385],
            [0.0012834820780124288, 3.8538823264088857],
            [-0.00001915825696584888, 3.861587434641478],
            [0.00005211894756717401, 3.8698475484454544],
            [-0.0013687803948235, 3.877316180379063],
            [-0.003318364172046383, 3.881666685525558],
            [-0.010652011873767705, 3.8906691043539214],
            [-0.018385593281414314, 3.896293392708504],
            [-0.03093514282135101, 3.901575972770721],
            [-0.03805640471128307, 3.9079961116883077],
            [-0.05302088996408388, 3.9296590733132715],
            [-0.05630487961392704, 3.938432494562798],
            [-0.0564671038655565, 3.947716540860573],
            [-0.0534662609177821, 3.9556667843364846],
            [-0.04260103138535288, 3.9723737693762806],
            [-0.04001573154981379, 3.974403755318826],
            [-0.03843834860817618, 3.98011590371818],
            [-0.03891619484078713, 3.983474936786826],
            [-0.04615926545321859, 3.9895671711118688],
            [-0.06830737426618885, 3.997500779412322],
            [-0.07373937618571245, 3.997825549702294],
            [-0.08214288886502406, 3.996946421266265],
            [-0.08529284402302256, 3.9951012388007383],
            [-0.09468190897719815, 3.992792029588207],
            [-0.10499460150540484, 3.9938872683938236],
            [-0.11597258073092938, 3.997020124545856],
            [-0.12160316411746233, 4.000815148229875],
            [-0.12245318008117316, 4.003310516979624],
            [-0.12090010002053926, 4.0154512278017656],
            [-0.12184361986345534, 4.02993995886377],
            [-0.12513660979383304, 4.0353672820740485],
            [-0.12508047364876004, 4.066866139993591],
            [-0.1241942809882835, 4.154400903846152],
            [-0.12269915515893284, 4.256462641775715],
            [-0.12214767962454225, 4.328712598463952],
            [-0.12150581044112073, 4.416015677132851]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.65605170897278,
          "lat": 42.832477769387985
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46127"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01265763"
      },
      "bbox": [
        -0.12513660979383304, 3.808752401422278, 0.1373248837675174,
        4.416015677132851
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.986103345182454, -2.6728952263751107],
            [7.986969496542084, -2.656520299000898],
            [7.9968540340836824, -2.6546918484011295],
            [8.01583982302907, -2.6540735455551236],
            [8.031448750491975, -2.654777692224276],
            [8.041923347805328, -2.6538480627563],
            [8.06207950290917, -2.653488844766151],
            [8.061958513073014, -2.6568833405687857],
            [8.067105476165766, -2.658439505269721],
            [8.075708334681755, -2.658436603895173],
            [8.081338600971257, -2.660782351307608],
            [8.085108757565129, -2.66052997298607],
            [8.08496475921992, -2.668456067803638],
            [8.083034137856863, -2.671520991988929],
            [8.091779818802564, -2.672827180177832],
            [8.091655025348771, -2.6771328163650123],
            [8.09543193135097, -2.6773179712525734],
            [8.098386547902246, -2.680724642758091],
            [8.100407175443134, -2.686254848344078],
            [8.10539509762891, -2.686406358197743],
            [8.105393497817772, -2.6892419300569217],
            [8.110512572668917, -2.690325119875842],
            [8.123288757925003, -2.6908051629861385],
            [8.123242294696821, -2.6993303373116855],
            [8.132855817886254, -2.699523849215944],
            [8.132932922225127, -2.7069374651523157],
            [8.137914976574754, -2.707141276847237],
            [8.137979563619236, -2.699644474633134],
            [8.14601853340181, -2.6998641384186373],
            [8.146065576605409, -2.6971799009591857],
            [8.15122791333517, -2.6976178935576676],
            [8.155656413409936, -2.695472334861933],
            [8.157318239712465, -2.692439705588116],
            [8.16824265579649, -2.691437750342739],
            [8.167334133888883, -2.7006664708955705],
            [8.171780073478214, -2.7008188958129207],
            [8.169392093530478, -2.712977888012228],
            [8.173292123602327, -2.7177320166792462],
            [8.180221289867651, -2.7180240085874794],
            [8.182538553097329, -2.7214628402003758],
            [8.1881874195056, -2.7161973981926697],
            [8.188584869801852, -2.7127268841634136],
            [8.197648501649077, -2.7116187502102647],
            [8.19987868123512, -2.7082610648695407],
            [8.20517638092202, -2.7069007662585887],
            [8.202616027525728, -2.7029826256982403],
            [8.20266627107782, -2.698550233411063],
            [8.199369449110069, -2.695187956111033],
            [8.200406536332327, -2.6906918558761026],
            [8.203267874107771, -2.691764072157029],
            [8.208341324759546, -2.688554908149318],
            [8.211076098893658, -2.6844179564941975],
            [8.213935025370992, -2.6859986249682453],
            [8.219822746273021, -2.6855983694168044],
            [8.220690420070506, -2.6824624928303837],
            [8.217511924939974, -2.6804394010231802],
            [8.218322574334865, -2.675371134973291],
            [8.222869834403472, -2.6766905257712117],
            [8.226582428316895, -2.670703496504196],
            [8.231532436209584, -2.6723369799344563],
            [8.233517419504143, -2.676278603468905],
            [8.238057907031221, -2.671422371709834],
            [8.243291686016699, -2.6709359277878577],
            [8.246745020510696, -2.6721355889468534],
            [8.252140759582833, -2.670803188056549],
            [8.257352808927145, -2.6723312799324797],
            [8.2607946637373, -2.675846733450602],
            [8.25926871195866, -2.6804022207587996],
            [8.256575440036483, -2.6834274721327707],
            [8.261012652032171, -2.6859799104600888],
            [8.267109211224563, -2.6837754396863187],
            [8.27279606676499, -2.6871081610140037],
            [8.271767981039021, -2.6823064238744765],
            [8.277066043743133, -2.681395731293392],
            [8.278238996171682, -2.6840345321245667],
            [8.283787576686713, -2.6868112248825144],
            [8.28731729837178, -2.6864075022176777],
            [8.28948885735217, -2.68908450045191],
            [8.294472403147013, -2.6904695381891077],
            [8.297426542213941, -2.696221176738364],
            [8.307439152412602, -2.695199816322585],
            [8.310749083635823, -2.699851510465267],
            [8.306481865295407, -2.7028175974918436],
            [8.309200449804742, -2.7066496445411525],
            [8.309550351977, -2.715281827642668],
            [8.311063715552846, -2.720531647687172],
            [8.31574014834828, -2.7519376499803503],
            [8.319301269229193, -2.793024740146679],
            [8.32124854601678, -2.8093722220965187],
            [8.327283331378368, -2.820893757476676],
            [8.323472569245624, -2.8229677086116336],
            [8.323264902217455, -2.861081909308879],
            [8.326039710272301, -2.868661322091424],
            [8.332511198970057, -2.871819310456936],
            [8.332318281072116, -2.8784042990406222],
            [8.325164566524865, -2.8784900812091996],
            [8.325160325455599, -2.9019776693071395],
            [8.32572083980987, -2.914891407187051],
            [8.320138618851797, -2.916200452360556],
            [8.303480150524763, -2.9200359820639985],
            [8.296225909342756, -2.92393631423108],
            [8.29271836481889, -2.939717792441861],
            [8.279513203709307, -2.9477089228094715],
            [8.276145040082568, -2.951292799273991],
            [8.26599465437208, -2.9576961399097947],
            [8.261283528727443, -2.9648604277031185],
            [8.26658500730941, -2.966649353461543],
            [8.266449349583379, -2.969296288582854],
            [8.260801328636147, -2.9704795494483953],
            [8.25932892625709, -2.9679964674256216],
            [8.253247065374177, -2.97438615609008],
            [8.242764522818272, -2.975239619489303],
            [8.240043838875605, -2.9860610838370953],
            [8.232146564496407, -2.9817641775675523],
            [8.231840733230143, -2.9852190207237626],
            [8.237144199375717, -2.986386981359958],
            [8.235423475032762, -2.990207258700322],
            [8.220340463771356, -2.9896792975734163],
            [8.217437577567168, -2.992302416307889],
            [8.21408774396235, -2.991325206946024],
            [8.21204079697908, -2.9951778342220305],
            [8.204923779585366, -2.994668484882624],
            [8.204431493047169, -3.0123646664350443],
            [8.201074971751018, -3.0187721724184238],
            [8.197240309176642, -3.0235387635787365],
            [8.193356067685905, -3.022173096975705],
            [8.183695003093165, -3.0211153682333842],
            [8.179484603845975, -3.02345231635442],
            [8.174827024063463, -3.0199695198906515],
            [8.166441460793779, -3.017702916567503],
            [8.165821284381135, -3.0145920566198714],
            [8.159538779193705, -3.008537999438071],
            [8.151609814417371, -3.0072841165562756],
            [8.152076698935137, -3.00258267508283],
            [8.148137015605545, -3.0015160853387157],
            [8.146447535624427, -2.9941989965886693],
            [8.142530255451637, -2.9868228095621254],
            [8.136534428878528, -2.9858363589611066],
            [8.131041703721916, -2.9885869364583217],
            [8.124574504970393, -2.9890541723780024],
            [8.118925515239301, -2.992649701263488],
            [8.115505243571743, -2.992894430046206],
            [8.110774119591982, -2.99590141371166],
            [8.105997226740596, -2.9963682674569845],
            [8.10568843092052, -2.9995823192562603],
            [8.100162151129217, -2.99595422456511],
            [8.09857037847137, -2.992142049052017],
            [8.095149626980863, -2.98886148678409],
            [8.092177249781551, -2.9888620970625226],
            [8.088219319716583, -2.992822313134494],
            [8.086175629902447, -2.9906445056637114],
            [8.07986024699514, -2.9877446319663967],
            [8.062255441245302, -2.9842789965961236],
            [8.053578325764912, -2.99171455716541],
            [8.05008663725147, -2.991579748451793],
            [8.047310533210906, -2.9927852085032463],
            [8.043540691492613, -2.9899876728532937],
            [8.034827365757904, -2.991222466437926],
            [8.031306237952641, -2.9861178161462414],
            [8.031079515428292, -2.982708159808981],
            [8.027899489082104, -2.9808599620764746],
            [8.026086596505314, -2.97721824492015],
            [8.028035264457039, -2.9724778806696928],
            [8.020444263454221, -2.969361319694839],
            [7.998217387715376, -2.929450828900395],
            [7.995849689780912, -2.92573134750907],
            [7.994085429325248, -2.904937480744049],
            [7.987906164646589, -2.9053260752606653],
            [7.988202807307666, -2.8866615744166246],
            [7.985507810475248, -2.869573875626363],
            [7.986157763041507, -2.786099742576683],
            [7.995390270043006, -2.7856876242206474],
            [7.996820954183612, -2.7824546324115706],
            [7.9940500951668705, -2.7767965403942756],
            [7.988996608783065, -2.777498505365366],
            [7.987469624306164, -2.780709454452993],
            [7.983252281738525, -2.7823433149648418],
            [7.976903500981303, -2.779139471905257],
            [7.9784990252467916, -2.7724342444815786],
            [7.985654884388614, -2.7729243326058723],
            [7.986853175274161, -2.760438744335755],
            [7.986925548615944, -2.7190080425924665],
            [7.987203490270493, -2.6824798768485367],
            [7.986103345182454, -2.6728952263751107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.4589438400422, "lat": 35.51387458722676 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47003"],
        "coty_name": ["Bedford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bedford County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01639723"
      },
      "bbox": [
        7.976903500981303, -3.0235387635787365, 8.332511198970057,
        -2.653488844766151
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [7.519819142565028, -2.1067439502090872],
              [7.526334139009933, -2.104398198040146],
              [7.522479690683009, -2.102063180090473],
              [7.519819142565028, -2.1067439502090872]
            ]
          ],
          [
            [
              [7.528250865608987, -1.9372612529643256],
              [7.549833754797045, -1.950630951274075],
              [7.607006304690474, -1.985476960435777],
              [7.625551324283095, -1.9920013185621581],
              [7.644726967197552, -2.01784064800659],
              [7.643221970291099, -2.0121233071757065],
              [7.646009715108091, -2.0116119672369175],
              [7.65035698354594, -2.0151992805991314],
              [7.6547710554020965, -2.015381063536065],
              [7.65482491535525, -2.008474637361173],
              [7.658736171140602, -2.007403825773583],
              [7.6611913224901675, -2.00408094327956],
              [7.665892195933245, -2.0038647871764588],
              [7.671274106367112, -2.0008399568936537],
              [7.677449181078435, -2.001361999243391],
              [7.680192466264585, -1.999502660919434],
              [7.680037143664592, -1.9929401754776392],
              [7.687965037561127, -1.9960666029801484],
              [7.694157062766546, -1.9908331537339445],
              [7.699627985810968, -1.9948402743519562],
              [7.702678380675662, -1.998023097062104],
              [7.698713390938057, -1.9995372217955014],
              [7.698861381828829, -2.0068261129003875],
              [7.702134553205588, -2.005187816327326],
              [7.7067503424252735, -2.010781462559745],
              [7.704058438432142, -2.0140191950792103],
              [7.704360258451972, -2.016812752431013],
              [7.698621358722621, -2.047556020292809],
              [7.697168093997935, -2.053087529559866],
              [7.681751372451559, -2.098148455446336],
              [7.67456120298681, -2.105492042038353],
              [7.663766455858789, -2.1327535882010986],
              [7.6584701977735, -2.1580708626082807],
              [7.662134515085092, -2.166257803571785],
              [7.660299411020774, -2.1739595070126776],
              [7.6568228747237495, -2.2564099798848134],
              [7.627833779625661, -2.2938000304590505],
              [7.630511751568108, -2.3462137074374136],
              [7.627295128031177, -2.3419065825942735],
              [7.62006356786438, -2.3438977931453624],
              [7.609757292113733, -2.3459591588648716],
              [7.595352143015502, -2.3480246356306775],
              [7.563899493151305, -2.3483198120168316],
              [7.549151930979505, -2.3480759018353417],
              [7.516903409060639, -2.349360875673185],
              [7.518388873333719, -2.3312027318203175],
              [7.522457146969127, -2.3274140318136114],
              [7.518798040799703, -2.3178377391293874],
              [7.521533824634757, -2.3164649979161007],
              [7.519117489720192, -2.288689060238769],
              [7.520353876510237, -2.242802107293263],
              [7.514885282807286, -2.237349064635908],
              [7.515390077505851, -2.2317774108432067],
              [7.5222139177387755, -2.2247783454239394],
              [7.5265941333205255, -2.2234299642599056],
              [7.531049471297019, -2.219251092355094],
              [7.528464140324524, -2.213698977937533],
              [7.52270818577992, -2.20564753189242],
              [7.512634445034755, -2.204667364158317],
              [7.511627202217716, -2.2009431496237792],
              [7.512730023723126, -2.1963569450792506],
              [7.504457934298753, -2.187886079474813],
              [7.498777804942684, -2.1889095058139567],
              [7.497597295430338, -2.1835652149567872],
              [7.501262601427626, -2.1725210349275144],
              [7.50360475340116, -2.169755457015343],
              [7.509177915680591, -2.171009653649278],
              [7.513077623323362, -2.167021871576541],
              [7.513568247718242, -2.1614925501750224],
              [7.508035433203148, -2.1541404576381074],
              [7.507549790420577, -2.150816249681559],
              [7.501996129404604, -2.1510048325227387],
              [7.496078398571975, -2.156463244650736],
              [7.489520393457302, -2.153793256592131],
              [7.489738819311985, -2.150067297490438],
              [7.497470518557988, -2.140783579385933],
              [7.4978737954896095, -2.138376538543208],
              [7.51694229818923, -2.1246323858713088],
              [7.517803007437494, -2.1213253814355193],
              [7.514553470783683, -2.1164615549305186],
              [7.515771072914671, -2.113060477899965],
              [7.505513021724872, -2.1118138787917005],
              [7.505723603348512, -2.1053083548619593],
              [7.510351387280818, -2.1059926709526917],
              [7.514741395141858, -2.104893502289638],
              [7.515875841505044, -2.1004677335211848],
              [7.518818306484637, -2.0962217385566566],
              [7.516474227403305, -2.0904598771436422],
              [7.513434580468926, -2.0883564277134217],
              [7.504635572301029, -2.086711497846138],
              [7.49636704119824, -2.083422585485505],
              [7.484823389901085, -2.0844733589496918],
              [7.4764962332862535, -2.083368028661894],
              [7.4694737446941435, -2.0852602240963436],
              [7.464865483501613, -2.0845828907331407],
              [7.458445829599105, -2.079953717593315],
              [7.452575126430598, -2.0736351295172963],
              [7.443692970273491, -2.078959021678817],
              [7.436920453975925, -2.07996299395349],
              [7.424838137847003, -2.083336738651582],
              [7.408850445581538, -2.083624093625316],
              [7.410525726532229, -2.0622550986573303],
              [7.411683182763669, -2.0563752796193464],
              [7.410177431512016, -2.052238598443176],
              [7.4133261253369085, -2.048905801137981],
              [7.416843328237038, -2.0510622141104253],
              [7.421544322092022, -2.0476327730579116],
              [7.424212498059762, -2.0494071046423694],
              [7.429014225969403, -2.042117099866618],
              [7.429970954310081, -2.0295474114452974],
              [7.432675401189592, -2.024711549402213],
              [7.4535010005000615, -2.0062067791355696],
              [7.458737218807191, -2.0040359720371685],
              [7.464971107702325, -1.98975779084301],
              [7.4687534714070765, -1.987043104332349],
              [7.475152540903773, -1.9906194449476622],
              [7.486050218598416, -1.9906978000218383],
              [7.483122592925244, -1.984709330522032],
              [7.485520799819444, -1.977362214019759],
              [7.484305107545179, -1.9732399393654392],
              [7.490507889876187, -1.9689998005577027],
              [7.497494663194455, -1.9746879544973102],
              [7.498657448418052, -1.9827484617425521],
              [7.502287463439743, -1.980122140337551],
              [7.507673961808122, -1.9785172434754736],
              [7.50898126890115, -1.9721848845929557],
              [7.505700280836418, -1.9682312680294087],
              [7.506415741582867, -1.9572372453834537],
              [7.5055930559353925, -1.9500172905250925],
              [7.522633735660363, -1.9420764888693676],
              [7.526443945528484, -1.9371760929665172],
              [7.528250865608987, -1.9372612529643256]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.08682276633476, "lat": 36.26110174436072 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47021"],
        "coty_name": ["Cheatham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cheatham County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01639731"
      },
      "bbox": [
        7.408850445581538, -2.349360875673185, 7.7067503424252735,
        -1.9371760929665172
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.7554952046045, -1.780193727200703],
            [6.7758985800443305, -1.7786222622566568],
            [6.802086579418662, -1.777391786471079],
            [6.91371834299114, -1.7799971818146827],
            [6.9316456992703595, -1.779864704971663],
            [6.931398758644581, -1.8107298053150933],
            [7.017015505374185, -1.8003862042529593],
            [7.0569819178649835, -1.7959651085987056],
            [7.098892873600873, -1.7913057669239805],
            [7.11928932182015, -1.8859512753168708],
            [7.147659774214775, -2.0018729154956816],
            [7.1489296891819505, -2.008770192093886],
            [7.16163619411292, -2.059616920406707],
            [7.1438035202211125, -2.060950315695944],
            [7.063740370020211, -2.0676457039494953],
            [7.058744494056262, -2.075873041366093],
            [7.0480229572873645, -2.0857359689232777],
            [7.033517758769015, -2.0958793382930443],
            [7.024040872317428, -2.101124108141786],
            [7.011925488547041, -2.106697343882706],
            [6.994891539487619, -2.11203730951677],
            [6.982675674684134, -2.1146921079480885],
            [6.963180693835199, -2.116144279280273],
            [6.950964764496989, -2.116253575466627],
            [6.925685334421942, -2.1135206371977024],
            [6.910644226888415, -2.109913362380946],
            [6.8980274470348055, -2.105440921418745],
            [6.88208479441597, -2.0982015408020738],
            [6.87788965635207, -2.0998858216167244],
            [6.859924360353592, -2.100132117146912],
            [6.85420777042711, -2.100769374588781],
            [6.851576105691628, -2.0973927643306496],
            [6.845534693654096, -2.094591481422212],
            [6.838840061245846, -2.0895092941256004],
            [6.835480566580668, -2.0846952336960007],
            [6.830978276127277, -2.075457040814543],
            [6.822548557421408, -2.061357618203061],
            [6.815656167709249, -2.0575050589676556],
            [6.807716887287088, -2.0477768755707353],
            [6.804627893664995, -2.0371054025578226],
            [6.800198483503355, -2.031997982846111],
            [6.785163993327171, -2.0195954546089863],
            [6.782390551617981, -2.0148981848573806],
            [6.782074508405527, -2.007412600707671],
            [6.786660576516616, -1.9950497887134344],
            [6.787603544497827, -1.9869523527294168],
            [6.786880164310426, -1.983025967347596],
            [6.783070015993529, -1.9740082986649243],
            [6.782165670689982, -1.9689782350051008],
            [6.784402336641367, -1.9610328442504188],
            [6.790154140876047, -1.9535138241214276],
            [6.79424002737592, -1.9467651484998822],
            [6.795265482701825, -1.9431941042498067],
            [6.794653887233988, -1.9359908864476782],
            [6.796733371977699, -1.925584936043338],
            [6.797229935912164, -1.9158817681911466],
            [6.792962222979736, -1.8949019336569661],
            [6.7888579126594575, -1.8840607776940357],
            [6.786655010782693, -1.8727632054017935],
            [6.781951264893076, -1.854105211333327],
            [6.771222135170327, -1.8271217142677787],
            [6.770887027227541, -1.821848838316118],
            [6.767889070720297, -1.8143990142486603],
            [6.76264417031741, -1.8072038793162337],
            [6.758880973739128, -1.7985134735912465],
            [6.7554952046045, -1.780193727200703]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.83843951064759,
          "lat": 36.501170283444296
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47161"],
        "coty_name": ["Stewart"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stewart County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01639792"
      },
      "bbox": [
        6.7554952046045, -2.116253575466627, 7.16163619411292,
        -1.777391786471079
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.573574095341131, -2.456733703386189],
            [8.578505823617673, -2.456587430283175],
            [8.582892162666436, -2.4549608855699003],
            [8.582606870238966, -2.4488850580736523],
            [8.593680340449142, -2.4474606157389567],
            [8.604044248040426, -2.447576859536883],
            [8.604228343501838, -2.4521294092625645],
            [8.607208854352521, -2.452364697640519],
            [8.60719755208832, -2.4457817594379336],
            [8.621327558358011, -2.444363219451302],
            [8.63004294134673, -2.4444409706713968],
            [8.631231372733685, -2.4398887800309246],
            [8.649419303082704, -2.4360824137702584],
            [8.651179418763135, -2.4449852447543616],
            [8.661873068638469, -2.444326944263971],
            [8.660098235402822, -2.441488256588482],
            [8.666386545748516, -2.4375633045423686],
            [8.674928230765342, -2.4368615807119265],
            [8.675059092000852, -2.4402336697461986],
            [8.679743374654288, -2.439666354661582],
            [8.678969537007559, -2.434895290082839],
            [8.684702302397797, -2.435752718534118],
            [8.693445548858762, -2.439617229004009],
            [8.70542072166221, -2.439359534555136],
            [8.709792346142441, -2.4429895563667214],
            [8.718280063928347, -2.4448314904111577],
            [8.736668571313137, -2.4476731938961653],
            [8.73670186723796, -2.4517345361201994],
            [8.746342807928109, -2.4573151530774315],
            [8.75270999480565, -2.4577557668558963],
            [8.76147270638243, -2.4600023299683196],
            [8.770560932566365, -2.4587193027348486],
            [8.77565748210541, -2.461573926765746],
            [8.776890307589193, -2.4662435576080184],
            [8.781127615055649, -2.4691959042816016],
            [8.789319949636589, -2.4723569097563467],
            [8.792212512614949, -2.471941607985548],
            [8.797260602731738, -2.467956991900819],
            [8.803928727190927, -2.477095376611312],
            [8.806596512812005, -2.4810533790328355],
            [8.805913419480005, -2.4915954340938398],
            [8.802887991731678, -2.497093877428313],
            [8.802480104140868, -2.5011914686744126],
            [8.805844493665791, -2.5039543434349416],
            [8.802903901009001, -2.5114900011230006],
            [8.798060347933873, -2.5130778004150587],
            [8.801922655398954, -2.5166006663416884],
            [8.808972773599894, -2.5121599490926276],
            [8.81724582765975, -2.5169413931251836],
            [8.81379909729355, -2.5213889306283415],
            [8.81515673848128, -2.524786545372792],
            [8.812422092939066, -2.5306151534397254],
            [8.818722942322001, -2.5366423652451155],
            [8.817357985093699, -2.5415285139088537],
            [8.81493716686112, -2.5442932265471674],
            [8.817033347694663, -2.5485163324271394],
            [8.815030108616988, -2.5585401192313837],
            [8.811643923296817, -2.5639438496517486],
            [8.816830642229334, -2.5890807439003978],
            [8.829389185299933, -2.6466326794935915],
            [8.8300411350383, -2.653831633239871],
            [8.869143922367908, -2.735638306471798],
            [8.829372136578288, -2.7413546028855444],
            [8.752780447132766, -2.7527538263880293],
            [8.717298566001235, -2.760999533937983],
            [8.71292164112257, -2.7616238523977374],
            [8.662919899570845, -2.777851875127528],
            [8.66539440363085, -2.7853682744866624],
            [8.661493974783395, -2.787022783388961],
            [8.65023720043605, -2.777355346757129],
            [8.630411209463766, -2.774240220999636],
            [8.62917986956733, -2.7754980106052187],
            [8.622787922054814, -2.77450113594999],
            [8.615809128329442, -2.7672024674439313],
            [8.613970187334361, -2.77232565023461],
            [8.610756465719941, -2.7696454315480294],
            [8.6067586732654, -2.7638490487169984],
            [8.610300680640561, -2.7612544013856732],
            [8.60793391529059, -2.757843089962449],
            [8.590002011214116, -2.757445049600272],
            [8.589282518243413, -2.747270861361064],
            [8.584573039584303, -2.7450925119305194],
            [8.578307570373935, -2.747079794101984],
            [8.570559508184958, -2.741232517214646],
            [8.563743899399764, -2.7382237080366654],
            [8.56085495623349, -2.7347165455720246],
            [8.559580844992452, -2.729248019213603],
            [8.551582576280262, -2.7289705168626863],
            [8.552512566458535, -2.7173734328103167],
            [8.543985380728301, -2.7168189241664935],
            [8.544414457237727, -2.7086641759964833],
            [8.546181034603778, -2.7031781205702288],
            [8.546103875292776, -2.6926057387185116],
            [8.542892336210326, -2.692623836635114],
            [8.539882879847632, -2.688676613292929],
            [8.538590163000922, -2.6840629534621705],
            [8.532950288754432, -2.683279706888405],
            [8.533435019823845, -2.678968349967171],
            [8.529056131641568, -2.67833818137485],
            [8.529541636363176, -2.6722610953539156],
            [8.519370287298006, -2.653957162835327],
            [8.514617195031802, -2.655184246038235],
            [8.512826782980698, -2.6452110957922597],
            [8.512169862190234, -2.638708265252453],
            [8.506241544538591, -2.6249562309223595],
            [8.503910199817831, -2.6083465936951122],
            [8.507374775579805, -2.6083314199338066],
            [8.506753731720956, -2.601401750423681],
            [8.501098632172729, -2.6001135140307823],
            [8.50097036366183, -2.596766761405875],
            [8.503732476807663, -2.594224772077564],
            [8.504236383525692, -2.5742424073756065],
            [8.505062553189749, -2.5705696316036613],
            [8.519269213482085, -2.541922908266712],
            [8.52567211361826, -2.535413318376055],
            [8.532195132352648, -2.5238749190107757],
            [8.533516989694933, -2.5203768838187757],
            [8.540163007468285, -2.519250655280363],
            [8.53894725325198, -2.515338582155889],
            [8.533699028248957, -2.5145918925761666],
            [8.55247435110585, -2.4763737180061054],
            [8.56443778907616, -2.4672759805137],
            [8.574200927633147, -2.4659132381726785],
            [8.573574095341131, -2.456733703386189]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.77845042684402, "lat": 35.67870112991413 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47177"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "01639796"
      },
      "bbox": [
        8.50097036366183, -2.787022783388961, 8.869143922367908,
        -2.434895290082839
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.508064278022382, -2.441874283485937],
            [7.508018640666563, -2.438703816868092],
            [7.503939663731591, -2.4386748556458473],
            [7.50245414387578, -2.429440294311674],
            [7.510440442492258, -2.428987401931508],
            [7.5103620475944854, -2.4249986203667264],
            [7.517218345012797, -2.424115100796588],
            [7.517163218516746, -2.4207874266211293],
            [7.511583730907711, -2.4205033455259124],
            [7.511587066970973, -2.414822803339564],
            [7.513160055317202, -2.410307976725349],
            [7.514415158875129, -2.3834036565066503],
            [7.516903409060639, -2.349360875673185],
            [7.549151930979505, -2.3480759018353417],
            [7.563899493151305, -2.3483198120168316],
            [7.595352143015502, -2.3480246356306775],
            [7.609757292113733, -2.3459591588648716],
            [7.62006356786438, -2.3438977931453624],
            [7.6353270576048375, -2.3948819717422554],
            [7.636976213980495, -2.399323623941636],
            [7.645611217210688, -2.39792895060836],
            [7.654975935919275, -2.3885685552077933],
            [7.719143044892345, -2.327063724013323],
            [7.770823131359584, -2.330220698528164],
            [7.809881477830738, -2.3322017783364575],
            [7.83053744841897, -2.3327335323918015],
            [7.841839689166732, -2.3351569793757743],
            [7.880067854576067, -2.3551046696297693],
            [7.8955339554154, -2.3553656274716457],
            [7.912462508744018, -2.365988505492381],
            [7.916882500347202, -2.3662202585496006],
            [7.922116839554093, -2.371728869510782],
            [7.950211567831573, -2.3821121972808856],
            [7.950295741331798, -2.3829641719963384],
            [7.967119557390088, -2.382869567797444],
            [7.967070450703181, -2.384798681094139],
            [7.974406894304054, -2.3848756873394623],
            [7.974483383945928, -2.388021530066081],
            [7.97241492134368, -2.392447555297238],
            [7.971043186511107, -2.402852870944388],
            [7.980040473045829, -2.412313435136547],
            [7.974371862127607, -2.4365489041714588],
            [7.972983700203476, -2.4470007617820513],
            [7.9745948265347915, -2.449791990706526],
            [7.982289972470813, -2.456515543589896],
            [7.986975131813508, -2.4723725757303083],
            [7.981020601036693, -2.4741644155380706],
            [7.986006197883678, -2.4923511279794837],
            [7.990699660326245, -2.496168228212582],
            [7.995515401898079, -2.496634561955078],
            [7.995086330768629, -2.499865505591962],
            [8.000681134863195, -2.5019889098646573],
            [8.000983960311356, -2.51379969742696],
            [7.999724325812793, -2.5167552689595247],
            [7.989360855731607, -2.517689314457223],
            [7.989346606407316, -2.5252972689561384],
            [7.982696137617738, -2.5249803956847474],
            [7.9828707007573465, -2.5307611525997205],
            [7.994445388534387, -2.5317000565338756],
            [7.994619934502692, -2.542780358625817],
            [7.991085997097153, -2.5403825845765144],
            [7.986130817996743, -2.5413711647137984],
            [7.985285458279181, -2.5483822210459763],
            [7.98787587817117, -2.5518440901703365],
            [7.990268837195537, -2.548292606623972],
            [7.994509367399014, -2.5463877958491508],
            [7.997189198680414, -2.552049080369301],
            [7.996625351327393, -2.566069154986937],
            [7.988240889407827, -2.5660273952980712],
            [7.987650797608305, -2.562468109722324],
            [7.98120671131548, -2.563386600817731],
            [7.9691332873716805, -2.563490317467004],
            [7.96900180467878, -2.5686575896545336],
            [7.956948110526467, -2.5693753022232038],
            [7.958512402090905, -2.573866931876873],
            [7.956653882129269, -2.577544777596653],
            [7.960416143195566, -2.5787272452853407],
            [7.960545891760493, -2.5928294758164965],
            [7.958149995543292, -2.5894682826442916],
            [7.952100733480053, -2.589299789548241],
            [7.94720587929229, -2.5958224384134176],
            [7.947076797354591, -2.6054723385808085],
            [7.945819690101037, -2.611867978424463],
            [7.933517396107958, -2.6107784347740903],
            [7.93412629656782, -2.6314862430760795],
            [7.933756481614758, -2.6408511199640796],
            [7.935016010328976, -2.6455731687913393],
            [7.943550239803052, -2.6441938758116876],
            [7.943616577446092, -2.6493712496252178],
            [7.946264656120596, -2.652355454847995],
            [7.938699295881033, -2.652274575759832],
            [7.938129954232586, -2.6578332626456955],
            [7.910626955471485, -2.6591800024809618],
            [7.908796296091301, -2.6673711813203544],
            [7.898436218731219, -2.6640123951511074],
            [7.8942128446405135, -2.665863479491635],
            [7.887382969859365, -2.6664612489166983],
            [7.887253897939952, -2.659996092887689],
            [7.880958359657653, -2.6601311106144085],
            [7.882010078502801, -2.6664284369360245],
            [7.877550031963065, -2.668799864064085],
            [7.876108821481114, -2.6665236129100154],
            [7.869962771931376, -2.666570219548969],
            [7.869862884179605, -2.663319871190612],
            [7.85700665403671, -2.663157488226176],
            [7.8570419414845345, -2.659654020567966],
            [7.849299931972092, -2.6593495103916966],
            [7.8455100666280675, -2.656226851726693],
            [7.844585013867333, -2.651735835688901],
            [7.8355260797562565, -2.6514016114968078],
            [7.83553258208272, -2.649818077160555],
            [7.821039971580025, -2.649147906076137],
            [7.81722049293619, -2.6496108217775185],
            [7.813426908221612, -2.6435197951837424],
            [7.809417696072324, -2.6410708639700675],
            [7.788553700353438, -2.636552943200036],
            [7.758256503540828, -2.626532376459158],
            [7.747282209904879, -2.6238934558788145],
            [7.739379447630212, -2.619812309415819],
            [7.742677366575294, -2.615457616188505],
            [7.745432502662349, -2.6029062233372198],
            [7.734933714930372, -2.6024350685108155],
            [7.7335323127442575, -2.6095574049928967],
            [7.727096026486893, -2.6093118450552257],
            [7.72752254960775, -2.601024936798051],
            [7.718010069828856, -2.6006751232764937],
            [7.718889840647042, -2.6072252827249733],
            [7.71718348880615, -2.611922522991387],
            [7.713449937401761, -2.612458309691171],
            [7.690713103150441, -2.6057124332035646],
            [7.679063943478588, -2.6053407888259557],
            [7.6751634314527175, -2.600607724568408],
            [7.6606274496567055, -2.596375289587451],
            [7.658153855917917, -2.5928563460663328],
            [7.655091087347891, -2.5947527285950827],
            [7.557420666629784, -2.565920066572055],
            [7.534106224770447, -2.5587786354967927],
            [7.509503860138069, -2.5516413666694646],
            [7.510265145714531, -2.5346497336971794],
            [7.511557352448125, -2.486660044563105],
            [7.512049061548396, -2.460347108467828],
            [7.508626826584325, -2.4602715541809825],
            [7.5086827710016335, -2.4482635045389736],
            [7.508064278022382, -2.441874283485937]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.89861453304947, "lat": 35.89383381041845 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47187"],
        "coty_name": ["Williamson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Williamson County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "01639801"
      },
      "bbox": [
        7.50245414387578, -2.668799864064085, 8.000983960311356,
        -2.327063724013323
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.984401098284554, -9.433700640752585],
            [-1.9798453993323746, -9.435796994314321],
            [-1.9241853572760843, -9.459086162893541],
            [-1.840904342373014, -9.493887237074459],
            [-1.808070962103027, -9.507714834821154],
            [-1.7190701537690993, -9.544814519104111],
            [-1.6410351310547109, -9.577329943659914],
            [-1.5761332647353115, -9.658641936296222],
            [-1.5527424632374431, -9.688106011925044],
            [-1.549857198408566, -9.692053464746094],
            [-1.5245970490179124, -9.7235516121286],
            [-1.5115853640227508, -9.742100012896488],
            [-1.5055044841165328, -9.74941680204911],
            [-1.4572601066520152, -9.810306848971583],
            [-1.4516209868051493, -9.81739721312346],
            [-1.438337871693569, -9.830785523744776],
            [-1.428467882546189, -9.84371063953474],
            [-1.4010519042162493, -9.878725672917389],
            [-1.3781203066185859, -9.905922984607928],
            [-1.3904664975926808, -9.915559367803736],
            [-1.4022452059990405, -9.925487313553646],
            [-1.4233475803909148, -9.941617745184637],
            [-1.4726657382374937, -9.980340698983134],
            [-1.5219930558490826, -10.019049282298113],
            [-1.5901390107823459, -10.072431088341462],
            [-1.5892798827899703, -10.037441823273445],
            [-1.6394903986411073, -10.036313267242406],
            [-1.7400001315652858, -10.033626449431509],
            [-1.8405091579879147, -10.030914862261923],
            [-1.9772284469283348, -10.027799102590736],
            [-1.9987412202910864, -10.027497899227004],
            [-1.998729745110726, -10.02732027076576],
            [-1.9946273129375423, -9.831640156876912],
            [-1.9925705820953914, -9.730105312403497],
            [-1.991617398835521, -9.679190770022542],
            [-1.9892459701282257, -9.591566401217099],
            [-1.9847819169995895, -9.448878802883526],
            [-1.984401098284554, -9.433700640752585]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.52716412029122,
          "lat": 28.893514255492022
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48013"],
        "coty_name": ["Atascosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Atascosa County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01383792"
      },
      "bbox": [
        -1.9987412202910864, -10.072431088341462, -1.3781203066185859,
        -9.433700640752585
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.7149416226873847, -8.305302150460188],
            [-0.6849909835003248, -8.32230153904643],
            [-0.6384328583510295, -8.349234740657666],
            [-0.5691407866733115, -8.388654934663391],
            [-0.4691697125472068, -8.46722575473578],
            [-0.4505492744854086, -8.547959996384156],
            [-0.42194085465949854, -8.67364428244958],
            [-0.4941479495862845, -8.748060121876264],
            [-0.5151270605128391, -8.768959492442171],
            [-0.5948814603503285, -8.849315983059629],
            [-0.6774892840607678, -8.932565352420783],
            [-0.7081299013807344, -8.902109991846448],
            [-0.7397799031922451, -8.871238328492858],
            [-0.8006037279442801, -8.810893330630522],
            [-0.8354397322876741, -8.776439784116755],
            [-0.892842413302353, -8.719063748753895],
            [-0.8970441339113943, -8.715253233526694],
            [-0.9193873258635019, -8.692273493710683],
            [-0.9476466227046595, -8.664284786273651],
            [-0.961864873351946, -8.649793764145505],
            [-0.9529037474167121, -8.639704454004674],
            [-0.9309396503109564, -8.61812615029307],
            [-0.9270204095939307, -8.615234352848542],
            [-0.8449631393301038, -8.532583327930901],
            [-0.8242102586667772, -8.511420036191808],
            [-0.8133110766984584, -8.491112841099124],
            [-0.8038237654511763, -8.472772252737728],
            [-0.7419946999473704, -8.356125987890739],
            [-0.7217389103018632, -8.317575998120889],
            [-0.7149416226873847, -8.305302150460188]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.31201455679853, "lat": 30.10360528952517 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48021"],
        "coty_name": ["Bastrop"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bastrop County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01383796"
      },
      "bbox": [
        -0.961864873351946, -8.932565352420783, -0.42194085465949854,
        -8.305302150460188
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.164463920819545, -7.652360549088659],
            [-1.1054086796340614, -7.618489957862045],
            [-1.0761279539106163, -7.601930898121859],
            [-1.0652574845630758, -7.595264668456082],
            [-1.037673032819796, -7.5795818910937625],
            [-0.9161151423790488, -7.509754620856739],
            [-0.7961092990970489, -7.440608158522924],
            [-0.7436875287460799, -7.410106873204758],
            [-0.6807813306416675, -7.486636984345376],
            [-0.6246616615844353, -7.451993897709129],
            [-0.6044631943290196, -7.486343543455816],
            [-0.5908720050416664, -7.509855892507665],
            [-0.5861968207578713, -7.517056763530652],
            [-0.5782795336227717, -7.530802060630322],
            [-0.5318028995804017, -7.609219269880167],
            [-0.5056746455353613, -7.6531182413741226],
            [-0.4508140762730231, -7.746296270373826],
            [-0.5456538208697795, -7.80041840033999],
            [-0.6060662116386728, -7.834771041685451],
            [-0.6135370624870696, -7.840170818583067],
            [-0.6406550908662604, -7.912622087280784],
            [-0.6638070097036637, -7.975790480324054],
            [-0.7135048792744098, -7.9533285683008295],
            [-0.7147958186462104, -7.952291156881206],
            [-0.7378818328848031, -7.9417526408652],
            [-0.8319452423958688, -7.898478888827129],
            [-0.9262506319168424, -7.854920931214183],
            [-0.9742270312447714, -7.845071966181086],
            [-1.1002077937844672, -7.817599357890078],
            [-1.1016335110629072, -7.812497046700948],
            [-1.1102156520576487, -7.792658337038303],
            [-1.128781539620588, -7.757023218460314],
            [-1.138243568399588, -7.740122949926141],
            [-1.1482935265638203, -7.72000554447942],
            [-1.1690746435580968, -7.686440901837641],
            [-1.1702939925681488, -7.655717017368162],
            [-1.164463920819545, -7.652360549088659]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.47876209975877,
          "lat": 31.037324071609834
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48027"],
        "coty_name": ["Bell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bell County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01383799"
      },
      "bbox": [
        -1.1702939925681488, -7.975790480324054, -0.4508140762730231,
        -7.410106873204758
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0140189399725412, -8.692925776904609],
            [-1.0080733716471402, -8.687883302358903],
            [-0.9934219161332276, -8.673682798143403],
            [-0.9655379488885026, -8.646146889719091],
            [-0.961864873351946, -8.649793764145505],
            [-0.9476466227046595, -8.664284786273651],
            [-0.9193873258635019, -8.692273493710683],
            [-0.8970441339113943, -8.715253233526694],
            [-0.892842413302353, -8.719063748753895],
            [-0.8354397322876741, -8.776439784116755],
            [-0.8006037279442801, -8.810893330630522],
            [-0.7397799031922451, -8.871238328492858],
            [-0.7081299013807344, -8.902109991846448],
            [-0.6774892840607678, -8.932565352420783],
            [-0.6793106308338321, -8.934401917364374],
            [-0.7597468818835161, -8.983080194253844],
            [-0.8488596262384654, -9.036955400797897],
            [-0.9245593376331271, -9.082787643215427],
            [-0.9252966558753267, -9.078418779502044],
            [-0.9296174073815775, -9.071795974010133],
            [-0.9319311308312342, -9.073093076868561],
            [-0.9305001725658566, -9.077023200688311],
            [-0.9367843494352006, -9.076524007040137],
            [-0.9428460004912284, -9.07773816677575],
            [-0.9404975806168203, -9.072274889489474],
            [-0.9415025937395717, -9.068318062979587],
            [-0.9454598691180205, -9.070382477223305],
            [-0.9508378837805849, -9.070927902585527],
            [-0.9550585603129877, -9.063388345239957],
            [-0.9531237989126958, -9.059855486462666],
            [-0.958683049537312, -9.058573496933569],
            [-0.9676085074377991, -9.058901325597773],
            [-0.9726542423564651, -9.05684368883669],
            [-0.9713975334516327, -9.051295723284383],
            [-0.9685748263553494, -9.050947931648613],
            [-0.9716288910870999, -9.045340648368418],
            [-0.9769528353758367, -9.049788231148668],
            [-0.9809833360892876, -9.04602922358673],
            [-0.9918770263264887, -9.044702932401082],
            [-0.9959212903328932, -9.049089602758604],
            [-0.999926738904539, -9.045242154048932],
            [-1.002538858271995, -9.04011459177617],
            [-1.005422450163282, -9.040284298677545],
            [-1.013238491535891, -9.044052495935572],
            [-1.0157068593904657, -9.041964467313825],
            [-1.0177069594510098, -9.035340264104196],
            [-1.0158903466139717, -9.031304258404893],
            [-1.0198367482455528, -9.028797481583368],
            [-1.022702366126233, -9.03095312146602],
            [-1.031502390592098, -9.03021508130893],
            [-1.0316589950003983, -9.026820876957022],
            [-1.0433774879847157, -9.020999356280296],
            [-1.0452575457215343, -9.015968968561593],
            [-1.0498589906389606, -9.013329146001563],
            [-1.0442886613785947, -9.01035344752138],
            [-1.0433065502978711, -9.006739275728373],
            [-1.0452801662488067, -8.999512789793231],
            [-1.0520121597848144, -9.000979110583971],
            [-1.0553298322909128, -8.997624772225604],
            [-1.0609679965039907, -8.994365290559506],
            [-1.0628805527239826, -8.997232109862805],
            [-1.0669724784223658, -8.998982654687024],
            [-1.0712819312291169, -8.992913248189335],
            [-1.0669598264441593, -8.990360580576414],
            [-1.064524823480014, -8.986808489324495],
            [-1.0734689659397332, -8.979296545428046],
            [-1.0711253633684017, -8.970551434336413],
            [-1.0759762890831248, -8.970040037095313],
            [-1.0802879687877034, -8.96397811848544],
            [-1.08174183108118, -8.959502933485286],
            [-1.0819391600144834, -8.952569650626284],
            [-1.0860484663099579, -8.951267639678093],
            [-1.0915455904466216, -8.95271346395356],
            [-1.0918458729472442, -8.957849266273643],
            [-1.0944914028348145, -8.959637587728343],
            [-1.1009651577432122, -8.958213612605414],
            [-1.0986535922452934, -8.952804123073545],
            [-1.0979372461232675, -8.946129854810598],
            [-1.1019926855853894, -8.94476276960728],
            [-1.1072953201658002, -8.937482823079929],
            [-1.102458299073609, -8.93504581091733],
            [-1.104632881982579, -8.93245326616151],
            [-1.1105857639130192, -8.931266488043722],
            [-1.109848990106893, -8.927304943160825],
            [-1.1121667342413843, -8.921688916505698],
            [-1.114290407133616, -8.922591010156957],
            [-1.1163883790649822, -8.929184409375322],
            [-1.1222219481268563, -8.930354054980217],
            [-1.1254920348899122, -8.927256598244378],
            [-1.1233648799717677, -8.921872115760259],
            [-1.1234504470608278, -8.916383079054025],
            [-1.1270468610605513, -8.917189603459969],
            [-1.1338584274914942, -8.912534932493951],
            [-1.1337369498325263, -8.903560142898783],
            [-1.136115844910651, -8.900734018116104],
            [-1.1321498749620207, -8.896218893411424],
            [-1.1311904545456, -8.891645047302008],
            [-1.1336835498508526, -8.888024550809673],
            [-1.129875508102003, -8.886711010551506],
            [-1.1291849118784676, -8.883678431653085],
            [-1.1345471469584028, -8.879280001179666],
            [-1.1352417832420307, -8.873066072874364],
            [-1.1384481494570282, -8.868814292453491],
            [-1.1444147612806086, -8.868140629717965],
            [-1.1448982128862735, -8.863215054989652],
            [-1.151264981279333, -8.855778158598989],
            [-1.1586847629029149, -8.859352792807963],
            [-1.1612264550768852, -8.853676669543313],
            [-1.161834240255252, -8.851343511013019],
            [-1.1705282143571951, -8.84965031455388],
            [-1.1730052003228404, -8.854859522851765],
            [-1.182054334411586, -8.85366061818368],
            [-1.1798634544283482, -8.84655289799379],
            [-1.1768648082815238, -8.82812221466173],
            [-1.15546062598059, -8.810698609224433],
            [-1.137504099983712, -8.796969292699615],
            [-1.1265010545904215, -8.790965201495899],
            [-1.1192285333293857, -8.78504201262581],
            [-1.1100175590353067, -8.779262547784677],
            [-1.0974343929930284, -8.772757657716229],
            [-1.0878242657825017, -8.769042948253478],
            [-1.0842924718391493, -8.760626083693367],
            [-1.0818641471266688, -8.757259469412535],
            [-1.0740498971737376, -8.751193098795268],
            [-1.0720918308372773, -8.747252338228876],
            [-1.0639670215005836, -8.7361772774792],
            [-1.0595651034585374, -8.727072416542875],
            [-1.0529681035003537, -8.721352074653096],
            [-1.0474062770681987, -8.719694678945352],
            [-1.0140189399725412, -8.692925776904609]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.61991274081522,
          "lat": 29.836853232177255
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48055"],
        "coty_name": ["Caldwell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caldwell County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01383813"
      },
      "bbox": [
        -1.182054334411586, -9.082787643215427, -0.6774892840607678,
        -8.646146889719091
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0331309488911569, -7.054406338802619],
            [-0.9675413028562012, -7.017151516348756],
            [-0.9163536878748584, -7.108445723743143],
            [-0.9086845565934595, -7.1225566648024605],
            [-0.8979795501493995, -7.141201181337014],
            [-0.8679341535414165, -7.193075845349585],
            [-0.8255296698423766, -7.267362903306251],
            [-0.811256468596446, -7.292861969894292],
            [-0.7912616292708927, -7.327318180580147],
            [-0.7812158656534285, -7.345825704177713],
            [-0.7790096951298972, -7.3486411916106045],
            [-0.7436875287460799, -7.410106873204758],
            [-0.7961092990970489, -7.440608158522924],
            [-0.9161151423790488, -7.509754620856739],
            [-1.037673032819796, -7.5795818910937625],
            [-1.0652574845630758, -7.595264668456082],
            [-1.0761279539106163, -7.601930898121859],
            [-1.1054086796340614, -7.618489957862045],
            [-1.164463920819545, -7.652360549088659],
            [-1.1817118474643307, -7.621189258183438],
            [-1.199874723117063, -7.589078265445129],
            [-1.2146083483551606, -7.563424081582236],
            [-1.245310167885544, -7.508586523632856],
            [-1.2526529176213348, -7.495834593815278],
            [-1.3039616545913015, -7.405410749875322],
            [-1.3461593830123157, -7.3302667059528615],
            [-1.3883452509449343, -7.255097395834657],
            [-1.359884731335106, -7.238898125328868],
            [-1.2989219481792678, -7.204820394916228],
            [-1.2319068575509735, -7.167167903462516],
            [-1.1425579490292725, -7.116564010179891],
            [-1.125239887833113, -7.10690843881855],
            [-1.0331309488911569, -7.054406338802619]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.79927253646234, "lat": 31.39088412648404 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48099"],
        "coty_name": ["Coryell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coryell County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01383835"
      },
      "bbox": [
        -1.3883452509449343, -7.652360549088659, -0.7436875287460799,
        -7.017151516348756
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.416734486285031, -5.683944455011196],
            [-3.3638996916114983, -5.687037720944997],
            [-3.30294550066394, -5.689958356532307],
            [-3.166279982970607, -5.697487566300205],
            [-3.10377619890511, -5.70094027058423],
            [-2.9907388804712425, -5.707081883222401],
            [-2.9947026413674, -5.785222266020763],
            [-3.000107418356557, -5.901643683477306],
            [-3.002141211530528, -5.939392833370999],
            [-3.002377770931816, -5.951518325832277],
            [-3.003287606960954, -5.9597736946546345],
            [-3.0060939545491645, -6.026120840662301],
            [-3.0118515335998506, -6.144017498981479],
            [-3.0644756581626686, -6.141053473832513],
            [-3.173589057548195, -6.135713921289209],
            [-3.2827016599391206, -6.130359734881912],
            [-3.32767856736688, -6.12795501213143],
            [-3.4423003176063025, -6.121652378578962],
            [-3.4376596124279333, -6.031105010881148],
            [-3.4332419622585926, -5.963937508395833],
            [-3.430716732218992, -5.91347137241336],
            [-3.416734486285031, -5.683944455011196]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.40217913892874,
          "lat": 32.74280973533918
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48151"],
        "coty_name": ["Fisher"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fisher County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01383861"
      },
      "bbox": [
        -3.4423003176063025, -6.144017498981479, -2.9907388804712425,
        -5.683944455011196
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.31954531998337177, -7.91325000889547],
            [0.35649155842199454, -7.9097250875550325],
            [0.3622614605202106, -7.908665718645992],
            [0.45202112585286897, -7.8938816833778285],
            [0.4839059235065513, -7.888719973058597],
            [0.5705445804435236, -7.873899232802498],
            [0.5809591075918409, -7.872441684151805],
            [0.5931420509794081, -7.972606659742139],
            [0.5961583970354691, -7.99843831481459],
            [0.609470306398035, -8.104566432125191],
            [0.620237317469433, -8.230745675816552],
            [0.6206761511530144, -8.233579350435132],
            [0.6237985551278648, -8.277679081759443],
            [0.6322979830998989, -8.394579357816054],
            [0.6325269721357906, -8.485963608770746],
            [0.6165207249626954, -8.486956553133858],
            [0.5300845944727528, -8.494300219845345],
            [0.5166927107653506, -8.494085984224098],
            [0.5036152656713764, -8.494651005507793],
            [0.45960116444745064, -8.49787193804422],
            [0.3870122320584, -8.502793279437268],
            [0.38336479643017324, -8.50628741097698],
            [0.3789850320515413, -8.501080725914191],
            [0.3728360758158598, -8.498666162245282],
            [0.3747695257472432, -8.492912011299792],
            [0.37871916502628833, -8.488899271453997],
            [0.3822966090297962, -8.489249576949808],
            [0.38811620119466916, -8.493827688880613],
            [0.39186375386271477, -8.493294124355009],
            [0.3940149608696966, -8.4873592777421],
            [0.39079619928754017, -8.480473591469492],
            [0.3866064036397246, -8.47869851076633],
            [0.3819184708668427, -8.479336950312502],
            [0.37858562525240613, -8.477257171991676],
            [0.37814693340275846, -8.473728938052101],
            [0.3813789433944467, -8.46625443190218],
            [0.3828672576898591, -8.457617686499141],
            [0.384647829306554, -8.453956556525254],
            [0.3903836059466646, -8.449410184596918],
            [0.39099761435992875, -8.444404196900983],
            [0.3863211102066814, -8.442410392492926],
            [0.3801792567696191, -8.443066293580637],
            [0.37703940580200535, -8.43929295911037],
            [0.37860838814553843, -8.432606323440984],
            [0.3830365451940232, -8.4270221828713],
            [0.38237964124875223, -8.422883523848906],
            [0.3799777751001208, -8.421155941234266],
            [0.36457700100079865, -8.426203472507817],
            [0.35990442196895356, -8.426506905503356],
            [0.3557786462667673, -8.420681019181677],
            [0.350297028387973, -8.419810593753718],
            [0.3460672059699153, -8.41750770649352],
            [0.3440800213434847, -8.40987350329454],
            [0.33501930922484474, -8.407150571331423],
            [0.33050905317615736, -8.402088353972555],
            [0.331046696046872, -8.398408576188766],
            [0.3401128138564359, -8.39516805834444],
            [0.34265854691627917, -8.390057988739132],
            [0.33637883455568235, -8.388088228645008],
            [0.3347414488156295, -8.380354189089333],
            [0.3410606903693097, -8.379689843516273],
            [0.3418036205266157, -8.367393867990074],
            [0.3383728417372731, -8.361561585373689],
            [0.3396234584096301, -8.355825369898504],
            [0.33710291878777027, -8.352546531552523],
            [0.33854178956160064, -8.348094063287082],
            [0.343658359462644, -8.349648003349046],
            [0.34819459658009355, -8.348301405855445],
            [0.3498748050615853, -8.345013736441436],
            [0.3555294378115323, -8.345351420441789],
            [0.3583102912693769, -8.348815501423413],
            [0.36070396692627277, -8.345457155344947],
            [0.3589742118477295, -8.34211934129527],
            [0.3632195096669508, -8.340173756922653],
            [0.36179651541813557, -8.334575110928856],
            [0.3659888941605446, -8.33186890413802],
            [0.370606274555299, -8.326892747523557],
            [0.36743524337431943, -8.32527617962885],
            [0.365959364173575, -8.319969620122881],
            [0.3674042936470343, -8.317287625570122],
            [0.372147935592721, -8.31476891000924],
            [0.3768133871595865, -8.31586151764507],
            [0.37917169497506487, -8.313386436824233],
            [0.3817077356031904, -8.316278941659121],
            [0.38849840996515383, -8.315613230786274],
            [0.3923641441242494, -8.310317547210081],
            [0.3936088551434802, -8.302104488642678],
            [0.389051025849757, -8.303433019201446],
            [0.3897368698719197, -8.297812989438226],
            [0.38387183049308926, -8.293304166299949],
            [0.3801252935885944, -8.295915040561178],
            [0.37715403352597254, -8.292710430133962],
            [0.37322029871908413, -8.29634501391749],
            [0.37367803993712084, -8.289420838057842],
            [0.3694349610835892, -8.289745289845275],
            [0.36644652005672207, -8.292783787813947],
            [0.36009807884434775, -8.291473226999626],
            [0.3578994212014173, -8.28639681339268],
            [0.3548974060822088, -8.283943808131694],
            [0.3580789873459479, -8.278684747023755],
            [0.3521587764549997, -8.273422571482511],
            [0.35240572105280304, -8.267756864655777],
            [0.3469213374022872, -8.264674258166606],
            [0.34340770445012736, -8.26114690488405],
            [0.3437059458830498, -8.254917710307092],
            [0.34935038484264247, -8.24948233717664],
            [0.35014431038515875, -8.243248516941648],
            [0.3450753317160193, -8.23778879154443],
            [0.34627227415686074, -8.234230076736281],
            [0.3414867504387863, -8.23347731765003],
            [0.34114754297441774, -8.228094393840482],
            [0.3424197284514437, -8.224831250797095],
            [0.33944096713104555, -8.221906904827378],
            [0.3325353483168621, -8.212697836571667],
            [0.3363050422067054, -8.20593018072759],
            [0.32781859745706066, -8.198969284432648],
            [0.3249190213665727, -8.192334309679838],
            [0.3265707865537765, -8.182187126254634],
            [0.32594789632557136, -8.177601002035878],
            [0.3274668321033333, -8.175667086297574],
            [0.32504257855659735, -8.171914124500521],
            [0.32478183348671463, -8.164161679523323],
            [0.3128106078362383, -8.152604394199939],
            [0.31153330770293775, -8.149425207243002],
            [0.305023869330938, -8.146173544630381],
            [0.3070532652959628, -8.141388199492438],
            [0.30446401138604184, -8.135645358401767],
            [0.3033509585977509, -8.12876012971906],
            [0.3070726441945161, -8.127851445761205],
            [0.30885458158109885, -8.113447943943195],
            [0.31471693104399745, -8.111941506538582],
            [0.31446298044019366, -8.107201698768733],
            [0.3178743437242135, -8.10257553375749],
            [0.31524528125226214, -8.099140234916813],
            [0.3210288612844325, -8.090549403380859],
            [0.31981766171529835, -8.087254457068862],
            [0.32027418086105813, -8.080052122911653],
            [0.3229188650301043, -8.076262495153355],
            [0.3227005190507708, -8.073038547484497],
            [0.3185867645527162, -8.071578395762957],
            [0.3192163711084203, -8.064041390333045],
            [0.315545364143761, -8.055376892024046],
            [0.31748128530995556, -8.049927137694926],
            [0.31758149539012936, -8.045751457418241],
            [0.313308715189262, -8.0392808064503],
            [0.31116681715225974, -8.026163773587502],
            [0.31610597642852073, -8.023274099211442],
            [0.3167458080673239, -8.01852609275231],
            [0.3226656612646274, -8.013459595439718],
            [0.32478318086588487, -8.007751846957119],
            [0.3243552642701016, -7.995876256309543],
            [0.3221718055846511, -7.991437536968181],
            [0.31789210311689736, -7.986871868218879],
            [0.3176190161061115, -7.982886985223909],
            [0.31907328565402443, -7.977333323545934],
            [0.3223516238862304, -7.975902285092344],
            [0.32246475888396525, -7.9710083651068295],
            [0.32435737557108296, -7.966375543141839],
            [0.31712102182608914, -7.952703487770212],
            [0.3120794364179862, -7.949490862228332],
            [0.3064130307829583, -7.940895338353976],
            [0.31152758294867733, -7.935004105804605],
            [0.31481118635217825, -7.9349674173126274],
            [0.3160694660477622, -7.927558141505807],
            [0.3148038423529775, -7.924566542915117],
            [0.3156084518894769, -7.918797813828848],
            [0.31954531998337177, -7.91325000889547]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.98546957877178, "lat": 30.54349030637421 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48185"],
        "coty_name": ["Grimes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grimes County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "01383878"
      },
      "bbox": [
        0.3033509585977509, -8.50628741097698, 0.6325269721357906,
        -7.872441684151805
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2682868105275968, -6.164660002271198],
            [-1.2125643868260232, -6.166446595966538],
            [-1.210454921769803, -6.166824742866276],
            [-1.1447245233354295, -6.168957654048981],
            [-1.107839003054388, -6.169435804201142],
            [-1.0438705392365213, -6.1710302837896345],
            [-1.0105868935222369, -6.171674776566955],
            [-0.9635475661395426, -6.172999709152946],
            [-0.8914229906240337, -6.175260272130378],
            [-0.8917080708856754, -6.198776264950615],
            [-0.8915975606919652, -6.2402104834527945],
            [-0.892907055659499, -6.259615212568056],
            [-0.8930568019122394, -6.331211600973204],
            [-0.893556174542248, -6.383639884920218],
            [-0.8939752785534493, -6.411928864864761],
            [-0.8943948187130951, -6.411978730810444],
            [-0.9718064063932954, -6.411897549186864],
            [-1.0348289285618624, -6.411605691354289],
            [-1.098969113126518, -6.4486859869400455],
            [-1.1175942134586414, -6.4598352637443055],
            [-1.1734215838960635, -6.491852589644277],
            [-1.1875410881218076, -6.451254396394504],
            [-1.2174824822786467, -6.362187408996872],
            [-1.2230072964408498, -6.349638549396299],
            [-1.2384093673529966, -6.305964466493123],
            [-1.2667713587092388, -6.223924072793141],
            [-1.2707516455077243, -6.2118039384794255],
            [-1.2682868105275968, -6.164660002271198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.83227197574814, "lat": 32.42993318347412 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48221"],
        "coty_name": ["Hood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hood County"],
        "coty_fp_code": "221",
        "coty_gnis_code": "01383896"
      },
      "bbox": [
        -1.2707516455077243, -6.491852589644277, -0.8914229906240337,
        -6.164660002271198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5156159528075974, -10.618532865203248],
            [-1.3931667363972065, -10.621706638294976],
            [-1.2631730692658025, -10.625035940713573],
            [-1.2037044385885933, -10.626220711801334],
            [-1.1964493635659144, -10.63308312336424],
            [-1.1902047148319876, -10.642072375845064],
            [-1.1880809904314225, -10.641611819785458],
            [-1.184071040131133, -10.64500493599198],
            [-1.1786875247835416, -10.64491439938116],
            [-1.1769609348318282, -10.64661078783981],
            [-1.1673556443037503, -10.647217432256236],
            [-1.1649753667074163, -10.648798658830737],
            [-1.160883470040797, -10.646369719212716],
            [-1.155450329021814, -10.64695749234231],
            [-1.1510842032639539, -10.644347131422402],
            [-1.1440656470726838, -10.645172716538328],
            [-1.1408486714744805, -10.642457946193753],
            [-1.1355423269274194, -10.642722756439106],
            [-1.131668591394826, -10.645755243840158],
            [-1.1318702830519638, -10.647990727172814],
            [-1.1270929722511869, -10.6527969880093],
            [-1.1251434162709535, -10.659091150393207],
            [-1.122195144872559, -10.664656213927147],
            [-1.1239266106279138, -10.668955177377283],
            [-1.1280556811784692, -10.67299695897198],
            [-1.127386051573934, -10.680340002708821],
            [-1.1299313161941975, -10.687610263147745],
            [-1.1692785849234038, -10.721883445813729],
            [-1.219688976950234, -10.765598036929067],
            [-1.2237105627143727, -10.768426267729375],
            [-1.252449420706995, -10.79338509483744],
            [-1.2526777793900008, -10.81832911294199],
            [-1.254098367715773, -10.89957772907513],
            [-1.2598292498434853, -10.978504680449756],
            [-1.2619454938989232, -11.002934446075264],
            [-1.2645048848208025, -11.036930285462708],
            [-1.326579154329808, -11.03588167240315],
            [-1.3691863271986697, -11.034828409581014],
            [-1.3721365805339698, -11.197131225678364],
            [-1.3734949077237857, -11.272841779283922],
            [-1.3757308155054508, -11.400659790372648],
            [-1.4536312551747501, -11.398210300070359],
            [-1.5315309754743223, -11.395743380885484],
            [-1.5289892699110414, -11.274238747074689],
            [-1.5266469567462486, -11.163173065978757],
            [-1.5237082568983922, -11.022402487266737],
            [-1.5223037510586759, -10.963934699452778],
            [-1.5225243413344687, -10.957658088872593],
            [-1.5217950734075834, -10.925978304710656],
            [-1.5212723628280702, -10.892270673030131],
            [-1.519455138713706, -10.802874196257251],
            [-1.5178459108978184, -10.723724468131161],
            [-1.5156159528075974, -10.618532865203248]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.08983684633348, "lat": 27.73139258366153 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48249"],
        "coty_name": ["Jim Wells"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jim Wells County"],
        "coty_fp_code": "249",
        "coty_gnis_code": "01383910"
      },
      "bbox": [
        -1.5315309754743223, -11.400659790372648, -1.122195144872559,
        -10.618532865203248
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0578051828258768, -8.554076433655247],
            [-1.9299663409825085, -8.558170223821325],
            [-1.910646074468408, -8.55818743916044],
            [-1.803260426388436, -8.560772866567925],
            [-1.7709648560464288, -8.561640018562912],
            [-1.7425728538619687, -8.60186817503284],
            [-1.72474886443789, -8.627388924983492],
            [-1.7224826443704435, -8.629955916396463],
            [-1.646496029565633, -8.735905372587231],
            [-1.6259707110354686, -8.764811448862234],
            [-1.6897928033095362, -8.824046933011827],
            [-1.7453444072030275, -8.873440569619198],
            [-1.8322044343130117, -8.949675895597904],
            [-1.831559200100069, -8.947049740792242],
            [-1.8351420279752844, -8.94136954324291],
            [-1.8381112503276809, -8.94590425878923],
            [-1.840697891190255, -8.94687799061375],
            [-1.8453373911433175, -8.94539317671404],
            [-1.8474527925013002, -8.948173340122251],
            [-1.8447736881961958, -8.950771747864138],
            [-1.847168797919825, -8.953370095213844],
            [-1.8525937676745827, -8.950738987381987],
            [-1.8563255703001111, -8.952038351797981],
            [-1.8588415480370397, -8.956759725815504],
            [-1.8643001969295174, -8.954551123725697],
            [-1.8683206472302671, -8.955062773449406],
            [-1.8729103436123555, -8.958406779721628],
            [-1.879520306266764, -8.956057186015425],
            [-1.8791955696413378, -8.96070433376022],
            [-1.8838533786471168, -8.960148328596796],
            [-1.8886215601467076, -8.962273267476222],
            [-1.8948340906008105, -8.967580205474864],
            [-1.8995380989952328, -8.963187939558214],
            [-1.9020460306438902, -8.9649617919973],
            [-1.9076011017896677, -8.963038378912092],
            [-1.9047105762967689, -8.97026658351601],
            [-1.909331932839305, -8.971066666037252],
            [-1.9128633630342653, -8.975699844565895],
            [-1.917948489437056, -8.975654795539208],
            [-1.9213308451681332, -8.971524566642568],
            [-1.9336102948093048, -8.969733369422306],
            [-1.9448465199502034, -8.971705642881766],
            [-1.948006488510994, -8.971141838153468],
            [-1.9499245626095032, -8.970371600587328],
            [-1.9927652025257703, -8.947107689337916],
            [-2.066679764486946, -8.907079983453482],
            [-2.065881776559659, -8.838247354257062],
            [-2.063730540578373, -8.737465646283335],
            [-2.0627900096807466, -8.701652348240623],
            [-2.0578051828258768, -8.554076433655247]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.71152048421408, "lat": 29.94465246066967 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48259"],
        "coty_name": ["Kendall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kendall County"],
        "coty_fp_code": "259",
        "coty_gnis_code": "01383915"
      },
      "bbox": [
        -2.066679764486946, -8.975699844565895, -1.6259707110354686,
        -8.554076433655247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1822748829186114, -8.384519912013145],
            [1.2058826658102437, -8.372801344416168],
            [1.211317442562281, -8.369670828264969],
            [1.2402657803032031, -8.354622999830896],
            [1.2545915143509452, -8.347825878921391],
            [1.296617085133721, -8.324849205242788],
            [1.3187345939546258, -8.31480136799704],
            [1.3594717396054388, -8.293554369405447],
            [1.3694297761395837, -8.288061639453035],
            [1.4590095418890687, -8.240385793318557],
            [1.4530943597261152, -8.23441175503313],
            [1.5169002779077525, -8.238122534464404],
            [1.5534666198841407, -8.236606659577385],
            [1.569812385723152, -8.286224431690515],
            [1.6050849293520442, -8.393413947929371],
            [1.646517164310467, -8.519847695300955],
            [1.650518338174228, -8.531298458321437],
            [1.6763353140130837, -8.609458506880515],
            [1.7251264035530114, -8.60891978749002],
            [1.8071248257573187, -8.606540505072866],
            [1.8069718387529572, -8.607529188973546],
            [1.8088865299243395, -8.686329484336808],
            [1.8131020384038963, -8.82760762399118],
            [1.770400812427739, -8.82831799529713],
            [1.7628974852618824, -8.82800804747723],
            [1.733127822027126, -8.828896243866355],
            [1.6432130076553888, -8.8313195808354],
            [1.5934686412542478, -8.832729998911708],
            [1.5138208073554815, -8.834782739445314],
            [1.4725352772038054, -8.83593473412501],
            [1.3997122246282931, -8.837633205605814],
            [1.3460954177199858, -8.839066820013871],
            [1.3421146673018796, -8.832904762265633],
            [1.3433570064417442, -8.829226261266248],
            [1.3402839146193124, -8.818892142008949],
            [1.332756106785549, -8.80574632546131],
            [1.3308248961618119, -8.804119491533926],
            [1.3357433550641171, -8.796173404070752],
            [1.332891005384451, -8.793898355100808],
            [1.3340348963868789, -8.786704541517738],
            [1.3363905712880033, -8.783300560536526],
            [1.3399625448980923, -8.771315260578962],
            [1.3455774885970189, -8.768560022361559],
            [1.3446826562687917, -8.759473282267262],
            [1.3423396228543973, -8.756261745380344],
            [1.3416259487986595, -8.75180604124231],
            [1.333012705373589, -8.74666236120422],
            [1.3331288046028187, -8.745057250268344],
            [1.3290512028269281, -8.733349671384588],
            [1.309896620670969, -8.728018261733332],
            [1.3056906187142985, -8.728229159855593],
            [1.301913052680697, -8.731646527036801],
            [1.2894811449167218, -8.696259185634242],
            [1.2650044012117936, -8.62340321684955],
            [1.2644087821007368, -8.622760495730828],
            [1.2435678942263408, -8.560078102883443],
            [1.2370859174773925, -8.54099016203776],
            [1.2179429103355808, -8.486364412787914],
            [1.2145405162602727, -8.477847757015986],
            [1.207910848708264, -8.45796296432548],
            [1.1822748829186114, -8.384519912013145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.81222210579661, "lat": 30.15162435031484 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48291"],
        "coty_name": ["Liberty"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Liberty County"],
        "coty_fp_code": "291",
        "coty_gnis_code": "01383931"
      },
      "bbox": [
        1.1822748829186114, -8.839066820013871, 1.8131020384038963,
        -8.23441175503313
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.740206569817512, -6.049830167228904],
            [-4.733232040669349, -6.050256692103914],
            [-4.603974522206675, -6.057930608315166],
            [-4.474715894288257, -6.065583927869305],
            [-4.356379124118721, -6.071954033061861],
            [-4.30302532172462, -6.075099107972644],
            [-4.319181203586095, -6.299625691424963],
            [-4.32281720650077, -6.3502300754385645],
            [-4.326774726278136, -6.4031958665486455],
            [-4.334623279012353, -6.511358105491547],
            [-4.402886153542893, -6.507867441850369],
            [-4.504775605467479, -6.50165686804202],
            [-4.56603424574932, -6.497979188593421],
            [-4.669879673109967, -6.491345374936715],
            [-4.769036928788125, -6.4850199937146575],
            [-4.762932865939298, -6.395105908972584],
            [-4.7533722295316405, -6.248904340860234],
            [-4.750078751808943, -6.197609309036262],
            [-4.741563933773445, -6.072933161545371],
            [-4.740206569817512, -6.049830167228904]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.9512766186935,
          "lat": 32.305994544790764
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48317"],
        "coty_name": ["Martin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Martin County"],
        "coty_fp_code": "317",
        "coty_gnis_code": "01383941"
      },
      "bbox": [
        -4.769036928788125, -6.511358105491547, -4.30302532172462,
        -6.049830167228904
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.497634913106566, -2.9488437980852633],
            [-4.367150763213613, -2.9570662455505468],
            [-4.33466587821116, -2.9592293511707664],
            [-4.103277903673067, -2.9733736685910634],
            [-4.063464089620738, -2.975598713893021],
            [-4.08462597531594, -3.332398743468384],
            [-4.089650035402572, -3.4150919689215646],
            [-4.157645694471345, -3.4110354955576576],
            [-4.200542747740538, -3.4082191619680144],
            [-4.240627468575467, -3.4061822029519155],
            [-4.300791642326959, -3.402684719423983],
            [-4.315617619471767, -3.4014652381169803],
            [-4.344441456557995, -3.399769546692651],
            [-4.358496313767476, -3.3986847486440035],
            [-4.432029904626116, -3.394021797314286],
            [-4.530004579707059, -3.387674449774063],
            [-4.528060795661044, -3.3621656031057534],
            [-4.515811831717041, -3.1975614420799428],
            [-4.5070428236824815, -3.071967438764227],
            [-4.506347465643468, -3.06943194915702],
            [-4.497634913106566, -2.9488437980852633]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.89392863598032,
          "lat": 35.40128687222311
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48375"],
        "coty_name": ["Potter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Potter County"],
        "coty_fp_code": "375",
        "coty_gnis_code": "01383973"
      },
      "bbox": [
        -4.530004579707059, -3.4150919689215646, -4.063464089620738,
        -2.9488437980852633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.039433027869333, -7.875055306754965],
            [1.0423061847930175, -7.872704665560149],
            [1.0445690575543045, -7.866820736212103],
            [1.0481254006902792, -7.865141483704206],
            [1.0509569424404004, -7.861509215318127],
            [1.0488511315298208, -7.8539283868850305],
            [1.053120574478462, -7.848857978360253],
            [1.053435917738501, -7.844004497093281],
            [1.0504373671586444, -7.839409135538689],
            [1.051637493361591, -7.836893882371693],
            [1.0619336205750265, -7.832413136520687],
            [1.0718403537297823, -7.831806801366579],
            [1.0796042691817884, -7.8332899142961026],
            [1.0863281250754728, -7.830688732625893],
            [1.10334275033612, -7.827718288841062],
            [1.1085871372290004, -7.830365852308379],
            [1.1157291308716464, -7.840352167935565],
            [1.1219885109870817, -7.847155433953575],
            [1.1146485798206383, -7.8632583052437885],
            [1.1116070523934918, -7.867257010548017],
            [1.1175259972331224, -7.875572452612527],
            [1.120143076606774, -7.888195858518251],
            [1.1221791813437343, -7.892709046668933],
            [1.1291454026887133, -7.897449508851989],
            [1.1345954985772069, -7.899987698446975],
            [1.1422429583477907, -7.901256870797002],
            [1.1486976460757734, -7.908963552748191],
            [1.1548499887719075, -7.909633124335545],
            [1.1581164311869725, -7.914603457535766],
            [1.165711977627722, -7.914918333931853],
            [1.1667295515613312, -7.919345250992922],
            [1.171231104337871, -7.9256400922417365],
            [1.1767948318116908, -7.930099926352161],
            [1.1864545698654512, -7.932971136908714],
            [1.1929110094303135, -7.940406174233208],
            [1.199766201704008, -7.943896381844559],
            [1.2020652540515275, -7.948133079244155],
            [1.208158404210362, -7.95101561020698],
            [1.2012022035667738, -7.956545975687491],
            [1.2048981275180126, -7.964184763881597],
            [1.2082760549321119, -7.973140694695913],
            [1.2059760471152263, -7.982326292635023],
            [1.2035978521131157, -7.985475382958637],
            [1.1968746484230612, -7.98851922462793],
            [1.1958292898939025, -7.991978797740665],
            [1.1987867220902757, -8.00041355020104],
            [1.1981680080600359, -8.007139493997922],
            [1.195885566842155, -8.009994281294363],
            [1.1951410702317256, -8.014989644368246],
            [1.1965857349381588, -8.018541816899495],
            [1.2025127640929931, -8.025021092296164],
            [1.2054166569065916, -8.032934702504857],
            [1.2053793216936763, -8.038300498411484],
            [1.2077118733179806, -8.038689427521092],
            [1.2191573303878545, -8.035434443234081],
            [1.2265326430594445, -8.036983521806],
            [1.227548271628014, -8.039157992562947],
            [1.2228929217628655, -8.043636256884556],
            [1.2191327731348567, -8.05453811537508],
            [1.2196710418532848, -8.056220594715963],
            [1.2257229264336298, -8.057985235879201],
            [1.2262201678020113, -8.061757400676516],
            [1.2220990700352923, -8.067351794836304],
            [1.223165522827644, -8.07070667782031],
            [1.2283344448129714, -8.073538179841133],
            [1.231916646044058, -8.073729161959168],
            [1.2398746919672934, -8.07087052841374],
            [1.2432065390664475, -8.067360210831083],
            [1.2437236482273606, -8.06084013139792],
            [1.2459297963240183, -8.059518927989584],
            [1.2533262242300909, -8.062156102917033],
            [1.2582824840455222, -8.058842848931413],
            [1.2638324831210004, -8.057907697847146],
            [1.269665639160079, -8.053031730614766],
            [1.2748053248416602, -8.051188600251173],
            [1.2757214748391876, -8.060045507170443],
            [1.2817182827158076, -8.059689382551316],
            [1.2885726564291073, -8.055426306888325],
            [1.292345391503653, -8.056935901316884],
            [1.2924577996067994, -8.061199930147838],
            [1.286332411861709, -8.065704080675042],
            [1.2883823818828704, -8.068216582430948],
            [1.3008804889434689, -8.070451775152303],
            [1.3048555643764697, -8.076384316458164],
            [1.3106371059929296, -8.072661675028579],
            [1.3140978899492548, -8.076214991575997],
            [1.3106670177601674, -8.082224213022684],
            [1.3036418511533527, -8.07999950090696],
            [1.3008020227139492, -8.081096330420602],
            [1.3040598208295267, -8.094269902952746],
            [1.308175779553972, -8.09638438069533],
            [1.308580345099438, -8.103547430760214],
            [1.3145176591380268, -8.10286907918276],
            [1.3151048318974707, -8.12429087522385],
            [1.3114619819617737, -8.125106381127905],
            [1.308765245501272, -8.12943564840296],
            [1.3031630737517532, -8.1301606825945],
            [1.3010689479995394, -8.133193518541296],
            [1.2951935802099674, -8.133190465816591],
            [1.2976831136237938, -8.138825122011918],
            [1.2922550140036622, -8.142190915087715],
            [1.2921617690616132, -8.144825196020864],
            [1.2981295923173946, -8.151871137046331],
            [1.303328291702756, -8.153007998259334],
            [1.3108590148777164, -8.152622422593165],
            [1.3184428788073963, -8.150037915469609],
            [1.327300220907967, -8.15091501232351],
            [1.3352929945409222, -8.153809462725466],
            [1.352177245242371, -8.153190763414184],
            [1.3593365509354978, -8.157517579763267],
            [1.3656536179681404, -8.158672076910676],
            [1.374240292870817, -8.169931712990689],
            [1.3793905204981445, -8.171741849591932],
            [1.3853606156832137, -8.171279519962862],
            [1.399831238356473, -8.167617401057505],
            [1.4080028452070745, -8.171542328086739],
            [1.4178342293165822, -8.172523500578649],
            [1.4213200786632305, -8.175836393560804],
            [1.427840433371827, -8.179062101197546],
            [1.4302922712196944, -8.182590964509988],
            [1.4456095247811016, -8.181898203646183],
            [1.450302461545374, -8.18406344377802],
            [1.4580741823239072, -8.182176508573777],
            [1.4688255163274506, -8.186549180935375],
            [1.4694615584657653, -8.188625709352324],
            [1.466431251408358, -8.19758081150715],
            [1.4626035692370558, -8.199525899490459],
            [1.4499986586093245, -8.203897357899907],
            [1.4466161509240292, -8.210131452314805],
            [1.437430078005473, -8.217535892445625],
            [1.4388753701022319, -8.23215586753725],
            [1.4433575302548405, -8.23402002785661],
            [1.4495305858484009, -8.2330608542091],
            [1.4530943597261152, -8.23441175503313],
            [1.4590095418890687, -8.240385793318557],
            [1.3694297761395837, -8.288061639453035],
            [1.3594717396054388, -8.293554369405447],
            [1.3187345939546258, -8.31480136799704],
            [1.296617085133721, -8.324849205242788],
            [1.2545915143509452, -8.347825878921391],
            [1.2402657803032031, -8.354622999830896],
            [1.211317442562281, -8.369670828264969],
            [1.2058826658102437, -8.372801344416168],
            [1.1822748829186114, -8.384519912013145],
            [1.1543325994635434, -8.39908095546351],
            [1.1310691782880706, -8.410163126758341],
            [1.1292718233928503, -8.403796458954291],
            [1.1340723877822092, -8.397457663731606],
            [1.1337705384361505, -8.39544428733748],
            [1.1391830160741554, -8.391714485391443],
            [1.1431267839262818, -8.391147020512738],
            [1.147450695340687, -8.383465038117166],
            [1.1500100848040768, -8.38193436798117],
            [1.1495643627003478, -8.377823844379362],
            [1.137312921117759, -8.373731884674969],
            [1.1349132127728092, -8.368438670239225],
            [1.1304086193796088, -8.367190503680167],
            [1.1281208543634487, -8.360872103083077],
            [1.1240917279576412, -8.35661133063063],
            [1.1209221778887715, -8.35072670173369],
            [1.116115159275219, -8.349840889386348],
            [1.109430557046041, -8.346949241766186],
            [1.1003014221285228, -8.347059656699953],
            [1.093459921903511, -8.344150050716808],
            [1.086173447253152, -8.337165896795167],
            [1.081940391862793, -8.335518332227526],
            [1.0770533575307415, -8.335482353343775],
            [1.0665076194506782, -8.32855005425494],
            [1.063483564073514, -8.328577000045483],
            [1.0594315177225107, -8.325547906678652],
            [1.054095681373896, -8.317121620166326],
            [1.0516106396553286, -8.31178164544646],
            [1.0406947319458284, -8.298178233866519],
            [1.0394101397291353, -8.293489405293235],
            [1.039978552298685, -8.288361192829182],
            [1.0350305657422352, -8.282084267555895],
            [1.0314574268146586, -8.272766086476027],
            [1.030264765916224, -8.267192396495577],
            [1.0265160185750637, -8.262999538978967],
            [1.0221783707169236, -8.255801644821656],
            [1.0226011582151426, -8.252385355672535],
            [1.0205794731918256, -8.247683393247224],
            [1.0201839510958188, -8.238444942836596],
            [1.0147187476726502, -8.227773198498705],
            [1.024792952725062, -8.107833633312632],
            [1.0268514572854772, -8.065331997128872],
            [1.0307420804322502, -7.995997554921754],
            [1.0317641630496084, -7.9837186307735655],
            [1.039433027869333, -7.875055306754965]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.16695660916629,
          "lat": 30.579510423067184
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48407"],
        "coty_name": ["San Jacinto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Jacinto County"],
        "coty_fp_code": "407",
        "coty_gnis_code": "01383989"
      },
      "bbox": [
        1.0147187476726502, -8.410163126758341, 1.4694615584657653,
        -7.827718288841062
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.004466274106275, -7.060896550431882],
            [-3.892777936583084, -7.064881306074146],
            [-3.8042540436751175, -7.068379435392907],
            [-3.663168069666102, -7.073149360511511],
            [-3.6584692408503914, -7.010730365738351],
            [-3.6522972412346664, -6.9308616866144135],
            [-3.6225426368086797, -6.941615021027588],
            [-3.5544639279164887, -6.946123296739226],
            [-3.401024709672862, -6.955009054961458],
            [-3.324835275574897, -6.958909581238771],
            [-3.2979382002352047, -6.960412163069023],
            [-3.1769567312429756, -6.966315982757767],
            [-3.123738413163198, -6.968413870105753],
            [-3.127519426376681, -7.073823125169491],
            [-3.1270178833488247, -7.078783726430638],
            [-3.121275420158466, -7.079884371825039],
            [-3.023231129150111, -7.08523221998391],
            [-3.026153087131896, -7.137784599403218],
            [-3.0278634249487535, -7.175873926551585],
            [-3.032515357664534, -7.265274341169738],
            [-3.040266473261772, -7.425230331345927],
            [-3.047992526419169, -7.574669957744364],
            [-3.161542985054657, -7.56897859628663],
            [-3.163222149256656, -7.569152000775412],
            [-3.2194496438723688, -7.566821541125032],
            [-3.3863097926793353, -7.559907505590706],
            [-3.5314315459215053, -7.554242262019152],
            [-3.5371288725133625, -7.55360813462272],
            [-3.529971445862621, -7.394028139405616],
            [-3.5301789142295523, -7.392850210402835],
            [-3.528018143310035, -7.336415265543174],
            [-3.526160714073469, -7.295456043256919],
            [-3.522687857076662, -7.204076619407765],
            [-3.519129601169742, -7.118591312732813],
            [-3.6551871948617713, -7.109893449931252],
            [-3.791242452356646, -7.101166779312913],
            [-3.8913255207200352, -7.095341857146641],
            [-3.9914075829450573, -7.0895013681681],
            [-4.006279743365491, -7.088513247982393],
            [-4.004466274106275, -7.060896550431882]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.462126958959, "lat": 31.404419151385706 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48451"],
        "coty_name": ["Tom Green"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tom Green County"],
        "coty_fp_code": "451",
        "coty_gnis_code": "01384011"
      },
      "bbox": [
        -4.006279743365491, -7.574669957744364, -3.023231129150111,
        -6.9308616866144135
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.3996023969205446, -5.903607723257616],
            [0.481380367170644, -5.90439212311304],
            [0.5184969297520987, -5.904887671159224],
            [0.5258455913645261, -5.9127821272768895],
            [0.524262051407296, -5.91935004306008],
            [0.5265368804984437, -5.91979860283314],
            [0.5284599049342174, -5.9261514727430145],
            [0.5373665536397879, -5.930744863860269],
            [0.5430749003328192, -5.9324485326252905],
            [0.5416566123320424, -5.935248772392463],
            [0.5483912893691344, -5.940030009672974],
            [0.5513678786636558, -5.938252660101576],
            [0.5564348321406056, -5.947297637640743],
            [0.5647007756108825, -5.952843982358682],
            [0.5688772270610928, -5.954680687555103],
            [0.5761615706593597, -5.961087493565278],
            [0.5774467260283225, -5.965020894952874],
            [0.5826020904526211, -5.9635925926408735],
            [0.5868761739972596, -5.9700606928564905],
            [0.5945075111981464, -5.97276802504879],
            [0.6015584639635504, -5.970218806914453],
            [0.6059180863250766, -5.972991658862263],
            [0.6178667080148537, -5.976482348604904],
            [0.6243248911422135, -5.974066363530473],
            [0.6295468808429879, -5.967860350961102],
            [0.6333448455725489, -5.969463257785661],
            [0.6355885972832737, -5.96619966938429],
            [0.6450657694845298, -5.970314985755666],
            [0.6492964958858303, -5.96844225321123],
            [0.6508946495938946, -5.970951892453903],
            [0.6597696534429597, -5.970334281065994],
            [0.6620064105959421, -5.971368322399126],
            [0.6615699531910968, -5.975981856910763],
            [0.6631094702408004, -5.979221712579749],
            [0.6607399660230651, -5.982371189578382],
            [0.6626722048055435, -5.986495452153282],
            [0.6675011786019533, -5.985946018097035],
            [0.6692936760315994, -5.9840684991212285],
            [0.6767844141031718, -5.986399036394077],
            [0.6812614805693662, -5.986813180947942],
            [0.6866894587189369, -5.989120346081984],
            [0.6892436441243479, -5.993559289382817],
            [0.6950338596948593, -5.993698810607884],
            [0.6974751997913196, -5.995960758570663],
            [0.7117072108239695, -5.999934683095135],
            [0.7148613434857911, -6.003683492859432],
            [0.7219698507899512, -6.004489198061026],
            [0.7242800085422386, -6.013296391068905],
            [0.7308526827956286, -6.013389740984573],
            [0.7340691939598947, -6.018570981981489],
            [0.7384726721642986, -6.021018912331487],
            [0.7368913919833255, -6.02328117984312],
            [0.741076488975146, -6.027038149666241],
            [0.7447047176236634, -6.026038122454906],
            [0.7489366769933747, -6.030120597984683],
            [0.750355034608774, -6.0277346822941205],
            [0.7543236990239645, -6.027897417830829],
            [0.7580445987726464, -6.0223907904709435],
            [0.7642139890294946, -6.023111116037149],
            [0.7672523423262005, -6.016945273651339],
            [0.768998395529702, -6.0212262841873905],
            [0.7693454713928396, -6.0246832530316485],
            [0.7733764747238443, -6.024559700376543],
            [0.775887284332342, -6.027504012412086],
            [0.7763526861375506, -6.032879081181626],
            [0.7829257161501394, -6.0338774573323075],
            [0.7937936563427896, -6.039098071901771],
            [0.7950180856137093, -6.045216921761827],
            [0.7972968577565855, -6.044574255901349],
            [0.8024625146302924, -6.05110346704297],
            [0.8029939635961544, -6.054454145894215],
            [0.8032899877265977, -6.085603770536999],
            [0.803693361856871, -6.155567753175833],
            [0.804084978306039, -6.2616022976996675],
            [0.8221332952853508, -6.279932332530899],
            [0.8261740284738777, -6.279836218826899],
            [0.8320718914022963, -6.283752422921542],
            [0.8328210375062114, -6.285688008615564],
            [0.8390866969867554, -6.288070717624131],
            [0.8390792642510291, -6.290932272185736],
            [0.8450530784980526, -6.299516486534637],
            [0.8489694598864804, -6.301782515057168],
            [0.8506041179569344, -6.308239966965985],
            [0.854284217798961, -6.308941726294292],
            [0.8593022320904365, -6.312967763900703],
            [0.8631610068501999, -6.319083929944459],
            [0.8693193616122535, -6.320472173313638],
            [0.872248310577194, -6.3245017783262965],
            [0.8777838187504616, -6.326287262653552],
            [0.8795326798758478, -6.330442522042294],
            [0.8821881843559847, -6.331813814535124],
            [0.8818928533634318, -6.339344280016036],
            [0.8860239917772231, -6.343050078682787],
            [0.8888801578612764, -6.351364064718714],
            [0.8950477222406614, -6.354826616091798],
            [0.8985555493799824, -6.360253624098243],
            [0.9058187583911714, -6.367635259088682],
            [0.9086469474263908, -6.372083114426564],
            [0.9173127643747356, -6.373734295584637],
            [0.9203526337464014, -6.372622953862862],
            [0.9233728334635476, -6.378283134595313],
            [0.926293358091783, -6.380896207441746],
            [0.9265649115457074, -6.385535760774241],
            [0.8732621018523405, -6.385924006242869],
            [0.7967533661825357, -6.38609765124372],
            [0.733940390681253, -6.38569196060122],
            [0.7141393031045395, -6.385851021844257],
            [0.6536737101814183, -6.385634019158718],
            [0.5915824059473067, -6.38514232005596],
            [0.48508472636547706, -6.384976408812994],
            [0.39996936577973047, -6.384573265121955],
            [0.40007397714897575, -6.361007549628027],
            [0.40002850021182124, -6.2420761240454326],
            [0.4003928951948953, -6.235280811281213],
            [0.40015182502507557, -6.1512003519377885],
            [0.40018636435771576, -6.091523844490708],
            [0.4000263485813459, -6.029364505440059],
            [0.39974235509731, -5.918454701121824],
            [0.3996023969205446, -5.903607723257616]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.83652908674757,
          "lat": 32.563674395321804
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48467"],
        "coty_name": ["Van Zandt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Van Zandt County"],
        "coty_fp_code": "467",
        "coty_gnis_code": "01384019"
      },
      "bbox": [
        0.3996023969205446, -6.38609765124372, 0.9265649115457074,
        -5.903607723257616
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.160701666084481, 1.866766343330964],
            [14.260404829820757, 1.8104685340499849],
            [14.340359573778285, 1.765477233615973],
            [14.334371926401802, 1.7534204423090065],
            [14.331101020338526, 1.7506584166573063],
            [14.327185500248465, 1.7306586900005378],
            [14.327216896888043, 1.7222159735110978],
            [14.32416871763168, 1.709472126428137],
            [14.315929388663362, 1.7070275354952293],
            [14.313579888436278, 1.7044096303468423],
            [14.308403621880773, 1.689454753380138],
            [14.306063723117989, 1.6797144365310523],
            [14.302157503902645, 1.6763838844561727],
            [14.297689830464812, 1.6681909707037277],
            [14.290786637050365, 1.6599622995932652],
            [14.284577294972786, 1.6548885713797417],
            [14.283191135060994, 1.6494246061872972],
            [14.275943496975012, 1.6410782233835994],
            [14.264975573260328, 1.6362800415859537],
            [14.261948591565112, 1.6283784547233928],
            [14.26040486362805, 1.622945669158151],
            [14.254795271815858, 1.6163390362921677],
            [14.249674232708635, 1.6143843906862543],
            [14.244011057012374, 1.6072198234253507],
            [14.244682143440595, 1.6040898038443194],
            [14.240592369607766, 1.5963322747934385],
            [14.237612494178439, 1.5924666797365647],
            [14.236639445105732, 1.588280711731253],
            [14.209687705447516, 1.6059450722691342],
            [14.203860206051663, 1.6094856559716564],
            [14.20208478640001, 1.6119750863588653],
            [14.190426575102704, 1.6170121065511827],
            [14.18996835584726, 1.62060200689145],
            [14.160220487582713, 1.60808708365974],
            [14.114457397300257, 1.6237350579080778],
            [14.116813435169925, 1.649283556189794],
            [14.118392893878251, 1.6632539251771103],
            [14.121895177303998, 1.667462982654964],
            [14.122296513045887, 1.6728997416963676],
            [14.124406202362957, 1.6796466478602967],
            [14.1286471618237, 1.6846994291300457],
            [14.133241493835813, 1.6840956028432184],
            [14.13609523447219, 1.6933147053447253],
            [14.13254435118569, 1.696447874569454],
            [14.137813015023125, 1.6980994298903846],
            [14.135714526436912, 1.7035667962071075],
            [14.13527076272665, 1.7093338838938723],
            [14.132270100338346, 1.7135969450893591],
            [14.137797102737615, 1.7249824611049094],
            [14.140857809482505, 1.7385192202805635],
            [14.139654831894063, 1.7411150440942054],
            [14.140293851176027, 1.7468973587271044],
            [14.139337540901138, 1.7512208525237978],
            [14.140967823610218, 1.7562521533078694],
            [14.139203386469688, 1.7591887653196474],
            [14.14475334330443, 1.7643542864890303],
            [14.1416589308687, 1.7674429393335356],
            [14.147071782298905, 1.7754950779812235],
            [14.14299636130925, 1.7842746676965113],
            [14.141915607813997, 1.7899878215876697],
            [14.14483504752402, 1.7925511323319276],
            [14.145667832244444, 1.8026327993110391],
            [14.144559638691717, 1.8094562657611708],
            [14.149731825109967, 1.8176748021491496],
            [14.147877904260879, 1.8230459942063624],
            [14.14906180695254, 1.8266405751577912],
            [14.15499808539743, 1.8301207876366115],
            [14.154985094534995, 1.835175783315231],
            [14.159158482131271, 1.8377895872753363],
            [14.156401073714393, 1.8415917462200535],
            [14.159024918365821, 1.8475051311846307],
            [14.158776392631449, 1.8592512205320044],
            [14.158095096905932, 1.861962520314875],
            [14.160701666084481, 1.866766343330964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.99673115079496, "lat": 39.112279050677 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51043"],
        "coty_name": ["Clarke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarke County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01690562"
      },
      "bbox": [
        14.114457397300257, 1.588280711731253, 14.340359573778285,
        1.866766343330964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.557465516044921, 0.3448209613277461],
            [13.562628226002078, 0.3471491263624097],
            [13.566123550680187, 0.34413863627719543],
            [13.572722079828619, 0.3479528751302412],
            [13.578216139640345, 0.35324296988946235],
            [13.583296547895008, 0.35437099499038177],
            [13.585749406246043, 0.3602333653929313],
            [13.593255184158723, 0.3642671028088017],
            [13.594996341862887, 0.36327175859436234],
            [13.599379003598687, 0.3666005705948111],
            [13.599484755910952, 0.369413332644822],
            [13.60480079628499, 0.3737598553308518],
            [13.614206550740132, 0.37846919647048727],
            [13.62136744375309, 0.3792327767908831],
            [13.625874311778487, 0.38431273457417015],
            [13.634926776422798, 0.37834982355248664],
            [13.638266224471527, 0.37181227750271345],
            [13.638321507492781, 0.36855007127469785],
            [13.642174862969359, 0.36696887173973275],
            [13.644447657510543, 0.3603489203119112],
            [13.649275648074285, 0.362221109414001],
            [13.664737154305506, 0.3654325091234801],
            [13.666383768772551, 0.3613810987943443],
            [13.67576001925549, 0.35644205490981395],
            [13.68021273447484, 0.3640720634945937],
            [13.684001131053629, 0.3676417717162772],
            [13.68728338154281, 0.3731818016896694],
            [13.687959483802748, 0.3795916876339378],
            [13.690351312718256, 0.3840924469450792],
            [13.697123674761144, 0.3919100423679744],
            [13.707052049057642, 0.3980109456433774],
            [13.70469221610238, 0.4017354600474551],
            [13.705346310634992, 0.40725006776024564],
            [13.708164554670892, 0.4139616582005126],
            [13.714195480925392, 0.42358998928858776],
            [13.724037840838006, 0.42498937711445656],
            [13.729700423753117, 0.42898378080577826],
            [13.730194168876029, 0.4326840864226434],
            [13.738352855108866, 0.4332204007284231],
            [13.744471443251072, 0.43845886255388045],
            [13.741474138066202, 0.4470145114281009],
            [13.742172719484772, 0.45333975407243665],
            [13.745123095158743, 0.46031793195929166],
            [13.744757173600032, 0.4670254159405127],
            [13.73755671275243, 0.4632934783076165],
            [13.73344337309898, 0.46668179763907197],
            [13.733913707996441, 0.4728740684497342],
            [13.732640060269922, 0.47548549005270796],
            [13.739473775967674, 0.48478413961189165],
            [13.74274891034199, 0.4844573152760688],
            [13.745597890405486, 0.48716505251908093],
            [13.74493683988662, 0.4901474850171759],
            [13.748003255013147, 0.4992821701257886],
            [13.746289889879058, 0.5094147551433018],
            [13.750737971838412, 0.5209486163198978],
            [13.75865837458841, 0.521573803498839],
            [13.762553793481436, 0.523931365030444],
            [13.763638012865131, 0.5306551465153554],
            [13.767005015540555, 0.5333200854213815],
            [13.774057206784024, 0.5444424681762995],
            [13.791950113678386, 0.5185406155701978],
            [13.80854758237249, 0.4938473197891279],
            [13.858503476364262, 0.42333700021458653],
            [13.8871088808666, 0.38189735699212035],
            [13.891330295191581, 0.37486272144338995],
            [13.900471864230202, 0.36186372165534175],
            [13.915022217055222, 0.3420907934425047],
            [13.932911364577862, 0.31630629651432646],
            [13.935992366806703, 0.30871481228362596],
            [13.938750273346514, 0.30464634870487683],
            [13.942769813473417, 0.30202508854609394],
            [13.938147965292227, 0.2984454810936176],
            [13.936223940747185, 0.2931923412465798],
            [13.938174435467998, 0.2908644097115875],
            [13.942662188059417, 0.2945485961644936],
            [13.951343571162797, 0.2865897679355956],
            [13.958277883059536, 0.28260573140706235],
            [13.955476103763717, 0.2796842718608428],
            [13.951292294648646, 0.2813096433365899],
            [13.94647632072656, 0.28120869954725297],
            [13.945493444519292, 0.27757755136536943],
            [13.947328432733404, 0.272867836838754],
            [13.947939697290176, 0.25820884126813504],
            [13.950136932464039, 0.25569646692294656],
            [13.958108413213573, 0.25193384397221413],
            [13.962061093289975, 0.24887970374273927],
            [13.96896675256695, 0.24693103795390184],
            [13.971674614179275, 0.24744189761607163],
            [13.97158810433246, 0.2539064321660063],
            [13.975072521799081, 0.25757872694092404],
            [13.981226530523154, 0.2598085191502242],
            [13.981045124369661, 0.24864464136712527],
            [13.977680050740863, 0.24442730470908103],
            [13.976553190401235, 0.23887961683692027],
            [13.977836392724363, 0.2341022556822306],
            [13.977311730861015, 0.22916171572486507],
            [13.979340052789773, 0.22594201354823001],
            [13.987910506486639, 0.22095219590631396],
            [13.992257012390516, 0.2136024510515257],
            [13.991707342025629, 0.21027444099731749],
            [13.985118622380355, 0.20399851078037223],
            [13.978691990521309, 0.2025281335776443],
            [13.975173605378556, 0.2043671612184526],
            [13.96894229407109, 0.21364659591233992],
            [13.962387933181349, 0.21849968969868258],
            [13.958553147184471, 0.21984869199317625],
            [13.951040181657314, 0.21867115551324504],
            [13.948759742650267, 0.21547892523287954],
            [13.950120681664448, 0.2089527146163418],
            [13.955309812679594, 0.20456895812997014],
            [13.957062084268754, 0.19893627183688584],
            [13.953772651122499, 0.1951474417018816],
            [13.94423809971082, 0.1923657199657656],
            [13.941071507765727, 0.19014035296610884],
            [13.938224029591627, 0.1843802334217783],
            [13.936429792630584, 0.17809523379085818],
            [13.940846151678304, 0.1666921444039515],
            [13.943583639475642, 0.16349825602734142],
            [13.945032728650151, 0.15863205697546487],
            [13.943451087913708, 0.15382248504023918],
            [13.93831016900174, 0.15010310932101129],
            [13.932620089002809, 0.1489537645575972],
            [13.926174738847726, 0.14540847838870663],
            [13.918471627828719, 0.14697173770001393],
            [13.905670358632188, 0.14677945018782365],
            [13.899023889363066, 0.1478217454064747],
            [13.891335385853532, 0.1463987547501141],
            [13.886705739396385, 0.14894694153520924],
            [13.87715018652531, 0.1470994128817296],
            [13.873114856649593, 0.14396212437051065],
            [13.8700220902664, 0.13943093950576693],
            [13.863015746363054, 0.13414670089883415],
            [13.861908402999354, 0.13148068200227359],
            [13.863074528895394, 0.1237894815815754],
            [13.865918159523721, 0.12017525869528511],
            [13.875650371674226, 0.11212619381490094],
            [13.87635057393053, 0.10568429389785858],
            [13.871307347076108, 0.10055350962883079],
            [13.863670770086683, 0.09607966449336512],
            [13.86155934372652, 0.09148534829599238],
            [13.861980849269202, 0.08781864828289877],
            [13.86523090298634, 0.0823013824879559],
            [13.872246364872696, 0.07752652637082943],
            [13.878192528438623, 0.07461696594565598],
            [13.880934294701284, 0.07102434734312137],
            [13.879908860098888, 0.06661163602925167],
            [13.873490868371674, 0.061539971015914734],
            [13.874323145513669, 0.054809210095589846],
            [13.87787863794241, 0.04714401516758342],
            [13.877313448950249, 0.03975244803960745],
            [13.872987014525117, 0.03721707756676787],
            [13.867339311671023, 0.03669702672157326],
            [13.860298088818848, 0.03766814416599477],
            [13.85185216722437, 0.04239203444504114],
            [13.847700578515974, 0.042355637838788235],
            [13.842226229116342, 0.03822621091507992],
            [13.842209835890895, 0.04227558001504636],
            [13.837357252748816, 0.044375276931462676],
            [13.836302348326425, 0.04159243212959336],
            [13.83130259716875, 0.042788109119682456],
            [13.82905759070294, 0.040688888499013906],
            [13.825081041324115, 0.040762593365510726],
            [13.821861516983176, 0.03560113128293649],
            [13.817473578365627, 0.03883555772064127],
            [13.776150474970576, 0.10214429198718214],
            [13.755629171327794, 0.13306764642469363],
            [13.753012958240538, 0.1352186288505199],
            [13.746036693337594, 0.14858069472002167],
            [13.739985422930229, 0.15146639124487715],
            [13.742545329530886, 0.1580423834510779],
            [13.738325561296381, 0.1605435683099705],
            [13.736367035762855, 0.1587398533492751],
            [13.728833824024473, 0.16179405381701803],
            [13.728951920474147, 0.16587207163113205],
            [13.723620727758032, 0.16920924401316442],
            [13.72441942681487, 0.17432780259168934],
            [13.7158104347356, 0.17904981327210104],
            [13.714281946994191, 0.1766881958291024],
            [13.708678564815651, 0.17346075002212716],
            [13.702342513658309, 0.1773810307569071],
            [13.700726353356746, 0.18003825789000846],
            [13.694907343770845, 0.1783583285707737],
            [13.692478869261837, 0.17559877448591665],
            [13.688501898051003, 0.17512314502817117],
            [13.683199596580897, 0.17988912433814452],
            [13.679561658282477, 0.18109326519521954],
            [13.666667832870905, 0.18098942095224518],
            [13.65727663227259, 0.18756282751864256],
            [13.658730153646111, 0.19271477391913633],
            [13.653656432443817, 0.19753373282992853],
            [13.65377222928572, 0.21369647819917836],
            [13.650281771757491, 0.2228257519805906],
            [13.646013151773106, 0.22862295060150645],
            [13.646500371300556, 0.2333483950515498],
            [13.64864121757145, 0.23577569261397005],
            [13.646520757432755, 0.24149172669617705],
            [13.640969014569208, 0.24711031101095401],
            [13.63746999971911, 0.24720294425522576],
            [13.627818012275878, 0.2516587896860429],
            [13.620342884655951, 0.24711083889055332],
            [13.616873202057088, 0.24902055259337683],
            [13.612778535118965, 0.24555284385946752],
            [13.606618689982547, 0.24891382890216593],
            [13.603312475781157, 0.2543457773032416],
            [13.603631391713295, 0.2588094945472663],
            [13.60087229334257, 0.2617224751054941],
            [13.595671636100949, 0.2605050893749056],
            [13.591712181689578, 0.2645243930716589],
            [13.58929447787595, 0.26496591311587353],
            [13.587030294648194, 0.27052256088083004],
            [13.58287314748622, 0.2695536244102704],
            [13.57141612054166, 0.2610655498248888],
            [13.56697323615859, 0.2592349944492447],
            [13.561760752801545, 0.25541023780167915],
            [13.564774429320897, 0.26204314155727393],
            [13.565482640417526, 0.2696484620452888],
            [13.569625765919897, 0.273881312818009],
            [13.56756744399127, 0.2761051249592618],
            [13.56915433088866, 0.2891850952286097],
            [13.565638253476877, 0.2919284977476196],
            [13.56879741546816, 0.30042538996886065],
            [13.568266250277961, 0.3032796649935105],
            [13.573686074711665, 0.31191626674380807],
            [13.572764586626024, 0.31602502163429863],
            [13.56943328854016, 0.31734647334734284],
            [13.566813723377555, 0.3220373638176772],
            [13.569507203259649, 0.3257094844112608],
            [13.567881645320513, 0.3312042425778724],
            [13.5650922531183, 0.3316103146367124],
            [13.562940526220006, 0.3356248676962992],
            [13.562531703686782, 0.34082775906717744],
            [13.557465516044921, 0.3448209613277461]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.88684027324491, "lat": 37.78737233932968 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51125"],
        "coty_name": ["Nelson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nelson County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01500936"
      },
      "bbox": [
        13.557465516044921, 0.03560113128293649, 13.992257012390516,
        0.5444424681762995
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.040848908692928, -0.22651179477380365],
            [14.041857312046893, -0.22311019945376084],
            [14.040373496960921, -0.21626310930254122],
            [14.043622015302807, -0.20572018995600466],
            [14.048452553292448, -0.19529891460588497],
            [14.050961737597731, -0.1917300213051077],
            [14.052962360484022, -0.18515901777818763],
            [14.056500751270358, -0.17767253208330777],
            [14.062008895088326, -0.16975623657630245],
            [14.0649431220415, -0.16293405142893425],
            [14.06748738677665, -0.1502566306989659],
            [14.069682434092426, -0.14593956649718343],
            [14.079220545708727, -0.13791374030503856],
            [14.081209549450259, -0.1338221668837324],
            [14.080723853161619, -0.1300765244236084],
            [14.086625681349934, -0.12640454633835227],
            [14.086688716549812, -0.12360065165369986],
            [14.09067349719601, -0.11853525870402905],
            [14.085374077441863, -0.11538417216451625],
            [14.084112692819046, -0.1131592226961701],
            [14.080959035833478, -0.06588039204292018],
            [14.085494853958789, -0.06853597377136059],
            [14.092674491531389, -0.07034292672615557],
            [14.088765560786387, -0.07480861496059066],
            [14.086510625823093, -0.08309497321953264],
            [14.090317407712064, -0.08489858616838943],
            [14.096417350863101, -0.08418401371434792],
            [14.10322343214659, -0.09450654880792904],
            [14.108786125318856, -0.0937900877409248],
            [14.113202344140495, -0.0962088577540338],
            [14.123904341238868, -0.10385675435268667],
            [14.126313939372585, -0.11038184281014546],
            [14.134564612118137, -0.10473060139829345],
            [14.145802990272689, -0.11028890157658125],
            [14.148067395693246, -0.11400280826395778],
            [14.15726093970104, -0.12100110441754046],
            [14.161386015900042, -0.11804962980403697],
            [14.167401336652947, -0.11594243134769364],
            [14.174258728504045, -0.11875910153601132],
            [14.175836596818494, -0.1167425195591136],
            [14.17658417820993, -0.10827393568760717],
            [14.181971065068405, -0.11260271567477813],
            [14.18596688689495, -0.1118965650975562],
            [14.188245997400765, -0.10388663208523521],
            [14.191806115194707, -0.10514834119299184],
            [14.198335698595463, -0.10951656905944986],
            [14.200690733200313, -0.10792945234885293],
            [14.207701956302314, -0.10728967062113644],
            [14.213018899465109, -0.11396149708413969],
            [14.22335493938683, -0.11281602945601588],
            [14.231396321022403, -0.11484143296301867],
            [14.234948174064112, -0.11300556175070522],
            [14.236853514700403, -0.11700776726543673],
            [14.244931233590698, -0.11978941205336283],
            [14.249859942421876, -0.12744024430487724],
            [14.252260255514178, -0.12916436056524222],
            [14.256619126443326, -0.12627736930719693],
            [14.262091434485335, -0.1245599994466425],
            [14.270726275736363, -0.12347142017247097],
            [14.275321599536241, -0.11965316564578858],
            [14.278013864544095, -0.11915082262077772],
            [14.282933948740986, -0.1232263293852787],
            [14.285888630156967, -0.11539099198785145],
            [14.289921347713415, -0.10813261646746032],
            [14.29695653758112, -0.10903966358483211],
            [14.297122600120067, -0.11460708066778875],
            [14.29904401610098, -0.11650107009498438],
            [14.307908293263244, -0.11477815957541848],
            [14.312498625015186, -0.11013305127452094],
            [14.314971998172805, -0.10577417752595514],
            [14.315363286542512, -0.10123389863029032],
            [14.32232273490936, -0.09594238830292022],
            [14.328244062106522, -0.094721675707733],
            [14.325474310405843, -0.08700791516861017],
            [14.328987921203039, -0.0822898024427381],
            [14.334264744657135, -0.08286999480336284],
            [14.335875324524618, -0.07703370684888301],
            [14.335296798438186, -0.07101535685088328],
            [14.339134908751372, -0.06849596821149107],
            [14.350695193861103, -0.07207227737128367],
            [14.35173274143523, -0.06774936284046497],
            [14.350974281334924, -0.06219852475583451],
            [14.346987934627629, -0.05905978550113484],
            [14.347307807769761, -0.05441205601580162],
            [14.356838343668505, -0.054235173875224536],
            [14.362468924412488, -0.04843738908082891],
            [14.364489758378719, -0.043501623221991595],
            [14.380923371468633, -0.1142646570511828],
            [14.394567698937543, -0.2157358967864167],
            [14.406970094489093, -0.2851340121218859],
            [14.407678748501919, -0.29020381553920194],
            [14.40070187288654, -0.29736030367822913],
            [14.393265813524835, -0.3013472828047594],
            [14.388727114121343, -0.302483754400895],
            [14.383727748508068, -0.311418475947594],
            [14.376244194873054, -0.31520165730527394],
            [14.36958033775339, -0.3174896218560595],
            [14.367192013614375, -0.31565873776033115],
            [14.363711250954706, -0.31948746039111686],
            [14.355046090326583, -0.3211420578172345],
            [14.352732839065444, -0.3187171571525895],
            [14.339661749363946, -0.32052012422899334],
            [14.335864255666872, -0.3221660757929058],
            [14.330814163994958, -0.3217664380422917],
            [14.325794192426535, -0.32377617166722017],
            [14.316779272097026, -0.321695827394574],
            [14.310310032596881, -0.32706986125202653],
            [14.309935545957696, -0.3325007334430769],
            [14.302422364359277, -0.34145769295859524],
            [14.291366964683146, -0.34707086999011977],
            [14.281970214140502, -0.34886667952869904],
            [14.272091400347481, -0.35608576130491537],
            [14.25668061440038, -0.36041831100540167],
            [14.253537728663002, -0.3622380701165213],
            [14.244691929367095, -0.3565201585918285],
            [14.241767414936655, -0.35651245763333667],
            [14.236256116918401, -0.35907752186034075],
            [14.23098975138065, -0.3583548836153745],
            [14.22667247108811, -0.3600360513739404],
            [14.219848208979021, -0.3550880290178366],
            [14.208015048879126, -0.3436642214677995],
            [14.205186393917675, -0.3424141308906339],
            [14.205004051656818, -0.3342644505665822],
            [14.197006710961096, -0.32333103579380584],
            [14.191013449656863, -0.31772843669569584],
            [14.18500230219898, -0.3153105776818925],
            [14.179190679845386, -0.31144511696331556],
            [14.175972465508005, -0.31118684611544417],
            [14.168395819460086, -0.31357349132571277],
            [14.166248275167812, -0.31147477045421496],
            [14.163422369199193, -0.3049534728182171],
            [14.151396742192661, -0.30775379591004554],
            [14.143588953129939, -0.3120775375854055],
            [14.141002626048856, -0.3180346988577894],
            [14.136265124530333, -0.3197743824581916],
            [14.126687645342475, -0.31581345106906555],
            [14.125471707560136, -0.3113026265664497],
            [14.122105747680456, -0.30959487647694556],
            [14.117869962925871, -0.31188645511992824],
            [14.107799479013572, -0.30799316753496364],
            [14.104985567789404, -0.30821168429522616],
            [14.100917997242341, -0.3018621729685153],
            [14.091448258456769, -0.2979782112199253],
            [14.08630089888646, -0.28595741244954803],
            [14.086653590827828, -0.2811042196693442],
            [14.083603088948248, -0.2765387869751745],
            [14.079477262418578, -0.2752800085367319],
            [14.074948054676046, -0.2765413174124947],
            [14.067440744904452, -0.27691022677098237],
            [14.06203021058409, -0.2752068145487264],
            [14.050888337288447, -0.2775225778685615],
            [14.047458389930293, -0.27951697999988995],
            [14.046094123522753, -0.2758123291592174],
            [14.042897394415787, -0.2749134023480119],
            [14.040440116940214, -0.2717354549663871],
            [14.041848762538395, -0.26311445942007505],
            [14.039320672834249, -0.25473485776355137],
            [14.042064024791786, -0.23807081803515265],
            [14.040848908692928, -0.22651179477380365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.44101175999955,
          "lat": 37.224284078086995
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51147"],
        "coty_name": ["Prince Edward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prince Edward County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01492359"
      },
      "bbox": [
        14.039320672834249, -0.3622380701165213, 14.407678748501919,
        -0.043501623221991595
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.989246057285625, -1.0583859080894402],
              [11.003661408167249, -1.0618409570296121],
              [11.002048499023577, -1.0680567740725029],
              [11.007290795941026, -1.07685528527511],
              [11.012707606646922, -1.0715927553659939],
              [11.01218041595277, -1.0698688694419969],
              [11.026526031788949, -1.0673622636240265],
              [11.029350064418612, -1.0686912368392911],
              [11.030245252386152, -1.061139683052066],
              [11.025204373230778, -1.0587046597433103],
              [11.021302782712661, -1.0515636711995107],
              [11.020570844353061, -1.045778224205107],
              [11.022535619021697, -1.0425012162128633],
              [11.02706938694092, -1.0393830178103831],
              [11.038445789576636, -1.0363336491366975],
              [11.043830970648619, -1.0357587882845816],
              [11.042176493118294, -1.0304550177926128],
              [11.038270893957062, -1.026412944330117],
              [11.041796670490434, -1.0244318590749457],
              [11.043068630840365, -1.020104304400486],
              [11.038802025013329, -1.0154487500586749],
              [11.02895554217625, -1.0141531904412175],
              [11.028436947378095, -1.0209267353186173],
              [11.02140972622911, -1.0171563340815468],
              [11.015927945309317, -1.019271847571087],
              [11.016197943073887, -1.0219161778512298],
              [11.012739788824325, -1.0239527006478037],
              [11.007669638724456, -1.0236498961296285],
              [11.005062542224323, -1.0312038223120172],
              [11.000418932648772, -1.039247429790719],
              [10.999582546489302, -1.0446449540217304],
              [10.99593084144977, -1.0463856561099631],
              [10.993892318684999, -1.0507437462974212],
              [10.994728896078632, -1.0551573664261151],
              [10.989246057285625, -1.0583859080894402]
            ]
          ],
          [
            [
              [10.820363109578068, -1.0275654979822222],
              [10.821190717023368, -1.0240502545591765],
              [10.824460806365543, -1.021091222810439],
              [10.8294088815074, -1.0212997929143905],
              [10.83094350847481, -1.0148860419498065],
              [10.837971958742031, -1.0152997830857418],
              [10.842580244217235, -1.0113807818695102],
              [10.847755204755147, -1.0041175789766308],
              [10.848497775251818, -0.9998389407699941],
              [10.84687693006516, -0.9965952156929015],
              [10.847776346782341, -0.9916158174938617],
              [10.852624538517736, -0.9925490642815085],
              [10.857629374871166, -0.988723294482956],
              [10.859590294472774, -0.990361820763946],
              [10.869444062807093, -0.9863105976229083],
              [10.871589255389924, -0.9842676419185448],
              [10.87534045240031, -0.9879868183976497],
              [10.878526304742548, -0.9848205380079134],
              [10.88380410268069, -0.983998488128655],
              [10.886559550991063, -0.9764392866224466],
              [10.890862891932349, -0.9753911835321364],
              [10.894046129695294, -0.9674117341818337],
              [10.899117368119354, -0.9623918027269956],
              [10.908179733306945, -0.9632809035003047],
              [10.909424733081163, -0.9583912011121242],
              [10.909272717327486, -0.9466295699194671],
              [10.910013389853, -0.944911776251617],
              [10.916725150402126, -0.9423941528981621],
              [10.922799520120902, -0.9440149110661727],
              [10.925357504682363, -0.9405937617735157],
              [10.924372214728994, -0.9381682336641318],
              [10.923721867595894, -0.9277261159693302],
              [10.919291805620754, -0.9192528101014121],
              [10.917871942810551, -0.9131834015883326],
              [10.920082312894644, -0.9103177924867885],
              [10.92427747305733, -0.9095433654431188],
              [10.924636689541956, -0.9055798902686351],
              [10.919304528406546, -0.9007753273939006],
              [10.916835295700292, -0.8940744785736334],
              [10.918668158772235, -0.891365856545918],
              [10.917254256523943, -0.8799623544894203],
              [10.91298328541323, -0.8742793735350493],
              [10.912489561159294, -0.8702400438523982],
              [10.915096442234013, -0.865503814438392],
              [10.925472981286852, -0.8586200014354085],
              [10.934165759428234, -0.8512518772461098],
              [10.942208347411002, -0.8457126039194884],
              [10.948457145704944, -0.8457182874536089],
              [10.95454474264179, -0.8377379867052417],
              [10.962121920224444, -0.8335323457643673],
              [10.963450548336555, -0.8276579468728805],
              [10.965699700692905, -0.8260073383960942],
              [10.979554087111802, -0.8216451471595356],
              [10.985059338568806, -0.8120267675593901],
              [10.990148447097441, -0.8060061970732585],
              [10.99658726963592, -0.8000782407949393],
              [11.004485438914246, -0.7948367730887135],
              [11.00767355677517, -0.7910158599930377],
              [11.00757096127167, -0.7885258598710967],
              [11.017284898712816, -0.7813829832429043],
              [11.02683757747026, -0.7722797731584745],
              [11.034869927545124, -0.7642760016571866],
              [11.051974981412062, -0.8410815397627096],
              [11.057291103150455, -0.845327116673655],
              [11.099501116225891, -0.8972976054989438],
              [11.103838026712912, -0.9052553289026841],
              [11.10299993502417, -0.91092123656281],
              [11.106262775414221, -0.9166807101432148],
              [11.112699965575699, -0.9189444910795678],
              [11.119104623169155, -0.9238651455754346],
              [11.119102856315738, -0.9316134003116319],
              [11.121233776742747, -0.9353642295325472],
              [11.128558573064353, -0.9353345526424723],
              [11.182651409390468, -0.9639283747565537],
              [11.185367746145022, -0.9636758658326491],
              [11.191137195532939, -0.9669428609545607],
              [11.196435757556074, -0.9684485359211344],
              [11.203565974167777, -0.9665306792956019],
              [11.202576211997675, -0.969808959043678],
              [11.204486929189352, -0.9725739093625786],
              [11.209226020486401, -0.9707414477570957],
              [11.215765797988205, -0.9770525324089507],
              [11.216818281695375, -0.9830481585866995],
              [11.220057780115251, -0.9897407310212242],
              [11.223221529211358, -0.9872201253560942],
              [11.230524860457642, -0.9857339219926384],
              [11.244915395542735, -0.9705741853573536],
              [11.277286040182203, -1.0326676513116448],
              [11.272446252203547, -1.0342186508540019],
              [11.269550233026553, -1.0372480624664961],
              [11.264075269664168, -1.038168374401902],
              [11.264541902706622, -1.0526201067536787],
              [11.263148954920782, -1.0532758929389294],
              [11.258936464291887, -1.0475936251380071],
              [11.257336378421455, -1.0431240649155515],
              [11.254025641406846, -1.0431914701794096],
              [11.255706739933725, -1.0504758393016707],
              [11.247982311935647, -1.0533178793078488],
              [11.246687450681408, -1.0480328912364993],
              [11.244116268060035, -1.0467076055560398],
              [11.238288155131073, -1.051696801365191],
              [11.234321835822918, -1.0494284661798166],
              [11.231284681809191, -1.0523632622422456],
              [11.230582099279552, -1.0561907449980614],
              [11.226187033834611, -1.052366264010735],
              [11.223327678348086, -1.052849526165666],
              [11.213409173867307, -1.061222581931976],
              [11.208731868847398, -1.0628710628758526],
              [11.20687137898504, -1.067542251629276],
              [11.196818908815821, -1.0740368512859326],
              [11.199567456374641, -1.067718488704816],
              [11.197795303370336, -1.0644621830595038],
              [11.193893478559625, -1.0655451574624455],
              [11.080083704996348, -1.0849084469934005],
              [11.030618512761345, -1.093273894882874],
              [11.017600825560839, -1.09762863960272],
              [11.0095239074954, -1.1102072340519797],
              [11.006330697717306, -1.1214184731894048],
              [11.006162674446132, -1.1282748478039493],
              [11.004863061219266, -1.1332490438670657],
              [10.99686116260058, -1.1415276594708639],
              [10.994266382765444, -1.141594191526538],
              [10.98715545785254, -1.1500219740202016],
              [10.981608507637931, -1.1615639312745034],
              [10.976167611829824, -1.1661603589289522],
              [10.972523716953198, -1.166020052700701],
              [10.969288870279902, -1.1608973459466188],
              [10.963255523102031, -1.1620949775566252],
              [10.956316777322648, -1.1601971815069856],
              [10.95552456511035, -1.1540180390105101],
              [10.950941420157951, -1.157047536246946],
              [10.946973750571736, -1.1567110007292136],
              [10.943165447032673, -1.1598278459946019],
              [10.940316358118269, -1.1567335469588176],
              [10.937125462357457, -1.1582904485422005],
              [10.935073179354708, -1.1558231776684706],
              [10.930064897985533, -1.1629820832450664],
              [10.9244449062774, -1.1776925379684704],
              [10.92056996765857, -1.1813299554005394],
              [10.919090132648057, -1.1881023588798758],
              [10.921231557914584, -1.1909948165065796],
              [10.876993229139757, -1.1597328886261649],
              [10.86445303749983, -1.1501693732632678],
              [10.861411898173202, -1.1497716952034693],
              [10.857237024494307, -1.1520971245144553],
              [10.852880507807882, -1.148511841250436],
              [10.852530200973456, -1.1446581387584167],
              [10.8559123299278, -1.1411999078279755],
              [10.853859355742344, -1.1380134090416199],
              [10.848546421767411, -1.1348964638963444],
              [10.848939855788165, -1.1300463866587829],
              [10.839901758304794, -1.1249361365161448],
              [10.834270820989142, -1.1168818565329575],
              [10.828479694542784, -1.111378106877691],
              [10.824599021090577, -1.1099263306878753],
              [10.829742569857764, -1.1001006159553377],
              [10.82306854236673, -1.0946836496188046],
              [10.823741523273982, -1.0922888313113195],
              [10.82980120056083, -1.083550889883629],
              [10.834344670724166, -1.0755032057453124],
              [10.83536887479527, -1.0709902818125316],
              [10.831090932555531, -1.0616102482775487],
              [10.831077801471299, -1.0516664157024491],
              [10.833638880594952, -1.04784771563611],
              [10.82759761585252, -1.0432923331903419],
              [10.825563786907836, -1.0432500471653487],
              [10.823323132138885, -1.0383655568061305],
              [10.820749993644135, -1.0363627413652263],
              [10.820363109578068, -1.0275654979822222]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.62114116432178, "lat": 36.97527584847893 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51195"],
        "coty_name": ["Wise"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wise County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "01496656"
      },
      "bbox": [
        10.820363109578068, -1.1909948165065796, 11.277286040182203,
        -0.7642760016571866
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.388489160514162, 11.101235686159477],
            [-16.384845950182324, 11.092774335678742],
            [-16.379155662589937, 11.090790785222824],
            [-16.377568040109338, 11.086085255793973],
            [-16.37854582336777, 11.08290840042038],
            [-16.37725314293937, 11.075142481868562],
            [-16.380226629942086, 11.071322286703834],
            [-16.379571482390602, 11.067809890433889],
            [-16.375487375918794, 11.059384909351186],
            [-16.375326735686276, 11.051102302852206],
            [-16.372547358693232, 11.050216036761144],
            [-16.36751107951399, 11.043532619518437],
            [-16.364825869493735, 11.035226184365284],
            [-16.36184198075917, 11.031911861814827],
            [-16.35647506144647, 11.030452355941721],
            [-16.348663398714617, 11.021595673590628],
            [-16.348437041275403, 11.016365532205425],
            [-16.342810738433467, 11.012582468435944],
            [-16.338303254843954, 11.011077429080425],
            [-16.33214286639676, 11.006790654022351],
            [-16.33059524474955, 10.998870146426084],
            [-16.33459962428165, 10.993533587413136],
            [-16.32995907220771, 10.980298124870727],
            [-16.327839174140564, 10.977069352210254],
            [-16.321532203815522, 10.973288673422344],
            [-16.31605962434785, 10.966916653623425],
            [-16.315384566120937, 10.960517848084462],
            [-16.311132589545615, 10.95475623744508],
            [-16.31578481770599, 10.9505797946963],
            [-16.317533536930934, 10.945632166196093],
            [-16.30452064161586, 10.93808234292755],
            [-16.305758115202213, 10.933843065613418],
            [-16.301794345806606, 10.92806599185308],
            [-16.306525086132318, 10.914131936706655],
            [-16.30352003018082, 10.909197226585656],
            [-16.298218156393283, 10.903708148272818],
            [-16.293424570338356, 10.904081587789165],
            [-16.289120854129735, 10.902018887061775],
            [-16.286570398312083, 10.903049039522708],
            [-16.283470019517093, 10.896907251550902],
            [-16.280178077260018, 10.893526175795676],
            [-16.276851936239645, 10.88790225127257],
            [-16.268875485917235, 10.891147833454854],
            [-16.26520546289304, 10.885740493710363],
            [-16.259154120076488, 10.879574370712215],
            [-16.25428153397243, 10.88165399230481],
            [-16.253041480818432, 10.88449171116823],
            [-16.24637105667953, 10.888461562094092],
            [-16.237363827933187, 10.881977702163859],
            [-16.229336509084508, 10.882836140878435],
            [-16.228557402530093, 10.877196738840185],
            [-16.226269726011342, 10.873463101108486],
            [-16.227082841291658, 10.867970182288046],
            [-16.223695949379344, 10.863185629099249],
            [-16.22190368344088, 10.85742990358711],
            [-16.213026354327763, 10.855379113671544],
            [-16.205826333863197, 10.851505629656176],
            [-16.200465125746756, 10.846112831013503],
            [-16.19205930070291, 10.843955297334768],
            [-16.188266723310733, 10.836485649544423],
            [-16.190509042045566, 10.830446232078277],
            [-16.1897850772776, 10.821784024008386],
            [-16.187786385139955, 10.817644350108855],
            [-16.1833581830352, 10.815161462336983],
            [-16.18202835706975, 10.812527464784692],
            [-16.176863216438303, 10.811197409673854],
            [-16.173112111749546, 10.80621566653149],
            [-16.1727286182521, 10.80184857103869],
            [-16.168306004018522, 10.795896575653536],
            [-16.164915456562177, 10.794064987319455],
            [-16.16149084328615, 10.787267505542003],
            [-16.1587254511308, 10.78426358584231],
            [-16.154191469236306, 10.783957324300527],
            [-16.14916338086004, 10.780288212669898],
            [-16.14426691874743, 10.78076828784039],
            [-16.138679277785304, 10.77758482649995],
            [-16.134482400223792, 10.776730272631461],
            [-16.128343591959126, 10.778424782298764],
            [-16.122134906890757, 10.773537480651717],
            [-16.12161965903519, 10.770581520611929],
            [-16.116041582896273, 10.770699539601186],
            [-16.10834766904609, 10.765829649074217],
            [-16.103926062344264, 10.763976222946821],
            [-16.10539393117104, 10.75311661400571],
            [-16.101915323167642, 10.747124476759149],
            [-16.1025350176408, 10.741740319032589],
            [-16.104970843015646, 10.73742799140146],
            [-16.097458253398564, 10.73116202060545],
            [-16.094270557093434, 10.73254220451017],
            [-16.090665521578096, 10.730383748941643],
            [-16.08974719204702, 10.734507390840584],
            [-16.075714521649953, 10.735718458028572],
            [-16.076142775007806, 10.740405268437382],
            [-16.075033454911562, 10.748165459911148],
            [-16.07194518137578, 10.752143943249461],
            [-16.069175125242175, 10.750834660384276],
            [-16.067155863036955, 10.744616500362689],
            [-16.066355096410774, 10.736814803439502],
            [-16.06264639062965, 10.733611834766128],
            [-16.055307320896922, 10.731359968330672],
            [-16.050405190517488, 10.723525813613815],
            [-16.051715087479007, 10.720540081593866],
            [-16.047197788172948, 10.717119727966821],
            [-16.04384541858994, 10.717842318902779],
            [-16.038132035303363, 10.710235720371738],
            [-16.034829494154334, 10.708605657730375],
            [-16.029407924210844, 10.700750095474753],
            [-16.02940597536172, 10.695308980531134],
            [-16.02338551765595, 10.68660898628481],
            [-16.0228889839759, 10.683776955147813],
            [-16.019221761031446, 10.67820821029461],
            [-16.01363135040432, 10.67775080486672],
            [-16.00592984669705, 10.674632405224504],
            [-16.00180372409171, 10.668289766620061],
            [-15.99813122505836, 10.659351468801015],
            [-15.92635510223499, 10.641072151385703],
            [-15.912204885606167, 10.638158864151269],
            [-15.80319563543926, 10.610633546138704],
            [-15.806308355995442, 10.6038075573049],
            [-15.806653505157124, 10.591492703326502],
            [-15.805488474950025, 10.586052730759844],
            [-15.800822095277953, 10.574505165858655],
            [-15.798242473711644, 10.57162988232478],
            [-15.79090370744093, 10.568849014535957],
            [-15.77877473586041, 10.567778227259394],
            [-15.7622305047056, 10.564356675567602],
            [-15.758125252211611, 10.56070632280453],
            [-15.755906554640971, 10.556175716737382],
            [-15.75492378241107, 10.547982884394834],
            [-15.75924030844303, 10.539436450657337],
            [-15.760804401641012, 10.534402756566566],
            [-15.76255654532497, 10.521755452483278],
            [-15.770063393140514, 10.511422980868046],
            [-15.772861815429223, 10.501030229382186],
            [-15.770488432786708, 10.484467660191859],
            [-15.771932160494536, 10.4760005568532],
            [-15.77595416229638, 10.466329981871592],
            [-15.782803037357747, 10.459074912993552],
            [-15.786066525670766, 10.454446454124861],
            [-15.791009375177078, 10.454185636367335],
            [-15.798040406493257, 10.450817386368806],
            [-15.805523077164946, 10.440893653045475],
            [-15.812560556606465, 10.430249803540404],
            [-15.816093271105334, 10.423263249287057],
            [-15.817024586771392, 10.41703025759974],
            [-15.816646781500348, 10.410666396761513],
            [-15.814313486078207, 10.403400926132942],
            [-15.803569357329131, 10.385607516750698],
            [-15.802401345637687, 10.379547976706021],
            [-15.805734525931197, 10.362800732630816],
            [-15.804664842340907, 10.356360924801768],
            [-15.807301203607587, 10.34792903728429],
            [-15.80827847185083, 10.340580315832499],
            [-15.806057496453175, 10.326746758853709],
            [-15.802966624394779, 10.311433584311901],
            [-15.801292288742644, 10.305854488231619],
            [-15.798843521444597, 10.291476008686216],
            [-15.797351266071235, 10.286874466210707],
            [-15.798297547273531, 10.278711093309015],
            [-15.80097274339188, 10.271769593465367],
            [-15.801692719657233, 10.26322426928152],
            [-15.810760738163625, 10.235643312708305],
            [-15.817765374943018, 10.206571299073667],
            [-15.817847925322276, 10.203365611278056],
            [-15.813361751047793, 10.189125117461908],
            [-15.809632632660936, 10.180944040092681],
            [-15.805404239005489, 10.16893385107451],
            [-15.803240049959335, 10.160670328466335],
            [-15.803358885451361, 10.154969753514163],
            [-15.807799397793366, 10.142947410104071],
            [-15.824089778043327, 10.123033682428963],
            [-15.831192944309272, 10.1178213704445],
            [-15.83805447088891, 10.11494308260693],
            [-15.846917948356543, 10.108842062359045],
            [-15.849279128292913, 10.101663754390236],
            [-15.853393720364963, 10.09240889123871],
            [-15.921460117979244, 10.10995784865265],
            [-15.98953037780348, 10.127491510981384],
            [-16.05760447450218, 10.145009872413214],
            [-16.12568238272934, 10.162512927175658],
            [-16.17109646181745, 10.174321745504948],
            [-16.210621219867196, 10.184927400035875],
            [-16.19876602266773, 10.225455349607262],
            [-16.187614160829686, 10.267072691345337],
            [-16.26029349574212, 10.28693563012965],
            [-16.270651374635595, 10.289605545564347],
            [-16.259470780932904, 10.330846581171286],
            [-16.249890861964747, 10.365022333452917],
            [-16.24899704196251, 10.371479882503774],
            [-16.263049646750613, 10.37476577104475],
            [-16.36224685987864, 10.40027048372849],
            [-16.36845453202792, 10.401582186437523],
            [-16.438758355983037, 10.420317791416958],
            [-16.509066498736804, 10.439036757742285],
            [-16.5081100517696, 10.442453391139619],
            [-16.5116128880818, 10.443345625786659],
            [-16.510662625618632, 10.4467881450704],
            [-16.514166019717926, 10.44775272351369],
            [-16.51324290774415, 10.451139473431123],
            [-16.516738515441013, 10.452056543792143],
            [-16.513930900041913, 10.462346063432843],
            [-16.520898682382843, 10.46419887019314],
            [-16.519942432040995, 10.467644410653431],
            [-16.523439776906017, 10.46859090049076],
            [-16.52156964520976, 10.47540878881669],
            [-16.525047393434505, 10.476383720451889],
            [-16.524120469886633, 10.47976477817899],
            [-16.527602434663407, 10.480733921440132],
            [-16.52479934507116, 10.491030852146892],
            [-16.52829047324327, 10.49192553724511],
            [-16.527392385010227, 10.495324044271278],
            [-16.530855999825068, 10.496289687845563],
            [-16.52992108595513, 10.499656014717429],
            [-16.533435922785937, 10.500685139211066],
            [-16.53248531628694, 10.504014757665924],
            [-16.535956212156158, 10.504975616933589],
            [-16.530380879350247, 10.525506770904038],
            [-16.53749454256472, 10.52741382975306],
            [-16.539679881119955, 10.532761768660764],
            [-16.543236497623756, 10.533088197848341],
            [-16.550291975016847, 10.539982542362992],
            [-16.548886405187872, 10.54282426262007],
            [-16.55109696654298, 10.545256587721774],
            [-16.55136721447392, 10.549502182824678],
            [-16.553471939946125, 10.552853266156655],
            [-16.553793987743816, 10.55832089544062],
            [-16.55737849098473, 10.56208633001421],
            [-16.559834938750214, 10.567700585636977],
            [-16.56623328030231, 10.573666739050145],
            [-16.568741696639663, 10.580815684684552],
            [-16.576419658500864, 10.587476883696823],
            [-16.577109587498047, 10.592045949231554],
            [-16.582582713668057, 10.591623527240507],
            [-16.588346963271462, 10.599928927599713],
            [-16.59351327888081, 10.605673915459109],
            [-16.5965909957215, 10.615036657975612],
            [-16.5957812635143, 10.617893625258581],
            [-16.598119514874675, 10.620436917933992],
            [-16.602443957125605, 10.621222303880065],
            [-16.60682969300188, 10.628248918124175],
            [-16.611176894570587, 10.630678059931888],
            [-16.617244255957072, 10.638402474683351],
            [-16.61669097015241, 10.640769151800368],
            [-16.626278677437067, 10.645917191848412],
            [-16.630906747456358, 10.651382790513424],
            [-16.63824842566153, 10.65067407078919],
            [-16.645472293861495, 10.651693188283547],
            [-16.649684795829444, 10.649821739007647],
            [-16.654163882045594, 10.645636634921747],
            [-16.66554049871186, 10.646923779305991],
            [-16.670563227788406, 10.64894869658576],
            [-16.673378288005694, 10.653262630719244],
            [-16.677371449845253, 10.653712153112508],
            [-16.685184885584622, 10.648947759064255],
            [-16.689909527972688, 10.649445390136371],
            [-16.69108917576168, 10.65565902162848],
            [-16.69588789978932, 10.66145934169254],
            [-16.696556418126367, 10.667743332892162],
            [-16.697026310866907, 10.675554227602376],
            [-16.702840902935275, 10.674122103180883],
            [-16.708976146709855, 10.682317723240258],
            [-16.70607124765183, 10.684719392352227],
            [-16.706840793350853, 10.689713397795366],
            [-16.707254484434255, 10.70164660738137],
            [-16.7027396702963, 10.704152847296843],
            [-16.6996566578897, 10.707565395243673],
            [-16.695764050964154, 10.70927120674491],
            [-16.6940934682816, 10.712967346171212],
            [-16.69033686228832, 10.712743600665538],
            [-16.68457022863845, 10.714960418779617],
            [-16.679183670242644, 10.714375137090487],
            [-16.67241433175538, 10.716258464865236],
            [-16.665625431799224, 10.713199828720619],
            [-16.663582930291767, 10.709618316223263],
            [-16.656541754663717, 10.705159456546005],
            [-16.65515411274624, 10.702445138330447],
            [-16.64502271871703, 10.70235631536277],
            [-16.64207619800396, 10.700095902625723],
            [-16.632707760589955, 10.702750839151891],
            [-16.629914130939227, 10.70794007589449],
            [-16.62646294926858, 10.711118046189378],
            [-16.62842511858523, 10.724966080910473],
            [-16.632299022525583, 10.72980562365755],
            [-16.63330236188847, 10.737393355473946],
            [-16.621882501788587, 10.74925971202069],
            [-16.62067289869892, 10.754047994696215],
            [-16.622318914762015, 10.761268581117612],
            [-16.6198134821611, 10.76396807451651],
            [-16.62293825602333, 10.774277788747952],
            [-16.626808490950076, 10.779172229408218],
            [-16.63270431335036, 10.784034966524297],
            [-16.64008954955129, 10.785517100289441],
            [-16.65099575796987, 10.794397582329319],
            [-16.650729409488743, 10.7966464998462],
            [-16.64395222769954, 10.802488596267727],
            [-16.64292916431659, 10.80898825730136],
            [-16.63752882197051, 10.809088026590134],
            [-16.63219912166371, 10.811794544156605],
            [-16.62835345399568, 10.811244785680119],
            [-16.625642434733827, 10.815905746209467],
            [-16.62285117570335, 10.816779259594583],
            [-16.62024026706794, 10.82088572628035],
            [-16.62227346879561, 10.8231452651893],
            [-16.620374049448316, 10.843593224256823],
            [-16.621656808459402, 10.845340559726845],
            [-16.628121942063952, 10.84827713460646],
            [-16.631757452008213, 10.851736498160808],
            [-16.63047323965527, 10.856091377717165],
            [-16.63488659504469, 10.857216596561077],
            [-16.64045418749711, 10.852764762916879],
            [-16.643723215597817, 10.854988498170906],
            [-16.648071460750284, 10.854949962216516],
            [-16.651717742107884, 10.85688269883796],
            [-16.653068163079865, 10.859901485646555],
            [-16.65949100670758, 10.861419862176149],
            [-16.664487732538653, 10.864240106949188],
            [-16.665776699120663, 10.867874531302819],
            [-16.66929033116762, 10.866026404541133],
            [-16.6702111373804, 10.862746464026458],
            [-16.675100730690215, 10.866211149174951],
            [-16.6772774396763, 10.871956139238943],
            [-16.674496549644363, 10.882309567727757],
            [-16.681155918060373, 10.887253749343072],
            [-16.6808701901553, 10.889838565103112],
            [-16.674764152011576, 10.895139317415438],
            [-16.674650377730938, 10.899397144449182],
            [-16.67024165324886, 10.905018006620901],
            [-16.667181827681993, 10.905244996844074],
            [-16.665163330244713, 10.9091050665337],
            [-16.668089156874366, 10.919693326466001],
            [-16.672008188137184, 10.920742649245714],
            [-16.68207260378777, 10.934239574874432],
            [-16.679016187027212, 10.938157906872494],
            [-16.679955849983948, 10.94599721886621],
            [-16.677633330818246, 10.949401450210393],
            [-16.673901403362336, 10.950918835752875],
            [-16.670770501036714, 10.948828381808722],
            [-16.66084120317392, 10.949249906767184],
            [-16.66026089251295, 10.954576632823244],
            [-16.658188967267492, 10.959596653068749],
            [-16.650824635137496, 10.958924670326683],
            [-16.64784198410045, 10.96062035885158],
            [-16.647025864359392, 10.966738007262041],
            [-16.650202253268844, 10.970793305527515],
            [-16.646654105349313, 10.974224546863798],
            [-16.64159928171672, 10.975110525624924],
            [-16.639200850856273, 10.981683987351643],
            [-16.642272545579694, 10.986209250274529],
            [-16.640501787814244, 10.990035449371693],
            [-16.636745292592046, 10.990760762260798],
            [-16.63182542668952, 10.988925527489132],
            [-16.629268847013783, 10.989527829898103],
            [-16.62595075091807, 10.993684508356212],
            [-16.619774482063498, 10.996155374909845],
            [-16.609063053870162, 10.995616931130456],
            [-16.605613146788404, 10.998901032696784],
            [-16.606446612333038, 11.005456364520139],
            [-16.600784960222516, 11.00980791096599],
            [-16.59990805395307, 11.013306287780107],
            [-16.592788184933983, 11.01746760286125],
            [-16.58373899415253, 11.020107473260804],
            [-16.576619880640244, 11.018092745699583],
            [-16.56763225826641, 11.026858990284943],
            [-16.56392970877031, 11.023148839411412],
            [-16.558460280685036, 11.026006580855196],
            [-16.548965078344583, 11.025111370429224],
            [-16.54779075253641, 11.02821809058327],
            [-16.541769458487693, 11.029683467421243],
            [-16.537392693168854, 11.038409681670709],
            [-16.530685517581095, 11.042700139860251],
            [-16.526290487813643, 11.048485568172852],
            [-16.522119694180734, 11.055772012890557],
            [-16.516226251706975, 11.060201318962351],
            [-16.505910902718696, 11.057896968341819],
            [-16.500301632697692, 11.062131246963663],
            [-16.48922460536041, 11.066022268466048],
            [-16.4876621341217, 11.072845805872928],
            [-16.482034365403862, 11.07296835335501],
            [-16.479159463336426, 11.078180361253649],
            [-16.476387520174796, 11.087417248084016],
            [-16.472315650913053, 11.091544616300732],
            [-16.463460441688532, 11.093374002549144],
            [-16.458931940964813, 11.088350330919184],
            [-16.449692327300856, 11.086064891687975],
            [-16.44489271153514, 11.087394497537131],
            [-16.441815501082335, 11.082992218365826],
            [-16.43767210465832, 11.08365470560699],
            [-16.437181876508525, 11.086362483765969],
            [-16.433172319693018, 11.089286863264217],
            [-16.430108757365453, 11.094029523063806],
            [-16.431039406932783, 11.098505919109352],
            [-16.4288961935596, 11.100583577602075],
            [-16.428823435815683, 11.10465235022755],
            [-16.413520652538885, 11.105967013333231],
            [-16.40822044925498, 11.101260864893494],
            [-16.405619825836315, 11.103919161980137],
            [-16.394335986270498, 11.09676003032535],
            [-16.392162757228483, 11.100577370248766],
            [-16.388489160514162, 11.101235686159477]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.67989268568283,
          "lat": 47.12436432726646
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53037"],
        "coty_name": ["Kittitas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kittitas County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01531926"
      },
      "bbox": [
        -16.708976146709855, 10.09240889123871, -15.75492378241107,
        11.105967013333231
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.237603484518004, 1.6938405862213304],
            [12.242643592241969, 1.6959464959467632],
            [12.245468272299467, 1.6995675947868687],
            [12.25075303723875, 1.6980443694619436],
            [12.255371090009495, 1.7020831139347976],
            [12.25550759300713, 1.711004868508236],
            [12.253749817905234, 1.716924029144295],
            [12.25598273904013, 1.7205282623102514],
            [12.256827915975272, 1.727153178416659],
            [12.268062820241722, 1.7317050527524949],
            [12.270503920722275, 1.7319951941630236],
            [12.269047365559434, 1.7403973150585825],
            [12.323818728916361, 1.7369105697114902],
            [12.332021606144663, 1.7359749709432608],
            [12.352401570027059, 1.7349938416379642],
            [12.426091645373322, 1.7303161805646279],
            [12.429766169803864, 1.7288327731806492],
            [12.43408365456008, 1.733168000983175],
            [12.436847751405404, 1.730629792097119],
            [12.444450163369766, 1.7290260966460627],
            [12.49698194513731, 1.7056930548995677],
            [12.505713093406081, 1.7015564539974806],
            [12.502159308347785, 1.697598346445254],
            [12.501984705558831, 1.6928011757497836],
            [12.505261224271157, 1.6808925682096818],
            [12.517797569591867, 1.6063587903768484],
            [12.52090450767254, 1.5870216002078856],
            [12.524502171219186, 1.5793682488020941],
            [12.529697635967167, 1.5767443354798103],
            [12.534061422161832, 1.5773426456805533],
            [12.554302401338557, 1.5553027322384212],
            [12.5222597184349, 1.4773383474055686],
            [12.523814299205217, 1.4572192015337297],
            [12.526930425013964, 1.4480490122827494],
            [12.528904754183309, 1.4311157806694053],
            [12.529909917349238, 1.418694763745033],
            [12.52847339153852, 1.4200926365850635],
            [12.519829966687162, 1.41736891099666],
            [12.515534976239158, 1.4040266959215395],
            [12.476031230865749, 1.4005512198927546],
            [12.40736904574874, 1.409166667489626],
            [12.35581472923776, 1.4160323041048788],
            [12.350515147495374, 1.4159957487298906],
            [12.342409557729207, 1.42118953212608],
            [12.336222056083434, 1.4213011480002344],
            [12.33305701143729, 1.4186204115086016],
            [12.328420659080752, 1.4190894838307735],
            [12.326540352334689, 1.4214158834713102],
            [12.323137538669931, 1.418055147077405],
            [12.317999041044603, 1.4204316941174855],
            [12.311469191118887, 1.4199500261689109],
            [12.308945897019331, 1.4169893574135761],
            [12.303996335106044, 1.4151858601360607],
            [12.288858516328068, 1.4147316190698103],
            [12.287404893461275, 1.4165305101829753],
            [12.281863882351583, 1.416940983074199],
            [12.27831247305394, 1.424207371630634],
            [12.27330975425471, 1.4236705895210475],
            [12.266209247748957, 1.4245465653507055],
            [12.260804467275673, 1.4276337518218738],
            [12.25482862114824, 1.429388271751182],
            [12.24827119211605, 1.4293739492433402],
            [12.241325141111213, 1.4264751135192058],
            [12.245535041597638, 1.4314678599383621],
            [12.24208281203161, 1.4425813539666674],
            [12.245781908974156, 1.440795227727932],
            [12.251982402999381, 1.4400464539435378],
            [12.25586184264495, 1.4372430253154735],
            [12.265737377483738, 1.4425501593502612],
            [12.266196125354062, 1.4537034903162025],
            [12.268812298137748, 1.4566685943324078],
            [12.272568646569024, 1.45123589719268],
            [12.279300645959996, 1.4559665731406624],
            [12.280594001748542, 1.461830500283219],
            [12.28523354357552, 1.4617593710741004],
            [12.287860039241718, 1.4638085617540126],
            [12.28728054690958, 1.4707541464797227],
            [12.287871282559054, 1.4770194365778497],
            [12.283653574208868, 1.4798165946906945],
            [12.269881623159199, 1.4817891527916305],
            [12.265226203480703, 1.4785479181107484],
            [12.262030948457703, 1.4824638298092003],
            [12.255419388362215, 1.483651092330109],
            [12.252841689521016, 1.4920403512113607],
            [12.257407901685163, 1.4959728962226875],
            [12.260622827321356, 1.4926349266487333],
            [12.264823639949554, 1.4911573515943575],
            [12.267795380576707, 1.4937359928138527],
            [12.267437142398686, 1.500003710782391],
            [12.263355406466095, 1.5035725513638079],
            [12.260688386860128, 1.5026557552311546],
            [12.255743979158428, 1.5054678967435224],
            [12.253340142779098, 1.5102825639925874],
            [12.241803414105272, 1.5169838800529016],
            [12.236281169700733, 1.5175927811507965],
            [12.232804873688304, 1.5216003907999296],
            [12.232057249501404, 1.530299142748427],
            [12.236161335042675, 1.5331200413701898],
            [12.236471318551134, 1.5433692710370934],
            [12.233292164875952, 1.5447501076282115],
            [12.230288257730066, 1.5428066370782392],
            [12.225977653333702, 1.5451163170516404],
            [12.22171542285587, 1.545070939721129],
            [12.219280137461263, 1.5424713592529695],
            [12.21575732134764, 1.5439664923938847],
            [12.217127974395796, 1.5506305089240433],
            [12.222932953697185, 1.5641895681352094],
            [12.226575280008335, 1.563612298228984],
            [12.22635960830843, 1.5699026623516812],
            [12.228645567060802, 1.5734486265802126],
            [12.22770450223745, 1.5771047744498645],
            [12.232387290963864, 1.5765539366836583],
            [12.235594268267231, 1.5811344508256333],
            [12.240243522932355, 1.5837159831616117],
            [12.239531189279484, 1.58971033172043],
            [12.244094407680663, 1.5981007941027467],
            [12.242978851339622, 1.6006329821547844],
            [12.249851027090322, 1.6092121590037174],
            [12.25005312782127, 1.6168493721770814],
            [12.258020753864574, 1.6214268103839884],
            [12.25848862410392, 1.6267107581904785],
            [12.25438835001797, 1.630028082982055],
            [12.248162266723389, 1.6315192533267546],
            [12.247997348362052, 1.635450636989391],
            [12.250139777708789, 1.6386612032071757],
            [12.249573383776452, 1.6425175168524921],
            [12.246760363233578, 1.646394903579672],
            [12.248804948175632, 1.6488378116186568],
            [12.244480371586068, 1.6561822396194437],
            [12.24316398836231, 1.6608276085565432],
            [12.240713371298583, 1.6611446134960275],
            [12.239322150657673, 1.6681193402874466],
            [12.244793331105802, 1.675765467399998],
            [12.243584231289535, 1.6821185899895226],
            [12.24365836813986, 1.6881044581200668],
            [12.239838263896308, 1.6877559524381929],
            [12.237603484518004, 1.6938405862213304]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.3798982228115, "lat": 39.283540626990984 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54033"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01718426"
      },
      "bbox": [
        12.21575732134764, 1.4005512198927546, 12.554302401338557,
        1.7403973150585825
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.120684604132853, 0.003808365165583382],
            [11.13096856880332, 0.017087002737764933],
            [11.141196555210978, 0.03670769942720976],
            [11.15644576558596, 0.059594806008629764],
            [11.159094278489867, 0.06179614400365753],
            [11.16115389022498, 0.06816111178503567],
            [11.167140700298582, 0.07195776509381353],
            [11.178217044138243, 0.09016085349275604],
            [11.18406511445897, 0.09169583317878319],
            [11.187337741798467, 0.09614610669852217],
            [11.185467246617806, 0.10039988707528169],
            [11.18833396346835, 0.10302334172296844],
            [11.187653727174112, 0.1080103597585192],
            [11.19013019668971, 0.1105452479941695],
            [11.189791735414556, 0.11450351017520673],
            [11.193831423106207, 0.11924303430162249],
            [11.187060773310925, 0.12260442666601279],
            [11.183436495111241, 0.12090501305196188],
            [11.179837231382656, 0.12303548462640514],
            [11.177197773271816, 0.12792400684931374],
            [11.180844486600765, 0.12947844922393664],
            [11.179363752988085, 0.13483322638178635],
            [11.181028983886025, 0.13738101257257163],
            [11.169223695792928, 0.13964770131242946],
            [11.162979959413013, 0.13950169481924596],
            [11.15985794354191, 0.14550499178816712],
            [11.156268463459517, 0.14422213260553676],
            [11.155549243568089, 0.14832171632941632],
            [11.15275494781527, 0.14878778741308107],
            [11.151391746186887, 0.1601951485819633],
            [11.148949290447218, 0.1646312926189377],
            [11.144057750347667, 0.16895545410195664],
            [11.13908629262542, 0.1669341237545719],
            [11.137297763377413, 0.17044427864328338],
            [11.131179541794705, 0.1725526229312179],
            [11.126151555168313, 0.17913041755727319],
            [11.125902289571266, 0.18397088509924706],
            [11.12930499861999, 0.18726419048980306],
            [11.131598449281517, 0.19717308519407567],
            [11.125014332813626, 0.20189755043250038],
            [11.119069392783377, 0.20273164624046613],
            [11.116274461755431, 0.20455073850684777],
            [11.110821946296953, 0.20402539818951757],
            [11.107448773424505, 0.2073076958508878],
            [11.107891872927883, 0.21543033998681235],
            [11.110749394301283, 0.21551505070777421],
            [11.110542836418773, 0.2238749738893541],
            [11.114698716498179, 0.23333155765027982],
            [11.111201439854415, 0.23469135681404865],
            [11.10968806091634, 0.23864486236790433],
            [11.113649118260232, 0.24226179445755502],
            [11.110200178518424, 0.246580712694213],
            [11.112107046297334, 0.25020811787128555],
            [11.106394665527752, 0.2602408953866792],
            [11.104692201661317, 0.2688618691664582],
            [11.112761202164936, 0.2750856070019283],
            [11.110463686511984, 0.2812678261852148],
            [11.111261496648122, 0.29383017698977576],
            [11.113109788380893, 0.2992024065668511],
            [11.116106093644834, 0.30068253811977036],
            [11.112909558969381, 0.3051459080241839],
            [11.112529613490539, 0.31139999176840133],
            [11.117606818689358, 0.31812221989277195],
            [11.12057642320621, 0.315809804520771],
            [11.122576135333832, 0.32288216291338145],
            [11.120270592227271, 0.32476364958645987],
            [11.119702345739404, 0.3289545299896721],
            [11.121603456181491, 0.3307745078837566],
            [11.121402462675146, 0.335296475294959],
            [11.12324534294319, 0.3385275068460891],
            [11.128205173527148, 0.33915377291127613],
            [11.129101480382019, 0.3421765379189391],
            [11.133384720249506, 0.34432605412189393],
            [11.138499262159597, 0.35008936339631],
            [11.141694406854038, 0.3513744040067692],
            [11.14231780752539, 0.35481883990377777],
            [11.145296029208104, 0.35821035998311646],
            [11.144196860175846, 0.36355540904831474],
            [11.144115104198733, 0.3724729276561692],
            [11.141488713791192, 0.3750588470600321],
            [11.140661709428823, 0.38138556927938594],
            [11.15122627593425, 0.3830941602595723],
            [11.149456487440569, 0.38820431674239403],
            [11.150668172670532, 0.3958109399514218],
            [11.15555202017834, 0.4011597057113993],
            [11.159319334527405, 0.40319602318603176],
            [11.162204903642257, 0.4141189590824078],
            [11.167805702773334, 0.410778657958749],
            [11.171221059896538, 0.4112802194219487],
            [11.176998945593697, 0.41431753688520884],
            [11.179813304219264, 0.4173522425566947],
            [11.186775074063, 0.42098871428884327],
            [11.192111583768853, 0.42044456392504104],
            [11.195978734281846, 0.4238530707999416],
            [11.199376326238417, 0.42319093555185683],
            [11.201238016037781, 0.4270061891198827],
            [11.205340347049223, 0.42537934821501067],
            [11.209465699331474, 0.4273804051322568],
            [11.208752496363623, 0.431997991309069],
            [11.212521951691585, 0.4413405227362138],
            [11.215878779243457, 0.4444384451280441],
            [11.219943992169638, 0.4508662246870661],
            [11.225464793906202, 0.45106636704765246],
            [11.227525347450863, 0.4530175085033735],
            [11.232363351043146, 0.4535686684786362],
            [11.23807578972612, 0.45986715521599725],
            [11.240552018298901, 0.45972741899860103],
            [11.243253138496131, 0.4636875006317575],
            [11.24660857885949, 0.4617180362822246],
            [11.25422647480649, 0.461682104054779],
            [11.257381906757185, 0.4634888375772034],
            [11.260141714389466, 0.4494809209362005],
            [11.262442193528559, 0.4418929422200359],
            [11.265969721004494, 0.4268338226007704],
            [11.26801288091654, 0.38332896348301837],
            [11.26847744603935, 0.37929418297536077],
            [11.275421518179328, 0.37543370057960596],
            [11.278509591206477, 0.37697365009080186],
            [11.285910589691644, 0.37066538183740677],
            [11.292389627071172, 0.3741790845350978],
            [11.29575958121323, 0.3722101315255674],
            [11.296101995579034, 0.36461290883969155],
            [11.301895848552343, 0.36621493075017514],
            [11.308206973186019, 0.3652726591306302],
            [11.311551313614336, 0.3614435723306463],
            [11.3155150201492, 0.3645636250426747],
            [11.315002448196193, 0.371314000409561],
            [11.321829217732915, 0.3732762696867675],
            [11.365977443019776, 0.4297698397148834],
            [11.390206777846922, 0.4223160291893974],
            [11.42049942840981, 0.425404301030474],
            [11.423174661735114, 0.42705958308359443],
            [11.42504806181694, 0.43191520469737055],
            [11.431409231585722, 0.43643187843824505],
            [11.441802962053968, 0.43209671571625474],
            [11.448121423772298, 0.42477971436867806],
            [11.449018490019029, 0.41689258640566024],
            [11.453998131589504, 0.41104097695948344],
            [11.455088071520576, 0.4033788856190888],
            [11.453650036614713, 0.4019861890339811],
            [11.457836142767075, 0.38762752928080635],
            [11.456823455227086, 0.385741259051197],
            [11.46172910586251, 0.38153904730688915],
            [11.460611376223438, 0.37665615776997535],
            [11.456684851746902, 0.3733338649655992],
            [11.463661311248224, 0.36638578706716896],
            [11.457802586082424, 0.35662135487031305],
            [11.45971628721513, 0.35225987364935707],
            [11.462324086405376, 0.3504648355677759],
            [11.461404763545954, 0.3443292885978929],
            [11.468163388827156, 0.34086225511771373],
            [11.468647978069553, 0.33849459123623943],
            [11.463286378471, 0.33662176711036507],
            [11.457020850173318, 0.3408383751441192],
            [11.453119632848722, 0.33923692816531764],
            [11.456762437100345, 0.3344725070973749],
            [11.444421255122526, 0.33662823387026114],
            [11.442534153117183, 0.3319898193526728],
            [11.446989825565629, 0.3276921501589364],
            [11.446169052796408, 0.3233077453310471],
            [11.442209519435432, 0.32297876369150824],
            [11.440725436466623, 0.31883800415862984],
            [11.44277606291825, 0.31431898762290716],
            [11.439229985584412, 0.31193962957760774],
            [11.438289709278886, 0.30354088654869926],
            [11.435798083144745, 0.29647180997173084],
            [11.442823932098376, 0.29826917583978413],
            [11.446542629657879, 0.2940556392757263],
            [11.44259203594216, 0.29231908175533516],
            [11.438128307923556, 0.293152489186564],
            [11.437196952536635, 0.2862204491939204],
            [11.428813916591585, 0.28465744434197443],
            [11.427926714892914, 0.2866697914221327],
            [11.421433818907152, 0.28618423645597896],
            [11.423558966654541, 0.27400155744573246],
            [11.411494333790303, 0.27434309078760344],
            [11.412657892450474, 0.2713171998641987],
            [11.41114838171383, 0.26757185938775474],
            [11.412865498873279, 0.25879246568641334],
            [11.419406115493334, 0.25858462700360424],
            [11.419863528250389, 0.2527135932682791],
            [11.422560417813079, 0.25097405235655446],
            [11.422120905514905, 0.24580805900299055],
            [11.417528873288925, 0.2453751221959357],
            [11.4126464048892, 0.24961727527909086],
            [11.40705442060867, 0.2474630269038323],
            [11.402186828008372, 0.24735842894561724],
            [11.397325493919304, 0.2498382413249227],
            [11.392811730579897, 0.25377408840806837],
            [11.38841976577167, 0.25214348170899853],
            [11.384011003454493, 0.25402386239990987],
            [11.378862282551797, 0.2524994505038087],
            [11.37791715535702, 0.2483767495810418],
            [11.379311956111477, 0.24122348183169312],
            [11.371938195134222, 0.238622723916351],
            [11.370644132458198, 0.22916581462597166],
            [11.372182855941379, 0.2266874353518085],
            [11.369425143876466, 0.22403470184084767],
            [11.367332256107082, 0.21829062475100594],
            [11.374715815461798, 0.20976768897291992],
            [11.374373290002005, 0.20508050382513882],
            [11.370804752540224, 0.19821001504837082],
            [11.36347327252206, 0.18850935702569369],
            [11.365584673259251, 0.1848203967105492],
            [11.364098159686163, 0.17793052568159143],
            [11.361500270477158, 0.17604134061849713],
            [11.362670324831837, 0.17072786911054957],
            [11.364702054076028, 0.16856143688224973],
            [11.360350606980893, 0.16214104443270042],
            [11.363098998410736, 0.16071100168680327],
            [11.362211783174454, 0.15242701832748284],
            [11.364336127456582, 0.1460078387727797],
            [11.372254236980277, 0.14187977181833836],
            [11.376712137475867, 0.142490096506619],
            [11.378276315410892, 0.1394456864238105],
            [11.387753655985176, 0.13798515635080194],
            [11.391265139041549, 0.13886882309993792],
            [11.395375301176582, 0.13649309485459007],
            [11.398503168169025, 0.13854305739892947],
            [11.401204896250595, 0.13689893909095982],
            [11.407317884380687, 0.13969688658121834],
            [11.408808654597081, 0.1365990822166935],
            [11.415309492206891, 0.13516833371445272],
            [11.405329398563284, 0.13167723175952076],
            [11.40040990578739, 0.13134764231673288],
            [11.397388385557154, 0.1279157660295769],
            [11.380272431707093, 0.12119419595738988],
            [11.37819675277894, 0.12304761742258737],
            [11.370595558291063, 0.12175338949181069],
            [11.369342003154355, 0.11800597105245748],
            [11.365952228098813, 0.1171671346890601],
            [11.363525261269027, 0.12062258926729093],
            [11.358589229151699, 0.11830673952364294],
            [11.354401151841927, 0.1209107485598699],
            [11.347041711789007, 0.1152987986853712],
            [11.340697892267757, 0.11446287560077818],
            [11.335837826765367, 0.11560943938667925],
            [11.333255373593527, 0.11335646743999567],
            [11.332719460885055, 0.10970304661351167],
            [11.328171953526034, 0.11036867491254358],
            [11.323371326294346, 0.1066085325723582],
            [11.312481337879806, 0.10448670479185619],
            [11.298574116852317, 0.09695882746392073],
            [11.298073029378694, 0.09391640057548903],
            [11.292523534748783, 0.09399126607028077],
            [11.253709912911322, 0.07363612714704613],
            [11.23355980981876, 0.06195586254722302],
            [11.205568308033676, 0.04795229102835166],
            [11.120684604132853, 0.003808365165583382]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.07034605129815, "lat": 38.17535964585425 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54043"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01550028"
      },
      "bbox": [
        11.104692201661317, 0.003808365165583382, 11.468647978069553,
        0.4636875006317575
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.421848808453317, 0.800866071400326],
            [11.440585874420195, 0.807054609369347],
            [11.488560887867848, 0.7553880147679757],
            [11.482084891757752, 0.7459171653389641],
            [11.475833899323222, 0.7328294372244232],
            [11.46831840931079, 0.7214741132498909],
            [11.465218548890103, 0.7231762222409094],
            [11.460048674662582, 0.7233962570881908],
            [11.457242573124864, 0.7177091213946407],
            [11.45244106821828, 0.7137589234235763],
            [11.452467447284091, 0.7084693319422877],
            [11.44992764615176, 0.7039389544414268],
            [11.453440625515878, 0.7003838928490201],
            [11.459235083466062, 0.6822239631521275],
            [11.458101742886907, 0.6783674127566638],
            [11.46068013986425, 0.6767605695857765],
            [11.460543545913575, 0.672745162663437],
            [11.458494882106773, 0.668791192183744],
            [11.460724545156218, 0.6661605044048574],
            [11.459752490156244, 0.6575615494276632],
            [11.461067975213, 0.6462486968121496],
            [11.464322631620664, 0.643517508044998],
            [11.469895985287467, 0.6413226860778669],
            [11.472347633300348, 0.6374584119828944],
            [11.469727073952647, 0.6342326338869806],
            [11.47567120516456, 0.6290887736990407],
            [11.480040289402467, 0.6286884545627525],
            [11.478447029281687, 0.6248416343464095],
            [11.481065560826984, 0.6165625289558285],
            [11.484414208202761, 0.6119221532924098],
            [11.488383535773979, 0.6012811372063198],
            [11.491874710184584, 0.6009271337092742],
            [11.492097451876177, 0.5939021127916015],
            [11.45377882340903, 0.5669548039971708],
            [11.427711365673517, 0.5508294408387711],
            [11.42320626325159, 0.5503604287805915],
            [11.421315107764745, 0.5443468962690129],
            [11.411323738460244, 0.5418934991598992],
            [11.41068898915964, 0.5382050941461803],
            [11.405794561571895, 0.53800555993546],
            [11.40102929854298, 0.533372966271041],
            [11.380867177677041, 0.5166298034062903],
            [11.366591697742745, 0.5043667010708076],
            [11.366044960411209, 0.4598269629480771],
            [11.365977443019776, 0.4297698397148834],
            [11.321829217732915, 0.3732762696867675],
            [11.315002448196193, 0.371314000409561],
            [11.3155150201492, 0.3645636250426747],
            [11.311551313614336, 0.3614435723306463],
            [11.308206973186019, 0.3652726591306302],
            [11.301895848552343, 0.36621493075017514],
            [11.296101995579034, 0.36461290883969155],
            [11.29575958121323, 0.3722101315255674],
            [11.292389627071172, 0.3741790845350978],
            [11.285910589691644, 0.37066538183740677],
            [11.278509591206477, 0.37697365009080186],
            [11.275421518179328, 0.37543370057960596],
            [11.26847744603935, 0.37929418297536077],
            [11.26801288091654, 0.38332896348301837],
            [11.265969721004494, 0.4268338226007704],
            [11.262442193528559, 0.4418929422200359],
            [11.260141714389466, 0.4494809209362005],
            [11.257381906757185, 0.4634888375772034],
            [11.250565126102892, 0.49231919547801456],
            [11.236458927214755, 0.5625856502588662],
            [11.226076797707574, 0.6139589980406823],
            [11.209537177238394, 0.6948045630577768],
            [11.23970000962033, 0.7190196238324125],
            [11.28546337547228, 0.756453286369458],
            [11.345395880536014, 0.7759794201948785],
            [11.349448866608373, 0.777082438448512],
            [11.421848808453317, 0.800866071400326]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.90899325327644, "lat": 38.50863981322198 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54079"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01550046"
      },
      "bbox": [
        11.209537177238394, 0.3614435723306463, 11.492097451876177,
        0.807054609369347
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.907718429315548, 1.822189355216731],
            [11.914368248689508, 1.8313084306924403],
            [11.919571482662507, 1.8347800589424674],
            [11.925558161961252, 1.8370727309317951],
            [11.934171710656598, 1.8381731124674565],
            [11.945018240037848, 1.8381987934978596],
            [11.953314569849178, 1.8435645286209443],
            [11.955578153135425, 1.8504443302843694],
            [11.957431095752952, 1.8628790295304285],
            [11.957079272717337, 1.870928117978214],
            [11.958540198753314, 1.8770069558473568],
            [11.957725468110748, 1.8872315255100627],
            [11.954382572505606, 1.902772852756457],
            [11.953753928797777, 1.9108425824161042],
            [11.955687358969634, 1.9184489575187886],
            [11.962211522501649, 1.9245388839609014],
            [11.967548901531766, 1.9262956702415077],
            [11.975055808898182, 1.9316478719661447],
            [11.976816627818756, 1.9404544811586328],
            [11.974247146466451, 1.9478430449182624],
            [11.972594260245188, 1.948943563422997],
            [12.048233410634243, 1.96171788114704],
            [12.125324487084887, 1.9743566202754403],
            [12.142351805856721, 1.9775610467617655],
            [12.208772513519158, 1.9879362656961566],
            [12.282459937069829, 1.9998585873123231],
            [12.28515880249134, 1.9915793934731754],
            [12.289379978095857, 1.9912191145623728],
            [12.290751144636587, 1.9953434113204234],
            [12.294782706412459, 1.9937630089299772],
            [12.298424263684726, 1.988266647645884],
            [12.298887981975465, 1.9837985424615738],
            [12.296858856743777, 1.9809219611162925],
            [12.299289007221635, 1.9737526829637186],
            [12.303843712230359, 1.9716721737678113],
            [12.308824347865922, 1.9626235219690935],
            [12.305489981264243, 1.9563189142399355],
            [12.308189598691557, 1.952109292863922],
            [12.305253570830496, 1.9480332823440747],
            [12.309138293672733, 1.9420145869665506],
            [12.308247552028645, 1.936958013372783],
            [12.313672875769425, 1.9353530232986984],
            [12.318986851890456, 1.9271804834816402],
            [12.315521632323732, 1.9196010789268843],
            [12.314031122838124, 1.9151464960285962],
            [12.310517080674686, 1.9130913559640201],
            [12.302724658901509, 1.9215857264032352],
            [12.296570864001836, 1.9213339989760805],
            [12.287020242916467, 1.916710808881721],
            [12.285376517091057, 1.9112788390611237],
            [12.281171629396791, 1.9060958884437915],
            [12.289675252215966, 1.8983251427850245],
            [12.288142534855517, 1.8917028028530514],
            [12.28487849881565, 1.8886587449040695],
            [12.281495759362624, 1.8894265783127944],
            [12.279444345576826, 1.8864060559883316],
            [12.282283857004158, 1.8822917837190776],
            [12.281961865478575, 1.8739471523501667],
            [12.27586535415686, 1.8726950259378616],
            [12.272536877001366, 1.8752923622526416],
            [12.260461346523009, 1.8699804359979373],
            [12.2585492404656, 1.8665378457538848],
            [12.260091171681678, 1.8636517820202005],
            [12.25856620331029, 1.8587177923471376],
            [12.260789761670525, 1.8554101968108072],
            [12.256314722731414, 1.8475161846539458],
            [12.252447505444579, 1.845548541111016],
            [12.254873636380152, 1.8408834890621435],
            [12.250680968294898, 1.8327767538374862],
            [12.254293137963598, 1.8265408517700965],
            [12.256881164014368, 1.8186763645634803],
            [12.256223289187425, 1.8160568948856528],
            [12.262708150507052, 1.8098397606609375],
            [12.265029074972182, 1.8041940897747013],
            [12.265039796502496, 1.8008675569724086],
            [12.27163530032968, 1.7868485979686002],
            [12.278524001454526, 1.7795982888117992],
            [12.28340995806768, 1.7774982821561873],
            [12.28081914456816, 1.7659109214484099],
            [12.283126947526018, 1.759838646387729],
            [12.277888272116417, 1.7541593062638803],
            [12.274551214649806, 1.7559198118739228],
            [12.27009697518826, 1.7537764783848888],
            [12.268479777984002, 1.7511277785027117],
            [12.269047365559434, 1.7403973150585825],
            [12.270503920722275, 1.7319951941630236],
            [12.268062820241722, 1.7317050527524949],
            [12.256827915975272, 1.727153178416659],
            [12.25598273904013, 1.7205282623102514],
            [12.253749817905234, 1.716924029144295],
            [12.25550759300713, 1.711004868508236],
            [12.255371090009495, 1.7020831139347976],
            [12.25075303723875, 1.6980443694619436],
            [12.245468272299467, 1.6995675947868687],
            [12.242643592241969, 1.6959464959467632],
            [12.237603484518004, 1.6938405862213304],
            [12.23613146838983, 1.6964694191817546],
            [12.232062971969038, 1.6978791157495001],
            [12.226688338352655, 1.6959461438179873],
            [12.226171672214333, 1.7003543378981691],
            [12.22020957065182, 1.7017038624762797],
            [12.21754272969905, 1.6981414700812736],
            [12.210333662343107, 1.6952908617144842],
            [12.211647732460763, 1.69914890705978],
            [12.209348573940327, 1.706584247374281],
            [12.206469674966232, 1.7106600458824752],
            [12.201749361703488, 1.7107212662995197],
            [12.197187286676268, 1.707385590395945],
            [12.195027752067807, 1.7078883919890295],
            [12.195280076304922, 1.6998770559995615],
            [12.188980470298514, 1.7007056003195413],
            [12.181832156378636, 1.7067115102170178],
            [12.178186272618898, 1.705852666429427],
            [12.171879518585785, 1.709362015114611],
            [12.166252949058237, 1.7104360234015437],
            [12.16460877790766, 1.7137635639307816],
            [12.161247062338424, 1.7142676033977584],
            [12.158897148652933, 1.7190923986553215],
            [12.154712114628133, 1.718988177542469],
            [12.149301845417533, 1.7212772528881353],
            [12.14656333676606, 1.716856732990574],
            [12.142476795900128, 1.7177087441460999],
            [12.138567865523145, 1.7138015039574894],
            [12.135162778277843, 1.7241716947989756],
            [12.133298740909137, 1.7263996858878177],
            [12.127199781498472, 1.7258130096144129],
            [12.126565026670619, 1.721156767382286],
            [12.12406772014728, 1.7176096362657844],
            [12.119977108508527, 1.7175615936393682],
            [12.118281008887713, 1.720089112305987],
            [12.110628454836535, 1.7189879212182975],
            [12.104344700561077, 1.7199106628424758],
            [12.1005128404021, 1.71893457019986],
            [12.096323288519097, 1.7240879548565569],
            [12.096521201835852, 1.728711638884379],
            [12.090793807759242, 1.7340870925745955],
            [12.087885701891931, 1.731994811140337],
            [12.084378835435615, 1.7326973462452047],
            [12.0818784919601, 1.740512473228187],
            [12.078216812479415, 1.7423982988330453],
            [12.076452588319363, 1.7471221179197516],
            [12.075830662774143, 1.7530539451909466],
            [12.0651850881293, 1.7573976436167578],
            [12.060658922365818, 1.7628687108112089],
            [12.055709799346193, 1.76178561817018],
            [12.051960956988312, 1.7663044173345697],
            [12.038935773066902, 1.7716925861515367],
            [12.038178888161337, 1.776023313116986],
            [12.040563373681758, 1.7788477249094017],
            [12.032908017764374, 1.7855981440698543],
            [12.027403521966395, 1.7881584028968502],
            [12.021856659481765, 1.7882942255021796],
            [12.01901579364832, 1.79319035466688],
            [12.015935473075865, 1.7936014755135656],
            [12.011991433262287, 1.7893944694452135],
            [12.010208779939658, 1.7853446347234663],
            [12.005958019239229, 1.786781808831261],
            [12.006816568444851, 1.7918047979635363],
            [12.002711526674931, 1.7922681549481654],
            [12.000214208178186, 1.7951609173423615],
            [11.99957605301696, 1.7995024794554815],
            [12.000470993976185, 1.8057829804848993],
            [11.99685348830684, 1.8058130180422034],
            [11.991704329274468, 1.8107410251368325],
            [11.986815041034532, 1.8113190902223124],
            [11.98203297843681, 1.816010258408771],
            [11.98112372952953, 1.8194804510343765],
            [11.983791097276526, 1.8242734207747655],
            [11.98205099008193, 1.8281352511163365],
            [11.977534772511005, 1.8283874309413655],
            [11.955489322160119, 1.8026375320743027],
            [11.917245388090096, 1.8162926801393633],
            [11.907718429315548, 1.822189355216731]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.63919203428397, "lat": 39.60526591438111 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54103"],
        "coty_name": ["Wetzel"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wetzel County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01717836"
      },
      "bbox": [
        11.907718429315548, 1.6938405862213304, 12.318986851890456,
        1.9998585873123231
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.565822083160778, 5.416181501543163],
            [5.6005613414325826, 5.418577491884362],
            [5.674591456888411, 5.424052901407196],
            [5.74862249941298, 5.429515505028951],
            [5.810450188033664, 5.4334185879334935],
            [5.846701856737979, 5.436150873567114],
            [5.911315598069598, 5.440640846454189],
            [5.906981586713951, 5.485630067410584],
            [5.970835974785637, 5.490214452874775],
            [6.030532536495243, 5.494920677272864],
            [6.08043800338057, 5.499161840395703],
            [6.0838125585163025, 5.453144700268392],
            [6.089297440240393, 5.395451530074625],
            [6.093066022060196, 5.352164411317695],
            [6.098337317203264, 5.294151098900929],
            [6.101361546793887, 5.255183866137062],
            [6.107021963639816, 5.19399137004222],
            [6.113653607994577, 5.105852759316272],
            [6.027250439213576, 5.098693762913505],
            [5.9413266412249275, 5.0924724868225235],
            [5.933872438067992, 5.1795994543834185],
            [5.869401313153641, 5.175326293637218],
            [5.826290065069625, 5.172294755239842],
            [5.758704833664056, 5.167945790704901],
            [5.708038594893193, 5.164252367585805],
            [5.671932208548721, 5.161356819785033],
            [5.596226945992432, 5.1559133371925805],
            [5.585214616248605, 5.155284594389146],
            [5.580612852329469, 5.224403655217048],
            [5.576476465811658, 5.278578218937632],
            [5.572360408912969, 5.329311970145038],
            [5.568137049776349, 5.388384534999925],
            [5.565822083160778, 5.416181501543163]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.48826328715138,
          "lat": 43.753571992089675
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55039"],
        "coty_name": ["Fond du Lac"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fond du Lac County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01581079"
      },
      "bbox": [
        5.565822083160778, 5.0924724868225235, 6.113653607994577,
        5.499161840395703
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.509665548310005, 5.874984315169449],
            [4.504587468405282, 5.962871204860139],
            [4.501151139331113, 6.020206595119891],
            [4.4955014536242075, 6.105387515365127],
            [4.49390916163052, 6.134357548206539],
            [4.563148529376186, 6.138655637418538],
            [4.661610803612681, 6.144562201760558],
            [4.678214799016429, 6.145872472939282],
            [4.743366259592243, 6.149344405139794],
            [4.827673151381704, 6.154843402683045],
            [4.830503006966812, 6.107748056207897],
            [4.833492063739649, 6.062885847553436],
            [4.836057678551823, 6.028818677982966],
            [4.839196672827354, 5.982355533478148],
            [4.9228469528973475, 5.987492162325527],
            [4.924823041917391, 5.95847808657649],
            [4.929153946515579, 5.900806200860548],
            [4.931671572536785, 5.872046253741639],
            [4.934404150360505, 5.835974305698125],
            [4.940884849585667, 5.739711914690214],
            [4.941686429005908, 5.725280879397493],
            [4.860682785282762, 5.721642285433617],
            [4.814702799694284, 5.718840680090978],
            [4.776013366912216, 5.716075634418273],
            [4.711180492645803, 5.71177046354969],
            [4.680388752863625, 5.710006253658764],
            [4.575699848502224, 5.7035206044317865],
            [4.5672086307374, 5.702441305915555],
            [4.522606245192413, 5.700075699087845],
            [4.518793757390235, 5.699806529683188],
            [4.514152542486381, 5.788229988415817],
            [4.512523789190467, 5.815855922472333],
            [4.509665548310005, 5.874984315169449]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.04159563652333,
          "lat": 44.455340508610234
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55141"],
        "coty_name": ["Wood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wood County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01581130"
      },
      "bbox": [
        4.49390916163052, 5.699806529683188, 4.941686429005908,
        6.154843402683045
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -67.15423072044273,
          "lat": 18.042239920739558
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72023"],
        "coty_name": ["Cabo Rojo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Cabo Rojo Municipio"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01804491"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.28766781427153,
          "lat": 18.316103892046968
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72049"],
        "coty_name": ["Culebra"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Culebra Municipio"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01804504"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.4163079462001, -4.395524473967942],
            [8.415552838160844, -4.392904285775116],
            [8.42027110004136, -4.37981133742937],
            [8.42444226931852, -4.377997620882097],
            [8.428528449380627, -4.3721640994580975],
            [8.436657225558251, -4.356186210577647],
            [8.44100213231208, -4.349004123870432],
            [8.447415934743235, -4.348334065452851],
            [8.450401784149157, -4.342404197702184],
            [8.45325937493613, -4.3427923589169515],
            [8.45996058852891, -4.355335101655296],
            [8.46383100279648, -4.3583105764853505],
            [8.469940850154245, -4.359392841758589],
            [8.47422746954753, -4.363812744275563],
            [8.477750659513962, -4.357534916095359],
            [8.483269507801296, -4.353312004757055],
            [8.490057953148227, -4.3449150858942165],
            [8.495687775467301, -4.343600522024563],
            [8.497174470300367, -4.340987116200592],
            [8.504203831851342, -4.33853897784008],
            [8.50891896794456, -4.339091240808106],
            [8.51515645797962, -4.336214653732025],
            [8.516655909586214, -4.339246566243456],
            [8.523094954303792, -4.3408361343014485],
            [8.523656505963126, -4.347030202006795],
            [8.521729580600542, -4.350816768198957],
            [8.532982249178577, -4.352641669219512],
            [8.536416777298054, -4.356796187203109],
            [8.542698214574735, -4.357265300905366],
            [8.545059794529122, -4.364946346568999],
            [8.544950656982602, -4.370567139507256],
            [8.546946249458665, -4.3747862576386956],
            [8.545536413661916, -4.38044563274545],
            [8.548133614944947, -4.3839529638650205],
            [8.547719464211308, -4.394095239970398],
            [8.553939161125527, -4.399193535779686],
            [8.558963227701616, -4.400823016271072],
            [8.562855500803964, -4.40023765605598],
            [8.565740042548432, -4.403454002368419],
            [8.569613948712085, -4.412670458103093],
            [8.570376662084863, -4.420841125609681],
            [8.578706429728935, -4.422442394354855],
            [8.580619082043118, -4.4166730767594355],
            [8.585521297871193, -4.4183782454744],
            [8.589651349852982, -4.418076973515009],
            [8.594676897905837, -4.41366276499721],
            [8.598628865882695, -4.417695978812128],
            [8.597362035102105, -4.423482423787469],
            [8.599999244600458, -4.4361304255631975],
            [8.605791287356523, -4.439888741194497],
            [8.608097549043594, -4.4434313788655695],
            [8.608006544346816, -4.447747932050914],
            [8.611463944941187, -4.454914972572446],
            [8.617354722821188, -4.45284441031611],
            [8.625344498968479, -4.452579980855568],
            [8.630933157318111, -4.448474685943829],
            [8.635044505713145, -4.448142853816162],
            [8.639622898063042, -4.4501695271735136],
            [8.645008850481583, -4.455084519683391],
            [8.647668338557388, -4.46220241931356],
            [8.648141740559417, -4.466814375058793],
            [8.639847943961419, -4.471360156829791],
            [8.63978493135864, -4.475748390598814],
            [8.645081109621296, -4.477151359651419],
            [8.648373306445475, -4.479464625095728],
            [8.652552499433883, -4.485267690775868],
            [8.651815569521675, -4.49131381399828],
            [8.646047858380529, -4.499068801012752],
            [8.64361223303842, -4.504546060689727],
            [8.64526204008466, -4.51565123943403],
            [8.651209383729208, -4.524164881041242],
            [8.654829748767716, -4.5269291146348545],
            [8.660145525194396, -4.533354454772022],
            [8.663980086783273, -4.539818538100136],
            [8.665575276028651, -4.548035649702147],
            [8.662989279551226, -4.549931164918303],
            [8.657895790559907, -4.549902270277116],
            [8.650709665867906, -4.553327858418971],
            [8.644646476325773, -4.558652529656915],
            [8.64057446223934, -4.564277433741223],
            [8.636873341987405, -4.57185815811526],
            [8.633862236986301, -4.5745085709368],
            [8.623136038754799, -4.57988843532225],
            [8.61014888389748, -4.5939966475820455],
            [8.608721679567314, -4.597676192628771],
            [8.609032327211064, -4.604657505639506],
            [8.605517182963407, -4.6076141960360815],
            [8.60065856430953, -4.6067462895177265],
            [8.59756412519636, -4.603920338258006],
            [8.593940449658742, -4.604211795492669],
            [8.589401501585163, -4.610957286065639],
            [8.58806175442926, -4.618120551944593],
            [8.591160605076931, -4.63057255245319],
            [8.591012169079479, -4.641108171074462],
            [8.58663121082503, -4.647787768952534],
            [8.583937797364209, -4.649378961652539],
            [8.577430350995526, -4.6488660374567665],
            [8.571907553621115, -4.64589709307424],
            [8.570189254992053, -4.6430288545935605],
            [8.56819317362244, -4.632832523545553],
            [8.564128479093545, -4.626742796040546],
            [8.560147880957452, -4.624210079630451],
            [8.555157906738247, -4.624266375856022],
            [8.549480060274798, -4.626477572365909],
            [8.54418701912555, -4.630214038855983],
            [8.541099090819705, -4.635749389390821],
            [8.541309245576636, -4.641504729978898],
            [8.545863607835742, -4.648076661797265],
            [8.56322240459632, -4.6559380167584665],
            [8.570929606657547, -4.66263377488049],
            [8.57248247371867, -4.669120897777723],
            [8.577956053015397, -4.681086823622823],
            [8.580017418100924, -4.687462403989759],
            [8.57984554265552, -4.6916278622314245],
            [8.577581547581358, -4.702913245224486],
            [8.575732602615508, -4.70605718095297],
            [8.57015082913877, -4.708450657406471],
            [8.559041419378879, -4.709469862410976],
            [8.554149320250792, -4.711809102579277],
            [8.55339521105586, -4.717365082308747],
            [8.557856945677624, -4.721211497729013],
            [8.566290298827857, -4.724777755092746],
            [8.568410085238126, -4.728306406352531],
            [8.566322244029635, -4.731930568345895],
            [8.547611478836133, -4.731071609840925],
            [8.542373405410705, -4.732126706869355],
            [8.539396657208732, -4.735353162010236],
            [8.538547045028638, -4.739312059992475],
            [8.539963353469203, -4.743590648802807],
            [8.5463155934261, -4.750008495824077],
            [8.548023333408514, -4.754124686223686],
            [8.54773200192804, -4.760691588903178],
            [8.551560181751592, -4.76551136573788],
            [8.562820087223619, -4.76910855694532],
            [8.565363167243339, -4.770868032822897],
            [8.568330570329069, -4.776516365538018],
            [8.568132387265718, -4.780077057016704],
            [8.564211757444944, -4.785572462924548],
            [8.555560477561528, -4.79085095890142],
            [8.544872490447794, -4.801099533175364],
            [8.540821958527127, -4.80627468141905],
            [8.538273228218166, -4.818767030822237],
            [8.539853860574285, -4.8274340562218745],
            [8.53630396042656, -4.832984666525942],
            [8.524681172360236, -4.838524286158914],
            [8.519326250643465, -4.840276746455512],
            [8.514737327159086, -4.838504758016819],
            [8.511174792696476, -4.833726470148911],
            [8.510744042712808, -4.828799800128988],
            [8.512506807065783, -4.823914675916238],
            [8.511773794871338, -4.818076694638988],
            [8.508488715424425, -4.815552435007644],
            [8.502409288419852, -4.817165328926799],
            [8.49709184688759, -4.82059414833583],
            [8.49325285447892, -4.8273523962023],
            [8.49293566507095, -4.836395161861569],
            [8.494747307151187, -4.841629458054549],
            [8.49421688555103, -4.8446137270837575],
            [8.488488432068461, -4.849112271574388],
            [8.484646114340487, -4.858868195043641],
            [8.483137479815438, -4.866002361888939],
            [8.483912380951208, -4.872425374981976],
            [8.48024318819979, -4.880003416404492],
            [8.475842595873996, -4.883336242442284],
            [8.469117824498387, -4.890318053274506],
            [8.467322971581185, -4.89432681930457],
            [8.46528527319895, -4.903536446205551],
            [8.459679695557604, -4.911914536704365],
            [8.455087588987954, -4.923523612240083],
            [8.452303455566517, -4.927132863835465],
            [8.445542311628728, -4.930213791951476],
            [8.438961251248424, -4.932042661131171],
            [8.436216873684732, -4.937161587754222],
            [8.431295646295778, -4.9432014710987175],
            [8.428750431556878, -4.9483783749403845],
            [8.426350856056642, -4.921034542540077],
            [8.417776914987831, -4.837124822940617],
            [8.365720978164422, -4.842487466065294],
            [8.332312161125138, -4.845594517419454],
            [8.328250934385965, -4.802102514850798],
            [8.299241415296613, -4.80505532199743],
            [8.298536148341768, -4.797703984294459],
            [8.276828583692794, -4.79927651852964],
            [8.276068916558085, -4.792083761887027],
            [8.268746636366169, -4.792961108100716],
            [8.263387391218147, -4.734040525119749],
            [8.270451082486968, -4.733466157383528],
            [8.268962728627706, -4.718956860172037],
            [8.276473020298395, -4.7182011907741455],
            [8.27491308397649, -4.7037206424365525],
            [8.282080005587698, -4.703191146019148],
            [8.280351549036629, -4.688310201304593],
            [8.27682354305319, -4.65270705654653],
            [8.274851589223669, -4.630740298167082],
            [8.26760294736248, -4.631414185591318],
            [8.266248059939073, -4.617245898738307],
            [8.258974725723393, -4.617792434963869],
            [8.2559238557585, -4.588292531865429],
            [8.227132798676983, -4.591008005170117],
            [8.223700232348207, -4.55435489283372],
            [8.269475150623045, -4.549879452434643],
            [8.276073725162815, -4.540475274344309],
            [8.279331038588007, -4.539423359694978],
            [8.282551196441506, -4.541770036492627],
            [8.287708426250656, -4.537108632662489],
            [8.297374288092083, -4.535499628003536],
            [8.30218373566835, -4.533237626026999],
            [8.30977760391296, -4.526748796861706],
            [8.321059701099893, -4.52327287941048],
            [8.325141387896172, -4.523087889525451],
            [8.328878829672995, -4.5210730741804],
            [8.336635296956985, -4.524903466161874],
            [8.342838919716115, -4.524756327068499],
            [8.34401767877892, -4.521232084456332],
            [8.349228014401028, -4.51719448090124],
            [8.36106016367285, -4.506377260366071],
            [8.3627147719698, -4.502531871176606],
            [8.366540524346094, -4.499698522348273],
            [8.371568506125275, -4.491677958672185],
            [8.371218759855786, -4.4883629280928785],
            [8.379250148078862, -4.4813883978584155],
            [8.387223154361822, -4.4725955081723185],
            [8.390082511474253, -4.466118176548807],
            [8.397353413741726, -4.46234478753036],
            [8.399619214661971, -4.4587458254585055],
            [8.403935984571643, -4.45663249259191],
            [8.407808102150574, -4.45058625114463],
            [8.409703294743315, -4.441940004393303],
            [8.405139131314844, -4.439931412753569],
            [8.401914093209133, -4.436121637098075],
            [8.400133294602695, -4.430656608732292],
            [8.401933979920855, -4.421799623931441],
            [8.406540463592748, -4.4158871209775],
            [8.41032609978873, -4.4166511203565975],
            [8.4155605631286, -4.406241318411985],
            [8.419849774681197, -4.403205404742193],
            [8.414964256048094, -4.398576477283652],
            [8.4163079462001, -4.395524473967942]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.3145997896258, "lat": 33.715741858955035 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01115"],
        "coty_name": ["St. Clair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Clair County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00164997"
      },
      "bbox": [
        8.223700232348207, -4.9483783749403845, 8.665575276028651,
        -4.336214653732025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.325332107693352, -9.387486038882177],
            [-16.323627946076446, -9.386687460741632],
            [-16.32245319753145, -9.38718728973372],
            [-16.32103392985417, -9.386964432492672],
            [-16.318866765232954, -9.38592972165451],
            [-16.317235155604333, -9.38772449624365],
            [-16.316720500948144, -9.389343849963812],
            [-16.313702599208543, -9.391763763611435],
            [-16.311473800001753, -9.392938015490818],
            [-16.307205926834097, -9.393421570264985],
            [-16.306016303579554, -9.396685740835963],
            [-16.30361587354675, -9.397145170280215],
            [-16.30115220133507, -9.398323520711365],
            [-16.300560190115547, -9.401417711880152],
            [-16.299084767826372, -9.402824082799071],
            [-16.29664283978272, -9.404403463092164],
            [-16.2891908624051, -9.405950071293535],
            [-16.28692886692242, -9.409521273442007],
            [-16.28416968712659, -9.412237149255711],
            [-16.281383317563105, -9.413228704711509],
            [-16.27914789032431, -9.413355483964684],
            [-16.22179217397161, -9.407689124475038],
            [-16.164434930056693, -9.4020377430284],
            [-16.149412447834955, -9.542124235060122],
            [-16.147194939973584, -9.562802599331118],
            [-16.135687910949855, -9.670087771850469],
            [-16.155212049545288, -9.672105876445848],
            [-16.22504418684147, -9.678777299861329],
            [-16.294874409719384, -9.685468032197901],
            [-16.29032303491657, -9.735186991729355],
            [-16.36658098818427, -9.741689732625266],
            [-16.44566157543535, -9.74784499584147],
            [-16.4760770941733, -9.75005379207582],
            [-16.499976347746582, -9.751727293016234],
            [-16.51945514586907, -9.753050734059135],
            [-16.570395329717954, -9.781215506364518],
            [-16.621327034143423, -9.809389734103027],
            [-16.687556137150363, -9.846047598145358],
            [-16.753771823699672, -9.882720720750942],
            [-16.820191176959657, -9.919527857426214],
            [-16.886598115370962, -9.95634945713547],
            [-16.889384803079277, -9.956437231003596],
            [-16.888544438062087, -9.981381695734166],
            [-16.930341516165456, -9.982609287062605],
            [-16.99784020954349, -9.984030107537171],
            [-17.06533856823538, -9.985466245267215],
            [-17.046782314282552, -9.95208684255832],
            [-17.01227501443487, -9.888870197408815],
            [-16.977755622415014, -9.82565604486592],
            [-16.978763290218765, -9.783803993713818],
            [-17.008781936272467, -9.784463373639658],
            [-17.00909856385866, -9.7694916540949],
            [-17.039075229917888, -9.770064957374236],
            [-17.039893476198337, -9.725148836900555],
            [-17.0496305782203, -9.72531651693785],
            [-17.05066409505726, -9.665430050273049],
            [-17.032568702509312, -9.665111041110618],
            [-16.950695527928257, -9.663274221770438],
            [-16.95244170690679, -9.60340626025144],
            [-16.92561628898772, -9.602664442497979],
            [-16.927490492332552, -9.54280430419887],
            [-16.893001748719186, -9.541748519765452],
            [-16.894683710337834, -9.536768307869817],
            [-16.897717407355806, -9.534410158766585],
            [-16.894400003553866, -9.528805044333625],
            [-16.892938132777715, -9.52676709015881],
            [-16.88824405893422, -9.516627489432318],
            [-16.885552704100842, -9.515244985932096],
            [-16.880256556121566, -9.515225332089594],
            [-16.878435568537107, -9.516301016711129],
            [-16.853257585657897, -9.515419255375319],
            [-16.853071787260195, -9.520406295603431],
            [-16.849282636593028, -9.521843188696065],
            [-16.841437729191174, -9.523573487046557],
            [-16.84520036839225, -9.532008020567215],
            [-16.83227817010703, -9.535959984943137],
            [-16.82825159326194, -9.539453814206622],
            [-16.808990979166055, -9.538646926963878],
            [-16.76984162493544, -9.474479419429258],
            [-16.730669835205894, -9.410322745723628],
            [-16.71518592945509, -9.409557353114662],
            [-16.64270557862689, -9.405387521023142],
            [-16.57022379016988, -9.401242010511213],
            [-16.504473740527715, -9.39678751245983],
            [-16.489543266240577, -9.39571530140308],
            [-16.489164745998963, -9.400691408822555],
            [-16.470936237191918, -9.39935352336615],
            [-16.434606113277706, -9.396589289903474],
            [-16.37996970317961, -9.392030772570205],
            [-16.325332107693352, -9.387486038882177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -150.01184360129596,
          "lat": 63.67136909876346
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02068"],
        "coty_name": ["Denali"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Denali Borough"],
        "coty_fp_code": "068",
        "coty_gnis_code": "01419988"
      },
      "bbox": [
        -17.06533856823538, -9.985466245267215, -16.135687910949855,
        -9.38592972165451
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.4877731979925164, -2.9570053930885276],
            [3.516358051686313, -2.9565723137787305],
            [3.598226146188792, -2.955865568819297],
            [3.655785682207071, -2.9544340927859354],
            [3.6839158621891563, -2.954105674977981],
            [3.73069127132369, -2.952916611103645],
            [3.794398814397882, -2.9510252712263187],
            [3.812578931893296, -2.950645278321677],
            [3.8369926906214005, -2.950037833301676],
            [3.8467761518360297, -2.9423277939491026],
            [3.850488690818608, -2.9421524347067316],
            [3.8514883710453836, -2.9725343968840408],
            [3.8524028910553985, -3.016952945286295],
            [3.8528340997563526, -3.0244904874592238],
            [3.853327655605224, -3.051372995550033],
            [3.8549642762177316, -3.1062917618058727],
            [3.8552612352271636, -3.121176805522637],
            [3.8555034539875104, -3.1488709018873777],
            [3.856812051217306, -3.2002349248294015],
            [3.8480699041183923, -3.2032796985521004],
            [3.842582663902082, -3.2025725366143147],
            [3.8402292723956073, -3.206200107841812],
            [3.836734492716956, -3.2064545330856613],
            [3.830489298069453, -3.2022971097213793],
            [3.826944242234178, -3.2095700654202526],
            [3.8255511363725767, -3.2155396373663243],
            [3.8196473947214145, -3.219522423177351],
            [3.8140687465595327, -3.221397364774832],
            [3.8157409117710857, -3.3000637205194283],
            [3.7745737377903716, -3.301207260052659],
            [3.716489686151561, -3.3030603656573274],
            [3.689060646927501, -3.3041240746830316],
            [3.6745181643735934, -3.3037800932388723],
            [3.6061242462953134, -3.3046328829842735],
            [3.5915786222161197, -3.3058781214688913],
            [3.577335426648624, -3.3060902735154336],
            [3.512258100518562, -3.30793779751697],
            [3.491948900238958, -3.308188914450585],
            [3.490745826163129, -3.2350082225401753],
            [3.4885250119630875, -3.132640095533077],
            [3.4915310328620666, -3.1325658633375344],
            [3.4907458008622525, -3.1001988435613734],
            [3.4903941146092405, -3.0741051217075483],
            [3.4892827631893297, -3.037473280937005],
            [3.4877731979925164, -2.9570053930885276]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.0266956592954, "lat": 35.53817192446565 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05023"],
        "coty_name": ["Cleburne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cleburne County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00066983"
      },
      "bbox": [
        3.4877731979925164, -3.308188914450585, 3.856812051217306,
        -2.9421524347067316
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.302636850749228, -2.573911394892949],
            [5.369630889099148, -2.5690748342606335],
            [5.483556340515383, -2.5603852277651202],
            [5.485402678854276, -2.5644962023750155],
            [5.492449175231355, -2.5716689053229933],
            [5.4921103690063875, -2.5800355151414047],
            [5.494865193944066, -2.5931204024447694],
            [5.497713044889378, -2.597529549806322],
            [5.501526847568865, -2.6006217660114594],
            [5.516618874645466, -2.608796303489419],
            [5.533583233679671, -2.616903974640801],
            [5.5426083035690255, -2.623223999439436],
            [5.551520691405194, -2.627236672032033],
            [5.5547005099553965, -2.6295704538148175],
            [5.559925058943644, -2.6360110763410134],
            [5.563507525157462, -2.6506312650067443],
            [5.563445980663825, -2.6614091959064043],
            [5.561243453644994, -2.6713975479195256],
            [5.558035280201449, -2.6757060147226395],
            [5.55200270720497, -2.681199086926004],
            [5.547840298939647, -2.6835379103184147],
            [5.54321067673131, -2.6840415461033613],
            [5.537216332499032, -2.6822301635503805],
            [5.52277810261846, -2.6690210404409394],
            [5.516306771511119, -2.664350201125046],
            [5.504357315414, -2.654556299475826],
            [5.493731707360277, -2.6502108624291734],
            [5.489248538123617, -2.6498196756811176],
            [5.481448060247342, -2.651088504998475],
            [5.475033724790024, -2.658113053328265],
            [5.463484890757265, -2.6728025404344926],
            [5.460408863700363, -2.680251934946337],
            [5.459178054943224, -2.6933264768676692],
            [5.461001320056737, -2.6989835386962424],
            [5.464465071163361, -2.703368157310407],
            [5.469826194813836, -2.706418826473463],
            [5.480270817600559, -2.709985491669863],
            [5.5013510434502635, -2.7155260799225456],
            [5.5107993593375255, -2.7185392676008613],
            [5.52304293095425, -2.7235986030005597],
            [5.52650943691564, -2.7283753724233817],
            [5.526561303898481, -2.73495264168932],
            [5.524851537040717, -2.7397434710956263],
            [5.521234008311051, -2.7437383782470754],
            [5.509935417629116, -2.7535126977319324],
            [5.500648376767736, -2.759413622944535],
            [5.495714361388783, -2.7590734445146965],
            [5.493057564000722, -2.756761551102977],
            [5.488847523692508, -2.756940936990919],
            [5.475868151039739, -2.7532256301498754],
            [5.470367826488209, -2.7544271969112373],
            [5.4575835268853226, -2.7596873905002117],
            [5.4466430430867545, -2.7729493104798704],
            [5.444337974113685, -2.7776210061426436],
            [5.446919944765107, -2.7844807547858],
            [5.445319376363627, -2.7922558273355045],
            [5.446737642786596, -2.806731525763898],
            [5.445455882175498, -2.809041326697483],
            [5.433067980810274, -2.8183934162931306],
            [5.426400350530984, -2.8223660961572588],
            [5.415759597499074, -2.8261342581412814],
            [5.409372434740227, -2.824540223609752],
            [5.406213898885382, -2.8219954606465696],
            [5.404136073872273, -2.813469078660886],
            [5.39543402772036, -2.8123064624382614],
            [5.389120060618304, -2.813637109855234],
            [5.3749598761051045, -2.8197636467074703],
            [5.370929842243827, -2.8202428739885192],
            [5.363956134780882, -2.816416429701631],
            [5.360703149606246, -2.812721526888996],
            [5.356099340330344, -2.813645828962573],
            [5.353504188584237, -2.8172419041610586],
            [5.335929009089313, -2.8294654679753517],
            [5.334620272119568, -2.8344349771849595],
            [5.331316810662788, -2.8383388301144867],
            [5.324321628547954, -2.843260142817074],
            [5.320936496194624, -2.8479583732915685],
            [5.320727188953094, -2.851517405863071],
            [5.322901651814739, -2.86272616925822],
            [5.324305973000426, -2.8803407007122077],
            [5.325419842494896, -2.8845041324258767],
            [5.330132060282059, -2.891615485287975],
            [5.3388076842945935, -2.9004965866584884],
            [5.344065288258383, -2.9087093183927157],
            [5.3501370289855075, -2.913857374001266],
            [5.356886366361377, -2.91763067614888],
            [5.367712465743685, -2.92112998794431],
            [5.373539156170599, -2.9209995182984607],
            [5.38295487531454, -2.9176346070016015],
            [5.385465615636417, -2.914788920225966],
            [5.390568815191964, -2.9039265469909035],
            [5.398020311010355, -2.8999337142035024],
            [5.404784367030851, -2.9007814505697493],
            [5.40947995114534, -2.907214739896658],
            [5.411478284623547, -2.9119621164179517],
            [5.4122010739005, -2.9192105703137354],
            [5.410547533890294, -2.931382126261446],
            [5.4086028881590735, -2.9353623759803553],
            [5.403008593458192, -2.939415688677526],
            [5.3959921548395196, -2.942931124610234],
            [5.38273172713855, -2.9552347822085996],
            [5.3751573031794635, -2.9570895687943284],
            [5.365758709061622, -2.9551345371580178],
            [5.359395781461291, -2.960952137463413],
            [5.349321354007829, -2.965866147472011],
            [5.339344670916349, -2.9729605310187743],
            [5.334991432653819, -2.977397687215802],
            [5.331052798076145, -2.9845837916759343],
            [5.330394125803919, -2.99041616159501],
            [5.333931960757735, -2.999336735159057],
            [5.340575825949124, -3.0112810930695106],
            [5.3449602936179685, -3.017743123757364],
            [5.355680560781502, -3.0224687537025603],
            [5.368891089529334, -3.024098460330265],
            [5.370767615559889, -3.0256371051979425],
            [5.3721722101568785, -3.0351346233004866],
            [5.376571513202808, -3.036939511741004],
            [5.3786183826059135, -3.0425257313419074],
            [5.37890172334647, -3.0477464616611196],
            [5.377447872092185, -3.0535823647857594],
            [5.37431950729646, -3.058939933532407],
            [5.366803119577304, -3.0623056151398016],
            [5.3583745933983415, -3.061853026924107],
            [5.353170437384213, -3.059054572949561],
            [5.333598224230307, -3.0518498589561407],
            [5.335415314216973, -3.0409510065144594],
            [5.3326552054116485, -3.033872542886049],
            [5.317541911951365, -3.0225458925990614],
            [5.306644531233547, -3.0170054756591713],
            [5.298877531159329, -3.0163907318571237],
            [5.291411051885051, -3.0179450706634974],
            [5.2839345979540315, -3.0224937145113047],
            [5.279086699745131, -3.0224856996438336],
            [5.270789663424576, -3.0267473511693956],
            [5.266841520788494, -3.0326222987098217],
            [5.265651579841609, -3.043295060895717],
            [5.260969920631203, -3.058026448295156],
            [5.2605318541685575, -3.0647347240375655],
            [5.263347338729981, -3.0777109917519634],
            [5.266842335259122, -3.0858040149103743],
            [5.274725729984459, -3.0970849755346883],
            [5.2810112205787965, -3.1021615097278237],
            [5.287787656803092, -3.1059428310928765],
            [5.294686685553338, -3.1161338396404306],
            [5.299402731914894, -3.1252696995452713],
            [5.302273499900548, -3.1351868068706996],
            [5.304173057918857, -3.1479054427739546],
            [5.295641329211137, -3.1556067150933824],
            [5.289902019333033, -3.1592039010577295],
            [5.2687565032391435, -3.1690990480565335],
            [5.262241750072731, -3.1774539187566893],
            [5.272964017214526, -3.183990261591711],
            [5.27497115941908, -3.1839674343282955],
            [5.272546612224816, -3.1878093260652176],
            [5.265145297301785, -3.191993807674837],
            [5.251695551004829, -3.173803838278104],
            [5.257306893746943, -3.1663399844174447],
            [5.249918815160222, -3.158614557126527],
            [5.246398584774655, -3.1480423118104115],
            [5.246060101437246, -3.142382835699851],
            [5.247590574870192, -3.1314600385204416],
            [5.250243162207098, -3.1205759705827414],
            [5.249434704496964, -3.1153099567296745],
            [5.239734803474753, -3.105164580219657],
            [5.232356461176228, -3.103898730529243],
            [5.222328266301793, -3.105020382695268],
            [5.216597829378364, -3.106540630665082],
            [5.21148819080095, -3.111367073852399],
            [5.207332892830098, -3.1175461720463047],
            [5.20524133731055, -3.12448561218881],
            [5.201274986546845, -3.1426301193073902],
            [5.193050105311221, -3.1486406786781815],
            [5.074558310311618, -3.154064007767712],
            [5.06929475420782, -3.0664648687371256],
            [5.0629615723707895, -2.9640294329390335],
            [5.061872326286487, -2.9351506439409563],
            [5.058819521520806, -2.891077842536347],
            [5.056698159388567, -2.8622002908563156],
            [5.051882022935281, -2.7814520989816565],
            [5.051836328293874, -2.774093453917919],
            [5.047227826054165, -2.7046161555905397],
            [5.039013252175863, -2.592842479549336],
            [5.168355784556562, -2.583728831349693],
            [5.187117021385879, -2.5820537961955616],
            [5.302636850749228, -2.573911394892949]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.05216309896221, "lat": 35.76240734953432 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05093"],
        "coty_name": ["Mississippi"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mississippi County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00069899"
      },
      "bbox": [
        5.039013252175863, -3.191993807674837, 5.563507525157462,
        -2.5603852277651202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.991827356651097, 2.1558146065981427],
            [-18.007776183354274, 2.094493366880153],
            [-18.003211760312702, 2.0943739792823526],
            [-18.00105678585867, 2.096273540419921],
            [-17.994010492521713, 2.0975517560359083],
            [-17.99137643161899, 2.0990848134088713],
            [-17.97169128433585, 2.071036429591145],
            [-17.981413780903534, 2.064333669407713],
            [-17.9890914473067, 2.067614078513294],
            [-17.991498234700895, 2.0651620572125715],
            [-17.99711050482315, 2.0628503842161923],
            [-18.003733194572078, 2.0622073857471226],
            [-18.01226624708502, 2.062728163881105],
            [-18.023352936869834, 2.059977650032921],
            [-18.030364400704, 2.054785012666497],
            [-18.037894419028277, 2.056214339416929],
            [-18.043951124175603, 2.0556865666972914],
            [-18.045940899696454, 2.0574425973331034],
            [-18.056684475761795, 2.057534968750081],
            [-18.063045558073448, 2.055297529329897],
            [-18.067411316392363, 2.0572408504058983],
            [-18.070099033505613, 2.0544317989463172],
            [-18.072613465988095, 2.0559671651872917],
            [-18.083490523011555, 2.0514195936987867],
            [-18.088012811835227, 2.0508742905204342],
            [-18.091136380670513, 2.047105986829597],
            [-18.095597157012914, 2.047070588297268],
            [-18.09938897806564, 2.044047440814953],
            [-18.104127545906145, 2.0432974127917842],
            [-18.105048055322065, 2.0406503775810254],
            [-18.10921171701567, 2.0384394651552302],
            [-18.11446606958632, 2.030143165552496],
            [-18.119011431836622, 2.0283404419585067],
            [-18.121587775474108, 2.0226421388926634],
            [-18.123260140705998, 2.0225743722946388],
            [-18.13078620981743, 2.0139609505510796],
            [-18.137192065008513, 2.0056288935075317],
            [-18.142934253275588, 2.00182335293096],
            [-18.15284770372924, 1.999457546770815],
            [-18.15590024038305, 1.996051643753744],
            [-18.15880836887629, 1.9953499591847055],
            [-18.16268456120605, 1.9891290702891462],
            [-18.168484401561894, 1.9844793998729775],
            [-18.16982445033375, 1.981558941104115],
            [-18.174756263595356, 1.9773769087797848],
            [-18.18317041248666, 1.9731505718734816],
            [-18.18688149242317, 1.9727883265138717],
            [-18.191927900611596, 1.9660909063380776],
            [-18.197479331582525, 1.9618189480606993],
            [-18.200997105483527, 1.9612127949060458],
            [-18.2055846320729, 1.9553744373181605],
            [-18.205584197576776, 1.9505773089753127],
            [-18.208448326631693, 1.950325454845775],
            [-18.214879166629874, 1.9450184603613352],
            [-18.218454818772393, 1.9434912771660218],
            [-18.223126339251262, 1.938581758190669],
            [-18.226313537367464, 1.929105946446898],
            [-18.235560368241117, 1.9267572529683639],
            [-18.241055033371534, 1.922971950379076],
            [-18.246669732793812, 1.9154450399226906],
            [-18.250478886916266, 1.9125767502743547],
            [-18.252725270745284, 1.9081054972826215],
            [-18.257734228572474, 1.903237209847804],
            [-18.265843379349878, 1.897582776235975],
            [-18.277241757630804, 1.884197098903956],
            [-18.279665106303646, 1.8779820349064174],
            [-18.28732955928315, 1.8781061825328749],
            [-18.291190970878272, 1.8728165259164726],
            [-18.297154482290676, 1.8707996222006174],
            [-18.296717980981203, 1.8639295170542383],
            [-18.304544226265026, 1.8648601170264278],
            [-18.30825095006528, 1.8628243430717215],
            [-18.313649684984238, 1.8566484506766359],
            [-18.31042082478288, 1.8532239438156282],
            [-18.312499738791036, 1.8501888082494178],
            [-18.316842894669865, 1.8500854908742956],
            [-18.318893044162124, 1.8445835228509435],
            [-18.323898458373968, 1.8415999432290362],
            [-18.32953267097286, 1.8322159808269647],
            [-18.33686171040808, 1.8285515235166379],
            [-18.341954771429123, 1.8277350454913603],
            [-18.34781926125694, 1.8251824748843783],
            [-18.350453777473184, 1.821730119978573],
            [-18.350860596746728, 1.8168946923550355],
            [-18.35360840643754, 1.8099761863651702],
            [-18.358180019898427, 1.804950500949749],
            [-18.364196345967756, 1.8032274138251645],
            [-18.36775937452758, 1.798375469058105],
            [-18.37257237738153, 1.799837076601211],
            [-18.376200234179745, 1.7873484337674064],
            [-18.381251692373848, 1.7890776494055198],
            [-18.38516325648681, 1.78785879723694],
            [-18.38767406261232, 1.7811234496718247],
            [-18.390807485900343, 1.7779029975386775],
            [-18.39823824427904, 1.773142919882453],
            [-18.403627674435228, 1.764337345382022],
            [-18.407063230575112, 1.7613709914922897],
            [-18.409293529750375, 1.7562495994989176],
            [-18.41505445662312, 1.7549191892493297],
            [-18.415483594631738, 1.7487111612425048],
            [-18.41737561268273, 1.7450935404285588],
            [-18.420634680273494, 1.7488654980233977],
            [-18.428189422756528, 1.7505048428278573],
            [-18.43128876753463, 1.7485664711496074],
            [-18.434741927860284, 1.7512880984726287],
            [-18.44224528506797, 1.7484916056940254],
            [-18.44465594669206, 1.7374430581116065],
            [-18.449307193293134, 1.7341875837524905],
            [-18.452744393494722, 1.7354735942299333],
            [-18.455055039765604, 1.7414316683258109],
            [-18.45140631386995, 1.7420647239311013],
            [-18.45132227827135, 1.7466617318563022],
            [-18.454761672294453, 1.7491845419697216],
            [-18.457277776761508, 1.7478521491771855],
            [-18.461204407479798, 1.7415167615603289],
            [-18.47036278653606, 1.7408053722439227],
            [-18.472202874584944, 1.7384503834569565],
            [-18.468695345149012, 1.7317758532351555],
            [-18.472608158615156, 1.729400846824873],
            [-18.4761615728346, 1.7298176781663253],
            [-18.481819772747215, 1.7282576410047519],
            [-18.479396306622878, 1.724699976248156],
            [-18.47117902147629, 1.7240368253142333],
            [-18.471992023083693, 1.7190504038218901],
            [-18.47049166222896, 1.7158620418153188],
            [-18.46583426923556, 1.7115748895209668],
            [-18.464527059551113, 1.7035438398272935],
            [-18.46690756628016, 1.699416517296942],
            [-18.48007911772538, 1.6952033176256327],
            [-18.484542801056495, 1.6946879323961366],
            [-18.489524050706265, 1.6886770683780397],
            [-18.490419834656176, 1.6786019957758327],
            [-18.496088533226416, 1.6727235729422085],
            [-18.50238521520308, 1.6756703929327486],
            [-18.506691747306252, 1.6717494841358713],
            [-18.511731243519645, 1.6708799650096027],
            [-18.513654591869635, 1.6690003800378892],
            [-18.51720430052709, 1.6601376289147336],
            [-18.52148752015651, 1.6555375429954884],
            [-18.526015906194484, 1.6531595075152168],
            [-18.53180287006669, 1.65665670459424],
            [-18.536955506884482, 1.6569367135994848],
            [-18.5394346501284, 1.6544579736591354],
            [-18.544669910642344, 1.652602011921541],
            [-18.54641522110779, 1.647303111570267],
            [-18.558787611240092, 1.639463467926679],
            [-18.5704836724231, 1.637083981197104],
            [-18.575314150529866, 1.6340227521109567],
            [-18.58062620134615, 1.6326056794213846],
            [-18.585916429607167, 1.6254122580579313],
            [-18.586421800440988, 1.6217052422383214],
            [-18.59239793606563, 1.6184397891157294],
            [-18.593135349764577, 1.6148986919944321],
            [-18.597827166126656, 1.6130975718220877],
            [-18.602799633362423, 1.6084604813378494],
            [-18.606686688573593, 1.6168754640415774],
            [-18.637590220274365, 1.678745517850849],
            [-18.642696858233407, 1.6877992217052926],
            [-18.650864045744616, 1.7055487415733712],
            [-18.654161254527626, 1.717658310437667],
            [-18.670593900508184, 1.7508984713525875],
            [-18.67337504577485, 1.7556226412167664],
            [-18.69621279822026, 1.802535357943734],
            [-18.70703908445269, 1.8216286920807865],
            [-18.719670443423762, 1.8454359772212425],
            [-18.740835193853563, 1.8948507098243763],
            [-18.744939048855887, 1.9029164610167955],
            [-18.751419996874183, 1.9160463963006467],
            [-18.755305194332493, 2.0110390889195955],
            [-18.758069552553174, 2.06109165230314],
            [-18.751784276605125, 2.055233144891242],
            [-18.748181493268593, 2.0546551521652896],
            [-18.742450413526935, 2.049104571998123],
            [-18.7383267038761, 2.05062973593503],
            [-18.73535943998336, 2.0492377775534707],
            [-18.726208145432096, 2.053480953926674],
            [-18.718571480661197, 2.0483279051820076],
            [-18.715454775021144, 2.044791181782606],
            [-18.71230992662385, 2.045192736419342],
            [-18.704919858605958, 2.0491429040903943],
            [-18.69843980088177, 2.049869699990854],
            [-18.694828828482834, 2.0483528692685806],
            [-18.689376545203782, 2.039672446420061],
            [-18.682736418099783, 2.036555777876901],
            [-18.67763294065604, 2.0413644720374933],
            [-18.67397345655788, 2.042313024806226],
            [-18.669725359217995, 2.045956331362185],
            [-18.668496678225853, 2.0511248824779655],
            [-18.666485071187484, 2.0526392232315196],
            [-18.65879435260561, 2.054305007716063],
            [-18.648562363401037, 2.0546554262000236],
            [-18.645668985625495, 2.0565579894500385],
            [-18.642747774637765, 2.06176373624117],
            [-18.63925699550487, 2.064104208319798],
            [-18.63619162043737, 2.069017617605927],
            [-18.633433003724747, 2.068453502280588],
            [-18.62384307955936, 2.0708095117155665],
            [-18.61469006684513, 2.074948298895345],
            [-18.61084997370516, 2.0808345652838645],
            [-18.60858282231001, 2.0821636376459622],
            [-18.604029477004218, 2.0789528396109684],
            [-18.6004882045138, 2.0850194077867363],
            [-18.59716527033903, 2.0842829045124582],
            [-18.594351718325782, 2.0801103100046956],
            [-18.587606951698923, 2.0814464592386144],
            [-18.579193972359434, 2.078185642818252],
            [-18.569696943080974, 2.0784710844690646],
            [-18.560527261610634, 2.0740992553986914],
            [-18.556520231822354, 2.080836641321711],
            [-18.543377426123907, 2.0896879886225936],
            [-18.537853958767766, 2.0884165709332474],
            [-18.52297570095413, 2.091708699726198],
            [-18.514677113895143, 2.090979377156345],
            [-18.51069215389326, 2.0918000315201772],
            [-18.506277800526547, 2.0904456060298746],
            [-18.500745048479057, 2.091449762201242],
            [-18.4979051907136, 2.0952460553315144],
            [-18.491557666537425, 2.0976277418152742],
            [-18.483637238397666, 2.098587005225379],
            [-18.47596224775051, 2.0959432932230944],
            [-18.47145245278382, 2.097959862624995],
            [-18.467587333193478, 2.0975583469768724],
            [-18.45988358327155, 2.102040402740049],
            [-18.454613255418767, 2.100046692679659],
            [-18.453624578352855, 2.1053210013590697],
            [-18.448430421294987, 2.114215558843453],
            [-18.44138021331545, 2.1147754518552047],
            [-18.439109553072733, 2.117612912690832],
            [-18.437969661201908, 2.1234024188100205],
            [-18.433835916815298, 2.123764225861995],
            [-18.433730913364126, 2.1350388927341992],
            [-18.431752084855376, 2.136114248316321],
            [-18.429583922467536, 2.1447224176168436],
            [-18.42512356321505, 2.146839321964434],
            [-18.42338607899418, 2.150710498143476],
            [-18.416770049576343, 2.152099585824851],
            [-18.408439875797242, 2.1494053742421237],
            [-18.401276036968312, 2.1499619771254976],
            [-18.395933614688353, 2.1488065757930195],
            [-18.39151692912104, 2.1541545949791194],
            [-18.391648752293378, 2.1587945183049415],
            [-18.389432500424007, 2.160369447390601],
            [-18.38179367663722, 2.158860722489727],
            [-18.373189682814935, 2.1620409784031147],
            [-18.367117233433998, 2.1620442187963578],
            [-18.36408877632583, 2.157801922047115],
            [-18.358389078788868, 2.156673851135178],
            [-18.35515931809019, 2.1600455129712253],
            [-18.352504113693968, 2.1590550998778104],
            [-18.348060788810578, 2.1631317463985216],
            [-18.345146491984412, 2.1636491002272615],
            [-18.3373494268389, 2.1701856782420506],
            [-18.33398929909208, 2.1716283833949053],
            [-18.33359824454022, 2.176034538209974],
            [-18.327948642957736, 2.1752326673262545],
            [-18.328121058524417, 2.17876871113725],
            [-18.318360355431267, 2.174055683711139],
            [-18.310051260758595, 2.174432263337534],
            [-18.303425650886503, 2.173458930153269],
            [-18.299812813161445, 2.1697194609700547],
            [-18.295974407646675, 2.171720254358537],
            [-18.291863887337254, 2.1717402163169557],
            [-18.287664822067097, 2.1742172548071617],
            [-18.287083519433377, 2.1767605600008015],
            [-18.282819974803584, 2.1812146812387154],
            [-18.27205675328018, 2.1843420740756376],
            [-18.264199480666367, 2.1886886259628873],
            [-18.25920218833503, 2.1876457581918887],
            [-18.25758151451283, 2.182213637574324],
            [-18.252995089646404, 2.1811466583128176],
            [-18.247893781150584, 2.177520423292053],
            [-18.24255199383305, 2.1768079126535627],
            [-18.23863323027346, 2.1745869349226328],
            [-18.23822966701407, 2.170353161008992],
            [-18.23439411692193, 2.1680823576858446],
            [-18.22637350514092, 2.1702795409448106],
            [-18.2200718811084, 2.170176885158954],
            [-18.214036156021038, 2.167358201111247],
            [-18.201902398870274, 2.166220746867234],
            [-18.197151461960317, 2.1626362438798146],
            [-18.189699069478877, 2.164258779769439],
            [-18.18671428675534, 2.1659921315674064],
            [-18.175519228454625, 2.164213723049577],
            [-18.166066417429665, 2.167192069437039],
            [-18.159084641912848, 2.163385611721393],
            [-18.154438253806113, 2.1623450311980643],
            [-18.14782228673886, 2.1627984993274296],
            [-18.13831351451838, 2.169719911244985],
            [-18.13409332264639, 2.169655135831175],
            [-18.12436883362707, 2.16466075682381],
            [-18.119219634698272, 2.16804731243509],
            [-18.111863644456815, 2.167025249699226],
            [-18.1036306176665, 2.172143573296908],
            [-18.0939959606133, 2.173111846987631],
            [-18.076151689725286, 2.162757512008368],
            [-18.067840710463106, 2.1613656837638726],
            [-18.06468416340069, 2.1583992141387807],
            [-18.05119740408446, 2.156028377862834],
            [-18.047340395705167, 2.1578486921246722],
            [-18.037314949738654, 2.154393618468524],
            [-18.034921754582747, 2.1523543365181186],
            [-18.023980129268317, 2.1523050756686004],
            [-18.01999495812553, 2.1568214494021785],
            [-18.016119205519217, 2.1574822565797462],
            [-18.01418090308501, 2.1554792144880373],
            [-18.007232843971337, 2.1573348149783325],
            [-18.00540334570618, 2.155711501024935],
            [-17.991827356651097, 2.1558146065981427]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -120.55417334837922, "lat": 38.2045991214195 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06009"],
        "coty_name": ["Calaveras"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calaveras County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01675885"
      },
      "bbox": [
        -18.758069552553174, 1.6084604813378494, -17.97169128433585,
        2.1886886259628873
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.768861607952612, 3.9904927448984555],
            [-19.749845167579945, 3.98527423210091],
            [-19.749585817175273, 3.9862884390512465],
            [-19.736239530179095, 3.982024734660812],
            [-19.54798078173028, 3.9279370829363045],
            [-19.35973401905457, 3.8738044204127577],
            [-19.357049408523274, 3.8732769704673737],
            [-19.266792418207885, 3.8477447743423085],
            [-19.266435705517623, 3.8469143593310027],
            [-19.217111900109764, 3.8322472525746742],
            [-19.213392596384146, 3.83079127183056],
            [-19.174218151672758, 3.8197375848960493],
            [-19.11678164112535, 3.803775940649552],
            [-19.112492675205086, 3.797560217388611],
            [-19.10945537969653, 3.8020665267713354],
            [-19.103522887970257, 3.8029588597319415],
            [-19.1001803162022, 3.799148558245228],
            [-19.105211067065255, 3.788693239872005],
            [-19.11122252688199, 3.7839345475449204],
            [-19.108831242910536, 3.7704717033201653],
            [-19.104776566349454, 3.762516121313538],
            [-19.099605913533924, 3.7587767755843173],
            [-19.0922010216828, 3.746921761780246],
            [-19.089553441066595, 3.739627319094591],
            [-19.087842772334735, 3.730567007598625],
            [-19.0855513385069, 3.72734743765981],
            [-19.080498800097697, 3.7245052458428947],
            [-19.077600137054976, 3.726055380730571],
            [-19.07597519989134, 3.7316216313223767],
            [-19.07150368901499, 3.732257189514944],
            [-19.07042711562258, 3.7267243354522575],
            [-19.07252143905608, 3.7214064066252366],
            [-19.075926044575215, 3.719888731112222],
            [-19.079762171443022, 3.7142565842673174],
            [-19.077012214570193, 3.7090526329412365],
            [-19.072767142188958, 3.7092748613950595],
            [-19.065755686700598, 3.7206323726384714],
            [-19.062059810222483, 3.7183790193921347],
            [-19.063522956927656, 3.7128061347996417],
            [-19.067947658023357, 3.708191473112809],
            [-19.069264315180337, 3.7040241184833786],
            [-19.067749403070824, 3.6995142169038533],
            [-19.068662162770536, 3.696754780516478],
            [-19.066984890779697, 3.6857197968339115],
            [-19.06862196380814, 3.6821951015564367],
            [-19.07226819696161, 3.679046582636213],
            [-19.081125046542088, 3.6785960612595017],
            [-19.083329630497115, 3.6729957141199288],
            [-19.087227646576054, 3.6695947382207725],
            [-19.09338111402351, 3.6709723064043986],
            [-19.097527264403663, 3.6705900553789457],
            [-19.106575818566565, 3.667561623875992],
            [-19.112978990654714, 3.67069923726418],
            [-19.115996539395333, 3.6684317014952454],
            [-19.116629584379325, 3.663776631522855],
            [-19.112714907170602, 3.6589239199414783],
            [-19.108972121484104, 3.658123291688476],
            [-19.10268858621098, 3.660268264732698],
            [-19.098454428320167, 3.6514932041436627],
            [-19.097803354669185, 3.6465617464065083],
            [-19.100068441529842, 3.6429102674262617],
            [-19.105717734044973, 3.6447948573493294],
            [-19.111118577465888, 3.6446676799024758],
            [-19.115139656084228, 3.6425268181456487],
            [-19.1199175887616, 3.6361097165668186],
            [-19.12288665072066, 3.629219732293601],
            [-19.121444553072926, 3.6236382698421137],
            [-19.1181799663851, 3.6217547512270603],
            [-19.116803456160213, 3.6167243723830333],
            [-19.117561468995486, 3.6126972009220713],
            [-19.12045385479864, 3.6099263632386487],
            [-19.128746170330853, 3.6089108312379223],
            [-19.132644755256443, 3.6047542003784043],
            [-19.13453297646566, 3.600600748760393],
            [-19.13560767278671, 3.59437171196448],
            [-19.13768460277479, 3.5899027246030637],
            [-19.137816494407048, 3.584366978349325],
            [-19.143975854579892, 3.580333794519798],
            [-19.14636616079996, 3.577307546125723],
            [-19.146119418674136, 3.5727830539516154],
            [-19.14009301388075, 3.5691399536692576],
            [-19.139468099487836, 3.565995508629506],
            [-19.143489664654645, 3.5643559404526557],
            [-19.150023424587793, 3.5637193775267573],
            [-19.151037236731252, 3.548876780876571],
            [-19.150238584282636, 3.5372338684334936],
            [-19.14488797744525, 3.5326920653879603],
            [-19.138786067350807, 3.53313992067401],
            [-19.136915431235426, 3.5281936267198413],
            [-19.113736512881413, 3.5292533798838046],
            [-19.04826667725657, 3.5118772254405934],
            [-19.04974555279819, 3.5073748956465733],
            [-19.055156184532283, 3.5013283189165287],
            [-19.064006597553533, 3.496954585950424],
            [-19.071005484461885, 3.4895967517460114],
            [-19.071077011410633, 3.4830879615644053],
            [-19.07296073999498, 3.482016543954079],
            [-19.071956497511497, 3.4702179561947775],
            [-19.072880620580758, 3.4645659201758403],
            [-19.075223485434663, 3.4622257476081764],
            [-19.077991556986287, 3.447220182727257],
            [-19.07688851734686, 3.445883447786166],
            [-19.08314192159005, 3.4375230935436036],
            [-19.08265975525155, 3.434133038177785],
            [-19.09003871041056, 3.420411709829833],
            [-19.089342600349305, 3.416195031969151],
            [-19.091588302351788, 3.4099262940198427],
            [-19.093744600566644, 3.4102636030900624],
            [-19.098021452867798, 3.403264678582229],
            [-19.098947939257037, 3.3999583496515604],
            [-19.10312335385022, 3.3945852619417107],
            [-19.103418268626243, 3.3910996746325166],
            [-19.10867466007823, 3.3842084674700175],
            [-19.11283372426605, 3.3767957701409657],
            [-19.114468914050807, 3.370219395774899],
            [-19.202737514767488, 3.394893698329038],
            [-19.200788228143246, 3.3964272424615447],
            [-19.198723271001928, 3.40258916639797],
            [-19.19480174667649, 3.406412884094767],
            [-19.192967211015752, 3.4126895111369695],
            [-19.19441829569097, 3.414962177534663],
            [-19.193986899321445, 3.4235304271275324],
            [-19.246364525088943, 3.438893032133209],
            [-19.287517428251956, 3.450779730738993],
            [-19.29535393612616, 3.4226181183031223],
            [-19.336921266623175, 3.4340899429357776],
            [-19.345180417943457, 3.4361672964334584],
            [-19.384659490888527, 3.4471477833604838],
            [-19.5021682447239, 3.4796230548499483],
            [-19.569355009193174, 3.49886146751024],
            [-19.581273155904487, 3.5030699003188976],
            [-19.599539140533395, 3.508533699522201],
            [-19.69196515966313, 3.534666224164704],
            [-19.71132908686127, 3.53845343289933],
            [-19.739943910887302, 3.5470082447397484],
            [-19.727354112992856, 3.597874399330455],
            [-19.716281036755422, 3.6109608009384844],
            [-19.70662035765679, 3.6418754328122467],
            [-19.703863991330625, 3.653389215852229],
            [-19.702996205226846, 3.667694491574437],
            [-19.692458417616805, 3.701938176373668],
            [-19.682108748624774, 3.7373308043717683],
            [-19.695379720499627, 3.7417260472124356],
            [-19.709466010650093, 3.743961413165004],
            [-19.72291802818141, 3.7481136098486916],
            [-19.73944969506313, 3.754657853373533],
            [-19.75045107397382, 3.7560170006235],
            [-19.784324156455874, 3.766939350298573],
            [-19.792061902960317, 3.7685412339901525],
            [-19.782799152071128, 3.7980059847022405],
            [-19.783709831355267, 3.8110188710994475],
            [-19.76113814494432, 3.894646875895192],
            [-19.775971029524868, 3.898767775861401],
            [-19.764585130225754, 3.9368262247441295],
            [-19.78354133477723, 3.942276251595235],
            [-19.780988706227074, 3.9483398974093737],
            [-19.77100608640659, 3.983663949170402],
            [-19.768861607952612, 3.9904927448984555]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.39197887479274,
          "lat": 39.59814303101324
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06021"],
        "coty_name": ["Glenn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Glenn County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00277275"
      },
      "bbox": [
        -19.792061902960317, 3.370219395774899, -19.04826667725657,
        3.9904927448984555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.721459126802614, 0.8176131742846402],
            [-18.658429756272866, 0.8551659847234703],
            [-18.653677002130298, 0.8517700922982459],
            [-18.649529721729234, 0.8542707760621988],
            [-18.64167126673976, 0.8548815417521335],
            [-18.6395846110097, 0.8527978963322558],
            [-18.63189396668892, 0.8552316584409061],
            [-18.618537836374315, 0.8549670302487488],
            [-18.612171343486956, 0.8570271211692966],
            [-18.600848256664193, 0.855505241902783],
            [-18.598021449732165, 0.8594446812041662],
            [-18.58499958113477, 0.8615384466699597],
            [-18.581065628064756, 0.8642692583434238],
            [-18.576624242289594, 0.8628517604255733],
            [-18.572284695369024, 0.8583592522150574],
            [-18.565837836424574, 0.8551862253256028],
            [-18.55788020400919, 0.856902311258724],
            [-18.547697686541955, 0.8555317594536465],
            [-18.53836730590337, 0.8593324138656346],
            [-18.531958416326642, 0.8637125218201651],
            [-18.52299289464337, 0.8639064043037495],
            [-18.520359092729603, 0.8656116206972644],
            [-18.516164038017575, 0.8642883509899908],
            [-18.507158336117914, 0.8707054730364789],
            [-18.501882639775697, 0.8725546007264451],
            [-18.4961907936009, 0.8717074705674196],
            [-18.4894118827853, 0.8690409916294505],
            [-18.481817922366275, 0.868843127438327],
            [-18.46791617219886, 0.8695060352082977],
            [-18.46508515897632, 0.8677724441739431],
            [-18.45548103501141, 0.8683062009205788],
            [-18.45078357831606, 0.8707109087148711],
            [-18.445156308396385, 0.8679460564720762],
            [-18.44014474566643, 0.8689007150732299],
            [-18.436333132872726, 0.8680449759068548],
            [-18.4317552286611, 0.8650077964097466],
            [-18.426030728314924, 0.8640063970859015],
            [-18.421268256024753, 0.8597431511859482],
            [-18.419278577882267, 0.860786316058348],
            [-18.41227416249424, 0.8595043213879979],
            [-18.410912447638992, 0.862066033422107],
            [-18.406545944331494, 0.8618928376373161],
            [-18.40306434678651, 0.8575623035144566],
            [-18.3933430148094, 0.8585032895115869],
            [-18.38900092012191, 0.8551132324378488],
            [-18.385901981711797, 0.8545308749757421],
            [-18.377616854726558, 0.8558164677492084],
            [-18.36836704873293, 0.8515112808057462],
            [-18.354997040875617, 0.8503480892955994],
            [-18.347220143177534, 0.853353927886549],
            [-18.33969677392427, 0.8522814192522676],
            [-18.332430562444973, 0.8536228115659877],
            [-18.32292125213895, 0.8525510527727134],
            [-18.31194026161272, 0.8552296455467132],
            [-18.141983538599785, 0.9597327241823403],
            [-18.14107943688884, 0.9601699226950936],
            [-18.031675090330538, 1.02715240985649],
            [-18.020308628530692, 1.0249119893278986],
            [-17.947184023153582, 1.0063812476800635],
            [-17.93634651758972, 1.0489621572510541],
            [-17.909122143199735, 1.042228815511858],
            [-17.90062348463672, 1.0746117665696922],
            [-17.877064564248435, 1.068655401121668],
            [-17.860302223571658, 1.1327733635544264],
            [-17.783788398800056, 1.1796213530375805],
            [-17.733557907316023, 1.2104693423630335],
            [-17.597907953193896, 1.2933103166295672],
            [-17.597920943328607, 1.2909636520774732],
            [-17.5885172049237, 1.2804951827813706],
            [-17.591058006042058, 1.2725970082647848],
            [-17.588411863462348, 1.2670442624591824],
            [-17.59032883532089, 1.2571179135297526],
            [-17.58583680697674, 1.254746310578772],
            [-17.579137224618748, 1.2482854012955698],
            [-17.57700914310285, 1.247753822648605],
            [-17.574827758549905, 1.2406542323864798],
            [-17.572673165045874, 1.2399080965460216],
            [-17.57332909209547, 1.2337242455463198],
            [-17.569923529222944, 1.2315212782071345],
            [-17.565595806198637, 1.2354358354003216],
            [-17.559916825688237, 1.2323704984674781],
            [-17.552202026413973, 1.2221428414249615],
            [-17.552719851991615, 1.2189828854208224],
            [-17.543139746427162, 1.213178914779392],
            [-17.536919063307714, 1.219839341085114],
            [-17.533868818148314, 1.2212082766673995],
            [-17.524078098303463, 1.2318764236407622],
            [-17.518510238110512, 1.2316950982166963],
            [-17.516105680503113, 1.2295932376386478],
            [-17.511853709004743, 1.229287368740678],
            [-17.508282934377295, 1.2259884667862337],
            [-17.5001043372819, 1.2275468183772569],
            [-17.498053377007476, 1.224845940631641],
            [-17.492830492802923, 1.223970064779997],
            [-17.491828263822526, 1.2218244938661487],
            [-17.48657293200709, 1.2184911560925789],
            [-17.48104321229242, 1.217631546117164],
            [-17.478259249754558, 1.2199309791238644],
            [-17.474705558074398, 1.216763193065674],
            [-17.468361956623063, 1.2152042500535356],
            [-17.459489487749302, 1.203423817189405],
            [-17.458592285411143, 1.1975156305995796],
            [-17.455574421995973, 1.19356985131521],
            [-17.45602237134057, 1.1910315715072883],
            [-17.452022026669287, 1.1796165005931611],
            [-17.44839558236442, 1.1777266376750628],
            [-17.444547667753493, 1.1693385300612504],
            [-17.439591320072807, 1.1653652267509509],
            [-17.437691458405833, 1.1582735670764446],
            [-17.435386149619426, 1.1556601908357296],
            [-17.434944667101426, 1.1472135908269518],
            [-17.436579034122694, 1.1419558350887784],
            [-17.435765038385824, 1.1358072037737017],
            [-17.439004655937545, 1.1287624814761426],
            [-17.435237976970807, 1.120913968781273],
            [-17.435836309708648, 1.1160810931707683],
            [-17.431806024952376, 1.1053607343850569],
            [-17.423675317734094, 1.0965789944783204],
            [-17.424734357333726, 1.0868118419161763],
            [-17.431588823595764, 1.070455303216707],
            [-17.427841423566804, 1.0614180857911308],
            [-17.426758929120147, 1.050750574645101],
            [-17.679670751982055, 0.894300752777016],
            [-17.693546825171357, 0.8850486924335801],
            [-17.699802626726534, 0.8797613368575514],
            [-17.70460809937387, 0.8774148210658903],
            [-17.708735147973496, 0.8712547867344297],
            [-17.70651348046802, 0.8677063541251946],
            [-17.70783091710874, 0.8646711536492446],
            [-17.711825634574904, 0.8636706482864865],
            [-17.717788232311563, 0.864410029632915],
            [-17.719005811510545, 0.8599801457688486],
            [-17.714432575626756, 0.8550620297219411],
            [-17.713799354684983, 0.8516936107954134],
            [-17.717220702371623, 0.8477144587165086],
            [-17.721677486805532, 0.8484973473352566],
            [-17.729192191336256, 0.8444383651825764],
            [-17.732286898849274, 0.8417090809889707],
            [-17.733273636397268, 0.8338052214883768],
            [-17.731290303755518, 0.8314660222345398],
            [-17.73069319265537, 0.8214564021195958],
            [-17.732886574808845, 0.8162706555137412],
            [-17.735968521705466, 0.8127199490675312],
            [-17.739179937656218, 0.8037028232727585],
            [-17.736348949380304, 0.80013131607398],
            [-17.735484261043613, 0.7943232970250135],
            [-17.737088285595732, 0.7876243296557868],
            [-17.736549983242664, 0.7824414267608711],
            [-17.739470422695394, 0.7740258079019587],
            [-17.747077057413772, 0.7705279251022797],
            [-17.752995665600025, 0.7549820382884551],
            [-17.756600089006923, 0.7521806761555048],
            [-17.755736120450827, 0.7484876474139801],
            [-17.752649231284575, 0.746578689074408],
            [-17.752796703085334, 0.7409241818104996],
            [-17.754704816797485, 0.7370242841950471],
            [-17.761082019117183, 0.7330710501661369],
            [-17.76648929807083, 0.72444086938646],
            [-17.772578882585222, 0.7217193611576039],
            [-17.777216913568676, 0.7219985141006406],
            [-17.783856044252364, 0.7180467195368243],
            [-17.786261579664256, 0.7079783405850939],
            [-17.790879062065834, 0.7044076586256026],
            [-17.79860724193071, 0.7048948478635473],
            [-17.8004973372845, 0.6986299265913958],
            [-17.809233271541324, 0.696074123514607],
            [-17.811347288429605, 0.6926668453358917],
            [-17.82142852499752, 0.6955168290912439],
            [-17.822707679538084, 0.7027779718523196],
            [-17.82541521154704, 0.7083692373976653],
            [-17.83200776841087, 0.7129876750846248],
            [-17.83778360139357, 0.7146851182594046],
            [-17.844021649120748, 0.7133592879596157],
            [-17.8455481959254, 0.7066990745399451],
            [-17.848999697243507, 0.6994509188688203],
            [-17.85572091310884, 0.6981202778277525],
            [-17.86784545919697, 0.7024107911018416],
            [-17.87092608334113, 0.7021166204111868],
            [-17.87335569004572, 0.6966855917532959],
            [-17.87943539419208, 0.6877805132520968],
            [-17.880522284649846, 0.6840019653614502],
            [-17.87977007490915, 0.6787155329097776],
            [-17.885273323461796, 0.6707804234944453],
            [-17.893975919131112, 0.6718032349636945],
            [-17.89893273730143, 0.6836684678567015],
            [-17.89926803775516, 0.6880005411436196],
            [-17.89582093605485, 0.6956871720526286],
            [-17.893576509386158, 0.6978147585493808],
            [-17.893341592826552, 0.7019050564444342],
            [-17.896726301559266, 0.7083738218469441],
            [-17.898902959990995, 0.7094885934754024],
            [-17.903114038401384, 0.7168402207487686],
            [-17.91183629133143, 0.7154668602446671],
            [-17.916175054067892, 0.7076528624756538],
            [-17.918736943782665, 0.7050551454560865],
            [-17.921234768064227, 0.6992858787334862],
            [-17.9245075106435, 0.6994776098238685],
            [-17.927663829665633, 0.7047304786891233],
            [-17.931645418013513, 0.7072168978867982],
            [-17.936333232642216, 0.7180044761380449],
            [-17.939198361677335, 0.7204039079797854],
            [-17.94514701130126, 0.720242699620948],
            [-17.94980593213952, 0.7159029574963287],
            [-17.95199949832815, 0.7060057086833306],
            [-17.958728589335077, 0.6973544896552378],
            [-17.957991058459697, 0.6946723177217345],
            [-17.948195599252863, 0.6919537202208398],
            [-17.943178397664763, 0.6914385140938991],
            [-17.938664704055626, 0.6825966027584249],
            [-17.938313969538846, 0.6772726637271052],
            [-17.94397744469109, 0.6697462795298009],
            [-17.95306644015954, 0.6690885429217055],
            [-17.958597440675668, 0.6657805901629152],
            [-17.96527125629264, 0.6532116754243069],
            [-17.96421673292627, 0.6504608200861498],
            [-17.96605108684755, 0.6441574880273617],
            [-17.97187639775912, 0.6436365441857933],
            [-17.980696460866408, 0.6485093482366729],
            [-17.987215166181194, 0.6507160507566955],
            [-17.990253232593204, 0.6551846198412284],
            [-17.994111701407977, 0.6576698890552507],
            [-17.997983850247792, 0.6580079653019635],
            [-18.00320129400238, 0.6527439674133426],
            [-18.005662519149574, 0.6461560402257489],
            [-18.009492534470613, 0.6398465904619363],
            [-18.00845344730709, 0.6342603159588834],
            [-18.013661512650643, 0.62840670000835],
            [-18.020964306749686, 0.6180494899263407],
            [-18.025505432716827, 0.6172467781792536],
            [-18.031298626708935, 0.6143444526314554],
            [-18.033696209844184, 0.617779305399312],
            [-18.02550498230349, 0.6270779096358968],
            [-18.031255474824373, 0.6375673281413213],
            [-18.04072594563215, 0.63963354086771],
            [-18.04768200665392, 0.6372104543228954],
            [-18.05093155432881, 0.6171649414303509],
            [-18.0534651352103, 0.6120032456723098],
            [-18.063910616590213, 0.6104190223491756],
            [-18.068887528003977, 0.6115265742723186],
            [-18.078453771455322, 0.616960262122668],
            [-18.084852377803756, 0.6152146881143349],
            [-18.088248513275968, 0.6104325845736643],
            [-18.0921870332327, 0.6086590511077892],
            [-18.101369413842963, 0.6008221492915288],
            [-18.117890762214635, 0.5930679956655355],
            [-18.126984034690555, 0.5858012108416554],
            [-18.132532954243807, 0.570009664663272],
            [-18.128190673269877, 0.5687967547440231],
            [-18.127752970452296, 0.5612288997892997],
            [-18.1310331414017, 0.5595429209930399],
            [-18.134442499675163, 0.5602458980258792],
            [-18.138726521767772, 0.556272821003674],
            [-18.14494634997731, 0.5539265925575209],
            [-18.144458426991598, 0.5488598736494502],
            [-18.147770602712868, 0.5433969816099328],
            [-18.153441904131668, 0.5404807844320524],
            [-18.16459906662367, 0.5416222602101536],
            [-18.169213404287728, 0.5329286859241147],
            [-18.182789659974013, 0.5234589306114733],
            [-18.18374964973288, 0.5169411565100545],
            [-18.18244901757234, 0.510876166542224],
            [-18.18479102201314, 0.5054025846862966],
            [-18.18788606846158, 0.5033207414871707],
            [-18.1947395462409, 0.503239050752521],
            [-18.200172410485017, 0.4966209546561853],
            [-18.20693264584687, 0.4940568705047657],
            [-18.21324597039545, 0.48279043650447406],
            [-18.217554791787702, 0.481663068220767],
            [-18.221254015854957, 0.4831697526301698],
            [-18.230281004790914, 0.4912231755862705],
            [-18.23107927571183, 0.498854608246267],
            [-18.236798445894117, 0.4991987857374761],
            [-18.237788856547738, 0.49634985147524824],
            [-18.243630162462114, 0.49175834130378326],
            [-18.248292319860152, 0.4962848995645454],
            [-18.252085319377017, 0.4940682958708565],
            [-18.256337657456964, 0.49593670855645927],
            [-18.265704871877467, 0.5049303699336708],
            [-18.271622903186106, 0.4991376720795027],
            [-18.275194402250932, 0.5011233074167746],
            [-18.281220231781788, 0.5018842249315381],
            [-18.287390300113433, 0.4976269609261229],
            [-18.29567633432068, 0.49858208186559266],
            [-18.3011607892627, 0.5035222198908561],
            [-18.305862210374315, 0.5005679068895427],
            [-18.30898255310341, 0.4946560111256905],
            [-18.316865845214526, 0.4925219077898094],
            [-18.328038056531454, 0.49690168840761884],
            [-18.335013855645975, 0.49558133663593973],
            [-18.342340153480155, 0.500144599682101],
            [-18.343226034673823, 0.5052565478801752],
            [-18.346733646965145, 0.5073171265041916],
            [-18.35144235742105, 0.5058121674117639],
            [-18.354006055976296, 0.4984783583824655],
            [-18.360388497591575, 0.49692167840846657],
            [-18.371931848630204, 0.500667133045094],
            [-18.37768421133459, 0.49898566053086746],
            [-18.380515615941082, 0.4937962534827069],
            [-18.386769973933397, 0.49016882461755007],
            [-18.39205887868934, 0.49300874057196076],
            [-18.39737669575482, 0.4939649787601529],
            [-18.402345042580897, 0.5018816811906573],
            [-18.408473936129635, 0.5042155468823519],
            [-18.414699027159216, 0.5023794755347675],
            [-18.418419495781265, 0.5026654470476064],
            [-18.420843216317344, 0.5092799363467543],
            [-18.42341511538894, 0.5109709195354434],
            [-18.433820652862373, 0.5093292592923918],
            [-18.437261596529595, 0.506799860569164],
            [-18.445490215685815, 0.5041804885721759],
            [-18.44979211846019, 0.5044914729584596],
            [-18.4530427787403, 0.5068570262865043],
            [-18.464963419580172, 0.507578237784219],
            [-18.471318357782106, 0.5066500207547394],
            [-18.47780146741939, 0.5034941866450944],
            [-18.488380764930817, 0.5001488726350677],
            [-18.492196263457153, 0.5002805566090355],
            [-18.497450959574984, 0.5073508975894115],
            [-18.501154344265252, 0.5072703810750682],
            [-18.503751961636034, 0.5012882643092574],
            [-18.511551930955765, 0.49496479386460873],
            [-18.51243211394444, 0.49019376002357307],
            [-18.51978635050742, 0.48493780171773737],
            [-18.522667923845546, 0.4857375320816551],
            [-18.523672521945738, 0.48924224433332786],
            [-18.52808879634364, 0.49392075180517664],
            [-18.526607238272412, 0.5008972076750983],
            [-18.538670832035233, 0.5026412867684327],
            [-18.542092313158122, 0.5013823031385277],
            [-18.544183781263428, 0.4979104896072087],
            [-18.550355989210043, 0.4993945632181344],
            [-18.55271553621968, 0.49836211149480836],
            [-18.552817457081662, 0.48613080810363957],
            [-18.557614319884184, 0.48725266750873014],
            [-18.56472898465518, 0.4913465806549749],
            [-18.566130122572584, 0.495638131226822],
            [-18.569567054296108, 0.49507282923883417],
            [-18.57205467044483, 0.49190822566186354],
            [-18.575903834308427, 0.4952350760118043],
            [-18.583569987816645, 0.49656603301217656],
            [-18.584755256761184, 0.49941933136812483],
            [-18.59292069476882, 0.4939156205854704],
            [-18.591800652857344, 0.49926503812655726],
            [-18.597089149721466, 0.5011128808717324],
            [-18.598961732409084, 0.49848734095094954],
            [-18.598834899798593, 0.4934580588024427],
            [-18.601318745561542, 0.4922537865343899],
            [-18.603098885401486, 0.4966518164051147],
            [-18.600506479197882, 0.500148345722955],
            [-18.60440964538364, 0.5027001868938167],
            [-18.60671265774304, 0.5101047813060288],
            [-18.614347180636898, 0.5152858817266642],
            [-18.61558111538389, 0.5128066830616306],
            [-18.62147116981649, 0.5128102787152743],
            [-18.62292611537179, 0.5154826363734629],
            [-18.621185522900536, 0.5217175693429524],
            [-18.628138443637607, 0.5203093267956259],
            [-18.630438736151397, 0.5219122745172965],
            [-18.62764492361269, 0.5282962418207761],
            [-18.629391966430887, 0.5302229881534607],
            [-18.634406820793032, 0.5300060810969726],
            [-18.635476431503022, 0.5373046535055865],
            [-18.639363986962017, 0.5360070639344207],
            [-18.63828616192973, 0.5292322042345698],
            [-18.638749786753802, 0.5244944369959512],
            [-18.643204389541825, 0.528061676722393],
            [-18.64695529745687, 0.5293846745947441],
            [-18.655974371941348, 0.5292645620017943],
            [-18.657890110869378, 0.5340867446781439],
            [-18.653707960415417, 0.5403202420768616],
            [-18.655910320924043, 0.5453887839981278],
            [-18.6540073089821, 0.5484593226898464],
            [-18.649791508364796, 0.5504455251041406],
            [-18.649862066891917, 0.5543288731693866],
            [-18.656229880453576, 0.5547367027757216],
            [-18.655393667496757, 0.5628881551701644],
            [-18.661146873463977, 0.5719906693269916],
            [-18.670624473861864, 0.5723581051326506],
            [-18.672371689793383, 0.5765056145482886],
            [-18.671528916264425, 0.5803364203242777],
            [-18.673048048270342, 0.5892205233800011],
            [-18.67979891383383, 0.5885625414605703],
            [-18.682544914161415, 0.593994909302218],
            [-18.68595902726954, 0.5948628331505125],
            [-18.688832851341584, 0.6065487550821178],
            [-18.694003387502768, 0.6075104669501475],
            [-18.691389330292612, 0.6112994209280379],
            [-18.696783652091128, 0.6144530123676122],
            [-18.69789629356761, 0.6191072582639081],
            [-18.701840215470316, 0.6200164246477882],
            [-18.70281593034595, 0.623046963674401],
            [-18.69672126937211, 0.6273606057479799],
            [-18.696114800295092, 0.63001137492164],
            [-18.70107478638224, 0.6332059479300239],
            [-18.70000210624893, 0.6384024319642889],
            [-18.696233029828022, 0.6400299952738],
            [-18.697653309000085, 0.643585703697915],
            [-18.70289835185357, 0.6478620957760983],
            [-18.703327589772528, 0.6538016241705762],
            [-18.696169693201913, 0.6628596106149527],
            [-18.691698919402455, 0.6645122718207381],
            [-18.685880877494757, 0.669024013123088],
            [-18.687320060025947, 0.6730523173801762],
            [-18.69157000680289, 0.6747938649028824],
            [-18.692671883295294, 0.6794174350455754],
            [-18.688102920413094, 0.6811882915185598],
            [-18.69079731352599, 0.6874127302735895],
            [-18.692652223342844, 0.6982626867501429],
            [-18.697671913688573, 0.7014427366792706],
            [-18.69817522026318, 0.7115646060555801],
            [-18.69603510056267, 0.7156061969692432],
            [-18.696799925044616, 0.7220854609393998],
            [-18.700876161789235, 0.7286207779423721],
            [-18.700714853921497, 0.7319996844183294],
            [-18.696114639975058, 0.7341631373806533],
            [-18.70056747685666, 0.7403457979406449],
            [-18.703270791740366, 0.7410697179114137],
            [-18.70332605178575, 0.7451186418247905],
            [-18.70531936722901, 0.7480538434241367],
            [-18.703875353440605, 0.7594537881858924],
            [-18.702788031721074, 0.762817330155835],
            [-18.707380448756513, 0.7682360189413099],
            [-18.705939105103077, 0.7750061027112182],
            [-18.708769750101546, 0.779239043667485],
            [-18.71357441849601, 0.7808375537258722],
            [-18.715213332956875, 0.7841821787071354],
            [-18.719329746624325, 0.7837053948228713],
            [-18.719332856094393, 0.7916556164693128],
            [-18.724713558993656, 0.7927921078684596],
            [-18.72382146303975, 0.7966686628563926],
            [-18.728757959440696, 0.8018693599138828],
            [-18.721204600364196, 0.8066673005465294],
            [-18.719168392242896, 0.812132836190785],
            [-18.721459126802614, 0.8176131742846402]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.76259241418602,
          "lat": 37.21805233870673
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06039"],
        "coty_name": ["Madera"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madera County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00277284"
      },
      "bbox": [
        -18.728757959440696, 0.481663068220767, -17.423675317734094,
        1.2933103166295672
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.220665989950284, 1.0457171819256252],
            [-19.21643770753087, 1.0483385482736254],
            [-19.07741729906732, 1.1307539753451519],
            [-19.065657450139636, 1.136974152344752],
            [-19.06049697569354, 1.1406747260866006],
            [-19.015694872418084, 1.167021370154804],
            [-19.000781292729584, 1.1767224227587232],
            [-18.974182358387008, 1.1917650235364448],
            [-18.965666644392556, 1.197047421263976],
            [-18.96835483340014, 1.1984255907701653],
            [-18.970547938786353, 1.202731775625661],
            [-18.973512906899636, 1.2035803692635534],
            [-18.973387458094948, 1.2113780687327835],
            [-18.97158653326522, 1.2159410896606573],
            [-18.9730272955804, 1.2210488497077874],
            [-18.96820870410128, 1.2210700332336615],
            [-18.968671268189603, 1.2270050050673507],
            [-18.965923441479738, 1.2307446261008683],
            [-18.97282302164661, 1.230074748103559],
            [-18.972881682369596, 1.23348096683451],
            [-18.968299546658624, 1.239590487178162],
            [-18.969913239241436, 1.2416753857566345],
            [-18.976679721290065, 1.2417638091354883],
            [-18.971784086513193, 1.251155151705383],
            [-18.965929815650977, 1.2538381515213035],
            [-18.928691932820573, 1.2616384432463486],
            [-18.925002227802747, 1.2635954910488416],
            [-18.880868411153372, 1.273589243759902],
            [-18.867831802352693, 1.2754413883986997],
            [-18.853145594209963, 1.278950603679627],
            [-18.84267219653971, 1.2801453768440243],
            [-18.827038190629636, 1.2833052566881784],
            [-18.8202879697198, 1.2853587831925577],
            [-18.80676150484367, 1.2881082688938337],
            [-18.794358666047643, 1.290038490617601],
            [-18.762840721120902, 1.296657808160035],
            [-18.658737025461882, 1.3182360748065354],
            [-18.654664744783904, 1.3193178609658125],
            [-18.570854946504568, 1.3370693356925663],
            [-18.452808485470907, 1.3616609854614756],
            [-18.45045717159797, 1.3499498673433117],
            [-18.429494231166167, 1.2386385851119586],
            [-18.42920431080227, 1.2312600833656027],
            [-18.43151656087417, 1.222739055499449],
            [-18.42979938919489, 1.2135619338564105],
            [-18.42514417421349, 1.2056685750494862],
            [-18.422574513319603, 1.2029256540605646],
            [-18.424536752949418, 1.1986853312064059],
            [-18.421680875008036, 1.1934750137231291],
            [-18.418430647793663, 1.180685475707512],
            [-18.417659394243117, 1.174564497291095],
            [-18.415562909150463, 1.168852997749895],
            [-18.416711376247424, 1.1600081216080098],
            [-18.415704979190206, 1.153955332669679],
            [-18.419837346178582, 1.1475892490644797],
            [-18.42545780701654, 1.1448590896472488],
            [-18.427038266552607, 1.1368062274250121],
            [-18.426300369692704, 1.1338932290857662],
            [-18.422678911092156, 1.1299007838365234],
            [-18.419865217866143, 1.1101456737941562],
            [-18.416273852549956, 1.0987776773114666],
            [-18.41512756743901, 1.0930488450839888],
            [-18.410598774631246, 1.086452629707207],
            [-18.409741285319846, 1.0797748003604983],
            [-18.404347542593936, 1.0618319291014566],
            [-18.403597658682077, 1.0548246730508288],
            [-18.402061836307276, 1.0525267547456123],
            [-18.39828215652415, 1.0385051920107002],
            [-18.395740369141365, 1.0249046252778926],
            [-18.394505098149992, 1.012467666007906],
            [-18.385558567845813, 0.9973613707116618],
            [-18.38421496347679, 0.9869272614461377],
            [-18.390026601571467, 0.9768329509056057],
            [-18.3903180822287, 0.9666978204342414],
            [-18.387927759584105, 0.9567229879566113],
            [-18.384482961150155, 0.9507806104962345],
            [-18.367802936323443, 0.9281971411155892],
            [-18.355957712428797, 0.9179051934311502],
            [-18.346909888295666, 0.9116902115320228],
            [-18.342223223626178, 0.9067862510617866],
            [-18.33335536996196, 0.9019760044755205],
            [-18.328754844118205, 0.8967441085260809],
            [-18.326388250180116, 0.8900687806823341],
            [-18.320895241502186, 0.8802629952587782],
            [-18.319388799367168, 0.8752823650122789],
            [-18.315929170029992, 0.8717237711570495],
            [-18.31474857510254, 0.8610835990996278],
            [-18.31194026161272, 0.8552296455467132],
            [-18.32292125213895, 0.8525510527727134],
            [-18.332430562444973, 0.8536228115659877],
            [-18.33969677392427, 0.8522814192522676],
            [-18.347220143177534, 0.853353927886549],
            [-18.354997040875617, 0.8503480892955994],
            [-18.36836704873293, 0.8515112808057462],
            [-18.377616854726558, 0.8558164677492084],
            [-18.385901981711797, 0.8545308749757421],
            [-18.38900092012191, 0.8551132324378488],
            [-18.3933430148094, 0.8585032895115869],
            [-18.40306434678651, 0.8575623035144566],
            [-18.406545944331494, 0.8618928376373161],
            [-18.410912447638992, 0.862066033422107],
            [-18.41227416249424, 0.8595043213879979],
            [-18.419278577882267, 0.860786316058348],
            [-18.421268256024753, 0.8597431511859482],
            [-18.426030728314924, 0.8640063970859015],
            [-18.4317552286611, 0.8650077964097466],
            [-18.436333132872726, 0.8680449759068548],
            [-18.44014474566643, 0.8689007150732299],
            [-18.445156308396385, 0.8679460564720762],
            [-18.45078357831606, 0.8707109087148711],
            [-18.45548103501141, 0.8683062009205788],
            [-18.46508515897632, 0.8677724441739431],
            [-18.46791617219886, 0.8695060352082977],
            [-18.481817922366275, 0.868843127438327],
            [-18.4894118827853, 0.8690409916294505],
            [-18.4961907936009, 0.8717074705674196],
            [-18.501882639775697, 0.8725546007264451],
            [-18.507158336117914, 0.8707054730364789],
            [-18.516164038017575, 0.8642883509899908],
            [-18.520359092729603, 0.8656116206972644],
            [-18.52299289464337, 0.8639064043037495],
            [-18.531958416326642, 0.8637125218201651],
            [-18.53836730590337, 0.8593324138656346],
            [-18.547697686541955, 0.8555317594536465],
            [-18.55788020400919, 0.856902311258724],
            [-18.565837836424574, 0.8551862253256028],
            [-18.572284695369024, 0.8583592522150574],
            [-18.576624242289594, 0.8628517604255733],
            [-18.581065628064756, 0.8642692583434238],
            [-18.58499958113477, 0.8615384466699597],
            [-18.598021449732165, 0.8594446812041662],
            [-18.600848256664193, 0.855505241902783],
            [-18.612171343486956, 0.8570271211692966],
            [-18.618537836374315, 0.8549670302487488],
            [-18.63189396668892, 0.8552316584409061],
            [-18.6395846110097, 0.8527978963322558],
            [-18.64167126673976, 0.8548815417521335],
            [-18.649529721729234, 0.8542707760621988],
            [-18.653677002130298, 0.8517700922982459],
            [-18.658429756272866, 0.8551659847234703],
            [-18.721459126802614, 0.8176131742846402],
            [-18.77361670351713, 0.786497078266866],
            [-18.77677403051152, 0.7843313033200504],
            [-18.77283933557954, 0.781326385335399],
            [-18.77191243434807, 0.7763146089266539],
            [-18.76862013448292, 0.7744638462849452],
            [-18.77060143323732, 0.7687950865003845],
            [-18.774983462055772, 0.7661155770345986],
            [-18.782538788710006, 0.7378275389188723],
            [-18.83251179738713, 0.7512702369006008],
            [-18.88538857049123, 0.7197574471262569],
            [-18.950850001119573, 0.6804129508893355],
            [-19.04508889445162, 0.6240133655559225],
            [-19.047368351307703, 0.6223412946814515],
            [-19.077748532554754, 0.6047106949918188],
            [-19.08905752864402, 0.5977394242741801],
            [-19.097359306359692, 0.6118037844941984],
            [-19.13659476214023, 0.6474209700475497],
            [-19.141846525588964, 0.6527659973495863],
            [-19.220016171562634, 0.7239454848159393],
            [-19.23438246431945, 0.737584817798335],
            [-19.232988301532927, 0.7472963902735873],
            [-19.235230472099982, 0.7557348733958039],
            [-19.236427243046514, 0.7645555780271373],
            [-19.235299526835675, 0.7678471150166063],
            [-19.2426544453377, 0.7739136732445913],
            [-19.242972001355664, 0.7831869333870058],
            [-19.241757332168007, 0.7847571723203489],
            [-19.242923193050128, 0.7908034133845887],
            [-19.24633201878299, 0.7921347612015333],
            [-19.249289155711452, 0.7978533182086794],
            [-19.251314861362726, 0.8046521053163574],
            [-19.24881038920616, 0.8097741035570768],
            [-19.247903370009123, 0.8159770469586465],
            [-19.250296964266457, 0.8220055046406111],
            [-19.253769487197513, 0.822365288454822],
            [-19.257249322324526, 0.8250433201578318],
            [-19.265701231268828, 0.8243998018535232],
            [-19.271824376809985, 0.8281303633463093],
            [-19.275974013834862, 0.825905962914714],
            [-19.275785110711272, 0.836318608925432],
            [-19.279780367657107, 0.8383859166284034],
            [-19.28174541900008, 0.8448344244076861],
            [-19.275538221683664, 0.8552788013532862],
            [-19.27044956289063, 0.8601372486704894],
            [-19.263828546730622, 0.8619295181377044],
            [-19.256258577326403, 0.8695228017718086],
            [-19.257922489382736, 0.8743007012029365],
            [-19.260755458433902, 0.8768729823714048],
            [-19.263483677546997, 0.8822824836387316],
            [-19.268667620405594, 0.8852180204480204],
            [-19.271540544479283, 0.8904236422117251],
            [-19.27542451157723, 0.9018535031313789],
            [-19.274934390088394, 0.9059177740446666],
            [-19.272231692781585, 0.9113283151800723],
            [-19.268286841815183, 0.9149205928298294],
            [-19.261370040606288, 0.9150956149754387],
            [-19.262136243079038, 0.926409662745962],
            [-19.25936236857642, 0.929165520193203],
            [-19.264227064911548, 0.9433144157209437],
            [-19.264015484910733, 0.9515359385408536],
            [-19.25887306202237, 0.9482811255406929],
            [-19.253698410921935, 0.952346834059633],
            [-19.244084307115426, 0.9526606451281532],
            [-19.241811669052694, 0.9649405157742637],
            [-19.235074859890013, 0.9684118928274661],
            [-19.231287566311355, 0.9652477435674272],
            [-19.227209928645458, 0.9678906452096697],
            [-19.225196607907744, 0.9773450320125634],
            [-19.229636287702757, 0.979576258334262],
            [-19.23385457795143, 0.9855254383085557],
            [-19.233802384311254, 0.9908771787391165],
            [-19.240147004858184, 1.0002297837876941],
            [-19.245383251510574, 1.0004965426152526],
            [-19.24699130680307, 1.005139842158277],
            [-19.24416788102415, 1.0080996888632376],
            [-19.240441001767618, 1.0078237561257253],
            [-19.2334573796694, 1.009614024693306],
            [-19.231263380274886, 1.0174176490993703],
            [-19.22709941590877, 1.0182433004367466],
            [-19.22692414258458, 1.0211940670215274],
            [-19.216560952876833, 1.0323278364296768],
            [-19.219167374162822, 1.0360301921513926],
            [-19.218571248202114, 1.0410196190607919],
            [-19.220665989950284, 1.0457171819256252]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -120.7176621951165, "lat": 37.19188212874575 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06047"],
        "coty_name": ["Merced"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Merced County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00277288"
      },
      "bbox": [
        -19.28174541900008, 0.5977394242741801, -18.31194026161272,
        1.3616609854614756
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.54094438508006, 4.320992215067176],
            [-18.445168448724782, 4.295159353179725],
            [-18.429913473833995, 4.294952291112494],
            [-18.424520940635194, 4.2890712372290665],
            [-18.417457380016845, 4.287026031552231],
            [-18.403358937073808, 4.282901947602919],
            [-18.391812776536202, 4.280478792465651],
            [-18.334395502207787, 4.265179384785704],
            [-18.320603546283557, 4.261895437448543],
            [-18.278539620823928, 4.250140670279886],
            [-18.2702578936247, 4.2483442925203025],
            [-18.223199124223374, 4.235654415332282],
            [-18.257517818131728, 4.107491157188904],
            [-18.27107018629381, 4.058043129247322],
            [-18.273247811896663, 4.05097257912853],
            [-18.25864530547401, 4.04710123642053],
            [-18.26434491837467, 4.026035605792324],
            [-18.23683633928347, 4.018791599544628],
            [-18.24036500194045, 4.005181688537949],
            [-18.19835703378736, 3.9937352549353924],
            [-18.202807846883164, 3.9800145240462026],
            [-18.188868535783925, 3.976229801106848],
            [-18.193044548443723, 3.962214963796523],
            [-18.16525713859939, 3.95497139623103],
            [-18.163373607742297, 3.962069115179153],
            [-18.149597011053668, 3.9583731237224447],
            [-18.13853482992059, 3.9994364488877396],
            [-18.124852758201925, 3.99595217319169],
            [-18.12307102079166, 4.002824281452349],
            [-18.116047637327533, 4.0009881933301115],
            [-18.11411989858001, 4.007899395102922],
            [-18.107180732110077, 4.006195943962839],
            [-18.103210056343, 4.020313463606259],
            [-18.089470658565343, 4.016647922533323],
            [-18.08735526558582, 4.023484917497296],
            [-18.073757740423854, 4.01975388006478],
            [-18.06826995981886, 4.042471298912132],
            [-18.05137784705333, 4.038492458768673],
            [-18.04943804401308, 4.0455217634306155],
            [-18.042575980878144, 4.043738065774774],
            [-18.04072227058613, 4.050840180650204],
            [-18.013117828074552, 4.043420155515946],
            [-18.01494861016751, 4.036099443167317],
            [-17.980479721596147, 4.027056971467138],
            [-17.960906090916783, 4.0209627256626],
            [-17.962400105168992, 4.013855729208895],
            [-17.955605608397182, 4.01199719572855],
            [-17.957597511712628, 4.005017694512163],
            [-17.943140707533743, 4.001017033081414],
            [-17.94512723879729, 3.9939370295792362],
            [-17.9116001759358, 3.9847901945512505],
            [-17.917111622551555, 3.9637203617014287],
            [-17.89668644854576, 3.9581256769703126],
            [-17.89852858942416, 3.9509892983598585],
            [-17.88467864742971, 3.947265489854181],
            [-17.886508456340348, 3.9404536752628716],
            [-17.872737090541314, 3.936566059246908],
            [-17.876292095858005, 3.922669896955113],
            [-17.862407935835556, 3.9191146446585683],
            [-17.8663864523413, 3.905067079450316],
            [-17.859387655829412, 3.903114754978083],
            [-17.863369513976323, 3.889185249787606],
            [-17.842508071077965, 3.883656371970492],
            [-17.84607333502679, 3.869606519912356],
            [-17.839580813894294, 3.8679044650906236],
            [-17.84374780971343, 3.8539007384175394],
            [-17.836899794881376, 3.851887391794894],
            [-17.838646117417888, 3.84497229478646],
            [-17.82442954603717, 3.8411173457024193],
            [-17.826563926140086, 3.8340103107642447],
            [-17.819476121447618, 3.8322444160547153],
            [-17.823524530681798, 3.817888956243624],
            [-17.8164159878711, 3.8160381838893023],
            [-17.818176266212237, 3.8094989838265954],
            [-17.804135374962968, 3.8057354874569227],
            [-17.807169830688487, 3.7950318918572146],
            [-17.793239610770055, 3.79141058586285],
            [-17.795188815443566, 3.784615524642327],
            [-17.78114143911729, 3.78098731480511],
            [-17.78295356959337, 3.7738492411723117],
            [-17.7552597439686, 3.766210984707613],
            [-17.734501491126434, 3.7607554066249373],
            [-17.727930828787038, 3.760146814515589],
            [-17.729319865028664, 3.7520575406988375],
            [-17.715463993021647, 3.748592841452051],
            [-17.721161429659375, 3.727098678110286],
            [-17.707888651437166, 3.723237940187814],
            [-17.693780781192956, 3.7201899497731494],
            [-17.70109864075723, 3.691164614381625],
            [-17.702569476039063, 3.691589467871372],
            [-17.70569522401138, 3.6782795521124507],
            [-17.698720536496346, 3.6764467022329055],
            [-17.70607156250743, 3.6479042941737863],
            [-17.692309122836722, 3.644201822762142],
            [-17.696053675992044, 3.6297424004216956],
            [-17.68915994809508, 3.627749533571592],
            [-17.693024490472002, 3.6137297978060654],
            [-17.685800629320244, 3.6117425229596214],
            [-17.689820786125207, 3.597049899719853],
            [-17.682999099974708, 3.595150980040332],
            [-17.68460386601281, 3.5891328785814727],
            [-17.677735245821992, 3.5872911711983746],
            [-17.679550038936334, 3.5802431007166535],
            [-17.67275182585772, 3.578453636504825],
            [-17.674622552481157, 3.571359599241144],
            [-17.66796498106167, 3.569627009873213],
            [-17.66994192472421, 3.5616082321367193],
            [-17.65685244760214, 3.558177437450794],
            [-17.664321115496104, 3.5297919483829574],
            [-17.657467757223422, 3.5279825514040577],
            [-17.664680271985215, 3.4995459691067863],
            [-17.671116059041154, 3.501259843665413],
            [-17.684670788744153, 3.4497408936050724],
            [-17.692950250151505, 3.4163132674616516],
            [-17.698744629515026, 3.4038691445559284],
            [-17.702228713081336, 3.3891188287372778],
            [-17.708870342088545, 3.390679882832294],
            [-17.71220519334457, 3.3764089229642735],
            [-17.718524693832297, 3.377906967575937],
            [-17.722369315477952, 3.3635022558913614],
            [-17.736183470593815, 3.3673388385670857],
            [-17.743895948057677, 3.3394111210234465],
            [-17.819383250196257, 3.3594136393534755],
            [-17.820333297755482, 3.3601066985402697],
            [-17.860971590198474, 3.3702658520993882],
            [-17.902320632805118, 3.381546213330412],
            [-17.96429147600804, 3.397864150147136],
            [-17.978854744051738, 3.399491348292393],
            [-17.99550690515473, 3.4039944907556396],
            [-18.046431948557366, 3.4173251787594614],
            [-18.11799029492631, 3.436376632120038],
            [-18.12237442277015, 3.4239148601528813],
            [-18.127563731357387, 3.4176143462917548],
            [-18.133342108198455, 3.4154491335429653],
            [-18.136845774478964, 3.4161631109326045],
            [-18.145258929950455, 3.4125434025571915],
            [-18.146198871570455, 3.417098268766239],
            [-18.14928306074117, 3.4211158789657996],
            [-18.151907514652343, 3.429817757775096],
            [-18.15716848730942, 3.4306823301939176],
            [-18.159421225680518, 3.439654103784052],
            [-18.16200791628569, 3.44474989963245],
            [-18.166510648328558, 3.450520586739577],
            [-18.171364139460316, 3.4508800732619096],
            [-18.17638972675801, 3.4535251413120025],
            [-18.17681908027159, 3.456468891796266],
            [-18.181448168725357, 3.45938334741273],
            [-18.18510577534398, 3.467750295612466],
            [-18.19279694380046, 3.4676974855842433],
            [-18.200068068881464, 3.470039221499568],
            [-18.20276662102028, 3.466070686732767],
            [-18.21723541930144, 3.466771843914582],
            [-18.21701918801941, 3.471542169581085],
            [-18.218443827564805, 3.475337820297949],
            [-18.22461261365208, 3.479634727239022],
            [-18.2280145138541, 3.479475946654937],
            [-18.229099860629148, 3.4854735542780375],
            [-18.227707799606314, 3.494640650962753],
            [-18.228154888946545, 3.4970685827075867],
            [-18.225639869866555, 3.502210271879116],
            [-18.226469850893043, 3.5072429133180147],
            [-18.229992860596568, 3.5048665631371065],
            [-18.23576944786819, 3.5046651480750963],
            [-18.23603296728349, 3.509666852764253],
            [-18.244601268079375, 3.5121425552779733],
            [-18.246019412222413, 3.5170314241164586],
            [-18.245080302492664, 3.5217914497214937],
            [-18.251507672189085, 3.527447838158653],
            [-18.252805760591247, 3.534461521417567],
            [-18.2525062648601, 3.538717639760902],
            [-18.256195164253246, 3.5431426736710763],
            [-18.261485827178234, 3.546761439564743],
            [-18.26396034824747, 3.5436039946549736],
            [-18.268051144494702, 3.54348391365399],
            [-18.27719316497535, 3.5391199984484514],
            [-18.281567592714136, 3.535418821681018],
            [-18.287414577224354, 3.536907505325388],
            [-18.29014529033149, 3.5351061262614265],
            [-18.295976744940255, 3.5365360785600197],
            [-18.299172025242243, 3.5332280832155747],
            [-18.30413670772923, 3.532187111293886],
            [-18.3079562674873, 3.5263137407114264],
            [-18.31587197356205, 3.5226427541624763],
            [-18.325524822639423, 3.4864527901312337],
            [-18.331454549569177, 3.479140958756819],
            [-18.333769924548413, 3.473000778322002],
            [-18.338504605124303, 3.4683417359884245],
            [-18.34526722331032, 3.465464050919959],
            [-18.344310350742113, 3.4611637554371746],
            [-18.34904517361478, 3.458570660803677],
            [-18.356969501129083, 3.456733535697768],
            [-18.35832695658638, 3.45361739297303],
            [-18.363478384947282, 3.4492128353442433],
            [-18.368537462922415, 3.447325258698796],
            [-18.373023103517, 3.444143534272766],
            [-18.375749671105265, 3.4448716768133987],
            [-18.378836384646043, 3.441360340547153],
            [-18.38228908724143, 3.441540876459395],
            [-18.386220169786185, 3.439080886594315],
            [-18.393036434198674, 3.4383513333331823],
            [-18.397211957653806, 3.440847172116956],
            [-18.434488656469185, 3.4241043129036663],
            [-18.457831812557554, 3.4131364814605996],
            [-18.458182482442982, 3.4195831199425295],
            [-18.465250426928872, 3.4214437356841643],
            [-18.462572970321183, 3.431408173343905],
            [-18.46898369297337, 3.4332977659837076],
            [-18.46696394479514, 3.440272835082401],
            [-18.480777518478735, 3.444122470190664],
            [-18.47914653098376, 3.45101974809399],
            [-18.493905739239345, 3.4551342062168957],
            [-18.486125680521898, 3.4829268840762713],
            [-18.499873493318955, 3.4866184828484896],
            [-18.498040752562662, 3.493563122485289],
            [-18.5037469621107, 3.4950141357999684],
            [-18.501966235384103, 3.502009298838535],
            [-18.507921856490505, 3.5037266524891377],
            [-18.504130415325303, 3.517811045599529],
            [-18.518237686603772, 3.5214111129305214],
            [-18.51457637531709, 3.5355950998235106],
            [-18.527808494383784, 3.5396686689487193],
            [-18.524947082106067, 3.5509197260878267],
            [-18.52616887854373, 3.551296915264257],
            [-18.522727666861982, 3.5646943959969257],
            [-18.536377756622795, 3.568411406268352],
            [-18.53271674916365, 3.582604930015318],
            [-18.546399384243024, 3.586139428730711],
            [-18.544940800796628, 3.591790965118667],
            [-18.54476086208806, 3.600309742984182],
            [-18.55716544606554, 3.6038916164072945],
            [-18.55348724492601, 3.6180870586161693],
            [-18.56671644801371, 3.620456891558738],
            [-18.56234856063857, 3.633834906423109],
            [-18.56567622348927, 3.6348245013928753],
            [-18.56464531343498, 3.6384924863325545],
            [-18.568122237223804, 3.6395040609645672],
            [-18.567055366996613, 3.6431267376896055],
            [-18.5770745062378, 3.645973248566157],
            [-18.575076056909282, 3.652999527355498],
            [-18.581831162141818, 3.6549283872884053],
            [-18.579183142168077, 3.6690368226990473],
            [-18.589322170205946, 3.6719520861647217],
            [-18.58540025770782, 3.6861715540053486],
            [-18.598998783853258, 3.6898864399665046],
            [-18.595292041026028, 3.7041672831278123],
            [-18.602113875438032, 3.7064349524916205],
            [-18.598699480751424, 3.7208859901452445],
            [-18.61263662103251, 3.7246349594246886],
            [-18.61064302300043, 3.731811934662831],
            [-18.62410733857216, 3.7355599573848517],
            [-18.622226604787468, 3.7438201334837067],
            [-18.631665680187513, 3.746539489763476],
            [-18.623245989738553, 3.7745226421408478],
            [-18.637173770117542, 3.778213997321622],
            [-18.63333992336397, 3.792326543753562],
            [-18.61933645580071, 3.7887669904969767],
            [-18.615574901183244, 3.802713129577981],
            [-18.622481214352135, 3.804781740409865],
            [-18.61420745037295, 3.832817390547558],
            [-18.60727503138317, 3.8307689176152406],
            [-18.59954332789482, 3.858748824573419],
            [-18.606473629421863, 3.86089999827442],
            [-18.598701618051717, 3.8882326055214746],
            [-18.591452180423264, 3.8862114531009087],
            [-18.5875396515337, 3.9006920716501874],
            [-18.58075765046287, 3.8987336788762184],
            [-18.575019925562803, 3.9196838728085956],
            [-18.56185819834376, 3.915810230949294],
            [-18.560285484021453, 3.9207709076116735],
            [-18.556659868419466, 3.919883677914957],
            [-18.552587526676454, 3.9340712479739817],
            [-18.545453228150286, 3.9322719265431165],
            [-18.541446104216853, 3.9459634631737464],
            [-18.54874570511287, 3.9479341238994055],
            [-18.5425093447452, 3.969810672208521],
            [-18.549532998214833, 3.971752664660614],
            [-18.547477103956062, 3.978757943946382],
            [-18.561402473844534, 3.982190219854687],
            [-18.551527580624274, 4.0171719843107745],
            [-18.575112162970353, 4.023887171861774],
            [-18.578707665049922, 4.02504820649174],
            [-18.58003732389276, 4.030070183867918],
            [-18.57683270274301, 4.034743864238592],
            [-18.574597777705108, 4.042683466467632],
            [-18.574246178272983, 4.05056420596372],
            [-18.566546063731597, 4.052826499003159],
            [-18.56753068895478, 4.059297219489209],
            [-18.570023193473954, 4.0630318122023485],
            [-18.56526996572205, 4.0662608717713455],
            [-18.5461629363536, 4.060232393555962],
            [-18.543011123318333, 4.056334486318691],
            [-18.537762140444507, 4.059014329301969],
            [-18.535964893945874, 4.063182811507192],
            [-18.53181704575383, 4.062693943471371],
            [-18.526623668811272, 4.065423923423133],
            [-18.521675988671888, 4.070223599512999],
            [-18.515088431637178, 4.068645073217221],
            [-18.509018696883597, 4.068787110057676],
            [-18.500588325107117, 4.080418302695959],
            [-18.502207446644075, 4.088011029654561],
            [-18.501973387298627, 4.091671987243211],
            [-18.49925179404793, 4.094195453754875],
            [-18.499199074038405, 4.1008970544085495],
            [-18.48966972288242, 4.106435546455285],
            [-18.487273770602922, 4.1103749628927035],
            [-18.480971364522507, 4.115627286065548],
            [-18.482576652744964, 4.120273248005923],
            [-18.479296068395183, 4.123002352690002],
            [-18.478896473807406, 4.126985007202185],
            [-18.485055251271884, 4.1297153164010485],
            [-18.486632056534674, 4.135107967482077],
            [-18.485195134840296, 4.1408222836795145],
            [-18.49022870022935, 4.142674856476339],
            [-18.490004712648123, 4.149160182901482],
            [-18.492324945872838, 4.153708445891084],
            [-18.48413683830853, 4.154672604944906],
            [-18.480577126799265, 4.150393951808606],
            [-18.4777527312866, 4.149193146590925],
            [-18.46982344135817, 4.156440514020996],
            [-18.465395350391308, 4.155394652382783],
            [-18.464014969442555, 4.1582606781951945],
            [-18.465650796399352, 4.161748134566049],
            [-18.470703711902143, 4.166105343659443],
            [-18.471614346745273, 4.1707504446580925],
            [-18.479212812600107, 4.178977860802629],
            [-18.476881646577183, 4.184769086927788],
            [-18.47964657400806, 4.18743215309692],
            [-18.484667764856844, 4.195981085066408],
            [-18.488597119899218, 4.1956137436404015],
            [-18.493811505736446, 4.19767129470892],
            [-18.495647979439056, 4.2006430143883495],
            [-18.500079793762893, 4.201264804244908],
            [-18.50611475224396, 4.204138001876127],
            [-18.510406666056383, 4.209260500627289],
            [-18.516674899537687, 4.214984167458283],
            [-18.522223956704018, 4.214244755123837],
            [-18.527033891095634, 4.215439246490785],
            [-18.53857728270754, 4.221009049216056],
            [-18.546608634419236, 4.22303262064275],
            [-18.547750231492085, 4.230444566787914],
            [-18.55024821058486, 4.234607503008885],
            [-18.549944328206553, 4.241059074350611],
            [-18.542395623579612, 4.247277871506866],
            [-18.54667768424002, 4.255703230426946],
            [-18.54636656489585, 4.262928837679113],
            [-18.54411465097109, 4.267189532044033],
            [-18.54433350578773, 4.270765560815297],
            [-18.54224953209001, 4.275917285372725],
            [-18.537287209758563, 4.2841020699413],
            [-18.534795019161123, 4.292092250093811],
            [-18.529613167799596, 4.295082866943732],
            [-18.53085652018155, 4.298697129411083],
            [-18.535270512903757, 4.300589582399422],
            [-18.544756150339914, 4.307860910577117],
            [-18.53983953219516, 4.316128182840057],
            [-18.54094438508006, 4.320992215067176]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.83851565492967,
          "lat": 40.00463797820376
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06063"],
        "coty_name": ["Plumas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Plumas County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00277296"
      },
      "bbox": [
        -18.637173770117542, 3.3394111210234465, -17.65685244760214,
        4.320992215067176
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.697735776967825, -0.1301402897066738],
            [-9.576745097030663, -0.14682663389429074],
            [-9.52720927346299, -0.15365447131798773],
            [-9.525826833671088, -0.14862337812364398],
            [-9.521579838909195, -0.1395214810689518],
            [-9.463905583779498, -0.14748027999307134],
            [-9.373652957684344, -0.15975983406188274],
            [-9.372533707626928, -0.15979731982189893],
            [-9.180177835676385, -0.18697295799430358],
            [-9.166077192058372, -0.18881501468673004],
            [-9.087725259115977, -0.19803087533051406],
            [-9.089202387940546, -0.2019348289892515],
            [-9.08427330669088, -0.2086967529676411],
            [-9.083064402157204, -0.21414025609286447],
            [-9.075625174192739, -0.21814640646658973],
            [-9.074390959359999, -0.22551435757656543],
            [-9.071218263857608, -0.23434784076349702],
            [-9.072022516741598, -0.24119120329653865],
            [-9.070852107975458, -0.2501900440151979],
            [-9.068323556486542, -0.2570876826157395],
            [-9.064653204179761, -0.25992751217930055],
            [-9.060945017504418, -0.2682509875730907],
            [-9.061323239622208, -0.2762703901476173],
            [-9.052330008448655, -0.27431387474598384],
            [-9.047109941821354, -0.27475626467862113],
            [-9.039690627347444, -0.273610379214426],
            [-9.032490266117598, -0.26831409142294105],
            [-9.028210132416497, -0.27037415208974735],
            [-9.023616587460713, -0.26708320833222315],
            [-9.021060684411076, -0.26854627158930444],
            [-9.013081773201376, -0.26904592296167545],
            [-9.00840426048466, -0.2655358583174373],
            [-9.006614913712495, -0.2717827726081619],
            [-9.002736768336687, -0.26674637963196546],
            [-8.993403066555926, -0.26035641033090845],
            [-8.991380688652143, -0.2538770926126346],
            [-8.987906036616351, -0.2524097214843708],
            [-8.981840879147914, -0.25199093648707827],
            [-8.971015599991087, -0.2601015646169921],
            [-8.969267919462748, -0.26642943610046804],
            [-8.966083575947247, -0.26930147469911486],
            [-8.96126095203133, -0.2682658586833852],
            [-8.958171528753377, -0.26597924630224323],
            [-8.946016083420488, -0.2606122689959584],
            [-8.94480467663467, -0.2651656917037751],
            [-8.938645397683253, -0.2685015421571576],
            [-8.935086310120369, -0.26693870700144207],
            [-8.930888129127828, -0.262598669201175],
            [-8.922104055010209, -0.262506145226704],
            [-8.917825142219156, -0.25967828587048947],
            [-8.90854918362365, -0.26083780881762364],
            [-8.903731621296792, -0.25989268205464866],
            [-8.899593373023064, -0.2624328933374639],
            [-8.8957596727983, -0.26085536307067864],
            [-8.893055583192169, -0.2624822189202901],
            [-8.885368686428317, -0.26263599124884357],
            [-8.882935986702684, -0.2747551243854952],
            [-8.879817623597233, -0.27721157586158496],
            [-8.877221291607258, -0.2848112704128819],
            [-8.874621759962373, -0.288643016563716],
            [-8.87043228630031, -0.28978818362747594],
            [-8.864744511351532, -0.28776471247649493],
            [-8.858034623498206, -0.2874741850995234],
            [-8.854489169933055, -0.29561306270443294],
            [-8.849670636835132, -0.30173221438865755],
            [-8.846632647230933, -0.3012750188226218],
            [-8.836889282147649, -0.3022802973855795],
            [-8.83499508268121, -0.30763662906094125],
            [-8.826134663477516, -0.32017966723508196],
            [-8.817161510911248, -0.3261962728972546],
            [-8.815060128461818, -0.33308414583120405],
            [-8.817371197247148, -0.33811539238443933],
            [-8.814475607358538, -0.344042549129096],
            [-8.80470956387022, -0.34422237847217185],
            [-8.802003651814054, -0.34678181816832687],
            [-8.802741243088864, -0.34959077356131496],
            [-8.798182196037155, -0.3525281939672847],
            [-8.795991621869968, -0.3564770002173376],
            [-8.799867303762715, -0.359871302997083],
            [-8.80507979019488, -0.3683175551315857],
            [-8.799746979045333, -0.37160037727861084],
            [-8.800091809819035, -0.37498377191583615],
            [-8.803671712760668, -0.3846903805932616],
            [-8.806601021575528, -0.3855317547797361],
            [-8.812082289354677, -0.3917731947759872],
            [-8.812499516531233, -0.4018696043906909],
            [-8.813726372287029, -0.40486233755716805],
            [-8.812086399464722, -0.4084990561723168],
            [-8.816763566940685, -0.41441591340873046],
            [-8.819291171732672, -0.41166696699252275],
            [-8.829231273363174, -0.41131076153763857],
            [-8.830966507586021, -0.4094273990848429],
            [-8.839147499182765, -0.4099293033577551],
            [-8.842869951112863, -0.4146592204225916],
            [-8.857975535485146, -0.41622029124511145],
            [-8.864522306134353, -0.4221033333044156],
            [-8.867788370798129, -0.42151989897584263],
            [-8.869256647634042, -0.4179644389758719],
            [-8.875974917786845, -0.4163550923744284],
            [-8.885329363822338, -0.42153137404622976],
            [-8.889909836861264, -0.4250790026723335],
            [-8.892141944680889, -0.43376876773030365],
            [-8.896346769672054, -0.4373300894474648],
            [-8.892521813310104, -0.44230929131572405],
            [-8.892540430802589, -0.44605057791850483],
            [-8.890557571074314, -0.451344981661212],
            [-8.890557212363142, -0.45769125792700716],
            [-8.88862087934336, -0.4605979104237435],
            [-8.88918294085918, -0.464246980425107],
            [-8.886769309715293, -0.47391631763607733],
            [-8.889882580551584, -0.47989005247026534],
            [-8.898068366329577, -0.48195950921332464],
            [-9.005454050542872, -0.4691333175804236],
            [-9.019254881271765, -0.4680240481325244],
            [-9.047240354372294, -0.46732032066696777],
            [-9.23988791438601, -0.4457218888830376],
            [-9.246519118889097, -0.44426735271888346],
            [-9.347151808075191, -0.4308268886645425],
            [-9.440107582043993, -0.41782406448079284],
            [-9.440326982387946, -0.41943699081763647],
            [-9.46264646779377, -0.4165097428671824],
            [-9.539927924565026, -0.4056903551848369],
            [-9.63536793830641, -0.3927030856486376],
            [-9.721095739560923, -0.4896964984683629],
            [-9.736743370660854, -0.5085907819117649],
            [-9.749945634644167, -0.5227919417194168],
            [-9.753878368857107, -0.5263323432583159],
            [-9.75152991183396, -0.5111912706225415],
            [-9.746294657075527, -0.48058563335361765],
            [-9.736103762420793, -0.40712604289019677],
            [-9.727913507216279, -0.34516181234931775],
            [-9.72126030163158, -0.30005837509967764],
            [-9.717180565267425, -0.2710634807996938],
            [-9.716187991137625, -0.2612308739154503],
            [-9.708771566039594, -0.21116788589919086],
            [-9.699028474918057, -0.13841997112991763],
            [-9.697735776967825, -0.1301402897066738]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -108.51731312318857, "lat": 37.7517261175602 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08033"],
        "coty_name": ["Dolores"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dolores County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00198132"
      },
      "bbox": [
        -9.753878368857107, -0.5263323432583159, -8.795991621869968,
        -0.1301402897066738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.481808287540483, 1.4876710011759766],
            [-9.459074018911512, 1.6503271842902765],
            [-9.341698392973337, 1.6342285250846305],
            [-9.343102334584264, 1.6240842535637472],
            [-9.327998268784473, 1.6218831321479799],
            [-9.31467011286558, 1.6209828026142623],
            [-9.310026591981805, 1.6195680969510649],
            [-9.197641702510607, 1.6043869343746693],
            [-9.085258676550675, 1.5891918803506384],
            [-9.079550715332575, 1.6326844915389658],
            [-9.000824351005878, 1.6227618636241319],
            [-8.824933077741987, 1.5995449900769336],
            [-8.824755097813346, 1.6008262219694978],
            [-8.698669780833647, 1.584742322251422],
            [-8.684787622606066, 1.5822759181340447],
            [-8.670097163833953, 1.5810999222475133],
            [-8.660557808715144, 1.5790771950766678],
            [-8.618340991514597, 1.5735873921793782],
            [-8.613599333491578, 1.5731727740858559],
            [-8.61156724388214, 1.5902320757284514],
            [-8.597060800409302, 1.7038232183669466],
            [-8.54959533744846, 1.697804347260672],
            [-8.482820507652551, 1.6895479546156762],
            [-8.411981543191342, 1.685900100878575],
            [-8.324657850586743, 1.673770363085043],
            [-8.299142061729778, 1.6699847241963583],
            [-8.213961781512978, 1.6599415014133838],
            [-8.203062757587755, 1.749413771194946],
            [-8.118195817788735, 1.736411356808314],
            [-8.107922947156597, 1.8253903647776928],
            [-8.106301383602467, 1.8251933954052484],
            [-8.095795127291007, 1.9123126186348471],
            [-7.990482851477939, 1.9002767067937831],
            [-7.885172126037474, 1.8882271153919452],
            [-7.895511976157646, 1.7996102133916065],
            [-7.8915258271433935, 1.7990013544919625],
            [-7.896560049832328, 1.75976587076953],
            [-7.899011830634523, 1.735621600592073],
            [-7.902794238494491, 1.7149831829311335],
            [-7.962931862673807, 1.7222208286246512],
            [-7.990383663571937, 1.4871277268922847],
            [-7.997701746220851, 1.4276271733051995],
            [-8.004490231783535, 1.3687691644780435],
            [-8.01147854378652, 1.3108926177421238],
            [-8.012768313277116, 1.2976953412810268],
            [-8.024966712905043, 1.1939472566026847],
            [-8.027885824640997, 1.1679668157662866],
            [-8.095711585325391, 1.1758609477509272],
            [-8.135826027959787, 1.1808288101271178],
            [-8.205971788080399, 1.1891048288354986],
            [-8.269317283882478, 1.196843392623483],
            [-8.391908921464315, 1.2119085522049151],
            [-8.514502405123508, 1.2269586013488674],
            [-8.613772500509578, 1.2393132971728928],
            [-8.702270476320585, 1.2505637320146705],
            [-8.823857703174912, 1.2660321390621907],
            [-8.89069783339108, 1.2750788128223256],
            [-8.892166824298783, 1.2750116747736977],
            [-8.981011475878741, 1.28633659066558],
            [-9.010257566640199, 1.2904722732613425],
            [-9.012936898124343, 1.2903791426753126],
            [-9.101086327554858, 1.3022129171067482],
            [-9.13477425688534, 1.3069928355243452],
            [-9.261223898898248, 1.3239018196666241],
            [-9.263586231720437, 1.3243485729553857],
            [-9.366187375169877, 1.3379290823423444],
            [-9.391189701038613, 1.3417865143990921],
            [-9.499460624173555, 1.3566261385189542],
            [-9.481808287540483, 1.4876710011759766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.90397038549823,
          "lat": 39.599322123046825
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08045"],
        "coty_name": ["Garfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garfield County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00198138"
      },
      "bbox": [
        -9.499460624173555, 1.1679668157662866, -7.885172126037474,
        1.9123126186348471
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.753878368857107, -0.5263323432583159],
            [-9.749945634644167, -0.5227919417194168],
            [-9.736743370660854, -0.5085907819117649],
            [-9.721095739560923, -0.4896964984683629],
            [-9.63536793830641, -0.3927030856486376],
            [-9.539927924565026, -0.4056903551848369],
            [-9.46264646779377, -0.4165097428671824],
            [-9.440326982387946, -0.41943699081763647],
            [-9.440107582043993, -0.41782406448079284],
            [-9.347151808075191, -0.4308268886645425],
            [-9.246519118889097, -0.44426735271888346],
            [-9.23988791438601, -0.4457218888830376],
            [-9.047240354372294, -0.46732032066696777],
            [-9.019254881271765, -0.4680240481325244],
            [-9.005454050542872, -0.4691333175804236],
            [-8.898068366329577, -0.48195950921332464],
            [-8.900822594631231, -0.49114997175792147],
            [-8.907045958933148, -0.4917255610364331],
            [-8.913250960674496, -0.4948791807285438],
            [-8.91902881540427, -0.5034547723438899],
            [-8.924707737405177, -0.5042955725835221],
            [-8.925534126031716, -0.5073918944015637],
            [-8.929374578782292, -0.5121280655976411],
            [-8.933291105740139, -0.5119064876453521],
            [-8.938352764986675, -0.5162764420549909],
            [-8.937676195785286, -0.5208228238778563],
            [-8.940953121218197, -0.5251660022374443],
            [-8.944930987091894, -0.5250348397042718],
            [-8.94363267188795, -0.5317948806108356],
            [-8.94458632348622, -0.5341745980700096],
            [-8.944863890739832, -0.5427537368258971],
            [-8.946239217507607, -0.5452070700500333],
            [-8.944785481623923, -0.5497728911839596],
            [-8.948035068204234, -0.5537539632772652],
            [-8.946986367819639, -0.5582642271537614],
            [-8.94967803506427, -0.5679552997798055],
            [-8.95149598142161, -0.5698341969711869],
            [-8.953853469212099, -0.5765323394965964],
            [-8.962025047152048, -0.5828447740746463],
            [-8.963123821926311, -0.5921408231087382],
            [-8.961840341745877, -0.5975768825065826],
            [-8.964319476714996, -0.6022602041711209],
            [-8.963353138126434, -0.605660817618235],
            [-8.968246089963673, -0.6118842735296435],
            [-8.966420428655349, -0.6182403434689139],
            [-8.968712143586805, -0.6241027520742379],
            [-8.96785556903153, -0.6354370375897508],
            [-8.971127045791338, -0.6441011069214757],
            [-8.969393179648977, -0.6506713530578841],
            [-8.973513202427037, -0.6561258794479925],
            [-8.9749749990553, -0.6626699672479149],
            [-8.97872925800008, -0.6663661698599564],
            [-8.981084880278463, -0.6718161126485438],
            [-8.984177341841471, -0.6715645716135595],
            [-8.988397492334048, -0.676159869612413],
            [-8.99494815605014, -0.6754007665448606],
            [-9.007734139970413, -0.6723076715632019],
            [-9.010909664566595, -0.6784848722453729],
            [-9.010534107632198, -0.6818177214001485],
            [-9.01636803270268, -0.6825154663493177],
            [-9.018939753409448, -0.6888490275875448],
            [-9.02621649340961, -0.6921527812365988],
            [-9.0278721146418, -0.6964575337445095],
            [-9.0332943399408, -0.7029440191387405],
            [-9.03646981567793, -0.7139893453692231],
            [-9.035652867494502, -0.7193903653827438],
            [-9.036715861347565, -0.7264328105491641],
            [-9.04299300849243, -0.7273816443031986],
            [-9.049074568333802, -0.7323342778136632],
            [-9.05834335540749, -0.731182995062152],
            [-9.0649271611416, -0.7322312108206857],
            [-9.071008385880692, -0.7390228755534922],
            [-9.075608189051461, -0.7412719125173132],
            [-9.079837684973503, -0.739399571544119],
            [-9.084872253123482, -0.7403308365239836],
            [-9.08629272122663, -0.7372660134965778],
            [-9.091168172291368, -0.7354024688604677],
            [-9.099840287235725, -0.7376234018558148],
            [-9.107457356389501, -0.7407532161926628],
            [-9.111963344763359, -0.7443775095531381],
            [-9.112771627455384, -0.7477743298179672],
            [-9.118879418049758, -0.7545400053581576],
            [-9.122712095183088, -0.7652520036656094],
            [-9.119720856972641, -0.7720316737334308],
            [-9.126177601163535, -0.776337084664225],
            [-9.129737540664028, -0.7846142428856433],
            [-9.132171065571175, -0.7858747359760124],
            [-9.132881477779494, -0.7912662549556119],
            [-9.130597703717816, -0.7945463304675066],
            [-9.131803830912226, -0.7996630433581019],
            [-9.135211723009773, -0.8001063248991063],
            [-9.137812476640518, -0.8097828376465075],
            [-9.142192773043499, -0.809982058609817],
            [-9.14503911223665, -0.8144131053231978],
            [-9.146189800106507, -0.8193393514628893],
            [-9.150142535216562, -0.8200791183911043],
            [-9.153662161019383, -0.8250214180185524],
            [-9.155790699254919, -0.8326522753048715],
            [-9.158978731642364, -0.8335008573214879],
            [-9.163057258505326, -0.8395890988354207],
            [-9.164266911732382, -0.8445625229148138],
            [-9.167332794708948, -0.847805927480045],
            [-9.17183990185711, -0.8498880684279296],
            [-9.17562266603594, -0.8538669799530617],
            [-9.177248268876147, -0.8580074892650623],
            [-9.182261225753022, -0.8593362670789172],
            [-9.185307696318649, -0.8628911094635768],
            [-9.19391228506059, -0.862433349160898],
            [-9.202580149913757, -0.8679815335048079],
            [-9.202693346564477, -0.8697139362205387],
            [-9.208107515829983, -0.8761916814857583],
            [-9.20887718144183, -0.8809816746089374],
            [-9.206069001464803, -0.8874231709716677],
            [-9.20714229227016, -0.8955701269580839],
            [-9.20990308304687, -0.8995401173215357],
            [-9.210095186019602, -0.9078718928366447],
            [-9.21157552915376, -0.9143510833954773],
            [-9.213692178131971, -0.9183009312082212],
            [-9.212067583063243, -0.9274370514882808],
            [-9.214301354938005, -0.9311904385807596],
            [-9.210229948197563, -0.9360173533273426],
            [-9.21152804250828, -0.9442234535181278],
            [-9.21467673917014, -0.9453696455728329],
            [-9.220632710979409, -0.9503572577838082],
            [-9.229248674363037, -0.958845557601022],
            [-9.229935961497553, -0.9684372875216533],
            [-9.232035544983253, -0.9712334459103246],
            [-9.231148454883373, -0.9771216520873768],
            [-9.232218396717458, -0.9828404841650236],
            [-9.237700172619446, -0.9852183861401892],
            [-9.23889255962462, -0.989978444687005],
            [-9.241733029807433, -0.9917361098091682],
            [-9.244015568774554, -0.9982436315250859],
            [-9.248663398782309, -1.0074155637433642],
            [-9.248232467992603, -1.010526087376994],
            [-9.251941974119948, -1.0116386903529064],
            [-9.251161136190833, -1.017307567527313],
            [-9.255228594920563, -1.01848535818547],
            [-9.256846018894596, -1.023043155209208],
            [-9.257559023014299, -1.029977117004144],
            [-9.269023932871466, -1.0386054575311667],
            [-9.272467779504387, -1.0434599567945597],
            [-9.27559506885941, -1.0449755322667436],
            [-9.275123834742981, -1.0506592036319051],
            [-9.280915493689312, -1.0573873765922375],
            [-9.290517701766369, -1.0529067831205379],
            [-9.292306464981241, -1.0571647024744106],
            [-9.291532953357112, -1.0607826209090536],
            [-9.297420874931268, -1.0722345894935474],
            [-9.297096265773822, -1.0749385144514942],
            [-9.301409105681467, -1.0796191631672172],
            [-9.300287495806487, -1.081811657769058],
            [-9.42350897042423, -1.0657097505154773],
            [-9.488812416240279, -1.0570922259578133],
            [-9.590672354069358, -1.043530342410286],
            [-9.751218009274192, -1.0219292058697416],
            [-9.822358383519017, -1.011957823660947],
            [-9.806697412143494, -0.8989765847383289],
            [-9.798343407154421, -0.8336630314228928],
            [-9.79493787434521, -0.8091093534820907],
            [-9.793308959648583, -0.800147977053813],
            [-9.78806451240486, -0.7616242586065249],
            [-9.788331119434506, -0.7609330744509234],
            [-9.770881369127915, -0.6359331943621936],
            [-9.753878368857107, -0.5263323432583159]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.59657667063678,
          "lat": 37.33857212696613
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08083"],
        "coty_name": ["Montezuma"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montezuma County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00198157"
      },
      "bbox": [
        -9.822358383519017, -1.081811657769058, -8.898068366329577,
        -0.3927030856486376
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.169186514783231, -7.8609145753727185],
            [10.241959714920116, -7.852108619053059],
            [10.24242749523512, -7.85189999123569],
            [10.35168351620292, -7.83740008623202],
            [10.4553742255635, -7.824043285371787],
            [10.455285523631238, -7.823335195045484],
            [10.512278438465666, -7.816539468833557],
            [10.528594856272793, -7.814373855418119],
            [10.561839651959572, -7.81051940063702],
            [10.567212621758086, -7.809565976231663],
            [10.57634573551904, -7.837689868244132],
            [10.675942908666546, -7.825923678411024],
            [10.718169317583047, -7.820720461097944],
            [10.719304473604797, -7.8315074377633165],
            [10.736166495349774, -7.966778634956085],
            [10.740063225777808, -7.9961018748979376],
            [10.734447714503238, -7.999979164044237],
            [10.731060985439894, -8.00058470369498],
            [10.725079927683918, -7.999479963397595],
            [10.715220279293899, -8.003490074656607],
            [10.70890605628258, -8.00996649739279],
            [10.7023928435463, -8.005079082932498],
            [10.698792875354306, -8.006105504175412],
            [10.690483339591323, -8.014715998975715],
            [10.673247696070714, -8.027151483313633],
            [10.664314858941161, -8.029549781672172],
            [10.654431558493693, -8.029010369045816],
            [10.649343370017997, -8.025576606275346],
            [10.65066137008652, -8.02031280082181],
            [10.654403667007943, -8.01675907513037],
            [10.656769240476107, -8.010947508270998],
            [10.655185668349219, -8.006359303285905],
            [10.651529441134187, -8.010590099763558],
            [10.644200250855885, -8.009435687675555],
            [10.639015257869701, -8.006298898963644],
            [10.629858852687361, -7.99300650931174],
            [10.626656872606208, -7.991341581845822],
            [10.624797336278473, -7.998669987855847],
            [10.629867532845298, -8.00934394220661],
            [10.632477555748757, -8.010500296714445],
            [10.635980262508083, -8.016555142381705],
            [10.632205414330247, -8.02034578573031],
            [10.619144724706954, -8.022601665466084],
            [10.611215517594133, -8.0222357462349],
            [10.603272725317744, -8.02296576916512],
            [10.60082370518043, -8.018679512613245],
            [10.594929641330891, -8.016538757999967],
            [10.592363721334436, -8.008742592576583],
            [10.58455089321002, -8.006094863893965],
            [10.579378929616258, -8.007757896358292],
            [10.57845874200772, -8.011308014761582],
            [10.57403873187682, -8.014472786670847],
            [10.571992738715599, -8.020021257018554],
            [10.571856609564307, -8.029308184319246],
            [10.575912110987836, -8.036412654698944],
            [10.5764573830348, -8.04371319965284],
            [10.575050836073205, -8.048220405706179],
            [10.571952630954453, -8.0520890538381],
            [10.567502358181128, -8.051748158454698],
            [10.561555559544322, -8.05642723085097],
            [10.558396576725718, -8.055594865797826],
            [10.554567286391235, -8.057030078302528],
            [10.538866423161062, -8.068290397576398],
            [10.529598933023383, -8.078170651065838],
            [10.525796702546321, -8.080896280535189],
            [10.522267153490688, -8.089136158122509],
            [10.517444450597747, -8.091985753987082],
            [10.518967032882781, -8.096320888949661],
            [10.513213907516402, -8.106573458777842],
            [10.510462959518692, -8.105784441852096],
            [10.508888313744093, -8.10145472248263],
            [10.504970592843593, -8.10482810301352],
            [10.501949220968287, -8.112184147496164],
            [10.50774729668686, -8.122165125595311],
            [10.506988447003254, -8.12739185375331],
            [10.508073042005654, -8.132329971726286],
            [10.513721000164425, -8.138959376123944],
            [10.517558850457428, -8.139828425348322],
            [10.52076299324173, -8.134393482832914],
            [10.523257664154068, -8.133171551352115],
            [10.528321070842274, -8.142214735855068],
            [10.527567386356308, -8.147406686660025],
            [10.522090035424426, -8.149272023000702],
            [10.5113709008727, -8.14839322975099],
            [10.509536735301326, -8.146972332009199],
            [10.50016451681017, -8.144927656223944],
            [10.489309111859113, -8.145116968713017],
            [10.480617608451698, -8.14103555078711],
            [10.468057041902863, -8.139990614368283],
            [10.4597859478322, -8.142638007163985],
            [10.450672600740187, -8.140145203246748],
            [10.445744077463063, -8.137145909326549],
            [10.443071356009959, -8.139832534141565],
            [10.445683809048125, -8.14588770280162],
            [10.445311741808291, -8.148700387046434],
            [10.443266865929877, -8.15047893869159],
            [10.438176915504716, -8.146745124649291],
            [10.434658536079038, -8.155611082331763],
            [10.432332536696986, -8.157985586689415],
            [10.426770622669332, -8.154713551448857],
            [10.4247540807906, -8.141488268207215],
            [10.421434371281045, -8.134114232085963],
            [10.415543757959133, -8.129459315053891],
            [10.411694126920692, -8.129378811276714],
            [10.408054707916698, -8.132542362212474],
            [10.404971424275745, -8.13871243402494],
            [10.40052732126492, -8.144643850990231],
            [10.396889683385009, -8.146419781081473],
            [10.387810945879698, -8.14722035598099],
            [10.382238174889876, -8.146177826681045],
            [10.377225695968306, -8.146830467411924],
            [10.379781323326675, -8.152209091652093],
            [10.378295212147947, -8.155285541537458],
            [10.371691007156818, -8.155806676506902],
            [10.368709503415117, -8.15442296476912],
            [10.368446109065946, -8.150304095598004],
            [10.372347024895852, -8.141374464524517],
            [10.365936804102123, -8.132069990857184],
            [10.360344659864884, -8.1306001147452],
            [10.352336988743515, -8.136523325290169],
            [10.345896041109464, -8.133505183210682],
            [10.345385878138776, -8.130780170744703],
            [10.348540887036858, -8.12835847487554],
            [10.342858475452452, -8.125466731247256],
            [10.338438313784128, -8.125827594697052],
            [10.337824696436657, -8.120942547512147],
            [10.335249208582228, -8.11888001846825],
            [10.329120864502435, -8.124339613538169],
            [10.326910362165235, -8.121597279410235],
            [10.323456455434815, -8.122770158881329],
            [10.306295261850783, -8.114838145148099],
            [10.298646451232894, -8.107532081056695],
            [10.297933458432588, -8.105359935928785],
            [10.302078849393745, -8.102690771981935],
            [10.298967385836075, -8.100411534399496],
            [10.293247587902338, -8.099725236609693],
            [10.291132088238703, -8.094055232859372],
            [10.28661447409944, -8.087153889800803],
            [10.280567607923683, -8.082241547069565],
            [10.276061424099332, -8.081627187658084],
            [10.268493169042776, -8.084086747998262],
            [10.263472108850081, -8.07800877904054],
            [10.2623485842137, -8.072394430244962],
            [10.255788840597939, -8.067285601607296],
            [10.255169177991153, -8.063295478533048],
            [10.243393836745124, -8.052157432916417],
            [10.24669257731536, -8.050445553809618],
            [10.244823433732, -8.045102706857838],
            [10.247664565533126, -8.043501978663022],
            [10.244355581847387, -8.039690118721026],
            [10.24011818316001, -8.037254554831966],
            [10.23723408511365, -8.037751756817105],
            [10.235603675191088, -8.03282950199188],
            [10.232592192185779, -8.033192895358074],
            [10.22776439938181, -8.028768621402536],
            [10.228069405949388, -8.019166508988347],
            [10.223409006044115, -8.013608412479396],
            [10.22516338729103, -8.009848009920832],
            [10.221950243129378, -8.004285757324658],
            [10.224660981447496, -8.001265691085552],
            [10.222740303698071, -7.99704808460753],
            [10.224834840233326, -7.9929264100076365],
            [10.222741394033468, -7.988925917386201],
            [10.222984505986226, -7.983553462311322],
            [10.221718435108293, -7.972166998564864],
            [10.212563791786268, -7.967759779892981],
            [10.211826252111404, -7.960506308595066],
            [10.213021897495901, -7.955074248726273],
            [10.208155121292668, -7.954199657846111],
            [10.20872974545812, -7.949561363343344],
            [10.206384194886551, -7.944511816737781],
            [10.205940689106274, -7.938956018288746],
            [10.200452691734347, -7.935057692670077],
            [10.196122887351262, -7.935690293203856],
            [10.193133631216305, -7.930863230655053],
            [10.18783565597962, -7.926851633026797],
            [10.190461818374818, -7.921369780118472],
            [10.187123368066889, -7.912806006045553],
            [10.181612642060124, -7.907774912776033],
            [10.176057452311971, -7.909794473626427],
            [10.17277082760991, -7.90792687350957],
            [10.162990459753216, -7.905062476588927],
            [10.15231005872793, -7.897404385503208],
            [10.158053688879592, -7.892690288677543],
            [10.157094545034479, -7.887335977413628],
            [10.159595215934305, -7.88345273331705],
            [10.156555170258466, -7.882121852478915],
            [10.157124594654247, -7.87506105858497],
            [10.169186514783231, -7.8609145753727185]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.40072564557455, "lat": 30.16732543467591 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12129"],
        "coty_name": ["Wakulla"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wakulla County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00306912"
      },
      "bbox": [
        10.15231005872793, -8.157985586689415, 10.740063225777808,
        -7.809565976231663
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.925290880612067, -5.604631398733735],
            [10.993615966318497, -5.551670208336279],
            [10.990099383702695, -5.545696515503746],
            [10.996747776029457, -5.541456207479241],
            [11.000343971950334, -5.546290268095046],
            [11.078676341300692, -5.485769670552288],
            [11.127338975293386, -5.449209049471894],
            [11.133242426340344, -5.443640090185057],
            [11.163582886234154, -5.491388205215756],
            [11.22778144228392, -5.593633854733484],
            [11.195295064825814, -5.568272942264892],
            [11.164459729710945, -5.609100225178511],
            [11.14021112948472, -5.640559412459078],
            [11.116495704340567, -5.672753933904399],
            [11.113553081970746, -5.675938213159983],
            [11.100741264199835, -5.69262839862664],
            [11.120424885325201, -5.707806824380718],
            [11.100832379984217, -5.732854713995952],
            [11.085596691737514, -5.753113100207769],
            [11.078950709129467, -5.748213954655758],
            [11.074056801389721, -5.754868670865568],
            [11.080221357763017, -5.75967086057795],
            [11.075214268204972, -5.766146651739202],
            [11.05769744052339, -5.752539247557214],
            [11.055327106739352, -5.752205736113188],
            [11.038918038922338, -5.739261324719611],
            [10.958336606749778, -5.676148552538567],
            [10.93185206486365, -5.654722850823732],
            [10.934332911909777, -5.652422028490456],
            [10.941910127047594, -5.650890868175401],
            [10.943603358597484, -5.64564736526446],
            [10.94203551572876, -5.636305707080638],
            [10.936974580054104, -5.629075478541473],
            [10.937161826280667, -5.626651519402907],
            [10.933392194704563, -5.622928982109034],
            [10.935603325625374, -5.619278385307967],
            [10.93327610373976, -5.61248987094858],
            [10.926584639113917, -5.609746420650908],
            [10.925290880612067, -5.604631398733735]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.32783989389193, "lat": 32.43445532151995 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13023"],
        "coty_name": ["Bleckley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bleckley County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00347451"
      },
      "bbox": [
        10.925290880612067, -5.766146651739202, 11.22778144228392,
        -5.443640090185057
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.706422582886015, -5.830638068761923],
            [9.71045044359722, -5.832217118346793],
            [9.713722250032236, -5.830931232518214],
            [9.719345846135782, -5.832961083423834],
            [9.722440742887605, -5.829923056007705],
            [9.726764198386798, -5.830435815178883],
            [9.735955028472905, -5.8256311542416945],
            [9.744024564062114, -5.818649641570481],
            [9.746324798683231, -5.8146263535328675],
            [9.752701707915248, -5.810757264128564],
            [9.754980712565382, -5.807478277442988],
            [9.76139105369909, -5.80550689742789],
            [9.763491920387903, -5.799459525005733],
            [9.767733508261006, -5.801478215626913],
            [9.772203959557505, -5.798893382969706],
            [9.775661092783427, -5.794252161683284],
            [9.777465145957478, -5.789368842165566],
            [9.783451251608072, -5.786347094970731],
            [9.787551581543168, -5.7877205951694],
            [9.790349647738404, -5.784480101615734],
            [9.799316990000051, -5.782780986883253],
            [9.803200338665457, -5.784275844225066],
            [9.805260165789402, -5.7816813198971895],
            [9.808435091563718, -5.782904450469762],
            [9.826623860924, -5.780011070561473],
            [9.830291374072107, -5.780708078396777],
            [9.83603721088386, -5.776583110770358],
            [9.835358047181355, -5.773600709210205],
            [9.838078882054015, -5.770091221278887],
            [9.840279265472356, -5.773118198529623],
            [9.847608547061819, -5.776736726304575],
            [9.851737542196016, -5.777217222630708],
            [9.856094891490283, -5.773027630101107],
            [9.859597618562553, -5.767345832070745],
            [9.862948437831264, -5.7653859215688295],
            [9.867727539477412, -5.768030324571337],
            [9.869258627584983, -5.762609927024221],
            [9.871411133410676, -5.759905577899894],
            [9.871624289367091, -5.753079081085962],
            [9.875482685957746, -5.7517526338527345],
            [9.876176366582834, -5.746462945573503],
            [9.878084130594127, -5.744432944233957],
            [9.879257844540744, -5.738410252222474],
            [9.877936965156389, -5.735955967880317],
            [9.881008194748455, -5.729514151702407],
            [9.884322403706173, -5.726643343224477],
            [9.886875157990554, -5.721102714343975],
            [9.885980465961413, -5.714794233127585],
            [9.887660878136703, -5.7095873434659214],
            [9.890139427458996, -5.707791368228572],
            [9.892347622859953, -5.700144587262411],
            [9.891180863487815, -5.697651804315182],
            [9.894513297221275, -5.687956757996114],
            [9.898218187314765, -5.681971869487085],
            [9.89726279614347, -5.680285351028518],
            [9.90622907487163, -5.674164401319303],
            [9.906094552225015, -5.672288760809638],
            [9.914793832283507, -5.6641452925262445],
            [9.92104409863978, -5.663353813161607],
            [9.927802109214849, -5.661650777815985],
            [9.934305483772839, -5.661637416537668],
            [9.93939702337192, -5.657477069915922],
            [9.943833901444343, -5.651663774857459],
            [9.950226071166936, -5.649771443319505],
            [9.957008683866148, -5.642715596217636],
            [9.966721001296964, -5.641656960452148],
            [9.970769042359812, -5.681503491320069],
            [9.954851168579676, -5.68330469010939],
            [9.960066004604288, -5.7363913308348895],
            [9.961089961920473, -5.7364706978341395],
            [9.968754925534553, -5.804716927179262],
            [9.976281751735591, -5.867285559776701],
            [9.982598405980356, -5.924356194419532],
            [9.98489051996106, -5.943744051653487],
            [9.910693048351005, -5.953939421290868],
            [9.86512932515998, -5.959948779090491],
            [9.866298175157265, -5.969777624925912],
            [9.856675269708548, -5.970809180144878],
            [9.855602154737294, -5.961069763972124],
            [9.764412446340078, -5.971739021033381],
            [9.769349564987328, -5.9654283860233726],
            [9.771562875748852, -5.958326590929548],
            [9.767498177338446, -5.956183051747899],
            [9.765129733338568, -5.958371511006217],
            [9.761767203175662, -5.957153525943659],
            [9.762091815348183, -5.951908510387387],
            [9.767052187742594, -5.953115493325265],
            [9.773176780891044, -5.953122454403165],
            [9.777906481050453, -5.950049261396471],
            [9.779335301215026, -5.943252682316415],
            [9.786887683086553, -5.9415174603021175],
            [9.789265281375155, -5.938583096588554],
            [9.784610573880107, -5.934158567322857],
            [9.775277295824406, -5.927291680971974],
            [9.768968375723475, -5.924805863233296],
            [9.758177191211477, -5.917622742009222],
            [9.74753971885309, -5.905846598228164],
            [9.743178467691676, -5.903889306809355],
            [9.698562494670846, -5.890331825395746],
            [9.687928851880736, -5.888844772783416],
            [9.682826466163698, -5.883044681167708],
            [9.68103278994006, -5.874880590394597],
            [9.682977693194392, -5.866078787509962],
            [9.696227564444092, -5.850588725800787],
            [9.69847344115828, -5.844222726216185],
            [9.6953950269462, -5.840003766269009],
            [9.696789138698074, -5.835959546810776],
            [9.704809937998977, -5.833966795480162],
            [9.706422582886015, -5.830638068761923]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.78696359792286, "lat": 32.34700481803184 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13053"],
        "coty_name": ["Chattahoochee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chattahoochee County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00351012"
      },
      "bbox": [
        9.68103278994006, -5.971739021033381, 9.98489051996106,
        -5.641656960452148
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.032826410501299, -3.7969336019982816],
            [11.033894778397885, -3.7979915103018698],
            [11.049661822963412, -3.7901077551617406],
            [11.079523667782995, -3.7799080192295564],
            [11.095313170675956, -3.7807965130894208],
            [11.105570635030567, -3.786126430267593],
            [11.099790086913497, -3.7923272061351545],
            [11.110249171870892, -3.798492737267724],
            [11.113414918192639, -3.7981741193214975],
            [11.12419711416339, -3.787570463507071],
            [11.130414553370061, -3.788693601584683],
            [11.161546671333975, -3.7548085955126314],
            [11.213693178946285, -3.7301267440606916],
            [11.22003998873172, -3.72518776733926],
            [11.227496268749874, -3.7237737845746164],
            [11.232858784555663, -3.7216259870576383],
            [11.238624128325172, -3.715258112108942],
            [11.247468818137271, -3.7112021857030135],
            [11.251138633580393, -3.7106294336494248],
            [11.25710324735114, -3.705278986420006],
            [11.26312543671019, -3.7034195537613694],
            [11.270970395859075, -3.6979324522205794],
            [11.278148931662674, -3.7036821535893196],
            [11.282414824193035, -3.704778440280468],
            [11.288948213374825, -3.7088883052590695],
            [11.296108323199839, -3.7170718234646714],
            [11.294905654871938, -3.7195832259572432],
            [11.297911011059702, -3.7249958208183194],
            [11.298721545084646, -3.7292391028663805],
            [11.301179321008691, -3.731621610142974],
            [11.300495942436278, -3.736866236450866],
            [11.305070531434476, -3.753843924270298],
            [11.30364940684723, -3.7571271284784644],
            [11.307605183405288, -3.7625776130842743],
            [11.307533365848858, -3.7709790156954757],
            [11.308116190176671, -3.7729686059212133],
            [11.317648264574325, -3.7870576139189063],
            [11.318866499754733, -3.7907292919000373],
            [11.319780599773017, -3.800134081646761],
            [11.32207020151637, -3.805925905242055],
            [11.329168115143826, -3.814507750952371],
            [11.336081531593035, -3.8291229424092856],
            [11.338139359381403, -3.8312131343673705],
            [11.348252905228406, -3.8370995133005934],
            [11.352054144006281, -3.838280350247219],
            [11.358286795338602, -3.8377412505848496],
            [11.36369198527456, -3.8415827658947537],
            [11.370130941639228, -3.842769373685492],
            [11.373353890871824, -3.8449698979470543],
            [11.380409294555184, -3.8541251298989194],
            [11.382419125765308, -3.860130275906179],
            [11.390309306808891, -3.868795357753327],
            [11.394534345525747, -3.8715787883212087],
            [11.399142032789964, -3.8724569975930287],
            [11.405985895743006, -3.8786384245940595],
            [11.407893855990102, -3.884003371201165],
            [11.40497879820683, -3.8950708836916066],
            [11.410317064167991, -3.9026055472478993],
            [11.414847331902894, -3.9048016954419453],
            [11.418419980425325, -3.9038523647175656],
            [11.42197593755872, -3.905452695945686],
            [11.42726829784158, -3.9102270561157915],
            [11.430048362457454, -3.9166387043364925],
            [11.435755615840563, -3.920431953490241],
            [11.438398969046336, -3.9254665682472076],
            [11.441481342166906, -3.928469259224964],
            [11.451780057791332, -3.934261504008825],
            [11.454181122759953, -3.938179585196054],
            [11.45364627900364, -3.944608038210966],
            [11.455416328954259, -3.9510117528408033],
            [11.462267455592574, -3.9644137973223397],
            [11.467104687876224, -3.9682785048111175],
            [11.473249281839452, -3.969718890921176],
            [11.473980911288468, -3.9727177139045433],
            [11.471323033354578, -3.9758287116195423],
            [11.471360694742625, -3.9810284372177107],
            [11.477711493640411, -3.9888412954242094],
            [11.482372558473669, -3.9918986528371727],
            [11.485442412964085, -3.9966567380066356],
            [11.48808547623097, -4.005448933363308],
            [11.479999565787386, -4.003013662237754],
            [11.475614178472366, -3.996905042126568],
            [11.467006127220664, -3.9953447879271873],
            [11.464590468472908, -3.9931227481821927],
            [11.455909936805872, -3.9889545140787703],
            [11.454491755863769, -3.9865178674391157],
            [11.44692007285821, -3.98505250114529],
            [11.443980862871522, -3.986591032748683],
            [11.43504727155456, -3.985980052678943],
            [11.430792753219682, -3.988635809855902],
            [11.429269109303318, -3.9946686843741777],
            [11.423340626533403, -3.995596058508246],
            [11.423268537964459, -3.990083026615127],
            [11.418111039375555, -3.986467216918873],
            [11.409433942364226, -3.9805142380611884],
            [11.405848643602472, -3.982086559503166],
            [11.399265062274118, -3.9877425147494265],
            [11.390328997743241, -3.9894178636159654],
            [11.37270820786577, -3.9957517681810635],
            [11.358322558023046, -3.994290111422576],
            [11.349510924639478, -3.9969571144216594],
            [11.34600351388008, -4.000306897585234],
            [11.339565790851186, -4.002207537034678],
            [11.335403986587664, -4.0052048404616105],
            [11.33106749565773, -4.0111583881073924],
            [11.322173607953218, -4.010858733214162],
            [11.310689123924755, -4.014814010969384],
            [11.305980996743335, -4.014454514483251],
            [11.29438656946979, -4.010086666340787],
            [11.287423494160281, -4.009536169214315],
            [11.280866255305252, -4.007941110717226],
            [11.277083300156898, -4.00459534337671],
            [11.272087999548841, -4.0067419614708095],
            [11.260777626384808, -3.9999704888128984],
            [11.257249697001091, -4.003163396913269],
            [11.258022378502826, -4.008742947230536],
            [11.249776997121305, -4.012075397935904],
            [11.24395902453858, -4.011218969049224],
            [11.239796089103908, -4.011963122937859],
            [11.237598303440663, -4.0064737600669],
            [11.234253245822087, -4.003534240673003],
            [11.226016637808366, -4.0021910556645715],
            [11.223841822285276, -3.997449074526803],
            [11.22012783645249, -3.998028596840787],
            [11.214449331557388, -3.996745929536632],
            [11.202863309438785, -3.995986899516866],
            [11.202838997116276, -3.989196531184687],
            [11.193549319796448, -3.989106968224108],
            [11.195436631634394, -3.993432733508695],
            [11.19354156689132, -3.995486648781942],
            [11.18932059979628, -3.991963247337191],
            [11.18503605088449, -3.995430702761471],
            [11.183082089684847, -3.9924879056644524],
            [11.174945904522561, -3.98905879026177],
            [11.171946655568998, -3.989589205757013],
            [11.169576951794834, -3.981957633561935],
            [11.172956018482719, -3.979826390449364],
            [11.169167107819401, -3.976896888683896],
            [11.161700453933523, -3.968860665982048],
            [11.159339442866866, -3.967776578518042],
            [11.154990413271713, -3.971270782082866],
            [11.15249882270049, -3.9708863786503903],
            [11.149398287821258, -3.966741968062257],
            [11.14032823226015, -3.9652666754771233],
            [11.138300993402643, -3.960112716057581],
            [11.13592428703964, -3.9617211780116826],
            [11.130655975443265, -3.958639270626994],
            [11.126785761890709, -3.9527855178401943],
            [11.127030762470538, -3.948645231666076],
            [11.12497289470486, -3.945221166917016],
            [11.115056948743232, -3.9405656580041617],
            [11.112081619927153, -3.9333056611399417],
            [11.106668087782692, -3.935914640178418],
            [11.1009109606831, -3.9312074152763596],
            [11.08695268957271, -3.9179539344300656],
            [11.083978318118325, -3.916893942985383],
            [11.08817053054126, -3.910982130118058],
            [11.085367681332263, -3.905284526868198],
            [11.086120670428853, -3.9015839687394633],
            [11.081227566356679, -3.8982791897103293],
            [11.07131543902233, -3.895714724969271],
            [11.068506702565335, -3.8901918765320715],
            [11.069932650232438, -3.8875420245460077],
            [11.065737328834295, -3.88444635112625],
            [11.062815320945294, -3.8804903783633944],
            [11.058285067159703, -3.8778967948512513],
            [11.055683912545934, -3.8729103178065643],
            [11.05719062457162, -3.871217700353196],
            [11.049441917441746, -3.864336432881402],
            [11.043922222910286, -3.866785900668875],
            [11.035856549365223, -3.862513152087766],
            [11.026173660906878, -3.859773235047184],
            [11.019529093009156, -3.8526149975085433],
            [11.019817312550733, -3.8500163838951784],
            [11.025973914461574, -3.831818451439933],
            [11.022406398007186, -3.825402654518654],
            [11.021492386464052, -3.8199129027980416],
            [11.025983808639316, -3.812974618076233],
            [11.029241837437926, -3.8097696118461992],
            [11.032139241941904, -3.803253145785424],
            [11.032826410501299, -3.7969336019982816]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.84005565134888, "lat": 34.11675261236743 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13105"],
        "coty_name": ["Elbert"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elbert County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00347828"
      },
      "bbox": [
        11.019529093009156, -4.014814010969384, 11.48808547623097,
        -3.6979324522205794
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.466760779617006, -3.2864019685957713],
            [10.469641731557243, -3.2830452568946655],
            [10.478254338449794, -3.2786474115253603],
            [10.480194719655941, -3.274395393504522],
            [10.48350732838406, -3.2719046065237216],
            [10.48522896031221, -3.265287785975521],
            [10.487613462699123, -3.2612363655668255],
            [10.490138604456332, -3.25849349917486],
            [10.497684549523006, -3.260137256837203],
            [10.505559661975507, -3.2565224361714997],
            [10.509581822206847, -3.2583381331933925],
            [10.514509137962735, -3.2570449862846678],
            [10.519311212532678, -3.2580880439539657],
            [10.520198335515557, -3.2540576369474348],
            [10.524681588339522, -3.251704959402077],
            [10.53233290311893, -3.25356819333064],
            [10.539882044685548, -3.2567976640232628],
            [10.547274273540616, -3.271686672474409],
            [10.550373493666067, -3.2729757124545618],
            [10.554436011559382, -3.2807047340049333],
            [10.557592671715026, -3.2843213723496474],
            [10.56051495599287, -3.2839568839549407],
            [10.569926183305295, -3.289405547744364],
            [10.565758312401197, -3.293540689141598],
            [10.569326292731168, -3.300399752685681],
            [10.568392375448067, -3.3024395039817627],
            [10.573768128226083, -3.308073813138344],
            [10.573175787889907, -3.316130309961096],
            [10.580604711344595, -3.3237249371060513],
            [10.590505350006527, -3.3232941852796065],
            [10.590610334228497, -3.3263162601010388],
            [10.594932542538128, -3.3324016589959045],
            [10.601003744035149, -3.3320069242219934],
            [10.60503058604007, -3.3343343618134593],
            [10.608856253621317, -3.3346797669667536],
            [10.612196332660266, -3.3376040981224784],
            [10.619366974786516, -3.3340097042821273],
            [10.625823115283787, -3.3386614700988377],
            [10.640579414432551, -3.341716691320086],
            [10.647759398230297, -3.334548170059847],
            [10.649163402728004, -3.331092607923081],
            [10.65679462624055, -3.331541949874458],
            [10.662310066599579, -3.328347392165089],
            [10.665171172180965, -3.3253379283420497],
            [10.664589769531622, -3.3191282381291565],
            [10.67273681389319, -3.318844365452965],
            [10.676018530275396, -3.3132529418221313],
            [10.680564675184435, -3.3133894079043835],
            [10.683245867036097, -3.31609291482736],
            [10.682325771516405, -3.3191134494117542],
            [10.684167296985569, -3.323614216908982],
            [10.690454343012146, -3.3259783901758775],
            [10.698843453858938, -3.3264690618187784],
            [10.700734318453739, -3.3286770159709715],
            [10.707028902045558, -3.324620788101014],
            [10.712757146247764, -3.3184732253005347],
            [10.718507347344817, -3.323853920549675],
            [10.72362110467295, -3.3225260344082437],
            [10.724348665488213, -3.324736345355208],
            [10.732379794392736, -3.3322897838895718],
            [10.7412679443285, -3.336340059640555],
            [10.743916892315562, -3.335865636151463],
            [10.747021954649217, -3.343471210823391],
            [10.750101124896345, -3.347176666322172],
            [10.746233829218413, -3.3502548189986388],
            [10.745973100400573, -3.355003793831011],
            [10.754306486485335, -3.3570470976722744],
            [10.759182655844208, -3.3632599211491483],
            [10.73909936303274, -3.3780070139928258],
            [10.727250689758055, -3.4245395560275207],
            [10.70856643722177, -3.5001977748497226],
            [10.68898194384085, -3.578956726112912],
            [10.688262776155682, -3.5817364849497833],
            [10.679961028025193, -3.580101444325065],
            [10.651688267288039, -3.5802667232414707],
            [10.623828788197613, -3.579651945544977],
            [10.61833081024228, -3.585966022227519],
            [10.612525939885066, -3.587111951778553],
            [10.61057229626733, -3.5910067757594377],
            [10.605952879383617, -3.596159938423023],
            [10.601817517387108, -3.603469401254829],
            [10.595799356377475, -3.6102695169283763],
            [10.591042269346566, -3.6221951793000744],
            [10.57992692451193, -3.630577820868042],
            [10.57461730287296, -3.6333884914892223],
            [10.572655209589215, -3.637338498668544],
            [10.572678680735278, -3.6427930177155656],
            [10.568720523529437, -3.6477780615168074],
            [10.559177387685736, -3.6359140786448414],
            [10.51780529881851, -3.581481947370345],
            [10.516839269617753, -3.5775866499600033],
            [10.51945444572153, -3.571185316442696],
            [10.52334143018632, -3.569796010170716],
            [10.528124679060161, -3.56463158297884],
            [10.531668399071384, -3.5630724441497845],
            [10.535004325865739, -3.557524920961427],
            [10.541991804395233, -3.552595203872094],
            [10.540395561250598, -3.548862322129682],
            [10.542467033521497, -3.5460061069953777],
            [10.546669694127285, -3.5441570461406844],
            [10.546624218563004, -3.5402174607447328],
            [10.552252415061638, -3.5338575508570393],
            [10.549556639526488, -3.5307525541690907],
            [10.548511565095364, -3.5246104235404796],
            [10.545968093991313, -3.521369688855007],
            [10.540198401515196, -3.517202744996719],
            [10.540014882390228, -3.51422683646329],
            [10.534322053745349, -3.5108785839644794],
            [10.535630844707017, -3.509112309161376],
            [10.530399371770322, -3.5026681009239247],
            [10.528729580950266, -3.4894481476299415],
            [10.52278852088357, -3.4819309238625222],
            [10.519738836947846, -3.471016720110744],
            [10.524782419315898, -3.4669594986075665],
            [10.52511010587234, -3.459992792361507],
            [10.5164409160508, -3.4493396460678754],
            [10.516291119532177, -3.446083906861388],
            [10.51309309324, -3.4420362716834765],
            [10.508668468221419, -3.4396049390588854],
            [10.505416861239766, -3.434759125484718],
            [10.50326385619645, -3.4353848391431017],
            [10.50034120923169, -3.425613897957693],
            [10.503666951272391, -3.4249865980036915],
            [10.50681249300883, -3.4201470346991005],
            [10.5121116023669, -3.414480198533667],
            [10.512694589147259, -3.4038060715523697],
            [10.515682195544752, -3.4028273765500923],
            [10.516419953689349, -3.382748111224462],
            [10.513108163702272, -3.3756098574125923],
            [10.5125738554162, -3.372190650718997],
            [10.516832051641295, -3.3613826451659894],
            [10.517999838877797, -3.355240620632782],
            [10.52215829597923, -3.351853625681332],
            [10.522615215875982, -3.3484437751755207],
            [10.519073602531234, -3.3414958058833895],
            [10.519487121145131, -3.3352489872408877],
            [10.516259657081097, -3.334452561456364],
            [10.51238038385368, -3.3280559655637085],
            [10.515246878075782, -3.3210824235349645],
            [10.514705742287225, -3.3182089446928402],
            [10.509914036669208, -3.3148755845902245],
            [10.509469215751093, -3.3114818533345147],
            [10.504603477053276, -3.31008683953763],
            [10.499228473418475, -3.31170219006436],
            [10.494588851226315, -3.3076384763306415],
            [10.488815588780662, -3.3043304476006514],
            [10.478217695686036, -3.296777477590452],
            [10.472874499204227, -3.2973717405879945],
            [10.47007586000311, -3.2910355425617723],
            [10.466760779617006, -3.2864019685957713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.53115373045915,
          "lat": 34.630974783560404
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13137"],
        "coty_name": ["Habersham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Habersham County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00351383"
      },
      "bbox": [
        10.466760779617006, -3.6477780615168074, 10.759182655844208,
        -3.251704959402077
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.50405314962622, -4.733564068805684],
            [10.51055116926412, -4.73097410574868],
            [10.515598394780307, -4.724394350796677],
            [10.516876095513876, -4.719052933618129],
            [10.522015457321451, -4.709285857967013],
            [10.52681138866585, -4.705712436308329],
            [10.52512408430636, -4.702960489757916],
            [10.517954129107867, -4.699099540837179],
            [10.515232612904581, -4.695060497621847],
            [10.520788292760589, -4.694224778876544],
            [10.520498313089973, -4.69138959349748],
            [10.513821403428041, -4.692377119640646],
            [10.512776133852176, -4.685461163986516],
            [10.526658296615613, -4.683321607898555],
            [10.524054602770605, -4.679497249869348],
            [10.525208161358213, -4.672162322807893],
            [10.529926046450038, -4.661405837373751],
            [10.533739002443602, -4.660526508430376],
            [10.537352398648595, -4.662135532026035],
            [10.540268757259783, -4.660061738942202],
            [10.540520183086533, -4.6554830069933955],
            [10.552483467412731, -4.648335904712275],
            [10.568680511063954, -4.640051789883582],
            [10.593430157353298, -4.608146878290573],
            [10.61867471705507, -4.597128702940635],
            [10.611629669567398, -4.591383837360895],
            [10.616704874371507, -4.584940206038316],
            [10.62412325548283, -4.590039060401554],
            [10.62479570227144, -4.591542993049637],
            [10.635009651525335, -4.600856263946454],
            [10.640927479337266, -4.599174454329423],
            [10.643563202938772, -4.595206128871681],
            [10.635758204076453, -4.588929328385664],
            [10.633443821468717, -4.581421561974538],
            [10.629494804162917, -4.5734092175858825],
            [10.632285910744745, -4.557198292402817],
            [10.689524068123003, -4.590482129486746],
            [10.766225569902558, -4.632568766521903],
            [10.766966652895974, -4.639469278429666],
            [10.768230994798346, -4.673471935033026],
            [10.771708558052099, -4.6929249589379465],
            [10.772294930581408, -4.713917782873438],
            [10.777207496984802, -4.754830512127151],
            [10.779245384519458, -4.7815890256493985],
            [10.790783112032114, -4.895001486707845],
            [10.714402355147557, -4.918494275805983],
            [10.573160481990342, -4.9638434528773505],
            [10.570902657344051, -4.954302111963424],
            [10.572662234784381, -4.947079626721748],
            [10.564133550484476, -4.938674595114422],
            [10.562423523225632, -4.934405842929227],
            [10.561796014555153, -4.925648297189201],
            [10.56048065182345, -4.921161888955922],
            [10.561805949521798, -4.916342572772137],
            [10.56540204913156, -4.90953381842328],
            [10.572168865959505, -4.903679355527663],
            [10.564652421245137, -4.9019248584482344],
            [10.568055025067249, -4.897308488454542],
            [10.56066495367874, -4.895242152867029],
            [10.557277854764815, -4.892168031695918],
            [10.554624154550726, -4.886700140301995],
            [10.548039740609386, -4.887874446371758],
            [10.548721635247167, -4.884739182146295],
            [10.555286806648907, -4.875199149247694],
            [10.555947235582764, -4.868085005789488],
            [10.560567200355162, -4.853909826719354],
            [10.559911468345124, -4.848576297673923],
            [10.557163368816262, -4.84480295540767],
            [10.554125614412396, -4.843567793827098],
            [10.550790272275156, -4.839336639446269],
            [10.54915922185475, -4.833651716720061],
            [10.545814441341777, -4.831598018176488],
            [10.541668757047653, -4.825858263750004],
            [10.539985860178492, -4.815812401873056],
            [10.542773565014057, -4.811558750925725],
            [10.543137683397044, -4.805215774790936],
            [10.539380371022766, -4.796259881822753],
            [10.532883387194197, -4.791192197541351],
            [10.532731034485415, -4.787199157161296],
            [10.527166590396385, -4.781100052052099],
            [10.529000887141548, -4.774668379956294],
            [10.527745340125781, -4.77036140261148],
            [10.521869236863665, -4.766855907190607],
            [10.51475001811982, -4.765241943111135],
            [10.507131588774653, -4.759431675105833],
            [10.510820626707742, -4.747350867278703],
            [10.50594600246598, -4.741588654014767],
            [10.505873312206647, -4.736253682732045],
            [10.50405314962622, -4.733564068805684]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.68802090305981,
          "lat": 33.316451160627274
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13159"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00346144"
      },
      "bbox": [
        10.50405314962622, -4.9638434528773505, 10.790783112032114,
        -4.557198292402817
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.573160481990342, -4.9638434528773505],
            [10.714402355147557, -4.918494275805983],
            [10.790783112032114, -4.895001486707845],
            [10.87701556612813, -4.869783422304862],
            [10.880242910607697, -4.871824575542833],
            [10.885280290950902, -4.868969551221928],
            [10.902634936919908, -4.9275884050600665],
            [10.906532204027844, -4.939517072099075],
            [10.928242065810602, -4.995614011806619],
            [10.934768305258755, -5.010703017077696],
            [10.97872537169439, -5.118729891597832],
            [10.941669177665327, -5.151888214363261],
            [10.860583748003622, -5.216533473879747],
            [10.857919755135834, -5.214541315943782],
            [10.852850751462842, -5.221165671897247],
            [10.829016503450367, -5.201910865881995],
            [10.813659851026193, -5.19005544825376],
            [10.804455631521826, -5.202819575569736],
            [10.803356805460584, -5.202908837792178],
            [10.784855389212044, -5.183039451232712],
            [10.735173582266587, -5.189438855692169],
            [10.732882681033864, -5.186088686564111],
            [10.732061711835161, -5.181617602116687],
            [10.726612660673297, -5.1779966926897325],
            [10.71485160127343, -5.175058702312461],
            [10.709066954862717, -5.170244312876667],
            [10.700124525203206, -5.164727366947258],
            [10.698004706467554, -5.16066782232277],
            [10.69718638248301, -5.154000910646175],
            [10.692820923012903, -5.144281724019297],
            [10.692853788633435, -5.138276297762398],
            [10.688264854491605, -5.132562477310411],
            [10.683328808919347, -5.13060043783487],
            [10.686012982396305, -5.121585211335449],
            [10.683718027669721, -5.116579391333193],
            [10.676826335423442, -5.114383132929797],
            [10.674873506070922, -5.11127229579257],
            [10.670649296927207, -5.109102171597908],
            [10.66981235078171, -5.097129260209229],
            [10.667003870096691, -5.093530498088886],
            [10.666779677445952, -5.08840159766919],
            [10.67020646828375, -5.0834945734947725],
            [10.667842318430282, -5.080252654426777],
            [10.662878259470183, -5.077912021081419],
            [10.659946332801164, -5.070761739279082],
            [10.664730358674632, -5.065082703008977],
            [10.665474280646603, -5.061580906973542],
            [10.66083326310659, -5.052778372430953],
            [10.649519898138667, -5.042919393430703],
            [10.648245962121207, -5.038303528290908],
            [10.64384767215855, -5.034459244633041],
            [10.638987698668224, -5.024560313459792],
            [10.633481809523765, -5.020848361740654],
            [10.628329891628987, -5.019680383096578],
            [10.623599520321504, -5.015455269912886],
            [10.614198661817845, -5.011249514609685],
            [10.609209596639156, -5.004956183923766],
            [10.607109043314432, -4.99920953257627],
            [10.60299489181561, -4.995032232159342],
            [10.594227997672442, -4.988902682664618],
            [10.592872679155395, -4.983243670813174],
            [10.58917990309035, -4.9771906227164795],
            [10.583188824282004, -4.972939193341481],
            [10.577021461519198, -4.973310037863606],
            [10.573834612702747, -4.9710897247201995],
            [10.573160481990342, -4.9638434528773505]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.56043946235529, "lat": 33.02511453101941 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13169"],
        "coty_name": ["Jones"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jones County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00345367"
      },
      "bbox": [
        10.573160481990342, -5.221165671897247, 10.97872537169439,
        -4.868969551221928
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.347181163648184, -6.445065220472929],
              [10.347895299219081, -6.452909159657657],
              [10.34024196775881, -6.453849266407264],
              [10.33950716631715, -6.445915394542578],
              [10.347181163648184, -6.445065220472929]
            ]
          ],
          [
            [
              [10.64107285113403, -6.188383484384155],
              [10.634473911567301, -6.200190525046371],
              [10.634869944100627, -6.205132313548465],
              [10.638780655153775, -6.211620448850832],
              [10.634973167669276, -6.217615045570267],
              [10.640687145564966, -6.226495725823255],
              [10.643067769681563, -6.232309670405486],
              [10.642782995556331, -6.236289301929829],
              [10.635699270604269, -6.241027938392961],
              [10.634719805382167, -6.251333977510833],
              [10.630472329803272, -6.250286009959046],
              [10.627544107693844, -6.25513684266997],
              [10.621095984300359, -6.260909401326561],
              [10.61995087570316, -6.266776008918216],
              [10.613017369963831, -6.267624359716904],
              [10.609424385698773, -6.27488229367842],
              [10.606862768769671, -6.28391578222721],
              [10.605730765948532, -6.29376457125673],
              [10.608821451588659, -6.2961246216500175],
              [10.606418580060424, -6.299614825593566],
              [10.602617691912576, -6.297536671148339],
              [10.59714986309732, -6.297921307357686],
              [10.594979959902656, -6.300989161719915],
              [10.584143822111221, -6.302179190020489],
              [10.582433244052103, -6.305609353218923],
              [10.58420615067564, -6.313700646275952],
              [10.591763679153113, -6.318551244634281],
              [10.597249188623865, -6.318454761259626],
              [10.59912580979428, -6.320429866049537],
              [10.59752898270773, -6.326266053956832],
              [10.605056591954707, -6.333882573577091],
              [10.605480763547737, -6.338975320028562],
              [10.600585844198525, -6.346904054707013],
              [10.59613030456725, -6.347430085414104],
              [10.59278722540945, -6.350573708305521],
              [10.592707332093662, -6.358223109684642],
              [10.591148999381897, -6.362596372757418],
              [10.591735326791685, -6.369904842955779],
              [10.588314415398196, -6.370795855520546],
              [10.585564712266589, -6.3743127264775685],
              [10.583310169960725, -6.383234326275102],
              [10.57639761821158, -6.388108820677669],
              [10.57310136557296, -6.391620248791425],
              [10.573959579422624, -6.393759823865962],
              [10.579829138363296, -6.3970544876152795],
              [10.582354756629604, -6.406438775171423],
              [10.58709835544444, -6.41378496034548],
              [10.585901599042286, -6.42082260908065],
              [10.58719798696829, -6.424753648140936],
              [10.590734075130433, -6.429588572108374],
              [10.592341918212929, -6.435141999922072],
              [10.596875478659326, -6.442171533207909],
              [10.594710944080266, -6.445234575874096],
              [10.594803199992025, -6.454028327560178],
              [10.593439806471457, -6.455444270426133],
              [10.584846127507372, -6.458451176633516],
              [10.583941004697285, -6.464136225813541],
              [10.58046877434968, -6.465750730222817],
              [10.579380898397153, -6.470729326291933],
              [10.577296577542505, -6.472487929369316],
              [10.575940522557291, -6.484500847670593],
              [10.547748110526687, -6.487774045915345],
              [10.53544489673092, -6.48998249084201],
              [10.503383299235857, -6.494288117916482],
              [10.489397277347011, -6.495938017142055],
              [10.460300997105037, -6.499953227750547],
              [10.40089476786178, -6.507312003581098],
              [10.361929182630089, -6.512734827731772],
              [10.35549938903411, -6.448153292419071],
              [10.355230996493365, -6.44414796865105],
              [10.347181163648184, -6.445065220472929],
              [10.346529878324505, -6.4379323205284615],
              [10.35454279519012, -6.437080914840601],
              [10.349633574990383, -6.38569460745707],
              [10.35505370006243, -6.38465042776874],
              [10.350582712513484, -6.343946971369635],
              [10.371820063212619, -6.34124601804871],
              [10.37209515307165, -6.338096517372933],
              [10.369540087863731, -6.335675432034676],
              [10.370724052566167, -6.32939969594216],
              [10.367732833070027, -6.324562498592466],
              [10.367699547423205, -6.3133882117809375],
              [10.365636459029158, -6.309563033271825],
              [10.366210659724638, -6.30448982255638],
              [10.363401810617772, -6.299229195063616],
              [10.357240379504947, -6.294941215615678],
              [10.351836741359486, -6.292924848269328],
              [10.351322255361538, -6.284085746382445],
              [10.347235226357439, -6.2840187854093035],
              [10.34430951421982, -6.2804037276331215],
              [10.339480105360051, -6.279080545509355],
              [10.336547565860098, -6.273840032150011],
              [10.332280471521168, -6.270836319723048],
              [10.32511466096852, -6.268986696213944],
              [10.31714352914495, -6.270638314206598],
              [10.311253572012996, -6.267884195949912],
              [10.308555200176928, -6.2688100506611155],
              [10.302442687517173, -6.266502210231626],
              [10.296958253273111, -6.267626463901629],
              [10.296496134647779, -6.2660983955177585],
              [10.294304991650947, -6.241537626538831],
              [10.293426087538569, -6.241659458345271],
              [10.291805833154147, -6.225393197153409],
              [10.335028489512062, -6.2203361830412405],
              [10.35320920969394, -6.21798358690162],
              [10.406044506901083, -6.212463068574109],
              [10.504545847736255, -6.201223194392828],
              [10.56658708698223, -6.193854489704312],
              [10.575137905721116, -6.193480732754791],
              [10.611978113770148, -6.189719551619252],
              [10.62974388457002, -6.187619524209109],
              [10.64107285113403, -6.188383484384155]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.14118960028703,
          "lat": 31.779579443954436
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13177"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00343390"
      },
      "bbox": [
        10.291805833154147, -6.512734827731772, 10.643067769681563,
        -6.187619524209109
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.639373597923592, 5.095121280687369],
            [-12.636288091265799, 5.0940249800920565],
            [-12.633819689218148, 5.097980278195425],
            [-12.627696548875809, 5.100514629343858],
            [-12.623392655602634, 5.100285631532562],
            [-12.619194874770127, 5.0978094291884775],
            [-12.613462463313661, 5.098760996024777],
            [-12.607943351650686, 5.097426801461983],
            [-12.608095421038799, 5.094017563349369],
            [-12.602753856870095, 5.092040035696296],
            [-12.591684677567757, 5.094578819828679],
            [-12.588366079624063, 5.094453751223214],
            [-12.584489031606452, 5.094201229502602],
            [-12.579501775436897, 5.096183948058859],
            [-12.574758717771497, 5.0956908227754205],
            [-12.566516183401058, 5.09953657333461],
            [-12.555487912800045, 5.102628958325054],
            [-12.54695227497888, 5.101357999763801],
            [-12.54002924318796, 5.097668395593807],
            [-12.534693239883605, 5.09338430575004],
            [-12.531918386477953, 5.088848935378233],
            [-12.526580334147406, 5.086409949550861],
            [-12.519887963395792, 5.081241999676591],
            [-12.514430025446353, 5.080742420601077],
            [-12.507333039461734, 5.085827618378799],
            [-12.499695160982137, 5.08735657520641],
            [-12.493618449839548, 5.092024309607828],
            [-12.482125191550839, 5.095613205302294],
            [-12.473868773159843, 5.0943847053478155],
            [-12.465104791698451, 5.083332641934262],
            [-12.46325446770744, 5.074388379681755],
            [-12.463799131863944, 5.069689029582842],
            [-12.460219261525632, 5.064205924329432],
            [-12.452188412796435, 5.056055424105532],
            [-12.44625532615264, 5.053404294553946],
            [-12.438365359386314, 5.051364341653317],
            [-12.434729139150429, 5.048675628767602],
            [-12.423916625923358, 5.047005645623345],
            [-12.417020751968412, 5.050195121944399],
            [-12.40409276252094, 5.052447222653036],
            [-12.400180687942704, 5.054630472909758],
            [-12.388450343317977, 5.057663331889188],
            [-12.37953319253568, 5.065515954183189],
            [-12.373590035596123, 5.07663096689572],
            [-12.366289435384251, 5.084828192538932],
            [-12.362956184293319, 5.0938496224434235],
            [-12.355487436962726, 5.102874171527038],
            [-12.343441838746147, 5.110579448836657],
            [-12.339094199781833, 5.118347664326531],
            [-12.33560480553209, 5.12248590525669],
            [-12.330319430819547, 5.125457194026761],
            [-12.325585225383128, 5.130375971187671],
            [-12.321841580790208, 5.135981127211752],
            [-12.320510237130351, 5.1405126713035445],
            [-12.315780407149028, 5.14997331368445],
            [-12.311432989718893, 5.154860257837127],
            [-12.296375132226546, 5.163498848953757],
            [-12.285157681298504, 5.164083025983475],
            [-12.274084829857408, 5.166186079929456],
            [-12.26203808351776, 5.16944420234344],
            [-12.257960688088724, 5.171570051032009],
            [-12.247646903095022, 5.171567115981926],
            [-12.241461414302433, 5.165343705644214],
            [-12.232978228826326, 5.164525492862432],
            [-12.215699939100631, 5.1627591148096945],
            [-12.20523807740104, 5.16370034024379],
            [-12.194983085869843, 5.160899284072261],
            [-12.188488928080094, 5.161495328886267],
            [-12.178064879925778, 5.169201826977415],
            [-12.173136470148599, 5.1701723731812255],
            [-12.15981651705247, 5.1698493170933855],
            [-12.15708929273474, 5.1683628818986],
            [-12.153473275948413, 5.160368746477331],
            [-12.15237529983124, 5.152467075158766],
            [-12.146548489064728, 5.145475897560947],
            [-12.143933873709084, 5.138406179349588],
            [-12.14145667771185, 5.135024217185707],
            [-12.135086800804089, 5.129979583347715],
            [-12.133489172583328, 5.120693152437222],
            [-12.126458380641118, 5.112555571945168],
            [-12.123799351437976, 5.105474412655919],
            [-12.11981159724136, 5.102291154767217],
            [-12.1134321849356, 5.1033787974814535],
            [-12.108787739665113, 5.101937675658285],
            [-12.104118775644405, 5.0979224251562485],
            [-12.089523781447266, 5.096289472739808],
            [-12.08776413684983, 5.092296205700742],
            [-12.087595413908794, 5.085196532889444],
            [-12.083664182939998, 5.082529420805973],
            [-12.080439512210733, 5.082996719357074],
            [-12.071950012470346, 5.089970395191957],
            [-12.069356747181015, 5.090920250125627],
            [-12.059763731235897, 5.090641448751665],
            [-12.048627181331376, 5.093319514763166],
            [-12.040697394647049, 5.093065280134995],
            [-12.034028565419483, 5.086881639287379],
            [-12.027141727844823, 5.0838582507986985],
            [-12.034336369344873, 5.046644090990495],
            [-11.91014736304212, 5.022669206714324],
            [-11.918140652467777, 4.979404184624831],
            [-11.92562840764235, 4.93765515785355],
            [-11.924703157936538, 4.937482359986327],
            [-11.956005385951457, 4.765392038030675],
            [-11.954771740866303, 4.765165680243651],
            [-11.980358515249769, 4.624596783641701],
            [-11.992059006295756, 4.559890775215734],
            [-12.013808003898284, 4.439999505538162],
            [-12.149710750935595, 4.462943672006102],
            [-12.226835903644034, 4.4759943086546015],
            [-12.274628553262819, 4.483950402245014],
            [-12.396617268966326, 4.504521243288873],
            [-12.506360233156371, 4.523036145716788],
            [-12.57028302561319, 4.533697026735359],
            [-12.645206802023417, 4.546588664976128],
            [-12.669684077778056, 4.551585646452922],
            [-12.692008602564739, 4.557276499237713],
            [-12.732984971631494, 4.568287246827497],
            [-12.77007841343745, 4.576176516246913],
            [-12.817851731672297, 4.585437385442725],
            [-12.944129556663693, 4.610086793351392],
            [-12.915803839903527, 4.753672749560152],
            [-12.895735324737599, 4.856213278997649],
            [-12.878982506424778, 4.941608782624671],
            [-12.882891463050052, 4.942000537726463],
            [-12.873824448872544, 4.985248067397031],
            [-12.86531609014775, 5.027275353629826],
            [-12.825007876828778, 5.019469850676122],
            [-12.709611246154248, 4.997029791754702],
            [-12.698752377588933, 5.0540363913156865],
            [-12.693185156861514, 5.081740755536311],
            [-12.691634316712108, 5.082288756302905],
            [-12.689597577232187, 5.092561836770962],
            [-12.684465765119535, 5.093026983495375],
            [-12.651238241805938, 5.089381457668114],
            [-12.640369863938696, 5.0896693612870845],
            [-12.639373597923592, 5.095121280687369]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.60009748646513,
          "lat": 42.28388158033186
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16031"],
        "coty_name": ["Cassia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cassia County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00395698"
      },
      "bbox": [
        -12.944129556663693, 4.439999505538162, -11.91014736304212,
        5.171570051032009
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.14038099598525, 5.998628667346124],
            [-14.062049566235302, 5.981856196708447],
            [-14.061889291964327, 5.982534785804688],
            [-13.93604831841808, 5.95613776605259],
            [-13.917709107135147, 6.041169571246078],
            [-13.91669394760899, 6.040979744948891],
            [-13.898320754810964, 6.124227700340391],
            [-13.897207006672792, 6.124054819580229],
            [-13.880569045220573, 6.201490578473226],
            [-13.842604472086792, 6.378269225532698],
            [-13.843448243885081, 6.378431772978005],
            [-13.833701825211344, 6.4227457061914786],
            [-13.825562030179901, 6.418721226531179],
            [-13.820546178329897, 6.418028254678129],
            [-13.817601430952639, 6.421302358097205],
            [-13.817502394557874, 6.429753210370637],
            [-13.812985231050881, 6.433772961176753],
            [-13.808294405661249, 6.435056816850599],
            [-13.806072177985218, 6.433028215597279],
            [-13.80156372426971, 6.433083636661525],
            [-13.800514603105764, 6.419932800642346],
            [-13.795197232250025, 6.418932972838521],
            [-13.794700373008698, 6.415923521693834],
            [-13.788879933279858, 6.413932103341905],
            [-13.782319220463037, 6.414763710037853],
            [-13.77679086322948, 6.418222123461003],
            [-13.768634437374153, 6.415067877293574],
            [-13.767580195692002, 6.410891216824845],
            [-13.763359609193978, 6.407695743504074],
            [-13.755203550567945, 6.413404731259629],
            [-13.75301719446067, 6.416756059638395],
            [-13.744861151864717, 6.415506862663054],
            [-13.73962295316677, 6.4197614233544655],
            [-13.735571611111112, 6.417743207737765],
            [-13.73099786889261, 6.418386472073523],
            [-13.727489977504417, 6.414812931969164],
            [-13.721206285974006, 6.419088423180665],
            [-13.721749003631702, 6.424257927431764],
            [-13.719243598687765, 6.427733388341045],
            [-13.712925031685659, 6.425657071897339],
            [-13.707923090643659, 6.4282458836559],
            [-13.706668885849167, 6.4311142840018265],
            [-13.702390368687414, 6.432005774884767],
            [-13.6972980034137, 6.437466091739842],
            [-13.697927630685397, 6.4422275846148],
            [-13.693616010633555, 6.44297777947726],
            [-13.69035782781594, 6.445923172199917],
            [-13.68656917675568, 6.446792678424736],
            [-13.685267726690995, 6.449527654446713],
            [-13.6764109335276, 6.449609640641088],
            [-13.672309707369706, 6.4474848382950505],
            [-13.667846020293593, 6.44748649683927],
            [-13.666106809578928, 6.44012181397426],
            [-13.659234320407963, 6.442126513292879],
            [-13.655117827424165, 6.448979297503463],
            [-13.652959524140847, 6.449794109005172],
            [-13.647868731967623, 6.447148558780724],
            [-13.642885417481642, 6.454256678275679],
            [-13.6459524151994, 6.4581162017044536],
            [-13.641987302555693, 6.460467351082648],
            [-13.63944956610769, 6.455777451122738],
            [-13.633600331109873, 6.4548314750625435],
            [-13.63302159793127, 6.452263865461508],
            [-13.627737094047125, 6.454160481130768],
            [-13.624485342789415, 6.457074678183009],
            [-13.62217396840801, 6.453657740146601],
            [-13.619232140778665, 6.459828787491523],
            [-13.615832516034736, 6.458992220865072],
            [-13.610095769409847, 6.462870580679548],
            [-13.606383108748961, 6.467661128703581],
            [-13.603732969614576, 6.465669210085589],
            [-13.601805326563788, 6.471287151865079],
            [-13.597114000270912, 6.473778214027789],
            [-13.59234128402726, 6.480016932056808],
            [-13.589737048977122, 6.4783879595574065],
            [-13.583883374725968, 6.482497980486542],
            [-13.578536380972267, 6.480126535197934],
            [-13.574438587165593, 6.486750135379562],
            [-13.568815596335776, 6.488994355409399],
            [-13.569843648947073, 6.493847130909797],
            [-13.56650872593233, 6.497971681111964],
            [-13.565800791094679, 6.501146662710264],
            [-13.558548961928386, 6.504504759295143],
            [-13.552541683166842, 6.500736845564622],
            [-13.550739605567243, 6.5034272931856085],
            [-13.557159157945383, 6.509461327402185],
            [-13.5591210332189, 6.5101459194514675],
            [-13.556407341416254, 6.518431275588963],
            [-13.56030123044052, 6.519796377186391],
            [-13.556998811717202, 6.524061909489881],
            [-13.554423292853327, 6.530813961823472],
            [-13.550295564035407, 6.5327926534743455],
            [-13.54495396438827, 6.53757575327886],
            [-13.546527636661983, 6.544096037371862],
            [-13.541899929330988, 6.550066021215273],
            [-13.540675242793984, 6.554203976270372],
            [-13.534903127133866, 6.556489156182241],
            [-13.526597098710281, 6.564360686050059],
            [-13.522116671076414, 6.56478409099218],
            [-13.5167529064948, 6.563476365842631],
            [-13.514967553262672, 6.566195394473387],
            [-13.511459487717218, 6.564979945990157],
            [-13.507447209928564, 6.56060193400073],
            [-13.49539772557893, 6.558659923257458],
            [-13.490345214828315, 6.555988272177277],
            [-13.487725786201043, 6.5657696468524955],
            [-13.480480988248067, 6.569011716870455],
            [-13.478015962612629, 6.572721443793666],
            [-13.472884658794696, 6.57665949282633],
            [-13.475343571237131, 6.579050508543628],
            [-13.474517779015242, 6.586626820115683],
            [-13.470134139505213, 6.595198080940719],
            [-13.472152832268927, 6.600528695207256],
            [-13.473181893168668, 6.608208380455009],
            [-13.469971586245046, 6.607813441535109],
            [-13.47040669423887, 6.614410214076969],
            [-13.459512102353253, 6.61663180659188],
            [-13.460045566681234, 6.619681092031099],
            [-13.456139727046041, 6.620486343402755],
            [-13.455816058525269, 6.626199147746767],
            [-13.449672213706672, 6.634210579296497],
            [-13.448925305410237, 6.636772619603797],
            [-13.444161920370474, 6.640345465638711],
            [-13.438419694335204, 6.641348072837825],
            [-13.437262078093037, 6.6440594132726245],
            [-13.424548362967565, 6.645314053053613],
            [-13.415763194974218, 6.643822177209176],
            [-13.411014940989045, 6.647750108297317],
            [-13.405614680871317, 6.650139362209731],
            [-13.399133473623003, 6.6477693068439505],
            [-13.384273484002676, 6.649774785245266],
            [-13.380452473418503, 6.65219155931505],
            [-13.367975441832513, 6.651843746073745],
            [-13.359501138283926, 6.654514093462322],
            [-13.354889349647571, 6.653734187702457],
            [-13.34757385502556, 6.657468630717638],
            [-13.34105478986594, 6.659320705003113],
            [-13.336297634848139, 6.6588939455891785],
            [-13.334632454961373, 6.655553884132236],
            [-13.33079952116361, 6.6565450432630575],
            [-13.329649064643107, 6.651964810000396],
            [-13.325079344780294, 6.651333036367095],
            [-13.320653035281211, 6.652733527928337],
            [-13.316662605070368, 6.650904704517078],
            [-13.315078376505161, 6.65360776447799],
            [-13.304531785767992, 6.654863951856977],
            [-13.299000129682842, 6.657353530065198],
            [-13.293992909298638, 6.654950498337614],
            [-13.277632996521183, 6.658063962004391],
            [-13.27760732887292, 6.66135569050582],
            [-13.26916353294035, 6.665474065057873],
            [-13.26923285996433, 6.6691392287174756],
            [-13.265426493619188, 6.676719055318428],
            [-13.265173393977673, 6.680774140307306],
            [-13.2579178775635, 6.688988710052698],
            [-13.257264455039385, 6.692255512314476],
            [-13.252890496372896, 6.698083511469889],
            [-13.2458599440716, 6.704643525289791],
            [-13.241209846986777, 6.7115345976440475],
            [-13.226574036615029, 6.719841516560752],
            [-13.223715975361142, 6.727776558663601],
            [-13.218811809010019, 6.732272749398925],
            [-13.214796519677524, 6.737833175351289],
            [-13.208495680720224, 6.742388052888187],
            [-13.205018906713358, 6.752494689763918],
            [-13.200200621704973, 6.759843725435837],
            [-13.199488667456256, 6.764643770945615],
            [-13.195472039388601, 6.769259602666152],
            [-13.192680083401946, 6.770179849485731],
            [-13.188047560745582, 6.774801771760551],
            [-13.191262882550046, 6.783381470852796],
            [-13.192236306018694, 6.790652727443521],
            [-13.195585419461636, 6.79468768742362],
            [-13.1985851941866, 6.800801923574375],
            [-13.207674733680916, 6.806554655161297],
            [-13.205424891839508, 6.80907040661306],
            [-13.195532755685141, 6.8046060235271515],
            [-13.191671039835828, 6.803993049532085],
            [-13.180963450900958, 6.797158069813411],
            [-13.179387647739409, 6.794549320476934],
            [-13.173008809559317, 6.794102266430062],
            [-13.16777351494713, 6.786021142485226],
            [-13.168460053279759, 6.781247059931133],
            [-13.163654001643165, 6.777272925808185],
            [-13.164053305554907, 6.768275324953491],
            [-13.160502130473507, 6.762657217419839],
            [-13.162372270458677, 6.755919734822512],
            [-13.160042257613703, 6.7524331525724826],
            [-13.16065363548324, 6.745637329929408],
            [-13.159916767552902, 6.741229874747674],
            [-13.163161519149817, 6.734351487900897],
            [-13.161602070005523, 6.72514234039467],
            [-13.162637038520312, 6.7198284318635855],
            [-13.162300421321152, 6.713836426056258],
            [-13.16549727228457, 6.71036160238205],
            [-13.16282103899136, 6.7058471465703215],
            [-13.166713091643352, 6.703624125386913],
            [-13.166361442467652, 6.700076455033598],
            [-13.163708014273283, 6.696259341216491],
            [-13.161987633388156, 6.689477590721682],
            [-13.162354556044958, 6.683427179517611],
            [-13.154473963905412, 6.678132855807799],
            [-13.14915100352174, 6.675848066854724],
            [-13.149659314406003, 6.673902964319818],
            [-13.146184150053548, 6.667072462311592],
            [-13.142720847357403, 6.666222914473403],
            [-13.132116477735531, 6.667440081718535],
            [-13.12835918668683, 6.669011131300002],
            [-13.127457283556433, 6.66315394456462],
            [-13.136369753638425, 6.6544635816356115],
            [-13.136744639101392, 6.652352929073271],
            [-13.132733467812287, 6.645887838128958],
            [-13.127054840829787, 6.647019030410772],
            [-13.124839387664224, 6.644939376259409],
            [-13.126961529506003, 6.635746169882756],
            [-13.122700079302703, 6.6315367358676465],
            [-13.117881298328914, 6.636096428241882],
            [-13.113231634656925, 6.635189211301401],
            [-13.111425048362364, 6.637751655798348],
            [-13.106781716492016, 6.637236821622825],
            [-13.098911891713882, 6.6439601987170525],
            [-13.094605296311386, 6.639372427249716],
            [-13.086164048300024, 6.637052718995254],
            [-13.081853887636555, 6.632534370324464],
            [-13.077525218403132, 6.633010709920378],
            [-13.071475208396016, 6.629412490545712],
            [-13.066986414073094, 6.629440202875364],
            [-13.062894511656765, 6.624867499065227],
            [-13.059199534859829, 6.624921123162146],
            [-13.055601950675692, 6.615538876613781],
            [-13.06238953756863, 6.611448316918899],
            [-13.062248748683057, 6.607921372549254],
            [-13.067767235916037, 6.6003934601155905],
            [-13.0724459904065, 6.6018777966339774],
            [-13.078179460522339, 6.595762904801112],
            [-13.078773734669388, 6.589739087898148],
            [-13.075105918940913, 6.58148708375207],
            [-13.07708917056129, 6.5754941069027355],
            [-13.078028049725727, 6.56665137622135],
            [-13.074441658293857, 6.564570606985099],
            [-13.069382223858517, 6.5576658675225],
            [-13.069922544046827, 6.550563002323738],
            [-13.071509471899159, 6.546548079263533],
            [-13.07458541745979, 6.54400066178014],
            [-13.077752511723158, 6.545495333397304],
            [-13.084080738838793, 6.540126046402896],
            [-13.093454100357176, 6.534563908325633],
            [-13.093171485331277, 6.53087885449684],
            [-13.097289614836619, 6.526075723497772],
            [-13.09869533150432, 6.517401335619514],
            [-13.100517031288602, 6.513099475911541],
            [-13.106634684455122, 6.513062333723934],
            [-13.112654731726394, 6.509639994381655],
            [-13.113425488111131, 6.503418326957033],
            [-13.116432072558693, 6.501722807100373],
            [-13.117069541944394, 6.496714901738242],
            [-13.119518537101543, 6.496027753716454],
            [-13.12510914277862, 6.4856081800637355],
            [-13.125918101275827, 6.477172212393783],
            [-13.127913099001626, 6.471517187107094],
            [-13.134051984831764, 6.463206809883822],
            [-13.136615616284447, 6.458521440556475],
            [-13.135444759324232, 6.456170599136506],
            [-13.136187732137053, 6.450576148217047],
            [-13.139189814734367, 6.448868532239181],
            [-13.138827606024455, 6.441875947393823],
            [-13.144020998976162, 6.437195390538588],
            [-13.143502583724992, 6.432730737950198],
            [-13.138872622876239, 6.425800317389425],
            [-13.138748854459719, 6.41902230923618],
            [-13.128758202266033, 6.414877063908964],
            [-13.129553916794032, 6.411402255918071],
            [-13.126992596049567, 6.403217610903025],
            [-13.130272072252927, 6.393978422345705],
            [-13.130112260775107, 6.3848311085663925],
            [-13.139768210290889, 6.380027181882757],
            [-13.142502870879673, 6.375890743921033],
            [-13.145112557929956, 6.375361851666211],
            [-13.147788014990464, 6.371136098634686],
            [-13.151968387945866, 6.369707121467874],
            [-13.154230863546294, 6.36537974577829],
            [-13.152932347490845, 6.362317918081625],
            [-13.152351292991668, 6.3523119112070745],
            [-13.157957408895928, 6.341478774173361],
            [-13.159938618284723, 6.339808725876155],
            [-13.159667012017632, 6.327495826606397],
            [-13.163406855414117, 6.319719080325631],
            [-13.1617647651492, 6.31494426748607],
            [-13.163405890133557, 6.311953382270564],
            [-13.166601749803254, 6.313849222611276],
            [-13.172840857365777, 6.312620877645242],
            [-13.176665163157192, 6.310625158463101],
            [-13.186021533965096, 6.3032116843436174],
            [-13.187830564911414, 6.299467321313762],
            [-13.19047974574587, 6.300251328733878],
            [-13.195285255265336, 6.306347591738443],
            [-13.20101455160582, 6.30491034405751],
            [-13.248258375370487, 6.076007293560315],
            [-13.250398606785515, 6.07631301327265],
            [-13.264615106051364, 6.00671097441084],
            [-13.284637308595036, 5.907519974398333],
            [-13.341971266805078, 5.629812555271568],
            [-13.335290172378569, 5.629495098411495],
            [-13.329884534725, 5.625664492319062],
            [-13.32583397869204, 5.624485279468068],
            [-13.314894407302889, 5.626773768990026],
            [-13.309207692064982, 5.622693103847979],
            [-13.30751225241486, 5.6199749148741045],
            [-13.311071220286719, 5.602977642336476],
            [-13.336166466501515, 5.479221349754824],
            [-13.485084069899267, 5.509434529800809],
            [-13.634010926960459, 5.539600722521895],
            [-13.616882958944872, 5.621106167676658],
            [-13.60786400440658, 5.619238407780705],
            [-13.591592374245703, 5.6976762191737516],
            [-13.602420849765446, 5.697008719818495],
            [-13.61132443860176, 5.698487892435641],
            [-13.62240974960806, 5.702804237978142],
            [-13.630624010455401, 5.700943054840984],
            [-13.634510952229027, 5.702565555004531],
            [-13.639499876335297, 5.708012596357033],
            [-13.642502941916268, 5.714445846283091],
            [-13.647998893290394, 5.71749235253592],
            [-13.652561300888893, 5.7221079931414165],
            [-13.656814290666514, 5.723233449124305],
            [-13.669647435921629, 5.72278435374585],
            [-13.675755546081001, 5.718740282676688],
            [-13.680055224276519, 5.71944342562371],
            [-13.689872175062659, 5.7242380942979905],
            [-13.69678810745148, 5.725082634374372],
            [-13.70634619846714, 5.728182158079089],
            [-13.709697545980719, 5.7379777787703805],
            [-13.709539592814679, 5.741142698847401],
            [-13.715760861673695, 5.7485461324454725],
            [-13.723813124214734, 5.750653020457478],
            [-13.733943066815648, 5.749830846365054],
            [-13.741107447466652, 5.745971869044197],
            [-13.752554320144082, 5.743728767703289],
            [-13.760343580936299, 5.744026322922355],
            [-13.7701545313506, 5.743195437589592],
            [-13.786666239777523, 5.747310950030028],
            [-13.789849276808424, 5.748682204728822],
            [-13.79756574626237, 5.748604688715772],
            [-13.802409676446002, 5.753678835319203],
            [-13.808548985912683, 5.750565065680457],
            [-13.814190510416813, 5.750669799001197],
            [-13.817858773832448, 5.752881608770205],
            [-13.825167701064087, 5.754017357256839],
            [-13.831199927898382, 5.760074739339068],
            [-13.835812345078352, 5.762216066457443],
            [-13.84074492980278, 5.767566771797881],
            [-13.840460600042546, 5.770463553810925],
            [-13.831025317228534, 5.777471155342307],
            [-13.830938414829367, 5.786521407563127],
            [-13.834384555723018, 5.791115369789318],
            [-13.843975057027931, 5.79425636911045],
            [-13.850660336387495, 5.793834829680312],
            [-13.86119455163553, 5.796667758352868],
            [-13.872033568235567, 5.795166990453776],
            [-13.877798775608383, 5.799791398216587],
            [-13.884002426483766, 5.803339928610067],
            [-13.884333093123587, 5.811768399346452],
            [-13.890825620732315, 5.819230243879694],
            [-13.897398875745505, 5.819305404304243],
            [-13.90283001824313, 5.815379118051394],
            [-13.912338424364798, 5.816998485984589],
            [-13.918654477887051, 5.8235732354153065],
            [-13.916981610665177, 5.8292312017171835],
            [-13.922072724808174, 5.8385347050498],
            [-13.92885554746641, 5.840387075886097],
            [-13.931590286880823, 5.839439269867826],
            [-13.937170239219661, 5.834073364999048],
            [-13.943662412013847, 5.833935461421953],
            [-13.947051161172793, 5.831520864578562],
            [-13.950044087540121, 5.831721800226506],
            [-13.956002663915742, 5.824121178963646],
            [-13.95613580913016, 5.821139980925257],
            [-13.961340834568347, 5.815310737855531],
            [-13.957015145198692, 5.799886262751821],
            [-13.957277918564177, 5.795461254034426],
            [-13.961879602027958, 5.787996276185639],
            [-13.97075223293516, 5.793878088228854],
            [-13.985875373971357, 5.798261417803696],
            [-13.994575486519285, 5.801623971547742],
            [-14.000256852815557, 5.8097527004151175],
            [-14.005886705426253, 5.81597214665653],
            [-14.009435324364988, 5.830507754763438],
            [-14.01369816733943, 5.841612681544784],
            [-14.015936065974993, 5.8441345820635195],
            [-14.023035824044113, 5.846160286302947],
            [-14.031444135191654, 5.845828309500677],
            [-14.042077814086916, 5.850293047778311],
            [-14.044750275385931, 5.858512583527486],
            [-14.049604352982156, 5.864167709197607],
            [-14.054866493859432, 5.876501409126209],
            [-14.060945326166078, 5.881527158685848],
            [-14.06466275716785, 5.882916628158347],
            [-14.070277769538594, 5.882254753196515],
            [-14.075843956172555, 5.883635312314402],
            [-14.077859256369482, 5.886569406430282],
            [-14.076324551201177, 5.891764824826444],
            [-14.0693629389356, 5.896151524056304],
            [-14.068455003264987, 5.9032406136272915],
            [-14.074108146737355, 5.909791204995797],
            [-14.078646713385533, 5.911003545116613],
            [-14.085846853988237, 5.910734135427551],
            [-14.090022541293704, 5.912550900867008],
            [-14.092323154734816, 5.917080328517617],
            [-14.098150095899886, 5.919303908846368],
            [-14.108062454825413, 5.926878068646761],
            [-14.11010084779001, 5.932131618956988],
            [-14.108957087100688, 5.936603717715779],
            [-14.109447771908586, 5.942416017826002],
            [-14.106728122192552, 5.948850507579232],
            [-14.097610579750263, 5.954277930967606],
            [-14.093798583117485, 5.958134213234219],
            [-14.101676600295947, 5.970831420909264],
            [-14.105324343948553, 5.97340797903059],
            [-14.11369009219565, 5.976692530094355],
            [-14.123708723235078, 5.976825585262442],
            [-14.127790178870189, 5.981194042106509],
            [-14.13506810665727, 5.985618419329288],
            [-14.142142978191558, 5.992695791637125],
            [-14.14038099598525, 5.998628667346124]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.46930219339545,
          "lat": 43.35391266288463
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16039"],
        "coty_name": ["Elmore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elmore County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00400252"
      },
      "bbox": [
        -14.142142978191558, 5.479221349754824, -13.055601950675692,
        6.80907040661306
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8650459340266674, 1.5928540001246043],
            [3.925483203231267, 1.5955094707543613],
            [3.94708222075942, 1.5963255760181723],
            [3.982538955384403, 1.5972586371699844],
            [4.051378885985477, 1.5992595359199382],
            [4.089409476274006, 1.6006778028273125],
            [4.1373541017929965, 1.601822315232032],
            [4.197559722220989, 1.6042800062012468],
            [4.313781481651123, 1.6085819877160035],
            [4.317431626813669, 1.519247538965824],
            [4.320397472991399, 1.454189269361759],
            [4.3211733096539735, 1.432148590008842],
            [4.325906804476338, 1.3436061650042785],
            [4.32524988551217, 1.3298986427890427],
            [4.325645702567516, 1.3153571309095],
            [4.3290107579431485, 1.257662215422546],
            [4.331259212119852, 1.2215228507558478],
            [4.334282533110872, 1.1692966507004139],
            [4.264215871955458, 1.1653121336607275],
            [4.189628389849385, 1.161677964415049],
            [4.175313102614275, 1.1611691258894667],
            [4.15803713918163, 1.1599459773542669],
            [4.068189962738741, 1.1557765931208104],
            [4.009602103009892, 1.1540915900710822],
            [3.9925376942042092, 1.1533508799606103],
            [3.991636934340961, 1.1596041029562503],
            [3.991731652360498, 1.1741891678879985],
            [3.9938121534190403, 1.1800402118050144],
            [3.992139148133816, 1.1877628786859848],
            [3.988327019108823, 1.1952538752833277],
            [3.980186760131076, 1.2058387669633521],
            [3.9645912188841814, 1.2150313255539653],
            [3.957968249658468, 1.2201154085826136],
            [3.951496466695175, 1.223350569079324],
            [3.9397123627064157, 1.2306793657950725],
            [3.9343749605048726, 1.2382102560392778],
            [3.9253197648831155, 1.2629126100437955],
            [3.9238463585193624, 1.2704756551526808],
            [3.9263798042098275, 1.2863875228330233],
            [3.936747333737665, 1.3011748009193351],
            [3.942533286904108, 1.3086616588964484],
            [3.943752350665945, 1.3160548626491386],
            [3.9430607674832325, 1.3216690162030593],
            [3.9409291544009393, 1.3268753424692183],
            [3.9350705316485426, 1.334439600865672],
            [3.9299770144224073, 1.3387773375910246],
            [3.925070269422683, 1.3446234569990076],
            [3.920367253936828, 1.3526834563291577],
            [3.918138550197872, 1.3584107350383898],
            [3.914175366751072, 1.3643095512006675],
            [3.9100553880752624, 1.3727846764881613],
            [3.9068138063289406, 1.3746023953523179],
            [3.9042790749325453, 1.3799435853058313],
            [3.9019455889699635, 1.3879870928122442],
            [3.8951846193165918, 1.4014675458094685],
            [3.8868824866677247, 1.4154224940115803],
            [3.8805433888484377, 1.4285055849962085],
            [3.8835343852312456, 1.4498380113739124],
            [3.878524976196133, 1.4632503834704063],
            [3.873435320631655, 1.4832121693191063],
            [3.8686913928895823, 1.5003271383505448],
            [3.864477047860882, 1.5201915444577307],
            [3.862487311703056, 1.5393821324474748],
            [3.8646505839019563, 1.550162061231387],
            [3.861218511962758, 1.5629009751920677],
            [3.8599426927089517, 1.5735655575501455],
            [3.861012136165397, 1.5814235878519671],
            [3.864905570331077, 1.58848613608457],
            [3.8650459340266674, 1.5928540001246043]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.1885232754411, "lat": 39.987890459143955 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00424202"
      },
      "bbox": [
        3.8599426927089517, 1.1533508799606103, 4.334282533110872,
        1.6085819877160035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.631114578023775, 4.014504836612266],
            [5.743644590892394, 4.01986564154483],
            [5.751013480585482, 4.020465496905626],
            [5.759214224762542, 4.021133991544124],
            [5.801423424050136, 4.025886483980116],
            [5.805488627281549, 3.9836212997163383],
            [5.808569398158768, 3.9472871313547264],
            [5.81553427441159, 3.8600845673590642],
            [5.823900342501081, 3.752909890442665],
            [5.826609187061588, 3.715728828510794],
            [5.829010927546597, 3.6854524012166867],
            [5.743251711247922, 3.678776979960125],
            [5.657201587419065, 3.671253656897992],
            [5.6548852187741545, 3.700384575348707],
            [5.649771196988793, 3.758427858531702],
            [5.646094046690969, 3.809576638278352],
            [5.643818845180483, 3.845891495871949],
            [5.641106477177965, 3.8820203464482397],
            [5.637732020147312, 3.9220338384819806],
            [5.631114578023775, 4.014504836612266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.82336833619726,
          "lat": 42.323073874499016
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17007"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00424205"
      },
      "bbox": [
        5.631114578023775, 3.671253656897992, 5.829010927546597,
        4.025886483980116
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.536755388487194, 0.11730550801788543],
            [6.606789726111412, 0.12399968398663362],
            [6.620979514439569, 0.1257673015747214],
            [6.64775269461131, 0.12798978429954808],
            [6.666013038784053, 0.1291043426604032],
            [6.685669201688206, 0.13099754899549557],
            [6.683104250247933, 0.12695542910216842],
            [6.683320433941671, 0.12145586305228631],
            [6.6875405779065495, 0.11893584924480885],
            [6.687159742948416, 0.11391661848451262],
            [6.690911113511626, 0.10812625518736523],
            [6.690199366768091, 0.10300390500506472],
            [6.69660612404983, 0.1023126543510875],
            [6.698929679044147, 0.09491359406366622],
            [6.701381320210926, 0.09448051061917334],
            [6.6957073976485155, 0.0827170611034812],
            [6.691065766651151, 0.07949457598088784],
            [6.690095821338977, 0.075446824539721],
            [6.693016176707948, 0.06748202353423544],
            [6.690259903783067, 0.057277246550942754],
            [6.693336458279279, 0.0530499069491284],
            [6.691436935065831, 0.05037142562755324],
            [6.695745323020662, 0.04793092654472985],
            [6.693968662274563, 0.04297858655543073],
            [6.698667437486496, 0.03939172544488715],
            [6.699063057692629, 0.03165444459534893],
            [6.704569592602378, 0.021503608091153172],
            [6.700838541557782, 0.018738207259264176],
            [6.7038431266078105, 0.01665344871847705],
            [6.703889847383268, 0.0025900772199232607],
            [6.700484468481451, -0.0026395609135550766],
            [6.699263522215308, -0.009414549354371523],
            [6.7032262338977935, -0.01019186231364311],
            [6.700828782433072, -0.013967744357563792],
            [6.700532561515975, -0.021907713968263437],
            [6.696148020874438, -0.01961545747818996],
            [6.690053156783627, -0.030308831705400396],
            [6.68726836375184, -0.030594376994701817],
            [6.687831436430048, -0.0390826217733583],
            [6.683663452859802, -0.041756159404013546],
            [6.687076024226771, -0.046378261518654006],
            [6.692198431352734, -0.04594844205171311],
            [6.693013315472909, -0.04993912404594283],
            [6.6868850011748835, -0.05220024255756671],
            [6.684463698861969, -0.057555301887803036],
            [6.684653947327815, -0.06405742149196121],
            [6.6882308910639825, -0.07142111754184209],
            [6.688553189610827, -0.07579912380805212],
            [6.693357257467562, -0.08255206851995865],
            [6.694399932602322, -0.08784092330595618],
            [6.702173044021012, -0.0927801513823876],
            [6.702981950379813, -0.09756584961089462],
            [6.7061864828439175, -0.103610670561095],
            [6.704176892836267, -0.10955771411729394],
            [6.705765555168798, -0.1159879340385592],
            [6.704360902865598, -0.11998142525544676],
            [6.706097470679723, -0.12359495373746734],
            [6.712264864219226, -0.12420348907217187],
            [6.714256713266227, -0.13164321848803848],
            [6.712127743395585, -0.133517468296302],
            [6.708238619146166, -0.13238823221622265],
            [6.7068482033670955, -0.14117812491350445],
            [6.709564021616609, -0.1441288715612326],
            [6.708273449122679, -0.1491798694224346],
            [6.700725269283841, -0.15538656311865934],
            [6.698641095317463, -0.15828110907719864],
            [6.695114625296694, -0.15769599630438816],
            [6.69289248873492, -0.16600757914069025],
            [6.693967492595967, -0.1693257436035116],
            [6.685386970938592, -0.1691807908293663],
            [6.682897305260262, -0.17329069621340337],
            [6.6843301011183005, -0.1838793008927332],
            [6.6556007352965825, -0.1860318880740523],
            [6.655903073527245, -0.19029605829584054],
            [6.56043491418628, -0.1977588421049191],
            [6.558099583970209, -0.1596145116369423],
            [6.5551625391883706, -0.11769605284915688],
            [6.551126788874675, -0.06304197166701007],
            [6.546324950291994, -0.0007236838675971911],
            [6.545738891318436, 0.009295350845687217],
            [6.5446085561727605, 0.01522242639382345],
            [6.543814260168219, 0.029964112591198903],
            [6.536755388487194, 0.11730550801788543]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.05339211748435, "lat": 38.41653807940721 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17047"],
        "coty_name": ["Edwards"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edwards County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00424225"
      },
      "bbox": [
        6.536755388487194, -0.1977588421049191, 6.714256713266227,
        0.13099754899549557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.619595012537374, 2.5049681037832654],
            [4.615759046826427, 2.5929932622938887],
            [4.651501206816952, 2.5948380677390843],
            [4.701122904113594, 2.597772861977338],
            [4.7863268744875, 2.6038353621799035],
            [4.855928641136298, 2.606190239930207],
            [4.882772568629709, 2.607362264330688],
            [4.953667917435468, 2.611491183904451],
            [4.958896029652629, 2.523540849583684],
            [4.964133969011873, 2.435628796565458],
            [4.969021135158586, 2.3594944228662866],
            [4.975366604559622, 2.260244101764198],
            [4.980412834255255, 2.17198932423897],
            [4.944527998229459, 2.1702131005845278],
            [4.9018382969214445, 2.167710187172051],
            [4.808381538334888, 2.162589813004776],
            [4.701126807793639, 2.156644212829099],
            [4.636493122217773, 2.1535772147522887],
            [4.632469922966805, 2.240865477987407],
            [4.629488527423616, 2.2997348872745316],
            [4.6274947412718275, 2.343707884989412],
            [4.623931130238421, 2.4169210990870544],
            [4.620909727818471, 2.4756153221389954],
            [4.619595012537374, 2.5049681037832654]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.21323589455082, "lat": 40.93181399928879 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17095"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00424249"
      },
      "bbox": [
        4.615759046826427, 2.1535772147522887, 4.980412834255255,
        2.611491183904451
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.045018579914329, 1.0446520145995313],
            [8.09572665865737, 1.0516190730347978],
            [8.11901307499138, 1.0549863540918458],
            [8.126785792784384, 1.0557262418283289],
            [8.1464583905615, 1.0585740170882885],
            [8.208007489889503, 1.0670451395156082],
            [8.262859481604481, 1.073876199006192],
            [8.349895958244803, 1.083164179172783],
            [8.353067853556544, 1.045832195129542],
            [8.357953670652316, 0.9940493563310465],
            [8.365757812889125, 0.917921045610978],
            [8.372133559028692, 0.8630240708879438],
            [8.329012417427816, 0.8577805290657786],
            [8.314514917639267, 0.8551464313511666],
            [8.285990769882458, 0.8517004922949326],
            [8.293306012114508, 0.7912007905511921],
            [8.288930532926932, 0.7930262868839663],
            [8.277592661204043, 0.7900761867439623],
            [8.274793482048917, 0.7904017478937921],
            [8.271315282452454, 0.7838100459216795],
            [8.267715553491964, 0.7835006107300078],
            [8.257285827284965, 0.778485710392337],
            [8.25767503745128, 0.7738610082373977],
            [8.252756284729598, 0.7729428892639877],
            [8.250244903922882, 0.7676835548186574],
            [8.246753590230714, 0.7662832073573694],
            [8.2494552687906, 0.7623660352447013],
            [8.24904788660712, 0.7583971866483334],
            [8.23617737104108, 0.756499326388333],
            [8.211815826760784, 0.7537794198829724],
            [8.172573031708827, 0.7474419472208492],
            [8.095678661119463, 0.7371539728675768],
            [8.081831390251297, 0.7356037174318777],
            [8.079992716694752, 0.7499946990698695],
            [8.07640103542997, 0.7794237437157022],
            [8.077853101214764, 0.7795839598519841],
            [8.07494984586879, 0.8048447823112972],
            [8.060294558940159, 0.9265924404368163],
            [8.056564317490134, 0.9563213089388266],
            [8.055986411629874, 0.956287186198479],
            [8.04762249283213, 1.0284664363069418],
            [8.045018579914329, 1.0446520145995313]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.89757320740502, "lat": 39.20593986454745 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18005"],
        "coty_name": ["Bartholomew"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bartholomew County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00451683"
      },
      "bbox": [
        8.045018579914329, 0.7356037174318777, 8.372133559028692,
        1.083164179172783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.31320122627645, 1.2359691849140413],
            [7.303854000947925, 1.3457368491987132],
            [7.300655458651192, 1.3865444833866938],
            [7.293888484303324, 1.4631243160706722],
            [7.290956119762645, 1.4993280657629147],
            [7.345919514792985, 1.5038780942303562],
            [7.3478812023498765, 1.5042318990116887],
            [7.392840665223138, 1.508192324549737],
            [7.395759512515526, 1.508174385204943],
            [7.457830852122859, 1.5137335909051632],
            [7.5291002592583185, 1.5204266276283966],
            [7.535370612035394, 1.5210394887462007],
            [7.54565759833817, 1.4165917508818824],
            [7.549767577711872, 1.3728169380894575],
            [7.5580887437101785, 1.2856164042204878],
            [7.592800548944472, 1.288633470515291],
            [7.590591367213004, 1.2858488256288068],
            [7.593093153136773, 1.2771114893459943],
            [7.591045062522006, 1.272862248591865],
            [7.585784463286944, 1.2655227510473794],
            [7.584320460487554, 1.2587495966870454],
            [7.585768140389566, 1.2542064471082566],
            [7.588461938178846, 1.2533769684381275],
            [7.58757110813106, 1.245224321799535],
            [7.584281633235221, 1.2362449978107213],
            [7.58781199056132, 1.2320672951713951],
            [7.587356724939184, 1.2279316491696188],
            [7.589091604711627, 1.2237097625150692],
            [7.593254394823681, 1.2194617183777072],
            [7.591116184414037, 1.2170826607559875],
            [7.5932893607625935, 1.2095747620550328],
            [7.59053832897968, 1.2087821595275205],
            [7.586442339457638, 1.2037794546776783],
            [7.586076900113464, 1.197107241307488],
            [7.575353313086595, 1.1826228423714613],
            [7.568688207451514, 1.1765999484351113],
            [7.5712897932021175, 1.150880643816401],
            [7.5742672644545, 1.1252149626299879],
            [7.5752159140551445, 1.1246713335262108],
            [7.573406716176413, 1.1249407483945397],
            [7.546367668525912, 1.122483384114625],
            [7.516896484241779, 1.1190932921126586],
            [7.500155388968392, 1.1189184072004905],
            [7.458021588801459, 1.1152012976956056],
            [7.449229948629484, 1.1146886359731494],
            [7.3986857047679875, 1.1102668449091],
            [7.381360925121618, 1.1092057415611516],
            [7.335623321733956, 1.1052595632102198],
            [7.324586801720326, 1.1040309187752417],
            [7.320649710460189, 1.1477772101843287],
            [7.31320122627645, 1.2359691849140413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.84499399836807, "lat": 39.66624898570418 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18133"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00450384"
      },
      "bbox": [
        7.290956119762645, 1.1040309187752417, 7.5932893607625935,
        1.5210394887462007
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.134403693762264, 3.1913279514193698],
            [1.2206164276476252, 3.1917557857863237],
            [1.2710216140984152, 3.192395409926703],
            [1.3067378115275485, 3.192627105828286],
            [1.3631309646616836, 3.1934157612838003],
            [1.3916752071884484, 3.193264327710816],
            [1.392913533647194, 3.1360073311998056],
            [1.3938333160884646, 3.076798042540552],
            [1.3941889141487762, 3.0331287150045743],
            [1.3948580742492833, 2.997010565114163],
            [1.3956357349837683, 2.9315116266055723],
            [1.4278836405335829, 2.9319435382776664],
            [1.429320284927833, 2.8332873748953866],
            [1.282826753517104, 2.831784981314202],
            [1.176561483310714, 2.830833220149866],
            [1.175586606626301, 2.9289174629308037],
            [1.1371695147333096, 2.928443053398622],
            [1.1365152832620358, 2.9864771257357163],
            [1.1358642247471806, 3.0152700436303808],
            [1.1349067677611535, 3.1043938921185172],
            [1.1348969895073115, 3.1260212027081367],
            [1.134403693762264, 3.1913279514193698]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.90580405102156, "lat": 41.68458601073157 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19009"],
        "coty_name": ["Audubon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Audubon County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00465194"
      },
      "bbox": [
        1.134403693762264, 2.830833220149866, 1.429320284927833,
        3.1934157612838003
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.020328564567127, 4.065214857003915],
            [4.106320177246389, 4.070161059431465],
            [4.141852175808444, 4.071884088712001],
            [4.192149981871725, 4.074081539126097],
            [4.190931982465306, 4.103713343560488],
            [4.1979914787758945, 4.101285980442968],
            [4.213011208120218, 4.098333445672755],
            [4.223898431868165, 4.094995630741899],
            [4.264883522995127, 4.08812787739911],
            [4.271403425814344, 4.086590918224918],
            [4.285209606468988, 4.084890654448231],
            [4.304380555145973, 4.080033388665898],
            [4.313655794629907, 4.078412209334765],
            [4.321778596865963, 4.076169410456324],
            [4.330073848027983, 4.071925678368402],
            [4.3351413100928315, 4.066857750831702],
            [4.337487137886971, 4.058649868162975],
            [4.3423845965108585, 4.050928848500358],
            [4.347626608261507, 4.035829058260535],
            [4.348791916830914, 4.028430486544873],
            [4.354921757883071, 4.018446822310281],
            [4.368723864444179, 4.005642716981564],
            [4.371048349397514, 3.9956191684105846],
            [4.375155001708993, 3.98780597245545],
            [4.38065611855543, 3.982542739671318],
            [4.383101731937818, 3.978157554432355],
            [4.3854065987229705, 3.9679946844185765],
            [4.390186761395203, 3.957291269946674],
            [4.39036987645043, 3.953980149277714],
            [4.385750629327054, 3.946753194607181],
            [4.377130784396683, 3.9293962216401344],
            [4.377296272902024, 3.9212597215002307],
            [4.379267508618973, 3.9162415048442485],
            [4.384982446403153, 3.90992621198767],
            [4.402111761172791, 3.8978173769141193],
            [4.41570732352876, 3.8911450220929704],
            [4.42758324932786, 3.887783912190741],
            [4.433824901788224, 3.885065263368161],
            [4.442320830390637, 3.8827975659327136],
            [4.446508278414555, 3.8800603457683494],
            [4.450365142543265, 3.874401547854397],
            [4.452713891397454, 3.8625528803851727],
            [4.455299664113878, 3.85782622463355],
            [4.460563367871125, 3.855086751425952],
            [4.483522192018893, 3.8462499354795563],
            [4.496692382039814, 3.839485285950277],
            [4.506802055665361, 3.8296098615615746],
            [4.511965080149885, 3.829381026766809],
            [4.516791216159485, 3.8264843109205238],
            [4.495900496629233, 3.825816160404277],
            [4.37665839248321, 3.819187503685255],
            [4.381214576720533, 3.731457745823783],
            [4.336714466121852, 3.7291581065766097],
            [4.3191657478016, 3.7280065299219993],
            [4.245845580615279, 3.7242249708538155],
            [4.210634402546381, 3.722642997672333],
            [4.183928465700187, 3.7211045086403214],
            [4.13004414633119, 3.7189036288195765],
            [4.040335922998037, 3.7142479615840154],
            [4.034416763347687, 3.8217001938287867],
            [4.03069462284485, 3.890253752132821],
            [4.028275241160976, 3.8901370640076016],
            [4.023596361131949, 3.9777525470900588],
            [4.020328564567127, 4.065214857003915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.882494267591, "lat": 42.46879889752418 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19061"],
        "coty_name": ["Dubuque"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dubuque County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00465219"
      },
      "bbox": [
        4.020328564567127, 3.7142479615840154, 4.516791216159485,
        4.103713343560488
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5976309322840991, 4.246729373608138],
            [1.6835745302842513, 4.248122630007993],
            [1.768950075376415, 4.249834363886188],
            [1.8117376952478066, 4.250774709644683],
            [1.9411102313235524, 4.252879745268438],
            [1.9413267242230088, 4.236844768700926],
            [1.943462186727402, 4.134485031087514],
            [1.9438483592170979, 4.112587016802984],
            [1.9449000968715522, 4.072517654741969],
            [1.9452154451013899, 4.0435123117751415],
            [1.9464104498458665, 3.988993287075587],
            [1.859864315994028, 3.987281643220805],
            [1.7886829113404212, 3.9858226667650714],
            [1.785072804202409, 3.985375593225101],
            [1.6883364870971713, 3.984364241927885],
            [1.6454151262229524, 3.983532352961207],
            [1.6018692183073369, 3.982968691350924],
            [1.6003200364420485, 4.074452453003461],
            [1.5985091847499424, 4.201122923023853],
            [1.5976309322840991, 4.246729373608138]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.2072112972599, "lat": 42.776443251132896 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19091"],
        "coty_name": ["Humboldt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Humboldt County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00465234"
      },
      "bbox": [
        1.5976309322840991, 3.982968691350924, 1.9464104498458665,
        4.252879745268438
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5925936408601143, 0.26651122199978194],
            [-0.5916940442843878, 0.30665296203003256],
            [-0.5897034921189517, 0.4422707875123027],
            [-0.573333652787612, 0.4423232002387768],
            [-0.4589101683781965, 0.441855929425027],
            [-0.4572073772871194, 0.44204646014478594],
            [-0.34750146359718387, 0.4402292901738864],
            [-0.27626848225688727, 0.4387638955802869],
            [-0.2764968538064805, 0.3925612016289618],
            [-0.27704524629116173, 0.3507336080871721],
            [-0.2781806183581963, 0.28002590665323546],
            [-0.2782068507695929, 0.2697666090901136],
            [-0.273719874790127, 0.2716205085376561],
            [-0.2680725388904482, 0.2760993907469337],
            [-0.268743257730891, 0.2805618956427096],
            [-0.26482955607419567, 0.2796827587485804],
            [-0.258589416802493, 0.2803721117083988],
            [-0.2545374458554628, 0.27756364363373975],
            [-0.2533226694766892, 0.28082819072052345],
            [-0.2493757657470079, 0.283656140890378],
            [-0.24972725898896536, 0.262130808061146],
            [-0.2508305169259278, 0.17402447288699222],
            [-0.22271648099120706, 0.1734699826341158],
            [-0.22308149782620912, 0.14430214415537584],
            [-0.22312433090556782, 0.11509870093562648],
            [-0.2518077436902112, 0.11527700573593352],
            [-0.25208665645586753, 0.08597655620736123],
            [-0.25295800394680706, 0.022959201067015118],
            [-0.2530601453603359, -0.0020006094442700747],
            [-0.2554058899931588, -0.0019736438523707493],
            [-0.2555732227092421, -0.018750634767093523],
            [-0.2578036675441707, -0.040474638474446184],
            [-0.25577383304787077, -0.047933696809511296],
            [-0.25616717526675825, -0.08946190364767029],
            [-0.32071047036889666, -0.08900781299944337],
            [-0.33246225056800965, -0.08906733621645559],
            [-0.42676147119724356, -0.08739425913617138],
            [-0.468541929937501, -0.08720672269620941],
            [-0.4697652313376229, -0.0870013563128272],
            [-0.5121061279876055, -0.08656685837846972],
            [-0.5833766417059727, -0.08564623164671017],
            [-0.5979014685555119, -0.08533195753994828],
            [-0.5965121776261713, 0.01711951454488847],
            [-0.5953004284329144, 0.09041158198616883],
            [-0.5948473741746261, 0.13457423754597225],
            [-0.5936237157261292, 0.2223740398168902],
            [-0.6006213416373345, 0.22266928081037687],
            [-0.6004043208405931, 0.2373896383073681],
            [-0.5931021746056423, 0.2373091229335334],
            [-0.5925936408601143, 0.26651122199978194]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.15269239397904,
          "lat": 38.866498073618395
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20041"],
        "coty_name": ["Dickinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickinson County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00484990"
      },
      "bbox": [
        -0.6006213416373345, -0.08946190364767029, -0.22271648099120706,
        0.4423232002387768
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7787876463588971, 0.5202759347360133],
            [0.778895985204913, 0.5786297488074802],
            [0.7786581136748052, 0.6593163912230242],
            [0.7780378935857709, 0.7252013473344323],
            [0.7925351262253081, 0.7252290945036511],
            [0.876931485352374, 0.7275461446872331],
            [0.9341620760693581, 0.727366850951652],
            [0.9628407339851678, 0.7270118853281642],
            [0.9799838771821789, 0.7272052249760871],
            [1.0563334713750687, 0.7270644292070242],
            [1.0905678951908508, 0.7273564436610391],
            [1.0914416037018826, 0.7127533114595339],
            [1.0914794173429927, 0.6833471417078443],
            [1.0922240568850095, 0.6250991608340056],
            [1.092303026600953, 0.5883151012841077],
            [1.0928251178094244, 0.5076807264685287],
            [1.0934124112800956, 0.44902156877180677],
            [1.0936824069457884, 0.4342876463173525],
            [1.0876601366966796, 0.43425613714600947],
            [1.0884497259990515, 0.37793383697759153],
            [1.0890531455246606, 0.34865117460873746],
            [1.0611262526706364, 0.348543857977951],
            [1.0216337724307851, 0.3480965415333457],
            [1.017891618432895, 0.35119596076485554],
            [1.014164229655907, 0.3506397591017376],
            [1.0133375082716838, 0.3466202025723113],
            [1.015600324678245, 0.34249769638074773],
            [1.0137597191994168, 0.3396830638869217],
            [1.0084987656317488, 0.3453724151218868],
            [1.0038003368523332, 0.3461452749142613],
            [0.990700718849908, 0.3383763843047378],
            [0.9868562370571612, 0.33804588547341713],
            [0.9806163527073023, 0.3352552725630609],
            [0.9676067177000302, 0.3356804006708175],
            [0.9622505912791559, 0.3385565143556461],
            [0.9573879270323581, 0.33871333721812363],
            [0.9515100106782833, 0.34332632007743635],
            [0.9346515277987992, 0.35225406978088397],
            [0.9315715352660415, 0.35466650424994134],
            [0.9246667262044891, 0.36353869533863825],
            [0.910191176023079, 0.3706585894489892],
            [0.8964354466416964, 0.3731786669107268],
            [0.8815632539783503, 0.3715534692864395],
            [0.873806438827131, 0.36741653006385283],
            [0.8618607359420872, 0.35994893620979523],
            [0.8530632871547393, 0.35695344593871775],
            [0.8481011023372165, 0.35965519442758775],
            [0.8423742868595622, 0.3676528137642205],
            [0.8375501507732809, 0.3701964547364737],
            [0.8313970193720343, 0.3679521593225547],
            [0.821720223269955, 0.3690510515825443],
            [0.8152821002503731, 0.37205673117522453],
            [0.8107458279966143, 0.3712435138877351],
            [0.7939200587675245, 0.3588250014813886],
            [0.7849761032645411, 0.3566669657074421],
            [0.7795789483149594, 0.3611211140411753],
            [0.7738440343358222, 0.36739556309386834],
            [0.7725843290721751, 0.37631723468909045],
            [0.7753894002748802, 0.3847997692666092],
            [0.7751408647951026, 0.43262429172946265],
            [0.7792950052561288, 0.43252501194211335],
            [0.7789636752180555, 0.46192145636360327],
            [0.7787876463588971, 0.5202759347360133]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.38342561495281,
          "lat": 39.235801435488625
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20087"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00485008"
      },
      "bbox": [
        0.7725843290721751, 0.3352552725630609, 1.0936824069457884,
        0.7275461446872331
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.22271648099120706, 0.1734699826341158],
            [-0.16539683743736944, 0.17277979931752316],
            [-0.08020799743958679, 0.17246451993924236],
            [-0.022838503751913406, 0.17202986384212174],
            [0.06262792540915145, 0.17116289829448217],
            [0.0769908454345918, 0.1709089978837312],
            [0.07688165770057565, 0.12697112589260046],
            [0.10725051021468068, 0.12659405757544148],
            [0.13360011575549705, 0.1259809876917022],
            [0.14854771043210108, 0.12647055832200182],
            [0.16252224577422145, 0.1262361356130316],
            [0.16266328152197118, 0.038516911387238964],
            [0.19135042975826796, 0.0384422368635988],
            [0.1908449006264658, -0.005521937604847827],
            [0.19035662854828306, -0.07822834205254814],
            [0.19049536363977576, -0.09295117333564654],
            [0.19000173527121175, -0.13099427872647565],
            [0.1896319588869849, -0.18103621574785198],
            [0.10556297332303209, -0.18069448369949145],
            [0.0500061316482292, -0.1803649287580758],
            [0.000760298878489278, -0.17977086118232394],
            [-0.08566430483704494, -0.1791283033176315],
            [-0.17120072933392913, -0.1780092540988941],
            [-0.25678094145321145, -0.1772589562113347],
            [-0.25616717526675825, -0.08946190364767029],
            [-0.25577383304787077, -0.047933696809511296],
            [-0.2578036675441707, -0.040474638474446184],
            [-0.2555732227092421, -0.018750634767093523],
            [-0.2554058899931588, -0.0019736438523707493],
            [-0.2530601453603359, -0.0020006094442700747],
            [-0.25295800394680706, 0.022959201067015118],
            [-0.25208665645586753, 0.08597655620736123],
            [-0.2518077436902112, 0.11527700573593352],
            [-0.22312433090556782, 0.11509870093562648],
            [-0.22308149782620912, 0.14430214415537584],
            [-0.22271648099120706, 0.1734699826341158]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.64988415082105,
          "lat": 38.687419048582036
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20127"],
        "coty_name": ["Morris"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morris County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00485028"
      },
      "bbox": [
        -0.2578036675441707, -0.18103621574785198, 0.19135042975826796,
        0.1734699826341158
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0214580931507424, 0.27450588527744507],
            [-0.9358383971510014, 0.27257203260760693],
            [-0.8621815610079181, 0.2711833699550896],
            [-0.80159472339163, 0.2701057733524982],
            [-0.7633475676602689, 0.26923944335804006],
            [-0.67802074956103, 0.26809490678221204],
            [-0.5925936408601143, 0.26651122199978194],
            [-0.5931021746056423, 0.2373091229335334],
            [-0.6004043208405931, 0.2373896383073681],
            [-0.6006213416373345, 0.22266928081037687],
            [-0.5936237157261292, 0.2223740398168902],
            [-0.5948473741746261, 0.13457423754597225],
            [-0.5953004284329144, 0.09041158198616883],
            [-0.5965121776261713, 0.01711951454488847],
            [-0.5979014685555119, -0.08533195753994828],
            [-0.7120544127306755, -0.08377019522612697],
            [-0.7910538603490412, -0.0827161709051813],
            [-0.8545017348204653, -0.08143452659878089],
            [-0.9864356534825901, -0.07847646760012345],
            [-0.9874047577839443, -0.07792914507880025],
            [-1.0256851312005348, -0.07737989420448861],
            [-1.0251077935286943, -0.04830272232134703],
            [-1.0241894724318745, 0.010395193660103377],
            [-1.026736492151103, 0.010602367692630028],
            [-1.0249621149051504, 0.09842047419572235],
            [-1.023271133662892, 0.1863844608870193],
            [-1.0214580931507424, 0.27450588527744507]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.64996382697433, "lat": 38.78381535338157 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20169"],
        "coty_name": ["Saline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saline County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00485047"
      },
      "bbox": [
        -1.026736492151103, -0.08533195753994828, -0.5925936408601143,
        0.27450588527744507
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.854969942698095, -1.4553621773189436],
            [5.857522457319219, -1.4490720487455817],
            [5.866338971765681, -1.4347634865644654],
            [5.868706314691823, -1.4322589906499466],
            [5.871983529203966, -1.423044698513993],
            [5.875605775044434, -1.4226687167226706],
            [5.888899122007435, -1.4117949585191547],
            [5.8992605107823355, -1.397647782987283],
            [5.9041134182100885, -1.3870995161845037],
            [5.908533664634252, -1.372530750463831],
            [5.910723669234213, -1.3620083385072161],
            [5.915095759010052, -1.3524158636824222],
            [5.9225071317225675, -1.3422369408753547],
            [5.935813650135587, -1.3274569716204976],
            [5.947969019978464, -1.3122807839667712],
            [5.950798193603427, -1.3110094535156507],
            [5.956233185115891, -1.303310481995472],
            [5.968434702780536, -1.2974068583721996],
            [5.978069788452338, -1.288284233440276],
            [5.991677005101856, -1.2829428889718284],
            [5.998323541515711, -1.2814155853107292],
            [6.005407552277389, -1.2842970859222296],
            [6.015641534240955, -1.285088601459926],
            [6.030392520846735, -1.2837122607454021],
            [6.031169550850628, -1.2837698650544012],
            [6.084121751585516, -1.4083156184613186],
            [6.113344029287969, -1.477294850346481],
            [6.122925590034127, -1.499120595485828],
            [6.144174408037602, -1.5494764179565452],
            [6.136226066437973, -1.5510595399963747],
            [6.127015712222681, -1.5567129035950058],
            [6.120234873185348, -1.556358918861172],
            [6.115693012118436, -1.553525956469202],
            [6.106816155310416, -1.5559096438732187],
            [6.102536192966031, -1.5597071084695135],
            [6.0970462241623125, -1.560516173188807],
            [6.0957293483321795, -1.562999624136688],
            [6.086181940322642, -1.5626628680724621],
            [6.0802122778347405, -1.567552080728209],
            [6.075811836443057, -1.5691170441176125],
            [6.065276815682628, -1.5688251190284568],
            [6.056053768931619, -1.5735309106169448],
            [6.043825689761529, -1.578332406208509],
            [6.03919553380538, -1.5818948455230701],
            [6.034447522875812, -1.5833413787948345],
            [6.030076274541927, -1.5815220771417877],
            [6.0266628117504055, -1.586331392410996],
            [6.022874382609131, -1.588240408249806],
            [6.017693938924007, -1.5871674920812955],
            [6.008726224945689, -1.5946474422943013],
            [6.002351725328701, -1.5939743528410462],
            [6.000409963900452, -1.5899976114728878],
            [5.984810112328435, -1.587328087283196],
            [5.979162056544919, -1.5903228458087268],
            [5.97300269624471, -1.5891174186486496],
            [5.963666998321684, -1.5905588777466402],
            [5.961921009562049, -1.5814573800910563],
            [5.957121231626408, -1.5846241324803616],
            [5.953991407460757, -1.5822937739653862],
            [5.944558580540893, -1.586555337557275],
            [5.950124812075026, -1.5884995952999252],
            [5.950799669676093, -1.5951111144457553],
            [5.94704893139306, -1.5980061280843523],
            [5.946216040062745, -1.6029598033602366],
            [5.934911874922458, -1.5969535809394977],
            [5.936716878504048, -1.592389640177361],
            [5.931654873820026, -1.5866654456209863],
            [5.930914479880395, -1.5803298136772652],
            [5.926806858730205, -1.5748242165093467],
            [5.92011818968082, -1.576320849335558],
            [5.920618834963468, -1.5622705317436536],
            [5.919535844714394, -1.5555761134456072],
            [5.916565599856755, -1.550573230602307],
            [5.910839894660199, -1.5440438914655985],
            [5.903505584562542, -1.5391963369348156],
            [5.898046030460965, -1.5379525942167331],
            [5.892131116056546, -1.5396953503345954],
            [5.887381844433829, -1.5371152695524906],
            [5.868754628450411, -1.5233187583794578],
            [5.863956318959887, -1.520339084713577],
            [5.857732450693083, -1.512618451503811],
            [5.8527994742081795, -1.5033402850629347],
            [5.850893295359793, -1.4974915127580577],
            [5.84882923686423, -1.4870829755563957],
            [5.849074610598915, -1.4779272461116455],
            [5.8523826767862195, -1.46173658642868],
            [5.854969942698095, -1.4553621773189436]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.9994778821821, "lat": 37.05859926135399 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21007"],
        "coty_name": ["Ballard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ballard County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00516850"
      },
      "bbox": [
        5.84882923686423, -1.6029598033602366, 6.144174408037602,
        -1.2814155853107292
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.752193912047656, -8.299753900377661],
            [4.757923450688897, -8.290825448524352],
            [4.7573964272071345, -8.28629152988159],
            [4.762720645738548, -8.282949299075648],
            [4.768779396428848, -8.283935291673231],
            [4.77137806829251, -8.278881002271255],
            [4.782313262606668, -8.275836297916252],
            [4.788287309297284, -8.27561118995922],
            [4.790582091721703, -8.27254754199503],
            [4.801371972341401, -8.273510613850647],
            [4.809328508513494, -8.27254946284616],
            [4.813435577048729, -8.275372187407712],
            [4.821403955431117, -8.277447103576506],
            [4.8245589274707115, -8.27576570198641],
            [4.834590972860957, -8.272961159031892],
            [4.837230580194455, -8.271248902031292],
            [4.840364010392912, -8.275877103618999],
            [4.846680137772354, -8.27670581921237],
            [4.85137909856742, -8.275552004157431],
            [4.859915203818497, -8.26990097602873],
            [4.86216504851595, -8.27039180272684],
            [4.867822690532476, -8.269615837536264],
            [4.876261486363184, -8.271621769805277],
            [4.879714472990099, -8.270236966867122],
            [4.890026474823728, -8.27477627210163],
            [4.895215286538697, -8.278951807810007],
            [4.899724160930084, -8.28439250926527],
            [4.90457619789224, -8.28480102074473],
            [4.910654534272184, -8.287282664036876],
            [4.907963518502413, -8.292853749083413],
            [4.909679214103646, -8.294834278117381],
            [4.916065929508364, -8.293931555568594],
            [4.9171951061365, -8.299913369661283],
            [4.920888430195166, -8.308020077235343],
            [4.923989891833636, -8.311389636517386],
            [4.921300421846086, -8.313777084845611],
            [4.922117659348547, -8.318380505445173],
            [4.9280979890043, -8.32029713935236],
            [4.934430776000945, -8.33385909101303],
            [4.9383758274158085, -8.33520104870906],
            [4.941183277067078, -8.332630228713327],
            [4.949745280828037, -8.329591450070232],
            [4.95780302552928, -8.329750459031628],
            [4.957875435360225, -8.336452329894898],
            [4.953192132914621, -8.34335768914289],
            [4.953714434472656, -8.34751277149216],
            [4.960314495742941, -8.354748754755839],
            [4.968515683004013, -8.357501276398057],
            [4.9676914935012935, -8.361007837333092],
            [4.974576390337051, -8.369050535908857],
            [4.981059177419492, -8.36916328000532],
            [4.983164537688659, -8.367167664160638],
            [4.990592820611614, -8.366655371413936],
            [4.992197356830098, -8.37057001678234],
            [4.9953289296338665, -8.372374460056967],
            [4.997470704192274, -8.377530743038632],
            [5.002329430972072, -8.383013239011998],
            [5.006955238387304, -8.385733521319882],
            [5.004880130720739, -8.395051286240848],
            [5.009211203874601, -8.394446394722163],
            [5.015327989683531, -8.399800139917012],
            [5.015794056628033, -8.405664688277621],
            [5.018862709429743, -8.408191872428663],
            [5.0189115934964335, -8.415995124364027],
            [5.023189588025865, -8.419327660111385],
            [5.028748895513437, -8.421136731565094],
            [5.033165097685342, -8.419365140404956],
            [5.034976232577745, -8.42492865500345],
            [5.0377251082357235, -8.428827935962032],
            [5.043051916796189, -8.429105039136912],
            [5.04922729175039, -8.423658508676438],
            [5.051333321597449, -8.419749621577669],
            [5.051347300763911, -8.415126038242684],
            [5.054909379369182, -8.412023274522257],
            [5.055465746206047, -8.407640324252364],
            [5.058319265277704, -8.405860608907668],
            [5.05293795999679, -8.397548867507382],
            [5.056679404244664, -8.391863622880186],
            [5.059966509654317, -8.38899382814597],
            [5.067428605980903, -8.389765961247171],
            [5.065721268237454, -8.383626764716231],
            [5.067856916087313, -8.378023909037815],
            [5.0732636967042275, -8.375370832740321],
            [5.078480430685488, -8.37026764434033],
            [5.083053026996673, -8.37398332104169],
            [5.088715721426491, -8.37479442660378],
            [5.090696989984131, -8.38020857531318],
            [5.092665339999824, -8.380947019429987],
            [5.086962912996042, -8.43558595383482],
            [4.986964621601451, -8.46379725843724],
            [4.893482369273653, -8.49023308105674],
            [4.854082271033826, -8.500987329157336],
            [4.855103866061077, -8.505346389921348],
            [4.8388033887733295, -8.520764844250287],
            [4.836921977007851, -8.526105776931875],
            [4.838282535879006, -8.529318197146445],
            [4.814982124113975, -8.549112281231086],
            [4.813178903108015, -8.55067522218734],
            [4.796975560257749, -8.551728348538175],
            [4.7828436277504425, -8.543841419794136],
            [4.778080254673788, -8.53886903313111],
            [4.760715647141828, -8.544238040877461],
            [4.760419322438209, -8.542761207189008],
            [4.73938630833807, -8.548121163193983],
            [4.735303726011327, -8.549535087541367],
            [4.718471891961528, -8.539332406829235],
            [4.715609167119445, -8.54398839437201],
            [4.706127678625989, -8.544869416041648],
            [4.706976516413835, -8.558700877368848],
            [4.692399297142144, -8.55949761478997],
            [4.689555681009541, -8.514262567203621],
            [4.703976655219903, -8.513346881170172],
            [4.701361695692968, -8.468820409837738],
            [4.710916644075696, -8.461145419774956],
            [4.715239464975254, -8.46098123654259],
            [4.717310614775781, -8.439924073506754],
            [4.725256532735689, -8.409821447788707],
            [4.725041181498347, -8.408733293860774],
            [4.735260581174427, -8.369628209371964],
            [4.753801830499812, -8.302576810656902],
            [4.752193912047656, -8.299753900377661]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.91141369338705,
          "lat": 30.203541878156418
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22005"],
        "coty_name": ["Ascension"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Ascension Parish"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00558403"
      },
      "bbox": [
        4.689555681009541, -8.55949761478997, 5.092665339999824,
        -8.269615837536264
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.829532034695018, -7.969969943444874],
            [4.9415256951294495, -7.963611699825963],
            [5.066113591670388, -7.956589323265865],
            [5.123916591644339, -7.953188627294286],
            [5.130053762345791, -8.058035631587346],
            [5.133436040972951, -8.114630208234495],
            [5.137631698105704, -8.117383323560576],
            [5.141678677892565, -8.116329013171356],
            [5.141740536100148, -8.124106733527833],
            [5.146113805528784, -8.125154140586702],
            [5.145041269078388, -8.12806872185449],
            [5.149026906148822, -8.133019972908096],
            [5.146885935812585, -8.137852167383187],
            [5.147127478092332, -8.141737175822119],
            [5.150498521485833, -8.149495914343598],
            [5.153198042121578, -8.152355778537741],
            [5.1499966255495755, -8.157871809882684],
            [5.153788035727737, -8.16212196163869],
            [5.153813810687107, -8.168566980033988],
            [5.159981896074968, -8.173237835211257],
            [5.163316930370999, -8.174021465353453],
            [5.164458539611912, -8.1784585362012],
            [5.1730585814478305, -8.180972118457724],
            [5.179004901725377, -8.18668218192602],
            [5.183052188871732, -8.19209107819396],
            [5.184077427270695, -8.199874754535923],
            [5.186992210457775, -8.202917356551788],
            [5.183494269036981, -8.206326772204353],
            [5.1897479413128975, -8.210007589510187],
            [5.193210096371145, -8.20893620373374],
            [5.195970445568343, -8.213248681370349],
            [5.195417366460941, -8.219185206015245],
            [5.197650491055821, -8.222102402227907],
            [5.194020370336435, -8.228127646262003],
            [5.1969762586517225, -8.235284875285735],
            [5.203290739788879, -8.230886434727655],
            [5.20771988505838, -8.233050461715573],
            [5.206858646778274, -8.239166143056611],
            [5.2085262119526705, -8.24111919293669],
            [5.215075259553063, -8.237909197641397],
            [5.21753567849575, -8.239579101328426],
            [5.220842350943758, -8.247215559564783],
            [5.221823044838756, -8.252035208879114],
            [5.215742715887254, -8.258834279245555],
            [5.213910913949976, -8.262793660513879],
            [5.213045303446393, -8.274350459306872],
            [5.214165663481076, -8.287406983186298],
            [5.217620247549006, -8.30689126653093],
            [5.215249406111397, -8.318606729604564],
            [5.203053916757512, -8.344746029770008],
            [5.1979473423905835, -8.366112441739144],
            [5.192440305974258, -8.375153697506603],
            [5.174253923862077, -8.393931084819371],
            [5.161109514761092, -8.402458383375905],
            [5.14960977667939, -8.403384030272095],
            [5.140628730637626, -8.402089813545318],
            [5.128313426906985, -8.394178910289781],
            [5.127753248321421, -8.391745383460067],
            [5.122565207454395, -8.384838652749584],
            [5.1193296204339775, -8.38312520281451],
            [5.115540830696505, -8.383648891376438],
            [5.1115783117268165, -8.386793203550058],
            [5.108588711269657, -8.386351708112013],
            [5.104904856411729, -8.382314811058023],
            [5.092665339999824, -8.380947019429987],
            [5.090696989984131, -8.38020857531318],
            [5.088715721426491, -8.37479442660378],
            [5.083053026996673, -8.37398332104169],
            [5.078480430685488, -8.37026764434033],
            [5.0732636967042275, -8.375370832740321],
            [5.067856916087313, -8.378023909037815],
            [5.065721268237454, -8.383626764716231],
            [5.067428605980903, -8.389765961247171],
            [5.059966509654317, -8.38899382814597],
            [5.056679404244664, -8.391863622880186],
            [5.05293795999679, -8.397548867507382],
            [5.058319265277704, -8.405860608907668],
            [5.055465746206047, -8.407640324252364],
            [5.054909379369182, -8.412023274522257],
            [5.051347300763911, -8.415126038242684],
            [5.051333321597449, -8.419749621577669],
            [5.04922729175039, -8.423658508676438],
            [5.043051916796189, -8.429105039136912],
            [5.0377251082357235, -8.428827935962032],
            [5.034976232577745, -8.42492865500345],
            [5.033165097685342, -8.419365140404956],
            [5.028748895513437, -8.421136731565094],
            [5.023189588025865, -8.419327660111385],
            [5.0189115934964335, -8.415995124364027],
            [5.018862709429743, -8.408191872428663],
            [5.015794056628033, -8.405664688277621],
            [5.015327989683531, -8.399800139917012],
            [5.009211203874601, -8.394446394722163],
            [5.004880130720739, -8.395051286240848],
            [5.006955238387304, -8.385733521319882],
            [5.002329430972072, -8.383013239011998],
            [4.997470704192274, -8.377530743038632],
            [4.9953289296338665, -8.372374460056967],
            [4.992197356830098, -8.37057001678234],
            [4.990592820611614, -8.366655371413936],
            [4.983164537688659, -8.367167664160638],
            [4.981059177419492, -8.36916328000532],
            [4.974576390337051, -8.369050535908857],
            [4.9676914935012935, -8.361007837333092],
            [4.968515683004013, -8.357501276398057],
            [4.960314495742941, -8.354748754755839],
            [4.953714434472656, -8.34751277149216],
            [4.953192132914621, -8.34335768914289],
            [4.957875435360225, -8.336452329894898],
            [4.95780302552928, -8.329750459031628],
            [4.949745280828037, -8.329591450070232],
            [4.941183277067078, -8.332630228713327],
            [4.9383758274158085, -8.33520104870906],
            [4.934430776000945, -8.33385909101303],
            [4.9280979890043, -8.32029713935236],
            [4.922117659348547, -8.318380505445173],
            [4.921300421846086, -8.313777084845611],
            [4.923989891833636, -8.311389636517386],
            [4.920888430195166, -8.308020077235343],
            [4.9171951061365, -8.299913369661283],
            [4.916065929508364, -8.293931555568594],
            [4.909679214103646, -8.294834278117381],
            [4.907963518502413, -8.292853749083413],
            [4.910654534272184, -8.287282664036876],
            [4.90457619789224, -8.28480102074473],
            [4.899724160930084, -8.28439250926527],
            [4.895215286538697, -8.278951807810007],
            [4.890026474823728, -8.27477627210163],
            [4.879714472990099, -8.270236966867122],
            [4.876261486363184, -8.271621769805277],
            [4.867822690532476, -8.269615837536264],
            [4.86216504851595, -8.27039180272684],
            [4.858713899355965, -8.267987212879728],
            [4.854402320057525, -8.268321710073842],
            [4.8543058679058975, -8.263969345021968],
            [4.849573897108909, -8.255368480792123],
            [4.842697009345169, -8.258093366155085],
            [4.836482387759419, -8.251200501689253],
            [4.828855891570425, -8.255648848934394],
            [4.827163965670414, -8.253256096807199],
            [4.821886005649169, -8.251358393652314],
            [4.8257866201287465, -8.248042776516982],
            [4.825274536007106, -8.245039506820547],
            [4.818862839791734, -8.24395306274998],
            [4.813720057600216, -8.238556568354307],
            [4.814794389025093, -8.226742418320471],
            [4.810110596343135, -8.224296153794041],
            [4.806155034188439, -8.229273552818364],
            [4.799961641851183, -8.23108649642038],
            [4.793243134748227, -8.226332274284443],
            [4.790045958970255, -8.222297592568477],
            [4.7900315775022, -8.21753295410148],
            [4.792173922713313, -8.214620347758068],
            [4.797556813164629, -8.216653643137642],
            [4.801595413093321, -8.214031451707791],
            [4.801390423809086, -8.211881380368304],
            [4.793148013589358, -8.201001173372036],
            [4.790210254996921, -8.199124366722097],
            [4.784375192447099, -8.199377421192438],
            [4.781161745987952, -8.198191019512775],
            [4.779807404896221, -8.19506806068207],
            [4.78272075004826, -8.191865788120797],
            [4.781363391231614, -8.187137021712058],
            [4.78697378686895, -8.182554819243913],
            [4.779996118252207, -8.178766703159479],
            [4.7748207025289435, -8.172603420364485],
            [4.779347465601381, -8.169732737645472],
            [4.773065433388193, -8.165957144327674],
            [4.770200063327295, -8.159343779464297],
            [4.771923866098143, -8.155402848508341],
            [4.776068568798745, -8.152702028129257],
            [4.7789029361629325, -8.154340706629572],
            [4.782768983512218, -8.15340926193333],
            [4.7845012288756585, -8.149591652137573],
            [4.7835527447013275, -8.144690621209985],
            [4.7802995962383195, -8.141786592827865],
            [4.7869520099290925, -8.128252951908731],
            [4.786488081608964, -8.12315520215753],
            [4.78274598307058, -8.119725297829302],
            [4.788210249453068, -8.116255780018292],
            [4.785379806923317, -8.11341587433921],
            [4.784744089121216, -8.109063962917956],
            [4.779196206032317, -8.10606218691679],
            [4.776675360410899, -8.102962257707306],
            [4.778887573017144, -8.096192755830117],
            [4.777096778706286, -8.091688328433479],
            [4.77266015027231, -8.090984518640816],
            [4.775997316456989, -8.087087983939641],
            [4.776045533103453, -8.083751947180867],
            [4.781075537125951, -8.081732803735516],
            [4.781936845874838, -8.078028147155253],
            [4.779245857287304, -8.073696786190691],
            [4.782209928158956, -8.070422354413136],
            [4.780928750672322, -8.066802985302592],
            [4.781478590099946, -8.057197847011677],
            [4.777378457327806, -8.053161527510184],
            [4.771764762069189, -8.050577512666433],
            [4.768387165540629, -8.050525582211206],
            [4.769051835173295, -8.045228878428308],
            [4.771002378677217, -8.042045157686282],
            [4.76913868003114, -8.0365515285726],
            [4.7731408722926565, -8.037180914595384],
            [4.77533088353098, -8.03108045207401],
            [4.778709691709086, -8.029222831089777],
            [4.779567446859966, -8.024788989875127],
            [4.785282490255956, -8.023975316573612],
            [4.789632336822558, -8.017941517797379],
            [4.795681368118202, -8.015349296577758],
            [4.799034105725748, -8.016611954435511],
            [4.799941745469175, -8.010858001710446],
            [4.806718489058066, -8.011369370254634],
            [4.811503866889164, -7.999497178120904],
            [4.807364657128742, -8.00230313297844],
            [4.805419863807445, -8.000003302589205],
            [4.809831181485925, -7.991987310782322],
            [4.81818651884276, -7.981107905976752],
            [4.821468747062931, -7.983023655378158],
            [4.824700029409125, -7.979795613253082],
            [4.825649623840311, -7.972860078690789],
            [4.829532034695018, -7.969969943444874]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.72792420143792, "lat": 30.44011765667629 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22063"],
        "coty_name": ["Livingston"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Livingston Parish"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00558083"
      },
      "bbox": [
        4.768387165540629, -8.429105039136912, 5.221823044838756,
        -7.953188627294286
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.379112519786319, -8.586707498287788],
            [3.3813834291516387, -8.588880490011837],
            [3.388008063624622, -8.589870853275885],
            [3.3916498336143657, -8.584132283364372],
            [3.3957043565335217, -8.583419515946217],
            [3.3976489791417355, -8.581124698206182],
            [3.406454555890945, -8.58008281608006],
            [3.4166747341859454, -8.580331106158582],
            [3.419031021613576, -8.576205074652613],
            [3.4258053700387006, -8.575100638736512],
            [3.427845364928437, -8.567941875307366],
            [3.435240398959689, -8.565724561773946],
            [3.4363776281536325, -8.561913832213222],
            [3.4411295174145904, -8.563469448494892],
            [3.440265292156303, -8.566021043880871],
            [3.449470535735878, -8.56968916384357],
            [3.456996953844085, -8.568557041243825],
            [3.4655787432823257, -8.581330042226817],
            [3.470840168252464, -8.583730337976673],
            [3.4708853900627954, -8.58681774240951],
            [3.481455155037818, -8.592842968554919],
            [3.4827987857499814, -8.595927618282516],
            [3.4862845757835093, -8.595893904212987],
            [3.4884472733430427, -8.598880246595973],
            [3.4957421521950813, -8.600722268919414],
            [3.50238883257887, -8.606564764026764],
            [3.5121394929892036, -8.609231725678166],
            [3.514718784725111, -8.611851266730643],
            [3.5260370381137185, -8.613618927432103],
            [3.5298796417741904, -8.616298350000797],
            [3.540028774223897, -8.618005224035445],
            [3.549099509718364, -8.62062065598936],
            [3.552958750980939, -8.622979376041416],
            [3.5566332743481888, -8.622436484415843],
            [3.5603533808011822, -8.619596556664996],
            [3.5690989536400637, -8.617801942749923],
            [3.5757787523485565, -8.61100987226971],
            [3.5836245264983435, -8.611042371445222],
            [3.5954041472780127, -8.604353864858552],
            [3.5989160194170684, -8.600140716071905],
            [3.6039687092234156, -8.5972431694776],
            [3.6043710555688735, -8.594698660848707],
            [3.610243117530195, -8.58925712029919],
            [3.6210284083549054, -8.583173489231791],
            [3.620544644678169, -8.576873597636583],
            [3.627397788231393, -8.56931023453331],
            [3.632642632756033, -8.567709054359192],
            [3.6339171668007038, -8.56076092352394],
            [3.636040558709768, -8.5562048598723],
            [3.6391879821815207, -8.55453862958503],
            [3.638977246149581, -8.547983725850443],
            [3.6454530284076805, -8.544019501270549],
            [3.6496807821540385, -8.543135807650904],
            [3.655332387587957, -8.540215142815226],
            [3.6623243931050857, -8.532541945922038],
            [3.662852241947963, -8.52797765234775],
            [3.665330894075858, -8.523203178191846],
            [3.6712505209802666, -8.521317336709837],
            [3.675782702682666, -8.526999181889034],
            [3.681505345851323, -8.527639571215465],
            [3.6836754536585046, -8.524850712632151],
            [3.6903039925051986, -8.523605963931328],
            [3.6938017194655735, -8.528514378543656],
            [3.6973601216613234, -8.528581855741878],
            [3.7096530679759425, -8.524715125740554],
            [3.714712284123828, -8.527513000103207],
            [3.7190670752151758, -8.527545351556306],
            [3.7213924904247624, -8.529815772188192],
            [3.726230316227768, -8.526897169942378],
            [3.7320075702859654, -8.526259388246297],
            [3.7363857394846067, -8.522950895403879],
            [3.7419769725494456, -8.523213718591816],
            [3.8076203724688136, -8.547188510938607],
            [3.8144615584092296, -8.541026688028811],
            [3.820529251264218, -8.542687162349663],
            [3.829112187400736, -8.538156119951505],
            [3.8371827656442448, -8.535607266276482],
            [3.8402568356826365, -8.533611987104083],
            [3.8430050726305343, -8.536539746789387],
            [3.8396946982346316, -8.543743836580326],
            [3.8435112540630203, -8.552696016136139],
            [3.8482750943955155, -8.554341127970106],
            [3.8522911467588656, -8.559878392186924],
            [3.8520789179737016, -8.562975923624718],
            [3.8545390329301017, -8.565784891916039],
            [3.8558709841625176, -8.574063230121373],
            [3.8584769935631087, -8.580225123165695],
            [3.862845936357016, -8.586542492752717],
            [3.87047171176969, -8.588754578269379],
            [3.9000519370838127, -8.600339957687869],
            [3.922182012778097, -8.60807176289556],
            [3.9492383235120982, -8.618379889254566],
            [3.933725287169275, -8.667677912187493],
            [3.9292365977155304, -8.672703752753641],
            [3.9294168507823017, -8.681759916621678],
            [3.9316003589208566, -8.687603470620157],
            [3.934952720520284, -8.701577433552574],
            [3.9357690894643826, -8.71721693953826],
            [3.954201635832867, -8.820719093754665],
            [3.948075715914488, -8.825712866682336],
            [3.945376903605719, -8.829252192237398],
            [3.9431332131860874, -8.834998215162097],
            [3.943345986842987, -8.838207826524263],
            [3.946609166008758, -8.842470621052009],
            [3.950851561042339, -8.850841808485209],
            [3.9503752779942167, -8.854229424812377],
            [3.946512993692733, -8.858127660270132],
            [3.940820704612624, -8.860101064301835],
            [3.9308752333224866, -8.861535619932063],
            [3.9271692840515584, -8.864138863692508],
            [3.9145424413529972, -8.870031789861319],
            [3.90137179997021, -8.87435389332123],
            [3.8837926403957557, -8.884327414387846],
            [3.8607186578322263, -8.898308923239615],
            [3.8336006709373973, -8.918802349067288],
            [3.8155659419493286, -8.936250367364686],
            [3.8097572370592987, -8.94262606116351],
            [3.8052544745596473, -8.942418741848156],
            [3.8029055440908177, -8.937954827311385],
            [3.8047475197643594, -8.933324043951353],
            [3.8136388161232313, -8.929254156695045],
            [3.816681525210611, -8.92652835825365],
            [3.816896887437829, -8.922435221425397],
            [3.820618387054569, -8.92187799682568],
            [3.8245284538070585, -8.91406474022397],
            [3.826333980168978, -8.905315865393515],
            [3.823250034016366, -8.899208359316097],
            [3.818615244026692, -8.893382617963958],
            [3.809462246818908, -8.891848781144393],
            [3.8032360465649786, -8.896759229660082],
            [3.805973134918992, -8.902051356047803],
            [3.80233847640076, -8.905594233408314],
            [3.7970945148841637, -8.907000038518133],
            [3.796203931342656, -8.901303569089315],
            [3.7908043944056713, -8.89734714184499],
            [3.784603368203544, -8.898014769855033],
            [3.7815613813177937, -8.901159225777345],
            [3.781148773507797, -8.908400497491577],
            [3.7832282097375733, -8.912181871510267],
            [3.7892961021495073, -8.914075005307339],
            [3.7898085439128475, -8.918816807361344],
            [3.7856787227284587, -8.92047707678702],
            [3.7810448522927027, -8.919277541296244],
            [3.7747212996645105, -8.915137538233934],
            [3.769354831815981, -8.913485636754498],
            [3.763144547905604, -8.909370851202913],
            [3.757207582509492, -8.908132460583666],
            [3.752657498461319, -8.915704692557249],
            [3.7554275745874035, -8.921561432014457],
            [3.7566460681826634, -8.926864893571796],
            [3.7589229017149735, -8.92899669477594],
            [3.761120616611661, -8.935371051920336],
            [3.7667073518382925, -8.938097728438557],
            [3.773979364233519, -8.94359098563569],
            [3.7746370847443176, -8.946071277657833],
            [3.780894227172927, -8.952663301669974],
            [3.7830959538479942, -8.953494609702208],
            [3.7890204771933895, -8.95948584856301],
            [3.7930156856013646, -8.958714381736897],
            [3.8013061871883647, -8.961148655727898],
            [3.8052920052789276, -8.96343110756788],
            [3.809510481858807, -8.96305741022946],
            [3.8130145932629382, -8.960105065239969],
            [3.8167833097334785, -8.959090327637695],
            [3.8323940006796473, -8.959497332474868],
            [3.8400615577491934, -8.957641643260938],
            [3.845648880551841, -8.958264071736325],
            [3.846492395565458, -8.964179027496481],
            [3.8291682323010883, -8.978911038034417],
            [3.8221234632784102, -8.985933289901988],
            [3.8193806169374596, -8.987065103043266],
            [3.8190028075578177, -8.995453224714023],
            [3.825970249637544, -9.004057864384306],
            [3.8281452596424836, -9.004174974958],
            [3.8283596168587186, -9.014378729310586],
            [3.832882887953245, -9.023796302287954],
            [3.837138153385048, -9.028144081421997],
            [3.8418573977021326, -9.038345581815973],
            [3.8475931582495697, -9.044548692278683],
            [3.8522461145634344, -9.04456482929689],
            [3.8524997906341665, -9.036333823432173],
            [3.8566358951893096, -9.038258046119447],
            [3.865908611869227, -9.032862470695559],
            [3.878842045672426, -9.03538111082236],
            [3.8878676695342556, -9.032485629376458],
            [3.8976743373639384, -9.030862141951957],
            [3.903977319755179, -9.02345225611476],
            [3.9115995715920047, -9.022832537048059],
            [3.915491146056433, -9.029310383142764],
            [3.9273260080887282, -9.037810173152312],
            [3.918162379825934, -9.03624862706275],
            [3.908931136001864, -9.035505540063602],
            [3.902076671856639, -9.037218491178468],
            [3.8941821956750844, -9.04121983407171],
            [3.8884580716727135, -9.045234243806417],
            [3.884720134601757, -9.049779846106741],
            [3.878525980189274, -9.05493565624491],
            [3.87893349456673, -9.059720582837901],
            [3.8824094459270118, -9.062685589082315],
            [3.8874609170253223, -9.0613054400136],
            [3.893197145890262, -9.064541185057662],
            [3.897438320460303, -9.062082527299527],
            [3.9023050061190467, -9.062556707836823],
            [3.904142178377995, -9.06584224520208],
            [3.9009251845559536, -9.068775117458316],
            [3.8908139636533847, -9.069783293049607],
            [3.883171009898201, -9.068292143277638],
            [3.8733177570445894, -9.070640941306996],
            [3.8511884588545056, -9.067621922343788],
            [3.8141950764360883, -9.070942238251439],
            [3.7930175474290966, -9.078321916914359],
            [3.7672948387334215, -9.09051995258124],
            [3.756772323707582, -9.096936222012758],
            [3.7203707083897317, -9.12039577405124],
            [3.71231575706143, -9.123366154989608],
            [3.6958088620026865, -9.127172458615787],
            [3.6785592031393968, -9.127938681136223],
            [3.6616171504470856, -9.131244919921613],
            [3.6425588743372073, -9.128088611370663],
            [3.6113810186908055, -9.121808582627649],
            [3.596728345590828, -9.120110414062962],
            [3.5796548803795774, -9.117274537667708],
            [3.568105123020595, -9.112800500525795],
            [3.542357138498373, -9.107520344424323],
            [3.535030887806154, -9.105236086698916],
            [3.5081879077251124, -9.102582620510278],
            [3.5032473046771955, -9.101596180103902],
            [3.479364961422323, -9.09898694284567],
            [3.474512318237608, -9.096404574230865],
            [3.4665172712646877, -9.096449852382394],
            [3.456564070734753, -9.094801436702596],
            [3.4574503758227793, -9.090786073970591],
            [3.449266833984829, -9.0818865929684],
            [3.441966189647436, -9.085823352293012],
            [3.4406655918007534, -9.089853377836244],
            [3.4473242681782796, -9.09380333921961],
            [3.4301629290433415, -9.091043829479549],
            [3.4196774699447174, -9.08988228689112],
            [3.405275006344376, -9.086943079116864],
            [3.399545966820121, -8.901939842481088],
            [3.394685042908434, -8.757638128603148],
            [3.392878468580859, -8.716513274402452],
            [3.3923991441714842, -8.71205700319975],
            [3.3909710271835567, -8.678436775492353],
            [3.3911954695176707, -8.675176885633585],
            [3.3903048761858403, -8.654355329639191],
            [3.3892012132429334, -8.639911702013977],
            [3.2845064536139117, -8.644329729266282],
            [3.287802764322891, -8.642410312372602],
            [3.292997803598426, -8.634998694724947],
            [3.2956552755351325, -8.63286093851671],
            [3.3020783283727613, -8.633125039262435],
            [3.312388245119421, -8.627245423402139],
            [3.318144361296049, -8.62678038088384],
            [3.3193931918701565, -8.61944355435209],
            [3.3232867892926947, -8.62168874690269],
            [3.328598120214159, -8.621303641194771],
            [3.338075937229081, -8.609627727495855],
            [3.3405248628495956, -8.609006040784239],
            [3.346276889518854, -8.610898607321408],
            [3.3501390692490154, -8.610253323102238],
            [3.3540226215592526, -8.601319954265115],
            [3.3565430201198483, -8.601136088305301],
            [3.358988894069102, -8.606476269678234],
            [3.3650806702302045, -8.605112579420702],
            [3.3687126943890493, -8.607398632834409],
            [3.375240995445223, -8.598868794372134],
            [3.3749512379133715, -8.593924835055185],
            [3.3766224529359237, -8.587290251604085],
            [3.379112519786319, -8.586707498287788]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.32417471153427,
          "lat": 29.846522255950855
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22113"],
        "coty_name": ["Vermilion"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Vermilion Parish"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00559538"
      },
      "bbox": [
        3.2845064536139117, -9.131244919921613, 3.954201635832867,
        -8.521317336709837
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.278953094280672, 1.557779462892179],
            [15.279902773746464, 1.5612100025675146],
            [15.278266544742653, 1.5654826231194536],
            [15.287441094876737, 1.5666691941616304],
            [15.295399682130826, 1.5772546507105072],
            [15.300758324032513, 1.5794237206589083],
            [15.301623608297511, 1.5819345553643034],
            [15.307449434902423, 1.585092121148509],
            [15.31446981279742, 1.5838497542994772],
            [15.322976268082645, 1.5862410885246068],
            [15.331386982650635, 1.5461166788389569],
            [15.337907782773097, 1.5414266542644186],
            [15.3471999781754, 1.5437617771159602],
            [15.398537854003317, 1.5546854447807064],
            [15.405834112432425, 1.547194937898673],
            [15.404843752336618, 1.5405806891310976],
            [15.405322478526745, 1.5336090017458723],
            [15.409803489305265, 1.5125745120528362],
            [15.422349585172816, 1.4817701780959338],
            [15.432626402823642, 1.466796412834446],
            [15.434097673448395, 1.4613223717784556],
            [15.438664750667204, 1.4540133075764454],
            [15.440074642436615, 1.4279985728899542],
            [15.442933919771614, 1.4109466242004094],
            [15.444628485189181, 1.4069168922698412],
            [15.448094841862327, 1.3941295727640002],
            [15.449689964957722, 1.377331055756647],
            [15.453143772908579, 1.3675722422819294],
            [15.45935417992795, 1.3555169768666306],
            [15.465501861949276, 1.3450057359256093],
            [15.480089560711816, 1.3256021991238498],
            [15.488500890622198, 1.318340795956806],
            [15.498008214184582, 1.312410668388078],
            [15.51461212626931, 1.3001916000025953],
            [15.516446843373112, 1.295996461169656],
            [15.520120532354378, 1.2922539724470739],
            [15.533112195576573, 1.2856904937392986],
            [15.55284587942137, 1.2704776444462165],
            [15.555356099112789, 1.2654823742098356],
            [15.561202851015087, 1.260141857230994],
            [15.566811985800122, 1.2524807819467048],
            [15.573675860321929, 1.248760403558097],
            [15.584159659205397, 1.2478373831447518],
            [15.581748602229414, 1.2428273348464631],
            [15.579628216709917, 1.2352068335652795],
            [15.585053245478512, 1.2244351233132018],
            [15.58545369824383, 1.2222043544797023],
            [15.575991177903507, 1.1994124984027323],
            [15.568887598804167, 1.1791838664143832],
            [15.568071088700732, 1.1749031461054344],
            [15.563090056867217, 1.1778263148148336],
            [15.554074795790113, 1.1785409715677084],
            [15.5443755297959, 1.1744018334595465],
            [15.54241581399119, 1.167068779353476],
            [15.535875731721639, 1.1744558464456338],
            [15.53036964668241, 1.1773457121618036],
            [15.528316944221627, 1.1728821353943553],
            [15.523297373238897, 1.1739468174542649],
            [15.516213921489872, 1.171643642222015],
            [15.514480535525122, 1.1730854046137178],
            [15.516422227617017, 1.1829822918237929],
            [15.516261200354908, 1.1883483893933218],
            [15.511522902999118, 1.198778689980695],
            [15.506288089091598, 1.2056593166526517],
            [15.496129736204638, 1.2151475889395669],
            [15.490269013136205, 1.2190906845187777],
            [15.482699941047878, 1.2218117701449287],
            [15.474850829910276, 1.2291257358662229],
            [15.466159875973531, 1.2349744141307746],
            [15.452006680608294, 1.2292289928466826],
            [15.446582987517683, 1.230452730078929],
            [15.44180484700206, 1.238412411114025],
            [15.42953057719714, 1.2413131991732298],
            [15.418069651944197, 1.2467451027745389],
            [15.412686180807535, 1.2503432139101325],
            [15.404238083790267, 1.249646714193692],
            [15.398866947589012, 1.2541213707297623],
            [15.396039765571988, 1.2584325689924352],
            [15.391270076213958, 1.2618886401497398],
            [15.387917848530414, 1.2660914550252018],
            [15.37887835157156, 1.2722510934643192],
            [15.368108125533203, 1.2784139595894475],
            [15.362891939779397, 1.280253513331658],
            [15.360995899812508, 1.2826990419640423],
            [15.361817525562138, 1.2873474734374488],
            [15.360917495137562, 1.2915261862961938],
            [15.351913699173336, 1.303702746071429],
            [15.3462239637054, 1.309766302697942],
            [15.338955677105156, 1.313661704076329],
            [15.339576483213104, 1.3241404618609687],
            [15.340828901684066, 1.3335404328780684],
            [15.342711171992878, 1.3398193916941916],
            [15.341891129764061, 1.3420910869011928],
            [15.33542204993864, 1.3470332872893938],
            [15.330547140694941, 1.3492967924957515],
            [15.330451481217084, 1.3605552437251272],
            [15.32951308071897, 1.366507985719882],
            [15.321459148634897, 1.37922945657264],
            [15.321329323901228, 1.3850158262016325],
            [15.317471710359527, 1.3925952421242125],
            [15.317437712144475, 1.3974448182289092],
            [15.319302624160901, 1.4049357376468612],
            [15.3198193893181, 1.4124271434364948],
            [15.317493645956542, 1.420170536638095],
            [15.316264303052114, 1.430516639095103],
            [15.309620286315289, 1.4392354340032405],
            [15.302821534524648, 1.4410894797285767],
            [15.296862900923639, 1.4460027905365775],
            [15.29533077375347, 1.4581258232873824],
            [15.29898030332566, 1.4653343281762938],
            [15.299036415589939, 1.4719491018329713],
            [15.295442889239927, 1.4739039219783494],
            [15.290232898843312, 1.4728804691589508],
            [15.286034359738403, 1.474003098308756],
            [15.284946896638992, 1.4792825774198377],
            [15.291086866090414, 1.48319948121459],
            [15.292029904820481, 1.4913169702400082],
            [15.284814308191493, 1.494375986649097],
            [15.281639565201226, 1.4985269629682532],
            [15.281132184538535, 1.502894163643382],
            [15.282239416836141, 1.5088160140990508],
            [15.27878085590385, 1.5150324968998332],
            [15.274808134388023, 1.518165932120075],
            [15.278313370246561, 1.5332091010379765],
            [15.275444019705855, 1.5396085756816522],
            [15.275851432861476, 1.5441928618413818],
            [15.281023616329218, 1.5452435567136298],
            [15.282787174192023, 1.5481327427797795],
            [15.280397254942095, 1.5564816340502892],
            [15.278953094280672, 1.557779462892179]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.56867552126485, "lat": 38.54334979102436 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24009"],
        "coty_name": ["Calvert"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calvert County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01676636"
      },
      "bbox": [
        15.274808134388023, 1.167068779353476, 15.58545369824383,
        1.5862410885246068
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.418764253058281, 2.58949075683619],
            [15.491533206790272, 2.605128652985319],
            [15.571950979589639, 2.622500989098248],
            [15.593594699610316, 2.6268509760656067],
            [15.685560385596903, 2.6467598855525623],
            [15.741863449565562, 2.6589662760871158],
            [15.749965176337065, 2.661040188822219],
            [15.75483725897846, 2.639225080000482],
            [15.763550088418505, 2.597965819231217],
            [15.768872633440855, 2.5777025760989734],
            [15.792424784943462, 2.4928310532423543],
            [15.821105077198698, 2.3910751712638167],
            [15.839785628876923, 2.3248305952066595],
            [15.834875057010763, 2.3258216942749583],
            [15.832219485962055, 2.3247674811207664],
            [15.828028939427767, 2.327026867205069],
            [15.825919731991766, 2.3247534371544027],
            [15.818698987680994, 2.322556929958809],
            [15.81811936279198, 2.3198480405558053],
            [15.813412911853185, 2.3195369412686375],
            [15.810399819722468, 2.3177285972072252],
            [15.807311612038102, 2.3201070198479323],
            [15.796324719259404, 2.3194570680157534],
            [15.792239205478142, 2.3111069447009776],
            [15.784525110218649, 2.306150118240226],
            [15.776121776152193, 2.2977227300128154],
            [15.771275877931417, 2.2998258160919023],
            [15.766309399043271, 2.2989679088828336],
            [15.756179764088962, 2.293195461104958],
            [15.754694767673218, 2.2892821073957883],
            [15.745482841114347, 2.2924924235552595],
            [15.736746575528374, 2.289205106317759],
            [15.73108409667011, 2.2901400477829017],
            [15.725127663994082, 2.2895485156195576],
            [15.721478993229672, 2.292631256879935],
            [15.717302834136783, 2.2922638851164368],
            [15.712228727917669, 2.2873408717333237],
            [15.707929714401143, 2.2872428306981702],
            [15.704123225418039, 2.2904781962731917],
            [15.697967465773463, 2.2913213362719724],
            [15.692629091578043, 2.2903055450359897],
            [15.688129014886597, 2.287411470057346],
            [15.686165563280769, 2.2826274841194327],
            [15.683140230482692, 2.2798726263737707],
            [15.680204656045301, 2.2801893158065307],
            [15.672661900483988, 2.2859291275949682],
            [15.67512239733423, 2.2914640955310106],
            [15.667255054191457, 2.2951849745894197],
            [15.65668192687657, 2.2941602211673593],
            [15.640381645914344, 2.2902249583136114],
            [15.63471480494653, 2.2903275090535327],
            [15.63143361599659, 2.2936581421888813],
            [15.630938641032346, 2.297266584949883],
            [15.63235914992971, 2.302946539049216],
            [15.634978534751587, 2.3073122652480227],
            [15.646232232537736, 2.3151998404028427],
            [15.652178349369905, 2.322720317243651],
            [15.653780843900718, 2.327697292555407],
            [15.653555436076413, 2.3322811662397758],
            [15.65594724401471, 2.3398071263179627],
            [15.660103096767822, 2.343851411129356],
            [15.665980105645199, 2.3470785498382427],
            [15.668376324526271, 2.3572239161181208],
            [15.66781403213862, 2.3603847116817653],
            [15.66954675914497, 2.370100640863811],
            [15.67210987119243, 2.3767998723207393],
            [15.661772659522626, 2.3825386819122363],
            [15.656487172056861, 2.3807475241285236],
            [15.657418357994583, 2.372051828723354],
            [15.655500649007438, 2.3689329047947494],
            [15.650525207201088, 2.366038009540927],
            [15.652052418212028, 2.363241023509461],
            [15.64792489400591, 2.358609073072686],
            [15.642945410133084, 2.3565122809385275],
            [15.639981073684863, 2.359916663539421],
            [15.64108775307256, 2.364712221185848],
            [15.64694349361651, 2.3746299906887147],
            [15.649048358289754, 2.381221939731506],
            [15.648816682286599, 2.38560004471852],
            [15.645743453160424, 2.393405102011439],
            [15.645349167313464, 2.398773560151389],
            [15.648118705988576, 2.4023752618063843],
            [15.648817636560445, 2.4070675068683545],
            [15.647353833774247, 2.420567431388178],
            [15.64971778177406, 2.427099341651348],
            [15.649705849006747, 2.431606747815328],
            [15.647740509791353, 2.4399324424400017],
            [15.652426887066188, 2.444627854314215],
            [15.657734034876485, 2.4452289561342506],
            [15.659831865217692, 2.4497419404898477],
            [15.653510181765, 2.4540844873156993],
            [15.654567444253665, 2.4589390145536614],
            [15.64961718694232, 2.469441843648938],
            [15.64957210504636, 2.473500651422441],
            [15.653892136177355, 2.473722840376319],
            [15.65734646468263, 2.478991999079555],
            [15.657574962400767, 2.4895993887586285],
            [15.661320114493254, 2.4959314831850348],
            [15.659207653428691, 2.4989416130032986],
            [15.658686585463402, 2.504424934224425],
            [15.66082490753823, 2.508599276522746],
            [15.653711061025009, 2.507768295126634],
            [15.651370824664065, 2.5061344128620044],
            [15.647323938367737, 2.499036138821278],
            [15.648611747362676, 2.491452127251857],
            [15.644585970022904, 2.481920765625001],
            [15.6267984224431, 2.467835687892517],
            [15.6247998351943, 2.4526854344604936],
            [15.628676997857042, 2.4489308464957924],
            [15.626134896893113, 2.4454040926582548],
            [15.621988371938084, 2.444994027691667],
            [15.61627497570475, 2.451232438245117],
            [15.607787036067196, 2.4514217404191054],
            [15.600628305272146, 2.454402850354259],
            [15.59420536729936, 2.4527515644341724],
            [15.594340216784655, 2.446428479770591],
            [15.581803188710145, 2.4439391342844474],
            [15.573201146537244, 2.4390574725899437],
            [15.562641146697665, 2.4526520644553176],
            [15.560113337042136, 2.4545132457982612],
            [15.51417814661405, 2.498140567553618],
            [15.50404975093144, 2.5024883023817206],
            [15.487061128614272, 2.530036247156996],
            [15.480739121865586, 2.535410884715113],
            [15.466937677168996, 2.5432871902235834],
            [15.464391956557236, 2.545738123344174],
            [15.441392008129261, 2.5582974752662304],
            [15.429297911002449, 2.572749229549471],
            [15.424267932797807, 2.578101498136708],
            [15.418764253058281, 2.58949075683619]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.94073048936522,
          "lat": 39.571231355751195
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24015"],
        "coty_name": ["Cecil"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cecil County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00596115"
      },
      "bbox": [
        15.418764253058281, 2.2798726263737707, 15.839785628876923,
        2.661040188822219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.325999720543344, 6.394041023253082],
            [18.33127813863842, 6.401573112983805],
            [18.339080877985978, 6.406663038509476],
            [18.345470384062462, 6.409598065053434],
            [18.37752609717923, 6.408687884596803],
            [18.360704392699773, 6.459163926872058],
            [18.366119415599478, 6.471879105654507],
            [18.370475259503074, 6.480381930639291],
            [18.379909391197955, 6.489924734488809],
            [18.390490667208944, 6.498843304511339],
            [18.442535070072555, 6.497085470767985],
            [18.443006662072513, 6.524944790008711],
            [18.445385184058306, 6.541825800364477],
            [18.451986132008376, 6.554246882799193],
            [18.494924625007865, 6.575978636533273],
            [18.505235914127134, 6.586089522285363],
            [18.51594996489579, 6.597759403449471],
            [18.526607688445914, 6.602689336345978],
            [18.535154342348644, 6.604923152423347],
            [18.547880094015664, 6.604284989795935],
            [18.57995923630865, 6.590481481784752],
            [18.586803838713962, 6.596524316776394],
            [18.590399930572033, 6.601553095677222],
            [18.599005136503877, 6.607362704381934],
            [18.60440875052871, 6.586377212113275],
            [18.615266277533046, 6.560580424959181],
            [18.62027316256689, 6.5537202618885155],
            [18.631344676530205, 6.5223838011071305],
            [18.649187121199457, 6.4912796179533885],
            [18.673213362169722, 6.46041938198142],
            [18.67613880040149, 6.454745147287355],
            [18.67347283040615, 6.449720483138577],
            [18.67574886564209, 6.440591555944664],
            [18.68545238025468, 6.437396628903954],
            [18.694035039594528, 6.438347733754306],
            [18.70057191244956, 6.43698515765874],
            [18.71200646775109, 6.428606846463145],
            [18.71437878976599, 6.425441706125538],
            [18.723157039844946, 6.424902763374714],
            [18.73400687167741, 6.42213620827167],
            [18.741621606437086, 6.421691422297552],
            [18.74495296415712, 6.4225580327461085],
            [18.747531148508862, 6.4199611983098555],
            [18.750661033579007, 6.41998371439476],
            [18.751726285823082, 6.429105751854468],
            [18.750183608407784, 6.430684533354811],
            [18.754862455437532, 6.436391219241815],
            [18.757924346692697, 6.442587188610068],
            [18.758691971553365, 6.448890370770674],
            [18.76196138595616, 6.453836039145283],
            [18.764064396040183, 6.454584082077447],
            [18.767558576569275, 6.461924015536633],
            [18.772341310357746, 6.46031679283387],
            [18.774536900021424, 6.466343852226443],
            [18.778278124002476, 6.4698538283246885],
            [18.781411376588945, 6.466268364860224],
            [18.78633476431314, 6.465970971767045],
            [18.78572744400098, 6.460340709188265],
            [18.786709913346645, 6.4557809312299215],
            [18.789638462875736, 6.452253761986536],
            [18.789385210040802, 6.446474855251938],
            [18.790857741514507, 6.4410757799842635],
            [18.79388974738545, 6.438891905051857],
            [18.796709662648865, 6.441287981554193],
            [18.80348509807215, 6.441317513068963],
            [18.80919000800442, 6.4442377386441105],
            [18.81269174859387, 6.441246270606042],
            [18.812469010721472, 6.436414069402006],
            [18.817035364752257, 6.434588256154514],
            [18.815721346548536, 6.428016903244629],
            [18.81953680236154, 6.426263488339759],
            [18.819015542862168, 6.421154821352768],
            [18.810872409159042, 6.418802391655555],
            [18.803500827442935, 6.41031027094443],
            [18.80353333271071, 6.404505480992102],
            [18.799265466698998, 6.401589275102759],
            [18.79691309249775, 6.396240436699993],
            [18.799198988259132, 6.387615417127794],
            [18.79889406766983, 6.379619378224024],
            [18.796133510769625, 6.3729414659156625],
            [18.7936508754126, 6.36986196478958],
            [18.793507536615916, 6.36499604916585],
            [18.790197322976013, 6.35858699643873],
            [18.783502378126446, 6.354905696377606],
            [18.781724197645772, 6.358202962190245],
            [18.784119652248002, 6.367197410344093],
            [18.784341449817983, 6.37360622122728],
            [18.78160758318197, 6.378305522397405],
            [18.775427720587967, 6.382431340202362],
            [18.767962640083095, 6.3787734274272685],
            [18.769242811844084, 6.3747690487018875],
            [18.76641608800753, 6.371281327183126],
            [18.765608252258165, 6.366346766626489],
            [18.768815984784265, 6.364427107995007],
            [18.765673732666734, 6.3557816818404005],
            [18.762704560685773, 6.3531813098795675],
            [18.760527505658875, 6.345520384776122],
            [18.754219019190337, 6.341926469559404],
            [18.753491091742486, 6.338612164463272],
            [18.7401159348381, 6.333893796875049],
            [18.73844899834351, 6.336528491059525],
            [18.731864127474, 6.33507832079384],
            [18.720908672202274, 6.327604423591862],
            [18.718678568999334, 6.317904071101652],
            [18.709577477556593, 6.313039065193021],
            [18.69625329846618, 6.314771470246078],
            [18.690187657615038, 6.310123556137191],
            [18.684155846489496, 6.300826789934251],
            [18.678830149293635, 6.296976783764274],
            [18.669946272651632, 6.2939737039445225],
            [18.664473844531724, 6.289304106759783],
            [18.66041585142315, 6.2912661887958645],
            [18.65423682790327, 6.2833677369427985],
            [18.648021493066267, 6.285209906637623],
            [18.644493188520773, 6.279932873026843],
            [18.64177220569238, 6.269400540717958],
            [18.645066777387317, 6.267444167857042],
            [18.651987028811234, 6.273600904336543],
            [18.65512931754059, 6.271483774673967],
            [18.655398234859547, 6.264612464238364],
            [18.648293134905156, 6.259356058759364],
            [18.645080402787578, 6.24995939395813],
            [18.645990454453628, 6.243303917961897],
            [18.649966699696893, 6.241285999235804],
            [18.655192548242308, 6.241965457942385],
            [18.65916035843385, 6.2571971676913645],
            [18.66327560697237, 6.261305575935439],
            [18.672463485025364, 6.25961682148028],
            [18.674428396333212, 6.262239879663912],
            [18.6770330331025, 6.251841928519399],
            [18.67273903010256, 6.241785676938461],
            [18.67345339027115, 6.23453066134484],
            [18.67742471905901, 6.2365083978188585],
            [18.68387091544563, 6.250660110716337],
            [18.68639167724125, 6.248984564527791],
            [18.685595530618578, 6.244398792300043],
            [18.686377291221945, 6.235401612192302],
            [18.683180777444015, 6.23153407563853],
            [18.67805235801848, 6.23419494376781],
            [18.671013477361562, 6.231055246699513],
            [18.65854814008006, 6.21578002504795],
            [18.65599758007805, 6.206180855026332],
            [18.656825660220225, 6.200908905046273],
            [18.652924079167132, 6.195713492737985],
            [18.646982287929273, 6.197567676060376],
            [18.643222953978714, 6.19513620739303],
            [18.641583556250502, 6.198884101069909],
            [18.631800336498017, 6.1960484872851165],
            [18.629276164912387, 6.189355061357229],
            [18.624910515020268, 6.18507777568516],
            [18.627822240261366, 6.167401846856348],
            [18.632454590326606, 6.161749418650413],
            [18.637041717864335, 6.158211882092528],
            [18.639165522138647, 6.1603007819124755],
            [18.648268293033638, 6.160048851031064],
            [18.65232305365219, 6.15854691623586],
            [18.653733797764648, 6.155439860218154],
            [18.657582354477505, 6.1546280293974],
            [18.656598643891588, 6.150366237801278],
            [18.652861280105572, 6.149692492687261],
            [18.644574229177582, 6.154795960414988],
            [18.639598202781453, 6.150428495317983],
            [18.640578539314244, 6.147029446908193],
            [18.634361232789033, 6.14636255115419],
            [18.631604628704107, 6.153607245471253],
            [18.63143605873842, 6.159503460696634],
            [18.62662440552883, 6.165405353938228],
            [18.6247389389577, 6.170380277765689],
            [18.623407243673082, 6.1807295475256865],
            [18.62231486486364, 6.183477283062197],
            [18.6186581622049, 6.183857810329083],
            [18.608719975091947, 6.167477042080796],
            [18.606642561907673, 6.165248350933536],
            [18.60298937982363, 6.16344402226325],
            [18.601960226062968, 6.1571570115423],
            [18.598400071609028, 6.150399092679518],
            [18.59192124644075, 6.152374889097048],
            [18.587885648655547, 6.147328970440164],
            [18.577375815458637, 6.148160530085824],
            [18.57457666527701, 6.155283348185459],
            [18.567658789502747, 6.161675041311086],
            [18.564061384064317, 6.15510771569937],
            [18.535561649275866, 6.18084896339578],
            [18.534292838814444, 6.189994145507614],
            [18.53884779712324, 6.19397003695902],
            [18.540709959365987, 6.201957258734547],
            [18.536603243423286, 6.206298978995087],
            [18.53978061239683, 6.208723868878542],
            [18.541428496903812, 6.213347774485406],
            [18.538773645511363, 6.218519565133504],
            [18.536154342987942, 6.219996126985457],
            [18.532029912783074, 6.231041566900503],
            [18.520885017565107, 6.225900348391424],
            [18.51377496343797, 6.224841112211587],
            [18.506620553762055, 6.229200654771046],
            [18.503085732377507, 6.254000944403585],
            [18.505731226104174, 6.261156674703223],
            [18.508108668515394, 6.2740597103161635],
            [18.514120514579698, 6.272692684638746],
            [18.519304035351656, 6.276562260076066],
            [18.524439416738876, 6.274587985691235],
            [18.528491954494367, 6.279631097162824],
            [18.521492008556354, 6.289579138728918],
            [18.4981383276593, 6.304917955808695],
            [18.497834440930315, 6.307684725388984],
            [18.486831161003753, 6.299631222948379],
            [18.446247971626107, 6.283618872117899],
            [18.439496942158858, 6.2869198173484415],
            [18.433267055896174, 6.294714503418123],
            [18.428647076718477, 6.2956600216830925],
            [18.426284330586334, 6.292629805279275],
            [18.42702359794157, 6.287350457318251],
            [18.425429768677866, 6.280914466482215],
            [18.425740177411427, 6.277030512439663],
            [18.4114110533567, 6.283940688645402],
            [18.41348803206143, 6.29095053978198],
            [18.416064627318775, 6.293637384751835],
            [18.345888985714403, 6.317048555805908],
            [18.34918506884023, 6.321897548437912],
            [18.354215799033717, 6.324636549847473],
            [18.35489870404585, 6.333528482637399],
            [18.325999720543344, 6.394041023253082]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -70.95270012352745, "lat": 42.67332272176973 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25009"],
        "coty_name": ["Essex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Essex County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00606931"
      },
      "bbox": [
        18.325999720543344, 6.14636255115419, 18.81953680236154,
        6.607362704381934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.694486515542366, 7.45776726892107],
            [8.700986325006367, 7.452681048972308],
            [8.708207861382398, 7.445679673144598],
            [8.71425691856556, 7.437976805633147],
            [8.721858094253655, 7.431550507650501],
            [8.725611141285881, 7.426740069902644],
            [8.7308300758808, 7.425447730680552],
            [8.732224716842342, 7.4215215317364605],
            [8.746979926767976, 7.410922895369504],
            [8.755014812633547, 7.4009820963928545],
            [8.75702440000133, 7.395445387715533],
            [8.757167674487105, 7.389542202988045],
            [8.758742254823966, 7.381996215464288],
            [8.763475829511268, 7.365436627740066],
            [8.766669210443418, 7.358245358760939],
            [8.772855387903473, 7.349630798744771],
            [8.780100076029283, 7.3433864447638495],
            [8.785302553279028, 7.340256273037969],
            [8.798756334738256, 7.335342686902199],
            [8.805005245212447, 7.3346259089397385],
            [8.81155774249908, 7.335045407524066],
            [8.817853847658034, 7.337033983750945],
            [8.827356032152213, 7.342856527431024],
            [8.827665250883568, 7.3459594644272554],
            [8.833349258349113, 7.34510755153204],
            [8.841283165692353, 7.3458375580903175],
            [8.84649156488226, 7.345293837703972],
            [8.850521531370015, 7.34313752209608],
            [8.856218583149616, 7.342864952361392],
            [8.861257912017686, 7.3442086238754944],
            [8.872417309379207, 7.348962129257239],
            [8.878040881286529, 7.3478203498588845],
            [8.884709682704742, 7.349408624342172],
            [8.89772725993729, 7.3493902373022975],
            [8.907609699231909, 7.346465301951397],
            [8.917069183122866, 7.34527283166142],
            [8.926812613323543, 7.336427005342208],
            [8.938576045035427, 7.330127706198754],
            [8.956039755625323, 7.31250237477267],
            [8.961174891198732, 7.308178826259062],
            [8.972783115343255, 7.30061428153054],
            [8.978324578055615, 7.300752532035249],
            [8.983566702372405, 7.294878278806271],
            [8.99115531500669, 7.293135413888516],
            [8.993999188689171, 7.289861907233085],
            [9.004106314710752, 7.287316090254361],
            [9.009828749865479, 7.286941723049727],
            [9.011095165017943, 7.283200427762798],
            [9.022316174066166, 7.279820301153345],
            [9.028360107081463, 7.281264457752481],
            [9.0304064451552, 7.2862174177010965],
            [9.035934976777156, 7.284727794027493],
            [9.042287947924232, 7.279045472261578],
            [9.045285798121196, 7.279660240401726],
            [9.04667150534582, 7.287302253627288],
            [9.049014821483977, 7.28703160115189],
            [9.059802634366157, 7.292048039207981],
            [9.065226405082011, 7.289425736300669],
            [9.069412878338172, 7.2816803893321635],
            [9.073783976173301, 7.277260669202507],
            [9.085644333752997, 7.27147920953787],
            [9.087921772059566, 7.2718686851378385],
            [9.095710761615086, 7.267070297571459],
            [9.101726692220458, 7.266397022073337],
            [9.111099655657988, 7.260695312266356],
            [9.114333301596536, 7.257770985025424],
            [9.119874371356044, 7.255891651306652],
            [9.126291457534608, 7.251316127085291],
            [9.132083905990427, 7.25074931876256],
            [9.137140368709796, 7.252060996963169],
            [9.144922086576864, 7.2491696451504195],
            [9.15035362884373, 7.241391831248372],
            [9.161703077574458, 7.24508332738147],
            [9.163561427708887, 7.24205648917704],
            [9.169594061529486, 7.239280795109801],
            [9.173642569450108, 7.243385606200029],
            [9.18137917888011, 7.242798325835209],
            [9.18710511896847, 7.247518585632927],
            [9.186423913767609, 7.251872861529598],
            [9.191911066967016, 7.252896748718724],
            [9.198331726063714, 7.249832127999825],
            [9.206761171765377, 7.243388363911835],
            [9.20989689754271, 7.243537019489814],
            [9.224761209155782, 7.23849331112204],
            [9.227072596573755, 7.241099369308099],
            [9.226057961290463, 7.249031904670172],
            [9.22093830200133, 7.255730462259685],
            [9.221771309192427, 7.258972003013754],
            [9.226351984394531, 7.255520320648627],
            [9.230875213355878, 7.248331259514189],
            [9.236028240739085, 7.245733939654442],
            [9.236075143395956, 7.242507500967537],
            [9.229073604173916, 7.2414632950977325],
            [9.228248271612639, 7.235725566942344],
            [9.232130367206638, 7.230112449344293],
            [9.237056434124598, 7.226495761718067],
            [9.239569734693417, 7.22766619206753],
            [9.23908491590795, 7.233528466498],
            [9.244873436279311, 7.234125673625231],
            [9.24693534344042, 7.230118898801539],
            [9.247937166806114, 7.223819894464895],
            [9.251989825347325, 7.220616704888996],
            [9.25705884480353, 7.222748158877024],
            [9.258116359542933, 7.2192919118885674],
            [9.261338273458554, 7.216273030969969],
            [9.263412623266358, 7.211637989963426],
            [9.271577635964853, 7.209346255416562],
            [9.278572541616791, 7.202698015281946],
            [9.281875953840881, 7.196653013911499],
            [9.29240386955019, 7.1947154007024645],
            [9.296655720224546, 7.191681382051133],
            [9.298121051973878, 7.187255259012321],
            [9.307491479658573, 7.186240130452693],
            [9.312597672803538, 7.180390318574968],
            [9.310055709425423, 7.172434368444009],
            [9.310109303343143, 7.165811649466976],
            [9.307790542447183, 7.1625407048708185],
            [9.29964536411799, 7.164169219300742],
            [9.2895965823613, 7.164419269840936],
            [9.289985247594684, 7.159297255208032],
            [9.295933773264172, 7.156986386326828],
            [9.293934768014593, 7.1529548725895165],
            [9.2950758405946, 7.147464212145553],
            [9.298460571060538, 7.144234417180813],
            [9.300270355691698, 7.138001512632056],
            [9.302432914049565, 7.134857491454852],
            [9.309598163664074, 7.130033278650144],
            [9.308756059701846, 7.1258965046439],
            [9.311971571818377, 7.124164198115878],
            [9.316129158873096, 7.118085430134602],
            [9.28435686663326, 7.113701595171822],
            [9.228604476134693, 7.1065661861925715],
            [9.181900214459029, 7.09862291697324],
            [9.143072858915417, 7.09293901761242],
            [9.128723501987649, 7.091031731886569],
            [9.06258960005891, 7.082919703880205],
            [9.000564002691844, 7.073193258415091],
            [8.972805855807268, 7.068464155954314],
            [8.881181687353417, 7.05341649304048],
            [8.795735742571564, 7.042751826727972],
            [8.717979054860239, 7.033187906902728],
            [8.707705959644256, 7.1153269906389385],
            [8.705775052743771, 7.115088860509076],
            [8.701016670995475, 7.1576241020212725],
            [8.696444659680303, 7.2001983981575],
            [8.6930797063926, 7.2281985316475845],
            [8.685313368488064, 7.285292864080311],
            [8.665650122754522, 7.424495433006372],
            [8.661524399634148, 7.453449678217123],
            [8.694486515542366, 7.45776726892107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.91803905298862, "lat": 45.34012302980343 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26141"],
        "coty_name": ["Presque Isle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Presque Isle County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01623013"
      },
      "bbox": [
        8.661524399634148, 7.033187906902728, 9.316129158873096,
        7.45776726892107
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7298267694004876, 9.81756429827884],
            [0.7433869370474674, 9.817361282980398],
            [0.8053531244168551, 9.818247516469768],
            [0.8307927647979818, 9.819074626864493],
            [0.8896705847313342, 9.819843943182704],
            [0.9036281083253145, 9.819805934621533],
            [0.9410614790009292, 9.81979014384805],
            [0.990992582393957, 9.820194365770051],
            [0.9913510456370798, 9.804954678851049],
            [0.9922693800969223, 9.734618057600185],
            [0.9920228417229219, 9.706503072081416],
            [0.9926462092213874, 9.692337303059789],
            [0.9930993630785858, 9.650471901041971],
            [1.0699264100249872, 9.651403105250163],
            [1.1680854963935763, 9.652838903009917],
            [1.2554678230722192, 9.654074162868534],
            [1.3428505830084574, 9.655283936419263],
            [1.4301430140498608, 9.656848705738764],
            [1.5178380161876794, 9.65833090277341],
            [1.5201569359277645, 9.658367765282412],
            [1.5222375991398214, 9.57222518244062],
            [1.525744353635297, 9.402730503035924],
            [1.5261550899118277, 9.375018113095381],
            [1.525531028539845, 9.357522247488337],
            [1.5269067787900494, 9.318632773123102],
            [1.5309137340936703, 9.318720991340811],
            [1.5323540041748933, 9.233865267291769],
            [1.5326788984153576, 9.21961071380481],
            [1.533257511033147, 9.148370636342591],
            [1.5339937659491847, 9.081141706369062],
            [1.534859770452114, 9.023654342996023],
            [1.5363697451070109, 8.978130604438743],
            [1.537003032126759, 8.978141019175263],
            [1.5388804537809335, 8.908062837724136],
            [1.5409621366150532, 8.894202785856978],
            [1.5408292402657582, 8.851309291806269],
            [1.541200312521361, 8.809225314276066],
            [1.5414673296184722, 8.755121115928354],
            [1.5420428348032666, 8.739238913016647],
            [1.5418965846361705, 8.72267603940383],
            [1.4917510990338472, 8.721861455099422],
            [1.453686746555852, 8.720338358904113],
            [1.4199125371379866, 8.719638819706837],
            [1.3978091637887409, 8.718860840775191],
            [1.3691215941782404, 8.718409643101337],
            [1.3402190699982701, 8.717491604137413],
            [1.3175050158094108, 8.717857595782462],
            [1.2883032581062308, 8.716987077799661],
            [1.194066648143274, 8.71678954156258],
            [1.1793853559924319, 8.71736330679638],
            [1.1066797952414746, 8.71697632363212],
            [1.0878743862557472, 8.71712445095807],
            [1.019834345139194, 8.717086851878083],
            [1.0190423667741901, 8.801754576858858],
            [1.0173802144321729, 8.887313872296744],
            [1.0164115082021354, 8.972780386131719],
            [1.0100908058586886, 8.972827200944554],
            [1.009574731184073, 9.058200386691892],
            [1.0090277970057782, 9.16084572478588],
            [1.0088225106844415, 9.167739477841682],
            [0.9980029748158259, 9.169400270200265],
            [0.9887551721630832, 9.171708292745707],
            [0.9800428888708329, 9.175081692314281],
            [0.9671677282171971, 9.18279727983153],
            [0.9601276736824391, 9.192108685187254],
            [0.9546669713985584, 9.204532750983457],
            [0.952934362808977, 9.210774575505969],
            [0.951245765473588, 9.224246142568752],
            [0.9519434797171982, 9.237134188009598],
            [0.9549183253202842, 9.249228614993719],
            [0.9549228208314949, 9.252914677118214],
            [0.9625506350459732, 9.273740068298455],
            [0.9720316657488955, 9.297313447860512],
            [0.9837000929081746, 9.312271757392374],
            [0.8643887137361527, 9.311861592151343],
            [0.7450773399872438, 9.31140482796301],
            [0.7386042977577529, 9.311377116819312],
            [0.7378682778991906, 9.396428150090603],
            [0.7369935789659825, 9.460279874256488],
            [0.7367683895970442, 9.549798482086832],
            [0.7369026005958658, 9.566257074797765],
            [0.7366972547091145, 9.648368064128285],
            [0.7310088234566606, 9.6483306400364],
            [0.7300612997455206, 9.67718654404398],
            [0.7309689897489483, 9.769026494568092],
            [0.7306726842167374, 9.810925346292503],
            [0.7298267694004876, 9.81756429827884]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.93765063338716,
          "lat": 47.973764963304184
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27007"],
        "coty_name": ["Beltrami"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beltrami County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00659449"
      },
      "bbox": [
        0.7298267694004876, 8.71678954156258, 1.5420428348032666,
        9.820194365770051
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4378872400271904, 6.479419045383014],
            [0.47767158519305464, 6.479216619216513],
            [0.5638910646739591, 6.479153340492895],
            [0.635555351129068, 6.47911657126937],
            [0.7072195879178044, 6.479066218076742],
            [0.7358175819687064, 6.479166650238682],
            [0.8075403609805853, 6.479733053430435],
            [0.9080713545194636, 6.481452674745053],
            [0.9946341814756868, 6.4817925507765555],
            [0.9946334175299234, 6.452911506700021],
            [0.9950308295744373, 6.395204806595934],
            [0.9947003586886939, 6.308532565535686],
            [0.9947914010265507, 6.265106205883161],
            [0.9952704413075301, 6.221943378505999],
            [0.9156358976932211, 6.221208989058489],
            [0.8295038383216481, 6.220248154846955],
            [0.8295163202873701, 6.194824220322379],
            [0.8291923703798654, 6.1841828206925005],
            [0.8302897206747822, 6.082596330331189],
            [0.8274499910833448, 6.08082551896188],
            [0.8241978212940378, 6.0828286613316305],
            [0.8241192997172003, 6.092152515330352],
            [0.8253994088935425, 6.0942126401477],
            [0.821355815371295, 6.0997731503876125],
            [0.8145440262171456, 6.10287066749697],
            [0.8115897824016346, 6.099633624903477],
            [0.8123376302244223, 6.096587970960057],
            [0.8069848269192526, 6.096533734852524],
            [0.8049262589099552, 6.101533415548332],
            [0.800032160995012, 6.0993919460951735],
            [0.7966565501757452, 6.101629740729321],
            [0.7963318609586785, 6.104371736223254],
            [0.8017241504768174, 6.105041985312315],
            [0.7999155510139772, 6.11287801928936],
            [0.8087532265219007, 6.113245230443192],
            [0.8190419987025218, 6.116769089650828],
            [0.8196620976507684, 6.118725813740117],
            [0.8150871220372083, 6.12427334518083],
            [0.8107316762796786, 6.125875566849358],
            [0.8040704461382236, 6.13160226175493],
            [0.7898406111725281, 6.132179687662986],
            [0.7859204221345931, 6.133199842177869],
            [0.7925453040312855, 6.14115047077571],
            [0.7919467979861685, 6.14478114802449],
            [0.786398095766976, 6.148997560558071],
            [0.7807348004642002, 6.15154550003658],
            [0.775131403488583, 6.152726648936067],
            [0.770270570520504, 6.158468261264613],
            [0.7710928089367527, 6.162878158023345],
            [0.7656021675998799, 6.169755338403088],
            [0.7632528141277111, 6.168322707662073],
            [0.7587536398167826, 6.16990539744129],
            [0.7465327070272274, 6.172518307814037],
            [0.7492463630809215, 6.177201497722265],
            [0.7461071277672109, 6.180270600167013],
            [0.7404912760909359, 6.178525510012876],
            [0.7360122151873784, 6.179991207579436],
            [0.7351390260350802, 6.1836096956351625],
            [0.7364381994592791, 6.188862082023414],
            [0.731953597344362, 6.196666372493416],
            [0.7278102863297092, 6.198036233543859],
            [0.7234424526924472, 6.206976396755976],
            [0.7203747831865617, 6.202395080988666],
            [0.717549833445579, 6.203286599965077],
            [0.7082375077826378, 6.213774454308211],
            [0.7114511691938323, 6.215307624484177],
            [0.7111457877749997, 6.220029189713224],
            [0.7073574385904263, 6.218063843982062],
            [0.7042867713184771, 6.219263637218183],
            [0.7011721286160449, 6.223116943209076],
            [0.6951426453884224, 6.225513567797952],
            [0.6955690397039538, 6.23308108279802],
            [0.6899118421820549, 6.236126504843204],
            [0.6848891356897874, 6.231148590883669],
            [0.6785751134676133, 6.232933350322884],
            [0.6691302121700872, 6.232378297087695],
            [0.6629906038919707, 6.2346698198746795],
            [0.659268183660056, 6.238014230792285],
            [0.6626009909099452, 6.240121722461114],
            [0.6611292084991559, 6.244525949882806],
            [0.6621221713469174, 6.249681005626863],
            [0.6565796301315788, 6.258109257869777],
            [0.6498555796775987, 6.2646439223909125],
            [0.6363414883769876, 6.2749690464090975],
            [0.635951807566782, 6.27014001848196],
            [0.6266484908724789, 6.276442150442024],
            [0.6261757667932603, 6.2720540071680375],
            [0.6213573808596753, 6.270997348553262],
            [0.6193736540997211, 6.274546576051164],
            [0.6158804844922409, 6.276291621693158],
            [0.6118197700733724, 6.274959639754714],
            [0.6020563030403626, 6.277626673361586],
            [0.6017598158654085, 6.280201273977404],
            [0.5972672723331203, 6.289819893496637],
            [0.5910169276253223, 6.289412658448373],
            [0.5880689180256378, 6.297831034320399],
            [0.5887446204235333, 6.303709787865212],
            [0.5871711888263911, 6.309930612486303],
            [0.5876171783506053, 6.3151109273987585],
            [0.58317769195752, 6.31883520015125],
            [0.572920785364573, 6.33030387836454],
            [0.5661415861391067, 6.333158454546104],
            [0.5603309127126916, 6.340474437361666],
            [0.5582943863605884, 6.345165704636143],
            [0.554093577224582, 6.351005358395109],
            [0.545836524552963, 6.355978311950265],
            [0.5446657156104847, 6.3610110349149345],
            [0.5380024747855252, 6.364401526726059],
            [0.4776039310046885, 6.425138860594734],
            [0.4687575921957116, 6.43829523755537],
            [0.46294695514617173, 6.440427734400676],
            [0.4638782255473654, 6.446776902202215],
            [0.45879609217532524, 6.451018382969112],
            [0.454948920348799, 6.451152060137095],
            [0.4532573065392744, 6.456102698712483],
            [0.4459052480214798, 6.463606709974244],
            [0.44375844013216825, 6.470066209587534],
            [0.43777514203216766, 6.477430999526884],
            [0.4378872400271904, 6.479419045383014]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.56675259203404, "lat": 45.02235578761274 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27023"],
        "coty_name": ["Chippewa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chippewa County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00659457"
      },
      "bbox": [
        0.43777514203216766, 6.08082551896188, 0.9952704413075301,
        6.4817925507765555
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.574499167529137, 5.559885646126936],
            [2.5779182044182054, 5.560001523192952],
            [2.626002054486319, 5.56168866522163],
            [2.7380838945735477, 5.565208020093134],
            [2.762555839068279, 5.56560883119014],
            [2.836836320831796, 5.5673096507968225],
            [2.838602094864768, 5.523290712524316],
            [2.84135057355938, 5.44791391162591],
            [2.844561416594478, 5.3615538607221715],
            [2.846893213174164, 5.289470882796595],
            [2.8493031474245805, 5.220894845057404],
            [2.8413388240748425, 5.220600995964821],
            [2.7624866703982676, 5.218023126870711],
            [2.7048629194779514, 5.216192128770227],
            [2.6652404923899256, 5.214711549278609],
            [2.5853460015328893, 5.212093180415845],
            [2.5850515208363434, 5.233905803610346],
            [2.582997637482505, 5.299238935293785],
            [2.5799846206283354, 5.386254921010603],
            [2.5773729380964516, 5.473750374672633],
            [2.574499167529137, 5.559885646126936]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.86209936993504,
          "lat": 44.022596916880694
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27039"],
        "coty_name": ["Dodge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dodge County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00659465"
      },
      "bbox": [
        2.574499167529137, 5.212093180415845, 2.8493031474245805,
        5.5673096507968225
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.722808413547816, 5.190297674081555],
            [1.8079616303633252, 5.191940796140107],
            [1.923454816787418, 5.1945482229457784],
            [2.0229458259355146, 5.196422380381587],
            [2.067071045096728, 5.1974964498316165],
            [2.1100112083839133, 5.198457452322279],
            [2.1528608323362532, 5.199740183382778],
            [2.1531921627914272, 5.192104124767569],
            [2.1545866447450113, 5.1357889229010025],
            [2.1544990030349345, 5.134048099497407],
            [2.157759027916563, 4.996049394002631],
            [2.159266585427525, 4.938086984499304],
            [2.1613443257045892, 4.85120654988451],
            [2.0458740894818894, 4.848489417975948],
            [1.9287497187635023, 4.846082155438422],
            [1.839299137579028, 4.844429973138118],
            [1.7286408161053846, 4.842348036055659],
            [1.7268175578971854, 4.943728970502884],
            [1.7254464829485754, 5.016023936762962],
            [1.7241299739291367, 5.088476568482414],
            [1.724082085047735, 5.104005360301425],
            [1.7232568864941462, 5.154244623873636],
            [1.722808413547816, 5.190297674081555]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.9480057947213, "lat": 43.673936567183155 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27043"],
        "coty_name": ["Faribault"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Faribault County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00659467"
      },
      "bbox": [
        1.722808413547816, 4.842348036055659, 2.1613443257045892,
        5.199740183382778
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1528608323362532, 5.199740183382778],
            [2.239893948443975, 5.201798532726808],
            [2.3263844801061833, 5.204217774962722],
            [2.4104919110660132, 5.206586493130532],
            [2.45368834120181, 5.2078782747200805],
            [2.5827921926793533, 5.21199014900274],
            [2.5855703458466897, 5.124551746122689],
            [2.587140833663223, 5.078960369848116],
            [2.5889835912969077, 5.015577681579711],
            [2.5895709812749477, 5.001151966572365],
            [2.5921388563374212, 4.914933346304736],
            [2.593902083266283, 4.863275625136803],
            [2.4929289298868564, 4.86007553387714],
            [2.4410657382694523, 4.858377036883898],
            [2.334511456201394, 4.855555379039472],
            [2.2704641620939188, 4.85391182841372],
            [2.1613443257045892, 4.85120654988451],
            [2.159266585427525, 4.938086984499304],
            [2.157759027916563, 4.996049394002631],
            [2.1544990030349345, 5.134048099497407],
            [2.1545866447450113, 5.1357889229010025],
            [2.1531921627914272, 5.192104124767569],
            [2.1528608323362532, 5.199740183382778]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.34881300408931,
          "lat": 43.673830242291004
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27047"],
        "coty_name": ["Freeborn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Freeborn County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00659469"
      },
      "bbox": [
        2.1528608323362532, 4.85120654988451, 2.593902083266283,
        5.21199014900274
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.040630642668287, 6.324210927537624],
            [2.039911200678913, 6.374480117485673],
            [2.039265469344467, 6.406383111103231],
            [2.0405680574218654, 6.417183243162427],
            [2.044775385749871, 6.419127716422604],
            [2.0421840152353594, 6.427361316319437],
            [2.051799192646404, 6.4254505518461915],
            [2.0581462984584014, 6.427481057826615],
            [2.0617963401934056, 6.433785769954885],
            [2.065212105305249, 6.436633099965751],
            [2.064558670199024, 6.444005817142464],
            [2.0664984447216126, 6.445057873591265],
            [2.0670723120521854, 6.450223709987853],
            [2.070478093683635, 6.461064512444484],
            [2.076293966067591, 6.469869298957887],
            [2.0794850419670445, 6.472778235865123],
            [2.082894717854896, 6.4784553506938645],
            [2.083680922201607, 6.4825034819679646],
            [2.088229897129894, 6.4882518082847005],
            [2.091739327434142, 6.490363977563074],
            [2.0953834893921326, 6.497031844763523],
            [2.0991285690743933, 6.49764391501063],
            [2.107933625928278, 6.501778691648482],
            [2.111443076284624, 6.5007363328653005],
            [2.1207398630518637, 6.506219772875729],
            [2.1269921458386554, 6.513348086412398],
            [2.1267579492553215, 6.5218382308029215],
            [2.122251515506808, 6.526671727522488],
            [2.117637537738981, 6.529936170644102],
            [2.113718995869087, 6.535738318107444],
            [2.112011624198164, 6.5407621168429415],
            [2.11318047786918, 6.544750243661713],
            [2.118657148201038, 6.546222341787594],
            [2.1212088989440008, 6.549070928347551],
            [2.1249708223126538, 6.556744167320954],
            [2.1287595708447826, 6.556735319173207],
            [2.1314867852965684, 6.550510243906643],
            [2.1358299608930493, 6.550565246201835],
            [2.1362408984246097, 6.557350392957764],
            [2.141666193438061, 6.5574804112847485],
            [2.1454597295817326, 6.556086218990865],
            [2.147498284513484, 6.560148170324872],
            [2.150131626965966, 6.560878430356869],
            [2.15173771023045, 6.556197573621331],
            [2.1573760878158574, 6.55733869966022],
            [2.1603534366514685, 6.5631024380452905],
            [2.1701130429338593, 6.567096464279018],
            [2.173982970817023, 6.56714394944501],
            [2.1789714198283585, 6.571730236506142],
            [2.180962703511663, 6.575616747608389],
            [2.18937341057663, 6.575678695352578],
            [2.192852993202253, 6.581616472833244],
            [2.19890457269764, 6.57979820234105],
            [2.1995367974731987, 6.57483912025995],
            [2.2029366389164586, 6.571771331132729],
            [2.2050109558783118, 6.574345025568279],
            [2.2042448387018516, 6.578003820982829],
            [2.207521605292707, 6.581879557984298],
            [2.2087028300258496, 6.587668035844546],
            [2.2123347870293526, 6.589413063336094],
            [2.20676038577527, 6.593689638827502],
            [2.207248270917836, 6.59593669997647],
            [2.2139284278476583, 6.595180343437843],
            [2.2224722938627632, 6.59031366206925],
            [2.22498908789992, 6.584113478887978],
            [2.2332520186867937, 6.575791587509169],
            [2.235894300669263, 6.575157986438165],
            [2.2439311907031425, 6.576335726174306],
            [2.248099802063874, 6.575131363299909],
            [2.2531749037481323, 6.570809626290316],
            [2.2578673789773784, 6.570277140177426],
            [2.2639102510697, 6.567335476928991],
            [2.270255296612723, 6.569098726642493],
            [2.2761683587707116, 6.565417667253509],
            [2.283347478982987, 6.552249822825118],
            [2.2856677837926234, 6.549824970649531],
            [2.2974473780203652, 6.543339227288656],
            [2.3119679248566425, 6.531145080912661],
            [2.3237575484392865, 6.5277900364628865],
            [2.327283271924614, 6.5231433963873515],
            [2.3330429298399986, 6.513324011037546],
            [2.344273613832997, 6.506535291496161],
            [2.3494568419650577, 6.501146601760683],
            [2.3579322954831725, 6.497716103250771],
            [2.3603769611392407, 6.491982413544489],
            [2.3656047998913268, 6.486178885738939],
            [2.3685651082680876, 6.481287549616671],
            [2.3703466089158556, 6.46975679841601],
            [2.3810094182372454, 6.46054529841694],
            [2.382469663024697, 6.457872191111173],
            [2.381778382907815, 6.438773372122279],
            [2.3826599137153175, 6.435116180462276],
            [2.381640561210261, 6.426678436048654],
            [2.379540798873942, 6.419867846562912],
            [2.378909113875619, 6.413412316670694],
            [2.3812338843551326, 6.406212452685287],
            [2.3824390342432062, 6.398681953240084],
            [2.380839556476425, 6.390474215579804],
            [2.4206896275173935, 6.391922835804252],
            [2.433976895754042, 6.3923821917779575],
            [2.435649619396239, 6.34856783688258],
            [2.4366408839334666, 6.310286580603121],
            [2.439645072655241, 6.308152748798228],
            [2.442391873872543, 6.2988006075001195],
            [2.4421190034527362, 6.29161736173513],
            [2.4430289200204807, 6.284302209808284],
            [2.4421463150063474, 6.277140483867776],
            [2.443146446829404, 6.267071595899896],
            [2.449064420130659, 6.262017130881151],
            [2.4505464260178775, 6.255697008739783],
            [2.4527486730912953, 6.252906082818548],
            [2.4599754031453513, 6.2519318053671125],
            [2.459207668266785, 6.246341034332921],
            [2.4561642368237, 6.243272925703091],
            [2.459286683562158, 6.238199148462806],
            [2.452998375141802, 6.232873753167911],
            [2.451682370913818, 6.229383360912269],
            [2.444729454859511, 6.223170367199043],
            [2.4467905557115115, 6.217860258253858],
            [2.442686012436776, 6.2100112833139525],
            [2.4398655950931967, 6.201231441256967],
            [2.4373753630041053, 6.197289147320253],
            [2.430569607909201, 6.195830603368827],
            [2.4321994353739425, 6.189662004019848],
            [2.426348776238527, 6.186351577802586],
            [2.4212006347935344, 6.18174377428196],
            [2.4181930757467236, 6.177260863441034],
            [2.4122377299053, 6.172231734265897],
            [2.409583002776064, 6.168321190968098],
            [2.3951424440832447, 6.163321998625928],
            [2.389241275556117, 6.162635698531979],
            [2.386189593887906, 6.158277237135533],
            [2.372790927872918, 6.1503588094619825],
            [2.366056726083522, 6.1481463736646],
            [2.357832558231101, 6.148110050400959],
            [2.355125405395599, 6.146460919248478],
            [2.350763418211522, 6.1417443834906225],
            [2.3452567111238243, 6.143588065302922],
            [2.341705925494828, 6.146351344547922],
            [2.339367675626397, 6.145127615213158],
            [2.3365550375085977, 6.14031544251435],
            [2.331533182628874, 6.143614569210719],
            [2.3290081028336935, 6.143566865043042],
            [2.320854130533275, 6.139635758657753],
            [2.318894639933232, 6.140220779875447],
            [2.3158715762965967, 6.151553453463037],
            [2.31389446158635, 6.1528156675047265],
            [2.3077241712643897, 6.151123738946907],
            [2.3023724015937996, 6.15735921190251],
            [2.2952153018572163, 6.161258338391297],
            [2.290337706092192, 6.160473883160049],
            [2.280552353572053, 6.1643872793407555],
            [2.2755272017661676, 6.164373116305124],
            [2.2737761416918474, 6.158685789346094],
            [2.2693188366498216, 6.156517155955336],
            [2.26479056687758, 6.156026840396828],
            [2.259792913642375, 6.159374400043964],
            [2.251319990637244, 6.156845450755376],
            [2.247401235520125, 6.157142606086356],
            [2.2455730218894066, 6.160134382589731],
            [2.2398744477597696, 6.156846018832238],
            [2.2367383510612253, 6.161644988587141],
            [2.2345955083172377, 6.162362053460239],
            [2.2317521270897376, 6.156725017500545],
            [2.2260785218231502, 6.15683809266816],
            [2.219903431090521, 6.1538717856177945],
            [2.219833742985503, 6.156715625840033],
            [2.2183574925202136, 6.192803834552408],
            [2.2171873775656525, 6.242781853999234],
            [2.203442330842531, 6.242133924941527],
            [2.1560009391254473, 6.2412345140712215],
            [2.136456075182108, 6.240297926243053],
            [2.116393466326634, 6.240173019935962],
            [2.086132315887263, 6.238673169588894],
            [2.0420685781006003, 6.237837285328861],
            [2.0417745397327516, 6.266658078329831],
            [2.040630642668287, 6.324210927537624]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.47694957751952, "lat": 45.00455148262667 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27053"],
        "coty_name": ["Hennepin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hennepin County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00659472"
      },
      "bbox": [
        2.039265469344467, 6.139635758657753, 2.4599754031453513,
        6.59593669997647
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2888835765771245, 9.55056986231873],
            [3.2932269894238675, 9.55040223096481],
            [3.2953685804504267, 9.544682498916863],
            [3.3004588976747087, 9.548703572825318],
            [3.3115460324030206, 9.549340802754715],
            [3.31391238795495, 9.553556156662795],
            [3.316876777895031, 9.554698107439053],
            [3.318730949019331, 9.550255798281524],
            [3.322103550646702, 9.548101899706506],
            [3.3268910245138126, 9.548585316918873],
            [3.32873027309755, 9.55360747613853],
            [3.3450340403008925, 9.549397792659834],
            [3.3482325849460124, 9.544422068293299],
            [3.347234316076668, 9.538118642618905],
            [3.3415202256971885, 9.530776638062328],
            [3.339816591606663, 9.521310597203524],
            [3.3499432508136184, 9.523776455183189],
            [3.352762763906254, 9.522002077409875],
            [3.353398379508938, 9.511209811302672],
            [3.3514167851697994, 9.504257265244872],
            [3.3550754509816274, 9.497266207268185],
            [3.358871644203838, 9.493768902675676],
            [3.3580958214972036, 9.484140670137304],
            [3.3556073675831124, 9.477231605839435],
            [3.3530315166547435, 9.475248366956595],
            [3.350786397327983, 9.46705210030942],
            [3.3565320268957097, 9.46616793344764],
            [3.363592284237284, 9.469235692514587],
            [3.363779823080895, 9.472151016987015],
            [3.3700597776601042, 9.475161014629327],
            [3.369614056423018, 9.470847231799574],
            [3.3673139222072757, 9.46483913613336],
            [3.374744879236004, 9.46083224009967],
            [3.3839477824001856, 9.462809297886945],
            [3.384128364542473, 9.465389793593094],
            [3.3903236536972914, 9.468261060569265],
            [3.3903221806113444, 9.463787781653483],
            [3.3941124801066165, 9.460067072440575],
            [3.399910431797035, 9.451847235655691],
            [3.416453517439846, 9.457473449993456],
            [3.434140802487237, 9.458535850317038],
            [3.442755649953326, 9.463182461530007],
            [3.4538309742191946, 9.465414165171477],
            [3.4583203117661716, 9.460476264007955],
            [3.447472785052864, 9.450515636849358],
            [3.444868021608859, 9.42390820758256],
            [3.446937193409237, 9.415188705775813],
            [3.445540255073519, 9.406799942011878],
            [3.451443972591664, 9.402104569306157],
            [3.467664177688244, 9.412204673179499],
            [3.5032415258963265, 9.42835135761581],
            [3.518886127259666, 9.427818304087028],
            [3.529001939877239, 9.430289199461436],
            [3.5315937396439896, 9.429025197218268],
            [3.5314264203389207, 9.424900674432852],
            [3.5380346268737792, 9.414361294460031],
            [3.5385146133106535, 9.411587123134032],
            [3.543892041679738, 9.411215432575432],
            [3.5542837654653465, 9.416518089603118],
            [3.569420999573582, 9.42072436865303],
            [3.5768791953471375, 9.429131439764136],
            [3.582464271009239, 9.433429271552802],
            [3.5864389626874003, 9.43122924419749],
            [3.5960541247202746, 9.436306984302602],
            [3.6029537211902833, 9.4381642233964],
            [3.60553970831368, 9.434755452684184],
            [3.6099366415201426, 9.435148773688308],
            [3.61333417070665, 9.438043748722643],
            [3.620086554480673, 9.439177914863668],
            [3.6282288344747897, 9.439193782455192],
            [3.6365374771652563, 9.440492777891995],
            [3.645908162021408, 9.445400448402946],
            [3.652345598861714, 9.445936976318238],
            [3.6630285949284227, 9.451725289737169],
            [3.6726564894696168, 9.463790078794803],
            [3.6783433317409573, 9.467741416647964],
            [3.6861026426259955, 9.471327203464753],
            [3.701126416958581, 9.493565644674625],
            [3.7061384062926743, 9.491216155641977],
            [3.7106840319728427, 9.494944394091592],
            [3.7234438336045184, 9.509939246116634],
            [3.735358185425119, 9.519030914917545],
            [3.731545831187415, 9.523827262534661],
            [3.7466750648690788, 9.530626082567212],
            [3.7498727102977085, 9.536312963395906],
            [3.7537671426934756, 9.538838920455136],
            [3.7647041542178896, 9.543960823467822],
            [3.7668722199990756, 9.548230528202403],
            [3.7707140117799933, 9.551758736377982],
            [3.7755448194258103, 9.550486814021246],
            [3.7822353213297486, 9.552797279543183],
            [3.783797399436722, 9.55678972902858],
            [3.7875588192536416, 9.55906997264764],
            [3.79656371504921, 9.561310866879966],
            [3.804352581614507, 9.56109009520264],
            [3.8110920165550475, 9.439654469414227],
            [3.815803213732311, 9.439896824565206],
            [3.823654943400217, 9.26797342519816],
            [3.8275701701374767, 9.267898433367629],
            [3.8359025369619775, 9.099305782531403],
            [3.8409907721251124, 8.987888456493229],
            [3.8479447747405677, 8.853572211741394],
            [3.841621978206892, 8.84662964773463],
            [3.833080999463948, 8.84450634980705],
            [3.831265126225495, 8.839874797851806],
            [3.824183299320295, 8.831343647396858],
            [3.8208207447470106, 8.82830531455313],
            [3.81712381237566, 8.821169786326081],
            [3.8062647898026705, 8.809572466638132],
            [3.8012791265806025, 8.801709375639565],
            [3.7942114450900206, 8.798537103030993],
            [3.779031840648095, 8.784648830639355],
            [3.7788106365694767, 8.78140837505131],
            [3.7709643769160683, 8.774059708616624],
            [3.770834435246047, 8.771339159185581],
            [3.7655749918174424, 8.76524896542407],
            [3.7627614084349905, 8.766028771295447],
            [3.7579139698002817, 8.75933318799326],
            [3.7558618048224095, 8.754346477115732],
            [3.752689775778711, 8.751149014974068],
            [3.7527269071781375, 8.748411960799329],
            [3.74929231930533, 8.743809245865924],
            [3.747603677508623, 8.73791086764763],
            [3.743411181807414, 8.731794332088812],
            [3.7447692419023726, 8.729026739518181],
            [3.7373032189696644, 8.722937193921805],
            [3.730071172369711, 8.714978625136045],
            [3.730055140758802, 8.711041769489226],
            [3.7280301725883724, 8.705014864868334],
            [3.7255963937557337, 8.702190335124502],
            [3.7217731665130485, 8.702661279821111],
            [3.7189774392223494, 8.696664943908374],
            [3.7159861575857507, 8.696385421559876],
            [3.7157506229747637, 8.691629291685182],
            [3.709473800168624, 8.689175421996264],
            [3.7085268500554314, 8.68550976750415],
            [3.7045812598822425, 8.678510748997747],
            [3.704855165356013, 8.6746524014772],
            [3.703319009890383, 8.668379600143645],
            [3.6961875588637882, 8.663249632525579],
            [3.692235431192841, 8.663692556689892],
            [3.6869976556418402, 8.658888181539522],
            [3.684171587852782, 8.65005853248355],
            [3.6780893515805335, 8.649996108656316],
            [3.67428607629297, 8.644146564467228],
            [3.672370734250186, 8.639266597905753],
            [3.66641855483846, 8.636502565230629],
            [3.6637213227795913, 8.63174394424485],
            [3.6534688847815606, 8.62168883101663],
            [3.6513130196229184, 8.614451071714221],
            [3.6458515397935125, 8.61124092623956],
            [3.6454690598101185, 8.608659529369831],
            [3.6415419041334176, 8.606587511804353],
            [3.6410998242798023, 8.60401795799572],
            [3.636008893464721, 8.598846391303443],
            [3.6338444113966872, 8.590395793649227],
            [3.628715919133579, 8.587404727628652],
            [3.6273645268879746, 8.58190590653162],
            [3.620239476492433, 8.579525172910797],
            [3.6178226050895903, 8.573879539994799],
            [3.6144251006900396, 8.571727993039294],
            [3.6144548644488568, 8.569061651159684],
            [3.60609192491127, 8.567156681891321],
            [3.6040294884706903, 8.563177780062174],
            [3.5996239269021597, 8.563015270052224],
            [3.5985872943470976, 8.55733840763575],
            [3.5918452278015205, 8.551084754856426],
            [3.591445597893958, 8.547268953931464],
            [3.5880960068226555, 8.545843755622114],
            [3.5816783260926948, 8.539867288224485],
            [3.5775318042231925, 8.53137308291024],
            [3.5733708057983664, 8.526444835474619],
            [3.570185755745059, 8.525691164515019],
            [3.5693126477183315, 8.520028283346992],
            [3.5626371389983027, 8.512027271953103],
            [3.5568046528693915, 8.508036386870241],
            [3.552886142246885, 8.503950800417693],
            [3.5491084682773826, 8.504689301341575],
            [3.5463963978022632, 8.502399536460672],
            [3.5410943373679875, 8.5015183186475],
            [3.535615090974891, 8.497926998724804],
            [3.527884615090577, 8.48659972150348],
            [3.5266245288744327, 8.48280989745576],
            [3.520724142526037, 8.480592052489463],
            [3.5141673029846734, 8.479657562057458],
            [3.5103530553274225, 8.477166145153783],
            [3.5072677428579286, 8.471209013002595],
            [3.502032840054968, 8.471903615671865],
            [3.494308948670613, 8.469407688231707],
            [3.491131116132554, 8.466959485967273],
            [3.4873743567791053, 8.458772830101376],
            [3.4845767417315696, 8.45559346252738],
            [3.4845395062418407, 8.450686560798593],
            [3.4811524815464114, 8.447806278050894],
            [3.478100113977646, 8.442166533044704],
            [3.477947136712483, 8.439247532355578],
            [3.4721857656496833, 8.440371951753585],
            [3.4627372445498605, 8.432395316407536],
            [3.4600752583531986, 8.42734246717469],
            [3.4567307462050327, 8.426002506748556],
            [3.4507738521779396, 8.417099159570276],
            [3.446799797305142, 8.414361109631077],
            [3.446406225624011, 8.411037602868442],
            [3.451095084510279, 8.407039058238814],
            [3.4505611075907408, 8.403361057479563],
            [3.445020499410641, 8.401843958366744],
            [3.440794163226378, 8.40541949392494],
            [3.435488905571206, 8.402681841423401],
            [3.4352768138657024, 8.390856066018404],
            [3.4331981379495473, 8.388395454267203],
            [3.429448169181638, 8.392523840327522],
            [3.4246678933708004, 8.392694749906886],
            [3.422687179384344, 8.385979680755954],
            [3.4174351917856187, 8.380910470428793],
            [3.4103651270556448, 8.381856956635888],
            [3.405514368342388, 8.37962587738006],
            [3.3958478307413595, 8.368217525576597],
            [3.3843052725905314, 8.35660540123593],
            [3.3716856250657568, 8.341220263336943],
            [3.3699891590282434, 8.337013154569766],
            [3.364916893122639, 8.33079055784471],
            [3.3579788457394106, 8.32554507000328],
            [3.356223535277039, 8.3163804351745],
            [3.346987288287007, 8.312295523548162],
            [3.343209348565348, 8.396648850979354],
            [3.339250557487211, 8.481860712788812],
            [3.3407431404510897, 8.481768479727757],
            [3.3370819065085016, 8.56701474405357],
            [3.333013249434508, 8.652044451845741],
            [3.3297496829877864, 8.737958906304815],
            [3.3305297326970855, 8.737991103985905],
            [3.3293988661597345, 8.781371065263725],
            [3.3269352056136023, 8.829641531566706],
            [3.3267629561823235, 8.843831739746594],
            [3.3257980145362556, 8.85109179370257],
            [3.324885977728006, 8.87988626139815],
            [3.3207046354034397, 8.954698306309558],
            [3.320560172857362, 8.96185645622174],
            [3.3173474901435576, 8.993782449692958],
            [3.315773677033883, 9.004360716222239],
            [3.31365902400181, 9.025440457507367],
            [3.313690837173272, 9.03256173896268],
            [3.3115868656120364, 9.065427185216986],
            [3.30964023943836, 9.081955518323777],
            [3.307655428625941, 9.115124418142129],
            [3.3053343365223924, 9.159651840074638],
            [3.303468932770529, 9.223411156102095],
            [3.30231091787718, 9.258968275578079],
            [3.298247230579916, 9.329930420098675],
            [3.297893292298784, 9.344261371228932],
            [3.2937601413014397, 9.41679728240708],
            [3.2888835765771245, 9.55056986231873]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.44579380285664,
          "lat": 47.641082002711784
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27075"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00659484"
      },
      "bbox": [
        3.2888835765771245, 8.312295523548162, 3.8479447747405677,
        9.561310866879966
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.39773922447654964, 5.960037961711893],
            [0.4405420274917088, 5.959709787098323],
            [0.48394927990767356, 5.960126496099485],
            [0.5563048251373264, 5.960374024741841],
            [0.6577241183689657, 5.960017994019723],
            [0.6705677258526433, 5.959858557172657],
            [0.7076199713376804, 5.960338474661374],
            [0.74492784188867, 5.960049205121263],
            [0.7450546536449528, 5.872913478627662],
            [0.751823595875645, 5.872700527833041],
            [0.7522836284928447, 5.8397182554691085],
            [0.7521553169118688, 5.831153544126926],
            [0.7530493404555525, 5.759176342069658],
            [0.7530970030511087, 5.701118348884987],
            [0.7540277890663815, 5.613963733966595],
            [0.7541973035852917, 5.526667977673071],
            [0.732966290840485, 5.526261369038486],
            [0.6757919256791244, 5.526658895948365],
            [0.6032181680635683, 5.526891367272347],
            [0.5043320969717836, 5.526880725846995],
            [0.4580772022939524, 5.527053622072071],
            [0.4181612607648885, 5.526958766666987],
            [0.40758320940542286, 5.527161371648623],
            [0.40717031419780686, 5.614361308678429],
            [0.40732525529056185, 5.665640574365864],
            [0.4071722592749074, 5.701740388355573],
            [0.40720895021787223, 5.745463319913253],
            [0.4068746881726379, 5.78910500072955],
            [0.4069131051434225, 5.840472859108075],
            [0.4065693985908552, 5.872936409605137],
            [0.39756243013004233, 5.874229943979071],
            [0.3974832073543672, 5.933013054117703],
            [0.39773922447654964, 5.960037961711893]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.83897581363854, "lat": 44.41350701797454 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27083"],
        "coty_name": ["Lyon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lyon County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00659487"
      },
      "bbox": [
        0.3974832073543672, 5.526261369038486, 0.7541973035852917,
        5.960374024741841
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.42615779086464434, 5.179868581653042],
            [0.45822770626364384, 5.17983850390359],
            [0.49774386855841857, 5.179499760708834],
            [0.5190999992472672, 5.179785645519664],
            [0.533550050601524, 5.179408888105109],
            [0.6270532966367903, 5.179144929226118],
            [0.6413635073219822, 5.178989538114477],
            [0.705599428694339, 5.179440043539054],
            [0.770870117199243, 5.179396437087638],
            [0.8498916640887578, 5.179787022477253],
            [0.8570207090126011, 5.179869546646525],
            [0.8573590129645998, 5.136416896959332],
            [0.8578632793125494, 5.092888366264569],
            [0.8574092350387202, 5.0781143753754625],
            [0.8575928636137996, 5.005725626099833],
            [0.8571167870475233, 4.955011433297768],
            [0.8572867524939477, 4.878209257707528],
            [0.8576367296028983, 4.832202654228327],
            [0.8326619641279014, 4.831653956901072],
            [0.734489202833593, 4.831041837180704],
            [0.6444605975701208, 4.830778769978017],
            [0.5641368163100491, 4.830742637884935],
            [0.47941767903383786, 4.830684926325596],
            [0.42535691769137085, 4.830736905065652],
            [0.42555220204114547, 4.854579643409055],
            [0.4250079591407118, 4.918127643430854],
            [0.42560293084656214, 5.0484047826347815],
            [0.4258510940364686, 5.055927121896443],
            [0.4259310512425763, 5.120840063004995],
            [0.42615779086464434, 5.179868581653042]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.75337472393329, "lat": 43.67425261695061 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27105"],
        "coty_name": ["Nobles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nobles County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00659498"
      },
      "bbox": [
        0.4250079591407118, 4.830684926325596, 0.8578632793125494,
        5.179869546646525
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.138457695114488, 5.836885009163831],
            [3.145593195751448, 5.828361654464099],
            [3.158184497118737, 5.82194049761332],
            [3.1724510720184047, 5.8178044168918035],
            [3.1961452042607132, 5.812179499684616],
            [3.212534036722344, 5.8103092684196636],
            [3.2233531887950346, 5.808193663854813],
            [3.2332445091044812, 5.800441746058904],
            [3.243076431641813, 5.79836276804366],
            [3.2530578627280695, 5.794502807460532],
            [3.2567376952369793, 5.79233758929611],
            [3.268847128418601, 5.792092142834205],
            [3.2747189431902877, 5.789589712061335],
            [3.2801809217481264, 5.7828489636885125],
            [3.286211512874187, 5.777440139567003],
            [3.29993674899534, 5.770507665060719],
            [3.3076399807229153, 5.769240492731297],
            [3.313835189693234, 5.764846166357105],
            [3.323252065578041, 5.759402208207722],
            [3.329490476615551, 5.758918696370877],
            [3.335514924812099, 5.756646064642273],
            [3.3434406669657086, 5.750551413645488],
            [3.3509625893229584, 5.7402755185082786],
            [3.357201606057932, 5.732732029324435],
            [3.3667621549631908, 5.727640699577028],
            [3.3687216851271855, 5.725801559159336],
            [3.374152863409487, 5.715168993322356],
            [3.3782672332857473, 5.704078373169959],
            [3.3778147682620516, 5.700900376413072],
            [3.37134937147913, 5.689500557904134],
            [3.3712120781579604, 5.684220024536908],
            [3.374528949204346, 5.679047964693265],
            [3.385073875162895, 5.6746221646853146],
            [3.3903232804573107, 5.670409700054861],
            [3.3926750733801345, 5.666350625839855],
            [3.3928601068822, 5.656230632253886],
            [3.3980600289496774, 5.64964924409549],
            [3.399738435591665, 5.645437128106741],
            [3.399354507268368, 5.640050965882511],
            [3.3962333254940353, 5.628676392229273],
            [3.396597678583431, 5.624651122138885],
            [3.3988818619140697, 5.619934002976262],
            [3.4061025064803134, 5.610521184016277],
            [3.4091963196730006, 5.603679469427786],
            [3.4104432210980233, 5.594739091242793],
            [3.418307554420384, 5.5910808723215],
            [3.422743268511654, 5.587704418005036],
            [3.4053255092274384, 5.587100611935901],
            [3.379057139136161, 5.585765575296637],
            [3.3499174943361676, 5.584692856102231],
            [3.265120105237136, 5.581027567786081],
            [3.2684350369327837, 5.494944178138131],
            [3.226263774292044, 5.493701517197966],
            [3.182731340238079, 5.492110821085507],
            [3.097167115135003, 5.489135635525082],
            [3.0938028356144347, 5.575277365983143],
            [3.0012982506084978, 5.572192328672236],
            [2.928166289719661, 5.569949128842476],
            [2.9249437893713086, 5.656364521947906],
            [2.9219467275110826, 5.743122844582469],
            [2.953643051368297, 5.744042623121756],
            [3.0075109495748245, 5.746038066675692],
            [3.004484753920876, 5.832809734546045],
            [3.048164871094218, 5.834108271414037],
            [3.090538626167412, 5.835539119343673],
            [3.138457695114488, 5.836885009163831]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.23027715665836,
          "lat": 44.284302125665725
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27157"],
        "coty_name": ["Wabasha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wabasha County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00659523"
      },
      "bbox": [
        2.9219467275110826, 5.489135635525082, 3.422743268511654,
        5.836885009163831
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.496915785869849, -5.70350259489944],
            [5.576299265082487, -5.698499307641068],
            [5.602146500374972, -5.6966475084663335],
            [5.601038318902659, -5.69099326436587],
            [5.656075167512281, -5.687733962865267],
            [5.693011384182338, -5.685337453879681],
            [5.702465960259676, -5.826273917418837],
            [5.709405707081906, -5.9358541268663645],
            [5.704607042676056, -5.937285162896957],
            [5.700963508523696, -5.9447878171063895],
            [5.692545500322754, -5.951098078869374],
            [5.686666837990877, -5.958082298967073],
            [5.6853271938617675, -5.965026872164808],
            [5.681377073640799, -5.963882576141914],
            [5.677327717289992, -5.966103827855759],
            [5.680823629077075, -5.970449750092148],
            [5.677896892583395, -5.973049728925417],
            [5.668802125532811, -5.975467313976979],
            [5.669760684582051, -5.982996100360875],
            [5.66755293994093, -5.986046874957245],
            [5.663415086264212, -5.987328696877701],
            [5.664399398555173, -5.98113401277428],
            [5.661268422776642, -5.982237934275228],
            [5.660841466352927, -5.985983566329761],
            [5.657721731686828, -5.988756538633361],
            [5.65536821317712, -5.983770326791223],
            [5.648709417155397, -5.986257646272495],
            [5.648355798387008, -5.989351844677031],
            [5.641296747787737, -5.992147096135064],
            [5.639304117539291, -5.988079352598069],
            [5.63195394913505, -5.990661097892959],
            [5.627061138863201, -5.989199290624822],
            [5.620983601149394, -5.982753786997677],
            [5.619804363585164, -5.987337494097364],
            [5.6165844076245195, -5.992713277737725],
            [5.613509946591234, -5.993860696553324],
            [5.606409318897058, -5.9928105512546415],
            [5.60339221910427, -5.993937844219252],
            [5.6020660168320955, -6.007877774357267],
            [5.599750357935138, -6.012844467871839],
            [5.5963112309066325, -6.016603299935884],
            [5.591498137045959, -6.018347419418726],
            [5.583650917428727, -6.015182338546309],
            [5.581179509303153, -6.020073085018011],
            [5.5762108624432525, -6.024548156025406],
            [5.57901246723133, -6.0290110437212165],
            [5.577475407724748, -6.034321652886931],
            [5.56969084170866, -6.042205968057169],
            [5.565436987096424, -6.041842158069343],
            [5.563179859877725, -6.0442258800784945],
            [5.565311043746573, -6.047155390280512],
            [5.5650303474478475, -6.050982277264481],
            [5.554954846429062, -6.05139891954361],
            [5.5551840868587155, -6.055090008904387],
            [5.551922487173749, -6.065025519194867],
            [5.549206729029811, -6.06838268378434],
            [5.5403693753568675, -6.068052272258304],
            [5.538002165808659, -6.070970034356095],
            [5.537822759746048, -6.075443311574783],
            [5.530838219471754, -6.078858909111918],
            [5.529926172135351, -6.083578815720362],
            [5.527498978807581, -6.084680326727477],
            [5.524880530374356, -6.091016952574931],
            [5.522131987269247, -6.08792546932633],
            [5.517842579135341, -6.086403077660651],
            [5.515038229748249, -6.089524856838191],
            [5.5127508750609735, -6.086896893983701],
            [5.508135016402195, -6.0851531258376],
            [5.505919696078962, -6.092273164981244],
            [5.499734429079838, -6.101076572905549],
            [5.496151670043234, -6.097794381417176],
            [5.48825603289114, -6.09987450437418],
            [5.487943425243145, -6.104270275335749],
            [5.4822736030964645, -6.104890517776643],
            [5.477823880560385, -6.107998633946008],
            [5.478680170152501, -6.111535546730317],
            [5.473545517822537, -6.1139248610786385],
            [5.474317211323034, -6.117402921104724],
            [5.47287077073336, -6.1228149717722715],
            [5.469103594240247, -6.12620820735015],
            [5.461570094893592, -6.136871633543243],
            [5.465183269339004, -6.140396464251942],
            [5.4622228586036465, -6.144652265854624],
            [5.457555082481431, -6.148084806667105],
            [5.4538256851295435, -6.1491186340829485],
            [5.449746327882581, -6.1478020986838695],
            [5.448521945208782, -6.152077335686179],
            [5.439456590774131, -6.1491472915613565],
            [5.438040880927284, -6.154027182892346],
            [5.442809753815412, -6.165237627123942],
            [5.444954896442363, -6.167460048283649],
            [5.442774543630799, -6.171312549738682],
            [5.434960644002492, -6.170564888787776],
            [5.442612976295289, -6.18097179567441],
            [5.445248782657898, -6.183257764487373],
            [5.443894447372682, -6.188011167599769],
            [5.381014917406258, -6.191944718418933],
            [5.367989778737607, -6.1919688244704885],
            [5.301312815104571, -6.196297240536939],
            [5.294608962108747, -6.196580486655778],
            [5.289390586026068, -6.10932407423636],
            [5.2483299627419875, -6.111677070811798],
            [5.210138836863138, -6.114095228659195],
            [5.206632759283683, -6.113992559131626],
            [5.159443313726199, -6.116855033594859],
            [5.116660132142885, -6.1186894051247505],
            [5.115949014877441, -6.105023102172384],
            [5.1115037777293555, -6.03345488079784],
            [5.115859122478996, -6.02215798575879],
            [5.124867958319848, -6.020485988110357],
            [5.129421207660977, -6.020464800347551],
            [5.130848292591852, -6.022831123006558],
            [5.134765566801227, -6.022611323951339],
            [5.138308985406164, -6.0285878333805325],
            [5.140334718064885, -6.025658063865412],
            [5.145114670153899, -6.027176667767097],
            [5.149642627258214, -6.03018954029215],
            [5.150669254830582, -6.026892262512062],
            [5.154481480543127, -6.025095673863053],
            [5.154177736316883, -6.022041656613211],
            [5.162328192405227, -6.021366594770775],
            [5.161828426153391, -6.017307117934772],
            [5.166667898039089, -6.01538133342387],
            [5.167605782761598, -6.007985826740158],
            [5.177654974629379, -6.0062464337143915],
            [5.182318763654833, -6.004402084163428],
            [5.1810736644930975, -6.000552789684543],
            [5.185545468903922, -5.9983668221044795],
            [5.1880245227230795, -6.000592043492032],
            [5.190893084657698, -5.997809151688092],
            [5.192677276959295, -5.989303550315309],
            [5.1965306991649935, -5.989387010981147],
            [5.197697816608511, -5.996013478923923],
            [5.205235308797839, -5.995037475882278],
            [5.207579238975871, -5.9882657948510785],
            [5.215932903352764, -5.984830265904357],
            [5.215709149607892, -5.981249108931173],
            [5.221044252244484, -5.973939893065863],
            [5.220439253399736, -5.969311041595099],
            [5.224183189634875, -5.9642215840663715],
            [5.2235988266351825, -5.959812849258396],
            [5.230816468585133, -5.953594743305437],
            [5.236659570830408, -5.9530562924519606],
            [5.2378778501141685, -5.9557575321912],
            [5.245448579065855, -5.9540788737060595],
            [5.24636179823781, -5.948342665175489],
            [5.250315969536139, -5.938436137684341],
            [5.257266474087386, -5.9413235454191895],
            [5.261817294131995, -5.941377920945497],
            [5.263207701541609, -5.937653144333082],
            [5.267456730980678, -5.93496808168209],
            [5.276301654083266, -5.93720265761733],
            [5.280352320296306, -5.932536287608886],
            [5.286518725838715, -5.929928853875317],
            [5.291425357088758, -5.929514992032561],
            [5.2948500596157055, -5.931946879354044],
            [5.297276794743548, -5.936223127817601],
            [5.29998461603193, -5.932801659883732],
            [5.3029260631247634, -5.933758016279135],
            [5.30920526738191, -5.929019058055022],
            [5.317013102108404, -5.930979382354621],
            [5.321315863197162, -5.925817253288624],
            [5.327238898890764, -5.920671332336204],
            [5.332254725273336, -5.915073986183582],
            [5.336031356263049, -5.913683746312242],
            [5.345680190550715, -5.906931260752563],
            [5.3500722400103635, -5.905524687829325],
            [5.351836734748573, -5.90101390932912],
            [5.360607916798229, -5.9024810030812604],
            [5.364852149805144, -5.904547106815256],
            [5.366439028837294, -5.893005497885775],
            [5.370234854547948, -5.889143131523084],
            [5.371674433611963, -5.891685129496537],
            [5.377283306221944, -5.890899794426106],
            [5.377760626343654, -5.888792211243075],
            [5.383254154553704, -5.889118305506146],
            [5.383262711690263, -5.8861623724131755],
            [5.388232174468576, -5.887145003817046],
            [5.391751898881551, -5.886102582852226],
            [5.39669564363839, -5.889581553100291],
            [5.403785268859675, -5.880624324703033],
            [5.403993328078419, -5.874481789802679],
            [5.411368173565773, -5.8672902878272355],
            [5.414541790859976, -5.859145619866961],
            [5.429879861919844, -5.856499433167633],
            [5.430383476141551, -5.853664652546849],
            [5.436627611659382, -5.85161005122652],
            [5.438240584476264, -5.843837920583245],
            [5.4416755021517655, -5.8428033186092865],
            [5.44392731534388, -5.839152206582216],
            [5.443165085104744, -5.834548199127048],
            [5.444212504305079, -5.828980741788001],
            [5.449000152519997, -5.826512492455922],
            [5.448277209214566, -5.82327666465561],
            [5.450566934785025, -5.8157890546968485],
            [5.449631382833726, -5.8105548000662885],
            [5.4539053409577996, -5.80794268393265],
            [5.452666024452837, -5.80528257009452],
            [5.456659468884095, -5.7924405988192005],
            [5.455927982551615, -5.787009694713255],
            [5.459028360320886, -5.782454722779823],
            [5.455981519387613, -5.780635903884915],
            [5.457801608073718, -5.773039978809206],
            [5.456481281787602, -5.767788087746915],
            [5.4572197904041015, -5.758755175784663],
            [5.460269880821944, -5.754009248992648],
            [5.463156704331365, -5.757421785910549],
            [5.470576210053797, -5.754438062570507],
            [5.475194265456166, -5.750584819741513],
            [5.475470015764442, -5.7474199584509265],
            [5.479200156238593, -5.739801616623717],
            [5.476450530193521, -5.738207409303326],
            [5.48195595637063, -5.731136896441984],
            [5.482565817351933, -5.7249624744536876],
            [5.485104050819288, -5.721983614396378],
            [5.484977615194158, -5.7176630883346355],
            [5.491135631252503, -5.716583139157372],
            [5.491653417609387, -5.711143430509772],
            [5.496915785869849, -5.70350259489944]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.03371848509514,
          "lat": 32.634745711085415
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28089"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00695768"
      },
      "bbox": [
        5.1115037777293555, -6.196580486655778, 5.709405707081906,
        -5.685337453879681
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.5935849553313535, -4.896586154597298],
            [5.645144667336549, -4.892993956793279],
            [5.6808563178827916, -4.890301067619542],
            [5.695234276464433, -4.889562135290605],
            [5.731650166418356, -4.886227899384396],
            [5.824369004609374, -4.880309671534366],
            [5.830222258358992, -4.960359943247831],
            [5.833211244229358, -5.003488980455669],
            [5.839652663611051, -5.098284264200786],
            [5.846787336520315, -5.097500094005086],
            [5.900946324842876, -5.09384747114177],
            [5.943272087232042, -5.090649734316056],
            [5.941777614961307, -5.09569902858038],
            [5.934048814324905, -5.097977744756895],
            [5.929882685756971, -5.097516574697123],
            [5.92650121389369, -5.1018577029112],
            [5.920392688853433, -5.106026381904734],
            [5.919409079418336, -5.108289037420743],
            [5.919941492822414, -5.1163912017065964],
            [5.914933042656983, -5.120570572411883],
            [5.90951879727591, -5.121886395704145],
            [5.904455767913812, -5.117810459516685],
            [5.890773614405089, -5.1148583503782605],
            [5.884847467224482, -5.121937714420034],
            [5.895250929525607, -5.269223620483609],
            [5.756767102636154, -5.2788547474668635],
            [5.7366517526726994, -5.28038742771815],
            [5.730545551199903, -5.199531079891918],
            [5.7279244843828065, -5.1633735375802035],
            [5.670609634328877, -5.167654657132248],
            [5.6694530300080475, -5.152957783242083],
            [5.612094212150045, -5.157212943108536],
            [5.608757396230402, -5.114378275910112],
            [5.608299601284572, -5.099331871146334],
            [5.603331155850375, -5.030288934337502],
            [5.598507873294599, -4.956513568369129],
            [5.5935849553313535, -4.896586154597298]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.6163939283774, "lat": 33.49409577682794 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28097"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00711757"
      },
      "bbox": [
        5.5935849553313535, -5.28038742771815, 5.943272087232042,
        -4.880309671534366
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.988904988273805, -4.162282964364114],
            [6.049941364609894, -4.157601331334157],
            [6.095557605411282, -4.153878123549816],
            [6.153053660104528, -4.149652444705328],
            [6.24813095904104, -4.143428978836608],
            [6.249496759168651, -4.157803928501909],
            [6.319173391011364, -4.152498769832384],
            [6.334102856147966, -4.1517117091151805],
            [6.336356222090835, -4.179204457961036],
            [6.335824858322578, -4.180182092694736],
            [6.340798628785959, -4.244944737392708],
            [6.351039369412193, -4.369042435585397],
            [6.3564942686844965, -4.442107081521715],
            [6.213333130398236, -4.452959749196002],
            [6.212631311477004, -4.453221912741274],
            [6.098624688167854, -4.461963801309943],
            [6.012317966625448, -4.468313210844973],
            [6.008157006005997, -4.417635542613638],
            [6.007890170959405, -4.417093441045977],
            [6.005215148236769, -4.380941948697632],
            [6.000132490012548, -4.314702973476103],
            [5.992104700756294, -4.2079220916338995],
            [5.988904988273805, -4.162282964364114]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.0373913773344, "lat": 34.225433349259575 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28115"],
        "coty_name": ["Pontotoc"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pontotoc County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00695803"
      },
      "bbox": [
        5.988904988273805, -4.468313210844973, 6.3564942686844965,
        -4.143428978836608
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5475546605002561, -1.0502055131931156],
            [1.5951010582005032, -1.0504485987623455],
            [1.6972508671786783, -1.0515289320468395],
            [1.731707812758727, -1.0517766339850387],
            [1.734910643667396, -1.0520653996997553],
            [1.8092000863243731, -1.0526555739094139],
            [1.8553183204678543, -1.0532850302865244],
            [1.9034398163776056, -1.0542774865304818],
            [1.9743219153793532, -1.0567674175439568],
            [1.9740519138926431, -1.1154969487150572],
            [1.9741395425344583, -1.1445940785085473],
            [1.9741300361252372, -1.233108344605364],
            [1.973961574455291, -1.3210148970821358],
            [1.9735292978758916, -1.3500547872779445],
            [1.9016941107936711, -1.3492473648374501],
            [1.8152329044927675, -1.3484892217028641],
            [1.7930379619987176, -1.3478660390630657],
            [1.7288003247456671, -1.3473844034537221],
            [1.7288115308752554, -1.3469298750661998],
            [1.6790601834999594, -1.3462985815163824],
            [1.6572166373845976, -1.3455446358779988],
            [1.631106588051278, -1.3441129733371906],
            [1.583757867663169, -1.342906328486385],
            [1.551834951917916, -1.3423555481917457],
            [1.5511694517165564, -1.295173608647183],
            [1.551042818860312, -1.2659876876471376],
            [1.550564232283381, -1.2358593648138703],
            [1.5501119852014944, -1.1835190827281983],
            [1.5493304470655898, -1.1512452679085698],
            [1.5475546605002561, -1.0502055131931156]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.34711927242743, "lat": 37.50231047933651 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29011"],
        "coty_name": ["Barton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barton County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00758460"
      },
      "bbox": [
        1.5475546605002561, -1.3500547872779445, 1.9743219153793532,
        -1.0502055131931156
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.684316911279043, -4.897310082374865],
            [7.678742854552024, -4.893973740172755],
            [7.676516369434436, -4.890069090147435],
            [7.677525664314302, -4.883321388222503],
            [7.680001186854749, -4.880181256023538],
            [7.684874727869319, -4.880977227465355],
            [7.687251206668651, -4.883759611086567],
            [7.6903938483251615, -4.891880280980078],
            [7.693032886592258, -4.894655451063044],
            [7.698557183412543, -4.894368110818039],
            [7.70292771425437, -4.887009425622495],
            [7.705373135449783, -4.879564608814521],
            [7.70500042156065, -4.872034514273904],
            [7.710161983932751, -4.868276955963117],
            [7.721356566209818, -4.870443694903386],
            [7.725826478207632, -4.869855591347696],
            [7.728823909841342, -4.867210570347932],
            [7.73590483574677, -4.8563305111543675],
            [7.73792393305177, -4.854852764565987],
            [7.746104659718462, -4.85275694207859],
            [7.747197876197113, -4.848227521127158],
            [7.744948428703446, -4.846057607356672],
            [7.7374282815296365, -4.842563646544007],
            [7.73055845879188, -4.833000420642806],
            [7.729585232237266, -4.82672613011476],
            [7.734212421830834, -4.815702713036069],
            [7.733979413649594, -4.8056547092568715],
            [7.748288842976618, -4.804393407648359],
            [7.747036707247972, -4.789875596772344],
            [7.775903649740958, -4.787583986496735],
            [7.774468218599225, -4.772807409771025],
            [7.817090491869926, -4.769177554177938],
            [7.814382233756165, -4.740172894238295],
            [7.8431818098526485, -4.7379840201569845],
            [7.840842720384454, -4.70885459795728],
            [7.855213539669783, -4.707619645138991],
            [7.850383740784824, -4.6640980701267125],
            [7.8578269476587, -4.663386233675703],
            [7.8563424456865025, -4.648730642664234],
            [7.863202991923825, -4.648158820437703],
            [7.86049048513019, -4.619016380325825],
            [7.874797471628591, -4.617820483182665],
            [7.87333921049286, -4.603167791642335],
            [7.902191246640772, -4.601214475546979],
            [7.900525737525784, -4.586496180939982],
            [7.914949147001239, -4.585557661406215],
            [7.913610457669784, -4.5710437813747795],
            [7.927670958377126, -4.5696913141843085],
            [7.9681530827948235, -4.53764725669984],
            [8.03479195581015, -4.533232177985448],
            [8.070826452581985, -4.53037558414022],
            [8.079231147971216, -4.535505029594664],
            [8.10455477667441, -4.550079356337722],
            [8.167136794614859, -4.586605323141053],
            [8.16882483981265, -4.589056477851016],
            [8.169614017266184, -4.596104022014167],
            [8.196972782122698, -4.594117386632032],
            [8.227132798676983, -4.591008005170117],
            [8.2559238557585, -4.588292531865429],
            [8.258974725723393, -4.617792434963869],
            [8.266248059939073, -4.617245898738307],
            [8.26760294736248, -4.631414185591318],
            [8.274851589223669, -4.630740298167082],
            [8.27682354305319, -4.65270705654653],
            [8.280351549036629, -4.688310201304593],
            [8.282080005587698, -4.703191146019148],
            [8.27491308397649, -4.7037206424365525],
            [8.276473020298395, -4.7182011907741455],
            [8.268962728627706, -4.718956860172037],
            [8.270451082486968, -4.733466157383528],
            [8.263387391218147, -4.734040525119749],
            [8.268746636366169, -4.792961108100716],
            [8.276068916558085, -4.792083761887027],
            [8.276828583692794, -4.79927651852964],
            [8.298536148341768, -4.797703984294459],
            [8.299241415296613, -4.80505532199743],
            [8.30109395320449, -4.826940085674046],
            [8.279688633019235, -4.828621566697185],
            [8.280242064885533, -4.83592286371985],
            [8.265983762236152, -4.837113986278824],
            [8.266591610077727, -4.843991222538026],
            [8.259370767386438, -4.844741100164634],
            [8.259988199145011, -4.851987298846455],
            [8.256293052963665, -4.852450538672465],
            [8.256752146322816, -4.856147905585795],
            [8.253915668235505, -4.8598794986032],
            [8.246378490106395, -4.8606754996180435],
            [8.247794260103223, -4.875156255408141],
            [8.240579489681636, -4.87596095284774],
            [8.24132932313855, -4.883102686230832],
            [8.234072386879442, -4.8839673330780045],
            [8.234739397023342, -4.891011243317946],
            [8.177259638914075, -4.897280810139562],
            [8.178691445008583, -4.912042917680196],
            [8.164182067203702, -4.913238744973859],
            [8.16483902991847, -4.920576439370449],
            [8.161362378257303, -4.920853169245241],
            [8.161687004132936, -4.924416997962368],
            [8.158137203593085, -4.924764228694459],
            [8.159404233317076, -4.935207087034889],
            [8.145044185838211, -4.936461943402478],
            [8.146356750864527, -4.950918662502252],
            [8.118533448091728, -4.952730439047856],
            [8.117947408944863, -4.953966646328308],
            [8.119588780116938, -4.9709747782375135],
            [8.11615293873714, -4.974368539510255],
            [8.112620510741202, -4.975467637305728],
            [8.113494340316342, -4.982326470200807],
            [8.099095773872692, -4.983453831232786],
            [8.101041587771546, -5.005144154333455],
            [8.079686265166638, -5.00658298321463],
            [8.079968846625272, -5.0107153359729795],
            [8.073205396356581, -5.0111260984616965],
            [8.07293911276753, -5.014264460655634],
            [8.058901489237192, -5.01537520932593],
            [8.061452924195441, -5.044100445576381],
            [8.018530918649406, -5.047273252497465],
            [8.019212975921823, -5.054575583873649],
            [8.01199512540542, -5.055122007692988],
            [8.012617944149184, -5.062249521175209],
            [8.009217239621943, -5.062540831946335],
            [8.006028230872916, -5.066497913671869],
            [8.006472564269618, -5.073813529097055],
            [8.001168135883924, -5.0743802179343485],
            [7.99986589902635, -5.0782803700596695],
            [7.992640782853373, -5.079135764574206],
            [7.992462716626261, -5.082710771542115],
            [7.989177719489652, -5.08298201976618],
            [7.9894639328742265, -5.086755429363274],
            [7.986012542910412, -5.087084714800007],
            [7.987748863789463, -5.105422396813256],
            [7.980781594430506, -5.10608663419971],
            [7.981053879647198, -5.10959016183841],
            [7.970201790052049, -5.110836042622713],
            [7.970914268166626, -5.118151310047916],
            [7.952884218458481, -5.11950321387007],
            [7.953529619630696, -5.126806555404784],
            [7.949882587099417, -5.127200985838262],
            [7.950099511358374, -5.1307256554509255],
            [7.946694078574521, -5.131423318280578],
            [7.943376545387952, -5.134988924098371],
            [7.943924576951496, -5.141973854041603],
            [7.907523985350712, -5.144960085222561],
            [7.875313639038354, -5.14754008312291],
            [7.872557382323048, -5.11856340566833],
            [7.865207573015504, -5.119171656594145],
            [7.864888157220252, -5.115511547465351],
            [7.854187700926161, -5.116530742156704],
            [7.853190473888546, -5.10553674243508],
            [7.820719395986421, -5.108401538857653],
            [7.818976730071964, -5.093287102810026],
            [7.790104929260745, -5.095396221742397],
            [7.788617633574488, -5.081006642868124],
            [7.774176411374807, -5.0822460343762135],
            [7.771832247565928, -5.060439904350186],
            [7.75743897621586, -5.061658075074532],
            [7.755898055861361, -5.046651530741137],
            [7.741562884225485, -5.047792191516363],
            [7.740942759871771, -5.040313574097927],
            [7.72675309231079, -5.041570167611534],
            [7.723998825449698, -5.012326131734357],
            [7.7097009807120545, -5.013193285401615],
            [7.708832464096598, -4.998316083822541],
            [7.704663359836861, -4.998824379136304],
            [7.70394749994614, -4.991330365718624],
            [7.693042206184466, -4.992198198348076],
            [7.6925402068937805, -4.985438885602255],
            [7.6780529960330846, -4.985754072773979],
            [7.676609285078982, -4.970907409159221],
            [7.651719964954661, -4.972034290192777],
            [7.650664366520489, -4.958016877238941],
            [7.6329068577183135, -4.959111310326243],
            [7.6316591733364145, -4.944942680922723],
            [7.626550869612625, -4.945335229296402],
            [7.629813019716311, -4.940107151950569],
            [7.633386465830556, -4.929576663104191],
            [7.633366020028806, -4.924171663961989],
            [7.63648253389763, -4.921684332443297],
            [7.640677038998024, -4.922323368439817],
            [7.6473549044971065, -4.9265688246237636],
            [7.65225866531523, -4.923604340179764],
            [7.6581855441484254, -4.924500247886179],
            [7.660885024024027, -4.9309509155061155],
            [7.663378028313976, -4.933018816426109],
            [7.669614305445119, -4.932479209258646],
            [7.6719740302193085, -4.930098059507559],
            [7.671895678761503, -4.92579731752029],
            [7.668096944192719, -4.916852248432268],
            [7.667812343527384, -4.911739055057748],
            [7.670031735370799, -4.9093494698307065],
            [7.676849458390486, -4.909407696933112],
            [7.684665505584955, -4.913183158323562],
            [7.688419169007558, -4.911650638214336],
            [7.690451617984983, -4.906078650462503],
            [7.6895362525307505, -4.903295256473964],
            [7.684316911279043, -4.897310082374865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.89640081711333, "lat": 33.55432130246521 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01073"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00161562"
      },
      "bbox": [
        7.626550869612625, -5.14754008312291, 8.30109395320449,
        -4.53037558414022
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.498441342620575, -3.7873181454712674],
              [8.4948328703597, -3.7875449061352597],
              [8.495182072676412, -3.791274926001415],
              [8.498818103377419, -3.7907985392558645],
              [8.498441342620575, -3.7873181454712674]
            ]
          ],
          [
            [
              [8.171737713677363, -3.808063382059276],
              [8.171429932953965, -3.81260667978605],
              [8.186545432433645, -3.839308574131533],
              [8.18863776797328, -3.848512970638837],
              [8.194441204422764, -3.8539324718108503],
              [8.218935760576596, -3.8677160428390085],
              [8.230059632482286, -3.868939242499373],
              [8.239121582124486, -3.868249026174602],
              [8.244955268397964, -3.871820199483661],
              [8.249571105086048, -3.8686930650644147],
              [8.256231690845743, -3.862452747977306],
              [8.25957857735021, -3.861554095116817],
              [8.271590677271611, -3.861271818789188],
              [8.274517046473113, -3.8632909005372227],
              [8.281103097120752, -3.8642109507524296],
              [8.287350126763373, -3.853041620340885],
              [8.288953625016292, -3.848685275707025],
              [8.29513016962819, -3.8450940641037414],
              [8.299535068193634, -3.846821294828045],
              [8.307431221379765, -3.8412039765717343],
              [8.308265398985759, -3.835073722955663],
              [8.304010685747103, -3.8330992501697145],
              [8.304875299290316, -3.8269688895392884],
              [8.3100789102548, -3.8194668025050813],
              [8.317741262796671, -3.8225584778174313],
              [8.321094312324636, -3.825335477561525],
              [8.324414112651485, -3.824285856014857],
              [8.327355398205551, -3.819460776436977],
              [8.331019902129034, -3.8178632148057594],
              [8.332262338695475, -3.8146461223654335],
              [8.34581858104095, -3.8244179596571755],
              [8.350918158566977, -3.8267935933894277],
              [8.35421683627032, -3.8228804096845694],
              [8.353982289554846, -3.817649618952221],
              [8.356903025708737, -3.806415717029911],
              [8.363741468325511, -3.7977484661036414],
              [8.366685625284134, -3.795171876358035],
              [8.36432943409007, -3.7866565419400704],
              [8.364792437447596, -3.7805421120575438],
              [8.368173989823662, -3.7733185997900422],
              [8.366271334947648, -3.7705550477275445],
              [8.362400695366013, -3.7716124965629745],
              [8.355429343678818, -3.7701585965167794],
              [8.348366070847279, -3.7699532001903577],
              [8.346757328312107, -3.7628393680525534],
              [8.350685186525682, -3.7634999506563456],
              [8.354178703276029, -3.758795538911342],
              [8.36029998108857, -3.7581489096595546],
              [8.369132465956577, -3.754129387377616],
              [8.36582809998517, -3.751870975629193],
              [8.365326736441949, -3.7482391196340243],
              [8.36775371644311, -3.741107397632663],
              [8.361383537873072, -3.7389212603000983],
              [8.356394411331108, -3.735142534613532],
              [8.350340165563233, -3.7371231888186354],
              [8.347792725713957, -3.736297736957914],
              [8.347672512503792, -3.735965140761715],
              [8.394613661753805, -3.730848357985237],
              [8.420683581187191, -3.728207510221853],
              [8.492706340327402, -3.72172988502172],
              [8.49706383194287, -3.771163888267131],
              [8.49242765446408, -3.7711847585564464],
              [8.502970836451244, -3.7792232147143614],
              [8.50299170706465, -3.7862126423923304],
              [8.498441342620575, -3.7873181454712674],
              [8.50657164152654, -3.7868147465632327],
              [8.501428837702806, -3.799881414496202],
              [8.503279497648716, -3.800592402984718],
              [8.507946883889147, -3.7954666149442593],
              [8.514703974024645, -3.7897125346648544],
              [8.517517418634986, -3.785672761375064],
              [8.520435648536543, -3.791324107815396],
              [8.523976058582978, -3.793932073543871],
              [8.528201690301998, -3.788541336574757],
              [8.532965296495696, -3.790869794259076],
              [8.530947198326768, -3.7949911125291145],
              [8.532042851731024, -3.7971060164008863],
              [8.536973589796055, -3.7983407281745407],
              [8.540256269789195, -3.7952636044062156],
              [8.54313808057251, -3.802720245087765],
              [8.538165603584241, -3.8105469783516357],
              [8.542119906557975, -3.8125254259172645],
              [8.543985755262193, -3.8168949852361997],
              [8.542565736929028, -3.8195734867040443],
              [8.54506482333094, -3.82258747489856],
              [8.546754236646382, -3.8276943640338286],
              [8.553545227266197, -3.8329734812657112],
              [8.554933966610093, -3.837645331520554],
              [8.553795564412361, -3.845119386960076],
              [8.556015153042742, -3.849158267037774],
              [8.560191340351494, -3.8508305389241153],
              [8.56679443547832, -3.847890174849434],
              [8.569934855191267, -3.8434446551859773],
              [8.573974133467605, -3.841631373836483],
              [8.579355774310239, -3.8371741962606674],
              [8.541580980586089, -3.8898600944874793],
              [8.544364015348393, -3.913766797310039],
              [8.537142767254881, -3.91454109037465],
              [8.538332739719312, -3.9253997270946317],
              [8.54550429082647, -3.9246912828318017],
              [8.547317277306965, -3.9424823050224345],
              [8.554841761613783, -4.002372682138876],
              [8.565658314786187, -4.09146823131083],
              [8.568839534020324, -4.11653935750674],
              [8.57074826246026, -4.131019017288178],
              [8.520369209379473, -4.135005490029184],
              [8.509278172301382, -4.141284713967694],
              [8.503780056495938, -4.140536344238282],
              [8.494253295109399, -4.148251123921117],
              [8.41810798664737, -4.234829994921245],
              [8.413681020345797, -4.230368338905896],
              [8.407015028857735, -4.221931358191365],
              [8.40052460079373, -4.218080398276864],
              [8.365420326440013, -4.182189003135135],
              [8.349355331374078, -4.166339602706064],
              [8.321103528043906, -4.137666295342852],
              [8.2949715443758, -4.105565493297321],
              [8.287360717185564, -4.095509625980821],
              [8.286958163034301, -4.086435502991848],
              [8.279686616973654, -4.086962766511806],
              [8.276618633953262, -4.08317404140705],
              [8.27970546308029, -4.071580585408673],
              [8.272739124501252, -4.072259541147552],
              [8.271428055748473, -4.057651190036744],
              [8.257087860438102, -4.058879388915004],
              [8.255312749328654, -4.045516541586996],
              [8.192890054055843, -4.050694907073507],
              [8.169968886080005, -4.052071161779828],
              [8.169389179839856, -4.044486419265966],
              [8.163849786551738, -3.985586811059492],
              [8.164474988603567, -3.9688282045555083],
              [8.166284864506034, -3.908063164848809],
              [8.167116428785794, -3.885584515778893],
              [8.170212396504644, -3.8142927068476085],
              [8.169785958984406, -3.81032188649723],
              [8.171737713677363, -3.808063382059276]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.30664931396376,
          "lat": 34.366960684994524
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01095"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00161574"
      },
      "bbox": [
        8.163849786551738, -4.234829994921245, 8.579355774310239,
        -3.72172988502172
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.841069033320986, -5.494894309521547],
            [6.8423144250000805, -5.412452534531228],
            [6.844745476693875, -5.300662058868121],
            [6.84475914950341, -5.281353900601051],
            [6.845564803878848, -5.263589754367048],
            [6.846802077649493, -5.19570655326713],
            [6.8479073644772, -5.1344856603181865],
            [6.84957194690626, -5.041221418609288],
            [6.8508297221097845, -4.96987349185781],
            [6.85137829409133, -4.948115531989753],
            [6.871698014081738, -4.94691674832923],
            [6.874827356652329, -4.947169234166837],
            [7.0108806829892485, -4.94012714504401],
            [7.036751939056514, -4.939452510314038],
            [7.077465298869124, -4.937082420673227],
            [7.122874927018694, -4.935620995314469],
            [7.195319419319248, -4.928187107631502],
            [7.210106402101874, -4.927411045454684],
            [7.21127620975804, -4.940703511082865],
            [7.218826421219411, -5.0100701969239445],
            [7.225490028345238, -5.081642383046241],
            [7.228990476234547, -5.12358919515982],
            [7.2298073514349115, -5.130544057265454],
            [7.233089032952948, -5.167748942922327],
            [7.235485923556345, -5.197966063396793],
            [7.236238840100669, -5.202952741718482],
            [7.244770141469402, -5.298042887007384],
            [7.243073800146023, -5.301762345358847],
            [7.236939666002797, -5.3052401400257345],
            [7.2299061832594855, -5.312758481218893],
            [7.225602495621699, -5.309278939356758],
            [7.221079546242658, -5.313493722192263],
            [7.213466479444904, -5.315252011383973],
            [7.207440127811682, -5.322950541555601],
            [7.203261697212657, -5.325401637540616],
            [7.197421299819084, -5.325966219141021],
            [7.1931477860559, -5.328101957663153],
            [7.19147450948664, -5.3335678311755705],
            [7.185223683537446, -5.3333154614598115],
            [7.175970952034631, -5.340249886513707],
            [7.172384699431545, -5.341382657315572],
            [7.168528532065388, -5.345212327826193],
            [7.164949491228824, -5.345376617591962],
            [7.162751950026518, -5.348926706879207],
            [7.1579892523089645, -5.351196173881809],
            [7.155545653125357, -5.356127444979943],
            [7.155729473144262, -5.361202567296956],
            [7.153241800084667, -5.368279305878687],
            [7.143255847470382, -5.3772797816249005],
            [7.142395173013644, -5.383180726353412],
            [7.128124214351469, -5.383813725255813],
            [7.125238441457584, -5.388365272226252],
            [7.119738113368864, -5.389453126495642],
            [7.118077954505383, -5.391574513078008],
            [7.112928491244678, -5.389862178020146],
            [7.110989967851426, -5.392763919399079],
            [7.107625381922542, -5.392492166571872],
            [7.106486842812772, -5.396526214414154],
            [7.095499231769787, -5.4005045133283485],
            [7.092518844911723, -5.406696240021331],
            [7.093993052159587, -5.411249214824977],
            [7.091283750587181, -5.412282249794948],
            [7.088525678825409, -5.407606367323449],
            [7.0858994914312206, -5.4120618243955],
            [7.09338769380096, -5.4227013510786835],
            [7.09157557765334, -5.424396222413476],
            [7.085208183872636, -5.4246500190520655],
            [7.085242548593476, -5.428309762698411],
            [7.081392328023971, -5.429828760252336],
            [7.076497661102592, -5.429498376834275],
            [7.07239316397439, -5.4271926164652955],
            [7.070643544647091, -5.42395240337859],
            [7.0655017376076525, -5.4193138078873],
            [7.064824050831238, -5.416123854299246],
            [7.059486433976127, -5.417004683780318],
            [7.053840842453432, -5.41583966697218],
            [7.052347286069156, -5.4191660111671345],
            [7.058262008762933, -5.423533977260991],
            [7.052186952017347, -5.42618170867325],
            [7.053348319095831, -5.430529792403583],
            [7.048593606771241, -5.432652150526858],
            [7.0437680409947285, -5.430429023686008],
            [7.042039625264866, -5.433405517873087],
            [7.037797747977485, -5.434059077480105],
            [7.0343288053870845, -5.432551245877389],
            [7.031947854093449, -5.434246516441244],
            [7.023944723988863, -5.429109719379926],
            [7.019816812470242, -5.429223103389985],
            [7.014528371119684, -5.431455888328804],
            [7.012986988070845, -5.435083714205566],
            [7.007471664254029, -5.435743336574405],
            [7.005384821958648, -5.431953771142103],
            [7.00113554956957, -5.432256137583437],
            [6.995426023399448, -5.4379754119255965],
            [7.002532984607948, -5.4469263035345055],
            [6.992798214182549, -5.454010312946882],
            [6.985700688762398, -5.455052882068974],
            [6.986545582014896, -5.4583919964393255],
            [6.9830395291443565, -5.461903985305889],
            [6.979994305626445, -5.47124899724576],
            [6.980728153467694, -5.478857865554115],
            [6.883835787467063, -5.4897159181237685],
            [6.879636947618028, -5.490021486370889],
            [6.841069033320986, -5.494894309521547]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.08870201099694, "lat": 33.28077992844012 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01107"],
        "coty_name": ["Pickens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pickens County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00161580"
      },
      "bbox": [
        6.841069033320986, -5.494894309521547, 7.244770141469402,
        -4.927411045454684
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.29316357424174, -12.582027160191403],
              [-18.290304940142804, -12.581551915365933],
              [-18.289404743431554, -12.582228684983033],
              [-18.286010683559674, -12.5833801807919],
              [-18.28491801668579, -12.58579817318299],
              [-18.286139587655477, -12.587289294998811],
              [-18.290383977482463, -12.585417753825034],
              [-18.29316357424174, -12.582027160191403]
            ]
          ],
          [
            [
              [-18.299529047393516, -12.637094269379508],
              [-18.297893508828693, -12.635303687191337],
              [-18.295810483470117, -12.63448395986463],
              [-18.291842055703775, -12.634654103315073],
              [-18.290949585396866, -12.633132528601873],
              [-18.29172745946392, -12.632088913545278],
              [-18.292070560328217, -12.630424198238325],
              [-18.289933378425193, -12.630684609417964],
              [-18.28971598593855, -12.631543974911938],
              [-18.288310655914955, -12.632542484149583],
              [-18.286470244005674, -12.628801892165786],
              [-18.28942855806174, -12.628618449131581],
              [-18.290669430046236, -12.629129722668695],
              [-18.292796588773474, -12.628168322461132],
              [-18.295234527226427, -12.62807090578857],
              [-18.294254247102895, -12.62665056849868],
              [-18.29287645058916, -12.626805041923747],
              [-18.29118957856248, -12.625533646304016],
              [-18.289141031764927, -12.624523919156818],
              [-18.28575612240287, -12.6212330317867],
              [-18.28352246508362, -12.623230514469759],
              [-18.283041711580886, -12.624390129117947],
              [-18.284123350401646, -12.625896508320151],
              [-18.28353443249394, -12.629263858324386],
              [-18.28218423965462, -12.630350988749695],
              [-18.278420490371857, -12.631250325331163],
              [-18.277004339980174, -12.630938518989705],
              [-18.274947655035884, -12.629225463276839],
              [-18.273817708781017, -12.628890984686642],
              [-18.271538856487123, -12.62976778379952],
              [-18.270694097453447, -12.631189350429594],
              [-18.2715727617521, -12.63257235663194],
              [-18.270492336913826, -12.635837289331361],
              [-18.271664836264097, -12.637291958956464],
              [-18.273668615714264, -12.64191309414046],
              [-18.27666485391246, -12.644539110568992],
              [-18.27826940601233, -12.646569991102348],
              [-18.280606594465763, -12.64756077371085],
              [-18.282067572470634, -12.648993665940546],
              [-18.283857639565152, -12.649745352293234],
              [-18.28560258706825, -12.649937898795283],
              [-18.286908221031897, -12.650632922426105],
              [-18.289065860710867, -12.64999661191769],
              [-18.289993563886068, -12.65076802965792],
              [-18.291041943022986, -12.650076975811997],
              [-18.292030832494998, -12.650421838980721],
              [-18.29389042302445, -12.648496083700936],
              [-18.2944109131796, -12.644894949480573],
              [-18.29578116296766, -12.644038494799352],
              [-18.29631328105149, -12.642919442447386],
              [-18.296043299552178, -12.640224412603052],
              [-18.299912876666436, -12.637672839906767],
              [-18.299529047393516, -12.637094269379508]
            ]
          ],
          [
            [
              [-18.3117758175234, -12.577706581173794],
              [-18.30826330759751, -12.577986950122234],
              [-18.305771648232085, -12.577905584992315],
              [-18.309410427839858, -12.580274641776581],
              [-18.3117758175234, -12.577706581173794]
            ]
          ],
          [
            [
              [-18.32377863154313, -12.59415204831658],
              [-18.32145803113601, -12.593872356016519],
              [-18.319847605481648, -12.592367420153996],
              [-18.3209572003224, -12.591344443739311],
              [-18.320158813843566, -12.589821068554627],
              [-18.31833769610835, -12.589780722147932],
              [-18.317924672273882, -12.587153068392416],
              [-18.31732452642873, -12.585707509292835],
              [-18.314202231330643, -12.585538008938334],
              [-18.3134998621286, -12.584007254949395],
              [-18.315658951160113, -12.58182770055693],
              [-18.317448278729117, -12.580937490882022],
              [-18.318086710599825, -12.579439980314396],
              [-18.31663504075293, -12.579229950290312],
              [-18.314472679163263, -12.581363053089172],
              [-18.30893388699028, -12.583718638442601],
              [-18.308037553607257, -12.582716886514996],
              [-18.306001655351327, -12.581805720277478],
              [-18.301180248543947, -12.581301818889232],
              [-18.3001254378365, -12.582411775209795],
              [-18.296091469580887, -12.583336399857595],
              [-18.295609042688184, -12.586174106671038],
              [-18.294750871906714, -12.587361623686242],
              [-18.294707872908326, -12.588578212697005],
              [-18.296555570858757, -12.591840392583514],
              [-18.297133420530233, -12.59188809694079],
              [-18.298357883725288, -12.589924474750594],
              [-18.300081138862552, -12.589368251615081],
              [-18.30342693563568, -12.587049825561582],
              [-18.304360353480476, -12.587349034724769],
              [-18.304911497097258, -12.588798929020237],
              [-18.304255635301374, -12.590111527169725],
              [-18.306623623498762, -12.593844974765002],
              [-18.305250835998475, -12.595168239994347],
              [-18.302804850315926, -12.594521457912455],
              [-18.299762494916738, -12.598217801515469],
              [-18.301674191373884, -12.600495451998642],
              [-18.300106250801537, -12.601787201711131],
              [-18.298648729446366, -12.601528308803225],
              [-18.29698513380334, -12.602827198038128],
              [-18.295962550671767, -12.60435577097349],
              [-18.296086622247724, -12.605280475049396],
              [-18.29510370142808, -12.606712608801173],
              [-18.295243036381333, -12.607823192862229],
              [-18.294511773783572, -12.611151913134846],
              [-18.295812595999273, -12.612405298595572],
              [-18.29753901711832, -12.611849137357368],
              [-18.29917726314163, -12.613122272097238],
              [-18.30030561403439, -12.612285298615861],
              [-18.30207424323315, -12.612239211272113],
              [-18.303487866682065, -12.613109165418557],
              [-18.304249493291973, -12.614778633725575],
              [-18.303337235884722, -12.616487324228014],
              [-18.30672934421658, -12.618089203831449],
              [-18.307535022808306, -12.617978673346656],
              [-18.3124169729866, -12.619040077236996],
              [-18.31446677750942, -12.620046002692245],
              [-18.31523018369638, -12.621715787349713],
              [-18.31853584529452, -12.621684896945995],
              [-18.32123891723232, -12.621327791969868],
              [-18.32122162642913, -12.618849924727973],
              [-18.31910683894645, -12.61878569293116],
              [-18.31702636359371, -12.616847734034367],
              [-18.317092406642832, -12.614784655298665],
              [-18.318939170026166, -12.612813154479154],
              [-18.319519909824262, -12.611176775469227],
              [-18.317604038626133, -12.608338739502814],
              [-18.315753878168334, -12.607411911389924],
              [-18.31259077179071, -12.609674629513512],
              [-18.308565629657817, -12.610228956718446],
              [-18.308782610716268, -12.606519283280422],
              [-18.307842271492373, -12.6050053404403],
              [-18.30827626509748, -12.60389614852271],
              [-18.310773755948293, -12.603416978216321],
              [-18.31246213259273, -12.600712656465642],
              [-18.311838059489876, -12.599547898889847],
              [-18.312261661889778, -12.597178450267148],
              [-18.311390000716393, -12.594772877898885],
              [-18.311776837123602, -12.593107857073932],
              [-18.309541176532736, -12.592118852411462],
              [-18.30796147784059, -12.592104474473269],
              [-18.30803516490461, -12.59069821285626],
              [-18.31099139895536, -12.588875363739744],
              [-18.31296257709352, -12.588997904955981],
              [-18.31480943084198, -12.590483981252385],
              [-18.31627108267164, -12.593074875602795],
              [-18.319618675003028, -12.59588835736634],
              [-18.323329047636403, -12.597317974358328],
              [-18.32377863154313, -12.59415204831658]
            ]
          ],
          [
            [
              [-18.32524297697689, -12.573661268898473],
              [-18.32207438647817, -12.572634655490504],
              [-18.322164893204594, -12.573420269267215],
              [-18.32389059514524, -12.574050435091348],
              [-18.32524297697689, -12.573661268898473]
            ]
          ],
          [
            [
              [-18.354718456449092, -12.662034347403747],
              [-18.352858544704077, -12.661671419676003],
              [-18.352441798965856, -12.659078527068145],
              [-18.350562741774464, -12.659045471172922],
              [-18.351204958523297, -12.65645957847063],
              [-18.350130164663653, -12.65626637725505],
              [-18.349022140037675, -12.659031298956872],
              [-18.346785697897854, -12.659871625937372],
              [-18.346380441928993, -12.661312283467328],
              [-18.345504799107076, -12.661759501122901],
              [-18.342217987323952, -12.667753210126344],
              [-18.34118639927234, -12.668072008124012],
              [-18.34087194114831, -12.669458688393982],
              [-18.33874052487568, -12.670430036906593],
              [-18.33674418338541, -12.672986374910492],
              [-18.33673969023847, -12.67519345507907],
              [-18.337568136048763, -12.67813170091493],
              [-18.337826902971603, -12.680599915525695],
              [-18.339457561148905, -12.68164164185816],
              [-18.339397698056445, -12.68263300461364],
              [-18.3414354680278, -12.683359847900064],
              [-18.342169208483988, -12.682924314531373],
              [-18.344278832319954, -12.683362986284585],
              [-18.3451206106239, -12.684186895883707],
              [-18.34592167608238, -12.682852649618376],
              [-18.347385032357455, -12.682498274485717],
              [-18.349694331548278, -12.683013637779283],
              [-18.35169109216675, -12.681581187006607],
              [-18.35454635904175, -12.681721995577238],
              [-18.354272863753582, -12.679677476738757],
              [-18.35351038292328, -12.67865981317051],
              [-18.351946861931665, -12.677849147227667],
              [-18.350952810857596, -12.67638072496403],
              [-18.352227041574903, -12.674961140675157],
              [-18.35177780988179, -12.671992953124457],
              [-18.353728168284952, -12.670048135103475],
              [-18.352124790781346, -12.668208546662036],
              [-18.352764574457122, -12.666700833163707],
              [-18.3542138322611, -12.666205879213296],
              [-18.354718456449092, -12.662034347403747]
            ]
          ],
          [
            [
              [-18.35590832432105, -12.556012384648753],
              [-18.355406071752846, -12.555727768262697],
              [-18.353677318603324, -12.55233025080602],
              [-18.35161703502611, -12.55278100603014],
              [-18.350633186066176, -12.554633536651691],
              [-18.34966954632853, -12.554526902477802],
              [-18.347424016495353, -12.55559825914748],
              [-18.345910752503602, -12.55796012454007],
              [-18.34377188276318, -12.559721473546043],
              [-18.34329245109321, -12.561905063868371],
              [-18.339995109929582, -12.564087808425041],
              [-18.33904669201842, -12.564165656848585],
              [-18.337328867611316, -12.565844921886127],
              [-18.3356840772278, -12.564487759753831],
              [-18.335963464126564, -12.562180727855985],
              [-18.337831057900058, -12.560582545134826],
              [-18.339287421858003, -12.558645444217698],
              [-18.342108764708833, -12.555943629051423],
              [-18.3406067164173, -12.554576282877209],
              [-18.34028559121677, -12.553065111234648],
              [-18.342152605596567, -12.55258538326932],
              [-18.341578367455007, -12.550908850391709],
              [-18.33981669800875, -12.549842942516179],
              [-18.338103483976216, -12.549890387771706],
              [-18.336726380245878, -12.550515639916352],
              [-18.336079837834834, -12.551873014052832],
              [-18.333931920684407, -12.551303325621443],
              [-18.332882205678363, -12.55185509666356],
              [-18.331180212558323, -12.550363553021304],
              [-18.33113657873227, -12.54929590918024],
              [-18.33342872420145, -12.54710620004025],
              [-18.335516040024963, -12.546423439036046],
              [-18.337856123693108, -12.54646441210299],
              [-18.34262130008639, -12.544768632625463],
              [-18.34281324099921, -12.540376220379915],
              [-18.341277242930577, -12.542457922336842],
              [-18.339510317789102, -12.542976090978325],
              [-18.33744421796338, -12.54444926866871],
              [-18.335932279782412, -12.54350231299999],
              [-18.336661228746788, -12.541999520066007],
              [-18.335575601508783, -12.541017900671825],
              [-18.336320315438275, -12.539700008791009],
              [-18.338228665084753, -12.539170939750816],
              [-18.338120647618233, -12.537364624808434],
              [-18.337398572890613, -12.536726040032855],
              [-18.338938535761734, -12.530829618671833],
              [-18.33860530311472, -12.528624316442775],
              [-18.339332745930257, -12.527122604193208],
              [-18.337617205610183, -12.525450065849842],
              [-18.336368089624074, -12.52532014929749],
              [-18.335956283550114, -12.527725591884938],
              [-18.33434609767313, -12.530043656190275],
              [-18.333215128544893, -12.530182908279833],
              [-18.331657963439287, -12.529240594915558],
              [-18.329296597700715, -12.52668943534142],
              [-18.329398373055668, -12.524542097850151],
              [-18.327909227620545, -12.52382670645469],
              [-18.327243139005816, -12.522160675992854],
              [-18.327947993693243, -12.520941269893019],
              [-18.32712866424831, -12.51970646605438],
              [-18.32709682022884, -12.518221587396782],
              [-18.32561610147611, -12.514810513436482],
              [-18.324399776524128, -12.514491356066411],
              [-18.32523043038891, -12.517537005853383],
              [-18.322422844180178, -12.52032151967328],
              [-18.32341092605925, -12.522983629353936],
              [-18.323107246388044, -12.525007333078168],
              [-18.324501473597053, -12.529079446847927],
              [-18.32526580488447, -12.530226559710972],
              [-18.328454582882532, -12.532432479467685],
              [-18.33035049763522, -12.532324169789332],
              [-18.330871653286593, -12.534514850228188],
              [-18.32933466667466, -12.536594606624295],
              [-18.330274170253816, -12.540334058009494],
              [-18.33019957761499, -12.5422484723446],
              [-18.329375513428122, -12.543758950043346],
              [-18.32739099255307, -12.543967116967272],
              [-18.326294337595627, -12.5428458083046],
              [-18.327047754976697, -12.541620744807439],
              [-18.323714982179165, -12.540541658265202],
              [-18.323225677174985, -12.54151230075079],
              [-18.323323714962527, -12.54322639795734],
              [-18.324187390900864, -12.543854530018299],
              [-18.32376897059094, -12.545098869262453],
              [-18.322754843506363, -12.545507111661136],
              [-18.322154300259545, -12.547417935931533],
              [-18.324332377297008, -12.54835899201637],
              [-18.32521665017403, -12.547542524969591],
              [-18.32722913021384, -12.547658201044474],
              [-18.328326286319705, -12.548221158170788],
              [-18.329190914812983, -12.551084558527114],
              [-18.3279159684047, -12.551234920749744],
              [-18.326972539101067, -12.549681529081067],
              [-18.326198932442015, -12.549558178406043],
              [-18.325650026136, -12.551512242749203],
              [-18.32367186211112, -12.55293026880756],
              [-18.323103009345388, -12.554094076189259],
              [-18.325613623990314, -12.556126825571802],
              [-18.32636790200826, -12.5560189945746],
              [-18.32776567566449, -12.55842142730556],
              [-18.329582396569116, -12.557341771157366],
              [-18.330715717985854, -12.556084732228044],
              [-18.333017923025754, -12.556223015440038],
              [-18.333176304394026, -12.55695584509445],
              [-18.329096718458434, -12.560596678328777],
              [-18.329235089223726, -12.563895008982524],
              [-18.331116047922638, -12.564114589646355],
              [-18.330428534634713, -12.566128595167696],
              [-18.331124254372106, -12.56700449108593],
              [-18.330377407427537, -12.568324215373316],
              [-18.331132599722235, -12.570454508661628],
              [-18.332291194575582, -12.571712615435176],
              [-18.330990585689943, -12.573824103814323],
              [-18.329677649128616, -12.57467722432904],
              [-18.32961447064133, -12.576175337573485],
              [-18.330872140433772, -12.578032607349153],
              [-18.329206607659973, -12.579801140201212],
              [-18.327691514168293, -12.579410933151514],
              [-18.326872991274158, -12.578217494209005],
              [-18.32459035567791, -12.57891549817863],
              [-18.325226519019655, -12.580777182082672],
              [-18.32408603198952, -12.582549094314142],
              [-18.3252642633976, -12.584601033965582],
              [-18.32598073620349, -12.584589672927125],
              [-18.32941178005385, -12.586132056169172],
              [-18.330587395895456, -12.584215976137047],
              [-18.330690221037603, -12.582620458422898],
              [-18.33291407484915, -12.582346210996441],
              [-18.333661680184218, -12.581585262994572],
              [-18.334282367245326, -12.579341313413165],
              [-18.33432543090142, -12.577611357001869],
              [-18.33517926592994, -12.576421635170536],
              [-18.33595683733792, -12.572672626497367],
              [-18.33804320379696, -12.57026308070247],
              [-18.340205801238167, -12.570412461080974],
              [-18.34132580642778, -12.571766294192127],
              [-18.34083375505338, -12.574372251622286],
              [-18.340999464399363, -12.578511460509265],
              [-18.34051441365417, -12.580651446729156],
              [-18.34085737554473, -12.584077241263692],
              [-18.342417508843777, -12.584976233465104],
              [-18.345816177205208, -12.583902937317],
              [-18.347531132750944, -12.581614314734564],
              [-18.348867701785487, -12.58103695680071],
              [-18.35312968403998, -12.581103992740545],
              [-18.354798631003796, -12.58269270846633],
              [-18.35425082265811, -12.58628698923365],
              [-18.356898882941696, -12.582098052245884],
              [-18.356207672136964, -12.580755001736902],
              [-18.35595088986308, -12.578909143315595],
              [-18.357195004435177, -12.57782566839239],
              [-18.3568268577743, -12.575802871260892],
              [-18.354628451380925, -12.574165809118176],
              [-18.354708791764907, -12.570706678851955],
              [-18.35274164931154, -12.569517448952475],
              [-18.351551697574294, -12.569569554448268],
              [-18.349588186862196, -12.570618238541952],
              [-18.346713787606365, -12.570529466007047],
              [-18.34457294619011, -12.568980421117596],
              [-18.34429100316256, -12.567930819530982],
              [-18.345005227877355, -12.56679943380039],
              [-18.347714956396167, -12.56554978861019],
              [-18.348274427658318, -12.564291072429324],
              [-18.34947415104554, -12.563259444201234],
              [-18.350908567111155, -12.563280469549523],
              [-18.351636034802947, -12.561215176153217],
              [-18.350839483438904, -12.559742990172095],
              [-18.351750143552366, -12.558688414031554],
              [-18.354987103703458, -12.557487233661048],
              [-18.35590832432105, -12.556012384648753]
            ]
          ],
          [
            [
              [-18.356430700357816, -12.535289458953411],
              [-18.35592252381146, -12.533842294208137],
              [-18.353178290901287, -12.535700311587242],
              [-18.35274780882491, -12.537318649613473],
              [-18.35265464923246, -12.540072909853645],
              [-18.354692638164753, -12.539391112226616],
              [-18.35632217319024, -12.537858555212306],
              [-18.356814588505543, -12.535862420248046],
              [-18.356430700357816, -12.535289458953411]
            ]
          ],
          [
            [
              [-18.376423225847525, -12.564451651784506],
              [-18.375674931496807, -12.564095319061698],
              [-18.375637961843303, -12.561533525195262],
              [-18.373471845807337, -12.561343823923783],
              [-18.371788278452907, -12.560133908799138],
              [-18.372219755324192, -12.557999255442722],
              [-18.37096750821981, -12.556799763976178],
              [-18.37119262162131, -12.555568731053027],
              [-18.369870816089183, -12.553582772270188],
              [-18.36812682685501, -12.552751365537672],
              [-18.366841164265175, -12.553325382798102],
              [-18.36614749213709, -12.555201409934176],
              [-18.366086264308567, -12.557211096566128],
              [-18.36716319116621, -12.558052972321827],
              [-18.367297384598533, -12.560652500796301],
              [-18.368982774681385, -12.561349744212976],
              [-18.368965024408936, -12.563309757689968],
              [-18.367941677207522, -12.564701823382196],
              [-18.37104737414359, -12.566865615273585],
              [-18.372309268459784, -12.567085540835215],
              [-18.37536540104382, -12.565987502981548],
              [-18.376274703996565, -12.56600372550282],
              [-18.376423225847525, -12.564451651784506]
            ]
          ],
          [
            [
              [-18.398277276247413, -12.657758507486841],
              [-18.396295685309966, -12.657130443355852],
              [-18.394470670638885, -12.657709146129669],
              [-18.393045660453787, -12.656845230755673],
              [-18.392914291909392, -12.655917741017005],
              [-18.391586951923767, -12.654529551911358],
              [-18.390954144479156, -12.655521872358989],
              [-18.389175184010288, -12.656612077211923],
              [-18.388120376984713, -12.656654850116812],
              [-18.38587789254217, -12.655249695915371],
              [-18.384669774113277, -12.652490218027468],
              [-18.383030205338287, -12.651362838975892],
              [-18.380834876543293, -12.650469731185526],
              [-18.377717388060248, -12.651108161878613],
              [-18.371903448193937, -12.653895420767153],
              [-18.372402888775934, -12.654650950404335],
              [-18.374783620705873, -12.654920163773545],
              [-18.376567869377446, -12.656599663763227],
              [-18.376479757104246, -12.657780422247999],
              [-18.374513919508555, -12.659494272940659],
              [-18.3760754057412, -12.659738231889314],
              [-18.379549877739027, -12.659304666811607],
              [-18.38143798913333, -12.658347443110685],
              [-18.382600785007604, -12.658436904816142],
              [-18.384783305101138, -12.659707149218344],
              [-18.384423572207332, -12.6616148799005],
              [-18.384830490637057, -12.662941884726044],
              [-18.387111483979428, -12.66260755764167],
              [-18.388866988329003, -12.663397359383671],
              [-18.38850786872588, -12.666385599490482],
              [-18.389135472484234, -12.666942905004515],
              [-18.39073126154456, -12.666478492357873],
              [-18.391169490128828, -12.665454918713285],
              [-18.39291256777564, -12.665024627988583],
              [-18.394412984137304, -12.665647724477218],
              [-18.3954933479006, -12.662128031123324],
              [-18.398277276247413, -12.657758507486841]
            ]
          ],
          [
            [
              [-18.39152353170832, -12.570301687532899],
              [-18.38941342343399, -12.568102565443446],
              [-18.388878927791, -12.56534907610767],
              [-18.386267592067274, -12.563939771756832],
              [-18.382622940023673, -12.564857350491021],
              [-18.381897580994835, -12.566365414267258],
              [-18.380289275979887, -12.566548968945076],
              [-18.379208958638316, -12.56729413987336],
              [-18.378691590852704, -12.56953086301703],
              [-18.379475406634278, -12.570817502833602],
              [-18.379003168997023, -12.57249101251338],
              [-18.37760668645128, -12.572376014653859],
              [-18.376649381887233, -12.573437266447213],
              [-18.377903655048005, -12.574637785718423],
              [-18.38024957387129, -12.574672092686205],
              [-18.38056288576473, -12.572825182373318],
              [-18.382081287710154, -12.572695963057773],
              [-18.382541872864426, -12.574103575795785],
              [-18.384442221138013, -12.574501580817788],
              [-18.385656025800312, -12.575238161883128],
              [-18.386924842374352, -12.574989820678462],
              [-18.38880961355019, -12.57361485620426],
              [-18.388829672790475, -12.572772912885299],
              [-18.39030219929013, -12.57213330054526],
              [-18.391684946183048, -12.572621326839334],
              [-18.39152353170832, -12.570301687532899]
            ]
          ],
          [
            [
              [-18.3983557358558, -12.579750832934751],
              [-18.397033266108934, -12.577296544200985],
              [-18.39591065464423, -12.575992671542313],
              [-18.39467802010933, -12.577172593153279],
              [-18.39501296922177, -12.579291648530686],
              [-18.394037019262157, -12.579609151484107],
              [-18.392394476949942, -12.582085336600983],
              [-18.39196761240243, -12.584784458712997],
              [-18.39116642211741, -12.587048880599538],
              [-18.391700810356724, -12.588732027299113],
              [-18.389995522274106, -12.589999456571247],
              [-18.390153202263324, -12.590686848605367],
              [-18.39239890155226, -12.590634616707256],
              [-18.394011201121113, -12.591524238185203],
              [-18.394425212896834, -12.590273733914549],
              [-18.39655913463644, -12.586866013459096],
              [-18.396352237968042, -12.58352002138033],
              [-18.397255761632756, -12.581340282647231],
              [-18.3987108124271, -12.58102785025357],
              [-18.3983557358558, -12.579750832934751]
            ]
          ],
          [
            [
              [-18.44122948437003, -12.607758764707283],
              [-18.43963579271176, -12.608158484400665],
              [-18.438247675396813, -12.609218414354043],
              [-18.437421763628933, -12.61116441826812],
              [-18.437684438321217, -12.614231642496527],
              [-18.43959280195725, -12.614365944496399],
              [-18.441032753765313, -12.61206020400646],
              [-18.44122948437003, -12.607758764707283]
            ]
          ],
          [
            [
              [-18.425213746407007, -12.420601063971896],
              [-18.424543659866, -12.419505241928109],
              [-18.424183562378904, -12.416671233677409],
              [-18.422712768713872, -12.416109171566154],
              [-18.421276008243577, -12.414897180369577],
              [-18.41972938034689, -12.41503502631263],
              [-18.420558014547616, -12.419352291132059],
              [-18.424757894222378, -12.42078058253819],
              [-18.425213746407007, -12.420601063971896]
            ]
          ],
          [
            [
              [-18.43999174125859, -12.476761967963668],
              [-18.434594915503926, -12.473979480616336],
              [-18.429691646768696, -12.474418614826641],
              [-18.426881107125165, -12.478916541750088],
              [-18.423318529379877, -12.4815216243526],
              [-18.42402879538939, -12.48505161548103],
              [-18.426128662773632, -12.487152419405621],
              [-18.432325454948298, -12.486272196186222],
              [-18.438937630725373, -12.483718227960983],
              [-18.43999174125859, -12.476761967963668]
            ]
          ],
          [
            [
              [-18.46952934997895, -12.596145590917446],
              [-18.467616965685313, -12.595454754985319],
              [-18.467311217562195, -12.594266171538997],
              [-18.46521330978941, -12.594387164336359],
              [-18.463554509217378, -12.595591032253918],
              [-18.46399364810201, -12.596673868034024],
              [-18.46616679298715, -12.597084485682661],
              [-18.466850297118807, -12.596460575882771],
              [-18.468799044485678, -12.597031217481643],
              [-18.46952934997895, -12.596145590917446]
            ]
          ],
          [
            [
              [-18.48274067855279, -12.620410918464586],
              [-18.48128959201801, -12.620310366495579],
              [-18.481807817563407, -12.618715598000334],
              [-18.480654164253686, -12.618212658058871],
              [-18.482120588523838, -12.615991938980391],
              [-18.480879249392537, -12.615075524861414],
              [-18.47984649588424, -12.611844212243419],
              [-18.481082861100717, -12.61147270680296],
              [-18.479939841371436, -12.6100788996958],
              [-18.479041517162756, -12.611215411717778],
              [-18.47720009051498, -12.610541531477677],
              [-18.475777069112286, -12.60872855841926],
              [-18.47482040364033, -12.609261252262382],
              [-18.4726478471729, -12.609132393202085],
              [-18.471627875702584, -12.610256190217969],
              [-18.469094969211042, -12.612126917221465],
              [-18.46739984789766, -12.610970194751163],
              [-18.46552115405516, -12.608893217981699],
              [-18.46458629926679, -12.606894467063068],
              [-18.46557122929154, -12.605400141286609],
              [-18.466421237147564, -12.601998725284611],
              [-18.46720039005171, -12.600617265172604],
              [-18.46432201643509, -12.59935848709252],
              [-18.463243295241348, -12.5983568414174],
              [-18.461335952533975, -12.597968616946845],
              [-18.46115752189754, -12.596346805305831],
              [-18.45898655662832, -12.59469581537221],
              [-18.45788009099221, -12.592386893758308],
              [-18.458131651612625, -12.591756221679193],
              [-18.456730826855814, -12.590129086913867],
              [-18.4568715435923, -12.589087535909924],
              [-18.45479669491873, -12.585908521704077],
              [-18.452035130044706, -12.584568217467998],
              [-18.451102420282574, -12.584582352771445],
              [-18.450705304401822, -12.58316908710653],
              [-18.448379588175467, -12.58263065979856],
              [-18.448141121349572, -12.581880585300135],
              [-18.450040004045547, -12.579933951651409],
              [-18.44839571584492, -12.580011688402688],
              [-18.446801378502602, -12.578846640196167],
              [-18.44438944841161, -12.5794138047892],
              [-18.443145137058785, -12.578146975686423],
              [-18.443010425350614, -12.576967616537674],
              [-18.44408140946269, -12.57563349163287],
              [-18.44460969317423, -12.573367132142378],
              [-18.445870840100792, -12.572786608886704],
              [-18.448542557579454, -12.573714124937313],
              [-18.4494160257794, -12.57358878720032],
              [-18.451675929677496, -12.574459502304052],
              [-18.45367214695827, -12.574816433268916],
              [-18.45465370538237, -12.573559769190199],
              [-18.45902407752169, -12.572462600581796],
              [-18.460732608567263, -12.571560019085037],
              [-18.461485024613918, -12.569669609719325],
              [-18.460642112702914, -12.566103377520255],
              [-18.458827144093878, -12.564377432961274],
              [-18.457822465269356, -12.565379000604336],
              [-18.456514516430513, -12.565708016051198],
              [-18.45435794543077, -12.565413110507684],
              [-18.45359520872219, -12.564431522920449],
              [-18.45193516990278, -12.56558557032174],
              [-18.451594373958937, -12.56678360835492],
              [-18.44968033014625, -12.568544206337645],
              [-18.448222524431806, -12.567041067673347],
              [-18.448616243249845, -12.56336390159925],
              [-18.45044491031006, -12.559954790222987],
              [-18.454316559452398, -12.558437684111624],
              [-18.457498119527436, -12.556959090488936],
              [-18.459142741906685, -12.555409549579643],
              [-18.46228451307751, -12.554026998009853],
              [-18.46279135874742, -12.551834231010629],
              [-18.463502133043587, -12.551022941526616],
              [-18.461942300710252, -12.54995215891505],
              [-18.4618633620796, -12.548629883255792],
              [-18.460116690014075, -12.54759962852112],
              [-18.45547414618197, -12.548255064244003],
              [-18.45306391710048, -12.55003595887839],
              [-18.452948046042277, -12.551329505781444],
              [-18.451073422188987, -12.55196542686384],
              [-18.44718415166551, -12.55504569415767],
              [-18.445665751137476, -12.556931969645715],
              [-18.44367762780997, -12.557133995266252],
              [-18.442765746753796, -12.558615750037987],
              [-18.44081196580252, -12.559187545666239],
              [-18.43888777828377, -12.561856476735102],
              [-18.436816413942037, -12.561434959602497],
              [-18.436406025965073, -12.559604839946433],
              [-18.437258663674708, -12.558502171028438],
              [-18.440212622936567, -12.556371486661885],
              [-18.44186712369864, -12.556433198756348],
              [-18.442524196841656, -12.554275062524352],
              [-18.44464388555314, -12.551169091053263],
              [-18.444440078279847, -12.550021098006148],
              [-18.445924055788904, -12.548791587140125],
              [-18.447129765520035, -12.545885267323328],
              [-18.448326359918937, -12.544401619754343],
              [-18.44883124217343, -12.539904106763828],
              [-18.446440298953842, -12.538092360600904],
              [-18.445426216560413, -12.53594657359451],
              [-18.444401946205744, -12.535712792806777],
              [-18.441786449717927, -12.539349787236675],
              [-18.44061200729417, -12.539548536319598],
              [-18.43866187311204, -12.54088834007143],
              [-18.436793025495856, -12.545134479096154],
              [-18.435209461680895, -12.546068562619967],
              [-18.435483963265256, -12.547722630455207],
              [-18.434869215347767, -12.549572697786747],
              [-18.434999226769627, -12.551216628979986],
              [-18.435693402338718, -12.552763879949579],
              [-18.433410769059883, -12.552617443708051],
              [-18.43252967168776, -12.551879660301607],
              [-18.430059905802885, -12.552029306687341],
              [-18.428645191413818, -12.552994467700975],
              [-18.42811535826475, -12.555513765511003],
              [-18.42852024726758, -12.55678397935254],
              [-18.42747335495386, -12.557599656406722],
              [-18.426193804469204, -12.557200077273349],
              [-18.425425154546765, -12.555612063647247],
              [-18.422853829736404, -12.554929819435062],
              [-18.422141403766, -12.553943232649281],
              [-18.418301259244043, -12.551670092087779],
              [-18.418577806152065, -12.550526643847128],
              [-18.423070379214828, -12.552112198046753],
              [-18.424758716861586, -12.55075049344279],
              [-18.42603110876949, -12.551337447663824],
              [-18.427058296146658, -12.55057021143415],
              [-18.42645557937137, -12.549224807800325],
              [-18.424849864360485, -12.548644407454056],
              [-18.42371163436851, -12.546670358066562],
              [-18.425048388438196, -12.545643223500294],
              [-18.42739655802714, -12.542918069641306],
              [-18.426208883853533, -12.542464093175271],
              [-18.425156865889615, -12.541159082731227],
              [-18.42331765175108, -12.54036659498277],
              [-18.424171830772334, -12.539289122061874],
              [-18.42689964131463, -12.538604804161075],
              [-18.427263023304082, -12.536871994176462],
              [-18.428417718344843, -12.53492920405852],
              [-18.429933891029002, -12.535330071854498],
              [-18.43076683507729, -12.530714295322385],
              [-18.432309225561273, -12.52834146212129],
              [-18.431364321629193, -12.52563191737713],
              [-18.43388569521865, -12.523032789599519],
              [-18.432209382874408, -12.522181355018063],
              [-18.430877626077944, -12.522975145521437],
              [-18.4283337355138, -12.522782570598729],
              [-18.427218596313423, -12.522323337896351],
              [-18.425607311245273, -12.524467766715187],
              [-18.42304176825508, -12.525067783461195],
              [-18.42139015809513, -12.528845102372104],
              [-18.419740935933845, -12.530597317877335],
              [-18.416820181342047, -12.53278719956333],
              [-18.416945172294444, -12.53517496364906],
              [-18.41622479228101, -12.537963333716819],
              [-18.414094976329107, -12.538406716165145],
              [-18.412238011221298, -12.535332034994726],
              [-18.413156202065156, -12.533132464971995],
              [-18.412532100195726, -12.531790032341025],
              [-18.413178417641884, -12.530266837539108],
              [-18.41361383871089, -12.526713598806937],
              [-18.414561046682, -12.524838174155322],
              [-18.414278487892943, -12.523583080391985],
              [-18.414594612977265, -12.520553417076169],
              [-18.411701495054963, -12.520435507346981],
              [-18.410396933665115, -12.521270814449084],
              [-18.409978124456018, -12.522936384475097],
              [-18.407123269270205, -12.522976758443004],
              [-18.406967626016904, -12.522059436063483],
              [-18.405675740118152, -12.52121831332553],
              [-18.40670186483842, -12.518639603752543],
              [-18.40633228478505, -12.517206659269464],
              [-18.403365577561893, -12.516790822236247],
              [-18.407110455759206, -12.515045454540433],
              [-18.406352143671604, -12.513786114684917],
              [-18.40679388995505, -12.512631221741854],
              [-18.408280326289212, -12.5117109114368],
              [-18.408047249839846, -12.510987324306601],
              [-18.408646673484157, -12.50870286754048],
              [-18.40721904586178, -12.509223139984421],
              [-18.404868997975022, -12.509288799898352],
              [-18.403858563858613, -12.50630870368521],
              [-18.402475774978384, -12.507056907259061],
              [-18.40180772700679, -12.506255120748383],
              [-18.402657450645002, -12.504879453555905],
              [-18.40050354289618, -12.503696038790917],
              [-18.399261323963167, -12.501550451090496],
              [-18.397869541774394, -12.498279753499828],
              [-18.39693472676318, -12.497152911617869],
              [-18.397264812955548, -12.49607926644335],
              [-18.39442083243994, -12.495907875041517],
              [-18.393015423662565, -12.499281070231614],
              [-18.391185408497687, -12.500600459207408],
              [-18.391108213456, -12.502372665050869],
              [-18.38988004481469, -12.503779841635776],
              [-18.39015275630134, -12.507845900476607],
              [-18.388857274697582, -12.511676343213537],
              [-18.391503848011222, -12.514889111261812],
              [-18.391677842354827, -12.516548174864516],
              [-18.394113186896472, -12.5171517675338],
              [-18.394027829994638, -12.5159499874005],
              [-18.39593893774843, -12.515761330140881],
              [-18.39790524130274, -12.516963122921732],
              [-18.399373999897815, -12.516882344141344],
              [-18.40108244735231, -12.516035959888228],
              [-18.402262252032806, -12.516700918408041],
              [-18.40261851748793, -12.51799544387621],
              [-18.40147767925803, -12.519583556605863],
              [-18.400186136830673, -12.52004476645866],
              [-18.40130054629794, -12.521297087914142],
              [-18.400697470334975, -12.52330390928676],
              [-18.398401793257765, -12.522944569363723],
              [-18.397631391553375, -12.523639582334674],
              [-18.39835510856738, -12.524786655246746],
              [-18.40012957674118, -12.525959163862264],
              [-18.40069057620001, -12.526887961447473],
              [-18.4017732487983, -12.531705045556771],
              [-18.401008734461204, -12.532469650248885],
              [-18.401730889907054, -12.533594360524903],
              [-18.402813786370732, -12.533966152121533],
              [-18.403377060200615, -12.53517424204592],
              [-18.402818596052732, -12.536107630502178],
              [-18.403027430533395, -12.539443426514222],
              [-18.402408165737008, -12.540498677511689],
              [-18.403815529896185, -12.542589484316068],
              [-18.40589492313062, -12.543153972950082],
              [-18.405834846880225, -12.544323928057489],
              [-18.404777245658906, -12.545021863708875],
              [-18.403349799752473, -12.544283897694179],
              [-18.401044733033068, -12.544647362297098],
              [-18.400612171232677, -12.545663271480237],
              [-18.401178947600282, -12.54743159998111],
              [-18.40076683230323, -12.54998460156708],
              [-18.399394678746187, -12.550383064182622],
              [-18.398522510438024, -12.548664129294897],
              [-18.396570831310907, -12.545826828020738],
              [-18.39566202825542, -12.543435750230246],
              [-18.395228753086528, -12.53944366136937],
              [-18.39555309711304, -12.53776208908922],
              [-18.395004873474424, -12.535131806413716],
              [-18.39290344547628, -12.533776549473991],
              [-18.389850719168994, -12.533759835470878],
              [-18.388506591984, -12.534713458741496],
              [-18.386747874812368, -12.534771443379329],
              [-18.38507915825022, -12.534239335291915],
              [-18.384926845012025, -12.536789902728982],
              [-18.388037354565807, -12.53850261956278],
              [-18.388182565457342, -12.539584467103708],
              [-18.38663041866049, -12.540090151391142],
              [-18.385857497883435, -12.541041415091573],
              [-18.387178682736344, -12.542209076045717],
              [-18.38768359656607, -12.543842857576811],
              [-18.389840949973028, -12.544752607741502],
              [-18.389328820769645, -12.546217770956186],
              [-18.38776384206475, -12.547120787202315],
              [-18.389205025979617, -12.548814450812126],
              [-18.389635497989996, -12.551737373513674],
              [-18.39120283222234, -12.552441723019928],
              [-18.392591884970326, -12.552228932030546],
              [-18.395606041998334, -12.55045400324294],
              [-18.396259569224835, -12.550817106307948],
              [-18.394164018522417, -12.557735046048943],
              [-18.39606706161736, -12.559763110717588],
              [-18.39626534429064, -12.560631976135051],
              [-18.39863969706293, -12.562316155781703],
              [-18.40002136145535, -12.562010044911712],
              [-18.401500598214966, -12.56041247146125],
              [-18.402061619361604, -12.557915030578853],
              [-18.404873134822058, -12.557577923731964],
              [-18.4057936890495, -12.555888689937138],
              [-18.407467830990633, -12.556698943213304],
              [-18.407402159528104, -12.55467593258981],
              [-18.408427654575387, -12.554400248275703],
              [-18.408965639742686, -12.553233945093789],
              [-18.408927277832458, -12.551512428424692],
              [-18.411095879640378, -12.549388095760095],
              [-18.412553321737317, -12.549400177809408],
              [-18.413977030086667, -12.550604141511737],
              [-18.413527513804603, -12.554024416625989],
              [-18.41399974774196, -12.555265383047825],
              [-18.413640923768526, -12.556556166888235],
              [-18.41484860744867, -12.559038975317698],
              [-18.41674634714407, -12.559152399383054],
              [-18.41781630459699, -12.557542449469342],
              [-18.419152487979574, -12.556748420123157],
              [-18.419950326428257, -12.558660734673428],
              [-18.41917111133387, -12.560572203200554],
              [-18.417795009971524, -12.56223312681661],
              [-18.41716865045165, -12.563734400500191],
              [-18.415414927964957, -12.563375093817083],
              [-18.415441840537472, -12.562369696304192],
              [-18.4137351497399, -12.56251924429429],
              [-18.413174242734975, -12.564738004631792],
              [-18.413091839952415, -12.568525641646108],
              [-18.41202166185133, -12.569109372291999],
              [-18.41209928026395, -12.570736339798927],
              [-18.41394852147608, -12.571345021977601],
              [-18.41477508938145, -12.570712179422415],
              [-18.41782882728343, -12.570117833185545],
              [-18.41944006556245, -12.569439421498075],
              [-18.421011362558353, -12.569884655174729],
              [-18.424546178226496, -12.567775442248712],
              [-18.425283992463516, -12.566706850342245],
              [-18.426348973254434, -12.56658935574338],
              [-18.428243343209346, -12.56896570744486],
              [-18.427964975288734, -12.570601297940499],
              [-18.425693898583113, -12.571899580882267],
              [-18.426271553345337, -12.572969206301277],
              [-18.424899102682, -12.57467833938468],
              [-18.424523256972634, -12.576042439079485],
              [-18.42706165427622, -12.578130470735518],
              [-18.427361183807463, -12.579552196456708],
              [-18.429859755539137, -12.581970843476432],
              [-18.430699228174248, -12.581989732505313],
              [-18.432410976701778, -12.583403371437377],
              [-18.433466039557796, -12.581370218768313],
              [-18.435160324352278, -12.581313172691099],
              [-18.436857147378543, -12.582564001936657],
              [-18.436289664644047, -12.58315208380375],
              [-18.43724246868518, -12.58514693173498],
              [-18.436642683191625, -12.585901505595201],
              [-18.436749032020852, -12.587551537496685],
              [-18.43827877911265, -12.589565880042041],
              [-18.4420612445495, -12.590560676844815],
              [-18.443974009213616, -12.592049319123031],
              [-18.444627547435978, -12.59339403827485],
              [-18.447437292763812, -12.594474926337734],
              [-18.45004328415725, -12.594661515941121],
              [-18.451745851099208, -12.596192420508842],
              [-18.451170719090527, -12.59746057755293],
              [-18.45237315211109, -12.599527978477768],
              [-18.4539737221508, -12.601489717518227],
              [-18.453948522417093, -12.607553863254521],
              [-18.456864676001075, -12.60921028644649],
              [-18.460480452380335, -12.608625354709108],
              [-18.46316772683295, -12.609880051346048],
              [-18.46535105115977, -12.610126398385153],
              [-18.467470152432455, -12.612204802787488],
              [-18.46784774778091, -12.614395813298152],
              [-18.467167849210572, -12.616823445014278],
              [-18.46800086410423, -12.619254824016409],
              [-18.46734046311763, -12.621892530931447],
              [-18.469836696086563, -12.623375776320922],
              [-18.471686062443254, -12.624871071299527],
              [-18.47286496489027, -12.626638736935924],
              [-18.472411305159323, -12.628673247106146],
              [-18.470439222274646, -12.630166213003195],
              [-18.47157755598403, -12.631258227406075],
              [-18.473662934005144, -12.631442852572444],
              [-18.475086952198012, -12.632250897531037],
              [-18.477291880863355, -12.634675641068622],
              [-18.47769025876987, -12.633818033678077],
              [-18.477654723851305, -12.631452375041397],
              [-18.47860998977, -12.63063791354762],
              [-18.478127115073438, -12.627375871061314],
              [-18.478809817933097, -12.625484320552784],
              [-18.482054467867243, -12.623497852757193],
              [-18.48134891617227, -12.622414101379169],
              [-18.48274067855279, -12.620410918464586]
            ]
          ],
          [
            [
              [-18.483224877585887, -12.441151252903445],
              [-18.4801663263865, -12.437617452088235],
              [-18.47914365258868, -12.437224424865853],
              [-18.478001222457234, -12.435114842564921],
              [-18.474240159803927, -12.434068611726204],
              [-18.466261566577696, -12.429967597537296],
              [-18.46499469992799, -12.429780609280042],
              [-18.464206116149327, -12.431201371040743],
              [-18.463006246969858, -12.431034116226114],
              [-18.460531246137563, -12.43237326721529],
              [-18.45725476108551, -12.43276663713562],
              [-18.456967441370068, -12.43371905531963],
              [-18.458054879556535, -12.434684124287921],
              [-18.458259132081725, -12.435822948705896],
              [-18.457091769532752, -12.4379672578999],
              [-18.454226256679963, -12.439202384893326],
              [-18.45293633112197, -12.437606717643389],
              [-18.44979144577069, -12.4349305940156],
              [-18.44921306799842, -12.435816569784906],
              [-18.450256993609155, -12.438314267375901],
              [-18.449226415814373, -12.439427237979636],
              [-18.444648345970492, -12.437111282761263],
              [-18.44102280301644, -12.43642530494979],
              [-18.440802601190903, -12.437506141827981],
              [-18.44274256541965, -12.44047920866534],
              [-18.444506279008955, -12.442588442033637],
              [-18.44459486367129, -12.44401632503221],
              [-18.445524487178787, -12.445321517365333],
              [-18.445914689565797, -12.447927093353565],
              [-18.445062372313497, -12.448930998962451],
              [-18.444726609836263, -12.451880859570238],
              [-18.443647490575092, -12.4529982353749],
              [-18.444133818800236, -12.454112843243315],
              [-18.44574639394742, -12.455125316137758],
              [-18.44551896981361, -12.45672217709783],
              [-18.444026669447407, -12.457979643540037],
              [-18.444277901966093, -12.459214747501745],
              [-18.445555337547173, -12.461130165162913],
              [-18.446753579735432, -12.461041405672175],
              [-18.4560994896781, -12.455306221985799],
              [-18.458177638292373, -12.452394869397258],
              [-18.457114981656037, -12.451029838578965],
              [-18.458533422791056, -12.449509560105279],
              [-18.460072762204582, -12.449739243331173],
              [-18.461075000725696, -12.447839544076034],
              [-18.46460881303745, -12.446633976269474],
              [-18.46793466438506, -12.447082316948752],
              [-18.468947026054206, -12.448833217725054],
              [-18.469010508288992, -12.449981434839549],
              [-18.471522987117776, -12.452901299532893],
              [-18.476882946062457, -12.452895876855694],
              [-18.4792813177319, -12.452499735359188],
              [-18.480951960642038, -12.44891813029048],
              [-18.482450291078223, -12.446702622961048],
              [-18.483075094174115, -12.444455605125867],
              [-18.483758684542682, -12.443454136423515],
              [-18.483224877585887, -12.441151252903445]
            ]
          ],
          [
            [
              [-18.490902818206912, -12.398493270589723],
              [-18.49025707902865, -12.397699567104835],
              [-18.488895953830042, -12.398266937732128],
              [-18.487685009979607, -12.397965306690365],
              [-18.485240314478112, -12.398565315776045],
              [-18.483178149240285, -12.399452313038081],
              [-18.48204916541171, -12.400944569959314],
              [-18.484574079482798, -12.401631506734397],
              [-18.485022039814968, -12.403299722105587],
              [-18.486288001877732, -12.40271841745073],
              [-18.48569772245189, -12.401525828308234],
              [-18.486774998244034, -12.399992060154364],
              [-18.490902818206912, -12.398493270589723]
            ]
          ],
          [
            [
              [-18.522774516760826, -12.473686109806826],
              [-18.520066947577593, -12.47358500122047],
              [-18.51901797393365, -12.473081829224174],
              [-18.518126318169152, -12.471309252210046],
              [-18.516034514978, -12.469884237884969],
              [-18.517199789435008, -12.468240008428623],
              [-18.51638352464399, -12.46673936708903],
              [-18.51675937512816, -12.46433526057654],
              [-18.51339553458983, -12.462057878878685],
              [-18.512426115813398, -12.462336116330938],
              [-18.509514911945875, -12.462196396106453],
              [-18.509170052722283, -12.464921909399303],
              [-18.50839666580672, -12.46573833347624],
              [-18.504138173064543, -12.467814607815445],
              [-18.503062271055406, -12.468938309055961],
              [-18.500886624301607, -12.469516185142895],
              [-18.49813212577625, -12.46856937051937],
              [-18.49800768209474, -12.467791780078572],
              [-18.494340072627125, -12.465770526950843],
              [-18.493145510750498, -12.465697564709515],
              [-18.489676636654412, -12.463749508628506],
              [-18.48916450556879, -12.462405437438141],
              [-18.486550676118163, -12.463346465414816],
              [-18.4827152206782, -12.463937405797948],
              [-18.481356338683394, -12.467034161449309],
              [-18.482253422958433, -12.468435920738415],
              [-18.4839278200899, -12.46855810356592],
              [-18.48716415234205, -12.471040442790121],
              [-18.48734497754274, -12.47288092661256],
              [-18.484313115391462, -12.47200370625104],
              [-18.48354780772249, -12.470496698929388],
              [-18.482772076797154, -12.47033695822565],
              [-18.481864849392814, -12.472232266747863],
              [-18.48035810399427, -12.471397675486626],
              [-18.48021500667249, -12.472850366582511],
              [-18.481479708077213, -12.473150484420284],
              [-18.481780798032265, -12.475258256846853],
              [-18.481599958451543, -12.47778285514105],
              [-18.481006365374288, -12.480950602462821],
              [-18.479642659046156, -12.483539796365077],
              [-18.48114194384146, -12.485258786113148],
              [-18.481416342377884, -12.488068022944287],
              [-18.482724995078158, -12.488317669995215],
              [-18.48361444586484, -12.48962929162195],
              [-18.483301034548674, -12.492261793978386],
              [-18.48488982853121, -12.495368252283013],
              [-18.485704021325684, -12.497850125193892],
              [-18.48516788330019, -12.499667526745151],
              [-18.486281590729423, -12.502773420995426],
              [-18.487598848217942, -12.503580912067507],
              [-18.488087807973905, -12.501767182423245],
              [-18.488045972144285, -12.499398690545974],
              [-18.490848678502296, -12.497880518738164],
              [-18.494071828100406, -12.49725212101275],
              [-18.495372688460396, -12.497408993830431],
              [-18.495424974679718, -12.496008811684236],
              [-18.494570838840104, -12.493624491833499],
              [-18.4948621238845, -12.491272155582307],
              [-18.496289608055037, -12.487418427241906],
              [-18.499888523415123, -12.486288589781925],
              [-18.5015125537018, -12.48683257904132],
              [-18.50219241799705, -12.487930130852734],
              [-18.504165729246257, -12.486720742602516],
              [-18.503716696989397, -12.485554681793397],
              [-18.504453164215395, -12.48339316390404],
              [-18.506282884427716, -12.482661682724993],
              [-18.508137740349095, -12.483136239359343],
              [-18.509015787895827, -12.484307402277722],
              [-18.512716937403212, -12.48516330982415],
              [-18.515689659990972, -12.483019900752465],
              [-18.5163333474038, -12.481377853672033],
              [-18.517464901840768, -12.48080469653141],
              [-18.518136233075328, -12.479439128218637],
              [-18.519735390056734, -12.477844962863223],
              [-18.520941504339, -12.477543238098402],
              [-18.522774516760826, -12.473686109806826]
            ]
          ],
          [
            [
              [-18.55512330881251, -12.228289621191202],
              [-18.552536749622554, -12.229108631902935],
              [-18.55368824126791, -12.230099411164082],
              [-18.555338630770553, -12.228994408132104],
              [-18.55512330881251, -12.228289621191202]
            ]
          ],
          [
            [
              [-18.589562078888928, -12.466656361031081],
              [-18.58683870893454, -12.465421324999737],
              [-18.585175602570672, -12.466332838094873],
              [-18.584039762662922, -12.465262365428284],
              [-18.58355811237427, -12.462732048834786],
              [-18.58374303562778, -12.460436559200959],
              [-18.581799316630605, -12.458239909076353],
              [-18.580519234383928, -12.457370349165373],
              [-18.579933016399394, -12.454967921486395],
              [-18.57864930582064, -12.453610812038052],
              [-18.577948138840473, -12.451916940372092],
              [-18.57456004292462, -12.447707901219768],
              [-18.573750840688994, -12.447464243008994],
              [-18.57128731800693, -12.445483323682623],
              [-18.56913103226462, -12.444840732935473],
              [-18.568069864462966, -12.445132385702115],
              [-18.565113184101556, -12.444777742530285],
              [-18.563073886917707, -12.443658196172873],
              [-18.559571894203792, -12.440109868473217],
              [-18.55740098455786, -12.440905098155001],
              [-18.555076742867765, -12.443199247934523],
              [-18.552948327361108, -12.443038796669006],
              [-18.552041048028023, -12.442525193000714],
              [-18.549066738397475, -12.444279482281361],
              [-18.546685351577587, -12.444884954973503],
              [-18.544253719544482, -12.448464197384851],
              [-18.544041088727457, -12.450781723546317],
              [-18.545134752665298, -12.452414718186834],
              [-18.545573601731164, -12.45506381343636],
              [-18.54458088116901, -12.458573190268485],
              [-18.54513159208858, -12.459308523322946],
              [-18.546248414472878, -12.462774447749357],
              [-18.54857907828704, -12.465100104949109],
              [-18.550412982724424, -12.469054597265233],
              [-18.552073665545215, -12.468101125636869],
              [-18.55388752388705, -12.469548716880226],
              [-18.555836476710198, -12.469542250622514],
              [-18.555751151018978, -12.472850179921723],
              [-18.55480535325459, -12.473362065028793],
              [-18.55395073411754, -12.47567743731378],
              [-18.550772992571417, -12.477152393610382],
              [-18.54912830612511, -12.475966108458877],
              [-18.545510523586756, -12.474090053633798],
              [-18.545339795913748, -12.471504039160408],
              [-18.541639412467692, -12.470658027428334],
              [-18.54085287913576, -12.468086775048075],
              [-18.538659715357834, -12.468022159577478],
              [-18.53794400372245, -12.470321818519944],
              [-18.53624475906579, -12.469976382906362],
              [-18.535718240502046, -12.468076404282774],
              [-18.53626008488586, -12.465004535207333],
              [-18.538556236666327, -12.46329469721631],
              [-18.539229073051075, -12.46197556000913],
              [-18.53769077390476, -12.459478776598324],
              [-18.536129724749802, -12.457681238404701],
              [-18.53432410822169, -12.456743003657675],
              [-18.53241650144464, -12.453401238998305],
              [-18.531034728489864, -12.4528859931807],
              [-18.529348507013754, -12.450775855419176],
              [-18.529104916329953, -12.44931502961262],
              [-18.527737703384293, -12.44893723809641],
              [-18.525927361998853, -12.450272150230163],
              [-18.524823530078635, -12.44968304313146],
              [-18.52304964662509, -12.451849300090904],
              [-18.52156924023389, -12.451759778427894],
              [-18.519818917752, -12.453227463804502],
              [-18.519258022699372, -12.454255837951756],
              [-18.52009578091526, -12.456912906486549],
              [-18.519483043387144, -12.461195378762797],
              [-18.521349489785326, -12.461804981521448],
              [-18.52173902822728, -12.466131758297346],
              [-18.523301769051333, -12.465609828172246],
              [-18.526254541858542, -12.46755394216815],
              [-18.5268430754859, -12.467264828505751],
              [-18.530027604222273, -12.469139745346215],
              [-18.53009693070984, -12.470759131381296],
              [-18.530891270481753, -12.472493784284046],
              [-18.531954798928925, -12.473134155680391],
              [-18.53286739715467, -12.47462566894667],
              [-18.533407440823932, -12.477593813432444],
              [-18.532566320622756, -12.481952203052968],
              [-18.531482373182868, -12.482522051105773],
              [-18.531900181359035, -12.484759878698801],
              [-18.531022371941297, -12.486425789797817],
              [-18.53233135642034, -12.488066441172855],
              [-18.53097692799657, -12.490197534365198],
              [-18.529439375826414, -12.490997518367067],
              [-18.528951903065924, -12.492765563985387],
              [-18.527211251715332, -12.49344539776061],
              [-18.52680671757341, -12.492740065554177],
              [-18.525120487356823, -12.494903040755027],
              [-18.524679495216446, -12.49666702020885],
              [-18.524950112011684, -12.498874587704382],
              [-18.5268297379051, -12.500974200488345],
              [-18.52759405178981, -12.500993598568426],
              [-18.530798682102287, -12.499706636160393],
              [-18.53247788278051, -12.50028886656934],
              [-18.53365627708227, -12.5015713657636],
              [-18.533489650129276, -12.503682401412416],
              [-18.531931796307965, -12.504298591230965],
              [-18.529912592878695, -12.503656029681268],
              [-18.527844664762778, -12.504414067304465],
              [-18.52676454761157, -12.5040991504912],
              [-18.525431628672408, -12.505531263054694],
              [-18.524501636796117, -12.50576017060582],
              [-18.5223410694844, -12.505129759085454],
              [-18.51934069539833, -12.507047098631164],
              [-18.519112295245648, -12.508093087511794],
              [-18.520282894697175, -12.510728396524422],
              [-18.520123265152446, -12.5153080786809],
              [-18.519307179755632, -12.517156476977073],
              [-18.51528833781824, -12.518938397406526],
              [-18.513679333925094, -12.518113113208896],
              [-18.5131412833764, -12.519888500321072],
              [-18.514733092835144, -12.521973302345666],
              [-18.516622638616397, -12.522259038232606],
              [-18.518736483848162, -12.521451354972532],
              [-18.519342490791004, -12.523210965492442],
              [-18.520913358342355, -12.522221712940912],
              [-18.523613496389093, -12.52107720751344],
              [-18.523988499591344, -12.5200628424896],
              [-18.525431421949357, -12.518759017730511],
              [-18.527869221745732, -12.518803989828294],
              [-18.52906514922679, -12.51836284336805],
              [-18.530165371251734, -12.518862538871737],
              [-18.531429688278255, -12.520511209709449],
              [-18.53083714049817, -12.52219966553691],
              [-18.52912349557577, -12.520827111824191],
              [-18.52672668597043, -12.521663701453495],
              [-18.52580332929912, -12.522917679467358],
              [-18.523601879172293, -12.522383253368004],
              [-18.523920345363738, -12.524123940289368],
              [-18.52150524283124, -12.526686431227501],
              [-18.522221124688894, -12.528109501965547],
              [-18.522128729404148, -12.529563980102287],
              [-18.52492353112528, -12.532187196389092],
              [-18.528491148249095, -12.537721851417624],
              [-18.530878149202866, -12.53770178761792],
              [-18.53142893648017, -12.536062624313187],
              [-18.529709325160365, -12.534175634856123],
              [-18.530212712240523, -12.5287637141044],
              [-18.532062601290416, -12.527699259131566],
              [-18.5338721433555, -12.529063236060356],
              [-18.535721403989214, -12.528464680924612],
              [-18.536335743991863, -12.528871544365213],
              [-18.53724638825943, -12.531721536568615],
              [-18.54053347135335, -12.531635782310373],
              [-18.53930574344232, -12.528023766694643],
              [-18.539570707201474, -12.527345190282391],
              [-18.541589413994757, -12.527941980886407],
              [-18.541976787988233, -12.528930121264667],
              [-18.543759450340197, -12.529083196818306],
              [-18.545542293531415, -12.530635169572113],
              [-18.5466961581212, -12.529309919126883],
              [-18.547944235933592, -12.52657612913414],
              [-18.547560960358624, -12.525168005876113],
              [-18.548676462978676, -12.52440604691546],
              [-18.55096023671969, -12.525255113125167],
              [-18.55231204249491, -12.524936110457112],
              [-18.55316186143596, -12.52298736373887],
              [-18.554797897735764, -12.523572715371847],
              [-18.55579969574343, -12.523101220138473],
              [-18.557008170499945, -12.521397146470001],
              [-18.557440540574213, -12.518650274532684],
              [-18.55698578217393, -12.517483210883848],
              [-18.557749252566573, -12.515636570045032],
              [-18.55796918448744, -12.513610873210382],
              [-18.55913947068721, -12.512470063804745],
              [-18.562741746950522, -12.511321948555695],
              [-18.565306232191364, -12.511207763015971],
              [-18.57039844437362, -12.511540887421313],
              [-18.572434779009985, -12.51185066445867],
              [-18.573047028893722, -12.513141504380924],
              [-18.57445155262603, -12.513793631860018],
              [-18.57505925102633, -12.51503846319149],
              [-18.574676025172135, -12.516848377293085],
              [-18.576051581744473, -12.519042322821885],
              [-18.577547788895327, -12.520105167869948],
              [-18.577654320033094, -12.521120667863888],
              [-18.5759111018825, -12.523627051589717],
              [-18.57700906772914, -12.524077009026897],
              [-18.577875779398273, -12.522777727998825],
              [-18.57934233505411, -12.523097547926143],
              [-18.58006722593177, -12.525450675806734],
              [-18.579899799388254, -12.526587341187133],
              [-18.581831388460213, -12.529053457309724],
              [-18.58219446649148, -12.532050703762426],
              [-18.584272511825237, -12.534082714127441],
              [-18.587146658804162, -12.534587844899407],
              [-18.586244108060022, -12.531924207773764],
              [-18.58638986927336, -12.530135906158586],
              [-18.585645702581512, -12.528063963241095],
              [-18.586197621864336, -12.526048573398075],
              [-18.584284282711327, -12.525121253311797],
              [-18.583580835836553, -12.523885391498295],
              [-18.583828286351782, -12.521248202402838],
              [-18.583424696039444, -12.520589255984245],
              [-18.583953510750458, -12.518810460306042],
              [-18.585725182485035, -12.517046799307916],
              [-18.585065192423095, -12.513056607361758],
              [-18.58641233177732, -12.511802320297631],
              [-18.588720051365794, -12.507001923322845],
              [-18.59100212387955, -12.506025461980535],
              [-18.59022377198585, -12.502283428295216],
              [-18.58869090676813, -12.499968974974433],
              [-18.586310544430756, -12.49459696286249],
              [-18.58588489197563, -12.490798663160751],
              [-18.586025702709534, -12.489201962265835],
              [-18.588140167370216, -12.48577667854544],
              [-18.589990754356972, -12.48391449964077],
              [-18.590040840607156, -12.482815847899694],
              [-18.58873749225808, -12.48152830112442],
              [-18.58587989339293, -12.477700039244587],
              [-18.584534521193014, -12.474882495012375],
              [-18.585362629973798, -12.471241692154393],
              [-18.58662104333747, -12.468976041890155],
              [-18.58851869827598, -12.467133925306497],
              [-18.589562078888928, -12.466656361031081]
            ]
          ],
          [
            [
              [-18.582320029179485, -12.269288932026114],
              [-18.58103011010423, -12.269053999388392],
              [-18.577853174359355, -12.266352359948847],
              [-18.57379156140604, -12.266237331833636],
              [-18.572760447787825, -12.2670538050433],
              [-18.570128398085362, -12.266083042116225],
              [-18.56876762824444, -12.26649616265812],
              [-18.56634838962043, -12.265319977323923],
              [-18.56442143701548, -12.263457143696321],
              [-18.563906798424092, -12.261715732535622],
              [-18.562954824206837, -12.260421581501625],
              [-18.560885542235596, -12.258812252283148],
              [-18.558668764882757, -12.253766527586945],
              [-18.557456089058753, -12.252468331808583],
              [-18.556602140311263, -12.253241377385743],
              [-18.556287534162557, -12.25469333394166],
              [-18.557413747211246, -12.256504277700724],
              [-18.558149173123642, -12.259042245895925],
              [-18.557415483947487, -12.262736917352468],
              [-18.557473879717755, -12.265069260003544],
              [-18.556246673405045, -12.268182342522369],
              [-18.55594518067389, -12.270208247516269],
              [-18.558303291872704, -12.269387826125753],
              [-18.55979749110157, -12.267127793365308],
              [-18.561839187232973, -12.266509253332122],
              [-18.564415836594268, -12.26652406484961],
              [-18.573334993404373, -12.268050452793013],
              [-18.58140052041027, -12.269887752645072],
              [-18.582320029179485, -12.269288932026114]
            ]
          ],
          [
            [
              [-18.594780089284114, -12.229124627808734],
              [-18.594148604354498, -12.228483041074876],
              [-18.5882232914318, -12.22564133161311],
              [-18.582928442352223, -12.225986097296078],
              [-18.57721473677159, -12.226128851585562],
              [-18.575770147806857, -12.226721949740918],
              [-18.57577789214466, -12.228098585420325],
              [-18.57711789916965, -12.229493860689745],
              [-18.580955786112476, -12.227127558224474],
              [-18.585840289371284, -12.226738102438572],
              [-18.589061226988033, -12.227455170815395],
              [-18.59406495273739, -12.231577178783017],
              [-18.594690173679286, -12.2313288111921],
              [-18.594780089284114, -12.229124627808734]
            ]
          ],
          [
            [
              [-18.70860932556327, -12.495373445765741],
              [-18.70728548480536, -12.494483890860979],
              [-18.70453721201389, -12.490528920888655],
              [-18.69895292905667, -12.488521127117906],
              [-18.6970653810017, -12.490899856756577],
              [-18.69446727196357, -12.491975739420933],
              [-18.693078780032202, -12.491940422965401],
              [-18.692622561527987, -12.49087090317891],
              [-18.68942681820364, -12.490052145130784],
              [-18.68535691037698, -12.49163630319858],
              [-18.686665994362347, -12.492636372599616],
              [-18.68786579305223, -12.492692797432456],
              [-18.688819306031412, -12.493942024514762],
              [-18.689338177631118, -12.495564704242236],
              [-18.689060325918476, -12.496481071878438],
              [-18.68768708083816, -12.497422578378037],
              [-18.686286199959873, -12.501894799645218],
              [-18.686763088207197, -12.50484797771423],
              [-18.686639930947262, -12.507183428650713],
              [-18.688165006895346, -12.510992060994809],
              [-18.690540600871515, -12.512022145758094],
              [-18.703281788680084, -12.503050686911937],
              [-18.702838989164697, -12.500858822402442],
              [-18.70583030660891, -12.498617883068146],
              [-18.707513163462217, -12.498713220919113],
              [-18.708915479709145, -12.496786136975727],
              [-18.70860932556327, -12.495373445765741]
            ]
          ],
          [
            [
              [-18.74700560029518, -12.53553518175267],
              [-18.74557736519604, -12.535414929234843],
              [-18.743455521044762, -12.532049492768852],
              [-18.74246909350379, -12.529774112370594],
              [-18.74310113309238, -12.52598404936602],
              [-18.7447389316024, -12.524233467094001],
              [-18.74442577645168, -12.520153624515885],
              [-18.743540883934457, -12.522193360540458],
              [-18.74081352667874, -12.52486081982661],
              [-18.73844570669267, -12.52630246585945],
              [-18.736024541991174, -12.530529598344549],
              [-18.7347658024655, -12.531500587383501],
              [-18.734064236304995, -12.53328634411636],
              [-18.73518364438578, -12.537326350583225],
              [-18.735130735667312, -12.538572368729044],
              [-18.736739545104722, -12.539986959285715],
              [-18.741905913846576, -12.540848186020634],
              [-18.743533445070685, -12.539435696837574],
              [-18.744062902632685, -12.538229352966423],
              [-18.74700560029518, -12.53553518175267]
            ]
          ],
          [
            [
              [-18.739921679709646, -12.384801264526498],
              [-18.73730569549035, -12.381320538551464],
              [-18.736417648830873, -12.383622099745988],
              [-18.73555645451902, -12.384553401877008],
              [-18.73612009738846, -12.386111673855734],
              [-18.73931386986684, -12.38646930136024],
              [-18.739921679709646, -12.384801264526498]
            ]
          ],
          [
            [
              [-18.758265114379395, -12.487012247850426],
              [-18.75742393387121, -12.48356161343555],
              [-18.755870493494008, -12.481545228898517],
              [-18.755000487433538, -12.479451496790942],
              [-18.753188249846367, -12.47786167281459],
              [-18.74910620969292, -12.47607076245891],
              [-18.746650547500952, -12.477271798432641],
              [-18.74335937156015, -12.47746014810522],
              [-18.73969968442051, -12.47842753067784],
              [-18.739021487636453, -12.477734656230842],
              [-18.735790311194275, -12.476838115194097],
              [-18.73496529051347, -12.475948868779918],
              [-18.73205294191779, -12.475485115072631],
              [-18.73028767028809, -12.475892248938978],
              [-18.727873813805722, -12.47474986499159],
              [-18.726821778026267, -12.474810354876215],
              [-18.72454159417326, -12.47366629110587],
              [-18.724493354499877, -12.475092985270825],
              [-18.72337938262806, -12.476661899455728],
              [-18.725022042945447, -12.478599976496513],
              [-18.727935465350985, -12.481073059935154],
              [-18.728321048632193, -12.482941978619438],
              [-18.729676135413992, -12.484119943017722],
              [-18.729631741303145, -12.487412927896303],
              [-18.731004887569554, -12.489149203134438],
              [-18.73209750069522, -12.491546610924003],
              [-18.734254175936332, -12.490792653342725],
              [-18.73405964206188, -12.489134437206092],
              [-18.736669031309248, -12.488375837790162],
              [-18.73815336003502, -12.48942262085957],
              [-18.739636479778007, -12.489443062807174],
              [-18.74271329323802, -12.490823906270263],
              [-18.74569735002793, -12.493638316161277],
              [-18.746556877269676, -12.492421168601119],
              [-18.74813036993802, -12.492593974699808],
              [-18.750114714337997, -12.490992887362431],
              [-18.752324475964052, -12.491092940778666],
              [-18.753573197518097, -12.489738280383662],
              [-18.755985174972565, -12.489931468468383],
              [-18.7570294349895, -12.490676672858774],
              [-18.75814261304941, -12.488402645946309],
              [-18.758265114379395, -12.487012247850426]
            ]
          ],
          [
            [
              [-18.801934671318634, -12.504737563058216],
              [-18.800011075407255, -12.502851687931472],
              [-18.799850432765446, -12.501538375189385],
              [-18.800906876702445, -12.500783897670305],
              [-18.7999958565831, -12.497641887494545],
              [-18.798744116530884, -12.499143302173692],
              [-18.79603123070845, -12.499459151802554],
              [-18.79349417346624, -12.498468834732883],
              [-18.792067366105833, -12.497162388468366],
              [-18.79223891662009, -12.495624248711893],
              [-18.7909644442408, -12.494977734386866],
              [-18.78859665646819, -12.495369188179115],
              [-18.78662217864923, -12.495060446663036],
              [-18.785307025064153, -12.493484042918453],
              [-18.78337241822656, -12.493894401769081],
              [-18.782972519161444, -12.495528558998732],
              [-18.781890936204906, -12.496471053388868],
              [-18.7788584663825, -12.498291948793707],
              [-18.776561774526716, -12.498686099475925],
              [-18.775914163768192, -12.499657993932132],
              [-18.774734616803258, -12.498999134626388],
              [-18.773342964358836, -12.499158755197993],
              [-18.77246161494455, -12.500381270492083],
              [-18.771534943352577, -12.50322037226494],
              [-18.769233568764424, -12.50357721831496],
              [-18.76770314489976, -12.502583837361941],
              [-18.76621885749796, -12.50357117252935],
              [-18.765097809824507, -12.505224359746515],
              [-18.768219405105558, -12.505094956454025],
              [-18.76880128764236, -12.507154993376261],
              [-18.76806104006456, -12.50936598872282],
              [-18.767141308535347, -12.510078597607919],
              [-18.765485082344522, -12.50963641413132],
              [-18.76444152616304, -12.510316483635235],
              [-18.762558234273136, -12.510577274882493],
              [-18.762302122293146, -12.511237412804324],
              [-18.759963643533876, -12.512678412702263],
              [-18.75890015349654, -12.513820922864634],
              [-18.756206594821496, -12.51492092913334],
              [-18.753752126807054, -12.515011820813255],
              [-18.750266849550158, -12.517111672475705],
              [-18.75139010306572, -12.518714981693813],
              [-18.750382627477993, -12.520114509731256],
              [-18.750625793618177, -12.522776118442401],
              [-18.750264995818664, -12.52377549504676],
              [-18.752013292845866, -12.524584165605038],
              [-18.755488006266063, -12.524799503968472],
              [-18.75678695194472, -12.526056079435866],
              [-18.75878571127351, -12.52634436047686],
              [-18.760693260929997, -12.52928639698219],
              [-18.760183185567804, -12.531848200507397],
              [-18.760923836783807, -12.534245083141684],
              [-18.76237175666515, -12.534525589668059],
              [-18.763300031820396, -12.533062438053438],
              [-18.76349136425758, -12.531449352303797],
              [-18.7653718492548, -12.530135759014447],
              [-18.76658927380335, -12.531097016456796],
              [-18.766587133605682, -12.533086674725935],
              [-18.7677884025171, -12.535314246971742],
              [-18.77178348465994, -12.5366378573331],
              [-18.772280402404412, -12.53878208673439],
              [-18.773134684959896, -12.539106256762272],
              [-18.774169603971348, -12.537535885775823],
              [-18.77663012359714, -12.53765233496944],
              [-18.778458534006393, -12.53568342592566],
              [-18.779073070168295, -12.533040893374446],
              [-18.779754687937686, -12.531932580114894],
              [-18.781083201075393, -12.53161586838142],
              [-18.781842568194982, -12.530358098924907],
              [-18.782887193451145, -12.53007416965932],
              [-18.783337204679864, -12.52784580669449],
              [-18.783367031101943, -12.525314795040916],
              [-18.781634520447078, -12.521728264029699],
              [-18.778583857571952, -12.520623786101778],
              [-18.77762136693628, -12.51865087541806],
              [-18.775708616835676, -12.518030046809935],
              [-18.775046278397102, -12.515907635341659],
              [-18.774046279876472, -12.514759431686164],
              [-18.774671750350677, -12.513589095425525],
              [-18.773214775461913, -12.512820773210569],
              [-18.773505605033673, -12.510659948546754],
              [-18.775630008116458, -12.50980564479739],
              [-18.773258795873176, -12.509005242061134],
              [-18.774064913567706, -12.506155214382652],
              [-18.775322797504053, -12.505473450948697],
              [-18.775479762959094, -12.5041935600825],
              [-18.777099031336025, -12.503717884842972],
              [-18.777134102735836, -12.501246789409615],
              [-18.77852339437298, -12.501063675485545],
              [-18.780256870972742, -12.501633694364875],
              [-18.781905588633983, -12.50114160582551],
              [-18.78363687556947, -12.502203600473477],
              [-18.783226641337432, -12.503162227387442],
              [-18.78173909631326, -12.504315203166364],
              [-18.78031907850574, -12.504642204454447],
              [-18.77961983096161, -12.506382061474746],
              [-18.780635101287118, -12.507457277697199],
              [-18.781210392764894, -12.509050411916112],
              [-18.78090836492487, -12.511306117431253],
              [-18.782642735234816, -12.513771912571656],
              [-18.783384865814494, -12.513967197012485],
              [-18.78446808451897, -12.515993709715477],
              [-18.784833233945086, -12.518220303969066],
              [-18.78654702241774, -12.520502539486738],
              [-18.78671877349849, -12.521722512256167],
              [-18.788181054944612, -12.521530249933742],
              [-18.788042497052516, -12.520189447075236],
              [-18.786757254626295, -12.519074321041284],
              [-18.78708832556038, -12.517258413962697],
              [-18.7905390525033, -12.514707593589474],
              [-18.79131371864786, -12.512606746784835],
              [-18.79205758484706, -12.512029456162296],
              [-18.79555796514417, -12.510687846001991],
              [-18.799518717652585, -12.510629767606902],
              [-18.79984532845602, -12.508739032299092],
              [-18.80145001884384, -12.507363837475534],
              [-18.802276245418756, -12.505322751756337],
              [-18.801934671318634, -12.504737563058216]
            ]
          ],
          [
            [
              [-18.8093526833903, -12.54623010448393],
              [-18.8080676613167, -12.54417081092928],
              [-18.806555629300895, -12.545339318047365],
              [-18.806403450695313, -12.546855897339157],
              [-18.804557163430843, -12.547848040405688],
              [-18.802394857209865, -12.552574590210604],
              [-18.801131955746794, -12.5525672611067],
              [-18.80006358301036, -12.554932446363082],
              [-18.800677896736428, -12.556620174868158],
              [-18.802338183183593, -12.558608805512508],
              [-18.8041468147521, -12.55964181723602],
              [-18.8051715753317, -12.559569676950476],
              [-18.804170707566705, -12.557082136249793],
              [-18.80638552101843, -12.553774833533826],
              [-18.807153833479326, -12.550238033781646],
              [-18.808616158712244, -12.548449488837255],
              [-18.809733900047807, -12.54796724575217],
              [-18.8093526833903, -12.54623010448393]
            ]
          ],
          [
            [
              [-18.80790424178719, -12.515275155966021],
              [-18.806334992522718, -12.515178243858166],
              [-18.804514075238423, -12.51361305328266],
              [-18.803377108663952, -12.513616757265321],
              [-18.802385500851116, -12.516575276255146],
              [-18.801377813385752, -12.517347695852367],
              [-18.798589009894144, -12.516877113084968],
              [-18.795681609805165, -12.5199523162661],
              [-18.797382332950914, -12.52132262266735],
              [-18.796792850304364, -12.522705341708026],
              [-18.797493622140443, -12.523928848419114],
              [-18.799065509723718, -12.52470759575482],
              [-18.80049112750939, -12.524799117324216],
              [-18.802370050735668, -12.522520577599238],
              [-18.80269377283922, -12.521640369075044],
              [-18.804742577987138, -12.519973752686184],
              [-18.806439241228173, -12.517786240668993],
              [-18.806310082642636, -12.516537891844395],
              [-18.80790424178719, -12.515275155966021]
            ]
          ],
          [
            [
              [-18.81752366958614, -12.525263915321304],
              [-18.81477781419945, -12.527148562609353],
              [-18.815404109191864, -12.531414511548636],
              [-18.812669890450866, -12.534072091629774],
              [-18.811429918829383, -12.53855201636802],
              [-18.812433347101894, -12.539447582999093],
              [-18.814280957475052, -12.539856273043188],
              [-18.815872160275077, -12.534992376898405],
              [-18.815635243425426, -12.532511710174848],
              [-18.817303432063976, -12.53141327966397],
              [-18.817697499819722, -12.528615335281904],
              [-18.81727476833001, -12.5267294462699],
              [-18.81752366958614, -12.525263915321304]
            ]
          ],
          [
            [
              [-18.919417288008795, -12.666146244131124],
              [-18.918751513412985, -12.66453419921949],
              [-18.91856454080939, -12.66223325279592],
              [-18.91621260741376, -12.6609111920601],
              [-18.91480539394949, -12.662599193362393],
              [-18.91518076407092, -12.66518131861039],
              [-18.91582381244487, -12.665939979676093],
              [-18.91550697107826, -12.667677259799259],
              [-18.91628784216543, -12.66916026455065],
              [-18.918653594355337, -12.670358888282122],
              [-18.91807432411927, -12.668037765561216],
              [-18.91948068686779, -12.666902523884952],
              [-18.919417288008795, -12.666146244131124]
            ]
          ],
          [
            [
              [-18.916307061503776, -12.556035168586373],
              [-18.91581100991152, -12.555556315023413],
              [-18.913371613366998, -12.556236155324356],
              [-18.912684739159015, -12.557614371232257],
              [-18.913299318942297, -12.559370981486502],
              [-18.915059771921563, -12.55938706879989],
              [-18.916299189635776, -12.557446389289128],
              [-18.916307061503776, -12.556035168586373]
            ]
          ],
          [
            [
              [-18.917339201726442, -12.564479984868713],
              [-18.915493398773485, -12.564364197945153],
              [-18.91369170733081, -12.563483043557609],
              [-18.909598105687362, -12.563498171899079],
              [-18.906004322818603, -12.56124028392771],
              [-18.905469124297657, -12.560272172460936],
              [-18.902898973389252, -12.557911245501371],
              [-18.901568332410275, -12.555819974212616],
              [-18.90187620836549, -12.553925922085314],
              [-18.899771325950177, -12.5525417221846],
              [-18.898266586333566, -12.552257752598358],
              [-18.895634659861482, -12.550327481478579],
              [-18.89380748434186, -12.549965358682586],
              [-18.892684086296445, -12.548718311756941],
              [-18.88982525628001, -12.549867742988276],
              [-18.887891222082217, -12.54848502578637],
              [-18.887066486343986, -12.550675777273183],
              [-18.882617008625797, -12.551807354371235],
              [-18.88062742467653, -12.552613955523748],
              [-18.878459835860152, -12.554287125023572],
              [-18.877144449963634, -12.556795953648031],
              [-18.87639674782116, -12.560175278169925],
              [-18.87596710382909, -12.560392096836408],
              [-18.876455860389136, -12.56305078215251],
              [-18.876419498876103, -12.565028710770656],
              [-18.87828497347575, -12.570395439164773],
              [-18.877557197604652, -12.573939908921904],
              [-18.87817587627098, -12.577086074293696],
              [-18.878627153656097, -12.583264165738157],
              [-18.879495799253345, -12.585534739379264],
              [-18.882155361966564, -12.585587479451632],
              [-18.884656966932905, -12.588584253258121],
              [-18.88619213286507, -12.590021097652226],
              [-18.887932592523253, -12.59268037150608],
              [-18.887998434464222, -12.594697476868683],
              [-18.888949581002088, -12.597783771046355],
              [-18.892536928223663, -12.599582677297878],
              [-18.893473401372468, -12.60048086603534],
              [-18.897870155734985, -12.601614161486278],
              [-18.899824757125824, -12.600290049054975],
              [-18.902631743796316, -12.598837189766485],
              [-18.903400248424663, -12.597870929140699],
              [-18.90435271432579, -12.592547762234712],
              [-18.90746612981074, -12.589007798964927],
              [-18.91030670267658, -12.588208653878068],
              [-18.910608068194076, -12.585887433493486],
              [-18.912178953314147, -12.583126719664019],
              [-18.913604523457764, -12.582031533707593],
              [-18.915264672309238, -12.582366832105429],
              [-18.915406211580482, -12.580677998996462],
              [-18.91674962446145, -12.580251971142214],
              [-18.915609692451678, -12.57891084718959],
              [-18.91495433484767, -12.576662730837485],
              [-18.916310457955653, -12.574305859761479],
              [-18.91596817710345, -12.571501543021878],
              [-18.916114715678845, -12.569672087925653],
              [-18.915299950587464, -12.568785596163844],
              [-18.915160026589398, -12.567345064867341],
              [-18.91727715183926, -12.566211226383382],
              [-18.917339201726442, -12.564479984868713]
            ]
          ],
          [
            [
              [-18.949644518583405, -12.738385155648901],
              [-18.94738667922698, -12.736436175543133],
              [-18.94361679047745, -12.738948299540349],
              [-18.94228537475747, -12.739172869711282],
              [-18.941631279946492, -12.741273336633117],
              [-18.94034372398031, -12.741421725502427],
              [-18.938819086085708, -12.740807227015443],
              [-18.937721831158193, -12.741453334844412],
              [-18.93410144205633, -12.741806108836991],
              [-18.934120801287868, -12.742658859302198],
              [-18.93589146446365, -12.743359524689856],
              [-18.936211202283076, -12.746148640146622],
              [-18.93534021626101, -12.747441311506838],
              [-18.935862208510507, -12.748717124320592],
              [-18.9341175251559, -12.750614918526782],
              [-18.9324911097223, -12.75070201341288],
              [-18.93025641238347, -12.749513007777605],
              [-18.92715388815748, -12.749810250701506],
              [-18.927001915148434, -12.751216600337884],
              [-18.927673186108265, -12.751893490991488],
              [-18.930584311794963, -12.752962097526039],
              [-18.93196735822905, -12.755832884484551],
              [-18.932903281456056, -12.755663010734635],
              [-18.933577685489773, -12.752584534940656],
              [-18.934562669753802, -12.752093841155103],
              [-18.936375329661825, -12.752563777198361],
              [-18.938445194841496, -12.75189164343656],
              [-18.939838900015403, -12.752125770277116],
              [-18.941481122668513, -12.753267839727936],
              [-18.94242184411804, -12.751926257263175],
              [-18.943834137536268, -12.751158455926898],
              [-18.945232096777715, -12.749293305348642],
              [-18.94529492861348, -12.747604659892948],
              [-18.946628564711585, -12.74679367995885],
              [-18.94688336744554, -12.744699611719787],
              [-18.94754447241915, -12.74391647330783],
              [-18.948064983446418, -12.741094059487551],
              [-18.94989207566515, -12.739586366636164],
              [-18.949644518583405, -12.738385155648901]
            ]
          ],
          [
            [
              [-18.958503826888837, -12.750424362210618],
              [-18.957211582327744, -12.751174888985231],
              [-18.955398847276417, -12.751236143310473],
              [-18.954121337219664, -12.750427406198707],
              [-18.951383811361715, -12.75128947988558],
              [-18.946423373128063, -12.754867329854465],
              [-18.947220181080187, -12.75524886358755],
              [-18.950165314395324, -12.754213928175535],
              [-18.95434126603568, -12.754357502791649],
              [-18.955429707167163, -12.753107112953828],
              [-18.958136417103795, -12.752365760736579],
              [-18.958837083994947, -12.751542747977048],
              [-18.958503826888837, -12.750424362210618]
            ]
          ],
          [
            [
              [-19.02552198734256, -12.724503288146071],
              [-19.02373912786312, -12.72547243204205],
              [-19.021792652347763, -12.724108858019312],
              [-19.021913349908537, -12.722141910755271],
              [-19.019682489463445, -12.719768920142748],
              [-19.019182133272142, -12.715410312972322],
              [-19.017954001490686, -12.714999907244502],
              [-19.017739235389772, -12.7130783752076],
              [-19.013457934834587, -12.712114594699134],
              [-19.014839002860246, -12.7107937365289],
              [-19.01510111705091, -12.709143199536125],
              [-19.017673760157518, -12.706905884191096],
              [-19.01757062899291, -12.704019917771152],
              [-19.01660874809584, -12.703765426784818],
              [-19.016605231073676, -12.701960040569096],
              [-19.016007554949372, -12.701515132093382],
              [-19.015148526754338, -12.704145891240989],
              [-19.013448662058337, -12.704557405293214],
              [-19.011448458671925, -12.704200254713173],
              [-19.010199220295377, -12.703269515326522],
              [-19.00877724060829, -12.703929673053143],
              [-19.006265919658873, -12.70624580180567],
              [-19.005344371837253, -12.705943324664087],
              [-18.9924139442074, -12.713126048637976],
              [-18.991305667464154, -12.714314324354017],
              [-18.991063261965063, -12.715771480081504],
              [-18.987668172132835, -12.717015593308279],
              [-18.985471531738614, -12.717011855218889],
              [-18.98506718054367, -12.717634132052744],
              [-18.986612787343596, -12.720050855953794],
              [-18.986323900210493, -12.721894622841477],
              [-18.984976206035526, -12.722400239587238],
              [-18.983905268639212, -12.72206176140846],
              [-18.982702240739048, -12.719648158727598],
              [-18.980433921206874, -12.71874922324924],
              [-18.978881864578383, -12.719185066230388],
              [-18.978702583873716, -12.720396658470158],
              [-18.980522338788198, -12.72159055804837],
              [-18.979959207325933, -12.722851148915478],
              [-18.978156015336157, -12.723604093019773],
              [-18.977131490956772, -12.721785304477612],
              [-18.976165254395646, -12.721860910724008],
              [-18.975130389366853, -12.720328869784899],
              [-18.97387412869631, -12.721154094715601],
              [-18.971226016524373, -12.722156345290799],
              [-18.968694620235866, -12.722572513367545],
              [-18.968933825053625, -12.723635467584941],
              [-18.97114624631242, -12.723022067224585],
              [-18.973013607979848, -12.724211176722465],
              [-18.973096712921706, -12.725199319018191],
              [-18.971157154842476, -12.726396541297973],
              [-18.969545622981805, -12.729692222835386],
              [-18.968268539142638, -12.72890293595836],
              [-18.965016048952986, -12.730883896629052],
              [-18.96415039046125, -12.732087170676381],
              [-18.965222825445235, -12.73280775832949],
              [-18.96491990840351, -12.734939114757514],
              [-18.962434124214525, -12.735348363604013],
              [-18.9601589226917, -12.7343984846011],
              [-18.95914372548037, -12.735953461077798],
              [-18.95694734457017, -12.736705624286838],
              [-18.956962218367536, -12.7390349295786],
              [-18.960431605349218, -12.737931890875945],
              [-18.96161587499385, -12.73802058179493],
              [-18.965224530735455, -12.737231995507942],
              [-18.965924355917604, -12.739189391383432],
              [-18.96474744456778, -12.740532674361408],
              [-18.96550157483754, -12.741816961666217],
              [-18.961861824207055, -12.74607236048703],
              [-18.962850813139386, -12.747797947315414],
              [-18.966526998593125, -12.746299949784534],
              [-18.967765376373887, -12.745376374217201],
              [-18.968638671268916, -12.743820264643434],
              [-18.97194286221719, -12.743882476361282],
              [-18.973383766089896, -12.743161016856572],
              [-18.973962091717862, -12.741359142761514],
              [-18.975618448405665, -12.739596307827073],
              [-18.976472792755782, -12.739652438960228],
              [-18.977903490305742, -12.740957460251748],
              [-18.97826331552397, -12.742003470964848],
              [-18.976907148604305, -12.743767623372655],
              [-18.977458700652033, -12.745018673716622],
              [-18.978512885673425, -12.744766548701328],
              [-18.980385132961683, -12.740970914470145],
              [-18.98130657925493, -12.740186763735077],
              [-18.984054618150005, -12.740264646393769],
              [-18.985294343170295, -12.741486749271644],
              [-18.98580999837339, -12.742910043249502],
              [-18.985347575528056, -12.743677795126706],
              [-18.98302422286494, -12.744613643471215],
              [-18.977713467750213, -12.748464468494895],
              [-18.978086563355465, -12.749363249203121],
              [-18.9830400441349, -12.746345327355966],
              [-18.984181152516967, -12.746549856269162],
              [-18.985138234414475, -12.744792271453715],
              [-18.988468111346936, -12.743270738104723],
              [-18.987386714763122, -12.741397012726098],
              [-18.988562431290777, -12.739256338592863],
              [-18.990437593553153, -12.73864793604881],
              [-18.99257041092238, -12.73875172139921],
              [-18.993633505264366, -12.739474285814493],
              [-18.99413858370635, -12.740827540642883],
              [-18.996167472206714, -12.739035740499206],
              [-18.996599748289434, -12.737586710770646],
              [-18.99825195112026, -12.73606312846749],
              [-19.00064797342043, -12.735706803495516],
              [-19.007870167346386, -12.739201450075743],
              [-19.009965237712628, -12.739501566501502],
              [-19.010182453092455, -12.740378369742716],
              [-19.008347000303154, -12.743228428746392],
              [-19.008722938222775, -12.744528178973527],
              [-19.010639122723877, -12.744065226046043],
              [-19.012147868922177, -12.742773652174131],
              [-19.012281229429156, -12.740344255233364],
              [-19.014043891452822, -12.73892442631892],
              [-19.015721131898115, -12.736772469115245],
              [-19.016890523932734, -12.736706689357797],
              [-19.017001538846973, -12.73373032320177],
              [-19.01809837063392, -12.732805936275206],
              [-19.021889879243606, -12.72766559182609],
              [-19.024296414147816, -12.725970886799754],
              [-19.02552198734256, -12.724503288146071]
            ]
          ],
          [
            [
              [-18.98514245698565, -12.411132103675895],
              [-18.981757007094558, -12.40905832263588],
              [-18.97721368630676, -12.406529671712622],
              [-18.966977938087318, -12.401387300568937],
              [-18.955768237109886, -12.396367022152516],
              [-18.949703491817658, -12.394123601158597],
              [-18.946251622578018, -12.393590126961765],
              [-18.943543709893106, -12.393984542322965],
              [-18.944857661268664, -12.395258831579438],
              [-18.94670896472817, -12.39627765614561],
              [-18.948480129693316, -12.396701486178063],
              [-18.950708223888615, -12.396275187755238],
              [-18.954145354538603, -12.397042056272612],
              [-18.958966615240513, -12.400284105955416],
              [-18.960975996727175, -12.401048523075755],
              [-18.96656584332153, -12.40255907496226],
              [-18.97464345612863, -12.406212981170713],
              [-18.983577358383513, -12.41119737933204],
              [-18.98514245698565, -12.411132103675895]
            ]
          ],
          [
            [
              [-19.010325598939755, -12.561954391575032],
              [-19.00792511352807, -12.56099811016968],
              [-19.006420493856066, -12.563739180097544],
              [-19.007582826457636, -12.565518012429436],
              [-19.0088121155814, -12.564979869768631],
              [-19.009100277766457, -12.562869260735948],
              [-19.010325598939755, -12.561954391575032]
            ]
          ],
          [
            [
              [-19.000594173996273, -12.448307545333783],
              [-19.0004189048271, -12.44755929154405],
              [-18.998366461497998, -12.447596540721216],
              [-18.996216170224542, -12.449001764973255],
              [-18.99722331543375, -12.449710828605548],
              [-18.999884981882676, -12.449406436703242],
              [-19.000594173996273, -12.448307545333783]
            ]
          ],
          [
            [
              [-19.010711286073597, -12.439172890338828],
              [-19.00679464524935, -12.434739656565707],
              [-19.00198730018073, -12.429724627642816],
              [-18.994871406462387, -12.420767626165452],
              [-18.993372178306142, -12.419938761780772],
              [-18.992127693626408, -12.419916047011743],
              [-18.99143187323563, -12.420753995583363],
              [-18.994354197556508, -12.421862355508026],
              [-18.997483162900217, -12.425837480926145],
              [-18.998633792580776, -12.428626677304097],
              [-19.002076444447656, -12.433122212157839],
              [-19.003422500002227, -12.433177656767388],
              [-19.008263482500844, -12.43842311206808],
              [-19.00846313890564, -12.440546218760764],
              [-19.010838946637442, -12.441118896159914],
              [-19.01137482427653, -12.440159535936537],
              [-19.010711286073597, -12.439172890338828]
            ]
          ],
          [
            [
              [-19.041114594714855, -12.380297257188758],
              [-19.039458054847294, -12.375812425832034],
              [-19.038364685218085, -12.375476606803302],
              [-19.03635494968, -12.375856452919416],
              [-19.03367367666241, -12.374605413741078],
              [-19.032318747981574, -12.3751384740692],
              [-19.030244569033428, -12.377005763016438],
              [-19.029384231357046, -12.379678145397115],
              [-19.030143039202148, -12.381540128236594],
              [-19.029804625454645, -12.383039116043848],
              [-19.03083002351389, -12.384838831399247],
              [-19.030609787209197, -12.386591507779613],
              [-19.032916777484584, -12.388299227164817],
              [-19.035100208838653, -12.388354206811318],
              [-19.035926013865993, -12.38738063712028],
              [-19.039105280378415, -12.385334659993406],
              [-19.040272448597324, -12.381730396749338],
              [-19.041114594714855, -12.380297257188758]
            ]
          ],
          [
            [
              [-18.15829940903238, -11.968037175575287],
              [-18.158506161028573, -11.97075104462589],
              [-18.15906195548935, -11.971286527514716],
              [-18.161739958629365, -11.97180804159904],
              [-18.16668080598093, -11.974555938679687],
              [-18.169208790676763, -11.976674025695074],
              [-18.170052747363957, -11.980271371320416],
              [-18.168864219971567, -11.981707814234174],
              [-18.168569201529714, -11.9829148903285],
              [-18.166340752579337, -11.987148416642842],
              [-18.16352553332751, -11.990574856401226],
              [-18.160194510652072, -11.992950355697298],
              [-18.16157497977624, -12.011097341365094],
              [-18.191648704066235, -12.008891883017302],
              [-18.193958365790785, -12.038548338721311],
              [-18.236987607049453, -12.035271506197393],
              [-18.239399923423633, -12.064915066744584],
              [-18.299253518110536, -12.060118975021553],
              [-18.301807874366602, -12.089746190327649],
              [-18.361780127896814, -12.084663474278146],
              [-18.367171797615683, -12.143878700834714],
              [-18.349076040582155, -12.145441244270247],
              [-18.359695352389693, -12.26381751392137],
              [-18.371691795199414, -12.262784848594817],
              [-18.37437353106942, -12.29236249586944],
              [-18.314477600932022, -12.297409330882983],
              [-18.319420949006478, -12.35473870095764],
              [-18.321776300402895, -12.382151055564558],
              [-18.323007034895884, -12.380588040315352],
              [-18.324937086829163, -12.38031410113968],
              [-18.327848187570474, -12.384312014236361],
              [-18.329486107374866, -12.385282827204236],
              [-18.32930223844682, -12.386785705621186],
              [-18.330124312357732, -12.388847237239153],
              [-18.331327034932396, -12.39022251558466],
              [-18.332509214465375, -12.390816243598556],
              [-18.33191696099255, -12.392409194738164],
              [-18.33305604133228, -12.395219198109608],
              [-18.33522337250423, -12.397921581390017],
              [-18.33496769210699, -12.399049636507243],
              [-18.335557203829854, -12.400407355180008],
              [-18.33508492967621, -12.401484333157665],
              [-18.333254132504365, -12.403757858628738],
              [-18.331189195294915, -12.404966247045612],
              [-18.33070939172293, -12.40678202959397],
              [-18.33280338251518, -12.406447791255022],
              [-18.333357384607044, -12.404948814780862],
              [-18.335905061008884, -12.403053961861543],
              [-18.336699592121924, -12.401073749005079],
              [-18.33820785139648, -12.39998000821414],
              [-18.342115124979756, -12.400715664129557],
              [-18.343104650211686, -12.399087774514422],
              [-18.344620740064666, -12.399168869929717],
              [-18.34864427771898, -12.402481390056616],
              [-18.349619628743323, -12.40292487811377],
              [-18.351208119030975, -12.402214652587514],
              [-18.352846148059715, -12.403138167086071],
              [-18.35435896675853, -12.402641655917016],
              [-18.355849218675512, -12.402954437266645],
              [-18.357161275838713, -12.402589909369869],
              [-18.357127695475207, -12.40119355981064],
              [-18.3552714323467, -12.39988894505463],
              [-18.354105609932468, -12.397104388876324],
              [-18.3543588786336, -12.395169100446623],
              [-18.349586420015125, -12.393172663531939],
              [-18.350114099666357, -12.390869299073199],
              [-18.350940427956775, -12.390085258909973],
              [-18.354208324735925, -12.390801340072176],
              [-18.35767694334673, -12.392444674428516],
              [-18.35907244707289, -12.392764707785137],
              [-18.359419179169844, -12.391628588806704],
              [-18.357976328509576, -12.3899757829691],
              [-18.356937229521403, -12.389418113345295],
              [-18.355865860075088, -12.387964436333244],
              [-18.35450373157116, -12.387725421646254],
              [-18.351000939166706, -12.38809817765056],
              [-18.349754924901017, -12.38765868686154],
              [-18.347200709078297, -12.387748793450248],
              [-18.345430756186587, -12.386906450775497],
              [-18.343362283191347, -12.388300824046759],
              [-18.341387967270844, -12.387543716197733],
              [-18.339787126206165, -12.389174881885674],
              [-18.33889310824731, -12.389456694755115],
              [-18.33677171389178, -12.391338458208395],
              [-18.336015329289875, -12.390225984003854],
              [-18.336605805308544, -12.388080128590268],
              [-18.337533323542793, -12.38791070006881],
              [-18.337012599474043, -12.385719066177838],
              [-18.334567283246137, -12.38359545942518],
              [-18.333275403161192, -12.383633519679385],
              [-18.332128339565124, -12.382622880077944],
              [-18.33194185619451, -12.380473082008535],
              [-18.333033554945562, -12.378678899791929],
              [-18.336244137973058, -12.379004837952014],
              [-18.33764347454109, -12.375670988923833],
              [-18.33856936746274, -12.375225792535304],
              [-18.341426855329477, -12.375609038437828],
              [-18.342350077865046, -12.374058385920309],
              [-18.343644208572783, -12.373789103065075],
              [-18.345801265379563, -12.3745929856879],
              [-18.347526956349107, -12.374591748699956],
              [-18.34991895426272, -12.372894070157832],
              [-18.349426007010976, -12.372106867307416],
              [-18.34706958865409, -12.370463124043992],
              [-18.345356492230437, -12.369709141424345],
              [-18.345170382706044, -12.367054965134738],
              [-18.344414262790444, -12.365944844501858],
              [-18.342039684945412, -12.365683408598631],
              [-18.341548103729718, -12.365172276428623],
              [-18.34196756728003, -12.363250759005505],
              [-18.338343323390294, -12.362402870398776],
              [-18.33613163744031, -12.360493886972744],
              [-18.335204829454316, -12.360916111547004],
              [-18.33314765424339, -12.360235981471615],
              [-18.332671129689366, -12.357998971861068],
              [-18.33315906361151, -12.356854704594943],
              [-18.334490010158866, -12.357296052016943],
              [-18.335050578368215, -12.355639776554222],
              [-18.337510617289595, -12.355021124990024],
              [-18.338516400331923, -12.35362666102685],
              [-18.34038817776506, -12.353088096928591],
              [-18.33937436652937, -12.351575725057058],
              [-18.339463645679555, -12.348881377020863],
              [-18.340644482313284, -12.34869063259592],
              [-18.34189238401879, -12.345782782571888],
              [-18.340507825911686, -12.344450899766894],
              [-18.340398729102855, -12.342061495231603],
              [-18.3373300279106, -12.337641319019983],
              [-18.334737732887675, -12.335629890582807],
              [-18.333838859335362, -12.333661288766981],
              [-18.333870386763127, -12.331676008422434],
              [-18.332071635534035, -12.330066559836455],
              [-18.332173480340426, -12.328975038313015],
              [-18.331123411110593, -12.32833234631998],
              [-18.329707158531757, -12.324984981569424],
              [-18.328874957025658, -12.32453633798099],
              [-18.326278001994012, -12.324901845600053],
              [-18.32542805793732, -12.32320583839322],
              [-18.325822398454722, -12.32234745116073],
              [-18.327276261973964, -12.322089397833576],
              [-18.328604383697016, -12.320924423448542],
              [-18.32886434522874, -12.319870596180756],
              [-18.33197249994361, -12.31628706325693],
              [-18.3358887516619, -12.313392638240089],
              [-18.339541836106065, -12.312055340651801],
              [-18.34137836327654, -12.310845189353946],
              [-18.346773817077622, -12.308031429070768],
              [-18.347664340796833, -12.307245718693714],
              [-18.35244817032183, -12.307070085529011],
              [-18.357139609431773, -12.305594170354432],
              [-18.359006688552547, -12.306053891027968],
              [-18.360027631248602, -12.305164399378318],
              [-18.36121463390457, -12.305086016273913],
              [-18.362839530775762, -12.304130554433751],
              [-18.366149076059788, -12.30372345967726],
              [-18.36807105816576, -12.304268966559873],
              [-18.371067769252868, -12.305821956357539],
              [-18.37221652035238, -12.305837306452625],
              [-18.37397279190487, -12.307130344656429],
              [-18.37365412816874, -12.31059743088093],
              [-18.37140509858317, -12.31189249651639],
              [-18.37355187866256, -12.31542333078919],
              [-18.373450323530413, -12.317152630710286],
              [-18.37261046349911, -12.320827909798389],
              [-18.373660865643018, -12.323629125296852],
              [-18.375739200086166, -12.32482717454711],
              [-18.37601084102362, -12.326272955725411],
              [-18.37700680429893, -12.326393337296624],
              [-18.378586743115473, -12.327519665165477],
              [-18.38076227740788, -12.326843106646002],
              [-18.383759092268892, -12.32635863133098],
              [-18.38410822708236, -12.32504240410522],
              [-18.3852824100856, -12.323516815963652],
              [-18.38684485142664, -12.322435891061115],
              [-18.388918773639993, -12.319434744243026],
              [-18.389982518509605, -12.319272595597901],
              [-18.39127824953587, -12.317552497171903],
              [-18.391940009643836, -12.315314601992432],
              [-18.39341222817408, -12.313992147951472],
              [-18.39439518874575, -12.313722249795632],
              [-18.39623355999139, -12.314340671615973],
              [-18.39724930434064, -12.315949336280896],
              [-18.396398689531736, -12.317401363654865],
              [-18.396588241603503, -12.31844043891872],
              [-18.3955371069339, -12.321792597660393],
              [-18.396318564058998, -12.323399885194183],
              [-18.396390580602485, -12.325211142096386],
              [-18.397740745688516, -12.32915390036958],
              [-18.398852033136542, -12.32848176877347],
              [-18.39931004526916, -12.32658085370885],
              [-18.40187964246851, -12.321646429901191],
              [-18.403231138006326, -12.320792426328495],
              [-18.40481100812714, -12.32088205916745],
              [-18.40828174146432, -12.322387608166363],
              [-18.410139775219196, -12.324702719469599],
              [-18.409190307432397, -12.326348886581165],
              [-18.4099779770761, -12.327749074779346],
              [-18.412436821743306, -12.32794351267724],
              [-18.413942808799213, -12.330244485693072],
              [-18.413940075569716, -12.3324734702407],
              [-18.413051736874174, -12.333770680690257],
              [-18.411305417889253, -12.334432146491885],
              [-18.408718748162176, -12.33741998576512],
              [-18.408848402758004, -12.339063813171238],
              [-18.40753536228758, -12.341617090904073],
              [-18.409046469618268, -12.347002368511468],
              [-18.41129926730671, -12.347216273888241],
              [-18.413127713196936, -12.346156309545181],
              [-18.41423380533611, -12.346172851706946],
              [-18.41908085969263, -12.344474810575864],
              [-18.42014501414115, -12.342792475521694],
              [-18.422344332874435, -12.34294020589848],
              [-18.42361561843886, -12.344712023225048],
              [-18.42161658747695, -12.349699554692998],
              [-18.418934370164585, -12.351182092944725],
              [-18.41658902306854, -12.353508815883519],
              [-18.417935873106295, -12.354079179787181],
              [-18.421887734788463, -12.351906498975062],
              [-18.424329370114005, -12.350790357493826],
              [-18.42498125557049, -12.349972623577539],
              [-18.426773337010605, -12.350524405889049],
              [-18.42785153614135, -12.3499901164122],
              [-18.428302893292553, -12.348545906017252],
              [-18.428229256846343, -12.346274732301554],
              [-18.428850813389975, -12.345390398393084],
              [-18.4283213293457, -12.344265226086131],
              [-18.429032153763103, -12.342337984999427],
              [-18.430177629825547, -12.340785517532309],
              [-18.433569108122665, -12.337649842998957],
              [-18.43497924519601, -12.338395605297734],
              [-18.43154693547203, -12.343329713950435],
              [-18.432290664015127, -12.344481448482412],
              [-18.43205801582547, -12.34574491344926],
              [-18.432762839760446, -12.347475451269156],
              [-18.432707863686865, -12.348631050008779],
              [-18.4336392155405, -12.350019341450885],
              [-18.43370874598547, -12.351992229423953],
              [-18.433025166155957, -12.353711610663128],
              [-18.433121539278048, -12.355222197766109],
              [-18.43226467949734, -12.356777426453872],
              [-18.43140092253445, -12.360903611272766],
              [-18.432114678668434, -12.36371807732085],
              [-18.433667909675485, -12.364444946316219],
              [-18.434668550312963, -12.364085988525087],
              [-18.437977530566304, -12.364223367856493],
              [-18.440252001080804, -12.362150953318466],
              [-18.44173465638386, -12.362637975919593],
              [-18.4422204593066, -12.364275210456046],
              [-18.44303100744848, -12.364132249900454],
              [-18.446250738558298, -12.365024578878941],
              [-18.448167664378317, -12.364906927958105],
              [-18.44941743351709, -12.365414469492569],
              [-18.45091976892871, -12.363894440368975],
              [-18.451796568310748, -12.363952096776261],
              [-18.453261877218875, -12.36229698945293],
              [-18.45355288089362, -12.36116424353112],
              [-18.455289656876754, -12.3613501042158],
              [-18.457505412849777, -12.363080785960388],
              [-18.458048311103678, -12.364067592895424],
              [-18.45836480717347, -12.366365823163566],
              [-18.45596731322018, -12.367393547368897],
              [-18.45576584205267, -12.369209859134276],
              [-18.457623020988095, -12.368439308370174],
              [-18.459239355814752, -12.366884445226512],
              [-18.461033662323295, -12.366925810763677],
              [-18.462920738561706, -12.36891016175175],
              [-18.46294181753086, -12.36983788136764],
              [-18.466353589505342, -12.369060499562934],
              [-18.46750980728293, -12.368353629652676],
              [-18.469211191654882, -12.368886844731524],
              [-18.471504680718432, -12.367520292323468],
              [-18.473248075565888, -12.367519077640653],
              [-18.47401470560437, -12.36668678332798],
              [-18.477008001679906, -12.365738056155186],
              [-18.479863941170564, -12.362680973946102],
              [-18.481749264639884, -12.362688295506798],
              [-18.483436884157975, -12.361383648661016],
              [-18.48845096496308, -12.358529908981579],
              [-18.490111112460596, -12.359594153479973],
              [-18.49247711531848, -12.36314481347945],
              [-18.493066069185698, -12.366566156971471],
              [-18.492179814394547, -12.36737386717303],
              [-18.48977218897419, -12.368524284984872],
              [-18.48902221768255, -12.369517531392209],
              [-18.486784904949506, -12.369775372353473],
              [-18.48601801381859, -12.370839102937078],
              [-18.48454524123794, -12.371439272424835],
              [-18.48307036370058, -12.37321569305234],
              [-18.479017184706304, -12.377310302675419],
              [-18.478894042185996, -12.378936555084788],
              [-18.4813200109515, -12.380291284749017],
              [-18.48324241441639, -12.379982029728046],
              [-18.48514981504247, -12.378994730138702],
              [-18.48753138209642, -12.380892904339385],
              [-18.488046562361692, -12.38257829652115],
              [-18.489056096609563, -12.384141690305164],
              [-18.49214561671979, -12.387450847763084],
              [-18.495693815613716, -12.388916852098442],
              [-18.497697232641244, -12.388679069987823],
              [-18.498515080145975, -12.391673052530606],
              [-18.498555209275928, -12.39479214679935],
              [-18.49809815746625, -12.396494293221108],
              [-18.499726137592596, -12.39860406102676],
              [-18.49972271389007, -12.399990839630766],
              [-18.501815195383436, -12.400831590678642],
              [-18.503218540900715, -12.40430997250399],
              [-18.503081358258353, -12.407114441613077],
              [-18.502196106064076, -12.409141257601322],
              [-18.50544932824065, -12.415654501944015],
              [-18.507558984262115, -12.417581601884217],
              [-18.509400982279743, -12.417544222948932],
              [-18.510331561347662, -12.418797455843794],
              [-18.51158934712582, -12.419301690290567],
              [-18.51248901558106, -12.420951245358914],
              [-18.513844570720384, -12.420710121144413],
              [-18.51568112503388, -12.42138522183604],
              [-18.51927346285724, -12.420854004646138],
              [-18.518862762952097, -12.419134652011778],
              [-18.520191553918753, -12.412619558713681],
              [-18.520073232936987, -12.411451043591402],
              [-18.52102326531422, -12.40728794287381],
              [-18.521197261255622, -12.403871662401713],
              [-18.524457364878373, -12.398030525795333],
              [-18.52481870846573, -12.396138133654185],
              [-18.525671135924945, -12.394399449452878],
              [-18.525044424631403, -12.393813337448206],
              [-18.52518619798175, -12.39224916186361],
              [-18.52457255663422, -12.38952862466441],
              [-18.526661870147585, -12.38696721686552],
              [-18.52747094195552, -12.384971827905131],
              [-18.52700850126168, -12.383455636474222],
              [-18.526196746958, -12.382933303263142],
              [-18.52543441127088, -12.379558377647259],
              [-18.526372146967045, -12.377562085645579],
              [-18.524370088711567, -12.376060393865833],
              [-18.522814197208323, -12.376072951022065],
              [-18.521852338482077, -12.374966375739826],
              [-18.52337575078903, -12.374172133575627],
              [-18.526015368022197, -12.374146210172633],
              [-18.52856647871621, -12.374700536303328],
              [-18.52900354346902, -12.37584722227568],
              [-18.531115623604943, -12.376429127874475],
              [-18.529342943865675, -12.37828725973743],
              [-18.530927217324102, -12.378569300393437],
              [-18.532151582507115, -12.380911132353702],
              [-18.530538472891706, -12.38217370286046],
              [-18.530208795669584, -12.383847231809819],
              [-18.53127754348103, -12.384530941181616],
              [-18.53202819641307, -12.386205563122688],
              [-18.53404216433542, -12.388003142157205],
              [-18.535229998933342, -12.390370915479847],
              [-18.5385836721437, -12.393346922923795],
              [-18.542684638590035, -12.394454673244404],
              [-18.54316046895018, -12.393729153654498],
              [-18.54570722660083, -12.392530617745061],
              [-18.547279869771568, -12.391057833281993],
              [-18.54871510691847, -12.39148538219139],
              [-18.550902225779673, -12.389301127225943],
              [-18.551715642358573, -12.388943383529082],
              [-18.55429270035264, -12.38962950614187],
              [-18.5557868443439, -12.389534336315727],
              [-18.56001484224115, -12.390348477184352],
              [-18.562452355807388, -12.39218591428307],
              [-18.563307549299587, -12.394482072599537],
              [-18.563451337052914, -12.39610895041056],
              [-18.562948224766398, -12.39780456921172],
              [-18.56129309217176, -12.398730042402667],
              [-18.560002762182418, -12.398604257402475],
              [-18.558837760948318, -12.399688219152717],
              [-18.557119583236755, -12.400209890572732],
              [-18.552469272896552, -12.39983874675606],
              [-18.55184996098488, -12.400478402216608],
              [-18.548108451594064, -12.402502473295442],
              [-18.54362363579606, -12.403487747176582],
              [-18.542305206382974, -12.403316604239437],
              [-18.541026138968892, -12.406056024319241],
              [-18.540301345016992, -12.408731904979888],
              [-18.540823840531132, -12.41190649492443],
              [-18.541170599332244, -12.415790216871322],
              [-18.541691998992917, -12.417353281490229],
              [-18.54444991362007, -12.421829097783428],
              [-18.54582994318593, -12.423036687092885],
              [-18.547152575081725, -12.422998931011216],
              [-18.549590060950514, -12.423661967860436],
              [-18.55625427252712, -12.422817364207031],
              [-18.560551191455797, -12.422900294946253],
              [-18.563468448469962, -12.42270216879065],
              [-18.56658590811194, -12.423734792938461],
              [-18.571288923589968, -12.42203583320838],
              [-18.574935635062513, -12.418194866911321],
              [-18.57724669339938, -12.417197449825773],
              [-18.578602139985634, -12.415902702775485],
              [-18.57920717852459, -12.411997406263929],
              [-18.579073679566672, -12.40978063080231],
              [-18.578517053150588, -12.408386087503581],
              [-18.57505436014039, -12.404962433231528],
              [-18.574485720355593, -12.403088559249372],
              [-18.576224660577846, -12.40058665873732],
              [-18.580015322073688, -12.397959552884638],
              [-18.583043793089434, -12.397074388525619],
              [-18.588720627812673, -12.39640504524941],
              [-18.59191241906232, -12.397051601024874],
              [-18.59512636654569, -12.398782341239],
              [-18.595303091202823, -12.39937199235007],
              [-18.59746758682274, -12.400533025200591],
              [-18.59874745361308, -12.401651710545439],
              [-18.59943405203577, -12.403728812626555],
              [-18.600998711764746, -12.405194008862992],
              [-18.60204768874172, -12.408559598140794],
              [-18.605847167088594, -12.411944080281444],
              [-18.605942061689372, -12.41290244924479],
              [-18.608012923614282, -12.415103387463178],
              [-18.607754894160404, -12.417980014777308],
              [-18.60982174860345, -12.421659568195928],
              [-18.611235816326676, -12.423523715943421],
              [-18.61287786530222, -12.424567676863914],
              [-18.616193331953557, -12.425615602616558],
              [-18.619835868470396, -12.427046645794263],
              [-18.62241720277389, -12.428309021920251],
              [-18.626180157553524, -12.430607764656843],
              [-18.627379203812836, -12.431805005018232],
              [-18.630161677415796, -12.433370723167357],
              [-18.637419168959784, -12.436323123073883],
              [-18.6410479292394, -12.43649837134688],
              [-18.64168991819766, -12.437150235222749],
              [-18.64452503124771, -12.437872568435168],
              [-18.650183948731932, -12.438991696682649],
              [-18.65151576829192, -12.440499363564808],
              [-18.653086678361316, -12.441377515088746],
              [-18.65446611542135, -12.442880207126338],
              [-18.655444321457203, -12.442915464498741],
              [-18.658846346481692, -12.444434922566108],
              [-18.662727807907707, -12.447040897141568],
              [-18.66456345534576, -12.446449635203658],
              [-18.66613139917963, -12.447103471340352],
              [-18.666930786739087, -12.446358706798257],
              [-18.669929167161552, -12.446803625340351],
              [-18.672249983404818, -12.446298466719053],
              [-18.674840485080363, -12.444392583884042],
              [-18.677074377687617, -12.444174902508019],
              [-18.677946320676377, -12.443476252355024],
              [-18.677552857487957, -12.442101381067932],
              [-18.67618628427791, -12.440529530801594],
              [-18.677061232148418, -12.437972775981972],
              [-18.678796235915488, -12.43629856312556],
              [-18.6805281281326, -12.435646244027359],
              [-18.6848286879463, -12.435226101458785],
              [-18.685097533228987, -12.435498978838057],
              [-18.69006398673714, -12.436119939232034],
              [-18.69416026058904, -12.437229316711099],
              [-18.697501638239405, -12.43900143251957],
              [-18.697087977720724, -12.440161942579875],
              [-18.698680075067855, -12.440359434774074],
              [-18.700847416128095, -12.439563840828933],
              [-18.704530832203286, -12.44201769071461],
              [-18.70663565073086, -12.441297913287553],
              [-18.70815760570379, -12.441502055209085],
              [-18.71185047564903, -12.440326676175486],
              [-18.714286637532748, -12.439801264151177],
              [-18.715380141085102, -12.436728324401454],
              [-18.716305449819995, -12.435486511936054],
              [-18.716041658643665, -12.432402188352114],
              [-18.71550110376664, -12.430208248829537],
              [-18.713600568045656, -12.429396880923376],
              [-18.7113296584549, -12.42771079753324],
              [-18.709963651054146, -12.425084889087044],
              [-18.708993357320725, -12.422524196867222],
              [-18.708024664904517, -12.421676886762361],
              [-18.707633318854167, -12.418307972016988],
              [-18.705762910529103, -12.412805574478442],
              [-18.706067899228707, -12.410521545464508],
              [-18.705654143267804, -12.408177801654823],
              [-18.70426122811201, -12.406800912463618],
              [-18.70406661113061, -12.404503122046355],
              [-18.704798209490423, -12.402219719957152],
              [-18.70365868855883, -12.400977602199417],
              [-18.70340141720292, -12.398548936374256],
              [-18.704693847803888, -12.39722379045906],
              [-18.704273023596507, -12.396250657265007],
              [-18.7007551135935, -12.393904222807],
              [-18.698850284945927, -12.391565352996391],
              [-18.69197395347371, -12.385117763362905],
              [-18.68988035224358, -12.381110329473232],
              [-18.690001568226307, -12.38031012160516],
              [-18.688217723421243, -12.378375936161863],
              [-18.68726865963761, -12.376674203423656],
              [-18.685324340107364, -12.3745964627875],
              [-18.684708033579533, -12.373345316513447],
              [-18.683420325324583, -12.372838008240645],
              [-18.680508125489073, -12.37085867920556],
              [-18.678189440641606, -12.36679388251007],
              [-18.677326091662415, -12.364598518560111],
              [-18.677765453272173, -12.360990779345476],
              [-18.676141802745363, -12.359595777095137],
              [-18.675941625634348, -12.358045970358175],
              [-18.676666647985652, -12.356118766344817],
              [-18.679008181873925, -12.35325320295386],
              [-18.680994905914186, -12.35183534266768],
              [-18.686245159279412, -12.349852122149375],
              [-18.689335717354062, -12.349015358006422],
              [-18.6938881818486, -12.348158118387092],
              [-18.701442278793206, -12.34747047440967],
              [-18.70630235028843, -12.347501569799984],
              [-18.711154210580567, -12.34800158565906],
              [-18.717581340074858, -12.349641092747481],
              [-18.72131306975171, -12.350239777945761],
              [-18.72607845842437, -12.353588195376878],
              [-18.72649284477692, -12.3546977937252],
              [-18.725786051115755, -12.355629369845472],
              [-18.725774551686705, -12.35843208334238],
              [-18.729027661861444, -12.359754646687376],
              [-18.730730561091384, -12.361158726953601],
              [-18.7305190883305, -12.362570536402803],
              [-18.732374108404898, -12.36425864282057],
              [-18.73281387831557, -12.366175905688603],
              [-18.73190996173128, -12.367735732819257],
              [-18.735373597908357, -12.369342170513976],
              [-18.736135073038554, -12.370244512243158],
              [-18.739276534062466, -12.372782951875084],
              [-18.741231486845617, -12.375687484149237],
              [-18.74131553867985, -12.377392016232214],
              [-18.740619332986043, -12.37890705510644],
              [-18.744356501277792, -12.380058255693257],
              [-18.746296217651505, -12.381227755125636],
              [-18.746823350930917, -12.383301326927961],
              [-18.744765256108764, -12.385480368540179],
              [-18.74469246339386, -12.386461852845834],
              [-18.746883546706158, -12.39251870402691],
              [-18.74705258091084, -12.393937213156716],
              [-18.746510446419087, -12.396155544907467],
              [-18.74669469111726, -12.397503073029993],
              [-18.747763538456457, -12.39921320498447],
              [-18.74796100081148, -12.402555702011538],
              [-18.748427752893367, -12.405078293910956],
              [-18.750180996476082, -12.410426418776163],
              [-18.75037690339345, -12.41286499591965],
              [-18.74966924103305, -12.41589483880307],
              [-18.74861597847931, -12.418220790657143],
              [-18.748454160251303, -12.419736501891773],
              [-18.748995865670626, -12.42101152728128],
              [-18.7522694909694, -12.425146841164052],
              [-18.756236252859686, -12.429692346376825],
              [-18.75920733706819, -12.432259390969524],
              [-18.76273405947427, -12.43667030534759],
              [-18.765441583299225, -12.43840731323366],
              [-18.77137768905012, -12.444799762607241],
              [-18.772814970446728, -12.44666085084573],
              [-18.777172952128797, -12.451163130107568],
              [-18.780363625204977, -12.455662457573334],
              [-18.78327197745517, -12.458215231375764],
              [-18.785558891174713, -12.459613864755616],
              [-18.788498590218744, -12.462363418969868],
              [-18.79023667370223, -12.465075157017882],
              [-18.791755099051876, -12.468168908948861],
              [-18.79332199886234, -12.47334517016294],
              [-18.793925462831485, -12.477959604184843],
              [-18.79484875003082, -12.478416703963969],
              [-18.795634419074705, -12.479836128909332],
              [-18.79833835538163, -12.479410389588582],
              [-18.799293070911606, -12.48135281168491],
              [-18.798270091667288, -12.482486360378328],
              [-18.799679527283306, -12.48375982017259],
              [-18.80280648144374, -12.48252961259614],
              [-18.80506793072055, -12.48051388116483],
              [-18.8069554901388, -12.477795117609313],
              [-18.80865166005623, -12.476242544447185],
              [-18.808799477569554, -12.475395065961546],
              [-18.81135798359099, -12.473590576424785],
              [-18.81311955391509, -12.471609838345222],
              [-18.81473392084128, -12.470952559813385],
              [-18.816514782261486, -12.47125573846022],
              [-18.819081156094448, -12.46999576998288],
              [-18.823085917602945, -12.47012810822529],
              [-18.824063311483524, -12.470688816948496],
              [-18.824380698563573, -12.472471437991004],
              [-18.825675817840892, -12.47308765623921],
              [-18.825586862215186, -12.475058990121749],
              [-18.823871816227346, -12.475869623486592],
              [-18.822302552579785, -12.475355274740643],
              [-18.822467890016007, -12.476876265051347],
              [-18.821248292239098, -12.477254190172204],
              [-18.821642529713955, -12.47888853948303],
              [-18.821651391488267, -12.481268857150392],
              [-18.820847655705254, -12.483652671203828],
              [-18.820530658237356, -12.485721945967672],
              [-18.819007906442444, -12.48732666782478],
              [-18.819848277285512, -12.490054029280042],
              [-18.821098346465735, -12.490490508409964],
              [-18.822629071826384, -12.489912064277759],
              [-18.823799556058137, -12.491245680562406],
              [-18.823487483570418, -12.492777925653254],
              [-18.81557912673327, -12.495955667635434],
              [-18.81476095057975, -12.495724637183699],
              [-18.81333857832989, -12.498158938011507],
              [-18.814188413971884, -12.500583664433828],
              [-18.813250573133317, -12.503265422218718],
              [-18.814368019481556, -12.504560167734962],
              [-18.81425795503958, -12.505415102019038],
              [-18.811475181362134, -12.509653415332911],
              [-18.813103958981426, -12.511975221582828],
              [-18.81320191248021, -12.51374152637299],
              [-18.814961991551478, -12.515968189278711],
              [-18.818386070607882, -12.517109651905841],
              [-18.819064975447702, -12.517977942821188],
              [-18.82102897300675, -12.518904604960039],
              [-18.823486668233038, -12.519199566589187],
              [-18.82611121295855, -12.51909983866971],
              [-18.827659154348027, -12.519595347131181],
              [-18.82977322224127, -12.521170863638332],
              [-18.83183293305239, -12.523267854022928],
              [-18.83306354230279, -12.523519943940723],
              [-18.834530960620942, -12.525476623688297],
              [-18.837149779091728, -12.52273734321973],
              [-18.83736007246911, -12.52162687617063],
              [-18.839629555131562, -12.5188741170023],
              [-18.843783569729734, -12.515100061215906],
              [-18.84771409279779, -12.512615823521948],
              [-18.85005415361094, -12.509502389259831],
              [-18.84806163247358, -12.507003753985504],
              [-18.845016784775847, -12.506035562402696],
              [-18.84389868537721, -12.5060993209274],
              [-18.8427988205532, -12.50478044985364],
              [-18.84548727645938, -12.50254002466864],
              [-18.844868998962106, -12.500672834919659],
              [-18.843303444826027, -12.498124424274886],
              [-18.844567833851556, -12.49675662091994],
              [-18.846419743676677, -12.496253718105208],
              [-18.850136282146746, -12.494591275693276],
              [-18.853204602577147, -12.494244635136974],
              [-18.85610091266214, -12.49480728052075],
              [-18.85810326331267, -12.49926607633238],
              [-18.860707076867268, -12.5020393873004],
              [-18.863911462939523, -12.50349930962596],
              [-18.866505717992744, -12.505992830008022],
              [-18.868389075777586, -12.510235384112814],
              [-18.86816123192475, -12.511644365449776],
              [-18.86674055699245, -12.513479555724619],
              [-18.8661991970818, -12.515254666904708],
              [-18.864585836034195, -12.517089807313452],
              [-18.865326263411376, -12.518007236964317],
              [-18.865460281792334, -12.520567680943527],
              [-18.864294310280854, -12.52328630924074],
              [-18.862825868363764, -12.523628016630425],
              [-18.862541879658462, -12.525349874868983],
              [-18.863247473992814, -12.526995342782396],
              [-18.86615843933744, -12.530396078742339],
              [-18.86817530093431, -12.533485758419445],
              [-18.870162840083236, -12.536073980756964],
              [-18.87236837389956, -12.537661752742178],
              [-18.876792615961005, -12.538811915786106],
              [-18.878830461592003, -12.538399077873008],
              [-18.881849729155146, -12.537021281294576],
              [-18.883986899971966, -12.534578290105104],
              [-18.88494640309038, -12.532138732843439],
              [-18.88603644318486, -12.530715074618968],
              [-18.886043563346774, -12.52815827364503],
              [-18.887089183371877, -12.523786754559023],
              [-18.888580470848645, -12.523064178072845],
              [-18.890432059135655, -12.52475886827557],
              [-18.890984621366368, -12.527551076218808],
              [-18.892222523571714, -12.529509454887435],
              [-18.894434263274547, -12.530081022011842],
              [-18.898301061564524, -12.528219828040609],
              [-18.900190251810297, -12.52833817216765],
              [-18.901546070834883, -12.527865510838101],
              [-18.90484975223051, -12.528698998782005],
              [-18.906575214189314, -12.529587320826346],
              [-18.907233962252512, -12.530584600247183],
              [-18.908333195735597, -12.530353950601352],
              [-18.908519278204786, -12.529017118635977],
              [-18.91061514032243, -12.527771193257614],
              [-18.911223001515893, -12.52691839444033],
              [-18.915199681337818, -12.524619426568593],
              [-18.9184232282623, -12.521542834758344],
              [-18.920152402727904, -12.520810229097586],
              [-18.920541087050722, -12.519565737866047],
              [-18.923111448857235, -12.516288696799547],
              [-18.923939675389907, -12.5141922415138],
              [-18.9235049612662, -12.5132621697635],
              [-18.925229474045498, -12.509412491022047],
              [-18.924484229761738, -12.507584629203611],
              [-18.925339757362828, -12.50443105287199],
              [-18.927535115570812, -12.502889633094215],
              [-18.926167224449625, -12.501796658644746],
              [-18.926060516122398, -12.499257067017492],
              [-18.92418381037082, -12.498725239356608],
              [-18.919813958876873, -12.498356407336983],
              [-18.918056979103326, -12.498670517562383],
              [-18.9151783065368, -12.497410645557386],
              [-18.912102447765147, -12.498057491424527],
              [-18.910366446373278, -12.500256744200477],
              [-18.90959582678113, -12.504552670999136],
              [-18.907870054577828, -12.505845025065996],
              [-18.90612699886415, -12.506272830497803],
              [-18.90318260330242, -12.507974063799562],
              [-18.901822790519816, -12.508400521154718],
              [-18.899755345022943, -12.507626181837464],
              [-18.898301153265976, -12.508063977386104],
              [-18.89710659573554, -12.506806717057454],
              [-18.89602208259789, -12.507690087967093],
              [-18.89318547133113, -12.507454938000707],
              [-18.892104174293472, -12.506511244094282],
              [-18.892815607317885, -12.504784489673614],
              [-18.89495809723846, -12.503185001985923],
              [-18.8971953513548, -12.502135573073888],
              [-18.899491201268123, -12.502460244767734],
              [-18.90044277503955, -12.501850311965569],
              [-18.902142802381043, -12.502201234261184],
              [-18.903667892972774, -12.500841148039429],
              [-18.904680712337473, -12.498865850564519],
              [-18.90707524869098, -12.495360522686795],
              [-18.9077996138754, -12.49283602674127],
              [-18.909110207399657, -12.491315358785176],
              [-18.9101218158046, -12.488658243071956],
              [-18.912648346759298, -12.487784604850374],
              [-18.916382467231983, -12.485211178249003],
              [-18.917494979906767, -12.482381275625748],
              [-18.917839801436585, -12.47918059271279],
              [-18.918752423287902, -12.47593223607182],
              [-18.918221867906315, -12.474993585450639],
              [-18.91868258947766, -12.47304188653387],
              [-18.9184836080001, -12.470261790344278],
              [-18.918755629167624, -12.469058866504646],
              [-18.918132976165857, -12.462777705620486],
              [-18.91830657821236, -12.458040607801607],
              [-18.91901969533011, -12.455475263264011],
              [-18.918536044567198, -12.45362131985404],
              [-18.921153847112297, -12.451190170951863],
              [-18.92476483408769, -12.44959055118044],
              [-18.926815254239, -12.44811742766359],
              [-18.932436533169657, -12.444580202740369],
              [-18.936069782235705, -12.444043138598163],
              [-18.938656101505334, -12.443380993691854],
              [-18.94031672301802, -12.441968245842753],
              [-18.939540371291333, -12.441026659361276],
              [-18.93768899004109, -12.441316479974137],
              [-18.93729093397737, -12.441957837597656],
              [-18.934221114130636, -12.442634695967142],
              [-18.9335497416915, -12.441878416905643],
              [-18.931016266387207, -12.442195363775628],
              [-18.929387899363082, -12.44283737213463],
              [-18.928863943494402, -12.441925329770806],
              [-18.930119101111416, -12.440626676199459],
              [-18.930157230412767, -12.438454868519916],
              [-18.926143225142944, -12.440173735295884],
              [-18.926061433123603, -12.438502634553464],
              [-18.926641804696896, -12.437629961839063],
              [-18.925987170188883, -12.436159270640108],
              [-18.927320861960318, -12.435230099969678],
              [-18.92922569889971, -12.436193998182583],
              [-18.929848060488712, -12.435171337053104],
              [-18.931872663043457, -12.435538010436245],
              [-18.932109378246217, -12.4347745362962],
              [-18.934023810602532, -12.433738057054889],
              [-18.934848346327712, -12.434193112040552],
              [-18.938246430066282, -12.433900161418611],
              [-18.93964167708247, -12.432019000286717],
              [-18.941039652343438, -12.432120471164396],
              [-18.945993960662392, -12.433819510845849],
              [-18.947851939211407, -12.435011123071826],
              [-18.94863551374662, -12.436660064356401],
              [-18.952215385692874, -12.43980309905354],
              [-18.95149784779046, -12.441128478355154],
              [-18.957160852181577, -12.447909129656612],
              [-18.959293294816423, -12.452190071782075],
              [-18.96121230016171, -12.456475812869773],
              [-18.961779262927116, -12.459605092308772],
              [-18.961025708961344, -12.461993612885744],
              [-18.95946169774148, -12.4626392926656],
              [-18.958342107013532, -12.463742015129366],
              [-18.95761898531104, -12.466009697743974],
              [-18.95806012290236, -12.466794924080096],
              [-18.95639264132639, -12.467921319068015],
              [-18.953692063029795, -12.467777192939],
              [-18.950661858085383, -12.468563226801823],
              [-18.94764614340385, -12.468387934965888],
              [-18.946639711542986, -12.471416584114326],
              [-18.946313117317576, -12.47344639915909],
              [-18.94446695748993, -12.474500790844916],
              [-18.94408323162455, -12.475929653360023],
              [-18.942641032312547, -12.478218987494332],
              [-18.943104212468207, -12.480429847215373],
              [-18.942107754268456, -12.481937275855895],
              [-18.94207401040541, -12.483837367082248],
              [-18.940146955053308, -12.485018691483383],
              [-18.93965776853756, -12.487281267769625],
              [-18.938206330639286, -12.488799831443412],
              [-18.93854568617782, -12.491706653419008],
              [-18.941301371857133, -12.494213716858862],
              [-18.943278086834873, -12.492673911332421],
              [-18.944279616709494, -12.492452974901878],
              [-18.946149766892542, -12.494603543663414],
              [-18.947115204071913, -12.496799341573597],
              [-18.947447579935243, -12.501794447623308],
              [-18.943484183891776, -12.50679904463135],
              [-18.9437965932008, -12.511119728309168],
              [-18.944282921079648, -12.51260517366749],
              [-18.942987684987116, -12.515138581664683],
              [-18.94391333975065, -12.517577139273344],
              [-18.94272942134157, -12.51951041447689],
              [-18.942559748665975, -12.52274614006681],
              [-18.941447324119, -12.524318610198955],
              [-18.941911648276804, -12.52672364319598],
              [-18.941662502455873, -12.527741006309974],
              [-18.939860704775537, -12.530645076429863],
              [-18.940763153662378, -12.53435747328703],
              [-18.941326008352522, -12.540039640450662],
              [-18.94206145035275, -12.543399471513938],
              [-18.942125861643245, -12.545693946082542],
              [-18.94146522044949, -12.54815114529915],
              [-18.938940444140517, -12.549809840196893],
              [-18.939626170889788, -12.5520734862905],
              [-18.941659447767385, -12.552296146961057],
              [-18.943530737698072, -12.550827310304172],
              [-18.945788307360456, -12.549694972087629],
              [-18.945142438532642, -12.547920082125245],
              [-18.945337667635002, -12.546673367556675],
              [-18.946470686300824, -12.544696411016735],
              [-18.949198387862378, -12.542587477496784],
              [-18.949239567366423, -12.541994816657304],
              [-18.951471251285515, -12.538703872963975],
              [-18.955052878007177, -12.536696462983636],
              [-18.95869450972746, -12.535502787036101],
              [-18.96325495863928, -12.53505923584406],
              [-18.96613606627537, -12.535722646357234],
              [-18.969941168671152, -12.537700076034657],
              [-18.97120714498197, -12.539228997714709],
              [-18.96960338511958, -12.542326082135682],
              [-18.969122421412536, -12.54429218614075],
              [-18.970125065945968, -12.545831971672303],
              [-18.969637672189496, -12.5468588430857],
              [-18.971667011858507, -12.546903195248046],
              [-18.972185487765028, -12.548599631251701],
              [-18.972997421010387, -12.549435700774833],
              [-18.97556022873851, -12.548611297422154],
              [-18.977496068526836, -12.549560439185747],
              [-18.977679127349695, -12.550957889910372],
              [-18.978712998804923, -12.551425903063397],
              [-18.980038041348717, -12.553018837747654],
              [-18.98192471946789, -12.553040626841229],
              [-18.983322080120548, -12.553769659110786],
              [-18.985670255988126, -12.553841741019172],
              [-18.988200539324154, -12.552242473890708],
              [-18.989806555148824, -12.550763294444502],
              [-18.992362821536318, -12.550594797156482],
              [-18.994366708963575, -12.551321947565382],
              [-18.995178921830203, -12.553027763281948],
              [-18.99688224917305, -12.554546519742145],
              [-18.99974235492412, -12.554125777675742],
              [-19.00267469032184, -12.553176920234106],
              [-19.004337007716273, -12.552118304973476],
              [-19.0060005971661, -12.551587333596649],
              [-19.007250504710836, -12.549634892026901],
              [-19.00736628543288, -12.54872553701562],
              [-19.00888812483615, -12.546478207951573],
              [-19.011819680181464, -12.544492291219166],
              [-19.01166891464075, -12.543053630163802],
              [-19.012762269098637, -12.541027891017507],
              [-19.01187140195292, -12.538769798563964],
              [-19.01199925879528, -12.537953474575811],
              [-19.01409700686151, -12.536053844840117],
              [-19.01599911401882, -12.53524189119003],
              [-19.01827047372526, -12.532280696948616],
              [-19.01837139615602, -12.530927492959448],
              [-19.019796801481146, -12.52646034079326],
              [-19.018816058114478, -12.52442841626868],
              [-19.018454641596364, -12.521656780594126],
              [-19.01664532587998, -12.520933086852459],
              [-19.014817642849735, -12.52094018706062],
              [-19.01452622430981, -12.518840914140782],
              [-19.016006019771538, -12.517024399601555],
              [-19.0171839806038, -12.514942816965224],
              [-19.01725406690593, -12.512678975031799],
              [-19.01786740932738, -12.51172898786387],
              [-19.02011091632002, -12.510398073679196],
              [-19.02091951535008, -12.507919373779385],
              [-19.02279956178256, -12.503303535630732],
              [-19.02333676274567, -12.499923095749198],
              [-19.024204136777392, -12.498564183753908],
              [-19.03491453737808, -12.487925113144225],
              [-19.037118839768677, -12.487207322382153],
              [-19.040107574547125, -12.486945975250702],
              [-19.042535820769118, -12.487135194713042],
              [-19.04531723549594, -12.488120598370164],
              [-19.05053022105839, -12.490325562849454],
              [-19.052151340388438, -12.49057541047022],
              [-19.054371177343697, -12.48928925247224],
              [-19.055462072349503, -12.489188242664435],
              [-19.05856263282601, -12.488016443773638],
              [-19.059641956295973, -12.490217504410037],
              [-19.058392296292777, -12.49221642923552],
              [-19.060968013517737, -12.493955935837988],
              [-19.061738536219302, -12.496127736694849],
              [-19.06418131113226, -12.498753640323203],
              [-19.06453461116915, -12.499879354839566],
              [-19.066928206379778, -12.503499042102838],
              [-19.068233854855126, -12.506234119766273],
              [-19.068510901940158, -12.508169904500463],
              [-19.067961034328984, -12.509372782610335],
              [-19.06818667540251, -12.510669655715885],
              [-19.06662806035185, -12.512844849920528],
              [-19.06454425660123, -12.514773818519796],
              [-19.0615490607948, -12.51673231856904],
              [-19.05973136805509, -12.517496138907603],
              [-19.055439621055882, -12.517311491219305],
              [-19.051075004884282, -12.522334872420528],
              [-19.049117705907573, -12.523821263311307],
              [-19.046931830167377, -12.526420020893841],
              [-19.04566482259146, -12.52727339609468],
              [-19.0432968403562, -12.529683723671596],
              [-19.04156011358046, -12.530011009333391],
              [-19.03934420346454, -12.53337424380344],
              [-19.037962556997208, -12.534585527697757],
              [-19.037184509820182, -12.538312811892727],
              [-19.0370781055569, -12.540303573440903],
              [-19.037868525878782, -12.541468514740815],
              [-19.035440533467916, -12.544099165576275],
              [-19.038695708982182, -12.545641479514378],
              [-19.04247901600747, -12.549560830534197],
              [-19.044011358123104, -12.549571220645769],
              [-19.04833357831402, -12.551035905634516],
              [-19.050141637620246, -12.55187581031108],
              [-19.052175412942, -12.553627862892002],
              [-19.055317408683923, -12.554335342628331],
              [-19.058313015954717, -12.556051283773888],
              [-19.059997296966568, -12.557708857645352],
              [-19.060362198512284, -12.559771306539524],
              [-19.063181223203998, -12.561698507303717],
              [-19.06608597337917, -12.563154591593754],
              [-19.06771878455557, -12.565150077247877],
              [-19.069360851666584, -12.565445428612197],
              [-19.072206153480586, -12.565058634274669],
              [-19.073488444377237, -12.566252187153808],
              [-19.076206360946287, -12.569703361078288],
              [-19.077060546377727, -12.572676483853487],
              [-19.07776457545294, -12.573832648920181],
              [-19.079686065258823, -12.574750245544163],
              [-19.082301844283492, -12.574770580943605],
              [-19.083769220717016, -12.575891804014013],
              [-19.0854220179501, -12.576279499282647],
              [-19.086229687624762, -12.575838519962524],
              [-19.088716830174924, -12.575969787197458],
              [-19.092289605727792, -12.575573482449226],
              [-19.093537524021983, -12.575166036100137],
              [-19.094514999869922, -12.575718980287839],
              [-19.096181013802127, -12.578721755664933],
              [-19.095568647656318, -12.579845203050457],
              [-19.09717058979339, -12.580521057386283],
              [-19.09902928066293, -12.58234469571691],
              [-19.100148100728735, -12.582379445554107],
              [-19.10225840998899, -12.581568464300856],
              [-19.103994694032515, -12.581517623629015],
              [-19.106878250302877, -12.580362708961427],
              [-19.107713977636298, -12.578782404039359],
              [-19.107167834153394, -12.575693222631969],
              [-19.10826892701876, -12.57261270825391],
              [-19.108162025202624, -12.570880302336874],
              [-19.10938508550597, -12.566650341877814],
              [-19.1109242674703, -12.56613755766819],
              [-19.11028039139853, -12.56515716359434],
              [-19.11059390915475, -12.5637612574132],
              [-19.107464075830055, -12.563424210514995],
              [-19.106010284202924, -12.562403451296607],
              [-19.102791323872747, -12.561254296411086],
              [-19.101806858873854, -12.559771834227769],
              [-19.100453126702075, -12.560419162026486],
              [-19.097020745492248, -12.559442109654498],
              [-19.09583346239152, -12.557984518222673],
              [-19.09658138006409, -12.55473904798735],
              [-19.09504944028607, -12.552216732144686],
              [-19.09503979208544, -12.549951876365245],
              [-19.093966169251193, -12.548687177034134],
              [-19.095119875612728, -12.546312900433522],
              [-19.09756103876799, -12.54485395838494],
              [-19.09865304417913, -12.543219832218762],
              [-19.09900672990469, -12.541662836550119],
              [-19.098584743583935, -12.539363953983774],
              [-19.09721534009253, -12.536304082481553],
              [-19.096901015421412, -12.533803890784675],
              [-19.09562602310525, -12.532331794134585],
              [-19.092420146023247, -12.534516663683423],
              [-19.09056295296065, -12.534019078437819],
              [-19.090586815365565, -12.535852669200404],
              [-19.089080365269993, -12.539121637243335],
              [-19.084696819407714, -12.537839693214565],
              [-19.083699996047745, -12.539295361494906],
              [-19.082065025629714, -12.5390013962096],
              [-19.078980553398807, -12.540036119728862],
              [-19.076402794724117, -12.5432619886962],
              [-19.074555519491444, -12.543843955199106],
              [-19.07326817192525, -12.542606370953152],
              [-19.073943791286407, -12.540583239163691],
              [-19.07625741553558, -12.537535636440156],
              [-19.079993246650112, -12.535329723361883],
              [-19.086195469752493, -12.529611081192499],
              [-19.08680766350143, -12.526720800048993],
              [-19.08606176947594, -12.52489361524597],
              [-19.085140715471557, -12.524155592175468],
              [-19.083632879074045, -12.521086676770732],
              [-19.083673503390767, -12.520247478550576],
              [-19.0815498834759, -12.513988077606047],
              [-19.081684755003998, -12.510913365648737],
              [-19.081079650189846, -12.510056164877389],
              [-19.080699551115877, -12.50507893425542],
              [-19.081109314915373, -12.502578757577364],
              [-19.080526580301687, -12.500873320026116],
              [-19.081639071536234, -12.497243883519186],
              [-19.083995832618303, -12.494242169704963],
              [-19.08517919748973, -12.491449236141724],
              [-19.085515563184305, -12.48973479941012],
              [-19.084861256703277, -12.4882528592323],
              [-19.08322210962431, -12.486225249321134],
              [-19.082145994728926, -12.485763214799793],
              [-19.08133461365314, -12.484138118469733],
              [-19.08065335722277, -12.481416125565818],
              [-19.08199955511986, -12.481089988559491],
              [-19.085765115165188, -12.482870777651776],
              [-19.088285901723143, -12.485010414270327],
              [-19.08884266033763, -12.486529903769869],
              [-19.090194488117874, -12.487563593921967],
              [-19.092886941859906, -12.488224220609265],
              [-19.09708037435438, -12.489944403748485],
              [-19.101429925633248, -12.492064928356934],
              [-19.105336330372328, -12.494763061824681],
              [-19.105706544389584, -12.496638375161972],
              [-19.104648496508812, -12.497302454113177],
              [-19.100909599887952, -12.49575479174076],
              [-19.096881051859523, -12.49518626789631],
              [-19.096529576246922, -12.49640958763124],
              [-19.099156269193017, -12.49792502425243],
              [-19.103677421711275, -12.499223558780283],
              [-19.10597577922034, -12.498480780131203],
              [-19.106798147422143, -12.49752014133669],
              [-19.107694335322446, -12.493776454114094],
              [-19.106872625496653, -12.491776972340856],
              [-19.09611904449876, -12.48796417077075],
              [-19.093184717240405, -12.48663348766167],
              [-19.086324725650712, -12.482089409565996],
              [-19.08211559265758, -12.480229397747284],
              [-19.079085140829225, -12.478206521157642],
              [-19.077654860284937, -12.47694900062789],
              [-19.076699763653487, -12.476986345324567],
              [-19.07464516985124, -12.475392172852432],
              [-19.06713160733852, -12.471215816629407],
              [-19.064892927963495, -12.468990466186101],
              [-19.058759830983814, -12.466030325642684],
              [-19.05753665488788, -12.46591104457568],
              [-19.05397489733522, -12.464431835643673],
              [-19.05091308385451, -12.463749880407894],
              [-19.047049740154534, -12.462606694814536],
              [-19.045209900985004, -12.462481109110966],
              [-19.042607904199105, -12.463066569460224],
              [-19.040868614099256, -12.462973411188738],
              [-19.037285164517513, -12.461021042733531],
              [-19.03172658255146, -12.45694595580749],
              [-19.022658368034747, -12.448989259444028],
              [-19.018813940711993, -12.444779124865365],
              [-19.01628728607703, -12.442450789635632],
              [-19.01395571294896, -12.442200226008127],
              [-19.012584681753506, -12.444720274976422],
              [-19.014301644759495, -12.444678899069988],
              [-19.014675476946948, -12.447014071510676],
              [-19.01584795740841, -12.447185079406774],
              [-19.016834260215138, -12.44499617297598],
              [-19.020363531801397, -12.447986308839889],
              [-19.020037020561425, -12.44873138346987],
              [-19.01776879595724, -12.449969322625652],
              [-19.018713518497226, -12.452275898330802],
              [-19.022428185386584, -12.453838995692362],
              [-19.02542293861018, -12.454701831302291],
              [-19.02828366527439, -12.458016367290766],
              [-19.029375552136848, -12.459648772059595],
              [-19.031629155985108, -12.461359894071395],
              [-19.034215841641622, -12.462370340507025],
              [-19.03493899658936, -12.464099531095268],
              [-19.034356348356784, -12.46506771096127],
              [-19.032407030004833, -12.466547100239275],
              [-19.02833645911327, -12.466578962140634],
              [-19.027523852687658, -12.46762307947316],
              [-19.025730962284968, -12.467488191616082],
              [-19.025290502705108, -12.468109085862285],
              [-19.02224588387593, -12.46725120998687],
              [-19.01896716274832, -12.467088337445286],
              [-19.016713884884528, -12.465740604892572],
              [-19.01411020071552, -12.468381141600736],
              [-19.01314375390048, -12.46729206846348],
              [-19.010228069534794, -12.471143866038924],
              [-19.01008621009968, -12.472193014799142],
              [-19.007630098810612, -12.471768947289911],
              [-19.005767401205606, -12.472857900663113],
              [-19.005163779161116, -12.470924300478606],
              [-19.00566102166942, -12.470015573942067],
              [-19.005025922461982, -12.467921560703367],
              [-19.0011637582521, -12.466957466220403],
              [-18.996381699285138, -12.467025666181916],
              [-18.992715034126903, -12.468583790158934],
              [-18.990624567696123, -12.464879897097845],
              [-18.990696633414004, -12.463361142308127],
              [-18.99009713869975, -12.461393049501785],
              [-18.988086942916144, -12.457914162164915],
              [-18.988094721464247, -12.45622925014541],
              [-18.98516233598842, -12.454742629377815],
              [-18.985293494164466, -12.449769598988397],
              [-18.985549197169444, -12.448147015203665],
              [-18.98672884429419, -12.446636907676945],
              [-18.988827168507584, -12.445894424205145],
              [-18.98989021605552, -12.44626340565481],
              [-18.991681390744027, -12.448012066628857],
              [-18.992762246772486, -12.448416110863498],
              [-18.994412243856473, -12.447544727490344],
              [-18.995522375199126, -12.44622984330489],
              [-18.997175840629303, -12.445731558035423],
              [-18.99710983238468, -12.44387077658376],
              [-18.99601187908719, -12.442846984175507],
              [-18.99448314326653, -12.442708140408918],
              [-18.992148858140016, -12.439804117704254],
              [-18.993898421082587, -12.437237992263782],
              [-18.99152085353484, -12.436289481910137],
              [-18.988431982320456, -12.437115427928118],
              [-18.986741140787558, -12.435508497219333],
              [-18.984203860121617, -12.434867456011492],
              [-18.983495150782822, -12.437015219003435],
              [-18.983634712767138, -12.439425831590428],
              [-18.982239094167763, -12.440402464745349],
              [-18.981016800671803, -12.438460437628187],
              [-18.978451868500063, -12.436133052503532],
              [-18.978438422870617, -12.43394020507018],
              [-18.975549596022528, -12.432029251193223],
              [-18.97438240436077, -12.430827732702095],
              [-18.975533395377752, -12.429464182525706],
              [-18.975120028648135, -12.428537680211535],
              [-18.9719982962001, -12.42595756143343],
              [-18.968467867125106, -12.424923574973873],
              [-18.96551889476044, -12.425352834199987],
              [-18.964976826954533, -12.42733612837509],
              [-18.964047678261558, -12.427876290969522],
              [-18.961360889322588, -12.428130888455357],
              [-18.959758355378906, -12.428637415287628],
              [-18.956866173310022, -12.425958668424201],
              [-18.954538328533673, -12.424626333048934],
              [-18.954462243976806, -12.42300367395677],
              [-18.953475711544325, -12.422058087678579],
              [-18.951023100812957, -12.421207965641749],
              [-18.95009011255045, -12.420302186618297],
              [-18.9482796228863, -12.41713129315588],
              [-18.948715170305704, -12.416469667039653],
              [-18.95161719878271, -12.414651190578134],
              [-18.951171620445457, -12.41382311214069],
              [-18.946840083625535, -12.414939024008117],
              [-18.94572767354168, -12.413404135311982],
              [-18.943879067846588, -12.413128666738857],
              [-18.942352970182053, -12.410994340082722],
              [-18.940734580177722, -12.40710226574717],
              [-18.937418221130695, -12.402264018267122],
              [-18.937017400161068, -12.402827444091372],
              [-18.939223323436547, -12.40720249942344],
              [-18.938288163942897, -12.410535874583985],
              [-18.934419982915994, -12.412613647063054],
              [-18.93089979203008, -12.413588178842392],
              [-18.930120691272908, -12.41539742088225],
              [-18.926275628458132, -12.41910094260021],
              [-18.92216260785526, -12.418643230319722],
              [-18.91947725338053, -12.416677208003614],
              [-18.918106939936845, -12.416453349911368],
              [-18.914971995076662, -12.414007093209573],
              [-18.912811798281414, -12.411717877179704],
              [-18.912553285384035, -12.409982202208989],
              [-18.91132853769653, -12.409368748344898],
              [-18.91195798691249, -12.40777441698197],
              [-18.91097668782816, -12.406879966012003],
              [-18.90873684767184, -12.40700427971396],
              [-18.90957289491215, -12.403950657904364],
              [-18.90918734515761, -12.399584928751942],
              [-18.911540591540472, -12.397958424532662],
              [-18.91219714067888, -12.394803053175275],
              [-18.911542258209487, -12.392548068063073],
              [-18.909694684482997, -12.390324220896826],
              [-18.908371854345372, -12.387801717896508],
              [-18.90825746624265, -12.385491653682216],
              [-18.907035654614912, -12.382752815744006],
              [-18.907247760348213, -12.381875659682692],
              [-18.91473384391147, -12.381486310492813],
              [-18.916014370100807, -12.383097329858227],
              [-18.917995719525983, -12.38440987413465],
              [-18.92204478272241, -12.384711585236726],
              [-18.923545434955454, -12.385779449870142],
              [-18.92438474441872, -12.385653217470916],
              [-18.92477341453167, -12.383124461949835],
              [-18.922208705117114, -12.38135808016174],
              [-18.92059145808708, -12.380633604787462],
              [-18.91905251765888, -12.378982210387536],
              [-18.90782210420082, -12.370306710332711],
              [-18.902734155316217, -12.365560644846617],
              [-18.900715707371, -12.362843574819232],
              [-18.89819419062314, -12.360128930897458],
              [-18.89373096015112, -12.356248451028218],
              [-18.88919675702245, -12.35155395056845],
              [-18.884174632687593, -12.34692849782791],
              [-18.87795021645231, -12.341710358335796],
              [-18.871851138218055, -12.335564358969423],
              [-18.85998134455429, -12.322554362612108],
              [-18.854494391638173, -12.315723457546587],
              [-18.851272402082632, -12.311958107207648],
              [-18.848554711719213, -12.309618480417061],
              [-18.839313885962337, -12.303849844208473],
              [-18.825246172012804, -12.298658225907353],
              [-18.81437664518996, -12.289618189805187],
              [-18.812173733001288, -12.288111930330995],
              [-18.806737915428283, -12.282675860982772],
              [-18.804048327232113, -12.281349900558642],
              [-18.792804508199847, -12.280294496228276],
              [-18.787439940300384, -12.278097923689916],
              [-18.780195669679962, -12.274356649751837],
              [-18.773406617887744, -12.269891818614473],
              [-18.767842803939715, -12.265679526617136],
              [-18.763977945682925, -12.261927120208759],
              [-18.76093378787636, -12.259291191589002],
              [-18.758769314362006, -12.257703332165454],
              [-18.752888285575057, -12.252545867133707],
              [-18.751338806998426, -12.251759617469117],
              [-18.745584116502652, -12.25149605314329],
              [-18.74208675734563, -12.250893870079773],
              [-18.739555911013554, -12.250127465067838],
              [-18.72919969442203, -12.249012236305175],
              [-18.722799464492844, -12.247626300148351],
              [-18.71528555959191, -12.245599809999778],
              [-18.707250174607964, -12.242538604367574],
              [-18.70575537658579, -12.241856104373884],
              [-18.69217368054047, -12.239770246366028],
              [-18.67899815223524, -12.23838278916175],
              [-18.675493839449462, -12.237621285877463],
              [-18.666504418183948, -12.236358696578957],
              [-18.659653533356735, -12.234949902292325],
              [-18.648382190437847, -12.232474558802302],
              [-18.635579958419136, -12.228380460451977],
              [-18.62505782022409, -12.225791874528408],
              [-18.616442458186576, -12.225191958901203],
              [-18.60913161123361, -12.225823208773264],
              [-18.607395238514957, -12.226599950573817],
              [-18.608390934517782, -12.227817664447219],
              [-18.61247931508622, -12.227805927285972],
              [-18.614487717595647, -12.226954085417988],
              [-18.615717064746878, -12.227511203002905],
              [-18.617278565940396, -12.22684306756507],
              [-18.618097428489268, -12.227489059642547],
              [-18.62142546772611, -12.228007398937951],
              [-18.624453427777087, -12.227503981285393],
              [-18.62602681256678, -12.228207007163702],
              [-18.628433622245808, -12.227997299177892],
              [-18.62952432917997, -12.228979963448216],
              [-18.63565947442753, -12.229928827907134],
              [-18.645166477616364, -12.232574597793855],
              [-18.646402525923175, -12.234263224290848],
              [-18.646786678111972, -12.23579053790983],
              [-18.647668546275387, -12.236932836105991],
              [-18.64713111732453, -12.24129887647177],
              [-18.643056452937863, -12.242180558963819],
              [-18.64059382164091, -12.242203966309798],
              [-18.63775517906769, -12.2436942862943],
              [-18.63704286687177, -12.244409365476297],
              [-18.632706870828134, -12.243342503641392],
              [-18.63136082477973, -12.24242752302894],
              [-18.62925339399123, -12.242361451487904],
              [-18.62584544835551, -12.244474774669659],
              [-18.623833309225642, -12.24527018828399],
              [-18.62016436633643, -12.246081687540228],
              [-18.618332929888307, -12.24475169691763],
              [-18.618095965757952, -12.243320773249572],
              [-18.61878222990917, -12.242304033624471],
              [-18.617199302654466, -12.240955640167975],
              [-18.617222871845538, -12.24329010307741],
              [-18.615386762301885, -12.24403296642746],
              [-18.61209790525493, -12.243049582617006],
              [-18.612543007027078, -12.244973258793932],
              [-18.612304381563206, -12.247060581783899],
              [-18.60924383635458, -12.24936073956816],
              [-18.608206115992694, -12.25065221740054],
              [-18.60662398922035, -12.250987969120581],
              [-18.604747151466263, -12.250787078397106],
              [-18.602361470710022, -12.251124113744948],
              [-18.600723056998177, -12.249384719992145],
              [-18.598206511301633, -12.247888189159314],
              [-18.597632915094874, -12.248086836445822],
              [-18.59683857726922, -12.245511800914748],
              [-18.59600328655047, -12.24514040604135],
              [-18.59234192802636, -12.24501528388085],
              [-18.58973620608094, -12.243406330915057],
              [-18.587389899530383, -12.243327668096835],
              [-18.58590305446425, -12.243847136177303],
              [-18.584496098942648, -12.24293851591115],
              [-18.58239823074342, -12.240818739270209],
              [-18.581252235962946, -12.23841819687718],
              [-18.581249731689656, -12.236220846950928],
              [-18.57941343382967, -12.236088913654221],
              [-18.580314706634155, -12.23805328129645],
              [-18.579378744795015, -12.239251086658925],
              [-18.576573540223098, -12.23967556222505],
              [-18.575968021634054, -12.238821891557157],
              [-18.5739649559107, -12.2374876624671],
              [-18.57090777111599, -12.237642640169787],
              [-18.57125775911983, -12.236496915133099],
              [-18.573271999592674, -12.236199314039316],
              [-18.572348277589267, -12.235117641771643],
              [-18.56924447615566, -12.235799721669569],
              [-18.567158082747866, -12.235508381684857],
              [-18.56560083504696, -12.23657850463741],
              [-18.56490448800083, -12.237728502019515],
              [-18.56478057311575, -12.24215766516568],
              [-18.5654803017248, -12.244788020315161],
              [-18.565588972587758, -12.247895482681638],
              [-18.566601862014906, -12.25094910033748],
              [-18.565971029835318, -12.252937135029951],
              [-18.563606411572486, -12.254459190766896],
              [-18.563589447672882, -12.256064763349775],
              [-18.56552684229083, -12.257833357989757],
              [-18.565367286304326, -12.25959689593413],
              [-18.5675049094139, -12.259013730595372],
              [-18.5685777782575, -12.25633848732507],
              [-18.569773001769583, -12.255479030435122],
              [-18.57186834584296, -12.25105825737061],
              [-18.574145589746166, -12.250640018333087],
              [-18.575711307394997, -12.250846961776238],
              [-18.576756534101772, -12.25159442595172],
              [-18.57900093336727, -12.251426950995688],
              [-18.5817378995609, -12.252356863608549],
              [-18.582722003229318, -12.252099624369327],
              [-18.585885869461052, -12.253241091858584],
              [-18.589299189402265, -12.254952507094512],
              [-18.59458192968241, -12.25922066175783],
              [-18.596945698138175, -12.26159007347429],
              [-18.59838904605332, -12.264101048659988],
              [-18.59956094446361, -12.267557972706262],
              [-18.597878330125898, -12.270089155958113],
              [-18.59686101278538, -12.27550205077814],
              [-18.595717484251864, -12.27663007461568],
              [-18.5946653415243, -12.276004451590536],
              [-18.59255007419837, -12.276819383017259],
              [-18.592138006158716, -12.277780022667494],
              [-18.58940751913737, -12.278979677805026],
              [-18.587891783316742, -12.279273210706442],
              [-18.586478754797625, -12.278775621926773],
              [-18.5837895503475, -12.276434817545955],
              [-18.58278454319879, -12.276542922155244],
              [-18.582478872906897, -12.277762528601832],
              [-18.584882363990125, -12.280500169178454],
              [-18.587359970037607, -12.283919655113504],
              [-18.587799540682873, -12.285390171175152],
              [-18.58723312321219, -12.286229033986185],
              [-18.588447104255582, -12.289228219530484],
              [-18.58856212664541, -12.293351816646108],
              [-18.58623288708986, -12.298324867746523],
              [-18.582396114937804, -12.301521439175145],
              [-18.580339771694433, -12.302053126289966],
              [-18.579357163796814, -12.30164773083883],
              [-18.577939274873422, -12.303188410319132],
              [-18.576088258310236, -12.306670527959124],
              [-18.574127440130194, -12.308111295170674],
              [-18.574100328432674, -12.310162300869433],
              [-18.572137819429525, -12.314154779939548],
              [-18.570491672121086, -12.316805798272378],
              [-18.567451352679285, -12.31964193228475],
              [-18.567789447309433, -12.321036449657479],
              [-18.56588019925929, -12.322103562473938],
              [-18.566024392898807, -12.323469789848033],
              [-18.562301578691912, -12.326974818081451],
              [-18.56193620104225, -12.329313509199594],
              [-18.55953211989129, -12.330613885941068],
              [-18.557550287323394, -12.329661174388699],
              [-18.55792005099367, -12.326907682541188],
              [-18.558611046551466, -12.32587174238064],
              [-18.557714499895617, -12.323153765775366],
              [-18.55681133379806, -12.322336214375031],
              [-18.55421195009949, -12.322309443247793],
              [-18.550979369188042, -12.323321965294364],
              [-18.54785976473825, -12.324967118510248],
              [-18.543410347985894, -12.32865546805719],
              [-18.54279788739065, -12.32976422907457],
              [-18.5426350198904, -12.332015574872218],
              [-18.543263114738334, -12.33507129186277],
              [-18.54209827242501, -12.336811402854801],
              [-18.54253829406876, -12.337637809860366],
              [-18.541447224554542, -12.340002704984986],
              [-18.541147226758362, -12.342388766811974],
              [-18.540662781434424, -12.342713114134535],
              [-18.537567790660923, -12.342513575924444],
              [-18.536368578981172, -12.340927340865958],
              [-18.536109723046774, -12.337958735474366],
              [-18.53776226130052, -12.336644846115158],
              [-18.538303653387036, -12.333229928056625],
              [-18.538874551043868, -12.331470279976374],
              [-18.53793876393582, -12.331296994178501],
              [-18.536074287674918, -12.33383576340449],
              [-18.534632918988272, -12.333628051637454],
              [-18.53334358112985, -12.332323510210838],
              [-18.53350009923357, -12.331632941059745],
              [-18.532511302221685, -12.328597888532169],
              [-18.533185558023153, -12.327381089858745],
              [-18.53454330495513, -12.3262755574956],
              [-18.53861436475369, -12.323947500693203],
              [-18.539698741402614, -12.323978747729374],
              [-18.540509048829154, -12.32239059044739],
              [-18.53942143402598, -12.32175154136501],
              [-18.538553798230335, -12.320180808043029],
              [-18.538784102275592, -12.31831830889879],
              [-18.53961134691833, -12.317684464136805],
              [-18.541318965427426, -12.317837649983263],
              [-18.54239682772843, -12.316903256191088],
              [-18.543816587116154, -12.317452383694583],
              [-18.543882876534408, -12.315376122907034],
              [-18.54688750567004, -12.31535383259262],
              [-18.54818757129369, -12.314895338577694],
              [-18.550610005708545, -12.313031949639074],
              [-18.55081043821976, -12.31197394533786],
              [-18.55249048496039, -12.310518861500483],
              [-18.549863263690884, -12.30425280487289],
              [-18.550806063230247, -12.302273897484687],
              [-18.549268978821715, -12.300359886188147],
              [-18.54909334095092, -12.298677581969748],
              [-18.550321465837502, -12.297406523082516],
              [-18.549830067785653, -12.295847558557565],
              [-18.550535862807706, -12.295355611390217],
              [-18.55033583799949, -12.291709421596124],
              [-18.551068460510194, -12.290258075303056],
              [-18.55097904163917, -12.287099333442029],
              [-18.55177181745064, -12.285235772134328],
              [-18.55352340177447, -12.28230048733255],
              [-18.55522536105373, -12.280457351116405],
              [-18.555583655629206, -12.279156967709737],
              [-18.55500844164857, -12.275911008280856],
              [-18.55255130833187, -12.276157228322448],
              [-18.548034679520896, -12.278214418640815],
              [-18.545464592188186, -12.280076288022796],
              [-18.54236888974703, -12.283038989796978],
              [-18.537186347642233, -12.285795036075225],
              [-18.529975885856214, -12.287407123941254],
              [-18.528276637371373, -12.288337914907483],
              [-18.52590884714693, -12.288314538815248],
              [-18.523348217278013, -12.288729356038987],
              [-18.51957062636538, -12.288455614647418],
              [-18.517412659286034, -12.288895368729763],
              [-18.515924422212265, -12.28803559092761],
              [-18.5143452819688, -12.28868895393397],
              [-18.510692807139193, -12.289180819409472],
              [-18.508772266078218, -12.288265482773706],
              [-18.506405992425588, -12.28803520552999],
              [-18.504804334881467, -12.288878088959544],
              [-18.504713452997358, -12.286387264827512],
              [-18.504055824829763, -12.286105613155492],
              [-18.502142494913183, -12.287574392579641],
              [-18.502544113369815, -12.28923340192763],
              [-18.50177266818875, -12.28994986559984],
              [-18.500231992537813, -12.290006099591727],
              [-18.4975086840499, -12.289040058426542],
              [-18.49508502683374, -12.295226368736095],
              [-18.493849453101912, -12.295528141092142],
              [-18.49279477360307, -12.298107406168901],
              [-18.49143788543896, -12.29860382005297],
              [-18.492255237402947, -12.30068380978327],
              [-18.493799822470894, -12.301592330679455],
              [-18.495038399359377, -12.304596694377379],
              [-18.495569893405065, -12.30683791300463],
              [-18.495781012851136, -12.309670315668452],
              [-18.4951045345744, -12.310883658332521],
              [-18.495453467809323, -12.312963731734767],
              [-18.494910837508854, -12.314577959349924],
              [-18.493713396037087, -12.315749390214755],
              [-18.49143227853119, -12.316885969085034],
              [-18.48802049154835, -12.314682650799996],
              [-18.488140970496715, -12.31306279557333],
              [-18.487490393508956, -12.311241008894543],
              [-18.48455780872134, -12.309589794519162],
              [-18.48277823369149, -12.309584570113149],
              [-18.480671111737617, -12.31014101271224],
              [-18.479555802199222, -12.311198157129466],
              [-18.478022073523988, -12.315628126104336],
              [-18.478210500822456, -12.318965131741528],
              [-18.475543853662355, -12.31953748622451],
              [-18.475137819144862, -12.32113843136229],
              [-18.473363653931408, -12.321718590006656],
              [-18.47134681865282, -12.321264265820437],
              [-18.47019586745813, -12.321469636921332],
              [-18.466684831875053, -12.320642708852338],
              [-18.46551749978553, -12.321670946501584],
              [-18.46270370883187, -12.322667957125308],
              [-18.462522299667175, -12.324661390146002],
              [-18.459918193689774, -12.325408910540625],
              [-18.458943607718975, -12.32651071153358],
              [-18.457236009476976, -12.326806351931072],
              [-18.455813560152006, -12.325696828355888],
              [-18.45324678780954, -12.326347755075926],
              [-18.451386158047907, -12.322153209266109],
              [-18.452917875648538, -12.321000904786048],
              [-18.45414711665451, -12.32157675806369],
              [-18.454509585102958, -12.323381553019932],
              [-18.45559133456258, -12.322888300198732],
              [-18.45606145200741, -12.320425851193336],
              [-18.460113788308302, -12.315832417062591],
              [-18.45962244918802, -12.312708603794432],
              [-18.46294647924142, -12.31036201571174],
              [-18.46471760375261, -12.30819372227443],
              [-18.464159025331043, -12.306317086816765],
              [-18.460956850156688, -12.305697088253503],
              [-18.459814984068483, -12.306491940071334],
              [-18.456456012342976, -12.305701832419894],
              [-18.455870687155407, -12.304463184735253],
              [-18.45391722898473, -12.304044618095457],
              [-18.453550744538756, -12.305236209918686],
              [-18.450078376294556, -12.305075313495381],
              [-18.448649630803345, -12.305458594152132],
              [-18.447632489981775, -12.304634170184167],
              [-18.44541537796417, -12.304975789295357],
              [-18.44515069744309, -12.304173885349707],
              [-18.44696459515015, -12.302080082711194],
              [-18.44884335603718, -12.300730235264163],
              [-18.448577990135195, -12.298398662853549],
              [-18.449741431981884, -12.297832418917995],
              [-18.45092816740919, -12.295566979062448],
              [-18.45449340872651, -12.295607430440477],
              [-18.455607872437888, -12.295339162761747],
              [-18.458330661636246, -12.296533293347029],
              [-18.459305520633762, -12.29355276967712],
              [-18.460678211634676, -12.292736990932525],
              [-18.464104990204095, -12.293289103523316],
              [-18.465124583402822, -12.290589205802739],
              [-18.467308040273984, -12.289641535140289],
              [-18.467766922409652, -12.288589877479737],
              [-18.469840919932302, -12.28729498340948],
              [-18.470847285844368, -12.286099981587054],
              [-18.471364418148283, -12.284217214781593],
              [-18.474288713549708, -12.28348374045994],
              [-18.47503764503116, -12.281868861537616],
              [-18.47630743387169, -12.28164322026174],
              [-18.47799404867027, -12.278824489078874],
              [-18.480489732810472, -12.276252870744502],
              [-18.48102396053583, -12.274917839009515],
              [-18.49202564548708, -12.270755270488232],
              [-18.492641509868363, -12.26849700056704],
              [-18.49451172036329, -12.266622885866845],
              [-18.49619922287892, -12.265728274047447],
              [-18.49736392860856, -12.264288080827127],
              [-18.497320340256014, -12.26246015537116],
              [-18.498763621092365, -12.260077773544332],
              [-18.500716939295327, -12.26043924002007],
              [-18.502831653813715, -12.26147163914529],
              [-18.50663601957807, -12.26394411332722],
              [-18.503694205267696, -12.26028939673646],
              [-18.502035822180144, -12.256970049723867],
              [-18.4994707779532, -12.249938669208028],
              [-18.500283382737344, -12.247343930811214],
              [-18.50140860206106, -12.246000042747633],
              [-18.504291172345923, -12.244486504571125],
              [-18.506547572046028, -12.24463387067649],
              [-18.50883611509561, -12.2458483468505],
              [-18.50948735435019, -12.248283871478897],
              [-18.51073603733498, -12.249077625923572],
              [-18.51150892817106, -12.247950134292445],
              [-18.510608634906227, -12.245705096182483],
              [-18.507054704301705, -12.239995276582977],
              [-18.503008327878934, -12.235966891637354],
              [-18.49917377396941, -12.230806050005185],
              [-18.497579982597316, -12.227659954778517],
              [-18.496101292658683, -12.22645533302623],
              [-18.491707026801254, -12.221017008207514],
              [-18.48752830762269, -12.214660524996969],
              [-18.483308387189858, -12.207853802913574],
              [-18.48137998988175, -12.20438877519256],
              [-18.479995610119484, -12.201237195918184],
              [-18.47982625779523, -12.19901406027609],
              [-18.479170033327673, -12.195754076049514],
              [-18.478386707186132, -12.193959657981447],
              [-18.47556306992068, -12.188942588998927],
              [-18.475071536112086, -12.18680288278143],
              [-18.469041062631707, -12.174940051227946],
              [-18.46813934704193, -12.172230563969157],
              [-18.46610995890783, -12.167123566338617],
              [-18.462728901301155, -12.160121893152962],
              [-18.457223863610743, -12.151278494786816],
              [-18.455295534503527, -12.148747021662773],
              [-18.45197763945333, -12.145956663776492],
              [-18.44801824817413, -12.142981995530423],
              [-18.439554817848737, -12.138631062286102],
              [-18.43586614918952, -12.135528481917921],
              [-18.433681593658275, -12.134358317945818],
              [-18.429838675512865, -12.130947933499288],
              [-18.42544009297794, -12.125862121147437],
              [-18.422642246607335, -12.121117102080067],
              [-18.419200860457078, -12.119276517095658],
              [-18.416605879955643, -12.117247897760643],
              [-18.41286424847902, -12.113829283773399],
              [-18.41209851256591, -12.112567588528904],
              [-18.40987449336, -12.11296818980445],
              [-18.407214086452207, -12.112167565531124],
              [-18.405076943102664, -12.110549867017419],
              [-18.400758985751075, -12.110757670090583],
              [-18.395032436961362, -12.10823865333167],
              [-18.38387355084037, -12.100818306603271],
              [-18.380237248074437, -12.097884406305061],
              [-18.375975406048315, -12.095141366156074],
              [-18.370628357589478, -12.091092074375888],
              [-18.364871136903055, -12.086039176729797],
              [-18.357618131800486, -12.080168375040921],
              [-18.350810275982877, -12.073040425315957],
              [-18.346594314002107, -12.069614485581555],
              [-18.343813949623943, -12.067824031263614],
              [-18.331488984504333, -12.063556253720394],
              [-18.328252538514104, -12.061757388782812],
              [-18.31509617815109, -12.05727793589344],
              [-18.308486980263954, -12.054631689429213],
              [-18.30199404593684, -12.051703540196913],
              [-18.29049086976486, -12.046979063955536],
              [-18.2877459418213, -12.04538243546806],
              [-18.2830925060504, -12.042993626316601],
              [-18.278371680667224, -12.039733610545932],
              [-18.27648389579137, -12.039077033623098],
              [-18.271551021553407, -12.034889316619074],
              [-18.25792861096215, -12.025779442805655],
              [-18.255794650079654, -12.024871229024823],
              [-18.251855955734815, -12.025362891293742],
              [-18.247918833988386, -12.023652709745106],
              [-18.240365494516976, -12.019082812791918],
              [-18.236409325407653, -12.01880638948097],
              [-18.23299002933876, -12.01643876056271],
              [-18.231015674244468, -12.016232057158767],
              [-18.225513099881805, -12.013157875916317],
              [-18.21721323360086, -12.007540811722308],
              [-18.215736637770263, -12.007136568753241],
              [-18.208571855506715, -12.002674492192902],
              [-18.20206493194195, -11.999031677067679],
              [-18.199392503976426, -11.997821565531707],
              [-18.186787057473147, -11.990837249728472],
              [-18.17947817503589, -11.984829790267998],
              [-18.174420251783463, -11.980227875316306],
              [-18.168350337059483, -11.974913868508894],
              [-18.16419349119201, -11.971764216856627],
              [-18.15829940903238, -11.968037175575287]
            ]
          ],
          [
            [
              [-19.44063335063229, -12.746861153432109],
              [-19.43843920278659, -12.746444905924278],
              [-19.43737583339758, -12.745558238951181],
              [-19.435532873410647, -12.745758005975642],
              [-19.43384367556692, -12.746870033481366],
              [-19.43236476096541, -12.747178922475658],
              [-19.433782999607736, -12.748561927594338],
              [-19.43497077138521, -12.747842779876995],
              [-19.43735378337234, -12.74806096482594],
              [-19.43842915947827, -12.749017935865863],
              [-19.44043148081733, -12.747566465941212],
              [-19.44063335063229, -12.746861153432109]
            ]
          ],
          [
            [
              [-19.446043921937736, -12.740751089341554],
              [-19.44400193246002, -12.740647899346158],
              [-19.44198777787214, -12.738666003767216],
              [-19.439631840839557, -12.739621611536442],
              [-19.433416603572333, -12.73716114825422],
              [-19.432286850436597, -12.736021483350664],
              [-19.430107332077217, -12.736851136226758],
              [-19.42745843845559, -12.735330281531178],
              [-19.427817499941003, -12.73438468927638],
              [-19.42721283306887, -12.733136795627107],
              [-19.42541215161139, -12.735777446583963],
              [-19.420685451287635, -12.735980327009267],
              [-19.421072580252243, -12.740792415339119],
              [-19.42231500498614, -12.740402111917545],
              [-19.42417080293254, -12.7408743568559],
              [-19.424460913951982, -12.739075063072743],
              [-19.42659168086125, -12.738686500090589],
              [-19.43121289182803, -12.739459730158279],
              [-19.43356617252239, -12.741268282507194],
              [-19.4335797091865, -12.742227159676183],
              [-19.43588123689269, -12.74255459041473],
              [-19.437791982122718, -12.742319622508855],
              [-19.442085282268454, -12.744056003762651],
              [-19.44391264181128, -12.743473523218116],
              [-19.44398614983147, -12.742740734613443],
              [-19.44623059248589, -12.741706365558489],
              [-19.446043921937736, -12.740751089341554]
            ]
          ],
          [
            [
              [-19.4559067041312, -12.756203154600511],
              [-19.454326013908435, -12.75708401074561],
              [-19.45441154382425, -12.759042865042655],
              [-19.453248057684572, -12.759471771448426],
              [-19.453543274165487, -12.760626722555438],
              [-19.45460140936133, -12.761033201080641],
              [-19.456319597154177, -12.759792868827986],
              [-19.45667470179169, -12.757810735913154],
              [-19.4559067041312, -12.756203154600511]
            ]
          ],
          [
            [
              [-19.436740787201014, -12.611422492528527],
              [-19.43515208305315, -12.608986968959409],
              [-19.43260879766198, -12.606539914870062],
              [-19.432249551645178, -12.604858887522948],
              [-19.428691491012952, -12.603910337941869],
              [-19.427055693849073, -12.603198395032464],
              [-19.42296555298816, -12.603716179524378],
              [-19.420863720991466, -12.602411996055451],
              [-19.420096956916524, -12.601202073067137],
              [-19.41883752906413, -12.60097632795157],
              [-19.4164514613962, -12.599575158077121],
              [-19.416239925242007, -12.59832343787357],
              [-19.41514930819034, -12.597070613623496],
              [-19.41151945699045, -12.598130217739556],
              [-19.4100386065887, -12.598034792200199],
              [-19.408694876292216, -12.59686992539109],
              [-19.405490753315153, -12.595670281209044],
              [-19.40467537597701, -12.594159222773163],
              [-19.40262518442041, -12.595320169963905],
              [-19.40067863022519, -12.594917404983661],
              [-19.397867209915443, -12.59634210085551],
              [-19.396489666303072, -12.596276529434407],
              [-19.39340047303373, -12.595460347119928],
              [-19.39144101702298, -12.594392828469337],
              [-19.390487093151684, -12.59437825579629],
              [-19.389040302634726, -12.592872214568349],
              [-19.387757632637975, -12.592933269476159],
              [-19.386000800730155, -12.591904480828996],
              [-19.382777151137194, -12.588802039310869],
              [-19.382299110548864, -12.587689305478273],
              [-19.37904082040588, -12.583927496335226],
              [-19.376222204003017, -12.58031065024953],
              [-19.36944907925455, -12.570456758395876],
              [-19.36854565541757, -12.568676723198747],
              [-19.3674346553655, -12.568139775411028],
              [-19.364531030814238, -12.563092222251532],
              [-19.359623811572607, -12.55399829849174],
              [-19.36040180300467, -12.553116846462036],
              [-19.35922986629228, -12.551760460548003],
              [-19.357084498750964, -12.55171873706054],
              [-19.353226757164553, -12.547181343426352],
              [-19.34775240660811, -12.53811445120932],
              [-19.345045892435866, -12.533163654819974],
              [-19.343948159894385, -12.531797014349431],
              [-19.343306812285626, -12.527447984364668],
              [-19.343457409070023, -12.525413289259351],
              [-19.341116659651625, -12.520457046106934],
              [-19.34095183098715, -12.519158405447113],
              [-19.337283149724065, -12.518951269881894],
              [-19.334232148788953, -12.518221687456219],
              [-19.334469715953645, -12.516860628273832],
              [-19.3317356320836, -12.514213630538327],
              [-19.330405775331084, -12.51378246890338],
              [-19.328074165579874, -12.511663788067123],
              [-19.326363960861027, -12.511716973650827],
              [-19.32296500362931, -12.510023930449147],
              [-19.321682640949913, -12.510175514196003],
              [-19.32068913286611, -12.511062277127326],
              [-19.317933863723812, -12.509150339452505],
              [-19.316962051030874, -12.509276922163178],
              [-19.31458086744834, -12.508322821465296],
              [-19.3114686924223, -12.509724785037891],
              [-19.309084158384206, -12.511887828640983],
              [-19.30804385571972, -12.512189629444254],
              [-19.307105267575526, -12.514318496182584],
              [-19.30523425833289, -12.515622612703824],
              [-19.30421468037649, -12.515755552348427],
              [-19.30280319053951, -12.517059496964796],
              [-19.301527415679942, -12.519358121836456],
              [-19.301859364939393, -12.521268367391174],
              [-19.30051312195133, -12.522231271674459],
              [-19.297962761857686, -12.523236748882649],
              [-19.291567409734817, -12.523671391270332],
              [-19.29082265247129, -12.52265095394718],
              [-19.287355550275514, -12.522163982524523],
              [-19.283624484542127, -12.521385454016093],
              [-19.279418728947903, -12.520206129588798],
              [-19.276368429450624, -12.519133945470148],
              [-19.271727308264538, -12.517027278202734],
              [-19.268610829209763, -12.515373762764513],
              [-19.2630577406362, -12.511609432132753],
              [-19.26007210830218, -12.508472855044863],
              [-19.25981549322386, -12.507001762127347],
              [-19.258375936541757, -12.50813837922087],
              [-19.25736090415961, -12.508291059351588],
              [-19.255325158316438, -12.507488392077981],
              [-19.252970637196537, -12.505271359088976],
              [-19.252137211403774, -12.505349063825072],
              [-19.250720877210846, -12.50709458998901],
              [-19.249191677712783, -12.508125697632382],
              [-19.24681437946465, -12.508835162466063],
              [-19.24322421630013, -12.50951345328369],
              [-19.241335705715045, -12.509488382453988],
              [-19.236354846811018, -12.508532797006096],
              [-19.23442769525282, -12.507947123474244],
              [-19.226857167522986, -12.504921743491657],
              [-19.22144889736831, -12.502116469905575],
              [-19.21685772495062, -12.499896585296264],
              [-19.21245397278244, -12.49684741335257],
              [-19.202673225750647, -12.489079091460141],
              [-19.200413967382726, -12.488962873632207],
              [-19.196347533364676, -12.490734111187829],
              [-19.193816962638763, -12.490891712987027],
              [-19.18872294350279, -12.489728052077046],
              [-19.186091884583842, -12.489381312589527],
              [-19.18052014355732, -12.48743775732207],
              [-19.178493354115083, -12.4870963716596],
              [-19.176945642127922, -12.487532156452946],
              [-19.1766672258934, -12.48839534776512],
              [-19.174863579654488, -12.488891370189469],
              [-19.172273882204557, -12.4905590475077],
              [-19.168639017977934, -12.491530018900121],
              [-19.167078280581002, -12.492201324706848],
              [-19.164019395252893, -12.492523666601567],
              [-19.15887719501372, -12.493567050652388],
              [-19.15626821289412, -12.494317029644241],
              [-19.152952974688727, -12.494696613614598],
              [-19.14687616882271, -12.49464617206952],
              [-19.141087496842786, -12.495069110506252],
              [-19.137518355211256, -12.494870070981934],
              [-19.136228529201883, -12.495264059599828],
              [-19.13143143788854, -12.494249694807062],
              [-19.12864304370872, -12.495254328060499],
              [-19.12667726822705, -12.496612744407907],
              [-19.124296203016755, -12.497770630858732],
              [-19.121796131121336, -12.498286720109489],
              [-19.120218619653294, -12.498037992868499],
              [-19.117590607060023, -12.498994147014159],
              [-19.117217183162836, -12.499728292232511],
              [-19.114636095581908, -12.501171215285803],
              [-19.11408420208459, -12.503317220729347],
              [-19.11461713279385, -12.503995227534777],
              [-19.116636323457673, -12.503641889969256],
              [-19.115735605148515, -12.502427883140232],
              [-19.116658183995927, -12.500676553208214],
              [-19.118370380519707, -12.500366215127702],
              [-19.120034564426167, -12.499403684858628],
              [-19.122147648669536, -12.499365940730488],
              [-19.125049081477886, -12.498793353910367],
              [-19.12717893867825, -12.498705161553202],
              [-19.12949747541832, -12.496309496583002],
              [-19.130600470740077, -12.496929711409392],
              [-19.132278526937235, -12.49866779621919],
              [-19.132191243100714, -12.500678925078903],
              [-19.13292279614913, -12.50252743069012],
              [-19.131778824977346, -12.503911873865762],
              [-19.131590196240623, -12.506055608785719],
              [-19.12925337513031, -12.508502484887625],
              [-19.12746320022083, -12.509107419485346],
              [-19.127047095576913, -12.510860000101104],
              [-19.12473247288552, -12.513632666798616],
              [-19.12376769244119, -12.51379166099136],
              [-19.122551424347357, -12.5158450903316],
              [-19.11983027780444, -12.519310078722791],
              [-19.11780324711699, -12.52291288564602],
              [-19.11573392730984, -12.523932166967962],
              [-19.116156194380082, -12.524838173480804],
              [-19.115025453903552, -12.527492121446913],
              [-19.114492056316845, -12.530274745623387],
              [-19.113836755230217, -12.530908007878399],
              [-19.11324215674153, -12.533770415015676],
              [-19.11235885144339, -12.54209307145218],
              [-19.111820810684637, -12.544195248293939],
              [-19.110782327676084, -12.545188260469912],
              [-19.110221660860702, -12.550948079459813],
              [-19.11094152875861, -12.552404444646758],
              [-19.112903861623263, -12.553593717267512],
              [-19.113559576154795, -12.55626236340889],
              [-19.11279739078536, -12.55799590821892],
              [-19.113081315166692, -12.558782385160121],
              [-19.115883912383545, -12.56207322608329],
              [-19.114342939218773, -12.562783229993677],
              [-19.113911826429348, -12.565793699916235],
              [-19.11446297951457, -12.568077490785411],
              [-19.114194788395533, -12.569389541740172],
              [-19.11309318117879, -12.570629071876198],
              [-19.11215628245838, -12.573498349922891],
              [-19.110046896938616, -12.575137194288446],
              [-19.11040182181693, -12.576410511577473],
              [-19.1097329177982, -12.577802369848083],
              [-19.110750281131644, -12.581629831727641],
              [-19.111445680007847, -12.585573911821308],
              [-19.110788298763474, -12.588548263350336],
              [-19.109647837734187, -12.58903742568838],
              [-19.10932013056182, -12.59095013816048],
              [-19.10803119810454, -12.593421778450093],
              [-19.105820921024947, -12.59656472834129],
              [-19.104675528514633, -12.599702553840162],
              [-19.103572856601502, -12.60129724732499],
              [-19.102217116333325, -12.601815256160277],
              [-19.10091432046908, -12.601025091430209],
              [-19.09767168354835, -12.602583125812313],
              [-19.09421629159462, -12.601827862173188],
              [-19.092744769599662, -12.602384570466137],
              [-19.090149472545516, -12.602716804824459],
              [-19.08722026526526, -12.601060273481812],
              [-19.085568695989327, -12.60154634523613],
              [-19.08425739003051, -12.602883903415417],
              [-19.08274320373092, -12.602806780749008],
              [-19.08064903468411, -12.601555642671526],
              [-19.07832279896254, -12.60071402159541],
              [-19.07579992861829, -12.599000668865338],
              [-19.07501566720315, -12.597240022930752],
              [-19.073806074471793, -12.597593625385995],
              [-19.073583313036828, -12.599939945538049],
              [-19.072435000465738, -12.60106487828902],
              [-19.07120918383101, -12.601136667748797],
              [-19.069715342962553, -12.60034627520159],
              [-19.06876210545709, -12.601822595135655],
              [-19.067162269850453, -12.601991874285694],
              [-19.0662357330786, -12.6034881200648],
              [-19.06629209611005, -12.604567729944371],
              [-19.06427601669862, -12.606589473238957],
              [-19.063795877632725, -12.608332952169002],
              [-19.062389061097676, -12.609870451766254],
              [-19.061940479148316, -12.612011747229891],
              [-19.06131041249854, -12.612356878468104],
              [-19.059732076694967, -12.614745280091478],
              [-19.059905913420728, -12.617347461204572],
              [-19.05948374777001, -12.622774791714415],
              [-19.059792545293966, -12.626164712163304],
              [-19.060838653249508, -12.627728164026461],
              [-19.059457911353647, -12.62964172266525],
              [-19.057958135999336, -12.630198500017697],
              [-19.05457857750268, -12.63050993639066],
              [-19.052142969771644, -12.62993647122002],
              [-19.050633178973115, -12.630422770608481],
              [-19.052497266378495, -12.63159334421612],
              [-19.052573913729088, -12.634211163313392],
              [-19.051053371188072, -12.635835237743494],
              [-19.05463565558336, -12.63902642310071],
              [-19.055710880128274, -12.637863810127072],
              [-19.058550793042496, -12.63767236557206],
              [-19.059603702352515, -12.638075756894013],
              [-19.06342953531544, -12.636779764625754],
              [-19.06532999734712, -12.635102628573046],
              [-19.069835781340913, -12.635181445387314],
              [-19.073534736767126, -12.634539199201129],
              [-19.071441977088167, -12.632122129904015],
              [-19.0698002442219, -12.630994483576472],
              [-19.06825603473106, -12.630895331844984],
              [-19.066915463675315, -12.629489948429708],
              [-19.064732952014392, -12.62985529790854],
              [-19.06402213464008, -12.629122266598767],
              [-19.06330493326721, -12.626970195488475],
              [-19.06369668506504, -12.625449617105708],
              [-19.064983795560625, -12.625110675730093],
              [-19.06632374173701, -12.625829431014546],
              [-19.073808998053444, -12.623491591949676],
              [-19.07684681941134, -12.623173996670529],
              [-19.077692430650593, -12.623485216277507],
              [-19.080066095361424, -12.622594578302351],
              [-19.0822358169977, -12.623506846462645],
              [-19.083430398847145, -12.626256227594597],
              [-19.084444765588753, -12.62706527648081],
              [-19.084142260230887, -12.628006500434765],
              [-19.084964936147177, -12.629173230075844],
              [-19.08659088943333, -12.629330375835918],
              [-19.08685766218154, -12.626783839291708],
              [-19.085856328090802, -12.625049691151599],
              [-19.086053212043765, -12.62405177640601],
              [-19.08807144645058, -12.622545292248489],
              [-19.08923400619494, -12.622694305608654],
              [-19.09044477864448, -12.62385462856039],
              [-19.09298351957817, -12.62208655590112],
              [-19.089630454590612, -12.61852083035291],
              [-19.090004605617146, -12.617238909168488],
              [-19.091080959000784, -12.616452464044743],
              [-19.095968323720967, -12.618362923802376],
              [-19.097804275772138, -12.621330700693685],
              [-19.09872026691103, -12.619263491865253],
              [-19.10123934022814, -12.616194693916912],
              [-19.10229825444484, -12.613444991398318],
              [-19.1043233373285, -12.611840466204155],
              [-19.104231257823542, -12.610031133822359],
              [-19.104917470764537, -12.608066824046723],
              [-19.104300074901808, -12.605312977923091],
              [-19.103561933567267, -12.60390060823632],
              [-19.105092849791035, -12.602246524459046],
              [-19.10849064926512, -12.60109107507962],
              [-19.11203655284805, -12.6006235990954],
              [-19.11519443393533, -12.60115577745376],
              [-19.11783970699456, -12.602160331387205],
              [-19.118803887182224, -12.603280328792675],
              [-19.118670796895998, -12.604197969573594],
              [-19.1219962671061, -12.606030875433142],
              [-19.123905600649053, -12.607634568088502],
              [-19.12492844574204, -12.60914921156103],
              [-19.125077797905572, -12.610501413103279],
              [-19.124628833735528, -12.612576423696384],
              [-19.12332963234691, -12.614485953990357],
              [-19.123332227271376, -12.617824952440063],
              [-19.123005250049015, -12.619078512661634],
              [-19.123892206738798, -12.621323861232804],
              [-19.123714914510604, -12.622770015665175],
              [-19.12432029239734, -12.623586139876988],
              [-19.124608744833104, -12.62589195552187],
              [-19.125302632561205, -12.626814342040618],
              [-19.126700667823286, -12.63022211853621],
              [-19.12756528990779, -12.6308130240125],
              [-19.130758471844278, -12.629869610884043],
              [-19.137679182051134, -12.629470549313504],
              [-19.142302762000597, -12.629817854291712],
              [-19.14385854241198, -12.629646469532771],
              [-19.14484180955961, -12.632021788940245],
              [-19.145741967576722, -12.633009857520193],
              [-19.145583137978214, -12.634075833159068],
              [-19.14851121423154, -12.635940970635346],
              [-19.149297812549435, -12.635664255015266],
              [-19.15480005010456, -12.63616876235531],
              [-19.15933766283809, -12.636072776251867],
              [-19.160095532317726, -12.636748392196761],
              [-19.160612170323116, -12.639238318790792],
              [-19.162807258042385, -12.640897302654293],
              [-19.165039171410168, -12.639369803495159],
              [-19.168520955002364, -12.637735458264551],
              [-19.170417477468437, -12.637228109267493],
              [-19.17459865340725, -12.635231232448575],
              [-19.182285463312095, -12.632588951202605],
              [-19.192334522920685, -12.630123737860831],
              [-19.19804479480811, -12.628278693813616],
              [-19.203323290989587, -12.627443070549429],
              [-19.20656667334954, -12.626355392517487],
              [-19.209048709895896, -12.62730035610713],
              [-19.211587693863017, -12.627500791221973],
              [-19.21496400859463, -12.626486630225779],
              [-19.22041918885931, -12.625689949534708],
              [-19.2209444532586, -12.625779153026249],
              [-19.229617292407028, -12.624365411227743],
              [-19.235793419093454, -12.623503783756293],
              [-19.238600830438568, -12.623540922738613],
              [-19.24220219333158, -12.62319875559032],
              [-19.249623735887543, -12.622978366341503],
              [-19.2508682170244, -12.62345864535382],
              [-19.254191587019026, -12.622893561185967],
              [-19.25868638337497, -12.622960416792077],
              [-19.260966363221517, -12.623356911772591],
              [-19.263347928049043, -12.623310340951365],
              [-19.265217749314594, -12.623886246465062],
              [-19.270810633271942, -12.624569647455635],
              [-19.27614425255604, -12.625456335663896],
              [-19.28190598257205, -12.626728676910027],
              [-19.287933766983745, -12.628434547506059],
              [-19.291430845780354, -12.629713086289506],
              [-19.29755827449458, -12.632328574284932],
              [-19.30159284626546, -12.634356756023179],
              [-19.304797329798273, -12.636225011901598],
              [-19.313773608792644, -12.642236018012984],
              [-19.31435449085955, -12.64326650632866],
              [-19.316621488395715, -12.645206320449564],
              [-19.319326455984946, -12.649104188786971],
              [-19.319326537353806, -12.650319506014714],
              [-19.318552166917897, -12.651891774110496],
              [-19.3159215568165, -12.653175855258532],
              [-19.31670252043314, -12.655296911657747],
              [-19.318287495663476, -12.655721800253565],
              [-19.31965159586816, -12.657205608520572],
              [-19.31928512184682, -12.658882832311818],
              [-19.31972324711319, -12.660389526553804],
              [-19.319394017959535, -12.6622996716082],
              [-19.321787366275633, -12.664699654704759],
              [-19.321864010600986, -12.66578530244121],
              [-19.325054649570134, -12.668111366794555],
              [-19.327985331888563, -12.669426994514815],
              [-19.32825249422131, -12.670626723774257],
              [-19.32946832577169, -12.671633371737565],
              [-19.333013327081506, -12.672496145372847],
              [-19.33461105548853, -12.673133421207698],
              [-19.3352890755425, -12.674294312568612],
              [-19.336957673545726, -12.675063796222801],
              [-19.337679874135155, -12.676193947411297],
              [-19.341445810950592, -12.677045258018232],
              [-19.344641191498518, -12.67815144278348],
              [-19.346215590578943, -12.679842383383487],
              [-19.35265888880204, -12.680253052052915],
              [-19.354673192712603, -12.680871953763692],
              [-19.35931238907328, -12.679839637762255],
              [-19.367529989652134, -12.680134309530864],
              [-19.370033362454524, -12.681033313267895],
              [-19.372381528817257, -12.68068943394599],
              [-19.37734562604129, -12.681177572907727],
              [-19.378788005674714, -12.682481187324036],
              [-19.38316142715608, -12.683395070850203],
              [-19.384855643852255, -12.683247801334991],
              [-19.387759427001416, -12.684176858066758],
              [-19.389563878876807, -12.683509465375765],
              [-19.391950271263703, -12.681171698118915],
              [-19.395682922743315, -12.679552709976821],
              [-19.397285498469767, -12.679298761518513],
              [-19.398603613177993, -12.678515600444813],
              [-19.40021774373405, -12.678331354157605],
              [-19.40421241929366, -12.67858156045232],
              [-19.405682676974816, -12.679591096138333],
              [-19.409164742137925, -12.678534227036089],
              [-19.41029281479624, -12.677206258849871],
              [-19.412826260494477, -12.676060700311291],
              [-19.41609542313109, -12.67520319410662],
              [-19.418932819593007, -12.671927306172673],
              [-19.422699717913932, -12.668931867354944],
              [-19.423846716751562, -12.668891216099064],
              [-19.425478078051828, -12.66764877167334],
              [-19.425816535946915, -12.663840558343798],
              [-19.426355840896047, -12.660933253782387],
              [-19.42732544671985, -12.659701666924775],
              [-19.42940394215926, -12.658936691683335],
              [-19.429860065154177, -12.657572799876469],
              [-19.43007800353997, -12.653355799398348],
              [-19.429571866486512, -12.65152610197201],
              [-19.42991391903013, -12.649058404908876],
              [-19.430826751852916, -12.647645162517748],
              [-19.433427054152244, -12.647655227912281],
              [-19.433762226478557, -12.646597583730514],
              [-19.435530342328857, -12.644162495659229],
              [-19.435141573770586, -12.643460883324186],
              [-19.433468432347432, -12.64313435238167],
              [-19.432599277353113, -12.642200379619124],
              [-19.432084793365316, -12.640468787027844],
              [-19.432742574692075, -12.638858726693417],
              [-19.43285046255834, -12.635021741622845],
              [-19.435423062514417, -12.632576782453688],
              [-19.436209481466285, -12.632592657317817],
              [-19.437112848194424, -12.630274599159435],
              [-19.437186894675577, -12.626969828334428],
              [-19.437743884211002, -12.625209725158976],
              [-19.43674986249654, -12.62195964984133],
              [-19.437152206672696, -12.619724194748665],
              [-19.436255744401038, -12.619201769333774],
              [-19.436094130273034, -12.617821060965445],
              [-19.436853478296655, -12.615242135067325],
              [-19.436248007498357, -12.613123313933265],
              [-19.436740787201014, -12.611422492528527]
            ]
          ],
          [
            [
              [-19.519831212676316, -12.762665133995087],
              [-19.517721818270406, -12.763353047805667],
              [-19.51660419262954, -12.760358122036394],
              [-19.51558868244258, -12.75908121414587],
              [-19.51391684498377, -12.758298807282062],
              [-19.510376569732102, -12.757874423347946],
              [-19.508307763115067, -12.758505872043465],
              [-19.507094041780356, -12.76092301079617],
              [-19.505712963843926, -12.760669748176197],
              [-19.50489032074693, -12.759071255180341],
              [-19.503483091115545, -12.757810687038296],
              [-19.50408087579178, -12.75612260797943],
              [-19.50210529086863, -12.75529301824708],
              [-19.501057463498075, -12.756670080399813],
              [-19.499741732284896, -12.756790725632214],
              [-19.498304014953863, -12.755920300274177],
              [-19.49745458986412, -12.756445517895225],
              [-19.4955498099308, -12.759167191961739],
              [-19.494041545381524, -12.759319300080245],
              [-19.49213113468391, -12.758862806981414],
              [-19.491447516064873, -12.757771288496205],
              [-19.489249356954478, -12.757939811238003],
              [-19.489002891506722, -12.759665724753981],
              [-19.48626807239255, -12.761029137648801],
              [-19.484253282753453, -12.760251984368947],
              [-19.483100573996573, -12.763619096841737],
              [-19.480067118455416, -12.764115247904233],
              [-19.478790604685354, -12.763312384912318],
              [-19.478677560558477, -12.761501171909389],
              [-19.47421641161836, -12.763769896190198],
              [-19.469192549263592, -12.765069446308257],
              [-19.468366012484307, -12.764866865002771],
              [-19.46794934197071, -12.763297696371243],
              [-19.469626569799484, -12.762398951248791],
              [-19.472387024683695, -12.75973520935723],
              [-19.473590302663666, -12.759827718368424],
              [-19.47479349373475, -12.759053881713296],
              [-19.47387873167028, -12.757470207750261],
              [-19.47292433571739, -12.75767386981997],
              [-19.471039315730557, -12.759088178352876],
              [-19.468608608213344, -12.759050716773459],
              [-19.468889227693175, -12.760112181950074],
              [-19.468022003822693, -12.761985944067565],
              [-19.467035304599964, -12.762002216483676],
              [-19.466642779022177, -12.760573552345504],
              [-19.459463384996393, -12.76024642745711],
              [-19.458602984603964, -12.762166687205184],
              [-19.457599609631625, -12.76266606824159],
              [-19.459009483615564, -12.764844566556699],
              [-19.45795607550211, -12.766796230240503],
              [-19.45811406882481, -12.768889064754799],
              [-19.45972461260055, -12.771372970930942],
              [-19.461996103249067, -12.771920174303725],
              [-19.463511718295536, -12.774130903300291],
              [-19.464521210365017, -12.776857616772041],
              [-19.46535639190199, -12.777107824451926],
              [-19.46631065871653, -12.779217547353616],
              [-19.46795659202952, -12.780733554103252],
              [-19.46953164230624, -12.780381332212066],
              [-19.471958572226175, -12.778926532056287],
              [-19.473637659038335, -12.778315990129876],
              [-19.476795020797866, -12.780259609385906],
              [-19.4786347166905, -12.778272649167196],
              [-19.48108536310277, -12.778981023312522],
              [-19.482097605695213, -12.77881565994421],
              [-19.482668837991376, -12.780409689732883],
              [-19.485264374164935, -12.780515485425195],
              [-19.486573060055505, -12.778903161434455],
              [-19.489079200585653, -12.777914316912316],
              [-19.490742233308918, -12.777786102908392],
              [-19.49352264888163, -12.778100932181507],
              [-19.495062999751116, -12.77640148864588],
              [-19.49817192833286, -12.77603495997869],
              [-19.49843374140457, -12.774111535683641],
              [-19.50037412430382, -12.772152827024245],
              [-19.50331893208436, -12.770558702777995],
              [-19.504943059379173, -12.77135097182725],
              [-19.50506764040338, -12.773210575231039],
              [-19.50749053061948, -12.77517276536041],
              [-19.508197340058704, -12.77182551676361],
              [-19.509302630611227, -12.770485729752945],
              [-19.510970779345623, -12.769534615115239],
              [-19.512408578147344, -12.76953743138046],
              [-19.513488563653922, -12.768056842586686],
              [-19.51564047387218, -12.767892461071163],
              [-19.519458898322334, -12.766486963609783],
              [-19.519854483291546, -12.764781942826792],
              [-19.519831212676316, -12.762665133995087]
            ]
          ],
          [
            [
              [-19.57447861102235, -12.762726516457946],
              [-19.57280606374287, -12.76252851356039],
              [-19.57063109805602, -12.762850395141674],
              [-19.568962855789454, -12.7621203855614],
              [-19.564054702838174, -12.762133395842925],
              [-19.562534427258466, -12.763066510191969],
              [-19.56149476549478, -12.762519122489783],
              [-19.560334565474864, -12.763246001270815],
              [-19.558323450007457, -12.762814369132151],
              [-19.557226273963906, -12.763337584560528],
              [-19.55523030373635, -12.7627102542105],
              [-19.554285349933174, -12.761856800894932],
              [-19.552612070026225, -12.762766148300553],
              [-19.55163921961296, -12.76119416538309],
              [-19.549760034692145, -12.761221428670364],
              [-19.54871276044724, -12.75922798758278],
              [-19.54671886897962, -12.76168554609787],
              [-19.545415484996294, -12.762724749148246],
              [-19.544233539881187, -12.762489347957342],
              [-19.54156363792412, -12.763372084208106],
              [-19.541454738399267, -12.762474006065005],
              [-19.540150592574268, -12.761825006329136],
              [-19.538085973671237, -12.763328443739564],
              [-19.535355227854158, -12.763303823384822],
              [-19.53373082700512, -12.762804407462147],
              [-19.53208944762069, -12.763898753565158],
              [-19.53040048357942, -12.763313262196268],
              [-19.52887992335194, -12.76453156508542],
              [-19.528594476538057, -12.767423965873627],
              [-19.52689299107117, -12.769878066476476],
              [-19.525721489146914, -12.770266011394607],
              [-19.525732549115734, -12.773158097428723],
              [-19.52480582589555, -12.77466326722398],
              [-19.52801386235501, -12.777119653577323],
              [-19.529560098690254, -12.77377411575786],
              [-19.532792084790056, -12.774102730919575],
              [-19.53409066114299, -12.773306661772796],
              [-19.535315615080272, -12.774066707423097],
              [-19.535216089974025, -12.77519287949417],
              [-19.53623462734752, -12.776470215758403],
              [-19.53647335989491, -12.779519077197074],
              [-19.537333549683026, -12.781305639681314],
              [-19.53994966265881, -12.778406038382427],
              [-19.542509723301517, -12.777445815783937],
              [-19.542772347762327, -12.775278014617994],
              [-19.543822332885654, -12.773074785030548],
              [-19.54331952211441, -12.77219415979727],
              [-19.544144708261566, -12.77012573864523],
              [-19.54497572920826, -12.769214003388566],
              [-19.547545228008126, -12.76887838245993],
              [-19.548985390101212, -12.767767655551156],
              [-19.550094797520515, -12.767870349566197],
              [-19.550875478176845, -12.766677081137003],
              [-19.551760530903643, -12.766913967848657],
              [-19.55242000076699, -12.768394848741098],
              [-19.55342635921157, -12.767356748172054],
              [-19.55587437558753, -12.766895403631823],
              [-19.557870225175705, -12.766123593745816],
              [-19.56007908894754, -12.765991485709637],
              [-19.561670851071103, -12.764901661549214],
              [-19.563728570488443, -12.76503536635838],
              [-19.565268970369644, -12.765884201928102],
              [-19.567360859535324, -12.765094995467699],
              [-19.571962597312492, -12.764747295909533],
              [-19.57455618627254, -12.763437267063185],
              [-19.57447861102235, -12.762726516457946]
            ]
          ],
          [
            [
              [-19.595407343263105, -12.770349004918373],
              [-19.592576909762492, -12.77035192991812],
              [-19.589148964455806, -12.768138116396175],
              [-19.587042803660985, -12.767194988072447],
              [-19.586746563949784, -12.766376288485587],
              [-19.584504841043174, -12.765504492177456],
              [-19.584110282887202, -12.764413230066404],
              [-19.581848585122316, -12.763979180238602],
              [-19.581183755559124, -12.76525142280436],
              [-19.583015368839906, -12.76715936522945],
              [-19.582091110300308, -12.769200249851666],
              [-19.579785863797348, -12.770463022833818],
              [-19.57713689680405, -12.773135875644474],
              [-19.578220706796177, -12.77502811115469],
              [-19.581079047991498, -12.775458421349462],
              [-19.58156998462669, -12.776533899395396],
              [-19.58365468670006, -12.775694925265178],
              [-19.585144791379783, -12.775971884494385],
              [-19.58646911323737, -12.775600489543471],
              [-19.58955452193387, -12.776183778960553],
              [-19.59259488410529, -12.777064179867034],
              [-19.592866566013214, -12.774988130121299],
              [-19.592505699876966, -12.773262420381245],
              [-19.59353794281489, -12.772650672971112],
              [-19.595407343263105, -12.770349004918373]
            ]
          ],
          [
            [
              [-19.60545343621503, -12.698181172631788],
              [-19.605115911794833, -12.695786290473611],
              [-19.60394616591094, -12.695604260146176],
              [-19.60193919054164, -12.6910944317741],
              [-19.600305133278045, -12.69080069543867],
              [-19.597518357230353, -12.688782872548492],
              [-19.59517208343687, -12.688371379238127],
              [-19.593198110211727, -12.689192883289662],
              [-19.591435007514054, -12.687093867542375],
              [-19.591972675703147, -12.685703395320905],
              [-19.59360514982379, -12.683547284235809],
              [-19.592501373391475, -12.682632510258614],
              [-19.59093051224333, -12.682135028604758],
              [-19.586390176004173, -12.684311560304055],
              [-19.585077144242746, -12.68742064949807],
              [-19.582231751764105, -12.689976837986015],
              [-19.581026352366077, -12.690135815923187],
              [-19.579149430524204, -12.688487724986585],
              [-19.579300247209936, -12.68658769517104],
              [-19.578205196026136, -12.686535652787985],
              [-19.577936549522665, -12.68778290822344],
              [-19.575905989995576, -12.688563756140418],
              [-19.574208071864856, -12.686259976447351],
              [-19.573093955308696, -12.685826377497348],
              [-19.571772920350888, -12.686436984534128],
              [-19.567095498258915, -12.685939815531011],
              [-19.563993297949693, -12.687622203630127],
              [-19.562307295586585, -12.687573444097168],
              [-19.559755799170688, -12.68930489836979],
              [-19.561566198399635, -12.693080137589474],
              [-19.564272493863815, -12.691657994309546],
              [-19.56744343321508, -12.691453093899943],
              [-19.569204044817795, -12.692738013275036],
              [-19.56999869574892, -12.69414010153451],
              [-19.569804607672623, -12.69580741973262],
              [-19.570301354053676, -12.696924141816758],
              [-19.57176226006773, -12.697635685001696],
              [-19.57850591698215, -12.69888491215596],
              [-19.579960076587025, -12.701472483120167],
              [-19.579315266898956, -12.70365120185755],
              [-19.579502661099802, -12.704965817218069],
              [-19.577603562562484, -12.706493957069181],
              [-19.576703391620004, -12.705060786258683],
              [-19.575846481791665, -12.704967197109427],
              [-19.574872337511493, -12.706144014170306],
              [-19.576707340549355, -12.708379172049078],
              [-19.57718971110113, -12.710509924551701],
              [-19.578335059996725, -12.712478970023797],
              [-19.576697234917173, -12.713818234657717],
              [-19.57536497138745, -12.712457936042044],
              [-19.573929841389006, -12.712174294438952],
              [-19.57302282209195, -12.714831234496462],
              [-19.571207595700884, -12.714082849008125],
              [-19.57012323868316, -12.714652943659615],
              [-19.569617555055537, -12.716519466958134],
              [-19.566321737851823, -12.716888802740241],
              [-19.563885101201464, -12.716533726464938],
              [-19.56105650039406, -12.717303481951443],
              [-19.558446587733904, -12.718468537342217],
              [-19.55612197613629, -12.720402933993734],
              [-19.553913134901187, -12.719381654777324],
              [-19.55106627815187, -12.718660841546084],
              [-19.54734020251763, -12.724679591639555],
              [-19.550007342558747, -12.728560689794554],
              [-19.551584414565287, -12.729641758703396],
              [-19.55193332811429, -12.731604945926444],
              [-19.553827780285882, -12.730851156112745],
              [-19.554956260362655, -12.729408266751006],
              [-19.557666503785555, -12.728515681738655],
              [-19.56034722109353, -12.728012769796774],
              [-19.56379600286368, -12.728486075791183],
              [-19.56575444085436, -12.727816186683318],
              [-19.56633253257411, -12.726899144051748],
              [-19.567777258355544, -12.727230914128944],
              [-19.569646846157557, -12.729657498357502],
              [-19.57097517554847, -12.730442229066082],
              [-19.570447428379182, -12.731640262975162],
              [-19.56864565957624, -12.734018586950661],
              [-19.569748774201575, -12.734649344606748],
              [-19.571070571809646, -12.733460763440412],
              [-19.572570472479406, -12.733542165265089],
              [-19.573565278137906, -12.73467332993937],
              [-19.575144622676394, -12.734644691609631],
              [-19.57606518148505, -12.736463070661587],
              [-19.576093587258963, -12.738000376136915],
              [-19.57912556964997, -12.738060385457258],
              [-19.581047715515435, -12.735804030610277],
              [-19.582624885818667, -12.735485529372673],
              [-19.58529673840464, -12.73656999249231],
              [-19.58484296703613, -12.737901026081826],
              [-19.58659397368794, -12.739095341382324],
              [-19.586463327834856, -12.739744366430116],
              [-19.583669778244555, -12.740464094543768],
              [-19.58236963777871, -12.742325852150003],
              [-19.583032050515403, -12.743803456738373],
              [-19.584436059081696, -12.744720286031578],
              [-19.58506990810479, -12.74658902722885],
              [-19.585925979083814, -12.747213965848296],
              [-19.587770239810197, -12.746994403114867],
              [-19.589041566944406, -12.748271470842855],
              [-19.59127654451274, -12.747743135919201],
              [-19.595659688747403, -12.744288527013882],
              [-19.598289565994346, -12.74402851815823],
              [-19.598233543450103, -12.742349938241643],
              [-19.59913551078728, -12.741856902060478],
              [-19.599331073306267, -12.739652915007309],
              [-19.60087461057453, -12.738326079463976],
              [-19.601109188097826, -12.73688703211882],
              [-19.603287877595655, -12.73414812961142],
              [-19.601094740729966, -12.733803880963034],
              [-19.599761102514517, -12.73437166789426],
              [-19.598755047837788, -12.734014726607542],
              [-19.596483428859578, -12.732140717832781],
              [-19.59550912505959, -12.73086292818403],
              [-19.593571759438717, -12.729461778771348],
              [-19.592679505810633, -12.728362230767354],
              [-19.59170395839728, -12.725157808037354],
              [-19.5920882750936, -12.724272729908694],
              [-19.59494888984669, -12.723394641776162],
              [-19.59625911720173, -12.722157235021518],
              [-19.597012898718425, -12.720582081299224],
              [-19.59779473710692, -12.71779817493293],
              [-19.59863277395823, -12.716690342103032],
              [-19.598254391360694, -12.715696253577395],
              [-19.59617461040876, -12.713503488182404],
              [-19.594617232814787, -12.713097844457476],
              [-19.590287462186925, -12.710763378629819],
              [-19.588688146534327, -12.710942366051572],
              [-19.587602853731283, -12.709589015194847],
              [-19.585790360912306, -12.708312469934159],
              [-19.585699224624133, -12.705345334616286],
              [-19.58654598449201, -12.703467760648829],
              [-19.588252025255535, -12.701971372397987],
              [-19.590944207415564, -12.700738047699813],
              [-19.593354265434147, -12.702583505404625],
              [-19.59403090162742, -12.70386225384483],
              [-19.59662789978558, -12.705097956667377],
              [-19.59752455896254, -12.705135643467722],
              [-19.603028241750618, -12.70413544239844],
              [-19.60556004307295, -12.700664900111482],
              [-19.60598985244109, -12.698954191465191],
              [-19.60545343621503, -12.698181172631788]
            ]
          ],
          [
            [
              [-19.69891179901862, -12.724041744228037],
              [-19.698095647030755, -12.724188535260668],
              [-19.69610690034236, -12.722855752376839],
              [-19.695794233733647, -12.721463317987359],
              [-19.696150304015603, -12.718357419663327],
              [-19.695518435149584, -12.71658819037372],
              [-19.694569633144475, -12.715503842195119],
              [-19.692936524698574, -12.714735491051938],
              [-19.691589373815617, -12.715218681129164],
              [-19.689704074065432, -12.714688033502753],
              [-19.689147629148987, -12.713050719444519],
              [-19.689509353437252, -12.710235524284045],
              [-19.690714176185672, -12.708475583499128],
              [-19.689630178587738, -12.706933254248893],
              [-19.68507136301682, -12.704567537882944],
              [-19.682883311579285, -12.70452526208617],
              [-19.682437823283607, -12.703737122575783],
              [-19.68057723628893, -12.704118198984938],
              [-19.677038657058663, -12.704268644139857],
              [-19.67466657634573, -12.70218502890665],
              [-19.673041078644786, -12.701703569928787],
              [-19.671454236098786, -12.699576544267613],
              [-19.67085216414007, -12.697948937841764],
              [-19.669345494902917, -12.698892048125769],
              [-19.66800813188027, -12.698359119156834],
              [-19.666866694172366, -12.695960673681318],
              [-19.66607847645566, -12.695715396945987],
              [-19.662969037920163, -12.697087071649214],
              [-19.65969411405299, -12.697572115736113],
              [-19.65803582197818, -12.695843130156783],
              [-19.65697355051877, -12.695453571713873],
              [-19.65614496370854, -12.697912553939053],
              [-19.656409249701834, -12.700129993778571],
              [-19.654056170807362, -12.70131714917055],
              [-19.65178254815004, -12.70133383758867],
              [-19.64894453379587, -12.699908485242053],
              [-19.64759818995972, -12.700387063273029],
              [-19.644629537656012, -12.702259569042338],
              [-19.64376261146563, -12.70506186105181],
              [-19.64396420255973, -12.706953236170204],
              [-19.645861344166956, -12.70864288478568],
              [-19.6463903593006, -12.710429376056995],
              [-19.648280252282348, -12.71154198647029],
              [-19.648177345483283, -12.71339168719255],
              [-19.646198589675983, -12.715813491102955],
              [-19.646261353496534, -12.717490048261263],
              [-19.645313236027135, -12.718524721809775],
              [-19.640929974670055, -12.721079865931472],
              [-19.64000087134262, -12.721146765332993],
              [-19.63491450572962, -12.71639891893777],
              [-19.63298240959712, -12.715050548925054],
              [-19.631697207295698, -12.71479373093002],
              [-19.631549069510758, -12.716410335980719],
              [-19.633439430853343, -12.716994948586764],
              [-19.634359316799216, -12.718761532025182],
              [-19.633305906751033, -12.719765862157166],
              [-19.63064881462845, -12.718784951866658],
              [-19.628985183036562, -12.721052112564497],
              [-19.627730611337462, -12.72204292116729],
              [-19.626352400219584, -12.722090717662246],
              [-19.62450606319156, -12.72390747268045],
              [-19.62285175275894, -12.724340463441456],
              [-19.62154935357735, -12.72750835747543],
              [-19.62129482717378, -12.729095837924033],
              [-19.622011371573475, -12.730031639951932],
              [-19.624564851563115, -12.73098527369486],
              [-19.62596621654069, -12.732139556015799],
              [-19.627365934356497, -12.732474100655608],
              [-19.631085231698886, -12.732210217714446],
              [-19.632886513430524, -12.732570327910029],
              [-19.633399252083166, -12.731853583972887],
              [-19.63721730837133, -12.730509607534785],
              [-19.639777400204878, -12.731218398172551],
              [-19.639882065269422, -12.733129747807121],
              [-19.63641473782624, -12.733689544855839],
              [-19.634260106477964, -12.734646086062396],
              [-19.631950922817694, -12.736111455515442],
              [-19.631376257789803, -12.737032188318306],
              [-19.630118287459247, -12.737203866924952],
              [-19.62863893396494, -12.738330602477623],
              [-19.6267903578695, -12.738797975648568],
              [-19.623652198597956, -12.740889045916104],
              [-19.622016750835023, -12.740353670311421],
              [-19.62083716962138, -12.738242960593215],
              [-19.619587650279144, -12.738460333002587],
              [-19.61941491496929, -12.740227246454811],
              [-19.61672863964998, -12.740453028506098],
              [-19.61479037460487, -12.739341939440333],
              [-19.61202784830833, -12.739145816208891],
              [-19.61120115071317, -12.737600871763727],
              [-19.609580700845815, -12.736869044667628],
              [-19.60767613645573, -12.738115094543868],
              [-19.60803338468592, -12.740079055838827],
              [-19.607841877616607, -12.741752184331645],
              [-19.610761160996322, -12.743080027183552],
              [-19.611160287568183, -12.743638012169468],
              [-19.611072286857397, -12.747513560733632],
              [-19.613306304537723, -12.74997427605578],
              [-19.617726777301453, -12.750269541477122],
              [-19.620573105776206, -12.749823199526062],
              [-19.621991655817986, -12.750252528446985],
              [-19.623385656591296, -12.751361996120371],
              [-19.625551699912833, -12.751805670533427],
              [-19.626400392476157, -12.751561208214271],
              [-19.628281333969895, -12.752344030594509],
              [-19.629411311970458, -12.754175746758124],
              [-19.6324151209496, -12.755390454118782],
              [-19.63365246205352, -12.75536759760537],
              [-19.635992467318154, -12.753509111622167],
              [-19.636416554455007, -12.75203426234174],
              [-19.641321872615038, -12.751706527819435],
              [-19.643382835349293, -12.750765198317119],
              [-19.643094424223275, -12.748932099644765],
              [-19.64362585439756, -12.747776065797959],
              [-19.645073449990885, -12.747280436208777],
              [-19.64782591492234, -12.747666225678488],
              [-19.648536432562544, -12.748555605982986],
              [-19.649861640663683, -12.752767413390352],
              [-19.650572338056662, -12.756073577802402],
              [-19.652241242537713, -12.757036312443436],
              [-19.654680314317105, -12.757863551405329],
              [-19.65618391587384, -12.761418127479486],
              [-19.658024901576017, -12.761963722340834],
              [-19.661084559106335, -12.76103710148178],
              [-19.661584667802217, -12.759981519021128],
              [-19.66094415980188, -12.75787052403672],
              [-19.659818406149064, -12.755555557037132],
              [-19.65965919554381, -12.753360158753951],
              [-19.662342191855693, -12.750952719421132],
              [-19.665867279044104, -12.749603991851643],
              [-19.66963971944225, -12.750916963856135],
              [-19.67121814934857, -12.751120278954527],
              [-19.67266587139053, -12.749557902820712],
              [-19.672491476456866, -12.747027347282167],
              [-19.674318771646632, -12.74617102816658],
              [-19.6756608858032, -12.746173899617261],
              [-19.67772459469875, -12.748706952388112],
              [-19.678499043576004, -12.750454306106159],
              [-19.680213015915424, -12.750052376131453],
              [-19.68423709612287, -12.751365754613797],
              [-19.68563737319282, -12.752469882217333],
              [-19.691122743951354, -12.752553919942862],
              [-19.691523954244385, -12.751514785571768],
              [-19.691227413999904, -12.748617581917985],
              [-19.692606603301588, -12.746436545913014],
              [-19.691228404996096, -12.745716262314978],
              [-19.68980108215607, -12.74394123622199],
              [-19.68957237774248, -12.742725317640923],
              [-19.690334138432878, -12.740171936864503],
              [-19.692418722889904, -12.73699555442378],
              [-19.69417802636505, -12.736051961952102],
              [-19.69662958394175, -12.733775623709228],
              [-19.696827472776867, -12.732193850874639],
              [-19.698243399119157, -12.728122557694782],
              [-19.69818834100598, -12.726779917753667],
              [-19.69891179901862, -12.724041744228037]
            ]
          ],
          [
            [
              [-19.725172266703034, -12.766512890263636],
              [-19.723300259849932, -12.765142101617917],
              [-19.72279417483956, -12.765375864515692],
              [-19.722599766544707, -12.768003486046196],
              [-19.7214232130674, -12.76736113356539],
              [-19.719453492553377, -12.76735400396894],
              [-19.719088197514754, -12.766741964638275],
              [-19.71924086890597, -12.763614140750203],
              [-19.71722601451737, -12.763493969608598],
              [-19.71546388638392, -12.764442044953885],
              [-19.71352775961583, -12.766050381745503],
              [-19.710360540332697, -12.767735222930085],
              [-19.707947410819077, -12.76787912472529],
              [-19.705969719024036, -12.76900942683463],
              [-19.70558157830771, -12.769854165815282],
              [-19.705528126068554, -12.772605245821193],
              [-19.704323361907708, -12.773161288835777],
              [-19.701098545598455, -12.776239306738553],
              [-19.704446077717332, -12.779008946218239],
              [-19.705808252097572, -12.778855860741729],
              [-19.710986157661253, -12.779533384531431],
              [-19.71346273435168, -12.778853514381492],
              [-19.716598628163307, -12.779354702750373],
              [-19.718085576697472, -12.778013657579452],
              [-19.719817567204977, -12.777490522984044],
              [-19.722177161695104, -12.777309857937604],
              [-19.72587341073346, -12.775690866978113],
              [-19.725957369507572, -12.7719434981911],
              [-19.724997479777336, -12.770566365509936],
              [-19.725566596539373, -12.767798367662595],
              [-19.725172266703034, -12.766512890263636]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -161.98075194723486,
          "lat": 55.36701483804713
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02013"],
        "coty_name": ["Aleutians East"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Aleutians East Borough"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01419964"
      },
      "bbox": [
        -19.725957369507572, -12.781305639681314, -18.15829940903238,
        -11.968037175575287
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-16.445686091266463, -10.388762195773756],
              [-16.43358910605189, -10.387915943271977],
              [-16.43285363761716, -10.397869010371812],
              [-16.422822331408025, -10.39715686859282],
              [-16.42208994173426, -10.407112381739811],
              [-16.306185684892444, -10.398216001583721],
              [-16.302765574668584, -10.397936078189314],
              [-16.295148151646274, -10.487436145622178],
              [-16.296777075954846, -10.48756989235459],
              [-16.294241826671524, -10.517401171639381],
              [-16.291678819656216, -10.54756439300883],
              [-16.287485601889493, -10.596943792252318],
              [-16.332567609434236, -10.600542340540878],
              [-16.331750582614866, -10.610484316591657],
              [-16.333035892537858, -10.610583852775553],
              [-16.33058780055437, -10.64041002630968],
              [-16.345973808428734, -10.641598529766847],
              [-16.38023532619764, -10.644177494873333],
              [-16.382524757012835, -10.614338157974021],
              [-16.381882079754163, -10.614290854137673],
              [-16.382577736094, -10.605233117168664],
              [-16.38048744499568, -10.60727370325931],
              [-16.377257927305003, -10.609782790498182],
              [-16.376200504148226, -10.606936768216595],
              [-16.378471493246924, -10.60187237860786],
              [-16.380430864292563, -10.600333518079326],
              [-16.382706081689648, -10.598054384498253],
              [-16.384554353509117, -10.594807423309542],
              [-16.385626827267114, -10.592402931812241],
              [-16.386864848930692, -10.591011998108431],
              [-16.38920990615912, -10.5891416887458],
              [-16.39150326073617, -10.585806511656019],
              [-16.394672322571594, -10.582896193723672],
              [-16.398039264709897, -10.58190018789334],
              [-16.400767948939762, -10.581408439218901],
              [-16.40535590495284, -10.577748387339708],
              [-16.4071025446348, -10.57698726723949],
              [-16.41002583446584, -10.574924260410697],
              [-16.410505223768546, -10.573899277752371],
              [-16.412728865879057, -10.57329814356191],
              [-16.417349333333416, -10.57522521336736],
              [-16.42393652990778, -10.576768847204182],
              [-16.427243786147336, -10.577080538249973],
              [-16.43156806204764, -10.578121561932607],
              [-16.436803131355934, -10.580263472564067],
              [-16.437559778231385, -10.58125527742638],
              [-16.43897631612642, -10.581772840997626],
              [-16.4403003044943, -10.581603942365751],
              [-16.44075339874138, -10.578357001646607],
              [-16.442458553343428, -10.575656071161669],
              [-16.443789588150842, -10.574808426536093],
              [-16.449083082670693, -10.573251864813514],
              [-16.450692918457978, -10.572442509288688],
              [-16.453049181293387, -10.570185595666823],
              [-16.45456463617752, -10.569848797252302],
              [-16.454972359539536, -10.568918135530739],
              [-16.45712352853635, -10.567845398506385],
              [-16.458287038724155, -10.56676578039452],
              [-16.4605225489883, -10.566496720732728],
              [-16.463975910974376, -10.563474614684125],
              [-16.46531147550486, -10.562805646269808],
              [-16.468112933236927, -10.56249327059863],
              [-16.469569525119777, -10.56298904251037],
              [-16.470787906484492, -10.564036533320914],
              [-16.47384155605642, -10.56414926267187],
              [-16.477180279259343, -10.563929945301531],
              [-16.479020382597437, -10.56472895676279],
              [-16.48028462627433, -10.564791563460787],
              [-16.48364347063637, -10.563950737754773],
              [-16.484319920900177, -10.562899955859342],
              [-16.48862859288386, -10.559609081798953],
              [-16.49050224464035, -10.559590220270573],
              [-16.49158815982883, -10.558703202729067],
              [-16.49381287606527, -10.558547201539216],
              [-16.49513399317722, -10.558053600799848],
              [-16.497975499636205, -10.557697158784773],
              [-16.49871165334004, -10.556607899132132],
              [-16.503305901131135, -10.554986465329463],
              [-16.50532216732422, -10.554615724393512],
              [-16.506437404599346, -10.553869062643809],
              [-16.50887200516112, -10.550774853954772],
              [-16.513075527533847, -10.5482896962955],
              [-16.516572074505902, -10.543097445707678],
              [-16.51793285910116, -10.540609077058107],
              [-16.521565708073123, -10.537531525062075],
              [-16.522853623895465, -10.535027403116107],
              [-16.5239301299428, -10.534474746902506],
              [-16.526411784854588, -10.531445852170489],
              [-16.527434116323658, -10.53146887351803],
              [-16.529501461492607, -10.530521795587465],
              [-16.53146346349977, -10.528693785012145],
              [-16.5333114737291, -10.528667364861887],
              [-16.53496921043506, -10.52783385658784],
              [-16.5386080842318, -10.525153100391627],
              [-16.54061566293004, -10.523990457826262],
              [-16.547155254457355, -10.517007006914021],
              [-16.553315236528753, -10.514931436342856],
              [-16.55675335961284, -10.51408258978597],
              [-16.563754121018313, -10.511571151459743],
              [-16.565361757740096, -10.509864477834453],
              [-16.564200237157646, -10.506543917942357],
              [-16.56157557029701, -10.503669087415128],
              [-16.55894960467772, -10.501358891994737],
              [-16.558411540729196, -10.500335849082898],
              [-16.55807403931349, -10.494707707965235],
              [-16.557120292340983, -10.49296762430193],
              [-16.555507150037585, -10.4929000112741],
              [-16.552410223956596, -10.494115167083999],
              [-16.5511177829506, -10.494315842185928],
              [-16.546079922777754, -10.492984591204292],
              [-16.544502640230814, -10.491978326962249],
              [-16.541845854699044, -10.49096658293411],
              [-16.541050707510276, -10.489611067919038],
              [-16.537857657724075, -10.485694748801594],
              [-16.538785539571773, -10.48428573530257],
              [-16.536407213007944, -10.480795819849543],
              [-16.535602286755402, -10.477719078870871],
              [-16.535747754768472, -10.47699559779235],
              [-16.534638886525673, -10.472417799645694],
              [-16.531436206691417, -10.46844514755356],
              [-16.52982047106655, -10.464026513345102],
              [-16.528144217007668, -10.460316120323705],
              [-16.527366698436673, -10.457502103342259],
              [-16.52671568074111, -10.456799661944101],
              [-16.52476171319481, -10.452423372501107],
              [-16.518881635958646, -10.447812050442515],
              [-16.513237764218687, -10.447279467195472],
              [-16.51153794281475, -10.446461285751427],
              [-16.50941249805788, -10.443938542358232],
              [-16.50918336072941, -10.439544004844814],
              [-16.50927254616016, -10.435763018533844],
              [-16.509884444239, -10.433416277834016],
              [-16.510766898936403, -10.431941437214265],
              [-16.508001537446543, -10.428212177213755],
              [-16.504337103779974, -10.426953250921567],
              [-16.502470730696153, -10.425674046070837],
              [-16.497957969283615, -10.425888044208628],
              [-16.49514946623412, -10.424450714324289],
              [-16.49185134335912, -10.421633490187745],
              [-16.48851108813031, -10.4191392721496],
              [-16.487503345297792, -10.418020583817677],
              [-16.485244094066427, -10.417044894810477],
              [-16.484143620262, -10.41714969109662],
              [-16.479826951085347, -10.419454069539857],
              [-16.4790013569621, -10.41725934057077],
              [-16.47780518115596, -10.415179429950648],
              [-16.47789095244781, -10.413399023054804],
              [-16.47550970360087, -10.411127028867392],
              [-16.47428907147152, -10.410508070842084],
              [-16.472041876141343, -10.410199387403887],
              [-16.469417567054272, -10.40851880550922],
              [-16.465236112599552, -10.404987209734186],
              [-16.464352315054228, -10.402796808726027],
              [-16.46319568845516, -10.402395934781184],
              [-16.46197506386916, -10.399018410181277],
              [-16.456667407293114, -10.395453213529935],
              [-16.452409228673655, -10.394461752649484],
              [-16.445945358578548, -10.394563914091012],
              [-16.440377332087635, -10.391632252467755],
              [-16.44074365562567, -10.389764209259567],
              [-16.445686091266463, -10.388762195773756]
            ]
          ],
          [
            [
              [-16.600271082353252, -10.521959217870494],
              [-16.597001616333515, -10.521487845044229],
              [-16.59544059947526, -10.520819474794795],
              [-16.593286721288347, -10.517984385469614],
              [-16.59214833094538, -10.513397164048614],
              [-16.59185881195678, -10.510506037596585],
              [-16.591037448304693, -10.50723051738631],
              [-16.589053927307212, -10.506021619725862],
              [-16.581769799320707, -10.504060837206245],
              [-16.579832945961765, -10.505403546311243],
              [-16.579817156203365, -10.508438027601555],
              [-16.58113614940328, -10.511517217092845],
              [-16.58311946059297, -10.514408221794767],
              [-16.58553413029791, -10.517194764456526],
              [-16.590083694534872, -10.521458587048993],
              [-16.592317440144605, -10.522909022478897],
              [-16.59481079703078, -10.522692087306204],
              [-16.598610631817103, -10.523031797158406],
              [-16.600271082353252, -10.521959217870494]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -149.10815610090862,
          "lat": 61.14975652646042
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02020"],
        "coty_name": ["Anchorage"],
        "coty_area_code": "USA",
        "coty_type": "municipality",
        "coty_name_long": ["Anchorage Municipality"],
        "coty_fp_code": "020",
        "coty_gnis_code": "01416061"
      },
      "bbox": [
        -16.600271082353252, -10.644177494873333, -16.287485601889493,
        -10.387915943271977
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.33955479357575, -9.442787038810897],
              [-18.338380691600666, -9.438114537924577],
              [-18.336710287081797, -9.436872243281336],
              [-18.335529283530267, -9.438208868755801],
              [-18.336759446468594, -9.43926523061854],
              [-18.337044568486444, -9.441975488615075],
              [-18.335981790074076, -9.445681545667329],
              [-18.337539452113734, -9.446396543695196],
              [-18.338689155255178, -9.445910185297674],
              [-18.339714685819747, -9.444637882537235],
              [-18.33955479357575, -9.442787038810897]
            ]
          ],
          [
            [
              [-18.425440508468775, -9.612750207429016],
              [-18.424878247831113, -9.611270383083559],
              [-18.423298451192725, -9.612232589596733],
              [-18.42389063757357, -9.613841321055734],
              [-18.425440508468775, -9.612750207429016]
            ]
          ],
          [
            [
              [-18.576368894445853, -9.60336483893283],
              [-18.5747062380786, -9.603924746838329],
              [-18.574280588602182, -9.604726176856598],
              [-18.572866339516978, -9.60423706471458],
              [-18.57072524079156, -9.60254628801577],
              [-18.570728628609746, -9.601286369706948],
              [-18.571528320594947, -9.600430985026216],
              [-18.569013345704054, -9.599072415064303],
              [-18.568367372131167, -9.599559962822411],
              [-18.566051837359286, -9.598059151925986],
              [-18.565231686303562, -9.598241519937226],
              [-18.563880295018496, -9.59532564624898],
              [-18.564305105323943, -9.594554784101923],
              [-18.561716460768483, -9.593744867098971],
              [-18.5599369640356, -9.591358170783117],
              [-18.55867241784437, -9.59199451460278],
              [-18.5585812592472, -9.595523962004469],
              [-18.55710611716524, -9.596892591089754],
              [-18.55538123904973, -9.596229948184252],
              [-18.555703758840544, -9.594162485718734],
              [-18.555104311296326, -9.59173486466973],
              [-18.551777514415996, -9.589982410557226],
              [-18.55161132155124, -9.588180632791333],
              [-18.550922369361356, -9.587631016875232],
              [-18.549487298293517, -9.588750788106713],
              [-18.547901493366457, -9.588146797008072],
              [-18.547401984429687, -9.589305781802695],
              [-18.545058428266877, -9.589575228651055],
              [-18.54494312344165, -9.590677440346187],
              [-18.542810783651692, -9.591030318730741],
              [-18.542921595678756, -9.592459370664328],
              [-18.540668139696866, -9.593852901922476],
              [-18.53778282067137, -9.594654380913095],
              [-18.534494971338336, -9.594824620196794],
              [-18.532718427652302, -9.594480883681056],
              [-18.530460816839245, -9.59313277360365],
              [-18.529871431141288, -9.591926865270915],
              [-18.52998194373854, -9.590152120319294],
              [-18.5258546982192, -9.591772783095664],
              [-18.525182766273822, -9.59303634962158],
              [-18.522273247467613, -9.59496866534208],
              [-18.521806149236873, -9.596364558639545],
              [-18.523053130986487, -9.597784499062964],
              [-18.522707788421716, -9.599912537243046],
              [-18.523110479174917, -9.601247061750554],
              [-18.5216675866597, -9.601837368623476],
              [-18.52026787079021, -9.603328332785399],
              [-18.520454330223476, -9.60442360438495],
              [-18.518132424942205, -9.60754195129492],
              [-18.52027332474693, -9.608456047694238],
              [-18.52146774171071, -9.61003031584696],
              [-18.52100584179898, -9.613474247875558],
              [-18.52283378660251, -9.613876646885302],
              [-18.52326764857159, -9.615223705595742],
              [-18.523128098383584, -9.617472684682934],
              [-18.52259585253485, -9.619420704341692],
              [-18.521086727890523, -9.622083018022439],
              [-18.521954320792773, -9.624439536318508],
              [-18.523197272761486, -9.625121395324328],
              [-18.525823612613532, -9.623944170983398],
              [-18.526866507382735, -9.62263269118009],
              [-18.52702424436936, -9.62154244086184],
              [-18.52604988201852, -9.61976392722108],
              [-18.526973041284634, -9.618541256251063],
              [-18.52930440375275, -9.617547981597742],
              [-18.530987290023493, -9.618314513326679],
              [-18.530730837166537, -9.620033615141745],
              [-18.532294045946788, -9.620551134214983],
              [-18.53339163670313, -9.622081890262303],
              [-18.53512435542662, -9.622015046890361],
              [-18.5361752288106, -9.622816918708248],
              [-18.537469569927854, -9.621228106254325],
              [-18.541794585442883, -9.619766097449158],
              [-18.542766522688506, -9.62042673175615],
              [-18.543405287814874, -9.621903559687633],
              [-18.5462164759027, -9.620643720535831],
              [-18.547474901888947, -9.62199036911816],
              [-18.54880697485737, -9.621730227638094],
              [-18.548462546043414, -9.61968477503587],
              [-18.54990136619399, -9.618855403743188],
              [-18.55164340616703, -9.618633245399005],
              [-18.55313947881638, -9.619236212378492],
              [-18.553557822470363, -9.62029059210136],
              [-18.555090308295032, -9.62114462888256],
              [-18.55664273827297, -9.620861198578307],
              [-18.55788553588039, -9.619182229830479],
              [-18.5605621275069, -9.620494517318663],
              [-18.561107513349352, -9.619637349506805],
              [-18.56337535188496, -9.619420986522565],
              [-18.563459503164683, -9.618498175945463],
              [-18.564865200206896, -9.61693427796132],
              [-18.5657293591148, -9.613989863719034],
              [-18.56719149536161, -9.612771188409306],
              [-18.56845315996088, -9.612555804774416],
              [-18.571429480717796, -9.613416021947337],
              [-18.572603608545943, -9.611755972015658],
              [-18.57354716572317, -9.611214623370147],
              [-18.572226222334365, -9.609931557308096],
              [-18.571275393460237, -9.607268369362522],
              [-18.57358323399897, -9.605714605557548],
              [-18.574783190811747, -9.606121291016905],
              [-18.576368894445853, -9.60336483893283]
            ]
          ],
          [
            [
              [-19.056477185884606, -9.209218795994111],
              [-19.055093825877496, -9.208447047861704],
              [-19.054362403774498, -9.208815635940315],
              [-19.051677795961503, -9.208730764874067],
              [-19.051074145150015, -9.210180327427505],
              [-19.052618875940688, -9.212897801292781],
              [-19.05343560872039, -9.215841588128354],
              [-19.055255883349073, -9.216069608959765],
              [-19.05568965481706, -9.21276610189979],
              [-19.056306574496396, -9.211244449898144],
              [-19.056477185884606, -9.209218795994111]
            ]
          ],
          [
            [
              [-19.296868067472047, -8.993574581386259],
              [-19.294178236845987, -8.992795439525707],
              [-19.293082113365784, -8.990077392524022],
              [-19.291118704375325, -8.989819052707094],
              [-19.28981915212118, -8.990130599064605],
              [-19.289402535060916, -8.992351866897973],
              [-19.290784057950237, -8.997712854688906],
              [-19.29291304527033, -8.996905299553164],
              [-19.295683941818748, -8.996565465600298],
              [-19.29741244205237, -8.994419235927547],
              [-19.296868067472047, -8.993574581386259]
            ]
          ],
          [
            [
              [-18.670615241632163, -8.542496603339723],
              [-18.676334134103023, -8.578378438865338],
              [-18.66568077869895, -8.580036504438253],
              [-18.684386015296656, -8.698118142211271],
              [-18.67390463501695, -8.69973438312417],
              [-18.692486035040297, -8.817904558912137],
              [-18.65260262231683, -8.823944475907004],
              [-18.661647910125712, -8.883087398137306],
              [-18.631867836317035, -8.887486426615041],
              [-18.640729241121825, -8.946669827422738],
              [-18.573222267713042, -8.956041078830363],
              [-18.505718806244097, -8.96543674918128],
              [-18.435380451653494, -8.97417719108857],
              [-18.36504550161591, -8.982944142744122],
              [-18.295884059877118, -8.990546134960779],
              [-18.226725531055667, -8.998173755617799],
              [-18.189715801204333, -9.001902888103537],
              [-18.12937916704367, -9.007486188213363],
              [-18.069044393638958, -9.013088993198714],
              [-18.06640366499546, -8.98329533104745],
              [-18.036293715944677, -8.985849973740466],
              [-18.00621455651519, -8.988311362073519],
              [-18.008653715508395, -9.018122757733721],
              [-18.00748694116418, -9.0182177252215],
              [-18.012375356045194, -9.077848306571653],
              [-18.042365197971577, -9.07540152449249],
              [-18.047447751597026, -9.134997409802644],
              [-18.045905726162736, -9.135167525549502],
              [-18.04867405567217, -9.167688062071344],
              [-18.050982502971053, -9.194800824610553],
              [-18.080951581589808, -9.192278406948473],
              [-18.086213673790223, -9.251900916062485],
              [-18.114075682655532, -9.249466266141638],
              [-18.124949814782315, -9.368731695134306],
              [-18.122703150445364, -9.368931681709263],
              [-18.13355586033118, -9.488226423519269],
              [-18.101595504227124, -9.49100672547188],
              [-18.10451682387996, -9.524289742528854],
              [-18.109452762847486, -9.580518106949436],
              [-18.13946654478409, -9.577911795760187],
              [-18.14217741817817, -9.607740207664975],
              [-18.16972645697302, -9.605270722841558],
              [-18.172521678283104, -9.635094017374659],
              [-18.232139782527867, -9.62950026788155],
              [-18.235106683954687, -9.65931145606328],
              [-18.264990039495224, -9.65638518325939],
              [-18.27109542853767, -9.715972572477764],
              [-18.26752943919668, -9.71633627854907],
              [-18.27057402033438, -9.746135111732201],
              [-18.30035699501111, -9.743138158955913],
              [-18.309754841773053, -9.832523393647598],
              [-18.379517052517976, -9.824931627745054],
              [-18.449281234732496, -9.817357301717296],
              [-18.48980641243763, -9.812603972609919],
              [-18.48615755779641, -9.782868321303711],
              [-18.516045837379803, -9.779252377575729],
              [-18.51231502559267, -9.749522266902833],
              [-18.51918536948751, -9.748683937819079],
              [-18.529464262678715, -9.74708556905098],
              [-18.542095193939204, -9.74583659123919],
              [-18.538269999827968, -9.716120168929494],
              [-18.56995802009623, -9.712101724069132],
              [-18.56383261887296, -9.70431264807469],
              [-18.563741791475547, -9.703495023440215],
              [-18.560582650400768, -9.699458324466566],
              [-18.551064547543145, -9.689432772419778],
              [-18.54823784945387, -9.685034489778147],
              [-18.544785627142065, -9.680825188725516],
              [-18.542257490250197, -9.679370712360612],
              [-18.540995039913625, -9.67715656742221],
              [-18.540046189688866, -9.676224151835228],
              [-18.538567188594364, -9.6729026770828],
              [-18.537298805376416, -9.671930409399721],
              [-18.538773241337925, -9.670084047255305],
              [-18.53666128892516, -9.66830093492184],
              [-18.53459564518169, -9.664481456514917],
              [-18.533858025524907, -9.664277263549565],
              [-18.53198304177306, -9.662362326816368],
              [-18.529668359646283, -9.658506834950238],
              [-18.524641090198184, -9.654277851076257],
              [-18.520561963197277, -9.651323772028608],
              [-18.517590638259694, -9.649564626409282],
              [-18.513094891913823, -9.64638481873074],
              [-18.51175845984604, -9.645126200358012],
              [-18.511067621957633, -9.643214520001083],
              [-18.511054553271798, -9.64090588477244],
              [-18.511553078921708, -9.638220064061125],
              [-18.513787766098897, -9.63712618821077],
              [-18.513119363236914, -9.635376714853312],
              [-18.513099082559183, -9.632133119092968],
              [-18.513799966329504, -9.629575691074953],
              [-18.514406029887517, -9.62883179962373],
              [-18.51543504260009, -9.625791919679507],
              [-18.51490914968422, -9.625553567357164],
              [-18.512593535992252, -9.626457649740653],
              [-18.511281254430873, -9.626000659906481],
              [-18.509155906003166, -9.62720800680284],
              [-18.50764859186252, -9.625969959961147],
              [-18.505032351507904, -9.627112166060073],
              [-18.503472691669767, -9.628173028398118],
              [-18.503896185426658, -9.62915946403567],
              [-18.50341543657515, -9.630835471436159],
              [-18.50223868333689, -9.631940324005864],
              [-18.502534422509466, -9.632699600426191],
              [-18.500073324212345, -9.6339317065985],
              [-18.4981563258126, -9.63160723102065],
              [-18.49553315422874, -9.631094940394437],
              [-18.494371498992347, -9.632621710380176],
              [-18.49215128251877, -9.632804373673642],
              [-18.493348528797643, -9.634881242871748],
              [-18.492910086447647, -9.635946829669633],
              [-18.490219840769004, -9.637721339194943],
              [-18.487706191543765, -9.638749998885666],
              [-18.48566214660364, -9.639229592878486],
              [-18.48433500414286, -9.640160402018786],
              [-18.483172278847807, -9.639359183658122],
              [-18.48052567193802, -9.639585804105861],
              [-18.480197990046452, -9.641693940316973],
              [-18.481595467290802, -9.64123008431451],
              [-18.482489918754727, -9.64182382486923],
              [-18.482431382928453, -9.643456446893923],
              [-18.480987240059573, -9.64414791872361],
              [-18.479483966891213, -9.64421225082536],
              [-18.478554000351394, -9.645081833085168],
              [-18.47836976642417, -9.646365765767433],
              [-18.475659515399457, -9.648629478923926],
              [-18.471813278240933, -9.65011521161072],
              [-18.472627934942416, -9.651594370849816],
              [-18.474042177299427, -9.651641788458981],
              [-18.477243482907515, -9.652466755912307],
              [-18.477828426549166, -9.655044751739613],
              [-18.4770580057706, -9.6554921978786],
              [-18.477866024232743, -9.657999542917985],
              [-18.477169276429116, -9.660377065387229],
              [-18.477936103556782, -9.660988398641244],
              [-18.479272851882737, -9.6592550397784],
              [-18.478769441028874, -9.65820563424208],
              [-18.480708429867793, -9.655456964095428],
              [-18.482480287002215, -9.654984747675899],
              [-18.483624205571097, -9.655623374706979],
              [-18.483930750262545, -9.65749170874922],
              [-18.483126693367428, -9.660197677188588],
              [-18.48372200985982, -9.661532333331404],
              [-18.485596804021903, -9.663082936131522],
              [-18.487284655330555, -9.662675592219767],
              [-18.489781775139885, -9.66276191520597],
              [-18.49279668526365, -9.664747794405974],
              [-18.49570199850613, -9.664802051072128],
              [-18.495108673396352, -9.666337262188215],
              [-18.49341789285428, -9.666876129172959],
              [-18.490405327377093, -9.66731566467054],
              [-18.48726903427422, -9.667361641108434],
              [-18.479945703353348, -9.666058901198689],
              [-18.476595031435252, -9.667238397792614],
              [-18.474908609232102, -9.665385422407258],
              [-18.474936734531603, -9.662824523485058],
              [-18.471673168024722, -9.662929698903064],
              [-18.470099979222745, -9.6667186896537],
              [-18.467336866045695, -9.66873240769053],
              [-18.465792314492727, -9.66573208841151],
              [-18.465703090132166, -9.664345987174572],
              [-18.464402032875075, -9.662915348429049],
              [-18.461800355013672, -9.664195867706532],
              [-18.45978702595492, -9.66619777318396],
              [-18.456406184537617, -9.665909712037331],
              [-18.45482617340896, -9.664342360517098],
              [-18.453370257922487, -9.664847316545382],
              [-18.452314187680855, -9.66428088212618],
              [-18.449629455667566, -9.665324177431842],
              [-18.447692194397803, -9.666558198133327],
              [-18.445857938509135, -9.666208595551932],
              [-18.444731462170925, -9.66655816672259],
              [-18.44440065590234, -9.66762193152773],
              [-18.44301386200139, -9.66820920505241],
              [-18.442598901897256, -9.6694230197885],
              [-18.439089499012724, -9.667089655006306],
              [-18.437761042098515, -9.667589351362597],
              [-18.43501287438196, -9.665452981536708],
              [-18.432337548911566, -9.66465606318075],
              [-18.430891002656427, -9.66528552858818],
              [-18.429564056028124, -9.66496548890681],
              [-18.428937192274745, -9.665742424045181],
              [-18.427298441835806, -9.66398606646121],
              [-18.42330757574696, -9.663024331413627],
              [-18.42244096927886, -9.66352199312885],
              [-18.419084719518096, -9.663480170963469],
              [-18.417874568346335, -9.664783586878677],
              [-18.41481626393954, -9.66495104763366],
              [-18.411165998776482, -9.667474536648538],
              [-18.409965977815915, -9.667020020153261],
              [-18.40767879397056, -9.668384646188288],
              [-18.406812072568755, -9.670011407796652],
              [-18.405212373472548, -9.67054093965648],
              [-18.403607177850564, -9.670133181712977],
              [-18.402252730978223, -9.67093842867094],
              [-18.399536134197028, -9.66962848709807],
              [-18.397063826880547, -9.669904321739605],
              [-18.395231024795365, -9.665878154175857],
              [-18.39390182335629, -9.6644243637244],
              [-18.39186305320686, -9.664998594224114],
              [-18.390138291664982, -9.665983173086655],
              [-18.38842877944548, -9.664241643582795],
              [-18.388274329439326, -9.668223522690555],
              [-18.387292544173263, -9.669283829309759],
              [-18.385159509776113, -9.670186191911776],
              [-18.38257393743215, -9.670134321534135],
              [-18.381708253756045, -9.669318850337385],
              [-18.378773450795155, -9.66830401092791],
              [-18.37831919153454, -9.667087263245687],
              [-18.374925174991752, -9.666266546661248],
              [-18.370925002108777, -9.666600669800644],
              [-18.368102778980724, -9.665833750122697],
              [-18.366723466163457, -9.666826531789267],
              [-18.363345355131994, -9.667522521398768],
              [-18.356187409718352, -9.665687072623008],
              [-18.35161369514274, -9.663624621051468],
              [-18.348007340001757, -9.663361513369022],
              [-18.346304019068942, -9.662304853746265],
              [-18.344605958878603, -9.662709309515803],
              [-18.341328431162992, -9.661119022843895],
              [-18.339229664130162, -9.658769771077191],
              [-18.337267743247914, -9.659444006249828],
              [-18.335704036807513, -9.659462329896362],
              [-18.334658998425926, -9.657886329411978],
              [-18.335224322910978, -9.655741540422538],
              [-18.3342493819748, -9.654811931175804],
              [-18.333640872807404, -9.65216524099747],
              [-18.334056960153394, -9.650713504150694],
              [-18.32988132362961, -9.648970536309898],
              [-18.328514393387806, -9.647987448407768],
              [-18.328883617361114, -9.644244932430391],
              [-18.330067513740225, -9.644729835866698],
              [-18.32975632658912, -9.642297081494739],
              [-18.328842653882692, -9.642556656022089],
              [-18.32366240849225, -9.64072052092198],
              [-18.321284439027636, -9.639154003879755],
              [-18.319289539370946, -9.637145151662224],
              [-18.318777125854634, -9.635979454058699],
              [-18.31712279933442, -9.63440570538932],
              [-18.31596301992937, -9.63168215963206],
              [-18.315950097851506, -9.630448031288008],
              [-18.314000539596428, -9.626067451853535],
              [-18.313548108056455, -9.62427986798131],
              [-18.312395394332302, -9.62253596293902],
              [-18.312243165003377, -9.619927995694452],
              [-18.311143190392794, -9.620016877277143],
              [-18.30824010031764, -9.622789804950374],
              [-18.30784958622062, -9.623473369827511],
              [-18.306050091480635, -9.622779141563699],
              [-18.30400295126103, -9.621316208133845],
              [-18.300024284065824, -9.617566598797566],
              [-18.294475777406138, -9.611205615197358],
              [-18.28966844766465, -9.603561857105198],
              [-18.28729987864852, -9.599170930800792],
              [-18.284844527649913, -9.596401171640549],
              [-18.28209582705029, -9.593779766157514],
              [-18.280340035970024, -9.5913522271512],
              [-18.274797048403286, -9.584271820497456],
              [-18.271483984527755, -9.578851794299908],
              [-18.268744826509458, -9.573450368164973],
              [-18.267648944053928, -9.570020526129294],
              [-18.26711420597978, -9.56713922042595],
              [-18.266548987123794, -9.560823231991312],
              [-18.26618486690055, -9.550730182806886],
              [-18.266789090085716, -9.54580364733501],
              [-18.268110628355338, -9.540578217436446],
              [-18.268021631734857, -9.538130926357482],
              [-18.268928920172364, -9.537311634760837],
              [-18.269328318062932, -9.535852378246284],
              [-18.26969417216119, -9.531251600977539],
              [-18.270756357511104, -9.52420122801057],
              [-18.274112664684296, -9.510499236491398],
              [-18.274761397153583, -9.50847395347677],
              [-18.27826643200885, -9.498941578079585],
              [-18.279052432780233, -9.498227231635301],
              [-18.28015307917532, -9.495649571632853],
              [-18.282033542739573, -9.4826380638529],
              [-18.282649525649425, -9.479480977544041],
              [-18.284106687836132, -9.473580609030579],
              [-18.284466462989883, -9.470434483237035],
              [-18.28455289819603, -9.466489586903055],
              [-18.285162947340673, -9.460681318346316],
              [-18.283922058816064, -9.456225231649103],
              [-18.283685131037178, -9.453741234872494],
              [-18.282939562665824, -9.451618611278318],
              [-18.282932859112666, -9.450014288564654],
              [-18.283850949018714, -9.444745333307495],
              [-18.283451470446316, -9.442390156429598],
              [-18.28363203430128, -9.439470772914547],
              [-18.28283931953194, -9.437499848574108],
              [-18.283014440880585, -9.435896838202037],
              [-18.28215945569648, -9.431287254464436],
              [-18.28205466431036, -9.42688983902909],
              [-18.281033978304656, -9.422665966439467],
              [-18.28064476119402, -9.419969114777851],
              [-18.280980575438434, -9.417865942628401],
              [-18.282764021284727, -9.411838574536876],
              [-18.284751359140806, -9.407900980525586],
              [-18.28680979916816, -9.404484875435344],
              [-18.29391481569498, -9.393574256373036],
              [-18.29796410956253, -9.387994968268902],
              [-18.302434142293638, -9.381239927000895],
              [-18.310215140710273, -9.368649157293216],
              [-18.316553655291095, -9.359383839335816],
              [-18.317497962585964, -9.356975958819989],
              [-18.31712060878952, -9.35585517472942],
              [-18.31968281810266, -9.354600019135386],
              [-18.32064560850473, -9.353097749205187],
              [-18.32103426444586, -9.35139432651243],
              [-18.32092129805587, -9.34940582606738],
              [-18.32387540655759, -9.350139001165475],
              [-18.325019807836775, -9.350032661210554],
              [-18.327529102807574, -9.348401916973181],
              [-18.331423374176232, -9.346404714793376],
              [-18.33596602284185, -9.343442406543348],
              [-18.33839830605724, -9.341317919412974],
              [-18.338539115933024, -9.338892891815739],
              [-18.339387718605373, -9.337460786793034],
              [-18.340766024345584, -9.338950458325499],
              [-18.34843150660702, -9.338576627187289],
              [-18.35079374347548, -9.33886187149654],
              [-18.351533435170982, -9.340111836454634],
              [-18.35272099951988, -9.340389850498187],
              [-18.353431208389523, -9.341542814747282],
              [-18.355370193376014, -9.342540268199024],
              [-18.357027237922505, -9.34469485118034],
              [-18.358020850339916, -9.347589903496708],
              [-18.35924139929486, -9.348699659668222],
              [-18.359862560528367, -9.350497645263463],
              [-18.360782805243765, -9.351718218452572],
              [-18.361744782042397, -9.351278905260205],
              [-18.361080621017255, -9.3488150007414],
              [-18.359526764650198, -9.347881323770094],
              [-18.359123683176335, -9.345638930363522],
              [-18.35996849682312, -9.34293566769011],
              [-18.36045932272144, -9.339362236172228],
              [-18.358729394548348, -9.337360451403834],
              [-18.356018515095293, -9.337182559841102],
              [-18.354534997867685, -9.335741964767468],
              [-18.354060622040635, -9.3342120515176],
              [-18.35263841325626, -9.33368773455323],
              [-18.351825743065245, -9.330928863442441],
              [-18.350639234513203, -9.330414544555783],
              [-18.350003247561585, -9.328327513303403],
              [-18.350084723871227, -9.322899021706323],
              [-18.349083920174817, -9.321086144381647],
              [-18.349888296253283, -9.318039384269298],
              [-18.34971514986401, -9.315743178788551],
              [-18.348555965449137, -9.314430189600934],
              [-18.34735639641316, -9.314492932452943],
              [-18.34697034249584, -9.313164959745782],
              [-18.347404816671588, -9.30909406712451],
              [-18.3460798881463, -9.308369909565023],
              [-18.34153549032024, -9.307505048284993],
              [-18.34018740773984, -9.305146500312484],
              [-18.338291690013452, -9.304929571107172],
              [-18.336810501998798, -9.303019876700914],
              [-18.334966246297242, -9.301560530561066],
              [-18.332798307870554, -9.300895846032033],
              [-18.33146885926573, -9.301279705826202],
              [-18.33086746952431, -9.303543626534193],
              [-18.32999358983003, -9.305044057494229],
              [-18.32826437221919, -9.306780762984022],
              [-18.322514944057787, -9.310058926695948],
              [-18.317419877536476, -9.311484404309411],
              [-18.316574622245664, -9.313105812519137],
              [-18.313656488306563, -9.314702336712104],
              [-18.310119027577166, -9.316240495020537],
              [-18.301973428930058, -9.317950554344796],
              [-18.295750672434576, -9.318489110039112],
              [-18.294516086605057, -9.318886852267122],
              [-18.291388711808768, -9.31909478930024],
              [-18.288244570870503, -9.319639343916498],
              [-18.28559900829511, -9.319473422750608],
              [-18.281117568461973, -9.31812974276884],
              [-18.280084791879222, -9.318397813335975],
              [-18.27864171474471, -9.317357531373489],
              [-18.278072393048976, -9.315070024444232],
              [-18.27717789925445, -9.314612184368013],
              [-18.277592978484545, -9.31261357378884],
              [-18.279066114401083, -9.31059357569276],
              [-18.282216248809277, -9.308628862832096],
              [-18.284089018080312, -9.307827870568643],
              [-18.285466410656596, -9.31025951064346],
              [-18.287318568058648, -9.308269442766957],
              [-18.28893086014671, -9.304034902339092],
              [-18.289036183726445, -9.303060796498887],
              [-18.28578117406532, -9.303204565633882],
              [-18.285336627885684, -9.303575755403678],
              [-18.27744810298147, -9.304900889792682],
              [-18.274464691407204, -9.30489263554832],
              [-18.26985153155954, -9.304254115140514],
              [-18.266098579130656, -9.30240652849966],
              [-18.26541617018703, -9.30133366709824],
              [-18.264109960653062, -9.300926138701959],
              [-18.26427917493605, -9.298993674730676],
              [-18.26197943994576, -9.29555789926504],
              [-18.258495438863584, -9.291962475737641],
              [-18.256115702320137, -9.290824474891325],
              [-18.25272518652849, -9.289789404354986],
              [-18.249602204371445, -9.287876041956052],
              [-18.24796506604712, -9.286448617159278],
              [-18.246470808256305, -9.28569758133189],
              [-18.243324542883915, -9.283098685735686],
              [-18.2420723364864, -9.28130066601349],
              [-18.241041812527506, -9.278636137692887],
              [-18.240590433174017, -9.276187455791215],
              [-18.240795502458763, -9.272134160592286],
              [-18.240345366780282, -9.270729826867328],
              [-18.240479723334303, -9.265484667463777],
              [-18.239547512426434, -9.264430413963257],
              [-18.239060015885922, -9.262148059279005],
              [-18.23807982425402, -9.26011046278003],
              [-18.23830140600994, -9.256910024441448],
              [-18.237655826770066, -9.254821919234463],
              [-18.238225233605952, -9.25294616868197],
              [-18.237085253063352, -9.251209330172028],
              [-18.23699191838125, -9.246880042553622],
              [-18.239177338310547, -9.241299827798992],
              [-18.242071795308558, -9.235367755917506],
              [-18.243780103509437, -9.232270245623328],
              [-18.244003237259964, -9.230486941767584],
              [-18.24365062921241, -9.228991353780595],
              [-18.246122718122397, -9.225529008408131],
              [-18.24706270239317, -9.223310499517533],
              [-18.247041600427153, -9.220568761906206],
              [-18.247533062825223, -9.218302632798277],
              [-18.24713078058535, -9.21633972163828],
              [-18.247954307969078, -9.2156757017444],
              [-18.24859753828721, -9.213201063914555],
              [-18.250887100459533, -9.209275879711612],
              [-18.252074281865035, -9.209065662419421],
              [-18.254034200037346, -9.209601487227822],
              [-18.258000687052093, -9.20759221297094],
              [-18.261307183594603, -9.204912480738507],
              [-18.262936062956296, -9.204180917835668],
              [-18.263238711872003, -9.201887729977916],
              [-18.263973005754934, -9.19941985142737],
              [-18.26692488781861, -9.199302071628255],
              [-18.26972173344123, -9.196027347241055],
              [-18.272072034538574, -9.193604285078385],
              [-18.27516209541487, -9.190804948603956],
              [-18.277311083649387, -9.188350211783064],
              [-18.27940669864723, -9.185251991699788],
              [-18.281814790712474, -9.180964600276692],
              [-18.28448029076237, -9.174144910989472],
              [-18.28387725432182, -9.171341314256384],
              [-18.281524468230693, -9.169698132748533],
              [-18.282106651341753, -9.16837614980277],
              [-18.283611913998268, -9.16804045487012],
              [-18.287247306219864, -9.168701933164545],
              [-18.288934477685384, -9.169536495913917],
              [-18.290746608114702, -9.17173498158659],
              [-18.291964683966746, -9.175709137416609],
              [-18.2921990892938, -9.180427248262061],
              [-18.29548205594009, -9.184340183968269],
              [-18.296820603408605, -9.184721883707212],
              [-18.297696223140367, -9.18585042689736],
              [-18.30134566190847, -9.188729453883042],
              [-18.304510176500678, -9.190294039114786],
              [-18.307231502840562, -9.192369451167627],
              [-18.3085918212999, -9.193923989675342],
              [-18.308050522258295, -9.196213033489066],
              [-18.308911072498937, -9.196751781925618],
              [-18.311431149129504, -9.197179656335056],
              [-18.313271811505643, -9.199157294368822],
              [-18.314771191884535, -9.20126037152798],
              [-18.3147226791344, -9.202924310056027],
              [-18.315253398024865, -9.204126013263044],
              [-18.318508991989535, -9.206160775307245],
              [-18.318565941347355, -9.20793111540495],
              [-18.320398071182318, -9.20980587038626],
              [-18.32129623629903, -9.216818591673919],
              [-18.322127962793285, -9.217237966444848],
              [-18.32354148165444, -9.219213428079167],
              [-18.325900838119335, -9.219040923980785],
              [-18.328712834785485, -9.219488303772359],
              [-18.328870546572414, -9.221671277455908],
              [-18.330917413361675, -9.222752286810746],
              [-18.33493955451387, -9.221706731175084],
              [-18.34097593646005, -9.222802740268438],
              [-18.344573252367397, -9.22307873830808],
              [-18.34600259502362, -9.225043999951433],
              [-18.345815311474986, -9.22633192143456],
              [-18.347561160530546, -9.228199941479415],
              [-18.34940944914539, -9.2268704094468],
              [-18.349643322889435, -9.22580323294803],
              [-18.348263199315547, -9.222730116148137],
              [-18.348280288521416, -9.221798003422757],
              [-18.352643300472675, -9.218485525145201],
              [-18.358700787218456, -9.215806990860775],
              [-18.362216611186977, -9.213828418847191],
              [-18.364701983906304, -9.210999449668213],
              [-18.365743005035185, -9.208557871542395],
              [-18.36862441678521, -9.211333645629411],
              [-18.370259507452, -9.212048117023325],
              [-18.37448109491783, -9.213154071411877],
              [-18.38318361717655, -9.214647071820503],
              [-18.391503069965093, -9.216554662372406],
              [-18.394593694777317, -9.218644691896014],
              [-18.396428046163443, -9.218030862811913],
              [-18.39876639353476, -9.219559306836988],
              [-18.401679526505333, -9.222000442446497],
              [-18.401871119843754, -9.223170757799979],
              [-18.404707549699694, -9.225009372502859],
              [-18.40683421346928, -9.227399948186688],
              [-18.40684532428104, -9.229609166586734],
              [-18.405443111926903, -9.2293033501413],
              [-18.40368842255491, -9.230545902032219],
              [-18.402303072275497, -9.230953341714864],
              [-18.39968469482988, -9.229608974684062],
              [-18.396977778642547, -9.226911362338978],
              [-18.39509107739159, -9.226212068276212],
              [-18.39630586474894, -9.22882873175493],
              [-18.39801902685174, -9.231001484798616],
              [-18.39968961510808, -9.232110080992884],
              [-18.403127759037485, -9.233517654842291],
              [-18.404965497867522, -9.23391932260044],
              [-18.41029900861654, -9.23422504097599],
              [-18.41492069872342, -9.234117733358742],
              [-18.421870231527464, -9.234177428459036],
              [-18.424289428177104, -9.233339575011088],
              [-18.425163894797826, -9.23418964816876],
              [-18.4337385558118, -9.234040256493332],
              [-18.43768106334314, -9.234641651190064],
              [-18.443858300983774, -9.236349769813021],
              [-18.44622079571666, -9.237447148404037],
              [-18.448041064262487, -9.239101169245272],
              [-18.448158651179096, -9.241065127632629],
              [-18.452466054265727, -9.244239798364392],
              [-18.452593619378447, -9.246220020438702],
              [-18.4541074964151, -9.250289979150077],
              [-18.455521585360824, -9.252083232185749],
              [-18.45572402095933, -9.253928905879064],
              [-18.456554016962873, -9.256329998589386],
              [-18.457930285448516, -9.257280907825843],
              [-18.459931065682117, -9.257231185511007],
              [-18.46179794609256, -9.257733738159672],
              [-18.462328059923088, -9.259335187174269],
              [-18.464846821019638, -9.259985931371421],
              [-18.46836689432408, -9.260185764106536],
              [-18.469817275953453, -9.261581443185488],
              [-18.472268559612207, -9.261928089339948],
              [-18.474553605092517, -9.264447107878116],
              [-18.477185636014656, -9.266227299911282],
              [-18.478474846646385, -9.266440034516934],
              [-18.479740844023407, -9.267366349921103],
              [-18.48194319255641, -9.267818715820097],
              [-18.484302694175604, -9.268820637716606],
              [-18.48599021123535, -9.27088442807703],
              [-18.489027976153057, -9.271693811834469],
              [-18.49214579736265, -9.27311501872653],
              [-18.493762277128805, -9.275288571882513],
              [-18.496387585379477, -9.276386564199491],
              [-18.49674035128514, -9.277013119303513],
              [-18.499488608324086, -9.278485547607522],
              [-18.499912099955957, -9.279221202881331],
              [-18.504552847059657, -9.280116205941509],
              [-18.50659176919181, -9.281000448836586],
              [-18.5072011666365, -9.28286105271278],
              [-18.509862933940916, -9.285874190451286],
              [-18.510113589219134, -9.287232638614316],
              [-18.511953879894623, -9.288639274625956],
              [-18.514063572481273, -9.29199291731227],
              [-18.514697169845547, -9.29409985048809],
              [-18.516017402027654, -9.295215030627359],
              [-18.515936499757558, -9.296509366893057],
              [-18.519794826627837, -9.300030905153813],
              [-18.52032102489856, -9.301232538519654],
              [-18.519230339330935, -9.304224007141851],
              [-18.51904794530303, -9.307844615043393],
              [-18.519751261121222, -9.30879973198497],
              [-18.52043106551462, -9.311510780420575],
              [-18.521304454449375, -9.311915081280558],
              [-18.522401056346215, -9.315341550979834],
              [-18.52258349648944, -9.317568557750409],
              [-18.52466247555599, -9.31918477508531],
              [-18.524851737668147, -9.320493277338485],
              [-18.52636196215728, -9.321042119355598],
              [-18.527046999343256, -9.322845871109598],
              [-18.52694654042362, -9.3239519070778],
              [-18.525928460044582, -9.325233177528064],
              [-18.52669910336753, -9.327030819377567],
              [-18.526055755114925, -9.327627742667111],
              [-18.526343977579522, -9.32938373209852],
              [-18.529376826516284, -9.331279068728184],
              [-18.532239229826846, -9.332135725470133],
              [-18.53356115133607, -9.331118484691048],
              [-18.534859701574977, -9.331507593726021],
              [-18.536991212920004, -9.33431053176878],
              [-18.540682945398338, -9.335967758683367],
              [-18.541910264059442, -9.335827283814474],
              [-18.54373967968789, -9.336912680025142],
              [-18.545358348881706, -9.340215859362532],
              [-18.54746180000257, -9.34273565139156],
              [-18.55076902825571, -9.346084349274918],
              [-18.552920624641025, -9.347062406603703],
              [-18.55456313179421, -9.343992325922558],
              [-18.554447746167813, -9.335948288266572],
              [-18.55400932008963, -9.333695957644986],
              [-18.553252025472183, -9.33245035558184],
              [-18.552742117548714, -9.330054666534993],
              [-18.55181775761439, -9.329193734274247],
              [-18.551749765377252, -9.32455933945932],
              [-18.55110829211647, -9.32319313772164],
              [-18.55175681902703, -9.321431227075005],
              [-18.551129691521414, -9.320208954507564],
              [-18.551962031066967, -9.317315075297074],
              [-18.553772404709992, -9.315019685341195],
              [-18.5530347937778, -9.313974308493188],
              [-18.55362825959927, -9.312638654576466],
              [-18.555114715579972, -9.311021451922137],
              [-18.55392598160126, -9.310426738188204],
              [-18.554080730150467, -9.307525963897708],
              [-18.55520093515897, -9.305955244729718],
              [-18.556881565983815, -9.304480765138074],
              [-18.55736247904808, -9.302872219521886],
              [-18.556189510148243, -9.300084594825055],
              [-18.55641314672595, -9.29780972321458],
              [-18.557261414403715, -9.295679506071268],
              [-18.556776984265653, -9.294459019573011],
              [-18.55500401865139, -9.294363421785272],
              [-18.553930845973735, -9.293305139189263],
              [-18.552072007119353, -9.292949062289447],
              [-18.552496364047016, -9.289177375623416],
              [-18.554386057967523, -9.285983313316265],
              [-18.556064130005936, -9.28446594766192],
              [-18.559126052739963, -9.282414238798244],
              [-18.559779899672407, -9.281145167031262],
              [-18.56117111477562, -9.280253358005744],
              [-18.56315850703323, -9.277662186084243],
              [-18.562918468445915, -9.276479877055973],
              [-18.563632690892764, -9.274447833926983],
              [-18.56381648994517, -9.27138277030779],
              [-18.564864393128776, -9.269447982737999],
              [-18.567122522343563, -9.268167756899624],
              [-18.570506009312695, -9.267450457643921],
              [-18.573782071339117, -9.267431653967643],
              [-18.5787079273263, -9.267740082968805],
              [-18.580615452161563, -9.268223783934179],
              [-18.580494740287936, -9.266956400430544],
              [-18.577810332684617, -9.266321141762402],
              [-18.576024501239402, -9.264619999444506],
              [-18.57563195883574, -9.262695323665309],
              [-18.575772447167644, -9.258633623263835],
              [-18.577005622241717, -9.256101256003724],
              [-18.576965484808845, -9.254894558523326],
              [-18.577772257751487, -9.252792221217991],
              [-18.578838883129542, -9.251526919907022],
              [-18.581902139625747, -9.248959105930107],
              [-18.58300238224802, -9.248468908962245],
              [-18.58376391866784, -9.246821075318458],
              [-18.587424150502347, -9.245967240347385],
              [-18.58876123186033, -9.245233639742331],
              [-18.589157137539033, -9.244076891482731],
              [-18.591560849082402, -9.241970257288543],
              [-18.5924482590404, -9.238808870759366],
              [-18.59144720663949, -9.237591380128332],
              [-18.590978015965952, -9.234814463644074],
              [-18.59028313501736, -9.234786264349669],
              [-18.588564454005436, -9.232907985362917],
              [-18.588028051965907, -9.23100848782956],
              [-18.58906736191743, -9.229321669691231],
              [-18.590689586388407, -9.229918261868724],
              [-18.592221350508385, -9.229158276373882],
              [-18.596095561804272, -9.22909743169478],
              [-18.59851231683956, -9.228375382664122],
              [-18.599829707971473, -9.230052612669015],
              [-18.601438226039633, -9.22976433640571],
              [-18.601820444725462, -9.227300487916562],
              [-18.605011164776315, -9.226524429595187],
              [-18.6059047566219, -9.227373315520774],
              [-18.606033725127663, -9.228605452837037],
              [-18.604231131680198, -9.231645645564106],
              [-18.607379718326555, -9.231378192730432],
              [-18.606971190748016, -9.232752449819426],
              [-18.607420901727004, -9.235166484999938],
              [-18.608907992217823, -9.237022916416455],
              [-18.61109137528978, -9.237698411384843],
              [-18.61126452757168, -9.239307061879478],
              [-18.614183910439436, -9.241125470265843],
              [-18.61525900311744, -9.241430195206648],
              [-18.615625197132125, -9.242755789929125],
              [-18.61824142441692, -9.2437283392748],
              [-18.618570983155365, -9.244870126807333],
              [-18.6200395948278, -9.245175093984656],
              [-18.623998948061928, -9.244993139539288],
              [-18.625277670200376, -9.24668914133685],
              [-18.622040044831344, -9.247364954631585],
              [-18.623912511527365, -9.248245331794234],
              [-18.622828389027983, -9.251272759841118],
              [-18.618895756755332, -9.253898915211673],
              [-18.618171266839525, -9.255389614701167],
              [-18.616522895730565, -9.256599157370674],
              [-18.615474962132506, -9.257974282413105],
              [-18.614869863182623, -9.261196002689076],
              [-18.61252126195972, -9.263072920456857],
              [-18.606551745584156, -9.264610885709603],
              [-18.604265098859294, -9.26617405022136],
              [-18.60084944189954, -9.266643484853429],
              [-18.600556411490015, -9.270839577552833],
              [-18.599229757933294, -9.275393651521293],
              [-18.598027554412095, -9.276861120089006],
              [-18.595253534930734, -9.278454131046106],
              [-18.593372789963535, -9.27869293858651],
              [-18.59157058634821, -9.278331612279802],
              [-18.589587091697553, -9.276798712470882],
              [-18.5875626124383, -9.276003203359965],
              [-18.585620120583005, -9.277997611226864],
              [-18.58339316624436, -9.27912034965596],
              [-18.580188684682525, -9.2781438722276],
              [-18.580119591991025, -9.279535643118654],
              [-18.581774033113533, -9.282422526511825],
              [-18.583190414182187, -9.285592708711302],
              [-18.58341139164176, -9.287313458379701],
              [-18.58124402408415, -9.289871210836877],
              [-18.58574274262291, -9.290696111048467],
              [-18.58977407262381, -9.292383512875807],
              [-18.591325376866713, -9.293263300462964],
              [-18.59336179612007, -9.29502472316394],
              [-18.59423530287741, -9.298099428963493],
              [-18.592855927033213, -9.299571055581518],
              [-18.593189526541504, -9.30345667537843],
              [-18.594328409975954, -9.304892113959465],
              [-18.594113476701065, -9.306050692094052],
              [-18.596177568485945, -9.307998080683042],
              [-18.595844561470518, -9.309393361458092],
              [-18.596696217910473, -9.311823002678256],
              [-18.599426121603706, -9.313869498490217],
              [-18.601394752805522, -9.313319732864338],
              [-18.603412201635525, -9.314759365991689],
              [-18.60727382636122, -9.31370037920712],
              [-18.606956486443387, -9.311970027266867],
              [-18.607675162806004, -9.311079025108327],
              [-18.60919679776612, -9.311019386139659],
              [-18.609717404564826, -9.30918327256016],
              [-18.609119805617492, -9.308347051162196],
              [-18.609216670143436, -9.306873588954717],
              [-18.61103172422542, -9.304459206763704],
              [-18.613002859805768, -9.303853799459175],
              [-18.61372495381108, -9.302164067705093],
              [-18.612734174917186, -9.300709995797332],
              [-18.61422645853788, -9.297334952332088],
              [-18.614499511782817, -9.295253276915517],
              [-18.61576328254816, -9.293323949294422],
              [-18.61506229271587, -9.291938993442347],
              [-18.615901118940513, -9.289958032185414],
              [-18.615364454299645, -9.288154495774913],
              [-18.616847777205027, -9.285582493734774],
              [-18.61868973481073, -9.284403991808485],
              [-18.619466365353922, -9.282425235022117],
              [-18.62226285686894, -9.280074638580682],
              [-18.625313054294523, -9.2789973552919],
              [-18.627338023955467, -9.27860358531728],
              [-18.626938792732755, -9.277320680281408],
              [-18.627281311705726, -9.27487302746067],
              [-18.628187299447507, -9.273676498882573],
              [-18.632589086771173, -9.269249395419513],
              [-18.6364763706299, -9.265834117949597],
              [-18.64173290161478, -9.26165802239094],
              [-18.650059683204965, -9.25580598739736],
              [-18.65853637345965, -9.250514590052846],
              [-18.662019256718892, -9.248713688899311],
              [-18.665353677268328, -9.247928828594173],
              [-18.66945742483695, -9.246118089867517],
              [-18.672141907209078, -9.245448060333036],
              [-18.67301920549562, -9.246203325469057],
              [-18.676809840470284, -9.245538139864523],
              [-18.68275948114625, -9.244745688376286],
              [-18.684571266565623, -9.243088435437816],
              [-18.690860364554478, -9.240616200602307],
              [-18.697557243321874, -9.23953815780456],
              [-18.702748928585066, -9.239305659223122],
              [-18.704104724612094, -9.239914365260498],
              [-18.70790580626513, -9.243332658192807],
              [-18.708588670273343, -9.242274161561918],
              [-18.710920724249373, -9.241398859594714],
              [-18.713197881056118, -9.241248561573997],
              [-18.71459645376093, -9.242755540539086],
              [-18.718805905375767, -9.244407565185108],
              [-18.721839355222905, -9.243687850635288],
              [-18.727166575142085, -9.240729882181844],
              [-18.730555372452127, -9.239409387160782],
              [-18.73530323212986, -9.238357271831807],
              [-18.740188114706935, -9.237007097236015],
              [-18.747195005492717, -9.235495696438548],
              [-18.760396755526607, -9.233871336751188],
              [-18.767551272716144, -9.233724964413481],
              [-18.781164888825007, -9.235353216006793],
              [-18.782296412423396, -9.235866764915563],
              [-18.790536158334067, -9.237965726112051],
              [-18.804480292351155, -9.242643689376834],
              [-18.813030898118036, -9.246067724895667],
              [-18.821665563685702, -9.249228073743359],
              [-18.829517182968942, -9.251988171979292],
              [-18.834059721780665, -9.254343950834487],
              [-18.835390808035072, -9.254273526212096],
              [-18.837147939122147, -9.255462040370263],
              [-18.840824193157122, -9.257281467354517],
              [-18.847353218515156, -9.25968992228272],
              [-18.85254811304498, -9.26083460529458],
              [-18.857077647141903, -9.261085836017015],
              [-18.864081341246045, -9.260696815370892],
              [-18.86980052618482, -9.259691643719519],
              [-18.872187410698643, -9.258756055731283],
              [-18.87509060402067, -9.258619551511954],
              [-18.878863707363863, -9.260412203596069],
              [-18.88746824619914, -9.255187988876992],
              [-18.891143499930326, -9.25279954504879],
              [-18.902768422006453, -9.245779297845028],
              [-18.911429228430638, -9.24107152653665],
              [-18.92044910938361, -9.236489494806088],
              [-18.92224546304048, -9.235260372905465],
              [-18.926615648592705, -9.23324219146707],
              [-18.933501506154283, -9.229621763281866],
              [-18.938722573437225, -9.227615440957617],
              [-18.939749783495596, -9.226806603683759],
              [-18.948352692668998, -9.22305056718119],
              [-18.95134805770983, -9.221381666171593],
              [-18.95894019269299, -9.217623329376185],
              [-18.961433568287163, -9.216764945849931],
              [-18.96581679524946, -9.21443277734603],
              [-18.97117818806802, -9.211806911968234],
              [-18.981380127987347, -9.20742982425442],
              [-18.984559108690945, -9.20624034219489],
              [-18.9902030963844, -9.204433913744428],
              [-18.99708619851789, -9.203039792510827],
              [-19.002647461296412, -9.199617495175572],
              [-19.00509070208435, -9.198390847639496],
              [-19.007879345335926, -9.197560563936742],
              [-19.01283467679368, -9.194902904408174],
              [-19.01503210185043, -9.194220564478416],
              [-19.01808585005865, -9.192575996496627],
              [-19.020409971120927, -9.19181923054788],
              [-19.023824799443474, -9.190050134535053],
              [-19.03009032086931, -9.18773005576242],
              [-19.03645247672929, -9.184867956095701],
              [-19.039534589413933, -9.183300984989831],
              [-19.043976845179692, -9.18171320936853],
              [-19.04888822071154, -9.179225738427055],
              [-19.05110255520918, -9.177556853058295],
              [-19.054741999541076, -9.174356051347765],
              [-19.05785907082704, -9.169927024148812],
              [-19.063026583501635, -9.163431851599324],
              [-19.07073511576585, -9.154815029911154],
              [-19.07151636865369, -9.153594817612626],
              [-19.072459080292713, -9.15094814887011],
              [-19.073704639385877, -9.142894294403932],
              [-19.07533984268349, -9.136704426926554],
              [-19.07734600093104, -9.123534639364259],
              [-19.077549256090347, -9.119711521016033],
              [-19.075715043260253, -9.116843393928175],
              [-19.07500862614682, -9.115048819604112],
              [-19.07408601991737, -9.111191070865578],
              [-19.07371509734036, -9.107106709795088],
              [-19.07386864894301, -9.103032681306667],
              [-19.073110046641567, -9.099185100094463],
              [-19.07133952866014, -9.098914100320624],
              [-19.070083665074375, -9.097591353441388],
              [-19.066919247731068, -9.096899231322439],
              [-19.065295468794552, -9.096963306303696],
              [-19.06340200111771, -9.094790150803675],
              [-19.061136167816827, -9.091112555949001],
              [-19.059520972477774, -9.08617737799538],
              [-19.058738364969134, -9.07983547818434],
              [-19.05905548777436, -9.07466359094646],
              [-19.05962950208422, -9.072323662344807],
              [-19.062919356100696, -9.06359596341248],
              [-19.065012170232976, -9.05935550948938],
              [-19.067765617942634, -9.054832042202252],
              [-19.07312587300154, -9.047851268479983],
              [-19.081289867616583, -9.039376099595277],
              [-19.085664900731675, -9.03571393339894],
              [-19.088992893711595, -9.032565064038675],
              [-19.09188805279678, -9.029216046102473],
              [-19.091205612933535, -9.028518308677771],
              [-19.09188133957861, -9.026725656613873],
              [-19.09307950526933, -9.024975603601037],
              [-19.09165246601698, -9.02377318667667],
              [-19.091140438512223, -9.022295484555409],
              [-19.089107477948872, -9.018508277310174],
              [-19.088767799093244, -9.017230017988682],
              [-19.089160162878393, -9.013149263128009],
              [-19.089975904884085, -9.010240127848853],
              [-19.09227552077315, -9.006168257522516],
              [-19.094403629413076, -9.003446316454479],
              [-19.101150288234898, -8.99690957678329],
              [-19.105469596189682, -8.993116620744944],
              [-19.10925343293224, -8.98803882224252],
              [-19.111783540242975, -8.98226408864862],
              [-19.11346847992524, -8.976944735348598],
              [-19.115454918496948, -8.971739680589373],
              [-19.116892026667664, -8.968500246111256],
              [-19.118175523766464, -8.963927304722617],
              [-19.117638821418844, -8.960417751397733],
              [-19.11418189924264, -8.953205526716946],
              [-19.112620433769393, -8.950337917922623],
              [-19.109957997392176, -8.943518469957178],
              [-19.108141939284877, -8.939795368786964],
              [-19.105367248822777, -8.93475387835504],
              [-19.10264459645051, -8.930709726212955],
              [-19.09921730319005, -8.926681149901219],
              [-19.09761915488302, -8.925065620694603],
              [-19.096405372207833, -8.924758081835076],
              [-19.094081855339763, -8.92538280559706],
              [-19.095599773633094, -8.927224551768855],
              [-19.095733234378063, -8.92879186759095],
              [-19.095261860853576, -8.931247057655083],
              [-19.09692756812495, -8.933114120861424],
              [-19.097412435760855, -8.936454564324281],
              [-19.103555620260497, -8.938769880089284],
              [-19.106975242047785, -8.940669699311728],
              [-19.109285141125298, -8.944426844301825],
              [-19.110646816905106, -8.9479981997519],
              [-19.111774888111192, -8.949595169914904],
              [-19.11500967283706, -8.955872993088356],
              [-19.115505103152366, -8.958680653150413],
              [-19.114829901278796, -8.961158784445837],
              [-19.113479019619724, -8.963773244425052],
              [-19.113127549494955, -8.965482491472043],
              [-19.114263149416484, -8.965925185834207],
              [-19.11445414312147, -8.967845595507637],
              [-19.112234265512438, -8.970816093831372],
              [-19.10927715528034, -8.971684413501032],
              [-19.10580431972291, -8.974816657841007],
              [-19.103131637240278, -8.976839279328635],
              [-19.103287416889284, -8.979173403756977],
              [-19.100317966344733, -8.980968406287413],
              [-19.0969776494222, -8.981451921366247],
              [-19.09502506171338, -8.983137580044234],
              [-19.09369906715462, -8.983321708613897],
              [-19.086604498543455, -8.986863740646521],
              [-19.083327485088564, -8.987527232189148],
              [-19.080538460792187, -8.987373120548208],
              [-19.077124334100862, -8.987642815126614],
              [-19.075840327841693, -8.98717369361654],
              [-19.070826462341426, -8.98687647123714],
              [-19.065404419704848, -8.985387524955172],
              [-19.063738161308414, -8.985984175782576],
              [-19.062529037671716, -8.987285924436899],
              [-19.06167430248788, -8.987288979754148],
              [-19.061770384028215, -8.983735095309811],
              [-19.061501948593552, -8.981060444413366],
              [-19.06460850282584, -8.9808246532482],
              [-19.070523556753685, -8.982112953662318],
              [-19.07379032174854, -8.983347925615485],
              [-19.073923171086175, -8.982733816509294],
              [-19.06959830955274, -8.980707247664308],
              [-19.065160022399432, -8.979872168175497],
              [-19.059728378302612, -8.979071888293877],
              [-19.05621225598265, -8.97827299856934],
              [-19.054348555392217, -8.977555786940018],
              [-19.052768674905387, -8.975722392827274],
              [-19.04983671832392, -8.973648651651125],
              [-19.046642753797112, -8.970358430385438],
              [-19.04531442861312, -8.967973424577806],
              [-19.044945305874545, -8.96645261338528],
              [-19.045616351326487, -8.96403458201825],
              [-19.045433513920955, -8.961200130351664],
              [-19.04558621407106, -8.956983173511643],
              [-19.045388702019608, -8.954196864196595],
              [-19.040800007073553, -8.950063664070491],
              [-19.038218735430924, -8.949980397944017],
              [-19.035268506830125, -8.947757023358593],
              [-19.03306401467666, -8.946998636708743],
              [-19.03231663082237, -8.94725100880684],
              [-19.03022530458709, -8.946247284251843],
              [-19.0263320408369, -8.942610614013097],
              [-19.02506148745594, -8.940865072433063],
              [-19.02329084610327, -8.939530968163368],
              [-19.024428172980606, -8.934997943805753],
              [-19.027660911633614, -8.928978685080406],
              [-19.030826997542537, -8.924935610805072],
              [-19.032983126645806, -8.922721506119212],
              [-19.03681310894509, -8.919356817121358],
              [-19.039695291644723, -8.917277421902932],
              [-19.04407958286339, -8.914817951622476],
              [-19.049065450233407, -8.912987228191781],
              [-19.05244766857914, -8.912492288525799],
              [-19.05491661187262, -8.91261236998178],
              [-19.055961730656072, -8.913530965083996],
              [-19.05732237450228, -8.913796326047517],
              [-19.059422866454817, -8.914977666329733],
              [-19.062779918226116, -8.914748700980208],
              [-19.06897945175962, -8.912518453658366],
              [-19.074034141474566, -8.909962606043049],
              [-19.079030737879002, -8.907659152887545],
              [-19.084706741882645, -8.905309382594412],
              [-19.087545492282224, -8.903463588801849],
              [-19.094853842770874, -8.896888534865361],
              [-19.09937770161683, -8.893409454209188],
              [-19.10325333343646, -8.890857231359869],
              [-19.110688522540308, -8.886228884488698],
              [-19.116354460100887, -8.883285756056887],
              [-19.119833763707014, -8.881955480608685],
              [-19.12509945893585, -8.880282260203662],
              [-19.129842073155352, -8.879736871101874],
              [-19.135721757701457, -8.87643951683909],
              [-19.138495652335802, -8.875112199593183],
              [-19.140981900437932, -8.875092033737724],
              [-19.144082830510552, -8.874439459702911],
              [-19.14790808788344, -8.873339825229088],
              [-19.148712741447497, -8.872792692939043],
              [-19.152805122773316, -8.871206911200323],
              [-19.156459270750513, -8.870228150631853],
              [-19.15714806431037, -8.870472236370368],
              [-19.16094484258205, -8.868880030284561],
              [-19.166234839679706, -8.867355408897613],
              [-19.174476953907103, -8.86131246251848],
              [-19.17604487594324, -8.859528308189324],
              [-19.177072040966028, -8.857745885587256],
              [-19.180531353953864, -8.854643083236653],
              [-19.182900218345715, -8.851379602815749],
              [-19.187863151723924, -8.846565368873113],
              [-19.1913890705815, -8.843925606059651],
              [-19.192131881851566, -8.842082917500306],
              [-19.191882091545153, -8.839469304848478],
              [-19.192864064112868, -8.837508836014322],
              [-19.19660413734661, -8.832560709498908],
              [-19.198348022291174, -8.831209242983928],
              [-19.20247874250859, -8.825466115210144],
              [-19.20471486708757, -8.823367975171987],
              [-19.20950766047264, -8.819695054374153],
              [-19.213019825038756, -8.81722534190013],
              [-19.214931321765174, -8.816183833474971],
              [-19.21818076331811, -8.813402034856681],
              [-19.21955215904603, -8.807866242196232],
              [-19.22170284551196, -8.806060840223317],
              [-19.228754520041445, -8.801328245258688],
              [-19.232676719799112, -8.799159506757212],
              [-19.23427530383665, -8.797944359230076],
              [-19.236401105726276, -8.797103017463199],
              [-19.23774105721991, -8.797676138975351],
              [-19.240620362769942, -8.795606831865799],
              [-19.243783260792316, -8.79276640561022],
              [-19.245480992430505, -8.79183285171853],
              [-19.24848118366081, -8.78872058077514],
              [-19.250344265771346, -8.782024310471208],
              [-19.248855063048698, -8.77942561763847],
              [-19.24969228624651, -8.775518482038418],
              [-19.25127988396267, -8.770603219163798],
              [-19.251401311500576, -8.767855146194558],
              [-19.2504021264595, -8.76325701506927],
              [-19.248299517181337, -8.757783889075565],
              [-19.24574996350015, -8.753496667038316],
              [-19.242800654060733, -8.750510707147999],
              [-19.23834733018854, -8.748017765162425],
              [-19.225620093019568, -8.741526362929475],
              [-19.220201663710306, -8.739460270206967],
              [-19.21461494122921, -8.737709980004814],
              [-19.207610850993166, -8.735829583389858],
              [-19.20193106216785, -8.734536748919297],
              [-19.201085526808416, -8.73450647016071],
              [-19.19679644858064, -8.733275305405718],
              [-19.18917096198024, -8.731649779602613],
              [-19.187882768867283, -8.73191715701783],
              [-19.18448935991203, -8.731398842294793],
              [-19.183353241302424, -8.730240503327815],
              [-19.18024845560728, -8.729474483018052],
              [-19.1628583193101, -8.724561172262199],
              [-19.15771304648715, -8.722883955819865],
              [-19.154575894789375, -8.723216030617735],
              [-19.152781958432243, -8.721384689910305],
              [-19.15051978745619, -8.720061205804143],
              [-19.145255789767926, -8.717810662293362],
              [-19.13448060077323, -8.713406670446576],
              [-19.129589817086895, -8.711269120965143],
              [-19.12089355699025, -8.706983646481017],
              [-19.113191792282183, -8.702972955666],
              [-19.110698255927094, -8.702802825331693],
              [-19.10642459926136, -8.699810734753198],
              [-19.105135720185505, -8.698256764109706],
              [-19.0986794646404, -8.694658578622985],
              [-19.086065795186624, -8.688082959484845],
              [-19.074865349644114, -8.68248402295814],
              [-19.065787750343755, -8.678274860219016],
              [-19.064722653803624, -8.677372436164703],
              [-19.053020301952785, -8.671621838323267],
              [-19.049380365763028, -8.669733494605396],
              [-19.039561814357693, -8.664902955818055],
              [-19.033359841322188, -8.661603716401265],
              [-19.023079134321954, -8.656798066799364],
              [-19.017166811980555, -8.653751716180516],
              [-19.003878949040693, -8.647441916125322],
              [-18.987446916255607, -8.640250093190321],
              [-18.98125603141089, -8.637680783084797],
              [-18.973113427442083, -8.634602816199122],
              [-18.948193500003537, -8.625521567059705],
              [-18.942143853940788, -8.624608660438312],
              [-18.93885489648288, -8.624649512023144],
              [-18.937592474613677, -8.625056740745043],
              [-18.935713979504346, -8.62306259046866],
              [-18.93423245316999, -8.620548454221504],
              [-18.931793897040688, -8.618539791221025],
              [-18.92205234367729, -8.6138022070596],
              [-18.9183690131709, -8.612865308102855],
              [-18.91702090750881, -8.613327981433299],
              [-18.914526693352315, -8.611933471509518],
              [-18.912783778561188, -8.61016791511012],
              [-18.90865305091854, -8.6081664259187],
              [-18.90476799087261, -8.606566177258681],
              [-18.898807646460078, -8.603643883553653],
              [-18.894066137367165, -8.601650811464099],
              [-18.88695048826901, -8.598869960330045],
              [-18.88434580350568, -8.5980285895309],
              [-18.86509121990484, -8.590418897851134],
              [-18.85135061921854, -8.585416826788844],
              [-18.8391462311579, -8.581302173178349],
              [-18.834954466247606, -8.580069406243668],
              [-18.822775947720686, -8.57603439133474],
              [-18.816568679844988, -8.574075448354684],
              [-18.806461871472756, -8.571119739052042],
              [-18.797575781287307, -8.568404390856763],
              [-18.78129145972196, -8.563915267253448],
              [-18.777227199326795, -8.563170905078886],
              [-18.77511707330388, -8.562478772931533],
              [-18.76855754217214, -8.560950524074007],
              [-18.75805606736667, -8.558644971949658],
              [-18.754307568007192, -8.557932814566941],
              [-18.737738018376046, -8.554244138630585],
              [-18.7339961850893, -8.55326027195561],
              [-18.72403733661977, -8.550975007348267],
              [-18.711495320342987, -8.548827867715705],
              [-18.703333181638488, -8.54727453188313],
              [-18.6819016024612, -8.543982316408105],
              [-18.674864932087765, -8.54274344788792],
              [-18.670615241632163, -8.542496603339723]
            ]
          ],
          [
            [
              [-19.359336656987743, -8.700287425045634],
              [-19.356124638586433, -8.698386445545507],
              [-19.351771766815105, -8.697917598642718],
              [-19.35093246068774, -8.698383688711763],
              [-19.352273318659655, -8.702368216048775],
              [-19.35225605854221, -8.707006750268944],
              [-19.352917657892977, -8.707895741445515],
              [-19.35432540815901, -8.70806252154999],
              [-19.35740745208334, -8.706812895437356],
              [-19.35900761596902, -8.704928241847789],
              [-19.359336656987743, -8.700287425045634]
            ]
          ],
          [
            [
              [-19.974289903233974, -9.35709177796794],
              [-19.973209090473606, -9.356661713551087],
              [-19.972167479037818, -9.355269303383414],
              [-19.971599363351505, -9.352682158762855],
              [-19.971495718014754, -9.34996992995388],
              [-19.96892062418189, -9.348309727999473],
              [-19.967763972302205, -9.345124263411437],
              [-19.968095762202186, -9.344387367643023],
              [-19.967437835928138, -9.341752132662778],
              [-19.968230291312256, -9.340054075513507],
              [-19.9673939345695, -9.337468376801388],
              [-19.966549916780433, -9.336367634545356],
              [-19.966939226320907, -9.335425880377096],
              [-19.96571168512881, -9.334049153289222],
              [-19.96572482458798, -9.333133829729087],
              [-19.963794191059012, -9.329784175728804],
              [-19.96297747599019, -9.326854665784744],
              [-19.96220955623417, -9.325886482870843],
              [-19.960604433799503, -9.325486774293791],
              [-19.95894035006786, -9.32267476618633],
              [-19.957660047092332, -9.323439285263685],
              [-19.956566347815063, -9.322673675345523],
              [-19.955714848445396, -9.320438755313718],
              [-19.95611509747202, -9.318851274629273],
              [-19.95419763344804, -9.317323645457511],
              [-19.952530444035194, -9.313529922962902],
              [-19.954003546907778, -9.312638472229324],
              [-19.9519048420626, -9.310592498574929],
              [-19.9505536716771, -9.31095833624182],
              [-19.948579867109192, -9.309220152216042],
              [-19.94777012893534, -9.31015866738301],
              [-19.94633025013373, -9.309790450067853],
              [-19.945150885041347, -9.308708314308037],
              [-19.944322822184983, -9.306963197439034],
              [-19.943365058557895, -9.306540533083268],
              [-19.941570619452996, -9.30282457447114],
              [-19.942168937019495, -9.299750150856035],
              [-19.941223010039344, -9.296753041249827],
              [-19.941963539754006, -9.294057679115527],
              [-19.940814456173648, -9.29266705728261],
              [-19.940538720497077, -9.290436143799774],
              [-19.939114513127954, -9.288327213918123],
              [-19.93724101325164, -9.287208947066361],
              [-19.936447298769878, -9.285308152100006],
              [-19.935691974029716, -9.285058914807138],
              [-19.933403396771443, -9.281750379425855],
              [-19.932706442392515, -9.279372100754125],
              [-19.932015436337895, -9.274540700897571],
              [-19.931165971573282, -9.265571099555421],
              [-19.93129557918043, -9.2642548399636],
              [-19.930790135137663, -9.262431967946632],
              [-19.929968700786738, -9.261938012731838],
              [-19.924061234703444, -9.264774304328162],
              [-19.921501986349337, -9.263768791308568],
              [-19.919620235325688, -9.26438802190212],
              [-19.91897732367323, -9.265502064358547],
              [-19.91935511205663, -9.267698185814966],
              [-19.917791709064083, -9.269474388038157],
              [-19.917125837062432, -9.271197910694388],
              [-19.918150509869918, -9.273673256240627],
              [-19.917575018685422, -9.277521753650614],
              [-19.918635501489355, -9.279574750617206],
              [-19.920901258253835, -9.280474884981503],
              [-19.921501155594708, -9.281407662509132],
              [-19.921108415831775, -9.282607063602518],
              [-19.921251290760697, -9.285058837197926],
              [-19.92217377723906, -9.286056370688875],
              [-19.92224874047225, -9.287847817312192],
              [-19.92293963219427, -9.289662877501812],
              [-19.924127364571763, -9.290929518429209],
              [-19.923406427146304, -9.295504105028623],
              [-19.923471364543595, -9.297261976992536],
              [-19.92235474758891, -9.299715167116267],
              [-19.919370615055204, -9.303424673073863],
              [-19.91292812278481, -9.309834333118548],
              [-19.90477673311461, -9.316580939746373],
              [-19.892626336987103, -9.325778338294217],
              [-19.889329994411234, -9.328540569682998],
              [-19.88345698550543, -9.33194317192266],
              [-19.880331779207037, -9.333938204707565],
              [-19.873369985257657, -9.338981978854997],
              [-19.87052922661037, -9.338780911550206],
              [-19.868134620798788, -9.341374575823757],
              [-19.861120273802, -9.3465356161123],
              [-19.85194135149272, -9.353048129277317],
              [-19.844673706657655, -9.357732663516648],
              [-19.839769113579848, -9.360400958756804],
              [-19.831428127474123, -9.364519126229023],
              [-19.824639351167722, -9.365848300399698],
              [-19.822565334069445, -9.365510536366996],
              [-19.821190908642347, -9.363480643998505],
              [-19.819408243983602, -9.362652255384006],
              [-19.817377103813794, -9.362907992155876],
              [-19.81356875022913, -9.361916957137879],
              [-19.812870230975925, -9.360999876589123],
              [-19.8106480653198, -9.359943088988555],
              [-19.80959898425033, -9.358851289200867],
              [-19.807442538828365, -9.358042112243844],
              [-19.805592653952623, -9.35840073650989],
              [-19.804098393481578, -9.357497870927373],
              [-19.80264287109969, -9.35586769283432],
              [-19.7988200233253, -9.354652089242904],
              [-19.7977196727578, -9.354667918612087],
              [-19.796093362935615, -9.353836424288673],
              [-19.792783271817918, -9.35049021081263],
              [-19.791561184513863, -9.34974463580397],
              [-19.787175267253577, -9.347954523800938],
              [-19.78605845772216, -9.348049258715553],
              [-19.784471113106893, -9.347358097837656],
              [-19.7810202536426, -9.347251792139229],
              [-19.77938558889664, -9.346082585266252],
              [-19.778174581955508, -9.344053552966198],
              [-19.776063706940114, -9.34368302182662],
              [-19.775630815944282, -9.345825745816342],
              [-19.773447794128106, -9.346790763759593],
              [-19.769710478803688, -9.347920576367459],
              [-19.76259955681993, -9.348202340922708],
              [-19.760709462268437, -9.347208472035847],
              [-19.760055285433516, -9.343195526232076],
              [-19.75870272851545, -9.342368371572757],
              [-19.756479223665668, -9.342286354224518],
              [-19.754227187145077, -9.341797270316269],
              [-19.75330364547202, -9.340862882096896],
              [-19.751408768402985, -9.34028427412998],
              [-19.74945447820195, -9.340359193296695],
              [-19.74716867656845, -9.34239652136665],
              [-19.744726319503194, -9.343381791954364],
              [-19.741904814378092, -9.345851960391473],
              [-19.74053161423105, -9.346419751858704],
              [-19.738951163523964, -9.346324101120175],
              [-19.737302197681412, -9.347297932594868],
              [-19.73516077296449, -9.347829953527832],
              [-19.734573612642933, -9.348652616883571],
              [-19.73284291695289, -9.349307599121605],
              [-19.73132485357883, -9.349308004312071],
              [-19.730364260259183, -9.346727215640298],
              [-19.729231866730327, -9.347346065427285],
              [-19.728280304397163, -9.349273155697379],
              [-19.72728098166006, -9.349670736843743],
              [-19.725512985472808, -9.349431795891908],
              [-19.724533071405954, -9.35095188270598],
              [-19.72236313112417, -9.350623755074775],
              [-19.720991440021244, -9.353593363449196],
              [-19.720948387248203, -9.355220108750807],
              [-19.718057952048344, -9.36029428820503],
              [-19.716405628582752, -9.361716815924035],
              [-19.71441312492301, -9.36269590585094],
              [-19.713108351727225, -9.364896973573778],
              [-19.71292060396526, -9.366560590204516],
              [-19.71320660633565, -9.370553982820251],
              [-19.711739343589706, -9.37287138580737],
              [-19.710754156963393, -9.375747997690608],
              [-19.70813955651739, -9.378647676694058],
              [-19.70456696417829, -9.380613744018946],
              [-19.701675281423025, -9.381207222685102],
              [-19.699336302987437, -9.383095787814922],
              [-19.700757242475554, -9.384518904066336],
              [-19.700745775961156, -9.386141390758912],
              [-19.69985655545615, -9.387751932159487],
              [-19.700221584557735, -9.388905814252555],
              [-19.69935966651133, -9.390020184764264],
              [-19.698862664090196, -9.392289072632705],
              [-19.699727904642867, -9.394377530574705],
              [-19.699525355753316, -9.397065416215183],
              [-19.699814831248233, -9.400200120735423],
              [-19.698761460501938, -9.402229278464532],
              [-19.698675011424836, -9.404777493298443],
              [-19.699722113704222, -9.405919073046103],
              [-19.70111301691633, -9.405693483361826],
              [-19.70129805638132, -9.407346715138129],
              [-19.70020731751292, -9.40968821224531],
              [-19.699843172954765, -9.411890538062634],
              [-19.69895783199789, -9.414295747045056],
              [-19.698873664427676, -9.415637986480013],
              [-19.700222859966615, -9.418445083200368],
              [-19.702879312177362, -9.41946158770169],
              [-19.703727755040596, -9.421786992014],
              [-19.703581171706805, -9.423032271459837],
              [-19.70143380711094, -9.426654560400758],
              [-19.7005462601209, -9.429214320757307],
              [-19.697616097626884, -9.432005324589358],
              [-19.693551085618992, -9.434843568054879],
              [-19.69186759139432, -9.435288609649401],
              [-19.691483672691625, -9.434511436590897],
              [-19.68940728914738, -9.43660183668429],
              [-19.687121356391973, -9.436926838804155],
              [-19.68676258831906, -9.438866845720908],
              [-19.68431720250924, -9.440553208747497],
              [-19.68380742162771, -9.44188673157278],
              [-19.68152260055571, -9.443609338423911],
              [-19.680870986045424, -9.446225391173666],
              [-19.678473611538912, -9.448580161382164],
              [-19.671881855889165, -9.452053356289767],
              [-19.66705134239388, -9.454154822260925],
              [-19.663017233133193, -9.455458549232114],
              [-19.66204968241127, -9.456029943578715],
              [-19.65615564132083, -9.457849356084626],
              [-19.65255164624515, -9.459197481255138],
              [-19.6496564793365, -9.45969536776246],
              [-19.647233992868095, -9.460723135545361],
              [-19.64627773886136, -9.46197118005983],
              [-19.64515483468584, -9.46473411442169],
              [-19.642445815632858, -9.467418219119216],
              [-19.640351289445135, -9.470751467070665],
              [-19.63744282078196, -9.473253986091828],
              [-19.638064541571094, -9.474243415264738],
              [-19.63768841453795, -9.475846784324004],
              [-19.638443133510734, -9.478016923181606],
              [-19.63819995239042, -9.479854685014093],
              [-19.636341043567434, -9.483550646378186],
              [-19.63228040358844, -9.487005695877665],
              [-19.6281909081578, -9.48955662273026],
              [-19.622765026458147, -9.49196306971502],
              [-19.61574133657448, -9.494890304800677],
              [-19.613310311541966, -9.494319347808245],
              [-19.61149154124767, -9.495348891493952],
              [-19.60688264791516, -9.497025441491306],
              [-19.60582534295845, -9.497081245564956],
              [-19.602835429959423, -9.49849390498895],
              [-19.601940046319694, -9.49858784813061],
              [-19.595591167671312, -9.50244208317959],
              [-19.59510274652162, -9.50312299208294],
              [-19.59172214138049, -9.50450891927812],
              [-19.58598114519254, -9.506587165871217],
              [-19.582031541879424, -9.507834827477765],
              [-19.56832214761175, -9.511310211040588],
              [-19.56649372882813, -9.511499515996823],
              [-19.563193551900447, -9.511114658494074],
              [-19.55788192009101, -9.512586093714601],
              [-19.55616775754578, -9.511952749845793],
              [-19.554696827475784, -9.514330622149691],
              [-19.551432736446813, -9.515902263592462],
              [-19.548958376466626, -9.516764365469227],
              [-19.54760716105327, -9.516539598594447],
              [-19.54642550481303, -9.517374226995072],
              [-19.546915446898296, -9.519156889976694],
              [-19.54439738550126, -9.520822893651275],
              [-19.54281898553478, -9.521102552442768],
              [-19.538839808745735, -9.520748784750914],
              [-19.53817469113868, -9.521011862469278],
              [-19.53650232086628, -9.523696963122568],
              [-19.534413845199843, -9.525907539130891],
              [-19.53222288144783, -9.527345328015786],
              [-19.52918628177315, -9.530259586464219],
              [-19.527187071000185, -9.53153954584328],
              [-19.524850432905623, -9.532516184238203],
              [-19.522033903740233, -9.533068543571336],
              [-19.521577600544894, -9.534079381477358],
              [-19.518294728675254, -9.534431632443141],
              [-19.516013854702756, -9.536491654051513],
              [-19.51231995226721, -9.53738785708135],
              [-19.511263978900654, -9.53962927484528],
              [-19.51211396490616, -9.540842263314827],
              [-19.513646317238656, -9.541525426473635],
              [-19.515525060921, -9.544898109287328],
              [-19.51743322574332, -9.546217780522374],
              [-19.51878131232002, -9.549103438789826],
              [-19.51911478781688, -9.552405012356617],
              [-19.5205731558726, -9.555268276816442],
              [-19.52192805340226, -9.560475811616907],
              [-19.52374484440291, -9.562089578312605],
              [-19.52628209284615, -9.563011444746923],
              [-19.528742616483978, -9.565634095771225],
              [-19.530177418642253, -9.567901968206197],
              [-19.534486698382846, -9.573826428207],
              [-19.543212076724874, -9.580551119466092],
              [-19.547173449897905, -9.582900505496859],
              [-19.549211762687364, -9.58373843598298],
              [-19.552049938542382, -9.583710456422958],
              [-19.55294997109274, -9.58327967319257],
              [-19.55764700362259, -9.579822585993929],
              [-19.558687635303215, -9.578673807229292],
              [-19.561723200033953, -9.576350970268086],
              [-19.563656949653307, -9.573590942132062],
              [-19.56864693195008, -9.570595536850291],
              [-19.5722513409386, -9.56875000578437],
              [-19.576671455695895, -9.56694615534819],
              [-19.58490968367903, -9.564383240390464],
              [-19.589505386703493, -9.563333004471403],
              [-19.593795696133743, -9.562617386596951],
              [-19.60214550018551, -9.56199587184658],
              [-19.607162357362967, -9.561907701164563],
              [-19.61207686627439, -9.562031680071158],
              [-19.617251566156447, -9.562436578084112],
              [-19.624780451549064, -9.563666659161976],
              [-19.628694917027232, -9.564741478650271],
              [-19.63020475485338, -9.567673064737544],
              [-19.632677329310265, -9.569312205314096],
              [-19.63268772532689, -9.571448239423445],
              [-19.63532167293836, -9.572630316960296],
              [-19.63706344857003, -9.57233886533304],
              [-19.63790293745282, -9.572945599168927],
              [-19.637940322406813, -9.575191455781113],
              [-19.640786301039363, -9.577088311581985],
              [-19.64224191410538, -9.577207176309814],
              [-19.64364197699427, -9.578218218557558],
              [-19.644270137662332, -9.579868973138645],
              [-19.645362805051516, -9.579919414775754],
              [-19.646625279568156, -9.578591501413838],
              [-19.649290683590607, -9.578923953021308],
              [-19.652882967791804, -9.580377547625211],
              [-19.655021162147204, -9.581559374204925],
              [-19.65929457136777, -9.584383437043241],
              [-19.661074632429216, -9.585994331185384],
              [-19.666221164122927, -9.592406992028044],
              [-19.669097638540364, -9.597096291714896],
              [-19.668663720412223, -9.603450840549781],
              [-19.667918226333352, -9.604048244022513],
              [-19.66814675803833, -9.606911127706942],
              [-19.666757249888253, -9.608849769240498],
              [-19.667288662998093, -9.611527153402447],
              [-19.66709179956545, -9.612955739895634],
              [-19.666122035670245, -9.614873239268631],
              [-19.665911622888917, -9.616727828507381],
              [-19.669421098901207, -9.616018191525248],
              [-19.67339111927923, -9.615928827645241],
              [-19.67701993056676, -9.616187504969133],
              [-19.679944304604835, -9.617533707331726],
              [-19.680802365054937, -9.618830386962088],
              [-19.682684800174805, -9.620192356251],
              [-19.68433071833433, -9.624726053916543],
              [-19.686569003197192, -9.626428054013894],
              [-19.688080009395048, -9.625301042412499],
              [-19.69127161753442, -9.622313011678767],
              [-19.691813548757455, -9.620876555869907],
              [-19.693373458140975, -9.61915992012416],
              [-19.695514924317813, -9.619189711493108],
              [-19.69791767509725, -9.61854150058925],
              [-19.698297700175942, -9.617874083270042],
              [-19.70198261437696, -9.615649839866158],
              [-19.703235039408035, -9.61300481592999],
              [-19.702355472284715, -9.61179167246275],
              [-19.7002834984946, -9.611093778029025],
              [-19.698841222665546, -9.609322898523546],
              [-19.698373767091354, -9.606782229072184],
              [-19.699892739938388, -9.602385390999725],
              [-19.70148657544087, -9.598932017871425],
              [-19.70119729309704, -9.596965354014129],
              [-19.700121968169626, -9.595110146245865],
              [-19.699879534812855, -9.59301838013515],
              [-19.70058710217721, -9.584867891760968],
              [-19.70211352163501, -9.578175416221825],
              [-19.703565294455654, -9.572921401635892],
              [-19.705174782335312, -9.568473914294877],
              [-19.707800427835686, -9.562673037072571],
              [-19.710041770231395, -9.560487433471698],
              [-19.71321357939753, -9.555512732702747],
              [-19.71478751523927, -9.553449186539675],
              [-19.718927965081996, -9.545867883016617],
              [-19.721141882038502, -9.54468225384767],
              [-19.72265149681972, -9.544699189691727],
              [-19.725146276644463, -9.543712525996966],
              [-19.726078740936206, -9.541879379520646],
              [-19.727584260167333, -9.539869214136704],
              [-19.7285905503195, -9.537253638140761],
              [-19.727538602058043, -9.536285305547565],
              [-19.72798804526179, -9.534532228897726],
              [-19.72886261224198, -9.533554980258911],
              [-19.73141053698208, -9.531712345444147],
              [-19.733540207779747, -9.529588292158136],
              [-19.73636806506476, -9.527637682032777],
              [-19.740920826415284, -9.525494294611994],
              [-19.742982350466313, -9.52556360855809],
              [-19.744126411640448, -9.526124804089562],
              [-19.74368041514858, -9.527419345951799],
              [-19.744933841510928, -9.527800810607154],
              [-19.745288985523416, -9.526146215585701],
              [-19.746833551161917, -9.525385811277163],
              [-19.748323190853682, -9.525479730426701],
              [-19.749349634490724, -9.524501418409912],
              [-19.753582156732655, -9.52338635403535],
              [-19.755751354074416, -9.520520511923355],
              [-19.759164406002096, -9.519068867385718],
              [-19.76542917114565, -9.518365385297066],
              [-19.76533559327946, -9.516629117197356],
              [-19.762664618105045, -9.515376771060426],
              [-19.761982236148373, -9.514207114815582],
              [-19.7615884969506, -9.511438119373182],
              [-19.761903122571955, -9.509335075938413],
              [-19.76160146750478, -9.507690518276533],
              [-19.76199603440123, -9.504690117951725],
              [-19.76288818975159, -9.501223824055531],
              [-19.764739124863496, -9.492751162409345],
              [-19.765915969883743, -9.488301432198801],
              [-19.767048711070277, -9.484893684326293],
              [-19.770396197726523, -9.477810815127897],
              [-19.773051636175502, -9.473606525990991],
              [-19.775640502136252, -9.469151984075156],
              [-19.779284055452592, -9.464624947479617],
              [-19.781155460405174, -9.462634344884343],
              [-19.783731341657646, -9.458753699614428],
              [-19.79293069212342, -9.449442700001198],
              [-19.795689619382074, -9.447340577285752],
              [-19.802119055040112, -9.443551192728286],
              [-19.807728729859715, -9.439279347325805],
              [-19.81123415562874, -9.436374919182045],
              [-19.820385791306606, -9.429523055076427],
              [-19.822358210728048, -9.428259756368533],
              [-19.826698218050982, -9.424756448480004],
              [-19.83321476103255, -9.420199705624196],
              [-19.837523775479166, -9.417763966320852],
              [-19.84252502677103, -9.41533859617682],
              [-19.848579250871573, -9.412981187056314],
              [-19.852608719119935, -9.41167540535735],
              [-19.86093217534683, -9.409484135208478],
              [-19.863421848882027, -9.40902909024253],
              [-19.86831819393999, -9.408671206185627],
              [-19.872123974731675, -9.409546569194214],
              [-19.878594539728564, -9.41319257556506],
              [-19.882909475705777, -9.413514261998792],
              [-19.887393068625105, -9.413028292162116],
              [-19.891333003809155, -9.41294959024709],
              [-19.894365869560794, -9.414213223970428],
              [-19.896759408396687, -9.414385947169793],
              [-19.899589689991906, -9.4153205114175],
              [-19.9005539158171, -9.416326020793347],
              [-19.901072420908672, -9.419814226707166],
              [-19.900150240726305, -9.420819691098586],
              [-19.900633656189264, -9.422753795625926],
              [-19.902307759772576, -9.422962923927898],
              [-19.90546614970968, -9.424957672262273],
              [-19.90669686828277, -9.42509196116023],
              [-19.90886375576765, -9.427118776753044],
              [-19.90861867988352, -9.428635080999003],
              [-19.90926805686636, -9.42961033807488],
              [-19.91050473556941, -9.4284822400429],
              [-19.914295183774637, -9.4276738095384],
              [-19.91530224760814, -9.428401848326386],
              [-19.91696987203419, -9.428152524964755],
              [-19.9188642505954, -9.429448490372772],
              [-19.921326716118273, -9.430135747722183],
              [-19.92240669762732, -9.430844389767845],
              [-19.92941022813218, -9.433464751651156],
              [-19.929978515387404, -9.432433856129128],
              [-19.931158726973678, -9.432656517958984],
              [-19.933483755660593, -9.43127366672527],
              [-19.933387534066444, -9.42865946897588],
              [-19.937428928189753, -9.42452459477188],
              [-19.93895286407689, -9.423889357609287],
              [-19.940301121845348, -9.425289979483184],
              [-19.941220515734493, -9.42470042261461],
              [-19.943475867177597, -9.424902389460708],
              [-19.944737272044655, -9.425560711700532],
              [-19.946144215722825, -9.424075385323263],
              [-19.946008078912115, -9.422313602232657],
              [-19.945222154730708, -9.419731108536764],
              [-19.945252269542767, -9.4185756868861],
              [-19.946399861659625, -9.41727473502355],
              [-19.95019631232647, -9.417751025652866],
              [-19.951457570854274, -9.415883496088421],
              [-19.951519631550884, -9.414566505509894],
              [-19.952858737255465, -9.413404713376583],
              [-19.954753425758753, -9.413699722934336],
              [-19.954729803461866, -9.411794044461464],
              [-19.956486860406162, -9.411590106710804],
              [-19.958855038137855, -9.408009838298826],
              [-19.96066410006602, -9.408135070406416],
              [-19.962686753361226, -9.406520364884027],
              [-19.963668608586353, -9.403656055992549],
              [-19.966251368030207, -9.402118982603316],
              [-19.968739149004072, -9.4023272521484],
              [-19.969073112773014, -9.39810882425329],
              [-19.969606613602206, -9.395862659646914],
              [-19.969281793094115, -9.393581703129945],
              [-19.969860120550468, -9.389834726855907],
              [-19.970651789785826, -9.38824583028854],
              [-19.97226944720209, -9.387273394416127],
              [-19.97305175455126, -9.386068544346108],
              [-19.973455873123623, -9.383782707383332],
              [-19.97291624239193, -9.381982173695423],
              [-19.973765768016342, -9.37950015586093],
              [-19.97471383894544, -9.378479694382062],
              [-19.974144300302374, -9.376573500211535],
              [-19.97539544336723, -9.374707914594822],
              [-19.97304664850203, -9.368213639884065],
              [-19.972866779302905, -9.364946141967854],
              [-19.974339576663372, -9.363745871014888],
              [-19.973485792215776, -9.362339021403761],
              [-19.973572170145303, -9.360029678958265],
              [-19.974289903233974, -9.35709177796794]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -164.02752864221864,
          "lat": 64.91112650443579
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02180"],
        "coty_name": ["Nome"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Nome Census Area"],
        "coty_fp_code": "180",
        "coty_gnis_code": "01419977"
      },
      "bbox": [
        -19.97539544336723, -9.832523393647598, -18.00621455651519,
        -8.542496603339723
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.876028386845457, -3.804363341355568],
            [-14.869346925327957, -3.7913425463298007],
            [-14.868098148954516, -3.7823679470470277],
            [-14.85682485774252, -3.7700473504126526],
            [-14.852266918383716, -3.7667844950359455],
            [-14.843804433124507, -3.7587470390140982],
            [-14.840589294811167, -3.7528906667118016],
            [-14.834214621993395, -3.745147183383803],
            [-14.830932744864898, -3.742712700302272],
            [-14.82383555842804, -3.740005701852585],
            [-14.81441491189506, -3.739045639205513],
            [-14.805984338808809, -3.733007169568096],
            [-14.804396259740184, -3.7255407821278053],
            [-14.801360702104374, -3.718472643081477],
            [-14.785566132563348, -3.710666916213009],
            [-14.769526436867833, -3.7038409331853583],
            [-14.77031984985954, -3.6983221969364015],
            [-14.775451568965979, -3.6853379682099874],
            [-14.776732971369563, -3.673344488375677],
            [-14.774882524743814, -3.6626483831611436],
            [-14.76263381021155, -3.649452055690162],
            [-14.755958889133101, -3.646026954182728],
            [-14.75563441694104, -3.6431250291185817],
            [-14.759150100176486, -3.638026060194385],
            [-14.760911570331906, -3.6321056104606337],
            [-14.759178536911536, -3.627197509157698],
            [-14.755743680259808, -3.626622406065301],
            [-14.752794627019954, -3.6226535275401686],
            [-14.752921432488069, -3.616513096164765],
            [-14.75774685398214, -3.607597198394687],
            [-14.754438376318578, -3.6020833581718654],
            [-14.74975542783272, -3.6014918378236964],
            [-14.744223154010887, -3.60259394346963],
            [-14.739923887959604, -3.5990841601363828],
            [-14.741874747615176, -3.5959356970595753],
            [-14.74924086418355, -3.593456958826153],
            [-14.752712861551979, -3.5868074090435944],
            [-14.749411853480169, -3.577679931456584],
            [-14.742939127546856, -3.5721579233950203],
            [-14.732524475226228, -3.568673062584552],
            [-14.726174974217704, -3.5681401540341673],
            [-14.718527242909149, -3.565670520808613],
            [-14.714523309295531, -3.5551658242750945],
            [-14.714254123997069, -3.543708948201072],
            [-14.71708154061907, -3.5400284327490867],
            [-14.71868618852493, -3.533717200089089],
            [-14.724105500625134, -3.526339139315011],
            [-14.719313319632938, -3.519727270783494],
            [-14.714463914146332, -3.5110379634539948],
            [-14.712926722640063, -3.501639094660677],
            [-14.713274261649007, -3.493920665111517],
            [-14.717102373292157, -3.4722449631502306],
            [-14.717651608116043, -3.460731896514745],
            [-14.721067917937825, -3.4441826429599165],
            [-14.715966829157606, -3.4410716925726526],
            [-14.712497877282674, -3.435193411567035],
            [-14.713340616733873, -3.424837110425202],
            [-14.715860034611762, -3.4112819870229014],
            [-14.715237153911477, -3.4038430669462967],
            [-14.712376919026989, -3.4008396961679397],
            [-14.708690412431165, -3.400403823169161],
            [-14.701727097429812, -3.403227074598222],
            [-14.693321344354565, -3.399103200992171],
            [-14.690476435133819, -3.395848115543788],
            [-14.689814757878716, -3.3868720528530107],
            [-14.693743294245426, -3.382106054858309],
            [-14.702145340603431, -3.367267334622241],
            [-14.702516282259685, -3.3596390481503713],
            [-14.700124888364636, -3.3599842313843684],
            [-14.69541776946354, -3.364205331644661],
            [-14.688714828654446, -3.362735083747689],
            [-14.68746050212834, -3.3597355638628583],
            [-14.688942492436446, -3.3519757840948867],
            [-14.69328402684797, -3.3445330701497227],
            [-14.697954038463665, -3.3387391995916476],
            [-14.704790235682719, -3.334206248924012],
            [-14.703712024917493, -3.3249130061541785],
            [-14.695650323610455, -3.3130041695886696],
            [-14.688733044638386, -3.3063644268147105],
            [-14.683287853022467, -3.3048915708324684],
            [-14.678370056592644, -3.306723396810459],
            [-14.669665587978974, -3.3037979159511615],
            [-14.664776587641862, -3.299586803932703],
            [-14.654796888503808, -3.29264697818457],
            [-14.650990644064388, -3.287508671971632],
            [-14.64134052962899, -3.282455636895337],
            [-14.6378108186151, -3.278190275948606],
            [-14.631306750359174, -3.2784313863286103],
            [-14.629359373438929, -3.272531422706221],
            [-14.634335566184172, -3.267587472380206],
            [-14.634549397916665, -3.2638905188129326],
            [-14.630330117031185, -3.2597890247637924],
            [-14.623696387054748, -3.262415307229746],
            [-14.61381608393364, -3.2590152524348355],
            [-14.608082484292819, -3.2535449689402407],
            [-14.605328327576956, -3.2484732051542693],
            [-14.602457985761227, -3.2390905236082586],
            [-14.601967575504338, -3.234233811489518],
            [-14.602993055324655, -3.226251032612734],
            [-14.602095000931339, -3.218544930171813],
            [-14.598030126553633, -3.204943118376271],
            [-14.594698936862313, -3.1976093468849096],
            [-14.592206205001803, -3.1902524719186522],
            [-14.586192338309045, -3.185886741100242],
            [-14.58386794085994, -3.181979652568481],
            [-14.573538758553752, -3.1731416070453955],
            [-14.569665938877124, -3.1714446371347607],
            [-14.561023550628361, -3.171474968552519],
            [-14.552629990799925, -3.174725296388512],
            [-14.542350264250425, -3.17068266648314],
            [-14.53159941650992, -3.1701316455443243],
            [-14.525698194542601, -3.166156221421016],
            [-14.521124626497748, -3.1600244906455965],
            [-14.513637619818649, -3.1573555129065465],
            [-14.5040940753173, -3.1596513283686214],
            [-14.494268235288013, -3.158774672601701],
            [-14.48274916987089, -3.152800468437791],
            [-14.462879999906427, -3.1341673306468616],
            [-14.457704892836222, -3.1312744412265023],
            [-14.447700615965799, -3.131558125929227],
            [-14.442433059941825, -3.134570686308512],
            [-14.430352394607835, -3.13320534683086],
            [-14.421219928094938, -3.1290386736782834],
            [-14.417723085702232, -3.126019702204293],
            [-14.408151598156014, -3.1240875069889906],
            [-14.40561904758766, -3.1225919483892834],
            [-14.402966511176158, -3.117950054473482],
            [-14.402194608020844, -3.11002406840259],
            [-14.399553393274008, -3.1070896962811543],
            [-14.392431641570669, -3.104553997478243],
            [-14.368432915369867, -3.0867492663259917],
            [-14.356357422346923, -3.079745449761254],
            [-14.35217185769584, -3.0730367858664063],
            [-14.345231981401815, -3.0719752809658343],
            [-14.342374116427425, -3.0687326742652887],
            [-14.3419051860755, -3.063031641539902],
            [-14.332957417999955, -3.065487627098483],
            [-14.325804446209743, -3.0655009914261115],
            [-14.318625066390997, -3.068666610204178],
            [-14.31428614860155, -3.064538292273452],
            [-14.31595829978619, -3.0578248216870243],
            [-14.316252012331395, -3.04951353758829],
            [-14.314721789415435, -3.0458981487351435],
            [-14.314656231958725, -3.030523429147558],
            [-14.312236559970387, -3.0234188861312297],
            [-14.304107811928148, -3.0240917711439006],
            [-14.302519583153842, -3.0271369915578585],
            [-14.294536802393951, -3.0348606413324357],
            [-14.287447912614677, -3.0349560640153355],
            [-14.280507911597402, -3.032189075870981],
            [-14.272213254392785, -3.035917180493287],
            [-14.267230435753005, -3.0434814066246543],
            [-14.26360759795953, -3.043373345584981],
            [-14.259108575885394, -3.0467143036315614],
            [-14.255451127128243, -3.0541394142528646],
            [-14.251210549245062, -3.060218712406601],
            [-14.24797539888363, -3.061762257787502],
            [-14.244719347940872, -3.066823852157105],
            [-14.24500658019013, -3.0704417440233023],
            [-14.238689066271409, -3.0778529943391555],
            [-14.238505112603029, -3.0815283539655187],
            [-14.23448504912736, -3.0829992367422725],
            [-14.230779862350916, -3.080627093743081],
            [-14.22800206749511, -3.0757374790871554],
            [-14.223320504972671, -3.0785479475713253],
            [-14.219696348559582, -3.088628940770512],
            [-14.21499477842211, -3.0928319841904304],
            [-14.209899892329487, -3.0925479626046384],
            [-14.202241429848467, -3.0945257500796663],
            [-14.192572077353717, -3.0933500572574912],
            [-14.179979370889452, -3.095023774966117],
            [-14.169076375061241, -3.0981915679931955],
            [-14.161442494514977, -3.10192165095625],
            [-14.154053722609751, -3.108962538436817],
            [-14.135204814618811, -3.1135839209939746],
            [-14.127255006921041, -3.11461439264175],
            [-14.113448659240165, -3.113482385524638],
            [-14.106208253768289, -3.112248146252444],
            [-14.095762841019186, -3.1158935568785395],
            [-14.091338676939145, -3.118938819941993],
            [-14.09133409197274, -3.127880246212588],
            [-14.088136749710701, -3.1346134026986845],
            [-14.085507803604104, -3.1481052522182744],
            [-14.081985141969112, -3.149482994611147],
            [-14.074851580263099, -3.148515118642922],
            [-14.07038897789078, -3.1466074401277786],
            [-14.069029423545707, -3.1426030757793315],
            [-14.065297786529529, -3.14014084496327],
            [-14.063817491510678, -3.143310578757347],
            [-14.059287649893372, -3.1435997711326094],
            [-14.05523980897947, -3.141690653587485],
            [-14.048055660213302, -3.142021630206959],
            [-14.038634690499952, -3.1514966959248616],
            [-14.033022381312158, -3.152735477677987],
            [-14.028238638967574, -3.1500229007071505],
            [-14.024234281677664, -3.150017179658057],
            [-14.018429890894199, -3.1476647557935116],
            [-14.010115884179662, -3.1474701137558494],
            [-14.006512200694258, -3.146402743544569],
            [-13.998412450548091, -3.1467993768061113],
            [-13.995918968210686, -3.148264760405284],
            [-13.99294660193565, -3.1609169127137675],
            [-13.992699400236404, -3.166404161751445],
            [-13.986461633107789, -3.1695153241192946],
            [-13.986782435005452, -3.1730972865066818],
            [-13.98174413462632, -3.1765636822301526],
            [-13.980332527343824, -3.182240989181012],
            [-13.968328557375315, -3.1836714789472538],
            [-13.960105947401198, -3.1861138992192606],
            [-13.956989452970383, -3.1838877910089174],
            [-13.950525214092728, -3.184161969165909],
            [-13.947349008045899, -3.1862716086269547],
            [-13.942510811658781, -3.1818156865086005],
            [-13.939052671880386, -3.183088159546256],
            [-13.934714703426636, -3.1795075747926185],
            [-13.928637066538206, -3.1779485235148694],
            [-13.92114724882029, -3.178932777916228],
            [-13.913797559388051, -3.1750381550361673],
            [-13.907119225309414, -3.1780866633124343],
            [-13.898110910208667, -3.1754339186166964],
            [-13.8974638837125, -3.177932217928016],
            [-13.89130517476867, -3.1749789454730406],
            [-13.888847306346419, -3.171504230648761],
            [-13.87924409622466, -3.166944982057868],
            [-13.873797225914474, -3.1531548986264624],
            [-13.864010211257506, -3.145111771355451],
            [-13.860800562803622, -3.1442225301606275],
            [-13.858830849913812, -3.1387065664938163],
            [-13.84476612843866, -3.130073750275972],
            [-13.837113509594127, -3.119553377194191],
            [-13.829415268503709, -3.1116873733078365],
            [-13.821946649811785, -3.109294147094272],
            [-13.816913656721216, -3.1114754936101305],
            [-13.810441861006122, -3.1112246536353374],
            [-13.806546831429628, -3.118008061981856],
            [-13.80081102045215, -3.120671095507366],
            [-13.793876965438272, -3.121948169562255],
            [-13.78970230347805, -3.1203624776484538],
            [-13.783078690170038, -3.1236671195051238],
            [-13.778547871689893, -3.1221859235757763],
            [-13.774714289459759, -3.1264896786743086],
            [-13.770590723085506, -3.1252292868222415],
            [-13.760444542925372, -3.131111820002949],
            [-13.75228524844759, -3.1329877916138655],
            [-13.74471430030142, -3.132480557701542],
            [-13.734343279279958, -3.137255477012804],
            [-13.729343710364184, -3.1425356554644908],
            [-13.71950887377171, -3.139017039692446],
            [-13.714324925280659, -3.140235254376803],
            [-13.708370804314114, -3.1459931440998927],
            [-13.695983733438252, -3.1512604331501137],
            [-13.686191843730558, -3.14996804390067],
            [-13.679577334730928, -3.146602894855707],
            [-13.676198583186045, -3.1435425447650176],
            [-13.67339027963747, -3.1387876374630874],
            [-13.66886162031102, -3.135427231088905],
            [-13.670153352817524, -3.13146409258406],
            [-13.667148125416224, -3.128878010885041],
            [-13.661347173487274, -3.1310936933602003],
            [-13.674015419744418, -3.1982354380322855],
            [-13.673926366322545, -3.199189122948149],
            [-13.696445986046054, -3.3219910464890425],
            [-13.697276299705736, -3.3246769308916275],
            [-13.71935624485019, -3.445613323566157],
            [-13.786803383091303, -3.802671102477606],
            [-13.800068888917297, -3.8744691505215445],
            [-13.814769981340833, -3.9539213835172795],
            [-13.834495837541438, -4.06068258613352],
            [-13.960751459042275, -4.037321347694455],
            [-14.08700423613751, -4.013944067392216],
            [-14.17404839671433, -3.9976050604108204],
            [-14.341860031534512, -3.965508553168209],
            [-14.325887575638435, -3.879745967025995],
            [-14.417339523582386, -3.8622122357895257],
            [-14.536529594481797, -3.8392161759698564],
            [-14.57869365213524, -3.831096870341829],
            [-14.611738778248446, -4.004033527846266],
            [-14.612400600384504, -4.003905042785802],
            [-14.66223177839825, -4.259303169639102],
            [-14.746435551593658, -4.242911440672492],
            [-14.74681020254809, -4.244820191193769],
            [-14.86545901735193, -4.22176225653307],
            [-14.87032582077021, -4.217603670675314],
            [-14.882007934875542, -4.212785234549216],
            [-14.893938158148696, -4.20986892673854],
            [-14.908509288554217, -4.204282915969066],
            [-14.914174459626587, -4.204442335998084],
            [-14.920864907922176, -4.2104302813161185],
            [-14.925353411276784, -4.211592872440082],
            [-14.934695916875471, -4.210583254368341],
            [-14.948870094518295, -4.205945893182336],
            [-14.95588280161195, -4.200618210974646],
            [-14.96229123166331, -4.184778357899276],
            [-14.966833220930804, -4.18018199573073],
            [-14.969720975022524, -4.181799508333153],
            [-14.979470749141317, -4.193106095274455],
            [-14.983365846485288, -4.193514379788847],
            [-14.989255669540114, -4.186908586438872],
            [-14.990820225213444, -4.182593559227547],
            [-14.990893568279478, -4.1768121770039075],
            [-14.98833978645223, -4.167454476650753],
            [-14.995995909836541, -4.151812314191665],
            [-14.996721254342107, -4.146394095609382],
            [-14.995083489948724, -4.138619348580276],
            [-14.999231494700313, -4.135553491172012],
            [-15.004540586216951, -4.13435275756705],
            [-15.008533719144268, -4.131724458598869],
            [-15.00785823013727, -4.122368000863964],
            [-15.001203424266222, -4.1069684777385564],
            [-14.992179597034163, -4.090909984112708],
            [-14.985290770855283, -4.085447133418302],
            [-14.982059451746833, -4.081674066282611],
            [-14.971172354996858, -4.06259289073525],
            [-14.971080848491562, -4.05568145827027],
            [-14.965158865909245, -4.04477423173954],
            [-14.963327573002369, -4.038320612384662],
            [-14.963228483163919, -4.022707926935471],
            [-14.956020340640967, -4.007965798443113],
            [-14.955413093461134, -4.001678038505525],
            [-14.960287839271748, -3.991070951573655],
            [-14.96370755897438, -3.979812188786074],
            [-14.962182629341047, -3.9773341703430405],
            [-14.949509045844176, -3.972037971248918],
            [-14.946848737326984, -3.9675765038230697],
            [-14.948714900708579, -3.9572734060686563],
            [-14.953535125290768, -3.950320341476082],
            [-14.961010023473868, -3.944983359517197],
            [-14.979030408218899, -3.9358982450805016],
            [-14.982839016024368, -3.93214749064991],
            [-14.986494320363343, -3.9167175321757717],
            [-14.984767847138981, -3.913670315938459],
            [-14.978400254855893, -3.908419418856387],
            [-14.966281928036278, -3.9021290110579567],
            [-14.960353999148778, -3.8959751526054434],
            [-14.9550317533971, -3.887562926408804],
            [-14.949633145998778, -3.872834717735863],
            [-14.948748092053442, -3.864093530309266],
            [-14.952448758801374, -3.847501264905556],
            [-14.951830425706007, -3.8399222910942874],
            [-14.95524528383545, -3.8350325996930406],
            [-14.960710762723956, -3.8231658161491984],
            [-14.961434899610163, -3.8165994518652115],
            [-14.95663289224271, -3.8146432285836203],
            [-14.949288731555166, -3.816757698116593],
            [-14.94162903214115, -3.817119978413222],
            [-14.937853732545143, -3.815254533657424],
            [-14.935361794114137, -3.8114629771529063],
            [-14.928545738653492, -3.8099323040216553],
            [-14.91705143831352, -3.8118523604018817],
            [-14.90546751398687, -3.819543032813252],
            [-14.898160763302371, -3.820381081277163],
            [-14.892477819963657, -3.8183204639486843],
            [-14.884703048989147, -3.8137354299181103],
            [-14.879135022570033, -3.8092953763686896],
            [-14.876028386845457, -3.804363341355568]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.98149455658415,
          "lat": 33.72940417566808
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04012"],
        "coty_name": ["La Paz"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["La Paz County"],
        "coty_fp_code": "012",
        "coty_gnis_code": "00043540"
      },
      "bbox": [
        -15.008533719144268, -4.259303169639102, -13.661347173487274,
        -3.0234188861312297
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.944483644414877, -4.294647639918255],
            [-11.917378443684887, -4.399827127073385],
            [-11.910625909912, -4.4263490255588565],
            [-11.902206903096573, -4.52086879392316],
            [-11.858990151467664, -4.651603313854458],
            [-11.85617724957988, -4.660758053636108],
            [-11.815554657754474, -4.7861026132047995],
            [-11.809419681117026, -4.8048402004484005],
            [-11.80782335709341, -4.806154364702974],
            [-11.794079575211788, -4.805562969895992],
            [-11.792559764409674, -4.801824430672503],
            [-11.792188598021708, -4.791480533402792],
            [-11.790276252159856, -4.787368665252254],
            [-11.781602575164401, -4.786616569659275],
            [-11.779246986449694, -4.783357194827981],
            [-11.775614283970151, -4.783894086369156],
            [-11.771259528201604, -4.776185608819474],
            [-11.7667308914994, -4.775642708763293],
            [-11.758452027688238, -4.769632893026516],
            [-11.75621080442921, -4.764146326476079],
            [-11.75699548843304, -4.761578905048172],
            [-11.752707218753589, -4.755719579897294],
            [-11.750282562776405, -4.7548047465026055],
            [-11.745844296851738, -4.757890806337097],
            [-11.744276273291504, -4.754230807015465],
            [-11.744187989383523, -4.7459544494716654],
            [-11.748874857866198, -4.728238182241652],
            [-11.741452870731466, -4.723036284904693],
            [-11.736860725253155, -4.721499986508953],
            [-11.735404706053993, -4.718120595560818],
            [-11.729711372152778, -4.716791702335156],
            [-11.723752499049795, -4.723244059948929],
            [-11.72095927036973, -4.724990468002169],
            [-11.71629323430518, -4.721430237476272],
            [-11.716760471533648, -4.718382384549188],
            [-11.720830520148517, -4.716623526267648],
            [-11.717601001590703, -4.713433041262976],
            [-11.711121263757837, -4.715260243443036],
            [-11.709644201001453, -4.710255480391338],
            [-11.709270235723332, -4.703505955838083],
            [-11.706208416711425, -4.7027416094480525],
            [-11.703086254611991, -4.6929079072491335],
            [-11.698826812650244, -4.69328947373571],
            [-11.694806309777462, -4.6874320869667585],
            [-11.689153026523243, -4.687254716481882],
            [-11.689837102485303, -4.69250266456892],
            [-11.685385569809965, -4.693444202313817],
            [-11.677487261442497, -4.685657041818802],
            [-11.676825294860079, -4.683884544662944],
            [-11.669372257066774, -4.676804256163246],
            [-11.662544194379272, -4.667717077222336],
            [-11.65098875028096, -4.667833770252569],
            [-11.641224296920642, -4.671004960564017],
            [-11.63537990930786, -4.67671272896731],
            [-11.633532644627616, -4.68026132635023],
            [-11.63017665838801, -4.681284566767824],
            [-11.624329940200278, -4.678747098669657],
            [-11.621278006878395, -4.674020348830421],
            [-11.616623266327192, -4.669968844584238],
            [-11.61242370058741, -4.673446942280814],
            [-11.608388493643295, -4.673594371738895],
            [-11.605961626231045, -4.670492434943996],
            [-11.601734016968402, -4.670010391665046],
            [-11.600754562122969, -4.666073428914283],
            [-11.596125320343543, -4.664848992575622],
            [-11.591257331927586, -4.667821770855631],
            [-11.590984676223032, -4.663499937422574],
            [-11.58577341703957, -4.652758734364001],
            [-11.58315641858306, -4.653563009920959],
            [-11.58219192227428, -4.658348134016562],
            [-11.572664941763865, -4.66507874906642],
            [-11.568728184424469, -4.6628999205431985],
            [-11.571370329319215, -4.660138380803539],
            [-11.573791896344696, -4.661835197967552],
            [-11.576869529139005, -4.658234094905212],
            [-11.576372513264204, -4.655270320445237],
            [-11.570236901065595, -4.651542300834883],
            [-11.56955256941661, -4.647599251193925],
            [-11.560312070631287, -4.649635718595541],
            [-11.557483156754714, -4.646386041905284],
            [-11.554237122242943, -4.646171330367386],
            [-11.549215029572709, -4.640623604377498],
            [-11.544233322309198, -4.640797404423125],
            [-11.53692311003607, -4.645515572339522],
            [-11.521780724175592, -4.648996094923326],
            [-11.515604294603227, -4.648720426602894],
            [-11.514070591104648, -4.645105001470408],
            [-11.515004481707148, -4.639661908432673],
            [-11.50567847425708, -4.635317735678466],
            [-11.502168674686569, -4.639419486782135],
            [-11.533620549311589, -4.841988158655675],
            [-11.540100899989726, -4.884286339056763],
            [-11.539377127057646, -4.884396822947626],
            [-11.566283761295113, -5.059090012385518],
            [-11.576848019141794, -5.127317395876301],
            [-11.606033864441532, -5.3136291473960116],
            [-11.607931161420606, -5.313339689022285],
            [-11.64856463269378, -5.306933767289248],
            [-11.653485863980983, -5.306469894843749],
            [-11.774882760661205, -5.28788464996951],
            [-11.884840695986187, -5.270752422762432],
            [-11.934071145382076, -5.263018889566887],
            [-11.934485796458972, -5.265737526923376],
            [-11.979203852303483, -5.258099924741839],
            [-12.00346004592837, -5.254766007274228],
            [-12.101867014556383, -5.239072943109409],
            [-12.193191614807661, -5.224597497563076],
            [-12.194790908375785, -5.234109979527301],
            [-12.251168913792926, -5.224824579116068],
            [-12.256986106857514, -5.224093225870686],
            [-12.37051340025729, -5.206042470757135],
            [-12.449903059956608, -5.193109469450429],
            [-12.535600137414342, -5.179002399489582],
            [-12.5347211601258, -5.173685905189171],
            [-12.552566416856635, -5.170809087844047],
            [-12.719447527032942, -5.143180470664858],
            [-12.853906647104997, -5.120588058317807],
            [-12.956610094487703, -5.103090153828054],
            [-13.05931127278562, -5.085578597403685],
            [-13.043379603197813, -4.993650829286288],
            [-13.029089447267319, -4.9109443008035845],
            [-13.002946599709825, -4.759885105496289],
            [-12.984958279772243, -4.655911064493791],
            [-12.98452219950224, -4.655674482426238],
            [-12.969616922515236, -4.569568098510294],
            [-12.968930378923801, -4.569684890637337],
            [-12.95093079891929, -4.465451921410818],
            [-12.939182045563843, -4.397503090736192],
            [-12.924225648430017, -4.3112696230626],
            [-12.925154104900033, -4.311113300664995],
            [-12.92102861888308, -4.294457620444316],
            [-12.915944039742705, -4.304054905625503],
            [-12.915951942910255, -4.306590945685749],
            [-12.920691954692463, -4.313036310922024],
            [-12.919958745634029, -4.317771306145221],
            [-12.922571880537744, -4.323807252107838],
            [-12.922437792293042, -4.328494318174113],
            [-12.919929736493973, -4.334838348979104],
            [-12.920170403507912, -4.337864907245767],
            [-12.911802530616251, -4.341859356429783],
            [-12.907379140945505, -4.3420186057097565],
            [-12.906997682451887, -4.34706744045913],
            [-12.902949465468714, -4.346362609872722],
            [-12.897067422490784, -4.3527789501870355],
            [-12.888586296493655, -4.354261029794266],
            [-12.883862967052117, -4.358504091345146],
            [-12.880985511800874, -4.363205139935625],
            [-12.881146570438727, -4.366313187291705],
            [-12.877461488951637, -4.369094920428366],
            [-12.876984185876536, -4.377396563603937],
            [-12.871723957617386, -4.3762209645957455],
            [-12.863990199759009, -4.381537472393974],
            [-12.862614870181806, -4.3859696055004855],
            [-12.85332073297305, -4.384410993870722],
            [-12.847487860315546, -4.385615422003777],
            [-12.843552426349495, -4.391234870532257],
            [-12.842980782245522, -4.3966595858156055],
            [-12.848048836777997, -4.406971572534206],
            [-12.840481784912534, -4.412946520635403],
            [-12.769527755938496, -4.424986863899795],
            [-12.685705374494477, -4.439128421515366],
            [-12.685509213052468, -4.440613789273127],
            [-12.62890197891332, -4.449144790186371],
            [-12.614629231266877, -4.451079806720413],
            [-12.572848276726411, -4.457962683656181],
            [-12.515877482210016, -4.467591510754125],
            [-12.431059423577263, -4.480843735445996],
            [-12.418574067514514, -4.402172792820587],
            [-12.417122473107346, -4.394479693205424],
            [-12.412894529380685, -4.366377678180218],
            [-12.403755006106518, -4.308943997471824],
            [-12.400995176644857, -4.309456265664263],
            [-12.386638691486585, -4.223220763785731],
            [-12.301756727431583, -4.237089338675698],
            [-12.132443987686676, -4.26460641161863],
            [-11.950976279438242, -4.293902972912578],
            [-11.944483644414877, -4.294647639918255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.34476226977357,
          "lat": 32.90440211180693
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04021"],
        "coty_name": ["Pinal"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pinal County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00025447"
      },
      "bbox": [
        -13.05931127278562, -5.3136291473960116, -11.502168674686569,
        -4.223220763785731
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.4486581277913, -3.765091312967215],
            [4.447010211011687, -3.7203278168006197],
            [4.489884570385421, -3.7177611860079587],
            [4.57414056183695, -3.7185654916752666],
            [4.603009339779085, -3.717089329254546],
            [4.6568553980072664, -3.714591820379282],
            [4.697229212135729, -3.712986898332465],
            [4.804139306394412, -3.70693636535928],
            [4.836720642262726, -3.7046310134360523],
            [4.885247607584517, -3.7027091104766794],
            [4.8925521655576185, -3.702180200328082],
            [4.93477853624862, -3.700663381104519],
            [5.008218393176945, -3.6970583008988],
            [5.011237734077033, -3.7409084206840406],
            [5.0132755537029645, -3.774571868152046],
            [5.005549805518732, -3.776050369580491],
            [4.9952506612227525, -3.7762447684432847],
            [4.988354926078508, -3.77762786950724],
            [4.978582941118407, -3.763409905399381],
            [4.989082296263368, -3.746336293181583],
            [4.993520647703068, -3.735634536826128],
            [4.992655851362026, -3.731045201977799],
            [4.98672555714768, -3.719780524689356],
            [4.983725486083052, -3.717215005495493],
            [4.972124769474054, -3.7123659537738334],
            [4.9653177129364545, -3.7119499881320897],
            [4.96150894916654, -3.7135143220493414],
            [4.954480562344219, -3.7185234524406816],
            [4.950521204938775, -3.72356757850242],
            [4.9483758910460285, -3.7298822038858077],
            [4.9490190933915175, -3.7412796139963516],
            [4.951321170537984, -3.746968209287932],
            [4.957506298257551, -3.7541135723963976],
            [4.96938580524358, -3.772211025726524],
            [4.9750863846065645, -3.782900653844193],
            [4.968806810193019, -3.7870671649074334],
            [4.964192092884647, -3.791780377944393],
            [4.959374852397816, -3.8042756566925484],
            [4.959550370071837, -3.8112166216706367],
            [4.96520947700394, -3.8236974795213814],
            [4.9811179494252436, -3.8481711025004954],
            [4.984548264962656, -3.8562468862834747],
            [4.985547103318911, -3.864598351190298],
            [4.9802669093959855, -3.8714323501942496],
            [4.972749141888318, -3.877242197997122],
            [4.964817310938494, -3.881151534901523],
            [4.951400372238573, -3.884448614732958],
            [4.944602819561314, -3.8845616751876455],
            [4.937707401364169, -3.8829999955040875],
            [4.9243712842076075, -3.875931823349025],
            [4.932894751062265, -3.862432426520601],
            [4.937493516493974, -3.8566447520141924],
            [4.947077090168552, -3.848377581386195],
            [4.948239893988765, -3.841145078912298],
            [4.9475116632568135, -3.8331673055542668],
            [4.938521566218656, -3.822768685210477],
            [4.931357689799453, -3.816464183890109],
            [4.931100470726034, -3.8081251814621533],
            [4.922758178494381, -3.804921360028725],
            [4.91281314035313, -3.8075402684834425],
            [4.907078781984206, -3.811981374588925],
            [4.90460915958819, -3.8163215227390075],
            [4.902154970128785, -3.8248610808168015],
            [4.904969261215217, -3.8375064372937646],
            [4.910556327204584, -3.852652721180347],
            [4.9065322779549225, -3.8693977505456485],
            [4.902868352426131, -3.8687682848700464],
            [4.891906102337723, -3.8713542744561944],
            [4.888771633447185, -3.8760123422243704],
            [4.888781731454414, -3.888048074388102],
            [4.886564834207052, -3.8968511916334605],
            [4.89685096505361, -3.8982225804675434],
            [4.902196490851509, -3.902752315761859],
            [4.91126990628511, -3.9083123536160067],
            [4.919673230760283, -3.91162158120966],
            [4.9325573413663015, -3.9115674256666595],
            [4.9591890346245115, -3.9013514497503525],
            [4.966585580812984, -3.899802778257131],
            [4.972999809477976, -3.9047474510927054],
            [4.975858151726165, -3.9119934455416834],
            [4.977068719393465, -3.9205584069431327],
            [4.975015784309499, -3.930514123626882],
            [4.97300262521136, -3.9349497129806035],
            [4.963381222588674, -3.9476082228339773],
            [4.949160883043829, -3.961563665973373],
            [4.942958741658744, -3.9702851182658874],
            [4.935905531009702, -3.9764888499797792],
            [4.930087881170747, -3.979265891865217],
            [4.923941685360043, -3.9808050450000234],
            [4.9161258125659915, -3.97995914044113],
            [4.911056972841052, -3.9771830243231525],
            [4.905216679901542, -3.9682336858933906],
            [4.904112657927084, -3.9628917637096905],
            [4.905340228232503, -3.949249560947003],
            [4.9146710673144876, -3.9314537862280075],
            [4.913052848423558, -3.925248355756833],
            [4.909343945962981, -3.9201108118051717],
            [4.900459768507349, -3.9154043035621693],
            [4.889177825727178, -3.916193958460263],
            [4.89196168786013, -3.930482422663423],
            [4.891971825817567, -3.9407737630518733],
            [4.891052159171566, -3.94337324650641],
            [4.88261437601013, -3.955114003434606],
            [4.880918023190918, -3.9584455861261447],
            [4.87815024319504, -3.9692852587265253],
            [4.8135842042888655, -3.9724861001333296],
            [4.745352792205671, -3.9757599078581958],
            [4.730827407936962, -3.976295820188745],
            [4.601137459409161, -3.982044163152682],
            [4.538784520783526, -3.984290688394559],
            [4.499291336189532, -3.9855166948683114],
            [4.497774093128641, -3.926847111132726],
            [4.4967146125591135, -3.896541535011254],
            [4.453485622690405, -3.898092962760886],
            [4.451012250945924, -3.8242034242840046],
            [4.4486581277913, -3.765091312967215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.78080332885345, "lat": 34.78052847294106 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05077"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00066866"
      },
      "bbox": [
        4.447010211011687, -3.9855166948683114, 5.0132755537029645,
        -3.6970583008988
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.558479699009368, 6.234744775201222],
            [-19.506723628968736, 6.219282344156378],
            [-19.43797752796268, 6.1976274954721156],
            [-19.354672666605797, 6.178033845077837],
            [-19.32074373130648, 6.170042656373816],
            [-19.292867598515915, 6.165000059504424],
            [-19.27847605680371, 6.160173029967067],
            [-19.248039859722688, 6.148071394419523],
            [-19.235323469801738, 6.14411487193153],
            [-19.222441030710122, 6.138556042019366],
            [-19.113114629515408, 6.107589538734919],
            [-19.059098261111362, 6.092369309248073],
            [-18.98764323190909, 6.071888262758918],
            [-18.93185720395023, 6.056757407656165],
            [-18.87033470974607, 6.041765408164323],
            [-18.830740402200767, 6.031112094609824],
            [-18.77626936713304, 6.015901950669151],
            [-18.748912674609276, 6.009296014935259],
            [-18.686303410955936, 5.9901471192129705],
            [-18.665809229229577, 5.983861182863991],
            [-18.596919077738093, 5.964102493426899],
            [-18.583301333401078, 5.959537386038018],
            [-18.514869952531296, 5.939103165547288],
            [-18.5060448841706, 5.935967054816943],
            [-18.451578300544956, 5.919508331614938],
            [-18.43898483871931, 5.916336840044659],
            [-18.340764312829346, 5.887312971327721],
            [-18.26559707846328, 5.864972023544853],
            [-18.192324107076384, 5.843313453155064],
            [-18.090634080424675, 5.813717487232642],
            [-18.103129292575463, 5.7684719038068195],
            [-18.11018669919743, 5.769674282948142],
            [-18.15627099037775, 5.601770866114513],
            [-18.150578200575403, 5.600309826261335],
            [-18.182134595656187, 5.484661667071179],
            [-18.19149751765299, 5.453923783443791],
            [-18.19204073936074, 5.4504649760960815],
            [-18.219692946198176, 5.349109098287255],
            [-18.231452351799526, 5.30663817377864],
            [-18.242887037654526, 5.2645676049810755],
            [-18.241487100394355, 5.263768900838672],
            [-18.277812649707062, 5.131352667628924],
            [-18.30687779737851, 5.0260654670810245],
            [-18.40467859908662, 5.052898147014982],
            [-18.502483637708483, 5.079714378102309],
            [-18.572461975857777, 5.098983904729109],
            [-18.57541469153373, 5.099914584203741],
            [-18.718507964273293, 5.139601567324366],
            [-18.79581970181166, 5.161000247234687],
            [-18.810841827565117, 5.166875023737962],
            [-18.84564659125284, 5.176549944732601],
            [-18.91183671425672, 5.195732820323716],
            [-18.932955367873447, 5.201629371357822],
            [-18.975405991931197, 5.211626954265789],
            [-19.063228627177246, 5.236362539363816],
            [-19.06305309970769, 5.238383233746964],
            [-19.058110203612763, 5.245098346418342],
            [-19.05895167356955, 5.248607605385906],
            [-19.063539679258614, 5.253637169826209],
            [-19.066184374202855, 5.259118517655314],
            [-19.069317301122506, 5.261402996463011],
            [-19.07207328647153, 5.271099642828749],
            [-19.068302849574835, 5.275695057810757],
            [-19.061042474652485, 5.281451287823382],
            [-19.062608008653, 5.2917849586917685],
            [-19.058841978790408, 5.2955377994753565],
            [-19.052935962293205, 5.298806781697901],
            [-19.05255282992529, 5.302701638017279],
            [-19.054264757620174, 5.309550443286121],
            [-19.05103978211308, 5.32071789095887],
            [-19.048474323214485, 5.323124665680272],
            [-19.048605064399954, 5.326725253057933],
            [-19.045924297728124, 5.336890593373051],
            [-19.042274290017016, 5.341053004474851],
            [-19.036329098869754, 5.340614944937742],
            [-19.031778428528142, 5.345456238319059],
            [-19.030690888930945, 5.359098220577885],
            [-19.02180813062576, 5.3610825993896265],
            [-19.01770895705255, 5.363617287564851],
            [-19.011064405791732, 5.364959545083385],
            [-19.012449938538456, 5.368255931834972],
            [-19.017095499178385, 5.3714549796762805],
            [-19.02036056427616, 5.377923837847377],
            [-19.025260883487732, 5.384270355732011],
            [-19.02270430024273, 5.392179247419265],
            [-19.03395733971983, 5.396213655381493],
            [-19.04128461544403, 5.395808126481586],
            [-19.045972058441755, 5.397289869827051],
            [-19.04847230537201, 5.402561250606851],
            [-19.04750657501795, 5.410839280281004],
            [-19.05172800027215, 5.4199980676949115],
            [-19.057243041185632, 5.426018287314006],
            [-19.06074479956398, 5.426501000512349],
            [-19.06284672477232, 5.429667616385937],
            [-19.07164350330214, 5.426868391597272],
            [-19.076491523655655, 5.424262393883226],
            [-19.080294616374452, 5.415913151911527],
            [-19.07990308415437, 5.4095944163893686],
            [-19.078445022259245, 5.406479711112184],
            [-19.080333299532324, 5.401825508523899],
            [-19.08565818714645, 5.398904707069607],
            [-19.086954715441898, 5.395061588923624],
            [-19.089688320342674, 5.393480663802273],
            [-19.09720573989658, 5.39562198276867],
            [-19.100858097480046, 5.400098300531401],
            [-19.108629138160655, 5.4005876350517354],
            [-19.11423653504724, 5.406893441166482],
            [-19.117895190584527, 5.4072617828892895],
            [-19.12941988575734, 5.403332153637535],
            [-19.132373910864438, 5.39976693304098],
            [-19.13257600428835, 5.394636847093419],
            [-19.13481105071209, 5.384289374923349],
            [-19.140519076452012, 5.380560066743326],
            [-19.144939648796605, 5.3710090480724855],
            [-19.14639795738712, 5.373634047919384],
            [-19.151288901645444, 5.375343982763336],
            [-19.163022770493026, 5.371757174117517],
            [-19.16461165326353, 5.366972077791783],
            [-19.16853869319473, 5.366028161149002],
            [-19.170788718755507, 5.370161755134312],
            [-19.179430569058507, 5.368191916348993],
            [-19.185634010970485, 5.36785894534637],
            [-19.190714455465358, 5.3690609779301175],
            [-19.19893391378285, 5.363221553741604],
            [-19.203607772086947, 5.358440728756842],
            [-19.20696750446156, 5.350900122189196],
            [-19.207911860772196, 5.345461393418294],
            [-19.21420889183725, 5.343436393461277],
            [-19.219377970821, 5.345406276047186],
            [-19.223322261873903, 5.343774828221755],
            [-19.22978865995606, 5.345914140664991],
            [-19.238085635406822, 5.344342479724836],
            [-19.24158611633571, 5.341253918728528],
            [-19.24962698194116, 5.3401006139358795],
            [-19.25224369849052, 5.334137005273038],
            [-19.256184183933918, 5.328753376397316],
            [-19.26047271460798, 5.328759682658128],
            [-19.262859279424454, 5.324835235158123],
            [-19.268375411809384, 5.325149895659329],
            [-19.271083266238083, 5.321313997484542],
            [-19.275408056750678, 5.318491062351021],
            [-19.282194180810727, 5.3198251207101235],
            [-19.2846950786572, 5.325922747662626],
            [-19.28998205475192, 5.329993775834812],
            [-19.299168534385483, 5.329194772139424],
            [-19.30618687326947, 5.324425763155359],
            [-19.318965241971895, 5.330027849202952],
            [-19.32399083678141, 5.334656633920005],
            [-19.331693409906915, 5.33524813024977],
            [-19.33553678363156, 5.337843609231465],
            [-19.341716359496136, 5.337263763488389],
            [-19.3465694653375, 5.334664322287852],
            [-19.352504476477645, 5.33333077025163],
            [-19.35514635424876, 5.329503723396037],
            [-19.36105395255225, 5.3266709237343735],
            [-19.367987143374155, 5.328137641781979],
            [-19.37333940385231, 5.321352736402822],
            [-19.378350912912655, 5.321310783560079],
            [-19.383880138824708, 5.326912469323288],
            [-19.38727104614829, 5.33259374594293],
            [-19.39106482360813, 5.330784941447933],
            [-19.39560304513669, 5.330774279537914],
            [-19.39721787273889, 5.328932346759796],
            [-19.397434820869947, 5.323299051969427],
            [-19.39481880140457, 5.315296028692255],
            [-19.398415418065273, 5.310353849877413],
            [-19.397314784827536, 5.299401665517377],
            [-19.399307832792477, 5.295723307318562],
            [-19.40337472607158, 5.295533838445126],
            [-19.410097588249226, 5.286861425475999],
            [-19.41082346698835, 5.275034066554732],
            [-19.41801218522199, 5.270788232398285],
            [-19.423834116027784, 5.266348700367201],
            [-19.426113067039516, 5.260407500546088],
            [-19.423168598509804, 5.257462853638097],
            [-19.425260803049678, 5.250270849692005],
            [-19.428289649364316, 5.244724939833013],
            [-19.427693045042695, 5.236069942254599],
            [-19.426154727007017, 5.233294177814764],
            [-19.416234618731526, 5.223329313850802],
            [-19.413216635692287, 5.219344498517591],
            [-19.407513398776416, 5.219027751595313],
            [-19.399228859303815, 5.217250934464786],
            [-19.399972776634932, 5.211101101006207],
            [-19.39813885156987, 5.20264162718348],
            [-19.39929073483357, 5.199216987040718],
            [-19.397262661743856, 5.1948174069370445],
            [-19.396695158988855, 5.188878207179003],
            [-19.39777039594343, 5.184656296325139],
            [-19.396955104387672, 5.179558206436336],
            [-19.392629605962373, 5.170609284837145],
            [-19.39678666660624, 5.167577890265761],
            [-19.399710195116487, 5.157460369851505],
            [-19.40440305099611, 5.15296837335061],
            [-19.40959899965836, 5.154045178880171],
            [-19.413051582204503, 5.148588456443819],
            [-19.413443328322938, 5.144150194013284],
            [-19.417031912108587, 5.140875887490322],
            [-19.421687922329138, 5.143982871763861],
            [-19.43001164138269, 5.143010974659957],
            [-19.4340406459597, 5.144038553888609],
            [-19.436789436566762, 5.147848626742027],
            [-19.438319693137913, 5.160023691989147],
            [-19.445799917836716, 5.168038358913076],
            [-19.448999743498533, 5.168595241450003],
            [-19.456281824047284, 5.173525596390927],
            [-19.463718168866247, 5.173713818601466],
            [-19.468828350203054, 5.176136722107941],
            [-19.47407011868203, 5.175962084378623],
            [-19.477391034743267, 5.173602279456832],
            [-19.49103951382668, 5.172959880825057],
            [-19.494619600216264, 5.175209372610208],
            [-19.50008557006895, 5.175661534299703],
            [-19.502115429558106, 5.186606386621189],
            [-19.500305110901582, 5.191576010328729],
            [-19.50177336262705, 5.1976669363984795],
            [-19.49818566598253, 5.205470687460822],
            [-19.500572923816467, 5.2135669727076746],
            [-19.50116032485461, 5.220486082418178],
            [-19.504083137698522, 5.221877685450472],
            [-19.50607713405971, 5.227402177414711],
            [-19.513676744615815, 5.232569289215164],
            [-19.515823774348405, 5.236103985227589],
            [-19.518910549439987, 5.236803499833147],
            [-19.522398139068933, 5.240076717469144],
            [-19.52669158301515, 5.240955041378599],
            [-19.528171243534022, 5.245671394910772],
            [-19.531918303477713, 5.249108903706919],
            [-19.53173262121837, 5.259470374255406],
            [-19.53824781112368, 5.261762309292098],
            [-19.547768102979084, 5.267489274553912],
            [-19.55363797732275, 5.269761712430203],
            [-19.559143338242336, 5.2706065485682245],
            [-19.56387859210321, 5.26828514273733],
            [-19.57108861969491, 5.273770213175354],
            [-19.58030965443225, 5.27481678949984],
            [-19.59128739513781, 5.2789064566398585],
            [-19.600088402306177, 5.275598383366734],
            [-19.603374152707232, 5.27959952608188],
            [-19.609872141944322, 5.279776604703602],
            [-19.614685450321982, 5.284443036296783],
            [-19.619143129109606, 5.284730170794263],
            [-19.625004350865183, 5.287091511499693],
            [-19.628488358663308, 5.290441784683414],
            [-19.62822374013361, 5.295563863900762],
            [-19.630967560881647, 5.30388533824145],
            [-19.633078160075243, 5.306400556017892],
            [-19.633870915973162, 5.314416227786257],
            [-19.63214963376625, 5.320608104773284],
            [-19.632548831496496, 5.323718693137983],
            [-19.635886022615193, 5.3289618841625614],
            [-19.637149147915547, 5.335917322081693],
            [-19.635882881332208, 5.339611376887295],
            [-19.64327343474583, 5.342371520345041],
            [-19.642312267535203, 5.345334619305276],
            [-19.64633520781745, 5.3612706498394385],
            [-19.651459078424914, 5.366062987698494],
            [-19.65667343239781, 5.367003549658756],
            [-19.66099039207624, 5.3651819727411745],
            [-19.667488796097512, 5.368433444374158],
            [-19.667936353175133, 5.37915471554091],
            [-19.66995404151794, 5.382878480442112],
            [-19.675274186728643, 5.385659608521017],
            [-19.679160962809902, 5.392664272836054],
            [-19.68159473191901, 5.395100189273075],
            [-19.686921297343513, 5.395046652127038],
            [-19.69587955266274, 5.392224772639208],
            [-19.698908360074576, 5.38857171445247],
            [-19.704980468139677, 5.3896813650916675],
            [-19.70518822003671, 5.396493746184153],
            [-19.710397727071115, 5.4016625901102575],
            [-19.710152653993962, 5.406126252287062],
            [-19.708232268174893, 5.410976814292045],
            [-19.710385165512744, 5.415135935502458],
            [-19.714635141564763, 5.41685548194108],
            [-19.71616974152788, 5.42298046066319],
            [-19.717378990590298, 5.425233429317363],
            [-19.7175789371158, 5.441253602014981],
            [-19.72053626690086, 5.4433887286678555],
            [-19.723578445945858, 5.450648255196013],
            [-19.72359021956623, 5.456220883461141],
            [-19.72594492881215, 5.460850877048048],
            [-19.72551183861678, 5.465522551206443],
            [-19.722591492922426, 5.469196170031491],
            [-19.723775125086405, 5.474049404438706],
            [-19.731934578869872, 5.481341356500601],
            [-19.733505122305754, 5.487699544621149],
            [-19.7292035307777, 5.492028621111434],
            [-19.72089218781877, 5.497160911697952],
            [-19.717349133930142, 5.507143844951934],
            [-19.717144658440397, 5.515700967835647],
            [-19.715506484901944, 5.519866013256455],
            [-19.716151342325652, 5.523566243336571],
            [-19.722234298713435, 5.528969127310282],
            [-19.724962601959312, 5.532703926743357],
            [-19.72493491074815, 5.536942234044188],
            [-19.72117093701353, 5.538249625510157],
            [-19.717524664884635, 5.541533542463961],
            [-19.71638582617874, 5.549014147751922],
            [-19.717985777849577, 5.552644149135403],
            [-19.71546333057837, 5.559156342821182],
            [-19.716060349349306, 5.567173218363248],
            [-19.72130969121719, 5.572564591856618],
            [-19.721232590110798, 5.577900502821383],
            [-19.723208106852162, 5.579776811323369],
            [-19.72269760665695, 5.5865040835767985],
            [-19.72017090048113, 5.592493072060816],
            [-19.71935625098477, 5.605742324027509],
            [-19.716279887343052, 5.60747202812025],
            [-19.714226744791628, 5.611871951134459],
            [-19.70973841917976, 5.616021964044887],
            [-19.713139741473597, 5.623214705385801],
            [-19.715278269525076, 5.624716460846372],
            [-19.717377093332537, 5.630294259246845],
            [-19.723486080931686, 5.633613820250592],
            [-19.723530782820596, 5.636915285953056],
            [-19.72659253207581, 5.6381280085564125],
            [-19.80982916280241, 5.662361483521562],
            [-19.815146725507454, 5.664267814939741],
            [-19.838762897695126, 5.670985653365794],
            [-19.837212092428313, 5.673592156947151],
            [-19.833081621834395, 5.675382708041941],
            [-19.831120114717045, 5.682545669444908],
            [-19.824128505504373, 5.682884004925121],
            [-19.819472639727355, 5.684185579342538],
            [-19.818310555796206, 5.68827617081906],
            [-19.815448308036142, 5.690501520472239],
            [-19.815263297073496, 5.699126964473583],
            [-19.818435634029058, 5.705478927082641],
            [-19.808658872690664, 5.710180477951099],
            [-19.80520723366756, 5.709374630532059],
            [-19.79609901601869, 5.711192718488849],
            [-19.790381467196756, 5.720309126322066],
            [-19.784535725852738, 5.724833216147482],
            [-19.785891945727535, 5.729430691543549],
            [-19.780346117669684, 5.736792401364283],
            [-19.78666804093735, 5.7411162238388735],
            [-19.78928744092114, 5.746539780404206],
            [-19.79087568085582, 5.753181495947079],
            [-19.78934654280379, 5.755747938024746],
            [-19.79167623324803, 5.760801792862777],
            [-19.78971425654504, 5.764518250959797],
            [-19.78878288019516, 5.770996841361523],
            [-19.78959946923073, 5.776120289390705],
            [-19.78920960569839, 5.783079167062027],
            [-19.787907956178522, 5.787297550487002],
            [-19.78988157980261, 5.789926125699067],
            [-19.789730371390615, 5.795042786470269],
            [-19.785519529959675, 5.80332276161331],
            [-19.785951287843957, 5.8089131895322526],
            [-19.78505954614008, 5.815069025072415],
            [-19.787177225630426, 5.820269947050577],
            [-19.79122092817104, 5.821173305827445],
            [-19.79353336080552, 5.823734626860408],
            [-19.80470730668017, 5.830424026556706],
            [-19.80752775819493, 5.830327406732795],
            [-19.811519954108775, 5.841820847824394],
            [-19.81131928276832, 5.845888694363348],
            [-19.806197990005373, 5.849396933614572],
            [-19.8039455839769, 5.854146133251577],
            [-19.7981943175748, 5.857641425921502],
            [-19.799752753711267, 5.8604555795251505],
            [-19.800771029802608, 5.867223490247012],
            [-19.79925436975999, 5.87138085559416],
            [-19.793789119977006, 5.871791501631041],
            [-19.79544442962521, 5.880729982680113],
            [-19.804120079355325, 5.879271438776738],
            [-19.80364715012348, 5.884126212217544],
            [-19.8091065726977, 5.88572725236021],
            [-19.816872266046925, 5.883462878535438],
            [-19.81815591041142, 5.887975805824098],
            [-19.81276508870242, 5.898180162806888],
            [-19.80875283797548, 5.899463484312657],
            [-19.80670428536067, 5.905236387469604],
            [-19.80150128345291, 5.909883447649977],
            [-19.792591202015636, 5.914854904295889],
            [-19.79102192698957, 5.920274566428561],
            [-19.783270856618184, 5.918839332371198],
            [-19.779487363351677, 5.916932649265654],
            [-19.778233706753475, 5.919761569492854],
            [-19.779885998394747, 5.927528051943797],
            [-19.779740397256273, 5.936645819192344],
            [-19.77571330930891, 5.952925366297727],
            [-19.772306492334984, 5.956570193239673],
            [-19.76096066613154, 5.963636564948479],
            [-19.753320998714592, 5.969531897503831],
            [-19.749774353672812, 5.970336102043075],
            [-19.753239501160643, 5.9775142765130616],
            [-19.750502193417585, 5.984163189590811],
            [-19.74624863368151, 5.985870657337667],
            [-19.74194989232311, 5.98953967827941],
            [-19.73993668964506, 5.995366481368763],
            [-19.739696642573417, 6.001350073891985],
            [-19.742455368468082, 6.008538777410185],
            [-19.745675272947274, 6.0117848109851995],
            [-19.747711758237912, 6.01687064824938],
            [-19.74572561088808, 6.024360710540402],
            [-19.746351097229613, 6.031244324589983],
            [-19.743730755238893, 6.0392007745074405],
            [-19.74234823951287, 6.047786459178452],
            [-19.742482571010658, 6.059949226914339],
            [-19.738524146412534, 6.062226590740454],
            [-19.732653383856217, 6.061028812849282],
            [-19.731527641315186, 6.065330408977411],
            [-19.727134594600695, 6.070778029449762],
            [-19.73140724599958, 6.077155860620885],
            [-19.73461260106949, 6.077178554636667],
            [-19.73728068265782, 6.081342564561501],
            [-19.736798881611936, 6.094255484574702],
            [-19.741752593234125, 6.100024916815454],
            [-19.739130372883462, 6.106312060601143],
            [-19.739386314064795, 6.1095026670677886],
            [-19.731894396410986, 6.1121306624791485],
            [-19.72245930123087, 6.112453551584827],
            [-19.71435616418926, 6.108256870874472],
            [-19.7119898977944, 6.117540669272348],
            [-19.703553715852532, 6.1227983013888485],
            [-19.701723265939982, 6.126493868766056],
            [-19.693175126545626, 6.127063068773798],
            [-19.692546571407302, 6.133237766429509],
            [-19.689552555992123, 6.137839333383405],
            [-19.68979252246095, 6.1401250604516555],
            [-19.68541155274844, 6.142445479445233],
            [-19.68870515568572, 6.146087633225115],
            [-19.682905452143245, 6.1487237330870546],
            [-19.678412361254587, 6.154335229224538],
            [-19.674419904478842, 6.150822312046693],
            [-19.666238807812523, 6.1493431378710754],
            [-19.665362509089963, 6.1452221210571265],
            [-19.66091489171714, 6.139872059537086],
            [-19.655009330037483, 6.138363394679537],
            [-19.652416159114672, 6.144882587591616],
            [-19.64540342468996, 6.14915192216187],
            [-19.64432776649962, 6.155240633433908],
            [-19.638660497274632, 6.1587684632288076],
            [-19.620206849612398, 6.151043953718685],
            [-19.614990422183435, 6.15267025497602],
            [-19.612296359795945, 6.1566888804641176],
            [-19.60875829804451, 6.159124714865702],
            [-19.60823403235349, 6.163248657945372],
            [-19.604631899082555, 6.174546991827324],
            [-19.599764740965096, 6.176526967298076],
            [-19.59746085102081, 6.181180427839775],
            [-19.594479608980777, 6.182106363585087],
            [-19.588009478910696, 6.189943665181028],
            [-19.582443398855368, 6.194214278551992],
            [-19.57990534323288, 6.204159183988031],
            [-19.581039566700888, 6.208355915826069],
            [-19.57876166220625, 6.212923667727585],
            [-19.57783871205952, 6.221305139369173],
            [-19.579341099687007, 6.224348786378417],
            [-19.572868239797106, 6.228742854838249],
            [-19.57008201531209, 6.228263084141558],
            [-19.561462354751473, 6.229784071678983],
            [-19.558479699009368, 6.234744775201222]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -122.5403627202114, "lat": 41.59269825992068 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06093"],
        "coty_name": ["Siskiyou"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Siskiyou County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00277311"
      },
      "bbox": [
        -19.838762897695126, 5.0260654670810245, -18.090634080424675,
        6.234744775201222
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.436395434798682, 1.2015603032018194],
            [-6.429957743145962, 1.2010493651164966],
            [-6.321088838636116, 1.1905257193993628],
            [-6.290926050451204, 1.187759638549222],
            [-6.198495807372839, 1.1790392990195755],
            [-6.140938365469188, 1.173779517404745],
            [-6.149674503253237, 1.0877219399747615],
            [-6.156988227958806, 1.0156732724486957],
            [-6.161499854392744, 0.9690415293757603],
            [-6.168348948301612, 0.8960164398564049],
            [-6.1751015384789065, 0.8229788011862602],
            [-6.182800465710187, 0.7353008335780992],
            [-6.205764795485295, 0.73741024759475],
            [-6.311391767545959, 0.7474054223114657],
            [-6.360671243360861, 0.752231695217076],
            [-6.466588945702061, 0.7620516701252603],
            [-6.565409603112756, 0.7713366161943087],
            [-6.692964864782494, 0.7836862505525305],
            [-6.687246994593212, 0.7893193094918818],
            [-6.685281212600235, 0.7998742451674844],
            [-6.680792516225629, 0.7990371713069117],
            [-6.6796463993640325, 0.8081491223073876],
            [-6.674722233123076, 0.816412946347416],
            [-6.670421980003523, 0.8167634652749979],
            [-6.666812865381728, 0.8201987083243811],
            [-6.665776333932935, 0.8246736556838323],
            [-6.655876669619973, 0.8307146999515878],
            [-6.656789978355409, 0.8356019482088782],
            [-6.654445657264389, 0.8375448109102341],
            [-6.652645237840301, 0.845760755186299],
            [-6.650458433007485, 0.8509882168092769],
            [-6.646180521245908, 0.8534579374967136],
            [-6.644672885977405, 0.8577884171760085],
            [-6.639283409125779, 0.8594954447078252],
            [-6.63459097664193, 0.8576023614893329],
            [-6.631663968989739, 0.8602576524386785],
            [-6.631738396521086, 0.8661304300014254],
            [-6.63355283427378, 0.8708527113700677],
            [-6.63164651574368, 0.8727963161860619],
            [-6.6328326086268525, 0.878533292693862],
            [-6.627526115927584, 0.8828181950184522],
            [-6.6228650509479, 0.8926554908949621],
            [-6.619251428355301, 0.8889861789286111],
            [-6.616076405559418, 0.8909381274436706],
            [-6.609985036624931, 0.8919730093804589],
            [-6.6084371209490556, 0.8944662202604555],
            [-6.6109396416517034, 0.8983633525796492],
            [-6.594262428436736, 0.9075963740076639],
            [-6.594858003693744, 0.9171146572604869],
            [-6.593181756735556, 0.9211026382645153],
            [-6.587841276262705, 0.927044633635889],
            [-6.588373741909195, 0.9306632311433448],
            [-6.582373678415599, 0.9373790504276666],
            [-6.583378192669701, 0.9440818405701811],
            [-6.578456733050607, 0.9446940011955358],
            [-6.57397539848051, 0.9536651227730418],
            [-6.566940153427768, 0.9619475289359305],
            [-6.563947887360193, 0.9727173616311243],
            [-6.560757864238938, 0.975535693436408],
            [-6.561644288091843, 0.9797956431004532],
            [-6.557142748288677, 0.9847301562190024],
            [-6.555115724035577, 0.9934507184793181],
            [-6.550667774974971, 0.9969455925446986],
            [-6.55004492082, 1.0007083718761167],
            [-6.547082248923427, 1.0022439758191528],
            [-6.545612800381588, 1.0060982596506798],
            [-6.547057962944821, 1.012464416286427],
            [-6.545220486545139, 1.015432258376727],
            [-6.549178783532095, 1.021414923693974],
            [-6.548383833906078, 1.0294737444846753],
            [-6.54227898068975, 1.0343923584411843],
            [-6.543344970288, 1.039129637384802],
            [-6.542614259508443, 1.0431201703139654],
            [-6.545035266731699, 1.0505550868934455],
            [-6.541364499332711, 1.0518791564894079],
            [-6.535669699909193, 1.057223011839866],
            [-6.5327036898220445, 1.0564080799224849],
            [-6.5240962823263295, 1.0606591425587408],
            [-6.518267919024473, 1.064412459353417],
            [-6.509976078122733, 1.0724217652153785],
            [-6.5059565343389885, 1.0746263935722877],
            [-6.507423748220903, 1.080723685277966],
            [-6.5044529390369705, 1.0881883357384172],
            [-6.504499314704703, 1.0954466027260565],
            [-6.510490034032118, 1.10316186268822],
            [-6.50967437986181, 1.1090483172990266],
            [-6.511198242593914, 1.1121123095125742],
            [-6.507389060496126, 1.1146805891863059],
            [-6.5055389977684674, 1.11826204276802],
            [-6.499527841203615, 1.1218059018092392],
            [-6.496581453345918, 1.1255151977552564],
            [-6.49146146290712, 1.1231582157392634],
            [-6.482167653587529, 1.124131951102976],
            [-6.476196132525634, 1.1274988606252845],
            [-6.4716615670488356, 1.132785325483158],
            [-6.469439209969749, 1.144396041161119],
            [-6.464201782050505, 1.148867153234166],
            [-6.463276005789052, 1.1548666555907359],
            [-6.464367250716433, 1.1607105853431132],
            [-6.4607665900340905, 1.1689508870890652],
            [-6.461274503721408, 1.1741518360640175],
            [-6.4577830504973655, 1.181484042810221],
            [-6.45157479336989, 1.1872069676769659],
            [-6.44322987651631, 1.198378995191031],
            [-6.438663572607412, 1.1989068720729437],
            [-6.436395434798682, 1.2015603032018194]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.92930022329398,
          "lat": 39.32976502983073
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08035"],
        "coty_name": ["Douglas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Douglas County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00198133"
      },
      "bbox": [
        -6.692964864782494, 0.7353008335780992, -6.140938365469188,
        1.2015603032018194
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.140938365469188, 1.173779517404745],
            [-6.098865658078727, 1.1699494609626808],
            [-6.043326651285662, 1.163681601747592],
            [-5.964141525178453, 1.15550828583074],
            [-5.914235877010092, 1.1518040564049752],
            [-5.77136168518484, 1.1403307613207738],
            [-5.64966166888061, 1.1306734431272396],
            [-5.62241149582219, 1.128741380832241],
            [-5.42126703259828, 1.11207151401302],
            [-5.4326489222334375, 0.9786749004441018],
            [-5.437612007585445, 0.9196401365531538],
            [-5.437394798262025, 0.9185044403070661],
            [-5.442807474219664, 0.8541320117853933],
            [-5.443716169497194, 0.8465646865282743],
            [-5.445091477582679, 0.8244807786542416],
            [-5.453399771022473, 0.7224559499011595],
            [-5.453621233572551, 0.72158975577557],
            [-5.457812146784045, 0.6713861550467545],
            [-5.462323977692183, 0.6718151148495982],
            [-5.464494902510277, 0.6420459405897672],
            [-5.466463077002417, 0.6278959752497505],
            [-5.46934608189583, 0.5830408817821067],
            [-5.4720037742383605, 0.5517641599795794],
            [-5.473297190352711, 0.5400139677891324],
            [-5.479984168664606, 0.44526632074264877],
            [-5.4817457493394075, 0.41680472485563363],
            [-5.482603836537799, 0.4086013685268786],
            [-5.569644045303661, 0.4158601597541124],
            [-5.5926068717013795, 0.4179388112048236],
            [-5.683563578498826, 0.4271881338701692],
            [-5.740533664694721, 0.43212331377291124],
            [-5.7314089121485825, 0.5176310226008967],
            [-5.728920175831238, 0.548187035564426],
            [-5.715341664432727, 0.6926852008998524],
            [-5.771478568514725, 0.6982356273817134],
            [-5.803708315034249, 0.70064384093734],
            [-5.899631244642303, 0.7091745730778234],
            [-5.942369350314408, 0.7130478709704795],
            [-6.033027982594478, 0.7218945712820226],
            [-6.098089000549818, 0.7275055739200875],
            [-6.182800465710187, 0.7353008335780992],
            [-6.1751015384789065, 0.8229788011862602],
            [-6.168348948301612, 0.8960164398564049],
            [-6.161499854392744, 0.9690415293757603],
            [-6.156988227958806, 1.0156732724486957],
            [-6.149674503253237, 1.0877219399747615],
            [-6.140938365469188, 1.173779517404745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.13574023713325,
          "lat": 39.28652802779678
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08039"],
        "coty_name": ["Elbert"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elbert County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00198136"
      },
      "bbox": [
        -6.182800465710187, 0.4086013685268786, -5.42126703259828,
        1.173779517404745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.159133676305263, 4.824774028057495],
            [17.167228047649285, 4.827641027167449],
            [17.205577321062197, 4.84322760515754],
            [17.195494223106916, 4.866411187125044],
            [17.187075763278706, 4.890896092513539],
            [17.172957651646946, 4.929413318827547],
            [17.182607799847837, 4.933135989135945],
            [17.162533523880224, 4.99036602097103],
            [17.183086017225428, 4.996765431802003],
            [17.20932772308274, 5.005427868867977],
            [17.226759670904386, 5.010711055599982],
            [17.246700357102185, 5.018781050629617],
            [17.25118390358097, 5.023248722946363],
            [17.272588372640996, 5.046185046106957],
            [17.282204791523316, 5.055346288038434],
            [17.29133187370864, 5.065666774175714],
            [17.30052922023755, 5.069024553906382],
            [17.33953581479486, 5.085050715347264],
            [17.340282303883715, 5.083270287958076],
            [17.35900271565558, 5.091101134902328],
            [17.375342829318853, 5.097175697383674],
            [17.37864632514684, 5.09926659839055],
            [17.405203681475534, 5.109272241961521],
            [17.409818414698417, 5.111445698449542],
            [17.414321336603564, 5.101419696723722],
            [17.41881714939708, 5.089272072231846],
            [17.421832625042047, 5.082736847557577],
            [17.432899792687248, 5.054929277249082],
            [17.438404209300465, 5.042293103659672],
            [17.410198630128136, 5.031216217285042],
            [17.412661772148947, 5.027323784704586],
            [17.408568680785258, 5.025884814825581],
            [17.40682938887748, 5.030345729662915],
            [17.39998120806353, 5.02747494490298],
            [17.412320379322466, 4.9927567745687025],
            [17.41551100184971, 4.94080347392442],
            [17.458832255135093, 4.958753160378289],
            [17.467118381435306, 4.955983785162559],
            [17.47144221941134, 4.952271128885574],
            [17.47400671054372, 4.947213011768416],
            [17.48521088814885, 4.947279477663197],
            [17.487750484767844, 4.941570829397504],
            [17.488022972870468, 4.9345953021851106],
            [17.484612399448253, 4.9348559770359515],
            [17.48382906683205, 4.927995709375125],
            [17.490478429920827, 4.926354771185159],
            [17.49068703323816, 4.923520015288531],
            [17.49552167761328, 4.9169142210431795],
            [17.50073463219377, 4.905958424517244],
            [17.48843450077712, 4.859900223158291],
            [17.489331540733, 4.858562832799266],
            [17.48494149147448, 4.845353055796382],
            [17.46050807026685, 4.851319621488136],
            [17.453019410639982, 4.850238922435502],
            [17.445799272106026, 4.8509394708861855],
            [17.4231061546654, 4.8490192172802855],
            [17.408533843048637, 4.848320360217896],
            [17.397197172965086, 4.846441494181358],
            [17.39713890888654, 4.8389747029465715],
            [17.38171780706641, 4.83195515535801],
            [17.384299553647203, 4.82393837713149],
            [17.388139596744868, 4.807644304646392],
            [17.38871434614721, 4.792192065014683],
            [17.37956808758632, 4.791398270040136],
            [17.380760134951487, 4.771825401392462],
            [17.381920361141876, 4.7615673425134855],
            [17.38381152797293, 4.751225678570432],
            [17.392691776146222, 4.723439010136043],
            [17.39422036971658, 4.717598669934143],
            [17.397018280750654, 4.714397643642331],
            [17.40392899862156, 4.7012893886992595],
            [17.40605099931896, 4.687202397841686],
            [17.400595761908594, 4.683182323920514],
            [17.39403630300308, 4.682359905999642],
            [17.391746858322232, 4.679747598097195],
            [17.389516960636882, 4.669803185923738],
            [17.392867978476545, 4.664313831570292],
            [17.39170765524467, 4.658131744778917],
            [17.382702715090126, 4.6479572543843295],
            [17.38151378954428, 4.637526406874079],
            [17.387004972342005, 4.621179129423205],
            [17.383422977380775, 4.622873629289516],
            [17.380962408523647, 4.62137269693576],
            [17.377472119631424, 4.6236900135291155],
            [17.373976252184992, 4.623177351680494],
            [17.370034568789073, 4.629907760524445],
            [17.36803981442682, 4.631004404885329],
            [17.345002013860515, 4.613550746611711],
            [17.34326943708842, 4.611273364215127],
            [17.333904321603665, 4.6231786333921745],
            [17.320744860243195, 4.619467508011778],
            [17.290780886456275, 4.643969798142525],
            [17.301877135873365, 4.6862135642429585],
            [17.301517266265005, 4.707132315931273],
            [17.306789802004968, 4.727860986310792],
            [17.304024797088093, 4.734114816948096],
            [17.29334820612983, 4.731715027145358],
            [17.2842358126055, 4.737883519054653],
            [17.27950830666243, 4.742505793820004],
            [17.27959276776734, 4.751833065086177],
            [17.27473115463228, 4.754783549713627],
            [17.269769433248953, 4.754711167579227],
            [17.259678428634587, 4.761710686045991],
            [17.256148468937965, 4.763152229595227],
            [17.25001561370804, 4.768172177862108],
            [17.24376155729397, 4.767930302588129],
            [17.237938954691412, 4.76221615746582],
            [17.232447838216043, 4.764692999952754],
            [17.230918727948414, 4.770762961985194],
            [17.227898564922437, 4.773980635368743],
            [17.224120030647832, 4.770866816950811],
            [17.2208940048916, 4.766029816374044],
            [17.21586934338284, 4.765511391986972],
            [17.213687850088917, 4.767608091454907],
            [17.21095168805002, 4.773671013204437],
            [17.204544473923793, 4.780450449154579],
            [17.201015604833934, 4.780616658084919],
            [17.19467238964655, 4.776678140524185],
            [17.19093445210624, 4.77271103572066],
            [17.187342971891006, 4.7734530317767545],
            [17.18395011436952, 4.779852023659162],
            [17.183628473048813, 4.788936239785502],
            [17.181429598473187, 4.793926414981558],
            [17.177251857613555, 4.79398782129953],
            [17.17387872109537, 4.79075517709629],
            [17.164390191169073, 4.796921652213787],
            [17.15875261451745, 4.802616407569808],
            [17.15853255819656, 4.80848305544563],
            [17.156364389966726, 4.811198686126658],
            [17.159133676305263, 4.824774028057495]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.08599750548112, "lat": 41.52314820626804 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09140"],
        "coty_name": ["Naugatuck Valley"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Naugatuck Valley Planning Region"],
        "coty_fp_code": "140",
        "coty_gnis_code": "02830249"
      },
      "bbox": [
        17.156364389966726, 4.611273364215127, 17.50073463219377,
        5.111445698449542
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [17.625503219481825, 4.6673626828545345],
              [17.624551978965258, 4.6790448279387],
              [17.627083368459527, 4.6818344767433295],
              [17.637344759983176, 4.6849313482766615],
              [17.637714642995636, 4.68112667523849],
              [17.632651865919463, 4.674292530049808],
              [17.625503219481825, 4.6673626828545345]
            ]
          ],
          [
            [
              [17.387004972342005, 4.621179129423205],
              [17.38151378954428, 4.637526406874079],
              [17.382702715090126, 4.6479572543843295],
              [17.39170765524467, 4.658131744778917],
              [17.392867978476545, 4.664313831570292],
              [17.389516960636882, 4.669803185923738],
              [17.391746858322232, 4.679747598097195],
              [17.39403630300308, 4.682359905999642],
              [17.400595761908594, 4.683182323920514],
              [17.40605099931896, 4.687202397841686],
              [17.40392899862156, 4.7012893886992595],
              [17.397018280750654, 4.714397643642331],
              [17.39422036971658, 4.717598669934143],
              [17.392691776146222, 4.723439010136043],
              [17.38381152797293, 4.751225678570432],
              [17.381920361141876, 4.7615673425134855],
              [17.380760134951487, 4.771825401392462],
              [17.37956808758632, 4.791398270040136],
              [17.38871434614721, 4.792192065014683],
              [17.388139596744868, 4.807644304646392],
              [17.384299553647203, 4.82393837713149],
              [17.38171780706641, 4.83195515535801],
              [17.39713890888654, 4.8389747029465715],
              [17.397197172965086, 4.846441494181358],
              [17.408533843048637, 4.848320360217896],
              [17.4231061546654, 4.8490192172802855],
              [17.445799272106026, 4.8509394708861855],
              [17.453019410639982, 4.850238922435502],
              [17.46050807026685, 4.851319621488136],
              [17.48494149147448, 4.845353055796382],
              [17.489331540733, 4.858562832799266],
              [17.48843450077712, 4.859900223158291],
              [17.50073463219377, 4.905958424517244],
              [17.49552167761328, 4.9169142210431795],
              [17.49068703323816, 4.923520015288531],
              [17.490478429920827, 4.926354771185159],
              [17.48382906683205, 4.927995709375125],
              [17.484612399448253, 4.9348559770359515],
              [17.488022972870468, 4.9345953021851106],
              [17.487750484767844, 4.941570829397504],
              [17.48521088814885, 4.947279477663197],
              [17.492011996451897, 4.947218194263117],
              [17.48344699554781, 4.968480699999708],
              [17.497611136217923, 4.975785687776295],
              [17.500610936802655, 4.969596987001969],
              [17.50236790347072, 4.961341463168689],
              [17.507798452901003, 4.961033360641541],
              [17.51482152044048, 4.975499988246617],
              [17.516120478187016, 4.982546785837481],
              [17.53898288224579, 4.992584089796889],
              [17.550048064281505, 4.996970231409524],
              [17.566335526335067, 4.947623940295319],
              [17.579806038581463, 4.905259688635641],
              [17.58606659126445, 4.909150286532798],
              [17.587902007232532, 4.897089243855625],
              [17.593787263736164, 4.86234997579918],
              [17.592381647932477, 4.846477272596479],
              [17.63563128828911, 4.868099094752329],
              [17.638459888628585, 4.868826556451238],
              [17.655486936895954, 4.8775579834019345],
              [17.660047173902747, 4.875615205403088],
              [17.662123287344592, 4.87199793116341],
              [17.66581326674425, 4.871025420070382],
              [17.66244725508252, 4.8596198696752975],
              [17.670152743601115, 4.8559720847330725],
              [17.67721989059311, 4.856267506658697],
              [17.67828889522311, 4.852193379572368],
              [17.682326533524083, 4.8460690145360195],
              [17.68893552892668, 4.839813288254437],
              [17.692622258731255, 4.838728885046794],
              [17.698068891619688, 4.834420422285936],
              [17.69818291989398, 4.828858209974259],
              [17.70369735488836, 4.822713133119859],
              [17.705708779531918, 4.816890381710745],
              [17.703908583382464, 4.811541535204511],
              [17.70653255749937, 4.799299998267679],
              [17.70941883614286, 4.792787584550987],
              [17.70864271061694, 4.786140316364239],
              [17.7103687136081, 4.779285478306971],
              [17.721231752493313, 4.7777048358902405],
              [17.724353735814084, 4.78078702094038],
              [17.72846638920809, 4.77637246523378],
              [17.732779157984442, 4.777658118961227],
              [17.734175587422786, 4.773494254641971],
              [17.7320715826436, 4.769357445510839],
              [17.734671168983006, 4.767733244462841],
              [17.736742898229434, 4.762464478859358],
              [17.739217673407527, 4.762088256238534],
              [17.74980747946924, 4.756060830523107],
              [17.75109119316732, 4.752669217131739],
              [17.754855360283813, 4.751514591136714],
              [17.765418100300376, 4.741956493036861],
              [17.769545564297037, 4.744284199474546],
              [17.77125178100135, 4.740112875896194],
              [17.774847344822394, 4.73716379780647],
              [17.773414488308998, 4.734631645115827],
              [17.774757959678094, 4.727430063518554],
              [17.77706218012855, 4.723844842936792],
              [17.785290023119803, 4.7202201093554],
              [17.785943965877745, 4.716329171979589],
              [17.781289870654724, 4.712888406704239],
              [17.756849898089275, 4.726847682317996],
              [17.74714286873981, 4.728143378857263],
              [17.73725039899868, 4.722557207513899],
              [17.732370464954595, 4.72348240085256],
              [17.72255477486058, 4.722296194852796],
              [17.706207263310798, 4.7130284465834515],
              [17.69448074972307, 4.708042117313874],
              [17.69173468388224, 4.711001874569908],
              [17.687985948025172, 4.711728963577068],
              [17.686742463097694, 4.707037512701879],
              [17.683142982063284, 4.707910906797633],
              [17.679994782985993, 4.700787833377902],
              [17.682659093625368, 4.698102378794892],
              [17.683208508755506, 4.694615630477263],
              [17.67691632574881, 4.696422759489538],
              [17.67822554793152, 4.689778290463457],
              [17.675806296931672, 4.684410592917461],
              [17.67311402474732, 4.681950439759993],
              [17.66945790477333, 4.683231179609425],
              [17.665142480188425, 4.678803877347308],
              [17.6587920213306, 4.682348522981912],
              [17.664738819484125, 4.691198249649248],
              [17.661468963378198, 4.694517280141284],
              [17.654162306227267, 4.688503188141549],
              [17.65460144111708, 4.69431249073136],
              [17.652344927786935, 4.695353326846429],
              [17.649411294338098, 4.690840583599828],
              [17.64486795184636, 4.688721109060591],
              [17.64335501081349, 4.6850482018817905],
              [17.63948489074085, 4.6863846543409755],
              [17.639839268205236, 4.690288833840812],
              [17.63604702377501, 4.690625799186235],
              [17.629900668397678, 4.686099529328757],
              [17.626518323278457, 4.691739231145852],
              [17.62035865080086, 4.690633831084126],
              [17.618860689743272, 4.691963637145929],
              [17.611458317393573, 4.686190865080149],
              [17.606798150442955, 4.68677132054609],
              [17.601371126339963, 4.684383600514058],
              [17.59976351974216, 4.679102428976079],
              [17.595749565264757, 4.678450534284745],
              [17.589547495834758, 4.672416471218158],
              [17.587533843111817, 4.666078318141181],
              [17.58379792925249, 4.664215519871894],
              [17.58247887927082, 4.666789415276338],
              [17.57718544752014, 4.669565169894595],
              [17.578530784285913, 4.67311868482018],
              [17.57209208965542, 4.677505187560219],
              [17.570894731929073, 4.672092922167077],
              [17.57100455290815, 4.662345755847676],
              [17.565630074872974, 4.663640401991178],
              [17.563273549521043, 4.669199907541333],
              [17.558233818482964, 4.66409191791286],
              [17.559073371903306, 4.659457877311373],
              [17.552544618161424, 4.652854296339903],
              [17.546096759872395, 4.6507500483454285],
              [17.53839979607634, 4.64654137402289],
              [17.53184342230495, 4.646536004557654],
              [17.52907861898045, 4.643638206544801],
              [17.526859327724324, 4.645994373697659],
              [17.5212962391898, 4.647580140089734],
              [17.520654413069078, 4.652329204631661],
              [17.525615079902845, 4.657285896954478],
              [17.52538988286909, 4.660725946458528],
              [17.521325764115346, 4.665786276534719],
              [17.514453494302256, 4.6691300983754696],
              [17.514449359936876, 4.6761262824343],
              [17.51080861849207, 4.68120637761255],
              [17.50844909070722, 4.689958568012436],
              [17.506614459207903, 4.693664096030638],
              [17.502530098052954, 4.693210022401661],
              [17.497964111242457, 4.684412126272707],
              [17.497398611082318, 4.6803312074427605],
              [17.49437849364787, 4.674824719882809],
              [17.48801293392324, 4.674306635853877],
              [17.491391140117244, 4.6659461664813415],
              [17.495673829951944, 4.662997364304406],
              [17.497812695963777, 4.656783948476677],
              [17.494739701494325, 4.653147192226305],
              [17.483542250939394, 4.645762017962528],
              [17.481327064072886, 4.642122264525814],
              [17.477935921823796, 4.6407751506561095],
              [17.477860851868062, 4.6366797512565725],
              [17.474922651585562, 4.631739143315029],
              [17.474284410754425, 4.624589354550255],
              [17.47064934257042, 4.619699893071013],
              [17.464784876115818, 4.620917908678804],
              [17.463047349084363, 4.607906715495287],
              [17.45567219551265, 4.605084906005588],
              [17.454886092743223, 4.603492231786813],
              [17.45448696812283, 4.5917452474912865],
              [17.451327578174684, 4.585370007295615],
              [17.447321205165295, 4.5839503511746384],
              [17.444294667264593, 4.586620819450323],
              [17.436261859297453, 4.583055250916059],
              [17.435082620537507, 4.578354642854438],
              [17.428389134846118, 4.584342416230592],
              [17.424473609483954, 4.585028657572585],
              [17.420630415799042, 4.582373604285863],
              [17.41753716825706, 4.578143528121238],
              [17.415606882868502, 4.570048017367222],
              [17.410710047096863, 4.568041811458972],
              [17.40525059895675, 4.561875567283051],
              [17.40166241394441, 4.555237093778812],
              [17.39575725652862, 4.53974312835398],
              [17.392253049327415, 4.5336347755529705],
              [17.381994621262542, 4.538310895673352],
              [17.378379028215015, 4.544876711476409],
              [17.378265642003804, 4.55064376786934],
              [17.380978413436097, 4.5564815962845655],
              [17.38285140584498, 4.567908728070536],
              [17.380947081841228, 4.571271129168187],
              [17.379746464161368, 4.577391612078344],
              [17.380089359164394, 4.581924941409805],
              [17.37688455650944, 4.588383400976091],
              [17.376261020047203, 4.592473057029866],
              [17.379760697362823, 4.6043930113881775],
              [17.385742338349907, 4.612400701761101],
              [17.387004972342005, 4.621179129423205]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.84448447498929,
          "lat": 41.361346066510144
        },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09170"],
        "coty_name": ["South Central Connecticut"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["South Central Connecticut Planning Region"],
        "coty_fp_code": "170",
        "coty_gnis_code": "02830252"
      },
      "bbox": [
        17.376261020047203, 4.5336347755529705, 17.785943965877745,
        4.996970231409524
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.449099529025638, -7.585960046665611],
            [12.476484698631005, -7.549132568354719],
            [12.517255293407977, -7.492043155299365],
            [12.53125428427942, -7.47291817829802],
            [12.580950135643258, -7.402994996065739],
            [12.606159680498607, -7.367904880186887],
            [12.622058961036716, -7.348361942610148],
            [12.627007857732622, -7.33745331783879],
            [12.631367779483666, -7.325997424120657],
            [12.634584603520912, -7.325389265629916],
            [12.642979134432519, -7.326343067588919],
            [12.654553605700606, -7.309216067718165],
            [12.653454151835472, -7.293030712876448],
            [12.660482285911968, -7.295764375036388],
            [12.668365801078481, -7.294915985085873],
            [12.675026386602656, -7.290144347013122],
            [12.6758838666903, -7.285938948131505],
            [12.674225633089044, -7.28216507634829],
            [12.675841270857166, -7.279678683072861],
            [12.673283851293592, -7.275034155316739],
            [12.67574362079175, -7.270966174100303],
            [12.6740924101436, -7.265692882079445],
            [12.679336411814392, -7.2586548689626795],
            [12.68307988667307, -7.256013495359755],
            [12.683151460234974, -7.252359681005963],
            [12.688631361708767, -7.251238030124552],
            [12.694839360946329, -7.255674923161454],
            [12.703534285415229, -7.250906515582355],
            [12.706553258380653, -7.252477645148882],
            [12.716321562991979, -7.251974910253836],
            [12.719420512929997, -7.254860944646432],
            [12.727185602476533, -7.254404190320007],
            [12.731081977144893, -7.2554742087059605],
            [12.731399029952014, -7.261317194089085],
            [12.733421323176568, -7.264141724181863],
            [12.736712654401854, -7.260743391815005],
            [12.737359195456333, -7.249877736134055],
            [12.739570498789025, -7.244779383793894],
            [12.743598030509608, -7.24238157199231],
            [12.74330310726106, -7.238684900126307],
            [12.74756708109352, -7.2379668437514955],
            [12.750217532888248, -7.233058978410832],
            [12.75459599121015, -7.234180817060768],
            [12.756208363169598, -7.230432179098394],
            [12.76401807610998, -7.2247951309882055],
            [12.768169368468541, -7.228181458270632],
            [12.774015399933454, -7.229030024125744],
            [12.77708350645138, -7.224301070359448],
            [12.78150292890207, -7.2243652394673505],
            [12.777046256375296, -7.233177855667985],
            [12.784072438367389, -7.235485551585804],
            [12.786400550529386, -7.2400823887665275],
            [12.777062974328308, -7.244995936635608],
            [12.777295981141606, -7.248828669061805],
            [12.780508473924192, -7.253706932785499],
            [12.784785698578037, -7.253666928960419],
            [12.785443098587244, -7.249358500794225],
            [12.794680732842563, -7.241180460861957],
            [12.799223676385193, -7.23912198825716],
            [12.802355849357573, -7.240858799537559],
            [12.802154495298007, -7.245390170033698],
            [12.799752963907137, -7.255355036046662],
            [12.801160205190252, -7.25894330143595],
            [12.811476814370717, -7.266079128996871],
            [12.819682511597701, -7.266242912759431],
            [12.821972228961275, -7.265006264264557],
            [12.82605063959206, -7.259333163946872],
            [12.829153596371919, -7.256867390535892],
            [12.833055255535161, -7.257784143028575],
            [12.834921038181633, -7.269031305014867],
            [12.839024281960885, -7.274062674944579],
            [12.842678856617955, -7.275568708632659],
            [12.847580400725462, -7.274597956401573],
            [12.853172314206656, -7.271557655973581],
            [12.858799665319639, -7.258117843456134],
            [12.85895379014304, -7.250170573923324],
            [12.854061374210374, -7.241201193706376],
            [12.860710484108614, -7.22912347901497],
            [12.873511070259958, -7.230736918058259],
            [12.882222450562576, -7.2386320919823595],
            [12.886633895724705, -7.250487161405948],
            [12.89481222660327, -7.258003442650999],
            [12.913260719460618, -7.263957734454098],
            [12.917276907976252, -7.266074112777002],
            [12.918275877966023, -7.274604769474334],
            [12.930895532459182, -7.287352880407794],
            [12.942270458582753, -7.297241175542839],
            [12.956930986263272, -7.297473584385282],
            [12.959247138925386, -7.298977896983191],
            [12.962180485697155, -7.313316183675848],
            [12.969901731140812, -7.339832033736524],
            [12.970991137663356, -7.345720483202269],
            [12.969054765526245, -7.35782976784683],
            [12.978624140993697, -7.37023398308269],
            [12.979314079700986, -7.374475702742689],
            [12.974116700440167, -7.376532214115388],
            [12.974194068754054, -7.379540661707149],
            [12.979509434318716, -7.382050860485966],
            [12.981453605827658, -7.384387616893037],
            [12.988191291068693, -7.381424555245047],
            [12.989412361777978, -7.3821921488507245],
            [12.988387292027259, -7.398501334978156],
            [12.990707268831528, -7.416030766372701],
            [12.996971020428672, -7.445839695006836],
            [13.004706185553182, -7.4714578020322975],
            [13.009862040616845, -7.484195402290821],
            [13.02286942819349, -7.520424318555948],
            [12.980172162179889, -7.52764985071583],
            [12.97433330553037, -7.52845158308096],
            [12.999421511105277, -7.671564997074219],
            [12.998754174535199, -7.672421237506558],
            [12.96097985235713, -7.678689654966854],
            [12.910131441181456, -7.687473032478705],
            [12.907415866109476, -7.671628057137093],
            [12.889947702719807, -7.677223156896793],
            [12.883169334462858, -7.677470371048778],
            [12.877684961051651, -7.6755070700720225],
            [12.870729540349577, -7.671012604848718],
            [12.862546995988911, -7.6725119888327695],
            [12.852699509194549, -7.669284185159044],
            [12.842859560571592, -7.668363068076169],
            [12.833042064391746, -7.669152027265342],
            [12.82866949728303, -7.671942597341324],
            [12.811958066380958, -7.684472001117995],
            [12.78663848184072, -7.6885875131612424],
            [12.773563036687005, -7.669376146295306],
            [12.772945455508774, -7.667058923238324],
            [12.772074325516071, -7.650526496826891],
            [12.77022608816842, -7.6401632648283675],
            [12.77630914058232, -7.629710974664883],
            [12.776731584325526, -7.620556343310962],
            [12.7569580357397, -7.622539532875956],
            [12.737762129265304, -7.625895978669257],
            [12.730322141190749, -7.624543969963414],
            [12.726305553372532, -7.629307128851067],
            [12.671932515953722, -7.637618832149568],
            [12.63508244621142, -7.643710194829084],
            [12.5717635118607, -7.654703189536814],
            [12.541872349939357, -7.659734673486651],
            [12.461620821697137, -7.670925478428717],
            [12.449099529025638, -7.585960046665611]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.67143630021872,
          "lat": 30.331416444598776
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12031"],
        "coty_name": ["Duval"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Duval County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00293656"
      },
      "bbox": [
        12.449099529025638, -7.6885875131612424, 13.02286942819349,
        -7.224301070359448
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.631185722338168, -10.033226808065711],
            [13.696148791491844, -10.023983246631138],
            [13.7361881772295, -10.018101980661237],
            [13.86774532225043, -9.997115275385088],
            [13.884980583685216, -9.994360164290347],
            [13.951153260611813, -9.982987223105676],
            [13.965335462519699, -10.064594522362464],
            [13.994041601997278, -10.059843689043852],
            [14.05106900543643, -10.0509096415252],
            [14.060332788968761, -10.106974671234553],
            [14.067852721222232, -10.15049890039432],
            [14.069584157507729, -10.157266002960418],
            [14.095042531035014, -10.306462268995565],
            [14.094192428706561, -10.306615135064373],
            [14.102709741975172, -10.354335125876554],
            [14.108976661646771, -10.391529569254015],
            [14.12282537807177, -10.472894081018909],
            [14.116676294226894, -10.480740409605378],
            [14.078624712945821, -10.525345103243296],
            [14.04056202797522, -10.569935016964202],
            [14.002488206825511, -10.61451009106868],
            [13.964403217046886, -10.659070265903491],
            [13.952548468733273, -10.526068804550981],
            [13.951745418202751, -10.520332696032646],
            [13.947582305868098, -10.475541050921837],
            [13.945213825214962, -10.472954399996008],
            [13.946335002003005, -10.467928599503487],
            [13.940956176278524, -10.465261433349697],
            [13.934052967878207, -10.457124838555163],
            [13.92777262541787, -10.461666165793597],
            [13.920499456842418, -10.460162822113936],
            [13.920480706255223, -10.45656639618],
            [13.915561041920638, -10.45878127928882],
            [13.910415533416286, -10.454434733595038],
            [13.909493558502417, -10.439909294645487],
            [13.899924073205163, -10.440580142798307],
            [13.895010710905714, -10.43855674545996],
            [13.890552187658562, -10.43351835069519],
            [13.886543467069618, -10.432513801424516],
            [13.884745067792501, -10.436318080878333],
            [13.88083525740881, -10.434500543624893],
            [13.879786671122972, -10.42929095212327],
            [13.876912762529154, -10.428372012317373],
            [13.873864852864145, -10.425963129426735],
            [13.873291917007641, -10.422369055763767],
            [13.870383934842813, -10.418198915315497],
            [13.8609914985804, -10.413633578565634],
            [13.860034848835475, -10.418028528969959],
            [13.854357640525846, -10.42017229791941],
            [13.848146884929337, -10.4211544675754],
            [13.842705083722914, -10.414722769974995],
            [13.836601546372915, -10.409332183504068],
            [13.83436041009022, -10.400606277238818],
            [13.834563214437598, -10.396437379583219],
            [13.829945744693896, -10.393460557711569],
            [13.824094414535546, -10.392712162277931],
            [13.818098505289496, -10.382807081649515],
            [13.817898916893219, -10.379901397808837],
            [13.814681781183156, -10.37401893938895],
            [13.813687925418149, -10.359431155979294],
            [13.81254012856535, -10.350106182486455],
            [13.807352327621143, -10.347717320252848],
            [13.805878389284342, -10.344348678478326],
            [13.799268868683559, -10.346132887893546],
            [13.798070700668053, -10.348066946532555],
            [13.787759784404555, -10.347385630548256],
            [13.783505045838357, -10.344100586334273],
            [13.782786266854375, -10.338192217330871],
            [13.780147400490218, -10.332379557122419],
            [13.777375386727613, -10.329135805465228],
            [13.779664623725221, -10.327080898443251],
            [13.77186193105223, -10.32209422219928],
            [13.768159554085413, -10.324268550214917],
            [13.763267203043513, -10.315800621149227],
            [13.763417613764556, -10.31200092923956],
            [13.766095215705139, -10.309334580061657],
            [13.764979519835093, -10.306627201534605],
            [13.770465409078323, -10.304108727584177],
            [13.773489221890683, -10.304228950362342],
            [13.774656813466517, -10.300175835320756],
            [13.769546414206928, -10.292945242237508],
            [13.764305801840742, -10.290865031145652],
            [13.754864596073405, -10.29187203132618],
            [13.755043244773633, -10.285567064695483],
            [13.75188630954885, -10.283146029241008],
            [13.746591435439885, -10.283245581545852],
            [13.74136358557169, -10.277772611341556],
            [13.736639534826189, -10.275559642360822],
            [13.727855762267765, -10.275931280395692],
            [13.724358996514, -10.27490604864743],
            [13.716755181822109, -10.277173992754282],
            [13.710757779146375, -10.28282729899965],
            [13.706937544029357, -10.27920773286966],
            [13.70353333266824, -10.279988764440949],
            [13.696530843133205, -10.279356781591067],
            [13.69153875258873, -10.274802769911124],
            [13.68884938287258, -10.275600045853398],
            [13.684788484089214, -10.272470758726236],
            [13.683375657340775, -10.262747970783499],
            [13.674207550024594, -10.259215682129032],
            [13.670177062032465, -10.256696304149484],
            [13.666841858135573, -10.256536720934527],
            [13.666346209655845, -10.235286983548736],
            [13.659515930571546, -10.225442762368885],
            [13.654840914391151, -10.225422207535127],
            [13.650927481815417, -10.2213133466433],
            [13.649572632977243, -10.21795270477735],
            [13.636155802107261, -10.2146750692356],
            [13.633357429565084, -10.212184948662529],
            [13.631535168186865, -10.205708155355913],
            [13.626142280578714, -10.200975357499653],
            [13.625813768496776, -10.198122450450171],
            [13.619444601487531, -10.193205099574355],
            [13.614615634530328, -10.195127720806214],
            [13.610831526438009, -10.192113012302714],
            [13.60525767198848, -10.192929857108375],
            [13.602781421941971, -10.190162796901964],
            [13.599557749078501, -10.190414915735671],
            [13.598896279003975, -10.18178465249327],
            [13.602055067266242, -10.178757516796969],
            [13.599665535283421, -10.176294064485472],
            [13.602211731362162, -10.169507422064772],
            [13.599567407624681, -10.164336655093555],
            [13.59628402375788, -10.165854320521833],
            [13.592899546023427, -10.16349566182607],
            [13.58906726017219, -10.157091980261548],
            [13.587829747595379, -10.151035989873831],
            [13.588680100376274, -10.147300103984206],
            [13.594200988888122, -10.141968945709946],
            [13.59108427978046, -10.138903193551885],
            [13.589887076353152, -10.134753384849796],
            [13.595204501444949, -10.135124846725956],
            [13.60263558794356, -10.12688205135646],
            [13.603438853720894, -10.12302767802639],
            [13.60887213482332, -10.12172696484784],
            [13.61453714709741, -10.118998451461163],
            [13.614638791381863, -10.114091839075133],
            [13.617357824556832, -10.110202188091469],
            [13.619120688027316, -10.104765215937952],
            [13.628308103666836, -10.101189084801197],
            [13.626729774064675, -10.093174363106883],
            [13.628753723546643, -10.08890932434291],
            [13.627665939821716, -10.085613704923295],
            [13.631852283843383, -10.081401972033706],
            [13.632396840868884, -10.078851131873375],
            [13.636891394979095, -10.077993141070996],
            [13.639173088715575, -10.073599063059843],
            [13.638024450522973, -10.06715059813986],
            [13.632996452530097, -10.058995966273905],
            [13.634191187963488, -10.057700261365198],
            [13.634599886021128, -10.04987332705381],
            [13.632434122379143, -10.045349138300319],
            [13.633286095179168, -10.04279167430542],
            [13.629997792359168, -10.03748386373935],
            [13.631185722338168, -10.033226808065711]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.88857849683096,
          "lat": 27.386411308880522
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12093"],
        "coty_name": ["Okeechobee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Okeechobee County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00295760"
      },
      "bbox": [
        13.587829747595379, -10.659070265903491, 14.12282537807177,
        -9.982987223105676
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.905700910271024, -8.469011303802425],
            [12.93694433575138, -8.455695846410086],
            [13.02157159764933, -8.419391474091007],
            [13.037184117564422, -8.411381222899214],
            [13.040438272375887, -8.411213120239927],
            [13.048702220973201, -8.40731284562488],
            [13.095771556210739, -8.386180795590573],
            [13.099828033934454, -8.383882262571323],
            [13.102813740542635, -8.3784814698802],
            [13.103305098571617, -8.372046276936468],
            [13.106634416161434, -8.367716407792926],
            [13.10726391091602, -8.364321370776839],
            [13.115462412522174, -8.364303116141548],
            [13.118505259690547, -8.361508650919978],
            [13.141071067954785, -8.488477462473835],
            [13.142637956884856, -8.496385970762182],
            [13.189212186993435, -8.488738794468746],
            [13.217915292675656, -8.483712647556878],
            [13.321443166169646, -8.465932261807145],
            [13.333103931270488, -8.463399420172406],
            [13.372339069027957, -8.456120747692259],
            [13.35697450883535, -8.37398029663718],
            [13.350957105310936, -8.342393479241094],
            [13.344792501599477, -8.315250260067735],
            [13.351305918803074, -8.313341808098754],
            [13.350038652998181, -8.308589890929253],
            [13.365929773688611, -8.301237427578986],
            [13.381573140502876, -8.29345028916786],
            [13.388729753512232, -8.292265516278569],
            [13.454922260145048, -8.401265487960712],
            [13.51796893505781, -8.49815386297412],
            [13.54944962861878, -8.546433638542453],
            [13.574113200510167, -8.579659363766579],
            [13.589615367919405, -8.596462891885551],
            [13.602115300026256, -8.60768085593366],
            [13.610461822701042, -8.613863478565397],
            [13.613510807060191, -8.620045936232463],
            [13.630087397085525, -8.644744249394979],
            [13.647143448651066, -8.667400086327614],
            [13.697305227113377, -8.72758492663764],
            [13.747477231974333, -8.787743760391919],
            [13.800070302517144, -8.852999800357933],
            [13.807725017881772, -8.86209219131881],
            [13.679624259537679, -8.882607281508093],
            [13.604246042959934, -8.895458125859344],
            [13.634729310281285, -9.066241077783205],
            [13.626657193453807, -9.069165868719278],
            [13.615290053240342, -9.070629299397217],
            [13.612244543187018, -9.066994947153109],
            [13.614726328282657, -9.065428070719921],
            [13.611369032659265, -9.05950048743595],
            [13.607879163288281, -9.063160815095847],
            [13.603465615687412, -9.05945075827539],
            [13.603155944679965, -9.055976685802944],
            [13.599204652816812, -9.054789372412918],
            [13.594388956793793, -9.050634006690345],
            [13.598749190842053, -9.045231428484575],
            [13.596022423950568, -9.038597917033846],
            [13.593071542916217, -9.035390756449347],
            [13.589859922829163, -9.02896571202228],
            [13.590021531503512, -9.024248277071289],
            [13.58598708294906, -9.020261724897953],
            [13.576125409894768, -9.015648617531005],
            [13.574480291751582, -9.007282751660439],
            [13.575027498920415, -9.00155207233952],
            [13.577210994263849, -8.996728249245976],
            [13.571775019773872, -8.989489765271344],
            [13.560356005231311, -8.984371341285241],
            [13.557818047082783, -8.980620467681353],
            [13.558153562924277, -8.974234531976537],
            [13.554809407376496, -8.973103713101205],
            [13.554283916769524, -8.967990704797145],
            [13.550427526584237, -8.967362339616718],
            [13.550377140123391, -8.964297261686111],
            [13.533452356209349, -8.951594660478243],
            [13.529716691291707, -8.947305244921548],
            [13.528317873537231, -8.93554961658855],
            [13.53299290417491, -8.923271380015562],
            [13.526907633835943, -8.907359006788216],
            [13.52437311918925, -8.903266960185752],
            [13.515936980007185, -8.896502366909072],
            [13.515960572553057, -8.889467748428139],
            [13.514410024217513, -8.886802125662948],
            [13.509138941583842, -8.88575733636256],
            [13.505904090271654, -8.881804989899724],
            [13.503103060851313, -8.884640081013787],
            [13.498483892643822, -8.8863370784394],
            [13.491329381460263, -8.878762282809094],
            [13.4882063433865, -8.881806991135834],
            [13.48181237728682, -8.880488535595743],
            [13.478756212930064, -8.876842907618492],
            [13.46820603655669, -8.880550578163056],
            [13.462105447395917, -8.886531248595912],
            [13.465926780194604, -8.893241604815127],
            [13.464994906594718, -8.89685211982282],
            [13.46073928847466, -8.901176307658082],
            [13.462882503321687, -8.908366496971231],
            [13.455324066257173, -8.911605071416789],
            [13.458300875411696, -8.915023608259016],
            [13.456715813993256, -8.917475189524135],
            [13.446987416557095, -8.918079230509344],
            [13.440574604784572, -8.919508369157434],
            [13.434055677746676, -8.922854499088244],
            [13.430269683651794, -8.92925771192333],
            [13.428288637812415, -8.927152454049894],
            [13.423120789613645, -8.928116060321571],
            [13.419094014903594, -8.918670559396606],
            [13.415570061613213, -8.918184384171541],
            [13.412708846167662, -8.921842441295357],
            [13.409669101113154, -8.920417242296487],
            [13.406995861556418, -8.924197606034234],
            [13.398554918219947, -8.92088224678871],
            [13.394246426452598, -8.916729939196028],
            [13.388940594948952, -8.915106133840583],
            [13.385360139469295, -8.909479676009322],
            [13.385470081556921, -8.905448923707526],
            [13.379832766328391, -8.900414263036467],
            [13.376795077618, -8.899641569514763],
            [13.377498873414192, -8.894263598317862],
            [13.374203938434908, -8.889191138088885],
            [13.301156403875718, -8.898360602042269],
            [13.291710679854662, -8.899848000650058],
            [13.287971785196518, -8.897335151831452],
            [13.27953152645541, -8.895862247399846],
            [13.271520279985458, -8.890449041689745],
            [13.266377626376986, -8.892069391672022],
            [13.257120021025678, -8.891909832320867],
            [13.255350709611859, -8.88968941782177],
            [13.258325880259555, -8.886196961603817],
            [13.258179354297674, -8.881572004332579],
            [13.260013298571495, -8.876977446416396],
            [13.249797843900957, -8.876132626219633],
            [13.24844078623142, -8.873641044477134],
            [13.251053713516232, -8.868225144558195],
            [13.244582127731611, -8.86246010554512],
            [13.24538455995789, -8.85871056979628],
            [13.243983164392962, -8.854036801614141],
            [13.24497591961964, -8.851381256675596],
            [13.251835633760148, -8.853437361561028],
            [13.25302044698616, -8.84780547699839],
            [13.252795917628198, -8.841997260075566],
            [13.249239526654218, -8.840593778619455],
            [13.24898147489722, -8.837326000015365],
            [13.246245972165049, -8.834821768985595],
            [13.248685332631783, -8.83056478129728],
            [13.245669729675624, -8.827609118880835],
            [13.249299781887846, -8.820117200982612],
            [13.249143992804397, -8.814612204189885],
            [13.247456938721426, -8.809837485825597],
            [13.24979777825108, -8.80811982889642],
            [13.244948858928916, -8.800543272039862],
            [13.246417001913358, -8.795249912080203],
            [13.243381564523313, -8.790841501799985],
            [13.239933541091418, -8.791383641387666],
            [13.237214840049402, -8.78581663348873],
            [13.23192994004192, -8.788322349497292],
            [13.232559309581257, -8.781332639872197],
            [13.228948719868734, -8.77675404213711],
            [13.233221574704315, -8.774903995586653],
            [13.233709889520446, -8.769096179855305],
            [13.237873585728458, -8.762932927216323],
            [13.239020088060352, -8.757865805174843],
            [13.235108841684584, -8.753910580295654],
            [13.229388081244307, -8.751431613280062],
            [13.221937454953368, -8.7522066290335],
            [13.216543904122554, -8.747194058612218],
            [13.212984656447757, -8.739292451517308],
            [13.206063579111177, -8.737061797731673],
            [13.20562251997245, -8.731632325426627],
            [13.190046465438963, -8.717752969058813],
            [13.183085867843186, -8.718935639726723],
            [13.178309403420428, -8.71366606418144],
            [13.175452806974983, -8.714472425779205],
            [13.168324692106017, -8.70874136576949],
            [13.162831961376227, -8.709971996181983],
            [13.15872520004274, -8.706987045799567],
            [13.147572580251477, -8.694412532550597],
            [13.142865080369377, -8.69580602231472],
            [13.14003066511241, -8.694815346840443],
            [13.138329032002272, -8.686604330818373],
            [13.13358466947829, -8.684216882882742],
            [13.133226276407964, -8.680676159363596],
            [13.136857660454112, -8.677894189620408],
            [13.137514087650816, -8.67482318184686],
            [13.13194198751675, -8.664917897220478],
            [13.125347013060479, -8.66344556729469],
            [13.12189343900519, -8.663878742218005],
            [13.11794847323203, -8.666831952854015],
            [13.106439828370418, -8.669831596820643],
            [13.103352042207417, -8.667958914540039],
            [13.098592814522654, -8.668548679222113],
            [13.094317044922336, -8.667069131273447],
            [13.095106837811388, -8.662253385189521],
            [13.088085356074119, -8.653643907329988],
            [13.088241395597606, -8.642100373945848],
            [13.08215198089399, -8.633983775456135],
            [13.079221357614342, -8.631630468719493],
            [13.07349420310522, -8.619789839505135],
            [13.067729065596904, -8.61291278871788],
            [13.066111111127672, -8.60818663998764],
            [13.066866427001681, -8.602915231542447],
            [13.06463746087998, -8.600254793703247],
            [13.057586757305168, -8.598155913664236],
            [13.055840827208588, -8.593141843499795],
            [13.048987877884487, -8.592602656697379],
            [13.045391846835567, -8.591261487995329],
            [13.042760910591246, -8.58817354466269],
            [13.038080662446196, -8.588999594901276],
            [13.027960070753211, -8.574799858106473],
            [13.01468273448006, -8.57412975713606],
            [13.009235401397445, -8.577566421584859],
            [13.00034035805002, -8.580166984344368],
            [12.99017205106531, -8.5801708478492],
            [12.984991834889609, -8.57891934348039],
            [12.978111037282895, -8.57201335941863],
            [12.978683461457864, -8.565150550016536],
            [12.973256077081254, -8.554673704426332],
            [12.95814135934803, -8.54076705109249],
            [12.95678880031037, -8.531412016423534],
            [12.948245988615568, -8.513184860204218],
            [12.946489208838095, -8.510540719278513],
            [12.940045484060871, -8.502269580791289],
            [12.938846436643022, -8.498285339502921],
            [12.934724999645983, -8.492726825186894],
            [12.931133983562878, -8.489679165911468],
            [12.927471494692616, -8.491009937407044],
            [12.920371517306686, -8.489749352286347],
            [12.916138226146924, -8.48659962142281],
            [12.912411641724981, -8.481805597718836],
            [12.905700910271024, -8.469011303802425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.18188595426159, "lat": 29.05840349387786 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12127"],
        "coty_name": ["Volusia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Volusia County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00306921"
      },
      "bbox": [
        12.905700910271024, -9.070629299397217, 13.807725017881772,
        -8.292265516278569
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.019906379541986, -6.202162408235664],
            [11.108344417674754, -6.191694914328217],
            [11.114208208085822, -6.1903323398133745],
            [11.163741712545946, -6.1845359209932225],
            [11.247007506371167, -6.174607396178487],
            [11.248695117673192, -6.170338722782348],
            [11.258257396359063, -6.1688803818358915],
            [11.265215226431899, -6.166989987122956],
            [11.268756618303913, -6.164483434949875],
            [11.27353007245627, -6.16779643284503],
            [11.281349348027508, -6.174723449404371],
            [11.288112112567237, -6.175866067142781],
            [11.289570176401888, -6.1790273474015605],
            [11.296802560226416, -6.180977647349101],
            [11.298009561558718, -6.18764786147282],
            [11.303303225975762, -6.1875003288495805],
            [11.309539119063365, -6.185630432790792],
            [11.312663686535194, -6.1864360370674065],
            [11.314810968923064, -6.1897343589631655],
            [11.315577036147358, -6.195007626977222],
            [11.313598907050817, -6.197238791302149],
            [11.31927297567302, -6.199804351617391],
            [11.325017561238191, -6.1973892095488505],
            [11.331487386638015, -6.196646100208595],
            [11.333773901953041, -6.190363170603968],
            [11.339891389820414, -6.192783569641677],
            [11.34442868643887, -6.198073925673886],
            [11.35308395015924, -6.196157450873514],
            [11.355881735548389, -6.1974090347913044],
            [11.357875846630085, -6.201657439475849],
            [11.361328967867037, -6.203536373236319],
            [11.362964868120164, -6.2011076031827645],
            [11.368012539294371, -6.2016405312824165],
            [11.370941105381132, -6.206647439611721],
            [11.378725793482314, -6.207596405313903],
            [11.383730921423167, -6.209227785816648],
            [11.38596720055399, -6.211645438534458],
            [11.391497517974894, -6.210585232450221],
            [11.392097097895626, -6.2084987264536355],
            [11.397329079605965, -6.20874371436641],
            [11.400077198484642, -6.212390424495599],
            [11.405196596955072, -6.214705457825553],
            [11.408294612933418, -6.219619436955978],
            [11.419750579251577, -6.217160474770264],
            [11.427391806347197, -6.220700833059968],
            [11.430062088501266, -6.219117991262717],
            [11.431488804889991, -6.2137741680320575],
            [11.434980540090844, -6.21325800784493],
            [11.439394038721822, -6.252312795712658],
            [11.441044835184428, -6.264374052640404],
            [11.44751616382265, -6.32019982534366],
            [11.403508500137868, -6.32473364837681],
            [11.324149130195424, -6.332507424609002],
            [11.29734355729735, -6.335346881282385],
            [11.300241913816706, -6.36184036086353],
            [11.243951716913333, -6.367834842586333],
            [11.225021616724414, -6.3694221498477654],
            [11.222190505038347, -6.3439630058414025],
            [11.211214479917427, -6.345634088258179],
            [11.171718501962633, -6.349959126933434],
            [11.170166999295672, -6.336273233768767],
            [11.165033613378476, -6.295797046691954],
            [11.16184161177281, -6.274748094627023],
            [11.149612966520522, -6.2763627149583705],
            [11.148056214784374, -6.263522038243854],
            [11.122893272102647, -6.266769970041318],
            [11.124040854243658, -6.279304281199658],
            [11.053982106973239, -6.287770985955961],
            [11.054212944366297, -6.282537620392263],
            [11.051855868114478, -6.27889158725952],
            [11.050025018390714, -6.26772181604078],
            [11.046264847271392, -6.266536936349366],
            [11.045278986550695, -6.263929403432987],
            [11.046834434272151, -6.258412096589144],
            [11.044504456392175, -6.25232250047411],
            [11.039151074943106, -6.2501750502802675],
            [11.037170570430952, -6.244799550951839],
            [11.031522548147143, -6.241217830162655],
            [11.028883013123647, -6.234754378899366],
            [11.028887077062809, -6.231073146830332],
            [11.025610967683615, -6.2287669159550685],
            [11.024384631871945, -6.225475365059794],
            [11.025386962876077, -6.220052771864755],
            [11.024218456897806, -6.21797543276084],
            [11.01803504402704, -6.214987055587083],
            [11.02056262825072, -6.204756673120873],
            [11.019906379541986, -6.202162408235664]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.22043431760355,
          "lat": 31.759770649460776
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13017"],
        "coty_name": ["Ben Hill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ben Hill County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00351606"
      },
      "bbox": [
        11.01803504402704, -6.3694221498477654, 11.44751616382265,
        -6.164483434949875
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.87342191290654, -4.6760147020805425],
            [9.876486312635011, -4.665685467408007],
            [9.881525988239241, -4.663706306948692],
            [9.883600279556777, -4.658510558132414],
            [9.913601597528013, -4.6450033950448555],
            [9.923235602770811, -4.641239646997598],
            [9.948142553648463, -4.62989545196515],
            [9.967523398807666, -4.621994640425335],
            [9.991544205919741, -4.612785046465614],
            [10.007356336212126, -4.611075477416761],
            [10.012196444124394, -4.619687934729095],
            [10.01467076353878, -4.629306400998453],
            [10.015373092460718, -4.6366682654963025],
            [10.028013513211487, -4.650123316547624],
            [10.029739014103917, -4.665690682895466],
            [10.038719593423348, -4.66469534978059],
            [10.050970817956255, -4.672258816645619],
            [10.055101285534189, -4.677447289442749],
            [10.059601298875446, -4.680069575428212],
            [10.061876791163812, -4.68473240818091],
            [10.061633539672291, -4.689626628971518],
            [10.065608061297123, -4.692617240192632],
            [10.063563239363397, -4.697245602533245],
            [10.06446517271788, -4.701488893610253],
            [10.061278399261283, -4.706060674241734],
            [10.066164826389556, -4.711391413660821],
            [10.05893008662286, -4.712169563819716],
            [10.05983285661777, -4.7201371987424485],
            [10.051972856290686, -4.721254950061437],
            [10.053865712781755, -4.737444865830715],
            [10.06148021154328, -4.736598803400473],
            [10.062466782358932, -4.744596095614487],
            [10.067972847939062, -4.7461616929276484],
            [10.068794490640302, -4.755256595983638],
            [10.063200294440733, -4.762342009458341],
            [10.064085408782283, -4.768200007514458],
            [10.068265418225035, -4.770464589403637],
            [10.068305437624316, -4.774323238788746],
            [10.071105061563879, -4.775838669361665],
            [10.071656222103016, -4.780487886129671],
            [10.064531674965892, -4.783516487370902],
            [10.068024182487225, -4.789210958736582],
            [10.067166115558758, -4.796338996279473],
            [10.073165499408509, -4.8000688490700725],
            [10.073848874614601, -4.803396655426865],
            [10.079395358874445, -4.812152461114417],
            [10.078524895912414, -4.816227257207918],
            [10.074553818534906, -4.818935809901602],
            [10.074105852021582, -4.82176710471028],
            [10.077384300546946, -4.823884746982993],
            [10.079588235334551, -4.828001594200209],
            [10.081088277582468, -4.835368024698759],
            [10.079378938721234, -4.8392965648260615],
            [10.073983589278008, -4.83936733744756],
            [10.075275891565552, -4.848304295148645],
            [10.072823578331292, -4.853574504913909],
            [10.06782712185942, -4.851606048778621],
            [10.065717643188098, -4.855105874588556],
            [10.064240338093821, -4.863481339340759],
            [10.060664479528919, -4.8635167629845855],
            [10.054826817443006, -4.866955746291977],
            [10.056309019563525, -4.8714336132548794],
            [10.053290029477422, -4.8726265203881125],
            [10.050717507698659, -4.881528785942784],
            [10.048156918602455, -4.884278298867178],
            [10.049283631773683, -4.891253876894543],
            [10.047728632906352, -4.898763291305879],
            [10.048588546836621, -4.903464248830119],
            [9.995297052666391, -4.9090093768711],
            [9.99098472889117, -4.90549539679726],
            [9.992207789592115, -4.902105968331861],
            [9.989021966100838, -4.894983681874103],
            [9.98503408282743, -4.890424699274409],
            [9.983349278689703, -4.886597142933014],
            [9.979766995021699, -4.885105895499009],
            [9.97725065076529, -4.878138387820482],
            [9.974575398172583, -4.875533810909652],
            [9.974213660106496, -4.869963555913386],
            [9.97560672510331, -4.865143879805973],
            [9.970512622877214, -4.8604046178214215],
            [9.969527806601842, -4.856184723759024],
            [9.971457985835972, -4.852432736921214],
            [9.963831304596114, -4.848124621574698],
            [9.96158978292434, -4.8428428132364285],
            [9.955325453470572, -4.8393787556214365],
            [9.955172398377746, -4.834705391940818],
            [9.95059711279314, -4.837734679364318],
            [9.947049712263977, -4.833170922371348],
            [9.942539651060635, -4.8335109811098285],
            [9.940237483715222, -4.82992444638404],
            [9.933159089607807, -4.832391611097699],
            [9.929196233026166, -4.828856377181863],
            [9.923470995746818, -4.8256645283197726],
            [9.918670308631828, -4.816996165469233],
            [9.913784760262486, -4.818620807205486],
            [9.910182246622641, -4.817771729105809],
            [9.908535075018044, -4.811745970667972],
            [9.903370392676718, -4.804772615527705],
            [9.902668291271976, -4.797915497505169],
            [9.900764005917301, -4.794936804872435],
            [9.893813135477386, -4.789156569399009],
            [9.886085444715043, -4.781224446925311],
            [9.886059653505738, -4.777700564408484],
            [9.882647499724769, -4.776970021431442],
            [9.879998981829068, -4.771587913793651],
            [9.877696443483423, -4.770915087985059],
            [9.875273067660777, -4.761480459661761],
            [9.875004665685953, -4.756504919976729],
            [9.871109642239704, -4.748907854672943],
            [9.869943462759922, -4.744031681076519],
            [9.866617151556149, -4.740366371012003],
            [9.867225081609647, -4.736411467002338],
            [9.865460399126652, -4.729374167207056],
            [9.865150039261318, -4.716924794166323],
            [9.866034738341748, -4.70963124551819],
            [9.86255071017879, -4.704945406424851],
            [9.865420246174132, -4.698801560129551],
            [9.868767956329002, -4.695503180137271],
            [9.871989053956957, -4.684349384494632],
            [9.87342191290654, -4.6760147020805425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.49424957160583, "lat": 33.41393327246514 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13113"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01687740"
      },
      "bbox": [
        9.86255071017879, -4.9090093768711, 10.081088277582468,
        -4.611075477416761
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.347181163648184, -6.445065220472929],
              [10.33950716631715, -6.445915394542578],
              [10.34024196775881, -6.453849266407264],
              [10.347895299219081, -6.452909159657657],
              [10.347181163648184, -6.445065220472929]
            ]
          ],
          [
            [
              [10.071905902092865, -6.248039878837931],
              [10.117878957202983, -6.243242784029999],
              [10.120875328297174, -6.24267675959329],
              [10.16300587350767, -6.238082698868514],
              [10.19485945484756, -6.234165792548198],
              [10.194149575568396, -6.2270829972773045],
              [10.200778503736712, -6.2264954946846105],
              [10.196951110243567, -6.185378435161714],
              [10.200348105347798, -6.189547554386062],
              [10.200797285375149, -6.192799753417104],
              [10.204797903700598, -6.193468777097642],
              [10.206120578524963, -6.197609975849856],
              [10.208831080331032, -6.199988379207967],
              [10.21805819576307, -6.20475672568281],
              [10.219043900362605, -6.207406069399111],
              [10.227706930455067, -6.212838719182122],
              [10.230232113500756, -6.211391957786091],
              [10.23967944392932, -6.218975833074228],
              [10.24031957955666, -6.222163100789181],
              [10.247044869853475, -6.225125178995478],
              [10.25379189275838, -6.22929157182161],
              [10.257740484451853, -6.234778369299109],
              [10.257303281495407, -6.237522434874612],
              [10.26072603376041, -6.239206314738528],
              [10.262534508952479, -6.242760673349091],
              [10.268305276963114, -6.247488847658785],
              [10.272056418796565, -6.248339219782565],
              [10.27827343596592, -6.257240114159263],
              [10.283353735948413, -6.25892245233456],
              [10.292476489514206, -6.267269168002936],
              [10.296958253273111, -6.267626463901629],
              [10.302442687517173, -6.266502210231626],
              [10.308555200176928, -6.2688100506611155],
              [10.311253572012996, -6.267884195949912],
              [10.31714352914495, -6.270638314206598],
              [10.32511466096852, -6.268986696213944],
              [10.332280471521168, -6.270836319723048],
              [10.336547565860098, -6.273840032150011],
              [10.339480105360051, -6.279080545509355],
              [10.34430951421982, -6.2804037276331215],
              [10.347235226357439, -6.2840187854093035],
              [10.351322255361538, -6.284085746382445],
              [10.351836741359486, -6.292924848269328],
              [10.357240379504947, -6.294941215615678],
              [10.363401810617772, -6.299229195063616],
              [10.366210659724638, -6.30448982255638],
              [10.365636459029158, -6.309563033271825],
              [10.367699547423205, -6.3133882117809375],
              [10.367732833070027, -6.324562498592466],
              [10.370724052566167, -6.32939969594216],
              [10.369540087863731, -6.335675432034676],
              [10.37209515307165, -6.338096517372933],
              [10.371820063212619, -6.34124601804871],
              [10.350582712513484, -6.343946971369635],
              [10.35505370006243, -6.38465042776874],
              [10.349633574990383, -6.38569460745707],
              [10.35454279519012, -6.437080914840601],
              [10.346529878324505, -6.4379323205284615],
              [10.347181163648184, -6.445065220472929],
              [10.355230996493365, -6.44414796865105],
              [10.35549938903411, -6.448153292419071],
              [10.361929182630089, -6.512734827731772],
              [10.233506815118323, -6.528503805058207],
              [10.233566282462647, -6.529112703705714],
              [10.15239278769847, -6.538976022563514],
              [10.154013976588285, -6.536600248698859],
              [10.156014343578377, -6.519734110816498],
              [10.158423243032605, -6.513228977463528],
              [10.15676332654843, -6.509995613996102],
              [10.153013515928313, -6.496065423280649],
              [10.154343954423231, -6.491966210415222],
              [10.152857759112385, -6.485667086400246],
              [10.15532464109494, -6.483049134871102],
              [10.154601813041506, -6.477774637254708],
              [10.149436657235507, -6.471247708459318],
              [10.149279774664649, -6.467553382703421],
              [10.144991518688416, -6.463151035980645],
              [10.141974785634009, -6.456539755175049],
              [10.141360713261838, -6.448615824364419],
              [10.134219155448458, -6.4419020852263165],
              [10.130132015104197, -6.432246956309864],
              [10.127101730250255, -6.4298887748209275],
              [10.123474684272457, -6.4204863614522365],
              [10.123882475401688, -6.417445405204226],
              [10.12108293851046, -6.414370533050887],
              [10.115827360317212, -6.403186382457602],
              [10.119181552208964, -6.398179667662137],
              [10.120647426036722, -6.392610321055558],
              [10.086935316845256, -6.395250600871821],
              [10.076497157147445, -6.291319390111865],
              [10.071905902092865, -6.248039878837931]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.43699207654595, "lat": 31.77695674733419 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13273"],
        "coty_name": ["Terrell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Terrell County"],
        "coty_fp_code": "273",
        "coty_gnis_code": "00352238"
      },
      "bbox": [
        10.071905902092865, -6.538976022563514, 10.37209515307165,
        -6.185378435161714
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.84451736125056, -5.577715812137254],
            [11.844514159938017, -5.577623265101421],
            [11.850737866895152, -5.57822939207091],
            [11.858487300228326, -5.59132152077166],
            [11.861679102136474, -5.593918570286232],
            [11.86560596805556, -5.591290758382496],
            [11.872045662555177, -5.590786719044586],
            [11.885006128207346, -5.6031723695798235],
            [11.89124303864918, -5.606322219689887],
            [11.894175806871784, -5.611269256243894],
            [11.898675912040988, -5.63186913100667],
            [11.90579864305458, -5.6314435086768855],
            [11.919919110428946, -5.626882296998751],
            [11.924724340047014, -5.627200387912704],
            [11.960642193509807, -5.621203804062142],
            [11.969220864263217, -5.6141986030364155],
            [11.974491399330391, -5.608987816807964],
            [11.996220396969083, -5.591119348316849],
            [11.994941666449321, -5.595111839325393],
            [12.002577380541187, -5.608356696139715],
            [12.004329819651995, -5.6246904802253],
            [12.006659506014595, -5.63110167550644],
            [12.012655869017799, -5.637074083428736],
            [12.013291617895462, -5.646223033117087],
            [12.020687699815776, -5.6549969247079686],
            [12.02013960490732, -5.658596653047237],
            [12.024071005216125, -5.659856973598697],
            [12.024212576201583, -5.665495504425212],
            [12.026810320543756, -5.6698266029074365],
            [12.02513312051558, -5.677518601979893],
            [12.032688630241262, -5.687394875183566],
            [12.032533206259446, -5.692157275550874],
            [12.038762105680531, -5.69904262215239],
            [12.044929380097601, -5.702694788964011],
            [12.04588335908428, -5.708281084771029],
            [12.052980945942016, -5.715485571493602],
            [12.053797192247638, -5.719918178125839],
            [12.056861127022254, -5.722655798925899],
            [12.055484013221237, -5.72587750259094],
            [12.057477610020806, -5.729321799826145],
            [12.057067749163691, -5.734600857697798],
            [12.060925608157211, -5.741833445496498],
            [12.058439376687186, -5.745602591187103],
            [12.059970988729221, -5.747929440567308],
            [12.057124555539342, -5.752139993457256],
            [12.05768595016741, -5.756732457974992],
            [12.053400212640735, -5.76290159246461],
            [12.055850596867492, -5.766844020884208],
            [12.055018579591513, -5.774610133241865],
            [12.055011164854712, -5.8272433600949665],
            [12.055777472352656, -5.837220291531352],
            [12.061559485820029, -5.99164055833596],
            [12.055998598895155, -5.9921194022271465],
            [12.053910110369834, -5.986565749211832],
            [12.049520935616444, -5.986292579263919],
            [12.047194183880688, -5.990769977437056],
            [12.044391613198236, -5.992590895194222],
            [12.041747166906706, -5.990246838657082],
            [12.040227058622929, -5.985861643399716],
            [12.034774189056092, -5.9809868612815515],
            [12.03357005449579, -5.977176704689001],
            [12.02978072635179, -5.976726789643641],
            [12.027540445236987, -5.981547605574985],
            [12.024095862728956, -5.981371636826598],
            [12.020394847461441, -5.974586405342218],
            [12.01413373645923, -5.974280300113107],
            [12.006001195224039, -5.970031463939032],
            [12.001856435056737, -5.970589918779933],
            [11.99907224651825, -5.974645307705135],
            [11.997462376599886, -5.979801183034432],
            [11.993545396599949, -5.980455478803796],
            [11.98700566831508, -5.96963492803152],
            [11.98143940660173, -5.969368486303482],
            [11.981782484858936, -5.973162009328409],
            [11.984924266253268, -5.976155056066917],
            [11.988882219731103, -5.977509611396405],
            [11.988640619409262, -5.982377896720517],
            [11.984225343822093, -5.984948276213956],
            [11.976338075141918, -5.982337391787355],
            [11.970951552824642, -5.982828743932219],
            [11.964210259697564, -5.981388446441893],
            [11.9465571468269, -5.981382569568024],
            [11.942366444885993, -5.977942289812081],
            [11.934256208158672, -5.981362749909377],
            [11.929459282971457, -5.981408264606747],
            [11.928937623800618, -5.976637013642819],
            [11.933332996826428, -5.971058802819832],
            [11.932729546893578, -5.96894139197317],
            [11.926369985335395, -5.9688436765042],
            [11.922703203135358, -5.9648456139369825],
            [11.918923506959828, -5.965161661046343],
            [11.918041847591503, -5.967913170738526],
            [11.921542340332266, -5.972054376298628],
            [11.920987865270845, -5.976474242890232],
            [11.917442756471218, -5.975569200217248],
            [11.91482633126943, -5.969885655273398],
            [11.910395444652119, -5.966986102602265],
            [11.906628811033324, -5.9663142963589735],
            [11.905584155199115, -5.970299476174692],
            [11.90782408504629, -5.972805463452917],
            [11.907044395537099, -5.976853560517697],
            [11.902732755647753, -5.97595573493981],
            [11.902436209832164, -5.971556017966666],
            [11.893685240702336, -5.968871367618992],
            [11.888710090019792, -5.965745733293057],
            [11.881306315505109, -5.963985725094732],
            [11.874540947351681, -5.9633292072251916],
            [11.870321469075689, -5.964234831433643],
            [11.86438362734251, -5.968010370417249],
            [11.859900038430037, -5.969457860426375],
            [11.840345824769397, -5.964307640504611],
            [11.83778398843001, -5.967390139240761],
            [11.836759211970401, -5.942284065810356],
            [11.837593507271285, -5.910678902327139],
            [11.836778340848195, -5.844901997779667],
            [11.836798777049133, -5.786377763250743],
            [11.837308989566951, -5.71593733016822],
            [11.83441251248154, -5.6928447806932025],
            [11.828342798397726, -5.641243344291466],
            [11.840002397392611, -5.594945360588358],
            [11.84451736125056, -5.577715812137254]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.33128063613464,
          "lat": 32.121531338791975
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13279"],
        "coty_name": ["Toombs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Toombs County"],
        "coty_fp_code": "279",
        "coty_gnis_code": "00345220"
      },
      "bbox": [
        11.828342798397726, -5.992590895194222, 12.061559485820029,
        -5.577623265101421
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.284637308595036, 5.907519974398333],
            [-13.146866708211403, 5.880100852907319],
            [-13.040486274925383, 5.858990270684038],
            [-12.935093103700938, 5.837963252063772],
            [-12.968748623476559, 5.66826462757879],
            [-12.969804838296193, 5.664185479358304],
            [-12.977364351589133, 5.62535421248957],
            [-13.002845003132618, 5.496902668220433],
            [-13.019309943735406, 5.500139394955572],
            [-13.034401542419674, 5.422457984257252],
            [-13.057509754146176, 5.305838440727599],
            [-13.058126224755522, 5.301970683852848],
            [-13.06767231850281, 5.305887960285814],
            [-13.071392452957392, 5.311361970746128],
            [-13.081170044315206, 5.318427226844528],
            [-13.090997169600778, 5.320996299579022],
            [-13.102282121024528, 5.320988590255112],
            [-13.110119249807113, 5.327305103822622],
            [-13.114458939146736, 5.329154009130152],
            [-13.117532071516516, 5.3330103306529635],
            [-13.124059060418485, 5.332040633364705],
            [-13.132061788868832, 5.337704449272602],
            [-13.138028892160616, 5.338584165096713],
            [-13.146052564379008, 5.3439659456882564],
            [-13.153580528213384, 5.344686730857437],
            [-13.161331205225784, 5.343472819406061],
            [-13.17071856895225, 5.339696659773606],
            [-13.1756158594088, 5.341911189667262],
            [-13.186418858383224, 5.344508469300257],
            [-13.192221919314136, 5.342434051089661],
            [-13.195414053534053, 5.344682642304304],
            [-13.19714397695948, 5.349659559869413],
            [-13.199950981562754, 5.3510355788614925],
            [-13.201062837110518, 5.358251320509027],
            [-13.199942803642076, 5.362040757013143],
            [-13.200881076189606, 5.3679445474449565],
            [-13.197638356983322, 5.37484158061507],
            [-13.196503738389811, 5.385378780270508],
            [-13.199380139674714, 5.391057562432053],
            [-13.203024556476821, 5.390196415228011],
            [-13.213045103729492, 5.39852747011206],
            [-13.211120141457712, 5.401653657350774],
            [-13.207634794714787, 5.4126036254818475],
            [-13.204758319053314, 5.4169409610299075],
            [-13.204152081989648, 5.423247268665712],
            [-13.205956786898042, 5.433949184078098],
            [-13.210093317016224, 5.440467790948462],
            [-13.217717729904178, 5.443809523478873],
            [-13.223484929431027, 5.44475434846699],
            [-13.231680661316675, 5.454796130570101],
            [-13.234134269141498, 5.45524523316834],
            [-13.243113682997638, 5.462557924210198],
            [-13.248320473656877, 5.464889249612906],
            [-13.25398920007786, 5.465329896075514],
            [-13.256890745832022, 5.461361555225084],
            [-13.262023976361723, 5.462763825644935],
            [-13.264618190740158, 5.472724902155377],
            [-13.262295227390451, 5.487824598354608],
            [-13.258707538049345, 5.4939537861745285],
            [-13.25266180505681, 5.500721792758066],
            [-13.254917620786841, 5.507314176339497],
            [-13.253819431445871, 5.510131292435016],
            [-13.245689687446951, 5.517127919334116],
            [-13.236435379715783, 5.518307203622493],
            [-13.233543165612884, 5.520056415148406],
            [-13.232298212256477, 5.524759100408649],
            [-13.224989046617614, 5.533775312340116],
            [-13.220824328147321, 5.5486439139091965],
            [-13.223407299166512, 5.553377781043246],
            [-13.224873088723143, 5.560615248071293],
            [-13.228725168223576, 5.564231508628144],
            [-13.229974811531987, 5.569761069525163],
            [-13.229021458910438, 5.573140811329776],
            [-13.233719752226298, 5.573546112258337],
            [-13.24027978524949, 5.5799497011245895],
            [-13.238719015276875, 5.582972352010388],
            [-13.243288110946787, 5.590940031199547],
            [-13.245850945205458, 5.597203598440285],
            [-13.249605463744109, 5.6014266581992755],
            [-13.249982085707739, 5.609178599648893],
            [-13.251622882913924, 5.611831869054133],
            [-13.259534408701176, 5.6135865991937175],
            [-13.266736975528609, 5.61367991687524],
            [-13.278452419695522, 5.620556780510349],
            [-13.286451216900794, 5.619546451437008],
            [-13.29101477621032, 5.622926475930963],
            [-13.297943870212093, 5.624056662052623],
            [-13.304572371091291, 5.6199835454396485],
            [-13.30751225241486, 5.6199749148741045],
            [-13.309207692064982, 5.622693103847979],
            [-13.314894407302889, 5.626773768990026],
            [-13.32583397869204, 5.624485279468068],
            [-13.329884534725, 5.625664492319062],
            [-13.335290172378569, 5.629495098411495],
            [-13.341971266805078, 5.629812555271568],
            [-13.284637308595036, 5.907519974398333]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.81155144009769,
          "lat": 42.97104318840976
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16047"],
        "coty_name": ["Gooding"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gooding County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00395441"
      },
      "bbox": [
        -13.341971266805078, 5.301970683852848, -12.935093103700938,
        5.907519974398333
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.133231257989342, 2.749807406134691],
            [4.147214007451806, 2.7502341422607186],
            [4.229796394050062, 2.7538960319634476],
            [4.262140542204989, 2.755409527287045],
            [4.371866169335766, 2.7580372739222874],
            [4.434033760821523, 2.7612269457446588],
            [4.493029770274777, 2.763683651858437],
            [4.521876521546475, 2.7647297576062453],
            [4.564904715012799, 2.7669276837942367],
            [4.6083213132048195, 2.7696092523883107],
            [4.611799620587843, 2.6807680102493068],
            [4.615759046826427, 2.5929932622938887],
            [4.619595012537374, 2.5049681037832654],
            [4.60485167508132, 2.5038011832007525],
            [4.539093692930943, 2.500356697391554],
            [4.4803070902246915, 2.4996381769141847],
            [4.448953870227334, 2.498820402470367],
            [4.361178372849556, 2.495113960104168],
            [4.292709612291484, 2.4920892018583185],
            [4.2494992176029145, 2.4905942509194605],
            [4.238797379808773, 2.49001823352292],
            [4.238372136937457, 2.4924785037626616],
            [4.239148200873461, 2.5166486975460582],
            [4.230449358856799, 2.5307647926618464],
            [4.223535227867205, 2.5389454073559237],
            [4.219282231119473, 2.5493590702891558],
            [4.210810536147076, 2.5615710317011833],
            [4.203886906583641, 2.5743744677864138],
            [4.197376131289235, 2.5809379832155885],
            [4.1899659324553475, 2.584198226999573],
            [4.1754775828107835, 2.580604849463309],
            [4.16465185169828, 2.582827813013477],
            [4.153531132698156, 2.602042787933746],
            [4.144737968335294, 2.6154528398555605],
            [4.1390612784413445, 2.622856592581214],
            [4.132372915320064, 2.6298492947999548],
            [4.123321667519823, 2.6376562129993375],
            [4.117091289653539, 2.6452978079879763],
            [4.110271876743892, 2.6510319619679805],
            [4.106977437434836, 2.6557367693908813],
            [4.106129751656908, 2.664392862706845],
            [4.108707154072409, 2.6706346279862854],
            [4.114955327164883, 2.6821290574160166],
            [4.120710484785167, 2.70233086897802],
            [4.124158809513594, 2.7100303999708077],
            [4.130748090166716, 2.717889572942838],
            [4.1325350670227605, 2.7217629271134753],
            [4.133321193620664, 2.729730152859923],
            [4.133231257989342, 2.749807406134691]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.74144087992458, "lat": 41.20533366113094 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17131"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01784750"
      },
      "bbox": [
        4.106129751656908, 2.49001823352292, 4.619595012537374,
        2.7696092523883107
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.2731541331097205, 0.9891213476745232],
            [5.347992500347657, 0.9952924060205764],
            [5.401258934059007, 0.9990263011893861],
            [5.408423043376782, 0.9104243269510767],
            [5.409124181742114, 0.8976519500381913],
            [5.415374675247417, 0.8222067024062986],
            [5.458572719206642, 0.8250811700342744],
            [5.543559395577724, 0.8309829728873929],
            [5.628938353890356, 0.8369205027445616],
            [5.671355955327514, 0.8402228272488748],
            [5.714169671685416, 0.8432153885772213],
            [5.723978023251971, 0.711225131656787],
            [5.723834393551526, 0.7113493598129552],
            [5.660139066305848, 0.7063754021048685],
            [5.638995522655304, 0.7048663734773447],
            [5.642030802592646, 0.6608037504001402],
            [5.648273632979398, 0.5728726029952785],
            [5.65271482627702, 0.5142245152995298],
            [5.615327879954573, 0.5116080763409873],
            [5.567182089805485, 0.5077240942081587],
            [5.538752884146105, 0.5058684157451785],
            [5.477917551651214, 0.5016063261711075],
            [5.444785248267735, 0.49971126919527487],
            [5.394773203012773, 0.49648013217589554],
            [5.396932417347454, 0.4674091007650794],
            [5.356118354420993, 0.4643312890364155],
            [5.310592462716562, 0.46114252182590554],
            [5.303531475499477, 0.5588613921886288],
            [5.303138461874615, 0.5612767510795384],
            [5.299632322007149, 0.6109569152347757],
            [5.291218544773471, 0.7143365831933399],
            [5.289842908613428, 0.7293083982237071],
            [5.283319048799096, 0.8124821860712454],
            [5.2866931698202, 0.8127243030925442],
            [5.275916610900327, 0.9544165335982726],
            [5.2731541331097205, 0.9891213476745232]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.47887129177109, "lat": 39.23102858779307 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17135"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01784866"
      },
      "bbox": [
        5.2731541331097205, 0.46114252182590554, 5.723978023251971,
        0.9990263011893861
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.133230201772971, 2.750042508268218],
            [4.133202742107109, 2.756149165888962],
            [4.135607416871059, 2.7820767423549304],
            [4.136492910936519, 2.7860088994269803],
            [4.145665851951388, 2.8027984014896097],
            [4.145821870003407, 2.817691386649964],
            [4.147117054739241, 2.8286969121483114],
            [4.14970142885857, 2.833868607612471],
            [4.154579862598302, 2.838276063800722],
            [4.161333583661745, 2.8422436308240684],
            [4.177501023723172, 2.8456432928197377],
            [4.192652871259061, 2.854236777861752],
            [4.199874570924197, 2.854735019996258],
            [4.206403039339484, 2.851114839134765],
            [4.219251272490795, 2.84586092341687],
            [4.234090989229776, 2.843869556936238],
            [4.241789224619726, 2.8484992306551686],
            [4.255514445602691, 2.8548438896849233],
            [4.2703480898417, 2.865631922293762],
            [4.279240203829614, 2.8733188812529415],
            [4.286217413386522, 2.878268359743782],
            [4.294252404649861, 2.881112636065919],
            [4.301016013957409, 2.881965465194564],
            [4.310493492383967, 2.8813154586277236],
            [4.323453405146052, 2.8820211341592064],
            [4.33913488139697, 2.8812886779127656],
            [4.345684462663243, 2.8800080351949546],
            [4.3661519419440875, 2.879493174335799],
            [4.3754845268647795, 2.8805081736099893],
            [4.385755910778205, 2.883215693971296],
            [4.4022382149312005, 2.886647682129463],
            [4.409710777756824, 2.8889800081416075],
            [4.4202492653391126, 2.893792332304282],
            [4.4278333328800565, 2.8940158166500174],
            [4.435469598082332, 2.895956858711317],
            [4.43946339094825, 2.899105039275342],
            [4.446415644546075, 2.907863977455006],
            [4.451824027023907, 2.913612879191957],
            [4.461856520992594, 2.92053107410285],
            [4.4706816386497765, 2.9303056477925598],
            [4.47282639864108, 2.9423226293118554],
            [4.477659243436073, 2.947637497379456],
            [4.4872171272133325, 2.9523145662515],
            [4.498057741728442, 2.955352560389842],
            [4.505831537240281, 2.962551207636283],
            [4.517069605298842, 2.9651119382457947],
            [4.522998372140166, 2.964242969736936],
            [4.538072590942985, 2.95966784247666],
            [4.547432411676817, 2.9586965497940185],
            [4.555357390852749, 2.959357067809613],
            [4.56684137432623, 2.9615357959493633],
            [4.576186445283997, 2.9659104195670225],
            [4.587460508742232, 2.9792702296275437],
            [4.595939064724127, 2.993274426383022],
            [4.603446496570564, 2.9984523986925447],
            [4.6076761835048545, 3.0074707842968587],
            [4.609757789596039, 3.010012400387078],
            [4.62039210936104, 3.017593713654808],
            [4.63243351203075, 3.0227397155266704],
            [4.6450014578937155, 3.026507781562976],
            [4.659997419929906, 3.035664378356133],
            [4.662091122410317, 3.0466756810537476],
            [4.65674394485914, 3.0889158446514045],
            [4.656287794033364, 3.0950410136624367],
            [4.660210463878995, 3.112986203110385],
            [4.660939701053882, 3.1281747203631705],
            [4.663859742055145, 3.1327782406994684],
            [4.671132284543763, 3.139024499834681],
            [4.674699122450202, 3.144386664755887],
            [4.675659618994524, 3.152099444835354],
            [4.674826958559661, 3.1591727351660706],
            [4.671261588411617, 3.167867291122678],
            [4.671412554963752, 3.1785099268607073],
            [4.6719298805998895, 3.183961671445519],
            [4.674786766470007, 3.192143952887687],
            [4.680174542155683, 3.2003438325699816],
            [4.69697516725473, 3.218812923579354],
            [4.708027721721111, 3.2242693982724036],
            [4.7112805794364325, 3.2276731687888818],
            [4.722813961841552, 3.236098915314866],
            [4.723454947182183, 3.230006552962269],
            [4.721569791018996, 3.2246937819920105],
            [4.722091986334714, 3.2203691362029914],
            [4.72820012367374, 3.215902150371799],
            [4.723942368495161, 3.2129848354051633],
            [4.721331046654109, 3.2075876264032135],
            [4.720922230577538, 3.1996189266819544],
            [4.729729354040128, 3.1939747663797324],
            [4.731346137779979, 3.1894007773242175],
            [4.728956876131801, 3.180341092563701],
            [4.73248401136851, 3.1782833461373974],
            [4.73230771668113, 3.173690167428334],
            [4.729261088165942, 3.1669960118079477],
            [4.7293459563774345, 3.1596268675812906],
            [4.725823987477669, 3.1550707898702894],
            [4.7317659343536445, 3.1525956436716758],
            [4.731916947794666, 3.1499531240196865],
            [4.736433794163733, 3.1490428217883073],
            [4.73986382227015, 3.1459865375973144],
            [4.740364763893522, 3.1369086858826054],
            [4.734524180855883, 3.134430622150954],
            [4.733711215033985, 3.132485472066221],
            [4.738723006445651, 3.128635913643116],
            [4.7472555414953055, 3.125109521097761],
            [4.754576658416711, 3.1236279549038097],
            [4.7692201838084465, 3.118397171238832],
            [4.77538745157115, 3.1132385914513323],
            [4.781456181165872, 3.1106649400584456],
            [4.784368441742891, 3.1045293687950277],
            [4.788510724825224, 3.103768444833267],
            [4.7908667992143155, 3.100813449012473],
            [4.789746663213353, 3.0953043471153867],
            [4.782217689835781, 3.0957013622189424],
            [4.782822308915846, 3.093275808686138],
            [4.790973616648303, 3.0916590184183312],
            [4.793200183424469, 3.086724289611713],
            [4.792136427033898, 3.0776539237903964],
            [4.793382527356482, 3.074004608632959],
            [4.789860619433129, 3.0656591464140845],
            [4.791575745569272, 3.0531832165915924],
            [4.79088600123887, 3.0499531870901433],
            [4.787782130789025, 3.0473442631600562],
            [4.779691628695697, 3.046074330432901],
            [4.776843940388202, 3.0438384623363564],
            [4.77703191778529, 3.039440386322017],
            [4.781456219252394, 3.0338054189507253],
            [4.782485595379086, 3.028596781548858],
            [4.781740222345786, 3.02191031460459],
            [4.779362731347424, 3.0107443013321182],
            [4.774418959075569, 2.997581320290705],
            [4.771616013077932, 2.994297743219956],
            [4.756774169133988, 2.9911650031761967],
            [4.752031605856433, 2.9874416225627027],
            [4.7505130825731845, 2.982719587192345],
            [4.746338191167223, 2.9815778580811805],
            [4.739096953348059, 2.9768941604161236],
            [4.732945120000681, 2.9744337182738523],
            [4.725306918848898, 2.9727410579763003],
            [4.7194852559183635, 2.9729947197493214],
            [4.7114367927610585, 2.9706950870284934],
            [4.704094734880248, 2.970253611588034],
            [4.698083619890281, 2.967681732258681],
            [4.69275890710269, 2.967009630142179],
            [4.687720905549337, 2.959448838657869],
            [4.683536783554072, 2.9573475108334035],
            [4.672263654654003, 2.961963595549801],
            [4.658054658957456, 2.955906538583834],
            [4.6495144998948446, 2.9493524801275934],
            [4.646020873606153, 2.9429953698315963],
            [4.643839721955989, 2.9297804467613626],
            [4.64172933141454, 2.9245205820913336],
            [4.639087767367469, 2.9223609746564816],
            [4.633947263454358, 2.9218142748554254],
            [4.627888572427624, 2.9147015359511323],
            [4.619817776632446, 2.9075717084019397],
            [4.609973609109512, 2.9014477943513373],
            [4.602002675432319, 2.9001738220541347],
            [4.605008470630765, 2.8369282833599465],
            [4.6083213132048195, 2.7696092523883107],
            [4.564904715012799, 2.7669276837942367],
            [4.521876521546475, 2.7647297576062453],
            [4.493029770274777, 2.763683651858437],
            [4.434033760821523, 2.7612269457446588],
            [4.371866169335766, 2.7580372739222874],
            [4.262140542204989, 2.755409527287045],
            [4.229796394050062, 2.7538960319634476],
            [4.147214007451806, 2.7502341422607186],
            [4.133231257989342, 2.749807406134691],
            [4.133230201772971, 2.750042508268218]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.56732470428578,
          "lat": 41.467376721563745
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17161"],
        "coty_name": ["Rock Island"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rock Island County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00424282"
      },
      "bbox": [
        4.133202742107109, 2.749807406134691, 4.793382527356482,
        3.236098915314866
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.07279734291452, 2.373784491593026],
            [8.078549665550222, 2.3740664902672006],
            [8.094067179086318, 2.376297699208211],
            [8.214212604152923, 2.3901906473070023],
            [8.241797583271266, 2.3935181077121137],
            [8.298832205913506, 2.3998432008068575],
            [8.383613454655297, 2.4096542260267886],
            [8.394654995833674, 2.3229868415491803],
            [8.405337552870098, 2.235305153100985],
            [8.412518823553366, 2.1778763783881887],
            [8.417660211127586, 2.135078931633406],
            [8.403578874229154, 2.1338001777686513],
            [8.388771637208977, 2.13156922241207],
            [8.337553339418905, 2.125809611332253],
            [8.316859219586785, 2.1243068774233973],
            [8.247032922751838, 2.1164891230428293],
            [8.233236911038912, 2.1140969506952705],
            [8.17631405208537, 2.108486871339839],
            [8.104017114494479, 2.1000388566939496],
            [8.101088035082828, 2.1286450661145775],
            [8.09435828259836, 2.186589975594007],
            [8.083974009288182, 2.2733047584108177],
            [8.08290946877279, 2.2875254558224865],
            [8.07279734291452, 2.373784491593026]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.65471216988342, "lat": 40.51579760966367 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18053"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00450355"
      },
      "bbox": [
        8.07279734291452, 2.1000388566939496, 8.417660211127586,
        2.4096542260267886
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.898155635569214, 0.7296968521763202],
            [7.954479281931449, 0.7358422825103281],
            [7.954587974870332, 0.7350273557123425],
            [8.009715229388751, 0.7409283618443501],
            [8.079992716694752, 0.7499946990698695],
            [8.081831390251297, 0.7356037174318777],
            [8.095678661119463, 0.7371539728675768],
            [8.172573031708827, 0.7474419472208492],
            [8.211815826760784, 0.7537794198829724],
            [8.23617737104108, 0.756499326388333],
            [8.24904788660712, 0.7583971866483334],
            [8.2494552687906, 0.7623660352447013],
            [8.246753590230714, 0.7662832073573694],
            [8.250244903922882, 0.7676835548186574],
            [8.252756284729598, 0.7729428892639877],
            [8.25767503745128, 0.7738610082373977],
            [8.257285827284965, 0.778485710392337],
            [8.267715553491964, 0.7835006107300078],
            [8.271315282452454, 0.7838100459216795],
            [8.274793482048917, 0.7904017478937921],
            [8.277592661204043, 0.7900761867439623],
            [8.288930532926932, 0.7930262868839663],
            [8.293306012114508, 0.7912007905511921],
            [8.307240612413338, 0.6748956126951974],
            [8.313179216372388, 0.6246907501851634],
            [8.322422651412536, 0.5454868002751184],
            [8.324184186011099, 0.5294681039952206],
            [8.31836721096143, 0.5166228253110607],
            [8.317017942771844, 0.5102839737089724],
            [8.319881177009918, 0.5006026597778845],
            [8.316538886471394, 0.4983387692912186],
            [8.310504638221218, 0.4979038401565698],
            [8.307505827836948, 0.49016623467119935],
            [8.304961069807849, 0.4880039179435627],
            [8.302161536784796, 0.481509667016407],
            [8.302841216214286, 0.4775176492775796],
            [8.30058331994081, 0.46940103850766934],
            [8.294108394882366, 0.4625177751672808],
            [8.29585212013388, 0.45902369831837614],
            [8.286636400507529, 0.45168172917494903],
            [8.285557668525763, 0.44800792610879],
            [8.281863949188924, 0.4481667592813997],
            [8.277996569382552, 0.44509933646685435],
            [8.268227531667684, 0.4440951118015167],
            [8.266230299846615, 0.43981580764541733],
            [8.260671537568358, 0.448458484530389],
            [8.260152930985884, 0.4444459430987908],
            [8.256271738253023, 0.4448703731883788],
            [8.257717899783348, 0.4502755372600381],
            [8.254946600988262, 0.451608497220904],
            [8.25153765248732, 0.46079788619061596],
            [8.2529870361474, 0.46349209872953223],
            [8.249184580646713, 0.4669023906640693],
            [8.247511487840482, 0.464703284722548],
            [8.240358069615157, 0.46877620078602894],
            [8.240816566763572, 0.4595665897581668],
            [8.23531734959045, 0.46580136839943354],
            [8.236344705542804, 0.45785965941013207],
            [8.22846537287635, 0.46149395810964045],
            [8.228270216478798, 0.46695730045902334],
            [8.221380417965431, 0.4659932375288278],
            [8.218993030727233, 0.47243186389062486],
            [8.214080920259246, 0.4678192024335253],
            [8.214081254499508, 0.46354455284433543],
            [8.211154915283132, 0.4628846287542253],
            [8.2087073338905, 0.47031622780734245],
            [8.204469449771619, 0.4698189511221065],
            [8.201789139759043, 0.4723929484520179],
            [8.198068302376829, 0.46895255086134585],
            [8.197368813100464, 0.46272039948282195],
            [8.19092538719614, 0.45926924082986464],
            [8.187965276091385, 0.4614881997177433],
            [8.188231217096735, 0.464537952934319],
            [8.183430132416772, 0.4644219719685641],
            [8.183409870905557, 0.4744369581697227],
            [8.177043713788734, 0.4730389683663839],
            [8.174516685567296, 0.47033015011733714],
            [8.17378626685187, 0.4660932902198951],
            [8.167212609253866, 0.46444689995084165],
            [8.165126258850671, 0.461183919755976],
            [8.161059913703799, 0.4607804197400935],
            [8.158674512256749, 0.46468956588164356],
            [8.159682859337615, 0.4691412828594466],
            [8.154490092781952, 0.4701767786667991],
            [8.151823055948233, 0.464226532651375],
            [8.140915320289233, 0.4626176114473136],
            [8.138651389599188, 0.46396537606294674],
            [8.1324926091091, 0.4718248251246421],
            [8.126473740421849, 0.4748810308771008],
            [8.124178255547701, 0.4773050421331394],
            [8.118804832900286, 0.47776864392339585],
            [8.11297456660901, 0.47373405502134686],
            [8.107852617886936, 0.479067357607748],
            [8.0992860838886, 0.4811045092290146],
            [8.095885708315897, 0.4797732286853688],
            [8.09332305341531, 0.47281115788028344],
            [8.09508004670255, 0.46597075618033845],
            [8.092959815420976, 0.46253098413818416],
            [8.089294241507634, 0.4635133969775049],
            [8.08152419507429, 0.4624493488820897],
            [8.075755758209317, 0.45906098938788736],
            [8.068279396232974, 0.45657533046873133],
            [8.06393911905902, 0.45917893859578623],
            [8.053504588130394, 0.46148692790711643],
            [8.04499300057826, 0.46674798772676107],
            [8.04217584637805, 0.46420697632189334],
            [8.038475735721907, 0.4640533573452978],
            [8.032499863086121, 0.46813441447078696],
            [8.030269023816318, 0.4729034767658076],
            [8.02728648753103, 0.47311812897987326],
            [8.024604386631083, 0.4664543381663905],
            [8.020761985409711, 0.46653048021849436],
            [8.016171561256815, 0.4714129386985597],
            [8.012071064587584, 0.4704233715275917],
            [8.015181952407278, 0.4647887110855645],
            [8.006439704376382, 0.46737056684219963],
            [8.0061339503562, 0.46169118095823497],
            [8.001741360407417, 0.45908960807510524],
            [8.00081283716292, 0.4645409989125693],
            [7.998087536327489, 0.4662714791188558],
            [7.992452777809405, 0.4596475542586751],
            [7.989220437688636, 0.45383611396349816],
            [7.984796297990292, 0.45115526200242545],
            [7.981468890014632, 0.45308724144570484],
            [7.977143679313068, 0.448251012551642],
            [7.97368404324123, 0.44943993301158675],
            [7.975953969170254, 0.45482569128943023],
            [7.97344382187879, 0.45648379085122776],
            [7.969444483883353, 0.45376132614389475],
            [7.969577825132423, 0.4494216565736436],
            [7.9622786993764905, 0.44877009973698534],
            [7.960338978077249, 0.4468027838963622],
            [7.949095547470954, 0.5428771885218894],
            [7.9439171198180745, 0.5860125934695661],
            [7.9434904537707745, 0.5869989572691642],
            [7.935212382185555, 0.6589714615101501],
            [7.932992868461244, 0.674624692285064],
            [7.9046091420407425, 0.6715573226641762],
            [7.903142197381598, 0.6834464425505673],
            [7.898155635569214, 0.7296968521763202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.03759888951015, "lat": 38.90648282710879 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18071"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00451678"
      },
      "bbox": [
        7.898155635569214, 0.43981580764541733, 8.324184186011099,
        0.7930262868839663
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.718835682591864, 3.5691830568915566],
            [8.732961335534574, 3.5710778982706786],
            [8.734801207599723, 3.553979917527538],
            [8.740484202174706, 3.5070616795644556],
            [8.742859185288061, 3.485535006131489],
            [8.750720314289447, 3.422653059568212],
            [8.761084186934797, 3.34137768602517],
            [8.755853299632518, 3.34087943634775],
            [8.693084500621762, 3.3319159972099945],
            [8.640463561399688, 3.3251370981854445],
            [8.612215223854093, 3.321263387023892],
            [8.562170158010874, 3.315029205846883],
            [8.474175501174878, 3.3043326462309426],
            [8.471874317142602, 3.325484319896439],
            [8.465706593343993, 3.3773419532311952],
            [8.453073667492166, 3.4778945263795538],
            [8.44935412440333, 3.5091292315746996],
            [8.445528129836179, 3.537243905711975],
            [8.504018463405455, 3.5438972227046763],
            [8.561233568722862, 3.5507768421864125],
            [8.562445685505736, 3.550730736713236],
            [8.610312765786034, 3.5558418241024805],
            [8.639926721893197, 3.5596219250977987],
            [8.718835682591864, 3.5691830568915566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.00084788146717, "lat": 41.64389266419631 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18151"],
        "coty_name": ["Steuben"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Steuben County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00450390"
      },
      "bbox": [
        8.445528129836179, 3.3043326462309426, 8.761084186934797,
        3.5710778982706786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8138037822533457, 3.5495416587094897],
            [1.8997748644669088, 3.5512777006372604],
            [1.9498179242040705, 3.5522211212573613],
            [1.9852670494174494, 3.5530445775321],
            [2.0704794799182453, 3.5546350258916],
            [2.1567833404700893, 3.556408837562362],
            [2.1577951747779496, 3.5089781848892847],
            [2.1596434167610283, 3.4314071435466196],
            [2.1610707106266576, 3.368927632523373],
            [2.163024514376047, 3.3072310442739474],
            [2.1654845680142127, 3.208705448343008],
            [2.0784968214520627, 3.206704581086067],
            [1.993225696292489, 3.2045568690056068],
            [1.9465562985845235, 3.2034653335063643],
            [1.8207491406167289, 3.2010845428401558],
            [1.8189570589892008, 3.288485979924458],
            [1.8184391429616573, 3.3175848709356126],
            [1.8166642293768476, 3.402462228157275],
            [1.814785107107363, 3.490946151925237],
            [1.8138037822533457, 3.5495416587094897]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.93164054328714, "lat": 42.03649525288246 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19015"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00465197"
      },
      "bbox": [
        1.8138037822533457, 3.2010845428401558, 2.1654845680142127,
        3.556408837562362
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2582608618220052, 3.893011830305959],
            [1.3015363146012975, 3.893280439316194],
            [1.3446966832950158, 3.8933555669489692],
            [1.3980096780988542, 3.893678059854554],
            [1.4312650458787135, 3.8940924491615676],
            [1.4746336560737396, 3.8955030037532743],
            [1.4853630136355835, 3.895252737321113],
            [1.5176347796724006, 3.8953555433162723],
            [1.6033351986212192, 3.896326115716277],
            [1.6047375372110972, 3.8105216261172172],
            [1.6379785459950011, 3.8109945891564876],
            [1.63971483086075, 3.7333824022403217],
            [1.6413931894142224, 3.610375083785643],
            [1.6425676763459836, 3.545687559806595],
            [1.5575490381706587, 3.5444671242713452],
            [1.4725999200887652, 3.543443362099252],
            [1.4724406045203122, 3.5432671992103284],
            [1.4581291462600012, 3.543209302965403],
            [1.387038903523155, 3.542217084587141],
            [1.3583897146785493, 3.5420041083002216],
            [1.3035393790011245, 3.541336093001199],
            [1.3026224780459013, 3.628326576207695],
            [1.302365898938866, 3.7174271746728715],
            [1.3016063753796603, 3.806845396993156],
            [1.2592492346197541, 3.806544654044917],
            [1.2581628299041785, 3.889745510110295],
            [1.2582608618220052, 3.893011830305959]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.6403863538244, "lat": 42.385185583503336 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19025"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00465202"
      },
      "bbox": [
        1.2581628299041785, 3.541336093001199, 1.6425676763459836,
        3.896326115716277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0918793739554316, 2.830554713190004],
            [1.176561483310714, 2.830833220149866],
            [1.282826753517104, 2.831784981314202],
            [1.429320284927833, 2.8332873748953866],
            [1.4304623927458997, 2.74615457035348],
            [1.432101675582436, 2.6590437728539813],
            [1.432486279883695, 2.628940635156537],
            [1.4329695947885936, 2.571683292637105],
            [1.4341188207980184, 2.484877554656901],
            [1.4308409040218173, 2.484649526192643],
            [1.348716687632213, 2.484071563334974],
            [1.2646035925009145, 2.4831903770995947],
            [1.188570192695728, 2.4825078907499614],
            [1.0947202386819352, 2.4821199979876347],
            [1.0941376930848947, 2.4822064858077115],
            [1.094009911106804, 2.540728329727313],
            [1.0932400126704291, 2.6261785607398727],
            [1.0930420055693773, 2.663254468012595],
            [1.092508902580079, 2.681317370678817],
            [1.0930062610883082, 2.713027227831968],
            [1.0915014249058443, 2.825341298480314],
            [1.0918793739554316, 2.830554713190004]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.927839690532, "lat": 41.33148930194941 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19029"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00465204"
      },
      "bbox": [
        1.0915014249058443, 2.4821199979876347, 1.4341188207980184,
        2.8332873748953866
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.03131650927215039, 4.832415886978624],
            [0.13648753483494733, 4.8317847135304826],
            [0.1747831732851754, 4.831541298936026],
            [0.22399183858725183, 4.831449510295009],
            [0.2982582004552121, 4.83107383311668],
            [0.37428756993095397, 4.83082498846452],
            [0.42535691769137085, 4.830736905065652],
            [0.47941767903383786, 4.830684926325596],
            [0.5641368163100491, 4.830742637884935],
            [0.5645342028571171, 4.741273754104916],
            [0.5647055623721441, 4.675982583215174],
            [0.563792652864076, 4.587890337766177],
            [0.5440551220806099, 4.588146108029745],
            [0.48470246605676226, 4.588009427010061],
            [0.44918078565692077, 4.588681059197815],
            [0.4353687222572295, 4.589151234373926],
            [0.3926866397358187, 4.587687108825511],
            [0.36362618358688564, 4.58759987400049],
            [0.3202770281151519, 4.587859639970147],
            [0.2711607889211318, 4.587960055967744],
            [0.22164926240013397, 4.58837430361859],
            [0.13734543553035575, 4.589822257797191],
            [0.06164702994855898, 4.5914256710453145],
            [0.05498279319159225, 4.591705239714278],
            [0.04587472644549015, 4.59984405337416],
            [0.03978136404935268, 4.600452257761121],
            [0.0390203959035354, 4.605908137942154],
            [0.04294440160278218, 4.606366017780993],
            [0.04521048382866625, 4.611499787544566],
            [0.043173702218868557, 4.620610811706383],
            [0.04288435125728722, 4.626688544906864],
            [0.03862406367285887, 4.623430726474762],
            [0.03758191160361645, 4.627977319676605],
            [0.04160829812690321, 4.629741787944216],
            [0.04841489565486682, 4.630747378326503],
            [0.051612432691129015, 4.627086709412489],
            [0.06164779603507237, 4.6262942276607655],
            [0.06319989646719838, 4.624338707004071],
            [0.0719417171849084, 4.626989405622735],
            [0.0796754546702209, 4.631431960593276],
            [0.08324054105590702, 4.643867096482981],
            [0.08090834084214095, 4.6479810828913335],
            [0.07787480598400166, 4.660044492430853],
            [0.07660787535686718, 4.667950785547975],
            [0.08435624084111602, 4.678666397992941],
            [0.08268437590177928, 4.683302080293528],
            [0.08226140042514826, 4.699606178938764],
            [0.0866534573956724, 4.706090069289081],
            [0.08653419308158465, 4.717140444194245],
            [0.08479697831547418, 4.726285489140371],
            [0.07534625252250461, 4.726639510451003],
            [0.06061350650409147, 4.738470049090173],
            [0.05693159532481717, 4.7444901748956525],
            [0.05278631755173963, 4.748955976861646],
            [0.04912635134090064, 4.750991689458211],
            [0.05117112965280955, 4.755512671264003],
            [0.05160800102675188, 4.760362671386102],
            [0.04804453452903704, 4.7635433336337085],
            [0.03886348112605597, 4.763528219767769],
            [0.03427530787956998, 4.766027970321241],
            [0.02833670786005958, 4.781581587720005],
            [0.030240004004017662, 4.7890100632983925],
            [0.034614565343341126, 4.790736886437718],
            [0.03512074596869199, 4.7947317250038894],
            [0.04299040627947745, 4.798914436427521],
            [0.04109283913561137, 4.803021045371369],
            [0.04214883790124725, 4.806179395718862],
            [0.04011858059866498, 4.810393872043078],
            [0.0441460530724492, 4.813257638171741],
            [0.04034754855992956, 4.815413386114756],
            [0.04039527785982082, 4.823006887123196],
            [0.034309033884673955, 4.825262098861548],
            [0.031105725429821405, 4.827982208537955],
            [0.03131650927215039, 4.832415886978624]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.21028062535292,
          "lat": 43.380523997692826
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19119"],
        "coty_name": ["Lyon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lyon County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00465248"
      },
      "bbox": [
        0.02833670786005958, 4.58759987400049, 0.5647055623721441,
        4.832415886978624
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.448579605286028, 2.8582563449140945],
            [2.4760203248247845, 2.8592597568019147],
            [2.553074863965379, 2.861476243225194],
            [2.6104198037599557, 2.8634614270312797],
            [2.674094203645295, 2.8655387884145096],
            [2.716751162133044, 2.866690313274983],
            [2.788137078825251, 2.869310106809241],
            [2.7913231748778493, 2.7821549983091303],
            [2.7943104545556836, 2.700345596245813],
            [2.7964362881846445, 2.629539422659635],
            [2.797527736579605, 2.6075706909260914],
            [2.8008948617627, 2.5197063252806746],
            [2.794026338517643, 2.519265937811537],
            [2.7153296930301245, 2.516670508488759],
            [2.6296426783740374, 2.5140757914490135],
            [2.5655380178794363, 2.512163623523738],
            [2.5446087857698383, 2.511426350301839],
            [2.458957177457179, 2.508865493376293],
            [2.4567402891871866, 2.5819186648910692],
            [2.456147107863311, 2.596762666835755],
            [2.45386649362736, 2.677072577451507],
            [2.4524941475131445, 2.7320440062982225],
            [2.4492157211000443, 2.8411263085547196],
            [2.448579605286028, 2.8582563449140945]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.09942939732535, "lat": 41.33444668908701 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19125"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00465251"
      },
      "bbox": [
        2.448579605286028, 2.508865493376293, 2.8008948617627, 2.869310106809241
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.499984445541556, 3.56509160477013],
            [2.5801189185786817, 3.567282680172379],
            [2.645822183743367, 3.5698623251387245],
            [2.669133285081441, 3.5705976762550846],
            [2.7664137586226305, 3.5745366276473187],
            [2.841311285030106, 3.5771102714738694],
            [2.8430951228253782, 3.5335979001137257],
            [2.8458902969177555, 3.459351352571132],
            [2.8499233467268077, 3.3584894300293886],
            [2.852636150770633, 3.2829842951653645],
            [2.8543024680362348, 3.227737017223491],
            [2.7676867083196637, 3.2248547584449527],
            [2.681547985008007, 3.222181838681941],
            [2.5955130872407652, 3.219698129058899],
            [2.5100367570277697, 3.2172202544828243],
            [2.507580848960569, 3.3049271764088313],
            [2.5051333233798836, 3.389600120615986],
            [2.5026557975175674, 3.4781947348421816],
            [2.499984445541556, 3.56509160477013]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.99877960129353,
          "lat": 42.035832422646244
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19127"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00465252"
      },
      "bbox": [
        2.499984445541556, 3.2172202544828243, 2.8543024680362348,
        3.5771102714738694
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1567833404700893, 3.556408837562362],
            [2.2142966458143714, 3.5578047253252416],
            [2.250762174166556, 3.558549807010926],
            [2.3298642271901215, 3.5607697813787462],
            [2.415486870788971, 3.5630303929470646],
            [2.499984445541556, 3.56509160477013],
            [2.5026557975175674, 3.4781947348421816],
            [2.5051333233798836, 3.389600120615986],
            [2.507580848960569, 3.3049271764088313],
            [2.5100367570277697, 3.2172202544828243],
            [2.4242422192439523, 3.2151724839055524],
            [2.3388753635486474, 3.2129550580452335],
            [2.3243961060369167, 3.212464997063081],
            [2.2231859213353706, 3.2099688008574647],
            [2.1654845680142127, 3.208705448343008],
            [2.163024514376047, 3.3072310442739474],
            [2.1610707106266576, 3.368927632523373],
            [2.1596434167610283, 3.4314071435466196],
            [2.1577951747779496, 3.5089781848892847],
            [2.1567833404700893, 3.556408837562362]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.46503515965112, "lat": 42.03621803054695 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19169"],
        "coty_name": ["Story"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Story County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00465273"
      },
      "bbox": [
        2.1567833404700893, 3.208705448343008, 2.5100367570277697,
        3.56509160477013
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8494146610689427, 0.03873485260853703],
            [0.9204885735595478, 0.0392143005597269],
            [1.013612983400512, 0.039599252398987476],
            [1.0496012666094263, 0.03992809748045692],
            [1.1068004350411353, 0.040197795447426285],
            [1.149656754913643, 0.04083711136022596],
            [1.1926453764929699, 0.04111702783888576],
            [1.1928861978089502, -0.002992899545414498],
            [1.1858487358798642, -0.0030614036359931677],
            [1.187202426635273, -0.07363168367517936],
            [1.186998072113287, -0.0835358146425857],
            [1.187756728056568, -0.14217094592787397],
            [1.1878095330656344, -0.18314370304189226],
            [1.1888297521915199, -0.3109825279395806],
            [1.1352440662424852, -0.3112272053574089],
            [1.1319735504269086, -0.31154066299659894],
            [1.1030249681273374, -0.31164068384257876],
            [1.0768842138008565, -0.31147380395691454],
            [1.0039502248041359, -0.31241453692529714],
            [0.9173113839837819, -0.31286075936201474],
            [0.8853278959997664, -0.3131676055711201],
            [0.8453721041559074, -0.3132225437697124],
            [0.8451913801697317, -0.2691409868046255],
            [0.8448397572001497, -0.22635398882971025],
            [0.8438765757526078, -0.09384362058772959],
            [0.8439060109606135, -0.07438929042732212],
            [0.8434380715580475, -0.041917752620310555],
            [0.8440000103590155, -0.005257711292224388],
            [0.8492707488807077, -0.0052352886860482645],
            [0.8494146610689427, 0.03873485260853703]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.28598306378392, "lat": 38.56454786214022 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20059"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00484998"
      },
      "bbox": [
        0.8434380715580475, -0.3132225437697124, 1.1928861978089502,
        0.04111702783888576
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7134789788142863, 0.9436610845481281],
            [-2.6762485288979576, 0.9419476998054943],
            [-2.6734619427591597, 0.9414604009595414],
            [-2.605706067152881, 0.9386521787322175],
            [-2.4779192589452843, 0.9333822396821552],
            [-2.3919142971395386, 0.9304039112229076],
            [-2.306222072559883, 0.9271265153961159],
            [-2.286554817863615, 0.9262681005895399],
            [-2.28758913877789, 0.8977037665900333],
            [-2.289433519658604, 0.8392011213005487],
            [-2.2897572968385544, 0.8381891863666886],
            [-2.293418422171355, 0.7517825888326674],
            [-2.2985045489314397, 0.6640864353879075],
            [-2.3023689486721133, 0.576114823834187],
            [-2.305500108344938, 0.4877229810233722],
            [-2.391380785663278, 0.49082553759043085],
            [-2.478775325419606, 0.4940620465760307],
            [-2.5039022493268805, 0.4951604989214925],
            [-2.536987287035689, 0.4962923555946788],
            [-2.5914893983766443, 0.4986996919769494],
            [-2.636030349088734, 0.5002025268537984],
            [-2.6505372350129437, 0.5010466513712204],
            [-2.7079140893591234, 0.5035203917867503],
            [-2.722169059606712, 0.5044214037402802],
            [-2.7346546801871905, 0.5048585654605677],
            [-2.7290583870456535, 0.6215372983990125],
            [-2.7282353782944626, 0.6364237340278509],
            [-2.721489846242312, 0.7678772046874898],
            [-2.7164297725757383, 0.8848950948936433],
            [-2.7134789788142863, 0.9436610845481281]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.8832286718325, "lat": 39.34973407355861 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20065"],
        "coty_name": ["Graham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Graham County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00481811"
      },
      "bbox": [
        -2.7346546801871905, 0.4877229810233722, -2.286554817863615,
        0.9436610845481281
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8610649888752293, -0.5209299264662055],
            [-0.7756740509412475, -0.5220572726420678],
            [-0.7331601960095535, -0.522953194529063],
            [-0.6229554605313726, -0.5250084326040599],
            [-0.6041263513542464, -0.5252270506262626],
            [-0.5198161518297023, -0.5251618189130809],
            [-0.4633431500616023, -0.5258718121787228],
            [-0.4339057764181519, -0.5265175728820297],
            [-0.43483048207495684, -0.6142922335149247],
            [-0.4358175361013859, -0.7024720156282643],
            [-0.4366323579401937, -0.7909603705439012],
            [-0.5084028352696293, -0.7904260524910035],
            [-0.6015166639453875, -0.7893304012461188],
            [-0.6940750065324348, -0.7878499326498836],
            [-0.772710208219931, -0.7864882211905891],
            [-0.8657905483069686, -0.7847950433186007],
            [-0.8659110042884077, -0.7859360869567094],
            [-0.864833910041361, -0.7261479997682297],
            [-0.8644659563054318, -0.6968015197280456],
            [-0.8640027114101093, -0.6821791692059276],
            [-0.8630864987792981, -0.6310652770546059],
            [-0.8625466003381389, -0.6088848240538712],
            [-0.8610649888752293, -0.5209299264662055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.42719923277453,
          "lat": 38.043225175032646
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20079"],
        "coty_name": ["Harvey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harvey County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00485005"
      },
      "bbox": [
        -0.8659110042884077, -0.7909603705439012, -0.4339057764181519,
        -0.5209299264662055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1903227572311252, 0.28699843501350386],
            [1.1952903959016592, 0.28292231914246435],
            [1.202403103942492, 0.27907816560536386],
            [1.2066919196201003, 0.27986270033712046],
            [1.2119757988315762, 0.2836312156648907],
            [1.2147446925077972, 0.28925532002807414],
            [1.215372424373797, 0.29342877618471436],
            [1.2134771004140599, 0.2975480609216098],
            [1.216655921574188, 0.30493832275084776],
            [1.2246389549183887, 0.3062143748233925],
            [1.230671455015348, 0.304383189769344],
            [1.2367239223212174, 0.3012017384686895],
            [1.248641162534127, 0.2979875411946213],
            [1.2554615116556624, 0.29077402905385985],
            [1.2606690666422766, 0.28775198020954446],
            [1.2670900482306453, 0.28765155460796976],
            [1.2734317663013888, 0.28998521293123947],
            [1.2793138526901968, 0.29587451233508605],
            [1.2805119886654976, 0.30061328254759095],
            [1.2858277085317158, 0.30718135030190796],
            [1.2924100794564612, 0.30879541141029465],
            [1.297306929435137, 0.30503336955055377],
            [1.2979282775347003, 0.3013085917945256],
            [1.294482897499672, 0.29477093105396335],
            [1.2956484974256934, 0.2895579329839217],
            [1.2999487900017288, 0.29257549314037096],
            [1.3037647125710623, 0.297583932717117],
            [1.3143296525715158, 0.313725964876047],
            [1.319124828352911, 0.32274296700727867],
            [1.3190971793938002, 0.3268834096645602],
            [1.3169387581928225, 0.33352924459720146],
            [1.316868266638549, 0.3373945313784818],
            [1.3206644082158663, 0.3483829384924201],
            [1.3224587058818917, 0.35766380928486047],
            [1.3278740544324914, 0.36424007180639084],
            [1.331464778901062, 0.3664857324538528],
            [1.3383414009954306, 0.3681165419891716],
            [1.3517924351911574, 0.3687704479944205],
            [1.3564044793149388, 0.36741711150586315],
            [1.364106194961832, 0.3629578924433041],
            [1.370981567793805, 0.35778443952838956],
            [1.3842642458960244, 0.35117746160769303],
            [1.395849449293385, 0.3515968700545026],
            [1.4185502634998777, 0.35179188393102867],
            [1.4418203339967615, 0.3523973655935176],
            [1.5348687633870444, 0.3538001599875658],
            [1.5351613805201714, 0.290918226034501],
            [1.5360999149105088, 0.24555737228883517],
            [1.5373833832002781, 0.15503570637245678],
            [1.5379886641176557, 0.13520492674117787],
            [1.5378567083907875, 0.0448661704516648],
            [1.464289687581998, 0.0438712702627728],
            [1.4500130510140243, 0.043895196042067035],
            [1.4213683715142131, 0.0433887266095331],
            [1.3400572852184633, 0.042594280294663556],
            [1.335404108284309, 0.042407611971593505],
            [1.278211316092141, 0.04175387311470904],
            [1.263204295636822, 0.04185752464347336],
            [1.2212843772117252, 0.041237307070039114],
            [1.1926453764929699, 0.04111702783888576],
            [1.1920733543450281, 0.11466775590427582],
            [1.191401155421248, 0.2027730954494365],
            [1.1904223603147637, 0.2619205407091612],
            [1.1903227572311252, 0.28699843501350386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.82230626343238, "lat": 38.88375458247166 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20091"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00485010"
      },
      "bbox": [
        1.1903227572311252, 0.04111702783888576, 1.5379886641176557,
        0.3687704479944205
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.062349816739646, -1.5600394396643644],
            [8.116122244392102, -1.5029395714438234],
            [8.164700169865904, -1.4512425440821581],
            [8.163604983210163, -1.4466491262321497],
            [8.163364833677788, -1.4386833661085432],
            [8.159935103440532, -1.438499007507947],
            [8.158590536012674, -1.4355900996959414],
            [8.160155031230858, -1.4311799840103816],
            [8.168163679920905, -1.4325230892124232],
            [8.171675769693593, -1.4318229085454348],
            [8.172704530918322, -1.4270819777550492],
            [8.175309524050409, -1.4259807881090543],
            [8.180831791165224, -1.4271725761736134],
            [8.180549476124634, -1.4234838080198984],
            [8.185291252699033, -1.4155583474956428],
            [8.18829489081676, -1.4139893593352242],
            [8.189843333010309, -1.4085743910268695],
            [8.194459842295773, -1.409058927881376],
            [8.198175005711535, -1.4148418622799974],
            [8.20147077671229, -1.416439581166362],
            [8.204895749810216, -1.4126487406020694],
            [8.207914583016631, -1.4058595043878965],
            [8.204045621566278, -1.4013501469602991],
            [8.201014072962135, -1.3922100317928],
            [8.203849617570876, -1.3865194415555073],
            [8.207093929857422, -1.3837759100934393],
            [8.214766293822631, -1.3938339611691142],
            [8.218269270970746, -1.3964587474166015],
            [8.224827625594525, -1.3922427243689879],
            [8.22556908191946, -1.389606565698236],
            [8.231517334706714, -1.3815471092213298],
            [8.234535397604773, -1.3822517417181739],
            [8.239582942395954, -1.38580312308268],
            [8.240426636693678, -1.3915699347402488],
            [8.23759323447009, -1.3954210600426133],
            [8.231626727384095, -1.398496076407034],
            [8.229236973244127, -1.4033764420586847],
            [8.235564138258173, -1.4080710307189876],
            [8.244474313060362, -1.4091571483865282],
            [8.250873477517416, -1.4033398376715653],
            [8.247566197203305, -1.398058592345837],
            [8.248100069545782, -1.3881532724147523],
            [8.250469736279767, -1.3848329407906455],
            [8.258903870541989, -1.3816677716085115],
            [8.25989016119397, -1.3839144263228307],
            [8.257131418111788, -1.3937065950978365],
            [8.256215980176757, -1.4007869151012218],
            [8.262157002164018, -1.407679166812393],
            [8.26305961084447, -1.4110457185705298],
            [8.256680303734866, -1.4136430066425163],
            [8.253985462940946, -1.4172986048368765],
            [8.258932476105556, -1.4220568460759795],
            [8.262143281702686, -1.4192870783727536],
            [8.268134186781413, -1.416939913291235],
            [8.271616841228028, -1.4175369665344144],
            [8.280578974517047, -1.4312096909620922],
            [8.282387285637286, -1.4365812233627264],
            [8.286142879928484, -1.4397725498733016],
            [8.286200926189498, -1.4435690435630422],
            [8.289264857584145, -1.4465259751198591],
            [8.294029302611998, -1.4468847443068988],
            [8.295997859291488, -1.4431433076225972],
            [8.294650578846177, -1.4400041762964693],
            [8.289229437077752, -1.434890574037842],
            [8.285602769684028, -1.428815981014608],
            [8.285718039428247, -1.424034199523826],
            [8.289089626604019, -1.4152435659521696],
            [8.292621286512368, -1.4098955755823914],
            [8.29976856330555, -1.4101091603237335],
            [8.30737101294206, -1.406753767246999],
            [8.313753047765923, -1.4065650924909567],
            [8.318913010105941, -1.4109696368832039],
            [8.316384931946716, -1.4139881623965593],
            [8.308923344308749, -1.4168008993266892],
            [8.31089293636663, -1.4278333243150862],
            [8.316510902120985, -1.431263521371797],
            [8.315345473956965, -1.4372648370941765],
            [8.312005566628674, -1.4367074974233394],
            [8.311639231513762, -1.4425082648060548],
            [8.313748183377147, -1.4447808515830654],
            [8.312741203315124, -1.454588361219995],
            [8.318502870103151, -1.4644853522870247],
            [8.329872974640672, -1.4725646294718426],
            [8.33293432669156, -1.4774718539004457],
            [8.327188582398056, -1.4825289677157767],
            [8.325531907669205, -1.4855737086970187],
            [8.324757907843576, -1.4961594135215077],
            [8.322553470638965, -1.5007826521033722],
            [8.324243939619922, -1.5030258144420396],
            [8.334753525712305, -1.4985013711958042],
            [8.341790425374466, -1.4990339714841574],
            [8.342134831242623, -1.5024614623745303],
            [8.339549536580613, -1.5056699892451053],
            [8.339506477645527, -1.5129245022074644],
            [8.343378702718033, -1.51183477750866],
            [8.350061600864825, -1.5154850030057683],
            [8.349708773333719, -1.5186051950138402],
            [8.352894476160518, -1.5203110303504714],
            [8.35473244407626, -1.5256019054746355],
            [8.351817968937862, -1.528249673367818],
            [8.34502687872439, -1.5281252384385864],
            [8.34099084106813, -1.5327048556479206],
            [8.342484824333065, -1.5349804812089578],
            [8.35133342873616, -1.5390963760770997],
            [8.354813013397159, -1.5460960765652012],
            [8.356938695307042, -1.546127209809777],
            [8.359554168514832, -1.5413309500125725],
            [8.37865693291065, -1.5434171350175419],
            [8.38258629474954, -1.5446597870724206],
            [8.390258102294641, -1.553464552640892],
            [8.399742880073394, -1.5602501959686055],
            [8.406454184021957, -1.578661355846108],
            [8.40676157246, -1.5855755311146682],
            [8.41980959697415, -1.6093573221953963],
            [8.428451165676192, -1.6292995219361879],
            [8.434679225094936, -1.6376547812294795],
            [8.43481700578664, -1.6484197319218963],
            [8.431219222831796, -1.6494731316085303],
            [8.42644059490275, -1.6563019666790915],
            [8.419618096169078, -1.6728661798111142],
            [8.37211147862975, -1.676005590232404],
            [8.332871011733475, -1.6765917441801195],
            [8.23459774690345, -1.6807933546532998],
            [8.16453832926142, -1.6823496658933685],
            [8.132805069859938, -1.6821224527939969],
            [8.112122945906595, -1.6831472266105498],
            [8.099542329131689, -1.684468746409321],
            [8.070686547542557, -1.686589532974843],
            [8.067716005520523, -1.6763324515833442],
            [8.065397138608146, -1.6720279813115584],
            [8.067701575395068, -1.6646754137708244],
            [8.061849087545749, -1.659361995901036],
            [8.064189070953345, -1.65646480935454],
            [8.063845466013575, -1.6438042402107593],
            [8.066002849879855, -1.6413726929313217],
            [8.06313169921467, -1.636028514393494],
            [8.065828602311564, -1.6314396107972102],
            [8.065877778690282, -1.625172024176586],
            [8.061484717607744, -1.622779370156577],
            [8.065019724697862, -1.6200176804319577],
            [8.065752221679519, -1.6158729089843111],
            [8.06137440649307, -1.6140122906293675],
            [8.064460926336594, -1.6088442059871462],
            [8.061335048844882, -1.606617500385329],
            [8.062390440397708, -1.6017543264203946],
            [8.059741188683802, -1.5993464569098206],
            [8.06354895506215, -1.5962020429974961],
            [8.061956063459219, -1.5896277580318552],
            [8.062349816739646, -1.5600394396643644]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.19042754808956,
          "lat": 36.751254029527146
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21003"],
        "coty_name": ["Allen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allen County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00516848"
      },
      "bbox": [
        8.059741188683802, -1.686589532974843, 8.43481700578664,
        -1.3815471092213298
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.521387749114302, 0.6886994353885894],
            [9.526524122591287, 0.6794306368375216],
            [9.529494118556956, 0.6758202928236896],
            [9.537509737300892, 0.6686326625725476],
            [9.543499447095808, 0.6662060497750392],
            [9.549248389295395, 0.6652261801565658],
            [9.582510864552221, 0.6632688071044317],
            [9.599141894113938, 0.6598346388562661],
            [9.614878125787437, 0.6549279598186332],
            [9.620539169104752, 0.6521045542328197],
            [9.63215274304191, 0.6494945163607061],
            [9.650254516793742, 0.6469208691702862],
            [9.664558832024625, 0.649643375952719],
            [9.670929932601883, 0.6496309941365347],
            [9.686732917939302, 0.6561995658897142],
            [9.69911393492865, 0.6629544291867568],
            [9.707052873852021, 0.6657491752327688],
            [9.719130396095734, 0.6725680037143897],
            [9.73187672972334, 0.6744748275855089],
            [9.738599594425896, 0.6740975759021972],
            [9.746253188923983, 0.672471658004446],
            [9.759296888305638, 0.6649420076883767],
            [9.760807652711259, 0.6620600035958462],
            [9.76853276527202, 0.661116066524655],
            [9.77891356670915, 0.6609033175538619],
            [9.757157015677958, 0.5752278881602226],
            [9.748552294501051, 0.5407966173276586],
            [9.733942893775925, 0.47760326637698464],
            [9.733442045526328, 0.47072217471596123],
            [9.731547437333456, 0.4669303587884574],
            [9.72621345570501, 0.47242337385208855],
            [9.723321502588892, 0.47209918121660743],
            [9.721682830404914, 0.4669386126403898],
            [9.714428550778054, 0.4652178906916697],
            [9.715779318529737, 0.4720689539177414],
            [9.713455008829229, 0.47577432519089286],
            [9.708566038654038, 0.4723325480126819],
            [9.71079692069589, 0.4649714845977679],
            [9.707532110621907, 0.46280838747564723],
            [9.702986133141863, 0.4627326015237507],
            [9.703366591632639, 0.4705942957398481],
            [9.698565343570449, 0.4757401673603251],
            [9.692195307084628, 0.47303733221095406],
            [9.692124738537682, 0.47876554795163234],
            [9.687782376373926, 0.4808037352181171],
            [9.684644711984436, 0.4771188766620111],
            [9.686049658840723, 0.47467466069011477],
            [9.683772330419458, 0.468851395945835],
            [9.68076687195936, 0.4706314768225089],
            [9.682126856243192, 0.47481213214357715],
            [9.678494867574154, 0.4761192703019517],
            [9.675810679621241, 0.4741276221371992],
            [9.672684936058628, 0.47879943236053724],
            [9.669734261751724, 0.4744987550565908],
            [9.667028330598418, 0.4738531994114938],
            [9.666043805206206, 0.4783138844183586],
            [9.6623419055879, 0.483274664977017],
            [9.660843880001643, 0.48040012575324137],
            [9.663235022181809, 0.47606581700153194],
            [9.662856800047658, 0.47271668263590977],
            [9.657573875811797, 0.4697133708472499],
            [9.654600398380973, 0.46581969218658686],
            [9.654165145405512, 0.4620950665447465],
            [9.648200367826021, 0.45921942007619987],
            [9.650470063786043, 0.45470556790179223],
            [9.64665789608063, 0.4526383700010719],
            [9.64560891773359, 0.44788817799815756],
            [9.642475225697499, 0.4430397708804698],
            [9.636316644741576, 0.44128788104398725],
            [9.6348237122919, 0.4393998321784695],
            [9.63728530930203, 0.4353228686326246],
            [9.627991946803045, 0.4240791719936683],
            [9.62033502044399, 0.4186259185116817],
            [9.614443952193735, 0.4192818068733712],
            [9.612987633513193, 0.4219222835858034],
            [9.60802853697927, 0.4214467660692066],
            [9.603352157240398, 0.42564118507197507],
            [9.599093660439465, 0.4237977201758086],
            [9.593960530430726, 0.42408593972706204],
            [9.586829007562663, 0.4171879681315417],
            [9.584052827991052, 0.4179066847810962],
            [9.580354742067138, 0.41465686502650034],
            [9.570559053087145, 0.41344716810979915],
            [9.56454004585752, 0.4210694129707029],
            [9.566668099122039, 0.42512091325659895],
            [9.574539130178286, 0.42727053586620656],
            [9.575669925007947, 0.4332799161720834],
            [9.571253027698203, 0.4452560879649111],
            [9.57068093707834, 0.45034882587028324],
            [9.577593604270257, 0.4548909344227625],
            [9.571822197429132, 0.46752813393741216],
            [9.567751030268946, 0.46065548306918835],
            [9.555464123310955, 0.516295799522263],
            [9.535919702304948, 0.6052654811659709],
            [9.517774342442252, 0.6831194703102498],
            [9.521387749114302, 0.6886994353885894]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.09019667599185, "lat": 38.68876014291336 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21023"],
        "coty_name": ["Bracken"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bracken County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00516858"
      },
      "bbox": [
        9.517774342442252, 0.41344716810979915, 9.77891356670915,
        0.6886994353885894
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.42396590597139, -0.3995546035675699],
            [9.425608669262221, -0.3967624359802286],
            [9.425762188866047, -0.3906659901633469],
            [9.434350423296976, -0.38512001944262153],
            [9.44510986239145, -0.3809638960312774],
            [9.452087596957574, -0.3682749790480206],
            [9.453552029757995, -0.36275196930159853],
            [9.458350183751683, -0.36232010130531384],
            [9.460860985007345, -0.36682381968513283],
            [9.46568968930471, -0.36713752352267687],
            [9.469246650971565, -0.3595267393459008],
            [9.467564578600074, -0.3548743635876542],
            [9.458108062326751, -0.3416490496071475],
            [9.454414113487022, -0.3391480365761567],
            [9.44884720890557, -0.33037459894733323],
            [9.446772983723378, -0.3244167325924889],
            [9.447512395743402, -0.31835838964483193],
            [9.450372681226636, -0.31301013206623535],
            [9.453540982231274, -0.31049697698950046],
            [9.457740703662484, -0.31330549689493664],
            [9.462825260290717, -0.3189865666102606],
            [9.47030253529934, -0.321885994009013],
            [9.476524738735648, -0.32103258305870125],
            [9.480453383155194, -0.31841211597186425],
            [9.484316500152953, -0.31315740755814275],
            [9.489091684932937, -0.30627092994140714],
            [9.492670670796945, -0.2896346770936789],
            [9.495309484610036, -0.286808861207398],
            [9.500803009803002, -0.2866638828736537],
            [9.508097391895703, -0.2981918341301882],
            [9.512719948469988, -0.3020789625476923],
            [9.517432845857137, -0.30880346203643644],
            [9.523675724553682, -0.3096505893071748],
            [9.528834779440581, -0.30285638544183136],
            [9.53503408101916, -0.2999230730767119],
            [9.537242620632123, -0.2949122522843734],
            [9.536119117874172, -0.2903835310019959],
            [9.529741395555968, -0.2780716184936672],
            [9.5246248773919, -0.27079929561833427],
            [9.5227373051936, -0.2659797973172991],
            [9.519041789801395, -0.2614841128375301],
            [9.518663625044677, -0.2580337373093467],
            [9.5219504561957, -0.25325912282470986],
            [9.527032218816252, -0.25362340097688973],
            [9.53394219472986, -0.2569306919471588],
            [9.53765492353067, -0.26011315037063126],
            [9.545980123397523, -0.2648375606548342],
            [9.549309177725023, -0.2693528707871239],
            [9.553425592643345, -0.26929622262564595],
            [9.554801006124102, -0.26572322146340166],
            [9.555093537927325, -0.25888131506405404],
            [9.559477125444637, -0.25392981368186257],
            [9.57674901243017, -0.24406243749493067],
            [9.582345139052407, -0.2427567246911828],
            [9.594517842550815, -0.2321243562343886],
            [9.602322011352898, -0.22705416601499634],
            [9.605683798287618, -0.2308773346774851],
            [9.605206105359155, -0.23751714977087118],
            [9.611299874364063, -0.24424012956335028],
            [9.61369101320903, -0.24869740326858145],
            [9.613575609944021, -0.256446261281475],
            [9.612071663375444, -0.25960217156427245],
            [9.613325755704105, -0.26561398728997593],
            [9.616524721674281, -0.26758377371161046],
            [9.62238693664966, -0.25973169993981043],
            [9.633006541810216, -0.25399111523840634],
            [9.63697678454434, -0.2546185445655656],
            [9.641872883271926, -0.2582342225406741],
            [9.646404326791078, -0.26682949461849265],
            [9.653064647061708, -0.2698188003736104],
            [9.660910243822185, -0.26765904325778417],
            [9.665850444809676, -0.2623451174113534],
            [9.673447702934272, -0.2571893729747939],
            [9.67831484008705, -0.2574909374202196],
            [9.685533387908842, -0.26019087249181844],
            [9.690134399755438, -0.2716137729981676],
            [9.695119494301274, -0.2726964670843345],
            [9.701634570680099, -0.26740559496200333],
            [9.706000077770366, -0.2654621552412747],
            [9.716119305248743, -0.2633308571441523],
            [9.720433890327305, -0.2635891831061],
            [9.72669567394953, -0.26977531723858406],
            [9.731831812467831, -0.27689130600189577],
            [9.736545299432617, -0.27905379979192757],
            [9.738693262413534, -0.278192329428352],
            [9.742622643635961, -0.2701450254523474],
            [9.746611063063673, -0.2664918959676493],
            [9.752071272125065, -0.2661929877799843],
            [9.759354956370121, -0.2730378187638759],
            [9.7590016318944, -0.2809255828592288],
            [9.757218961561621, -0.28617414381606315],
            [9.753894449889401, -0.29117513686496455],
            [9.751963567003036, -0.2915598127359048],
            [9.744433683533796, -0.2878982263811993],
            [9.742662393282032, -0.2896945930607862],
            [9.741660790545456, -0.2993774800262319],
            [9.738028778049813, -0.3074511841397052],
            [9.732902225281597, -0.3126866123974366],
            [9.732875100423337, -0.32249297546951716],
            [9.73703958946334, -0.32532419178892447],
            [9.73965155406623, -0.3240524104245237],
            [9.749477756646247, -0.31240964557525164],
            [9.754493182360358, -0.313003590383005],
            [9.760105566503746, -0.31658148168067907],
            [9.76764457640138, -0.3169349262904271],
            [9.77032382677207, -0.32078325856530204],
            [9.770907676801881, -0.3244551568727051],
            [9.768220422481317, -0.32849278594424286],
            [9.754654756288655, -0.34292842547533553],
            [9.74705523715377, -0.34478239065046545],
            [9.74623375326113, -0.34996026923756507],
            [9.748267729524184, -0.35303557947284686],
            [9.757199476525196, -0.35589105797241777],
            [9.76367172106204, -0.35587588752928284],
            [9.768969601767902, -0.3591613391382517],
            [9.764910571424924, -0.36570225546945956],
            [9.764476977706302, -0.370935366399006],
            [9.766955355346157, -0.37421488198595354],
            [9.771916277334167, -0.37729643269087426],
            [9.77202363663138, -0.38402678802181545],
            [9.769253306556456, -0.3882170658051541],
            [9.761551493913997, -0.39283891290761463],
            [9.766798339163508, -0.4030042509913821],
            [9.762980474585476, -0.40607624595116676],
            [9.76190597241084, -0.41029070758083863],
            [9.767221933398222, -0.4136263166013941],
            [9.765189934473586, -0.41692124371331035],
            [9.767529149407768, -0.4209247271242021],
            [9.770428680534629, -0.4325224105192654],
            [9.77066838344599, -0.44112288222235374],
            [9.767586832983252, -0.4448094542543825],
            [9.765660395910222, -0.45018244192297635],
            [9.768768129343597, -0.4525422545559082],
            [9.769687812062042, -0.4572241767783841],
            [9.775894873365472, -0.46043923674712184],
            [9.771274974082592, -0.4663347840106134],
            [9.759247289558678, -0.47346190969398516],
            [9.759389264968, -0.47903445303032643],
            [9.755254823279241, -0.48310290775850795],
            [9.749516181375173, -0.4859609682322675],
            [9.749698398219953, -0.4886390863919643],
            [9.765555325244163, -0.5240710782437406],
            [9.78777731059918, -0.5613944749114879],
            [9.747687342080908, -0.5678457434104146],
            [9.72541152731149, -0.5780544116565253],
            [9.708208484696693, -0.615505380350613],
            [9.698162345177886, -0.6156217694614798],
            [9.695744643034525, -0.6142268491047884],
            [9.68839319146707, -0.613568531827252],
            [9.680769597304444, -0.6220421256602119],
            [9.676726603863113, -0.6184718727707019],
            [9.669848550325183, -0.6183094176130943],
            [9.666199461587626, -0.6204131948020448],
            [9.665350935059411, -0.6248470432238449],
            [9.659632677330807, -0.6289676472285762],
            [9.655212197428924, -0.6295171790780756],
            [9.653659160665667, -0.6255351060844144],
            [9.646815577627907, -0.6223249786683959],
            [9.639836470464921, -0.6222251776548623],
            [9.63592395921923, -0.6242714627009168],
            [9.628291502549096, -0.6248517419666105],
            [9.627257553845146, -0.6204408418659385],
            [9.629473508219077, -0.6128197408188694],
            [9.625000435630806, -0.6110217776921746],
            [9.622840563834872, -0.6136340646204166],
            [9.623214293654259, -0.6178081745227058],
            [9.619089348449817, -0.6210101857807392],
            [9.616322994561477, -0.6197943314303233],
            [9.614812831294806, -0.614955852242591],
            [9.609886279940874, -0.611186348757752],
            [9.60702387840772, -0.6132001369942197],
            [9.6044585576456, -0.6114290174116558],
            [9.599140130209848, -0.6154760991113373],
            [9.5929799986191, -0.612480344674062],
            [9.590603543827397, -0.6135993025932979],
            [9.58735629930261, -0.6110794482969224],
            [9.585767829180234, -0.6060834093366958],
            [9.585897117133017, -0.6003640561227982],
            [9.580339130348074, -0.5964875291590886],
            [9.580153770257587, -0.5941724208574679],
            [9.575708006520413, -0.5904842595573903],
            [9.575747448414477, -0.586691736839061],
            [9.57299535693683, -0.5839670482495881],
            [9.56981865491027, -0.5842051773861],
            [9.56879114409366, -0.5788469317229668],
            [9.566474133128363, -0.5738944515170061],
            [9.567678044108643, -0.5696291429999129],
            [9.565143579812132, -0.5671694759990574],
            [9.562202778970226, -0.5597115397076298],
            [9.5571966404271, -0.5593154555502029],
            [9.553910225023662, -0.5605818274664749],
            [9.55100987885037, -0.5570801731715302],
            [9.544353401372703, -0.5572683712990625],
            [9.542614121976104, -0.551815184629296],
            [9.54115113941479, -0.5418029812699136],
            [9.535685846111782, -0.5397630019864561],
            [9.530855252945575, -0.5414293219873142],
            [9.524900900780608, -0.5414383733105358],
            [9.524779086909314, -0.5375590263923153],
            [9.528227252395135, -0.5359820689240014],
            [9.524901583679176, -0.5303455226461319],
            [9.529023040520578, -0.5282048317610174],
            [9.52807896752117, -0.52549742845911],
            [9.521865231415072, -0.5266684026376616],
            [9.51709247191903, -0.5223186364396387],
            [9.51837385732573, -0.519123123534231],
            [9.523105758710248, -0.5174756384537418],
            [9.509144362339486, -0.507696694574982],
            [9.50239047801183, -0.5062313603185276],
            [9.504907546783679, -0.4989359443860532],
            [9.501787554838108, -0.49879032180389804],
            [9.497656077503049, -0.49048132021544766],
            [9.499668064497982, -0.4835020513682997],
            [9.49542404563772, -0.4821965476457182],
            [9.492882081758795, -0.4871854674624151],
            [9.488745192710102, -0.48645346354421976],
            [9.485140021834658, -0.48057205953058735],
            [9.481655079739962, -0.479659461247687],
            [9.48179765078411, -0.4763298531723907],
            [9.489449165280165, -0.47122636618505587],
            [9.49211715314838, -0.46593624272921647],
            [9.490622196761452, -0.46406286487294496],
            [9.484569792540054, -0.4681739369232038],
            [9.475442530572224, -0.4622333882466429],
            [9.471210981241862, -0.4562936083898659],
            [9.46401642042423, -0.45634600927390084],
            [9.462358267497674, -0.45426519509152635],
            [9.462389515771696, -0.44497494861054465],
            [9.456180269417514, -0.43688378326927413],
            [9.454752276991062, -0.44126178429035506],
            [9.451272855637503, -0.44011542552800864],
            [9.45098744437818, -0.4367892007398803],
            [9.445624267456136, -0.43260537756357653],
            [9.446436053198354, -0.4302820218079635],
            [9.452337540346974, -0.42597960452350164],
            [9.450865312509665, -0.41870233644093846],
            [9.446972853873497, -0.4194697176093793],
            [9.444221212513412, -0.41759177268599296],
            [9.442902825401054, -0.41287136249568307],
            [9.436890313678283, -0.41369449370015104],
            [9.433801687614334, -0.41069345724435724],
            [9.43552818729787, -0.4026562881810462],
            [9.433673085026053, -0.4008614012483164],
            [9.42396590597139, -0.3995546035675699]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.27803150888876, "lat": 37.72016638294785 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21151"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00516919"
      },
      "bbox": [
        9.42396590597139, -0.6295171790780756, 9.78777731059918,
        -0.22705416601499634
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.9893570606505, -0.09535443128286566],
            [9.992147267085619, -0.101295058627546],
            [9.995459828011136, -0.09622666468444886],
            [9.99723068244825, -0.09636883249182594],
            [10.00018860196114, -0.09105183564303684],
            [9.997947704469777, -0.08890969793313944],
            [10.002903927782064, -0.08502685226594457],
            [10.013265741649889, -0.08383484431161309],
            [10.02137493350571, -0.08656037931172265],
            [10.02448973684824, -0.07963315994028033],
            [10.028957127049143, -0.07596055276329221],
            [10.041948979325223, -0.07485701769485299],
            [10.044141973815503, -0.07096327868511138],
            [10.049024281805817, -0.06977705948703822],
            [10.054665119169876, -0.06498527558039469],
            [10.055797297563288, -0.060511481854346225],
            [10.06298603328216, -0.0557083838119957],
            [10.068317373736276, -0.05931582567832858],
            [10.072121322512674, -0.05643974966559264],
            [10.074744579403106, -0.05747781815126297],
            [10.082190695497422, -0.05461987375105775],
            [10.089387486740902, -0.05739521043462064],
            [10.09549641384506, -0.06593330475616518],
            [10.098647960970332, -0.066546986932341],
            [10.104021001456763, -0.07183026494593521],
            [10.105223920582615, -0.06589272276446047],
            [10.111287037913721, -0.06565959253960803],
            [10.121128288429228, -0.06268298886830759],
            [10.126082854024201, -0.06430735899887961],
            [10.12842126514132, -0.062359181522345375],
            [10.127826432057, -0.05620610801046081],
            [10.130427182892078, -0.05201314936788553],
            [10.128568900077235, -0.04953092283595211],
            [10.126375310253618, -0.041211842524306486],
            [10.1284554548576, -0.036032138607193544],
            [10.126889471130008, -0.02872342999875375],
            [10.123153461303595, -0.02431453728408823],
            [10.124158334446491, -0.016505888268526003],
            [10.182586301021008, -0.01884174801097555],
            [10.184112957742427, -0.017015095244320266],
            [10.186387307584294, -0.018158589824532882],
            [10.195804812916393, -0.01965502946859836],
            [10.200678727310168, -0.01699951640889331],
            [10.203403996837814, -0.01761316864748753],
            [10.207461957607421, -0.01451931321113267],
            [10.21105124171914, -0.013859863234833477],
            [10.211025813444284, -0.02248629894420892],
            [10.205675458969932, -0.027033127447786853],
            [10.202072990746748, -0.03323239399264042],
            [10.202161455837917, -0.038353661869255366],
            [10.20591054961041, -0.03945507883338636],
            [10.21456481251533, -0.03221269808440471],
            [10.218926644042963, -0.030472532022329656],
            [10.220787781677636, -0.03400681970594771],
            [10.21624173720059, -0.03916371299683401],
            [10.211391648749919, -0.04281015063105876],
            [10.211519323127812, -0.0453928583238955],
            [10.215976816271576, -0.04706609972085816],
            [10.221583242868416, -0.04577807746951563],
            [10.225732662533623, -0.042971725121840075],
            [10.223756158874119, -0.03513459393498071],
            [10.224306912687176, -0.03246785824841424],
            [10.233278296699112, -0.030598336489552264],
            [10.236501932767133, -0.027022902224731655],
            [10.240631736754867, -0.11969194411974945],
            [10.207486434548676, -0.17689454783274283],
            [10.20722567869972, -0.19331256816001938],
            [10.20456045681873, -0.19439646901654364],
            [10.205450667470295, -0.20029874537788273],
            [10.20959291374565, -0.19972023850413417],
            [10.214132586093324, -0.20310330462261705],
            [10.212025223971436, -0.20555087086828716],
            [10.208921060959867, -0.21111783312934176],
            [10.19637963605621, -0.21798177808203534],
            [10.195971943307843, -0.22186349654373055],
            [10.19115909654894, -0.23286411439764362],
            [10.19166254996715, -0.23715615087641675],
            [10.184614272779228, -0.24619700145637374],
            [10.177044684648925, -0.24790080314752472],
            [10.173678659725686, -0.2516535483476585],
            [10.164396805296445, -0.2543973311509484],
            [10.160189819931126, -0.25337113032909897],
            [10.155221048428189, -0.25601269829420614],
            [10.149833768083548, -0.25583774062673514],
            [10.149427732455676, -0.2517030365740769],
            [10.146763346111852, -0.2512332058754851],
            [10.146099461092664, -0.25732645020384687],
            [10.143921787807212, -0.2588998114662583],
            [10.13726852422975, -0.25598547103215735],
            [10.13468068578619, -0.24809578331573073],
            [10.120842735386166, -0.2444094753296622],
            [10.118245883408024, -0.24546157796348955],
            [10.116084920591437, -0.2567101280420225],
            [10.111411339844286, -0.2560030734010506],
            [10.105890081337328, -0.2555807730866509],
            [10.101907990580616, -0.2566606443619398],
            [10.097486553530603, -0.2495150277503274],
            [10.094456013015948, -0.24811358214447155],
            [10.090744282040733, -0.2517554884941574],
            [10.085004701620468, -0.24929188327533186],
            [10.086080221361085, -0.244529031686205],
            [10.082900116040275, -0.24190528973110065],
            [10.07888683632033, -0.23283994576777098],
            [10.074516559863346, -0.23298334223490966],
            [10.071399912738801, -0.22952708478237788],
            [10.011112656261455, -0.19803198604182254],
            [10.004553024195149, -0.19405642251234745],
            [10.001853649362168, -0.18952453016900242],
            [10.003237280439809, -0.18628953041104998],
            [10.002907363951945, -0.17970441549811078],
            [9.997421270722205, -0.17723997504425257],
            [9.992533200822242, -0.1767699152995802],
            [9.994373363613706, -0.17008218861658253],
            [9.994386273905878, -0.16535075254737883],
            [9.98779110791712, -0.16286234285889295],
            [9.987015935653805, -0.1579355795986044],
            [9.98482613277524, -0.15668332909674224],
            [9.983792043586568, -0.14149262826879555],
            [9.982819249140999, -0.14011349915789842],
            [9.985918147428253, -0.13374267409584742],
            [9.982530645066541, -0.13215461600317466],
            [9.98319648787196, -0.1283804256325889],
            [9.980034436598173, -0.1259403918081107],
            [9.981053738792724, -0.1227630170550011],
            [9.97892268293029, -0.10546591649217454],
            [9.986921875408452, -0.10764034015907623],
            [9.987526370240236, -0.09667593466876606],
            [9.9893570606505, -0.09535443128286566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.59877419974018, "lat": 37.94136220882933 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21165"],
        "coty_name": ["Menifee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Menifee County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00516929"
      },
      "bbox": [
        9.97892268293029, -0.2588998114662583, 10.240631736754867,
        -0.013859863234833477
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.6660263739947, 0.33230565372522686],
            [9.66972704116899, 0.33402631029614427],
            [9.677824486951181, 0.3291360906033908],
            [9.688386006878401, 0.3331158086954732],
            [9.693627683387115, 0.3309976628110472],
            [9.701329550491273, 0.3300444989262984],
            [9.705288768495668, 0.3276328028882499],
            [9.711499037396552, 0.32640767525442604],
            [9.724062734406834, 0.32055608565329474],
            [9.729330415162151, 0.32522539347143653],
            [9.733056777413948, 0.3264945701690144],
            [9.735213885510236, 0.32399639366846594],
            [9.74013852819877, 0.3146895865660086],
            [9.745723018048492, 0.31500005533521985],
            [9.744165923250701, 0.3230187167449364],
            [9.748626348739323, 0.3225710424712887],
            [9.750080508464956, 0.3158351035938971],
            [9.749384945540092, 0.30779309542696526],
            [9.754060211780315, 0.3091715032869759],
            [9.754416497778891, 0.3184581522414124],
            [9.761794804042601, 0.3208533882147074],
            [9.76244790024165, 0.3242160963529035],
            [9.788399368269221, 0.3105980013091588],
            [9.814793278078955, 0.2737413773692045],
            [9.821796996175905, 0.2510626202700672],
            [9.823693763320332, 0.25533031733239214],
            [9.829754383570455, 0.2582596265077175],
            [9.838391692784553, 0.2580275872613126],
            [9.840843977587603, 0.2569418814173356],
            [9.841023163398614, 0.25259744134054746],
            [9.83485944018706, 0.24681371682229838],
            [9.836330875616513, 0.24089693695472209],
            [9.843857262873726, 0.2449770156060487],
            [9.846574962541462, 0.2541334276683655],
            [9.854198124642, 0.25728651263818064],
            [9.85569251570852, 0.25669533851542364],
            [9.858876438977711, 0.24722148495582666],
            [9.86125885315856, 0.24510627053945375],
            [9.864974654730899, 0.2479992269813265],
            [9.868132744680203, 0.2481248618783831],
            [9.86783093554132, 0.24003810904410403],
            [9.870106554097893, 0.23047936673077554],
            [9.876751837325626, 0.2303640426513147],
            [9.87827027141183, 0.23495237043304534],
            [9.883550947290873, 0.23680437943870442],
            [9.882378110942541, 0.23051835582366276],
            [9.878461539351006, 0.22287066101203204],
            [9.880862354650471, 0.2193553118925132],
            [9.883893197550645, 0.21968297644121676],
            [9.888328297110235, 0.21722464714966397],
            [9.890896399948392, 0.2121224220076675],
            [9.886386497612703, 0.2105372348992791],
            [9.88578348458437, 0.20371972222076318],
            [9.881924499783453, 0.1969997696708409],
            [9.882136684374823, 0.19445326201689409],
            [9.880997972158742, 0.1939912712357498],
            [9.839145616377351, 0.1364526695973123],
            [9.795605016945903, 0.0766680666437403],
            [9.790878412790237, 0.07915863005652043],
            [9.800333956736585, 0.08953904361105695],
            [9.80008386255139, 0.09475886616025696],
            [9.7968229563658, 0.09517969200129918],
            [9.792755381010263, 0.09231597409494649],
            [9.791712484419067, 0.09748278722162003],
            [9.793954169659838, 0.10165133063505342],
            [9.792476859778944, 0.10470153456258792],
            [9.784779997813427, 0.10390021794375155],
            [9.783546012379908, 0.10229185848386381],
            [9.783999727386052, 0.09094155225864023],
            [9.775862237971461, 0.09070936061561424],
            [9.774951155816188, 0.09671343180637697],
            [9.770479189526236, 0.09691653459668932],
            [9.768752436431775, 0.10147757652527424],
            [9.765313850281657, 0.09870439267804564],
            [9.753483107103378, 0.09365391731016089],
            [9.754028032569494, 0.09774252262533234],
            [9.748309927446176, 0.10276957570011809],
            [9.745519350934849, 0.10159602927976072],
            [9.73930035335781, 0.10360952662545789],
            [9.733075787265003, 0.10754448478127873],
            [9.724703978305511, 0.1115395277224389],
            [9.724938249097063, 0.11301849711380689],
            [9.73153552602349, 0.11673028148035025],
            [9.731351074560642, 0.12126079569073851],
            [9.726709054893691, 0.1266815871974891],
            [9.72619376908936, 0.1337392976243282],
            [9.717394875098062, 0.13101408827667063],
            [9.713868165472768, 0.13277573267046225],
            [9.710442227489358, 0.13106729841606438],
            [9.708033148772012, 0.13385664972789327],
            [9.708925727703551, 0.13843836228848347],
            [9.712328330339535, 0.13944051611775887],
            [9.7099518993355, 0.14395399227187805],
            [9.705992993026072, 0.139620765882837],
            [9.703300464605551, 0.14029716624464955],
            [9.703592878144994, 0.14433802220970576],
            [9.699639883232049, 0.14687293956042077],
            [9.695100016049404, 0.14082853845696205],
            [9.698568227505726, 0.13860887983434403],
            [9.698389031533639, 0.13400220394014528],
            [9.696516174524016, 0.1322203453232582],
            [9.690609154679805, 0.13121219123591427],
            [9.691014787840254, 0.1365332600414229],
            [9.688725883652872, 0.1422928298314822],
            [9.683795072610097, 0.1469191369457753],
            [9.681404685418393, 0.14449957898932664],
            [9.676872922216566, 0.1435055474416855],
            [9.675258173901849, 0.14634163755677915],
            [9.678476573321202, 0.1504273031592891],
            [9.685993962042085, 0.15478315294438635],
            [9.686348867887395, 0.1581457212138991],
            [9.676338241360417, 0.159480107786067],
            [9.67421677622255, 0.1659448697872249],
            [9.66892871189225, 0.166966916112648],
            [9.664847166303607, 0.1737281149207917],
            [9.662014401509978, 0.1742263803217417],
            [9.629765767214595, 0.2214398265088267],
            [9.606239625501816, 0.23563308233711291],
            [9.614595431990216, 0.24889571303081098],
            [9.6660263739947, 0.33230565372522686]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.01524475670817, "lat": 38.33553696826969 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21181"],
        "coty_name": ["Nicholas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nicholas County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "00516937"
      },
      "bbox": [
        9.606239625501816, 0.0766680666437403, 9.890896399948392,
        0.33402631029614427
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.240884708180056, -0.7390050400424346],
            [10.249607478410253, -0.7423087962909433],
            [10.252604404766249, -0.7378367168365287],
            [10.257766345966736, -0.7350280239040707],
            [10.264327186324186, -0.7286049876080993],
            [10.26752252790665, -0.7293347155143673],
            [10.273994646834392, -0.726849643732043],
            [10.27395030617785, -0.7203596082281336],
            [10.276197520989223, -0.7161687026922546],
            [10.280640252486494, -0.7143973887626858],
            [10.281317959262484, -0.7093373890444877],
            [10.285198595888025, -0.7081697579181715],
            [10.284064723357035, -0.7028993565491181],
            [10.286341665338435, -0.6990381013770838],
            [10.285019496862372, -0.6950800461486839],
            [10.287962632330135, -0.694110667420431],
            [10.2904388761718, -0.6894751972596992],
            [10.301845454635394, -0.6916437748941887],
            [10.305968163471983, -0.6866557654717287],
            [10.313511566916803, -0.6863273918646424],
            [10.315820234145596, -0.692356253810908],
            [10.3200268023885, -0.6933791281696339],
            [10.327735163472441, -0.6985808838604881],
            [10.327921604019862, -0.7012777733174121],
            [10.333064868115141, -0.7037420244262855],
            [10.332263028925851, -0.7063096566906185],
            [10.338030454395147, -0.709413790001058],
            [10.340156423686029, -0.7058650687337127],
            [10.342931176656881, -0.708028833255171],
            [10.343322868211038, -0.7123821773947611],
            [10.347158571242174, -0.7141905981388634],
            [10.351303068445754, -0.7197795704338916],
            [10.363290198061934, -0.719919714145862],
            [10.36539005767632, -0.7177325532251418],
            [10.370100627516864, -0.7178696743588515],
            [10.373516531332825, -0.7080141762371593],
            [10.378149456243623, -0.7085125361386355],
            [10.379926788636439, -0.7035920526504945],
            [10.377937548224741, -0.700927236503434],
            [10.377741116929112, -0.6967493829040161],
            [10.38286745546846, -0.6944930681713606],
            [10.386262763696894, -0.6956463573737444],
            [10.388047342293829, -0.6923952445057897],
            [10.39342352485459, -0.6907210128719301],
            [10.398161950964614, -0.6806559765890254],
            [10.397342010594059, -0.6792183809701937],
            [10.402935728882907, -0.671310003136585],
            [10.406747735633846, -0.6696771807199482],
            [10.410838818410861, -0.6713910231904425],
            [10.413348531083422, -0.6686336476567807],
            [10.420145100807513, -0.6710871746348375],
            [10.425163549169884, -0.6673250664941182],
            [10.425249368285339, -0.6618670777498427],
            [10.429655125618217, -0.6578710464787316],
            [10.439890938270569, -0.6526378268958777],
            [10.443510982236788, -0.6468484631733796],
            [10.44906529051557, -0.645703966317896],
            [10.485924525645288, -0.5951230587779904],
            [10.488098181566016, -0.5962869761983964],
            [10.48906199938313, -0.6006928554937047],
            [10.491806788998984, -0.6014553534402874],
            [10.497394902492266, -0.6069274074883141],
            [10.495324676407732, -0.612167048037476],
            [10.499874450201881, -0.6155399642636161],
            [10.501527889663013, -0.6224353822783829],
            [10.508606930449515, -0.6247498365432195],
            [10.51315379121709, -0.6220463649703399],
            [10.514966500586294, -0.6259639939188755],
            [10.526067084393084, -0.6256799828250338],
            [10.52902202505616, -0.6227076526637806],
            [10.531458895888349, -0.6240905076833458],
            [10.544762220813295, -0.6240586798332095],
            [10.548121961227533, -0.6267237686810283],
            [10.552143771610874, -0.6249146684489488],
            [10.554658028259595, -0.6216210935619289],
            [10.561604608248455, -0.6241424476816367],
            [10.579807570662489, -0.6853147626837337],
            [10.582287505579517, -0.6914046122216372],
            [10.58221823016819, -0.695806195746374],
            [10.577814810667334, -0.6998512463184678],
            [10.584177592932733, -0.706867658729881],
            [10.580865031154868, -0.7180877811291657],
            [10.581161307202049, -0.721093275241146],
            [10.585550033679148, -0.7219345147739018],
            [10.586907416191249, -0.7287236379131855],
            [10.5833895643538, -0.7330514117702531],
            [10.580280468576056, -0.7336099010800727],
            [10.578552616901561, -0.7411039466278307],
            [10.581679257697779, -0.744858742047137],
            [10.578572023310876, -0.7487072316630342],
            [10.57949825539421, -0.7533081865924495],
            [10.577964505021841, -0.7610843544352401],
            [10.579524980698228, -0.764970140010001],
            [10.58355483045429, -0.7697431393423825],
            [10.580737260899294, -0.7732514381323056],
            [10.585095931868853, -0.7771073208969128],
            [10.58624069370979, -0.7818383980377092],
            [10.58232266638878, -0.7919469168241347],
            [10.590126690664226, -0.787689529026913],
            [10.597777909971727, -0.7912832361234876],
            [10.602525641489084, -0.7913250243622975],
            [10.609450953933534, -0.787303667877832],
            [10.609679635666762, -0.783521320962616],
            [10.616133785734787, -0.7818686804980927],
            [10.615723160680187, -0.7769986969040735],
            [10.625111180521067, -0.7749041908298124],
            [10.628785704235986, -0.7786059017982997],
            [10.62758730282394, -0.7818078475264363],
            [10.629697914581005, -0.7916893005500905],
            [10.639375564844705, -0.7991096040876763],
            [10.642130736309047, -0.8059003252864437],
            [10.643713248168078, -0.8067188319923809],
            [10.650439759608284, -0.804894660281932],
            [10.652707611738906, -0.8026717253199765],
            [10.658654061327118, -0.8026016765027272],
            [10.659948644769704, -0.8083949839649819],
            [10.66292069375157, -0.810720214465156],
            [10.668989370681462, -0.8082254586835074],
            [10.673925965453078, -0.8088250087247176],
            [10.674965426054035, -0.8129105406290621],
            [10.681134001518938, -0.810771004165759],
            [10.683991226425334, -0.8167160589861262],
            [10.687221221249235, -0.8202004507628038],
            [10.680850149515067, -0.8273691816445724],
            [10.676754380522633, -0.8402118355875332],
            [10.673255036498453, -0.8400934751138002],
            [10.672516560943754, -0.8438138202490091],
            [10.668923285795426, -0.84908393229084],
            [10.664912680736277, -0.8503958335877548],
            [10.661581230957779, -0.8545441927822751],
            [10.664782967161136, -0.8624898794195955],
            [10.654284169106162, -0.8918847591457348],
            [10.651180691316869, -0.8981480769937737],
            [10.650859751853334, -0.9071962045533424],
            [10.656846726235427, -0.9134052377583298],
            [10.657302352218366, -0.9180843583480327],
            [10.663323462080694, -0.9182138422858913],
            [10.663666848137902, -0.9224324626450533],
            [10.66109357030942, -0.9235230293586753],
            [10.661541382473786, -0.9291152345893726],
            [10.664628643282645, -0.9300208130685342],
            [10.664899455902688, -0.9335594713231232],
            [10.67134113800538, -0.9402423595327842],
            [10.669766223250928, -0.9454058042716109],
            [10.670320572223993, -0.9495628280120595],
            [10.667985815155461, -0.9516377673055998],
            [10.67224775066909, -0.958301613476166],
            [10.66802555489901, -0.9625307307005513],
            [10.66488250781867, -0.9606514691240757],
            [10.660496110833275, -0.9606411267426681],
            [10.661461127178645, -0.9648131826765597],
            [10.65813480507531, -0.9682972762625086],
            [10.657365087080139, -0.9718101884328246],
            [10.653142761847832, -0.9728620805600883],
            [10.650402526575014, -0.9773517172404603],
            [10.652137765307474, -0.9813786607213748],
            [10.655987311163376, -0.9800131378675196],
            [10.657625091265405, -0.9842989104095037],
            [10.665142205644612, -0.9870446724595295],
            [10.668524174882322, -0.9864283748821715],
            [10.6694688826527, -0.9924750204501445],
            [10.665262600860624, -0.9971762551264435],
            [10.669141568283326, -1.0034485252336034],
            [10.666510366445499, -1.0068058548581527],
            [10.660659295708921, -1.0081085069390185],
            [10.658441259388578, -1.0125399480888373],
            [10.655658515178407, -1.0117866872288257],
            [10.651267392550107, -1.0156358151183982],
            [10.647388417810195, -1.0232039985273498],
            [10.644124042145267, -1.0232731827933634],
            [10.641189260362433, -1.0278802729391991],
            [10.63740275213153, -1.0270677911324233],
            [10.634097312995387, -1.0336182400313148],
            [10.628459548370955, -1.0355685058074717],
            [10.625269911182798, -1.0299443170059177],
            [10.620781249688354, -1.0308590197185221],
            [10.618465680257474, -1.0280334974612912],
            [10.616062706332826, -1.0235468477432648],
            [10.606585265545409, -1.0264394955195066],
            [10.601656100363344, -1.024550090722576],
            [10.599288246910687, -1.0176976008784595],
            [10.594682101107551, -1.019074078152147],
            [10.590294466617914, -1.0172397636349189],
            [10.58709115461165, -1.0192839062486914],
            [10.58542337784617, -1.0124164834743863],
            [10.57999658614786, -1.0135887833278865],
            [10.577379511549676, -1.017122866376881],
            [10.568699077521279, -1.0143042326951783],
            [10.56610193427936, -1.014471110322547],
            [10.565483790486969, -1.00623345874554],
            [10.563155958197536, -1.0015723619124253],
            [10.569323846763856, -0.9965626056703385],
            [10.568439135614401, -0.9911148635180056],
            [10.56564746072551, -0.9902069014511174],
            [10.565287149524421, -0.9861764711644276],
            [10.570333009519716, -0.9824433982805387],
            [10.56489609794908, -0.9788400720548007],
            [10.566860429092161, -0.9718941216407833],
            [10.57389884529375, -0.9693990616604654],
            [10.574494801912612, -0.9625214086942644],
            [10.570659889266837, -0.9584594950824875],
            [10.57005984913939, -0.9551573971062989],
            [10.565031348806029, -0.954209928379771],
            [10.565495584757898, -0.9500359016860974],
            [10.570427613684126, -0.9459612481360375],
            [10.567615145224044, -0.94307572570771],
            [10.570350456315577, -0.9389558896773076],
            [10.56776559867554, -0.931576878816523],
            [10.564781711398966, -0.9299198905434573],
            [10.55678096462188, -0.9284667649839929],
            [10.554297931288747, -0.9233955851860404],
            [10.54741736421342, -0.9275511029199037],
            [10.545256844340258, -0.9262474159973041],
            [10.544787809388005, -0.9196417482447747],
            [10.541054949357703, -0.9200945542587855],
            [10.539376047152508, -0.9152085218108869],
            [10.535890424533088, -0.9140076934253447],
            [10.535701640476276, -0.9089371316377154],
            [10.528241903228958, -0.907446786508665],
            [10.527210318040316, -0.9047051898162144],
            [10.519333663683845, -0.9043442620617737],
            [10.51779395083361, -0.9010355552459985],
            [10.523766902540315, -0.8950848766605708],
            [10.522238436432302, -0.8903178180989314],
            [10.5162954540656, -0.8894180637884893],
            [10.515553025309659, -0.8855593759931571],
            [10.517954684588156, -0.8811736878530047],
            [10.52085240359466, -0.8791557390178985],
            [10.523603025611113, -0.8815130171364334],
            [10.526212497328556, -0.8785313237893994],
            [10.525903530241061, -0.8734076883749257],
            [10.529188837544547, -0.8710679043728409],
            [10.533432419173957, -0.8707295664003188],
            [10.529352633580903, -0.8617997504672826],
            [10.527509373997948, -0.8634533038565811],
            [10.522296124307255, -0.8627132348354787],
            [10.51984677853446, -0.8588358735717432],
            [10.514408377610122, -0.8596356630895252],
            [10.510953773389762, -0.8555802116673018],
            [10.506992223814887, -0.8561533410185026],
            [10.504014998576992, -0.8495462167999875],
            [10.497004590707505, -0.8469404643008305],
            [10.492568428726335, -0.8472723465908449],
            [10.486833701091664, -0.8388230130525268],
            [10.481001787685354, -0.8436804665993131],
            [10.472239901822594, -0.8428775599195409],
            [10.4638513365596, -0.836235943274859],
            [10.460085293701272, -0.8291388228739092],
            [10.455929309003741, -0.82930058140007],
            [10.455172882356935, -0.8326693899552584],
            [10.451140799386735, -0.8330434091567026],
            [10.446774090362618, -0.829441288688557],
            [10.445613920463282, -0.8251840795009305],
            [10.44179785357767, -0.8239699920271489],
            [10.439566385975796, -0.8190915565743153],
            [10.429568185830409, -0.8247955913278009],
            [10.428207968984193, -0.8194251575418207],
            [10.424552353655999, -0.819994880065067],
            [10.4221465252877, -0.8158474469635308],
            [10.41815013580904, -0.8140156951867483],
            [10.421529467121754, -0.8096795080084895],
            [10.420585334064889, -0.8067968733769346],
            [10.414776994455076, -0.801542674263844],
            [10.41689309729042, -0.797582663144539],
            [10.411519745590274, -0.7946842805003042],
            [10.40959479625838, -0.7917546723971757],
            [10.410832530561565, -0.7844631818990299],
            [10.412931157094171, -0.7785139940045316],
            [10.409338364976069, -0.7743623645052419],
            [10.406384997670017, -0.7732543761139185],
            [10.405680401821048, -0.7693534479758236],
            [10.399148659801131, -0.769162393403671],
            [10.396713973465214, -0.762583631728489],
            [10.39895022528835, -0.7574669954734733],
            [10.397094006749288, -0.7551850354901152],
            [10.392368507080594, -0.7537748861264173],
            [10.386746333301774, -0.7541743220269707],
            [10.382828415035398, -0.7597485355122813],
            [10.381129875698559, -0.7581368360430076],
            [10.381663590272044, -0.7531505112755179],
            [10.379901270279559, -0.7501089826032082],
            [10.374703283658127, -0.7518423420277517],
            [10.369835943612838, -0.7513268505130108],
            [10.369019570614638, -0.7479439272609095],
            [10.362717432487889, -0.748059551178461],
            [10.360131745602695, -0.7413820095119055],
            [10.357343645024452, -0.7436229568339112],
            [10.351242102633316, -0.7449352918362241],
            [10.344370233779664, -0.750189770012442],
            [10.343722838121655, -0.7537544433152539],
            [10.337520958127438, -0.7578901488512759],
            [10.336024407163679, -0.7629966922266639],
            [10.338106007397483, -0.7667553907083915],
            [10.33722739248915, -0.770952640021048],
            [10.331013600072659, -0.7692191898544525],
            [10.329295806242959, -0.775137126097833],
            [10.321759332366073, -0.7738332898236754],
            [10.319920585197917, -0.7756561556811811],
            [10.313903356686344, -0.7706695433188916],
            [10.305790922798156, -0.7743936367587079],
            [10.298083249542254, -0.7878375677259304],
            [10.296624306344818, -0.7952355104454798],
            [10.298882734101172, -0.7989380465253069],
            [10.305639529125953, -0.8002275664435022],
            [10.30086283904241, -0.8037009725358384],
            [10.300364030770607, -0.8084102756826668],
            [10.302067402059194, -0.8150023461659945],
            [10.294818471190345, -0.8183167701991092],
            [10.293083072491198, -0.8242752210332919],
            [10.289831002895234, -0.8237317959172901],
            [10.289135163345502, -0.8311566147306908],
            [10.28494969250819, -0.8335462320250138],
            [10.281889632710879, -0.8286568745612711],
            [10.281999847297024, -0.8222353580045659],
            [10.27902730708373, -0.8181429979652572],
            [10.279770378832627, -0.8146809240195876],
            [10.275899755464648, -0.8134589525488859],
            [10.272112901430347, -0.8154826500791159],
            [10.267088395612253, -0.8128360900942806],
            [10.264871580928645, -0.8100153514106792],
            [10.270555077543236, -0.8062455320880457],
            [10.267913031315025, -0.8028475679992296],
            [10.268340687093552, -0.7993315248335461],
            [10.255655471922095, -0.7912182767752358],
            [10.253585720434707, -0.7863838683825191],
            [10.248495000837, -0.7895102442903246],
            [10.243870240439575, -0.7866804121349181],
            [10.243580869106177, -0.7813230835172741],
            [10.245860886851139, -0.7771752070811214],
            [10.243850875491495, -0.7751638979852375],
            [10.24501640852181, -0.7709540497852572],
            [10.240084840644048, -0.7634585224354313],
            [10.244903554795934, -0.7567030586405812],
            [10.241963899609221, -0.7538610245780965],
            [10.242679365072151, -0.7494527650004215],
            [10.238588456009174, -0.7467144616945726],
            [10.238016511027327, -0.7407934012351133],
            [10.240884708180056, -0.7390050400424346]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.22153165053102, "lat": 37.24431290802468 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21193"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "00516943"
      },
      "bbox": [
        10.238016511027327, -1.0355685058074717, 10.687221221249235,
        -0.5951230587779904
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.360833526405367, -1.3275162196930932],
            [7.363980414198588, -1.3249674142046701],
            [7.367925830612915, -1.328971555784192],
            [7.369416318011573, -1.333372472369461],
            [7.372715733781038, -1.334818563305214],
            [7.370797695198795, -1.3409128193023734],
            [7.3725657987465585, -1.344672708917185],
            [7.367270015081077, -1.3462989002811778],
            [7.361727287394703, -1.346187656034673],
            [7.362925265353093, -1.3502597906616058],
            [7.368154623160256, -1.34901109354893],
            [7.369741890437318, -1.3503487064438084],
            [7.370961568230672, -1.3588628776657017],
            [7.434778044197768, -1.3503906906717948],
            [7.474617559764466, -1.3449906565351903],
            [7.524153148102758, -1.3238189139164616],
            [7.527799087974594, -1.3743945605097487],
            [7.538634246767561, -1.5048143673724854],
            [7.544510650939134, -1.5817451269205511],
            [7.554380662015147, -1.618526208517279],
            [7.548830498252891, -1.6388828825955848],
            [7.5577251988124825, -1.7442061579389372],
            [7.514969539947847, -1.7490392612973982],
            [7.423575303106512, -1.7580740693836578],
            [7.340151678963614, -1.7661000439883847],
            [7.344453474577944, -1.6628706622186957],
            [7.345040932334263, -1.6555749985300445],
            [7.351533979276588, -1.5179709954624803],
            [7.354655863466442, -1.4567270744798966],
            [7.360833526405367, -1.3275162196930932]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.17921597501108, "lat": 36.83566374998978 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21219"],
        "coty_name": ["Todd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Todd County"],
        "coty_fp_code": "219",
        "coty_gnis_code": "00516956"
      },
      "bbox": [
        7.340151678963614, -1.7661000439883847, 7.5577251988124825,
        -1.3238189139164616
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.828125121468721, -1.356633999737785],
            [7.834807422069721, -1.3229419522297723],
            [7.847822026632049, -1.2586091420687942],
            [7.858869575323422, -1.204529036951808],
            [7.861124630406792, -1.1968108953246124],
            [7.85960258328129, -1.1919451657836988],
            [7.858933568790485, -1.184017467666543],
            [7.854846287238498, -1.1819367880044183],
            [7.85075027422149, -1.1768975940505793],
            [7.8503032444272325, -1.1705557943482614],
            [7.85412085065561, -1.1672795776630993],
            [7.859888817900032, -1.1697648746520277],
            [7.863048896671047, -1.165058977073692],
            [7.872613833689822, -1.1643688356180335],
            [7.877763396298791, -1.1700398664510625],
            [7.882456598701703, -1.1680670209466435],
            [7.883074704155241, -1.163223183447957],
            [7.889072373407646, -1.1637031428605573],
            [7.896843227062114, -1.1596232896159298],
            [7.897561944518764, -1.1667173380052294],
            [7.906884565066965, -1.1697429399621375],
            [7.915463266696677, -1.1691934041336625],
            [7.917643144973004, -1.1642469104696664],
            [7.921909944302871, -1.1630627942376826],
            [7.926325326520971, -1.1672022229979717],
            [7.928704564529965, -1.160562361506196],
            [7.934089077858518, -1.156661274961364],
            [7.939259922301284, -1.1571530192934292],
            [7.945569637133979, -1.1545300801850058],
            [7.948959479121279, -1.1509271787378665],
            [7.95232792399378, -1.1559210073483865],
            [7.959189513927864, -1.15885739805904],
            [7.959975479973878, -1.1629860677047648],
            [7.970281688296528, -1.1734824474683256],
            [7.974220694765062, -1.179306890572149],
            [7.975632485816709, -1.1860429554330547],
            [7.9834823723863035, -1.1881596365803353],
            [7.990057640190553, -1.1870171835374965],
            [7.993641115641619, -1.1836423724305127],
            [7.992675757366841, -1.1766615689438233],
            [7.99364121032224, -1.171953619806004],
            [7.9977668979660805, -1.1709731759220605],
            [8.002186760606435, -1.1756296784704],
            [8.00935075534189, -1.1777702926716032],
            [8.015721671766919, -1.1823699076016272],
            [8.019033714520399, -1.1832838682091098],
            [8.021384449726275, -1.1803610891200509],
            [8.018285536952943, -1.1731123216657982],
            [8.020151503766494, -1.167192492503887],
            [8.027474875030109, -1.1641280814921375],
            [8.128859814679965, -1.2444060695989496],
            [8.139576923993472, -1.2416395938733906],
            [8.148194895687592, -1.2373500836592153],
            [8.156498158947253, -1.2292659855235128],
            [8.158554111506927, -1.2247026403630885],
            [8.162179779129067, -1.2234674739781228],
            [8.167905345898149, -1.2190420574291168],
            [8.176056854861123, -1.2157692240224334],
            [8.199610849089447, -1.2410733192596952],
            [8.263127127607582, -1.2503276122045452],
            [8.234535397604773, -1.3822517417181739],
            [8.231517334706714, -1.3815471092213298],
            [8.22556908191946, -1.389606565698236],
            [8.224827625594525, -1.3922427243689879],
            [8.218269270970746, -1.3964587474166015],
            [8.214766293822631, -1.3938339611691142],
            [8.207093929857422, -1.3837759100934393],
            [8.203849617570876, -1.3865194415555073],
            [8.201014072962135, -1.3922100317928],
            [8.204045621566278, -1.4013501469602991],
            [8.207914583016631, -1.4058595043878965],
            [8.204895749810216, -1.4126487406020694],
            [8.20147077671229, -1.416439581166362],
            [8.198175005711535, -1.4148418622799974],
            [8.194459842295773, -1.409058927881376],
            [8.189843333010309, -1.4085743910268695],
            [8.18829489081676, -1.4139893593352242],
            [8.185291252699033, -1.4155583474956428],
            [8.180549476124634, -1.4234838080198984],
            [8.180831791165224, -1.4271725761736134],
            [8.175309524050409, -1.4259807881090543],
            [8.172704530918322, -1.4270819777550492],
            [8.171675769693593, -1.4318229085454348],
            [8.168163679920905, -1.4325230892124232],
            [8.160155031230858, -1.4311799840103816],
            [8.158590536012674, -1.4355900996959414],
            [8.159935103440532, -1.438499007507947],
            [8.163364833677788, -1.4386833661085432],
            [8.163604983210163, -1.4466491262321497],
            [8.164700169865904, -1.4512425440821581],
            [8.116122244392102, -1.5029395714438234],
            [8.062349816739646, -1.5600394396643644],
            [8.063334672641645, -1.5284527861669541],
            [8.005114179622405, -1.5242768740912906],
            [7.944883912195877, -1.5209095099553427],
            [7.916816675935544, -1.5197673138684353],
            [7.889238473138248, -1.4689756277017691],
            [7.828125121468721, -1.356633999737785]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.42381687382232, "lat": 36.9935723724046 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21227"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "227",
        "coty_gnis_code": "00516960"
      },
      "bbox": [
        7.828125121468721, -1.5600394396643644, 8.263127127607582,
        -1.1509271787378665
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.747115503648542, -0.5179865631628984],
            [8.75423869844656, -0.5147896220219302],
            [8.754635195510291, -0.5112609650071992],
            [8.758031165091518, -0.5065831303629408],
            [8.760632859235985, -0.5078307604578014],
            [8.768262095890202, -0.5065488543782269],
            [8.767344531761779, -0.5028332626330565],
            [8.767975324139824, -0.49695628109249285],
            [8.76472579601015, -0.4879432395494718],
            [8.764184794859098, -0.4816785625227501],
            [8.769079550988623, -0.4816116011860585],
            [8.778681446847068, -0.4864068415936435],
            [8.782106999325116, -0.48692494030647077],
            [8.786790447102739, -0.4778581037120096],
            [8.781206288224764, -0.475459347550448],
            [8.77714876031883, -0.4630277990517008],
            [8.776970354691214, -0.4602930603312397],
            [8.784015319771953, -0.4625397939249816],
            [8.791249976520675, -0.46254317671357864],
            [8.791705777034856, -0.4558094263550752],
            [8.795488699522362, -0.45384155923379443],
            [8.800344672743497, -0.4547695402550483],
            [8.804754075347352, -0.4534835156673673],
            [8.81277143703449, -0.44647595837691495],
            [8.81394714146804, -0.44147848896756364],
            [8.812501249653488, -0.4388289526552287],
            [8.80722140719479, -0.4357801001040693],
            [8.806784734016299, -0.4309505663309298],
            [8.810452233636424, -0.42658836356922425],
            [8.811374865768308, -0.41935532607084103],
            [8.816195997663218, -0.41772712458589556],
            [8.814841844376739, -0.4139656881281104],
            [8.8163913006449, -0.4068191406474785],
            [8.822480332881943, -0.4073539162539423],
            [8.829720989031383, -0.4021470301360014],
            [8.831861564710936, -0.39850413379854505],
            [8.827973889598569, -0.3888835448756176],
            [8.829080645674287, -0.3840793117099801],
            [8.832727126527162, -0.38868243136277275],
            [8.83566204242519, -0.3888589212983509],
            [8.83825587130793, -0.39202320825895265],
            [8.841200788272827, -0.3918629907797896],
            [8.845336567764972, -0.386849909961755],
            [8.854929751062144, -0.3875206887214877],
            [8.857249345843796, -0.38600702326507164],
            [8.853907709331088, -0.3806802327766611],
            [8.846395935680524, -0.37616938906961433],
            [8.845573271554743, -0.369588792808407],
            [8.848278240906282, -0.3675864635714417],
            [8.854605056004011, -0.3713272105856401],
            [8.859087845678436, -0.3704639288867463],
            [8.857922082968527, -0.36556065175103736],
            [8.861912214406585, -0.3647684166998896],
            [8.86500918031094, -0.3773477326592639],
            [8.869018089114276, -0.37768930107463805],
            [8.870466070754148, -0.36956252544095436],
            [8.875426325449741, -0.3605436261594769],
            [8.878610184020802, -0.37035742729202764],
            [8.878779389115664, -0.3733953031378568],
            [8.875752667906696, -0.37630747634222683],
            [8.878082838809451, -0.3793877603205483],
            [8.884175935117138, -0.3805774791105828],
            [8.888167270311314, -0.38368555574684876],
            [8.88924033943324, -0.376419152540041],
            [8.891797890694543, -0.37198558456951486],
            [8.884789551585815, -0.36775634865397877],
            [8.890511958071484, -0.35362944960293197],
            [8.889898737239223, -0.3492711431974483],
            [8.887455456309644, -0.34476498746733314],
            [8.885148113700394, -0.3320676335177257],
            [8.886470587703547, -0.3278542716561169],
            [8.892035636971427, -0.3330050476835033],
            [8.893171550478975, -0.3363391123875525],
            [8.890522452471794, -0.3404998087807745],
            [8.891692851716693, -0.34330957387180366],
            [8.896332220635934, -0.34564175492063953],
            [8.897894253359222, -0.34119954651046147],
            [8.896298158303651, -0.33799128992220184],
            [8.900072808368964, -0.3362832949059932],
            [8.904440124953634, -0.3372617292654399],
            [8.907756477359895, -0.3400738288813916],
            [8.912233273218723, -0.3365630674052681],
            [8.916718016638779, -0.33708725416795876],
            [8.91829269457164, -0.3403474314871416],
            [8.921963970755844, -0.34079274553348626],
            [8.92364166210718, -0.3384364819962083],
            [8.923541242563173, -0.33351223894631904],
            [8.921678024794817, -0.3284912430534138],
            [8.924754788509587, -0.3290929299727034],
            [8.926544340702792, -0.33469050572411],
            [8.933272269096884, -0.33333925722353214],
            [8.932338954559707, -0.3279626824442262],
            [8.928431338218155, -0.32699617973587725],
            [8.928032016385185, -0.3234468610216143],
            [8.936446191229177, -0.32583030381939915],
            [8.937269634768713, -0.3197071833930777],
            [8.939989644046651, -0.31628032164685227],
            [8.939448000078018, -0.3096359775839004],
            [8.941050605156018, -0.3074798972136744],
            [8.94866868997424, -0.30887787091906826],
            [8.956520522092099, -0.3127121440368557],
            [8.955908723976654, -0.3182675011773775],
            [8.957733123143067, -0.3281714676460759],
            [8.960664999008841, -0.3305631675574393],
            [8.972797140949323, -0.33279405304149656],
            [8.974864581780036, -0.32821717846387777],
            [8.979266816287721, -0.3284147245631348],
            [8.982533580678215, -0.33077614817448003],
            [8.990059444020632, -0.3295236958337781],
            [8.988263341218948, -0.32197917016240435],
            [8.994875496576487, -0.32741173846689486],
            [8.998300583047737, -0.32332864858095944],
            [9.002924919126517, -0.32099226692012245],
            [9.005964615656936, -0.32469544061658584],
            [9.014011992791993, -0.32722779081387365],
            [9.017306106564732, -0.32369157100007856],
            [9.0181194768793, -0.33377521444476005],
            [9.023530202130802, -0.3364852175182987],
            [9.036942453150997, -0.35423245808606174],
            [9.04489366268116, -0.35791477209856587],
            [9.045058722978103, -0.3779125246930932],
            [9.040127090592334, -0.3779223125768776],
            [9.040325231452336, -0.39661879651903026],
            [9.045223036013127, -0.39661916849044715],
            [9.046330670417603, -0.4738971644188362],
            [9.046326623619624, -0.5365327382573953],
            [9.047850075247753, -0.584726832010866],
            [8.975275888449453, -0.5932830667647594],
            [8.910141072662736, -0.6007473998754692],
            [8.87119819963942, -0.6053601125815207],
            [8.826525954437505, -0.5892116567542998],
            [8.817239479500179, -0.5913328814925123],
            [8.811164421555029, -0.5899226010528891],
            [8.803615034044633, -0.5921541482339565],
            [8.799620736814255, -0.5886185693908199],
            [8.793254916474359, -0.5864043684331197],
            [8.791839619538619, -0.5827855835436156],
            [8.787024816576222, -0.5775553722843487],
            [8.782405057835966, -0.5782879496832825],
            [8.775247708258963, -0.5728030496962607],
            [8.776444664202096, -0.5650884515479229],
            [8.77555146519524, -0.561783744230412],
            [8.777235929574143, -0.5585889026215392],
            [8.771922452941347, -0.5510027263044155],
            [8.77226169567223, -0.5464886519156316],
            [8.768768694655448, -0.5445060560565359],
            [8.765616533422175, -0.5397903592734988],
            [8.757516018202805, -0.5343246847212909],
            [8.754885289832826, -0.5311363224696897],
            [8.751662329639775, -0.5239894803749137],
            [8.747115503648542, -0.5179865631628984]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.17477724968532, "lat": 37.75342684735321 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21229"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "229",
        "coty_gnis_code": "00516961"
      },
      "bbox": [
        8.747115503648542, -0.6053601125815207, 9.047850075247753,
        -0.3074798972136744
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.296516231977956, 2.0682428424869963],
            [15.293981475647621, 2.06663652910184],
            [15.288412123387971, 2.0719300033040584],
            [15.286429189927167, 2.076544878388553],
            [15.275603523477463, 2.0815994633034336],
            [15.267774201762125, 2.0794074959186193],
            [15.264995836965596, 2.081581697422161],
            [15.260842672711734, 2.0818586436166546],
            [15.259477677102492, 2.085746649143649],
            [15.255588686969935, 2.084751509349744],
            [15.254692943484164, 2.081437950578503],
            [15.24946542545774, 2.080166016245935],
            [15.25252765879264, 2.0730262749101795],
            [15.257518441288477, 2.0714045560673062],
            [15.258008678237756, 2.0690404956997206],
            [15.263756789638729, 2.0669124076586036],
            [15.269304473983281, 2.0635097986220714],
            [15.273011471431946, 2.0582081626667716],
            [15.273504292001663, 2.047307831199125],
            [15.281947200029768, 2.041183757596608],
            [15.285711174602048, 2.0423445795319033],
            [15.287340606608172, 2.03898227560862],
            [15.293090776933258, 2.0386574034384717],
            [15.298547361862852, 2.040749265259365],
            [15.300599382567539, 2.0354454604138685],
            [15.289956874658003, 2.0224783340398833],
            [15.262918640847868, 2.027382126741776],
            [15.236056014114732, 2.049625573496036],
            [15.230231482183143, 2.0515237798052586],
            [15.208644282292722, 2.058939948622509],
            [15.184173591160787, 2.066623228009313],
            [15.163962978567486, 2.0737046918838846],
            [15.152533566811995, 2.077217423903665],
            [15.140693359433051, 2.1331665059355096],
            [15.13320344075371, 2.1701047683616532],
            [15.19702477865729, 2.183344652045536],
            [15.218299911581092, 2.1875272913666794],
            [15.229052490929718, 2.190063660853284],
            [15.269300307484736, 2.1983544092237612],
            [15.279400976881176, 2.150177553038175],
            [15.29318544192132, 2.0835054199481653],
            [15.296516231977956, 2.0682428424869963]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.61451981389136,
          "lat": 39.305175297538526
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24510"],
        "coty_name": ["Baltimore"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Baltimore city"],
        "coty_fp_code": "510",
        "coty_gnis_code": "01702381"
      },
      "bbox": [
        15.13320344075371, 2.0224783340398833, 15.300599382567539,
        2.1983544092237612
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.603604693931644, 6.1913249148940634],
            [17.716724537223836, 6.216034916678746],
            [17.819037230044355, 6.237733660423045],
            [17.85634202385226, 6.246230124679063],
            [17.87793468343578, 6.250945853170399],
            [17.881055292672247, 6.243800929580024],
            [17.905449583011258, 6.229341435281715],
            [17.9081802623648, 6.23052533575062],
            [17.910745159853054, 6.22647517700559],
            [17.916141671005853, 6.2231464334923565],
            [17.91896203631697, 6.2162904390466],
            [17.92603646551989, 6.1831569782042815],
            [17.934634493279013, 6.189686534727768],
            [17.98415877602402, 6.2011288829050875],
            [17.98193491687151, 6.208374756336365],
            [18.06887326972385, 6.197210058608597],
            [18.077998243505846, 6.124930614293836],
            [18.079380623633252, 6.116001216376458],
            [18.111546188617694, 6.117750294975249],
            [18.10741344779471, 6.123844961103446],
            [18.108670264904312, 6.126417144399377],
            [18.107458161663835, 6.133211693166856],
            [18.11066428490634, 6.1423224167928705],
            [18.115568209692764, 6.148256792037437],
            [18.125937338040586, 6.143594554095079],
            [18.135815922244518, 6.14410183936971],
            [18.144155220004357, 6.1536130620323535],
            [18.17544628943954, 6.154100367943157],
            [18.18649846263561, 6.133528966341918],
            [18.185834260212367, 6.126089282354932],
            [18.177740064359686, 6.083636561624474],
            [18.19179249753457, 6.079139235657979],
            [18.194613089452012, 6.023463313330243],
            [18.177293843821076, 6.013920809577561],
            [18.166219907645473, 6.001306605249983],
            [18.18604042454702, 5.995380608244988],
            [18.170803164541624, 5.973853207122915],
            [18.174839582830643, 5.972055280889828],
            [18.17243128929524, 5.9612167644103495],
            [18.163160082784547, 5.950849624405246],
            [18.17035479469503, 5.945341104675437],
            [18.176053982987078, 5.9431059600739795],
            [18.18189943171933, 5.942329568707868],
            [18.18275949553919, 5.9357126650498016],
            [18.190710655948383, 5.928322788374909],
            [18.19496036741208, 5.926207915163863],
            [18.201918038125864, 5.920831433834202],
            [18.210963220154028, 5.932949102896676],
            [18.222177872252416, 5.942117014715382],
            [18.245740181045957, 5.952367045176937],
            [18.252259925530787, 5.951582475859447],
            [18.266889788035986, 5.957760279340238],
            [18.269892326788177, 5.95127375904185],
            [18.27227590771689, 5.9387324900672045],
            [18.268026813030122, 5.898772354070219],
            [18.269825780371427, 5.890273357718462],
            [18.26371412136684, 5.892098176743248],
            [18.256291269071127, 5.888413328193677],
            [18.251033608501537, 5.887244334926271],
            [18.24663865519595, 5.8826626678601945],
            [18.23636549283654, 5.884776639813962],
            [18.233219730953955, 5.884681539585492],
            [18.227871563112693, 5.881969577267115],
            [18.21396525754468, 5.870753617291102],
            [18.213565138533504, 5.827733507424751],
            [18.233070761485163, 5.809484414208626],
            [18.24138840812776, 5.8107205020074835],
            [18.241365292126304, 5.808725889313754],
            [18.252460564264176, 5.811334917205448],
            [18.255751062615403, 5.801893080220217],
            [18.26561461497095, 5.811960656979252],
            [18.28886449097204, 5.817220970117147],
            [18.291262675656572, 5.820428186443792],
            [18.301356385589877, 5.797412257304982],
            [18.315328165693575, 5.800279077602575],
            [18.317597799946565, 5.791458243045264],
            [18.323837689712917, 5.766775150906893],
            [18.317454915249026, 5.758215596851137],
            [18.31132408333028, 5.748258900491637],
            [18.31306500206218, 5.744589616191086],
            [18.311764529338152, 5.741751367574824],
            [18.31592314345176, 5.735801409228611],
            [18.319792011288314, 5.733160699979122],
            [18.319622570551537, 5.726332141792537],
            [18.339091891585493, 5.652476214109241],
            [18.318726636953514, 5.644832906368611],
            [18.28378247829157, 5.634752494098767],
            [18.210199982326944, 5.6130728221830966],
            [18.149927243056972, 5.595378958010462],
            [18.12662721117976, 5.587598911861518],
            [18.121689103721366, 5.602377393920277],
            [18.057139908668606, 5.586517663107996],
            [17.98756288094156, 5.5712035682370935],
            [17.933040978202946, 5.557700799283035],
            [17.88072305024713, 5.547322623244734],
            [17.86603589355372, 5.606091271071394],
            [17.84831443611025, 5.675141951164789],
            [17.80444835888198, 5.655606211849301],
            [17.801645492365598, 5.662732519050932],
            [17.750886564699208, 5.673144736016388],
            [17.749166189376783, 5.6817763512047765],
            [17.747131065227865, 5.685523988932332],
            [17.74703938564076, 5.691507072949146],
            [17.766027648322115, 5.740499063146441],
            [17.76743576815547, 5.744323879122393],
            [17.773204394721414, 5.744343538873208],
            [17.77063512689479, 5.752449487132839],
            [17.76695126365894, 5.752050166189313],
            [17.762357619093358, 5.7653305028937645],
            [17.76591716605674, 5.765856326810464],
            [17.763237887022814, 5.778456745047808],
            [17.76610387700032, 5.781867536494832],
            [17.76734856717125, 5.788321019296195],
            [17.76117515010212, 5.790158988729185],
            [17.757047108323125, 5.7886718443176495],
            [17.756081875675363, 5.793854739316443],
            [17.758013720652713, 5.796627550725032],
            [17.756449958454027, 5.802486137438361],
            [17.75696296834071, 5.806559310066629],
            [17.72284500797897, 5.789570842590104],
            [17.72209714103861, 5.7913728639468935],
            [17.713863824323575, 5.785878159841429],
            [17.70330005263923, 5.811237578276137],
            [17.705302805000258, 5.812069979536196],
            [17.70254252655731, 5.81866652131543],
            [17.700569421499857, 5.817816879550105],
            [17.69459387835184, 5.832716228620975],
            [17.689609454456424, 5.831169632026301],
            [17.683320675768023, 5.8259520169597145],
            [17.682258411579387, 5.823128370656127],
            [17.67699896300042, 5.818742698514444],
            [17.675301070584233, 5.819228369875592],
            [17.674554433897992, 5.828170157732215],
            [17.672122646232022, 5.832997061897105],
            [17.67285127609959, 5.839901280054693],
            [17.66790066233896, 5.844005516580503],
            [17.66872739037118, 5.851398212845682],
            [17.66580579475308, 5.856057317525574],
            [17.66744499879764, 5.8623970010646245],
            [17.665328823951207, 5.863183728469188],
            [17.66167498077377, 5.873120844779902],
            [17.66168054397821, 5.889144743091516],
            [17.662410172404954, 5.895183340940323],
            [17.668576110858684, 5.906730591218092],
            [17.670896855941454, 5.916034219556965],
            [17.67311771320956, 5.919418605574509],
            [17.657887775912872, 5.955161957541596],
            [17.682407223119345, 5.996413262492588],
            [17.660231855561996, 6.011430223320078],
            [17.650198514870834, 6.037364344643915],
            [17.645674778858318, 6.045965341903946],
            [17.64411091613502, 6.0527316388305294],
            [17.647157823545168, 6.054461411509044],
            [17.65517978421309, 6.054039072863311],
            [17.644926461558477, 6.07714268504377],
            [17.648545857202997, 6.077480309740939],
            [17.650053963629926, 6.0814450668388655],
            [17.653549470235113, 6.084000666520111],
            [17.650971230852964, 6.0898292917975985],
            [17.66088984251469, 6.094522455264033],
            [17.66653664022721, 6.096192841289291],
            [17.668944618229418, 6.099151705122679],
            [17.66636145806034, 6.109105939487763],
            [17.667142247154395, 6.113360420643692],
            [17.665210251674775, 6.117537012759223],
            [17.66529293788519, 6.121679099458971],
            [17.656162103182474, 6.143860917054162],
            [17.647473933986245, 6.140597617925091],
            [17.644599450560797, 6.14772080405882],
            [17.635131839014196, 6.143968004271437],
            [17.63241215524161, 6.151004548078869],
            [17.623097630484953, 6.147866220440208],
            [17.603604693931644, 6.1913249148940634]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -71.90773916073913,
          "lat": 42.351400728271166
        },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25027"],
        "coty_name": ["Worcester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Worcester County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00606940"
      },
      "bbox": [
        17.603604693931644, 5.547322623244734, 18.339091891585493,
        6.250945853170399
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.338058807660632, 6.646352113528827],
            [8.452419310808702, 6.659935455336875],
            [8.50823152128338, 6.6655970905240185],
            [8.563155254416507, 6.672436118413227],
            [8.598266061484892, 6.676271665361561],
            [8.672558735306868, 6.683356718560307],
            [8.683060695124956, 6.5982785281171425],
            [8.688292416236548, 6.554711793081464],
            [8.702924748701799, 6.442169608358544],
            [8.70432092709739, 6.430291469328704],
            [8.715868654584462, 6.339739687568188],
            [8.660138086489345, 6.335569489275742],
            [8.64508645969532, 6.334646485430759],
            [8.588479369150656, 6.3279713585709185],
            [8.545903026889356, 6.32332503316426],
            [8.503032389926402, 6.3181589879896904],
            [8.460701053709041, 6.313286052258503],
            [8.42766081983568, 6.309009987441433],
            [8.376207649331667, 6.302950216574007],
            [8.366971458542823, 6.3879520153730995],
            [8.363430886577776, 6.416696205886741],
            [8.36030334277905, 6.445820042560431],
            [8.35333062981469, 6.502285265149974],
            [8.348209630402902, 6.560550627231793],
            [8.338058807660632, 6.646352113528827]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.61026827258685, "lat": 44.68368274029736 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26039"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01622962"
      },
      "bbox": [
        8.338058807660632, 6.302950216574007, 8.715868654584462,
        6.683356718560307
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.300633242252822, 6.900964046191614],
            [8.309865320556751, 6.90229029283788],
            [8.353818942161114, 6.906486517539045],
            [8.38671023812818, 6.9092789705848325],
            [8.383023926229047, 6.9380209173163925],
            [8.376755988845927, 6.995185316914391],
            [8.441314688119617, 7.002033522598296],
            [8.4771152277633, 7.005481437653232],
            [8.51013594518512, 7.0092247619100485],
            [8.609703011248579, 7.019973562533807],
            [8.634140811622487, 7.0229086835044],
            [8.643893516508115, 6.93790017742735],
            [8.651898270860702, 6.867039109715908],
            [8.658967311783854, 6.797007868843007],
            [8.661077294500688, 6.777140450285655],
            [8.66670758709924, 6.728918834860857],
            [8.672558735306868, 6.683356718560307],
            [8.598266061484892, 6.676271665361561],
            [8.563155254416507, 6.672436118413227],
            [8.50823152128338, 6.6655970905240185],
            [8.452419310808702, 6.659935455336875],
            [8.338058807660632, 6.646352113528827],
            [8.332332536524998, 6.68908493646501],
            [8.330745168435453, 6.703449433337016],
            [8.326439106049417, 6.732144285301244],
            [8.322701082808894, 6.7608407159102395],
            [8.316566413150326, 6.812695035101089],
            [8.316387284558196, 6.815659228695017],
            [8.310908369050555, 6.8151423981149],
            [8.300633242252822, 6.900964046191614]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.5990196991944, "lat": 45.02142204182764 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26137"],
        "coty_name": ["Otsego"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Otsego County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01623011"
      },
      "bbox": [
        8.300633242252822, 6.646352113528827, 8.672558735306868, 7.0229086835044
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.376207649331667, 6.302950216574007],
            [8.42766081983568, 6.309009987441433],
            [8.460701053709041, 6.313286052258503],
            [8.503032389926402, 6.3181589879896904],
            [8.545903026889356, 6.32332503316426],
            [8.588479369150656, 6.3279713585709185],
            [8.64508645969532, 6.334646485430759],
            [8.660138086489345, 6.335569489275742],
            [8.715868654584462, 6.339739687568188],
            [8.726980065931771, 6.254261011955651],
            [8.737825298883822, 6.168543790910378],
            [8.749136497592971, 6.082499919513993],
            [8.751875876943176, 6.062645010013575],
            [8.759537378877114, 6.011840990247653],
            [8.760154104826636, 5.996867002618385],
            [8.675519894097159, 5.986520194272785],
            [8.5897656086822, 5.976184389462582],
            [8.534921726835073, 5.969914876057351],
            [8.46260499531397, 5.961491468782925],
            [8.416702601678761, 5.9565752491941995],
            [8.405408492727988, 6.043047050710783],
            [8.400617611390643, 6.085337333297869],
            [8.390796408993785, 6.154598593203167],
            [8.383218992492738, 6.214371551656919],
            [8.376207649331667, 6.302950216574007]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.61158640979399, "lat": 44.33556182475083 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26143"],
        "coty_name": ["Roscommon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roscommon County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01623014"
      },
      "bbox": [
        8.376207649331667, 5.9565752491941995, 8.760154104826636,
        6.339739687568188
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.843963221279731, 5.307994075017334],
            [8.842129754358236, 5.323421770491512],
            [8.898737971852709, 5.330221014224568],
            [8.984848882949771, 5.3414480182894355],
            [8.97939580564882, 5.391730634837243],
            [8.975760109832235, 5.427939864226398],
            [9.003552256542264, 5.4307194206563825],
            [9.060494724492857, 5.436961394866537],
            [9.065237659783289, 5.39394986855605],
            [9.162004503717682, 5.404748453759231],
            [9.204435095695866, 5.4098853230156045],
            [9.232816164199864, 5.413510911492679],
            [9.23805380614687, 5.370522244197174],
            [9.32320021218661, 5.381405950441522],
            [9.334605091075167, 5.2958728879894315],
            [9.340272119269123, 5.254231364906251],
            [9.343285927657039, 5.230129418842024],
            [9.34558520531692, 5.230023779792323],
            [9.354978177230276, 5.155053878442643],
            [9.358900582031065, 5.126136557917967],
            [9.280487143794751, 5.115859893724415],
            [9.224957408637842, 5.108131993969114],
            [9.18902632904651, 5.103268034057542],
            [9.202331475602898, 5.01653451428637],
            [9.115112216774168, 5.004413015666269],
            [9.030470252748355, 4.990701611647286],
            [8.99578862872719, 4.986430534107101],
            [8.946195655792751, 4.980543169860836],
            [8.886808340617424, 4.972764567246924],
            [8.87929731790054, 5.0305896802905385],
            [8.865635890738767, 5.1352623838140765],
            [8.853356093670998, 5.232093507844152],
            [8.843963221279731, 5.307994075017334]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.05316545277084, "lat": 43.33503597341743 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26145"],
        "coty_name": ["Saginaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saginaw County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01623015"
      },
      "bbox": [
        8.842129754358236, 4.972764567246924, 9.358900582031065,
        5.436961394866537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.565490212851092, 4.3582125438761095],
            [9.657985420743747, 4.374571997350262],
            [9.714115587218588, 4.384139989438387],
            [9.76335431553106, 4.392287259471169],
            [9.826596953311986, 4.403115606089014],
            [9.883159382614688, 4.4124591242166735],
            [9.904348953900207, 4.415703322698186],
            [9.918510525206594, 4.417741920092172],
            [9.946810322337834, 4.422524694660366],
            [9.98917054252282, 4.43008915335865],
            [10.016312391858381, 4.434572581558575],
            [10.058622287423834, 4.440818259848983],
            [10.056898616597033, 4.431111673868505],
            [10.058173704304346, 4.424965344557701],
            [10.055559728096304, 4.418090592189063],
            [10.053182432336214, 4.3968106346651075],
            [10.052625678945251, 4.386273001398836],
            [10.049878061137118, 4.3772233794134126],
            [10.04377132051798, 4.36888056891782],
            [10.03610282737258, 4.363869001190051],
            [10.03370606914206, 4.359788869535709],
            [10.031430518514947, 4.3525337345047665],
            [10.031424953125912, 4.347205103848012],
            [10.026287208152523, 4.34128366660633],
            [10.009754963470895, 4.336456434094117],
            [10.003395477352036, 4.336083497472713],
            [10.001888936513607, 4.3330734957067225],
            [10.005441972857792, 4.330781037768979],
            [10.01163406657165, 4.330878726445861],
            [10.012199712601241, 4.328946259354543],
            [10.008891534202917, 4.321502952171327],
            [9.988944727025029, 4.311067811674903],
            [9.971113766652405, 4.307523324408882],
            [9.962062941760347, 4.3038045818736785],
            [9.936495489562303, 4.288095041973131],
            [9.925675032564705, 4.276421985236845],
            [9.915654485157324, 4.258108410391718],
            [9.914340798529924, 4.254958571687379],
            [9.910300325314713, 4.236960622897188],
            [9.90893524359171, 4.227320591230236],
            [9.90151157554336, 4.203839983552537],
            [9.90213890235356, 4.1761852629007175],
            [9.904333501991287, 4.139574205969406],
            [9.908877145853008, 4.127378165352698],
            [9.91599562172025, 4.10359026072776],
            [9.922101578579046, 4.0919595275691245],
            [9.921673585015391, 4.08398535532547],
            [9.918805088235581, 4.0709380565560584],
            [9.917536276241758, 4.0557601155186545],
            [9.909742502255234, 4.05530470286561],
            [9.907770611749422, 4.053137244363278],
            [9.902805739762558, 4.0525628518972265],
            [9.899038039687738, 4.048726748989308],
            [9.896119019698071, 4.052541008557625],
            [9.888172340750012, 4.048730155941648],
            [9.892121612292556, 4.038389798898093],
            [9.88955759854371, 4.036881716414699],
            [9.884962392429706, 4.043423517531767],
            [9.881693486230436, 4.0440200713180054],
            [9.879783932140848, 4.039767599656523],
            [9.876160896682231, 4.037251035297934],
            [9.876889164318005, 4.025736186474077],
            [9.88278224538854, 4.012323340316557],
            [9.883156181495462, 4.0046092182812],
            [9.878062685791079, 3.999420991901551],
            [9.874936723136841, 3.998064669597225],
            [9.866862064063056, 4.001766915350512],
            [9.865059444139137, 3.9998153175755347],
            [9.861083061666616, 4.0020085425105005],
            [9.859070422667552, 4.0062319387055],
            [9.851002007622261, 4.005532827168736],
            [9.851773044764466, 4.009105810796875],
            [9.840231075766024, 4.01625193540434],
            [9.83637628074505, 4.014837712451407],
            [9.833288769975631, 4.0215431357887175],
            [9.83071563354309, 4.022215541187521],
            [9.828039479503717, 4.026951061557368],
            [9.824514463435266, 4.0255169645181645],
            [9.823738035118629, 4.0219114288545725],
            [9.819309135351201, 4.023449700677536],
            [9.819806176842151, 4.026448942456803],
            [9.813501452923646, 4.027440408877475],
            [9.806437541191947, 4.03871868582051],
            [9.797774548700481, 4.043723607477463],
            [9.738011005545097, 4.035386426994507],
            [9.7062075390747, 4.030818027381746],
            [9.70707865236762, 4.025065203909642],
            [9.663843796324523, 4.01842714085405],
            [9.620593280305828, 4.011426366460528],
            [9.611714339506634, 4.069335273526271],
            [9.600011676558129, 4.143618396506473],
            [9.595437605208598, 4.173457979739375],
            [9.594155592614738, 4.187113894303229],
            [9.58725208255074, 4.230112065779267],
            [9.570304936182392, 4.330414365649167],
            [9.565490212851092, 4.3582125438761095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.28307461030595, "lat": 42.28223262362058 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26163"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "01623022"
      },
      "bbox": [
        9.565490212851092, 3.998064669597225, 10.058622287423834,
        4.440818259848983
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8677898479878332, 6.32145754158882],
            [1.9752757692722094, 6.322982322702944],
            [1.9832585141957282, 6.323708016647132],
            [2.0354671370952717, 6.324406147377381],
            [2.040630642668287, 6.324210927537624],
            [2.0417745397327516, 6.266658078329831],
            [2.0420685781006003, 6.237837285328861],
            [2.086132315887263, 6.238673169588894],
            [2.116393466326634, 6.240173019935962],
            [2.136456075182108, 6.240297926243053],
            [2.1560009391254473, 6.2412345140712215],
            [2.203442330842531, 6.242133924941527],
            [2.2171873775656525, 6.242781853999234],
            [2.2183574925202136, 6.192803834552408],
            [2.219833742985503, 6.156715625840033],
            [2.205469300005217, 6.156074421633115],
            [2.2051162582275676, 6.150067138581115],
            [2.2001732234388407, 6.1469399989480875],
            [2.1957887401254115, 6.150878000417986],
            [2.187554459339242, 6.14746440069022],
            [2.181609255305949, 6.146545035182547],
            [2.177770762943806, 6.144286536730066],
            [2.1765818833784722, 6.1329858442558205],
            [2.1715440469544722, 6.1342247039205],
            [2.164455575332332, 6.133119567248981],
            [2.168089402711196, 6.1268425654256085],
            [2.1640854274006647, 6.120349425727454],
            [2.1601703972121147, 6.118119703920254],
            [2.1531388292871196, 6.116596627354413],
            [2.148866448888838, 6.112517048505729],
            [2.149657508840941, 6.1101550225523376],
            [2.156812403109958, 6.106914364242376],
            [2.1585528704601074, 6.104114705160089],
            [2.1544312645801047, 6.099265989139729],
            [2.1498220994654695, 6.103646648102077],
            [2.149128290113043, 6.0972682084919505],
            [2.1435587017539737, 6.090084835241589],
            [2.1427285803755614, 6.087301602882911],
            [2.1449515457931323, 6.081830333978814],
            [2.1423400169360707, 6.076855992032102],
            [2.143063327412569, 6.073240000035664],
            [2.147216975131825, 6.073694911368955],
            [2.1469888004011053, 6.065780346635751],
            [2.1530601404751986, 6.057605612614525],
            [2.147851448924907, 6.05344303343331],
            [2.1454158075875274, 6.049082407551304],
            [2.1407992230309985, 6.047783819251796],
            [2.1393660529532497, 6.043632547244473],
            [2.1302456658722035, 6.0419343943275425],
            [2.1270531680414626, 6.039783579315453],
            [2.123799836877656, 6.045295962999213],
            [2.1195933156066697, 6.045441269598261],
            [2.112856333138421, 6.041927746953679],
            [2.1106755499832905, 6.036328390243605],
            [2.0974415940394313, 6.0188440655711455],
            [2.094450995606216, 6.017470112261077],
            [2.086167489924215, 6.016237600154181],
            [2.08076782360074, 6.01233428150746],
            [2.0851115845600083, 6.0078520989932125],
            [2.0830914466827006, 6.004099148857906],
            [2.0802711081684953, 6.002987044124051],
            [2.077350717339302, 6.005587347870485],
            [2.0692196525909154, 5.994443606038405],
            [2.062887539896489, 5.993643970791659],
            [2.053704551636021, 5.989952531279661],
            [2.05855054970278, 5.986369357968379],
            [2.05396844455746, 5.983282652742054],
            [2.05147830276308, 5.987219411925524],
            [2.048206203620021, 5.988376207414301],
            [2.047329247075497, 6.021390443561754],
            [1.989553683394194, 6.020249037930506],
            [1.961735528471395, 6.0193346470294955],
            [1.9609025990612043, 6.062809720998903],
            [1.8744976176758856, 6.061374381222969],
            [1.8731369979782848, 6.142618683862914],
            [1.871930446356143, 6.1984905737306075],
            [1.871285438118685, 6.235089892041853],
            [1.8699121536910845, 6.235094180696468],
            [1.8692879286040758, 6.2491596089477275],
            [1.8685146022689456, 6.27824960782685],
            [1.8677898479878332, 6.32145754158882]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.80255833808587, "lat": 44.82068359920308 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27019"],
        "coty_name": ["Carver"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carver County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00659455"
      },
      "bbox": [
        1.8677898479878332, 5.983282652742054, 2.219833742985503,
        6.324406147377381
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.533257511033147, 9.148370636342591],
            [1.621055028238485, 9.150075125556423],
            [1.713098655335624, 9.152236151160405],
            [1.790436217651289, 9.154505263404129],
            [1.8354612424929162, 9.155627633220742],
            [1.9006299804488131, 9.156685721071668],
            [1.9676019591691984, 9.157532223065902],
            [1.9666530669611606, 9.208993567648008],
            [2.0009966763570244, 9.209594339010652],
            [2.0010926662924318, 9.208256486467542],
            [2.0881248685243166, 9.21082033826807],
            [2.1037472035386275, 9.211521919110822],
            [2.176003841939959, 9.210351769571629],
            [2.1915868911137357, 9.21034648710623],
            [2.219085366707319, 9.210820188218964],
            [2.3057038829655916, 9.212590650019386],
            [2.392322633066557, 9.214336711690247],
            [2.40632375826853, 9.214742586558604],
            [2.4362605179322174, 9.214597145568641],
            [2.436745966515896, 9.20084685737238],
            [2.436955086007248, 9.130950204985332],
            [2.439623655581747, 9.074836992522236],
            [2.4407137216504755, 9.046801884449938],
            [2.4546319282500555, 9.047064624914293],
            [2.45544379527659, 9.025340877030073],
            [2.4555552655731696, 9.01105936768889],
            [2.455042454493581, 8.987125245874262],
            [2.455613428460215, 8.970590068207626],
            [2.4555694103654226, 8.953508224428862],
            [2.456243939467919, 8.946400822501253],
            [2.4585465199808163, 8.87455133923991],
            [2.4583430506074455, 8.859230601933222],
            [2.4588197048182465, 8.854229350733085],
            [2.4588944836311204, 8.83117178113994],
            [2.457995151259726, 8.817257864551559],
            [2.458338602805371, 8.803103568861866],
            [2.4577710887385886, 8.78943310521856],
            [2.458925901886769, 8.732751138469268],
            [2.4602052544688804, 8.715948824293937],
            [2.461821185718684, 8.70475088916122],
            [2.4632302294320274, 8.704701493003208],
            [2.4642854741595115, 8.6681001425553],
            [2.4651838453688804, 8.617551889561154],
            [2.4682688891055693, 8.531924464931057],
            [2.47015441360489, 8.44698783704813],
            [2.4771611411840997, 8.447171687009778],
            [2.479644020828669, 8.365582322552811],
            [2.479199958982909, 8.365561815415349],
            [2.3871497111519275, 8.361611178703699],
            [2.3226061697937763, 8.361533348171575],
            [2.302366354440334, 8.362171137600882],
            [2.2578012016700075, 8.360956084144084],
            [2.2140972995082473, 8.359965565447487],
            [2.1267837361250925, 8.358711387862746],
            [2.0706696026928157, 8.35684459313713],
            [2.0043451864666264, 8.356267190948873],
            [1.9872019470641715, 8.356276631140146],
            [1.9866599122169741, 8.400588203241485],
            [1.986086734053377, 8.434220219399755],
            [1.9851287784775344, 8.473691951291599],
            [1.9838948424410743, 8.534303070883135],
            [1.9814945552532701, 8.532068142256287],
            [1.9759155026084547, 8.538114288962642],
            [1.9685253209333244, 8.540174826572198],
            [1.9656719394101072, 8.543247942569636],
            [1.963776824321798, 8.548581203489066],
            [1.963209855445629, 8.555743996950095],
            [1.9595850882054717, 8.554687312768749],
            [1.9580549051250737, 8.561215042719656],
            [1.9623053958038028, 8.565080643270173],
            [1.9620532486921185, 8.573154866058454],
            [1.9720580398956862, 8.581994940314997],
            [1.9746517629020865, 8.591129180761303],
            [1.9754815598984972, 8.597242297033588],
            [1.98088009949031, 8.59979823447931],
            [1.9754794296672937, 8.612491942379869],
            [1.9735929679625415, 8.615354453412165],
            [1.97328926605654, 8.62071577662203],
            [1.9816023190869287, 8.619351069569127],
            [1.98165741873913, 8.626441403327293],
            [1.97708006748282, 8.626791820330489],
            [1.9681772248674898, 8.62964401068841],
            [1.9637442142469914, 8.629030092560672],
            [1.9574971515989694, 8.624417199697978],
            [1.9515659114342965, 8.625643228087966],
            [1.9504065538581954, 8.621573408409018],
            [1.9468152015712004, 8.624209037376492],
            [1.9474314086998823, 8.628352954560508],
            [1.9390310991347568, 8.628947021007544],
            [1.9344203149685326, 8.627063600692432],
            [1.9337573556127623, 8.630389999909125],
            [1.9298078083587897, 8.634453926294018],
            [1.9266029571692302, 8.633942787025864],
            [1.925701499241655, 8.639282385298342],
            [1.9178589825150336, 8.638304583757895],
            [1.9150507838517874, 8.636125402705707],
            [1.906987413967927, 8.636785049849438],
            [1.9044259180436671, 8.639841605658072],
            [1.9052386831701622, 8.642787496014792],
            [1.9016134472072548, 8.644458925419665],
            [1.9025630474998503, 8.63497100652283],
            [1.899734001409645, 8.630711391434794],
            [1.900211833421197, 8.626374726718245],
            [1.8948045844398524, 8.6214017893579],
            [1.8917084341038584, 8.622065861489363],
            [1.8856545141751129, 8.618735452260522],
            [1.8847254529585613, 8.6218383836718],
            [1.8807391511153615, 8.620717620065657],
            [1.8803957479047984, 8.624678878707908],
            [1.8759455145126218, 8.626073526823951],
            [1.8709475221724396, 8.62465331958179],
            [1.8682561709603458, 8.632572934976874],
            [1.865701969448022, 8.63596844495359],
            [1.8588913702393204, 8.635882090704126],
            [1.8549771412619978, 8.643491475546952],
            [1.849417359810401, 8.645515019116937],
            [1.8457528272754586, 8.648392995117202],
            [1.847001659288049, 8.651375646433083],
            [1.8445076117197539, 8.655862080653849],
            [1.8319972478763875, 8.657861705327743],
            [1.830437927239388, 8.660583732393741],
            [1.8265881804352453, 8.662316293758275],
            [1.8167107771100353, 8.664683193347575],
            [1.8141194621618597, 8.667249490166702],
            [1.8081295841912706, 8.668788557332133],
            [1.8090452286201406, 8.674323893110786],
            [1.8021709125143366, 8.677031684879232],
            [1.8021688770961446, 8.680453265181907],
            [1.7994038975132016, 8.682158221521298],
            [1.8002724388220146, 8.685666251165255],
            [1.7973516909064218, 8.68933283040251],
            [1.7969376179726593, 8.694947323487028],
            [1.7991225030720501, 8.700211620004747],
            [1.7969233720975581, 8.709590659895365],
            [1.7974998485510634, 8.718205144124576],
            [1.801074457788259, 8.719074053546262],
            [1.8064468590960956, 8.724427584383823],
            [1.8047266142079414, 8.727770664114413],
            [1.8001166490406504, 8.730196822493543],
            [1.7964371037562192, 8.736254207664471],
            [1.790110039854082, 8.744662094932613],
            [1.782948160544076, 8.752963859823318],
            [1.7739837521423634, 8.775206987677125],
            [1.769812058168829, 8.782481017649154],
            [1.7592810286450984, 8.791598032138534],
            [1.7436647824863236, 8.794013225748357],
            [1.6829775404172966, 8.765647940300791],
            [1.6223029614588818, 8.737266115159267],
            [1.6062373448215939, 8.727988564951076],
            [1.602315292180688, 8.727644122781612],
            [1.596378734130337, 8.729931686635648],
            [1.584152564131934, 8.735924934517147],
            [1.575401615746489, 8.736494902565983],
            [1.5710262138667386, 8.738136165910708],
            [1.567725547338528, 8.742877824331625],
            [1.5648015328774882, 8.742891439501918],
            [1.562812431844193, 8.73837596839355],
            [1.557830286234291, 8.73854400509938],
            [1.5535302917749807, 8.744145008447598],
            [1.5474700642536134, 8.74425166308197],
            [1.5467189979474023, 8.74731915967906],
            [1.5500304456830583, 8.749727919587698],
            [1.5449374914657985, 8.755496654484242],
            [1.5414673296184722, 8.755121115928354],
            [1.541200312521361, 8.809225314276066],
            [1.5408292402657582, 8.851309291806269],
            [1.5409621366150532, 8.894202785856978],
            [1.5388804537809335, 8.908062837724136],
            [1.537003032126759, 8.978141019175263],
            [1.5363697451070109, 8.978130604438743],
            [1.534859770452114, 9.023654342996023],
            [1.5339937659491847, 9.081141706369062],
            [1.533257511033147, 9.148370636342591]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.63194457102617,
          "lat": 47.509501157019514
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27061"],
        "coty_name": ["Itasca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Itasca County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00659476"
      },
      "bbox": [
        1.533257511033147, 8.356267190948873, 2.479644020828669,
        9.214742586558604
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.788693373340714, -4.395106296933435],
            [5.861552217342231, -4.390331340950874],
            [6.001469983936934, -4.381372891795918],
            [6.005215148236769, -4.380941948697632],
            [6.007890170959405, -4.417093441045977],
            [6.008157006005997, -4.417635542613638],
            [6.012317966625448, -4.468313210844973],
            [6.098624688167854, -4.461963801309943],
            [6.102763461835896, -4.5131905307403475],
            [6.1109991171084515, -4.617604758601778],
            [6.114019187628474, -4.662708870169951],
            [6.1169292280077805, -4.696568819909904],
            [6.118715465437987, -4.724292390522547],
            [6.075833050788875, -4.727808382344346],
            [6.079671433252398, -4.801110531723688],
            [6.080739113068936, -4.817581637353791],
            [6.047790001013584, -4.8202223701536715],
            [5.914607996314256, -4.8297231006202095],
            [5.821112309286178, -4.8360547229885755],
            [5.818212665632947, -4.79536708809164],
            [5.810917862256217, -4.69019675806442],
            [5.8035802276485455, -4.584371620663339],
            [5.798746205592682, -4.515801438090262],
            [5.7965355355338986, -4.486398533236501],
            [5.795325408269309, -4.486462935158283],
            [5.793432915811421, -4.464149437404138],
            [5.791547626233886, -4.435622903091195],
            [5.790906967245827, -4.432189294529855],
            [5.788693373340714, -4.395106296933435]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.33647767282824, "lat": 33.9364636656138 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28013"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00695731"
      },
      "bbox": [
        5.788693373340714, -4.8360547229885755, 6.118715465437987,
        -4.380941948697632
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.943272087232042, -5.090649734316056],
            [5.947937624001126, -5.089138067289611],
            [5.9504155790559565, -5.085970609890553],
            [5.953833516368561, -5.08609468556476],
            [5.95353253793346, -5.081592260068256],
            [5.957520077373988, -5.076868520313349],
            [5.964525577998273, -5.080294304700046],
            [5.975298985617298, -5.07894579885332],
            [5.977777265900699, -5.074953807080999],
            [5.981845796852533, -5.065268938301843],
            [5.98627788633057, -5.058350395033701],
            [5.9905928969081605, -5.055332056563729],
            [5.991355445390084, -5.050920589258468],
            [5.99944446950293, -5.047489081797479],
            [6.004992672739257, -5.042101516648276],
            [6.008599440121237, -5.043457777338872],
            [6.0126969270171315, -5.038027811353815],
            [6.018879966150067, -5.037905956788559],
            [6.020873042132803, -5.035861823391601],
            [6.030048558869777, -5.033432286872522],
            [6.034086412289001, -5.027635067315262],
            [6.037968588613322, -5.025367324474254],
            [6.050902450182722, -5.026863834883065],
            [6.0541219106030155, -5.026419265643711],
            [6.056318469299928, -5.023127707885678],
            [6.06483329932251, -5.022336806864847],
            [6.067999277484231, -5.015787852021492],
            [6.071165490059383, -5.014306422476739],
            [6.081347791319865, -5.015677932887971],
            [6.0917053384139335, -5.009676687088521],
            [6.101518854637158, -5.0086138961614255],
            [6.103434644734566, -5.006409926636979],
            [6.14958910916598, -5.003128078487931],
            [6.179790825979254, -5.000546849668647],
            [6.18636590755946, -5.092862871155144],
            [6.18931654897909, -5.129990175746814],
            [6.198032663175838, -5.247780221485716],
            [6.180951125417479, -5.24908388251416],
            [6.183158782843513, -5.2844323009910115],
            [6.184070592322027, -5.2897270782276165],
            [6.187347808655846, -5.336937947176715],
            [6.170788559869771, -5.338479387994774],
            [6.1007197480233275, -5.3436734128740175],
            [6.106634909577901, -5.431802135223604],
            [6.020390749870993, -5.438428880075356],
            [6.0129780072486465, -5.326647057833894],
            [6.00909580933341, -5.2617087419393025],
            [5.986592577409329, -5.263085944323365],
            [5.895250929525607, -5.269223620483609],
            [5.884847467224482, -5.121937714420034],
            [5.890773614405089, -5.1148583503782605],
            [5.904455767913812, -5.117810459516685],
            [5.90951879727591, -5.121886395704145],
            [5.914933042656983, -5.120570572411883],
            [5.919941492822414, -5.1163912017065964],
            [5.919409079418336, -5.108289037420743],
            [5.920392688853433, -5.106026381904734],
            [5.92650121389369, -5.1018577029112],
            [5.929882685756971, -5.097516574697123],
            [5.934048814324905, -5.097977744756895],
            [5.941777614961307, -5.09569902858038],
            [5.943272087232042, -5.090649734316056]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.24841962373695, "lat": 33.34731085372776 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28019"],
        "coty_name": ["Choctaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Choctaw County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00695734"
      },
      "bbox": [
        5.884847467224482, -5.438428880075356, 6.198032663175838,
        -5.000546849668647
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.302281147313269, -4.869878369811468],
            [5.297080415107306, -4.782033006470018],
            [5.311969177290994, -4.780040929247586],
            [5.339162445593093, -4.77836110422865],
            [5.426474493976584, -4.773615900108669],
            [5.426398895532301, -4.759238424954444],
            [5.469180705572203, -4.7566285169942235],
            [5.464573683189312, -4.682371186585332],
            [5.523361853442906, -4.678585446394403],
            [5.583647287939076, -4.675583406032325],
            [5.593545976945309, -4.674863893107955],
            [5.595715188569018, -4.704710421378877],
            [5.6382649391015836, -4.702107913999865],
            [5.810917862256217, -4.69019675806442],
            [5.818212665632947, -4.79536708809164],
            [5.821112309286178, -4.8360547229885755],
            [5.824369004609374, -4.880309671534366],
            [5.731650166418356, -4.886227899384396],
            [5.695234276464433, -4.889562135290605],
            [5.6808563178827916, -4.890301067619542],
            [5.645144667336549, -4.892993956793279],
            [5.5935849553313535, -4.896586154597298],
            [5.481882703128543, -4.904048715968966],
            [5.435098012944995, -4.907246776267372],
            [5.312488167368542, -4.914185993894976],
            [5.304872349162935, -4.914667096274823],
            [5.302281147313269, -4.869878369811468]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.80203911591835, "lat": 33.7699518480291 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28043"],
        "coty_name": ["Grenada"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grenada County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00695746"
      },
      "bbox": [
        5.297080415107306, -4.914667096274823, 5.824369004609374,
        -4.674863893107955
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.479101850574616, -6.771726816950422],
            [4.52103488705124, -6.770553241368984],
            [4.555598837762443, -6.770092979932619],
            [4.582574050552382, -6.770025089812791],
            [4.607092696397948, -6.769583741322035],
            [4.677473156823868, -6.769613452527534],
            [4.695060198751431, -6.773156808393972],
            [4.796012690454069, -6.791916150991634],
            [4.797150181821865, -6.792492503128374],
            [4.824335710182206, -6.797140108264439],
            [4.823664592242813, -6.805390439573342],
            [4.824245425421628, -6.814708715539729],
            [4.826955950644143, -6.81917026368476],
            [4.822565301587166, -6.825649801543485],
            [4.820878753865099, -6.830792704520771],
            [4.817794253548041, -6.8334947697987145],
            [4.817568540886293, -6.83853381245704],
            [4.915864035075474, -6.832471932235877],
            [4.920278226934236, -6.919757404457725],
            [4.9247058393856955, -7.006737506625843],
            [4.913866495894861, -7.006869935795033],
            [4.868800714403572, -7.010127103700321],
            [4.817763192505851, -7.012715750554209],
            [4.808077473910312, -7.0138101037606715],
            [4.759634570768671, -7.016101235088459],
            [4.702208481666488, -7.019306381207404],
            [4.660795391768304, -7.021358240665051],
            [4.571999014654151, -7.026425440125011],
            [4.570973407225171, -7.006099146652123],
            [4.516630346673013, -7.009982109218824],
            [4.503749722997063, -7.010551993855719],
            [4.496737534233811, -7.003377488904501],
            [4.4878141988710905, -6.997297093710447],
            [4.472352324064242, -6.994302644686906],
            [4.470866855058531, -6.99076434292031],
            [4.474992861256975, -6.985870637148207],
            [4.4734592265377096, -6.97763786220473],
            [4.470849416077989, -6.975718920549303],
            [4.467523342320191, -6.97706199168604],
            [4.45946014441029, -6.9754158843531],
            [4.45547477828337, -6.9717208330594636],
            [4.450551017810211, -6.971995128247967],
            [4.446639940187778, -6.970117443027048],
            [4.447158121125615, -6.966064743067019],
            [4.4444477608062956, -6.961801339125723],
            [4.448558917243855, -6.9572595017943195],
            [4.45107967028755, -6.9510828322051],
            [4.448638095256693, -6.948869289040852],
            [4.448931840880388, -6.944915112748674],
            [4.444513453097579, -6.9429413621282],
            [4.445284207479369, -6.9342981106094115],
            [4.4419474729523225, -6.934445084936377],
            [4.441598483296622, -6.928957084488826],
            [4.437334317507658, -6.932376647832725],
            [4.426176569282348, -6.894224740413297],
            [4.43223922051513, -6.89464701270958],
            [4.448504527049417, -6.897652756307794],
            [4.462172496838686, -6.896724283340415],
            [4.4719896017627265, -6.887300319798185],
            [4.474856770177653, -6.8803471186447425],
            [4.471669687031877, -6.87480893009165],
            [4.462304324237675, -6.871095679729225],
            [4.451971419408869, -6.870722932675712],
            [4.43932657885811, -6.8766507709952736],
            [4.4187387861731855, -6.882889051376864],
            [4.3941849655997105, -6.8875264391745326],
            [4.385288746139526, -6.884398772975869],
            [4.385905732061278, -6.865663864616074],
            [4.388524594063002, -6.846566900181975],
            [4.398047987685686, -6.802666298842517],
            [4.403800088456421, -6.79399709401581],
            [4.412494976511342, -6.790077273790604],
            [4.429639235230271, -6.787540045630785],
            [4.44136231435797, -6.783269544508224],
            [4.44548719413541, -6.796348865405796],
            [4.445449096582363, -6.80953663100834],
            [4.446308503322346, -6.814484660226237],
            [4.4506229409237585, -6.824557088322552],
            [4.453083503869968, -6.828030780750723],
            [4.4579001135546195, -6.831188325175863],
            [4.464347065944522, -6.833066621699709],
            [4.4704215639402465, -6.832566213603929],
            [4.475663829984525, -6.829010922231281],
            [4.48005491918326, -6.823699946021911],
            [4.482144194955925, -6.819041296390034],
            [4.48364580232201, -6.8098546963097695],
            [4.483072111537587, -6.8081674481213],
            [4.464443686371776, -6.791118296735107],
            [4.46238581803835, -6.787225063158365],
            [4.462939797540298, -6.779707753352718],
            [4.465586186898657, -6.776780095007698],
            [4.479101850574616, -6.771726816950422]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.03725184177058, "lat": 31.73423322570441 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28063"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00695755"
      },
      "bbox": [
        4.385288746139526, -7.026425440125011, 4.9247058393856955,
        -6.769583741322035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.19090265173701, -7.65330055193041],
            [4.200721240711668, -7.646923556141986],
            [4.216350994530209, -7.64039437316377],
            [4.229748623984582, -7.6337536780702395],
            [4.239717281256838, -7.626566125850546],
            [4.245181479348621, -7.620588676434384],
            [4.25097915683476, -7.611180109890588],
            [4.253339553903447, -7.603844207309261],
            [4.254100140863162, -7.5959510298685435],
            [4.252608493953842, -7.589263942052128],
            [4.249885750760846, -7.583492771665467],
            [4.246745307326735, -7.580297195468408],
            [4.222690896640733, -7.560243274746931],
            [4.209577291505445, -7.550776740169262],
            [4.2049802743332485, -7.548199543831536],
            [4.198934279904487, -7.542601825324062],
            [4.1948266435523145, -7.536179290267313],
            [4.194523513136372, -7.524377231918129],
            [4.1975887708972754, -7.516164773886942],
            [4.21166012199533, -7.497919693357467],
            [4.217323451662294, -7.48874967327846],
            [4.223449706884702, -7.473435562334294],
            [4.222520153908516, -7.460975043439819],
            [4.22525418692547, -7.459212611527724],
            [4.22708364598019, -7.451399174490883],
            [4.224021276468661, -7.447417698353371],
            [4.22708294922278, -7.437811901252067],
            [4.230695374978281, -7.433794295182749],
            [4.232699892333876, -7.427301633870386],
            [4.24505959247799, -7.415643398254243],
            [4.251711033835754, -7.412333256671104],
            [4.256159752396916, -7.411495949176806],
            [4.261639040613654, -7.412141602258909],
            [4.267687401078013, -7.4155935717788495],
            [4.270984069054074, -7.419668634095769],
            [4.272278794535553, -7.425701810709859],
            [4.271923498764663, -7.435076172737799],
            [4.280570385764719, -7.434202996090054],
            [4.289480985709147, -7.4281445122268535],
            [4.290836570786693, -7.423099077147699],
            [4.2993291046929265, -7.424003271582995],
            [4.304170331641666, -7.421234243535902],
            [4.3063739706946444, -7.414628201321772],
            [4.309484357648664, -7.414774517611669],
            [4.310580994933524, -7.410835500164326],
            [4.314466877477502, -7.409014317508595],
            [4.312445325915574, -7.404695295741231],
            [4.315148450879641, -7.402211506574157],
            [4.312930833976369, -7.397750203083054],
            [4.314858752858118, -7.388523945836937],
            [4.309662844675765, -7.383030221164191],
            [4.304527535204707, -7.383397818591313],
            [4.302013747315744, -7.3775190796875485],
            [4.29698122628251, -7.373162524221792],
            [4.298633686114623, -7.364591419925567],
            [4.301442642278867, -7.364109477768371],
            [4.311279146554579, -7.366726745557772],
            [4.315175380907493, -7.362150467322528],
            [4.317750864670325, -7.362773080462625],
            [4.317723654938278, -7.35582307970826],
            [4.32020323333758, -7.349618263467307],
            [4.3194334489514, -7.328497135287324],
            [4.340793476132594, -7.327720650344549],
            [4.346740244252619, -7.329505377669957],
            [4.348736207322924, -7.332479717981284],
            [4.357590334005569, -7.330892038092351],
            [4.360083176201861, -7.327196057957806],
            [4.3648858705234055, -7.325354699103173],
            [4.3663151379134, -7.321981431231981],
            [4.3768099036120045, -7.319467766406514],
            [4.379489480219272, -7.3196360083064524],
            [4.382719620815289, -7.31372494339708],
            [4.38438610700838, -7.320183854822925],
            [4.387785725353091, -7.317757754474974],
            [4.389863040763091, -7.311164314940331],
            [4.393973445639544, -7.310282349587384],
            [4.395851222647188, -7.307467733464878],
            [4.402074454788559, -7.30941362710896],
            [4.40574850783043, -7.308238188113762],
            [4.405892137331629, -7.303208766881215],
            [4.408682186811525, -7.302929142099787],
            [4.413769103031917, -7.2997112908655994],
            [4.419178599087694, -7.303208449190989],
            [4.426182443493374, -7.302978625823468],
            [4.436566865675468, -7.291475350240733],
            [4.443415869169236, -7.29003345718538],
            [4.4471214550202856, -7.285886941746449],
            [4.452830694253412, -7.2871076442148395],
            [4.453891481158558, -7.282187151430905],
            [4.457535895835353, -7.280573004122794],
            [4.465905445614267, -7.280878742290794],
            [4.469518853441953, -7.284628607496056],
            [4.475177556711718, -7.282892620129008],
            [4.483268118669798, -7.272061304438865],
            [4.491778144008933, -7.27049621202166],
            [4.493316701171424, -7.279088023325004],
            [4.49704300786867, -7.279470723927243],
            [4.498753832112568, -7.273999780447158],
            [4.502048717503571, -7.27594881783927],
            [4.506687596761808, -7.271478751032491],
            [4.509893061976232, -7.271385283760106],
            [4.513527116123457, -7.267622631748607],
            [4.519466598737841, -7.267869244115881],
            [4.5234207127903865, -7.266383095102698],
            [4.532129240514339, -7.271126377138259],
            [4.537071291502514, -7.275769119712954],
            [4.534648912435315, -7.280616580153235],
            [4.538404640411904, -7.28270758153965],
            [4.5474492650705525, -7.283612183259452],
            [4.554555717131722, -7.279822127091811],
            [4.556724101206017, -7.282530376643407],
            [4.5573064563122205, -7.287275171440999],
            [4.564092316363185, -7.285128372742843],
            [4.56991820257896, -7.290220908262002],
            [4.577777521173775, -7.2847879382044365],
            [4.581832797935605, -7.288616343332306],
            [4.585067046744882, -7.292079340532085],
            [4.5916598887285165, -7.287048076988581],
            [4.596837596988162, -7.29256734789434],
            [4.594324211215088, -7.294619831883999],
            [4.602406541349156, -7.302793352241041],
            [4.608240857031876, -7.303558287848584],
            [4.609272557934101, -7.306912940410678],
            [4.615649548812471, -7.308570788639268],
            [4.615837854986028, -7.312451742566901],
            [4.622851356903841, -7.313191407562752],
            [4.629967512313584, -7.305656588404577],
            [4.636489115041845, -7.311473166446786],
            [4.6399360053999805, -7.314568054724674],
            [4.643006245108148, -7.314587022017948],
            [4.647324481567077, -7.325434703256276],
            [4.647878444481892, -7.332176208898646],
            [4.651259858555769, -7.33552694809126],
            [4.65008760396464, -7.338122847482782],
            [4.6512862901679295, -7.342756749909041],
            [4.657031135283812, -7.3437620277110325],
            [4.658582872616894, -7.346187854401424],
            [4.665945267885108, -7.34925110475591],
            [4.66906595937955, -7.34872534761063],
            [4.672818856600061, -7.419916882001154],
            [4.674305274102635, -7.452785783701703],
            [4.677069524595775, -7.5044890588426725],
            [4.679224164445328, -7.533429906109787],
            [4.680502465132847, -7.5603083090436565],
            [4.683355902730732, -7.628636674763464],
            [4.683182484446143, -7.629864179954288],
            [4.6421556314462205, -7.632041850972545],
            [4.584237070552856, -7.634715921784135],
            [4.542671829472003, -7.636758951905845],
            [4.5241784597178905, -7.637388867159569],
            [4.437707233809829, -7.64191204276206],
            [4.373016398222828, -7.645235978704202],
            [4.310047259081583, -7.648197153985579],
            [4.307735296942791, -7.648619260345873],
            [4.274743640945073, -7.649468184404047],
            [4.201007726216122, -7.6530876539327295],
            [4.19090265173701, -7.65330055193041]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.31095862572445,
          "lat": 31.161061486526012
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28157"],
        "coty_name": ["Wilkinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilkinson County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00695799"
      },
      "bbox": [
        4.19090265173701, -7.65330055193041, 4.683355902730732,
        -7.266383095102698
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.138895759409813, 9.988644485099405],
            [-4.051846244605721, 9.982464080696397],
            [-3.964987432490997, 9.976485279693078],
            [-3.8777567627945757, 9.97068497201761],
            [-3.8201662595006938, 9.966640430586533],
            [-3.7615913874017113, 9.962700224803582],
            [-3.7038280996377266, 9.958973419991343],
            [-3.6167709331267885, 9.953351509215631],
            [-3.529826869968538, 9.948094891571548],
            [-3.5352145053474295, 9.863338711644749],
            [-3.5408319063245295, 9.778540272676299],
            [-3.506479138801442, 9.776472688616012],
            [-3.5091287925850447, 9.732536101244188],
            [-3.5152973649800106, 9.635456128609363],
            [-3.5211451480400426, 9.544699521827319],
            [-3.52794786290628, 9.43598395396092],
            [-3.493894777097633, 9.43390002603625],
            [-3.4995035320641676, 9.347247008480906],
            [-3.5048676443679296, 9.262375178175791],
            [-3.5916824327183354, 9.267772885966332],
            [-3.671228630884416, 9.272770115567663],
            [-3.682741381797088, 9.273600746859294],
            [-3.7822284293643724, 9.279863329083737],
            [-3.8516050594165576, 9.28465207271377],
            [-3.8576612000504835, 9.196921766441328],
            [-3.865684619831392, 9.192741934212863],
            [-3.8720225317777968, 9.191396097674579],
            [-3.8780642262274374, 9.19238830094321],
            [-3.8895355765040667, 9.20032458781856],
            [-3.9072658458570952, 9.203085879074168],
            [-3.9161174179377634, 9.207609770363534],
            [-3.925520853918248, 9.217868157359092],
            [-3.9303766017631507, 9.222222465134958],
            [-3.936029234158822, 9.224863320410545],
            [-3.947895505120287, 9.227926863333062],
            [-3.9571351290039987, 9.22776868941126],
            [-3.965592552997889, 9.226183652672397],
            [-3.975204321458151, 9.226544389468282],
            [-3.9891880260003285, 9.236143478215379],
            [-3.9975399723689455, 9.242804470227343],
            [-4.007701413394632, 9.248805234216993],
            [-4.01559788547326, 9.255143351805735],
            [-4.01952593529948, 9.26385861138114],
            [-4.026415406597234, 9.272876401201255],
            [-4.030102150194169, 9.279219489036514],
            [-4.032832495561112, 9.300908327999876],
            [-4.033149757026814, 9.310750530364231],
            [-4.031424228325942, 9.323584691440761],
            [-4.027336180427902, 9.330564883294635],
            [-4.025988409632202, 9.343818952472937],
            [-4.0247911481694345, 9.349231755995206],
            [-4.022348038081457, 9.354067622185772],
            [-4.013458285589869, 9.363855312008983],
            [-4.007990954707901, 9.372212035379023],
            [-4.005109151282699, 9.37466267064016],
            [-3.996993343755314, 9.384111631587919],
            [-3.9836683583303816, 9.39163299909916],
            [-3.973962002221285, 9.399888391396606],
            [-3.9649242421849755, 9.411257310516023],
            [-3.9615973872868917, 9.416805372139107],
            [-3.953796398802151, 9.432553987482057],
            [-3.953435244688459, 9.436979675395392],
            [-3.95655822292432, 9.441804414591225],
            [-3.967032640454892, 9.4459033376239],
            [-3.974846342323931, 9.450010040455318],
            [-3.980824722396828, 9.45411439518166],
            [-3.983197589613944, 9.45720310747647],
            [-3.9838457317698577, 9.46221401864264],
            [-3.9827918249250973, 9.479376408386678],
            [-3.9881885577650973, 9.488673247219277],
            [-3.9935730462594594, 9.488980585083473],
            [-4.000074561807452, 9.484030041913389],
            [-4.009950767888445, 9.481121627106507],
            [-4.019837792286144, 9.483895060976922],
            [-4.024274763115993, 9.487741456470568],
            [-4.028015500789689, 9.495840747506907],
            [-4.024554247655557, 9.503419081970263],
            [-4.022928844710322, 9.512828877712312],
            [-4.0231614384486205, 9.520787648231394],
            [-4.025772896229212, 9.524148260180182],
            [-4.031983636177222, 9.52729402083251],
            [-4.039758610152923, 9.528837750744017],
            [-4.049380906870709, 9.533652468156943],
            [-4.0630996390991205, 9.534511750037685],
            [-4.069180698894148, 9.535427096078871],
            [-4.076383882400831, 9.538578962134157],
            [-4.085332379922465, 9.54148859160734],
            [-4.084905014625641, 9.5437961677378],
            [-4.074001173598069, 9.547959177047408],
            [-4.071735952562635, 9.552892849205252],
            [-4.070150166314214, 9.563220743140686],
            [-4.074514805911, 9.57063598991535],
            [-4.08287736089455, 9.576125194015766],
            [-4.0884768563446965, 9.5779767675189],
            [-4.101842968432081, 9.570505347961298],
            [-4.108417882425044, 9.568383185740801],
            [-4.116278861472193, 9.568749646698397],
            [-4.130724043439139, 9.574405491331797],
            [-4.130415981432041, 9.57571246227887],
            [-4.127009818804898, 9.620549667578475],
            [-4.12695758583491, 9.623428064656585],
            [-4.123093115804195, 9.6750736405097],
            [-4.116084503913682, 9.773109643402798],
            [-4.112806659724847, 9.816914386104731],
            [-4.151407389871608, 9.819722931868498],
            [-4.14511788950942, 9.904108730358892],
            [-4.138895759409813, 9.988644485099405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.35569016183683,
          "lat": 48.20132246655838
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38061"],
        "coty_name": ["Mountrail"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mountrail County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01035307"
      },
      "bbox": [
        -4.151407389871608, 9.191396097674579, -3.493894777097633,
        9.988644485099405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.462710634296814, 2.134863122035224],
            [10.459582993869523, 2.1727093098087775],
            [10.452653680938413, 2.2518066811856845],
            [10.449834845617852, 2.2869394393879228],
            [10.530219419337808, 2.293844817696697],
            [10.57841855562512, 2.2977423620026802],
            [10.626490521932054, 2.301317375157163],
            [10.657202857498726, 2.303800495913317],
            [10.659038234165212, 2.2848215506821177],
            [10.691350301378936, 2.2874097619520826],
            [10.736367616302449, 2.2913133113941764],
            [10.77956003966471, 2.2958775392974897],
            [10.806989563749157, 2.299472947388447],
            [10.806890935991746, 2.3003979239971275],
            [10.837640512052953, 2.3046190911629707],
            [10.870673514286581, 2.308567978194558],
            [10.880536346446942, 2.3095546825385247],
            [10.885730827731606, 2.253652738571386],
            [10.887814567660941, 2.2375149388867195],
            [10.895703735077511, 2.1643884791862638],
            [10.903232981378558, 2.092410003701578],
            [10.905145278717072, 2.0760601678979613],
            [10.910744786356782, 2.0200339664293177],
            [10.89617303773956, 2.0188700596505513],
            [10.88583706225138, 2.0172940778261514],
            [10.889632176416857, 1.9793041671486826],
            [10.811535117437789, 1.9727978983806416],
            [10.749392663626196, 1.9683627409706728],
            [10.748970064293156, 1.9738952060561397],
            [10.715048805582574, 1.9715158922018359],
            [10.707829323461254, 1.9650661007849448],
            [10.683362076852868, 1.96323748413119],
            [10.625567650673752, 1.958520536907813],
            [10.603899909170792, 1.9564638382502002],
            [10.550201427609514, 1.9522398771003728],
            [10.480535235199392, 1.947408955669762],
            [10.473246365575271, 1.9467311341661075],
            [10.47040508755611, 1.9836393688145166],
            [10.474665438451124, 1.9840645141273057],
            [10.468944859447587, 2.059542044114339],
            [10.465208241924286, 2.1065453641830514],
            [10.462710634296814, 2.134863122035224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.48312194585309,
          "lat": 40.091622824816234
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39089"],
        "coty_name": ["Licking"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Licking County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01074057"
      },
      "bbox": [
        10.449834845617852, 1.9467311341661075, 10.910744786356782,
        2.3095546825385247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.894000618743434, 2.62790212436848],
            [9.89394377846357, 2.6283570473927647],
            [9.946293272855709, 2.635396133071802],
            [9.979737499736295, 2.6396638804403754],
            [9.97776681476504, 2.65452821951741],
            [10.035563741678473, 2.662628463770097],
            [10.061464169092526, 2.665931083097504],
            [10.121642082229432, 2.6749133848684754],
            [10.153739379747917, 2.679548737270786],
            [10.235959793492432, 2.6909666766434426],
            [10.249571437525463, 2.6939552157749493],
            [10.309776421669559, 2.702949807664742],
            [10.316845192136048, 2.6442979541325324],
            [10.281661205555016, 2.6390472132223746],
            [10.243948649704317, 2.632935510836932],
            [10.247968987052957, 2.603940169964158],
            [10.264829110089114, 2.478662737584969],
            [10.22207121680395, 2.4665175205337064],
            [10.226038910625054, 2.415465378993149],
            [10.156173209851916, 2.409162454610214],
            [10.121011981998594, 2.4062911853911033],
            [10.097268686962037, 2.404760382908195],
            [10.054364460502594, 2.4024745890872645],
            [10.052003287169349, 2.421721390333612],
            [10.046079891807144, 2.465520611846301],
            [9.919046216620702, 2.4466252668153468],
            [9.919971979208043, 2.4570551584772904],
            [9.910993849014153, 2.508177656765982],
            [9.907344850684405, 2.527560316551438],
            [9.903387426264102, 2.5551071435257455],
            [9.89956251394907, 2.586478216483751],
            [9.894000618743434, 2.62790212436848]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.16093046134004, "lat": 40.58717185856992 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39101"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01074063"
      },
      "bbox": [
        9.89394377846357, 2.4024745890872645, 10.316845192136048,
        2.702949807664742
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.887814567660941, 2.2375149388867195],
            [10.958973254960895, 2.243574949393102],
            [10.963435694829062, 2.2433414927166515],
            [11.00977048883476, 2.2493565231426826],
            [11.14118189365723, 2.264389509552798],
            [11.172519455389445, 2.267814259672055],
            [11.242615320880834, 2.2760043535221124],
            [11.24272000971061, 2.275318609299213],
            [11.247483223217307, 2.230821430856591],
            [11.25262951622552, 2.1855146719377356],
            [11.258909229652769, 2.1281976309174624],
            [11.26675843576994, 2.0541324379395838],
            [11.295082701861642, 2.0574292216222956],
            [11.299479518713872, 2.023028605739377],
            [11.29951880067113, 2.021052452149919],
            [11.30613301977338, 1.9692097504719341],
            [11.316827338022115, 1.8820043617068845],
            [11.277047154909312, 1.8780753793596359],
            [11.166732850854487, 1.8678658930996694],
            [11.141859026564983, 1.8654325272610341],
            [11.114013824587246, 1.8619918295255642],
            [11.07156143129525, 1.8590174614239243],
            [11.0717037503112, 1.8579534934945043],
            [11.0289071350034, 1.854652679429541],
            [11.02502760874576, 1.9002376224721882],
            [10.97985009011672, 1.8962062267502233],
            [10.95124451959168, 1.8940038228645308],
            [10.949073999194942, 1.922172000427157],
            [10.944047213485522, 1.9832962152538303],
            [10.889632176416857, 1.9793041671486826],
            [10.88583706225138, 2.0172940778261514],
            [10.89617303773956, 2.0188700596505513],
            [10.910744786356782, 2.0200339664293177],
            [10.905145278717072, 2.0760601678979613],
            [10.903232981378558, 2.092410003701578],
            [10.895703735077511, 2.1643884791862638],
            [10.887814567660941, 2.2375149388867195]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.94437297269411,
          "lat": 39.965425533401344
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39119"],
        "coty_name": ["Muskingum"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Muskingum County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01074072"
      },
      "bbox": [
        10.88583706225138, 1.854652679429541, 11.316827338022115,
        2.2760043535221124
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.301067064378215, 3.5030554941018335],
            [11.369752197114655, 3.512740578320861],
            [11.44855641664807, 3.5253050711378706],
            [11.50575699208325, 3.5340781302638558],
            [11.549900845289898, 3.541472986310708],
            [11.586983035083497, 3.5474435105781064],
            [11.592996453758989, 3.5097261446933135],
            [11.599252385026842, 3.4719493954235774],
            [11.610305508252043, 3.403248090412519],
            [11.62149354085039, 3.335215450550093],
            [11.635997801930916, 3.2436097951947094],
            [11.637625330410682, 3.236050078651091],
            [11.645130220094828, 3.1897409965574175],
            [11.582528384509885, 3.180076032726013],
            [11.501626386159446, 3.1675207424855256],
            [11.496137934815104, 3.166440266821313],
            [11.461878877896426, 3.161456915518442],
            [11.381835729082296, 3.149363986383345],
            [11.355440258353191, 3.145086751752945],
            [11.34742154723077, 3.1969334188599827],
            [11.33352958285996, 3.2914048725354874],
            [11.332688633073545, 3.2956259151489897],
            [11.32377898068397, 3.3541033624468617],
            [11.323333833156457, 3.3584319037490142],
            [11.317491184730022, 3.3950928891106518],
            [11.310929374289232, 3.4391969521408656],
            [11.301067064378215, 3.5030554941018335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.19739160710397, "lat": 41.16767687341024 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39133"],
        "coty_name": ["Portage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Portage County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01074079"
      },
      "bbox": [
        11.301067064378215, 3.145086751752945, 11.645130220094828,
        3.5474435105781064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5487884446850195, -1.6919307311075726],
            [-1.4415260559116152, -1.6952132086799063],
            [-1.3926391388593338, -1.696992514955731],
            [-1.3061006897590661, -1.6990690734396863],
            [-1.206674519568244, -1.7011810711730118],
            [-1.2075340638815526, -1.757785497744225],
            [-1.2060265380399178, -1.7578219918253317],
            [-1.2083533705305507, -1.859942658733724],
            [-1.2090384378721077, -1.8869639389805264],
            [-1.2094281681893435, -1.8897975851898954],
            [-1.2106458269982678, -1.9337434364595405],
            [-1.2102831125677578, -1.9371003239808442],
            [-1.2108390708803765, -1.9523705828173337],
            [-1.2122666096842996, -2.036217625095114],
            [-1.21211723246723, -2.037328026270028],
            [-1.2136237600498885, -2.1093414273952393],
            [-1.2096286626669668, -2.109440031053888],
            [-1.211436456413361, -2.189907208765864],
            [-1.2126569566932497, -2.2410266803278587],
            [-1.3050475382716236, -2.238652416418245],
            [-1.4261257390066917, -2.2359293786257326],
            [-1.5544743548452797, -2.2325650551975125],
            [-1.5507772067646473, -2.100475900426841],
            [-1.5564218539817156, -2.1003323608315996],
            [-1.552939144698908, -1.9687574246869612],
            [-1.5489934005319965, -1.8297060093583581],
            [-1.5479030481569331, -1.7857120514481],
            [-1.5468228982610093, -1.7492960435396645],
            [-1.5505827919269968, -1.7491823570502545],
            [-1.5487884446850195, -1.6919307311075726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.32399830494981, "lat": 36.73104932860858 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40003"],
        "coty_name": ["Alfalfa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alfalfa County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01101789"
      },
      "bbox": [
        -1.5564218539817156, -2.2410266803278587, -1.2060265380399178,
        -1.6919307311075726
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.206674519568244, -1.7011810711730118],
            [-1.0906619336153474, -1.7033297333255357],
            [-0.9617690135835076, -1.7056372150447399],
            [-0.878562815398253, -1.707054409838249],
            [-0.8311328632051108, -1.707619593146765],
            [-0.806948958437267, -1.7084439614218443],
            [-0.6929022236523971, -1.710281293741514],
            [-0.6937496789266913, -1.767764593422249],
            [-0.6954301030077024, -1.8706391808138525],
            [-0.6957845739942721, -1.8998948932791475],
            [-0.6969854403879655, -1.9765548236901067],
            [-0.69864630719914, -2.0824641777459423],
            [-0.6992838418947911, -2.1189611686825587],
            [-0.7629772501200237, -2.118098145540102],
            [-0.8421355886772577, -2.1167959412204214],
            [-0.9471336074264104, -2.1150764888217806],
            [-1.0564265202425194, -2.1127042158688907],
            [-1.181452959219671, -2.1101309308365153],
            [-1.2096286626669668, -2.109440031053888],
            [-1.2136237600498885, -2.1093414273952393],
            [-1.21211723246723, -2.037328026270028],
            [-1.2122666096842996, -2.036217625095114],
            [-1.2108390708803765, -1.9523705828173337],
            [-1.2102831125677578, -1.9371003239808442],
            [-1.2106458269982678, -1.9337434364595405],
            [-1.2094281681893435, -1.8897975851898954],
            [-1.2090384378721077, -1.8869639389805264],
            [-1.2083533705305507, -1.859942658733724],
            [-1.2060265380399178, -1.7578219918253317],
            [-1.2075340638815526, -1.757785497744225],
            [-1.206674519568244, -1.7011810711730118]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.78610940465715, "lat": 36.79613146583903 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40053"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01101814"
      },
      "bbox": [
        -1.2136237600498885, -2.1189611686825587, -0.6929022236523971,
        -1.7011810711730118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.1293588647100197, -1.71653143591407],
            [-0.11887798166524768, -1.716312595063542],
            [-0.016664392958471497, -1.7173889177256418],
            [0.04802046030582264, -1.7179995906810215],
            [0.06802344230198813, -1.718177170455022],
            [0.15188160265296427, -1.7179882891438734],
            [0.24514029695558545, -1.718266703076506],
            [0.30552259160093653, -1.718663211612456],
            [0.3175932381161457, -1.7185029439775996],
            [0.3520461302593864, -1.7188021999395684],
            [0.4630993689258249, -1.7189991781328489],
            [0.4631339050875564, -1.850367916426757],
            [0.4632313653310919, -1.9678283786148492],
            [0.4632348196092242, -2.0445504932840843],
            [0.46297917841434344, -2.186744026964836],
            [0.4628066709728013, -2.299333979222858],
            [0.46253583856768843, -2.4387229960284564],
            [0.46268827738561125, -2.4448869565438516],
            [0.4626067320802887, -2.5041188631638476],
            [0.46275941454247727, -2.563957398535833],
            [0.3964949723126417, -2.5643401076388166],
            [0.31205149527743814, -2.5639453762181645],
            [0.24914609813034336, -2.562965123355676],
            [0.2476265531970455, -2.5572696707304305],
            [0.24846287740290335, -2.5511613671107454],
            [0.2522042484814238, -2.5453646598285578],
            [0.25765201643135166, -2.541126281968367],
            [0.26580344497349323, -2.533193797468808],
            [0.26868946669925425, -2.5277398004574727],
            [0.2696241098182488, -2.519912968347828],
            [0.2668354182117782, -2.509870080375687],
            [0.26077242488577607, -2.500686549396433],
            [0.25640664703599647, -2.497931833154514],
            [0.2500982364447086, -2.496950304270179],
            [0.23159967806793558, -2.4974779398114753],
            [0.22281307632015324, -2.496088205318404],
            [0.20262208537267348, -2.4977066392498615],
            [0.1920343346201521, -2.4941672287758467],
            [0.18288723640392235, -2.4866150079186116],
            [0.17407814520379705, -2.4738803964823974],
            [0.1671157090535287, -2.4680790314028997],
            [0.15478944774131387, -2.4565977517570157],
            [0.14322424655057153, -2.450166072870243],
            [0.12637329186691076, -2.4460702005642845],
            [0.12209142772703273, -2.4433008666709823],
            [0.11731970015202851, -2.4375246835147952],
            [0.11405379164663439, -2.4291692447371545],
            [0.11363901660593653, -2.4181833935386368],
            [0.11092002546324495, -2.408017769692947],
            [0.10794300027787249, -2.4018002449144493],
            [0.09916179197181782, -2.3907601542403953],
            [0.09313298350908938, -2.3888398816795973],
            [0.08541688393877449, -2.38926879132587],
            [0.07739110896786053, -2.391719553744412],
            [0.07418947753356629, -2.3949265925659784],
            [0.06678622192444036, -2.4055800454061647],
            [0.0634437727365049, -2.4156066764858966],
            [0.059996637599967095, -2.4199392885020874],
            [0.05237286937415993, -2.4246516227497783],
            [0.04433652007940934, -2.4265511199036824],
            [0.03545007748206532, -2.426490436637478],
            [0.026984704081428484, -2.424717631485458],
            [0.0226614956559949, -2.4228782852752166],
            [0.01355530402131135, -2.416600113333894],
            [0.005969901974314947, -2.4068605315052065],
            [0.006888592812230866, -2.3897949766209843],
            [0.017702339442928983, -2.37381461773075],
            [0.021751686041215794, -2.371078772077632],
            [0.027727838175499606, -2.370229803238711],
            [0.03756996701031373, -2.3664509894498127],
            [0.046425083257324175, -2.3571624622501313],
            [0.05003097214577991, -2.3447145879197144],
            [0.04714217326987087, -2.3351318416777462],
            [0.043832077529747236, -2.327889647652069],
            [0.036095311151916984, -2.3221454921389597],
            [0.032602848063520096, -2.321594155035833],
            [0.026363986711310856, -2.3256667024329136],
            [0.016388860573893573, -2.3357464839915636],
            [0.012038519254308723, -2.3416263076922785],
            [0.004559579259038709, -2.347709882869761],
            [-0.001345430289530313, -2.3485171318238343],
            [-0.0078393107673196, -2.3469025695900254],
            [-0.016273344086370295, -2.3396015930596805],
            [-0.0180559937256857, -2.3234538527411726],
            [-0.019781851271492994, -2.3183874351624656],
            [-0.02501777755660036, -2.316273993093192],
            [-0.030726867694276717, -2.311576904630226],
            [-0.03247179105910358, -2.3050907781223047],
            [-0.03635233829664462, -2.299156381778014],
            [-0.042971997831408225, -2.295399422188263],
            [-0.0524508043549771, -2.2973700203535192],
            [-0.06368906802573968, -2.298495039515771],
            [-0.07392633172491227, -2.300719932806362],
            [-0.08637476913606938, -2.2969125757755218],
            [-0.09575227589149142, -2.2895197470535473],
            [-0.09903117055963412, -2.2854354116346896],
            [-0.10269517045118408, -2.283126406292978],
            [-0.10770261964911747, -2.275333766543415],
            [-0.10839295120470006, -2.266617152474271],
            [-0.10368670095623198, -2.2553011565936494],
            [-0.10201232729109631, -2.2495789217163225],
            [-0.09875072708443744, -2.2428989961117853],
            [-0.09874320102662251, -2.2341752326036413],
            [-0.10141192960921984, -2.229143773727084],
            [-0.10956004248600922, -2.2233920011058705],
            [-0.11341271547353467, -2.2169236393922107],
            [-0.11201351225738108, -2.211150863502144],
            [-0.11219782407576188, -2.199809482331892],
            [-0.11490859372336089, -2.1937893907584813],
            [-0.11590136641699283, -2.187889269189416],
            [-0.1193260580853819, -2.176496465999024],
            [-0.12290916225978651, -2.16955316960124],
            [-0.1275881294793108, -2.1655661072696177],
            [-0.13195785268538085, -2.159960947600964],
            [-0.13579120666953445, -2.1568284335759187],
            [-0.1484308468785781, -2.1538963627856487],
            [-0.15940647381702056, -2.158742129104649],
            [-0.16554880500253377, -2.163688175908651],
            [-0.1713470700186907, -2.16566249388138],
            [-0.17915846389596088, -2.1722610143495573],
            [-0.18934535619144877, -2.179875323813245],
            [-0.1940074971835452, -2.1897326497047414],
            [-0.20042079443235275, -2.194620928254122],
            [-0.20311990568780328, -2.1984690711743817],
            [-0.20335698248051434, -2.2075644998812796],
            [-0.21120175738244581, -2.2204954711596097],
            [-0.21464374377776785, -2.228339374793025],
            [-0.21913842896903282, -2.2335184580566594],
            [-0.22566920529873824, -2.238214709079234],
            [-0.2276083573506143, -2.2419234677904063],
            [-0.2335195116696136, -2.248485844527661],
            [-0.2403996867006655, -2.246833398416084],
            [-0.24555929186138262, -2.247257376070306],
            [-0.2505457587122237, -2.2505142580047606],
            [-0.2562104195994407, -2.250232661432873],
            [-0.26314518903132006, -2.2513083785975874],
            [-0.26721398340436964, -2.2552115058710713],
            [-0.2736150866083995, -2.2563993487735168],
            [-0.28026851882116616, -2.262808558234491],
            [-0.2853805004347413, -2.263515775850825],
            [-0.29656986259085055, -2.2588406908298535],
            [-0.3068556408714204, -2.2586661756854993],
            [-0.31851414901040953, -2.252554605857548],
            [-0.31992257983936934, -2.248084273360196],
            [-0.3269092974897378, -2.240560783697962],
            [-0.33332914886562454, -2.2371211113193916],
            [-0.33818819143244944, -2.2289570494010107],
            [-0.3402401998362652, -2.2110913587893823],
            [-0.33850694061539527, -2.1996272154225474],
            [-0.3334437597108435, -2.19239786732551],
            [-0.32918633711697026, -2.1889691184907485],
            [-0.31541486932490403, -2.1828249568671536],
            [-0.30944618367026583, -2.182135571401914],
            [-0.30334286263875637, -2.1840105733721624],
            [-0.2991470861409725, -2.1839026563093675],
            [-0.2922636097305453, -2.180951216095675],
            [-0.28748321543792255, -2.17477619069229],
            [-0.28301329549563464, -2.171433681495629],
            [-0.2720585054249657, -2.165758171749304],
            [-0.2625061042111177, -2.1654953232384653],
            [-0.2545113826320524, -2.1671071125377224],
            [-0.25165878223949295, -2.1652818587029175],
            [-0.24462866329104213, -2.1548749198253105],
            [-0.2435051265824993, -2.1520595679558787],
            [-0.242873528510941, -2.142799893294461],
            [-0.2555931822968319, -2.1292072233408286],
            [-0.25891027856018284, -2.1222666078587165],
            [-0.26209714790077565, -2.1190509525591477],
            [-0.2682319807418759, -2.1172625431829615],
            [-0.27297374076355857, -2.1182920067359796],
            [-0.278806065160434, -2.1223261205081325],
            [-0.2850499715519918, -2.123768851509075],
            [-0.2907123710985477, -2.127802707522664],
            [-0.31240957268146463, -2.1324148464864083],
            [-0.31616365582371153, -2.1316175352064923],
            [-0.32592567960678637, -2.1325281912409553],
            [-0.3350606074787418, -2.134815320267125],
            [-0.36013411356815245, -2.130894128868995],
            [-0.37598067570755717, -2.124417141901216],
            [-0.3772968755267187, -2.1229799329518566],
            [-0.3745288561807073, -2.118727763477953],
            [-0.36877289921439815, -2.1194774147578808],
            [-0.36696324578371986, -2.1141661216481946],
            [-0.3724585609806908, -2.1056415679735436],
            [-0.3724406225894471, -2.100431568045319],
            [-0.36981913206595934, -2.093439215906199],
            [-0.37175846774792537, -2.0866406271683045],
            [-0.37157951604999173, -2.0790894781661264],
            [-0.3731194231933226, -2.0725161290922496],
            [-0.380179929123517, -2.065577551249504],
            [-0.3816544672244119, -2.0508509535845048],
            [-0.3814853855469099, -2.0317875905377285],
            [-0.37276052255020037, -2.0238095034981662],
            [-0.36096020220139335, -2.01679534993572],
            [-0.3547433125512727, -2.0145422081037667],
            [-0.3522938842100214, -2.0170226806270173],
            [-0.34967872232284924, -2.022856835919752],
            [-0.3425425938298876, -2.021926346786153],
            [-0.3359935159181189, -2.024134094810502],
            [-0.33287654557661484, -2.0229854698486345],
            [-0.32709560483667816, -2.028339532515281],
            [-0.32420468235887323, -2.0289872620998834],
            [-0.3133695683125195, -2.028014821762621],
            [-0.30437944879629036, -2.0282429957409702],
            [-0.2909976140160008, -2.033324052371817],
            [-0.2858727332936515, -2.033121822317516],
            [-0.27649176068960346, -2.030982411539912],
            [-0.2728684801282612, -2.0286739074095874],
            [-0.27369581361282064, -2.02335742697535],
            [-0.2689097641270111, -2.014133149320079],
            [-0.2674253521605862, -1.9997860232424085],
            [-0.2612464691242287, -1.9941798558395447],
            [-0.25846130096721676, -1.9897869424280172],
            [-0.25654405406092645, -1.9809811266879584],
            [-0.25346804421388086, -1.978227444498016],
            [-0.24143074589032062, -1.9650283279645766],
            [-0.23365557804802536, -1.9650390253441548],
            [-0.22810461184878356, -1.9632798532393578],
            [-0.22379497764519882, -1.9640306306280788],
            [-0.21374381337145587, -1.9710154355106915],
            [-0.19827261252564757, -1.9738499270315482],
            [-0.1923319999202008, -1.971980561054486],
            [-0.18835138915331706, -1.9672785488982745],
            [-0.1854055530952534, -1.958270819489032],
            [-0.18597272638946669, -1.9535505595912153],
            [-0.18892044313030962, -1.9495917529793412],
            [-0.16202519346100483, -1.949781259019773],
            [-0.16187671191659128, -1.935242672854024],
            [-0.13309905552464338, -1.9353890626912447],
            [-0.13250379207763172, -1.873945977696758],
            [-0.13210088733576, -1.8175661566264614],
            [-0.13164984398457982, -1.774805576436895],
            [-0.12996850097985294, -1.774811792702462],
            [-0.1293588647100197, -1.71653143591407]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.39843939147589,
          "lat": 36.629159625757204
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40113"],
        "coty_name": ["Osage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osage County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01101844"
      },
      "bbox": [
        -0.3816544672244119, -2.5643401076388166, 0.4632348196092242,
        -1.716312595063542
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.952731013754558, 3.4740984661394054],
            [12.948255135363379, 3.502190934666634],
            [12.950597983984233, 3.5025694715103404],
            [12.944711074226708, 3.536110678793569],
            [12.93348453280058, 3.603278178961672],
            [12.92409728250083, 3.6574142457466694],
            [12.907548298637918, 3.753589229770981],
            [12.913119959513066, 3.7494008673144914],
            [12.920919806657476, 3.7481327794898593],
            [12.924786053285251, 3.753251653269559],
            [12.922622400857385, 3.761843736273453],
            [12.927694736549954, 3.764647131741436],
            [12.931560713751507, 3.7620685795277025],
            [12.932843190719693, 3.753091405074787],
            [12.93585437323758, 3.7525571375064137],
            [12.938573618815095, 3.7577102327914242],
            [12.935287130690687, 3.7664939642248654],
            [12.93655918864364, 3.771028858458515],
            [12.942008816272352, 3.7679970572212835],
            [12.940716949597281, 3.763025213579053],
            [12.941611759649605, 3.7596323270910834],
            [12.947825142650062, 3.7574953211724127],
            [12.952057144734715, 3.761324446796804],
            [12.956508998573685, 3.772107807719627],
            [12.96252462819118, 3.770658269401252],
            [12.970026069573214, 3.7638233736995494],
            [12.979883381561864, 3.7595191748874317],
            [12.983992055963585, 3.761979502780604],
            [12.98419840522153, 3.7667233456603433],
            [12.981275700602867, 3.7714089853172554],
            [12.982015910466405, 3.7767726297577946],
            [12.98572547945321, 3.778521943961262],
            [12.989414634027112, 3.7772123832107725],
            [12.991920591470342, 3.7779633913489774],
            [12.9975085171601, 3.7909611613644767],
            [13.001388569651992, 3.7933459941717023],
            [13.009679820275549, 3.7905577427452477],
            [13.018979459968872, 3.7932156596263376],
            [13.029007683101868, 3.8016370036891534],
            [13.035498613875252, 3.802633985867295],
            [13.044388174731537, 3.7966880909454175],
            [13.045516435227764, 3.804222218293918],
            [13.049138955756314, 3.8070766299588605],
            [13.053035702323621, 3.8074175369341754],
            [13.055937826210286, 3.81358557214261],
            [13.059468893244553, 3.818388421838333],
            [13.067785838561912, 3.8190079288368577],
            [13.071578878189301, 3.827586168013628],
            [13.07492533393146, 3.8286201101375243],
            [13.08010747727727, 3.8233448319777072],
            [13.083297728392887, 3.825627466489222],
            [13.085122780270321, 3.816425693494952],
            [13.162310798107102, 3.7875884115229863],
            [13.202766874298996, 3.7722218285926075],
            [13.245780580023919, 3.756274409470126],
            [13.267269085058672, 3.748118701859881],
            [13.266148358080887, 3.7387139598328516],
            [13.270987964291345, 3.7158238707698388],
            [13.29172483395386, 3.71918843143146],
            [13.296762726892458, 3.691080253851629],
            [13.255396660215851, 3.6844199819943038],
            [13.243323252270027, 3.624346605228819],
            [13.240199768341952, 3.6095256499160793],
            [13.247956988400023, 3.5670440938599857],
            [13.25712910409945, 3.5184043697665643],
            [13.269463550587076, 3.451764948849018],
            [13.28076054520659, 3.385428268750172],
            [13.235502380792726, 3.377447437092791],
            [13.169404680826569, 3.3678809551682107],
            [13.124369717653012, 3.3603699797174063],
            [13.043541798296584, 3.3472114071793277],
            [12.977313845011578, 3.3361831762000116],
            [12.971936672545436, 3.364577131763626],
            [12.970574589058323, 3.385643861562714],
            [12.968553215286969, 3.3977018787315845],
            [12.956677404825074, 3.473345768887754],
            [12.952731013754558, 3.4740984661394054]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.99943042330891, "lat": 41.12817281452697 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42065"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01213674"
      },
      "bbox": [
        12.907548298637918, 3.3361831762000116, 13.296762726892458,
        3.8286201101375243
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.12662721117976, 5.587598911861518],
            [18.149927243056972, 5.595378958010462],
            [18.210199982326944, 5.6130728221830966],
            [18.28378247829157, 5.634752494098767],
            [18.318726636953514, 5.644832906368611],
            [18.339091891585493, 5.652476214109241],
            [18.422028087409416, 5.675926347112304],
            [18.430678844270286, 5.643252757165724],
            [18.435958087402057, 5.623611147702044],
            [18.45421653759287, 5.55417437076048],
            [18.459550937799854, 5.556826029693841],
            [18.4835897208797, 5.567321352008222],
            [18.486431028063645, 5.550647021652974],
            [18.496278540427063, 5.533228668964338],
            [18.494940483504234, 5.514720967014064],
            [18.502348571804642, 5.507030418284402],
            [18.497352325286606, 5.497929504505963],
            [18.496973961442603, 5.492746080390143],
            [18.506338256688508, 5.480591573307409],
            [18.5074683705766, 5.471759981747092],
            [18.509549227754956, 5.468263400731473],
            [18.513877699135413, 5.467539694557348],
            [18.519158933499636, 5.460946272650713],
            [18.521789251107307, 5.455105703980105],
            [18.53004669885784, 5.452782018967352],
            [18.512104992421786, 5.423631802315274],
            [18.510730392674574, 5.421884529907776],
            [18.510967284541316, 5.415472130345279],
            [18.508048129628683, 5.414701302624327],
            [18.504787587163246, 5.419888845499773],
            [18.504757137971076, 5.424319754104297],
            [18.502657146807717, 5.42946802121336],
            [18.499563016816676, 5.4328824862746],
            [18.496036918125643, 5.431768133193118],
            [18.496894673971465, 5.438799895484982],
            [18.495927563112346, 5.445165212831901],
            [18.489826217623964, 5.449623375533908],
            [18.48235099774988, 5.449673217476173],
            [18.476129977134462, 5.446377793287681],
            [18.47596554768744, 5.443576872892352],
            [18.483633143001622, 5.432748523717469],
            [18.485737680190915, 5.424636082772095],
            [18.48746253021918, 5.423225201826675],
            [18.486158484328893, 5.422787151117157],
            [18.482731680293835, 5.427438361967303],
            [18.478653037477155, 5.426635778888258],
            [18.47364370015984, 5.4297588190136725],
            [18.466137125235594, 5.425947459672398],
            [18.464430565095178, 5.4217620000539055],
            [18.458563699722514, 5.421904712057051],
            [18.456451743257517, 5.417660531906452],
            [18.448645008047446, 5.41436274991686],
            [18.44738189366642, 5.408724013840133],
            [18.448431565756007, 5.406345463883717],
            [18.445034594550744, 5.402063501296596],
            [18.447798825305313, 5.397937644197756],
            [18.448609634791143, 5.393945176283117],
            [18.444003993661152, 5.392265740838849],
            [18.44298216008805, 5.384383246082122],
            [18.397217709795225, 5.370370757428471],
            [18.378658084249956, 5.365141890711178],
            [18.308821558021215, 5.344507765974074],
            [18.254834554452586, 5.3289179957286],
            [18.205244459147213, 5.314872800383828],
            [18.192820192933187, 5.358373751659383],
            [18.182276398413414, 5.393706286417135],
            [18.146006486554494, 5.517344355840045],
            [18.12662721117976, 5.587598911861518]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.57997840344925, "lat": 41.8721379999189 },
        "year": "2023",
        "ste_code": ["44"],
        "ste_name": ["Rhode Island"],
        "coty_code": ["44007"],
        "coty_name": ["Providence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Providence County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01219781"
      },
      "bbox": [
        18.12662721117976, 5.314872800383828, 18.53004669885784,
        5.675926347112304
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.307533365848858, -3.7709790156954757],
            [11.349751137460325, -3.7282291061039827],
            [11.39600631961146, -3.6821786120718323],
            [11.408071855626238, -3.6698116379714247],
            [11.47598414021056, -3.598864674873671],
            [11.506698378534242, -3.5663543059116574],
            [11.570840113879765, -3.4982166664064374],
            [11.615905478163027, -3.4500782746282046],
            [11.618200253061639, -3.457883316207682],
            [11.617488718946571, -3.464805667952162],
            [11.62640238898077, -3.4719927533485118],
            [11.636297423150165, -3.4767093572471426],
            [11.641356686726064, -3.4776565497951792],
            [11.645971281636257, -3.482349618334613],
            [11.650326553074416, -3.4887322844327158],
            [11.652000038149547, -3.4932457563843426],
            [11.656236603832417, -3.4956353043388204],
            [11.662007007674143, -3.495351525497682],
            [11.667720245661176, -3.5020281780906326],
            [11.666651526378944, -3.505484810072638],
            [11.669351694045615, -3.5082809536630024],
            [11.673349360931045, -3.5070054970425315],
            [11.675461408332476, -3.5127795619358917],
            [11.681404714345724, -3.516484493587724],
            [11.619894664089616, -3.5935601760343365],
            [11.628202254125005, -3.6022137536570136],
            [11.630846743428807, -3.6096233191538816],
            [11.641875066920731, -3.612935107001525],
            [11.64229292791404, -3.617696564914172],
            [11.644701746869048, -3.6269611479290327],
            [11.644219127950333, -3.628751775481673],
            [11.65088824101966, -3.655237606823063],
            [11.662576108042865, -3.6599680201809397],
            [11.677384669941322, -3.67044288847704],
            [11.689988189546234, -3.683119808589915],
            [11.70734720029389, -3.7049629184909505],
            [11.71005128755938, -3.7128851988417586],
            [11.718065817392091, -3.7322505515504965],
            [11.721880128786477, -3.760884101783759],
            [11.718584750401696, -3.7907559729461817],
            [11.709494326645412, -3.814818804833965],
            [11.707076394436816, -3.8202612333558523],
            [11.683511879750217, -3.850622239607895],
            [11.666042046720598, -3.8698972098643596],
            [11.628697692718209, -3.8815637888568686],
            [11.626620919600716, -3.8824367606522356],
            [11.564249664064176, -3.888376021108238],
            [11.560337082406706, -3.8851032051019363],
            [11.556462032429277, -3.8837819334071675],
            [11.553500683917708, -3.8802934720753948],
            [11.543270000302961, -3.8755611760624467],
            [11.536166464532775, -3.8711955174884025],
            [11.533815799520879, -3.8749457373933334],
            [11.527349301716548, -3.8773395401664383],
            [11.524441108269823, -3.882128621289811],
            [11.516935759629735, -3.8834489358485804],
            [11.509959437993121, -3.886278366226549],
            [11.499318975553722, -3.885890655588114],
            [11.458089657067832, -3.9468315079953666],
            [11.455416328954259, -3.9510117528408033],
            [11.45364627900364, -3.944608038210966],
            [11.454181122759953, -3.938179585196054],
            [11.451780057791332, -3.934261504008825],
            [11.441481342166906, -3.928469259224964],
            [11.438398969046336, -3.9254665682472076],
            [11.435755615840563, -3.920431953490241],
            [11.430048362457454, -3.9166387043364925],
            [11.42726829784158, -3.9102270561157915],
            [11.42197593755872, -3.905452695945686],
            [11.418419980425325, -3.9038523647175656],
            [11.414847331902894, -3.9048016954419453],
            [11.410317064167991, -3.9026055472478993],
            [11.40497879820683, -3.8950708836916066],
            [11.407893855990102, -3.884003371201165],
            [11.405985895743006, -3.8786384245940595],
            [11.399142032789964, -3.8724569975930287],
            [11.394534345525747, -3.8715787883212087],
            [11.390309306808891, -3.868795357753327],
            [11.382419125765308, -3.860130275906179],
            [11.380409294555184, -3.8541251298989194],
            [11.373353890871824, -3.8449698979470543],
            [11.370130941639228, -3.842769373685492],
            [11.36369198527456, -3.8415827658947537],
            [11.358286795338602, -3.8377412505848496],
            [11.352054144006281, -3.838280350247219],
            [11.348252905228406, -3.8370995133005934],
            [11.338139359381403, -3.8312131343673705],
            [11.336081531593035, -3.8291229424092856],
            [11.329168115143826, -3.814507750952371],
            [11.32207020151637, -3.805925905242055],
            [11.319780599773017, -3.800134081646761],
            [11.318866499754733, -3.7907292919000373],
            [11.317648264574325, -3.7870576139189063],
            [11.308116190176671, -3.7729686059212133],
            [11.307533365848858, -3.7709790156954757]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.45926545996687, "lat": 34.22264909217649 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45001"],
        "coty_name": ["Abbeville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Abbeville County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01245666"
      },
      "bbox": [
        11.307533365848858, -3.9510117528408033, 11.721880128786477,
        -3.4500782746282046
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8579350598778144, 5.538555270456493],
            [-0.732165674951996, 5.535794513378798],
            [-0.6576345610591007, 5.5348894461146685],
            [-0.5663542918835035, 5.533134787257981],
            [-0.5153966624400792, 5.532516364493792],
            [-0.5167972515245971, 5.447373605190193],
            [-0.5177998188160838, 5.360539473691144],
            [-0.5182929205375011, 5.331333850036943],
            [-0.5189129153089593, 5.273248647735008],
            [-0.5199404252475279, 5.186372321337153],
            [-0.5771028128993189, 5.1872874848066],
            [-0.6417464163149414, 5.188484579107833],
            [-0.6916278462608085, 5.189584233636274],
            [-0.7665101940231264, 5.191322389379515],
            [-0.8081590821948063, 5.192373615316001],
            [-0.8658417034958377, 5.193540317262847],
            [-0.8640503896443495, 5.2804228614026565],
            [-0.8620841387002646, 5.375039171957819],
            [-0.8609203184776137, 5.432737465053417],
            [-0.8604097616198058, 5.4665154147513295],
            [-0.8599418806639691, 5.468742128514272],
            [-0.8579350598778144, 5.538555270456493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.6101940854484, "lat": 44.0219390746989 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46097"],
        "coty_name": ["Miner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Miner County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01265777"
      },
      "bbox": [
        -0.8658417034958377, 5.186372321337153, -0.5153966624400792,
        5.538555270456493
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.400538570855934, -2.7081687631485543],
            [6.406183987041553, -2.7079201108950937],
            [6.405545534804668, -2.6951219945944533],
            [6.408322678456223, -2.694554650273453],
            [6.409246527313283, -2.690047907122317],
            [6.412857840261243, -2.684647906466114],
            [6.420499161774626, -2.6787821536923833],
            [6.426871889445026, -2.6799815573449193],
            [6.426221980659639, -2.6724427445516796],
            [6.428046695552687, -2.6701522778040245],
            [6.4830995831920335, -2.667205181318439],
            [6.485962075950751, -2.666631174154018],
            [6.55919411565139, -2.662881888744995],
            [6.666567242032487, -2.6571350681193717],
            [6.671855937344819, -2.656751900047361],
            [6.740946392593154, -2.653154760338839],
            [6.742339119649783, -2.6849318387986716],
            [6.739103007328087, -2.687561053061217],
            [6.739200557409246, -2.691442012875496],
            [6.742482825103526, -2.6930540436151884],
            [6.746773510794174, -2.799955228588657],
            [6.748480128368277, -2.8402887760565205],
            [6.741401852995499, -2.841595792849534],
            [6.7419005347696865, -2.8476887315098356],
            [6.7486007672706645, -2.847279422917318],
            [6.749108560094538, -2.862534889630133],
            [6.724723118942958, -2.919964197625909],
            [6.7327647531194375, -2.919617856489238],
            [6.7329641880428905, -2.9247518416667035],
            [6.727392956994971, -2.9269705536558064],
            [6.721505806355746, -2.927313927010123],
            [6.713488645174967, -2.9468844748908984],
            [6.718170948314729, -3.0526788889884857],
            [6.723270971223481, -3.052522194915916],
            [6.723429533192542, -3.057168114450783],
            [6.7200758860743965, -3.0572772427559856],
            [6.717096709969542, -3.0598624686664007],
            [6.627693663646405, -3.06460729632682],
            [6.619158493426865, -2.9906697323054425],
            [6.609198520186506, -2.991155554721017],
            [6.5888131195185995, -3.001409243652501],
            [6.579316519550899, -3.004437522132723],
            [6.577435088401517, -2.9994045592989265],
            [6.5725144882456945, -2.998151786611446],
            [6.557201945796519, -2.9981479824632706],
            [6.534368557651083, -2.9943259783077503],
            [6.503926488974002, -2.9804127089413446],
            [6.492146283206858, -2.9710218795867838],
            [6.48284347668274, -2.9620560952049875],
            [6.4693066426834775, -2.9457136863497975],
            [6.458479720462218, -2.9280558088404387],
            [6.453466569108842, -2.9180527055937193],
            [6.449577994888373, -2.908818339941341],
            [6.439139080006922, -2.907162395403209],
            [6.436835468241402, -2.9091900945037454],
            [6.431169006698342, -2.9094455144493927],
            [6.425677242775012, -2.9053375222065654],
            [6.421885247076455, -2.90629009901088],
            [6.415045794126924, -2.9128913437885],
            [6.410897484155892, -2.9108246453320494],
            [6.4101099976201645, -2.872124195010292],
            [6.415981183577616, -2.8720239876783533],
            [6.414909319327327, -2.8623104704742],
            [6.41478541259918, -2.853821927760786],
            [6.408635976625451, -2.8520353154050295],
            [6.4050719576809865, -2.78770495911149],
            [6.400538570855934, -2.7081687631485543]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.38800814157887,
          "lat": 35.654257183658686
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47077"],
        "coty_name": ["Henderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henderson County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01639754"
      },
      "bbox": [
        6.400538570855934, -3.06460729632682, 6.749108560094538,
        -2.653154760338839
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.907944196958332, -2.640304988524481],
            [6.908228573384882, -2.627005348835812],
            [6.909352646204286, -2.6209127539232826],
            [6.9121986658153975, -2.6144334882360205],
            [6.933414624271124, -2.614847721948836],
            [6.954395207055758, -2.6134640620765754],
            [6.95456718637856, -2.6204620453190466],
            [6.959811443442871, -2.622830689102791],
            [6.963214792631124, -2.626845440367128],
            [6.969296673111989, -2.625829425931853],
            [6.975992919298855, -2.628079050989089],
            [6.977946037781434, -2.6313156806201126],
            [6.9817884678679825, -2.6315657161723616],
            [6.985482568894029, -2.6364217712301707],
            [6.992846316484598, -2.6378509780094945],
            [6.994410187776684, -2.639897329086142],
            [6.999265692266121, -2.6410127783681987],
            [7.003492920593455, -2.644208485208208],
            [7.006735059682178, -2.643705488776888],
            [7.007795219108788, -2.6391544189480842],
            [7.007585950931157, -2.631242851771438],
            [7.008867186582711, -2.626622077654149],
            [7.013549111053249, -2.6239409601326127],
            [7.017591724739198, -2.624183098745132],
            [7.0236881765112775, -2.621955317278278],
            [7.02745492179064, -2.613326471200295],
            [7.027811679857265, -2.6087564835095334],
            [7.1092516948976705, -2.5996875045582333],
            [7.106169060147278, -2.713783143835541],
            [7.110689386615008, -2.7140287266254215],
            [7.11286551719822, -2.710431262976298],
            [7.120479267246027, -2.728890019593536],
            [7.125988227342392, -2.728384750828651],
            [7.126004396387156, -2.734964000374293],
            [7.115293269965654, -2.7352441197246207],
            [7.113932835965499, -2.738173418732705],
            [7.104356631863675, -2.7381405580286438],
            [7.102956149870727, -2.7771023905126224],
            [7.106821896101998, -2.779252767858785],
            [7.112301863248897, -2.784419859597736],
            [7.117934111858789, -2.785381880799249],
            [7.119746282181487, -2.7894041955215982],
            [7.124065981993097, -2.790215163815476],
            [7.126312082947391, -2.7924654378457356],
            [7.1332210264891955, -2.7932805627408293],
            [7.133934178329995, -2.796180497298249],
            [7.138069262831544, -2.7988906160079265],
            [7.14261782050461, -2.799341665466801],
            [7.146319568100004, -2.803106024152975],
            [7.151229125799559, -2.803492615672],
            [7.153976695534614, -2.8070468022528483],
            [7.160167164053825, -2.8094350587381105],
            [7.161001553056126, -2.812257360246731],
            [7.173771396119316, -2.8216580413337953],
            [7.1764132184560525, -2.8259208424223625],
            [7.180133202111421, -2.8381457704275745],
            [7.185878087221755, -2.844651361361845],
            [7.183832433900624, -2.851153196466392],
            [7.186568443038366, -2.854844811902389],
            [7.185307092921688, -2.858764634915657],
            [7.185514865060406, -2.8701242214086973],
            [7.176914957044896, -2.8777246628725885],
            [7.175770462398907, -2.8827445770977],
            [7.170699283745772, -2.8851825275114242],
            [7.162413144063718, -2.882955295156725],
            [7.1578463665533105, -2.884743240035101],
            [7.159626420747386, -2.889390266381127],
            [7.159521863266596, -2.9326281012050903],
            [7.143158281757975, -2.934099187753927],
            [7.143071665396932, -2.941954703481979],
            [7.139856930419022, -2.9420026760215268],
            [7.139824324693674, -2.956583428645893],
            [7.126026172764867, -2.9493467616001325],
            [7.1166298047475784, -2.9500723495908834],
            [7.111109409354722, -2.953122148823801],
            [7.070512855603741, -2.9609738800034635],
            [7.068023271816172, -2.966747101442576],
            [7.064293357523157, -2.965125115424166],
            [7.062059609073778, -2.970266163029459],
            [7.05644559148034, -2.970822787030164],
            [7.052668553987629, -2.9777569267224924],
            [7.036421285828475, -2.9838309643904983],
            [7.028042100550558, -2.9843901972302773],
            [7.025625443920584, -2.9761745709304974],
            [7.022016432380455, -2.974224718220063],
            [7.013505834900574, -2.9805366440911008],
            [7.007294147579934, -2.9805157785553407],
            [7.001556943494103, -2.9866588186322156],
            [6.990264333066735, -2.9906105640046188],
            [6.986069666314018, -2.987498604114948],
            [6.978646700236406, -2.990222867851995],
            [6.977549556647228, -2.9944853785998364],
            [6.973916608889362, -2.994136110706557],
            [6.968857316729623, -2.9891512670652545],
            [6.953389530260284, -2.9981287009525803],
            [6.950678945787894, -2.9964655249963585],
            [6.945740362217412, -2.9975117323583094],
            [6.941605490026344, -3.0002297915878673],
            [6.935744718634461, -2.9975211295877933],
            [6.930409857280247, -3.0005765891783067],
            [6.929235533701843, -3.0054341115815193],
            [6.923863308713966, -3.0055093886125435],
            [6.922742089419593, -3.0118344177213077],
            [6.916197300250989, -3.016833949263006],
            [6.9124822417316585, -3.0229534831654914],
            [6.907486538480048, -3.0275809814944687],
            [6.907368847677348, -3.0339008612536023],
            [6.911591231918199, -3.0367849606564614],
            [6.900331447612312, -3.037628751277294],
            [6.892585148940876, -3.0337498210525493],
            [6.8881176293537045, -3.027977559979506],
            [6.881932521940491, -3.017805355797152],
            [6.880923194838654, -3.008918843954765],
            [6.882624965488785, -3.0029079591031445],
            [6.8874360515799955, -2.9998392640122757],
            [6.889563957441087, -2.9965718218896877],
            [6.892121581117811, -2.9892126631542446],
            [6.9089674068978235, -2.9817657964053708],
            [6.9145165942034055, -2.980547059859177],
            [6.92153207751236, -2.9759907456105656],
            [6.927142401540039, -2.9679626855626213],
            [6.928332770810409, -2.9641935571079006],
            [6.930722312465745, -2.943493416050918],
            [6.929906023135984, -2.936508052927233],
            [6.927331179547805, -2.92995741821521],
            [6.923315001022246, -2.922640525050461],
            [6.918526872874577, -2.9165413928569706],
            [6.908044518209997, -2.9059284280338358],
            [6.897169141760476, -2.887525909974081],
            [6.891289388599572, -2.876048863181341],
            [6.887279737351663, -2.8708632416881135],
            [6.874211171855391, -2.8473897460715483],
            [6.8721927904818125, -2.8394158127087072],
            [6.873337800343685, -2.8333639300672444],
            [6.882515010695412, -2.7997272025222832],
            [6.882883119592073, -2.7821327611918343],
            [6.881589396721429, -2.776588564783346],
            [6.875934004796556, -2.7715332797951753],
            [6.872071429824235, -2.766629497391766],
            [6.866260317564172, -2.750373459011742],
            [6.86497494477446, -2.743510175700272],
            [6.8662888722292506, -2.735249285453396],
            [6.873841079481114, -2.72215106669355],
            [6.8789663233441996, -2.7158056454566006],
            [6.88210321646364, -2.714038532888257],
            [6.887677557043345, -2.708419293667692],
            [6.897129444329602, -2.6958202367012136],
            [6.899680884426942, -2.6906955811489013],
            [6.903780824473249, -2.67787705229977],
            [6.9071271397817116, -2.660640019889852],
            [6.907944196958332, -2.640304988524481]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.85887601329686,
          "lat": 35.642677321353275
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47135"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01639781"
      },
      "bbox": [
        6.86497494477446, -3.037628751277294, 7.186568443038366,
        -2.5996875045582333
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.06853146919436, -2.454978925258396],
              [9.078927606235851, -2.4590143274435308],
              [9.080732111175218, -2.454153331527366],
              [9.088524048567779, -2.4537857476609197],
              [9.087829440763587, -2.4631956920053804],
              [9.086190972646044, -2.4740732288857523],
              [9.082217865588023, -2.469901062332754],
              [9.078850122972451, -2.462542005415696],
              [9.073140063182498, -2.4627386217750815],
              [9.067970601048037, -2.4591700974008615],
              [9.06853146919436, -2.454978925258396]
            ]
          ],
          [
            [
              [8.736668571313137, -2.4476731938961653],
              [8.740067263166424, -2.4449449675921318],
              [8.745406361201718, -2.446564032081379],
              [8.750946285924206, -2.4509205688275353],
              [8.755811567406127, -2.451044944068137],
              [8.759603658448718, -2.4485690356456504],
              [8.765566422762156, -2.4371989855010665],
              [8.774545038224913, -2.4271778397605006],
              [8.774540840764168, -2.4227833230807203],
              [8.771950239644163, -2.4208565864301788],
              [8.761247826976977, -2.4220468886322974],
              [8.751683931762031, -2.4279910895429033],
              [8.74495046544116, -2.4283319867538893],
              [8.74158771238387, -2.425179078349323],
              [8.74132135475363, -2.421533443838831],
              [8.746247612633502, -2.4155791310806856],
              [8.75579823195783, -2.4074520224226728],
              [8.760071259082396, -2.40068435244744],
              [8.766868356741135, -2.3930854425738546],
              [8.766028869714358, -2.3868457155945215],
              [8.759956919833973, -2.386013393293374],
              [8.753698549246455, -2.3901407527974574],
              [8.742083871174692, -2.393930762728319],
              [8.74245526776993, -2.3886959837672],
              [8.748874637179615, -2.3851007622442344],
              [8.75378258047962, -2.381024886551611],
              [8.756976220137082, -2.3765912417950394],
              [8.756930170631165, -2.373536981880834],
              [8.75288701057881, -2.37111210275918],
              [8.751919825349562, -2.362227463783568],
              [8.746189527167179, -2.3604531311156727],
              [8.748300797967113, -2.349576830365244],
              [8.739317765222482, -2.327903967372473],
              [8.736621308622054, -2.305422549924862],
              [8.747737441656406, -2.2867855988429473],
              [8.748172155091178, -2.273068979510914],
              [8.75283789053855, -2.268624610457234],
              [8.750002080903231, -2.266305134141338],
              [8.746439754785882, -2.260168263853208],
              [8.746496330730567, -2.2508914591586002],
              [8.749796159537865, -2.24793651403441],
              [8.76026369413376, -2.2419566767184516],
              [8.76244273044697, -2.2397183231277835],
              [8.764381550313306, -2.2319727589050404],
              [8.768953898858474, -2.2289280198125394],
              [8.770890134872129, -2.2259671767149216],
              [8.78040400393769, -2.229316337567109],
              [8.78207398961799, -2.2276384514182634],
              [8.786870660170944, -2.22891650451054],
              [8.790856771313512, -2.2257297982785738],
              [8.792245908387358, -2.221577422914403],
              [8.79005969937321, -2.2144434944080915],
              [8.79064036553001, -2.2092963228187226],
              [8.7946284383311, -2.206782721228967],
              [8.800807033578074, -2.209793000471191],
              [8.807009614162736, -2.194249972023907],
              [8.813675494841167, -2.1940508359358364],
              [8.818516782075884, -2.188590341714203],
              [8.848072131159466, -2.181046491543345],
              [8.855145994222292, -2.1818994414238477],
              [8.94439571461054, -2.198816280133095],
              [8.957015913439397, -2.199002105972966],
              [8.959180758683608, -2.2014030191169565],
              [8.972353840290822, -2.203835270471344],
              [8.99827932470773, -2.2168174398149367],
              [8.998682734419216, -2.213904813143136],
              [9.011592612583371, -2.2139305322201994],
              [9.010771959908665, -2.2231860179189313],
              [9.01442025955919, -2.252782243051025],
              [9.053510596901969, -2.2624105767864537],
              [9.054012623301382, -2.275953700440582],
              [9.07045517525248, -2.307575631546243],
              [9.078181769923392, -2.326710910889781],
              [9.102074294189011, -2.3266941918229818],
              [9.102268838621042, -2.3382500613919275],
              [9.094665025178825, -2.338339167229193],
              [9.094747621693022, -2.3450188413500834],
              [9.089304974107915, -2.3455809902542475],
              [9.098438770536882, -2.360880362276844],
              [9.09834646502049, -2.3629489902988503],
              [9.091036080075769, -2.4303293911899995],
              [9.086138444007464, -2.4303750964418818],
              [9.086627099392354, -2.4417352770346623],
              [9.076945990116762, -2.4416036819375804],
              [9.075922105340778, -2.4512994779516433],
              [9.07052662274306, -2.4489997378038915],
              [9.070842930665835, -2.4453293041419575],
              [9.064335393418936, -2.4437599009177657],
              [9.062241768390798, -2.433628829297455],
              [9.066348622329768, -2.430456611204812],
              [9.070705648827369, -2.4199741350338213],
              [9.061468065327038, -2.424288831699399],
              [8.995938527091232, -2.4539767253605924],
              [8.98545414867182, -2.4521126810279306],
              [8.94752716580398, -2.4419305502985647],
              [8.940280688285771, -2.438515016158866],
              [8.936478627602522, -2.4385110427623835],
              [8.932090462512502, -2.4417506461893375],
              [8.923601446416654, -2.436920957355786],
              [8.918947404310604, -2.4385398298988252],
              [8.914136588035294, -2.4375706602092975],
              [8.911026511242428, -2.4401686883854046],
              [8.912640156728076, -2.443658577485018],
              [8.907730070444218, -2.444202444209282],
              [8.903632750236659, -2.4380292654119513],
              [8.896441370363055, -2.4433533447675497],
              [8.893307900456895, -2.4470710492183168],
              [8.888112039027574, -2.449511870275764],
              [8.88531694986412, -2.456435714400735],
              [8.880261467483772, -2.4521632284550097],
              [8.873815764898922, -2.449084107771255],
              [8.868889578790869, -2.4494760603085095],
              [8.863519139153066, -2.4580693971514718],
              [8.863893327308206, -2.460499049098936],
              [8.86813349058805, -2.463527777053186],
              [8.868508266932547, -2.468990300789891],
              [8.867242224069528, -2.4736360927281935],
              [8.863593222415163, -2.4719843856362824],
              [8.857639464360437, -2.466764013419755],
              [8.852208905639536, -2.4695505569371603],
              [8.849166275019309, -2.4661586266344715],
              [8.843351226782524, -2.4718341622600164],
              [8.838090199166073, -2.469665228108158],
              [8.827655306289254, -2.4627424224792],
              [8.817417449224772, -2.4636240887823635],
              [8.814719107550438, -2.4684819489149885],
              [8.809458454713727, -2.468779884877072],
              [8.806267272680856, -2.4653692963030904],
              [8.803981720264732, -2.4676122106251315],
              [8.808217351617726, -2.4751600589725427],
              [8.803928727190927, -2.477095376611312],
              [8.797260602731738, -2.467956991900819],
              [8.792212512614949, -2.471941607985548],
              [8.789319949636589, -2.4723569097563467],
              [8.781127615055649, -2.4691959042816016],
              [8.776890307589193, -2.4662435576080184],
              [8.77565748210541, -2.461573926765746],
              [8.770560932566365, -2.4587193027348486],
              [8.76147270638243, -2.4600023299683196],
              [8.75270999480565, -2.4577557668558963],
              [8.746342807928109, -2.4573151530774315],
              [8.73670186723796, -2.4517345361201994],
              [8.736668571313137, -2.4476731938961653]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.45526446604144, "lat": 35.92641096050721 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47185"],
        "coty_name": ["White"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["White County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "01639800"
      },
      "bbox": [
        8.736621308622054, -2.477095376611312, 9.102268838621042,
        -2.181046491543345
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.9709892071960635, -4.868148273462713],
            [-1.8768887621026782, -4.870657731627349],
            [-1.7971947676203417, -4.872696731282332],
            [-1.6850948745107164, -4.875345418986916],
            [-1.617873981211125, -4.876712045480943],
            [-1.588491834978617, -4.877125989895033],
            [-1.534399765999676, -4.878425860582166],
            [-1.5366104856663363, -4.964654573087472],
            [-1.5364806165869191, -4.969258384902676],
            [-1.5393171736902516, -5.08664908019272],
            [-1.5397167091761337, -5.0962783643308125],
            [-1.5405749645657414, -5.15478805680426],
            [-1.542094662355958, -5.248792723207727],
            [-1.5432813887054544, -5.3195718494252],
            [-1.607173275705753, -5.318189180501098],
            [-1.6093223055857435, -5.318024596627045],
            [-1.711075749062803, -5.315914969314039],
            [-1.816563657073714, -5.312707360398515],
            [-1.8179333391890793, -5.312453243418974],
            [-1.9197795315578867, -5.30812957256397],
            [-1.9852562058145504, -5.305782726622934],
            [-1.9809267573587699, -5.171511840249614],
            [-1.977635957372111, -5.075727049236845],
            [-1.9723726856874522, -4.91887384870824],
            [-1.9709892071960635, -4.868148273462713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.68766944716774, "lat": 33.61527502461333 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48009"],
        "coty_name": ["Archer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Archer County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01383790"
      },
      "bbox": [
        -1.9852562058145504, -5.3195718494252, -1.534399765999676,
        -4.868148273462713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.401537874008945, -4.853653803772014],
            [-2.1701737126352927, -4.861658616129999],
            [-2.065460412028579, -4.865084331640257],
            [-1.9748171923769222, -4.867861920965782],
            [-1.9709892071960635, -4.868148273462713],
            [-1.9723726856874522, -4.91887384870824],
            [-1.977635957372111, -5.075727049236845],
            [-1.9809267573587699, -5.171511840249614],
            [-1.9852562058145504, -5.305782726622934],
            [-2.1272939711101952, -5.300570947238485],
            [-2.2553148659175237, -5.295830337999176],
            [-2.3833351141010377, -5.29107429097957],
            [-2.4148978094793336, -5.289820489344408],
            [-2.4132009581347797, -5.240226894146776],
            [-2.4133432665073786, -5.237281821558728],
            [-2.409259593170473, -5.108819921692038],
            [-2.406628694051081, -5.022258212435102],
            [-2.404275976523736, -4.95414105237643],
            [-2.401537874008945, -4.853653803772014]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.21353824721382,
          "lat": 33.616509264169764
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48023"],
        "coty_name": ["Baylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baylor County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01383797"
      },
      "bbox": [
        -2.4148978094793336, -5.305782726622934, -1.9709892071960635,
        -4.853653803772014
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0371952289397057, -5.361995677040614],
            [1.0388088770049342, -5.361144929034582],
            [1.0430430902866645, -5.360808315550844],
            [1.044202061690416, -5.3566957936073685],
            [1.0533501359978774, -5.361226434246141],
            [1.0616162591674156, -5.36243053040921],
            [1.0670898822308064, -5.365577761605893],
            [1.0702354047278142, -5.36473875076799],
            [1.0807822412960908, -5.37119509009915],
            [1.0850668087023496, -5.368157326886354],
            [1.0922934904582948, -5.370853948088108],
            [1.1017715282634157, -5.3670491204013935],
            [1.108167800020759, -5.360485458694959],
            [1.119705722408373, -5.359560672996351],
            [1.1263438547837745, -5.35753055151812],
            [1.1287320178286184, -5.358840792409135],
            [1.1298867651227478, -5.3646302568895186],
            [1.1350010351833806, -5.364403616715993],
            [1.1385805243990117, -5.35894090779069],
            [1.1419682222378087, -5.357926540326525],
            [1.145287063056486, -5.359594201443149],
            [1.147861666772397, -5.356176654647327],
            [1.1585213069102038, -5.35330797455158],
            [1.1585173288487156, -5.358104829372234],
            [1.1637241940442378, -5.358084025549374],
            [1.1653362120940933, -5.356002669445392],
            [1.1723324273819382, -5.356035593470811],
            [1.174195426802788, -5.351566894710496],
            [1.1819851141456503, -5.351889575696006],
            [1.188976331855341, -5.348456468335035],
            [1.189893532713676, -5.402349966664466],
            [1.190966121113729, -5.481045528993379],
            [1.191518740426255, -5.577426945826694],
            [1.1913597639121007, -5.614750862722504],
            [1.1916976227116334, -5.704002042097579],
            [1.1869483809502854, -5.708824112990981],
            [1.1824987168679324, -5.707733838242241],
            [1.1812912898866121, -5.7124633554278965],
            [1.1740600568526784, -5.7178906665873965],
            [1.1728545163611885, -5.722904271775186],
            [1.1701658722860375, -5.725356479822202],
            [1.170318721667574, -5.736084475314571],
            [1.1670321357365814, -5.738088181760592],
            [1.1641268037862076, -5.744184716481878],
            [1.161621745322561, -5.746209301954733],
            [1.1627411879638008, -5.749314480198793],
            [1.1618501844211118, -5.758733193798411],
            [1.1598109288510785, -5.763625096948745],
            [1.1542418733266433, -5.766486036243421],
            [1.1508957388602505, -5.773711705622711],
            [1.153335861807365, -5.777190802375849],
            [1.0399276458933848, -5.777348053716725],
            [1.0398183773341296, -5.661557308811952],
            [1.0392459187953518, -5.573298644487547],
            [1.0386721782710302, -5.483511267526905],
            [1.0384861960819836, -5.439021231892119],
            [1.0377932386415585, -5.409534812461176],
            [1.0371952289397057, -5.361995677040614]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.21842611980557,
          "lat": 33.175554703107395
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48159"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "01383865"
      },
      "bbox": [
        1.0371952289397057, -5.777348053716725, 1.1916976227116334,
        -5.348456468335035
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3765452475895747, -8.185243945765917],
            [-2.3572972401263765, -8.186337979918179],
            [-2.2701236165959147, -8.18968083675892],
            [-2.1829493556279824, -8.193009430463842],
            [-2.115642370366823, -8.195554478959057],
            [-2.111698018323811, -8.195365076714005],
            [-2.0846089194088715, -8.196115723870804],
            [-2.008173694097582, -8.197715194954997],
            [-1.9568473445186108, -8.199199863781732],
            [-1.9007298961702033, -8.201306952024833],
            [-1.8627963884021856, -8.20210616928835],
            [-1.7643645651928868, -8.204000586899042],
            [-1.7671819057960925, -8.390100140482938],
            [-1.7681269333184986, -8.45535943136109],
            [-1.7691253045520492, -8.49587834409844],
            [-1.7709648560464288, -8.561640018562912],
            [-1.803260426388436, -8.560772866567925],
            [-1.910646074468408, -8.55818743916044],
            [-1.9299663409825085, -8.558170223821325],
            [-2.0578051828258768, -8.554076433655247],
            [-2.0910898172129384, -8.553376177840962],
            [-2.1828624255923907, -8.551720944945414],
            [-2.312006700737105, -8.549154180987864],
            [-2.386675366914932, -8.547384187703669],
            [-2.3851871066119883, -8.494281308470804],
            [-2.3824017037966567, -8.402054749996324],
            [-2.382005855065054, -8.396532700560273],
            [-2.3818195912280746, -8.382662151892902],
            [-2.3773088155272464, -8.212658354509127],
            [-2.3765452475895747, -8.185243945765917]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.94652069205371,
          "lat": 30.318066920000607
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48171"],
        "coty_name": ["Gillespie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gillespie County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "01383871"
      },
      "bbox": [
        -2.386675366914932, -8.561640018562912, -1.7643645651928868,
        -8.185243945765917
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5786139176406915, -5.522193023893225],
            [0.5808509809073559, -5.51926005808586],
            [0.58584659925184, -5.518293658332511],
            [0.5956991784186502, -5.506751189151789],
            [0.6011036908723648, -5.50924497869735],
            [0.6132148300054182, -5.500109925669207],
            [0.6230993551178216, -5.496775015866385],
            [0.6242903210690102, -5.4920931451831185],
            [0.632793183162115, -5.487440033980341],
            [0.6426217376570914, -5.485758077544948],
            [0.6473218965125822, -5.481157898375694],
            [0.6483488133129776, -5.473123844377014],
            [0.6526620195998022, -5.46762518355443],
            [0.6533394021216908, -5.464397764540206],
            [0.6577506159756619, -5.461932897677778],
            [0.6608364006082419, -5.456569885823179],
            [0.6601235729534102, -5.4541043736070085],
            [0.6659598508821443, -5.452991344716404],
            [0.6645042087852545, -5.44453276588604],
            [0.6707860715444007, -5.442983271892217],
            [0.6779600240802389, -5.444112707704248],
            [0.680070808453329, -5.439081010584603],
            [0.6845772911863905, -5.439708984286724],
            [0.6908577612947318, -5.436222631764978],
            [0.698386536656032, -5.44062639964027],
            [0.7021129292131817, -5.43827415683614],
            [0.704199538413563, -5.439460466397755],
            [0.7107709182168058, -5.434781027483407],
            [0.7188019749785975, -5.4337674108112335],
            [0.7207919619395546, -5.439887441774902],
            [0.7266802626198607, -5.440991583817419],
            [0.7307865234790631, -5.437307816398178],
            [0.7346173942537628, -5.438855240118553],
            [0.7426022469007064, -5.430638500765558],
            [0.7485068425890496, -5.429700470888769],
            [0.7538520553072202, -5.430851680194174],
            [0.7590277694957077, -5.42860862910622],
            [0.7605591976277649, -5.419793211817921],
            [0.767655186090625, -5.416418768538206],
            [0.7744303949965341, -5.408056557211875],
            [0.7764885296212272, -5.408059484637392],
            [0.7824971425209707, -5.402389595045396],
            [0.783238863593809, -5.395420509305836],
            [0.7872172354821476, -5.39071444411494],
            [0.7958952911637093, -5.388398194792089],
            [0.7989312403561631, -5.385322216244052],
            [0.811197594639505, -5.381566624343729],
            [0.8124489186986911, -5.386109842553697],
            [0.8185204232653478, -5.386488832091667],
            [0.8197634764366794, -5.384341216020626],
            [0.8312153102029118, -5.387946506725784],
            [0.8343370631965817, -5.386117701439731],
            [0.8351336872639931, -5.382817204026873],
            [0.8391794880238316, -5.3846645291419515],
            [0.8454698623318776, -5.379885240082439],
            [0.8498049843613678, -5.380825502267701],
            [0.8533601950213565, -5.383736010180775],
            [0.8568902553915702, -5.391346474722455],
            [0.8670464838755633, -5.394019770208894],
            [0.8698788571780142, -5.3907366677874595],
            [0.876051132007989, -5.389952016578256],
            [0.8808557928909247, -5.391325132337288],
            [0.8826715380352315, -5.387185868161112],
            [0.8855507381284188, -5.38599081157872],
            [0.8902884006953165, -5.390163295978249],
            [0.8948963943581487, -5.388461414309222],
            [0.8971306177674258, -5.383626865790057],
            [0.8997756528223247, -5.385742371773691],
            [0.9049052305476719, -5.382894310445828],
            [0.9104486739313776, -5.38155012965664],
            [0.9138924863198581, -5.377363734025268],
            [0.9120038612475493, -5.3753867088656495],
            [0.9170344492719362, -5.37254033527091],
            [0.9212446304913855, -5.375727801368584],
            [0.9272197318827277, -5.377233729718499],
            [0.9325591690616283, -5.375473175729943],
            [0.9423647060765035, -5.369916341341894],
            [0.9467377182672126, -5.371108717186101],
            [0.9490957624414834, -5.368650421047505],
            [0.9555585476227522, -5.370274547896407],
            [0.9611633206615959, -5.368015181183615],
            [0.9632681771250727, -5.372517791054253],
            [0.9711817255769543, -5.371331748292146],
            [0.9820521311084827, -5.371635239814458],
            [0.9865890532420744, -5.369554479057412],
            [0.9915147613273526, -5.374134884381963],
            [0.9976072796108323, -5.372833020287515],
            [0.9995331236893226, -5.374969164939407],
            [1.0071876482296962, -5.377624477749366],
            [1.014236567572708, -5.377959708085786],
            [1.0196008554864777, -5.375631762275816],
            [1.022670519542803, -5.372403464030735],
            [1.0274307659030597, -5.370834026182351],
            [1.0333918795832369, -5.371083068998448],
            [1.0337381291192218, -5.3681595308406775],
            [1.0371952289397057, -5.361995677040614],
            [1.0377932386415585, -5.409534812461176],
            [1.0384861960819836, -5.439021231892119],
            [1.0386721782710302, -5.483511267526905],
            [1.0392459187953518, -5.573298644487547],
            [1.0398183773341296, -5.661557308811952],
            [1.0399276458933848, -5.777348053716725],
            [0.9414294779248151, -5.778679477956038],
            [0.8634764415622033, -5.779642454402253],
            [0.7761247441318854, -5.780740746838598],
            [0.7427461992812746, -5.781083908661577],
            [0.7407286338706568, -5.761948358978715],
            [0.7036677131614802, -5.762079658856559],
            [0.6719442220093822, -5.761484093508308],
            [0.6162326584720887, -5.762257048188194],
            [0.5783454693804667, -5.762330599491022],
            [0.5778094404324826, -5.742165444722099],
            [0.5775726412949596, -5.691918170985822],
            [0.5778046217715997, -5.6766958125952725],
            [0.5779159422147084, -5.612231482041165],
            [0.5786139176406915, -5.522193023893225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.5639483677745, "lat": 33.14955226170745 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48223"],
        "coty_name": ["Hopkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hopkins County"],
        "coty_fp_code": "223",
        "coty_gnis_code": "01383897"
      },
      "bbox": [
        0.5775726412949596, -5.781083908661577, 1.0399276458933848,
        -5.361995677040614
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.03802864379426, -2.5376447163654317],
            [-3.923344552983874, -2.5444730318240545],
            [-3.8126427146067003, -2.5507960569820023],
            [-3.6079970174368015, -2.562003930216484],
            [-3.6105293275886616, -2.607034538753921],
            [-3.6156745958563112, -2.7024084838390845],
            [-3.6207635994657106, -2.7954489464385928],
            [-3.631474381927535, -2.9948103228946352],
            [-3.797923669998593, -2.9861753796684813],
            [-3.848014843519065, -2.983464128250181],
            [-3.9835710802771143, -2.9762490426860544],
            [-4.063258672829209, -2.9717134231198488],
            [-4.062129545896088, -2.9541581506456347],
            [-4.0589535848341445, -2.8977375524899744],
            [-4.048621126792971, -2.7213601363502695],
            [-4.03802864379426, -2.5376447163654317]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.35467916829921,
          "lat": 35.84003587770862
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48233"],
        "coty_name": ["Hutchinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hutchinson County"],
        "coty_fp_code": "233",
        "coty_gnis_code": "01383902"
      },
      "bbox": [
        -4.063258672829209, -2.9948103228946352, -3.6079970174368015,
        -2.5376447163654317
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5432813887054544, -5.3195718494252],
            [-1.542094662355958, -5.248792723207727],
            [-1.4393298406230317, -5.251768897117404],
            [-1.3359414424941443, -5.2542795323528235],
            [-1.235070466545421, -5.256080286306942],
            [-1.1755921657010022, -5.2569098031404575],
            [-1.1763317259906347, -5.290371212833997],
            [-1.1259662773096375, -5.291274195606035],
            [-1.1261421869797892, -5.302446750387366],
            [-1.1287556311211344, -5.4037607483214805],
            [-1.1293021633021092, -5.417975633874257],
            [-1.1305582632645719, -5.488537597303964],
            [-1.134578567792606, -5.626419740138299],
            [-1.1376311040704052, -5.724564891609442],
            [-1.24961314677276, -5.720181784682422],
            [-1.3383682238951622, -5.71693344725952],
            [-1.4077699568446385, -5.714671500556787],
            [-1.4633947935016196, -5.712414356498379],
            [-1.5581388073248532, -5.708352587654332],
            [-1.5551249340532358, -5.627608744528807],
            [-1.5525340585888239, -5.560359027900123],
            [-1.549181637727298, -5.493073832082851],
            [-1.546004657977561, -5.418052100937741],
            [-1.5441009962906944, -5.34667662884002],
            [-1.5436314588031141, -5.340713073781216],
            [-1.5432813887054544, -5.3195718494252]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.17247886425885, "lat": 33.23346075511601 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48237"],
        "coty_name": ["Jack"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jack County"],
        "coty_fp_code": "237",
        "coty_gnis_code": "01383904"
      },
      "bbox": [
        -1.5581388073248532, -5.724564891609442, -1.1259662773096375,
        -5.248792723207727
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.1300525954023004, -10.314481521710713],
            [0.14562965372181308, -10.236069463439591],
            [0.15345779677224575, -10.197999131944258],
            [0.17994245484539778, -10.0670397761871],
            [0.17935781442589221, -10.034948140941086],
            [0.18441655845317645, -9.935912332986987],
            [0.18709260664504, -9.884032077346049],
            [0.19144695987024604, -9.792073631146732],
            [0.19152672909632226, -9.784670053159735],
            [0.1929008407311238, -9.752017505102607],
            [0.23090849425524654, -9.729609469306148],
            [0.23796174896235064, -9.72583935936538],
            [0.25357643132955165, -9.716386981218017],
            [0.35950915916922155, -9.653311171845623],
            [0.42994700941635616, -9.611373305005968],
            [0.4775617401575139, -9.582105805639506],
            [0.4941611841995465, -9.571658606969784],
            [0.5399389770144305, -9.52482930017971],
            [0.5737386257866532, -9.489955915142966],
            [0.5994174617096343, -9.514585404752356],
            [0.58795891881245, -9.525800054850816],
            [0.6049645436692819, -9.542281187915762],
            [0.6020547571429665, -9.54528470951882],
            [0.6039585099215431, -9.549739601794064],
            [0.597432932458069, -9.551496349171526],
            [0.5946673033276999, -9.55868313351022],
            [0.5956618396210345, -9.563566943979248],
            [0.5942281303581516, -9.566624681499627],
            [0.596479303296567, -9.570216566156473],
            [0.6035875340953664, -9.578132643531953],
            [0.6050775480923564, -9.581449473185426],
            [0.6057694383517566, -9.588245385977443],
            [0.6029944514253136, -9.593833111843816],
            [0.6015094391725835, -9.601373995502621],
            [0.602925665202849, -9.602750859987086],
            [0.5980791558606572, -9.610408126137566],
            [0.6008561861172699, -9.61125280316395],
            [0.6020150689227962, -9.618614304756822],
            [0.6138247883295876, -9.627882906643418],
            [0.6193184339295253, -9.62687021428682],
            [0.6231421131846727, -9.628043107775293],
            [0.6335074368836328, -9.626982710844633],
            [0.6379585105968594, -9.637639973716487],
            [0.6408527368401933, -9.637043958008704],
            [0.6429457302825135, -9.642893031662803],
            [0.6458640675549113, -9.645994190593413],
            [0.6554558847343868, -9.65150803656991],
            [0.6614964538703851, -9.652627683787633],
            [0.6693168201921794, -9.656530713806827],
            [0.6670420599004785, -9.662605779474978],
            [0.6644927633373866, -9.66498922806977],
            [0.6600762195929898, -9.664597819325714],
            [0.6586093341258409, -9.672214638315632],
            [0.6528749294869614, -9.673921485169664],
            [0.6526608124628582, -9.678609372382846],
            [0.6567848207548328, -9.681952054591745],
            [0.6527203366074434, -9.686209286628017],
            [0.6532839675498985, -9.688834191870527],
            [0.6575845543476987, -9.689994224315575],
            [0.6577770493843067, -9.693290453177875],
            [0.6550733612209119, -9.696061530499032],
            [0.6571391058972434, -9.707484270341647],
            [0.662726205570108, -9.711250087584142],
            [0.6578361107843548, -9.718992120493281],
            [0.6591769980917498, -9.721311507244593],
            [0.6632626301495069, -9.72156777032474],
            [0.6676391948957783, -9.727181745106208],
            [0.6647336621712379, -9.730819444034834],
            [0.6690545962058924, -9.736015800507293],
            [0.6657512730937268, -9.737917809792007],
            [0.6649026948790964, -9.742967898767281],
            [0.6696448169682135, -9.748196352134293],
            [0.7217382304291141, -9.746813981459939],
            [0.7272817703901592, -9.745892220870498],
            [0.7295736116660106, -9.749796943333866],
            [0.7348621664079896, -9.750671967329891],
            [0.740723255757885, -9.754777375481337],
            [0.744445265743681, -9.749580508625778],
            [0.7483221334708775, -9.751034236485904],
            [0.7533729663655083, -9.758437016021796],
            [0.7659395768367602, -9.763487770557067],
            [0.7709657867839149, -9.772343818738328],
            [0.774089832835611, -9.775901245729441],
            [0.7715404855769779, -9.780026561909999],
            [0.7688122918152034, -9.788917709142611],
            [0.769565917137434, -9.795247935123252],
            [0.772151165404033, -9.79702570442161],
            [0.7748804050039735, -9.802075955049657],
            [0.7745209417437752, -9.804601446701604],
            [0.7778603257708515, -9.810468861160757],
            [0.7814869503158124, -9.810469086903794],
            [0.7850412225063504, -9.8166215736719],
            [0.787483102669907, -9.81669196510649],
            [0.7940534969154291, -9.820281777981961],
            [0.800014173771677, -9.828781432862298],
            [0.8046456714800815, -9.830914771999689],
            [0.8122575775716726, -9.837102122731615],
            [0.8198928423990346, -9.841939594906895],
            [0.8259252127228202, -9.84723767065414],
            [0.8274687233626408, -9.851185098840661],
            [0.8327826735511362, -9.8536737853244],
            [0.8355196134174774, -9.86073727096495],
            [0.8330631422432003, -9.873333068123202],
            [0.8377873721025649, -9.880061437279307],
            [0.8431987268949758, -9.883030649807695],
            [0.8545932531447928, -9.882387622399458],
            [0.8583846462701609, -9.88387404568579],
            [0.8641580120481638, -9.880078508891788],
            [0.8688645584423124, -9.879776748675742],
            [0.8757074617793345, -9.883494446314193],
            [0.8824110684860065, -9.879385229084573],
            [0.8947897918674922, -9.87550243621236],
            [0.8988786652867158, -9.875096885225],
            [0.8987829497186679, -9.884027226253938],
            [0.8961004569818817, -9.88686711035919],
            [0.8469937315078895, -9.915998584770762],
            [0.8247271237758155, -9.92889991211693],
            [0.7861152839042669, -9.950584180423501],
            [0.7727735755921558, -9.957274928937329],
            [0.7627666379863487, -9.960691235493803],
            [0.7611764713138488, -9.96563360373579],
            [0.7287167701955047, -9.98498170495215],
            [0.695783451616875, -10.005365436855985],
            [0.6641608931695988, -10.024251721760464],
            [0.6285074245347273, -10.044563078226151],
            [0.609709961590427, -10.054929163841628],
            [0.5602453587370108, -10.079008101284515],
            [0.4852786310295069, -10.112344362727644],
            [0.47820722392822534, -10.116755839935434],
            [0.47379537701573005, -10.116140520559894],
            [0.4640656353005415, -10.120261202619941],
            [0.4251126063123015, -10.137930198106472],
            [0.39039479168046476, -10.154039576695206],
            [0.3360509192878217, -10.181598785187973],
            [0.30412108933696097, -10.198297485014269],
            [0.2827724308148687, -10.209824541804657],
            [0.26667322863315124, -10.219425609827002],
            [0.22545432582915886, -10.244966462411842],
            [0.2026601452722934, -10.26171206479006],
            [0.19548442240076316, -10.267624344883744],
            [0.18496868731300992, -10.277320466681209],
            [0.18159081331548324, -10.282074472681103],
            [0.17300059031271744, -10.280860933641522],
            [0.16176718546166535, -10.287181742127673],
            [0.1510471709964226, -10.295554857110046],
            [0.13790586900457288, -10.30706320393154],
            [0.1300525954023004, -10.314481521710713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.01099304070648, "lat": 28.82114716351589 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48321"],
        "coty_name": ["Matagorda"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Matagorda County"],
        "coty_fp_code": "321",
        "coty_gnis_code": "01383943"
      },
      "bbox": [
        0.1300525954023004, -10.314481521710713, 0.8988786652867158,
        -9.489955915142966
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.2037247213138835, -2.8973036363886826],
            [-5.070261893764285, -2.906505999626041],
            [-5.064133685970021, -2.906291522291976],
            [-4.9680581042164915, -2.9129077602793743],
            [-4.869296178738567, -2.919787049260221],
            [-4.859968937198786, -2.9198186666721884],
            [-4.497191681573509, -2.9413190754395835],
            [-4.497634913106566, -2.9488437980852633],
            [-4.506347465643468, -3.06943194915702],
            [-4.5070428236824815, -3.071967438764227],
            [-4.515811831717041, -3.1975614420799428],
            [-4.528060795661044, -3.3621656031057534],
            [-4.530004579707059, -3.387674449774063],
            [-4.590902113692731, -3.383903752739415],
            [-4.597064103248642, -3.382765251633843],
            [-4.614619344076055, -3.381577799608668],
            [-4.632097573132023, -3.379402441377629],
            [-4.720982183709177, -3.3727388158107936],
            [-4.831700585806085, -3.3641324861114836],
            [-4.860322194888043, -3.362015345824087],
            [-4.900113219797503, -3.358717087385267],
            [-4.996468500625987, -3.354359841104204],
            [-5.001255101438839, -3.353866580304099],
            [-5.237198034996244, -3.3386192984884726],
            [-5.2331816834436955, -3.2802586536031493],
            [-5.232192875195737, -3.2714258196018164],
            [-5.221133009920525, -3.126105551170803],
            [-5.2037247213138835, -2.8973036363886826]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.60277084348931,
          "lat": 35.405045892515965
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48359"],
        "coty_name": ["Oldham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oldham County"],
        "coty_fp_code": "359",
        "coty_gnis_code": "01383965"
      },
      "bbox": [
        -5.237198034996244, -3.387674449774063, -4.497191681573509,
        -2.8973036363886826
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.633560926781197, 0.3807366663211663],
            [14.641626618083794, 0.4567276242745977],
            [14.645059022835495, 0.4573130418924806],
            [14.646308253254222, 0.46917461663166715],
            [14.644494008273234, 0.4787817575640909],
            [14.645693912246331, 0.4837149602222689],
            [14.644464357867127, 0.4969116366420063],
            [14.647366598688574, 0.5123578828897166],
            [14.664022733207302, 0.6718160446810826],
            [14.6719008108289, 0.6721023174767219],
            [14.67713693664944, 0.6703467173563006],
            [14.683074801614513, 0.6641460340718107],
            [14.686289524931366, 0.6656557445282635],
            [14.687527630201267, 0.6611669715470183],
            [14.697574146397923, 0.6641110699110021],
            [14.70176364958982, 0.6615761468736716],
            [14.703172650042264, 0.6505544641551507],
            [14.708704286724295, 0.6497093247026924],
            [14.714534151818325, 0.6439038533422219],
            [14.71427450848567, 0.637853412994206],
            [14.718597862976727, 0.6380461795490618],
            [14.72293943062162, 0.6409087523961384],
            [14.725642372240143, 0.636494994914885],
            [14.729638278502163, 0.6347464077488271],
            [14.727835841408293, 0.6275220170164989],
            [14.730023950590256, 0.624231923788697],
            [14.733472679262887, 0.6257059621599788],
            [14.735016848402372, 0.6308035061904236],
            [14.741521131365692, 0.6321493118206373],
            [14.75012159313726, 0.6284315144592652],
            [14.756491196092083, 0.6310456899422403],
            [14.756732072059206, 0.6363132314935933],
            [14.758495217048587, 0.6391310359158259],
            [14.763900108373514, 0.6369527333952947],
            [14.766913597908983, 0.6322489990534911],
            [14.770363895318896, 0.6295688463561303],
            [14.769297521325777, 0.6265665117857083],
            [14.77391217358048, 0.6198331797372806],
            [14.778500544437843, 0.6201831411151661],
            [14.786761232421616, 0.6118884800080123],
            [14.781601713436633, 0.6108485370734961],
            [14.780202817067211, 0.6071796971517126],
            [14.790223629193903, 0.6019571084673506],
            [14.796407518134357, 0.6086235740093345],
            [14.802221545347042, 0.6093940421395337],
            [14.805224306034075, 0.6043731304978427],
            [14.808987037859143, 0.6021344763785605],
            [14.812808297547987, 0.5970608132252295],
            [14.816441162012309, 0.5952177792200137],
            [14.825866218757854, 0.594451442009705],
            [14.8339739287761, 0.5917014603017151],
            [14.836564093100717, 0.5835523678166088],
            [14.840574559582787, 0.5829282106442967],
            [14.844006573027967, 0.5790797326426655],
            [14.84881899625472, 0.580275413339831],
            [14.853148909375333, 0.5866738229486658],
            [14.859934766936728, 0.5871607524802244],
            [14.864538148943462, 0.5900691948068059],
            [14.866522249733777, 0.5935204262715781],
            [14.871709193570977, 0.5962102583172997],
            [14.875539886805612, 0.5903872770122088],
            [14.880259111020509, 0.5882666841562324],
            [14.88478759788876, 0.5785839998736058],
            [14.888316172142018, 0.5769847295859856],
            [14.889574767126518, 0.5733315015406051],
            [14.89530041652514, 0.5702372703067405],
            [14.89222286235526, 0.5609113231649961],
            [14.895041041501582, 0.5527627082367021],
            [14.89427962967469, 0.5463760847315287],
            [14.896670107447168, 0.5449963487365755],
            [14.895752747803815, 0.5410359563382148],
            [14.897973063834682, 0.5378705532611937],
            [14.897419245820767, 0.53425592288767],
            [14.900926518665496, 0.5301367861224935],
            [14.905140795936415, 0.531054535926606],
            [14.911783591865108, 0.5303320043371519],
            [14.913639807640443, 0.5273387230734597],
            [14.9123510156238, 0.5238170842633482],
            [14.907581311505481, 0.5225604807416173],
            [14.905497600323317, 0.5204092441715719],
            [14.906033793848671, 0.5145676064598451],
            [14.909312182204665, 0.5155523361596057],
            [14.913894309107281, 0.5124760867586622],
            [14.920306537320565, 0.5115137358559012],
            [14.922218205104038, 0.5146339713502724],
            [14.928084357569748, 0.5124079918945968],
            [14.927984656055287, 0.5004024296654256],
            [14.93453938276667, 0.4975308341631717],
            [14.933276144110032, 0.49502169051675543],
            [14.924845474886753, 0.4947627246417854],
            [14.924174200108297, 0.4899252122446261],
            [14.932203583665942, 0.4872487463587105],
            [14.938669521979305, 0.4901164183976893],
            [14.9489797184179, 0.4897080608019368],
            [14.950592641843945, 0.4974756389778221],
            [14.949422847178328, 0.5009639871408923],
            [14.952503055372027, 0.5054856739619831],
            [14.952340925718492, 0.5083144773989996],
            [14.958142279540715, 0.5127695967460901],
            [14.96190845541731, 0.5115145379120999],
            [14.964262192311644, 0.5072794218030224],
            [14.969063689866621, 0.5069995127378157],
            [14.978868048840537, 0.5117418025409864],
            [14.981150852795148, 0.5092720349965878],
            [14.983226375954182, 0.4981413376194771],
            [14.990588637214172, 0.49183945595586087],
            [14.99019184090518, 0.48879314790612916],
            [14.983665251016966, 0.4879389917850732],
            [14.979399717026654, 0.48218241410339535],
            [14.98304299095294, 0.47555700698285425],
            [14.987271334467103, 0.47338366681480415],
            [14.99381425064517, 0.4769253199007364],
            [14.998694520467613, 0.4755176340083525],
            [15.007315229827011, 0.47962786275424424],
            [15.010333731193992, 0.47609540030396336],
            [15.009743206583439, 0.46891123665888124],
            [15.00708413625178, 0.4651575849374593],
            [15.001817437958644, 0.4672179256689749],
            [14.996767031490409, 0.465142455232459],
            [14.99746034656831, 0.4600160997683482],
            [15.001327704868162, 0.45603344332885104],
            [15.008189888607145, 0.45965207991029894],
            [15.00997845019765, 0.4593484490377086],
            [15.015231601911553, 0.46469112087676046],
            [15.018141094301408, 0.46593428409979015],
            [15.019516083614501, 0.4605926395812744],
            [15.017610446534254, 0.45556685841442773],
            [15.018771946032354, 0.4499612610076104],
            [15.026731184303287, 0.4421556763443883],
            [15.034363336357861, 0.4423303948169595],
            [15.037248360715255, 0.4502757860966749],
            [15.03969493264481, 0.4532684626523065],
            [15.045881000766949, 0.45071848124033925],
            [15.049535168373614, 0.4451422701255772],
            [15.058852365236822, 0.4424494666575855],
            [15.062226413256807, 0.4461607748029842],
            [15.055575845938717, 0.4569465102315612],
            [15.055235541846823, 0.46322801757470194],
            [15.058446899630145, 0.4641161277993941],
            [15.062134284417526, 0.45973235472808366],
            [15.06485504760646, 0.46142882970908056],
            [15.068291396492784, 0.456078532664258],
            [15.067451963166768, 0.4529550984965904],
            [15.07215913978927, 0.44998357060487476],
            [15.069529505965342, 0.44110376104446836],
            [15.06690609077871, 0.43524065030570686],
            [15.064695611295482, 0.4333003188278152],
            [15.071604771292268, 0.4264468037375713],
            [15.06890467214241, 0.42137471596089865],
            [15.074521271157629, 0.42087612866133994],
            [15.084048745114421, 0.4259514223884182],
            [15.089251327835909, 0.4276769041699119],
            [15.09258815657957, 0.426583144502903],
            [15.094597040390948, 0.42247582888538815],
            [15.092717855115257, 0.41727252794538716],
            [15.097721913520214, 0.4170081894897261],
            [15.100648320630194, 0.4192660218771887],
            [15.100996262697, 0.42381156079487203],
            [15.09929100359554, 0.4269960931946066],
            [15.100853321413842, 0.4308612235718306],
            [15.104291017088288, 0.4324308673604559],
            [15.112650510456914, 0.4303100037455897],
            [15.114914260002585, 0.42698640822191813],
            [15.117121984983346, 0.4178707057828943],
            [15.112020957354833, 0.4063694026968537],
            [15.116867857146117, 0.4010271010136308],
            [15.120748986216823, 0.4011114685719277],
            [15.131833224637456, 0.4073332688776821],
            [15.133304812210064, 0.41265080303960844],
            [15.145838933499034, 0.41365703264468623],
            [15.146097254075544, 0.41637353431515517],
            [15.142734734079529, 0.423738787735035],
            [15.146964375941664, 0.42221382797618934],
            [15.147563164240124, 0.41930705265199075],
            [15.154306690849987, 0.41758126894332914],
            [15.155452680854257, 0.41496068419126103],
            [15.165715073868066, 0.41343583413132395],
            [15.16903094930778, 0.41445866010115445],
            [15.172536218725773, 0.4184204380542581],
            [15.175523029156926, 0.4175386709775605],
            [15.177170137551277, 0.41416938835779615],
            [15.177056313487295, 0.407663200102329],
            [15.172909147841601, 0.39821885509572913],
            [15.173428971060556, 0.3951880290393357],
            [15.176595810955375, 0.3923873201389472],
            [15.174070887659555, 0.39000116330655216],
            [15.169861707973732, 0.3905094355540291],
            [15.165158852641849, 0.38791813263829045],
            [15.171432085962001, 0.3802387410841145],
            [15.169646667127427, 0.3774784298303542],
            [15.163736151448822, 0.3782092926388988],
            [15.162531650938329, 0.3670293374815687],
            [15.16802208054764, 0.36138187412556333],
            [15.1663692267002, 0.3575010099230324],
            [15.163475692957128, 0.35628668582750894],
            [15.1654121220514, 0.3473534917891025],
            [15.16356830915518, 0.3417040117765245],
            [15.157594211272986, 0.34111502307849756],
            [15.151565786546346, 0.34213162391832624],
            [15.148022466368104, 0.3412602876716794],
            [15.14112133398948, 0.34287900188650294],
            [15.116947815403742, 0.3050668060551104],
            [15.116442116704112, 0.30120450500962664],
            [15.111132589988456, 0.28940735023297803],
            [15.102484739651555, 0.28399106188199164],
            [15.100452765481416, 0.27503422522798016],
            [15.098802755906119, 0.27421921577566044],
            [15.094080939777944, 0.2745335155332778],
            [15.082998792538294, 0.28020370221764224],
            [15.07689025280629, 0.2840179912528055],
            [15.069142316113538, 0.28357190650668923],
            [15.063648881668684, 0.2853691112602338],
            [15.059838456992122, 0.2852041027516867],
            [15.055662707994644, 0.2888019831095149],
            [15.049750981884191, 0.28669968503451654],
            [15.044263922249009, 0.2869364245532286],
            [15.03469459498698, 0.29167646761342475],
            [15.031141544564788, 0.29128816444828837],
            [15.025759665939036, 0.2943826229215257],
            [15.01859469205809, 0.29600038401480794],
            [15.016315084294238, 0.29804673623457173],
            [15.004120189783169, 0.2995930461259312],
            [14.995137066199538, 0.30566349784517066],
            [14.98640016152046, 0.30863231791884826],
            [14.979305163955253, 0.30851198433925436],
            [14.974393247110726, 0.31118282732770103],
            [14.97138926284678, 0.31062815880175776],
            [14.96310692213139, 0.3171947874844282],
            [14.96041245708325, 0.3156693511478977],
            [14.958710935288009, 0.32028372097396696],
            [14.954608443625807, 0.324351302605691],
            [14.956153553648985, 0.3328404347278706],
            [14.954932815505133, 0.3361274143336271],
            [14.9515692847856, 0.3369494773642628],
            [14.943630280107302, 0.3412311916712543],
            [14.935928860776034, 0.3557011288144128],
            [14.931011984607826, 0.3573796046497754],
            [14.929112072491773, 0.3640517803473898],
            [14.920418609925916, 0.3725771146724196],
            [14.91824581364866, 0.3812026224193318],
            [14.914837093778736, 0.38596345543665767],
            [14.910072376204557, 0.3872653071194625],
            [14.909110905931263, 0.382890978506494],
            [14.902455078318864, 0.379471689275342],
            [14.892162994638795, 0.38714623964964384],
            [14.888737923275388, 0.38416752726352876],
            [14.888612977227535, 0.3794668411337298],
            [14.884032316874892, 0.3807181282673594],
            [14.877481475321538, 0.3853903037136643],
            [14.871313085912925, 0.3973049064564194],
            [14.865640575547484, 0.3943318805277235],
            [14.858642189441715, 0.39508324062317063],
            [14.852095314467691, 0.3895534541492678],
            [14.846979938643418, 0.3876365772382505],
            [14.84374500602394, 0.381479472466472],
            [14.839123282398093, 0.3772408905557478],
            [14.83728663530252, 0.37323133975095235],
            [14.83237736273043, 0.369935059101385],
            [14.82783457874298, 0.370514806462004],
            [14.826725941849501, 0.3683488309074524],
            [14.81923670470423, 0.36893777741906],
            [14.814185608746353, 0.37190063556732483],
            [14.809563889489189, 0.3717589600042562],
            [14.805971873526273, 0.3746721698127307],
            [14.794919949548747, 0.37766169868821214],
            [14.794822249038402, 0.381144331420384],
            [14.791581083779258, 0.38381299205747055],
            [14.780624685578013, 0.38862166210841503],
            [14.775535451742414, 0.3851777887133027],
            [14.772537538709331, 0.3813587007118466],
            [14.766001974090123, 0.38090764626320367],
            [14.743185190257535, 0.3810841284957455],
            [14.738346306770792, 0.37701818956368427],
            [14.726338212860776, 0.37267575795912566],
            [14.716473182361474, 0.3728336671746209],
            [14.703686648047357, 0.36934545173485084],
            [14.673040319794625, 0.37394105456875165],
            [14.654791523184768, 0.37486399222149425],
            [14.645162962043612, 0.3737336111358519],
            [14.633421373304774, 0.3794238496568993],
            [14.633560926781197, 0.3807366663211663]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.49089528294766,
          "lat": 37.760072806975174
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51085"],
        "coty_name": ["Hanover"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hanover County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01480132"
      },
      "bbox": [
        14.633421373304774, 0.27421921577566044, 15.177170137551277,
        0.6721023174767219
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.437146500467467, 0.539077291123428],
            [15.452902942082055, 0.5712743614353227],
            [15.459230663462193, 0.5762573019678263],
            [15.468453387600038, 0.5734604503410166],
            [15.475110658929324, 0.582831545429506],
            [15.477817439494393, 0.5887687835434648],
            [15.480907475942963, 0.5912240014860891],
            [15.481561760113216, 0.5862566191034608],
            [15.484634793285938, 0.5808483119097932],
            [15.48836375790552, 0.5779599760089887],
            [15.4941556599318, 0.5761683456530801],
            [15.499279884764652, 0.5758673718950282],
            [15.517819080648001, 0.5787188406008794],
            [15.526858022439768, 0.5781261876495041],
            [15.534604773341547, 0.5758505956145539],
            [15.53754064493271, 0.5734591566846354],
            [15.533047132855936, 0.5699140431394596],
            [15.537238545350858, 0.5653806132227785],
            [15.537811576924417, 0.5622035924998949],
            [15.548848145991979, 0.5581985362530483],
            [15.55749093195861, 0.5522019530722984],
            [15.55934138895419, 0.5481715629325544],
            [15.558499449839397, 0.5440075964902923],
            [15.56171423743655, 0.5349686150497032],
            [15.568766138464717, 0.5302901392677053],
            [15.569104301788597, 0.5249793385207587],
            [15.571180881141652, 0.5215145521202478],
            [15.580201369129398, 0.5115552319839817],
            [15.580384815045342, 0.5097545616760213],
            [15.57380564758673, 0.5025281087848457],
            [15.587890664759954, 0.49577351318386964],
            [15.588661407879982, 0.4901510878634024],
            [15.586757822767154, 0.48823238175270545],
            [15.593989673740461, 0.4831098059924648],
            [15.598107654347231, 0.4785794619467009],
            [15.605377341807435, 0.47585806652060575],
            [15.613950574471946, 0.4650501532651576],
            [15.619943803601718, 0.46159974930459646],
            [15.627659464026978, 0.45873952263020623],
            [15.632969816093143, 0.4585896982982256],
            [15.638439677065108, 0.4603174788537187],
            [15.65023058251872, 0.46270758585570515],
            [15.65938200121886, 0.4659178342872621],
            [15.672608628607065, 0.4663929921215455],
            [15.68187574718207, 0.4689278991411319],
            [15.686878016677829, 0.47171219249925267],
            [15.68898615808565, 0.4699805778761567],
            [15.693070240032132, 0.4722065944167691],
            [15.704682802831153, 0.4751473761227069],
            [15.707011183107888, 0.47381807356717526],
            [15.707114309132212, 0.4689077000257602],
            [15.709326290206366, 0.4601433392309294],
            [15.704859722799474, 0.4587248119528276],
            [15.712219145888543, 0.4540454298702848],
            [15.713611969955327, 0.4507815558844664],
            [15.71836757442532, 0.4496953671081835],
            [15.72540474533037, 0.4461142809199484],
            [15.730334499348018, 0.4483436252860051],
            [15.74999835569078, 0.4434814553698573],
            [15.764347449976578, 0.44616298500959134],
            [15.77081413774958, 0.44855840482553705],
            [15.790925604535609, 0.44900444761736363],
            [15.800889773407311, 0.44632993004534327],
            [15.805966354533156, 0.4426841274103492],
            [15.812289315204607, 0.44652139029289456],
            [15.81761426321738, 0.44603952172822514],
            [15.820143695040983, 0.44234287530401334],
            [15.817772150797358, 0.4353011451122148],
            [15.811759500526643, 0.42898223133412716],
            [15.805432020799199, 0.4275144909173589],
            [15.798523732613615, 0.4279796825928191],
            [15.797435230211017, 0.42501378672804924],
            [15.800065640057852, 0.4219052644577277],
            [15.802294023829587, 0.41078504448893693],
            [15.800599658824686, 0.40585638847551947],
            [15.798427802916445, 0.4182647986671956],
            [15.797068878677488, 0.4206941497525323],
            [15.79215086900607, 0.42141176561044497],
            [15.791857972704904, 0.4164803256841424],
            [15.785308437669155, 0.4132676377315607],
            [15.780224021730593, 0.4132712780631813],
            [15.775988854205469, 0.4093697083073379],
            [15.777952411927098, 0.40328236967358155],
            [15.763581161704904, 0.4037946330837251],
            [15.757013013076282, 0.4007140598477208],
            [15.75098348846573, 0.4006292876750202],
            [15.743147205853681, 0.403399201044241],
            [15.741022830221642, 0.3956912996300038],
            [15.74093042249112, 0.38665463765077224],
            [15.741886564005728, 0.38327896998947225],
            [15.740557082381695, 0.37954307959876377],
            [15.736233216121246, 0.37591078203344913],
            [15.73127384003548, 0.3754378274816035],
            [15.725942729989805, 0.37850114629394144],
            [15.721811973477429, 0.3770898203594947],
            [15.71656809006338, 0.37754354600370416],
            [15.70607748718206, 0.38057945425103185],
            [15.70018095826841, 0.38603290451387295],
            [15.691438127547377, 0.38759992353334843],
            [15.68373831568913, 0.39169557395273136],
            [15.669229342089988, 0.38972176299815237],
            [15.665387597442075, 0.3953759152069711],
            [15.661393738482307, 0.39868715826835716],
            [15.657504843760478, 0.399151057288484],
            [15.649903301292964, 0.39713025704888066],
            [15.646263676759068, 0.39866861412008586],
            [15.644583103259821, 0.40221790616546144],
            [15.638318370804765, 0.40536766265747515],
            [15.631639920766824, 0.40485635183778396],
            [15.630466405153038, 0.40955064855133416],
            [15.625946333559659, 0.41233947154173384],
            [15.623072046120512, 0.4101856695812808],
            [15.625188958497628, 0.4053241187677604],
            [15.624350583982094, 0.3990912736060019],
            [15.62070572601628, 0.39955091919468144],
            [15.620955411619706, 0.40282239051237273],
            [15.616584719869943, 0.40434748076753224],
            [15.610251840636613, 0.4024350729081709],
            [15.607288369700687, 0.4033768927876822],
            [15.604006516295682, 0.40971531409779477],
            [15.603986493624625, 0.4138763575500267],
            [15.599002716211947, 0.41478432709062046],
            [15.597114385196093, 0.4173217676442042],
            [15.59202828160061, 0.41759226590837284],
            [15.590734206747602, 0.4210541441595636],
            [15.585049986085249, 0.4246876599192537],
            [15.5806120334983, 0.4238401164096677],
            [15.578161423275153, 0.41829151464424],
            [15.573473666661233, 0.41591513800015006],
            [15.571122283810418, 0.4175777034936066],
            [15.572322143048202, 0.4243325051754808],
            [15.567984888812278, 0.42348696987095774],
            [15.565793424313947, 0.4189370720672925],
            [15.559391525020803, 0.42289202932245934],
            [15.552821262188376, 0.42087136662503993],
            [15.549675620247973, 0.4242727699589907],
            [15.539023875232663, 0.42882485981665436],
            [15.537159939211268, 0.4303527580603783],
            [15.530799324015772, 0.431513702012349],
            [15.529542046199973, 0.4344742801402589],
            [15.522896928273168, 0.4362606721790558],
            [15.520295368964016, 0.43913897781611777],
            [15.512631600713473, 0.4397985139677522],
            [15.508621829380012, 0.4451839975038754],
            [15.499770981874315, 0.4505085666906064],
            [15.496389938620549, 0.46027357503480326],
            [15.491997526754792, 0.4604537698557738],
            [15.488384488301953, 0.46350292376487096],
            [15.487476757682153, 0.4698028305611969],
            [15.483415061295824, 0.4732999713608649],
            [15.476973745781484, 0.47420050905306976],
            [15.477257090260748, 0.4770989941625885],
            [15.473047796360616, 0.4801702901197466],
            [15.47040060796962, 0.4850763378029119],
            [15.470583898859196, 0.48858202133014694],
            [15.46547550914516, 0.4902470509400611],
            [15.464684341165094, 0.4997882709291089],
            [15.465102766279998, 0.5039515316460186],
            [15.459959444136283, 0.5019818167547154],
            [15.44995377469916, 0.5110850502910542],
            [15.44857892825842, 0.5149972164855046],
            [15.444718898156934, 0.5170959323972709],
            [15.44059120886778, 0.5223220681998977],
            [15.441132223689836, 0.5262689508529855],
            [15.437146500467467, 0.539077291123428]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.56996980079744, "lat": 37.63030381181427 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51119"],
        "coty_name": ["Middlesex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Middlesex County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01480147"
      },
      "bbox": [
        15.437146500467467, 0.3754378274816035, 15.820143695040983,
        0.5912240014860891
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.065665201601414, 1.3296248337646703],
            [14.069272041420318, 1.3332839465572306],
            [14.075652569101624, 1.3341249019131125],
            [14.080842402786717, 1.3317954308130318],
            [14.086593462391926, 1.3337903048824173],
            [14.09002315809764, 1.3318902975135618],
            [14.095657288733634, 1.3393507474412076],
            [14.099661766997563, 1.3386970599499124],
            [14.102204425993646, 1.34490307133398],
            [14.105234083642447, 1.3472450512329748],
            [14.10962421542211, 1.346994681255375],
            [14.113215067897691, 1.352696880151822],
            [14.117009948003705, 1.3552027794920354],
            [14.122146185859483, 1.3555927572066928],
            [14.126086003845622, 1.3588622673144721],
            [14.129514593227134, 1.364490669129837],
            [14.129758967788911, 1.3704702399570798],
            [14.135318442300976, 1.3772314048764136],
            [14.135605702139319, 1.400912323952733],
            [14.13450240422586, 1.403493504827483],
            [14.14092075765508, 1.4056327773581554],
            [14.14031678570356, 1.412945413929541],
            [14.138880253186471, 1.4153492360501143],
            [14.139845439448116, 1.4200674332489487],
            [14.143578847279233, 1.4235717232166463],
            [14.146575176465142, 1.4329652845100118],
            [14.150102165945176, 1.4370832997048937],
            [14.148031431147457, 1.442880256694363],
            [14.155840941678854, 1.4456649445819976],
            [14.154467100999861, 1.4489464829470424],
            [14.157913447883706, 1.4501512871031603],
            [14.163692109850395, 1.4545113469159348],
            [14.162773416761087, 1.45645115112184],
            [14.167978216340975, 1.458078333228031],
            [14.17073599148859, 1.4490864677602693],
            [14.175144805990287, 1.4459182813397586],
            [14.178598551187035, 1.4404784716313563],
            [14.184462639477356, 1.4375486767045833],
            [14.186610102162701, 1.433248474193458],
            [14.192654321426453, 1.4267179499413514],
            [14.200496796920257, 1.4259273365734226],
            [14.205664489309447, 1.4228105594115217],
            [14.207805428957926, 1.4240964575776882],
            [14.21463393529383, 1.418303553791154],
            [14.217840786199288, 1.4182373262355765],
            [14.230701013761347, 1.4114862409208588],
            [14.237422991824907, 1.4060783648076522],
            [14.244418589594074, 1.4038176257740376],
            [14.246559761050307, 1.4060409499641076],
            [14.255225817120795, 1.4031037287173729],
            [14.251200203225501, 1.400321284572623],
            [14.256708669835524, 1.3890197053038182],
            [14.260933119976665, 1.389367662006497],
            [14.26294131312461, 1.385584484775803],
            [14.258775767433072, 1.3819630497020616],
            [14.26255217027132, 1.378129682929894],
            [14.260364620657317, 1.3719350941184105],
            [14.260774121227383, 1.3648016972624113],
            [14.263862281759591, 1.3623689234488785],
            [14.270275193398943, 1.3630537241849254],
            [14.269323333369547, 1.3577511044943935],
            [14.272254523188327, 1.356341997883512],
            [14.271883001398242, 1.3482592699247615],
            [14.274937542989994, 1.3495049544931523],
            [14.277182208421932, 1.346989120529697],
            [14.277276549149688, 1.3425393303017303],
            [14.280265909324518, 1.3397467880084202],
            [14.276970466872646, 1.3366314942507345],
            [14.284087923236276, 1.3301277219481018],
            [14.288740358431614, 1.329178231032312],
            [14.294328046638658, 1.3228486360168643],
            [14.303239289393646, 1.3217101004024525],
            [14.30867284912299, 1.3189194704931766],
            [14.322000558991231, 1.3163475380574405],
            [14.326355462209225, 1.3140046061883162],
            [14.330025142015964, 1.3170533752406408],
            [14.33620913163389, 1.3163052794968806],
            [14.337190920459312, 1.3190289967136317],
            [14.342878571900306, 1.317187871786734],
            [14.275838897841169, 1.2349641198710446],
            [14.244116063489862, 1.1964615739655597],
            [14.207721330860167, 1.130054418395445],
            [14.198050161227478, 1.1127017479037316],
            [14.19315053401072, 1.1086716568321804],
            [14.190357436114246, 1.114014483423563],
            [14.183148058990236, 1.1139624991112653],
            [14.18104667230782, 1.1097333154286937],
            [14.17419668284838, 1.112727217728091],
            [14.169534546884025, 1.1168532571747591],
            [14.16671440819293, 1.1137060966597205],
            [14.162231413495993, 1.1197950820012366],
            [14.15994540891735, 1.1204843539980762],
            [14.155873845912728, 1.1155430841147724],
            [14.150343907914904, 1.1142184115914149],
            [14.14844589666587, 1.1122740157873487],
            [14.128931904876238, 1.128189651177499],
            [14.11885627913563, 1.1368941096479064],
            [14.116173778236114, 1.1381836648414938],
            [14.095920278291603, 1.1541649750622864],
            [14.049786365625708, 1.1910380903601028],
            [14.054900707181472, 1.192684718752082],
            [14.058507339432968, 1.1961765907743258],
            [14.060892051702163, 1.2094616605486337],
            [14.060326211957118, 1.2126557350205796],
            [14.062436022988798, 1.218329728927711],
            [14.057605717089206, 1.2267984714162148],
            [14.057592636349751, 1.2358418478090036],
            [14.052327262968987, 1.2375148000742844],
            [14.053494025601957, 1.2439644013822468],
            [14.057563478733726, 1.2492006777555067],
            [14.054563505037901, 1.2569032168963656],
            [14.050422951737415, 1.2640151787197782],
            [14.042844420257486, 1.2671504173661383],
            [14.040647845919276, 1.2666993718645612],
            [14.040502939981634, 1.2757503899121734],
            [14.043231592618296, 1.2863084475218196],
            [14.043084772531003, 1.29453223940244],
            [14.043890356931058, 1.3034909207443257],
            [14.047901467992382, 1.30353802767219],
            [14.054368450221943, 1.3057755430676574],
            [14.057069715405541, 1.312777349005276],
            [14.056576954669566, 1.3166680923226348],
            [14.058684640894644, 1.3199054263640038],
            [14.062985534872984, 1.3199341504622082],
            [14.065665201601414, 1.3296248337646703]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.15919010304478,
          "lat": 38.684831588363295
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51157"],
        "coty_name": ["Rappahannock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rappahannock County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01673976"
      },
      "bbox": [
        14.040502939981634, 1.1086716568321804, 14.342878571900306,
        1.458078333228031
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.882397628975683, 1.626265253549331],
            [14.902955326466667, 1.6123002460570224],
            [14.90334796744176, 1.6100031051632349],
            [14.89887017959119, 1.608346001874289],
            [14.884176400693825, 1.6116740309307593],
            [14.879864605338026, 1.6112867218795017],
            [14.87218746091275, 1.6086644163049384],
            [14.867199872645545, 1.6158771085305594],
            [14.869294061686977, 1.6267470322553919],
            [14.882397628975683, 1.626265253549331]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.17464426912747, "lat": 38.88429786954588 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51610"],
        "coty_name": ["Falls Church"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Falls Church city"],
        "coty_fp_code": "610",
        "coty_gnis_code": "01498423"
      },
      "bbox": [
        14.867199872645545, 1.608346001874289, 14.90334796744176,
        1.6267470322553919
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.650848715169472, 0.877923712479377],
            [13.650729922635403, 0.8800274041910603],
            [13.654283231243985, 0.8941841800883623],
            [13.657720302015887, 0.9004388374660866],
            [13.655669802440531, 0.9013539530778928],
            [13.657180465765173, 0.9098547995556234],
            [13.649031723985425, 0.920069180834367],
            [13.644885153022939, 0.9212767290021155],
            [13.646955629226381, 0.9291996062352038],
            [13.647964141429505, 0.9365560393750637],
            [13.652289256313283, 0.9449547935607219],
            [13.661849495398544, 0.942732736632386],
            [13.662241233111464, 0.952786223222297],
            [13.664355788383999, 0.9645275097770433],
            [13.667742469157258, 0.9774140365537014],
            [13.670158853145606, 0.9769695806098906],
            [13.671060646195029, 0.9696945297003289],
            [13.68192153464366, 0.9669704621458614],
            [13.69070778558679, 0.9576981282379783],
            [13.693168296251276, 0.9528922756378629],
            [13.693218129474609, 0.9452881682523081],
            [13.700533693527433, 0.9498713852498162],
            [13.703315152398323, 0.9504786963588467],
            [13.70539579568582, 0.9448401037903496],
            [13.705880320939452, 0.938672992328082],
            [13.708845764984316, 0.9386900089097929],
            [13.712910979068592, 0.9358125201588511],
            [13.71485503558745, 0.9315859503776013],
            [13.71259224749018, 0.9183656562812806],
            [13.71521904089147, 0.9166623198771253],
            [13.698297715888291, 0.9066818762502448],
            [13.692492344711374, 0.9076563795093067],
            [13.69015873068869, 0.9044671218868566],
            [13.680411004769105, 0.9021460698030174],
            [13.67544018319981, 0.8983190950678882],
            [13.676014974988448, 0.89105614995034],
            [13.672312137396172, 0.8919061513972275],
            [13.67273408712366, 0.8784763195298085],
            [13.662859505613172, 0.8774898203405115],
            [13.66037627705417, 0.8781825776144631],
            [13.65654048981906, 0.874455931091968],
            [13.650848715169472, 0.877923712479377]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.87352743540433,
          "lat": 38.436144906298274
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51660"],
        "coty_name": ["Harrisonburg"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Harrisonburg city"],
        "coty_fp_code": "660",
        "coty_gnis_code": "01498563"
      },
      "bbox": [
        13.644885153022939, 0.874455931091968, 13.71521904089147,
        0.9774140365537014
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.721880341926285, 9.670601807949454],
            [-14.719626142510185, 9.667708884474948],
            [-14.714203039029876, 9.6643166150347],
            [-14.711453997271619, 9.662326029171357],
            [-14.702923791436369, 9.644409969493779],
            [-14.69780137751868, 9.6374170074726],
            [-14.696051648781312, 9.631383411755992],
            [-14.692656747000854, 9.626963483830087],
            [-14.683601955010932, 9.622734702205124],
            [-14.672721322521117, 9.623134850393912],
            [-14.65638172843134, 9.618310378173469],
            [-14.650578099826514, 9.618598801999944],
            [-14.645850782116135, 9.620681319738994],
            [-14.64094063359336, 9.628301408145276],
            [-14.635154672975567, 9.631276288615789],
            [-14.628622586156009, 9.63029440039642],
            [-14.61914915322841, 9.627690227452927],
            [-14.60980707092333, 9.62792846415019],
            [-14.604108239072282, 9.628864903651191],
            [-14.5939699320598, 9.632412446821567],
            [-14.577870238427838, 9.631461941154017],
            [-14.56961440913093, 9.62998819567115],
            [-14.560090673373479, 9.626261434490383],
            [-14.537559826989005, 9.62628403815532],
            [-14.523973626679654, 9.619097375061877],
            [-14.50941971612301, 9.612397647058838],
            [-14.497743221430142, 9.610313656659207],
            [-14.492597450058446, 9.611612327427265],
            [-14.48947758256066, 9.615278073902827],
            [-14.483260675937316, 9.630675876930715],
            [-14.478918798262312, 9.636434688498547],
            [-14.472546012752577, 9.640615331066444],
            [-14.467437381134244, 9.64185785125031],
            [-14.461958032791753, 9.641700280650202],
            [-14.477489635978868, 9.580205493552215],
            [-14.483139783829682, 9.581546164524033],
            [-14.504676896629336, 9.496082438548363],
            [-14.448120060280942, 9.483832931878968],
            [-14.41971919741701, 9.477312536402675],
            [-14.426459337931103, 9.449109575558339],
            [-14.412509881364734, 9.445707023423966],
            [-14.422371123598793, 9.4033359553194],
            [-14.407965277292819, 9.400104276105699],
            [-14.411124583525956, 9.386256097852558],
            [-14.396972708969047, 9.383044382064973],
            [-14.4079371235222, 9.339449969724699],
            [-14.365245117907602, 9.330523127339829],
            [-14.366164854706184, 9.326891729408235],
            [-14.414569057310622, 9.122246839130785],
            [-14.408275030211984, 9.120799028809257],
            [-14.435905567152039, 9.003222220380689],
            [-14.51322935172644, 9.021923543458026],
            [-14.601120678673317, 9.042681849882696],
            [-14.689017573042511, 9.06341646246679],
            [-14.702062110386306, 9.06651501288797],
            [-14.698308723719283, 9.077901889572434],
            [-14.69512530219351, 9.084083073712696],
            [-14.693735210256264, 9.090944637551752],
            [-14.689502689064978, 9.104763546522571],
            [-14.685199823929787, 9.126173764357542],
            [-14.68317469137777, 9.132873694175641],
            [-14.669936729124904, 9.1874509485065],
            [-14.650991237040177, 9.26413693173216],
            [-14.735368272869033, 9.284166605139132],
            [-14.72576326701025, 9.324577224220567],
            [-14.714914676657527, 9.367827990991628],
            [-14.761201254739023, 9.37872698250866],
            [-14.799722660611284, 9.38732068402214],
            [-14.772794983808097, 9.498222383515227],
            [-14.762730426502094, 9.5403312506556],
            [-14.758947075186065, 9.554269667923023],
            [-14.739042810041003, 9.64067653993922],
            [-14.729074445679368, 9.639007348738868],
            [-14.721880341926285, 9.670601807949454]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.90777705518322,
          "lat": 46.29752469553217
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53013"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01513273"
      },
      "bbox": [
        -14.799722660611284, 9.003222220380689, -14.365245117907602,
        9.670601807949454
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.520943726869529, 9.950384138151028],
            [-15.465094861866772, 9.935476371057966],
            [-15.450837038290244, 9.99216829027093],
            [-15.366910804419875, 9.972084897691813],
            [-15.321975175833371, 9.960804054197787],
            [-15.258167000800446, 9.94491886397306],
            [-15.194048240893034, 9.928052304676871],
            [-15.136882652520994, 9.91373501994945],
            [-15.072675265013764, 9.898135161148845],
            [-15.008471096102186, 9.882521839549522],
            [-14.971851676109901, 9.87384821576506],
            [-14.90225118543036, 9.857892342594816],
            [-14.839094572449222, 9.842949116866333],
            [-14.775940951782943, 9.827992913282369],
            [-14.762639407773252, 9.825577686201445],
            [-14.675977576126902, 9.806695838727471],
            [-14.683153491889005, 9.806292468411758],
            [-14.687874233848135, 9.807200626562896],
            [-14.692685790548238, 9.805604433198466],
            [-14.696302921256697, 9.810643104346225],
            [-14.703493666111743, 9.806844289234773],
            [-14.702245583485476, 9.80269869618769],
            [-14.701263669705044, 9.792390235397088],
            [-14.695789519700169, 9.761652831663278],
            [-14.694619615435178, 9.75082505315886],
            [-14.699982882119889, 9.746696963305263],
            [-14.702678775713197, 9.736815906476792],
            [-14.704954847154726, 9.736455733304116],
            [-14.708716834420855, 9.73120842698042],
            [-14.707315426392855, 9.7276119929279],
            [-14.707466985513017, 9.72095820927741],
            [-14.704782297242069, 9.714329069715227],
            [-14.70203197440101, 9.711718588073015],
            [-14.704503774681825, 9.706860004234509],
            [-14.695427883728897, 9.695524312878982],
            [-14.697636789337828, 9.682265821164126],
            [-14.70445081897712, 9.68302997896299],
            [-14.705228875801172, 9.678454697399248],
            [-14.708414870960711, 9.674908867596681],
            [-14.709201089583809, 9.670928120788957],
            [-14.714203039029876, 9.6643166150347],
            [-14.719626142510185, 9.667708884474948],
            [-14.721880341926285, 9.670601807949454],
            [-14.730653508004071, 9.680107090517874],
            [-14.735127884731709, 9.681593137684034],
            [-14.73995033452004, 9.681189689398474],
            [-14.75210454348863, 9.678166046282016],
            [-14.755436506163619, 9.678368432179717],
            [-14.760768587836854, 9.68133304133524],
            [-14.772883332816413, 9.695797158455454],
            [-14.781730326003062, 9.698274130327976],
            [-14.810036521865355, 9.6960684530116],
            [-14.824136287092978, 9.689160477465398],
            [-14.832863343103574, 9.68387285352929],
            [-14.838159999562503, 9.684967673047588],
            [-14.849656145297867, 9.689321827109028],
            [-14.85456234249303, 9.692185973036173],
            [-14.866851927300194, 9.703946787886814],
            [-14.871223523073096, 9.70950494904213],
            [-14.880704786602259, 9.713376306712831],
            [-14.887263842811407, 9.711462764563398],
            [-14.895244897729599, 9.70333774467404],
            [-14.905644967068547, 9.6960142627467],
            [-14.909098432940748, 9.69516170013752],
            [-14.918642081641677, 9.6950042276819],
            [-14.928585840393678, 9.69351804229929],
            [-14.930422339184636, 9.691846725454782],
            [-14.944754312175908, 9.685506940025046],
            [-14.947927236751696, 9.682698555960007],
            [-14.956894353114315, 9.671509130808284],
            [-14.961327315574893, 9.668260170291171],
            [-14.973422954674101, 9.667255754884636],
            [-14.981580493863074, 9.663887758271091],
            [-14.985775584146117, 9.65959894936515],
            [-15.002138256528202, 9.647245241459945],
            [-15.00726236022938, 9.638846671869546],
            [-15.009303580565188, 9.63278336212798],
            [-15.010093203457062, 9.622917377756394],
            [-15.011512807457963, 9.61895863464245],
            [-15.01711809590889, 9.611248287402248],
            [-15.024925963054, 9.601886517353188],
            [-15.02587802119192, 9.59566227365066],
            [-15.031877769168107, 9.587160151505321],
            [-15.0339273772153, 9.582893969639413],
            [-15.034018986751, 9.571336415481257],
            [-15.03566426755944, 9.563684998413025],
            [-15.038844736477628, 9.561059157577176],
            [-15.051966841685438, 9.559205506272809],
            [-15.056481241589934, 9.55701518183247],
            [-15.066088809564818, 9.544738895605802],
            [-15.06979846214894, 9.542738532599941],
            [-15.081950025999662, 9.5414560474303],
            [-15.085966176341538, 9.537249045790718],
            [-15.090137561569504, 9.525398049949825],
            [-15.096250664858484, 9.523116897529604],
            [-15.10658881877702, 9.527308923988395],
            [-15.12170644866708, 9.530394572533352],
            [-15.124032703878244, 9.529713916011888],
            [-15.135391391008051, 9.516059517870746],
            [-15.13822113328298, 9.510473181926221],
            [-15.140931029718407, 9.502272173212825],
            [-15.144700540568966, 9.49817064695786],
            [-15.152362738345746, 9.494545100382544],
            [-15.153913352452019, 9.489942400125173],
            [-15.151424011822614, 9.483871840318116],
            [-15.150995593280841, 9.479559871039282],
            [-15.153970627261439, 9.47191242915639],
            [-15.161390499663625, 9.468459982866861],
            [-15.165879934248322, 9.468783394789167],
            [-15.175709458992072, 9.472577367201739],
            [-15.181296976880509, 9.472970254586988],
            [-15.191916931459762, 9.471630477141995],
            [-15.198888885440013, 9.468871693865596],
            [-15.204377243205707, 9.461134341004929],
            [-15.21049762165019, 9.45937313140071],
            [-15.214898474571386, 9.45672836418562],
            [-15.217934035066847, 9.451369044705512],
            [-15.226448879087043, 9.445976035707874],
            [-15.231995316804092, 9.44537947338074],
            [-15.241977101209285, 9.447102979504015],
            [-15.264805682828667, 9.446683255551232],
            [-15.29032953417867, 9.44815936990372],
            [-15.305166984419628, 9.451133220153745],
            [-15.307908024786027, 9.450631968668384],
            [-15.319182405302442, 9.444972407552855],
            [-15.327416884131077, 9.443077570214095],
            [-15.331655179098492, 9.441003035128025],
            [-15.344523305197995, 9.438319163248577],
            [-15.352462952288722, 9.43088498841278],
            [-15.35823442219394, 9.422840911749429],
            [-15.362407211156913, 9.418393411849053],
            [-15.36457174717163, 9.42157870721457],
            [-15.373909070338561, 9.429416622934577],
            [-15.380845628460738, 9.436166525905636],
            [-15.390004117494579, 9.443664300431742],
            [-15.396727820532089, 9.451579162833593],
            [-15.403763798497364, 9.457805569394814],
            [-15.41148343873976, 9.462647557744885],
            [-15.426273695736878, 9.468714123308171],
            [-15.433357016004178, 9.470251895816402],
            [-15.442490177353013, 9.474394976562374],
            [-15.450775234092623, 9.480730045209238],
            [-15.461081589157223, 9.485833601070022],
            [-15.464980214813952, 9.49043597167309],
            [-15.47328807305521, 9.506742155894264],
            [-15.477345461785442, 9.515939275519205],
            [-15.482965290727758, 9.522672249188824],
            [-15.490938389921864, 9.527675991603235],
            [-15.493765527520418, 9.533072207039112],
            [-15.494027482707267, 9.536954151565526],
            [-15.490775426741614, 9.54602370236361],
            [-15.487949449239867, 9.550083715606892],
            [-15.481773937921872, 9.556105374116722],
            [-15.476795361641853, 9.562412593833807],
            [-15.473411009195527, 9.569399029330572],
            [-15.4708525429712, 9.589165128579822],
            [-15.470507349549973, 9.599762335835992],
            [-15.473347991165172, 9.60790669364851],
            [-15.472839704023144, 9.625564398071077],
            [-15.471945925632237, 9.62932775139118],
            [-15.467670357718397, 9.635368726718402],
            [-15.464596626760216, 9.645783792638998],
            [-15.463179313656747, 9.65662024787905],
            [-15.458077207950279, 9.666780647491215],
            [-15.450178513179742, 9.68629318647542],
            [-15.450316482177447, 9.692276622651503],
            [-15.448632122555201, 9.704146304170338],
            [-15.444677420480293, 9.714096684572851],
            [-15.443332979300282, 9.719680750811547],
            [-15.443076731204085, 9.72808313972213],
            [-15.437707955936267, 9.734514522562048],
            [-15.435945778044038, 9.744410034609587],
            [-15.436974731026321, 9.769736585275306],
            [-15.43927041395802, 9.774373978646057],
            [-15.455982938768582, 9.79269950332769],
            [-15.459791089962867, 9.807624383657851],
            [-15.4645873643647, 9.819009763349891],
            [-15.467577416551888, 9.823022481200866],
            [-15.476047682025268, 9.830195253472276],
            [-15.48439525668016, 9.839932167912941],
            [-15.487060707445616, 9.84421399303397],
            [-15.492158959895292, 9.856798801697643],
            [-15.501279674849618, 9.873739678694287],
            [-15.503937081110859, 9.88020495149633],
            [-15.504451367022561, 9.885998765632255],
            [-15.50256004512908, 9.89693565758075],
            [-15.49962244686529, 9.905810843431567],
            [-15.499151607710425, 9.912226287430789],
            [-15.500606264162538, 9.91840680824196],
            [-15.504084172209794, 9.923692686800873],
            [-15.512193942058872, 9.929259397664385],
            [-15.517740704924215, 9.934416313317815],
            [-15.524813762469629, 9.94303461462567],
            [-15.524216334089207, 9.948146594957613],
            [-15.520943726869529, 9.950384138151028]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.89894268719266,
          "lat": 46.53473794045082
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53021"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01531822"
      },
      "bbox": [
        -15.524813762469629, 9.418393411849053, -14.675977576126902,
        9.99216829027093
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.721880341926285, 9.670601807949454],
            [-14.729074445679368, 9.639007348738868],
            [-14.739042810041003, 9.64067653993922],
            [-14.758947075186065, 9.554269667923023],
            [-14.762730426502094, 9.5403312506556],
            [-14.772794983808097, 9.498222383515227],
            [-14.799722660611284, 9.38732068402214],
            [-14.761201254739023, 9.37872698250866],
            [-14.714914676657527, 9.367827990991628],
            [-14.72576326701025, 9.324577224220567],
            [-14.735368272869033, 9.284166605139132],
            [-14.650991237040177, 9.26413693173216],
            [-14.669936729124904, 9.1874509485065],
            [-14.68317469137777, 9.132873694175641],
            [-14.685199823929787, 9.126173764357542],
            [-14.689502689064978, 9.104763546522571],
            [-14.693735210256264, 9.090944637551752],
            [-14.69512530219351, 9.084083073712696],
            [-14.698308723719283, 9.077901889572434],
            [-14.702062110386306, 9.06651501288797],
            [-14.789677181044784, 9.086454725675388],
            [-14.803003514323171, 9.090000788841573],
            [-14.859181806164553, 9.102907119583296],
            [-14.896032488999872, 9.111957839340235],
            [-14.917392736009846, 9.116660389185371],
            [-15.040490006254123, 9.146024321818594],
            [-15.135537367157593, 9.169088340331472],
            [-15.237617944796753, 9.193450228011997],
            [-15.340730381661205, 9.218208223667991],
            [-15.371956948223605, 9.225008677915897],
            [-15.350069489409268, 9.23952026131073],
            [-15.334707130195413, 9.24354739868215],
            [-15.333682952528335, 9.246378888103346],
            [-15.333574219479164, 9.255093881241153],
            [-15.33437271269823, 9.260365354102731],
            [-15.332603018492618, 9.267860170408568],
            [-15.326984702578272, 9.277853381469804],
            [-15.323822728433475, 9.289045524035604],
            [-15.32463266911476, 9.297828339348067],
            [-15.328605810767467, 9.315084476795521],
            [-15.331236588916154, 9.335890837624927],
            [-15.328999442946515, 9.339384296690014],
            [-15.327715082590652, 9.347225883556193],
            [-15.332712815577404, 9.364388576793795],
            [-15.339056006981526, 9.37899691638821],
            [-15.346048017679834, 9.392667244042498],
            [-15.3479705658767, 9.398171398285744],
            [-15.354836223701362, 9.408876518948457],
            [-15.362407211156913, 9.418393411849053],
            [-15.35823442219394, 9.422840911749429],
            [-15.352462952288722, 9.43088498841278],
            [-15.344523305197995, 9.438319163248577],
            [-15.331655179098492, 9.441003035128025],
            [-15.327416884131077, 9.443077570214095],
            [-15.319182405302442, 9.444972407552855],
            [-15.307908024786027, 9.450631968668384],
            [-15.305166984419628, 9.451133220153745],
            [-15.29032953417867, 9.44815936990372],
            [-15.264805682828667, 9.446683255551232],
            [-15.241977101209285, 9.447102979504015],
            [-15.231995316804092, 9.44537947338074],
            [-15.226448879087043, 9.445976035707874],
            [-15.217934035066847, 9.451369044705512],
            [-15.214898474571386, 9.45672836418562],
            [-15.21049762165019, 9.45937313140071],
            [-15.204377243205707, 9.461134341004929],
            [-15.198888885440013, 9.468871693865596],
            [-15.191916931459762, 9.471630477141995],
            [-15.181296976880509, 9.472970254586988],
            [-15.175709458992072, 9.472577367201739],
            [-15.165879934248322, 9.468783394789167],
            [-15.161390499663625, 9.468459982866861],
            [-15.153970627261439, 9.47191242915639],
            [-15.150995593280841, 9.479559871039282],
            [-15.151424011822614, 9.483871840318116],
            [-15.153913352452019, 9.489942400125173],
            [-15.152362738345746, 9.494545100382544],
            [-15.144700540568966, 9.49817064695786],
            [-15.140931029718407, 9.502272173212825],
            [-15.13822113328298, 9.510473181926221],
            [-15.135391391008051, 9.516059517870746],
            [-15.124032703878244, 9.529713916011888],
            [-15.12170644866708, 9.530394572533352],
            [-15.10658881877702, 9.527308923988395],
            [-15.096250664858484, 9.523116897529604],
            [-15.090137561569504, 9.525398049949825],
            [-15.085966176341538, 9.537249045790718],
            [-15.081950025999662, 9.5414560474303],
            [-15.06979846214894, 9.542738532599941],
            [-15.066088809564818, 9.544738895605802],
            [-15.056481241589934, 9.55701518183247],
            [-15.051966841685438, 9.559205506272809],
            [-15.038844736477628, 9.561059157577176],
            [-15.03566426755944, 9.563684998413025],
            [-15.034018986751, 9.571336415481257],
            [-15.0339273772153, 9.582893969639413],
            [-15.031877769168107, 9.587160151505321],
            [-15.02587802119192, 9.59566227365066],
            [-15.024925963054, 9.601886517353188],
            [-15.01711809590889, 9.611248287402248],
            [-15.011512807457963, 9.61895863464245],
            [-15.010093203457062, 9.622917377756394],
            [-15.009303580565188, 9.63278336212798],
            [-15.00726236022938, 9.638846671869546],
            [-15.002138256528202, 9.647245241459945],
            [-14.985775584146117, 9.65959894936515],
            [-14.981580493863074, 9.663887758271091],
            [-14.973422954674101, 9.667255754884636],
            [-14.961327315574893, 9.668260170291171],
            [-14.956894353114315, 9.671509130808284],
            [-14.947927236751696, 9.682698555960007],
            [-14.944754312175908, 9.685506940025046],
            [-14.930422339184636, 9.691846725454782],
            [-14.928585840393678, 9.69351804229929],
            [-14.918642081641677, 9.6950042276819],
            [-14.909098432940748, 9.69516170013752],
            [-14.905644967068547, 9.6960142627467],
            [-14.895244897729599, 9.70333774467404],
            [-14.887263842811407, 9.711462764563398],
            [-14.880704786602259, 9.713376306712831],
            [-14.871223523073096, 9.70950494904213],
            [-14.866851927300194, 9.703946787886814],
            [-14.85456234249303, 9.692185973036173],
            [-14.849656145297867, 9.689321827109028],
            [-14.838159999562503, 9.684967673047588],
            [-14.832863343103574, 9.68387285352929],
            [-14.824136287092978, 9.689160477465398],
            [-14.810036521865355, 9.6960684530116],
            [-14.781730326003062, 9.698274130327976],
            [-14.772883332816413, 9.695797158455454],
            [-14.760768587836854, 9.68133304133524],
            [-14.755436506163619, 9.678368432179717],
            [-14.75210454348863, 9.678166046282016],
            [-14.73995033452004, 9.681189689398474],
            [-14.735127884731709, 9.681593137684034],
            [-14.730653508004071, 9.680107090517874],
            [-14.721880341926285, 9.670601807949454]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.4784680576458,
          "lat": 46.229753410056496
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53071"],
        "coty_name": ["Walla Walla"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walla Walla County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01531819"
      },
      "bbox": [
        -15.371956948223605, 9.06651501288797, -14.650991237040177,
        9.713376306712831
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.10144709249488, 2.220044744401493],
            [14.11268274626612, 2.2062589645783346],
            [14.12012251927845, 2.203991409063868],
            [14.133456307791935, 2.2054494691377284],
            [14.139488755592815, 2.2069389645898267],
            [14.143370801287892, 2.2131753323869963],
            [14.148723410128303, 2.2179112845357793],
            [14.156656409369747, 2.217027004496492],
            [14.15824445358816, 2.2148526106652797],
            [14.159368578438766, 2.2035289986898157],
            [14.162024071119895, 2.19828823706706],
            [14.165201253673711, 2.19654032241401],
            [14.170105309954756, 2.1998708221186396],
            [14.17070866538819, 2.207555802722058],
            [14.168811713576774, 2.221127258505032],
            [14.165770359896488, 2.2251687693805455],
            [14.161056868457024, 2.226355146214987],
            [14.161904936882856, 2.2308041942812946],
            [14.168920506559871, 2.2310085370371335],
            [14.172729868957, 2.2278708484101255],
            [14.178534916742516, 2.219685634041963],
            [14.184086304688144, 2.2186625001185387],
            [14.206068992643628, 2.2172745907052986],
            [14.210540868509318, 2.220906161989832],
            [14.208912168048444, 2.228884976423268],
            [14.20415024547359, 2.233325903093267],
            [14.205057639292404, 2.236013397383068],
            [14.213138923253457, 2.2360495021106828],
            [14.218268108419023, 2.233798153871069],
            [14.230460976958772, 2.232021373172957],
            [14.238416297178366, 2.2337000652997907],
            [14.24221271365306, 2.233272965889115],
            [14.247817860072368, 2.2291994642044766],
            [14.251290234076212, 2.2195409946649183],
            [14.252417570327538, 2.209616912287034],
            [14.252535684166508, 2.1991996291770763],
            [14.251092518230765, 2.1941474283886957],
            [14.247101109550131, 2.1912831556181547],
            [14.236796080241326, 2.1895738175035624],
            [14.229585186007744, 2.1870927013608235],
            [14.220059260767417, 2.1851993032866535],
            [14.21374365307937, 2.1795693494056025],
            [14.213631924497257, 2.176211210116459],
            [14.216279065489347, 2.1726092793921654],
            [14.228926385533866, 2.1671700839419095],
            [14.234690006149147, 2.1622241435086966],
            [14.23615022354882, 2.1588404083485266],
            [14.236713398319498, 2.1485871746360177],
            [14.238070532884754, 2.1415897410754416],
            [14.243164158316683, 2.1391456908626942],
            [14.250047124437833, 2.141582504372644],
            [14.256082535188227, 2.145899769456021],
            [14.256560996462905, 2.148530996285264],
            [14.255064837024468, 2.156723102597213],
            [14.259678255781566, 2.1611410743523365],
            [14.266455478761952, 2.1589061865131134],
            [14.268785828119078, 2.1541170606126325],
            [14.268591984727266, 2.146700411198926],
            [14.26651849861631, 2.1437615290697303],
            [14.256113864502774, 2.1329346161852376],
            [14.25470965664535, 2.1301008862357445],
            [14.257074456679193, 2.125705274318894],
            [14.26814410654621, 2.1238545345614286],
            [14.273048666443476, 2.124303617588658],
            [14.272079668230193, 2.1162510199665356],
            [14.270403098558898, 2.112209340195198],
            [14.27094314090439, 2.108913841245719],
            [14.268486538497207, 2.099819289151382],
            [14.26622641835811, 2.086612861494211],
            [14.265368748041286, 2.0755321394566133],
            [14.259659533835304, 2.066715975423259],
            [14.258893092432615, 2.063071462131089],
            [14.242983305856036, 2.0390557111671455],
            [14.215529572745151, 1.9970181163864373],
            [14.210936165839263, 1.9945033717032679],
            [14.20627322563393, 1.994986837043253],
            [14.203639472091421, 1.9906578849864962],
            [14.20735529967371, 1.9867251065110312],
            [14.201651874768936, 1.9850878332501163],
            [14.19769185227466, 1.9791760770108497],
            [14.19182586503172, 1.9784752233444955],
            [14.196091727144289, 1.9707855973059216],
            [14.191798399171084, 1.9677413919383575],
            [14.195168328297969, 1.9634969609336574],
            [14.195008704940026, 1.9564936246981706],
            [14.189883600007484, 1.9595527664245231],
            [14.185840196891332, 1.959361645650728],
            [14.183107550933068, 1.9563411423771768],
            [14.188026368548758, 1.9532214211196828],
            [14.184285605736632, 1.941740531439458],
            [14.181822498678674, 1.9399204298330937],
            [14.183091299564902, 1.933610270319573],
            [14.178119105912403, 1.9346790381468322],
            [14.1783873148481, 1.9309426731974166],
            [14.182029321773397, 1.9306020537480748],
            [14.183898597880825, 1.9278711548606844],
            [14.179485370171987, 1.9199150701876053],
            [14.173239764197143, 1.9125145602625695],
            [14.169794019146941, 1.9020715753410622],
            [14.166564515473063, 1.8975937793085869],
            [14.165818274309347, 1.8917390939832692],
            [14.160668297338455, 1.8912078743936134],
            [14.16278012258789, 1.8879248490410006],
            [14.16301345670066, 1.8832171412387981],
            [14.157732636666628, 1.8819760058306048],
            [14.15751683075841, 1.8778871782271536],
            [14.164584416741864, 1.8756905291429702],
            [14.163663168385733, 1.8725956873762155],
            [14.159812580420363, 1.8701477665321324],
            [14.160700539844694, 1.8667669667174551],
            [14.094743961451103, 1.9033221643890954],
            [14.066506735385198, 1.9198122415621],
            [14.051687123665621, 1.9269048724063704],
            [14.025854135679207, 1.943156608035218],
            [14.010199027557356, 1.9515996967271614],
            [13.989592239760087, 1.9642676209418606],
            [13.989991227311462, 1.9682140895204936],
            [13.992777465877774, 1.9774493092811127],
            [13.995207556128946, 1.9918232003527683],
            [13.99672020249154, 1.9970308999938633],
            [13.997987244814027, 2.007201906761487],
            [14.001593336307437, 2.018238918526387],
            [14.00195857448315, 2.025620938966429],
            [14.001660857695818, 2.0400792492527877],
            [14.00273578128421, 2.04939355571952],
            [14.002570428562814, 2.0579769027778374],
            [14.004803285462344, 2.0789263351838496],
            [14.007285063743742, 2.0934554313251166],
            [14.006222965727348, 2.097188562661634],
            [14.006884552434776, 2.1043740409914866],
            [14.01179801660586, 2.1282810421927847],
            [14.011657738966889, 2.1348482263463917],
            [14.013120631089249, 2.1458339166447065],
            [14.01525811568404, 2.153737123504627],
            [14.01726508783815, 2.1693326655687346],
            [14.01895683232708, 2.177819791751284],
            [14.036121256373029, 2.1811843360147285],
            [14.04224050825218, 2.175884222999237],
            [14.054252628292357, 2.1726330383256296],
            [14.055701392101266, 2.173590887577423],
            [14.057232281228442, 2.185431522525406],
            [14.058392950424071, 2.1887640762048197],
            [14.062065208076682, 2.1921082923661848],
            [14.072835056273108, 2.1937744862847026],
            [14.077577737272938, 2.1936825728025253],
            [14.085551964016737, 2.205157038918387],
            [14.087572597839124, 2.2107720997773863],
            [14.089935920147116, 2.2107215579367607],
            [14.092267169796209, 2.2147110192847888],
            [14.091649850242913, 2.2190395560757694],
            [14.098879046625196, 2.2209938404244225],
            [14.10144709249488, 2.220044744401493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.02754188686032,
          "lat": 39.464105120859465
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54003"],
        "coty_name": ["Berkeley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Berkeley County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01550008"
      },
      "bbox": [
        13.989592239760087, 1.8667669667174551, 14.273048666443476,
        2.2360495021106828
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.017894220382312, 0.9311371130184767],
            [12.052639976484373, 0.9661213246444157],
            [12.108395874421328, 1.0216332037825218],
            [12.148993312862254, 1.0642822283899784],
            [12.20804668758809, 1.1264919751549598],
            [12.214587271704984, 1.1288068927843375],
            [12.218883255808505, 1.1338238435471024],
            [12.229878661028344, 1.1440799232050807],
            [12.233255670318977, 1.1344835134046376],
            [12.23604995195963, 1.1335175695818687],
            [12.239424026568114, 1.1355681874236243],
            [12.238850205313971, 1.14077993958311],
            [12.24353551720525, 1.1430494019910573],
            [12.248297243395186, 1.1404017570739708],
            [12.253153461071706, 1.1397304920168925],
            [12.252899592564079, 1.144808286115126],
            [12.257319536616167, 1.1482853599374747],
            [12.25854644779192, 1.153676257976137],
            [12.265114568674727, 1.154629135483488],
            [12.266330331689986, 1.1600501527531086],
            [12.273539894311781, 1.1615913700616185],
            [12.276798959645811, 1.1633828527286105],
            [12.28478527949615, 1.156333132399795],
            [12.283822816612982, 1.1520924789835145],
            [12.286890432608029, 1.1478497654723883],
            [12.291401623931366, 1.1448128716843544],
            [12.291794171395466, 1.1314044235679248],
            [12.298045779949922, 1.125254159503169],
            [12.301093237622535, 1.121067712930837],
            [12.3036025033764, 1.120867607755146],
            [12.306801019488475, 1.125101305475915],
            [12.312944921826809, 1.1297940424557544],
            [12.318797428487992, 1.1327139127867858],
            [12.32236413323302, 1.1318591927818062],
            [12.324770459650564, 1.1267214208412806],
            [12.33204148500861, 1.1209216861923417],
            [12.341359833651403, 1.1252754210175162],
            [12.342547314248716, 1.130926161658069],
            [12.345787741440107, 1.13239440145472],
            [12.351049890829294, 1.130439423042193],
            [12.354438385221755, 1.1276560524956398],
            [12.361698947739383, 1.1243431810036661],
            [12.366476056558016, 1.1172113561220478],
            [12.373892580902066, 1.1190436164065234],
            [12.380096506524394, 1.111807595322742],
            [12.384695080845294, 1.1082177932807484],
            [12.388833438045145, 1.1091963650007057],
            [12.38954376643743, 1.1050868543610861],
            [12.388194614556506, 1.1014738657705259],
            [12.388529354110876, 1.0964778020365007],
            [12.386123427257708, 1.0933813901248712],
            [12.38768347246207, 1.0899417965971625],
            [12.384968200267666, 1.0845149663229379],
            [12.386231659949832, 1.0783509741095625],
            [12.385316008996348, 1.074930245313956],
            [12.388525381142037, 1.0723771096925923],
            [12.39468041070839, 1.0703032912080364],
            [12.398203647226666, 1.0742430242816963],
            [12.40311388215397, 1.07333882104639],
            [12.406675882629827, 1.069460137626837],
            [12.408016805089845, 1.065568126487814],
            [12.404658801635868, 1.061194719594109],
            [12.41168025805483, 1.0534736499555633],
            [12.419054996119868, 1.0571751490976076],
            [12.423063396581611, 1.0518020590209924],
            [12.419268192879628, 1.0498329530778616],
            [12.418899293095908, 1.0451757614314607],
            [12.416534742812466, 1.0393072029844315],
            [12.418735632942347, 1.03579959858673],
            [12.419910546006726, 1.0282896778756418],
            [12.416838734776013, 1.0175741119869999],
            [12.39305860401671, 0.9178695297489537],
            [12.343833338935974, 0.8427608436427996],
            [12.303881806925551, 0.7815650682499654],
            [12.2978474800504, 0.7793936326617333],
            [12.289849494677185, 0.780026327720732],
            [12.284504888544664, 0.7820631330926561],
            [12.282295142509055, 0.7846805459111524],
            [12.2742017903157, 0.7819911613015378],
            [12.271750936089274, 0.7845737396567241],
            [12.264882942572902, 0.7822645384171946],
            [12.257101805101527, 0.7817892007346046],
            [12.255735525468362, 0.7844101132237747],
            [12.25208428627104, 0.7836490412181983],
            [12.250690366161805, 0.778719814122397],
            [12.246432951460184, 0.7820248446700239],
            [12.244501151665256, 0.7777194963674556],
            [12.241425223526784, 0.7794211821294416],
            [12.23704423017647, 0.7768662346964651],
            [12.23684472733285, 0.7679137360932452],
            [12.233181750411141, 0.7705456071904403],
            [12.227527826959292, 0.7682087247671969],
            [12.22554958698119, 0.775180276245056],
            [12.220812557703802, 0.7764237514399924],
            [12.218017642262783, 0.7792262799877098],
            [12.217731183506864, 0.7828456576453067],
            [12.213734578539526, 0.7851870090297255],
            [12.209393310439664, 0.7845609837904903],
            [12.202714383724548, 0.7882060764193473],
            [12.200501111013315, 0.7951030296510662],
            [12.19602632837773, 0.7957795770046814],
            [12.130759103212505, 0.7335880176954811],
            [12.12933231817996, 0.7391644620485874],
            [12.125943995196694, 0.7426357346119429],
            [12.122031610685283, 0.7493965942905685],
            [12.121651907650508, 0.7559283110110832],
            [12.120184939010628, 0.759351905422681],
            [12.116533280454881, 0.762701401845346],
            [12.103629748287695, 0.7661264488631483],
            [12.100450079429253, 0.7648106378737678],
            [12.097080743009892, 0.7665761815603365],
            [12.099947451043825, 0.7699737390979692],
            [12.097095871586358, 0.7781638327071183],
            [12.097503097446328, 0.7855697313021264],
            [12.086972009735275, 0.7927417288740785],
            [12.084711738838966, 0.8001369213266348],
            [12.081021737722288, 0.8035223294329319],
            [12.073401284028563, 0.803960772868717],
            [12.068045785977914, 0.8064906493981634],
            [12.066881897319716, 0.8096891058479614],
            [12.059475094203338, 0.8108439217988159],
            [12.057884132764313, 0.8142063769361259],
            [12.054674971959718, 0.8128773913450812],
            [12.0517691544641, 0.8091206362647039],
            [12.048882709357905, 0.8088382333649162],
            [12.04594767167601, 0.8158308222752771],
            [12.045515605457505, 0.82597579256709],
            [12.040234667138913, 0.8254652457785014],
            [12.037928064882438, 0.8349269395758887],
            [12.037683371251617, 0.8407482751808706],
            [11.99016345424807, 0.8755514163243406],
            [12.017894220382312, 0.9311371130184767]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.71924270185396, "lat": 38.69983259477515 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54007"],
        "coty_name": ["Braxton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Braxton County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01550010"
      },
      "bbox": [
        11.99016345424807, 0.7335880176954811, 12.423063396581611,
        1.1633828527286105
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.074396527561705, 1.6074438532779558],
            [13.082978157334766, 1.60666198482744],
            [13.087697440608444, 1.6074968132717238],
            [13.087555978804598, 1.6111258154286725],
            [13.092949899199407, 1.6163164429360688],
            [13.098081441033479, 1.6159477827740532],
            [13.100501195279508, 1.6202956087170448],
            [13.108013347978199, 1.6247370736890796],
            [13.11222693821445, 1.632652422394013],
            [13.114963500938835, 1.6327663264868348],
            [13.117721298592155, 1.6378169669462448],
            [13.116267083012534, 1.6432120424384369],
            [13.119378521891424, 1.645846351798862],
            [13.11891509410838, 1.6490007018635118],
            [13.12489319280947, 1.6517612287941328],
            [13.129710876003134, 1.6628648550884495],
            [13.133058325489168, 1.6659063722949359],
            [13.135657671381587, 1.6754624488128598],
            [13.139496470758868, 1.6779086229546558],
            [13.13852479065583, 1.6817468726528646],
            [13.143082227738693, 1.6819396929061066],
            [13.144514043699468, 1.6872680700002127],
            [13.148818619129349, 1.6902900460661345],
            [13.157156873795891, 1.6926849733726026],
            [13.162342170620397, 1.6967941001248572],
            [13.163163690125387, 1.704322948482358],
            [13.166932064257887, 1.7042487859032167],
            [13.168383474556332, 1.7071977657655033],
            [13.165205429778279, 1.71015548360709],
            [13.166716684257494, 1.7134470496623762],
            [13.169904214351066, 1.7143289342548824],
            [13.17087020789415, 1.717497459353018],
            [13.174623099413099, 1.7213901121271933],
            [13.179048828261342, 1.723360813797291],
            [13.18260243490296, 1.7227822552797183],
            [13.187129255337588, 1.728178955886261],
            [13.197382211841843, 1.7250505886331058],
            [13.206536347039066, 1.7264387009090445],
            [13.205852569308263, 1.7306145800733714],
            [13.20962940024667, 1.7375616765453465],
            [13.20835607955622, 1.7426043733744334],
            [13.20853301189414, 1.751108398352716],
            [13.21534597883968, 1.7577249628134806],
            [13.220553439696339, 1.757015476578444],
            [13.242669412886556, 1.7561121338554506],
            [13.306283346562592, 1.7602688911534674],
            [13.321741464422127, 1.7604999001724493],
            [13.348181193848697, 1.7497491273000654],
            [13.451781872381337, 1.7071456504995917],
            [13.449036628834396, 1.701513253533857],
            [13.44524663998924, 1.68679791477665],
            [13.445936197974754, 1.6844870059394101],
            [13.443135315318518, 1.6793289856236668],
            [13.44446859765851, 1.6772359310328746],
            [13.441390048331908, 1.6656615133375983],
            [13.443054501348044, 1.6620653434337842],
            [13.440146013515692, 1.6574378062454131],
            [13.437895128109442, 1.6504690261836708],
            [13.438433642100142, 1.647489769745968],
            [13.435692901472494, 1.6406367269087963],
            [13.432243084736536, 1.634681373659908],
            [13.428234259452331, 1.6175501085138164],
            [13.425074034214191, 1.6124648885818393],
            [13.426073442192966, 1.6086313518628008],
            [13.432052913278087, 1.6049638895110285],
            [13.431119557960493, 1.600992925843813],
            [13.427827935540094, 1.5967299853946368],
            [13.426543760323804, 1.5924507718464211],
            [13.427511954354504, 1.5852201869016145],
            [13.429838779871154, 1.581845363030085],
            [13.426003428142577, 1.573667669463874],
            [13.42225328923831, 1.5684806310191852],
            [13.419838368194473, 1.5628155133907893],
            [13.422445806106055, 1.5591832599051],
            [13.418747633304713, 1.5498003507700209],
            [13.413742704072128, 1.5459252625002606],
            [13.415087293808753, 1.5406296734827332],
            [13.41389482010798, 1.534672270127315],
            [13.410665380478525, 1.5309131034798718],
            [13.407402903321929, 1.5295057604794495],
            [13.412203567109158, 1.522370685271029],
            [13.41081440006064, 1.5150346058720436],
            [13.408914936762839, 1.512510683416442],
            [13.408450922196481, 1.5063132722823591],
            [13.406658184016193, 1.5028118780515365],
            [13.404547300169313, 1.4941259513679839],
            [13.416374183930014, 1.4792304631099498],
            [13.413797949579777, 1.4731267518317972],
            [13.414527566337572, 1.466899768815268],
            [13.416939677544153, 1.4643595736142279],
            [13.41597464030838, 1.4605966768736387],
            [13.417387766530556, 1.4572768648828818],
            [13.457230217719163, 1.3910038536211569],
            [13.456277818529975, 1.3867296013845665],
            [13.451116929282923, 1.3780058744861334],
            [13.441023483265202, 1.3575222782048126],
            [13.437713210306418, 1.3562549371442936],
            [13.433354348061894, 1.351835207079614],
            [13.436806684926022, 1.3417897301356574],
            [13.436311262539595, 1.3380084321034715],
            [13.440141908014619, 1.3350051449926208],
            [13.439933638369748, 1.3278908839532773],
            [13.43322467932165, 1.316838747536044],
            [13.42988834494444, 1.3061892995385225],
            [13.423571937676718, 1.291619550659977],
            [13.4234687373733, 1.2891396021023604],
            [13.415990110415828, 1.278757953384426],
            [13.416361148370418, 1.2768348997159031],
            [13.410823391783374, 1.2646445236290318],
            [13.338770190649118, 1.3085802071057782],
            [13.28304859440354, 1.3410968511182404],
            [13.246231903482418, 1.3629272288706036],
            [13.2216756727219, 1.3787716756802335],
            [13.221038735998475, 1.3806065861962984],
            [13.214529766281428, 1.384682886501788],
            [13.224925944384802, 1.3900075747692113],
            [13.226423452245399, 1.3917077746081739],
            [13.227915164090922, 1.399182238099643],
            [13.231966574033398, 1.4063239568235202],
            [13.230939639580924, 1.4195571642931726],
            [13.232764647855486, 1.4234877669859116],
            [13.236676590317744, 1.4268319670930705],
            [13.23437597941295, 1.437034726048208],
            [13.239309374080921, 1.4450952433389395],
            [13.238885825741976, 1.4564292632351226],
            [13.232259647465323, 1.461062274810025],
            [13.23416051644838, 1.467557882792029],
            [13.238183648397973, 1.4675651551624953],
            [13.240788234272308, 1.4738547884624904],
            [13.239907136993114, 1.477123221803469],
            [13.240370184316937, 1.4873566683351074],
            [13.239098096345131, 1.4894178505643714],
            [13.240784149929905, 1.4962139507987655],
            [13.240461858031564, 1.5007018883515622],
            [13.234725031040215, 1.5033053459648207],
            [13.232430136247375, 1.5026706515470396],
            [13.228460451064016, 1.4955385774484538],
            [13.220098674344996, 1.4967234605251478],
            [13.21735221978379, 1.4981546152773482],
            [13.211594659910837, 1.505266038098011],
            [13.203480819049412, 1.5049077470566443],
            [13.195028301287795, 1.506221590096861],
            [13.198963100093238, 1.514392699669775],
            [13.19705422859226, 1.5193447055971083],
            [13.198693163561781, 1.5216036507983406],
            [13.197685417310243, 1.528528206059398],
            [13.207332091965458, 1.5415978143311273],
            [13.20349851390459, 1.545962656854354],
            [13.202331565300414, 1.54928901063718],
            [13.207906406473848, 1.5543762999247601],
            [13.208255546494838, 1.5581280194888432],
            [13.203801595601803, 1.5625662111356375],
            [13.201880483167958, 1.5703229702482735],
            [13.204240190713557, 1.5794529960583166],
            [13.206254899340333, 1.5821673716522517],
            [13.206268630855186, 1.5878069950893972],
            [13.21239229395551, 1.593299879764179],
            [13.21311403449293, 1.5984481037484066],
            [13.210891266055157, 1.6017447673268341],
            [13.213644969132767, 1.6077668545306159],
            [13.22022788629958, 1.6124207650275355],
            [13.222731375818148, 1.6198349417641684],
            [13.21949873584652, 1.6253083695104154],
            [13.211138319568773, 1.6337646870682168],
            [13.207039943358453, 1.636213957083851],
            [13.200592132278707, 1.6347652677241695],
            [13.19715353657177, 1.6312871218596323],
            [13.194915303475623, 1.6346826296841188],
            [13.189021484578037, 1.636713215058235],
            [13.180204201719627, 1.634127309952772],
            [13.178831623068518, 1.6269143766938017],
            [13.171544533378452, 1.626241289136895],
            [13.171643371771784, 1.622159413874259],
            [13.167620035677073, 1.6171437901312704],
            [13.161631279541478, 1.620594645860312],
            [13.157012965062163, 1.6207011207406106],
            [13.153787310024441, 1.619106671254898],
            [13.154001125004863, 1.615250195985777],
            [13.150285042574973, 1.6151065436687257],
            [13.14715418464143, 1.6107622691057133],
            [13.147745349938532, 1.6069734303445486],
            [13.142153572923407, 1.6033225039404375],
            [13.13829122940098, 1.6035636736621366],
            [13.13222689747132, 1.5999327806736354],
            [13.128381037780962, 1.6014070867010233],
            [13.123972938922128, 1.600323188089856],
            [13.121520354785584, 1.596099809735734],
            [13.11661457067767, 1.6000523605525938],
            [13.11044988925358, 1.5987626286715098],
            [13.111324837458335, 1.5937930585644957],
            [13.109237667950405, 1.5914789814335233],
            [13.105313452992037, 1.5911997603207295],
            [13.09640693099121, 1.586866626113145],
            [13.093806009956378, 1.583028307207593],
            [13.089826721697621, 1.5843787406941254],
            [13.086463916194816, 1.5879893364071824],
            [13.07898833822966, 1.5914930110878494],
            [13.076097566062748, 1.596415253956121],
            [13.074396527561705, 1.6074438532779558]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.19555319698145,
          "lat": 39.105102044355085
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54023"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01697238"
      },
      "bbox": [
        13.074396527561705, 1.2646445236290318, 13.457230217719163,
        1.7604999001724493
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.320982487747278, -0.3391291247697078],
            [12.32135260942381, -0.3382879946063423],
            [12.341674258796186, -0.27251838420209057],
            [12.354765752988214, -0.23200953503199587],
            [12.380935136085593, -0.16652267868529705],
            [12.396262558165173, -0.12145493093325793],
            [12.415165166394388, -0.06939170052339463],
            [12.42295187794768, -0.046794128582120516],
            [12.428264487085121, -0.02895306457742821],
            [12.423240963081067, -0.012241849954696269],
            [12.430549158271413, -0.015530082890390299],
            [12.436243123911177, -0.015535572944219611],
            [12.44439683408453, -0.01695876049405184],
            [12.451798826513821, -0.017205359136202338],
            [12.45590306464578, -0.0202947746022903],
            [12.461207048774186, -0.022013518171141038],
            [12.463407027897405, -0.020544114313104263],
            [12.476492835008022, -0.022569409200920525],
            [12.550963937149213, -0.032823522294739026],
            [12.551126263295474, -0.029590553448312837],
            [12.557061414071033, -0.02848922974139105],
            [12.558877440381858, -0.03138337492898521],
            [12.56200289935661, -0.02801870793998346],
            [12.571505333764808, -0.028107531015123935],
            [12.5751883124362, -0.022929925073886304],
            [12.57662905988469, -0.02630827688540652],
            [12.58416641069778, -0.02520873845324121],
            [12.587159774860758, -0.02780377682524053],
            [12.586115505388008, -0.031102734554184296],
            [12.595497676282793, -0.03295655544250963],
            [12.596355925277168, -0.0301732523632946],
            [12.606099976223582, -0.02259988680916011],
            [12.611652876542319, -0.01654397628040018],
            [12.615156519090712, -0.010966685859355622],
            [12.619583866685373, -0.01221894821519599],
            [12.622616657051465, -0.004698578111856534],
            [12.625697967318082, -0.00402782308892146],
            [12.630257089743054, 0.003911588930213093],
            [12.635464960188925, 0.0061900042794595005],
            [12.634801016035475, 0.0009958213131881291],
            [12.636297796069496, -0.0011984492474117112],
            [12.63507686860711, -0.005610761233684704],
            [12.636773482104307, -0.007366590773723616],
            [12.642110361587386, -0.0009894398243701918],
            [12.646430399489676, -0.00796145854202181],
            [12.644558403736532, -0.015717553070340035],
            [12.651491283551035, -0.021479311423649918],
            [12.654067668571349, -0.021236183131670076],
            [12.655623079254449, -0.015457710211867697],
            [12.66332128363359, -0.015812603368745286],
            [12.665408266845663, -0.010270005757082154],
            [12.667221050973803, 0.003522898181220162],
            [12.6777859738073, 0.0016048904786023874],
            [12.67722272758654, -0.0009118168665041593],
            [12.672553668642022, -0.006252496003699789],
            [12.6732319174104, -0.009741045916007116],
            [12.68328224242322, -0.014613525212890582],
            [12.696133286639144, -0.013573514544289516],
            [12.703438356104174, -0.01093084913418374],
            [12.713640416555066, -0.0052429470165962395],
            [12.732369908280209, -0.037649273920477254],
            [12.743410217433992, -0.0470356567555255],
            [12.766599779354944, -0.05179517596647308],
            [12.782409437827539, -0.0592891382863158],
            [12.779802221890955, -0.06761804600717312],
            [12.770957526630093, -0.08250951837899488],
            [12.764407472248905, -0.08856485044896484],
            [12.7584372297625, -0.0963387610239439],
            [12.750320512519508, -0.10214853599822084],
            [12.7418992050227, -0.10935738747049675],
            [12.733383210868325, -0.11764857177040691],
            [12.709750656278919, -0.1363831412353571],
            [12.72522479195639, -0.15231135853551367],
            [12.723972352823964, -0.15468921209277736],
            [12.714563438252041, -0.16045071423818422],
            [12.71300758079983, -0.16457707408664138],
            [12.730714173563149, -0.17070211932127402],
            [12.742911618706806, -0.1593282568080656],
            [12.750579975593693, -0.16110780981837125],
            [12.741291020469967, -0.18850277744614158],
            [12.734791759656995, -0.19510480071461997],
            [12.726701250335687, -0.20054702850409323],
            [12.718708738281869, -0.2071347690616363],
            [12.709865087074018, -0.21023918677319156],
            [12.693201316781863, -0.2204478996200424],
            [12.696851528416772, -0.2248351147138369],
            [12.691023706150546, -0.23187439280857033],
            [12.683429825058266, -0.23692329564673667],
            [12.671309362171197, -0.24717459151021481],
            [12.66936113652229, -0.24953612316439194],
            [12.653368788260709, -0.2628739943826564],
            [12.641829661777228, -0.2768066908849599],
            [12.636030022338838, -0.2819471278656866],
            [12.631708070039771, -0.28447393462838194],
            [12.626889605830694, -0.2915352258642365],
            [12.621088134612792, -0.2949110761996514],
            [12.619048571296066, -0.2960977141500755],
            [12.602109908752688, -0.28648315101098715],
            [12.598645573652622, -0.2771174906880326],
            [12.599853350136431, -0.263645613579678],
            [12.58165379850359, -0.24215795795456227],
            [12.578319748106907, -0.24597869714615925],
            [12.573059042734414, -0.2484487807819191],
            [12.566128153546595, -0.24936301174450096],
            [12.563134813387201, -0.25304303706024966],
            [12.556859145703765, -0.25336988078640055],
            [12.551460085758281, -0.2554137827144456],
            [12.54478355580232, -0.26038438465160235],
            [12.541540279241081, -0.2641902026844851],
            [12.527986333621191, -0.27656069260864935],
            [12.524552969036943, -0.2824573172832709],
            [12.518562381918573, -0.2888259567278374],
            [12.506778480426023, -0.2976369901893517],
            [12.50321902443543, -0.3017724789017195],
            [12.503227529689205, -0.3044946839795978],
            [12.495890732265464, -0.30690112636330175],
            [12.493090884587495, -0.3121193234369674],
            [12.487011908241065, -0.3185572766776089],
            [12.481465354837697, -0.32215473004086953],
            [12.45982157412506, -0.3409035712719321],
            [12.454749480558405, -0.3446751349709129],
            [12.445424830079473, -0.35348440716565516],
            [12.43216775866114, -0.36213802274362134],
            [12.426533113711837, -0.36668375983760854],
            [12.416448835066946, -0.3730214573031304],
            [12.413976747462117, -0.373484015264716],
            [12.406137458202217, -0.3800386618587599],
            [12.398622088656328, -0.3838303468585139],
            [12.391533869053292, -0.3729387362515949],
            [12.38645241332694, -0.3687628872893827],
            [12.38408522455731, -0.36344688434344885],
            [12.379150781850575, -0.36313780656944655],
            [12.371271379747613, -0.36433755684917474],
            [12.366482529535725, -0.36272054935641695],
            [12.365333007265333, -0.35672303008434214],
            [12.338718474454296, -0.34031280469610115],
            [12.334401468174804, -0.33935455164265005],
            [12.331202501335593, -0.3425046469770033],
            [12.327411110307356, -0.3403855530315656],
            [12.320982487747278, -0.3391291247697078]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.55053381139014, "lat": 37.56033865003434 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54063"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01557702"
      },
      "bbox": [
        12.320982487747278, -0.3838303468585139, 12.782409437827539,
        0.0061900042794595005
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.552177046976528, -0.22143970168046484],
            [11.558939984640924, -0.20949377531310767],
            [11.56275886573487, -0.2111651655081912],
            [11.565472576848391, -0.2070799038262279],
            [11.568122855182612, -0.2067825691969363],
            [11.56792557414425, -0.20231894048096674],
            [11.571387455636714, -0.2005715145021289],
            [11.574929400021405, -0.2019776576301935],
            [11.581439405851976, -0.19731887623231217],
            [11.585044600616518, -0.19074918432550797],
            [11.588436974555627, -0.19064535150469425],
            [11.592706456151745, -0.19582159054493858],
            [11.595523588475016, -0.19243416141510353],
            [11.600003749557677, -0.1916547515039044],
            [11.60282237045787, -0.18775609632630003],
            [11.601270158493483, -0.18063751757451432],
            [11.606128843352735, -0.17765562424971032],
            [11.61312230483966, -0.17097976727987943],
            [11.61612103790376, -0.1724661521391054],
            [11.624435199526017, -0.16875514272012987],
            [11.570224005769676, -0.12721854581945097],
            [11.568202181907177, -0.1258896713858027],
            [11.569476646603938, -0.12069317118890034],
            [11.57546577914507, -0.12050383526805629],
            [11.576548577659212, -0.11666371935604294],
            [11.582699500724855, -0.11073010418927617],
            [11.585011968334413, -0.11293380379643313],
            [11.589163685056455, -0.11159118555930976],
            [11.59494278239324, -0.11367883475860552],
            [11.596537146290057, -0.10904592953479784],
            [11.610288849246691, -0.10573798135918698],
            [11.61293124665624, -0.10289243099343232],
            [11.617450904849294, -0.10179260019853585],
            [11.619545634942162, -0.09524459593834715],
            [11.62806560218826, -0.09190909602432826],
            [11.634229320336324, -0.09444497528018252],
            [11.637468626853915, -0.08762020812202384],
            [11.641155582570828, -0.09104348896419882],
            [11.647081924666649, -0.08523974213028482],
            [11.649678830589604, -0.08617266638346639],
            [11.657248185461503, -0.0844081152993258],
            [11.662196228392654, -0.0851870263543522],
            [11.664993978928429, -0.08016434633003414],
            [11.669088709732168, -0.07586320011859031],
            [11.672516413693941, -0.07860955329494478],
            [11.676316429232967, -0.07445500665802368],
            [11.679643212575144, -0.07394764785588973],
            [11.684105993334477, -0.07050871434930601],
            [11.69261115801082, -0.0712523779773699],
            [11.69336271777131, -0.07410004365065657],
            [11.697088986593597, -0.07516534553500151],
            [11.704797058273048, -0.0799073109668095],
            [11.703585789886818, -0.08244712710805782],
            [11.706328930241762, -0.08744205309013102],
            [11.711966929100548, -0.09219857793562292],
            [11.718274775017283, -0.086840848936499],
            [11.721679498493506, -0.08631974700483674],
            [11.723951234540914, -0.07943377890097676],
            [11.731459865012166, -0.07572860925361874],
            [11.736221872528803, -0.06805174000699808],
            [11.740539621366173, -0.06779932078118567],
            [11.743303442484677, -0.0610412180193423],
            [11.746073596100915, -0.060003171411855245],
            [11.749951917527945, -0.06257399186239428],
            [11.755899914639281, -0.056961000317002075],
            [11.75905308649123, -0.057906937655495004],
            [11.761068766428274, -0.05402133734352806],
            [11.76703079771076, -0.05739595072645753],
            [11.772328888501136, -0.054129069821877616],
            [11.778352582699897, -0.061886745349069794],
            [11.78268881394857, -0.06143383800710333],
            [11.786580795047861, -0.06286777204436711],
            [11.789038932694723, -0.059413735291715744],
            [11.795627225261507, -0.056186426578377184],
            [11.800446131461594, -0.057257078909195194],
            [11.801896450959369, -0.06204004753750826],
            [11.810800429915112, -0.07098528032945607],
            [11.816209595815634, -0.07985729894879688],
            [11.820864053454947, -0.08588244671199277],
            [11.829283889205573, -0.0885207848870376],
            [11.86014969976802, -0.12825879565749465],
            [11.93501914400311, -0.22725027026636424],
            [11.934694442323794, -0.23019910949720696],
            [11.938309898066466, -0.23556363741422365],
            [11.941395985818977, -0.23549184265482723],
            [11.94560074156154, -0.2410709363602138],
            [11.946952077039278, -0.24668569646250196],
            [11.944657956665749, -0.2513353747444368],
            [11.946256769798097, -0.25496983975952586],
            [11.944354058348086, -0.26139086595819516],
            [11.948083305661156, -0.2688273920185054],
            [11.956427929146928, -0.27591965719865347],
            [11.960610386961683, -0.27570198541864316],
            [11.972241410459246, -0.27959855093920205],
            [11.97575221894992, -0.27674075215445904],
            [11.980846571861633, -0.28480727432045744],
            [11.984982008696333, -0.2848123352536583],
            [11.99167413794902, -0.29008789241916194],
            [11.998483395351277, -0.28331903577919393],
            [12.001144799293968, -0.2858759065797411],
            [12.00512918546211, -0.2854313035545377],
            [12.009200083803622, -0.2901089399414773],
            [12.019373999046195, -0.29618130681416155],
            [12.022649422792366, -0.2962813228721216],
            [12.025698382619773, -0.3020373263807942],
            [12.020963495380599, -0.3034335042862128],
            [12.018764361438558, -0.3067543892499029],
            [12.014122357347592, -0.3068160027413571],
            [12.011036937365699, -0.3120006303384722],
            [12.005376395063367, -0.3139647241421058],
            [11.999244849102006, -0.31801850378794644],
            [11.995827900786113, -0.3225314972966839],
            [11.99631439034247, -0.327226350241107],
            [11.991208691006767, -0.33389572174072923],
            [11.991828721162756, -0.339906489448348],
            [11.985698740239839, -0.34874244724044323],
            [11.975630496759198, -0.3517513934152062],
            [11.97530940404194, -0.35911885353090783],
            [11.967420701882789, -0.3635442851630202],
            [11.970433410766178, -0.3687599480245688],
            [11.97039495238324, -0.372495079959547],
            [11.980899033245095, -0.3799488083694341],
            [11.98129170906469, -0.38196626340120027],
            [11.986672172180617, -0.38661695724447354],
            [11.987756544731472, -0.39195420930099845],
            [11.992874153846584, -0.3997892664638111],
            [11.990039247853492, -0.40175652562009256],
            [11.985884580773394, -0.40764440800208585],
            [11.977198707895749, -0.4031153451847748],
            [11.974347112729957, -0.39929824528749225],
            [11.969914690942316, -0.39855407136571386],
            [11.956911904360899, -0.3937633896942769],
            [11.953503284462116, -0.38997311009616875],
            [11.947567226988415, -0.3932876625448529],
            [11.94131848355255, -0.3937838640600541],
            [11.938146478187836, -0.3908187071926481],
            [11.93464008484095, -0.3911805048798867],
            [11.931071938500065, -0.38886420999997806],
            [11.91780494293258, -0.3873793594505972],
            [11.909881405030358, -0.37960048934599394],
            [11.906583661390084, -0.3708119700926916],
            [11.900889074855765, -0.37318925411148895],
            [11.896075134777835, -0.3691782901053988],
            [11.893211126745717, -0.37525797217847134],
            [11.885223360628414, -0.37659006222451596],
            [11.880227114060526, -0.38013888859886297],
            [11.878950117630255, -0.37650468802771053],
            [11.874931156014643, -0.3757138413512999],
            [11.873539767906914, -0.37980949610887044],
            [11.873900190812194, -0.3854674526077431],
            [11.87164314092184, -0.38790665849140915],
            [11.867719617664923, -0.38624234834475707],
            [11.863250316388703, -0.3811187468009516],
            [11.85934009110834, -0.3782688650002008],
            [11.856318402812798, -0.37813948265827885],
            [11.851631952862329, -0.37428105408918344],
            [11.850390261688533, -0.3709639996275672],
            [11.853915827128548, -0.3637074636254148],
            [11.850264713897834, -0.36262777919237044],
            [11.847682384277618, -0.3586551499717817],
            [11.840469371154958, -0.3571046005694868],
            [11.83343191926451, -0.36018524921019596],
            [11.830079852480267, -0.36434781479316586],
            [11.821170376407864, -0.3638146475556103],
            [11.816353558270169, -0.3720298809926525],
            [11.809861083139463, -0.36952064033471305],
            [11.803653138283504, -0.37134993865353466],
            [11.800916016326738, -0.3699446699253314],
            [11.793283063643893, -0.3725966611374109],
            [11.78696181741462, -0.36467451689831315],
            [11.781513259740786, -0.3630224792749792],
            [11.773620905689873, -0.36376925950771105],
            [11.771340493777585, -0.3604706137171891],
            [11.767911853065355, -0.36394186747325047],
            [11.762562365627659, -0.3631079587324581],
            [11.758096966656781, -0.3670121361443624],
            [11.754687287735056, -0.36399616421634057],
            [11.749171331927288, -0.36845572487682077],
            [11.746215009013417, -0.3658808636599134],
            [11.744457236577652, -0.36180095469110274],
            [11.738549986065182, -0.36659322475882405],
            [11.731482959708847, -0.3625055558274486],
            [11.72745097343187, -0.35297462300017585],
            [11.729914463035946, -0.3493299307606993],
            [11.722278170634738, -0.34875864361036973],
            [11.721675125673219, -0.3427218532989041],
            [11.717076393913722, -0.3386223642632162],
            [11.714063437508834, -0.33918388641699465],
            [11.711350006687345, -0.3432746848460907],
            [11.70786612880055, -0.3454398424301058],
            [11.70963773328238, -0.3497663845316889],
            [11.703065596006356, -0.3514824381466087],
            [11.699648433123823, -0.34730418311860867],
            [11.695680485529062, -0.34995094548360145],
            [11.69264694725405, -0.34724616454469065],
            [11.690923642810942, -0.3427077457819788],
            [11.68811999024749, -0.3409892660183203],
            [11.681777859079459, -0.3436899176687235],
            [11.675717229218575, -0.34981985089084283],
            [11.669402416793305, -0.3490435428139429],
            [11.662877126316962, -0.35473207990175437],
            [11.66710278025128, -0.3621584382172812],
            [11.659645954853303, -0.36747817172134517],
            [11.654581878868159, -0.36814383048464583],
            [11.651215425583478, -0.37522511262912933],
            [11.647586398830974, -0.37376293894323165],
            [11.641265962448959, -0.3766032870348742],
            [11.637119635909604, -0.3757694062154971],
            [11.634079630892739, -0.37844450725495593],
            [11.628391660182738, -0.37811398332126006],
            [11.62151219496583, -0.37358401081764],
            [11.618956600887586, -0.3736188636126495],
            [11.614753831758954, -0.369165950571712],
            [11.605765594297312, -0.37448117976356216],
            [11.600294600222153, -0.3727168137943705],
            [11.596333401930721, -0.3734602246479147],
            [11.59362479976692, -0.3779859983009757],
            [11.583013552332703, -0.3767101226014727],
            [11.580821746462256, -0.37111844822797174],
            [11.576397968272113, -0.37392782232725635],
            [11.572190639677196, -0.37394825563620737],
            [11.563652011561686, -0.3768672278738734],
            [11.557779795936705, -0.37162307796798527],
            [11.553963818822824, -0.3710731539008666],
            [11.555258952144587, -0.36383291843969434],
            [11.556975650675923, -0.3620432964146585],
            [11.555680007823721, -0.3544785000325967],
            [11.552727951895811, -0.34910167815267706],
            [11.54625435636402, -0.34935920518612],
            [11.541733599680962, -0.34146064267384674],
            [11.53837133587804, -0.33757353665148054],
            [11.532384434366348, -0.34000335812747084],
            [11.527795867698567, -0.33905770145235675],
            [11.525512356883986, -0.33388725972271427],
            [11.525942238452894, -0.32616476350532103],
            [11.532646526246863, -0.32005386419109394],
            [11.537594198081013, -0.3202304024712686],
            [11.54155666050004, -0.3159595506440697],
            [11.537762216764786, -0.31183212273952443],
            [11.541975294654916, -0.3039496246031152],
            [11.543445891414494, -0.29841890069850496],
            [11.540728478796117, -0.28810424677227],
            [11.543450489934907, -0.2852456495077857],
            [11.552191234621112, -0.2832170626366284],
            [11.552876592153089, -0.2801771683525942],
            [11.547017673457947, -0.2757235635575015],
            [11.546970254751933, -0.27276937207202767],
            [11.550136587160218, -0.26924724702592984],
            [11.552580786382732, -0.2699866109463537],
            [11.553700259630702, -0.2758420493959142],
            [11.558892407164887, -0.26975086565159284],
            [11.560980391402536, -0.2609608515957944],
            [11.558582635817723, -0.25662434472793666],
            [11.561509357679089, -0.25393718479098243],
            [11.562273864853914, -0.24953309823727893],
            [11.559513008797602, -0.24331106613486211],
            [11.555299700094075, -0.23955419040244566],
            [11.55462341633572, -0.23506066796970648],
            [11.555995386248359, -0.22995249706155058],
            [11.555258848776457, -0.22505956394085852],
            [11.552177046976528, -0.22143970168046484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.54919393089986,
          "lat": 37.609651752492105
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54109"],
        "coty_name": ["Wyoming"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wyoming County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01550061"
      },
      "bbox": [
        11.525512356883986, -0.40764440800208585, 12.025698382619773,
        -0.05402133734352806
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.603088205931691, 6.692187045860799],
            [-6.5352102314776825, 6.685099155015122],
            [-6.523952901629506, 6.690678569883938],
            [-6.427218950193593, 6.680772293068716],
            [-6.32379746858681, 6.670336521718875],
            [-6.2335414134180684, 6.661276795770672],
            [-6.143287549235818, 6.652195569808911],
            [-6.072261035538543, 6.645236085138587],
            [-6.001235845900673, 6.638263293955803],
            [-5.936166206469091, 6.632034488770491],
            [-5.948555942770499, 6.504242333368409],
            [-5.947214425628396, 6.504112668164925],
            [-5.956780125973307, 6.420151083504071],
            [-5.962779615300279, 6.421330542645896],
            [-5.972553628404762, 6.320918951653186],
            [-5.986345785094902, 6.178482706153124],
            [-5.988058347483785, 6.16446670783668],
            [-5.985623608463981, 6.164133503728444],
            [-5.995550406524351, 6.068673231863504],
            [-5.996117831034906, 6.06442019287273],
            [-6.009529006982572, 5.9273544405354945],
            [-6.010489225563784, 5.916075411540904],
            [-6.016638253197482, 5.8555283454804306],
            [-6.018885174621687, 5.815179274493169],
            [-6.0168208612597756, 5.814989478635213],
            [-6.037985858772297, 5.606392163733584],
            [-6.051775713056783, 5.467895230189987],
            [-6.0498906466838935, 5.467808784627294],
            [-6.0595934163230565, 5.38129384481426],
            [-6.082261475539434, 5.144777267013106],
            [-6.082093574312701, 5.140785650304872],
            [-6.115018231315839, 5.143360916184375],
            [-6.203854726857834, 5.1517242516526185],
            [-6.292692845605869, 5.160069927896718],
            [-6.346036369338844, 5.164736677691519],
            [-6.381230602096785, 5.168371967985132],
            [-6.3846208679209875, 5.168437000390711],
            [-6.517206784079088, 5.181067629834726],
            [-6.65413993719811, 5.194457454349448],
            [-6.74394347896311, 5.203507186583074],
            [-6.755989008790898, 5.204945186338922],
            [-6.743272541479135, 5.328954391860709],
            [-6.74332227247573, 5.334379158675887],
            [-6.721654432234271, 5.529654699477413],
            [-6.715644249003683, 5.529112538736422],
            [-6.69412400758254, 5.736679239114289],
            [-6.683895834302531, 5.84275758809833],
            [-6.680460187571422, 5.875049785763699],
            [-6.6841059379503545, 5.875427288791133],
            [-6.670036125304144, 6.00912535159052],
            [-6.64561608268196, 6.22363744931888],
            [-6.6413617535703615, 6.223291518460201],
            [-6.637689046250195, 6.265893229304302],
            [-6.625157732698938, 6.39104889961201],
            [-6.624782986708507, 6.393954655119784],
            [-6.626351539759662, 6.408038506254256],
            [-6.609977499292133, 6.557171930508315],
            [-6.611140577527944, 6.568302322992276],
            [-6.615026539909399, 6.568745863248644],
            [-6.604924853980159, 6.675715020400314],
            [-6.603088205931691, 6.692187045860799]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.54820097987168,
          "lat": 44.24818319787137
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56005"],
        "coty_name": ["Campbell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Campbell County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01605068"
      },
      "bbox": [
        -6.755989008790898, 5.140785650304872, -5.936166206469091,
        6.692187045860799
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": 144.77426749584734, "lat": 13.44370756594467 },
        "year": "2023",
        "ste_code": ["66"],
        "ste_name": ["Guam"],
        "coty_code": ["66010"],
        "coty_name": ["Guam"],
        "coty_area_code": "GUM",
        "coty_type": null,
        "coty_name_long": ["Guam"],
        "coty_fp_code": "010",
        "coty_gnis_code": "01802705"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -67.17476894464053, "lat": 18.36032068264784 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72003"],
        "coty_name": ["Aguada"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Aguada Municipio"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01804481"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.67515186220045, "lat": 18.40667984885645 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72013"],
        "coty_name": ["Arecibo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Arecibo Municipio"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01804486"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.92603656022759,
          "lat": 18.439726267580134
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72115"],
        "coty_name": ["Quebradillas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Quebradillas Municipio"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01804538"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -64.76801071815274,
          "lat": 17.733301055155902
        },
        "year": "2023",
        "ste_code": ["78"],
        "ste_name": ["United States Virgin Islands"],
        "coty_code": ["78010"],
        "coty_name": ["St. Croix"],
        "coty_area_code": "VIR",
        "coty_type": "island",
        "coty_name_long": ["St. Croix Island"],
        "coty_fp_code": "010",
        "coty_gnis_code": "02378248"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.35738852317065, -2.238784339467854],
              [16.362435150792503, -2.236840909319705],
              [16.36360099978404, -2.23185674205081],
              [16.365813330354406, -2.2303482527164333],
              [16.366546219302883, -2.225936701634129],
              [16.37033846369646, -2.222168696888753],
              [16.378399830842824, -2.209390156348964],
              [16.380063996910476, -2.195145827658625],
              [16.381567667536306, -2.191778449030645],
              [16.38743065806104, -2.196729400753638],
              [16.39244247160609, -2.192381803086829],
              [16.393599852760406, -2.1881230086409555],
              [16.39882660795405, -2.1806791006776263],
              [16.400420630858683, -2.176247743109706],
              [16.405910911221962, -2.171557991866541],
              [16.405742613337598, -2.1681402030873134],
              [16.410837961928692, -2.1634537496772546],
              [16.41780531015007, -2.1515466120223183],
              [16.42334045128347, -2.1448400125896376],
              [16.42539605747945, -2.1388659566770296],
              [16.433836191133807, -2.1231161247266868],
              [16.436270687328907, -2.121558572767287],
              [16.439049101349045, -2.1163960971109796],
              [16.441126345716917, -2.106806804595681],
              [16.453341120945957, -2.0884137569268826],
              [16.45598546351073, -2.081514525429152],
              [16.46004962216308, -2.080574218009419],
              [16.461680021069316, -2.0759753400340792],
              [16.468437634872217, -2.0747054471777338],
              [16.47038284327814, -2.0719661524754596],
              [16.46875444935113, -2.0642872470511793],
              [16.473629537512156, -2.0567544400557454],
              [16.47321638770105, -2.054435170794417],
              [16.478078488884933, -2.046103910533594],
              [16.488515179322203, -2.035787022123107],
              [16.489906056935677, -2.0315609910853536],
              [16.493082621101873, -2.030165688317596],
              [16.494293499103904, -2.0250945878360995],
              [16.49364929319543, -2.020578918170983],
              [16.49810011567707, -2.0144200282126383],
              [16.502026069527734, -2.013586362061708],
              [16.505464196551618, -2.0056365037185393],
              [16.50814638675086, -2.0037836599961127],
              [16.50984952116574, -1.9973262329206725],
              [16.50798116575741, -1.995959031291942],
              [16.509543001148703, -1.9892099803944852],
              [16.514120237491603, -1.9806994297087457],
              [16.513218017445492, -1.977201820790816],
              [16.51581174379823, -1.9745653969797259],
              [16.52137707057788, -1.9721788755609837],
              [16.530338207208644, -1.9720362508463802],
              [16.53511308744143, -1.9733447818660588],
              [16.545161079405464, -1.9786634518273816],
              [16.546418331277877, -1.9834488794891425],
              [16.53762322381418, -1.9932630313263568],
              [16.531442108342535, -1.9979477393861442],
              [16.52113774038118, -2.007358818315615],
              [16.51656764800026, -2.0125823918743184],
              [16.50659680349404, -2.0261734159856584],
              [16.485745164066557, -2.056192542328012],
              [16.46737816823152, -2.0831161134214202],
              [16.449924283938714, -2.1080779156578133],
              [16.43221776568703, -2.1363828803748017],
              [16.414669241200162, -2.1651356322167206],
              [16.404992967883594, -2.178818389823959],
              [16.386212926714567, -2.2044544947126417],
              [16.37748364603464, -2.215927903800798],
              [16.369432222470063, -2.2283836987015366],
              [16.360409425669708, -2.2411219951081383],
              [16.35738852317065, -2.238784339467854]
            ]
          ],
          [
            [
              [16.212317490972247, -2.4103793520042256],
              [16.21366445163468, -2.408290182311783],
              [16.219435995711525, -2.4074951483437124],
              [16.229403084630608, -2.4078391998493722],
              [16.233007879624846, -2.407090669180611],
              [16.2354265103253, -2.409201858101413],
              [16.234413670318073, -2.417654955602591],
              [16.220690965521715, -2.4182922721752202],
              [16.2170856378244, -2.419040211947111],
              [16.214248036726364, -2.4168137793095545],
              [16.212317490972247, -2.4103793520042256]
            ]
          ],
          [
            [
              [16.225396068979848, -2.4976460865500196],
              [16.229285904575583, -2.50416404377064],
              [16.232274058047295, -2.505958802024921],
              [16.24073326555222, -2.505089799649542],
              [16.24509013245645, -2.5066001220092455],
              [16.24694534254021, -2.4991320697894612],
              [16.24606702039092, -2.4952898601734774],
              [16.248472858503913, -2.4923758422575317],
              [16.250094846306332, -2.4845535199005027],
              [16.253223570862584, -2.476741027648956],
              [16.25630831704484, -2.464914446323641],
              [16.256713628932495, -2.4573472003235652],
              [16.259438219571052, -2.4517917418967277],
              [16.261102973930512, -2.4453307863059344],
              [16.255678734068493, -2.4405854229926014],
              [16.261741821530027, -2.432808494420251],
              [16.26220992370624, -2.4255516189427144],
              [16.265623174662036, -2.4191306896558133],
              [16.26647623239389, -2.4137248325029694],
              [16.271116147852677, -2.408255091954529],
              [16.273605329313146, -2.402347762431534],
              [16.270918912390325, -2.3974376865820353],
              [16.276224494864874, -2.3917493607670846],
              [16.278515007876535, -2.384517255175625],
              [16.28368595203775, -2.380464573525019],
              [16.286085670372856, -2.380205206111827],
              [16.287888304246863, -2.3755677457864945],
              [16.292171819583945, -2.369930108162989],
              [16.29084501837438, -2.3643364118449757],
              [16.293343096205078, -2.3607607347365485],
              [16.29002643095715, -2.356628714028349],
              [16.291052501273743, -2.3494202188703572],
              [16.288526809074785, -2.3452836938297024],
              [16.289236201117664, -2.342241552512551],
              [16.29275416160666, -2.3401418162545813],
              [16.293072227424172, -2.3375023453210684],
              [16.299147422537704, -2.337038254670804],
              [16.304694593460198, -2.338211389867909],
              [16.308008920204347, -2.3343840197440837],
              [16.305979277926884, -2.3273321841393635],
              [16.306919790549507, -2.3246437887827605],
              [16.3048047343685, -2.320584406657798],
              [16.308537918991078, -2.314982157206244],
              [16.312706733709813, -2.3141110225516135],
              [16.311386402996202, -2.3066709407096018],
              [16.315166499071623, -2.305077901888437],
              [16.321872457151265, -2.304237745079635],
              [16.326029296664586, -2.2999125330462373],
              [16.331300180333912, -2.2861917672615153],
              [16.331439881424558, -2.282707662611409],
              [16.336826155787143, -2.2748296064218927],
              [16.335761622881506, -2.268624361010529],
              [16.34723222230726, -2.2603558514292503],
              [16.351572773836505, -2.251653084665281],
              [16.353979825794234, -2.251068007023745],
              [16.345059970549517, -2.2699709029165693],
              [16.330208512276997, -2.29871689724068],
              [16.317703463215565, -2.3239982508148302],
              [16.305101360636087, -2.353401647315732],
              [16.29772081148442, -2.3684504599709615],
              [16.281294595329886, -2.4069392082607086],
              [16.267903518582422, -2.439572194121326],
              [16.263287927368093, -2.4516354170494714],
              [16.260219419850824, -2.462008820999914],
              [16.2573969173915, -2.475471666981607],
              [16.250169876311258, -2.5001528885775657],
              [16.24757040585325, -2.5135714665820865],
              [16.24638900436367, -2.525812521058582],
              [16.240332576415952, -2.519178938210862],
              [16.232364626281626, -2.511735750250509],
              [16.2252373926325, -2.501461546782575],
              [16.225396068979848, -2.4976460865500196]
            ]
          ],
          [
            [
              [16.18071062986301, -2.4135098306256557],
              [16.186362503718897, -2.41213924598887],
              [16.19495070545214, -2.4115663916053105],
              [16.202001722611293, -2.413120926448607],
              [16.200756185837957, -2.4214204206501817],
              [16.208337275550143, -2.422663058295252],
              [16.208897731806328, -2.4253617782451458],
              [16.222911112875295, -2.423259991032189],
              [16.233430252764997, -2.4252991933501438],
              [16.23498330477276, -2.4318127044054894],
              [16.233366121919648, -2.4335569974773192],
              [16.22896953488006, -2.431452955534226],
              [16.187542828269507, -2.427373098155183],
              [16.184517025807494, -2.4251857305193236],
              [16.180391165968867, -2.415787845743099],
              [16.18071062986301, -2.4135098306256557]
            ]
          ],
          [
            [
              [16.1224293016872, -2.4504447771485753],
              [16.12731717283307, -2.4489815976871427],
              [16.134389604173887, -2.4487297401690546],
              [16.139955236905294, -2.449993682750919],
              [16.15257416721793, -2.450525324333491],
              [16.17319008437977, -2.456399054491754],
              [16.185136427958373, -2.4578692259083446],
              [16.186922873375885, -2.455408223110196],
              [16.195560839664623, -2.460780253357915],
              [16.200037438759832, -2.4609787828123535],
              [16.208436139958003, -2.46366373603369],
              [16.215628856489566, -2.4674023580674374],
              [16.220558292160543, -2.468633473559301],
              [16.229525218425252, -2.4687048371377185],
              [16.230993743156954, -2.4708147532369096],
              [16.23989853961449, -2.4736334806423708],
              [16.24032973620187, -2.478372139282404],
              [16.243200273573574, -2.4834099603812767],
              [16.242733796512056, -2.4868863558983314],
              [16.238082964067207, -2.486242586594151],
              [16.225825677700506, -2.47454200846471],
              [16.220391428061788, -2.4716453141398516],
              [16.20468309258864, -2.4658094396335497],
              [16.191455128092443, -2.4627555329385666],
              [16.17982406958309, -2.4608989848858434],
              [16.162151347819457, -2.458922136126989],
              [16.136466788184787, -2.4576295993858737],
              [16.123159805687855, -2.4518494123481984],
              [16.1224293016872, -2.4504447771485753]
            ]
          ],
          [
            [
              [15.784953605620501, -2.563248073903266],
              [15.78700900609912, -2.5607661957421306],
              [15.786015723372623, -2.556627103460889],
              [15.789300827256731, -2.5560456646313807],
              [15.79129363126591, -2.552591513905486],
              [15.796131320553902, -2.5487232704913496],
              [15.809940504670193, -2.5403141045200006],
              [15.830731911743635, -2.528885303276653],
              [15.83580470201318, -2.526976449566605],
              [15.846210891761519, -2.52093537206288],
              [15.850536020394477, -2.5243193736447194],
              [15.856828675281978, -2.5229648700275766],
              [15.860104013276064, -2.5207756736684086],
              [15.864878464278563, -2.5201306629816753],
              [15.86822925031684, -2.51792474478902],
              [15.87483609057728, -2.5157824436273133],
              [15.87773024001078, -2.5136695812233794],
              [15.900617927302896, -2.506374854091559],
              [15.910135317110827, -2.5025928307778207],
              [15.911434826448918, -2.5012042699357364],
              [15.919227409284703, -2.499058329570412],
              [15.929591658502032, -2.494780665593933],
              [15.936514340478574, -2.4879873248026865],
              [15.941080499625702, -2.4859331190717717],
              [15.94821912088987, -2.4864079399945545],
              [15.952664632106764, -2.484537937465655],
              [15.959048423438203, -2.4793794906265623],
              [15.967182123183928, -2.4785238594210623],
              [15.978501085420746, -2.4742854422206677],
              [15.985896375173963, -2.4682751135324414],
              [15.990135510454836, -2.4634711508346854],
              [15.994211683041634, -2.461352940035431],
              [15.998641218691697, -2.4617328151967146],
              [16.01405691843358, -2.458579731258659],
              [16.01789204320166, -2.456830262464865],
              [16.026823989439247, -2.455243011922507],
              [16.036569257274685, -2.454531756656137],
              [16.039525757857223, -2.456979951114065],
              [16.046384677578562, -2.4530017206026606],
              [16.054376545311563, -2.451844589719978],
              [16.055597047430517, -2.4504690743977386],
              [16.053910365485205, -2.4414916731109835],
              [16.06120846812705, -2.4411989415391493],
              [16.068206632543497, -2.4502117884379744],
              [16.072405883378995, -2.4467760554402234],
              [16.07912528656489, -2.4444316028859867],
              [16.091433764101673, -2.4446334117492654],
              [16.0882483101837, -2.438777170128442],
              [16.08897984368311, -2.4354115802595797],
              [16.092955183767867, -2.4343530866822394],
              [16.104331062966953, -2.444230741425307],
              [16.11068051308965, -2.443163969541271],
              [16.11188621828203, -2.448624080340829],
              [16.099173929789004, -2.451080734169634],
              [16.073379846991564, -2.4530613217717474],
              [16.058737418964355, -2.455354276801295],
              [16.04300164403066, -2.45884750465993],
              [16.02997139980575, -2.4622088650297975],
              [16.001968561490415, -2.47059862584951],
              [15.976898890241594, -2.4791938937612854],
              [15.939254108748225, -2.493280094100212],
              [15.8829995001919, -2.5163991756563164],
              [15.864060118409233, -2.5247609886385036],
              [15.84873548147861, -2.531922830251943],
              [15.817483886665048, -2.5481545088885174],
              [15.803206758395342, -2.5561000966118597],
              [15.789838973272705, -2.5646227182902477],
              [15.784953605620501, -2.563248073903266]
            ]
          ],
          [
            [
              [15.768360565428827, -2.397611378597171],
              [15.858420093841794, -2.38187387655907],
              [15.867628031370339, -2.3798526328014593],
              [15.864261255909767, -2.3646599207969845],
              [15.919615922895671, -2.340883855703429],
              [15.917366725357152, -2.3328986414206088],
              [16.005739389496036, -2.3130091133523085],
              [16.00956412243085, -2.310046583777428],
              [16.016787039669843, -2.3111472868095357],
              [16.063936411234113, -2.27790790776634],
              [16.064483218597097, -2.2758540149409776],
              [16.062829579379855, -2.264549248118719],
              [16.064845445676667, -2.25835530223452],
              [16.063988803634253, -2.2509511165971445],
              [16.065815280978093, -2.2465645146123494],
              [16.071924914885283, -2.2425548401999524],
              [16.0752993611716, -2.238575276256379],
              [16.07950682681266, -2.2303800387643613],
              [16.08028657988608, -2.2268021576902624],
              [16.082217725952667, -2.203748968340535],
              [16.058484458130753, -2.187941321259093],
              [16.05832434293911, -2.1811272319551125],
              [16.05649242940414, -2.1769287069488046],
              [16.06397075611664, -2.1700275612087183],
              [16.066080930127008, -2.1632958776770606],
              [16.069197730703458, -2.160248302919457],
              [16.078338239762676, -2.1567635396092992],
              [16.088915266180013, -2.149765904375412],
              [16.09890599335454, -2.1485037100776516],
              [16.109563596585545, -2.149507488375078],
              [16.1240834600634, -2.1539190360937424],
              [16.133249676353202, -2.1534252363534807],
              [16.134864978138115, -2.1456801184835985],
              [16.12957456932338, -2.1423602802065878],
              [16.12947494024418, -2.1399755489305683],
              [16.138985152877336, -2.1325946023406055],
              [16.139721760395496, -2.129344794057354],
              [16.155774567286475, -2.12229917145943],
              [16.168152789227847, -2.119083463909938],
              [16.18059185292695, -2.113928931490366],
              [16.18350359067048, -2.121952477249689],
              [16.188541815372623, -2.1253152543598675],
              [16.1955439333683, -2.1314760506344346],
              [16.200756793986695, -2.129991256361432],
              [16.205866710703805, -2.1261216172221182],
              [16.20590221002321, -2.122505898673679],
              [16.200379506490663, -2.1214778455942223],
              [16.197107819367574, -2.1153156195501004],
              [16.19116024825855, -2.1085352312290397],
              [16.191713572449878, -2.1048354923611674],
              [16.196711301593584, -2.1001657520263155],
              [16.197331259844315, -2.0946266467743757],
              [16.19237925031299, -2.095456265365833],
              [16.19091404016652, -2.0931564234055107],
              [16.193766712778256, -2.0746161009004958],
              [16.195809545078358, -2.0702981488387824],
              [16.198075957369017, -2.0698263461425626],
              [16.20124511985841, -2.0755776683316625],
              [16.204617617119247, -2.069064412017895],
              [16.209305397584465, -2.06508350972602],
              [16.202181124637377, -2.0545468855483144],
              [16.196704516408264, -2.055687377595852],
              [16.198807293093953, -2.0374236618804407],
              [16.20415132488719, -2.0355823844958425],
              [16.216090781107795, -2.042834427228552],
              [16.21712155881204, -2.0468267436616667],
              [16.22163103507499, -2.050493128787328],
              [16.226071019467298, -2.0481645773084134],
              [16.22996552814873, -2.0492178125563116],
              [16.234336318213266, -2.0574493734177435],
              [16.233755221511466, -2.0641925371148715],
              [16.237151476694475, -2.072901161643925],
              [16.24525264879656, -2.0758199351229782],
              [16.240313222128396, -2.077652169660457],
              [16.235408045878888, -2.082483461263092],
              [16.237533122995163, -2.0860484512071826],
              [16.235187185880225, -2.092750692515408],
              [16.241586309476393, -2.1054472102768846],
              [16.24538894926338, -2.1066583226171596],
              [16.249797783127498, -2.103230877408076],
              [16.25668387465024, -2.122945727538435],
              [16.257257839351688, -2.126635435924341],
              [16.252975875370094, -2.136351918480141],
              [16.262343402345632, -2.1528472907305254],
              [16.26791183642329, -2.1492772380675813],
              [16.271167894672597, -2.139371768582146],
              [16.27542322069391, -2.137078067330032],
              [16.278898451369646, -2.142368795406696],
              [16.28290495456518, -2.153966986142443],
              [16.290435990052497, -2.1465746306425793],
              [16.29074405057562, -2.1376849743331787],
              [16.29216179375067, -2.1265581229938286],
              [16.2886210155105, -2.1190768992476965],
              [16.29213143591422, -2.1179128953942157],
              [16.294820166901843, -2.122238181482949],
              [16.305783227400255, -2.124709282117467],
              [16.305615551171492, -2.117324082201855],
              [16.311955303752374, -2.1212094944534123],
              [16.318488155633073, -2.119299642489816],
              [16.324722479485597, -2.1237489642928136],
              [16.328868232305567, -2.1218764325935995],
              [16.338597663754044, -2.1268551646912988],
              [16.341435991430203, -2.1206427151185503],
              [16.33851270154359, -2.111428635721248],
              [16.33153529517093, -2.1068510035903882],
              [16.329053816468203, -2.1016385883471447],
              [16.324419288715152, -2.0969385640059817],
              [16.31830889191473, -2.0932069462419913],
              [16.30620696056218, -2.0768982036460404],
              [16.296117751620315, -2.0683062047335183],
              [16.28976355750418, -2.0643077739291735],
              [16.288094179849992, -2.0610498985087706],
              [16.29127987073166, -2.0583786773280854],
              [16.301421497812722, -2.059878876458444],
              [16.316141997693997, -2.0632053599772147],
              [16.321822868426466, -2.065805566670065],
              [16.33081034615863, -2.0665176022854115],
              [16.35285399115004, -2.0732281807037376],
              [16.389978098076217, -2.0746487425991442],
              [16.395089706722185, -2.077465133690748],
              [16.394619416042868, -2.0873919697495817],
              [16.392853422932728, -2.0939823902585677],
              [16.38902121296899, -2.0992032872915787],
              [16.38485012381892, -2.1018862515706274],
              [16.372933450943382, -2.09215958275634],
              [16.36007484200173, -2.0854382834866545],
              [16.352922611166218, -2.0889482453444366],
              [16.34710505947066, -2.093178081522508],
              [16.35338556996261, -2.0993839353935235],
              [16.358624905786915, -2.107604432681514],
              [16.364993716725383, -2.113487200123661],
              [16.375603016109654, -2.118878160891284],
              [16.37792387628068, -2.125211028041045],
              [16.375871175698844, -2.1332672781967434],
              [16.378286826225644, -2.1381773869993466],
              [16.373870623666402, -2.142517243818775],
              [16.36880675069219, -2.143782825635469],
              [16.365145446941288, -2.1479632841653653],
              [16.36762854625136, -2.152257931055985],
              [16.36758391960173, -2.15867696064242],
              [16.35428298713697, -2.1582726920754216],
              [16.342307498025846, -2.1529603275473432],
              [16.33763517528074, -2.1523352888628513],
              [16.33116374813143, -2.1563009825967403],
              [16.3325616180264, -2.1648367280880416],
              [16.338921120120684, -2.166914434081203],
              [16.335028264375534, -2.1709415777820933],
              [16.339263648048327, -2.178884111964233],
              [16.355029025838977, -2.1777835888248323],
              [16.35806501793589, -2.178529084109211],
              [16.355163042532183, -2.1879704532322783],
              [16.351451506183004, -2.194593090484882],
              [16.348751646585676, -2.2025651253311875],
              [16.33941176602722, -2.2115729143819496],
              [16.33886701668745, -2.216504752818065],
              [16.321855128673576, -2.220554789244407],
              [16.31588572689308, -2.2272898886384738],
              [16.314933176082988, -2.2326091139630266],
              [16.312567933182994, -2.2346791911895196],
              [16.31405445369008, -2.238567567457082],
              [16.31096877418718, -2.2408191453462423],
              [16.305225138866746, -2.239812143619214],
              [16.29899063530176, -2.2326831135049],
              [16.300106413884702, -2.227630778582045],
              [16.302788034470883, -2.2234564664924417],
              [16.302010970782398, -2.2188018403070187],
              [16.296948747618444, -2.2144399192529445],
              [16.291843769801154, -2.2126975308723282],
              [16.289918462887815, -2.2167124458522447],
              [16.291585432169768, -2.2227871052181727],
              [16.29097948375235, -2.2387737751731542],
              [16.293335331609704, -2.245308593770944],
              [16.29387150787073, -2.2589528814765223],
              [16.29179354064945, -2.262497823302342],
              [16.295313781730677, -2.2679883410279094],
              [16.293777572098076, -2.2729281216508466],
              [16.29132791278948, -2.2744443986273413],
              [16.28576454620153, -2.269581071664038],
              [16.280658084474695, -2.274462774670868],
              [16.278392688967966, -2.2853780798517858],
              [16.273313483481292, -2.2894503180594614],
              [16.269157366341602, -2.2913215217427108],
              [16.269048875898157, -2.298374105315117],
              [16.264480903435757, -2.322923379547016],
              [16.26306849241781, -2.327997197506353],
              [16.259180410665596, -2.3325727226300383],
              [16.259707057243975, -2.3400726864123493],
              [16.25569650179538, -2.3471627375338824],
              [16.25219739902405, -2.35030219501457],
              [16.2528730919705, -2.3563907786461775],
              [16.247136839124696, -2.349747619607151],
              [16.24097907446604, -2.3496215715476447],
              [16.240574451140876, -2.3543273081285285],
              [16.237132574350746, -2.355846580182198],
              [16.230051114227958, -2.3617390429546243],
              [16.23463815589047, -2.3676186814308138],
              [16.24073901060744, -2.3693646858875934],
              [16.24343801746974, -2.372824035366879],
              [16.243590368592667, -2.3764094269099942],
              [16.247139383663104, -2.381098641039163],
              [16.246561202880436, -2.384006497318952],
              [16.241821720192785, -2.3850185241412634],
              [16.24170536611086, -2.38825835235294],
              [16.238166695936577, -2.3950246339464383],
              [16.232796183187453, -2.3977485659252715],
              [16.230797752072927, -2.395750707067246],
              [16.223998070737082, -2.396358925585512],
              [16.220452365616033, -2.3954866577461167],
              [16.216396621305257, -2.4008678565121513],
              [16.20479672767104, -2.3963224505813723],
              [16.198568054972377, -2.400628181530482],
              [16.187614389324906, -2.404103168907866],
              [16.18053417935637, -2.3957211463513075],
              [16.183039870590047, -2.391584972564509],
              [16.184316640047822, -2.3862966840416298],
              [16.18187418148688, -2.3822456337070106],
              [16.172305985665616, -2.37130290132397],
              [16.17292736841488, -2.367401413537064],
              [16.178184048010408, -2.366268866319402],
              [16.176715677983744, -2.3601443729061335],
              [16.178062245957065, -2.3580567106269723],
              [16.174679393867272, -2.3541374088708036],
              [16.16977994874179, -2.358164307540781],
              [16.16297437431616, -2.3577648926786683],
              [16.15874417988619, -2.352939020705639],
              [16.155949354960683, -2.3467645963305657],
              [16.150732033862838, -2.341617824757142],
              [16.140894178315197, -2.3456597201125575],
              [16.14202784096342, -2.350847446863184],
              [16.145062624544835, -2.356246185681186],
              [16.14477168609722, -2.3653455233152445],
              [16.14537810368575, -2.373054552033464],
              [16.147612279787996, -2.380025927116399],
              [16.143847366885407, -2.3876347671000704],
              [16.14703717645656, -2.3961811487239753],
              [16.145869827873085, -2.400276969161855],
              [16.14907272463947, -2.405241526190892],
              [16.145846501618575, -2.409726509506108],
              [16.147113143568653, -2.4148913697868633],
              [16.158095276486424, -2.422068291220058],
              [16.156312969482446, -2.428589257374614],
              [16.137320005511246, -2.4287705931939416],
              [16.1313083495648, -2.42840309982766],
              [16.114628677238244, -2.430032461663556],
              [16.111566755185812, -2.427030335907439],
              [16.107105703778412, -2.427851536122404],
              [16.10560826026052, -2.4304135252665127],
              [16.106907490403106, -2.4367112901644066],
              [16.100968836067164, -2.434111913394973],
              [16.09713726486735, -2.428629537982606],
              [16.086928156915015, -2.4315138154707143],
              [16.084003834744472, -2.4299604964076504],
              [16.078375137209793, -2.4327572189478066],
              [16.07568259599526, -2.430299238070536],
              [16.07241737233353, -2.4317087336247067],
              [16.061021086266862, -2.4307637358757925],
              [16.04363114453314, -2.4329616540705286],
              [16.040400170312694, -2.4346033072470745],
              [16.033158384279357, -2.4331498580594286],
              [16.029291320267514, -2.4340400713166583],
              [16.01260276189237, -2.4358907062054977],
              [16.002206579697333, -2.4388015034994064],
              [15.97348422601045, -2.440263883511423],
              [15.965928305552683, -2.443862504924396],
              [15.952196093463868, -2.4469573399825846],
              [15.947555348265848, -2.448784376431828],
              [15.93907172331225, -2.449729388079919],
              [15.934287811717963, -2.452270443724661],
              [15.925561081357266, -2.452969363295179],
              [15.922643919638492, -2.4575774999783224],
              [15.913174039945451, -2.461963525463511],
              [15.903838827501916, -2.467962508340466],
              [15.90047995684587, -2.4675675203989953],
              [15.894575913544738, -2.475033958863704],
              [15.89020479659025, -2.47582258852366],
              [15.887975480273925, -2.478135570920077],
              [15.877677171352131, -2.482967074778899],
              [15.873846945111435, -2.4811976094888397],
              [15.871890182206128, -2.4858054740040187],
              [15.867966136868183, -2.4902239287302637],
              [15.863820726303576, -2.491651721440536],
              [15.850448615907201, -2.5031838793685752],
              [15.8467307996346, -2.4996153959749754],
              [15.840481729656133, -2.503034672327591],
              [15.84224939167898, -2.50747573870778],
              [15.841135340716933, -2.5103382193582098],
              [15.83743537394405, -2.5089383870361353],
              [15.834977680759025, -2.510610948040571],
              [15.833638775286222, -2.516855659921818],
              [15.827383578278615, -2.5182511391979054],
              [15.82296564129521, -2.5117647648531483],
              [15.817761160845707, -2.5185532383136056],
              [15.812785364066618, -2.515778966095539],
              [15.810550443910707, -2.5176008942190014],
              [15.813594851684622, -2.521686938075122],
              [15.808304355230009, -2.525101610153654],
              [15.80535883135022, -2.525307366550722],
              [15.798454681993466, -2.528364369775348],
              [15.795478225333824, -2.530950704777164],
              [15.791108641699408, -2.5320984880837827],
              [15.791844949749315, -2.5347892763521247],
              [15.78439631457382, -2.5365837066246937],
              [15.774060900349784, -2.5360207555762164],
              [15.77032666246498, -2.534716199678535],
              [15.765934047800975, -2.5299386808912807],
              [15.768862506690057, -2.524916488139848],
              [15.770120279559222, -2.517094519655798],
              [15.76545931817913, -2.4999320984454525],
              [15.762311387145305, -2.4948656253397186],
              [15.757346859418973, -2.489501737465593],
              [15.749488191429615, -2.483408454304452],
              [15.743659315672444, -2.4694246858208673],
              [15.742429408260616, -2.4613463749847675],
              [15.740123555783004, -2.458311997993011],
              [15.736476316251965, -2.4578849871987973],
              [15.731763155221314, -2.4529841240654924],
              [15.729380430876592, -2.4584661891363813],
              [15.725814794503798, -2.453677708050221],
              [15.720574098021105, -2.4513124871930376],
              [15.715257055573765, -2.4554040561005896],
              [15.713713736349312, -2.4511175730079193],
              [15.718367803809157, -2.4498287877041944],
              [15.709488222679399, -2.4395896411092584],
              [15.706914372556643, -2.4429617311084857],
              [15.703995582333492, -2.4416545610326215],
              [15.703559261412332, -2.437660630747437],
              [15.705633158404899, -2.434525592291219],
              [15.703537964559068, -2.432235233428538],
              [15.70547140717629, -2.4286422689436717],
              [15.71218947718166, -2.428181723000278],
              [15.719796096144771, -2.425332726400183],
              [15.720149444032177, -2.4220277889282578],
              [15.728347542974477, -2.4192151452879567],
              [15.73458857992552, -2.423096791877945],
              [15.741565127418898, -2.4208458757552203],
              [15.743833190043823, -2.41781725511001],
              [15.746755320164809, -2.4104072576938673],
              [15.754032852903883, -2.4110830089342263],
              [15.756490930071372, -2.41241741508767],
              [15.761247273026276, -2.410575538580562],
              [15.759814749665837, -2.40473246359751],
              [15.76305656743409, -2.3988592057121276],
              [15.768360565428827, -2.397611378597171]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.65896713293165, "lat": 34.83573973715742 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37031"],
        "coty_name": ["Carteret"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carteret County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01026337"
      },
      "bbox": [
        15.703537964559068, -2.5646227182902477, 16.546418331277877,
        -1.9720362508463802
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.192677104080161, -1.645486926220728],
            [13.178574402934377, -1.5473034450926006],
            [13.17152758662376, -1.496792316268348],
            [13.170032807737385, -1.4823012891866916],
            [13.169038648143077, -1.4800074267742434],
            [13.15750903965697, -1.399259358671366],
            [13.246291098034451, -1.3875001920564487],
            [13.279662287346826, -1.3833387882386057],
            [13.313279214892033, -1.3794579976364891],
            [13.422873770665158, -1.3653513951365215],
            [13.465359357730376, -1.3591083738228067],
            [13.556005823012141, -1.3467183569639107],
            [13.559465853140434, -1.3727720827805872],
            [13.564159599067706, -1.405785253893173],
            [13.566526517017271, -1.4254491640789713],
            [13.573678249760972, -1.4731980058642524],
            [13.578336727967187, -1.5055790009651915],
            [13.591700389534031, -1.5847146903496396],
            [13.608079896793972, -1.6875158848213612],
            [13.539298051186087, -1.695908225591043],
            [13.451264072964294, -1.706634840456085],
            [13.33897470035156, -1.7195709768579948],
            [13.290098139883863, -1.7253335916438057],
            [13.289483749676435, -1.7255734365982098],
            [13.204993591609588, -1.7355543414399965],
            [13.201465989265749, -1.7108144844518303],
            [13.192677104080161, -1.645486926220728]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.78892780297713,
          "lat": 36.079488342839575
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37081"],
        "coty_name": ["Guilford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Guilford County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01008558"
      },
      "bbox": [
        13.15750903965697, -1.7355543414399965, 13.608079896793972,
        -1.3467183569639107
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.098931176909012, -3.0212009220031493],
            [15.12751788918095, -3.010546841997833],
            [15.125669003701411, -3.0049493886341705],
            [15.130154386943422, -2.992984409431962],
            [15.135500155021766, -2.9894028621314126],
            [15.133812093893988, -2.9849757290879593],
            [15.127282255549895, -2.983832587652977],
            [15.125766333859417, -2.9807939523552425],
            [15.12582249176645, -2.9747656909823927],
            [15.129106501748081, -2.9730367139171388],
            [15.134969351598142, -2.9727176862189966],
            [15.13764096990638, -2.9674659080767274],
            [15.143292929708096, -2.960606966110594],
            [15.146350659148998, -2.961111997176267],
            [15.146839971483526, -2.971097233310866],
            [15.155543569022846, -2.9765939510403587],
            [15.156934173175655, -2.96919275103358],
            [15.163642416596451, -2.9695938397605675],
            [15.164041472068, -2.975060685601132],
            [15.166879349232799, -2.9794030089530565],
            [15.171492832313929, -2.979107086267099],
            [15.174638111445551, -2.9761736943436867],
            [15.179202903413543, -2.9677351195757717],
            [15.180377538084667, -2.961440589403703],
            [15.182950309798432, -2.9597555865678227],
            [15.189363052958754, -2.959289622357538],
            [15.194166028550574, -2.9555941743368908],
            [15.195704411464883, -2.958155135911782],
            [15.19689457863356, -2.966182586385214],
            [15.202871680523998, -2.9685438253503733],
            [15.209924523254557, -2.9661394969034838],
            [15.21304214517279, -2.963925055686912],
            [15.218963209439568, -2.955177557845673],
            [15.229213967368562, -2.9464375082914946],
            [15.239274482623427, -2.9439169259804268],
            [15.247767789064445, -2.936803929085288],
            [15.254374590326362, -2.9322856310690426],
            [15.259300014418002, -2.935568870469258],
            [15.260593489024842, -2.9381404770502457],
            [15.265879508412054, -2.937681781090375],
            [15.27157793585652, -2.942355927198679],
            [15.268816628936806, -2.9477864520352335],
            [15.268877623511624, -2.9505728344115405],
            [15.26497153513582, -2.9531536640734255],
            [15.266458351261143, -2.9571334660099926],
            [15.269950050423374, -2.961402049395519],
            [15.327544568216313, -3.0054001279979836],
            [15.33796719956791, -3.0075176383080455],
            [15.337831847722722, -3.012044249429105],
            [15.340314691157717, -3.0146862242368613],
            [15.345639545363529, -3.012014097093495],
            [15.351860113581075, -3.012339952071287],
            [15.359000369617544, -3.004283118422527],
            [15.362335987880797, -3.0053462715264576],
            [15.360723843546085, -3.0085376267479633],
            [15.3434476882209, -3.0347955588960183],
            [15.329393831785678, -3.0651082503762743],
            [15.322652920610036, -3.0790456740464567],
            [15.292554187641107, -3.156693820443135],
            [15.287746247608434, -3.1733646320603603],
            [15.283322378400056, -3.196567727527322],
            [15.27420035726738, -3.2416753042303443],
            [15.269378684642213, -3.2433075708554315],
            [15.267940993183812, -3.2461635649377505],
            [15.272503512263814, -3.25127312753926],
            [15.271031882355912, -3.2659428845675325],
            [15.267297572191902, -3.293088701229621],
            [15.259586994987128, -3.359287994575682],
            [15.25699634127783, -3.364048089270405],
            [15.254254432569304, -3.387183057225073],
            [15.250129609616232, -3.404616375146921],
            [15.233045981626095, -3.364846270996295],
            [15.236603916092509, -3.354163712561922],
            [15.23698694821429, -3.350379283129319],
            [15.236014571020455, -3.338347374432682],
            [15.236748206299657, -3.3351274504909045],
            [15.236062049357143, -3.3173202124585446],
            [15.234290840564238, -3.2979177331340046],
            [15.230409875566167, -3.2756108051023505],
            [15.222710796376289, -3.249975216761701],
            [15.213537115163202, -3.213323554967456],
            [15.203527904833328, -3.1984118074442938],
            [15.194321378287558, -3.1855559554570854],
            [15.1905353968715, -3.1746439513472566],
            [15.186356814699908, -3.1663634233094133],
            [15.184445407046438, -3.155561579855002],
            [15.18441124438693, -3.1475573587899177],
            [15.182957032561648, -3.1429148698296374],
            [15.178716264231994, -3.137435872202193],
            [15.176425647250255, -3.106048629032911],
            [15.169263962772837, -3.1000535011402857],
            [15.164235470286256, -3.09863116064028],
            [15.16701005734138, -3.0944017968773996],
            [15.164057409635927, -3.0903483933255216],
            [15.15862851259765, -3.0942503094412763],
            [15.153682294349869, -3.084209891420944],
            [15.148392210748163, -3.0862379720431368],
            [15.145125135219187, -3.083583574697918],
            [15.145113428482956, -3.0774373399361243],
            [15.141839330040543, -3.075605005305038],
            [15.133776896200494, -3.0762263110838575],
            [15.134111977378, -3.071448382618031],
            [15.140112504718696, -3.068352491622571],
            [15.140395304519947, -3.0646091613663384],
            [15.134810436748081, -3.0629116848406315],
            [15.128868996104195, -3.0680444043568436],
            [15.127833557663113, -3.061787665682912],
            [15.124611520895176, -3.0589200197790984],
            [15.119511118643594, -3.060612998716488],
            [15.116631255315554, -3.0577821100273668],
            [15.117108141662392, -3.047649379319483],
            [15.11569617182284, -3.0428980640522343],
            [15.116194118271816, -3.0375764520993442],
            [15.120224726115449, -3.033673602416162],
            [15.120311385105097, -3.0296725598773566],
            [15.116245188745772, -3.026777594138829],
            [15.113192819976257, -3.02742704521981],
            [15.107178863945478, -3.033725538257201],
            [15.103209496201297, -3.032795424174508],
            [15.103625516606337, -3.0273050969122974],
            [15.102321478181214, -3.0230780758253886],
            [15.098931176909012, -3.0212009220031493]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.88471607170344, "lat": 34.23286879392201 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37129"],
        "coty_name": ["New Hanover"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["New Hanover County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01026329"
      },
      "bbox": [
        15.098931176909012, -3.404616375146921, 15.362335987880797,
        -2.9322856310690426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.38144924104867, -2.5170132214502967],
            [10.389443781431213, -2.516818091974628],
            [10.395906258428282, -2.5184995754460435],
            [10.399856928678119, -2.517729367749763],
            [10.405968780727644, -2.513862444350982],
            [10.408223934217306, -2.5147915849664053],
            [10.41894755982884, -2.5071493581706803],
            [10.423369675856723, -2.5010548711995155],
            [10.429152628726388, -2.5015405255297596],
            [10.435912005576592, -2.506058987206739],
            [10.441843320828058, -2.5113291422090342],
            [10.442779564167182, -2.514201427399139],
            [10.447063446714942, -2.514994401584211],
            [10.454345234214278, -2.5111567818312808],
            [10.459345580030538, -2.51001672749552],
            [10.47069125483841, -2.5101990512087315],
            [10.47957730873218, -2.507650430242504],
            [10.485034553652467, -2.5079827370835672],
            [10.495861282744057, -2.5056054250797692],
            [10.498543989221801, -2.5080282620450713],
            [10.513898706137965, -2.505888508146875],
            [10.518729625246513, -2.5012984640271165],
            [10.52344368935588, -2.4993153931883105],
            [10.527583482982, -2.48758418619537],
            [10.526591529973139, -2.483532121880161],
            [10.531274571021891, -2.4796214043601004],
            [10.531833231621137, -2.475732049608605],
            [10.538466527843513, -2.472518263167243],
            [10.543300706992685, -2.4663401683011172],
            [10.548747731100507, -2.4548185882120555],
            [10.549396876853395, -2.451540200069798],
            [10.560430018289708, -2.4519684489257347],
            [10.568827803548892, -2.449585876812618],
            [10.569487259034576, -2.447178393882703],
            [10.581858972049782, -2.4375521482035336],
            [10.587215527099179, -2.4354075081554223],
            [10.59007189007367, -2.4326112811358898],
            [10.59207670946411, -2.4237100874251305],
            [10.598690153539081, -2.4216877050919954],
            [10.603345359513954, -2.41676399849872],
            [10.608778475914077, -2.416248937997763],
            [10.61584038782991, -2.4038206933298976],
            [10.615753746504199, -2.3991401520368876],
            [10.618228233321984, -2.39349353525117],
            [10.628872025968137, -2.388797823408807],
            [10.630719716627894, -2.3861121566972137],
            [10.642139578987175, -2.3872835257372653],
            [10.649873364636736, -2.3943900969455676],
            [10.651730583863182, -2.3945040398780124],
            [10.661930369104292, -2.389779709014919],
            [10.665519649096826, -2.3797544930041674],
            [10.666051015051885, -2.3721775885545324],
            [10.67930359923362, -2.3633072924228724],
            [10.680450502678703, -2.359157847174777],
            [10.686344882088646, -2.354536749396878],
            [10.689915033231596, -2.3470399553519403],
            [10.695828541919836, -2.347993565086984],
            [10.702495414730993, -2.3460950804358953],
            [10.722704554840291, -2.3464020498992424],
            [10.727615013359008, -2.351867897001465],
            [10.730377362884077, -2.3565294005239648],
            [10.736066685277216, -2.356060567259865],
            [10.750220119066531, -2.364136546654743],
            [10.748666858276447, -2.369332498071858],
            [10.743034831201658, -2.3763170140410765],
            [10.743113811592604, -2.38108608526123],
            [10.738619997080292, -2.387066324438058],
            [10.739990937652475, -2.394503977580997],
            [10.74703553453062, -2.3962268492928978],
            [10.751716755856693, -2.394888612322938],
            [10.757011378467354, -2.3982710666484968],
            [10.761232836970763, -2.402617756867407],
            [10.762528398813707, -2.4067446030812483],
            [10.759678452718383, -2.411719481687761],
            [10.75941322371934, -2.416363128530156],
            [10.764772681540563, -2.4219817151765466],
            [10.760426340129879, -2.4299418278334213],
            [10.75908000226482, -2.4371785641515866],
            [10.761251159612685, -2.4392312768866744],
            [10.760713023613935, -2.443808958533911],
            [10.76366625918281, -2.4505288933469234],
            [10.769689541618645, -2.4535525312431754],
            [10.776556317986417, -2.454728751314691],
            [10.779110917545774, -2.4583557014385464],
            [10.782099736966043, -2.4655798975362964],
            [10.781354212625105, -2.4683414162748556],
            [10.784602346545833, -2.4706329042438244],
            [10.785411627939952, -2.474212818496562],
            [10.78865002213128, -2.4782776498521457],
            [10.786638160396828, -2.4839273792447014],
            [10.782986363010423, -2.4878921779795737],
            [10.78349662633219, -2.4943070830763228],
            [10.778634498741702, -2.4959658729389145],
            [10.778688892392063, -2.5124339412817727],
            [10.774017850973705, -2.515832218847178],
            [10.769817590563056, -2.5210756525954814],
            [10.761800048795248, -2.5171387542111296],
            [10.750066169877293, -2.518843721449558],
            [10.744239045955737, -2.512676195916067],
            [10.742001758002768, -2.5141992327083083],
            [10.735382668366228, -2.5143205163411366],
            [10.731552395115894, -2.5171741783678647],
            [10.72845459716318, -2.516399248461656],
            [10.724809096981666, -2.5224162991785906],
            [10.714812372954212, -2.5293187766893372],
            [10.709546026630159, -2.529027525196957],
            [10.707818607140636, -2.5331658129114865],
            [10.708494078755784, -2.537302854405318],
            [10.702072532048776, -2.5404557871910876],
            [10.70050987224355, -2.5445837796550426],
            [10.695777992925832, -2.546693005836696],
            [10.692749016213936, -2.553684559221733],
            [10.6941315229056, -2.5571955681430008],
            [10.68965519682251, -2.5637253967200406],
            [10.685341562891272, -2.563077411272638],
            [10.679809499385376, -2.569594690186285],
            [10.676499837381877, -2.569303624585838],
            [10.675358321497876, -2.5769863784854303],
            [10.67085892257831, -2.584359668431188],
            [10.665034241139866, -2.581762250775732],
            [10.659590605848958, -2.5812296073596297],
            [10.655609512274209, -2.576694446882409],
            [10.648279066665731, -2.578951888191947],
            [10.643769224036369, -2.585109455099695],
            [10.64138344164965, -2.6200401036316014],
            [10.639706229371676, -2.6277967670090834],
            [10.641571936753289, -2.631311698417272],
            [10.641818077985926, -2.6366617374123327],
            [10.644114508736553, -2.642289888023354],
            [10.648675706751355, -2.643545029108231],
            [10.651094263773349, -2.6419110027212827],
            [10.655189703130295, -2.6473755805016372],
            [10.654787774515322, -2.6516317444872803],
            [10.66171073074352, -2.6546140195598396],
            [10.65920349537608, -2.6633959504888707],
            [10.666752628498664, -2.66949897722185],
            [10.666654965585032, -2.675572001457479],
            [10.67068313042944, -2.6823523575688206],
            [10.670759903647923, -2.6881995959795],
            [10.6723145050811, -2.6928494432877517],
            [10.675332820322485, -2.6971669681183785],
            [10.672241023990127, -2.704951270852443],
            [10.67316087684601, -2.7080978812470398],
            [10.670476957769134, -2.7142707064633282],
            [10.671833964984655, -2.7207555508429158],
            [10.66637325220525, -2.7239883057739362],
            [10.657682446967511, -2.7240645854056402],
            [10.652769454158125, -2.728388131663471],
            [10.645477625220765, -2.726322114392104],
            [10.64073651344369, -2.7304896727520664],
            [10.63488620373505, -2.729975861647299],
            [10.631053016362191, -2.731764779422238],
            [10.62395803698097, -2.730592596274777],
            [10.620822701183343, -2.7337600288474433],
            [10.616602226957525, -2.742832588913156],
            [10.611307852334365, -2.7407252126645565],
            [10.607628134371241, -2.742820733192394],
            [10.6016140986295, -2.7368144213273204],
            [10.597939538615313, -2.7365951617565654],
            [10.594376814797167, -2.7403111176652852],
            [10.592547146747798, -2.7453418759532386],
            [10.586752187635497, -2.746653823177007],
            [10.58391910039321, -2.7495373722062393],
            [10.582367270196862, -2.7613381773766257],
            [10.578135648743928, -2.7629888172337314],
            [10.576684305293039, -2.7659784470995334],
            [10.57067611731701, -2.76837020271774],
            [10.565001363796162, -2.765421715372513],
            [10.554426511927332, -2.762242768049343],
            [10.551387419791705, -2.768461489854963],
            [10.549125116229055, -2.769292067009547],
            [10.483934907830776, -2.7858471719663784],
            [10.410795392126786, -2.8042381928956472],
            [10.405454067257272, -2.8083753601949453],
            [10.403519306444661, -2.8029045800096393],
            [10.395494473646437, -2.7944930463330326],
            [10.390990134226012, -2.79181619194992],
            [10.390664067275596, -2.7822675276636013],
            [10.396037359376992, -2.7641934747733776],
            [10.400435512266371, -2.759409890664427],
            [10.407621401128104, -2.757716739792943],
            [10.407906013568477, -2.7558809866318024],
            [10.413962751530201, -2.750119082624889],
            [10.420817772087025, -2.7479666870249555],
            [10.426047021994831, -2.743824754518357],
            [10.430624695720473, -2.7447867942275823],
            [10.438163804300315, -2.738742494080031],
            [10.444768370182986, -2.736069648380446],
            [10.447089936216457, -2.7321346157083126],
            [10.44872300783601, -2.7235759169358467],
            [10.450770426781729, -2.72132804220033],
            [10.457094997008394, -2.709013810190925],
            [10.459376529158241, -2.708031773149636],
            [10.462425239185944, -2.7020328497978046],
            [10.461731944927816, -2.696236858640429],
            [10.462693944052168, -2.685927368369502],
            [10.464775468739145, -2.678224264966628],
            [10.465051152201585, -2.6712366939898065],
            [10.46687301257713, -2.6679838270186047],
            [10.46407781980612, -2.6644180282468124],
            [10.46333177893271, -2.659680651628933],
            [10.460328694910801, -2.659382470914846],
            [10.462318658704415, -2.6531476296209395],
            [10.46086211253109, -2.6431557034217104],
            [10.45852702953261, -2.643107335517664],
            [10.453506289306855, -2.6474891792149773],
            [10.450400887380614, -2.647802780899631],
            [10.442392398341507, -2.653562276536852],
            [10.438654524120157, -2.65126058656004],
            [10.434319853600673, -2.6453319354997027],
            [10.429952227821817, -2.6450801004164077],
            [10.424367311220415, -2.6415852104818787],
            [10.41393622931343, -2.640525207616804],
            [10.41276847086309, -2.6450370906857508],
            [10.413778298172147, -2.652168391325968],
            [10.412108892281504, -2.6569265701213807],
            [10.406364931259182, -2.6571203235140493],
            [10.40343673763925, -2.653282383059633],
            [10.397777584757767, -2.6549636020292384],
            [10.393408671612338, -2.651152574562357],
            [10.385771141348991, -2.6509594323973644],
            [10.382063753256451, -2.6494155452273653],
            [10.368430975541347, -2.648180687173347],
            [10.362243182485395, -2.646912589756493],
            [10.358012070723976, -2.649202109367228],
            [10.351416041950719, -2.6491691437297593],
            [10.341462608501217, -2.645949950095956],
            [10.338016544331008, -2.6469007348491265],
            [10.329634560848323, -2.6520425061709356],
            [10.32309663070637, -2.6541184443685624],
            [10.313919985668607, -2.653275901554113],
            [10.30861481941957, -2.6541962983683582],
            [10.297848206074644, -2.6492211333473494],
            [10.29053996651921, -2.647446763146912],
            [10.286225745350464, -2.6446089958955903],
            [10.28291282037715, -2.6481598263130155],
            [10.283804501664653, -2.6507459265846034],
            [10.282624700929027, -2.6561790543474157],
            [10.280314090758779, -2.6571880852019714],
            [10.27540779897136, -2.655755160488088],
            [10.270221867233571, -2.6517230340289397],
            [10.26205311686995, -2.6525991842723156],
            [10.25816577128369, -2.6553344905950484],
            [10.250967125456992, -2.651821032926743],
            [10.245643732868754, -2.6537412712835633],
            [10.235831375932387, -2.6586501655001937],
            [10.233284415759584, -2.656320687845168],
            [10.232161535963716, -2.652123886148625],
            [10.226897832945184, -2.647499607369558],
            [10.22033497284841, -2.645525752427679],
            [10.215582622495193, -2.6461027034907016],
            [10.209760431523197, -2.6486319375480516],
            [10.198498137801835, -2.6449345781180833],
            [10.19404630854007, -2.6469867214740255],
            [10.184210381176706, -2.663602417597421],
            [10.175854256501157, -2.666025189817304],
            [10.171665547166759, -2.664335928465796],
            [10.163536003072787, -2.6553667975201143],
            [10.166265835468444, -2.65448178107704],
            [10.170892347044402, -2.6499097791224755],
            [10.174853801108107, -2.642875005048706],
            [10.18425492847796, -2.639264973454234],
            [10.190770300421741, -2.638709692187078],
            [10.194486829447698, -2.6357802308650466],
            [10.196022993146672, -2.631838733278604],
            [10.197750864792193, -2.62212157696527],
            [10.200769034054213, -2.61973810721292],
            [10.200177964009123, -2.6141976337851576],
            [10.204068752283202, -2.6082993647786634],
            [10.206789461643652, -2.6067105893124167],
            [10.211801856974127, -2.5962479142076567],
            [10.21259336596155, -2.5916469658082257],
            [10.220032554616342, -2.5866667869009468],
            [10.230638446758968, -2.584589291137195],
            [10.239580033875452, -2.5860755501443276],
            [10.25215786649592, -2.578862708702984],
            [10.257322817736023, -2.5791505586526773],
            [10.268604221794021, -2.567046352508933],
            [10.273554885433354, -2.5590115727784988],
            [10.285331971170669, -2.5517886001714345],
            [10.290256362665932, -2.5479136011065773],
            [10.294967670749209, -2.5401109629711947],
            [10.295449591745244, -2.5353193777034857],
            [10.301225655221275, -2.535162131852273],
            [10.307105750568573, -2.5323015303104435],
            [10.313039681717376, -2.534031805552639],
            [10.323853844390362, -2.5282508799022048],
            [10.326329550878853, -2.5302738680898886],
            [10.33408106200131, -2.530564389580811],
            [10.346214585375279, -2.522220026833839],
            [10.364596225591603, -2.519509069492691],
            [10.37071231936398, -2.5172477393893233],
            [10.37342196081592, -2.518231481165328],
            [10.38144924104867, -2.5170132214502967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.49278417709485,
          "lat": 35.486831688774785
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37173"],
        "coty_name": ["Swain"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Swain County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "01008588"
      },
      "bbox": [
        10.163536003072787, -2.8083753601949453, 10.78865002213128,
        -2.3460950804358953
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.769215300758395, -1.4626583565658653],
            [15.779610174430857, -1.4494969941276092],
            [15.777352051243794, -1.447585179810017],
            [15.777413792764976, -1.4437278447976285],
            [15.781952871835442, -1.4392671862595816],
            [15.781530447742787, -1.4345459962758742],
            [15.786359139920643, -1.431283936859833],
            [15.784122992973948, -1.4260614793996993],
            [15.78444128864875, -1.4197676858513975],
            [15.786187441556116, -1.4165211053364444],
            [15.78983640606146, -1.4149723524809446],
            [15.790812671839273, -1.4081163228035856],
            [15.793280967513295, -1.3997241748709977],
            [15.790546560938326, -1.394487372117261],
            [15.791655429212677, -1.391267856785097],
            [15.79524431997622, -1.3901973299209145],
            [15.797856316656173, -1.3848007345436848],
            [15.79614891887096, -1.379296002089465],
            [15.791480204951712, -1.3760865498112769],
            [15.787182998154526, -1.3711964023810184],
            [15.787969430674105, -1.3625940784204502],
            [15.792478456644327, -1.3550540281941308],
            [15.79653097630181, -1.3529570982015395],
            [15.799113302847097, -1.3466751314908099],
            [15.796356128071917, -1.3449116402279195],
            [15.795631239246127, -1.3409201244755542],
            [15.79114672171671, -1.3370573102179044],
            [15.792815282981019, -1.3333446921795327],
            [15.793298542210277, -1.3246441095724735],
            [15.796278248812541, -1.3190044083481713],
            [15.795566139012626, -1.3165756197394645],
            [15.800414029928755, -1.3109666208955422],
            [15.805315176580269, -1.3094268536610572],
            [15.8081269422906, -1.3054727876642946],
            [15.813716179422423, -1.3023554031287103],
            [15.818866702775377, -1.297148134779112],
            [15.82387840912863, -1.2879229449984284],
            [15.826573071338986, -1.2774407368153011],
            [15.827068602528174, -1.266352306111086],
            [15.828825125299941, -1.2587013804860303],
            [15.827958010219497, -1.2528248124123083],
            [15.82942137083121, -1.247154033120151],
            [15.83531596565967, -1.2402553761919772],
            [15.842880240667496, -1.238450487866901],
            [15.84602720765847, -1.2265253995482506],
            [15.845467110185536, -1.2179039938369325],
            [15.853352188415377, -1.2185583553494421],
            [15.857668151015204, -1.2215189039914474],
            [15.87164309355351, -1.2231984317690376],
            [15.877895515323255, -1.2195285645535365],
            [15.88851975366635, -1.2151974579675124],
            [15.912415396784747, -1.2110468588653984],
            [15.916087795738692, -1.2060264821155393],
            [15.928848141556879, -1.2016828087510614],
            [15.939146826311921, -1.1990577311371962],
            [15.955324888638078, -1.1975590986760027],
            [15.974363676220971, -1.189604034404392],
            [15.989713501772622, -1.1804442851067565],
            [16.00131818735542, -1.1677747869664952],
            [16.006165417893104, -1.1683404993379678],
            [16.01350802445722, -1.1648322416699832],
            [16.020530439306714, -1.1592129686542307],
            [16.024473694584934, -1.1546235139002496],
            [16.04990063495667, -1.1394912678397415],
            [16.062512021366206, -1.1326033026224178],
            [16.06780241254313, -1.1309021413158589],
            [16.073994352468734, -1.1325809773037099],
            [16.082114395522247, -1.1388135246670674],
            [16.08318862806673, -1.1439432985161617],
            [16.09267576696514, -1.1532033272884765],
            [16.08761067901562, -1.15947933442332],
            [16.09144527591891, -1.1638341863908845],
            [16.095348321636646, -1.164801390328541],
            [16.100245877647122, -1.1732982553264732],
            [16.10375820597945, -1.1721749571195361],
            [16.10353064904877, -1.1772101324800146],
            [16.097087505958257, -1.194285022668016],
            [16.105705812498044, -1.2083961404304402],
            [16.11173258446383, -1.2236216931570905],
            [16.120724252213854, -1.2296373263225207],
            [16.12891961355956, -1.242629236028556],
            [16.103503546883548, -1.3252673426230586],
            [16.121539496399205, -1.4129303690140702],
            [16.021232914490987, -1.4267547331956016],
            [16.009972958408532, -1.428436108203487],
            [15.93753535310836, -1.4432977122172925],
            [15.876282525979835, -1.4557146616398975],
            [15.774180655541855, -1.476329395709701],
            [15.769215300758395, -1.4626583565658653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.57751170680069,
          "lat": 35.822515735842266
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37187"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "01026331"
      },
      "bbox": [
        15.769215300758395, -1.476329395709701, 16.12891961355956,
        -1.1309021413158589
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.041533109103222, 0.08503126734830747],
            [4.054226062745412, 0.08192192368284432],
            [4.062864984277343, 0.08414464809719431],
            [4.072958824654478, 0.09459938581247723],
            [4.079814027650215, 0.09605103366876894],
            [4.087213958202511, 0.09246935125807886],
            [4.102310318011117, 0.0777657480407238],
            [4.115465868448584, 0.0681162636122104],
            [4.127618016619699, 0.05619666446643929],
            [4.1454981380276905, 0.045328187288943535],
            [4.149108891793145, 0.041843408338980856],
            [4.153693093450849, 0.03361949905483808],
            [4.154834408852664, 0.02727707722966338],
            [4.153667230337656, 0.020693259534512388],
            [4.155591946396661, 0.012067854602223552],
            [4.163662722879185, 0.00856633617437917],
            [4.174189374487339, 0.0060682736843627955],
            [4.189975630152762, -0.000017861676246853404],
            [4.213703166347684, -0.003060966241126263],
            [4.229442868602196, -0.00772881238904256],
            [4.235182562056691, -0.008015759470174792],
            [4.24454347796259, -0.005611509003400033],
            [4.257238378318451, 0.0005797348378846955],
            [4.271540360652153, 0.005628065801314609],
            [4.2780308819892445, 0.0065259936033733685],
            [4.2881554260388945, 0.005403309269392269],
            [4.295544102962859, 0.0023636849525569604],
            [4.303099510025026, -0.00361600392297038],
            [4.307152836642786, -0.008546711219405017],
            [4.31663022264495, -0.02824293852212712],
            [4.322670400962734, -0.03551674934863426],
            [4.329679419294757, -0.04013443054992458],
            [4.3400460712895645, -0.04561095060609617],
            [4.358040814056156, -0.05019498995038051],
            [4.36206619955295, -0.05211219593963795],
            [4.3704475981565825, -0.05771822819859596],
            [4.375475165161386, -0.060101236924493845],
            [4.387183845123363, -0.0634442774677621],
            [4.394621995508248, -0.06393986862406226],
            [4.399810855886792, -0.06306463209252151],
            [4.408779951999603, -0.059760574186326895],
            [4.4178779774358645, -0.054554415582649826],
            [4.432250944216618, -0.04193728512252684],
            [4.449910224955781, -0.03252357314927363],
            [4.460327855197378, -0.02434199497951192],
            [4.465136897573529, -0.0185143055929234],
            [4.477122631658531, -0.007482973733181534],
            [4.4902005708383435, -0.0021165056199866617],
            [4.501316940602097, 0.0003200212642783819],
            [4.507047988459051, 0.00332325461210135],
            [4.514585975135386, 0.011153372569784787],
            [4.519449395900632, 0.02024330028519294],
            [4.523061613312826, 0.03503689761025204],
            [4.527879751813376, 0.041155817841848456],
            [4.528938432054593, 0.0449289288845239],
            [4.53646238486523, 0.05013851342754872],
            [4.537540359882771, 0.0320636037458666],
            [4.539737767935149, -0.013090902961500818],
            [4.540442130660828, -0.048105155468652655],
            [4.541693591368919, -0.08606458579506084],
            [4.54313555397091, -0.1238761178893973],
            [4.5448753088605445, -0.1753294116438163],
            [4.543416969205432, -0.1921417661708842],
            [4.535709278848681, -0.2626545823975072],
            [4.527213394261322, -0.3440313526056575],
            [4.5272093756339755, -0.3482730633302067],
            [4.5236214777139745, -0.39068700925434047],
            [4.4932945452373225, -0.3922003145567797],
            [4.462861285423549, -0.3930000141723415],
            [4.442252058132696, -0.394387165855018],
            [4.37590481254762, -0.39724578637972563],
            [4.375844273515709, -0.39605880177595226],
            [4.360855378483227, -0.3992700103165256],
            [4.345988815699837, -0.4002612344266397],
            [4.278395248244213, -0.4037891449368927],
            [4.255557567233058, -0.4048032645133337],
            [4.22115568506534, -0.40674121173361044],
            [4.15427800701374, -0.4100359155869997],
            [4.126548240407777, -0.4115646932521084],
            [4.067106661096076, -0.41446882576867944],
            [4.06693987687601, -0.4086860070182197],
            [4.065966028719548, -0.375249474428184],
            [4.064269273564959, -0.33466609367455596],
            [4.064385486808833, -0.33251812953693094],
            [4.062538339498208, -0.2858336797684066],
            [4.061295094214186, -0.2858731095603118],
            [4.057102392990247, -0.19668195237675076],
            [4.056370686713843, -0.1963324604353015],
            [4.053521566065704, -0.13583675322954664],
            [4.051956715481801, -0.10649163085123879],
            [4.051395177404626, -0.10652710622285576],
            [4.049358547350701, -0.061856588079109674],
            [4.048991941492534, -0.046137768220633],
            [4.045448050051533, 0.010129225939773296],
            [4.043789078076928, 0.051023082531764324],
            [4.042680618512741, 0.07379910780547812],
            [4.041533109103222, 0.08503126734830747]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.07497875577991, "lat": 38.41114634970828 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29071"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00758490"
      },
      "bbox": [
        4.041533109103222, -0.41446882576867944, 4.5448753088605445,
        0.09605103366876894
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.655237754655143, -0.8579723003835494],
            [4.654867000946539, -0.8425848045992937],
            [4.653003134508557, -0.7991807051046638],
            [4.650004376805078, -0.7397981151663533],
            [4.647715966317799, -0.6865640967247992],
            [4.646574621815381, -0.655264053124154],
            [4.6436404620883875, -0.5983618617017217],
            [4.640770896923962, -0.5374362341840947],
            [4.639817196067095, -0.5132258082303274],
            [4.645747914325461, -0.5154071167477425],
            [4.6513401523752345, -0.5130922396276649],
            [4.6556962964110715, -0.5161396570162449],
            [4.658894938054412, -0.5155133166261131],
            [4.661834203063511, -0.5185173397928107],
            [4.661043337436639, -0.5272319924078522],
            [4.657321258484721, -0.5318042168623562],
            [4.655887998814613, -0.5370809988036553],
            [4.656928794557332, -0.5461448592932557],
            [4.6562607448099005, -0.5488993241579492],
            [4.6608860044711165, -0.5607183542061541],
            [4.660920040868054, -0.5659069261805615],
            [4.664414508634327, -0.5720390755217484],
            [4.661688277735999, -0.5757619231268841],
            [4.655190719465234, -0.5768693773740097],
            [4.653000716790977, -0.5820694914841075],
            [4.688113042198471, -0.5843670101474376],
            [4.773209600602966, -0.5527973321474832],
            [4.815391800123718, -0.5373422570660455],
            [4.8161395118107055, -0.5376887318205796],
            [4.819271820678571, -0.540175880403486],
            [4.892312822353591, -0.5944548668378432],
            [4.8292954421240735, -0.6635454805421769],
            [4.79800618253379, -0.697719602285173],
            [4.79218867401403, -0.7043618395770744],
            [4.824661958542362, -0.732666740990096],
            [4.858453689153879, -0.7625799690950735],
            [4.8837722426731744, -0.7853743809264517],
            [4.909090800910068, -0.8093616241309629],
            [4.950508317919933, -0.84965903754179],
            [4.957941134842827, -0.8573832675610894],
            [5.007100999676493, -0.9032336388765736],
            [5.041236293672012, -0.8706525387604345],
            [5.0771499245210405, -0.8971892644582741],
            [5.050644385620672, -0.9288958161567302],
            [4.993772926393851, -0.9328669325666621],
            [4.965451397683166, -0.9341610859561146],
            [4.92195788814232, -0.9364885918832865],
            [4.912959143968745, -0.9371536725657997],
            [4.810434480176214, -0.9421696908573599],
            [4.760981075827108, -0.9451300138661215],
            [4.746629799949061, -0.9449703084736917],
            [4.746557659848697, -0.9435808215314099],
            [4.7322584047021365, -0.946465572666767],
            [4.703464311013654, -0.9483766083135197],
            [4.658325145781638, -0.950841533995828],
            [4.657600241621437, -0.93416792781376],
            [4.655237754655143, -0.8579723003835494]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.47228082767863,
          "lat": 37.810259502094596
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29187"],
        "coty_name": ["St. Francois"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Francois County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "00758548"
      },
      "bbox": [
        4.639817196067095, -0.950841533995828, 5.0771499245210405,
        -0.5130922396276649
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.53646238486523, 0.05013851342754872],
            [4.552582651848831, 0.056535189592963817],
            [4.556495977998275, 0.05929371355863835],
            [4.557739998578641, 0.06236468032077901],
            [4.557015818214154, 0.06768223988071939],
            [4.561825943436607, 0.07285658258028362],
            [4.571643431863935, 0.0758963764395505],
            [4.575969742721033, 0.07893905583729453],
            [4.577224999402514, 0.08323878650534683],
            [4.5786764390790715, 0.09586973335566563],
            [4.5891392337736585, 0.10288740391341937],
            [4.59918967018532, 0.10544464522148861],
            [4.610499132044067, 0.10664745127649153],
            [4.617368639111608, 0.10622906412930082],
            [4.627254900093784, 0.10067990853112575],
            [4.633206410999933, 0.0987302218697925],
            [4.639993842669313, 0.09888874830336034],
            [4.645089567246094, 0.0979158074253249],
            [4.652097800892136, 0.0993097841918341],
            [4.660562828555189, 0.102266424523032],
            [4.669564999197822, 0.10034150709160196],
            [4.674262625818474, 0.10145651760696783],
            [4.682797909408827, 0.10642138684388301],
            [4.6867467976206365, 0.11184423411267322],
            [4.688997609698807, 0.11876547656785798],
            [4.688430530836226, 0.12840691766922085],
            [4.684831319629258, 0.14708857256513602],
            [4.687630739619289, 0.1531958315527424],
            [4.698412691675738, 0.1608714422183043],
            [4.71277493912865, 0.1703320195336991],
            [4.720294456080549, 0.18186667744626542],
            [4.722009567601699, 0.1862577784306284],
            [4.727696140812753, 0.21440858264081172],
            [4.744203657374342, 0.24461577238698143],
            [4.75063156304951, 0.25283849107017253],
            [4.757930612289741, 0.2554469227456458],
            [4.769869146791697, 0.25520758879933414],
            [4.786037794299368, 0.25041644723817563],
            [4.795913336529021, 0.24973079312825272],
            [4.805287762897209, 0.2521957826447006],
            [4.8110451175352535, 0.25661368566750314],
            [4.820265993406606, 0.27115566065920343],
            [4.822999167557419, 0.2790835060944871],
            [4.824335088724999, 0.28844539806287195],
            [4.823777578266385, 0.2965039439874041],
            [4.824783362527349, 0.3035794410020086],
            [4.827607441532948, 0.312939066592748],
            [4.830729388567611, 0.31711462173626015],
            [4.8395376876077725, 0.3223262097682596],
            [4.848372297365427, 0.3220046649815343],
            [4.856263845316864, 0.3199009224881225],
            [4.8649607297854, 0.31424147672753433],
            [4.874793695027696, 0.305380245042739],
            [4.8814088005129666, 0.29438468393094624],
            [4.891223379877002, 0.28596724864868056],
            [4.907706347347852, 0.27729708319873747],
            [4.939670102178032, 0.25769040550573247],
            [4.945039292122115, 0.2552360338894984],
            [4.949587836546184, 0.25505232678939743],
            [4.956804604267939, 0.2578509247022868],
            [4.961207858357394, 0.262421631995606],
            [4.9678682778272725, 0.2670333737659946],
            [4.973624021709975, 0.2685390093468056],
            [4.980803716369263, 0.26849922537312737],
            [4.992728629427768, 0.26101975478585904],
            [4.995920608451409, 0.2558647948002247],
            [5.000688988310945, 0.24575348183293866],
            [4.997009774857012, 0.2377359900114704],
            [4.979759798064346, 0.22149670931730378],
            [4.965011595353256, 0.2096840630645059],
            [4.9514229313597165, 0.21089222735273036],
            [4.9513386158499735, 0.20132031092330674],
            [4.9491190970650925, 0.19511373695915202],
            [4.942766837625953, 0.18502586994358453],
            [4.931629930265086, 0.17110415940359022],
            [4.9251580031813145, 0.1646221264890912],
            [4.920465440117128, 0.16228817017408104],
            [4.902716351268751, 0.15184491937279485],
            [4.8679328473189765, 0.08580850474571661],
            [4.867200282850725, 0.07489225377610267],
            [4.865710943871412, 0.06336817726856458],
            [4.86414271544734, 0.05966487557212837],
            [4.863228604408884, 0.04765641455468355],
            [4.857214707453176, 0.022965119283362596],
            [4.863500314419884, 0.0077794251258985325],
            [4.8772910233710585, -0.007983199564502417],
            [4.883220807577486, -0.012984113258068334],
            [4.897301677374284, -0.021141063486829606],
            [4.898818990753908, -0.03064863738690166],
            [4.902306565072955, -0.034903328878191954],
            [4.909479740853947, -0.03675682041474942],
            [4.905497934258035, -0.04862659437261546],
            [4.902515784190457, -0.06333219600071886],
            [4.901196242952843, -0.07362915293533748],
            [4.899006716292185, -0.08367405175769392],
            [4.89863938603365, -0.09047401712164944],
            [4.896516982833822, -0.0977844150022326],
            [4.8940616622635815, -0.11877053363837696],
            [4.891900256442707, -0.13167021684770416],
            [4.88867156880331, -0.14256725431686132],
            [4.874383628631356, -0.15768738577271318],
            [4.864489786128636, -0.17231734524280226],
            [4.858414107015335, -0.1788215636988623],
            [4.853504778182691, -0.18557780455818107],
            [4.85111442118287, -0.18240589535088222],
            [4.850697181173363, -0.17729496029424058],
            [4.847355793917164, -0.1686032010674915],
            [4.8478940638335475, -0.15671648018481002],
            [4.845793166083455, -0.1454380873299201],
            [4.846298945635079, -0.1375136457581231],
            [4.850693735402823, -0.13247513879016465],
            [4.854225549704243, -0.1248597450340384],
            [4.853605109544072, -0.11953943814095044],
            [4.851339090225556, -0.11779711296981299],
            [4.8397772055128785, -0.11558247745246869],
            [4.822422562133478, -0.12197893517355889],
            [4.811281278561706, -0.12501620677515426],
            [4.811249622168878, -0.12015457124792896],
            [4.807961289504101, -0.11719581925169752],
            [4.803864064640433, -0.12176093710053287],
            [4.797517031800865, -0.12383037189992767],
            [4.792802377325892, -0.11962176700314807],
            [4.791982358817496, -0.11363219700889102],
            [4.785669669237176, -0.09860186270162492],
            [4.786844041007775, -0.09290979908918216],
            [4.791306585728793, -0.09558484013147167],
            [4.796237565235845, -0.09275865328329468],
            [4.798002606075533, -0.08794800962590814],
            [4.795719499003809, -0.07961400728672255],
            [4.797234515116969, -0.0752308042196389],
            [4.753944488697892, -0.07711273671934922],
            [4.72955533424563, -0.07866004872081983],
            [4.714258949138632, -0.07931921531035845],
            [4.653425075398642, -0.08249869023767915],
            [4.6501714453000735, -0.09067615557650983],
            [4.645767275428296, -0.10522095848646104],
            [4.6377018352850845, -0.11406255707656857],
            [4.634304016218907, -0.1135917662431088],
            [4.625776371133614, -0.10826320127947701],
            [4.621349092082924, -0.10036982293002887],
            [4.613663711651569, -0.09865562514299056],
            [4.607570173508319, -0.09892330259155765],
            [4.604411155737125, -0.1003593501333606],
            [4.600859129229469, -0.10818699838847644],
            [4.6067922005243425, -0.1312331910619828],
            [4.599537141792751, -0.1390475964164832],
            [4.588753467712777, -0.1425635086637424],
            [4.587103500223761, -0.13791872052914536],
            [4.589648827391967, -0.13470150918921492],
            [4.588056705510803, -0.13046412355114745],
            [4.584586625970066, -0.13143828536214314],
            [4.583190709778173, -0.13576416645827044],
            [4.580681938256303, -0.13566890533926623],
            [4.580929405026319, -0.12830549668743604],
            [4.576301523967115, -0.1243216365470458],
            [4.574320602974943, -0.11841779232025905],
            [4.570612954212848, -0.11671338110472099],
            [4.566226300775191, -0.11732522737191337],
            [4.563638385749201, -0.11972680728429594],
            [4.5590089266427505, -0.12110013473104797],
            [4.556385954942689, -0.12004359131617943],
            [4.559642842417729, -0.11466000841045229],
            [4.557242117681866, -0.11156541784590379],
            [4.5520566077654525, -0.10801067931229577],
            [4.546628068924351, -0.10763557782213747],
            [4.54313555397091, -0.1238761178893973],
            [4.541693591368919, -0.08606458579506084],
            [4.540442130660828, -0.048105155468652655],
            [4.539737767935149, -0.013090902961500818],
            [4.537540359882771, 0.0320636037458666],
            [4.53646238486523, 0.05013851342754872]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.44340246934863,
          "lat": 38.640662791272064
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29189"],
        "coty_name": ["St. Louis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Louis County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "00758549"
      },
      "bbox": [
        4.53646238486523, -0.18557780455818107, 5.000688988310945,
        0.3223262097682596
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.546801699152261, 8.200375991494685],
            [-5.542669447220907, 8.243155786828789],
            [-5.456267174306611, 8.235040697325521],
            [-5.453704428991274, 8.263483497732],
            [-5.388938796230838, 8.257718161358131],
            [-5.324174316811864, 8.251940106461035],
            [-5.3254506284278555, 8.237739250007616],
            [-5.28203556504951, 8.233884613159493],
            [-5.284662172806513, 8.205428071592351],
            [-5.201530236084001, 8.198395955682054],
            [-5.118400062618565, 8.191342968950234],
            [-5.0721828180787645, 8.187332179407631],
            [-5.080545343548998, 8.088372982528677],
            [-5.083127726587173, 8.057808441352563],
            [-5.094468886116539, 7.934015320088174],
            [-5.095477674361352, 7.9172008454216245],
            [-5.102754061112613, 7.8317398840300365],
            [-5.108952698862603, 7.758662204911881],
            [-5.115714310795587, 7.678931337546151],
            [-5.116164584418011, 7.677920801819705],
            [-5.127347619893428, 7.555964166628073],
            [-5.131026307445941, 7.501735889876537],
            [-5.135393746316046, 7.439154266429731],
            [-5.198443756062934, 7.444441594327733],
            [-5.191034667041668, 7.530187375208513],
            [-5.238925651139715, 7.534271401074823],
            [-5.238998487575506, 7.5334369422415515],
            [-5.325030764294163, 7.54091602401573],
            [-5.324846297058825, 7.543557473254433],
            [-5.353603530431426, 7.546192385980076],
            [-5.368421374606062, 7.5470347749645175],
            [-5.36089380786775, 7.630301653882683],
            [-5.42472864379893, 7.635788684519291],
            [-5.447664527365323, 7.63798896971581],
            [-5.440430655655975, 7.718153483937352],
            [-5.488059800109178, 7.7222313180314694],
            [-5.5919001125767, 7.732018882389674],
            [-5.69574350753541, 7.741775060345361],
            [-5.679334657686541, 7.915751741234053],
            [-5.692940515494369, 7.917003817257874],
            [-5.677691755767572, 8.081735630365019],
            [-5.677642414472999, 8.083146954675716],
            [-5.558471680096662, 8.072118403183966],
            [-5.546801699152261, 8.200375991494685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.41740476971772,
          "lat": 46.33398521345906
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30025"],
        "coty_name": ["Fallon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fallon County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01688745"
      },
      "bbox": [
        -5.69574350753541, 7.439154266429731, -5.0721828180787645,
        8.263483497732
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.12108311823501, 10.63769116570077],
            [-11.022221202327227, 10.619930299002295],
            [-10.923365419728816, 10.60213545035776],
            [-10.922653140848828, 10.601686917867562],
            [-10.802831606528953, 10.58046721223291],
            [-10.764384376782676, 10.573829189206915],
            [-10.689080228508091, 10.560620577979215],
            [-10.613779579662582, 10.547392298027539],
            [-10.610430452319351, 10.550679108875087],
            [-10.599758383707126, 10.609819648464718],
            [-10.581159682922445, 10.713108413411444],
            [-10.501206961662751, 10.69949405824904],
            [-10.421258028316865, 10.685857363405319],
            [-10.351582972335136, 10.674046581919658],
            [-10.351682392495226, 10.67235685185347],
            [-10.341669402417084, 10.6706580212792],
            [-10.338920398276597, 10.665641538528059],
            [-10.334995233145836, 10.664480917903607],
            [-10.323375978788185, 10.663315864429919],
            [-10.319849874773668, 10.66240624331005],
            [-10.31832411515263, 10.652365072139114],
            [-10.309090668202272, 10.64714738051098],
            [-10.304982885370428, 10.647372394444556],
            [-10.3027218749283, 10.653739392029216],
            [-10.295407915836313, 10.648433042391627],
            [-10.291472683675728, 10.647355483405278],
            [-10.286244976613828, 10.64023712823164],
            [-10.286121444872869, 10.63562651266041],
            [-10.281638376334705, 10.63520364670235],
            [-10.281685260058508, 10.62979147582196],
            [-10.279189690560024, 10.62622473571178],
            [-10.276355555733799, 10.628576108676302],
            [-10.271635686857241, 10.627336377328591],
            [-10.270293695035617, 10.623848471675737],
            [-10.27273888521445, 10.620953611019697],
            [-10.269807028505173, 10.617834075791153],
            [-10.262117124396008, 10.618763309492596],
            [-10.261666960589663, 10.613730363367564],
            [-10.259646943657634, 10.610918408685164],
            [-10.254693363825744, 10.613584455867898],
            [-10.255185969571096, 10.618759595719741],
            [-10.251056764955814, 10.619172297708209],
            [-10.248672208951199, 10.6148180780326],
            [-10.24411823071908, 10.61992654604273],
            [-10.236878579374341, 10.620267811418213],
            [-10.233906848285748, 10.623878878330611],
            [-10.230032271762127, 10.622161121739314],
            [-10.229038640535562, 10.617615468344232],
            [-10.222644788751365, 10.621481301120355],
            [-10.218440531451622, 10.618027341107377],
            [-10.223449016019135, 10.615691987046214],
            [-10.222692293657978, 10.612266777889866],
            [-10.218212830312691, 10.611862996464573],
            [-10.216776214215836, 10.616966351176863],
            [-10.210322860375843, 10.61650345667903],
            [-10.212682344748918, 10.60946085474269],
            [-10.20782684938575, 10.60898313399574],
            [-10.201881131181, 10.604383650462648],
            [-10.209186275580791, 10.561890445985581],
            [-10.16622643665031, 10.554454538894008],
            [-10.166395375487431, 10.553472681471364],
            [-10.080451731018856, 10.539358779425024],
            [-10.087503684584107, 10.4978058539589],
            [-10.001450329537754, 10.483320330108608],
            [-10.022461368204388, 10.358454382173019],
            [-9.93964662132795, 10.344942815136083],
            [-9.936823214035089, 10.344288032366077],
            [-9.852233059044156, 10.330825117308207],
            [-9.866254829782537, 10.246800010442758],
            [-9.88907953376421, 10.107049062586094],
            [-9.91071976080686, 10.11052042570871],
            [-10.021537741069297, 10.127272396685518],
            [-10.13236134674681, 10.14398289231085],
            [-10.22971883785189, 10.160024520149678],
            [-10.272761215623426, 10.167438471244074],
            [-10.263012779519558, 10.223402095970824],
            [-10.30567485510954, 10.230685353896819],
            [-10.298165250366877, 10.272679667957734],
            [-10.384246984720408, 10.28772243955432],
            [-10.376935847409992, 10.329588434294621],
            [-10.434225762736743, 10.339924326426736],
            [-10.497479164128228, 10.351081505104759],
            [-10.560735096918783, 10.362224951825599],
            [-10.622279953617031, 10.373240641531064],
            [-10.683827252910874, 10.384243315592192],
            [-10.745376970640692, 10.395232970657762],
            [-10.806929082641913, 10.406209603376322],
            [-10.807071183859241, 10.405428430335895],
            [-10.849639117620486, 10.412929797672993],
            [-10.8498726631356, 10.411654686102057],
            [-10.931934734707575, 10.42620636059882],
            [-10.936415421529853, 10.425470345434613],
            [-10.939829383887572, 10.427020423863373],
            [-10.942009337812888, 10.430257967621307],
            [-10.948463484073933, 10.427725513392668],
            [-10.9495683522954, 10.423816778031155],
            [-10.957752535091805, 10.421176153577415],
            [-10.96007412190186, 10.425109613550982],
            [-10.958293404860832, 10.42794063508243],
            [-10.95882326612014, 10.433460502872963],
            [-10.955458222759036, 10.439621782799456],
            [-10.96052826707333, 10.44938184600876],
            [-10.964291628788242, 10.449193731193887],
            [-10.973633562752422, 10.44358560859236],
            [-10.976904783839354, 10.443223993656536],
            [-10.981060509180798, 10.440465498295714],
            [-10.984842956885345, 10.443713823589201],
            [-10.991054551186258, 10.442851375164796],
            [-10.995150535918155, 10.44523506234134],
            [-10.998177833773271, 10.44420464135139],
            [-11.002952418892614, 10.445908818641495],
            [-11.00683326350323, 10.443829799643735],
            [-11.006205455800654, 10.453762980768897],
            [-11.012176415237322, 10.462654202067199],
            [-11.019410856754995, 10.461860351327454],
            [-11.024350002311541, 10.469441173431488],
            [-11.026101714377353, 10.477144292692543],
            [-11.031275923277024, 10.481859942568493],
            [-11.034736662526086, 10.487888740325644],
            [-11.037454073990189, 10.485141707190705],
            [-11.042236874371254, 10.485764854760804],
            [-11.046103493450074, 10.483995476515275],
            [-11.04961780127121, 10.484921997395233],
            [-11.053866091117131, 10.481067815519149],
            [-11.056638515730901, 10.482625040494575],
            [-11.061283030665237, 10.487959420382339],
            [-11.065123434861977, 10.490483185541816],
            [-11.068045096310463, 10.489614785275602],
            [-11.069864253181663, 10.494289029265197],
            [-11.06871488387957, 10.499352317096179],
            [-11.065855497399012, 10.500688449642974],
            [-11.065412466107443, 10.504048118312573],
            [-11.066970092088946, 10.508903567197091],
            [-11.065052146640358, 10.513053124915427],
            [-11.065679534355207, 10.519311600897405],
            [-11.064473817451482, 10.522231221279382],
            [-11.065303890669155, 10.528947791424562],
            [-11.063721767674862, 10.530223525427466],
            [-11.063477192768268, 10.535918986371108],
            [-11.059396141928868, 10.53761876590482],
            [-11.056510524396483, 10.540882976803463],
            [-11.056190024671736, 10.545905654797048],
            [-11.053785204966905, 10.547692643664297],
            [-11.054240242170254, 10.551832816139704],
            [-11.058091114985716, 10.555316355849612],
            [-11.058207713971901, 10.563894974778925],
            [-11.061240769772459, 10.565189406057245],
            [-11.06538075247587, 10.573112955648575],
            [-11.070987451597183, 10.57404740667454],
            [-11.076309739860147, 10.579790798002836],
            [-11.081269818326382, 10.580099531429239],
            [-11.084625775730833, 10.584663632313283],
            [-11.089868542568293, 10.587560986335601],
            [-11.088351622891206, 10.591640365555104],
            [-11.090399509955494, 10.596488942196421],
            [-11.092003931427824, 10.606760984248664],
            [-11.100121559724496, 10.611093138927695],
            [-11.107655337729451, 10.612943547177231],
            [-11.111805496210263, 10.61711214554729],
            [-11.110976201974141, 10.620957579529053],
            [-11.113161511976031, 10.624285038959389],
            [-11.121677953457832, 10.630720914661088],
            [-11.12108311823501, 10.63769116570077]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.22632508557135,
          "lat": 48.22777708346155
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30073"],
        "coty_name": ["Pondera"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pondera County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01719587"
      },
      "bbox": [
        -11.121677953457832, 10.107049062586094, -9.852233059044156,
        10.713108413411444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.963862352861026, 3.5384438483456964],
            [-4.892686389739962, 3.5320056752112747],
            [-4.873767160202537, 3.5314377919879028],
            [-4.793375647123074, 3.5257605449391782],
            [-4.685840904142513, 3.5168544345952792],
            [-4.66151779414465, 3.5145107421249118],
            [-4.613462366760465, 3.5103200413275335],
            [-4.595387580605668, 3.5085854993538033],
            [-4.570070862367972, 3.506962991203628],
            [-4.532821919148998, 3.505508762804232],
            [-4.51284735810849, 3.5058380364146324],
            [-4.474030114035166, 3.504140418975417],
            [-4.459092795947121, 3.5035319866256227],
            [-4.459833882383587, 3.4888447117492167],
            [-4.473409697703647, 3.312276432253388],
            [-4.474090224271524, 3.284522653618037],
            [-4.472737457192983, 3.2697906715668914],
            [-4.470680633741598, 3.2549443405116816],
            [-4.467821748424904, 3.239945616761282],
            [-4.446785333432777, 3.23811471305447],
            [-4.448099864823126, 3.2237045904990524],
            [-4.450417233997671, 3.209060515044498],
            [-4.45074370560635, 3.1944130532334265],
            [-4.456784675485309, 3.1072311622829325],
            [-4.458295502392358, 3.0875422466435674],
            [-4.464076447026905, 3.001085789276317],
            [-4.4686928813537845, 2.9329879691489036],
            [-4.555098743970025, 2.939418446727629],
            [-4.668861884343695, 2.947423003019818],
            [-4.697479495906715, 2.94902280523713],
            [-4.754671962659294, 2.9529263080345705],
            [-4.771757313968388, 2.954549586437509],
            [-4.8264647402732, 2.958620996969694],
            [-4.947154743906451, 2.9672837082785497],
            [-4.969528121982041, 2.9691457332690674],
            [-5.01213501280848, 2.9719952606650373],
            [-5.0059037786788325, 3.034309074847464],
            [-5.002531700686638, 3.0803641246587503],
            [-4.996769074704408, 3.176335946101655],
            [-4.992753155268664, 3.2343517938608186],
            [-4.991382563211481, 3.2596381363471165],
            [-4.98932076082186, 3.278548982604834],
            [-4.98354025440805, 3.278814047456361],
            [-4.983347849851364, 3.284833014720651],
            [-4.98056647203698, 3.322265564164865],
            [-4.977904271748556, 3.351501621844636],
            [-4.9759948533199925, 3.3652096915038774],
            [-4.971110104170293, 3.431309111420429],
            [-4.963862352861026, 3.5384438483456964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.01043783824693,
          "lat": 41.715985908605745
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31123"],
        "coty_name": ["Morrill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morrill County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00835883"
      },
      "bbox": [
        -5.01213501280848, 2.9329879691489036, -4.446785333432777,
        3.5384438483456964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.725301934560214, 3.978840087886092],
            [16.739906216118303, 3.973027117186486],
            [16.74365432391982, 3.9674735337849634],
            [16.7492541566065, 3.969844902265491],
            [16.755292163691944, 3.9768941166055622],
            [16.758291351973174, 3.976907507837159],
            [16.764403715612293, 3.9735479231422177],
            [16.765314680408864, 3.9688182042415483],
            [16.768530838079087, 3.9645266997442468],
            [16.773911247442644, 3.9674192086524713],
            [16.769285426819916, 3.980363184276623],
            [16.774024867776617, 3.993577745189474],
            [16.77577810343761, 4.001119161619787],
            [16.779998434393676, 4.003956905168445],
            [16.782399379826238, 4.010448511737071],
            [16.785336076336126, 4.013236947403555],
            [16.800604986023078, 4.018270778429775],
            [16.803292615545217, 4.021445065436127],
            [16.8058078812175, 4.027822155664761],
            [16.810775263635303, 4.032084073835813],
            [16.811584895308904, 4.037128651859346],
            [16.816869481643625, 4.035783376270619],
            [16.81701634645647, 4.031544234889322],
            [16.819600005743332, 4.029895155402229],
            [16.833663036096716, 4.024146222973612],
            [16.834589386455498, 4.01974076100013],
            [16.841637561476716, 4.01768220366323],
            [16.829565057711246, 3.9733535029158413],
            [16.83157027190263, 3.9348958022093887],
            [16.82725603850934, 3.9329274490024217],
            [16.8257616420677, 3.925032554254664],
            [16.825840633885985, 3.9189232209314055],
            [16.82286601592978, 3.918689123608128],
            [16.817702621592904, 3.910029616720378],
            [16.814767893828762, 3.900905131815458],
            [16.80652827338998, 3.9042717653963916],
            [16.803993343633177, 3.8982011698931553],
            [16.805644605953304, 3.8916573631587994],
            [16.802048106976656, 3.881200238911143],
            [16.813328498226042, 3.877868148880612],
            [16.810809988370377, 3.868968618332187],
            [16.79718683492239, 3.8718995204611626],
            [16.795091092514575, 3.8681660861891274],
            [16.79981020139914, 3.8590675694498837],
            [16.79529934943262, 3.853297640943228],
            [16.78591428585356, 3.852029388135731],
            [16.777466838643694, 3.845796893206349],
            [16.772848069240275, 3.8437113069011306],
            [16.765440962237342, 3.842135275026835],
            [16.76082391671389, 3.8394980006772825],
            [16.758393758611604, 3.841966073620366],
            [16.758975313428067, 3.8463199636097274],
            [16.762621052873232, 3.854442906854505],
            [16.77770665223143, 3.9036980122798197],
            [16.774200430022763, 3.9058542471215714],
            [16.77032296089005, 3.9164783206064664],
            [16.766262708429203, 3.9171098319213566],
            [16.760969389607805, 3.915499915290013],
            [16.75948149003073, 3.919149585696185],
            [16.758984951471547, 3.9356972476899243],
            [16.757958907271696, 3.938054401022399],
            [16.75360262409271, 3.9395812438661486],
            [16.74349799482223, 3.9365594009473677],
            [16.739689534921567, 3.93343658268297],
            [16.73752419315273, 3.9278672387292266],
            [16.73180361656263, 3.9256398449469],
            [16.72814701187059, 3.925765005233521],
            [16.72427805015683, 3.9297355028438687],
            [16.720757062614837, 3.937215844420159],
            [16.719809238457383, 3.946359681574435],
            [16.72038409546302, 3.9517378535880106],
            [16.72256031735846, 3.9571301453667513],
            [16.722858998556497, 3.962071881544536],
            [16.726187391692296, 3.970274175168957],
            [16.725301934560214, 3.978840087886092]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.07510241108737,
          "lat": 40.740791906369545
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34017"],
        "coty_name": ["Hudson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hudson County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00882278"
      },
      "bbox": [
        16.719809238457383, 3.8394980006772825, 16.841637561476716,
        4.037128651859346
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.455048555995198, -5.569169690661018],
            [-10.424708638217094, -5.350333182657517],
            [-10.4183149883906, -5.304310189897188],
            [-10.406271297758622, -5.220665706554359],
            [-10.246919509560353, -5.242947506088771],
            [-10.269126457503488, -5.41571190624638],
            [-10.173768944265856, -5.428437633152774],
            [-10.132963268243195, -5.433569748137295],
            [-10.097754136144339, -5.438376380146227],
            [-10.109595058748809, -5.524881163115319],
            [-10.018353383701857, -5.53688602480259],
            [-10.021341489782557, -5.559276542671173],
            [-10.060393180085295, -5.851743683878454],
            [-10.064541066864189, -5.883402968599744],
            [-10.066586113147283, -5.893097370161322],
            [-10.07196180444589, -5.933032407904692],
            [-10.076661542866793, -5.969899368460637],
            [-10.06575791575121, -5.9713415500359615],
            [-10.07898410820605, -6.070436275967568],
            [-10.088887992550537, -6.144163374386486],
            [-10.094226049834594, -6.1855019586474045],
            [-9.921901756828014, -6.207641004065315],
            [-9.83647674412926, -6.218515008063317],
            [-9.8420919211621, -6.261759196718669],
            [-9.836115804144674, -6.262502641600498],
            [-9.840835622626457, -6.298945138082704],
            [-9.839504771845418, -6.299216675127125],
            [-9.8611311848284, -6.467635210591654],
            [-9.876169304732644, -6.580118130521268],
            [-9.8975605466777, -6.744606698566503],
            [-10.002843657707281, -6.73090140002227],
            [-10.108124379058841, -6.717177730846388],
            [-10.213402732272316, -6.703435687525822],
            [-10.318678738816592, -6.689675266014231],
            [-10.387149858679713, -6.681329453075261],
            [-10.448141824430916, -6.673155545541931],
            [-10.607484207250137, -6.651259223088225],
            [-10.587326643077576, -6.505540479952775],
            [-10.58434085126631, -6.486290055569662],
            [-10.564914322712212, -6.3508905289586925],
            [-10.542996838987232, -6.192697687922464],
            [-10.54067915267863, -6.178675428631573],
            [-10.536437979075208, -6.146048537701186],
            [-10.53228315507816, -6.119318078570261],
            [-10.512646633103333, -5.977925085494186],
            [-10.510759701462709, -5.963532263826649],
            [-10.502006815751734, -5.903245432892877],
            [-10.455048555995198, -5.569169690661018]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.71478184335167,
          "lat": 31.914032764794914
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35023"],
        "coty_name": ["Hidalgo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hidalgo County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00929106"
      },
      "bbox": [
        -10.607484207250137, -6.744606698566503, -9.836115804144674,
        -5.220665706554359
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.489877158112467, 5.1501740013692405],
            [15.478783621767628, 5.20426180029945],
            [15.46938566501033, 5.253078800181872],
            [15.466335166408953, 5.267303014406018],
            [15.470515326189402, 5.270570576076521],
            [15.478417034680595, 5.270853557000113],
            [15.483106688302906, 5.276888151425127],
            [15.489625641433772, 5.273658376764769],
            [15.491698701519686, 5.281074950332207],
            [15.497062392902315, 5.2759550300379345],
            [15.508776015637931, 5.281781202968645],
            [15.514278172019864, 5.279830898367635],
            [15.519242212626267, 5.279579627994292],
            [15.53055642827459, 5.2883771676074165],
            [15.54332153484895, 5.292688965195837],
            [15.542455854879014, 5.297167305029425],
            [15.546493247050352, 5.302238280614877],
            [15.548756704976034, 5.311425306280354],
            [15.556419855420366, 5.316924746695591],
            [15.556789176766225, 5.320652713279572],
            [15.562922008388215, 5.326395579751552],
            [15.559773785327598, 5.330370868370101],
            [15.562080046542368, 5.338104906086349],
            [15.56516934017201, 5.342953703955204],
            [15.569736979260894, 5.341632901699416],
            [15.574023914673425, 5.345274561407798],
            [15.583956089912558, 5.344670744414997],
            [15.589878174295633, 5.349214018187245],
            [15.597100393315912, 5.350917323244095],
            [15.599311408708813, 5.353849016782351],
            [15.599501290970439, 5.359444263930315],
            [15.601355513265684, 5.361439823169434],
            [15.611505863403224, 5.364495379161033],
            [15.61308943665887, 5.344983314168888],
            [15.64300217620351, 5.379680393073357],
            [15.646846496016272, 5.376158885116863],
            [15.65901316586465, 5.391870281644298],
            [15.65475973929597, 5.39555158855224],
            [15.673796954292461, 5.422433962839047],
            [15.696173813302883, 5.437692907667116],
            [15.724591573186823, 5.442514216315081],
            [15.720388338825657, 5.467332907818434],
            [15.722753148785522, 5.464102023451466],
            [15.73364967548159, 5.4631056753384515],
            [15.734609070443895, 5.458986733859905],
            [15.741760101591039, 5.457851299691943],
            [15.743338447436479, 5.464727330560244],
            [15.747573883568048, 5.4658773542881285],
            [15.748231651309858, 5.487160094359888],
            [15.758627766423427, 5.491316122897614],
            [15.761443389424475, 5.485259720780809],
            [15.775845591156397, 5.498488605624037],
            [15.775385294606432, 5.499625898786364],
            [15.805200773142195, 5.52733264980317],
            [15.83174088315068, 5.5522318036739335],
            [15.880528662021225, 5.556806834434756],
            [15.885439241131126, 5.555924115334585],
            [15.891614131473425, 5.563609948005689],
            [15.894214650539228, 5.564517673449359],
            [15.89731374403787, 5.568977392840179],
            [15.90228601479533, 5.571486414387683],
            [15.910543864958743, 5.571477462682908],
            [15.91332844088639, 5.575770325845843],
            [15.922621754878397, 5.576160812638429],
            [15.925246434460895, 5.578713824282713],
            [16.012396708538716, 5.502537788383994],
            [16.127043698718303, 5.470956382184539],
            [16.15345879279374, 5.463485975785925],
            [16.165756073841898, 5.460201203396495],
            [16.148804318081602, 5.398965395320071],
            [16.12097347702664, 5.298063855680466],
            [16.1512925050316, 5.290078985518523],
            [16.154402143239686, 5.289566403206223],
            [16.189633417572733, 5.2806761834606695],
            [16.157627654641786, 5.248324980333456],
            [16.137900625899693, 5.245407521356152],
            [16.127302860288246, 5.217271206202145],
            [16.083714184805135, 5.1734721216600565],
            [16.035607614790056, 5.12550377641069],
            [15.987658036457587, 5.0773844730525],
            [15.948618046166985, 5.03870566147965],
            [15.90551255675272, 4.997563483755703],
            [15.85343587918036, 4.946497573375425],
            [15.761756231033981, 4.857343758098064],
            [15.761851772048797, 4.857146619327229],
            [15.756553572914033, 4.852986550526361],
            [15.750036580175706, 4.852847305319829],
            [15.745779689892222, 4.856042299101361],
            [15.742781974936792, 4.860925662832516],
            [15.741567622646402, 4.868661361767868],
            [15.7387552367023, 4.87273122167143],
            [15.734209737165914, 4.872507151406557],
            [15.731534186060555, 4.859722668517758],
            [15.729417516746633, 4.858835781914168],
            [15.725123506531594, 4.862977609779143],
            [15.719689574189847, 4.865622748014421],
            [15.715008174500015, 4.865675254961062],
            [15.707621612000217, 4.861552952076177],
            [15.703479711326096, 4.8503613318711425],
            [15.697355962686363, 4.851065530108612],
            [15.690846703971864, 4.856041155838589],
            [15.687268603718401, 4.856458899176617],
            [15.682656334429286, 4.85046822931748],
            [15.6778473799158, 4.849522591651524],
            [15.673369901750824, 4.852706305693267],
            [15.671648013483136, 4.856997460804576],
            [15.674774371190692, 4.8642174072356115],
            [15.671111282314442, 4.870270216545293],
            [15.662632987540727, 4.87207473767093],
            [15.659435469049596, 4.881393575499297],
            [15.661987224544406, 4.886951960504543],
            [15.661031439192254, 4.891965975568265],
            [15.651244531058286, 4.905382064387069],
            [15.648264573638919, 4.9164316882731995],
            [15.645771055234322, 4.9213483919421055],
            [15.637486801088368, 4.923604914081315],
            [15.63485684280526, 4.927342519259009],
            [15.633923776118554, 4.93267127503792],
            [15.631817248994462, 4.934381390204297],
            [15.626524229111482, 4.931382767303619],
            [15.627634880235473, 4.927608098677962],
            [15.62103150470146, 4.92626766589955],
            [15.614264557411646, 4.930145519920299],
            [15.611473193494549, 4.936345289721597],
            [15.603184121305684, 4.942088664886391],
            [15.59529844579509, 4.9429775542546555],
            [15.592392320296314, 4.945952198074255],
            [15.593200814603476, 4.9588690384393725],
            [15.589343139832318, 4.964259510096525],
            [15.584866790046604, 4.965897015020265],
            [15.574549518053173, 4.967862620120026],
            [15.571743741951973, 4.969603022580505],
            [15.571593025048758, 4.972818750905151],
            [15.567421703406396, 4.975094352505391],
            [15.562909018972467, 4.969338687679915],
            [15.559848684315597, 4.967455202227258],
            [15.555710849857002, 4.967446673027583],
            [15.55162109763599, 4.970043129452927],
            [15.546397279990993, 4.9690364810239105],
            [15.541419423635558, 4.972150505156443],
            [15.537284713831694, 4.978664176690365],
            [15.531663004702713, 4.989661571887258],
            [15.520564023196805, 4.99976441160912],
            [15.520725308919467, 5.003229656294967],
            [15.517060861933961, 5.011315103421145],
            [15.514159871486433, 5.02733908982677],
            [15.498631289843296, 5.106299026976189],
            [15.489877158112467, 5.1501740013692405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.96649543972123, "lat": 42.19807539526923 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36025"],
        "coty_name": ["Delaware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delaware County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00974111"
      },
      "bbox": [
        15.466335166408953, 4.849522591651524, 16.189633417572733,
        5.578713824282713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.514785980325133, 5.999582122094558],
            [14.559702092277552, 6.011183939333001],
            [14.609221878073205, 6.02447719740792],
            [14.609493669816377, 6.023364420502318],
            [14.6237813003107, 6.027146810178134],
            [14.630119479037793, 6.025529187516534],
            [14.635921802441322, 6.028131065508341],
            [14.641445766525756, 6.025494327929959],
            [14.644227390993349, 6.022709216392607],
            [14.651135802972705, 6.019300188166132],
            [14.654598035102184, 6.011508988665096],
            [14.65836526643209, 6.008276504483538],
            [14.660877923120818, 6.003015062220844],
            [14.667148056515138, 6.00726725272904],
            [14.670075324566385, 6.01758589182453],
            [14.670741745145355, 6.0228335550551115],
            [14.66961381735736, 6.027807303948778],
            [14.665471762082843, 6.030923580012165],
            [14.66318539332216, 6.036471728537151],
            [14.656960301679673, 6.040684159727648],
            [14.661941843983744, 6.0425558939531046],
            [14.665826277614286, 6.040089576462574],
            [14.66900251303238, 6.041878834935655],
            [14.671824750996667, 6.036953992072376],
            [14.677895743192177, 6.031201317473246],
            [14.683894836832545, 6.021606677988622],
            [14.692013759665505, 6.021062349583412],
            [14.69564370259761, 6.01722659521168],
            [14.700218849804656, 6.015224093712642],
            [14.705075968562255, 6.016093886480324],
            [14.708325613541609, 6.019276710458012],
            [14.708980772426251, 6.02533222358626],
            [14.710762953231212, 6.02933587166289],
            [14.716872640740137, 6.026488228680114],
            [14.719128958598498, 6.031560484098314],
            [14.712160697949333, 6.035408428707682],
            [14.709225102847245, 6.04164899397795],
            [14.70726835201008, 6.0498523703343015],
            [14.700780531345046, 6.051153592389667],
            [14.701926883680436, 6.0554645169573655],
            [14.69761890226443, 6.06825374721311],
            [14.699085779374613, 6.07339894007257],
            [14.696686252748975, 6.079360060353192],
            [14.700260065860283, 6.082810841782683],
            [14.703620343363955, 6.082973630414133],
            [14.721899451121912, 6.069460324002285],
            [14.726154900174938, 6.068087881104035],
            [14.7308407432554, 6.064267405788366],
            [14.73963114845327, 6.062644990237152],
            [14.746854694265004, 6.060456237940274],
            [14.752864347099292, 6.062458860139327],
            [14.757468383132453, 6.059425512657053],
            [14.763684669799458, 6.058047598416406],
            [14.77131173350128, 6.059171080060792],
            [14.779207888729454, 6.054234358176668],
            [14.781930585857495, 6.051559933123676],
            [14.78485801135792, 6.053456864243759],
            [14.794380368039475, 6.049603874654357],
            [14.801547961263665, 6.041650172350305],
            [14.800550436354873, 6.038290409971298],
            [14.801992146157788, 6.033816433412412],
            [14.804613248851144, 6.031617538297138],
            [14.813648629748535, 6.034636453940498],
            [14.82039086081726, 6.0347731687223565],
            [14.822548275173267, 6.038865654376604],
            [14.827295560075903, 6.039160075632323],
            [14.836462095905356, 6.034415358757264],
            [14.839245140502339, 6.0304794085635],
            [14.844221228841755, 6.030811099999839],
            [14.855252943893717, 6.028035999606962],
            [14.861101233490976, 6.023016498593203],
            [14.86519388144015, 6.0251144872124165],
            [14.868641726418806, 6.028731819250432],
            [14.872077060504395, 6.025592528490693],
            [14.871181327651168, 6.019532166476251],
            [14.873518648365154, 6.017655069534059],
            [14.878298037722292, 6.020821951975711],
            [14.881177598100363, 6.018435711540719],
            [14.880721418434593, 6.01527781774736],
            [14.886376065586774, 6.01185005952073],
            [14.885631203089902, 6.006038874725083],
            [14.89014629359276, 6.004218304132661],
            [14.890127534692617, 5.9978773379049],
            [14.892591589004764, 5.989964251088451],
            [14.89779849972976, 5.985143730220295],
            [14.902635656340276, 5.9842938361295195],
            [14.908420561353497, 5.988259712304935],
            [14.910043036095141, 5.984771766248351],
            [14.906529361665832, 5.978950738009311],
            [14.9060578956218, 5.9757050021876355],
            [14.910300356546125, 5.969582183632516],
            [14.90895673238512, 5.9674349902136825],
            [14.902497932554093, 5.967782191344147],
            [14.90112814588947, 5.9611333772634785],
            [14.897653047381498, 5.953021250938549],
            [14.900063000667707, 5.94701476420378],
            [14.900635486163905, 5.94136789951876],
            [14.905627676767006, 5.940386724866082],
            [14.911796087917848, 5.941265931781318],
            [14.9137703526631, 5.939595867658269],
            [14.918681108216656, 5.9411355178875525],
            [14.918986558043107, 5.943463802244796],
            [14.92792445725593, 5.942559678462405],
            [14.934278016779913, 5.946035208576216],
            [14.940596177266986, 5.948332815574123],
            [14.943218825062408, 5.944965923131494],
            [14.95030696670308, 5.919104430964416],
            [14.972221298077127, 5.837435634797485],
            [14.976236818608946, 5.821649221019328],
            [14.996495456168995, 5.746402510169567],
            [15.011384492746702, 5.693076503037282],
            [15.020512110210268, 5.659629125472361],
            [14.989911328657717, 5.650462051744419],
            [14.943956035280703, 5.637077653997739],
            [14.891142922086505, 5.622527129288453],
            [14.891443966828714, 5.6209685842930766],
            [14.866810998042538, 5.614438490080397],
            [14.858876047692679, 5.611970122604656],
            [14.809503718060382, 5.598237375535504],
            [14.754451923675337, 5.583152645823108],
            [14.752060310757795, 5.592077627758446],
            [14.741419129339747, 5.604143911353725],
            [14.729749880943388, 5.615017380126942],
            [14.72354309255933, 5.619731557979846],
            [14.697411355245837, 5.635600975447011],
            [14.679507836640768, 5.6474657292459804],
            [14.613401199869543, 5.629934772220051],
            [14.595936192680437, 5.694714888280085],
            [14.591426452936242, 5.711013530847183],
            [14.571693254103202, 5.785408879831072],
            [14.551365451206697, 5.779813580793949],
            [14.538946114191463, 5.826789848691305],
            [14.52724885123464, 5.86906228769445],
            [14.527158587528671, 5.874617248187807],
            [14.531103319760199, 5.879150471997356],
            [14.536860288045139, 5.880144799393158],
            [14.54410711827741, 5.879529898348597],
            [14.545205299701397, 5.880732155795333],
            [14.542504360387532, 5.89004478179254],
            [14.534942042077418, 5.905418375495726],
            [14.527038401848067, 5.916030226611534],
            [14.530099100415216, 5.919384367532146],
            [14.535870555037613, 5.920714234415836],
            [14.522024255851258, 5.972169962973308],
            [14.514785980325133, 5.999582122094558]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.19462319289694, "lat": 43.00579767401658 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36067"],
        "coty_name": ["Onondaga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Onondaga County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00974132"
      },
      "bbox": [
        14.514785980325133, 5.583152645823108, 15.020512110210268,
        6.082973630414133
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.511977180156197, -2.464226423192423],
            [11.50633203174291, -2.484294987427531],
            [11.503751976713225, -2.490300291943993],
            [11.505504096146495, -2.4946700174518464],
            [11.508013137523992, -2.495912832343161],
            [11.511272400136145, -2.502129092125879],
            [11.510398779587401, -2.5092869345760427],
            [11.513563051991449, -2.5138831486465376],
            [11.515214697947327, -2.5233944099273744],
            [11.518586411822705, -2.525631974902079],
            [11.518319486883835, -2.532018081388776],
            [11.521540271678903, -2.533491199786868],
            [11.52640842328991, -2.538132551559796],
            [11.526972230589939, -2.5428874034726463],
            [11.52562900896544, -2.545752182294411],
            [11.517287511052787, -2.557063597192202],
            [11.514083948631756, -2.5661428257132965],
            [11.515661951822308, -2.5684831705244844],
            [11.51442651076205, -2.5730336311391198],
            [11.511518273681501, -2.5769693416907216],
            [11.50682871715669, -2.5881147993240536],
            [11.504836487985974, -2.5957186850442593],
            [11.504921734879238, -2.5999263795338],
            [11.500030617529333, -2.603645715675287],
            [11.500539581700497, -2.6094904747129606],
            [11.49942556044804, -2.61416002534714],
            [11.4970311664835, -2.6168460220890917],
            [11.498493037614848, -2.6221187905270247],
            [11.495708219958948, -2.624302193809456],
            [11.494585655969827, -2.6292557993250005],
            [11.486360134074536, -2.629445626888748],
            [11.483736097867766, -2.632657077640952],
            [11.484300043551913, -2.6360507733479834],
            [11.482081421560915, -2.638627114886754],
            [11.477129321780724, -2.6517807184886797],
            [11.474052534626757, -2.6548951029112153],
            [11.47725894063893, -2.696875728964515],
            [11.469621022050811, -2.697791361718177],
            [11.471869830515177, -2.713923162633058],
            [11.47854724301807, -2.712996632079887],
            [11.481570185364506, -2.749276791121573],
            [11.474243871745687, -2.752964523898076],
            [11.47411622879482, -2.7579854075736714],
            [11.468975793815854, -2.7620618751346466],
            [11.464127865365182, -2.7597293481481624],
            [11.459046091793077, -2.755202917418941],
            [11.458326093034835, -2.7523545314229048],
            [11.460612211647785, -2.7463650447405294],
            [11.455195984022968, -2.7373799216813515],
            [11.454576080981823, -2.7345210959547743],
            [11.448738750048989, -2.7304215776458594],
            [11.444837603292832, -2.733203550843575],
            [11.439961157240644, -2.7428035179035195],
            [11.43387074940177, -2.7457052570279226],
            [11.427657083687519, -2.750537865749344],
            [11.424667550497281, -2.756587325450229],
            [11.423246178318665, -2.7668361283210703],
            [11.424822769543765, -2.7709927320350505],
            [11.421815006040577, -2.772055734086004],
            [11.421663739775877, -2.777757179581131],
            [11.416436834864978, -2.785484759581415],
            [11.40768020813186, -2.786481119373159],
            [11.402645546329797, -2.789409363692213],
            [11.401824473580353, -2.7865885907620016],
            [11.405819396257916, -2.7800495467336686],
            [11.402978043112297, -2.775657728036824],
            [11.39823504471171, -2.775595372294935],
            [11.392401571854192, -2.780003395463087],
            [11.385745993447792, -2.7800878503843256],
            [11.377172608148134, -2.7843593239235047],
            [11.372168743874614, -2.7931982992657214],
            [11.369624937448759, -2.7951473756568403],
            [11.365015801995948, -2.7927809374963077],
            [11.362121253209713, -2.7967766098835645],
            [11.355450529375112, -2.7966741938723088],
            [11.352954273091797, -2.8014440536348526],
            [11.345389692867569, -2.806072192512925],
            [11.341400052582012, -2.8075066869151213],
            [11.339316906885989, -2.80238432485752],
            [11.335107060343615, -2.800966831222401],
            [11.325836736237322, -2.802713631592074],
            [11.324056030012931, -2.806847206960364],
            [11.3269492077153, -2.8108593397489403],
            [11.323090441391045, -2.8140183957629077],
            [11.318846288764806, -2.813963406843374],
            [11.314810802463846, -2.820954943811825],
            [11.311622813661923, -2.823038202455847],
            [11.3057437901708, -2.8169654554546537],
            [11.301262939068774, -2.8159305986885332],
            [11.300300866712778, -2.809714334803892],
            [11.295573601557985, -2.806240414033765],
            [11.276633812770662, -2.748500082841584],
            [11.271129822373796, -2.711473658212732],
            [11.264885438528868, -2.7097927145787075],
            [11.261471775680308, -2.71169587851015],
            [11.262241671260194, -2.682954794668177],
            [11.255333970709028, -2.6837060945023037],
            [11.249922963189919, -2.6756724829653935],
            [11.250517141813212, -2.669595793934526],
            [11.247531892053722, -2.66372131388195],
            [11.226690208306227, -2.646525360472453],
            [11.208604179068123, -2.630225341097926],
            [11.135216475245374, -2.563696720698159],
            [11.138947812843197, -2.5560479291824083],
            [11.145298786780687, -2.552766858159176],
            [11.145267812250157, -2.5494623333260407],
            [11.149141366354609, -2.5465693026250222],
            [11.15266679007118, -2.5415701932236017],
            [11.155217498929046, -2.5356054927539176],
            [11.158171252163516, -2.5345602346472518],
            [11.162626978270215, -2.5296504881855753],
            [11.166318153956796, -2.5274181110323135],
            [11.173114773592339, -2.527295092959432],
            [11.182769965229564, -2.525402637499536],
            [11.187578844789227, -2.519161785982145],
            [11.19478017439553, -2.520899537000108],
            [11.199531325526687, -2.5242834905330023],
            [11.204352621561222, -2.521330710404114],
            [11.206720658723944, -2.5241488713894773],
            [11.211947590245439, -2.526031648567567],
            [11.214723165973973, -2.53079739125104],
            [11.219068742201726, -2.5310880281208714],
            [11.231557803927698, -2.536806297317805],
            [11.234395419014884, -2.532149388567011],
            [11.237298199400744, -2.5321668830927346],
            [11.241431374123913, -2.5280509133844236],
            [11.254290213253237, -2.533904699174796],
            [11.259516753438932, -2.530729997433922],
            [11.26355345794839, -2.5339980332483125],
            [11.273748321001987, -2.5358596042672175],
            [11.274810920235726, -2.528771516130944],
            [11.279717787910327, -2.5282938206473053],
            [11.279460055675498, -2.5227523955985234],
            [11.289183218100368, -2.520222656749526],
            [11.29627064552787, -2.5324743921371455],
            [11.293407156618388, -2.5391138469706296],
            [11.301215465475217, -2.541632382143935],
            [11.307414020587407, -2.539387889835196],
            [11.306156577942064, -2.5261513941305243],
            [11.301010530485907, -2.526657758003082],
            [11.301064852472777, -2.5184052328318054],
            [11.351623762277395, -2.5104237645022214],
            [11.358007366046749, -2.503812337027496],
            [11.3625163605516, -2.504305599218509],
            [11.363401861277499, -2.498504844358464],
            [11.368644101543515, -2.4946911237958997],
            [11.369124840054383, -2.4921283533714083],
            [11.380121220786164, -2.48650125990716],
            [11.382673398798639, -2.4803260974436614],
            [11.38616591000675, -2.4794342859320815],
            [11.389627595842615, -2.475197335865049],
            [11.394958561264524, -2.476726227090362],
            [11.397956416662135, -2.474808180845477],
            [11.402968760130802, -2.477948657327095],
            [11.413841876924945, -2.4762251277572918],
            [11.418445774554005, -2.479054871777098],
            [11.41951724912141, -2.481442395538399],
            [11.430580976581487, -2.4832382965871975],
            [11.43147726223809, -2.479750193958852],
            [11.429900615074768, -2.4747001444245056],
            [11.427578804921128, -2.4721732952314044],
            [11.427835745271645, -2.468596117695352],
            [11.425489998736824, -2.4644350011728657],
            [11.42671752797708, -2.458546414338264],
            [11.434261557389759, -2.457179583292536],
            [11.436387769609366, -2.4518616217062092],
            [11.445938675262466, -2.4532479917983734],
            [11.450427079487557, -2.4496698564985184],
            [11.44914675233971, -2.446021269896684],
            [11.449956260094021, -2.4419737082479935],
            [11.453746760165894, -2.4396674522351516],
            [11.511977180156197, -2.464226423192423]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.47996895203242, "lat": 35.33630263839315 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37089"],
        "coty_name": ["Henderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henderson County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01008562"
      },
      "bbox": [
        11.135216475245374, -2.823038202455847, 11.526972230589939,
        -2.4396674522351516
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.809168761582018, -7.118995582636434],
            [8.866768266532027, -7.1125150322891555],
            [8.868341190686422, -7.1230948287963916],
            [8.875293867577623, -7.122299045936659],
            [8.874158624870907, -7.111488738840165],
            [8.92339255043758, -7.105306678083233],
            [8.972903868631048, -7.098553497429129],
            [9.0064580900746, -7.0947277232856845],
            [9.025097053585064, -7.092381935813654],
            [9.036360873197658, -7.091397672151169],
            [9.08692282092503, -7.0858086093856825],
            [9.149601181010922, -7.079151419574467],
            [9.218436625234986, -7.072934202490972],
            [9.261519267504445, -7.068483049729359],
            [9.324059944255561, -7.061770471471197],
            [9.360821006585587, -7.055222713184752],
            [9.377421492976387, -7.0527796707737815],
            [9.408214938615718, -7.047517340495284],
            [9.416794796509054, -7.120594803914365],
            [9.422630596908022, -7.177440611923381],
            [9.428227986048876, -7.24250033730703],
            [9.428521414273298, -7.248401005222135],
            [9.42030433604238, -7.249456589916426],
            [9.347913256008308, -7.257949712680984],
            [9.206726083461389, -7.274320817691247],
            [9.206509272780952, -7.2747994644892735],
            [9.08462781594112, -7.289167209153765],
            [8.995372483336109, -7.299164820469352],
            [8.964391787143988, -7.301954309267667],
            [8.894839500486016, -7.309587124600047],
            [8.83493980297823, -7.314632906189453],
            [8.834272367435288, -7.305667445418829],
            [8.831465396726943, -7.305976889103357],
            [8.829450379807973, -7.291862925445437],
            [8.826944695042133, -7.269946554232717],
            [8.816271929585037, -7.185416401705636],
            [8.809622397596149, -7.120886914777252],
            [8.809168761582018, -7.118995582636434]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.83908907955096, "lat": 31.0950457723879 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01061"],
        "coty_name": ["Geneva"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Geneva County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00161556"
      },
      "bbox": [
        8.809168761582018, -7.314632906189453, 9.428521414273298,
        -7.047517340495284
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.239496010555736, -6.145408871622038],
            [7.229672460315603, -6.142151712817143],
            [7.223644872815037, -6.132270106682833],
            [7.220151724887677, -6.128644555958282],
            [7.209762362215369, -6.12564943016587],
            [7.206236533445229, -6.117609916894705],
            [7.202887387599623, -6.114618483167481],
            [7.194164575935558, -6.117106042601146],
            [7.183452163857984, -6.1133602774741655],
            [7.177795020700126, -6.107860927043741],
            [7.170626049938592, -6.102769758170164],
            [7.16212709336474, -6.093310778547904],
            [7.160045617401726, -6.092016235766514],
            [7.141371633477022, -6.091534265314963],
            [7.137004625934837, -6.087293711830705],
            [7.137838468043985, -6.0788037334218545],
            [7.13725691615936, -6.072750225780554],
            [7.1375726732664715, -6.053952472925564],
            [7.13958463603086, -6.038961363912649],
            [7.144560238101745, -6.029950262109664],
            [7.15224351649948, -6.023967287617146],
            [7.16395909217976, -6.016481367310096],
            [7.169459383933446, -6.009615493301766],
            [7.1737261838025566, -6.005799086984188],
            [7.185835357091187, -6.003784850287016],
            [7.189843740078718, -6.002118808153487],
            [7.204509072126966, -5.987990338926892],
            [7.208006378850806, -5.979530278028311],
            [7.212052756446555, -5.9664303035595845],
            [7.2233794655840295, -5.956552979262104],
            [7.230629801648022, -5.943982513051924],
            [7.235993066082284, -5.937363132094038],
            [7.242880704563, -5.932269148027521],
            [7.245928051871628, -5.9315173953807125],
            [7.255799759476425, -5.9321718795190375],
            [7.2626645849928, -5.9317270437468474],
            [7.275516298080822, -5.9352835578925465],
            [7.286862018529138, -5.936043400679538],
            [7.293715374473777, -5.932451607213978],
            [7.29564129703475, -5.924867635880902],
            [7.291393253699739, -5.920584778915991],
            [7.285129123995586, -5.91922791019989],
            [7.285081263006977, -5.916618657852495],
            [7.2912446675021805, -5.903687135293202],
            [7.296894818047862, -5.904678416170734],
            [7.305406518097747, -5.904319574986953],
            [7.310100629127427, -5.905380860536297],
            [7.315379549705006, -5.911104600175938],
            [7.310802268598156, -5.916130968360307],
            [7.310067906626914, -5.9204719937761725],
            [7.311224142005611, -5.928682714910685],
            [7.317114879124474, -5.930568622525776],
            [7.319910039798499, -5.92380376242589],
            [7.390109127681652, -5.917770874447392],
            [7.393734856146523, -5.96124479146319],
            [7.408949218098936, -5.960058643832813],
            [7.505391518518043, -5.95067283126211],
            [7.564323564673854, -5.945143615526849],
            [7.572668021836971, -6.037012310837248],
            [7.572480883934264, -6.047105342895774],
            [7.5801328190250965, -6.1191470558477405],
            [7.62298587568343, -6.115003474827388],
            [7.627563555748126, -6.157440433058324],
            [7.623720662410181, -6.155002449002855],
            [7.6189365586443705, -6.156995429555091],
            [7.614167790020902, -6.155401357191412],
            [7.602992290042944, -6.156516760081962],
            [7.592396273372387, -6.159500587275841],
            [7.588701128192686, -6.164264503344522],
            [7.585571285833104, -6.171308746057462],
            [7.59757171817051, -6.292676036288703],
            [7.57001961680935, -6.295161719269939],
            [7.51210545710561, -6.3006671668639145],
            [7.524376133825626, -6.4267855030715575],
            [7.522492454814205, -6.426924833221952],
            [7.486679569376759, -6.433418694162686],
            [7.487777943637569, -6.444150821705212],
            [7.418736841530374, -6.45139855009987],
            [7.362486733456445, -6.455825759299224],
            [7.320123659720344, -6.45941270344928],
            [7.212751257825606, -6.469195579321982],
            [7.1666716365825325, -6.47298163743949],
            [7.146668621371273, -6.4743880968435406],
            [7.137423510522313, -6.466930057103427],
            [7.134573548237927, -6.4613534085227196],
            [7.129611884227746, -6.458903250471054],
            [7.128348971426478, -6.463815023292424],
            [7.1315046106324855, -6.468951705346464],
            [7.128273730485775, -6.473012475972139],
            [7.1204258404100225, -6.46989216083435],
            [7.111605423329011, -6.461204876369078],
            [7.107487651274364, -6.450944926194035],
            [7.109031864773255, -6.43644437240474],
            [7.1088513395611574, -6.4264283133322095],
            [7.103865873197995, -6.416867025734999],
            [7.104318254295332, -6.41286554063164],
            [7.106867173643211, -6.4096777970050995],
            [7.121176828538072, -6.396678019034719],
            [7.124708606698504, -6.395163772102796],
            [7.13043877093059, -6.394931158192893],
            [7.136369468130211, -6.3980296653629445],
            [7.14309824898129, -6.403023594813778],
            [7.1461044382548, -6.401146248688218],
            [7.150725410197714, -6.391899803577534],
            [7.1550521051344536, -6.386482598656945],
            [7.162199944807928, -6.381597581506514],
            [7.1634868753438905, -6.376517186892514],
            [7.161340399631923, -6.369700399675392],
            [7.156585148537164, -6.364824743722169],
            [7.155208155884315, -6.3618574270093005],
            [7.1562452353853025, -6.3552099419360255],
            [7.161540566365328, -6.341944522750792],
            [7.162418273078918, -6.3233308422367065],
            [7.165338702881019, -6.317669866179726],
            [7.176684336631155, -6.317509848825351],
            [7.179139298907042, -6.3130349454126415],
            [7.182804401666909, -6.297735526783583],
            [7.186058739456034, -6.275531289468698],
            [7.184634054108172, -6.269123455702175],
            [7.179957657025084, -6.259735116561362],
            [7.180217086874284, -6.255010770318239],
            [7.182558936033266, -6.247718405111413],
            [7.182813557729159, -6.24170570636788],
            [7.180217853849548, -6.234769477842334],
            [7.175183081632374, -6.226680467703209],
            [7.1748584338565955, -6.221711671541188],
            [7.17934583669193, -6.212120817403819],
            [7.177617164107962, -6.19963646495148],
            [7.169415846113935, -6.193066167769445],
            [7.16782621440191, -6.19036193634713],
            [7.167508469393778, -6.176877889228717],
            [7.1701189975612545, -6.176152898142662],
            [7.178086445893615, -6.178946782625722],
            [7.180142620284523, -6.177377287707094],
            [7.17674931087689, -6.168123279295021],
            [7.177517739760951, -6.165989667382165],
            [7.182531035124107, -6.163662558261352],
            [7.189969662815002, -6.165591949698139],
            [7.192380438402536, -6.163822734624022],
            [7.197143474387804, -6.154163247390156],
            [7.202026036749699, -6.151305059917433],
            [7.204592797713415, -6.153070144563984],
            [7.209353104001979, -6.160316774195101],
            [7.211333094442636, -6.16125135388239],
            [7.2181242975413245, -6.15970595295585],
            [7.223356000972251, -6.155918283621183],
            [7.225226490772003, -6.153119228973784],
            [7.23071916992554, -6.151633124868162],
            [7.2351485379540845, -6.154714444894411],
            [7.23461511755922, -6.162725099153879],
            [7.229764781196988, -6.170068123158023],
            [7.230132475340923, -6.173906798105095],
            [7.234193430099418, -6.17484857589625],
            [7.239477265086464, -6.173705727154229],
            [7.243271071545651, -6.170224125327015],
            [7.243453989878231, -6.1678755171365935],
            [7.239677068346473, -6.158743076953472],
            [7.241373610511321, -6.1479052876209925],
            [7.239496010555736, -6.145408871622038]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.78950405042126,
          "lat": 32.247668012290895
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01091"],
        "coty_name": ["Marengo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marengo County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00161572"
      },
      "bbox": [
        7.103865873197995, -6.4743880968435406, 7.627563555748126,
        -5.903687135293202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.98218737524535, -10.897810049099471],
              [-18.9814343736162, -10.89771490300543],
              [-18.97556068623116, -10.904079294943985],
              [-18.972523231533653, -10.906602427589275],
              [-18.968220844817107, -10.907784242268193],
              [-18.966684061707245, -10.905626548318164],
              [-18.965199429430196, -10.904632821422332],
              [-18.964338816791443, -10.90632883421632],
              [-18.96610542380785, -10.907092941950706],
              [-18.9686165392644, -10.911325212043426],
              [-18.96958602055479, -10.911514440556404],
              [-18.97281725952757, -10.909790839169803],
              [-18.979095467459207, -10.904498166411209],
              [-18.982344583052186, -10.8988246792594],
              [-18.98218737524535, -10.897810049099471]
            ]
          ],
          [
            [
              [-19.09055871354254, -10.487311864063962],
              [-19.089372241497827, -10.485154206600825],
              [-19.084360219660798, -10.4739792219127],
              [-19.081524573449435, -10.475823079481382],
              [-19.078925838199236, -10.476897705636123],
              [-19.076394367573258, -10.479338411005308],
              [-19.07352938895947, -10.481022836056257],
              [-19.06824923801066, -10.48731604988104],
              [-19.06696806149515, -10.48797067693189],
              [-19.067512620009445, -10.490477050520592],
              [-19.07050127458739, -10.49193727951297],
              [-19.07506478752007, -10.49253146622048],
              [-19.077423572661615, -10.493403825319097],
              [-19.086826161260923, -10.494500150564638],
              [-19.089257482541008, -10.49410028567522],
              [-19.09034960218949, -10.492093873706237],
              [-19.09055871354254, -10.487311864063962]
            ]
          ],
          [
            [
              [-19.102274916744665, -10.455286972874463],
              [-19.101427359263084, -10.455155051849035],
              [-19.09661710305318, -10.453049561064407],
              [-19.090707039311354, -10.449822411401321],
              [-19.083105706472733, -10.446172685572025],
              [-19.07854266846922, -10.444328326350725],
              [-19.077978746703003, -10.449827306199724],
              [-19.072381212913257, -10.450136979344594],
              [-19.068744073482193, -10.449527567526586],
              [-19.059214494936217, -10.446276518943876],
              [-19.056512202753947, -10.445815432236913],
              [-19.05355114587777, -10.446198636363386],
              [-19.051471010127035, -10.445836146370052],
              [-19.05022605201952, -10.445037717367269],
              [-19.045789666851658, -10.444459523016555],
              [-19.043594018288626, -10.443417985608578],
              [-19.042482539492568, -10.44400020279475],
              [-19.040816931723256, -10.446075788899835],
              [-19.039231300407213, -10.446833380909013],
              [-19.036742351937132, -10.445837414367793],
              [-19.035416996923665, -10.446354139389243],
              [-19.034241510949656, -10.448349455959265],
              [-19.03298259131159, -10.449257731357786],
              [-19.031902314596362, -10.448831902797592],
              [-19.03103161531327, -10.447270492506442],
              [-19.03205987719358, -10.445601256153678],
              [-19.03171628698396, -10.444755281752169],
              [-19.029930343464965, -10.444948557086681],
              [-19.027707316493796, -10.446113114265712],
              [-19.026352988686394, -10.447634769996839],
              [-19.02532569595188, -10.449904480486499],
              [-19.024017390871602, -10.451119812542649],
              [-19.023586556730407, -10.448586938640824],
              [-19.017841423378943, -10.448624879717855],
              [-19.013563218666455, -10.449424460096061],
              [-19.014911977347445, -10.458715556557852],
              [-19.01332974644033, -10.461878428797936],
              [-19.011091497611424, -10.462575553712805],
              [-19.008684476873515, -10.46183484801515],
              [-19.00120887992446, -10.464760251786922],
              [-18.99523100571994, -10.46283166027231],
              [-18.99015679029018, -10.462657518784201],
              [-18.987078326690533, -10.461158001629892],
              [-18.985278814588334, -10.46125290812911],
              [-18.983759859942595, -10.462402160897154],
              [-18.98207803945254, -10.464977680842686],
              [-18.980896764089767, -10.46457129904259],
              [-18.97866314536864, -10.459728203886192],
              [-18.976090576442147, -10.457645621884112],
              [-18.97027809865918, -10.45669005753069],
              [-18.967284328281455, -10.456880809225158],
              [-18.963752839938095, -10.459258060393],
              [-18.96119956814531, -10.459077146748795],
              [-18.95960835765967, -10.458031083611159],
              [-18.95790455389679, -10.455707657484437],
              [-18.955284492669108, -10.45513302403997],
              [-18.95016342339231, -10.456472858018293],
              [-18.947410339926137, -10.455117577893938],
              [-18.946295194989005, -10.452697402753119],
              [-18.94715862596119, -10.451439167028905],
              [-18.945745079667876, -10.450228052543778],
              [-18.942721266535326, -10.44998092709095],
              [-18.93969821615104, -10.449273900354918],
              [-18.938157955861357, -10.44778237719836],
              [-18.934053639789724, -10.446511789485852],
              [-18.932082544246217, -10.44093974734848],
              [-18.932217009768646, -10.438637722902692],
              [-18.93163368492599, -10.43567360545464],
              [-18.930278917984765, -10.432198462186758],
              [-18.92986866796171, -10.428947992405625],
              [-18.930968754001825, -10.42759065904785],
              [-18.93731966191322, -10.428915973756354],
              [-18.938872022915405, -10.427144557579993],
              [-18.940373898313318, -10.424701893869985],
              [-18.940493466431118, -10.422666602535598],
              [-18.93818629277742, -10.420819656423811],
              [-18.93667635220724, -10.417866846019134],
              [-18.93684339864962, -10.41562510018478],
              [-18.941064022649485, -10.411039658351118],
              [-18.9386552801574, -10.405875996396805],
              [-18.934995256567497, -10.401273312729932],
              [-18.93375848544504, -10.400876637876163],
              [-18.93121388297687, -10.401789438027112],
              [-18.929029485461086, -10.40126246463603],
              [-18.927412425424592, -10.401946860524436],
              [-18.92578009219359, -10.404571496128794],
              [-18.923729586354376, -10.406620293495589],
              [-18.924466954221554, -10.411216645319673],
              [-18.922940362545507, -10.411706757410718],
              [-18.917862956174233, -10.40909314450418],
              [-18.914699919309005, -10.407189186943544],
              [-18.91466487583104, -10.404374685189625],
              [-18.91429276878797, -10.401459857626234],
              [-18.904947243190293, -10.393743481900897],
              [-18.902179171171223, -10.391797011963092],
              [-18.899005628526805, -10.392571215668582],
              [-18.893332678539814, -10.390014849604798],
              [-18.885170892460362, -10.388104670642395],
              [-18.883332671278986, -10.384284505621526],
              [-18.883063166542886, -10.37923348596733],
              [-18.88369507625819, -10.375235637357921],
              [-18.887274959596223, -10.372211129619542],
              [-18.889997770825634, -10.373668265472812],
              [-18.891920363415462, -10.375377474584386],
              [-18.893567768654687, -10.375467346471872],
              [-18.892648847473676, -10.372300466297816],
              [-18.892162940257055, -10.369200825313987],
              [-18.89286393837844, -10.361193400125421],
              [-18.891009768693905, -10.358935809404251],
              [-18.88960849934947, -10.354945553995849],
              [-18.892174463677787, -10.351288861321786],
              [-18.893809737584114, -10.34750644677481],
              [-18.892382429753347, -10.342523408151264],
              [-18.889763434583337, -10.338491262281293],
              [-18.889314031477735, -10.333444266778717],
              [-18.88862582824559, -10.331299403775237],
              [-18.887354085024285, -10.331405127297366],
              [-18.88297693148018, -10.333636734033073],
              [-18.8791918887835, -10.334971651282048],
              [-18.873094955041175, -10.334303039108187],
              [-18.869523633100147, -10.335105712721722],
              [-18.865580792002753, -10.338363720972685],
              [-18.861253056750986, -10.340885715221274],
              [-18.854550349974865, -10.337958758222669],
              [-18.850291640467425, -10.340290456212117],
              [-18.84518028585038, -10.344260050910902],
              [-18.84263651198609, -10.345774851660194],
              [-18.839767543668597, -10.346100916065538],
              [-18.83851454608393, -10.347381864091497],
              [-18.837069033928202, -10.350155583231551],
              [-18.834702162691553, -10.351760047662182],
              [-18.830053694839535, -10.35239507824724],
              [-18.826570977192556, -10.352525909027644],
              [-18.822904219555436, -10.3523006538314],
              [-18.81864778332094, -10.349895299733982],
              [-18.815179947299832, -10.349759799899038],
              [-18.812006142548938, -10.348277060478615],
              [-18.810991549974034, -10.345145040488772],
              [-18.81365306098079, -10.338735526470044],
              [-18.813151937306987, -10.334820986301464],
              [-18.810882903068027, -10.33225083777787],
              [-18.808594504730227, -10.332062668739985],
              [-18.805109649803928, -10.332310697186141],
              [-18.800067066059828, -10.331095605095488],
              [-18.798984841101653, -10.329931142437198],
              [-18.79850103027026, -10.328391011803463],
              [-18.798768043750652, -10.3266265578241],
              [-18.80061978678646, -10.324490497686556],
              [-18.801857690040933, -10.32250862044743],
              [-18.79891017839592, -10.320570364148647],
              [-18.794804928312114, -10.318700062962051],
              [-18.791815744038924, -10.315808874960563],
              [-18.7909162464966, -10.31383724467319],
              [-18.79182762662896, -10.307553401569953],
              [-18.7902255798884, -10.306314303191973],
              [-18.78749821365927, -10.305799016931543],
              [-18.786361606762796, -10.306942678789225],
              [-18.787303656778015, -10.31214398883923],
              [-18.785625705448396, -10.314239247938945],
              [-18.781762324775993, -10.312729229077055],
              [-18.778835632112333, -10.311284204544584],
              [-18.776910884767315, -10.311819007758542],
              [-18.77400191063348, -10.315451277905401],
              [-18.769165783965992, -10.31913790825164],
              [-18.764753607744215, -10.320696743123495],
              [-18.75851222172751, -10.321674679952158],
              [-18.753617505701424, -10.323228556626416],
              [-18.749072853087107, -10.324250075798208],
              [-18.743052768574394, -10.322133962317944],
              [-18.736147832419757, -10.31718260731727],
              [-18.72954329247409, -10.316138145171792],
              [-18.718791882555834, -10.316553144272062],
              [-18.712627908521178, -10.317518977386339],
              [-18.705011839191666, -10.317400421698848],
              [-18.696968590878498, -10.316075494568718],
              [-18.69322440872947, -10.314427050639246],
              [-18.690475534955596, -10.312594949121037],
              [-18.684035954748616, -10.30777198669924],
              [-18.679524931624595, -10.303630108905002],
              [-18.675819747031866, -10.30139328232782],
              [-18.67306031079521, -10.302346921401956],
              [-18.67008146521086, -10.304151363276592],
              [-18.66565551758589, -10.30419483567119],
              [-18.658984005693807, -10.303461764461918],
              [-18.654506759199712, -10.30333429905099],
              [-18.65006527681756, -10.302559923191719],
              [-18.64380091932918, -10.302822612959103],
              [-18.634301837035142, -10.30193553587288],
              [-18.630235934288596, -10.303737756946227],
              [-18.62872828847366, -10.30720188856994],
              [-18.63048236520771, -10.310654308234257],
              [-18.629843525796126, -10.31365680053177],
              [-18.6310151756912, -10.317243648431486],
              [-18.63177569682686, -10.320536359164088],
              [-18.626238771485298, -10.322818149268283],
              [-18.619189215330696, -10.323789987426244],
              [-18.61404404062833, -10.322789568305891],
              [-18.611998718233316, -10.321068528856367],
              [-18.606731908966488, -10.318647875030923],
              [-18.60284385394854, -10.319725698845636],
              [-18.59687719822042, -10.322727821925163],
              [-18.589540429552557, -10.323733640966928],
              [-18.58154580674594, -10.326479755626718],
              [-18.574330593385923, -10.329960706878532],
              [-18.56330112149808, -10.33675556223445],
              [-18.556512457199492, -10.339144784348758],
              [-18.55465312762625, -10.33869703391417],
              [-18.547500151307677, -10.338839511287098],
              [-18.53767602245092, -10.3402409460358],
              [-18.535085359045947, -10.339677655171046],
              [-18.509366410592502, -10.330398100636748],
              [-18.504609104240213, -10.328055469719747],
              [-18.50204157863392, -10.32705837272488],
              [-18.499039131028354, -10.326562371106828],
              [-18.49628458516663, -10.326483676435833],
              [-18.490643405414996, -10.327387748958294],
              [-18.485757815997157, -10.327803817463781],
              [-18.480732789409835, -10.326924204932038],
              [-18.47511455763969, -10.325294752834683],
              [-18.470258034201084, -10.323255556198358],
              [-18.464924692239606, -10.320184539573974],
              [-18.459648599614173, -10.318356219907477],
              [-18.438907877003395, -10.316603060019888],
              [-18.430178273424357, -10.314906628241205],
              [-18.405218845899462, -10.313582472211811],
              [-18.40303843832381, -10.312771327966557],
              [-18.397599386100826, -10.308856051463856],
              [-18.39343801025299, -10.304474244928016],
              [-18.386808897334326, -10.296754741243978],
              [-18.373545960940547, -10.28696531516155],
              [-18.358595578990133, -10.278765089535387],
              [-18.355738527286068, -10.277600026412024],
              [-18.346151668190334, -10.27334886292604],
              [-18.342249471603164, -10.271793938693325],
              [-18.333435125292862, -10.269828708815673],
              [-18.32672802876187, -10.268815841910781],
              [-18.320624126539006, -10.268685656746783],
              [-18.31233005913825, -10.26725492852241],
              [-18.299785149066977, -10.261551253920103],
              [-18.288494454163335, -10.255652883782568],
              [-18.278737778513353, -10.252314641391637],
              [-18.26968900135324, -10.250899429653096],
              [-18.262244582700365, -10.251444654859018],
              [-18.255832755397414, -10.25270386751676],
              [-18.24769667981088, -10.25588831549054],
              [-18.245786836899804, -10.256166224272274],
              [-18.24348476979994, -10.252422409986789],
              [-18.242468822533, -10.24905332124837],
              [-18.24253170344993, -10.247826022390077],
              [-18.245874287463163, -10.246770781466306],
              [-18.247643608599375, -10.24543337378855],
              [-18.25209679413381, -10.244831292730408],
              [-18.253069407897865, -10.244305615385079],
              [-18.25315076440949, -10.243033014024892],
              [-18.25127323812671, -10.242132247536153],
              [-18.25158612341999, -10.239768594014894],
              [-18.252446192167636, -10.239072155496586],
              [-18.254503910475442, -10.239415032926859],
              [-18.25837520771225, -10.241584459180142],
              [-18.264151383542256, -10.241893483616115],
              [-18.27091546741931, -10.240527387926628],
              [-18.276399189756532, -10.239100024422273],
              [-18.282750728433143, -10.236025565222485],
              [-18.28753672675036, -10.231740965802613],
              [-18.289475482341373, -10.229009814794765],
              [-18.292075934076447, -10.223281040040929],
              [-18.293966755520586, -10.216838981894522],
              [-18.29518032806653, -10.211174722457105],
              [-18.295529396690142, -10.207468976711349],
              [-18.295563972981817, -10.204364722154946],
              [-18.21529206252479, -10.211562428776142],
              [-18.13502177456132, -10.218777477253857],
              [-18.088111547631705, -10.222544089362298],
              [-18.08570150580722, -10.192692214291739],
              [-17.96600729202831, -10.201388916992903],
              [-17.963934461714004, -10.171510920280465],
              [-17.89086553168863, -10.17592932072567],
              [-17.817797556038776, -10.180362924034284],
              [-17.72494072448745, -10.18497435947741],
              [-17.726341881719666, -10.21488647185443],
              [-17.64535450382658, -10.217958527859528],
              [-17.564367842542715, -10.221048798649173],
              [-17.530846651085945, -10.222026839979309],
              [-17.452821791961608, -10.223623987142155],
              [-17.374797292388898, -10.225238051121156],
              [-17.294605648244715, -10.225729698280139],
              [-17.21441411924853, -10.22623921934852],
              [-17.186362521095234, -10.226174493954453],
              [-17.186470969403903, -10.196228751900719],
              [-17.126626985093544, -10.195850730807644],
              [-17.12690414481721, -10.16590572249061],
              [-17.07405884722159, -10.165295980398819],
              [-17.074484258519487, -10.135356210208089],
              [-17.063382279920962, -10.13520515202965],
              [-17.060993763760642, -10.29086751351446],
              [-17.05881870046657, -10.434587948485014],
              [-17.139514394868264, -10.435498366365954],
              [-17.138808544414328, -10.525293660134704],
              [-17.1312904860913, -10.525232881094022],
              [-17.13052279837955, -10.615007356960806],
              [-17.26907595745918, -10.615324267110358],
              [-17.311337610638212, -10.615086602014179],
              [-17.39532568803824, -10.613835750916977],
              [-17.47931395955075, -10.612597539901246],
              [-17.564367556337608, -10.610396921274306],
              [-17.565208758211195, -10.610370945710773],
              [-17.729241047565377, -10.604327979963616],
              [-17.762129809432118, -10.602833078197762],
              [-17.760679737929014, -10.57294144854554],
              [-17.820612819663552, -10.569973343310433],
              [-17.822225545440237, -10.59985720989503],
              [-17.85226672184996, -10.598251094332117],
              [-17.85395941019595, -10.628129737536199],
              [-17.88407693289452, -10.626439317740278],
              [-17.882303258634952, -10.596566086114217],
              [-18.047336663919978, -10.585891700822275],
              [-18.062417740157308, -10.584796886492239],
              [-18.064679995926767, -10.614640057924099],
              [-18.077087707121454, -10.613724126231986],
              [-18.07938363899205, -10.643562690425549],
              [-18.109221010914112, -10.641305773421557],
              [-18.111597545920684, -10.67113582590515],
              [-18.141509144835744, -10.668795319647861],
              [-18.14642262401332, -10.728436155977613],
              [-18.15811963973758, -10.727500256464785],
              [-18.16060757852392, -10.75731487369553],
              [-18.190433080412497, -10.754873882881395],
              [-18.195568133578956, -10.814483055682587],
              [-18.225546252871965, -10.811952469621758],
              [-18.22819314073651, -10.841746353156994],
              [-18.239201672959158, -10.840797788205833],
              [-18.241245088011897, -10.863545144260275],
              [-18.244553452585205, -10.900372558210822],
              [-18.27444649377484, -10.897744577151043],
              [-18.279955618664527, -10.957294172050673],
              [-18.320339654295186, -10.953623389279391],
              [-18.326059755345504, -11.013142445516092],
              [-18.355940445612816, -11.01033744323313],
              [-18.357656050250164, -11.027730206989819],
              [-18.36181578169194, -11.069829826432692],
              [-18.371826028017054, -11.068873494911696],
              [-18.3747798582262, -11.098613013805206],
              [-18.404579043914893, -11.095716055511993],
              [-18.40761944625114, -11.125444693626683],
              [-18.437488051259567, -11.122466179705093],
              [-18.44372208197958, -11.181897427264976],
              [-18.453091631846977, -11.180947604933316],
              [-18.456232826779168, -11.21065575306727],
              [-18.48602159966819, -11.207587830725137],
              [-18.49194574927527, -11.262275793345333],
              [-18.492450764312878, -11.262558364118462],
              [-18.498327175832674, -11.266438746326658],
              [-18.552312808301643, -11.26059112373585],
              [-18.555702225607455, -11.290252534060347],
              [-18.54963230442936, -11.290923856755857],
              [-18.55009104296116, -11.292078842269486],
              [-18.551875542272093, -11.292354916525614],
              [-18.55534811832158, -11.296059102875397],
              [-18.557145116345406, -11.299135784769387],
              [-18.557506420128835, -11.300480652667172],
              [-18.558778953986735, -11.30263204923604],
              [-18.55966047115302, -11.306368443416838],
              [-18.56012546957695, -11.311218585609405],
              [-18.55991334586042, -11.31507439843682],
              [-18.557358454195644, -11.314732488027687],
              [-18.550725413842468, -11.312264393779747],
              [-18.54844284965902, -11.311056518315072],
              [-18.547229384288265, -11.312022975603027],
              [-18.551751906120572, -11.31367287140542],
              [-18.55817703794349, -11.316784445958627],
              [-18.564193059109837, -11.317796810288538],
              [-18.56664725835619, -11.31857708420402],
              [-18.56919810839249, -11.318682345190014],
              [-18.574586871117347, -11.320252303467917],
              [-18.579495074651916, -11.321177471682182],
              [-18.584666682441163, -11.322756609704346],
              [-18.589561323568702, -11.32489073614272],
              [-18.592938720568444, -11.327408174286802],
              [-18.593319313034307, -11.328438229594436],
              [-18.593347778634087, -11.33092306931914],
              [-18.594029557985337, -11.332112435554878],
              [-18.596242971642983, -11.333388018729531],
              [-18.59781118402521, -11.333040566234219],
              [-18.598742968776275, -11.331712868756803],
              [-18.601985674206208, -11.331562753742633],
              [-18.604062996546222, -11.332036800014173],
              [-18.60449650705622, -11.33295354035655],
              [-18.605832442394195, -11.332480807076607],
              [-18.60899276333623, -11.332917711009122],
              [-18.610526068279402, -11.333752783513319],
              [-18.611261792493114, -11.334828521206772],
              [-18.613023765042165, -11.3359382750661],
              [-18.61538940666862, -11.336760161116882],
              [-18.617993915616097, -11.338787407321673],
              [-18.61997714311402, -11.341568557573472],
              [-18.619545827178122, -11.342519975104116],
              [-18.62087171498519, -11.345075694895701],
              [-18.622402934020162, -11.345137449390089],
              [-18.62378723337887, -11.344503462791165],
              [-18.62513304301773, -11.34480963712944],
              [-18.625437372771298, -11.346488622918631],
              [-18.627016838725734, -11.345491207415664],
              [-18.629409840585744, -11.34510952652222],
              [-18.63116166114346, -11.34617967814526],
              [-18.6336840759769, -11.346473565824448],
              [-18.6343334917007, -11.346951088368911],
              [-18.636247597081272, -11.346386770161345],
              [-18.63595061416359, -11.344271604424303],
              [-18.6343592131847, -11.343165606755411],
              [-18.63348059542464, -11.339463688049262],
              [-18.63264255486856, -11.337734146760619],
              [-18.633749926008477, -11.335351516853452],
              [-18.63482616585236, -11.329087151035838],
              [-18.638256553296184, -11.322531584397742],
              [-18.639566100383778, -11.320770861374841],
              [-18.64224688310447, -11.318851284759559],
              [-18.644316317884403, -11.318353389341047],
              [-18.64513100099913, -11.319159942651108],
              [-18.64566983176377, -11.320920911668196],
              [-18.64792225113841, -11.318341700084499],
              [-18.65065813161272, -11.317902380752528],
              [-18.65297021425616, -11.318031474426189],
              [-18.655430951945846, -11.316821084971401],
              [-18.656588190361457, -11.317221663583867],
              [-18.65822066674872, -11.31492785324598],
              [-18.660221990248615, -11.315660441983209],
              [-18.66231497990282, -11.31517603247081],
              [-18.664516020381324, -11.31628990167246],
              [-18.666828153518704, -11.317948714653753],
              [-18.66833130297263, -11.317621018488452],
              [-18.66887704772909, -11.315517759223903],
              [-18.669825127911512, -11.314564169964264],
              [-18.671151126573175, -11.314390564959385],
              [-18.67260384390857, -11.315419973634999],
              [-18.674027801150494, -11.315508480347615],
              [-18.67529682129446, -11.318040869567982],
              [-18.676754064440075, -11.318747778209255],
              [-18.67723298586625, -11.316507987552052],
              [-18.67821571719501, -11.315608542182218],
              [-18.682936027603855, -11.314941881167158],
              [-18.685222778582126, -11.31602089876386],
              [-18.688470490764054, -11.316083157191056],
              [-18.689681368845612, -11.315680243487453],
              [-18.69153947913209, -11.314190977289583],
              [-18.69318425749835, -11.311868345671057],
              [-18.695646870067613, -11.311915430774642],
              [-18.69713699008699, -11.31044794916209],
              [-18.698956814862125, -11.310571844320721],
              [-18.699423738982926, -11.30944229589132],
              [-18.701552279221, -11.308391118486904],
              [-18.701837031690577, -11.307026005483255],
              [-18.703360386590855, -11.305661458106488],
              [-18.70529519846386, -11.304976489627606],
              [-18.70519930058963, -11.304043946046859],
              [-18.702773697328656, -11.30272898963059],
              [-18.699266977183065, -11.302659872100794],
              [-18.69758782767248, -11.302090664694484],
              [-18.69602526655815, -11.302450945688168],
              [-18.694727520798004, -11.300762895444468],
              [-18.693994618796623, -11.298899841517196],
              [-18.692573910957066, -11.299521254879485],
              [-18.691340920046645, -11.299388181549846],
              [-18.690510878220895, -11.300391079752972],
              [-18.68803909053216, -11.299994632288277],
              [-18.68743525418163, -11.300631531101143],
              [-18.687094280073918, -11.302773825591904],
              [-18.684940966551743, -11.302924511427054],
              [-18.683113960480128, -11.301856621765765],
              [-18.681539228331577, -11.299493484308522],
              [-18.68289724620819, -11.297144845199725],
              [-18.679032744138897, -11.298892326217667],
              [-18.677037289398733, -11.30030888332135],
              [-18.675791498887886, -11.300242748328246],
              [-18.673594898086122, -11.298981997285363],
              [-18.67185486167818, -11.297195648890545],
              [-18.67050658958479, -11.297526926479051],
              [-18.668007340655805, -11.299087330661367],
              [-18.667231545026024, -11.30072200682289],
              [-18.66746666589348, -11.302280454933188],
              [-18.66454843037955, -11.302561008120817],
              [-18.66150804166971, -11.30060451323123],
              [-18.66303399503048, -11.30348987296785],
              [-18.663071777918745, -11.305393107288516],
              [-18.663656830775484, -11.306267577274689],
              [-18.663832743805347, -11.309120126086885],
              [-18.65880580786479, -11.309754651683864],
              [-18.65557869767001, -11.309296756284047],
              [-18.65347663377549, -11.308621114404527],
              [-18.650249576987328, -11.306726114912896],
              [-18.646190422558632, -11.303148946115353],
              [-18.643915113771044, -11.299771415005017],
              [-18.64285849879559, -11.29659590717953],
              [-18.643359833839988, -11.29535985025564],
              [-18.645207342127037, -11.29360317688316],
              [-18.64648373576914, -11.293218554941133],
              [-18.64709726104033, -11.291305698435679],
              [-18.646799232174313, -11.289028519398366],
              [-18.646005305596578, -11.2882010022366],
              [-18.644416675057496, -11.2881506930021],
              [-18.64296312937926, -11.286886195140783],
              [-18.642489262896156, -11.285657410531838],
              [-18.639123566253026, -11.28396079904127],
              [-18.63789402960299, -11.284030324550725],
              [-18.63637499687648, -11.28275194609675],
              [-18.634828187694293, -11.282139368941769],
              [-18.633447902420258, -11.279668602897926],
              [-18.632435178274484, -11.2786312177556],
              [-18.631772720470195, -11.276102946320947],
              [-18.63028232221792, -11.274993346034053],
              [-18.628018297361823, -11.272493366805582],
              [-18.628024409051232, -11.270740263156803],
              [-18.62677081334958, -11.268043419212407],
              [-18.62484596321507, -11.264975695918585],
              [-18.62276563778725, -11.259514248070898],
              [-18.622403005432933, -11.256119725291498],
              [-18.622277291318326, -11.250373464984945],
              [-18.623119769736903, -11.244241169928184],
              [-18.624148982918747, -11.238601349416122],
              [-18.625015063362333, -11.2325137855085],
              [-18.624984691492173, -11.226873216335823],
              [-18.623632521200058, -11.215791459826047],
              [-18.62234972223812, -11.212110843876294],
              [-18.622012896741534, -11.207322827568126],
              [-18.622332486584224, -11.2020994400893],
              [-18.623581225977297, -11.19602694140284],
              [-18.62469392238639, -11.192945909119604],
              [-18.62801258796867, -11.186424402853062],
              [-18.62879437440956, -11.184359548142215],
              [-18.629350088778445, -11.181493670009152],
              [-18.62920174066065, -11.180088957880155],
              [-18.62771039022417, -11.177165170427266],
              [-18.624988427827365, -11.174533358678456],
              [-18.626741968486357, -11.171636613724804],
              [-18.629396664221996, -11.171051817797235],
              [-18.6326132878613, -11.16908663045417],
              [-18.6343980230971, -11.167351484923563],
              [-18.638603472652218, -11.159610637009179],
              [-18.64435276888278, -11.14842919886702],
              [-18.646947917782068, -11.143042291274192],
              [-18.649194445541372, -11.137803659588553],
              [-18.652987276572038, -11.122235591566929],
              [-18.65459310567198, -11.111728259481632],
              [-18.65572408506013, -11.10636555380257],
              [-18.657553334167712, -11.096335948959235],
              [-18.65739253587134, -11.094183080681498],
              [-18.652342207488648, -11.088714886880142],
              [-18.64972351132877, -11.08340078524887],
              [-18.646782325357847, -11.07787491853941],
              [-18.64332680691736, -11.07247553010758],
              [-18.636216371990837, -11.068478272829912],
              [-18.635766821024482, -11.062558837974125],
              [-18.634911629570073, -11.05940129952339],
              [-18.633317668428738, -11.058538711415347],
              [-18.632161370166447, -11.058990388681822],
              [-18.629811416568163, -11.058324813181295],
              [-18.627953655452473, -11.05656448017951],
              [-18.626334054218304, -11.055830469083649],
              [-18.62358322582743, -11.055228567374288],
              [-18.621107619799794, -11.055140377397576],
              [-18.61960690168833, -11.052228517971605],
              [-18.618543060806797, -11.049413033919782],
              [-18.61700002227532, -11.04631837204838],
              [-18.615316808539784, -11.044163836576805],
              [-18.613205250364167, -11.043025290825241],
              [-18.611507580235557, -11.043201724794507],
              [-18.608849757303407, -11.044391773572432],
              [-18.607737495594144, -11.042380798377032],
              [-18.60491653991358, -11.035025608297886],
              [-18.60289206770822, -11.031366979609247],
              [-18.60187252885038, -11.029053904437424],
              [-18.599988620760406, -11.027658287825469],
              [-18.599870134459906, -11.029851261013807],
              [-18.601596184497126, -11.030636762316869],
              [-18.60146053244941, -11.03268556745203],
              [-18.600363742308783, -11.033084838328243],
              [-18.597517006841798, -11.032679376973116],
              [-18.594834721864157, -11.033470452885574],
              [-18.593671101181812, -11.033310902725395],
              [-18.59000301541285, -11.0304861114223],
              [-18.58797291429225, -11.030129602282877],
              [-18.58720963227073, -11.027807798903677],
              [-18.586203308482137, -11.026289278258481],
              [-18.585301802735415, -11.023690891668034],
              [-18.58641557437434, -11.021087610148323],
              [-18.588445467675154, -11.01772055782341],
              [-18.591261252139486, -11.011645933095794],
              [-18.592041810348675, -11.007599198132334],
              [-18.593085897033912, -11.00501108330483],
              [-18.59511152343609, -11.001265143140945],
              [-18.599082827401748, -10.995434065449265],
              [-18.601576179178892, -10.990694642551992],
              [-18.60335347821999, -10.984765532470975],
              [-18.6035692128222, -10.983404112168575],
              [-18.60520515728935, -10.979959977771076],
              [-18.607465930805372, -10.975831978390406],
              [-18.6089499787376, -10.972236914683931],
              [-18.609741763904598, -10.965553420115706],
              [-18.609624140664216, -10.961459894607017],
              [-18.608562810015954, -10.959833465209536],
              [-18.610732068340887, -10.954453270537185],
              [-18.61056389639534, -10.953243672899806],
              [-18.608813016700832, -10.952178125794136],
              [-18.608527026426195, -10.950170528566641],
              [-18.610527158732694, -10.946708796202698],
              [-18.61299952236914, -10.941609725708606],
              [-18.61402740072377, -10.940032237110765],
              [-18.6153331251583, -10.936944379132534],
              [-18.615462086003614, -10.934557421758889],
              [-18.614716849743058, -10.933215260192664],
              [-18.615949769556835, -10.931151549212537],
              [-18.615988867611033, -10.927516366942063],
              [-18.617246974298688, -10.925093619057712],
              [-18.6174360032816, -10.923034270561423],
              [-18.62011133498884, -10.918644779535216],
              [-18.619629436629204, -10.915232449715505],
              [-18.621283532636532, -10.913146631316039],
              [-18.623946285382726, -10.908179234075067],
              [-18.626501163309726, -10.904906663035407],
              [-18.626243265838774, -10.903837519565556],
              [-18.627451408159054, -10.902792163528886],
              [-18.63180649900656, -10.89541336786391],
              [-18.63314319722464, -10.892679094299902],
              [-18.636336872210272, -10.88415049788494],
              [-18.638604453430258, -10.87422482519034],
              [-18.639132508248874, -10.869645436312238],
              [-18.638922717566505, -10.868469722477156],
              [-18.63719480153737, -10.866525476517545],
              [-18.63687896688899, -10.860480247720288],
              [-18.638161635815877, -10.857864133300685],
              [-18.63926206731651, -10.856469816734375],
              [-18.639090585260913, -10.85518235862163],
              [-18.643051860932726, -10.853515632405456],
              [-18.645532310986933, -10.848660646034439],
              [-18.647194439317953, -10.84593749692255],
              [-18.648370060948167, -10.843335399639743],
              [-18.649814910490633, -10.839399549235946],
              [-18.651561826804638, -10.83399283844066],
              [-18.651984694537614, -10.831308972631835],
              [-18.6516986406183, -10.826411000428989],
              [-18.652908966343098, -10.82381228724196],
              [-18.653051259818653, -10.82030421974696],
              [-18.65869908300623, -10.818828335328398],
              [-18.660047078335452, -10.816487038230004],
              [-18.660479325872966, -10.813199138457374],
              [-18.660116444093916, -10.809839941481552],
              [-18.66240955675898, -10.807249620141704],
              [-18.666401928816725, -10.801358672500518],
              [-18.66737370119371, -10.80049689540547],
              [-18.668192264514154, -10.79662670289319],
              [-18.670081308188806, -10.793134568627305],
              [-18.67226810955575, -10.786792001799892],
              [-18.67367457036899, -10.780774626408334],
              [-18.673638322598304, -10.780046472914355],
              [-18.68694649703781, -10.77655435872067],
              [-18.6895588571007, -10.780854606338243],
              [-18.694895011629345, -10.785532488896566],
              [-18.697298470188866, -10.791179417370573],
              [-18.697658029086547, -10.79583077559695],
              [-18.698183679718216, -10.796505834094422],
              [-18.697611005383454, -10.800081779674946],
              [-18.698704319402196, -10.806045975313848],
              [-18.698905042825725, -10.811239046820248],
              [-18.698094399207772, -10.816355430333338],
              [-18.697960716604655, -10.82138130962545],
              [-18.69832778999736, -10.822767034065803],
              [-18.6980207308572, -10.82536673609125],
              [-18.702465144494155, -10.830776243655134],
              [-18.703423269633973, -10.832349819294208],
              [-18.70343931853883, -10.833587764266424],
              [-18.705230699778674, -10.835779863396976],
              [-18.70770131740122, -10.837861322540766],
              [-18.711471087766096, -10.840489589397901],
              [-18.713826478135648, -10.84138980649013],
              [-18.71644310892346, -10.841573976380134],
              [-18.71788114769989, -10.840580548630712],
              [-18.72687059560599, -10.841212799544676],
              [-18.72995112909793, -10.840320031680722],
              [-18.733075484207422, -10.837724498267079],
              [-18.734818206173863, -10.837623928004794],
              [-18.73946466019251, -10.83391966114016],
              [-18.74151537617337, -10.833157185135663],
              [-18.745803942258334, -10.835041569462957],
              [-18.745276488839608, -10.838421358608205],
              [-18.745948027439606, -10.840611135067787],
              [-18.748838285529253, -10.844355577103384],
              [-18.75117821489478, -10.846494556085538],
              [-18.7537972893764, -10.84805893003862],
              [-18.75639184696851, -10.84912859001896],
              [-18.759544881446146, -10.850912676792461],
              [-18.76447002162571, -10.852318444811111],
              [-18.768749857910407, -10.852822859327174],
              [-18.77285216655039, -10.852944693512441],
              [-18.77680315270415, -10.853790908078754],
              [-18.779140730303133, -10.854787358999877],
              [-18.78164715047657, -10.857006060130223],
              [-18.791229301701737, -10.86139492025948],
              [-18.794560400632854, -10.863025468083697],
              [-18.802247555221292, -10.865482901329091],
              [-18.803441201631287, -10.865613084715134],
              [-18.81107403263635, -10.869444802792014],
              [-18.81355140640668, -10.870335895799053],
              [-18.81704438395799, -10.870527654532806],
              [-18.81734568282336, -10.871026973813477],
              [-18.819816218625267, -10.871358421064562],
              [-18.821956108406763, -10.87258357039183],
              [-18.82432737497519, -10.87315476032764],
              [-18.830875719726546, -10.874277730313102],
              [-18.837794984948815, -10.874888907267357],
              [-18.84215120194357, -10.874768176042961],
              [-18.847916906021094, -10.87654987346323],
              [-18.8515837459276, -10.87718970521046],
              [-18.86346703879014, -10.878472601132072],
              [-18.875836986132228, -10.879009970757002],
              [-18.88411380570091, -10.878884761289807],
              [-18.88877378018748, -10.878642228863717],
              [-18.897110892238473, -10.878624590287364],
              [-18.91434340545222, -10.877788624441397],
              [-18.921711727816568, -10.87704157558955],
              [-18.933002368417878, -10.87545854189539],
              [-18.938975330053612, -10.874400158277064],
              [-18.940313103299935, -10.873479182959018],
              [-18.942106503240975, -10.873921522294234],
              [-18.94340685085945, -10.872910750525339],
              [-18.94894666614601, -10.87150058363396],
              [-18.95210373537278, -10.871057213553017],
              [-18.954736303784554, -10.869939523164552],
              [-18.95700058073196, -10.86958451084827],
              [-18.957898279241036, -10.868868230566564],
              [-18.96045193634436, -10.86821994285768],
              [-18.965878825437397, -10.866184666629833],
              [-18.967280208348438, -10.864673929839833],
              [-18.969220915036217, -10.86366515269142],
              [-18.972970180007408, -10.863106779474517],
              [-18.974719176477574, -10.861442256113442],
              [-18.977866373145304, -10.859944239025447],
              [-18.980375105903676, -10.859352033708898],
              [-18.98275828337166, -10.857613377004022],
              [-18.985740933379226, -10.8561910389198],
              [-18.990774674491878, -10.85280667619534],
              [-18.994101034479044, -10.849699066390713],
              [-18.997987210888557, -10.842255838256227],
              [-18.998691726480306, -10.83977422771485],
              [-18.9988520704011, -10.837313236365935],
              [-19.000236329376413, -10.829052238066],
              [-19.00278862247155, -10.819317797770806],
              [-19.00340991757403, -10.815002300489631],
              [-19.003268763857, -10.81277905288088],
              [-19.00075172970072, -10.811491369770277],
              [-18.997312485378593, -10.808427664437469],
              [-18.99409348647502, -10.806776819890754],
              [-18.99172346939432, -10.807052950044062],
              [-18.989853263269733, -10.808374497718981],
              [-18.987036846768337, -10.807408880710241],
              [-18.984093700897155, -10.806835710421524],
              [-18.98328677830274, -10.80529617812422],
              [-18.98528143045321, -10.803832589860699],
              [-18.98492964189647, -10.802121073281638],
              [-18.98361036859402, -10.800390049115224],
              [-18.98419832396424, -10.798786340291068],
              [-18.98553277836585, -10.798605787707057],
              [-18.987870217784085, -10.796529965449796],
              [-18.992107913237422, -10.788793924140442],
              [-18.993183131471536, -10.787924924560365],
              [-18.993942196196727, -10.786357892168756],
              [-18.995845916863537, -10.784347412277802],
              [-19.000524688266122, -10.782141846911545],
              [-19.00203839750898, -10.780853535131943],
              [-19.00356156509138, -10.778949479326494],
              [-19.011373581056443, -10.773128389176824],
              [-19.013109141103183, -10.773031740148195],
              [-19.01398684461943, -10.771446231168449],
              [-19.015767103497716, -10.772099680228495],
              [-19.017798155593976, -10.771190634976918],
              [-19.019521446840848, -10.767567897442486],
              [-19.01916808397276, -10.765882177607471],
              [-19.01996912964769, -10.76434971564951],
              [-19.021230007396742, -10.76307798830201],
              [-19.022742821041245, -10.762595184366258],
              [-19.0243869311188, -10.763423452847773],
              [-19.02449410581253, -10.762034342896765],
              [-19.025321946038094, -10.760725358394554],
              [-19.028146479037236, -10.754100589464853],
              [-19.028372656348104, -10.75251841786756],
              [-19.029600954473217, -10.749316492848331],
              [-19.03173622783862, -10.74567176826259],
              [-19.033970185979364, -10.740421080151547],
              [-19.037838488955423, -10.730191607111923],
              [-19.038192231551335, -10.728042082025857],
              [-19.03770071893379, -10.726648833979613],
              [-19.0366982715219, -10.72629261235059],
              [-19.0360561367711, -10.724905767778814],
              [-19.03705025332576, -10.723508574058783],
              [-19.037344887175312, -10.721275605812869],
              [-19.038977181549146, -10.718996170955291],
              [-19.04023195582868, -10.717885206246125],
              [-19.042634082095283, -10.716605006064878],
              [-19.044026151580773, -10.715266382013933],
              [-19.046775388694844, -10.714217249620226],
              [-19.05484193315102, -10.704947680484663],
              [-19.05625909528215, -10.702394587767138],
              [-19.05827889261034, -10.699740291561598],
              [-19.058878936699177, -10.69844866814312],
              [-19.05983284602434, -10.694626489580664],
              [-19.059838243193838, -10.690435218054745],
              [-19.058070707818118, -10.690371329266975],
              [-19.058154749176605, -10.687720005637878],
              [-19.057855116086735, -10.686531333756081],
              [-19.058882502598923, -10.68544088252953],
              [-19.060169417837553, -10.685421886502121],
              [-19.060896035421823, -10.6842758882815],
              [-19.0604834445211, -10.678368518459452],
              [-19.060065863178053, -10.677096846025119],
              [-19.061806153742857, -10.67642820079966],
              [-19.063111520223217, -10.676652370404387],
              [-19.064867288218775, -10.678719894797377],
              [-19.067308520004854, -10.680531849447199],
              [-19.068392659988255, -10.680916800861512],
              [-19.074112803258956, -10.680019907676245],
              [-19.076909561899978, -10.679299797798643],
              [-19.078844588578427, -10.678457668839355],
              [-19.08297556378972, -10.677277442389794],
              [-19.088676757893776, -10.674791015975147],
              [-19.091189807485545, -10.673343229839066],
              [-19.09682622205596, -10.669431755107217],
              [-19.098774295765292, -10.667502294072591],
              [-19.104784850114186, -10.661998002065234],
              [-19.105781768310916, -10.66043995129045],
              [-19.108249547532964, -10.65795010666294],
              [-19.11254029870947, -10.652311662046262],
              [-19.116098525877955, -10.648206084841695],
              [-19.120670750596567, -10.64140512685633],
              [-19.121442985656902, -10.639241953693087],
              [-19.122197524336503, -10.638521724922969],
              [-19.127334375991452, -10.629531186447426],
              [-19.127609278605764, -10.62849246185232],
              [-19.129769119908637, -10.624504499396892],
              [-19.131108099098796, -10.621250153206155],
              [-19.132374284760093, -10.617232857083508],
              [-19.131795100494053, -10.615194197124817],
              [-19.12969860167052, -10.616138291967895],
              [-19.128284481167725, -10.61587210101387],
              [-19.1274022103633, -10.61676597419453],
              [-19.12555157831577, -10.616005629868365],
              [-19.124335818024363, -10.615028091963216],
              [-19.12267350875442, -10.61541559807896],
              [-19.1198278648177, -10.614285874641201],
              [-19.116765634591122, -10.614791923624125],
              [-19.114615957034985, -10.613560470909905],
              [-19.10953778274252, -10.611613766318754],
              [-19.10662098101962, -10.608853987130102],
              [-19.105677657562506, -10.606836108055298],
              [-19.104744654620802, -10.60578212476039],
              [-19.10375614070997, -10.603565354888621],
              [-19.104255065498574, -10.602971213461636],
              [-19.10265787707923, -10.600754189328452],
              [-19.101219197447016, -10.600928916285014],
              [-19.099004430582667, -10.600308424437591],
              [-19.098306641876714, -10.597289286698159],
              [-19.096827540210462, -10.593928199450561],
              [-19.097349293765763, -10.590756215078256],
              [-19.09816402865723, -10.589622452988602],
              [-19.101166137301302, -10.587957107253485],
              [-19.104316613269173, -10.588381014416958],
              [-19.10609165769338, -10.587884144304407],
              [-19.107607583783246, -10.586959038975854],
              [-19.11049375297941, -10.58594703767846],
              [-19.113119326792006, -10.585599616471335],
              [-19.115417911315703, -10.587921423666728],
              [-19.11663681130414, -10.588763722978536],
              [-19.118277510438126, -10.588205567630583],
              [-19.120839360044435, -10.588558747635942],
              [-19.122023622388372, -10.590881165391465],
              [-19.124503370490118, -10.591472846052795],
              [-19.124840910735063, -10.592113054336735],
              [-19.127417993519042, -10.5917051734457],
              [-19.128136331986894, -10.592753401940955],
              [-19.131547796042096, -10.592984023430123],
              [-19.13333155356711, -10.596006128839218],
              [-19.135784098163388, -10.596068135338863],
              [-19.137674499478802, -10.597635391911423],
              [-19.13869147447507, -10.597918946782482],
              [-19.1435776675196, -10.596731527620488],
              [-19.145203330861847, -10.597032933081639],
              [-19.146914168662047, -10.596683224253344],
              [-19.14906181664415, -10.596958401985685],
              [-19.149736151094928, -10.59750118576917],
              [-19.151532578780404, -10.597116770654834],
              [-19.156679215769135, -10.592629692481335],
              [-19.158283867574468, -10.591794286117098],
              [-19.1632444592536, -10.590215909318955],
              [-19.164816479388264, -10.590532755084999],
              [-19.167500850360632, -10.589226994965907],
              [-19.168638375067165, -10.5879264310078],
              [-19.169604484741853, -10.58430865963245],
              [-19.16960025228749, -10.58128525952911],
              [-19.169903448502712, -10.58018842143297],
              [-19.17146627244889, -10.579820850602713],
              [-19.172085881382074, -10.578955992364886],
              [-19.17205542535085, -10.575150625173503],
              [-19.173499572680246, -10.573858186193492],
              [-19.172790282498596, -10.571584382251231],
              [-19.168025387935824, -10.570001291683932],
              [-19.16662039674486, -10.568009117761648],
              [-19.165363888622462, -10.565162612018447],
              [-19.163555669810396, -10.56468289983129],
              [-19.16277624306735, -10.565183750728105],
              [-19.16045936835837, -10.56512156436967],
              [-19.15824129558575, -10.566649104757737],
              [-19.156875587793248, -10.566634833847614],
              [-19.15425608651272, -10.567835546155454],
              [-19.150733454326613, -10.568717082861294],
              [-19.14773951427644, -10.568485516578814],
              [-19.145724599571096, -10.567352197640613],
              [-19.142799321655946, -10.564899351155665],
              [-19.141844974434726, -10.562974267802153],
              [-19.14290167175436, -10.561099912895132],
              [-19.142612613301193, -10.56026937876774],
              [-19.13977808995237, -10.55749633813169],
              [-19.137502934739338, -10.55591693963477],
              [-19.135407973578285, -10.55679955380189],
              [-19.13418639727328, -10.556534446621022],
              [-19.13200072845024, -10.557370270379488],
              [-19.1309573243132, -10.55729958686628],
              [-19.128305914103365, -10.55567994872046],
              [-19.12633249032567, -10.553803750175492],
              [-19.125104963859314, -10.551499860985317],
              [-19.12244171751593, -10.548573435625574],
              [-19.122068888917063, -10.547247583499699],
              [-19.12018284574369, -10.546582573456453],
              [-19.119030154871197, -10.547304778206218],
              [-19.117260026939057, -10.546354512728012],
              [-19.11590064113016, -10.547192354151235],
              [-19.113188563685384, -10.546989911082683],
              [-19.112449501017718, -10.544603434991043],
              [-19.11063900898586, -10.542089087152144],
              [-19.110265061759133, -10.540988840069407],
              [-19.10712315429927, -10.539225997424717],
              [-19.105903287989534, -10.537267364701089],
              [-19.10500403545941, -10.536580327513809],
              [-19.103329702914763, -10.536653125048204],
              [-19.100851022343974, -10.537918176244107],
              [-19.099174444455883, -10.53817387813164],
              [-19.09615603706152, -10.537040919198363],
              [-19.09466907699243, -10.535554041282387],
              [-19.092940345797846, -10.534697531820655],
              [-19.088934100730583, -10.531078506032388],
              [-19.08723634615233, -10.52736717249306],
              [-19.087000459385568, -10.52622256050338],
              [-19.088266944687252, -10.52379191710958],
              [-19.092890119844945, -10.518621905731912],
              [-19.09466751491826, -10.515068614164571],
              [-19.095241114732154, -10.510329077688494],
              [-19.093574473499814, -10.508855607262158],
              [-19.09358554855191, -10.50783770449363],
              [-19.09550804290481, -10.50624060611159],
              [-19.0944379601865, -10.503694466415034],
              [-19.092181889782434, -10.504466208713591],
              [-19.090428206108967, -10.503989220676036],
              [-19.088224663751834, -10.504656236684585],
              [-19.08607207959956, -10.503933161733661],
              [-19.08474490852054, -10.503999982331253],
              [-19.082167735200567, -10.503395256149277],
              [-19.081229013619758, -10.50233064451368],
              [-19.078670698976616, -10.501486119089108],
              [-19.0778032650119, -10.50025170892019],
              [-19.074676459048508, -10.499003843663424],
              [-19.069982910417977, -10.497732421744308],
              [-19.06788979900096, -10.496612231136604],
              [-19.064731513712076, -10.492926729680795],
              [-19.063964533673943, -10.492382184934751],
              [-19.06267421223287, -10.488840715756634],
              [-19.064238407445636, -10.484634325853133],
              [-19.07223451952485, -10.476989599319793],
              [-19.073297941824038, -10.475418176935106],
              [-19.075229995455693, -10.47088972727875],
              [-19.07543584142575, -10.46824436412897],
              [-19.074930172499517, -10.466343446881599],
              [-19.07164857638286, -10.460830214350121],
              [-19.07060452380648, -10.459605267659427],
              [-19.067110392031992, -10.458133110845086],
              [-19.066026212779846, -10.454246176774625],
              [-19.06702406336728, -10.451577188795296],
              [-19.069835903056283, -10.450834755760555],
              [-19.071980184275315, -10.45096898662045],
              [-19.07364506372994, -10.45152499410914],
              [-19.075046252748166, -10.45256885824178],
              [-19.07644988815208, -10.455310963775219],
              [-19.08205120434955, -10.458315294300569],
              [-19.08583967259412, -10.461662828160046],
              [-19.08825807566565, -10.461946467284303],
              [-19.091185499607608, -10.461234324538626],
              [-19.094191993565246, -10.460166355120016],
              [-19.095547426224552, -10.458939883206654],
              [-19.10105633568604, -10.456500202979312],
              [-19.102274916744665, -10.455286972874463]
            ]
          ],
          [
            [
              [-19.540798873620595, -10.623843871252506],
              [-19.537342820052416, -10.625811039837352],
              [-19.535656914902454, -10.628710946371541],
              [-19.533473090530624, -10.629629607014468],
              [-19.532176883451577, -10.629057481737192],
              [-19.530396304722693, -10.629186694472564],
              [-19.52886062061436, -10.628371253351188],
              [-19.527141438819896, -10.62646891677119],
              [-19.524918658866223, -10.624667787735211],
              [-19.521825209617518, -10.623728015700397],
              [-19.519024959755846, -10.623997148139974],
              [-19.51604127885051, -10.622160847417083],
              [-19.514340851596497, -10.62185603607754],
              [-19.511718961983316, -10.622171406121907],
              [-19.508362791220485, -10.623505509649721],
              [-19.506923244628336, -10.624873003590027],
              [-19.507184908211073, -10.625735904451988],
              [-19.50920760482625, -10.627807609797221],
              [-19.50521994237879, -10.628122894740352],
              [-19.503851499651766, -10.629330510838452],
              [-19.503223012589796, -10.626274169101135],
              [-19.500250635636363, -10.624577579588836],
              [-19.49819824939038, -10.625109309384804],
              [-19.495821423121317, -10.625185324159418],
              [-19.495193423878636, -10.6257045270267],
              [-19.490676688476018, -10.627013305234534],
              [-19.488822500303634, -10.628002809258986],
              [-19.48764686146536, -10.629336419308803],
              [-19.488038449536127, -10.63125434328575],
              [-19.483761624272617, -10.630351335204931],
              [-19.478777729242758, -10.628131512080564],
              [-19.478861666495845, -10.630504277944917],
              [-19.477531395223895, -10.631908512611309],
              [-19.469662941942683, -10.63708712417871],
              [-19.4672806893172, -10.637760344308948],
              [-19.46235059946888, -10.637142561824218],
              [-19.460396604600408, -10.636712854221978],
              [-19.45439302334591, -10.637423351559839],
              [-19.453392185639203, -10.637035846805464],
              [-19.452216864863217, -10.63765881245113],
              [-19.451730219283885, -10.639622784175852],
              [-19.453218483750476, -10.641183290860754],
              [-19.45307010045104, -10.643892901720248],
              [-19.45158673060871, -10.644762605241057],
              [-19.44738424123765, -10.645783885639501],
              [-19.444638183094973, -10.645379696075343],
              [-19.444007881142586, -10.643381981618049],
              [-19.442474699922144, -10.642639260183051],
              [-19.440806334262685, -10.643002729535189],
              [-19.440140152244332, -10.64471006827026],
              [-19.440079757297433, -10.646404702010278],
              [-19.43809087426903, -10.647058145948613],
              [-19.436129459327802, -10.644901026558498],
              [-19.434446614210465, -10.644456003816245],
              [-19.433301351326076, -10.642495530011328],
              [-19.431387493822182, -10.641201981587331],
              [-19.429734030817283, -10.641955754538413],
              [-19.428162196163314, -10.63742028447011],
              [-19.4266917823917, -10.636664510763751],
              [-19.427630604281767, -10.635799785013429],
              [-19.427101801948265, -10.63461464182549],
              [-19.428287738574788, -10.63204246422101],
              [-19.426972862827164, -10.630800994799067],
              [-19.427097092852325, -10.629739961118855],
              [-19.429102262738375, -10.628027397867186],
              [-19.429861394278856, -10.62626404099385],
              [-19.43006054154758, -10.624214180532404],
              [-19.428895213757595, -10.62435517111352],
              [-19.426062311133947, -10.621582481242411],
              [-19.423794519220664, -10.621333697754594],
              [-19.421873687405068, -10.61861435977697],
              [-19.420926084298998, -10.618899394213264],
              [-19.418616260410598, -10.618222961289758],
              [-19.41740780272829, -10.617190530940167],
              [-19.415985853231767, -10.615184250988221],
              [-19.411477804137995, -10.613850343238523],
              [-19.41070503336154, -10.615654289962219],
              [-19.409354128495124, -10.616119094379219],
              [-19.408117543052878, -10.618011498801364],
              [-19.406030786890934, -10.616441556977056],
              [-19.4051736949828, -10.612940265199278],
              [-19.406181875721924, -10.611692736017897],
              [-19.406373108455362, -10.609483181061325],
              [-19.40485388538702, -10.609938151836117],
              [-19.404336104664317, -10.613037744336154],
              [-19.40302804143942, -10.613824672287667],
              [-19.398194538376895, -10.614432031819549],
              [-19.397318784791683, -10.61263215015054],
              [-19.398557581274215, -10.611279778179197],
              [-19.39714084385913, -10.610555356783296],
              [-19.393924814193824, -10.612158008736154],
              [-19.392077624246834, -10.614245561356011],
              [-19.389173956167888, -10.616491465381783],
              [-19.390094164648506, -10.618739044457872],
              [-19.387882263238073, -10.618970307215081],
              [-19.386828937034096, -10.619997095654433],
              [-19.38480784352023, -10.616921764060557],
              [-19.38216608770136, -10.615909244172272],
              [-19.382417865967593, -10.611414704370647],
              [-19.381688611265343, -10.609173750760736],
              [-19.38245094288623, -10.608265371985041],
              [-19.38219272356023, -10.605336839882746],
              [-19.380108345173934, -10.604385937380748],
              [-19.37813634163476, -10.6046536979102],
              [-19.377333484639166, -10.602779826382898],
              [-19.373956798835128, -10.603331760016829],
              [-19.372410813253442, -10.602031066750026],
              [-19.370444197158637, -10.601139931788724],
              [-19.369343887400387, -10.599982829973131],
              [-19.36910889717974, -10.59866385841271],
              [-19.36760083129961, -10.598843053409675],
              [-19.36587706011852, -10.59683289740678],
              [-19.364356549119766, -10.59759198017443],
              [-19.362245099896636, -10.597883690127597],
              [-19.361010171886093, -10.599043422905808],
              [-19.35994395393268, -10.59924244973932],
              [-19.35938238485734, -10.600544465444004],
              [-19.358297736071872, -10.600540419205732],
              [-19.35648987998886, -10.601434806778888],
              [-19.355504434165816, -10.603352876172448],
              [-19.352731689239498, -10.604653152356715],
              [-19.352067607798542, -10.60607765716856],
              [-19.352090644095995, -10.607498504287168],
              [-19.350051979841602, -10.608393332005555],
              [-19.348118000442852, -10.611354709921814],
              [-19.344387071918366, -10.610496391848717],
              [-19.3426666225952, -10.609678962223361],
              [-19.342790373779188, -10.608582224784703],
              [-19.3389805874349, -10.607737719045971],
              [-19.335412403661117, -10.6072811240755],
              [-19.33307855895314, -10.604986775162748],
              [-19.329543733163245, -10.604914894118581],
              [-19.328139067006802, -10.604430383608557],
              [-19.32245341680456, -10.604545199011412],
              [-19.322729513292117, -10.606330774263386],
              [-19.320788254980073, -10.60839876916985],
              [-19.32050996864541, -10.606819815115358],
              [-19.319319472404764, -10.604603385293968],
              [-19.317865097934405, -10.604621764170046],
              [-19.314724196268354, -10.60397891581513],
              [-19.313234489246284, -10.604580621028791],
              [-19.312905780779662, -10.605486353002108],
              [-19.31471756076077, -10.60835306005254],
              [-19.313575602156053, -10.609696231000909],
              [-19.312158096109076, -10.608366110572241],
              [-19.309947402920383, -10.60967638079339],
              [-19.308460791465443, -10.609967667024984],
              [-19.30819883118918, -10.611562679430646],
              [-19.30638794436968, -10.61024134607207],
              [-19.306255934255713, -10.608986323445427],
              [-19.305077997989354, -10.608148575657962],
              [-19.30401203593102, -10.60646548719984],
              [-19.303891690304063, -10.603167969833976],
              [-19.30449403519548, -10.60105920436825],
              [-19.306207775356558, -10.599881897810375],
              [-19.30914438928, -10.602212565201508],
              [-19.308716983849166, -10.600497087267621],
              [-19.307532218824143, -10.599290378458585],
              [-19.305989458138114, -10.596953904485417],
              [-19.30588427141598, -10.595180454176544],
              [-19.30744352537934, -10.594072648002212],
              [-19.307285001620187, -10.59268010501076],
              [-19.306151386023505, -10.591629835156695],
              [-19.305555544059914, -10.594539946049412],
              [-19.303192787059878, -10.594804868076745],
              [-19.302174191660487, -10.59536044165153],
              [-19.30128409238153, -10.597376338408852],
              [-19.301229849711596, -10.601074621519352],
              [-19.30209794401874, -10.602483677282553],
              [-19.303195157842236, -10.603005802052053],
              [-19.303432116359964, -10.604488303490818],
              [-19.30280725107419, -10.60526161303384],
              [-19.301815584495923, -10.608184183039556],
              [-19.30190902101027, -10.609569424912019],
              [-19.303295759310675, -10.61129805588529],
              [-19.3026415860993, -10.61358268668068],
              [-19.299894282707015, -10.615483755567649],
              [-19.300136940997653, -10.617111216544735],
              [-19.30124525828016, -10.618355046876998],
              [-19.299987618279882, -10.620873918636905],
              [-19.297150684803636, -10.623533726845547],
              [-19.295828151398684, -10.624041239506035],
              [-19.296473361311318, -10.625596975593538],
              [-19.298537965727412, -10.626380061510718],
              [-19.30000630802981, -10.628097229621106],
              [-19.300038069421216, -10.629268749852514],
              [-19.30102200720783, -10.631404555701035],
              [-19.29995266721962, -10.631597970179815],
              [-19.298621531802723, -10.63095032361012],
              [-19.29734221011658, -10.63202826934903],
              [-19.29494060767828, -10.633019565753775],
              [-19.293215078085154, -10.632938168656866],
              [-19.288814597045896, -10.634845912293688],
              [-19.287835133003277, -10.635972202539287],
              [-19.286604244684938, -10.636420426695675],
              [-19.283603429685964, -10.636773228820351],
              [-19.27924821186617, -10.636344911885073],
              [-19.27807922041184, -10.635438644068355],
              [-19.273227722645984, -10.636718352887744],
              [-19.272221353102925, -10.636237037502779],
              [-19.27193910234448, -10.632901142118564],
              [-19.27090745644369, -10.632507103413117],
              [-19.27088019990912, -10.630778313075583],
              [-19.27016079603363, -10.630493857870954],
              [-19.268114057057716, -10.631147306009442],
              [-19.266290533043207, -10.630976703378552],
              [-19.26448126934561, -10.629977605980153],
              [-19.25965360774511, -10.634095080656662],
              [-19.257624236431468, -10.634619899577535],
              [-19.256137527383295, -10.635832131318216],
              [-19.253095401385654, -10.635833548437583],
              [-19.254030108829905, -10.637525714679526],
              [-19.2533026945146, -10.638562545523193],
              [-19.24977485304938, -10.639102715182844],
              [-19.248006757876237, -10.63809321901805],
              [-19.24749872616655, -10.639421037185176],
              [-19.24852189967199, -10.640231801339947],
              [-19.24836661792517, -10.64120842376738],
              [-19.246718068481176, -10.644058762781274],
              [-19.242686071933438, -10.646419301272354],
              [-19.24098377298379, -10.646459927581336],
              [-19.23959666482471, -10.645939284761164],
              [-19.237438452524078, -10.647143435706093],
              [-19.238862593134826, -10.649247712477479],
              [-19.23684041477593, -10.651666852274266],
              [-19.23572548947494, -10.651614303403512],
              [-19.23390418705494, -10.653419649491587],
              [-19.235852294598548, -10.65530994539082],
              [-19.23658311598266, -10.657041564281915],
              [-19.235288848932157, -10.658652369209397],
              [-19.234084640291393, -10.65880066410077],
              [-19.23447553431418, -10.660385517332136],
              [-19.233736287368693, -10.661837353276661],
              [-19.23592529466384, -10.662054350831673],
              [-19.237392102960793, -10.663699742987452],
              [-19.23806146582197, -10.666704892044452],
              [-19.240985657784577, -10.666937740381412],
              [-19.2426881448821, -10.66653603394834],
              [-19.244093384290252, -10.66748912399141],
              [-19.244442911771085, -10.669413941119368],
              [-19.243642403420985, -10.670412834207253],
              [-19.244094553543803, -10.672443794677733],
              [-19.24383731071644, -10.674020410116944],
              [-19.242386303873364, -10.675930208719421],
              [-19.240012529686787, -10.675517607308501],
              [-19.23924875337369, -10.676148057359034],
              [-19.240563401605062, -10.68063757384047],
              [-19.238909883771605, -10.683286849306837],
              [-19.23951629738789, -10.685251901799154],
              [-19.240394536769568, -10.686175681808496],
              [-19.242650942448222, -10.687313942410636],
              [-19.245276093637138, -10.690252526173614],
              [-19.247013799660003, -10.69314002723296],
              [-19.247736487965845, -10.69504487791392],
              [-19.24893985518688, -10.69636818188947],
              [-19.24764872174573, -10.69987112890444],
              [-19.24448575891627, -10.700217431571463],
              [-19.24126438042686, -10.700241010650107],
              [-19.24070286697253, -10.703159464609417],
              [-19.24189204539077, -10.705565820980413],
              [-19.243694072081574, -10.705333870734224],
              [-19.244658278911366, -10.70649323281726],
              [-19.244200498553294, -10.707901430074074],
              [-19.242726120759553, -10.70832477761208],
              [-19.242243763668146, -10.710526005030175],
              [-19.24066456236324, -10.711299683934728],
              [-19.24202805363772, -10.712348609414892],
              [-19.24113697901054, -10.713915556788315],
              [-19.24338307267369, -10.716596817301674],
              [-19.242722882225276, -10.718747246927734],
              [-19.243098106846674, -10.72059256227335],
              [-19.24511992396148, -10.722026432659074],
              [-19.24545322014612, -10.723173275145546],
              [-19.247601952196096, -10.724377113954247],
              [-19.248917722889864, -10.724687417463848],
              [-19.251774794779845, -10.728635931363371],
              [-19.252424307674904, -10.731059005416519],
              [-19.25122862037881, -10.732807099139313],
              [-19.248280644509645, -10.7336968118682],
              [-19.248399713642513, -10.736213611363453],
              [-19.249745649156356, -10.741096803001843],
              [-19.249252940161483, -10.742556430965768],
              [-19.246622293308636, -10.742890613041961],
              [-19.24625297350798, -10.745036288722455],
              [-19.24190442856906, -10.74820783945203],
              [-19.243796414704182, -10.748669892561093],
              [-19.24275470870034, -10.74989220466779],
              [-19.244544866384437, -10.752121076179446],
              [-19.24517260512169, -10.75396955733871],
              [-19.247086056839485, -10.755011176858087],
              [-19.247195746875207, -10.757950618991273],
              [-19.245504313779374, -10.761412758213414],
              [-19.243469274374334, -10.764142675048925],
              [-19.24467355017539, -10.765684506995314],
              [-19.245070032375935, -10.766949958336864],
              [-19.242808807181195, -10.767259402881693],
              [-19.240657221134402, -10.76700718902034],
              [-19.239944522923608, -10.766088466563792],
              [-19.240190269183273, -10.76487839179133],
              [-19.238945052627766, -10.76451076354565],
              [-19.237996855637537, -10.76321642030273],
              [-19.23698581858542, -10.763683168382318],
              [-19.235349038413105, -10.763008020025653],
              [-19.23421205004948, -10.765121719299044],
              [-19.233121166433136, -10.765143855001224],
              [-19.23142865992906, -10.763685818551734],
              [-19.229769084651043, -10.764763955145922],
              [-19.231605871356795, -10.766322397803961],
              [-19.232368823906096, -10.768233318536739],
              [-19.233783956604412, -10.770490595211925],
              [-19.235069178117147, -10.769434360522558],
              [-19.23684575173531, -10.769710842458087],
              [-19.23890215763581, -10.7724826044264],
              [-19.23955940402067, -10.775205715180036],
              [-19.238943201420046, -10.776939593355324],
              [-19.237809164168386, -10.778137461931731],
              [-19.236013864498506, -10.77752983491571],
              [-19.235374673404404, -10.778432997419555],
              [-19.236107375950937, -10.779934097283153],
              [-19.23593036430618, -10.781300168538323],
              [-19.23944046956754, -10.785117994814525],
              [-19.239923625611176, -10.786871699242793],
              [-19.241679601043593, -10.78748650230014],
              [-19.242937346505116, -10.786266283827786],
              [-19.24494396663198, -10.785458811013527],
              [-19.245957986281493, -10.785700559167388],
              [-19.246832497539046, -10.787511679757456],
              [-19.249636962782354, -10.788319337989542],
              [-19.25251329807066, -10.786482010004814],
              [-19.25513121521235, -10.787655290569578],
              [-19.256059098078715, -10.786950155774718],
              [-19.25773008902303, -10.787786849252617],
              [-19.26143010487586, -10.787934231678742],
              [-19.26329062735517, -10.789113228885787],
              [-19.264793595679883, -10.78901725335493],
              [-19.265294829200993, -10.787591688404033],
              [-19.264787704182783, -10.786426934651342],
              [-19.266260145028692, -10.784539015349052],
              [-19.267862249810758, -10.7847592652266],
              [-19.268842474092228, -10.7834172585484],
              [-19.271452550704915, -10.783376504883483],
              [-19.273236009946046, -10.784358279542637],
              [-19.273918490301682, -10.785784723208314],
              [-19.275753301720393, -10.784500203339958],
              [-19.276865439535108, -10.78434592210889],
              [-19.280545847343475, -10.785995717056569],
              [-19.281580349924734, -10.78518602384738],
              [-19.283700452429603, -10.784769508191806],
              [-19.286765138257493, -10.785815983612597],
              [-19.28837202558196, -10.78674394643501],
              [-19.2924763324139, -10.789989616351319],
              [-19.293440010681394, -10.78948390646757],
              [-19.295460744018456, -10.78966839570455],
              [-19.296396148498278, -10.791761746387428],
              [-19.297977072468484, -10.790475979066304],
              [-19.29853444352355, -10.789372593419573],
              [-19.298521920598905, -10.787701097121312],
              [-19.301750861113117, -10.78687477440626],
              [-19.30490583838985, -10.786562326759586],
              [-19.30867208327324, -10.786809647503308],
              [-19.314319866160005, -10.787848305770275],
              [-19.319236592139248, -10.789267551950042],
              [-19.32210247050639, -10.790342922202727],
              [-19.32820757487888, -10.793346604349424],
              [-19.33077542646908, -10.794851930162173],
              [-19.335843604504, -10.798168254883734],
              [-19.337403838176435, -10.79880777731028],
              [-19.33900626486407, -10.798768840276496],
              [-19.340953368196462, -10.797408972935719],
              [-19.342208324848787, -10.79890034620669],
              [-19.339800943593822, -10.801643757419631],
              [-19.33949220856462, -10.80450962585279],
              [-19.338202392538513, -10.805540367716242],
              [-19.337803676163855, -10.806577613122158],
              [-19.338718399656557, -10.809642347564411],
              [-19.336376120769977, -10.812752194283451],
              [-19.33626911650975, -10.815122118626293],
              [-19.334695221822653, -10.816456149224141],
              [-19.334619438399148, -10.817183508669515],
              [-19.33634634019402, -10.818928488175551],
              [-19.336743972130716, -10.82150249507112],
              [-19.338162759301476, -10.822505855553581],
              [-19.339576717863437, -10.822123985477731],
              [-19.340898580764204, -10.823060762240782],
              [-19.34586598531984, -10.822159841925],
              [-19.34796849362948, -10.822954163851277],
              [-19.34851163043886, -10.82369590442503],
              [-19.35080636526495, -10.82235413900002],
              [-19.354669987777065, -10.821902265371962],
              [-19.355663019036403, -10.821090804256633],
              [-19.357754382834397, -10.816885387840031],
              [-19.3560698647278, -10.815386842882155],
              [-19.356262576735247, -10.813041784095075],
              [-19.35736756847131, -10.81036219179645],
              [-19.35945059590496, -10.806580575306024],
              [-19.361918811027255, -10.802602687576979],
              [-19.36483569881071, -10.798542560624403],
              [-19.368094184189108, -10.795174683897935],
              [-19.372602074065004, -10.79192175902434],
              [-19.374271793769353, -10.791676962188095],
              [-19.374988238480224, -10.792320764971329],
              [-19.376110031210164, -10.791316519605363],
              [-19.378573512532096, -10.786477871543944],
              [-19.38096131395247, -10.784127831304604],
              [-19.383759268878322, -10.78193212016148],
              [-19.38683949199425, -10.779997445181237],
              [-19.389688170675864, -10.778733968949503],
              [-19.391670867318044, -10.778910022021861],
              [-19.393006436099007, -10.778367521654259],
              [-19.39482677737805, -10.778908793590121],
              [-19.397369850378766, -10.778475971435586],
              [-19.39763014145482, -10.779601772076866],
              [-19.399224335293436, -10.78039441352615],
              [-19.400810270566204, -10.77917500952931],
              [-19.402842072324354, -10.779927512768397],
              [-19.403996730230563, -10.778998088834697],
              [-19.401975876353355, -10.776336001657802],
              [-19.40491920395646, -10.776874926408428],
              [-19.406608951103877, -10.77804716036483],
              [-19.408120268434814, -10.777428055184238],
              [-19.409531075109463, -10.777708506464682],
              [-19.41058610521078, -10.776923155001088],
              [-19.41298417993108, -10.776723873344423],
              [-19.415710684186955, -10.776902912019645],
              [-19.418662992673152, -10.775633043854965],
              [-19.421267340754554, -10.775078577900826],
              [-19.422189293488277, -10.772534195591835],
              [-19.423363764605156, -10.772039437313255],
              [-19.425824339038833, -10.768595390838577],
              [-19.425405493991118, -10.766892296568079],
              [-19.428058212742833, -10.76378988491498],
              [-19.427893204923016, -10.762626378389275],
              [-19.42982028001103, -10.76230257400535],
              [-19.437098059798547, -10.757753126964715],
              [-19.437633234059643, -10.756603072602491],
              [-19.443060178579458, -10.755777322598634],
              [-19.444584697871758, -10.753746045918364],
              [-19.444833703383257, -10.75147677502496],
              [-19.446613355221707, -10.748495950582576],
              [-19.451389329104792, -10.741965814711717],
              [-19.453899289211115, -10.738740096527492],
              [-19.459068000120592, -10.732949653988479],
              [-19.460401770011984, -10.7316876599125],
              [-19.46359527920737, -10.727993626701695],
              [-19.46513560061577, -10.726712025737285],
              [-19.46781091740897, -10.725189535458114],
              [-19.4692761873844, -10.724696181173988],
              [-19.471116539312057, -10.723334632417469],
              [-19.471309067998014, -10.721978826031568],
              [-19.47346644947617, -10.720095294722487],
              [-19.47807135012217, -10.717671765279862],
              [-19.481442680603287, -10.71626143277176],
              [-19.485816410100192, -10.711975884084248],
              [-19.488788969495797, -10.712984148251214],
              [-19.491796684974812, -10.711976662200502],
              [-19.493301288497133, -10.71220465477402],
              [-19.496154400745233, -10.711372389122088],
              [-19.499564207526998, -10.70808648676641],
              [-19.500430148125766, -10.706011995430055],
              [-19.50141516635125, -10.704730380336464],
              [-19.5051146210801, -10.701741672312096],
              [-19.5076239507542, -10.698004241747872],
              [-19.508919935958325, -10.695155050120592],
              [-19.511871401692094, -10.690912228191328],
              [-19.51301184258245, -10.689578138449171],
              [-19.513992826696363, -10.686750466153184],
              [-19.51470475003378, -10.683746345750212],
              [-19.515827557575484, -10.68233244459476],
              [-19.515258140960434, -10.680795382114674],
              [-19.517927200426296, -10.680745246409941],
              [-19.518612074341416, -10.68161185276562],
              [-19.522003481028936, -10.680560379739818],
              [-19.5254340209015, -10.680210584766593],
              [-19.529561670465625, -10.677212931194571],
              [-19.529883751541995, -10.67591606738993],
              [-19.526984443923897, -10.670062995406928],
              [-19.5273568470942, -10.669111594970786],
              [-19.527703330597838, -10.663761417465151],
              [-19.527005979179645, -10.659581470892821],
              [-19.52712089046013, -10.656680059255338],
              [-19.528366044276684, -10.652426722366586],
              [-19.52860363606782, -10.649918766926673],
              [-19.52963938591029, -10.649127575909443],
              [-19.531600049342895, -10.644482022093086],
              [-19.53198260989246, -10.642779825284052],
              [-19.533096171926047, -10.640243079813482],
              [-19.53451149024296, -10.633605495235996],
              [-19.537432618514817, -10.629060946008675],
              [-19.539777630960582, -10.627505447399551],
              [-19.540798873620595, -10.623843871252506]
            ]
          ],
          [
            [
              [-20.453409974865657, -10.296080802715684],
              [-20.45197028995861, -10.296245490870279],
              [-20.449868875348045, -10.295337370794197],
              [-20.449178569738567, -10.293176334199185],
              [-20.449966429628727, -10.290839657727519],
              [-20.44872333950931, -10.289387953362324],
              [-20.44719112276268, -10.286545300297183],
              [-20.446939906716466, -10.284005943915774],
              [-20.447426949639183, -10.282937586830792],
              [-20.444960553671706, -10.282221364282057],
              [-20.44438501965921, -10.281293044283213],
              [-20.44372387504182, -10.277526851870528],
              [-20.442636593025657, -10.27687381576613],
              [-20.440526966342933, -10.277485427411692],
              [-20.437725255019046, -10.277202610305139],
              [-20.43656047858996, -10.276571930970492],
              [-20.435165570978494, -10.274745492037033],
              [-20.43335171554602, -10.27463933605431],
              [-20.430294214984958, -10.273209744665953],
              [-20.426166953545483, -10.268473387741805],
              [-20.42460530774618, -10.267074572229845],
              [-20.418436123324128, -10.269273902476664],
              [-20.419567496358184, -10.270796971065801],
              [-20.419899459213106, -10.274905025203443],
              [-20.422261003908357, -10.27885053517259],
              [-20.42354920440133, -10.279615073639969],
              [-20.425358683144662, -10.281701841231426],
              [-20.425736846482245, -10.282686822710893],
              [-20.4257327455665, -10.28538140294875],
              [-20.424612312843163, -10.287892915559235],
              [-20.42502070512988, -10.28912240835537],
              [-20.424070615577882, -10.29263808771917],
              [-20.42421596834459, -10.296555243720904],
              [-20.4246843751254, -10.298273830426313],
              [-20.423454053556966, -10.30199843261478],
              [-20.42324769947975, -10.304881193270383],
              [-20.42152452935058, -10.308242502325042],
              [-20.420614135614056, -10.308756751263477],
              [-20.42040203464466, -10.310335398335235],
              [-20.41882722431588, -10.312768795172142],
              [-20.417249900292862, -10.31347392486459],
              [-20.41424713200899, -10.318129221691315],
              [-20.413093640991324, -10.32098972037412],
              [-20.412099947185965, -10.322665980899142],
              [-20.4110362162952, -10.326555543472088],
              [-20.40954955887628, -10.328583760849646],
              [-20.40720014690207, -10.331152926770677],
              [-20.40210400435695, -10.33712085796267],
              [-20.400235738260577, -10.339889456140318],
              [-20.397495380129577, -10.342736904274325],
              [-20.394280529656626, -10.345422961506038],
              [-20.390558062722082, -10.349433778375547],
              [-20.38893343329728, -10.35246944029418],
              [-20.38130694241993, -10.358299117099953],
              [-20.37725664028821, -10.360919597346424],
              [-20.37444593764183, -10.36238686468254],
              [-20.372724731283228, -10.362913747742308],
              [-20.36941497671568, -10.362957797741018],
              [-20.36538749569377, -10.364342461166062],
              [-20.363277486573708, -10.364850049655871],
              [-20.361746075636983, -10.364561824919182],
              [-20.36058981258826, -10.362775768947486],
              [-20.359660746903653, -10.36236091768469],
              [-20.35706793999521, -10.36355143280217],
              [-20.35628666443923, -10.364529740345143],
              [-20.352056233634954, -10.36727390675662],
              [-20.35293535320374, -10.369138267546203],
              [-20.35126471216776, -10.373235231704525],
              [-20.349750307798573, -10.37551549291761],
              [-20.347998343006186, -10.378748438756705],
              [-20.344610696141622, -10.383112825566291],
              [-20.339095847599218, -10.391657865483943],
              [-20.337519952828384, -10.393742949705043],
              [-20.335865734414536, -10.394962169760648],
              [-20.333636451513478, -10.395960529881702],
              [-20.331961445443092, -10.398748156874563],
              [-20.33348306760992, -10.399594864227849],
              [-20.335598061619876, -10.399981214353053],
              [-20.33629548554314, -10.40122510036076],
              [-20.33944844951452, -10.402253465174535],
              [-20.34198931500872, -10.401294545835933],
              [-20.345510873492934, -10.401373839374624],
              [-20.346239171635794, -10.401086650496518],
              [-20.34673835821971, -10.397776186197214],
              [-20.347794083393396, -10.396848277629264],
              [-20.34777797747777, -10.395457529325252],
              [-20.346741133142682, -10.393632185631777],
              [-20.3471884263868, -10.390591483301835],
              [-20.348486082441696, -10.388877574570767],
              [-20.354248265004173, -10.385200129222659],
              [-20.359788414206204, -10.3826803228612],
              [-20.361681866599728, -10.38215055248575],
              [-20.36572371533961, -10.382117379506688],
              [-20.367627322395517, -10.380738522672734],
              [-20.369723039532058, -10.380023704304184],
              [-20.372423354408078, -10.380068756799277],
              [-20.374140722264045, -10.379078710745473],
              [-20.37698008814295, -10.378280241598492],
              [-20.379060077373904, -10.378244449439531],
              [-20.380308478118714, -10.379161851133652],
              [-20.382281870299682, -10.379197988784652],
              [-20.384009226300407, -10.379853222586979],
              [-20.386540260728648, -10.379604548583561],
              [-20.388949884790325, -10.380109052421675],
              [-20.391774060431576, -10.37969234742431],
              [-20.39474669971887, -10.379782749000507],
              [-20.39560863256911, -10.378057653467927],
              [-20.39733994702385, -10.376678509877785],
              [-20.397408960611653, -10.37428932920338],
              [-20.3982685659841, -10.37226874601073],
              [-20.40489060923869, -10.365016925844738],
              [-20.409459162285124, -10.360671901262634],
              [-20.411280027964096, -10.359899617980501],
              [-20.41207374892019, -10.358827501831719],
              [-20.41290218880952, -10.355123581562662],
              [-20.41423539454232, -10.352122033334375],
              [-20.414833709277016, -10.349668552541457],
              [-20.41581996372937, -10.347231138388743],
              [-20.41781038536347, -10.343577065294474],
              [-20.41920320010221, -10.34237602276403],
              [-20.42017130138821, -10.340028501117663],
              [-20.422734612616964, -10.335154080498329],
              [-20.424606652891285, -10.332843493480489],
              [-20.425519658388822, -10.329456354762968],
              [-20.42835008827414, -10.326363151058283],
              [-20.428636024114816, -10.324887414144635],
              [-20.430898854252998, -10.321323712714324],
              [-20.43230856557263, -10.320622682332294],
              [-20.43153383251166, -10.318017833201528],
              [-20.432826599120496, -10.316210339484057],
              [-20.43435316451432, -10.31104480320471],
              [-20.435888634872434, -10.308914353540676],
              [-20.437770892487958, -10.307949269152559],
              [-20.43872119777546, -10.308138859573946],
              [-20.440418982265406, -10.307268683523802],
              [-20.442341438154273, -10.307008400629012],
              [-20.44448996024634, -10.304657070913368],
              [-20.446467919998568, -10.301595576106406],
              [-20.447806401782152, -10.301376411698431],
              [-20.449734668411125, -10.300142430873315],
              [-20.45256912591201, -10.299235685538816],
              [-20.453409974865657, -10.296080802715684]
            ]
          ],
          [
            [
              [-20.447039716770437, -10.240696817777403],
              [-20.444756423814095, -10.237751673413257],
              [-20.443334200000525, -10.236822801929488],
              [-20.44149517619956, -10.234084760289655],
              [-20.440225960669384, -10.232818022283803],
              [-20.43885015006322, -10.230491953499335],
              [-20.435499731308727, -10.22848880344862],
              [-20.434773858200533, -10.229873991419637],
              [-20.434450484411016, -10.231897008120256],
              [-20.434763107313284, -10.234490425337594],
              [-20.43619892881561, -10.23575100338232],
              [-20.43663613786042, -10.238477287840842],
              [-20.435853487398628, -10.240383059877033],
              [-20.436912489198225, -10.243349348846122],
              [-20.437210575750747, -10.24561378954969],
              [-20.438408875179384, -10.247491326642942],
              [-20.438468029360376, -10.248817987699478],
              [-20.43722525266967, -10.252161229259974],
              [-20.43697108490061, -10.253999348555432],
              [-20.437977882695122, -10.256228117653457],
              [-20.438799807550858, -10.256283706253306],
              [-20.44055948314066, -10.253672009972084],
              [-20.442439773993293, -10.25245333319341],
              [-20.443372962432612, -10.247518460358096],
              [-20.445660639328604, -10.243996440290836],
              [-20.44657622630433, -10.243519920950925],
              [-20.447039716770437, -10.240696817777403]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -159.8185092257587, "lat": 60.91317370532101 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02050"],
        "coty_name": ["Bethel"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Bethel Census Area"],
        "coty_fp_code": "050",
        "coty_gnis_code": "01419966"
      },
      "bbox": [
        -20.453409974865657, -11.346951088368911, -17.05881870046657,
        -10.13520515202965
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.077073262772249, -4.31514715414844],
            [-11.07169151825328, -4.310222562283276],
            [-11.063023083669965, -4.315069513563291],
            [-11.061156677852244, -4.318166494575399],
            [-11.050855810523503, -4.319563917910741],
            [-11.046370364502335, -4.316834299601341],
            [-11.043886714389508, -4.318024042623386],
            [-11.045044845251471, -4.32229543634353],
            [-11.04259921815192, -4.325112823508781],
            [-11.036248047334148, -4.324937802960091],
            [-11.030886233384036, -4.330236081111831],
            [-11.026711827739215, -4.329077666454369],
            [-11.014472111784704, -4.333445495738193],
            [-11.008127459812108, -4.32741035616416],
            [-11.004698168997995, -4.326851804213163],
            [-10.99525061215124, -4.3287608115845355],
            [-10.993264217842029, -4.331527186647371],
            [-10.993820089897998, -4.3352285217482365],
            [-10.989217566479367, -4.33728772038128],
            [-10.983743336937659, -4.337680012513749],
            [-10.980221419811283, -4.33953744728363],
            [-10.978541034753096, -4.3428074808484345],
            [-10.97091058265586, -4.345883865309788],
            [-10.970996777240755, -4.351576181525165],
            [-10.963277014654665, -4.360669832147243],
            [-10.961863457344569, -4.364294889492181],
            [-10.955143029401162, -4.36260620904891],
            [-10.961446029284737, -4.370351815790135],
            [-10.958059263056208, -4.372202264560918],
            [-10.95372061414377, -4.380139648047504],
            [-10.948155573953109, -4.381745866522199],
            [-10.946420764088352, -4.3768827776175865],
            [-10.939269424300717, -4.385576116744391],
            [-10.941954072466114, -4.390631282773062],
            [-10.93697552882739, -4.392527345615177],
            [-10.939083073011085, -4.396451111916372],
            [-10.939729215755507, -4.401174734623215],
            [-10.934156589058151, -4.408907564764998],
            [-10.928933477646552, -4.410132318179325],
            [-10.928286939136616, -4.414572496767609],
            [-10.932415520370135, -4.422351415175335],
            [-10.93714253651961, -4.427987052770946],
            [-10.936329873290463, -4.430571229337723],
            [-10.931579826125127, -4.429929955680224],
            [-10.929670280922252, -4.427709410419009],
            [-10.925582526220296, -4.42733546585699],
            [-10.923647299690497, -4.432239172577765],
            [-10.920180908723848, -4.431222412776942],
            [-10.91405292094232, -4.43568542974318],
            [-10.914378667671881, -4.440897584664817],
            [-10.908092968124532, -4.441363169853895],
            [-10.900814712265555, -4.444027066118272],
            [-10.8966464532179, -4.442514812196197],
            [-10.895818604663967, -4.439046725710289],
            [-10.888425319139198, -4.4397427952954605],
            [-10.882088945228055, -4.436689216992163],
            [-10.881137224918751, -4.431623847926511],
            [-10.877823662193105, -4.4295371301953885],
            [-10.877731714846659, -4.41912079711172],
            [-10.873064157683023, -4.412416286333968],
            [-10.870116916025642, -4.410407991437364],
            [-10.863070546185048, -4.4089525822439395],
            [-10.86484223998978, -4.40294694354764],
            [-10.859902972809914, -4.404334930536912],
            [-10.853154103235342, -4.401263987441902],
            [-10.849201402389625, -4.401016905601513],
            [-10.850324134696159, -4.394606403222225],
            [-10.845356346485346, -4.3955248890210665],
            [-10.843266085128155, -4.39052938315571],
            [-10.839857717437486, -4.387640201461869],
            [-10.838792479059505, -4.3921226676921785],
            [-10.835985040293712, -4.392263167987316],
            [-10.83361800977134, -4.3890678195174],
            [-10.828941851219815, -4.389113194479021],
            [-10.827916218652545, -4.386938132734762],
            [-10.823342606227886, -4.386151629609594],
            [-10.817773165814874, -4.379416216283928],
            [-10.816237303969475, -4.373480567426873],
            [-10.810399177637807, -4.376869541065562],
            [-10.805633181981563, -4.376755150242203],
            [-10.805717613877897, -4.374037076608002],
            [-10.810547765771396, -4.371963840942267],
            [-10.808383315090644, -4.364384821998063],
            [-10.812907765361585, -4.36195568595742],
            [-10.811481637619236, -4.357727768334231],
            [-10.801762481103458, -4.352624453045947],
            [-10.79862230795084, -4.354117685123262],
            [-10.797780409574152, -4.349198473587435],
            [-10.79112172644113, -4.350509152501298],
            [-10.783432853153677, -4.348865030536467],
            [-10.777286123184691, -4.351187378181305],
            [-10.767771792724348, -4.347973363117627],
            [-10.767074956678117, -4.352986282064588],
            [-10.764156005613593, -4.35357268267507],
            [-10.760695211046539, -4.34548617081988],
            [-10.756679161573787, -4.345799957041907],
            [-10.748997678171445, -4.338179739564289],
            [-10.750401962867524, -4.331784783278055],
            [-10.748608844201193, -4.3278420037165946],
            [-10.74268525245173, -4.327245293135613],
            [-10.734923143722213, -4.324982321914731],
            [-10.732144119953329, -4.328966790254973],
            [-10.72748324196536, -4.328445433660432],
            [-10.719650012409293, -4.3215241418306345],
            [-10.716441442689526, -4.321418952735366],
            [-10.70876898648755, -4.31854109611951],
            [-10.706142562329918, -4.325249143035221],
            [-10.701902035812706, -4.32444496970442],
            [-10.695114680545014, -4.327064782025184],
            [-10.691799483230595, -4.322750323441121],
            [-10.689354622155307, -4.327786020603388],
            [-10.681883075978455, -4.330280219597834],
            [-10.683727795996145, -4.325679614421091],
            [-10.675138411442832, -4.31567279746864],
            [-10.67326298620987, -4.315279126859879],
            [-10.6733706306674, -4.309131885812682],
            [-10.662689725873715, -4.307863354854127],
            [-10.659512762361931, -4.305949628923874],
            [-10.659100053996793, -4.301739314385025],
            [-10.656455078736995, -4.299306239027594],
            [-10.652683646706897, -4.2998987422071835],
            [-10.654587146517452, -4.312506760939791],
            [-10.720183052646908, -4.769071717272559],
            [-10.734754304620983, -4.8704043312448055],
            [-10.691194534717376, -4.979462265227313],
            [-10.634044192426627, -5.122743234635288],
            [-10.621481358749266, -5.12500203010584],
            [-10.580023682065463, -5.224443254411619],
            [-10.57655368757705, -5.2249453481801345],
            [-10.5751953536638, -5.233396700506798],
            [-10.557815088066246, -5.297918163265429],
            [-10.560861899374183, -5.324830675204484],
            [-10.557782609591372, -5.343285345019585],
            [-10.573514567931218, -5.375587481867789],
            [-10.5691198999829, -5.393788116638051],
            [-10.587062712651555, -5.433002214106691],
            [-10.589103675644921, -5.446804444905302],
            [-10.553888952386071, -5.497058612386642],
            [-10.553314870715552, -5.499211165279914],
            [-10.546310061886238, -5.509817744610791],
            [-10.530151201466674, -5.5328457703962854],
            [-10.510405696037662, -5.561562774740874],
            [-10.604821773520072, -5.548461263985371],
            [-10.605052290813704, -5.550038919546788],
            [-10.690006360917298, -5.537081457153105],
            [-10.774500189935043, -5.523381117902358],
            [-10.966646486750292, -5.496836694523423],
            [-11.030439016614832, -5.487425405778816],
            [-11.032122817646629, -5.486954821082334],
            [-11.113631399885177, -5.475079206674731],
            [-11.233443706916761, -5.457589702079393],
            [-11.353253364027275, -5.440081451089706],
            [-11.45504336868537, -5.425006099231389],
            [-11.536169134027727, -5.412973653596971],
            [-11.535996018929032, -5.411724095967555],
            [-11.62066649828378, -5.398956412511837],
            [-11.607931161420606, -5.313339689022285],
            [-11.606033864441532, -5.3136291473960116],
            [-11.576848019141794, -5.127317395876301],
            [-11.566283761295113, -5.059090012385518],
            [-11.539377127057646, -4.884396822947626],
            [-11.540100899989726, -4.884286339056763],
            [-11.533620549311589, -4.841988158655675],
            [-11.502168674686569, -4.639419486782135],
            [-11.500749334541593, -4.644385302609131],
            [-11.49327332733779, -4.64772270334508],
            [-11.489739594563373, -4.6482303133792024],
            [-11.486863441511684, -4.6453561883469],
            [-11.478969177722997, -4.643923855901954],
            [-11.478529827564591, -4.646487540988834],
            [-11.469324941743267, -4.646954973238099],
            [-11.461718763155542, -4.641678304110337],
            [-11.46477018234535, -4.635485612421797],
            [-11.468735060380208, -4.632825624210667],
            [-11.470716770618639, -4.626923223679417],
            [-11.476178492881301, -4.620382712962223],
            [-11.471999325005791, -4.615022932580594],
            [-11.471004657970987, -4.611398630834446],
            [-11.474895097685938, -4.608920836264092],
            [-11.478307389519415, -4.601028310320206],
            [-11.484042900679501, -4.596847395100723],
            [-11.483468241827268, -4.584654325951221],
            [-11.488609572102865, -4.579564443635855],
            [-11.487317287468153, -4.573012963420391],
            [-11.490977930410628, -4.569345564760154],
            [-11.490141233189242, -4.5601731333321665],
            [-11.491650588049009, -4.553742643242055],
            [-11.493786213988596, -4.55174834352334],
            [-11.491096769381283, -4.543549911698695],
            [-11.49395437440618, -4.542314277902771],
            [-11.493518406391384, -4.538474121499943],
            [-11.487286195088661, -4.537213967198506],
            [-11.484574755969698, -4.534742656430351],
            [-11.485995122652193, -4.5300980803402044],
            [-11.484637475781057, -4.528095138844224],
            [-11.485074102241226, -4.518385027493236],
            [-11.482831572142747, -4.513972761569143],
            [-11.478144456430924, -4.509234119578359],
            [-11.479608526835637, -4.5014735855395545],
            [-11.479155529516873, -4.493188234027515],
            [-11.477768604505227, -4.487200033943195],
            [-11.474959530803323, -4.485093535285533],
            [-11.474739277137811, -4.481332570327664],
            [-11.478925342053534, -4.473389201837891],
            [-11.477684517144588, -4.470323216395966],
            [-11.470902339527973, -4.468238499681864],
            [-11.469255409193986, -4.457861090028264],
            [-11.467507859501978, -4.454715875867644],
            [-11.455267663867728, -4.449844893516697],
            [-11.451512057395176, -4.452964385379878],
            [-11.448096992322538, -4.45296100669781],
            [-11.446379897393259, -4.4473269449391974],
            [-11.44335253456317, -4.4447286839295295],
            [-11.441139724404756, -4.438550539552917],
            [-11.437486413522663, -4.441224341284709],
            [-11.425994438352047, -4.437932083991828],
            [-11.420945052652566, -4.440500666210837],
            [-11.418464665306582, -4.436913594633588],
            [-11.414469204498007, -4.4414051434819966],
            [-11.400585273586147, -4.448097920309385],
            [-11.394210906961879, -4.4425933799432125],
            [-11.39149261962994, -4.4440922992948275],
            [-11.384288279897817, -4.434179229059937],
            [-11.384833403679197, -4.428441753606756],
            [-11.380783275403132, -4.428418224295625],
            [-11.378381183474692, -4.422316215588495],
            [-11.37371318623447, -4.4218062292324065],
            [-11.368822976480752, -4.42351783719725],
            [-11.363164685425025, -4.421414804961087],
            [-11.361429953599746, -4.4189693545987945],
            [-11.354362478086797, -4.419312925765508],
            [-11.351883150910437, -4.423067173504978],
            [-11.34729180588229, -4.422627325022395],
            [-11.346888433422295, -4.425211490344435],
            [-11.33796852795122, -4.42566297151034],
            [-11.33454944017184, -4.4241812274859145],
            [-11.323498556388381, -4.416837352373543],
            [-11.31960658588656, -4.415824390774392],
            [-11.315215361817808, -4.4232385841666995],
            [-11.30821479823822, -4.423654192900489],
            [-11.303680058215246, -4.421883451817418],
            [-11.300115386571944, -4.424500661043622],
            [-11.290084961823524, -4.420457959011794],
            [-11.28853277901926, -4.422883460723376],
            [-11.284229465763623, -4.41905850865393],
            [-11.281999791054144, -4.423366514756752],
            [-11.27867030818367, -4.42392289380186],
            [-11.276967014395922, -4.428915987721309],
            [-11.273878417865642, -4.428882625088977],
            [-11.269367908496772, -4.42372060745926],
            [-11.265951121958539, -4.426644860232225],
            [-11.26131846760827, -4.426469243293629],
            [-11.257483465437975, -4.424181854152473],
            [-11.253267134341423, -4.426174728107415],
            [-11.253494534954116, -4.418723526963212],
            [-11.24953330167045, -4.417017150396056],
            [-11.247564837567905, -4.420655379615078],
            [-11.24309049375248, -4.419452005854791],
            [-11.240424897827964, -4.421308242421419],
            [-11.233707830955147, -4.419038387940364],
            [-11.232999884497541, -4.412486784212525],
            [-11.231279665170339, -4.410739356500374],
            [-11.232071552426566, -4.4053122406337115],
            [-11.093479033393013, -4.425406577218941],
            [-11.077073262772249, -4.31514715414844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.8874673872597,
          "lat": 32.932596987947484
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04009"],
        "coty_name": ["Graham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Graham County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00025444"
      },
      "bbox": [
        -11.62066649828378, -5.561562774740874, -10.510405696037662,
        -4.299306239027594
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.757924611240085, -0.5219156821934922],
            [-13.735591139326464, -0.4083579186641035],
            [-13.727936259507592, -0.36600235568978384],
            [-13.662216517631201, -0.37898684834543167],
            [-13.62343578048976, -0.38643324437511356],
            [-13.396724686764585, -0.4292479954822152],
            [-13.288005236425622, -0.4495242652339974],
            [-13.229762339354448, -0.46031853245015286],
            [-13.124714546375145, -0.4796672271397344],
            [-12.97326546281445, -0.5072909732724957],
            [-12.884975837334446, -0.5232468194298298],
            [-12.83258400058527, -0.5325771679066764],
            [-12.77830971860178, -0.5422024007283731],
            [-12.607147609907502, -0.572288215548701],
            [-12.551696091686884, -0.5821381164688164],
            [-12.556307099098046, -0.5860264040398431],
            [-12.557089728487979, -0.5953507331374955],
            [-12.558728426699737, -0.5966894769834095],
            [-12.55476080889971, -0.603084622820983],
            [-12.55346583373568, -0.6072937491500086],
            [-12.554183840832907, -0.611228006983756],
            [-12.551574662369406, -0.6167935313175149],
            [-12.551850111404361, -0.6219690037500384],
            [-12.554347864416718, -0.6280302537720517],
            [-12.55289140192092, -0.6313757518774432],
            [-12.561001234939804, -0.6385152889213117],
            [-12.567490669325725, -0.6428310083309634],
            [-12.573327980546226, -0.6551051671843356],
            [-12.571325627178876, -0.6582005193559588],
            [-12.572605493932507, -0.6648190059092606],
            [-12.574970802724371, -0.6685023812939681],
            [-12.579287659896748, -0.6708685374388136],
            [-12.581083230322248, -0.6746017924725856],
            [-12.583864676907648, -0.6740713291779183],
            [-12.587123533820193, -0.6788837085105961],
            [-12.594728438271396, -0.6823320379410334],
            [-12.59955799176337, -0.6907352442414993],
            [-12.598566098874965, -0.6942549789746769],
            [-12.602401019802967, -0.7037436026907221],
            [-12.605764566219221, -0.7079106746655434],
            [-12.60662111222805, -0.7118715549335886],
            [-12.61180847827662, -0.7150250817005274],
            [-12.614866370528434, -0.7238978518138222],
            [-12.614529866090626, -0.7281469081266696],
            [-12.61860761794756, -0.7300257005490784],
            [-12.62181559372613, -0.7336569385174736],
            [-12.624479525170841, -0.7409146530602706],
            [-12.632890624018094, -0.7563805877924102],
            [-12.631395658312192, -0.7578601878554316],
            [-12.633149809918285, -0.765103951700333],
            [-12.636856365781956, -0.7680051006675352],
            [-12.647342730431921, -0.779693081837094],
            [-12.647714363690815, -0.7837444905088935],
            [-12.653185184072752, -0.7876641519123895],
            [-12.651935987727223, -0.7961291350880043],
            [-12.655277138770828, -0.8012962556585688],
            [-12.657028891678301, -0.8063996261441068],
            [-12.653893238032891, -0.8076834020171364],
            [-12.654261311957033, -0.8129922036799985],
            [-12.656748882739937, -0.8198754502999439],
            [-12.654305973054152, -0.8222331066369503],
            [-12.654181708681943, -0.8277128396938122],
            [-12.658017525501803, -0.8264408741338718],
            [-12.655387887950175, -0.8343189965677905],
            [-12.657280946689948, -0.8354670500671348],
            [-12.661684736586103, -0.8314949124966633],
            [-12.663851114841028, -0.8348139607161054],
            [-12.659595563407292, -0.8364914046313792],
            [-12.660776387717044, -0.8408620968831917],
            [-12.665990475668366, -0.8453506241811165],
            [-12.666354191085764, -0.8492290279125762],
            [-12.671381665628678, -0.8545683338348304],
            [-12.669137665852725, -0.857355498838333],
            [-12.671938081187905, -0.8621134067729763],
            [-12.675875607561949, -0.8639280123553684],
            [-12.67327551135497, -0.8673573956161733],
            [-12.67670174152636, -0.8718754247700556],
            [-12.676227472710197, -0.8767701864938953],
            [-12.681389957829126, -0.8806541658813836],
            [-12.682272664837296, -0.8893859820736918],
            [-12.686973460671961, -0.8930530394480191],
            [-12.684624207219668, -0.8971814749318937],
            [-12.6862922300652, -0.8993868168952899],
            [-12.68467226947281, -0.9060443578595763],
            [-12.685827502347742, -0.9089267393549569],
            [-12.681785874910151, -0.9134740302019017],
            [-12.68480974553556, -0.9163459774832741],
            [-12.684505462201232, -0.929456407072901],
            [-12.683196488776707, -0.9336722277161722],
            [-12.685638608928901, -0.9395972021293282],
            [-12.682925519532388, -0.9423194667637543],
            [-12.684958344462622, -0.9470979503742306],
            [-12.685301840808586, -0.954144046805797],
            [-12.68207838827241, -0.9553982325886717],
            [-12.682692042142449, -0.9588211489025384],
            [-12.686089535057636, -0.9616805286417803],
            [-12.685328498298748, -0.9673902352814063],
            [-12.688403479719423, -0.9696699787703152],
            [-12.686949589192457, -0.9731916208099366],
            [-12.6917149756961, -0.9752054335567764],
            [-12.694620533603764, -0.9784016086341785],
            [-12.693472096157597, -0.9864800434885023],
            [-12.695550788102713, -0.9899135654577653],
            [-12.699651381465966, -0.9930214253135181],
            [-12.70113091219944, -0.9972034685262737],
            [-12.707699413459661, -0.9979362563888464],
            [-12.708594355614643, -1.0004646563971542],
            [-12.713801973179194, -1.0009097678276497],
            [-12.713670756033157, -1.00364225770625],
            [-12.719233881871357, -1.0064628094719097],
            [-12.722132413077462, -1.010578976543651],
            [-12.717651264519638, -1.0137677637743279],
            [-12.722278713218824, -1.020742357753353],
            [-12.726852813116224, -1.0202523531791392],
            [-12.72720533068174, -1.0286263367905246],
            [-12.728455021815124, -1.034431466787608],
            [-12.725229623834606, -1.0351111563421684],
            [-12.727085761505638, -1.0417263399698886],
            [-12.72563455973214, -1.0463602080828864],
            [-12.728770089201781, -1.0486763420727192],
            [-12.726259233430348, -1.0552495537415447],
            [-12.721992841448623, -1.0551783387555251],
            [-12.721477100686299, -1.0591903205339481],
            [-12.724332056752797, -1.0616014062278916],
            [-12.719789173396025, -1.06459863457063],
            [-12.723863011899295, -1.0682168841005062],
            [-12.717169941327082, -1.0715604016481626],
            [-12.718139732647394, -1.082337942087549],
            [-12.712423510735078, -1.080670131548428],
            [-12.709881377410754, -1.0816984870828463],
            [-12.709440877079926, -1.0860104729077649],
            [-12.711288609398013, -1.0879573684884514],
            [-12.709863380600599, -1.0933801351584875],
            [-12.715892801175833, -1.0980278418063694],
            [-12.715954062046421, -1.1013850523632411],
            [-12.721607928704158, -1.1025728984618897],
            [-12.730266222745346, -1.1076332595475862],
            [-12.728428347892681, -1.1166717251329683],
            [-12.729864293732055, -1.1210690784496122],
            [-12.72661967898503, -1.1233176799236295],
            [-12.731943731807492, -1.1271770327509871],
            [-12.733849130766819, -1.1305626666358282],
            [-12.730343371203395, -1.1392204667315018],
            [-12.725247417043391, -1.1390657448162502],
            [-12.72210711045438, -1.157539471777445],
            [-12.726208903719408, -1.1635360477881052],
            [-12.72874154464703, -1.1638519967466172],
            [-12.729548070860169, -1.175099284712009],
            [-12.73822381259686, -1.1764372759198216],
            [-12.744650100607272, -1.1803636832301294],
            [-12.74699095564285, -1.1841394242598964],
            [-12.750953534115114, -1.1974674476021943],
            [-12.756907654045195, -1.2054985285966349],
            [-12.768045534374693, -1.2144068068634601],
            [-12.773730986696206, -1.2167745428796475],
            [-12.779247274549617, -1.2174960878583805],
            [-12.781807310048778, -1.2148189828030818],
            [-12.783179343380825, -1.2043114606952157],
            [-12.790393800031111, -1.2015112783550053],
            [-12.804808914180851, -1.205867293453694],
            [-12.811810229350531, -1.2072768929146651],
            [-12.814476060747749, -1.2108509114174628],
            [-12.814128318104887, -1.2201566093781009],
            [-12.812575600512206, -1.2253507180028123],
            [-12.813230943275487, -1.2308145015340595],
            [-12.815529129326626, -1.233289434389169],
            [-12.819887989929576, -1.2346045803264485],
            [-12.824355680721567, -1.2336368453059414],
            [-12.828237958109975, -1.2310611412018413],
            [-12.833540922361632, -1.2253426275686319],
            [-12.838260667537098, -1.223758107875026],
            [-12.842758210230944, -1.2260313486035819],
            [-12.847783916943884, -1.2377201216096065],
            [-12.852062861197615, -1.2414034990565856],
            [-12.856899319903011, -1.2432087423053566],
            [-12.865556033035803, -1.2417428482554647],
            [-12.868556731417591, -1.242274642894521],
            [-12.871534167352632, -1.2461913944154344],
            [-12.872714073782449, -1.2528769123837977],
            [-12.876391624371735, -1.2582585724801925],
            [-12.88276512891062, -1.2578402758175304],
            [-12.89157703781095, -1.2519305890301615],
            [-12.901012991518437, -1.250471185350746],
            [-12.907420605803654, -1.252237544090023],
            [-12.913102149587452, -1.2580425564290254],
            [-12.920052347846788, -1.2586825757286808],
            [-12.933931444512973, -1.250686941231395],
            [-12.94062124250497, -1.2513214736691625],
            [-12.94557951928155, -1.2548694042332098],
            [-12.949080303030783, -1.262359491905783],
            [-12.952408712855501, -1.2664015773504207],
            [-12.964967568423587, -1.273434615864391],
            [-12.96884500752341, -1.2737642907426536],
            [-12.977604218362169, -1.2677007529259539],
            [-12.981920511287488, -1.2667706160271701],
            [-12.986089265463301, -1.2680282577995023],
            [-12.990676567377157, -1.2762926405755612],
            [-12.993151159270969, -1.278849514332803],
            [-13.000763053414616, -1.28075501512741],
            [-13.01008931525416, -1.2811326782955053],
            [-13.017150724515165, -1.2829461754621225],
            [-13.034321628098933, -1.284520889099158],
            [-13.039524160087296, -1.2829640585078292],
            [-13.052831038518148, -1.2740134639414558],
            [-13.05680093637258, -1.2732411580368779],
            [-13.063238715215098, -1.2742321216133818],
            [-13.078205259479452, -1.280212948763286],
            [-13.083799804953735, -1.2843713079499455],
            [-13.094620096852628, -1.2965865571510913],
            [-13.102491324711613, -1.2974172643084814],
            [-13.109940060932962, -1.2994130976076128],
            [-13.11573613581195, -1.3027340331389161],
            [-13.12420553272649, -1.305541226614658],
            [-13.131068453344525, -1.3061729311893506],
            [-13.147583471520669, -1.3137775552477184],
            [-13.15500973420849, -1.3221154395533297],
            [-13.161015937847047, -1.3254321787522083],
            [-13.168708862455272, -1.327161073065498],
            [-13.174515239529915, -1.3193656621610428],
            [-13.181152963830423, -1.3165682151138631],
            [-13.188084502961061, -1.3181724466273226],
            [-13.191904755138461, -1.3224008690789264],
            [-13.197301716311616, -1.3257288328828443],
            [-13.20424423519019, -1.3284520143977399],
            [-13.210182541848809, -1.3293178738804035],
            [-13.218106093739857, -1.3319652428858217],
            [-13.222274667289518, -1.334665958224046],
            [-13.222537790519747, -1.3386452256764778],
            [-13.228416354149813, -1.350407913227728],
            [-13.228138137203398, -1.3649135395787264],
            [-13.234853037533794, -1.3703967251088405],
            [-13.240005232247826, -1.3729188429472188],
            [-13.25151485038574, -1.389251205715076],
            [-13.256713452005647, -1.3899605463951064],
            [-13.267944294948425, -1.383990955179148],
            [-13.277386003588024, -1.3872197273402223],
            [-13.281422021899397, -1.3834134636217081],
            [-13.28699914649379, -1.38044311014631],
            [-13.29316638637599, -1.37525654431047],
            [-13.303856947906583, -1.3735957513963823],
            [-13.310259395744206, -1.373760893502933],
            [-13.316048892847007, -1.3687677970096137],
            [-13.31959099674882, -1.3676610769680537],
            [-13.325333323268433, -1.3699194955866278],
            [-13.32932192856748, -1.3752740677263935],
            [-13.333572891776738, -1.3872236276798344],
            [-13.339043443761685, -1.3965801453260602],
            [-13.344269419448256, -1.3993041471782448],
            [-13.354604118802857, -1.407339015040068],
            [-13.359603078791498, -1.4141230588318587],
            [-13.362598725624851, -1.4209165516660103],
            [-13.361775388686834, -1.4273457772653633],
            [-13.363150796357294, -1.4415710803005481],
            [-13.363009463234421, -1.4488027737856295],
            [-13.360014563263038, -1.452543088949622],
            [-13.358328001338561, -1.4597528538285527],
            [-13.361636403703846, -1.4720472240362363],
            [-13.361365548627202, -1.4777973837875094],
            [-13.358314966827383, -1.4841790579845726],
            [-13.349639760922422, -1.4885951611984887],
            [-13.347335957193177, -1.4919187810900818],
            [-13.346635613076883, -1.4974798754120304],
            [-13.348544423628093, -1.5000274406762204],
            [-13.347848994543911, -1.5046694168822328],
            [-13.35577180527063, -1.5097426400682388],
            [-13.358989106042658, -1.5141283650222939],
            [-13.358401951732068, -1.524762114449863],
            [-13.359341647064605, -1.5298978326920203],
            [-13.36351948066134, -1.5380724310854894],
            [-13.369081895796667, -1.5445266751860622],
            [-13.370531025184516, -1.5492452109395107],
            [-13.366661479713839, -1.5552273027070902],
            [-13.363929497142372, -1.5619780940713055],
            [-13.363847451096042, -1.5659241753758426],
            [-13.361145627216867, -1.5692080165993552],
            [-13.355616329759812, -1.5731261958023106],
            [-13.355594588534661, -1.5812000592320452],
            [-13.360152735653003, -1.5910074141452946],
            [-13.360487188520406, -1.6030498823482557],
            [-13.365749536430297, -1.6110542796347838],
            [-13.370803057676769, -1.6149528090472003],
            [-13.377635778552628, -1.6229863344644855],
            [-13.379964524890521, -1.6358879630802483],
            [-13.385954936322026, -1.6405486136421406],
            [-13.386201600843274, -1.6457385931178943],
            [-13.384769792896313, -1.650060350314824],
            [-13.39050409849878, -1.6616045500062653],
            [-13.435974527928934, -1.9068511467388336],
            [-13.440568001593679, -1.9318633769698568],
            [-13.445734590578533, -1.9598831745727467],
            [-13.444855009324199, -1.960043245352769],
            [-13.470218535268408, -2.0980640081810105],
            [-13.472787136654675, -2.1124595223277747],
            [-13.5012432740612, -2.2661554111154563],
            [-13.515596766232916, -2.343986620075793],
            [-13.574974229158434, -2.6651185807426527],
            [-13.59537417742224, -2.7753062366493304],
            [-13.596051150634791, -2.7751815331982588],
            [-13.617600991591758, -2.890000691124684],
            [-13.616889989825358, -2.890135748387428],
            [-13.63175099350168, -2.9720657537527746],
            [-13.644047856475797, -3.0384814955076345],
            [-13.661347173487274, -3.1310936933602003],
            [-13.667148125416224, -3.128878010885041],
            [-13.670153352817524, -3.13146409258406],
            [-13.66886162031102, -3.135427231088905],
            [-13.67339027963747, -3.1387876374630874],
            [-13.676198583186045, -3.1435425447650176],
            [-13.679577334730928, -3.146602894855707],
            [-13.686191843730558, -3.14996804390067],
            [-13.695983733438252, -3.1512604331501137],
            [-13.708370804314114, -3.1459931440998927],
            [-13.714324925280659, -3.140235254376803],
            [-13.71950887377171, -3.139017039692446],
            [-13.729343710364184, -3.1425356554644908],
            [-13.734343279279958, -3.137255477012804],
            [-13.74471430030142, -3.132480557701542],
            [-13.75228524844759, -3.1329877916138655],
            [-13.760444542925372, -3.131111820002949],
            [-13.770590723085506, -3.1252292868222415],
            [-13.774714289459759, -3.1264896786743086],
            [-13.778547871689893, -3.1221859235757763],
            [-13.783078690170038, -3.1236671195051238],
            [-13.78970230347805, -3.1203624776484538],
            [-13.793876965438272, -3.121948169562255],
            [-13.80081102045215, -3.120671095507366],
            [-13.806546831429628, -3.118008061981856],
            [-13.810441861006122, -3.1112246536353374],
            [-13.816913656721216, -3.1114754936101305],
            [-13.821946649811785, -3.109294147094272],
            [-13.829415268503709, -3.1116873733078365],
            [-13.837113509594127, -3.119553377194191],
            [-13.84476612843866, -3.130073750275972],
            [-13.858830849913812, -3.1387065664938163],
            [-13.860800562803622, -3.1442225301606275],
            [-13.864010211257506, -3.145111771355451],
            [-13.873797225914474, -3.1531548986264624],
            [-13.87924409622466, -3.166944982057868],
            [-13.888847306346419, -3.171504230648761],
            [-13.89130517476867, -3.1749789454730406],
            [-13.8974638837125, -3.177932217928016],
            [-13.898110910208667, -3.1754339186166964],
            [-13.907119225309414, -3.1780866633124343],
            [-13.913797559388051, -3.1750381550361673],
            [-13.92114724882029, -3.178932777916228],
            [-13.928637066538206, -3.1779485235148694],
            [-13.934714703426636, -3.1795075747926185],
            [-13.939052671880386, -3.183088159546256],
            [-13.942510811658781, -3.1818156865086005],
            [-13.947349008045899, -3.1862716086269547],
            [-13.950525214092728, -3.184161969165909],
            [-13.956989452970383, -3.1838877910089174],
            [-13.960105947401198, -3.1861138992192606],
            [-13.968328557375315, -3.1836714789472538],
            [-13.980332527343824, -3.182240989181012],
            [-13.98174413462632, -3.1765636822301526],
            [-13.986782435005452, -3.1730972865066818],
            [-13.986461633107789, -3.1695153241192946],
            [-13.992699400236404, -3.166404161751445],
            [-13.99294660193565, -3.1609169127137675],
            [-13.995918968210686, -3.148264760405284],
            [-13.998412450548091, -3.1467993768061113],
            [-14.006512200694258, -3.146402743544569],
            [-14.010115884179662, -3.1474701137558494],
            [-14.018429890894199, -3.1476647557935116],
            [-14.024234281677664, -3.150017179658057],
            [-14.028238638967574, -3.1500229007071505],
            [-14.033022381312158, -3.152735477677987],
            [-14.038634690499952, -3.1514966959248616],
            [-14.048055660213302, -3.142021630206959],
            [-14.05523980897947, -3.141690653587485],
            [-14.059287649893372, -3.1435997711326094],
            [-14.063817491510678, -3.143310578757347],
            [-14.065297786529529, -3.14014084496327],
            [-14.069029423545707, -3.1426030757793315],
            [-14.07038897789078, -3.1466074401277786],
            [-14.074851580263099, -3.148515118642922],
            [-14.081985141969112, -3.149482994611147],
            [-14.085507803604104, -3.1481052522182744],
            [-14.088136749710701, -3.1346134026986845],
            [-14.09133409197274, -3.127880246212588],
            [-14.091338676939145, -3.118938819941993],
            [-14.095762841019186, -3.1158935568785395],
            [-14.106208253768289, -3.112248146252444],
            [-14.113448659240165, -3.113482385524638],
            [-14.127255006921041, -3.11461439264175],
            [-14.135204814618811, -3.1135839209939746],
            [-14.154053722609751, -3.108962538436817],
            [-14.161442494514977, -3.10192165095625],
            [-14.169076375061241, -3.0981915679931955],
            [-14.179979370889452, -3.095023774966117],
            [-14.192572077353717, -3.0933500572574912],
            [-14.202241429848467, -3.0945257500796663],
            [-14.209899892329487, -3.0925479626046384],
            [-14.21499477842211, -3.0928319841904304],
            [-14.219696348559582, -3.088628940770512],
            [-14.223320504972671, -3.0785479475713253],
            [-14.22800206749511, -3.0757374790871554],
            [-14.230779862350916, -3.080627093743081],
            [-14.23448504912736, -3.0829992367422725],
            [-14.238505112603029, -3.0815283539655187],
            [-14.238689066271409, -3.0778529943391555],
            [-14.24500658019013, -3.0704417440233023],
            [-14.244719347940872, -3.066823852157105],
            [-14.24797539888363, -3.061762257787502],
            [-14.251210549245062, -3.060218712406601],
            [-14.255451127128243, -3.0541394142528646],
            [-14.259108575885394, -3.0467143036315614],
            [-14.26360759795953, -3.043373345584981],
            [-14.267230435753005, -3.0434814066246543],
            [-14.272213254392785, -3.035917180493287],
            [-14.280507911597402, -3.032189075870981],
            [-14.287447912614677, -3.0349560640153355],
            [-14.294536802393951, -3.0348606413324357],
            [-14.302519583153842, -3.0271369915578585],
            [-14.304107811928148, -3.0240917711439006],
            [-14.312236559970387, -3.0234188861312297],
            [-14.313853274549201, -3.020350440819472],
            [-14.324664407131504, -3.0060201191363434],
            [-14.329851379141356, -2.982821199353353],
            [-14.334491390608541, -2.971883850969271],
            [-14.340471249916414, -2.9655188344258296],
            [-14.344590919365423, -2.962938733206778],
            [-14.350328740027956, -2.956447153707624],
            [-14.361610798751277, -2.953147453047657],
            [-14.370862168684933, -2.947810484203611],
            [-14.373164478974326, -2.9442959454776316],
            [-14.375363186368778, -2.93591814564555],
            [-14.382463331002954, -2.925314110500832],
            [-14.387618808234471, -2.919758858869092],
            [-14.39476131641312, -2.906855452741098],
            [-14.397112903686098, -2.9052118557534574],
            [-14.407098690587212, -2.9025924709524973],
            [-14.412054199035838, -2.899379286691889],
            [-14.414918941033017, -2.8929100006040036],
            [-14.414046893022066, -2.8864108489702978],
            [-14.415413929993106, -2.8822646273163155],
            [-14.419332712614565, -2.875944455223687],
            [-14.432077431708413, -2.864205228088707],
            [-14.437485394112224, -2.8616942813105646],
            [-14.439576042465953, -2.8530350314867703],
            [-14.442435512213509, -2.8476117463576838],
            [-14.447979159746177, -2.8450896614008845],
            [-14.459073578523565, -2.844665321880772],
            [-14.465379129838038, -2.8454554234960527],
            [-14.473822050420567, -2.8446617447964657],
            [-14.477276971336863, -2.840459019788874],
            [-14.482116125146943, -2.8317818769276224],
            [-14.481711303234245, -2.827644371035951],
            [-14.477147427314408, -2.819935545588419],
            [-14.474117503724585, -2.812855976079416],
            [-14.473172303124565, -2.8017343707541453],
            [-14.471298648547496, -2.7950685931451726],
            [-14.46566788757822, -2.78433885520582],
            [-14.463958675713313, -2.7751996923149034],
            [-14.463498072377606, -2.7617426261888642],
            [-14.467957187883895, -2.7472660546695344],
            [-14.475313850684529, -2.718473109405281],
            [-14.48691209712598, -2.70483548479356],
            [-14.494226665991446, -2.6912279163438484],
            [-14.494989571667682, -2.686742000868969],
            [-14.487418322021256, -2.6857333963204293],
            [-14.484269623729402, -2.683158053638431],
            [-14.482594207522277, -2.675158020244231],
            [-14.485342062932306, -2.67032080042622],
            [-14.49210038241483, -2.6620011445660943],
            [-14.492373304021486, -2.6516077068398887],
            [-14.490082965912736, -2.6451690459789585],
            [-14.491657278751752, -2.6363386224016003],
            [-14.494929716924652, -2.6306859720044824],
            [-14.499974902870566, -2.6247237700107373],
            [-14.499375614383407, -2.62101682377043],
            [-14.493479062771483, -2.6171258320747017],
            [-14.494883196287386, -2.6103595093466576],
            [-14.494625314725432, -2.604653505464493],
            [-14.498349488638125, -2.5947260766132794],
            [-14.499752940615322, -2.588904785623961],
            [-14.499967918720484, -2.5779972518581875],
            [-14.499265214237855, -2.572194506565307],
            [-14.502069944033751, -2.5650819440431776],
            [-14.509239869315904, -2.563109990336254],
            [-14.512610213828477, -2.5602753937424274],
            [-14.513777295913593, -2.5516044089013215],
            [-14.517079617561285, -2.5477633137780074],
            [-14.531966299976931, -2.535806469456806],
            [-14.539607690827355, -2.5198455066711074],
            [-14.54692528595785, -2.511945812650044],
            [-14.554908356489399, -2.500345160655224],
            [-14.55831457346409, -2.4925033983669387],
            [-14.564187120190345, -2.470349725874871],
            [-14.564787854760198, -2.4584698071740436],
            [-14.564420879219032, -2.4487302752329927],
            [-14.56603526246191, -2.4373034621799863],
            [-14.568726998034679, -2.426955107511587],
            [-14.572041630447533, -2.420669482798724],
            [-14.579903394672659, -2.410464120246651],
            [-14.590941413001088, -2.400778107773618],
            [-14.597702811308432, -2.3897000909477075],
            [-14.599589606413335, -2.380438996554515],
            [-14.598757211905623, -2.36961036078878],
            [-14.595821847012436, -2.3604470608368917],
            [-14.589822743163223, -2.349236976282049],
            [-14.588662150599882, -2.3447529443290818],
            [-14.588961319280742, -2.3350593899105583],
            [-14.586285022458178, -2.3259355492933356],
            [-14.582754724646767, -2.3183597084954073],
            [-14.5815977169728, -2.312295687061361],
            [-14.582925197253708, -2.297538049583939],
            [-14.580656805724884, -2.287568329520222],
            [-14.574606807734163, -2.2767162660446996],
            [-14.572069763683478, -2.265883024562385],
            [-14.573320821003112, -2.2553274498737936],
            [-14.574493989228358, -2.247953720098874],
            [-14.573259680163414, -2.2361267830592677],
            [-14.570824824353997, -2.2285842738304535],
            [-14.56545876974115, -2.220176650854599],
            [-14.559833258673399, -2.213961543460822],
            [-14.54077686625319, -2.2031289194535053],
            [-14.53729219763427, -2.1983891309344488],
            [-14.535870583439902, -2.1941888819958772],
            [-14.536101095264739, -2.18772956219732],
            [-14.541160995981802, -2.178232217765809],
            [-14.54752881215524, -2.171209094160921],
            [-14.562159821051353, -2.160290290314105],
            [-14.564229372857973, -2.154361945742996],
            [-14.561521778483016, -2.1507562091172776],
            [-14.549722351596433, -2.14160550208369],
            [-14.540234791635797, -2.1393145812051015],
            [-14.521377307582853, -2.1424500288463713],
            [-14.510805374926663, -2.141150368921061],
            [-14.50445524740983, -2.13853017669192],
            [-14.497843678315443, -2.1287952939717494],
            [-14.498065053088359, -2.124297137539374],
            [-14.490946766194673, -2.1067724946394115],
            [-14.486571179781123, -2.085891328301278],
            [-14.485509802084737, -2.0685179261118254],
            [-14.486628516071827, -2.0628430110281473],
            [-14.489969984966152, -2.0583364268670628],
            [-14.488198669830508, -2.0479427917478854],
            [-14.48792226633216, -2.0356581701516676],
            [-14.485326385158428, -2.005058968087924],
            [-14.48678120807353, -1.9692323699092937],
            [-14.47957255592661, -1.942616961785443],
            [-14.481256491437275, -1.9071133357281997],
            [-14.483294716822314, -1.8947185079101825],
            [-14.486475779306199, -1.8837958230811698],
            [-14.48571688184163, -1.866741947586778],
            [-14.487865231608023, -1.8531807543856798],
            [-14.504290780449189, -1.8281496504248034],
            [-14.504296486137555, -1.8229544384191225],
            [-14.509494908307158, -1.8096594236914239],
            [-14.508412977098583, -1.8028213055447302],
            [-14.509883722497591, -1.7975719810698167],
            [-14.507458278062977, -1.789307490740426],
            [-14.51179463782313, -1.7814233448205936],
            [-14.509367218319369, -1.7744279645777623],
            [-14.511192675898563, -1.7674419200410503],
            [-14.511473346586117, -1.7568752512190269],
            [-14.507457993594315, -1.7431550972197611],
            [-14.501470171553995, -1.737506319641908],
            [-14.495205897164444, -1.7360385918470438],
            [-14.487814693079827, -1.7270814725641725],
            [-14.48720123905239, -1.722997822055845],
            [-14.488759448190429, -1.7179683008592275],
            [-14.486141554131759, -1.6936215494143352],
            [-14.48842202758123, -1.683741382177861],
            [-14.492754070691543, -1.678716845996118],
            [-14.492376693195192, -1.6764421381560817],
            [-14.482827834664871, -1.6729118456547278],
            [-14.478596542359744, -1.6721767026882421],
            [-14.472707903526405, -1.662947687059883],
            [-14.469399480659169, -1.650032157551917],
            [-14.47245963481119, -1.6404123774166033],
            [-14.477146818658557, -1.6365628540683115],
            [-14.477996050784274, -1.6305670616152224],
            [-14.482425635172417, -1.6155768795735568],
            [-14.489742355625136, -1.6053723019053974],
            [-14.487766919864086, -1.590462884799357],
            [-14.47887668578364, -1.5788327381614666],
            [-14.476478069756226, -1.5732852786030065],
            [-14.477185703764583, -1.5684904623979328],
            [-14.4862196241593, -1.5585866816083755],
            [-14.48952517215964, -1.5531627932770173],
            [-14.491255290704352, -1.5454092076398351],
            [-14.490600583304625, -1.5419705315858454],
            [-14.479853531003394, -1.52155630612222],
            [-14.47419324790384, -1.499746206212506],
            [-14.476104238446618, -1.4858904789167329],
            [-14.469971736617937, -1.465409077317668],
            [-14.477218899012524, -1.447505672279994],
            [-14.474695518962157, -1.4438939969452325],
            [-14.468941192212505, -1.440514810338474],
            [-14.460212709846502, -1.427691958003545],
            [-14.458782552421933, -1.424331194008799],
            [-14.462653877358834, -1.4148086172041852],
            [-14.464368101456948, -1.405995379249027],
            [-14.461353789714174, -1.402925687313595],
            [-14.453716068681146, -1.4025259228501021],
            [-14.450593047850187, -1.3988294709462357],
            [-14.442242057463005, -1.3957366740112391],
            [-14.432182089455138, -1.395887052227187],
            [-14.425805629716596, -1.3929079827868762],
            [-14.425389160619975, -1.3883834268114013],
            [-14.431462969766752, -1.3827251782330705],
            [-14.434849800188921, -1.375170230694411],
            [-14.449030579766378, -1.3547905535513205],
            [-14.453440013463702, -1.3430671604317028],
            [-14.449552941294204, -1.3276413872867334],
            [-14.45275099287421, -1.3230931645445567],
            [-14.46067721741266, -1.2929494127335357],
            [-14.460447213334369, -1.2903603040577398],
            [-14.466162319665727, -1.275356516460739],
            [-14.466781273896308, -1.2655206335276317],
            [-14.462327926797004, -1.2591951006649837],
            [-14.462139256160158, -1.2443920045466659],
            [-14.458654908503123, -1.2380847554850851],
            [-14.448087106587144, -1.2320371114584305],
            [-14.442041255747874, -1.2271718069145436],
            [-14.441877872671695, -1.2230217085254484],
            [-14.447576165358816, -1.2155068151279518],
            [-14.453487718675932, -1.2142862515895743],
            [-14.454667658023572, -1.211658144410533],
            [-14.45382758181285, -1.205892679826647],
            [-14.446947833483726, -1.1992043802227392],
            [-14.446377811119099, -1.1940939292120938],
            [-14.449559941725552, -1.1810432038070993],
            [-14.454013212632068, -1.1714352997321051],
            [-14.45575272445436, -1.1652250149639147],
            [-14.453543402084609, -1.160717783782273],
            [-14.447258999966857, -1.1542638261337266],
            [-14.437235676410715, -1.148689987993091],
            [-14.421765841527405, -1.1483621406603652],
            [-14.410993950598291, -1.149828918045709],
            [-14.402264211880553, -1.1473147634033576],
            [-14.394298923238075, -1.1523337245785414],
            [-14.391882810941006, -1.1520656707831192],
            [-14.384475057569977, -1.1472738401105282],
            [-14.378502788325584, -1.1481162595512746],
            [-14.372085590711574, -1.1413392152008281],
            [-14.355789069545684, -1.1332612171828913],
            [-14.353144437632432, -1.1333481949098745],
            [-14.346820553698016, -1.1277455418477893],
            [-14.342609224893492, -1.1338018243369232],
            [-14.341130745376972, -1.1396354555900823],
            [-14.337502266748125, -1.1425220125761837],
            [-14.33334800944548, -1.1413860959391826],
            [-14.320271531980143, -1.1337120479933762],
            [-14.305998751302893, -1.1312275225981587],
            [-14.298475299896797, -1.1281912112345194],
            [-14.29072761041468, -1.1299070347078866],
            [-14.285891946052336, -1.1293716304817996],
            [-14.281015742706469, -1.1320575560498967],
            [-14.273344245137505, -1.132475743677966],
            [-14.26598017827144, -1.1380579425512547],
            [-14.253949796176624, -1.1373009034714325],
            [-14.249313819438003, -1.1393281871560326],
            [-14.244791125945836, -1.1455653930949308],
            [-14.244978820951031, -1.1494534143333184],
            [-14.251196458071094, -1.1527122113871608],
            [-14.253465995414876, -1.158875339958863],
            [-14.251052477250616, -1.162154076336719],
            [-14.246559389245434, -1.1636322139814868],
            [-14.234158683455405, -1.1628785695002208],
            [-14.220474434579849, -1.1561418412295128],
            [-14.216363043429464, -1.156121727320336],
            [-14.211073770543734, -1.1588723091988034],
            [-14.208984332637012, -1.1665584251587582],
            [-14.20606966203864, -1.1722077099542967],
            [-14.203484176826413, -1.173156971318667],
            [-14.18500486615514, -1.16469481413549],
            [-14.177322145305734, -1.158208647787012],
            [-14.172158273426154, -1.157291244068634],
            [-14.163938560188058, -1.1601377944501299],
            [-14.151538170908086, -1.1671430939579914],
            [-14.14560261630621, -1.1659297209376023],
            [-14.142420016871107, -1.1676168604189872],
            [-14.136488978031096, -1.1840252486170026],
            [-14.127341391545084, -1.195399615492929],
            [-14.121441943143964, -1.2085695678179305],
            [-14.117090372106714, -1.210738399222784],
            [-14.104379979308117, -1.236879594409182],
            [-14.103538890975036, -1.2441445666482946],
            [-14.10728513765742, -1.2494880318325403],
            [-14.111851272696573, -1.2522523791968203],
            [-14.114510148657258, -1.257484862355532],
            [-14.11307986793565, -1.2607062179796238],
            [-14.103587072846906, -1.2628675499822901],
            [-14.099170372553502, -1.2666674254465395],
            [-14.097921394130331, -1.2710115714757932],
            [-14.088840045372683, -1.2776035063288702],
            [-14.083153702192224, -1.279014532746526],
            [-14.082491385267028, -1.283854608683023],
            [-14.083543072701987, -1.2878985691577463],
            [-14.08175930113773, -1.2964271131265945],
            [-14.079583475873852, -1.3003391649352964],
            [-14.066407331883, -1.3134539299649886],
            [-14.060018647868977, -1.3171123537663796],
            [-14.054183276553331, -1.3164249094351106],
            [-14.04271028427811, -1.3184166082122588],
            [-14.0254197911247, -1.3164389232222344],
            [-14.010002906841478, -1.3125040290885113],
            [-14.00302747442388, -1.3137498038116584],
            [-13.993485213540177, -1.3194179521493266],
            [-13.98838682281413, -1.3161938069515349],
            [-13.986061650535625, -1.3094050378758602],
            [-13.9804635807924, -1.3074876615463735],
            [-13.976494817696175, -1.3013861198610277],
            [-13.975776938479939, -1.2919066153455536],
            [-13.969450703516946, -1.280248071721913],
            [-13.961919988554214, -1.2716323808459407],
            [-13.956521073492762, -1.2621311174596546],
            [-13.948513601371625, -1.2533752621116463],
            [-13.950342777115683, -1.2488777885877438],
            [-13.954154944302267, -1.2440243158435396],
            [-13.953274568533566, -1.2384040582507383],
            [-13.948907851899442, -1.2337678262674174],
            [-13.940488842507442, -1.2307144695846106],
            [-13.93202473795297, -1.23088459741404],
            [-13.924718051405584, -1.2153562658279322],
            [-13.914031177521608, -1.2041522710854888],
            [-13.898568268305281, -1.1788889842992292],
            [-13.888289432347191, -1.1696171727719826],
            [-13.87651895431457, -1.1670320709458832],
            [-13.866318161439175, -1.1138697570516558],
            [-13.862481124786884, -1.0875839729555754],
            [-13.858965625471102, -1.0693198497683372],
            [-13.853398778339065, -1.0460457884752514],
            [-13.850808980302686, -1.0298015238559575],
            [-13.840491802104612, -0.9827440866317197],
            [-13.828982142152695, -0.9244466165791156],
            [-13.823238922984158, -0.8932359166148685],
            [-13.819596509749605, -0.8668393526889139],
            [-13.798205341827686, -0.7435636002068853],
            [-13.786376501987917, -0.675057426312751],
            [-13.770923108613234, -0.5918771932105353],
            [-13.757924611240085, -0.5219156821934922]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.75789331325666,
          "lat": 35.70408063914914
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04015"],
        "coty_name": ["Mohave"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mohave County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00025445"
      },
      "bbox": [
        -14.599589606413335, -3.1862716086269547, -12.551574662369406,
        -0.36600235568978384
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.5282660418404586, 2.2410973313245766],
            [-4.441637758390072, 2.2352108474854395],
            [-4.354653811680394, 2.228897982618162],
            [-4.326650778855803, 2.22721365047072],
            [-4.269787969835877, 2.223184891055761],
            [-4.174174308115223, 2.2172062358411546],
            [-4.078561452865083, 2.2112145535903447],
            [-4.081981378916376, 2.1588681966171275],
            [-4.085319278136795, 2.107777310663284],
            [-4.092476446724796, 1.9982275546478367],
            [-4.093460525062668, 1.9803643969737248],
            [-4.098560391318629, 1.8997814604213785],
            [-4.22167707490587, 1.907330775603956],
            [-4.223709690652351, 1.907717452502554],
            [-4.358874813710258, 1.9165421256832935],
            [-4.402118933755845, 1.9192292001823812],
            [-4.445324849172225, 1.9215740284744858],
            [-4.560352175935081, 1.9291517184992704],
            [-4.557946258507788, 1.9648803993639072],
            [-4.548579518945682, 2.104900787874915],
            [-4.54595099259291, 2.1372086144333418],
            [-4.541415293351947, 2.1973508571508056],
            [-4.531051090267341, 2.1967767520458343],
            [-4.5282660418404586, 2.2410973313245766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.35759660887975,
          "lat": 40.593972076725926
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08095"],
        "coty_name": ["Phillips"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Phillips County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00198163"
      },
      "bbox": [
        -4.560352175935081, 1.8997814604213785, -4.078561452865083,
        2.2410973313245766
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.861939320749864, 2.246311170436975],
            [15.895260993841207, 2.256150500078414],
            [15.918007202624189, 2.258729853048555],
            [15.922681874533835, 2.2550027439750284],
            [15.92690140191992, 2.253855797845222],
            [15.932860374264648, 2.255065538152386],
            [15.937680288940376, 2.2574075893703323],
            [15.942290946064512, 2.2579052308703176],
            [15.945825860165664, 2.2607037905321388],
            [15.945978464266588, 2.263398287146571],
            [15.950230745653212, 2.270092152837312],
            [15.956458764908648, 2.2713770808392026],
            [15.960732075838274, 2.275278695892124],
            [15.964327469298519, 2.2821808414309106],
            [15.968728877282683, 2.281331051789462],
            [15.974510399126418, 2.282365709462108],
            [15.984720112204919, 2.2878542076121424],
            [15.991042426935275, 2.286615958695104],
            [15.997306376700568, 2.2928508977000015],
            [15.99955437546688, 2.303757870120507],
            [15.998212207747777, 2.308855581690855],
            [16.000669505296845, 2.312687364361556],
            [16.004831882392057, 2.3150391615662214],
            [16.00636758873406, 2.31922762238737],
            [16.001049698542015, 2.3263276821753687],
            [16.00253125806777, 2.3308160323821587],
            [16.00568901077198, 2.3276883230636085],
            [16.007150086286522, 2.3322188202560317],
            [16.011274369330536, 2.3344410931028867],
            [16.013213862718494, 2.338584835197012],
            [16.018315308991866, 2.3358285840061725],
            [16.022190956870677, 2.3446136575914642],
            [16.027387922010767, 2.346061749122994],
            [16.030257993481065, 2.3491479268435493],
            [16.032635383658764, 2.35448806430666],
            [16.039345226624054, 2.3492579195208587],
            [16.048647854180253, 2.3465899558428926],
            [16.051012616997085, 2.3442495604839757],
            [16.05041087238734, 2.338681072033223],
            [16.0540263437771, 2.335588149023914],
            [16.06303788614723, 2.333640454534137],
            [16.06316886323531, 2.331146375868726],
            [16.07237621130317, 2.3272195004609952],
            [16.079596986961675, 2.326134556680973],
            [16.08413802117256, 2.3235090317072453],
            [16.087417530874024, 2.317722413587393],
            [16.091612356203576, 2.315604690837105],
            [16.098827873409718, 2.315016892760983],
            [16.101260984306737, 2.311414919038783],
            [16.10315103509147, 2.3004785725233448],
            [16.10695029290177, 2.2932622646727916],
            [16.123455500826708, 2.2789496169370924],
            [16.125512521227844, 2.275562633440079],
            [16.131993924538126, 2.2714370711284557],
            [16.135411134996154, 2.2659705576293425],
            [16.134546646969145, 2.2585396759023326],
            [16.13675917203645, 2.2506988646552006],
            [16.140128674947295, 2.248625265525817],
            [16.141802592260646, 2.2339341761123097],
            [16.143397207542325, 2.2305797287939924],
            [16.149772352920934, 2.2254436168602068],
            [16.15126133215196, 2.2186870632130673],
            [16.153856934895153, 2.2146800263168727],
            [16.15563786653341, 2.2041706872130518],
            [16.15548796440054, 2.1963684506487273],
            [16.151965856621626, 2.183372110095019],
            [16.151654466647905, 2.177642761118751],
            [16.153185913464345, 2.173202949229898],
            [16.154185085744192, 2.164874505437545],
            [16.152775862082223, 2.161517201883252],
            [16.15472909627099, 2.1560440560786107],
            [16.161315496772655, 2.143561131728604],
            [16.16337981627223, 2.132046245307245],
            [16.17470811821101, 2.1103417376272273],
            [16.176655857145757, 2.089615341407357],
            [16.18002829149666, 2.0782429717703095],
            [16.186372868530448, 2.071710893930876],
            [16.18630727633137, 2.0703254641287763],
            [16.194046405426064, 2.065096660190582],
            [16.200604519217556, 2.0640778738829453],
            [16.20434202834254, 2.0608180278773855],
            [16.208114954437296, 2.059709002654917],
            [16.218915133398916, 2.0516312837563015],
            [16.23143569581108, 2.0461464563512677],
            [16.236163292004505, 2.0421296597305076],
            [16.260021115968495, 2.0145696601567593],
            [16.26419585357429, 2.0078284689948624],
            [16.26957438785556, 1.9954401199790972],
            [16.27248163780723, 1.9789565428731901],
            [16.27407302526241, 1.9739878997115234],
            [16.271877043695792, 1.9781666707180343],
            [16.265402683488674, 1.9798621032704913],
            [16.263685075134802, 1.9756124767608663],
            [16.25759470241592, 1.9752976760976921],
            [16.25641336588907, 1.9715315369071482],
            [16.24997880567732, 1.9702393043883148],
            [16.250118154799768, 1.9743994457783454],
            [16.24682826192275, 1.975748423073094],
            [16.24494179610982, 1.9691268170000442],
            [16.242909508920803, 1.969181728387451],
            [16.23461326629089, 1.9772803980432119],
            [16.23149769105964, 1.9728755921121595],
            [16.229008049521394, 1.9781598680134875],
            [16.225411960360624, 1.9792851043386956],
            [16.21891087183838, 1.9783042631979888],
            [16.218796667075345, 1.9721135116119664],
            [16.211119984572388, 1.967261270719185],
            [16.206892272527664, 1.9610311730639525],
            [16.2100554689152, 1.954518303204258],
            [16.20749383973786, 1.9505778915490406],
            [16.211557693585608, 1.9473856640593448],
            [16.210675633891075, 1.943021280759208],
            [16.212619142240204, 1.9407924646702945],
            [16.21032528977127, 1.9360130409785385],
            [16.212742880379547, 1.9319800440140416],
            [16.206799300983896, 1.9320651817743277],
            [16.20132441081744, 1.929133468033355],
            [16.200908348144605, 1.9251487355245236],
            [16.192241482839556, 1.9223013630022368],
            [16.18981626947191, 1.9191503304116106],
            [16.184541829493703, 1.9203794269300203],
            [16.1778187528937, 1.9178048900052163],
            [16.170159631718956, 1.9133519691576453],
            [16.16629617668253, 1.9144962776744208],
            [16.158394306776696, 1.9071132876972696],
            [16.152525128228294, 1.9035292454430424],
            [16.151645679791628, 1.8985491795399294],
            [16.153083897897584, 1.8924601428361703],
            [16.149356785026857, 1.886579391266284],
            [16.148042469761137, 1.8803461041812994],
            [16.14396764477577, 1.8789269492868739],
            [16.140905199916972, 1.8755023608088894],
            [16.140840007392384, 1.8721977759791448],
            [16.13800387104445, 1.85942415323308],
            [16.136673581383107, 1.8506000417007795],
            [16.126035569217457, 1.8422284329256464],
            [16.12486367331352, 1.8355096832205262],
            [16.118522679956097, 1.8314827549779165],
            [16.114954539227377, 1.8250962857240474],
            [15.989861094591769, 1.7919138456863328],
            [15.978995920430547, 1.8302836012289663],
            [15.954881301976855, 1.9160010757599442],
            [15.917312659690039, 2.049629112054487],
            [15.911497243984076, 2.0692872004107743],
            [15.904020860032801, 2.096997833371589],
            [15.898172211950373, 2.117895750926485],
            [15.894153426656153, 2.130391252617656],
            [15.875872763175444, 2.196945630775693],
            [15.861939320749864, 2.246311170436975]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.56863990979511, "lat": 39.08594402086645 },
        "year": "2023",
        "ste_code": ["10"],
        "ste_name": ["Delaware"],
        "coty_code": ["10001"],
        "coty_name": ["Kent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kent County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00217271"
      },
      "bbox": [
        15.861939320749864, 1.7919138456863328, 16.27407302526241,
        2.35448806430666
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.913897606654318, 1.6749028482263562],
            [14.930816648679974, 1.7011308997402805],
            [14.961219572292226, 1.747007252643242],
            [14.984230676874521, 1.7318913860862384],
            [14.996137935385878, 1.7235660830306176],
            [15.057570859009834, 1.68230110613446],
            [15.081108810712488, 1.6659757317273014],
            [15.056998138754244, 1.6286310312181818],
            [15.05453788060443, 1.6252477222218185],
            [15.039192144994193, 1.6008155699081292],
            [15.025902193074733, 1.5813370641979545],
            [15.003435884670454, 1.546033719265387],
            [15.001683055516242, 1.555120345033705],
            [15.00017323209599, 1.5685871791643622],
            [14.99740968817381, 1.5754695951573008],
            [14.996725408691573, 1.5827444258668968],
            [14.995172440334915, 1.5861376155823976],
            [14.99036198275536, 1.5877398627800294],
            [14.98969551917532, 1.5926371508204882],
            [14.997041391170091, 1.5950220722851538],
            [14.997181433714161, 1.6053879502387811],
            [14.99411110182207, 1.611594345367585],
            [14.98867374062085, 1.6178783753951895],
            [14.98631055376111, 1.6245057723482559],
            [14.979986231743151, 1.6227131444267142],
            [14.973516397278795, 1.6309824752046933],
            [14.971196249223583, 1.6305727014168814],
            [14.965525366435251, 1.638223221992917],
            [14.96053598303627, 1.648130402997801],
            [14.958120787806617, 1.6491875005418573],
            [14.94873835959038, 1.6485306178975034],
            [14.939251410711972, 1.6507366651794082],
            [14.93052682495547, 1.6561859413171696],
            [14.927099734497107, 1.6618788869923207],
            [14.920520488803593, 1.6668343606034128],
            [14.913897606654318, 1.6749028482263562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.01629544939028, "lat": 38.90468102546304 },
        "year": "2023",
        "ste_code": ["11"],
        "ste_name": ["District of Columbia"],
        "coty_code": ["11001"],
        "coty_name": ["District of Columbia"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["District of Columbia"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01702382"
      },
      "bbox": [
        14.913897606654318, 1.546033719265387, 15.081108810712488,
        1.747007252643242
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.683659670522527, -12.171477137635483],
              [14.683389844663653, -12.175131340836753],
              [14.690370440721974, -12.184570855937986],
              [14.689994408390099, -12.188842641514094],
              [14.68376727168544, -12.188676731499536],
              [14.681025269087563, -12.171884578874183],
              [14.683659670522527, -12.171477137635483]
            ]
          ],
          [
            [
              [14.648253775600223, -12.426877385866021],
              [14.65884339272609, -12.422375690664591],
              [14.659737832151356, -12.425670970412543],
              [14.650304912687943, -12.429238161320487],
              [14.648253775600223, -12.426877385866021]
            ]
          ],
          [
            [
              [14.619845691789168, -12.367660313856593],
              [14.623517833999433, -12.368742206806886],
              [14.625970174524618, -12.372781101888126],
              [14.624097279084234, -12.374934473071008],
              [14.61895672603023, -12.37138591745041],
              [14.619845691789168, -12.367660313856593]
            ]
          ],
          [
            [
              [14.622844572605375, -12.396128113616422],
              [14.623776257904447, -12.389872650768467],
              [14.62891398421803, -12.389571998725875],
              [14.624043807919943, -12.380986706074959],
              [14.634411221114949, -12.388792533553072],
              [14.62935311539182, -12.390869764828576],
              [14.622844572605375, -12.396128113616422]
            ]
          ],
          [
            [
              [14.606265511976959, -12.3828982901295],
              [14.608579128577697, -12.38295482419723],
              [14.615663383778152, -12.379071732620972],
              [14.612676364263997, -12.384920535218825],
              [14.610266286333742, -12.386992465784441],
              [14.606265511976959, -12.3828982901295]
            ]
          ],
          [
            [
              [14.606147298748832, -12.408815336062954],
              [14.608869802148725, -12.403818309150589],
              [14.612047733666369, -12.405571681123226],
              [14.610197370582679, -12.408450093832998],
              [14.606147298748832, -12.408815336062954]
            ]
          ],
          [
            [
              [14.589111532712504, -12.3501531675618],
              [14.594034384460452, -12.35048453195562],
              [14.593937157568142, -12.356479075231215],
              [14.589111532712504, -12.3501531675618]
            ]
          ],
          [
            [
              [14.583847468208326, -12.339861058090623],
              [14.588822708066397, -12.334944411194288],
              [14.592212370079475, -12.340093660461868],
              [14.584503105301946, -12.34136338817379],
              [14.583847468208326, -12.339861058090623]
            ]
          ],
          [
            [
              [14.550505500676339, -12.312975009232368],
              [14.554574467599663, -12.309328095215438],
              [14.558658479807379, -12.308041947831159],
              [14.562937402448757, -12.308721793632376],
              [14.5551232735209, -12.313534367051725],
              [14.550505500676339, -12.312975009232368]
            ]
          ],
          [
            [
              [14.533206307575675, -12.350217884718306],
              [14.538211484358538, -12.347837909964447],
              [14.54578296205873, -12.354049434004079],
              [14.542605561968116, -12.35702444806972],
              [14.537974147721815, -12.349090027197034],
              [14.533206307575675, -12.350217884718306]
            ]
          ],
          [
            [
              [14.537140847362908, -12.392108138394338],
              [14.542896315854511, -12.387608758476963],
              [14.53992232006092, -12.377770459992828],
              [14.548837390713375, -12.387500081026774],
              [14.540179356528569, -12.392464231561267],
              [14.537140847362908, -12.392108138394338]
            ]
          ],
          [
            [
              [14.523889149009515, -12.340081311334826],
              [14.52795401416082, -12.339480127747349],
              [14.529933583124025, -12.34224931717347],
              [14.526953164997026, -12.345628858897149],
              [14.523889149009515, -12.340081311334826]
            ]
          ],
          [
            [
              [14.530743964265504, -12.436287886095654],
              [14.533582651484735, -12.433807561581588],
              [14.536362135648657, -12.43469995836603],
              [14.53650670740475, -12.438805722085842],
              [14.533884820004662, -12.440518143487852],
              [14.530743964265504, -12.436287886095654]
            ]
          ],
          [
            [
              [14.495614445397855, -12.329953660979085],
              [14.503254439442632, -12.330063581488934],
              [14.508403798019824, -12.332503187880691],
              [14.515203697470183, -12.3302248743332],
              [14.516456569519615, -12.338636691317461],
              [14.514346023629876, -12.340041404237386],
              [14.507999754363452, -12.340189446757318],
              [14.502147978523046, -12.337624312711274],
              [14.499803508449437, -12.332644844005966],
              [14.495614445397855, -12.329953660979085]
            ]
          ],
          [
            [
              [14.501496655152419, -12.430155574216114],
              [14.508888752957054, -12.42558789459862],
              [14.510136925025677, -12.429890294142304],
              [14.513128376103712, -12.429210635623926],
              [14.511329711654874, -12.435699210072132],
              [14.514144430566098, -12.439985998689597],
              [14.512972249478908, -12.443540984593186],
              [14.508380024367225, -12.442484377946867],
              [14.507399739656375, -12.4319459949011],
              [14.50317352388987, -12.43247425251238],
              [14.501496655152419, -12.430155574216114]
            ]
          ],
          [
            [
              [14.512079183516612, -12.495529768969172],
              [14.51515210322066, -12.490276697564935],
              [14.51795372485984, -12.493116605544195],
              [14.512079183516612, -12.495529768969172]
            ]
          ],
          [
            [
              [14.478705436710188, -12.45396239974787],
              [14.481516839569771, -12.451620593385993],
              [14.484857162223577, -12.452269787641445],
              [14.482939381100158, -12.457132190081547],
              [14.478705436710188, -12.45396239974787]
            ]
          ],
          [
            [
              [14.460318901287378, -12.401901091525604],
              [14.462089716901094, -12.399019286200145],
              [14.468399719132687, -12.40061561000827],
              [14.471125781685062, -12.398486109632408],
              [14.476101425133583, -12.388538495599208],
              [14.475232970917796, -12.384042072556158],
              [14.472165616981243, -12.38057439630528],
              [14.466730519136709, -12.377822830834258],
              [14.46887797756123, -12.370812497827783],
              [14.47468538142914, -12.370113670805592],
              [14.473675460150112, -12.374004971663348],
              [14.470642239083276, -12.376056786334026],
              [14.480312248895721, -12.386086913897579],
              [14.480574081661073, -12.389011455973657],
              [14.478772662652869, -12.399562853952359],
              [14.47454451292619, -12.401219822301284],
              [14.472366819911452, -12.404504969386023],
              [14.477588752403898, -12.408339028935771],
              [14.478277486641698, -12.413483205532632],
              [14.476015104577872, -12.414994221161898],
              [14.481065500044087, -12.422830717588845],
              [14.48198839999612, -12.43144111190736],
              [14.476401941239722, -12.430929309048505],
              [14.47352818025217, -12.42799991322029],
              [14.47340985265036, -12.421407434381043],
              [14.468890524497219, -12.409240392516796],
              [14.466023314254095, -12.404836723922175],
              [14.460318901287378, -12.401901091525604]
            ]
          ],
          [
            [
              [14.598546741332687, -12.280928974304791],
              [14.59863162661021, -12.2768515219297],
              [14.59412428595983, -12.27643625504717],
              [14.590958055923533, -12.274456091942252],
              [14.58910910937792, -12.264916642754631],
              [14.595737213955623, -12.26124018975546],
              [14.600426407239528, -12.264344866198815],
              [14.60205651818514, -12.26071255309616],
              [14.607020949332634, -12.257573129725536],
              [14.612554627668267, -12.25710563211423],
              [14.612982409787088, -12.252589536290484],
              [14.623042574923355, -12.246670202090996],
              [14.631325344069744, -12.243025007108939],
              [14.63471556869479, -12.240062034974505],
              [14.644082201873783, -12.245615823817392],
              [14.65631142099488, -12.244046128405781],
              [14.655149290212252, -12.235969825186876],
              [14.660686794358421, -12.226537371168618],
              [14.672500155464437, -12.224612143089766],
              [14.674140280978028, -12.22983501352209],
              [14.672413827238774, -12.235904457966226],
              [14.673200741108163, -12.239250747749665],
              [14.661226026996788, -12.244030993172354],
              [14.661006060260538, -12.248592637466038],
              [14.663112270599601, -12.252568433956869],
              [14.658801805433514, -12.267476654339326],
              [14.65936498370638, -12.27275486454406],
              [14.664369793046061, -12.279525558848423],
              [14.668130568802411, -12.281549091910248],
              [14.678969201817464, -12.283691318703031],
              [14.688112207984748, -12.281684627882083],
              [14.689084883428553, -12.27636851329308],
              [14.696751124343452, -12.272810084486885],
              [14.702659312675385, -12.274485304001855],
              [14.704185472046824, -12.273079602821367],
              [14.703609921488086, -12.26579414447537],
              [14.712358170772847, -12.264067771861578],
              [14.716568568743613, -12.261594563590007],
              [14.720570633632644, -12.261788039599773],
              [14.722918134649577, -12.256141534818319],
              [14.725210068784001, -12.246925311070695],
              [14.729217639763105, -12.241325564216393],
              [14.731865517708355, -12.227734705536236],
              [14.73014382348025, -12.22085544242321],
              [14.731588597765585, -12.217040363346978],
              [14.730241286438698, -12.20588836291605],
              [14.728411477657437, -12.203554574397183],
              [14.722653499289377, -12.205332025755451],
              [14.720215465466342, -12.203307552512298],
              [14.720697607338865, -12.199017698340713],
              [14.717215521610598, -12.194739989545385],
              [14.711837419278126, -12.195508816575218],
              [14.709919144219022, -12.193293753389524],
              [14.706694193493412, -12.195712111176642],
              [14.702216625807786, -12.194649105184725],
              [14.698074251566364, -12.188763341779072],
              [14.70483463646469, -12.189864512116543],
              [14.70951542304986, -12.186135878131838],
              [14.71386306481537, -12.185034816142888],
              [14.718810506683994, -12.180490087313386],
              [14.722230699922108, -12.183495659571873],
              [14.726148296508514, -12.184699715522287],
              [14.731996673772022, -12.181044294275871],
              [14.736761398558446, -12.176645608901783],
              [14.740416824965184, -12.171685300730989],
              [14.747180134667948, -12.166308574403088],
              [14.74820505284041, -12.161528004321172],
              [14.753682459982425, -12.156960487588622],
              [14.754522510722957, -12.154011885296304],
              [14.759380697750267, -12.150023869646201],
              [14.759126279982627, -12.141526770686578],
              [14.766088382131796, -12.135668612331866],
              [14.76858614950719, -12.126196926023233],
              [14.769294016155719, -12.117088273801544],
              [14.774551750471568, -12.111416191865395],
              [14.783176886844021, -12.1113450934493],
              [14.781306798596438, -12.115862322781018],
              [14.7845626690436, -12.118805498888491],
              [14.789018598320117, -12.120393609114336],
              [14.785272638122173, -12.136340026385959],
              [14.777278566193562, -12.142126226130204],
              [14.771731545885181, -12.152809304276856],
              [14.771138161540732, -12.157899464028572],
              [14.772148460434485, -12.162453341341886],
              [14.76720984058959, -12.1792358022297],
              [14.760692082353637, -12.192104233607955],
              [14.755255320139852, -12.205550003165609],
              [14.753227887436399, -12.209008228075184],
              [14.749504738250554, -12.220459483997535],
              [14.748857401326463, -12.226474336325202],
              [14.74392527220139, -12.232124356927702],
              [14.741466935912616, -12.238223571258839],
              [14.738956256535868, -12.247608807161253],
              [14.735639169814313, -12.250876461385337],
              [14.736111140510653, -12.253910987620348],
              [14.734576748354533, -12.260655836259751],
              [14.731920557153828, -12.262500473282872],
              [14.730949194891826, -12.271958617318191],
              [14.724617358979573, -12.277833559395074],
              [14.72434839719956, -12.285153728186028],
              [14.72214440828947, -12.289855426465449],
              [14.718630762239792, -12.29189898394745],
              [14.713763404633475, -12.300900995168977],
              [14.716690935568055, -12.301900455646548],
              [14.725864241538616, -12.297464430833875],
              [14.729532272223333, -12.29815044831016],
              [14.726371681844448, -12.304188644933928],
              [14.724545982210484, -12.31433636006433],
              [14.720335713930403, -12.31523180418588],
              [14.71483757141779, -12.31915383803679],
              [14.712670748005921, -12.333466826150362],
              [14.711122682337132, -12.338912466322986],
              [14.7076208518765, -12.341745361519962],
              [14.70515674768306, -12.348707909997657],
              [14.702084238163392, -12.34963013588759],
              [14.696939924439253, -12.357123688402861],
              [14.694244468063946, -12.363026571453007],
              [14.685563232615587, -12.369927343204367],
              [14.682170368923634, -12.370761490706778],
              [14.679831290597363, -12.374784891996132],
              [14.677340594420732, -12.371760167999309],
              [14.673035782117976, -12.370455830371265],
              [14.668481075253322, -12.377662118257499],
              [14.669482277682144, -12.385405976399491],
              [14.660179918533117, -12.400132382649485],
              [14.655488599825045, -12.403635538664263],
              [14.64460393134687, -12.408597985241444],
              [14.636320498286105, -12.418308711151257],
              [14.627446443563002, -12.435216961885805],
              [14.620521423686249, -12.443056808973077],
              [14.62524187578626, -12.448023671265437],
              [14.625606166016778, -12.450845502544889],
              [14.622244397327686, -12.458201439545125],
              [14.618952542324843, -12.462655707831734],
              [14.60999838719792, -12.468678882465712],
              [14.608567914301885, -12.472516714381168],
              [14.605274980447952, -12.475712955503603],
              [14.605558241411021, -12.479709467696985],
              [14.592465595217153, -12.487227547107747],
              [14.590100476210356, -12.49410141625234],
              [14.58616489980993, -12.501150214745103],
              [14.581186394393365, -12.507940309195455],
              [14.578737000376824, -12.515535587351634],
              [14.574105721292668, -12.521328808101778],
              [14.571114605207097, -12.52336103795046],
              [14.56543149490344, -12.534043735957583],
              [14.553051978601987, -12.539965367844543],
              [14.547458296213163, -12.541515217982363],
              [14.540564683677744, -12.545183998690232],
              [14.538232741267628, -12.549005564083794],
              [14.533226160886022, -12.553138254810671],
              [14.521417133755605, -12.568434851004145],
              [14.513442052317561, -12.581888885599488],
              [14.494506886474994, -12.601432359505047],
              [14.491851022110755, -12.600774426042042],
              [14.49077590508864, -12.595557059507282],
              [14.497974015580093, -12.591194422141276],
              [14.499177285761586, -12.58489668154571],
              [14.505065908485633, -12.584628103840833],
              [14.508420536146703, -12.581221193970809],
              [14.513490959836941, -12.572065675678173],
              [14.515685643313763, -12.57115268108657],
              [14.521439792600225, -12.561727762301826],
              [14.518379212988274, -12.556075190118124],
              [14.517940163194856, -12.549499678933211],
              [14.521090700758554, -12.548972296715716],
              [14.524811422536072, -12.551931212307366],
              [14.527265075563106, -12.550495828786936],
              [14.52812148524775, -12.541978446170086],
              [14.53732807592511, -12.544575025139341],
              [14.54051409520255, -12.542355047664806],
              [14.541636790192072, -12.538623635148255],
              [14.536330707511787, -12.533997318287483],
              [14.53689848875123, -12.527485696594146],
              [14.540604068176476, -12.525162901688475],
              [14.545040195125338, -12.52660713415398],
              [14.548689330749566, -12.529918936640902],
              [14.552701751442472, -12.525831881588665],
              [14.556291592924863, -12.528144563729768],
              [14.564204050598327, -12.527188523944652],
              [14.56799673965662, -12.5188206961357],
              [14.57058202496818, -12.518615252275024],
              [14.574447470833096, -12.51331210785681],
              [14.573118201765348, -12.509300341679245],
              [14.575943687111488, -12.504082030105865],
              [14.577754007498424, -12.496476112398318],
              [14.578302310511942, -12.489479382037961],
              [14.581960136517006, -12.485857693899698],
              [14.579075865370406, -12.474004813348687],
              [14.582635742888163, -12.473897790109872],
              [14.590247385058321, -12.468825313541025],
              [14.593748349358739, -12.467462306784935],
              [14.60424240811784, -12.469231407563631],
              [14.606159679080438, -12.46618645666475],
              [14.603904618426087, -12.456425183683876],
              [14.607691264151427, -12.455647137761517],
              [14.611843141474006, -12.4502287848617],
              [14.610888687837596, -12.448320091374448],
              [14.614085344170658, -12.444384470354036],
              [14.613052815015347, -12.441251381227913],
              [14.616394064671704, -12.4357169355412],
              [14.6245386220594, -12.428714450763025],
              [14.62914353020174, -12.423583885610412],
              [14.63007017373131, -12.420473589089696],
              [14.643522070570405, -12.399959734159175],
              [14.643526856420745, -12.39374582579379],
              [14.6417216743311, -12.390246270461468],
              [14.64297711539471, -12.38657039529275],
              [14.646935061070435, -12.39235437663785],
              [14.650780000256923, -12.389628531350358],
              [14.656870683084835, -12.381908220229741],
              [14.65679493992028, -12.379499213106092],
              [14.661456365597274, -12.371167075772494],
              [14.663992477651473, -12.36854662555294],
              [14.662484520057658, -12.362894275697782],
              [14.658041723050836, -12.360769069448539],
              [14.657535466986436, -12.358429163718395],
              [14.653398313159048, -12.356148699091953],
              [14.648962467628088, -12.356021830141856],
              [14.646953268128515, -12.353924220571011],
              [14.640629023313204, -12.352417565009647],
              [14.634673575127923, -12.349167105799431],
              [14.636524753255467, -12.346318844105221],
              [14.637086505913034, -12.339844445256972],
              [14.631469733505462, -12.332755833181869],
              [14.631845236037512, -12.329064715530873],
              [14.629764124953146, -12.3229293840031],
              [14.63180813048358, -12.31512670899902],
              [14.635211407370075, -12.307897119495808],
              [14.63581644904794, -12.303870707488507],
              [14.640568911816047, -12.30179153727429],
              [14.642760974411258, -12.296489803183968],
              [14.642008642466738, -12.290084991578608],
              [14.637764006343149, -12.290585846778432],
              [14.634658756012405, -12.285035128098746],
              [14.629674685991352, -12.283534552867376],
              [14.62538873575567, -12.278744455678522],
              [14.622540681932248, -12.278831561412654],
              [14.618165496864478, -12.274245335123958],
              [14.612762116354267, -12.276586316812098],
              [14.605260523581375, -12.27435721903834],
              [14.599471172726131, -12.277952822588352],
              [14.598546741332687, -12.280928974304791]
            ]
          ],
          [
            [
              [14.472776492873388, -12.514982675117809],
              [14.475221618013865, -12.508851804666946],
              [14.481025195339939, -12.507220819395906],
              [14.482474766886183, -12.509546469114078],
              [14.479656832175266, -12.512520298985512],
              [14.480243450447443, -12.515373902756691],
              [14.472776492873388, -12.514982675117809]
            ]
          ],
          [
            [
              [14.479287754255411, -12.578348970051673],
              [14.482857647817854, -12.573201586040575],
              [14.48588558309711, -12.574205030282487],
              [14.487260417417684, -12.57861580081385],
              [14.48326777927007, -12.582550990193361],
              [14.478967950813535, -12.581581494133594],
              [14.479287754255411, -12.578348970051673]
            ]
          ],
          [
            [
              [14.441816860377983, -12.411057311370055],
              [14.44648050837023, -12.407039037028019],
              [14.451380859163933, -12.409425587938353],
              [14.452593075121149, -12.411719467111407],
              [14.44189111508043, -12.412484793379294],
              [14.441816860377983, -12.411057311370055]
            ]
          ],
          [
            [
              [14.43557639520952, -12.398485882593613],
              [14.434833812282204, -12.390465831494534],
              [14.438952341982036, -12.389585934040953],
              [14.443560275393551, -12.397330458154316],
              [14.43830299747067, -12.39635734605285],
              [14.43557639520952, -12.398485882593613]
            ]
          ],
          [
            [
              [14.44774205716868, -12.478700311065449],
              [14.451285073336832, -12.478014836712116],
              [14.452089629887203, -12.483170308819814],
              [14.447306408112098, -12.482089255605661],
              [14.44774205716868, -12.478700311065449]
            ]
          ],
          [
            [
              [14.4305953659918, -12.45747693309614],
              [14.434021787779358, -12.45009922564856],
              [14.437045898895727, -12.45157251882289],
              [14.435798748523133, -12.457302726767146],
              [14.438426104068673, -12.45909200783845],
              [14.434103786028308, -12.46226898019852],
              [14.4305953659918, -12.45747693309614]
            ]
          ],
          [
            [
              [14.4190744145555, -12.39330580683013],
              [14.42596050612313, -12.394812708608258],
              [14.421983721045347, -12.39939894750915],
              [14.418121799982217, -12.394699735791477],
              [14.4190744145555, -12.39330580683013]
            ]
          ],
          [
            [
              [14.451779944958457, -12.603618910372022],
              [14.454012222705202, -12.597395036706677],
              [14.45720763212288, -12.596882742883166],
              [14.461788726020872, -12.604499031447933],
              [14.45951030507602, -12.607677064562886],
              [14.453855583559042, -12.608192407808717],
              [14.451779944958457, -12.603618910372022]
            ]
          ],
          [
            [
              [14.404080491811431, -12.377888431073591],
              [14.408839071375933, -12.37662085614311],
              [14.409442716903518, -12.380254155416461],
              [14.417257212456756, -12.383083448480152],
              [14.421015486721815, -12.388590605145847],
              [14.414047327794737, -12.387937331666476],
              [14.411931443931348, -12.384665243221702],
              [14.404080491811431, -12.377888431073591]
            ]
          ],
          [
            [
              [14.411961402700916, -12.518622506116813],
              [14.412264442297513, -12.51182559576004],
              [14.41765393986642, -12.50842857545719],
              [14.416726601728147, -12.517194458749591],
              [14.411961402700916, -12.518622506116813]
            ]
          ],
          [
            [
              [14.39590604813763, -12.452750569792782],
              [14.397420878420037, -12.446051062302661],
              [14.40171898328722, -12.447026796089235],
              [14.405109953635884, -12.451779078401984],
              [14.39590604813763, -12.452750569792782]
            ]
          ],
          [
            [
              [14.402931721553637, -12.505466978276074],
              [14.406865286495682, -12.509750577046129],
              [14.40444564211518, -12.51123136982367],
              [14.402931721553637, -12.505466978276074]
            ]
          ],
          [
            [
              [14.425815420839523, -12.654918395890112],
              [14.425836140615539, -12.65207309115081],
              [14.431483247357875, -12.643676804969608],
              [14.437173341245385, -12.64057203731414],
              [14.442946315219203, -12.64366949836547],
              [14.449810392577627, -12.638333136246072],
              [14.450865868872397, -12.63562903978885],
              [14.455847948982916, -12.631781691783694],
              [14.455148517067803, -12.624326856543767],
              [14.461442742003987, -12.619281918427234],
              [14.465870598182512, -12.617977618482707],
              [14.467805532294907, -12.620895496193635],
              [14.462900510513451, -12.625613284493667],
              [14.45772234447489, -12.635584686465805],
              [14.45170076668321, -12.640811876225987],
              [14.439026007132126, -12.648731735308758],
              [14.435769381564162, -12.651778576013818],
              [14.431926111041777, -12.658728123671311],
              [14.429848171447961, -12.659137554247211],
              [14.425815420839523, -12.654918395890112]
            ]
          ],
          [
            [
              [14.335632452908799, -12.397586634387205],
              [14.338268432704613, -12.396855288282206],
              [14.347101124522407, -12.403413228774998],
              [14.341787258538844, -12.403743851495971],
              [14.335632452908799, -12.397586634387205]
            ]
          ],
          [
            [
              [14.336080807399936, -12.71576978176315],
              [14.337729379171437, -12.71389004919057],
              [14.346451714923948, -12.710757762176204],
              [14.35117146206007, -12.706994716936828],
              [14.351802224425198, -12.704446163250388],
              [14.358960541708203, -12.694950352170828],
              [14.36209062926676, -12.694187181961126],
              [14.367463875705091, -12.683817095875929],
              [14.371077520559082, -12.682016374030159],
              [14.380565630040016, -12.672041867022608],
              [14.383055508591871, -12.674892332279462],
              [14.373773583678762, -12.682893782753197],
              [14.368495295415851, -12.690053303544765],
              [14.36772351342737, -12.692899619969047],
              [14.371199006786401, -12.697697409742057],
              [14.378367766734916, -12.697784219306627],
              [14.384789027668269, -12.68875858550289],
              [14.38911718734982, -12.690903501997054],
              [14.38386078133331, -12.702190779982724],
              [14.3567195308519, -12.706141844666147],
              [14.347914345107466, -12.712827318037714],
              [14.337973446637843, -12.718466444896626],
              [14.336080807399936, -12.71576978176315]
            ]
          ],
          [
            [
              [14.256732721794197, -12.430557390037544],
              [14.257984560599036, -12.42731470741039],
              [14.257473193335388, -12.422089300263362],
              [14.263013838222408, -12.425087842732392],
              [14.263071123993361, -12.429360963115675],
              [14.257656377537732, -12.432689031195427],
              [14.256732721794197, -12.430557390037544]
            ]
          ],
          [
            [
              [14.229404711252673, -12.412578286331478],
              [14.233448183321569, -12.408044621987637],
              [14.237151991146453, -12.409936310116084],
              [14.233146138951046, -12.412849401432332],
              [14.229404711252673, -12.412578286331478]
            ]
          ],
          [
            [
              [14.228211562777835, -12.437017995853095],
              [14.230637563797089, -12.434976336782292],
              [14.235769004064643, -12.440033938189389],
              [14.232808054543705, -12.442820912232733],
              [14.228211562777835, -12.437017995853095]
            ]
          ],
          [
            [
              [14.274180614307692, -12.763629957215684],
              [14.27940312527755, -12.759027058951368],
              [14.282278385615916, -12.752265706092638],
              [14.285548339542808, -12.751202193535597],
              [14.288657917796629, -12.757495176902706],
              [14.284317206641582, -12.762740079053376],
              [14.274180614307692, -12.763629957215684]
            ]
          ],
          [
            [
              [14.266196621590138, -12.762875597451679],
              [14.271235926841864, -12.761880028602027],
              [14.271383554651829, -12.764802419427214],
              [14.267192785054288, -12.766929182080599],
              [14.266196621590138, -12.762875597451679]
            ]
          ],
          [
            [
              [14.20249843636951, -12.441031299491582],
              [14.209439233198474, -12.437538261748607],
              [14.21229554968872, -12.438911086563309],
              [14.206678552208825, -12.442612093531602],
              [14.20249843636951, -12.441031299491582]
            ]
          ],
          [
            [
              [14.10018941931926, -12.84862135807829],
              [14.105698581210879, -12.847107280826823],
              [14.115147877779778, -12.840833024793787],
              [14.117255952965985, -12.841950113622609],
              [14.122739153150414, -12.84041058632314],
              [14.130142971675514, -12.8348051021057],
              [14.138511116547322, -12.831930909670714],
              [14.142230289161684, -12.833022950430365],
              [14.1464188158601, -12.828604672289254],
              [14.15202527337657, -12.827197972868348],
              [14.150277823659202, -12.82453506684373],
              [14.154371720530657, -12.818966230589501],
              [14.158576689713298, -12.816227117049866],
              [14.162933466253508, -12.809272958451261],
              [14.170210336805182, -12.802595276139076],
              [14.17472833462575, -12.80233552133795],
              [14.185932523907004, -12.809645288141093],
              [14.193965674068977, -12.807299231271298],
              [14.199261826227897, -12.800758227762701],
              [14.201292334102945, -12.802085527723147],
              [14.21295993814911, -12.795274090143861],
              [14.212151489141474, -12.790898494222086],
              [14.216625211225765, -12.789027327490114],
              [14.217892632287406, -12.784244308497259],
              [14.224726687448584, -12.784796685503311],
              [14.226721907125851, -12.78054845514699],
              [14.231006848408828, -12.777509572510304],
              [14.235687210948441, -12.777727237006514],
              [14.23757744558998, -12.77222648806303],
              [14.242283168713728, -12.769850541695076],
              [14.245675289591626, -12.763969190166778],
              [14.247925683515614, -12.768247758520546],
              [14.251964764504619, -12.76519893397248],
              [14.258498860332217, -12.758385601976775],
              [14.264771204199265, -12.756748665344292],
              [14.265864145400942, -12.758824670794759],
              [14.26006808901411, -12.764995124312222],
              [14.239175432563592, -12.78368073219776],
              [14.236706253017015, -12.787757278852846],
              [14.230007800029679, -12.79170846103171],
              [14.226623127718312, -12.79591696544459],
              [14.216528609872011, -12.805244157180077],
              [14.204536021942236, -12.813327898673949],
              [14.20061027855357, -12.818710825540274],
              [14.19046989446696, -12.825162551135568],
              [14.18466980284879, -12.821953735216095],
              [14.184933496441744, -12.816427656970742],
              [14.179313435471316, -12.816717147205129],
              [14.1630084926444, -12.826354071862268],
              [14.157603407237902, -12.831384179903285],
              [14.15137699383316, -12.833129530104292],
              [14.148328008903645, -12.836726954819584],
              [14.145095988181824, -12.844490000473874],
              [14.14368435870566, -12.85221794738815],
              [14.144236772960541, -12.85901304614395],
              [14.141008176191162, -12.857113924218172],
              [14.13050070942212, -12.86127879055183],
              [14.127570864959274, -12.8610816706347],
              [14.118246190386389, -12.863898584720445],
              [14.113312360744253, -12.861100131149664],
              [14.109419944684458, -12.855050297211445],
              [14.104798804193004, -12.850781895078656],
              [14.10018941931926, -12.84862135807829]
            ]
          ],
          [
            [
              [13.96612950771471, -12.919287722637891],
              [13.971060859109318, -12.911365519052747],
              [13.97644211372802, -12.908604878949047],
              [13.982128601460746, -12.898137051643491],
              [13.991641860584672, -12.8981384295246],
              [13.994633971139034, -12.895272275581037],
              [13.997518392406404, -12.896617918409675],
              [13.99685920570976, -12.901388051868095],
              [13.994148425216842, -12.901595147773566],
              [13.991087234842928, -12.90521742266034],
              [13.977778211689499, -12.913136601573592],
              [13.97249221970306, -12.914969567549504],
              [13.96972383078118, -12.918553809867973],
              [13.96612950771471, -12.919287722637891]
            ]
          ],
          [
            [
              [13.934133150456518, -12.805618987690423],
              [13.935776827816632, -12.801968808612111],
              [13.94143420873212, -12.80547480866694],
              [13.94467053684087, -12.809532058903528],
              [13.94119821171248, -12.812639191522477],
              [13.936386153723005, -12.809927342140673],
              [13.934133150456518, -12.805618987690423]
            ]
          ],
          [
            [
              [13.920971695104667, -12.831780939090658],
              [13.922698536289984, -12.828049072569545],
              [13.927697838243397, -12.826338843544425],
              [13.935213842674528, -12.834981934434781],
              [13.936229041591552, -12.838127597290882],
              [13.927984661385853, -12.834815358349925],
              [13.921233899210804, -12.833422305287218],
              [13.920971695104667, -12.831780939090658]
            ]
          ],
          [
            [
              [13.907602162410486, -12.822789879526242],
              [13.909707888864487, -12.819348316205106],
              [13.91512879662574, -12.824403197864504],
              [13.916567234985866, -12.828455156458878],
              [13.907365379803988, -12.824333693325578],
              [13.907602162410486, -12.822789879526242]
            ]
          ],
          [
            [
              [13.909563850082689, -12.855922850306126],
              [13.91430883277844, -12.853816211146073],
              [13.912533438276789, -12.845465612529537],
              [13.906744610601768, -12.836686095836376],
              [13.908459779174459, -12.835887276769476],
              [13.920070758426142, -12.844847503433089],
              [13.926526905177647, -12.84439201262945],
              [13.935262049817556, -12.851264349580312],
              [13.93674882189275, -12.859869574941433],
              [13.939998828870664, -12.863580649372675],
              [13.938717048846623, -12.866626812521668],
              [13.93481011970777, -12.865332308567686],
              [13.929106707888021, -12.857394315554652],
              [13.92615085317587, -12.855525455550483],
              [13.917275797809635, -12.855483147892462],
              [13.911182220975391, -12.858494686978096],
              [13.909563850082689, -12.855922850306126]
            ]
          ],
          [
            [
              [13.897612577502167, -12.848359482941863],
              [13.90277589430984, -12.846735298722637],
              [13.902455544931522, -12.841948326780031],
              [13.907500824170192, -12.844441958259619],
              [13.90790072744723, -12.851109055038174],
              [13.90576215161904, -12.852273848263446],
              [13.902013143263886, -12.849583704672469],
              [13.897612577502167, -12.848359482941863]
            ]
          ],
          [
            [
              [13.738755987656608, -11.930170674780902],
              [13.741621796517212, -11.925991424219593],
              [13.750642544645357, -11.919490670601155],
              [13.756061445403828, -11.923285648541393],
              [13.756330657449697, -11.937919645645195],
              [13.745720716358557, -11.942535503133898],
              [13.740754417500455, -11.94065941565517],
              [13.738885885103011, -11.93689602808637],
              [13.738755987656608, -11.930170674780902]
            ]
          ],
          [
            [
              [13.621094957879995, -11.849882579616708],
              [13.636785216061211, -11.847421509480187],
              [13.751599995274523, -11.830203938996815],
              [13.772453938208937, -11.826507514321143],
              [13.809765138006615, -11.82071781264709],
              [13.896549355121278, -11.806983457806554],
              [13.983329312197576, -11.793223207847863],
              [14.070105016761103, -11.779437059627009],
              [14.156876476306325, -11.765625009808026],
              [14.184963278263162, -11.937852626483105],
              [14.185423394104703, -11.93966740985414],
              [14.226023345846858, -12.187557807702651],
              [14.235914071487445, -12.185809587453015],
              [14.255117067613611, -12.301508796672671],
              [14.258716168510853, -12.300844063390073],
              [14.2636065374365, -12.331244486065641],
              [14.26925185999157, -12.36412558232513],
              [14.260044137179158, -12.366213974935294],
              [14.25369220893525, -12.368805828584673],
              [14.249621361654661, -12.372284444813948],
              [14.24601859614309, -12.378886706041884],
              [14.243523227691773, -12.378103297818793],
              [14.237736426536893, -12.380002844989198],
              [14.233368007631045, -12.384003026632941],
              [14.233252489453172, -12.392068299340247],
              [14.23666138411396, -12.39754820665746],
              [14.236402891998967, -12.40539265232556],
              [14.22226728547046, -12.406008075709448],
              [14.198651679611407, -12.416399607717427],
              [14.197483165293866, -12.422453135074795],
              [14.193915082583024, -12.421255274013683],
              [14.192678969200704, -12.417332249311368],
              [14.185600352491578, -12.417202407038987],
              [14.179930392637532, -12.421538082688688],
              [14.177495864173146, -12.42010433576067],
              [14.172902150552721, -12.420887223633196],
              [14.149617600173936, -12.434024528832238],
              [14.14000485649369, -12.434363928314744],
              [14.127270313152438, -12.432441773002912],
              [14.10254839860991, -12.43736874054514],
              [14.089076312569889, -12.443349920979225],
              [14.077452630255133, -12.450510417325843],
              [14.074170698559524, -12.45356075645597],
              [14.067809895842993, -12.452866866844731],
              [14.062907167826197, -12.444690139845909],
              [14.059779431192501, -12.441050859132925],
              [14.044305661885497, -12.429566763891659],
              [14.035406305319237, -12.42426313649572],
              [14.028799075193538, -12.422264907048712],
              [14.016227150239667, -12.422442189324862],
              [14.011085546228392, -12.398010378834302],
              [14.002728223358277, -12.384919693602468],
              [13.995285974909546, -12.375911119635681],
              [13.988510292023355, -12.370466588391858],
              [13.978132956481462, -12.364689232663821],
              [13.975538261471083, -12.3420353320042],
              [13.976763125476852, -12.334689363340626],
              [13.975260132407747, -12.318503427842726],
              [13.979394469426373, -12.312602954383847],
              [13.978923278254342, -12.307270535848192],
              [13.976912393413972, -12.303735512140252],
              [13.977925501249914, -12.290098027040992],
              [13.983172645745764, -12.282495037975485],
              [13.98430244708358, -12.270070778117839],
              [13.980561874859879, -12.264093492815041],
              [13.98276934262478, -12.255901158877142],
              [13.988713792051932, -12.246842072711763],
              [13.99400863010639, -12.244187864223353],
              [14.005949736994928, -12.246501041869479],
              [14.00784251099367, -12.239878705527538],
              [14.00719261307472, -12.230455494290368],
              [14.004820616978318, -12.226606007650753],
              [13.999119755559112, -12.225574287585],
              [14.000596241942079, -12.219750221800224],
              [13.998186214351415, -12.215839648190569],
              [13.999849458406533, -12.211305569250753],
              [13.998247689141696, -12.208190032021923],
              [13.993120421809074, -12.207615545891413],
              [13.981347291051998, -12.208601165070922],
              [13.976061551380935, -12.207207525332983],
              [13.972216766121042, -12.204236320699742],
              [13.970243896219397, -12.192843782976484],
              [13.972628518363893, -12.187493780485667],
              [13.969573984896337, -12.183179885932546],
              [13.968357950609512, -12.176569255856759],
              [13.965746962194086, -12.171649253315035],
              [13.959849631186847, -12.167664635116713],
              [13.958955277702852, -12.160040451396075],
              [13.953074724353808, -12.154431418867853],
              [13.94745583496589, -12.145770147108324],
              [13.944070427820034, -12.133592331856468],
              [13.9438178848015, -12.128107900832973],
              [13.93187625481399, -12.124303119615014],
              [13.923152133083997, -12.120279693068888],
              [13.900518338088657, -12.098525863321969],
              [13.898525645373672, -12.088649383892378],
              [13.902159398646184, -12.071175038670535],
              [13.90033732299243, -12.066803970164752],
              [13.894406368347859, -12.058209487765074],
              [13.889917646040331, -12.057606004337424],
              [13.883973078061489, -12.054856883436521],
              [13.87827177208444, -12.05102581524313],
              [13.874749606219764, -12.045617294427736],
              [13.869450562084866, -12.042153950467359],
              [13.86955279272518, -12.037768944172509],
              [13.862877090370336, -12.032553624565455],
              [13.857516968488973, -12.020982387741503],
              [13.858586176664494, -12.014293111536448],
              [13.856370380529533, -12.007300080367987],
              [13.847568107737478, -12.006753287245754],
              [13.828368050873557, -12.0039245364001],
              [13.823380509272017, -11.994511247244684],
              [13.823025017708982, -11.981066346987076],
              [13.813337128556112, -11.97628566500425],
              [13.811354446812024, -11.967978457992025],
              [13.80569682615141, -11.968211954289192],
              [13.804685752900351, -11.959127628528165],
              [13.807964317087169, -11.953586062476056],
              [13.801166480747558, -11.951095048630501],
              [13.804009143575172, -11.943902429860163],
              [13.800245870078642, -11.936510148890733],
              [13.787666003841263, -11.932324131427897],
              [13.778497041826077, -11.924725492833618],
              [13.760767033165473, -11.919840151275807],
              [13.755751112324734, -11.915701690534052],
              [13.744937704941478, -11.911636825464269],
              [13.735590314369462, -11.905945846932433],
              [13.729622618393885, -11.898754059026738],
              [13.729190087860731, -11.894107519461935],
              [13.720100892211779, -11.893903469302],
              [13.708540847181109, -11.889989568721541],
              [13.709520614394025, -11.882038767038804],
              [13.704973570476454, -11.864712641562654],
              [13.697262433177768, -11.860215849926917],
              [13.692033557800626, -11.863107278338694],
              [13.673411625594635, -11.860835373145887],
              [13.663952647937764, -11.853077692727016],
              [13.65316842434316, -11.85240969145518],
              [13.647505400174873, -11.850164542335653],
              [13.632883757767674, -11.853816119702326],
              [13.621094957879995, -11.849882579616708]
            ]
          ],
          [
            [
              [13.787910075583621, -12.98273669364194],
              [13.789497619961125, -12.981992698636553],
              [13.802782765661158, -12.986834237154046],
              [13.802034251474995, -12.989977676834062],
              [13.797291917771423, -12.98697961878846],
              [13.787910075583621, -12.98273669364194]
            ]
          ],
          [
            [
              [13.498173730234699, -13.093049032797786],
              [13.500744849995009, -13.08030621341241],
              [13.506992552480181, -13.076534533739158],
              [13.50783219069419, -13.067260313367719],
              [13.505755082872303, -13.065425973217586],
              [13.503227729502298, -13.053425858458969],
              [13.50295883223624, -13.048265542016427],
              [13.50690284947475, -13.048950599647872],
              [13.509404936079159, -13.056188742999218],
              [13.510661826803112, -13.065036742145978],
              [13.521068512471981, -13.061409358382893],
              [13.527500464841859, -13.053800489860981],
              [13.534282855615144, -13.051590847824206],
              [13.547536070352145, -13.055260614239458],
              [13.558428345830409, -13.044060831113683],
              [13.571742757079267, -13.02601317453467],
              [13.56434115476062, -13.016484995637436],
              [13.541791106227338, -13.009446064746657],
              [13.52842811088263, -13.007140585872822],
              [13.5306369922266, -12.997667325353827],
              [13.535342717854336, -12.985298545362424],
              [13.542341094998966, -12.978590099361524],
              [13.580074372490277, -12.955671538694073],
              [13.591478480357452, -12.945742793174109],
              [13.603224370755175, -12.931050166032449],
              [13.617127232128128, -12.925691408417247],
              [13.627231019770099, -12.915007776064554],
              [13.665200823345451, -12.8924624340525],
              [13.677526526172137, -12.883831175087394],
              [13.686824299815871, -12.863309153415155],
              [13.695061411938514, -12.858162586449131],
              [13.737181969682915, -12.855967539435708],
              [13.738786073154142, -12.85418020274417],
              [13.74586109130482, -12.822190978132468],
              [13.747816385170974, -12.818919595820438],
              [13.752970284479732, -12.816114993228064],
              [13.767598809884836, -12.809751580448493],
              [13.775267321521094, -12.804185106683045],
              [13.79430090146928, -12.791685213362666],
              [13.796464372840552, -12.791824197727685],
              [13.79926999706053, -12.800307501991078],
              [13.791119331977313, -12.815949378386701],
              [13.785911011489214, -12.823654716400094],
              [13.788064822035034, -12.831312055412248],
              [13.794024094655216, -12.837012777262077],
              [13.820813277356669, -12.822146617127189],
              [13.827419889557532, -12.808994187176543],
              [13.831985042546759, -12.806126243012372],
              [13.836021246926842, -12.806721006942684],
              [13.858692847072101, -12.812353860386995],
              [13.864620872498461, -12.814462407045507],
              [13.871843222280539, -12.822904851678448],
              [13.875187941980037, -12.848601999822202],
              [13.88051024364698, -12.85284108655858],
              [13.88354661238529, -12.860791295928973],
              [13.892262572365796, -12.867564491352175],
              [13.902798020956476, -12.878793030447957],
              [13.908270799233252, -12.880486252195519],
              [13.912977752373301, -12.87945704337534],
              [13.923682602301575, -12.879935060584247],
              [13.927329940477199, -12.884256594985306],
              [13.933730992414462, -12.898770003936313],
              [13.939259977358196, -12.914604573074312],
              [13.951527305046683, -12.921744980025686],
              [13.938040736466515, -12.931708141058536],
              [13.924812335261509, -12.935516028836883],
              [13.921347812080258, -12.941598644620287],
              [13.916442022171804, -12.941748596242238],
              [13.90926127673376, -12.947210060203874],
              [13.89630372262077, -12.951908054352927],
              [13.87185198168004, -12.96593865014815],
              [13.867602263201729, -12.967785730544698],
              [13.86077942398942, -12.96647143200179],
              [13.85381480948877, -12.949116185637106],
              [13.847586503376304, -12.945898321206975],
              [13.838482344735962, -12.947402780011688],
              [13.825890158452967, -12.945276326522022],
              [13.819633601633505, -12.954053762979933],
              [13.81743803099925, -12.952749356210013],
              [13.815315108611744, -12.944240178838779],
              [13.792182112619093, -12.952024920112558],
              [13.786031398935327, -12.957257351873213],
              [13.784353985364856, -12.954355673453996],
              [13.761388187908516, -12.951283458409396],
              [13.759151420357924, -12.95886971351092],
              [13.761814912597618, -12.967138213318952],
              [13.76131835027199, -12.97935213672383],
              [13.755938809603062, -12.9844665421849],
              [13.754826018018418, -12.986993794728964],
              [13.741035441611949, -12.989936341083938],
              [13.73491659490931, -12.994260677091054],
              [13.719631312304426, -13.001240132762291],
              [13.715985734000173, -13.00736033838486],
              [13.706917466418739, -13.011534366041975],
              [13.697938816394947, -13.01827465633037],
              [13.692181729137973, -13.020974386408401],
              [13.681989299093493, -13.029608127249494],
              [13.67522529607467, -13.031183438931558],
              [13.661308183324483, -13.039579807601692],
              [13.652125435894934, -13.040885111659877],
              [13.647394650719383, -13.045679455485992],
              [13.628491831996703, -13.050092891259077],
              [13.618928344302223, -13.061509269503883],
              [13.61232988068089, -13.066657597364925],
              [13.600764943515182, -13.067548152711916],
              [13.588972834554, -13.072319326566351],
              [13.583429576860809, -13.072480124495483],
              [13.56694166253589, -13.075152395161481],
              [13.555020911547064, -13.079050285448151],
              [13.549740831954239, -13.082621868866887],
              [13.542013858991162, -13.083103156160215],
              [13.53151983145074, -13.086599242114064],
              [13.52224892106982, -13.091542893281508],
              [13.506548282304276, -13.095998758880208],
              [13.498218135450527, -13.096283726732123],
              [13.498173730234699, -13.093049032797786]
            ]
          ],
          [
            [
              [13.422237999648312, -13.09060859694112],
              [13.428779829119597, -13.089427287557854],
              [13.431111657595025, -13.09165038428511],
              [13.427395293506555, -13.094677036167061],
              [13.422237999648312, -13.09060859694112]
            ]
          ],
          [
            [
              [13.3956274016282, -13.111880732667784],
              [13.398564054399367, -13.10789885627684],
              [13.402783174259717, -13.108959244945984],
              [13.40268088218198, -13.111771614544045],
              [13.396553066496026, -13.116462959908352],
              [13.3956274016282, -13.111880732667784]
            ]
          ],
          [
            [
              [13.394970501582415, -13.127103797706656],
              [13.396955329725024, -13.12330154510099],
              [13.404465213750477, -13.12448487109186],
              [13.403589898059014, -13.126525448589984],
              [13.395364547193738, -13.129628040172877],
              [13.394970501582415, -13.127103797706656]
            ]
          ],
          [
            [
              [13.349537417493552, -13.138173564364594],
              [13.356513973103848, -13.134902944649083],
              [13.359460372397658, -13.137838244068893],
              [13.350038096321146, -13.139444112056959],
              [13.349537417493552, -13.138173564364594]
            ]
          ],
          [
            [
              [13.319858104747198, -13.13247615214115],
              [13.321513070229068, -13.129335503020028],
              [13.329140091684256, -13.132478444628033],
              [13.330455835316451, -13.136077514566173],
              [13.32396792769728, -13.139143350257623],
              [13.319858104747198, -13.13247615214115]
            ]
          ],
          [
            [
              [13.18822773876532, -13.097991075404217],
              [13.19240666735311, -13.092300299389974],
              [13.201165023460359, -13.08875085563237],
              [13.205966526023305, -13.088494596472879],
              [13.222128812485407, -13.092438471232924],
              [13.22884522263621, -13.096894878869758],
              [13.232245672058037, -13.106565040599085],
              [13.231923388563256, -13.115432252371507],
              [13.228678183382497, -13.1226292709957],
              [13.223961108432386, -13.126295361742987],
              [13.222892645693436, -13.13035099467799],
              [13.218542299067996, -13.133814435306377],
              [13.208027607216726, -13.135645310854505],
              [13.204429937039002, -13.132087042037893],
              [13.214171181055471, -13.131321744907144],
              [13.216973425061056, -13.127142231868245],
              [13.222222582495915, -13.122296222901484],
              [13.223240794432245, -13.113648387142277],
              [13.220778803030852, -13.112007561248117],
              [13.216040742431954, -13.113631419789128],
              [13.210850037661347, -13.102724090248895],
              [13.206854583492612, -13.099728123375732],
              [13.193524310731858, -13.096493476291576],
              [13.18822773876532, -13.097991075404217]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.10920206455593, "lat": 25.32070757448606 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12087"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00295759"
      },
      "bbox": [
        13.18822773876532, -13.139444112056959, 14.789018598320117,
        -11.765625009808026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.964403217046886, -10.659070265903491],
            [14.082961468368488, -10.640773986251435],
            [14.20151312871716, -10.622434349727897],
            [14.23498316737654, -10.616956660205597],
            [14.321578639960068, -10.602967403275152],
            [14.35580198365383, -10.597688081994326],
            [14.407987280877467, -10.588500135109912],
            [14.494139101063203, -10.574951022482018],
            [14.52317863483441, -10.570898223842953],
            [14.579960551202394, -10.561978970346129],
            [14.622988047131987, -10.554907900203123],
            [14.620848375686712, -10.541095882359183],
            [14.675581269064173, -10.53243437126438],
            [14.684002454853282, -10.54973816444273],
            [14.688126604341461, -10.556002134393852],
            [14.687699369814451, -10.557796992904903],
            [14.694862839464324, -10.574513187492846],
            [14.713274802438661, -10.6120827179417],
            [14.723841399305213, -10.634630524899102],
            [14.747482862468972, -10.692966789184489],
            [14.748138466646742, -10.701877335932451],
            [14.749568862140885, -10.70510439889957],
            [14.750718230569783, -10.714895037153026],
            [14.747431493452645, -10.715287310452846],
            [14.747058351193605, -10.722730979903874],
            [14.754399212490585, -10.750998132996695],
            [14.757260608686263, -10.765751855017024],
            [14.759425915156493, -10.771662183045233],
            [14.761803629517429, -10.785080772796166],
            [14.762998880189416, -10.795878768853473],
            [14.763554491812258, -10.809327761788111],
            [14.767466865291563, -10.838348011543895],
            [14.77375892292053, -10.869762038698559],
            [14.775395464298409, -10.880002191547334],
            [14.778508082348365, -10.912345400225053],
            [14.778523887139464, -10.92707027539853],
            [14.779629250793272, -10.935782041470471],
            [14.778349930426618, -10.943390823947627],
            [14.778204259185253, -10.971496958528158],
            [14.779657383856016, -11.024719752729151],
            [14.780266845488033, -11.026931884644075],
            [14.780857218216207, -11.04669693274593],
            [14.78418104644876, -11.085551369667716],
            [14.783538505784108, -11.087002927613023],
            [14.786183600012933, -11.108969100743373],
            [14.788893278180534, -11.140668851791578],
            [14.787560658036444, -11.141974817590995],
            [14.787637787233516, -11.156100101841734],
            [14.776035180184449, -11.158280907078659],
            [14.771424771630127, -11.153536214858637],
            [14.765579835812682, -11.157353134585282],
            [14.76480214632894, -11.15336752200954],
            [14.75760836907734, -11.154336095481538],
            [14.671350130786957, -11.16861648325726],
            [14.627064210289166, -11.162182482702665],
            [14.584142100104915, -11.155684230390463],
            [14.587486765671672, -11.175929584211168],
            [14.480982234747751, -11.193120525538697],
            [14.374471663741215, -11.210274199016801],
            [14.370894559828097, -11.210740677908388],
            [14.294816835783728, -11.223098250706956],
            [14.21873595721869, -11.235436806530712],
            [14.142651918595611, -11.24775634763027],
            [14.066564714357675, -11.260056876139656],
            [14.064067166800141, -11.248312084570177],
            [14.065770563474523, -11.248109088958756],
            [14.044770684291255, -11.136866897998134],
            [14.044453927137795, -11.134297825185016],
            [14.019280968013677, -10.995894705068633],
            [14.012204553640101, -10.95392900686895],
            [14.005591154434784, -10.912347144075783],
            [13.994029383656372, -10.84194736980742],
            [13.964403217046886, -10.659070265903491]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.4654969102096, "lat": 26.647569993058156 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12099"],
        "coty_name": ["Palm Beach"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Palm Beach County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00295761"
      },
      "bbox": [
        13.964403217046886, -11.260056876139656, 14.788893278180534,
        -10.53243437126438
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [11.325210163050304, -7.381006946200827],
              [11.325209665035006, -7.3810069782564165],
              [11.298066037140831, -7.382681033909282],
              [11.300697412767066, -7.377974901503572],
              [11.307259031218031, -7.377556830026039],
              [11.3093815282655, -7.374027835817119],
              [11.31433998811506, -7.374921702906431],
              [11.318207961639263, -7.378884198903876],
              [11.325210163050304, -7.381006946200827]
            ]
          ],
          [
            [
              [10.909868128380056, -7.030744099129682],
              [10.991117712353187, -7.021997505528752],
              [11.047741001708777, -7.016689384307486],
              [11.044389361903352, -6.9903498014209315],
              [11.041192513871996, -6.973094915589578],
              [11.04984541247976, -6.981980598308304],
              [11.054301460412608, -6.984151409218116],
              [11.056765273153673, -6.98767605171234],
              [11.059548109402918, -6.987975216135541],
              [11.061862978997121, -6.992510406708658],
              [11.06555249875373, -6.994771772487697],
              [11.072515653356128, -6.996138689942467],
              [11.083381891564468, -6.9920274952267505],
              [11.090504319337311, -6.991648592339062],
              [11.09427985780151, -6.993531905268089],
              [11.099094436404252, -6.993169619316904],
              [11.101538138624687, -6.9951730831028],
              [11.104944929498936, -6.991853527244833],
              [11.108407957036778, -6.991620865429747],
              [11.112795715976171, -6.997774895217978],
              [11.111952409486273, -7.001407892668918],
              [11.116206318147878, -7.002457078476235],
              [11.119611113659918, -7.005814123668932],
              [11.125905215823199, -7.007691425448056],
              [11.131273147858973, -7.0076633605273155],
              [11.135976973202101, -7.015183507446922],
              [11.141278894369588, -7.019866716773277],
              [11.141137328571201, -7.024521157079553],
              [11.157200847256192, -7.04612052221387],
              [11.161903732265793, -7.046775905655264],
              [11.165034021099517, -7.050385972457077],
              [11.167147990016852, -7.061903271334734],
              [11.171385206263947, -7.065994554624304],
              [11.175258450052892, -7.072657006579285],
              [11.174559548418962, -7.079047002462044],
              [11.177887999092206, -7.077623727028588],
              [11.181532742716206, -7.084621074234751],
              [11.180213414093762, -7.089290459340614],
              [11.175923476877983, -7.0954852471234],
              [11.178334003899504, -7.098447326824316],
              [11.176047059584349, -7.104740943024583],
              [11.17823906273696, -7.106560121375451],
              [11.175664111244247, -7.119919032103616],
              [11.177600598458067, -7.120859290018296],
              [11.179595007325466, -7.130367177077702],
              [11.186795575608201, -7.1321546225329016],
              [11.192597325590656, -7.137641780274347],
              [11.199265897548425, -7.141856513715698],
              [11.202064446274266, -7.137289492177956],
              [11.216084429221533, -7.145156838114637],
              [11.21697823329754, -7.143874062115624],
              [11.226738202929639, -7.142325784998256],
              [11.230437384857353, -7.142554467571726],
              [11.236135614418181, -7.145106029653876],
              [11.239494988541626, -7.141111753607361],
              [11.244166127708434, -7.144855121424939],
              [11.246183660872946, -7.148408273479692],
              [11.251342437692204, -7.151170946288841],
              [11.256339589529896, -7.162060004711715],
              [11.259710818217602, -7.163388071451008],
              [11.264434616789256, -7.169207150335907],
              [11.260620604259005, -7.177505416208574],
              [11.262251919979818, -7.180069225070684],
              [11.255995189947612, -7.1872247359769705],
              [11.245862023897189, -7.187585526718599],
              [11.243930510410191, -7.185681630940481],
              [11.239663809288812, -7.195599769481339],
              [11.23625595644712, -7.198394890305353],
              [11.22984854824941, -7.199516456142244],
              [11.226300494612458, -7.202467121565272],
              [11.214650142677915, -7.200397122248184],
              [11.209738387028496, -7.201391582407475],
              [11.208449002676998, -7.204941101196261],
              [11.203843924360303, -7.211294883258201],
              [11.202355032856014, -7.215582970515646],
              [11.19223529315787, -7.218089508309643],
              [11.18590432483621, -7.215501300535133],
              [11.18128706577545, -7.216294478639968],
              [11.181252988522377, -7.223055522274167],
              [11.186011531121732, -7.228450313643987],
              [11.185877853629252, -7.234466576101142],
              [11.182196429558342, -7.238308113800574],
              [11.183207450029823, -7.245505794642676],
              [11.178759162468271, -7.248414468101502],
              [11.179934076366742, -7.252395618133155],
              [11.179281640345636, -7.257791209110732],
              [11.183859318954559, -7.263368859539868],
              [11.180764272586725, -7.269705894820495],
              [11.171815072038623, -7.271714306326526],
              [11.170167293307017, -7.276365387276649],
              [11.16765517668116, -7.275410580346969],
              [11.161699156712617, -7.279734835114983],
              [11.16034076362667, -7.284486894751272],
              [11.165163242071015, -7.292108344055403],
              [11.169874574598639, -7.295254904788042],
              [11.17754742222671, -7.303225948688517],
              [11.178514095771764, -7.308728273536913],
              [11.17832355137159, -7.316198265565738],
              [11.180964853059725, -7.316401485140102],
              [11.188329898796052, -7.319840678283151],
              [11.192013707193144, -7.322685806550955],
              [11.195726475351877, -7.332419840275893],
              [11.199329196724321, -7.336540058696675],
              [11.202917773008876, -7.33592774841719],
              [11.207080050273738, -7.342339957702495],
              [11.214473096287444, -7.341204448677965],
              [11.220135179532539, -7.34289257002565],
              [11.222128656929778, -7.339458856093793],
              [11.22605876415075, -7.342593910577106],
              [11.22803755317588, -7.348281412108729],
              [11.22622842602459, -7.3500138033126845],
              [11.232140545155909, -7.353736268800383],
              [11.238834801465483, -7.352002985841476],
              [11.245481552343053, -7.348553219005558],
              [11.250231037775881, -7.353347055335777],
              [11.248667248329701, -7.357757552623919],
              [11.254471416201989, -7.357428655860471],
              [11.257404802570909, -7.359798485293209],
              [11.264870058968027, -7.3615928915723865],
              [11.265534868871857, -7.363642161001738],
              [11.27043601357489, -7.366140911695596],
              [11.275329811968282, -7.3667076133982325],
              [11.278647159882354, -7.369688740695589],
              [11.280229738006442, -7.377312892516269],
              [11.27616937094057, -7.380460084326261],
              [11.28359306576909, -7.383576977234475],
              [11.221975410898533, -7.387558236133602],
              [11.20533608766729, -7.388858295180791],
              [11.16152879066079, -7.391347020426482],
              [11.065628304927, -7.398268930177141],
              [11.009796436844715, -7.401851300144824],
              [10.952365150774343, -7.405757108674071],
              [10.942834015249044, -7.3231240945365315],
              [10.945589276686464, -7.32280873945049],
              [10.939188219493166, -7.275529702076058],
              [10.934241081590699, -7.247909193808343],
              [10.930821297615593, -7.217500769837189],
              [10.924727830355636, -7.166802001796823],
              [10.917220996706567, -7.097154461105225],
              [10.909868128380056, -7.030744099129682]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.58015498829603,
          "lat": 30.841947744280574
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13027"],
        "coty_name": ["Brooks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brooks County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00345518"
      },
      "bbox": [
        10.909868128380056, -7.405757108674071, 11.325210163050304,
        -6.973094915589578
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.728293884607655, -3.7724146456200165],
            [9.785548902595687, -3.7659442106408085],
            [9.789419750797899, -3.796579093172558],
            [9.876433882769732, -3.7869579356339065],
            [9.903592226161384, -3.78385675616143],
            [9.90280103137507, -3.7760497376967024],
            [9.917130164539879, -3.7745016752888367],
            [9.918034051242076, -3.7818906728247903],
            [9.937390269027338, -3.7796265744513584],
            [9.938236328943018, -3.786845221177247],
            [9.94518221406303, -3.7859685007940636],
            [9.944354769886978, -3.7785712430636806],
            [10.053643623950348, -3.7648034675802946],
            [10.058939516071261, -3.8106009222899675],
            [10.061715717287518, -3.835064917214951],
            [10.067493143654374, -3.883306477643546],
            [10.073636259249112, -3.9326920190923285],
            [10.076705306227995, -3.9596163807120557],
            [10.029002033268641, -3.965134581511973],
            [10.020072061484528, -3.9664969897012607],
            [10.01320511829024, -3.9754631190841714],
            [10.009245108797256, -3.9778889633544563],
            [10.001847348092333, -3.9781722976563625],
            [9.999669266240033, -3.9870030853064464],
            [9.996913338567175, -3.9933621786198414],
            [10.00079136042356, -4.000176665303087],
            [9.998731518773027, -4.002519173573255],
            [10.000863503683524, -4.014103704017427],
            [9.99937588626253, -4.0186800261816025],
            [10.001347038490875, -4.02389711685099],
            [10.000595010453686, -4.031506488763463],
            [9.994453142838216, -4.033926261393359],
            [9.98666460299235, -4.038764286784345],
            [9.979671382519566, -4.03898107635197],
            [9.971700847983824, -4.048197412019242],
            [9.962078373299825, -4.0526685116276315],
            [9.958962739614456, -4.050648199768102],
            [9.95625651349685, -4.05229835801913],
            [9.960198930914144, -4.087769437105101],
            [9.942895421795201, -4.089640031828525],
            [9.884445020243314, -4.095234362131222],
            [9.883984607008795, -4.0913040461385295],
            [9.880413431730178, -4.0917123433302685],
            [9.880876286274736, -4.0956302113960605],
            [9.821417251824936, -4.101347452762602],
            [9.799410540392296, -4.103265664169417],
            [9.798977774675443, -4.099123535498496],
            [9.791682839752603, -4.09982585451401],
            [9.792135053697356, -4.104002084402657],
            [9.763523289108065, -4.1067810416710095],
            [9.756927537846495, -4.0425461287880315],
            [9.751188643218212, -3.9926563352822804],
            [9.749838103641547, -3.9824382726760805],
            [9.75012365830313, -3.957611884844487],
            [9.747801877634254, -3.934680892123048],
            [9.735552982298909, -3.8380528493399506],
            [9.743140527868837, -3.8372497502158827],
            [9.74245678240808, -3.8288859958748467],
            [9.734531086300251, -3.8298268428406828],
            [9.728293884607655, -3.7724146456200165]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.47618643010661,
          "lat": 34.243981140939944
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13057"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01685718"
      },
      "bbox": [
        9.728293884607655, -4.1067810416710095, 10.076705306227995,
        -3.7648034675802946
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.70100371503318, -4.624177107648209],
            [9.70120055194172, -4.615054665267186],
            [9.702237993503461, -4.6115632509305895],
            [9.708642557699678, -4.601536082904579],
            [9.714804870073396, -4.59705805173853],
            [9.72417610877479, -4.585477380499716],
            [9.733895556556854, -4.579728429737873],
            [9.74061096842913, -4.565083465499221],
            [9.743513058563128, -4.560796497279229],
            [9.749522538442461, -4.5675764902300156],
            [9.755143037320657, -4.5666932010925905],
            [9.757775326120441, -4.5596097884574345],
            [9.758387148447275, -4.55427964519653],
            [9.762005429500539, -4.551119956598811],
            [9.768672262991235, -4.5476987340727115],
            [9.773212240199502, -4.542508691433674],
            [9.792922702596437, -4.535408798326154],
            [9.802039637483244, -4.528897213263698],
            [9.81223925007323, -4.5271370971015585],
            [9.81605428334657, -4.524254193117848],
            [9.818726964204764, -4.515339064931766],
            [9.81637450706066, -4.508238165838196],
            [9.816187183064804, -4.499765786014588],
            [9.818946214433074, -4.497109784530038],
            [9.825924457407023, -4.498398418142488],
            [9.833591997096049, -4.490907431322297],
            [9.831079024255265, -4.481090936566078],
            [9.839512304456045, -4.475836272978369],
            [9.84340863431572, -4.4702107091560945],
            [9.849324931894218, -4.466162871135547],
            [9.853015139853893, -4.458841832721554],
            [9.853816806828233, -4.453363501196927],
            [9.858616565505582, -4.448762949128196],
            [9.864756627761873, -4.447916310199263],
            [9.867251775597747, -4.439269026164936],
            [9.870289935933094, -4.432536654946556],
            [9.874491615763922, -4.429393512834147],
            [9.886870168180392, -4.413057039913818],
            [9.899720330846334, -4.401171482859209],
            [9.903767218857954, -4.389703379590006],
            [9.908469100471178, -4.385180925676465],
            [9.919372326413502, -4.376580533630013],
            [9.924937127081662, -4.369612943101993],
            [9.927019317930352, -4.364540259881325],
            [9.932245631971911, -4.356323710249448],
            [9.937273381290943, -4.353444973147409],
            [9.941230686550288, -4.349219530859944],
            [9.947891734476995, -4.33946804997886],
            [9.95404201107866, -4.337920801344675],
            [9.958121117515306, -4.33999181427117],
            [9.960768091398363, -4.335879962179914],
            [9.955213775083367, -4.326586126505262],
            [9.955444153564974, -4.318640414928182],
            [9.953547159884636, -4.311893554024119],
            [9.957395374385825, -4.305480665576245],
            [9.955412733484348, -4.299188342754658],
            [9.958748767166357, -4.291489370375437],
            [9.964049836293986, -4.283985801502752],
            [9.962252825031728, -4.275709212445448],
            [9.964373358750947, -4.272352716223474],
            [9.961654840554862, -4.267516102358889],
            [9.962815357135222, -4.263202653484695],
            [9.957137787830499, -4.255881262282253],
            [9.95725074761794, -4.251424121231813],
            [9.962317035877579, -4.246095056813327],
            [9.964362373973865, -4.239697612435321],
            [9.968989692121887, -4.237205975690854],
            [9.978855658702278, -4.22832886468199],
            [9.987365688322983, -4.215909844752447],
            [9.991404092511887, -4.208855121950819],
            [9.99770829692686, -4.202135088464126],
            [10.00274228021933, -4.194228531016244],
            [10.000910419505162, -4.186533013804625],
            [10.005378745037413, -4.1844264172350885],
            [10.00762223718217, -4.178150800176384],
            [10.00706935756347, -4.170624276717704],
            [10.002173850129582, -4.165709529064483],
            [9.996618970603699, -4.1652581614205015],
            [9.993419842032615, -4.162855571214529],
            [9.987800427021313, -4.153830967529009],
            [9.983595297752112, -4.1515257963094285],
            [9.982351468799045, -4.147403312195685],
            [9.983399741237466, -4.14205066723583],
            [9.982923908604562, -4.136099723156069],
            [9.9807635397769, -4.1352381208619144],
            [9.979931398951166, -4.129191956816358],
            [9.970535568356178, -4.118631007347646],
            [9.969651360689824, -4.110867597556257],
            [9.9646203899903, -4.1094177771896385],
            [9.962279454263182, -4.106119308685614],
            [9.960198930914144, -4.087769437105101],
            [9.95625651349685, -4.05229835801913],
            [9.958962739614456, -4.050648199768102],
            [9.962078373299825, -4.0526685116276315],
            [9.971700847983824, -4.048197412019242],
            [9.979671382519566, -4.03898107635197],
            [9.98666460299235, -4.038764286784345],
            [9.994453142838216, -4.033926261393359],
            [10.000595010453686, -4.031506488763463],
            [10.001347038490875, -4.02389711685099],
            [9.99937588626253, -4.0186800261816025],
            [10.000863503683524, -4.014103704017427],
            [9.998731518773027, -4.002519173573255],
            [10.00079136042356, -4.000176665303087],
            [9.996913338567175, -3.9933621786198414],
            [9.999669266240033, -3.9870030853064464],
            [10.001847348092333, -3.9781722976563625],
            [10.009245108797256, -3.9778889633544563],
            [10.01320511829024, -3.9754631190841714],
            [10.020072061484528, -3.9664969897012607],
            [10.029002033268641, -3.965134581511973],
            [10.076705306227995, -3.9596163807120557],
            [10.086250890831778, -4.035822029533686],
            [10.089806698150973, -4.0374620559032035],
            [10.09085830485307, -4.040547737489695],
            [10.094761449679035, -4.039928273884775],
            [10.101619278348316, -4.042060918101083],
            [10.106462974531295, -4.041598700896251],
            [10.11205977868463, -4.045698078497084],
            [10.117091352413718, -4.04171727444823],
            [10.124391774812393, -4.0416030306790764],
            [10.131913605420893, -4.049318026818237],
            [10.13687228508826, -4.049318798153089],
            [10.144795696784765, -4.051895627228018],
            [10.149434735612315, -4.055286309862284],
            [10.150948332851142, -4.058746293924936],
            [10.158063865790762, -4.067295624236086],
            [10.170113590559934, -4.069085875252603],
            [10.173444680332233, -4.072434953790559],
            [10.187070664938137, -4.078122197138455],
            [10.196657409664894, -4.075598531087926],
            [10.204440639647702, -4.0788122787510614],
            [10.21072834475524, -4.079543628464705],
            [10.225123132920208, -4.078079817676386],
            [10.223315308120656, -4.081354919206369],
            [10.217841170207846, -4.084713184916518],
            [10.214283674702639, -4.08829457783737],
            [10.211704224862975, -4.094068726105638],
            [10.20625952478156, -4.097888177759923],
            [10.202072012981793, -4.098778389546541],
            [10.192306959178236, -4.10316398812151],
            [10.182386810551858, -4.103582945942981],
            [10.178922407530482, -4.102385105189572],
            [10.17534930840289, -4.1053585190370105],
            [10.169608083315392, -4.107682669487963],
            [10.165581525117647, -4.116028454906522],
            [10.163184721058231, -4.130175383492979],
            [10.1640058619005, -4.136687423131849],
            [10.16064382133763, -4.142806295628599],
            [10.155820693779791, -4.146765448474053],
            [10.147005400098852, -4.149642278172985],
            [10.146617871230294, -4.142129565473736],
            [10.137310295124257, -4.1365790588789695],
            [10.124518550154283, -4.138026701300542],
            [10.1175854989533, -4.142679777109752],
            [10.108744940076926, -4.1457184291915405],
            [10.10841628898791, -4.151612298424343],
            [10.106024112907146, -4.15727874317872],
            [10.10340723851302, -4.158779591087884],
            [10.09813815284755, -4.158853851089757],
            [10.100514549917142, -4.168065947193919],
            [10.09992929186203, -4.171706754978873],
            [10.102839361570794, -4.1775474720877614],
            [10.097258750009587, -4.18206167815913],
            [10.09388991923687, -4.187476354567868],
            [10.090285368135193, -4.189163468496562],
            [10.08451036043105, -4.1911094992771405],
            [10.07612269895343, -4.188776867166251],
            [10.069222574685034, -4.189283182081268],
            [10.059747243554071, -4.185045933887042],
            [10.053922802842735, -4.183772059626048],
            [10.049876799696383, -4.1843938732619845],
            [10.039429404181233, -4.182003301360865],
            [10.032591978064842, -4.187766517393466],
            [10.03228642430584, -4.194604572042],
            [10.035298806930426, -4.218496405959332],
            [10.040312791023355, -4.262860250814268],
            [10.050362117235474, -4.346324335202936],
            [10.05259432654646, -4.361651498161499],
            [10.055097959128592, -4.388513373990705],
            [10.063760043802992, -4.460646283128716],
            [10.068736361341177, -4.5052284909596425],
            [10.044210990692951, -4.507858224388161],
            [9.988111336602508, -4.514264503710019],
            [9.989093282420159, -4.521782670125413],
            [9.985156438387074, -4.522261934143867],
            [9.984226349554437, -4.514620125181248],
            [9.980413211011745, -4.5154877240993825],
            [9.989102097042087, -4.59102668788167],
            [9.989562883427265, -4.598385280809144],
            [9.991544205919741, -4.612785046465614],
            [9.967523398807666, -4.621994640425335],
            [9.948142553648463, -4.62989545196515],
            [9.923235602770811, -4.641239646997598],
            [9.913601597528013, -4.6450033950448555],
            [9.883600279556777, -4.658510558132414],
            [9.881525988239241, -4.663706306948692],
            [9.876486312635011, -4.665685467408007],
            [9.87342191290654, -4.6760147020805425],
            [9.864005751387962, -4.67635579080382],
            [9.862988125723957, -4.6689751006995115],
            [9.822519521265974, -4.672760365549596],
            [9.78910882686479, -4.677541116774941],
            [9.756450326762051, -4.681587490606976],
            [9.67405875626034, -4.690644594592475],
            [9.675008052973064, -4.688787842508581],
            [9.681614455091458, -4.686358201672359],
            [9.687022700894818, -4.6873442345209675],
            [9.69283412150322, -4.6865452429953605],
            [9.700066854209227, -4.68052126425056],
            [9.702226724741926, -4.677490584493893],
            [9.701732610166864, -4.67405602697119],
            [9.695126994652375, -4.66724819655399],
            [9.69210102024513, -4.6611200739993235],
            [9.685178604246198, -4.655168332635531],
            [9.68494264865522, -4.65175471764357],
            [9.688199769174545, -4.64556191034786],
            [9.688479588673577, -4.639323155886312],
            [9.690118006166719, -4.635459264678699],
            [9.699076797211019, -4.6280390479761975],
            [9.70100371503318, -4.624177107648209]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.46702088172461, "lat": 33.79027732549548 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13121"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01694833"
      },
      "bbox": [
        9.67405875626034, -4.690644594592475, 10.225123132920208,
        -3.9596163807120557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.209364344121997, -4.951904931298364],
            [10.226442103464448, -4.949903738263033],
            [10.229782421918692, -4.954520922751971],
            [10.230287509611752, -4.959044115056039],
            [10.29669607103413, -4.951219990663087],
            [10.313135801754875, -4.949496985251023],
            [10.310275957901899, -4.925391374442879],
            [10.378150408909082, -4.917064464947356],
            [10.383088654688207, -4.952111246432098],
            [10.387492412561084, -4.989700024532514],
            [10.388291188890117, -4.994115013454249],
            [10.38987647980618, -5.012697810557678],
            [10.403447660375594, -5.128756873018677],
            [10.408161187106671, -5.170715657714255],
            [10.400310299716264, -5.17154546655339],
            [10.401901933986522, -5.188046060808075],
            [10.344575615878567, -5.194544770142995],
            [10.338187395328148, -5.137375051572122],
            [10.325241185995983, -5.138460465546494],
            [10.272576171628385, -5.1445991053812445],
            [10.232634156230523, -5.149407233241239],
            [10.215782255583164, -5.151144618745685],
            [10.21157682979285, -5.110833616918196],
            [10.219927624235218, -5.1097205116523075],
            [10.219083196779868, -5.101579733551476],
            [10.227553443053097, -5.100886259565175],
            [10.224647743312255, -5.074483392433115],
            [10.22292352248282, -5.061834037008937],
            [10.216443559849754, -5.007650106710372],
            [10.215520598790318, -4.9984243825190235],
            [10.209364344121997, -4.951904931298364]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.13946791699712,
          "lat": 33.076536721913335
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13171"],
        "coty_name": ["Lamar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lamar County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00326713"
      },
      "bbox": [
        10.209364344121997, -5.194544770142995, 10.408161187106671,
        -4.917064464947356
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.670715148575757, -6.223014578088844],
            [9.676726440733038, -6.2223239579725815],
            [9.677496920608913, -6.22902972141729],
            [9.693478210018377, -6.2275363753120905],
            [9.694446099853788, -6.236574167377717],
            [9.719666409523978, -6.233466613181462],
            [9.71883461221743, -6.22561871238431],
            [9.727795135949178, -6.22448319771184],
            [9.728627822268729, -6.232331023606675],
            [9.768620329881434, -6.2288821436328705],
            [9.769273739904822, -6.236863262595303],
            [9.760940894684587, -6.237670004789424],
            [9.761640638142408, -6.2454956568506885],
            [9.753648775241295, -6.24618657550342],
            [9.754398943781894, -6.255239900806884],
            [9.770464504039438, -6.253300832173267],
            [9.771109859189965, -6.261294254301893],
            [9.787509294408835, -6.259815959373302],
            [9.788135307992308, -6.2678697967647485],
            [9.804097407889106, -6.266684475365343],
            [9.805031746088662, -6.275046133958635],
            [9.81366178112391, -6.274239903151921],
            [9.821324254051415, -6.354671156886288],
            [9.828130279909209, -6.420952564486505],
            [9.787408970288315, -6.424667207934412],
            [9.730222175979842, -6.430265314409686],
            [9.73105211230224, -6.438106617161164],
            [9.691215639473791, -6.442207120132368],
            [9.69043163410804, -6.434638961822204],
            [9.665685807517212, -6.437157980155772],
            [9.662266525605178, -6.437138247478769],
            [9.633837579126029, -6.439708633491747],
            [9.63284150707247, -6.438312471883249],
            [9.639216610084635, -6.427136477854861],
            [9.637417499737758, -6.4115682823983455],
            [9.637673397483436, -6.401993544554283],
            [9.634358272810433, -6.395291906127538],
            [9.634928481732912, -6.391149192143871],
            [9.629133059197109, -6.3862887233354995],
            [9.626364456288744, -6.381479646592219],
            [9.62905306925458, -6.374540723271236],
            [9.628182322867954, -6.369212513922714],
            [9.625559333543933, -6.361975693406119],
            [9.628747223796383, -6.357893681532579],
            [9.629640063760887, -6.350153931108407],
            [9.633033042104099, -6.343436043251293],
            [9.631913773049535, -6.337433109058996],
            [9.62668381411606, -6.328984558949233],
            [9.627675887058734, -6.327263208539879],
            [9.643509659240223, -6.3251528383395765],
            [9.645963065634225, -6.3213543603015285],
            [9.64467935399715, -6.317084625924024],
            [9.645348235494337, -6.310167043813121],
            [9.642141079373099, -6.306715200771397],
            [9.650491046801665, -6.300231309652468],
            [9.652992755435898, -6.2909983411845305],
            [9.65806455783789, -6.287803701136886],
            [9.661778808239319, -6.2802404899188],
            [9.66758821708745, -6.275351940386924],
            [9.66405283715221, -6.270530744697835],
            [9.658933836830952, -6.258651278868771],
            [9.661412550887972, -6.253641742769642],
            [9.669017592559877, -6.251060011252025],
            [9.673766029532468, -6.247297457355447],
            [9.674921378736936, -6.243344064818366],
            [9.669516489897836, -6.233407354641623],
            [9.671108874109743, -6.228097483337039],
            [9.670715148575757, -6.223014578088844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.01876146159492, "lat": 31.86734833910293 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13239"],
        "coty_name": ["Quitman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Quitman County"],
        "coty_fp_code": "239",
        "coty_gnis_code": "00350547"
      },
      "bbox": [
        9.625559333543933, -6.442207120132368, 9.828130279909209,
        -6.2223239579725815
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.759182655844208, -3.3632599211491483],
            [10.756201639945035, -3.3679198224364395],
            [10.759601580462414, -3.370462880864442],
            [10.766391862905527, -3.368230958678701],
            [10.77403171717706, -3.371065907355389],
            [10.776779083508256, -3.3735108770225777],
            [10.778779306125125, -3.3782200014074752],
            [10.788701910154852, -3.377205458227854],
            [10.7916599301937, -3.3798339506726105],
            [10.792318744391022, -3.3831192099866936],
            [10.800016546743402, -3.3911893532035484],
            [10.812002218280613, -3.3961041412802455],
            [10.813071897107129, -3.398486030475246],
            [10.819758443206792, -3.401433868282494],
            [10.82688834693546, -3.4017948017134105],
            [10.833628364594505, -3.4041371845193598],
            [10.839963888134172, -3.409580237650763],
            [10.841473827918884, -3.413438002532292],
            [10.846497219033512, -3.4151880965474897],
            [10.84507405237628, -3.4217880936591674],
            [10.855842431971231, -3.427454936437076],
            [10.862538075461176, -3.428209690951709],
            [10.867948923503086, -3.425999327020685],
            [10.87411571484066, -3.4254768485865585],
            [10.88237103579899, -3.4271098416804104],
            [10.886148939446954, -3.4312704818040607],
            [10.892754486841845, -3.4271264916523307],
            [10.897243581998142, -3.4256044866578166],
            [10.906236466729823, -3.424487350310934],
            [10.911011970468241, -3.426886683468065],
            [10.91148788398262, -3.430376866856694],
            [10.90697121949728, -3.432309659409846],
            [10.9077863121598, -3.4395115883496814],
            [10.909594491565892, -3.440688287392275],
            [10.921060401613506, -3.4419765074552644],
            [10.918315999366756, -3.4496603538760895],
            [10.932297294097886, -3.4554807057319206],
            [10.93570225550323, -3.4605023484802104],
            [10.935948405250956, -3.4661694615153844],
            [10.94211936469437, -3.468262720709682],
            [10.946797322043755, -3.4650875350712544],
            [10.950512012734379, -3.4664813546549675],
            [10.950114063092844, -3.4717476136360172],
            [10.952388068780085, -3.4741386801968988],
            [10.956150590235556, -3.473422438716967],
            [10.962534987390695, -3.4781216723223785],
            [10.964605750847731, -3.4834366065923468],
            [10.967642064656092, -3.483635342327842],
            [10.969612697069419, -3.4877173912592467],
            [10.958031241182084, -3.5022841046126385],
            [10.92947215060531, -3.539103894763463],
            [10.91731430657266, -3.5553878666928544],
            [10.891740691672657, -3.5597902449624836],
            [10.859908133829952, -3.565839475517241],
            [10.803706438967053, -3.5761048811159033],
            [10.763531176006127, -3.5829895391748745],
            [10.759569253763749, -3.5838905803503485],
            [10.740979463998015, -3.5953300619010493],
            [10.736176087354725, -3.593377047141024],
            [10.731537251412178, -3.593018728529095],
            [10.727989765666267, -3.590370424655504],
            [10.68898194384085, -3.578956726112912],
            [10.70856643722177, -3.5001977748497226],
            [10.727250689758055, -3.4245395560275207],
            [10.73909936303274, -3.3780070139928258],
            [10.759182655844208, -3.3632599211491483]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.29327596141258, "lat": 34.55403639453597 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13257"],
        "coty_name": ["Stephens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stephens County"],
        "coty_fp_code": "257",
        "coty_gnis_code": "00350028"
      },
      "bbox": [
        10.68898194384085, -3.5953300619010493, 10.969612697069419,
        -3.3632599211491483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.839313619916979, 6.681355684142686],
            [-11.724861971745351, 6.661111879021865],
            [-11.610415958438962, 6.64083520124325],
            [-11.641630870979501, 6.469654177388413],
            [-11.640942394288233, 6.469534587728905],
            [-11.656591716139644, 6.383932129326695],
            [-11.551083301209871, 6.364951525943515],
            [-11.445579748004455, 6.345943780729206],
            [-11.446693811574308, 6.3394321259667015],
            [-11.475915438638152, 6.174917826713182],
            [-11.477298963523857, 6.175138653025072],
            [-11.508117510712072, 6.003347600501165],
            [-11.509488810816904, 6.003579551884645],
            [-11.523961630661871, 5.921836115526253],
            [-11.566145468068475, 5.929389768549998],
            [-11.566877127294882, 5.925313440917819],
            [-11.608078139818113, 5.932578222537345],
            [-11.623727735728878, 5.847255108338169],
            [-11.709123004817673, 5.862725542207709],
            [-11.723783470197406, 5.782020785182638],
            [-11.73098033605144, 5.783303712813222],
            [-11.745694228903512, 5.702098672181088],
            [-11.788682484013869, 5.709778022868787],
            [-11.915024060595169, 5.732725985167626],
            [-12.04137202979227, 5.755638100808408],
            [-12.026279366032462, 5.83673006759829],
            [-12.06321316587228, 5.843532993037632],
            [-12.065184128047038, 5.8441098506120035],
            [-12.1428848750559, 5.858620782306016],
            [-12.220588152273564, 5.873117979771346],
            [-12.215533123331541, 5.900144081170184],
            [-12.204308159111928, 5.95674550508575],
            [-12.195861045365586, 6.000620213848746],
            [-12.1997597664511, 6.0025233197510826],
            [-12.202196166203365, 6.000424538380652],
            [-12.210255728985864, 5.999502472719887],
            [-12.21488613863936, 6.004546472546962],
            [-12.21834080423879, 6.004471626691345],
            [-12.222648786574796, 6.00855924408061],
            [-12.215370333995285, 6.018794730114491],
            [-12.216049517237954, 6.027659456134898],
            [-12.217315172314134, 6.032220745079672],
            [-12.224227993270095, 6.038915371621051],
            [-12.225531379108896, 6.041584908566331],
            [-12.22462843483029, 6.048464701887454],
            [-12.226347581513435, 6.051503799973006],
            [-12.222906765801428, 6.062235449941277],
            [-12.224841456254628, 6.066649440267682],
            [-12.222654246324383, 6.070733742211367],
            [-12.22438417324747, 6.076416467100477],
            [-12.225006819973665, 6.089545475359187],
            [-12.227083444300636, 6.094975888965192],
            [-12.244823322153275, 6.103980876131662],
            [-12.2487736947834, 6.103205735365848],
            [-12.260031061202803, 6.1038519382092185],
            [-12.260256716712664, 6.101026842042222],
            [-12.265459396587453, 6.09271250502944],
            [-12.269854142566784, 6.094397496570153],
            [-12.275164197158489, 6.09317986680012],
            [-12.278170250969827, 6.0907362263893505],
            [-12.280891783002238, 6.091659931472419],
            [-12.284225999158272, 6.087713672954017],
            [-12.288369674312232, 6.0882323186856215],
            [-12.298887039566777, 6.0928776526313655],
            [-12.295976094315378, 6.098207319929361],
            [-12.290192419647125, 6.1019315329271695],
            [-12.286996507921078, 6.1018014758662575],
            [-12.285078968146504, 6.109035136178708],
            [-12.282516221007375, 6.113664827470127],
            [-12.278346970816663, 6.117761404001068],
            [-12.271882077371783, 6.122318689767778],
            [-12.272390173047514, 6.124560997104049],
            [-12.268880735308844, 6.129287000357296],
            [-12.265909049155672, 6.130130847769795],
            [-12.262773501774646, 6.138915464838089],
            [-12.250987074290503, 6.14424388054287],
            [-12.243373954858303, 6.141428086974301],
            [-12.235619966673521, 6.141679327012009],
            [-12.2220153197162, 6.147337544445802],
            [-12.217016449463713, 6.153049785515668],
            [-12.214113265200304, 6.154546384429049],
            [-12.208869915819074, 6.160297359590703],
            [-12.204525274802009, 6.161163594614727],
            [-12.198382281117388, 6.166078980968568],
            [-12.18752498186464, 6.1691183882602045],
            [-12.18494241593855, 6.1684202105873345],
            [-12.172282371615832, 6.174606525694524],
            [-12.168631085111876, 6.173550891938294],
            [-12.154564458085744, 6.180262472786034],
            [-12.145621322962088, 6.183079207782097],
            [-12.142107759414719, 6.18671332812802],
            [-12.136388584120482, 6.187613519447972],
            [-12.133766610377808, 6.190154340063718],
            [-12.127629905076418, 6.188996645028699],
            [-12.117466864194792, 6.19239788814077],
            [-12.114079484706796, 6.192075757407606],
            [-12.097038617067625, 6.203453787575233],
            [-12.087503209076385, 6.206864287205017],
            [-12.081622033466171, 6.206245414949598],
            [-12.079680010348765, 6.204016577684578],
            [-12.074708642696677, 6.20764858400879],
            [-12.071832689367723, 6.213174146479748],
            [-12.067220698960261, 6.217155266765861],
            [-12.060195577277824, 6.220148325263821],
            [-12.054156306940543, 6.217948680013899],
            [-12.045709988714771, 6.220420035694896],
            [-12.044943139261314, 6.224446423122985],
            [-12.04091130865149, 6.2286374974111824],
            [-12.033773712817373, 6.231176212828445],
            [-12.027324837672232, 6.237110010493366],
            [-12.023559319052007, 6.238520127415025],
            [-12.012908596339987, 6.248893975323141],
            [-12.008795120607827, 6.257894897860216],
            [-12.008368972119179, 6.265219802806459],
            [-12.002903813137785, 6.280977914385133],
            [-11.999158906593404, 6.282332434878477],
            [-11.991640979091102, 6.282076956874335],
            [-11.987785908240358, 6.284079593234541],
            [-11.980170380983143, 6.284911637877361],
            [-11.978728482229801, 6.281714804379441],
            [-11.972880777768292, 6.280085085359392],
            [-11.97127077973324, 6.27590848979296],
            [-11.962718017356117, 6.2731090898679165],
            [-11.956811758277563, 6.273495986003357],
            [-11.954678007417462, 6.2708404891265435],
            [-11.953771343101433, 6.264187223234465],
            [-11.949984846163282, 6.262405612640184],
            [-11.951857327403244, 6.25793649161971],
            [-11.947042317610983, 6.2587959438522205],
            [-11.949932588484034, 6.263233366818971],
            [-11.950195708515176, 6.2694973161820835],
            [-11.948979893891936, 6.275683313329298],
            [-11.952022956484695, 6.279552034144222],
            [-11.951108261755433, 6.284006888643178],
            [-11.954252186290315, 6.287000103657634],
            [-11.958089352471612, 6.28714218618602],
            [-11.959909060556908, 6.290852360993351],
            [-11.959810220773223, 6.298414413256903],
            [-11.962325797085656, 6.300475523097722],
            [-11.960681324714049, 6.304571485932267],
            [-11.96401284111682, 6.30780471613622],
            [-11.963965321920552, 6.3128925476099536],
            [-11.967891697991437, 6.322891712602597],
            [-11.970678730044913, 6.327298667944526],
            [-11.977544667457645, 6.329206676487217],
            [-11.981790618878989, 6.335290538789324],
            [-11.986812485842556, 6.338144516796564],
            [-11.99882533753703, 6.346399073429908],
            [-12.00021047494138, 6.348690528491306],
            [-12.000445911105496, 6.357080826790042],
            [-11.995664876597699, 6.369182092288802],
            [-11.985477826629939, 6.385196246612585],
            [-11.984227081513358, 6.388996674998455],
            [-11.98247493905999, 6.406532408142197],
            [-11.979489024855512, 6.410103699745028],
            [-11.97961790473355, 6.419727941929077],
            [-11.976840803058126, 6.425780430412048],
            [-11.97713450418755, 6.43457421875209],
            [-11.974303092887299, 6.443296377342927],
            [-11.975001529624677, 6.446575959678954],
            [-11.973145586917552, 6.452856496120605],
            [-11.97786222229836, 6.461178305032973],
            [-11.977708005947727, 6.465708315751085],
            [-11.973924251843714, 6.4700035520021],
            [-11.975092561855051, 6.475596984735117],
            [-11.972923977474695, 6.491337725094037],
            [-11.973053895815502, 6.500546425333058],
            [-11.967500007530335, 6.528920111623276],
            [-11.938284648250319, 6.523341655289662],
            [-11.906645266123355, 6.693916881075329],
            [-11.839313619916979, 6.681355684142686]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.17205181942602,
          "lat": 43.72293650637219
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16023"],
        "coty_name": ["Butte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butte County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00401703"
      },
      "bbox": [
        -12.298887039566777, 5.702098672181088, -11.445579748004455,
        6.693916881075329
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.769825929783982, 7.3338268848727575],
            [-13.768904210650641, 7.341353988743151],
            [-13.77181598227857, 7.348874831337684],
            [-13.769242630767472, 7.350096866343286],
            [-13.767793857986058, 7.356470435708268],
            [-13.767803568772432, 7.365741572965887],
            [-13.766988740395377, 7.374737581328861],
            [-13.769488312209791, 7.383456008666974],
            [-13.768894007493142, 7.394122481921118],
            [-13.770127479035267, 7.397018818045687],
            [-13.766684798087162, 7.40429182452765],
            [-13.766315438745, 7.414223462845643],
            [-13.768403553686111, 7.416405466140293],
            [-13.770387541581433, 7.422141328537827],
            [-13.766979664997383, 7.425365951540235],
            [-13.764822101247786, 7.431800270401957],
            [-13.761611025480883, 7.436940683572326],
            [-13.760732345472777, 7.443991609862289],
            [-13.755839508220927, 7.4483545540756015],
            [-13.752451853170616, 7.457715422698165],
            [-13.752287859496933, 7.470488880993929],
            [-13.7500026747504, 7.475399289087796],
            [-13.753059060488475, 7.47972394916047],
            [-13.751879516405, 7.485537163357707],
            [-13.745295710013528, 7.489329515610035],
            [-13.743494118251013, 7.494359064706491],
            [-13.739792497510923, 7.500368996264375],
            [-13.738107573775194, 7.505898850253541],
            [-13.735248005276611, 7.510912468048718],
            [-13.734215377565379, 7.5195975933126675],
            [-13.730329080474661, 7.523978071361413],
            [-13.730045631523355, 7.528078959053757],
            [-13.727050413671092, 7.532124180320953],
            [-13.728053022881934, 7.538751254661707],
            [-13.732796892899163, 7.54178031777837],
            [-13.74023232528717, 7.558507429478314],
            [-13.734818112478345, 7.562281546277339],
            [-13.735147865809557, 7.5677026559641725],
            [-13.731402562208238, 7.576012212904339],
            [-13.736677935232239, 7.580486317273242],
            [-13.740459691388976, 7.5864266674737255],
            [-13.74038253854227, 7.591718750117141],
            [-13.743149568502798, 7.59492462678839],
            [-13.744601960895787, 7.601160446664547],
            [-13.747402619629632, 7.601515798134074],
            [-13.747876456213262, 7.615737779269583],
            [-13.742849293242964, 7.620985999985575],
            [-13.738633163803044, 7.629072277309691],
            [-13.738193360073044, 7.636149810896178],
            [-13.736065113495597, 7.6390557851711804],
            [-13.729824595791879, 7.655696433972385],
            [-13.728150186994093, 7.666074870684354],
            [-13.725332844876075, 7.672938174194255],
            [-13.725500494207942, 7.675344408375033],
            [-13.721707530362659, 7.683391103383082],
            [-13.72043360303717, 7.694519866035306],
            [-13.715823076511539, 7.694444082965947],
            [-13.713043408337933, 7.700078752629305],
            [-13.713910781124941, 7.704889407419829],
            [-13.710602987098646, 7.708219689815146],
            [-13.708150083938316, 7.715776846060285],
            [-13.702599341067488, 7.715440775927446],
            [-13.700498914260955, 7.713370664577622],
            [-13.695630818992303, 7.7270386362208265],
            [-13.688220188711332, 7.72581299417153],
            [-13.685835773679058, 7.730513238780265],
            [-13.682411058901701, 7.742783781532729],
            [-13.678018402104517, 7.750391842882595],
            [-13.678587099967684, 7.757641057603877],
            [-13.674772104281617, 7.759259255259892],
            [-13.675331809292157, 7.763960518136286],
            [-13.66930623626876, 7.763809129783613],
            [-13.66678811781584, 7.760630167462436],
            [-13.660993923631695, 7.759336286195008],
            [-13.658192981350298, 7.760116794343953],
            [-13.649781439292637, 7.769499572260287],
            [-13.650264603010116, 7.771533832338151],
            [-13.643407665197675, 7.777299707016906],
            [-13.642236202531327, 7.783867978718783],
            [-13.638779658165156, 7.79054427188651],
            [-13.641669358069967, 7.79530376293226],
            [-13.6417402442344, 7.799929915901289],
            [-13.646652220756113, 7.8033231088253965],
            [-13.645129326497273, 7.809991265025202],
            [-13.648764894786893, 7.817858593893513],
            [-13.64672361638095, 7.8248825585482],
            [-13.640984071497034, 7.830540111450612],
            [-13.64011671795502, 7.836453114907681],
            [-13.632462598793385, 7.8349693514135845],
            [-13.62845516510718, 7.83655433476036],
            [-13.62924117529237, 7.839495368867396],
            [-13.62746770343619, 7.843751223605684],
            [-13.624598044535436, 7.841466613638629],
            [-13.621557545672673, 7.842490605796135],
            [-13.618667913436079, 7.8474788666936295],
            [-13.61471238288674, 7.862718102880643],
            [-13.609783589059168, 7.865940434964461],
            [-13.603903399787319, 7.872048279465366],
            [-13.608319599428212, 7.878573852581612],
            [-13.617906250156043, 7.886018244902747],
            [-13.62893017397641, 7.889229295791544],
            [-13.631914403751713, 7.893236527961902],
            [-13.635982704277586, 7.893791939969447],
            [-13.63602231837839, 7.897612178258006],
            [-13.63350794666578, 7.901914559802842],
            [-13.635178717199375, 7.904179464075703],
            [-13.631057324943686, 7.91440010511845],
            [-13.632751559134256, 7.922849398525152],
            [-13.632406953712058, 7.928116587679596],
            [-13.629721865337947, 7.931862580107397],
            [-13.626592662965452, 7.933166243573674],
            [-13.623008948455386, 7.937423580779746],
            [-13.621375421979025, 7.9427513686676114],
            [-13.621104825702036, 7.950228037241102],
            [-13.617269659874948, 7.9539143424510295],
            [-13.614269540639903, 7.954592612610763],
            [-13.611049762379869, 7.958511475856962],
            [-13.609958145537187, 7.964735797084848],
            [-13.606874665831805, 7.9673350424223495],
            [-13.601576603670486, 7.968983510494534],
            [-13.5962312336007, 7.966948057044527],
            [-13.594371410768238, 7.962937086001307],
            [-13.588006722378076, 7.9623807915083695],
            [-13.581619700225069, 7.959686248157709],
            [-13.579910628601002, 7.957446565227432],
            [-13.575521120278212, 7.9583939060522155],
            [-13.573352007597524, 7.962458916370805],
            [-13.565149854278888, 7.966907798659223],
            [-13.55574057232487, 7.965052505349761],
            [-13.551751839418705, 7.969344091653092],
            [-13.55166319387455, 7.97320258776367],
            [-13.548065972281274, 7.977461516159699],
            [-13.541584695932508, 7.979101286571966],
            [-13.536955613096277, 7.975102058651728],
            [-13.534429943001058, 7.977349410142145],
            [-13.525498298265529, 7.9809406578700415],
            [-13.518188980159763, 7.989216687521858],
            [-13.50647714650019, 7.995449103835727],
            [-13.504296909540997, 8.002216600219835],
            [-13.49223507532456, 8.006573545797975],
            [-13.489122441448025, 7.989566190965885],
            [-13.491263142223474, 7.987290218962395],
            [-13.49627143475433, 7.986377950057826],
            [-13.498220840406454, 7.983143511488964],
            [-13.446373163285282, 7.972139439447035],
            [-13.446169767471549, 7.972949813150261],
            [-13.32938727015839, 7.94868779988827],
            [-13.212612569677642, 7.924387452277799],
            [-13.13776784697709, 7.90944152903023],
            [-13.062926123736696, 7.894479915268418],
            [-12.98808742279272, 7.879502614603347],
            [-12.91325176697075, 7.864509630737529],
            [-12.838419179083559, 7.849500967464561],
            [-12.763589681929053, 7.834476628668703],
            [-12.688763298288153, 7.819436618324568],
            [-12.613940050922697, 7.8043809404966495],
            [-12.618744310840098, 7.797765789943466],
            [-12.626160159586345, 7.797045660974623],
            [-12.63102363384625, 7.798151385665781],
            [-12.63757791478895, 7.789744135750926],
            [-12.636559944893134, 7.7866862476389915],
            [-12.640946586221414, 7.776248151735102],
            [-12.641618747189034, 7.772308710822399],
            [-12.64938531787884, 7.76484435541581],
            [-12.648082096659543, 7.758446648085115],
            [-12.649411972529208, 7.743438673576925],
            [-12.647834127353292, 7.734062029404338],
            [-12.651483973275022, 7.730145223878484],
            [-12.653671492200246, 7.723397190025713],
            [-12.656465965359757, 7.722987041083945],
            [-12.65869345286713, 7.712238778318725],
            [-12.661129402594652, 7.709852880712426],
            [-12.656845954692301, 7.704425794103001],
            [-12.653598205714527, 7.702737424348601],
            [-12.654626890177592, 7.6984755083867356],
            [-12.659996924159154, 7.694217347886845],
            [-12.662552219123075, 7.6873243255426935],
            [-12.661509592605618, 7.681951150538259],
            [-12.663771097039177, 7.676963405888923],
            [-12.661561703257844, 7.670954480487198],
            [-12.663423335431993, 7.665390513815858],
            [-12.666540616739765, 7.661013798474378],
            [-12.664097893101337, 7.6570346259494295],
            [-12.667686127717472, 7.652625382986841],
            [-12.666936720341296, 7.648523650698748],
            [-12.670694346406682, 7.642414311141615],
            [-12.670662149481895, 7.634214096180933],
            [-12.673942859792911, 7.630339603991063],
            [-12.67076132955268, 7.62765475345602],
            [-12.671643256205387, 7.6216660077840706],
            [-12.677004470103677, 7.619891008260192],
            [-12.677603289343276, 7.614308492959243],
            [-12.680549235584527, 7.608242987260844],
            [-12.681115111138649, 7.604003819443693],
            [-12.683424202453061, 7.601512458181519],
            [-12.684471220266525, 7.5954502818174845],
            [-12.686668382223871, 7.591270581677391],
            [-12.684170534538278, 7.589558441707222],
            [-12.684611216049118, 7.585006625336398],
            [-12.690135730677513, 7.573632043377076],
            [-12.690779620429716, 7.568450922671601],
            [-12.685452940229279, 7.565897367655643],
            [-12.68679063778732, 7.562432654014837],
            [-12.685646511153926, 7.552679947643159],
            [-12.689038428669013, 7.548757891367151],
            [-12.694855592676298, 7.547560507840995],
            [-12.696236124812119, 7.545316909001247],
            [-12.692480612520036, 7.539834183107822],
            [-12.696272431790964, 7.534986787595372],
            [-12.696563301725176, 7.5259996103608815],
            [-12.694751086608694, 7.5198471682976225],
            [-12.698563807754478, 7.517667426066331],
            [-12.69972713010636, 7.514405327680225],
            [-12.694132084880541, 7.510609533076887],
            [-12.700958755504212, 7.507334074939246],
            [-12.702149713514325, 7.501836292402373],
            [-12.70437872099151, 7.500049753790678],
            [-12.70845115437279, 7.501782822878211],
            [-12.7161558773949, 7.502510309865978],
            [-12.717074485803268, 7.49803289484057],
            [-12.721862390453397, 7.497825425663179],
            [-12.724239525693463, 7.500773909283493],
            [-12.729453618973954, 7.498637150793885],
            [-12.731504553470478, 7.491656817649747],
            [-12.727138452570486, 7.484175194709983],
            [-12.728772978128257, 7.479621572251971],
            [-12.734971828423756, 7.478571248597717],
            [-12.73336696880334, 7.473382985590775],
            [-12.734607525607021, 7.46849776931093],
            [-12.745975360037377, 7.4693154784617635],
            [-12.748447439190777, 7.464267498152871],
            [-12.754679181607383, 7.465034200620612],
            [-12.757096753566145, 7.456418697335167],
            [-12.761705913978608, 7.455964972076504],
            [-12.767857490481106, 7.450156092765802],
            [-12.769160860203776, 7.445414545938754],
            [-12.77225453998938, 7.4422102269778865],
            [-12.784749116676753, 7.43816827211741],
            [-12.788258077851827, 7.439665230544294],
            [-12.796182633467364, 7.430865819741934],
            [-12.796736028034475, 7.428062878716286],
            [-12.802818070663603, 7.4271488058580974],
            [-12.8056897232539, 7.422214730622847],
            [-12.809100486321654, 7.426264026318334],
            [-12.81606841722308, 7.421706242537178],
            [-12.8186614372036, 7.42240797680059],
            [-12.825337926835683, 7.419121262364064],
            [-12.829017218233215, 7.416096939341005],
            [-12.839115428472029, 7.411082319323327],
            [-12.840713831811112, 7.405955044280275],
            [-12.84855410582402, 7.40507836985556],
            [-12.852591203004119, 7.406757266302778],
            [-12.85663043464076, 7.400335224291761],
            [-12.855503518650215, 7.3965469703516025],
            [-12.867023588438782, 7.385628633106051],
            [-12.87830316832711, 7.384816583682987],
            [-12.879971709358534, 7.379252764496462],
            [-12.889368124594503, 7.377052171053255],
            [-12.894637717203938, 7.381253616912591],
            [-12.898022098227603, 7.3820865481616815],
            [-12.89965769067672, 7.386725445193066],
            [-12.90385884210008, 7.389109511269114],
            [-12.910734636388018, 7.388756252646435],
            [-12.915523916040089, 7.390143995412744],
            [-12.919263545480693, 7.389293439494823],
            [-12.918294485554236, 7.38499252341623],
            [-12.922837773708219, 7.383092936729457],
            [-12.92644429349222, 7.377621743388839],
            [-12.929277576311751, 7.378250158322605],
            [-12.930699812405257, 7.3960211563020515],
            [-12.926284225378305, 7.4004001995824416],
            [-12.92935413328262, 7.408499711479437],
            [-12.936130408914327, 7.402524755065898],
            [-12.939885820100066, 7.401385606352754],
            [-12.938780493699202, 7.409916899511698],
            [-12.940817030775374, 7.4174683824237855],
            [-12.946104696034283, 7.42158283550466],
            [-12.959750762882077, 7.430039991907996],
            [-12.960093223897772, 7.434368176727714],
            [-12.963098149918101, 7.436528463086529],
            [-12.962852264270804, 7.440677088444661],
            [-12.969705775082394, 7.444384716687632],
            [-12.974602313532154, 7.44057675018566],
            [-12.981852513920892, 7.438407283829958],
            [-12.986901555211098, 7.434936837004805],
            [-12.99482093558309, 7.433442073149621],
            [-12.996766766966878, 7.431095806062221],
            [-13.0102654456876, 7.423876231352267],
            [-13.014453062612152, 7.417374957364472],
            [-13.023920261495165, 7.411883023076553],
            [-13.02270043544532, 7.404302579831872],
            [-13.017439427491526, 7.400548720037443],
            [-13.018557615168175, 7.39510988580707],
            [-13.027497740538731, 7.384826602260837],
            [-13.034704495680701, 7.361966062837202],
            [-13.038789852798667, 7.355702159511626],
            [-13.041630230942692, 7.354037943103554],
            [-13.042588201584035, 7.350387347522956],
            [-13.046901542310945, 7.348473985730833],
            [-13.046630604687273, 7.34406993540969],
            [-13.0491275296956, 7.3375831140031265],
            [-13.051331413457424, 7.335302903100996],
            [-13.06022175095077, 7.335347040594869],
            [-13.062318628144364, 7.329362320439356],
            [-13.064592166227664, 7.327267894021501],
            [-13.069284078786826, 7.326909414180246],
            [-13.075011846514974, 7.3229738422907396],
            [-13.077577866816373, 7.316850786029259],
            [-13.080567109910675, 7.318845177127167],
            [-13.083529390567978, 7.323397415774855],
            [-13.087047257597757, 7.320200682246706],
            [-13.092292604407135, 7.32645958554141],
            [-13.096094082227689, 7.32235288550416],
            [-13.094081677417503, 7.317703875983349],
            [-13.097294490338314, 7.314524515747237],
            [-13.10118814246216, 7.3164502032313745],
            [-13.102937397410543, 7.319636443663016],
            [-13.109116933856406, 7.317955458437768],
            [-13.113946444873458, 7.318118954883687],
            [-13.12022018436564, 7.316456001407621],
            [-13.123814741640015, 7.308029113409886],
            [-13.128527225314416, 7.310018811708977],
            [-13.131881555082279, 7.314141323596456],
            [-13.136888058750932, 7.3160221632306195],
            [-13.14055173324755, 7.307717316429526],
            [-13.145157414286045, 7.305572695717942],
            [-13.150587640295567, 7.299540570901923],
            [-13.151804682064212, 7.295049781069761],
            [-13.156023689235091, 7.293222417107733],
            [-13.160385049542862, 7.288464247894747],
            [-13.16104003081101, 7.2680288088017555],
            [-13.159169225882065, 7.257322949162199],
            [-13.159673774185643, 7.25296394765542],
            [-13.157617263285813, 7.250462783724807],
            [-13.160587120852089, 7.239814629758488],
            [-13.15395406632299, 7.233236957536347],
            [-13.155750547585109, 7.230536247022388],
            [-13.15566125432436, 7.225545882008767],
            [-13.144049732059532, 7.222704387110362],
            [-13.138302209848229, 7.220483038249157],
            [-13.135950253820049, 7.223096401665813],
            [-13.132151107125637, 7.221919353338558],
            [-13.131984935544835, 7.214091035447412],
            [-13.127736726720974, 7.21214768239774],
            [-13.12837390149165, 7.206746954610263],
            [-13.13013412266866, 7.204241070449616],
            [-13.129613952455067, 7.198367916282045],
            [-13.124862764634242, 7.190989730293524],
            [-13.126201660286238, 7.185149513220043],
            [-13.126649880060482, 7.175819567375619],
            [-13.133853271448666, 7.171829616358984],
            [-13.13344003575929, 7.168132354802775],
            [-13.130209204913852, 7.167226951978778],
            [-13.127117470455907, 7.163760510599551],
            [-13.127959293941407, 7.161448887888378],
            [-13.13412541517201, 7.160217789989841],
            [-13.133395305365394, 7.153843874068313],
            [-13.13600711148576, 7.148741095729413],
            [-13.135002393594618, 7.142040823969204],
            [-13.13663967985785, 7.137812908994489],
            [-13.138353327424456, 7.125496425476429],
            [-13.14235113069013, 7.121816746348855],
            [-13.142190640142433, 7.117975118575631],
            [-13.145013802494685, 7.114938921027416],
            [-13.149085188218079, 7.113840074473714],
            [-13.151655799943203, 7.1060920674315335],
            [-13.157263733641631, 7.102129970510804],
            [-13.15828845694684, 7.093331113403728],
            [-13.16969343384437, 7.084171714911821],
            [-13.171427462678663, 7.0781653051639175],
            [-13.183140842470923, 7.068889598052459],
            [-13.188132958636583, 7.06757044139943],
            [-13.19065984684677, 7.069822777557482],
            [-13.193781672586969, 7.057509817061907],
            [-13.200571605525166, 7.056167123980772],
            [-13.201672138339752, 7.052991810485179],
            [-13.207228367723475, 7.057265120864277],
            [-13.207828746802795, 7.059410041655612],
            [-13.217714500195044, 7.065359021206832],
            [-13.219481865822832, 7.068416539588686],
            [-13.224524667081255, 7.07011305622556],
            [-13.231428240493306, 7.066651554621456],
            [-13.235131633776307, 7.067514668187413],
            [-13.237823718880142, 7.070383181245123],
            [-13.242694806723385, 7.068345735621257],
            [-13.244714411765862, 7.065883588465869],
            [-13.241097508329261, 7.057887051983632],
            [-13.24601387618231, 7.055604703187464],
            [-13.24690523528471, 7.051394769213534],
            [-13.243571841810134, 7.048306975604222],
            [-13.244874361857716, 7.042620007344586],
            [-13.245050050174871, 7.036130786190852],
            [-13.248615557691682, 7.0347106841918325],
            [-13.250044604638182, 7.026721619085675],
            [-13.255691399461913, 7.025585947684249],
            [-13.266893820881553, 7.021808914569448],
            [-13.270115403067965, 7.0177582810208845],
            [-13.275774349343454, 7.017362433130402],
            [-13.278716899915478, 7.01301068658526],
            [-13.27790249407103, 7.010945460583838],
            [-13.27953586626494, 7.005227829857355],
            [-13.282737213639038, 6.9988743189736535],
            [-13.285608524067875, 6.996598988564681],
            [-13.291287985750186, 6.996499937228064],
            [-13.292488212265281, 6.990462163728179],
            [-13.2954610101703, 6.990513859336503],
            [-13.296266744723885, 6.995182621170833],
            [-13.301569421601007, 6.999842566993319],
            [-13.30839924091817, 7.000695293463569],
            [-13.311124692143364, 6.996310498200392],
            [-13.316495637548645, 6.995043701846706],
            [-13.322388296884741, 6.991889666279095],
            [-13.324284734776402, 6.985353384328808],
            [-13.32765794194832, 6.986040007445272],
            [-13.334966003851974, 6.982252789515854],
            [-13.345621426071423, 6.9827675924029755],
            [-13.346254962585391, 6.979678556077339],
            [-13.35450200000796, 6.984514389000346],
            [-13.36306982063688, 6.977764685461096],
            [-13.36818880737938, 6.9804736243528565],
            [-13.369090016365776, 6.98963203208623],
            [-13.375818813447884, 6.990128703964541],
            [-13.380556930775544, 6.983938066752168],
            [-13.493918165682361, 7.007774899652001],
            [-13.587857379484552, 7.027472180399712],
            [-13.68180120050165, 7.047146933921939],
            [-13.741547134934567, 7.059777240597946],
            [-13.74143662203275, 7.060719922018935],
            [-13.787570635658376, 7.070454816017326],
            [-13.789949795989783, 7.060590172763148],
            [-13.792211577594918, 7.058403345209481],
            [-13.795769817991403, 7.044827192822091],
            [-13.802946758905868, 7.033461682508719],
            [-13.80194717462934, 7.031508120218521],
            [-13.804950866803482, 7.027789758892948],
            [-13.808404572617032, 7.019468205053469],
            [-13.80756676588539, 7.015374531546269],
            [-13.811790626319915, 7.013193391596102],
            [-13.813715967149577, 7.0081040910113614],
            [-13.812585275726326, 7.00291691051291],
            [-13.814408784716578, 6.992821735945896],
            [-13.811812031236379, 6.9869427700083495],
            [-13.812810473186712, 6.9856348920579565],
            [-13.843045991465088, 6.991915062896308],
            [-13.842295470101147, 6.995506494476842],
            [-13.88293731365753, 7.0042412763690685],
            [-13.864286897938815, 7.088309703972164],
            [-13.84563887068319, 7.172419732050215],
            [-13.80334270792205, 7.163520506595302],
            [-13.766644014213872, 7.333049795442143],
            [-13.769825929783982, 7.3338268848727575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.56632221571712,
          "lat": 44.76662171921354
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16085"],
        "coty_name": ["Valley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Valley County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00399756"
      },
      "bbox": [
        -13.88293731365753, 6.977764685461096, -12.613940050922697,
        8.006573545797975
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.0120812130820624, 1.5643105951004304],
            [5.014083491705384, 1.5674835533038727],
            [5.0188967172384675, 1.5678195886050073],
            [5.016673455557633, 1.5774382474675228],
            [5.020953018419103, 1.5844295337830114],
            [5.023458690292296, 1.5813409883241336],
            [5.027179741303242, 1.5849791032720855],
            [5.028352129713929, 1.5896380901965832],
            [5.025864226695938, 1.5922676914154108],
            [5.029404446250118, 1.5949888605319493],
            [5.0285670171677275, 1.5988844725838793],
            [5.034107637329067, 1.600211839923587],
            [5.034322267784706, 1.597387441525187],
            [5.03917257465266, 1.594310112472311],
            [5.045367032902755, 1.5931390194213806],
            [5.0482237734516815, 1.5884059932943453],
            [5.054404297694282, 1.590351826366289],
            [5.050769896957581, 1.5949046135890261],
            [5.05869102069647, 1.5962503752685795],
            [5.0603726603943935, 1.59864616256678],
            [5.066381061817808, 1.597657022507055],
            [5.070107702480972, 1.5928885256052712],
            [5.076832592935339, 1.59138212102369],
            [5.077907688517551, 1.5950230921262212],
            [5.082740766690581, 1.5890031123603885],
            [5.08882991265886, 1.5910734419331967],
            [5.093592676236991, 1.5887792967653536],
            [5.094554108708468, 1.5925699294935525],
            [5.099426305837789, 1.5951359127715128],
            [5.101038273079816, 1.5979103156632408],
            [5.104469842697921, 1.59828842772429],
            [5.1070192437880655, 1.59446050555468],
            [5.106669405727504, 1.5913914367999702],
            [5.109719991781062, 1.5897286731293956],
            [5.118853425816131, 1.5924552609883433],
            [5.125785743779483, 1.589240334959544],
            [5.127410834513839, 1.5936486887942038],
            [5.132929326595056, 1.5877277867812258],
            [5.137781291263369, 1.5893338503309367],
            [5.13982808529098, 1.5866457680761767],
            [5.148761205685342, 1.5864550406702038],
            [5.153425319778956, 1.589540900352033],
            [5.160627821610216, 1.590555908740014],
            [5.162922848107997, 1.5890673206484123],
            [5.167285315874674, 1.595671302637637],
            [5.171946281519004, 1.593004550826231],
            [5.177378492498462, 1.5956834197459369],
            [5.182211201356423, 1.5958195090302931],
            [5.1968771305671275, 1.594374727944016],
            [5.199093615215882, 1.5971883488335459],
            [5.20251462355686, 1.5977170327833974],
            [5.207597713916606, 1.6060198912466725],
            [5.2108852089715505, 1.6055636978703889],
            [5.212309709200709, 1.6113620627400598],
            [5.221173176074895, 1.6128508945439413],
            [5.226252860768672, 1.6166343559682264],
            [5.227293937093777, 1.6124991593978337],
            [5.229883320678047, 1.6104802618799174],
            [5.235268650864767, 1.6124145380543387],
            [5.242809403906005, 1.617563574425817],
            [5.24243678281416, 1.6201054114102404],
            [5.247265633307297, 1.6266405144506584],
            [5.254268320617108, 1.625768601432124],
            [5.2552704396958125, 1.632422286364164],
            [5.2728019735263105, 1.6264545735220215],
            [5.278861516112611, 1.6281431824916004],
            [5.286077088482545, 1.6230144703920126],
            [5.293321459560919, 1.6129458759957036],
            [5.293705871159724, 1.6102896981727939],
            [5.29875122640755, 1.6089679391152192],
            [5.308707713721225, 1.5973016502087747],
            [5.3111801188919205, 1.5670437386001672],
            [5.3278058173101766, 1.5682987248006826],
            [5.3310747965514755, 1.5244050002912068],
            [5.330553592434056, 1.524354581764363],
            [5.336363229411244, 1.4513005458839807],
            [5.245522590947054, 1.4443859019953562],
            [5.248459596427628, 1.4075163658013965],
            [5.244925289598231, 1.4072494626559022],
            [5.246701879959767, 1.385292594116902],
            [5.202204237463712, 1.3822683104765008],
            [5.195676983778959, 1.3820044189234915],
            [5.196617670644508, 1.3673901629020966],
            [5.164583805138448, 1.3652887617216363],
            [5.132675890029298, 1.3625010626217713],
            [5.110659485727261, 1.3609718811622185],
            [5.025712404411213, 1.3559468208083088],
            [5.02178841105431, 1.4143521417909175],
            [5.016534022662431, 1.4945405757013728],
            [5.01468097349908, 1.52703822208938],
            [5.0120812130820624, 1.5643105951004304]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.80207371857425,
          "lat": 40.027427766250995
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17129"],
        "coty_name": ["Menard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Menard County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00424266"
      },
      "bbox": [
        5.0120812130820624, 1.3559468208083088, 5.336363229411244,
        1.632422286364164
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.104157334278486, 3.6794989530353734],
            [5.147129431970709, 3.6837961564075523],
            [5.190034562472748, 3.6870117089178147],
            [5.2332975388854654, 3.689745379410921],
            [5.275787772705511, 3.692971408836696],
            [5.318526507319295, 3.696880222714553],
            [5.333237385302204, 3.697912499841241],
            [5.4039136198160795, 3.7040310958261013],
            [5.482160334206561, 3.7107789105983096],
            [5.484371717614358, 3.685369709488504],
            [5.486194475835429, 3.6568460840457484],
            [5.517532866120095, 3.659078347898823],
            [5.572383671455054, 3.663640798635937],
            [5.657201587419065, 3.671253656897992],
            [5.664307511011524, 3.583853658724858],
            [5.661948996542285, 3.5836603565888043],
            [5.672311208908075, 3.449258611727208],
            [5.675537200492359, 3.4099736230194417],
            [5.622514969486673, 3.405304489754441],
            [5.60302986605926, 3.4034180784969634],
            [5.5638249658093075, 3.400231316713912],
            [5.561596383776188, 3.399860706138861],
            [5.521211340168041, 3.3967150137205873],
            [5.443915855335909, 3.3898853498684787],
            [5.423643261326137, 3.387855133461135],
            [5.3667305810017, 3.3839564878678394],
            [5.365841333226457, 3.398608712988909],
            [5.33762392293901, 3.396862162650349],
            [5.3283557173119185, 3.3866801120843575],
            [5.329463685331901, 3.380900739250793],
            [5.326892708456571, 3.378783278508149],
            [5.320008797566371, 3.383379703421583],
            [5.313833797448251, 3.38629103165897],
            [5.314937657155094, 3.389301373274454],
            [5.320473373478122, 3.3927452487347134],
            [5.319919158458808, 3.398390500646698],
            [5.315511917185608, 3.4003494157657825],
            [5.310805399460856, 3.3995031157158806],
            [5.301881089563713, 3.401427174693936],
            [5.295757019308895, 3.401085875699062],
            [5.288405064380724, 3.4023226509580207],
            [5.2833553179381765, 3.401654160639492],
            [5.280015506260092, 3.399394045046489],
            [5.277689151813082, 3.3923920504993696],
            [5.2521820314824215, 3.3903085951891967],
            [5.237358570488834, 3.3897513935669386],
            [5.203150725210426, 3.386814475879518],
            [5.167652368957967, 3.3840396330179456],
            [5.166046299663463, 3.412579016341154],
            [5.124417475197882, 3.4100999328997923],
            [5.12317449613887, 3.4166548370519356],
            [5.120019963975093, 3.4736750749396212],
            [5.118149719420581, 3.5043937892181596],
            [5.118507664542044, 3.505688950600935],
            [5.116094259954281, 3.533985775532068],
            [5.113263751420368, 3.570528809358875],
            [5.111816418489558, 3.5922849826027683],
            [5.104157334278486, 3.6794989530353734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.32070864653495, "lat": 42.04257407648187 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17141"],
        "coty_name": ["Ogle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ogle County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01784894"
      },
      "bbox": [
        5.104157334278486, 3.378783278508149, 5.675537200492359,
        3.7107789105983096
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.953667917435468, 2.611491183904451],
            [5.015251647427512, 2.615413877861317],
            [5.040428282918574, 2.617137189682345],
            [5.035175073542472, 2.7025107605521725],
            [5.042748072442166, 2.7030493552939547],
            [5.129311380497362, 2.7081261810359045],
            [5.205741071247363, 2.713151682332539],
            [5.21162160641876, 2.627436348468737],
            [5.217044971598141, 2.5470252236526347],
            [5.223268981996456, 2.4517129925297985],
            [5.136671021815952, 2.4462008351695643],
            [5.083351850126698, 2.4436280574638145],
            [5.050845280134141, 2.4417146269053775],
            [4.964133969011873, 2.435628796565458],
            [4.958896029652629, 2.523540849583684],
            [4.953667917435468, 2.611491183904451]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.7974743586182, "lat": 41.09336670790365 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17175"],
        "coty_name": ["Stark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stark County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00424288"
      },
      "bbox": [
        4.953667917435468, 2.435628796565458, 5.223268981996456,
        2.713151682332539
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.390392947662399, -0.2124839174912462],
            [6.4325879068512695, -0.20852412177031246],
            [6.474962013006009, -0.20394681241798046],
            [6.533670008204968, -0.19951338051681244],
            [6.56043491418628, -0.1977588421049191],
            [6.655903073527245, -0.19029605829584054],
            [6.6556007352965825, -0.1860318880740523],
            [6.6843301011183005, -0.1838793008927332],
            [6.686813249107734, -0.18641989034711315],
            [6.691635555076729, -0.19434145864746347],
            [6.694476228395406, -0.20235646694625609],
            [6.694262478489493, -0.2075814599667439],
            [6.692188068904631, -0.21288323299929368],
            [6.691437334879292, -0.21480172191078928],
            [6.691746121398552, -0.22544680955644933],
            [6.693784313025036, -0.23427966839785075],
            [6.701066472654271, -0.245087926228232],
            [6.706198992176819, -0.2507825791421871],
            [6.715345259259468, -0.2578513825695827],
            [6.730423121172204, -0.26583812493379283],
            [6.733866615952869, -0.26914006160032655],
            [6.736548188208887, -0.27601020461469505],
            [6.735871340523516, -0.2817593408250759],
            [6.739210176765021, -0.28389439859046967],
            [6.742738714443825, -0.2810684911887658],
            [6.743920480657363, -0.2777399727096479],
            [6.742466415527379, -0.2733559214204617],
            [6.744205431325705, -0.26629801022505223],
            [6.749814883040471, -0.26578852314203094],
            [6.754303362288517, -0.2722142167240364],
            [6.75409638545587, -0.2771614219726153],
            [6.751521519250193, -0.2813862784185992],
            [6.741959289555025, -0.2891888259242669],
            [6.744506378708781, -0.29367644110525193],
            [6.743949274982708, -0.29747875677313673],
            [6.737613727524956, -0.3011778882441078],
            [6.730686684694228, -0.3147510076821219],
            [6.722077970986518, -0.3091164148727198],
            [6.714430855625612, -0.3100444843621708],
            [6.711712064060446, -0.3121769981513355],
            [6.708726560293658, -0.3213103703907649],
            [6.709754858995091, -0.32885841533396026],
            [6.708945117115858, -0.3333799037359564],
            [6.703161180313618, -0.33682225217682515],
            [6.691212145161908, -0.33646449023158176],
            [6.680135186728648, -0.3424257975836393],
            [6.677862469829251, -0.34897107466013044],
            [6.680071397273102, -0.3557358362072735],
            [6.683073841075421, -0.36126629602794774],
            [6.688333818193346, -0.36155867935312747],
            [6.715762264463979, -0.3467645643634947],
            [6.721399345934046, -0.34343910504564457],
            [6.725449020194214, -0.3561526890900247],
            [6.718874073859165, -0.3760634596123968],
            [6.710553852231669, -0.3841556083357183],
            [6.6937008978514365, -0.3939600681493106],
            [6.669360902864539, -0.3958065614562898],
            [6.665446958101878, -0.3976553529844371],
            [6.662434899398313, -0.4018602781008202],
            [6.663051081324818, -0.4092394648830713],
            [6.664815280249848, -0.41250334283401086],
            [6.669860704885132, -0.4157277273179462],
            [6.674861338869314, -0.41561147534258475],
            [6.682457521312648, -0.4119323167629092],
            [6.689456795696559, -0.414180231111318],
            [6.6900631220767, -0.4185880014464794],
            [6.683908075785644, -0.4226532765838656],
            [6.680216875243727, -0.42995617229078986],
            [6.678411454645213, -0.440140331361196],
            [6.681502445905519, -0.44926610735253286],
            [6.691277468488178, -0.4696438777688162],
            [6.691892863958462, -0.48025065532750866],
            [6.689682945996353, -0.4854731897674088],
            [6.686325841735437, -0.48800846528697656],
            [6.677737739220723, -0.4895017860867929],
            [6.67415188934135, -0.4916239961935037],
            [6.67585961393774, -0.5057150255783229],
            [6.681371627737358, -0.5180626405393897],
            [6.677921184212936, -0.522989607313449],
            [6.673393521446361, -0.5246242709535216],
            [6.667452340720259, -0.5226227917004954],
            [6.662139803308008, -0.5162483946520204],
            [6.658209309264683, -0.516203701111619],
            [6.652449649732469, -0.5203762461560566],
            [6.651135731710244, -0.5238969515784929],
            [6.652564896214852, -0.5279755672978934],
            [6.656994157845679, -0.5321739899821952],
            [6.665831411426538, -0.5337705092423771],
            [6.678012454885227, -0.5337547605560048],
            [6.681640657795954, -0.5346112576609392],
            [6.68882142292359, -0.5329890878892265],
            [6.6908882538229255, -0.5346959622700836],
            [6.693499623871642, -0.5448164289794264],
            [6.69763771809264, -0.5524147202925545],
            [6.696580260176812, -0.556620023094997],
            [6.6928181797104, -0.5597143086528882],
            [6.689218718292221, -0.5591973278895612],
            [6.685534912782327, -0.5556796711566836],
            [6.680185604117875, -0.5559872647929458],
            [6.673360100299663, -0.5581419976807498],
            [6.665222476985055, -0.558801929656371],
            [6.662927470388199, -0.5574589987355073],
            [6.652317941095547, -0.5552460848672461],
            [6.639970519483417, -0.546245840990886],
            [6.633534413310831, -0.5465303684625253],
            [6.631247342341015, -0.551225034051057],
            [6.63419028980466, -0.5589117193518893],
            [6.635940796335315, -0.5607397514608246],
            [6.6298070805432365, -0.5589912341218599],
            [6.6280015650227, -0.5550327823737969],
            [6.618569144555849, -0.5476295224593287],
            [6.611677128704472, -0.5456337461434477],
            [6.600455514320481, -0.5391643271343174],
            [6.6010633825919, -0.5473729073725642],
            [6.574724025489987, -0.5497945842622755],
            [6.553691408204008, -0.5510854333511546],
            [6.487360853265524, -0.5556917131185014],
            [6.432969924216112, -0.5600007392416719],
            [6.415257054946406, -0.5619426357250183],
            [6.411599429254509, -0.5161423049015771],
            [6.405155818784222, -0.43078910188228975],
            [6.399555471789488, -0.34366845019014086],
            [6.39275977248806, -0.24522225662474398],
            [6.390392947662399, -0.2124839174912462]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.17958212243268, "lat": 38.08748182468661 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17193"],
        "coty_name": ["White"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["White County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "00424297"
      },
      "bbox": [
        6.390392947662399, -0.5619426357250183, 6.754303362288517,
        -0.1838793008927332
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.58606608805362, 2.153940095245107],
            [8.595854490945733, 2.1552051751484287],
            [8.594281385946266, 2.1707525131227685],
            [8.584642881635917, 2.2555835518197256],
            [8.58886236912714, 2.2561883320086404],
            [8.586439211793248, 2.2783627322716073],
            [8.583410348635804, 2.3017557128770867],
            [8.578610358978633, 2.34403752605988],
            [8.591893377508004, 2.3455664455483007],
            [8.649042512512361, 2.352693658433678],
            [8.67775101668006, 2.356423604399047],
            [8.72368329680959, 2.3626029370540427],
            [8.72885714464392, 2.363609583537374],
            [8.777409340427864, 2.370453286203971],
            [8.876235179403063, 2.3836458653536288],
            [8.884327920699254, 2.313221459900367],
            [8.893878219003986, 2.2241458037630673],
            [8.901198790585289, 2.1638415343631627],
            [8.906432048383381, 2.121145002150761],
            [8.83359409749456, 2.111874903273829],
            [8.746055167077172, 2.101246498921081],
            [8.689223502578201, 2.0935538841660732],
            [8.612787528856195, 2.0836788876006764],
            [8.59518341233986, 2.0815841979224334],
            [8.589529401964159, 2.1249383600928384],
            [8.58606608805362, 2.153940095245107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.00562111778558, "lat": 40.43791570676152 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18075"],
        "coty_name": ["Jay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jay County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00450362"
      },
      "bbox": [
        8.578610358978633, 2.0815841979224334, 8.906432048383381,
        2.3836458653536288
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.16151835896256, 3.0348693414931596],
            [8.21625859471198, 3.0414493537241354],
            [8.247143852245655, 3.0447393686971505],
            [8.249703887489986, 3.0155673315008493],
            [8.30537250871407, 3.020746621791826],
            [8.356259063520795, 3.0261682637951317],
            [8.41992561813751, 3.032538848562969],
            [8.42034160653425, 3.01930172552802],
            [8.423534845219589, 2.9877060763805043],
            [8.428084246542099, 2.9470717626189016],
            [8.406931901029111, 2.944867211638959],
            [8.412461861135995, 2.899513775187642],
            [8.42850734134165, 2.7711613752318454],
            [8.341857578648808, 2.761444686418066],
            [8.313899761766924, 2.7572936062127322],
            [8.257069136487113, 2.749856665237347],
            [8.19957524506443, 2.742786692840804],
            [8.170335421222555, 2.739196559631404],
            [8.164710048401705, 2.7839775343696793],
            [8.160848269237817, 2.8128951425735673],
            [8.15555655473692, 2.85511926065624],
            [8.14855494127588, 2.9155798353602154],
            [8.173672236743318, 2.9184315497595392],
            [8.170366387272246, 2.9541653755395036],
            [8.165237763502494, 3.0059063939008186],
            [8.16151835896256, 3.0348693414931596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.50508520294431,
          "lat": 41.139391077035384
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18183"],
        "coty_name": ["Whitley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Whitley County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00450369"
      },
      "bbox": [
        8.14855494127588, 2.739196559631404, 8.42850734134165,
        3.0447393686971505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1325466586283413, 3.5402113516549147],
            [1.1747399912028784, 3.5404932459162506],
            [1.2320334846838867, 3.5406630528955345],
            [1.3035393790011245, 3.541336093001199],
            [1.3583897146785493, 3.5420041083002216],
            [1.387038903523155, 3.542217084587141],
            [1.4581291462600012, 3.543209302965403],
            [1.4724406045203122, 3.5432671992103284],
            [1.4730053061025226, 3.492690470645009],
            [1.4745548983806513, 3.3820964936041724],
            [1.4758048469541463, 3.2828650919484033],
            [1.477537345223931, 3.194820060331184],
            [1.3916752071884484, 3.193264327710816],
            [1.3631309646616836, 3.1934157612838003],
            [1.3067378115275485, 3.192627105828286],
            [1.2710216140984152, 3.192395409926703],
            [1.2206164276476252, 3.1917557857863237],
            [1.134403693762264, 3.1913279514193698],
            [1.1340549887290776, 3.210562157698987],
            [1.134002876431846, 3.2492514044692347],
            [1.1336885349546897, 3.3227161901979954],
            [1.133122090566491, 3.4156464645177986],
            [1.1330272262003835, 3.4533284609741184],
            [1.1327190722592315, 3.489727483048448],
            [1.1325466586283413, 3.5402113516549147]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.8605327283301, "lat": 42.03620760449317 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19027"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00465203"
      },
      "bbox": [
        1.1325466586283413, 3.1913279514193698, 1.477537345223931,
        3.5432671992103284
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7058963590232693, 3.5384451399141197],
            [0.765918592401976, 3.5382733570880487],
            [0.8761458037399146, 3.538530066051862],
            [0.9614025077874261, 3.539316016862615],
            [1.0042415709846457, 3.5394555851294474],
            [1.047067772106095, 3.5399297647411503],
            [1.1325466586283413, 3.5402113516549147],
            [1.1327190722592315, 3.489727483048448],
            [1.1330272262003835, 3.4533284609741184],
            [1.133122090566491, 3.4156464645177986],
            [1.1336885349546897, 3.3227161901979954],
            [1.134002876431846, 3.2492514044692347],
            [1.1340549887290776, 3.210562157698987],
            [1.134403693762264, 3.1913279514193698],
            [1.0485224278479823, 3.190898854032079],
            [0.9637111947759303, 3.1907460972229953],
            [0.9271269956076591, 3.190132612681564],
            [0.9007207524919407, 3.189428622535586],
            [0.8632264541511814, 3.1890549345459367],
            [0.7910563058015877, 3.188968916251466],
            [0.7056701324007854, 3.188319850063745],
            [0.7058249117255463, 3.2759820334945635],
            [0.7058738053622594, 3.360658155578525],
            [0.705881567153957, 3.436548978332988],
            [0.7060972618666985, 3.501971456488684],
            [0.7058963590232693, 3.5384451399141197]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.38196103857629, "lat": 42.03720498535653 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19047"],
        "coty_name": ["Crawford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crawford County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00465212"
      },
      "bbox": [
        0.7056701324007854, 3.188319850063745, 1.134403693762264,
        3.5402113516549147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9074634157207986, 2.2135979850097334],
            [3.935479919844087, 2.2146802746038716],
            [3.932574196188454, 2.280419251029083],
            [3.93140932446899, 2.3023174138255174],
            [3.928079064612501, 2.3757143598356834],
            [3.923680563326486, 2.477867566323523],
            [4.009695407434991, 2.4821439780110217],
            [4.0724048963442, 2.484218542623809],
            [4.174129355545011, 2.4893298127743027],
            [4.238372136937457, 2.4924785037626616],
            [4.238797379808773, 2.49001823352292],
            [4.2418233301609956, 2.481585163854919],
            [4.245734192218061, 2.4545284324148344],
            [4.244266626914983, 2.438891657322124],
            [4.24448474009225, 2.4260064702947384],
            [4.242333049773328, 2.414545636346473],
            [4.2386234988086375, 2.4058308363828718],
            [4.236801181242215, 2.3986337158223847],
            [4.242570353519462, 2.3772194840426764],
            [4.242595759699075, 2.3729924579819652],
            [4.237386599130346, 2.3548669382968592],
            [4.236159646881291, 2.3433007932723613],
            [4.231922210302362, 2.3371940419954647],
            [4.224485298713068, 2.3331633907944056],
            [4.219971533855841, 2.3295137272754327],
            [4.2104274881967925, 2.324953692895555],
            [4.202567731910163, 2.3169176661403528],
            [4.200003791482125, 2.3128046504818167],
            [4.194439656883834, 2.2997985715023948],
            [4.190257848977187, 2.294687969496239],
            [4.183512205151032, 2.29016308468992],
            [4.177974893940738, 2.2831318871455775],
            [4.170202496920192, 2.26257773944867],
            [4.162499921026281, 2.2557296731943026],
            [4.155185772813481, 2.2466806213374655],
            [4.146238503075853, 2.237371308259474],
            [4.144234894882241, 2.233676545266376],
            [4.141839581435271, 2.224005020283655],
            [4.142176539357629, 2.2147932553263403],
            [4.146253518070378, 2.205354616501509],
            [4.147332713316203, 2.1991689368791567],
            [4.147355331435481, 2.1920900291101137],
            [4.144687640328997, 2.179263284270513],
            [4.14044564547712, 2.1688943620860575],
            [4.136478405464069, 2.1624926905136492],
            [4.135090535284172, 2.156964628598999],
            [4.132161070148422, 2.136266705619733],
            [4.136518624133796, 2.1194489807654606],
            [4.1361362015895065, 2.1073149628120156],
            [4.128996368659133, 2.110700792761463],
            [4.122443912982506, 2.108497603694234],
            [4.116100651410233, 2.1107554787127447],
            [4.110047755301277, 2.1162622833600295],
            [4.1069463676481375, 2.1158354915319046],
            [4.104551958791117, 2.119867287191713],
            [4.098508260653179, 2.12634824257389],
            [4.097777698632404, 2.1316597907053487],
            [4.094193724655653, 2.1290210303221913],
            [4.0886341035634075, 2.1306327198906523],
            [4.08641296087215, 2.1290939708280923],
            [4.083811656285431, 2.1216302120824424],
            [4.085776662098756, 2.117582067286506],
            [4.082893090746766, 2.1165265299182323],
            [4.078004359400425, 2.1212209016210943],
            [4.074937395790973, 2.1223312117764204],
            [4.073481310196939, 2.1260914637774366],
            [4.068615799233436, 2.1264985190341865],
            [4.065936688994585, 2.1224577417606074],
            [4.062046954888263, 2.1230588158631396],
            [4.063928648321582, 2.1281430618933705],
            [4.0557192721284325, 2.139561851764313],
            [4.048134387962288, 2.1412613567117957],
            [4.043198979378224, 2.14423984986276],
            [4.034418687834373, 2.1547569932361172],
            [4.031428160007985, 2.1566235977436494],
            [4.027217096949974, 2.156628101460972],
            [4.019498335758706, 2.159859616879911],
            [4.012775068084095, 2.1596974242185194],
            [4.009634716676668, 2.1580337127818088],
            [4.005142354819462, 2.1594352194213258],
            [4.00311977467163, 2.1644538965217186],
            [4.001752767760729, 2.171462665158863],
            [3.9964734233325756, 2.1772613914075203],
            [3.9933110804291827, 2.177614412989692],
            [3.9843739962134013, 2.175811563383208],
            [3.9812220754005185, 2.177202924027961],
            [3.9770172491793025, 2.1837107788026215],
            [3.971684699133607, 2.1843170787391863],
            [3.9648466510873877, 2.1878889896744464],
            [3.955707530382275, 2.1892753075791913],
            [3.953616457035174, 2.194535748562892],
            [3.9509617276392213, 2.1963643258550047],
            [3.9468725166176943, 2.1937045832605557],
            [3.942723891467506, 2.1928704598845346],
            [3.934769396546083, 2.19986248564512],
            [3.9270785025237678, 2.2029351473968584],
            [3.9196078602510425, 2.209860303523026],
            [3.9099781065800907, 2.2094860251935735],
            [3.9074634157207986, 2.2135979850097334]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.18149994962612, "lat": 40.92317331346613 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19057"],
        "coty_name": ["Des Moines"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Des Moines County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00465217"
      },
      "bbox": [
        3.9074634157207986, 2.1073149628120156, 4.245734192218061,
        2.4924785037626616
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2546796888705478, 4.2436054281907065],
            [1.3398952181280448, 4.244054169755073],
            [1.4259270476220016, 4.244938838862264],
            [1.4689840256812972, 4.245780870880027],
            [1.5120260906058933, 4.246244149686482],
            [1.5404637291948364, 4.246232152869584],
            [1.5976309322840991, 4.246729373608138],
            [1.5985091847499424, 4.201122923023853],
            [1.6003200364420485, 4.074452453003461],
            [1.6018692183073369, 3.982968691350924],
            [1.6023315592995608, 3.9327595625386795],
            [1.6028083278461513, 3.9244890954849843],
            [1.6033351986212192, 3.896326115716277],
            [1.5176347796724006, 3.8953555433162723],
            [1.4853630136355835, 3.895252737321113],
            [1.4746336560737396, 3.8955030037532743],
            [1.4312650458787135, 3.8940924491615676],
            [1.3980096780988542, 3.893678059854554],
            [1.3446966832950158, 3.8933555669489692],
            [1.3015363146012975, 3.893280439316194],
            [1.2582608618220052, 3.893011830305959],
            [1.256474374689761, 3.980153085699462],
            [1.256413541320953, 3.99837916034897],
            [1.256667230105988, 4.067786346636811],
            [1.2553405162725653, 4.189116948181221],
            [1.2546796888705478, 4.2436054281907065]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.67873737453158, "lat": 42.73414932568294 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19151"],
        "coty_name": ["Pocahontas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pocahontas County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00465264"
      },
      "bbox": [
        1.2546796888705478, 3.893011830305959, 1.6033351986212192,
        4.246729373608138
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.06164702994855898, 4.5914256710453145],
            [0.13734543553035575, 4.589822257797191],
            [0.22164926240013397, 4.58837430361859],
            [0.2711607889211318, 4.587960055967744],
            [0.3202770281151519, 4.587859639970147],
            [0.36362618358688564, 4.58759987400049],
            [0.3926866397358187, 4.587687108825511],
            [0.4353687222572295, 4.589151234373926],
            [0.44918078565692077, 4.588681059197815],
            [0.48470246605676226, 4.588009427010061],
            [0.5440551220806099, 4.588146108029745],
            [0.563792652864076, 4.587890337766177],
            [0.5635954643878572, 4.545098758371792],
            [0.563749494231123, 4.51597927719178],
            [0.5641725237494972, 4.501470640124413],
            [0.5646181267261627, 4.457336152809206],
            [0.565226276204874, 4.413645905088185],
            [0.5653770088510975, 4.370075391801195],
            [0.5661492634906407, 4.238569276505625],
            [0.48022028437776887, 4.239172697713801],
            [0.4658818235959902, 4.239551909528321],
            [0.39394368960615206, 4.23943852940163],
            [0.32177485610857576, 4.238880635188806],
            [0.2220166250561391, 4.239199507801003],
            [0.18594407999627097, 4.239247254617056],
            [0.13575464637445633, 4.239564580964746],
            [0.07241038934757564, 4.239290325460863],
            [0.06977366794042913, 4.255056786065052],
            [0.08116529368344823, 4.266040445906532],
            [0.08780173704115982, 4.265930955419736],
            [0.08522304536228578, 4.270279589014349],
            [0.08896108906160016, 4.274178650264921],
            [0.09291126792804533, 4.275644718943677],
            [0.09632114213177931, 4.28516196141891],
            [0.09965677943070013, 4.289889899199391],
            [0.0976485748543677, 4.2987264484337455],
            [0.09547097986957409, 4.301902878173349],
            [0.08836796347894957, 4.3034832895239905],
            [0.08524814431446144, 4.308270586650706],
            [0.09111978567752936, 4.316555874953153],
            [0.09067745891502645, 4.322060413298019],
            [0.09474099634533248, 4.3271476592537095],
            [0.10167144158533185, 4.328739559153674],
            [0.1042209505986674, 4.332412315920673],
            [0.10620450266432004, 4.340311429407075],
            [0.10423300630205884, 4.345178657954783],
            [0.10078849977572604, 4.3498710848804],
            [0.09786734138558606, 4.350480024262504],
            [0.09223282690600787, 4.355419022210487],
            [0.09073363500392388, 4.359172963464748],
            [0.09364566341846492, 4.368040625284296],
            [0.08885453153309139, 4.370162841107799],
            [0.08692196056087122, 4.372860301492812],
            [0.09290621733941473, 4.38069731450372],
            [0.09908261576573457, 4.37937621731446],
            [0.10736660087267032, 4.381495659867291],
            [0.11003838038329893, 4.3862030372236145],
            [0.11720708646083546, 4.393069325144115],
            [0.11993049773857553, 4.39422570832666],
            [0.12352466287555831, 4.3925136805449085],
            [0.12888106543217703, 4.394666079266455],
            [0.13303291860006958, 4.405693800841975],
            [0.13381448177678243, 4.414036917331762],
            [0.13300291339374415, 4.418802285846984],
            [0.1277085439244603, 4.420316417183861],
            [0.12927432085715135, 4.425647832721764],
            [0.13557510023731667, 4.431165089234029],
            [0.14474583485864506, 4.44459638664676],
            [0.14677163419823253, 4.451529429313821],
            [0.14311963734588168, 4.455400262924834],
            [0.14186519989716187, 4.464565317778111],
            [0.13687500587169812, 4.473020024332588],
            [0.13312254478363078, 4.474962230703191],
            [0.1299014126743209, 4.474335237274105],
            [0.12517450309567038, 4.481138554729355],
            [0.12469473940791304, 4.494956732739513],
            [0.12652150377579957, 4.512955078737956],
            [0.12110008489975868, 4.516599495917186],
            [0.12007719889714258, 4.520773472443958],
            [0.12016344761905799, 4.529754031062854],
            [0.12236762127374977, 4.536089374602553],
            [0.118163130060083, 4.553060059305701],
            [0.11196375048391756, 4.555264729160643],
            [0.10384920983885336, 4.554774430242963],
            [0.10071316659774335, 4.551899972707639],
            [0.08727461364323928, 4.548888580330688],
            [0.0818061348533775, 4.555312572504813],
            [0.07539205205440536, 4.558924525588128],
            [0.07222993928663937, 4.556996446500414],
            [0.061472331656449046, 4.558137397581227],
            [0.05746816355906101, 4.555599648195287],
            [0.05166588700785139, 4.562983784680991],
            [0.049761564679949036, 4.570416922759177],
            [0.05409887553338693, 4.575681484683497],
            [0.06302316536265579, 4.578675104605248],
            [0.06335403114927522, 4.589181486370193],
            [0.06164702994855898, 4.5914256710453145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.17787870104148, "lat": 43.08263600115894 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19167"],
        "coty_name": ["Sioux"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sioux County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00465272"
      },
      "bbox": [
        0.049761564679949036, 4.238569276505625, 0.5661492634906407,
        4.5914256710453145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.3269365743665493, 2.275479422338919],
            [3.3915016479705287, 2.2781228751624845],
            [3.4313976872837424, 2.27996337314011],
            [3.499670835751723, 2.283771326292747],
            [3.559765302865745, 2.286772544044432],
            [3.6577696341779244, 2.2905694796174383],
            [3.6720208991020584, 2.2915650433235593],
            [3.675541753099908, 2.203418554563913],
            [3.6797517694771864, 2.1152876500253903],
            [3.6825112066820274, 2.0565339778652567],
            [3.685160027657136, 2.0025723913135223],
            [3.686371433121753, 2.0026552365892796],
            [3.6868244686837954, 1.9869891903301484],
            [3.6842151198564266, 1.989895933105899],
            [3.676855849794116, 2.0017880284792073],
            [3.6271532436520477, 1.997009763723284],
            [3.6050492068719153, 1.9951170525422368],
            [3.572378552101194, 1.9915380379481555],
            [3.519154749453296, 1.9873179698258452],
            [3.5162945755612287, 1.9868847595825605],
            [3.4513097328368363, 1.9819926827177468],
            [3.401197866657003, 1.978017095918405],
            [3.3385317691035428, 1.9741582792903798],
            [3.3368425383433653, 2.0348037851459124],
            [3.3363968828572257, 2.057091482749027],
            [3.3334846965234535, 2.123077759433292],
            [3.3303534904516003, 2.2050342313808975],
            [3.3279360824498214, 2.2523836017755077],
            [3.3269365743665493, 2.275479422338919]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.94994635606729, "lat": 40.7532277394112 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19177"],
        "coty_name": ["Van Buren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Van Buren County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00465277"
      },
      "bbox": [
        3.3269365743665493, 1.9741582792903798, 3.6868244686837954,
        2.2915650433235593
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9648193350697478, 1.312497279126912],
            [0.9888107714647052, 1.3126668445997582],
            [0.989785796233081, 1.3016928669794303],
            [0.9933163492704824, 1.2969192149295459],
            [1.0030787424457728, 1.2902810738307122],
            [1.0144795933082567, 1.2847261569742223],
            [1.0181995694048203, 1.2820113038605223],
            [1.0276044356167846, 1.2674441738834994],
            [1.033273300896967, 1.2611906798722097],
            [1.0400416432581427, 1.2575162151107833],
            [1.047852077256999, 1.2564035054277318],
            [1.0561286171001194, 1.257125748444353],
            [1.0610576704702561, 1.2559283297241763],
            [1.0681654385961183, 1.251692222739928],
            [1.0705996399501023, 1.2469148936412475],
            [1.0710968786199695, 1.240825756303148],
            [1.0701423395983596, 1.2350492822717878],
            [1.067365437630639, 1.2276915569015674],
            [1.0674326994391254, 1.2207359781317628],
            [1.0703551270960123, 1.2165003734449074],
            [1.0765550796829924, 1.2131593404095118],
            [1.0874782144703656, 1.2126191310649468],
            [1.0929012041627366, 1.2146478739347415],
            [1.1023294457895751, 1.2197333267700106],
            [1.110073880691482, 1.2187568384066487],
            [1.1145607024866933, 1.2147307332182724],
            [1.1156513385820943, 1.2081838705905794],
            [1.1149782450706736, 1.2020589903386716],
            [1.1171784153069904, 1.1943414851337248],
            [1.1216737744452125, 1.189502486047079],
            [1.126702666532011, 1.1868370978454792],
            [1.1436721052777274, 1.1819483972424971],
            [1.1557104728569976, 1.1759839878989955],
            [1.1622830272349116, 1.1746122897700406],
            [1.1955300098672703, 1.178799877487378],
            [1.2029484235408567, 1.1849096123208824],
            [1.205011048319579, 1.1923080279131013],
            [1.2042996299102269, 1.2002864371033501],
            [1.2054379640448847, 1.2047934460795466],
            [1.2096658364989814, 1.2110627948969501],
            [1.2138887700776273, 1.2137108555124572],
            [1.2209782167051526, 1.2142368521537847],
            [1.228917913015685, 1.2116891353427033],
            [1.2338216859010753, 1.2106078245933258],
            [1.2408261345580236, 1.211492066344167],
            [1.2548218245925653, 1.215880929537977],
            [1.2607145937112418, 1.2147973846991058],
            [1.2665738430923645, 1.2124374924762662],
            [1.2737532178520588, 1.2077104635611295],
            [1.2788499551504713, 1.2004480203165866],
            [1.2794070035985923, 1.1945472051002362],
            [1.2762921592176302, 1.1867866285540438],
            [1.2707835734642494, 1.1810256195228652],
            [1.2680998617727348, 1.175054199845332],
            [1.2680283010824474, 1.1705488126807473],
            [1.2718411231652005, 1.163713307500725],
            [1.2806888509587862, 1.1552716388639936],
            [1.2877715622223285, 1.1501207419471207],
            [1.2982674060574162, 1.1479322232091094],
            [1.3062344926085947, 1.1485574081459886],
            [1.3106196807222668, 1.147316944963701],
            [1.3151733387831193, 1.143156292951761],
            [1.3186353811955864, 1.1350797614318262],
            [1.3189886333489378, 1.120971960499847],
            [1.3156102854368446, 1.1112886208111181],
            [1.3132477747400386, 1.1081284125620725],
            [1.306524153156476, 1.1048850605016542],
            [1.2816917780671977, 1.1032438115995615],
            [1.276310040635014, 1.0996793738250297],
            [1.2740668053860107, 1.092210609200766],
            [1.2752837026536876, 1.0869119584041325],
            [1.2814820037160644, 1.0797640660322],
            [1.2887346912442936, 1.0742433544354983],
            [1.2921772641561318, 1.072667961893596],
            [1.2967832705126319, 1.0728015493304344],
            [1.3021599914966075, 1.0747205282559826],
            [1.315547080754295, 1.084968684001779],
            [1.3233526920463805, 1.0868129012782184],
            [1.3264149085606771, 1.0855373922800549],
            [1.331392341109034, 1.0769178517792417],
            [1.3324962168985457, 1.0674446277440977],
            [1.3299596112956154, 1.0566157222096555],
            [1.324575635179099, 1.048074115891808],
            [1.3204343465886417, 1.0438872091692164],
            [1.3140019859495815, 1.04007728806267],
            [1.3082327921076131, 1.0380922678930182],
            [1.2999597939237983, 1.0372979018863784],
            [1.2879348795337486, 1.0417944128430519],
            [1.2789600719051737, 1.0483294284499325],
            [1.2718688421879423, 1.0545151079478619],
            [1.2645831625032213, 1.0584861113887025],
            [1.2595850001504483, 1.0585278896040198],
            [1.2520158820813774, 1.051760154879233],
            [1.2482034571684597, 1.0447108325742411],
            [1.2478017176331027, 1.035648797568046],
            [1.2499744145992788, 1.019783124144919],
            [1.249730184195325, 1.0051990126409864],
            [1.248020908325693, 0.9985759852756417],
            [1.2442576841607944, 0.9934487333608966],
            [1.2383303500259188, 0.9898325693961041],
            [1.2311706640249247, 0.988464561018839],
            [1.2193864676537107, 0.9875282974954706],
            [1.2123292265919259, 0.9845322658326652],
            [1.2052944311512275, 0.9769763076316755],
            [1.197933870918663, 0.9642361155255299],
            [1.1967582512727157, 0.9609279384484011],
            [1.1926126147374674, 0.955568276820631],
            [1.1888914494622091, 0.9489767082656754],
            [1.1860307188804784, 0.9413492534541745],
            [1.1847559882397591, 0.9325658273708395],
            [1.186164230617006, 0.9261874922714117],
            [1.161707801497123, 0.925696198865044],
            [1.1605142496327232, 0.9314023802171473],
            [1.1520625255437287, 0.9314549130072833],
            [1.1500399010941738, 0.9343848927522215],
            [1.1527088394202838, 0.9387723341963474],
            [1.15068094983944, 0.9460613111348882],
            [1.145039554302479, 0.9472525339138785],
            [1.139389493223507, 0.9542242194703993],
            [1.1386526876979115, 0.9633007603771151],
            [1.130977038693452, 0.9635668115577573],
            [1.0989948658371067, 0.9630998970663319],
            [1.0957315074622538, 0.9632792856899962],
            [0.9673707681670205, 0.9623436959460181],
            [0.9666868529501998, 1.0723948351942174],
            [0.9659333941264925, 1.153117414098476],
            [0.9656998621857332, 1.2119016653086816],
            [0.9648193350697478, 1.312497279126912]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.14683572438646, "lat": 39.78806644335541 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20043"],
        "coty_name": ["Doniphan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Doniphan County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00484991"
      },
      "bbox": [
        0.9648193350697478, 0.925696198865044, 1.3324962168985457,
        1.3126668445997582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.27626848225688727, 0.4387638955802869],
            [-0.2748876396291482, 0.4387751556509026],
            [-0.27395598879012434, 0.5041610540569208],
            [-0.27423170962049137, 0.527362058221167],
            [-0.1884413436435112, 0.525470282781571],
            [-0.18900057514812477, 0.4449787554560217],
            [-0.17464705610626452, 0.44479934968916773],
            [-0.17578351229146857, 0.42503803360629716],
            [-0.18153141678979778, 0.42098448451557036],
            [-0.19057743935405516, 0.4060821124057298],
            [-0.19079867608197532, 0.3933990675893885],
            [-0.10780034585194842, 0.39218072504733176],
            [-0.10785769299336163, 0.38642225567712024],
            [-0.10218785942817527, 0.3843608856839505],
            [-0.09639691171096115, 0.39203890642492367],
            [-0.09121798981886794, 0.3958127381040915],
            [-0.08495053214299703, 0.3944397679003328],
            [-0.07918987372347963, 0.39549722308693647],
            [-0.07922173356822827, 0.37724038798781684],
            [-0.023654666141557, 0.3768628167888571],
            [0.005270606381543059, 0.37701587945224146],
            [0.07852906741708626, 0.37583884252387945],
            [0.07821773548063485, 0.34654624687241276],
            [0.07802763612114881, 0.3175009996665094],
            [0.07739696316060371, 0.25910381347151407],
            [0.0769908454345918, 0.1709089978837312],
            [0.06262792540915145, 0.17116289829448217],
            [-0.022838503751913406, 0.17202986384212174],
            [-0.08020799743958679, 0.17246451993924236],
            [-0.16539683743736944, 0.17277979931752316],
            [-0.22271648099120706, 0.1734699826341158],
            [-0.2508305169259278, 0.17402447288699222],
            [-0.24972725898896536, 0.262130808061146],
            [-0.2493757657470079, 0.283656140890378],
            [-0.2533226694766892, 0.28082819072052345],
            [-0.2545374458554628, 0.27756364363373975],
            [-0.258589416802493, 0.2803721117083988],
            [-0.26482955607419567, 0.2796827587485804],
            [-0.268743257730891, 0.2805618956427096],
            [-0.2680725388904482, 0.2760993907469337],
            [-0.273719874790127, 0.2716205085376561],
            [-0.2782068507695929, 0.2697666090901136],
            [-0.2781806183581963, 0.28002590665323546],
            [-0.27704524629116173, 0.3507336080871721],
            [-0.2764968538064805, 0.3925612016289618],
            [-0.27626848225688727, 0.4387638955802869]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.75248964491352,
          "lat": 39.002384117242435
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20061"],
        "coty_name": ["Geary"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Geary County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00484999"
      },
      "bbox": [
        -0.2782068507695929, 0.1709089978837312, 0.07852906741708626,
        0.527362058221167
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.833330449606326, -0.6339590582949409],
            [-2.8376105913316834, -0.7217013366049992],
            [-2.8417793181010453, -0.8096277537266667],
            [-2.8317951896451325, -0.8101057757171561],
            [-2.8359513068613054, -0.900701876443501],
            [-2.8401107954757863, -0.9884642361017184],
            [-2.8444040912937854, -1.076569377628318],
            [-2.848785241827129, -1.164716726255668],
            [-2.8664881906481052, -1.1637258196207616],
            [-2.8915329435556814, -1.1628648801157182],
            [-2.9770380418419915, -1.1594338019848667],
            [-3.0335808318086928, -1.1567732217100726],
            [-3.1053622510933, -1.1532464387419237],
            [-3.191413604366213, -1.1490680648944693],
            [-3.1868840326012493, -1.0611046259639991],
            [-3.1803624815154015, -0.929362825738611],
            [-3.1781898099820416, -0.8854494168432576],
            [-3.1732295645641972, -0.7922453711966194],
            [-3.183710806009539, -0.7916109792742567],
            [-3.1802270107352864, -0.7263207002016157],
            [-3.1743204855016374, -0.6164680781918026],
            [-3.05163837249495, -0.6236862067152225],
            [-3.003966652205164, -0.6264898378954613],
            [-2.961456569690808, -0.6282539914929739],
            [-2.833330449606326, -0.6339590582949409]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.43788179960508,
          "lat": 37.73818814947186
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20069"],
        "coty_name": ["Gray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gray County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00485001"
      },
      "bbox": [
        -3.191413604366213, -1.164716726255668, -2.8317951896451325,
        -0.6164680781918026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5979014685555119, -0.08533195753994828],
            [-0.5833766417059727, -0.08564623164671017],
            [-0.5121061279876055, -0.08656685837846972],
            [-0.4697652313376229, -0.0870013563128272],
            [-0.468541929937501, -0.08720672269620941],
            [-0.42676147119724356, -0.08739425913617138],
            [-0.33246225056800965, -0.08906733621645559],
            [-0.32071047036889666, -0.08900781299944337],
            [-0.25616717526675825, -0.08946190364767029],
            [-0.25678094145321145, -0.1772589562113347],
            [-0.17120072933392913, -0.1780092540988941],
            [-0.17184213072105572, -0.2220041313945376],
            [-0.17217594827628208, -0.2803998054089694],
            [-0.17268883691993878, -0.353650608450348],
            [-0.18680564021012683, -0.3533922252586952],
            [-0.18767093630721643, -0.4400100699581571],
            [-0.19012947533333233, -0.4415727661348922],
            [-0.19083548910340753, -0.5015740075271993],
            [-0.19060552829125912, -0.5023222972825814],
            [-0.19082902351277528, -0.5456252456824372],
            [-0.19157657544816417, -0.6189459362299472],
            [-0.2627801616400057, -0.6181283637358052],
            [-0.348563879617762, -0.6164800269890417],
            [-0.43483048207495684, -0.6142922335149247],
            [-0.4339057764181519, -0.5265175728820297],
            [-0.4633431500616023, -0.5258718121787228],
            [-0.5198161518297023, -0.5251618189130809],
            [-0.6041263513542464, -0.5252270506262626],
            [-0.6027604495674039, -0.43722523280576836],
            [-0.601523754631729, -0.34922532886268026],
            [-0.6008701745582474, -0.29060681358793483],
            [-0.5991885611190073, -0.17336578422387175],
            [-0.5979014685555119, -0.08533195753994828]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.0968908758481, "lat": 38.35890220183591 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20115"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00485022"
      },
      "bbox": [
        -0.6041263513542464, -0.6189459362299472, -0.17120072933392913,
        -0.08533195753994828
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.0147408688879296, 0.6257737311415489],
            [-1.0006368382806148, 0.6253817801720533],
            [-0.9288975954900549, 0.6243594980459547],
            [-0.8423587424819552, 0.6227775364331165],
            [-0.7854058331841683, 0.6216816548696622],
            [-0.6709476817309424, 0.6197219388690847],
            [-0.5861608072582731, 0.6179457611395877],
            [-0.5880853076699365, 0.5301166807940205],
            [-0.5892534221872173, 0.4718678266692895],
            [-0.5897034921189517, 0.4422707875123027],
            [-0.5916940442843878, 0.30665296203003256],
            [-0.5925936408601143, 0.26651122199978194],
            [-0.67802074956103, 0.26809490678221204],
            [-0.7633475676602689, 0.26923944335804006],
            [-0.80159472339163, 0.2701057733524982],
            [-0.8621815610079181, 0.2711833699550896],
            [-0.9358383971510014, 0.27257203260760693],
            [-1.0214580931507424, 0.27450588527744507],
            [-1.0197928339434974, 0.34768784791807233],
            [-1.0199336407398374, 0.36232307662186775],
            [-1.018404190369006, 0.43558972871851],
            [-1.0177974387231608, 0.4498082910771653],
            [-1.0190139160187761, 0.45026315228090663],
            [-1.0170239216598969, 0.5378504142529875],
            [-1.0179250175356864, 0.5572231663483556],
            [-1.0174495358422817, 0.567367234025034],
            [-1.0172708370394747, 0.5962381963247484],
            [-1.0156527896132646, 0.6108812244705578],
            [-1.0147408688879296, 0.6257737311415489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.65019736288218,
          "lat": 39.132529219741585
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20143"],
        "coty_name": ["Ottawa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ottawa County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00485035"
      },
      "bbox": [
        -1.0214580931507424, 0.26651122199978194, -0.5861608072582731,
        0.6257737311415489
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.286554817863615, 0.9262681005895399],
            [-2.1798169226084285, 0.9224928309277093],
            [-2.134347198851412, 0.9206229401589976],
            [-2.105689111948249, 0.9198285093540902],
            [-2.0485954103869797, 0.9178763730152669],
            [-2.0366199811580317, 0.917116274871311],
            [-2.0177575099019673, 0.916928147692132],
            [-2.0058375596279894, 0.916262896522219],
            [-1.9630276608560546, 0.9154686690985423],
            [-1.9463373344650612, 0.9147547871628579],
            [-1.8774758682645303, 0.9127181561875788],
            [-1.860822283093587, 0.9120918046315628],
            [-1.8611396274228917, 0.8957502197955483],
            [-1.8622356771228992, 0.8677486613975398],
            [-1.8636684619402502, 0.8238499926105098],
            [-1.8656883188473203, 0.7875701984113075],
            [-1.8671345485738635, 0.7363878544597362],
            [-1.868723143030108, 0.707123307521832],
            [-1.8705361471326414, 0.6638257754606366],
            [-1.872513245785288, 0.6487798667923987],
            [-1.873074648231717, 0.6050295239417552],
            [-1.8749304586588476, 0.5607226280516608],
            [-1.8774124730879802, 0.4732731427381153],
            [-1.9065028581362584, 0.4744777087025949],
            [-1.9247400521802902, 0.4747055769392862],
            [-1.9370618743610426, 0.475337127645588],
            [-2.011512394732579, 0.47792616384991377],
            [-2.033058106423157, 0.47833380151102056],
            [-2.0568677965326865, 0.4793270014428076],
            [-2.1035198322696544, 0.4802177628048728],
            [-2.1037542703680123, 0.4806341275791434],
            [-2.152878497182911, 0.48238900965755255],
            [-2.2390154359944647, 0.4852585854724959],
            [-2.2952084055136184, 0.48720787467927384],
            [-2.305500108344938, 0.4877229810233722],
            [-2.3023689486721133, 0.576114823834187],
            [-2.2985045489314397, 0.6640864353879075],
            [-2.293418422171355, 0.7517825888326674],
            [-2.2897572968385544, 0.8381891863666886],
            [-2.289433519658604, 0.8392011213005487],
            [-2.28758913877789, 0.8977037665900333],
            [-2.286554817863615, 0.9262681005895399]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.32502778879032, "lat": 39.35023143791444 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20163"],
        "coty_name": ["Rooks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rooks County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00485045"
      },
      "bbox": [
        -2.305500108344938, 0.4732731427381153, -1.860822283093587,
        0.9262681005895399
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4943360352602002, -1.1083756167743792],
            [0.4945331583140693, -0.9912757245978532],
            [0.4943806242509131, -0.9765729405214661],
            [0.5316849867430459, -0.976387701785336],
            [0.5580413103212578, -0.9767779967218891],
            [0.6366616507405657, -0.9768832543170183],
            [0.7222066253967296, -0.9769716260745281],
            [0.7435387557814047, -0.9771479375912809],
            [0.8353590739864636, -0.977211680246519],
            [0.8355510905343666, -1.0942136819370303],
            [0.8365356995601325, -1.1529499127685325],
            [0.8364188993732683, -1.1806500926264065],
            [0.8369154483526116, -1.2048859724155794],
            [0.8366488501333069, -1.2589631873838618],
            [0.837069408891911, -1.3293352532700733],
            [0.8009431758585592, -1.3295401326417065],
            [0.7267451090105183, -1.3292048227461153],
            [0.6343006880960205, -1.3285893905458939],
            [0.5810058527835467, -1.3281245731435036],
            [0.49395152213676347, -1.3275784308989116],
            [0.49321812194217063, -1.267633973251528],
            [0.4932955925327579, -1.213089511733299],
            [0.4943360352602002, -1.1083756167743792]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.7434089118705, "lat": 37.55925754837893 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20205"],
        "coty_name": ["Wilson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilson County"],
        "coty_fp_code": "205",
        "coty_gnis_code": "00485063"
      },
      "bbox": [
        0.49321812194217063, -1.3295401326417065, 0.837069408891911,
        -0.976387701785336
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.718722869852789, -1.1522349227299635],
            [8.751987167140038, -1.129873402773766],
            [8.787796609629893, -1.1086460234072129],
            [8.827186696661938, -1.0803587022207244],
            [8.846020803659734, -1.053741167820817],
            [8.870314244535894, -1.0190202996633946],
            [8.875538190648754, -1.016432063847003],
            [8.877262280952952, -1.014054939994044],
            [8.875401492006413, -1.0092724090467842],
            [8.870423476271254, -1.0019115988904956],
            [8.87236952360949, -0.9955246561677048],
            [8.876392919732263, -0.9996271004698191],
            [8.879996362508889, -0.9982354038384954],
            [8.883039850906943, -0.9945242224741411],
            [8.886038886440112, -0.9950578549398646],
            [8.90130272920667, -0.9788173062007207],
            [8.902586207501509, -0.9761448425076481],
            [8.907429716377932, -0.9752501698399653],
            [8.912045390287624, -0.9782117048364661],
            [8.917179639167484, -0.9763902613874267],
            [8.919562419094557, -0.9725277146851865],
            [8.939280688089251, -0.9720015260366607],
            [8.942768055839222, -0.967825342020455],
            [8.948441719321876, -0.9656789939499274],
            [8.952845585563825, -0.9673463779386897],
            [8.957701748904604, -0.9645649486380123],
            [8.959113829111883, -0.9608766531185525],
            [8.96272577120179, -0.9590751772564449],
            [8.963335407375467, -0.9547812787508638],
            [8.961742381480676, -0.9515975899435019],
            [8.961721436536653, -0.9467761387350999],
            [8.965810510840623, -0.9395320406560502],
            [8.96628130056138, -0.9345140951735746],
            [8.96278480360253, -0.9295836109409534],
            [8.9617647037781, -0.9242573582294813],
            [8.970686357265228, -0.9178445908015486],
            [8.975623187957222, -0.9174993408334202],
            [8.979526653662605, -0.9187293530031546],
            [8.994095449282078, -0.923123052130336],
            [9.024331373541372, -0.9423537293827595],
            [9.070442668316845, -0.9624929967531896],
            [9.080208187608521, -1.0228292876072327],
            [9.089325467560778, -1.0324811608998474],
            [9.060010733647049, -1.097335354327396],
            [9.053467660503342, -1.1093408926604367],
            [9.031504049135572, -1.1534972916338908],
            [9.010562879119531, -1.1967861762147802],
            [8.998324082858314, -1.2136035791389692],
            [8.983587122338529, -1.2368550302997257],
            [8.981749911574324, -1.2541636985470788],
            [8.971195040602028, -1.3112054799811597],
            [8.893674193986783, -1.3142802592697442],
            [8.796794063079497, -1.3175644737892473],
            [8.802936569120547, -1.3006920398519648],
            [8.748301077969469, -1.2523233880575793],
            [8.726654540619558, -1.1941282376737823],
            [8.718722869852789, -1.1522349227299635]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.28061900445292, "lat": 37.1041643162255 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21001"],
        "coty_name": ["Adair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adair County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00516847"
      },
      "bbox": [
        8.718722869852789, -1.3175644737892473, 9.089325467560778,
        -0.9174993408334202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.68260568885015, -0.1312323363858351],
            [8.68258497615124, -0.14254584443825122],
            [8.679375673376082, -0.14443336611206],
            [8.677314726416963, -0.14853975652681534],
            [8.66656444462853, -0.1493514291059287],
            [8.658760289747097, -0.15675802069469402],
            [8.653798115235555, -0.15696073098776536],
            [8.629999236811893, -0.24428356316460886],
            [8.626332680660482, -0.24632546874226888],
            [8.650094951852452, -0.264633333254164],
            [8.61804755285802, -0.29401693055279265],
            [8.62320620628057, -0.2961224747960306],
            [8.626849534613214, -0.3012127284559652],
            [8.626347879029737, -0.3057802018561665],
            [8.623310879432564, -0.31171928717558667],
            [8.614396538397608, -0.3195888484861953],
            [8.610568322435359, -0.332418423042956],
            [8.60587288904655, -0.33726862270691155],
            [8.602064113925875, -0.338683349844171],
            [8.598316469135323, -0.3371672925040604],
            [8.598623500201732, -0.34197738528049604],
            [8.593531219302381, -0.3467403463848226],
            [8.591518462154818, -0.3460202723561176],
            [8.584410307444017, -0.3561418915306073],
            [8.585811096027651, -0.3600859227561453],
            [8.586659551415556, -0.37029786926149083],
            [8.591719826763745, -0.37997112716158027],
            [8.585891302453186, -0.3884592433018503],
            [8.582554724010755, -0.3884878470135791],
            [8.578192218099243, -0.3929414526845584],
            [8.571312253568355, -0.39667558144055554],
            [8.567106238777733, -0.3963366732029249],
            [8.569445389162386, -0.401298490872312],
            [8.570694688414493, -0.40724946330814354],
            [8.56375653725645, -0.41661588767282376],
            [8.5588983872198, -0.417534405292581],
            [8.556994808955427, -0.42256820739800494],
            [8.554598657818602, -0.4242995453769127],
            [8.54779046314862, -0.4350242225341917],
            [8.53997399493893, -0.437205562634006],
            [8.541026189310271, -0.44083585507709305],
            [8.533902674921894, -0.44593936638474285],
            [8.524463074287226, -0.4483286256920263],
            [8.521572539754125, -0.4549792241053974],
            [8.519056312446141, -0.4527079574049613],
            [8.511183039687076, -0.45810908784821847],
            [8.507055337227623, -0.4626335514379052],
            [8.503852349577645, -0.45994896226182685],
            [8.50087403568924, -0.4603561347008595],
            [8.49021048514331, -0.46797986465461117],
            [8.4896535724261, -0.4655903969324621],
            [8.481566674160085, -0.4643694502929654],
            [8.47671851715583, -0.4653572620081748],
            [8.472953233402437, -0.4619523459519787],
            [8.473094826180565, -0.4570067792492328],
            [8.470017719507736, -0.45488010896433373],
            [8.465901929659045, -0.4546615376943638],
            [8.46546872146994, -0.4513942245967523],
            [8.457656155290337, -0.44728305888574826],
            [8.455551696574835, -0.44264146549706057],
            [8.450034730592929, -0.44075351441432514],
            [8.446366805135463, -0.4380448986344023],
            [8.436187088283623, -0.43814644414593307],
            [8.429147231171351, -0.43370751008638075],
            [8.425932278203083, -0.4288122578350961],
            [8.42330680572664, -0.42787432785145124],
            [8.423114527400571, -0.42322816815346037],
            [8.420657944168454, -0.42243244475956593],
            [8.416415686084703, -0.42569132764739365],
            [8.409816988758276, -0.42538159252453017],
            [8.408704820175132, -0.4220887064506064],
            [8.40416635403121, -0.41729845728831],
            [8.400376905847153, -0.41542052787071293],
            [8.391334686589559, -0.4060160316345575],
            [8.389165149651225, -0.40107233643309753],
            [8.389480809240881, -0.39539274076932596],
            [8.393194812491554, -0.392195066314238],
            [8.405868875674466, -0.3971066811196857],
            [8.409613217835249, -0.39413642715087965],
            [8.404864505552712, -0.387664757816974],
            [8.397376972968159, -0.3836870037611846],
            [8.395952142724237, -0.3709011221736447],
            [8.393317974658641, -0.3657190611700647],
            [8.388570692268454, -0.3638736148885955],
            [8.381567215978473, -0.36396799730339185],
            [8.377923055525637, -0.35986881311865404],
            [8.37863157490532, -0.3557944470587283],
            [8.375931329805457, -0.34825167275368324],
            [8.371265384255214, -0.3410362835945948],
            [8.36761702727186, -0.33920094193553946],
            [8.36086697950218, -0.3388643181651372],
            [8.356618635272437, -0.34091629743085633],
            [8.351551941915785, -0.33997223289014517],
            [8.341269087977537, -0.34962754014450975],
            [8.336709968518663, -0.35090305701212887],
            [8.332503168685175, -0.34802883419240105],
            [8.33322774072971, -0.3412866353492446],
            [8.331456860256514, -0.332801778244797],
            [8.331735318481364, -0.326002530056585],
            [8.333042065096619, -0.3205945604043592],
            [8.328867572348715, -0.30597016429033047],
            [8.326062334883794, -0.2992925003993332],
            [8.311359631124043, -0.29983563852003153],
            [8.306632155500697, -0.2989380838921737],
            [8.300770316148455, -0.2943577402933091],
            [8.30378866840947, -0.2955998076437173],
            [8.31165703028118, -0.28344912546369117],
            [8.318453955563278, -0.2802018731865447],
            [8.316954782561279, -0.27721342035269725],
            [8.318240221501291, -0.2702633232451591],
            [8.322717697054879, -0.2651787043667342],
            [8.324844124365175, -0.26056283076335596],
            [8.32907164422206, -0.25989457823594486],
            [8.339150195273936, -0.25083928616302265],
            [8.33936508022131, -0.24780720948289842],
            [8.34375420675941, -0.2460452730448891],
            [8.466261267031651, -0.1866347652941128],
            [8.588083004106718, -0.18698006392643252],
            [8.618482790180007, -0.16845640813409846],
            [8.644829688250553, -0.15410616208042272],
            [8.68260568885015, -0.1312323363858351]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.69590025238696,
          "lat": 37.970136360243195
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21029"],
        "coty_name": ["Bullitt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bullitt County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00516861"
      },
      "bbox": [
        8.300770316148455, -0.46797986465461117, 8.68260568885015,
        -0.1312323363858351
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.913768025325683, -1.7374129067011315],
            [5.918600307826366, -1.7316471018807669],
            [5.924585496480789, -1.728176352689287],
            [5.928175459271665, -1.7241981614275301],
            [5.962425693657834, -1.7320909071124402],
            [5.959162974895728, -1.746753279536881],
            [6.0108566390675575, -1.7441730650224132],
            [6.160127611704786, -1.7314489707822274],
            [6.157430205549602, -1.7368875035550477],
            [6.156402767456411, -1.7491471812608714],
            [6.16319322663927, -1.8089773589924536],
            [6.164586564391691, -1.822416184907551],
            [6.167565357218925, -1.8691167581975725],
            [6.173261660912118, -1.9443455479365577],
            [6.177934838899836, -2.0036243028055423],
            [6.169566674355, -2.0042194827302957],
            [6.163555999259991, -2.004613974938797],
            [6.1293099238148345, -1.9644535716484894],
            [6.1031833247435365, -1.9342126822031356],
            [6.095929912513688, -1.9356409074340495],
            [6.0890176848486535, -1.9359037154454606],
            [6.083879751637896, -1.9338381759791288],
            [6.0762279378987465, -1.9271241275030648],
            [6.072746862768626, -1.9217717675566588],
            [6.004622542152143, -1.926189924144985],
            [6.001103527830846, -1.922491566746522],
            [5.994499139619941, -1.9218784536910405],
            [5.987053363732842, -1.9169538348182733],
            [5.904984512266073, -1.8757869799746607],
            [5.883022291032329, -1.8759977610784626],
            [5.8903119436568, -1.8657013466847698],
            [5.894235860123664, -1.8591261186004575],
            [5.886192538151267, -1.8541006767223094],
            [5.885765041284933, -1.8403503749705628],
            [5.8843280334417365, -1.8370504763635083],
            [5.879750031312522, -1.8322383636003066],
            [5.871682068435148, -1.8254549762773176],
            [5.86164874855759, -1.8152697611169095],
            [5.858633562022027, -1.8114107429105069],
            [5.856690666307161, -1.8017091906811913],
            [5.85707017563872, -1.7931382035610022],
            [5.858270720701087, -1.7877963703953152],
            [5.862658808888942, -1.7795853421086079],
            [5.867759387229628, -1.7727230158243363],
            [5.871519149329639, -1.7699297022274327],
            [5.881283403088419, -1.765685356629964],
            [5.889383530946612, -1.7688099343415007],
            [5.901043957804165, -1.7685744879132728],
            [5.906670848831741, -1.7716209482463978],
            [5.91411469011194, -1.7713058735987297],
            [5.9190156019078906, -1.7627887219985827],
            [5.9205344880481645, -1.7548321191574228],
            [5.919721657734245, -1.7467460382043027],
            [5.913768025325683, -1.7374129067011315]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.97613068703343, "lat": 36.67813582356087 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21105"],
        "coty_name": ["Hickman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hickman County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00516899"
      },
      "bbox": [
        5.856690666307161, -2.004613974938797, 6.177934838899836,
        -1.7241981614275301
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.28494969250819, -0.8335462320250138],
            [10.289135163345502, -0.8311566147306908],
            [10.289831002895234, -0.8237317959172901],
            [10.293083072491198, -0.8242752210332919],
            [10.294818471190345, -0.8183167701991092],
            [10.302067402059194, -0.8150023461659945],
            [10.300364030770607, -0.8084102756826668],
            [10.30086283904241, -0.8037009725358384],
            [10.305639529125953, -0.8002275664435022],
            [10.298882734101172, -0.7989380465253069],
            [10.296624306344818, -0.7952355104454798],
            [10.298083249542254, -0.7878375677259304],
            [10.305790922798156, -0.7743936367587079],
            [10.313903356686344, -0.7706695433188916],
            [10.319920585197917, -0.7756561556811811],
            [10.321759332366073, -0.7738332898236754],
            [10.329295806242959, -0.775137126097833],
            [10.331013600072659, -0.7692191898544525],
            [10.33722739248915, -0.770952640021048],
            [10.338106007397483, -0.7667553907083915],
            [10.336024407163679, -0.7629966922266639],
            [10.337520958127438, -0.7578901488512759],
            [10.343722838121655, -0.7537544433152539],
            [10.344370233779664, -0.750189770012442],
            [10.351242102633316, -0.7449352918362241],
            [10.357343645024452, -0.7436229568339112],
            [10.360131745602695, -0.7413820095119055],
            [10.362717432487889, -0.748059551178461],
            [10.369019570614638, -0.7479439272609095],
            [10.369835943612838, -0.7513268505130108],
            [10.374703283658127, -0.7518423420277517],
            [10.379901270279559, -0.7501089826032082],
            [10.381663590272044, -0.7531505112755179],
            [10.381129875698559, -0.7581368360430076],
            [10.382828415035398, -0.7597485355122813],
            [10.386746333301774, -0.7541743220269707],
            [10.392368507080594, -0.7537748861264173],
            [10.397094006749288, -0.7551850354901152],
            [10.39895022528835, -0.7574669954734733],
            [10.396713973465214, -0.762583631728489],
            [10.399148659801131, -0.769162393403671],
            [10.405680401821048, -0.7693534479758236],
            [10.406384997670017, -0.7732543761139185],
            [10.409338364976069, -0.7743623645052419],
            [10.412931157094171, -0.7785139940045316],
            [10.410832530561565, -0.7844631818990299],
            [10.40959479625838, -0.7917546723971757],
            [10.411519745590274, -0.7946842805003042],
            [10.41689309729042, -0.797582663144539],
            [10.414776994455076, -0.801542674263844],
            [10.420585334064889, -0.8067968733769346],
            [10.421529467121754, -0.8096795080084895],
            [10.41815013580904, -0.8140156951867483],
            [10.4221465252877, -0.8158474469635308],
            [10.424552353655999, -0.819994880065067],
            [10.428207968984193, -0.8194251575418207],
            [10.429568185830409, -0.8247955913278009],
            [10.439566385975796, -0.8190915565743153],
            [10.44179785357767, -0.8239699920271489],
            [10.445613920463282, -0.8251840795009305],
            [10.446774090362618, -0.829441288688557],
            [10.451140799386735, -0.8330434091567026],
            [10.455172882356935, -0.8326693899552584],
            [10.455929309003741, -0.82930058140007],
            [10.460085293701272, -0.8291388228739092],
            [10.4638513365596, -0.836235943274859],
            [10.472239901822594, -0.8428775599195409],
            [10.481001787685354, -0.8436804665993131],
            [10.486833701091664, -0.8388230130525268],
            [10.492568428726335, -0.8472723465908449],
            [10.497004590707505, -0.8469404643008305],
            [10.504014998576992, -0.8495462167999875],
            [10.506992223814887, -0.8561533410185026],
            [10.510953773389762, -0.8555802116673018],
            [10.514408377610122, -0.8596356630895252],
            [10.51984677853446, -0.8588358735717432],
            [10.522296124307255, -0.8627132348354787],
            [10.527509373997948, -0.8634533038565811],
            [10.529352633580903, -0.8617997504672826],
            [10.533432419173957, -0.8707295664003188],
            [10.529188837544547, -0.8710679043728409],
            [10.525903530241061, -0.8734076883749257],
            [10.526212497328556, -0.8785313237893994],
            [10.523603025611113, -0.8815130171364334],
            [10.52085240359466, -0.8791557390178985],
            [10.517954684588156, -0.8811736878530047],
            [10.515553025309659, -0.8855593759931571],
            [10.5162954540656, -0.8894180637884893],
            [10.522238436432302, -0.8903178180989314],
            [10.523766902540315, -0.8950848766605708],
            [10.51779395083361, -0.9010355552459985],
            [10.519333663683845, -0.9043442620617737],
            [10.527210318040316, -0.9047051898162144],
            [10.528241903228958, -0.907446786508665],
            [10.535701640476276, -0.9089371316377154],
            [10.535890424533088, -0.9140076934253447],
            [10.539376047152508, -0.9152085218108869],
            [10.541054949357703, -0.9200945542587855],
            [10.544787809388005, -0.9196417482447747],
            [10.545256844340258, -0.9262474159973041],
            [10.54741736421342, -0.9275511029199037],
            [10.554297931288747, -0.9233955851860404],
            [10.55678096462188, -0.9284667649839929],
            [10.564781711398966, -0.9299198905434573],
            [10.56776559867554, -0.931576878816523],
            [10.570350456315577, -0.9389558896773076],
            [10.567615145224044, -0.94307572570771],
            [10.570427613684126, -0.9459612481360375],
            [10.565495584757898, -0.9500359016860974],
            [10.565031348806029, -0.954209928379771],
            [10.57005984913939, -0.9551573971062989],
            [10.570659889266837, -0.9584594950824875],
            [10.574494801912612, -0.9625214086942644],
            [10.57389884529375, -0.9693990616604654],
            [10.566860429092161, -0.9718941216407833],
            [10.56489609794908, -0.9788400720548007],
            [10.570333009519716, -0.9824433982805387],
            [10.565287149524421, -0.9861764711644276],
            [10.56564746072551, -0.9902069014511174],
            [10.568439135614401, -0.9911148635180056],
            [10.569323846763856, -0.9965626056703385],
            [10.563155958197536, -1.0015723619124253],
            [10.565483790486969, -1.00623345874554],
            [10.56610193427936, -1.014471110322547],
            [10.568699077521279, -1.0143042326951783],
            [10.569840565025682, -1.023650617925115],
            [10.566165304189202, -1.0303219038495806],
            [10.559812641775958, -1.027699902204548],
            [10.55751362709879, -1.0249052213145142],
            [10.555255457638792, -1.0329476035038245],
            [10.54874420330233, -1.0352045674002983],
            [10.545390802551765, -1.0334385790713327],
            [10.540457212510518, -1.036467419093521],
            [10.536477507036519, -1.0343589169218343],
            [10.533388021458881, -1.0378061883868241],
            [10.53244335046103, -1.0455497003074747],
            [10.528336277842584, -1.0560408483671748],
            [10.514682549857232, -1.0747503284604243],
            [10.501908412385747, -1.0846153883713496],
            [10.492117416076805, -1.0948619675165594],
            [10.468362659929575, -1.1097467057847732],
            [10.422763174565906, -1.1309182081492484],
            [10.42193815069372, -1.1347476514951242],
            [10.416190412505106, -1.1386004080267231],
            [10.411575230964004, -1.1374601450674526],
            [10.410035474952224, -1.1425904302366519],
            [10.412786500950958, -1.1486436896438397],
            [10.412087203978453, -1.1517870263934866],
            [10.415921584124874, -1.1527341163422233],
            [10.417290631516181, -1.158940989135813],
            [10.414042849760369, -1.159830306357178],
            [10.41091243513452, -1.1666226852608164],
            [10.408643817426393, -1.1691531932578563],
            [10.399603271779126, -1.1716311008783422],
            [10.396860194305452, -1.1711234443710867],
            [10.38970724599361, -1.1731411505894107],
            [10.388173567585353, -1.1677930861489285],
            [10.378492387336658, -1.1736570232063939],
            [10.373181355601147, -1.1729569781309679],
            [10.372174110895461, -1.1810782704845895],
            [10.365873426927257, -1.1787341188155585],
            [10.363647231920272, -1.175904240619613],
            [10.357091781833015, -1.1740911658556057],
            [10.354350941033053, -1.169991251501248],
            [10.35207034897968, -1.1723645762833796],
            [10.346071360001023, -1.1744634067711297],
            [10.344194984798525, -1.1724217201160991],
            [10.33627121953269, -1.1734762192398784],
            [10.332604888596563, -1.171157803231043],
            [10.332085287972063, -1.163472565817846],
            [10.335564496094069, -1.1626102600893184],
            [10.33590356198332, -1.1595340618136667],
            [10.342395630424326, -1.1564806554203932],
            [10.34117852213154, -1.152084984791521],
            [10.337500994315796, -1.1486574247348977],
            [10.333337539341006, -1.1490035320465397],
            [10.331279429236178, -1.1454246466768938],
            [10.325050563940664, -1.1464812644723033],
            [10.322806059581412, -1.1418149044844128],
            [10.323361336148805, -1.1312942151316072],
            [10.304483082821523, -1.0727139215487087],
            [10.313357108384228, -1.0663658926305595],
            [10.307223389967698, -1.0575420936385307],
            [10.307385760809229, -1.0541826647059753],
            [10.302702921121433, -1.0497513299943095],
            [10.298745300165638, -1.0500660178275862],
            [10.29438352491418, -1.04306958264974],
            [10.291641084518046, -1.0359693521715492],
            [10.286747370633552, -1.037614652102019],
            [10.28500855023532, -1.0304094272730453],
            [10.279300979568571, -1.0301178937991882],
            [10.280174536264733, -1.0249012382805058],
            [10.282807421639552, -1.0256407542702335],
            [10.285051039167412, -1.0222371853256575],
            [10.28247114116277, -1.0178117085828478],
            [10.284244435207906, -1.0146523866525377],
            [10.281618173921318, -1.0113368342329707],
            [10.283138452817251, -1.0075418392219828],
            [10.28236700909499, -1.002701750798972],
            [10.27628724243926, -0.9930828900174158],
            [10.27025413106407, -0.9949560378347775],
            [10.28106646204961, -0.9692801834808624],
            [10.266468979133096, -0.9549518163082655],
            [10.260027395848219, -0.9064585126385303],
            [10.291308424366527, -0.8649530363872142],
            [10.269116549471986, -0.84034037102269],
            [10.28494969250819, -0.8335462320250138]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.38118475568301, "lat": 37.09397720454382 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21131"],
        "coty_name": ["Leslie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leslie County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00516912"
      },
      "bbox": [
        10.260027395848219, -1.1810782704845895, 10.574494801912612,
        -0.7413820095119055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.359664334778106, -8.201819639739139],
            [3.3981225021983645, -8.201057697725945],
            [3.4789532541904666, -8.198225520834203],
            [3.5280762871582265, -8.196653346939506],
            [3.5320091401950977, -8.196691828820216],
            [3.5732668504780967, -8.19520413618497],
            [3.595969411599309, -8.194157977798357],
            [3.6688367438535696, -8.191122774440469],
            [3.6924955244271893, -8.190450594118719],
            [3.6946864399742214, -8.233554297894928],
            [3.7529794747520406, -8.231080037832474],
            [3.754776673572695, -8.26711203624971],
            [3.7570644596827205, -8.31739485458912],
            [3.7718369222428656, -8.316597730438984],
            [3.773151592375568, -8.345430459485064],
            [3.787736396667357, -8.344872376891066],
            [3.7880473342249865, -8.36662916564786],
            [3.7886756462285174, -8.380758187025936],
            [3.773698805213614, -8.381255441206076],
            [3.77447691930216, -8.395734557892702],
            [3.759832049965114, -8.396120693961588],
            [3.761166381913, -8.42496689650257],
            [3.731737466283317, -8.425324419614505],
            [3.7326258068386515, -8.440692682503165],
            [3.7287586059722515, -8.444955879060503],
            [3.725203512790041, -8.446642614761119],
            [3.719249174432344, -8.446492158471651],
            [3.7121139695390224, -8.448114697629167],
            [3.7004690465357895, -8.457142337911677],
            [3.7010746141722537, -8.460845315551039],
            [3.6985456738165285, -8.464990870578152],
            [3.7017242920769937, -8.473522135818923],
            [3.7002086415005087, -8.478307919528374],
            [3.7028359243739644, -8.482408354304644],
            [3.698373766941067, -8.49235444202676],
            [3.6994076640047497, -8.497198841183708],
            [3.695926229719183, -8.500263663943718],
            [3.691879237908515, -8.501477962842621],
            [3.6896638170439653, -8.50675300725037],
            [3.6807004538366974, -8.516433828426594],
            [3.6762535463461634, -8.5233288413227],
            [3.6712505209802666, -8.521317336709837],
            [3.665330894075858, -8.523203178191846],
            [3.662852241947963, -8.52797765234775],
            [3.6623243931050857, -8.532541945922038],
            [3.655332387587957, -8.540215142815226],
            [3.6496807821540385, -8.543135807650904],
            [3.6454530284076805, -8.544019501270549],
            [3.638977246149581, -8.547983725850443],
            [3.6391879821815207, -8.55453862958503],
            [3.636040558709768, -8.5562048598723],
            [3.6339171668007038, -8.56076092352394],
            [3.632642632756033, -8.567709054359192],
            [3.627397788231393, -8.56931023453331],
            [3.620544644678169, -8.576873597636583],
            [3.6210284083549054, -8.583173489231791],
            [3.610243117530195, -8.58925712029919],
            [3.6043710555688735, -8.594698660848707],
            [3.6039687092234156, -8.5972431694776],
            [3.5989160194170684, -8.600140716071905],
            [3.5954041472780127, -8.604353864858552],
            [3.5836245264983435, -8.611042371445222],
            [3.5757787523485565, -8.61100987226971],
            [3.5690989536400637, -8.617801942749923],
            [3.5603533808011822, -8.619596556664996],
            [3.5566332743481888, -8.622436484415843],
            [3.552958750980939, -8.622979376041416],
            [3.549099509718364, -8.62062065598936],
            [3.540028774223897, -8.618005224035445],
            [3.5298796417741904, -8.616298350000797],
            [3.5260370381137185, -8.613618927432103],
            [3.514718784725111, -8.611851266730643],
            [3.5121394929892036, -8.609231725678166],
            [3.50238883257887, -8.606564764026764],
            [3.4957421521950813, -8.600722268919414],
            [3.4884472733430427, -8.598880246595973],
            [3.4862845757835093, -8.595893904212987],
            [3.4827987857499814, -8.595927618282516],
            [3.481455155037818, -8.592842968554919],
            [3.4708853900627954, -8.58681774240951],
            [3.470840168252464, -8.583730337976673],
            [3.4655787432823257, -8.581330042226817],
            [3.456996953844085, -8.568557041243825],
            [3.449470535735878, -8.56968916384357],
            [3.440265292156303, -8.566021043880871],
            [3.4411295174145904, -8.563469448494892],
            [3.4363776281536325, -8.561913832213222],
            [3.435240398959689, -8.565724561773946],
            [3.427845364928437, -8.567941875307366],
            [3.4258053700387006, -8.575100638736512],
            [3.419031021613576, -8.576205074652613],
            [3.4166747341859454, -8.580331106158582],
            [3.406454555890945, -8.58008281608006],
            [3.3976489791417355, -8.581124698206182],
            [3.3957043565335217, -8.583419515946217],
            [3.3916498336143657, -8.584132283364372],
            [3.388008063624622, -8.589870853275885],
            [3.3813834291516387, -8.588880490011837],
            [3.379112519786319, -8.586707498287788],
            [3.3851081583504365, -8.584378628012846],
            [3.382952374129532, -8.579781360315332],
            [3.3848626094730476, -8.574795229883232],
            [3.3798655973891107, -8.569190971402483],
            [3.377805954810826, -8.561548175206342],
            [3.3802526153248933, -8.557327598871252],
            [3.3758147104648875, -8.555536527552661],
            [3.375702898107881, -8.552421333383842],
            [3.380484319570409, -8.55088601694244],
            [3.3809731614035736, -8.546598257520351],
            [3.3749164618419516, -8.545824123660225],
            [3.3765211761276714, -8.538214301848445],
            [3.3799730413508833, -8.53596752028176],
            [3.3803374709317144, -8.531539159001445],
            [3.3866562750475926, -8.529446810775449],
            [3.3881662134394097, -8.523491432337293],
            [3.3920495257032943, -8.519771996469984],
            [3.3897195700350253, -8.515226267133778],
            [3.388188315910177, -8.507980375213352],
            [3.385247585384558, -8.504928544528697],
            [3.3946206421217524, -8.502703789855216],
            [3.3961849274537705, -8.499120225219885],
            [3.401703559109227, -8.499958533318722],
            [3.4055474973621354, -8.496559525106742],
            [3.404322495946501, -8.492932900201026],
            [3.405605659577638, -8.486617443187281],
            [3.4025456918990313, -8.486041111880503],
            [3.4020764498008167, -8.48207724515236],
            [3.4054642630196885, -8.48024530367409],
            [3.4049197281161523, -8.477494264605873],
            [3.4096536201896304, -8.475570706855324],
            [3.4027814859779286, -8.471821135128264],
            [3.396285552581907, -8.473822569843168],
            [3.3912001587954963, -8.470918718660831],
            [3.391312388963149, -8.469029447837503],
            [3.386200078038044, -8.466634694958252],
            [3.383571845909195, -8.455799696587007],
            [3.376532200218964, -8.452710822997963],
            [3.373201401934199, -8.450101789122233],
            [3.376386639167315, -8.438717371312203],
            [3.3733611015747695, -8.435388621318639],
            [3.375472989182723, -8.426814159135754],
            [3.374475125465777, -8.42255438071543],
            [3.374167032833037, -8.413497343992418],
            [3.3723137695650576, -8.406722162348146],
            [3.3737907636255553, -8.399420218075504],
            [3.371823012599074, -8.388967867023963],
            [3.371839674241998, -8.382921472067096],
            [3.3699325653424927, -8.381259080831498],
            [3.3750409510131782, -8.373099748963343],
            [3.36919480203196, -8.368123746109411],
            [3.3678671082933773, -8.36341914857139],
            [3.370538653651837, -8.357803428767642],
            [3.370709610539763, -8.35375111400856],
            [3.376091758839282, -8.350693624432978],
            [3.3764366475273953, -8.345158257425156],
            [3.3731901966613567, -8.338590722780149],
            [3.368055516545007, -8.334588663199023],
            [3.3689541489500496, -8.325498448344755],
            [3.3665044001261997, -8.319938640642375],
            [3.3699827337477597, -8.31549863493926],
            [3.3653700554653656, -8.310581952111358],
            [3.364351952425125, -8.307420616307652],
            [3.368338777702324, -8.299443976638859],
            [3.3728381539624745, -8.298942502929911],
            [3.3767817890198883, -8.296526942726441],
            [3.384396100202606, -8.294726535218288],
            [3.385291125411997, -8.283149396252881],
            [3.387223759883807, -8.27994208112097],
            [3.3851966169076593, -8.274329013395032],
            [3.389634009357433, -8.265437183478202],
            [3.3886652263571633, -8.262629925457366],
            [3.3914361100365684, -8.258664238804524],
            [3.3911933809014827, -8.252623365298332],
            [3.3860565414519965, -8.247325193532303],
            [3.386363127254335, -8.242608093483973],
            [3.380894501685537, -8.240665103033514],
            [3.3812900002821653, -8.23778543762541],
            [3.3739788537624316, -8.229653549724029],
            [3.3710153761181463, -8.228326035338462],
            [3.368282393470119, -8.22075840172219],
            [3.369408732498053, -8.21792030644085],
            [3.3653703708353766, -8.216655170469794],
            [3.365093693193794, -8.213957687627662],
            [3.359664334778106, -8.201819639739139]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.41196060601082,
          "lat": 30.290591214732995
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22001"],
        "coty_name": ["Acadia"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Acadia Parish"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00558389"
      },
      "bbox": [
        3.359664334778106, -8.622979376041416, 3.7886756462285174,
        -8.190450594118719
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4076233919940666, -8.30729791007027],
            [2.41053105024224, -8.30624970504532],
            [2.413336229720011, -8.301843953477105],
            [2.414017707561076, -8.295286521813981],
            [2.4185219636519637, -8.296556628799223],
            [2.420112345803331, -8.290722282376793],
            [2.419767860476476, -8.28053201062487],
            [2.4230400163869223, -8.27805233434192],
            [2.4258806216185316, -8.283235513569647],
            [2.4330791757723356, -8.276770276180612],
            [2.4357291338675586, -8.279580355072456],
            [2.4407775369671847, -8.278795203521875],
            [2.4391580080159025, -8.275431009083379],
            [2.4432801979724346, -8.272334033711372],
            [2.4439322487458224, -8.2648278933558],
            [2.4385338625864312, -8.266752402004595],
            [2.4360513300545876, -8.264019591953588],
            [2.4405492304721528, -8.260117120190667],
            [2.4362574278567197, -8.254682892905826],
            [2.4367031725394304, -8.251894854959207],
            [2.442635911762943, -8.251979084176748],
            [2.4364586124909406, -8.243208226123313],
            [2.4316877199403546, -8.240809380935914],
            [2.432689394329382, -8.234773025304458],
            [2.4271637968131645, -8.228513010007687],
            [2.428748087004276, -8.225207530962399],
            [2.432663653916725, -8.224104334236824],
            [2.4269481734060507, -8.216548912800937],
            [2.4287357319847622, -8.212840581768978],
            [2.4280910701115563, -8.209317056871544],
            [2.4326224335546645, -8.204007331843368],
            [2.4346292181525473, -8.199119689530873],
            [2.4319288934593026, -8.197421043171023],
            [2.4314114918150223, -8.192910007111776],
            [2.4265171179664424, -8.191532316003133],
            [2.422947678466941, -8.186559841774933],
            [2.4166966054110954, -8.185375475380734],
            [2.411354992507347, -8.179821176614947],
            [2.412027192881934, -8.174608834034402],
            [2.4062852292883417, -8.173350090878793],
            [2.4065564034565186, -8.170576226984954],
            [2.414984528470935, -8.16638428469733],
            [2.4131586946875596, -8.158007547364615],
            [2.4191361570746706, -8.152023021313022],
            [2.41569726852897, -8.144896755919719],
            [2.4169492328127404, -8.141513744018498],
            [2.415431427189185, -8.137377505499371],
            [2.420354969744671, -8.131054002325873],
            [2.423872881970542, -8.13350817116115],
            [2.4271433231663995, -8.130932318812604],
            [2.4273425926683867, -8.123859081208819],
            [2.4304111493576586, -8.12232793981188],
            [2.436156175662302, -8.12229191494615],
            [2.438198326009353, -8.119057039381287],
            [2.444973568671984, -8.116513384127236],
            [2.449425719256533, -8.120618556838084],
            [2.457178293538336, -8.11650200174451],
            [2.456547626120812, -8.110891450153881],
            [2.452772319628326, -8.102768017381498],
            [2.4477655136469236, -8.09954858109646],
            [2.4505892087733203, -8.094505500519533],
            [2.453728432252049, -8.09227967988866],
            [2.450873507070515, -8.085780130788873],
            [2.4510850111844285, -8.080207033664147],
            [2.45442496456332, -8.074478837077544],
            [2.4522278087419083, -8.070298875129],
            [2.462717332439084, -8.058267686391778],
            [2.462740617333153, -8.052897986385894],
            [2.4676203722048373, -8.049114833952242],
            [2.4717428877816148, -8.048689748312995],
            [2.475637170918024, -8.040520713123938],
            [2.481460101500468, -8.042764110346313],
            [2.483798018401827, -8.03713370697313],
            [2.4899400171379864, -8.037316392735725],
            [2.4916247337497177, -8.034239594241557],
            [2.4968948954438175, -8.030311672797342],
            [2.499003010272569, -8.022840256247525],
            [2.504658093838449, -8.01592212972922],
            [2.5010291358026944, -8.0092148709938],
            [2.5041185250684905, -8.006120501615964],
            [2.5049570269890404, -8.00131617629121],
            [2.507629275423661, -7.997824743291807],
            [2.5067946723711114, -7.991696248021715],
            [2.5119831542829765, -7.992090610467606],
            [2.51326767688508, -7.9870076340527705],
            [2.5120431620347765, -7.975974430686985],
            [2.505901198753428, -7.9719557825834775],
            [2.5045770045012863, -7.9684945789605415],
            [2.5081539396298966, -7.966097519789642],
            [2.5123808456454166, -7.965666562772448],
            [2.5136733438213943, -7.962469934750281],
            [2.507953628152, -7.954438854182633],
            [2.5147487526636443, -7.952190723365024],
            [2.516208074026876, -7.948352996665446],
            [2.527190253349614, -7.946398442981061],
            [2.5275635037683553, -7.9428598248130005],
            [2.5257690526615253, -7.937891497092463],
            [2.528721357588377, -7.93236882815367],
            [2.533901479833506, -7.932945815849241],
            [2.533299763353038, -7.92887222919518],
            [2.5289358012637333, -7.923506390751663],
            [2.53378002567189, -7.9223056841934],
            [2.5356556775334824, -7.91841884282663],
            [2.533063283472684, -7.913481186862476],
            [2.534642345282331, -7.907029577382947],
            [2.5411541039922083, -7.908597836371677],
            [2.545715286895383, -7.9068968046116295],
            [2.5524081286540476, -7.902148924979408],
            [2.5497416238724555, -7.892317166215667],
            [2.5577444672125322, -7.886442313919635],
            [2.5554492558545605, -7.881024141162568],
            [2.558809198974789, -7.876616312795082],
            [2.5542940685672453, -7.869912069323473],
            [2.545829110092114, -7.867094493625832],
            [2.554716490450013, -7.8578709307900345],
            [2.5506214697379477, -7.851763430114712],
            [2.5530405766585207, -7.841332492293742],
            [2.5563568945836175, -7.837842023997094],
            [2.556386999222673, -7.832606936305168],
            [2.5708002891608857, -7.828594861393908],
            [2.578808341234896, -7.829872672211847],
            [2.5833298808163843, -7.833598131290574],
            [2.5884848982477213, -7.83360299239114],
            [2.598014409916245, -7.841410489342178],
            [2.600521285386247, -7.839336835645188],
            [2.60313119395788, -7.843759754467632],
            [2.6116033506428455, -7.84251494203825],
            [2.6167755033479065, -7.844674085043202],
            [2.6217914240602194, -7.849077920455016],
            [2.631998800735554, -7.844107466960681],
            [2.632136586235548, -7.842259368797907],
            [2.6388714640250157, -7.841414364625381],
            [2.6448028637164405, -7.836577168956228],
            [2.650143863993853, -7.8344603619221855],
            [2.6580319105472663, -7.825624286360371],
            [2.660600830848818, -7.827623787855976],
            [2.667549447144259, -7.823721434392007],
            [2.6701072731289073, -7.8243086672246065],
            [2.728201353138289, -7.822531503861468],
            [2.8292439155891427, -7.819656405933416],
            [2.8557389486691815, -7.818549477522218],
            [2.9013392354323932, -7.816970079992249],
            [2.9159784728037823, -7.817015009677118],
            [2.916240589095122, -7.8223338404989375],
            [2.9725042794284096, -7.819605397417598],
            [3.0055688772308033, -7.817700289885905],
            [3.0490606809036653, -7.817895283397353],
            [3.0512627292987835, -7.863141670590182],
            [3.0521618576667064, -7.86315408111577],
            [3.05440251604602, -7.943500492718872],
            [3.056923216248959, -8.06705628900644],
            [3.0576225919914104, -8.09592183251288],
            [3.0142913430741753, -8.096804828145348],
            [2.9503500113370027, -8.09931504657629],
            [2.927460446233406, -8.099818895816494],
            [2.9282608231113088, -8.126846709555032],
            [2.929482987522771, -8.178975618562346],
            [2.932374979324386, -8.272841201039052],
            [2.9329364873794406, -8.293191680068228],
            [2.8454782401765133, -8.29583176237029],
            [2.714370159082732, -8.299829248273568],
            [2.7135245976424014, -8.242899402288257],
            [2.712576268807228, -8.21307159081909],
            [2.6250547091856764, -8.215055338366884],
            [2.6275286830889466, -8.302258356096216],
            [2.5702222530786933, -8.303366757955665],
            [2.5394484887208524, -8.304113544908502],
            [2.535708724159037, -8.304487037924767],
            [2.506625945766723, -8.305261500357414],
            [2.5036443205585877, -8.30507332499114],
            [2.4690532219043293, -8.30623509517221],
            [2.4570795286264366, -8.306339257592787],
            [2.407665061845845, -8.307742191424312],
            [2.4076233919940666, -8.30729791007027]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.34335555248788,
          "lat": 30.648530431835006
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22011"],
        "coty_name": ["Beauregard"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Beauregard Parish"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00558436"
      },
      "bbox": [
        2.4062852292883417, -8.307742191424312, 3.0576225919914104,
        -7.816970079992249
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.4211142475382035, -9.503899597424544],
              [5.428637646824455, -9.500240198743768],
              [5.429568753841976, -9.503568974410818],
              [5.42289463858676, -9.506118248374145],
              [5.4211142475382035, -9.503899597424544]
            ]
          ],
          [
            [
              [5.398961143573905, -9.39025971109252],
              [5.401857483772579, -9.389987799322373],
              [5.399544671897703, -9.396477122798126],
              [5.396950634380828, -9.393145141302776],
              [5.398961143573905, -9.39025971109252]
            ]
          ],
          [
            [
              [5.393179804159794, -9.468696468401387],
              [5.39496095866935, -9.467157611272727],
              [5.402985420542584, -9.465559349000731],
              [5.401493210439769, -9.470156683984],
              [5.396730608591733, -9.471446044003395],
              [5.393179804159794, -9.468696468401387]
            ]
          ],
          [
            [
              [5.3817105077991005, -9.463228172477663],
              [5.391235915689337, -9.458862754839275],
              [5.39873092521654, -9.453712879977683],
              [5.398993333640169, -9.442525682992256],
              [5.4028674977796785, -9.442912346530159],
              [5.40961402172045, -9.4462203898034],
              [5.409681417160488, -9.450610126928257],
              [5.406480452575484, -9.454487962654749],
              [5.397281904187773, -9.459025651337075],
              [5.384256455352393, -9.463991493184444],
              [5.3817105077991005, -9.463228172477663]
            ]
          ],
          [
            [
              [5.343667097579161, -9.368514893942415],
              [5.345474080279047, -9.3706387603738],
              [5.344024524217213, -9.374512868614413],
              [5.343667097579161, -9.368514893942415]
            ]
          ],
          [
            [
              [4.890999086910184, -8.705146649943103],
              [4.97763583969804, -8.69827217333904],
              [4.9765692017468925, -8.684349525722512],
              [4.982660485334083, -8.683708461480622],
              [4.985910470280386, -8.688048372937452],
              [4.990558536049332, -8.688770467863744],
              [4.997618819612597, -8.691686455137967],
              [5.000995196168101, -8.691668730696001],
              [5.008719023525448, -8.696277651262022],
              [5.017226859404308, -8.699180171574433],
              [5.025425666315774, -8.698188750942272],
              [5.031487199860144, -8.695919756098863],
              [5.036370972220726, -8.700255012942565],
              [5.037115501579163, -8.705807542574362],
              [5.0441725424219195, -8.70466408047367],
              [5.043331567885159, -8.701595087201028],
              [5.051033876935275, -8.69835141790743],
              [5.053773961636686, -8.701019304674457],
              [5.060346957939351, -8.69646565553668],
              [5.062155271800004, -8.70199301361809],
              [5.066009857475364, -8.702655706877803],
              [5.0690444431033646, -8.708119852745815],
              [5.073470791928749, -8.707506991546348],
              [5.080055235384289, -8.71067417673888],
              [5.086471578609965, -8.709306081246554],
              [5.090316844106389, -8.7102505676096],
              [5.095103005353166, -8.707470300892421],
              [5.1081818196937565, -8.703728520695899],
              [5.113484366421528, -8.703028880208324],
              [5.118181012766693, -8.703914590217948],
              [5.12421412919644, -8.707390682549633],
              [5.128457325796956, -8.706279781024831],
              [5.131283990349575, -8.714057217203798],
              [5.13660286354413, -8.711608320900094],
              [5.139964312380551, -8.706542158390157],
              [5.144427501654104, -8.703574934353842],
              [5.157335577384871, -8.702424199991176],
              [5.1794286691668345, -8.701190036125418],
              [5.194770393721619, -8.70257497582249],
              [5.200148368669101, -8.70827795624571],
              [5.2055054690802605, -8.71839910736275],
              [5.213320038916949, -8.727612281023648],
              [5.218222962722538, -8.728780817439551],
              [5.223466332938734, -8.726615173320337],
              [5.2278806514314855, -8.726449661102064],
              [5.2365587902090835, -8.731699167505253],
              [5.239719438671397, -8.737580688257557],
              [5.24531456481005, -8.742970337870709],
              [5.2455417725067015, -8.750994473863235],
              [5.248767889480032, -8.757863122902167],
              [5.249735667586193, -8.765009939961729],
              [5.249211178717416, -8.76911180586014],
              [5.250882686403791, -8.776792335985311],
              [5.2544454973441725, -8.779447329933774],
              [5.256407408336632, -8.784071530432634],
              [5.262703140598876, -8.788119012301818],
              [5.2679106050618, -8.79346796865974],
              [5.277380039647442, -8.797581664138763],
              [5.284818408995266, -8.804642786790296],
              [5.292751386368848, -8.81055810044846],
              [5.302209176092556, -8.810707496348835],
              [5.3108374541956165, -8.813659670855431],
              [5.314587449174538, -8.811507897869356],
              [5.3260117952211345, -8.817508779377423],
              [5.336025300558123, -8.819122524707568],
              [5.341287972641965, -8.821374916636215],
              [5.34391264481647, -8.824561043279823],
              [5.344050885547786, -8.832501218693288],
              [5.345590424772715, -8.837384855770141],
              [5.351688736745133, -8.8411939005489],
              [5.354915388536013, -8.845888084993298],
              [5.3530876803917, -8.851671012116094],
              [5.356169911174914, -8.858251020389838],
              [5.355688800264709, -8.873218380107337],
              [5.356604523316303, -8.876298686514916],
              [5.36354072023493, -8.884175313964386],
              [5.370168746441618, -8.888317568661874],
              [5.396419022168203, -8.88761442703669],
              [5.472552455410466, -8.883491592747642],
              [5.494749998933169, -8.882771078353217],
              [5.501211843438361, -8.883273144689232],
              [5.507986384409114, -8.891373767714645],
              [5.51196815015422, -8.892417135436043],
              [5.518315205678306, -8.88955507826152],
              [5.523144311567436, -8.888859179991659],
              [5.528925426024865, -8.895031899895177],
              [5.536150490402184, -8.894003552184872],
              [5.534919675412232, -8.899289929150815],
              [5.535028680418181, -8.904978882949212],
              [5.5372983643277855, -8.909113426915484],
              [5.537756463581557, -8.91381054393562],
              [5.534778087220747, -8.918015519614311],
              [5.5334698799273685, -8.925158367515223],
              [5.5353623633614815, -8.930610482175409],
              [5.535568109340048, -8.938386559059552],
              [5.534808018023917, -8.947655494931462],
              [5.536242537144384, -8.954331664660566],
              [5.53894544378995, -8.95716882297724],
              [5.538701506323548, -8.961275949185088],
              [5.542605276301296, -8.960280254952707],
              [5.54362932925736, -8.963714271719436],
              [5.540403942991785, -8.967995714873354],
              [5.544335566614713, -8.9706251689779],
              [5.542761512928618, -8.976041353634496],
              [5.545204028093387, -8.982216678085134],
              [5.535807538061253, -8.988859265573396],
              [5.534721375851175, -8.992948568580474],
              [5.540832201060658, -8.996547134415176],
              [5.540456263006652, -9.000161673923126],
              [5.534063974094863, -9.003300328329036],
              [5.526549454715917, -9.003852135476569],
              [5.516810900749362, -9.008217404751127],
              [5.512316412476535, -9.014429945299266],
              [5.512246517518533, -9.018984395267964],
              [5.5146328020796895, -9.023376443271516],
              [5.517918515644603, -9.025642783717545],
              [5.528448297983049, -9.027749267387302],
              [5.531482878489795, -9.031419604887862],
              [5.536183548369067, -9.043496486751584],
              [5.54254968745287, -9.053010527570224],
              [5.551269144257413, -9.064094166726496],
              [5.55487822568855, -9.067557967216569],
              [5.559314146879437, -9.076684690869516],
              [5.561747444135897, -9.086228704382997],
              [5.564369623826468, -9.090598746130691],
              [5.575678391159103, -9.096789635839592],
              [5.5853921921333995, -9.100669768952494],
              [5.602119986239779, -9.103861018370075],
              [5.610162083176295, -9.102296298320827],
              [5.614630505774209, -9.09864594488905],
              [5.619506218980329, -9.099126092933517],
              [5.624481782431029, -9.102547778333015],
              [5.631601213757599, -9.104284605335762],
              [5.6377011055825035, -9.101593689451875],
              [5.642215031188866, -9.101287664542747],
              [5.642958946770391, -9.10745211720061],
              [5.648096371030003, -9.110045214882796],
              [5.653210774296636, -9.114149932148099],
              [5.649281737327532, -9.116324452331972],
              [5.6493954656973, -9.118744868683311],
              [5.653778787053202, -9.125478378701967],
              [5.661308232662158, -9.129427586830179],
              [5.6673499666746325, -9.12977321215587],
              [5.668990820879437, -9.132330941826062],
              [5.666083930031354, -9.147521033455018],
              [5.6601807805268205, -9.16767540424576],
              [5.6641920795967335, -9.173126561126162],
              [5.662778520022233, -9.17624236201062],
              [5.6651047949128275, -9.181076960197672],
              [5.663510154549059, -9.185543090202907],
              [5.65793543662259, -9.188184781868108],
              [5.653471051401787, -9.193069403641038],
              [5.65465547779209, -9.200267572523696],
              [5.657997540359351, -9.203849370440276],
              [5.660834079688055, -9.203065590306936],
              [5.661138096030831, -9.210244560018886],
              [5.665738819038711, -9.215155415923567],
              [5.664542845990672, -9.215883505312169],
              [5.659568748148785, -9.227718902964813],
              [5.659971813865296, -9.237321985492454],
              [5.662466756165126, -9.24554340641299],
              [5.661656806035708, -9.2507389329231],
              [5.66449072690258, -9.256094867443641],
              [5.672911654623659, -9.25782588416967],
              [5.680828131905076, -9.258153152275387],
              [5.684103262355582, -9.26389105857143],
              [5.679618432421022, -9.271751473137469],
              [5.67506562860492, -9.275312062495223],
              [5.667938415494865, -9.277598941511844],
              [5.65444330030501, -9.2745419605611],
              [5.6457873974881085, -9.265857363662372],
              [5.62967602798573, -9.265724610336175],
              [5.617772099079189, -9.277931195884264],
              [5.6129685459937555, -9.287446307270459],
              [5.6068479502151005, -9.289255796425879],
              [5.603084648088916, -9.297989441353124],
              [5.6055443552218644, -9.309006536522357],
              [5.611262279804335, -9.31562357767252],
              [5.612132655846145, -9.322844847225054],
              [5.627470544597149, -9.331944722172643],
              [5.634685998296607, -9.34082588651533],
              [5.636265594904226, -9.348919255998258],
              [5.63932593159726, -9.351893234457],
              [5.64540701333169, -9.35148003682556],
              [5.646121675206939, -9.35543292098885],
              [5.639781135137008, -9.359180073278866],
              [5.629687874069845, -9.369728112701665],
              [5.628306227704208, -9.375860816411574],
              [5.6236412158829445, -9.379825237817743],
              [5.626932144732643, -9.383254268288317],
              [5.627752162730121, -9.387367460572024],
              [5.625980451532783, -9.393484841159273],
              [5.620293665727617, -9.397875055251014],
              [5.6028638649872295, -9.413601044208148],
              [5.557804341564446, -9.448737662772958],
              [5.5500956524629865, -9.455355848465963],
              [5.544525049334515, -9.461602004470087],
              [5.539445311791193, -9.465010947783487],
              [5.513875781630891, -9.479170448431871],
              [5.4983749796306505, -9.474358641256414],
              [5.493363825202493, -9.474146010890832],
              [5.4913018402366, -9.471090262805932],
              [5.4933676240916745, -9.465739056262274],
              [5.488881135882385, -9.459936191634219],
              [5.491833872931442, -9.457731717961678],
              [5.49908550588119, -9.45883516586834],
              [5.502547068436794, -9.456945398387594],
              [5.5025841743185095, -9.446323845009069],
              [5.501274684527008, -9.438699346969186],
              [5.495576023350725, -9.43731353501218],
              [5.492941803605772, -9.431805053833164],
              [5.488285208915231, -9.430050261126459],
              [5.4704489624176516, -9.430253322110504],
              [5.462587453203079, -9.427185972278977],
              [5.466732200361879, -9.42519646827702],
              [5.474970511693336, -9.427166607705123],
              [5.4833784012263225, -9.425127420156763],
              [5.488874893044296, -9.421415756469585],
              [5.485416270095287, -9.417625869146308],
              [5.47849259212523, -9.413324635483821],
              [5.468668364718351, -9.4143200769154],
              [5.467601307779427, -9.410488639832156],
              [5.47780653585076, -9.403833301180251],
              [5.477967812647793, -9.397981817233342],
              [5.473423253204717, -9.396818820203757],
              [5.4628121085877845, -9.400217169196877],
              [5.461512942967014, -9.395990315137421],
              [5.4586370034897245, -9.393189470609784],
              [5.4539423597241825, -9.392955833151088],
              [5.457471737378578, -9.38772478146961],
              [5.462077968933758, -9.38991020746846],
              [5.464054295445954, -9.395019362051533],
              [5.4697149511976715, -9.392325719283658],
              [5.475068582821859, -9.384627475919045],
              [5.474780790431294, -9.3799311971723],
              [5.471810728867717, -9.378980315345052],
              [5.475339338792727, -9.370366913001057],
              [5.467221611156709, -9.371978934195255],
              [5.463516044994785, -9.37161581633161],
              [5.465340603827254, -9.36502032675354],
              [5.459433004314329, -9.360248108270653],
              [5.455212681120691, -9.349023083244653],
              [5.4498921294138825, -9.346088049159167],
              [5.445751473660985, -9.331963335801913],
              [5.443215267355161, -9.331293804444824],
              [5.440553738679251, -9.326841711547441],
              [5.438528576883729, -9.31917621248771],
              [5.435187761676364, -9.312101138369236],
              [5.432688559877822, -9.310302658108458],
              [5.431013558218735, -9.30497227588056],
              [5.428909927386658, -9.302843898076103],
              [5.424264738994918, -9.30506422639863],
              [5.42100862738538, -9.301057206064703],
              [5.416142187872094, -9.301344588089119],
              [5.414780893172114, -9.297737258713076],
              [5.41495050734299, -9.290249918284545],
              [5.411032498194311, -9.287306066264176],
              [5.40737943776518, -9.29561345669249],
              [5.402016917248551, -9.29111503106406],
              [5.401667726381695, -9.288779805004955],
              [5.395814316613821, -9.286461031241732],
              [5.395905471949424, -9.277647843213968],
              [5.386366686387956, -9.271038593950957],
              [5.3791987774664545, -9.27791116160133],
              [5.369598788658131, -9.282365712635217],
              [5.367420029009573, -9.284131510931257],
              [5.366326742233163, -9.293617408654825],
              [5.367462393775747, -9.302155435780218],
              [5.372560713639649, -9.302266381742982],
              [5.371088662715508, -9.308908301888353],
              [5.372624855480224, -9.311994014573228],
              [5.366030808450098, -9.319856730725538],
              [5.3609870332630685, -9.318922134391672],
              [5.358703598837126, -9.32243522649374],
              [5.359307112903235, -9.325576330577496],
              [5.3582615390310595, -9.334139459685641],
              [5.353698262876568, -9.336044332501368],
              [5.349372734401646, -9.343671664466246],
              [5.346825922780229, -9.339312194810788],
              [5.349683013857847, -9.336688100274658],
              [5.3473124884597105, -9.326582319099607],
              [5.353403553400705, -9.320696098930895],
              [5.351687068856419, -9.313625706897655],
              [5.351772012119507, -9.311313247988199],
              [5.3552500691812375, -9.306171368430448],
              [5.357115283748199, -9.300425680029404],
              [5.362125778332847, -9.295691800196392],
              [5.361664817121261, -9.282199898559838],
              [5.366839074185683, -9.274714355973199],
              [5.364759079327263, -9.266630568889688],
              [5.357008283399983, -9.25368495790522],
              [5.360260099407796, -9.243932824078255],
              [5.35957893063085, -9.2351650068536],
              [5.361565748480715, -9.229390144538302],
              [5.360003827737302, -9.22309493644595],
              [5.357929803503447, -9.219704976051329],
              [5.355283373346929, -9.211277194967568],
              [5.34890945179846, -9.205849245653104],
              [5.345433531804718, -9.200889521426626],
              [5.338854051360217, -9.195942156152409],
              [5.334842196540402, -9.195166167373442],
              [5.325243053404318, -9.19099229738506],
              [5.31756504898961, -9.181496758990637],
              [5.309812091713149, -9.175281040021295],
              [5.3060533952199735, -9.170686440317432],
              [5.29792719768707, -9.164928966134994],
              [5.294297405749209, -9.157967008278137],
              [5.289112128868907, -9.153759161457176],
              [5.287584901962963, -9.148191211521478],
              [5.279611407820693, -9.132471681206932],
              [5.277633413009788, -9.13042473783621],
              [5.270935726577943, -9.128173314934385],
              [5.267626742102025, -9.124492706941323],
              [5.261663647787071, -9.123476036423162],
              [5.256710925656626, -9.118350371056518],
              [5.2518855188790825, -9.111223238557002],
              [5.243745219848557, -9.109193509402557],
              [5.2392035671393105, -9.10207390456681],
              [5.23114395436211, -9.096568762221034],
              [5.225432467898844, -9.089137873466118],
              [5.219353758447005, -9.086842883867838],
              [5.215110877867376, -9.083133590455287],
              [5.215441535684708, -9.074417404500583],
              [5.210459251198192, -9.069986060448583],
              [5.208279768394173, -9.06507978545363],
              [5.202100592332424, -9.058392028884882],
              [5.194654565362663, -9.054377060689882],
              [5.186573947190704, -9.05538301550398],
              [5.179892584436066, -9.032322175879083],
              [5.1683540970534265, -9.025272472179225],
              [5.15520752889037, -9.019891394942006],
              [5.140298884588637, -9.002288359622355],
              [5.139974447435986, -8.997333400920471],
              [5.137130904992473, -8.994848626881181],
              [5.12526908308559, -8.993002166250317],
              [5.115914051257693, -8.993312054581427],
              [5.110052309035417, -8.991731610002615],
              [5.104634614313723, -8.988083722747099],
              [5.099521672385333, -8.981215377124293],
              [5.0962442577899125, -8.975292663012384],
              [5.087622878685445, -8.963232323326444],
              [5.083170959326214, -8.958010039796788],
              [5.073722350878068, -8.949748102940687],
              [5.0644517474440605, -8.93868893229609],
              [5.060462924287789, -8.93505567131533],
              [5.049570637191943, -8.930402343037215],
              [5.0407716178024575, -8.9245865208902],
              [5.03297354059382, -8.925594973862804],
              [5.026264661998842, -8.92418645138472],
              [5.023189516516128, -8.92217702117322],
              [5.015995690952203, -8.915057199979158],
              [5.005435852769908, -8.906361919481329],
              [5.000410301540949, -8.89355098685739],
              [4.989593569347437, -8.873185039406545],
              [4.986734863804055, -8.871593787589658],
              [4.986008266850491, -8.864353407967071],
              [4.9839888524635265, -8.856461113883613],
              [4.976337085928106, -8.859881666462432],
              [4.969359357312288, -8.855316650639162],
              [4.97000959813273, -8.846549630266045],
              [4.9676485507455705, -8.841696813354432],
              [4.967195064726898, -8.830743090455302],
              [4.965597507752491, -8.829740192187613],
              [4.954815133888298, -8.827939676842064],
              [4.948165595282534, -8.830375348674126],
              [4.948725449366984, -8.84144514507801],
              [4.939359613195577, -8.846853862879964],
              [4.936600467668929, -8.846578234215718],
              [4.93503033724737, -8.850830865909915],
              [4.937958005380521, -8.860079501006473],
              [4.902754173976619, -8.862441978040238],
              [4.905961423766085, -8.891067047650473],
              [4.796225688662504, -8.898538956780568],
              [4.81637046978157, -8.868009303642134],
              [4.8435017748870095, -8.819403425883603],
              [4.861384020969477, -8.781033454384094],
              [4.8617206984863754, -8.777724537479159],
              [4.87170193361112, -8.734063006990414],
              [4.892751729790514, -8.732581420031474],
              [4.890999086910184, -8.705146649943103]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.42567452092835,
          "lat": 29.566323251837062
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22057"],
        "coty_name": ["Lafourche"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Lafourche Parish"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00558065"
      },
      "bbox": [
        4.796225688662504, -9.506118248374145, 5.684103262355582,
        -8.683708461480622
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.7386414301000075, -5.666385568120356],
            [3.836061071918249, -5.663049432473683],
            [3.900013280082617, -5.660010789404721],
            [3.9999973660711845, -5.656346686164059],
            [4.016236610790365, -5.6550624183994955],
            [4.106902607052829, -5.651891951707595],
            [4.145923223150366, -5.650215631875547],
            [4.15212821990747, -5.6495370224368475],
            [4.212241012256606, -5.646849744359309],
            [4.2213778442986545, -5.647021956386973],
            [4.245362558887629, -5.646158024986276],
            [4.265826496238728, -5.644991815220013],
            [4.26729877978441, -5.650132875652738],
            [4.264172209737127, -5.651061400194808],
            [4.263941287099506, -5.660262974683447],
            [4.256069430058169, -5.659180085731718],
            [4.257361836737141, -5.664026897969433],
            [4.255179190606056, -5.66828146781167],
            [4.25918763968986, -5.6694967993338174],
            [4.2610842295134415, -5.6661320037635265],
            [4.264115384419114, -5.665720527523951],
            [4.265569281363853, -5.670235601022654],
            [4.260699768676452, -5.679760457853284],
            [4.250701056714201, -5.6860725457402],
            [4.2476468008373764, -5.690833198232333],
            [4.244814924834614, -5.697678153345971],
            [4.244645589984207, -5.701490380889262],
            [4.237536115633624, -5.707091513318677],
            [4.234564752845306, -5.711141677655147],
            [4.23262097916278, -5.717426381482128],
            [4.236206335526694, -5.722966886686838],
            [4.236220285394316, -5.726101530921446],
            [4.232723366377595, -5.729186970372412],
            [4.223790576489724, -5.743191503693359],
            [4.219696204179844, -5.746526868141194],
            [4.218763928343179, -5.751873737207628],
            [4.220453960283396, -5.759079216285486],
            [4.222318851922046, -5.762639267132269],
            [4.219485845631406, -5.764326344740568],
            [4.214942105589716, -5.77002848877265],
            [4.208823856379787, -5.775089753299484],
            [4.198218814067254, -5.7788767511686014],
            [4.189542405124721, -5.777534339081025],
            [4.1841878580908425, -5.778705592456007],
            [4.179643184294793, -5.78206341726142],
            [4.177973329557621, -5.788463615819697],
            [4.167479292866296, -5.79951709731568],
            [4.163720951878365, -5.8012358826015005],
            [4.1617150326974786, -5.806978518484144],
            [4.161889640948385, -5.810916395893059],
            [4.158736456699958, -5.815235040430722],
            [4.1583466298283, -5.824975411214281],
            [4.15957508151286, -5.831119613510784],
            [4.155127665123819, -5.83499982573716],
            [4.1549596945595715, -5.838147664622898],
            [4.151112027495969, -5.838823684403202],
            [4.145743624985622, -5.849974524404364],
            [4.147582646469603, -5.8587331097039534],
            [4.145140130832578, -5.863267068880824],
            [4.139490163779715, -5.86721042092256],
            [4.135069381249024, -5.87476834728735],
            [4.138991246137192, -5.878035918037651],
            [4.143401864151024, -5.884853068189165],
            [4.144493846918783, -5.897919614972326],
            [4.1434677762425185, -5.908493927227256],
            [4.139130222400306, -5.913645138991816],
            [4.135808562473641, -5.919306193116695],
            [4.131826459356655, -5.9198969744606424],
            [4.1326755568770865, -5.926750233018529],
            [4.12984325852576, -5.9278449311529915],
            [4.127329692589181, -5.931661304818792],
            [4.127646416543344, -5.9365035376253035],
            [4.118624274907489, -5.939469127997173],
            [4.115240627946476, -5.944806075728964],
            [4.114684750847541, -5.949790180042252],
            [4.110894310707402, -5.957233502651108],
            [4.116244463816347, -5.957480723608932],
            [4.119678246780151, -5.963023202475821],
            [4.12350605626207, -5.962723698359164],
            [4.126809459604843, -5.970243705083559],
            [4.1246618031942885, -5.972972049001604],
            [4.12593099536568, -5.978361834354927],
            [4.1204982573561315, -5.983132234157221],
            [4.117396927012927, -5.9890012845995475],
            [4.113472779451174, -5.99159604272239],
            [4.114478139670594, -5.995404497461388],
            [4.112442903970374, -5.997761600282863],
            [4.111083160105657, -6.007260567235224],
            [4.1067925663630085, -6.019312014277227],
            [4.1023788071911795, -6.0214345657622355],
            [4.102130692108967, -6.026678608956773],
            [4.096968532223689, -6.0351988706058926],
            [4.094475389887446, -6.041237471557827],
            [4.087289175416627, -6.048971448757457],
            [4.084869333023304, -6.047299928566756],
            [4.07596341934604, -6.045429010603966],
            [4.072094186744533, -6.052385792774687],
            [4.065856150110001, -6.05261896933872],
            [4.064735924282531, -6.049725946821625],
            [4.058748178279025, -6.048267318078888],
            [4.054287271015905, -6.049891431714174],
            [4.047461198598248, -6.056234675156175],
            [4.041182388856563, -6.065320799433307],
            [4.04087040338654, -6.068360130226318],
            [4.035812760143317, -6.074646810223828],
            [4.0341426421624185, -6.082607835523719],
            [4.036260346828828, -6.091021206286904],
            [4.032924456039484, -6.101358409056255],
            [4.030826188501746, -6.103847340563717],
            [4.0239752652279925, -6.105890117586961],
            [4.020580689107234, -6.101815910412229],
            [4.015805461299953, -6.103789741715349],
            [4.012902180289826, -6.107982499324044],
            [4.007994823500808, -6.109397121792812],
            [4.000613624200828, -6.102656839646406],
            [3.9954488819977043, -6.104878869545854],
            [3.9944917929910964, -6.100500800275566],
            [3.991109187128375, -6.099137490848439],
            [3.9877360504223756, -6.100733524246222],
            [3.983737945949376, -6.096939596323429],
            [3.9783377284544157, -6.0937475728558965],
            [3.9730051134994016, -6.095794416338514],
            [3.968407179522635, -6.1007986116897746],
            [3.9702206132020645, -6.103502851987582],
            [3.9695278015550945, -6.108995387460219],
            [3.9677791241168943, -6.111525259619036],
            [3.961570600174823, -6.1122562567056375],
            [3.957373333069845, -6.115352249148261],
            [3.955633213104487, -6.119608962827733],
            [3.951657760224637, -6.122725906486773],
            [3.950032009525559, -6.130485420354075],
            [3.951330756022302, -6.136231777156279],
            [3.9514963011022872, -6.147664940288231],
            [3.946436413808952, -6.14921621789899],
            [3.9364941402687332, -6.14866621750174],
            [3.9324932182987626, -6.145448935384582],
            [3.928470698812914, -6.144798426017045],
            [3.9185602291313866, -6.1335751609878475],
            [3.9187308496775826, -6.13071741297477],
            [3.9101460167432385, -6.124106516882936],
            [3.9016085820850184, -6.132768592450156],
            [3.90050677576902, -6.138931884538754],
            [3.9011645019617665, -6.1454208280481435],
            [3.8998580712774493, -6.147495471729303],
            [3.900444021234597, -6.152641294836614],
            [3.8976168410252585, -6.159598664345928],
            [3.892407831393909, -6.163072182381029],
            [3.8901367234553463, -6.163041277239092],
            [3.8971828713064784, -6.1533085749882455],
            [3.8976934242095855, -6.14805168509288],
            [3.8964093187446736, -6.141045203538106],
            [3.892485950784213, -6.135674857166427],
            [3.8936884352670624, -6.133506623204445],
            [3.887293452717673, -6.129350687568176],
            [3.881910057089801, -6.121851221423415],
            [3.8801532131221923, -6.1127172241549035],
            [3.8764326768341015, -6.103339387541312],
            [3.8754319144961236, -6.098318391032983],
            [3.8792184773303613, -6.092426462064549],
            [3.8777132887105723, -6.087397812084312],
            [3.8743732912161617, -6.085689467389271],
            [3.869945625733494, -6.088241375712329],
            [3.863437762595696, -6.082984818345622],
            [3.8621738062883177, -6.073083645318878],
            [3.86869598795025, -6.065234521820109],
            [3.8692197363823513, -6.061238070951879],
            [3.875773926196289, -6.050867901177369],
            [3.875438611243883, -6.047758790114076],
            [3.8778725013497812, -6.0448037552307525],
            [3.8779153670633364, -6.03968219589616],
            [3.8749684786785505, -6.031753805915628],
            [3.8747804982118264, -6.024212031969545],
            [3.878304087939908, -6.020023802928646],
            [3.884348553507829, -6.018937366134109],
            [3.886872267524667, -6.014468052425111],
            [3.8845642239117515, -6.00765840584067],
            [3.8780621591461535, -6.0030383850516245],
            [3.8743752453736935, -6.00183112529763],
            [3.8690741282150127, -6.003478979720681],
            [3.8654073538257676, -6.011067284925923],
            [3.854285360262523, -6.005509545404505],
            [3.852961482382159, -6.0016348474843095],
            [3.849621855703906, -5.997806474998562],
            [3.842398788261608, -5.9931579931899135],
            [3.8369980678973272, -5.984798232249611],
            [3.8332156914837783, -5.971692479647807],
            [3.8330267657859554, -5.965161674735183],
            [3.829206529931618, -5.959703105023971],
            [3.82268967223768, -5.964979256849807],
            [3.817828310918786, -5.965170545815888],
            [3.8117292488516346, -5.967470184722284],
            [3.8015204690979987, -5.9641224261549],
            [3.795677998505756, -5.972076600548531],
            [3.788839966710198, -5.971525457984834],
            [3.786186660741639, -5.969934636707562],
            [3.780773810932866, -5.9610044642718885],
            [3.774796107712245, -5.961018208322124],
            [3.7717721990787663, -5.967155501657918],
            [3.7730535735077493, -5.9701434126807005],
            [3.7769424302639476, -5.972712759153769],
            [3.7824143696016552, -5.972916158746816],
            [3.7836057315691964, -5.97606180144774],
            [3.7800418001671647, -5.980625513556926],
            [3.7720309271345496, -5.984794529137073],
            [3.7679564131315484, -5.98782774206621],
            [3.7674073831964967, -5.982627887570592],
            [3.770007717304646, -5.980351556378461],
            [3.7712227122101383, -5.973449454103488],
            [3.7663535735978373, -5.976288325156999],
            [3.762474050493397, -5.976043109018918],
            [3.7632652394791952, -5.972191502533336],
            [3.7599201706643015, -5.967512336352761],
            [3.7628803139724423, -5.959185237038656],
            [3.7537250472665704, -5.96482690786465],
            [3.761379468922808, -5.95563937441241],
            [3.7576466951860477, -5.952223598096588],
            [3.7536382342194408, -5.9514455655657885],
            [3.7579796018468112, -5.947220037294929],
            [3.7559992859545703, -5.942361881896031],
            [3.7635099753576555, -5.937067822425112],
            [3.7629993182707633, -5.929992826354281],
            [3.755869153718476, -5.924183407355],
            [3.753711804774304, -5.912210637760092],
            [3.7566287536120506, -5.906142410729619],
            [3.759966087007982, -5.896209661779221],
            [3.7610464998329287, -5.879302519263035],
            [3.759035220809186, -5.874035038473686],
            [3.753550095600294, -5.865724588053128],
            [3.748863060614367, -5.853061488232456],
            [3.7524608633515713, -5.850163548062344],
            [3.7528300633364124, -5.847348577527119],
            [3.747614014203065, -5.84482492791769],
            [3.7474876536727484, -5.840583869113177],
            [3.7501150924990965, -5.838403033199013],
            [3.7564969913611725, -5.836623064436815],
            [3.755073558155694, -5.8295914756055724],
            [3.7476836284347224, -5.824791287857584],
            [3.736732506564171, -5.809989495966781],
            [3.731678627591161, -5.7999762734625415],
            [3.731068083109942, -5.792943249381076],
            [3.7342000852550257, -5.784731567939017],
            [3.736474737935868, -5.781717610859042],
            [3.7325971831061047, -5.774739202911216],
            [3.732861734737377, -5.770162541651568],
            [3.735113084750626, -5.765007251142564],
            [3.7328565763443495, -5.762124093816286],
            [3.7347684309119478, -5.75919698275543],
            [3.734039162586406, -5.7524274651760985],
            [3.738543987738376, -5.751792412276676],
            [3.7390213788047073, -5.749477184532225],
            [3.735262032394524, -5.740975302589511],
            [3.7336550368693664, -5.732767441033078],
            [3.7338534861654002, -5.728377257781025],
            [3.731298859106086, -5.723655163482775],
            [3.731304702691831, -5.717557173162243],
            [3.7274634758865632, -5.718087581167878],
            [3.7284578716735894, -5.712982129300016],
            [3.7265271088872174, -5.7099467234217585],
            [3.728532118408574, -5.70563146809179],
            [3.734281976979272, -5.705202921415227],
            [3.7346584221898, -5.701005466270734],
            [3.7290111621092863, -5.693374424985854],
            [3.731735859317745, -5.690032495160255],
            [3.737439630633514, -5.68687655987957],
            [3.7365458111103265, -5.677653844588227],
            [3.7407427128391966, -5.673030076933279],
            [3.7386414301000075, -5.666385568120356]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.80182458103106, "lat": 32.82024468382294 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22067"],
        "coty_name": ["Morehouse"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Morehouse Parish"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00558097"
      },
      "bbox": [
        3.7265271088872174, -6.163072182381029, 4.26729877978441,
        -5.644991815220013
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.955149860067333, 8.911068845874476],
            [18.00780084308149, 8.792826416326546],
            [18.060450855245502, 8.67450049866407],
            [18.0318177575439, 8.662108140539804],
            [18.06814296822255, 8.580697763251175],
            [18.073438820502098, 8.583087304316432],
            [18.11142722671653, 8.50488348262813],
            [18.142878468259614, 8.402931870912152],
            [18.18722631105548, 8.44747105592407],
            [18.23158494928045, 8.491997656519437],
            [18.288427123455865, 8.422686620879217],
            [18.347642254456876, 8.350375216591432],
            [18.32504427297256, 8.327279039069929],
            [18.381924426428476, 8.33028395831301],
            [18.47180901171141, 8.335858525861523],
            [18.520404433762504, 8.338315258107198],
            [18.51047094137641, 8.302917745123468],
            [18.522012329895002, 8.30852511334778],
            [18.53758521976546, 8.276610839632111],
            [18.544337873079506, 8.27962114576534],
            [18.546531451275246, 8.275037572431104],
            [18.5586125441914, 8.280643634727157],
            [18.57559476545601, 8.24727597291081],
            [18.57876614799901, 8.240401498094524],
            [18.559319070375516, 8.21619985408905],
            [18.570018210288627, 8.194187138805466],
            [18.563206849781807, 8.19104633774141],
            [18.586469096354204, 8.14360142223262],
            [18.58614273280665, 8.101762794336738],
            [18.586014744868155, 8.036252614365075],
            [18.58661290692863, 7.984403233317863],
            [18.579870743223363, 7.984981331883693],
            [18.56284720413082, 7.940163999617725],
            [18.555448887288378, 7.919336628393472],
            [18.543563377145706, 7.887487109673711],
            [18.53615604162154, 7.866963190992482],
            [18.52649221120963, 7.842055693067334],
            [18.52142038057389, 7.8273917927601735],
            [18.51574944826746, 7.812441163574444],
            [18.52172474788289, 7.807551896020225],
            [18.52284161982837, 7.7971431404924525],
            [18.527135229230904, 7.789756307050635],
            [18.526886385754057, 7.786272868757447],
            [18.508697331862418, 7.792134196345642],
            [18.504417295343657, 7.78981990577907],
            [18.489685648170898, 7.748886929121277],
            [18.479158263768248, 7.758078711349333],
            [18.470896823846946, 7.763728092459828],
            [18.467315543146704, 7.753796920883399],
            [18.459618551040144, 7.754170159574206],
            [18.457785665835832, 7.758109291578118],
            [18.447953760138603, 7.763877768206052],
            [18.443870704766812, 7.771172400574874],
            [18.439537987296536, 7.7740537696097025],
            [18.436583940775474, 7.778891599394515],
            [18.431363469064575, 7.784234242581082],
            [18.43066519631206, 7.787329171875022],
            [18.427159942643364, 7.790843239683368],
            [18.428466576163643, 7.7962690873767615],
            [18.425604332111707, 7.79848022052935],
            [18.427194071967943, 7.802750908770558],
            [18.42534359705539, 7.807047307828153],
            [18.42683004654563, 7.811050778156571],
            [18.426986103456148, 7.8173753893609845],
            [18.42492460551789, 7.818084080355675],
            [18.42394612947565, 7.825127352043463],
            [18.421437186118723, 7.828960236710066],
            [18.422969129089125, 7.8328974112204675],
            [18.423583621017368, 7.840609336030678],
            [18.428816362745124, 7.852834970960387],
            [18.423844000394563, 7.858158765808792],
            [18.42246542756353, 7.862383050358056],
            [18.4137773123781, 7.8768387230265615],
            [18.40856829040261, 7.879914619470017],
            [18.406206781243363, 7.8792578330253935],
            [18.3904424457197, 7.892426946418375],
            [18.36452706466279, 7.861223305205781],
            [18.35078859027293, 7.8437649798133355],
            [18.34700285036458, 7.847872998217472],
            [18.32428848404677, 7.8213519508395395],
            [18.278909476463433, 7.765538932998264],
            [18.248751505898255, 7.776166649133353],
            [18.25116018871154, 7.769368817945201],
            [18.248109066331438, 7.766767953883808],
            [18.247281110243264, 7.759741018894958],
            [18.25156906982485, 7.758336938906445],
            [18.253234674243085, 7.753155256341902],
            [18.256760670665617, 7.747743387816491],
            [18.258164210377338, 7.741990418755934],
            [18.26799093290998, 7.734204503270792],
            [18.30892219582754, 7.735180712273772],
            [18.31027289532811, 7.729440717364849],
            [18.312534432318618, 7.726243780163404],
            [18.31859997652297, 7.729133990457331],
            [18.34225878837628, 7.7092766983459855],
            [18.382818773423903, 7.674731187595716],
            [18.36480980204884, 7.653463536762009],
            [18.381713178487775, 7.63990734911694],
            [18.36977094109879, 7.621915560080094],
            [18.36787810569085, 7.614040756884758],
            [18.37509888002936, 7.597013715616718],
            [18.379047253956724, 7.595319937974341],
            [18.383152514751117, 7.596489196440289],
            [18.37209060750107, 7.578747455622302],
            [18.36989595514547, 7.584035206705546],
            [18.362425921078295, 7.572732693052484],
            [18.360238408780862, 7.577967943939892],
            [18.351455436125665, 7.564697474488567],
            [18.35254228153083, 7.560031771359669],
            [18.350985417812417, 7.557124256963325],
            [18.35652283405391, 7.554570204618561],
            [18.360129845694733, 7.5492781965847],
            [18.359668915524242, 7.544328435632627],
            [18.36119361267864, 7.538583778231105],
            [18.36720626536108, 7.537276864580173],
            [18.37338628308285, 7.5296132560009745],
            [18.37493737122335, 7.520321786486811],
            [18.369248971748352, 7.517476574589363],
            [18.365317346457957, 7.511158430238316],
            [18.361910945033898, 7.510524099947495],
            [18.352763961234864, 7.511468569204401],
            [18.350103295834984, 7.506713775850027],
            [18.34553146446189, 7.504916985010917],
            [18.343982314620355, 7.506354922201857],
            [18.336204570823927, 7.505568854311273],
            [18.327754026561184, 7.498547890155155],
            [18.3231102774229, 7.496631391377893],
            [18.312004591070373, 7.497373184382745],
            [18.308050768801532, 7.498947154648442],
            [18.306125777912214, 7.495491579576347],
            [18.302638251000772, 7.493237100722664],
            [18.29740131054345, 7.487278718725849],
            [18.288438224858627, 7.483428435433798],
            [18.282583079835018, 7.475061938962824],
            [18.28123098995079, 7.470556296223839],
            [18.27563350989945, 7.468720292423247],
            [18.27113786857256, 7.469902073518255],
            [18.26697856315995, 7.467414387819431],
            [18.264528583505555, 7.462667110509866],
            [18.26143065094209, 7.459919362754976],
            [18.25602420241592, 7.461543302043959],
            [18.254573806152642, 7.458749792244095],
            [18.249430509371592, 7.457980146671899],
            [18.244897170534422, 7.462426358438558],
            [18.241681592571556, 7.463453004024187],
            [18.237734548501866, 7.460835007630151],
            [18.22481801716214, 7.505928963575067],
            [18.208044776802673, 7.560203099287568],
            [18.202684430204577, 7.579413107430111],
            [18.16622309233168, 7.698284942791584],
            [18.150677748774733, 7.7475149846596985],
            [18.105916722623245, 7.892613641159705],
            [18.102323575848406, 7.905375676100456],
            [18.09447030572751, 7.930097437817771],
            [18.08936135059287, 7.946180798206963],
            [18.07819305674416, 7.983256331688673],
            [18.066664976392865, 8.018574521824862],
            [18.038030767806884, 8.109257668731995],
            [18.029650424112422, 8.134078540114311],
            [18.012007814930318, 8.189074632388786],
            [17.983670387946574, 8.281484710147224],
            [17.95870081935921, 8.358051932398668],
            [17.95317318776637, 8.376196802938443],
            [17.925039124271034, 8.460491242489411],
            [17.897229732419056, 8.541110029117561],
            [17.875731167208823, 8.606360959810077],
            [17.873686891835444, 8.610809378756715],
            [17.830490433405615, 8.74190252660069],
            [17.81872836307618, 8.776574718973421],
            [17.798677460581334, 8.838814904726974],
            [17.7787337237348, 8.893448955344688],
            [17.785057844946905, 8.897446062963198],
            [17.7904266276263, 8.90396508535727],
            [17.793320356933005, 8.905814734722373],
            [17.798651414633113, 8.90450100173048],
            [17.801140513638412, 8.907399177367424],
            [17.804894878405232, 8.90816064507708],
            [17.812474371072717, 8.90713494023963],
            [17.81308742871107, 8.909936550849674],
            [17.818611933618993, 8.913202996241727],
            [17.826034055747115, 8.919897893799991],
            [17.828148254415222, 8.929464385032425],
            [17.82546650398509, 8.932564781192081],
            [17.820508998776265, 8.934193138450073],
            [17.817096079031632, 8.942366871600969],
            [17.81749970261063, 8.946519771786864],
            [17.822020330911524, 8.945847973464884],
            [17.828198605482036, 8.942325914510942],
            [17.83322314534784, 8.94148989223481],
            [17.838524547109543, 8.936697149613607],
            [17.84649142769171, 8.940302387117182],
            [17.85095750248158, 8.940225687570202],
            [17.85394539790377, 8.945483520215243],
            [17.859260610749562, 8.949292068344118],
            [17.867613764798712, 8.937752839439733],
            [17.873140574365067, 8.933624833506155],
            [17.879874266406123, 8.933665246271067],
            [17.882647297473962, 8.93070415657871],
            [17.88973543448157, 8.929603213686137],
            [17.890107469259117, 8.923011698628812],
            [17.895527029871026, 8.919280668253796],
            [17.89777173464751, 8.915646101859492],
            [17.895655430286883, 8.90569768998232],
            [17.89563515718773, 8.897922335926937],
            [17.8997357541612, 8.896851168988745],
            [17.904915984212998, 8.891189886987773],
            [17.910500532282082, 8.887565997251684],
            [17.91056326516043, 8.883518026225836],
            [17.9168112775142, 8.882130003324413],
            [17.920771908952748, 8.87678713309293],
            [17.920632876548908, 8.868388229113211],
            [17.925761630700922, 8.864723481830277],
            [17.932178549658, 8.862035250194952],
            [17.939268412267126, 8.863112636099382],
            [17.952683470141242, 8.861668090518346],
            [17.95984904163136, 8.869070215747655],
            [17.960955378431212, 8.873887243242763],
            [17.954539457452093, 8.878091117734533],
            [17.953607977139757, 8.886307869351148],
            [17.950839954709473, 8.889076030321517],
            [17.949507046907932, 8.895814332522901],
            [17.95444443485942, 8.903084289961857],
            [17.955149860067333, 8.911068845874476]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -70.75661756624379,
          "lat": 44.499919681806496
        },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23017"],
        "coty_name": ["Oxford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oxford County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00581294"
      },
      "bbox": [
        17.7787337237348, 7.457980146671899, 18.58661290692863,
        8.949292068344118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [15.40324209610315, 2.097967196566789],
              [15.407920294412019, 2.1004685434045],
              [15.421954960414006, 2.1156944240034767],
              [15.424569109647178, 2.1162958083842573],
              [15.432499603159247, 2.1140936291457733],
              [15.430872677627033, 2.1063841631326707],
              [15.415739431685369, 2.090682210889906],
              [15.408119255825397, 2.090815808920791],
              [15.404925037293806, 2.092840830204533],
              [15.40324209610315, 2.097967196566789]
            ]
          ],
          [
            [
              [15.005653313253067, 2.503136435987833],
              [15.058968160175114, 2.514383443614861],
              [15.168016835693777, 2.5369866567577724],
              [15.176561739432167, 2.5016590040545506],
              [15.177116241108449, 2.500870709850928],
              [15.190352728420406, 2.4430923739253596],
              [15.193064663439026, 2.4322911216515366],
              [15.200796348672643, 2.4165448982472415],
              [15.207128853688625, 2.4093850043060905],
              [15.21143270037736, 2.4090260017430776],
              [15.219052321391317, 2.397009249964432],
              [15.22090504500167, 2.391284478805961],
              [15.22431258603237, 2.3882534736750514],
              [15.22561753576994, 2.384778983993765],
              [15.228525840362078, 2.3851116723128474],
              [15.230705199611187, 2.3792187851789963],
              [15.232215724718651, 2.3677666925943317],
              [15.235412902373888, 2.3680008429493005],
              [15.237724372526257, 2.364769290298852],
              [15.243538239845273, 2.362632910618065],
              [15.24695393981859, 2.355582425367375],
              [15.249956786629085, 2.356071352836428],
              [15.252332757243696, 2.3519757177335405],
              [15.256446554084802, 2.353307681726939],
              [15.261236290434345, 2.35270565738801],
              [15.262631245348084, 2.355552662713605],
              [15.268305661337855, 2.3547621648099],
              [15.2735920272793, 2.3511426749210624],
              [15.284029729509442, 2.3495633824666835],
              [15.285325949258475, 2.3478366762523475],
              [15.29290568712702, 2.3460527817030723],
              [15.293517908494309, 2.343089477108069],
              [15.29865465031907, 2.34336250280901],
              [15.302515837509114, 2.345799430170324],
              [15.309512347271196, 2.3415885659789306],
              [15.312078257856244, 2.3411027378369327],
              [15.314684414151715, 2.3464396754976757],
              [15.318909204674773, 2.3422767062100553],
              [15.318138263819764, 2.3354039917059803],
              [15.316586328420644, 2.3321054789254663],
              [15.317797184305917, 2.32818410333742],
              [15.320693844592848, 2.3288163996412963],
              [15.325488862322596, 2.3224540775285947],
              [15.328975513651468, 2.320363836947602],
              [15.336214827018436, 2.3219942476427122],
              [15.34442305863869, 2.317746188285925],
              [15.346309279649406, 2.314356572015553],
              [15.350045486065834, 2.314345182392548],
              [15.353706700933046, 2.311226827378932],
              [15.355762985548237, 2.30668470613964],
              [15.358441179222902, 2.307242794569536],
              [15.358126917780849, 2.3010589319691808],
              [15.363080713775332, 2.298608929028396],
              [15.36719798578522, 2.2943610207429694],
              [15.368211615217286, 2.287160417264998],
              [15.370092853180717, 2.285431154185655],
              [15.368972580890382, 2.2783188008033792],
              [15.370433565192448, 2.273798389908795],
              [15.3766528904245, 2.2713858261062727],
              [15.379947721467397, 2.265971391501698],
              [15.380789969736801, 2.2556479591675602],
              [15.385176831770343, 2.255646108452204],
              [15.38994899319941, 2.2525704562289763],
              [15.393713623052495, 2.2431041600552155],
              [15.394756713874916, 2.2426916820720555],
              [15.395196138638543, 2.2342408650013716],
              [15.399590640767537, 2.2341206011156567],
              [15.403347199660722, 2.2295112026736352],
              [15.407883474993813, 2.230935176273016],
              [15.412991099484119, 2.2296386380067834],
              [15.41227024548497, 2.2246585654633724],
              [15.413694121684287, 2.2223051162544585],
              [15.413367213912116, 2.215891434311384],
              [15.410295665353809, 2.213595203236509],
              [15.418911545860015, 2.2030794065370514],
              [15.422592480978603, 2.197007256450834],
              [15.426202022404224, 2.193348667270803],
              [15.424028969359307, 2.1913579733472615],
              [15.420779105820145, 2.1956600514697637],
              [15.41439553268357, 2.1959315105390322],
              [15.411327318279753, 2.194151448861433],
              [15.4124832034985, 2.1890885401505336],
              [15.410959814017476, 2.1839371826311766],
              [15.412193151234115, 2.181164255662592],
              [15.416681678918758, 2.18371510987394],
              [15.419526388090182, 2.182132516225016],
              [15.42647663933379, 2.181707980715714],
              [15.42686875965677, 2.177739259791073],
              [15.431503714098897, 2.173445333194566],
              [15.42645408697005, 2.171739694098782],
              [15.424161326396707, 2.1680366146457417],
              [15.418119348807755, 2.169672484278284],
              [15.412366333122153, 2.1664629868319323],
              [15.411442340347332, 2.170108903088133],
              [15.403022895261948, 2.1743151918518784],
              [15.399042621393578, 2.1724396970055873],
              [15.405759448789237, 2.1647542589655453],
              [15.402332435760927, 2.1561175815528926],
              [15.396656865556913, 2.1491947007763454],
              [15.392405309566294, 2.151716729845506],
              [15.394173077254893, 2.1561630050904133],
              [15.39185733622059, 2.158331471245087],
              [15.386227349518414, 2.156775518117677],
              [15.383436285799872, 2.1541068132538963],
              [15.376984176855737, 2.158254457226717],
              [15.37245056247926, 2.1576862856198695],
              [15.371567986281407, 2.153899824620584],
              [15.375399426751686, 2.146265631370697],
              [15.379793219071288, 2.146614972838412],
              [15.382892040240646, 2.144703614039111],
              [15.3836829992545, 2.1400351205760546],
              [15.389397056779009, 2.1349725970008495],
              [15.39738540189952, 2.1368332692145175],
              [15.399029283948526, 2.1280007247074497],
              [15.391165910832788, 2.1265259142362525],
              [15.3882468682805, 2.118234781253282],
              [15.39178167118623, 2.1154292526222473],
              [15.387007988395611, 2.1028018501512014],
              [15.388569362811658, 2.0966780258697066],
              [15.380485847291553, 2.093471834709892],
              [15.370545726424353, 2.0986994639939014],
              [15.363622352123835, 2.095736374626792],
              [15.358054632783078, 2.097142149597281],
              [15.353848517611393, 2.0892207654015955],
              [15.360006490341538, 2.0842810016425957],
              [15.368848333024683, 2.082314353127152],
              [15.371493154832844, 2.0825818857274068],
              [15.376842988116584, 2.07971413343755],
              [15.378554399967255, 2.077320580776166],
              [15.387956165906, 2.07824030149115],
              [15.394581238972515, 2.0808586878265456],
              [15.3968204766235, 2.0775460648749204],
              [15.389690018999675, 2.0720101020780906],
              [15.384790850316438, 2.0655093871777135],
              [15.383515558249782, 2.05578626329062],
              [15.381993121668767, 2.050392119821238],
              [15.374265201322775, 2.0451304507242334],
              [15.371194261364014, 2.0375223189138985],
              [15.36681283060974, 2.039006878568145],
              [15.364127413258574, 2.044703030902431],
              [15.366867606872187, 2.0521077841345594],
              [15.363200317084807, 2.059408858382231],
              [15.354726891318702, 2.0584966724862594],
              [15.351928066068488, 2.0544968834630595],
              [15.353862353373687, 2.0483523957204377],
              [15.353249081897125, 2.0446029785390754],
              [15.340940775412182, 2.041214983860856],
              [15.332703640086027, 2.0357225714067297],
              [15.329866981529955, 2.035579718657577],
              [15.324357411332807, 2.0421629655788704],
              [15.32341127665191, 2.0469478475617193],
              [15.326276172691243, 2.048397997899868],
              [15.325358740793328, 2.0550386433903705],
              [15.323476283244966, 2.0600543221235337],
              [15.318041635326201, 2.064237515924629],
              [15.315255411498748, 2.063753047137746],
              [15.311726994621276, 2.0592243038789313],
              [15.307916261571268, 2.062322530901554],
              [15.30555971191939, 2.071412238264037],
              [15.301550549112756, 2.0714336151750907],
              [15.296516231977956, 2.0682428424869963],
              [15.29318544192132, 2.0835054199481653],
              [15.279400976881176, 2.150177553038175],
              [15.269300307484736, 2.1983544092237612],
              [15.229052490929718, 2.190063660853284],
              [15.218299911581092, 2.1875272913666794],
              [15.19702477865729, 2.183344652045536],
              [15.13320344075371, 2.1701047683616532],
              [15.140693359433051, 2.1331665059355096],
              [15.152533566811995, 2.077217423903665],
              [15.163962978567486, 2.0737046918838846],
              [15.184173591160787, 2.066623228009313],
              [15.208644282292722, 2.058939948622509],
              [15.230231482183143, 2.0515237798052586],
              [15.22420469696737, 2.037083127492031],
              [15.219148956259776, 2.0349130597909166],
              [15.210445470940147, 2.038823006236078],
              [15.201445452242702, 2.0390000140714513],
              [15.197105210151069, 2.037729070538904],
              [15.193514079881197, 2.034707007295353],
              [15.186936798109409, 2.0246696720746034],
              [15.181569199087665, 2.0248931162296793],
              [15.175477688899685, 2.019277590293983],
              [15.176015518417586, 2.016332954520809],
              [15.173724204327305, 2.0147519936651883],
              [15.16957054647461, 2.0166354219720812],
              [15.167354060747465, 2.0219191551904783],
              [15.162428619872381, 2.0213975077446182],
              [15.158535366846708, 2.024466993942665],
              [15.152405110368424, 2.0264330786375795],
              [15.14831893153745, 2.0259890036131796],
              [15.139983752856134, 2.02778322435961],
              [15.136823074826719, 2.031243989228081],
              [15.13073628252206, 2.035331985755749],
              [15.128705494221155, 2.037916578115625],
              [15.124062729868744, 2.0400652141682247],
              [15.119735770349235, 2.0379891395728666],
              [15.118288339441158, 2.0428111077126605],
              [15.111561016803742, 2.0454073276145426],
              [15.103238650021373, 2.046958385317731],
              [15.096848007708953, 2.0513744660777835],
              [15.092145523651737, 2.0532148459384243],
              [15.091474266144354, 2.056894052553661],
              [15.093933645845066, 2.0593646482894616],
              [15.095862138708707, 2.0707008223341106],
              [15.094019195067427, 2.0788010759166493],
              [15.098337059523487, 2.0837041575562187],
              [15.097488071045003, 2.085744389924249],
              [15.090568045944966, 2.087486364961722],
              [15.08435232871724, 2.0930011325183004],
              [15.084568336019746, 2.0978700275853037],
              [15.082321175750755, 2.100287227573623],
              [15.074466032977602, 2.1012086618307104],
              [15.070555508576849, 2.0988680709087735],
              [15.066599085918039, 2.1007846362635316],
              [15.06435757565776, 2.095846846340546],
              [15.059884269903305, 2.1005722476677002],
              [15.05573974445022, 2.097864462234438],
              [15.054294685727147, 2.092088991501113],
              [15.051338536999364, 2.0955576070257544],
              [15.048318335880953, 2.0943609828705014],
              [15.044521008344624, 2.096574749930698],
              [15.04096607377927, 2.093498199135062],
              [15.037190277781098, 2.094548019292816],
              [15.034922595397743, 2.099812275771855],
              [15.02833292500969, 2.1052522235286455],
              [15.024825081305924, 2.1064879229802753],
              [15.018403449515118, 2.105637814932785],
              [15.015075537545858, 2.1092158943344548],
              [15.016801596003178, 2.1131291100262533],
              [15.014063023200551, 2.115165507087791],
              [15.00933661734895, 2.1223545954478915],
              [15.009896361296649, 2.129326674456799],
              [15.006671558657608, 2.1363810071135623],
              [15.004386689778064, 2.136592916044255],
              [15.000216737435013, 2.141483184622312],
              [14.996078017787019, 2.1526445791187196],
              [15.001971383662156, 2.1593809106359814],
              [15.004108312243773, 2.160204506954092],
              [15.002055161495706, 2.166880641588382],
              [14.997336712659257, 2.1687473481356907],
              [15.001011545374977, 2.174341047900738],
              [14.996745495752153, 2.1758149754711256],
              [14.997323395211748, 2.1802566689242977],
              [14.996412990063513, 2.1889249311423296],
              [14.997272903544706, 2.191982771887509],
              [14.991740924713323, 2.1924431305332153],
              [14.990974949701846, 2.1949153746606505],
              [14.986473414019699, 2.199139712208972],
              [14.98395467625988, 2.197694116445457],
              [14.983162492670022, 2.2038650191488536],
              [14.983979315868927, 2.2076818021658444],
              [14.987353021471337, 2.2108591885807507],
              [14.98532439868653, 2.2162109531045346],
              [14.990386793968852, 2.217036373521784],
              [14.993446575511706, 2.222704330215677],
              [14.990774474709943, 2.224321648280961],
              [14.987865630268425, 2.2213611831019393],
              [14.980096863744151, 2.2246172179377144],
              [14.985346194627875, 2.226818751831349],
              [14.97953605389124, 2.231194325824115],
              [14.983060167252411, 2.2333944706848285],
              [14.984128105451399, 2.2373797684852335],
              [14.983448888889475, 2.2453214330662057],
              [14.987852746434788, 2.2481891580294233],
              [14.98835299395134, 2.253778046086761],
              [14.992371524414077, 2.255074921193403],
              [14.99341081044525, 2.260596750421575],
              [14.99142488578898, 2.2620911411055604],
              [14.990603486006167, 2.273700454801583],
              [14.991893326170068, 2.305566965811899],
              [14.9950517989529, 2.351501493679922],
              [14.99561042244224, 2.363811840009629],
              [15.001326699745764, 2.4493298415890745],
              [15.005653313253067, 2.503136435987833]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.63968672707942, "lat": 39.46309163860757 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24005"],
        "coty_name": ["Baltimore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baltimore County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01695314"
      },
      "bbox": [
        14.97953605389124, 2.0147519936651883, 15.432499603159247,
        2.5369866567577724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.680918414013743, 3.8809732090650657],
            [8.766762378192793, 3.889015315467996],
            [8.865046595452586, 3.9022646315961844],
            [8.925224538150212, 3.9103769741255268],
            [8.935957400840591, 3.9119711114961695],
            [8.977994526415934, 3.9172289049308238],
            [9.019767541831705, 3.922736094635244],
            [9.031194837516802, 3.8357981051834784],
            [9.046499128700523, 3.7143440239848933],
            [9.06284770549319, 3.588432128770839],
            [9.06701331803218, 3.5570420662921136],
            [9.038327952764098, 3.5527499668198854],
            [9.010113476421285, 3.5483315363768955],
            [8.911358406632669, 3.533439038071921],
            [8.781456368911766, 3.514066847524448],
            [8.740484202174706, 3.5070616795644556],
            [8.734801207599723, 3.553979917527538],
            [8.732961335534574, 3.5710778982706786],
            [8.718835682591864, 3.5691830568915566],
            [8.712660892241749, 3.620051676910992],
            [8.70258245903209, 3.7068866323112935],
            [8.69146496451973, 3.794394115169833],
            [8.68274072179741, 3.866933729712127],
            [8.680918414013743, 3.8809732090650657]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.59295483524936, "lat": 41.88777981506725 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26059"],
        "coty_name": ["Hillsdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hillsdale County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01622972"
      },
      "bbox": [
        8.680918414013743, 3.5070616795644556, 9.06701331803218,
        3.922736094635244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.001851043355632, 6.562104571741571],
            [8.007909634517594, 6.569700742282312],
            [8.011428896357563, 6.5702915382432625],
            [8.012060710715266, 6.574407458707529],
            [8.008318002052546, 6.578508541897399],
            [8.00862797999013, 6.5835195455915425],
            [8.004899674306921, 6.596137138702923],
            [8.001230080553663, 6.600478523431674],
            [8.011239812542494, 6.604408376561908],
            [8.025466396648357, 6.612058006417383],
            [8.107061764642525, 6.620821166857837],
            [8.108679417228466, 6.620863773944559],
            [8.166442010482427, 6.627137708038808],
            [8.194582871015962, 6.630578459328102],
            [8.252510824162666, 6.637299714540133],
            [8.338058807660632, 6.646352113528827],
            [8.348209630402902, 6.560550627231793],
            [8.35333062981469, 6.502285265149974],
            [8.36030334277905, 6.445820042560431],
            [8.363430886577776, 6.416696205886741],
            [8.366971458542823, 6.3879520153730995],
            [8.376207649331667, 6.302950216574007],
            [8.26704538073521, 6.289652003232513],
            [8.205280963943862, 6.282537902549765],
            [8.190517173979808, 6.281461885029993],
            [8.181320741039489, 6.280223311599993],
            [8.10578755837921, 6.2727944030313365],
            [8.03470806696006, 6.265059872243543],
            [8.025829623421858, 6.35036421754928],
            [8.020859432810514, 6.393339457768998],
            [8.015712818466575, 6.436180601374537],
            [8.01384002498554, 6.453976685783735],
            [8.001851043355632, 6.562104571741571]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.09018442747254, "lat": 44.68467662136701 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26079"],
        "coty_name": ["Kalkaska"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kalkaska County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01622982"
      },
      "bbox": [
        8.001230080553663, 6.265059872243543, 8.376207649331667,
        6.646352113528827
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.3224591310116915, 5.854613006132301],
            [7.382001810399874, 5.858112960546248],
            [7.410761020696347, 5.860049151697339],
            [7.46823968023708, 5.862423902574454],
            [7.498145236733218, 5.864041697853114],
            [7.540518641514926, 5.866968231934672],
            [7.5691961080459516, 5.868329846966724],
            [7.577158917254991, 5.8120913083575045],
            [7.582915895613354, 5.7654371728229785],
            [7.5861178077541505, 5.735415063330644],
            [7.590237047136092, 5.692424671203301],
            [7.600376750731679, 5.605979473390449],
            [7.603438580389224, 5.577045344258523],
            [7.610102300093039, 5.519649153384055],
            [7.523955645577367, 5.511203760385258],
            [7.46300955037984, 5.506068276868137],
            [7.437242400580838, 5.504053896212942],
            [7.4094052468764735, 5.501555333398215],
            [7.352329542984372, 5.496971426528816],
            [7.328836277479278, 5.494594803671653],
            [7.328435341119889, 5.50275917901436],
            [7.326396832888483, 5.515757681001009],
            [7.32295292883436, 5.530364881728598],
            [7.318312629504981, 5.541091961562797],
            [7.311268793107414, 5.56345571521924],
            [7.3066549874730695, 5.591473913590522],
            [7.300024474740896, 5.612958513500361],
            [7.294732566848396, 5.620701981375825],
            [7.292960464177138, 5.633291800197715],
            [7.290469765952123, 5.642949910649228],
            [7.280930964830793, 5.659383657805418],
            [7.273031787021123, 5.671523427064649],
            [7.257829244121535, 5.69081513129441],
            [7.25169048565506, 5.701085374025157],
            [7.245957889954946, 5.7157334227240355],
            [7.2449666330878495, 5.725869712969728],
            [7.2482210529001945, 5.735990213524575],
            [7.253368474206498, 5.744256420023157],
            [7.263575627038327, 5.7547121594383865],
            [7.288470716454557, 5.778235770722369],
            [7.299189851530358, 5.793170857793612],
            [7.308826360576581, 5.812896435627492],
            [7.316243732240247, 5.832075721142778],
            [7.320244003772791, 5.844027176699825],
            [7.3224591310116915, 5.854613006132301]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.24994185275416,
          "lat": 43.995167131811186
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26105"],
        "coty_name": ["Mason"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mason County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01622995"
      },
      "bbox": [
        7.2449666330878495, 5.494594803671653, 7.610102300093039,
        5.868329846966724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.3815811309612947, 6.7377393003444395],
            [0.46775453368203235, 6.738125245542871],
            [0.511120002741502, 6.73806634311329],
            [0.59779972625139, 6.7381307688411685],
            [0.6410212059068253, 6.7382418662165655],
            [0.7275764517120376, 6.738654226241617],
            [0.8143506275838313, 6.738508763183871],
            [0.8285291275929061, 6.73880181256926],
            [0.9144974523546036, 6.739710137786933],
            [0.986409514933093, 6.740463682015563],
            [0.9866843735343349, 6.6975276109937605],
            [0.987225803682989, 6.63931613891341],
            [0.9876750233177279, 6.610273876618318],
            [0.9878230169928316, 6.567534071895338],
            [0.9939779644410912, 6.567553439801253],
            [0.9946341814756868, 6.4817925507765555],
            [0.9080713545194636, 6.481452674745053],
            [0.8075403609805853, 6.479733053430435],
            [0.7358175819687064, 6.479166650238682],
            [0.7072195879178044, 6.479066218076742],
            [0.635555351129068, 6.47911657126937],
            [0.5638910646739591, 6.479153340492895],
            [0.47767158519305464, 6.479216619216513],
            [0.4378872400271904, 6.479419045383014],
            [0.4342625461101247, 6.483331018495455],
            [0.429770957947895, 6.485676207825641],
            [0.42431343560253154, 6.4837657366315335],
            [0.42144335959100754, 6.4862328716718896],
            [0.41133811147141996, 6.4917096875482585],
            [0.41042490307451707, 6.493152396925564],
            [0.40411309672759405, 6.492985642382532],
            [0.3980361773025668, 6.496733473152773],
            [0.3956185520337821, 6.501386906379754],
            [0.3906120755135984, 6.503918010044712],
            [0.39076471324367423, 6.566581433866197],
            [0.3809002957781389, 6.566609750204112],
            [0.3809059764528444, 6.65288039970978],
            [0.38076407210159957, 6.7247520718386165],
            [0.3815811309612947, 6.7377393003444395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.68146820771595, "lat": 45.28271042318393 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27151"],
        "coty_name": ["Swift"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Swift County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00659520"
      },
      "bbox": [
        0.38076407210159957, 6.479066218076742, 0.9946341814756868,
        6.740463682015563
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.3349194324842575, -6.876862009396225],
            [5.347449901250939, -6.869907241642852],
            [5.3524329028716675, -6.87019677431398],
            [5.360696395882669, -6.867102759011128],
            [5.367102134899866, -6.867031551388283],
            [5.37635744834132, -6.86397665212984],
            [5.3793500598608555, -6.861803842513539],
            [5.385676878162016, -6.859866727969284],
            [5.390362340539891, -6.854532322176551],
            [5.394918774412806, -6.8510177195730115],
            [5.399001724784737, -6.849933512607869],
            [5.402159341257951, -6.8461960064464655],
            [5.409784225626222, -6.842728816030162],
            [5.415388754900911, -6.843180255273035],
            [5.418969821590188, -6.842150673982421],
            [5.42101343178718, -6.839028028983701],
            [5.4288358462878845, -6.832665148547233],
            [5.433194893476374, -6.835962504320271],
            [5.436403560167453, -6.835565471080849],
            [5.560865874825987, -6.818848798611539],
            [5.562705824138305, -6.852311898369969],
            [5.569200913996073, -6.95462175786004],
            [5.573044402650925, -7.028324516067652],
            [5.574840412008947, -7.05687526674628],
            [5.589210333120984, -7.056024808373731],
            [5.592771955452483, -7.109779766464564],
            [5.597756060460223, -7.187174757336449],
            [5.591505050564005, -7.187565254319494],
            [5.592680341874961, -7.182302987103953],
            [5.585459640718626, -7.185975462378454],
            [5.583097935360106, -7.1840096509083],
            [5.562566786803932, -7.185115267669243],
            [5.528283057898659, -7.187356920709069],
            [5.531988594701067, -7.245652600142657],
            [5.525014243246501, -7.246281226670444],
            [5.525153914262837, -7.249705317652706],
            [5.521497927889339, -7.249941602799196],
            [5.521803910574431, -7.2534091745794],
            [5.496798751170111, -7.25505519878194],
            [5.496300198863434, -7.247895490718512],
            [5.489044143413014, -7.248370840388523],
            [5.488306056814831, -7.241106007894573],
            [5.473622547011545, -7.24183083880091],
            [5.473152196749778, -7.234476439760166],
            [5.459054151587869, -7.235489896023315],
            [5.358835171612521, -7.241953120976628],
            [5.358336948284238, -7.242057906780897],
            [5.35448218829053, -7.1842021193327055],
            [5.352309010055611, -7.147553880815174],
            [5.350665426699927, -7.124891611166753],
            [5.351937235919044, -7.119616493704206],
            [5.3494366990866675, -7.105241486192707],
            [5.340788626433983, -6.9670029948965],
            [5.3349194324842575, -6.876862009396225]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.10698431949018,
          "lat": 31.550194953738078
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28077"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00695762"
      },
      "bbox": [
        5.3349194324842575, -7.25505519878194, 5.597756060460223,
        -6.818848798611539
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.709405707081906, -5.9358541268663645],
            [5.702465960259676, -5.826273917418837],
            [5.693011384182338, -5.685337453879681],
            [5.689921500517745, -5.640533342195638],
            [5.746239645443144, -5.636619021147261],
            [5.786491687335749, -5.633510244468544],
            [5.844845715116074, -5.6292387367699535],
            [5.910810173218646, -5.62452935026786],
            [5.967646697116153, -5.620044258243626],
            [5.985529397880713, -5.6196117889384665],
            [6.031830578987966, -5.615578951879893],
            [6.035703350938773, -5.672043523205612],
            [6.036911110084561, -5.6791543193827305],
            [6.038183483324454, -5.697465999730894],
            [6.03899719854857, -5.697963980341162],
            [6.039162311787738, -5.711842140176008],
            [6.043403968954099, -5.773506394985534],
            [6.043826583678272, -5.776399603422551],
            [6.04980404636436, -5.85894213483891],
            [6.0546741984493595, -5.92153601295644],
            [6.054494885672196, -5.92221649987452],
            [6.0582429332503125, -5.970100027774129],
            [6.054057241476208, -5.9704181643578185],
            [6.010221485659514, -5.973733842039231],
            [5.880666656064172, -5.982272358197285],
            [5.843618079126549, -5.984941321943791],
            [5.79535513791182, -5.9881727557705355],
            [5.713310450829954, -5.992719486980119],
            [5.709405707081906, -5.9358541268663645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.52401774648874, "lat": 32.75352102403763 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28079"],
        "coty_name": ["Leake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leake County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00695763"
      },
      "bbox": [
        5.689921500517745, -5.992719486980119, 6.0582429332503125,
        -5.615578951879893
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.4258935394459025, -5.230496327549953],
            [6.45470097137676, -5.228329691300456],
            [6.545060841359112, -5.220914396952798],
            [6.638094588911466, -5.213610421703416],
            [6.7317974198224375, -5.204841617477175],
            [6.846802077649493, -5.19570655326713],
            [6.845564803878848, -5.263589754367048],
            [6.84475914950341, -5.281353900601051],
            [6.844745476693875, -5.300662058868121],
            [6.8423144250000805, -5.412452534531228],
            [6.841069033320986, -5.494894309521547],
            [6.839933577500794, -5.5574078811210725],
            [6.812084235377599, -5.5596259849886165],
            [6.755830424142764, -5.564717462131464],
            [6.690454811346227, -5.570492522996248],
            [6.590330730417009, -5.579263031093925],
            [6.5571123037383625, -5.581856647009368],
            [6.4633800177332965, -5.589695953052267],
            [6.453525306588568, -5.590610388995174],
            [6.444604256107512, -5.481896653718188],
            [6.440334805122755, -5.427626369287457],
            [6.4343814563458235, -5.343358189926092],
            [6.4258935394459025, -5.230496327549953]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.569753363391, "lat": 33.110154165287334 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28103"],
        "coty_name": ["Noxubee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Noxubee County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00695774"
      },
      "bbox": [
        6.4258935394459025, -5.590610388995174, 6.846802077649493,
        -5.19570655326713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.796304450609248, -5.092572265755043],
            [4.792282211937414, -5.016589237365767],
            [4.791525202215067, -5.005653525160689],
            [4.8780987933085465, -5.00074076872155],
            [4.874642201436424, -4.938065346109124],
            [4.872797668742724, -4.910205370262616],
            [4.872503164103605, -4.899774528439107],
            [4.871598617337155, -4.893173109898803],
            [4.86857634056616, -4.832497008846375],
            [4.865117271571103, -4.76578660259364],
            [4.86122775126954, -4.678218377212504],
            [4.858402022807272, -4.6285367596337865],
            [4.881802032881397, -4.627276020972396],
            [4.885247578244398, -4.627496066471686],
            [5.027753130488202, -4.62076217692636],
            [5.029214099095415, -4.635510125375784],
            [5.033150599261418, -4.708352550331119],
            [5.035566819568125, -4.756530866129876],
            [5.036956387171995, -4.7764204442941764],
            [5.037479787967382, -4.7954997004454745],
            [5.038413298106862, -4.810852895073623],
            [5.0400402351019205, -4.8473876890783565],
            [5.0421473340822915, -4.884147333333721],
            [5.043728455460342, -4.898452936361887],
            [5.04437423658867, -4.913100950357619],
            [5.049296947281139, -5.009754559885979],
            [5.050600098591898, -5.024511614730248],
            [5.051940914445344, -5.058091788182555],
            [5.056221592119396, -5.128106302940662],
            [5.059447904865849, -5.188360971962129],
            [5.0596270961566265, -5.188910027516656],
            [5.064477222670851, -5.27818579166132],
            [5.018610638344371, -5.280900150738291],
            [5.014391429145219, -5.28138103506702],
            [4.979722931812878, -5.2833753610239365],
            [4.983383497220708, -5.342051398749923],
            [4.9472740764565195, -5.343975507673094],
            [4.940737525377164, -5.34460851521341],
            [4.8514199817946455, -5.349546508558019],
            [4.849852744819018, -5.350066019446055],
            [4.810447421242374, -5.351911282538237],
            [4.80847954362063, -5.3227929948401735],
            [4.803808191813325, -5.235726169284972],
            [4.800138797447846, -5.176430520079252],
            [4.803469116026018, -5.176186296816173],
            [4.800307402004028, -5.121757657310784],
            [4.798146329049158, -5.092507227046126],
            [4.796304450609248, -5.092572265755043]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.58862669877242, "lat": 33.60229144902554 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28133"],
        "coty_name": ["Sunflower"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sunflower County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00695787"
      },
      "bbox": [
        4.791525202215067, -5.351911282538237, 5.064477222670851,
        -4.62076217692636
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.4541581841097, 0.4274630346294902],
            [3.4688559118179114, 0.4281603050880164],
            [3.5135394227952186, 0.4287363940712982],
            [3.5571613215545113, 0.42957069692525696],
            [3.644106582941133, 0.4327869438439241],
            [3.68966403423001, 0.4341849328151661],
            [3.7124114334746454, 0.4350407471231124],
            [3.735132440295854, 0.43535371194730077],
            [3.7610198588846635, 0.43629164064559445],
            [3.808103104248154, 0.4376374288513428],
            [3.8204113299029516, 0.43817791617465673],
            [3.8216105576559447, 0.3634222576418088],
            [3.821789688607758, 0.36286146279995996],
            [3.822067912911624, 0.31724072882518206],
            [3.8237545873999976, 0.24069451612143875],
            [3.824201219708823, 0.19691096129010477],
            [3.8252497624872226, 0.14562311395847166],
            [3.8258544807644594, 0.12614482223085063],
            [3.825478769149126, 0.10645571269725151],
            [3.826719481626994, 0.09190768872899285],
            [3.8267314241418275, 0.07898828276103202],
            [3.819757336732475, 0.07702948911288998],
            [3.812646886066763, 0.07691589925948145],
            [3.7992600870524567, 0.07895341438813641],
            [3.793488113707785, 0.08101099569824664],
            [3.7841698920838835, 0.08147114130742364],
            [3.7722014114187497, 0.0805959632611946],
            [3.7609032180409447, 0.07852277579494713],
            [3.754280806964864, 0.07157478064269254],
            [3.744226031673472, 0.059699166863490534],
            [3.740651378279436, 0.05665886572104407],
            [3.7236898678635977, 0.052861294233519936],
            [3.708549680713391, 0.05315471197715243],
            [3.6985463220503285, 0.05143363352723337],
            [3.692631603978999, 0.04916897814846323],
            [3.677861746744459, 0.04206238744472208],
            [3.6678254316444034, 0.038464230348294076],
            [3.6568107008644546, 0.03151994310877291],
            [3.6510043123614135, 0.02500439058959675],
            [3.645340033092878, 0.015130886230981975],
            [3.6410090364681205, 0.003090986603906565],
            [3.6393702681337996, 0.0005914225339500831],
            [3.6250974948720205, -0.01436990723324665],
            [3.619410587967079, -0.019131135721937483],
            [3.61087418961098, -0.029102777094820818],
            [3.6021755600590146, -0.0384142353316439],
            [3.595952328111755, -0.04117608334146485],
            [3.583963401283454, -0.04371038780788023],
            [3.5731240370720436, -0.04918666068089637],
            [3.5658558256510524, -0.05491694936547959],
            [3.552983902987951, -0.06695214651798091],
            [3.548000070832937, -0.0707006822549225],
            [3.540261838869299, -0.07388802984009162],
            [3.5149374104964775, -0.08184079275037241],
            [3.50781478918352, -0.08246745339236156],
            [3.484503029504715, -0.08096076906941896],
            [3.4747758038338863, -0.07953048182994517],
            [3.4639171345869606, -0.07662716738872911],
            [3.452442522221134, -0.07261646742615653],
            [3.448190993338554, -0.06991804919201301],
            [3.4369997218399284, -0.06579246527727371],
            [3.4284998012057653, -0.061203048860324676],
            [3.4153589807453697, -0.05200703424965705],
            [3.4048928175463185, -0.04352141309440009],
            [3.4014715459993043, -0.03842654465755467],
            [3.4008590906953304, -0.03190055536112306],
            [3.40126588055316, -0.020379056343445952],
            [3.399138848269171, -0.01324867315302993],
            [3.394934021914907, -0.006403297940546498],
            [3.38632256937284, -0.0007356403156732748],
            [3.3861808067565975, 0.045626487337009476],
            [3.383959745628291, 0.04669516878373669],
            [3.379933765454151, 0.05427177680879229],
            [3.3839185822251356, 0.05819140355601029],
            [3.3877795662789474, 0.059267731741842994],
            [3.3885644766493757, 0.06398890191314992],
            [3.386758741556943, 0.07136156397369983],
            [3.3897770900738737, 0.07716306714111346],
            [3.3959030895639546, 0.07759252269812224],
            [3.402775457988489, 0.08131945568558228],
            [3.4047861785397164, 0.08384148485708055],
            [3.40209877783493, 0.0925386245792928],
            [3.403473148602492, 0.0946299129189896],
            [3.409260036617243, 0.09387978179062197],
            [3.412296644387999, 0.09654226180039677],
            [3.412791225902216, 0.09987469318683419],
            [3.4089451123357373, 0.10368754786632468],
            [3.412156795424722, 0.10731100900206048],
            [3.411945834675874, 0.11063629153840934],
            [3.416336019139587, 0.11241054829487346],
            [3.4175074760723168, 0.11900196265642353],
            [3.4197767124763, 0.12402481835710188],
            [3.4258282965558475, 0.12388499638884723],
            [3.4268001751679105, 0.1311425492971402],
            [3.423769456830702, 0.1415721651784801],
            [3.4287130871306077, 0.14412849475139056],
            [3.427155618796162, 0.14953353070473496],
            [3.4302619573286335, 0.15228756994741008],
            [3.4303183340621994, 0.15528507730229785],
            [3.4272680350231175, 0.15982328056251968],
            [3.4313696585556137, 0.1637201165255541],
            [3.4354475291483233, 0.15620829589664142],
            [3.438477752148237, 0.15796827796468685],
            [3.435005053886093, 0.16150173753566643],
            [3.4334585196366993, 0.1654498709184611],
            [3.4384862941827232, 0.16618934522757944],
            [3.445331321643168, 0.17416577118963597],
            [3.4428913700359347, 0.17795003013618804],
            [3.4380433083474795, 0.174896321581327],
            [3.439215757342612, 0.18174177012831774],
            [3.4320962773016572, 0.1844522682857004],
            [3.4309764723027443, 0.18784876366303918],
            [3.4366333601355867, 0.19289424285040682],
            [3.4323149436498728, 0.19872266212004722],
            [3.4394143182615307, 0.20257581650891038],
            [3.4400933102643028, 0.2058916491525707],
            [3.434267326357085, 0.20563798526725452],
            [3.4361418208386487, 0.21362539270785233],
            [3.4323822612064916, 0.21159638850560675],
            [3.4289348509782993, 0.21489452410938256],
            [3.4340166334019724, 0.21872919936310747],
            [3.4323749454372283, 0.2265345478720401],
            [3.4300440564778363, 0.22770020544380826],
            [3.4257836178906222, 0.22463668750144536],
            [3.422375309184937, 0.22641584748723761],
            [3.424968983201956, 0.22960879397865902],
            [3.424357366241118, 0.23293995847266305],
            [3.426500827319839, 0.2408621199986989],
            [3.4314381082932908, 0.24024154095346942],
            [3.432014374944361, 0.24624003094907673],
            [3.4273454581788796, 0.24454826772861407],
            [3.4241540116730627, 0.2490371454436166],
            [3.425040076548564, 0.2528239598039777],
            [3.419970405159595, 0.2576816465284614],
            [3.418752545478146, 0.2610580488407065],
            [3.4192820083880857, 0.26722120043716907],
            [3.424133600669906, 0.2718957800662461],
            [3.426235472338012, 0.2784661725310445],
            [3.425758545352333, 0.2843228674981072],
            [3.4273009487811055, 0.2921266705429512],
            [3.426092016935024, 0.29379958211859436],
            [3.426976437152646, 0.3021749257986327],
            [3.426060922160417, 0.30443063229596723],
            [3.427624940495922, 0.31463415436043174],
            [3.4304880518137857, 0.31976018193069006],
            [3.4288735738791885, 0.3221855372894806],
            [3.432747451178317, 0.32909571364989665],
            [3.429523348942447, 0.3389261225974514],
            [3.429954438686861, 0.34235596443270394],
            [3.4341075404206984, 0.3446556481254827],
            [3.4366095043138705, 0.35367372135985026],
            [3.435110406509466, 0.35835085126848143],
            [3.4366478148587456, 0.36150235154132815],
            [3.434950227003565, 0.3677679191489323],
            [3.4388471090603026, 0.37473189289760567],
            [3.43822188160822, 0.38023365384019486],
            [3.4402198946430276, 0.38758322257826866],
            [3.4370732210038444, 0.3895538274925215],
            [3.432411060688625, 0.3893693189686306],
            [3.4321975174248327, 0.392142411232207],
            [3.4358024446890845, 0.3945745933412118],
            [3.437796986264352, 0.40752482065359485],
            [3.4409003473336344, 0.4110574427991319],
            [3.4381905725871995, 0.4132488448472218],
            [3.438705457462009, 0.4178066983692772],
            [3.437305073903263, 0.4219136962715161],
            [3.4379143210049095, 0.4270826410570677],
            [3.4541581841097, 0.4274630346294902]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.92599498758534, "lat": 38.8355043953211 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29027"],
        "coty_name": ["Callaway"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Callaway County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00758468"
      },
      "bbox": [
        3.379933765454151, -0.08246745339236156, 3.8267314241418275,
        0.43817791617465673
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5217762125567849, 1.358083906777559],
            [1.5370507836095944, 1.3583983972864753],
            [1.6376620178982462, 1.3595179345682238],
            [1.6824190804558765, 1.3605711313682416],
            [1.7306966735133398, 1.3614898848683408],
            [1.7865339956680426, 1.3597721684375386],
            [1.8151056659056757, 1.3586127884960688],
            [1.8267513534150268, 1.3584828210754394],
            [1.8278818038733355, 1.2245598296299913],
            [1.8296189523024693, 1.1107041468537078],
            [1.8300038545419834, 1.0887069900759927],
            [1.8304686662248901, 1.0823259013927877],
            [1.8303512080598217, 1.067204258916906],
            [1.8194355646419451, 1.0673795603410297],
            [1.7874522767575987, 1.0670148580150398],
            [1.744531766855745, 1.0673097156298847],
            [1.7299139123571248, 1.0666640309029685],
            [1.708801322904677, 1.0665582961381006],
            [1.6577958024983248, 1.0658011122836784],
            [1.6433256607575815, 1.0657859650168384],
            [1.572648413689896, 1.0646730661227162],
            [1.551813578870808, 1.0637726209070597],
            [1.5284770540179455, 1.063502401879155],
            [1.5269618376914484, 1.1368608156043634],
            [1.5251996575211886, 1.195622827927409],
            [1.5232599540987328, 1.2844776621667804],
            [1.5217762125567849, 1.358083906777559]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.40473557835851, "lat": 39.89317642015255 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29063"],
        "coty_name": ["DeKalb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeKalb County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00758486"
      },
      "bbox": [
        1.5217762125567849, 1.063502401879155, 1.8304686662248901,
        1.3614898848683408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.318502412293345, -0.8573870850998967],
            [2.361701251293527, -0.8577105500778873],
            [2.361375569452649, -0.8725654375191367],
            [2.45201768814779, -0.8733255462173308],
            [2.4829666981509244, -0.8737579884181846],
            [2.5143613612677687, -0.8745319368961446],
            [2.58089125997842, -0.8752690557697838],
            [2.663702093115211, -0.8749394161269655],
            [2.663162011565928, -0.9484175938195506],
            [2.6774184099830287, -0.9483504387628177],
            [2.677456399637195, -1.0144119793863453],
            [2.677762801002212, -1.0202069248724148],
            [2.677744037329288, -1.0442488001480208],
            [2.678075279719275, -1.1028124459386583],
            [2.678324175101337, -1.1050059884974663],
            [2.6783124017292224, -1.1464751793029793],
            [2.6791183171716546, -1.2339152950554364],
            [2.67948506567363, -1.2638890975042487],
            [2.6349361659317148, -1.2634401676877225],
            [2.6065639222168917, -1.2638105713695114],
            [2.5653109106644885, -1.2638134103168952],
            [2.547433626572412, -1.2633797603056556],
            [2.47531712783055, -1.263116531697108],
            [2.4595872667336205, -1.262746472548231],
            [2.4222863387968396, -1.26281323820024],
            [2.4133005110042793, -1.2631461306644711],
            [2.3343316696356444, -1.263004174320076],
            [2.3342105304801826, -1.2337967931539375],
            [2.3346778986238315, -1.1162917063796152],
            [2.334761799890031, -1.0734791103901706],
            [2.3352497561103687, -1.0133779365711386],
            [2.33551895997229, -0.9455189465937375],
            [2.3175390023887688, -0.9454165652610869],
            [2.3181779264161477, -0.9012179433010423],
            [2.318502412293345, -0.8573870850998967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.40054855292335, "lat": 37.61649977053054 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29167"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00758538"
      },
      "bbox": [
        2.3175390023887688, -1.2638890975042487, 2.67948506567363,
        -0.8573870850998967
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.068933250417876, -1.2513908614775082],
            [12.10484589592818, -1.2454977314373683],
            [12.140549364234156, -1.2410503511628577],
            [12.150472480324845, -1.2402129751717395],
            [12.208128058950944, -1.232499158810078],
            [12.212591446462788, -1.2327169132140798],
            [12.23593237872358, -1.230574150223213],
            [12.24933943506859, -1.2287667728380518],
            [12.282330398260646, -1.2254950751057436],
            [12.301528934355973, -1.2228148168173008],
            [12.33920914815482, -1.2194367266879398],
            [12.34530749307849, -1.219284523626619],
            [12.39079982754584, -1.2124764699598363],
            [12.42585213203481, -1.208350061658669],
            [12.419388310137562, -1.247854329137703],
            [12.416083994803833, -1.2466105722815204],
            [12.415579800974236, -1.2719853825845935],
            [12.413918530832506, -1.2750096118224594],
            [12.393272176717895, -1.3182937978153872],
            [12.38651154247619, -1.3253012690417092],
            [12.390119115591803, -1.3303961104310795],
            [12.412808470877136, -1.3562623058712542],
            [12.399799436884214, -1.3757666498108747],
            [12.39827221026298, -1.3816808613312979],
            [12.396034144487718, -1.38446162217864],
            [12.390085284084769, -1.3883403647370836],
            [12.388531580969895, -1.3914154430808714],
            [12.393812812500698, -1.4004068657668989],
            [12.392710853674624, -1.4033231386199585],
            [12.381736594581545, -1.4017606698021596],
            [12.368091251428199, -1.4122376281559537],
            [12.357486433347244, -1.411955522271998],
            [12.340830799117738, -1.3940322310050266],
            [12.337644070176792, -1.376410919171938],
            [12.310184682477063, -1.3738717394364635],
            [12.307902897019638, -1.369512307251679],
            [12.308117476356212, -1.3659134245308346],
            [12.304208594506244, -1.3628351853451632],
            [12.302293961157833, -1.3589059437551263],
            [12.2968591501748, -1.35782720659139],
            [12.29323134664612, -1.3534595758351178],
            [12.288372992222573, -1.3561605448620044],
            [12.269067005866875, -1.3720990974829916],
            [12.269756759736644, -1.3758410073502956],
            [12.26726441154365, -1.3831987356775286],
            [12.263426220369283, -1.3866991486599562],
            [12.26015532622009, -1.3822310182567992],
            [12.25496222998847, -1.381185669389163],
            [12.252859815955915, -1.3753154509660033],
            [12.242761320609654, -1.3724642025064395],
            [12.240819376297152, -1.3697897000333137],
            [12.225308734731215, -1.4061078245858636],
            [12.209088309428626, -1.4227472373360668],
            [12.204359392657434, -1.4316103791887873],
            [12.199123723324591, -1.4335298321666727],
            [12.192193526966985, -1.4404138351301674],
            [12.191537462969984, -1.4431273219007819],
            [12.18775870179432, -1.4460036263199378],
            [12.18277195809915, -1.44519747827464],
            [12.179766588998, -1.4466766211371498],
            [12.183462660831148, -1.4368026638919495],
            [12.184766575097624, -1.4305691654688644],
            [12.181800591825436, -1.4250087627834667],
            [12.182234887087612, -1.4211676239615831],
            [12.18002806494709, -1.418150269804928],
            [12.173237193019416, -1.4127332971869775],
            [12.16999759450259, -1.4115553949100275],
            [12.164284076434694, -1.4045301771709164],
            [12.162118785711929, -1.3993660481938142],
            [12.164323528455194, -1.3945129549254185],
            [12.162416363328616, -1.3913503332035948],
            [12.162007672045466, -1.3858105656163968],
            [12.156763433962988, -1.3782550534595508],
            [12.152663989938127, -1.3689668876865133],
            [12.14727977409882, -1.366085415899095],
            [12.143509246849737, -1.362633118356743],
            [12.138828653198996, -1.3562103515626809],
            [12.13418597599588, -1.3539478631890436],
            [12.130231283521276, -1.3536799536155937],
            [12.126509425596366, -1.3442236624578616],
            [12.119286729783532, -1.3395046085018552],
            [12.105303505112309, -1.3263229786003974],
            [12.100730912785535, -1.3177918398640247],
            [12.097429803982456, -1.3055807460149],
            [12.093541550392777, -1.3005422666691302],
            [12.089059792162542, -1.297785801534069],
            [12.084450679420126, -1.2909755762268131],
            [12.080032116942384, -1.2869668488983106],
            [12.078072284511741, -1.2834727671085286],
            [12.079469462105363, -1.2805704377585811],
            [12.078323437215975, -1.2736231927384178],
            [12.076034875048274, -1.2731830773803516],
            [12.07345820575552, -1.2799476146686832],
            [12.068933250417876, -1.2513908614775082]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.12706512162666,
          "lat": 36.491516445284944
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37005"],
        "coty_name": ["Alleghany"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alleghany County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01008533"
      },
      "bbox": [
        12.068933250417876, -1.4466766211371498, 12.42585213203481,
        -1.208350061658669
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.088637489592665, -2.345432453477886],
            [14.08901865986227, -2.3416519674290464],
            [14.087015606312942, -2.339304209765574],
            [14.085602617180292, -2.3312705730025143],
            [14.086844800717186, -2.3274910259260984],
            [14.150832514304259, -2.2962787559805458],
            [14.16271683626707, -2.291487644026433],
            [14.181410888614693, -2.2861538744641616],
            [14.204718391989097, -2.27835426959892],
            [14.209821921816081, -2.27798411875689],
            [14.21386515921705, -2.273581281344601],
            [14.220194054792612, -2.2722914529416465],
            [14.22611382887951, -2.2696800573406866],
            [14.228266638607517, -2.2667955489572726],
            [14.232319449727951, -2.2654610447547836],
            [14.237255618653052, -2.260447637546179],
            [14.241860839566186, -2.2620129170888243],
            [14.245718082703915, -2.2590729268181318],
            [14.25163205793148, -2.25839664649572],
            [14.254912569537069, -2.2544668128349334],
            [14.25560683731995, -2.2511735463049924],
            [14.253092545478117, -2.2467624789164313],
            [14.259273673943296, -2.242072708995408],
            [14.266248712364026, -2.2430092244685147],
            [14.269021651489902, -2.2368471025195076],
            [14.273604928540333, -2.2342800794533257],
            [14.273817538517747, -2.2314379195549305],
            [14.279023476487588, -2.2305070475636515],
            [14.289027006802122, -2.225731788446126],
            [14.290528092472229, -2.2214164000357055],
            [14.297721665470219, -2.2195053588538083],
            [14.30220775844506, -2.2215550019132873],
            [14.307049661293634, -2.220866893206536],
            [14.308904401969405, -2.2145966464817786],
            [14.314450090520246, -2.2105246573411903],
            [14.322802867295401, -2.2125319175083846],
            [14.327400325900836, -2.21065124085681],
            [14.332872079709105, -2.211097339723571],
            [14.334400235324974, -2.2134481327421014],
            [14.346369414316124, -2.207756036668561],
            [14.347213404342714, -2.210873628319271],
            [14.35296896453496, -2.2058499275383436],
            [14.356520563496856, -2.2050292777132263],
            [14.360577670259918, -2.2064934047022917],
            [14.365542192640545, -2.203814173856913],
            [14.368016776890382, -2.199755206189878],
            [14.37314755514083, -2.2013464077372067],
            [14.375512008202076, -2.205743481131414],
            [14.384452649994147, -2.204836220240807],
            [14.386379553559477, -2.2065400232047523],
            [14.458531060471632, -2.20479636596481],
            [14.46119321029389, -2.2124169721595286],
            [14.459157543143641, -2.216629096620346],
            [14.460566866727564, -2.221089149363703],
            [14.4576428559, -2.2304767950006474],
            [14.453048688200473, -2.234879216568923],
            [14.45159981970543, -2.2388778741094897],
            [14.455272510605162, -2.244221681414578],
            [14.460403554760818, -2.247231552455076],
            [14.457358979443958, -2.2512041752254492],
            [14.454751572975287, -2.251208035071842],
            [14.451219349448518, -2.2551965521712622],
            [14.447039386909987, -2.25299046619174],
            [14.444209902100408, -2.257707813351319],
            [14.449967267069864, -2.260986159228114],
            [14.453623715341296, -2.261089174960092],
            [14.45123363317225, -2.267431156606689],
            [14.452904295922632, -2.2710976186785685],
            [14.457213180072538, -2.275595112671058],
            [14.461127284390265, -2.2777863677864016],
            [14.460477719073172, -2.2821609498380533],
            [14.45750027213472, -2.2816355007258426],
            [14.455595424193348, -2.2860110736756543],
            [14.460973411858705, -2.287924993395119],
            [14.462127007525865, -2.293743798490366],
            [14.457420748098114, -2.2961520660688204],
            [14.45703573447417, -2.298198156171236],
            [14.460881944969625, -2.301689359609004],
            [14.45975460910468, -2.303884780683455],
            [14.461982276089408, -2.3109841279499683],
            [14.463851131939197, -2.3120534966794746],
            [14.461838122926588, -2.3206304268073277],
            [14.459659480020058, -2.324915771171374],
            [14.455387699210403, -2.3288973839964555],
            [14.453630203443538, -2.334774177918058],
            [14.457613995227756, -2.3359343045389234],
            [14.462051422813195, -2.3318739337050913],
            [14.464630536209393, -2.3367385143752153],
            [14.462041040127792, -2.3400716399747203],
            [14.456392561669334, -2.3411024217712195],
            [14.453904805077162, -2.3433054906693327],
            [14.456795860032424, -2.3508479204591373],
            [14.455339823168096, -2.3540258721683394],
            [14.4517225673603, -2.3566993492508894],
            [14.453474594032421, -2.360755295881075],
            [14.449509061673925, -2.363841197620918],
            [14.443885554285984, -2.3645689223115993],
            [14.445238860831466, -2.3746296448276674],
            [14.452731339298989, -2.3778051264737288],
            [14.454662875433476, -2.3862783552479274],
            [14.453790613518155, -2.3885664664557686],
            [14.457297990128264, -2.3922731007500078],
            [14.457133379402675, -2.39554261689177],
            [14.461154052962007, -2.399170898113521],
            [14.46464459716975, -2.4049093318317984],
            [14.462052763559281, -2.4120867625422027],
            [14.467336784516977, -2.417794675054329],
            [14.466564504276365, -2.4199198712944314],
            [14.472776777728585, -2.4268673459755146],
            [14.471148293254318, -2.432697936031128],
            [14.47465683152796, -2.43595185152859],
            [14.474413399765101, -2.4382274831318798],
            [14.479802367522714, -2.4440936572997174],
            [14.481130825648226, -2.460393847134876],
            [14.492280035677583, -2.4650981692305134],
            [14.490670640835566, -2.46933709892778],
            [14.495320782430422, -2.4722299693289314],
            [14.500939017056043, -2.478021898307936],
            [14.508648971947048, -2.483480329826516],
            [14.51397287414967, -2.4853614419088763],
            [14.519770906323403, -2.4928517564479464],
            [14.530835886525722, -2.4949315625500796],
            [14.534502684560499, -2.4993723755167507],
            [14.541393744160443, -2.5041865419032088],
            [14.550609899226421, -2.5037943498905553],
            [14.551427493824566, -2.5096733013365022],
            [14.554313980092351, -2.5138203781773782],
            [14.55865069247389, -2.514585536121138],
            [14.562475861137969, -2.5214060570917027],
            [14.57006663804575, -2.523226379032125],
            [14.575344877094444, -2.520660929175066],
            [14.580028797453496, -2.5253826814011746],
            [14.578014818575339, -2.531957057777166],
            [14.579382908781815, -2.536076684786222],
            [14.588804362122081, -2.541495805163247],
            [14.596067026107535, -2.5429004472187464],
            [14.597915225926718, -2.5488827822162556],
            [14.601620815053181, -2.5502990985064278],
            [14.606067501336282, -2.5492472470773513],
            [14.608631236901543, -2.5528030420126044],
            [14.610819798463435, -2.5625841017917135],
            [14.620085710094779, -2.5654497421903866],
            [14.620586419756544, -2.5679717378546267],
            [14.626966893150456, -2.569773760718121],
            [14.627922147270832, -2.5726282121037265],
            [14.619322121180652, -2.577926427788953],
            [14.612681229603941, -2.585979474768695],
            [14.597711016282105, -2.5834220528853846],
            [14.487896432429036, -2.60395881669832],
            [14.362688038609697, -2.6271318201989153],
            [14.305745806246629, -2.653293876848475],
            [14.302539840884391, -2.6518111291174273],
            [14.291195487925998, -2.6408813525620043],
            [14.280539895534915, -2.6284963310519616],
            [14.28367424145083, -2.62106165468937],
            [14.282222802101316, -2.616389944855088],
            [14.278739684108752, -2.6111386876729554],
            [14.276769001227132, -2.605896562857657],
            [14.268608246646517, -2.598655140833196],
            [14.265137537422138, -2.596726708816823],
            [14.262375921284166, -2.5914382463189765],
            [14.25137904920656, -2.5872598177213266],
            [14.249380085255309, -2.5836584367345874],
            [14.175195991923605, -2.5566710490925466],
            [14.176543135377422, -2.5459355286703125],
            [14.170221432551623, -2.5397054817497997],
            [14.1625677358083, -2.5297026598281165],
            [14.162481431224094, -2.5258072832482217],
            [14.159416179484296, -2.519341114832793],
            [14.152631835201007, -2.5140839376133437],
            [14.146634509630331, -2.5042658936829705],
            [14.138044583020559, -2.500094286541629],
            [14.136728060091183, -2.4967487607554375],
            [14.125643654852025, -2.4843140539340736],
            [14.124102370457624, -2.4812790280902948],
            [14.118026977096894, -2.4755162503373787],
            [14.116018613890088, -2.4704794945261757],
            [14.117581216788881, -2.4668447346217355],
            [14.113299400800498, -2.462105742593683],
            [14.11483291772474, -2.4582417364264235],
            [14.112721618680258, -2.453721938468096],
            [14.113668787893257, -2.4472110779118754],
            [14.111669687235924, -2.4403089998034178],
            [14.108816155424698, -2.438708339764313],
            [14.109498981062488, -2.4348618740481287],
            [14.105899496281802, -2.4267000130127623],
            [14.10328366634536, -2.425913503161981],
            [14.100470186594668, -2.4203942027042764],
            [14.10111700030011, -2.418350083600363],
            [14.097849178220411, -2.411288374957697],
            [14.096443770892712, -2.405366593526553],
            [14.08835691729209, -2.3963211119456758],
            [14.085047433141952, -2.3955552109226663],
            [14.088637489592665, -2.345432453477886]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.8277435648693, "lat": 35.04874642184309 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37051"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01026124"
      },
      "bbox": [
        14.085047433141952, -2.653293876848475, 14.627922147270832,
        -2.199755206189878
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.209100599941683, -2.3061824984439485],
            [15.300245320374593, -2.2234658364642415],
            [15.355161463567752, -2.108472434172034],
            [15.325808763135896, -2.042137558575135],
            [15.371036372616167, -2.047628671220733],
            [15.389955738920404, -2.0541611085413165],
            [15.501358669430383, -2.1031586353599083],
            [15.627524228899835, -2.148629238850298],
            [15.625763167759509, -2.1536512311492184],
            [15.62845769528778, -2.159280108517443],
            [15.62899664867209, -2.163153401635794],
            [15.635400904582067, -2.166038153288029],
            [15.638734681548767, -2.169759190336586],
            [15.643074055984066, -2.1690801861366507],
            [15.64614007539678, -2.166603483980637],
            [15.649052000242818, -2.1603497838484507],
            [15.654532511521621, -2.162800603021192],
            [15.656980868548137, -2.1616758212877665],
            [15.664428214152199, -2.166658968733227],
            [15.66550034808604, -2.1626182560966356],
            [15.670050911415283, -2.1606070445844696],
            [15.67411294135003, -2.153805176784937],
            [15.674737815476032, -2.1481802731363016],
            [15.680761378875937, -2.1463038284579765],
            [15.684719908424755, -2.1468564538419903],
            [15.685878399908352, -2.144085941670859],
            [15.692115922539063, -2.148557463455047],
            [15.696351946681537, -2.162389689550475],
            [15.695973349239667, -2.1702384651653883],
            [15.697958879007027, -2.1725016361503457],
            [15.701444432432446, -2.181884697558488],
            [15.708897036599392, -2.1877278986570725],
            [15.70689322740175, -2.192030975358494],
            [15.707553064671789, -2.198363756630518],
            [15.721103016858214, -2.2727507125527384],
            [15.730175347757275, -2.3273014231703804],
            [15.740072385084535, -2.3833103192289284],
            [15.788100072292641, -2.367835654801918],
            [15.786632903315082, -2.3711046225485743],
            [15.775410703215552, -2.3862311330942028],
            [15.770511408559612, -2.3914774874789644],
            [15.768360565428827, -2.397611378597171],
            [15.76305656743409, -2.3988592057121276],
            [15.759814749665837, -2.40473246359751],
            [15.761247273026276, -2.410575538580562],
            [15.756490930071372, -2.41241741508767],
            [15.754032852903883, -2.4110830089342263],
            [15.746755320164809, -2.4104072576938673],
            [15.743833190043823, -2.41781725511001],
            [15.741565127418898, -2.4208458757552203],
            [15.73458857992552, -2.423096791877945],
            [15.728347542974477, -2.4192151452879567],
            [15.720149444032177, -2.4220277889282578],
            [15.719796096144771, -2.425332726400183],
            [15.71218947718166, -2.428181723000278],
            [15.70547140717629, -2.4286422689436717],
            [15.703537964559068, -2.432235233428538],
            [15.705633158404899, -2.434525592291219],
            [15.703559261412332, -2.437660630747437],
            [15.700013239681201, -2.4394775757511016],
            [15.695782233315578, -2.436288826984781],
            [15.694172683998229, -2.4287518189197153],
            [15.682563706172735, -2.4242301806297792],
            [15.680894104806336, -2.4204884585385815],
            [15.674919523721348, -2.418409541344868],
            [15.676087721075127, -2.4131364781896774],
            [15.680504317715943, -2.406471532656467],
            [15.680975292418886, -2.3994584318945025],
            [15.683940408366958, -2.395457585989966],
            [15.680176102393567, -2.3887383761874594],
            [15.675855407225406, -2.3935739057920986],
            [15.672450582401492, -2.3956905645696605],
            [15.664971203349513, -2.394277395463701],
            [15.664791803486585, -2.3878457952276055],
            [15.659947331237936, -2.381768635517354],
            [15.653897848904492, -2.377936180604323],
            [15.653838952516589, -2.371876012125349],
            [15.647051437787745, -2.3659086134281573],
            [15.643733337031449, -2.360795356929843],
            [15.646021489572261, -2.3590058365152595],
            [15.635946937730274, -2.346084954538624],
            [15.631461851728686, -2.3491427466652977],
            [15.629072945582204, -2.348484812142289],
            [15.629552586799536, -2.343605552232941],
            [15.623940086188334, -2.341851115447746],
            [15.62440621953354, -2.337003343551343],
            [15.615050281848676, -2.3371370055503573],
            [15.61118206571425, -2.3334129081846298],
            [15.609060295087751, -2.327431770713374],
            [15.603743944038065, -2.3296080286404086],
            [15.603657189851988, -2.3255161465886993],
            [15.600367564687673, -2.3210020537848726],
            [15.597761713554808, -2.320293128017246],
            [15.5945742657545, -2.3148274878795685],
            [15.581196866035846, -2.3151864893994865],
            [15.575961566384054, -2.312497986128037],
            [15.572132721155155, -2.3144959735036266],
            [15.568872073171638, -2.311656112127318],
            [15.563675879073665, -2.3122676381078193],
            [15.558989514192492, -2.3098695463647796],
            [15.556710490271435, -2.315330065817982],
            [15.548540421142636, -2.3145318736023555],
            [15.540991390188617, -2.3117723357638353],
            [15.533791654280131, -2.31800455364389],
            [15.531686967109819, -2.322538499987769],
            [15.52267677235552, -2.3256605006355375],
            [15.51725839396444, -2.3325138584372254],
            [15.518908772100263, -2.347493459411218],
            [15.398506533347009, -2.308650083115936],
            [15.345147564973816, -2.311163373536112],
            [15.287064223466535, -2.3152934710152606],
            [15.260531819779505, -2.331317122726192],
            [15.209100599941683, -2.3061824984439485]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.35510442995431, "lat": 35.02169823965647 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37103"],
        "coty_name": ["Jones"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jones County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01026338"
      },
      "bbox": [
        15.209100599941683, -2.4394775757511016, 15.788100072292641,
        -2.042137558575135
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.7476391521585644, 9.009396989890105],
            [-3.744658382757479, 9.007139878985532],
            [-3.7335502652582075, 9.002195305096338],
            [-3.7173957448862196, 8.99840472772091],
            [-3.7101687293270893, 8.999613304786369],
            [-3.7007764756028387, 8.999602857507506],
            [-3.69378983373789, 9.001320128272678],
            [-3.685059066101651, 9.000567553004457],
            [-3.6764225243446838, 9.001493492168878],
            [-3.668701899569571, 9.00405157111727],
            [-3.6601874542736574, 9.003119398604662],
            [-3.6509772056064196, 8.998211948850948],
            [-3.643328671727297, 8.998614709845357],
            [-3.6374213563360436, 9.000504168855402],
            [-3.633416028063907, 9.000350753314107],
            [-3.628601802823122, 8.996902570438946],
            [-3.624072949656637, 8.986884463155828],
            [-3.624871817671843, 8.983984968251125],
            [-3.630888398175617, 8.975119961138882],
            [-3.632051919358325, 8.971849870997326],
            [-3.6285581141092065, 8.96582919665812],
            [-3.6233263026437843, 8.963534662087195],
            [-3.611014203991892, 8.965468780141892],
            [-3.6042567927301623, 8.965655818608068],
            [-3.5919117271100767, 8.964485214144382],
            [-3.5855608343441827, 8.963133091942863],
            [-3.5746945624995483, 8.958425290687554],
            [-3.5668274987025725, 8.953152188994359],
            [-3.5598789150074097, 8.947226588854893],
            [-3.539539283900146, 8.928082083314633],
            [-3.534596981369492, 8.926263711709845],
            [-3.5228252489802294, 8.926058179780664],
            [-3.513778468764638, 8.922556055213015],
            [-3.5019986242844583, 8.916291768461853],
            [-3.493933719502087, 8.914748151456806],
            [-3.485766997026208, 8.916810679076159],
            [-3.4755018562477074, 8.922844450888642],
            [-3.4700519279235587, 8.924841587867595],
            [-3.436174366503925, 8.945519258621468],
            [-3.430501854531966, 8.948073162161247],
            [-3.412372746043701, 8.95299818659439],
            [-3.405613398098463, 8.953325594340402],
            [-3.3974031174289245, 8.951841460122594],
            [-3.383558687472388, 8.947708745876215],
            [-3.3682949537113767, 8.940663138152587],
            [-3.36379507353184, 8.9396479764528],
            [-3.357990052879324, 8.940786527142226],
            [-3.3477323532617658, 8.939863299403802],
            [-3.324687336239652, 8.94369592472767],
            [-3.3092795942294564, 8.948486631486585],
            [-3.3052292368215763, 8.951137852675116],
            [-3.2793632118549296, 8.95772848399736],
            [-3.2696733753685354, 8.9624469139858],
            [-3.2643612292688275, 8.962452832241079],
            [-3.2568065752458333, 8.960789088260142],
            [-3.2390813466927217, 8.967393371734527],
            [-3.2338351382420103, 8.968291027560563],
            [-3.2268654191825457, 8.967610438530393],
            [-3.2214255749030762, 8.965240970864096],
            [-3.217178691959157, 8.961072754312935],
            [-3.2014371278486555, 8.940332531428455],
            [-3.1968978175073284, 8.937777593575158],
            [-3.1856176334596173, 8.929207111400503],
            [-3.1838962621293425, 8.926290527675576],
            [-3.1850820039420342, 8.920646064939728],
            [-3.1884514452529342, 8.916154817421663],
            [-3.196776319624583, 8.910255043781337],
            [-3.2091627175745088, 8.90524699464059],
            [-3.218283019153866, 8.900022354121106],
            [-3.2228103865150874, 8.896061445333814],
            [-3.234446243935145, 8.88271934917555],
            [-3.236655404478916, 8.875173796649872],
            [-3.236181624583163, 8.869246201867151],
            [-3.2337944860620693, 8.86456929867132],
            [-3.224443218356711, 8.853042908863005],
            [-3.2179319552861108, 8.840675817968407],
            [-3.2153314407100475, 8.827839961310467],
            [-3.2142355632970028, 8.813710541471483],
            [-3.2131468204490403, 8.80774638190918],
            [-3.2083846387199464, 8.795672297585263],
            [-3.1963684128768555, 8.777975300005117],
            [-3.189434124174043, 8.773946814970657],
            [-3.1865404967191013, 8.769652336220696],
            [-3.1872881681180436, 8.760148506194184],
            [-3.1860640249923113, 8.744530564783412],
            [-3.1862797383325074, 8.729975727657575],
            [-3.181385984130966, 8.717595787316782],
            [-3.180573269796835, 8.709083803473433],
            [-3.181281725910269, 8.701444611680909],
            [-3.1806993180605745, 8.697277393905695],
            [-3.1769738021050764, 8.69431356479056],
            [-3.1638216899819254, 8.692500711193457],
            [-3.149884762850692, 8.685231397479953],
            [-3.1392930516844038, 8.68159577865013],
            [-3.13056029501675, 8.676488559337054],
            [-3.124130977736236, 8.671704494125075],
            [-3.1217722560901113, 8.667440027944938],
            [-3.123477456528989, 8.644342144868391],
            [-3.2243500736079125, 8.650142242941655],
            [-3.2911623634400486, 8.653878422679584],
            [-3.3579754228426184, 8.657600618774087],
            [-3.425797548196526, 8.66163454208381],
            [-3.440201340774505, 8.662979873790881],
            [-3.444465455638206, 8.66279777823864],
            [-3.469005799712535, 8.66400737346007],
            [-3.4720657122642615, 8.609989769259457],
            [-3.474393165443917, 8.574778546553578],
            [-3.4810443353391216, 8.465621240110602],
            [-3.4845101687079194, 8.408761910109028],
            [-3.5683938850162265, 8.413905947806791],
            [-3.63983187434009, 8.418360309473735],
            [-3.7112708565259114, 8.422798948927884],
            [-3.744759820967107, 8.425029907550195],
            [-3.7428292482037775, 8.453403558675006],
            [-3.7353102749600957, 8.565958757681887],
            [-3.730532384204888, 8.637905211555939],
            [-3.7221894170243583, 8.765292603593453],
            [-3.7637576858335615, 8.767957637448884],
            [-3.7611112365795476, 8.809980028890502],
            [-3.758999838368765, 8.838836026809647],
            [-3.753909950863824, 8.916769631618978],
            [-3.748526027114264, 8.998313406576967],
            [-3.7476391521585644, 9.009396989890105]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.83148926589134,
          "lat": 47.30920985687596
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38057"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01034233"
      },
      "bbox": [
        -3.7637576858335615, 8.408761910109028, -3.1217722560901113,
        9.009396989890105
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.508139186767513, 2.066669750748122],
            [9.502906185284559, 2.1569863927447988],
            [9.591104302722645, 2.1611872947262185],
            [9.670455946323333, 2.165257345275384],
            [9.677832407472087, 2.165443108678524],
            [9.678632521677772, 2.150752254038322],
            [9.708366790526274, 2.152333136655465],
            [9.767021521205878, 2.154548326241936],
            [9.856263934357976, 2.157803849557053],
            [9.891233351989715, 2.1589945502709815],
            [9.899419216095964, 2.1595284383025812],
            [9.906424788021608, 2.0593690260958253],
            [9.90758608951862, 2.044655061097486],
            [9.910339534015517, 1.9798456759499172],
            [9.911605249289718, 1.9427976896295804],
            [9.84484275414935, 1.9380445846444676],
            [9.823382677286205, 1.9367369439207194],
            [9.798805333272243, 1.9360105491686985],
            [9.785145516519341, 1.9350162183843589],
            [9.72642487890704, 1.9322828229578346],
            [9.696974317145573, 1.9310602521616396],
            [9.647030593557545, 1.9283113837314496],
            [9.612540464599489, 1.926229866040544],
            [9.603863172278045, 1.9263738604481841],
            [9.546541130949555, 1.923608075265994],
            [9.543913889224386, 1.923116130292479],
            [9.516474291830052, 1.9215872132426401],
            [9.510436550989615, 2.0225293095847494],
            [9.508139186767513, 2.066669750748122]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.76956325065126, "lat": 40.13770235639023 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39021"],
        "coty_name": ["Champaign"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Champaign County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01074023"
      },
      "bbox": [
        9.502906185284559, 1.9215872132426401, 9.911605249289718,
        2.165443108678524
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.462001084763022, 1.797818259250244],
            [10.459996812720586, 1.827356494108003],
            [10.47451534351571, 1.8280406129585325],
            [10.47259091143783, 1.8502357288311277],
            [10.470814809592808, 1.881070593916443],
            [10.469660193268691, 1.8900930047780158],
            [10.46833786451806, 1.9166349952597876],
            [10.454129470602076, 1.9155447706375435],
            [10.45174200703296, 1.9452537678131527],
            [10.473246365575271, 1.9467311341661075],
            [10.480535235199392, 1.947408955669762],
            [10.550201427609514, 1.9522398771003728],
            [10.603899909170792, 1.9564638382502002],
            [10.625567650673752, 1.958520536907813],
            [10.683362076852868, 1.96323748413119],
            [10.707829323461254, 1.9650661007849448],
            [10.715048805582574, 1.9715158922018359],
            [10.719662063543957, 1.9003741295533805],
            [10.720088112848154, 1.8888878551315502],
            [10.721172739639236, 1.8774692712965713],
            [10.757406023211846, 1.87986961972888],
            [10.778862679665274, 1.8815097588202574],
            [10.78047111661178, 1.866904745586934],
            [10.785440931876884, 1.8000779645297729],
            [10.785826811200552, 1.7923639811352392],
            [10.814926935033084, 1.7944340751802508],
            [10.821159525439944, 1.7060801898951485],
            [10.764445110913242, 1.702118236166515],
            [10.732767238143369, 1.7002563425980561],
            [10.736804942468698, 1.6408476859887284],
            [10.696524109064036, 1.6379175932648267],
            [10.644231162675032, 1.6335374538436565],
            [10.648629447126078, 1.5886911694857464],
            [10.625950299921174, 1.58672738739857],
            [10.564591069092058, 1.5820115798505279],
            [10.565702465248567, 1.567269729111189],
            [10.494706513272181, 1.5634447901429573],
            [10.480426459086262, 1.562510033889923],
            [10.474652784423466, 1.6513193509633937],
            [10.472183993771061, 1.6511393614486527],
            [10.470246250375393, 1.6779287029082055],
            [10.462001084763022, 1.797818259250244]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.6305788761669, "lat": 39.75163163038604 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39045"],
        "coty_name": ["Fairfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fairfield County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01074035"
      },
      "bbox": [
        10.45174200703296, 1.562510033889923, 10.821159525439944,
        1.9715158922018359
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.846743191887985, 1.6352203798954557],
            [9.848244571346918, 1.6354235802248562],
            [9.931601729732598, 1.6397106607211123],
            [9.98061716090548, 1.6419448358618713],
            [9.988811890280306, 1.6429656735838178],
            [9.993937302864559, 1.6425492507873498],
            [10.065392357984315, 1.6476492594765877],
            [10.088280095023652, 1.6496543496876288],
            [10.126994600316804, 1.652496076837477],
            [10.1525016545205, 1.6539853490228047],
            [10.155075924600844, 1.616949695743065],
            [10.158021164745403, 1.5824815644059336],
            [10.163329456967022, 1.510120626492798],
            [10.165855990870929, 1.4733453369100689],
            [10.145475121855911, 1.4242719803041068],
            [10.129689571850298, 1.3858599506753284],
            [10.115628207829323, 1.3509579201137554],
            [10.10414940238275, 1.3237041685901192],
            [10.097387692199517, 1.3229751731905681],
            [10.028690038373117, 1.3140501036814176],
            [9.973367545963942, 1.3072539618841328],
            [9.938372641339889, 1.3030921415711276],
            [9.936008925670945, 1.3393535288580698],
            [9.930236005589018, 1.4243016301834737],
            [9.930077042577533, 1.429909208392242],
            [9.927633518571863, 1.4704502127918389],
            [9.890874460165607, 1.4688549073758224],
            [9.855754662477834, 1.4668478599767822],
            [9.853092575975834, 1.5158733083676375],
            [9.850712760651843, 1.5557703251805304],
            [9.849269686564762, 1.5882075436103806],
            [9.846743191887985, 1.6352203798954557]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.45611698324913,
          "lat": 39.559883933506775
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39047"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01074036"
      },
      "bbox": [
        9.846743191887985, 1.3030921415711276, 10.165855990870929,
        1.6539853490228047
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.95096881040932, 1.0852015593113566],
            [10.944310315081193, 1.1749207584988508],
            [10.943424054279026, 1.1892653305356689],
            [10.940364177079791, 1.2268610305325667],
            [10.937532248484898, 1.2646213809828573],
            [10.966712926241442, 1.2670912839440025],
            [11.025281688057055, 1.2715124205654924],
            [11.134968711296525, 1.2800537731239676],
            [11.169456386496238, 1.2834506558321563],
            [11.202605103068299, 1.2864730918710157],
            [11.294760759480976, 1.2953023019701757],
            [11.359537260086013, 1.3016019385572117],
            [11.362086483509579, 1.2927506648262483],
            [11.372879910453596, 1.2708382950686357],
            [11.376178315703969, 1.249290044122413],
            [11.379527854786117, 1.2395480330016067],
            [11.3804587987958, 1.2292771544065317],
            [11.37888049413485, 1.217605697202085],
            [11.375833222615105, 1.2115303607598293],
            [11.36752073924393, 1.2022110910877948],
            [11.359928044047276, 1.197391049377695],
            [11.355487451767516, 1.1964154972784005],
            [11.34816095680866, 1.1970471622554417],
            [11.342068051753495, 1.1992942760779821],
            [11.334528151310291, 1.1992826540741237],
            [11.330672147528597, 1.1939052482046204],
            [11.333064218025598, 1.1805867376209007],
            [11.335303023293317, 1.1744925355693456],
            [11.343403349287499, 1.1635636491733814],
            [11.346091040277729, 1.1612119347857035],
            [11.35785237432084, 1.1544089944324603],
            [11.369840366078956, 1.1455990189483016],
            [11.378026471380789, 1.1357063347383918],
            [11.379254904900353, 1.1229264991903842],
            [11.374926258510335, 1.1164198536886436],
            [11.373218766638521, 1.1092837310058734],
            [11.373074007363332, 1.1041932548015736],
            [11.374490042098394, 1.0999097534415518],
            [11.372529902426624, 1.0914839861116614],
            [11.372234511771747, 1.0834377966915816],
            [11.375861005116914, 1.0747524586956225],
            [11.386259157181088, 1.0665574859479514],
            [11.392134888242252, 1.0589438314156738],
            [11.395341381022847, 1.0585590094286013],
            [11.396528055274777, 1.0550556210455513],
            [11.39474752458962, 1.0469082233406348],
            [11.390433659368504, 1.0433149205325971],
            [11.384427656495117, 1.0424284754965574],
            [11.375148619177335, 1.0443254589460396],
            [11.366026292935757, 1.0493883730058815],
            [11.357145573881628, 1.0578665801486133],
            [11.350367845090984, 1.0609878421819947],
            [11.342082728077287, 1.0601867363423465],
            [11.337574823882907, 1.0565431517552355],
            [11.333567998321422, 1.049243027254168],
            [11.329934519737227, 1.0401342197379526],
            [11.331057681741177, 1.0244250107105088],
            [11.33210038576095, 1.021412813276125],
            [11.3308542988259, 1.012364179402212],
            [11.324706452896102, 0.9999919954482144],
            [11.31390514550975, 0.9891705986103035],
            [11.303973383716023, 0.9806463074483944],
            [11.29683009162396, 0.9798877130807551],
            [11.288546521088595, 0.9826086842828002],
            [11.282149586720736, 0.9875840865884674],
            [11.272617259870877, 0.993645743228125],
            [11.27099992082621, 0.9972515629319421],
            [11.271396683463601, 1.0033736697125986],
            [11.28050418782038, 1.0192807726492894],
            [11.28296987217222, 1.0215260344091526],
            [11.288168452324651, 1.0304704015461994],
            [11.288671993011762, 1.0348306412957762],
            [11.285848727867982, 1.042643909976062],
            [11.280141038307548, 1.0495394372160636],
            [11.274335503600856, 1.057941439233328],
            [11.26811326182212, 1.06951802621277],
            [11.26013026255591, 1.0794655229104972],
            [11.253573727712014, 1.0888484252657915],
            [11.246154000404578, 1.0934949546952237],
            [11.238423974822334, 1.0951371756138844],
            [11.232595014492663, 1.0934480851408446],
            [11.22645379784132, 1.0902158812907683],
            [11.219119607447325, 1.0888440278978586],
            [11.215186723404521, 1.091339761769726],
            [11.212419182542865, 1.100910630015307],
            [11.20894278259023, 1.1070278399122238],
            [11.201372447024067, 1.116619523151027],
            [11.195016024656972, 1.1211871828759077],
            [11.188300536843467, 1.1221711735392599],
            [11.179342920815879, 1.1203949313970931],
            [11.172755821754876, 1.1169960908302665],
            [11.168598695503452, 1.1131787832503965],
            [11.166362777048207, 1.105616179440191],
            [11.165541646686513, 1.092229002738743],
            [11.162437229104391, 1.0821779278285277],
            [11.150663176270488, 1.0707447815006172],
            [11.143226003145466, 1.0657698310897623],
            [11.136587907393741, 1.059587032379312],
            [11.134200502504429, 1.0541352696554156],
            [11.133847752573619, 1.0475507383080793],
            [11.131714848239156, 1.0408502242894222],
            [11.127768254479172, 1.0856336147511252],
            [11.01814824394405, 1.0762997612061527],
            [10.962623157011105, 1.071652782426492],
            [10.952294311377074, 1.0705830928398181],
            [10.95096881040932, 1.0852015593113566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.02286044673424, "lat": 39.08226463545959 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39105"],
        "coty_name": ["Meigs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meigs County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01074065"
      },
      "bbox": [
        10.937532248484898, 0.9798877130807551, 11.396528055274777,
        1.3016019385572117
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.645685511146239, 2.0472205006515445],
            [11.710911260929935, 2.0553617793133134],
            [11.728907403790105, 2.0574454914396387],
            [11.730600742547471, 2.056488245494795],
            [11.781155026552979, 2.0622382357787106],
            [11.812383479525112, 2.065383633984964],
            [11.812606650381236, 2.063690110164259],
            [11.825989979623046, 2.0652087573191977],
            [11.914755315695292, 2.073632316111738],
            [11.961029071188193, 2.0790491700685494],
            [11.958095348116368, 2.0700713163104627],
            [11.959587403286113, 2.0643310273191835],
            [11.964140971013109, 2.0539988877480964],
            [11.966494166633465, 2.0408278987060045],
            [11.965670887067564, 2.0272874675860644],
            [11.959998305116846, 2.0183101058240625],
            [11.94162917389113, 1.9995306907655261],
            [11.939715900186398, 1.9956898583286888],
            [11.938315310999362, 1.9871052880244866],
            [11.943418959762774, 1.9773975432297746],
            [11.95311457354906, 1.9680645694646097],
            [11.96036879433179, 1.9643464901318748],
            [11.969737018557955, 1.9516642706907703],
            [11.972594260245188, 1.948943563422997],
            [11.974247146466451, 1.9478430449182624],
            [11.976816627818756, 1.9404544811586328],
            [11.975055808898182, 1.9316478719661447],
            [11.967548901531766, 1.9262956702415077],
            [11.962211522501649, 1.9245388839609014],
            [11.955687358969634, 1.9184489575187886],
            [11.953753928797777, 1.9108425824161042],
            [11.954382572505606, 1.902772852756457],
            [11.957725468110748, 1.8872315255100627],
            [11.958540198753314, 1.8770069558473568],
            [11.957079272717337, 1.870928117978214],
            [11.957431095752952, 1.8628790295304285],
            [11.955578153135425, 1.8504443302843694],
            [11.953314569849178, 1.8435645286209443],
            [11.945018240037848, 1.8381987934978596],
            [11.934171710656598, 1.8381731124674565],
            [11.925558161961252, 1.8370727309317951],
            [11.919571482662507, 1.8347800589424674],
            [11.914368248689508, 1.8313084306924403],
            [11.907718429315548, 1.822189355216731],
            [11.890298743810128, 1.8022476124143734],
            [11.879301304835538, 1.787352444208865],
            [11.875758397541507, 1.7806495652801617],
            [11.865812964453921, 1.7704298975837218],
            [11.855978695300669, 1.758155772613651],
            [11.85237388025305, 1.7503280335133315],
            [11.846749983503027, 1.7441605750763387],
            [11.843119407285482, 1.7763467460069202],
            [11.763489276454054, 1.767548250927486],
            [11.683617801707586, 1.7582855305080909],
            [11.684007346405723, 1.7558516538425528],
            [11.669979109747922, 1.7538794604946124],
            [11.666350762412359, 1.7824505014425203],
            [11.652091924481551, 1.7806859719395118],
            [11.642495920767248, 1.8537141806550257],
            [11.640029657328824, 1.8670234318685974],
            [11.638193042652933, 1.8819673419090195],
            [11.609131970452838, 1.8776919934285223],
            [11.603365342307567, 1.920912623801058],
            [11.593591042905574, 1.9983440417683613],
            [11.588117835500398, 2.0399127560383263],
            [11.645685511146239, 2.0472205006515445]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.08291538434787, "lat": 39.72736321645731 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39111"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01074068"
      },
      "bbox": [
        11.588117835500398, 1.7441605750763387, 11.976816627818756,
        2.0790491700685494
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.021152125649306373, -4.843258535206604],
            [-0.019995534255047114, -4.841156582790383],
            [-0.023145163228031517, -4.836105668834057],
            [-0.02126834148289742, -4.832783342971035],
            [-0.015477579204033561, -4.8282129613440095],
            [-0.014788693041314192, -4.822673529123848],
            [-0.019726034894661505, -4.822399347367804],
            [-0.015267731051749226, -4.817784478317763],
            [-0.014795523866262601, -4.8130457314610124],
            [-0.020758537587256876, -4.811321535749144],
            [-0.02473488076852688, -4.805007081000569],
            [-0.022883072790666502, -4.8020237183173755],
            [-0.02391004554381584, -4.7974241176812855],
            [-0.027375404972418554, -4.792233942716517],
            [-0.022770312024050547, -4.786722472119423],
            [-0.020311137190516335, -4.789930435092092],
            [-0.017375769634456122, -4.787523782659557],
            [-0.018653453790344283, -4.7840380161708635],
            [-0.015311817694508748, -4.782998222489907],
            [-0.011928073142916567, -4.779494641581978],
            [-0.01124457912201091, -4.773518692036424],
            [-0.017283539947685875, -4.771374412070867],
            [-0.017526106473506272, -4.766929943693579],
            [-0.024897292533007816, -4.76680106992936],
            [-0.02489271250730307, -4.763706541530585],
            [-0.028686044403441874, -4.762870536950588],
            [-0.030379080838972703, -4.7583154016019105],
            [-0.03419502525009423, -4.757203852909164],
            [-0.0333105976826663, -4.752351613656341],
            [-0.04047228914994726, -4.747786412082914],
            [-0.041741446660291254, -4.7405836580767],
            [-0.049098015027381356, -4.7351125298422],
            [-0.043857862390916436, -4.727323168214357],
            [-0.03342557351640254, -4.729739724220262],
            [-0.03178172220699225, -4.723398721724382],
            [-0.024426154022986937, -4.720900231138016],
            [-0.021665606919690796, -4.726357008402932],
            [-0.015870951272812645, -4.730847133675267],
            [-0.012563693045308156, -4.728592847154292],
            [-0.00853101318066196, -4.721046734928506],
            [-0.012436671112459054, -4.714136351417393],
            [-0.0075716912443061545, -4.709061330141794],
            [-0.01328613463018774, -4.706436899481287],
            [-0.010286316414089957, -4.703839074482728],
            [-0.008705830788187046, -4.695615843456921],
            [-0.004652656099610061, -4.6938937601263735],
            [-0.002979388225422256, -4.689678811594313],
            [0.004903138634511211, -4.687199595557892],
            [0.006606065447812577, -4.681321453217792],
            [0.01350656532883263, -4.674003914020721],
            [0.010996222549210089, -4.665857517554992],
            [0.006786723022258149, -4.663706928840538],
            [0.0031220999481666773, -4.664117342594945],
            [-0.00009437610604220414, -4.660359235566597],
            [0.0044619827214602715, -4.659387750751418],
            [0.00682735059657348, -4.656363428916333],
            [-0.0004413301580318324, -4.655406758785317],
            [-0.0038548395276694217, -4.651426285471989],
            [-0.0012408016109230634, -4.649027343062845],
            [-0.0047855452042298696, -4.642462714236561],
            [-0.013984695395421139, -4.632505811868463],
            [-0.012106465566499644, -4.629314162293555],
            [-0.01582523880782151, -4.626088382537875],
            [-0.017182776300828987, -4.622792556888588],
            [-0.015930762211785687, -4.622945875921092],
            [0.09086948125829489, -4.623741944178497],
            [0.09102421117354179, -4.580300915839026],
            [0.12911154574546868, -4.580504106695438],
            [0.14452527158546702, -4.580721156604911],
            [0.20039229189134616, -4.580914938182981],
            [0.2818063448035301, -4.58131621508143],
            [0.3425118256951667, -4.581477941853214],
            [0.4706557700238134, -4.581733216454636],
            [0.47630731656526515, -4.584247824112577],
            [0.4858256336358012, -4.584540040318742],
            [0.4926321317991333, -4.5883067410255025],
            [0.4946437304360538, -4.58733963895184],
            [0.4998675891355981, -4.589450878960199],
            [0.5042133153435823, -4.596920164418141],
            [0.5049903680473384, -4.609494681862887],
            [0.5097815596757529, -4.6145835442035015],
            [0.514510741232851, -4.613070947423267],
            [0.514447108390157, -4.669262600255039],
            [0.5146042610691569, -4.6707307846216075],
            [0.514797393913531, -4.791190827961084],
            [0.5164850854211452, -4.796988712484685],
            [0.522293965368211, -4.799807762419243],
            [0.5245386185099452, -4.804995528484451],
            [0.5281718028156632, -4.807838830539192],
            [0.5274354424471921, -4.810717734516285],
            [0.5305582924144477, -4.814432707927796],
            [0.5383436337815658, -4.817669381906248],
            [0.5414965118237741, -4.8168290535900935],
            [0.5451455079067388, -4.8194957832982475],
            [0.5488887915680618, -4.817761059885577],
            [0.5565376567595602, -4.820981996865062],
            [0.5572888462668565, -4.823727800561246],
            [0.563741744510043, -4.823728887214572],
            [0.5731619739583301, -4.835723858232009],
            [0.5741041610946931, -4.843100944402735],
            [0.578148859853153, -4.85218094270563],
            [0.5841939182085346, -4.854418478414168],
            [0.5862964800890266, -4.858387344133446],
            [0.593337717037512, -4.861591256331674],
            [0.5942485906602484, -4.864197629848127],
            [0.5981551796852493, -4.866228755261548],
            [0.6016132337225085, -4.86384175857822],
            [0.6053479752571581, -4.866451015690302],
            [0.6099927463755248, -4.865917527137985],
            [0.6168331479758744, -4.8667306265427195],
            [0.6243781610252108, -4.8694498955576355],
            [0.6310084230215847, -4.865830449548952],
            [0.6394925919065808, -4.865988607771956],
            [0.6438628085515155, -4.8712295373707075],
            [0.6490330471536006, -4.864970932436828],
            [0.6534142444974856, -4.868045145742157],
            [0.6569328854954769, -4.868473226526898],
            [0.6603427542087081, -4.866287930052319],
            [0.6684554063641125, -4.878397521221247],
            [0.668385915355923, -4.883961525501081],
            [0.6636857069554507, -4.889512264871637],
            [0.6586476265838749, -4.892751905135509],
            [0.6529051197574625, -4.894326717558448],
            [0.6484927691300875, -4.892287602398098],
            [0.6452005230573609, -4.888260265405028],
            [0.6431311425657691, -4.888547063386871],
            [0.6369565409781689, -4.881900054049998],
            [0.6279022179030923, -4.878380226669464],
            [0.6243518546430077, -4.878295212945734],
            [0.614078329207702, -4.8806051036200815],
            [0.6107460670131333, -4.883010375127184],
            [0.6129868755215586, -4.895228625580348],
            [0.6115036489979377, -4.899137876536696],
            [0.6053602718216743, -4.903675871886653],
            [0.5977166096780995, -4.904104792546423],
            [0.5904021236888151, -4.899700887359894],
            [0.5828497044343873, -4.890460161416179],
            [0.5734598753142809, -4.88824955076047],
            [0.5668646848250034, -4.88380085992979],
            [0.5571367109686701, -4.874880564030571],
            [0.5506486665491203, -4.872282205614914],
            [0.5413514790050923, -4.865623780726773],
            [0.5248937542208028, -4.854649604899328],
            [0.5194061678868138, -4.856437473518066],
            [0.5159676433263669, -4.869095773877653],
            [0.5121523370277506, -4.878128164574003],
            [0.5096665606184416, -4.879944452825655],
            [0.5027695785972285, -4.88140763860269],
            [0.48669278734486415, -4.883407423251437],
            [0.4767214510331826, -4.887130576077357],
            [0.4767186674391248, -4.875347514982552],
            [0.4726488764675483, -4.871145277417267],
            [0.46487988184938944, -4.867491996834785],
            [0.46093296063938044, -4.867377522934829],
            [0.4600806530093165, -4.869989340584123],
            [0.46263885401998395, -4.876258995859649],
            [0.4682529890119958, -4.878297518529301],
            [0.465099479904036, -4.888752668935879],
            [0.4593737848178667, -4.894317217324105],
            [0.44758067789280936, -4.8992730130994975],
            [0.4445783186081805, -4.897352245126762],
            [0.44763035283047303, -4.886293882877031],
            [0.4440329114042296, -4.882709694591822],
            [0.439473342671653, -4.883430114919066],
            [0.43787605679552855, -4.892562595873896],
            [0.43307633447835653, -4.898587178875743],
            [0.42347428805950116, -4.903377529873013],
            [0.41103534815713005, -4.898296466395984],
            [0.3939713594394464, -4.893131108906559],
            [0.3812195618129349, -4.891798865011003],
            [0.38008215166787085, -4.893064363363912],
            [0.383234779320218, -4.901874213231249],
            [0.3833860583936713, -4.907103604592258],
            [0.381807080696022, -4.909365279387997],
            [0.37304128039380663, -4.9074225691187445],
            [0.3663063353143792, -4.901906253221088],
            [0.36236615205904904, -4.899813572999392],
            [0.34921079755174544, -4.900603498696247],
            [0.3416519885441344, -4.901957162691584],
            [0.33870725959200254, -4.907827145245279],
            [0.3410273424143911, -4.920626549183979],
            [0.33939662673610926, -4.9228420486735835],
            [0.3345400809827736, -4.921593717157933],
            [0.3278160883647426, -4.922009941475843],
            [0.31867040511100775, -4.925175156196078],
            [0.3161273224270719, -4.929259226393378],
            [0.3192572063663051, -4.937898138599853],
            [0.3231931546541134, -4.940483516670217],
            [0.32371867052336356, -4.934944556000734],
            [0.3260038319960218, -4.928725139606931],
            [0.3301743273449708, -4.9266578236946685],
            [0.33244323455047997, -4.929658481687585],
            [0.33084213728551226, -4.934088783701758],
            [0.330713600908998, -4.944176760441474],
            [0.32945755735983995, -4.951145479057839],
            [0.3239003873525059, -4.96983984562632],
            [0.31677935774000837, -4.979473573686009],
            [0.30975984093052567, -4.983617606633261],
            [0.2987351511527699, -4.987868077882497],
            [0.28170279081353555, -4.992573924248177],
            [0.27468604321356116, -4.991924210446128],
            [0.258858269739304, -4.980881518051691],
            [0.25281426633381954, -4.977761751279646],
            [0.24620357538575574, -4.972336872871766],
            [0.23444901400876061, -4.969282928230566],
            [0.2258630180294741, -4.96851083273197],
            [0.22135656476914597, -4.970315470200731],
            [0.21901633085666763, -4.973940955542951],
            [0.21362139990665568, -4.988887045993526],
            [0.20995423360490648, -5.004803054268956],
            [0.2105822406398751, -5.013052149933422],
            [0.21019763434655023, -5.019872998192541],
            [0.20774774234550908, -5.029395114946854],
            [0.2019602323799909, -5.040906538190016],
            [0.19849595939563536, -5.044804907889479],
            [0.18959290552819208, -5.0464309183895635],
            [0.1845048461743432, -5.051149674129994],
            [0.17599308449286816, -5.0534758097539845],
            [0.16968438694473553, -5.052673969090586],
            [0.1645373800872063, -5.047976189678756],
            [0.16370141417960943, -5.038710325416689],
            [0.15852894766948517, -5.02287853693035],
            [0.1504607139623175, -5.013809002511217],
            [0.13064617665192266, -4.993184715980862],
            [0.12252303682914378, -4.981685204424355],
            [0.12030015303775558, -4.9732611509795595],
            [0.11498283131106776, -4.963260680188716],
            [0.10874733781719552, -4.9606105390988064],
            [0.09404541428038503, -4.958157416027976],
            [0.08485091384197813, -4.963933290818713],
            [0.07335058148090307, -4.963663345821064],
            [0.06263710170349315, -4.966053114058279],
            [0.050910320248223076, -4.96642100487278],
            [0.041348192417910365, -4.9574436915259446],
            [0.03808392464540299, -4.951086541946293],
            [0.0376136608669234, -4.935655631833757],
            [0.03491433953196383, -4.927432251301017],
            [0.029405178318786102, -4.917823125625833],
            [0.024295754565487063, -4.915672985454638],
            [0.009133759741896036, -4.919477064150483],
            [-0.003302504062409934, -4.9200244861210205],
            [-0.00877425154723377, -4.919402660222952],
            [-0.02037199416922077, -4.910388342348806],
            [-0.032033876956813846, -4.903974312475721],
            [-0.05004177197416214, -4.896676107055918],
            [-0.05507319961029933, -4.892623106791096],
            [-0.05476243139795073, -4.885680192887098],
            [-0.051792066912856934, -4.881549146472883],
            [-0.04064144623520854, -4.869100212911209],
            [-0.028551726200846856, -4.863068654812365],
            [-0.022553603601530633, -4.857520699523124],
            [-0.018586279194806543, -4.849230302178088],
            [-0.021152125649306373, -4.843258535206604]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.25973664420377, "lat": 33.96224625185394 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40013"],
        "coty_name": ["Bryan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bryan County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01101794"
      },
      "bbox": [
        -0.05507319961029933, -5.0534758097539845, 0.6684554063641125,
        -4.580300915839026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7470278863839224, -2.7788043236495636],
            [-2.734908389406336, -2.776468076363918],
            [-2.7240202445866464, -2.772158572243199],
            [-2.7197880264130974, -2.7689796179520445],
            [-2.713535512242348, -2.761235515968732],
            [-2.692964919277315, -2.752549005705365],
            [-2.685315310281655, -2.748655918858667],
            [-2.68187696892372, -2.7425949249553607],
            [-2.6712808955860585, -2.734646942584931],
            [-2.668686658268333, -2.7260716409128047],
            [-2.6696130262459197, -2.720372400360874],
            [-2.6724280755710357, -2.7181358753261033],
            [-2.673483248450659, -2.707451964017963],
            [-2.6723264587673086, -2.7004992881425154],
            [-2.6695860699375085, -2.6958596567219204],
            [-2.6585565260723283, -2.6857319355859737],
            [-2.6577604640659254, -2.6786934842961494],
            [-2.6527155257468564, -2.675147444491888],
            [-2.6423719959988325, -2.6756191192937044],
            [-2.637035837629674, -2.6726792423865047],
            [-2.6253963171943484, -2.660279047538831],
            [-2.6191237067284896, -2.658118513973223],
            [-2.611601605012939, -2.657700021121811],
            [-2.6001300630908113, -2.6594375181261105],
            [-2.59242401727638, -2.6622230426425095],
            [-2.5890466544477553, -2.665417669205811],
            [-2.585890822254975, -2.677245116203571],
            [-2.58689794535109, -2.6818702667704115],
            [-2.5844623204699673, -2.694297091697037],
            [-2.586837532844013, -2.70177517973768],
            [-2.5894317706253265, -2.705459879878856],
            [-2.591192718438778, -2.7124548507198867],
            [-2.591514250926353, -2.720362957298897],
            [-2.589651319113592, -2.725094667874804],
            [-2.592509343541208, -2.7317680614332804],
            [-2.592544728771377, -2.7370481780250997],
            [-2.5885047238216568, -2.7415491254976656],
            [-2.586551914954235, -2.745881646557079],
            [-2.5862027477961247, -2.7557279754132917],
            [-2.5824128865143736, -2.759690802088617],
            [-2.5771460664040067, -2.76254302654978],
            [-2.5737870688920053, -2.7674798677880856],
            [-2.5689033776135592, -2.7707954011882028],
            [-2.5675025714274406, -2.778246694845594],
            [-2.559742648300236, -2.7850279662759054],
            [-2.5550758711911103, -2.7871293762475715],
            [-2.5487499699406206, -2.7854817422621125],
            [-2.5432708502879047, -2.7863686183094423],
            [-2.540117819593812, -2.788786733527625],
            [-2.5370890876501755, -2.7935896079336238],
            [-2.5300646171014294, -2.798660064361232],
            [-2.5258291623396336, -2.803477409794369],
            [-2.5250092335328076, -2.8066669011121705],
            [-2.5206189242273846, -2.8096439368033153],
            [-2.5021392395870223, -2.8156779082182113],
            [-2.4955650558145517, -2.818708941034933],
            [-2.4894423626606064, -2.819693401781863],
            [-2.47865770580728, -2.8193057276684215],
            [-2.4697004765358868, -2.821346938342274],
            [-2.4553545564737806, -2.8289765801165703],
            [-2.4414737263155293, -2.8297519217701494],
            [-2.4359004347199424, -2.8253298487270913],
            [-2.4282356540819388, -2.817096096946992],
            [-2.4084879155541783, -2.8141243770954683],
            [-2.400914721341655, -2.811334384278966],
            [-2.3959476142322584, -2.810778169253867],
            [-2.3930971788760593, -2.8082481696932757],
            [-2.3898537018975867, -2.795265542832566],
            [-2.385257276656798, -2.7871264899250114],
            [-2.386918255856609, -2.77941336178583],
            [-2.3847023492595416, -2.774031820621443],
            [-2.380411254602508, -2.771807212044528],
            [-2.3734117960410503, -2.7661666524120916],
            [-2.3718774716306665, -2.7630300161702737],
            [-2.363967716227271, -2.7549812280660833],
            [-2.3562152233309837, -2.7492902938939126],
            [-2.352438495371577, -2.7383162979670366],
            [-2.350853480554704, -2.7359426566564213],
            [-2.3503611483219036, -2.7292716417784697],
            [-2.3479230460852225, -2.7262878031533715],
            [-2.347078915236316, -2.7173649162403692],
            [-2.3426633393879817, -2.7081890859130273],
            [-2.3416305488721485, -2.7030751054687387],
            [-2.3386197431659843, -2.696537730726058],
            [-2.3298370141497378, -2.6892363921810736],
            [-2.323682795840159, -2.6900245911002645],
            [-2.3172995895223005, -2.6847061694117045],
            [-2.311441292421819, -2.6760298640579028],
            [-2.3024447098264074, -2.6708466464568468],
            [-2.2905852674100933, -2.6685805593436007],
            [-2.2783896163411637, -2.6652412552286977],
            [-2.2667384490752167, -2.665061367370311],
            [-2.260260968506998, -2.6659125994395785],
            [-2.247347969510319, -2.664594519672633],
            [-2.245412347299589, -2.6654129106458955],
            [-2.247628741139603, -2.7305736551980524],
            [-2.247871494142555, -2.7322506111591025],
            [-2.2496414726882064, -2.7803033523533176],
            [-2.2454914946087094, -2.7804386601373876],
            [-2.248437526666808, -2.867784078180365],
            [-2.251622141299313, -2.940370808889463],
            [-2.256072263321023, -3.056824708038289],
            [-2.2587654016683416, -3.1300324125860906],
            [-2.2483522710973602, -3.130422474074103],
            [-2.249894681008745, -3.1736414610146726],
            [-2.349269661890807, -3.1699374989173656],
            [-2.405371016030138, -3.1680159346429075],
            [-2.420483341690603, -3.167348658791984],
            [-2.42387109577657, -3.2551323705952306],
            [-2.452955550127176, -3.2541709509404457],
            [-2.551613635074094, -3.249801067581549],
            [-2.6664054709111316, -3.2451032571613845],
            [-2.7665048124750595, -3.2407761923956753],
            [-2.7609836109566235, -3.109839118473127],
            [-2.75815435692864, -3.0427361579458427],
            [-2.7527620415303593, -2.9148322964338096],
            [-2.7470278863839224, -2.7788043236495636]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.69576046502587, "lat": 35.68830787470504 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40129"],
        "coty_name": ["Roger Mills"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roger Mills County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01101852"
      },
      "bbox": [
        -2.7665048124750595, -3.2551323705952306, -2.245412347299589,
        -2.657700021121811
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1666934894370058, -3.087408681448004],
            [1.2590688890723953, -3.0866752229055554],
            [1.3815192396638238, -3.085335192418737],
            [1.4239786721629069, -3.084861430824028],
            [1.5098151361670398, -3.0839074093275816],
            [1.5953316001792157, -3.0827430729556964],
            [1.6696337929829363, -3.0815849771844888],
            [1.6938571332343273, -3.0809955004021408],
            [1.7022818291296113, -3.1371845417112523],
            [1.7146743241780973, -3.2235736688541072],
            [1.731607298777034, -3.3273227966846415],
            [1.727891920963043, -3.3347713738381803],
            [1.7195735196965993, -3.3409724803685976],
            [1.7125074964888067, -3.342705185610013],
            [1.7077932592081897, -3.342638528618449],
            [1.6979914818094572, -3.3456731617284934],
            [1.6893662699547192, -3.3522192233026766],
            [1.6869459407680847, -3.3568296361226793],
            [1.6876869397974943, -3.3613675559907974],
            [1.6921333195156203, -3.3694270654339897],
            [1.690619371784044, -3.3726934528230443],
            [1.6807695231395876, -3.3794027300314644],
            [1.6809523098405512, -3.392248572555847],
            [1.6832803993933785, -3.3966463238784272],
            [1.6904380197153823, -3.403885940227405],
            [1.6923170008872461, -3.412515482062678],
            [1.6890111400861998, -3.4173168158788014],
            [1.6816062999397463, -3.421126408459863],
            [1.676244368623764, -3.4164684314788643],
            [1.668108622299657, -3.4179204691056437],
            [1.6616171134924145, -3.4143225132631767],
            [1.650030797142428, -3.4183913960544396],
            [1.6425761364468365, -3.417871372363205],
            [1.6385790855775746, -3.4165315374737313],
            [1.6328715032110872, -3.412723824839245],
            [1.6208948590210033, -3.3973725353378676],
            [1.614923515279349, -3.3942129504218546],
            [1.6001155632041302, -3.3953323348190216],
            [1.5968883984932116, -3.3969198418810027],
            [1.5928817416159866, -3.4017747535978873],
            [1.5834216992731878, -3.419610145248389],
            [1.5759611810592784, -3.426354053635005],
            [1.5693732270159024, -3.430228521640841],
            [1.557650796945783, -3.43295287691747],
            [1.545364528249065, -3.4317839325912693],
            [1.5407457831114204, -3.4293651793528634],
            [1.5351632959461803, -3.4239060499172314],
            [1.5328860617390718, -3.4196343614376428],
            [1.5322527727685888, -3.4059373237904733],
            [1.5309429262950565, -3.4016751823951035],
            [1.5272795612011019, -3.397061813190811],
            [1.5224120221494504, -3.3945314733587173],
            [1.5117548583662956, -3.3920526566009115],
            [1.5030901185075205, -3.3849045143153176],
            [1.4981784700065397, -3.3786849570932076],
            [1.4904541426146167, -3.3727251867748733],
            [1.4841068430311213, -3.3700922221325103],
            [1.474049040181666, -3.3678872360000685],
            [1.4583054300862701, -3.3697561641892233],
            [1.4513162417771266, -3.3742998920903435],
            [1.446127787866052, -3.383137663591583],
            [1.441798484120954, -3.3941223137365744],
            [1.4387428828640836, -3.398439356092335],
            [1.433486207051418, -3.400654943313228],
            [1.4232190905849782, -3.402403014481539],
            [1.4174842138980022, -3.3999111501465658],
            [1.4149303786592917, -3.396418821472252],
            [1.4118587413426815, -3.3883754804065305],
            [1.4104863867473176, -3.3789392825448004],
            [1.4101635094350888, -3.3637178701429153],
            [1.408463833693967, -3.360078639813761],
            [1.4036954097659662, -3.356206969173908],
            [1.3995727777977718, -3.3546104524021665],
            [1.3935144258303922, -3.3572139687422298],
            [1.3856665872704272, -3.365924846009565],
            [1.3805514504517886, -3.3694304796610464],
            [1.3566929848409441, -3.3771740334883806],
            [1.351496108501735, -3.379731875314142],
            [1.343463004215424, -3.3798825180816183],
            [1.337930289663629, -3.37615565743076],
            [1.3374356227493114, -3.3724076122221667],
            [1.3405784786818293, -3.3678305795181194],
            [1.3508824144425426, -3.3591142410333776],
            [1.3570407722918025, -3.3530995755728155],
            [1.358932871125279, -3.3464421496866334],
            [1.3588795909072864, -3.3417401042199],
            [1.3555804895727444, -3.3342967849267096],
            [1.3510185935334686, -3.328137939455712],
            [1.3487031383358283, -3.3272601147067062],
            [1.343504734735682, -3.3289867249846616],
            [1.3387756112516789, -3.3324853994594883],
            [1.3317567160094437, -3.3334895563560862],
            [1.3213957062938444, -3.329828672316593],
            [1.312921687031505, -3.3191744499846862],
            [1.3045915351839497, -3.318254699671308],
            [1.2991145900090015, -3.3198796462167057],
            [1.2918288581505777, -3.318703410747183],
            [1.2822346410175272, -3.3183850877661705],
            [1.2713686897491647, -3.314828547921309],
            [1.2662702508687287, -3.312288249525162],
            [1.2553203535554276, -3.301931261795298],
            [1.2521955503919697, -3.296624813152513],
            [1.2514179835418255, -3.291697094789681],
            [1.252330710880009, -3.278290655681328],
            [1.2509904496867867, -3.2736707462969994],
            [1.2420696557918598, -3.2698330506155777],
            [1.2360148130484891, -3.269894131020699],
            [1.2307481272211478, -3.268033963700393],
            [1.2213952053360806, -3.261880284774645],
            [1.2180950025649977, -3.262214952177631],
            [1.2087083400477336, -3.2683494821693277],
            [1.2057991453232804, -3.268075430232216],
            [1.1996892800114123, -3.2623924176125865],
            [1.1962352674064036, -3.247415987515445],
            [1.1931915175291126, -3.2414007740933126],
            [1.183840780378641, -3.2340354435504777],
            [1.1730716324885677, -3.2214415460568144],
            [1.1699203684189385, -3.215096742167831],
            [1.1675207676698767, -3.2057769949297863],
            [1.1636583096956814, -3.2010179485102896],
            [1.1634049570727183, -3.1750752959715514],
            [1.1674210923401465, -3.1750264907639707],
            [1.1669867156923497, -3.124023842377389],
            [1.1665447663110367, -3.106103131943843],
            [1.1666934894370058, -3.087408681448004]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.75520806595361,
          "lat": 35.495351384413155
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40135"],
        "coty_name": ["Sequoyah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sequoyah County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01101855"
      },
      "bbox": [
        1.1634049570727183, -3.43295287691747, 1.731607298777034,
        -3.0809955004021408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.353653676746639, 4.331481042381084],
            [15.382604844255507, 4.418744243945555],
            [15.355730440022839, 4.4319069233579835],
            [15.362194068859123, 4.450829689417833],
            [15.370898742323682, 4.48047296818518],
            [15.366142905999633, 4.485355087031851],
            [15.386177797807951, 4.552970578862642],
            [15.391389890249728, 4.553010771297567],
            [15.393258579795944, 4.555552071261782],
            [15.391062258485684, 4.5608380653070695],
            [15.440145308478778, 4.571388785542403],
            [15.4618818687079, 4.575835019432746],
            [15.52787794220424, 4.589909036169017],
            [15.577785358318256, 4.600736242990793],
            [15.591568405557446, 4.548713544116506],
            [15.602044947550233, 4.508228313159236],
            [15.620923802006773, 4.439892694650263],
            [15.622063340627843, 4.434508895587271],
            [15.629369476213082, 4.406751693139142],
            [15.649151854752718, 4.329966845300868],
            [15.675954576450598, 4.2285171607096546],
            [15.673934876224585, 4.22359306483342],
            [15.668370750965993, 4.220174603086886],
            [15.665722366342118, 4.22118174776556],
            [15.663958943837144, 4.213930404657174],
            [15.65874555359373, 4.213046532373661],
            [15.658764465043378, 4.209455465720531],
            [15.648969658311717, 4.210111106299518],
            [15.64749055758739, 4.2055719122247845],
            [15.64318003414359, 4.20383078133903],
            [15.63941256377763, 4.2041147245911565],
            [15.63743926804665, 4.197180952798334],
            [15.634699325031017, 4.192371828459337],
            [15.629604442516555, 4.177715687127891],
            [15.622192801820855, 4.179841058966913],
            [15.61867347205575, 4.182751394765964],
            [15.611271160919282, 4.179973734124603],
            [15.606229121803164, 4.170578412425811],
            [15.604260250870372, 4.16011498984083],
            [15.598981008019807, 4.1566028440170095],
            [15.597077548737534, 4.150279864600985],
            [15.59522655224378, 4.148981401643105],
            [15.596520348107552, 4.141427087598764],
            [15.593012307181073, 4.135950741142839],
            [15.594675561593007, 4.1273651298206095],
            [15.590486159393782, 4.125308834811021],
            [15.587651094412612, 4.120493924764633],
            [15.579984831411194, 4.118074128348132],
            [15.582903592662642, 4.112416532770336],
            [15.58062113612525, 4.107470054469754],
            [15.575314134436155, 4.1090920110625255],
            [15.572031604837008, 4.108371408073595],
            [15.566677659295369, 4.115946450054046],
            [15.561836924324638, 4.111881751067982],
            [15.556171467076311, 4.110568263468402],
            [15.552301266059803, 4.11146735019758],
            [15.549184320822006, 4.115787038930924],
            [15.546258660381891, 4.115198541886806],
            [15.544792170814118, 4.12102272926799],
            [15.539733772952813, 4.125013971104027],
            [15.522479038854884, 4.193512767886635],
            [15.501300513428584, 4.196040837238435],
            [15.496211143344736, 4.219277592952573],
            [15.48873297844068, 4.217478719415255],
            [15.48434806832682, 4.233554113880662],
            [15.481995650278467, 4.232813641501029],
            [15.478506542022066, 4.245911104478974],
            [15.483634283716235, 4.247287123493484],
            [15.478457603436757, 4.268394497049859],
            [15.437758681287926, 4.2687160011116685],
            [15.415268103785305, 4.281391624772302],
            [15.392903859702715, 4.288672249411786],
            [15.388532608243525, 4.2934072895951765],
            [15.382869044086444, 4.294804502791461],
            [15.372341624347136, 4.295254043193484],
            [15.363747068183605, 4.30018448484751],
            [15.360759269933896, 4.305217759336266],
            [15.358592819617693, 4.320713339174217],
            [15.353653676746639, 4.331481042381084]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.60919220830334,
          "lat": 41.436672891926456
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42069"],
        "coty_name": ["Lackawanna"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lackawanna County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01213675"
      },
      "bbox": [
        15.353653676746639, 4.107470054469754, 15.675954576450598,
        4.600736242990793
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.786450896968683, 3.416358024381119],
            [15.826247822932704, 3.39563241815415],
            [15.876658589889134, 3.3716042411589946],
            [15.879783672939233, 3.369465922688458],
            [15.97101189367839, 3.32436547110066],
            [15.999816452488881, 3.3100093151370626],
            [16.023068687430076, 3.2987819272707055],
            [16.0604057767404, 3.2811454654144447],
            [16.078801064425086, 3.2721393071934135],
            [16.108658601033444, 3.2569456598210373],
            [16.133962832778057, 3.244385691262047],
            [16.233743573623418, 3.1965205956333245],
            [16.230937308207736, 3.18998765674339],
            [16.208829942009668, 3.157798972187786],
            [16.1988675840841, 3.134796045539923],
            [16.19606211032944, 3.1311895219512262],
            [16.1885569572371, 3.1151672145628226],
            [16.196632845758902, 3.1114051545410333],
            [16.1926215592117, 3.1027574081943943],
            [16.184875032615608, 3.092875978843952],
            [16.184244851399722, 3.0903389719005534],
            [16.16190062454042, 3.100963030586086],
            [16.137466635945238, 3.1120005903324923],
            [16.12612735137376, 3.1174262658401846],
            [16.119837570959202, 3.10374517308474],
            [16.08940754285198, 3.1177955983799963],
            [16.072177966918723, 3.081127649601351],
            [16.067672959085925, 3.072918617882858],
            [16.07410728182152, 3.067651899535059],
            [16.08174786653618, 3.0633959090758487],
            [16.085213051922945, 3.059835706567433],
            [16.097328423103935, 3.0525489474923666],
            [16.10927046997454, 3.0479193832016542],
            [16.114794874167096, 3.0434863328992514],
            [16.12041117716407, 3.0407772753952433],
            [16.115481810098757, 3.0350695421003886],
            [16.08977518506754, 3.0099048260815673],
            [16.08382756768717, 3.0027595911701415],
            [16.075586823550925, 2.995052925445875],
            [16.067595677576257, 3.0041171617833013],
            [16.059125549051604, 3.0119724575421816],
            [16.04033634336221, 3.031489117366793],
            [16.03425252294532, 3.026436422720163],
            [16.004959992942652, 3.0578374827509736],
            [15.997293242319508, 3.0666805613016077],
            [15.993613409366365, 3.068378304826229],
            [15.987969913641276, 3.074164322518628],
            [15.971226935366825, 3.058735517063333],
            [15.957851905653719, 3.0738210245469935],
            [15.948739697064719, 3.0831594592038254],
            [15.943009255450473, 3.0899108308004224],
            [15.931527247952639, 3.079520019509901],
            [15.928383161168966, 3.0837294790282117],
            [15.918348923444189, 3.0747752384578004],
            [15.916709189731563, 3.0806860144024184],
            [15.911307393898246, 3.0830082987986573],
            [15.910942684186544, 3.088893133015362],
            [15.904441496425157, 3.0919526786064617],
            [15.901725168566529, 3.095969700490923],
            [15.902308853152743, 3.101060469029507],
            [15.906693842341177, 3.1050295140665756],
            [15.90586248756961, 3.110716944575344],
            [15.897325674880697, 3.1130013236819267],
            [15.89147698022858, 3.109139379686822],
            [15.882212571669967, 3.10679870968996],
            [15.872051731735182, 3.1109100328138286],
            [15.86648953330531, 3.117839012423859],
            [15.866515725635136, 3.1230627601847103],
            [15.869784875887499, 3.129455770291927],
            [15.870061935212858, 3.136056684463788],
            [15.867549091683387, 3.1378689763309398],
            [15.863651130243476, 3.137392957547768],
            [15.860895572765612, 3.1349390894775615],
            [15.859379536290707, 3.125787126756838],
            [15.857502285533887, 3.1226240201797197],
            [15.852701067680991, 3.1241296696950243],
            [15.850922794254293, 3.133033868472673],
            [15.846857085113328, 3.142584042288474],
            [15.836541517318011, 3.1478269930862535],
            [15.82755626699069, 3.15988201122915],
            [15.819888830711273, 3.173230216241579],
            [15.817242507386926, 3.1766458400756554],
            [15.813035943865723, 3.1776825380745626],
            [15.812337383630265, 3.1737250724828847],
            [15.814976035320784, 3.1700529076835986],
            [15.815736839867812, 3.165366930046455],
            [15.813340435577164, 3.161667200464441],
            [15.808443723029635, 3.1616546819728377],
            [15.80231023945205, 3.167039363942313],
            [15.799871219894648, 3.1719711088488745],
            [15.79366199015638, 3.1781768922669524],
            [15.781990819293206, 3.198727272819364],
            [15.778534528241781, 3.1992184320557375],
            [15.774831365498223, 3.1964350019492267],
            [15.775150095519626, 3.1930410158043867],
            [15.77862620306983, 3.190473234011797],
            [15.778299281040443, 3.1855137442641444],
            [15.773623620748115, 3.182629222670831],
            [15.770325288732963, 3.1838852838481304],
            [15.766776269918456, 3.1884430030427287],
            [15.75453044255577, 3.191622997493428],
            [15.749993018716706, 3.191985792710194],
            [15.74106746459754, 3.195167338139682],
            [15.73744310158853, 3.1935012017991653],
            [15.730047652575484, 3.1959150079110925],
            [15.72550396475712, 3.1944253276458667],
            [15.721780912248336, 3.1911304508172353],
            [15.716586308143206, 3.1842438291667143],
            [15.713216898429346, 3.1833858721331247],
            [15.707171183433653, 3.1876552151575472],
            [15.707679664080631, 3.188282839161726],
            [15.71728572199676, 3.216737919488195],
            [15.72261001373584, 3.231446307151059],
            [15.74128018326813, 3.2852484769518076],
            [15.74604157407702, 3.2994074567690577],
            [15.760139993349231, 3.339413138488173],
            [15.780390794640606, 3.39814151184783],
            [15.786450896968683, 3.416358024381119]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.36725714524523,
          "lat": 40.210821888103624
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42091"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01213680"
      },
      "bbox": [
        15.707171183433653, 2.995052925445875, 16.233743573623418,
        3.416358024381119
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.747861177790671, 3.786904201913408],
            [15.769765656889259, 3.795339702456643],
            [15.785337883120905, 3.8040875724437586],
            [15.787497605648475, 3.807293055261197],
            [15.810969257487073, 3.817534942864989],
            [15.83957930229048, 3.83919351095843],
            [15.851278884803188, 3.851781863326273],
            [15.86532087306509, 3.8589058417071027],
            [15.876030732956883, 3.867946210619839],
            [15.882173699013896, 3.87663114257592],
            [15.884755452282272, 3.8868097477610037],
            [15.906390991396444, 3.9094128544926443],
            [15.897962698107602, 3.9175208530549943],
            [15.909871307513312, 3.9306119115571962],
            [15.910713163744145, 3.939345898864525],
            [15.92542913961933, 3.9513305948872715],
            [15.931109076807877, 3.9534096731420094],
            [15.937326396258841, 3.9580769234178788],
            [15.93709060223652, 3.9633867638610827],
            [15.941935026609569, 3.9670313213815755],
            [15.953734346727199, 3.970990035726831],
            [15.958941440996181, 3.9744909423757835],
            [15.968949708853556, 3.9842896784914528],
            [15.973380719094727, 3.9953481769792254],
            [15.974398797530366, 3.9892125848596383],
            [15.978630151218367, 3.980357364569064],
            [15.984155020854553, 3.9765254652004147],
            [15.99005342585599, 3.9691405558166415],
            [15.991255892916753, 3.9659276895814384],
            [16.001236960281293, 3.9556372369543342],
            [16.01537661257118, 3.948213467571859],
            [16.01921532244969, 3.942010817587947],
            [16.021813067946578, 3.930891906020996],
            [16.024077925809216, 3.9277707316784585],
            [16.031713519274962, 3.9227808859432884],
            [16.038445178398383, 3.9160079905784992],
            [16.042977334962963, 3.9129029258313874],
            [16.046277504942246, 3.9078739813582746],
            [16.046627600737114, 3.903803289499798],
            [16.042080259419723, 3.89902470522343],
            [16.039487660299834, 3.89332116129467],
            [16.04111481777538, 3.887533404095811],
            [16.03620317026457, 3.8843061731409025],
            [16.031371267721873, 3.8857873310536775],
            [16.02107137378742, 3.8827792792052818],
            [16.01800476696732, 3.8799249521795427],
            [16.018041208532253, 3.873628528621949],
            [16.020818301017652, 3.8702641232909722],
            [16.029262039411137, 3.8649122225547687],
            [16.031660677071958, 3.859659162223074],
            [16.028719308113036, 3.850178899344055],
            [16.025411416883, 3.8456239434669652],
            [16.02340578114825, 3.8403996868797545],
            [16.024734364107363, 3.832673165884972],
            [16.021003933065828, 3.822867885412944],
            [16.015279231105012, 3.819793781527067],
            [16.01127517243043, 3.8162167907707034],
            [16.007508731713898, 3.804246562489862],
            [16.00583776282622, 3.801621628939488],
            [15.994636675971876, 3.800181411572054],
            [15.983387280855277, 3.801391190635727],
            [15.97771102382912, 3.799468631199436],
            [15.975812316640528, 3.7940753587670257],
            [15.976357773127786, 3.785229068122172],
            [15.973351675708793, 3.7795290344655608],
            [15.967700160533502, 3.774651165568622],
            [15.965146798733384, 3.7697552804090417],
            [15.967363572330873, 3.763898563356398],
            [15.976178300945554, 3.757394250314802],
            [15.98019302262197, 3.7507139982726736],
            [15.978706579807557, 3.746721555170954],
            [15.979467249230746, 3.740605173528834],
            [15.974934175421415, 3.7331483345387966],
            [15.973689286587415, 3.7238811469652005],
            [15.972895380809458, 3.7094761396073563],
            [15.976410662826678, 3.7040696899973],
            [15.980265822430253, 3.7005957375609215],
            [15.985339506223802, 3.699742402440758],
            [15.98966033336374, 3.701312419557574],
            [15.995236646740123, 3.7002414237845587],
            [15.996432967939212, 3.695211125769253],
            [15.994020214797745, 3.687844549862498],
            [15.988960503858738, 3.6825631096565634],
            [15.986177781283429, 3.674916818360459],
            [15.985194557294207, 3.666218171640448],
            [15.98975614045954, 3.6632957138333517],
            [15.99478525561486, 3.6569958546301717],
            [15.998804045087395, 3.646273465480689],
            [15.998276336839009, 3.6413382497962616],
            [15.993124181918933, 3.6395508515602644],
            [15.990713387577813, 3.636804765238249],
            [15.996278317523018, 3.6291629863611976],
            [15.970754925418184, 3.6051133133355187],
            [15.95700676876169, 3.593057178459378],
            [15.93536876469241, 3.5676169097046495],
            [15.926219879684796, 3.555937576067405],
            [15.911793704428348, 3.536417383785029],
            [15.911387777987718, 3.53662689083931],
            [15.849663180143402, 3.5685033287839025],
            [15.855981600006645, 3.5857642597621338],
            [15.854099350036638, 3.6037736568323777],
            [15.85751985583785, 3.6075441822947645],
            [15.855801911869383, 3.61427698192545],
            [15.85126669456845, 3.6171142252609068],
            [15.850845602131466, 3.622333337570555],
            [15.84694557868335, 3.6225086809508005],
            [15.829937097043913, 3.6352744763368325],
            [15.811854033971157, 3.6501576855362337],
            [15.810406936493989, 3.6557404806168763],
            [15.776879868673078, 3.6294224078663504],
            [15.774233118860865, 3.6328334034133594],
            [15.772889380308339, 3.6400178446088587],
            [15.770863039532076, 3.644338465826105],
            [15.765194653224372, 3.6487659970692286],
            [15.75969589810184, 3.649788120871628],
            [15.753689997072927, 3.6593564160883303],
            [15.748974821891027, 3.661758051774487],
            [15.741763084329252, 3.669610227212807],
            [15.734649267263935, 3.6790604697146185],
            [15.730634925060565, 3.6856217204889017],
            [15.727397079257267, 3.6979047343941787],
            [15.72374051805638, 3.700856603668858],
            [15.718174191425655, 3.7009304957685405],
            [15.716342743703027, 3.6989494122419115],
            [15.71699999499617, 3.690705507422705],
            [15.715774473887784, 3.687487461790229],
            [15.71152231396576, 3.6834712589232668],
            [15.70650543087718, 3.6811719575163675],
            [15.701358817539028, 3.682712257801474],
            [15.697265085457634, 3.6858184395029414],
            [15.694859390603908, 3.690567872662772],
            [15.690219659882445, 3.6923448395727174],
            [15.681879284775484, 3.689200912783232],
            [15.677980173639044, 3.690659782103482],
            [15.673332948394215, 3.6973456093687274],
            [15.668390502410837, 3.7024015228297835],
            [15.665456412103458, 3.709235505300932],
            [15.664003864779806, 3.718345641234523],
            [15.660072038585758, 3.7230146366748302],
            [15.660362351479522, 3.728649188907708],
            [15.654915378921604, 3.7384435505029967],
            [15.659452154753582, 3.740105835434649],
            [15.663570449758547, 3.746418542122459],
            [15.67543216380711, 3.7552960730041702],
            [15.684159526029731, 3.7589390824737277],
            [15.689684716202885, 3.760228808652446],
            [15.693487028081464, 3.764522999530707],
            [15.700192680687412, 3.768316691790225],
            [15.709820690319862, 3.770325196927511],
            [15.716261618423408, 3.7738825773949465],
            [15.724283868809614, 3.7759319195380376],
            [15.740219701605845, 3.7829437969533193],
            [15.747861177790671, 3.786904201913408]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.30762941814078,
          "lat": 40.754129176324646
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42095"],
        "coty_name": ["Northampton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Northampton County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01209185"
      },
      "bbox": [
        15.654915378921604, 3.536417383785029, 16.046627600737114,
        3.9953481769792254
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.577785358318256, 4.600736242990793],
            [15.55576030258376, 4.683755486597655],
            [15.5411453177895, 4.7382947031910305],
            [15.527090439981782, 4.792103255604249],
            [15.517643400126511, 4.825803432691284],
            [15.504679727855896, 4.875696407345221],
            [15.485591788625117, 4.948176944393716],
            [15.574549518053173, 4.967862620120026],
            [15.584866790046604, 4.965897015020265],
            [15.589343139832318, 4.964259510096525],
            [15.593200814603476, 4.9588690384393725],
            [15.592392320296314, 4.945952198074255],
            [15.59529844579509, 4.9429775542546555],
            [15.603184121305684, 4.942088664886391],
            [15.611473193494549, 4.936345289721597],
            [15.614264557411646, 4.930145519920299],
            [15.62103150470146, 4.92626766589955],
            [15.627634880235473, 4.927608098677962],
            [15.626524229111482, 4.931382767303619],
            [15.631817248994462, 4.934381390204297],
            [15.633923776118554, 4.93267127503792],
            [15.63485684280526, 4.927342519259009],
            [15.637486801088368, 4.923604914081315],
            [15.645771055234322, 4.9213483919421055],
            [15.648264573638919, 4.9164316882731995],
            [15.651244531058286, 4.905382064387069],
            [15.661031439192254, 4.891965975568265],
            [15.661987224544406, 4.886951960504543],
            [15.659435469049596, 4.881393575499297],
            [15.662632987540727, 4.87207473767093],
            [15.671111282314442, 4.870270216545293],
            [15.674774371190692, 4.8642174072356115],
            [15.671648013483136, 4.856997460804576],
            [15.673369901750824, 4.852706305693267],
            [15.6778473799158, 4.849522591651524],
            [15.682656334429286, 4.85046822931748],
            [15.687268603718401, 4.856458899176617],
            [15.690846703971864, 4.856041155838589],
            [15.697355962686363, 4.851065530108612],
            [15.703479711326096, 4.8503613318711425],
            [15.707621612000217, 4.861552952076177],
            [15.715008174500015, 4.865675254961062],
            [15.719689574189847, 4.865622748014421],
            [15.725123506531594, 4.862977609779143],
            [15.729417516746633, 4.858835781914168],
            [15.731534186060555, 4.859722668517758],
            [15.734209737165914, 4.872507151406557],
            [15.7387552367023, 4.87273122167143],
            [15.741567622646402, 4.868661361767868],
            [15.742781974936792, 4.860925662832516],
            [15.745779689892222, 4.856042299101361],
            [15.750036580175706, 4.852847305319829],
            [15.756553572914033, 4.852986550526361],
            [15.761851772048797, 4.857146619327229],
            [15.764918183036817, 4.858458858888576],
            [15.773120880401146, 4.8531525701151885],
            [15.781774003598462, 4.855770516420042],
            [15.785433408922765, 4.854285217295649],
            [15.787724597942683, 4.847302717626972],
            [15.787917754835235, 4.841176816479542],
            [15.790769933708864, 4.83407926085374],
            [15.801353716508908, 4.831874100574557],
            [15.807130119771603, 4.828046734278083],
            [15.813108953222379, 4.827579996823965],
            [15.816718780082658, 4.831664916987878],
            [15.822477381609087, 4.831834986155563],
            [15.823669532043425, 4.826541039422458],
            [15.822420524776902, 4.816163108270533],
            [15.819597620359358, 4.8134496481393665],
            [15.81437403136299, 4.813366471422115],
            [15.811341863345168, 4.811509932359535],
            [15.806995857779011, 4.801854926041596],
            [15.806793398166246, 4.795706844464875],
            [15.807719351333072, 4.787884289809114],
            [15.81147303621558, 4.783492452562715],
            [15.817550113655155, 4.784064418082751],
            [15.829042382063095, 4.789873824147595],
            [15.832007031689697, 4.787746034610059],
            [15.841525609550255, 4.785580646004482],
            [15.849484782423005, 4.774908423782157],
            [15.851655753335443, 4.767354614830803],
            [15.852307911518999, 4.7576671716319625],
            [15.85500693813415, 4.750019952734985],
            [15.860430022879742, 4.738824892058178],
            [15.859417378309336, 4.734794702174961],
            [15.852608919720012, 4.734858426193535],
            [15.848740502886583, 4.7336381542985615],
            [15.84812418704286, 4.728945557664094],
            [15.849846640719663, 4.726523916703124],
            [15.856492024129166, 4.722123249573123],
            [15.864115327210385, 4.712173647229638],
            [15.866513210123525, 4.7065821789245295],
            [15.866368559759016, 4.702430590474242],
            [15.862833475386807, 4.6975004737347525],
            [15.86412380040423, 4.69289120796298],
            [15.867656570797923, 4.692178469735587],
            [15.871843840781947, 4.687311445181493],
            [15.874113375473787, 4.681397650931244],
            [15.87686527869737, 4.6671359898039695],
            [15.87981878593419, 4.657657214266641],
            [15.885019940210483, 4.650203524319024],
            [15.885788455708665, 4.6445477111229],
            [15.88321490370572, 4.6419226185928055],
            [15.878670329710268, 4.643654727518461],
            [15.873706900819718, 4.639266574232751],
            [15.87614648029068, 4.6350077863193935],
            [15.8704480307772, 4.633058772664881],
            [15.865994227236145, 4.629761773634941],
            [15.870920431107065, 4.624464321184725],
            [15.851708171576833, 4.563584569401201],
            [15.826867656797084, 4.4845971209018884],
            [15.822968509774926, 4.473852800798497],
            [15.822586077366873, 4.469671101052404],
            [15.817582723360244, 4.465603419437132],
            [15.818454778853953, 4.460345479227525],
            [15.818120955999039, 4.453761736091891],
            [15.821302148400884, 4.449914628478948],
            [15.818162664697963, 4.444513818686669],
            [15.812891570976388, 4.442585072883094],
            [15.813590624966857, 4.4387409679259],
            [15.808929283537864, 4.43493026486982],
            [15.802103506021862, 4.426389121749725],
            [15.798211637005725, 4.426363876794043],
            [15.790860099810107, 4.424319131267277],
            [15.791548074918953, 4.420230581455914],
            [15.7852627454995, 4.4197720350186644],
            [15.780549254939716, 4.409530240427547],
            [15.78364197626492, 4.406209239071166],
            [15.786142248344834, 4.400536888099313],
            [15.780982056705893, 4.395990392332567],
            [15.780775964224263, 4.390734246396918],
            [15.784015600004706, 4.388598337366267],
            [15.78307840993684, 4.383067153979275],
            [15.779643370411808, 4.37801719451629],
            [15.781015371911796, 4.371199248497211],
            [15.778963828661734, 4.368013734776298],
            [15.76979714289391, 4.366090073482663],
            [15.756329269565292, 4.3578884155978805],
            [15.749233171156934, 4.3633436805176835],
            [15.746947997042264, 4.363308973351737],
            [15.74447145862231, 4.356511921476324],
            [15.738220080181412, 4.352497756322071],
            [15.732349640598711, 4.354855941065746],
            [15.727515169279895, 4.360077511250891],
            [15.724551214893875, 4.359101519716989],
            [15.721978689918048, 4.354515934167356],
            [15.71916380386945, 4.352948312519763],
            [15.71861774862221, 4.34578825519437],
            [15.720676208691565, 4.345166844719527],
            [15.723578650110268, 4.340252014127529],
            [15.727473704521744, 4.3387598498689055],
            [15.727890985380158, 4.335698053366485],
            [15.731766764004997, 4.333075737829661],
            [15.731613740073678, 4.328852801073789],
            [15.728570595322127, 4.32439072378943],
            [15.731082260140429, 4.319986653135345],
            [15.740693213516792, 4.321645711431765],
            [15.741453130566294, 4.326268153374768],
            [15.744755288537915, 4.327170944106377],
            [15.749487353304733, 4.322681348180869],
            [15.754851247906199, 4.320543398628582],
            [15.756347105271903, 4.315729412351835],
            [15.756437037693344, 4.310273809355378],
            [15.754109701171657, 4.308181448170275],
            [15.75448910849702, 4.304546859245127],
            [15.757331817926831, 4.299646716782359],
            [15.753615389888894, 4.287785506141203],
            [15.749928112790721, 4.286073056186312],
            [15.750582152050457, 4.282422674797929],
            [15.754316839435367, 4.276610949890091],
            [15.751287078447026, 4.2725449504793245],
            [15.749789833293073, 4.265905433101772],
            [15.752113345920584, 4.262034887990452],
            [15.751206884543032, 4.256203859864956],
            [15.747769863986152, 4.253015081435256],
            [15.744837434863038, 4.252867530699165],
            [15.74261695348466, 4.249769905172115],
            [15.74198197350121, 4.244290200844148],
            [15.749224202661955, 4.240903154047035],
            [15.747789864197403, 4.2329245871061465],
            [15.739937512014778, 4.2223082599069475],
            [15.728997107977632, 4.2184367364908235],
            [15.644415181332738, 4.1948994668209405],
            [15.634699325031017, 4.192371828459337],
            [15.63743926804665, 4.197180952798334],
            [15.63941256377763, 4.2041147245911565],
            [15.64318003414359, 4.20383078133903],
            [15.64749055758739, 4.2055719122247845],
            [15.648969658311717, 4.210111106299518],
            [15.658764465043378, 4.209455465720531],
            [15.65874555359373, 4.213046532373661],
            [15.663958943837144, 4.213930404657174],
            [15.665722366342118, 4.22118174776556],
            [15.668370750965993, 4.220174603086886],
            [15.673934876224585, 4.22359306483342],
            [15.675954576450598, 4.2285171607096546],
            [15.649151854752718, 4.329966845300868],
            [15.629369476213082, 4.406751693139142],
            [15.622063340627843, 4.434508895587271],
            [15.620923802006773, 4.439892694650263],
            [15.602044947550233, 4.508228313159236],
            [15.591568405557446, 4.548713544116506],
            [15.577785358318256, 4.600736242990793]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.30322947427959, "lat": 41.64874459890777 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42127"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01213692"
      },
      "bbox": [
        15.485591788625117, 4.192371828459337, 15.885788455708665,
        4.967862620120026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.656795280381264, -4.138562726986061],
            [12.657091207673492, -4.138534653240006],
            [12.715787869647182, -4.096082108127679],
            [12.733780481191822, -4.082634031063341],
            [12.766138986477722, -4.066222370951705],
            [12.785809976775004, -4.085037715585651],
            [12.793314558021937, -4.09160446987957],
            [12.80858957254147, -4.106621488964937],
            [12.842206544995454, -4.137387226150537],
            [12.856899349710018, -4.116433202271564],
            [12.861369140984106, -4.122419731285062],
            [12.861735713218703, -4.129755865921452],
            [12.864642069061597, -4.134638335448908],
            [12.86464548512683, -4.141489953175783],
            [12.86583118209907, -4.15040106234885],
            [12.882777414056754, -4.151063386002995],
            [12.911774444630975, -4.131987094082301],
            [12.974494178751316, -4.137819325037014],
            [13.04538729767768, -4.18192245636966],
            [13.080470600478522, -4.204318245507353],
            [13.080670606109289, -4.215938600037186],
            [13.08596400312791, -4.222375904036785],
            [13.092554353599093, -4.225224807607449],
            [13.09440440743268, -4.230382280889542],
            [13.099313607148801, -4.237111971161742],
            [13.108379997020096, -4.241978516022975],
            [13.110869962469714, -4.246961526696455],
            [13.117354875136888, -4.250152306616024],
            [13.122379264961681, -4.247424574657539],
            [13.127860858909589, -4.246551190343326],
            [13.132856407292241, -4.243634057939868],
            [13.13766020355731, -4.2483938519449005],
            [13.142836985195334, -4.243121701930102],
            [13.152866165239688, -4.249440633611774],
            [13.156441281795441, -4.24437131350245],
            [13.147974011797155, -4.233724484347738],
            [13.142326760093628, -4.228001487551782],
            [13.145920733773078, -4.222878340261564],
            [13.14088635232589, -4.217922347996848],
            [13.164239584859907, -4.173719406360662],
            [13.144204665223706, -4.164636122803869],
            [13.150503740020888, -4.158049835910268],
            [13.167343447738023, -4.150326927689203],
            [13.172264175501036, -4.150181960302356],
            [13.179728288107803, -4.147572268653746],
            [13.18924147772398, -4.142341651388035],
            [13.191076567885402, -4.148836564851168],
            [13.193720096411969, -4.1485995673131635],
            [13.199734237355443, -4.144303364973155],
            [13.201543898776189, -4.146153793296863],
            [13.227180147420965, -4.1635949964705],
            [13.231225305905602, -4.161664285759719],
            [13.231471026550123, -4.154803194833177],
            [13.229452865417864, -4.148806060505405],
            [13.236187582065927, -4.146681976230754],
            [13.236096950257403, -4.141721240301614],
            [13.239834591441904, -4.142335229260481],
            [13.245029511899288, -4.138660271647732],
            [13.250802458257684, -4.143568026213924],
            [13.25466117712337, -4.144369112273614],
            [13.259304197237814, -4.153004507578632],
            [13.261692174543516, -4.155251353200415],
            [13.267675059775254, -4.154552244508582],
            [13.269738256081475, -4.14890609528743],
            [13.274418925306044, -4.148211999161173],
            [13.278903298666878, -4.153015521165891],
            [13.280202540273274, -4.157787599833922],
            [13.278541980779758, -4.162256058665265],
            [13.281632602030744, -4.168797440183994],
            [13.277257189396838, -4.1708218082837725],
            [13.269185199237821, -4.168963075163343],
            [13.265066562682389, -4.169587615788646],
            [13.264661622013515, -4.172903350900304],
            [13.266327193250325, -4.179836088319825],
            [13.273521463488196, -4.180467520264534],
            [13.276709943569955, -4.183559378260807],
            [13.273563365024204, -4.188898841636701],
            [13.274785434967445, -4.191943740403887],
            [13.280968774995214, -4.192174025012889],
            [13.289261964207679, -4.18961949851055],
            [13.293371697090182, -4.191664271542281],
            [13.291101495191338, -4.196824399105166],
            [13.298504962328897, -4.202847705745915],
            [13.296991323017679, -4.211324507665277],
            [13.297730083670045, -4.213543817683073],
            [13.313701221372641, -4.222799050944093],
            [13.32606297526373, -4.231145049830236],
            [13.33432164173006, -4.235297857637137],
            [13.33827930556152, -4.239538796525821],
            [13.347767186403175, -4.242383872894719],
            [13.356631649854227, -4.243601703576817],
            [13.364876077427756, -4.248484817854052],
            [13.372942927755423, -4.249520515608651],
            [13.392188137627503, -4.245236650402932],
            [13.39814078373126, -4.244574511867897],
            [13.405932007388461, -4.237810240836926],
            [13.413130857512806, -4.23293300324765],
            [13.42281638571862, -4.230686235222228],
            [13.427475853630481, -4.22305749276548],
            [13.43386437683938, -4.222586549690394],
            [13.438600739032767, -4.230701840820318],
            [13.442559416838153, -4.2303773755963014],
            [13.44976850983192, -4.223567323703509],
            [13.450733710935115, -4.218684408277059],
            [13.456096305857569, -4.215481993202941],
            [13.460622535615848, -4.215884481478718],
            [13.464038046847952, -4.213652843628038],
            [13.465920159848327, -4.217943792969546],
            [13.46475059266927, -4.222760357777749],
            [13.468395020043856, -4.224253449237168],
            [13.472952135197398, -4.218485239452239],
            [13.478867326675976, -4.218349282877989],
            [13.481025957161876, -4.227286447215387],
            [13.4798902692425, -4.236749390889724],
            [13.482349750861031, -4.246957374617466],
            [13.482188288654333, -4.252796613053151],
            [13.48569095228568, -4.257093093169397],
            [13.487344084557677, -4.270310187492165],
            [13.481319387616185, -4.271024373887401],
            [13.482259777914681, -4.278471893595652],
            [13.480493772094299, -4.278746425733559],
            [13.474366431264222, -4.2726147953036335],
            [13.473176722321215, -4.281027523476722],
            [13.474154290545329, -4.288020720060604],
            [13.475931898140175, -4.29128183982586],
            [13.47678211047165, -4.297340260328938],
            [13.47857202020806, -4.300733594121085],
            [13.479894322535312, -4.311343540890031],
            [13.475449635101226, -4.326374017100658],
            [13.47752449251229, -4.335672956152427],
            [13.474818942565639, -4.343653920363241],
            [13.476710892347414, -4.354508594383189],
            [13.477050280233126, -4.365702214674552],
            [13.475448226063968, -4.365214136977409],
            [13.470277518374282, -4.373888864568869],
            [13.465118547286142, -4.376680822949565],
            [13.463929243441553, -4.381657848824393],
            [13.459578406886571, -4.385574554393847],
            [13.451372635497735, -4.390481258486542],
            [13.448403570181544, -4.398970262520279],
            [13.442918978994475, -4.403745686831858],
            [13.435489857249628, -4.4079186236052035],
            [13.430969210826959, -4.409130249971905],
            [13.426502887699588, -4.407903793230525],
            [13.41904165178613, -4.402856686252268],
            [13.41226768879523, -4.40027336106292],
            [13.406218313244837, -4.399265592165111],
            [13.398389833668597, -4.40166964775827],
            [13.39534157942374, -4.407022662723501],
            [13.395487124668904, -4.421804223320778],
            [13.38433022713669, -4.420362158815997],
            [13.376262243500232, -4.420614737653989],
            [13.37143420179445, -4.41881531843926],
            [13.367781420189196, -4.419040366066769],
            [13.362238137741034, -4.422293753289403],
            [13.347704136276908, -4.428875318166338],
            [13.341969307066167, -4.430320347580339],
            [13.334156845085007, -4.4293087161612394],
            [13.32967998029244, -4.4276240025639835],
            [13.321675011659945, -4.421682739281504],
            [13.318165035869178, -4.42077926029108],
            [13.311012647653559, -4.422290566448597],
            [13.30146465729488, -4.420803461770625],
            [13.29121045575045, -4.416015397685945],
            [13.28065885853683, -4.399940836870956],
            [13.278311541470885, -4.3927657484087765],
            [13.27773954656548, -4.381850501423994],
            [13.276658500907246, -4.376560888143336],
            [13.271568268993752, -4.367833331785174],
            [13.26738689462544, -4.364522207153803],
            [13.186727205818048, -4.437354894136653],
            [13.151673711077946, -4.469208051480967],
            [13.147652930398344, -4.472631333293822],
            [13.113402494326884, -4.503715567703294],
            [13.056550515569413, -4.555021996996596],
            [13.05092333650213, -4.559886901465762],
            [13.046122989968945, -4.559833458920477],
            [13.04136170734016, -4.555219255552223],
            [13.033559449770765, -4.5519561409998115],
            [13.03173804857213, -4.548919134079003],
            [13.032122339253338, -4.544200494596165],
            [13.026629954985076, -4.541309740502779],
            [13.024947580020298, -4.538995227038138],
            [13.016520806069504, -4.538393096097971],
            [13.010944799008739, -4.534840931584926],
            [13.013062517107743, -4.531473568811667],
            [13.007545258425509, -4.5311254875278575],
            [13.008031160224323, -4.522919694501838],
            [13.003713976561599, -4.522612750627834],
            [13.004286082815296, -4.518770600265622],
            [13.001511458393848, -4.505430946740695],
            [12.9978236053162, -4.505184529100362],
            [12.99369345302219, -4.507315027879005],
            [12.992564484827403, -4.4999043221910435],
            [12.986512912610293, -4.5002241028651895],
            [12.98543052860291, -4.49792957222221],
            [12.98096013875821, -4.497809757505788],
            [12.979405370633888, -4.4940122803075635],
            [12.972759017096505, -4.493073442314741],
            [12.967826186725732, -4.489203202334476],
            [12.962253569024874, -4.488381514816971],
            [12.958896985266668, -4.481695412571934],
            [12.948974942850713, -4.478754466192192],
            [12.948897195861061, -4.4766059979466375],
            [12.937513101032652, -4.470071465545577],
            [12.935053276871713, -4.470275907777653],
            [12.92921915890889, -4.464277639520688],
            [12.925535534686766, -4.464085425046297],
            [12.923189674984531, -4.460175234446402],
            [12.913195216104379, -4.453372303402796],
            [12.906264697586238, -4.449784268324737],
            [12.893379241873616, -4.448853695052413],
            [12.889950466759563, -4.443746811837772],
            [12.886028595305879, -4.441992006068567],
            [12.882189193367177, -4.4437690980523366],
            [12.877007115921215, -4.440963988503261],
            [12.873270838341268, -4.435748798053659],
            [12.867925397663754, -4.433819821282999],
            [12.864220364483584, -4.435410105425003],
            [12.858237546909278, -4.432923059787161],
            [12.855543418235367, -4.428909856892667],
            [12.85246327080194, -4.4298597883831405],
            [12.848162219917437, -4.427891008174736],
            [12.844672061560008, -4.43016896789249],
            [12.839153869114163, -4.4290755989620045],
            [12.83740887263256, -4.4250162190390805],
            [12.832993606229222, -4.42117535603841],
            [12.831453544535588, -4.422498575871991],
            [12.825190801073873, -4.420722325753209],
            [12.821242159539244, -4.422684584032999],
            [12.811585195646147, -4.418140069707496],
            [12.809867085151213, -4.41464102974924],
            [12.80475475284006, -4.4136246069262395],
            [12.800307119328181, -4.409082912773637],
            [12.794152687522068, -4.406170343800902],
            [12.792075019424706, -4.4014217055580565],
            [12.789245753636525, -4.400120177956408],
            [12.783599291022488, -4.400877001202785],
            [12.778143923942562, -4.398444523520839],
            [12.769421365683225, -4.399817477203905],
            [12.761548858836385, -4.398695724845751],
            [12.755900046745097, -4.396947805982958],
            [12.750472574545691, -4.393031480084177],
            [12.744627636609652, -4.393121670202329],
            [12.739846812709187, -4.388935296144862],
            [12.731813532070186, -4.384609356146924],
            [12.72907971030878, -4.384865089517648],
            [12.720156076136766, -4.379474658387746],
            [12.718056180890706, -4.380256542342716],
            [12.711442622310807, -4.377683541665376],
            [12.706027731768934, -4.379412947137516],
            [12.704590605833543, -4.3782084163169825],
            [12.692654926590059, -4.378191798162466],
            [12.689177984094378, -4.371579983781712],
            [12.683966330046573, -4.3698543941447205],
            [12.681379470101307, -4.361274611503311],
            [12.675114561448664, -4.3548657773059585],
            [12.669943580467029, -4.353932826781128],
            [12.66438112623704, -4.355555672407658],
            [12.661095717770705, -4.354352768787881],
            [12.653986650626457, -4.354978782674749],
            [12.652590265494037, -4.352962178140989],
            [12.646789352422457, -4.354988877101132],
            [12.641289589883431, -4.3545688346105305],
            [12.63469871246589, -4.352175409666164],
            [12.63078190918796, -4.348967259620037],
            [12.626057852578494, -4.348070625616555],
            [12.62099358077549, -4.3425023790965644],
            [12.613997219645634, -4.339236666439005],
            [12.61122361973749, -4.335126059491664],
            [12.604516071784674, -4.333119443564089],
            [12.599386847028526, -4.328749015056263],
            [12.592923138193788, -4.324933330143612],
            [12.586545456170244, -4.325621859570752],
            [12.582706267234904, -4.3277324984297865],
            [12.572682111192618, -4.324470360758386],
            [12.566794923491315, -4.328155049101498],
            [12.555236413004616, -4.3292757109732865],
            [12.550688642849275, -4.3258366561783745],
            [12.540546516117297, -4.327225518335803],
            [12.530274963507763, -4.323461105479235],
            [12.552036942279871, -4.2930487821084],
            [12.589809713950642, -4.237836759428683],
            [12.656795280381264, -4.138562726986061]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.80028694524539, "lat": 33.43900150661294 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45075"],
        "coty_name": ["Orangeburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orangeburg County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01248014"
      },
      "bbox": [
        12.530274963507763, -4.559886901465762, 13.487344084557677,
        -4.066222370951705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0917962960160668, 5.570809273199395],
            [-2.0661921044619507, 5.570422216257769],
            [-1.980249817403902, 5.568271150473205],
            [-1.8943078239126685, 5.566102333427169],
            [-1.8490917329450824, 5.564645997168896],
            [-1.8489267246686885, 5.566145015195032],
            [-1.7978863527097542, 5.564665253753045],
            [-1.74233200633247, 5.562758876758815],
            [-1.740798676995204, 5.562922094045999],
            [-1.7053220294899374, 5.5615209505981555],
            [-1.6269507748068848, 5.559126735910472],
            [-1.6300337067232722, 5.471026026297553],
            [-1.6324017544740899, 5.398958576271697],
            [-1.632400585984862, 5.392278145486378],
            [-1.6340209312471021, 5.355640140007441],
            [-1.6357746584537614, 5.298100492250092],
            [-1.6645742944255741, 5.298728973977974],
            [-1.7229015404920824, 5.300292561738078],
            [-1.7297003531940154, 5.300671113324087],
            [-1.765834905884667, 5.301127672846805],
            [-1.8078388545547255, 5.301914864010986],
            [-1.865016279062316, 5.303719485018329],
            [-1.8677162577486301, 5.303589390486488],
            [-1.93962156636539, 5.306704778883831],
            [-1.9433056741965489, 5.307453325588936],
            [-1.9386842900179102, 5.319386993324378],
            [-1.9354105612093622, 5.335115668428128],
            [-1.934566782215934, 5.354222479670317],
            [-1.939609953222149, 5.36828124815547],
            [-1.9474543133757876, 5.3755355157322215],
            [-1.9576652085432262, 5.387674512090381],
            [-1.974297145423203, 5.40095415278624],
            [-1.98645913096219, 5.414338962506121],
            [-1.9908623291212806, 5.417560158033062],
            [-1.9992197519227077, 5.421849760890994],
            [-2.0118396912384977, 5.424960040932518],
            [-2.0234286873946625, 5.42594672460765],
            [-2.0327236158349336, 5.427414368744588],
            [-2.042508319023759, 5.430375826606238],
            [-2.050297822914597, 5.431911636401962],
            [-2.0591476633350934, 5.4409852077932905],
            [-2.066233214764576, 5.447168311718698],
            [-2.072190493297684, 5.454251824178554],
            [-2.075193395786678, 5.459836358671868],
            [-2.082616362744779, 5.470076766014419],
            [-2.0847651654339807, 5.475647599286694],
            [-2.084962466945105, 5.481760245700739],
            [-2.08370624035384, 5.487849487712166],
            [-2.0781014750089826, 5.505686245873051],
            [-2.0677154846352757, 5.527657850984081],
            [-2.0674783461274795, 5.5360165320758155],
            [-2.0744949542159805, 5.5489733388524245],
            [-2.0917962960160668, 5.570809273199395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.20486306049955,
          "lat": 44.076309811851836
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46017"],
        "coty_name": ["Buffalo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buffalo County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01265767"
      },
      "bbox": [
        -2.0917962960160668, 5.298100492250092, -1.6269507748068848,
        5.570809273199395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.1764132184560525, -2.8259208424223625],
            [7.185471391526827, -2.824616328148918],
            [7.190389541055901, -2.8192512397886893],
            [7.194293740999691, -2.8192795759790785],
            [7.196705220029005, -2.812905590853044],
            [7.207675260964217, -2.812969558972702],
            [7.207433954126547, -2.8052833486170394],
            [7.2022650220072695, -2.7999747026601276],
            [7.210267644769373, -2.798892618675542],
            [7.215097921752982, -2.7953109129376332],
            [7.216866048090571, -2.78858700586777],
            [7.220546933220933, -2.784983053553112],
            [7.223940700647482, -2.784177682226659],
            [7.229905851245867, -2.7769164941746114],
            [7.234382971701598, -2.7782800612437284],
            [7.244292930519908, -2.7764704604456356],
            [7.247354285628226, -2.7807871548254837],
            [7.247616550197046, -2.7842395142337333],
            [7.250166565066271, -2.7873954186792584],
            [7.256968925115595, -2.789939223856718],
            [7.261969316793719, -2.79720328007462],
            [7.268091813197682, -2.798204965285638],
            [7.2779093427180115, -2.798334133892555],
            [7.277790524456219, -2.7998898268455665],
            [7.295406460433903, -2.796109732073856],
            [7.335280415654849, -2.8059481195536398],
            [7.341009344417096, -2.804505435434404],
            [7.343908932952707, -2.800568942498067],
            [7.367194597514155, -2.7932069125287295],
            [7.4132232082939495, -2.7539694661195515],
            [7.416082522795663, -2.7575761173416433],
            [7.42215577867826, -2.75301063737251],
            [7.427811837143219, -2.753048219992948],
            [7.4276862824834895, -2.7554057001260928],
            [7.434185008472578, -2.7553092391669183],
            [7.434085960885801, -2.7697728436407374],
            [7.435240693130435, -2.7771030169455506],
            [7.431763379813664, -2.778241325565365],
            [7.43219513712664, -2.78216408874918],
            [7.42861775951241, -2.7831221050599515],
            [7.426323555053739, -2.7908437243298843],
            [7.420634827775449, -2.7954114227103997],
            [7.4203259518565865, -2.803119683112228],
            [7.421370672616295, -2.816357462406062],
            [7.424158239651, -2.828766253726748],
            [7.435240350307684, -2.827983253486446],
            [7.4364438049644885, -2.839658772348518],
            [7.44526580864921, -2.839130315468618],
            [7.44549773877634, -2.843031497107327],
            [7.449963271398195, -2.842114246889287],
            [7.455761693546774, -2.843107804333791],
            [7.455186259543306, -2.8618745942604273],
            [7.47764871524312, -2.860908061127554],
            [7.477589552925554, -2.866549119166611],
            [7.481337847971484, -2.8665086030936195],
            [7.482013841121388, -2.8775294580279134],
            [7.483357135181599, -2.877700578582222],
            [7.486214556772818, -2.887619249515531],
            [7.487643439396519, -2.903670620830298],
            [7.491185346174853, -2.9013699146733716],
            [7.497965222131917, -2.9017189213937877],
            [7.497580769481207, -2.9069332854760868],
            [7.490689831588409, -2.9067644148570624],
            [7.487593235254998, -2.9117744852058314],
            [7.493368167366802, -2.9159734382346114],
            [7.491585507501924, -2.919643472545298],
            [7.491709961639347, -2.9245042413581674],
            [7.495757410437386, -2.924635123916195],
            [7.495358313597135, -2.9381306822502182],
            [7.493353616487962, -2.9384383712460744],
            [7.4926446392357695, -2.9499616319385122],
            [7.486564660169949, -2.9497651217499863],
            [7.486634091767032, -2.958008115092206],
            [7.4834899786851805, -2.957957658040741],
            [7.483442612183553, -2.9649535614126186],
            [7.457100193137203, -2.9643067717348996],
            [7.457225061702339, -2.9554767224918432],
            [7.43324224971686, -2.958979178161216],
            [7.422720713683912, -2.9577068798395203],
            [7.416860211787756, -2.9576973434851195],
            [7.3584478034594305, -2.962994794584071],
            [7.361543820761737, -2.997498750691993],
            [7.361552599250939, -3.0003698910228143],
            [7.350996022157598, -3.0012817698583043],
            [7.350722371608501, -2.9997404516915434],
            [7.337540666812373, -3.0004698002792494],
            [7.33834633919244, -3.00842827172809],
            [7.31318059395231, -3.0107238874501223],
            [7.308768582658232, -3.014044715234106],
            [7.308885085445866, -3.027788707684087],
            [7.299016187457917, -3.0282978144212143],
            [7.261734807664656, -3.031718795880365],
            [7.261151664860565, -3.0238267187512546],
            [7.259280435159393, -3.0238804983090173],
            [7.248210930421654, -3.019661057779939],
            [7.242998277636865, -3.019958799113908],
            [7.239113788311375, -3.0133337791141983],
            [7.235914083670878, -3.0128147400748193],
            [7.232500105391388, -3.0054043593005817],
            [7.2326856600416285, -2.9961382132583294],
            [7.212132492115851, -2.9957628393527083],
            [7.211871176601565, -2.9930539681301114],
            [7.204848603809699, -2.9937808724796486],
            [7.200622205887979, -2.9930039140817937],
            [7.198379286790134, -2.962175844585921],
            [7.166280020997747, -2.964927259816189],
            [7.155307922212998, -2.9586506234402927],
            [7.139824324693674, -2.956583428645893],
            [7.139856930419022, -2.9420026760215268],
            [7.143071665396932, -2.941954703481979],
            [7.143158281757975, -2.934099187753927],
            [7.159521863266596, -2.9326281012050903],
            [7.159626420747386, -2.889390266381127],
            [7.1578463665533105, -2.884743240035101],
            [7.162413144063718, -2.882955295156725],
            [7.170699283745772, -2.8851825275114242],
            [7.175770462398907, -2.8827445770977],
            [7.176914957044896, -2.8777246628725885],
            [7.185514865060406, -2.8701242214086973],
            [7.185307092921688, -2.858764634915657],
            [7.186568443038366, -2.854844811902389],
            [7.183832433900624, -2.851153196466392],
            [7.185878087221755, -2.844651361361845],
            [7.180133202111421, -2.8381457704275745],
            [7.1764132184560525, -2.8259208424223625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.49303280960872, "lat": 35.52725278534738 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47101"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01639765"
      },
      "bbox": [
        7.139824324693674, -3.031718795880365, 7.497965222131917,
        -2.75301063737251
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.301833831273002, -3.263251622018057],
            [6.351890138593835, -3.2594698359502887],
            [6.35409075029362, -3.2486304932681587],
            [6.361281802411692, -3.2483202684745387],
            [6.361633081536948, -3.2398314883486967],
            [6.365376991236931, -3.217128574085052],
            [6.371639969146827, -3.194644768290778],
            [6.375340546485531, -3.1866649437891015],
            [6.382220976865532, -3.1805015939141885],
            [6.384298352161388, -3.184799662274064],
            [6.384801459680244, -3.1913759708447467],
            [6.3950243924704555, -3.1905656064684083],
            [6.394773945389145, -3.187040971990111],
            [6.399578387962163, -3.1850653168515346],
            [6.399339717124099, -3.1819882997911497],
            [6.393005518325864, -3.1825404750849855],
            [6.3902267650081255, -3.1841492279309644],
            [6.389733986985388, -3.1777862194023507],
            [6.392344763448922, -3.177582586647725],
            [6.391734791586036, -3.1687361763113473],
            [6.390398326374375, -3.1628544074726355],
            [6.399788201738687, -3.1506988791997834],
            [6.406573841012319, -3.1407217979383564],
            [6.432917158820483, -3.1292071378549373],
            [6.445735521432921, -3.1214528333122225],
            [6.4607508728294345, -3.1151269076569617],
            [6.462895700493545, -3.122038363461921],
            [6.470236223121989, -3.1268636597307498],
            [6.469268426087059, -3.119940074861378],
            [6.464786777478607, -3.114618195751093],
            [6.500624415628127, -3.10895372591576],
            [6.501243401682202, -3.114739613903421],
            [6.510759051704211, -3.1143465759170246],
            [6.512133584592375, -3.1082337231608554],
            [6.528619875852875, -3.1066101902404664],
            [6.575410451813246, -3.1054163566182065],
            [6.601240780461504, -3.105026717601848],
            [6.612533216702175, -3.1042624737297713],
            [6.612628875152932, -3.110180049579221],
            [6.623375114420485, -3.1095793454429184],
            [6.622583414418764, -3.1036772001536117],
            [6.629365856906331, -3.102856206305706],
            [6.630365235968458, -3.1230711955306574],
            [6.632236631654433, -3.168595312746255],
            [6.626583779837891, -3.1690161081462977],
            [6.627467780147827, -3.179265466040571],
            [6.626051560329425, -3.180827222265055],
            [6.6267076763507315, -3.1938835827760905],
            [6.63288751110902, -3.193532754131539],
            [6.634665917891571, -3.2274329545319786],
            [6.63460144094375, -3.2360953457700776],
            [6.640572521763845, -3.3607766259188967],
            [6.643733265965893, -3.4357443138773953],
            [6.645993174588711, -3.4863499703771983],
            [6.646048663324087, -3.490865957211846],
            [6.57937112384951, -3.4957724447684466],
            [6.497569226843294, -3.50243568121135],
            [6.399951064654212, -3.5103125595282276],
            [6.317221874903126, -3.516890598977505],
            [6.317235935829962, -3.5120072878379545],
            [6.3129041096750695, -3.46212692141819],
            [6.307063210002155, -3.383517996666713],
            [6.301833831273002, -3.263251622018057]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.56357939456213, "lat": 35.17553966919392 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47109"],
        "coty_name": ["McNairy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McNairy County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01639774"
      },
      "bbox": [
        6.301833831273002, -3.516890598977505, 6.646048663324087,
        -3.102856206305706
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.311980526180719, -2.048799844446984],
            [10.318835672176656, -2.0499403968496055],
            [10.32389866890143, -2.0493347729804325],
            [10.325436510081905, -2.042331960107089],
            [10.357748315271802, -2.062338296277632],
            [10.359687512860274, -2.0626052115296662],
            [10.362594537594086, -2.067515185815518],
            [10.367247482539437, -2.064770380738888],
            [10.382629077106047, -2.073581993661805],
            [10.438834867997961, -2.1071265900099214],
            [10.442530672061492, -2.1085087951386954],
            [10.447623621348617, -2.115275202346089],
            [10.446759289017091, -2.1201940671148045],
            [10.455748412009791, -2.127706076341628],
            [10.456445597893127, -2.1310189128578814],
            [10.465051690554686, -2.131220302363957],
            [10.473300341192962, -2.1330886487751077],
            [10.47382713868213, -2.1364229315767758],
            [10.477242986346333, -2.1394918410846624],
            [10.482165282336211, -2.1366701511586292],
            [10.484904526133064, -2.143665769175123],
            [10.491082006319814, -2.142176821450952],
            [10.49464778493354, -2.1364545388809146],
            [10.496572314960435, -2.1420542479972493],
            [10.500995566487825, -2.1399007775173984],
            [10.506682359375962, -2.1408725412048075],
            [10.508403663646, -2.1344227021926203],
            [10.51233401277723, -2.133892564398082],
            [10.516209793321835, -2.1386640256215603],
            [10.52067690606356, -2.1366245612062182],
            [10.530260411286685, -2.1270842568671595],
            [10.540060336994395, -2.130565452975185],
            [10.544003633933372, -2.1255347426755935],
            [10.550287442516902, -2.126367707882156],
            [10.552413320869258, -2.1292729470980074],
            [10.552654316419806, -2.1350230754537836],
            [10.551157025545415, -2.1379658232678147],
            [10.55292168366658, -2.142880859978204],
            [10.555697834073301, -2.1437050789760868],
            [10.561591868327529, -2.140760565827608],
            [10.568357805946208, -2.1414139068742495],
            [10.574525255553466, -2.138277128266122],
            [10.576855205279866, -2.135379196520181],
            [10.58200207737821, -2.1340631318457897],
            [10.589530798745503, -2.1366435111982796],
            [10.595395218149761, -2.140109550424292],
            [10.601462686021213, -2.139617240567824],
            [10.608030076309785, -2.143004478039686],
            [10.615578063715308, -2.149218681048859],
            [10.619071411030271, -2.1532952852775566],
            [10.615905155755529, -2.156288445829097],
            [10.615314851683952, -2.159749930054294],
            [10.62251095165934, -2.1618612643967223],
            [10.622012130580503, -2.1683824572898027],
            [10.624252786717605, -2.172666672013826],
            [10.62394521510975, -2.1772186477719275],
            [10.640428085695602, -2.1803932031234594],
            [10.640434277440905, -2.1839537659858324],
            [10.638212514375814, -2.1927314854953632],
            [10.641910379395082, -2.1939123292862246],
            [10.64676313135474, -2.198696438153518],
            [10.649413797314919, -2.2050107971090025],
            [10.65608080884528, -2.2123678542292016],
            [10.659556104388118, -2.211839991097692],
            [10.660729533590018, -2.2174340689160763],
            [10.667610010209977, -2.218486437419085],
            [10.66718833006572, -2.2246687596225097],
            [10.664735685598504, -2.227715894080446],
            [10.659631486731325, -2.2307993563086406],
            [10.659009646103453, -2.225332580149806],
            [10.654668460914724, -2.2244872186286275],
            [10.653678341609155, -2.2282946116056643],
            [10.656883219689131, -2.2391595678000984],
            [10.654675717619316, -2.245826956219233],
            [10.651170943096602, -2.2511637847380843],
            [10.652889642826029, -2.25518766714707],
            [10.653248652738567, -2.262894352957532],
            [10.656254298301576, -2.267931421123402],
            [10.660487660853645, -2.265960931766016],
            [10.662148369190316, -2.2720476534115774],
            [10.664504288756746, -2.273739032780997],
            [10.663339170363784, -2.285669523730817],
            [10.663564978149948, -2.2924090186654222],
            [10.662565764484492, -2.295749290407117],
            [10.665186649294437, -2.3131105130654825],
            [10.667459619119112, -2.314642101656309],
            [10.671000181804635, -2.323257956711458],
            [10.67096148421984, -2.3317581695498357],
            [10.675512324339415, -2.3317652228579444],
            [10.683489781158599, -2.328206378171947],
            [10.687454573464299, -2.3280111846589775],
            [10.689205518887455, -2.333485450339403],
            [10.688449749435394, -2.33920021753494],
            [10.689915033231596, -2.3470399553519403],
            [10.686344882088646, -2.354536749396878],
            [10.680450502678703, -2.359157847174777],
            [10.67930359923362, -2.3633072924228724],
            [10.666051015051885, -2.3721775885545324],
            [10.665519649096826, -2.3797544930041674],
            [10.661930369104292, -2.389779709014919],
            [10.651730583863182, -2.3945040398780124],
            [10.649873364636736, -2.3943900969455676],
            [10.642139578987175, -2.3872835257372653],
            [10.630719716627894, -2.3861121566972137],
            [10.628872025968137, -2.388797823408807],
            [10.618228233321984, -2.39349353525117],
            [10.615753746504199, -2.3991401520368876],
            [10.61584038782991, -2.4038206933298976],
            [10.608778475914077, -2.416248937997763],
            [10.603345359513954, -2.41676399849872],
            [10.598690153539081, -2.4216877050919954],
            [10.59207670946411, -2.4237100874251305],
            [10.59007189007367, -2.4326112811358898],
            [10.587215527099179, -2.4354075081554223],
            [10.581858972049782, -2.4375521482035336],
            [10.569487259034576, -2.447178393882703],
            [10.568827803548892, -2.449585876812618],
            [10.560430018289708, -2.4519684489257347],
            [10.549396876853395, -2.451540200069798],
            [10.548747731100507, -2.4548185882120555],
            [10.543300706992685, -2.4663401683011172],
            [10.538466527843513, -2.472518263167243],
            [10.531833231621137, -2.475732049608605],
            [10.531274571021891, -2.4796214043601004],
            [10.526591529973139, -2.483532121880161],
            [10.527583482982, -2.48758418619537],
            [10.52344368935588, -2.4993153931883105],
            [10.518729625246513, -2.5012984640271165],
            [10.513898706137965, -2.505888508146875],
            [10.498543989221801, -2.5080282620450713],
            [10.495861282744057, -2.5056054250797692],
            [10.485034553652467, -2.5079827370835672],
            [10.47957730873218, -2.507650430242504],
            [10.47069125483841, -2.5101990512087315],
            [10.459345580030538, -2.51001672749552],
            [10.454345234214278, -2.5111567818312808],
            [10.447063446714942, -2.514994401584211],
            [10.442779564167182, -2.514201427399139],
            [10.441843320828058, -2.5113291422090342],
            [10.435912005576592, -2.506058987206739],
            [10.429152628726388, -2.5015405255297596],
            [10.423369675856723, -2.5010548711995155],
            [10.41894755982884, -2.5071493581706803],
            [10.408223934217306, -2.5147915849664053],
            [10.405968780727644, -2.513862444350982],
            [10.399856928678119, -2.517729367749763],
            [10.395906258428282, -2.5184995754460435],
            [10.389443781431213, -2.516818091974628],
            [10.38144924104867, -2.5170132214502967],
            [10.374995673024918, -2.469290505143458],
            [10.374306472277127, -2.4610682656101686],
            [10.365750828914946, -2.395561648215754],
            [10.362354259368807, -2.4001264306703147],
            [10.357274370674393, -2.4018733815192053],
            [10.353227632609233, -2.399943161132658],
            [10.348720239662795, -2.387541483157452],
            [10.350003626429663, -2.3814538718473766],
            [10.3472833262012, -2.3785413274426452],
            [10.343489782296452, -2.378703743076861],
            [10.337567964205876, -2.3820618778433325],
            [10.331932598639645, -2.381055105830225],
            [10.329152951947446, -2.3790139309920257],
            [10.331269074392862, -2.3749881715861116],
            [10.331267532383237, -2.3709143393315277],
            [10.325666328631234, -2.3702311630425252],
            [10.324720367762827, -2.3636680766882936],
            [10.321017645314464, -2.364577168320055],
            [10.31793642459943, -2.3627242761679965],
            [10.313549938346629, -2.3442900422914015],
            [10.308753953984095, -2.3427957035734046],
            [10.308510066014165, -2.339428382196452],
            [10.303879303117286, -2.3388589209133444],
            [10.303848799191528, -2.3306109747438706],
            [10.300692523701718, -2.32547704142339],
            [10.284322486658578, -2.2965590467336368],
            [10.284786247383403, -2.2927002951114805],
            [10.289446042789082, -2.287336895044865],
            [10.280928160687129, -2.286498404687485],
            [10.274811750150343, -2.2772790435043415],
            [10.27389590178109, -2.278458092617073],
            [10.258349046575912, -2.251790423298627],
            [10.2606732795599, -2.249687139117738],
            [10.256126769157943, -2.2444963893184724],
            [10.253224088318984, -2.246184203088645],
            [10.250654246420563, -2.2423707244636235],
            [10.250866321399453, -2.2389716030441247],
            [10.245636607326473, -2.2300352066212996],
            [10.244482532133592, -2.219547299952964],
            [10.240236919286588, -2.2150988098089486],
            [10.23542548229159, -2.212663231823237],
            [10.243117544318604, -2.2060898564991485],
            [10.24647215154953, -2.201589118752359],
            [10.24708016916677, -2.1965808150364663],
            [10.249055911277328, -2.192436967382454],
            [10.25356069060615, -2.188827307622838],
            [10.253743840885816, -2.185142817576802],
            [10.26071600341152, -2.181295828392614],
            [10.26458888174076, -2.1772149137955408],
            [10.273667272441868, -2.17328292727253],
            [10.275951293414293, -2.177077004412344],
            [10.280159971135756, -2.1738811144853836],
            [10.288271393577238, -2.1650874382065246],
            [10.297932823941329, -2.1567796481024337],
            [10.302077899855494, -2.1515503356814816],
            [10.305380949716108, -2.150071201644858],
            [10.308260123939428, -2.1446755211277972],
            [10.313254044740871, -2.150181722690797],
            [10.317076171961922, -2.1485276830693287],
            [10.312805238603667, -2.1423020899351832],
            [10.31369369278699, -2.1379300322199626],
            [10.319595106104803, -2.1348709513076476],
            [10.325877543706206, -2.1270759179565846],
            [10.330072615007527, -2.119718251816193],
            [10.335530013117507, -2.1134190165829705],
            [10.329647183860024, -2.099997720044856],
            [10.336543585652358, -2.0986082702290108],
            [10.335855353777495, -2.095385253775051],
            [10.32714248941447, -2.0946081627720092],
            [10.323730772119532, -2.0863260655491445],
            [10.319309915226922, -2.0781235230533297],
            [10.317250317548904, -2.0686313689792835],
            [10.311870203171017, -2.057867129511932],
            [10.311980526180719, -2.048799844446984]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.5241721679047, "lat": 35.7846476140556 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47155"],
        "coty_name": ["Sevier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sevier County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "01639789"
      },
      "bbox": [
        10.23542548229159, -2.5184995754460435, 10.689915033231596,
        -2.042331960107089
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9187932866418571, -6.604983644207374],
            [0.9643966143668027, -6.604873058598428],
            [1.0175607155112225, -6.604298710340471],
            [1.1141703626646802, -6.602799336156356],
            [1.1613666545409203, -6.601871551010771],
            [1.2378204003647997, -6.600747303358136],
            [1.2910936690433825, -6.600222106282836],
            [1.2966302601131023, -6.599579010647351],
            [1.3186590001008656, -6.599308444606198],
            [1.3193048299460968, -6.64088422984406],
            [1.3189935137953686, -6.651216575965545],
            [1.3200559452315628, -6.741275195229639],
            [1.3207270368439543, -6.808729805358055],
            [1.3218968606100838, -6.883718489510315],
            [1.322215929256957, -6.890503234951756],
            [1.3621634775799, -6.890657181836745],
            [1.364750834303707, -6.9014067396514545],
            [1.363693256112367, -6.9046757462800485],
            [1.3553525422929777, -6.911329255808009],
            [1.3584446014317146, -6.917848243848704],
            [1.3528572424274388, -6.928573284517774],
            [1.3484646679554526, -6.9307304977002575],
            [1.3504622328774105, -6.935447367515829],
            [1.3487194518747203, -6.939364432010244],
            [1.3433043500756916, -6.94071275822774],
            [1.338541648411179, -6.939603616864582],
            [1.336296918485429, -6.94124723774829],
            [1.328393794901754, -6.942923455061506],
            [1.3314183848427728, -6.950650937191772],
            [1.3338476570467204, -6.953948316836489],
            [1.3459115437337272, -6.958486364970246],
            [1.3479460304373718, -6.96282251054176],
            [1.3533939619705093, -6.96170895535163],
            [1.3620601201006763, -6.96378302311651],
            [1.3630961195209395, -6.966408819374873],
            [1.3700813256469047, -6.969549553770876],
            [1.3720644601326497, -6.977119915863512],
            [1.3691908956006709, -6.980832112171694],
            [1.3641942738557071, -6.9809226687875405],
            [1.3579001625993692, -6.983619486714605],
            [1.3540059107798261, -6.98349983669397],
            [1.3482190213829215, -6.981281015836631],
            [1.3438150931584232, -6.983068744487986],
            [1.3404674980720366, -6.98122165667357],
            [1.3343011883059754, -6.9962599219231505],
            [1.3366188183084462, -6.999745283040291],
            [1.3400532884998082, -6.999646425011209],
            [1.3423589074961377, -7.0023929789107155],
            [1.3459025787658927, -7.011942893079505],
            [1.3492704955287287, -7.012822339012039],
            [1.3457334000782966, -7.017946020896897],
            [1.3439647338949925, -7.023626455255903],
            [1.3448952607189661, -7.026815249964471],
            [1.3420989589762469, -7.034290912099484],
            [1.3404074703403586, -7.0421221413191315],
            [1.3452005859954, -7.049966636601784],
            [1.3472361044021581, -7.048985615789088],
            [1.3500881584752997, -7.059290720964023],
            [1.352938029234505, -7.072154813435255],
            [1.3518043026428754, -7.076153883929691],
            [1.3548671618375057, -7.082649335663002],
            [1.352776309555914, -7.092980216516304],
            [1.3542213124472913, -7.099176064206865],
            [1.3608976812537321, -7.097150285260012],
            [1.361324631106935, -7.108523230912852],
            [1.3652610255865372, -7.11259129060501],
            [1.3706739534904007, -7.123284225211182],
            [1.3753235957754417, -7.12932456513822],
            [1.373800127714146, -7.134833040901058],
            [1.3744185945094713, -7.141695419146649],
            [1.3757720250058514, -7.144924512862298],
            [1.3805522546775624, -7.148226546766734],
            [1.3780439213594695, -7.151082519818399],
            [1.3766807502074956, -7.156012885241082],
            [1.3794113632807858, -7.160773565123491],
            [1.3843122005992354, -7.165465678004446],
            [1.3909156749901854, -7.164345480572848],
            [1.3952508805527706, -7.160685223268041],
            [1.4042250626298687, -7.157509152753426],
            [1.4059777549826338, -7.168577953822977],
            [1.4014488349743917, -7.1759819427101075],
            [1.4001901764175166, -7.17989583887658],
            [1.400661778270943, -7.18907773805728],
            [1.4054986768719484, -7.193638314521382],
            [1.408923358575247, -7.192365270908399],
            [1.4139950647186577, -7.206136187418864],
            [1.4208768661278663, -7.205461774249424],
            [1.4229559819866813, -7.207788207687196],
            [1.4265876032111884, -7.207526139947814],
            [1.3949807643464305, -7.2355238417517755],
            [1.3507852593828344, -7.274427724591199],
            [1.311193233295925, -7.309095253662759],
            [1.3109351222155055, -7.309607755735493],
            [1.3076830124423848, -7.302460175899061],
            [1.3039813828174758, -7.300860415275631],
            [1.3040660936438273, -7.297672063448017],
            [1.3090581507534422, -7.2956736348761115],
            [1.3070152973597997, -7.292242386768186],
            [1.2990916494177187, -7.290785538359824],
            [1.2927994658143582, -7.292883277541173],
            [1.2864901710316308, -7.290035537023162],
            [1.2798511312617378, -7.289061725715896],
            [1.2760195661435525, -7.290789927856164],
            [1.269577701274466, -7.28279574694192],
            [1.2688863045937948, -7.2767428434421335],
            [1.2620631855620161, -7.268078181305117],
            [1.2577338568487273, -7.264527312528395],
            [1.2560983540512303, -7.269938028668364],
            [1.2508746524351657, -7.272278240308672],
            [1.2503636627525492, -7.269303497248006],
            [1.2441459066233695, -7.268000966406386],
            [1.238444804315806, -7.270198577180487],
            [1.228265143628867, -7.2672812604462775],
            [1.225303160600839, -7.261635351710834],
            [1.225637093796528, -7.257711270724885],
            [1.222313757623852, -7.25547257434112],
            [1.2199034899682732, -7.247622965525813],
            [1.2233894890970385, -7.245201148868534],
            [1.2233886403982193, -7.241798859852926],
            [1.226919017823852, -7.240595526210133],
            [1.2333047720139914, -7.233471640545297],
            [1.2293496059298037, -7.231597569842196],
            [1.230682421428612, -7.225781045609108],
            [1.2279205120217178, -7.217651175342016],
            [1.2195315990452822, -7.208866192615477],
            [1.2104537955087644, -7.204025163055649],
            [1.2062090323113217, -7.199544489435447],
            [1.197982203604971, -7.196487244361685],
            [1.1908174217126297, -7.197299747312419],
            [1.1910110559799119, -7.192918825390984],
            [1.187663228705792, -7.186724464972728],
            [1.1884296690816962, -7.181381886336713],
            [1.1920274161531326, -7.179148057364867],
            [1.19376075189365, -7.173971939486518],
            [1.1872263309975095, -7.173887895764868],
            [1.1842458518666523, -7.171429687307181],
            [1.185673307670314, -7.168148243672973],
            [1.1792613335468878, -7.166328938829995],
            [1.1749744096089234, -7.163748308590492],
            [1.174546803070399, -7.159551624568772],
            [1.167728067452881, -7.156620027355206],
            [1.1662575537547477, -7.152448155211741],
            [1.1624862837322776, -7.1525324805073485],
            [1.1599184957180855, -7.15695830392992],
            [1.1553173323391417, -7.159214396856467],
            [1.1509529337515951, -7.15942975912705],
            [1.1448726588712494, -7.164501310035647],
            [1.1402228235800944, -7.1641117392807345],
            [1.1353268572151816, -7.167348428311314],
            [1.13297298011416, -7.165524719718697],
            [1.1269525295932232, -7.1641842459782],
            [1.11997279954389, -7.160278622353465],
            [1.1143957448222022, -7.162886944745779],
            [1.108719851040123, -7.161068111597368],
            [1.1077215240277707, -7.163113457668212],
            [1.0946393128482739, -7.161722615377729],
            [1.0858605916227122, -7.153944325693645],
            [1.083018217955064, -7.14657417375915],
            [1.0802672757893628, -7.145167310852364],
            [1.0830688685550804, -7.1430357010420025],
            [1.0837081178777705, -7.1387204910053335],
            [1.089125965265895, -7.134068639590571],
            [1.0916097326325336, -7.130210300029375],
            [1.0897207511642584, -7.120223606961579],
            [1.0864183680747606, -7.113461020023371],
            [1.0728188372057366, -7.112834721744064],
            [1.0675279744896813, -7.10537157262678],
            [1.0720377509671124, -7.105686696205996],
            [1.0725237273636592, -7.099579328812936],
            [1.0687114813319212, -7.094706800715543],
            [1.0711911954112041, -7.092694167487318],
            [1.0718496826476507, -7.086646993056254],
            [1.0746599150279295, -7.086664761083486],
            [1.0775304847501934, -7.081071119606098],
            [1.0756661945196941, -7.077371797712939],
            [1.072246336225722, -7.074945799323686],
            [1.0694813631693851, -7.070667964720958],
            [1.0690234495213413, -7.067165142434428],
            [1.0718073458181365, -7.065705146071065],
            [1.071149077143874, -7.062164898342836],
            [1.0620385656019105, -7.052685182862697],
            [1.053837037296831, -7.049899596336486],
            [1.053679180131021, -7.046421140481096],
            [1.0466364748335943, -7.041389608066793],
            [1.047074584753285, -7.032468284557531],
            [1.0422808848365788, -7.03224942899774],
            [1.0384324345561053, -7.034365063026613],
            [1.0327100524778858, -7.031270487384273],
            [1.0359853621582185, -7.028609903692189],
            [1.0328670403047595, -7.02167701371469],
            [1.0295784420485075, -7.020282519766759],
            [1.0270135356351033, -7.024692415810999],
            [1.0206300085755342, -7.020877765271675],
            [1.0288450949725807, -7.01084339295422],
            [1.0282809126222747, -7.005907751297365],
            [1.024527210673039, -7.003415628588405],
            [1.016992989693151, -7.005215950135428],
            [1.011525572513195, -7.0082517188314535],
            [1.0105304702932916, -7.010965961530377],
            [1.005858412088555, -7.010118084618649],
            [1.0004955853550057, -7.012319964529828],
            [0.9968288844651044, -7.003234605150385],
            [0.9990711401485244, -6.999308949363356],
            [1.0064265140548718, -6.997632076768448],
            [1.0038813180936976, -6.995267407193182],
            [1.0067205549494358, -6.9919356062198315],
            [1.0032068728491494, -6.986675190219961],
            [0.9965381263835672, -6.9865607773926595],
            [0.9911998729296704, -6.985229839577941],
            [0.9900967884956332, -6.9827954142089865],
            [0.985496602837763, -6.983979655886461],
            [0.982253812476897, -6.980796163001281],
            [0.9780937173460524, -6.9795943759921935],
            [0.9763879662219855, -6.97603891620733],
            [0.9719488879103321, -6.979096753926975],
            [0.9745091698746664, -6.968565151420432],
            [0.9732688889116127, -6.964543912797285],
            [0.9759734577251117, -6.958270300971364],
            [0.9746491470870268, -6.956049196230403],
            [0.9764531758130555, -6.952186045055895],
            [0.9718987427196326, -6.937976815033104],
            [0.9678012698300997, -6.929164528009306],
            [0.9702912764370623, -6.925731623699971],
            [0.9680995364153342, -6.917726725288975],
            [0.9643963209821813, -6.916389484285516],
            [0.9622345354654098, -6.911556232744096],
            [0.962435485857645, -6.905544504738574],
            [0.9567839061744011, -6.902356912399711],
            [0.9540747890467354, -6.903964027078839],
            [0.9501806520635109, -6.898633081279284],
            [0.9454622026444045, -6.900528227504254],
            [0.9387051812586504, -6.8964283693934645],
            [0.9368459141109999, -6.898195503957824],
            [0.9321752793567007, -6.89186182198863],
            [0.9338586301359111, -6.888948843901781],
            [0.932623965054517, -6.882885171795676],
            [0.9348945237981625, -6.878078652323254],
            [0.9414444750675347, -6.872034999631767],
            [0.9391158406569905, -6.868561790456311],
            [0.9397369121361432, -6.865683589473429],
            [0.9446824945975937, -6.859721621617667],
            [0.9426462976159597, -6.851988442065325],
            [0.9436388892130887, -6.846427581021338],
            [0.9388663239191725, -6.841581959703978],
            [0.9390451226065019, -6.838261173478229],
            [0.944338823071037, -6.837060794045397],
            [0.9468367664080667, -6.834557069651856],
            [0.9437461281546412, -6.826198022954419],
            [0.9484424005590283, -6.823181280653205],
            [0.9481096268627695, -6.820417969043058],
            [0.9513990965403034, -6.815106927651947],
            [0.9502888905833976, -6.810515591781749],
            [0.940314334729103, -6.803909775251701],
            [0.9319703979940395, -6.794236252340302],
            [0.9284302328812434, -6.785738302467063],
            [0.9253476446274502, -6.780595722727768],
            [0.9271895818113621, -6.776426583143125],
            [0.9331580283468139, -6.777058633378617],
            [0.9333871689186702, -6.772956518190976],
            [0.9284792782805822, -6.770835698268916],
            [0.9268861252073496, -6.76416866586218],
            [0.9286409554303675, -6.747612605110704],
            [0.9314660415245288, -6.745592589475417],
            [0.9309350898257738, -6.741699965124778],
            [0.9348119850340242, -6.7374743421908905],
            [0.9442458690409179, -6.732992062657945],
            [0.9468922535458197, -6.727678300310395],
            [0.9463193950715956, -6.724774731525031],
            [0.9494361279853027, -6.721525682695008],
            [0.9422756459426076, -6.709315266028734],
            [0.9373234015312408, -6.7076328923783315],
            [0.937659091981494, -6.704641878638073],
            [0.9414590242722424, -6.699762089556205],
            [0.9461042253862229, -6.70151395722202],
            [0.9503327420334008, -6.698686099663939],
            [0.951239768656935, -6.692931859193276],
            [0.9463851331243323, -6.6894059204512955],
            [0.9443105409936114, -6.690158868534249],
            [0.9399115129846267, -6.687283536427211],
            [0.9387042569784922, -6.6827104212459005],
            [0.9423794091920807, -6.680688514146755],
            [0.9390654553587134, -6.676957199281872],
            [0.9377105651099655, -6.672057378962043],
            [0.9433390376598494, -6.668489698770825],
            [0.9447650957134053, -6.663349676664475],
            [0.9474208329448954, -6.663577352325183],
            [0.9492715999356056, -6.6563843275003745],
            [0.9455542959621722, -6.655824667135638],
            [0.945866357881081, -6.653755532454439],
            [0.9429264727079933, -6.646467107339477],
            [0.9385333672826728, -6.643891689431114],
            [0.9355643695045381, -6.6445988931655995],
            [0.9337090674529954, -6.638623242706672],
            [0.9297090285754873, -6.633954606066074],
            [0.9253723234287553, -6.632771633166618],
            [0.9175144601169767, -6.616834351679143],
            [0.9187932866418571, -6.604983644207374]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.16506283758696,
          "lat": 31.836967821294717
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48073"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01383822"
      },
      "bbox": [
        0.9175144601169767, -7.309607755735493, 1.4265876032111884,
        -6.599308444606198
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.599456567384266, -6.552730534313702],
            [-3.5395163380954613, -6.556086554590056],
            [-3.528501529547587, -6.557366909017111],
            [-3.46795785937562, -6.560458468580107],
            [-3.434300182981956, -6.562113047090754],
            [-3.428602445864909, -6.562988259409533],
            [-3.3393118958186587, -6.568732854224723],
            [-3.2543075268706634, -6.573706659706831],
            [-3.1815848496463257, -6.577914863208794],
            [-3.118651940055035, -6.580559307784459],
            [-3.1057840011374447, -6.580350858429744],
            [-3.1104455357947423, -6.672525891003644],
            [-3.1179535061274484, -6.835282207327971],
            [-3.123738413163198, -6.968413870105753],
            [-3.1769567312429756, -6.966315982757767],
            [-3.2979382002352047, -6.960412163069023],
            [-3.324835275574897, -6.958909581238771],
            [-3.401024709672862, -6.955009054961458],
            [-3.5544639279164887, -6.946123296739226],
            [-3.6225426368086797, -6.941615021027588],
            [-3.6133185032618407, -6.788385743826144],
            [-3.599456567384266, -6.552730534313702]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.52993928799279,
          "lat": 31.888597481648006
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48081"],
        "coty_name": ["Coke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coke County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01383826"
      },
      "bbox": [
        -3.6225426368086797, -6.968413870105753, -3.1057840011374447,
        -6.552730534313702
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.3956021951760086, -5.747643164826462],
            [-0.3353142876596328, -5.7489499374952375],
            [-0.23985863580671613, -5.751430735459662],
            [-0.12912914242597479, -5.7540844455623805],
            [-0.022895209726145862, -5.756624842879898],
            [0.03276872716603575, -5.7579518157936125],
            [0.03269345520279824, -5.77690416520009],
            [0.03165780142423197, -5.823651863459482],
            [0.03092985057823196, -5.864960495695387],
            [0.030205911974445363, -5.927347008585061],
            [0.02933767435602069, -5.986513583888875],
            [0.028134652477501704, -6.040841397300004],
            [0.028089985312785067, -6.056846892947967],
            [0.027118282754772897, -6.096158642815204],
            [0.025254882584007137, -6.195789776993351],
            [0.019756620853350202, -6.195693515281385],
            [-0.07476728532024068, -6.194351193863052],
            [-0.15865004718738573, -6.193138681611481],
            [-0.23983142057531667, -6.191897099665828],
            [-0.33756446109828564, -6.190419436866996],
            [-0.40685006492764925, -6.188808718068363],
            [-0.4046292732157197, -6.0991261121825975],
            [-0.4016382647241891, -5.980388189069566],
            [-0.40117333891616225, -5.9575485914054],
            [-0.39855471058007214, -5.859107887697325],
            [-0.3956021951760086, -5.747643164826462]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.77776779253142, "lat": 32.76655594783184 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48113"],
        "coty_name": ["Dallas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dallas County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01383842"
      },
      "bbox": [
        -0.40685006492764925, -6.195789776993351, 0.03276872716603575,
        -5.747643164826462
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.682089761442723, -6.4519515705171715],
            [-1.638680333163683, -6.427925784686804],
            [-1.6167962584376727, -6.416046621031936],
            [-1.6153110320173873, -6.341830063264117],
            [-1.6144780546412911, -6.307034780337403],
            [-1.6129489372222907, -6.255125739069973],
            [-1.6116081125794812, -6.202289538073736],
            [-1.525561043337391, -6.204626587856126],
            [-1.4358657806196164, -6.206901727603898],
            [-1.3320464495901279, -6.209973096235483],
            [-1.2707516455077243, -6.2118039384794255],
            [-1.2667713587092388, -6.223924072793141],
            [-1.2384093673529966, -6.305964466493123],
            [-1.2230072964408498, -6.349638549396299],
            [-1.2174824822786467, -6.362187408996872],
            [-1.1875410881218076, -6.451254396394504],
            [-1.1734215838960635, -6.491852589644277],
            [-1.1693285479541156, -6.503653185540183],
            [-1.1282765840710884, -6.595031822025151],
            [-1.1083552992949062, -6.639095666645397],
            [-1.21676025079025, -6.699453859411526],
            [-1.228335663928094, -6.705981865060863],
            [-1.2612180099842594, -6.7240844356839125],
            [-1.3315362382624016, -6.763223463675379],
            [-1.4018634830838645, -6.802349637862236],
            [-1.4365445431879689, -6.739050909987607],
            [-1.501884054100506, -6.77627822640561],
            [-1.5321548106009852, -6.720754994411279],
            [-1.534039377149787, -6.716754443308336],
            [-1.5545575268800902, -6.680103692465395],
            [-1.561037639766179, -6.669986445622835],
            [-1.5832550274661308, -6.6308943677429895],
            [-1.6250707031698888, -6.555827126867988],
            [-1.6721861904621782, -6.4704583469478525],
            [-1.682089761442723, -6.4519515705171715]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.21794318321619, "lat": 32.23624459385387 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48143"],
        "coty_name": ["Erath"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Erath County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01383857"
      },
      "bbox": [
        -1.682089761442723, -6.802349637862236, -1.1083552992949062,
        -6.202289538073736
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5534666198841407, -8.236606659577385],
            [1.640780324517396, -8.234868658646892],
            [1.7209530902378556, -8.233241550430483],
            [1.7196973494383112, -8.225260077545125],
            [1.713703531382038, -8.197722738813857],
            [1.7528275454001412, -8.197280605955532],
            [1.7562639674591713, -8.19703737711445],
            [1.8104413751932225, -8.196122454807535],
            [1.8604050553470648, -8.195478493795218],
            [1.9557425586825243, -8.193916042413944],
            [2.02296855149498, -8.192948021606782],
            [2.1211031141318295, -8.191482859994716],
            [2.121735486333037, -8.194943584107522],
            [2.1157586450663675, -8.206484380341633],
            [2.110859636204263, -8.211959201647023],
            [2.1147174487136855, -8.214745138497529],
            [2.114925517846468, -8.222829812819667],
            [2.1126575691772014, -8.224433551269202],
            [2.106591033885921, -8.232244191810617],
            [2.1034967064922117, -8.243385450621926],
            [2.100549930317242, -8.247151579226514],
            [2.0952655497445973, -8.248839169978725],
            [2.099743528945961, -8.25215664539062],
            [2.1026924217913603, -8.251838315435835],
            [2.0995019212064876, -8.258929745908858],
            [2.091929143167074, -8.267175457938993],
            [2.0926603297184916, -8.279901158415424],
            [2.084476352644334, -8.284797531614963],
            [2.086095708875579, -8.28880889963802],
            [2.0830071272564608, -8.292410758385357],
            [2.0866230215651327, -8.293943358034708],
            [2.0866209969118366, -8.299036523786503],
            [2.0846443108172075, -8.299715911215467],
            [2.0827228727591116, -8.30776386477039],
            [2.0831400711002956, -8.310887144674656],
            [2.0876267062772595, -8.310676174806396],
            [2.087997573997247, -8.314226678425605],
            [2.0849175824393753, -8.314950494782835],
            [2.084943569200135, -8.31973028328093],
            [2.088934581821214, -8.319598384434883],
            [2.0912742380068186, -8.323073321172659],
            [2.096024035652769, -8.32272684658495],
            [2.0968599530183214, -8.324807427009507],
            [2.0938226556740336, -8.330533853739194],
            [2.0982159973227095, -8.335416474872279],
            [2.0994365022021086, -8.343181256830489],
            [2.097635881604497, -8.347342200561938],
            [2.100760336458, -8.355024298586983],
            [2.1032867719856356, -8.355949788061594],
            [2.108335460647056, -8.361488504526244],
            [2.1082398981667576, -8.365946526645699],
            [2.113075816917101, -8.362726520699006],
            [2.1150967715772326, -8.370490028126184],
            [2.1147655732006596, -8.373939469232262],
            [2.108913411275127, -8.378702223787524],
            [2.10488204542491, -8.376901804950057],
            [2.103000098674001, -8.384437092124513],
            [2.0984163430579406, -8.390372114164746],
            [2.101028368757029, -8.398848839345707],
            [2.099257305485787, -8.402999226449628],
            [2.095125333188596, -8.406266351182769],
            [2.0943280760413416, -8.409568697938841],
            [2.0889567211959945, -8.411199671152195],
            [2.0859569298037277, -8.415770075508545],
            [2.086649102731582, -8.424245186559558],
            [2.0891869847143436, -8.429039704048705],
            [2.0848981595723353, -8.430889811984034],
            [2.0924143810010944, -8.4477499016269],
            [2.0906688106258033, -8.453206678133622],
            [2.099015580340201, -8.451217018497495],
            [2.10518413675098, -8.45688704119064],
            [2.0964517513407035, -8.461809023224422],
            [2.093445414713574, -8.468019614420353],
            [2.0866505061113862, -8.47143371361384],
            [2.0872871091083156, -8.474101481071848],
            [2.088411309766762, -8.476473303985793],
            [2.087202000976153, -8.481569985168864],
            [2.088705302247817, -8.487182095615191],
            [2.0877388165929474, -8.49045175951111],
            [2.0888569645518493, -8.496643828026409],
            [2.0937076792931895, -8.501668658336154],
            [2.098761766788235, -8.50442237329268],
            [2.1005546285200696, -8.503412143066056],
            [2.10782371285929, -8.512041842821658],
            [2.1075697503306134, -8.517908578956142],
            [2.1039880276103426, -8.522885095099628],
            [2.1038836607270186, -8.526859495178359],
            [2.0988726857301065, -8.524994081509735],
            [2.094481485879038, -8.527365857972912],
            [2.093093331754923, -8.539830671182791],
            [2.0910987687035827, -8.54240954260829],
            [2.095094764858955, -8.54730342760606],
            [2.0903562413409267, -8.554599266405837],
            [2.086379108553752, -8.54939889009403],
            [2.0794395530237364, -8.549424386115398],
            [2.0711270602418357, -8.546574759580622],
            [2.0697570336539104, -8.549774830493194],
            [2.0583139234678156, -8.544948999606188],
            [2.0538114845391577, -8.545193903583362],
            [2.0442664361873457, -8.542513745021962],
            [2.047228313440203, -8.539699648529293],
            [2.04056225201308, -8.537134369458416],
            [2.040987090518698, -8.531187933687159],
            [2.037580303112437, -8.528285888538779],
            [2.0345376350803086, -8.533564843545275],
            [2.0303340024114, -8.536196985462604],
            [2.0266219394804246, -8.536483940611404],
            [2.0269691191011106, -8.532637046307284],
            [2.0237421670194493, -8.530308570825598],
            [2.0176281896685633, -8.532101355255215],
            [2.0140317289740612, -8.527858704699517],
            [2.0089885993769543, -8.529037498604108],
            [2.009426668243404, -8.53195743932318],
            [2.0067666957812644, -8.534672536309994],
            [2.0014486801223237, -8.536771192928576],
            [1.9970421667709275, -8.543166317583896],
            [1.9905501796729852, -8.544405322108554],
            [1.9875327871303392, -8.547269824711078],
            [1.9865561188862677, -8.55168049352974],
            [1.9821972958842824, -8.551548427333072],
            [1.978867640336746, -8.548033715475697],
            [1.9755866820956798, -8.550638086059035],
            [1.9673371002112572, -8.545753438837748],
            [1.9656606516154596, -8.549828903799481],
            [1.9608596645138945, -8.549917661566639],
            [1.9524587534168936, -8.547364861487635],
            [1.949256207420762, -8.557548623592567],
            [1.9500947193589275, -8.561697316238742],
            [1.9489315994049945, -8.566092721761066],
            [1.9520399433761355, -8.570666047302737],
            [1.9520781004067465, -8.576984787242914],
            [1.948874977065113, -8.585982717375753],
            [1.9433724656276588, -8.588220992899577],
            [1.9385774856983382, -8.599699187823438],
            [1.9306477943019589, -8.601946859445272],
            [1.9246222939780953, -8.600321209139366],
            [1.918849347797746, -8.599997783202737],
            [1.9157432666540921, -8.604197186980947],
            [1.912916107379605, -8.603516800546716],
            [1.9103281974757482, -8.60641666657177],
            [1.9060294242827287, -8.60509725799951],
            [1.9048662497904336, -8.607569163832476],
            [1.8997557373206668, -8.610669817435527],
            [1.8992779235485182, -8.613554497818173],
            [1.8895411105557227, -8.613512335635022],
            [1.8897533192778535, -8.610687726654973],
            [1.880782595119092, -8.612483973194005],
            [1.8798050683983, -8.615294850679161],
            [1.874716576909269, -8.615367602479063],
            [1.8665738521149549, -8.609467596378241],
            [1.861933192241643, -8.6104855336765],
            [1.8563899472499117, -8.61465514065542],
            [1.8533407874360261, -8.612755632846111],
            [1.847753744378999, -8.618952129301368],
            [1.846843093051798, -8.621346545833795],
            [1.838896672314807, -8.619139857280759],
            [1.8338101084135239, -8.61995265242489],
            [1.8282289480729161, -8.61407011772286],
            [1.8218134935397134, -8.613842597801689],
            [1.8142483287526054, -8.60527436294854],
            [1.8108240270089526, -8.603749658866267],
            [1.8071248257573187, -8.606540505072866],
            [1.7251264035530114, -8.60891978749002],
            [1.6763353140130837, -8.609458506880515],
            [1.650518338174228, -8.531298458321437],
            [1.646517164310467, -8.519847695300955],
            [1.6050849293520442, -8.393413947929371],
            [1.569812385723152, -8.286224431690515],
            [1.5534666198841407, -8.236606659577385]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.39017030617563,
          "lat": 30.332395307753373
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48199"],
        "coty_name": ["Hardin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardin County"],
        "coty_fp_code": "199",
        "coty_gnis_code": "01383885"
      },
      "bbox": [
        1.5534666198841407, -8.621346545833795, 2.121735486333037,
        -8.191482859994716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.571470124523009, -5.191327415841979],
            [-4.5089801047140226, -5.1949991309099675],
            [-4.493154684986066, -5.195253418855353],
            [-4.3995977405445, -5.199700878562449],
            [-4.3209463620694235, -5.203386987127802],
            [-4.250210382790334, -5.206628151484152],
            [-4.170095729485071, -5.210757265490387],
            [-4.1415387995135635, -5.212364795109934],
            [-4.142718905936731, -5.233813505046556],
            [-4.150829980559612, -5.3660610820053165],
            [-4.155473538526939, -5.441111260612586],
            [-4.162241562049113, -5.554080224800484],
            [-4.167507414570565, -5.646214889459809],
            [-4.278869604964729, -5.638833557392039],
            [-4.301724409685748, -5.637350314031416],
            [-4.3885908295773906, -5.632863427673276],
            [-4.507187450297219, -5.6262689692286285],
            [-4.534554477185506, -5.624673952916903],
            [-4.599350078119387, -5.621207509093254],
            [-4.5969638136167426, -5.587915068242396],
            [-4.596061399187743, -5.5808832211715],
            [-4.589270323373755, -5.472376375617792],
            [-4.587330734562744, -5.442822493096754],
            [-4.585523358537392, -5.411266410200514],
            [-4.5768880132634715, -5.275453910664343],
            [-4.571470124523009, -5.191327415841979]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.81612696132085,
          "lat": 33.17682683871332
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48305"],
        "coty_name": ["Lynn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lynn County"],
        "coty_fp_code": "305",
        "coty_gnis_code": "01383938"
      },
      "bbox": [
        -4.599350078119387, -5.646214889459809, -4.1415387995135635,
        -5.191327415841979
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.1802538782796748, -7.7535258859644305],
            [-2.177297305397976, -7.669181185572643],
            [-2.17353019245972, -7.562120220064498],
            [-2.1697503888000096, -7.4462618764871005],
            [-2.1618431908607056, -7.236595663666351],
            [-2.155689532375662, -7.23915553386534],
            [-2.148957813801801, -7.234693759102289],
            [-2.146353960863667, -7.230964954322268],
            [-2.1383232605751363, -7.235562675554665],
            [-2.1358390778872467, -7.233410082759057],
            [-2.1374576689886955, -7.227628781266903],
            [-2.1314357015159975, -7.2241013147636615],
            [-2.127079540346208, -7.214514455676055],
            [-2.117392444214602, -7.208839376289515],
            [-2.113164899623555, -7.211645101170709],
            [-2.1096111055041433, -7.217203496386095],
            [-2.102893229160937, -7.224350209885715],
            [-2.100751545675318, -7.229903197582284],
            [-2.0935942316005276, -7.228487368311431],
            [-2.0894516356056765, -7.219621484776148],
            [-2.082023248007917, -7.2188917184138575],
            [-2.077024619331361, -7.216226981910087],
            [-2.073538670425743, -7.218323770359382],
            [-2.0732244621880995, -7.221469452355945],
            [-2.0800831833441933, -7.229171036825353],
            [-2.0804793826550108, -7.233454231499575],
            [-2.072445779423408, -7.238557538113278],
            [-2.064947225885895, -7.245048173109405],
            [-2.0577926859860267, -7.246598335068755],
            [-2.054853426025969, -7.248618295281247],
            [-2.0544230007609308, -7.254613609310593],
            [-2.0572559889938153, -7.2564488002007845],
            [-2.0580904606974513, -7.2628331676790845],
            [-2.054843853970665, -7.265915570520785],
            [-2.051796386436929, -7.260887897604923],
            [-2.045379301828852, -7.253838827438328],
            [-2.047294109804667, -7.2487164007309275],
            [-2.0427287224129427, -7.244291866291346],
            [-2.039324403693291, -7.243055555495237],
            [-2.033863077641418, -7.243295108797306],
            [-2.0306081608447113, -7.2457025092608704],
            [-2.03058703836076, -7.25509657231806],
            [-2.0288849254593537, -7.264688230266657],
            [-2.022182888311518, -7.267822214206688],
            [-2.015161102853452, -7.266191280794018],
            [-2.0121131821069165, -7.2678053338333],
            [-2.002363049895003, -7.266399705440378],
            [-1.9972643382104505, -7.2689988223653],
            [-1.9899639677812881, -7.262947775333655],
            [-1.9881498547813043, -7.259961815729382],
            [-1.9771044943514717, -7.258913963644657],
            [-1.9716436738262229, -7.262838471336354],
            [-1.9661684337129743, -7.268547237878454],
            [-1.960803291714884, -7.283202034896583],
            [-1.9625679216587102, -7.290105689423203],
            [-1.9558147461168238, -7.2932422697961865],
            [-1.943765022210384, -7.293998862730024],
            [-1.939415074468033, -7.29260924884786],
            [-1.9324721311919426, -7.287984563530447],
            [-1.9285033016735385, -7.290880504404712],
            [-1.9309554856660673, -7.297512347747919],
            [-1.928211505228757, -7.29979637838503],
            [-1.9208654075700187, -7.297798471413964],
            [-1.9160080073980388, -7.294292796615011],
            [-1.9093470629881413, -7.297191626797144],
            [-1.9059330774863688, -7.297261158813047],
            [-1.897073643887841, -7.291446169800778],
            [-1.8935582461493687, -7.294622034540364],
            [-1.8952028997739463, -7.30252624692635],
            [-1.8952473174275162, -7.3096986296999225],
            [-1.8964730816713893, -7.317781809941348],
            [-1.8999957666894602, -7.326071005200768],
            [-1.8975132668910357, -7.328021417702057],
            [-1.8924185453506288, -7.325466815865531],
            [-1.8899168685067451, -7.3295220473293075],
            [-1.8857502799757482, -7.330350440520029],
            [-1.8758841431139701, -7.3183608108834655],
            [-1.879021855245708, -7.309976696950759],
            [-1.87913706118437, -7.305479183667544],
            [-1.8751600144737235, -7.302443923510877],
            [-1.8703055066603422, -7.302272420044679],
            [-1.8658388176915255, -7.298732745419033],
            [-1.862599904195551, -7.289335446491872],
            [-1.8628096447138334, -7.285839012729371],
            [-1.8674069985361044, -7.278232374993922],
            [-1.8633482804981996, -7.276130015850353],
            [-1.8551279272481531, -7.277658604158137],
            [-1.851533572894548, -7.281694733550319],
            [-1.8531151382383229, -7.2909217456441455],
            [-1.8560065871102012, -7.29476010299254],
            [-1.8518837008647515, -7.29945945564175],
            [-1.8471203697615093, -7.30282202926168],
            [-1.8370769500226063, -7.2995912635041105],
            [-1.8287616027156033, -7.300096699127904],
            [-1.8276932230069742, -7.303188666605295],
            [-1.8285019180841207, -7.313082462770046],
            [-1.826261535996603, -7.319945195678297],
            [-1.831852288526364, -7.322415253887673],
            [-1.8360917105612746, -7.3268831382634625],
            [-1.8370440569643869, -7.337739919006102],
            [-1.8351930666136436, -7.341594559428647],
            [-1.836981520303289, -7.3493488782761105],
            [-1.839690068134893, -7.351313906449956],
            [-1.8437634615312721, -7.35118971518321],
            [-1.8444572348482797, -7.3578741734594155],
            [-1.843029560662137, -7.35996800888142],
            [-1.8387666651935286, -7.360059659925268],
            [-1.835857502103532, -7.36775877979574],
            [-1.8295873165974488, -7.3671238389254405],
            [-1.8253074166230172, -7.363322642725096],
            [-1.8187127717244063, -7.361261001288658],
            [-1.8121491224546744, -7.3548212505695485],
            [-1.8077381986612386, -7.352650862010058],
            [-1.807379939485531, -7.346614950679979],
            [-1.801696562480577, -7.344027497982432],
            [-1.796246653028991, -7.339414469648121],
            [-1.7913553291519524, -7.339480269859499],
            [-1.7906079595797713, -7.343104092201301],
            [-1.7942361243592098, -7.347795806222748],
            [-1.7916123536806126, -7.351217539217861],
            [-1.7893140911203835, -7.3486341159005],
            [-1.7790603955614528, -7.355634920468582],
            [-1.780940269680227, -7.361916586742423],
            [-1.7839165713312226, -7.362418114498359],
            [-1.7884122692864997, -7.367552832194272],
            [-1.7867996326078752, -7.372819217167435],
            [-1.782493500589514, -7.376493821371121],
            [-1.7865297846291284, -7.382316124786464],
            [-1.790222389370987, -7.384645688307955],
            [-1.7908668212719598, -7.39048661091252],
            [-1.7865625646561425, -7.394105338160552],
            [-1.7828147815997097, -7.391124039202973],
            [-1.77666309902428, -7.383525798848921],
            [-1.7743393009315718, -7.382542118353884],
            [-1.766184227768115, -7.38388673234425],
            [-1.7703244575390698, -7.3909962187656175],
            [-1.7754696326056765, -7.393141190676264],
            [-1.7754816833077849, -7.3983004177815115],
            [-1.769651565155099, -7.39924585383441],
            [-1.7550705667510296, -7.396880903215002],
            [-1.7518141821216608, -7.395433128963126],
            [-1.7453982202718836, -7.388557798924681],
            [-1.7454215780760585, -7.3856347999322995],
            [-1.742290437850911, -7.382495472585152],
            [-1.7380446881075913, -7.384085873003312],
            [-1.7376887980657656, -7.39010349522413],
            [-1.7444716161108358, -7.397828692302442],
            [-1.746251029058623, -7.403408851837961],
            [-1.74842490338761, -7.417262465580164],
            [-1.7487007842967628, -7.4225095677133055],
            [-1.7537886135858562, -7.424874248186093],
            [-1.761841359656678, -7.427115961944273],
            [-1.7688270831595045, -7.423447662510559],
            [-1.7730135832198348, -7.427221606028436],
            [-1.7744342769516273, -7.434082644718819],
            [-1.7722242255331309, -7.438576209482095],
            [-1.7617738140724775, -7.445629127596896],
            [-1.7569824466155566, -7.447443956289118],
            [-1.7490441359076758, -7.455043707610631],
            [-1.7456342844811819, -7.454105814539588],
            [-1.746080416987499, -7.447902126264084],
            [-1.7444637706108825, -7.443188590642381],
            [-1.7407110817390454, -7.441629601872226],
            [-1.7333358108006462, -7.444024489829177],
            [-1.7296615992006998, -7.455305058912019],
            [-1.7242044745069427, -7.464753461478151],
            [-1.7215442364005888, -7.46699660854695],
            [-1.719792730058578, -7.47385663663822],
            [-1.719740393723106, -7.479171075945969],
            [-1.720655900829143, -7.488287376560028],
            [-1.7242177134392929, -7.497514610323809],
            [-1.7263660698713985, -7.506038833511464],
            [-1.7252968752180877, -7.511485324717341],
            [-1.7180491497820336, -7.516505784675447],
            [-1.7119924102623516, -7.517354960186849],
            [-1.7046768596111035, -7.515175009850542],
            [-1.7000510668045263, -7.518648335676467],
            [-1.6977633300202835, -7.524145306168724],
            [-1.7057643067457393, -7.5310910851081605],
            [-1.7035956350816022, -7.535279236668444],
            [-1.6951278629805238, -7.536074544796015],
            [-1.691671784878225, -7.537739968625644],
            [-1.68603280001303, -7.5444160176724795],
            [-1.6813316201923039, -7.545670886383381],
            [-1.6730423161997343, -7.54321436738493],
            [-1.6713554695099744, -7.5471181647753705],
            [-1.6779004064575425, -7.555206475366645],
            [-1.68132584618138, -7.5558061872353175],
            [-1.6910622307359042, -7.554194936468024],
            [-1.6934261248233597, -7.557518540336377],
            [-1.6916707195846308, -7.569530203774079],
            [-1.6956960940711507, -7.575056245683808],
            [-1.702288803062286, -7.578157106247665],
            [-1.7079690456227747, -7.5794987970328425],
            [-1.7103708768833534, -7.584992405590407],
            [-1.707319912904284, -7.5899691756562495],
            [-1.7018166340571685, -7.5959816362656225],
            [-1.7009944104416552, -7.5991768733261535],
            [-1.6961354964994402, -7.6069065423039515],
            [-1.6950265890280123, -7.61482725812345],
            [-1.6931187089647919, -7.618950025840435],
            [-1.6900578192986027, -7.620810213801803],
            [-1.6855456876090267, -7.617134976454472],
            [-1.679666339438469, -7.603766451458775],
            [-1.6731548425823228, -7.600389376355338],
            [-1.670250680337626, -7.5934159461443365],
            [-1.6638069146412213, -7.591937373033874],
            [-1.658635252609664, -7.596439001785221],
            [-1.6538866585542717, -7.591618815267202],
            [-1.6516364638001952, -7.592780308628303],
            [-1.6457030345660515, -7.60308550551354],
            [-1.6403796818565741, -7.6035210384060266],
            [-1.635786098604151, -7.599606208715407],
            [-1.631580152761341, -7.600425329008636],
            [-1.63136402897407, -7.603170495196259],
            [-1.6368303776428432, -7.609970780306643],
            [-1.6435094648999828, -7.614304206806554],
            [-1.6431788187779326, -7.618823795312531],
            [-1.6347521933602231, -7.621805628695189],
            [-1.6330992697759963, -7.624563516112894],
            [-1.6327582361820736, -7.631526014749695],
            [-1.638574399334513, -7.635005305319233],
            [-1.6473335099240236, -7.634814648030292],
            [-1.650621092246369, -7.640447954533321],
            [-1.656890525086225, -7.643181103722866],
            [-1.6555939348194435, -7.651217231487282],
            [-1.650301129740228, -7.65719220340451],
            [-1.640812961613239, -7.663175159034086],
            [-1.6316702910550998, -7.6664031550960665],
            [-1.6274126287041046, -7.668918707648535],
            [-1.6242866098795157, -7.6725786526534305],
            [-1.6201193103328129, -7.681538523503276],
            [-1.6200794538277314, -7.686036378094613],
            [-1.6254509348329895, -7.692934022378501],
            [-1.6352715653396042, -7.69754951098889],
            [-1.6373602728944598, -7.702877504204893],
            [-1.6323707889093886, -7.711134058720784],
            [-1.626596446938178, -7.717915603753592],
            [-1.6231343134494334, -7.72652876132809],
            [-1.6244103797628342, -7.731058859062285],
            [-1.6329564033280204, -7.741785025675815],
            [-1.6329821051833298, -7.746087203810134],
            [-1.6284388473294582, -7.758773291406716],
            [-1.6241159127718412, -7.760981069423201],
            [-1.6093697459018639, -7.7626167477147945],
            [-1.6020611745624038, -7.766305371660748],
            [-1.600827352924673, -7.769061208449192],
            [-1.6033952734200865, -7.78148569646025],
            [-1.60797134805552, -7.786625561646047],
            [-1.6188354336971433, -7.783522495625144],
            [-1.6246610826765022, -7.784605954139588],
            [-1.6280963054698878, -7.788917872275204],
            [-1.6747236308270648, -7.787208597079439],
            [-1.7000921114242526, -7.786741110352246],
            [-1.723619456570422, -7.785870561224984],
            [-1.7820678814287547, -7.784396431756306],
            [-1.8856776555654717, -7.78250902647571],
            [-1.8885188377039062, -7.782952474686647],
            [-1.9910952687458212, -7.779196914668637],
            [-1.995490369260978, -7.779416178338936],
            [-2.0717138075745454, -7.776474824378961],
            [-2.1305775295259792, -7.77421631892272],
            [-2.1809723337466194, -7.772427660398661],
            [-2.1802538782796748, -7.7535258859644305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.81756481341307,
          "lat": 31.155173223502228
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48411"],
        "coty_name": ["San Saba"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Saba County"],
        "coty_fp_code": "411",
        "coty_gnis_code": "01383991"
      },
      "bbox": [
        -2.1809723337466194, -7.788917872275204, -1.600827352924673,
        -7.208839376289515
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.744680142077002, -0.035722925555027915],
            [-12.737100486984447, 0.007508050525992058],
            [-12.647201485920828, -0.008594213297029373],
            [-12.569011417423111, -0.022291829248935316],
            [-12.556224779240216, -0.02514516787975136],
            [-12.479429179944885, -0.03889415848289316],
            [-12.47231531599137, -0.040571071254682387],
            [-12.34672428299287, -0.062430676103217356],
            [-12.319693476937372, -0.06698481704424838],
            [-12.320724302943287, -0.07289995831734193],
            [-12.25593091496968, -0.0841214785622924],
            [-12.168870921399016, -0.09917317608502954],
            [-12.169028680170284, -0.10009177513243174],
            [-12.080892750717556, -0.11527921616549755],
            [-11.91813209842543, -0.14285156751241987],
            [-11.9174833756648, -0.1389528040351729],
            [-11.877188202347813, -0.14568751864794785],
            [-11.664841679606562, -0.18112650509974249],
            [-11.664751257056444, -0.18057750247563695],
            [-11.408672018802019, -0.22159342779027905],
            [-11.152597192922343, -0.2626365341059039],
            [-10.991754278863787, -0.2878365846000342],
            [-10.999794088293813, -0.2971538838274542],
            [-11.004686769024746, -0.30060972908918293],
            [-11.008539171077167, -0.30791218741364446],
            [-11.01115499801457, -0.31527505386374854],
            [-11.012322164454003, -0.3216593892683043],
            [-11.015104574430108, -0.3286999266585127],
            [-11.013525936831684, -0.33127956377009654],
            [-11.002258362225694, -0.3339683000840317],
            [-10.995102138753877, -0.33848989519903167],
            [-10.995136096323792, -0.3430514016892676],
            [-10.9982567025704, -0.34442971186102206],
            [-11.005541037730058, -0.34501178758930234],
            [-11.013977771228019, -0.34794934491228624],
            [-11.017717251315718, -0.34808613733794685],
            [-11.027637399570938, -0.3455295378867149],
            [-11.033803807925892, -0.34273679915206823],
            [-11.041984893710648, -0.34021704765191985],
            [-11.05482331499417, -0.33817651904522],
            [-11.058292510441126, -0.3390259119317974],
            [-11.063799365943643, -0.34688070360275963],
            [-11.065100603362744, -0.35788593497507626],
            [-11.068562612884174, -0.36002183027996726],
            [-11.080334167357197, -0.3562205765547882],
            [-11.082810051508808, -0.3575268720432273],
            [-11.082305151429358, -0.36354702241612485],
            [-11.078929501996676, -0.3679831780193136],
            [-11.075736306399026, -0.3749793918421694],
            [-11.069659727796386, -0.3828366114029952],
            [-11.064761314580496, -0.38423413962393393],
            [-11.05700759021326, -0.38303235010641984],
            [-11.050984293835523, -0.38586145757671675],
            [-11.049992069828527, -0.3914520026543684],
            [-11.057104992459793, -0.4034986083025987],
            [-11.060842453645487, -0.4123003744264339],
            [-11.065445682548962, -0.41659491702582546],
            [-11.069926819033112, -0.419078950467717],
            [-11.075912826194843, -0.4178999376460941],
            [-11.082579708828458, -0.41129133915085625],
            [-11.089084081472162, -0.4084715240441912],
            [-11.09475960329444, -0.4095766572429515],
            [-11.096244680568422, -0.4161970974923085],
            [-11.094416956524364, -0.42201843820968854],
            [-11.090610718687461, -0.42943479742924207],
            [-11.079669901271572, -0.44261469565666106],
            [-11.0768213190276, -0.4477596940718166],
            [-11.080345334169737, -0.4526861919417499],
            [-11.088379815929288, -0.4578725790102521],
            [-11.090176806626351, -0.46206503514621755],
            [-11.089649759608605, -0.46675765521792506],
            [-11.091505757728035, -0.4711534544000212],
            [-11.094508418496806, -0.4719237823427564],
            [-11.098971305915551, -0.46860957666910946],
            [-11.10009340487692, -0.4637051752483244],
            [-11.10464099498603, -0.4641035891753502],
            [-11.106808474927426, -0.46915458492842965],
            [-11.108883481367123, -0.4782110612471227],
            [-11.112548615933344, -0.4816457521165783],
            [-11.11777832139541, -0.4810526828916746],
            [-11.121052234276393, -0.4832175993009455],
            [-11.12376321785391, -0.48744011893244005],
            [-11.126875793176335, -0.4891017180305647],
            [-11.133377780456252, -0.487314751110682],
            [-11.148565846286536, -0.4878135932110791],
            [-11.156518189023217, -0.4805246300592505],
            [-11.158517945843698, -0.4773125770468557],
            [-11.16891994913747, -0.4701642325778788],
            [-11.176758347951818, -0.4611925516555078],
            [-11.184814341027618, -0.4539017129060806],
            [-11.190214467065584, -0.4514384376188635],
            [-11.19473770063922, -0.4519763102217229],
            [-11.198818134560007, -0.45561676615074165],
            [-11.19945454046283, -0.462842701530252],
            [-11.196871715455583, -0.47231727454776773],
            [-11.192204994193379, -0.4768435005047493],
            [-11.183143289316137, -0.4799682994491814],
            [-11.177196761996584, -0.48592359042508615],
            [-11.17625451023829, -0.48927231943650756],
            [-11.17717806552528, -0.5012487769056754],
            [-11.18089451678046, -0.5077698396578499],
            [-11.184686799179257, -0.5101452055144996],
            [-11.19021011296575, -0.5115383322848183],
            [-11.202239358266318, -0.5110559050869012],
            [-11.207244895875215, -0.5133585202557099],
            [-11.208859707185876, -0.5224856143962817],
            [-11.207614056960178, -0.526928379408796],
            [-11.201673112624102, -0.5370200187935184],
            [-11.201878536222752, -0.5415874650148367],
            [-11.20511643217281, -0.5450021849877897],
            [-11.210320371828338, -0.544644531234877],
            [-11.221703859882046, -0.5464676416942127],
            [-11.225457093784016, -0.5503124204264713],
            [-11.224949353101875, -0.5538538590245106],
            [-11.220268910233072, -0.5619118730094271],
            [-11.217865140206726, -0.5699669386161464],
            [-11.220561763926538, -0.5744734996735422],
            [-11.225273164559995, -0.5770090427565474],
            [-11.234114153527724, -0.5786385029992378],
            [-11.237476582479134, -0.5811861435878175],
            [-11.238337434020044, -0.5862287079590152],
            [-11.233551611604469, -0.5932019737850704],
            [-11.233123188512405, -0.5965918248705282],
            [-11.23462235368071, -0.6030995677209094],
            [-11.238221615299356, -0.6070246363906354],
            [-11.244422370163765, -0.6099864292176184],
            [-11.246835191159544, -0.6128945333587722],
            [-11.246706895324317, -0.6197330371752262],
            [-11.248576345114149, -0.6239322126063153],
            [-11.253193171544751, -0.6231929925247848],
            [-11.259723392311907, -0.6164864481543759],
            [-11.264969895245175, -0.6157755703061996],
            [-11.267355393112567, -0.6231557933619429],
            [-11.266882684483942, -0.62904115122115],
            [-11.268225500708416, -0.6338273672540861],
            [-11.271085845671902, -0.6382291273179531],
            [-11.278971436723477, -0.6440294977821129],
            [-11.283375193276717, -0.642627210625597],
            [-11.288011838072437, -0.6376597828148263],
            [-11.293319050657427, -0.6402109289379284],
            [-11.29417825881202, -0.6456962381939558],
            [-11.29184359644026, -0.6563896966019248],
            [-11.294587220302855, -0.6585010239046151],
            [-11.297785294557835, -0.6637522114417979],
            [-11.302185018951596, -0.6653234941760391],
            [-11.31473901521048, -0.6594224473043193],
            [-11.319773426638351, -0.6614224701723241],
            [-11.319286253614342, -0.6700670901372702],
            [-11.323873935021698, -0.6733361385303637],
            [-11.33294657680482, -0.6730442102459463],
            [-11.3372276797492, -0.6712668887281482],
            [-11.34271465026127, -0.666919190277004],
            [-11.351508437964037, -0.6702518209777986],
            [-11.36390187088717, -0.6700719236553025],
            [-11.367614928970728, -0.6711766673125494],
            [-11.370642539746962, -0.6760581504506371],
            [-11.374039756277153, -0.6783479610183362],
            [-11.381164137487616, -0.6768174782111339],
            [-11.382297089042304, -0.6705323640931965],
            [-11.385463302439247, -0.6680877489189537],
            [-11.388557959512587, -0.6682729799693625],
            [-11.396092109547409, -0.6717234316699604],
            [-11.406198799335634, -0.6676140231313112],
            [-11.41439132522224, -0.6686402977849413],
            [-11.429740822224241, -0.6609651340462034],
            [-11.4339885811707, -0.6637315842002935],
            [-11.43990901645526, -0.6741471531194542],
            [-11.442893015758331, -0.6773728152655245],
            [-11.446068834614973, -0.6780704087660052],
            [-11.452194053919007, -0.6760042978000006],
            [-11.456124324154226, -0.6722218170157596],
            [-11.458481224428073, -0.6650321238288242],
            [-11.4646811158775, -0.657641124984891],
            [-11.47241103812707, -0.6588439571955543],
            [-11.475860799876708, -0.6604973176625455],
            [-11.48366064088459, -0.6720025911812624],
            [-11.494892041698597, -0.6826195377544283],
            [-11.5004306222787, -0.6889135952660723],
            [-11.512872110798698, -0.6999694094144071],
            [-11.516687386625145, -0.7000261379928642],
            [-11.51874873761883, -0.6977356102938349],
            [-11.52068570999675, -0.6887825151304614],
            [-11.525339744401299, -0.6842367846677526],
            [-11.529514722856387, -0.687871535400351],
            [-11.532814045197648, -0.6953051843838971],
            [-11.536697221495787, -0.7009260317610111],
            [-11.535204726343652, -0.7076364800861014],
            [-11.526385973267319, -0.7117216954120654],
            [-11.524806539144134, -0.7157968873748057],
            [-11.527358337818066, -0.7211096941549543],
            [-11.533010017700219, -0.7297258371408841],
            [-11.538066655229391, -0.7321419515254479],
            [-11.541925361308456, -0.7301185482452774],
            [-11.543457217944319, -0.7268197669905043],
            [-11.548759003301837, -0.7035544225289562],
            [-11.552275047941153, -0.6962599394855097],
            [-11.558501838755719, -0.691591103397404],
            [-11.565401960718077, -0.6884560931767636],
            [-11.570617302668573, -0.682121227111602],
            [-11.57486037974545, -0.6796250166878631],
            [-11.57937677077833, -0.6825483295223039],
            [-11.581205349989663, -0.6887179194587907],
            [-11.580259900855223, -0.6999296921786513],
            [-11.577445982262443, -0.7029590884323996],
            [-11.56652302579024, -0.7037814281207727],
            [-11.566123558911835, -0.7091833263343834],
            [-11.57317074167167, -0.713531638181095],
            [-11.58106741964266, -0.7158052301992313],
            [-11.586390741196771, -0.7187968529319988],
            [-11.58762213218039, -0.7215835690857904],
            [-11.58592562884183, -0.7297269186188368],
            [-11.588691564899637, -0.7328208196167774],
            [-11.59262448216966, -0.7334604322874404],
            [-11.59562961876519, -0.7319062392868407],
            [-11.601195695929581, -0.722906252077185],
            [-11.60628801827971, -0.7216176108710344],
            [-11.61043239046252, -0.7238472350116066],
            [-11.616418084872649, -0.7301201710969433],
            [-11.621765421649178, -0.7320163420180088],
            [-11.62760077072656, -0.7315208188574258],
            [-11.636686735657124, -0.7348494831100414],
            [-11.64136554166939, -0.7354601492289206],
            [-11.647791372433314, -0.7338110528971391],
            [-11.65555138188731, -0.7301992448161012],
            [-11.66579196311833, -0.727783058192375],
            [-11.671121143873401, -0.7282026696972835],
            [-11.67383793456877, -0.7302692288160251],
            [-11.74708380486572, -0.7182956950438611],
            [-11.847154846743683, -0.7018169478869588],
            [-12.026874269867223, -0.6718740210988985],
            [-12.410693634391622, -0.6064250668204505],
            [-12.41944770856231, -0.6048004445200458],
            [-12.551696091686884, -0.5821381164688164],
            [-12.607147609907502, -0.572288215548701],
            [-12.77830971860178, -0.5422024007283731],
            [-12.83258400058527, -0.5325771679066764],
            [-12.800134221109065, -0.35211862479582745],
            [-12.782284108053192, -0.25312694459047086],
            [-12.783984713895125, -0.25282030027301516],
            [-12.744680142077002, -0.035722925555027915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.88790850733334,
          "lat": 37.28508042495089
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49025"],
        "coty_name": ["Kane"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kane County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01448026"
      },
      "bbox": [
        -12.83258400058527, -0.7354601492289206, -10.991754278863787,
        0.007508050525992058
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.40191761791355, 7.787464525420811],
            [16.424616229493804, 7.801867105054028],
            [16.44288660412837, 7.815116763624575],
            [16.453693654287353, 7.824754770216318],
            [16.46356430737883, 7.836275122880628],
            [16.46594474334625, 7.844362436652225],
            [16.465577812177184, 7.850195360196243],
            [16.45983600148125, 7.868224948223392],
            [16.459554954137708, 7.873594585731364],
            [16.460589787960124, 7.880501259448356],
            [16.46879441106574, 7.886961957502487],
            [16.470814567886112, 7.893104641991097],
            [16.465542597937954, 7.912438280566614],
            [16.465132531175513, 7.9293692813095165],
            [16.461521360321964, 7.9436314748160735],
            [16.458365019274844, 7.953163528870675],
            [16.456608263341078, 7.962597507042504],
            [16.510875272288036, 7.949282843349875],
            [16.553376421101714, 7.938984552027368],
            [16.605203985849528, 7.925485516490923],
            [16.688261379168612, 7.9274621892818375],
            [16.698269672119054, 7.927855433699706],
            [16.746219836007665, 7.887008466401673],
            [16.77489159093668, 7.864346163867778],
            [16.78764202325553, 7.863418752392828],
            [16.780619432636453, 7.830696147591732],
            [16.801796003450843, 7.82553323526005],
            [16.78923697366618, 7.774337471875743],
            [16.814132429589968, 7.772888351809392],
            [16.80516766387738, 7.733351912171094],
            [16.801687296948757, 7.720235089703922],
            [16.831186183983075, 7.712279892833817],
            [16.822034009071313, 7.679754540286994],
            [16.817465482797772, 7.678339555150886],
            [16.80890090151271, 7.679775722467227],
            [16.804894892398462, 7.679563198861199],
            [16.795711191528337, 7.681334778090809],
            [16.785615817925358, 7.590417010044274],
            [16.793814416090648, 7.589915130140085],
            [16.78824217509876, 7.531829144267704],
            [16.78227503183799, 7.467528641870084],
            [16.756233851897992, 7.5328468965421544],
            [16.73368334672151, 7.592509729928339],
            [16.700770615033374, 7.593372758224948],
            [16.707855963496833, 7.576277204969165],
            [16.67208757909472, 7.561980005111411],
            [16.670751828378123, 7.565655861324774],
            [16.66435274771099, 7.562543149444333],
            [16.61690511454542, 7.540892570039993],
            [16.61045122080564, 7.538383641464899],
            [16.58736439303138, 7.527765591084073],
            [16.564480017184675, 7.518965354296292],
            [16.537887428161646, 7.509103332207416],
            [16.50705729403936, 7.505847772069287],
            [16.50633853579713, 7.515951026913406],
            [16.50408288964863, 7.521327459206827],
            [16.499119104044734, 7.527967323731439],
            [16.492073438389376, 7.540431287935133],
            [16.488698371397472, 7.548315449812622],
            [16.483213510401157, 7.571364955605299],
            [16.47840558081169, 7.5809763776744985],
            [16.47038288047774, 7.59183932303149],
            [16.46838181178454, 7.599095193660827],
            [16.467467686335652, 7.606902219675848],
            [16.468811800260017, 7.611010046642283],
            [16.473748504858573, 7.619035381195456],
            [16.4764749617763, 7.625670847406849],
            [16.47626753915969, 7.640031414551223],
            [16.480170894760555, 7.667298737295178],
            [16.47894458170484, 7.679500844438936],
            [16.476572169327895, 7.684374203124228],
            [16.47108996804971, 7.692078393166891],
            [16.469857516821932, 7.701236246619402],
            [16.466044092718995, 7.713297736575931],
            [16.460754674476743, 7.721313287013017],
            [16.455711438788548, 7.735019577816192],
            [16.449812072113502, 7.740663703636761],
            [16.442793670225026, 7.745499427134616],
            [16.439208985654588, 7.756553389435814],
            [16.43397156586432, 7.758551258232361],
            [16.430077725660873, 7.765224588763172],
            [16.423217984125756, 7.771113932781639],
            [16.42263157291528, 7.7745931293722865],
            [16.418461127652325, 7.778763867927719],
            [16.4074673569484, 7.782261390978051],
            [16.40191761791355, 7.787464525420811]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.08128416150772, "lat": 44.46106435087683 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50007"],
        "coty_name": ["Chittenden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chittenden County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01461760"
      },
      "bbox": [
        16.40191761791355, 7.467528641870084, 16.831186183983075,
        7.962597507042504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.049786365625708, 1.1910380903601028],
            [14.095920278291603, 1.1541649750622864],
            [14.116173778236114, 1.1381836648414938],
            [14.11885627913563, 1.1368941096479064],
            [14.128931904876238, 1.128189651177499],
            [14.14844589666587, 1.1122740157873487],
            [14.1950109846266, 1.0746881831705586],
            [14.221643173015867, 1.0533774000134315],
            [14.226635847587934, 1.0509182701667745],
            [14.234225963762523, 1.0427941752944174],
            [14.240518263045361, 1.0397976724297133],
            [14.24371671929687, 1.0358974367536253],
            [14.248698175483689, 1.0364824987183598],
            [14.25278141764113, 1.0316255264395078],
            [14.249844739118018, 1.0275146625901395],
            [14.250947665459833, 1.0222312124268986],
            [14.258111089388638, 1.0164322680954692],
            [14.257110570876698, 1.01463949114143],
            [14.26191194174817, 1.011107509737297],
            [14.267106805148426, 1.0124525734142664],
            [14.266391450595705, 1.008106449193776],
            [14.275981437597649, 1.0047474549497026],
            [14.278531143285727, 0.9977108266524254],
            [14.278244916136394, 0.9936384934519884],
            [14.281836875438652, 0.9916169566698496],
            [14.279103265230274, 0.9864593045504976],
            [14.268640157130065, 0.980192194986066],
            [14.26902712375519, 0.9753190851780071],
            [14.266011926768465, 0.9663396627575908],
            [14.267293923139468, 0.9607571559942556],
            [14.272610448635103, 0.9516938731520476],
            [14.279013031250074, 0.9473384453480349],
            [14.278501135570181, 0.9430083523573595],
            [14.284645375164109, 0.943780191983474],
            [14.290182641076202, 0.9409020464434866],
            [14.295797878532515, 0.9365898027081396],
            [14.300647722962061, 0.9308130738554583],
            [14.294254701610798, 0.9291487885941913],
            [14.29224391262685, 0.9270067658012967],
            [14.290444820894999, 0.9208040336827024],
            [14.286477688179902, 0.9119794868159619],
            [14.294796543950271, 0.9126407805844273],
            [14.29391239239912, 0.9106066724989867],
            [14.295834397964759, 0.9051399155733603],
            [14.292632755850203, 0.8987901240438658],
            [14.290301826519018, 0.8982555212054376],
            [14.285683758776045, 0.887711031789329],
            [14.27965861878947, 0.8856408822963082],
            [14.278355607000739, 0.8807687129546817],
            [14.266099127704857, 0.8761204954489185],
            [14.264952514886307, 0.8724172808087802],
            [14.261095747209794, 0.8712638006282349],
            [14.260718984795693, 0.8760843817467706],
            [14.258653114819314, 0.8777904579359939],
            [14.255359962809276, 0.875100963982675],
            [14.2528806546463, 0.8666936838105284],
            [14.259121928796551, 0.8590611656188097],
            [14.253809561441631, 0.8581547921181112],
            [14.249584009680554, 0.8606103179107577],
            [14.23590972314766, 0.8568550012861443],
            [14.235038244756506, 0.8544030743795011],
            [14.241439423011691, 0.8526246768459206],
            [14.241655364711054, 0.8438920257873205],
            [14.237817852923932, 0.8426543334109666],
            [14.234493472924491, 0.8382974632198845],
            [14.232634808760098, 0.8333512864359763],
            [14.227322297710034, 0.8308717360640864],
            [14.213943504430688, 0.8266062888836382],
            [14.213387771260214, 0.8137727442612118],
            [14.205104633292844, 0.8126577658552375],
            [14.199606073707352, 0.8155650223289138],
            [14.194903671559349, 0.8155783259941791],
            [14.190504023327586, 0.813466546652852],
            [14.187010196588734, 0.8190788078926239],
            [14.179966165436827, 0.8200142650321656],
            [14.175320693444883, 0.8265171092036128],
            [14.170059825717557, 0.8276132153612743],
            [14.170787744059677, 0.8321925871418977],
            [14.173254344169518, 0.8349803493117294],
            [14.171462859014184, 0.8403871574906759],
            [14.161029951479323, 0.8426911457894289],
            [14.153650272850932, 0.8462295593244946],
            [14.147873812737902, 0.8495517922388225],
            [14.146322322660039, 0.8466815205940594],
            [14.141094021697553, 0.8456103192385003],
            [14.142167014509745, 0.8405066222588339],
            [14.133901436856258, 0.8426357675962225],
            [14.130940057401242, 0.837955328550552],
            [14.12732666858852, 0.8392686435055147],
            [14.120544776473322, 0.8389228616241948],
            [14.11653897123238, 0.8446053027447118],
            [14.106363862726738, 0.8459806939822158],
            [14.105112452973295, 0.8534107646085343],
            [14.09921551332824, 0.8521573032439587],
            [14.095192332166492, 0.85546814659986],
            [14.09165536449205, 0.8548977166269428],
            [14.090001055197398, 0.8626065457072027],
            [14.095573460398507, 0.8654607120505308],
            [14.09146379562477, 0.8674208543769071],
            [14.091319367097066, 0.8713736160884091],
            [14.087680269077639, 0.8733184626307104],
            [14.088418727146491, 0.8776937327961053],
            [14.08653338648448, 0.8796133403679424],
            [14.077948264727766, 0.8775362600442868],
            [14.074184112730546, 0.877796036711167],
            [14.070005254653651, 0.8834300097029401],
            [14.063758920946755, 0.8855620060866318],
            [14.06263323307339, 0.8880722897882176],
            [14.053619679137114, 0.8923368406014766],
            [14.048647572950259, 0.9001219399676603],
            [14.045193870669127, 0.9031600853034779],
            [14.041248318876438, 0.9104061717618829],
            [14.028546315034465, 0.9200328913546663],
            [14.028563985943158, 0.92981999787205],
            [14.030226486853545, 0.9361059910506464],
            [14.027153031812356, 0.9415298535371607],
            [14.023370833981692, 0.945003168232136],
            [14.018095529859236, 0.9464174803289936],
            [14.015396903064241, 0.9545051659361976],
            [14.012115360360594, 0.9604378726981517],
            [14.012506553498476, 0.9663522634736446],
            [14.015092978848674, 0.9711331916036035],
            [14.01410857475048, 0.9807963392384152],
            [14.01250580692868, 0.9872830053713173],
            [14.009423569248552, 0.991169771844383],
            [14.007801787533419, 0.9986460914507469],
            [14.009122525275345, 1.001402198599163],
            [14.007202999011671, 1.0057948825589238],
            [13.999287138939465, 1.0109991751444385],
            [13.996357108778014, 1.016793146859559],
            [13.990756740947619, 1.024073842095246],
            [13.994593419322765, 1.0390842734655448],
            [13.995369314344398, 1.0443163847179135],
            [13.990944252256185, 1.0485111431781535],
            [13.993114528359587, 1.0554991103711497],
            [13.991667803152238, 1.0616624418660698],
            [13.992149121190483, 1.0660126863328403],
            [13.994851129245376, 1.069639931766274],
            [13.994706731299784, 1.0726931714260546],
            [13.988713006372931, 1.0773545910154845],
            [13.991426741105302, 1.0809839483855583],
            [13.996273185480591, 1.0775729304014539],
            [14.005008630093075, 1.0872014265988652],
            [14.007193861474304, 1.1007624827665665],
            [14.013675612027042, 1.1071288995966095],
            [14.020401470857104, 1.111951791458704],
            [14.024649335235045, 1.1119383584122275],
            [14.029640045308293, 1.1196644839202636],
            [14.027805574585756, 1.1263114537186178],
            [14.025517391491741, 1.1281956494135998],
            [14.025734827852048, 1.1332191739090014],
            [14.021987391570093, 1.1399502098323864],
            [14.022812183507096, 1.145921586792144],
            [14.028583661158269, 1.1533383482914088],
            [14.031932007884453, 1.1619404408571712],
            [14.03319915275073, 1.1700135343382285],
            [14.035699208617123, 1.17449495901717],
            [14.039698710150077, 1.173389719885367],
            [14.041303632516106, 1.177365390293451],
            [14.046403465212094, 1.182671539320708],
            [14.045847428600919, 1.1855500866236173],
            [14.049786365625708, 1.1910380903601028]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.27922239117544, "lat": 38.41378524978384 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51113"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01494590"
      },
      "bbox": [
        13.988713006372931, 0.8126577658552375, 14.300647722962061,
        1.1910380903601028
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.160751138269198, 0.0392468799302667],
              [16.161775028923103, 0.04584073739286113],
              [16.16394855149515, 0.04789567996044895],
              [16.173227881917533, 0.05260585067267384],
              [16.18060406261369, 0.05235296175479756],
              [16.185656813456752, 0.05070369833412802],
              [16.190026285377524, 0.04643829175646277],
              [16.190591611369488, 0.03622590229800206],
              [16.187396030414273, 0.03298577393236753],
              [16.174084896770395, 0.029143188962103342],
              [16.170543501266714, 0.02924983948872491],
              [16.16384456227157, 0.033529246841877476],
              [16.160751138269198, 0.0392468799302667]
            ]
          ],
          [
            [
              [16.100837061774776, 0.49640427214114535],
              [16.103805840261405, 0.4997839503163826],
              [16.115106692625346, 0.500317415065911],
              [16.119949661565787, 0.5022467220604725],
              [16.125499201229786, 0.5068459711590643],
              [16.129026495948732, 0.5062142017279508],
              [16.132979989784854, 0.5029743944865362],
              [16.13938362310276, 0.5018516266740122],
              [16.145386009691236, 0.5051452193219875],
              [16.15039141786157, 0.5066055148932337],
              [16.15376920269243, 0.5059179072511177],
              [16.159710404759494, 0.5085045509171146],
              [16.161865990247662, 0.511351222886547],
              [16.16636934827505, 0.5108299820140201],
              [16.171237161734712, 0.5148899213642879],
              [16.176433324449913, 0.5145195230071293],
              [16.217759006809512, 0.4973685976059778],
              [16.216119520967645, 0.4891646430548095],
              [16.207938615169446, 0.48064949603016544],
              [16.211106555277066, 0.47155354935991256],
              [16.214963923326653, 0.47300362279737634],
              [16.220354660301457, 0.4720525783044752],
              [16.21849904577433, 0.4678556647695411],
              [16.22200272397883, 0.45967526335936426],
              [16.222112804754907, 0.45696461010316125],
              [16.218841534690508, 0.4530365915195008],
              [16.215685580694064, 0.44630325503535706],
              [16.211193332850677, 0.44323109356817875],
              [16.21049072952136, 0.43902202213712993],
              [16.216058230794953, 0.43064804400830836],
              [16.220901067183675, 0.4294274236824119],
              [16.23226891757238, 0.4340969476342819],
              [16.236850888487005, 0.432299308584265],
              [16.242440207179822, 0.42597467517090387],
              [16.25030151971865, 0.4366810242426371],
              [16.254046658030965, 0.43574791959859727],
              [16.27433995354265, 0.43914400941652587],
              [16.27824709414697, 0.43907780191508367],
              [16.28520685769687, 0.43612308577831166],
              [16.292076601897907, 0.4318465036719094],
              [16.295580925175035, 0.43124847449156883],
              [16.29918307399766, 0.43402464146356223],
              [16.314094920317412, 0.4416522754256068],
              [16.316564266125162, 0.4475403187557785],
              [16.325106307121402, 0.45238021134474793],
              [16.32803367227478, 0.4512689002751481],
              [16.33116478553116, 0.44545999514079676],
              [16.331618785108123, 0.43681461224534723],
              [16.332807667426767, 0.43401327204707957],
              [16.32518006379789, 0.42026548950829745],
              [16.31525046019244, 0.3902180714367574],
              [16.30876915215116, 0.3653995205272157],
              [16.30524346071992, 0.35429299470953574],
              [16.30231454939112, 0.35014554412770915],
              [16.30041107964711, 0.34115060234500694],
              [16.299986536220356, 0.32465610308893345],
              [16.294709589402856, 0.30701649885880716],
              [16.287343500159388, 0.2904820169006074],
              [16.28389579912021, 0.28573534627315894],
              [16.280380416299312, 0.2776529843594849],
              [16.276220271202618, 0.2721920039733899],
              [16.273724428287764, 0.27157532733494233],
              [16.26909929857275, 0.27443267408289324],
              [16.262467900220592, 0.27231801145744067],
              [16.26003531697366, 0.26605768866493607],
              [16.2626865056279, 0.2601374495823238],
              [16.267339415485925, 0.253045077563133],
              [16.269574590923778, 0.23324544646353673],
              [16.26927083880436, 0.22493549148583136],
              [16.26805110668025, 0.2210960309426058],
              [16.258623345377497, 0.21649219106732714],
              [16.254954322400966, 0.21135130295551582],
              [16.256981135481155, 0.2072174750058424],
              [16.260314237131126, 0.20464207463598688],
              [16.26757204594827, 0.20830551579664888],
              [16.27217697960136, 0.20142365184687414],
              [16.273235786348355, 0.19076341399265354],
              [16.269380934538287, 0.18537839851040502],
              [16.259972854232693, 0.18025907553458112],
              [16.254567978250325, 0.17293178699701156],
              [16.255084001828266, 0.17000516729162582],
              [16.262029004982896, 0.17057849343957118],
              [16.264502630273316, 0.1667589460171945],
              [16.264233389271734, 0.16044233712788808],
              [16.255241112264837, 0.14630178655928486],
              [16.256731109766136, 0.13977049627347116],
              [16.250663241374042, 0.13268168938272865],
              [16.241768973834393, 0.11830816498036541],
              [16.232722500331455, 0.09726190961916428],
              [16.220060554033804, 0.07405993473940056],
              [16.214602024615555, 0.06884091776443622],
              [16.207966589471226, 0.064872566867219],
              [16.20400894026203, 0.06363230297009112],
              [16.20831979706524, 0.07287947556380592],
              [16.20900178796592, 0.07615283446798046],
              [16.194866784871905, 0.08075383212733353],
              [16.188744094071108, 0.0748420481524596],
              [16.18456319974579, 0.07325233567134382],
              [16.182607771968428, 0.07040368573882187],
              [16.175987239426117, 0.0658478589539165],
              [16.168236213910365, 0.06339071881456002],
              [16.164982657957015, 0.06084941652633891],
              [16.162570750167212, 0.07238460958492697],
              [16.15214712105348, 0.09655070506518708],
              [16.14634799764139, 0.1042433967285901],
              [16.14138856228574, 0.10669804662061144],
              [16.139148685005402, 0.11288128272605584],
              [16.12782402091863, 0.12678385810531412],
              [16.120040317148515, 0.13247510391533168],
              [16.116423384019704, 0.13606417364173434],
              [16.113060771344404, 0.14148248390484208],
              [16.111276010313144, 0.15321781431791245],
              [16.109980003550646, 0.15704533854280525],
              [16.109658073462363, 0.16977545882679596],
              [16.1052184867806, 0.17126966063332544],
              [16.09505863431514, 0.18569891249568066],
              [16.09244471771049, 0.19013124743266088],
              [16.091618880796712, 0.20189459004887966],
              [16.09324829021263, 0.2075409106872222],
              [16.097633628813437, 0.21398822478194174],
              [16.092976608710334, 0.2232449259521764],
              [16.095849691020803, 0.22952039356837162],
              [16.094762176172583, 0.23192423942529716],
              [16.08887101522369, 0.2303737321130889],
              [16.086600410101973, 0.23338939647942475],
              [16.085193564325987, 0.25095953884860506],
              [16.08681750646084, 0.26779930291684995],
              [16.092924064203107, 0.28266330574236137],
              [16.096764592498502, 0.2978217301567871],
              [16.097781354230687, 0.3044532896582865],
              [16.100874810861004, 0.308035627090664],
              [16.09847916383018, 0.311257345272049],
              [16.096647202159385, 0.31980167458897624],
              [16.10106388165962, 0.3215605504837668],
              [16.10500615513404, 0.32503667641144696],
              [16.10365988681244, 0.32864888859649866],
              [16.10675567828413, 0.33116353308578367],
              [16.107278255500386, 0.3403416837702037],
              [16.100643942723988, 0.3440897467083792],
              [16.096658053948673, 0.34302057037608374],
              [16.091883298727907, 0.3535585454593405],
              [16.08980629133803, 0.37634049532012914],
              [16.090830594159314, 0.38335710027323905],
              [16.094032726560357, 0.3910409774359954],
              [16.094345520328737, 0.3972147839762614],
              [16.09804144513405, 0.4083236353375627],
              [16.099506716395645, 0.41059203349480283],
              [16.094382422706385, 0.4155848100888228],
              [16.093140207135892, 0.4255916045087109],
              [16.093436609111162, 0.432924794327332],
              [16.092626248654046, 0.44079871361611594],
              [16.094936805984272, 0.46374630883563794],
              [16.099664707366617, 0.4778801063348456],
              [16.099921501734404, 0.48622759709954994],
              [16.10242317093847, 0.49503455860271617],
              [16.100837061774776, 0.49640427214114535]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.87711479356788,
          "lat": 37.344031780793514
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51131"],
        "coty_name": ["Northampton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Northampton County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01480151"
      },
      "bbox": [
        16.085193564325987, 0.029143188962103342, 16.332807667426767,
        0.5148899213642879
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.427789203394525, 0.057495428880078844],
            [14.428345341133186, 0.12164912350550447],
            [14.429403195834174, 0.23600746580748477],
            [14.427062451910134, 0.24405237051286754],
            [14.43082801216066, 0.25216310474908793],
            [14.428375020600248, 0.2556231844353837],
            [14.431090504005077, 0.2573347904272912],
            [14.430632900128805, 0.26277824294569124],
            [14.435645268269086, 0.2673617741190014],
            [14.440662982021202, 0.2618122419008507],
            [14.444136708057773, 0.25973585595156756],
            [14.457142366460623, 0.25709598302731573],
            [14.461088478921349, 0.2568542104088185],
            [14.472016960068576, 0.25824561935159224],
            [14.480581758607217, 0.26071591429815083],
            [14.488185185333347, 0.25864774301583215],
            [14.493196093011687, 0.2552073374106457],
            [14.500842470321366, 0.25154759352886336],
            [14.510320156678068, 0.247959122504438],
            [14.516757947359805, 0.24813037182212916],
            [14.53067836219983, 0.25237809948251966],
            [14.535161899384565, 0.25663827075117807],
            [14.537961983422154, 0.26357877317361667],
            [14.536708895896572, 0.2727282796720321],
            [14.53019532255722, 0.28085921555301757],
            [14.5267538501232, 0.2832959865088378],
            [14.524419240977647, 0.2878879741076156],
            [14.52423317790857, 0.29258641926591256],
            [14.52778801233822, 0.3062991508350607],
            [14.52911552998821, 0.3087384963531686],
            [14.541740237272162, 0.32159238973260396],
            [14.545298002696427, 0.32362238146004374],
            [14.551625424389819, 0.3238218353239608],
            [14.554821369799203, 0.3218264896507308],
            [14.563476991265007, 0.308073896155817],
            [14.568230167964433, 0.3038986047521431],
            [14.584284853577103, 0.29791261180655715],
            [14.589675835397344, 0.2950431308885516],
            [14.595799181113124, 0.29007129767182305],
            [14.60168554370606, 0.2867849579293704],
            [14.607958777039707, 0.2848264655451998],
            [14.614515500648743, 0.2847334309603201],
            [14.626295054785809, 0.2790000610044234],
            [14.633564278116983, 0.27185377483129414],
            [14.634744193382977, 0.2671626450874112],
            [14.634381982542553, 0.26057355311539004],
            [14.637038646264124, 0.2574087653938577],
            [14.64393238758396, 0.2550029484876306],
            [14.649053879445214, 0.2565331593705114],
            [14.654534211100584, 0.26180954663362493],
            [14.658993871308045, 0.2642367534386375],
            [14.678894323715737, 0.2683963027004138],
            [14.684469903447495, 0.26771727981517746],
            [14.688009486989499, 0.26559881695420384],
            [14.692608647135861, 0.2607032134826878],
            [14.707551086025418, 0.25183447129355935],
            [14.71408865890229, 0.24996599677733747],
            [14.720181005904795, 0.25023449216072985],
            [14.731001463493142, 0.2542004767699318],
            [14.745157475354993, 0.24913859957684448],
            [14.74973329962031, 0.24637794916905034],
            [14.770440269181055, 0.23890304209904162],
            [14.774549891887595, 0.2367696611356251],
            [14.77450631192622, 0.2335345040627309],
            [14.768725352409877, 0.22592091056394917],
            [14.715409046354479, 0.15301839705691278],
            [14.685032228256189, 0.11122080597865759],
            [14.686762200006713, 0.10348791977505717],
            [14.686950332552135, 0.09719339406505231],
            [14.683565222627154, 0.0890768686521969],
            [14.684184396900013, 0.08625410687933815],
            [14.682536847733113, 0.07702326260802345],
            [14.66972276872701, 0.0707739724892225],
            [14.664662714054614, 0.07015977744132718],
            [14.659997265989857, 0.06452396931858517],
            [14.657811540060576, 0.06487362819708282],
            [14.65403014290116, 0.05991122699239698],
            [14.64853521170882, 0.062477536054191575],
            [14.644835416014388, 0.06615721764826098],
            [14.64525861594657, 0.07559805796726918],
            [14.638508460434117, 0.0791348215538953],
            [14.632685860407491, 0.08886964362623143],
            [14.633398741050094, 0.09578789956717244],
            [14.63233435049552, 0.09882811951494323],
            [14.624651105294845, 0.09735797046980153],
            [14.618520100877584, 0.08849765919398282],
            [14.612599245850596, 0.0874214503962877],
            [14.6083941381239, 0.09423614355363695],
            [14.609427032576217, 0.10472232241323626],
            [14.608059879423942, 0.10904738982276697],
            [14.603175451127193, 0.11240328887981135],
            [14.599049371055179, 0.1104603285459607],
            [14.591872260905433, 0.1096009815655363],
            [14.582463430114185, 0.11537532324900843],
            [14.578699925844555, 0.10954017450649498],
            [14.574107218723666, 0.10680556586816316],
            [14.572634408347982, 0.10882463571266682],
            [14.564522138057491, 0.10933565684155995],
            [14.558418656028307, 0.11186331387069115],
            [14.55564234934556, 0.11064503443620809],
            [14.548440342332302, 0.11259220076899076],
            [14.541478226039315, 0.11090394384472985],
            [14.534013505026037, 0.11044224404661754],
            [14.530064423721743, 0.11282286273494209],
            [14.521838399099526, 0.12003769646047176],
            [14.511039257571241, 0.11119808176385242],
            [14.512225668791563, 0.10845806808480098],
            [14.511871597008854, 0.10244036781049885],
            [14.513279842832842, 0.09108791317057356],
            [14.508899402644593, 0.09289356435709713],
            [14.504235743507945, 0.08965370672428458],
            [14.498601853859524, 0.08839688830915277],
            [14.4945454024196, 0.08966181331708231],
            [14.487549196929143, 0.0863523792849978],
            [14.4877667512763, 0.08339712881829621],
            [14.483320756435125, 0.0770227261910266],
            [14.484043700286977, 0.07049904191601801],
            [14.479202800817474, 0.06452156448600019],
            [14.475003126513508, 0.06528128233182166],
            [14.47216894227373, 0.06362589810639721],
            [14.461686212846114, 0.06662605411660402],
            [14.458206316298734, 0.06428577664381441],
            [14.4584771148822, 0.05309745533370786],
            [14.456172620957261, 0.04839514311951466],
            [14.453587740431523, 0.04944238305971256],
            [14.45315241950842, 0.05556935798218697],
            [14.4491317222546, 0.05600487035911643],
            [14.441204012832483, 0.0499215618286899],
            [14.43553414574343, 0.049421951400922384],
            [14.431783943806925, 0.05657487841975077],
            [14.427789203394525, 0.057495428880078844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.91516976140336, "lat": 37.55015271174933 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51145"],
        "coty_name": ["Powhatan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Powhatan County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01674225"
      },
      "bbox": [
        14.427062451910134, 0.04839514311951466, 14.774549891887595,
        0.3238218353239608
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.368963911460808, -0.6186069111309516],
            [12.376530659292944, -0.6126208592848517],
            [12.379635728781718, -0.6089573233878444],
            [12.387537745311468, -0.6021294624109568],
            [12.396796868752064, -0.5928032614011671],
            [12.400604313774814, -0.5853762674498916],
            [12.405207850700517, -0.579892599588431],
            [12.41244503504469, -0.5756772130555187],
            [12.422462098412637, -0.5686371078999308],
            [12.43594166595722, -0.5606416340071709],
            [12.44188153802643, -0.5585207974125798],
            [12.45083854676948, -0.5538273254616407],
            [12.454611522281064, -0.5530688862735569],
            [12.460564464289263, -0.5469857367188051],
            [12.4664060315087, -0.5452959576615544],
            [12.48103499781822, -0.5354452984758297],
            [12.489885705403658, -0.528559112884521],
            [12.498699385350783, -0.5192490665009717],
            [12.514309000520141, -0.511073241377867],
            [12.525873779613063, -0.5029221394855881],
            [12.533234797178892, -0.49871246443924105],
            [12.53986385731541, -0.4930182720520599],
            [12.546095969122213, -0.4902876651078854],
            [12.546830933122994, -0.4963747693629541],
            [12.542045546072837, -0.5027967462826602],
            [12.542191769951712, -0.5092254802871103],
            [12.544557620881891, -0.5134767885798938],
            [12.54494377161927, -0.5206019228693932],
            [12.547276819160235, -0.5245966401915227],
            [12.555021278294232, -0.5297871441267872],
            [12.558888772674909, -0.5342992031497564],
            [12.562399149724422, -0.5416308746450307],
            [12.56809028561679, -0.5477116237321781],
            [12.572531977479947, -0.549508058840165],
            [12.576760022077224, -0.5463780717899741],
            [12.578704192089337, -0.5423284544745459],
            [12.586575076190567, -0.5319159764973534],
            [12.595329768978848, -0.5262686453382155],
            [12.603927179653981, -0.5228744323505286],
            [12.607821065552445, -0.5200855902482268],
            [12.618148214980067, -0.5172753298857008],
            [12.622847849185186, -0.5196403390787637],
            [12.624880466809918, -0.5234708907658243],
            [12.623551154960442, -0.5303251492928502],
            [12.615951128629511, -0.5331474627474433],
            [12.608622482983272, -0.5315368496093433],
            [12.59987760708535, -0.5349986082116929],
            [12.595816543654696, -0.5382859369622034],
            [12.594205444426455, -0.5433180469914687],
            [12.59072073897549, -0.5478140097213515],
            [12.590240667049157, -0.5554538060042731],
            [12.597798415758314, -0.5598989046906953],
            [12.604852237064327, -0.5713641929255405],
            [12.611124694867033, -0.570583900734325],
            [12.617658880832886, -0.5681577643975587],
            [12.620991248186758, -0.5707641300872012],
            [12.6249663967078, -0.5794296634605604],
            [12.625400904145748, -0.5882898869094072],
            [12.624325111907842, -0.5910736804289837],
            [12.607385361266601, -0.5808438645211752],
            [12.603613979989463, -0.5812852964003759],
            [12.589584358226729, -0.5905967025200447],
            [12.576124424978532, -0.605086773488161],
            [12.574784992617888, -0.6081100671917063],
            [12.575592139992576, -0.6174599794526314],
            [12.582264367711574, -0.6305456607914974],
            [12.587196935004746, -0.6352204364616956],
            [12.592022710740753, -0.6415719050173201],
            [12.597570341471435, -0.6519413591050818],
            [12.605805723042076, -0.6544466838627998],
            [12.609110099883178, -0.6462922379644118],
            [12.614383388203018, -0.6617262826561897],
            [12.619517022047395, -0.6633155532227432],
            [12.623612458462532, -0.6689044272919125],
            [12.620957476444444, -0.6703793741818199],
            [12.619697720622522, -0.6749465092239785],
            [12.627299385879725, -0.676803919559235],
            [12.62868484219125, -0.6855208726216039],
            [12.62445007920474, -0.6865991779165981],
            [12.623262900185884, -0.6823453295817282],
            [12.61798380260935, -0.6781618104286796],
            [12.611811140365834, -0.6784091911015314],
            [12.610377677866607, -0.6816519581079742],
            [12.614185675389335, -0.6880598095049861],
            [12.620471466389596, -0.6936961456589763],
            [12.621243030023397, -0.7012511485831536],
            [12.624339476593306, -0.7177669250347138],
            [12.637675532438026, -0.7415400675463432],
            [12.634498646753674, -0.7442199185866413],
            [12.635477993723361, -0.7512363016457967],
            [12.632927597785844, -0.7571433751029573],
            [12.624441283373795, -0.759880614767684],
            [12.62108377907173, -0.7699490591677364],
            [12.613994026870449, -0.7730310347398408],
            [12.606915212170588, -0.7849481939444358],
            [12.602862138514777, -0.7896548123273625],
            [12.5989072192093, -0.7898173815672682],
            [12.59049721090551, -0.7933057559372311],
            [12.586825510794611, -0.7980471800201215],
            [12.580173246509752, -0.7990274559780169],
            [12.577297431640028, -0.801705084858522],
            [12.57595672975707, -0.8057105891880569],
            [12.57520522383528, -0.8100148033881055],
            [12.567963955221208, -0.8120278439217258],
            [12.561416508963294, -0.8188972806101387],
            [12.559086661458263, -0.8233200561750946],
            [12.559326392140944, -0.827166875878236],
            [12.550749802693081, -0.8314317762001299],
            [12.544071407728955, -0.8357295936388585],
            [12.54552413514664, -0.8439868764622186],
            [12.543913999645302, -0.8484012495959228],
            [12.539559143134372, -0.8485157956495732],
            [12.535927121976355, -0.8518786704074619],
            [12.51168586921581, -0.8665877848432658],
            [12.501255670291384, -0.8718324535487912],
            [12.454337321416384, -0.8242313222959741],
            [12.442949154058768, -0.8150027458256411],
            [12.43757283084294, -0.8193321394130546],
            [12.43656455805453, -0.8142169711272129],
            [12.433433652164057, -0.8075714912219525],
            [12.435445481392643, -0.8063954031858465],
            [12.411186513909064, -0.7841676965047242],
            [12.385802479334139, -0.76299110368173],
            [12.375042760454717, -0.7569523726449182],
            [12.35805210286977, -0.743151442782939],
            [12.335552496770037, -0.6997714968953405],
            [12.314890388870117, -0.6604003421418735],
            [12.323406945725527, -0.6579737552407084],
            [12.335306152292908, -0.6519562313792558],
            [12.346938493877316, -0.6428073170276308],
            [12.35618223861286, -0.6304307903674384],
            [12.368963911460808, -0.6186069111309516]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.7144044038712, "lat": 37.06352790598671 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51155"],
        "coty_name": ["Pulaski"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pulaski County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "01501465"
      },
      "bbox": [
        12.314890388870117, -0.8718324535487912, 12.637675532438026,
        -0.4902876651078854
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.989246057285625, -1.0583859080894402],
            [10.994728896078632, -1.0551573664261151],
            [10.993892318684999, -1.0507437462974212],
            [10.99593084144977, -1.0463856561099631],
            [10.999582546489302, -1.0446449540217304],
            [11.000418932648772, -1.039247429790719],
            [11.005062542224323, -1.0312038223120172],
            [11.007669638724456, -1.0236498961296285],
            [11.012739788824325, -1.0239527006478037],
            [11.016197943073887, -1.0219161778512298],
            [11.015927945309317, -1.019271847571087],
            [11.02140972622911, -1.0171563340815468],
            [11.028436947378095, -1.0209267353186173],
            [11.02895554217625, -1.0141531904412175],
            [11.038802025013329, -1.0154487500586749],
            [11.043068630840365, -1.020104304400486],
            [11.041796670490434, -1.0244318590749457],
            [11.038270893957062, -1.026412944330117],
            [11.042176493118294, -1.0304550177926128],
            [11.043830970648619, -1.0357587882845816],
            [11.038445789576636, -1.0363336491366975],
            [11.02706938694092, -1.0393830178103831],
            [11.022535619021697, -1.0425012162128633],
            [11.020570844353061, -1.045778224205107],
            [11.021302782712661, -1.0515636711995107],
            [11.025204373230778, -1.0587046597433103],
            [11.030245252386152, -1.061139683052066],
            [11.029350064418612, -1.0686912368392911],
            [11.026526031788949, -1.0673622636240265],
            [11.01218041595277, -1.0698688694419969],
            [11.012707606646922, -1.0715927553659939],
            [11.007290795941026, -1.07685528527511],
            [11.002048499023577, -1.0680567740725029],
            [11.003661408167249, -1.0618409570296121],
            [10.989246057285625, -1.0583859080894402]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.62578341673262,
          "lat": 36.931875867529946
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51720"],
        "coty_name": ["Norton"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Norton city"],
        "coty_fp_code": "720",
        "coty_gnis_code": "01498434"
      },
      "bbox": [
        10.989246057285625, -1.07685528527511, 11.043830970648619,
        -1.0141531904412175
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.510203462605354, 10.9549375761107],
              [-17.503077849211458, 10.967707705694778],
              [-17.49893317022114, 10.970313154473049],
              [-17.500111537927427, 10.960753498388243],
              [-17.50233370269628, 10.956911429576037],
              [-17.510064023213598, 10.951735087496687],
              [-17.510203462605354, 10.9549375761107]
            ]
          ],
          [
            [
              [-17.494251939179993, 11.07952246229617],
              [-17.49012706796749, 11.079487306005204],
              [-17.486348489951773, 11.075977497781533],
              [-17.48142335794647, 11.074609742731518],
              [-17.473806280342615, 11.064080129255146],
              [-17.469508212624174, 11.06339029293483],
              [-17.470748813141874, 11.05666397885416],
              [-17.46766843596428, 11.053809712593363],
              [-17.460758420668, 11.04279691865373],
              [-17.459012211391123, 11.035654725238047],
              [-17.452092585504715, 11.027663811518753],
              [-17.455737602553867, 11.019159205827455],
              [-17.462303964489944, 11.01576479796226],
              [-17.466461632495186, 11.01177637248738],
              [-17.470229969007683, 11.012917956056096],
              [-17.473213070083254, 11.017101083524853],
              [-17.476192341685774, 11.026204995434028],
              [-17.47659984081119, 11.03209591306546],
              [-17.479022807999915, 11.03526377574993],
              [-17.480440854983925, 11.042032149975743],
              [-17.4837624102602, 11.046248357783037],
              [-17.48543916982332, 11.053769280844485],
              [-17.489934575872486, 11.0643264080082],
              [-17.495214133600637, 11.073673416061798],
              [-17.494251939179993, 11.07952246229617]
            ]
          ],
          [
            [
              [-17.557667953256704, 10.91946999900797],
              [-17.553582471373407, 10.913964122769952],
              [-17.54678768257823, 10.917182563559491],
              [-17.544508753596208, 10.92114256036447],
              [-17.538887773573734, 10.92761045780629],
              [-17.527759256692082, 10.937287154536426],
              [-17.521361080811705, 10.941142076990051],
              [-17.517047046966614, 10.942311229594113],
              [-17.511075956527925, 10.941117552244705],
              [-17.507955452597965, 10.943687713869576],
              [-17.502782309971032, 10.945184045424652],
              [-17.492557774987024, 10.95757532778361],
              [-17.48700226565089, 10.968854203701921],
              [-17.471594561342936, 10.970871338502478],
              [-17.463092429070297, 10.980291244656163],
              [-17.460312928444484, 10.984594575564525],
              [-17.45920183044576, 10.991515860491322],
              [-17.453954503434275, 11.001046589072827],
              [-17.4421042155218, 11.009315161138213],
              [-17.43908243244831, 11.013874490626872],
              [-17.43557821654826, 11.022394864069028],
              [-17.4339867554308, 11.02899379521255],
              [-17.42873070464594, 11.02849643596659],
              [-17.4250174067462, 11.03138293784799],
              [-17.42338049435805, 11.036983527939245],
              [-17.415537489958417, 11.044767429390372],
              [-17.40469485348501, 11.054161219682442],
              [-17.40061303007656, 11.06005268783574],
              [-17.397389226589805, 11.069096747114088],
              [-17.399501902845554, 11.081177179833938],
              [-17.403383070922384, 11.094424767145167],
              [-17.398487354560686, 11.095613984405697],
              [-17.393879413173867, 11.091970880652184],
              [-17.38733473422956, 11.081335219595593],
              [-17.384735388540047, 11.07867488553825],
              [-17.38018258727213, 11.076890764275563],
              [-17.38040389386507, 11.074197168338264],
              [-17.37704194621373, 11.066867884021525],
              [-17.377489322225372, 11.065339021042133],
              [-17.371737596975876, 11.054391801396674],
              [-17.364187140513707, 11.043737052495201],
              [-17.357761675823955, 11.0400317332231],
              [-17.35338305960897, 11.035709469268],
              [-17.34907340511308, 11.02873916898585],
              [-17.34781182540901, 11.023614332806744],
              [-17.342736757895597, 11.023665832671151],
              [-17.339032517930026, 11.027703319892584],
              [-17.333089904667364, 11.027839175467276],
              [-17.329678523931452, 11.032612477897512],
              [-17.323508503054047, 11.037595651941722],
              [-17.32415193625226, 11.040324320273571],
              [-17.320151665611135, 11.04279707659336],
              [-17.321663568493022, 11.048665222349054],
              [-17.327568102888485, 11.053972389796117],
              [-17.33311267137327, 11.055011237245314],
              [-17.34015517276126, 11.060442824358748],
              [-17.33841958181342, 11.065718752243637],
              [-17.331655274654686, 11.065235522804883],
              [-17.325288438949578, 11.075798377818636],
              [-17.317174831485847, 11.074211876061225],
              [-17.278283793216236, 11.0052673769004],
              [-17.279843440275002, 11.000104549662627],
              [-17.251217193470772, 10.991721921233276],
              [-17.21083241587432, 10.980842875146706],
              [-17.1826447130218, 10.972755131357973],
              [-17.154483814948687, 10.965170028653938],
              [-17.150608925561755, 10.961030804992722],
              [-17.153177113919398, 10.953947802608853],
              [-17.151760717889893, 10.95068027621383],
              [-17.14597022358326, 10.944940462267349],
              [-17.145623686755844, 10.942860065162344],
              [-17.14912668727273, 10.93810978580248],
              [-17.143127605795133, 10.935415119511296],
              [-17.145346606761347, 10.929762125455905],
              [-17.147174961562612, 10.92126417250955],
              [-17.145091214582763, 10.917356206129456],
              [-17.141436356251326, 10.903152434095885],
              [-17.138200334303296, 10.900468275173845],
              [-17.13846198394241, 10.896926042016913],
              [-17.134701055222887, 10.895303489707013],
              [-17.1296922995078, 10.888935201278601],
              [-17.12214754002163, 10.884800399874825],
              [-17.119189769381386, 10.87665664295832],
              [-17.114670711265326, 10.866766579241],
              [-17.10617861521237, 10.86605330262156],
              [-17.103081578086503, 10.867232316853608],
              [-17.097025475712293, 10.864513408386994],
              [-17.090163318012674, 10.864727684811323],
              [-17.083758299329084, 10.857022048070489],
              [-17.078735027348646, 10.858046847886078],
              [-17.079606829957235, 10.848816658243386],
              [-17.07237919943638, 10.848243564156865],
              [-17.068259279023838, 10.843126481125568],
              [-17.067308338091866, 10.83857849359233],
              [-17.059650057409176, 10.837234078242629],
              [-17.056058943542563, 10.833483129023495],
              [-17.055585235192524, 10.829739413089754],
              [-17.057484783093347, 10.824819768962792],
              [-17.05432319748889, 10.818245200737715],
              [-17.049088502336527, 10.815031164529913],
              [-17.04269604009948, 10.81996855476562],
              [-17.041944030964736, 10.822693400511096],
              [-17.034638901867613, 10.823324538973186],
              [-17.028248136248354, 10.822223863256712],
              [-17.022441445474325, 10.82549168326992],
              [-17.01308356670863, 10.820087962716602],
              [-17.007490348790352, 10.819403987967005],
              [-17.005740274381512, 10.815830718501362],
              [-17.00023690339962, 10.816246471800788],
              [-16.997015205124413, 10.813352652315926],
              [-16.99803263010206, 10.810388029805763],
              [-16.990127868720453, 10.80787110372152],
              [-16.988993273463294, 10.804802843312428],
              [-16.984601292205088, 10.802730582644484],
              [-16.978668775154333, 10.80588257476734],
              [-16.977797812330547, 10.808812309309426],
              [-16.974230877856126, 10.809168957012906],
              [-16.967478335688646, 10.813533348818126],
              [-16.96420439347036, 10.812881141815877],
              [-16.96026791827166, 10.81669860201853],
              [-16.957225293211934, 10.817303796013933],
              [-16.954176812663814, 10.820490840417433],
              [-16.94816235449076, 10.822881305636681],
              [-16.939784242363846, 10.819637573627302],
              [-16.936987855732017, 10.817569468579208],
              [-16.935493367653745, 10.812856033665367],
              [-16.93310550937506, 10.810874354024625],
              [-16.927274277290653, 10.811202272142033],
              [-16.920637118694003, 10.80405240155697],
              [-16.915451359254757, 10.804827366424497],
              [-16.913836813703472, 10.800777642978641],
              [-16.908331191759025, 10.796617345469263],
              [-16.904011770654346, 10.78854366419384],
              [-16.89406422741221, 10.786591220606208],
              [-16.880885305299532, 10.780760187605583],
              [-16.873470427934617, 10.783962302563962],
              [-16.869045599674312, 10.783709999545325],
              [-16.865339998546144, 10.786448135415542],
              [-16.859883462714965, 10.783996404577385],
              [-16.85614613038474, 10.779296900626392],
              [-16.852762011739433, 10.779004069799864],
              [-16.849236665351327, 10.775728486361434],
              [-16.844860306961273, 10.774747851416508],
              [-16.841082624939478, 10.771449921800656],
              [-16.83478338321726, 10.761343608705468],
              [-16.83480534095344, 10.756676045728097],
              [-16.83086630945845, 10.74859247804056],
              [-16.829070898139705, 10.738739701714643],
              [-16.821776854868453, 10.733142046476683],
              [-16.81747212044528, 10.73350773965755],
              [-16.814256611518015, 10.731737084848056],
              [-16.806972355588982, 10.730110976029204],
              [-16.802724168402936, 10.731715811617844],
              [-16.795083975747193, 10.730475300407628],
              [-16.79000310247234, 10.728579461555313],
              [-16.786947437779368, 10.729715901592712],
              [-16.778063169421667, 10.725123610359242],
              [-16.77273743574934, 10.7235138879738],
              [-16.772134180865905, 10.719744458945085],
              [-16.76674205639711, 10.716147409170677],
              [-16.762005142197893, 10.715062790843776],
              [-16.76037108781808, 10.710189880729654],
              [-16.75735104667892, 10.707804071525931],
              [-16.75579362010653, 10.69975096610627],
              [-16.751294652016423, 10.691227482695291],
              [-16.747242585119647, 10.686636320759057],
              [-16.74559707025273, 10.682831246964927],
              [-16.742630481090732, 10.681078222435499],
              [-16.73833537073629, 10.675853358864885],
              [-16.72863811670721, 10.676225565891407],
              [-16.721205237430485, 10.675283358055914],
              [-16.717023688604055, 10.676497646833846],
              [-16.71418338016125, 10.673633420428159],
              [-16.704500179400107, 10.671279550002385],
              [-16.696805412727297, 10.667559859711668],
              [-16.69965925485928, 10.665840219811582],
              [-16.69913733438486, 10.6564047626611],
              [-16.69745590276952, 10.653572131025204],
              [-16.70135902576403, 10.642704501635485],
              [-16.70088672890524, 10.637993278562968],
              [-16.707220043919676, 10.63296883362471],
              [-16.710683269989605, 10.632733944704299],
              [-16.711823487332886, 10.62987256236843],
              [-16.72403381581243, 10.620345502530176],
              [-16.72336948337609, 10.60982850243559],
              [-16.72531468312131, 10.606431651623097],
              [-16.733852294842226, 10.601395712363255],
              [-16.734658642106684, 10.598407309737416],
              [-16.738342713268867, 10.59388371169687],
              [-16.737558221745452, 10.588767624994949],
              [-16.740254147851804, 10.585886943075474],
              [-16.743148732813896, 10.586656196551573],
              [-16.74781308900304, 10.584593882462844],
              [-16.749785142612623, 10.581745596122937],
              [-16.753963861765104, 10.582365092068983],
              [-16.7623612325673, 10.580496699492997],
              [-16.7689169895349, 10.577904201985996],
              [-16.767650573302376, 10.571233027456246],
              [-16.778633552524497, 10.565376764255182],
              [-16.78202395668727, 10.561739968016624],
              [-16.7794704470435, 10.55769498745504],
              [-16.780881542321566, 10.552642029727977],
              [-16.779834170032377, 10.549024568549328],
              [-16.782948841264794, 10.54271050627966],
              [-16.782936944785394, 10.535656290937759],
              [-16.789606869212196, 10.530987948507489],
              [-16.79020601514339, 10.527208120209277],
              [-16.797550829798396, 10.525199896417574],
              [-16.805633509485478, 10.520382527324061],
              [-16.81208524028407, 10.52168139231212],
              [-16.817533870370543, 10.519370710041578],
              [-16.821230751950267, 10.519591058825217],
              [-16.826970487286115, 10.513962329525198],
              [-16.83323115925767, 10.51092457907972],
              [-16.837232160876543, 10.506296028808096],
              [-16.838216345914464, 10.500284737691796],
              [-16.844348176582216, 10.496228279642324],
              [-16.847881395546832, 10.490690884605232],
              [-16.84313074842518, 10.487561357055604],
              [-16.839703917188803, 10.480374546319654],
              [-16.83347131233761, 10.47672227287373],
              [-16.834375636834967, 10.46888664915347],
              [-16.831351982527238, 10.453956011099239],
              [-16.832310439292794, 10.447369130084855],
              [-16.826775776913873, 10.44295581041194],
              [-16.825096193819185, 10.437426591041026],
              [-16.827010767739704, 10.433368646864846],
              [-16.829466391016297, 10.432502088266927],
              [-16.822655167416325, 10.422107785355538],
              [-16.821475973412802, 10.411711335772187],
              [-16.815584734331427, 10.400914751688735],
              [-16.819818753612743, 10.400903032213316],
              [-16.824347717485313, 10.398393720640177],
              [-16.82642025561075, 10.394501138987302],
              [-16.92702658123406, 10.421727365274387],
              [-17.02764168140951, 10.448919673123763],
              [-17.041143287431748, 10.445508346717606],
              [-17.050455801604592, 10.441174583774615],
              [-17.053859956357325, 10.43637174458593],
              [-17.06057053646226, 10.434980472823966],
              [-17.065835804592496, 10.431462078601104],
              [-17.065354733541138, 10.428092244351507],
              [-17.071060648586965, 10.424442251354206],
              [-17.076149365665014, 10.425293865996544],
              [-17.084281549550404, 10.418056574882394],
              [-17.087619736117098, 10.416144676794284],
              [-17.091406037187912, 10.411452538427723],
              [-17.09741484142133, 10.411966707999044],
              [-17.116503222373524, 10.41895372621625],
              [-17.12204921478312, 10.422986287019821],
              [-17.127653154290087, 10.424791098639293],
              [-17.13461558533741, 10.431487869417143],
              [-17.14182315436907, 10.432780606437595],
              [-17.14513344506304, 10.435834564715705],
              [-17.150016615986974, 10.436948911093506],
              [-17.15346651903287, 10.439854601491332],
              [-17.156661785740415, 10.448196488121269],
              [-17.16102161058652, 10.45191677856399],
              [-17.163943597361573, 10.456920071988694],
              [-17.170233184748852, 10.457987235007995],
              [-17.17250076364092, 10.454701132040448],
              [-17.178075501058405, 10.454351090709574],
              [-17.180274568940206, 10.452364758704165],
              [-17.187649855946546, 10.452935027274924],
              [-17.189015094027464, 10.455680257127277],
              [-17.19598610895533, 10.461768892342125],
              [-17.197131823148307, 10.464637917299322],
              [-17.20104970399616, 10.465008984318246],
              [-17.205046541441668, 10.461693187297586],
              [-17.208699386042674, 10.461690277556373],
              [-17.21385030534647, 10.458118456894262],
              [-17.21704168860352, 10.460317782372908],
              [-17.225740211719668, 10.461607053773477],
              [-17.230618900602654, 10.467150435102209],
              [-17.235037744264748, 10.468950374043922],
              [-17.236523891393514, 10.471378393711744],
              [-17.24017918359436, 10.470022437925124],
              [-17.245849590011233, 10.475395505078477],
              [-17.250268649691204, 10.47826120350394],
              [-17.262528740329916, 10.480545086998477],
              [-17.273184919903958, 10.481231548776039],
              [-17.280543495228947, 10.489136341738721],
              [-17.285408471991595, 10.488396266733607],
              [-17.287204570830124, 10.491052319065506],
              [-17.29949124674211, 10.49351293077615],
              [-17.303322699849904, 10.498296131525555],
              [-17.306572346760987, 10.4972505644544],
              [-17.312727281873563, 10.4986196089938],
              [-17.32068272026665, 10.508067083879748],
              [-17.325970171654177, 10.507960702877313],
              [-17.32729809546866, 10.51067021894358],
              [-17.329853483305993, 10.513906488524478],
              [-17.33078712152718, 10.518870927774586],
              [-17.334213107290644, 10.518363584130759],
              [-17.338371729815307, 10.520918616754193],
              [-17.341243061211628, 10.520404841739587],
              [-17.342950604723086, 10.524410403927686],
              [-17.346442007930232, 10.5260453444547],
              [-17.348620187483217, 10.529702729124793],
              [-17.353626488151836, 10.530226118488445],
              [-17.35594542622134, 10.527496772220564],
              [-17.360247447213915, 10.529591552383387],
              [-17.363323523858103, 10.529117519104767],
              [-17.365210217873067, 10.524211413801936],
              [-17.370285828502414, 10.526445188583835],
              [-17.373469188027126, 10.535670722928549],
              [-17.378388524247875, 10.535761549329743],
              [-17.382047819792064, 10.543680914469789],
              [-17.383103211227354, 10.549193774631288],
              [-17.389889054985577, 10.554691227519381],
              [-17.39071945118964, 10.561843344871376],
              [-17.383763040913006, 10.570430807717408],
              [-17.380523119894058, 10.572283506791235],
              [-17.37994543598387, 10.578458187356198],
              [-17.37605518108927, 10.590472674936805],
              [-17.379900653460936, 10.593317323631465],
              [-17.385900312296865, 10.593472646530298],
              [-17.38963622219773, 10.596680230252902],
              [-17.387772480502925, 10.600114408201886],
              [-17.390163610317373, 10.605399006910648],
              [-17.386963561692927, 10.607041867860966],
              [-17.387564319604365, 10.610200718149443],
              [-17.392439687446974, 10.609282694866875],
              [-17.396293728309733, 10.60614061191075],
              [-17.400478496227663, 10.606389647869253],
              [-17.407710380594146, 10.610432736203226],
              [-17.409474604657635, 10.615269185790316],
              [-17.41235236794917, 10.614399237232742],
              [-17.41601444985283, 10.619241926740433],
              [-17.422504477148138, 10.614900246530468],
              [-17.425275719842848, 10.616301265544962],
              [-17.42881165076656, 10.623103516775474],
              [-17.439791801408585, 10.622936630026924],
              [-17.442325756679875, 10.627331718641006],
              [-17.449187701839165, 10.631906601056318],
              [-17.45105912514524, 10.634369606739137],
              [-17.45520954742354, 10.634909109735048],
              [-17.461882345617404, 10.639863107558527],
              [-17.462488253346628, 10.643211075399348],
              [-17.467231558061385, 10.640971073283183],
              [-17.470152683631, 10.6483926283834],
              [-17.468464843285012, 10.652448127948915],
              [-17.4734013870457, 10.656284918299429],
              [-17.479270481550063, 10.653843259296378],
              [-17.4797753017112, 10.657907140450781],
              [-17.4852708283978, 10.661815620212819],
              [-17.48902261868683, 10.662164199747453],
              [-17.487287856152523, 10.669406248215363],
              [-17.483909259416244, 10.67241459672534],
              [-17.487356317916635, 10.67450360643162],
              [-17.484318152594792, 10.678767818585243],
              [-17.485085072501157, 10.691286374309321],
              [-17.482431797874142, 10.69725602546231],
              [-17.48223976288027, 10.702384045493416],
              [-17.48968929413414, 10.711081519658904],
              [-17.495441803327086, 10.712981550082201],
              [-17.497589220973605, 10.718124947045048],
              [-17.49765059994964, 10.723137859488524],
              [-17.50840504315825, 10.732103155111952],
              [-17.5148618286079, 10.7350922578672],
              [-17.518237380089662, 10.739773655610458],
              [-17.51884392070882, 10.744225900400052],
              [-17.517135297671274, 10.751634570989783],
              [-17.517387170512656, 10.76252012012195],
              [-17.515006875446304, 10.766215929715521],
              [-17.522288180781945, 10.777397728569639],
              [-17.5174874883116, 10.774998372884856],
              [-17.516578466011197, 10.78025745797737],
              [-17.521452121831526, 10.780022897311676],
              [-17.529075595485402, 10.781923183008875],
              [-17.53194505612751, 10.784868979420127],
              [-17.538261170821084, 10.787224515084832],
              [-17.541236631037428, 10.778411718458276],
              [-17.544955045797014, 10.78251182908979],
              [-17.551605448219444, 10.785666278876775],
              [-17.55550766112908, 10.792502416940323],
              [-17.55338612447878, 10.798016931365689],
              [-17.548611304645213, 10.801730094082371],
              [-17.544987726874275, 10.811141638994654],
              [-17.550171236594608, 10.812479821503441],
              [-17.550016901188982, 10.815714269337564],
              [-17.558461447405747, 10.821793745497722],
              [-17.56065260992245, 10.826951295139908],
              [-17.567634718685046, 10.83434602276679],
              [-17.568314256354164, 10.83885615055707],
              [-17.5658412377739, 10.842769692782944],
              [-17.56938887394829, 10.848415184755194],
              [-17.567903357042226, 10.852642587930342],
              [-17.56403085904011, 10.856057705628466],
              [-17.56355197102027, 10.86210992476246],
              [-17.566756575638067, 10.87144788023588],
              [-17.571243888397746, 10.874473573818044],
              [-17.56792935614517, 10.877726378199796],
              [-17.57081504380839, 10.88297147145427],
              [-17.574647777143543, 10.8873530164903],
              [-17.57212070113192, 10.889511257910133],
              [-17.57433748317891, 10.900083483548768],
              [-17.571376253243287, 10.904458538868418],
              [-17.57183249261536, 10.907229016475227],
              [-17.563824670885865, 10.909306412182673],
              [-17.562413415498302, 10.91363431243258],
              [-17.55920450918199, 10.914912656650785],
              [-17.557667953256704, 10.91946999900797]
            ]
          ],
          [
            [
              [-17.550835793295228, 11.025366662943632],
              [-17.54516600013104, 11.027383111798834],
              [-17.54157206013085, 11.032273433272161],
              [-17.533108078265045, 11.038077041356186],
              [-17.529701138909747, 11.043343233603764],
              [-17.521247102432223, 11.041158411079351],
              [-17.516624964654795, 11.04105894648026],
              [-17.513439969120594, 11.038948554751979],
              [-17.51232535726094, 11.033504603611101],
              [-17.5074669893302, 11.029342320417305],
              [-17.510336858642415, 11.02244577646767],
              [-17.5064145655739, 11.019695503266664],
              [-17.503445839535978, 11.024037544694629],
              [-17.497280113089865, 11.01858910911625],
              [-17.495665235030362, 11.007330567391621],
              [-17.497201929834254, 11.003533012094623],
              [-17.50169937384826, 11.001179803087483],
              [-17.508985808546953, 10.999421252465627],
              [-17.523071393309372, 11.000943713660917],
              [-17.532365895929768, 11.00554530176919],
              [-17.537064548949942, 11.011791534189385],
              [-17.545537037089087, 11.015348574179816],
              [-17.551657275347758, 11.022575274084966],
              [-17.550835793295228, 11.025366662943632]
            ]
          ],
          [
            [
              [-17.575051346516418, 10.979026587745915],
              [-17.5639056798552, 10.981641225211366],
              [-17.56395573682097, 10.987974120741903],
              [-17.55742142203022, 10.995794931370327],
              [-17.552579471371097, 10.997153379842036],
              [-17.54637001330789, 11.001731569843306],
              [-17.543129712219645, 11.00284810659772],
              [-17.535506861192186, 11.002331145994937],
              [-17.534690000549716, 10.997360895177072],
              [-17.52838145204771, 10.992403010182013],
              [-17.52510969079859, 10.98482840340756],
              [-17.531615028354757, 10.96148601212892],
              [-17.534513994994423, 10.960827466817127],
              [-17.535155218548464, 10.954422913341972],
              [-17.541484723689134, 10.954072729492696],
              [-17.543233173477, 10.958202025038887],
              [-17.54735993775729, 10.959699071622184],
              [-17.55099453351102, 10.952510327077881],
              [-17.549747243155892, 10.947055498825362],
              [-17.55223191349521, 10.94292291097504],
              [-17.557841659043973, 10.942449198657709],
              [-17.56307281748857, 10.947810455896088],
              [-17.567143030774773, 10.958567117330396],
              [-17.571157284033404, 10.963320815882302],
              [-17.57202554581852, 10.968991014864015],
              [-17.57681991038525, 10.97589803794261],
              [-17.575051346516418, 10.979026587745915]
            ]
          ],
          [
            [
              [-17.55766712984148, 11.180911084122776],
              [-17.545322473681388, 11.223053519771437],
              [-17.4916578219447, 11.207585391455249],
              [-17.475846217293917, 11.203267941875222],
              [-17.448566758967686, 11.195143167997124],
              [-17.406417756211635, 11.183841816899937],
              [-17.381577600579114, 11.176603418831057],
              [-17.38490789191279, 11.16858419620285],
              [-17.385653143336235, 11.163733495997015],
              [-17.38441651086713, 11.157018143750749],
              [-17.381779845914178, 11.153340106145052],
              [-17.380997764496716, 11.148545300120947],
              [-17.386756460075777, 11.142176188295196],
              [-17.39015853958205, 11.14083323201979],
              [-17.39404073468828, 11.135574694254744],
              [-17.400155573637605, 11.125097118652764],
              [-17.411691063449368, 11.115028907816173],
              [-17.415878468525758, 11.108921829376289],
              [-17.41914141346291, 11.109030109528993],
              [-17.41986500859003, 11.101112478140283],
              [-17.41824689133536, 11.088581809214022],
              [-17.413851180168475, 11.077685568602904],
              [-17.412050307147435, 11.070565507450649],
              [-17.411749441883828, 11.065250319268374],
              [-17.415213405177624, 11.060887140353776],
              [-17.42905828945017, 11.049885596038608],
              [-17.43993281163371, 11.04328545806547],
              [-17.445512265432892, 11.04278452358135],
              [-17.448292297038147, 11.04598440136432],
              [-17.452523628098415, 11.053460977228738],
              [-17.450484382495187, 11.05739872073452],
              [-17.44485796181751, 11.061052779651822],
              [-17.450001849946045, 11.062503534742357],
              [-17.45986229809467, 11.062829237134602],
              [-17.462668764527795, 11.064767915251522],
              [-17.46853228715447, 11.07297354325141],
              [-17.479465117042864, 11.078846677354552],
              [-17.482606184880666, 11.082518016834987],
              [-17.486278316281826, 11.083228090541995],
              [-17.492691483317465, 11.088971801973338],
              [-17.49745399686147, 11.089991027438009],
              [-17.50063708421647, 11.08500023023072],
              [-17.504372491721618, 11.08539918305887],
              [-17.51007104981248, 11.088977520211483],
              [-17.510372903142358, 11.091696515191957],
              [-17.502448128071997, 11.103779670151463],
              [-17.49914631108631, 11.104205930954343],
              [-17.496440987539927, 11.107220972450047],
              [-17.499209240057596, 11.112368814138817],
              [-17.493468982191523, 11.117471449095792],
              [-17.486999021100818, 11.125002414657747],
              [-17.48656893820165, 11.129501342506497],
              [-17.482312790007285, 11.133490425684398],
              [-17.47621941335564, 11.132421042373258],
              [-17.47361388352695, 11.128086503175567],
              [-17.47137023582093, 11.13055981627743],
              [-17.47228584536454, 11.134906771146593],
              [-17.475178028114545, 11.136541661300644],
              [-17.477515472390202, 11.140636945054181],
              [-17.46694066572852, 11.149090501148686],
              [-17.464717705855694, 11.148625621652862],
              [-17.457831374325583, 11.152562758413705],
              [-17.449876526809465, 11.154400975155546],
              [-17.447924583433867, 11.157608000445151],
              [-17.438511035926545, 11.16442502689791],
              [-17.437741633245167, 11.171067866674866],
              [-17.443785662648914, 11.17114045688118],
              [-17.454501033466713, 11.167882132897164],
              [-17.46115713996357, 11.167064417893167],
              [-17.46569102337089, 11.167692404449562],
              [-17.46847658268015, 11.165684765905683],
              [-17.47920097265405, 11.16530449534475],
              [-17.489243087918982, 11.156940698929237],
              [-17.49836711866524, 11.155007339521028],
              [-17.502664371201593, 11.15081221769833],
              [-17.508621370326424, 11.150228561646612],
              [-17.51384535770177, 11.147873034033429],
              [-17.516407247711637, 11.148969712622806],
              [-17.518296088228315, 11.144053712324268],
              [-17.5180969826273, 11.139428081832348],
              [-17.524552160591963, 11.130112500830538],
              [-17.533309192340855, 11.122582537065819],
              [-17.540300867218726, 11.112397593136524],
              [-17.544364675800413, 11.108083072349233],
              [-17.547268151506735, 11.098952585555752],
              [-17.551709935099353, 11.09603099290136],
              [-17.54984155424038, 11.090913296529964],
              [-17.54572943943883, 11.090068624606284],
              [-17.549598140605248, 11.085437848076173],
              [-17.55129082688388, 11.078544751874468],
              [-17.548731025235973, 11.078637331212777],
              [-17.544055974425884, 11.083046848593407],
              [-17.540049386258005, 11.081746011630226],
              [-17.543210307385902, 11.077891221862675],
              [-17.544813592567255, 11.072446592932224],
              [-17.543634457046448, 11.066703379140352],
              [-17.53806818605978, 11.063813660351013],
              [-17.534929100374, 11.065874118646006],
              [-17.533147054849042, 11.061599028556966],
              [-17.537510994204812, 11.059393835367768],
              [-17.53998233661187, 11.052717303844869],
              [-17.5416308055188, 11.051708326990166],
              [-17.54163068324417, 11.0448215664321],
              [-17.54031650904775, 11.041824578973987],
              [-17.542499179987875, 11.036703317851408],
              [-17.556622767448232, 11.030044228544872],
              [-17.56043349074436, 11.02685899017001],
              [-17.56346357482317, 11.02804691606019],
              [-17.563818387707926, 11.032577477204203],
              [-17.561677630199306, 11.040994048683121],
              [-17.568809128600606, 11.032845473334667],
              [-17.567383900575383, 11.030800687896953],
              [-17.568121991201572, 11.021983330094777],
              [-17.560718094008386, 11.019872481958132],
              [-17.56917277915346, 11.012104671133667],
              [-17.57160417282434, 11.004421344798695],
              [-17.57008994881287, 11.001527776862781],
              [-17.57561815938079, 10.999977029275035],
              [-17.577093497803514, 10.997264928535152],
              [-17.58647793247253, 10.993533052499995],
              [-17.591336739750673, 10.995914381630511],
              [-17.59206877759606, 11.001527551032089],
              [-17.591146752007923, 11.014403337660122],
              [-17.594622958228097, 11.015227452611972],
              [-17.597539703259976, 11.018519429119266],
              [-17.599393134781003, 11.031045855265528],
              [-17.602176846959875, 11.043190855806904],
              [-17.599515566268792, 11.054203380272273],
              [-17.600714454231788, 11.058153279364847],
              [-17.605432715589437, 11.061628745148555],
              [-17.60796761818298, 11.065630672393555],
              [-17.608315547047198, 11.073601758936745],
              [-17.610352772322447, 11.078877691591677],
              [-17.60634641357166, 11.082552144463376],
              [-17.605050314937092, 11.08583642463954],
              [-17.59008645755461, 11.10533557981364],
              [-17.58725737552108, 11.105589569273663],
              [-17.57984065910995, 11.11138550004247],
              [-17.57344880609458, 11.114310594168684],
              [-17.564802411068648, 11.123088199556758],
              [-17.564050986946892, 11.129091905524364],
              [-17.56544466268418, 11.134152945803784],
              [-17.56454517895934, 11.142894956703557],
              [-17.555391907645397, 11.159759148745135],
              [-17.548670012839565, 11.157365505589109],
              [-17.542761392533205, 11.156853529305026],
              [-17.542648532123813, 11.159049356821543],
              [-17.54861935823502, 11.16119049389867],
              [-17.557370508049416, 11.168186003595892],
              [-17.5561175012385, 11.17233638315377],
              [-17.55317345238494, 11.172717348668483],
              [-17.55210988815135, 11.176320303514222],
              [-17.548126413484827, 11.177546328474694],
              [-17.54908278985096, 11.181427462957453],
              [-17.554691017987878, 11.182160894035304],
              [-17.55766712984148, 11.180911084122776]
            ]
          ],
          [
            [
              [-17.61209845325313, 11.094229780712134],
              [-17.608268736263156, 11.103359104765202],
              [-17.601883067040244, 11.106418330060858],
              [-17.597941635051992, 11.102877456499147],
              [-17.604871499261403, 11.096000745246004],
              [-17.607503007309223, 11.091668165236383],
              [-17.610507155006832, 11.090981901420399],
              [-17.61209845325313, 11.094229780712134]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.10396217581403,
          "lat": 47.02383142912004
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53053"],
        "coty_name": ["Pierce"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pierce County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01529159"
      },
      "bbox": [
        -17.61209845325313, 10.394501138987302, -16.696805412727297,
        11.223053519771437
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.763218653097184, 1.0922821628952746],
            [11.765959651771997, 1.0959306254618881],
            [11.762395397572753, 1.1011989568072056],
            [11.770626704864128, 1.105003116772278],
            [11.76784371500906, 1.1075313669006615],
            [11.766888526870277, 1.1118174859833265],
            [11.764229584164546, 1.11437744346241],
            [11.790596892314662, 1.153886315828509],
            [11.830393135974528, 1.2175202821036009],
            [11.833330302927445, 1.2215332701995383],
            [11.832618146135573, 1.2258590361843436],
            [11.837628022247086, 1.2322840416452014],
            [11.852800464809944, 1.2374488166735929],
            [11.855981204613586, 1.2399941287968936],
            [11.862273214243917, 1.2351619266935365],
            [11.864678968289313, 1.2376875573794992],
            [11.869281469746785, 1.2332023553571172],
            [11.871487009650151, 1.2276224536174758],
            [11.877587072357205, 1.225009145070618],
            [11.880310349647871, 1.2196133296276714],
            [11.886414939414683, 1.221396730525421],
            [11.890181907271085, 1.2144318653482473],
            [11.897103769812842, 1.2173653008452971],
            [11.903020213919987, 1.2114584421848995],
            [11.908008200320957, 1.2129615827704816],
            [11.911241298746386, 1.2117362696779164],
            [11.925120603266954, 1.2141417620742994],
            [11.930631497742818, 1.2187210272224378],
            [11.934558758643403, 1.216047208207741],
            [11.931670228705322, 1.2131357791880033],
            [11.936978354981944, 1.2086636096860552],
            [11.937646262526862, 1.20537125341388],
            [11.934776525948834, 1.2029226555703239],
            [11.935202506929658, 1.1991748755415077],
            [11.940148567813505, 1.190947343983051],
            [11.946813385545605, 1.1899779892034335],
            [11.952239804116154, 1.184919134501523],
            [11.956566780492382, 1.1825027376249015],
            [11.957661391205928, 1.1790962486220928],
            [11.965182886571482, 1.171245445205943],
            [11.959968294925808, 1.1667987780167663],
            [11.962427745022591, 1.1622263192392344],
            [11.966582294718913, 1.1581831258267838],
            [11.96513552788229, 1.1553444713644538],
            [11.966906625896188, 1.1495616978231489],
            [11.968790950977896, 1.149646774847474],
            [11.970385329792387, 1.1428341687107066],
            [11.967480310887616, 1.140759105303437],
            [11.969020097771308, 1.137500018738549],
            [11.964908206771979, 1.134971476682814],
            [11.96350996982456, 1.1320435280082137],
            [11.964971015850377, 1.1257952921045158],
            [11.968885501923632, 1.1243743821381864],
            [11.96770496604648, 1.1201010398400848],
            [11.97161797683095, 1.110269467318062],
            [11.977522267447021, 1.0854012135142022],
            [11.983960994924733, 1.0567168295453786],
            [11.979990233241418, 1.054629599757992],
            [11.977712640950696, 1.0502736459045985],
            [11.980802460836076, 1.0465973658476688],
            [11.978079666335036, 1.040814151016221],
            [11.979847469000719, 1.0379017884674258],
            [11.980673408413491, 1.0317801664006947],
            [11.976959183026652, 1.029234238471373],
            [11.973834261468616, 1.0248225863543219],
            [11.971079852315885, 1.02469576812855],
            [11.968757151198, 1.0197412709880744],
            [11.967711774797714, 1.0113322533711542],
            [11.963523956080524, 1.011228672303444],
            [11.963197836000138, 1.0066373627971559],
            [11.958337948048904, 1.0019421348045874],
            [11.951203756409043, 0.9976421676776247],
            [11.955010573678283, 0.9957066039486147],
            [11.956974547022234, 0.9849355405654704],
            [11.959503956093235, 0.9809453309165488],
            [11.964488404489337, 0.9816501196813469],
            [11.962902331210948, 0.9763825689059272],
            [11.970392001166031, 0.972813632722469],
            [11.970448952299808, 0.9695147810296816],
            [11.984459367200333, 0.970057217235065],
            [11.984319298884888, 0.9648429631171491],
            [11.989069955763977, 0.9683447943306769],
            [11.99300383755425, 0.9653575797717514],
            [11.99618821393511, 0.965176032372156],
            [11.997381746253755, 0.9615282567862831],
            [12.00167250849175, 0.9618756068512841],
            [12.003704318885742, 0.9589971377781376],
            [12.005630184912334, 0.949680779042836],
            [12.010456889096778, 0.945091226023646],
            [12.010650325203818, 0.941047091560419],
            [12.013350918491788, 0.9401337754662239],
            [12.014644355927766, 0.9346955240098265],
            [12.017894220382312, 0.9311371130184767],
            [11.99016345424807, 0.8755514163243406],
            [11.9592407699962, 0.8135502973712061],
            [11.958770740608761, 0.820549662027872],
            [11.95342681624281, 0.8258804181566136],
            [11.951637733213053, 0.8292722606306511],
            [11.946981705197988, 0.8283970172958276],
            [11.94511333243461, 0.8346109387703405],
            [11.941785484778705, 0.8344079666027501],
            [11.9409311394946, 0.8382522824426781],
            [11.93669232815728, 0.8378534330080247],
            [11.932816755492569, 0.8295117717832462],
            [11.925582002946081, 0.8276328285853959],
            [11.920252781075517, 0.8308417884611635],
            [11.918502268070787, 0.8339755164973146],
            [11.910802158039852, 0.8341628621091481],
            [11.906291002798543, 0.836576582444645],
            [11.90436770841194, 0.8351707597024155],
            [11.89938807272871, 0.8377573824883634],
            [11.89670988991778, 0.8369136229442729],
            [11.895418786108035, 0.8411901429769216],
            [11.89271052224775, 0.8441694219188552],
            [11.894486998418087, 0.8489532841064112],
            [11.89215080322711, 0.8541803615496293],
            [11.888521515357285, 0.8522560382220106],
            [11.888373288265347, 0.8598879136128523],
            [11.889562870720177, 0.8648818397698393],
            [11.881899306871828, 0.8667187977283125],
            [11.879412324293192, 0.871404142644431],
            [11.881152928355725, 0.8737965589611313],
            [11.878582692716469, 0.8781315160803244],
            [11.881646048311975, 0.8816497791215522],
            [11.882091661226607, 0.8909212754742262],
            [11.876649683812738, 0.8980953401548467],
            [11.877387080884509, 0.9018916232719952],
            [11.875411232479953, 0.91064209140427],
            [11.871363998195456, 0.9132842646779518],
            [11.874339831500155, 0.9228859547114261],
            [11.871836575502169, 0.9304117922237708],
            [11.869561935360505, 0.932658149825086],
            [11.862115331435044, 0.9362858115220613],
            [11.859580858183566, 0.9409596377310021],
            [11.85153909720113, 0.9507347018373211],
            [11.848032957859848, 0.95127870874438],
            [11.849155940993073, 0.9550931601108813],
            [11.842886161062257, 0.9568324713219291],
            [11.841734674909665, 0.9626096531907843],
            [11.836424918492659, 0.9646666104982153],
            [11.83726604119362, 0.9710547582350485],
            [11.832253692292142, 0.9713947357061196],
            [11.825960427962393, 0.9702814334852093],
            [11.8271248733718, 0.9748407319203053],
            [11.821527648627466, 0.976044149457912],
            [11.824085479494437, 0.9804272520946942],
            [11.827538515387847, 0.9832994428454156],
            [11.821785248593603, 0.9865087581825824],
            [11.823343485250678, 0.9955248222138036],
            [11.81875938721236, 0.9962646686018543],
            [11.822258835698827, 1.0022085825100704],
            [11.820749552543113, 1.0074063749030724],
            [11.818196843142632, 1.0092421858883895],
            [11.824598149983338, 1.0160825536999443],
            [11.821013323398692, 1.0186444063235267],
            [11.818232681537786, 1.0280716310662767],
            [11.8124935130323, 1.02956855339828],
            [11.81127945650473, 1.035855865959263],
            [11.808403861477858, 1.0352000431400654],
            [11.804173952917433, 1.0296574088244703],
            [11.800846948338428, 1.0334691918154886],
            [11.797233840687971, 1.0345223521564388],
            [11.79788242355351, 1.0413157208789603],
            [11.803289931994316, 1.0413191218152933],
            [11.80417725708323, 1.045158096169516],
            [11.798552487251689, 1.0461750988246565],
            [11.797851457069358, 1.0537984800729778],
            [11.800495310084157, 1.057389160603156],
            [11.794588353321757, 1.0646768760310292],
            [11.789716057883677, 1.0686802140862974],
            [11.78678231273802, 1.0684400062484913],
            [11.780644757964104, 1.0728406269830932],
            [11.788557570749095, 1.0775142312083117],
            [11.782698199963125, 1.0788621168438597],
            [11.77887303546246, 1.0816614979125652],
            [11.779239879277407, 1.0874121067436178],
            [11.775639014065096, 1.0903017961355734],
            [11.772075245401886, 1.0848906101404798],
            [11.769810496490384, 1.0849220394082233],
            [11.769729177187088, 1.0917274192993354],
            [11.76438507765528, 1.0901623142683818],
            [11.763218653097184, 1.0922821628952746]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.1176402566506, "lat": 38.844473171633254 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54013"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01696945"
      },
      "bbox": [
        11.762395397572753, 0.8135502973712061, 12.017894220382312,
        1.2399941287968936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.194580219377823, 0.3310889102802144],
            [12.253873246508329, 0.3307831771639278],
            [12.299185277239882, 0.33040121586649823],
            [12.329468940168391, 0.32796668342997226],
            [12.343426727384296, 0.342614663154579],
            [12.383523816444317, 0.3916748183026929],
            [12.407474102888143, 0.42045690941827313],
            [12.463698676686926, 0.4894545298288838],
            [12.495444184700675, 0.5297320621510424],
            [12.51037605080728, 0.5501657588546301],
            [12.575892471777163, 0.5185525426387397],
            [12.580889180837142, 0.4842255233452449],
            [12.591829872827958, 0.40716132296917895],
            [12.67892344971885, 0.35223669139001],
            [12.70364001040197, 0.35245858694872373],
            [12.710709666731562, 0.35289104270985966],
            [12.712077808754778, 0.3548536815523808],
            [12.717162993916359, 0.3539017601174899],
            [12.722283880601342, 0.34972470482155965],
            [12.727189560900955, 0.3522276698410677],
            [12.73079245272282, 0.35716742922567274],
            [12.735017555325804, 0.3570410223843952],
            [12.738642921630078, 0.35455737402452325],
            [12.741253764233376, 0.3565429897537136],
            [12.746433524625163, 0.3567751807497766],
            [12.754120802895823, 0.35408393057159016],
            [12.7610614878488, 0.35730218738460184],
            [12.7987033575578, 0.38180234777325045],
            [12.873598328920169, 0.400139453308241],
            [12.910417140001522, 0.40878973690987197],
            [12.906713652993462, 0.3917816457813189],
            [12.903632805235354, 0.38336459089036523],
            [12.905624265556483, 0.3797066723771318],
            [12.904258916397062, 0.3733005950497313],
            [12.900817889397032, 0.37017566648321804],
            [12.898148505678122, 0.3610803794213815],
            [12.898589252669982, 0.3560563246001905],
            [12.895692668203191, 0.35460492756989614],
            [12.89285883808679, 0.3485990365886795],
            [12.893135457895323, 0.3416224611475094],
            [12.889624810763989, 0.3325969166340426],
            [12.882871360606089, 0.32721534864009955],
            [12.88287932345641, 0.32273040928689184],
            [12.875638162236784, 0.3139770443360992],
            [12.867867851494548, 0.30345420138840984],
            [12.860258405980069, 0.29147266845133885],
            [12.85503984772421, 0.28525621323546907],
            [12.848016188018535, 0.2788403222845259],
            [12.842732502888087, 0.2728767666380065],
            [12.84245520371438, 0.27017524421239103],
            [12.835286214778623, 0.2586377075024696],
            [12.829808795987338, 0.2460013287896609],
            [12.824769161688842, 0.2459685484434966],
            [12.822482327919769, 0.24126793275545233],
            [12.81614064499591, 0.23158929538224454],
            [12.814985558598618, 0.2286519645002507],
            [12.816915521646965, 0.22294154318749415],
            [12.812352650247313, 0.22240040784966184],
            [12.808418712380494, 0.21783654194274452],
            [12.807365419488363, 0.21291352239009323],
            [12.800801035118925, 0.2047580606644851],
            [12.794685958995714, 0.20810719722708174],
            [12.79177347478688, 0.20242723142783667],
            [12.786444731466052, 0.19466778171863225],
            [12.782578080139498, 0.18581942597537332],
            [12.78135365298672, 0.17839445513190413],
            [12.778789484526962, 0.17178171681566273],
            [12.775072948556593, 0.16982100735904704],
            [12.774720481310128, 0.16370604586097803],
            [12.779112700387182, 0.15721566755526947],
            [12.774058660538532, 0.1543085489164517],
            [12.768680174698302, 0.1472802512370129],
            [12.763609031550706, 0.1387302958244037],
            [12.762190864445662, 0.1300245120940462],
            [12.759295195002448, 0.12608625903877368],
            [12.753865622509883, 0.12229379948815607],
            [12.749139410477339, 0.11034455448690322],
            [12.748382891794504, 0.10350626667807479],
            [12.753928107479593, 0.09916001254300646],
            [12.753820467212316, 0.09545902696110646],
            [12.760603373605376, 0.09496456372225405],
            [12.761536545570255, 0.09050519243213952],
            [12.752723197050075, 0.0903933021192188],
            [12.749974292402127, 0.0894117619692063],
            [12.746642299760278, 0.0835553173696068],
            [12.743334972931853, 0.08256558181585015],
            [12.74320681073057, 0.07778725861857035],
            [12.738081965963508, 0.07739365760674521],
            [12.736426604376865, 0.07143136438853441],
            [12.738581187477665, 0.06580526567884264],
            [12.732867225340227, 0.06379835943392613],
            [12.731686769905119, 0.04543013629660774],
            [12.734382929597162, 0.04094690595228463],
            [12.741400716576038, 0.03834014118039351],
            [12.741241138875735, 0.03429385272373366],
            [12.738207726016986, 0.028373684464975138],
            [12.733672852227153, 0.02574628643002636],
            [12.727302049250762, 0.013479612386787172],
            [12.719853044148707, 0.0005231167694284644],
            [12.713640416555066, -0.0052429470165962395],
            [12.703438356104174, -0.01093084913418374],
            [12.696133286639144, -0.013573514544289516],
            [12.68328224242322, -0.014613525212890582],
            [12.6732319174104, -0.009741045916007116],
            [12.672553668642022, -0.006252496003699789],
            [12.67722272758654, -0.0009118168665041593],
            [12.6777859738073, 0.0016048904786023874],
            [12.667221050973803, 0.003522898181220162],
            [12.665408266845663, -0.010270005757082154],
            [12.66332128363359, -0.015812603368745286],
            [12.655623079254449, -0.015457710211867697],
            [12.654067668571349, -0.021236183131670076],
            [12.651491283551035, -0.021479311423649918],
            [12.644558403736532, -0.015717553070340035],
            [12.646430399489676, -0.00796145854202181],
            [12.642110361587386, -0.0009894398243701918],
            [12.636773482104307, -0.007366590773723616],
            [12.63507686860711, -0.005610761233684704],
            [12.636297796069496, -0.0011984492474117112],
            [12.634801016035475, 0.0009958213131881291],
            [12.635464960188925, 0.0061900042794595005],
            [12.630257089743054, 0.003911588930213093],
            [12.625697967318082, -0.00402782308892146],
            [12.622616657051465, -0.004698578111856534],
            [12.619583866685373, -0.01221894821519599],
            [12.615156519090712, -0.010966685859355622],
            [12.611652876542319, -0.01654397628040018],
            [12.606099976223582, -0.02259988680916011],
            [12.596355925277168, -0.0301732523632946],
            [12.595497676282793, -0.03295655544250963],
            [12.586115505388008, -0.031102734554184296],
            [12.587159774860758, -0.02780377682524053],
            [12.58416641069778, -0.02520873845324121],
            [12.57662905988469, -0.02630827688540652],
            [12.5751883124362, -0.022929925073886304],
            [12.571505333764808, -0.028107531015123935],
            [12.56200289935661, -0.02801870793998346],
            [12.558877440381858, -0.03138337492898521],
            [12.557061414071033, -0.02848922974139105],
            [12.551126263295474, -0.029590553448312837],
            [12.550963937149213, -0.032823522294739026],
            [12.476492835008022, -0.022569409200920525],
            [12.463407027897405, -0.020544114313104263],
            [12.461207048774186, -0.022013518171141038],
            [12.45590306464578, -0.0202947746022903],
            [12.451798826513821, -0.017205359136202338],
            [12.44439683408453, -0.01695876049405184],
            [12.436243123911177, -0.015535572944219611],
            [12.430549158271413, -0.015530082890390299],
            [12.423240963081067, -0.012241849954696269],
            [12.414396872930803, 0.01831137056689627],
            [12.361426069337647, 0.059958712028354906],
            [12.3561765553438, 0.06683363118737874],
            [12.338361094215331, 0.08053425450482507],
            [12.290705657522146, 0.10662220885344618],
            [12.335604223537347, 0.11000979631827779],
            [12.274249786302423, 0.18606732077483876],
            [12.299604424707688, 0.2264579152432944],
            [12.298418876878713, 0.22816281135038546],
            [12.288441255801201, 0.22907044261271745],
            [12.28423976168837, 0.2318842820929925],
            [12.282443389967797, 0.23512840520599496],
            [12.284215997349449, 0.24606899161035883],
            [12.281736883017016, 0.24999866428067855],
            [12.27419637488379, 0.25598489021599113],
            [12.272410433064389, 0.2635084449210007],
            [12.269776206507448, 0.2648888729331791],
            [12.258004781895002, 0.26486089488385733],
            [12.251868949814492, 0.26248651904930276],
            [12.24759605633681, 0.2662017408243631],
            [12.247773071154311, 0.2696607777461507],
            [12.245474084015498, 0.2727968723177897],
            [12.244668542776218, 0.27770251542796215],
            [12.249740881632544, 0.27845174764523106],
            [12.257274495417848, 0.2834908973109528],
            [12.254615675765686, 0.28806922841157817],
            [12.254542082936593, 0.29156468738512475],
            [12.260102480949751, 0.29487590629753885],
            [12.264334485177798, 0.29941353379656455],
            [12.260348962517984, 0.30204596639780135],
            [12.255291073121882, 0.29909486226463255],
            [12.249027331285347, 0.3004503637507948],
            [12.242658633486887, 0.29737395690912494],
            [12.238715084768028, 0.2907823403021966],
            [12.239148009969123, 0.2875033459678955],
            [12.23502225217881, 0.2857400069955485],
            [12.228237480832775, 0.28794325267895393],
            [12.218440416074452, 0.2870846806019639],
            [12.214132815518802, 0.2880609233996349],
            [12.203900067513128, 0.29361125137835625],
            [12.201205722529501, 0.29829770048501],
            [12.194059755573925, 0.3038155791134145],
            [12.189393409840541, 0.30587275877249465],
            [12.195886469415028, 0.30983162367328765],
            [12.196922424658524, 0.31707397202269666],
            [12.19433615746222, 0.3207868130156614],
            [12.195447033972593, 0.3233090606648804],
            [12.194580219377823, 0.3310889102802144]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.45294642436603, "lat": 37.94690104976807 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54025"],
        "coty_name": ["Greenbrier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greenbrier County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01557518"
      },
      "bbox": [
        12.189393409840541, -0.03295655544250963, 12.910417140001522,
        0.5501657588546301
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.640669779467329, 2.046727107773143],
            [13.641814412288056, 2.046555847491482],
            [13.660261614076612, 2.0524367665033614],
            [13.661589746285436, 2.0548168926480748],
            [13.66568437477477, 2.0559036930420205],
            [13.678641230211737, 2.0537542807573033],
            [13.682651074557507, 2.0514490557118465],
            [13.685541362345237, 2.055246271530052],
            [13.689757920956856, 2.0576671580067103],
            [13.69031684901523, 2.052563999895116],
            [13.694295362888974, 2.0492952841064294],
            [13.70171565794666, 2.049289703971086],
            [13.706659094375292, 2.045901720581037],
            [13.71227962429423, 2.0439394463240865],
            [13.718509672723986, 2.047230945733623],
            [13.726528350034789, 2.048177088329123],
            [13.739901946388976, 2.0544119655946957],
            [13.744758561724636, 2.0554541025787794],
            [13.759556396835162, 2.051908015632731],
            [13.769826793589534, 2.0529343385830967],
            [13.776420480171954, 2.0553642207139826],
            [13.781806314681667, 2.0535767371453955],
            [13.78586598079146, 2.0548969448443337],
            [13.812226198366577, 2.0426701680650874],
            [13.855879194587137, 2.0284217495846075],
            [13.875696786657228, 2.0235412876116396],
            [13.886638285955508, 2.021639097559692],
            [13.885552263951793, 2.017527346628306],
            [13.889316477671976, 2.015441117514234],
            [13.889874642151598, 2.0034075689929387],
            [13.890862886999187, 1.9963295687885843],
            [13.8874685725029, 1.991800792545484],
            [13.892544735575044, 1.9866840618085038],
            [13.89407308584704, 1.983623564374751],
            [13.89198438563461, 1.9760220691343555],
            [13.887382032869214, 1.9668833994289117],
            [13.889991531159227, 1.958809828707024],
            [13.897224100419768, 1.95374852858402],
            [13.89744448889502, 1.9470772534494463],
            [13.903944879753382, 1.945636076563014],
            [13.898402869348141, 1.9269475882974758],
            [13.891644164789053, 1.9130258745534416],
            [13.90616819506348, 1.9110848937771054],
            [13.912587970506667, 1.9110053599490475],
            [13.914405695901015, 1.9076479438422775],
            [13.90925292763701, 1.900020354409449],
            [13.91088768447201, 1.8959190538280808],
            [13.90452160674446, 1.872818910887982],
            [13.901104029844547, 1.8717064409038975],
            [13.900512930257266, 1.8642409073773623],
            [13.895806832330958, 1.8582129595158965],
            [13.888556918226186, 1.8448367360464581],
            [13.888297867086857, 1.839801017285477],
            [13.885880498756787, 1.8336156980024514],
            [13.880857435997703, 1.8305541491167978],
            [13.88018463816396, 1.8248323160637523],
            [13.873723926812405, 1.811755058779177],
            [13.870985101123393, 1.8046378398186362],
            [13.879667286666916, 1.8012195257571906],
            [13.888270119278113, 1.7941704446300724],
            [13.885472314145169, 1.7906540890073968],
            [13.886303815848702, 1.7805045845526557],
            [13.879562688221867, 1.7652074399597897],
            [13.872523096316742, 1.7531221718218173],
            [13.867510578937585, 1.7429821417546414],
            [13.873737878700458, 1.7422753194226812],
            [13.876042256972625, 1.7390164211209058],
            [13.879438911589302, 1.7391617302951594],
            [13.877031544750277, 1.733641217258807],
            [13.886222987323187, 1.7252341978073122],
            [13.889228051662311, 1.7262901281912704],
            [13.891300482784215, 1.7223689895973961],
            [13.896461784058483, 1.7205268993051195],
            [13.89957071636067, 1.7175647488714658],
            [13.893515161081233, 1.7071544461712018],
            [13.884491916581373, 1.6996262813925713],
            [13.87946904707916, 1.6873585107866194],
            [13.87914695132933, 1.6774990332638373],
            [13.867191648343985, 1.6559713649471706],
            [13.862151047499399, 1.6545248818855764],
            [13.858077765664731, 1.648924836769555],
            [13.853821478955677, 1.6498765832857956],
            [13.849853487513764, 1.6466004151977534],
            [13.84281479348491, 1.6387397876326257],
            [13.842564139283882, 1.6366276679624825],
            [13.835296478680828, 1.6246500234107561],
            [13.827913027052299, 1.6275746396751936],
            [13.827013767675448, 1.6319733891369625],
            [13.823433623380618, 1.6315068074069996],
            [13.821831620371583, 1.6352339217825491],
            [13.816180018787806, 1.6391424483783568],
            [13.809206362764039, 1.6419875956385628],
            [13.809367713852954, 1.6438149224054281],
            [13.800771236396953, 1.6498204660886606],
            [13.797039678040225, 1.6537221207245012],
            [13.787222786718607, 1.659671628802246],
            [13.754586020549251, 1.6627782326449962],
            [13.746674682078178, 1.6456512831282233],
            [13.742566148158897, 1.6381223085481071],
            [13.735787137302243, 1.6427873134649884],
            [13.72864634823628, 1.6442271357654334],
            [13.724423249111267, 1.6422129462693347],
            [13.716074507259835, 1.6405832147796158],
            [13.707922865147209, 1.6431449106478941],
            [13.704386216482094, 1.6498354715451142],
            [13.68615357616133, 1.6565807916107604],
            [13.680123403078309, 1.656476651380584],
            [13.666069390675057, 1.6548218934308156],
            [13.65414683936698, 1.6540691623279737],
            [13.591605037661907, 1.667199789744784],
            [13.564982220304952, 1.673123105479794],
            [13.543096400696045, 1.6753808423673746],
            [13.519412796990505, 1.6798760049781056],
            [13.451781872381337, 1.7071456504995917],
            [13.45351141487363, 1.7132435403342003],
            [13.463244418276755, 1.7328325016221322],
            [13.466945563853411, 1.737497560352561],
            [13.472274789436185, 1.7387886296636952],
            [13.4764346120642, 1.7438205287473785],
            [13.479893285987892, 1.7517058303701498],
            [13.484564008776962, 1.7553850325304725],
            [13.4858651878409, 1.7616177574358147],
            [13.48465852336027, 1.764862054058113],
            [13.485249918599886, 1.7699259883555738],
            [13.487993589535773, 1.7764053087566456],
            [13.489846103792065, 1.7774176206124943],
            [13.492826754971588, 1.7834203021678752],
            [13.495955969550005, 1.786110869808467],
            [13.500741377399274, 1.7941076227710244],
            [13.505563096215196, 1.8068640892651104],
            [13.508073006512973, 1.8105175713729318],
            [13.51039985059347, 1.8082405956063325],
            [13.51709697400443, 1.8109346417823924],
            [13.521135739250274, 1.810262012004502],
            [13.523855612931056, 1.813054945734949],
            [13.532353493004255, 1.817640760436206],
            [13.534967181945493, 1.830728966177455],
            [13.535770057154359, 1.8393299583540048],
            [13.540990911178794, 1.840945174821118],
            [13.54704102427774, 1.8540173217269023],
            [13.5479134581072, 1.8598056019820364],
            [13.554264718454622, 1.868339664891351],
            [13.556920528985332, 1.8809129194895198],
            [13.56010501230549, 1.8888853589149883],
            [13.561858296140498, 1.8984639926193745],
            [13.561539271100168, 1.9041146396740267],
            [13.56300198752784, 1.9134124515223705],
            [13.561660350044326, 1.9190841319380838],
            [13.565028262669102, 1.922878082355821],
            [13.570239602178352, 1.9351220422184343],
            [13.570249480551448, 1.9392081664478964],
            [13.572245976469816, 1.9429443044017602],
            [13.575755764758048, 1.9449628287985528],
            [13.581340856119576, 1.9419061887682725],
            [13.582700415911585, 1.9428129211836767],
            [13.585830049397652, 1.9548133828416536],
            [13.593357530021827, 1.9581802540207598],
            [13.594575581290545, 1.9655460562933127],
            [13.599357206295533, 1.9654094655834424],
            [13.612849690490423, 2.0031042860411614],
            [13.617174760010478, 2.005630318383371],
            [13.62175931951739, 2.010133914408638],
            [13.640669779467329, 2.046727107773143]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.61413734882095, "lat": 39.31704290914589 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54027"],
        "coty_name": ["Hampshire"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hampshire County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01718644"
      },
      "bbox": [
        13.451781872381337, 1.6246500234107561, 13.914405695901015,
        2.0576671580067103
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.776667140409213, 2.082879555602098],
            [12.891581688321084, 2.1032657174791747],
            [12.93832566183859, 2.1109392178191744],
            [12.992170407303297, 2.120675400225142],
            [13.005657783443935, 2.044316680298833],
            [13.005099545566482, 2.04224821751294],
            [13.02357862537608, 1.9322190728730115],
            [13.020944670312936, 1.9317568654811448],
            [13.022534614996225, 1.9214600745928412],
            [13.033814496825913, 1.854339507048041],
            [13.052140674749667, 1.745272893846129],
            [13.050857981726754, 1.7450478468948072],
            [13.058664769578742, 1.6973103157996998],
            [13.06089921260204, 1.6808652620756017],
            [13.061900812512345, 1.6792132075340833],
            [13.063754195851024, 1.6662766951020127],
            [13.064864051762425, 1.6661640452004227],
            [13.074396527561705, 1.6074438532779558],
            [13.076097566062748, 1.596415253956121],
            [13.05688187326869, 1.6148995290734995],
            [12.966895662504692, 1.6341671843715657],
            [12.91158066141568, 1.6460890065502432],
            [12.887662644787536, 1.6301376442258622],
            [12.826676245223965, 1.590063372383449],
            [12.826049018334379, 1.5894691209059517],
            [12.825482657125116, 1.594759996250439],
            [12.81742534712379, 1.5981784534338177],
            [12.812346035457386, 1.5981433731346606],
            [12.804199817771197, 1.5963062764873628],
            [12.801633446645221, 1.598409234212519],
            [12.792607346659954, 1.6001576802052173],
            [12.789684939986325, 1.6034541822309194],
            [12.79057558439359, 1.6091748856522747],
            [12.786313713634529, 1.6248672389731351],
            [12.781747980583477, 1.625617210895365],
            [12.781130509740066, 1.6311211385297135],
            [12.777415070926306, 1.636999135624415],
            [12.772431496670249, 1.641421079740852],
            [12.769464487305305, 1.6414554644129307],
            [12.766361520857393, 1.645328547115402],
            [12.761580248149212, 1.6443553468053733],
            [12.755559100791249, 1.6472071627806217],
            [12.749403125108506, 1.6470335806144403],
            [12.74954885701195, 1.6472816868022717],
            [12.726889838047638, 1.78241273184441],
            [12.715190677479876, 1.8278642362318467],
            [12.724885412546717, 1.8529279520298052],
            [12.751031101570682, 1.9219078169985757],
            [12.774132126042842, 1.9831596061471484],
            [12.771328458831507, 2.016974033691637],
            [12.780770337647768, 2.0591143950214383],
            [12.776667140409213, 2.082879555602098]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.66815348572278, "lat": 39.46933794456556 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54077"],
        "coty_name": ["Preston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Preston County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01558642"
      },
      "bbox": [
        12.715190677479876, 1.5894691209059517, 13.076097566062748,
        2.120675400225142
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.84706694813617, 0.2743340571206841],
            [10.854763890859473, 0.2735396313469308],
            [10.861600726512709, 0.2746769152691361],
            [10.864461900375979, 0.27811884612877236],
            [10.86630548893544, 0.2847219283667359],
            [10.867786962241036, 0.2941774294158447],
            [10.866287842347965, 0.30502872606983666],
            [10.86207047274129, 0.3115952789453857],
            [10.859912732941867, 0.32146658129351735],
            [10.857009559420435, 0.32488077273866134],
            [10.857352564873485, 0.3299955506791999],
            [10.860268762131426, 0.33876750052825555],
            [10.86285585446941, 0.34393731071898365],
            [10.862437151487851, 0.3478025242745317],
            [10.858815530896363, 0.35318787726763773],
            [10.857237611818345, 0.35820907645865935],
            [10.850216885352477, 0.36293300279033625],
            [10.84543793151374, 0.36919668217276363],
            [10.839742517929583, 0.3707429001545022],
            [10.838332051587361, 0.37264367854828384],
            [10.836329045436624, 0.3855935947643414],
            [10.835852809010444, 0.392622450335348],
            [10.837604507478902, 0.400014524642016],
            [10.836781790808573, 0.40849751285271085],
            [10.831117411172567, 0.4163206626401874],
            [10.83051307711602, 0.4207550354097208],
            [10.8333084282442, 0.42591882951225085],
            [10.829830120408051, 0.43775855116675616],
            [10.829308713834045, 0.4455825329947799],
            [10.830872703699372, 0.4500269229077461],
            [10.8313778431398, 0.446458664585017],
            [10.836689800996316, 0.4415924628959009],
            [10.843991288781359, 0.4375733366885257],
            [10.850041925446517, 0.4357359893885197],
            [10.858571081783586, 0.4365181650962281],
            [10.867077197252877, 0.43618630341558456],
            [10.874386696278727, 0.4377012880878663],
            [10.882329573316364, 0.44038042961871543],
            [10.89835481480061, 0.44838085052062976],
            [10.93829341505973, 0.42314286277876934],
            [10.965011083564182, 0.4066805190885227],
            [11.031801804640331, 0.3649208955419543],
            [11.039405493434236, 0.3609619950050181],
            [11.048001938152293, 0.36844443487231293],
            [11.049897225404013, 0.3723420755807686],
            [11.048953681657503, 0.38090466352687363],
            [11.053112819476187, 0.38525386644658866],
            [11.056807682077181, 0.3849782239295512],
            [11.061806574256808, 0.38859368738838346],
            [11.071597606238504, 0.3883134726903191],
            [11.070435953447856, 0.385965348007579],
            [11.07362042347777, 0.38304307960920597],
            [11.081957512952187, 0.3812632593157334],
            [11.080394021465972, 0.37588827174986356],
            [11.084542974830544, 0.376687011747194],
            [11.088626070391296, 0.3741580826550144],
            [11.091664415627193, 0.3671733417477199],
            [11.087154865205257, 0.36394025914046063],
            [11.080742946840143, 0.365810637069644],
            [11.076773325675795, 0.3640484778183854],
            [11.076145778863657, 0.3607931867501191],
            [11.071891406264328, 0.3592971343616515],
            [11.070310218080008, 0.355256643689369],
            [11.07373216339967, 0.3480851442889943],
            [11.070782034233192, 0.345817368056297],
            [11.071123742792528, 0.34262831317890313],
            [11.06875172142347, 0.3343846295746409],
            [11.069816305060865, 0.3319462980503414],
            [11.068242397803935, 0.32728459955907657],
            [11.072483879439185, 0.3229040610174656],
            [11.071508200448369, 0.3155843026903098],
            [11.077041878348178, 0.30888833659115406],
            [11.08147451301337, 0.30648678624211634],
            [11.083312488235993, 0.30066291603090856],
            [11.091053005506879, 0.29542781462149226],
            [11.093016229580135, 0.2969823869052223],
            [11.09765804211572, 0.29323751772012685],
            [11.100924959781784, 0.29420526670632213],
            [11.103311322297664, 0.29153588388278256],
            [11.108532468068082, 0.29575150457694693],
            [11.111261496648122, 0.29383017698977576],
            [11.110463686511984, 0.2812678261852148],
            [11.112761202164936, 0.2750856070019283],
            [11.104692201661317, 0.2688618691664582],
            [11.106394665527752, 0.2602408953866792],
            [11.112107046297334, 0.25020811787128555],
            [11.110200178518424, 0.246580712694213],
            [11.113649118260232, 0.24226179445755502],
            [11.10968806091634, 0.23864486236790433],
            [11.111201439854415, 0.23469135681404865],
            [11.114698716498179, 0.23333155765027982],
            [11.110542836418773, 0.2238749738893541],
            [11.110749394301283, 0.21551505070777421],
            [11.107891872927883, 0.21543033998681235],
            [11.107448773424505, 0.2073076958508878],
            [11.110821946296953, 0.20402539818951757],
            [11.116274461755431, 0.20455073850684777],
            [11.119069392783377, 0.20273164624046613],
            [11.125014332813626, 0.20189755043250038],
            [11.131598449281517, 0.19717308519407567],
            [11.12930499861999, 0.18726419048980306],
            [11.125902289571266, 0.18397088509924706],
            [11.126151555168313, 0.17913041755727319],
            [11.131179541794705, 0.1725526229312179],
            [11.137297763377413, 0.17044427864328338],
            [11.13908629262542, 0.1669341237545719],
            [11.144057750347667, 0.16895545410195664],
            [11.148949290447218, 0.1646312926189377],
            [11.151391746186887, 0.1601951485819633],
            [11.15275494781527, 0.14878778741308107],
            [11.155549243568089, 0.14832171632941632],
            [11.156268463459517, 0.14422213260553676],
            [11.15985794354191, 0.14550499178816712],
            [11.162979959413013, 0.13950169481924596],
            [11.169223695792928, 0.13964770131242946],
            [11.181028983886025, 0.13738101257257163],
            [11.179363752988085, 0.13483322638178635],
            [11.180844486600765, 0.12947844922393664],
            [11.177197773271816, 0.12792400684931374],
            [11.179837231382656, 0.12303548462640514],
            [11.183436495111241, 0.12090501305196188],
            [11.187060773310925, 0.12260442666601279],
            [11.193831423106207, 0.11924303430162249],
            [11.189791735414556, 0.11450351017520673],
            [11.19013019668971, 0.1105452479941695],
            [11.187653727174112, 0.1080103597585192],
            [11.18833396346835, 0.10302334172296844],
            [11.185467246617806, 0.10039988707528169],
            [11.187337741798467, 0.09614610669852217],
            [11.18406511445897, 0.09169583317878319],
            [11.178217044138243, 0.09016085349275604],
            [11.167140700298582, 0.07195776509381353],
            [11.16115389022498, 0.06816111178503567],
            [11.159094278489867, 0.06179614400365753],
            [11.15644576558596, 0.059594806008629764],
            [11.141196555210978, 0.03670769942720976],
            [11.13096856880332, 0.017087002737764933],
            [11.120684604132853, 0.003808365165583382],
            [11.057065277117733, -0.0877754710872465],
            [11.061902086125253, -0.09493765896462056],
            [11.061402271900839, -0.09848669530888267],
            [11.067997578466342, -0.10043474972698282],
            [11.069240515898224, -0.1038173055840529],
            [11.067209713304116, -0.1072024697709907],
            [11.062425830383225, -0.1076255570429617],
            [11.05824451562671, -0.10186968196414567],
            [11.054571171860726, -0.1028148983473274],
            [11.04960476231871, -0.09638407706386892],
            [11.041840924930794, -0.09267335992763993],
            [11.042445618001551, -0.08882688877875075],
            [11.052590399652448, -0.08548567202432622],
            [11.05160779425109, -0.08240216989756136],
            [11.045966300606647, -0.08250613383310326],
            [11.043793184180572, -0.0795387859190314],
            [11.042342043609299, -0.07031967447599294],
            [11.039022492821772, -0.0661205041255729],
            [11.031230382288095, -0.06393028945229629],
            [11.025105556088869, -0.05429930687659276],
            [11.017456665325376, -0.05168025979337911],
            [11.01289816412916, -0.04739081551132637],
            [11.006848355767422, -0.04740900486790873],
            [11.003856424879746, -0.042435333588757666],
            [11.000235932512293, -0.04359508146993504],
            [10.999719842005714, -0.04697638284636832],
            [11.001337069193589, -0.054288567203575944],
            [10.999750772715776, -0.05880156604034047],
            [10.995133975262528, -0.05560797547849202],
            [10.996048989683711, -0.05046902442211199],
            [10.994484758731728, -0.046723775704288935],
            [10.991144107397536, -0.044262279629563854],
            [10.984638236521862, -0.043305548817305056],
            [10.983682219430754, -0.04050240432395325],
            [10.988487567518135, -0.034975978073069895],
            [10.987445199543359, -0.03259022687503155],
            [10.97756261805896, -0.0340006299736748],
            [10.975432091103148, -0.033459725638002334],
            [10.970846055494409, -0.028575387508985903],
            [10.971751609550394, -0.024910241072456332],
            [10.978421987197791, -0.024747682795935266],
            [10.979457550853402, -0.02104031296114991],
            [10.973859397725358, -0.01940320292412589],
            [10.972536947339192, -0.015643266707598084],
            [10.974245004730468, -0.014256690230856484],
            [10.980199744227306, -0.014755235023256024],
            [10.984964316332217, -0.01014764846759018],
            [10.990813367682984, 0.000809015669936872],
            [10.989713736578347, 0.0023509947623856927],
            [10.980591107287406, 0.0037190985348670297],
            [10.979229436372961, 0.011725947756735291],
            [10.980832345805892, 0.013562159284506655],
            [10.990487941448347, 0.015048499381038617],
            [10.993337914496163, 0.019333631942419927],
            [10.991784779592539, 0.027130377774044652],
            [10.985686724406065, 0.02822521161973484],
            [10.97763599355645, 0.024463594710330036],
            [10.975058732056045, 0.030641774740870844],
            [10.974429801671562, 0.0358502523405776],
            [10.971435906137001, 0.03876260695443581],
            [10.962520419140299, 0.037538191608237376],
            [10.957199401340045, 0.03930936967244892],
            [10.951948253437509, 0.03622917837283194],
            [10.947987081376505, 0.03760463411690839],
            [10.950259162863013, 0.04161974906643996],
            [10.946518885191253, 0.04478437030291887],
            [10.940229175083266, 0.05529996206404815],
            [10.939263753832668, 0.06214141772934616],
            [10.931357522243514, 0.06697456697384763],
            [10.927797588639843, 0.07170072788934036],
            [10.927721621730157, 0.07966966717309507],
            [10.924208699664439, 0.08247371147570874],
            [10.920651400822, 0.08790119336723136],
            [10.91998975990032, 0.09215119634235884],
            [10.915825171197762, 0.09619070696480662],
            [10.913293931779153, 0.10372096956239678],
            [10.906567801320822, 0.10484189870169185],
            [10.900720479634645, 0.1119687069674239],
            [10.894076991549845, 0.11251691789887557],
            [10.885171680959864, 0.1199809488936198],
            [10.883543189942097, 0.12341428559631057],
            [10.88157195953625, 0.13613567168625582],
            [10.874921614305109, 0.13913420402913723],
            [10.870805139995092, 0.14370661830911885],
            [10.863490687456355, 0.14768470856088636],
            [10.856204820095034, 0.14601712924653867],
            [10.851908880728232, 0.14848636048060362],
            [10.850665885041364, 0.15724154355962874],
            [10.846396048617514, 0.1595321154448193],
            [10.839902723813427, 0.16048311123435732],
            [10.837220562423495, 0.1625318058164138],
            [10.835834867967607, 0.1668649821600503],
            [10.833451785007103, 0.18004213311136813],
            [10.827749349360607, 0.18815412440221008],
            [10.828516152043159, 0.19241651300411902],
            [10.831335789191943, 0.1944003386330535],
            [10.841905092613487, 0.19526138046034486],
            [10.846759111503887, 0.19445600407006644],
            [10.852634685498591, 0.19786013929675497],
            [10.855819388090573, 0.21472340481565472],
            [10.858252778054958, 0.22485186700590626],
            [10.85607643990247, 0.2451067704400952],
            [10.847094018276925, 0.25022410401292144],
            [10.842795284710949, 0.26072434245796533],
            [10.84532565980946, 0.27273258629706054],
            [10.84706694813617, 0.2743340571206841]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.42700114368179, "lat": 38.14591446540679 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54099"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01550056"
      },
      "bbox": [
        10.827749349360607, -0.1076255570429617, 11.193831423106207,
        0.4500269229077461
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.02242883952384, 8.377130363577475],
              [4.027896961838806, 8.38169928270097],
              [4.027599739708757, 8.385020805379016],
              [4.032746852924604, 8.386683776965072],
              [4.034576909386817, 8.38535796071079],
              [4.032725780048025, 8.376345070318758],
              [4.025400543128589, 8.374390438813109],
              [4.02242883952384, 8.377130363577475]
            ]
          ],
          [
            [
              [3.971503267673978, 8.39365514872888],
              [3.9733341350102505, 8.394524060923995],
              [3.97677987095826, 8.389620330702103],
              [3.982234052511067, 8.388312364742568],
              [3.9868655668350006, 8.389962809938671],
              [3.990519416146897, 8.388824361033635],
              [3.9875280406145515, 8.379794583962612],
              [3.985246229215932, 8.37967233349738],
              [3.9776222423469116, 8.386146512401496],
              [3.973387863336579, 8.387487443502065],
              [3.971503267673978, 8.39365514872888]
            ]
          ],
          [
            [
              [3.900465786465391, 8.380882843476831],
              [3.9009605757397376, 8.384541643359933],
              [3.9085827767209795, 8.388070650914727],
              [3.9185915283324855, 8.390743696709713],
              [3.922494120404478, 8.39006629835844],
              [3.9306464242878016, 8.39655160253471],
              [3.9305792296409714, 8.403107621703082],
              [3.9351406251265226, 8.402354384044797],
              [3.9373480671262713, 8.394713211522303],
              [3.9407540658824622, 8.388661719242707],
              [3.9337383358824036, 8.38292320665399],
              [3.9340759136654975, 8.378584889329487],
              [3.9373541233355986, 8.36826806561418],
              [3.9364834992615285, 8.363982925877924],
              [3.926612437551826, 8.363005749833134],
              [3.922029662499038, 8.364224340824167],
              [3.9160880611569944, 8.361278713572382],
              [3.913344876222945, 8.361851819330903],
              [3.9094956210322636, 8.369686279416023],
              [3.90735273730013, 8.37141536517359],
              [3.902932459532883, 8.370563681289495],
              [3.9000818501047982, 8.378044094837895],
              [3.900465786465391, 8.380882843476831]
            ]
          ],
          [
            [
              [3.522018141664709, 8.138722307190312],
              [3.5318780097009532, 8.138313416909995],
              [3.5496399603747357, 8.141773115350286],
              [3.5572792565854567, 8.145872674403838],
              [3.5620149264389482, 8.151445756312103],
              [3.5771888279096427, 8.154379671815233],
              [3.5913019329072795, 8.159383329287971],
              [3.598481838891522, 8.162718415567978],
              [3.6016157063885563, 8.166784572514912],
              [3.606015884725029, 8.16699413474379],
              [3.611255098497059, 8.173643709363922],
              [3.6167934735572707, 8.177257663526218],
              [3.6183633183732646, 8.18128413332594],
              [3.6284984955826745, 8.177721807883124],
              [3.634010948373651, 8.1773953872498],
              [3.635191604576818, 8.179895298135365],
              [3.6430518594994874, 8.181025118364108],
              [3.6477777737085106, 8.18348803492183],
              [3.6525797199797885, 8.188905350398766],
              [3.6563473181562, 8.196175798124589],
              [3.6654134536405185, 8.206769009946138],
              [3.681047889083299, 8.216532609879552],
              [3.6894652458768373, 8.22041620314591],
              [3.697657883188826, 8.221011254656696],
              [3.698659811855309, 8.223923506438513],
              [3.7078885517679967, 8.223586765733595],
              [3.7142803988932753, 8.225189753067495],
              [3.7204190682653238, 8.22839741218875],
              [3.7242545546118153, 8.232779476695766],
              [3.7357083091626353, 8.251998662943262],
              [3.743618056939659, 8.257972316942494],
              [3.75020105792585, 8.259293194118513],
              [3.756245266500504, 8.26393285980667],
              [3.766075643321897, 8.27887040781659],
              [3.770787617885985, 8.27910692791592],
              [3.7679163934459496, 8.271005173153352],
              [3.761680896126457, 8.266760505198347],
              [3.7603885519689157, 8.261841041274272],
              [3.7551724182362634, 8.251765631743973],
              [3.758384413815435, 8.247190477873511],
              [3.765420768857086, 8.242009527869385],
              [3.773838194376278, 8.238335418974929],
              [3.78114587994794, 8.239197483999664],
              [3.782684488083296, 8.24932335032192],
              [3.7899838364280347, 8.25060244949662],
              [3.7927395480577575, 8.252921613201305],
              [3.795852360058463, 8.265144648307668],
              [3.7985165049550487, 8.268141117686195],
              [3.803343495069788, 8.265563619695184],
              [3.801643713435618, 8.256235099588656],
              [3.8028175246221187, 8.254331800426186],
              [3.811079655330669, 8.251975217263455],
              [3.823087915666636, 8.25401462777515],
              [3.8290073624111294, 8.25817542064976],
              [3.8300193111077054, 8.27633663308382],
              [3.8317940236109274, 8.279178389025184],
              [3.838576399639246, 8.280452242405772],
              [3.8427942006981888, 8.279131274045604],
              [3.8475767228212105, 8.275684520448374],
              [3.857860105138476, 8.279189887582351],
              [3.8664298766543417, 8.287432320140441],
              [3.8684428969518936, 8.291842326208183],
              [3.8693930106412053, 8.301224221866422],
              [3.879489251259615, 8.310083263988178],
              [3.8887956680292572, 8.315204849614915],
              [3.895608825150023, 8.316915352764143],
              [3.902402573898072, 8.325187000784407],
              [3.909016529524724, 8.341022630483923],
              [3.914974018087506, 8.34377730546752],
              [3.92232917210367, 8.338885168068304],
              [3.926452324223174, 8.33887715527182],
              [3.9387917583843026, 8.33378647880537],
              [3.945118949835993, 8.333076277210598],
              [3.9504690055249965, 8.335409568350915],
              [3.9536363631401024, 8.3433756611095],
              [3.9590985406344537, 8.347051182644888],
              [3.966584764627369, 8.349825755183433],
              [3.9719982104148572, 8.354587707121944],
              [3.972579740766186, 8.360938555573943],
              [3.9830971261625443, 8.366012186798056],
              [3.9886138045831174, 8.365883516797473],
              [3.9950563510460735, 8.362720612135018],
              [4.001302960198261, 8.361836156782845],
              [4.005601485474501, 8.35854898448943],
              [4.0075742532555125, 8.353409369463622],
              [4.00705143638514, 8.346399917820502],
              [4.007676009323994, 8.34099097742879],
              [4.011441633317549, 8.33783083319347],
              [4.018306047284737, 8.336680099933657],
              [4.0243869524035984, 8.343742135146758],
              [4.028335561212819, 8.343507114693018],
              [4.033815425578336, 8.340257648195532],
              [4.038669544208269, 8.3332678969936],
              [4.040756378970507, 8.32759280701355],
              [4.041090199995019, 8.319205556314499],
              [4.0431666214904585, 8.316324826804767],
              [4.051829884617038, 8.315937204827016],
              [4.061484962466743, 8.306725097429506],
              [4.0643037691142725, 8.301713350555952],
              [4.064464003258497, 8.296716912079393],
              [4.062095712648751, 8.293544932520618],
              [4.05750669382176, 8.291606692177025],
              [4.053439171637979, 8.29301405700829],
              [4.0471004690732375, 8.292682500999346],
              [4.051316408292423, 8.288531441825468],
              [4.05198713107349, 8.284521742449991],
              [4.050611354004948, 8.27938289467972],
              [4.045529134976893, 8.267088932405361],
              [4.040330893259717, 8.26117646104583],
              [4.0409066509476705, 8.253622253109043],
              [4.0432154886597, 8.250204068835322],
              [4.037797739389389, 8.243168866530397],
              [4.038235253999146, 8.240226256145194],
              [4.034892176799292, 8.231145578897728],
              [4.026574883396687, 8.221229781938437],
              [4.025052573919816, 8.216006818629108],
              [4.020660024838803, 8.214405137030928],
              [4.017584958712814, 8.211170727504499],
              [4.016582485286863, 8.204737642313681],
              [4.011815325975156, 8.196921655847055],
              [4.006057556774347, 8.195808219538296],
              [4.00140939089732, 8.196842134285365],
              [3.9975011369373963, 8.195289653705139],
              [3.9931366747339108, 8.186840728974124],
              [3.9963034260059063, 8.180513066428803],
              [3.9946355979612624, 8.174647035674912],
              [3.9919159704096545, 8.170821051659908],
              [3.9796902013276316, 8.162201631730653],
              [3.9813075382523877, 8.153050192526852],
              [3.9915095250720056, 8.130193381495985],
              [4.004943729795505, 8.107491244103317],
              [4.0045008005385245, 8.10141662106856],
              [3.998007825660632, 8.093386408339365],
              [3.9951418675761152, 8.087990852366628],
              [3.989533638738708, 8.085278363980603],
              [3.9836490150938935, 8.077662913782417],
              [3.9800625153751215, 8.075007612744491],
              [3.9711763745223956, 8.072721810187023],
              [3.966419526034272, 8.069682946599404],
              [3.9643431698146414, 8.065342904461293],
              [3.9646745854701995, 8.053297613659126],
              [3.961218937617289, 8.04353219473818],
              [3.9612591950872718, 8.034228223109508],
              [3.958485184166049, 8.031326123268451],
              [3.956820003308539, 8.02480136327975],
              [3.952250027097745, 8.019186403794786],
              [3.9504154693437585, 8.014878244548918],
              [3.9439151286641, 8.010144218053277],
              [3.942177870830298, 8.006695209951795],
              [3.94779086049661, 7.9938557505339105],
              [3.9506178236826086, 7.9946473630725325],
              [3.9599237972010966, 7.992032301332258],
              [3.963997080225899, 7.910184263063506],
              [3.9661798164225184, 7.910297814570049],
              [3.967291404300615, 7.89048163525506],
              [3.967387125191006, 7.880171498812277],
              [3.96987178118775, 7.8341201295480145],
              [3.9706668894564254, 7.826298518392617],
              [3.97336943678612, 7.780958307594799],
              [3.975585234165776, 7.7372280626163645],
              [3.9760836329219615, 7.710453704216499],
              [3.9750389315618246, 7.695225204998585],
              [3.9767229236854673, 7.680470640308244],
              [3.9791047293352086, 7.669254494843899],
              [3.979788757596425, 7.6533029847809715],
              [3.984548359597137, 7.567230624556071],
              [3.9554813199261147, 7.5662289066452235],
              [3.9431019968132115, 7.565084153320701],
              [3.8454748992547714, 7.560836762881445],
              [3.810487969481825, 7.560851778264702],
              [3.7668908282832483, 7.559316361732848],
              [3.7524963881955724, 7.558152682065647],
              [3.7377870278920047, 7.557722578277461],
              [3.723083479485802, 7.556009173420936],
              [3.674484706211421, 7.553542448705555],
              [3.6367004621660377, 7.55183478591243],
              [3.5935834187309874, 7.550208332429358],
              [3.5789931044829015, 7.549028562758923],
              [3.564367602795994, 7.5493025081599585],
              [3.550034802884403, 7.548037121104734],
              [3.5462542844627634, 7.63397069522285],
              [3.5449030827572883, 7.659270943941871],
              [3.542048523722381, 7.719925352120557],
              [3.5389023908857067, 7.782242479265569],
              [3.5354729034070234, 7.848196607931107],
              [3.5336840102273714, 7.888970254809735],
              [3.5324058155793314, 7.889400357735979],
              [3.5314095398357264, 7.903958170252147],
              [3.5300633542871203, 7.9409579393312875],
              [3.5296361231466533, 7.94628517951564],
              [3.52711450260899, 8.008482475276852],
              [3.5272524163655765, 8.013808166751359],
              [3.5259806999258627, 8.04584429966255],
              [3.521937143368414, 8.132765325869489],
              [3.522018141664709, 8.138722307190312]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.20088497088214,
          "lat": 46.523635527882114
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55007"],
        "coty_name": ["Bayfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bayfield County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01581063"
      },
      "bbox": [
        3.521937143368414, 7.548037121104734, 4.064464003258497,
        8.403107621703082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1687221089990443, 6.590848200410024],
            [3.251447780047418, 6.593522733337623],
            [3.2765415263300848, 6.594631606793042],
            [3.3439460749859906, 6.597003202726307],
            [3.3878517425413337, 6.598901754568687],
            [3.399774733354449, 6.599088559704907],
            [3.455777305717397, 6.601847004885405],
            [3.5139927042824746, 6.604057803645453],
            [3.5152634710283865, 6.574937780186085],
            [3.517438447078955, 6.517448853909977],
            [3.5279701544329214, 6.517539826623544],
            [3.5295236970923822, 6.479597733256413],
            [3.53330703796963, 6.4069011495197525],
            [3.5357430995253436, 6.356070249736472],
            [3.540801421198937, 6.254651404708064],
            [3.5431157009325243, 6.21370932969199],
            [3.544852679088084, 6.179578764271968],
            [3.548766133622383, 6.083189524510723],
            [3.4149786114657537, 6.077326092258098],
            [3.3769322011088305, 6.075851022879076],
            [3.337286922375668, 6.074073188558296],
            [3.280775631201363, 6.07179777420801],
            [3.205058952414355, 6.069149858075777],
            [3.2018092187307063, 6.140995096106353],
            [3.2007152523368663, 6.155876479553147],
            [3.199054452897902, 6.19891384650123],
            [3.1971831909455286, 6.241774169066529],
            [3.1961532683994847, 6.27052640471838],
            [3.1948590770490384, 6.317399414275666],
            [3.1915746367807323, 6.383129691446701],
            [3.1895602620925874, 6.425647378432022],
            [3.1882400532719544, 6.4581435390232995],
            [3.1866239673521366, 6.503828176741884],
            [3.1718533149967496, 6.503451834044765],
            [3.171489633282216, 6.51723376856342],
            [3.1687221089990443, 6.590848200410024]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.89641226879178, "lat": 44.94654510543948 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55033"],
        "coty_name": ["Dunn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dunn County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01581076"
      },
      "bbox": [
        3.1687221089990443, 6.069149858075777, 3.548766133622383,
        6.604057803645453
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.049967448675153, 5.4666757711605305],
            [5.113303613908009, 5.470858413615067],
            [5.241324743664299, 5.480286229212832],
            [5.242927898807839, 5.480228152175077],
            [5.29806402738677, 5.48413565350944],
            [5.333510079459668, 5.487065271679456],
            [5.356965647140383, 5.488720255368903],
            [5.357206521820066, 5.488410973353978],
            [5.3616509637668806, 5.430038897101583],
            [5.3624156897148305, 5.423027246470537],
            [5.362878075610968, 5.408198457002395],
            [5.36498480528699, 5.382731680368602],
            [5.343351000928361, 5.381226319049045],
            [5.347775827304455, 5.322862562170107],
            [5.350606812898182, 5.319969662569848],
            [5.34827710407113, 5.316520825451627],
            [5.352588986797107, 5.310460080735111],
            [5.358092105195238, 5.309925285526278],
            [5.363669302317197, 5.314563227801202],
            [5.369842995612277, 5.316582225929349],
            [5.373375379159612, 5.272132437139683],
            [5.367968823411312, 5.272722378893579],
            [5.3606854818741905, 5.270424697527702],
            [5.356573525421042, 5.271492085562976],
            [5.344037197266869, 5.270034004357942],
            [5.3341490774313165, 5.270032646829294],
            [5.330251121497832, 5.27146263862703],
            [5.324248558958131, 5.270841792241816],
            [5.3191864343924635, 5.26604286048075],
            [5.317973139886136, 5.262459307740185],
            [5.319899672442611, 5.2333408133554435],
            [5.3227994319354375, 5.195046553907006],
            [5.326252851112729, 5.146005614240554],
            [5.267097008564453, 5.141510112869428],
            [5.257723768410949, 5.14043914461709],
            [5.226056818574077, 5.1385710090023275],
            [5.14385768301743, 5.132765721483057],
            [5.099794450092426, 5.129822645232151],
            [5.099478509952815, 5.1301141247946145],
            [5.071760519081522, 5.127987876482289],
            [5.069716905790692, 5.156972812155906],
            [5.066172046515589, 5.215889211288952],
            [5.0638310186641275, 5.251846428730617],
            [5.060671222285878, 5.31019928052099],
            [5.059097401896134, 5.33204611679349],
            [5.058576957087473, 5.34567675555785],
            [5.057113051041045, 5.368193275925652],
            [5.049967448675153, 5.4666757711605305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.39872605483203, "lat": 43.8195373362212 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55077"],
        "coty_name": ["Marquette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marquette County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01581098"
      },
      "bbox": [
        5.049967448675153, 5.127987876482289, 5.373375379159612,
        5.488720255368903
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.8749224341413773, 5.141219453401209],
            [3.937114162994875, 5.144025585984756],
            [3.9523739280679187, 5.145014427064466],
            [3.982074270969919, 5.14592575128838],
            [4.042344270493028, 5.149103318538633],
            [4.071751171157777, 5.15089354738788],
            [4.124400401600818, 5.153754920840178],
            [4.199785626919955, 5.157937877814627],
            [4.236087238860062, 5.16012571887815],
            [4.300758068947954, 5.164487519254232],
            [4.34250574888451, 5.166397768786489],
            [4.342324447828099, 5.17001884628137],
            [4.356560338028888, 5.170741534890127],
            [4.356776083181206, 5.167048280745873],
            [4.381753669418911, 5.168292769096898],
            [4.467677883815526, 5.173501436998707],
            [4.5096709871009155, 5.178642877027071],
            [4.525671855638346, 5.180852488329497],
            [4.55400339727921, 5.184194280343939],
            [4.558660712488026, 5.10081343000576],
            [4.559287768473193, 5.093832398111646],
            [4.5644420344905, 5.022674858036461],
            [4.565475421097508, 5.006998339532692],
            [4.526394468683594, 5.004791685142476],
            [4.446154645058131, 4.999374481985073],
            [4.410023622341277, 4.996749685156885],
            [4.305839604965898, 4.990852759718327],
            [4.308563262872092, 4.953296896355297],
            [4.3130028170647705, 4.90445552760809],
            [4.315380988289087, 4.8611925292827545],
            [4.300780004585308, 4.859652131909766],
            [4.28338050860821, 4.859849718791011],
            [4.258912572715656, 4.859618515765637],
            [4.2439139795160905, 4.857278164387901],
            [4.208054885563112, 4.856120643377211],
            [4.15775225877293, 4.853382109798287],
            [4.09932323972516, 4.850384177675131],
            [4.055302984539064, 4.847634639483659],
            [4.010637233288233, 4.845276097939267],
            [3.9986953539925234, 4.844387263610908],
            [3.9277884534630396, 4.840554438330911],
            [3.926532015926377, 4.842578950718372],
            [3.9099018409598267, 4.862300937371041],
            [3.9060847760766153, 4.8717640732869825],
            [3.9066529153251417, 4.876654016341807],
            [3.911898234507241, 4.882436620945176],
            [3.9146270022373524, 4.888367956747304],
            [3.9176362422771662, 4.902042160745052],
            [3.9156397579344295, 4.908166124481999],
            [3.915091965080603, 4.917702139268153],
            [3.9147439465526, 4.9296351062294],
            [3.910678213911817, 4.934861054839985],
            [3.9029267202414246, 4.940561097589038],
            [3.899747967163442, 4.949384300971899],
            [3.8947225025041776, 4.956527852829446],
            [3.8938201742063403, 4.965322107357292],
            [3.8958102264334435, 4.971298444463091],
            [3.90096097413512, 4.981422744848167],
            [3.9013716430909446, 4.9922176759211965],
            [3.9007878572833268, 4.998427678772984],
            [3.8951712357914787, 5.0061003036322305],
            [3.8846891392227465, 5.016200671972408],
            [3.8806870388447376, 5.019128323118625],
            [3.8754488798913846, 5.025372963904551],
            [3.8725475836576306, 5.030609718879155],
            [3.8721570787408104, 5.042615864981719],
            [3.875413759151736, 5.053647624244386],
            [3.8744526106400254, 5.06307513939992],
            [3.8684102454542835, 5.070054487019993],
            [3.8667450117881113, 5.08168523807407],
            [3.866613973894046, 5.091680856533302],
            [3.8692216893724125, 5.110882993051053],
            [3.8680367208780506, 5.125017517969159],
            [3.8692087163281648, 5.129204762729893],
            [3.872685129856336, 5.134928520882322],
            [3.8749224341413773, 5.141219453401209]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.83440940214105, "lat": 43.59387709883695 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55123"],
        "coty_name": ["Vernon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vernon County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01581121"
      },
      "bbox": [
        3.866613973894046, 4.840554438330911, 4.565475421097508,
        5.184194280343939
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.12741236894381, "lat": 18.25109893869492 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72007"],
        "coty_name": ["Aguas Buenas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Aguas Buenas Municipio"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01804483"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.25646528087805, "lat": 18.0128046277778 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72123"],
        "coty_name": ["Salinas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Salinas Municipio"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01804542"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.279025810963892, 9.821270397433395],
            [-12.27264592168732, 9.819479318022951],
            [-12.27060222121954, 9.814543968365633],
            [-12.256684242638471, 9.807883954272942],
            [-12.24954396927438, 9.810353545189116],
            [-12.240053912971844, 9.807433731521167],
            [-12.231984830772706, 9.802533492461544],
            [-12.22719136984838, 9.796343599311518],
            [-12.22267252949852, 9.795952050973414],
            [-12.218610936573926, 9.800726921350545],
            [-12.215799143049558, 9.80182330048043],
            [-12.210818845697174, 9.807628812360901],
            [-12.20437355814715, 9.811988718952515],
            [-12.201224805714746, 9.809517384854876],
            [-12.193855512166737, 9.807515292933738],
            [-12.187278988561408, 9.80318067034399],
            [-12.184050340900615, 9.803993682114124],
            [-12.179861857674956, 9.802647598855353],
            [-12.172891162744238, 9.798303330925922],
            [-12.168180139397304, 9.799023792107798],
            [-12.164909528214285, 9.795174838500472],
            [-12.159426339903638, 9.791304015464497],
            [-12.149975601137733, 9.787460698088061],
            [-12.144967540944569, 9.783127570429468],
            [-12.136484695355545, 9.781170865943489],
            [-12.12554839363574, 9.776862712851269],
            [-12.123277798262372, 9.773658680601681],
            [-12.117151995403677, 9.772340034537013],
            [-12.117548570894822, 9.770349258069096],
            [-12.114780080309284, 9.760301689215282],
            [-12.107262683429814, 9.759094828954261],
            [-12.105252430323056, 9.755034911547938],
            [-12.10213859006673, 9.753012315883652],
            [-12.099052745909955, 9.74722066232913],
            [-12.093951180791414, 9.743440149634685],
            [-12.089154135612699, 9.74243488228906],
            [-12.087539844476392, 9.738484392687747],
            [-12.083675686379642, 9.734339699506044],
            [-12.07684255944623, 9.732877116756757],
            [-12.073527231470061, 9.730482217023651],
            [-12.068947290904262, 9.73061676947373],
            [-12.06314177961909, 9.725287639161504],
            [-12.059805141446905, 9.717657858884344],
            [-12.055942198594053, 9.719161409871361],
            [-12.048753633263214, 9.718624322327575],
            [-12.04696589461734, 9.71658668241081],
            [-12.040412617807277, 9.7158478411753],
            [-12.034671332780649, 9.708624667757224],
            [-12.029213014120591, 9.700437536218624],
            [-12.024248064097737, 9.69888859479366],
            [-12.019478257112024, 9.694882890207866],
            [-12.016084857033698, 9.689121966864978],
            [-12.008312407094929, 9.688111540597996],
            [-12.002428256320218, 9.685559811508812],
            [-11.997738254109658, 9.686728784759918],
            [-11.9944619377855, 9.679762844292103],
            [-11.9947649751305, 9.673206750366283],
            [-11.990627887948577, 9.668636807103125],
            [-11.993788454581454, 9.667115313950925],
            [-12.00017991287382, 9.667062949678],
            [-12.003029535104274, 9.659163414498227],
            [-12.00484466684658, 9.656831200483108],
            [-12.000089125308882, 9.65470035754626],
            [-11.99073674874309, 9.642469739488304],
            [-11.98522819562191, 9.640469959598189],
            [-11.980218683263193, 9.63135430594526],
            [-11.973193023033383, 9.629119846785702],
            [-11.968095245130874, 9.620003109634482],
            [-11.956009115272565, 9.61215144273318],
            [-11.950275469099477, 9.609527155466047],
            [-11.94385092009427, 9.607942235819852],
            [-11.935103356795336, 9.613102162359825],
            [-11.928927749557706, 9.618657361969877],
            [-11.92105237663312, 9.61521792665829],
            [-11.914074132508256, 9.609227138428894],
            [-11.909526120109689, 9.611473041000934],
            [-11.904267801408938, 9.616826785364603],
            [-11.900084258843851, 9.617553009703343],
            [-11.895355855752829, 9.616123120662332],
            [-11.854279047429594, 9.608169815449093],
            [-11.814675192636347, 9.600841500277607],
            [-11.774442423833976, 9.593107547479713],
            [-11.725023448051575, 9.583917693166557],
            [-11.716962855257263, 9.625770590085972],
            [-11.641708381468849, 9.611636432819404],
            [-11.625391436776734, 9.695402315426671],
            [-11.627521542123755, 9.69578476869226],
            [-11.62646539413088, 9.701303142338645],
            [-11.630586448575526, 9.701854644705366],
            [-11.634344749964065, 9.699920015232678],
            [-11.639257811617755, 9.701174047922683],
            [-11.640478111290085, 9.706704521700102],
            [-11.64452074311558, 9.709430280737097],
            [-11.645303102589482, 9.715394455004274],
            [-11.65099724841909, 9.720356648150725],
            [-11.655026320985696, 9.720365882177626],
            [-11.656299491404152, 9.726729380083203],
            [-11.654774736659013, 9.7310015895398],
            [-11.6565964607112, 9.736965840291315],
            [-11.65934299723218, 9.741043563970937],
            [-11.662366136629856, 9.74089668620443],
            [-11.669323061342086, 9.744026548233453],
            [-11.670387285473224, 9.748168905902848],
            [-11.660042789900306, 9.751342917673654],
            [-11.658257225140147, 9.761897313568848],
            [-11.65307738988979, 9.77024209954437],
            [-11.65465461044995, 9.77346635462058],
            [-11.654836007978927, 9.787016165672139],
            [-11.656780769590775, 9.791693458525586],
            [-11.65271147824972, 9.791505022603628],
            [-11.650268266530059, 9.799779171633473],
            [-11.643045106042015, 9.800777388922368],
            [-11.64158104952419, 9.805840512435108],
            [-11.637065637942461, 9.81330856431447],
            [-11.635962471506534, 9.82032827629748],
            [-11.637903448122705, 9.822260527894667],
            [-11.639441350414609, 9.82986687273814],
            [-11.643082080179395, 9.836735007108057],
            [-11.642906567482584, 9.840587110075134],
            [-11.644881018434884, 9.84673969209775],
            [-11.642204056396027, 9.853072774501497],
            [-11.641771172982912, 9.86101389744211],
            [-11.644119813937529, 9.863444323656669],
            [-11.643881061010443, 9.868282669461124],
            [-11.646503535905056, 9.871934735912669],
            [-11.647394892770672, 9.877943919892637],
            [-11.653657761826794, 9.881058061608382],
            [-11.656956801376598, 9.885860251103914],
            [-11.660963798724213, 9.887649164458034],
            [-11.664740168481597, 9.891156121257628],
            [-11.663366002939581, 9.89319996756262],
            [-11.663385861119977, 9.900365614978798],
            [-11.666753725789686, 9.905341511876836],
            [-11.670281334427997, 9.906459873225447],
            [-11.673837523346752, 9.911224430259967],
            [-11.667622534979342, 9.913701913186049],
            [-11.663787889309706, 9.921100005350791],
            [-11.664894109923273, 9.92626968085387],
            [-11.655461199667267, 9.931922514839195],
            [-11.653278503542337, 9.929383745413519],
            [-11.644473788221108, 9.93073395323266],
            [-11.640773133984101, 9.940248152084843],
            [-11.642101772397316, 9.944601479520136],
            [-11.649841004037912, 9.951103221578471],
            [-11.645294503216325, 9.96030342074738],
            [-11.64401029745283, 9.965713317337183],
            [-11.647581081503587, 9.96995183348933],
            [-11.645934368475968, 9.972633588120827],
            [-11.64163437015535, 9.973862299256183],
            [-11.639013377139339, 9.977797289682993],
            [-11.638393764522545, 9.986089374094052],
            [-11.64012474604603, 9.988876825735069],
            [-11.63909426671, 9.993837328986114],
            [-11.642398129177593, 10.003967655119432],
            [-11.640951354680896, 10.009354274111528],
            [-11.638168335468121, 10.01449145522793],
            [-11.63870013954892, 10.018184356252208],
            [-11.63643124339165, 10.02147311648598],
            [-11.63706907014259, 10.026318936654354],
            [-11.647762098345774, 10.026772819334317],
            [-11.649097940884266, 10.030068313144374],
            [-11.618589886255588, 10.024575974396283],
            [-11.520153201529318, 10.006187182163318],
            [-11.439201393045403, 9.99095196703069],
            [-11.327353199444698, 9.97040665394225],
            [-11.373391643745572, 9.726141847131618],
            [-11.38937957789873, 9.64130285649631],
            [-11.403779536086972, 9.565058946244116],
            [-11.365863469737862, 9.558224622562769],
            [-11.293838922647096, 9.545460134555723],
            [-11.309529518647851, 9.460931139226657],
            [-11.332947864187519, 9.336689974979512],
            [-11.35643154153196, 9.209845827121613],
            [-11.433240853051492, 9.223804047699137],
            [-11.438944791418157, 9.195232440384629],
            [-11.445625795110637, 9.196707093657713],
            [-11.481291408806854, 9.203271008571654],
            [-11.491884270194571, 9.147142733825007],
            [-11.536005637974514, 9.155169981310221],
            [-11.53852153876505, 9.141989753567453],
            [-11.54285070981496, 9.142794008812588],
            [-11.545509424888648, 9.128789433148139],
            [-11.62444810878308, 9.143118113881343],
            [-11.634988355710503, 9.087155134095154],
            [-11.720005214334385, 9.10279394781109],
            [-11.719519504066088, 9.105406049230568],
            [-11.742631105111704, 9.109764256372198],
            [-11.745765288369194, 9.110471898868731],
            [-11.833381768479741, 9.126769984507156],
            [-11.883317613131247, 9.136102707029288],
            [-11.974622113058356, 9.153749891195053],
            [-11.97474108313786, 9.153182397421556],
            [-12.052690388875295, 9.168179408558345],
            [-12.084163241196121, 9.17437809605724],
            [-12.087254676309682, 9.17683489947439],
            [-12.091800070441883, 9.177297757533191],
            [-12.097278156916488, 9.179861517202832],
            [-12.099683230704365, 9.185506039070459],
            [-12.11359090682314, 9.186625170624254],
            [-12.117634422243317, 9.183059431949768],
            [-12.125151912917039, 9.186570416518878],
            [-12.13276303388129, 9.182690266854582],
            [-12.136247496415745, 9.185065120329751],
            [-12.139261033821162, 9.181209660638189],
            [-12.146170845137062, 9.186432105600588],
            [-12.155503069980258, 9.183324880957061],
            [-12.165193226458571, 9.178867430032481],
            [-12.168004194513216, 9.179198463339718],
            [-12.169644321815241, 9.174499612859675],
            [-12.168827807748372, 9.172003893906453],
            [-12.18056518775168, 9.164145751871555],
            [-12.189953412141696, 9.166093664434321],
            [-12.194019314033598, 9.168128753126105],
            [-12.200327303169125, 9.173895521997377],
            [-12.20178480631098, 9.177884399112648],
            [-12.207132517161694, 9.176961026032632],
            [-12.215642332146945, 9.179404766783604],
            [-12.220048377898586, 9.182405429116832],
            [-12.222261453465435, 9.186559225013756],
            [-12.227962605459341, 9.191305139913906],
            [-12.232107293939885, 9.187132854707963],
            [-12.2379204894593, 9.188180160305343],
            [-12.243867831228217, 9.185572709113124],
            [-12.247771681135818, 9.188831393408645],
            [-12.258890940489907, 9.180878231988462],
            [-12.262284644672441, 9.183490587563304],
            [-12.266290854054565, 9.182875549369992],
            [-12.269471463402967, 9.185855403524565],
            [-12.27317847095095, 9.186276046487352],
            [-12.278552601204899, 9.190574896982188],
            [-12.279152328659526, 9.195292905219612],
            [-12.275239568106242, 9.198344771353508],
            [-12.275735951976278, 9.205686864841802],
            [-12.279526115374752, 9.20974373815252],
            [-12.289204615105504, 9.213138889712123],
            [-12.290653708567028, 9.219946665261256],
            [-12.285327042540143, 9.222911589259809],
            [-12.285143625940313, 9.225257296005902],
            [-12.290753658343286, 9.226530790158499],
            [-12.289351486344591, 9.232938397337664],
            [-12.281794637136983, 9.236225839883344],
            [-12.274446466746346, 9.242497605501276],
            [-12.274385500306838, 9.246328832371102],
            [-12.270162165481548, 9.2561882697332],
            [-12.271527281035628, 9.262131182334063],
            [-12.276670235943124, 9.266928620732394],
            [-12.280900472390568, 9.274698434255594],
            [-12.282877006550745, 9.27542490199586],
            [-12.282793380679617, 9.283472528083697],
            [-12.284945255956664, 9.28648200976924],
            [-12.289993810384702, 9.288530274674976],
            [-12.293177699333476, 9.293738505626726],
            [-12.300611705824828, 9.292942381586691],
            [-12.298542399650367, 9.30314230639679],
            [-12.213680464605472, 9.286481290141964],
            [-12.19693480571727, 9.369641838823545],
            [-12.208575474543471, 9.371844218083858],
            [-12.183391651577095, 9.496945599985917],
            [-12.170160313661096, 9.494330806647982],
            [-12.167866278665946, 9.50844854818107],
            [-12.165038339611705, 9.522422880993256],
            [-12.150376442715299, 9.519455392893246],
            [-12.147132913261675, 9.535755978552226],
            [-12.131877282704707, 9.532613580160495],
            [-12.12270368194008, 9.520946394885945],
            [-12.117512674537814, 9.520909616855782],
            [-12.112060554549954, 9.51867245878207],
            [-12.100413521321787, 9.51062084434272],
            [-12.097460072749886, 9.52575452822774],
            [-12.075961835964442, 9.521585676746735],
            [-12.073317296591954, 9.535428429895582],
            [-12.11610212599358, 9.543836161157516],
            [-12.107924583207634, 9.586408721837351],
            [-12.163280511361558, 9.597056058317431],
            [-12.157678627719621, 9.623437604453096],
            [-12.171784126664248, 9.62619385004868],
            [-12.166238614775667, 9.654015340519747],
            [-12.194740564215955, 9.659551870093253],
            [-12.191882101621088, 9.673525662313837],
            [-12.206180926705889, 9.676315039422994],
            [-12.200407933794532, 9.704098463667332],
            [-12.227996138881831, 9.70954821867919],
            [-12.225044975698548, 9.72403434254391],
            [-12.239078301329224, 9.726708711011717],
            [-12.230627339935886, 9.768434225582299],
            [-12.273187544951206, 9.776797898162735],
            [-12.270369714026256, 9.790715576476444],
            [-12.284623560999352, 9.79350871414561],
            [-12.279025810963892, 9.821270397433395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.92372221785523,
          "lat": 47.03656156140016
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30063"],
        "coty_name": ["Missoula"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Missoula County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01719596"
      },
      "bbox": [
        -12.300611705824828, 9.087155134095154, -11.293838922647096,
        10.030068313144374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.375484716720656, 6.587245576465988],
            [17.389931193358997, 6.589309065293073],
            [17.39622094124083, 6.565975205315045],
            [17.43901623952126, 6.573129665958628],
            [17.429601851744682, 6.597098146257703],
            [17.462656178946336, 6.602845850834698],
            [17.45947933335779, 6.609952776392325],
            [17.50138769747479, 6.626814504104258],
            [17.506689417831673, 6.62922316213973],
            [17.57807141875823, 6.659735197554456],
            [17.57468125670435, 6.624844180893133],
            [17.575219996556548, 6.607363832035002],
            [17.614674149361736, 6.615192339198922],
            [17.674663412251384, 6.629577512427563],
            [17.677537016383233, 6.630249948856048],
            [17.68264077529823, 6.583338392504878],
            [17.683653533680015, 6.583850196176338],
            [17.688282303410624, 6.51972329406312],
            [17.6992722273739, 6.467733507719231],
            [17.703849924179963, 6.447225118194756],
            [17.743597499482593, 6.456361644034607],
            [17.753220937320144, 6.4337019344399655],
            [17.766356025015433, 6.401051858190017],
            [17.77430120103085, 6.383029035805555],
            [17.786739614420693, 6.353895618030164],
            [17.80462050982262, 6.312636132377579],
            [17.82636120930778, 6.317197090625897],
            [17.831755896228504, 6.305835610974461],
            [17.85634202385226, 6.246230124679063],
            [17.819037230044355, 6.237733660423045],
            [17.716724537223836, 6.216034916678746],
            [17.603604693931644, 6.1913249148940634],
            [17.47809209521186, 6.165109857488111],
            [17.47476755761939, 6.170831527675409],
            [17.463091619085723, 6.181006258620767],
            [17.458157774091134, 6.19192498541979],
            [17.454405688185364, 6.19657037485582],
            [17.449900624354044, 6.197936273053993],
            [17.443777033543167, 6.203541865773666],
            [17.438473933135963, 6.201711566901093],
            [17.43819139172899, 6.197180625465013],
            [17.43382788472963, 6.192740794151773],
            [17.430350594205688, 6.19125796319991],
            [17.42659196705415, 6.195315782019106],
            [17.427252241524943, 6.198334272171348],
            [17.431044603249266, 6.202559182207833],
            [17.429394150000643, 6.207620947023132],
            [17.420035946392936, 6.216342725886109],
            [17.401521519788364, 6.2263275428578995],
            [17.396471371979477, 6.237303148796733],
            [17.394020673878995, 6.24057282457131],
            [17.3860547522993, 6.260802048916749],
            [17.381456457431725, 6.26448453666994],
            [17.377205938814914, 6.269926507320193],
            [17.377612935587727, 6.277265061871563],
            [17.374514708565087, 6.2836158065107925],
            [17.372997157106614, 6.291976475267327],
            [17.372477571314946, 6.3016815122256045],
            [17.379959920086606, 6.30810229424837],
            [17.384379102254204, 6.318045305177116],
            [17.38203000408567, 6.326955519347987],
            [17.38191283726974, 6.331474406153502],
            [17.384720786835963, 6.335051042607319],
            [17.38442984161408, 6.33924386448444],
            [17.37993499570556, 6.348511465922918],
            [17.377486460998764, 6.359563471887895],
            [17.374794794464897, 6.364474766751207],
            [17.369433022067152, 6.367846166460747],
            [17.36986270170755, 6.373159937724522],
            [17.37755287941308, 6.383564497228663],
            [17.38472995375297, 6.3863955983504415],
            [17.386918300596, 6.388638929492354],
            [17.39467152174871, 6.392473329392674],
            [17.400794050548793, 6.4005419361798825],
            [17.4068298838319, 6.4000578030419595],
            [17.412758378857326, 6.412742336591612],
            [17.408503669638783, 6.418529945242181],
            [17.407949789703405, 6.422538460918445],
            [17.40970660590321, 6.4296774751293135],
            [17.41153019432483, 6.431399386667378],
            [17.417361082643957, 6.432723805295083],
            [17.41960036762438, 6.438518813936371],
            [17.417919017696015, 6.442549776501075],
            [17.40752081724498, 6.44686111397015],
            [17.401701354222734, 6.453927340638055],
            [17.400551096214564, 6.456700281299055],
            [17.399488314752595, 6.468944486300859],
            [17.393826881565445, 6.474564913121917],
            [17.391525842219146, 6.479286840801899],
            [17.39285561314408, 6.484521883875006],
            [17.397768291381226, 6.492024673951132],
            [17.402526147636355, 6.501325329556876],
            [17.406312990977426, 6.512971756834418],
            [17.405809455357886, 6.517886088366217],
            [17.396767498392062, 6.530263745359005],
            [17.397193864391713, 6.535835997648296],
            [17.40030537632935, 6.540504958058305],
            [17.400816251133318, 6.544919709611339],
            [17.399220988887357, 6.550265674321997],
            [17.38961127571819, 6.558705396132926],
            [17.38965690259298, 6.564487304023732],
            [17.38108749273481, 6.56555892424389],
            [17.37575501827476, 6.5720834602743174],
            [17.37527130418573, 6.575021500918818],
            [17.377390529203296, 6.581350639744675],
            [17.375484716720656, 6.587245576465988]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.25125407399086, "lat": 42.91935013550353 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33005"],
        "coty_name": ["Cheshire"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cheshire County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00873176"
      },
      "bbox": [
        17.369433022067152, 6.165109857488111, 17.85634202385226,
        6.659735197554456
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.044458407683845, -5.510481319695866],
            [-6.004484490506369, -5.5135992970875165],
            [-5.997382693344729, -5.426566623987669],
            [-5.990128453633236, -5.339607917734254],
            [-5.984503454147734, -5.271318994047543],
            [-5.975919803515677, -5.167377482131398],
            [-5.969107189395645, -5.084037825920916],
            [-5.931938392849587, -5.086948309116501],
            [-5.917222888642498, -4.912892408153469],
            [-5.786294980691896, -4.923006238078044],
            [-5.743425198490577, -4.926212787142712],
            [-5.673481910089951, -4.931478916375031],
            [-5.519724852876481, -4.9430593670989165],
            [-5.365966236346856, -4.954618668556399],
            [-5.382909612164221, -5.136581486729395],
            [-5.387999688249681, -5.195466606617633],
            [-5.39461464654592, -5.264448287341675],
            [-5.395317564949961, -5.268526517304842],
            [-5.39840177245642, -5.305524882378409],
            [-5.405648691457897, -5.383717256143706],
            [-5.415107476629476, -5.4856864042343325],
            [-5.418542471584097, -5.524399452617093],
            [-5.421618174809894, -5.5651511514174645],
            [-5.425959875538643, -5.624160510792812],
            [-5.428569983659001, -5.655763599092008],
            [-5.431483826070722, -5.696523663410827],
            [-5.435326439382098, -5.7466578145608915],
            [-5.442445253150781, -5.841124172482838],
            [-5.444958499613782, -5.8772866035691],
            [-5.446744981140841, -5.899108655229186],
            [-5.454289322077781, -6.001206821668548],
            [-5.468178720845662, -6.188199753156977],
            [-5.472909538554184, -6.251877500546622],
            [-5.482219678779652, -6.3771737526338415],
            [-5.486479352041963, -6.4348999438197945],
            [-5.493003085156609, -6.5210569575272626],
            [-5.577761019246926, -6.514770259994884],
            [-5.664024272583212, -6.508264402975421],
            [-5.713569477583268, -6.504582711640043],
            [-5.880322655422768, -6.49153852308255],
            [-6.0470727745254, -6.478455138627785],
            [-6.025158398791728, -6.210281740537617],
            [-6.016553130250335, -6.105418214550525],
            [-6.007375893234714, -5.994196059262357],
            [-6.0045179028756674, -5.958397697245175],
            [-6.080793436383061, -5.952158878331111],
            [-6.0704656035382785, -5.827020773909388],
            [-6.060518870127744, -5.704959308322886],
            [-6.044458407683845, -5.510481319695866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.41247200405985,
          "lat": 32.79210104876128
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35025"],
        "coty_name": ["Lea"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lea County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01702365"
      },
      "bbox": [
        -6.080793436383061, -6.5210569575272626, -5.365966236346856,
        -4.912892408153469
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.763546804772378, -2.5291278847401792],
            [-7.758645790324985, -2.528328461776452],
            [-7.754850303416437, -2.521990348551201],
            [-7.740809549781054, -2.519823422769527],
            [-7.734318902446733, -2.515587175437286],
            [-7.732074668462806, -2.5113694590267888],
            [-7.727345146062023, -2.5104787054557214],
            [-7.720011961792909, -2.5018856771282043],
            [-7.716169319957537, -2.498646718053996],
            [-7.71645662810719, -2.4938874527335866],
            [-7.711924666891316, -2.4848918396678097],
            [-7.7058657286979635, -2.484201704333434],
            [-7.70188187256449, -2.4820176557775624],
            [-7.6994259486771295, -2.47649241212879],
            [-7.69899908752192, -2.4708881002582324],
            [-7.694192868184762, -2.464558443568242],
            [-7.695846322814515, -2.4633131456924526],
            [-7.701767565688028, -2.46415256423024],
            [-7.702221491201769, -2.4616812289820933],
            [-7.7099959615768165, -2.4592989374641387],
            [-7.71584910168192, -2.4587492233643906],
            [-7.725514247476481, -2.45981243688255],
            [-7.735569063776996, -2.4581886626420526],
            [-7.737258286411774, -2.454492495238077],
            [-7.7469858487264425, -2.4510384764824797],
            [-7.752701212132685, -2.4457667456777896],
            [-7.7509823059886624, -2.4292454776997143],
            [-7.749232815749156, -2.4120618407538266],
            [-7.744916237238194, -2.3934525523260954],
            [-7.740676303578183, -2.3542026183300258],
            [-7.659245217072994, -2.3630708416041775],
            [-7.58805941807635, -2.370507808481746],
            [-7.582031124354687, -2.3152468545599065],
            [-7.5830365836886715, -2.3115684848212887],
            [-7.591064730001368, -2.31084698553747],
            [-7.592446227336515, -2.308085811692154],
            [-7.589447699687151, -2.303528397057625],
            [-7.594283826074237, -2.3002044158993318],
            [-7.594026038288653, -2.2976842837114817],
            [-7.543017457981643, -2.302998798944872],
            [-7.422040348224128, -2.3155939749261263],
            [-7.311340095454519, -2.3268398585897336],
            [-7.314302405171144, -2.350438569606055],
            [-7.3278191063798666, -2.458074743652034],
            [-7.33524790580488, -2.5172099118556797],
            [-7.3344475450288575, -2.517266648710538],
            [-7.342531508343755, -2.5959487906915544],
            [-7.346821744197465, -2.676016036128782],
            [-7.348646003967099, -2.6768402885443328],
            [-7.351197159327224, -2.6992396105017877],
            [-7.35157609916953, -2.705726822388561],
            [-7.354735585361265, -2.7364831903507465],
            [-7.3545397947124425, -2.7379368666037003],
            [-7.367797320849502, -2.8663428219158376],
            [-7.3837138280067265, -3.026744314224493],
            [-7.382383022823648, -3.0269464760645723],
            [-7.391217768428846, -3.115807788506636],
            [-7.408336507024301, -3.2901208591142965],
            [-7.662846690063157, -3.2645718352858286],
            [-7.751981543817905, -3.2552598448517016],
            [-7.83593456289545, -3.24675463765557],
            [-7.8313309636168436, -3.2045912397518683],
            [-7.8213698607296305, -3.1152415162680644],
            [-7.817150794219156, -3.0708453552442134],
            [-7.814502200130521, -3.0355886988239926],
            [-7.808667649706163, -2.9819139622012485],
            [-7.811308203740862, -2.9813894014146274],
            [-7.796166495488696, -2.842447487183863],
            [-7.795698821317636, -2.840058430311557],
            [-7.782813690893431, -2.720741225259872],
            [-7.773250690176331, -2.6324293036310937],
            [-7.774528441292839, -2.632291120857467],
            [-7.7693924358257345, -2.585582084389546],
            [-7.763546804772378, -2.5291278847401792]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.97625739553253,
          "lat": 35.50690253674843
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35049"],
        "coty_name": ["Santa Fe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Santa Fe County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00933322"
      },
      "bbox": [
        -7.83593456289545, -3.2901208591142965, -7.311340095454519,
        -2.2976842837114817
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.075762305603092, 5.863405501373971],
            [13.087723193425427, 5.79600191758805],
            [13.102191978285454, 5.73682382986195],
            [13.107966774573386, 5.711708519159345],
            [13.11225385229451, 5.678766082720524],
            [13.117689680572848, 5.639607217635043],
            [13.120494961309227, 5.6248871933911255],
            [13.12861082827151, 5.585765602912019],
            [13.128609752575802, 5.582981350015541],
            [13.124109025997488, 5.580347918903348],
            [13.114641624298843, 5.580587021582712],
            [13.1122235234384, 5.5766236412295065],
            [13.109279262371727, 5.5773876601806185],
            [13.104471130394407, 5.575966949924002],
            [13.10264097392251, 5.580322183294295],
            [13.099370361284567, 5.581746707346308],
            [13.09902591283774, 5.585487598813297],
            [13.091494090873667, 5.585164134033837],
            [13.091588388708336, 5.580771351036679],
            [13.087429461177596, 5.5775666830505575],
            [13.0830811377529, 5.577189381006038],
            [13.077915219940644, 5.573099800663726],
            [13.074996346897851, 5.572968124812131],
            [13.069455938078692, 5.576385451617763],
            [13.06925402575596, 5.579430970208353],
            [13.071871058463374, 5.583164528251407],
            [13.068817940737159, 5.584847289545474],
            [13.065950595997096, 5.582182064536951],
            [13.066233515543663, 5.578487981566113],
            [13.061478386326208, 5.575346914292494],
            [13.057322085346287, 5.577590771590234],
            [13.057141210248215, 5.572724089573775],
            [13.054870912644407, 5.571357377713317],
            [13.044799021041497, 5.57048077531398],
            [13.043216980677615, 5.56575777416804],
            [13.047520901092431, 5.562069538294705],
            [13.046681425211325, 5.556805500815697],
            [13.044569432474189, 5.554338681451208],
            [13.040605144601464, 5.556709797558958],
            [13.037906758378039, 5.552457852180894],
            [13.032014151781638, 5.550921095448358],
            [13.029994841406674, 5.554171210012639],
            [13.021496143882219, 5.554955037267384],
            [13.023800563893706, 5.561234110841139],
            [13.018555906582248, 5.564134693234623],
            [13.013418393871845, 5.560814023726503],
            [13.008055071858957, 5.56578164911001],
            [13.00944401904146, 5.568667684062919],
            [13.003149869828663, 5.569681757149739],
            [13.00065300422519, 5.568108468339078],
            [13.00233821090434, 5.564432288921973],
            [12.997793638328785, 5.5625325875240925],
            [13.000272940479991, 5.554786181906715],
            [12.993685585486082, 5.554903880234877],
            [12.986988452614778, 5.557225473488875],
            [12.97893808713925, 5.553270198371885],
            [12.97559174278696, 5.553371702159487],
            [12.973528279919545, 5.548933168933969],
            [12.969785411906802, 5.554178266419804],
            [12.966576455045667, 5.555833709082844],
            [12.963023477834533, 5.552809711469369],
            [12.955346674610361, 5.551967246122825],
            [12.954631560026915, 5.547388741719207],
            [12.950051188068297, 5.546926745830563],
            [12.948165753881248, 5.544714564511269],
            [12.941376295612294, 5.548708484158936],
            [12.937189748898785, 5.5459262615730625],
            [12.932755054578704, 5.531614604905542],
            [12.927294187995734, 5.528893308247349],
            [12.921356737789125, 5.529510336648032],
            [12.914455272057081, 5.52733401635256],
            [12.908463867694985, 5.521548618546057],
            [12.90234567579557, 5.521595144556868],
            [12.891622425974452, 5.518852024432082],
            [12.888837708137324, 5.513622119084595],
            [12.89170009457645, 5.508087451398118],
            [12.885745306501384, 5.503420057660505],
            [12.874863591546514, 5.501127349804686],
            [12.873189549893446, 5.497414638278108],
            [12.878710376136747, 5.489811791961352],
            [12.880763322262872, 5.484190135411472],
            [12.878035954577575, 5.479630339544036],
            [12.876771166248796, 5.473807198756876],
            [12.873327880580566, 5.468386882751942],
            [12.864852734198658, 5.466644899812102],
            [12.860550699212311, 5.468713819251527],
            [12.851607519765828, 5.468319063587555],
            [12.846554307539188, 5.465668910244266],
            [12.841992140888422, 5.467484144297368],
            [12.839110460964077, 5.465085772745081],
            [12.836208418450132, 5.466844067720744],
            [12.831645085602107, 5.4794703094614],
            [12.828173863884556, 5.485329246859813],
            [12.819977908135339, 5.491373556850838],
            [12.815358332860576, 5.493776637267052],
            [12.789039826936808, 5.501446157382605],
            [12.785518234730917, 5.501725845905072],
            [12.759796675180658, 5.4977999056864695],
            [12.742529700446095, 5.4957111125144005],
            [12.735978820573226, 5.492878899152931],
            [12.694716371370637, 5.495565938166621],
            [12.693449548887143, 5.498898136896756],
            [12.698925441972234, 5.5119295217395585],
            [12.701329493685092, 5.5263443351658434],
            [12.699047160292205, 5.531893656251383],
            [12.69105951234093, 5.537720681640619],
            [12.695797751144749, 5.544075808356119],
            [12.69863539061194, 5.546093519897242],
            [12.702388329438332, 5.55510413849162],
            [12.705711298902935, 5.558750673509543],
            [12.70592646612256, 5.564483048679446],
            [12.699590294038146, 5.582358189104071],
            [12.692934056254247, 5.592652041531262],
            [12.691508000144196, 5.602562184704414],
            [12.691444986773885, 5.618815686981316],
            [12.683489506487447, 5.6285692930487095],
            [12.684446884110402, 5.640328567843286],
            [12.679365368548998, 5.656187994628788],
            [12.676447439221706, 5.6715218143902755],
            [12.664694162421288, 5.677848484947816],
            [12.669685610120695, 5.679962412995208],
            [12.698781653257674, 5.695379378566309],
            [12.71330644629359, 5.701391609119431],
            [12.720739975909092, 5.703520172389984],
            [12.742480074212262, 5.7150331363326226],
            [12.75876814001263, 5.7260749144318215],
            [12.773949454360558, 5.7345465887452365],
            [12.790618965908605, 5.743079198771956],
            [12.806263541631347, 5.752213087733981],
            [12.81190216896162, 5.754968246939944],
            [12.821550354111247, 5.763062815506211],
            [12.823279561937788, 5.762462135743504],
            [12.8357756342138, 5.767877599103872],
            [12.84077958104696, 5.771309810570781],
            [12.864222885253383, 5.780046325021087],
            [12.894196671624973, 5.797215914388888],
            [12.90401701908206, 5.7989884610597855],
            [12.916665919554084, 5.803589189875541],
            [12.923522131945619, 5.807061517338671],
            [12.94790632352571, 5.821688144805466],
            [12.951915330570632, 5.824872653409003],
            [12.958164068292541, 5.827844869507932],
            [12.982566878055342, 5.836164037401596],
            [13.017834796646861, 5.850957566264376],
            [13.036849718621585, 5.857340778801378],
            [13.043112859706826, 5.85792554514947],
            [13.058504529348156, 5.863794003231183],
            [13.063068635468719, 5.8642965606867605],
            [13.06690681330205, 5.862211012506139],
            [13.075762305603092, 5.863405501373971]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.74529847911231,
          "lat": 43.200087121896736
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36063"],
        "coty_name": ["Niagara"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Niagara County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00974130"
      },
      "bbox": [
        12.664694162421288, 5.465085772745081, 13.12861082827151,
        5.8642965606867605
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.14653520905366, 4.808290704311723],
              [18.147391679653666, 4.813840198415035],
              [18.14925445613637, 4.815794522974704],
              [18.149528387301114, 4.821307540107225],
              [18.15255388736074, 4.820143710746696],
              [18.15395715436312, 4.823757105228538],
              [18.153901830287044, 4.829171076369732],
              [18.150776226253004, 4.831975931922015],
              [18.153094750460937, 4.83477879051892],
              [18.163122907225016, 4.8329490483931945],
              [18.16293873661272, 4.82799930588858],
              [18.16597042651024, 4.824718347788385],
              [18.172995922788665, 4.835031941225516],
              [18.171711167201032, 4.844088504512075],
              [18.172603031138525, 4.846159159560344],
              [18.17735215756134, 4.847561310085803],
              [18.183037630121834, 4.8467441291795685],
              [18.188120986668682, 4.849996628150212],
              [18.18794950158728, 4.853701607806322],
              [18.193339752469054, 4.853144406784743],
              [18.198431333396574, 4.856600173900294],
              [18.20312347623171, 4.855188512634192],
              [18.207496966153126, 4.856568735617701],
              [18.205843315576743, 4.860895094815978],
              [18.207441643830943, 4.865432983997392],
              [18.216091181712407, 4.865163885826371],
              [18.216668640523476, 4.861378674827631],
              [18.21311040271538, 4.855810115659179],
              [18.202797831212266, 4.851873997859699],
              [18.199748132205343, 4.848566273561844],
              [18.19507149145697, 4.84727250767765],
              [18.188211974647565, 4.840400224665511],
              [18.18643247671014, 4.837131859811034],
              [18.182020312858825, 4.833528485372006],
              [18.17807961848088, 4.828148324910006],
              [18.175883670535825, 4.820885105580185],
              [18.17158224979579, 4.816369209830441],
              [18.16540815050011, 4.817259453611123],
              [18.160350741619727, 4.816136253365842],
              [18.15510602177193, 4.810225788420021],
              [18.147522584453927, 4.807000656289343],
              [18.14653520905366, 4.808290704311723]
            ]
          ],
          [
            [
              [18.108950138146184, 4.639458532316917],
              [18.11014559871421, 4.643707337566574],
              [18.11447569928376, 4.646960762202417],
              [18.1169180819257, 4.65220189782675],
              [18.115369685835876, 4.665345306257015],
              [18.120410412982068, 4.6603655145309215],
              [18.126372601381444, 4.657064739760668],
              [18.143623513808688, 4.654749884170656],
              [18.14840965281263, 4.6528041433624425],
              [18.15548970915523, 4.653509236443323],
              [18.156878021896077, 4.6505810982323705],
              [18.15212477425547, 4.642815807943064],
              [18.152581557648162, 4.638072755456532],
              [18.15540054353179, 4.631254724618637],
              [18.15883522272481, 4.626650962319021],
              [18.157134009787367, 4.6217044234511375],
              [18.15917563231226, 4.6120751312980985],
              [18.15450148377507, 4.605873120188185],
              [18.15282733594555, 4.6061457985960645],
              [18.147614740615122, 4.626559414368388],
              [18.140589245868348, 4.635800259324974],
              [18.137635807970657, 4.6375332333778765],
              [18.126308349538267, 4.639083301575199],
              [18.11391445696439, 4.635717671192839],
              [18.110541452537174, 4.636296487234619],
              [18.108950138146184, 4.639458532316917]
            ]
          ],
          [
            [
              [18.03971105160305, 4.70347338732817],
              [18.04095559097362, 4.706762699995769],
              [18.05287006903279, 4.719012294289115],
              [18.06481679786941, 4.721007539132668],
              [18.06151510005981, 4.716819250073991],
              [18.05731834257828, 4.716726559185995],
              [18.055860916136126, 4.714374979146346],
              [18.052663046590453, 4.695269053602036],
              [18.050641782144282, 4.694924883067654],
              [18.045964207106977, 4.700114882811022],
              [18.040026284280263, 4.700423866492208],
              [18.03971105160305, 4.70347338732817]
            ]
          ],
          [
            [
              [17.295691843117883, 3.9313315925537164],
              [17.291258912569642, 3.9488010439698207],
              [17.283460563771715, 3.9767387576306525],
              [17.281389776378944, 3.991893930102402],
              [17.257569120413184, 4.051588012282205],
              [17.240214590237287, 4.096016207795062],
              [17.239149166582198, 4.098135431140323],
              [17.218022946563586, 4.151265510873528],
              [17.21430682972629, 4.1595957313390945],
              [17.207175071065915, 4.168713613209615],
              [17.2067978249175, 4.176027237476227],
              [17.204337453280967, 4.176778995521022],
              [17.20371956941632, 4.179644588910728],
              [17.198583067139374, 4.1826842874359595],
              [17.195536318629205, 4.188406637187466],
              [17.192638240417555, 4.199658724033721],
              [17.18997372825721, 4.203849629976279],
              [17.186477360275795, 4.205423329511291],
              [17.180237373899683, 4.213028242969067],
              [17.177360851347117, 4.21932832674087],
              [17.174094415752712, 4.222982272080794],
              [17.16847674931866, 4.225182795357173],
              [17.1676112277952, 4.227587696620472],
              [17.166882375668386, 4.243728362208474],
              [17.171096988851993, 4.249871868130214],
              [17.177164413349104, 4.247091421113889],
              [17.188926492451444, 4.245166229441472],
              [17.208400368476443, 4.246710807190285],
              [17.215470500891993, 4.242247434400726],
              [17.217968230228156, 4.234595715307847],
              [17.21497158605251, 4.224265443368724],
              [17.217378764489993, 4.222352738356932],
              [17.22342762160564, 4.22083903520476],
              [17.233500146298848, 4.221103678039021],
              [17.240998555847888, 4.2247118330608755],
              [17.244554569948843, 4.22883612300418],
              [17.252963213549148, 4.226471450976783],
              [17.256159905405514, 4.22262207198392],
              [17.25870261519523, 4.2231968315141994],
              [17.25861081828779, 4.235817244485145],
              [17.270722391199666, 4.230016747612587],
              [17.275108548612685, 4.225152030804188],
              [17.27930776475293, 4.222659696006898],
              [17.277651928351936, 4.22993664613979],
              [17.27425338313281, 4.233123721851692],
              [17.272030547684672, 4.238014387632443],
              [17.274656182565035, 4.24024505217212],
              [17.27491450600882, 4.246013941018539],
              [17.27260249357649, 4.251517174237525],
              [17.26716902602817, 4.251155400716534],
              [17.263461663074295, 4.253911745360149],
              [17.25872312005619, 4.254345892245809],
              [17.250665407394944, 4.250712566778859],
              [17.24629710523226, 4.244460426280564],
              [17.234248811151133, 4.24951536277364],
              [17.231724568851796, 4.260150542663362],
              [17.231678045109895, 4.265105815902015],
              [17.229842868525257, 4.272314778868839],
              [17.23632902406673, 4.274817997361304],
              [17.25393034725802, 4.260760650291736],
              [17.261522641694718, 4.256492960529218],
              [17.278604104647467, 4.253092265447099],
              [17.278543817753814, 4.255459939209195],
              [17.28721356044385, 4.260543966364467],
              [17.31485713837958, 4.261973875490962],
              [17.337302313882624, 4.2573099614676195],
              [17.3604986676028, 4.257217933182177],
              [17.367828450226813, 4.255671943301969],
              [17.40452843411993, 4.2803003899550145],
              [17.416370638584105, 4.290217249184315],
              [17.42155413993538, 4.292346853343904],
              [17.41946953755958, 4.308221235308351],
              [17.416790223843513, 4.319260843743842],
              [17.413420865313487, 4.322379374098601],
              [17.4082850995062, 4.323202757582122],
              [17.404199989643153, 4.328269865420772],
              [17.411717245340373, 4.32855232158354],
              [17.418549830607866, 4.330625812892044],
              [17.4241185995636, 4.334601155353326],
              [17.430718369618386, 4.344877673760607],
              [17.43787147715446, 4.341083951935377],
              [17.44432617034025, 4.339825008364342],
              [17.45057715280256, 4.341168258952058],
              [17.452302911617533, 4.3446932381522165],
              [17.461526203469937, 4.347774699655034],
              [17.479875909196092, 4.344012486035696],
              [17.48866854930787, 4.343370689785292],
              [17.49015226913819, 4.346202809086323],
              [17.522389215828007, 4.356202533850445],
              [17.552111685600632, 4.363161278454141],
              [17.58304621294204, 4.366985628506428],
              [17.601522128122966, 4.3720669546594],
              [17.61757307518626, 4.377669822825172],
              [17.63984264725093, 4.3889687025734965],
              [17.664364868845787, 4.391511525522568],
              [17.68390232631458, 4.394933109041471],
              [17.703807185500125, 4.40312936282334],
              [17.720423754766504, 4.412941598659186],
              [17.72881229031492, 4.41910635346015],
              [17.744418432245663, 4.425525192038108],
              [17.753962912979368, 4.426234379811342],
              [17.771267401211446, 4.43327681721684],
              [17.780465012971042, 4.436262059162369],
              [17.790800269335286, 4.443455531974157],
              [17.813098116753174, 4.460635083548942],
              [17.836501503106728, 4.491914228131059],
              [17.851493181846813, 4.514362352006905],
              [17.85734808321677, 4.516654736474866],
              [17.867578658355104, 4.525031098509367],
              [17.869815195017, 4.528292555117959],
              [17.878007675602213, 4.533572389250798],
              [17.88760188780493, 4.550657240358677],
              [17.892872265361433, 4.572467275551228],
              [17.91219914916641, 4.579251511645931],
              [17.925306931604457, 4.591222266319959],
              [17.93072855097278, 4.602888293511637],
              [17.931253012934775, 4.6116231513815515],
              [17.935288995634092, 4.617103271782227],
              [17.93896700303897, 4.618971142289742],
              [17.943097730480982, 4.6264717222597405],
              [17.94568213796112, 4.635078278450012],
              [17.945536043330183, 4.641590715096659],
              [17.956083211939145, 4.645231753671503],
              [17.961055068284825, 4.6435170337542395],
              [17.969363572021468, 4.64634710202386],
              [17.97346855851954, 4.657016643416083],
              [17.977515158701262, 4.657015740245356],
              [17.982282112909378, 4.6642291041180215],
              [17.98719150626538, 4.668661851710497],
              [17.99539832564234, 4.673699377779629],
              [18.000514297637036, 4.671150127613403],
              [18.005124270188535, 4.671357372282906],
              [18.014067075838117, 4.679385394965504],
              [18.017845598003152, 4.681710193071228],
              [18.027813348857926, 4.6821415765418],
              [18.022953261061186, 4.675078598485081],
              [18.01909507309069, 4.662343275544294],
              [18.018963979769214, 4.6540384495007485],
              [18.015627108063555, 4.648833258342813],
              [18.00984669933193, 4.645672394902099],
              [18.004522241750646, 4.638167732922512],
              [17.997975139082232, 4.631911797464906],
              [17.995174277638053, 4.631270065177798],
              [17.999366378521554, 4.641058913641636],
              [17.998572764412266, 4.641922335001255],
              [17.986650185694234, 4.643830051460365],
              [17.978387467935914, 4.649749650280628],
              [17.972454893814504, 4.647873484561427],
              [17.972282728363215, 4.645447058760979],
              [17.967376269668183, 4.639047532374335],
              [17.96667166522326, 4.632485866980272],
              [17.962553785942394, 4.620076893308336],
              [17.96386714560961, 4.615423266491932],
              [17.967459909501546, 4.612892240601599],
              [17.97148296864847, 4.612910298390314],
              [17.979303948638506, 4.609327990884169],
              [17.98126303152051, 4.60331778313287],
              [17.98499242455111, 4.598404622862812],
              [17.99208723451345, 4.5982611838054765],
              [17.99773352419326, 4.595116588080115],
              [18.01375429450326, 4.597142868810333],
              [18.017613472275787, 4.5945245724592665],
              [18.017003641114897, 4.589390288316735],
              [18.014903090865314, 4.584441494044398],
              [18.02530590240818, 4.571064470208323],
              [18.021514650021135, 4.5652262420065215],
              [18.023887795069545, 4.5594710900502085],
              [18.02793013711194, 4.5552830615163],
              [18.034788419922712, 4.556063696950903],
              [18.037695009592316, 4.563465093328525],
              [18.050982238390358, 4.56965122581338],
              [18.059701602226994, 4.571440445372668],
              [18.069251955558652, 4.569989095183687],
              [18.076778065850494, 4.565520672367011],
              [18.082652856402067, 4.564756606183212],
              [18.09076421029644, 4.567140475196214],
              [18.097325258484943, 4.574889867542562],
              [18.09873581496125, 4.583250888802389],
              [18.105657831609356, 4.592321993632481],
              [18.11254056794462, 4.592702212216142],
              [18.1200541960619, 4.58775779787978],
              [18.12758808100514, 4.583915738507716],
              [18.131257611719693, 4.576138134865764],
              [18.13145879826537, 4.568536115580831],
              [18.141268034391786, 4.562451862184782],
              [18.15275364029118, 4.548962576231132],
              [18.15952199023256, 4.544767309027481],
              [18.16513288722435, 4.543531594295512],
              [18.170033627801114, 4.544620662074245],
              [18.177754645241382, 4.551895908454909],
              [18.178820494456986, 4.564376975389836],
              [18.18860962360184, 4.570105397018772],
              [18.188408246377943, 4.575857330134439],
              [18.191401299116162, 4.577950489322873],
              [18.192015530343568, 4.581900352945683],
              [18.19602349208793, 4.583709337493903],
              [18.207098864483843, 4.583461960829135],
              [18.213410233476214, 4.5860182647367],
              [18.218862696641352, 4.590535167884852],
              [18.22069915738117, 4.597154841848207],
              [18.228753971798554, 4.611109313054531],
              [18.23050819441198, 4.618055971271057],
              [18.237948954092488, 4.620680630252084],
              [18.24163190324445, 4.616573732444039],
              [18.24687762896789, 4.615721687040491],
              [18.25276512240014, 4.618996372129826],
              [18.25584691324644, 4.625753746898834],
              [18.25365717759471, 4.6318587711682015],
              [18.24875595763324, 4.640268030275109],
              [18.24836009585159, 4.647655994828949],
              [18.251077026091878, 4.650258596366921],
              [18.25767695839611, 4.652619729135319],
              [18.262252406886578, 4.657647206256107],
              [18.275122652608587, 4.664189301026793],
              [18.284635618968256, 4.672325310573185],
              [18.287246862209997, 4.671736347952513],
              [18.293205344316636, 4.665602938474187],
              [18.29793886842371, 4.665081910871032],
              [18.30473220663425, 4.667928787828104],
              [18.312568527484256, 4.668183918870777],
              [18.315776623451644, 4.670957184791978],
              [18.321676336353995, 4.668995223898376],
              [18.323046763519134, 4.666732502565686],
              [18.32125805339571, 4.660724528601537],
              [18.31837559985405, 4.656707405397962],
              [18.3180791890183, 4.653359303252279],
              [18.31501889493787, 4.649390876928512],
              [18.31464432415083, 4.644830714598062],
              [18.305615514590066, 4.637735538406502],
              [18.293156562486494, 4.626344665444176],
              [18.28736387651462, 4.624920863455592],
              [18.27502477834671, 4.616064919319651],
              [18.26015330518945, 4.604491372970815],
              [18.215798812571958, 4.5652441828957935],
              [18.161094030672064, 4.5223394172959095],
              [18.084018255062517, 4.456382414928532],
              [18.069921890207986, 4.443020048246672],
              [18.018555355770147, 4.3978388101303745],
              [17.983059226487015, 4.367661917680617],
              [17.93506901881029, 4.3307354051879505],
              [17.932556624738954, 4.328128435065823],
              [17.925643035254897, 4.32415876889285],
              [17.867081342796236, 4.283055241240754],
              [17.807889517072507, 4.242621016349143],
              [17.753320902733538, 4.206759198103114],
              [17.74842176624927, 4.201890329032782],
              [17.745265207092388, 4.201934023396129],
              [17.73794704958433, 4.197227089063885],
              [17.675662957880434, 4.152094441826506],
              [17.63664529437044, 4.122045310410298],
              [17.57959666385411, 4.073127404008011],
              [17.551832238837253, 4.052541215996836],
              [17.53140314437609, 4.039618418431999],
              [17.48471867311315, 4.0122704292252545],
              [17.475639060323598, 4.007634176502045],
              [17.44824013457212, 3.990421355093884],
              [17.42718535146139, 3.9792981348862093],
              [17.410970100741846, 3.972100321650122],
              [17.37905408205548, 3.9630932693044083],
              [17.37507049151117, 3.963536574492239],
              [17.361586272343953, 3.9716370103829126],
              [17.35034683407972, 3.9684969691237155],
              [17.343779592916505, 3.9646270244125725],
              [17.316982292958908, 3.945375900804308],
              [17.295691843117883, 3.9313315925537164]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.84580221423822, "lat": 40.86800424910466 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36103"],
        "coty_name": ["Suffolk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Suffolk County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00974149"
      },
      "bbox": [
        17.166882375668386, 3.9313315925537164, 18.323046763519134,
        4.865432983997392
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.016306677287334, -3.7413959029672],
            [9.018264146739114, -3.747169218341171],
            [9.031140908106742, -3.790577689550944],
            [9.07328023488033, -3.933355553634173],
            [9.08476212582701, -3.9744243467488363],
            [9.094468839657502, -4.009457590821525],
            [9.129372492275989, -4.132607080628627],
            [9.131588121262126, -4.143180413171522],
            [9.14054646216413, -4.176135878360598],
            [9.16168357741817, -4.253161871958883],
            [9.162610390129375, -4.255296927457851],
            [9.172434635825658, -4.290567607445541],
            [9.165227132220853, -4.29129645998539],
            [9.165478085640101, -4.294964563131962],
            [9.15105750874942, -4.296474411605176],
            [9.151307814925659, -4.300061642520059],
            [9.09432741960041, -4.306549167445051],
            [9.09550599703224, -4.321091875644386],
            [9.0675632356389, -4.3251602967072875],
            [9.066492578666647, -4.310564493412593],
            [9.030571672750403, -4.311941836788914],
            [8.963723889375304, -4.314289940389856],
            [8.953352344847122, -4.315109240957255],
            [8.893650794348629, -4.316823497177787],
            [8.89290256708919, -4.295941812113144],
            [8.837491896637077, -4.199861577873177],
            [8.831885987094665, -4.190354264260133],
            [8.830820706568476, -4.18493153568042],
            [8.832108730715357, -4.175261980676833],
            [8.8345587826751, -4.168535153730931],
            [8.834393262393348, -4.1653687258823595],
            [8.828785123129888, -4.161847321200804],
            [8.817029254344572, -4.166763150096719],
            [8.801312674864736, -4.183763926307227],
            [8.794565611648068, -4.1837271072190925],
            [8.789443248067885, -4.142230074256726],
            [8.78312647850507, -4.09466860942884],
            [8.778183544068881, -4.050116542023199],
            [8.797362303020098, -4.053649413606981],
            [8.807602817509986, -4.052239108504484],
            [8.804982675752523, -4.032758741658031],
            [8.833402991681004, -4.0295270393426765],
            [8.855130831676359, -4.001135687732448],
            [8.904807074465099, -3.9365359928211463],
            [8.903424628943252, -3.932663563008564],
            [8.909078885304762, -3.9248449960286655],
            [8.908433390198528, -3.9216479402645397],
            [8.911841488483418, -3.917015060162852],
            [8.92529662382114, -3.9131437119451777],
            [8.925461484133326, -3.908192102103705],
            [8.930475961086708, -3.9105663507950523],
            [8.934143289199055, -3.909564980243332],
            [8.935414145009016, -3.9062071563618828],
            [8.939754621741741, -3.9017732793083857],
            [8.93757208708012, -3.8968250728725145],
            [8.94150362622629, -3.8931063697492947],
            [8.944397486986619, -3.8862291124737767],
            [8.939405956463524, -3.8823771639852747],
            [8.939273555360861, -3.8778278585825134],
            [8.945207581190235, -3.880995995567332],
            [8.948433968001998, -3.8799225891144853],
            [8.95000553267213, -3.8688137768093775],
            [8.953466028952805, -3.8618290612977564],
            [8.958174772046197, -3.858321277782716],
            [8.957020620025125, -3.8524003584251174],
            [8.965807557656966, -3.848121054903259],
            [8.964369651239739, -3.8433431894450734],
            [8.96946766697418, -3.839237215944703],
            [8.972135146909858, -3.831250210256862],
            [8.969870777887698, -3.819818886559221],
            [8.96657565511502, -3.8138786822307176],
            [8.970429363448243, -3.8114853178736157],
            [8.970498457115179, -3.8071670036667458],
            [8.968134549544198, -3.8012155061069093],
            [8.972828012694706, -3.8012787040974505],
            [8.975038973260126, -3.7976062567966284],
            [8.972963219396723, -3.79220293854979],
            [8.969451536728481, -3.7867711048151023],
            [8.973936869131082, -3.784539614129019],
            [8.97667673419896, -3.780091283493141],
            [8.982176822565105, -3.779834350211053],
            [8.983344949602794, -3.7739343633980185],
            [8.981753532454462, -3.7684068352184577],
            [8.987547401232554, -3.7656598954476324],
            [8.994042107576234, -3.768229392383888],
            [8.995909500179467, -3.762074764793815],
            [8.998769137614605, -3.7599519052989807],
            [9.001401783463736, -3.7532510548941356],
            [9.009516414451356, -3.7485032715049003],
            [9.006823685255833, -3.7455548262658414],
            [9.007957229245184, -3.7418963871870123],
            [9.011615099626072, -3.739804121427901],
            [9.016306677287334, -3.7413959029672]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.60379756791806,
          "lat": 34.175910101161726
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01019"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00161535"
      },
      "bbox": [
        8.778183544068881, -4.3251602967072875, 9.172434635825658,
        -3.739804121427901
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.8835026249364235, -3.5759075779596516],
            [6.883542719749762, -3.5734065395187518],
            [6.894137704109845, -3.5733153986447803],
            [6.8985616310622255, -3.5724124070967527],
            [6.903737663240657, -3.5696445298348887],
            [6.910374136241112, -3.5637029665622237],
            [6.920497330152593, -3.5587033148183314],
            [6.928500319961819, -3.557595914836914],
            [6.936476599790681, -3.559322168249547],
            [6.952647657755948, -3.566757869221685],
            [6.9675507325892365, -3.5724598578032283],
            [6.972847824514254, -3.573368849331789],
            [6.981879409325549, -3.5769409553376303],
            [6.985364687765598, -3.5771172624635],
            [6.994428081954331, -3.5839044213409514],
            [6.998755891558695, -3.586227017325904],
            [7.006134809538563, -3.593621070087337],
            [7.017558565406382, -3.609930450365367],
            [7.0221522223893595, -3.6206146132808783],
            [7.025227282094604, -3.633013096978225],
            [7.027952116791512, -3.640062750485724],
            [7.034953370371169, -3.651779409280507],
            [7.040379780397272, -3.6569433473177164],
            [7.055191345213822, -3.6664912082395213],
            [7.067636414113335, -3.676549637902523],
            [7.074429301315758, -3.680765313635232],
            [7.086378505964086, -3.689288703137318],
            [7.097815473220219, -3.701839510399035],
            [7.108943906470019, -3.7093129367423847],
            [7.123747444430722, -3.7142193026196906],
            [7.133181207450963, -3.7164957592962806],
            [7.144308253097024, -3.7155354072734252],
            [7.16077341934757, -3.7115076353704297],
            [7.170764654314592, -3.709693371762664],
            [7.18100724780884, -3.7017230957332],
            [7.191502307337556, -3.6981441351575324],
            [7.194652013960106, -3.6952105362740526],
            [7.203574713968952, -3.6765365172636764],
            [7.210295097975014, -3.668536951539445],
            [7.233972121373201, -3.657660844850153],
            [7.241377750466734, -3.655934808436371],
            [7.252425559705533, -3.6497664777555134],
            [7.260446625413191, -3.6441324134454733],
            [7.275493272229063, -3.639459276217982],
            [7.284154969198908, -3.635675359374118],
            [7.290906369985856, -3.630289196461528],
            [7.2977117291590385, -3.6263210692646295],
            [7.302748764690158, -3.6222007037300763],
            [7.305047822663474, -3.6148903811247877],
            [7.30893784260358, -3.6104759785248732],
            [7.320197467709712, -3.6052082475078775],
            [7.328578839939177, -3.6043867933012455],
            [7.3360165254926795, -3.599352163029419],
            [7.344855580661724, -3.599459155715635],
            [7.353619039212896, -3.5958100457845195],
            [7.362069054019852, -3.5972835558952094],
            [7.366910195566808, -3.6039815650886373],
            [7.378377924499251, -3.6070760959046595],
            [7.385845303307942, -3.6110318838517674],
            [7.392911926681829, -3.6124624814198443],
            [7.400972615574445, -3.6122389847252743],
            [7.416106421036392, -3.6145652258797],
            [7.428380280013161, -3.6178781307801566],
            [7.435889250914871, -3.6211263291558873],
            [7.434569681551745, -3.627020251456092],
            [7.43741360635497, -3.634742100967892],
            [7.4336471313361665, -3.6424824398617637],
            [7.431894252093135, -3.6481705734591667],
            [7.4378547871728795, -3.6482006484092344],
            [7.4473392755098695, -3.6534600731902693],
            [7.447648980781198, -3.658071899688497],
            [7.445328740192563, -3.663399233406017],
            [7.439171593136953, -3.669446635075206],
            [7.441970608484093, -3.676550474000822],
            [7.443047308475492, -3.6819374855595206],
            [7.437023495291183, -3.684264368649763],
            [7.436713113906869, -3.691020171340157],
            [7.434696042241451, -3.694511875307426],
            [7.437270259017101, -3.699394952705659],
            [7.438068625046156, -3.7043239471263036],
            [7.44349242959523, -3.7087426019210405],
            [7.443867002232237, -3.712730759636178],
            [7.436912099520186, -3.7185721865503076],
            [7.435258633527538, -3.722427888062444],
            [7.429361329466881, -3.7240462326278085],
            [7.425462621917834, -3.726863224123699],
            [7.4243120776061575, -3.7306389516597083],
            [7.424396354403806, -3.736890686021843],
            [7.4277607649701896, -3.7421874966073223],
            [7.4337321890829555, -3.7474190514321837],
            [7.430485685998778, -3.7527613729198044],
            [7.430199275876554, -3.7569763718999534],
            [7.4347824395500925, -3.761590269202056],
            [7.431508032360531, -3.764276205137871],
            [7.434204233230636, -3.7688993447711017],
            [7.430893484093526, -3.774259268197134],
            [7.426474890685127, -3.773293184749198],
            [7.422209111503175, -3.777502139287903],
            [7.408171172869, -3.7736910421306797],
            [7.403216978311082, -3.7776788085437905],
            [7.404676366795021, -3.7830317699051106],
            [7.4086290297224, -3.7850186594990447],
            [7.409191030798058, -3.7879277945777377],
            [7.404909153945221, -3.7893835093125223],
            [7.402074689109531, -3.796097959965731],
            [7.396650419087965, -3.8019502125585616],
            [7.393133332253483, -3.8023428030872877],
            [7.389340388798835, -3.8105936231778936],
            [7.390001636776323, -3.8163218211111167],
            [7.388600764903942, -3.8223161479369763],
            [7.384503692679663, -3.8255264276638044],
            [7.382637369843037, -3.8296663636714348],
            [7.383456355725955, -3.8331937129840226],
            [7.38724564788665, -3.8335075781522767],
            [7.385481266497436, -3.8385473464404383],
            [7.389772375249109, -3.8415522158060114],
            [7.387013758755452, -3.849227826422618],
            [7.381230376435985, -3.8508421289756636],
            [7.380459874329156, -3.8601000052622303],
            [7.373127133029291, -3.862068977178835],
            [7.317488132010929, -3.8658762820664787],
            [7.293695363048799, -3.866915350642939],
            [7.284864696996029, -3.8677980472829745],
            [7.206856406315539, -3.8721632533465913],
            [7.1117768448579195, -3.8784952239604156],
            [7.011785250349392, -3.8844558414294887],
            [6.917508030173844, -3.888349064188757],
            [6.891466144935875, -3.888981361070349],
            [6.875240453738197, -3.890087699345058],
            [6.875647526865445, -3.8824720951368574],
            [6.876486290353999, -3.8486447524929503],
            [6.880895847829824, -3.745680831705419],
            [6.880672740261055, -3.7234759535322124],
            [6.882402573065867, -3.6573708064354755],
            [6.8835026249364235, -3.5759075779596516]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.80502112864178, "lat": 34.70045879927198 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01033"],
        "coty_name": ["Colbert"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colbert County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00161542"
      },
      "bbox": [
        6.875240453738197, -3.890087699345058, 7.447648980781198,
        -3.557595914836914
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.309754841773053, -9.832523393647598],
            [-18.30035699501111, -9.743138158955913],
            [-18.27057402033438, -9.746135111732201],
            [-18.26752943919668, -9.71633627854907],
            [-18.27109542853767, -9.715972572477764],
            [-18.264990039495224, -9.65638518325939],
            [-18.235106683954687, -9.65931145606328],
            [-18.232139782527867, -9.62950026788155],
            [-18.172521678283104, -9.635094017374659],
            [-18.16972645697302, -9.605270722841558],
            [-18.14217741817817, -9.607740207664975],
            [-18.13946654478409, -9.577911795760187],
            [-18.109452762847486, -9.580518106949436],
            [-18.10451682387996, -9.524289742528854],
            [-18.101595504227124, -9.49100672547188],
            [-18.13355586033118, -9.488226423519269],
            [-18.122703150445364, -9.368931681709263],
            [-18.124949814782315, -9.368731695134306],
            [-18.114075682655532, -9.249466266141638],
            [-18.086213673790223, -9.251900916062485],
            [-18.080951581589808, -9.192278406948473],
            [-18.050982502971053, -9.194800824610553],
            [-18.04867405567217, -9.167688062071344],
            [-18.045905726162736, -9.135167525549502],
            [-18.047447751597026, -9.134997409802644],
            [-18.042365197971577, -9.07540152449249],
            [-18.012375356045194, -9.077848306571653],
            [-18.00748694116418, -9.0182177252215],
            [-18.008653715508395, -9.018122757733721],
            [-18.00621455651519, -8.988311362073519],
            [-18.036293715944677, -8.985849973740466],
            [-18.02867256958851, -8.896456642178748],
            [-18.03027156240283, -8.89632313636035],
            [-18.025173406116103, -8.836747712428927],
            [-17.935069307153586, -8.843846034890355],
            [-17.93054681082782, -8.784246265298611],
            [-17.899503129954674, -8.786495188129525],
            [-17.839532848454592, -8.790350877148024],
            [-17.779563935942424, -8.794227288258158],
            [-17.772459358391036, -8.674943294293898],
            [-17.712626495694092, -8.678031329194173],
            [-17.65279476018629, -8.681140632750386],
            [-17.655567771030423, -8.740812563412433],
            [-17.59531963793116, -8.743356628806657],
            [-17.592934598656022, -8.683669067636187],
            [-17.5330531705454, -8.685769788387454],
            [-17.534058279040217, -8.715664082994625],
            [-17.50401901966625, -8.716597500947817],
            [-17.50492027304079, -8.746453307460746],
            [-17.444638966788872, -8.748038401990325],
            [-17.443225247033865, -8.688321051555006],
            [-17.437001563355512, -8.688462725857812],
            [-17.436315134278196, -8.65861009384006],
            [-17.345508423379094, -8.660208271908601],
            [-17.34472813906521, -8.600508600918147],
            [-17.25450254791476, -8.601223298597548],
            [-17.254409045855336, -8.571379006781765],
            [-17.24554278314601, -8.571402195915551],
            [-17.24528983914727, -8.452080332394212],
            [-17.26669241912583, -8.452009047428572],
            [-17.266556621214985, -8.422192962466115],
            [-17.327208371614603, -8.421719816525751],
            [-17.326193960082296, -8.332312574060259],
            [-17.31831976529583, -8.332396664999584],
            [-17.318008351671246, -8.302606756762026],
            [-17.348366672029016, -8.302244981910928],
            [-17.347952849871174, -8.27246298856994],
            [-17.378207802945543, -8.27200043922332],
            [-17.377691633789023, -8.242226520504866],
            [-17.407842106182375, -8.241663887806174],
            [-17.407223807911528, -8.211899234105045],
            [-17.400542543355606, -8.212032719306594],
            [-17.399592034943172, -8.164520055803873],
            [-17.364643362257407, -8.16515880134097],
            [-17.36014291629933, -8.16521394569542],
            [-17.304592921368158, -8.165702473781396],
            [-17.249043111943987, -8.166211086539578],
            [-17.19780612037768, -8.166044091429809],
            [-17.14656907526581, -8.165894183059953],
            [-17.088500623592466, -8.164985722471004],
            [-17.03043182452591, -8.164099209740508],
            [-16.96720972285669, -8.162245367693556],
            [-16.90398684807446, -8.160417544762488],
            [-16.843097997107787, -8.157778713834514],
            [-16.782208083153552, -8.155164020346582],
            [-16.6970671538785, -8.150493539745261],
            [-16.63191742314273, -8.1463649853822],
            [-16.60802726053907, -8.144730396626647],
            [-16.544387048759386, -8.139814584901034],
            [-16.480744758078604, -8.134925156489052],
            [-16.42467824187688, -8.129830615567688],
            [-16.368609824320234, -8.124756558201486],
            [-16.30627471435972, -8.118246253865884],
            [-16.243936899255903, -8.11176127923093],
            [-16.170578004863515, -8.10328012546783],
            [-16.177262200156555, -8.048618233259045],
            [-16.19142092366405, -7.93277323023968],
            [-16.131764085148088, -7.9251895388707565],
            [-16.072104181969035, -7.917629395328092],
            [-16.00729162848792, -7.908433690780986],
            [-15.942475029136183, -7.899265797131504],
            [-15.878650844859964, -7.889232327749172],
            [-15.814822303033843, -7.8792258462907],
            [-15.750088068361345, -7.868093685553255],
            [-15.685348964362312, -7.856989316530644],
            [-15.621986993259425, -7.845302225976165],
            [-15.558620202018405, -7.833641817673566],
            [-15.552133037098226, -7.832393438264398],
            [-15.531449396372377, -7.935769472967529],
            [-15.513735404593444, -8.0242427393757],
            [-15.48765090273577, -8.15448669217697],
            [-15.417938807227632, -8.502367948248436],
            [-15.380750275532888, -8.687776161830252],
            [-15.372102125812555, -8.730871172668675],
            [-15.37444775807215, -8.731441456847573],
            [-15.375803907045656, -8.732148213834263],
            [-15.378552708538331, -8.734986852891893],
            [-15.378421379249385, -8.736088776315555],
            [-15.38199871341649, -8.737143895681987],
            [-15.38364517528042, -8.738771370811346],
            [-15.383741932442545, -8.739741274370916],
            [-15.386140289465203, -8.739968165743212],
            [-15.386802083635784, -8.740916088862292],
            [-15.387412815263318, -8.744463479704416],
            [-15.389291523788463, -8.745826657643367],
            [-15.386983193561322, -8.747497111836537],
            [-15.390297880862466, -8.748854764683461],
            [-15.389982406182273, -8.75076102817667],
            [-15.39151111697816, -8.751801593696662],
            [-15.391679761644788, -8.754366698296863],
            [-15.394701752526503, -8.758409111951947],
            [-15.399158739205445, -8.759659377416847],
            [-15.399876104400478, -8.760441340497108],
            [-15.398325951713078, -8.761685269011249],
            [-15.399823958911472, -8.762598105919361],
            [-15.399041833262563, -8.764037045435863],
            [-15.399530442818783, -8.764840757542013],
            [-15.40113001735696, -8.764634545674832],
            [-15.400486408098823, -8.76644362195385],
            [-15.401992457996558, -8.76709288972902],
            [-15.401782858131938, -8.768024806504727],
            [-15.402555298741413, -8.770763738350416],
            [-15.405100175835388, -8.773607176555926],
            [-15.404866788488528, -8.775773001675011],
            [-15.406888901237576, -8.778093991066747],
            [-15.40727501529849, -8.779518783221848],
            [-15.408687898957501, -8.781189327813951],
            [-15.409127633922738, -8.78368627697435],
            [-15.410640557382276, -8.783297459038385],
            [-15.410557330376673, -8.785161165941638],
            [-15.411138359589446, -8.78577994075542],
            [-15.410945547412812, -8.790368393745906],
            [-15.410589659586448, -8.791581402571449],
            [-15.409127073945264, -8.793506157427478],
            [-15.409280205541071, -8.79486302439617],
            [-15.41021487316415, -8.79690424053176],
            [-15.409705996788821, -8.799436541175332],
            [-15.411397249058988, -8.802842980793413],
            [-15.410817380617978, -8.80416683288212],
            [-15.413299009954818, -8.805759837505068],
            [-15.41287193611603, -8.808329922022798],
            [-15.414029724416933, -8.809817913949054],
            [-15.415242329347615, -8.810586927162134],
            [-15.414887152893096, -8.812242403661227],
            [-15.411388603386369, -8.813480056826252],
            [-15.411354123549511, -8.816216283889451],
            [-15.411654283001504, -8.817956182915044],
            [-15.412815659452114, -8.819035697321246],
            [-15.414264798358987, -8.8194639775324],
            [-15.415637898811196, -8.82088359389124],
            [-15.415894644293278, -8.822504507203895],
            [-15.417341055975049, -8.82400516506965],
            [-15.419563590369261, -8.82844514162919],
            [-15.420973848261402, -8.828898869813214],
            [-15.423080150418484, -8.827786011932764],
            [-15.424924458945885, -8.827307812315802],
            [-15.426015648637705, -8.82767679717857],
            [-15.42668719849052, -8.830020743958368],
            [-15.426780155680287, -8.831675904723898],
            [-15.426160421146385, -8.832571419698908],
            [-15.426141629512244, -8.834293495104086],
            [-15.426719054934408, -8.8350326019717],
            [-15.42636936147649, -8.836838039920872],
            [-15.42743549990605, -8.8377772371004],
            [-15.428842332965882, -8.835907663872252],
            [-15.431389546723935, -8.835611657481245],
            [-15.431998872360381, -8.836704446555531],
            [-15.431592824253851, -8.839168813194199],
            [-15.432090580209993, -8.840593664300881],
            [-15.431765228163885, -8.842210998907033],
            [-15.432104268733655, -8.844312835646061],
            [-15.434063263383047, -8.845825676040295],
            [-15.435624080345384, -8.846087903823422],
            [-15.437011401366922, -8.845652637812984],
            [-15.438271904230861, -8.84707270179034],
            [-15.437639714681684, -8.848209527680892],
            [-15.440988816544406, -8.848159553268816],
            [-15.442032813443355, -8.848873516308162],
            [-15.44202127760716, -8.849933038884176],
            [-15.440319923713181, -8.850815428043884],
            [-15.439733483924808, -8.853841411040275],
            [-15.438981258591252, -8.85546367854771],
            [-15.440314316384779, -8.856411182444546],
            [-15.442838440952842, -8.855115259730844],
            [-15.443796012646729, -8.855701710952308],
            [-15.444385489789866, -8.8582286734143],
            [-15.44508407129751, -8.858542911281809],
            [-15.447905662530262, -8.857327645991303],
            [-15.449000513040588, -8.857343499094064],
            [-15.452974325491507, -8.860812383126843],
            [-15.454565797002504, -8.861645028039451],
            [-15.453658342576375, -8.863258717104273],
            [-15.455898206841464, -8.865712097319642],
            [-15.456880736949135, -8.865617629085428],
            [-15.458331926713178, -8.864531169261536],
            [-15.460104294704815, -8.865299728126082],
            [-15.461355738378632, -8.866652178760697],
            [-15.461681873725503, -8.869260479956612],
            [-15.46016974727855, -8.873542592026839],
            [-15.460168384627828, -8.876108714558057],
            [-15.463187745223973, -8.878361441148916],
            [-15.462935235170104, -8.880059816091501],
            [-15.463660684281844, -8.88124201499827],
            [-15.465798883227388, -8.881861552596224],
            [-15.467503545947796, -8.884077333855684],
            [-15.466773244365335, -8.886256878088249],
            [-15.467339028601009, -8.88734163136513],
            [-15.469404782789148, -8.888765491729169],
            [-15.47143099915092, -8.889495801137013],
            [-15.473592979437173, -8.888106611358255],
            [-15.47263742906728, -8.885175417910775],
            [-15.472609204997633, -8.882924254700795],
            [-15.474315009205583, -8.882075993801008],
            [-15.475655823926292, -8.88253890426904],
            [-15.476475783570592, -8.883695573439441],
            [-15.47566738895614, -8.885372867785405],
            [-15.477229670026519, -8.88762728486521],
            [-15.477265538841998, -8.889005947674324],
            [-15.479149946153939, -8.890106807277594],
            [-15.482881770520038, -8.889933775542925],
            [-15.485115653657463, -8.891634347559876],
            [-15.485732889414974, -8.892574114808857],
            [-15.487241068861525, -8.892428554420974],
            [-15.488493692036256, -8.890882743095135],
            [-15.489687115738448, -8.89063090293294],
            [-15.490511274496564, -8.891655722577966],
            [-15.491808203422622, -8.891557130295487],
            [-15.49148784261172, -8.889923278090077],
            [-15.49213337692973, -8.888833212086636],
            [-15.493884038732055, -8.890040684110646],
            [-15.495030064943407, -8.889580259417794],
            [-15.494865141631681, -8.888286745095224],
            [-15.497536499783468, -8.887706267023768],
            [-15.498582384565998, -8.886130909751419],
            [-15.500359497551761, -8.88792972797618],
            [-15.501772250109601, -8.886924450991847],
            [-15.503200186433654, -8.888732409175045],
            [-15.504229729879166, -8.888182780154155],
            [-15.50539591129778, -8.886177611357269],
            [-15.506769991683734, -8.885363924858678],
            [-15.508546918030994, -8.886886446195904],
            [-15.508298133116607, -8.88823126901864],
            [-15.509539694985715, -8.88885188833866],
            [-15.510724063031805, -8.887867961581481],
            [-15.512328361003371, -8.889135228361418],
            [-15.51333584815032, -8.888028277632078],
            [-15.515275191158414, -8.888078244831723],
            [-15.515586511819834, -8.889311968299127],
            [-15.514087237112879, -8.889857798599522],
            [-15.514424215500577, -8.890853219523063],
            [-15.519100473007482, -8.891442089354639],
            [-15.520459380058366, -8.8932584725416],
            [-15.519744897753935, -8.894467485842702],
            [-15.521706545667078, -8.895517407491969],
            [-15.525214763080351, -8.896009245590895],
            [-15.52572035097686, -8.897723774229307],
            [-15.52785829154134, -8.898454499067883],
            [-15.52886759553588, -8.899671064266506],
            [-15.531665894012788, -8.900680611234366],
            [-15.532614221509295, -8.902311956305464],
            [-15.534257052407101, -8.903719728152618],
            [-15.533801497827058, -8.905643460225809],
            [-15.536417495100881, -8.906114700028594],
            [-15.536806407357238, -8.907850570124696],
            [-15.538376476157161, -8.91017339909566],
            [-15.53984220718689, -8.911236609703726],
            [-15.540886829406508, -8.91272109256881],
            [-15.542777300615759, -8.912788156698397],
            [-15.544959156187579, -8.913859162211924],
            [-15.545527660776804, -8.915158667181565],
            [-15.546982421881893, -8.915386850557207],
            [-15.545294908939077, -8.916992622224107],
            [-15.546869920283937, -8.918745649319987],
            [-15.54662408874648, -8.92053312675373],
            [-15.548552451302566, -8.920477702561357],
            [-15.548586415952977, -8.921501284973335],
            [-15.547638780973989, -8.922976403818277],
            [-15.548725722788287, -8.923789206760226],
            [-15.550304168948463, -8.926220052596268],
            [-15.551075711602618, -8.926504956202454],
            [-15.553359297561068, -8.928578787478386],
            [-15.556467130920904, -8.927774262101007],
            [-15.559206802339002, -8.929124138685276],
            [-15.562106242638375, -8.92740520022108],
            [-15.566720386686116, -8.925319757006957],
            [-15.568657489914498, -8.92478663223338],
            [-15.570988579440693, -8.924937802378933],
            [-15.574520259459874, -8.927330809154821],
            [-15.578344680164921, -8.932177662883522],
            [-15.578735016510128, -8.93294185050128],
            [-15.579216552554291, -8.937264383864706],
            [-15.57898238491261, -8.943085946897655],
            [-15.57997398182258, -8.94576411509576],
            [-15.581619685972553, -8.947357604884578],
            [-15.58303824404892, -8.948042784799993],
            [-15.583029340422524, -8.949129469684692],
            [-15.585306128587796, -8.951042603505304],
            [-15.588052175364318, -8.951785005870146],
            [-15.591187071199668, -8.954231216875666],
            [-15.59239194744833, -8.955841264267717],
            [-15.59127492158167, -8.956654834925352],
            [-15.590325648531707, -8.956232239242546],
            [-15.589484691942904, -8.954425321977569],
            [-15.588222369623924, -8.955719528883659],
            [-15.589166359375813, -8.956923859246578],
            [-15.586583286107128, -8.957306123535643],
            [-15.584780502857434, -8.956326400097169],
            [-15.584125550236674, -8.957628341625693],
            [-15.585786778277463, -8.957880995473811],
            [-15.585952431709325, -8.958870587663647],
            [-15.584502150467557, -8.959930458066417],
            [-15.585121403007102, -8.962043588901928],
            [-15.582626673053808, -8.963408690052512],
            [-15.58169143357173, -8.966053923976865],
            [-15.583288911799787, -8.966828825002276],
            [-15.582717607736477, -8.969783237406928],
            [-15.583993087780515, -8.972317273935657],
            [-15.582446101332195, -8.972382074445786],
            [-15.581536023834271, -8.973176756223072],
            [-15.580730685728467, -8.975092075757386],
            [-15.580616233062079, -8.976721179886919],
            [-15.581183565326553, -8.978866386931443],
            [-15.580191322218893, -8.980380262680766],
            [-15.580370021177448, -8.981685262049663],
            [-15.583540201700782, -8.98051809327843],
            [-15.583264672425244, -8.981990937556017],
            [-15.581782995393427, -8.982672398721071],
            [-15.58198140439875, -8.983574330028308],
            [-15.583674530711876, -8.984506094610339],
            [-15.584514816006271, -8.985888920336778],
            [-15.58199080959468, -8.98696218962295],
            [-15.582133109583602, -8.988141393840406],
            [-15.583727127033963, -8.988898158209613],
            [-15.583167364153535, -8.990005104733257],
            [-15.584097904436662, -8.990719865134771],
            [-15.584141232884791, -8.99227773295073],
            [-15.584955375664684, -8.992958361664746],
            [-15.584167463685931, -8.994252343354841],
            [-15.584305536523997, -8.99556324983215],
            [-15.585529059251316, -8.99660127913158],
            [-15.585589394911857, -8.997520786690217],
            [-15.586851644266757, -8.999031337385707],
            [-15.5866622916611, -8.9999677006322],
            [-15.588419883370605, -9.001686766322196],
            [-15.58761895683362, -9.002767844681179],
            [-15.588937075094266, -9.003891238860945],
            [-15.590104682282703, -9.006533929543458],
            [-15.591801774670815, -9.007444159889188],
            [-15.592245522490671, -9.008350630060976],
            [-15.592182925498518, -9.010414488330873],
            [-15.592870280984096, -9.011793870480746],
            [-15.5915482620281, -9.013347866716394],
            [-15.591918854607655, -9.01450564212094],
            [-15.594076790175542, -9.016679850957631],
            [-15.595071666844476, -9.016743419669325],
            [-15.597199257196701, -9.015636075051658],
            [-15.598280172654308, -9.015827251920884],
            [-15.59982194142096, -9.01495853200171],
            [-15.601105362184336, -9.014924157884723],
            [-15.601669553965063, -9.015788017254252],
            [-15.603129592289136, -9.015766284580321],
            [-15.604766264291483, -9.01653202047252],
            [-15.607811419954164, -9.020740807974816],
            [-15.60870727611596, -9.024171485058751],
            [-15.610093948597038, -9.026060778678554],
            [-15.611411771877213, -9.026409654014785],
            [-15.612652089986987, -9.025924244725822],
            [-15.612776998674269, -9.024200307062877],
            [-15.611739193284082, -9.021804257912141],
            [-15.613130224176276, -9.021127265233327],
            [-15.614715080870448, -9.022701700527504],
            [-15.614960643889228, -9.024033667555036],
            [-15.61614483930458, -9.025706348722673],
            [-15.617221520088515, -9.025586919998164],
            [-15.617324999135258, -9.023858836342043],
            [-15.61820795541603, -9.023147929640842],
            [-15.619697898192303, -9.023752133842754],
            [-15.620585174772774, -9.024790283481574],
            [-15.620494471434494, -9.026233476463428],
            [-15.618655545820422, -9.027685007176684],
            [-15.618698394945088, -9.030238722225533],
            [-15.620149644457227, -9.031034596266363],
            [-15.622005863671985, -9.03071501150609],
            [-15.624529541577616, -9.02853536858949],
            [-15.62569231909674, -9.02876504342354],
            [-15.626958376687039, -9.030365011397674],
            [-15.62657037897496, -9.03371904499015],
            [-15.627603908762534, -9.0332592419116],
            [-15.628404907163329, -9.03417021399689],
            [-15.62700467456837, -9.038984226726171],
            [-15.628236107809911, -9.040422581358818],
            [-15.629536765118974, -9.039085897934724],
            [-15.630075467957464, -9.03675756898795],
            [-15.631324403751746, -9.036782939642714],
            [-15.630863401087831, -9.03894951614366],
            [-15.632748954043246, -9.042907792575797],
            [-15.633243669869056, -9.045440432378948],
            [-15.635121344318437, -9.045235703708776],
            [-15.635888301728135, -9.042554159989947],
            [-15.63662907706785, -9.041660178106223],
            [-15.638424685759064, -9.042856197877262],
            [-15.637700623310243, -9.046099539027855],
            [-15.638221400174482, -9.04717617503441],
            [-15.640981758971304, -9.046814291106418],
            [-15.643370865059275, -9.050495962525419],
            [-15.643331669117897, -9.052679389612305],
            [-15.644063391690342, -9.053820083997495],
            [-15.643959716695495, -9.05565865212035],
            [-15.64452780236162, -9.056390803414331],
            [-15.646495532686373, -9.056956640839475],
            [-15.648794478785899, -9.058761329587748],
            [-15.65006412695792, -9.061004382629223],
            [-15.653232639644726, -9.063268845563456],
            [-15.655661123204064, -9.063328372941601],
            [-15.658439142895869, -9.061221069785024],
            [-15.659804018929947, -9.061225534613806],
            [-15.661745279858604, -9.063247195631858],
            [-15.66186955049275, -9.06506467167335],
            [-15.660345425508684, -9.064519837793053],
            [-15.657761060768658, -9.067661047882675],
            [-15.65875931516311, -9.069363719486933],
            [-15.661127243845977, -9.070163986066175],
            [-15.66092841874962, -9.072470866071086],
            [-15.659773749775756, -9.0747440824884],
            [-15.657933039068826, -9.076344127272431],
            [-15.658696260430029, -9.077463687898765],
            [-15.661671448636884, -9.077421062052368],
            [-15.665516138920726, -9.077893749839122],
            [-15.665735287894995, -9.078910806401165],
            [-15.662402245326112, -9.080664606834324],
            [-15.662440362700908, -9.082243909265493],
            [-15.664084078486532, -9.084627634279315],
            [-15.66640031100032, -9.0851296700095],
            [-15.668858978629105, -9.084265791172125],
            [-15.670133245835185, -9.084716712931195],
            [-15.671635906915242, -9.084261300651484],
            [-15.673241643001296, -9.08495530149112],
            [-15.67319316950632, -9.087402626400042],
            [-15.675008698161909, -9.090484506007115],
            [-15.676286746196794, -9.091578702105233],
            [-15.678934171010308, -9.092323518343719],
            [-15.68025054318936, -9.094443283537396],
            [-15.67950099916833, -9.095269085757604],
            [-15.677185044470681, -9.094766756617723],
            [-15.675130941965826, -9.096175508970028],
            [-15.674639063046168, -9.098380378227123],
            [-15.675826730301074, -9.099478780826255],
            [-15.675869022025344, -9.101368754599545],
            [-15.674439537546428, -9.101794369178611],
            [-15.67274674197492, -9.10385030053247],
            [-15.672543797994548, -9.105182659621534],
            [-15.670341754325804, -9.107327841418002],
            [-15.670450240198203, -9.109461211696217],
            [-15.67155452985234, -9.112602120766834],
            [-15.671071528786591, -9.114377245656984],
            [-15.6711524694837, -9.116131001859314],
            [-15.67068195803659, -9.118783169449193],
            [-15.671072538754512, -9.121273497686811],
            [-15.670792454709307, -9.121882168399484],
            [-15.671419881815275, -9.124197990463719],
            [-15.670764600818393, -9.126215589086652],
            [-15.671379216854572, -9.128041775199028],
            [-15.671033787503296, -9.130187278678871],
            [-15.669883395751903, -9.13266077466544],
            [-15.667576593831537, -9.131783824249034],
            [-15.665896960181051, -9.13377628991168],
            [-15.661475062466547, -9.13648853587859],
            [-15.660231251994972, -9.136441844496442],
            [-15.660320882500574, -9.137987286617093],
            [-15.65904225954188, -9.1387748280015],
            [-15.659011428033734, -9.140252212886123],
            [-15.659699321446638, -9.141937928024857],
            [-15.661016372135663, -9.141954846202509],
            [-15.662861398511554, -9.144998357531911],
            [-15.66445729822517, -9.14706285623994],
            [-15.666514499199163, -9.14762446891878],
            [-15.668636837746252, -9.146649442578825],
            [-15.670935077172034, -9.147125894480238],
            [-15.672062149826514, -9.148079545449038],
            [-15.671380926040342, -9.150446492731923],
            [-15.669284002158653, -9.152069170403017],
            [-15.669653217752058, -9.153779998774699],
            [-15.671507436809572, -9.154799497742989],
            [-15.67143097780292, -9.155874637501448],
            [-15.669479077145844, -9.157730650473388],
            [-15.667391848098415, -9.157428518715694],
            [-15.665842319745657, -9.157786425004572],
            [-15.664765535513864, -9.159344703269294],
            [-15.666740298834583, -9.162158304214303],
            [-15.666033929560134, -9.163667889785106],
            [-15.668144101469634, -9.165658032804542],
            [-15.669905889899482, -9.165858969075622],
            [-15.670858290030056, -9.16762258972765],
            [-15.673522433302088, -9.17067320432362],
            [-15.677934467880792, -9.174090748276763],
            [-15.679092877027081, -9.178421873903204],
            [-15.680268007175654, -9.181340423248518],
            [-15.679467070549546, -9.182200572302557],
            [-15.680580837382067, -9.183549699485487],
            [-15.680571117875736, -9.18644019978281],
            [-15.682176030378551, -9.18782968185691],
            [-15.682186103853793, -9.18931430444941],
            [-15.682854539359269, -9.19047137208483],
            [-15.681964327415907, -9.19206857341065],
            [-15.682199876737949, -9.1957893210242],
            [-15.685655597339101, -9.197533811670715],
            [-15.687569377364888, -9.198055153368427],
            [-15.688273307480124, -9.199289578669381],
            [-15.688290043072284, -9.201514764159503],
            [-15.69024322133113, -9.201365195291901],
            [-15.690566725495104, -9.202228237702807],
            [-15.692464509173009, -9.20375716272791],
            [-15.694543553043756, -9.203975609473211],
            [-15.696594872655995, -9.20566435997554],
            [-15.698011357697276, -9.20542238340498],
            [-15.699955190551153, -9.205882689794745],
            [-15.702822421110959, -9.204792783809998],
            [-15.705282068567655, -9.205024487663133],
            [-15.708555654644856, -9.204562848015645],
            [-15.71059311226102, -9.205335449822083],
            [-15.712049697720166, -9.205034029455506],
            [-15.713606010026735, -9.20358145198902],
            [-15.716044111654767, -9.203011620285078],
            [-15.719029409117597, -9.20418285114101],
            [-15.722066184798392, -9.203442683542837],
            [-15.722736548604681, -9.20275249674457],
            [-15.727154614058835, -9.202381601914452],
            [-15.731830339540537, -9.202868514348252],
            [-15.73810881258138, -9.202153378413543],
            [-15.742021427863806, -9.203449360064132],
            [-15.7424861004342, -9.20228379410127],
            [-15.744156485365071, -9.200331813950772],
            [-15.745326833155495, -9.200463989383719],
            [-15.745950165525311, -9.197360779717414],
            [-15.744765312162501, -9.195970732488352],
            [-15.745125465462532, -9.193093382742013],
            [-15.747383446199427, -9.191577532399908],
            [-15.748732976532592, -9.19148161844544],
            [-15.752693231701414, -9.192040328871581],
            [-15.75378507534468, -9.191240046108838],
            [-15.75461313484356, -9.188980830474836],
            [-15.754493746849274, -9.187291323145095],
            [-15.752946021810349, -9.18517597068125],
            [-15.753405672503202, -9.183122342851993],
            [-15.752249583260724, -9.181164406385959],
            [-15.75361748256414, -9.180038943314452],
            [-15.753372617949339, -9.17917807178421],
            [-15.751186350576821, -9.177448495972923],
            [-15.749339873359427, -9.177479999272428],
            [-15.747299372327607, -9.17375087649508],
            [-15.746106729056317, -9.173082346246558],
            [-15.743923762430935, -9.170878282255348],
            [-15.744064678506113, -9.169249923192137],
            [-15.745239539371106, -9.167707417411805],
            [-15.74733085091149, -9.16817977376186],
            [-15.748062654603023, -9.167464157877683],
            [-15.751078963459483, -9.16756975374316],
            [-15.752881995721197, -9.166303107053771],
            [-15.75410921736104, -9.16476971677804],
            [-15.758243978492999, -9.164807823890136],
            [-15.759103052217402, -9.164156193914804],
            [-15.760013727720224, -9.162252850963869],
            [-15.75826896342371, -9.161180009123203],
            [-15.757544040035924, -9.160124057914564],
            [-15.757389479011096, -9.158154656929186],
            [-15.755498460122462, -9.157251750163793],
            [-15.755039230347304, -9.155447093463946],
            [-15.753626970359555, -9.153654939877024],
            [-15.755286733629044, -9.151361742494972],
            [-15.754877399066178, -9.149583313172677],
            [-15.75635843497762, -9.147238014891533],
            [-15.75922090496857, -9.144616844129427],
            [-15.75852954936132, -9.144239636433696],
            [-15.757696626880714, -9.142009163116741],
            [-15.754292011855332, -9.139356431484725],
            [-15.755662961305289, -9.136096408060661],
            [-15.756720255125428, -9.134650271303611],
            [-15.755605134335475, -9.132500167119845],
            [-15.754399900500376, -9.128887237896615],
            [-15.754030477984857, -9.126486409743242],
            [-15.754699747247397, -9.12501772327995],
            [-15.759540913927035, -9.12240507216677],
            [-15.760136307747633, -9.121463121578637],
            [-15.757974130353244, -9.119684333753595],
            [-15.757913957053916, -9.118869381604348],
            [-15.755876578053813, -9.117623774261123],
            [-15.755072390079429, -9.115339939552516],
            [-15.752820467071894, -9.113117060075313],
            [-15.750209530186856, -9.112279665674851],
            [-15.74873417736512, -9.107693298281164],
            [-15.749459037264566, -9.106106819768799],
            [-15.749050597759327, -9.103702781187486],
            [-15.748104816659632, -9.101708557471586],
            [-15.749528714860917, -9.101055465782263],
            [-15.752439596712938, -9.097658429619653],
            [-15.753624290588549, -9.09827885682543],
            [-15.755461592453672, -9.097683018485121],
            [-15.758128542918332, -9.097302512330248],
            [-15.759686809830733, -9.09514783221931],
            [-15.760886323064064, -9.09446138059572],
            [-15.763386854516593, -9.094004905777254],
            [-15.765983880361059, -9.092333389733195],
            [-15.765298135625573, -9.089816360038528],
            [-15.767199456518776, -9.085982342454951],
            [-15.76537246788992, -9.085281672372528],
            [-15.763553064252697, -9.085652603922847],
            [-15.761420400757622, -9.086983858472419],
            [-15.760607674400914, -9.086725457177735],
            [-15.759993511456729, -9.082142002506599],
            [-15.760292392658128, -9.080907705359659],
            [-15.757638277727251, -9.07682479857678],
            [-15.755970723749131, -9.076803699271332],
            [-15.753758694086287, -9.075511244910883],
            [-15.752800473884756, -9.073787273043783],
            [-15.74856469406292, -9.073586268352585],
            [-15.747424695351727, -9.07139902982118],
            [-15.74330719236208, -9.06898574832349],
            [-15.74382376731916, -9.066595901669954],
            [-15.743040718695863, -9.06583888584523],
            [-15.741605998095642, -9.063236905825338],
            [-15.741832185812536, -9.061964614737368],
            [-15.741214266810232, -9.060657934833428],
            [-15.740903785769213, -9.057243394354302],
            [-15.742003654524705, -9.056768729491159],
            [-15.744129287635719, -9.054041004146116],
            [-15.74673051287448, -9.054322050795202],
            [-15.74766766566249, -9.052135226537924],
            [-15.750374394332889, -9.05207789635536],
            [-15.752795197701657, -9.050906882820918],
            [-15.754159941281003, -9.049462828186268],
            [-15.755481758631182, -9.049373302904895],
            [-15.75711367828884, -9.050249714291668],
            [-15.758147658362695, -9.052923676525714],
            [-15.760846682279437, -9.053213247548147],
            [-15.766237906984424, -9.051407089924956],
            [-15.767788570893417, -9.051477912406584],
            [-15.768310311818288, -9.053221437094697],
            [-15.771872450426349, -9.05439704621541],
            [-15.773767441130765, -9.05316702353402],
            [-15.776728429100116, -9.052689484498671],
            [-15.777474896432382, -9.056354777249329],
            [-15.778765435610786, -9.05708833938514],
            [-15.780661171664551, -9.055138469699807],
            [-15.782832416171127, -9.055558973261693],
            [-15.785798466913679, -9.05441635794371],
            [-15.787027659362437, -9.05546049982816],
            [-15.787834351682125, -9.055195282615989],
            [-15.789148211303312, -9.057424999290411],
            [-15.791446293799785, -9.056937742728392],
            [-15.793830206502129, -9.056004220544022],
            [-15.795837622829962, -9.057258565132743],
            [-15.796782908693942, -9.058400304714828],
            [-15.799414066526039, -9.05775789229615],
            [-15.801172544410193, -9.05936808351366],
            [-15.803358544733799, -9.060158330344658],
            [-15.804723949769516, -9.059626315861554],
            [-15.805683397438761, -9.061115191014295],
            [-15.804864545380722, -9.065184264546934],
            [-15.805728702116873, -9.066202073584885],
            [-15.805446986796273, -9.067442741203037],
            [-15.806036631470612, -9.068632409070748],
            [-15.808363676416985, -9.069306081746069],
            [-15.809535283026664, -9.069110226513825],
            [-15.809616213263437, -9.070468217464652],
            [-15.813239153561463, -9.071779716093625],
            [-15.815815655203048, -9.074794901989247],
            [-15.816939518286892, -9.07479937443084],
            [-15.818426010417562, -9.076606183911501],
            [-15.81958528327044, -9.080322706549035],
            [-15.822086587414182, -9.079885899589192],
            [-15.823691190550566, -9.076105157926385],
            [-15.826622206399962, -9.073892216401102],
            [-15.829344083525294, -9.073639284265289],
            [-15.832252061446733, -9.075900204268699],
            [-15.834143287467723, -9.079035177049848],
            [-15.83821695673226, -9.076337835395513],
            [-15.84042807073535, -9.075901820755922],
            [-15.84271106299847, -9.076719875563382],
            [-15.844211479803423, -9.07457522053108],
            [-15.85077918578712, -9.071449214267176],
            [-15.854097961073718, -9.07136476543605],
            [-15.85550452045314, -9.070600728692826],
            [-15.857164991606593, -9.06897713078471],
            [-15.859834487288824, -9.068950427758045],
            [-15.860505593012858, -9.069630753909886],
            [-15.860290951657499, -9.073691167126391],
            [-15.866750018789949, -9.0726438150951],
            [-15.868233662241295, -9.07141598031464],
            [-15.873128897352686, -9.068933638301244],
            [-15.878444439883886, -9.06684050533437],
            [-15.881917667230338, -9.067996977376856],
            [-15.882019694134623, -9.066223061760454],
            [-15.885464789341786, -9.063999419560346],
            [-15.886725100048293, -9.062545962198357],
            [-15.889907589083709, -9.062272818779807],
            [-15.891808073547073, -9.066893251927844],
            [-15.895552521831709, -9.067206164662522],
            [-15.90055467338785, -9.064494639699879],
            [-15.902212185875483, -9.06439508029834],
            [-15.90283056262646, -9.066040873152497],
            [-15.903929806860434, -9.066417080977585],
            [-15.90561409957822, -9.069198982476781],
            [-15.907250372601952, -9.069598141357828],
            [-15.907056274592435, -9.070907001901356],
            [-15.908354600321374, -9.072170005693131],
            [-15.909829971763088, -9.072390497538729],
            [-15.912045641785166, -9.07408232503693],
            [-15.91362417874777, -9.076539291666087],
            [-15.91518080794678, -9.077235237482963],
            [-15.915393256611953, -9.079639884681658],
            [-15.91739674846443, -9.080525024954197],
            [-15.91999308484946, -9.080219344293653],
            [-15.920578526668614, -9.080915636867068],
            [-15.922725808187069, -9.081460982604499],
            [-15.92466063924633, -9.080708309022079],
            [-15.926337681319938, -9.081548297460648],
            [-15.928311011172333, -9.083891996669886],
            [-15.928695413876412, -9.084951631614883],
            [-15.931359642309914, -9.087743321437658],
            [-15.93208001278988, -9.089920675634998],
            [-15.934452826501401, -9.092315259362824],
            [-15.935538565383219, -9.09161756357307],
            [-15.937115774250612, -9.091883147323811],
            [-15.939757328011126, -9.093269891057782],
            [-15.94151714353871, -9.093825237623202],
            [-15.9431576991211, -9.092981993704681],
            [-15.943920561855807, -9.094138537500365],
            [-15.945796556555385, -9.09288603292002],
            [-15.947982928997824, -9.093789480655616],
            [-15.948771418441414, -9.09506181821977],
            [-15.951349149123745, -9.095005536412456],
            [-15.952591839074815, -9.094422972312078],
            [-15.954158973952111, -9.095921972382737],
            [-15.955905214843295, -9.095008844986422],
            [-15.955511603235772, -9.092420326678393],
            [-15.957572229434223, -9.091645166434366],
            [-15.960017337833989, -9.089845454003308],
            [-15.961373576194921, -9.090930732607802],
            [-15.96419233680535, -9.090609573189436],
            [-15.964780292106838, -9.09379659166494],
            [-15.966109067790077, -9.0951486573363],
            [-15.96541119738039, -9.09635764353686],
            [-15.965763779502183, -9.097251238181538],
            [-15.96771299336974, -9.098147178592745],
            [-15.969316759701835, -9.09780281725475],
            [-15.972065798419, -9.099193923172049],
            [-15.972618345258166, -9.099004331650761],
            [-15.973402479623143, -9.09682722647719],
            [-15.975480414432798, -9.098222565912149],
            [-15.977101933105441, -9.10009397336341],
            [-15.977009256898281, -9.105188273722835],
            [-15.979033972454095, -9.105542179396934],
            [-15.979861603148885, -9.106166281696842],
            [-15.981771109098704, -9.10608315194095],
            [-15.984428874257427, -9.106808421738961],
            [-15.986131747904693, -9.106535047135294],
            [-15.988197635396228, -9.108200221345399],
            [-15.990016907376006, -9.110469681108956],
            [-15.99201002976377, -9.10977635562671],
            [-15.994177035572617, -9.112063324885693],
            [-15.995792792101907, -9.111712209593357],
            [-15.997247508079846, -9.107960539556032],
            [-15.99706588513509, -9.106538433936885],
            [-15.9984765022598, -9.105283746830859],
            [-16.00025793610294, -9.104601642303788],
            [-16.001542601027094, -9.102804004632274],
            [-16.000324260400586, -9.101904772930158],
            [-16.000439459745085, -9.099806074276591],
            [-16.00233719236594, -9.09961918560263],
            [-16.0032992305289, -9.098524928603139],
            [-16.005687770536614, -9.098524777199728],
            [-16.008115170634973, -9.099277937729982],
            [-16.013076686715483, -9.101727333184149],
            [-16.01421373561884, -9.102055627013103],
            [-16.015244873504674, -9.100778039181511],
            [-16.015811576595226, -9.098892813729154],
            [-16.01465537205405, -9.096877988754718],
            [-16.01329475564416, -9.095554086395973],
            [-16.01333877000924, -9.093439193784064],
            [-16.012529812484935, -9.091717135069521],
            [-16.011308362567036, -9.090587245778584],
            [-16.00886084142194, -9.090317225744208],
            [-16.007273878577276, -9.088793996084746],
            [-16.005240752173417, -9.08752957202348],
            [-16.002294622547485, -9.084723921923448],
            [-16.002039059528745, -9.082708725576394],
            [-16.002602194395713, -9.081748286366977],
            [-16.002165445716543, -9.08009120140304],
            [-16.000717284032756, -9.07841530841261],
            [-15.997115641134803, -9.076795019375297],
            [-15.996511438269563, -9.074703869506429],
            [-15.997579360403035, -9.073504213708361],
            [-15.99784894200831, -9.070969665364034],
            [-15.999410229994114, -9.071240023108384],
            [-16.001984048543722, -9.070617693726563],
            [-16.004231558233396, -9.06965256046486],
            [-16.003156324781123, -9.06721253907173],
            [-16.005444448706218, -9.064374563967663],
            [-16.005207473743905, -9.062004165984098],
            [-16.005557247259798, -9.06110498156277],
            [-16.007510024660505, -9.0598847837441],
            [-16.00884517914868, -9.06112344576233],
            [-16.01329939475761, -9.062845391200884],
            [-16.016364989344023, -9.06221611698166],
            [-16.01758444370222, -9.06109862898139],
            [-16.01960550906127, -9.060738406805386],
            [-16.020941975306126, -9.061544007504756],
            [-16.024518184481412, -9.05941182833545],
            [-16.026362016508116, -9.06042084648093],
            [-16.028173846622884, -9.059011914693409],
            [-16.029337844313112, -9.057176950057586],
            [-16.030353235703508, -9.056831530740684],
            [-16.033602210964474, -9.054544236581592],
            [-16.036169001420983, -9.054254929884292],
            [-16.037212707801444, -9.05615266645826],
            [-16.037402624375325, -9.057735509298949],
            [-16.03927643860535, -9.057546126136105],
            [-16.040624709187192, -9.058255332193331],
            [-16.044470218275322, -9.058920196382001],
            [-16.046179013117477, -9.058901052958579],
            [-16.047834063509754, -9.057116817901244],
            [-16.04957464323549, -9.05621414417261],
            [-16.05151846198205, -9.053425563937767],
            [-16.05386573560292, -9.05172490175844],
            [-16.0571734063473, -9.052314816080816],
            [-16.059547772399288, -9.049849577289157],
            [-16.061105231282383, -9.048917129033159],
            [-16.064045344942397, -9.048551865836224],
            [-16.064760105389432, -9.047434728319406],
            [-16.067148236985346, -9.04593076868532],
            [-16.067191533085232, -9.044541978624885],
            [-16.06661518201859, -9.041807707787337],
            [-16.067317683624182, -9.04101368395412],
            [-16.06879134612513, -9.041026899281134],
            [-16.07150033526817, -9.039916394741194],
            [-16.074578273309704, -9.03725273459621],
            [-16.072443761299414, -9.034506338232644],
            [-16.072009121908597, -9.032181357456405],
            [-16.073487540256274, -9.02962763860444],
            [-16.073361469239053, -9.02828093487838],
            [-16.077265053233322, -9.02750639062342],
            [-16.078282360648178, -9.024540730706535],
            [-16.074733709426813, -9.020680697669023],
            [-16.073015038364858, -9.017151186571063],
            [-16.07163199875445, -9.01563678816731],
            [-16.06912451120956, -9.011988675023035],
            [-16.06736098589556, -9.008801787356276],
            [-16.064816573779623, -9.00739625015982],
            [-16.0630607460819, -9.0083516723891],
            [-16.061102365148415, -9.007113074039811],
            [-16.061414047499945, -9.002417994309091],
            [-16.05985117134833, -9.00007166899842],
            [-16.05907850582348, -8.998149554243952],
            [-16.058023579773657, -8.996706423578514],
            [-16.057551434874725, -8.994614147945525],
            [-16.058047550809768, -8.992916037318025],
            [-16.059281037661048, -8.99198345468387],
            [-16.060141653793757, -8.989944825555137],
            [-16.061851003114125, -8.989693556046625],
            [-16.063671852834272, -8.99084292249263],
            [-16.06709613457802, -8.991003027552251],
            [-16.069446726775862, -8.993381177372472],
            [-16.070689956207996, -8.992615457870118],
            [-16.07283162418124, -8.992733962694482],
            [-16.075467394542255, -8.99353902739904],
            [-16.077734336509266, -8.993518861323551],
            [-16.0787702254716, -8.992753498576496],
            [-16.079007872423013, -8.990949570761963],
            [-16.08019491768836, -8.989339543997742],
            [-16.083301193842324, -8.987923977488656],
            [-16.086966460660705, -8.986829695634922],
            [-16.086852625958613, -8.983853484886879],
            [-16.087732982513234, -8.982361358971522],
            [-16.088089423316113, -8.980098335806163],
            [-16.088650922301973, -8.979136537029502],
            [-16.09100216375736, -8.978342065051411],
            [-16.093614076014493, -8.97839895850962],
            [-16.09584314548378, -8.981708809457997],
            [-16.098479092376742, -8.983430547508535],
            [-16.101409495112954, -8.983004621487314],
            [-16.104812892370152, -8.984213637129445],
            [-16.10680638380774, -8.986376291511853],
            [-16.1076290438766, -8.988813640464583],
            [-16.112705618722746, -8.988186838540422],
            [-16.1156613706978, -8.988508796837243],
            [-16.116404441371834, -8.991013592791907],
            [-16.117492781432905, -8.99082566420351],
            [-16.119094177309147, -8.993051282252527],
            [-16.11989113260595, -8.993444673443186],
            [-16.12320961240893, -8.993636709585974],
            [-16.125089971139094, -8.990766604488565],
            [-16.12534523933558, -8.989686042406786],
            [-16.127263207167694, -8.988608338627467],
            [-16.128676194196487, -8.989199163888246],
            [-16.130359359361506, -8.989053955406511],
            [-16.131796159183057, -8.99121451238613],
            [-16.13371280523279, -8.992277242561043],
            [-16.134837871781514, -8.990754550371559],
            [-16.136588712205253, -8.990220592709564],
            [-16.139077820533238, -8.994125448025656],
            [-16.138176714039034, -8.99722956133776],
            [-16.135716668081074, -8.997139531568086],
            [-16.135693354801123, -8.998984935935685],
            [-16.135086351194996, -9.002862331918456],
            [-16.134362732699955, -9.003952537652939],
            [-16.13193210674445, -9.004876723792805],
            [-16.13198128826885, -9.00718509327441],
            [-16.134182242590313, -9.010840364909683],
            [-16.136270960365934, -9.012520717155912],
            [-16.13624377668007, -9.014313931285665],
            [-16.138966423748943, -9.021114002970627],
            [-16.142593144426698, -9.02260667315306],
            [-16.143826307346476, -9.023626968131442],
            [-16.146804568672923, -9.022719591293905],
            [-16.14885291176346, -9.023138886011026],
            [-16.150884455402803, -9.026435269899553],
            [-16.153657054299735, -9.027741894541727],
            [-16.155181015222745, -9.027956561498044],
            [-16.156922247835936, -9.029215185789289],
            [-16.15844462051581, -9.031886357368803],
            [-16.160837076389598, -9.032990011890684],
            [-16.162901321160543, -9.033237521492612],
            [-16.16335151164269, -9.034623413645356],
            [-16.162262015407162, -9.036316050853047],
            [-16.162946396276237, -9.038102411632972],
            [-16.16452823521289, -9.036558678566685],
            [-16.166161804579392, -9.036255119075907],
            [-16.168340772602264, -9.03852595624195],
            [-16.171613454799132, -9.038158689758998],
            [-16.172514714546296, -9.041153220816511],
            [-16.172539509270504, -9.04233496811735],
            [-16.175009795949638, -9.042582715540712],
            [-16.17663719848491, -9.042081744984817],
            [-16.17788892396046, -9.044310097269891],
            [-16.17899529001623, -9.045237024483775],
            [-16.183405689644946, -9.045578928652649],
            [-16.185414158516174, -9.046858152845603],
            [-16.188147052843597, -9.047873184212584],
            [-16.187862460263332, -9.050965178759345],
            [-16.188607020552322, -9.0520491755115],
            [-16.19149858276871, -9.053307448552578],
            [-16.193549438455737, -9.052909064682252],
            [-16.19534310596761, -9.052118795435925],
            [-16.196421460734797, -9.050880343492848],
            [-16.199232301584637, -9.049489988697278],
            [-16.201896527291584, -9.050969371666007],
            [-16.203305118449975, -9.051193580214628],
            [-16.204150022141516, -9.049478451846385],
            [-16.207056580520753, -9.048182872741007],
            [-16.207967213967812, -9.049123717514869],
            [-16.208436631722652, -9.0508749089685],
            [-16.210126614345725, -9.050488899885677],
            [-16.21487827881296, -9.051134860547073],
            [-16.219275537519938, -9.054906544748784],
            [-16.220362191432443, -9.05436787529123],
            [-16.22222444425382, -9.050930692375863],
            [-16.224710066285834, -9.05004372079304],
            [-16.22943976935346, -9.052831791487135],
            [-16.230250784659084, -9.052869408486886],
            [-16.2334042482444, -9.0549227928535],
            [-16.235784416632598, -9.05451894189557],
            [-16.23877170742552, -9.054856997221941],
            [-16.240636803890418, -9.055397062543078],
            [-16.242772903159533, -9.05476041692777],
            [-16.244453696423708, -9.05618162251158],
            [-16.248105618450698, -9.056866603475452],
            [-16.251156806828188, -9.058625503761165],
            [-16.252551933314926, -9.06150520438862],
            [-16.255455101313604, -9.062525716290791],
            [-16.259451924173604, -9.066548893968884],
            [-16.26119723485511, -9.067496153011835],
            [-16.262733950177594, -9.067781044977865],
            [-16.267630358832893, -9.070954411626829],
            [-16.269265675106126, -9.070967343650972],
            [-16.273638771627684, -9.074112094017357],
            [-16.275509527357176, -9.077251789343029],
            [-16.27740049972652, -9.078935418056085],
            [-16.27804315957948, -9.08001307762296],
            [-16.281012425378368, -9.0827706773549],
            [-16.34256652503995, -9.088491864090393],
            [-16.366154498197563, -9.090583270019103],
            [-16.442367959000823, -9.096946699268855],
            [-16.43262635872575, -9.216256162685312],
            [-16.430712196796275, -9.216103757637459],
            [-16.42813393341526, -9.247573629201174],
            [-16.42420289649897, -9.295604535280589],
            [-16.423206332302357, -9.307773010813433],
            [-16.425274181952183, -9.310206716340701],
            [-16.42286890236044, -9.311894348884675],
            [-16.42104862345018, -9.310997337143545],
            [-16.420092077523, -9.309129844756873],
            [-16.421203489231956, -9.307393692704037],
            [-16.419438760075092, -9.30404185075785],
            [-16.41746705726771, -9.301844025898298],
            [-16.415931776184838, -9.300624798521362],
            [-16.413044851796155, -9.302453311621484],
            [-16.410597348548592, -9.300020669550191],
            [-16.409201421598574, -9.299754892798545],
            [-16.40763546246607, -9.301641880617128],
            [-16.40605202344148, -9.30272857099173],
            [-16.404497161433266, -9.302862615489836],
            [-16.40376331490786, -9.304040125907118],
            [-16.398288015838375, -9.306051208341358],
            [-16.395702164652054, -9.308207583290729],
            [-16.394471430050015, -9.308067218079499],
            [-16.392312977463945, -9.310816192053101],
            [-16.389157209241898, -9.312798752440832],
            [-16.390527559472208, -9.313974164186844],
            [-16.39185762368137, -9.315985754510768],
            [-16.388042852113482, -9.31735965296492],
            [-16.387985981947054, -9.319142657243175],
            [-16.387230098416044, -9.321941460692667],
            [-16.384968037450484, -9.32533389925718],
            [-16.38324393016157, -9.326268509689173],
            [-16.38461097577106, -9.327528996160948],
            [-16.381850940831526, -9.328569877090809],
            [-16.380739743775123, -9.330305344158651],
            [-16.37961997650952, -9.328974173097789],
            [-16.37822324003227, -9.3300391957576],
            [-16.37649084958549, -9.33006772288656],
            [-16.376318260838744, -9.332051012584804],
            [-16.374598919252882, -9.331629365934758],
            [-16.372628129253517, -9.333152826346108],
            [-16.372324099817572, -9.335413309361215],
            [-16.371065565153053, -9.335539312443657],
            [-16.37120312875243, -9.33744409730673],
            [-16.36879307153469, -9.338054504473256],
            [-16.367553460953363, -9.341323186594423],
            [-16.36498439170213, -9.3403944868259],
            [-16.36360001750923, -9.339469463435968],
            [-16.36273671924599, -9.340576072763207],
            [-16.358890160435323, -9.341465322038612],
            [-16.360014623139747, -9.342578996147953],
            [-16.35852562382091, -9.343558489770945],
            [-16.358702739636275, -9.34489213844799],
            [-16.357041070257438, -9.346707066119874],
            [-16.35774810397537, -9.348712183400083],
            [-16.355462127123015, -9.349693688060867],
            [-16.356082242734026, -9.351325749115372],
            [-16.35417596449742, -9.35114676032865],
            [-16.354613764716024, -9.352663980447886],
            [-16.353302883367636, -9.353481623074252],
            [-16.3543054977503, -9.355442402278358],
            [-16.354808476766546, -9.358297604881171],
            [-16.3534815181358, -9.359226378482365],
            [-16.352069997011892, -9.361429475143145],
            [-16.350734384089353, -9.361140309312702],
            [-16.350472068039107, -9.362622196199833],
            [-16.349110002912525, -9.363201503026682],
            [-16.348622292830004, -9.36435676911522],
            [-16.349168232591598, -9.365972108298044],
            [-16.346825869122622, -9.36636323654832],
            [-16.346434590069844, -9.367534784050529],
            [-16.346598328330717, -9.369527620105458],
            [-16.34552673941499, -9.370266736594619],
            [-16.343042214547914, -9.369769230362225],
            [-16.341937427161692, -9.370509269692468],
            [-16.34136977256969, -9.372618934871479],
            [-16.339787708436027, -9.372611283863865],
            [-16.33928194062522, -9.37373552318795],
            [-16.338033889934827, -9.37383975540216],
            [-16.337035539838848, -9.374724698222098],
            [-16.33769282369587, -9.376234627761697],
            [-16.335106268843628, -9.376614440748899],
            [-16.335431755542178, -9.378578827301256],
            [-16.335230150678083, -9.381970499687359],
            [-16.333203067384446, -9.382913040903402],
            [-16.33142481954683, -9.382812024580167],
            [-16.33062710330088, -9.384256614991479],
            [-16.32916754237733, -9.383881726005209],
            [-16.32827897063823, -9.38597584165768],
            [-16.325332107693352, -9.387486038882177],
            [-16.37996970317961, -9.392030772570205],
            [-16.434606113277706, -9.396589289903474],
            [-16.470936237191918, -9.39935352336615],
            [-16.489164745998963, -9.400691408822555],
            [-16.489543266240577, -9.39571530140308],
            [-16.504473740527715, -9.39678751245983],
            [-16.57022379016988, -9.401242010511213],
            [-16.64270557862689, -9.405387521023142],
            [-16.71518592945509, -9.409557353114662],
            [-16.730669835205894, -9.410322745723628],
            [-16.76984162493544, -9.474479419429258],
            [-16.808990979166055, -9.538646926963878],
            [-16.82825159326194, -9.539453814206622],
            [-16.83227817010703, -9.535959984943137],
            [-16.84520036839225, -9.532008020567215],
            [-16.841437729191174, -9.523573487046557],
            [-16.849282636593028, -9.521843188696065],
            [-16.853071787260195, -9.520406295603431],
            [-16.853257585657897, -9.515419255375319],
            [-16.878435568537107, -9.516301016711129],
            [-16.880256556121566, -9.515225332089594],
            [-16.885552704100842, -9.515244985932096],
            [-16.88824405893422, -9.516627489432318],
            [-16.892938132777715, -9.52676709015881],
            [-16.894400003553866, -9.528805044333625],
            [-16.897717407355806, -9.534410158766585],
            [-16.894683710337834, -9.536768307869817],
            [-16.893001748719186, -9.541748519765452],
            [-16.927490492332552, -9.54280430419887],
            [-16.92561628898772, -9.602664442497979],
            [-16.95244170690679, -9.60340626025144],
            [-16.950695527928257, -9.663274221770438],
            [-17.032568702509312, -9.665111041110618],
            [-17.05066409505726, -9.665430050273049],
            [-17.0496305782203, -9.72531651693785],
            [-17.039893476198337, -9.725148836900555],
            [-17.039075229917888, -9.770064957374236],
            [-17.00909856385866, -9.7694916540949],
            [-17.008781936272467, -9.784463373639658],
            [-16.978763290218765, -9.783803993713818],
            [-16.977755622415014, -9.82565604486592],
            [-17.01227501443487, -9.888870197408815],
            [-17.046782314282552, -9.95208684255832],
            [-17.06533856823538, -9.985466245267215],
            [-17.065701868170866, -9.98547162917381],
            [-17.063382279920962, -10.13520515202965],
            [-17.074484258519487, -10.135356210208089],
            [-17.07405884722159, -10.165295980398819],
            [-17.12690414481721, -10.16590572249061],
            [-17.126626985093544, -10.195850730807644],
            [-17.186470969403903, -10.196228751900719],
            [-17.186362521095234, -10.226174493954453],
            [-17.21441411924853, -10.22623921934852],
            [-17.294605648244715, -10.225729698280139],
            [-17.374797292388898, -10.225238051121156],
            [-17.452821791961608, -10.223623987142155],
            [-17.530846651085945, -10.222026839979309],
            [-17.564367842542715, -10.221048798649173],
            [-17.64535450382658, -10.217958527859528],
            [-17.726341881719666, -10.21488647185443],
            [-17.72494072448745, -10.18497435947741],
            [-17.817797556038776, -10.180362924034284],
            [-17.89086553168863, -10.17592932072567],
            [-17.963934461714004, -10.171510920280465],
            [-17.96600729202831, -10.201388916992903],
            [-18.08570150580722, -10.192692214291739],
            [-18.088111547631705, -10.222544089362298],
            [-18.13502177456132, -10.218777477253857],
            [-18.21529206252479, -10.211562428776142],
            [-18.295563972981817, -10.204364722154946],
            [-18.357790547481127, -10.198140557027044],
            [-18.348304067528417, -10.108778324623858],
            [-18.369690356228304, -10.106555596837865],
            [-18.35680342611497, -9.987421858219001],
            [-18.34849004602278, -9.988285936541757],
            [-18.335702576647417, -9.86913932001599],
            [-18.327356601863652, -9.870004389664956],
            [-18.323682430017833, -9.83550196893154],
            [-18.310214554364272, -9.836885098410189],
            [-18.309754841773053, -9.832523393647598]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -151.38961883136705, "lat": 65.5086508279619 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02290"],
        "coty_name": ["Yukon-Koyukuk"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Yukon-Koyukuk Census Area"],
        "coty_fp_code": "290",
        "coty_gnis_code": "01419987"
      },
      "bbox": [
        -18.369690356228304, -10.22623921934852, -15.372102125812555,
        -7.832393438264398
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.440568001593679, -1.9318633769698568],
            [-13.437245364489812, -1.932570084964413],
            [-13.427872708585177, -1.9315353584593091],
            [-13.412303968052457, -1.9340757792110765],
            [-13.407134938232234, -1.936874033794271],
            [-13.398383165567774, -1.9387708019812806],
            [-13.38699013372565, -1.9388846134086035],
            [-13.38250089764766, -1.9405657988471476],
            [-13.376815855047765, -1.9453633773880963],
            [-13.373728317750537, -1.950647759196552],
            [-13.362203215044696, -1.958775177850927],
            [-13.352462344459846, -1.967675764056455],
            [-13.342934571363651, -1.9690267445367535],
            [-13.335850215033084, -1.968988746733832],
            [-13.317971497786875, -1.9764151922999633],
            [-13.313873928782044, -1.979898017175321],
            [-13.307090374933658, -1.9877266298828697],
            [-13.302785557315318, -1.9964871188930957],
            [-13.301499430350393, -2.0078321550638005],
            [-13.294438182880462, -2.0142241600572666],
            [-13.256242323167637, -2.043857707586508],
            [-13.181385870242485, -2.117922243931901],
            [-13.177417927113135, -2.122916211754498],
            [-13.173654388060477, -2.130509904591859],
            [-13.17221275002807, -2.135884782897661],
            [-13.16966129376291, -2.160911729949889],
            [-13.163010576083375, -2.162506053360106],
            [-13.12083521874792, -2.179233814692249],
            [-13.064221388692538, -2.2066024071539125],
            [-13.055768599748829, -2.209639900950038],
            [-13.050652489511915, -2.2129063140604415],
            [-13.042431836168236, -2.2217466233262617],
            [-13.030743540418921, -2.2244259895205523],
            [-13.025578447918438, -2.2272792461947715],
            [-13.02229019543389, -2.2307204986735054],
            [-13.020088894537338, -2.2355223566086293],
            [-13.004539748655239, -2.239499681650364],
            [-12.990534603293435, -2.240200640372882],
            [-12.976819499206517, -2.237786418745175],
            [-12.96989282522563, -2.239103088343408],
            [-12.959718216561317, -2.244319836346616],
            [-12.953230881679334, -2.250672618551156],
            [-12.94967708778425, -2.256152198519333],
            [-12.947399121222372, -2.262760045269964],
            [-12.943435663124221, -2.263708071372301],
            [-12.93775540508824, -2.259060069723112],
            [-12.933915296787871, -2.257585307582021],
            [-12.92509831814675, -2.2578416040343545],
            [-12.920474980841021, -2.26047225035536],
            [-12.916486816860946, -2.26517687007518],
            [-12.91481444097785, -2.2695287019386883],
            [-12.915193461694082, -2.2779607603585648],
            [-12.918726943454788, -2.285475582009033],
            [-12.908485072085794, -2.2913423875747334],
            [-12.904945805188145, -2.2956533886551655],
            [-12.889720050995765, -2.322899015473865],
            [-12.86252937972751, -2.334820385541427],
            [-12.860305438905156, -2.335029911368881],
            [-12.827839476203946, -2.334514939630551],
            [-12.824539309352792, -2.3352742443114165],
            [-12.807264834279936, -2.3426971851846763],
            [-12.802835736196982, -2.3365629648923423],
            [-12.799943371526796, -2.334422657413871],
            [-12.788682616670274, -2.330963643070663],
            [-12.783649821730513, -2.3273130095955237],
            [-12.779318741544373, -2.3261119346299353],
            [-12.782861196519018, -2.347795932768933],
            [-12.78759660754758, -2.3720375010185237],
            [-12.79832729521628, -2.435267219066048],
            [-12.713451389812695, -2.451063371727295],
            [-12.71876901272522, -2.479242964979938],
            [-12.722875607978713, -2.5088994966759093],
            [-12.731090746848473, -2.555801235874152],
            [-12.742671107246894, -2.625180632194657],
            [-12.675523408857677, -2.63651807217653],
            [-12.664825766138055, -2.6377552056712092],
            [-12.52227107766646, -2.662096834342587],
            [-12.492186394641573, -2.667135757615307],
            [-12.491883848751971, -2.6653599858598755],
            [-12.4747791026742, -2.6676200792972744],
            [-12.364106701505195, -2.6865495009659655],
            [-12.321243752929908, -2.6937101935240926],
            [-12.320496489416747, -2.688969996679701],
            [-12.295297378467808, -2.693249859206716],
            [-12.303234392329813, -2.7400429785451608],
            [-12.310707458698216, -2.785129820156271],
            [-12.318308771020094, -2.825746215937463],
            [-12.321649185218448, -2.840600504903471],
            [-12.324341846131952, -2.85474074421167],
            [-12.325424542466449, -2.8696922918597996],
            [-12.309743107755796, -2.871482597671752],
            [-12.283330999847076, -2.875901433863815],
            [-12.250938578547213, -2.8818970308425573],
            [-12.228788085627558, -2.8864991097666133],
            [-12.214391228225216, -2.8886227265931574],
            [-12.180873074294926, -2.8944761759875073],
            [-12.143893210363009, -2.9006689607402603],
            [-12.15791953244937, -2.985384594284209],
            [-12.16198997896112, -3.0078196337230194],
            [-12.164030204281065, -3.023983864681169],
            [-12.171128012736023, -3.065707406929183],
            [-12.172191448888302, -3.0655259474662504],
            [-12.176437700828536, -3.091039696383959],
            [-12.19438883878759, -3.20100346834781],
            [-12.195539836578172, -3.2008137049616123],
            [-12.200279177645326, -3.2289222621668143],
            [-12.200652144804321, -3.233472608515226],
            [-12.205494798750294, -3.261047176480067],
            [-12.206982827420395, -3.262914324041434],
            [-12.212179459292123, -3.2639443899414724],
            [-12.21385230805858, -3.2671824716685776],
            [-12.221119972501366, -3.2683405687741165],
            [-12.222996612486478, -3.274579471700179],
            [-12.22650738006069, -3.2767662392295533],
            [-12.234854658622737, -3.275746668139998],
            [-12.23799121000449, -3.2732617137782944],
            [-12.243746754185565, -3.2754307413368733],
            [-12.246333622088146, -3.2748183731649316],
            [-12.25050059294852, -3.2788389114373038],
            [-12.250548483103909, -3.2818769344732117],
            [-12.254300620271586, -3.2829903539066327],
            [-12.257566996942527, -3.287403358547463],
            [-12.260235121344065, -3.286912818531398],
            [-12.26377380776806, -3.2908092557600472],
            [-12.268743269377591, -3.2907748958611944],
            [-12.273548617316127, -3.2925280949240947],
            [-12.27457005513619, -3.2967309585591904],
            [-12.279131406088197, -3.2965045132641912],
            [-12.283461330400096, -3.2941831313032965],
            [-12.28784798426859, -3.2946522751198466],
            [-12.289764735935778, -3.297333479411495],
            [-12.299114826886516, -3.299742059603133],
            [-12.300007016865623, -3.3185321965575736],
            [-12.30277177092308, -3.3239275475872607],
            [-12.309281842307781, -3.3319019264160463],
            [-12.312448438212003, -3.3407698120598024],
            [-12.310373029265058, -3.3426975619509465],
            [-12.313018297084371, -3.35366944216281],
            [-12.311134470195487, -3.3546258575839896],
            [-12.311568645515642, -3.3605177745828505],
            [-12.315472303234234, -3.3679837300564386],
            [-12.315406357007507, -3.3701805187676213],
            [-12.319224636538378, -3.3737906108359517],
            [-12.320432580840572, -3.377080369736517],
            [-12.324267734083127, -3.3772500979917677],
            [-12.332781049368844, -3.382083729267651],
            [-12.333929985361145, -3.3846772998149115],
            [-12.331002414815268, -3.387735312584424],
            [-12.331186830842414, -3.3906197423282927],
            [-12.328080834311441, -3.393666407517179],
            [-12.325398223334854, -3.388516603621293],
            [-12.318910315896739, -3.3872207269379655],
            [-12.317416736643692, -3.3888191275607302],
            [-12.320791651286829, -3.398920174512057],
            [-12.326715783304495, -3.399844576459632],
            [-12.335922815929033, -3.3991631479962123],
            [-12.334697148949004, -3.411467453181884],
            [-12.335214487437192, -3.4162638272022727],
            [-12.337472660720902, -3.4205372689954907],
            [-12.344617824294042, -3.42077517719584],
            [-12.345209020315812, -3.42425269011492],
            [-12.35142551446892, -3.429641053607965],
            [-12.353551636444571, -3.4344613096413577],
            [-12.350426481674853, -3.436835398483395],
            [-12.35578852161372, -3.4392416425363854],
            [-12.357042451694937, -3.445156409463676],
            [-12.356060208588133, -3.449518692176397],
            [-12.361633232184426, -3.451967030286011],
            [-12.361554960929718, -3.458334865022267],
            [-12.363659453526385, -3.4607249469099703],
            [-12.364597766081143, -3.466266682059755],
            [-12.358476591308259, -3.4677350822589665],
            [-12.354065652187435, -3.4755279561794006],
            [-12.354629505772868, -3.480486270578311],
            [-12.36037978708192, -3.486507273156536],
            [-12.363499656271069, -3.4860810082852804],
            [-12.365112700024135, -3.480683982138928],
            [-12.371744584168407, -3.477958422360949],
            [-12.372838703858909, -3.480999907181132],
            [-12.369686172134724, -3.4870511914525526],
            [-12.362026532138339, -3.4893079769242217],
            [-12.360058338625633, -3.4943355369570455],
            [-12.361616432142426, -3.498493991294769],
            [-12.36841660872918, -3.495894048524193],
            [-12.370975015022527, -3.5019570493635843],
            [-12.380491628993106, -3.5113921006688873],
            [-12.384546673632943, -3.512165697414852],
            [-12.385522795440327, -3.5164145827208384],
            [-12.381131679056871, -3.5228046243861173],
            [-12.380387887357676, -3.5260947601443857],
            [-12.324334133998484, -3.5353935894746904],
            [-12.209203856592772, -3.554460816598786],
            [-12.190021638673011, -3.557769803438127],
            [-12.193602093737601, -3.5596563950375204],
            [-12.196440114227027, -3.5658120682112306],
            [-12.20127887134573, -3.5676081268697324],
            [-12.205765236848896, -3.57283045975745],
            [-12.204987378321665, -3.575793730166719],
            [-12.196615346324268, -3.5764702136754316],
            [-12.195043818557453, -3.579014105353852],
            [-12.197963774077596, -3.583572238579598],
            [-12.197482071421762, -3.5890653344176897],
            [-12.193137087172069, -3.590275170023216],
            [-12.193459293005477, -3.5943877969070575],
            [-12.191458561515521, -3.5975704957563552],
            [-12.19560083700452, -3.602921928067844],
            [-12.202908090457363, -3.6082779257317474],
            [-12.205999888655887, -3.6119717557735167],
            [-12.202999417763076, -3.615108672434638],
            [-12.202046574215888, -3.6241936490392863],
            [-12.200241924693593, -3.6279199199466574],
            [-12.192115614620143, -3.6373545495196207],
            [-12.192716830560352, -3.640569066282162],
            [-12.190659958986943, -3.643942803612474],
            [-12.192889212673052, -3.650608098296736],
            [-12.200892569936373, -3.6504288876233377],
            [-12.201618301266468, -3.653724796430097],
            [-12.19982453585557, -3.6621680406976385],
            [-12.203229577079837, -3.666416763466887],
            [-12.208357265598154, -3.6674990828030536],
            [-12.212942271963342, -3.6669244863079564],
            [-12.214759521902893, -3.670256217234475],
            [-12.221009849279, -3.6678192707077493],
            [-12.223527956013005, -3.6738382012199913],
            [-12.22619559771317, -3.676191444711608],
            [-12.224919587440708, -3.6815531534827635],
            [-12.227258012159473, -3.6875819950440274],
            [-12.227088643012229, -3.6906056916459398],
            [-12.230722561748896, -3.6938201916134608],
            [-12.231724555521499, -3.7003627220222652],
            [-12.229302923074695, -3.705121520039017],
            [-12.233902697619508, -3.7042776907666846],
            [-12.417079951341744, -3.673971016813229],
            [-12.534677717502362, -3.6375211680735973],
            [-12.63100628831487, -3.6075946093823634],
            [-12.764546173908556, -3.5661536985314073],
            [-12.762900790154891, -3.5724967708591846],
            [-12.76014884879686, -3.571394904280979],
            [-12.757034886764355, -3.5739660277548073],
            [-12.765129627057672, -3.576464639558919],
            [-12.767590733600775, -3.580976274745166],
            [-12.7681774620846, -3.587179451155902],
            [-12.766796759526864, -3.596840882574603],
            [-12.770413576528803, -3.6010961133514834],
            [-12.773861110523193, -3.596504436043829],
            [-12.777779423727639, -3.596021297204181],
            [-12.779704522379118, -3.5979909676784145],
            [-12.784571386276994, -3.5984294274102298],
            [-12.78588263599865, -3.6028816953053058],
            [-12.784458329052892, -3.6060309703690594],
            [-12.790671405888256, -3.6137069821320567],
            [-12.793747453940817, -3.6149482329587883],
            [-12.797623115690097, -3.619524244941556],
            [-12.800358357374796, -3.6316798763544784],
            [-12.802909477701112, -3.6350882975626146],
            [-12.80869861960483, -3.637831241033134],
            [-12.812852116400311, -3.6377674796909796],
            [-12.819129321325741, -3.639457576873022],
            [-12.819308927470576, -3.6429028856575636],
            [-12.825857871961638, -3.6449049439378594],
            [-12.83386197503114, -3.6502924888839368],
            [-12.836009358398897, -3.6481332552170826],
            [-12.841484086578385, -3.6463264594193086],
            [-12.842465199892255, -3.6524356104713136],
            [-12.839395342090322, -3.6562332721781723],
            [-12.845075181947946, -3.6621515448667337],
            [-12.84089831073398, -3.663883895103656],
            [-12.837885834019893, -3.667964245130518],
            [-12.841496504465104, -3.677386277348383],
            [-12.84407743000493, -3.6869312444530964],
            [-12.85064953514759, -3.686764785923461],
            [-12.851611882004928, -3.688970098555337],
            [-12.850079567246164, -3.6942096901962698],
            [-12.852454107300176, -3.696759425749554],
            [-12.85772342443995, -3.6966434359921476],
            [-12.862669072402081, -3.694932116032332],
            [-12.867001081124418, -3.6956646967996383],
            [-12.870821971621028, -3.6998755300980752],
            [-12.880580644626386, -3.704109539760052],
            [-12.88307560589272, -3.706704030723401],
            [-12.88327799300809, -3.71480051047733],
            [-12.933787672531436, -3.6892413046839208],
            [-12.999868714716191, -3.6555664445001628],
            [-13.19705910653962, -3.5550926560968574],
            [-13.242104702123804, -3.5321248959953047],
            [-13.307235149080366, -3.5204609286580855],
            [-13.435879988550058, -3.4972176372650443],
            [-13.564522546891807, -3.4739612560049213],
            [-13.71935624485019, -3.445613323566157],
            [-13.697276299705736, -3.3246769308916275],
            [-13.696445986046054, -3.3219910464890425],
            [-13.673926366322545, -3.199189122948149],
            [-13.674015419744418, -3.1982354380322855],
            [-13.661347173487274, -3.1310936933602003],
            [-13.644047856475797, -3.0384814955076345],
            [-13.63175099350168, -2.9720657537527746],
            [-13.616889989825358, -2.890135748387428],
            [-13.617600991591758, -2.890000691124684],
            [-13.596051150634791, -2.7751815331982588],
            [-13.59537417742224, -2.7753062366493304],
            [-13.574974229158434, -2.6651185807426527],
            [-13.515596766232916, -2.343986620075793],
            [-13.5012432740612, -2.2661554111154563],
            [-13.472787136654675, -2.1124595223277747],
            [-13.470218535268408, -2.0980640081810105],
            [-13.444855009324199, -1.960043245352769],
            [-13.445734590578533, -1.9598831745727467],
            [-13.440568001593679, -1.9318633769698568]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.55371999829747,
          "lat": 34.59980396131734
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04025"],
        "coty_name": ["Yavapai"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yavapai County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00042809"
      },
      "bbox": [
        -13.71935624485019, -3.71480051047733, -12.143893210363009,
        -1.9315353584593091
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.614930530224716, -2.1099935250473982],
            [4.672996842226744, -2.1069913806850615],
            [4.687472800050051, -2.105990178527885],
            [4.780355667122403, -2.1008089978237776],
            [4.899766637816929, -2.0940458290809385],
            [4.968204392393457, -2.0900863297807803],
            [5.056420135886646, -2.085225187159584],
            [5.065358984163455, -2.084648527779862],
            [5.117182032941044, -2.0813261585748606],
            [5.115719167046353, -2.082548253518219],
            [5.113270010478372, -2.100158611559927],
            [5.12183511654309, -2.103057846249266],
            [5.125537424442962, -2.1029701693453235],
            [5.127039380182638, -2.108411374726513],
            [5.123839826752515, -2.1096537220511373],
            [5.118535707042795, -2.1085552713949953],
            [5.116674759038489, -2.1161239188891128],
            [5.128059764355222, -2.1159906248327065],
            [5.128357892779049, -2.1191247074993433],
            [5.1318768231453635, -2.1234184749964267],
            [5.1336820421108555, -2.135910734221257],
            [5.135582363478823, -2.142200303163148],
            [5.133146600578934, -2.1470898696438985],
            [5.129092680872122, -2.148101009461874],
            [5.128697049531654, -2.154924331955215],
            [5.132258563005931, -2.1577124898363276],
            [5.1363644643037905, -2.1560744128836458],
            [5.13631795749176, -2.1652806084552303],
            [5.139388042990468, -2.1637285854186206],
            [5.141445692334824, -2.167047867056032],
            [5.14727899568761, -2.1674228718651523],
            [5.157216362082211, -2.1737385692301197],
            [5.161831888550297, -2.1727982924247136],
            [5.169272691000818, -2.1731011484507126],
            [5.1805562471719275, -2.1756330520148306],
            [5.1838379165164055, -2.1803768869988045],
            [5.190484807485071, -2.187246254968509],
            [5.194395456069013, -2.193647323542405],
            [5.195464899498908, -2.202780811492602],
            [5.194411253556198, -2.216674722524132],
            [5.191144500546435, -2.220115866832506],
            [5.18601619063428, -2.228135959523368],
            [5.189250889838473, -2.2335766648658666],
            [5.186871115909575, -2.235297641638313],
            [5.186341523376949, -2.240210011510444],
            [5.188614705813389, -2.242565545469838],
            [5.184276098921005, -2.2549058533221533],
            [5.186071945802517, -2.2583088650845395],
            [5.188803063732717, -2.2575140540217506],
            [5.194952229548237, -2.26327996056133],
            [5.19980084663978, -2.2731984024956686],
            [5.195460444240702, -2.281885732702648],
            [5.189712138299077, -2.2886726430374726],
            [5.191630878759619, -2.2954895804638085],
            [5.185991025962368, -2.3050907200293715],
            [5.173092028873548, -2.3092721873935678],
            [5.16919611541091, -2.3116897170008595],
            [5.161547696500665, -2.3134169704165504],
            [5.159674823714341, -2.3257642281487327],
            [5.155265205705954, -2.3354276554309013],
            [5.151146461647596, -2.336655372216599],
            [5.151011480340131, -2.339622408722066],
            [5.155657809763401, -2.344143059549375],
            [5.1546825574107915, -2.3504501224161065],
            [5.150086921075171, -2.3536897229941616],
            [5.142135667712003, -2.353089102693095],
            [5.135329775454781, -2.3619436425939924],
            [5.134695125166128, -2.3656122029672324],
            [5.131905141860943, -2.3676794445532656],
            [5.127767628458325, -2.365851341324011],
            [5.118440404139642, -2.3719469466887197],
            [5.113448919375272, -2.374313134300154],
            [5.111123946882314, -2.377642345058931],
            [5.106850729511805, -2.37764924810466],
            [5.105363769695112, -2.381757522865142],
            [5.043844794939115, -2.386070240770507],
            [5.043682834495465, -2.386358865885649],
            [5.001194891758782, -2.388872973515967],
            [4.999550994448538, -2.359104132656101],
            [5.0003806349928555, -2.3590414025014264],
            [4.99876444494184, -2.3298487671007244],
            [4.956621313509397, -2.331923244933044],
            [4.941791013787398, -2.333145735074774],
            [4.91318279696653, -2.3347140161892357],
            [4.87007122909877, -2.3361424137166997],
            [4.868569000566544, -2.335504284295499],
            [4.827002362461332, -2.337485247402269],
            [4.812590625557025, -2.3364560072621616],
            [4.783767196405184, -2.337419009017323],
            [4.7837329357989224, -2.3363976213248527],
            [4.755062075549651, -2.3375804570708523],
            [4.667453742041134, -2.3399300469070217],
            [4.624241909995697, -2.3437515508406896],
            [4.609857001193909, -2.3441279528110455],
            [4.609058833702302, -2.322870886127567],
            [4.6158083264774765, -2.3247633052449186],
            [4.621031653316515, -2.3225226264750067],
            [4.621337071644466, -2.3162442024339382],
            [4.624953136963272, -2.3167236623406424],
            [4.6284087692329905, -2.3238956950111604],
            [4.632044352225322, -2.3270899525360123],
            [4.633945650508978, -2.324711678254085],
            [4.638843040210401, -2.3246169989898506],
            [4.641723596981689, -2.3221340887392428],
            [4.645850426021724, -2.3233521298909836],
            [4.646821931702819, -2.326562260846107],
            [4.652660763967214, -2.32480260903326],
            [4.649720555316734, -2.2398514711898474],
            [4.647966076629992, -2.194715292744356],
            [4.638011421564646, -2.195221360624991],
            [4.63021092804297, -2.194221511934616],
            [4.63181615637257, -2.1877138776440717],
            [4.634747892105107, -2.1879645953355067],
            [4.641509898061446, -2.1851347064195017],
            [4.634255648218748, -2.180403480871187],
            [4.630663501976338, -2.1841827632133706],
            [4.624850542208521, -2.183504370708029],
            [4.630216327243421, -2.1741307868761743],
            [4.624818245181881, -2.1739862544693893],
            [4.622417100907817, -2.169587079835307],
            [4.625433418180215, -2.1626775401316487],
            [4.624419071238965, -2.155648049779279],
            [4.625820097823326, -2.149472748937849],
            [4.625065395626441, -2.143984783196155],
            [4.626435269685015, -2.1422605734001294],
            [4.625206381889492, -2.133364536995299],
            [4.628921258341985, -2.130885804761879],
            [4.626131377997545, -2.126423130914657],
            [4.626598594055735, -2.1202393539054962],
            [4.619611485854534, -2.117557211799655],
            [4.616490411973525, -2.1108390796911314],
            [4.614930530224716, -2.1099935250473982]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.41727942372299,
          "lat": 36.368305038604646
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05021"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00063759"
      },
      "bbox": [
        4.609058833702302, -2.388872973515967, 5.19980084663978,
        -2.0813261585748606
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5284007668939528, -2.161703446663458],
            [3.5521807284203213, -2.160504943863495],
            [3.659275022810363, -2.156494654250273],
            [3.754573627449197, -2.1520545802237416],
            [3.865394620393409, -2.1467231711442354],
            [3.9085929650363544, -2.144512084199942],
            [3.9411423743307474, -2.1432906128473297],
            [4.016367136086727, -2.1398379160893493],
            [4.045598691339873, -2.138806946575266],
            [4.085522009106681, -2.138168349800434],
            [4.087004171515114, -2.213983665500217],
            [4.088139154197837, -2.257733074832439],
            [4.089889291699737, -2.301587186430197],
            [4.060333273937133, -2.3019942450834483],
            [4.00089269994507, -2.3038998578907157],
            [4.003614262180101, -2.3611355625255497],
            [4.004866445095124, -2.392006445408539],
            [3.954440528741402, -2.391871296237166],
            [3.904666937928355, -2.3933853811295234],
            [3.861179637892364, -2.3945009556701184],
            [3.8310842334578834, -2.395591400993571],
            [3.7888205892547666, -2.3965516642793068],
            [3.7602592484643274, -2.396899734932583],
            [3.6891623165834297, -2.399199342273157],
            [3.6109957782472777, -2.4002711536418397],
            [3.5328019692234127, -2.4011909680462193],
            [3.5309913016494874, -2.401174304343946],
            [3.5304595131489225, -2.3717809310861195],
            [3.5308511266542397, -2.3570179109530014],
            [3.5306745784742164, -2.312798038084869],
            [3.5311799817299554, -2.312776586893576],
            [3.5308377423337953, -2.2725546848781355],
            [3.5306912248092703, -2.225094591483649],
            [3.529545789537473, -2.2175187867471173],
            [3.5284007668939528, -2.161703446663458]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.81815160004533,
          "lat": 36.381650860120416
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05049"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00066854"
      },
      "bbox": [
        3.5284007668939528, -2.4011909680462193, 4.089889291699737,
        -2.138168349800434
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.141165649175711, -3.5562890384218413],
            [4.142479812637191, -3.5526586495864723],
            [4.148696516840287, -3.556464938350799],
            [4.153560370694837, -3.5562375559219657],
            [4.1501428368668885, -3.547113572817903],
            [4.150832623294419, -3.5435823257506036],
            [4.161935253141264, -3.5431295414258765],
            [4.171620423220926, -3.5415570186339616],
            [4.173511583856144, -3.5370293880382473],
            [4.1706123148334875, -3.5328126419318435],
            [4.168308735026388, -3.5332327273487887],
            [4.165351049368269, -3.538414150350033],
            [4.1603115751871025, -3.540893277434203],
            [4.158063942073069, -3.5403881520636715],
            [4.157189582455969, -3.5351376406369077],
            [4.16113892022482, -3.5261243221776843],
            [4.15432677509278, -3.518575784286082],
            [4.150436011733239, -3.510577556079697],
            [4.150387871799, -3.5043649365247354],
            [4.153882870631542, -3.5035889605777415],
            [4.160081288178569, -3.5090192023662388],
            [4.168202183148657, -3.507567138825152],
            [4.167749714106394, -3.504462222463015],
            [4.163975995703483, -3.502231380546323],
            [4.162848964283465, -3.4986144856817827],
            [4.163697978727403, -3.4919443614274726],
            [4.160578448416332, -3.4897686199241753],
            [4.156789350367294, -3.49064169267704],
            [4.1432873908829, -3.4901110026507305],
            [4.140800730979042, -3.4890543625614905],
            [4.139434070452035, -3.484151264820592],
            [4.142096639743521, -3.477957231607585],
            [4.14640102063803, -3.474931342491995],
            [4.156651961547027, -3.479009118616586],
            [4.159828994485273, -3.4788165239746927],
            [4.163521413698199, -3.474939012856579],
            [4.165465919685481, -3.4695808133830637],
            [4.170081452275879, -3.4637503483145347],
            [4.167556335134429, -3.4575503741646845],
            [4.163634644232178, -3.4529445288230805],
            [4.16661085288993, -3.4500062385290313],
            [4.175901065657808, -3.4505592010119703],
            [4.179395666546822, -3.4464945935921043],
            [4.180236771558498, -3.434652450534553],
            [4.181753983961998, -3.4300811180382134],
            [4.186032273743024, -3.4277070702722128],
            [4.189688434350765, -3.4292924690757767],
            [4.191699552610292, -3.4334685085611274],
            [4.192017325994023, -3.4447870649107313],
            [4.194810123552287, -3.449917040139317],
            [4.20208141484147, -3.454390221567382],
            [4.206830512517494, -3.4508068231695046],
            [4.207363418962137, -3.4459996098365986],
            [4.205344520214499, -3.4436510578922004],
            [4.199897027638629, -3.4439920372915442],
            [4.1969014171371395, -3.4421997120580863],
            [4.197063573604582, -3.4370626911088213],
            [4.204354120012579, -3.4272741383846874],
            [4.201024797837002, -3.42434687498689],
            [4.1932451730971785, -3.4235888261431553],
            [4.1929058842914655, -3.4189426894814385],
            [4.196274990872301, -3.4188984409557497],
            [4.201644921405339, -3.421679529971235],
            [4.205411446792815, -3.4184913987604437],
            [4.204426422492826, -3.4163142914811155],
            [4.197516318314315, -3.412033354421767],
            [4.19580624712501, -3.4081774273774395],
            [4.1977195495919855, -3.397618972747193],
            [4.200052856937499, -3.393268420048339],
            [4.205526540019322, -3.389084772381353],
            [4.208124626569767, -3.385524538739887],
            [4.20872542617748, -3.377014285369664],
            [4.20510557877641, -3.373360114676983],
            [4.202194288127345, -3.374876782699826],
            [4.202336242559427, -3.385837127190478],
            [4.197625415611151, -3.39025578952299],
            [4.192620163688645, -3.3896787376526554],
            [4.186068443570938, -3.3825503704366975],
            [4.185057743141898, -3.377586498022145],
            [4.1759220481206105, -3.3778391034536965],
            [4.175070928868574, -3.349071314337742],
            [4.172942540494238, -3.3456632361835723],
            [4.173410213938784, -3.3396597164356248],
            [4.170823111104837, -3.3378636888517907],
            [4.167367473893951, -3.344709817682572],
            [4.160926742605642, -3.350022481414742],
            [4.156089134816658, -3.3497002574377777],
            [4.153717704823727, -3.3473670424852933],
            [4.15215389212976, -3.341681955562466],
            [4.156294949404345, -3.3316739815998933],
            [4.155303731676488, -3.3278064526396958],
            [4.158879404155489, -3.3247581460186106],
            [4.162301086762644, -3.312097910252353],
            [4.160718455956726, -3.307536805920102],
            [4.155215090099836, -3.3043971413163375],
            [4.149980709998702, -3.3046351488719607],
            [4.1454963466306785, -3.2988152475524886],
            [4.147282243162672, -3.2947609489711374],
            [4.153190307273244, -3.2942729647906357],
            [4.157986797851162, -3.292035039825664],
            [4.162075601255276, -3.286543631844114],
            [4.1609333421246415, -3.2818925920084108],
            [4.153971511975225, -3.281150204063439],
            [4.151463701981759, -3.279338550066248],
            [4.1493759150643275, -3.274194207434167],
            [4.152955082309846, -3.2709842753778164],
            [4.15745914929855, -3.272614273084911],
            [4.1663243002925086, -3.2804210568359626],
            [4.171909534187944, -3.281161192371649],
            [4.173012473758805, -3.277029121426766],
            [4.169180748567997, -3.273151198075243],
            [4.162580118772912, -3.2733067899804786],
            [4.159383080874832, -3.2674738473017597],
            [4.161341054853149, -3.2649050892986593],
            [4.1663963302922085, -3.2623897786964053],
            [4.168637348828773, -3.2587049730866373],
            [4.174393015705991, -3.2553455527252186],
            [4.180941461840298, -3.2597131203014387],
            [4.186418091297399, -3.266169032802719],
            [4.190343750828162, -3.266957931430149],
            [4.192717745873127, -3.261968135008881],
            [4.185973893635777, -3.255047613973152],
            [4.179110820987978, -3.2506139759367496],
            [4.179964516573339, -3.247050252307885],
            [4.187425478361539, -3.2449171835402733],
            [4.1944537719693695, -3.2386757799802783],
            [4.198797208735505, -3.2368945541839294],
            [4.203959026541092, -3.2318178876513364],
            [4.2042490892758435, -3.227374536188201],
            [4.200336708311627, -3.219994275304467],
            [4.202599616065785, -3.211271557603859],
            [4.207525275689216, -3.2109155984912423],
            [4.207349588605812, -3.2238269049914585],
            [4.2128648679898335, -3.2311356415562233],
            [4.217074594765983, -3.230371356992932],
            [4.219838268968003, -3.2268245508331805],
            [4.221872168742879, -3.215847366049625],
            [4.219448140262673, -3.2132510370713074],
            [4.2120708943629515, -3.211732620910348],
            [4.211977279332712, -3.2092592708530723],
            [4.217755608528731, -3.203588452681484],
            [4.21953177310061, -3.199991895164247],
            [4.2167562143845645, -3.1941399112199442],
            [4.295213591642826, -3.1895220435297182],
            [4.296018427810526, -3.2058401609637044],
            [4.29996383956316, -3.2635174045326907],
            [4.300829277849021, -3.278211863662321],
            [4.307438541610526, -3.277831218254355],
            [4.343289207484658, -3.2769144947216913],
            [4.360518725750419, -3.2758039063036435],
            [4.456822619778691, -3.273300615002201],
            [4.472099481521646, -3.272804949332578],
            [4.474986441304051, -3.332221288051871],
            [4.476008354849371, -3.361479175150821],
            [4.4775956863256985, -3.398467303296027],
            [4.480569146809725, -3.480157248515525],
            [4.481932539045381, -3.5246402450002883],
            [4.484965330184591, -3.599858866361318],
            [4.485971410675896, -3.628199895658886],
            [4.457332598655203, -3.6290791057344998],
            [4.401295215945792, -3.63113046355795],
            [4.347955107919933, -3.632914840762263],
            [4.330136924372269, -3.63289061008744],
            [4.330487341246058, -3.6525045737512305],
            [4.2858430879966605, -3.6542974428715356],
            [4.288200407878341, -3.727511870112133],
            [4.228135752027637, -3.7302516778457138],
            [4.225126988260733, -3.635072908931533],
            [4.226702411631477, -3.6350324631565605],
            [4.225235614432155, -3.5900362596337376],
            [4.162073447576778, -3.5928116580645253],
            [4.164174062386589, -3.5849278854710516],
            [4.161560985785625, -3.584014066787158],
            [4.158530199751081, -3.58813591267613],
            [4.14626267221184, -3.5937518347998085],
            [4.138574328202671, -3.5903219218803932],
            [4.134176061613717, -3.5899637826042183],
            [4.131437623689395, -3.5853765690840076],
            [4.132787767256589, -3.5809285798905854],
            [4.135766191877636, -3.578462999756647],
            [4.143410641096738, -3.581783440665032],
            [4.148478766436711, -3.581971002684058],
            [4.156164304218888, -3.5785803679997206],
            [4.157507877503591, -3.576192091859902],
            [4.151756630477545, -3.572443943208857],
            [4.1472333616918435, -3.5652031336403898],
            [4.1392541329223205, -3.562020922080732],
            [4.141165649175711, -3.5562890384218413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.24300824900475,
          "lat": 35.186328553189455
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05147"],
        "coty_name": ["Woodruff"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woodruff County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00069907"
      },
      "bbox": [
        4.131437623689395, -3.7302516778457138, 4.485971410675896,
        -3.1895220435297182
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.739344979534035, 2.564517381749706],
            [-18.73403345413819, 2.5631774666372666],
            [-18.731871700792993, 2.5672776341050256],
            [-18.72800344653805, 2.5818441032016266],
            [-18.723755680224492, 2.5829137558424686],
            [-18.71455827911261, 2.5962865911111255],
            [-18.71325229562211, 2.5998814139407225],
            [-18.709262340309934, 2.6042992721530718],
            [-18.708478904004807, 2.6124481720928427],
            [-18.705718792195903, 2.6166070194455124],
            [-18.700710802249944, 2.618709024426125],
            [-18.691151419046832, 2.6284068057743144],
            [-18.688642449193985, 2.632351578845912],
            [-18.68777550039406, 2.6386290414360754],
            [-18.684865557290262, 2.6414655375336182],
            [-18.681504965350786, 2.648558287100489],
            [-18.681679358231218, 2.6570310441711396],
            [-18.676567261519672, 2.654036081451835],
            [-18.669214054915045, 2.6547620794677624],
            [-18.666409477972834, 2.6609132207385704],
            [-18.66956377831726, 2.665993021438918],
            [-18.66690973884698, 2.671726013149957],
            [-18.662378773143832, 2.6724932421753307],
            [-18.653444557799595, 2.678191694535877],
            [-18.645199579784318, 2.6781741191595114],
            [-18.641714703713188, 2.679403174703942],
            [-18.640007749642475, 2.6832689800698923],
            [-18.640879993506918, 2.6925365501447547],
            [-18.63412970129769, 2.6960474161311825],
            [-18.632301189780744, 2.699031099339023],
            [-18.63267216279605, 2.70849122064809],
            [-18.634814990337965, 2.7146516751830108],
            [-18.621605892213992, 2.717574804025391],
            [-18.61962357668299, 2.719096392514629],
            [-18.621440892401946, 2.7242482268419304],
            [-18.624641695485487, 2.72666850064778],
            [-18.62367410662471, 2.7299217691722797],
            [-18.614114799758653, 2.736064697817912],
            [-18.611463566180902, 2.74130650008213],
            [-18.60812012452627, 2.7419683982413514],
            [-18.606108311960835, 2.7384254757837563],
            [-18.599266497290337, 2.7389018300588206],
            [-18.593630213419182, 2.740730012480821],
            [-18.5891542707938, 2.737861457308394],
            [-18.580435443552453, 2.736757576423333],
            [-18.571551571305744, 2.7404188933852605],
            [-18.57121171171438, 2.744084281663013],
            [-18.55753768662828, 2.7436841869910764],
            [-18.55364416139424, 2.745486119755296],
            [-18.550481924948862, 2.7441072321239166],
            [-18.542650210982025, 2.7488204133971217],
            [-18.53811596088649, 2.7473295611004094],
            [-18.53286187942623, 2.7426039034086016],
            [-18.52902748731183, 2.7417369912998275],
            [-18.52571323682567, 2.7521999174320158],
            [-18.523502760602288, 2.7619897702332055],
            [-18.52355650356067, 2.767955261674677],
            [-18.520112804128306, 2.7686896612750145],
            [-18.51782277206578, 2.7661237884860252],
            [-18.513296686954277, 2.764661521637317],
            [-18.505781462253776, 2.7557418074098714],
            [-18.495938559964028, 2.7511636581823575],
            [-18.487256414612183, 2.7553268251018728],
            [-18.483427178662875, 2.7537149555251226],
            [-18.481373246523855, 2.7507784543088323],
            [-18.478157667199397, 2.7502311593291533],
            [-18.472365053962918, 2.7457351137169796],
            [-18.465656683754275, 2.7419198363494104],
            [-18.46362873687883, 2.745955618185564],
            [-18.45869324304428, 2.747667974911044],
            [-18.459346689416734, 2.755437681479149],
            [-18.456077619832524, 2.7608224639465444],
            [-18.452167780845052, 2.763947023221703],
            [-18.446008370250635, 2.7608782180698896],
            [-18.445631704161123, 2.756956772657701],
            [-18.44213396068192, 2.756105960197499],
            [-18.439381657009505, 2.7617930486280446],
            [-18.436356645195062, 2.7634561205779526],
            [-18.43478611990094, 2.770300168796333],
            [-18.429668144203887, 2.7745747458993586],
            [-18.422271519018047, 2.774720414665191],
            [-18.418499935067317, 2.7793036728190255],
            [-18.410528948587196, 2.7781896205002847],
            [-18.409009209452606, 2.772511021129072],
            [-18.402644480040507, 2.7745496000372283],
            [-18.3996665960714, 2.7737474005323275],
            [-18.39361313843289, 2.7769018690275007],
            [-18.38542052060157, 2.7776770323944513],
            [-18.382145742834354, 2.77159050258346],
            [-18.375882452254228, 2.7758018638609965],
            [-18.366456972250127, 2.770273942417783],
            [-18.365616554082987, 2.7665677227794165],
            [-18.361668058877125, 2.764650084138835],
            [-18.355968284804742, 2.7667085725911287],
            [-18.352425137723486, 2.7608637172257637],
            [-18.3533278939354, 2.7549945373226237],
            [-18.350589478156554, 2.747168173122278],
            [-18.347147185520278, 2.7453047932778176],
            [-18.343201809692854, 2.7394989858819874],
            [-18.339813777525254, 2.7394443459770716],
            [-18.332829052936432, 2.7416228230129587],
            [-18.32863872352805, 2.744758513120876],
            [-18.32634976249725, 2.743386060776036],
            [-18.32821741840372, 2.738042364286002],
            [-18.326531969197443, 2.731611624965679],
            [-18.32921421167557, 2.728946697208324],
            [-18.33067675927633, 2.721300874021754],
            [-18.325864205763697, 2.7155659845463544],
            [-18.325473254135964, 2.7111985369072102],
            [-18.31969121004878, 2.708138267542548],
            [-18.317428643395278, 2.7043463124621256],
            [-18.31463958798365, 2.703146682936087],
            [-18.314465951355047, 2.6975974551682005],
            [-18.311833824882726, 2.6974350559459266],
            [-18.306598779233372, 2.691388808414512],
            [-18.30158850707854, 2.689017054496824],
            [-18.29764696238103, 2.690986488603048],
            [-18.291915464102363, 2.6861519972947336],
            [-18.284861829842686, 2.684263170448213],
            [-18.283295859801697, 2.6816129121835903],
            [-18.282521643991974, 2.675458927074341],
            [-18.280866623332837, 2.6739548093590937],
            [-18.27579685129932, 2.6753421811846385],
            [-18.272944506733612, 2.673821074765496],
            [-18.27328533335495, 2.669761953730397],
            [-18.268883029467258, 2.6678813577196103],
            [-18.268369437950728, 2.663490008192392],
            [-18.270525565010473, 2.66084761658358],
            [-18.2667366099186, 2.6556135470463156],
            [-18.26642168927875, 2.6517400622509464],
            [-18.262140653847062, 2.648322098984568],
            [-18.25630552167336, 2.645992167007509],
            [-18.249999948014402, 2.6459129745276986],
            [-18.24549281599572, 2.6503837313875187],
            [-18.240954247755667, 2.6492975692673757],
            [-18.238874415000524, 2.654977637591343],
            [-18.236767641169752, 2.655326192601661],
            [-18.230939832033773, 2.6522032384702006],
            [-18.22417994857047, 2.6562288294408467],
            [-18.22115200652061, 2.654126633758043],
            [-18.213107425158572, 2.6529014093895698],
            [-18.21116591735243, 2.6554773758950163],
            [-18.206479392212234, 2.6553567279984036],
            [-18.20359495930944, 2.660425572358627],
            [-18.19562760421889, 2.6607577671105065],
            [-18.19234072706446, 2.6677327873739705],
            [-18.18933272490759, 2.6685461504463057],
            [-18.186556966975267, 2.674515727595472],
            [-18.181054408750313, 2.674530965464229],
            [-18.176587907600155, 2.677903138387285],
            [-18.173470504136368, 2.6782585036931286],
            [-18.17010978018723, 2.683513274051969],
            [-18.166540992534845, 2.685181014010218],
            [-18.16001122793646, 2.695047621190858],
            [-18.1531974727131, 2.6963205717512047],
            [-18.153151248396963, 2.7035343766804334],
            [-18.14964620521326, 2.7073195868350544],
            [-18.146436355758052, 2.7140919178819396],
            [-18.14295838064661, 2.7167069809387354],
            [-18.140899686653285, 2.724017415928453],
            [-18.137455373600343, 2.728516334010217],
            [-18.130808339465126, 2.73238685918091],
            [-18.11409036426471, 2.7262280527057263],
            [-18.052507617167908, 2.7058965749896986],
            [-18.03855470709927, 2.7032929396017407],
            [-18.00106061310269, 2.6935377703081196],
            [-17.994524490336993, 2.6931550227923435],
            [-17.986891541996684, 2.690062926885707],
            [-17.984863839467224, 2.697060855439265],
            [-17.943343784315076, 2.6863846806221376],
            [-17.94082227464978, 2.6934034563504703],
            [-17.926995399415727, 2.6899304586547768],
            [-17.925093443472957, 2.697045556722808],
            [-17.916163125899715, 2.694748795006251],
            [-17.91251064426727, 2.7089326955715056],
            [-17.90552952534314, 2.7069853082769506],
            [-17.903779771961347, 2.7139157179717284],
            [-17.79860793895503, 2.686935417456622],
            [-17.814662675346472, 2.6203340234148236],
            [-17.75922910012587, 2.537072781130675],
            [-17.76129111969974, 2.532408388872961],
            [-17.75659123980187, 2.5235880715170724],
            [-17.753517438552606, 2.519795873772274],
            [-17.750402539202906, 2.518787467117299],
            [-17.74991288351657, 2.5105752496864993],
            [-17.750752618971887, 2.5048982549083925],
            [-17.749494387436926, 2.4992653707437906],
            [-17.754255413063706, 2.495057402877675],
            [-17.752346729354713, 2.487085193553811],
            [-17.75632374569867, 2.4818231272179565],
            [-17.761269246500312, 2.4809962436476947],
            [-17.754512050271757, 2.473643505843688],
            [-17.75572430731097, 2.468465927944256],
            [-17.758518555123974, 2.4655009147849207],
            [-17.76905396810152, 2.460463072995764],
            [-17.775650201628732, 2.4622224779829756],
            [-17.780835042133294, 2.4606955019044925],
            [-17.78429602388576, 2.452695552445995],
            [-17.787221750331348, 2.441173028515818],
            [-17.798948652431122, 2.439611396218874],
            [-17.801022028285427, 2.4349297954669296],
            [-17.800574910779673, 2.43066199575995],
            [-17.80391752421286, 2.4298250781860458],
            [-17.80967936779719, 2.42589347989318],
            [-17.814633718314628, 2.420022269467165],
            [-17.82019880928148, 2.417110358608125],
            [-17.823057281551442, 2.4111067111582227],
            [-17.82054715939923, 2.409081004188518],
            [-17.824520577486272, 2.4034556560746045],
            [-17.829081474504168, 2.4003878357965727],
            [-17.829952366047984, 2.39725540566666],
            [-17.8361491403542, 2.3957493464247954],
            [-17.839328018527926, 2.3965558746518325],
            [-17.844102779499003, 2.3950042950454593],
            [-17.94295070390469, 2.344217162129159],
            [-17.94707919974773, 2.344616978170816],
            [-17.945327779783966, 2.351209901221597],
            [-17.96076525337515, 2.3553529933484323],
            [-17.962085073800687, 2.3504086436408906],
            [-17.96504530481572, 2.3532658307703387],
            [-17.970978863086778, 2.354543137183614],
            [-17.977851402747145, 2.348942497927816],
            [-17.982021053819736, 2.346977551958688],
            [-17.98479719892769, 2.34253778963551],
            [-17.98510431577562, 2.3386295888899338],
            [-17.981928622309912, 2.3303479921915446],
            [-17.99002766725375, 2.318819939687891],
            [-17.994873378069354, 2.317910131838929],
            [-18.00210596724223, 2.3092578518774096],
            [-18.00095657328868, 2.303266473655363],
            [-18.00690382761289, 2.296629324474337],
            [-18.011214864924142, 2.29445047189798],
            [-18.013568046656328, 2.296762132979747],
            [-18.024727763809054, 2.2929315762128573],
            [-18.033981332260645, 2.2944993351786085],
            [-18.039972882649117, 2.2974464474325575],
            [-18.054955396647625, 2.2965785338038303],
            [-18.05624679345677, 2.2933759278742314],
            [-18.060418827603748, 2.293316193494596],
            [-18.06105096865034, 2.2966375081632715],
            [-18.066653296646688, 2.2998016999691453],
            [-18.06951331772251, 2.2978987887791447],
            [-18.069507380863957, 2.2944983717144884],
            [-18.074623171972576, 2.2935402342429674],
            [-18.082464424588462, 2.283505793113766],
            [-18.081044240963383, 2.2778008446454177],
            [-18.085834435934, 2.275002526741247],
            [-18.088973294321523, 2.275034784970188],
            [-18.090311611834437, 2.2672421352065464],
            [-18.092877686889207, 2.263823126538026],
            [-18.097510055125827, 2.2625700380969853],
            [-18.100353930285333, 2.263793721820458],
            [-18.106746438960798, 2.2633355511685425],
            [-18.108582510405547, 2.2619872464917345],
            [-18.11685220938172, 2.2599743401105012],
            [-18.121010740852235, 2.2556697693763668],
            [-18.122648494165592, 2.2500372745670125],
            [-18.130705999608786, 2.243586069216663],
            [-18.13296089823993, 2.2444977012979526],
            [-18.142838306049565, 2.2432985963795877],
            [-18.15003942932916, 2.245155034246078],
            [-18.150835608985766, 2.2411841131173054],
            [-18.15372628251654, 2.23880940784895],
            [-18.166303342885616, 2.237925120742814],
            [-18.17625006024119, 2.2432208679640446],
            [-18.1819663176284, 2.2439276521210156],
            [-18.19126562723867, 2.2466199204328334],
            [-18.19352583134651, 2.2481409612641547],
            [-18.20085076812228, 2.246396818961723],
            [-18.211011459336245, 2.2492495688433065],
            [-18.214607689986597, 2.248215344808274],
            [-18.21870866089416, 2.2447651897223513],
            [-18.221092357241034, 2.247538994434031],
            [-18.23451183842067, 2.2463643800524298],
            [-18.24181662962772, 2.2431424299902374],
            [-18.250631623173206, 2.2446136756024555],
            [-18.25932478079573, 2.2430962986683114],
            [-18.26168379714391, 2.2460071567152036],
            [-18.270136871977304, 2.247808296943032],
            [-18.27815378608289, 2.245112625464651],
            [-18.289637364654915, 2.2457932240884033],
            [-18.29831099624328, 2.2478132567794398],
            [-18.302932184616967, 2.2454270233305866],
            [-18.30936753011413, 2.2454148285690185],
            [-18.31121816773755, 2.2438675654581313],
            [-18.31989112348338, 2.2431403186767316],
            [-18.335538327232683, 2.245781118610209],
            [-18.344382243033962, 2.24781197951635],
            [-18.35214404595651, 2.2520619333446557],
            [-18.36661886126958, 2.2495670284814526],
            [-18.373773242785987, 2.248949837684637],
            [-18.382748476229974, 2.252564967992974],
            [-18.390488973842512, 2.253892379824354],
            [-18.393840944113705, 2.25315418599178],
            [-18.405241866637603, 2.2583026560083237],
            [-18.41030412614036, 2.2584053896756595],
            [-18.417035355805524, 2.2649508349330882],
            [-18.42526222809966, 2.2694979771267976],
            [-18.429996218400596, 2.276350752330089],
            [-18.434872951722504, 2.2793772781966832],
            [-18.443036585933523, 2.2823307477267907],
            [-18.443020334696328, 2.2869000447950127],
            [-18.445235503432016, 2.2918769450187964],
            [-18.450519442145865, 2.294750978151897],
            [-18.467624065760475, 2.313870771312022],
            [-18.469252688909783, 2.3197151963971154],
            [-18.474976780264278, 2.3224205807064977],
            [-18.480258834713677, 2.3212835117424753],
            [-18.48137382133501, 2.324359621951519],
            [-18.4875410694672, 2.326147275161835],
            [-18.48746757789225, 2.3312982502632047],
            [-18.49244882080335, 2.330288799329994],
            [-18.495364985681817, 2.3350018964615997],
            [-18.502228943506296, 2.334552037518451],
            [-18.509815581630047, 2.338274901333996],
            [-18.51376170895463, 2.3356992565173686],
            [-18.520635192106326, 2.344542227165103],
            [-18.525634324842468, 2.3444828081266884],
            [-18.525618530190478, 2.34741509135875],
            [-18.532415330024197, 2.3478243604866784],
            [-18.533516988588755, 2.350056644565511],
            [-18.53886489778554, 2.3501831919670138],
            [-18.54150701103549, 2.3522745537015717],
            [-18.54411642511356, 2.3489747710125934],
            [-18.54818063838085, 2.350634773488273],
            [-18.554038283465854, 2.3502604645057663],
            [-18.555615896142136, 2.352216265672359],
            [-18.5609530634171, 2.3513075798163108],
            [-18.563563410643013, 2.3487061431482976],
            [-18.568075125787555, 2.348549543299902],
            [-18.571205816563467, 2.3423639854725273],
            [-18.575048640377815, 2.344155318969304],
            [-18.577413835341513, 2.3371060052449018],
            [-18.5832043178394, 2.3388756460648628],
            [-18.5836175847406, 2.344780016108837],
            [-18.591529900604122, 2.3425528060645844],
            [-18.593128675234365, 2.3404698225352853],
            [-18.59196151983441, 2.335661724082064],
            [-18.595476003794264, 2.331430145106752],
            [-18.598922925021657, 2.3308249493647173],
            [-18.601562626579724, 2.336284608736661],
            [-18.603508405049627, 2.3360098468053714],
            [-18.608108860534685, 2.3403656283988163],
            [-18.612190434914645, 2.3342349968222673],
            [-18.61736570962026, 2.331636899548521],
            [-18.62068409209705, 2.332657053070817],
            [-18.627087432890434, 2.3323558341159805],
            [-18.63110476615595, 2.329661074757529],
            [-18.63218087442808, 2.332795413159998],
            [-18.636679714390855, 2.3356864683903367],
            [-18.63636871393115, 2.344442098954335],
            [-18.63990318679754, 2.3450240248692915],
            [-18.642504064496496, 2.3417209560877663],
            [-18.648310918394543, 2.340497881402731],
            [-18.651648504374535, 2.343208879740949],
            [-18.657517887266604, 2.3421903022876163],
            [-18.661653591227186, 2.343852094748021],
            [-18.665978463636144, 2.3399857949017178],
            [-18.670483318906925, 2.3403221771893326],
            [-18.67770470284196, 2.3433003558738177],
            [-18.681696913222982, 2.34175155367448],
            [-18.684555928201767, 2.3471807619769867],
            [-18.688179642578042, 2.3497116455225626],
            [-18.69198093656409, 2.3486010468527345],
            [-18.69458926587492, 2.3439898214270913],
            [-18.701451934238786, 2.3421624494381454],
            [-18.707758356063703, 2.3431753843234104],
            [-18.7092525760243, 2.3736612042782266],
            [-18.710590580493598, 2.3917475438620808],
            [-18.713756927313828, 2.4485576993224574],
            [-18.71370225389451, 2.4749443433751703],
            [-18.714334319517477, 2.490762505441965],
            [-18.72088387949785, 2.5648862249844746],
            [-18.726630278088752, 2.559540723474508],
            [-18.735246664108846, 2.5565602223509285],
            [-18.739344979534035, 2.564517381749706]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -120.5246537928891, "lat": 38.77869782341393 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06017"],
        "coty_name": ["El Dorado"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["El Dorado County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00277273"
      },
      "bbox": [
        -18.739344979534035, 2.237925120742814, -17.749494387436926,
        2.7793036728190255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-20.102551981935655, 5.836785473440961],
            [-20.085750166998363, 5.8317468920448805],
            [-19.974270265061502, 5.799254262599912],
            [-19.974848311669952, 5.797340508150185],
            [-19.892778686569944, 5.773084181904055],
            [-19.91677323592471, 5.692910889270273],
            [-19.903104294594762, 5.689110171969966],
            [-19.899280118745935, 5.688630459050899],
            [-19.838762897695126, 5.670985653365794],
            [-19.815146725507454, 5.664267814939741],
            [-19.80982916280241, 5.662361483521562],
            [-19.72659253207581, 5.6381280085564125],
            [-19.723530782820596, 5.636915285953056],
            [-19.723486080931686, 5.633613820250592],
            [-19.717377093332537, 5.630294259246845],
            [-19.715278269525076, 5.624716460846372],
            [-19.713139741473597, 5.623214705385801],
            [-19.70973841917976, 5.616021964044887],
            [-19.714226744791628, 5.611871951134459],
            [-19.716279887343052, 5.60747202812025],
            [-19.71935625098477, 5.605742324027509],
            [-19.72017090048113, 5.592493072060816],
            [-19.72269760665695, 5.5865040835767985],
            [-19.723208106852162, 5.579776811323369],
            [-19.721232590110798, 5.577900502821383],
            [-19.72130969121719, 5.572564591856618],
            [-19.716060349349306, 5.567173218363248],
            [-19.71546333057837, 5.559156342821182],
            [-19.717985777849577, 5.552644149135403],
            [-19.71638582617874, 5.549014147751922],
            [-19.717524664884635, 5.541533542463961],
            [-19.72117093701353, 5.538249625510157],
            [-19.72493491074815, 5.536942234044188],
            [-19.724962601959312, 5.532703926743357],
            [-19.722234298713435, 5.528969127310282],
            [-19.716151342325652, 5.523566243336571],
            [-19.715506484901944, 5.519866013256455],
            [-19.717144658440397, 5.515700967835647],
            [-19.717349133930142, 5.507143844951934],
            [-19.72089218781877, 5.497160911697952],
            [-19.7292035307777, 5.492028621111434],
            [-19.733505122305754, 5.487699544621149],
            [-19.731934578869872, 5.481341356500601],
            [-19.723775125086405, 5.474049404438706],
            [-19.722591492922426, 5.469196170031491],
            [-19.72551183861678, 5.465522551206443],
            [-19.72594492881215, 5.460850877048048],
            [-19.72359021956623, 5.456220883461141],
            [-19.723578445945858, 5.450648255196013],
            [-19.72053626690086, 5.4433887286678555],
            [-19.7175789371158, 5.441253602014981],
            [-19.717378990590298, 5.425233429317363],
            [-19.71616974152788, 5.42298046066319],
            [-19.720303013217336, 5.414530232524545],
            [-19.72729594558573, 5.410609710165214],
            [-19.729635214820917, 5.412926721548102],
            [-19.738309252221125, 5.411300342847607],
            [-19.73966491512465, 5.407632549932911],
            [-19.738825537789246, 5.400483803902991],
            [-19.742019097068198, 5.396889035767484],
            [-19.741375647179492, 5.393607040017989],
            [-19.74474910683753, 5.3848972528341825],
            [-19.746605082668502, 5.374295855242205],
            [-19.748944934047703, 5.367810861316969],
            [-19.754374739753153, 5.362772170474516],
            [-19.758552648539638, 5.356080680343591],
            [-19.75815189156484, 5.354146447996373],
            [-19.764181301026962, 5.34802223445478],
            [-19.763813702990333, 5.345547954050592],
            [-19.76953996726544, 5.343401451362259],
            [-19.7763288516659, 5.347105367435769],
            [-19.778048306531534, 5.350822917215233],
            [-19.78151132565779, 5.350766058546491],
            [-19.779443344653696, 5.342871426037006],
            [-19.780171900746105, 5.339777697760081],
            [-19.785806221572713, 5.335096656920157],
            [-19.783396559471203, 5.33165108749837],
            [-19.783796426672584, 5.325984181376853],
            [-19.779822889204976, 5.325139356021929],
            [-19.776825197813903, 5.317078677519632],
            [-19.770439971599863, 5.315242650070241],
            [-19.76570571814008, 5.315451487825617],
            [-19.76183020004166, 5.308954613286779],
            [-19.764413798986833, 5.304058956213604],
            [-19.76646088684018, 5.293600789735289],
            [-19.766063040520727, 5.286099949567752],
            [-19.761004447394615, 5.279943904226587],
            [-19.758216149701134, 5.279047989509033],
            [-19.763287337199092, 5.2701309020101625],
            [-19.762452674018224, 5.261739569155499],
            [-19.765844319646828, 5.260484494445477],
            [-19.773434999659923, 5.261608779104426],
            [-19.781528014465845, 5.254601794123963],
            [-19.781932544249127, 5.249858323827605],
            [-19.784745869157785, 5.242519130484957],
            [-19.788649583761945, 5.238855036643508],
            [-19.791275731269785, 5.239209421343149],
            [-19.796472948849075, 5.229646264349836],
            [-19.80505645285652, 5.226004902867639],
            [-19.810327098688116, 5.224837658013353],
            [-19.81151760457099, 5.2216334717463075],
            [-19.8073391282283, 5.217567620781201],
            [-19.80683934647767, 5.213219045825228],
            [-19.809783646292775, 5.206764398170813],
            [-19.812378068265744, 5.204079120707652],
            [-19.817187631418527, 5.203082324324716],
            [-19.820574422770754, 5.204620046936469],
            [-19.835172284779933, 5.198149198352243],
            [-19.839181558653237, 5.1944114273158615],
            [-19.844713545821286, 5.183478265194161],
            [-19.850301114159926, 5.187019950447969],
            [-19.855285881510103, 5.187868750796573],
            [-19.864922717292163, 5.195127178079423],
            [-19.865882658123247, 5.20002139801796],
            [-19.86925422620672, 5.206260907970987],
            [-19.87290073812706, 5.209753071124095],
            [-19.877798567024385, 5.209844586477351],
            [-19.883166948844796, 5.213848610444769],
            [-19.880060882563633, 5.2179562172684895],
            [-19.88212538427882, 5.222551218597097],
            [-19.88878247786211, 5.229033459341902],
            [-19.891061450570632, 5.234218682094243],
            [-19.897522801603774, 5.234040963527108],
            [-19.89991008429683, 5.231292344446374],
            [-19.900393633971742, 5.222634239011917],
            [-19.903670951523935, 5.2239490393366275],
            [-19.9134095673213, 5.221472741324843],
            [-19.91640011586383, 5.218798899320575],
            [-19.920206464702353, 5.218883148323505],
            [-19.924637105237196, 5.22418414623016],
            [-19.928717946755395, 5.223616939014996],
            [-19.93387241754284, 5.224941745597487],
            [-19.941079089653055, 5.229653648687519],
            [-19.94303394264564, 5.227061079995123],
            [-19.941993387478345, 5.223443164471413],
            [-19.93757732040994, 5.217970055419443],
            [-19.94146497642007, 5.211284328817773],
            [-19.937151178057196, 5.2002750635545825],
            [-19.93755281160412, 5.19537912526348],
            [-19.941670746301288, 5.1917518920432615],
            [-19.937347671760648, 5.1825658775775265],
            [-19.937058641363116, 5.177739930533394],
            [-19.94117920658208, 5.17544011116029],
            [-19.938133067995885, 5.169946565276128],
            [-19.938837554967215, 5.1672149128872045],
            [-19.936265796631876, 5.160938175955668],
            [-19.933024909761038, 5.162175270733226],
            [-19.92935061408689, 5.158826684084094],
            [-19.9367983887372, 5.1513491981235076],
            [-19.928931067334897, 5.148778678084959],
            [-19.930398208262098, 5.1453963449744355],
            [-19.930428080312456, 5.133448209071606],
            [-19.92505340201731, 5.131100963559318],
            [-19.924813983768853, 5.1291304535242555],
            [-19.928671472799806, 5.124575804331858],
            [-19.925321681727855, 5.120309689864893],
            [-19.92563085733327, 5.11801791732802],
            [-19.930644437998982, 5.115137961962142],
            [-19.934661030898923, 5.110974321883352],
            [-19.932670611133716, 5.102418893265532],
            [-19.933403617186386, 5.0998651152057475],
            [-19.92900484567069, 5.097251664854877],
            [-19.931371857097023, 5.089262732548862],
            [-19.93144932482302, 5.084061067906844],
            [-19.933442166836954, 5.082834451323596],
            [-19.939364670975472, 5.087276327601082],
            [-19.94126845640777, 5.078762625201334],
            [-19.93776057267549, 5.080657367018471],
            [-19.936226644645195, 5.0767944165095225],
            [-19.9383710378746, 5.074142053311765],
            [-19.938135695083222, 5.0694059435743215],
            [-19.933953079182974, 5.064118621150385],
            [-19.934505435352747, 5.061478431075418],
            [-19.938678160243793, 5.058976697339553],
            [-19.93793772395576, 5.051669759035685],
            [-19.941705528681105, 5.049571841530063],
            [-19.940307677265036, 5.046312215293962],
            [-19.941399270831806, 5.04015121381825],
            [-19.940272537702214, 5.027812286089588],
            [-19.94113180567252, 5.022435462703841],
            [-19.943166673317357, 5.018730901534583],
            [-19.982588945267462, 4.887959292551386],
            [-19.996277829390976, 4.841364366701636],
            [-20.009557815268945, 4.797585082148091],
            [-20.00962251270814, 4.796653924281268],
            [-20.02974200355222, 4.729767641813104],
            [-20.055385341088986, 4.6443445080092545],
            [-20.08158900303255, 4.556302500910117],
            [-20.08344094023691, 4.548900477513835],
            [-20.12281253892004, 4.418174462996957],
            [-20.15317411446594, 4.317290282479471],
            [-20.271453192772405, 4.352407811403885],
            [-20.299949265041114, 4.360996992033862],
            [-20.30340908191373, 4.362351123189681],
            [-20.437585648362017, 4.401891240052545],
            [-20.501386115125243, 4.421100404988199],
            [-20.50704241704477, 4.435476732352311],
            [-20.51111002257311, 4.440173947717296],
            [-20.513569841849424, 4.4451192840960525],
            [-20.51870609826097, 4.4505638085465815],
            [-20.524853073957186, 4.452932407253558],
            [-20.528661665609253, 4.450429979841376],
            [-20.530879479337383, 4.452522396465353],
            [-20.5338450834313, 4.4633116849118695],
            [-20.53194493644163, 4.468873480694683],
            [-20.52406488809515, 4.496150038287561],
            [-20.52506736947358, 4.509422104882777],
            [-20.528140173077723, 4.515526360015704],
            [-20.528484222523808, 4.518787604372256],
            [-20.532704888339964, 4.530359792955709],
            [-20.534638645136717, 4.538956954657029],
            [-20.539527109643565, 4.542963721410788],
            [-20.541493208549447, 4.546645464895228],
            [-20.55225203950263, 4.557544338577035],
            [-20.55838351106715, 4.560807777220399],
            [-20.560358614618305, 4.563355232748112],
            [-20.57227266170007, 4.571898626191098],
            [-20.578944471173287, 4.580111112182249],
            [-20.58280218751934, 4.5817678088466804],
            [-20.593420259555902, 4.616935333526626],
            [-20.600159133168248, 4.626229956566977],
            [-20.604739603360287, 4.635945078554218],
            [-20.618020834786062, 4.649028378039727],
            [-20.625083305595265, 4.663994330807578],
            [-20.634800972261818, 4.6740216420441065],
            [-20.638331530528266, 4.681047666964932],
            [-20.650723928855477, 4.703564639776],
            [-20.65244136609271, 4.715402011452642],
            [-20.655276417214225, 4.719365972166125],
            [-20.66160426228958, 4.725160555031278],
            [-20.666658781580747, 4.733519765482765],
            [-20.667588245595482, 4.737593895326635],
            [-20.67035957883786, 4.741758159069211],
            [-20.671273251600425, 4.746002194225753],
            [-20.669326253190366, 4.74962596253764],
            [-20.666911897923505, 4.760695401411175],
            [-20.65369832447659, 4.7800709760640325],
            [-20.6513250886197, 4.785983233893196],
            [-20.647110703807748, 4.789731409028059],
            [-20.644114406834703, 4.794125251576972],
            [-20.642942992872285, 4.811427544206964],
            [-20.6460086446872, 4.819656099222079],
            [-20.646206512736093, 4.82438471284108],
            [-20.63889402627712, 4.855865576114824],
            [-20.639481237964592, 4.875048486180162],
            [-20.64168489242912, 4.881934726959845],
            [-20.64820068788598, 4.892577716220089],
            [-20.648718663647998, 4.899379522922069],
            [-20.6517545580164, 4.90950563490851],
            [-20.648792086422734, 4.921091041190842],
            [-20.652034931666254, 4.926389143194406],
            [-20.649798668655365, 4.931092733078419],
            [-20.635559138727356, 4.946618067972177],
            [-20.618902194704415, 4.970638251003422],
            [-20.61468828664285, 4.979894786122927],
            [-20.61591072192175, 4.985634508845998],
            [-20.61392132384243, 4.990821262677924],
            [-20.608711401707577, 4.998195712423455],
            [-20.597170848494738, 5.008676083009882],
            [-20.586023220725775, 5.022465088895658],
            [-20.541376790108586, 5.07999302092506],
            [-20.524278036491935, 5.099036212959096],
            [-20.52188546082929, 5.100203577700904],
            [-20.493700171251778, 5.131833214352358],
            [-20.448028776776976, 5.176239439093293],
            [-20.42344329976558, 5.204693326782213],
            [-20.39400765236899, 5.23324336689476],
            [-20.364570437337843, 5.264721451395332],
            [-20.341820304886195, 5.291875995759382],
            [-20.311965883927805, 5.334941135825035],
            [-20.27972946819077, 5.3918357968362205],
            [-20.264096241500603, 5.426571142791292],
            [-20.267161435959057, 5.440777315655407],
            [-20.265809121448562, 5.442793007212524],
            [-20.267538155369536, 5.450303046492019],
            [-20.273147161780024, 5.459070796705987],
            [-20.279068697396053, 5.463303429990254],
            [-20.28182286928035, 5.459236270255113],
            [-20.286209424903767, 5.461267687719317],
            [-20.280346066260684, 5.467939196107998],
            [-20.281322106648613, 5.474701792577984],
            [-20.284377062128065, 5.474876501396376],
            [-20.28448197556525, 5.481777474111044],
            [-20.28030120678802, 5.484367703809748],
            [-20.27695495160822, 5.493723552394516],
            [-20.277786707555222, 5.506412491866929],
            [-20.279702231089914, 5.508822455001742],
            [-20.276349357072014, 5.511392103819968],
            [-20.275821301259388, 5.516030989367794],
            [-20.273479635332933, 5.518364376889834],
            [-20.269966565992593, 5.528112433455141],
            [-20.2721881662579, 5.5370396022901724],
            [-20.26810023769059, 5.538955456153844],
            [-20.26856292362041, 5.545226463577106],
            [-20.26339062275161, 5.548214527396458],
            [-20.257697462281993, 5.544202150127001],
            [-20.252370667792594, 5.546614133957629],
            [-20.22403869836776, 5.585262227591271],
            [-20.20109680989019, 5.620207236808057],
            [-20.200184640147647, 5.627535148446122],
            [-20.197437976193324, 5.630638260894243],
            [-20.173568694038515, 5.672703179867191],
            [-20.146661957294143, 5.726872175696293],
            [-20.133743272559684, 5.75200761321319],
            [-20.1081915879211, 5.812124373533511],
            [-20.106985651977695, 5.823981229977103],
            [-20.102551981935655, 5.836785473440961]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -123.87560709731135, "lat": 40.6993031998421 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06023"],
        "coty_name": ["Humboldt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Humboldt County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01681908"
      },
      "bbox": [
        -20.671273251600425, 4.317290282479471, -19.70973841917976,
        5.836785473440961
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.723650204449605, 4.489790380215055],
            [-19.717747537785836, 4.486395432330987],
            [-19.713198295554523, 4.4872944445245135],
            [-19.709616531664814, 4.4904030950754725],
            [-19.704979346333616, 4.48853219037365],
            [-19.69735125324683, 4.494520366258439],
            [-19.689760374573435, 4.497399086920993],
            [-19.687047251618406, 4.495479002409651],
            [-19.681400476085084, 4.4945268830806855],
            [-19.679300501664112, 4.497310410084639],
            [-19.673366781209246, 4.497161792367296],
            [-19.669412681158008, 4.4955266740526065],
            [-19.66249469578459, 4.49591186420214],
            [-19.657051732275303, 4.497956795382005],
            [-19.651425369588534, 4.498273352310961],
            [-19.648149730707388, 4.49245517733156],
            [-19.638148963327108, 4.489879354492761],
            [-19.63379675421936, 4.485698063349169],
            [-19.62171335646814, 4.487604010461612],
            [-19.6195508525579, 4.481222662999968],
            [-19.61379455022556, 4.478503287448199],
            [-19.60778111633444, 4.48143486078683],
            [-19.60229448031493, 4.482701021845189],
            [-19.599586298174714, 4.486115138688451],
            [-19.591141567284563, 4.49164844992067],
            [-19.584060963119377, 4.497751532489279],
            [-19.57665843993686, 4.502056421663653],
            [-19.575361829526216, 4.505062824063032],
            [-19.570684418043804, 4.50802507898194],
            [-19.565492745387235, 4.5083699345028805],
            [-19.56061298720581, 4.505930495300542],
            [-19.560306394843515, 4.503197189722715],
            [-19.554692002789768, 4.499440678720916],
            [-19.54638183089407, 4.499576804351863],
            [-19.54330316570978, 4.498611861171251],
            [-19.540110996343298, 4.500853418829016],
            [-19.534026951551724, 4.500711038817512],
            [-19.529139053544224, 4.498941951007858],
            [-19.52273679702983, 4.498650965668695],
            [-19.515673957156544, 4.501602300872737],
            [-19.503140972930566, 4.497330841760248],
            [-19.49719280187658, 4.49914901346972],
            [-19.479182436960052, 4.498861261967887],
            [-19.476070557491276, 4.4949424883944635],
            [-19.47252871636018, 4.499054905643735],
            [-19.465804513283235, 4.496756983695079],
            [-19.460453682240704, 4.488409421807408],
            [-19.462444504383136, 4.485592847603689],
            [-19.46467942198387, 4.477682990775361],
            [-19.458198520085045, 4.476736835860835],
            [-19.448371477078084, 4.474150874611762],
            [-19.446373767668568, 4.470408107233189],
            [-19.438426264591445, 4.464373990498851],
            [-19.436436878434623, 4.46003422622434],
            [-19.427112063921495, 4.454670439476358],
            [-19.427414058614282, 4.449726182925787],
            [-19.42478421847651, 4.448250229529059],
            [-19.41915702468313, 4.449004504948725],
            [-19.415269000202166, 4.44489182052202],
            [-19.4105837124441, 4.4428000411980495],
            [-19.40616111800027, 4.446297245017432],
            [-19.397200173822654, 4.44472399133587],
            [-19.39518484078109, 4.44831474195971],
            [-19.386714194205148, 4.448254529902096],
            [-19.38711326479936, 4.455768842385186],
            [-19.38355264774325, 4.455564017367298],
            [-19.376505055256462, 4.451632181455014],
            [-19.36960088614607, 4.454469745992907],
            [-19.362489318603394, 4.459739136921061],
            [-19.355270906812674, 4.459015250396471],
            [-19.347567567523484, 4.465933837391985],
            [-19.339392822798494, 4.462565278660741],
            [-19.33833663566346, 4.460682916684396],
            [-19.325381279412245, 4.466781707323616],
            [-19.322580090107856, 4.4698585085048945],
            [-19.318397661510307, 4.466506142311072],
            [-19.315646819399777, 4.471897352104282],
            [-19.312056492608093, 4.4678765534066045],
            [-19.30371185059241, 4.473917969208781],
            [-19.300857232449328, 4.473627706395208],
            [-19.297898493023567, 4.478599763948671],
            [-19.29489585929875, 4.472208627627358],
            [-19.288223909606323, 4.471377136593756],
            [-19.287560502131775, 4.464865474170937],
            [-19.27696770566724, 4.461131459628404],
            [-19.274483840464846, 4.458150674522981],
            [-19.270946619009894, 4.460901790731213],
            [-19.264675711584694, 4.458926543285779],
            [-19.261971155670953, 4.454421992640115],
            [-19.261579398574685, 4.449475151009989],
            [-19.255353412441735, 4.450455459230502],
            [-19.252358023542065, 4.44909999425978],
            [-19.249106072920224, 4.443470559752622],
            [-19.239718623976817, 4.441953647348883],
            [-19.231019176565297, 4.444437038865288],
            [-19.22663952142388, 4.442831205137001],
            [-19.2252391976865, 4.43786820825722],
            [-19.218395245935103, 4.435765076650453],
            [-19.213106599381653, 4.43183086468711],
            [-19.207994597341095, 4.432696892690675],
            [-19.194559399556148, 4.427011610465404],
            [-19.19073018629336, 4.427674156378897],
            [-19.184459196418484, 4.423552584230013],
            [-19.17645383274019, 4.420161239028384],
            [-19.170409792945552, 4.4219180165542085],
            [-19.162651640071587, 4.418810763175629],
            [-19.159611214398844, 4.419589771157526],
            [-19.151991509611243, 4.413445555773574],
            [-19.14279471059662, 4.41547221415269],
            [-19.13694559596192, 4.418935725399976],
            [-19.134760513489493, 4.41523051921162],
            [-19.12921710046725, 4.411936525380474],
            [-19.12411037421891, 4.412714735251458],
            [-19.120185492338166, 4.411483330029994],
            [-19.116159838374767, 4.4124245653255265],
            [-19.109993643216523, 4.4108203872112135],
            [-19.105448369787172, 4.416878373221274],
            [-19.097721694519137, 4.414460953772315],
            [-19.09227473309873, 4.411730615947811],
            [-19.088341439212364, 4.414257013354978],
            [-19.080747407738546, 4.408169927109202],
            [-19.079118214744835, 4.404889642286771],
            [-19.07381504984618, 4.4025570359929915],
            [-19.072809281663332, 4.399069207765347],
            [-19.06819065686854, 4.4001917998959135],
            [-19.061259284753135, 4.410017245119392],
            [-19.061205758430393, 4.400714394834178],
            [-19.057610609633738, 4.395428718152868],
            [-19.051108047536896, 4.393884819295678],
            [-19.052331730501493, 4.398594784145242],
            [-19.0589290704402, 4.402077527596836],
            [-19.053478384276833, 4.408022463070348],
            [-19.04998044523819, 4.406344741932535],
            [-19.041460588240742, 4.405964018128107],
            [-19.038855092536128, 4.40460830849899],
            [-19.035216887198025, 4.4075326998096145],
            [-19.02783488317178, 4.406635643974509],
            [-19.012877690930424, 4.40313718481195],
            [-19.0119807558179, 4.407352853504208],
            [-19.0057510174177, 4.405934534436996],
            [-19.002718444889755, 4.408316571513808],
            [-18.99917195856451, 4.4058796371579065],
            [-18.995784857686584, 4.4085489238090805],
            [-18.991810445556233, 4.409110552890232],
            [-18.98611566453825, 4.412331504667465],
            [-18.97995460377213, 4.4079177697587095],
            [-18.973402341898367, 4.406173500260337],
            [-18.966693148454546, 4.4074464742306345],
            [-18.96071791920323, 4.405800528981497],
            [-18.955413340965034, 4.405643026663472],
            [-18.95115444069424, 4.408252255828783],
            [-18.945966189513932, 4.404953741092241],
            [-18.938983611619353, 4.404260297156927],
            [-18.926683857908763, 4.405481428482902],
            [-18.925237519747185, 4.402373673177464],
            [-18.91877109345734, 4.405778977648316],
            [-18.914925240328298, 4.404529287786665],
            [-18.910586729306278, 4.399557620885644],
            [-18.90780509143144, 4.40176424153637],
            [-18.897521379753602, 4.395815247861756],
            [-18.888880506322874, 4.392778827062202],
            [-18.884606933546838, 4.388626589628574],
            [-18.877638826323434, 4.386331711363245],
            [-18.87155918509218, 4.380888660648846],
            [-18.86737918611225, 4.381862407575262],
            [-18.861083654735882, 4.380942604172434],
            [-18.854839107059885, 4.384632326769872],
            [-18.849034230843674, 4.385776344413256],
            [-18.84884797991707, 4.383350341762149],
            [-18.84149778206929, 4.378425211421534],
            [-18.834741946600797, 4.383095611340108],
            [-18.8327717314374, 4.382149897068978],
            [-18.819226352673972, 4.388802885829086],
            [-18.816138714846943, 4.387185236268607],
            [-18.808828328507627, 4.389544311973966],
            [-18.79926645270332, 4.3890472424761935],
            [-18.795663924397793, 4.3850422509454665],
            [-18.791048906624233, 4.381937132397046],
            [-18.78530673371289, 4.380151308588961],
            [-18.778180881347676, 4.380904335498044],
            [-18.77201936520015, 4.380219613090789],
            [-18.765708687279165, 4.382324657730602],
            [-18.75892303778433, 4.377868752466236],
            [-18.752578770955914, 4.37737205117642],
            [-18.74585031901158, 4.369252188059076],
            [-18.716002053685447, 4.358824743670161],
            [-18.713253582877254, 4.359508884175853],
            [-18.704098818827973, 4.365554739866925],
            [-18.701900590931125, 4.368320495509905],
            [-18.698363642817426, 4.367375631181163],
            [-18.693499236176493, 4.368423017112625],
            [-18.68835241634399, 4.364496028960783],
            [-18.684582891729672, 4.36395421651619],
            [-18.679960256061616, 4.365874070167467],
            [-18.675800643990225, 4.365968092820424],
            [-18.67037303049192, 4.361416079749976],
            [-18.666344173983056, 4.360267175876782],
            [-18.66614643119993, 4.357481110527161],
            [-18.657022043620973, 4.349044004399364],
            [-18.65218395685976, 4.340491139806171],
            [-18.646500893722617, 4.340897639836735],
            [-18.638169292987413, 4.339810631721106],
            [-18.63164065564657, 4.337361560161232],
            [-18.62833411968826, 4.3381935711133774],
            [-18.62382133412131, 4.336243163251894],
            [-18.622692759037214, 4.332421754570737],
            [-18.619421968989432, 4.328121265658805],
            [-18.6117512712433, 4.325508207260245],
            [-18.604847909348308, 4.328337297901845],
            [-18.59956611501154, 4.333814560781066],
            [-18.589980558127905, 4.334667425461328],
            [-18.569025898192077, 4.329462838743154],
            [-18.553478426396598, 4.323731257281257],
            [-18.54094438508006, 4.320992215067176],
            [-18.53983953219516, 4.316128182840057],
            [-18.544756150339914, 4.307860910577117],
            [-18.535270512903757, 4.300589582399422],
            [-18.53085652018155, 4.298697129411083],
            [-18.529613167799596, 4.295082866943732],
            [-18.534795019161123, 4.292092250093811],
            [-18.537287209758563, 4.2841020699413],
            [-18.54224953209001, 4.275917285372725],
            [-18.54433350578773, 4.270765560815297],
            [-18.54411465097109, 4.267189532044033],
            [-18.54636656489585, 4.262928837679113],
            [-18.54667768424002, 4.255703230426946],
            [-18.542395623579612, 4.247277871506866],
            [-18.549944328206553, 4.241059074350611],
            [-18.55024821058486, 4.234607503008885],
            [-18.547750231492085, 4.230444566787914],
            [-18.546608634419236, 4.22303262064275],
            [-18.53857728270754, 4.221009049216056],
            [-18.527033891095634, 4.215439246490785],
            [-18.522223956704018, 4.214244755123837],
            [-18.516674899537687, 4.214984167458283],
            [-18.510406666056383, 4.209260500627289],
            [-18.50611475224396, 4.204138001876127],
            [-18.500079793762893, 4.201264804244908],
            [-18.495647979439056, 4.2006430143883495],
            [-18.493811505736446, 4.19767129470892],
            [-18.488597119899218, 4.1956137436404015],
            [-18.484667764856844, 4.195981085066408],
            [-18.47964657400806, 4.18743215309692],
            [-18.476881646577183, 4.184769086927788],
            [-18.479212812600107, 4.178977860802629],
            [-18.471614346745273, 4.1707504446580925],
            [-18.470703711902143, 4.166105343659443],
            [-18.465650796399352, 4.161748134566049],
            [-18.464014969442555, 4.1582606781951945],
            [-18.465395350391308, 4.155394652382783],
            [-18.46982344135817, 4.156440514020996],
            [-18.4777527312866, 4.149193146590925],
            [-18.480577126799265, 4.150393951808606],
            [-18.48413683830853, 4.154672604944906],
            [-18.492324945872838, 4.153708445891084],
            [-18.490004712648123, 4.149160182901482],
            [-18.49022870022935, 4.142674856476339],
            [-18.485195134840296, 4.1408222836795145],
            [-18.486632056534674, 4.135107967482077],
            [-18.485055251271884, 4.1297153164010485],
            [-18.478896473807406, 4.126985007202185],
            [-18.479296068395183, 4.123002352690002],
            [-18.482576652744964, 4.120273248005923],
            [-18.480971364522507, 4.115627286065548],
            [-18.487273770602922, 4.1103749628927035],
            [-18.48966972288242, 4.106435546455285],
            [-18.499199074038405, 4.1008970544085495],
            [-18.49925179404793, 4.094195453754875],
            [-18.501973387298627, 4.091671987243211],
            [-18.502207446644075, 4.088011029654561],
            [-18.500588325107117, 4.080418302695959],
            [-18.509018696883597, 4.068787110057676],
            [-18.515088431637178, 4.068645073217221],
            [-18.521675988671888, 4.070223599512999],
            [-18.526623668811272, 4.065423923423133],
            [-18.53181704575383, 4.062693943471371],
            [-18.535964893945874, 4.063182811507192],
            [-18.537762140444507, 4.059014329301969],
            [-18.543011123318333, 4.056334486318691],
            [-18.5461629363536, 4.060232393555962],
            [-18.56526996572205, 4.0662608717713455],
            [-18.570023193473954, 4.0630318122023485],
            [-18.56753068895478, 4.059297219489209],
            [-18.566546063731597, 4.052826499003159],
            [-18.574246178272983, 4.05056420596372],
            [-18.574597777705108, 4.042683466467632],
            [-18.57683270274301, 4.034743864238592],
            [-18.58003732389276, 4.030070183867918],
            [-18.578707665049922, 4.02504820649174],
            [-18.575112162970353, 4.023887171861774],
            [-18.5803141334292, 4.021965129418183],
            [-18.585423610306076, 4.003476397366833],
            [-18.592603576720673, 4.005533165058728],
            [-18.594760486922087, 3.99818015519585],
            [-18.61519824873712, 4.004029285026319],
            [-18.61715561990567, 3.9969671123936625],
            [-18.624328470125658, 3.9991409213238587],
            [-18.6262759649536, 3.9921145889538128],
            [-18.640675206898923, 3.995993878688039],
            [-18.642677929298234, 3.988752952050122],
            [-18.698106374089857, 4.003992305788948],
            [-18.69985158991293, 3.996925935674351],
            [-18.70668404456901, 3.998979099995674],
            [-18.71635136439823, 3.964311184763351],
            [-18.71918538030806, 3.9623470322424543],
            [-18.72655843272767, 3.9643747260636264],
            [-18.728862263408356, 3.9563023499650742],
            [-18.73503687549558, 3.9583327372660766],
            [-18.73747142942919, 3.951019039519389],
            [-18.743502708799028, 3.952765118742282],
            [-18.747629110309624, 3.9394263656835156],
            [-18.75455986098757, 3.941519338438547],
            [-18.761817926804554, 3.9132420681035187],
            [-18.76937043060452, 3.915572127720232],
            [-18.773413356186396, 3.9015084858471267],
            [-18.81382727540073, 3.914592055253538],
            [-18.81848983415415, 3.909342344182572],
            [-18.826802494359725, 3.904668004324953],
            [-18.831638755960633, 3.9051193736534837],
            [-18.835190840176228, 3.90301922707316],
            [-18.84072151255188, 3.8937473189689302],
            [-18.846465908432222, 3.891751871825917],
            [-18.854038090082074, 3.8846694615764603],
            [-18.858624332321668, 3.8791038811553626],
            [-18.86118257695773, 3.871930334611768],
            [-18.863888882119348, 3.868404078685104],
            [-18.870402174682408, 3.849212197929827],
            [-18.87291682313244, 3.8472808047050893],
            [-18.884514023075077, 3.8435001914607154],
            [-18.894730249147077, 3.836847216193997],
            [-18.916054040059183, 3.842451152985367],
            [-18.915591248712733, 3.838274361351453],
            [-18.966570219712978, 3.852088661483253],
            [-18.974840094913393, 3.8535697839351717],
            [-19.09208295654634, 3.8869341753437263],
            [-19.09015678619357, 3.8823441766931905],
            [-19.098894281289606, 3.8741030086344717],
            [-19.106499606643023, 3.8683039228716884],
            [-19.107035183462905, 3.863373744947284],
            [-19.111948542955354, 3.8566541583336886],
            [-19.118944488090108, 3.8535182355219257],
            [-19.121884285025327, 3.850066138186293],
            [-19.1196196333667, 3.8406883404407597],
            [-19.116235879783787, 3.8361151073990594],
            [-19.116486144660396, 3.833093155080113],
            [-19.120179108076112, 3.8271824630936147],
            [-19.126164582593457, 3.8231894032014035],
            [-19.12645596648652, 3.8210147192591655],
            [-19.120724715961373, 3.811681782777099],
            [-19.117784102037966, 3.8099926784239404],
            [-19.11678164112535, 3.803775940649552],
            [-19.174218151672758, 3.8197375848960493],
            [-19.213392596384146, 3.83079127183056],
            [-19.217111900109764, 3.8322472525746742],
            [-19.266435705517623, 3.8469143593310027],
            [-19.266792418207885, 3.8477447743423085],
            [-19.357049408523274, 3.8732769704673737],
            [-19.35973401905457, 3.8738044204127577],
            [-19.54798078173028, 3.9279370829363045],
            [-19.736239530179095, 3.982024734660812],
            [-19.749585817175273, 3.9862884390512465],
            [-19.749845167579945, 3.98527423210091],
            [-19.768861607952612, 3.9904927448984555],
            [-19.772221861665184, 3.99513537884913],
            [-19.770301677397768, 4.002693015151888],
            [-19.7700624845708, 4.009684157317984],
            [-19.767718973008076, 4.021088729627748],
            [-19.765507466226314, 4.026549014491202],
            [-19.767827415957868, 4.031428389823057],
            [-19.770986767720444, 4.03416315636121],
            [-19.771956411758875, 4.04077265114009],
            [-19.76819463116751, 4.0465683492059545],
            [-19.76483692713746, 4.0486016541613905],
            [-19.765106111263506, 4.0527128748049375],
            [-19.761624955320656, 4.056080823646756],
            [-19.75828337058509, 4.06184345196112],
            [-19.759263480825027, 4.065822497898986],
            [-19.754545657064078, 4.072051071822517],
            [-19.751718270973786, 4.081558439905142],
            [-19.74911294582539, 4.085456653017477],
            [-19.74692107829639, 4.099098181352996],
            [-19.736001027584862, 4.099675393606376],
            [-19.729749787358553, 4.099070606491231],
            [-19.722965632162847, 4.101236679284461],
            [-19.722034805935238, 4.107068073942841],
            [-19.719528392079276, 4.113283813851403],
            [-19.712289470697826, 4.114451337102286],
            [-19.71214139377484, 4.11835221185],
            [-19.719496793365423, 4.130196309854074],
            [-19.71672911309326, 4.141192827715339],
            [-19.714078448145465, 4.143644669358347],
            [-19.712160022806845, 4.15553638214487],
            [-19.715413879296797, 4.163668580318482],
            [-19.716303748780888, 4.168115081525718],
            [-19.713847971088818, 4.171661021077584],
            [-19.71765152989495, 4.1822741344495435],
            [-19.722600463300807, 4.186869846428122],
            [-19.717068465856624, 4.199787456147892],
            [-19.7202944583834, 4.204638388419731],
            [-19.71991171238121, 4.20880419519336],
            [-19.714747307818058, 4.213287746444047],
            [-19.71165668055668, 4.2191529284071025],
            [-19.712918697870247, 4.225722236210556],
            [-19.71112404699592, 4.232974408914229],
            [-19.7060389130545, 4.236015437307971],
            [-19.706094686466635, 4.2464907055650185],
            [-19.710436560596396, 4.255258037360619],
            [-19.714865289510886, 4.258561532400732],
            [-19.71328339715888, 4.263355229826269],
            [-19.715904392834652, 4.268032636533893],
            [-19.712555323773337, 4.270555454194488],
            [-19.707941509386764, 4.2777230385986185],
            [-19.703882413474734, 4.277325827110188],
            [-19.703867754657942, 4.2835288229195125],
            [-19.700732887844648, 4.287145457383479],
            [-19.70156447389382, 4.297838309313371],
            [-19.703268649366322, 4.304334504209275],
            [-19.70155579990416, 4.306733448694316],
            [-19.70225222782256, 4.312138927184975],
            [-19.701395014223188, 4.318812509868203],
            [-19.69514851349526, 4.3264372737796215],
            [-19.701473939149288, 4.330448633956213],
            [-19.706992641148346, 4.336316992714585],
            [-19.702701081461466, 4.343703703173334],
            [-19.702377089768753, 4.349887576918875],
            [-19.699006970316756, 4.355000587240654],
            [-19.69701305853225, 4.361514874994844],
            [-19.69262755312308, 4.366436168960924],
            [-19.687040960077262, 4.368813635200518],
            [-19.682881824937773, 4.372414472326732],
            [-19.684811187200975, 4.3783769366545355],
            [-19.680553232819168, 4.383131053431203],
            [-19.68092462378189, 4.390268869725513],
            [-19.683105839403744, 4.3935934255475075],
            [-19.68209691212437, 4.401950957505777],
            [-19.680051938518115, 4.407379774863345],
            [-19.677230865114737, 4.409873874701238],
            [-19.673484878167635, 4.418162286554162],
            [-19.675533387264895, 4.420866495972701],
            [-19.672787536442968, 4.427094084441248],
            [-19.678609467087497, 4.438072238203484],
            [-19.68805052382038, 4.443895800381787],
            [-19.692825974095996, 4.4526849272917275],
            [-19.69650077796192, 4.456525078042837],
            [-19.705298736609613, 4.4612265181597],
            [-19.710033779917538, 4.458888317013805],
            [-19.71865485460622, 4.468214438629152],
            [-19.71977408851775, 4.473330538582065],
            [-19.723222871436473, 4.480016158766128],
            [-19.72254626676839, 4.486278994173117],
            [-19.723650204449605, 4.489790380215055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.23410415423686,
          "lat": 40.12559707280561
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06103"],
        "coty_name": ["Tehama"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tehama County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01692767"
      },
      "bbox": [
        -19.772221861665184, 3.803775940649552, -18.464014969442555,
        4.5083699345028805
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.149376741244706, 2.7247257458641587],
            [-7.053153807749678, 2.7138309752971077],
            [-6.944983353465385, 2.7024757153548635],
            [-6.836814752571383, 2.69110277173109],
            [-6.802742404500524, 2.6876102794907473],
            [-6.686488272819081, 2.6763351684224164],
            [-6.570236090134439, 2.665039662104415],
            [-6.4689988941390695, 2.6554518655035344],
            [-6.452546078389735, 2.653881702359018],
            [-6.3365399338280435, 2.642699908803119],
            [-6.220535746314002, 2.6314978097201194],
            [-6.231050912148575, 2.5179609841163604],
            [-6.23519966820568, 2.477056700264746],
            [-6.240861745644697, 2.416063577580544],
            [-6.249239956855288, 2.329011492878705],
            [-6.248917235639745, 2.3289668894242452],
            [-6.253298418727623, 2.2855722962609155],
            [-6.2549502471013305, 2.2711079489726216],
            [-6.266242927072829, 2.154721296777249],
            [-6.270241771844498, 2.1110845946453525],
            [-6.276662025364183, 2.045763370659249],
            [-6.283678764936816, 1.9804994285465307],
            [-6.367261070217068, 1.9886184452642304],
            [-6.367422286260164, 1.9743540384515266],
            [-6.3744316076203535, 1.9006826922629634],
            [-6.415925349081811, 1.904142232439262],
            [-6.4930870113651675, 1.9114986391368936],
            [-6.511607775813673, 1.91402028716596],
            [-6.55059087338939, 1.9187273619322118],
            [-6.585277733436221, 1.9211216629737868],
            [-6.600007096751471, 1.9225768047415057],
            [-6.6154695956746075, 1.9236049062890277],
            [-6.627677841796785, 1.9213609775766647],
            [-6.681534003499439, 1.9282373200568592],
            [-6.706010533597919, 1.9310317832939665],
            [-6.709838298342891, 1.9319737713960048],
            [-6.735980032340215, 1.9356195295429903],
            [-6.755813159168162, 1.9378436630236975],
            [-6.8248316366155395, 1.9437760382212736],
            [-6.831270910980711, 1.9481491652235714],
            [-6.833137509817283, 1.9511472151889628],
            [-6.840889123555612, 1.9523162736993795],
            [-6.845281859645475, 1.9587422458656862],
            [-6.842457241488943, 1.9642799868260359],
            [-6.842878753112008, 1.9699465438900483],
            [-6.846038603311734, 1.9722449092533565],
            [-6.8444979955158765, 1.9769335196623705],
            [-6.847033181390506, 1.9797701990447203],
            [-6.847343330298145, 1.98345187123232],
            [-6.845178563028727, 1.98904962265683],
            [-6.851046331857301, 1.9959824984246026],
            [-6.856232508018263, 1.9993107340303904],
            [-6.85224237690764, 2.005176425229626],
            [-6.855175720067304, 2.0089613294372644],
            [-6.854653030789142, 2.011541088596502],
            [-6.8631283417484505, 2.0136853073592684],
            [-6.86871122644588, 2.020795354638745],
            [-6.874125029164995, 2.0246551981624985],
            [-6.874320288786821, 2.0290802779876183],
            [-6.878104844798428, 2.032874575117901],
            [-6.878409579049608, 2.036586188938408],
            [-6.882717078498107, 2.0397128195074763],
            [-6.886892917731508, 2.038363374874414],
            [-6.893498102064319, 2.0432413825350353],
            [-6.895060756728075, 2.0475874054408014],
            [-6.900609418771836, 2.0521982200262068],
            [-6.90119920697908, 2.057033018278696],
            [-6.903807277454397, 2.057238057591824],
            [-6.906160933859367, 2.0626845782264707],
            [-6.909865403530256, 2.0673380953800455],
            [-6.909432863299475, 2.0705683411040754],
            [-6.9131087318511915, 2.0748825841140346],
            [-6.9151623643166555, 2.080558919829903],
            [-6.91502705253523, 2.0887264996306736],
            [-6.914045034122558, 2.092988433946782],
            [-6.918789833898411, 2.100771371357727],
            [-6.920613226345045, 2.1053587539021805],
            [-6.925349905850572, 2.1106925811336588],
            [-6.927035505931857, 2.1153723020012403],
            [-6.929981596416897, 2.117792645972849],
            [-6.930880677140703, 2.122955550502809],
            [-6.928586387037493, 2.1247794692826365],
            [-6.929292137776413, 2.1319442852735135],
            [-6.925049080242892, 2.1389380908994444],
            [-6.919995778393782, 2.1435120299371624],
            [-6.920984262531463, 2.148053450668039],
            [-6.917389478822744, 2.1598048550528848],
            [-6.919967351960868, 2.1670179597445287],
            [-6.918118603740123, 2.1696998243858023],
            [-6.922417017306528, 2.172112896370329],
            [-6.927895795270912, 2.172798953922036],
            [-6.935391947659278, 2.1772205726293716],
            [-6.938358234290202, 2.1778333818457907],
            [-6.9404418432047414, 2.1812563034814887],
            [-6.947461242009216, 2.1828954158689884],
            [-6.952931743997922, 2.1858163747969828],
            [-6.952905966709242, 2.192330459856624],
            [-6.949575786312026, 2.1969371011146586],
            [-6.948845691467608, 2.2059662309448265],
            [-6.952274305824562, 2.207643291399871],
            [-6.955215269612251, 2.214631024341987],
            [-6.9588722476271085, 2.2203475471360257],
            [-6.961876459761395, 2.2227217865671114],
            [-6.969367381125412, 2.224622346071176],
            [-6.976418930744589, 2.2234830247517974],
            [-6.982711413273638, 2.2213245504238115],
            [-6.987186625993623, 2.217630688081767],
            [-6.98955339085597, 2.2192706440364494],
            [-6.991338076814897, 2.2262355891933523],
            [-6.98843668959559, 2.230015595538124],
            [-6.985400500644843, 2.2389726223628683],
            [-6.986072415236632, 2.2466712561777813],
            [-6.988627718921238, 2.2568703669434074],
            [-6.986547811595845, 2.262853153249641],
            [-6.986480962354083, 2.2705624937101443],
            [-6.98912969869605, 2.275201359273286],
            [-6.993592257167107, 2.2775280235990616],
            [-6.996407979783387, 2.2972299530476574],
            [-6.995854061464912, 2.3056328560032298],
            [-6.996763885825294, 2.311942319124265],
            [-7.000110124780619, 2.3125362229085753],
            [-7.005335418306231, 2.315766632954767],
            [-7.0082437086485525, 2.323785773012506],
            [-7.006339152890751, 2.328148176398677],
            [-7.008799729922757, 2.3346174438019993],
            [-7.006989247797187, 2.3432092696748663],
            [-7.006638441303449, 2.3495890338406156],
            [-7.010156571300883, 2.3546796373648093],
            [-7.011440286732378, 2.3629080813048406],
            [-7.010382999600736, 2.3667388998703234],
            [-7.012052383869729, 2.3711256971181487],
            [-7.016290561652645, 2.37683744336995],
            [-7.01671678719119, 2.38445584614436],
            [-7.019959774727365, 2.391054195051306],
            [-7.018113092098898, 2.3953275993891667],
            [-7.020455441146946, 2.398623077938962],
            [-7.018832825224485, 2.404062974721664],
            [-7.021659537526661, 2.412301613860989],
            [-7.025240767441955, 2.416776428502649],
            [-7.029634775805611, 2.420191072073551],
            [-7.02971335364073, 2.4290229966048655],
            [-7.027896986940515, 2.431927102406915],
            [-7.029150926321442, 2.4379483460649762],
            [-7.032773082757532, 2.444355091289878],
            [-7.03957273575224, 2.449625158269343],
            [-7.04456989880169, 2.4592975553796736],
            [-7.044877311453063, 2.465583798410305],
            [-7.049898829453829, 2.468012412492804],
            [-7.048320256215801, 2.471635030451471],
            [-7.05040769580591, 2.4747931404686576],
            [-7.049806806193608, 2.4847970345967094],
            [-7.053129799042047, 2.4873492954204135],
            [-7.052593631032381, 2.4955259511889087],
            [-7.056295484530616, 2.49995947990466],
            [-7.059588806097668, 2.5005200109395735],
            [-7.063209750863303, 2.507081215887878],
            [-7.062235445237247, 2.512879863736575],
            [-7.0637899547885254, 2.5200974763463417],
            [-7.066928501020687, 2.521665353898451],
            [-7.065946521968548, 2.5248834556202504],
            [-7.069733421893853, 2.5333693552857652],
            [-7.074569510383058, 2.5383883218704617],
            [-7.079326935560978, 2.5396677483825965],
            [-7.082517450080031, 2.545674592110609],
            [-7.085533801417107, 2.549012587029182],
            [-7.090528654683538, 2.552076976943702],
            [-7.093293869365396, 2.5599053538232988],
            [-7.0993989217820515, 2.563315618564424],
            [-7.096690446859133, 2.56928131132834],
            [-7.102020507509187, 2.5742455506140485],
            [-7.099971511541422, 2.579283366814994],
            [-7.102618526967223, 2.5836131596461773],
            [-7.110228423892617, 2.5869763049118832],
            [-7.115730136408532, 2.591393652059348],
            [-7.119104055551055, 2.5988433011003726],
            [-7.117103133352782, 2.600311252184106],
            [-7.114626080316843, 2.6068112871965448],
            [-7.116612081652993, 2.6151032401496925],
            [-7.115811255474215, 2.617681137489151],
            [-7.119711537385344, 2.624717844172903],
            [-7.124739829925213, 2.6281654734140996],
            [-7.127608788345085, 2.6282071452313134],
            [-7.132096395757923, 2.633533526630356],
            [-7.134916900753576, 2.635049483433489],
            [-7.134788341289434, 2.6387305475434597],
            [-7.14124688788995, 2.643609302227918],
            [-7.141446518199383, 2.6481593410707234],
            [-7.144481773574488, 2.6504251702227157],
            [-7.14860530434196, 2.657694244990421],
            [-7.15233507264253, 2.6605790830047034],
            [-7.154018042638846, 2.6728361196382737],
            [-7.149239894835666, 2.6817584148922298],
            [-7.151217782457827, 2.685529871537442],
            [-7.148770009246961, 2.6904445641345367],
            [-7.150781278613715, 2.691749745096821],
            [-7.1496561812963915, 2.6979715167097353],
            [-7.151409045805245, 2.700106999896556],
            [-7.151040868635628, 2.7056907864844475],
            [-7.153792898159523, 2.7143907915090866],
            [-7.153790358195556, 2.717431602591621],
            [-7.149376741244706, 2.7247257458641587]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -105.4611094513344, "lat": 40.66639267832263 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08069"],
        "coty_name": ["Larimer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Larimer County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00198150"
      },
      "bbox": [
        -7.154018042638846, 1.9006826922629634, -6.220535746314002,
        2.7247257458641587
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.106469303156475, -0.25618580689073145],
            [-8.103064470387382, -0.252158287936232],
            [-8.09751532575256, -0.2521523776561572],
            [-8.095508003967568, -0.24963558070994],
            [-8.094674813570357, -0.24419997497663193],
            [-8.08736037437573, -0.24514147099383468],
            [-8.079228729091556, -0.24030112454632777],
            [-8.074989265778889, -0.24329319571631366],
            [-8.07464505707816, -0.2477704084739013],
            [-8.070343793324986, -0.25125216655247984],
            [-8.068442729735908, -0.2546886407405744],
            [-8.068893041729945, -0.2591154791697183],
            [-8.064601530083872, -0.2631110529634567],
            [-8.060850448396616, -0.2632866874586253],
            [-8.057344474461887, -0.26126450481723923],
            [-8.055286387375947, -0.25772490940408394],
            [-8.050977526897398, -0.2552392125362542],
            [-8.043318688814487, -0.25293669038215644],
            [-8.036213273306451, -0.2537106337914828],
            [-8.031563119431157, -0.2568662278901995],
            [-8.02538987187339, -0.2535215935528258],
            [-8.022941590973629, -0.2546034860256163],
            [-8.019701224247694, -0.26029573087485586],
            [-8.01169448562768, -0.2619902198215587],
            [-8.013545039795815, -0.2732117172887632],
            [-8.011563828152074, -0.2747395371081128],
            [-8.01008389835171, -0.2809037086096737],
            [-8.006663065004854, -0.2825479897746126],
            [-8.00479033677879, -0.29024721056582825],
            [-7.991776359345183, -0.30690653982652455],
            [-7.974169905604598, -0.30936978205140503],
            [-7.969978879042271, -0.31461693177371064],
            [-7.961682714559672, -0.31420088610254476],
            [-7.956511014351025, -0.3165008762838395],
            [-7.952630134336557, -0.32108843066516407],
            [-7.941206975839612, -0.3373907810067428],
            [-7.938019799845097, -0.347192383239875],
            [-7.925194323903585, -0.3536829854751949],
            [-7.921036920389885, -0.35327422459340363],
            [-7.909490525189158, -0.3480908597776515],
            [-7.900267278232113, -0.36222820987847654],
            [-7.894230817500754, -0.36606025646159246],
            [-7.890743619419051, -0.3657771259558647],
            [-7.885865162657937, -0.36299981623902117],
            [-7.880147014542544, -0.36337499937737683],
            [-7.877615201659965, -0.36629518859579496],
            [-7.882204980426088, -0.40467277484435343],
            [-7.892379589307526, -0.4888103828985911],
            [-7.892963738206882, -0.4900817097317289],
            [-7.897203674925409, -0.5248020345714322],
            [-7.902986685753501, -0.5760692020873738],
            [-7.915438651610151, -0.5746589646035459],
            [-7.944307332894738, -0.8356421924335127],
            [-7.945208384957309, -0.8436590370236297],
            [-8.044038709761105, -0.8343915169187164],
            [-8.070900770253502, -0.8319429058213309],
            [-8.074308096249746, -0.8311875820896457],
            [-8.210322235743357, -0.8171784218566223],
            [-8.272332743616396, -0.8098044289438039],
            [-8.268686344711712, -0.7791919479712024],
            [-8.262718378134513, -0.728386563904811],
            [-8.245344293238944, -0.601424476038131],
            [-8.240997008846243, -0.5770159397487649],
            [-8.235202265797305, -0.5268335802328667],
            [-8.251704026336594, -0.5244157256998415],
            [-8.239456308818037, -0.4501062979264086],
            [-8.238009981284963, -0.44295891815806226],
            [-8.227548596282857, -0.37139872509715266],
            [-8.224143069393856, -0.33410553534536874],
            [-8.222724846679672, -0.3249811252971057],
            [-8.215202292890629, -0.26094481305929096],
            [-8.208678877146458, -0.26273946120335423],
            [-8.202380993370344, -0.2604002564507072],
            [-8.193325349368582, -0.2589457281477137],
            [-8.1893485351863, -0.25555915134070856],
            [-8.186838357562928, -0.24906392541904443],
            [-8.180165215553656, -0.2544272006581373],
            [-8.175193022609704, -0.25388965332152147],
            [-8.172666785070628, -0.2511843039383314],
            [-8.164926199056284, -0.25152045861581],
            [-8.161922590832468, -0.2504079434622384],
            [-8.157952514923807, -0.24483625723133978],
            [-8.15319852732675, -0.24696910797700403],
            [-8.150175039331408, -0.2549385450379855],
            [-8.14677792683133, -0.2544529576004931],
            [-8.141469125558146, -0.25893828584788225],
            [-8.134776626581264, -0.2596612542823872],
            [-8.130054964101248, -0.2564654563328445],
            [-8.12403983506008, -0.2564273532136918],
            [-8.120427855626206, -0.26170149845250174],
            [-8.114072635563701, -0.26497874097891133],
            [-8.112040124747804, -0.2624896212999875],
            [-8.11028494333875, -0.25505079052319307],
            [-8.106469303156475, -0.25618580689073145]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.92414239325204,
          "lat": 37.66896850116963
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08079"],
        "coty_name": ["Mineral"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mineral County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00198155"
      },
      "bbox": [
        -8.272332743616396, -0.8436590370236297, -7.877615201659965,
        -0.24030112454632777
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.512038247859891, 2.495432581892836],
            [-4.487806282827806, 2.4940068258850654],
            [-4.439864232018421, 2.490299349649632],
            [-4.388450441172935, 2.486997059671716],
            [-4.307541545576862, 2.4813714824425257],
            [-4.2959548910897425, 2.4804660390994453],
            [-4.24165118216062, 2.476882017762314],
            [-4.117377920299942, 2.4688928507178782],
            [-4.0626598904326165, 2.4654257708940404],
            [-4.065284251078055, 2.422445103804438],
            [-4.07171793487654, 2.320096140397247],
            [-4.078561452865083, 2.2112145535903447],
            [-4.174174308115223, 2.2172062358411546],
            [-4.269787969835877, 2.223184891055761],
            [-4.326650778855803, 2.22721365047072],
            [-4.354653811680394, 2.228897982618162],
            [-4.441637758390072, 2.2352108474854395],
            [-4.5282660418404586, 2.2410973313245766],
            [-4.52529766983684, 2.2848917970539615],
            [-4.519331093302493, 2.37707402793186],
            [-4.512038247859891, 2.495432581892836]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.35184284619814,
          "lat": 40.875903343424696
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08115"],
        "coty_name": ["Sedgwick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sedgwick County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00198173"
      },
      "bbox": [
        -4.5282660418404586, 2.2112145535903447, -4.0626598904326165,
        2.495432581892836
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.647015483751041, 1.9352608289965698],
            [-4.560352175935081, 1.9291517184992704],
            [-4.445324849172225, 1.9215740284744858],
            [-4.402118933755845, 1.9192292001823812],
            [-4.358874813710258, 1.9165421256832935],
            [-4.223709690652351, 1.907717452502554],
            [-4.22167707490587, 1.907330775603956],
            [-4.098560391318629, 1.8997814604213785],
            [-4.101642363041024, 1.8559144698855305],
            [-4.101653325044522, 1.8525647399247096],
            [-4.103942760342029, 1.8193560805257407],
            [-4.104455112933718, 1.8084204232785104],
            [-4.1049663755436905, 1.7975067964893765],
            [-4.112417472973172, 1.6876438435638774],
            [-4.117688383290835, 1.6062847851201676],
            [-4.126822499258076, 1.4600188352959906],
            [-4.136532180492734, 1.3056858477867548],
            [-4.136782532312921, 1.2992978949229268],
            [-4.142958912933265, 1.1968867307996027],
            [-4.146978075261659, 1.1302035309202931],
            [-4.147999964412116, 1.108242460185999],
            [-4.148744384338328, 1.1004387588694535],
            [-4.152897677225161, 1.0279029195450224],
            [-4.304947497177056, 1.0356554058926624],
            [-4.305928468564808, 1.0358666513043835],
            [-4.370633953696431, 1.0390225514367841],
            [-4.406366531486368, 1.0411027866849902],
            [-4.469894266724381, 1.0455227370288693],
            [-4.535799588922378, 1.049862319021377],
            [-4.550241830460307, 1.049500110980589],
            [-4.581893233491085, 1.0512563076390018],
            [-4.67866144671775, 1.057180093680444],
            [-4.727133411190245, 1.0604939239083633],
            [-4.71819617786979, 1.174203143661998],
            [-4.715275935796927, 1.2070544709307178],
            [-4.715334171217284, 1.214117206771341],
            [-4.7062411254152785, 1.3250648701921328],
            [-4.698851929911985, 1.455405580512153],
            [-4.696388104249418, 1.4980544666219744],
            [-4.6884714140940815, 1.4974257110830396],
            [-4.680803488815269, 1.6139565084058471],
            [-4.6776556725489735, 1.6576649519510573],
            [-4.672859886252935, 1.7159570722147237],
            [-4.663546617972358, 1.8483284676308775],
            [-4.653458825498971, 1.8474687657913873],
            [-4.647015483751041, 1.9352608289965698]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.42425286316812,
          "lat": 40.002928659000624
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08125"],
        "coty_name": ["Yuma"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yuma County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00198178"
      },
      "bbox": [
        -4.727133411190245, 1.0279029195450224, -4.098560391318629,
        1.9352608289965698
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.263446751512362, -8.36277256909237],
              [10.265883383910204, -8.362161854827844],
              [10.274968843039245, -8.365908668216706],
              [10.279435375185406, -8.365351951829094],
              [10.286263665007663, -8.362587269300493],
              [10.28938363700438, -8.35626905688171],
              [10.297516356856034, -8.356930968698041],
              [10.306173167479589, -8.35384531317127],
              [10.316401649840463, -8.342344577518652],
              [10.32208302455806, -8.330462401500029],
              [10.331736307511733, -8.325089356366762],
              [10.336535849350303, -8.323590886331129],
              [10.335601629229927, -8.32092883596325],
              [10.338770079153036, -8.317222276004603],
              [10.339824886538842, -8.313120728646872],
              [10.346389479296867, -8.310794239099677],
              [10.34787147320167, -8.320385452021933],
              [10.346746370189631, -8.325168592166351],
              [10.342900469278499, -8.331762679903026],
              [10.340186702647344, -8.333952777746793],
              [10.31788566421207, -8.347720220630823],
              [10.307045710418317, -8.35533891789106],
              [10.27758656893788, -8.368045960461771],
              [10.270274450449357, -8.370275898200163],
              [10.266490447516093, -8.36904630878318],
              [10.263446751512362, -8.36277256909237]
            ]
          ],
          [
            [
              [9.917831482181484, -8.562340510933673],
              [9.922505353771504, -8.561581836608962],
              [9.930032753150693, -8.567781773507253],
              [9.935148383580678, -8.569110725794227],
              [9.944061931775906, -8.57607606769548],
              [9.959125840542884, -8.580487125826018],
              [9.962270657030157, -8.580253736613649],
              [9.971553406240723, -8.582777185761989],
              [9.98176640387295, -8.5844203541964],
              [9.986911400800972, -8.582129655600571],
              [9.991359175017697, -8.581878094011048],
              [9.991693941345348, -8.576783640825438],
              [9.99736818273396, -8.574779876607769],
              [10.0059979158885, -8.573710432493991],
              [10.019720519937454, -8.56819427673015],
              [10.038010838872326, -8.557156574226072],
              [10.040541374666407, -8.554465536180489],
              [10.046673017594921, -8.551188200376414],
              [10.058621052604979, -8.535232768934568],
              [10.062425258429055, -8.533779703715583],
              [10.063549057949059, -8.526976454337357],
              [10.067873765984316, -8.52280138295443],
              [10.073898072442473, -8.520852427843943],
              [10.08211538397579, -8.521052173793056],
              [10.085989315511503, -8.515630302828272],
              [10.090251527640126, -8.512408239402422],
              [10.096693545436532, -8.511546506456298],
              [10.101363238380811, -8.503949083090284],
              [10.106949756272645, -8.502649953325616],
              [10.111037990652264, -8.499674851764402],
              [10.110727704177764, -8.495596596110012],
              [10.114763753209735, -8.496272457899913],
              [10.115877104289346, -8.49318700098199],
              [10.123205108489246, -8.493239968602614],
              [10.13862771169559, -8.487460135114263],
              [10.156588869725704, -8.480024201250526],
              [10.160360664062482, -8.476471317680236],
              [10.165048617281549, -8.476565318942448],
              [10.169261191312867, -8.47282680143539],
              [10.175084627584681, -8.46958174373193],
              [10.171586270445527, -8.464867010669733],
              [10.168162731653807, -8.465097664049052],
              [10.166634287695302, -8.458063316444665],
              [10.169957939739808, -8.457030267044187],
              [10.17750173116648, -8.46383292624408],
              [10.181868148303884, -8.465712405749453],
              [10.18573868839037, -8.46201185351706],
              [10.183419583871153, -8.455622412480857],
              [10.184439667596521, -8.450670603127197],
              [10.19274760697664, -8.445694118085388],
              [10.201431661635407, -8.43608496804012],
              [10.205245741988202, -8.433897311589833],
              [10.20935311861159, -8.428953043791765],
              [10.214339008315049, -8.427870786786125],
              [10.22538990007706, -8.417259473597161],
              [10.226496817592174, -8.40980673854002],
              [10.232186613548718, -8.407867653694009],
              [10.238989936192477, -8.397711324179022],
              [10.239688352914811, -8.391153156983558],
              [10.244237318656202, -8.386999948215857],
              [10.24786766978027, -8.379889367698082],
              [10.250754890197447, -8.387399837768339],
              [10.245482282334768, -8.392896027397171],
              [10.230763309310921, -8.413626532809165],
              [10.210384226075835, -8.43866758290497],
              [10.195768992589386, -8.45698777259714],
              [10.186450953091017, -8.465588305036864],
              [10.168579377802033, -8.478271218825446],
              [10.15098064517733, -8.487972042800651],
              [10.143376006002638, -8.49057709228888],
              [10.123375042441292, -8.500334265914475],
              [10.110078361896232, -8.50785659809359],
              [10.09825793233971, -8.515680934931297],
              [10.055706680371165, -8.549303709360911],
              [10.040723376017043, -8.5604404640665],
              [10.021282467889087, -8.570192118679685],
              [9.974744640603676, -8.592997910681383],
              [9.967318827574811, -8.595767796022399],
              [9.962196973600774, -8.593128337344389],
              [9.944163693445288, -8.58020524560458],
              [9.930270075469581, -8.571953356439968],
              [9.919947376912038, -8.567150411772133],
              [9.917831482181484, -8.562340510933673]
            ]
          ],
          [
            [
              [9.939961345561619, -8.215848681189044],
              [9.94507533320713, -8.205648345356883],
              [9.94421138075823, -8.204290321429417],
              [9.94600678776918, -8.193113829233663],
              [9.945958232276249, -8.189165272530452],
              [9.949121298697962, -8.187278506420155],
              [9.948909126097464, -8.180601359984298],
              [9.952750306117311, -8.17484354782411],
              [9.950365975815991, -8.172275595038222],
              [9.980423013669064, -8.168981231291836],
              [10.064587643563597, -8.160808458038362],
              [10.162531155037696, -8.149990462931807],
              [10.292601836767313, -8.134880544300803],
              [10.299012327478156, -8.134393597618294],
              [10.348540887036858, -8.12835847487554],
              [10.345385878138776, -8.130780170744703],
              [10.345896041109464, -8.133505183210682],
              [10.352336988743515, -8.136523325290169],
              [10.360344659864884, -8.1306001147452],
              [10.365936804102123, -8.132069990857184],
              [10.372347024895852, -8.141374464524517],
              [10.368446109065946, -8.150304095598004],
              [10.368709503415117, -8.15442296476912],
              [10.371691007156818, -8.155806676506902],
              [10.378295212147947, -8.155285541537458],
              [10.379781323326675, -8.152209091652093],
              [10.377225695968306, -8.146830467411924],
              [10.382238174889876, -8.146177826681045],
              [10.387810945879698, -8.14722035598099],
              [10.396889683385009, -8.146419781081473],
              [10.40052732126492, -8.144643850990231],
              [10.404971424275745, -8.13871243402494],
              [10.408054707916698, -8.132542362212474],
              [10.411694126920692, -8.129378811276714],
              [10.415543757959133, -8.129459315053891],
              [10.421434371281045, -8.134114232085963],
              [10.4247540807906, -8.141488268207215],
              [10.426770622669332, -8.154713551448857],
              [10.432332536696986, -8.157985586689415],
              [10.434658536079038, -8.155611082331763],
              [10.438176915504716, -8.146745124649291],
              [10.443266865929877, -8.15047893869159],
              [10.445311741808291, -8.148700387046434],
              [10.448842208091232, -8.151045970261919],
              [10.446229002674482, -8.157846155034466],
              [10.441757767863583, -8.160236954283366],
              [10.441934999097008, -8.165867519687643],
              [10.445337491491737, -8.167408389129918],
              [10.456286965201347, -8.166288360681394],
              [10.462813255431909, -8.160033029747046],
              [10.471187484098161, -8.161090837387555],
              [10.475096958721164, -8.164213209639207],
              [10.481541428091644, -8.16353361028682],
              [10.492250970850934, -8.160577045926159],
              [10.494891988255137, -8.16088383351263],
              [10.50365706644868, -8.168040430764439],
              [10.507254513947839, -8.168629748335485],
              [10.513154977418251, -8.165238678153049],
              [10.52114559929551, -8.166993195941716],
              [10.528285024967413, -8.170467086604203],
              [10.53316667646591, -8.170452378313106],
              [10.53547081641805, -8.174146348320273],
              [10.539250769407877, -8.186516576726179],
              [10.540148872130755, -8.19232939694691],
              [10.539570477100407, -8.203139520107436],
              [10.536074881035981, -8.214319038257623],
              [10.533965074102378, -8.217734409104667],
              [10.528060997960976, -8.221098292585282],
              [10.522126737768334, -8.22147918342402],
              [10.515186934247328, -8.22328352059085],
              [10.510878996394569, -8.225508524350884],
              [10.503320652148988, -8.226769285961389],
              [10.48168744607107, -8.221895143189727],
              [10.465638488772322, -8.221795176796345],
              [10.456645293373597, -8.218669767770344],
              [10.449444544488731, -8.214092084100159],
              [10.44154952705896, -8.206412011071533],
              [10.438118713634038, -8.199370338769736],
              [10.430994735770247, -8.201519489352128],
              [10.42266962791539, -8.205787978299504],
              [10.414392828453288, -8.213552505538656],
              [10.41145049720062, -8.215390091287453],
              [10.405787334602076, -8.222445066735299],
              [10.403112529733946, -8.218690671670666],
              [10.397502467895574, -8.21723637579131],
              [10.389201337602966, -8.217990375670773],
              [10.374011855708412, -8.22380071779918],
              [10.368063625938422, -8.226759665090109],
              [10.342615394856654, -8.248386557896898],
              [10.321837345405001, -8.261360452270097],
              [10.314156088123791, -8.26710411214896],
              [10.306655289771594, -8.276111183917747],
              [10.29744534376191, -8.28474988220673],
              [10.290390691707596, -8.289710571175592],
              [10.288445145597507, -8.293334151627509],
              [10.282831232375864, -8.297020477078664],
              [10.275554014595675, -8.304221004134165],
              [10.274822211758806, -8.31185270574385],
              [10.273424451874268, -8.313682094176603],
              [10.269081742558027, -8.311359954329296],
              [10.266346094387357, -8.314058964726986],
              [10.262879129008967, -8.311915910003087],
              [10.257462896638527, -8.315969459012022],
              [10.25844677149297, -8.319576700417572],
              [10.250153558127218, -8.319959422646871],
              [10.243401106861757, -8.32244274242906],
              [10.235560012848165, -8.328082605061473],
              [10.223602853537567, -8.340234032405997],
              [10.215236373768546, -8.347748872677645],
              [10.209849660823666, -8.350262227929624],
              [10.193490027713757, -8.368730153778017],
              [10.188175755217964, -8.369243267741101],
              [10.174901485418365, -8.378702710702967],
              [10.164365972971265, -8.38693921621203],
              [10.158923404078433, -8.392343671194364],
              [10.154686777704026, -8.393842590547468],
              [10.13795474818047, -8.405396379037617],
              [10.127055181145302, -8.409023541931624],
              [10.116383373784295, -8.416819378134813],
              [10.11027056415686, -8.419914665583395],
              [10.101828811980104, -8.425390252679968],
              [10.091189441486671, -8.435170054939801],
              [10.087138029999595, -8.44707633403586],
              [10.082943228052123, -8.446806274156435],
              [10.08055858299499, -8.442169710698682],
              [10.076285140857467, -8.439664452277881],
              [10.073467735096784, -8.435795270514417],
              [10.077791925397529, -8.42581963316216],
              [10.081486762252263, -8.414453304085592],
              [10.083710402080781, -8.404589573932531],
              [10.088572767361763, -8.400254024864251],
              [10.094824426217347, -8.387456749576211],
              [10.092571277617001, -8.378980377642893],
              [10.093389739085168, -8.371894620734375],
              [10.087229894777042, -8.371583578639497],
              [10.083635505465402, -8.373646267898632],
              [10.084117534052387, -8.381196604047087],
              [10.08237076613363, -8.385717537511105],
              [10.065815047579, -8.385897796637014],
              [10.061377721813782, -8.388977015198446],
              [10.056702905138259, -8.389920661269608],
              [10.056322706259937, -8.396245708693712],
              [10.052910799725833, -8.400727246533775],
              [10.048550009161165, -8.412895359097735],
              [10.043550777295543, -8.418879179900753],
              [10.040509515818282, -8.424774550058315],
              [10.034022023229818, -8.43068528663484],
              [10.019479861610137, -8.437619629493662],
              [10.016927583070304, -8.450546025129427],
              [10.010569727648965, -8.457128332084627],
              [10.006630240176086, -8.458123186770381],
              [10.002642427888663, -8.461752570437293],
              [9.993572993027295, -8.466309983084255],
              [9.987375733671662, -8.467395102664119],
              [9.986788208639695, -8.469409233748364],
              [9.980148547147948, -8.472274004243513],
              [9.97010591864319, -8.47081471376724],
              [9.96405890283359, -8.474958936786868],
              [9.96127328571116, -8.475337012090552],
              [9.957026794422445, -8.471598888662832],
              [9.94999050085019, -8.470086622818945],
              [9.945419886346995, -8.470264076219241],
              [9.928804158571129, -8.468683135325977],
              [9.903346344482344, -8.471865062191373],
              [9.886609987168564, -8.476652488929828],
              [9.860083682365643, -8.48725683686304],
              [9.853223437170044, -8.490534135566328],
              [9.844184902011337, -8.493772465275239],
              [9.840257030577765, -8.497507364902896],
              [9.831123885805443, -8.499095613433608],
              [9.824003771941028, -8.502157496195101],
              [9.818808461212335, -8.501946232664041],
              [9.806182388674417, -8.506781654039074],
              [9.81404393494675, -8.489518329315722],
              [9.843758122952572, -8.460875767433883],
              [9.890049654544589, -8.415552922361385],
              [9.8948934971711, -8.417603813862454],
              [9.906554808873814, -8.417689548451499],
              [9.91785591604159, -8.420529921024913],
              [9.922416273626789, -8.417822038247454],
              [9.923782156854672, -8.413769064282054],
              [9.924267682450514, -8.404003318332723],
              [9.927338384817327, -8.401102361190983],
              [9.930946210272825, -8.401417247206734],
              [9.937167816523509, -8.406171131816446],
              [9.94949259604085, -8.406219653655395],
              [9.950541960463925, -8.404263882999329],
              [9.951501970222624, -8.393009808115679],
              [9.954805826392066, -8.386103509802139],
              [9.963100017785322, -8.376728483898216],
              [9.962382400709187, -8.364351539577049],
              [9.958275704521602, -8.360114517470338],
              [9.953319330356797, -8.358929996072455],
              [9.950115159205769, -8.355596681614756],
              [9.949751704563374, -8.346513147971393],
              [9.946593248184382, -8.337941145887912],
              [9.943049270469588, -8.334022279463639],
              [9.941841888334434, -8.323084714761],
              [9.937938396711335, -8.316393409903453],
              [9.93740306833733, -8.311417358835774],
              [9.926737902541094, -8.29545450203868],
              [9.923098674520592, -8.287126383951666],
              [9.92724206117085, -8.278129185413388],
              [9.9258633685311, -8.270164782714096],
              [9.928688486417235, -8.267704342680378],
              [9.930753963217573, -8.258128360540896],
              [9.940702666103887, -8.254311049011731],
              [9.93729553766484, -8.25099129851841],
              [9.938307460708993, -8.246981054050593],
              [9.942386071064629, -8.242309629229887],
              [9.944187074201597, -8.236812330538712],
              [9.946942601965143, -8.232918591596869],
              [9.942806037882859, -8.224732784168728],
              [9.939961345561619, -8.215848681189044]
            ]
          ],
          [
            [
              [9.803633193602574, -8.522410944506962],
              [9.808926871137764, -8.52041752019945],
              [9.816772804017468, -8.51982770286043],
              [9.82105832265087, -8.517220225962767],
              [9.849749637034284, -8.514143801594612],
              [9.860601106239145, -8.515684177528842],
              [9.8745965664284, -8.509952117823108],
              [9.878597526480217, -8.506730298987332],
              [9.895933022838316, -8.502679371643783],
              [9.90507555661973, -8.503965230616686],
              [9.90834391860166, -8.505218348537804],
              [9.913939721585121, -8.504433289369743],
              [9.916086470497547, -8.50665154984771],
              [9.921905527244695, -8.508409070187321],
              [9.926678801204266, -8.512867019437088],
              [9.932089060250926, -8.513175604549772],
              [9.926657889399293, -8.522496811785949],
              [9.92009269403925, -8.537967099476802],
              [9.917399947637067, -8.555604055152699],
              [9.91474312898152, -8.557140405491756],
              [9.897296960427123, -8.560920965993082],
              [9.884060832266089, -8.560444390467845],
              [9.87909196174973, -8.558983231023559],
              [9.874339901754729, -8.554782042143538],
              [9.86393714822052, -8.547116805834607],
              [9.84663867945885, -8.53780492220946],
              [9.835660534810998, -8.532386699100764],
              [9.820057844608247, -8.527172237026937],
              [9.80705064540894, -8.525140652109085],
              [9.803633193602574, -8.522410944506962]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.81369034531745,
          "lat": 29.876590247328185
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12037"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00306911"
      },
      "bbox": [
        9.803633193602574, -8.595767796022399, 10.540148872130755,
        -8.12835847487554
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.325209665035006, -7.3810069782564165],
            [11.325210163050304, -7.381006946200827],
            [11.44098820574465, -7.373486300140935],
            [11.456632286633498, -7.37232136008107],
            [11.47347258682764, -7.3715685200711],
            [11.477988504390911, -7.371366046262535],
            [11.570561956972835, -7.365017366979985],
            [11.696120024636, -7.3562092213439065],
            [11.857333853165848, -7.345163605580611],
            [11.855898230311425, -7.348494135636065],
            [11.848819049657783, -7.354715489212203],
            [11.84465214442899, -7.360402886888665],
            [11.847752812024945, -7.363381845576884],
            [11.845997697322836, -7.370297082504126],
            [11.837876677274748, -7.376073843022601],
            [11.839698157977526, -7.379532493036158],
            [11.837137489782675, -7.382887799614566],
            [11.831167493518079, -7.387209100136513],
            [11.837740862390689, -7.40096386224662],
            [11.841975161720837, -7.405241795185968],
            [11.845284192124756, -7.412984503782422],
            [11.840341611890837, -7.415380017780596],
            [11.83431512525207, -7.4158127981196404],
            [11.83414432734168, -7.420694724863149],
            [11.838924206912353, -7.427733411525241],
            [11.841936000357876, -7.424026951888987],
            [11.84661185292776, -7.432204614671194],
            [11.848552918815894, -7.438995296856642],
            [11.854801362677927, -7.4373847643261],
            [11.856795989336776, -7.440945604769487],
            [11.855318065865859, -7.445794899868082],
            [11.858393667540813, -7.448020658670906],
            [11.857996147531301, -7.450798463016953],
            [11.866420278133065, -7.452606202793038],
            [11.867059510274306, -7.457349361402988],
            [11.862369396505557, -7.459327910769064],
            [11.865202187704103, -7.462309704430092],
            [11.863680041884486, -7.4647337205871365],
            [11.87000198711644, -7.467934379894272],
            [11.886056382296585, -7.4689818559383925],
            [11.886051788096953, -7.474406716229221],
            [11.88409971604485, -7.478173432011785],
            [11.893817433543047, -7.485261774218388],
            [11.896393706790969, -7.488636477735578],
            [11.892379450468507, -7.4899608584490736],
            [11.89524190742329, -7.49378910397045],
            [11.90281996835157, -7.497960181797838],
            [11.905236379594271, -7.496061610829332],
            [11.909035893260727, -7.5013242092085894],
            [11.908800386495225, -7.504086080749083],
            [11.912225091023572, -7.506375142673089],
            [11.912286832679053, -7.513818505517118],
            [11.916417403763973, -7.516275288330583],
            [11.915204680476505, -7.519834094232095],
            [11.917291168971246, -7.525059139438679],
            [11.921585571930452, -7.528159764391193],
            [11.921082158019138, -7.533894138502259],
            [11.921896727268038, -7.5394395661677756],
            [11.919876844238562, -7.542956731774793],
            [11.91322948793057, -7.544305496278996],
            [11.913734216619586, -7.551158938023995],
            [11.912803165379893, -7.553961450412663],
            [11.909163623124943, -7.5561511868228655],
            [11.908495631457978, -7.55899496628146],
            [11.91238350127531, -7.565626013445433],
            [11.909876738493338, -7.569367027403357],
            [11.90281083593792, -7.5726355729733115],
            [11.897795394267668, -7.579271293180571],
            [11.896875699891138, -7.583298099703086],
            [11.893728016023084, -7.585300566452414],
            [11.899872190486724, -7.5950026305667775],
            [11.898259008625525, -7.600082781165785],
            [11.890981459540974, -7.607037177458436],
            [11.887655274535433, -7.6060898443852505],
            [11.882824740345994, -7.607603559959664],
            [11.877287904963035, -7.612642806753177],
            [11.87404157687185, -7.619343398213303],
            [11.871894275059011, -7.620381783825643],
            [11.864811716047813, -7.614257994407366],
            [11.864306215797296, -7.609001090634553],
            [11.85490172284839, -7.615770684811336],
            [11.853049441907695, -7.622809455871138],
            [11.847727268623176, -7.62772293232898],
            [11.842094233250245, -7.626448034219165],
            [11.834818855242494, -7.622670922246785],
            [11.835296838419543, -7.619413172628273],
            [11.831350110460932, -7.6164654388132425],
            [11.825383458492897, -7.622374407401989],
            [11.820452415208958, -7.625666643153126],
            [11.818665162537172, -7.624212295821213],
            [11.811172924539422, -7.626196016754799],
            [11.80786028081755, -7.624146914603794],
            [11.804169926612653, -7.614122334462498],
            [11.802717844896593, -7.610760322618902],
            [11.79890160971466, -7.607632608858682],
            [11.795031807167046, -7.606991629190452],
            [11.79116851883876, -7.615580502711018],
            [11.788871647966547, -7.612904759738745],
            [11.776909887698459, -7.612975606326599],
            [11.775126788747015, -7.609360230589017],
            [11.770693705587941, -7.608984499568426],
            [11.768054460792877, -7.6137625114263106],
            [11.76337450824343, -7.613456574734652],
            [11.761267077415937, -7.616167735050404],
            [11.753010607903539, -7.6091868308080794],
            [11.74791068902634, -7.600546522503616],
            [11.742660523147498, -7.602347366287121],
            [11.740081148551274, -7.601609169721813],
            [11.733994874992304, -7.594404268255013],
            [11.729585673556546, -7.595614247927287],
            [11.719692646535718, -7.5939204164539325],
            [11.714717650652664, -7.5887789156202965],
            [11.716618144888692, -7.585010336168079],
            [11.715276458331084, -7.581780020738122],
            [11.716902186354847, -7.5769762659901705],
            [11.714080787181533, -7.57588558447757],
            [11.70156267373711, -7.5806578794451385],
            [11.700019457727251, -7.583148854349992],
            [11.693954596864492, -7.580699436299473],
            [11.690381572434394, -7.580796017607275],
            [11.68321296634564, -7.576699705277925],
            [11.679995571446627, -7.577741641480397],
            [11.672262116545697, -7.569172040521649],
            [11.663828012392681, -7.569316172663859],
            [11.66405398910659, -7.56366250292273],
            [11.657435366577108, -7.561463821452719],
            [11.656040800312883, -7.557865766911699],
            [11.644944862818221, -7.556041369706513],
            [11.632398221292503, -7.5555617669572435],
            [11.6297120214167, -7.549406565766856],
            [11.620283013901215, -7.547962882850909],
            [11.618002373685005, -7.545833700101458],
            [11.612278162290524, -7.549528339926443],
            [11.610506648862081, -7.55503566584785],
            [11.603778400424158, -7.555543793792873],
            [11.601758352311995, -7.554069536586428],
            [11.590817759387901, -7.55173466094514],
            [11.586820474499376, -7.549904573153641],
            [11.580769115153041, -7.551864740963626],
            [11.574183107622396, -7.552466436347669],
            [11.572392894390553, -7.554828139967135],
            [11.567029850389376, -7.553865481012591],
            [11.561141088222795, -7.55632633256609],
            [11.558084424443962, -7.5601377402988295],
            [11.551915762470134, -7.559504986499808],
            [11.547977305542615, -7.547896575379506],
            [11.544989664730975, -7.543892456936624],
            [11.543371178169691, -7.548566192988442],
            [11.533528027755274, -7.55122617325442],
            [11.526170253197195, -7.55535003784552],
            [11.519831023307411, -7.556037242900835],
            [11.515086690929564, -7.55897439236712],
            [11.51172388098901, -7.558324228688499],
            [11.506710863317211, -7.563068413705887],
            [11.502844152411235, -7.570754739038639],
            [11.49640772261128, -7.570367506647069],
            [11.495504811904873, -7.57333103768048],
            [11.491426974056587, -7.576218571085138],
            [11.486192594180217, -7.5770345725846635],
            [11.483568352538587, -7.580668844728054],
            [11.482735089975384, -7.585114055073611],
            [11.486592564161855, -7.586130727034167],
            [11.484731202374798, -7.591719681516804],
            [11.479390734207076, -7.596794853641124],
            [11.48105730956636, -7.602012444568215],
            [11.477321298129198, -7.604682280994881],
            [11.476445890057498, -7.610576669787919],
            [11.473126898053216, -7.604755804014768],
            [11.469506584010672, -7.60457349287018],
            [11.471409203371321, -7.599567097470328],
            [11.465377425401737, -7.589041469962689],
            [11.465352895989296, -7.587079359206134],
            [11.457072023614433, -7.584774225778705],
            [11.451863574113567, -7.582091605491352],
            [11.444191273017672, -7.585203782309191],
            [11.440685706597503, -7.581090154809564],
            [11.43742843072055, -7.579383514484276],
            [11.432603637164071, -7.582893212249433],
            [11.429532462307531, -7.579538706439073],
            [11.430126376174282, -7.574090999960656],
            [11.42590241426179, -7.565651937401336],
            [11.427368855776805, -7.5619221672086985],
            [11.423251958002904, -7.550699743233345],
            [11.427119580496113, -7.546412147089038],
            [11.42465451913412, -7.540569008041612],
            [11.418489648665606, -7.535376101845852],
            [11.402708325885769, -7.532515107021134],
            [11.403454316351912, -7.527185573956922],
            [11.401472613234592, -7.526029405654878],
            [11.40092133625727, -7.517043947644069],
            [11.398968140081601, -7.513896947428363],
            [11.402362268277974, -7.512155343194929],
            [11.399454939578547, -7.50371036483114],
            [11.400876160982635, -7.499730432037419],
            [11.397241197399438, -7.495278456949296],
            [11.397752065072865, -7.489564484491832],
            [11.400639717159573, -7.487640809808876],
            [11.398038394741011, -7.481725762335136],
            [11.395308469723739, -7.480908159875258],
            [11.393724205513326, -7.475777132528942],
            [11.390232766639112, -7.475384160869884],
            [11.392418626163083, -7.470997714705017],
            [11.390402578038184, -7.465929252443821],
            [11.383335849490184, -7.458764919573462],
            [11.377348874094004, -7.455865554583503],
            [11.377527189758418, -7.451273247537625],
            [11.380545284276518, -7.448871132109691],
            [11.37805145543478, -7.442615451015724],
            [11.37384942990306, -7.439165164232866],
            [11.375476660089861, -7.434621482160727],
            [11.371941272133583, -7.428376233885179],
            [11.372640231837028, -7.424191151508524],
            [11.376443168143084, -7.422514231871635],
            [11.372255393732358, -7.412579043141276],
            [11.363628666954753, -7.399481614787983],
            [11.363820938948832, -7.395254484482658],
            [11.360993880855428, -7.388469955212718],
            [11.354556871820202, -7.382789312339079],
            [11.347098798305884, -7.384371883109586],
            [11.344699370450183, -7.382909772849484],
            [11.3396567900966, -7.384515315761056],
            [11.33773914812416, -7.381418057640182],
            [11.33198534814753, -7.383648564098302],
            [11.325209665035006, -7.3810069782564165]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.94793403046594,
          "lat": 30.496366231770057
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12047"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00295736"
      },
      "bbox": [
        11.325209665035006, -7.62772293232898, 11.921896727268038,
        -7.345163605580611
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.649259241466405, -6.76538085851364],
            [10.706439768623484, -6.759102868477705],
            [10.806343268914556, -6.747726382245451],
            [10.852487266811165, -6.742257295822405],
            [10.854326299828376, -6.755358524487935],
            [10.892218439040525, -6.751068068586358],
            [10.89072473226923, -6.737906136174447],
            [10.941300101500168, -6.73235710943203],
            [10.985351375930165, -6.727560896002377],
            [11.061112357421901, -6.7199966622232505],
            [11.060878701499824, -6.726493184159283],
            [11.062687420207405, -6.732453088926712],
            [11.061601084563875, -6.736795096614844],
            [11.062136437868313, -6.745053169841168],
            [11.063385937265943, -6.748583801060807],
            [11.066822635577592, -6.751957022511728],
            [11.067921926809836, -6.761449481459967],
            [11.07264028906359, -6.7663731528403295],
            [11.075004360840483, -6.7801863002309615],
            [11.073953866912262, -6.785047632718677],
            [11.075282609131108, -6.7939438453147485],
            [11.072372902873214, -6.801045063231775],
            [11.073692089297708, -6.804357677319613],
            [11.072445150627452, -6.808633152098029],
            [11.073385062590695, -6.817820784581533],
            [11.077073913525384, -6.82254486011705],
            [11.076798100936296, -6.833247264388618],
            [11.07900766663792, -6.83553409802198],
            [11.079313572992971, -6.839672644699459],
            [11.072678772912836, -6.845554745976439],
            [11.071403486069173, -6.853802505279661],
            [11.068010848263135, -6.855637003634209],
            [11.068090677637246, -6.860713224134618],
            [11.063952099764824, -6.866941923808871],
            [11.059904581882005, -6.866668153534126],
            [11.05698031697466, -6.869515833102708],
            [11.057207109447823, -6.874507149947138],
            [11.055737672559838, -6.878481480249231],
            [11.05858204954701, -6.900655407544481],
            [11.054429847295062, -6.901393570933791],
            [11.052020629599543, -6.90472469174219],
            [11.0485315140916, -6.905462199760561],
            [11.04869998547558, -6.917552972541733],
            [11.050413342616016, -6.9269087359058155],
            [11.048971354275338, -6.93161669250631],
            [11.051788220164742, -6.939201411048879],
            [11.050025761943703, -6.943994206075661],
            [11.044461639212395, -6.949956400994097],
            [11.045950145965817, -6.958991840746442],
            [11.04546594277139, -6.962276240741862],
            [11.041074094315565, -6.966214339406611],
            [11.041192513871996, -6.973094915589578],
            [11.044389361903352, -6.9903498014209315],
            [11.047741001708777, -7.016689384307486],
            [10.991117712353187, -7.021997505528752],
            [10.909868128380056, -7.030744099129682],
            [10.871921706569825, -7.034795573800752],
            [10.873279984462833, -7.0473259546487315],
            [10.860619926749978, -7.048791597784193],
            [10.85926937191626, -7.036186021042476],
            [10.755123688720621, -7.047682153065951],
            [10.700328428277395, -7.053900999798683],
            [10.682563570204797, -7.055774826313094],
            [10.678265183269852, -7.02047961787592],
            [10.675461126569452, -6.995680536347751],
            [10.666432959323949, -6.996729832642463],
            [10.665342414689784, -6.987424570890828],
            [10.674445730823981, -6.986231268177964],
            [10.66684198664456, -6.920003295865248],
            [10.66633194614904, -6.9172641614837564],
            [10.657437096490462, -6.83929795345545],
            [10.649259241466405, -6.76538085851364]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.76883280696418,
          "lat": 31.188351347026206
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13071"],
        "coty_name": ["Colquitt"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colquitt County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00343936"
      },
      "bbox": [
        10.649259241466405, -7.055774826313094, 11.079313572992971,
        -6.7199966622232505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.061112357421901, -6.7199966622232505],
            [11.105105690772957, -6.715359075337808],
            [11.104331983836907, -6.708727030783158],
            [11.116575918212794, -6.704028294462955],
            [11.115330898203837, -6.690506334732663],
            [11.123981560425081, -6.688636164853064],
            [11.12631389803709, -6.693682121526687],
            [11.125798222369752, -6.699363608022736],
            [11.127981028050197, -6.705765521477282],
            [11.12554090248584, -6.707873716676105],
            [11.126395063555844, -6.715959227263293],
            [11.124625334946046, -6.718312575373875],
            [11.124821620112572, -6.7226848082121915],
            [11.129228471304353, -6.725833331824649],
            [11.129822225905034, -6.735911322825133],
            [11.136342598669193, -6.7443987303926525],
            [11.1415700339487, -6.741865897907312],
            [11.14692768277002, -6.7444051088925505],
            [11.15046316437389, -6.748566544655363],
            [11.153566376094332, -6.7486395780161335],
            [11.160839192321971, -6.759837582874231],
            [11.163587726740158, -6.7603493524133516],
            [11.170184097584874, -6.766317341530522],
            [11.173928846166126, -6.7684461693718],
            [11.175196314198345, -6.772262518463604],
            [11.182995903345365, -6.775584629644059],
            [11.188899827295433, -6.779158622989979],
            [11.195090121935518, -6.7810825700927495],
            [11.20279145422329, -6.779393040654209],
            [11.21037687132634, -6.775971756187036],
            [11.221193359150087, -6.782113515294648],
            [11.22422156208303, -6.787053091126961],
            [11.224732182720903, -6.790484845289736],
            [11.222342053906134, -6.799922543554486],
            [11.223282718391518, -6.8038277053513845],
            [11.228196088282337, -6.809987671858484],
            [11.227806012410161, -6.817269600967268],
            [11.22945821564567, -6.824818267208336],
            [11.228609585403111, -6.828629474343466],
            [11.22976004867348, -6.8343156177186115],
            [11.233612475328341, -6.83800146412915],
            [11.237737122595965, -6.844266325140884],
            [11.24003687140618, -6.844834501701611],
            [11.246138723935946, -6.850973177023642],
            [11.257146092663005, -6.855077030119031],
            [11.257278143460503, -6.862150666635962],
            [11.2595220483441, -6.865695902802194],
            [11.260442818963593, -6.8735163413362015],
            [11.25698431508633, -6.879295446982894],
            [11.257459732410965, -6.881626071021146],
            [11.254883955288221, -6.89138453414825],
            [11.255135466071234, -6.894090618307355],
            [11.250732616977182, -6.899193739448385],
            [11.249431248296204, -6.905329460261204],
            [11.250509819527304, -6.907372504825622],
            [11.250739147333976, -6.9156746566559155],
            [11.253830850013863, -6.925136681460079],
            [11.260519859098109, -6.931034051685075],
            [11.264241354710773, -6.931435228991364],
            [11.268455957199984, -6.929376904353221],
            [11.271965833439745, -6.932775308284163],
            [11.27119854535971, -6.937273856337359],
            [11.275028393825036, -6.937454126507793],
            [11.278221227213546, -6.940548870910747],
            [11.27748498002998, -6.94815005743793],
            [11.282312449992396, -6.950958050188564],
            [11.28552532649649, -6.949631697745269],
            [11.288612076735673, -6.953106897276209],
            [11.292883993483208, -6.954703387512977],
            [11.29181293906748, -6.963730665162749],
            [11.289939571029901, -6.967339793811488],
            [11.2902686364816, -6.973326145653484],
            [11.292736646317037, -6.977322666358184],
            [11.287577380314374, -6.982406229179736],
            [11.283943972561865, -6.991129344516458],
            [11.284783709777944, -6.992027909328024],
            [11.271394141557288, -6.993751692880079],
            [11.197350688174415, -7.001013368863119],
            [11.171877191917545, -7.003778843519105],
            [11.131273147858973, -7.0076633605273155],
            [11.125905215823199, -7.007691425448056],
            [11.119611113659918, -7.005814123668932],
            [11.116206318147878, -7.002457078476235],
            [11.111952409486273, -7.001407892668918],
            [11.112795715976171, -6.997774895217978],
            [11.108407957036778, -6.991620865429747],
            [11.104944929498936, -6.991853527244833],
            [11.101538138624687, -6.9951730831028],
            [11.099094436404252, -6.993169619316904],
            [11.09427985780151, -6.993531905268089],
            [11.090504319337311, -6.991648592339062],
            [11.083381891564468, -6.9920274952267505],
            [11.072515653356128, -6.996138689942467],
            [11.06555249875373, -6.994771772487697],
            [11.061862978997121, -6.992510406708658],
            [11.059548109402918, -6.987975216135541],
            [11.056765273153673, -6.98767605171234],
            [11.054301460412608, -6.984151409218116],
            [11.04984541247976, -6.981980598308304],
            [11.041192513871996, -6.973094915589578],
            [11.041074094315565, -6.966214339406611],
            [11.04546594277139, -6.962276240741862],
            [11.045950145965817, -6.958991840746442],
            [11.044461639212395, -6.949956400994097],
            [11.050025761943703, -6.943994206075661],
            [11.051788220164742, -6.939201411048879],
            [11.048971354275338, -6.93161669250631],
            [11.050413342616016, -6.9269087359058155],
            [11.04869998547558, -6.917552972541733],
            [11.0485315140916, -6.905462199760561],
            [11.052020629599543, -6.90472469174219],
            [11.054429847295062, -6.901393570933791],
            [11.05858204954701, -6.900655407544481],
            [11.055737672559838, -6.878481480249231],
            [11.057207109447823, -6.874507149947138],
            [11.05698031697466, -6.869515833102708],
            [11.059904581882005, -6.866668153534126],
            [11.063952099764824, -6.866941923808871],
            [11.068090677637246, -6.860713224134618],
            [11.068010848263135, -6.855637003634209],
            [11.071403486069173, -6.853802505279661],
            [11.072678772912836, -6.845554745976439],
            [11.079313572992971, -6.839672644699459],
            [11.07900766663792, -6.83553409802198],
            [11.076798100936296, -6.833247264388618],
            [11.077073913525384, -6.82254486011705],
            [11.073385062590695, -6.817820784581533],
            [11.072445150627452, -6.808633152098029],
            [11.073692089297708, -6.804357677319613],
            [11.072372902873214, -6.801045063231775],
            [11.075282609131108, -6.7939438453147485],
            [11.073953866912262, -6.785047632718677],
            [11.075004360840483, -6.7801863002309615],
            [11.07264028906359, -6.7663731528403295],
            [11.067921926809836, -6.761449481459967],
            [11.066822635577592, -6.751957022511728],
            [11.063385937265943, -6.748583801060807],
            [11.062136437868313, -6.745053169841168],
            [11.061601084563875, -6.736795096614844],
            [11.062687420207405, -6.732453088926712],
            [11.060878701499824, -6.726493184159283],
            [11.061112357421901, -6.7199966622232505]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.43053393663558, "lat": 31.15404050829079 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13075"],
        "coty_name": ["Cook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cook County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00343878"
      },
      "bbox": [
        11.041074094315565, -7.007691425448056, 11.292883993483208,
        -6.688636164853064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.516481463771976, -6.676304231270708],
            [10.518998544187241, -6.673480442641904],
            [10.537426128542087, -6.671182031021486],
            [10.582716772457195, -6.6651118621244585],
            [10.636885760479286, -6.6576212710550635],
            [10.644875023056214, -6.725527965279732],
            [10.649259241466405, -6.76538085851364],
            [10.657437096490462, -6.83929795345545],
            [10.66633194614904, -6.9172641614837564],
            [10.66684198664456, -6.920003295865248],
            [10.674445730823981, -6.986231268177964],
            [10.665342414689784, -6.987424570890828],
            [10.666432959323949, -6.996729832642463],
            [10.675461126569452, -6.995680536347751],
            [10.678265183269852, -7.02047961787592],
            [10.611322815741781, -7.028584337270415],
            [10.582454025354872, -7.031805324749844],
            [10.50403096208499, -7.040769673568349],
            [10.459855696352099, -7.046083000754416],
            [10.362095992367856, -7.058073427702618],
            [10.250748626853008, -7.07206195452942],
            [10.25341884246813, -7.060967491167691],
            [10.251490038897394, -7.052366029023527],
            [10.24890276144167, -7.048313071742095],
            [10.248540414683783, -7.041639607516948],
            [10.251822287421575, -7.038204521188176],
            [10.25272498069947, -7.032135436466312],
            [10.250428741677739, -7.029220726975023],
            [10.246373929087511, -7.027519127634546],
            [10.250905444685642, -7.022853755187817],
            [10.26165465030998, -7.00928940106821],
            [10.266352424524555, -7.009404817065128],
            [10.267046480592013, -6.999725276010613],
            [10.263074939691549, -6.995222348444266],
            [10.262810680213251, -6.992066985882971],
            [10.270333596556856, -6.98748134645464],
            [10.273889972571281, -6.983342878018907],
            [10.271304480583513, -6.98082843713783],
            [10.273446020975056, -6.978365007522466],
            [10.280381008532919, -6.980465135787426],
            [10.285667439570407, -6.974117724490886],
            [10.28869746058085, -6.965391349314818],
            [10.296105045250485, -6.961823851532494],
            [10.300291745523678, -6.955389446048544],
            [10.305033280237993, -6.95394971129419],
            [10.310190737419456, -6.948731196060365],
            [10.314016217493695, -6.949281720921439],
            [10.312050213258535, -6.9554783618277956],
            [10.318019609302244, -6.953541400371411],
            [10.318427683239438, -6.949854124113878],
            [10.32146457403917, -6.947786752811453],
            [10.323976661718238, -6.938454294031461],
            [10.318649945290163, -6.9322873489050405],
            [10.321090740364694, -6.928264053992366],
            [10.320118423714487, -6.922720080137733],
            [10.32470460995412, -6.917190830990873],
            [10.32930250154708, -6.914553264843087],
            [10.328807729518209, -6.911085669266354],
            [10.334089331601282, -6.906885980277373],
            [10.338312440459829, -6.905263977834031],
            [10.34380489985116, -6.89913367131339],
            [10.346589326386422, -6.899921023011398],
            [10.350879510647987, -6.897998987264975],
            [10.353264125213167, -6.885712552673952],
            [10.355493385886836, -6.88311130924489],
            [10.35447170107811, -6.877515342496887],
            [10.35802509485653, -6.870619169123372],
            [10.362972762159087, -6.8660989289618914],
            [10.368013143826396, -6.856815285830477],
            [10.367048552246436, -6.8502359748144706],
            [10.370171859744936, -6.84706754384167],
            [10.37080255033738, -6.843635968394951],
            [10.36806308255279, -6.834870035084981],
            [10.36460272243421, -6.830926130532793],
            [10.371410459130578, -6.823329054101938],
            [10.377670221955325, -6.820308706926653],
            [10.380103830334445, -6.822117935069039],
            [10.38455374122273, -6.821690636246885],
            [10.386728153026622, -6.818727799279587],
            [10.385847738043754, -6.811599024812037],
            [10.38763338076098, -6.808912666585377],
            [10.39377477484203, -6.808389599103822],
            [10.397176369037341, -6.806099957087468],
            [10.406421489052242, -6.804484536078972],
            [10.412441252812684, -6.79967588307234],
            [10.416697018191389, -6.799562777369364],
            [10.420930706754609, -6.796018628829033],
            [10.41925756925996, -6.791006526782276],
            [10.422114708921272, -6.787004991573184],
            [10.431149871159079, -6.788121870034331],
            [10.43388430587435, -6.791644159291056],
            [10.440444512350421, -6.787361821251859],
            [10.444222504746302, -6.787298143589424],
            [10.450305153721994, -6.7847329976980655],
            [10.454249304243685, -6.7771436998985495],
            [10.45579627797672, -6.768973502579276],
            [10.462575363963214, -6.766771936913185],
            [10.467201990702408, -6.767224824645594],
            [10.467979646523604, -6.763598925891912],
            [10.472818252002288, -6.763876579847822],
            [10.47648821012759, -6.766288606966983],
            [10.478804774657094, -6.764029757437497],
            [10.477975757606384, -6.756342769056774],
            [10.474440113735607, -6.747315460534592],
            [10.474430724558495, -6.736545850544699],
            [10.477344649641758, -6.72899779377867],
            [10.486644939109935, -6.721206446908974],
            [10.48747264168639, -6.727381685446303],
            [10.491584460022008, -6.7265838869371],
            [10.492431993927466, -6.721669406129834],
            [10.48903165456889, -6.715155446307371],
            [10.488589622438628, -6.711351341486603],
            [10.49170351328671, -6.707956564943492],
            [10.498592679566379, -6.705231776692929],
            [10.50491079103761, -6.700997892175652],
            [10.509260313022672, -6.703969377447019],
            [10.510919646908212, -6.700333643444007],
            [10.51184358826286, -6.693770973617939],
            [10.517484546174089, -6.682510875149498],
            [10.516481463771976, -6.676304231270708]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.19425706686718, "lat": 31.22533786867528 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13205"],
        "coty_name": ["Mitchell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mitchell County"],
        "coty_fp_code": "205",
        "coty_gnis_code": "00343645"
      },
      "bbox": [
        10.246373929087511, -7.07206195452942, 10.678265183269852,
        -6.6576212710550635
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.172642640323692, -4.315454494962919],
            [11.17493630372269, -4.310984823477842],
            [11.174741056334735, -4.306558789719452],
            [11.176393409385375, -4.302031003283493],
            [11.182895025600505, -4.296574060478962],
            [11.205259362400202, -4.270664782099548],
            [11.267057931641448, -4.364121097834377],
            [11.271389198669665, -4.366203124084297],
            [11.271552876182486, -4.369314255848925],
            [11.277828511349046, -4.375133415931312],
            [11.282092670619575, -4.3724631998649635],
            [11.27618680663988, -4.369150035287789],
            [11.280141021237023, -4.364180750747692],
            [11.27771106144129, -4.359345693264577],
            [11.283060144499322, -4.352109325143592],
            [11.299020841944838, -4.352786626908467],
            [11.307402074652224, -4.343035271512771],
            [11.31194310867232, -4.339420929717538],
            [11.316310443366556, -4.34020479909639],
            [11.319118433427425, -4.334913493254157],
            [11.324681678900022, -4.3353763565233185],
            [11.326192335967654, -4.332946343768948],
            [11.334911267217054, -4.339766127031215],
            [11.368798503917452, -4.357664955914293],
            [11.373958643028551, -4.359551876432988],
            [11.378471310859943, -4.362893918774449],
            [11.38592816920949, -4.363082851099811],
            [11.387248913447674, -4.366990685705137],
            [11.39014065883095, -4.368586642479579],
            [11.394223047417844, -4.364868499935915],
            [11.396561286252897, -4.366488004282453],
            [11.401902553482572, -4.3642865414569645],
            [11.405888512036585, -4.365041077838623],
            [11.4112891332287, -4.362900580603221],
            [11.411493654847831, -4.367363248788472],
            [11.414099502652475, -4.3691353924173555],
            [11.41911849312392, -4.36235572727802],
            [11.418834233573117, -4.3584081691282455],
            [11.424829016290197, -4.360170724135134],
            [11.425029879108852, -4.3565089231274525],
            [11.43149891431179, -4.356503673088674],
            [11.43440646983069, -4.358033031491427],
            [11.434745823321597, -4.362748697667668],
            [11.437037250986052, -4.369415878885764],
            [11.444067882898489, -4.372833542302195],
            [11.437958571358953, -4.3834460965749935],
            [11.432465415973422, -4.381282310873191],
            [11.428197028124014, -4.383286347886385],
            [11.425323828476337, -4.387919368585701],
            [11.427547150112193, -4.3911755968940955],
            [11.427302189258604, -4.395811633994208],
            [11.422078708613178, -4.404230923596658],
            [11.42274375797104, -4.409664801938989],
            [11.415113703172421, -4.418019206495842],
            [11.414740487417678, -4.424047607376548],
            [11.4174900476654, -4.425606815002795],
            [11.417178286802168, -4.4380920782351225],
            [11.415375773836836, -4.439387008363698],
            [11.411552013105785, -4.447963736668335],
            [11.404771180776766, -4.450516253489669],
            [11.4019700104149, -4.463720792620922],
            [11.402172633829236, -4.466769255889033],
            [11.398218189704322, -4.4701630881589045],
            [11.393234473922632, -4.468631819884247],
            [11.39014809252312, -4.469437364674908],
            [11.384470821109623, -4.4675970143907415],
            [11.381106143095451, -4.470241473679183],
            [11.372597615129404, -4.471181959123492],
            [11.368350145825604, -4.473770554659677],
            [11.34417394438297, -4.466559444999747],
            [11.340603244419148, -4.469284435235049],
            [11.339396383157137, -4.474965636794428],
            [11.340131509687321, -4.484416896503057],
            [11.339176548266103, -4.4864948681963215],
            [11.330649239467544, -4.4913800893364115],
            [11.329041441062085, -4.498204931222809],
            [11.329323432407554, -4.501729433417512],
            [11.32380659273294, -4.508311395519659],
            [11.322032862816503, -4.512771872699348],
            [11.316619029131113, -4.521066646988385],
            [11.309682631866341, -4.5266287472022135],
            [11.315553474768091, -4.533226004126457],
            [11.31541344084378, -4.5364782941709425],
            [11.318981747740468, -4.537379843931792],
            [11.32352500885188, -4.547274897007735],
            [11.324905953594776, -4.547882834555825],
            [11.318547752555935, -4.551142447172295],
            [11.31204258108774, -4.549704531108063],
            [11.307563826154114, -4.5473762947924365],
            [11.301774980371178, -4.550574851055864],
            [11.300176530177419, -4.549172780485784],
            [11.29391023280854, -4.556220640751542],
            [11.289198578057777, -4.5562127931835],
            [11.284653169325503, -4.558277236487576],
            [11.253030173796633, -4.558684881510433],
            [11.24228571251978, -4.5509516469588585],
            [11.23739748159412, -4.550518241053371],
            [11.234060277511563, -4.553739723757797],
            [11.222472321307746, -4.554959648983901],
            [11.21609125799458, -4.558761708609284],
            [11.208658907523294, -4.554171252021264],
            [11.203804972700521, -4.549651886514445],
            [11.191149196130478, -4.5405392610114985],
            [11.189309906874481, -4.540609013070897],
            [11.20884605561182, -4.516991104450226],
            [11.203572000785684, -4.487734337418899],
            [11.204284964797157, -4.486694957455258],
            [11.17308434328017, -4.430141641678538],
            [11.174962823695653, -4.424599612736985],
            [11.18270289183486, -4.417755637263081],
            [11.189720563520597, -4.404652512137423],
            [11.186705476193264, -4.40343362538045],
            [11.184859964511674, -4.395468594243157],
            [11.177796640330913, -4.389094322677526],
            [11.180666483073892, -4.383499446780659],
            [11.187975178217021, -4.3788800866412805],
            [11.196174033986411, -4.39217292524746],
            [11.20044230263415, -4.3844995484514],
            [11.200311929553115, -4.364222956434609],
            [11.213925356978356, -4.3458192899152985],
            [11.213825713088246, -4.342752024231502],
            [11.209516469813607, -4.337383299824954],
            [11.204055572877333, -4.333247551891871],
            [11.201083322961399, -4.3285996587664775],
            [11.189434201649568, -4.327538781448083],
            [11.183909271668428, -4.3230161761649475],
            [11.179793400326757, -4.322108604762537],
            [11.172642640323692, -4.315454494962919]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.87882501490245, "lat": 33.56607687110716 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13265"],
        "coty_name": ["Taliaferro"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taliaferro County"],
        "coty_fp_code": "265",
        "coty_gnis_code": "00347654"
      },
      "bbox": [
        11.172642640323692, -4.558761708609284, 11.444067882898489,
        -4.270664782099548
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.443042772155891, -5.854795042135526],
            [11.483273650578873, -5.801338991898208],
            [11.470575637832615, -5.789624380900262],
            [11.475547474660525, -5.784720121222373],
            [11.481837649114787, -5.789680913898931],
            [11.487025286295225, -5.783654595173462],
            [11.492903208100412, -5.788238533740573],
            [11.557145769155877, -5.703274046620592],
            [11.563567994405545, -5.707941670330615],
            [11.56839859684744, -5.701698234962979],
            [11.561912288385544, -5.69666007192079],
            [11.570488924794496, -5.684604513687673],
            [11.590505403958696, -5.658613637715631],
            [11.592726984178412, -5.6617537344163615],
            [11.60017395072451, -5.6607636551126195],
            [11.604292621298367, -5.662755807336448],
            [11.604970226673776, -5.667935376515316],
            [11.607767011014484, -5.6666615559067175],
            [11.611966156982723, -5.669062321697556],
            [11.61797078933383, -5.6688477041051515],
            [11.630985071678111, -5.667089927963794],
            [11.633466050488126, -5.668404418444337],
            [11.63833996043824, -5.666550786670075],
            [11.643934097355151, -5.659722793298477],
            [11.647496305978034, -5.6624609635668754],
            [11.653424223071449, -5.664555958170888],
            [11.656777964731964, -5.663301966346902],
            [11.65780153857374, -5.667868036288789],
            [11.653087583261883, -5.670076205775767],
            [11.657228789028073, -5.674414628112161],
            [11.655259988251629, -5.676380901495441],
            [11.656457388313406, -5.682027565745365],
            [11.662625881842073, -5.683251590882273],
            [11.667195193319964, -5.688400025029285],
            [11.665859121608888, -5.6994715028765555],
            [11.662083663466015, -5.70068084854136],
            [11.66313908048776, -5.706921814957256],
            [11.660483342291826, -5.708533040355567],
            [11.660277650023831, -5.713698700957248],
            [11.66410067223304, -5.715144668864019],
            [11.667037846922014, -5.720615385169627],
            [11.674678350372961, -5.7240992789083736],
            [11.676966547802046, -5.7315671055450785],
            [11.674801775442946, -5.736449857631866],
            [11.68551190149741, -5.749587156705134],
            [11.682132229862102, -5.753188554710742],
            [11.681138755625668, -5.760660392348403],
            [11.685634363605018, -5.769316108595207],
            [11.684317780202345, -5.773832451234933],
            [11.69019037092024, -5.773152353704237],
            [11.68757449872353, -5.778159872016144],
            [11.691545001786151, -5.7810705458995955],
            [11.690227713320603, -5.786538281794024],
            [11.702164027742128, -5.792151123025613],
            [11.703202464955648, -5.803717734640155],
            [11.699628668232542, -5.808039143256485],
            [11.700007012100349, -5.811363833329158],
            [11.696260202387988, -5.817868354429346],
            [11.695122284019545, -5.8222417424936594],
            [11.691838464202242, -5.823205290863592],
            [11.692851031212413, -5.826761575541685],
            [11.695654757869105, -5.828396245735252],
            [11.697561800565227, -5.834718423961614],
            [11.70004674978559, -5.836347373868047],
            [11.699933925728839, -5.840754774229027],
            [11.702801121266353, -5.844223057521921],
            [11.70971400417977, -5.8475427641497175],
            [11.709564427033127, -5.8529144957465835],
            [11.713607230026772, -5.863686414589106],
            [11.712908807758778, -5.868541588943677],
            [11.709584375986756, -5.867369690085758],
            [11.705308124750587, -5.869910110197623],
            [11.708420689898645, -5.874251082616135],
            [11.71262059590785, -5.874178848636666],
            [11.71841929784418, -5.879442028203973],
            [11.71552462148127, -5.881330529529462],
            [11.717021403460855, -5.886226113815326],
            [11.71561999717643, -5.892169478898107],
            [11.71962520394308, -5.894870575144789],
            [11.720647734328061, -5.900900945726648],
            [11.727353695361545, -5.904494682562668],
            [11.726491663704078, -5.911208774902322],
            [11.722812769229625, -5.91371869277259],
            [11.725855711253844, -5.917687860745476],
            [11.733635135631445, -5.920952916959791],
            [11.731780983233886, -5.923587056182385],
            [11.732084404954799, -5.930772214128375],
            [11.736239901984698, -5.931906691848126],
            [11.735291744696381, -5.936023966115595],
            [11.741463092970754, -5.940989151358709],
            [11.744091124360237, -5.941676807537552],
            [11.753690249498826, -5.9477324937380756],
            [11.760901474267005, -5.951315660464133],
            [11.765950572643867, -5.956389348488854],
            [11.771639924627928, -5.9550367949752285],
            [11.77442884818214, -5.95897943174215],
            [11.775779865181748, -5.965104104727932],
            [11.782141698995545, -5.962548305328539],
            [11.788911097387562, -5.970154751898071],
            [11.791270201655617, -5.976396568744583],
            [11.788620818137398, -5.984517235906189],
            [11.788381176965135, -5.987606551849107],
            [11.782581689360216, -5.98701632468848],
            [11.777054044935422, -5.989515141768543],
            [11.771072284774064, -5.98884795909202],
            [11.766190088862674, -5.99347609645055],
            [11.761534667141122, -6.00029112218176],
            [11.75990161498797, -6.006173828616428],
            [11.757017250512932, -6.007492832778463],
            [11.755506867680145, -6.012667600318125],
            [11.750600829923004, -6.012735900394517],
            [11.748281124762466, -6.017402995752782],
            [11.745973090468567, -6.013187471779858],
            [11.741693799577451, -6.012642982224516],
            [11.738898444018428, -6.018021722237399],
            [11.733890312862885, -6.024782924105682],
            [11.73027969728012, -6.025190989638667],
            [11.726281267124048, -6.02897957230858],
            [11.723091948068141, -6.029836516103946],
            [11.71964411758878, -6.0277993051355905],
            [11.708974554266955, -6.036163583258793],
            [11.700515318672707, -6.031977767100617],
            [11.701242917615588, -6.026892714343136],
            [11.68689435337876, -6.02391163063046],
            [11.67661770499516, -6.012762671321598],
            [11.669912625022167, -6.010118821634056],
            [11.668239699430899, -6.006836682351332],
            [11.662222424167618, -6.004382379471338],
            [11.65903704341779, -5.996669027206953],
            [11.653654105136948, -5.989371200928568],
            [11.65069459047394, -5.98999050486407],
            [11.646820049579826, -5.987373316665111],
            [11.645572609887447, -5.982919965758597],
            [11.640198444838795, -5.978978426634378],
            [11.640257828027991, -5.975613620054139],
            [11.637292472592856, -5.973686178898242],
            [11.6338942915926, -5.968352607235566],
            [11.634717107252287, -5.963978693751902],
            [11.627260925725075, -5.959295020033865],
            [11.617301756547056, -5.958791289274949],
            [11.610168140308208, -5.960837844994959],
            [11.597685141228395, -5.957774471404043],
            [11.594675749186258, -5.958586555033832],
            [11.59000067708392, -5.956580906065234],
            [11.587325682796758, -5.952615128868578],
            [11.582988039060995, -5.953335306953493],
            [11.576362464587802, -5.9501109534867975],
            [11.572741603431568, -5.943374934078677],
            [11.566817858778714, -5.939419408754524],
            [11.560904017807795, -5.9296681881587],
            [11.555658492226675, -5.926515766312602],
            [11.548089702941207, -5.923978358981134],
            [11.53778838639964, -5.92204450491769],
            [11.536069956508868, -5.9196639824626205],
            [11.528804014906328, -5.918163726736365],
            [11.52482214084598, -5.91974808703412],
            [11.51642247947344, -5.919993342221118],
            [11.511868791561128, -5.918149272784938],
            [11.510315775474709, -5.91494810658246],
            [11.49965728612115, -5.908346062684548],
            [11.496123738707007, -5.909273650833077],
            [11.484673058809049, -5.905224557110217],
            [11.480715909657611, -5.900266799725231],
            [11.475834892647756, -5.898664818714442],
            [11.470195742274038, -5.889084286000153],
            [11.468111755509844, -5.876542109961082],
            [11.464004154552462, -5.872430681025808],
            [11.458786764751522, -5.869040269590684],
            [11.455142630921149, -5.864890727780351],
            [11.442667666588706, -5.864333124109709],
            [11.434549934813871, -5.866476666389093],
            [11.443042772155891, -5.854795042135526]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.72454386329748, "lat": 32.11690743691769 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13309"],
        "coty_name": ["Wheeler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wheeler County"],
        "coty_fp_code": "309",
        "coty_gnis_code": "00351278"
      },
      "bbox": [
        11.434549934813871, -6.036163583258793, 11.791270201655617,
        -5.658613637715631
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.165600937674418, 6.714255229729958],
            [-14.084646981618588, 6.696842854611567],
            [-14.003696363343376, 6.679414487741638],
            [-13.936612974699864, 6.5744430064118164],
            [-13.892112559309268, 6.503810370951239],
            [-13.83806718545547, 6.418065748210989],
            [-13.833701825211344, 6.4227457061914786],
            [-13.843448243885081, 6.378431772978005],
            [-13.842604472086792, 6.378269225532698],
            [-13.880569045220573, 6.201490578473226],
            [-13.897207006672792, 6.124054819580229],
            [-13.898320754810964, 6.124227700340391],
            [-13.91669394760899, 6.040979744948891],
            [-13.917709107135147, 6.041169571246078],
            [-13.93604831841808, 5.95613776605259],
            [-14.061889291964327, 5.982534785804688],
            [-14.062049566235302, 5.981856196708447],
            [-14.14038099598525, 5.998628667346124],
            [-14.14156863886337, 6.003942369408435],
            [-14.146238959549429, 6.00704358745889],
            [-14.152727212835437, 6.009150767837125],
            [-14.162842126658738, 6.01057676277329],
            [-14.166208292575666, 6.012698449669176],
            [-14.168477324832663, 6.017852365286336],
            [-14.168335791130042, 6.029148301846951],
            [-14.1713731085566, 6.037744897188985],
            [-14.178608848676744, 6.042982356785086],
            [-14.18020868760594, 6.045684079968216],
            [-14.17888743551167, 6.049440668367605],
            [-14.179455476509155, 6.057291336482475],
            [-14.184732239585168, 6.061885477360079],
            [-14.188955340309585, 6.062688031656402],
            [-14.192247111246605, 6.066173362400287],
            [-14.196727055015451, 6.07563776582429],
            [-14.19790427129577, 6.081612189647472],
            [-14.205495096986464, 6.0904012181972575],
            [-14.207951350495442, 6.096402174471324],
            [-14.207164696988723, 6.099975926912466],
            [-14.203106694468687, 6.107499652074113],
            [-14.201781100460604, 6.119136825879464],
            [-14.192916769967631, 6.1315171528750465],
            [-14.191955275621723, 6.139721726713734],
            [-14.197062832743796, 6.155002722012254],
            [-14.202646910863765, 6.161235476888014],
            [-14.205400968304161, 6.166842992372414],
            [-14.203895690298376, 6.168996918021167],
            [-14.202637132385805, 6.177109629476583],
            [-14.2036625375419, 6.18346110784418],
            [-14.205706126098557, 6.188835712091839],
            [-14.208165143087939, 6.190669859163244],
            [-14.2143853041512, 6.200047514418707],
            [-14.21930085732405, 6.203879788007679],
            [-14.22424517118893, 6.204499206670776],
            [-14.230212718642903, 6.202426438894888],
            [-14.241760254602662, 6.202941599291382],
            [-14.247999268466534, 6.204970317238452],
            [-14.256908342936814, 6.2049193128495554],
            [-14.27053031712947, 6.200579939529767],
            [-14.276317359901352, 6.210424005307906],
            [-14.25914141144718, 6.289772397477931],
            [-14.26004336359796, 6.290212328790605],
            [-14.241027693270816, 6.375344235461994],
            [-14.21284662148956, 6.3697547975783895],
            [-14.20659757220195, 6.397465793194624],
            [-14.191124407490774, 6.468645871140966],
            [-14.185499470371825, 6.49349821626378],
            [-14.17535903548356, 6.5396570417686775],
            [-14.203238123081903, 6.545805211959037],
            [-14.186146091513182, 6.621277031315061],
            [-14.176107688103027, 6.667204456357657],
            [-14.165600937674418, 6.714255229729958]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.24115938809985,
          "lat": 43.45107686613674
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16001"],
        "coty_name": ["Ada"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ada County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00395066"
      },
      "bbox": [
        -14.276317359901352, 5.95613776605259, -13.833701825211344,
        6.714255229729958
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.084080738838793, 6.540126046402896],
            [-13.07917689179471, 6.5354506829164105],
            [-13.07476437766526, 6.533631334308542],
            [-13.072004873307517, 6.527543679540258],
            [-13.063708712631723, 6.531124887927402],
            [-13.058624529527322, 6.530646298630763],
            [-13.052919202035122, 6.521700081698558],
            [-13.046769935089397, 6.513779658334613],
            [-13.04249538276981, 6.509916458297257],
            [-13.036870946333803, 6.5084258122288166],
            [-13.03262688676453, 6.502284904234827],
            [-13.027756465691862, 6.4982810488751],
            [-13.022994741026805, 6.498658790480788],
            [-13.019020615158588, 6.496052121013938],
            [-13.018040433069583, 6.4919880987401815],
            [-13.004087378520104, 6.486876881988504],
            [-12.99929997691463, 6.481278116203748],
            [-12.995535513546772, 6.481171349682437],
            [-12.992819584350524, 6.478910339715078],
            [-12.994221723393345, 6.472818211266375],
            [-12.999092337744957, 6.469481311499086],
            [-13.002714732034987, 6.459650884483119],
            [-13.000449492790898, 6.4546891251591365],
            [-12.991521342174131, 6.45643585611594],
            [-12.986150578506463, 6.453843806339882],
            [-12.985130676617873, 6.448497199671385],
            [-12.980244958445876, 6.450525846209366],
            [-12.973318978391179, 6.456855442477991],
            [-12.96410347922955, 6.456952629097216],
            [-12.96217971689981, 6.458911854085111],
            [-12.957925549626804, 6.456959709714128],
            [-12.952621026509096, 6.456882695962746],
            [-12.94847398523863, 6.4541069702375635],
            [-12.94619425513303, 6.445229476273035],
            [-12.943516315301096, 6.445890479128606],
            [-12.935996790635748, 6.4424176543883975],
            [-12.930606406060688, 6.450500881793224],
            [-12.92694125174866, 6.450380253525659],
            [-12.91901183146729, 6.454505414814692],
            [-12.916361880388001, 6.453055637312588],
            [-12.911951243635478, 6.453685155405613],
            [-12.908268475582924, 6.45131967347134],
            [-12.900387290712219, 6.459514353122551],
            [-12.895584403565858, 6.451542839380043],
            [-12.892278188800319, 6.447755417914641],
            [-12.891262882970791, 6.441778816066276],
            [-12.89173510391223, 6.436208652094508],
            [-12.889917179843803, 6.430297783702106],
            [-12.889786145441612, 6.42574135121149],
            [-12.893509647832502, 6.41735537161678],
            [-12.891138098870796, 6.404562237246181],
            [-12.894467140639044, 6.396319154720343],
            [-12.89470130037379, 6.392242472531047],
            [-12.88931906196739, 6.382976738806781],
            [-12.886118158092922, 6.384542327928526],
            [-12.881576257706048, 6.383281688410763],
            [-12.879934699873955, 6.377697439301152],
            [-12.883482070199992, 6.373251118190204],
            [-12.888015014907511, 6.37000719086884],
            [-12.889771768303833, 6.366174424518109],
            [-12.892750120897484, 6.365119262342848],
            [-12.895227164869372, 6.357810239545744],
            [-12.897405914345049, 6.346661220374644],
            [-12.895110937255339, 6.339079023039503],
            [-12.90345444742538, 6.334979016477798],
            [-12.905811328461358, 6.328984765634894],
            [-12.903595013894988, 6.318140993489625],
            [-12.90187454669856, 6.31610684049619],
            [-12.902699091857935, 6.311968659073623],
            [-12.90052229191377, 6.309989786987821],
            [-12.895477556957424, 6.309196422232403],
            [-12.892615471643008, 6.300568176779539],
            [-12.892810620153316, 6.295284401641762],
            [-12.895274342128046, 6.290967158352308],
            [-12.896061893130707, 6.284778325421369],
            [-12.901944651208893, 6.281611489134527],
            [-12.9045822680367, 6.2782202690414675],
            [-12.903245802103607, 6.270895258832554],
            [-12.905851363668877, 6.265804583347967],
            [-12.913179170069794, 6.259395355267377],
            [-12.91668263300135, 6.252608042979866],
            [-12.916806087796445, 6.246333524938016],
            [-12.920540067865867, 6.237543005289095],
            [-12.92057703885981, 6.234477540041926],
            [-12.913947770303784, 6.236005126799503],
            [-12.90566141296152, 6.2358901708206345],
            [-12.90331621809591, 6.2337303116873715],
            [-12.898343717793079, 6.232774912713646],
            [-12.896425119478902, 6.2263584703164145],
            [-12.893790397551339, 6.221888721953578],
            [-12.894457904207393, 6.216993095116854],
            [-12.89034525265567, 6.211220543186004],
            [-12.88130373745019, 6.211494511041004],
            [-12.878361718546927, 6.20475043711737],
            [-12.87235295334431, 6.199850355161983],
            [-12.86838147260745, 6.200856271566366],
            [-12.86724112522385, 6.197879595300711],
            [-12.863560657168874, 6.195574277850128],
            [-12.859110042801085, 6.190246473517027],
            [-12.861979230055537, 6.184424916103889],
            [-12.85958305460522, 6.1812651379722325],
            [-12.864490479290916, 6.178677326905598],
            [-12.869010436931884, 6.171053800975168],
            [-12.870835324725038, 6.16446408021162],
            [-12.8624257032018, 6.156641254887259],
            [-12.860952449602884, 6.146400985902234],
            [-12.857698241182934, 6.139179492196432],
            [-12.856581442490851, 6.134419267860965],
            [-12.85292273864305, 6.131716924776671],
            [-12.853197914869208, 6.128073673556053],
            [-12.847945456390999, 6.124929892351892],
            [-12.840336075309967, 6.123910844498491],
            [-12.835713900082316, 6.11822515197748],
            [-12.83180759564392, 6.115535580749418],
            [-12.824070262182772, 6.116545151414851],
            [-12.822820982579028, 6.113739167554397],
            [-12.82224156111713, 6.106328741449125],
            [-12.818579257110105, 6.1035616646340864],
            [-12.820599114532305, 6.09333414319275],
            [-12.82475006685724, 6.087296110639626],
            [-12.827290706330508, 6.081263905329138],
            [-12.829969059189587, 6.081203859874423],
            [-12.84149554792851, 6.072381268761429],
            [-12.844849382780707, 6.067084079270136],
            [-12.850018633811692, 6.068701490455242],
            [-12.854894042083297, 6.064377753389345],
            [-12.861801027073883, 6.0274066060190385],
            [-12.847712019392587, 6.024599086884585],
            [-12.853812435130891, 5.99547856967115],
            [-12.85905004205856, 5.996521488226815],
            [-12.866024731318733, 5.961996454501597],
            [-12.862989257437054, 5.959832181966463],
            [-12.854792795498424, 5.959539225442533],
            [-12.847764421017553, 5.957914535521754],
            [-12.844573732194666, 5.953427391588086],
            [-12.834102567147184, 5.951300311698798],
            [-12.827669932636912, 5.953493748251411],
            [-12.81598296965604, 5.943653768624501],
            [-12.806176094646597, 5.949053069926563],
            [-12.801126772927116, 5.946777283357986],
            [-12.797215874376224, 5.946500939017004],
            [-12.791949971365712, 5.94832447208379],
            [-12.789023749327006, 5.944152000725273],
            [-12.783581327558833, 5.940688499108312],
            [-12.777628072040736, 5.940897889866807],
            [-12.76807631485141, 5.935519813688382],
            [-12.781517044449433, 5.868204697005978],
            [-12.76724033336743, 5.865374867493129],
            [-12.778562285303888, 5.808609281032289],
            [-12.863894159677878, 5.825334860902902],
            [-12.864163613922129, 5.82403816757524],
            [-12.899852682780745, 5.830876222576092],
            [-12.935093103700938, 5.837963252063772],
            [-13.040486274925383, 5.858990270684038],
            [-13.146866708211403, 5.880100852907319],
            [-13.284637308595036, 5.907519974398333],
            [-13.264615106051364, 6.00671097441084],
            [-13.250398606785515, 6.07631301327265],
            [-13.248258375370487, 6.076007293560315],
            [-13.20101455160582, 6.30491034405751],
            [-13.195285255265336, 6.306347591738443],
            [-13.19047974574587, 6.300251328733878],
            [-13.187830564911414, 6.299467321313762],
            [-13.186021533965096, 6.3032116843436174],
            [-13.176665163157192, 6.310625158463101],
            [-13.172840857365777, 6.312620877645242],
            [-13.166601749803254, 6.313849222611276],
            [-13.163405890133557, 6.311953382270564],
            [-13.1617647651492, 6.31494426748607],
            [-13.163406855414117, 6.319719080325631],
            [-13.159667012017632, 6.327495826606397],
            [-13.159938618284723, 6.339808725876155],
            [-13.157957408895928, 6.341478774173361],
            [-13.152351292991668, 6.3523119112070745],
            [-13.152932347490845, 6.362317918081625],
            [-13.154230863546294, 6.36537974577829],
            [-13.151968387945866, 6.369707121467874],
            [-13.147788014990464, 6.371136098634686],
            [-13.145112557929956, 6.375361851666211],
            [-13.142502870879673, 6.375890743921033],
            [-13.139768210290889, 6.380027181882757],
            [-13.130112260775107, 6.3848311085663925],
            [-13.130272072252927, 6.393978422345705],
            [-13.126992596049567, 6.403217610903025],
            [-13.129553916794032, 6.411402255918071],
            [-13.128758202266033, 6.414877063908964],
            [-13.138748854459719, 6.41902230923618],
            [-13.138872622876239, 6.425800317389425],
            [-13.143502583724992, 6.432730737950198],
            [-13.144020998976162, 6.437195390538588],
            [-13.138827606024455, 6.441875947393823],
            [-13.139189814734367, 6.448868532239181],
            [-13.136187732137053, 6.450576148217047],
            [-13.135444759324232, 6.456170599136506],
            [-13.136615616284447, 6.458521440556475],
            [-13.134051984831764, 6.463206809883822],
            [-13.127913099001626, 6.471517187107094],
            [-13.125918101275827, 6.477172212393783],
            [-13.12510914277862, 6.4856081800637355],
            [-13.119518537101543, 6.496027753716454],
            [-13.117069541944394, 6.496714901738242],
            [-13.116432072558693, 6.501722807100373],
            [-13.113425488111131, 6.503418326957033],
            [-13.112654731726394, 6.509639994381655],
            [-13.106634684455122, 6.513062333723934],
            [-13.100517031288602, 6.513099475911541],
            [-13.09869533150432, 6.517401335619514],
            [-13.097289614836619, 6.526075723497772],
            [-13.093171485331277, 6.53087885449684],
            [-13.093454100357176, 6.534563908325633],
            [-13.084080738838793, 6.540126046402896]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.80578298109091,
          "lat": 43.46335271806975
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16025"],
        "coty_name": ["Camas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Camas County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00399408"
      },
      "bbox": [
        -13.284637308595036, 5.808609281032289, -12.76724033336743,
        6.540126046402896
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.537161513504515, 6.142363994424725],
            [-10.532889172928833, 6.146514864083395],
            [-10.528231482854267, 6.145394294136175],
            [-10.51899301334088, 6.149570777958004],
            [-10.516955745373004, 6.153634960492774],
            [-10.511846400600595, 6.157446544496625],
            [-10.501762613094659, 6.162116484992574],
            [-10.499026401060481, 6.158555877524499],
            [-10.498273471991745, 6.151267925566878],
            [-10.488168329387111, 6.150971854723115],
            [-10.48560696985971, 6.143479477691531],
            [-10.486611954217226, 6.136715547307115],
            [-10.479576187153176, 6.134887232924333],
            [-10.477270585837296, 6.131630731589364],
            [-10.46954709563325, 6.12781467821818],
            [-10.463142772902597, 6.131330946417675],
            [-10.460983726699348, 6.130458754400833],
            [-10.452502507789585, 6.132587164526863],
            [-10.444307148817678, 6.1434273064703495],
            [-10.435949257631771, 6.143391301544393],
            [-10.432151374192914, 6.141272456880145],
            [-10.425424229018896, 6.144867869818624],
            [-10.422233483190022, 6.143992730481755],
            [-10.41871152688074, 6.1492596755629005],
            [-10.415864937142867, 6.149388417460482],
            [-10.413153421893167, 6.144775415166798],
            [-10.407841293205982, 6.140852813578938],
            [-10.405957976269576, 6.137953245354881],
            [-10.395359527374977, 6.138641182031078],
            [-10.39631751669266, 6.131362419354498],
            [-10.38587207107867, 6.127275606776606],
            [-10.377717451654311, 6.13362195498357],
            [-10.37476417862473, 6.132354526536256],
            [-10.371122756750779, 6.1364681963671694],
            [-10.36613898527065, 6.1365784936414425],
            [-10.36436570374168, 6.140483773090787],
            [-10.357614023205109, 6.141969599358888],
            [-10.35446096398536, 6.143894583797926],
            [-10.351863174060961, 6.140196395376151],
            [-10.34741881944363, 6.147628292140038],
            [-10.34271908945839, 6.146608955184267],
            [-10.33241056480905, 6.150820142133541],
            [-10.327958139983929, 6.154870476487771],
            [-10.320337044598592, 6.153525370103954],
            [-10.315265816576787, 6.15677633103629],
            [-10.3129184008053, 6.155918415851726],
            [-10.308315756900704, 6.157656690001128],
            [-10.305674345123164, 6.156820962029595],
            [-10.301844747390229, 6.159167717180438],
            [-10.298264387098724, 6.158956031543462],
            [-10.295622935850337, 6.161443486282147],
            [-10.286427168344733, 6.16416278360956],
            [-10.28035666414345, 6.1613464361782055],
            [-10.278437006225348, 6.162038702670611],
            [-10.289930197013367, 6.087976867231237],
            [-10.304719338066393, 5.996762097006375],
            [-10.324550398925139, 5.870463397206882],
            [-10.328812775960134, 5.8420670459523345],
            [-10.353484870698784, 5.686015101376792],
            [-10.361794324867091, 5.697140628223355],
            [-10.358136642607858, 5.705434392085066],
            [-10.362318796725452, 5.706551819906008],
            [-10.365603225557924, 5.713342552773696],
            [-10.369272189030477, 5.715189708062205],
            [-10.372996359706125, 5.711983170158217],
            [-10.37926361677891, 5.710741796233371],
            [-10.387276731322688, 5.715254153093735],
            [-10.39170865785319, 5.715148842310851],
            [-10.39688831270623, 5.719190395910603],
            [-10.401237557394209, 5.7239907232385185],
            [-10.406049434168114, 5.7255567736767174],
            [-10.41350382422953, 5.736088982241035],
            [-10.415195175228618, 5.741518364303643],
            [-10.423518569008651, 5.738734211409326],
            [-10.432058938211545, 5.741501264815062],
            [-10.436512392801157, 5.7458206874777185],
            [-10.440566107577158, 5.7413331763542415],
            [-10.450800145071605, 5.740722201603101],
            [-10.456820591616715, 5.7416739311425715],
            [-10.462372090069634, 5.746742548091786],
            [-10.465494944266132, 5.759629408100311],
            [-10.467587598518945, 5.762237520317322],
            [-10.464748200525708, 5.76461813091569],
            [-10.464351038352461, 5.769307568816905],
            [-10.465803052542189, 5.772470723269641],
            [-10.46304147141222, 5.777192191063897],
            [-10.464713162640876, 5.778667509882768],
            [-10.466733152399053, 5.7855066389857],
            [-10.466625208420782, 5.789639890194082],
            [-10.46833678547334, 5.79457274122245],
            [-10.46502471542598, 5.80060718349142],
            [-10.467581184306681, 5.804400197062768],
            [-10.465545883392963, 5.810546487243691],
            [-10.471978721289192, 5.819603083270511],
            [-10.47570079818021, 5.82784438724652],
            [-10.586602178287455, 5.8459101161416465],
            [-10.558482963056123, 6.017969825511535],
            [-10.55914281724565, 6.018081143837012],
            [-10.545077626980905, 6.103130722366918],
            [-10.543657561242025, 6.102927220831291],
            [-10.537161513504515, 6.142363994424725]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.20763932403734,
          "lat": 43.75940739543112
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16081"],
        "coty_name": ["Teton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Teton County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00399297"
      },
      "bbox": [
        -10.586602178287455, 5.686015101376792, -10.278437006225348,
        6.16416278360956
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.0164897946805125, 3.0539216620422494],
            [5.073408771652779, 3.0578310423711703],
            [5.103458997640389, 3.060100828462412],
            [5.187418166180279, 3.066119468222543],
            [5.275447739250442, 3.07219057553223],
            [5.358210608849916, 3.0777489759526446],
            [5.4434978941849135, 3.0838344813230285],
            [5.465060310197185, 3.08552985590321],
            [5.531671682733302, 3.0903754897026183],
            [5.539270714531513, 2.986357490428506],
            [5.54540849767227, 2.912910144101279],
            [5.553711448032183, 2.8143555336147217],
            [5.551782559933136, 2.8131407454239437],
            [5.541145006246069, 2.8124237563550287],
            [5.524247556488288, 2.8143296699731275],
            [5.516212710980111, 2.8137148712488673],
            [5.508051248429672, 2.814024584969066],
            [5.496587005577773, 2.817867915712586],
            [5.489342196485162, 2.818964600511092],
            [5.481911768042085, 2.8216778301583765],
            [5.47472707671591, 2.8204568460789803],
            [5.464536628221907, 2.810212948334363],
            [5.457780073457902, 2.8082872507524486],
            [5.449073946432906, 2.8036470684579506],
            [5.426803334806937, 2.7958053831853213],
            [5.422275068928495, 2.7900508583709716],
            [5.422330643564068, 2.786685746146094],
            [5.426508622605199, 2.778656958963135],
            [5.4253034584519435, 2.7690505241554777],
            [5.4201626121429625, 2.7534947145043636],
            [5.415664043759473, 2.726688879899782],
            [5.383681969224456, 2.7249642515932297],
            [5.333995191799252, 2.721865695382854],
            [5.337848552582546, 2.6652232372408595],
            [5.3401198760133175, 2.6361365617128283],
            [5.267783775129509, 2.631355674282901],
            [5.21162160641876, 2.627436348468737],
            [5.205741071247363, 2.713151682332539],
            [5.129311380497362, 2.7081261810359045],
            [5.042748072442166, 2.7030493552939547],
            [5.041368578484562, 2.7251024639416515],
            [5.038526583577852, 2.7791191998540286],
            [5.033385199450893, 2.8558879684749274],
            [5.028049740974232, 2.936813012981397],
            [5.024451863659215, 2.988248875704396],
            [5.023144229028819, 2.9882753062415173],
            [5.0164897946805125, 3.0539216620422494]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.52865859414372, "lat": 41.40412778864781 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17011"],
        "coty_name": ["Bureau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bureau County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00424207"
      },
      "bbox": [
        5.0164897946805125, 2.627436348468737, 5.553711448032183,
        3.0903754897026183
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.084309736539562, 2.045920643432216],
            [4.106905408538102, 2.0627390535359384],
            [4.118726710391077, 2.070707770751126],
            [4.12891024619697, 2.0795653723135508],
            [4.131787636040168, 2.0865157132526013],
            [4.1341347773616635, 2.102717109050243],
            [4.1361362015895065, 2.1073149628120156],
            [4.136518624133796, 2.1194489807654606],
            [4.132161070148422, 2.136266705619733],
            [4.135090535284172, 2.156964628598999],
            [4.136478405464069, 2.1624926905136492],
            [4.14044564547712, 2.1688943620860575],
            [4.144687640328997, 2.179263284270513],
            [4.147355331435481, 2.1920900291101137],
            [4.147332713316203, 2.1991689368791567],
            [4.146253518070378, 2.205354616501509],
            [4.142176539357629, 2.2147932553263403],
            [4.141839581435271, 2.224005020283655],
            [4.144234894882241, 2.233676545266376],
            [4.146238503075853, 2.237371308259474],
            [4.155185772813481, 2.2466806213374655],
            [4.162499921026281, 2.2557296731943026],
            [4.170202496920192, 2.26257773944867],
            [4.177974893940738, 2.2831318871455775],
            [4.183512205151032, 2.29016308468992],
            [4.190257848977187, 2.294687969496239],
            [4.194439656883834, 2.2997985715023948],
            [4.200003791482125, 2.3128046504818167],
            [4.202567731910163, 2.3169176661403528],
            [4.2104274881967925, 2.324953692895555],
            [4.219971533855841, 2.3295137272754327],
            [4.224485298713068, 2.3331633907944056],
            [4.231922210302362, 2.3371940419954647],
            [4.236159646881291, 2.3433007932723613],
            [4.237386599130346, 2.3548669382968592],
            [4.242595759699075, 2.3729924579819652],
            [4.242570353519462, 2.3772194840426764],
            [4.236801181242215, 2.3986337158223847],
            [4.2386234988086375, 2.4058308363828718],
            [4.242333049773328, 2.414545636346473],
            [4.24448474009225, 2.4260064702947384],
            [4.244266626914983, 2.438891657322124],
            [4.245734192218061, 2.4545284324148344],
            [4.2418233301609956, 2.481585163854919],
            [4.238797379808773, 2.49001823352292],
            [4.2494992176029145, 2.4905942509194605],
            [4.292709612291484, 2.4920892018583185],
            [4.361178372849556, 2.495113960104168],
            [4.36512171025997, 2.4071505064195122],
            [4.366583189194753, 2.3786470350382225],
            [4.371707878376782, 2.2640369465932535],
            [4.37293749011171, 2.238247010252241],
            [4.377766816355193, 2.1432863031555596],
            [4.378355915960824, 2.1218413002870045],
            [4.381776001128428, 2.0592705645661025],
            [4.302860528913767, 2.0579382128671724],
            [4.295524031845271, 2.05807635115779],
            [4.288331987791819, 2.0562242533582324],
            [4.207095467420428, 2.049103722262458],
            [4.134423332680852, 2.047335158738058],
            [4.12103631199835, 2.0471241252570898],
            [4.09172259690878, 2.045933613544608],
            [4.084309736539562, 2.045920643432216]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.92512501051421,
          "lat": 40.818022672822885
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17071"],
        "coty_name": ["Henderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henderson County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00424237"
      },
      "bbox": [
        4.084309736539562, 2.045920643432216, 4.381776001128428,
        2.495113960104168
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.790842922424336, -0.30121367668702204],
            [5.783344694629693, -0.17636668405021175],
            [5.777346058682481, -0.08927383683793824],
            [5.774340242883035, -0.03817964114618495],
            [5.831731130798032, -0.03364271766770883],
            [5.860345838512068, -0.03182851748843439],
            [5.945733182898017, -0.022464538646485555],
            [6.0322978916052685, -0.017166302092787196],
            [6.092647164025453, -0.012910937791386915],
            [6.118645310781721, -0.011441131902142016],
            [6.12394634029571, -0.08520769112407359],
            [6.125739879397052, -0.11523937006372932],
            [6.128041076818709, -0.1445747718963204],
            [6.130560308376414, -0.1890184182726199],
            [6.130320092330482, -0.18921920281082158],
            [6.13289929513208, -0.23138664731848121],
            [6.135507821529954, -0.27624791957237904],
            [6.1413621345023515, -0.3638826467345582],
            [6.054962426943969, -0.36929176691792465],
            [6.026194410999935, -0.3712197256133614],
            [6.007927773766452, -0.3730706236148592],
            [5.965700813020188, -0.37689057563022815],
            [5.88043994476494, -0.383624631525651],
            [5.869485732224174, -0.3847543855856624],
            [5.811212144139703, -0.3889647497435944],
            [5.7954891166471585, -0.3898110209661446],
            [5.790842922424336, -0.30121367668702204]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.92398874910447, "lat": 38.30052855555015 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17081"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00424242"
      },
      "bbox": [
        5.774340242883035, -0.3898110209661446, 6.1413621345023515,
        -0.011441131902142016
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.633282061426577, 2.7058661130763895],
            [8.690064284606962, 2.7133926286113534],
            [8.71912998441925, 2.71769553868653],
            [8.77648742716548, 2.7253960876367587],
            [8.83437576079923, 2.7341620870248127],
            [8.849317783453042, 2.6123611019309765],
            [8.853334941486303, 2.576912716887059],
            [8.857916147175795, 2.539713715124469],
            [8.867986504552894, 2.4545318462390804],
            [8.876235179403063, 2.3836458653536288],
            [8.777409340427864, 2.370453286203971],
            [8.72885714464392, 2.363609583537374],
            [8.72368329680959, 2.3626029370540427],
            [8.67775101668006, 2.356423604399047],
            [8.66622359276852, 2.4436376182882458],
            [8.666936446505565, 2.44372597208454],
            [8.663179201017307, 2.4750502294909693],
            [8.656147479518582, 2.5313332587475115],
            [8.655622352302492, 2.5312706358275534],
            [8.648541328685221, 2.5890669346701776],
            [8.644415346466438, 2.6196594524989676],
            [8.633282061426577, 2.7058661130763895]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.93666240642257, "lat": 40.7456726658578 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00450401"
      },
      "bbox": [
        8.633282061426577, 2.356423604399047, 8.876235179403063,
        2.7341620870248127
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.81641469217946, 0.727031263647229],
            [8.81821792755973, 0.7823283484027652],
            [8.818353147402279, 0.7974842691188193],
            [8.81942556707709, 0.8315727969810577],
            [8.821545363168086, 0.9290303738778157],
            [8.823429117563807, 1.006483380099375],
            [8.826006320930107, 1.0931137783358786],
            [8.874006221601421, 1.098230535849338],
            [8.930206714687603, 1.1039146540204243],
            [8.94766734268647, 1.1061018259680258],
            [8.994647225701415, 1.111092509168205],
            [9.013619605957546, 1.112922169767891],
            [9.015157000370605, 1.1005689213958665],
            [9.019186863841234, 1.0622423474695384],
            [9.021935883726517, 1.0380167100807187],
            [9.030717426452515, 0.9658903697445564],
            [9.031743517890735, 0.9553111558131855],
            [9.036739570403844, 0.91269942906734],
            [9.027958583696153, 0.9065890821458579],
            [9.019694462060707, 0.8969445515262958],
            [9.016337722807435, 0.8909917584444157],
            [9.009028988567831, 0.8816402316959966],
            [9.00036070678087, 0.8744503220811698],
            [8.994739975490626, 0.8716550025525747],
            [8.988892289909252, 0.86731493387318],
            [8.983800691680253, 0.8576688443533016],
            [8.984432732405807, 0.8535044286572327],
            [8.99474923288385, 0.8386453983153123],
            [9.001781401790218, 0.8334808578657289],
            [8.994435824786985, 0.8241543303712379],
            [8.988397385601866, 0.8133742842650729],
            [8.976720983629766, 0.8176607142889033],
            [8.972178152558538, 0.8125768896817351],
            [8.966813908418752, 0.8118370716974627],
            [8.965755331490957, 0.8081312721946324],
            [8.961888769955475, 0.8030114822705074],
            [8.954355619867991, 0.8039766619981427],
            [8.952255409878564, 0.8019301915283837],
            [8.952768355395031, 0.7969100613906687],
            [8.948809750735158, 0.7934615106864469],
            [8.94762019699084, 0.789824139508701],
            [8.942485823211133, 0.7888946213074185],
            [8.939346173719333, 0.7917859621063527],
            [8.935798786725766, 0.7859203966420011],
            [8.92674113951202, 0.7891227496536503],
            [8.923855918706142, 0.7871331873700397],
            [8.918343633219022, 0.7864002653443807],
            [8.91405768490974, 0.7878765996270736],
            [8.911731535298365, 0.7780686840889769],
            [8.912949812055254, 0.7694888881894884],
            [8.909247019333435, 0.7681083218699737],
            [8.90153696272492, 0.7715192750742961],
            [8.89762876044836, 0.770533179871714],
            [8.895856586034308, 0.7630729872378508],
            [8.88649642377785, 0.7638519171608181],
            [8.881508819754448, 0.760021027514709],
            [8.879458157120098, 0.7555517029963672],
            [8.876445342630022, 0.7531104662801036],
            [8.877106815641506, 0.7497457713427027],
            [8.880918048982613, 0.7466510739621895],
            [8.880284459411753, 0.7426943825739188],
            [8.874289875524518, 0.7454207226612067],
            [8.87210840062758, 0.7436561869528979],
            [8.87289708110484, 0.7344694976123389],
            [8.866609342452687, 0.7348129361501394],
            [8.86750795444116, 0.738637442283033],
            [8.86303217892787, 0.7402129330886684],
            [8.863262368226996, 0.7338907301447152],
            [8.85897559648025, 0.732256524959107],
            [8.856345214077386, 0.7351613643314757],
            [8.85293588767523, 0.7343696431159591],
            [8.850034759383043, 0.7254790433159275],
            [8.846808162006862, 0.722479029969908],
            [8.844685152331875, 0.7175310983578791],
            [8.84023928499931, 0.7217660017539022],
            [8.8359828036114, 0.7204599271233838],
            [8.832163800307463, 0.7167390174662447],
            [8.828186088849492, 0.7173486104790147],
            [8.825733746009702, 0.7244130714961214],
            [8.82683191823359, 0.7284701346196475],
            [8.830045418830576, 0.7325164576367234],
            [8.828475086122696, 0.7370552506794386],
            [8.822771312485772, 0.7341170058750058],
            [8.821862258219408, 0.7305929230011341],
            [8.81641469217946, 0.727031263647229]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.97324870216836, "lat": 39.14525496238029 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18029"],
        "coty_name": ["Dearborn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dearborn County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00450344"
      },
      "bbox": [
        8.81641469217946, 0.7167390174662447, 9.036739570403844,
        1.112922169767891
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.19957524506443, 2.742786692840804],
            [8.257069136487113, 2.749856665237347],
            [8.313899761766924, 2.7572936062127322],
            [8.341857578648808, 2.761444686418066],
            [8.42850734134165, 2.7711613752318454],
            [8.435136456186935, 2.712236075520575],
            [8.438173797256168, 2.6828832832680614],
            [8.445080554141532, 2.625705272424512],
            [8.449432624153534, 2.5865664812106215],
            [8.458682530997706, 2.507720836749907],
            [8.468853124136302, 2.420016774774395],
            [8.46186352535035, 2.4196236525416692],
            [8.423924449386938, 2.41453767602741],
            [8.421393043527917, 2.4139612746747923],
            [8.383613454655297, 2.4096542260267886],
            [8.298832205913506, 2.3998432008068575],
            [8.241797583271266, 2.3935181077121137],
            [8.236292907462802, 2.4370365199583244],
            [8.229124798668234, 2.4979279378831794],
            [8.229085601961355, 2.4993548663849783],
            [8.217966099059245, 2.588339324150201],
            [8.218441457132702, 2.590240830515305],
            [8.210563811978682, 2.655260247832877],
            [8.210292652839263, 2.65523061124473],
            [8.201193655441827, 2.7288620715337406],
            [8.19957524506443, 2.742786692840804]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.48813253971812,
          "lat": 40.829212940033734
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18069"],
        "coty_name": ["Huntington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Huntington County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00450361"
      },
      "bbox": [
        8.19957524506443, 2.3935181077121137, 8.468853124136302,
        2.7711613752318454
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.581240243737351, 0.6647971739774563],
            [8.653571667091319, 0.6735837628593774],
            [8.733735926672015, 0.6829853859094395],
            [8.766262225071568, 0.6864844459427841],
            [8.775901920452034, 0.604223227630728],
            [8.777026834422848, 0.5892589746529997],
            [8.77934954665698, 0.5692546937189411],
            [8.782823775356837, 0.5426725090157907],
            [8.791282569538376, 0.475905334041177],
            [8.79307381987081, 0.4631823078538861],
            [8.783504660421865, 0.46655605963512453],
            [8.776833190948764, 0.4713964105008926],
            [8.772351334183186, 0.47587574268196803],
            [8.76416530144046, 0.48727599045238196],
            [8.753823557292787, 0.5001431177811305],
            [8.743596028649213, 0.5050269525665423],
            [8.73599392904635, 0.506598281030519],
            [8.719801085914984, 0.5069913671395223],
            [8.707567512668103, 0.5047838901522975],
            [8.686859267054123, 0.4970168881381038],
            [8.675122425859763, 0.49173352707050705],
            [8.662843830608868, 0.4884883912316052],
            [8.657433965376187, 0.48786245840773734],
            [8.63722144001281, 0.49085154870641956],
            [8.627528751878206, 0.49130268503870994],
            [8.620569321057657, 0.48887648590508476],
            [8.608489759520745, 0.4803860455976866],
            [8.60487066332852, 0.47121045682202267],
            [8.599679730326722, 0.462586332100511],
            [8.59842564119492, 0.45864995963989563],
            [8.596832773224119, 0.44227619330633033],
            [8.59894372372001, 0.432187198636665],
            [8.608486332689893, 0.4210520644504535],
            [8.614358440781313, 0.410771053742222],
            [8.616297058207465, 0.4003997554615694],
            [8.616436824988911, 0.38711499992530085],
            [8.618954583371886, 0.3626929485966667],
            [8.623059260754394, 0.34983825581576533],
            [8.630336333411842, 0.33842030979709786],
            [8.61919340244813, 0.33682979953559394],
            [8.591758560901631, 0.3339448353754753],
            [8.591107622882136, 0.34022834029486315],
            [8.577475289554673, 0.33849695157105786],
            [8.57569411992687, 0.35304666191454703],
            [8.519364650492701, 0.3462280601255615],
            [8.51064222601675, 0.41871207973035646],
            [8.48197340647578, 0.4158488557796542],
            [8.478390236139028, 0.44503285746803567],
            [8.449885395192785, 0.44207212394968676],
            [8.44713583858757, 0.4639557759356255],
            [8.433251112532787, 0.4626000821285987],
            [8.432434497337265, 0.46948874982509886],
            [8.417875052277774, 0.4677412543188904],
            [8.40902533601541, 0.5439890554937599],
            [8.408884748489466, 0.5466682237172232],
            [8.407782976021656, 0.5551475550325159],
            [8.442747013819575, 0.5592796398297958],
            [8.443498818157627, 0.5526736229205662],
            [8.450824347471308, 0.5534615424042126],
            [8.450109583177078, 0.5600421581240407],
            [8.464096773347517, 0.5616855091332568],
            [8.460535112577011, 0.5912804619143218],
            [8.489074855857977, 0.59439367277845],
            [8.485855807296952, 0.6234072304854196],
            [8.513716959530534, 0.6266050284473871],
            [8.509862664970882, 0.6560802025391782],
            [8.581240243737351, 0.6647971739774563]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.43854738408417,
          "lat": 38.785780784453536
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18077"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00450363"
      },
      "bbox": [
        8.407782976021656, 0.3339448353754753, 8.79307381987081,
        0.6864844459427841
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.755997958770866, 3.072941189770175],
            [6.748327145274226, 3.161732465804101],
            [6.745881545319041, 3.188579114565485],
            [6.738721428503893, 3.273020664860563],
            [6.735776846418827, 3.311573963954939],
            [6.737731271311508, 3.313482363574333],
            [6.742916250141927, 3.308422644197476],
            [6.742304801029502, 3.3052929626006704],
            [6.7489849376515165, 3.2984069121933297],
            [6.756588838282295, 3.293081479304597],
            [6.766829883804036, 3.2893787766628995],
            [6.769086391880185, 3.2853929391488146],
            [6.771870054467458, 3.2859951881319365],
            [6.774080138381033, 3.2815952310351064],
            [6.780458508020372, 3.2793381946839175],
            [6.7838954215270695, 3.285449446306711],
            [6.7927583501822015, 3.2923138782258117],
            [6.795142996389102, 3.291546974041276],
            [6.7992465395996335, 3.281105847453444],
            [6.7995160204779355, 3.2764053287775714],
            [6.803307723769386, 3.2734474505110334],
            [6.80622761486523, 3.2773277226232604],
            [6.804000091033753, 3.280324472666298],
            [6.8009346317082136, 3.288957209318738],
            [6.810706607120183, 3.299880294118812],
            [6.8175667194093155, 3.2985913523334123],
            [6.8241098412033505, 3.2911910800793196],
            [6.819673443756357, 3.286223460315446],
            [6.824420759444245, 3.2811341166977117],
            [6.8162314338579995, 3.269516439597625],
            [6.804898673188907, 3.264092577059751],
            [6.811038726990966, 3.2554308331097954],
            [6.818197992289621, 3.251002797635616],
            [6.821192011608757, 3.251164331095499],
            [6.824768110996771, 3.254307924582929],
            [6.832440010508896, 3.2505871984867203],
            [6.857540099770476, 3.2434857300005833],
            [6.873711657951037, 3.241464652262215],
            [6.888256592839012, 3.241139158074282],
            [6.8952235019018655, 3.240424264785693],
            [6.895502435158318, 3.237992906738203],
            [6.900326163554862, 3.2379462613854364],
            [6.9047080214636525, 3.2399526892605905],
            [6.9061060091820945, 3.237265194032946],
            [6.910138426582798, 3.2372295702678686],
            [6.910676099276051, 3.241501682426653],
            [6.913802989810867, 3.242196534184167],
            [6.917561354535517, 3.239681311718722],
            [6.9255133152231085, 3.239703287294897],
            [6.937629048512612, 3.2411994066792302],
            [6.9660949396686425, 3.2475106975367374],
            [6.972227053498277, 3.1883570635983305],
            [6.978790555717495, 3.130345816592732],
            [6.985948187467572, 3.057777620020741],
            [6.989274958682779, 3.0195753553025644],
            [6.990657327733094, 3.0067456056340935],
            [6.993961213849371, 2.970302247542575],
            [6.994888667714273, 2.9562402608946914],
            [7.00269152948161, 2.8838604635848464],
            [7.004420888418732, 2.8648157043089175],
            [6.999448793371056, 2.8577632902732693],
            [6.964234125089441, 2.8374165663395154],
            [6.957229964402667, 2.8333422995544466],
            [6.948654113694745, 2.822659585171295],
            [6.931011897880741, 2.801618576825336],
            [6.926206607904652, 2.7979286575083133],
            [6.915262947928165, 2.796291785779272],
            [6.902667976734512, 2.789490224931306],
            [6.8903449780289385, 2.7840675882409602],
            [6.881701999656232, 2.7734713701600047],
            [6.8664772033851005, 2.771509863349997],
            [6.861135610326867, 2.774305733431411],
            [6.845069086844347, 2.7806816907584135],
            [6.840136747286731, 2.781240002760846],
            [6.833255205602689, 2.776965326970323],
            [6.8133995964673515, 2.774468133077119],
            [6.78264483883945, 2.767877709754131],
            [6.770695267892451, 2.9002053432774897],
            [6.766141082082156, 2.953199646067215],
            [6.758140814457939, 3.0483636376870322],
            [6.755997958770866, 3.072941189770175]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.3821295667443, "lat": 41.41671233619459 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18089"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00450495"
      },
      "bbox": [
        6.735776846418827, 2.767877709754131, 7.004420888418732,
        3.313482363574333
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.4634629898256435, 0.5399104630852807],
            [7.547702654864945, 0.5482110628874067],
            [7.63325445123059, 0.5569083784080235],
            [7.637258352379671, 0.5132113587483049],
            [7.645863399111164, 0.4243872214822432],
            [7.65092914088021, 0.3731047382676034],
            [7.654619916666204, 0.33769945495640386],
            [7.658940141024979, 0.29410183252932404],
            [7.661336032135845, 0.27294134793423147],
            [7.671022980528244, 0.17678810112612853],
            [7.585628201741423, 0.16805420925187764],
            [7.551415660408601, 0.16521452370772557],
            [7.552813724699678, 0.16203440911611472],
            [7.547332354302876, 0.15335823882338448],
            [7.539034553672842, 0.14640618606338102],
            [7.528692778902502, 0.14279359023226662],
            [7.523894399892404, 0.13703088539172167],
            [7.522510959275563, 0.1304214783808203],
            [7.5149962304051225, 0.12976441485459414],
            [7.511613061069892, 0.13075995624074005],
            [7.505192534904338, 0.13521827831474392],
            [7.5008494799788625, 0.13395429493364028],
            [7.49617200167754, 0.12895084258731776],
            [7.492026163106254, 0.1295890729416786],
            [7.488688560338423, 0.13224347030525543],
            [7.4865678031526235, 0.13755863595528445],
            [7.477890213293598, 0.2309718815220477],
            [7.4714795508521625, 0.297695284426155],
            [7.461523074418218, 0.40863475634053986],
            [7.457496333011996, 0.4511298025738618],
            [7.471846426259571, 0.45278276704225373],
            [7.4634629898256435, 0.5399104630852807]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.8030753842312, "lat": 38.708023131908455 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18101"],
        "coty_name": ["Martin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Martin County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00451679"
      },
      "bbox": [
        7.457496333011996, 0.12895084258731776, 7.671022980528244,
        0.5569083784080235
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.642733249962099, 1.7802840167774332],
            [8.699099525815171, 1.7864143543718396],
            [8.754298882672758, 1.793388719704809],
            [8.825659691156599, 1.8021523381122881],
            [8.875121310425818, 1.8078209226079565],
            [8.875226461396055, 1.8090468693427242],
            [8.93712545847927, 1.8150390718932738],
            [8.938070236313457, 1.8052500214340235],
            [8.946459797028396, 1.7265932295140503],
            [8.957352524919775, 1.6230171017983566],
            [8.967524278580326, 1.535764437213562],
            [8.881745733990883, 1.5257053157081761],
            [8.850097146888922, 1.5221673978121777],
            [8.850152726753587, 1.5243812014952782],
            [8.800693522826716, 1.518926767081061],
            [8.802251759526927, 1.5043802945287137],
            [8.736998499686479, 1.497120996287388],
            [8.733805881859462, 1.4966119545547931],
            [8.68820720182215, 1.4920227236201726],
            [8.68486082594532, 1.5211935679820983],
            [8.683770576675956, 1.5359270048250235],
            [8.681078040660331, 1.565220969974025],
            [8.65259529541045, 1.5620251236224576],
            [8.647633064491334, 1.6059452045573597],
            [8.643167202695322, 1.647388446526292],
            [8.658088642691313, 1.6493153324830754],
            [8.650015992167537, 1.722839782600414],
            [8.642733249962099, 1.7802840167774332]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.00989270180337, "lat": 39.86438642073384 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18177"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00450336"
      },
      "bbox": [
        8.642733249962099, 1.4920227236201726, 8.967524278580326,
        1.8150390718932738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.2500376444621635, 2.5545019677552663],
            [7.365587171704705, 2.565687924353742],
            [7.42461447773587, 2.5712208819815863],
            [7.510664851885906, 2.5783938882676263],
            [7.520101763383389, 2.4921460208015502],
            [7.526282051845171, 2.4211524928786026],
            [7.527986536013801, 2.40276420828121],
            [7.45593101973414, 2.3966429970687617],
            [7.403681241376561, 2.3923234672074054],
            [7.400368431838224, 2.3882804489611926],
            [7.397604520000644, 2.3810936557120597],
            [7.398869746906644, 2.375721148825462],
            [7.405828686577955, 2.3727396214122023],
            [7.404218370308434, 2.3694690215313803],
            [7.4007053726822205, 2.3676714352265376],
            [7.398190572509499, 2.3641092911634525],
            [7.397383259898943, 2.3515988105401266],
            [7.401791516738634, 2.349303685527989],
            [7.4046597933189595, 2.3410566310575533],
            [7.403292683953492, 2.3373348020848614],
            [7.3994002398664795, 2.3358932431847417],
            [7.399019703050211, 2.3322220712076347],
            [7.401517238358011, 2.3307906491560084],
            [7.41327672799248, 2.333345209490519],
            [7.4115815411346375, 2.329387592083804],
            [7.404530938872683, 2.324794272257435],
            [7.402975875031414, 2.318078063764413],
            [7.3910780488758085, 2.316660234141909],
            [7.392811226649533, 2.3018070857255712],
            [7.393759798931311, 2.300945514851888],
            [7.39826291959455, 2.261230654273128],
            [7.398167820420725, 2.2602745527281547],
            [7.403245400752218, 2.2146095821524656],
            [7.368839160257303, 2.2112802247148013],
            [7.330047737034315, 2.20710166022551],
            [7.28810820786862, 2.2029964703637],
            [7.245633105819377, 2.1993502401774268],
            [7.230230057789228, 2.1982150936494285],
            [7.160215933591472, 2.1921956414675563],
            [7.150583543895126, 2.279017210443784],
            [7.143868227582023, 2.351251297021446],
            [7.14274157123361, 2.366283413197769],
            [7.141561673962731, 2.366224286084785],
            [7.138599394224817, 2.3953342684212595],
            [7.13679681606062, 2.409863631175487],
            [7.1309813506145225, 2.467516432551886],
            [7.215613702945751, 2.475826196725699],
            [7.2139372752698145, 2.49028421588613],
            [7.20777670374364, 2.550229892203051],
            [7.2500376444621635, 2.5545019677552663]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.86547431854599, "lat": 40.74976492024275 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18181"],
        "coty_name": ["White"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["White County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "00450338"
      },
      "bbox": [
        7.1309813506145225, 2.1921956414675563, 7.527986536013801,
        2.5783938882676263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6395700023191737, 3.918926327170926],
            [2.6979057653044536, 3.9205307795485016],
            [2.72668819307375, 3.921086683961139],
            [2.7694037300127827, 3.9222245083979517],
            [2.8125175743901347, 3.9235707125718955],
            [2.933558708617365, 3.9277018812692397],
            [2.9854155326914817, 3.9296212636142442],
            [2.988539848183869, 3.8430731588166633],
            [3.0034193268922307, 3.8436041610517035],
            [3.006671679371617, 3.757727035034881],
            [3.010124087896604, 3.6703790195407535],
            [2.981646848058113, 3.6692272190404474],
            [2.866872771554983, 3.6651145483783063],
            [2.8378881752972602, 3.6639968971201924],
            [2.841311285030106, 3.5771102714738694],
            [2.7664137586226305, 3.5745366276473187],
            [2.669133285081441, 3.5705976762550846],
            [2.6665765801752843, 3.6433396395223476],
            [2.664107182898671, 3.7157240552095674],
            [2.659934863059436, 3.832998167254557],
            [2.642193678443374, 3.8325806890488407],
            [2.6406077277332844, 3.8908147921505645],
            [2.6395700023191737, 3.918926327170926]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.79143133110304, "lat": 42.40185728360021 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19075"],
        "coty_name": ["Grundy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grundy County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00465226"
      },
      "bbox": [
        2.6395700023191737, 3.5705976762550846, 3.010124087896604,
        3.9296212636142442
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3916752071884484, 3.193264327710816],
            [1.477537345223931, 3.194820060331184],
            [1.5631090834344026, 3.1965967557830646],
            [1.6779579753610823, 3.1982735257790798],
            [1.7350713625591352, 3.1992389640066783],
            [1.7363624285806183, 3.1123117721083635],
            [1.7381394925105085, 3.0235542075439],
            [1.7393422586280922, 2.980670211351938],
            [1.740051329591803, 2.936018060859367],
            [1.7687731429052889, 2.9361998227544506],
            [1.7702009374523904, 2.856577374740779],
            [1.7704110695179693, 2.8382958569672057],
            [1.6990415682656754, 2.8369746914510694],
            [1.5679221840441044, 2.835014924367145],
            [1.5571782665788487, 2.8346184471908535],
            [1.5145770466935515, 2.8342916075000124],
            [1.429320284927833, 2.8332873748953866],
            [1.4278836405335829, 2.9319435382776664],
            [1.3956357349837683, 2.9315116266055723],
            [1.3948580742492833, 2.997010565114163],
            [1.3941889141487762, 3.0331287150045743],
            [1.3938333160884646, 3.076798042540552],
            [1.392913533647194, 3.1360073311998056],
            [1.3916752071884484, 3.193264327710816]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.50104604090095, "lat": 41.68374427863234 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19077"],
        "coty_name": ["Guthrie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Guthrie County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00465227"
      },
      "bbox": [
        1.3916752071884484, 2.8332873748953866, 1.7704110695179693,
        3.1992389640066783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4242422192439523, 3.2151724839055524],
            [2.5100367570277697, 3.2172202544828243],
            [2.5955130872407652, 3.219698129058899],
            [2.681547985008007, 3.222181838681941],
            [2.7676867083196637, 3.2248547584449527],
            [2.8543024680362348, 3.227737017223491],
            [2.8541673505576397, 3.2210887642982233],
            [2.855008248228818, 3.2065798310841935],
            [2.8567442304635784, 3.1555072026268176],
            [2.858991163032205, 3.0817884182084843],
            [2.862685083499931, 2.9652821378457763],
            [2.8698707350317827, 2.9655831016906116],
            [2.873470488523108, 2.872442041064077],
            [2.788137078825251, 2.869310106809241],
            [2.716751162133044, 2.866690313274983],
            [2.674094203645295, 2.8655387884145096],
            [2.6104198037599557, 2.8634614270312797],
            [2.553074863965379, 2.861476243225194],
            [2.4760203248247845, 2.8592597568019147],
            [2.448579605286028, 2.8582563449140945],
            [2.447617905961989, 2.884896504250388],
            [2.4458869854146466, 2.9521400875408577],
            [2.431054825984033, 2.951575214905997],
            [2.429373572045682, 3.0170028990285562],
            [2.427234739559599, 3.097888153498282],
            [2.4242422192439523, 3.2151724839055524]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.05375797705283,
          "lat": 41.686035787421034
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19099"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00465238"
      },
      "bbox": [
        2.4242422192439523, 2.8582563449140945, 2.873470488523108,
        3.227737017223491
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.3156080746021064, 2.540124596464166],
            [3.402613744665353, 2.5442096770174714],
            [3.4328929373291888, 2.5458266225280246],
            [3.476141160080879, 2.5478625973881543],
            [3.490460854868407, 2.5482883084928947],
            [3.554214507946517, 2.549144384988861],
            [3.5833504584715574, 2.5502758308779145],
            [3.6403702590181317, 2.553630603948108],
            [3.661731357439187, 2.555022400120106],
            [3.6629697830454826, 2.518713280780483],
            [3.6645679111618463, 2.47919947857366],
            [3.6660449364260823, 2.4324584153587634],
            [3.6674381248633297, 2.394098175545321],
            [3.6711024949242366, 2.3167248421008004],
            [3.6720208991020584, 2.2915650433235593],
            [3.6577696341779244, 2.2905694796174383],
            [3.559765302865745, 2.286772544044432],
            [3.499670835751723, 2.283771326292747],
            [3.4313976872837424, 2.27996337314011],
            [3.3915016479705287, 2.2781228751624845],
            [3.3269365743665493, 2.275479422338919],
            [3.323370412624581, 2.361366719745823],
            [3.320613059195301, 2.4227382673696414],
            [3.3186051026433616, 2.471225803244691],
            [3.3156080746021064, 2.540124596464166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.94890472339847, "lat": 41.03177575676519 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19101"],
        "coty_name": ["Jefferson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00465239"
      },
      "bbox": [
        3.3156080746021064, 2.275479422338919, 3.6720208991020584,
        2.555022400120106
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.675541753099908, 2.203418554563913],
            [3.740583656023861, 2.206738035523951],
            [3.762373055466204, 2.2077316298911454],
            [3.8422107249760415, 2.2108534671835898],
            [3.9074634157207986, 2.2135979850097334],
            [3.9099781065800907, 2.2094860251935735],
            [3.9196078602510425, 2.209860303523026],
            [3.9270785025237678, 2.2029351473968584],
            [3.934769396546083, 2.19986248564512],
            [3.942723891467506, 2.1928704598845346],
            [3.9468725166176943, 2.1937045832605557],
            [3.9509617276392213, 2.1963643258550047],
            [3.953616457035174, 2.194535748562892],
            [3.955707530382275, 2.1892753075791913],
            [3.9648466510873877, 2.1878889896744464],
            [3.971684699133607, 2.1843170787391863],
            [3.9770172491793025, 2.1837107788026215],
            [3.9812220754005185, 2.177202924027961],
            [3.9843739962134013, 2.175811563383208],
            [3.9933110804291827, 2.177614412989692],
            [3.9964734233325756, 2.1772613914075203],
            [4.001752767760729, 2.171462665158863],
            [4.00311977467163, 2.1644538965217186],
            [4.005142354819462, 2.1594352194213258],
            [4.009634716676668, 2.1580337127818088],
            [4.012775068084095, 2.1596974242185194],
            [4.019498335758706, 2.159859616879911],
            [4.027217096949974, 2.156628101460972],
            [4.031428160007985, 2.1566235977436494],
            [4.034418687834373, 2.1547569932361172],
            [4.043198979378224, 2.14423984986276],
            [4.048134387962288, 2.1412613567117957],
            [4.0557192721284325, 2.139561851764313],
            [4.063928648321582, 2.1281430618933705],
            [4.062046954888263, 2.1230588158631396],
            [4.065936688994585, 2.1224577417606074],
            [4.068615799233436, 2.1264985190341865],
            [4.073481310196939, 2.1260914637774366],
            [4.074937395790973, 2.1223312117764204],
            [4.078004359400425, 2.1212209016210943],
            [4.082893090746766, 2.1165265299182323],
            [4.085776662098756, 2.117582067286506],
            [4.083811656285431, 2.1216302120824424],
            [4.08641296087215, 2.1290939708280923],
            [4.0886341035634075, 2.1306327198906523],
            [4.094193724655653, 2.1290210303221913],
            [4.097777698632404, 2.1316597907053487],
            [4.098508260653179, 2.12634824257389],
            [4.104551958791117, 2.119867287191713],
            [4.1069463676481375, 2.1158354915319046],
            [4.110047755301277, 2.1162622833600295],
            [4.116100651410233, 2.1107554787127447],
            [4.122443912982506, 2.108497603694234],
            [4.128996368659133, 2.110700792761463],
            [4.1361362015895065, 2.1073149628120156],
            [4.1341347773616635, 2.102717109050243],
            [4.131787636040168, 2.0865157132526013],
            [4.12891024619697, 2.0795653723135508],
            [4.118726710391077, 2.070707770751126],
            [4.106905408538102, 2.0627390535359384],
            [4.084309736539562, 2.045920643432216],
            [4.075034625240085, 2.0434693700817497],
            [4.059489671436956, 2.0450371419792805],
            [4.0373911180382365, 2.0438811410204414],
            [4.0296646591090335, 2.0417612290973297],
            [4.024766835626171, 2.0387122216026756],
            [4.016417041608666, 2.036628317789383],
            [3.993910082530558, 2.0294483610421215],
            [3.9695927416393144, 2.0153904298588143],
            [3.9630042371591805, 2.0112394657146817],
            [3.9550183951657454, 2.0028858759955313],
            [3.945151000258118, 1.9830113276057721],
            [3.941413867160648, 1.9746137868163427],
            [3.92580183187083, 1.9587248647939608],
            [3.923208832506954, 1.9537375307748188],
            [3.9223427840159992, 1.9465455745070228],
            [3.9230679082586213, 1.9416762559785647],
            [3.927477438830388, 1.9359253253061663],
            [3.937184788530084, 1.932641009838122],
            [3.942094384584493, 1.9280122798639872],
            [3.952498239809534, 1.9126560751075918],
            [3.95676188211554, 1.9002574164496622],
            [3.9574462839613633, 1.8944038273325654],
            [3.9570125286965316, 1.8842448742246234],
            [3.9551017513382547, 1.8745356643557671],
            [3.9484122163750053, 1.855789157872902],
            [3.946359390962393, 1.8417190603541709],
            [3.947316115376866, 1.8345375425243633],
            [3.953634274956202, 1.8171743004673926],
            [3.954907338966572, 1.8107590989581506],
            [3.955333435549446, 1.8004067297071593],
            [3.953384187886528, 1.7909017024707323],
            [3.9489081643422295, 1.7863963677135337],
            [3.944212728908203, 1.7834394434163072],
            [3.9377881253584657, 1.7813086670279992],
            [3.9257518178226762, 1.779868453965433],
            [3.921111935953661, 1.7755932379598092],
            [3.9162005226508985, 1.779624036456325],
            [3.9042677981847436, 1.782850484781163],
            [3.9014912057071918, 1.7788871139981073],
            [3.9014866218560944, 1.775784553335232],
            [3.896930915630054, 1.772165148397407],
            [3.8876951854729063, 1.7713601997667978],
            [3.886059514767228, 1.7740139551441778],
            [3.8879606843159227, 1.779834844645438],
            [3.886312401130293, 1.7809837519218508],
            [3.8812597363320496, 1.7783471657451235],
            [3.8750649318131196, 1.77694073043207],
            [3.871753660154106, 1.7789204652030752],
            [3.8664156319661336, 1.788342180197429],
            [3.868292381557571, 1.7989119258143642],
            [3.8606463922522822, 1.7965908332503333],
            [3.855157891968972, 1.7979320546229158],
            [3.852144101178338, 1.8010835029967434],
            [3.840231621978402, 1.8045492653993627],
            [3.8387395331947665, 1.8071429865671462],
            [3.838334518812353, 1.8136531072948479],
            [3.8434771962229637, 1.825429392973121],
            [3.842668651780519, 1.827788692196234],
            [3.835708850782304, 1.8280655424854146],
            [3.8328201083749236, 1.8304653738899601],
            [3.8320711580345272, 1.8344880618286206],
            [3.8388639273789926, 1.842512597479025],
            [3.838631426900556, 1.8504699451262594],
            [3.8349365210656288, 1.8529921029557745],
            [3.823536579354583, 1.8515955640740784],
            [3.8167974843846806, 1.8519056674532675],
            [3.8082903265207486, 1.853747841274658],
            [3.7998573772611044, 1.8580744772736197],
            [3.7953809775634255, 1.8632672549568672],
            [3.789703398140114, 1.8793729647444792],
            [3.7834963342668195, 1.8869213644860046],
            [3.7729425055600383, 1.8915228223100318],
            [3.7662449895061667, 1.8960118149549121],
            [3.7626830941048377, 1.9011746401062293],
            [3.7617247613479794, 1.9081631470639342],
            [3.763856777252536, 1.917593099797925],
            [3.7640725669407202, 1.9254187380163217],
            [3.7631068483342673, 1.9304749519073185],
            [3.7582645047702936, 1.9347086735600438],
            [3.748446579986162, 1.9363172023813007],
            [3.7360402173655247, 1.9394304476812305],
            [3.723432591278615, 1.9406191219610904],
            [3.715269242414726, 1.9423650172957234],
            [3.708115920008755, 1.9489613226873679],
            [3.7073220108618368, 1.9539449720892275],
            [3.7111655649304693, 1.9661465761671184],
            [3.7085330250204454, 1.972711736603016],
            [3.7026463284730093, 1.977227248007027],
            [3.690550352413172, 1.983641448552697],
            [3.6868244686837954, 1.9869891903301484],
            [3.686371433121753, 2.0026552365892796],
            [3.685160027657136, 2.0025723913135223],
            [3.6825112066820274, 2.0565339778652567],
            [3.6797517694771864, 2.1152876500253903],
            [3.675541753099908, 2.203418554563913]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.47928766339598, "lat": 40.64197458830353 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19111"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00465244"
      },
      "bbox": [
        3.675541753099908, 1.7713601997667978, 4.1361362015895065,
        2.2135979850097334
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.2874905950241473, 2.504871870702017],
            [2.3739509262662137, 2.506405227224328],
            [2.458957177457179, 2.508865493376293],
            [2.5446087857698383, 2.511426350301839],
            [2.5655380178794363, 2.512163623523738],
            [2.6296426783740374, 2.5140757914490135],
            [2.6328688314215016, 2.4269108971353663],
            [2.635653071380837, 2.3383896632740164],
            [2.638703030640453, 2.2526576928557946],
            [2.6389321000260266, 2.2498742401870273],
            [2.5530713790380317, 2.2469050263149435],
            [2.4667566487306223, 2.244255433355581],
            [2.4376172507152005, 2.243607737925887],
            [2.4169778018916466, 2.2426479788187783],
            [2.380815319244069, 2.24158644571348],
            [2.2950651480658695, 2.2400512091310105],
            [2.2932775759263286, 2.2986830535834084],
            [2.292476144670545, 2.339315035574347],
            [2.290122571791832, 2.4166988932130833],
            [2.2879139976380576, 2.4974169672633137],
            [2.2874905950241473, 2.504871870702017]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.32774148091679, "lat": 41.02935340819337 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19117"],
        "coty_name": ["Lucas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lucas County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00465247"
      },
      "bbox": [
        2.2874905950241473, 2.2400512091310105, 2.6389321000260266,
        2.5140757914490135
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.3043816371527672, 4.601498084235351],
            [3.302628713936746, 4.64421531961042],
            [3.2975918596230565, 4.781655251525771],
            [3.29436567667171, 4.859888466720592],
            [3.2933067699875656, 4.889504097755734],
            [3.3837824864700874, 4.893209302490908],
            [3.4749238024826288, 4.897218634162584],
            [3.545473051108448, 4.900301461291438],
            [3.616195735619868, 4.903246834796598],
            [3.63157949499294, 4.904158843781277],
            [3.6342896622328444, 4.849360805022542],
            [3.634712240331313, 4.835398636018396],
            [3.63878226865559, 4.745556781554236],
            [3.6438831927004305, 4.74575779410625],
            [3.644761474432961, 4.7189045182357034],
            [3.6473556116974684, 4.658431038287754],
            [3.6496948413446497, 4.615083047932997],
            [3.6516519779775813, 4.571789622381838],
            [3.6540053839963904, 4.506567607372157],
            [3.655031244465157, 4.485091970446816],
            [3.605886513749557, 4.483014998626969],
            [3.5679997012808924, 4.481248445082114],
            [3.4742358797526243, 4.477256444859836],
            [3.4247578185997747, 4.475534629961195],
            [3.423404521514958, 4.475640264835183],
            [3.3684347685611162, 4.473371921333511],
            [3.3096520168040198, 4.471167954341091],
            [3.3079379390968002, 4.5147300708244265],
            [3.3060475448083655, 4.557722308491409],
            [3.3043816371527672, 4.601498084235351]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.84370071491658,
          "lat": 43.290661904731735
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19191"],
        "coty_name": ["Winneshiek"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winneshiek County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "00465284"
      },
      "bbox": [
        3.2933067699875656, 4.471167954341091, 3.655031244465157,
        4.904158843781277
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8801656779398965, 0.03266546759844621],
            [-1.8016027578438447, 0.030269342016449822],
            [-1.738325373953894, 0.028262621399136743],
            [-1.6240383891676917, 0.024875836093248473],
            [-1.5379925427740087, 0.02264760220315195],
            [-1.4576491641159395, 0.02051468688774945],
            [-1.4528962139847459, 0.020428869925265273],
            [-1.4551645634189576, -0.06832415169164177],
            [-1.4578329953922862, -0.15628535855345327],
            [-1.4603337518297195, -0.2442691369758494],
            [-1.461429043387763, -0.28830623886604434],
            [-1.4627796823637318, -0.3714873275531813],
            [-1.4642950199586862, -0.41981069874838445],
            [-1.5014133635487001, -0.4185347044850419],
            [-1.5438586290281842, -0.4173621554418504],
            [-1.6360022001975405, -0.4150754474879918],
            [-1.7012739349199753, -0.41316713608993355],
            [-1.8006379994937207, -0.4099659179828256],
            [-1.8078321315227357, -0.4096046153310993],
            [-1.8936831461304073, -0.40691466777134655],
            [-1.890954120848836, -0.31899756765370413],
            [-1.8894085099491276, -0.24571442491873036],
            [-1.8883876256362977, -0.23150892254878458],
            [-1.8867945241127666, -0.17287697146327877],
            [-1.8856731662570176, -0.14350533549053932],
            [-1.8830941408703454, -0.05553080967884901],
            [-1.8813392423670434, -0.007903299148701729],
            [-1.8801656779398965, 0.03266546759844621]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.75645113687776,
          "lat": 38.478941284334745
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20009"],
        "coty_name": ["Barton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barton County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00484974"
      },
      "bbox": [
        -1.8936831461304073, -0.41981069874838445, -1.4528962139847459,
        0.03266546759844621
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.8220129959473037, -0.37042462255272746],
            [-2.6816719042621875, -0.3771926984393558],
            [-2.645914998674193, -0.37881640138198264],
            [-2.6367843016321233, -0.3789952000371292],
            [-2.608372653640174, -0.38034545845207735],
            [-2.548799941800913, -0.3828271894287067],
            [-2.5467161090218235, -0.3826797292705885],
            [-2.493907571675864, -0.38463891137101847],
            [-2.4827816099901336, -0.3851958686489952],
            [-2.4138773704230685, -0.38791809944099653],
            [-2.3939706227293738, -0.3884132162064849],
            [-2.3225239886783595, -0.39102009461900955],
            [-2.3118697200167664, -0.3914637324701123],
            [-2.3161980788535583, -0.5235670530229516],
            [-2.317750291819731, -0.5678419387462764],
            [-2.3217735579060594, -0.6707738046088098],
            [-2.324631466181476, -0.7437653433813793],
            [-2.3526268530770302, -0.7428910246377329],
            [-2.410288633364776, -0.7402072561255357],
            [-2.4966607002787393, -0.7371006390635225],
            [-2.546359212350365, -0.7347969737357977],
            [-2.582112625439766, -0.7333318423272204],
            [-2.66769249797266, -0.7301260592654075],
            [-2.7388377695916586, -0.7266707183946655],
            [-2.7806581178049945, -0.7244726224399626],
            [-2.8376105913316834, -0.7217013366049992],
            [-2.833330449606326, -0.6339590582949409],
            [-2.8285615055012614, -0.5460633420890842],
            [-2.825774633918424, -0.4799185390498367],
            [-2.8220129959473037, -0.37042462255272746]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.89792423110012,
          "lat": 38.087495674717196
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20083"],
        "coty_name": ["Hodgeman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hodgeman County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00485006"
      },
      "bbox": [
        -2.8376105913316834, -0.7437653433813793, -2.3118697200167664,
        -0.37042462255272746
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4371035353891615, 1.3381468572272863],
            [-1.3516574641372912, 1.3360291838558345],
            [-1.2622336008626902, 1.333940348971236],
            [-1.2440207419311118, 1.3332960084274887],
            [-1.201118714166523, 1.3326030259853543],
            [-1.1299265476541214, 1.3306047676203487],
            [-1.002560858719469, 1.3277252514661213],
            [-1.0029272915969263, 1.3135680052796128],
            [-1.0042822149104436, 1.239347961410652],
            [-1.0073531714392374, 1.1516059627497828],
            [-1.0084431000076064, 1.0640424862961249],
            [-1.00944301015406, 0.9763562895508494],
            [-1.0115007421325775, 0.8887305938707394],
            [-1.0975358144878025, 0.8907514629016694],
            [-1.1835083335797214, 0.8926498498125828],
            [-1.2377452505499444, 0.8941596115770694],
            [-1.3509454855066003, 0.8968948836191988],
            [-1.4356343273006935, 0.8991680664643313],
            [-1.4492829754138474, 0.8996386563802308],
            [-1.4468888135859832, 0.9768606141186005],
            [-1.4467515824394102, 0.9873332647649089],
            [-1.4439798261441146, 1.0749413869643913],
            [-1.4427199444155436, 1.1186614256202418],
            [-1.4425220197474236, 1.1314569034378676],
            [-1.4413654184234983, 1.1626265300084397],
            [-1.4394216205437385, 1.2503634178270857],
            [-1.4382729220390784, 1.2905344241501422],
            [-1.4371035353891615, 1.3381468572272863]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.21833590064246, "lat": 39.78472372349112 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20089"],
        "coty_name": ["Jewell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jewell County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00485009"
      },
      "bbox": [
        -1.4492829754138474, 0.8887305938707394, -1.002560858719469,
        1.3381468572272863
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4578329953922862, -0.15628535855345327],
            [-1.3807750546213502, -0.15819281606365793],
            [-1.371931726639046, -0.15852900962412994],
            [-1.2848508417761435, -0.16025899335549956],
            [-1.2418663602959936, -0.16134012686276783],
            [-1.0998163317363712, -0.16434754644637026],
            [-1.0988436406327315, -0.16419649792884147],
            [-1.0270592149715636, -0.16534570234472062],
            [-1.029165455718116, -0.2560276786904968],
            [-1.0307566570720779, -0.34188183418613594],
            [-1.033144389671063, -0.43010157550922357],
            [-1.0309996626249465, -0.43019145212541837],
            [-1.0309822429122835, -0.43725061787464287],
            [-1.0325345501410044, -0.517762634308362],
            [-1.0468059595613066, -0.5175029080286815],
            [-1.075533408743315, -0.5175096798192417],
            [-1.175592240684369, -0.514581330653076],
            [-1.2038627183755315, -0.5138918691650858],
            [-1.2041222712473083, -0.5284103062949378],
            [-1.2257035091355688, -0.5284135769273043],
            [-1.2615455215485571, -0.5278895087586939],
            [-1.261282384725892, -0.5129993968429929],
            [-1.275713327035193, -0.5129250946729069],
            [-1.289459724461382, -0.512318771783284],
            [-1.346746920659376, -0.5108782431904828],
            [-1.3750137801884557, -0.5099779712686714],
            [-1.382208338411356, -0.5100321123168543],
            [-1.4611299490536351, -0.5088174819696517],
            [-1.458541120788582, -0.4200101293080593],
            [-1.4642950199586862, -0.41981069874838445],
            [-1.4627796823637318, -0.3714873275531813],
            [-1.461429043387763, -0.28830623886604434],
            [-1.4603337518297195, -0.2442691369758494],
            [-1.4578329953922862, -0.15628535855345327]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.20097891359056, "lat": 38.34716338193114 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20159"],
        "coty_name": ["Rice"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rice County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "00485043"
      },
      "bbox": [
        -1.4642950199586862, -0.5284135769273043, -1.0270592149715636,
        -0.15628535855345327
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.4980549651022157, 0.1060566211848309],
            [-3.3996569549819147, 0.09972535345653079],
            [-3.372651597306215, 0.09805533425968199],
            [-3.328035690076236, 0.09557598777339507],
            [-3.3027980667222514, 0.09452970314016124],
            [-3.300079712087334, 0.09474709696718508],
            [-3.2590685948823412, 0.09278903637796779],
            [-3.253323221144003, 0.09232989167627062],
            [-3.205785817471637, 0.09025330644790905],
            [-3.158174214988562, 0.08790062634163219],
            [-3.1609276533011927, 0.02066935383535752],
            [-3.1610963296209187, 0.020453241688883277],
            [-3.1657641620315258, -0.0875045867250874],
            [-3.166371697430593, -0.09954798707805557],
            [-3.1703676831804914, -0.19167912088780595],
            [-3.1710377544480757, -0.20450312170961849],
            [-3.172672026455605, -0.24884046337451862],
            [-3.175775758885166, -0.32214391729622466],
            [-3.1773073572083916, -0.35183480176356585],
            [-3.331832012654227, -0.3431026596629491],
            [-3.3480232483357963, -0.3421428037945889],
            [-3.502305441024962, -0.33466081986770807],
            [-3.519520977176675, -0.33378210219495985],
            [-3.516998563388395, -0.2752346490727447],
            [-3.5133036618004954, -0.1873209511026924],
            [-3.511957643496513, -0.1580661747778172],
            [-3.509122320038095, -0.10754946961124856],
            [-3.505582726933844, -0.04080029392768416],
            [-3.4980549651022157, 0.1060566211848309]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -100.9068610821828, "lat": 38.48217533270289 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20171"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00485048"
      },
      "bbox": [
        -3.519520977176675, -0.35183480176356585, -3.158174214988562,
        0.1060566211848309
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.160127611704786, -1.7314489707822274],
            [6.1538889549687195, -1.6483611783813525],
            [6.147137344867309, -1.5565763556271088],
            [6.216141658941798, -1.5516200169000924],
            [6.228877560908408, -1.5508541590137503],
            [6.228972685177405, -1.5526385966642888],
            [6.236711016900066, -1.5538789440857215],
            [6.3090516412353885, -1.5484607725716273],
            [6.330247475698919, -1.545895409813168],
            [6.3588285326657585, -1.5446221258166106],
            [6.406990146251981, -1.541271064371087],
            [6.409134255216986, -1.5716351510786561],
            [6.413760328426006, -1.6302133912185084],
            [6.41911190863688, -1.7097982987233298],
            [6.421024140390063, -1.7343051109292045],
            [6.430473542782702, -1.8736504156436928],
            [6.431971194781449, -1.896676201562661],
            [6.438217359715151, -1.9852443341664423],
            [6.416541422820902, -1.9865885183325644],
            [6.3936128060189406, -1.9880059356317759],
            [6.301539788838476, -1.9947476178263805],
            [6.23290845596762, -1.9994249926529506],
            [6.177934838899836, -2.0036243028055423],
            [6.173261660912118, -1.9443455479365577],
            [6.167565357218925, -1.8691167581975725],
            [6.164586564391691, -1.822416184907551],
            [6.16319322663927, -1.8089773589924536],
            [6.156402767456411, -1.7491471812608714],
            [6.157430205549602, -1.7368875035550477],
            [6.160127611704786, -1.7314489707822274]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.6511922280613, "lat": 36.72310086193606 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21083"],
        "coty_name": ["Graves"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Graves County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00516888"
      },
      "bbox": [
        6.147137344867309, -2.0036243028055423, 6.438217359715151,
        -1.541271064371087
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.344194984798525, -1.1724217201160991],
            [10.346071360001023, -1.1744634067711297],
            [10.35207034897968, -1.1723645762833796],
            [10.354350941033053, -1.169991251501248],
            [10.357091781833015, -1.1740911658556057],
            [10.363647231920272, -1.175904240619613],
            [10.365873426927257, -1.1787341188155585],
            [10.372174110895461, -1.1810782704845895],
            [10.373181355601147, -1.1729569781309679],
            [10.378492387336658, -1.1736570232063939],
            [10.388173567585353, -1.1677930861489285],
            [10.38970724599361, -1.1731411505894107],
            [10.396860194305452, -1.1711234443710867],
            [10.399603271779126, -1.1716311008783422],
            [10.408643817426393, -1.1691531932578563],
            [10.41091243513452, -1.1666226852608164],
            [10.414042849760369, -1.159830306357178],
            [10.417290631516181, -1.158940989135813],
            [10.415921584124874, -1.1527341163422233],
            [10.412087203978453, -1.1517870263934866],
            [10.412786500950958, -1.1486436896438397],
            [10.410035474952224, -1.1425904302366519],
            [10.411575230964004, -1.1374601450674526],
            [10.416190412505106, -1.1386004080267231],
            [10.42193815069372, -1.1347476514951242],
            [10.422763174565906, -1.1309182081492484],
            [10.468362659929575, -1.1097467057847732],
            [10.492117416076805, -1.0948619675165594],
            [10.501908412385747, -1.0846153883713496],
            [10.514682549857232, -1.0747503284604243],
            [10.528336277842584, -1.0560408483671748],
            [10.53244335046103, -1.0455497003074747],
            [10.533388021458881, -1.0378061883868241],
            [10.536477507036519, -1.0343589169218343],
            [10.540457212510518, -1.036467419093521],
            [10.545390802551765, -1.0334385790713327],
            [10.54874420330233, -1.0352045674002983],
            [10.555255457638792, -1.0329476035038245],
            [10.55751362709879, -1.0249052213145142],
            [10.559812641775958, -1.027699902204548],
            [10.566165304189202, -1.0303219038495806],
            [10.569840565025682, -1.023650617925115],
            [10.568699077521279, -1.0143042326951783],
            [10.577379511549676, -1.017122866376881],
            [10.57999658614786, -1.0135887833278865],
            [10.58542337784617, -1.0124164834743863],
            [10.58709115461165, -1.0192839062486914],
            [10.590294466617914, -1.0172397636349189],
            [10.594682101107551, -1.019074078152147],
            [10.599288246910687, -1.0176976008784595],
            [10.601656100363344, -1.024550090722576],
            [10.606585265545409, -1.0264394955195066],
            [10.616062706332826, -1.0235468477432648],
            [10.618465680257474, -1.0280334974612912],
            [10.616227485144732, -1.032227556939591],
            [10.616368856761763, -1.038055538705335],
            [10.610611060504478, -1.038483279700885],
            [10.607434381375612, -1.0407049068287806],
            [10.599872914458325, -1.0502675663167151],
            [10.601724588236287, -1.0540114993844434],
            [10.600139150344743, -1.0589911319695369],
            [10.597760647359443, -1.0607724926420528],
            [10.602147342557405, -1.066883762786132],
            [10.59955938020133, -1.0752007043736918],
            [10.60265062402098, -1.0779029608688213],
            [10.61005691495862, -1.0732937969914225],
            [10.619467158608488, -1.0701672454945566],
            [10.629481620788425, -1.0635346649009505],
            [10.640658411937876, -1.057909425773463],
            [10.644884451341051, -1.0567433173289476],
            [10.652589975020524, -1.0521189872046977],
            [10.664966555283113, -1.0457570290621423],
            [10.668569458171055, -1.0446176940773833],
            [10.686761854636137, -1.0359010505928412],
            [10.68779466269614, -1.0388061061829812],
            [10.692388587578346, -1.0382509961500954],
            [10.699683976522529, -1.0409603397981761],
            [10.703784725171547, -1.0355208950167074],
            [10.705379846643687, -1.030650821576013],
            [10.710142809876364, -1.0240834479919787],
            [10.721742779397907, -1.0178808253332423],
            [10.731016499052506, -1.015293595078856],
            [10.741000884638455, -1.0103140949835463],
            [10.744875824412013, -1.0074292212648663],
            [10.747713017537082, -1.003223946446318],
            [10.758316494240365, -0.9943894731206158],
            [10.759993645944817, -0.9941056118838622],
            [10.820363109578068, -1.0275654979822222],
            [10.820749993644135, -1.0363627413652263],
            [10.823323132138885, -1.0383655568061305],
            [10.825563786907836, -1.0432500471653487],
            [10.82759761585252, -1.0432923331903419],
            [10.833638880594952, -1.04784771563611],
            [10.831077801471299, -1.0516664157024491],
            [10.831090932555531, -1.0616102482775487],
            [10.83536887479527, -1.0709902818125316],
            [10.834344670724166, -1.0755032057453124],
            [10.82980120056083, -1.083550889883629],
            [10.823741523273982, -1.0922888313113195],
            [10.82306854236673, -1.0946836496188046],
            [10.829742569857764, -1.1001006159553377],
            [10.824599021090577, -1.1099263306878753],
            [10.824762018003284, -1.1131757462527734],
            [10.820163541964687, -1.1149436260252172],
            [10.816506689035885, -1.1197215252013155],
            [10.812553352433104, -1.1224531039598509],
            [10.804349211602005, -1.1260418173949585],
            [10.80391004226974, -1.131232926121105],
            [10.792531849382632, -1.133604977062538],
            [10.781551399158827, -1.1419011229997114],
            [10.770629878380023, -1.1445549276120144],
            [10.763852799259146, -1.1491755281432414],
            [10.757223205604006, -1.1550325074578467],
            [10.749901439649538, -1.153996907959997],
            [10.742535891412912, -1.1555783104784072],
            [10.735290378844402, -1.1591304366175768],
            [10.73170930842154, -1.1645559670194203],
            [10.730440134745686, -1.168704455562367],
            [10.725418130623494, -1.1700063966011633],
            [10.717744628753575, -1.168309818509408],
            [10.713063075152286, -1.1633487515573218],
            [10.701200603210335, -1.1660975587889961],
            [10.69731657649678, -1.1692792902563032],
            [10.686913424187331, -1.1686670889822892],
            [10.684452954466398, -1.1711436502754542],
            [10.677302271566791, -1.1691677392011406],
            [10.675494184757325, -1.1734905036123737],
            [10.67768789698807, -1.1789977887185872],
            [10.677135991774785, -1.1831486554192137],
            [10.668237358318958, -1.1871162918167424],
            [10.665379698807241, -1.191378292385408],
            [10.659764876084445, -1.194794105642825],
            [10.657855843757776, -1.197805491657597],
            [10.660967195871262, -1.2035953029307276],
            [10.662470107783744, -1.2122535214392216],
            [10.659894151832074, -1.2203479190641857],
            [10.654703298544959, -1.2274754965376657],
            [10.649622027555266, -1.2392289672749588],
            [10.646715803052881, -1.2425559941714341],
            [10.640253557983046, -1.244723049089811],
            [10.639401225831977, -1.247057876959231],
            [10.643759902044152, -1.2540322124790804],
            [10.641432912603943, -1.258684767054205],
            [10.643117531140744, -1.261663224828801],
            [10.642568040794668, -1.265793500614934],
            [10.647558267256276, -1.2685752897600058],
            [10.646339347497367, -1.2719359915750477],
            [10.648069037287218, -1.2788678928430406],
            [10.645725127423315, -1.2802466124081477],
            [10.642390707504731, -1.2875258261706233],
            [10.634939173531755, -1.2898641746791728],
            [10.626547553766397, -1.2905988387478606],
            [10.623085202617345, -1.2934122371956174],
            [10.597104909526962, -1.2973450972320946],
            [10.578234688346813, -1.3082519944808004],
            [10.565928153906352, -1.314396831508375],
            [10.558354893197924, -1.3170489539521124],
            [10.551589169515768, -1.3215264529435404],
            [10.545323213369164, -1.3231860160253486],
            [10.541175432420276, -1.3262910724478292],
            [10.536364349548231, -1.3274482715239067],
            [10.527250587740047, -1.3329522713524444],
            [10.512384751793777, -1.3373946425151806],
            [10.50604671936394, -1.3415044577978057],
            [10.485642774206806, -1.3512677669213131],
            [10.472976932494863, -1.3608039454477652],
            [10.469851700675958, -1.3602035550682332],
            [10.467350692142562, -1.3624726530531739],
            [10.453527355155533, -1.3705273631436994],
            [10.447226784627045, -1.3786005675833048],
            [10.447193521558864, -1.381354244754332],
            [10.43539374515726, -1.3890361694348856],
            [10.42647535976323, -1.3936863056680702],
            [10.416553457093054, -1.3962276433044545],
            [10.413073731604424, -1.395977381899198],
            [10.407537084283002, -1.3983419046949443],
            [10.397425314330203, -1.4000981612564456],
            [10.394332991605912, -1.3674098020067351],
            [10.376363816796863, -1.357073222585161],
            [10.373402692340168, -1.3583073810433024],
            [10.369778787828412, -1.35528784923116],
            [10.367756230009041, -1.3489845503709508],
            [10.36426617111782, -1.3460336388162457],
            [10.361361012506277, -1.3403906702042898],
            [10.356965106706523, -1.3358417336643096],
            [10.358087206265894, -1.3234288897046262],
            [10.357723981011683, -1.3203940006151955],
            [10.360567967163485, -1.316067332714838],
            [10.361561611929705, -1.3110690561242313],
            [10.362197071359384, -1.2842018960365564],
            [10.355478700445484, -1.2822554871796261],
            [10.354796513021869, -1.2794836511096441],
            [10.343042611320271, -1.2656870116499308],
            [10.338633246345255, -1.2628120127597975],
            [10.356694178711901, -1.217890388134274],
            [10.351134268071474, -1.2139162332345932],
            [10.345238158690469, -1.2047708376914084],
            [10.34308352341312, -1.1932698398607826],
            [10.340131568880192, -1.1849625625448643],
            [10.341788805586082, -1.1815266718078345],
            [10.341682919017238, -1.1748354969778514],
            [10.344194984798525, -1.1724217201160991]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.21793743656943, "lat": 36.85696374801765 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21095"],
        "coty_name": ["Harlan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harlan County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00516894"
      },
      "bbox": [
        10.338633246345255, -1.4000981612564456, 10.83536887479527,
        -0.9941056118838622
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.795605016945903, 0.0766680666437403],
            [9.801189552124038, 0.07647756882356263],
            [9.80228855734456, 0.07276749366442137],
            [9.798600620044684, 0.07146763541329554],
            [9.796186179620253, 0.06698289407032852],
            [9.801656720050484, 0.06653455084188663],
            [9.80154963727758, 0.06284915231845781],
            [9.796804176477012, 0.05950626077084349],
            [9.80278465608018, 0.05669494112162935],
            [9.808139484839728, 0.05629943601017367],
            [9.807384438352537, 0.051009653378604636],
            [9.801025127189833, 0.04971695924285583],
            [9.804758323872358, 0.04479161987343907],
            [9.810149936763207, 0.04365160338494353],
            [9.817474458236997, 0.05104356466920145],
            [9.816583631139798, 0.04590529951385276],
            [9.821845904455493, 0.043460861285316885],
            [9.820274088041053, 0.03993984530565917],
            [9.828035519930609, 0.03982384151450094],
            [9.82789939841753, 0.037376512786624114],
            [9.833079087969246, 0.03533552423830878],
            [9.837065897657387, 0.03703240740965795],
            [9.877300735923214, 0.03049663532392722],
            [9.882131476118225, 0.026249616747147667],
            [9.931231137948545, -0.018983407722528593],
            [9.95110048779931, -0.05654590198115974],
            [9.990320361391491, -0.08750717881600982],
            [9.99143013577482, -0.08873705640847343],
            [9.9893570606505, -0.09535443128286566],
            [9.987526370240236, -0.09667593466876606],
            [9.986921875408452, -0.10764034015907623],
            [9.97892268293029, -0.10546591649217454],
            [9.981053738792724, -0.1227630170550011],
            [9.980034436598173, -0.1259403918081107],
            [9.98319648787196, -0.1283804256325889],
            [9.982530645066541, -0.13215461600317466],
            [9.985918147428253, -0.13374267409584742],
            [9.982819249140999, -0.14011349915789842],
            [9.983792043586568, -0.14149262826879555],
            [9.98482613277524, -0.15668332909674224],
            [9.987015935653805, -0.1579355795986044],
            [9.98779110791712, -0.16286234285889295],
            [9.994386273905878, -0.16535075254737883],
            [9.994373363613706, -0.17008218861658253],
            [9.992533200822242, -0.1767699152995802],
            [9.987449689811971, -0.1846061096501906],
            [9.98333697538968, -0.18842366668160027],
            [9.969174095702416, -0.19292981352307018],
            [9.960615518226703, -0.19625554564780742],
            [9.954228096428286, -0.1966247383427647],
            [9.952595254297227, -0.194804886479966],
            [9.947977753121716, -0.19472966836883204],
            [9.945211673863767, -0.19875522633612178],
            [9.940546965948906, -0.1960730345838444],
            [9.936092880865905, -0.19672234429577243],
            [9.936113741041497, -0.19984330778184686],
            [9.929574270828253, -0.20078782763602113],
            [9.91846650917432, -0.19815522379869463],
            [9.909107522582653, -0.20106736572518458],
            [9.901763881208163, -0.19035676073702396],
            [9.884751075972956, -0.19232114275688686],
            [9.8795049694569, -0.19014658073038598],
            [9.842496903574858, -0.18035925903025976],
            [9.837897936771729, -0.18399570382540023],
            [9.822592697880781, -0.1577635040225763],
            [9.80444207955817, -0.1290515790506075],
            [9.790336618359841, -0.10875517286013842],
            [9.77854731211049, -0.08963351208507288],
            [9.761611052957111, -0.06331598174063026],
            [9.726107449475208, -0.010508712163161849],
            [9.733058305812682, -0.0007891708239307075],
            [9.73554126849428, 0.004777223854533259],
            [9.739541641601042, 0.010304322400314904],
            [9.747262184098886, 0.014617319625235898],
            [9.752204105183278, 0.019553842660075454],
            [9.75404791474849, 0.023936923212752554],
            [9.759313610380637, 0.02772715911726562],
            [9.763171648191122, 0.03215385405560872],
            [9.78831919151944, 0.058385092166899445],
            [9.795605016945903, 0.0766680666437403]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.91315273217407,
          "lat": 38.033512773135506
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21173"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00516933"
      },
      "bbox": [
        9.726107449475208, -0.20106736572518458, 9.994386273905878,
        0.0766680666437403
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.360886289125632, -8.19499830184131],
            [3.3640794198709463, -8.193746781489157],
            [3.367956688986492, -8.188763109578893],
            [3.3669818326950884, -8.184498863556968],
            [3.371642827112371, -8.177451497617547],
            [3.3729428164325084, -8.173150558975145],
            [3.368846426886678, -8.16633491496951],
            [3.3658619919502573, -8.16507712614492],
            [3.3686762379724215, -8.15853695455647],
            [3.3729895781800487, -8.154424269400018],
            [3.3806208091475605, -8.152012559646947],
            [3.3855894362726078, -8.138411395650701],
            [3.39031030028526, -8.135490114054074],
            [3.3897695299030675, -8.128773430284799],
            [3.3929056646246174, -8.1274091762261],
            [3.3970590360762567, -8.12323274475629],
            [3.3957876154457893, -8.120820778143734],
            [3.3989666662079636, -8.116224046885074],
            [3.3974223591122694, -8.111978028822035],
            [3.394227484933492, -8.11115939418971],
            [3.3892296722771342, -8.10275852956002],
            [3.385698798555435, -8.10107375214781],
            [3.3835147010246422, -8.05679610408459],
            [3.3809084906336975, -7.995073970738336],
            [3.379049739065208, -7.940360237313094],
            [3.3766863477010216, -7.882781074635072],
            [3.374199169831372, -7.789245488586522],
            [3.400308583809173, -7.788080288922391],
            [3.4077780360020005, -7.784378303603087],
            [3.411623339342951, -7.7836366600893925],
            [3.413368780087716, -7.781105071044907],
            [3.423099389826127, -7.785592799655528],
            [3.4337527217710986, -7.784284043810581],
            [3.4353653347781465, -7.789515235101834],
            [3.4502536406190942, -7.7865096897386366],
            [3.4547921512083133, -7.783942088161161],
            [3.461611663118416, -7.7772469248245155],
            [3.4682452911456845, -7.772849784577047],
            [3.4739861478543768, -7.763322902298739],
            [3.4748202837167805, -7.75665156855083],
            [3.472466018104694, -7.749037015513636],
            [3.47115719266877, -7.740579264482385],
            [3.472554152993157, -7.729740435929959],
            [3.4788120868451773, -7.7298257235276395],
            [3.4817190202728767, -7.724130303420245],
            [3.489302734705532, -7.725830853868009],
            [3.4927331227982927, -7.723314175903646],
            [3.497943130857564, -7.7167431004798415],
            [3.501599061693464, -7.716410709040705],
            [3.5171599853735906, -7.70747736701894],
            [3.5243985195971947, -7.705245797991011],
            [3.528593038042495, -7.700922281114571],
            [3.5328778463374784, -7.690144307951522],
            [3.5320738185282594, -7.686958433949766],
            [3.53603775208223, -7.6847845199139035],
            [3.546084630576576, -7.681431666168046],
            [3.5494049606151403, -7.677855721459821],
            [3.5590778371098897, -7.67897292902847],
            [3.5593898739054013, -7.683503312164244],
            [3.561748517962683, -7.686299949284077],
            [3.56844617886287, -7.688653602437218],
            [3.5724630304674507, -7.686341615186629],
            [3.5747112882538192, -7.688237818255597],
            [3.57392915875307, -7.691700408843113],
            [3.5783480196382746, -7.694115844816267],
            [3.586995476303343, -7.695016078384571],
            [3.5898234694501063, -7.696274967203121],
            [3.591205106519856, -7.7002627956788405],
            [3.587577123475214, -7.703982159019388],
            [3.5910596392035217, -7.707810155381198],
            [3.5954277818550677, -7.7049516693780635],
            [3.599773899553343, -7.704301001345566],
            [3.604231669020183, -7.706840792121853],
            [3.5999096460254965, -7.713973054059457],
            [3.6118720024446835, -7.713374067944446],
            [3.6137832355135058, -7.711600717926883],
            [3.6425897229869895, -7.710589608991484],
            [3.643751884068669, -7.739505181661685],
            [3.6817523535588172, -7.781577151650247],
            [3.6839100569113485, -7.825120934870934],
            [3.705455724433055, -7.823945634986252],
            [3.7071397653332787, -7.840704906873381],
            [3.7087007066069146, -7.8789431324308286],
            [3.7128678482809363, -7.887134799550885],
            [3.721107770600396, -7.891891573615736],
            [3.726638998512775, -7.892928422953462],
            [3.7315825971434182, -7.896854784991258],
            [3.734465421077026, -7.90073166180508],
            [3.7428428442957675, -7.902601257441751],
            [3.743333351438987, -7.908101783846049],
            [3.746822405638909, -7.996011760571323],
            [3.74318532873393, -7.996758863874646],
            [3.7418056073608557, -8.00314729326639],
            [3.7360171677608296, -8.003644919658345],
            [3.7289962505807215, -8.01112230355352],
            [3.7235543932629263, -8.014495114737427],
            [3.724032368493098, -8.022776973386135],
            [3.7205506530303945, -8.029919959851348],
            [3.720420852895952, -8.041011507674348],
            [3.7217973967450697, -8.045316571205381],
            [3.7156226913943855, -8.053535488558303],
            [3.7176149133276337, -8.102160808025168],
            [3.673934089606228, -8.103733888337874],
            [3.6747859103882785, -8.133021947312196],
            [3.591661844300752, -8.13604757591737],
            [3.5440362803321586, -8.13794279958994],
            [3.5358888871634044, -8.140262114270493],
            [3.5307223015307834, -8.14347147173244],
            [3.5284206050280162, -8.140746523316599],
            [3.5216969037997847, -8.144135263198411],
            [3.514662467786888, -8.143613533813001],
            [3.5120481258704737, -8.150004189539283],
            [3.5065028744155176, -8.153361838096956],
            [3.5051060476373994, -8.162026920061555],
            [3.5026625059900556, -8.164074515748522],
            [3.502401754132131, -8.17061671498216],
            [3.50436882000729, -8.178310442442786],
            [3.5030201498343945, -8.182968707972458],
            [3.4984112242192613, -8.18436020468989],
            [3.4955312935567138, -8.18296332681133],
            [3.489643044436391, -8.186753690073916],
            [3.486572950616843, -8.187356537276067],
            [3.4819545513819667, -8.192886274803472],
            [3.4789532541904666, -8.198225520834203],
            [3.3981225021983645, -8.201057697725945],
            [3.359664334778106, -8.201819639739139],
            [3.3618863909484484, -8.196756568830319],
            [3.360886289125632, -8.19499830184131]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.40594396249281, "lat": 30.72883735480913 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22039"],
        "coty_name": ["Evangeline"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Evangeline Parish"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00558551"
      },
      "bbox": [
        3.359664334778106, -8.201819639739139, 3.746822405638909,
        -7.677855721459821
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.992170407303297, 2.120675400225142],
            [13.055304504942592, 2.132145438293504],
            [13.130817354447363, 2.1459401603927604],
            [13.193306679823745, 2.1574181593528117],
            [13.315299272783127, 2.179988683787675],
            [13.403149177694658, 2.195765519311987],
            [13.386270218372255, 2.123152202586464],
            [13.364071499680028, 2.0280736133731914],
            [13.342375535312014, 1.9352671990605554],
            [13.342415573769271, 1.9302982536492255],
            [13.331955926545167, 1.9252021804603898],
            [13.32570679215665, 1.925132687982496],
            [13.318000895332634, 1.9284604634765976],
            [13.314933888824356, 1.9250754596150348],
            [13.31689357639232, 1.9211108994494979],
            [13.322214324335395, 1.920229651708946],
            [13.324382547776157, 1.9147886177386753],
            [13.317961568062618, 1.9141673201143015],
            [13.31562847045632, 1.9126608326974766],
            [13.315964228844395, 1.9076840231019698],
            [13.320480036410705, 1.908682460118035],
            [13.321111952177032, 1.9025481784513385],
            [13.317967702328936, 1.896415457587032],
            [13.313779915227984, 1.893175960575127],
            [13.312833292658883, 1.8876112308587711],
            [13.318286431787874, 1.883097597271101],
            [13.317384804601513, 1.881072184604215],
            [13.308079652729736, 1.8817828631866587],
            [13.304958666719974, 1.877469478742729],
            [13.307478114331856, 1.8708135690738577],
            [13.3076102174012, 1.8655818098238186],
            [13.301244713368968, 1.8658819208129669],
            [13.297259374817145, 1.8629127197174258],
            [13.2993043287305, 1.856782434307016],
            [13.298219343442625, 1.851312176343548],
            [13.293604826479076, 1.8510227879683971],
            [13.292129060620637, 1.8597018376455494],
            [13.287149510181223, 1.8627545096630211],
            [13.283876660730618, 1.860201727894485],
            [13.285723593574897, 1.8548096926468678],
            [13.282492686934322, 1.8489855682875733],
            [13.281849251814172, 1.8439596740012079],
            [13.286897101218393, 1.8356059732459167],
            [13.285280499742512, 1.8304888769486398],
            [13.279903583160259, 1.8336875809659061],
            [13.276888668015276, 1.837279170980568],
            [13.271919501438584, 1.8357399435719604],
            [13.276074350658876, 1.8307704123095823],
            [13.270722177055667, 1.8259393006511155],
            [13.263666004354349, 1.8281861667808104],
            [13.260948831921143, 1.8276240479922496],
            [13.258471684466665, 1.8161911690070587],
            [13.252849834645616, 1.8079107572933595],
            [13.252478282012271, 1.800372588852446],
            [13.247954160266039, 1.7992326077059941],
            [13.239190792367975, 1.799118718663519],
            [13.239109146621763, 1.7940328670043513],
            [13.23207644687612, 1.7925792512152436],
            [13.22736747727865, 1.7878595699104112],
            [13.22189693629137, 1.7885135285640177],
            [13.22492987462343, 1.782811659250654],
            [13.225906107438519, 1.7779295845355914],
            [13.223706251243115, 1.7737583347250137],
            [13.226927459731739, 1.770810978882407],
            [13.226430642437357, 1.7674357059427006],
            [13.223344747113849, 1.7652089136973577],
            [13.217116213852659, 1.7662093680511177],
            [13.21534597883968, 1.7577249628134806],
            [13.20853301189414, 1.751108398352716],
            [13.20835607955622, 1.7426043733744334],
            [13.20962940024667, 1.7375616765453465],
            [13.205852569308263, 1.7306145800733714],
            [13.206536347039066, 1.7264387009090445],
            [13.197382211841843, 1.7250505886331058],
            [13.187129255337588, 1.728178955886261],
            [13.18260243490296, 1.7227822552797183],
            [13.179048828261342, 1.723360813797291],
            [13.174623099413099, 1.7213901121271933],
            [13.17087020789415, 1.717497459353018],
            [13.169904214351066, 1.7143289342548824],
            [13.166716684257494, 1.7134470496623762],
            [13.165205429778279, 1.71015548360709],
            [13.168383474556332, 1.7071977657655033],
            [13.166932064257887, 1.7042487859032167],
            [13.163163690125387, 1.704322948482358],
            [13.162342170620397, 1.6967941001248572],
            [13.157156873795891, 1.6926849733726026],
            [13.148818619129349, 1.6902900460661345],
            [13.144514043699468, 1.6872680700002127],
            [13.143082227738693, 1.6819396929061066],
            [13.13852479065583, 1.6817468726528646],
            [13.139496470758868, 1.6779086229546558],
            [13.135657671381587, 1.6754624488128598],
            [13.133058325489168, 1.6659063722949359],
            [13.129710876003134, 1.6628648550884495],
            [13.12489319280947, 1.6517612287941328],
            [13.11891509410838, 1.6490007018635118],
            [13.119378521891424, 1.645846351798862],
            [13.116267083012534, 1.6432120424384369],
            [13.117721298592155, 1.6378169669462448],
            [13.114963500938835, 1.6327663264868348],
            [13.11222693821445, 1.632652422394013],
            [13.108013347978199, 1.6247370736890796],
            [13.100501195279508, 1.6202956087170448],
            [13.098081441033479, 1.6159477827740532],
            [13.092949899199407, 1.6163164429360688],
            [13.087555978804598, 1.6111258154286725],
            [13.087697440608444, 1.6074968132717238],
            [13.082978157334766, 1.60666198482744],
            [13.074396527561705, 1.6074438532779558],
            [13.064864051762425, 1.6661640452004227],
            [13.063754195851024, 1.6662766951020127],
            [13.061900812512345, 1.6792132075340833],
            [13.06089921260204, 1.6808652620756017],
            [13.058664769578742, 1.6973103157996998],
            [13.050857981726754, 1.7450478468948072],
            [13.052140674749667, 1.745272893846129],
            [13.033814496825913, 1.854339507048041],
            [13.022534614996225, 1.9214600745928412],
            [13.020944670312936, 1.9317568654811448],
            [13.02357862537608, 1.9322190728730115],
            [13.005099545566482, 2.04224821751294],
            [13.005657783443935, 2.044316680298833],
            [12.992170407303297, 2.120675400225142]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.27292860324465,
          "lat": 39.528879086795165
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24023"],
        "coty_name": ["Garrett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garrett County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01711058"
      },
      "bbox": [
        12.992170407303297, 1.60666198482744, 13.403149177694658,
        2.195765519311987
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.011712723637444, 6.727066403779766],
            [9.096986949566569, 6.738249730726952],
            [9.180488803576493, 6.751154762704934],
            [9.222747865761175, 6.75686401928975],
            [9.265615868866577, 6.762952018581798],
            [9.337352497318152, 6.771562594356467],
            [9.35129521897715, 6.77348912358744],
            [9.409312736785441, 6.78088875256113],
            [9.410198916475826, 6.775461961099316],
            [9.415998652756997, 6.76552218612535],
            [9.424390430592734, 6.758254666137947],
            [9.427818510740114, 6.753709588901006],
            [9.430309030514046, 6.740593463151652],
            [9.435451905904483, 6.734009478812445],
            [9.435740978683652, 6.728376285166019],
            [9.437447157978015, 6.7220678658212005],
            [9.436195860786743, 6.71937491420647],
            [9.43619142021781, 6.712824719206577],
            [9.43790692457727, 6.703987059295468],
            [9.443089142715074, 6.692058862076737],
            [9.440473669742007, 6.686238414042574],
            [9.439388249694693, 6.68092350621944],
            [9.440826560568853, 6.674302778789824],
            [9.444624802019382, 6.663460283771911],
            [9.448167569589478, 6.656347973415644],
            [9.453763382256506, 6.6495651886023035],
            [9.46235967298483, 6.642816333680766],
            [9.464049355019252, 6.637739698448127],
            [9.462768529616888, 6.63487270927219],
            [9.462730472093602, 6.6245278420628],
            [9.463533614591771, 6.621254549287001],
            [9.461282787956682, 6.607983523461501],
            [9.460433951173188, 6.598903258902721],
            [9.460245906308641, 6.585728219200229],
            [9.45874704246519, 6.577127903988027],
            [9.456667422544394, 6.574357710125891],
            [9.452098245498414, 6.564012062970897],
            [9.449604069880623, 6.55665186998309],
            [9.447980163152765, 6.543754520071576],
            [9.44748163094151, 6.535179303902632],
            [9.448537058613878, 6.52160947812504],
            [9.455032136466274, 6.487082412189383],
            [9.461658218688436, 6.470258289451716],
            [9.46092244903646, 6.467815391566538],
            [9.457409686898847, 6.44173170741422],
            [9.457520779405225, 6.438963778894397],
            [9.38489168104313, 6.42934212287479],
            [9.292169160117922, 6.4169753492800226],
            [9.213216859320871, 6.406052379005451],
            [9.142113981012983, 6.395973359577713],
            [9.057271251423307, 6.384101854577924],
            [9.045706717727015, 6.469403497266631],
            [9.037148641996552, 6.532999446077312],
            [9.028890059395367, 6.593599905836531],
            [9.022756922725875, 6.641260188228052],
            [9.019716438336767, 6.666945698407187],
            [9.011712723637444, 6.727066403779766]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.5938143663025, "lat": 44.685424256652475 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26001"],
        "coty_name": ["Alcona"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alcona County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01622943"
      },
      "bbox": [
        9.011712723637444, 6.384101854577924, 9.464049355019252,
        6.78088875256113
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.635528427677991, 8.45194591090692],
            [5.63363773622747, 8.436270019398425],
            [5.632218831466633, 8.42932735761888],
            [5.627913583333474, 8.415578983787642],
            [5.6261895097268315, 8.40750600418146],
            [5.622585838084401, 8.398566777325545],
            [5.624372395706924, 8.389494884521985],
            [5.6239348110585095, 8.3820278212855],
            [5.622383475922715, 8.374523460950103],
            [5.623958955015694, 8.363608108355741],
            [5.622102786970213, 8.35660491340375],
            [5.622141228502754, 8.347353024976954],
            [5.621022860635403, 8.345529549860574],
            [5.622696900894554, 8.33942727393217],
            [5.630154213100211, 8.326718167138127],
            [5.631124155145175, 8.318458143053832],
            [5.639288965161851, 8.303920100802944],
            [5.63927856320381, 8.301602608593138],
            [5.635009084539453, 8.295376833864358],
            [5.628777177481822, 8.298894073564266],
            [5.626455160931098, 8.296641405311103],
            [5.620725440564378, 8.283235839465883],
            [5.618087119410229, 8.279372427141615],
            [5.616327472611679, 8.272571580369638],
            [5.619699701959933, 8.268944173390373],
            [5.629948310206996, 8.26464250429471],
            [5.632973905811165, 8.264390407841955],
            [5.638892248261177, 8.267271337941892],
            [5.6495735507490705, 8.279223497908749],
            [5.650034130668941, 8.286745701205833],
            [5.655580293516382, 8.298288606308137],
            [5.6560586592621505, 8.303016222769049],
            [5.658667501308451, 8.309933864600401],
            [5.668805777234289, 8.325888037312248],
            [5.669971846858871, 8.32883457585137],
            [5.690999618016001, 8.356948011967443],
            [5.690004209833656, 8.363759784244449],
            [5.684410050120356, 8.36967522197081],
            [5.675518636364623, 8.364318290581037],
            [5.6745114232443115, 8.36844531339421],
            [5.677087547100574, 8.374599792706263],
            [5.683024493383867, 8.384617560063237],
            [5.689316453658656, 8.389984962196898],
            [5.694551859947479, 8.390258995305405],
            [5.693013367653132, 8.380070083488617],
            [5.698150153189753, 8.376146608154194],
            [5.707613980943797, 8.375690825942463],
            [5.709690036000155, 8.376784572165343],
            [5.715480604079962, 8.385768983862782],
            [5.720655115848519, 8.391364640876818],
            [5.728203399133049, 8.401403480094169],
            [5.732993780521181, 8.405799886741892],
            [5.735563050215044, 8.411193461690585],
            [5.754068518728434, 8.429366036244886],
            [5.766787890741191, 8.439170402528886],
            [5.770711860691826, 8.445642423177562],
            [5.777374681913738, 8.453954499182199],
            [5.795325155943876, 8.465342211911198],
            [5.8074542419496025, 8.470524214380752],
            [5.812855553654787, 8.479267263146648],
            [5.820500377350243, 8.482362427073275],
            [5.827758399496892, 8.48694343677479],
            [5.835347107469725, 8.493703046805557],
            [5.83870087804999, 8.492786059537979],
            [5.842432041144602, 8.496193796031799],
            [5.851079393259415, 8.490409890028696],
            [5.8458947579944684, 8.488066988245672],
            [5.841934405993543, 8.48320950369344],
            [5.8425140608245805, 8.476672699891823],
            [5.840701497213424, 8.472959318876805],
            [5.817149390612654, 8.446696728215498],
            [5.808576994826995, 8.44160518968839],
            [5.804468297295804, 8.434932579404657],
            [5.801226010830357, 8.435551605328854],
            [5.797284318571199, 8.431781564053553],
            [5.787272189613327, 8.420297269587671],
            [5.782204018377412, 8.410334734156034],
            [5.7774775040223725, 8.396222726107794],
            [5.7789013695617095, 8.390876675134933],
            [5.77554116570057, 8.390926337117586],
            [5.772690530190456, 8.37784371379486],
            [5.766317631379203, 8.362393238757864],
            [5.759011501316292, 8.356008298336391],
            [5.759333794330818, 8.347111589497278],
            [5.766396235755818, 8.348886746790473],
            [5.7714950864439, 8.354603231078515],
            [5.772813873310278, 8.36146111084442],
            [5.777796081006436, 8.364597033509915],
            [5.779931856728403, 8.373447490760967],
            [5.784129929682685, 8.387043221321631],
            [5.790265429285142, 8.398716611098875],
            [5.794103573399383, 8.403028880402585],
            [5.803745561449691, 8.411117773925834],
            [5.803386045923153, 8.414460887394858],
            [5.800392969348838, 8.417990298055251],
            [5.808850420679889, 8.424536446869785],
            [5.812828085364252, 8.425903773602288],
            [5.820193606452526, 8.432762660048773],
            [5.8358109492367705, 8.434327262488056],
            [5.840411019527391, 8.436621813652],
            [5.850380680455013, 8.439501990449951],
            [5.859331309798334, 8.44109627350178],
            [5.8682169506391375, 8.444770751408056],
            [5.87623452565228, 8.449767388392038],
            [5.889258858492459, 8.454054677552058],
            [5.8971631578889765, 8.453799800584765],
            [5.9154993781590735, 8.447441465299251],
            [5.921600941387822, 8.375449943581081],
            [5.921545244899243, 8.371725531786188],
            [5.924082611577088, 8.346550991679061],
            [5.927576669584317, 8.303871112921199],
            [5.964127643864945, 8.306723799138],
            [5.96844133963825, 8.25699322155702],
            [5.971235108753572, 8.222177291507155],
            [5.886012948929238, 8.21438437176485],
            [5.897081957854923, 8.075688418341695],
            [5.90685751517416, 7.960160170027553],
            [5.821001547220806, 7.953218311132625],
            [5.735147374536246, 7.946254576229067],
            [5.645731727857534, 7.939154146262607],
            [5.56221815140069, 7.93267162767742],
            [5.519041471575199, 7.929559212566369],
            [5.506195232010998, 8.099319344469603],
            [5.496500200602997, 8.227278650296844],
            [5.497515199670114, 8.234737876492742],
            [5.494757418244747, 8.268812580402763],
            [5.4930716328495475, 8.2686917064217],
            [5.486231314979647, 8.354027337502687],
            [5.515407536877795, 8.356405089293714],
            [5.558709569010337, 8.359360891606691],
            [5.573196861466118, 8.360865321237638],
            [5.567538549315416, 8.431785942737992],
            [5.56627010796877, 8.446031261509317],
            [5.635528427677991, 8.45194591090692]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.36520925403784, "lat": 46.66260732021265 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26013"],
        "coty_name": ["Baraga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baraga County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01622949"
      },
      "bbox": [
        5.486231314979647, 7.929559212566369, 5.971235108753572,
        8.496193796031799
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.687825171151937, 3.455337110640402],
            [7.681739569472679, 3.52203584112452],
            [7.678076407071352, 3.565702986855315],
            [7.671927514866228, 3.63063154316722],
            [7.667007836181827, 3.680170803922775],
            [7.6579345062784006, 3.767022985888392],
            [7.742361948357318, 3.775082408357535],
            [7.77745720347912, 3.7783199090330624],
            [7.827446047087626, 3.78326450411195],
            [7.868904982331344, 3.787161145564155],
            [7.949207039903989, 3.7954133481832826],
            [7.995364456850816, 3.8004253382268196],
            [8.005924939227512, 3.7148066250816063],
            [8.016140282810827, 3.6280726803334327],
            [8.019569165709507, 3.594552831475098],
            [8.026683275165173, 3.5303108867829067],
            [8.025547723946554, 3.524708774933408],
            [8.022654665502664, 3.5215435405299167],
            [8.021569280135095, 3.5156788365008365],
            [8.016499713726207, 3.510914799195988],
            [8.010108838377699, 3.5067552604919108],
            [8.009693429731385, 3.4969921096596734],
            [8.011600206322854, 3.4928675961747464],
            [8.0080603667277, 3.488088052687704],
            [7.948610794844585, 3.482032624981139],
            [7.8607394265543045, 3.4732968824466575],
            [7.82406542232844, 3.4700066229212254],
            [7.808196477377203, 3.46835917858653],
            [7.760125624267612, 3.463404838855522],
            [7.687825171151937, 3.455337110640402]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.99349137208826, "lat": 41.91536295858385 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26027"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01622956"
      },
      "bbox": [
        7.6579345062784006, 3.455337110640402, 8.026683275165173,
        3.8004253382268196
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.288283354133402, 5.592123758541459],
            [8.34530812755966, 5.598988824517697],
            [8.373754414736698, 5.602079198309859],
            [8.432229882003858, 5.609157049818969],
            [8.545357681058123, 5.623443474706674],
            [8.63265882662897, 5.634224577284736],
            [8.642507515263683, 5.547422482499733],
            [8.653929801412596, 5.446093456016253],
            [8.65583224781224, 5.431808672748985],
            [8.662835955639313, 5.374300271409812],
            [8.673545762401778, 5.287302583865028],
            [8.63070815459324, 5.282222955764173],
            [8.559400369643587, 5.27399355669614],
            [8.502510641569001, 5.26715973993217],
            [8.416563649054298, 5.257190556090024],
            [8.388284050620538, 5.253739091691313],
            [8.331000338491421, 5.247273883929055],
            [8.315355464836466, 5.375962553243069],
            [8.309933968670347, 5.419378346619027],
            [8.29939594700989, 5.505732066647475],
            [8.294796887381942, 5.539139576340048],
            [8.288283354133402, 5.592123758541459]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.84678956487491, "lat": 43.64061196966232 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26073"],
        "coty_name": ["Isabella"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Isabella County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01622979"
      },
      "bbox": [
        8.288283354133402, 5.247273883929055, 8.673545762401778,
        5.634224577284736
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4181612607648885, 5.526958766666987],
            [0.4580772022939524, 5.527053622072071],
            [0.5043320969717836, 5.526880725846995],
            [0.6032181680635683, 5.526891367272347],
            [0.6757919256791244, 5.526658895948365],
            [0.732966290840485, 5.526261369038486],
            [0.7541973035852917, 5.526667977673071],
            [0.8085404401184595, 5.526826057232689],
            [0.847830335186745, 5.52754217086067],
            [0.8484899682243939, 5.440525014921465],
            [0.8489359224301067, 5.353724461864404],
            [0.8494917768972899, 5.266740204181306],
            [0.849404126869408, 5.22277909680671],
            [0.8498916640887578, 5.179787022477253],
            [0.770870117199243, 5.179396437087638],
            [0.705599428694339, 5.179440043539054],
            [0.6413635073219822, 5.178989538114477],
            [0.6270532966367903, 5.179144929226118],
            [0.533550050601524, 5.179408888105109],
            [0.5190999992472672, 5.179785645519664],
            [0.49774386855841857, 5.179499760708834],
            [0.45822770626364384, 5.17983850390359],
            [0.42615779086464434, 5.179868581653042],
            [0.4173224893272951, 5.179842998888993],
            [0.4178105845827149, 5.26639070355492],
            [0.4175341306878946, 5.353395808206056],
            [0.4178868188032754, 5.440413935966555],
            [0.4181612607648885, 5.526958766666987]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.76330778129358, "lat": 44.02213975617175 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27101"],
        "coty_name": ["Murray"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Murray County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00659496"
      },
      "bbox": [
        0.4173224893272951, 5.178989538114477, 0.8498916640887578,
        5.52754217086067
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.11360929082006971, 8.801940142122131],
            [-0.09098499197295672, 8.80182823385508],
            [-0.019675009522318078, 8.801014735777729],
            [-0.004137335223645183, 8.800722022396007],
            [0.03854559632893505, 8.801209241562578],
            [0.040012331359685606, 8.800913976050461],
            [0.12353932163833947, 8.800541955714458],
            [0.12753170406022277, 8.80023261835764],
            [0.24404343039287463, 8.80036680378671],
            [0.3308078841218013, 8.800312558906075],
            [0.3833499005266316, 8.799920498890218],
            [0.38672140769007096, 8.799673905863871],
            [0.41776188867356306, 8.799566160289258],
            [0.41788170953462256, 8.757136224826986],
            [0.4178278142058707, 8.714282244766242],
            [0.4182998121205268, 8.626219940529811],
            [0.4183367022833922, 8.587817954008452],
            [0.41793451926755976, 8.522298006650356],
            [0.41789353188249395, 8.458151436944997],
            [0.33066703125725827, 8.457616834093095],
            [0.24343429755180301, 8.458020745630591],
            [0.1579098099451595, 8.458067078926659],
            [0.07814018180342999, 8.458895317683918],
            [-0.007978360060327408, 8.459360907364399],
            [-0.05150606307216774, 8.45941928743515],
            [-0.11031630193032799, 8.4593287610569],
            [-0.10780316959394608, 8.462336348438896],
            [-0.10013606452649185, 8.463590678650542],
            [-0.0996333042790177, 8.469709995553476],
            [-0.09595263974046961, 8.473399035368187],
            [-0.0997648387445595, 8.475052261316456],
            [-0.09892108835221203, 8.482351904723195],
            [-0.10100520445368791, 8.485711211556776],
            [-0.09756599585001767, 8.492513890673608],
            [-0.09858651133432426, 8.493871510095396],
            [-0.10463368849086285, 8.491734463965047],
            [-0.10510694965824802, 8.495850147418832],
            [-0.10075509427458981, 8.497217523344746],
            [-0.10226126285804844, 8.500895278920087],
            [-0.10885478252533708, 8.504468611314989],
            [-0.10572046729012333, 8.510795607435176],
            [-0.10731569558687674, 8.51644732429166],
            [-0.10338824383218895, 8.519018166619912],
            [-0.10702054043407738, 8.52229587931922],
            [-0.10540695322415815, 8.526585472279253],
            [-0.1062207709862968, 8.530067798081054],
            [-0.1043929369101471, 8.53351828235015],
            [-0.10580129765812342, 8.536629866359693],
            [-0.11164010336909726, 8.53888505538437],
            [-0.10795914490342076, 8.542428203420794],
            [-0.10404714145765999, 8.538798256195596],
            [-0.10213597459686422, 8.541674467578249],
            [-0.10510559858515238, 8.545595077588336],
            [-0.1074149495210704, 8.549797132102649],
            [-0.1044850243205493, 8.555190828212053],
            [-0.10720221374762627, 8.559355857437286],
            [-0.10975862653217877, 8.569782913945737],
            [-0.10575002416872284, 8.573928381310987],
            [-0.10731901359366838, 8.575978587762537],
            [-0.11205782585715163, 8.575551938519517],
            [-0.11334758491760061, 8.579942159087516],
            [-0.1095032810892019, 8.583764080794293],
            [-0.11188730406290978, 8.59955563372965],
            [-0.1042586893455551, 8.610766242906353],
            [-0.1033000575450049, 8.613203021532907],
            [-0.1061473805352237, 8.617028472802904],
            [-0.10927307027194184, 8.615384421477541],
            [-0.11066493233617815, 8.619188465894945],
            [-0.11376819097423921, 8.622001816590465],
            [-0.10533230695313645, 8.626259432923378],
            [-0.10691279994636765, 8.630469784484685],
            [-0.10150583022743691, 8.632751706248449],
            [-0.10205880203903163, 8.635369309877733],
            [-0.10630638481334129, 8.63632620490254],
            [-0.10926576750021033, 8.632668694400694],
            [-0.11302732360643274, 8.635822739654966],
            [-0.11014124136988007, 8.638062211732304],
            [-0.10532570160597121, 8.638284638917833],
            [-0.10241322761284063, 8.644324287233777],
            [-0.10535136949825705, 8.64667340079907],
            [-0.10919040023576229, 8.646656727130045],
            [-0.11369968098763557, 8.655006769319915],
            [-0.11067219043593746, 8.65646429539106],
            [-0.11127517022198276, 8.66012483361355],
            [-0.11535013594369192, 8.66233968437137],
            [-0.11689361361863981, 8.665347029579992],
            [-0.11415386513452538, 8.668187681867211],
            [-0.11692040009055087, 8.675013940602962],
            [-0.11196355102875671, 8.673299493609528],
            [-0.10701156443143538, 8.67597740717086],
            [-0.10951363475425427, 8.678225165569573],
            [-0.11233199280834598, 8.675664299250018],
            [-0.1179931989133232, 8.677818390641724],
            [-0.11712715291676912, 8.680159429632685],
            [-0.11264955712252138, 8.679892862282534],
            [-0.11008140482796176, 8.68571839126093],
            [-0.10717117942797082, 8.687182702850038],
            [-0.10956404421747533, 8.691913511181331],
            [-0.10662569477015447, 8.694120413260704],
            [-0.114263733939619, 8.699773568252668],
            [-0.10819982497617087, 8.70295009175463],
            [-0.11168326027511062, 8.707718540898387],
            [-0.11556924026643402, 8.70940839877575],
            [-0.1230101959083379, 8.718891053996781],
            [-0.12368100827014171, 8.726729223006508],
            [-0.11885108907227736, 8.728357164689792],
            [-0.1221794619226251, 8.73450430032108],
            [-0.12316732905205385, 8.741453542971712],
            [-0.11870782546405942, 8.743932401196927],
            [-0.12116553256447814, 8.749647772534653],
            [-0.11846893636125647, 8.756559510820347],
            [-0.11734135831073052, 8.765397299131212],
            [-0.12098722144075587, 8.770472263723374],
            [-0.12192002265422193, 8.776101397350619],
            [-0.11625862150312866, 8.780192508151353],
            [-0.1161744569211387, 8.783319705917034],
            [-0.12153522771891821, 8.78402151704865],
            [-0.12422897021006932, 8.780588741604054],
            [-0.1269039539466686, 8.782453277087958],
            [-0.12344570246315334, 8.786991705433453],
            [-0.11847081529215206, 8.78644147266111],
            [-0.11644131336453722, 8.790557841656497],
            [-0.12340834511749438, 8.792905188190009],
            [-0.11360929082006971, 8.801940142122131]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.4549751865041, "lat": 47.32652458791989 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27107"],
        "coty_name": ["Norman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Norman County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00659499"
      },
      "bbox": [
        -0.1269039539466686, 8.457616834093095, 0.4183367022833922,
        8.801940142122131
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.8413388240748425, 5.220600995964821],
            [2.8493031474245805, 5.220894845057404],
            [2.846893213174164, 5.289470882796595],
            [2.844561416594478, 5.3615538607221715],
            [2.84135057355938, 5.44791391162591],
            [2.838602094864768, 5.523290712524316],
            [2.836836320831796, 5.5673096507968225],
            [2.928166289719661, 5.569949128842476],
            [3.0012982506084978, 5.572192328672236],
            [3.0938028356144347, 5.575277365983143],
            [3.097167115135003, 5.489135635525082],
            [3.182731340238079, 5.492110821085507],
            [3.226263774292044, 5.493701517197966],
            [3.2684350369327837, 5.494944178138131],
            [3.268638619074877, 5.493989864993306],
            [3.272328552248402, 5.408732021178187],
            [3.275107772459962, 5.343827796936769],
            [3.2794360182480276, 5.2357614198254305],
            [3.1864717697707463, 5.232051375757802],
            [3.1077685127401633, 5.229875047878322],
            [3.013952333291594, 5.2265195926451264],
            [3.0144717640965424, 5.212355536905459],
            [2.927923288458814, 5.209146472665197],
            [2.841931152058453, 5.205892075530703],
            [2.8413388240748425, 5.220600995964821]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.40178343163136, "lat": 44.00377808306112 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27109"],
        "coty_name": ["Olmsted"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Olmsted County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00659500"
      },
      "bbox": [
        2.836836320831796, 5.205892075530703, 3.2794360182480276,
        5.575277365983143
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.223705930093765, 5.896201060538505],
            [2.3117301623003224, 5.89873886492663],
            [2.347707847323672, 5.899978832512075],
            [2.396263000282709, 5.90123055557903],
            [2.3982087198812336, 5.829493922887378],
            [2.4450578052211687, 5.830096045450716],
            [2.4484815533951325, 5.8304274349968965],
            [2.5062946316260253, 5.831900726527961],
            [2.527363416916026, 5.833045067808368],
            [2.5705198224255263, 5.834489846988564],
            [2.571625653912449, 5.791356405861069],
            [2.572529068102129, 5.762643306726641],
            [2.5729195900718214, 5.741085661002761],
            [2.5739713193024722, 5.704871310941293],
            [2.5762898951965143, 5.617907923203209],
            [2.5779182044182054, 5.560001523192952],
            [2.574499167529137, 5.559885646126936],
            [2.491401146740191, 5.557217008395582],
            [2.402686770657899, 5.554548757725963],
            [2.3544896059461347, 5.552933130228733],
            [2.3169038897942396, 5.552062556892514],
            [2.2606304982008494, 5.550563078548872],
            [2.2321359331645074, 5.549569766277667],
            [2.2291284455813973, 5.665393630989027],
            [2.2279783186640287, 5.723420524765746],
            [2.2265205741741823, 5.781166424917247],
            [2.223705930093765, 5.896201060538505]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.29669766132683,
          "lat": 44.354252905537045
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27131"],
        "coty_name": ["Rice"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rice County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00659511"
      },
      "bbox": [
        2.223705930093765, 5.549569766277667, 2.5779182044182054,
        5.90123055557903
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.8335878770806122, 6.762444033230556],
            [1.8372373361216068, 6.756602428847226],
            [1.844564006979719, 6.752298808139012],
            [1.8486293011684007, 6.745377126098271],
            [1.854281039383437, 6.742927547850439],
            [1.8615481123339572, 6.744801228893645],
            [1.863547293556148, 6.741560129571267],
            [1.8591190923834917, 6.7361622504302625],
            [1.8601215126858046, 6.7319105737771245],
            [1.8640435048466646, 6.732101514904744],
            [1.864372719282173, 6.73735461226966],
            [1.8701851934266898, 6.742145907202127],
            [1.8777320596476839, 6.740009195793036],
            [1.8823197006970096, 6.73227334608382],
            [1.888851926879792, 6.72795217575751],
            [1.8952558863173241, 6.72167622791318],
            [1.899688078734886, 6.7189308590423575],
            [1.9031199954471312, 6.721412003462047],
            [1.905042689906015, 6.725203350457232],
            [1.9149447841413494, 6.726018686162429],
            [1.9189171244670284, 6.727353649139104],
            [1.9250810084504222, 6.726145009535531],
            [1.929293717933301, 6.723430638725138],
            [1.9317802976899165, 6.714601209484959],
            [1.937164287068704, 6.710686478516111],
            [1.944971936311363, 6.706768826856112],
            [1.9471053357924466, 6.704576916119813],
            [1.9493163010914911, 6.695387380601299],
            [1.9536009818295028, 6.689195202345936],
            [1.9637384106782367, 6.681542230409388],
            [1.9754008293186265, 6.67952248744037],
            [1.9814705358882307, 6.679820272547168],
            [1.987765862060515, 6.6783118151766026],
            [1.9914687362775771, 6.67164505682114],
            [1.9984083539120376, 6.665667353347968],
            [2.00060795137621, 6.661419571842211],
            [2.008450906293021, 6.654924450583289],
            [2.0173461149796323, 6.652384824731244],
            [2.0316829206397164, 6.6426197257298005],
            [2.039327208237955, 6.640125213853835],
            [2.0455483373715775, 6.640829941076503],
            [2.0546056835170265, 6.6451671533505765],
            [2.066281965227536, 6.645630279595467],
            [2.077484452414496, 6.643510306040025],
            [2.084643139645195, 6.645597133752706],
            [2.0903398355955236, 6.651109787771121],
            [2.09932410229658, 6.642529818114203],
            [2.103511504788803, 6.641612796946861],
            [2.1091589790473586, 6.642514230280707],
            [2.116222317388153, 6.642047189110473],
            [2.1208566255091577, 6.64312951354288],
            [2.134584123497448, 6.642810049822789],
            [2.1417329946574446, 6.640223293956111],
            [2.147092313206869, 6.639804466877433],
            [2.158489885150099, 6.640565922028326],
            [2.1640881970331804, 6.6398562176605695],
            [2.16882555771302, 6.642110639192147],
            [2.172035497340395, 6.64992060677179],
            [2.1768877298142844, 6.648478283779807],
            [2.179347352343747, 6.638998026474201],
            [2.18273903113667, 6.6325298638494345],
            [2.1843997951629146, 6.616247660671908],
            [2.185474177232184, 6.613643238144056],
            [2.1931688990363094, 6.6051630972882105],
            [2.1996596218719673, 6.603990847769838],
            [2.2034172924493802, 6.601045140767362],
            [2.207248270917836, 6.59593669997647],
            [2.20676038577527, 6.593689638827502],
            [2.2123347870293526, 6.589413063336094],
            [2.2087028300258496, 6.587668035844546],
            [2.207521605292707, 6.581879557984298],
            [2.2042448387018516, 6.578003820982829],
            [2.2050109558783118, 6.574345025568279],
            [2.2029366389164586, 6.571771331132729],
            [2.1995367974731987, 6.57483912025995],
            [2.19890457269764, 6.57979820234105],
            [2.192852993202253, 6.581616472833244],
            [2.18937341057663, 6.575678695352578],
            [2.180962703511663, 6.575616747608389],
            [2.1789714198283585, 6.571730236506142],
            [2.173982970817023, 6.56714394944501],
            [2.1701130429338593, 6.567096464279018],
            [2.1603534366514685, 6.5631024380452905],
            [2.1573760878158574, 6.55733869966022],
            [2.15173771023045, 6.556197573621331],
            [2.150131626965966, 6.560878430356869],
            [2.147498284513484, 6.560148170324872],
            [2.1454597295817326, 6.556086218990865],
            [2.141666193438061, 6.5574804112847485],
            [2.1362408984246097, 6.557350392957764],
            [2.1358299608930493, 6.550565246201835],
            [2.1314867852965684, 6.550510243906643],
            [2.1287595708447826, 6.556735319173207],
            [2.1249708223126538, 6.556744167320954],
            [2.1212088989440008, 6.549070928347551],
            [2.118657148201038, 6.546222341787594],
            [2.11318047786918, 6.544750243661713],
            [2.112011624198164, 6.5407621168429415],
            [2.113718995869087, 6.535738318107444],
            [2.117637537738981, 6.529936170644102],
            [2.122251515506808, 6.526671727522488],
            [2.1267579492553215, 6.5218382308029215],
            [2.1269921458386554, 6.513348086412398],
            [2.1207398630518637, 6.506219772875729],
            [2.111443076284624, 6.5007363328653005],
            [2.107933625928278, 6.501778691648482],
            [2.0991285690743933, 6.49764391501063],
            [2.0953834893921326, 6.497031844763523],
            [2.091739327434142, 6.490363977563074],
            [2.088229897129894, 6.4882518082847005],
            [2.083680922201607, 6.4825034819679646],
            [2.082894717854896, 6.4784553506938645],
            [2.0794850419670445, 6.472778235865123],
            [2.076293966067591, 6.469869298957887],
            [2.070478093683635, 6.461064512444484],
            [2.0670723120521854, 6.450223709987853],
            [2.0664984447216126, 6.445057873591265],
            [2.064558670199024, 6.444005817142464],
            [2.065212105305249, 6.436633099965751],
            [2.0617963401934056, 6.433785769954885],
            [2.0581462984584014, 6.427481057826615],
            [2.051799192646404, 6.4254505518461915],
            [2.0421840152353594, 6.427361316319437],
            [2.044775385749871, 6.419127716422604],
            [2.0405680574218654, 6.417183243162427],
            [2.039265469344467, 6.406383111103231],
            [2.039911200678913, 6.374480117485673],
            [2.040630642668287, 6.324210927537624],
            [2.0354671370952717, 6.324406147377381],
            [1.9832585141957282, 6.323708016647132],
            [1.9752757692722094, 6.322982322702944],
            [1.8677898479878332, 6.32145754158882],
            [1.8387496390484048, 6.320794335745228],
            [1.781589907220944, 6.319812051585145],
            [1.6955626202333152, 6.31884618125885],
            [1.6939740186315242, 6.405263884143585],
            [1.692353048580131, 6.505281748364639],
            [1.6913776247404362, 6.549430323552902],
            [1.690314514429548, 6.5772258363496565],
            [1.6878254063061515, 6.577180523608259],
            [1.6864153077756519, 6.621563890019011],
            [1.6858902351536178, 6.635219470858381],
            [1.6906752749286569, 6.638258788253967],
            [1.6889226448978916, 6.6438040931495514],
            [1.6919565608723113, 6.645883154133864],
            [1.6989467928735236, 6.645929679439483],
            [1.7019846787883983, 6.647435739442137],
            [1.7138652619065293, 6.6500480032529365],
            [1.7160180913470364, 6.653574815522417],
            [1.724131593417779, 6.65358725405887],
            [1.7263918240233171, 6.655462473447371],
            [1.732738980216701, 6.657218959978344],
            [1.738178901182423, 6.6565316746430545],
            [1.742972949209254, 6.65165101116878],
            [1.7477459367233044, 6.640083561647043],
            [1.7544090627673057, 6.639961605856068],
            [1.7565889336871263, 6.64294871478278],
            [1.7594445651453774, 6.64282375801395],
            [1.7870388313741596, 6.667281505136958],
            [1.7920071655191239, 6.676904773513788],
            [1.7992726321210855, 6.6827841807472534],
            [1.8029212392441578, 6.681765548112213],
            [1.8058142884169495, 6.686140418457496],
            [1.8033679467153718, 6.68768866758401],
            [1.802933106041171, 6.692831825265471],
            [1.8059782956947927, 6.698862134992531],
            [1.8070262867372424, 6.703689806913895],
            [1.8108226073530411, 6.705412409499765],
            [1.8076819347929574, 6.713620120736951],
            [1.8076061467287599, 6.719123544217926],
            [1.813031902683717, 6.723417544899347],
            [1.8170683171239133, 6.734156257092997],
            [1.8203581064344312, 6.73884574713886],
            [1.8191012378335858, 6.743413592588529],
            [1.821161403721135, 6.748262920499519],
            [1.827725551856602, 6.755542229929339],
            [1.8273763484874077, 6.760535325956528],
            [1.8299082227719456, 6.763180722597842],
            [1.8335878770806122, 6.762444033230556]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.96303361401606,
          "lat": 45.173985376142234
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27171"],
        "coty_name": ["Wright"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wright County"],
        "coty_fp_code": "171",
        "coty_gnis_code": "00659530"
      },
      "bbox": [
        1.6858902351536178, 6.31884618125885, 2.2123347870293526,
        6.763180722597842
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.054057241476208, -5.9704181643578185],
            [6.0582429332503125, -5.970100027774129],
            [6.114680545486116, -5.966120894618914],
            [6.115055665895825, -5.965646104152856],
            [6.21680718054358, -5.958314887947051],
            [6.221809453700869, -5.958055657077615],
            [6.3160290168972, -5.951188123420434],
            [6.343957797751752, -5.949061064102248],
            [6.352012061974494, -5.9487604063810435],
            [6.395049283283499, -5.9452961468987],
            [6.3955366483616665, -5.963839581080954],
            [6.3989348819718845, -6.0059841653664705],
            [6.4010790278341245, -6.0356683390325125],
            [6.403175336673171, -6.05877641091311],
            [6.403149938248011, -6.062057138109158],
            [6.408316064137259, -6.127916410272348],
            [6.41024269106308, -6.150044493550366],
            [6.417091256723208, -6.238535550480509],
            [6.422028343698391, -6.296941907320288],
            [6.364902221760121, -6.30129800422325],
            [6.250962218534866, -6.309673563152136],
            [6.193762687250738, -6.313956426268087],
            [6.078890520396829, -6.322395127335344],
            [6.0729845307256465, -6.238186683037867],
            [6.067227348691463, -6.157079847850449],
            [6.060668305962999, -6.062906280234596],
            [6.056968936412399, -6.008325741768862],
            [6.054057241476208, -5.9704181643578185]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.11876922466875, "lat": 32.40022784295432 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28101"],
        "coty_name": ["Newton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newton County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00695773"
      },
      "bbox": [
        6.054057241476208, -6.322395127335344, 6.422028343698391,
        -5.9452961468987
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.65979561359013, -3.489782926357316],
            [6.745153286999387, -3.4830029296300027],
            [6.792130435242689, -3.478987803252178],
            [6.7935120630655925, -3.4833611745045365],
            [6.804074830989247, -3.4989402434810084],
            [6.814270791927082, -3.510615812109614],
            [6.818119596379098, -3.51767817055474],
            [6.828437793034878, -3.5388025518343587],
            [6.83501016137596, -3.5494347194807774],
            [6.842388109561713, -3.556923255131314],
            [6.850767378061669, -3.563079888260382],
            [6.860659543559931, -3.5676791229496616],
            [6.881633082697914, -3.574151144025142],
            [6.8835026249364235, -3.5759075779596516],
            [6.882402573065867, -3.6573708064354755],
            [6.880672740261055, -3.7234759535322124],
            [6.880895847829824, -3.745680831705419],
            [6.876486290353999, -3.8486447524929503],
            [6.875647526865445, -3.8824720951368574],
            [6.875240453738197, -3.890087699345058],
            [6.871818122600952, -4.00994521157489],
            [6.846907283722235, -4.011780726440135],
            [6.730844398314478, -4.021088308710012],
            [6.7258743956311475, -3.966284124366936],
            [6.720029459073896, -3.9040694743796234],
            [6.716838531101012, -3.8591647311976427],
            [6.707093957175261, -3.743315085171056],
            [6.692775241544468, -3.744315772160687],
            [6.691556223489308, -3.729794956846782],
            [6.677643157321219, -3.730662484330637],
            [6.673937164376915, -3.6867268467646377],
            [6.669595331296441, -3.631624227412013],
            [6.664218098302654, -3.5560384376246965],
            [6.65979561359013, -3.489782926357316]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.23929395397785, "lat": 34.7404053101243 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28141"],
        "coty_name": ["Tishomingo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tishomingo County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00695791"
      },
      "bbox": [
        6.65979561359013, -4.021088308710012, 6.8835026249364235,
        -3.478987803252178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5048676443679296, 9.262375178175791],
            [-3.470533177712315, 9.26025959916937],
            [-3.417788946457054, 9.257321361445259],
            [-3.33121113721902, 9.252145902306868],
            [-3.308853655113231, 9.251095832237857],
            [-3.2589653411125847, 9.248218097509431],
            [-3.157522444119784, 9.242742961918282],
            [-3.070573860474697, 9.238046911096294],
            [-2.983602455302491, 9.233510334979044],
            [-2.9182884236055338, 9.229808966343148],
            [-2.8966581830412546, 9.229180995369193],
            [-2.8966858380590157, 9.228710653310664],
            [-2.8100854242268434, 9.22432776593797],
            [-2.723137646023165, 9.219553063812702],
            [-2.636000218375561, 9.215318312964238],
            [-2.6373064543797673, 9.187115451417492],
            [-2.6389310287704992, 9.158690876810596],
            [-2.6412902115765613, 9.103291425160855],
            [-2.644266476563506, 9.045302198087219],
            [-2.703430941612505, 9.047992928880863],
            [-2.707963713883188, 8.964711259237628],
            [-2.712288177758068, 8.87924406513095],
            [-2.7184767173323228, 8.752336462310177],
            [-2.72085648435017, 8.708481945971837],
            [-2.772687021306194, 8.71106199449701],
            [-2.776595203546602, 8.629337935690865],
            [-2.7811784712728445, 8.543681060762223],
            [-2.8247620934084536, 8.54569544735189],
            [-2.9117751568764727, 8.549975700624142],
            [-2.9286786292250393, 8.551032800430795],
            [-2.9351003791939663, 8.559993706516178],
            [-2.939950986753616, 8.56792767787874],
            [-2.9440808224846897, 8.581636562342455],
            [-2.94544274667589, 8.589488313866752],
            [-2.94492013678475, 8.598029619326098],
            [-2.939777218192439, 8.611155886343314],
            [-2.935247951668737, 8.619192725052995],
            [-2.9320203120048083, 8.627198363872822],
            [-2.931550859858386, 8.633475777069924],
            [-2.932163551090855, 8.642664295776493],
            [-2.934788906383593, 8.648046126052805],
            [-2.939066900116781, 8.650507980186081],
            [-2.9418634498894485, 8.65407941408708],
            [-2.942578945110226, 8.658626592668117],
            [-2.9482102870990334, 8.664664999416871],
            [-2.9591012294163734, 8.671828898437028],
            [-2.963697271300346, 8.676598490459028],
            [-2.970816677726078, 8.681432663444161],
            [-2.982240095855886, 8.684954328016358],
            [-2.9863045209598273, 8.688121380024347],
            [-2.998496361596886, 8.69004446361213],
            [-3.0048777784569665, 8.69228194268289],
            [-3.009791479070295, 8.69123912476514],
            [-3.017530401074387, 8.691743591180833],
            [-3.0286364039028655, 8.69032781819768],
            [-3.0448053341348014, 8.684033495559948],
            [-3.068849350262852, 8.679997122843004],
            [-3.072915950420135, 8.67567018811435],
            [-3.0752951277702727, 8.668502318669404],
            [-3.0752769440570233, 8.660832446659509],
            [-3.080560373826131, 8.649354553476995],
            [-3.085742449271143, 8.647902028758292],
            [-3.0943307787278256, 8.649780878357214],
            [-3.103212483830018, 8.654902636774517],
            [-3.1069513897355057, 8.658924810809152],
            [-3.117343859788956, 8.665981791068623],
            [-3.1217722560901113, 8.667440027944938],
            [-3.124130977736236, 8.671704494125075],
            [-3.13056029501675, 8.676488559337054],
            [-3.1392930516844038, 8.68159577865013],
            [-3.149884762850692, 8.685231397479953],
            [-3.1638216899819254, 8.692500711193457],
            [-3.1769738021050764, 8.69431356479056],
            [-3.1806993180605745, 8.697277393905695],
            [-3.181281725910269, 8.701444611680909],
            [-3.180573269796835, 8.709083803473433],
            [-3.181385984130966, 8.717595787316782],
            [-3.1862797383325074, 8.729975727657575],
            [-3.1860640249923113, 8.744530564783412],
            [-3.1872881681180436, 8.760148506194184],
            [-3.1865404967191013, 8.769652336220696],
            [-3.189434124174043, 8.773946814970657],
            [-3.1963684128768555, 8.777975300005117],
            [-3.2083846387199464, 8.795672297585263],
            [-3.2131468204490403, 8.80774638190918],
            [-3.2142355632970028, 8.813710541471483],
            [-3.2153314407100475, 8.827839961310467],
            [-3.2179319552861108, 8.840675817968407],
            [-3.224443218356711, 8.853042908863005],
            [-3.2337944860620693, 8.86456929867132],
            [-3.236181624583163, 8.869246201867151],
            [-3.236655404478916, 8.875173796649872],
            [-3.234446243935145, 8.88271934917555],
            [-3.2228103865150874, 8.896061445333814],
            [-3.218283019153866, 8.900022354121106],
            [-3.2091627175745088, 8.90524699464059],
            [-3.196776319624583, 8.910255043781337],
            [-3.1884514452529342, 8.916154817421663],
            [-3.1850820039420342, 8.920646064939728],
            [-3.1838962621293425, 8.926290527675576],
            [-3.1856176334596173, 8.929207111400503],
            [-3.1968978175073284, 8.937777593575158],
            [-3.2014371278486555, 8.940332531428455],
            [-3.217178691959157, 8.961072754312935],
            [-3.2214255749030762, 8.965240970864096],
            [-3.2268654191825457, 8.967610438530393],
            [-3.2338351382420103, 8.968291027560563],
            [-3.2390813466927217, 8.967393371734527],
            [-3.2568065752458333, 8.960789088260142],
            [-3.2643612292688275, 8.962452832241079],
            [-3.2696733753685354, 8.9624469139858],
            [-3.2793632118549296, 8.95772848399736],
            [-3.3052292368215763, 8.951137852675116],
            [-3.3092795942294564, 8.948486631486585],
            [-3.324687336239652, 8.94369592472767],
            [-3.3477323532617658, 8.939863299403802],
            [-3.357990052879324, 8.940786527142226],
            [-3.36379507353184, 8.9396479764528],
            [-3.3682949537113767, 8.940663138152587],
            [-3.383558687472388, 8.947708745876215],
            [-3.3974031174289245, 8.951841460122594],
            [-3.405613398098463, 8.953325594340402],
            [-3.412372746043701, 8.95299818659439],
            [-3.430501854531966, 8.948073162161247],
            [-3.436174366503925, 8.945519258621468],
            [-3.4700519279235587, 8.924841587867595],
            [-3.4755018562477074, 8.922844450888642],
            [-3.485766997026208, 8.916810679076159],
            [-3.493933719502087, 8.914748151456806],
            [-3.5019986242844583, 8.916291768461853],
            [-3.513778468764638, 8.922556055213015],
            [-3.5228252489802294, 8.926058179780664],
            [-3.534596981369492, 8.926263711709845],
            [-3.539539283900146, 8.928082083314633],
            [-3.5598789150074097, 8.947226588854893],
            [-3.5668274987025725, 8.953152188994359],
            [-3.5746945624995483, 8.958425290687554],
            [-3.5855608343441827, 8.963133091942863],
            [-3.5919117271100767, 8.964485214144382],
            [-3.6042567927301623, 8.965655818608068],
            [-3.611014203991892, 8.965468780141892],
            [-3.6233263026437843, 8.963534662087195],
            [-3.6285581141092065, 8.96582919665812],
            [-3.632051919358325, 8.971849870997326],
            [-3.630888398175617, 8.975119961138882],
            [-3.624871817671843, 8.983984968251125],
            [-3.624072949656637, 8.986884463155828],
            [-3.628601802823122, 8.996902570438946],
            [-3.633416028063907, 9.000350753314107],
            [-3.6374213563360436, 9.000504168855402],
            [-3.643328671727297, 8.998614709845357],
            [-3.6509772056064196, 8.998211948850948],
            [-3.6601874542736574, 9.003119398604662],
            [-3.668701899569571, 9.00405157111727],
            [-3.6764225243446838, 9.001493492168878],
            [-3.685059066101651, 9.000567553004457],
            [-3.69378983373789, 9.001320128272678],
            [-3.7007764756028387, 8.999602857507506],
            [-3.7101687293270893, 8.999613304786369],
            [-3.7173957448862196, 8.99840472772091],
            [-3.7335502652582075, 9.002195305096338],
            [-3.744658382757479, 9.007139878985532],
            [-3.7476391521585644, 9.009396989890105],
            [-3.757990831201465, 9.022650625521031],
            [-3.760678451930666, 9.029313108416348],
            [-3.7637795737722186, 9.033839581670005],
            [-3.776977473059297, 9.046099780554254],
            [-3.7834982838371287, 9.054389039937103],
            [-3.7851112413928054, 9.060784866871467],
            [-3.78305059139465, 9.071265512613367],
            [-3.782757304821223, 9.08480887990689],
            [-3.783393454519781, 9.093596530531574],
            [-3.782464046567217, 9.101397250206968],
            [-3.7801337154387484, 9.111857484010368],
            [-3.7792079675015486, 9.13282265072367],
            [-3.776516229749069, 9.147678707021702],
            [-3.7758058525562648, 9.156276710235568],
            [-3.7768312558906403, 9.16125480614222],
            [-3.786708646037086, 9.167890707096419],
            [-3.7903343690546807, 9.172547511217726],
            [-3.792360954442107, 9.178769472024117],
            [-3.7940772247225016, 9.188604736598998],
            [-3.790210756688728, 9.191592678726028],
            [-3.781632967970713, 9.189952140693391],
            [-3.7777432548391037, 9.191269745059532],
            [-3.7732594346076533, 9.195396743219513],
            [-3.770934073729738, 9.200744536226333],
            [-3.770191329780201, 9.206784344788863],
            [-3.7717955844137974, 9.214254145788523],
            [-3.778761842323826, 9.218635700243789],
            [-3.790358198049716, 9.221749664338887],
            [-3.8025187745977966, 9.227553729385262],
            [-3.810191479362087, 9.232475799586842],
            [-3.8208877187977954, 9.236813403990078],
            [-3.825641823263025, 9.236734114061736],
            [-3.8323419965344274, 9.232954556098141],
            [-3.8369144834228712, 9.227561953544134],
            [-3.844833493479328, 9.212864998406879],
            [-3.847514536722415, 9.20538287503766],
            [-3.8503347079965344, 9.201838010029501],
            [-3.8576612000504835, 9.196921766441328],
            [-3.8516050594165576, 9.28465207271377],
            [-3.7822284293643724, 9.279863329083737],
            [-3.682741381797088, 9.273600746859294],
            [-3.671228630884416, 9.272770115567663],
            [-3.5916824327183354, 9.267772885966332],
            [-3.5048676443679296, 9.262375178175791]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.32182214880716,
          "lat": 47.606945578435294
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38055"],
        "coty_name": ["McLean"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McLean County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01034232"
      },
      "bbox": [
        -3.8576612000504835, 8.543681060762223, -2.636000218375561,
        9.28465207271377
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.773873265632165, 3.23743627121384],
            [8.814531141580344, 3.2423494694019874],
            [8.872798478079853, 3.2498298722893084],
            [8.915314616744798, 3.255056841918262],
            [9.051004969349519, 3.271972427442948],
            [9.064793637028037, 3.273860878342282],
            [9.115211059787132, 3.2801452398856785],
            [9.198764388472105, 3.2907247320044934],
            [9.210445874086492, 3.203633446715832],
            [9.221236659765205, 3.1164133560628793],
            [9.231555751879952, 3.029123047683558],
            [9.15477299767033, 3.0191927618228322],
            [9.147576182918211, 3.018390571509149],
            [9.142202302060166, 3.0618886849637197],
            [9.127833770719384, 3.0603251745627724],
            [9.07161464819313, 3.053351344434576],
            [9.056639696479554, 3.051787305601478],
            [9.051142826011567, 3.0957892728549017],
            [8.975952504377256, 3.0858016327184914],
            [8.937198342399903, 3.0813119141745093],
            [8.879424007692224, 3.074017673161758],
            [8.794818727497699, 3.0640879814971305],
            [8.792600990957613, 3.0824471420130064],
            [8.781060568185575, 3.1771732791642666],
            [8.773873265632165, 3.23743627121384]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.49049041709226, "lat": 41.32390659467342 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39039"],
        "coty_name": ["Defiance"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Defiance County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01074032"
      },
      "bbox": [
        8.773873265632165, 3.018390571509149, 9.231555751879952,
        3.2907247320044934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.24272000971061, 2.275318609299213],
            [11.276883949312124, 2.2792826912279605],
            [11.270639843567345, 2.33651008903165],
            [11.268525105828104, 2.3509190095069594],
            [11.302546021683247, 2.3549075149893404],
            [11.40427755188539, 2.367024897460403],
            [11.516294711678063, 2.380416508143006],
            [11.521695309540977, 2.3383243487125887],
            [11.607023276147501, 2.3496694055758174],
            [11.610377187913075, 2.3228091949196537],
            [11.623877480859845, 2.219019405769852],
            [11.627472063334453, 2.1899607625734907],
            [11.635106784744993, 2.130745159723654],
            [11.582762771362766, 2.1241675523582515],
            [11.549398637645037, 2.119794989860416],
            [11.549909711214363, 2.116127740426704],
            [11.521146015936358, 2.11241399929987],
            [11.525052545142781, 2.0832432644931176],
            [11.467715145605085, 2.0764093131387473],
            [11.471146207490548, 2.0473952748334012],
            [11.384644996648616, 2.0373203841671153],
            [11.392285367545513, 1.9787174980800228],
            [11.378012867654494, 1.9771850089258887],
            [11.316267900516767, 1.970020302545628],
            [11.30613301977338, 1.9692097504719341],
            [11.29951880067113, 2.021052452149919],
            [11.299479518713872, 2.023028605739377],
            [11.295082701861642, 2.0574292216222956],
            [11.26675843576994, 2.0541324379395838],
            [11.258909229652769, 2.1281976309174624],
            [11.25262951622552, 2.1855146719377356],
            [11.247483223217307, 2.230821430856591],
            [11.24272000971061, 2.275318609299213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.49424749160235, "lat": 40.05201488253256 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39059"],
        "coty_name": ["Guernsey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Guernsey County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01074042"
      },
      "bbox": [
        11.24272000971061, 1.9692097504719341, 11.635106784744993,
        2.380416508143006
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.570820164296386, 1.480258781564482],
            [10.565702465248567, 1.567269729111189],
            [10.564591069092058, 1.5820115798505279],
            [10.625950299921174, 1.58672738739857],
            [10.648629447126078, 1.5886911694857464],
            [10.644231162675032, 1.6335374538436565],
            [10.696524109064036, 1.6379175932648267],
            [10.736804942468698, 1.6408476859887284],
            [10.732767238143369, 1.7002563425980561],
            [10.764445110913242, 1.702118236166515],
            [10.821159525439944, 1.7060801898951485],
            [10.823016866335312, 1.684389680695823],
            [10.825506533889467, 1.6473569372646721],
            [10.848534588462565, 1.6490611565338116],
            [10.886815997493342, 1.6515202614647535],
            [10.915499242036432, 1.6541278963388515],
            [10.91841817120372, 1.6255392541677245],
            [10.991220133749596, 1.630732970273847],
            [10.998134378717362, 1.6315086841461757],
            [11.00513845705693, 1.540477555822448],
            [11.003019508748482, 1.5402109670739952],
            [10.918644510968292, 1.5345862552574365],
            [10.924515686915772, 1.4449775240646103],
            [10.877373216763912, 1.441383867013364],
            [10.835995205508043, 1.4384917311547136],
            [10.752494932326075, 1.4320036632859203],
            [10.754122492497018, 1.4111349063895566],
            [10.75389838687696, 1.4053940523129567],
            [10.68389214810892, 1.4003499217878694],
            [10.664420398083132, 1.3992989581743738],
            [10.665472117207852, 1.38477034121961],
            [10.636516621833579, 1.382304562769156],
            [10.578921178409066, 1.3793009435177126],
            [10.573374306025391, 1.4474446608830747],
            [10.570820164296386, 1.480258781564482]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.47922028937417, "lat": 39.49705653566618 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39073"],
        "coty_name": ["Hocking"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hocking County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01074049"
      },
      "bbox": [
        10.564591069092058, 1.3793009435177126, 11.00513845705693,
        1.7060801898951485
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.768386423645316, 3.133107431957331],
            [10.758828989648597, 3.206550714041066],
            [10.829586029358996, 3.21628796052655],
            [10.821585196988858, 3.2796078157762696],
            [10.894363030078882, 3.290351082488538],
            [10.892764181623498, 3.2993659078073327],
            [10.889178236697346, 3.328143641970085],
            [10.884286130592475, 3.365160699433163],
            [10.917826387318666, 3.3701355638050137],
            [10.922583109789349, 3.371415810398225],
            [10.939308282938885, 3.373437339730169],
            [10.953888993850981, 3.3757447865353556],
            [11.02221401994394, 3.3874191443733825],
            [11.081398769329459, 3.397136180309961],
            [11.095934082284515, 3.399256311814878],
            [11.106766919195925, 3.324544162742622],
            [11.115784130215477, 3.258542955300551],
            [11.11940407131408, 3.233223580525335],
            [11.13186724145604, 3.148681172924044],
            [11.136964357244931, 3.1117008683840095],
            [11.084501786058462, 3.1033846169717902],
            [11.0330974133097, 3.0957191203090013],
            [10.991281266163671, 3.090337068905631],
            [10.883310460463113, 3.0755932606702627],
            [10.810096102699882, 3.0662273343368214],
            [10.77744930315448, 3.061723173369511],
            [10.768386423645316, 3.133107431957331]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.8996934879942, "lat": 41.117578334206705 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39103"],
        "coty_name": ["Medina"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Medina County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01074064"
      },
      "bbox": [
        10.758828989648597, 3.061723173369511, 11.136964357244931,
        3.399256311814878
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.810096102699882, 3.0662273343368214],
            [10.883310460463113, 3.0755932606702627],
            [10.991281266163671, 3.090337068905631],
            [11.0330974133097, 3.0957191203090013],
            [11.084501786058462, 3.1033846169717902],
            [11.136964357244931, 3.1117008683840095],
            [11.167166415750804, 3.11625569229472],
            [11.178440596570235, 3.0420425651415504],
            [11.187456107570398, 2.9822590176279635],
            [11.203054687771907, 2.877492935021545],
            [11.20457354376895, 2.862829547699598],
            [11.214190393480928, 2.796948502157573],
            [11.214096106456783, 2.796588724997718],
            [11.157381793229598, 2.7882911784475675],
            [11.12857157082012, 2.783651362882373],
            [11.08941466465981, 2.7779224937176505],
            [11.0571495978379, 2.772400514141567],
            [11.004657360578006, 2.764525999934788],
            [10.95927233280133, 2.75852084103758],
            [10.91440848029828, 2.7523441690286075],
            [10.87424592127399, 2.7458306088740594],
            [10.859866710544935, 2.7442592826549057],
            [10.851303043800028, 2.802243772590426],
            [10.8390907969327, 2.8795747345616673],
            [10.833697434996026, 2.925661595899732],
            [10.828780370129635, 2.9615469088547215],
            [10.824489813254706, 2.975817935389038],
            [10.819748318378466, 3.0047159016840426],
            [10.819158334203227, 3.011949426190409],
            [10.814513829684602, 3.038780354219736],
            [10.810096102699882, 3.0662273343368214]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.888010610194, "lat": 40.82885884821253 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39169"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "01074096"
      },
      "bbox": [
        10.810096102699882, 2.7442592826549057, 11.214190393480928,
        3.11625569229472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9322053485857114, -1.717155686347217],
            [1.042824567515624, -1.716177434647649],
            [1.114463786075376, -1.715517990014669],
            [1.1965569773285054, -1.7147739842025458],
            [1.2486706281527276, -1.7142430841496825],
            [1.2429235278913624, -1.7188598167353233],
            [1.2376591798236782, -1.7185689925795857],
            [1.227853492799617, -1.7197613070476232],
            [1.2278713785674817, -1.7294563366565792],
            [1.2320197065405396, -1.7348954897027893],
            [1.229900149773479, -1.7388684267603347],
            [1.2328432847751942, -1.7477240306552937],
            [1.2375164821528262, -1.7534319666722153],
            [1.2515122752054864, -1.7615334341415774],
            [1.258082797724219, -1.7622980164161608],
            [1.2604596012097347, -1.7641521327540473],
            [1.258823316324495, -1.770948608263615],
            [1.2559687983391232, -1.7711028465329206],
            [1.256773823358188, -1.855708060599795],
            [1.2579595562718853, -1.9727743349590032],
            [1.2586654183389798, -2.0460319303783034],
            [1.2593996732886923, -2.1192758145179593],
            [1.2544415758425425, -2.1197011148598],
            [1.255336690346211, -2.2082407423279413],
            [1.1980611813409416, -2.208394122392363],
            [1.1707915224226848, -2.208341932690505],
            [1.0736698234002842, -2.2094366821665754],
            [0.9986261099311491, -2.2101360941255703],
            [0.9978434480044241, -2.121978747114157],
            [0.9157768523719464, -2.1226045601987034],
            [0.9150608789437931, -2.0202220121744014],
            [0.9147185485216667, -1.9616789193235797],
            [0.9141337945615894, -1.8740100407709852],
            [0.9135445268621968, -1.7744408165627885],
            [0.9324732040380884, -1.774207241358871],
            [0.9322053485857114, -1.717155686347217]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.20845528549025, "lat": 36.76176140981433 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40035"],
        "coty_name": ["Craig"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Craig County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01101805"
      },
      "bbox": [
        0.9135445268621968, -2.2101360941255703, 1.2604596012097347,
        -1.7142430841496825
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2301100996488956, -3.334940234475428],
            [-1.1715453576306252, -3.33614402664954],
            [-1.1681199020105675, -3.335595217487202],
            [-1.1621233567137035, -3.3427969314313373],
            [-1.1599259549092482, -3.347490272873749],
            [-1.1625931232540268, -3.3505375864511486],
            [-1.161648240808426, -3.3535261969670502],
            [-1.1580705444707402, -3.3539925367973824],
            [-1.154017779153024, -3.35007064299057],
            [-1.1521883801294897, -3.3520018847444315],
            [-1.1415421313325649, -3.35615938650029],
            [-1.1379585994486334, -3.35848544212501],
            [-1.1318378828725186, -3.3578419945724836],
            [-1.1284734461234411, -3.3635718167335735],
            [-1.1244578460660435, -3.3649451620413156],
            [-1.1209713784412871, -3.369312191287053],
            [-1.1169620300122143, -3.369282831551128],
            [-1.1100191419832626, -3.358988381627938],
            [-1.1091739714684141, -3.3529083295477973],
            [-1.1099362387753704, -3.3404127985918586],
            [-1.1068149539807588, -3.3381203843282963],
            [-1.0998940258171281, -3.3401179173182793],
            [-1.0978778716796973, -3.3421403221038153],
            [-1.0966488360153055, -3.351503274622764],
            [-1.0919148833870125, -3.3571152304529916],
            [-1.089057074960547, -3.3623293837522477],
            [-1.084024703297754, -3.363553907612076],
            [-1.077837291212167, -3.3601847661057374],
            [-1.0734836972501296, -3.362718602003435],
            [-1.0748746578217778, -3.370787451047819],
            [-1.072134403682126, -3.372141583818698],
            [-1.0675666591871193, -3.3692993788632672],
            [-1.0619283062448797, -3.369043697068889],
            [-1.059453032992042, -3.367459909568931],
            [-1.0600135982207004, -3.3605901249458126],
            [-1.0533456633691143, -3.361063343408814],
            [-1.0505971244672627, -3.3597455351870806],
            [-1.050382950144181, -3.3556963491722964],
            [-1.0477072530724572, -3.3540828613165514],
            [-1.0419875602813435, -3.354892058779399],
            [-1.0380134305268742, -3.3605763729842146],
            [-1.037504827337668, -3.3719777153136175],
            [-1.0350116712393516, -3.3759123662861237],
            [-1.0251672068907935, -3.3827181133049606],
            [-1.0189595031169132, -3.3819998979964825],
            [-1.0119456765086954, -3.38376743244926],
            [-1.0077661749908866, -3.3822297960938195],
            [-1.0015699225287635, -3.383918297445692],
            [-1.0014694737667023, -3.379421823326241],
            [-0.9974380545737456, -3.3768876466781124],
            [-0.9890093016780853, -3.3788008246076355],
            [-0.9853337461703399, -3.385319511211363],
            [-0.9822649585721408, -3.3814076680053193],
            [-0.9765105684966375, -3.3820554341194575],
            [-0.9712082869878302, -3.378816442947104],
            [-0.9692314039176001, -3.3726526105316146],
            [-0.9655503264101348, -3.373217636218609],
            [-0.9624477615603324, -3.377541916428808],
            [-0.9566141454007678, -3.3797539234099916],
            [-0.9503417665270287, -3.3893323776198123],
            [-0.9412580636635357, -3.395141134266406],
            [-0.9310338128118643, -3.3932421068106597],
            [-0.927206183377542, -3.39060899457584],
            [-0.9221695614244015, -3.391285022513477],
            [-0.9216638208475854, -3.3937819435077112],
            [-0.9161571233522252, -3.3943753786011195],
            [-0.9081777159073388, -3.392036216735759],
            [-0.8988174990093525, -3.3852889191816256],
            [-0.8877599689581706, -3.3838269673150028],
            [-0.8873389431050879, -3.3874281146239094],
            [-0.8896777449412334, -3.5169028658079484],
            [-0.8892743889505607, -3.516908936237183],
            [-0.8904683140827895, -3.5765098738009313],
            [-0.8915341706466513, -3.6410313475921425],
            [-0.8935258461367873, -3.7506883518765135],
            [-0.8953993365635129, -3.8530599464434694],
            [-0.8954915218015482, -3.867668834780319],
            [-0.8935902996637345, -3.867759512036335],
            [-0.8948475692747626, -3.9332956446779495],
            [-0.8970031650437496, -4.042584551376079],
            [-1.0403113755881517, -4.03978459819552],
            [-1.1649421532944644, -4.036965092975997],
            [-1.2399625464765172, -4.035999005035591],
            [-1.2383467091103493, -3.963121050706395],
            [-1.236376850692168, -3.8755360280979567],
            [-1.2364865621759709, -3.861232131421334],
            [-1.2393887983833465, -3.8611090285714926],
            [-1.2370934895847512, -3.761145968213661],
            [-1.2354707188107383, -3.686225559448662],
            [-1.234076302598814, -3.6277886735593823],
            [-1.2325403693072219, -3.6255157194732406],
            [-1.2301960665913756, -3.51022039270655],
            [-1.2331416965328, -3.5101657026410047],
            [-1.2321913128532107, -3.466256238085426],
            [-1.2311899116549416, -3.4079819994043095],
            [-1.2301100996488956, -3.334940234475428]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.88412627699475, "lat": 35.01693847367719 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40051"],
        "coty_name": ["Grady"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grady County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01101813"
      },
      "bbox": [
        -1.2399625464765172, -4.042584551376079, -0.8873389431050879,
        -3.334940234475428
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7317113277970122, -4.142140632734407],
            [0.7324710825302301, -4.142018350869174],
            [0.8144470408937896, -4.141408467306831],
            [0.860144837006162, -4.141168956150304],
            [0.8597283816769224, -4.054115794810693],
            [0.9165491082537, -4.053689816144462],
            [1.0222801085145983, -4.052908260310335],
            [1.1161255025146968, -4.052568316840666],
            [1.1715930610595404, -4.052034574604828],
            [1.2306965250718405, -4.051321837595993],
            [1.3302422467429944, -4.050219243064328],
            [1.331219308122041, -4.137907940870506],
            [1.3319043204357415, -4.19333677333372],
            [1.3321574570702421, -4.22466915552198],
            [1.2429466200418522, -4.225632704084794],
            [1.2438141610511266, -4.314002939983417],
            [1.2441791902471084, -4.338004022501591],
            [1.2457425000694986, -4.490449802398078],
            [1.1598379091557922, -4.491300918259292],
            [1.1606026221036587, -4.578596086946827],
            [1.1563506005578161, -4.578509252180204],
            [1.060442660795493, -4.579339141843747],
            [0.9709386132935215, -4.580022366754104],
            [0.884448853866991, -4.580562013122476],
            [0.8167036484008924, -4.580957001944401],
            [0.7274744344215818, -4.5813526151399975],
            [0.6449050949896307, -4.581630404259507],
            [0.6450324396596857, -4.566509748797743],
            [0.6448039528728716, -4.489588897437764],
            [0.6446114115602081, -4.410813654883844],
            [0.6444027953423267, -4.319498740696529],
            [0.6442841535419086, -4.229955868922518],
            [0.7320630190724347, -4.229552182857736],
            [0.7317113277970122, -4.142140632734407]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.3758582283143, "lat": 34.41616460579269 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40127"],
        "coty_name": ["Pushmataha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pushmataha County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01101851"
      },
      "bbox": [
        0.6442841535419086, -4.581630404259507, 1.3321574570702421,
        -4.050219243064328
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6543865064504649, -2.562252456693358],
            [0.6825767465798507, -2.5624801240879957],
            [0.6971222969043965, -2.5629904898477194],
            [0.703994743496818, -2.5624649267318085],
            [0.7255479880455528, -2.562461386384601],
            [0.7688708210408536, -2.5621195097414056],
            [0.7693873610795308, -2.5744001198216337],
            [0.7707560603599996, -2.578136550462836],
            [0.7752985079693603, -2.5825819785016115],
            [0.7800499910762076, -2.591368072009991],
            [0.7879361386168302, -2.5953974001757834],
            [0.789940956605407, -2.5924768232649753],
            [0.7940141382910629, -2.590684621362525],
            [0.8028581841864657, -2.591164014650514],
            [0.8095563511577119, -2.5953557053536938],
            [0.8073669582704939, -2.6111092692177063],
            [0.8092850068165457, -2.6175163314185963],
            [0.8147614924072519, -2.6257843830296816],
            [0.8219451305998756, -2.633504525259664],
            [0.8187524323992851, -2.642633110266465],
            [0.8126163603674352, -2.6405078304997294],
            [0.8072720657602489, -2.6428924351323335],
            [0.8012833075304868, -2.6410549486355683],
            [0.8005467226698574, -2.644864351292415],
            [0.8068569404245519, -2.6499116937018807],
            [0.9122033797363761, -2.6493785596289485],
            [0.998003296211609, -2.6487627060025094],
            [1.0734988535054464, -2.6488149752314656],
            [1.0980074948868603, -2.6485584225038266],
            [1.0981998068705723, -2.683133491988409],
            [1.084363099909453, -2.6838896388024436],
            [1.0846255427091414, -2.714775569464166],
            [1.0806802700825766, -2.7147501229141264],
            [1.0806985722645341, -2.7217527106743873],
            [1.0775167361524303, -2.7218116529860503],
            [1.0774705615024565, -2.7328845911956137],
            [1.0743040358384883, -2.7365090782066797],
            [1.0632678049727018, -2.736479669043459],
            [1.055007091973186, -2.7448955263771935],
            [1.0481876374878696, -2.750025991805805],
            [1.0453135263768296, -2.7537830276273705],
            [1.0421943597452337, -2.760578208484865],
            [1.0427009343403038, -2.7640210676628305],
            [1.0463243997032639, -2.7685148052490764],
            [1.049374305891692, -2.7773283572893526],
            [1.0505374252740782, -2.793046324065585],
            [1.0500179210558866, -2.7954968693010316],
            [1.0449089053962335, -2.8004945342588994],
            [1.0409611255122, -2.806119119730557],
            [1.0391415602489205, -2.8169087018351044],
            [1.0436681017926301, -2.826709676371483],
            [1.051417847917173, -2.8354230948350647],
            [1.0539329373942365, -2.841431501096986],
            [1.0597186181649005, -2.8479465452655885],
            [1.069028971929599, -2.8508448712753274],
            [1.0766841314596052, -2.8511255466201364],
            [1.079994303187926, -2.852366953241593],
            [1.0825561573866687, -2.8560747374326434],
            [1.0840924889838441, -2.863004132163976],
            [1.081001231937248, -2.874087393227499],
            [1.0763923098870807, -2.877461764912292],
            [1.0682552255689226, -2.8878497582571407],
            [1.0637073233796044, -2.891600771104696],
            [1.0642960371433543, -2.897191059912551],
            [1.0617586586695988, -2.9009653885689475],
            [1.0530985985415764, -2.905304096763316],
            [1.0521236479126381, -2.9097463190966013],
            [1.0538133948422828, -2.912531185233067],
            [0.9959392657753101, -2.912943765074012],
            [0.9905280948432845, -2.9126244444417586],
            [0.9887320927578145, -2.910291464024051],
            [0.9841008116222086, -2.9090612539352305],
            [0.9776679420242551, -2.9038637606797066],
            [0.9748886266102677, -2.9066157777798867],
            [0.9669619124513024, -2.9110022387950303],
            [0.9598315665688212, -2.9123137122553064],
            [0.9533165766401422, -2.9158852631838363],
            [0.9484044810821247, -2.916960701924423],
            [0.944997111321852, -2.9195089349099757],
            [0.9296933094819683, -2.9271626176769203],
            [0.9248303096684403, -2.928421662575135],
            [0.9087355960332169, -2.9269467676218155],
            [0.9032023282697028, -2.924502474245765],
            [0.8948696157380208, -2.9222348620899066],
            [0.8836124080005353, -2.9227933548003753],
            [0.867563562371241, -2.927616659967765],
            [0.8489745541932054, -2.935019362758349],
            [0.8346662465888378, -2.9367147030733975],
            [0.8298066847255282, -2.9391306908191894],
            [0.8271657215388337, -2.9383864067374112],
            [0.822626412895281, -2.940258200692311],
            [0.8203931760299694, -2.9386843472793283],
            [0.8149439476352965, -2.9395581456735806],
            [0.8108108865061177, -2.9445788110760156],
            [0.8036077576812227, -2.956092066973359],
            [0.7977151102849308, -2.962161738540867],
            [0.7932916731188665, -2.962309912648921],
            [0.790550794859572, -2.960115619648478],
            [0.7837493203477639, -2.949592728205955],
            [0.7777892420344121, -2.9512571211046223],
            [0.7680196537280708, -2.9501063820879794],
            [0.7598922914512288, -2.9452967675156114],
            [0.7544791954404229, -2.940126277905517],
            [0.7532781576550736, -2.9367143200278107],
            [0.7550277073915767, -2.9225183765323743],
            [0.7517985925811108, -2.9120932809030435],
            [0.7532677154240786, -2.9058026818042486],
            [0.7536827043376998, -2.8944937141528717],
            [0.7472898355149303, -2.8881034668283725],
            [0.7455768566129187, -2.885185886535947],
            [0.7464447889517355, -2.8798780766322465],
            [0.7439587801312169, -2.8735242713135305],
            [0.7444916387236217, -2.8705721317748045],
            [0.6797464347722999, -2.870932729088481],
            [0.6515770942804552, -2.8712198245533664],
            [0.6087351128997046, -2.871342340921036],
            [0.6086347078416553, -2.8261470394958565],
            [0.654744435267788, -2.825988192951063],
            [0.6550442955984543, -2.793583988980806],
            [0.6546953404470357, -2.6795289217428273],
            [0.6543865064504649, -2.562252456693358]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.52121891497694,
          "lat": 35.961060682205236
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40145"],
        "coty_name": ["Wagoner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wagoner County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01101860"
      },
      "bbox": [
        0.6086347078416553, -2.962309912648921, 1.0981998068705723,
        -2.5621195097414056
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.835618234078975, 8.848589041905923],
            [-18.82141170276768, 8.842598392138504],
            [-18.79394021243826, 8.836415066240745],
            [-18.74600665500245, 8.821745197972623],
            [-18.704733935430806, 8.809434311025285],
            [-18.631577331444475, 8.787312782704337],
            [-18.596761698251, 8.777552341085576],
            [-18.549980395729342, 8.76380238313833],
            [-18.52748916460093, 8.757414544678074],
            [-18.52790822805137, 8.748434446799354],
            [-18.52412854701095, 8.73781143309426],
            [-18.518793367069335, 8.729901231683709],
            [-18.516768038734988, 8.72450269085731],
            [-18.517962108275633, 8.715279938849287],
            [-18.517825811364187, 8.709958224567318],
            [-18.5149185791037, 8.706906306758517],
            [-18.501527038911842, 8.70412111932836],
            [-18.499149976481043, 8.701735643731784],
            [-18.498842326770873, 8.692408948455272],
            [-18.493942010840886, 8.683832437701275],
            [-18.49578373694671, 8.676246556763907],
            [-18.500040639432648, 8.673442492739106],
            [-18.51325673775182, 8.67161472703824],
            [-18.520960045315967, 8.671826473074306],
            [-18.529789509906788, 8.676188916617091],
            [-18.540199265289715, 8.676276095851373],
            [-18.556394308070285, 8.68016449279749],
            [-18.561339346584262, 8.68184652905446],
            [-18.566656279958373, 8.680022772860493],
            [-18.569144893053533, 8.674079996023755],
            [-18.568576976725375, 8.670560786073628],
            [-18.57090490309226, 8.66759070470505],
            [-18.57687108797823, 8.66817830476106],
            [-18.580352617838887, 8.665251403776933],
            [-18.581413591796178, 8.660343216231706],
            [-18.5858554997601, 8.657703758655428],
            [-18.591502105780233, 8.656994066659953],
            [-18.595139042347434, 8.653369908078357],
            [-18.594833930522878, 8.650327049428013],
            [-18.58870035532128, 8.646501194459994],
            [-18.58669088535062, 8.643328505520849],
            [-18.589806319597727, 8.638265101243524],
            [-18.594707944730075, 8.638157588637721],
            [-18.60442962514924, 8.64120681071197],
            [-18.615394326201585, 8.642920171112866],
            [-18.623642882810966, 8.642118859039233],
            [-18.638270089650465, 8.639283590852],
            [-18.641281411439167, 8.636907968077356],
            [-18.648765060342352, 8.62656106644554],
            [-18.64988877442861, 8.622545883120813],
            [-18.64249137283932, 8.61567224756772],
            [-18.639807043288503, 8.611522440519927],
            [-18.640341300447083, 8.608837624775699],
            [-18.647023581758578, 8.60292578384863],
            [-18.652719786677967, 8.596217072253046],
            [-18.65126544086867, 8.592772419966389],
            [-18.64253253769802, 8.592316662899218],
            [-18.639280222833694, 8.585844684820932],
            [-18.638330406122087, 8.57591922820945],
            [-18.63388536548165, 8.57145631341698],
            [-18.631682007779755, 8.565397672583686],
            [-18.63230162950643, 8.561692384692108],
            [-18.636418164308665, 8.555625685868366],
            [-18.637785358418064, 8.550276524752821],
            [-18.64314318386996, 8.54783077276704],
            [-18.639984956552446, 8.541637980442099],
            [-18.641446471215293, 8.536021325335701],
            [-18.644642278044568, 8.531442832560879],
            [-18.644656970807805, 8.519736096475413],
            [-18.646276263108106, 8.513102123182303],
            [-18.644212409757035, 8.505026664248293],
            [-18.647472041146713, 8.499810434357162],
            [-18.651812051019878, 8.498487565626718],
            [-18.6601045499791, 8.500441638828917],
            [-18.66321678682258, 8.4970414539982],
            [-18.66052406593577, 8.485376899422256],
            [-18.661342849510156, 8.482539632214396],
            [-18.666209587327316, 8.484779263646264],
            [-18.668545949003295, 8.483202988517524],
            [-18.669735683438574, 8.475111791964796],
            [-18.670084861250924, 8.463419100424478],
            [-18.670778610589046, 8.461498422758554],
            [-18.67945735610675, 8.456413715430672],
            [-18.688002893502357, 8.456892466214276],
            [-18.68877323180547, 8.453681771061753],
            [-18.68675128001671, 8.446956839609614],
            [-18.684053099371763, 8.443235495712235],
            [-18.67892923631557, 8.439955365167876],
            [-18.676841014107033, 8.43503159198792],
            [-18.677573015499345, 8.428813535050146],
            [-18.684345007175004, 8.430700795928775],
            [-18.6889321785817, 8.429071658176671],
            [-18.68802825166308, 8.416011714976072],
            [-18.691913397652982, 8.412244684097598],
            [-18.698268323826504, 8.411945865720298],
            [-18.702587547699974, 8.408903502097818],
            [-18.703002675075787, 8.406287659239673],
            [-18.697900784083956, 8.402746949093004],
            [-18.689043502494094, 8.40251031551306],
            [-18.686647761562163, 8.399913318224622],
            [-18.68560034925794, 8.394976561177964],
            [-18.689048929514406, 8.384369640613544],
            [-18.68910636800215, 8.381368067583889],
            [-18.686219861356456, 8.378886775082751],
            [-18.676859217294183, 8.375489923076305],
            [-18.674852600654745, 8.373251938616463],
            [-18.67586774356834, 8.369803063573523],
            [-18.67524032634053, 8.36190199834591],
            [-18.678939774967155, 8.359234177003009],
            [-18.678516670638338, 8.35426478414014],
            [-18.672273670045353, 8.34845325851736],
            [-18.746396180410454, 8.37006090228537],
            [-18.80303381362213, 8.386633715722288],
            [-18.803806198390625, 8.384061604510512],
            [-18.858603094636756, 8.399601285074782],
            [-18.872633127128786, 8.404736351744589],
            [-18.93001262387844, 8.421571873553988],
            [-18.94169003334975, 8.426256630099168],
            [-18.95534208765347, 8.42958358815479],
            [-18.956992286128408, 8.42466986065466],
            [-19.039293681447848, 8.452744865248153],
            [-19.038238939551043, 8.456242667684311],
            [-19.07951081173784, 8.468096882430823],
            [-19.070215350523075, 8.499123437983153],
            [-19.098291820650836, 8.50658904235377],
            [-19.089933820861347, 8.534470209597364],
            [-19.062579438863885, 8.526246300313959],
            [-19.03380265427632, 8.518966680281347],
            [-19.029705579642012, 8.532839948030729],
            [-19.01628133754368, 8.528965375712227],
            [-19.008133661789838, 8.556612142697483],
            [-19.011047582164778, 8.557488535304138],
            [-18.998352119461707, 8.599133898756275],
            [-18.970243575209892, 8.591369958519024],
            [-18.963470980843066, 8.588335291903377],
            [-18.92189122806032, 8.57679228825549],
            [-18.91493049348222, 8.574153594523947],
            [-18.90885816690013, 8.59466040206691],
            [-18.901897969742645, 8.616186601811064],
            [-18.90114857015116, 8.615965206089738],
            [-18.883047332256947, 8.677182980680891],
            [-18.88211791426214, 8.680859282169047],
            [-18.851846305120105, 8.781018499299421],
            [-18.85584517283962, 8.782220184584865],
            [-18.835618234078975, 8.848589041905923]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.42927208355017,
          "lat": 44.49177705067793
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41003"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01155126"
      },
      "bbox": [
        -19.098291820650836, 8.34845325851736, -18.493942010840886,
        8.848589041905923
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.26853718470192, 10.148892617148228],
            [-18.25725248932516, 10.144313510065514],
            [-18.247687141921723, 10.142621065812406],
            [-18.227275966215792, 10.135144943749099],
            [-18.213324221419544, 10.131305454207725],
            [-18.190784708101535, 10.136652140906014],
            [-18.183381415017397, 10.139129563969096],
            [-18.174981184828653, 10.14009239045334],
            [-18.160833132821196, 10.144444398071451],
            [-18.1251636817009, 10.150943465453434],
            [-18.09258613730529, 10.137735111123751],
            [-18.087473265751722, 10.12848630541784],
            [-18.058295237291595, 10.095422671186675],
            [-18.053819806615063, 10.086712922677778],
            [-18.049402883847073, 10.083378258504105],
            [-18.04308882511929, 10.076210467959385],
            [-18.03547734810906, 10.070880834323209],
            [-18.03263131299622, 10.06778949345822],
            [-18.01304299723739, 10.032462759518813],
            [-17.97986948807914, 10.001362247101993],
            [-17.97330158373856, 9.975465817914161],
            [-17.977118844071125, 9.946861437865866],
            [-17.96715345927973, 9.92679191099516],
            [-17.96414569599671, 9.891466219911212],
            [-17.953861448807878, 9.868208526739634],
            [-17.95658424144047, 9.839718507115505],
            [-17.965615293383646, 9.82212135173084],
            [-17.964528024596255, 9.792716019016094],
            [-17.960403823955264, 9.774491562094925],
            [-17.96549954853542, 9.758354479331176],
            [-17.96737669529769, 9.752412047083531],
            [-17.97958765622769, 9.736223514896468],
            [-17.983523895447938, 9.721944458692581],
            [-17.9742210766321, 9.689128387907289],
            [-17.974750400233862, 9.667314992717067],
            [-17.980721717166215, 9.643635709716396],
            [-17.98373897894312, 9.638510313199992],
            [-17.998797726653507, 9.642881790423795],
            [-18.00098716869371, 9.635604551264674],
            [-18.05365165680994, 9.651142006001729],
            [-18.097719837094573, 9.663842846535541],
            [-18.093586669749453, 9.677232855168146],
            [-18.13458565829022, 9.689805564313273],
            [-18.130544490336053, 9.703394708518355],
            [-18.14430712007954, 9.707994954862235],
            [-18.158191612082828, 9.71195519644756],
            [-18.149768132705344, 9.737991589593033],
            [-18.205966981763627, 9.755207131845946],
            [-18.260085153188353, 9.770646483856359],
            [-18.343773324571334, 9.795272638074186],
            [-18.371116083103416, 9.802602981854275],
            [-18.368638239205044, 9.809349401468424],
            [-18.362450630579797, 9.82943397143582],
            [-18.353054667243143, 9.855936400031348],
            [-18.34576839848173, 9.884537914279257],
            [-18.342028581814425, 9.896496828046262],
            [-18.321108372377, 9.966422119237382],
            [-18.32089559388334, 9.966499582633665],
            [-18.30400122874986, 10.020727038448134],
            [-18.296101576467603, 10.047300590064006],
            [-18.301273002978043, 10.048968482227128],
            [-18.287537882945916, 10.089654493966083],
            [-18.28321856518699, 10.104745418009466],
            [-18.274128288418876, 10.130980907211583],
            [-18.26853718470192, 10.148892617148228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.08829088570187,
          "lat": 45.94379196122666
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41009"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01135847"
      },
      "bbox": [
        -18.371116083103416, 9.635604551264674, -17.953861448807878,
        10.150943465453434
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.954248912182454, 7.349821629681247],
            [-19.925918228191364, 7.3406091494020576],
            [-19.90976068776205, 7.335617758946489],
            [-19.909304386568802, 7.3370052517872795],
            [-19.826676439291862, 7.311164809377976],
            [-19.800168873630756, 7.303442125910947],
            [-19.80120732846557, 7.29979950787728],
            [-19.797814504167384, 7.298937472120454],
            [-19.79992087309232, 7.29174761344001],
            [-19.79313809940958, 7.290199176300362],
            [-19.790888703783473, 7.2860188905743914],
            [-19.793192196880973, 7.2792099112319],
            [-19.779420146469516, 7.27506099089769],
            [-19.783873814127503, 7.260110347131535],
            [-19.777093168988852, 7.258126858481046],
            [-19.77905266351079, 7.25131185074128],
            [-19.78244004907801, 7.252356349986008],
            [-19.784405423759573, 7.245508512690485],
            [-19.777921730693556, 7.2434412069012275],
            [-19.77875122475268, 7.239954564074888],
            [-19.775414877643716, 7.238888337359997],
            [-19.77646164046338, 7.235429984900155],
            [-19.76968758016117, 7.23341756564241],
            [-19.770710995427955, 7.229905121983522],
            [-19.767490975266696, 7.228944594613863],
            [-19.7695992115014, 7.2221468284312875],
            [-19.76740961323717, 7.217863776502268],
            [-19.753587055066674, 7.214770279270057],
            [-19.75816450194899, 7.201791322224952],
            [-19.754395601005797, 7.20055807742665],
            [-19.755427552978944, 7.196862095610814],
            [-19.75174319988152, 7.1957569224898075],
            [-19.75286018798558, 7.1921899185451865],
            [-19.749469939865936, 7.1911781571620965],
            [-19.752843118950747, 7.180127739449631],
            [-19.74942667860316, 7.179171857721074],
            [-19.755713846541116, 7.15800419471312],
            [-19.76934842872409, 7.161937433264598],
            [-19.772085151253094, 7.151781253115139],
            [-19.775372222064018, 7.152843772498053],
            [-19.778958870303462, 7.139542539053444],
            [-19.783542565000502, 7.126286963886686],
            [-19.780222736594382, 7.125365785867717],
            [-19.794812185838133, 7.077452037946135],
            [-19.779928961901557, 7.072954433829408],
            [-19.800200747254443, 7.007227287910004],
            [-19.796130080249196, 7.005999211896087],
            [-19.79742229008888, 7.001773617626797],
            [-19.794022468556022, 7.000731063929963],
            [-19.792736672403954, 7.004976356616517],
            [-19.78655214535582, 7.003111321146174],
            [-19.784417549048403, 7.009992603158192],
            [-19.763956181679422, 7.003669198673337],
            [-19.76183277374685, 7.010591353357277],
            [-19.748199605550294, 7.006340512285864],
            [-19.696357632074196, 6.991045709703471],
            [-19.692140682351923, 7.004854150833765],
            [-19.678421238793195, 7.000743194810027],
            [-19.67417424090254, 7.0145325643486185],
            [-19.660439984582936, 7.010413011346859],
            [-19.65624451563393, 7.024261061120973],
            [-19.64243779288723, 7.020159404903352],
            [-19.639343216960395, 7.030255517863446],
            [-19.631416384609608, 7.027920428401762],
            [-19.621119117467014, 7.061132419240494],
            [-19.58105362894611, 7.049454349835314],
            [-19.578848799074205, 7.056178189930546],
            [-19.56603140536162, 7.052234736758684],
            [-19.56392483022846, 7.0590838365012045],
            [-19.537215433865594, 7.050928561819565],
            [-19.532129690953674, 7.04805171708479],
            [-19.524320124982854, 7.052143460711114],
            [-19.520892754348736, 7.054875844885455],
            [-19.514412576334223, 7.055154516655465],
            [-19.508199332736314, 7.0511943174203955],
            [-19.506492604254728, 7.047725091055101],
            [-19.501203617722187, 7.043876943336759],
            [-19.49483921468885, 7.037124187343102],
            [-19.489920032892456, 7.035903003906271],
            [-19.488884111633585, 7.030769525660814],
            [-19.484378802404976, 7.026077870691428],
            [-19.47689762926473, 7.02782399665892],
            [-19.47218513039723, 7.026540781465597],
            [-19.47578514632447, 7.024329770117324],
            [-19.478654997150862, 7.019476509511054],
            [-19.48433812263967, 7.018674589790948],
            [-19.488109212733953, 7.015528660032471],
            [-19.49492210774754, 7.005413269726483],
            [-19.49582185467775, 7.001327750158124],
            [-19.505918380133448, 6.993347614803472],
            [-19.50744025612379, 6.993240653314872],
            [-19.516169521404716, 6.9812775966667],
            [-19.51577563935093, 6.978963018526103],
            [-19.51905864293706, 6.974336845725717],
            [-19.526184102149436, 6.969121249022912],
            [-19.531134217212944, 6.962721446090575],
            [-19.534266248129423, 6.962096477696838],
            [-19.5370109422215, 6.958677811472966],
            [-19.596439890010874, 6.905393189602971],
            [-19.598629724635533, 6.899251376874503],
            [-19.59657793355639, 6.898158390621716],
            [-19.593272351018097, 6.8913307463065285],
            [-19.59297535297218, 6.886491579455903],
            [-19.596393839009597, 6.881191642417105],
            [-19.602198477596037, 6.879774535666795],
            [-19.606593540651023, 6.869570591112268],
            [-19.623370284617838, 6.862751409200502],
            [-19.626361499160964, 6.854110297280681],
            [-19.630199242178502, 6.850129671632065],
            [-19.636896249841456, 6.845277586615025],
            [-19.63817987443615, 6.838554900321791],
            [-19.636655709333944, 6.832183661760241],
            [-19.641175662870964, 6.829416498739129],
            [-19.65035308900376, 6.821391638936668],
            [-19.652652858166658, 6.820846313209405],
            [-19.660822584241085, 6.812324512878437],
            [-19.66214321832254, 6.807826979841432],
            [-19.661809947526017, 6.800717433200791],
            [-19.669927450193235, 6.798096478442711],
            [-19.671852292443145, 6.794322793805535],
            [-19.67614928725598, 6.791888203627489],
            [-19.683969883316845, 6.791886267719297],
            [-19.686824636956434, 6.793525209148395],
            [-19.698162159169325, 6.792306822731897],
            [-19.704375436249258, 6.7939918117911535],
            [-19.708352041339758, 6.797813820849906],
            [-19.710029877007827, 6.802529029756529],
            [-19.714906063104547, 6.804226789581645],
            [-19.7243560725183, 6.8038361644921554],
            [-19.72632093896674, 6.805030796500076],
            [-19.734903030893, 6.804037910975787],
            [-19.738492982817107, 6.807434613060874],
            [-19.74403796476025, 6.809750523493805],
            [-19.744110761927086, 6.813234133418618],
            [-19.74824698995121, 6.812444615012705],
            [-19.75234947468836, 6.814063697669192],
            [-19.754944565390783, 6.811621837559185],
            [-19.760146359580812, 6.81264319054034],
            [-19.76431821225903, 6.806878454321072],
            [-19.761270162622516, 6.805124295909854],
            [-19.75925255394918, 6.800163449912047],
            [-19.759797106029925, 6.796356893722574],
            [-19.763504163701167, 6.787867716950597],
            [-19.76351587735834, 6.78340328322592],
            [-19.769113057338792, 6.775888527053315],
            [-19.767263911479922, 6.77165689006106],
            [-19.770607439255073, 6.768589989911925],
            [-19.770266848200468, 6.763126011349358],
            [-19.77172511157861, 6.760961525988678],
            [-19.776203496334823, 6.760641075141866],
            [-19.782611999414232, 6.754489199938753],
            [-19.783031577925428, 6.750978486983899],
            [-19.780901517879627, 6.74668973205149],
            [-19.784405610324356, 6.744380390159665],
            [-19.782739804103993, 6.739311214403022],
            [-19.7880795101221, 6.733666007697902],
            [-19.79862052363971, 6.7313414642927905],
            [-19.801497111344933, 6.727924832002939],
            [-19.806976034428274, 6.727962707772989],
            [-19.80859780006707, 6.722857394231967],
            [-19.81295149584972, 6.716262185572763],
            [-19.815729150805407, 6.71404442438117],
            [-19.81364470709086, 6.710031154753601],
            [-19.814047579367347, 6.703051008170915],
            [-19.816596200544552, 6.697889510129892],
            [-19.813270834549133, 6.685391537600683],
            [-19.809048842961875, 6.686689402546906],
            [-19.80643455264166, 6.683926182382554],
            [-19.791137571627957, 6.677974518879299],
            [-19.784669551598725, 6.6769891988470516],
            [-19.76881458991718, 6.6693999721327035],
            [-19.763842160282827, 6.669107181356078],
            [-19.75970403905543, 6.666481212488885],
            [-19.749051835263373, 6.668585578320443],
            [-19.749449489945963, 6.662579502811256],
            [-19.743634146650766, 6.655905108380336],
            [-19.74213675033563, 6.650674984187672],
            [-19.732376572027547, 6.648970373738856],
            [-19.72714295624801, 6.649059619555285],
            [-19.720642330578205, 6.651347826995464],
            [-19.717927510806422, 6.64861215326527],
            [-19.716993084242816, 6.642710185159996],
            [-19.712699109312272, 6.640146481289052],
            [-19.716240737762664, 6.631210879562787],
            [-19.716052089646837, 6.626338944328153],
            [-19.71330365184815, 6.617290773341443],
            [-19.707707985603435, 6.611167212808526],
            [-19.702836559457563, 6.612006909498048],
            [-19.698417112201618, 6.6066933980096625],
            [-19.69522822873936, 6.600806814903187],
            [-19.70336441652651, 6.594194879466005],
            [-19.704502036908675, 6.590024320833329],
            [-19.702065638928172, 6.588550487230433],
            [-19.699180205631357, 6.583702007525782],
            [-19.701349454150467, 6.5779214781709605],
            [-19.69835320173767, 6.573978956931836],
            [-19.698926443956246, 6.571402354914759],
            [-19.695741258414785, 6.563274171149597],
            [-19.69782730386811, 6.558519142503171],
            [-19.696944759578066, 6.551352025664369],
            [-19.69240311885371, 6.548151726690619],
            [-19.6938390253103, 6.540427217949402],
            [-19.693199638481634, 6.532916034532992],
            [-19.695842203427606, 6.52973726949115],
            [-19.691047640640743, 6.52354498821243],
            [-19.68808218936963, 6.5234600101091065],
            [-19.68658874656553, 6.520185371118896],
            [-19.683606744222054, 6.5194250131004425],
            [-19.689064175440258, 6.503806846818258],
            [-19.697003430199224, 6.50056982693334],
            [-19.70129268226561, 6.503131154966145],
            [-19.705090161601024, 6.499781587728392],
            [-19.70814328518179, 6.493447815233562],
            [-19.71230106277514, 6.492467150618322],
            [-19.716944944415076, 6.483784305427729],
            [-19.717967864582278, 6.479796179494742],
            [-19.715552302092004, 6.477375999321814],
            [-19.714186847837187, 6.47253899865659],
            [-19.715641966993907, 6.4669644034127876],
            [-19.71817072495943, 6.463423748869033],
            [-19.720963258149382, 6.455821978559346],
            [-19.725445838654267, 6.454008429391918],
            [-19.7291703904316, 6.4495112333328],
            [-19.732353321060767, 6.44858253039684],
            [-19.7420535777694, 6.448414373731059],
            [-19.747122926255955, 6.443094709016961],
            [-19.750669471829543, 6.443583046733469],
            [-19.756217999391406, 6.440619870271118],
            [-19.760174010405304, 6.434977113982701],
            [-19.7588452226889, 6.430157507542348],
            [-19.75435945498486, 6.423143524379888],
            [-19.74956621409059, 6.421149758924859],
            [-19.75250614325284, 6.413782336275467],
            [-19.75214188400983, 6.4061895603566406],
            [-19.749440143093654, 6.403597922791704],
            [-19.750676545918456, 6.392858810023157],
            [-19.749180722343155, 6.3881283971266525],
            [-19.748461045375215, 6.380992327185595],
            [-19.751127994251153, 6.379568978215883],
            [-19.754715996687906, 6.37338128543385],
            [-19.756290203944022, 6.368607604290681],
            [-19.76304797259616, 6.363866035090632],
            [-19.76379964435504, 6.361528090710523],
            [-19.768918672001657, 6.3598812372558795],
            [-19.76859195414432, 6.356763194652056],
            [-19.77433914583634, 6.349440008787948],
            [-19.778787645342984, 6.348349338366781],
            [-19.780166788494295, 6.344960532088218],
            [-19.779809496903567, 6.334765610290595],
            [-19.775117442204323, 6.329106117308757],
            [-19.78090866871302, 6.316217430463578],
            [-19.7760812293337, 6.310847838935448],
            [-19.774946426424822, 6.307252062058195],
            [-19.777743696112214, 6.301886031701458],
            [-19.77192180296325, 6.296021394567662],
            [-19.774937624241932, 6.293844946806473],
            [-19.78339107485438, 6.296899362166803],
            [-19.89995536071786, 6.3319662155021605],
            [-19.96031455592713, 6.350746245542305],
            [-19.98591171868865, 6.358865030100721],
            [-20.0491724919578, 6.379574429172973],
            [-20.05156201922595, 6.390198144080046],
            [-20.061298080672252, 6.404434076190146],
            [-20.06153173764522, 6.409870416207198],
            [-20.067098553893388, 6.4138525623864275],
            [-20.070031713642898, 6.41811366870857],
            [-20.072535542339793, 6.42448625861553],
            [-20.073530329486264, 6.431430408745728],
            [-20.076801021466974, 6.437272714566081],
            [-20.08178235755863, 6.439223608830518],
            [-20.08380670037478, 6.438112314111221],
            [-20.08829370693697, 6.440557874946899],
            [-20.095549226808433, 6.449458495835626],
            [-20.095906110097108, 6.459144999362944],
            [-20.09797699559905, 6.4638745780818745],
            [-20.1011823583613, 6.465350638448863],
            [-20.103630495166957, 6.473445722543198],
            [-20.10312611527286, 6.477472457219018],
            [-20.106180219878127, 6.487944413774074],
            [-20.1100178050577, 6.491251276779579],
            [-20.113279331202328, 6.499417308694384],
            [-20.11299130562508, 6.505341717894869],
            [-20.117454303939812, 6.506887083992288],
            [-20.11854327626236, 6.510701202261218],
            [-20.114922398215366, 6.514279086390558],
            [-20.11472476618755, 6.519744239328491],
            [-20.116437632875808, 6.525211085357928],
            [-20.112818306894525, 6.527851351442377],
            [-20.11260853666805, 6.530403924473984],
            [-20.109017668696147, 6.535273868665956],
            [-20.10766323893643, 6.540270122272964],
            [-20.11194110605473, 6.550789439559567],
            [-20.1125444441791, 6.559949510451764],
            [-20.111302047238716, 6.565961306171867],
            [-20.108838496926253, 6.565352838386979],
            [-20.1055870205971, 6.568214780298912],
            [-20.106547457984348, 6.575778582183635],
            [-20.10371611673142, 6.577814334428244],
            [-20.100602809072612, 6.586031410586725],
            [-20.10334147531202, 6.589861246951962],
            [-20.104781286645945, 6.603005554051959],
            [-20.106670317222452, 6.604241261077661],
            [-20.103424449861006, 6.613430969612879],
            [-20.103650619435218, 6.618814940483938],
            [-20.1018427786952, 6.620829113741206],
            [-20.101115677125048, 6.626012559330427],
            [-20.102769277946315, 6.63525657263274],
            [-20.10546670105674, 6.638453633361801],
            [-20.105190591498705, 6.641171416661384],
            [-20.10890313024322, 6.650503361860966],
            [-20.115058450586467, 6.663488004898849],
            [-20.113280706327544, 6.670405550352422],
            [-20.110347582204337, 6.672552711945748],
            [-20.10427781255176, 6.691376402255793],
            [-20.100464850410486, 6.709353592844465],
            [-20.10121760422391, 6.712896273506243],
            [-20.098789633445534, 6.717985699864263],
            [-20.101969175918835, 6.727468572841856],
            [-20.101065896799916, 6.732302578892447],
            [-20.103890959049167, 6.734856041228771],
            [-20.10659827126954, 6.732369710885756],
            [-20.10878620602068, 6.738395208918961],
            [-20.105685027107054, 6.74450077988872],
            [-20.101452434906665, 6.747556560008588],
            [-20.101328275351406, 6.751742788924991],
            [-20.099242876690695, 6.753838744990557],
            [-20.087234003976803, 6.7872553718707165],
            [-20.082703664648765, 6.805297698740511],
            [-20.078149859413806, 6.818340852889436],
            [-20.07718560491785, 6.84712665104671],
            [-20.07523677170502, 6.8514930717288935],
            [-20.07121615466166, 6.856107625399217],
            [-20.06275699315111, 6.863801319949575],
            [-20.06034821624807, 6.867117012557624],
            [-20.05582484855808, 6.884267203469224],
            [-20.050370393140113, 6.894128330332553],
            [-20.05002096756989, 6.90076193145672],
            [-20.03741259901979, 6.914625760331426],
            [-20.02196244320653, 6.9359320049637105],
            [-20.019968741347277, 6.940638737148258],
            [-20.01000279937101, 6.956772002149555],
            [-20.004265881794932, 6.968649474744872],
            [-20.006537627812065, 6.973267317231161],
            [-20.004680886840287, 6.976408891208196],
            [-20.006211714148947, 6.987186891697719],
            [-20.009872292793727, 6.987483700259233],
            [-20.005686451228698, 6.993035568870971],
            [-20.00188174064905, 7.004756796955771],
            [-19.998038296601504, 7.012019187883612],
            [-19.998815864407845, 7.014356318151846],
            [-19.996566117035027, 7.021092044556748],
            [-19.99909441467536, 7.023718881180502],
            [-19.997370889771936, 7.0310823627356065],
            [-19.999069528979664, 7.03337091803753],
            [-19.999849222764837, 7.041535282870959],
            [-19.996011696673108, 7.044217364537077],
            [-19.99580144694632, 7.052981412842486],
            [-19.997269731689904, 7.057254801750345],
            [-20.00094027146012, 7.060144617998698],
            [-20.007301088195966, 7.069063789069984],
            [-20.009964251381, 7.0707974890649],
            [-20.016777541713214, 7.078067573399172],
            [-20.016706870785832, 7.080124286262261],
            [-20.01185340956498, 7.085903138206933],
            [-20.011693977416734, 7.091161248565388],
            [-20.01442480599621, 7.096751790003863],
            [-20.013425905986708, 7.099277407166017],
            [-20.015168160340625, 7.105126285414255],
            [-20.013696781618652, 7.110234094195269],
            [-20.014036059986978, 7.120574147494986],
            [-20.015681958365864, 7.123429291384302],
            [-20.014264636597705, 7.127475090578551],
            [-20.016035966167443, 7.137264269863318],
            [-20.025754529950927, 7.1497702156161065],
            [-20.0347289960077, 7.150401157452032],
            [-20.036796755381786, 7.147579269442822],
            [-20.04200530259241, 7.145702426506343],
            [-20.043270240154804, 7.149937927840819],
            [-20.03984405395524, 7.158311974873865],
            [-20.0371811590359, 7.183654321244147],
            [-20.034325830214566, 7.202552396805174],
            [-20.035179793125504, 7.228285773836481],
            [-20.038213027645252, 7.23839254902652],
            [-20.0421100665029, 7.247096689548034],
            [-20.045367377766706, 7.2524372165083975],
            [-20.049580795369234, 7.255920003559454],
            [-20.03872598554265, 7.256945659787863],
            [-20.02956234622666, 7.268250173427397],
            [-20.0255721189859, 7.269916623234134],
            [-20.021130608239602, 7.27429598370936],
            [-20.01753119925584, 7.280825403139629],
            [-20.015932706376404, 7.286328360969842],
            [-20.01284156983545, 7.286088331751783],
            [-20.00835018734935, 7.288786630470694],
            [-19.979447592895983, 7.319094184897165],
            [-19.95599637780652, 7.347394911855335],
            [-19.954248912182454, 7.349821629681247]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -124.15675960526829,
          "lat": 42.45762567929858
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41015"],
        "coty_name": ["Curry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Curry County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01155129"
      },
      "bbox": [
        -20.11854327626236, 6.293844946806473, -19.47218513039723,
        7.349821629681247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.29852788720809, 3.3816667359450907],
            [12.299794318964521, 3.3806043270742516],
            [12.32794547072706, 3.437248497779617],
            [12.354126731562385, 3.4939650990687854],
            [12.383669715041657, 3.498771831341931],
            [12.405482676527477, 3.5027474217795858],
            [12.482928908489303, 3.517223963487258],
            [12.510762588128756, 3.521841587148752],
            [12.578253632593073, 3.5333791222780393],
            [12.582996046528105, 3.5307333332449646],
            [12.589609019318413, 3.4950687520156163],
            [12.59370460520622, 3.4649563038897786],
            [12.61060077050947, 3.3684726409029206],
            [12.619129644622577, 3.3200275816588243],
            [12.630398877954212, 3.248229755171002],
            [12.642241713857505, 3.1772373752929175],
            [12.645893757559293, 3.153160867287145],
            [12.653779551013997, 3.1056591596759264],
            [12.660749510343363, 3.0695544616625168],
            [12.666385554902982, 3.034568913189816],
            [12.666446987835469, 3.034443587191525],
            [12.65553732366544, 3.03280201872474],
            [12.639667172064877, 3.029451053083579],
            [12.601129585549145, 3.0248251120775542],
            [12.572828906068585, 3.0204513095682777],
            [12.564992805002507, 3.0185280382965467],
            [12.555350589335076, 3.0177411123236824],
            [12.52942359511406, 3.0137562841456744],
            [12.501485839031806, 3.0098529125094364],
            [12.468068585056987, 3.0031308002390222],
            [12.447163146126705, 3.000912253882139],
            [12.411206692359308, 2.9953283115728015],
            [12.385123295409139, 2.991002410661221],
            [12.384964861147836, 2.991753054679221],
            [12.367082922208233, 2.9879619807829103],
            [12.343402963914127, 2.9833842214417325],
            [12.328021845289426, 2.9809652091053938],
            [12.319529028983522, 3.0197489689292785],
            [12.313245808900419, 3.050256087804767],
            [12.3012687366354, 3.10576907159151],
            [12.290242047499833, 3.159798060233354],
            [12.259982748068232, 3.303600471849011],
            [12.29852788720809, 3.3816667359450907]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.91331931135201, "lat": 40.91201638350341 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42019"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01213661"
      },
      "bbox": [
        12.259982748068232, 2.9809652091053938, 12.666446987835469,
        3.5333791222780393
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.91426602506343, 2.7443245820688147],
            [13.96233854268569, 2.720755962212958],
            [14.006820123990444, 2.7169837024788333],
            [14.081757321522858, 2.711461626313312],
            [14.081620048336223, 2.7135558883685857],
            [14.135190432264116, 2.680339576828759],
            [14.127451583730483, 2.6717559135057023],
            [14.122423773842375, 2.660826393472281],
            [14.118958697708074, 2.6479757984249046],
            [14.112589446024218, 2.63615960919369],
            [14.112731891446389, 2.6320281908614405],
            [14.10785864770957, 2.6224430412100586],
            [14.104802554236166, 2.6117398235027136],
            [14.107155204105, 2.604186724963386],
            [14.10496109480064, 2.595220039529202],
            [14.104655971875932, 2.589885469937839],
            [14.101670241286127, 2.582564362576469],
            [14.101872151186354, 2.575208265398142],
            [14.100670618786754, 2.5705719920486034],
            [14.102070686307522, 2.558336392966199],
            [14.097664175539663, 2.5431124149484683],
            [14.093893416080503, 2.5389931175899996],
            [14.092519984613588, 2.5339975657597624],
            [14.094939615088004, 2.527742574642657],
            [14.093434780013146, 2.518675639458074],
            [14.092482749933893, 2.508017721182039],
            [14.091351443573608, 2.5056445976200785],
            [14.088889799648015, 2.4765913819090137],
            [14.086692964671148, 2.465912376007253],
            [14.076887548798762, 2.427895684457198],
            [14.070747570025404, 2.411421430090963],
            [14.068335340603292, 2.4062370611275727],
            [14.062668429407463, 2.3977630572680373],
            [14.05818834848508, 2.3887947470896935],
            [14.05804321919559, 2.3867146588675383],
            [14.05319004411702, 2.374801834705388],
            [14.04988548257506, 2.364931592656379],
            [14.044527631748865, 2.353229285100457],
            [14.041934765481022, 2.3408240317846527],
            [14.024512726779598, 2.3108346037806475],
            [13.946819212641897, 2.2961782248718685],
            [13.85105419652146, 2.278394747757142],
            [13.842005906502678, 2.276540772060152],
            [13.813725867120258, 2.2712122863901785],
            [13.817183818434337, 2.2771673648928044],
            [13.822479185108163, 2.2905178173587313],
            [13.830347331215076, 2.3085681239969857],
            [13.832415224551056, 2.311114284779003],
            [13.837816010992544, 2.3286934406749653],
            [13.84151913952258, 2.3367312640279527],
            [13.843856174138386, 2.348866428273164],
            [13.855588909529583, 2.38474935057971],
            [13.858505819734148, 2.403767913220071],
            [13.861024412393288, 2.428560368237593],
            [13.86178802323826, 2.442557728659591],
            [13.864212347612455, 2.455943605212103],
            [13.864542142171537, 2.466473969863011],
            [13.871524611236548, 2.5011359800394475],
            [13.874184816429965, 2.5111838076015007],
            [13.876537537610165, 2.515942787521375],
            [13.876584155051683, 2.5238451518944203],
            [13.880847493192976, 2.551952191802551],
            [13.883309926460546, 2.562145744130717],
            [13.891351445470152, 2.581562387088197],
            [13.89363247889041, 2.5843119983789418],
            [13.890413136572151, 2.5886687144892737],
            [13.889174113384415, 2.6006583913411703],
            [13.886361324476104, 2.604299894218195],
            [13.885796797059603, 2.612626872373802],
            [13.888710819106931, 2.6171778406203328],
            [13.897006370832221, 2.6199041109100683],
            [13.899222810461021, 2.624269125842793],
            [13.89951608703982, 2.6325596082749567],
            [13.896434265640462, 2.6334664608857996],
            [13.891225148628953, 2.6387978255430964],
            [13.885118085843596, 2.6383780537029025],
            [13.881845149233039, 2.6394452074187997],
            [13.879355196547348, 2.643018310500087],
            [13.878319994324952, 2.6533271203089726],
            [13.875591885350282, 2.656245694673891],
            [13.886234637184394, 2.6739513621207798],
            [13.904921087045302, 2.698511837230233],
            [13.90525244644484, 2.7014053712403534],
            [13.91426602506343, 2.7443245820688147]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.11265367322531, "lat": 39.92536188260606 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42057"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01213671"
      },
      "bbox": [
        13.813725867120258, 2.2712122863901785, 14.135190432264116,
        2.7443245820688147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.556811231993024, 3.663665589989626],
            [15.565271894620103, 3.67053293525118],
            [15.565537628449327, 3.6738372634880982],
            [15.56852922322354, 3.675197075472276],
            [15.574308017682847, 3.6864965802889946],
            [15.59174751387654, 3.698841554550875],
            [15.59570072299544, 3.7077660669742447],
            [15.607816425052123, 3.7153655138309656],
            [15.654915378921604, 3.7384435505029967],
            [15.660362351479522, 3.728649188907708],
            [15.660072038585758, 3.7230146366748302],
            [15.664003864779806, 3.718345641234523],
            [15.665456412103458, 3.709235505300932],
            [15.668390502410837, 3.7024015228297835],
            [15.673332948394215, 3.6973456093687274],
            [15.677980173639044, 3.690659782103482],
            [15.681879284775484, 3.689200912783232],
            [15.690219659882445, 3.6923448395727174],
            [15.694859390603908, 3.690567872662772],
            [15.697265085457634, 3.6858184395029414],
            [15.701358817539028, 3.682712257801474],
            [15.70650543087718, 3.6811719575163675],
            [15.71152231396576, 3.6834712589232668],
            [15.715774473887784, 3.687487461790229],
            [15.71699999499617, 3.690705507422705],
            [15.716342743703027, 3.6989494122419115],
            [15.718174191425655, 3.7009304957685405],
            [15.72374051805638, 3.700856603668858],
            [15.727397079257267, 3.6979047343941787],
            [15.730634925060565, 3.6856217204889017],
            [15.734649267263935, 3.6790604697146185],
            [15.741763084329252, 3.669610227212807],
            [15.748974821891027, 3.661758051774487],
            [15.753689997072927, 3.6593564160883303],
            [15.75969589810184, 3.649788120871628],
            [15.765194653224372, 3.6487659970692286],
            [15.770863039532076, 3.644338465826105],
            [15.772889380308339, 3.6400178446088587],
            [15.774233118860865, 3.6328334034133594],
            [15.776879868673078, 3.6294224078663504],
            [15.810406936493989, 3.6557404806168763],
            [15.811854033971157, 3.6501576855362337],
            [15.829937097043913, 3.6352744763368325],
            [15.84694557868335, 3.6225086809508005],
            [15.850845602131466, 3.622333337570555],
            [15.85126669456845, 3.6171142252609068],
            [15.855801911869383, 3.61427698192545],
            [15.85751985583785, 3.6075441822947645],
            [15.854099350036638, 3.6037736568323777],
            [15.855981600006645, 3.5857642597621338],
            [15.849663180143402, 3.5685033287839025],
            [15.911387777987718, 3.53662689083931],
            [15.908272242072426, 3.532857990646981],
            [15.883497628391886, 3.49913989111812],
            [15.865952584896498, 3.47602888582671],
            [15.840178530548338, 3.423624711264945],
            [15.826247822932704, 3.39563241815415],
            [15.786450896968683, 3.416358024381119],
            [15.734023905737354, 3.443750381752878],
            [15.653335253189585, 3.486999546094537],
            [15.60347305741325, 3.5136101819974175],
            [15.568865256404708, 3.531645076792826],
            [15.511345944606212, 3.562886035441195],
            [15.47095825202447, 3.585328951792291],
            [15.494531949815736, 3.6067808285551757],
            [15.502028869767168, 3.6081946432091843],
            [15.525721293784283, 3.628012899939619],
            [15.532294826014876, 3.6394528120320326],
            [15.54296071779676, 3.6499767562955956],
            [15.543462799823192, 3.6547312290443696],
            [15.551790232132733, 3.6579605762223775],
            [15.556811231993024, 3.663665589989626]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.5923509902626, "lat": 40.61267424799711 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42077"],
        "coty_name": ["Lehigh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lehigh County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01209182"
      },
      "bbox": [
        15.47095825202447, 3.39563241815415, 15.911387777987718,
        3.7384435505029967
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.58062113612525, 4.107470054469754],
            [15.582903592662642, 4.112416532770336],
            [15.579984831411194, 4.118074128348132],
            [15.587651094412612, 4.120493924764633],
            [15.590486159393782, 4.125308834811021],
            [15.594675561593007, 4.1273651298206095],
            [15.593012307181073, 4.135950741142839],
            [15.596520348107552, 4.141427087598764],
            [15.59522655224378, 4.148981401643105],
            [15.597077548737534, 4.150279864600985],
            [15.598981008019807, 4.1566028440170095],
            [15.604260250870372, 4.16011498984083],
            [15.606229121803164, 4.170578412425811],
            [15.611271160919282, 4.179973734124603],
            [15.61867347205575, 4.182751394765964],
            [15.622192801820855, 4.179841058966913],
            [15.629604442516555, 4.177715687127891],
            [15.634699325031017, 4.192371828459337],
            [15.644415181332738, 4.1948994668209405],
            [15.728997107977632, 4.2184367364908235],
            [15.739937512014778, 4.2223082599069475],
            [15.823763046016385, 4.247690110530144],
            [15.829595587751433, 4.249200652050179],
            [15.904207815299516, 4.271941332740565],
            [15.905214047237099, 4.237694732170234],
            [15.907027129417974, 4.167747696589379],
            [15.966894790943098, 4.171617333291637],
            [15.981655580679018, 4.154815707100652],
            [16.00609391571191, 4.126421608460065],
            [16.01026562252672, 4.126079712238125],
            [16.01478535936274, 4.122238667455079],
            [16.02203325146306, 4.1259589014820754],
            [16.026651292206086, 4.126250663199317],
            [16.026279523824424, 4.130121992126852],
            [16.02977320894568, 4.131428938073111],
            [16.031881909326163, 4.135245695968097],
            [16.03484826507941, 4.133450046255748],
            [16.036396215649454, 4.137523740633962],
            [16.03996794331996, 4.137598571085249],
            [16.04338576298086, 4.1341780314022945],
            [16.048091753846183, 4.136921398692031],
            [16.05154736166935, 4.1420387421913425],
            [16.055381006525735, 4.144961213970882],
            [16.05746865763584, 4.143641269818786],
            [16.057974657689726, 4.137011868045861],
            [16.05663390635122, 4.13413008845464],
            [16.049524700026332, 4.126226468895333],
            [16.04479536423114, 4.12428699204307],
            [16.0382597456065, 4.118312011961789],
            [16.034741960202332, 4.110930637865253],
            [16.030070682689583, 4.108793080940393],
            [16.029318606574883, 4.098613606843025],
            [16.024792000065162, 4.08694721521268],
            [16.02580293575373, 4.080052252601055],
            [16.020034884765334, 4.075355433486581],
            [16.0168089478385, 4.069971145659088],
            [15.995771948975083, 4.050254231324365],
            [15.991380275156155, 4.048973070320092],
            [15.984484624709646, 4.040304654216966],
            [15.973723016765826, 4.031909175737562],
            [15.973065085752589, 4.029775528844801],
            [15.965022766380413, 4.0217538780802995],
            [15.960903957766469, 4.015646663057374],
            [15.961466185773679, 4.004523790498536],
            [15.960414569169167, 4.000874247600585],
            [15.962980712631264, 3.9953729904324002],
            [15.966858568499054, 3.9941781024856775],
            [15.971329351679847, 3.996385732454313],
            [15.973380719094727, 3.9953481769792254],
            [15.968949708853556, 3.9842896784914528],
            [15.958941440996181, 3.9744909423757835],
            [15.953734346727199, 3.970990035726831],
            [15.941935026609569, 3.9670313213815755],
            [15.93709060223652, 3.9633867638610827],
            [15.937326396258841, 3.9580769234178788],
            [15.931109076807877, 3.9534096731420094],
            [15.92542913961933, 3.9513305948872715],
            [15.910713163744145, 3.939345898864525],
            [15.909871307513312, 3.9306119115571962],
            [15.897962698107602, 3.9175208530549943],
            [15.906390991396444, 3.9094128544926443],
            [15.884755452282272, 3.8868097477610037],
            [15.882173699013896, 3.87663114257592],
            [15.876030732956883, 3.867946210619839],
            [15.86532087306509, 3.8589058417071027],
            [15.851278884803188, 3.851781863326273],
            [15.83957930229048, 3.83919351095843],
            [15.810969257487073, 3.817534942864989],
            [15.787497605648475, 3.807293055261197],
            [15.785337883120905, 3.8040875724437586],
            [15.769765656889259, 3.795339702456643],
            [15.747861177790671, 3.786904201913408],
            [15.733007806459819, 3.8075779324632064],
            [15.692976037943186, 3.8528301305166788],
            [15.663042053263695, 3.885743500776871],
            [15.644888573734164, 3.9050917648125036],
            [15.662770327934432, 3.922663405843669],
            [15.694660582342452, 3.952876847935045],
            [15.679512758058653, 3.964936912743798],
            [15.633527212162077, 4.003180671700055],
            [15.627063769949784, 4.003143967168146],
            [15.624156762376995, 4.011753601949288],
            [15.620724382624223, 4.014492982711393],
            [15.617881166825317, 4.019515341972662],
            [15.615524907389233, 4.018583418718827],
            [15.612685164561167, 4.02297966566431],
            [15.60142064373506, 4.0288072102372405],
            [15.597099711390218, 4.031783218234757],
            [15.593020253766715, 4.0320728108768344],
            [15.592781111796143, 4.0400063935005806],
            [15.5863304419077, 4.039484326308421],
            [15.581696065536102, 4.049307492878331],
            [15.577806440485462, 4.052797724473889],
            [15.573794934759949, 4.05442336459062],
            [15.572258898970093, 4.049462326350902],
            [15.568450309998546, 4.050316166014337],
            [15.564042012981194, 4.0543654073151245],
            [15.559515794987654, 4.052739953841968],
            [15.557070251146715, 4.057726852112168],
            [15.553499412345149, 4.061243886485924],
            [15.553173783227447, 4.064035347794255],
            [15.559209266208386, 4.06713347516758],
            [15.564431653495626, 4.064585550099961],
            [15.56439667347885, 4.06941411578079],
            [15.567799752239868, 4.070504947639534],
            [15.565732920249824, 4.0788649527236025],
            [15.57432082652711, 4.089295153190906],
            [15.572108062425034, 4.094512922836431],
            [15.576820213274646, 4.094864835815213],
            [15.580817618750133, 4.097609963045773],
            [15.579031277840505, 4.101580224572007],
            [15.58062113612525, 4.107470054469754]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.33947624169471, "lat": 41.05803451451038 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42089"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01209184"
      },
      "bbox": [
        15.553173783227447, 3.786904201913408, 16.057974657689726,
        4.271941332740565
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.61458570163915, 2.5426822165649368],
            [12.636651373103241, 2.558085449950823],
            [12.653818116796188, 2.569137629782475],
            [12.663254016893267, 2.575932581803259],
            [12.675683916493897, 2.584093250117745],
            [12.65868932040827, 2.5855915002606427],
            [12.655572785417325, 2.5901134222217057],
            [12.660053969754333, 2.601185014321244],
            [12.660880621803717, 2.607327689128372],
            [12.665980133816234, 2.617424051133149],
            [12.66461304595681, 2.6207326627463092],
            [12.658755928635836, 2.6267584652695604],
            [12.656427284303456, 2.6337788417195642],
            [12.657386190419329, 2.6362325910221975],
            [12.66854772769048, 2.63877911969283],
            [12.670893129945561, 2.6419586598204527],
            [12.670068795795732, 2.646113234060352],
            [12.662484726925593, 2.6518194298484588],
            [12.659157366985903, 2.6529568219756405],
            [12.659697411459886, 2.669572323302034],
            [12.658925791827913, 2.7323575234078565],
            [12.662379010834263, 2.744236816634705],
            [12.661090696506983, 2.7476685594949717],
            [12.662657529867682, 2.7507414692042156],
            [12.66955212425062, 2.747604325815588],
            [12.673575973958346, 2.750684009699154],
            [12.67504417487925, 2.756348963898641],
            [12.683504471039448, 2.761973198289375],
            [12.683493809713598, 2.770395739283782],
            [12.689452385106474, 2.771523036689973],
            [12.685143603238501, 2.776816345742411],
            [12.692396620785471, 2.777369900917007],
            [12.692667899612715, 2.7811227998533736],
            [12.698582266568128, 2.7871622740418496],
            [12.69949602593441, 2.791415949871436],
            [12.695525557999654, 2.8211457847791848],
            [12.690580403847086, 2.8545001843066635],
            [12.68507158993342, 2.8865128833607283],
            [12.684780867993876, 2.8902314339379305],
            [12.677209647234271, 2.89592606869046],
            [12.67403722122583, 2.895969715205759],
            [12.667597942318157, 2.903326825226915],
            [12.658905471619091, 2.9058171361081446],
            [12.655421717723065, 2.909250090849932],
            [12.650352831595411, 2.9078754958809587],
            [12.645549633895051, 2.909849276870998],
            [12.636991438178903, 2.908169453498711],
            [12.633577547102195, 2.9057144777626287],
            [12.630027242715443, 2.910989375686981],
            [12.623586543234588, 2.9235584218921757],
            [12.622329772797647, 2.927868626114937],
            [12.621808171278388, 2.9372683850226133],
            [12.624455538324499, 2.9453471487458844],
            [12.62813769374388, 2.950880051710477],
            [12.636678790821334, 2.9569840821165934],
            [12.64603569040697, 2.9618449364264237],
            [12.654777926030633, 2.9684104783143863],
            [12.65669298986308, 2.971298020811335],
            [12.659416183770128, 2.979456132814116],
            [12.66625760636604, 2.9895173668930033],
            [12.67129207799649, 3.0000304356379113],
            [12.673323214805285, 3.006255968947884],
            [12.673503237093708, 3.0109507702535594],
            [12.670730239831146, 3.017660467340972],
            [12.665661307091568, 3.0260214414481346],
            [12.666446987835469, 3.034443587191525],
            [12.666385554902982, 3.034568913189816],
            [12.675478556450065, 3.0383918676552923],
            [12.682771317567433, 3.047897612693498],
            [12.686174530157459, 3.0474999667806726],
            [12.695632257304274, 3.041845038396592],
            [12.702762666166771, 3.0399581169605483],
            [12.707698049551922, 3.0374943796033778],
            [12.711161472027156, 3.0267273325975617],
            [12.717678797078635, 3.0219214481211765],
            [12.72293638195239, 3.019792430872066],
            [12.730031400094711, 3.0188993172651393],
            [12.733757851882183, 3.0148361178594523],
            [12.734431713691151, 3.006773847940437],
            [12.736364988971953, 3.00181589576322],
            [12.741512948593437, 3.0013476158403067],
            [12.745108525874029, 3.005883364429962],
            [12.747683386230596, 3.0124828530109835],
            [12.753029177041466, 3.015737034690161],
            [12.75425922466047, 3.0122591580771982],
            [12.751299131139398, 3.0040983723416965],
            [12.752122401138735, 2.9953910282101064],
            [12.757535402755769, 2.9897376907407116],
            [12.760031572475787, 2.9828625176860095],
            [12.764733002560112, 2.9821275910145575],
            [12.768148097068838, 2.987811209373218],
            [12.771849220194156, 2.9896019450094142],
            [12.776444849974249, 2.9877204605260332],
            [12.782216880599032, 2.988204282569564],
            [12.782837586858017, 2.985430968901406],
            [12.774565261655521, 2.9766595201661064],
            [12.771822310993207, 2.965284406795409],
            [12.782775494625874, 2.9461534292767295],
            [12.785766514929438, 2.94409008779295],
            [12.803248090155407, 2.9362738107710875],
            [12.812027492463425, 2.929658313580827],
            [12.816112733031241, 2.929289664431953],
            [12.822610607711747, 2.931835920030109],
            [12.828632585450134, 2.9259903450218694],
            [12.834082312488736, 2.9230733729656686],
            [12.83578508779431, 2.91762440237676],
            [12.838552079686655, 2.916418393519159],
            [12.842732617240207, 2.9183712089326272],
            [12.844777519987016, 2.9233682416997326],
            [12.844948826209226, 2.929126169605165],
            [12.849780984048467, 2.929534719080601],
            [12.851744911852649, 2.9234955581026543],
            [12.859448942610605, 2.9294932124031554],
            [12.866312616131953, 2.9307259375765167],
            [12.870608416742229, 2.9274318883959465],
            [12.871721070975495, 2.9256756603126735],
            [12.867089639698689, 2.9197435081674863],
            [12.8658552694109, 2.912877854730954],
            [12.872120773893855, 2.902513196955936],
            [12.872560122129427, 2.894124454556842],
            [12.876027494193407, 2.886730853013068],
            [12.875965138721288, 2.8814208903597227],
            [12.881806779552095, 2.8789884736592763],
            [12.886894896674475, 2.8858857694528792],
            [12.892306195764583, 2.88919950154028],
            [12.900294890507599, 2.8745260398422947],
            [12.902450628832675, 2.8721114640776095],
            [12.906632613388076, 2.8728210294720085],
            [12.912706797657156, 2.8777058078623856],
            [12.914739949066998, 2.8762654147192563],
            [12.918457791724956, 2.869749639256466],
            [12.921184816467004, 2.867448414441501],
            [12.924924929583952, 2.861114655270957],
            [12.93497207270821, 2.8595276141712795],
            [12.940414148020611, 2.8615070700728915],
            [12.9433196465164, 2.864998463542988],
            [12.944094259410381, 2.8747141679525368],
            [12.94194510849983, 2.883669927063158],
            [12.942376550468978, 2.8861853003671465],
            [12.947741438485712, 2.8875851857900825],
            [12.94939835721247, 2.8806779214568974],
            [12.948146065743334, 2.8693879539882357],
            [12.950493333706659, 2.8636982551916947],
            [12.955871966626201, 2.862199099765342],
            [12.960642062168265, 2.8640962262335803],
            [12.961208908217143, 2.8663390784033336],
            [12.959415115147575, 2.878696409886423],
            [12.963622446651964, 2.8825940237035432],
            [12.970507554273174, 2.8752120529414373],
            [12.973010430745676, 2.867430190735221],
            [12.976821334030761, 2.866925989736294],
            [12.978182494013419, 2.8705775199993337],
            [12.98258051377391, 2.8746523674703695],
            [12.99180002591664, 2.878730781913774],
            [12.99483523419011, 2.877621432656038],
            [12.996905654680928, 2.8736538833695637],
            [12.994710018264318, 2.8681336941295426],
            [12.997142204165131, 2.8625580899947236],
            [12.996756280807906, 2.8567375598263998],
            [12.997822452770196, 2.852752429436017],
            [13.00089641403137, 2.8527285511332825],
            [13.006386035093362, 2.8557664572141768],
            [13.01018359848671, 2.862678773927021],
            [13.018442846632976, 2.8603721301012714],
            [13.022726373860477, 2.8503208996511824],
            [13.020600620756193, 2.844220424832282],
            [13.021907618524256, 2.8398328915197046],
            [13.029313024730891, 2.8394619914641535],
            [13.035147073147558, 2.8461535983255324],
            [13.038278080298866, 2.8567319707286853],
            [13.044139414778284, 2.8556368880516634],
            [13.049185618029465, 2.857302734320301],
            [13.063981628699652, 2.8535079790205184],
            [13.067452673337767, 2.8508433089793237],
            [13.071796488659414, 2.8452535451420946],
            [13.075239720771842, 2.8425595651881728],
            [13.0790687123697, 2.8429141118641],
            [13.08314166701925, 2.8474711730242492],
            [13.08764154144127, 2.847280654383143],
            [13.096947745796795, 2.845229397628217],
            [13.103960482551908, 2.8460754606715932],
            [13.110060709778462, 2.8487438253397213],
            [13.113371197065161, 2.8462661819421746],
            [13.113178457032587, 2.838999590880917],
            [13.117776713504929, 2.8356857419372146],
            [13.126525168174597, 2.8381875969894605],
            [13.136042745258003, 2.83660356780975],
            [13.141999764098971, 2.8365269215545412],
            [13.144333730164782, 2.8324778330145985],
            [13.138782103586495, 2.8309450239399445],
            [13.134959902301953, 2.8258600250531463],
            [13.137899454321731, 2.8161616429660503],
            [13.142774492231016, 2.8124366694944753],
            [13.151446357522765, 2.8167989617150444],
            [13.15755895057856, 2.813339865087108],
            [13.161229293481133, 2.8158999070445994],
            [13.161123836763645, 2.819269787861778],
            [13.164169224346573, 2.826172437893405],
            [13.164688509915267, 2.8327259152822415],
            [13.168120649133254, 2.8364435918633726],
            [13.175095331300563, 2.8338454952789287],
            [13.179478298165034, 2.82909866206711],
            [13.18369303889832, 2.8284109955453447],
            [13.187871436960753, 2.8310732552922677],
            [13.188278239912748, 2.8346531936424397],
            [13.191266435757885, 2.840303170515583],
            [13.197911633855115, 2.8436457599901566],
            [13.198968212045017, 2.8488438543615078],
            [13.20162317914706, 2.8490385615270193],
            [13.206044890674441, 2.8606466071574537],
            [13.201807107099853, 2.861968407768339],
            [13.20032143832691, 2.8653015996340776],
            [13.200535291768245, 2.870858710844705],
            [13.202671074648734, 2.873039489702377],
            [13.211911938163079, 2.875756295555562],
            [13.228009984749319, 2.8714711190969022],
            [13.235510881075198, 2.87050598765398],
            [13.245152391448805, 2.8593509797672487],
            [13.24816551894682, 2.856851546912106],
            [13.247741728467302, 2.8531970574106618],
            [13.23711845363521, 2.814660725526081],
            [13.232132485891345, 2.808675221088186],
            [13.231191122346447, 2.7975217108589185],
            [13.227381828122413, 2.7955133599940174],
            [13.224566169241836, 2.79133742810444],
            [13.222277789082883, 2.7810942102177747],
            [13.219623498173423, 2.7775067671242213],
            [13.219124857503106, 2.7719660432144697],
            [13.215697699606237, 2.767003519420787],
            [13.216655912373865, 2.7605794259557532],
            [13.212394747316903, 2.752322096902242],
            [13.212023416812524, 2.74925585082816],
            [13.206852568107731, 2.7361830176128468],
            [13.207530786665103, 2.7298977092714374],
            [13.20600524569261, 2.72671797445864],
            [13.200205637627723, 2.722299402908357],
            [13.197094339400513, 2.7158579028628624],
            [13.195923126754508, 2.709073081600879],
            [13.194165684662972, 2.7063210181941764],
            [13.195611065442328, 2.6996624258093878],
            [13.193408515924418, 2.6981421907707683],
            [13.191898829307776, 2.6900032384041856],
            [13.18845624511059, 2.6874483771396616],
            [13.186994105949266, 2.6801537319303423],
            [13.183622399396526, 2.6770046655107467],
            [13.18570936413096, 2.672733258650052],
            [13.181295498195059, 2.660857787310821],
            [13.181064353955843, 2.657986869721355],
            [13.176822500716284, 2.654391335851559],
            [13.176527456190186, 2.6476770103960128],
            [13.172388189343453, 2.6463050023969505],
            [13.169737356848223, 2.643016788925017],
            [13.172631169608481, 2.6369386249164455],
            [13.171127447597483, 2.6293164053738636],
            [13.172624776034105, 2.6277721947095207],
            [13.170600878674964, 2.6232364301682387],
            [13.167460445534239, 2.620418769572928],
            [13.162755778018331, 2.6209749287229327],
            [13.160795323590028, 2.6191164867780095],
            [13.16349616006059, 2.6139084798975967],
            [13.16550290241341, 2.604282261883286],
            [13.159266452305992, 2.600161127178198],
            [13.150811985009646, 2.599434869987737],
            [13.151890393886866, 2.595268442292242],
            [13.150707204817348, 2.59216697914449],
            [13.151759146379803, 2.584403402284149],
            [13.153089700945683, 2.5815825211871406],
            [13.151204723125293, 2.5768931761187215],
            [13.151408533125638, 2.565771423772756],
            [13.148554150303413, 2.563158735311546],
            [13.14808197200883, 2.5574348018854662],
            [13.143924213771653, 2.5516841618292037],
            [13.14180650517983, 2.5452987053049996],
            [13.137020080415523, 2.544595531348639],
            [13.133618665700075, 2.5474014639181966],
            [13.131816804438461, 2.5523280358736296],
            [13.125718235584705, 2.5493003099546203],
            [13.121136005488784, 2.5508822762971852],
            [13.11470110559526, 2.543421089434511],
            [13.114908826698125, 2.5346865123668256],
            [13.112934128820543, 2.5282715084037815],
            [13.10581265611617, 2.525253098613903],
            [13.101797382110302, 2.5201648389663784],
            [13.099016111790021, 2.5211443981931847],
            [13.092773772191089, 2.514661110998042],
            [13.09223202338822, 2.506178434913473],
            [13.088248647912222, 2.5038267659758193],
            [13.086523876580161, 2.4990147462590704],
            [13.088316633937671, 2.490577348210945],
            [13.085599464242195, 2.4885800294643086],
            [13.081599437822211, 2.478959831375154],
            [13.082792037167058, 2.473664677661215],
            [13.07874648771358, 2.4709874083019985],
            [13.076701038210707, 2.463998136799582],
            [13.072972187229315, 2.4619755123005658],
            [13.060542597366494, 2.462949404686787],
            [13.05578631112533, 2.4624033621537675],
            [13.050655769964939, 2.4583612348449386],
            [13.038790022018446, 2.457755473067628],
            [13.035865722838416, 2.459214161381633],
            [13.033361230296306, 2.46565151825471],
            [13.02530275037499, 2.481610205398227],
            [13.020972583277139, 2.4874175721251994],
            [13.011022336203911, 2.491708912402384],
            [13.007040585191533, 2.4922055466251285],
            [12.989714740575257, 2.4987609780431517],
            [12.986072465390048, 2.502592328739503],
            [12.981573653834209, 2.5094974092876234],
            [12.979182594405717, 2.50869722264184],
            [12.970960373972671, 2.5096235805308647],
            [12.964107755126806, 2.514944783506317],
            [12.95228485298202, 2.517944698428011],
            [12.948641733693371, 2.5206716710603754],
            [12.942949695136098, 2.527388793865912],
            [12.942000251384071, 2.5338371923068213],
            [12.930323918965799, 2.5400927855744646],
            [12.92962206023106, 2.5427831785584583],
            [12.913504541225752, 2.539898305528203],
            [12.909979590297256, 2.5363909323975635],
            [12.90380168110442, 2.535860748953122],
            [12.897655435889948, 2.5335640469864273],
            [12.89393467110797, 2.52821695769312],
            [12.88952541401555, 2.5246695955272593],
            [12.889796273223238, 2.522782709972529],
            [12.884411515915, 2.5135088454982757],
            [12.880644524575658, 2.517937480020031],
            [12.87824016322244, 2.5179356548212986],
            [12.874312406389176, 2.5092634442789317],
            [12.87603158251621, 2.502626165090392],
            [12.87057602646463, 2.49787302046927],
            [12.864489928766586, 2.4994566825909863],
            [12.86251845524804, 2.4973205445551945],
            [12.862441506317504, 2.4912271303371227],
            [12.858092750712029, 2.4913360335350947],
            [12.851562550273718, 2.4875136294172155],
            [12.848203063172754, 2.4885887837751843],
            [12.844478341304935, 2.484930846211255],
            [12.8458206150917, 2.4807735409999614],
            [12.841015257752767, 2.4754600264269726],
            [12.840461250135625, 2.472390658790692],
            [12.842591371203227, 2.4644540338626437],
            [12.836315454290736, 2.46527571931672],
            [12.832770025281711, 2.4713419475536202],
            [12.825282923672024, 2.4726985853648102],
            [12.824484877642472, 2.470354489739532],
            [12.8197095287928, 2.470984174252423],
            [12.81601539818492, 2.4695467628862025],
            [12.81612339117386, 2.466664474953797],
            [12.809705014180597, 2.4622816457963475],
            [12.808127985164887, 2.4588999427559965],
            [12.80012349582932, 2.4623960755827476],
            [12.795385645162884, 2.4632631247870793],
            [12.794485455208756, 2.4675467941567724],
            [12.791756429797589, 2.4701040992400776],
            [12.786794301317629, 2.469383512071087],
            [12.782892045134902, 2.4708709469732786],
            [12.784038468507958, 2.474967151287214],
            [12.779263552807206, 2.4778136274172358],
            [12.76986054714265, 2.478612290609094],
            [12.76799214485321, 2.4833993958230867],
            [12.763219718913842, 2.4820358217920666],
            [12.758593839615736, 2.4776837679660564],
            [12.755884172113886, 2.4780282965343976],
            [12.75314113815013, 2.4746286207159103],
            [12.749336574939914, 2.4750991551414354],
            [12.740326234216463, 2.4803238210641383],
            [12.742190273443766, 2.4830574042022415],
            [12.737055829308904, 2.4877756516459906],
            [12.735083805335032, 2.484861925632677],
            [12.729593910652307, 2.4843619215788895],
            [12.725147453219657, 2.487905473963227],
            [12.719953913031842, 2.4902798726353854],
            [12.694372613779665, 2.4857593184747],
            [12.676770640651213, 2.483153516711092],
            [12.671487399347152, 2.486049680500308],
            [12.666540159751587, 2.4855178097497],
            [12.6676544400424, 2.481192060104651],
            [12.629591184444983, 2.474040019762689],
            [12.623258861352912, 2.4747612786011914],
            [12.621778924005143, 2.471878384310641],
            [12.613719126973788, 2.474763686726465],
            [12.607942637056745, 2.4836437203773167],
            [12.600007752548452, 2.49033767680539],
            [12.596524831795811, 2.498546261896591],
            [12.59894099425261, 2.5043262494841887],
            [12.60377449916279, 2.507688663299427],
            [12.608230314530648, 2.5084505006096762],
            [12.623175317273063, 2.507833160357896],
            [12.629350457510577, 2.5101835260444907],
            [12.633200943994808, 2.5172817158262295],
            [12.633584200097445, 2.5258906961129433],
            [12.629524121336873, 2.5368871044460835],
            [12.62749914776075, 2.539371076354725],
            [12.618831334851885, 2.543040917418459],
            [12.61458570163915, 2.5426822165649368]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.46677280331629, "lat": 40.31091213076963 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42129"],
        "coty_name": ["Westmoreland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Westmoreland County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01209191"
      },
      "bbox": [
        12.596524831795811, 2.457755473067628, 13.24816551894682,
        3.047897612693498
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.4349827053760205, 5.19318526747505],
            [-4.2914472818050555, 5.182947952513795],
            [-4.21056936115219, 5.177441530985174],
            [-4.1108213838205705, 5.170668979272575],
            [-3.9866760971221824, 5.1625374423573875],
            [-3.979421487795733, 5.162341599135517],
            [-3.9728857642477386, 5.165947749097089],
            [-3.973909714862861, 5.17111979044026],
            [-3.9673072938055793, 5.170087364098053],
            [-3.9650298888218276, 5.171380510514669],
            [-3.964675590441609, 5.178448751437853],
            [-3.9613472575630375, 5.179623962826604],
            [-3.9585805172036213, 5.176491755757998],
            [-3.952647525262487, 5.173834141664148],
            [-3.9542619729415773, 5.1470980689749455],
            [-3.967088389915187, 4.952107243761599],
            [-3.9671118117354496, 4.949896016804339],
            [-3.9469782303648016, 4.948760033436884],
            [-3.948436155666729, 4.918985527113575],
            [-3.9489408957234913, 4.914513764419901],
            [-3.9523655751553766, 4.861896488060562],
            [-3.9533856511107013, 4.843136757008107],
            [-3.962646592294735, 4.688441299997087],
            [-3.9678018870043243, 4.601261015914572],
            [-3.9479103676089085, 4.599909407376642],
            [-3.9483724582798128, 4.590343894187099],
            [-3.9564920517634405, 4.4747041460751555],
            [-3.957025662667998, 4.470099097290037],
            [-3.957069182661222, 4.470101884763057],
            [-4.055748136079571, 4.476654521848927],
            [-4.1544284542168155, 4.483186836250345],
            [-4.250809793775354, 4.489698929994051],
            [-4.315121675218184, 4.494235036506384],
            [-4.4008785578534395, 4.500377188862026],
            [-4.471905707957089, 4.505545249592367],
            [-4.623109631755891, 4.516997332879608],
            [-4.613674820208047, 4.646506838443135],
            [-4.609355355023897, 4.704749053074704],
            [-4.602047172474749, 4.803337429654538],
            [-4.594421561920708, 4.90677540828364],
            [-4.588090829831606, 4.992901146679106],
            [-4.578630859474685, 5.121611918513095],
            [-4.57497590035149, 5.122718716454237],
            [-4.569916127439449, 5.126959758894886],
            [-4.566696374005899, 5.1250112119108975],
            [-4.562370321623319, 5.127587166001024],
            [-4.562088238393961, 5.1315629430659175],
            [-4.5585982985563245, 5.133089856612469],
            [-4.550941745958575, 5.130104175099741],
            [-4.54770235543405, 5.127103870175799],
            [-4.53874627828925, 5.130121520895032],
            [-4.532125077231581, 5.1294313399419345],
            [-4.528474460486795, 5.130873811825199],
            [-4.523832023775275, 5.137991854966501],
            [-4.527694759366795, 5.14306739752019],
            [-4.52519386134638, 5.148400053587977],
            [-4.519591172562568, 5.151366806090075],
            [-4.518182630003053, 5.1559504196485175],
            [-4.520195847757911, 5.160703366267846],
            [-4.518878588769865, 5.164445948488723],
            [-4.5153004179074525, 5.167926983333632],
            [-4.516011540906121, 5.172606130643874],
            [-4.510292097427557, 5.1742388738167495],
            [-4.507812141813334, 5.177043612181431],
            [-4.5091134185812205, 5.183698850459318],
            [-4.502767310572432, 5.185355801987969],
            [-4.491736385029413, 5.180890015463797],
            [-4.488181156513141, 5.180251013359381],
            [-4.481237480247644, 5.17587372929624],
            [-4.47770745884582, 5.1774674615474705],
            [-4.474146619496469, 5.175828950224273],
            [-4.475351069237495, 5.1711069733513],
            [-4.473765095477588, 5.167129644125138],
            [-4.468026764739494, 5.166249299686925],
            [-4.465370190447422, 5.167748111905524],
            [-4.4634287403846375, 5.172953822765738],
            [-4.458525526961085, 5.169671269397491],
            [-4.453326424979062, 5.1638325924395385],
            [-4.448669156035994, 5.165988876135831],
            [-4.447156135619926, 5.170549761614547],
            [-4.439546106931522, 5.173487908643614],
            [-4.440937805563649, 5.1777591784023524],
            [-4.440138295171718, 5.181235859108143],
            [-4.434159142549321, 5.191250262208021],
            [-4.4349827053760205, 5.19318526747505]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.55166232715256,
          "lat": 43.33554742606593
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46102"],
        "coty_name": ["Oglala Lakota"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oglala Lakota County"],
        "coty_fp_code": "102",
        "coty_gnis_code": "01266992"
      },
      "bbox": [
        -4.623109631755891, 4.470099097290037, -3.9469782303648016,
        5.19318526747505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.1092516948976705, -2.5996875045582333],
            [7.1111899945909185, -2.531576878183862],
            [7.119369222292206, -2.5248983903550477],
            [7.126462399679542, -2.5250708402982776],
            [7.128961643874415, -2.5197062916501127],
            [7.141179742587406, -2.5170596319154748],
            [7.148957268372958, -2.518557495824267],
            [7.15230953293824, -2.5123528158746367],
            [7.156705372464108, -2.510252463424171],
            [7.1589584729410305, -2.5111938136127505],
            [7.166856710067725, -2.502173861599377],
            [7.170908697463936, -2.501350923717496],
            [7.177966237940455, -2.493551504402735],
            [7.18039356974918, -2.4872638019729596],
            [7.18469073694354, -2.486217953762577],
            [7.183299762482438, -2.4806056380532615],
            [7.190833908593913, -2.4798896230276783],
            [7.1934374122483575, -2.477802701191023],
            [7.202392955962518, -2.475476688125153],
            [7.205050632215565, -2.4808732278068244],
            [7.20718839693696, -2.4781337173782383],
            [7.212176872006572, -2.4768548401233814],
            [7.21750096429199, -2.479835820538753],
            [7.223108519622374, -2.478825147312577],
            [7.229025431039432, -2.4726784924655383],
            [7.22878906527964, -2.4690167937078926],
            [7.234276867869042, -2.4640303997039896],
            [7.237297921060953, -2.4594233884878167],
            [7.24063715734532, -2.4593190116046904],
            [7.2449623339116025, -2.455410225724951],
            [7.2465647604599, -2.44900382399372],
            [7.244565562178954, -2.445498335839728],
            [7.244865246534659, -2.4419809887258466],
            [7.242896893792189, -2.4379088063486867],
            [7.243812582453805, -2.435429807765554],
            [7.24121536706608, -2.4318388877567454],
            [7.277258684154925, -2.4334120999484927],
            [7.277849747199658, -2.437884525098095],
            [7.283759978594256, -2.435799085407784],
            [7.283354408574344, -2.4336436262632053],
            [7.350392909025878, -2.436331004901715],
            [7.4146663761985625, -2.439073395038949],
            [7.429212035967924, -2.4398451966945074],
            [7.429136744802964, -2.4418397750847594],
            [7.442432569404304, -2.442170834327436],
            [7.449885284493493, -2.4450906741877483],
            [7.451666201666366, -2.44160558399789],
            [7.491504235938927, -2.441605497479322],
            [7.508064278022382, -2.441874283485937],
            [7.5086827710016335, -2.4482635045389736],
            [7.508626826584325, -2.4602715541809825],
            [7.512049061548396, -2.460347108467828],
            [7.511557352448125, -2.486660044563105],
            [7.510265145714531, -2.5346497336971794],
            [7.509503860138069, -2.5516413666694646],
            [7.508116772190081, -2.6264920252228277],
            [7.507458547307712, -2.653620420882408],
            [7.505980196259579, -2.679489197013036],
            [7.500775515710936, -2.6809831871542875],
            [7.497895919342039, -2.68418865144086],
            [7.492496607621963, -2.6856878404175735],
            [7.483991798450882, -2.6862387382837447],
            [7.483705694025797, -2.6888817774584512],
            [7.49154203503856, -2.690808846367915],
            [7.4944456432668485, -2.696302914905033],
            [7.494256304269303, -2.6991071151824553],
            [7.49091274891161, -2.7055252638362974],
            [7.487334218647525, -2.70970246885404],
            [7.483142745197106, -2.710875928522975],
            [7.464272026226331, -2.711457750757879],
            [7.459986969068585, -2.7135231518973972],
            [7.458042204161635, -2.719543872167197],
            [7.453171336101041, -2.7231666170386086],
            [7.450472187173756, -2.7236305284420728],
            [7.449462087456, -2.7295156325773897],
            [7.442354117436077, -2.7364081473253186],
            [7.443864329794896, -2.7390007091263806],
            [7.4417622507267795, -2.7499791834453617],
            [7.439119628484896, -2.753373535699831],
            [7.435958506755445, -2.7524337690314526],
            [7.431243429875705, -2.7543826226702617],
            [7.427811837143219, -2.753048219992948],
            [7.42215577867826, -2.75301063737251],
            [7.416082522795663, -2.7575761173416433],
            [7.4132232082939495, -2.7539694661195515],
            [7.367194597514155, -2.7932069125287295],
            [7.343908932952707, -2.800568942498067],
            [7.341009344417096, -2.804505435434404],
            [7.335280415654849, -2.8059481195536398],
            [7.295406460433903, -2.796109732073856],
            [7.277790524456219, -2.7998898268455665],
            [7.2779093427180115, -2.798334133892555],
            [7.268091813197682, -2.798204965285638],
            [7.261969316793719, -2.79720328007462],
            [7.256968925115595, -2.789939223856718],
            [7.250166565066271, -2.7873954186792584],
            [7.247616550197046, -2.7842395142337333],
            [7.247354285628226, -2.7807871548254837],
            [7.244292930519908, -2.7764704604456356],
            [7.234382971701598, -2.7782800612437284],
            [7.229905851245867, -2.7769164941746114],
            [7.223940700647482, -2.784177682226659],
            [7.220546933220933, -2.784983053553112],
            [7.216866048090571, -2.78858700586777],
            [7.215097921752982, -2.7953109129376332],
            [7.210267644769373, -2.798892618675542],
            [7.2022650220072695, -2.7999747026601276],
            [7.207433954126547, -2.8052833486170394],
            [7.207675260964217, -2.812969558972702],
            [7.196705220029005, -2.812905590853044],
            [7.194293740999691, -2.8192795759790785],
            [7.190389541055901, -2.8192512397886893],
            [7.185471391526827, -2.824616328148918],
            [7.1764132184560525, -2.8259208424223625],
            [7.173771396119316, -2.8216580413337953],
            [7.161001553056126, -2.812257360246731],
            [7.160167164053825, -2.8094350587381105],
            [7.153976695534614, -2.8070468022528483],
            [7.151229125799559, -2.803492615672],
            [7.146319568100004, -2.803106024152975],
            [7.14261782050461, -2.799341665466801],
            [7.138069262831544, -2.7988906160079265],
            [7.133934178329995, -2.796180497298249],
            [7.1332210264891955, -2.7932805627408293],
            [7.126312082947391, -2.7924654378457356],
            [7.124065981993097, -2.790215163815476],
            [7.119746282181487, -2.7894041955215982],
            [7.117934111858789, -2.785381880799249],
            [7.112301863248897, -2.784419859597736],
            [7.106821896101998, -2.779252767858785],
            [7.102956149870727, -2.7771023905126224],
            [7.104356631863675, -2.7381405580286438],
            [7.113932835965499, -2.738173418732705],
            [7.115293269965654, -2.7352441197246207],
            [7.126004396387156, -2.734964000374293],
            [7.125988227342392, -2.728384750828651],
            [7.120479267246027, -2.728890019593536],
            [7.11286551719822, -2.710431262976298],
            [7.110689386615008, -2.7140287266254215],
            [7.106169060147278, -2.713783143835541],
            [7.1092516948976705, -2.5996875045582333]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.47330730096061, "lat": 35.80326580770198 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47081"],
        "coty_name": ["Hickman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hickman County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01639756"
      },
      "bbox": [
        7.102956149870727, -2.8259208424223625, 7.512049061548396,
        -2.4318388877567454
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.563507525157462, -2.6506312650067443],
            [5.565381833535154, -2.6480091695596224],
            [5.565146588973066, -2.6430052432510998],
            [5.563041359309064, -2.638431624550478],
            [5.565377198028584, -2.633390876210166],
            [5.570087269901276, -2.6321072883380827],
            [5.576835539454035, -2.635457858449318],
            [5.584013758272152, -2.6358921586730304],
            [5.588859235354044, -2.6350661404439393],
            [5.59851233597758, -2.6310350916659497],
            [5.604827562723891, -2.6252031392017625],
            [5.611903103658883, -2.628782244552246],
            [5.61451493611371, -2.6230581704839344],
            [5.619756164855899, -2.627107195696018],
            [5.624829540107804, -2.621285751730607],
            [5.6279056598896275, -2.6144958706501944],
            [5.6338958052429104, -2.617740374316895],
            [5.637262214849302, -2.6160788613517534],
            [5.6450140493697685, -2.6208206483606524],
            [5.651391899099341, -2.6210887893422283],
            [5.656931225139552, -2.616275091040801],
            [5.662804592168516, -2.62176166006856],
            [5.668734175761242, -2.6150337575126255],
            [5.669549873590467, -2.618418868043593],
            [5.667537997792466, -2.6220396508270816],
            [5.669732088070972, -2.6251062022307616],
            [5.674082317733607, -2.6170225851879487],
            [5.680200113694643, -2.616499690507519],
            [5.682329033650793, -2.614324656385358],
            [5.6805011723581975, -2.6108341497662315],
            [5.682363741117668, -2.60478364879005],
            [5.680871760638272, -2.6007607705272773],
            [5.748138434950407, -2.5972576223841557],
            [5.748372049151672, -2.5995759597182304],
            [5.7533299242691625, -2.6060402682797936],
            [5.756590359888527, -2.6026726705602967],
            [5.764329944486964, -2.6159707621763517],
            [5.770334144971252, -2.6167309986583303],
            [5.768277809063081, -2.6220597280422373],
            [5.775042029141618, -2.6265857952171254],
            [5.778966337796532, -2.6271761132693667],
            [5.781671944661023, -2.6328942840016327],
            [5.788053670039115, -2.6343342824818055],
            [5.792914750610652, -2.636722000441974],
            [5.794111671813551, -2.643488159573074],
            [5.7982162430507325, -2.645656633831445],
            [5.797897550773273, -2.6494292865413183],
            [5.800883204356412, -2.656287293133125],
            [5.8040985319283, -2.6597163077329364],
            [5.804364000874458, -2.663610689303754],
            [5.807046562802304, -2.6694861258908986],
            [5.80598018859229, -2.674954301462853],
            [5.8080307112200344, -2.6781878612189867],
            [5.804359714603161, -2.680479423214488],
            [5.8048159144234, -2.6836054436257046],
            [5.802107944950203, -2.6893339428003813],
            [5.7985631095441414, -2.6925965256029922],
            [5.797664881519676, -2.7014782412284086],
            [5.795323394736493, -2.7058588857185324],
            [5.796070124445605, -2.7105156379763673],
            [5.7938119070897, -2.71367672292077],
            [5.7933848986528105, -2.719550249454782],
            [5.797985463050065, -2.724110281388126],
            [5.79177840307464, -2.7230637910997686],
            [5.771316296799996, -2.72235538577348],
            [5.7609441819171625, -2.7216173887539603],
            [5.759019101654817, -2.7357032923688647],
            [5.754677055955716, -2.7417276302891262],
            [5.748706879820785, -2.746383163158186],
            [5.747349870556859, -2.750453094203276],
            [5.7475960804296955, -2.757331997569233],
            [5.742897763279081, -2.7600871690139193],
            [5.739197197008323, -2.76703580836306],
            [5.739816556154201, -2.775032449517365],
            [5.73452601270446, -2.7807790977015956],
            [5.735431890811123, -2.798898437451377],
            [5.745622505275636, -2.7987407082993463],
            [5.745945985191284, -2.805986567797389],
            [5.742368203087944, -2.8063188529851093],
            [5.742867841440942, -2.8166126344557276],
            [5.729871848328562, -2.8653267681460064],
            [5.718905427790602, -2.8659190334683613],
            [5.721345341686319, -2.923963178825102],
            [5.722043028502188, -2.9540691218927377],
            [5.711913951816855, -2.956050327141764],
            [5.707496092415211, -2.9609054378185142],
            [5.7072523115798806, -2.9641299919588593],
            [5.703203930147482, -2.965363766311183],
            [5.701000083909035, -2.9691557246077567],
            [5.697221431468661, -2.9705221925159178],
            [5.6906122106021195, -2.9708112482107105],
            [5.689067598979898, -2.969149222303546],
            [5.689179488528827, -2.96362088837543],
            [5.681192730693746, -2.962030683988557],
            [5.682753868789407, -2.958883086100228],
            [5.680670069642706, -2.956311275261321],
            [5.676099837146764, -2.960143623142084],
            [5.676724922482952, -2.954193488120245],
            [5.671201317875396, -2.9555371996022157],
            [5.671596787074339, -2.9500764101830868],
            [5.666894088227313, -2.9484238025246237],
            [5.660927226787426, -2.9493020415050637],
            [5.660996860361342, -2.944028063766782],
            [5.656479738980073, -2.947715306356477],
            [5.652450616982526, -2.9485724449645967],
            [5.652273706806375, -2.943714182305233],
            [5.64727922290169, -2.943541681716225],
            [5.64187638172334, -2.940373548967867],
            [5.638685943518049, -2.940934856953449],
            [5.63219548351146, -2.9384860349486863],
            [5.628798817179005, -2.9357854284483307],
            [5.625184464562924, -2.930209727961178],
            [5.618087268594438, -2.9263594127489023],
            [5.6111924826715045, -2.92571273185039],
            [5.607869829983746, -2.923718302090588],
            [5.60846059251873, -2.921022238850145],
            [5.604919187086698, -2.918748485450524],
            [5.603827957999389, -2.9136121708833964],
            [5.593296284889311, -2.9064795807137327],
            [5.588869453607294, -2.9070582182428613],
            [5.589221087893205, -2.9127594101588388],
            [5.5815909418456275, -2.913240139237696],
            [5.575696675761087, -2.911632567066908],
            [5.570924127104944, -2.914200715517264],
            [5.573761952667141, -2.9194277178987047],
            [5.571023619040839, -2.9232940335175437],
            [5.564977116341479, -2.92750413411254],
            [5.56007950663119, -2.9280629103639244],
            [5.556996563755444, -2.9212692184915894],
            [5.553470458150008, -2.919838525157647],
            [5.552019723620773, -2.9227033725068288],
            [5.54578628831077, -2.922677482798172],
            [5.543288560491345, -2.9248077699686603],
            [5.5401557858858546, -2.922237387910932],
            [5.540919650769035, -2.919160852996454],
            [5.5340951099756674, -2.9186026483461007],
            [5.529270522498552, -2.922184489040631],
            [5.525450464677417, -2.9212406239041724],
            [5.516000812212764, -2.9246377096969858],
            [5.512610757289281, -2.923615319681409],
            [5.510263126277024, -2.9156796876465934],
            [5.508014890800722, -2.915428080098997],
            [5.5009477829448645, -2.9221574656797444],
            [5.5011318542421, -2.9183692352412134],
            [5.493433699383514, -2.9177932730094223],
            [5.491322456768378, -2.91494171552971],
            [5.486721693851814, -2.914197765567351],
            [5.486441061272577, -2.922094549536372],
            [5.48210754470646, -2.9193573755156983],
            [5.481333663252956, -2.924794985686715],
            [5.472997080825921, -2.9275783450066735],
            [5.468541789118192, -2.9311622161495268],
            [5.464707551562127, -2.9284520302835313],
            [5.459429652760865, -2.929119080170039],
            [5.453547455268887, -2.9376526356040307],
            [5.449129971379526, -2.939995699286333],
            [5.451281043227686, -2.9446350958017824],
            [5.4453194799972175, -2.9478934635122935],
            [5.440728665818884, -2.9489284042623725],
            [5.436506954757327, -2.9550467360456034],
            [5.435821886123833, -2.9586841629715903],
            [5.4367550937219935, -2.9651498803683225],
            [5.433859915579601, -2.9660508799247247],
            [5.419734548552477, -2.96530887948206],
            [5.422447032705328, -2.9716997749319387],
            [5.419205518245713, -2.9746603412108574],
            [5.415674323013883, -2.9747030923988813],
            [5.414475467444114, -2.978942882541046],
            [5.410881120974093, -2.978350310613665],
            [5.407289710343177, -2.985259806552102],
            [5.404022229251066, -2.9820830710097233],
            [5.397852397254227, -2.9854021915746727],
            [5.393812037982303, -2.9846951923368006],
            [5.388260519159503, -2.988793559065743],
            [5.392528058970442, -2.9935432794843284],
            [5.386595933756683, -3.001196848319517],
            [5.387815652894143, -3.0038637814669915],
            [5.383699855729864, -3.0220753417750164],
            [5.378835673899544, -3.0303527837626736],
            [5.3721722101568785, -3.0351346233004866],
            [5.370767615559889, -3.0256371051979425],
            [5.368891089529334, -3.024098460330265],
            [5.355680560781502, -3.0224687537025603],
            [5.3449602936179685, -3.017743123757364],
            [5.340575825949124, -3.0112810930695106],
            [5.333931960757735, -2.999336735159057],
            [5.330394125803919, -2.99041616159501],
            [5.331052798076145, -2.9845837916759343],
            [5.334991432653819, -2.977397687215802],
            [5.339344670916349, -2.9729605310187743],
            [5.349321354007829, -2.965866147472011],
            [5.359395781461291, -2.960952137463413],
            [5.365758709061622, -2.9551345371580178],
            [5.3751573031794635, -2.9570895687943284],
            [5.38273172713855, -2.9552347822085996],
            [5.3959921548395196, -2.942931124610234],
            [5.403008593458192, -2.939415688677526],
            [5.4086028881590735, -2.9353623759803553],
            [5.410547533890294, -2.931382126261446],
            [5.4122010739005, -2.9192105703137354],
            [5.411478284623547, -2.9119621164179517],
            [5.40947995114534, -2.907214739896658],
            [5.404784367030851, -2.9007814505697493],
            [5.398020311010355, -2.8999337142035024],
            [5.390568815191964, -2.9039265469909035],
            [5.385465615636417, -2.914788920225966],
            [5.38295487531454, -2.9176346070016015],
            [5.373539156170599, -2.9209995182984607],
            [5.367712465743685, -2.92112998794431],
            [5.356886366361377, -2.91763067614888],
            [5.3501370289855075, -2.913857374001266],
            [5.344065288258383, -2.9087093183927157],
            [5.3388076842945935, -2.9004965866584884],
            [5.330132060282059, -2.891615485287975],
            [5.325419842494896, -2.8845041324258767],
            [5.324305973000426, -2.8803407007122077],
            [5.322901651814739, -2.86272616925822],
            [5.320727188953094, -2.851517405863071],
            [5.320936496194624, -2.8479583732915685],
            [5.324321628547954, -2.843260142817074],
            [5.331316810662788, -2.8383388301144867],
            [5.334620272119568, -2.8344349771849595],
            [5.335929009089313, -2.8294654679753517],
            [5.353504188584237, -2.8172419041610586],
            [5.356099340330344, -2.813645828962573],
            [5.360703149606246, -2.812721526888996],
            [5.363956134780882, -2.816416429701631],
            [5.370929842243827, -2.8202428739885192],
            [5.3749598761051045, -2.8197636467074703],
            [5.389120060618304, -2.813637109855234],
            [5.39543402772036, -2.8123064624382614],
            [5.404136073872273, -2.813469078660886],
            [5.406213898885382, -2.8219954606465696],
            [5.409372434740227, -2.824540223609752],
            [5.415759597499074, -2.8261342581412814],
            [5.426400350530984, -2.8223660961572588],
            [5.433067980810274, -2.8183934162931306],
            [5.445455882175498, -2.809041326697483],
            [5.446737642786596, -2.806731525763898],
            [5.445319376363627, -2.7922558273355045],
            [5.446919944765107, -2.7844807547858],
            [5.444337974113685, -2.7776210061426436],
            [5.4466430430867545, -2.7729493104798704],
            [5.4575835268853226, -2.7596873905002117],
            [5.470367826488209, -2.7544271969112373],
            [5.475868151039739, -2.7532256301498754],
            [5.488847523692508, -2.756940936990919],
            [5.493057564000722, -2.756761551102977],
            [5.495714361388783, -2.7590734445146965],
            [5.500648376767736, -2.759413622944535],
            [5.509935417629116, -2.7535126977319324],
            [5.521234008311051, -2.7437383782470754],
            [5.524851537040717, -2.7397434710956263],
            [5.526561303898481, -2.73495264168932],
            [5.52650943691564, -2.7283753724233817],
            [5.52304293095425, -2.7235986030005597],
            [5.5107993593375255, -2.7185392676008613],
            [5.5013510434502635, -2.7155260799225456],
            [5.480270817600559, -2.709985491669863],
            [5.469826194813836, -2.706418826473463],
            [5.464465071163361, -2.703368157310407],
            [5.461001320056737, -2.6989835386962424],
            [5.459178054943224, -2.6933264768676692],
            [5.460408863700363, -2.680251934946337],
            [5.463484890757265, -2.6728025404344926],
            [5.475033724790024, -2.658113053328265],
            [5.481448060247342, -2.651088504998475],
            [5.489248538123617, -2.6498196756811176],
            [5.493731707360277, -2.6502108624291734],
            [5.504357315414, -2.654556299475826],
            [5.516306771511119, -2.664350201125046],
            [5.52277810261846, -2.6690210404409394],
            [5.537216332499032, -2.6822301635503805],
            [5.54321067673131, -2.6840415461033613],
            [5.547840298939647, -2.6835379103184147],
            [5.55200270720497, -2.681199086926004],
            [5.558035280201449, -2.6757060147226395],
            [5.561243453644994, -2.6713975479195256],
            [5.563445980663825, -2.6614091959064043],
            [5.563507525157462, -2.6506312650067443]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.6304754828805, "lat": 35.76050978424199 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47097"],
        "coty_name": ["Lauderdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lauderdale County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01639763"
      },
      "bbox": [
        5.320727188953094, -3.0351346233004866, 5.8080307112200344,
        -2.5972576223841557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.649393828484337, -3.0732703052357753],
            [8.65521125570388, -3.0693016698041644],
            [8.660451457594494, -3.0642616452074543],
            [8.664985811347966, -3.0569990296599743],
            [8.669952081693868, -3.0530916972618294],
            [8.683484326594321, -3.0529795025206927],
            [8.688102445254808, -3.0500149567007013],
            [8.720251795745487, -3.066410982994395],
            [8.73004089610165, -3.0693009085770133],
            [8.749285080562611, -3.0701022160092375],
            [8.757288674937849, -3.069843418483749],
            [8.7921394695173, -3.041784318654667],
            [8.773942237254543, -2.993101466651163],
            [8.776969360180368, -2.9904947949991576],
            [8.787139606051475, -2.992501753599719],
            [8.789574863539135, -2.994621401317766],
            [8.793996964825213, -2.9903979680370676],
            [8.802836075013836, -2.985955620471757],
            [8.801774321403569, -2.982322707407358],
            [8.807164197979816, -2.978768120454419],
            [8.80869948762367, -2.976039830930284],
            [8.815485188948204, -2.9720769518885892],
            [8.819263113555056, -2.975001868686361],
            [8.824075906470316, -2.9747256173445313],
            [8.833864180288193, -2.9719450610898295],
            [8.890771777069494, -2.9504903558628217],
            [8.891965891448942, -2.9497496606394322],
            [8.894624793426347, -2.9606040714890254],
            [8.94766016013903, -2.983374170037441],
            [8.950286310287689, -2.989258917775691],
            [8.953034422896547, -2.990752335322752],
            [8.960600397349095, -2.9914576837107134],
            [8.964294802027458, -2.9933139774277735],
            [8.969409572628376, -2.9917190941621867],
            [8.977436916540931, -2.993036497703183],
            [8.98073707070174, -2.992068342497536],
            [8.983747267778087, -2.9944134355207304],
            [8.989778707378921, -2.9960611720190546],
            [8.99325867916111, -2.999450359638185],
            [8.995313777665359, -3.0051379494717896],
            [8.999999247727505, -3.005562472675742],
            [9.002756840120332, -3.0096592274529064],
            [9.00667400963034, -3.010821825687344],
            [9.007408952103951, -3.0142236714839683],
            [9.023669340014516, -3.0299862690060966],
            [9.027874217694578, -3.032160783138889],
            [9.029815017856997, -3.0387349961933845],
            [9.0343415731714, -3.046379134620001],
            [9.037247010245256, -3.048199856654966],
            [9.039560740757322, -3.0528882974466653],
            [9.036773406441881, -3.0611528015571197],
            [9.044440809895335, -3.0732146821012467],
            [9.040974580391557, -3.080769496878274],
            [9.041497835443128, -3.0890655376947693],
            [9.046893857530023, -3.095258313217565],
            [9.048439146964984, -3.0988292556482895],
            [9.049144847614542, -3.1067478775866344],
            [9.051322944315206, -3.116713976282673],
            [9.048336418364968, -3.1339195653420897],
            [9.046815601801308, -3.149098732767691],
            [9.056851345003041, -3.1478720143590366],
            [9.063229466359765, -3.152138459673216],
            [9.065764981181403, -3.152583920537349],
            [9.070830357432126, -3.1572249714414062],
            [9.07153861287205, -3.161292501720467],
            [9.076080721938187, -3.1639245205920847],
            [9.07569428069942, -3.1757235633416285],
            [9.074594118874042, -3.1826357647879524],
            [9.071981216005602, -3.1886767412837616],
            [9.067162726669828, -3.1957997162862912],
            [9.066240507047565, -3.2035518072843434],
            [9.064557821862048, -3.2088353476866],
            [9.061179955447146, -3.21302166427171],
            [9.056811082481996, -3.2153690593800905],
            [9.052484468752613, -3.213202267518941],
            [9.046310572792388, -3.213534821926659],
            [9.043009671520519, -3.2158005331298543],
            [9.04216758133507, -3.2208677712814913],
            [9.039403084048816, -3.2285246746531837],
            [9.036790947166804, -3.229010811461042],
            [9.038308184030415, -3.236606958109113],
            [9.036748809831192, -3.2433467140060546],
            [9.032239416581064, -3.250798352604894],
            [9.026411478390582, -3.256047918953383],
            [9.020733100259662, -3.2584585906361774],
            [9.020440546678136, -3.2620068496041745],
            [9.01310693329358, -3.263373217877682],
            [9.001468308648658, -3.2744305656085837],
            [8.996266489715216, -3.2749717424227827],
            [8.997334920000657, -3.2788132434218067],
            [8.891330600248326, -3.2888721062213198],
            [8.818818152952362, -3.295352935267705],
            [8.713891088651017, -3.3046089321068535],
            [8.681941860440702, -3.307790181655701],
            [8.667864897943055, -3.1753375845587786],
            [8.661505986015978, -3.112136623833927],
            [8.657533958372124, -3.075522679265074],
            [8.649706272428647, -3.0762405688207086],
            [8.649393828484337, -3.0732703052357753]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.6220188973918, "lat": 35.129290722096975 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47115"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01639770"
      },
      "bbox": [
        8.649393828484337, -3.307790181655701, 9.076080721938187,
        -2.9497496606394322
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.614295184211638, -2.0483133778728555],
            [8.611399897820107, -2.0418795075001444],
            [8.61352090911393, -2.0373954140099455],
            [8.617260832200278, -2.040630303180088],
            [8.62142057605044, -2.0394720146555625],
            [8.62813720856411, -2.046571309632803],
            [8.633112024436333, -2.047601175219332],
            [8.636272475836146, -2.050904983620846],
            [8.64037663193688, -2.050549229244962],
            [8.644852011333597, -2.054833624229339],
            [8.647629028747437, -2.055364915993999],
            [8.65329994572678, -2.0533695578594573],
            [8.658793403777285, -2.0485356798316254],
            [8.663652547220408, -2.0479374516381137],
            [8.673600279612828, -2.0490570229313656],
            [8.67754113838364, -2.0546661359061082],
            [8.686656034149587, -2.0497011730844377],
            [8.687005051813458, -2.0524982814608244],
            [8.690579524840345, -2.053636319695197],
            [8.695887271455716, -2.0530480919273466],
            [8.699015283100351, -2.0548371342856813],
            [8.706557003995878, -2.0527362423377116],
            [8.71001494558889, -2.053745066759002],
            [8.712144785460751, -2.0574091882638337],
            [8.71677655486165, -2.059252578896249],
            [8.719425540283845, -2.0545673449070643],
            [8.7249953240659, -2.0544385767790407],
            [8.727596874091677, -2.0511909949103253],
            [8.731064770172907, -2.0522942049850057],
            [8.730467438568107, -2.0569554240938963],
            [8.73297660060685, -2.0604456470785224],
            [8.737057019159286, -2.0576325865360117],
            [8.743893598723718, -2.055655878814351],
            [8.74956919460692, -2.0568238209500613],
            [8.748881481151528, -2.0506846502629235],
            [8.755867251783526, -2.050467321061259],
            [8.755727815350614, -2.0475082260230204],
            [8.758534327424341, -2.044623548951255],
            [8.766665650961459, -2.043531460345564],
            [8.766667142793812, -2.0401184196379916],
            [8.777924282099681, -2.0381395170324783],
            [8.780706376781854, -2.041971848670238],
            [8.780737704601227, -2.0461221724866165],
            [8.784541647283831, -2.047032784804241],
            [8.79277478467236, -2.0439010283704135],
            [8.790818789743943, -2.04112786586318],
            [8.79310026930689, -2.0328659543274106],
            [8.801696190982048, -2.031650707302537],
            [8.80538610983882, -2.0294814509397012],
            [8.805806172761237, -2.0245269784873527],
            [8.81583685731531, -2.0246607149045532],
            [8.8157402393913, -2.021871222989918],
            [8.809552997373292, -2.0223603012642717],
            [8.809545938448204, -2.01692009473628],
            [8.807719078587814, -2.0140883507303586],
            [8.807586579482175, -2.00617030129851],
            [8.809974889282056, -2.003400472285411],
            [8.818550738189199, -2.0031503430972375],
            [8.818599243614997, -2.006199981732906],
            [8.824740742260213, -2.0061647072184567],
            [8.824731307583352, -1.9983880842766868],
            [8.825877492257526, -1.9961500085179538],
            [8.825827872090247, -1.9848912528109106],
            [8.836931803024182, -1.9815319467672656],
            [8.833538798823012, -1.959109951835853],
            [8.836887605316727, -1.9576919429642847],
            [8.837925742477289, -1.961497829217241],
            [8.84237790663462, -1.959909429772453],
            [8.84262615856253, -1.9566651888788926],
            [8.852404667252912, -1.9573084196358168],
            [8.854749479026257, -1.9541476747613846],
            [8.861777719591723, -1.956132879676494],
            [8.862472701484458, -1.9601351093648023],
            [8.85963499489704, -1.9651455494226597],
            [8.866044211836702, -1.9691208396105964],
            [8.868578466334766, -1.9727974163940416],
            [8.868626821942229, -1.9768492307125132],
            [8.859120001741964, -1.9773814344880478],
            [8.861475898096863, -1.9817093960436418],
            [8.869291328191013, -1.9809572681315069],
            [8.869384143441788, -1.9859562105132735],
            [8.87112260835208, -1.9901526983472226],
            [8.871615422798346, -1.996309871875965],
            [8.874789001754293, -1.9980351952656703],
            [8.879691980998688, -1.9978684658018206],
            [8.885212363730513, -1.9940098147191223],
            [8.888074032938068, -2.00069650153628],
            [8.885559644426621, -2.002604122910011],
            [8.886744168202593, -2.0091510084724673],
            [8.889425692697031, -2.0103206299003515],
            [8.897430198147992, -2.009856461304883],
            [8.900418891329075, -2.0136620300009294],
            [8.90103348355324, -2.0186534150734476],
            [8.910975324647682, -2.019360067427826],
            [8.92884211809313, -2.0259340209170498],
            [8.934405780459514, -2.023479049323462],
            [8.938422031049575, -2.027875599155011],
            [8.941769191727271, -2.024253690951217],
            [8.945216310954834, -2.0238768330145955],
            [8.945496306210432, -2.029536067667304],
            [8.976714719620805, -2.028786288775546],
            [8.98069634082087, -2.042568744940779],
            [8.97860215368511, -2.045797402549635],
            [9.001216350452536, -2.051955379549541],
            [9.022632734190099, -2.0603867415804946],
            [9.023267283488977, -2.05710488658688],
            [9.028940791376089, -2.054949378277949],
            [9.029087130219802, -2.059649340003749],
            [9.031904463478046, -2.064077961293494],
            [9.043603902142992, -2.0691767680002284],
            [9.08152139015054, -2.0832769602102723],
            [9.149633612920221, -2.083369907282559],
            [9.16574024586235, -2.087769947090337],
            [9.160745473876762, -2.0940935396808804],
            [9.157929501487612, -2.094232632508514],
            [9.14508544426065, -2.1000987136968936],
            [9.141861768607194, -2.1009875939883123],
            [9.128464089544481, -2.131663776580979],
            [9.061735260469298, -2.132975694643501],
            [9.062017186343931, -2.138220281199014],
            [9.053876589888517, -2.1389989154687754],
            [9.054241184755258, -2.1553655940112177],
            [9.05793104357418, -2.1599418597195674],
            [9.060131586715956, -2.166846238765985],
            [9.057359095148392, -2.1718933861571705],
            [9.057302810532546, -2.1766513059407417],
            [9.06152824868518, -2.184602572768264],
            [9.058576807493811, -2.189373510516626],
            [9.058500155159134, -2.1999183315445663],
            [9.056752208793979, -2.1997563941841234],
            [9.054546770548157, -2.244540608323067],
            [9.058965928369096, -2.2441966972609695],
            [9.05931739095161, -2.2624240392588244],
            [9.053510596901969, -2.2624105767864537],
            [9.01442025955919, -2.252782243051025],
            [9.010771959908665, -2.2231860179189313],
            [9.011592612583371, -2.2139305322201994],
            [8.998682734419216, -2.213904813143136],
            [8.99827932470773, -2.2168174398149367],
            [8.972353840290822, -2.203835270471344],
            [8.959180758683608, -2.2014030191169565],
            [8.957015913439397, -2.199002105972966],
            [8.94439571461054, -2.198816280133095],
            [8.855145994222292, -2.1818994414238477],
            [8.848072131159466, -2.181046491543345],
            [8.818516782075884, -2.188590341714203],
            [8.813675494841167, -2.1940508359358364],
            [8.807009614162736, -2.194249972023907],
            [8.800807033578074, -2.209793000471191],
            [8.7946284383311, -2.206782721228967],
            [8.79064036553001, -2.2092963228187226],
            [8.79005969937321, -2.2144434944080915],
            [8.792245908387358, -2.221577422914403],
            [8.790856771313512, -2.2257297982785738],
            [8.786870660170944, -2.22891650451054],
            [8.78207398961799, -2.2276384514182634],
            [8.78040400393769, -2.229316337567109],
            [8.770890134872129, -2.2259671767149216],
            [8.768953898858474, -2.2289280198125394],
            [8.764381550313306, -2.2319727589050404],
            [8.76244273044697, -2.2397183231277835],
            [8.76026369413376, -2.2419566767184516],
            [8.749796159537865, -2.24793651403441],
            [8.746496330730567, -2.2508914591586002],
            [8.746439754785882, -2.260168263853208],
            [8.74160482950948, -2.2634610805010174],
            [8.739927870474967, -2.258692486818771],
            [8.737583578509321, -2.2586857359017967],
            [8.72599318111502, -2.2473981152574023],
            [8.70743002761035, -2.2139524837508975],
            [8.704443285614236, -2.2103280442556517],
            [8.696415015188586, -2.209042405761852],
            [8.676970445686907, -2.1998291615539736],
            [8.671533600459657, -2.2027124843147163],
            [8.670376711925643, -2.2008474669142246],
            [8.657965447765639, -2.2065102341544267],
            [8.654286197578505, -2.2164897488958983],
            [8.651285893296885, -2.21771296689155],
            [8.64284581108558, -2.2155938526429395],
            [8.640931554426258, -2.208477414669344],
            [8.634914277404414, -2.2080902213732543],
            [8.635663341800415, -2.2024198747295203],
            [8.63814900406684, -2.1964047484362785],
            [8.637997603204317, -2.190863939420825],
            [8.630660988086193, -2.1844085405105784],
            [8.629466577130161, -2.1860448654174],
            [8.622496796152628, -2.1842369381581874],
            [8.620681453153376, -2.179747882479586],
            [8.617562433390043, -2.178186927134114],
            [8.616669149635596, -2.174839113451013],
            [8.613241461189245, -2.1713909057893077],
            [8.613080216092554, -2.1663573249254173],
            [8.610428184226377, -2.1632829942473917],
            [8.606137604588499, -2.1617391979312472],
            [8.604131123336229, -2.157383954615894],
            [8.60797571805824, -2.14976047161869],
            [8.604779746235037, -2.1463143735444925],
            [8.60251028030623, -2.1410986702262376],
            [8.602952382195207, -2.118187585461763],
            [8.606476227459167, -2.117901597806858],
            [8.61696518828458, -2.114639003333596],
            [8.615219112897273, -2.1068692560446207],
            [8.610479150629292, -2.1078741487855455],
            [8.611056868220674, -2.1141090573546975],
            [8.602938628148427, -2.113738426053638],
            [8.600658331331514, -2.1055501795988323],
            [8.60410449791713, -2.1054146291956775],
            [8.607565360633707, -2.099926705840638],
            [8.602512303874008, -2.093188491399866],
            [8.603438736901854, -2.0866778652131472],
            [8.602385212795527, -2.081761169451775],
            [8.596912613529756, -2.084749580831494],
            [8.594633285507555, -2.082302198509566],
            [8.598299409985692, -2.077241857979807],
            [8.61243489464478, -2.076227552412874],
            [8.615806313630758, -2.072195288277246],
            [8.613899863296231, -2.066824748469091],
            [8.617324559738357, -2.0650917303159275],
            [8.613212958327741, -2.056101535504345],
            [8.610114553936013, -2.056780594447186],
            [8.614295184211638, -2.0483133778728555]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.49511575201599,
          "lat": 36.140928154243134
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47141"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01639783"
      },
      "bbox": [
        8.594633285507555, -2.2634610805010174, 9.16574024586235,
        -1.9541476747613846
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.304196879580819, -4.221978601328367],
            [-5.303477909700239, -4.211850567607836],
            [-5.190548716188985, -4.220158764808755],
            [-5.174097981910599, -4.221247373122306],
            [-5.063596413586963, -4.229166408252947],
            [-5.040556181750862, -4.230693923644703],
            [-4.95295225209058, -4.23687023536492],
            [-4.958712860678599, -4.315990545858914],
            [-4.965390445420801, -4.411859467781418],
            [-4.967836401980649, -4.447993437568239],
            [-4.981448507926108, -4.639160791365912],
            [-4.987377815322324, -4.725660478755564],
            [-5.008923548906538, -4.7242822815097725],
            [-5.147171683843014, -4.71462083958047],
            [-5.20256315581393, -4.710716636756634],
            [-5.342662776108159, -4.700615205799001],
            [-5.340389528598706, -4.674984792404808],
            [-5.335528235169068, -4.623755268339753],
            [-5.3316224558341485, -4.579655850897233],
            [-5.328683777966648, -4.550655619364658],
            [-5.326246717888332, -4.5216241961401336],
            [-5.323841287063417, -4.487897427043312],
            [-5.320512649265036, -4.445746995507586],
            [-5.313760232219485, -4.354073444184341],
            [-5.307371698078218, -4.267848671286564],
            [-5.304196879580819, -4.221978601328367]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.82987613354229,
          "lat": 34.068584651870175
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48017"],
        "coty_name": ["Bailey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bailey County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01383794"
      },
      "bbox": [
        -5.342662776108159, -4.725660478755564, -4.95295225209058,
        -4.211850567607836
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.992482471883529, -3.8599876987750146],
            [-3.9626620535833332, -3.861738995369018],
            [-3.922715923509799, -3.8630458880424627],
            [-3.8325500604086304, -3.86820841803071],
            [-3.771470334545653, -3.8721362637270897],
            [-3.6826011079535275, -3.8763949791735324],
            [-3.5639479038714, -3.882615497740889],
            [-3.569978462281351, -3.9951254847492845],
            [-3.5706802894126928, -4.009461696225212],
            [-3.578205552803171, -4.1475303105313195],
            [-3.58775738749559, -4.319906470854069],
            [-3.665806797424163, -4.316130474654799],
            [-3.7730591138606346, -4.310586580105796],
            [-3.8567590000033656, -4.305991713804419],
            [-4.017739144368234, -4.296856466475363],
            [-4.011061156244826, -4.174608070080873],
            [-4.00512886231186, -4.0784104300236885],
            [-4.004992539987994, -4.073657017350494],
            [-3.9998280513160154, -3.985870437771507],
            [-3.9978818929773157, -3.9552109574275027],
            [-3.992482471883529, -3.8599876987750146]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.20855536514655,
          "lat": 34.53026761228932
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48045"],
        "coty_name": ["Briscoe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Briscoe County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01383808"
      },
      "bbox": [
        -4.017739144368234, -4.319906470854069, -3.5639479038714,
        -3.8599876987750146
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.063464089620738, -2.975598713893021],
            [-4.063258672829209, -2.9717134231198488],
            [-3.9835710802771143, -2.9762490426860544],
            [-3.848014843519065, -2.983464128250181],
            [-3.797923669998593, -2.9861753796684813],
            [-3.631474381927535, -2.9948103228946352],
            [-3.631700114446049, -3.0010193162052254],
            [-3.638332315689718, -3.1207921891042156],
            [-3.6411331157484104, -3.176633402081537],
            [-3.6451201750624556, -3.2497462825231147],
            [-3.65244186200454, -3.3811762591676886],
            [-3.6555587914706043, -3.440515422879989],
            [-3.733237277818239, -3.436758304647313],
            [-3.837756205131871, -3.430625784481032],
            [-3.8898450718912154, -3.4277053849721497],
            [-4.080179693386364, -3.415535327391205],
            [-4.089650035402572, -3.4150919689215646],
            [-4.08462597531594, -3.332398743468384],
            [-4.063464089620738, -2.975598713893021]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.35419795315818,
          "lat": 35.40348728414811
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48065"],
        "coty_name": ["Carson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carson County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01383818"
      },
      "bbox": [
        -4.089650035402572, -3.440515422879989, -3.631474381927535,
        -2.9717134231198488
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.121410943712244, -4.775667043140814],
            [-4.012320708460852, -4.780780436932911],
            [-3.9336831000457098, -4.784604455655926],
            [-3.8645143902356582, -4.787674351667134],
            [-3.863496573189116, -4.787920466070406],
            [-3.691119019421722, -4.796422454402304],
            [-3.7009253464422347, -4.999164686558117],
            [-3.712457824601933, -5.2337432899841305],
            [-3.814508134402137, -5.228474217284251],
            [-3.9076391366373553, -5.223715509074596],
            [-3.9849904689677986, -5.219621251045732],
            [-3.991248626542017, -5.219768772064196],
            [-4.038454565078325, -5.217466607412701],
            [-4.1415387995135635, -5.212364795109934],
            [-4.1364407833075765, -5.108204516691844],
            [-4.136525486422133, -5.106851278053954],
            [-4.13030890062533, -4.968101996011531],
            [-4.122890040134081, -4.808068197625826],
            [-4.121410943712244, -4.775667043140814]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.29999093052363,
          "lat": 33.614657099877334
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48107"],
        "coty_name": ["Crosby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crosby County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "01383839"
      },
      "bbox": [
        -4.1415387995135635, -5.2337432899841305, -3.691119019421722,
        -4.775667043140814
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.402886153542893, -6.507867441850369],
            [-4.334623279012353, -6.511358105491547],
            [-4.221543767110254, -6.518414515993016],
            [-4.205656403712421, -6.519323492265589],
            [-4.092048405706196, -6.525736791733757],
            [-3.9784394049892713, -6.532132366706323],
            [-3.9720630326136948, -6.532544855059834],
            [-3.989643595737333, -6.817531151634844],
            [-3.9987857811035927, -6.966990361777452],
            [-4.085084142396256, -6.961781861167564],
            [-4.090408047171464, -6.961656557569869],
            [-4.19446505759979, -6.955496839002555],
            [-4.196174576743387, -6.955283712686224],
            [-4.312700445620073, -6.948490195892115],
            [-4.429225116007523, -6.941676109093165],
            [-4.418506331163541, -6.765608023217819],
            [-4.413664390269536, -6.686689097457377],
            [-4.402886153542893, -6.507867441850369]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.52077978259815,
          "lat": 31.86947541089269
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48173"],
        "coty_name": ["Glasscock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Glasscock County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "01383872"
      },
      "bbox": [
        -4.429225116007523, -6.966990361777452, -3.9720630326136948,
        -6.507867441850369
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6851509613395224, -7.235693417806492],
            [0.7632855363738899, -7.212576332457355],
            [0.7593318191654338, -7.197871320492716],
            [0.7928820285122407, -7.191888069517048],
            [0.8336916506906936, -7.185210585128656],
            [0.8878438137627838, -7.175662443254195],
            [0.8938248406398477, -7.174245259412697],
            [0.928460381135534, -7.16884325238614],
            [0.993814223687983, -7.159053356459745],
            [1.0019412706679418, -7.157378953803848],
            [1.0802672757893628, -7.145167310852364],
            [1.083018217955064, -7.14657417375915],
            [1.0858605916227122, -7.153944325693645],
            [1.0946393128482739, -7.161722615377729],
            [1.1077215240277707, -7.163113457668212],
            [1.108719851040123, -7.161068111597368],
            [1.1143957448222022, -7.162886944745779],
            [1.11997279954389, -7.160278622353465],
            [1.1269525295932232, -7.1641842459782],
            [1.13297298011416, -7.165524719718697],
            [1.1353268572151816, -7.167348428311314],
            [1.1402228235800944, -7.1641117392807345],
            [1.1448726588712494, -7.164501310035647],
            [1.1509529337515951, -7.15942975912705],
            [1.1553173323391417, -7.159214396856467],
            [1.1599184957180855, -7.15695830392992],
            [1.1624862837322776, -7.1525324805073485],
            [1.1662575537547477, -7.152448155211741],
            [1.167728067452881, -7.156620027355206],
            [1.174546803070399, -7.159551624568772],
            [1.1749744096089234, -7.163748308590492],
            [1.1792613335468878, -7.166328938829995],
            [1.185673307670314, -7.168148243672973],
            [1.1842458518666523, -7.171429687307181],
            [1.1872263309975095, -7.173887895764868],
            [1.19376075189365, -7.173971939486518],
            [1.1920274161531326, -7.179148057364867],
            [1.1884296690816962, -7.181381886336713],
            [1.187663228705792, -7.186724464972728],
            [1.1910110559799119, -7.192918825390984],
            [1.1908174217126297, -7.197299747312419],
            [1.197982203604971, -7.196487244361685],
            [1.2062090323113217, -7.199544489435447],
            [1.2104537955087644, -7.204025163055649],
            [1.2195315990452822, -7.208866192615477],
            [1.2279205120217178, -7.217651175342016],
            [1.230682421428612, -7.225781045609108],
            [1.2293496059298037, -7.231597569842196],
            [1.2333047720139914, -7.233471640545297],
            [1.226919017823852, -7.240595526210133],
            [1.2233886403982193, -7.241798859852926],
            [1.2233894890970385, -7.245201148868534],
            [1.2199034899682732, -7.247622965525813],
            [1.222313757623852, -7.25547257434112],
            [1.225637093796528, -7.257711270724885],
            [1.225303160600839, -7.261635351710834],
            [1.228265143628867, -7.2672812604462775],
            [1.238444804315806, -7.270198577180487],
            [1.2441459066233695, -7.268000966406386],
            [1.2503636627525492, -7.269303497248006],
            [1.2508746524351657, -7.272278240308672],
            [1.2560983540512303, -7.269938028668364],
            [1.2577338568487273, -7.264527312528395],
            [1.2620631855620161, -7.268078181305117],
            [1.2688863045937948, -7.2767428434421335],
            [1.269577701274466, -7.28279574694192],
            [1.2760195661435525, -7.290789927856164],
            [1.2798511312617378, -7.289061725715896],
            [1.2864901710316308, -7.290035537023162],
            [1.2927994658143582, -7.292883277541173],
            [1.2990916494177187, -7.290785538359824],
            [1.3070152973597997, -7.292242386768186],
            [1.3090581507534422, -7.2956736348761115],
            [1.3040660936438273, -7.297672063448017],
            [1.3039813828174758, -7.300860415275631],
            [1.3076830124423848, -7.302460175899061],
            [1.3109351222155055, -7.309607755735493],
            [1.3091307783567174, -7.314240696235201],
            [1.3191433381983415, -7.320962713408926],
            [1.3268656112904016, -7.321249665514457],
            [1.3337691166944339, -7.328031470325786],
            [1.3343771405046072, -7.332968398531117],
            [1.3401279865949653, -7.337936693476217],
            [1.3443260481170975, -7.339602908410276],
            [1.3428393939568453, -7.343625297972171],
            [1.3498118283338378, -7.347805952287993],
            [1.3070265164585892, -7.384001640676984],
            [1.2087752707232629, -7.464729720540087],
            [1.1855173611456218, -7.484253707154455],
            [1.1833565603093223, -7.48554938076158],
            [1.0913053371240957, -7.560387086358323],
            [1.0506818270792897, -7.593530328594465],
            [0.9974787644593874, -7.636674575076791],
            [0.9810039237245133, -7.650291492228101],
            [0.9463977372337474, -7.678338971917957],
            [0.868491588442383, -7.7421895189797905],
            [0.7905667250748608, -7.806012440697877],
            [0.785146620940503, -7.809193630768076],
            [0.7793811371803617, -7.810566356972401],
            [0.7727816072798365, -7.80973993741863],
            [0.770880023654742, -7.807895934467303],
            [0.7687197823947138, -7.801868549095329],
            [0.7632723620753072, -7.800618710873321],
            [0.7630672024040684, -7.791441742203513],
            [0.758738193166856, -7.785984011592814],
            [0.7584212708461343, -7.78349881975128],
            [0.7542985916303774, -7.779571318209822],
            [0.7501555124502605, -7.765952114849624],
            [0.7436032481074843, -7.7606130381631395],
            [0.741215020057371, -7.751465731202097],
            [0.7361219622639437, -7.7494861023316925],
            [0.7381393860335212, -7.746585160505722],
            [0.7454342022660662, -7.743262639205743],
            [0.7456653577492921, -7.740207531269975],
            [0.7507199164363132, -7.732686725580907],
            [0.7516658180476629, -7.728854652791814],
            [0.7555790546510106, -7.720782527909551],
            [0.7486512135226744, -7.717259268648851],
            [0.746754720616921, -7.714873217162826],
            [0.7466319422238872, -7.7103258995106625],
            [0.7514504413036347, -7.703991837861302],
            [0.7650279928042578, -7.701021413905627],
            [0.7695949570915533, -7.69532617161143],
            [0.7730243447757635, -7.695136342436591],
            [0.7757585917407087, -7.699822132522353],
            [0.7812794418376546, -7.6938660849352365],
            [0.7797346753052281, -7.68546263278316],
            [0.7764623887386904, -7.68333675125581],
            [0.766844503343594, -7.6825775772834906],
            [0.7607237836652984, -7.674410894836835],
            [0.7583878671975876, -7.670071645524088],
            [0.763821055055878, -7.667373468123466],
            [0.758755193729598, -7.663369180478929],
            [0.7564591526490516, -7.657672354087069],
            [0.7528980568732851, -7.6571242389436325],
            [0.7495300862651606, -7.654453497603907],
            [0.7415535997499322, -7.661204217089851],
            [0.7370899896564811, -7.65888073748251],
            [0.7321837515764977, -7.660448022213653],
            [0.7302176809960431, -7.657384150453334],
            [0.7263429067840672, -7.655615922061233],
            [0.7233083787980428, -7.659950677892916],
            [0.7205958637840986, -7.660689019760617],
            [0.716796273424836, -7.6551229965224294],
            [0.7133069113472874, -7.659407092182439],
            [0.7110451035239965, -7.656261124634049],
            [0.6998893177695578, -7.657810330634243],
            [0.6977265642938898, -7.655651010727691],
            [0.6955747071082229, -7.649828598654907],
            [0.6911599276742425, -7.653811201652129],
            [0.6861741551885513, -7.651829359490247],
            [0.6849756390742087, -7.64748650624122],
            [0.676940786532445, -7.645582831366671],
            [0.6714385191173626, -7.649178492242033],
            [0.6671814311095334, -7.648125274165198],
            [0.6648286975935125, -7.643608925417371],
            [0.6632398427739834, -7.636917907387779],
            [0.6576837181166197, -7.621027003676313],
            [0.655422263000746, -7.615947798589294],
            [0.6577666058333972, -7.609056648504889],
            [0.6551970089819906, -7.601981958721487],
            [0.6582852219562759, -7.598432232787425],
            [0.6621614446652373, -7.598022131485302],
            [0.6665215643123824, -7.59399056898365],
            [0.67190776561218, -7.595043176867188],
            [0.6730341196369498, -7.588295302623684],
            [0.6785512601330942, -7.582919272860475],
            [0.6812504847629627, -7.5856641275485925],
            [0.6838701419658355, -7.584828640380137],
            [0.6875327684485868, -7.578749737859083],
            [0.6930070280987553, -7.5789394601938485],
            [0.6951063997498576, -7.574061958501642],
            [0.6902930278547531, -7.570413226566805],
            [0.6838145707066625, -7.5636086397671285],
            [0.6807883581568068, -7.556368529646235],
            [0.6808496341781987, -7.546232258574529],
            [0.6787504092928698, -7.537517828763436],
            [0.6785805249775391, -7.530095202970833],
            [0.6829286382778681, -7.52300854398911],
            [0.6860218742107766, -7.519737130103522],
            [0.6906759580539957, -7.517921676141055],
            [0.6955966829617838, -7.513783180705314],
            [0.6980377125854533, -7.508366074628401],
            [0.6963001413353335, -7.499214911801964],
            [0.6990988379421054, -7.492459215194264],
            [0.6959117748237754, -7.488074584655958],
            [0.7001724971903096, -7.48269144575901],
            [0.6953204519102943, -7.478886536964869],
            [0.6977611617123861, -7.467586962533479],
            [0.7071443431561983, -7.463689725877182],
            [0.7103675756526044, -7.459724612095328],
            [0.7150675961477516, -7.45863557989989],
            [0.7162248736926535, -7.456186060535575],
            [0.7127352021761294, -7.452364613738028],
            [0.716684934992429, -7.446258294141546],
            [0.7233482041017691, -7.441691517647503],
            [0.7270353335550758, -7.441322441937621],
            [0.7336808066761475, -7.449730610618646],
            [0.7435163512963898, -7.4430867561287695],
            [0.7419372750427297, -7.436307087312687],
            [0.7458762841444941, -7.430186045218282],
            [0.743118473634336, -7.422720411276585],
            [0.7441744553231898, -7.4201769262503126],
            [0.7508595088220699, -7.417743167367037],
            [0.7520824352213208, -7.421713886752412],
            [0.7555261867180361, -7.420713364398813],
            [0.7568942586026911, -7.409122513848861],
            [0.7550305924076406, -7.399097417679362],
            [0.7532062343401393, -7.393471251136491],
            [0.7409305445934246, -7.394065327188676],
            [0.7384634679683301, -7.391002988540151],
            [0.7411674086377931, -7.388005725404549],
            [0.7431594419889052, -7.382445642524446],
            [0.751633013363074, -7.381650699038589],
            [0.7481364933680731, -7.372590685755679],
            [0.7402757965910783, -7.373225941948956],
            [0.7400108201628873, -7.37088456297703],
            [0.7342866951790225, -7.370132287335241],
            [0.7322277545832097, -7.366980509985867],
            [0.7261951771626153, -7.36439899751716],
            [0.727536431693445, -7.360479440435234],
            [0.7266694309867815, -7.354168769879525],
            [0.7241781542192248, -7.352014502264061],
            [0.7249617031409642, -7.347660525546953],
            [0.7183887947940127, -7.345781831178182],
            [0.7171540921321762, -7.336930125531061],
            [0.7202439604110193, -7.332900259438843],
            [0.7193048377255834, -7.330898065352145],
            [0.7135800973915469, -7.327331609711056],
            [0.7099624957971732, -7.320417980866892],
            [0.7088362542535455, -7.315751740023292],
            [0.7095775317454012, -7.304671462636984],
            [0.7077669575050568, -7.29848151265318],
            [0.7091925039197969, -7.2927437122185035],
            [0.7092403575904237, -7.285341979734761],
            [0.7049881708913505, -7.279416732490381],
            [0.7009825123833987, -7.277054476720858],
            [0.6969241928017585, -7.277243458214607],
            [0.6879817313560017, -7.28039444083251],
            [0.6831914873208786, -7.279604871585673],
            [0.6788552363296791, -7.2814079013195],
            [0.6787943405633114, -7.2758165634812535],
            [0.6881890367403407, -7.265529006864157],
            [0.6925410921879221, -7.266361383606503],
            [0.6958199693599451, -7.269446230461978],
            [0.6992389047779572, -7.268933505551086],
            [0.6992449044818317, -7.262305995180559],
            [0.6957029875088974, -7.2575100049820165],
            [0.6931960557400576, -7.250038797325205],
            [0.6884978115947261, -7.253862300868054],
            [0.6830119500077335, -7.253135310355649],
            [0.680305362671654, -7.247351242075175],
            [0.6840715893591968, -7.243409135293647],
            [0.6815804421996756, -7.240556442149458],
            [0.6851509613395224, -7.235693417806492]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.4226701873146, "lat": 31.31770999959022 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48225"],
        "coty_name": ["Houston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Houston County"],
        "coty_fp_code": "225",
        "coty_gnis_code": "01383898"
      },
      "bbox": [
        0.6551970089819906, -7.810566356972401, 1.3498118283338378,
        -7.145167310852364
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.4572601066520152, -9.810306848971583],
            [-1.3986187148024085, -9.765724379481982],
            [-1.3901044595708394, -9.75827195896273],
            [-1.3647268155753587, -9.737557522289483],
            [-1.35366496461765, -9.728937506632745],
            [-1.2826975652959243, -9.672540149338062],
            [-1.2305520653394746, -9.63135707168793],
            [-1.1628274472916658, -9.577565651016624],
            [-1.0987773961760723, -9.526717022895262],
            [-1.0455956106075923, -9.484331297458574],
            [-1.0014283925903145, -9.534591267315434],
            [-0.9572506334150236, -9.584833685000238],
            [-0.9468112233298072, -9.596412068562122],
            [-0.9573033227898202, -9.605067676803346],
            [-0.9619367096612254, -9.6073914289737],
            [-0.9845667461352399, -9.625578294903786],
            [-1.0467024994807825, -9.674960388372943],
            [-1.072478562431693, -9.695651303005578],
            [-1.0603149778447496, -9.711048583547578],
            [-1.0055104461633075, -9.77948370322716],
            [-0.9506875761418612, -9.847886790311222],
            [-0.9180608329427407, -9.888759337591745],
            [-0.988483385499508, -9.942994432407781],
            [-1.044074072532304, -9.985736128579978],
            [-1.0996762009716308, -10.028460061030078],
            [-1.1050249969304848, -10.02543193972961],
            [-1.1078550379502548, -10.02063641336011],
            [-1.1112501422934695, -10.019474390250249],
            [-1.1142542220342964, -10.022910336851991],
            [-1.1407505603068633, -10.02541844065543],
            [-1.1417957714509044, -10.020452983672252],
            [-1.1440166298053884, -10.018160690535037],
            [-1.148482331004011, -10.019931951727843],
            [-1.1494411342391766, -10.01560885514991],
            [-1.152350994830811, -10.016051884097203],
            [-1.158739015841297, -10.012583485102764],
            [-1.1663324658457137, -10.010217040224761],
            [-1.1695306023261944, -10.011103232625576],
            [-1.1777134607807338, -10.005739597213106],
            [-1.184702577657428, -10.003845178365076],
            [-1.1899280951921867, -9.99871551885934],
            [-1.1915513776980735, -9.999754528790225],
            [-1.1985498861455448, -9.992102052882261],
            [-1.2037331762251964, -9.989476328693398],
            [-1.2074721702143583, -9.982179718036472],
            [-1.2117803806863983, -9.981806578111684],
            [-1.218679474349281, -9.975430923708126],
            [-1.227782772112546, -9.97827145911967],
            [-1.2928139642002525, -10.0009107599075],
            [-1.2984804938775207, -10.00272613579978],
            [-1.3391588501995488, -9.953795358534334],
            [-1.3781203066185859, -9.905922984607928],
            [-1.4010519042162493, -9.878725672917389],
            [-1.428467882546189, -9.84371063953474],
            [-1.438337871693569, -9.830785523744776],
            [-1.4516209868051493, -9.81739721312346],
            [-1.4572601066520152, -9.810306848971583]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.85939910446582, "lat": 28.90571105543911 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48255"],
        "coty_name": ["Karnes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Karnes County"],
        "coty_fp_code": "255",
        "coty_gnis_code": "01383913"
      },
      "bbox": [
        -1.4572601066520152, -10.028460061030078, -0.9180608329427407,
        -9.484331297458574
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.263493528689474, -6.460733518986479],
            [-6.175397422574997, -6.46762228569231],
            [-6.068469262368261, -6.4767313533149995],
            [-6.0470727745254, -6.478455138627785],
            [-5.880322655422768, -6.49153852308255],
            [-5.713569477583268, -6.504582711640043],
            [-5.7139181401913355, -6.504799274617141],
            [-5.731080665546681, -6.721907493924224],
            [-5.741439930867713, -6.8516318395205555],
            [-5.861147957079556, -6.842091988708379],
            [-5.980854188706116, -6.8325303102904735],
            [-5.98556602797616, -6.831518536164084],
            [-5.987118337335229, -6.82936809488619],
            [-5.986838067195769, -6.819556088273581],
            [-5.990285411185636, -6.818394699312483],
            [-5.991894619387284, -6.815167082442975],
            [-5.996790666522689, -6.8099581374182145],
            [-5.996772516538782, -6.806545177563548],
            [-5.998885522349756, -6.799210182799356],
            [-5.998666486590284, -6.792608633171052],
            [-5.993390255426371, -6.794892141856863],
            [-5.986089521512253, -6.79355810591197],
            [-5.987660255597345, -6.791362796785334],
            [-5.989107787939892, -6.778619986790837],
            [-5.9947222675492835, -6.7786147379981365],
            [-5.9994044573177945, -6.774616479504196],
            [-6.007293236020096, -6.772773499424903],
            [-6.010300694290324, -6.770294348513799],
            [-6.017162852142594, -6.77100600999672],
            [-6.02488827022564, -6.7655141683090845],
            [-6.026874685054918, -6.7595330472775945],
            [-6.030143648759096, -6.757606316650451],
            [-6.031605113866733, -6.751040638896978],
            [-6.03683189129133, -6.737640211433919],
            [-6.039321156362399, -6.736873419119759],
            [-6.041356519496717, -6.7316517930965665],
            [-6.048805463069065, -6.7304389990292375],
            [-6.051918099761808, -6.732052346878887],
            [-6.057478866553036, -6.73213793560576],
            [-6.065160323302255, -6.73453862514299],
            [-6.0685383798419705, -6.731705523151934],
            [-6.075020213754491, -6.73791813903955],
            [-6.088523087395236, -6.736119325044022],
            [-6.0947144664057324, -6.734083613965715],
            [-6.097798706177273, -6.730066111212593],
            [-6.0964449503042655, -6.7261718567217414],
            [-6.099375124095614, -6.721289929813263],
            [-6.103309182872726, -6.720799941553921],
            [-6.1028166678283515, -6.716485297396935],
            [-6.106498490757711, -6.711828996946904],
            [-6.111400764114344, -6.711591059570894],
            [-6.1154833319831345, -6.709521933057436],
            [-6.1161569728183816, -6.701670935652705],
            [-6.117581460540286, -6.698314791572534],
            [-6.12164520926682, -6.700771990178615],
            [-6.128550494834952, -6.702157206612771],
            [-6.1290191940183885, -6.695386549212422],
            [-6.132130609065119, -6.69086521396865],
            [-6.132315375722619, -6.686238551187812],
            [-6.134687771606235, -6.679651149017992],
            [-6.136874618828335, -6.677323095334026],
            [-6.136508824692406, -6.671160527411344],
            [-6.1345812711427605, -6.666956525685555],
            [-6.133929351437537, -6.659143279942005],
            [-6.135060316346787, -6.65537970484153],
            [-6.132642231989965, -6.6501994116495275],
            [-6.133787589830981, -6.643959686621478],
            [-6.137078488767108, -6.6415319175868115],
            [-6.139663765590507, -6.637107315512111],
            [-6.142402231747763, -6.635931915042209],
            [-6.1403604064975355, -6.631115135147317],
            [-6.135633439911682, -6.625358603507705],
            [-6.136768968937731, -6.6194404177042765],
            [-6.139674325547376, -6.6162047385607226],
            [-6.1434239860933, -6.609143857619628],
            [-6.14744180924317, -6.608145596327784],
            [-6.146492142612858, -6.602352741722587],
            [-6.149051802614816, -6.5972162006511],
            [-6.146980130989847, -6.593160411493166],
            [-6.146186727431174, -6.582410539273184],
            [-6.148678397773924, -6.580616888975304],
            [-6.154459339192785, -6.580687091125491],
            [-6.162300195823208, -6.587637471411005],
            [-6.168838780526127, -6.586187341142068],
            [-6.176591083718862, -6.593882636104375],
            [-6.1828764309245425, -6.593680001442719],
            [-6.184762893060702, -6.599697951566181],
            [-6.189926136053661, -6.6026755842781375],
            [-6.193083375163365, -6.600675532994167],
            [-6.194573622982041, -6.595848931524892],
            [-6.192122973175324, -6.591723276237221],
            [-6.191300787298934, -6.583641578466187],
            [-6.189189708074559, -6.579119104959373],
            [-6.190253774020262, -6.575213670660475],
            [-6.205884097198643, -6.56930651376715],
            [-6.209289396542907, -6.565816694673199],
            [-6.214523647098845, -6.56268285577487],
            [-6.215353698917909, -6.55770545185771],
            [-6.218679808143842, -6.5476862350291976],
            [-6.217471086506333, -6.539286816928436],
            [-6.215065031478795, -6.5341586836302215],
            [-6.21866937257037, -6.531296437271307],
            [-6.218448438779149, -6.525059333445923],
            [-6.219714562646445, -6.522084407645648],
            [-6.226539001433273, -6.51686968683885],
            [-6.231062667875741, -6.516826217815257],
            [-6.235115869492827, -6.518782018595667],
            [-6.237231896020084, -6.513190555276434],
            [-6.2407589976950835, -6.508357933014489],
            [-6.233963427859891, -6.502093556107934],
            [-6.2339712053877765, -6.499049476923228],
            [-6.238993586765284, -6.492464240277879],
            [-6.23944843314638, -6.486769002976008],
            [-6.23780643139285, -6.481434643407854],
            [-6.240795708588067, -6.4753587180008765],
            [-6.2468677864817606, -6.4774864890155746],
            [-6.250706238007265, -6.481266975260782],
            [-6.254812024600263, -6.481873049655932],
            [-6.261962970715766, -6.481011176782564],
            [-6.2648713298146275, -6.475510067306909],
            [-6.267160058896878, -6.466450571828861],
            [-6.263493528689474, -6.460733518986479]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.58004220804791,
          "lat": 31.849283870759848
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48301"],
        "coty_name": ["Loving"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Loving County"],
        "coty_fp_code": "301",
        "coty_gnis_code": "01383936"
      },
      "bbox": [
        -6.267160058896878, -6.8516318395205555, -5.713569477583268,
        -6.460733518986479
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6837736773314629, -5.758712188831383],
            [-1.636622055904644, -5.7606088295847115],
            [-1.560115970582855, -5.764003102641715],
            [-1.5591173750161538, -5.726989199202811],
            [-1.5581388073248532, -5.708352587654332],
            [-1.4633947935016196, -5.712414356498379],
            [-1.4077699568446385, -5.714671500556787],
            [-1.3383682238951622, -5.71693344725952],
            [-1.24961314677276, -5.720181784682422],
            [-1.2517869081938044, -5.777487375851843],
            [-1.2559593457085723, -5.881021913517968],
            [-1.2599149919066424, -5.973448719266442],
            [-1.2597239061753658, -5.974349503088746],
            [-1.2653478940116063, -6.106090561010406],
            [-1.2682868105275968, -6.164660002271198],
            [-1.2707516455077243, -6.2118039384794255],
            [-1.3320464495901279, -6.209973096235483],
            [-1.4358657806196164, -6.206901727603898],
            [-1.525561043337391, -6.204626587856126],
            [-1.6116081125794812, -6.202289538073736],
            [-1.6327501617496378, -6.201390226054345],
            [-1.6931282983772475, -6.197914766847044],
            [-1.6962810311041778, -6.197927860068083],
            [-1.6930977675441075, -6.089149849939357],
            [-1.6901254142038156, -5.9793189105621805],
            [-1.689509314933416, -5.962024561150007],
            [-1.686463957085673, -5.855828595863494],
            [-1.6837736773314629, -5.758712188831383]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.31300637204919, "lat": 32.75316509270862 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48363"],
        "coty_name": ["Palo Pinto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Palo Pinto County"],
        "coty_fp_code": "363",
        "coty_gnis_code": "01383967"
      },
      "bbox": [
        -1.6962810311041778, -6.2118039384794255, -1.24961314677276,
        -5.708352587654332
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.24502863786679685, -7.629839938101215],
            [-0.21237308695936352, -7.6119625813061065],
            [-0.20338272471783428, -7.607304574368811],
            [-0.16103386602674502, -7.583477344668042],
            [-0.1582410079769465, -7.582122102990106],
            [-0.13302807939606948, -7.5671049993452035],
            [-0.06942136539413438, -7.53057417343026],
            [-0.06542666569921964, -7.527925076629998],
            [-0.04491241979827729, -7.516269424708343],
            [-0.01595147896186399, -7.499798921111607],
            [0.0036555575531278103, -7.489466687930409],
            [0.058600025817604935, -7.458018082887526],
            [0.13780403849635733, -7.412917554827846],
            [0.19220191037787962, -7.381836207829879],
            [0.1915762818154097, -7.388443512563383],
            [0.19495690062339754, -7.39270594287174],
            [0.19504222029744886, -7.400003096780433],
            [0.19190752476293968, -7.402927920471449],
            [0.19377135394554032, -7.415534518090929],
            [0.19007027540999222, -7.4198694759534565],
            [0.18872350472859808, -7.425885140492807],
            [0.18623729726958532, -7.428014457803855],
            [0.19056509668792565, -7.434286906136985],
            [0.19159583779408326, -7.438873164000841],
            [0.18667834365622382, -7.437850494439252],
            [0.1839506425904431, -7.440259456622009],
            [0.1851953107733537, -7.442981501634096],
            [0.18445080766726005, -7.452134225068375],
            [0.18698221403377588, -7.45614020845803],
            [0.1892172634862995, -7.455737773295723],
            [0.1944357349089976, -7.461300809727742],
            [0.19316176174033123, -7.465830146746791],
            [0.19637647331904456, -7.46772737043937],
            [0.1956348119820307, -7.472777776975967],
            [0.18927794041202237, -7.481577481412949],
            [0.18652437773897126, -7.47873639552908],
            [0.18317193101666884, -7.481092064517473],
            [0.18166410653531584, -7.485961332625857],
            [0.18364471367342022, -7.492075269002642],
            [0.19102135163019776, -7.496965521451407],
            [0.19088141748876192, -7.498780805764753],
            [0.1960416663664209, -7.5099079938452284],
            [0.19351504227985125, -7.512193864641409],
            [0.19301887654972488, -7.516551719396398],
            [0.19917304236687564, -7.521104399974386],
            [0.19812608571497206, -7.52843483053914],
            [0.19945910482111162, -7.5375126158448476],
            [0.19799038551301626, -7.540081308347084],
            [0.20333351219707652, -7.542742562202216],
            [0.20577697721079066, -7.551696906910667],
            [0.20850405227507973, -7.553951514278759],
            [0.20881252929541633, -7.572008618121987],
            [0.20737017662049245, -7.57904198699002],
            [0.20994186820024563, -7.581925374445637],
            [0.2085380827054799, -7.589952154131168],
            [0.21257990109694452, -7.599120343243061],
            [0.22260419498436038, -7.6154410933960826],
            [0.22262108862425314, -7.618627329119944],
            [0.22737808273316337, -7.6215697970862175],
            [0.22610414674923654, -7.624430022902889],
            [0.22658663397167073, -7.632125042652397],
            [0.22410799926797897, -7.641659676028669],
            [0.22673837265444582, -7.6452131155792555],
            [0.22689917072639432, -7.650029036785349],
            [0.23145705620271448, -7.653446563888753],
            [0.23352516978946578, -7.659221195209285],
            [0.23610979916002456, -7.658776031732154],
            [0.2432692352415174, -7.661524867615983],
            [0.24665713619079238, -7.665235499010144],
            [0.24422562494020558, -7.668335991338527],
            [0.2456088758891359, -7.672090871087352],
            [0.2507087314976747, -7.674119551697357],
            [0.25721775923155604, -7.680813185441607],
            [0.2531805168801516, -7.685939741832933],
            [0.25740214196546674, -7.689829633194498],
            [0.25733375575936535, -7.69284962420631],
            [0.25246438960966344, -7.694247865146526],
            [0.2510875959270478, -7.697799237408831],
            [0.25239740760998963, -7.700563231761795],
            [0.25055628882033215, -7.704904584114128],
            [0.2454507248739417, -7.709297820721396],
            [0.24515983485152976, -7.713234459151189],
            [0.24155382206220766, -7.721906522247239],
            [0.2409152553375707, -7.728816968509526],
            [0.2440839798096559, -7.730870113142185],
            [0.2513103593485593, -7.731838394511238],
            [0.25618568195519315, -7.738959569399535],
            [0.2601075795137388, -7.739525011702476],
            [0.25894600676158835, -7.754048891719816],
            [0.2563896214141023, -7.7596468024708924],
            [0.25771017733483365, -7.763357128873294],
            [0.2509043559503321, -7.766144304612251],
            [0.23870384177401824, -7.772861618342363],
            [0.22306654123208025, -7.784221630314106],
            [0.20651900379080493, -7.793765755331002],
            [0.18517947659292497, -7.80810127599689],
            [0.17515338036005787, -7.815548599543833],
            [0.1651053232935279, -7.824726180231813],
            [0.16164364199576897, -7.830303255142645],
            [0.15415428232433967, -7.839407826348542],
            [0.15083650356468395, -7.851641863505325],
            [0.14354013324191986, -7.8591906769264455],
            [0.13682960896830862, -7.865041240557428],
            [0.13212608751216698, -7.871968104540738],
            [0.12897638091242866, -7.881366291014164],
            [0.12226708189098333, -7.895741460821837],
            [0.11774347865174156, -7.901342359665678],
            [0.11276410719617513, -7.909201480695371],
            [0.10449573548628574, -7.930718339217599],
            [0.10100358463605699, -7.942654828544036],
            [0.09475259044279927, -7.950560458118091],
            [0.08773382445690175, -7.961139929636352],
            [0.08257866757799416, -7.971252352592834],
            [0.07558725021319891, -7.981857771020068],
            [0.07144068502663098, -7.990415554342666],
            [0.06738470667474199, -7.9929209366263],
            [0.042893750043003546, -8.004939532598447],
            [-0.022592103841114, -8.038364038976963],
            [-0.02411203750392139, -8.032679979390155],
            [-0.031637749995986335, -8.027109723478931],
            [-0.03681948565020319, -8.024860668159238],
            [-0.04818210302581851, -8.016585860476924],
            [-0.0459795619538788, -8.012862790742028],
            [-0.04742115907011723, -8.007468030973754],
            [-0.05024660318479445, -8.005471794111012],
            [-0.05698075279620914, -8.004659044431914],
            [-0.06471872404452941, -8.005535999517223],
            [-0.06905758609884502, -8.003237478435752],
            [-0.0786824140218066, -7.992969272380613],
            [-0.07306166161231636, -7.984420764178715],
            [-0.06677151491887091, -7.985861540090609],
            [-0.06328771642316774, -7.984017301270274],
            [-0.0609243721707803, -7.97781681630328],
            [-0.061957518773832654, -7.974048016659773],
            [-0.06768442563892386, -7.965689262867389],
            [-0.0713286201877794, -7.954350426961682],
            [-0.07880738958674428, -7.951269703370273],
            [-0.08385645571434736, -7.9561338369763135],
            [-0.08663412728526387, -7.957326768760461],
            [-0.09048861584640722, -7.95508943539282],
            [-0.09276541791582135, -7.949504138571347],
            [-0.08963451372132884, -7.942759558544569],
            [-0.08342300619685722, -7.939737481478785],
            [-0.08159132014857491, -7.937585707038776],
            [-0.0810150988964973, -7.930155094387749],
            [-0.08265873010560053, -7.923292494530484],
            [-0.08549189703602544, -7.916453496224721],
            [-0.08905199445147208, -7.911284858196378],
            [-0.09402268980756563, -7.907564444964361],
            [-0.10184918997531107, -7.9051093130303345],
            [-0.11014166747710287, -7.900572268378412],
            [-0.1099620129851442, -7.8927763207998565],
            [-0.11776156286352392, -7.890410083035935],
            [-0.1203116377667038, -7.882884494586962],
            [-0.12913042796796226, -7.873420201884824],
            [-0.13156278523310155, -7.868485344868863],
            [-0.1318861262602756, -7.859423042518345],
            [-0.12975189265617418, -7.855287884567201],
            [-0.12161970931240199, -7.855294602733253],
            [-0.12169684805967769, -7.850009817155035],
            [-0.12794357282911326, -7.846092434621601],
            [-0.1315631411581665, -7.8421220673806635],
            [-0.13293378510170986, -7.837936356209124],
            [-0.13046192731275538, -7.835984112583157],
            [-0.1240977287869654, -7.838218683502509],
            [-0.12082018312439143, -7.832863078362844],
            [-0.1221868950099443, -7.828788689804374],
            [-0.1281726203596193, -7.82578986053782],
            [-0.13540834750407826, -7.826661384966909],
            [-0.13990688900203702, -7.828844087482027],
            [-0.14894825163555847, -7.837359377719453],
            [-0.15761332060810448, -7.83600463625944],
            [-0.1635866658932123, -7.832829534806592],
            [-0.16451596801907384, -7.827248532221774],
            [-0.1603074728180421, -7.8215019317324925],
            [-0.16127055861180967, -7.818499871981829],
            [-0.17027056547471975, -7.819658936960475],
            [-0.1831548608104438, -7.807304860079006],
            [-0.18416311006801103, -7.803771362698775],
            [-0.18219816789640955, -7.79104557522621],
            [-0.18659292751823287, -7.779192095589266],
            [-0.19032848107055356, -7.7759117037868695],
            [-0.1938740601344407, -7.776101985488127],
            [-0.19662581552555955, -7.770095155669279],
            [-0.19534888797144784, -7.762517477036172],
            [-0.18551229332383531, -7.756524429512355],
            [-0.18324068873754512, -7.74669284764174],
            [-0.17702850315214472, -7.745698022998185],
            [-0.17298621200506994, -7.740237037483343],
            [-0.17467143139313202, -7.734082254517844],
            [-0.18200030695866945, -7.72962448059076],
            [-0.19045151605240737, -7.735197304151704],
            [-0.1939730868358127, -7.734864966024313],
            [-0.19550069059423839, -7.732106336031031],
            [-0.19733835623924886, -7.723208143948957],
            [-0.19758891194710662, -7.715435739168229],
            [-0.19447172156473938, -7.712248039291071],
            [-0.19426866451236033, -7.708312142150791],
            [-0.20036450709556064, -7.706606809119262],
            [-0.2021457798869735, -7.7037293530789],
            [-0.2012523231901427, -7.699399301862292],
            [-0.19544416381684956, -7.696112936989488],
            [-0.19147215559461875, -7.692320341745937],
            [-0.19121496919059042, -7.688007750655343],
            [-0.19491387856053033, -7.685282884173287],
            [-0.2011467703860731, -7.687042917364449],
            [-0.20676692372479458, -7.6859601762102585],
            [-0.20779771961125287, -7.682987074890712],
            [-0.20823237970685632, -7.67408931853482],
            [-0.2110309304438176, -7.670755504760531],
            [-0.2171969865195195, -7.6709629640649455],
            [-0.22281524019866153, -7.6748144416901765],
            [-0.2290257110454459, -7.676667068195578],
            [-0.23467595870971955, -7.675731235594088],
            [-0.23740179876409237, -7.672402127584186],
            [-0.23652573362513268, -7.666524663114357],
            [-0.23346548920142599, -7.661401444201521],
            [-0.22713645553576672, -7.654767461587784],
            [-0.23363533260326952, -7.644462783969802],
            [-0.24523633091284497, -7.634616257252694],
            [-0.24502863786679685, -7.629839938101215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.51292307733463,
          "lat": 31.027034172780613
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48395"],
        "coty_name": ["Robertson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Robertson County"],
        "coty_fp_code": "395",
        "coty_gnis_code": "01383983"
      },
      "bbox": [
        -0.24523633091284497, -8.038364038976963, 0.2601075795137388,
        -7.381836207829879
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.770435968319846, -7.545924320214915],
            [-3.6537825696700534, -7.54977773867853],
            [-3.5371288725133625, -7.55360813462272],
            [-3.5314315459215053, -7.554242262019152],
            [-3.3863097926793353, -7.559907505590706],
            [-3.2194496438723688, -7.566821541125032],
            [-3.163222149256656, -7.569152000775412],
            [-3.161542985054657, -7.56897859628663],
            [-3.047992526419169, -7.574669957744364],
            [-3.054777759961166, -7.715948092749108],
            [-3.0549309738941575, -7.717435720113292],
            [-3.065257223570834, -7.949523220164354],
            [-3.1886212692028644, -7.944880754260704],
            [-3.3119844649229515, -7.9402107274037],
            [-3.346944393759604, -7.938652353544864],
            [-3.5128508420753892, -7.932437491979325],
            [-3.6031198597092224, -7.928365425094556],
            [-3.6933882699720777, -7.924278577812079],
            [-3.7887749980114234, -7.919548738241611],
            [-3.780662186428589, -7.767101351086533],
            [-3.78071960823522, -7.766824766175674],
            [-3.770435968319846, -7.545924320214915]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.53831780343656,
          "lat": 30.897422433481324
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48413"],
        "coty_name": ["Schleicher"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Schleicher County"],
        "coty_fp_code": "413",
        "coty_gnis_code": "01383992"
      },
      "bbox": [
        -3.7887749980114234, -7.949523220164354, -3.047992526419169,
        -7.545924320214915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.1734215838960635, -6.491852589644277],
            [-1.1175942134586414, -6.4598352637443055],
            [-1.098969113126518, -6.4486859869400455],
            [-1.0348289285618624, -6.411605691354289],
            [-0.9718064063932954, -6.411897549186864],
            [-0.8943948187130951, -6.411978730810444],
            [-0.8958292732318107, -6.526962272476349],
            [-0.9049817939682445, -6.526303834131776],
            [-0.9090591547988528, -6.522830578551251],
            [-0.9251506915821636, -6.532848954467988],
            [-0.9366048687329531, -6.539208345337056],
            [-0.9689956686275514, -6.558604746882748],
            [-1.0022927985874237, -6.577434287490558],
            [-1.0353504125161757, -6.596919533255439],
            [-1.1083552992949062, -6.639095666645397],
            [-1.1282765840710884, -6.595031822025151],
            [-1.1693285479541156, -6.503653185540183],
            [-1.1734215838960635, -6.491852589644277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.77454457742978, "lat": 32.22220490822793 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48425"],
        "coty_name": ["Somervell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Somervell County"],
        "coty_fp_code": "425",
        "coty_gnis_code": "01383998"
      },
      "bbox": [
        -1.1734215838960635, -6.639095666645397, -0.8943948187130951,
        -6.411605691354289
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.887941721587578, -6.912657227207224],
            [-4.861974588885332, -6.9144201506950616],
            [-4.7906194353074545, -6.91877266927348],
            [-4.610041458097407, -6.930297580051502],
            [-4.429225116007523, -6.941676109093165],
            [-4.446656421404331, -7.228032859582675],
            [-4.446591559886099, -7.230769166213239],
            [-4.461081233611474, -7.464700251909654],
            [-4.4614434733568, -7.466925796383002],
            [-4.4643968470930915, -7.509713271533801],
            [-4.586751237845584, -7.500541797192577],
            [-4.655282066309626, -7.495393408991693],
            [-4.6959838924180755, -7.492047767172353],
            [-4.803632155154595, -7.483592797062433],
            [-4.911278524122137, -7.475118076285593],
            [-4.908271841020552, -7.434379316294556],
            [-4.909043704046822, -7.363715511477449],
            [-4.902277953560394, -7.18818637654573],
            [-4.9007492647559605, -7.156781549986191],
            [-4.8950909298112695, -7.037037116350628],
            [-4.887941721587578, -6.912657227207224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -102.04314286461504, "lat": 31.3687810211074 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48461"],
        "coty_name": ["Upton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Upton County"],
        "coty_fp_code": "461",
        "coty_gnis_code": "01384016"
      },
      "bbox": [
        -4.911278524122137, -7.509713271533801, -4.429225116007523,
        -6.912657227207224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.38336479643017324, -8.50628741097698],
            [0.3870122320584, -8.502793279437268],
            [0.45960116444745064, -8.49787193804422],
            [0.5036152656713764, -8.494651005507793],
            [0.5166927107653506, -8.494085984224098],
            [0.5300845944727528, -8.494300219845345],
            [0.6165207249626954, -8.486956553133858],
            [0.6325269721357906, -8.485963608770746],
            [0.6330274298249234, -8.552203322901157],
            [0.6332136079198503, -8.597963548897848],
            [0.6336909506638903, -8.639921973053037],
            [0.6283690212783676, -8.641793706567817],
            [0.6282823769161655, -8.644666542611215],
            [0.6229425206872596, -8.644669027706763],
            [0.6199298826441344, -8.646887125828012],
            [0.6119642613858765, -8.648241013632914],
            [0.6073428505400632, -8.645105287992246],
            [0.6042432303886658, -8.646754775304323],
            [0.5979079184983658, -8.641157536337754],
            [0.5996212349074915, -8.635294459205497],
            [0.5928508813917476, -8.628120239044797],
            [0.5873795136192346, -8.628419612260636],
            [0.5871304822245491, -8.626018325597812],
            [0.5820039032921688, -8.623305324816641],
            [0.5817237519217977, -8.617799359958383],
            [0.5736329888812367, -8.611856457740528],
            [0.5726373296051578, -8.608255981714532],
            [0.5647079841381583, -8.61065300986492],
            [0.5593071654267656, -8.611261346613043],
            [0.5539695751903461, -8.608207081582],
            [0.5481249591460062, -8.607266732779891],
            [0.5459772816207707, -8.604428389705008],
            [0.5405423131365228, -8.602429679524398],
            [0.531121346097724, -8.59395764290727],
            [0.5250053994882544, -8.586533373686734],
            [0.5150707613675344, -8.585027148459634],
            [0.5115407445435778, -8.58244392589807],
            [0.5093914544876206, -8.57636735628324],
            [0.5053218266273999, -8.574454433617035],
            [0.5018856365381594, -8.569624784804988],
            [0.4976420331215154, -8.567497612044152],
            [0.5284988646373205, -8.665995569401662],
            [0.5315951105672219, -8.665871355737693],
            [0.5319737678402399, -8.676212045922632],
            [0.5482243591372783, -8.726996996161693],
            [0.557011656472537, -8.753321329458664],
            [0.5595672247982444, -8.763761942304425],
            [0.577222322522923, -8.819379510390096],
            [0.5877661643200831, -8.85323677827348],
            [0.6024838512532759, -8.898935791038522],
            [0.6146750037641687, -8.938181826350585],
            [0.6144631259309723, -8.938514338399637],
            [0.5635612494670443, -8.960775918820264],
            [0.5491789822627751, -8.966675555297618],
            [0.506323206808629, -8.985597678646918],
            [0.4886579234321355, -8.98591611623445],
            [0.488962699071028, -8.997675813049637],
            [0.435348328076731, -8.998277590131037],
            [0.4315029026983585, -8.99264839768736],
            [0.42929404343607885, -8.986636124481091],
            [0.4359182483220513, -8.981446300256797],
            [0.4377572436789066, -8.978177675520712],
            [0.43806033877840594, -8.971870442266095],
            [0.43131905505845913, -8.95303883564818],
            [0.42643328482855763, -8.94768746747718],
            [0.42786511793938603, -8.934527676222798],
            [0.42710579223606254, -8.931689352497711],
            [0.42132521388904626, -8.924080872179598],
            [0.41258166471576374, -8.92669362583541],
            [0.4109965274105795, -8.922531853182063],
            [0.4077237812552303, -8.920186830938563],
            [0.4031644501037659, -8.920167827840297],
            [0.3993103974114457, -8.92195621510813],
            [0.3923954378431282, -8.922355896485497],
            [0.3832325953474988, -8.918525763502927],
            [0.3748661610484088, -8.917463446307645],
            [0.37416508769339685, -8.914728266005854],
            [0.3781461331718127, -8.906985683009111],
            [0.37792639877584555, -8.899951228693844],
            [0.37017303188025774, -8.90498699625419],
            [0.35981870824527173, -8.893575392927717],
            [0.35790844632953456, -8.888042151086093],
            [0.3585912726173565, -8.885512858210351],
            [0.36299077512966815, -8.880037660235393],
            [0.3680136103292695, -8.877557818026263],
            [0.37316038693944964, -8.877128508133138],
            [0.37564106916047996, -8.873667457955337],
            [0.36824118437075776, -8.869003035269957],
            [0.36660469149309743, -8.862068449088932],
            [0.36650276852232216, -8.855270877298448],
            [0.3681911768550161, -8.854027825632688],
            [0.3754562115577842, -8.85314583845172],
            [0.3807328993548129, -8.851213026221698],
            [0.3832229515796379, -8.84854245513531],
            [0.3817002422883739, -8.843893026860608],
            [0.37614058990381427, -8.84517990211377],
            [0.3721833650540455, -8.844269787037373],
            [0.3690472139401732, -8.839129696957455],
            [0.3620892847703511, -8.837133682959447],
            [0.35620168158467524, -8.833018077561933],
            [0.35437300124652354, -8.829253552887355],
            [0.35449401657702945, -8.82492280910705],
            [0.3564946469502695, -8.82104838757889],
            [0.3640330572218388, -8.816701950963898],
            [0.36560678147774245, -8.81298193081128],
            [0.3601191495802263, -8.799980289808476],
            [0.35243538124824025, -8.796997967705996],
            [0.35015537515117523, -8.79474453606036],
            [0.35069758553246455, -8.788977334828761],
            [0.35857763358541955, -8.779467391793835],
            [0.36368066939471, -8.782151548751093],
            [0.3658598673155674, -8.785464081383273],
            [0.3698651520356722, -8.787947653269953],
            [0.37447055064304563, -8.788148580781211],
            [0.37648230305553954, -8.785090097775212],
            [0.37413790166917943, -8.782056623520928],
            [0.3739338983585089, -8.776306908499988],
            [0.37168596129491505, -8.773239704927018],
            [0.3603395909578989, -8.773704202652354],
            [0.35630169355578, -8.76979637427313],
            [0.3546591139967756, -8.76385148399423],
            [0.35621759471090814, -8.760743069948566],
            [0.35976196694322415, -8.761750755606412],
            [0.36471624278665443, -8.76631260700241],
            [0.3705304489068777, -8.769454411517982],
            [0.3741626512990826, -8.767451116586322],
            [0.381562861818124, -8.768976334798364],
            [0.3818122740236859, -8.764539548705145],
            [0.3747018753755451, -8.761113143285593],
            [0.3809261318753999, -8.75085203145879],
            [0.3769533727792929, -8.745237129373335],
            [0.37465810760154467, -8.739457473525427],
            [0.3733201281861466, -8.732798016097258],
            [0.3758948349976605, -8.725523121276419],
            [0.3785854731906863, -8.725215215728502],
            [0.3845244682646734, -8.730988813614747],
            [0.38909468626089344, -8.729284209781827],
            [0.3906088956324988, -8.724148095232811],
            [0.38544791724761, -8.715335604770265],
            [0.38183252667420176, -8.704104393242241],
            [0.3773322999763735, -8.70136060047725],
            [0.37468595534088417, -8.703790269592789],
            [0.3700417686564554, -8.704620390473801],
            [0.36582568964307993, -8.702490850102057],
            [0.3697671548679312, -8.697543328943954],
            [0.37081667440081045, -8.690995999107283],
            [0.366861112443472, -8.683430307752603],
            [0.36240107221698015, -8.67959679304916],
            [0.3473002484099264, -8.674400716663191],
            [0.3421693204796218, -8.67155377659221],
            [0.337154634015917, -8.66534932928008],
            [0.3391438367912861, -8.662973865378277],
            [0.33749971845501486, -8.659670383177886],
            [0.3340853111389607, -8.65817842124703],
            [0.334850176323452, -8.653323497041978],
            [0.34026153728732145, -8.658963845951268],
            [0.34531917025463243, -8.662875996515785],
            [0.3481080765428966, -8.658957318349078],
            [0.3419453898611738, -8.653129302611626],
            [0.34132481598201886, -8.64683486883745],
            [0.33972612000790436, -8.64506853578797],
            [0.33371262328039525, -8.645322650248144],
            [0.33035383210856034, -8.643526623489969],
            [0.3268444140667609, -8.63838629602677],
            [0.32635472519694375, -8.633119081768742],
            [0.3319290417501444, -8.627677444350407],
            [0.3298384054355857, -8.621748093619082],
            [0.32527340128580934, -8.622191053862844],
            [0.32179352961153335, -8.62902985701397],
            [0.31845544062323355, -8.631156443300089],
            [0.31441318882679936, -8.630807742420565],
            [0.312832120421712, -8.627479618713357],
            [0.31563692857273695, -8.622145718842514],
            [0.31251656209738465, -8.617843495021587],
            [0.3051653995942695, -8.621020563123617],
            [0.3007574723271044, -8.619773541585147],
            [0.2981278141795692, -8.615043999211178],
            [0.30184047666919817, -8.611725805058223],
            [0.3084093637682004, -8.612967977326365],
            [0.30836735666156617, -8.607384037675997],
            [0.30276626706037096, -8.602269549443532],
            [0.2984175308795404, -8.595803580563981],
            [0.29811073359132884, -8.5920890195753],
            [0.3015544639351365, -8.588856085357047],
            [0.3067129493787733, -8.589647227543704],
            [0.31180665932621815, -8.592800385136652],
            [0.31525016287862623, -8.58940847113507],
            [0.3098261539111937, -8.585605317622443],
            [0.3055867322259738, -8.579934539795923],
            [0.3077471857892281, -8.575013377117264],
            [0.31152145188836966, -8.575874935457005],
            [0.32168475444072586, -8.584061009016354],
            [0.325014806657056, -8.587476753129504],
            [0.3311529902080625, -8.588645259194404],
            [0.3332739971662038, -8.583803776961545],
            [0.3341131387998109, -8.575295406221166],
            [0.3312858195033227, -8.571287489019584],
            [0.3255713972183896, -8.568960035568486],
            [0.3238714774721256, -8.56590128903362],
            [0.32482216443371265, -8.562294373447857],
            [0.3297609462683982, -8.55774522479802],
            [0.3303181644646643, -8.553821563549567],
            [0.3262932853911238, -8.550557841141963],
            [0.32582836819237293, -8.547816824118973],
            [0.32815634270366123, -8.540573250637637],
            [0.3264374356062332, -8.535260978501096],
            [0.3265279485233627, -8.524610147797413],
            [0.3344121666714877, -8.518272981095325],
            [0.3365398743035471, -8.513371387104167],
            [0.33857093204708355, -8.512790083982553],
            [0.34277628495848256, -8.519077981965374],
            [0.3461178126409787, -8.52048727148554],
            [0.35309692499802986, -8.519705495012392],
            [0.36192242513545314, -8.507229615027398],
            [0.3656478231380836, -8.50427142527858],
            [0.36934729501655195, -8.51149563496282],
            [0.37837492804912054, -8.516843186517042],
            [0.3802993960544394, -8.516501448407816],
            [0.38339724203304604, -8.510982499681687],
            [0.38336479643017324, -8.50628741097698]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.98765757698808,
          "lat": 30.010793411553557
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48473"],
        "coty_name": ["Waller"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Waller County"],
        "coty_fp_code": "473",
        "coty_gnis_code": "01384022"
      },
      "bbox": [
        0.29811073359132884, -8.998277590131037, 0.6336909506638903,
        -8.485963608770746
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.192559259832977, -3.0230501447460023],
            [-3.1561022312188194, -3.024629550080977],
            [-3.0649000353854636, -3.0287503579147605],
            [-3.0632928522445164, -3.0289978763920904],
            [-2.862004016688087, -3.0380480510021215],
            [-2.75815435692864, -3.0427361579458427],
            [-2.7609836109566235, -3.109839118473127],
            [-2.7665048124750595, -3.2407761923956753],
            [-2.7716882205140982, -3.3636871077595902],
            [-2.7766748413309297, -3.4819172305871073],
            [-2.926954172732326, -3.4753342113468],
            [-3.0528869660376037, -3.4696297480802105],
            [-3.0996200309721305, -3.467455983720641],
            [-3.2069029989763993, -3.4623774491090895],
            [-3.2126157387366625, -3.461910583726217],
            [-3.2058167053200144, -3.331656387571076],
            [-3.205211127576014, -3.3156558655848953],
            [-3.2007768453898064, -3.212187725360647],
            [-3.1982317592253513, -3.154799904407251],
            [-3.196430164354604, -3.111242966026754],
            [-3.1958319062021854, -3.0904489756430253],
            [-3.192559259832977, -3.0230501447460023]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.26976441166305,
          "lat": 35.40123533244465
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48483"],
        "coty_name": ["Wheeler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wheeler County"],
        "coty_fp_code": "483",
        "coty_gnis_code": "01384027"
      },
      "bbox": [
        -3.2126157387366625, -3.4819172305871073, -2.75815435692864,
        -3.0230501447460023
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.131010705382673, 2.7224128323091557],
            [-13.108709471064282, 2.836191454035291],
            [-13.077053471975887, 3.0007917184826356],
            [-13.071745016776664, 3.0269692927797296],
            [-13.070255123877699, 3.032283545883202],
            [-13.058255933993884, 3.095829009202687],
            [-13.055774587154618, 3.1077765076036723],
            [-13.019811883044499, 3.2887281797411037],
            [-13.012640367871054, 3.3248122737382464],
            [-13.006719305456466, 3.3568685744266755],
            [-13.003760398778065, 3.369638153838723],
            [-12.970777107472497, 3.537926672547639],
            [-12.959573582221127, 3.5950859948170337],
            [-12.778734083735479, 3.561459684345804],
            [-12.597903822035136, 3.527782440517172],
            [-12.417082857268701, 3.4940542780809962],
            [-12.236271248668904, 3.460275216787759],
            [-12.140608297732214, 3.4430951426267726],
            [-12.044947851325775, 3.4259008677096534],
            [-12.005252283968852, 3.4321200470769817],
            [-11.938854701915819, 3.4421691999763233],
            [-11.806134132737068, 3.4623661303483217],
            [-11.74661544122766, 3.2947954110429176],
            [-11.68712839866775, 3.127167056713237],
            [-11.670386749421393, 3.0795327321366974],
            [-11.663568717809023, 3.070796625985124],
            [-11.657383468112716, 3.067499736181017],
            [-11.655276625807547, 3.060408849276747],
            [-11.653907312265089, 3.048296035394618],
            [-11.654545186723803, 3.0439886178527535],
            [-11.657817693128292, 3.037549340394722],
            [-11.660327664631046, 3.0349689380818843],
            [-11.661275963021424, 3.030278367823943],
            [-11.660412000318066, 3.0225034142495146],
            [-11.661597478383664, 3.0145635194619618],
            [-11.663780032361169, 3.0099152819241235],
            [-11.664147100217173, 3.003677315341655],
            [-11.661719389345024, 2.9988712402047444],
            [-11.662514586785717, 2.9950054372028747],
            [-11.661067568585942, 2.986254028459071],
            [-11.665415951725155, 2.976632008139646],
            [-11.66050453773476, 2.964257644297984],
            [-11.655868136300743, 2.961288428934895],
            [-11.652521233763029, 2.952461353435799],
            [-11.655278774947925, 2.945247237656521],
            [-11.6553979204619, 2.9339638236831607],
            [-11.661103033490548, 2.929813950614737],
            [-11.66081172581423, 2.9266596024689155],
            [-11.66394981271904, 2.922792814918571],
            [-11.66315556540957, 2.9204515785526786],
            [-11.66527971890687, 2.911934447663375],
            [-11.662855935634802, 2.9056150798989298],
            [-11.66593948349993, 2.8953549358255177],
            [-11.669193583662777, 2.888449283501996],
            [-11.66774995068853, 2.8811008812087393],
            [-11.669067338051526, 2.8715184612696465],
            [-11.67458217616724, 2.868131968374796],
            [-11.676941871559652, 2.864775226641989],
            [-11.675735173564314, 2.858659084408426],
            [-11.673164156051884, 2.85198463266316],
            [-11.675903804035164, 2.8418311283203717],
            [-11.674031109611546, 2.834919711757528],
            [-11.675433870744657, 2.8317694427369515],
            [-11.672408003755995, 2.8201229532176977],
            [-11.674073775263713, 2.8161998111308795],
            [-11.686763534486014, 2.819864275185865],
            [-11.691859476532127, 2.8143407945541496],
            [-11.704657523550745, 2.8134977280839535],
            [-11.707307674423914, 2.8068252363358672],
            [-11.707845613375895, 2.7992371164875376],
            [-11.70662754089355, 2.785679264591189],
            [-11.70404661042224, 2.7845513434122857],
            [-11.698151693291932, 2.773300976269823],
            [-11.701611616963795, 2.767627881640915],
            [-11.705012796783107, 2.756520337257265],
            [-11.706891903191178, 2.74361918126993],
            [-11.708926304660645, 2.7415046498613016],
            [-11.70808852655609, 2.7356252040135107],
            [-11.705061485920584, 2.732036257084113],
            [-11.702043848912428, 2.724301686417101],
            [-11.706546145597141, 2.7203787577756535],
            [-11.708111734294851, 2.7124417652383825],
            [-11.704564218099005, 2.7067357275195434],
            [-11.703623354295896, 2.7000337553221083],
            [-11.70110770757242, 2.6969389277971145],
            [-11.698481984632682, 2.686213303660085],
            [-11.702392540209118, 2.6830991035402865],
            [-11.711146191973922, 2.6817957038881337],
            [-11.71563841635427, 2.678933353525997],
            [-11.713465752819, 2.6755483020320527],
            [-11.71500306625734, 2.671163623969123],
            [-11.71750822005317, 2.67032716030392],
            [-11.71961286831175, 2.6657802547849405],
            [-11.718488351941225, 2.6593129608395154],
            [-11.715209496045375, 2.6525838749885544],
            [-11.71490343570458, 2.6461110275144617],
            [-11.71920100573566, 2.6260654559711147],
            [-11.72285597930992, 2.6219870386734043],
            [-11.723092130378948, 2.6174877919412736],
            [-11.717955029949376, 2.6100925375458246],
            [-11.719402434233343, 2.6019865556778066],
            [-11.71608650209062, 2.600805483073058],
            [-11.719287370412447, 2.5838408406606246],
            [-11.717819555101586, 2.5789629202454933],
            [-11.713601245060548, 2.576039910981308],
            [-11.713297615657478, 2.569585426650399],
            [-11.708336697890253, 2.5664351673374477],
            [-11.704688498094988, 2.568089151903667],
            [-11.703651121227951, 2.5633652466440173],
            [-11.70018524301787, 2.5600414393750066],
            [-11.707916193106813, 2.555695829957583],
            [-11.70749719360068, 2.5521496918851994],
            [-11.710600744598302, 2.5481992093927817],
            [-11.702364800154138, 2.543213598539491],
            [-11.703310032126689, 2.5383937770136322],
            [-11.708207408890177, 2.5307177288876206],
            [-11.708224868426107, 2.527512264447084],
            [-11.703886214983234, 2.526082308369228],
            [-11.704576721774476, 2.518584025497026],
            [-11.709223276242529, 2.5199419600059834],
            [-11.716193852209186, 2.512273620606727],
            [-11.719889917011388, 2.5120781415001496],
            [-11.728357435733304, 2.5056687560854582],
            [-11.727281143916363, 2.4997713448827295],
            [-11.725013082859848, 2.497298528928101],
            [-11.729282642196438, 2.492437272602266],
            [-11.731255509915849, 2.4861108667410963],
            [-11.733944393478275, 2.4826088082578788],
            [-11.731579240453469, 2.4784753434653126],
            [-11.725920322605772, 2.473440284263195],
            [-11.727093124343876, 2.4690998789461833],
            [-11.725376962999986, 2.464276102744014],
            [-11.7218451016812, 2.4619754339953857],
            [-11.721863999194573, 2.4579710012558404],
            [-11.719130478348747, 2.4560211981555327],
            [-11.72508890439664, 2.448260251983379],
            [-11.727505729512645, 2.438849633274904],
            [-11.738173804365273, 2.437042495112313],
            [-11.74291360559706, 2.429841306835256],
            [-11.741697845079823, 2.4199726241351613],
            [-11.74282819633337, 2.4180398925364743],
            [-11.747905557508645, 2.4197792349618927],
            [-11.75170620743234, 2.412875145929825],
            [-11.748718529120827, 2.403646951115762],
            [-11.749473913030208, 2.401448288669335],
            [-11.746472223782975, 2.3913410825882813],
            [-11.749197663911655, 2.3848892255469085],
            [-11.753215779196843, 2.379285428808109],
            [-11.753573620743337, 2.3720443272565417],
            [-11.757076153901762, 2.3646925331206408],
            [-11.76332943321295, 2.3599546570145233],
            [-11.771109608779044, 2.3587802194679712],
            [-11.783051202453384, 2.3516854684561155],
            [-11.794351781043783, 2.347526789807114],
            [-11.795761421448614, 2.341164903342633],
            [-11.798612764091521, 2.3371120425836196],
            [-11.804974678762942, 2.3313169164368026],
            [-11.807379565839435, 2.3272834405057696],
            [-11.808097295148887, 2.321358785932284],
            [-11.815968302834758, 2.3180386192667934],
            [-11.819201919081408, 2.3130952703331102],
            [-11.82322590251402, 2.3136033146645705],
            [-11.829499419627716, 2.3066614082175136],
            [-11.834483034532422, 2.3065139697528902],
            [-11.83724881272603, 2.304177529897724],
            [-11.843192682925842, 2.3054378526201424],
            [-11.84473237221675, 2.3078785871725453],
            [-11.85385900598776, 2.308114098169061],
            [-11.861421875340973, 2.3059278735468474],
            [-11.863445980286862, 2.309681034253296],
            [-11.863381537151469, 2.3152770407529277],
            [-11.865422146760785, 2.317594258110878],
            [-11.875937739012137, 2.3164532114600718],
            [-11.878699750066682, 2.3191875847205514],
            [-11.881286028711202, 2.3258932168424726],
            [-11.884311005551751, 2.31914019442403],
            [-11.888459547312415, 2.317815995546535],
            [-11.887517853424187, 2.304262775369632],
            [-11.88913020312043, 2.301787280688698],
            [-11.890871707307483, 2.2928648066280926],
            [-11.896601646455911, 2.2856239417109636],
            [-11.89688487335997, 2.279133921093653],
            [-11.983521473378941, 2.293635694240605],
            [-12.093142096605344, 2.3126648127576797],
            [-12.238449499862025, 2.3384624511585335],
            [-12.23835971412635, 2.3389647394828894],
            [-12.407988217902965, 2.370157464901248],
            [-12.575154353041018, 2.400416187195484],
            [-12.575044134347143, 2.401012102847953],
            [-12.744204027560892, 2.4325676411895687],
            [-12.9133702289441, 2.464088675685249],
            [-13.08021698402404, 2.4961153793099276],
            [-13.171504577034153, 2.5137541948860767],
            [-13.153777663565723, 2.603569801140969],
            [-13.147656825792009, 2.6365085349848667],
            [-13.134416067988495, 2.703524649239783],
            [-13.131010705382673, 2.7224128323091557]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.13107469805317,
          "lat": 40.44874709089672
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49045"],
        "coty_name": ["Tooele"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tooele County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01448036"
      },
      "bbox": [
        -13.171504577034153, 2.279133921093653, -11.652521233763029,
        3.5950859948170337
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.390321937952693, 0.034179460660225765],
            [13.398763170717064, 0.034079836239268475],
            [13.402187043984988, 0.04509576188831595],
            [13.41209605264191, 0.04804049850976704],
            [13.41587878718158, 0.04784339092349456],
            [13.420230344165743, 0.05224845871645848],
            [13.42542894211144, 0.05979567243863384],
            [13.429524866646123, 0.06744806999468962],
            [13.433145264861473, 0.07012638631036013],
            [13.44042092724135, 0.07238674431457974],
            [13.44327917658192, 0.07740847063495873],
            [13.444090131206135, 0.08338799553383436],
            [13.453496118068342, 0.09000891012919551],
            [13.452580416498103, 0.09581941469635595],
            [13.454222250344083, 0.10150438584306196],
            [13.453921240040945, 0.10855286256487026],
            [13.461711625650246, 0.1212253067791695],
            [13.465470497905327, 0.12508111747308187],
            [13.466090312876076, 0.13274739705811978],
            [13.46849228656981, 0.1396632165490779],
            [13.465213026619734, 0.14575298742603734],
            [13.469354633771216, 0.16036891147182908],
            [13.472156676802786, 0.16507314827184724],
            [13.470244866497213, 0.16767936617293255],
            [13.47290003378407, 0.17714208228874664],
            [13.473932666850315, 0.1855210568260929],
            [13.476181232784294, 0.18994281743700547],
            [13.478399198071983, 0.19845151620104273],
            [13.484474678764792, 0.21045830989537748],
            [13.487452280074473, 0.21930062367679146],
            [13.48793112803827, 0.22409971181658367],
            [13.491964135379241, 0.23433736483557266],
            [13.495464229079886, 0.23163697964631572],
            [13.498987490725472, 0.2342867414832465],
            [13.49962063056854, 0.23736473679992587],
            [13.50467872773098, 0.24766400347446033],
            [13.509497354622948, 0.2514940192696209],
            [13.51420191912659, 0.2572540274252524],
            [13.5169291445424, 0.2538629796437933],
            [13.521679287984485, 0.25249450636843807],
            [13.524390416426623, 0.24826990778397848],
            [13.528074087278085, 0.24750955267091096],
            [13.527996534152036, 0.24214018712161084],
            [13.532207031822455, 0.24071490707070656],
            [13.53607735544599, 0.23628510252630255],
            [13.541101580825963, 0.23760692877126283],
            [13.544014923166287, 0.2367670998034399],
            [13.549766915551553, 0.2441672382043594],
            [13.556468763616545, 0.24638714155176766],
            [13.563274901210038, 0.25307857908420667],
            [13.561760752801545, 0.25541023780167915],
            [13.56697323615859, 0.2592349944492447],
            [13.57141612054166, 0.2610655498248888],
            [13.58287314748622, 0.2695536244102704],
            [13.587030294648194, 0.27052256088083004],
            [13.58929447787595, 0.26496591311587353],
            [13.591712181689578, 0.2645243930716589],
            [13.595671636100949, 0.2605050893749056],
            [13.60087229334257, 0.2617224751054941],
            [13.603631391713295, 0.2588094945472663],
            [13.603312475781157, 0.2543457773032416],
            [13.606618689982547, 0.24891382890216593],
            [13.612778535118965, 0.24555284385946752],
            [13.616873202057088, 0.24902055259337683],
            [13.620342884655951, 0.24711083889055332],
            [13.627818012275878, 0.2516587896860429],
            [13.63746999971911, 0.24720294425522576],
            [13.640969014569208, 0.24711031101095401],
            [13.646520757432755, 0.24149172669617705],
            [13.64864121757145, 0.23577569261397005],
            [13.646500371300556, 0.2333483950515498],
            [13.646013151773106, 0.22862295060150645],
            [13.650281771757491, 0.2228257519805906],
            [13.65377222928572, 0.21369647819917836],
            [13.653656432443817, 0.19753373282992853],
            [13.658730153646111, 0.19271477391913633],
            [13.65727663227259, 0.18756282751864256],
            [13.666667832870905, 0.18098942095224518],
            [13.679561658282477, 0.18109326519521954],
            [13.683199596580897, 0.17988912433814452],
            [13.688501898051003, 0.17512314502817117],
            [13.692478869261837, 0.17559877448591665],
            [13.694907343770845, 0.1783583285707737],
            [13.700726353356746, 0.18003825789000846],
            [13.702342513658309, 0.1773810307569071],
            [13.708678564815651, 0.17346075002212716],
            [13.714281946994191, 0.1766881958291024],
            [13.7158104347356, 0.17904981327210104],
            [13.72441942681487, 0.17432780259168934],
            [13.723620727758032, 0.16920924401316442],
            [13.728951920474147, 0.16587207163113205],
            [13.728833824024473, 0.16179405381701803],
            [13.736367035762855, 0.1587398533492751],
            [13.738325561296381, 0.1605435683099705],
            [13.742545329530886, 0.1580423834510779],
            [13.739985422930229, 0.15146639124487715],
            [13.746036693337594, 0.14858069472002167],
            [13.753012958240538, 0.1352186288505199],
            [13.755629171327794, 0.13306764642469363],
            [13.776150474970576, 0.10214429198718214],
            [13.817473578365627, 0.03883555772064127],
            [13.821861516983176, 0.03560113128293649],
            [13.825081041324115, 0.040762593365510726],
            [13.82905759070294, 0.040688888499013906],
            [13.83130259716875, 0.042788109119682456],
            [13.836302348326425, 0.04159243212959336],
            [13.837357252748816, 0.044375276931462676],
            [13.842209835890895, 0.04227558001504636],
            [13.842226229116342, 0.03822621091507992],
            [13.834546383323845, 0.026511803119769674],
            [13.827962726877631, 0.027160825567853708],
            [13.824057805829481, 0.02624497327148125],
            [13.821596706647709, 0.02353921790105826],
            [13.828597943064072, 0.012699671883382698],
            [13.827127767520343, 0.0058653908519377095],
            [13.821667575112725, 0.0007677932046689522],
            [13.81906355857503, -0.003811098471314371],
            [13.814776994975198, -0.006128745955533967],
            [13.808176162499434, -0.013681994271290486],
            [13.799827588388286, -0.013840033258340281],
            [13.789195427265852, -0.0103647525296836],
            [13.786940363981271, -0.013339402717657012],
            [13.793961990768004, -0.016441842530140964],
            [13.797894578967925, -0.022945136256669798],
            [13.797786097116289, -0.02917796052045385],
            [13.79568411257918, -0.032343621439241695],
            [13.781520410137526, -0.040442061607626305],
            [13.772848557824808, -0.05010865588060673],
            [13.767077357366354, -0.06018076392435877],
            [13.764630730002686, -0.06185999819733521],
            [13.759990540483523, -0.07081633668275897],
            [13.752476273919429, -0.07580936016114037],
            [13.749605223419316, -0.07923417030878672],
            [13.749648052574436, -0.08838776778788791],
            [13.74807116093812, -0.09331891234789616],
            [13.744697934569542, -0.09527844823931078],
            [13.739526424671997, -0.09601092068607217],
            [13.734770686280028, -0.09379495072687266],
            [13.72913787651305, -0.0935366672274545],
            [13.726698604570498, -0.09710505433785262],
            [13.730361500327676, -0.10095924418828872],
            [13.731311970851863, -0.10789546196755552],
            [13.726254560694633, -0.11215952494441131],
            [13.719852726040253, -0.11121400299646121],
            [13.71337847770716, -0.10786778322744901],
            [13.7080537801486, -0.10999317244084926],
            [13.708965862102612, -0.11565880811381878],
            [13.715288142416412, -0.12096485609117676],
            [13.717150109892984, -0.12977656022151166],
            [13.721366023827308, -0.1388958094148049],
            [13.716680307833656, -0.14485853625356926],
            [13.706306033752746, -0.1415085896831073],
            [13.701746114594462, -0.13828241098621719],
            [13.687640917623582, -0.13114135777410754],
            [13.68062743248319, -0.12975747633582074],
            [13.679001037677825, -0.13275290840006312],
            [13.67884945800915, -0.13943124651128838],
            [13.673766646273497, -0.1398143531979958],
            [13.668111922561156, -0.1364125657091572],
            [13.660923797844953, -0.12999643080511536],
            [13.655952868604418, -0.12408920805572056],
            [13.655034136548421, -0.11814477436137348],
            [13.649687387434541, -0.10864641799071811],
            [13.64642800069699, -0.10667202190220454],
            [13.644893155286377, -0.10966251965834145],
            [13.632982367913012, -0.10356013110846811],
            [13.621158535831894, -0.09612245892955341],
            [13.618931519425328, -0.09313765688731847],
            [13.61278835211072, -0.08843728279790997],
            [13.611248055878976, -0.0817289888644579],
            [13.60866008925575, -0.07439861821074319],
            [13.60664282732309, -0.07285019198744597],
            [13.590783492475337, -0.0733854130752606],
            [13.584628897410187, -0.06742879398716063],
            [13.582370389716448, -0.06352161778749381],
            [13.575693054993117, -0.05871633211692488],
            [13.576024106082482, -0.0535563079843428],
            [13.57893319116597, -0.0501396276624665],
            [13.57817662330663, -0.04748253305424949],
            [13.571850896104504, -0.04673068679245755],
            [13.561746353646473, -0.04918015476435196],
            [13.550229808858623, -0.06353938409068655],
            [13.546381384771957, -0.06038112917480763],
            [13.544553756270364, -0.05122718381129172],
            [13.540476580501029, -0.04969410162227987],
            [13.53584947933125, -0.0540094007395942],
            [13.528901260469787, -0.056267155337661],
            [13.523686610976423, -0.06255355059756564],
            [13.5180697052566, -0.062323459714634356],
            [13.513834612130086, -0.05904374800667016],
            [13.50428552619563, -0.05523295025473992],
            [13.49350837926519, -0.05504051290539728],
            [13.483441139888717, -0.05238059915036487],
            [13.473618501474393, -0.044597920467963605],
            [13.469816533959445, -0.03845535341597978],
            [13.461138517159076, -0.029930605040238797],
            [13.4556783082978, -0.021873041367859294],
            [13.45498405689692, -0.016228558588167515],
            [13.451172675388015, -0.00922575225521451],
            [13.450382860285359, -0.004690283535923858],
            [13.447328621471856, -0.0003530621863922844],
            [13.440203283479146, 0.006508402350378752],
            [13.438705306813343, 0.015533280977268776],
            [13.43407970991849, 0.019273279109130213],
            [13.429502523508749, 0.019063880771259076],
            [13.424487345038328, 0.021508147264612646],
            [13.42065976783746, 0.02722512521009708],
            [13.41704226718534, 0.029103245263360823],
            [13.408087228206785, 0.026285430086146255],
            [13.404068333216237, 0.02078350466263477],
            [13.397478290978848, 0.019816376930903074],
            [13.392986819070945, 0.022825411235477634],
            [13.392969237659196, 0.02939477317759563],
            [13.390321937952693, 0.034179460660225765]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.14515249157576,
          "lat": 37.604827364497346
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51009"],
        "coty_name": ["Amherst"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Amherst County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01480095"
      },
      "bbox": [
        13.390321937952693, -0.14485853625356926, 13.842226229116342,
        0.27052256088083004
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.483973787696764, -0.5247126881285764],
            [13.50540634249244, -0.4487845192109196],
            [13.529656326576436, -0.3625358602000601],
            [13.535352903946361, -0.34104211866528894],
            [13.539280579806354, -0.32777106423195856],
            [13.552937396338184, -0.27821780057206896],
            [13.558891184859748, -0.25595314456634916],
            [13.564058624458376, -0.24000503640563878],
            [13.574804452697041, -0.20106375791532088],
            [13.580015546875375, -0.19818727356368804],
            [13.579194515004952, -0.2047755918116754],
            [13.583366585072543, -0.20632705117729297],
            [13.596121141248068, -0.20667600717473203],
            [13.59597228476753, -0.21069041460038393],
            [13.611850764155491, -0.21791434379933072],
            [13.616860408719598, -0.21037443684928997],
            [13.623695016128199, -0.20391018044140663],
            [13.627735688134779, -0.20362927202128883],
            [13.631518949068678, -0.20615861962239249],
            [13.637356856912817, -0.20323764719407608],
            [13.641364103274576, -0.20322047783243635],
            [13.650454984724549, -0.18586049783474878],
            [13.66746794996336, -0.1648551310410173],
            [13.671029736572516, -0.16417215231882284],
            [13.678252224014487, -0.16666277496364532],
            [13.682401389412389, -0.1668187058418779],
            [13.6874732842862, -0.15871610932870667],
            [13.691311505548015, -0.1576633673058598],
            [13.701746114594462, -0.13828241098621719],
            [13.706306033752746, -0.1415085896831073],
            [13.716680307833656, -0.14485853625356926],
            [13.721366023827308, -0.1388958094148049],
            [13.717150109892984, -0.12977656022151166],
            [13.715288142416412, -0.12096485609117676],
            [13.708965862102612, -0.11565880811381878],
            [13.7080537801486, -0.10999317244084926],
            [13.71337847770716, -0.10786778322744901],
            [13.719852726040253, -0.11121400299646121],
            [13.726254560694633, -0.11215952494441131],
            [13.731311970851863, -0.10789546196755552],
            [13.730361500327676, -0.10095924418828872],
            [13.726698604570498, -0.09710505433785262],
            [13.72913787651305, -0.0935366672274545],
            [13.734770686280028, -0.09379495072687266],
            [13.739526424671997, -0.09601092068607217],
            [13.744697934569542, -0.09527844823931078],
            [13.817704164856798, -0.19713489318293603],
            [13.825039948022251, -0.22106119725480397],
            [13.830148638765088, -0.22021874194607743],
            [13.833372228441693, -0.22722602354206792],
            [13.840626137076825, -0.22993962100280432],
            [13.845841752202569, -0.23312130989707652],
            [13.849387146806617, -0.23942116874595548],
            [13.850229486012287, -0.244058811544468],
            [13.85288188440233, -0.24924102757760855],
            [13.853756940089102, -0.2595582503164898],
            [13.855182713218683, -0.2634022907380536],
            [13.859093990313875, -0.2660014566766719],
            [13.86476988586952, -0.26299639943433445],
            [13.8668540548021, -0.26389114747237225],
            [13.877147031096918, -0.2566113965455457],
            [13.889398993426589, -0.2578223303051941],
            [13.89098861613822, -0.25928171798509636],
            [13.901512570416472, -0.26053663121984516],
            [13.90391829633592, -0.2622811961328948],
            [13.910543547606334, -0.2731691526576885],
            [13.911223058989629, -0.28027514449431795],
            [13.90983567622233, -0.282839564589065],
            [13.911423850957089, -0.28753512726455827],
            [13.927672916436148, -0.2886420984174877],
            [13.938127920285012, -0.2899115077328836],
            [13.920261540749626, -0.41284059962163666],
            [13.909377638121569, -0.4809089434584673],
            [13.908825030996619, -0.48314704929353064],
            [13.902515914900247, -0.48051955533347246],
            [13.895292094048354, -0.4816432951027954],
            [13.883794485470867, -0.47546103537822515],
            [13.870981687158949, -0.47270408574624145],
            [13.867461985566143, -0.4711053012923182],
            [13.854936535920196, -0.46856980797490505],
            [13.852459089444228, -0.46540767035304526],
            [13.848212684933799, -0.467194491083859],
            [13.843453273495125, -0.4750025436180309],
            [13.835396617453155, -0.4800358408575858],
            [13.831777908027547, -0.4882017793439275],
            [13.82568376264788, -0.4889040589699388],
            [13.819859386271041, -0.4821462616027169],
            [13.812571932232158, -0.48156103971057124],
            [13.799065079475271, -0.47908278001591326],
            [13.794381702423642, -0.48116458759663067],
            [13.784629898263766, -0.48120975763924884],
            [13.78072476283383, -0.4788374695698186],
            [13.766244086586925, -0.4744270018088653],
            [13.75578534867255, -0.4705867352958067],
            [13.752032767167728, -0.46860638624141376],
            [13.739878213895473, -0.466018909383051],
            [13.731885600809075, -0.4494003886788366],
            [13.729050933113205, -0.44732310685667326],
            [13.723599234644269, -0.44726840403111173],
            [13.719792064322997, -0.44948594892338395],
            [13.716958525342953, -0.4542470300412517],
            [13.716960199961026, -0.4593910534069134],
            [13.713390024502461, -0.4634725408484361],
            [13.700843357892134, -0.46987857069348843],
            [13.694862634226165, -0.47586133552493537],
            [13.688781739201648, -0.47300440297512464],
            [13.685181593271404, -0.4738134330461678],
            [13.68240035609276, -0.48189262312421854],
            [13.68237610040522, -0.4875187245301047],
            [13.679997073363095, -0.49121071514582026],
            [13.677244017416434, -0.49049238630856246],
            [13.67104210943135, -0.4837027336006396],
            [13.666055935224714, -0.4753274414889571],
            [13.664648471225396, -0.471437175100035],
            [13.66615790263166, -0.4630044242249454],
            [13.664766096293569, -0.44904342225625826],
            [13.661646021239667, -0.4410670899537257],
            [13.659177049082023, -0.4373232617934513],
            [13.651829418282796, -0.4313517529837867],
            [13.647128823800582, -0.43177106689021133],
            [13.645250997927585, -0.43508554867367516],
            [13.645694596251918, -0.4400771572094845],
            [13.648067559503849, -0.44810815448986846],
            [13.643714621944339, -0.4526690655482208],
            [13.637459027842755, -0.45122231355639025],
            [13.635500968587106, -0.44834371721899674],
            [13.632606372444835, -0.43901172194020777],
            [13.629993812363638, -0.4360999387520044],
            [13.626489992200808, -0.429300889419908],
            [13.619029912346784, -0.42228736853562565],
            [13.61468638986353, -0.42366571921626034],
            [13.610295215322429, -0.4295903746444119],
            [13.607611570479364, -0.4380393868784143],
            [13.606663887519716, -0.4463086745315069],
            [13.601262983749738, -0.45027574842745743],
            [13.599741072747705, -0.45321771683035605],
            [13.590384067276647, -0.4557014570483494],
            [13.585958905496556, -0.4554924610620191],
            [13.580710573134258, -0.4509746552673728],
            [13.561310551867164, -0.44075313773131086],
            [13.557854301713517, -0.44020175021832664],
            [13.553990967199626, -0.43593955201179985],
            [13.551859333623762, -0.4300487444855104],
            [13.54636410454001, -0.43269946260372366],
            [13.55016191837163, -0.4365500638015148],
            [13.548112974804093, -0.441766121602258],
            [13.543059420997164, -0.4458260494265772],
            [13.533446097970067, -0.4508099005316833],
            [13.524685455318256, -0.45068104964099637],
            [13.520461493146021, -0.45238603056317583],
            [13.51941236739673, -0.45558990944187494],
            [13.523661368239654, -0.45722524216449834],
            [13.529155522065887, -0.4575503524193807],
            [13.53129936499367, -0.46037252597985867],
            [13.53103700929428, -0.4651631782547391],
            [13.528634625919205, -0.47154806299500507],
            [13.521430743505073, -0.4777340306641398],
            [13.52051447320408, -0.4802540478994028],
            [13.509470965549108, -0.4819141699723346],
            [13.507353050017489, -0.4837775258484147],
            [13.509798845379375, -0.4898288773653107],
            [13.512865168417743, -0.5068313333359037],
            [13.512637645590658, -0.511159128362158],
            [13.510041896008502, -0.5135721404009768],
            [13.502888041162663, -0.516678873817171],
            [13.496222054329476, -0.5172137562793183],
            [13.489939069501508, -0.5194080701137945],
            [13.483973787696764, -0.5247126881285764]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.0965433090708, "lat": 37.205344018188974 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51031"],
        "coty_name": ["Campbell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Campbell County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01674917"
      },
      "bbox": [
        13.483973787696764, -0.5247126881285764, 13.938127920285012,
        -0.0935366672274545
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.248040989148322, -0.4894214445634638],
            [12.253115666482817, -0.48994079598011736],
            [12.25870746967145, -0.4883190645915589],
            [12.272633787470172, -0.4822988018221335],
            [12.284570310637115, -0.47323363543732666],
            [12.29326988754013, -0.4684768852907301],
            [12.306421857646065, -0.45733439420778366],
            [12.320087641019402, -0.44092573962912807],
            [12.32718339206886, -0.4298977230974388],
            [12.34103378088475, -0.41914731759721174],
            [12.308841386645344, -0.38645281020300365],
            [12.320291188513607, -0.356086056369286],
            [12.317140694441727, -0.3483101618843307],
            [12.319934915515473, -0.33801133194537236],
            [12.320982487747278, -0.3391291247697078],
            [12.327411110307356, -0.3403855530315656],
            [12.331202501335593, -0.3425046469770033],
            [12.334401468174804, -0.33935455164265005],
            [12.338718474454296, -0.34031280469610115],
            [12.365333007265333, -0.35672303008434214],
            [12.366482529535725, -0.36272054935641695],
            [12.371271379747613, -0.36433755684917474],
            [12.379150781850575, -0.36313780656944655],
            [12.38408522455731, -0.36344688434344885],
            [12.38645241332694, -0.3687628872893827],
            [12.391533869053292, -0.3729387362515949],
            [12.398622088656328, -0.3838303468585139],
            [12.406137458202217, -0.3800386618587599],
            [12.413976747462117, -0.373484015264716],
            [12.416448835066946, -0.3730214573031304],
            [12.426533113711837, -0.36668375983760854],
            [12.43216775866114, -0.36213802274362134],
            [12.445424830079473, -0.35348440716565516],
            [12.454749480558405, -0.3446751349709129],
            [12.45982157412506, -0.3409035712719321],
            [12.481465354837697, -0.32215473004086953],
            [12.487011908241065, -0.3185572766776089],
            [12.493090884587495, -0.3121193234369674],
            [12.495890732265464, -0.30690112636330175],
            [12.503227529689205, -0.3044946839795978],
            [12.50321902443543, -0.3017724789017195],
            [12.506778480426023, -0.2976369901893517],
            [12.518562381918573, -0.2888259567278374],
            [12.524552969036943, -0.2824573172832709],
            [12.527986333621191, -0.27656069260864935],
            [12.541540279241081, -0.2641902026844851],
            [12.54478355580232, -0.26038438465160235],
            [12.551460085758281, -0.2554137827144456],
            [12.556859145703765, -0.25336988078640055],
            [12.563134813387201, -0.25304303706024966],
            [12.566128153546595, -0.24936301174450096],
            [12.573059042734414, -0.2484487807819191],
            [12.578319748106907, -0.24597869714615925],
            [12.58165379850359, -0.24215795795456227],
            [12.599853350136431, -0.263645613579678],
            [12.598645573652622, -0.2771174906880326],
            [12.602109908752688, -0.28648315101098715],
            [12.619048571296066, -0.2960977141500755],
            [12.621088134612792, -0.2949110761996514],
            [12.663434144286017, -0.3739269379869148],
            [12.65628459477596, -0.38289618051111135],
            [12.659421400136155, -0.3923893336447099],
            [12.661933625896511, -0.3944398683247693],
            [12.665787513578131, -0.3912221285205009],
            [12.671251414913213, -0.39654887725494586],
            [12.666240136287303, -0.4017112395968686],
            [12.657169469409274, -0.41294897466847896],
            [12.649885294290014, -0.4200712082623772],
            [12.638864631844392, -0.4337416655465702],
            [12.631676406908555, -0.4387723743012011],
            [12.623625035319213, -0.4460901308156745],
            [12.601545039995662, -0.4602048501052982],
            [12.585307032003577, -0.46747067826410466],
            [12.575164514772219, -0.4714208140942169],
            [12.561970776950231, -0.48028978144979806],
            [12.551352089950768, -0.4855613173174775],
            [12.546095969122213, -0.4902876651078854],
            [12.53986385731541, -0.4930182720520599],
            [12.533234797178892, -0.49871246443924105],
            [12.525873779613063, -0.5029221394855881],
            [12.514309000520141, -0.511073241377867],
            [12.498699385350783, -0.5192490665009717],
            [12.489885705403658, -0.528559112884521],
            [12.48103499781822, -0.5354452984758297],
            [12.4664060315087, -0.5452959576615544],
            [12.460564464289263, -0.5469857367188051],
            [12.454611522281064, -0.5530688862735569],
            [12.45083854676948, -0.5538273254616407],
            [12.44188153802643, -0.5585207974125798],
            [12.43594166595722, -0.5606416340071709],
            [12.422462098412637, -0.5686371078999308],
            [12.41244503504469, -0.5756772130555187],
            [12.405207850700517, -0.579892599588431],
            [12.400604313774814, -0.5853762674498916],
            [12.396796868752064, -0.5928032614011671],
            [12.387537745311468, -0.6021294624109568],
            [12.379635728781718, -0.6089573233878444],
            [12.376530659292944, -0.6126208592848517],
            [12.368963911460808, -0.6186069111309516],
            [12.34453695586965, -0.5984198403796905],
            [12.3493718908925, -0.5970223149024001],
            [12.353072021698159, -0.5927837902701579],
            [12.358604600574807, -0.5885523566675176],
            [12.348556441511155, -0.5745534367165342],
            [12.340340359846218, -0.5828961086023834],
            [12.33314685030762, -0.5917414047562591],
            [12.255402921138996, -0.5318296900836116],
            [12.224072134177714, -0.510983986687907],
            [12.235981054205514, -0.5043374223366004],
            [12.244764525043335, -0.4920057927199953],
            [12.248040989148322, -0.4894214445634638]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.70291807218845, "lat": 37.31421462786404 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51071"],
        "coty_name": ["Giles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Giles County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01494551"
      },
      "bbox": [
        12.224072134177714, -0.6186069111309516, 12.671251414913213,
        -0.24215795795456227
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.540910563879265, 0.12466920955123341],
            [15.542758033558089, 0.11781532305669097],
            [15.545679248255182, 0.11517486551257126],
            [15.550943310489364, 0.10643199721487154],
            [15.554741139947275, 0.10204014534538901],
            [15.560422138561472, 0.09923487651057218],
            [15.55951946137429, 0.10457897387247662],
            [15.56623490432904, 0.10611284214644277],
            [15.567207666625032, 0.10858533415533018],
            [15.571609858891543, 0.11148683498940867],
            [15.572339153483478, 0.115335124291504],
            [15.576200124974518, 0.11941218789201416],
            [15.579100789692204, 0.11883464336177435],
            [15.58159487365328, 0.10800990270525448],
            [15.585079919950603, 0.10377641333117278],
            [15.58166915607642, 0.09702258204954668],
            [15.585858749713788, 0.0927569156481966],
            [15.58636242454309, 0.08729135537835644],
            [15.59042751322033, 0.0880282976888584],
            [15.597869755379522, 0.08324293933472998],
            [15.600791320569622, 0.0795874895058286],
            [15.595008163187458, 0.07573476184170748],
            [15.581616278986699, 0.07290662431703024],
            [15.57550534739911, 0.07311915057276414],
            [15.56957266399003, 0.07065648507315683],
            [15.553527813021669, 0.06955971945320642],
            [15.544465906167066, 0.07518724436775075],
            [15.538874982715653, 0.0830748928758307],
            [15.538718944923026, 0.09769128062075792],
            [15.548312950574113, 0.10024690292961459],
            [15.54713559962083, 0.10375827157355046],
            [15.540060621979642, 0.10440475707472388],
            [15.541199586891413, 0.1095313831001866],
            [15.539044741934879, 0.11088939968973159],
            [15.536925146305405, 0.11787602967728864],
            [15.532880314147965, 0.11922407445513421],
            [15.531149462216971, 0.12252077771837311],
            [15.533253950602706, 0.12554994009675027],
            [15.537663995987995, 0.1283077779467824],
            [15.540910563879265, 0.12466920955123341]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.70759997637747, "lat": 37.26940012142034 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51830"],
        "coty_name": ["Williamsburg"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Williamsburg city"],
        "coty_fp_code": "830",
        "coty_gnis_code": "01789076"
      },
      "bbox": [
        15.531149462216971, 0.06955971945320642, 15.600791320569622,
        0.1283077779467824
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.104040064778555, 10.346070351863021],
            [-18.07665159647182, 10.3377520429698],
            [-18.062186343369003, 10.334697113370087],
            [-18.04833112354525, 10.33101485262022],
            [-18.03453501322902, 10.328457176486141],
            [-17.929086853838, 10.297480969096455],
            [-17.894298751742674, 10.28757311875357],
            [-17.826363188525942, 10.268032223688717],
            [-17.758431832371596, 10.248476113456038],
            [-17.67571935615982, 10.225799062623611],
            [-17.619778277438996, 10.209442634868939],
            [-17.57844166678457, 10.197676494899191],
            [-17.536087747229075, 10.185995581801127],
            [-17.536354524550855, 10.184929213004128],
            [-17.524564135543045, 10.18100977306511],
            [-17.45497247234837, 10.161294078606932],
            [-17.453968563135735, 10.161073293371105],
            [-17.462598534413285, 10.13334514991743],
            [-17.474947372708062, 10.092389538554],
            [-17.502918858644136, 9.997291120326786],
            [-17.505303351859688, 9.997658263715275],
            [-17.509039164232988, 9.987716544799913],
            [-17.52831915203143, 9.919100633995878],
            [-17.548422573859416, 9.848761864273735],
            [-17.556239733722695, 9.854973456152345],
            [-17.562458224278746, 9.858591235467136],
            [-17.56866804313135, 9.85811124062411],
            [-17.574211986125146, 9.853473015984237],
            [-17.57733280073759, 9.85248981688498],
            [-17.58218424505207, 9.853430629334127],
            [-17.585420802402535, 9.842864373816075],
            [-17.595187598362763, 9.837007823937215],
            [-17.599297308577004, 9.837360496592234],
            [-17.60359277892648, 9.831181789411103],
            [-17.603857993377492, 9.826569532339343],
            [-17.607552968618577, 9.823169133050133],
            [-17.61290671751337, 9.824567332463461],
            [-17.615712529861195, 9.822183411910881],
            [-17.613768832839273, 9.819270886983995],
            [-17.616095820356506, 9.812441015961126],
            [-17.615348663365285, 9.808743435205148],
            [-17.6115724658092, 9.802449275125438],
            [-17.615602879528797, 9.797493159619036],
            [-17.620956315436185, 9.796303111515858],
            [-17.622147660973077, 9.789904010831586],
            [-17.630718297784806, 9.780968050030125],
            [-17.639465958480518, 9.777776013696805],
            [-17.645472201597617, 9.778670281757119],
            [-17.64879795379095, 9.777632272050871],
            [-17.65163977731954, 9.779610370838872],
            [-17.651788297529773, 9.784469639745256],
            [-17.660509893308927, 9.784277225684965],
            [-17.664427852672677, 9.790199038029586],
            [-17.668507467575658, 9.793207143469095],
            [-17.67276519387059, 9.800371112335275],
            [-17.685630742221946, 9.805539604458534],
            [-17.68497449659349, 9.808123190650166],
            [-17.691905057814864, 9.810235022477999],
            [-17.696678766816124, 9.809762565320899],
            [-17.70108602766506, 9.811766224834935],
            [-17.701910388174916, 9.819502623937506],
            [-17.70543160787682, 9.82230830793468],
            [-17.722218689812347, 9.830089827371665],
            [-17.72735419571855, 9.827123334253255],
            [-17.730704901462857, 9.827944166160293],
            [-17.732653084054338, 9.831844308701495],
            [-17.73615435511983, 9.830721388027698],
            [-17.736373443654156, 9.826720973540404],
            [-17.742802993746977, 9.828103819291298],
            [-17.74439358364447, 9.833270000514528],
            [-17.74981635835506, 9.83264494760358],
            [-17.75287818325669, 9.834797933621278],
            [-17.76190484967813, 9.832361201505146],
            [-17.761531068825246, 9.826934907605844],
            [-17.76692925312426, 9.824510528184522],
            [-17.77355636019912, 9.823107282409854],
            [-17.77670583645395, 9.819581080035654],
            [-17.780678115445465, 9.817808758680032],
            [-17.78422781209679, 9.812696222347272],
            [-17.78961709072694, 9.811994378744036],
            [-17.794369557268965, 9.814254975229643],
            [-17.797780374354378, 9.817400792545474],
            [-17.803270441898878, 9.817008119568628],
            [-17.80772095776269, 9.813740244503073],
            [-17.81590955642153, 9.812373762971616],
            [-17.820570280431085, 9.808794132962493],
            [-17.82824931863517, 9.806579850856096],
            [-17.8308142083679, 9.808481379533504],
            [-17.838051885426417, 9.809434400414126],
            [-17.84499838275946, 9.8137732926016],
            [-17.848202830127914, 9.813829313284103],
            [-17.85838082748808, 9.807375313789253],
            [-17.859371750669304, 9.812096527696177],
            [-17.863711633380557, 9.817960175446316],
            [-17.871398703033382, 9.821953446624875],
            [-17.875939752443983, 9.825879120201801],
            [-17.879834216429494, 9.826230180418202],
            [-17.880657160698323, 9.823506114483221],
            [-17.87738557043215, 9.81917468925568],
            [-17.879274649959868, 9.814310614424688],
            [-17.88223230872513, 9.814044021004687],
            [-17.885345973390283, 9.817952927024372],
            [-17.890389321446936, 9.81887284821174],
            [-17.89569018943785, 9.822238791748816],
            [-17.899680621765743, 9.822962393541335],
            [-17.900215011371657, 9.815818922849775],
            [-17.907521042881648, 9.80863632759319],
            [-17.912432883140454, 9.808290912332373],
            [-17.916384945862642, 9.810707067952446],
            [-17.919207744061385, 9.79778120186004],
            [-17.927286572846743, 9.796928607237039],
            [-17.927831536143472, 9.791629771042679],
            [-17.9178090889208, 9.789554103727552],
            [-17.921360970377155, 9.781870451540312],
            [-17.919986713173504, 9.77290472536759],
            [-17.915817640667743, 9.765069793232865],
            [-17.91913431066449, 9.761666899683325],
            [-17.926677666803798, 9.767844842393828],
            [-17.931729155813798, 9.768798873312782],
            [-17.93859754852702, 9.764579240667706],
            [-17.94636121648953, 9.764223674991827],
            [-17.95537237597778, 9.762535645755563],
            [-17.959377198938206, 9.759112842512769],
            [-17.96549954853542, 9.758354479331176],
            [-17.960403823955264, 9.774491562094925],
            [-17.964528024596255, 9.792716019016094],
            [-17.965615293383646, 9.82212135173084],
            [-17.95658424144047, 9.839718507115505],
            [-17.953861448807878, 9.868208526739634],
            [-17.96414569599671, 9.891466219911212],
            [-17.96715345927973, 9.92679191099516],
            [-17.977118844071125, 9.946861437865866],
            [-17.97330158373856, 9.975465817914161],
            [-17.97986948807914, 10.001362247101993],
            [-18.01304299723739, 10.032462759518813],
            [-18.03263131299622, 10.06778949345822],
            [-18.03547734810906, 10.070880834323209],
            [-18.04308882511929, 10.076210467959385],
            [-18.049402883847073, 10.083378258504105],
            [-18.053819806615063, 10.086712922677778],
            [-18.058295237291595, 10.095422671186675],
            [-18.087473265751722, 10.12848630541784],
            [-18.09258613730529, 10.137735111123751],
            [-18.1251636817009, 10.150943465453434],
            [-18.160833132821196, 10.144444398071451],
            [-18.1539979687823, 10.169571545418831],
            [-18.149821669563572, 10.183129571858563],
            [-18.1512225224288, 10.183501742242374],
            [-18.14667770249443, 10.200621029157737],
            [-18.135506532957443, 10.236577176542783],
            [-18.13093939995363, 10.249405906732667],
            [-18.119602699523295, 10.28976653104995],
            [-18.11616667454187, 10.304500031414621],
            [-18.11184482897503, 10.317894145421347],
            [-18.11052785216187, 10.324882286358427],
            [-18.104040064778555, 10.346070351863021]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.6809908174532,
          "lat": 46.193222508569555
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53015"],
        "coty_name": ["Cowlitz"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cowlitz County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01529156"
      },
      "bbox": [
        -18.160833132821196, 9.758354479331176, -17.453968563135735,
        10.346070351863021
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.554302401338557, 1.5553027322384212],
            [12.567344210207363, 1.5533688235007348],
            [12.641044543791915, 1.5735296179682396],
            [12.661883873859916, 1.5793493460284205],
            [12.693876861503153, 1.6000377101720054],
            [12.698404087308237, 1.6024111663390597],
            [12.700659002635376, 1.6060707777476226],
            [12.70511467746061, 1.6081080482892054],
            [12.705184575952153, 1.614584559507656],
            [12.706546619448487, 1.6212545499984083],
            [12.710794037809059, 1.6221717364199164],
            [12.712970058418927, 1.6284739351068471],
            [12.715641898600033, 1.6316350919455636],
            [12.714007918549314, 1.6371363161589525],
            [12.718432566156533, 1.6394335759133762],
            [12.722052564265898, 1.6365776381626373],
            [12.723319663427585, 1.6322904709721449],
            [12.728182052242273, 1.6323043237129637],
            [12.733520266763579, 1.6366749154010187],
            [12.735247393064657, 1.639492393958949],
            [12.738973980171169, 1.6348402480452928],
            [12.74231437095317, 1.638492539708315],
            [12.739583823682398, 1.6450591792050113],
            [12.742016199477604, 1.6494972036843707],
            [12.749403125108506, 1.6470335806144403],
            [12.755559100791249, 1.6472071627806217],
            [12.761580248149212, 1.6443553468053733],
            [12.766361520857393, 1.645328547115402],
            [12.769464487305305, 1.6414554644129307],
            [12.772431496670249, 1.641421079740852],
            [12.777415070926306, 1.636999135624415],
            [12.781130509740066, 1.6311211385297135],
            [12.781747980583477, 1.625617210895365],
            [12.786313713634529, 1.6248672389731351],
            [12.79057558439359, 1.6091748856522747],
            [12.789684939986325, 1.6034541822309194],
            [12.792607346659954, 1.6001576802052173],
            [12.801633446645221, 1.598409234212519],
            [12.804199817771197, 1.5963062764873628],
            [12.812346035457386, 1.5981433731346606],
            [12.81742534712379, 1.5981784534338177],
            [12.825482657125116, 1.594759996250439],
            [12.826049018334379, 1.5894691209059517],
            [12.827833861684818, 1.5828885994578406],
            [12.822907605284707, 1.5771265016686742],
            [12.826316034380774, 1.5681901797162217],
            [12.82428716676657, 1.5632334261120169],
            [12.823574505978705, 1.5569658971349638],
            [12.81944876803964, 1.5510356986493445],
            [12.82314906039665, 1.54808837491244],
            [12.823474904563986, 1.539849860133045],
            [12.820762023833549, 1.5346979856655025],
            [12.822556237577718, 1.5316023332470365],
            [12.824606279314757, 1.5174133487913504],
            [12.821724296379042, 1.512412704438643],
            [12.821552288558582, 1.5038837717214737],
            [12.823312895266358, 1.4999875400298095],
            [12.822445677597978, 1.4968689545418659],
            [12.822826049509182, 1.4896636214575227],
            [12.821604394740696, 1.4867914239652593],
            [12.823262577444002, 1.4834919340913508],
            [12.828583744270688, 1.4833815332171751],
            [12.830581623887122, 1.479015030898626],
            [12.829039895486261, 1.4761901106536046],
            [12.834048107649943, 1.473363686079906],
            [12.833906252038737, 1.4696526657779883],
            [12.836344511128996, 1.4645415317900428],
            [12.833555983833694, 1.4585325202746846],
            [12.83073828709117, 1.4572293875733435],
            [12.828990199952162, 1.4524233667887916],
            [12.822285200229574, 1.449224533343687],
            [12.81905934863462, 1.4493879766319648],
            [12.816229041732832, 1.442246319059671],
            [12.81622090981172, 1.4345646224772657],
            [12.812542533053069, 1.4255369666084114],
            [12.815229655099953, 1.4216965554533947],
            [12.812508825672198, 1.4175436936915766],
            [12.813289725625843, 1.4107140239238527],
            [12.811532798348995, 1.4045759505111335],
            [12.812301794678925, 1.3950816673757807],
            [12.811796714102385, 1.386188331896332],
            [12.809651589948558, 1.3795742693436683],
            [12.808264739113753, 1.3630554887788884],
            [12.806115029557274, 1.3532663155246556],
            [12.807453035805917, 1.3449956590417416],
            [12.805215273961483, 1.3366251686526334],
            [12.806371071451967, 1.3317026301996016],
            [12.804512467674808, 1.3224754260510594],
            [12.735165932530304, 1.2966915079935657],
            [12.665469833842735, 1.2720433997941936],
            [12.66772637602254, 1.276701962532999],
            [12.673912183977606, 1.277987392349792],
            [12.674214908876785, 1.2803901571215508],
            [12.679703093530835, 1.2856747198743959],
            [12.679160846990598, 1.2891774028794354],
            [12.674637146642644, 1.2891297053831499],
            [12.671383868552173, 1.2911849021365713],
            [12.677652325981173, 1.2960393267360617],
            [12.678990705312982, 1.3029038747190476],
            [12.685376460634814, 1.3040013191997317],
            [12.682980154506671, 1.3127756936282404],
            [12.683747470067573, 1.318634620976941],
            [12.682935517607984, 1.3230211298938972],
            [12.685907354214999, 1.3252075434291894],
            [12.682339900428104, 1.3294713027859824],
            [12.678897959682763, 1.33085817373228],
            [12.678551040368024, 1.333744761519102],
            [12.685630315290231, 1.3403686451789754],
            [12.683390447182898, 1.3431986680423105],
            [12.678346127971702, 1.3438881453415379],
            [12.67256031865891, 1.3498096173717702],
            [12.675124690847346, 1.3545188320356054],
            [12.674107861740092, 1.3629439471820592],
            [12.671701484201183, 1.3649658371072273],
            [12.668601758982874, 1.3616372086158781],
            [12.663785532508827, 1.364713379019095],
            [12.617643514572963, 1.3566705479908752],
            [12.602096950990996, 1.3735469819649533],
            [12.593957779561643, 1.3873091343139445],
            [12.579106575717939, 1.4011487495885722],
            [12.553159463053401, 1.408024267014677],
            [12.545905785591563, 1.4055787928871655],
            [12.539285910021396, 1.4140554429917194],
            [12.529909917349238, 1.418694763745033],
            [12.528904754183309, 1.4311157806694053],
            [12.526930425013964, 1.4480490122827494],
            [12.523814299205217, 1.4572192015337297],
            [12.5222597184349, 1.4773383474055686],
            [12.554302401338557, 1.5553027322384212]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.00300485386582, "lat": 39.13295208070257 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54001"],
        "coty_name": ["Barbour"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barbour County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01696996"
      },
      "bbox": [
        12.5222597184349, 1.2720433997941936, 12.836344511128996,
        1.6494972036843707
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.665469833842735, 1.2720433997941936],
            [12.735165932530304, 1.2966915079935657],
            [12.804512467674808, 1.3224754260510594],
            [12.806371071451967, 1.3317026301996016],
            [12.805215273961483, 1.3366251686526334],
            [12.807453035805917, 1.3449956590417416],
            [12.806115029557274, 1.3532663155246556],
            [12.808264739113753, 1.3630554887788884],
            [12.809651589948558, 1.3795742693436683],
            [12.811796714102385, 1.386188331896332],
            [12.812301794678925, 1.3950816673757807],
            [12.811532798348995, 1.4045759505111335],
            [12.813289725625843, 1.4107140239238527],
            [12.812508825672198, 1.4175436936915766],
            [12.815229655099953, 1.4216965554533947],
            [12.812542533053069, 1.4255369666084114],
            [12.81622090981172, 1.4345646224772657],
            [12.816229041732832, 1.442246319059671],
            [12.81905934863462, 1.4493879766319648],
            [12.822285200229574, 1.449224533343687],
            [12.828990199952162, 1.4524233667887916],
            [12.83073828709117, 1.4572293875733435],
            [12.833555983833694, 1.4585325202746846],
            [12.836344511128996, 1.4645415317900428],
            [12.833906252038737, 1.4696526657779883],
            [12.834048107649943, 1.473363686079906],
            [12.837552322926024, 1.476116323489912],
            [12.8415063655263, 1.4712658450264717],
            [12.854850583650705, 1.468952287606938],
            [12.859574482415116, 1.4628021892134844],
            [12.864677941581844, 1.459890405736881],
            [12.864688243604009, 1.4562042139052291],
            [12.873893972694372, 1.4480622047769292],
            [12.87848968109254, 1.4408654463304673],
            [12.879867719277016, 1.4364940607058263],
            [12.878502134335651, 1.4340055032500676],
            [12.880804492493558, 1.422010457906121],
            [12.879101036450198, 1.4196685385944794],
            [12.882363464801168, 1.4107055447518977],
            [12.880077589793338, 1.408570538935763],
            [12.879536000480226, 1.403561043175049],
            [12.87733143527913, 1.400517368149355],
            [12.99165066328484, 1.3873177649512287],
            [13.098073534701344, 1.375111056897754],
            [13.098987644831011, 1.3724388078970713],
            [13.10294324850346, 1.3706295801825972],
            [13.104809005040721, 1.3758950132933883],
            [13.108386411482096, 1.3792932976513768],
            [13.114069986206678, 1.3776432579987044],
            [13.115647095850095, 1.379498170603671],
            [13.121966642942606, 1.38212002269429],
            [13.126314381486651, 1.382633443746073],
            [13.132731152481453, 1.380801007357427],
            [13.134444329037242, 1.3822755100253687],
            [13.143269491939996, 1.3819187543775004],
            [13.150976471203716, 1.3857168802981588],
            [13.16528828902573, 1.3833419754546026],
            [13.168988407404868, 1.3858992858486705],
            [13.174220523678379, 1.3871239128628314],
            [13.189901451706785, 1.385969815382168],
            [13.199757250443557, 1.383302775328999],
            [13.208914334925856, 1.3863560486114408],
            [13.214529766281428, 1.384682886501788],
            [13.221038735998475, 1.3806065861962984],
            [13.2216756727219, 1.3787716756802335],
            [13.21889062945642, 1.374179731713946],
            [13.219021785174455, 1.3641573730277723],
            [13.215185417049074, 1.3517933347881839],
            [13.213656231864512, 1.3507029626137106],
            [13.213695981713697, 1.343842150497633],
            [13.20825287271319, 1.3387801175471725],
            [13.19718985123366, 1.3393890615089195],
            [13.19285332401824, 1.3378037362684179],
            [13.177816034668204, 1.3356644993956563],
            [13.17022129517905, 1.3405786056051687],
            [13.15511502192516, 1.3415065437797837],
            [13.150794688877616, 1.338491802986326],
            [13.14640514652887, 1.3372075134723531],
            [13.146193647913735, 1.331738432063159],
            [13.149432413879623, 1.3240051599006346],
            [13.153280959411251, 1.3208538702865855],
            [13.15406004039335, 1.3172889077905416],
            [13.158117288803577, 1.3133371054299137],
            [13.158816905404244, 1.3080280774219106],
            [13.149711140262347, 1.3028397287866],
            [13.145423076258941, 1.2982940390402709],
            [13.140394666520042, 1.2975132196251338],
            [13.135398849047414, 1.2938688409628918],
            [13.133434459754758, 1.290346931416294],
            [13.125819602793145, 1.2913679804297018],
            [13.122183114095302, 1.2938047116050269],
            [13.109936627991106, 1.2940152160735336],
            [13.10443858466301, 1.2910025965058438],
            [13.105524899051966, 1.2852489973872012],
            [13.110378437559508, 1.2794378127321855],
            [13.11439968119846, 1.2761455126235424],
            [13.113923667647924, 1.267249641541718],
            [13.107864082036695, 1.2549153881174957],
            [13.103184818071366, 1.2498946209760244],
            [13.103203728356993, 1.2462086346689918],
            [13.098359350683365, 1.2380850392327625],
            [13.112392652747259, 1.2290659187200816],
            [13.10914514856727, 1.2210817950683293],
            [13.109275924284317, 1.2173507441802867],
            [13.11213372270808, 1.21256381893022],
            [13.121791623510614, 1.2080596902746226],
            [13.12912817132168, 1.201966012157876],
            [13.131837548612868, 1.1945359227934211],
            [13.130101630069523, 1.1888141616796244],
            [13.13097644670767, 1.1815882721966504],
            [13.12741013498489, 1.1777863344836326],
            [13.123262891074429, 1.1683486023335072],
            [13.121189218051741, 1.1618363589271345],
            [13.12023944566881, 1.152036369860243],
            [13.117366956730072, 1.1442572130828954],
            [13.111753265604193, 1.143172853528696],
            [13.111697761798542, 1.1336320504632822],
            [13.107961526932723, 1.1289820113509428],
            [13.104752133368068, 1.1276012761503864],
            [13.102134180127848, 1.1184236143501587],
            [13.103317590919616, 1.1117096413102618],
            [13.100406869190415, 1.1064409473597265],
            [13.096286630098412, 1.1067433200597558],
            [13.093885104248274, 1.0986482918200575],
            [13.093778151575581, 1.0943264387310456],
            [13.0907925716754, 1.0916534156429696],
            [13.087171637523147, 1.084975508035011],
            [13.08740197592291, 1.0805065603774764],
            [13.080495980502969, 1.0773565493792836],
            [13.08202202246591, 1.0627600233979364],
            [13.08722085574509, 1.05591459555254],
            [13.085494770809438, 1.0528488141753716],
            [13.080560244705737, 1.0528866550658695],
            [13.070973693279306, 1.055281319381749],
            [13.068338055951376, 1.0537127012867424],
            [13.064406880188399, 1.0552891572581837],
            [13.062385239391892, 1.0502235917602536],
            [13.060157406909477, 1.045429685770784],
            [13.056368147268772, 1.0460004191100194],
            [13.05585644034311, 1.0516499228197018],
            [13.059911982414206, 1.0590149764922874],
            [13.05961095971889, 1.0648036015568123],
            [13.053895115958998, 1.0669861269041703],
            [13.046655539171567, 1.0643955085274477],
            [13.041102031402009, 1.0660948194427493],
            [13.034353039477558, 1.0710697898420927],
            [13.031549941116177, 1.071402881793118],
            [13.029336360459089, 1.0674323506816445],
            [13.019864992893142, 1.0609724079672416],
            [13.021541275713043, 1.0558324952109062],
            [13.020579917946433, 1.051874615074624],
            [13.021588223779945, 1.0433420259103325],
            [13.007960804011567, 1.0427223729616495],
            [13.00446792854326, 1.0524659956298579],
            [13.002459134553732, 1.0559091682403425],
            [12.995136699343218, 1.0605842139320125],
            [12.989627673410716, 1.0593236582431238],
            [12.985809484529486, 1.0528233072163444],
            [12.978770422328187, 1.0499672360742873],
            [12.974263404129958, 1.0506228598895881],
            [12.96934470753543, 1.0568414713060175],
            [12.972898311588906, 1.0612460000671233],
            [12.972704611783504, 1.0673596805775838],
            [12.970754397502729, 1.078190017547059],
            [12.97439986605547, 1.0825082163355433],
            [12.971172084590645, 1.0834872199748264],
            [12.967432871393525, 1.0887833864704644],
            [12.96076186498949, 1.0892705063354735],
            [12.957615856996979, 1.0915959590697306],
            [12.957692590046241, 1.0947840765616954],
            [12.953583263526836, 1.0963286665914815],
            [12.953483533065807, 1.1023558379816776],
            [12.948791043056046, 1.1041072959037834],
            [12.944041219328678, 1.1016488855572704],
            [12.935348936205486, 1.1056823305731716],
            [12.931811509138207, 1.1021019628010837],
            [12.9312969249092, 1.0937155225903785],
            [12.925535347024994, 1.0848353599469407],
            [12.92648534374101, 1.0797744269870166],
            [12.920759972168439, 1.0729499288349187],
            [12.921679486762507, 1.0693527002422716],
            [12.925013063231614, 1.0669207662453097],
            [12.921639081879343, 1.0559947294876806],
            [12.918875259862181, 1.0533680756915225],
            [12.921134151812758, 1.0452540872851177],
            [12.917141750788279, 1.0379089327947657],
            [12.918026757102904, 1.035500108459845],
            [12.91479318617594, 1.0232784573433924],
            [12.91495978840462, 1.0159191799804987],
            [12.910854603840798, 1.0137796848759457],
            [12.90756965148551, 1.0068643171728058],
            [12.90999498566577, 0.9995990186439215],
            [12.912149109207524, 0.9973353105179968],
            [12.909662805859568, 0.989195711513847],
            [12.9072254409546, 0.9869333410987515],
            [12.90082707372616, 0.9871668497191053],
            [12.902925431787075, 0.9767710800898864],
            [12.90526022514758, 0.9736888851401553],
            [12.90774465009368, 0.9665348908016135],
            [12.904271675402285, 0.9579477543759977],
            [12.904820218050615, 0.9529210203904621],
            [12.901104643734232, 0.9397874063265244],
            [12.903079607744965, 0.9328530639684118],
            [12.902243941637881, 0.9212368002087499],
            [12.90299579946753, 0.915936534789169],
            [12.900928746843164, 0.9087322038608133],
            [12.901334341499325, 0.9060594878784336],
            [12.798736058268757, 0.8018009569236212],
            [12.790308680752192, 0.7934447971210403],
            [12.720763325918423, 0.7968054416695464],
            [12.636683352159507, 0.695146738968675],
            [12.640491810788633, 0.7170956015506171],
            [12.66092722412786, 0.8393957371553248],
            [12.60120581206376, 0.9313502331809929],
            [12.559297360537155, 0.9958754122024958],
            [12.584334050950787, 1.0501148197343997],
            [12.668102072479423, 1.0663006098533434],
            [12.673287856241311, 1.1641418761947544],
            [12.655436651885795, 1.21960784210779],
            [12.659753492554454, 1.2226848202243565],
            [12.659145056736048, 1.229888524746539],
            [12.660451264696546, 1.2320950847259196],
            [12.665655878535278, 1.2343898159140543],
            [12.667599304290155, 1.245692723861193],
            [12.665961151556566, 1.2493092678850695],
            [12.659426231760646, 1.2510289762042563],
            [12.665773224363006, 1.2597493907103523],
            [12.662710882904344, 1.2642769859796965],
            [12.665977677837656, 1.2663041451635193],
            [12.668163653721844, 1.2710859136860602],
            [12.665469833842735, 1.2720433997941936]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.87578245882713, "lat": 38.77475771120721 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54083"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01550048"
      },
      "bbox": [
        12.559297360537155, 0.695146738968675, 13.2216756727219,
        1.476116323489912
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.473891497087007, 6.4809310549520545],
            [4.556700657473118, 6.485721112516299],
            [4.551213574603294, 6.5720464820902444],
            [4.584284969381458, 6.573863545293181],
            [4.659641749931652, 6.578329536410362],
            [4.715356314693595, 6.581774014328083],
            [4.799782972134832, 6.587089545190609],
            [4.833385592079361, 6.58909748373583],
            [4.948500545497031, 6.596637692507038],
            [4.978559579024763, 6.598462364439033],
            [5.047728294274611, 6.602884708119992],
            [5.094203556861098, 6.605715141270556],
            [5.150426139726013, 6.609187269685643],
            [5.23611313675531, 6.6151021882648475],
            [5.24276439623033, 6.5265130521113575],
            [5.246107884647273, 6.483859582000728],
            [5.249773786105493, 6.4337839049008885],
            [5.250531109735865, 6.419193766609843],
            [5.254974277608612, 6.3547001995847765],
            [5.256145433107324, 6.339882752270637],
            [5.2588738911023025, 6.296889291783696],
            [5.267636288615279, 6.1810711041326405],
            [5.181187829118109, 6.1750035267224215],
            [5.173998141390052, 6.1750869121862575],
            [5.109755319478577, 6.173195021227821],
            [5.078941079585637, 6.17241349503785],
            [4.995305472855631, 6.1663965070092415],
            [4.971764082157131, 6.164566563359628],
            [4.911386083896572, 6.160183123355495],
            [4.827673151381704, 6.154843402683045],
            [4.743366259592243, 6.149344405139794],
            [4.678214799016429, 6.145872472939282],
            [4.661610803612681, 6.144562201760558],
            [4.563148529376186, 6.138655637418538],
            [4.49390916163052, 6.134357548206539],
            [4.487347214761156, 6.235033242908843],
            [4.485260839125606, 6.274670400968684],
            [4.4846257554408036, 6.292372132785963],
            [4.483002506476406, 6.321694722430638],
            [4.4817373686049455, 6.3503377654063575],
            [4.479311307646427, 6.378964900219653],
            [4.478631374266196, 6.384009478287854],
            [4.477223180045522, 6.4077719680643455],
            [4.473891497087007, 6.4809310549520545]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.75905787964172, "lat": 44.89828954262189 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55073"],
        "coty_name": ["Marathon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marathon County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01581096"
      },
      "bbox": [
        4.473891497087007, 6.134357548206539, 5.267636288615279,
        6.6151021882648475
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.711745437226276, 6.123269231299034],
            [5.73233829362693, 6.124983442456017],
            [5.7949284598014135, 6.128763204425948],
            [5.824220242562508, 6.130811129245174],
            [5.867158931079926, 6.1333677324379465],
            [5.881546332358676, 6.133886694207302],
            [5.921881536861765, 6.136159797754883],
            [5.960762043027495, 6.1374189291188435],
            [5.967803636304761, 6.137834089813302],
            [5.986001806888768, 6.140559070277418],
            [6.006399263705692, 6.143036078091263],
            [6.007793969259699, 6.130424538800312],
            [6.010392146702962, 6.09496538122896],
            [6.012866456938052, 6.066054674387753],
            [6.01812591415415, 6.001285445390273],
            [6.021775788454896, 5.949011884270961],
            [6.025380262525226, 5.904936225850606],
            [6.027105641557708, 5.8859607686079025],
            [6.027347051300236, 5.8715003406961515],
            [6.028995801756255, 5.864277336942335],
            [6.030594934888555, 5.846836223619215],
            [6.033253134809193, 5.800153273706313],
            [5.996895523566061, 5.797980084462617],
            [5.926115156740909, 5.793200764113278],
            [5.882559028573592, 5.790135597809408],
            [5.859872429408771, 5.788616012477043],
            [5.853838565733704, 5.787886217426442],
            [5.796623455656352, 5.783268554536024],
            [5.773415513010645, 5.781133412924186],
            [5.725867252635277, 5.777412081348836],
            [5.719721666368226, 5.776564519405862],
            [5.64361380228831, 5.770718135443144],
            [5.63890332771017, 5.843153622525953],
            [5.635714754569969, 5.900770715185753],
            [5.63254185159366, 5.942832835039392],
            [5.625695816591821, 6.028501856732194],
            [5.623100155807847, 6.06457610217142],
            [5.619139998360107, 6.116245221872773],
            [5.705106844948333, 6.122673047883248],
            [5.711745437226276, 6.123269231299034]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.46494038095045, "lat": 44.41608690652497 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55087"],
        "coty_name": ["Outagamie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Outagamie County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01581104"
      },
      "bbox": [
        5.619139998360107, 5.770718135443144, 6.033253134809193,
        6.143036078091263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.03214150200159, 5.729338653750868],
            [5.084748871404525, 5.731616737203076],
            [5.114728652385834, 5.7331977505838525],
            [5.181306234146985, 5.737640344591567],
            [5.195186238959236, 5.738675008351082],
            [5.282334871959934, 5.7445601844803535],
            [5.298156671684351, 5.745383251442096],
            [5.366803768470797, 5.749958999422617],
            [5.411325053189055, 5.7530167391647655],
            [5.471036278810039, 5.757265037477784],
            [5.485653818052347, 5.75846455676595],
            [5.539053463147091, 5.762155103589821],
            [5.544284723859501, 5.6972369847201625],
            [5.545453162762949, 5.6811516259946595],
            [5.54963703391491, 5.630904286759796],
            [5.554340761025779, 5.562180169257165],
            [5.558858011438378, 5.503889622144978],
            [5.5300450925618545, 5.501920394672204],
            [5.465748400622617, 5.497152791609399],
            [5.385829919729591, 5.491147694705591],
            [5.356965647140383, 5.488720255368903],
            [5.333510079459668, 5.487065271679456],
            [5.29806402738677, 5.48413565350944],
            [5.242927898807839, 5.480228152175077],
            [5.241324743664299, 5.480286229212832],
            [5.113303613908009, 5.470858413615067],
            [5.049967448675153, 5.4666757711605305],
            [5.045712762281804, 5.528289173534017],
            [5.041138520159056, 5.596115220125009],
            [5.035931710396589, 5.680648977160105],
            [5.03214150200159, 5.729338653750868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.2429288672846, "lat": 44.11311982627604 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55137"],
        "coty_name": ["Waushara"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Waushara County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01581128"
      },
      "bbox": [
        5.03214150200159, 5.4666757711605305, 5.558858011438378,
        5.762155103589821
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.81051306961699, "lat": 18.14535520066339 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72069"],
        "coty_name": ["Humacao"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Humacao Municipio"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01804515"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -67.00532304882145, "lat": 18.44991184562338 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72071"],
        "coty_name": ["Isabela"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Isabela Municipio"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01804516"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.7359436315609407, 0.2642548409185548],
            [2.7359927027007083, 0.30493777515229287],
            [2.736253444997274, 0.3090682245511403],
            [2.772857476962442, 0.3508140462407013],
            [2.8207474612517167, 0.4046241359249502],
            [2.820605865275167, 0.3989244598689033],
            [2.8242096354525437, 0.3907950794068627],
            [2.8303277959937163, 0.3809814757355889],
            [2.83761170653125, 0.36137129193386947],
            [2.8415028516643726, 0.3559014857479656],
            [2.8471184526098154, 0.35150023588932994],
            [2.861171341735782, 0.34642398491157433],
            [2.8678435930018016, 0.34180029217781077],
            [2.8792207513572605, 0.3283225855654579],
            [2.8864823800243995, 0.3235724426066077],
            [2.895034401702256, 0.3214701550185979],
            [2.91141732794382, 0.320492201827127],
            [2.9336266915607214, 0.31490679242211084],
            [2.9403458537513556, 0.31465615381053724],
            [2.947161081005191, 0.3155044765214921],
            [2.9542824207159364, 0.31801659499337187],
            [2.962136624612079, 0.32310326231810266],
            [2.9779851186304285, 0.3278327990302645],
            [2.9889084336356873, 0.32913554714860244],
            [2.9983959321254114, 0.3270715031435613],
            [3.0095274530470695, 0.3214623054655073],
            [3.0187319267692705, 0.321286228169025],
            [3.0380318537545468, 0.3231682466019413],
            [3.058399482670484, 0.3210834681783237],
            [3.0718576543219847, 0.31738563148396337],
            [3.0831146518442325, 0.31569963041823584],
            [3.0910444179669545, 0.3160870870013418],
            [3.1038155529975624, 0.3207023141575408],
            [3.110415216100034, 0.32106005531956416],
            [3.113536201209107, 0.31983743726149705],
            [3.1240514164405067, 0.30910469097495763],
            [3.1279867119052014, 0.3032132784422972],
            [3.1388468334658275, 0.2945752477232705],
            [3.1479075004855352, 0.28817624028885397],
            [3.1529810802503317, 0.28290265529434444],
            [3.161290956715387, 0.2724725666071904],
            [3.159999228262063, 0.2696939928516089],
            [3.1457257886379906, 0.23105513753284282],
            [3.114194246356926, 0.14152223952453685],
            [3.1092239667936865, 0.1282220883911739],
            [3.09357626059795, 0.08362436317148275],
            [3.078394066016803, 0.039491300263414846],
            [3.0785310122476948, 0.024893167840868185],
            [3.064477018967485, 0.02482652416525595],
            [2.993772403870551, 0.025078365030150426],
            [2.993750468561308, 0.026029348737524553],
            [2.979388491188431, 0.024987321184203163],
            [2.9063365943406385, 0.023949675653757822],
            [2.906334520175094, 0.02296557618529653],
            [2.8921687585428875, 0.02226137638618721],
            [2.820761236681739, 0.02224423317374496],
            [2.7513248814237468, 0.02610072399669438],
            [2.735955378554537, 0.026692351448133922],
            [2.7361079839073863, 0.04704590953297268],
            [2.736152943539932, 0.13198839054057937],
            [2.736302794901873, 0.1520150110085679],
            [2.7360750184181533, 0.21067201791522266],
            [2.736208550771838, 0.25428075442576364],
            [2.7359436315609407, 0.2642548409185548]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.81012493721656, "lat": 38.84355860966702 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29053"],
        "coty_name": ["Cooper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cooper County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00758481"
      },
      "bbox": [
        2.7359436315609407, 0.02224423317374496, 3.161290956715387,
        0.4046241359249502
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1577545837161822, 1.46476024335573],
            [2.1559003525969156, 1.5670705533892089],
            [2.155170325936059, 1.596949236518017],
            [2.197256338375393, 1.597656180008844],
            [2.2390853755668267, 1.599224844562938],
            [2.2595824562440647, 1.5996603241004623],
            [2.2605703366406753, 1.6001198398000593],
            [2.3006221296492297, 1.6015376997916189],
            [2.3540731875959877, 1.60267422921548],
            [2.3548512501140597, 1.6030639584192785],
            [2.419193161875063, 1.6053969098403527],
            [2.4545827452702778, 1.606964661393974],
            [2.4566623790133497, 1.5482183689008533],
            [2.4585327900005813, 1.470062097425887],
            [2.459017331046452, 1.4599661258584582],
            [2.461599675124199, 1.3718233475161814],
            [2.465092385276453, 1.3719191951304102],
            [2.4660282298372374, 1.3434158505988396],
            [2.4669220397080376, 1.305871230413405],
            [2.374334547495393, 1.3011545415616241],
            [2.282258983859626, 1.2965737791803968],
            [2.2672076427103804, 1.2951929649454104],
            [2.255183999026698, 1.2947694182188814],
            [2.2190554293675264, 1.2924537637577667],
            [2.2086586464207394, 1.2921936181972415],
            [2.1805161284269126, 1.2905590590207698],
            [2.163424847364129, 1.2899578118488508],
            [2.1621042566467703, 1.3266428126891854],
            [2.1616449731173137, 1.3306686474922091],
            [2.1604190229823033, 1.3622330072260211],
            [2.159593527621258, 1.3620924955648652],
            [2.159312688105104, 1.3988859181884739],
            [2.158690809581083, 1.4060034718973824],
            [2.157805773342859, 1.4335935925495338],
            [2.1577545837161822, 1.46476024335573]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.56534732289552,
          "lat": 40.113924448160866
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29079"],
        "coty_name": ["Grundy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grundy County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00758494"
      },
      "bbox": [
        2.155170325936059, 1.2899578118488508, 2.4669220397080376,
        1.606964661393974
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.163424847364129, 1.2899578118488508],
            [2.1805161284269126, 1.2905590590207698],
            [2.2086586464207394, 1.2921936181972415],
            [2.2190554293675264, 1.2924537637577667],
            [2.255183999026698, 1.2947694182188814],
            [2.2672076427103804, 1.2951929649454104],
            [2.282258983859626, 1.2965737791803968],
            [2.374334547495393, 1.3011545415616241],
            [2.4669220397080376, 1.305871230413405],
            [2.467375394434064, 1.3059060197750505],
            [2.4697785069731344, 1.2176641188796689],
            [2.4683657427541994, 1.217589582016593],
            [2.4713668670587654, 1.0817275565531963],
            [2.4721386947910102, 1.0397249730410008],
            [2.514317423296128, 1.0405363115816335],
            [2.546693777634085, 1.0415873789218595],
            [2.54849817123937, 1.0356484009085911],
            [2.5382238590218758, 1.028310527451595],
            [2.5332708673884428, 1.0196377908623788],
            [2.5379614514149065, 1.019177274942887],
            [2.5351526475116715, 1.0107555797040497],
            [2.5361837209404814, 1.0082075350575235],
            [2.533333880008337, 1.0041088488369148],
            [2.535240698446471, 0.9992717543178609],
            [2.5422174317395636, 0.9946223083076362],
            [2.54304672197649, 0.9901603335372238],
            [2.535663695646138, 0.9886414387329745],
            [2.5475690835538765, 0.97128179262549],
            [2.552958842561526, 0.9666976252940696],
            [2.5529796898073, 0.9601475984636264],
            [2.5482832648774045, 0.9567714361171713],
            [2.5436747344334405, 0.9577143793450728],
            [2.541162976590789, 0.9599534669515796],
            [2.538411114765799, 0.9561036288422001],
            [2.5407548786925096, 0.9526409707204645],
            [2.431179190702286, 0.9487634909821995],
            [2.3452929534052016, 0.945478756953579],
            [2.3022907326670543, 0.9436317947487458],
            [2.2517028751025627, 0.9409758405312215],
            [2.174457151161926, 0.9388098495157137],
            [2.17329659792583, 0.9900049308202604],
            [2.171962981350406, 1.0264910977641237],
            [2.169849459481429, 1.113606384689772],
            [2.169243161456111, 1.1388908103324402],
            [2.1668376971880154, 1.2019783404582634],
            [2.1659857486930036, 1.2165666509155502],
            [2.163424847364129, 1.2899578118488508]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.54821905608252,
          "lat": 39.782084868454376
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29117"],
        "coty_name": ["Livingston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Livingston County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00758513"
      },
      "bbox": [
        2.163424847364129, 0.9388098495157137, 2.5529796898073,
        1.3059060197750505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.874139056463729, 9.416480297178726],
            [-7.8691403625166, 9.412960371238972],
            [-7.854000999966652, 9.40990787569286],
            [-7.8428798935489645, 9.411865571926587],
            [-7.837606361388334, 9.416080866208059],
            [-7.832038567828777, 9.415168055991073],
            [-7.8284143452242585, 9.410054617202015],
            [-7.8237476164558535, 9.40875774724282],
            [-7.8071433381471325, 9.409588398309616],
            [-7.802384980443755, 9.41178907765674],
            [-7.79694855281297, 9.412608354740744],
            [-7.791074291682752, 9.409075368027905],
            [-7.788578127538892, 9.404674172894095],
            [-7.78401827281252, 9.40141768876388],
            [-7.772064452343857, 9.400576154222234],
            [-7.7626828204591645, 9.40224444825115],
            [-7.75465296305218, 9.409907321212195],
            [-7.7507906133355755, 9.410945545814158],
            [-7.7423150709539375, 9.409950031593702],
            [-7.738339197350518, 9.40676405985588],
            [-7.7344597130727175, 9.406349816985472],
            [-7.727664317174685, 9.408087768868604],
            [-7.724102511445817, 9.407742892100122],
            [-7.720100937665643, 9.404569709261647],
            [-7.715855354028119, 9.40459349712041],
            [-7.7055239186645075, 9.409497622344206],
            [-7.702759440200569, 9.408853240836848],
            [-7.697722720454437, 9.404771893704847],
            [-7.694091581957289, 9.398367310774702],
            [-7.679667035392887, 9.390492850236347],
            [-7.672466480090503, 9.388616615291712],
            [-7.66090646190911, 9.390179371604555],
            [-7.655229363095875, 9.393858801470202],
            [-7.646969861749336, 9.389939553436452],
            [-7.640977346708343, 9.381836430456497],
            [-7.6391337403883295, 9.373099558716786],
            [-7.627959373369377, 9.36819952735461],
            [-7.622024878001859, 9.370340758086416],
            [-7.618698162201958, 9.369759499436832],
            [-7.615879586597605, 9.36556768926894],
            [-7.615461827876467, 9.356259757149738],
            [-7.619828008023881, 9.351213214109741],
            [-7.621171716545276, 9.34561638918478],
            [-7.6171412775053975, 9.337863317152294],
            [-7.615089693430857, 9.335833458040003],
            [-7.614460751580264, 9.330773200431707],
            [-7.616689726489894, 9.321604740448624],
            [-7.61266740497935, 9.31507055599531],
            [-7.606074569651107, 9.311947676807732],
            [-7.6037803693147525, 9.309607221751293],
            [-7.603907671589375, 9.303697511668599],
            [-7.609108058920705, 9.29409873877558],
            [-7.613947303990868, 9.289068481680692],
            [-7.614582945122131, 9.284405182400265],
            [-7.612735123745309, 9.275871679549214],
            [-7.614864084761787, 9.271496372396042],
            [-7.6187101125051795, 9.267621131680094],
            [-7.618698349869912, 9.261514426958401],
            [-7.620381069488312, 9.25547186949742],
            [-7.618582635890639, 9.25275498032411],
            [-7.624429897069259, 9.249469312040985],
            [-7.622852044186362, 9.244427597432017],
            [-7.625097049936249, 9.242408157706343],
            [-7.625687835167148, 9.236610667659345],
            [-7.622696636907869, 9.237106715742947],
            [-7.621827897128993, 9.231696081552004],
            [-7.624745045712733, 9.228202654491426],
            [-7.6222556244552475, 9.224414510579809],
            [-7.624886610623093, 9.220106099500038],
            [-7.628791784290626, 9.221975274197957],
            [-7.628798336951147, 9.217066466708374],
            [-7.62465799923357, 9.217994182899163],
            [-7.625009154703939, 9.204993444514868],
            [-7.627794066983214, 9.205882716368508],
            [-7.630491130001129, 9.201428784708128],
            [-7.635758193284943, 9.201592826060121],
            [-7.638045226968349, 9.197919676073312],
            [-7.635767151821776, 9.193425799030035],
            [-7.6394410749732, 9.19171926346704],
            [-7.643344010305757, 9.19452675593693],
            [-7.645737557124247, 9.189993530683575],
            [-7.641367685504073, 9.188264122179998],
            [-7.642366519218774, 9.182394672846879],
            [-7.650177881349712, 9.18429801839863],
            [-7.648675777527517, 9.1804747093847],
            [-7.65150757094821, 9.17672381822644],
            [-7.650383053936298, 9.173796109826855],
            [-7.661844870860743, 9.169389867564103],
            [-7.658556964734979, 9.163989699843935],
            [-7.667619684639768, 9.16325454239828],
            [-7.665907858027454, 9.157873598362233],
            [-7.662544157592561, 9.156016098006045],
            [-7.660581215310454, 9.151726701542753],
            [-7.66435852094953, 9.150502493792606],
            [-7.6639363451484295, 9.146037198247912],
            [-7.667607275358433, 9.144155690906851],
            [-7.670752697308679, 9.138811949198654],
            [-7.669063846205666, 9.13633315352411],
            [-7.663878823389325, 9.135627320375393],
            [-7.666993316658232, 9.132160242973725],
            [-7.658738314091453, 9.128687944726446],
            [-7.655712319959936, 9.12577155133138],
            [-7.659671397012288, 9.123931094467718],
            [-7.662613125462393, 9.124976935700548],
            [-7.667659942935641, 9.120372319594285],
            [-7.6690840701208725, 9.11382602440308],
            [-7.662277249857444, 9.109589016948371],
            [-7.667716925360746, 9.105992749096526],
            [-7.673487784590628, 9.103932521902442],
            [-7.673354028520949, 9.101826623230364],
            [-7.667217787018162, 9.097486653861411],
            [-7.66491056857598, 9.093390365853901],
            [-7.671140625153231, 9.094666854814612],
            [-7.675556163966165, 9.091632603490478],
            [-7.677831205405956, 9.08672657611285],
            [-7.6728329702767395, 9.085888375226645],
            [-7.670137976559719, 9.083889046880769],
            [-7.672665329099539, 9.07793918958373],
            [-7.676083594861862, 9.079464825123171],
            [-7.678419376634601, 9.075653810649097],
            [-7.67359950680228, 9.070375657872242],
            [-7.669180328065054, 9.070334736992017],
            [-7.671855657799214, 9.06438493530054],
            [-7.677930665191557, 9.068730997012635],
            [-7.6838349929374115, 9.062174234662017],
            [-7.671382181342978, 9.054243410929947],
            [-7.672368629141033, 9.049019677535865],
            [-7.675914403906437, 9.0513898752884],
            [-7.680708534040052, 9.049750345183718],
            [-7.676973163971451, 9.04454550350284],
            [-7.677674093843034, 9.040393671342372],
            [-7.681772469739873, 9.037766115959379],
            [-7.67626709231794, 9.035256728320794],
            [-7.673667326668859, 9.03971123059543],
            [-7.670098856081151, 9.033105710626483],
            [-7.672347682892089, 9.03072592724941],
            [-7.6677633667627765, 9.027977766773175],
            [-7.6671176581586415, 9.024952632506794],
            [-7.6695406221702775, 9.019418896057848],
            [-7.669379976900572, 9.015910472326718],
            [-7.672697003579197, 9.01518850759465],
            [-7.6756968507754655, 9.010026554706293],
            [-7.673442149152952, 9.003651186396315],
            [-7.6689326678989715, 9.005084091359475],
            [-7.670662853932081, 8.99938695898529],
            [-7.666729073048301, 8.996237553878338],
            [-7.672325320977367, 8.993019641813243],
            [-7.670046332503202, 8.988084786545073],
            [-7.667253353405963, 8.989315211612787],
            [-7.6659457497598265, 8.993852317704148],
            [-7.661761540556579, 8.989261756861781],
            [-7.669969442584487, 8.98491395785576],
            [-7.667148097734983, 8.982214073278099],
            [-7.669211152626908, 8.976832864197004],
            [-7.67354446803937, 8.978575554519038],
            [-7.675454637558127, 8.98372526178476],
            [-7.678694695655691, 8.982045767841047],
            [-7.678598186202818, 8.978438491742756],
            [-7.674734689014003, 8.974389872826087],
            [-7.675813768419887, 8.972232565948495],
            [-7.6744261566097185, 8.965690691041312],
            [-7.677342265043964, 8.965795924164732],
            [-7.679419103528131, 8.971638471265551],
            [-7.682467220303283, 8.974371331922745],
            [-7.686186979440034, 8.970881856452577],
            [-7.682486660510772, 8.966299282889118],
            [-7.682262862629728, 8.961144363900972],
            [-7.67659372367377, 8.95790807843146],
            [-7.67685282637872, 8.95474385932966],
            [-7.681906219636908, 8.94638564893461],
            [-7.687509129775714, 8.944304386273963],
            [-7.693930638375333, 8.940151248824796],
            [-7.6902847877762035, 8.93505822019642],
            [-7.682151145375704, 8.933819846110167],
            [-7.679837569059725, 8.92869252171282],
            [-7.680860440406591, 8.924357795359343],
            [-7.684898280970843, 8.922979169448773],
            [-7.688135309998362, 8.925285553939181],
            [-7.691163685998466, 8.923327484353816],
            [-7.683948633969758, 8.920155808694851],
            [-7.681089806045344, 8.917428146241575],
            [-7.681678950884369, 8.913174743462136],
            [-7.679417104819631, 8.910822784629023],
            [-7.679600028649094, 8.90350233085678],
            [-7.681230316033202, 8.900771606331709],
            [-7.6859789731810215, 8.901234208028072],
            [-7.6869853278323115, 8.898223532554457],
            [-7.680700900719473, 8.897784379130906],
            [-7.681334987410175, 8.892524294789164],
            [-7.677588846658705, 8.891941301251565],
            [-7.677352835122129, 8.896225414294857],
            [-7.6732463530284605, 8.894949676847883],
            [-7.670656327764342, 8.891712747814086],
            [-7.675471410582073, 8.888617346198552],
            [-7.6779430941249505, 8.882754535737345],
            [-7.673360196342567, 8.88128565661512],
            [-7.6774896568014785, 8.875601316733011],
            [-7.674524598678144, 8.872030800691556],
            [-7.677655799627419, 8.867110729249797],
            [-7.676618321615903, 8.862041787163774],
            [-7.681439448783149, 8.8607753033098],
            [-7.679882014361808, 8.85733616610383],
            [-7.66959094600032, 8.853086956756302],
            [-7.668573222456273, 8.850583489612678],
            [-7.671033373860259, 8.844636251973167],
            [-7.68012489135594, 8.838013980742346],
            [-7.679553208591191, 8.831088974173085],
            [-7.673994733780122, 8.826129142443238],
            [-7.6707591449485415, 8.826797063749897],
            [-7.667056521002441, 8.831738973964708],
            [-7.663864726685904, 8.826584849756951],
            [-7.664539377708119, 8.819632331359264],
            [-7.659909943312299, 8.820471548185866],
            [-7.6612852818553305, 8.815605445783643],
            [-7.657129445643483, 8.809711939022577],
            [-7.6622888039708625, 8.808371138383983],
            [-7.661436727691169, 8.801134936327442],
            [-7.659823336540005, 8.796486823915195],
            [-7.66726326455683, 8.792541230477365],
            [-7.6714397845900635, 8.789037011540575],
            [-7.672643670021711, 8.786017778632178],
            [-7.676290950215604, 8.787132975243122],
            [-7.678381539802173, 8.782877557267685],
            [-7.676149284751938, 8.776494410414978],
            [-7.680779414582513, 8.775454377390805],
            [-7.6783697224396334, 8.771481341317758],
            [-7.678464520222154, 8.767765461224633],
            [-7.682463310355964, 8.766635909610462],
            [-7.686156215704483, 8.761766369750767],
            [-7.686499607876953, 8.75708446894626],
            [-7.684251285703808, 8.75589599467796],
            [-7.681375973960571, 8.75064460160616],
            [-7.689531174093069, 8.752999168855423],
            [-7.69596239511082, 8.750391005148513],
            [-7.690957573324112, 8.744813919143931],
            [-7.6970427790539375, 8.744538000171046],
            [-7.693677560103307, 8.739388218153204],
            [-7.689950923259488, 8.73703527718367],
            [-7.694407225890989, 8.733414707404945],
            [-7.697754312306476, 8.735367487725801],
            [-7.7018486852895025, 8.734889248216312],
            [-7.70263677676569, 8.731826281756303],
            [-7.699226030078625, 8.725685163993168],
            [-7.703527616910793, 8.722749792499965],
            [-7.701464692865051, 8.717114742531717],
            [-7.702399413240145, 8.71519469021746],
            [-7.709280373778108, 8.713462133310868],
            [-7.7100058657398245, 8.710112186112832],
            [-7.707358763054463, 8.705929452822176],
            [-7.711074217182155, 8.702200539634283],
            [-7.710539770581664, 8.69526612252068],
            [-7.707758187778207, 8.692341274098665],
            [-7.704624747279076, 8.695704709533498],
            [-7.701355474163608, 8.695835711822628],
            [-7.695099640084304, 8.692649999683244],
            [-7.698735565550238, 8.686145949046493],
            [-7.694683809710709, 8.685040797598676],
            [-7.690810869392455, 8.681543154055028],
            [-7.685481487841304, 8.681703340807678],
            [-7.691077855165442, 8.673945155285146],
            [-7.687738949480538, 8.668865922106145],
            [-7.6828709067663805, 8.669352799068783],
            [-7.681610368757433, 8.666830482438332],
            [-7.678071190562858, 8.659158718251089],
            [-7.67179440110517, 8.659474445573258],
            [-7.6708822244107875, 8.656972718108454],
            [-7.672196339306409, 8.651680118845368],
            [-7.670820440140837, 8.64941047891807],
            [-7.662817606918171, 8.649007842937625],
            [-7.666967426386296, 8.643568551614178],
            [-7.661714494756854, 8.637785377052243],
            [-7.659823782272519, 8.631712643066935],
            [-7.661048356887279, 8.625676569997228],
            [-7.656218743451165, 8.623322390978556],
            [-7.655520606169197, 8.618934523708793],
            [-7.653062119448288, 8.616150800696909],
            [-7.659441748849948, 8.614226563737216],
            [-7.661777086346776, 8.61197214352595],
            [-7.661141586624919, 8.607123165128595],
            [-7.657962016713611, 8.608227939891615],
            [-7.652803997207397, 8.606961830587776],
            [-7.652945422667521, 8.603175853324561],
            [-7.65661823834761, 8.602864400421733],
            [-7.655813849303195, 8.598889701300218],
            [-7.661610598080752, 8.596051281881424],
            [-7.664288351056337, 8.59290395932986],
            [-7.65578244735194, 8.588170352523486],
            [-7.654037445359642, 8.584894898824563],
            [-7.657175087042866, 8.581053521716198],
            [-7.654659015880883, 8.57574366854225],
            [-7.650115793107831, 8.577445822353747],
            [-7.6472724959518255, 8.573484594182917],
            [-7.64941710583543, 8.568211327760741],
            [-7.775067097388634, 8.582950126676632],
            [-7.77515574724269, 8.582260227160667],
            [-7.8889240608196625, 8.59664957729657],
            [-7.9457670995410075, 8.603915012927361],
            [-8.018305308540244, 8.609584872015878],
            [-8.026516990109297, 8.609677332165866],
            [-8.112493811432065, 8.620857550121412],
            [-8.19847359151561, 8.632014980365737],
            [-8.18640929768727, 8.717262573542943],
            [-8.173087600552769, 8.715472867615867],
            [-8.1453282050479, 8.911441839742658],
            [-8.137201096366981, 8.970098954892203],
            [-8.223902147993716, 8.981677299346089],
            [-8.212061934502286, 9.064570437870856],
            [-8.200697734209973, 9.063003057059367],
            [-8.189090901596769, 9.14765455253652],
            [-8.102499902336662, 9.135998517552204],
            [-8.097534777092825, 9.171376802880303],
            [-8.01191997877014, 9.16049002014536],
            [-8.011774534979232, 9.161588937835488],
            [-7.925599951900952, 9.150390748767995],
            [-7.924671872405307, 9.15742559353416],
            [-7.910256176095149, 9.15556250621997],
            [-7.893466845830741, 9.282492786202356],
            [-7.8825326137430025, 9.365591391218912],
            [-7.880952970665414, 9.365388315299642],
            [-7.874139056463729, 9.416480297178726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.25018973294536,
          "lat": 47.117581121397514
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30069"],
        "coty_name": ["Petroleum"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Petroleum County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01719590"
      },
      "bbox": [
        -8.223902147993716, 8.568211327760741, -7.6037803693147525,
        9.416480297178726
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5648261973761607, 2.022694689267501],
            [-0.4788499248434475, 2.021308632364264],
            [-0.3936687172120713, 2.0201454195305204],
            [-0.357337502462627, 2.019482987395836],
            [-0.3365449214467465, 2.0193812499556545],
            [-0.2858443119055707, 2.0187015774872883],
            [-0.28480804336577215, 2.018523384706753],
            [-0.2229117704502131, 2.0179100957053655],
            [-0.22407714891718652, 1.9299954480158077],
            [-0.2232103364824077, 1.8860814908226355],
            [-0.2239567646272803, 1.842175249181625],
            [-0.22557580815926476, 1.7543076016176686],
            [-0.22623811167133795, 1.6725643503392396],
            [-0.22822308809385158, 1.6668570997828425],
            [-0.31229726567760996, 1.6676709407576653],
            [-0.3636085489420131, 1.6682729486025174],
            [-0.48449478549512737, 1.6701152296153818],
            [-0.5701004158784942, 1.671635411006606],
            [-0.568649844392147, 1.7739880216469925],
            [-0.5669694080594334, 1.8825071032654603],
            [-0.565453030276647, 1.9788214995848237],
            [-0.5648261973761607, 2.022694689267501]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.14094938232016, "lat": 40.52406910713626 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31151"],
        "coty_name": ["Saline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saline County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "00835897"
      },
      "bbox": [
        -0.5701004158784942, 1.6668570997828425, -0.2229117704502131,
        2.022694689267501
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.81844213236747, 4.405266315926597],
            [-16.81706837720866, 4.404809506234629],
            [-16.65945672902763, 4.366273448239328],
            [-16.501854369593502, 4.327697537794381],
            [-16.43819078816906, 4.3119648353380615],
            [-16.463338850512844, 4.2094777895541995],
            [-16.365620761518006, 4.186248838922332],
            [-16.26790605550324, 4.163004968503484],
            [-16.17019474130155, 4.139746181909011],
            [-16.072486827647783, 4.1164724831998205],
            [-16.07070673260391, 4.115939463284235],
            [-15.88936185546475, 4.074076375454899],
            [-15.854722090835153, 4.0658587720281085],
            [-15.816426209071244, 4.057021676025832],
            [-15.746440411129647, 4.040331481380031],
            [-15.697718720457999, 4.028993625057508],
            [-15.629311584699343, 4.013373199189243],
            [-15.635749668900548, 3.985425123698077],
            [-15.668943256649056, 3.843359010485006],
            [-15.655408558456868, 3.840353678888938],
            [-15.539548933567492, 3.8133218348823923],
            [-15.423693844944536, 3.78626987905852],
            [-15.417896011625146, 3.783723543506601],
            [-15.418382292627687, 3.7775539828879965],
            [-15.430045955887909, 3.726296970066437],
            [-15.452496043691616, 3.6303211588105024],
            [-15.54459537672873, 3.4825819216545093],
            [-15.546003314972861, 3.480705118662616],
            [-15.580523005859792, 3.4251343823295537],
            [-15.672694024185452, 3.277582584325736],
            [-15.748667325148178, 3.155507601036023],
            [-15.807443736074958, 3.1695297693103286],
            [-15.810725565044875, 3.1708065844287803],
            [-15.883795592299334, 3.1878886277957577],
            [-15.890342925389326, 3.1895473745443153],
            [-16.03365623185402, 3.2233601117504747],
            [-16.175356655686052, 3.2559936327624066],
            [-16.180245845171658, 3.257425184084319],
            [-16.22531542960695, 3.2680530669563996],
            [-16.40777166548522, 3.3100258165575633],
            [-16.590237230561062, 3.3519561783860214],
            [-16.690584885789736, 3.3768787732293455],
            [-16.790935616642454, 3.4017884032150243],
            [-16.89128942001834, 3.4266850628233967],
            [-16.991646292686593, 3.4515687470525314],
            [-17.010051443359743, 3.455967431451805],
            [-17.010833329953957, 3.455656641683052],
            [-17.07587940203484, 3.4717815489118258],
            [-17.036438567912736, 3.62699793565139],
            [-16.998307616275586, 3.777309346762012],
            [-16.94795045526407, 3.978696791648244],
            [-16.92920891141451, 3.974541927571267],
            [-16.912948168249624, 4.039028371318935],
            [-16.873098191938215, 4.194621656769958],
            [-16.87126833137926, 4.200261755524946],
            [-16.820044296241775, 4.398791703827665],
            [-16.81844213236747, 4.405266315926597]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.40441825662447,
          "lat": 40.440411350756584
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32027"],
        "coty_name": ["Pershing"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pershing County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00858646"
      },
      "bbox": [
        -17.07587940203484, 3.155507601036023, -15.417896011625146,
        4.405266315926597
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.242555030939315, 3.9962605594438956],
            [16.246441686697743, 3.999572918997541],
            [16.252099647858845, 4.001225032269299],
            [16.254731171482106, 4.004073846873347],
            [16.256216980602606, 4.008525981091517],
            [16.261391354143978, 4.010129140954225],
            [16.264069339295872, 4.009375143707169],
            [16.267773117698287, 4.012186320438731],
            [16.27112682639635, 4.008356894131227],
            [16.2794992516699, 4.006159569674424],
            [16.28461238392577, 4.002432048517597],
            [16.28510734262683, 3.9958207672303123],
            [16.287633889532056, 3.9943644472990734],
            [16.292888329399016, 3.9982516497183016],
            [16.29635757419717, 4.0048523610020075],
            [16.301745838218785, 4.005973739679158],
            [16.303651048738736, 4.0091661642473575],
            [16.30866699306586, 4.009440938159847],
            [16.314581661850255, 4.015722539056778],
            [16.317165749757194, 4.019958449765205],
            [16.322321548680556, 4.0221018077907305],
            [16.32577699752031, 4.02839294591749],
            [16.32354604083326, 4.03053629053704],
            [16.324200589969585, 4.035399792347877],
            [16.3308665272521, 4.039768204399493],
            [16.332600451720797, 4.049440690456275],
            [16.33179673081031, 4.057529373287634],
            [16.325248954107998, 4.065046727292038],
            [16.325329947334456, 4.070840991091412],
            [16.32886954957216, 4.078943805678158],
            [16.32858034008005, 4.080590547816976],
            [16.341862618482995, 4.108763919680165],
            [16.373565729720646, 4.167531389493935],
            [16.383294230397926, 4.186618499370893],
            [16.397486494506975, 4.212075418634267],
            [16.407626525169068, 4.206426240855896],
            [16.411408567891407, 4.2058564034119055],
            [16.4109478270393, 4.200757475963682],
            [16.41298869709551, 4.193955692488504],
            [16.409783419886868, 4.191203382471197],
            [16.408821216587555, 4.187941563758592],
            [16.409295967693232, 4.176114863395127],
            [16.408492316888726, 4.169432593635177],
            [16.4116430461432, 4.16341644849175],
            [16.413372909604174, 4.163401826828988],
            [16.41955957991287, 4.169081217271654],
            [16.420509756850763, 4.172878200522079],
            [16.425994141986166, 4.17943518476996],
            [16.43021663165252, 4.180262230479785],
            [16.43568028915409, 4.185910422362819],
            [16.439253469333572, 4.186722936750549],
            [16.445551475678624, 4.190674471417031],
            [16.450121642083047, 4.1876757004798275],
            [16.452025220835793, 4.182425400125703],
            [16.459621593188338, 4.1770099284473705],
            [16.46371320237279, 4.1767705576698795],
            [16.46474952595145, 4.1718344201609625],
            [16.46247215599035, 4.165602474225788],
            [16.462083984301668, 4.158969629840488],
            [16.466957271201622, 4.16076488317224],
            [16.46869464151758, 4.1684001783833855],
            [16.474764582722138, 4.17009201442453],
            [16.482163692796163, 4.1678848938949695],
            [16.488202523646624, 4.162369241974984],
            [16.494716754632382, 4.162338211318639],
            [16.49733212505637, 4.159017256803368],
            [16.501673318184334, 4.161762657142231],
            [16.50599092750134, 4.162735739300251],
            [16.509767716481605, 4.161095417935216],
            [16.516647117307137, 4.165168276519228],
            [16.521536675189598, 4.166364340788324],
            [16.525321010422285, 4.1638676510268535],
            [16.527595513783112, 4.157522393312869],
            [16.534155940468867, 4.160916305249478],
            [16.54537352979106, 4.1584718547731985],
            [16.5532133673327, 4.161792186847277],
            [16.558534820966873, 4.1589363355103774],
            [16.564220473673874, 4.161116796979505],
            [16.569545622978943, 4.157661577209172],
            [16.570227159141186, 4.154001455463016],
            [16.573068602420776, 4.151511069187182],
            [16.570703509832867, 4.146445640183863],
            [16.571627848132863, 4.142574287698661],
            [16.58072634792852, 4.143818586391416],
            [16.586105607504663, 4.141643467408901],
            [16.58485796464602, 4.137021424682964],
            [16.588086183571544, 4.131505698731129],
            [16.588917966172335, 4.124015183060905],
            [16.591746121697405, 4.121888452807004],
            [16.59301678723937, 4.106322188202947],
            [16.591625572920414, 4.097394494785928],
            [16.589193699514343, 4.094159058946805],
            [16.59059916178164, 4.09055163862125],
            [16.59338797594699, 4.089237409972199],
            [16.596737431699147, 4.083608667310033],
            [16.605066488890657, 4.084038691551172],
            [16.609767744573308, 4.079774243126483],
            [16.610468456610963, 4.077341644266803],
            [16.605761484973147, 4.074979875338005],
            [16.608424931872552, 4.072181748380559],
            [16.608989230573048, 4.066252570382957],
            [16.602740274381272, 4.065394279427703],
            [16.600131695316353, 4.068271468368085],
            [16.596299114692744, 4.065536049117582],
            [16.593394198027017, 4.066037647315642],
            [16.592124982642304, 4.071100956731038],
            [16.5847050328072, 4.0678577640118165],
            [16.577625378321294, 4.067322364098906],
            [16.57355774968847, 4.064150796403996],
            [16.572570391133738, 4.068416130693951],
            [16.56628947284329, 4.064644757836431],
            [16.561633696809608, 4.063682878036119],
            [16.56071809103787, 4.0565825945039355],
            [16.56134489130442, 4.046523411510451],
            [16.56278843218835, 4.045584168752353],
            [16.563263843499694, 4.0373298840176055],
            [16.56598697234705, 4.033241772061603],
            [16.5668574617157, 4.028312954651206],
            [16.56998336681555, 4.026810868688092],
            [16.579984120400123, 4.02516342016514],
            [16.583427521456585, 4.0201693108758985],
            [16.57969774662092, 4.01904541210225],
            [16.578881816090615, 4.010346884872931],
            [16.5819903598298, 3.9906996548889406],
            [16.578883950903588, 3.987487596117439],
            [16.582252476867843, 3.981959032366958],
            [16.579683044915456, 3.9724029686382223],
            [16.575672776736237, 3.972116525534274],
            [16.571690287192684, 3.9690885598789327],
            [16.57196473416842, 3.964834037218266],
            [16.56701466873953, 3.9558622392994964],
            [16.56410761589367, 3.9546047584612594],
            [16.56323528944274, 3.9482138498979786],
            [16.56633092069949, 3.9357137837713596],
            [16.563529734914173, 3.931296881281088],
            [16.566398466248664, 3.926333007881136],
            [16.565535373582414, 3.922114955104081],
            [16.566911254202207, 3.9188541393900564],
            [16.564205175491498, 3.91492296528483],
            [16.57880096999219, 3.912271325564741],
            [16.57836216047767, 3.9082584108175857],
            [16.574539545214513, 3.9058772019923014],
            [16.575054187022218, 3.89993115335989],
            [16.57082738662612, 3.898448387315158],
            [16.57202171175448, 3.8948376583880537],
            [16.573620253982668, 3.8899806529955314],
            [16.5675476747572, 3.886721834601579],
            [16.570010157811044, 3.8844615519240264],
            [16.56629736569236, 3.8778696126473196],
            [16.561327934176816, 3.877647773942229],
            [16.562927376987233, 3.8708468610473585],
            [16.559381403712116, 3.868765238984045],
            [16.554935349098606, 3.8686895568049326],
            [16.55192339048041, 3.863120769480141],
            [16.551864389828836, 3.85978657274427],
            [16.548448982272095, 3.85858682381442],
            [16.547546200805144, 3.853995308557057],
            [16.542434071567076, 3.8502172250623037],
            [16.536841344221273, 3.8391363535355314],
            [16.533651362460486, 3.834406653006178],
            [16.525642484594083, 3.8281185518796876],
            [16.52718813250726, 3.8225646175506465],
            [16.52653589012212, 3.816644174229148],
            [16.52164771465059, 3.8149161977871215],
            [16.516594253990224, 3.8079938676562537],
            [16.51326819815325, 3.8086552997065857],
            [16.511973190977184, 3.80542755641027],
            [16.50605126730146, 3.803012925179116],
            [16.501741644793842, 3.7978709971102336],
            [16.499038192783726, 3.7978510324043118],
            [16.49563293776662, 3.793767285162111],
            [16.493522636823283, 3.7941233633006255],
            [16.492183781826693, 3.7865383051383894],
            [16.488917770757165, 3.7826697870218826],
            [16.481575453066434, 3.780565812345638],
            [16.478787606540482, 3.7831256529930246],
            [16.473423752898984, 3.794719303388596],
            [16.472719731904746, 3.7990488831990383],
            [16.474930121191637, 3.8012070346515268],
            [16.470546174316425, 3.8099724901216656],
            [16.47021659074167, 3.8142969336326487],
            [16.47162513168881, 3.8195745100728304],
            [16.47737593977199, 3.8267767458175963],
            [16.476704152046867, 3.8330506858870392],
            [16.471975452731385, 3.8373713724642267],
            [16.465963876095568, 3.839119063549574],
            [16.466361972403156, 3.8433891958189723],
            [16.459779802830877, 3.8483941293293817],
            [16.45930940015454, 3.85533023265579],
            [16.450198672762237, 3.860766593568501],
            [16.443715679568037, 3.859202621857002],
            [16.443827730603928, 3.8626044683363645],
            [16.440508358519544, 3.872228460477291],
            [16.435923871444956, 3.880325650512145],
            [16.43326195672561, 3.881840705428516],
            [16.42283874166788, 3.876309907609685],
            [16.317379965521905, 3.815740146186134],
            [16.30836430184332, 3.8158467957592],
            [16.302274134850858, 3.819416244171575],
            [16.294831568217333, 3.8225904828790163],
            [16.280479604816662, 3.8244125850023303],
            [16.262900543183516, 3.8248585922132152],
            [16.25931038478972, 3.8259548891159927],
            [16.25206023436881, 3.823233875276246],
            [16.24519378059976, 3.823485494851453],
            [16.240301072225623, 3.8218406394198476],
            [16.237299448277362, 3.822919339346655],
            [16.223253509650636, 3.832074677911629],
            [16.22191809401454, 3.8344174643197135],
            [16.18192780552131, 3.855464303203542],
            [16.185261353842773, 3.860045812926191],
            [16.18801787447882, 3.8599109936990854],
            [16.192347699516386, 3.8650249654573807],
            [16.196647131911234, 3.8681579389191216],
            [16.1971179868475, 3.8748107569504375],
            [16.201629010395276, 3.8740366742739596],
            [16.203858999978337, 3.8773975469770114],
            [16.207233053052196, 3.8781354465420455],
            [16.208246081003647, 3.8852007914712257],
            [16.211077919482708, 3.8864447964724143],
            [16.214687471058877, 3.8983924915913173],
            [16.217314042645853, 3.902446060888006],
            [16.215787733930387, 3.9056788603004704],
            [16.217832530168277, 3.9095618188744687],
            [16.223227692484556, 3.9155588793990734],
            [16.221333779810088, 3.9193283918245028],
            [16.21768410513449, 3.9216920793648478],
            [16.2186416797083, 3.927631892033563],
            [16.223204827246906, 3.930282233471077],
            [16.22552477745555, 3.9341658638643153],
            [16.2247668532514, 3.9399035036106134],
            [16.2286290547707, 3.941658216241308],
            [16.22927442003184, 3.944559684365455],
            [16.22338959797306, 3.949164166517315],
            [16.223676059688167, 3.9560291675409656],
            [16.22169144718457, 3.961773766276697],
            [16.223020785729407, 3.96588200063051],
            [16.2308334387551, 3.9726996272947366],
            [16.230537174997053, 3.978567204111857],
            [16.238957570746322, 3.9896778662387122],
            [16.242555030939315, 3.9962605594438956]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.54456103773812, "lat": 40.86191874794739 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34027"],
        "coty_name": ["Morris"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morris County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00882231"
      },
      "bbox": [
        16.18192780552131, 3.780565812345638, 16.610468456610963,
        4.212075418634267
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-7.7509823059886624, -2.4292454776997143],
              [-7.752701212132685, -2.4457667456777896],
              [-7.75313572827632, -2.44205158737426],
              [-7.762062003642839, -2.437097897696036],
              [-7.76527903659064, -2.4314838665675804],
              [-7.769352063728156, -2.4303133023791554],
              [-7.773859573503014, -2.4268742942341897],
              [-7.7509823059886624, -2.4292454776997143]
            ]
          ],
          [
            [
              [-8.832674344848705, -2.157493817827975],
              [-8.821530888870457, -2.0692564357491925],
              [-8.814965474310794, -2.0254087946307093],
              [-8.80387035323113, -1.937938550157841],
              [-8.761900685657569, -1.9429941605113488],
              [-8.7480358633071, -1.9457462726749113],
              [-8.686408709310895, -1.9545102249239945],
              [-8.63491365394008, -1.9603110850075],
              [-8.55085606531028, -1.9738517324920384],
              [-8.510470881668928, -1.9766963665387172],
              [-8.35147420855877, -1.9954130973252608],
              [-8.259325754198606, -2.0061638909777604],
              [-8.217550435825954, -2.0109435504326103],
              [-8.229621276644004, -2.1100306617633438],
              [-8.232091689592684, -2.1315184927729978],
              [-8.242859341286946, -2.2289616282153135],
              [-8.235158247490903, -2.23022204440487],
              [-8.200877473485468, -2.2340830570784513],
              [-8.156964676977827, -2.2387520190099615],
              [-7.893707388407434, -2.266046689764184],
              [-7.848702033286018, -2.270811687322395],
              [-7.8414136656335085, -2.272579577253073],
              [-7.7994937397746025, -2.276369120867698],
              [-7.734207488673365, -2.2831985412100773],
              [-7.736503254898868, -2.3043924581405535],
              [-7.736850032757797, -2.31154753186694],
              [-7.738815108434473, -2.318310462482464],
              [-7.751709700293797, -2.3177860211725654],
              [-7.750936682516783, -2.3104833676861514],
              [-7.765423780837825, -2.3088497063459292],
              [-7.779671782436909, -2.30671682499955],
              [-7.7811355749005315, -2.321715508800478],
              [-7.794408126246505, -2.320179164207004],
              [-7.793971090004584, -2.326432734260547],
              [-7.808802609235754, -2.3254860301527738],
              [-7.821537959774407, -2.323254961077635],
              [-7.850299159957545, -2.3199837889092536],
              [-7.849264749208387, -2.312767650131097],
              [-7.8601279585217165, -2.3114167407313615],
              [-7.861537501549039, -2.322431475167353],
              [-7.8748340253653355, -2.444005938569827],
              [-7.888936828135168, -2.4424810554347673],
              [-7.890164125897503, -2.4445533007155436],
              [-7.89052647237849, -2.451783145157337],
              [-7.885902767568864, -2.4599646433026003],
              [-7.877920209965645, -2.4641834201014663],
              [-7.874595065521769, -2.46360303119059],
              [-7.863222574146423, -2.465376422746845],
              [-7.853086915171874, -2.4613258180346285],
              [-7.846724837974821, -2.4636852123617974],
              [-7.843090010986285, -2.4686061092921494],
              [-7.84206647645962, -2.4591780665464467],
              [-7.833112113069823, -2.464404877208949],
              [-7.828334701173386, -2.469204265374879],
              [-7.817426205205192, -2.47126993961032],
              [-7.798088894574757, -2.4833547603754274],
              [-7.785284000433771, -2.4901780698515217],
              [-7.773392670201546, -2.504050288814676],
              [-7.769529801033988, -2.514337563944757],
              [-7.7678675850542165, -2.51462601136727],
              [-7.766572015314011, -2.5303662658304598],
              [-7.763546804772378, -2.5291278847401792],
              [-7.7693924358257345, -2.585582084389546],
              [-7.774528441292839, -2.632291120857467],
              [-7.773250690176331, -2.6324293036310937],
              [-7.782813690893431, -2.720741225259872],
              [-7.795698821317636, -2.840058430311557],
              [-7.796166495488696, -2.842447487183863],
              [-7.811308203740862, -2.9813894014146274],
              [-7.808667649706163, -2.9819139622012485],
              [-7.814502200130521, -3.0355886988239926],
              [-7.817150794219156, -3.0708453552442134],
              [-7.916014974254221, -3.058326372038422],
              [-7.9573998448635805, -3.0537670093825198],
              [-7.990128797199758, -3.0496419581454757],
              [-8.106936440960137, -3.0367465108726366],
              [-8.118983969477759, -3.0415757321216232],
              [-8.121522186379423, -3.04376762221373],
              [-8.136982003403483, -3.048496580264832],
              [-8.141754168583871, -3.0493453618357846],
              [-8.140573485534958, -3.0448334351978317],
              [-8.145178167897429, -3.0396330238266684],
              [-8.142938136245814, -3.0360865087649325],
              [-8.150125294072247, -3.0318807872815485],
              [-8.23454161743794, -3.022226082252847],
              [-8.307014303670645, -3.0139624851315534],
              [-8.394592803625152, -3.0034755739775965],
              [-8.504274798322932, -2.9905959883807802],
              [-8.533405662201947, -2.9862476822261925],
              [-8.583663462697631, -2.9802823826440745],
              [-8.606916363518549, -2.8902326288597293],
              [-8.66352261076533, -2.8833122057267913],
              [-8.65064999538895, -2.7693171086651542],
              [-8.6473270685888, -2.7701959505519467],
              [-8.635905154958335, -2.663313580838731],
              [-8.629423457894758, -2.6054516938844454],
              [-8.617580117963492, -2.5059926147235263],
              [-8.610957799409338, -2.448746523280686],
              [-8.602286823623224, -2.37695654102294],
              [-8.593478112578925, -2.303192643781325],
              [-8.579955154509108, -2.1898723053659266],
              [-8.676628600714464, -2.1773669258180024],
              [-8.777385094373411, -2.1642983709627006],
              [-8.832674344848705, -2.157493817827975]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.86592127958284,
          "lat": 35.68859358442044
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35043"],
        "coty_name": ["Sandoval"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sandoval County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00929113"
      },
      "bbox": [
        -8.832674344848705, -3.0708453552442134, -7.734207488673365,
        -1.937938550157841
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.509284182555737, -3.2549832955360825],
            [-8.485499298745323, -3.3461826756471393],
            [-8.276766361532365, -3.3701607662974675],
            [-8.240057135724559, -3.374232705218484],
            [-8.237572889962044, -3.36948338502118],
            [-8.233820016523088, -3.3653049049529953],
            [-8.223807487935202, -3.360591068874177],
            [-8.217281061030421, -3.3494728323312692],
            [-8.207955606937187, -3.3411882723746738],
            [-8.000807805457494, -3.367138627607711],
            [-7.9965391254583675, -3.3691596339701575],
            [-7.996077172358619, -3.373086428044604],
            [-7.992839085127319, -3.379278997009546],
            [-7.990412034447168, -3.3787880414241522],
            [-7.9878225879537474, -3.3824074771917427],
            [-7.990150709497175, -3.401881331412487],
            [-8.032278816364402, -3.3973029856172032],
            [-8.042651394732566, -3.484255658523649],
            [-8.048485279402232, -3.522026673632035],
            [-8.052683791179588, -3.5609462570457326],
            [-8.056258538124276, -3.5964054136045607],
            [-8.062099494273141, -3.659105126142032],
            [-8.067214814644482, -3.6585051625816662],
            [-8.075750218149635, -3.74582904107884],
            [-8.032714433704168, -3.7500627508418884],
            [-8.035127710190993, -3.7645337010552478],
            [-8.0356478738593, -3.772165694381859],
            [-8.041794234308602, -3.8320733328520644],
            [-8.059788211621793, -3.832326730966771],
            [-8.074118399812278, -3.831181752415441],
            [-8.111186360385226, -3.8068993370218993],
            [-8.158093801561787, -3.784595464482298],
            [-8.317035923483758, -3.7086466308517623],
            [-8.404266596554324, -3.6498846499068986],
            [-8.421888328616179, -3.6468504051923123],
            [-8.515788503098154, -3.6368779660007977],
            [-8.663257207995391, -3.6204289253863453],
            [-8.659879450138556, -3.5903929835439574],
            [-8.661833647792696, -3.59015188310652],
            [-8.640326573733855, -3.4161290865961123],
            [-8.636706931100214, -3.387677553978435],
            [-8.629799696844387, -3.329602197729131],
            [-8.62606971685541, -3.3004219142712405],
            [-8.61926105439152, -3.241673314663548],
            [-8.509284182555737, -3.2549832955360825]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.80901135996648,
          "lat": 34.71548552755404
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35061"],
        "coty_name": ["Valencia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Valencia County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00933052"
      },
      "bbox": [
        -8.663257207995391, -3.832326730966771, -7.9878225879537474,
        -3.241673314663548
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.359782782205473, 4.997664099478215],
            [14.358183559999684, 5.006494603930349],
            [14.409244948497356, 5.02046026259249],
            [14.44465193781978, 5.030502065298791],
            [14.47294416862811, 5.036911852459789],
            [14.515039329617267, 5.045117575405644],
            [14.523114796369521, 5.046482731205818],
            [14.53326030993024, 5.001802927474816],
            [14.566977272698951, 5.009003201718102],
            [14.569222200720851, 4.99855302475283],
            [14.596183955180923, 5.0045191565003515],
            [14.601293201665127, 5.001091702483281],
            [14.614611456063319, 5.01913728846971],
            [14.607806870497736, 5.052748225774248],
            [14.636511831964386, 5.0583978860226395],
            [14.666285723252136, 5.063695240220306],
            [14.674619104890807, 5.032969902926589],
            [14.693481049309758, 4.939887377594468],
            [14.674472121494675, 4.936478170959741],
            [14.674550097328474, 4.933094871215801],
            [14.678403424802807, 4.929680275053917],
            [14.682303600867035, 4.920751903965272],
            [14.681911513228622, 4.912748627491838],
            [14.685142785995884, 4.908736062026721],
            [14.688741640360012, 4.895598045881815],
            [14.698847943700889, 4.863348033398048],
            [14.711114777742742, 4.8372967332857995],
            [14.705446842803582, 4.792847300553339],
            [14.709267256040356, 4.788528594093062],
            [14.709964142174817, 4.784194309446115],
            [14.651731891826405, 4.77284264301022],
            [14.5709215248881, 4.7571711980119895],
            [14.447207549225311, 4.732055321192163],
            [14.442690487561059, 4.731037039509437],
            [14.414763121055296, 4.724970593241774],
            [14.410028936903972, 4.747498791061341],
            [14.391421726709803, 4.840221396249367],
            [14.386081888360556, 4.865912804761129],
            [14.370548746619466, 4.943642636045401],
            [14.364889408889207, 4.969613520204926],
            [14.359782782205473, 4.997664099478215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.76004036911371, "lat": 42.14127110454362 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36015"],
        "coty_name": ["Chemung"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chemung County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00974106"
      },
      "bbox": [
        14.358183559999684, 4.724970593241774, 14.711114777742742,
        5.063695240220306
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.587161196870685, 5.330000780016239],
            [16.590165862083968, 5.343655693960848],
            [16.590468011581073, 5.355941831925746],
            [16.592349304391348, 5.3617479505365235],
            [16.590935513961156, 5.370322996686195],
            [16.59151074366184, 5.373904766465742],
            [16.596748791398447, 5.376198505122108],
            [16.60207055140715, 5.3815516815074735],
            [16.607879356163526, 5.391727596656784],
            [16.61197190961701, 5.4019179903563765],
            [16.611873657994114, 5.420670362888055],
            [16.6080248432218, 5.4310639201153075],
            [16.608246506969817, 5.441144699176946],
            [16.614537440013248, 5.454718220703151],
            [16.617817981892987, 5.459203477292796],
            [16.622327902467326, 5.460759610119102],
            [16.626790831614343, 5.466603730978466],
            [16.63488294880601, 5.471456372577005],
            [16.63970099357312, 5.482268618689156],
            [16.6416687254617, 5.489728482901488],
            [16.642134521290902, 5.500792198343502],
            [16.640037020825748, 5.513122860448185],
            [16.63880084683501, 5.5259837192334285],
            [16.632772973108963, 5.539382130076683],
            [16.632978827754698, 5.544464432935198],
            [16.62166166509111, 5.5683908847961705],
            [16.617948520173304, 5.573052968121678],
            [16.618721562001596, 5.577399754748264],
            [16.615494264564358, 5.587947856698912],
            [16.612782377660764, 5.591290811967553],
            [16.611410179749562, 5.602110999147124],
            [16.612690535110225, 5.610996201336059],
            [16.61218562505898, 5.624336046726587],
            [16.6132042654076, 5.647874897741311],
            [16.611446779964314, 5.66197811460293],
            [16.609336122823166, 5.669123559359721],
            [16.604862207027153, 5.674840795092012],
            [16.603515581953406, 5.679919542022025],
            [16.59957107136973, 5.679951572363804],
            [16.631266945773522, 5.692085860992681],
            [16.72061633248091, 5.727050198507847],
            [16.75740337318361, 5.74218899311783],
            [16.79466903002889, 5.757916109453575],
            [16.877757795523692, 5.791179558342979],
            [16.895985226551087, 5.798022559834962],
            [16.89403914848875, 5.7145069684595695],
            [16.891883746094003, 5.624307759720129],
            [16.889891681911838, 5.542942512935105],
            [16.88755195109097, 5.449654790706349],
            [16.88521080237491, 5.358602322746027],
            [16.901920907041287, 5.324884086481278],
            [16.88426398197324, 5.320944540667291],
            [16.890391324787277, 5.285316346633456],
            [16.897192406292795, 5.249790323298881],
            [16.875509397025652, 5.248486403215784],
            [16.810574604830663, 5.246634364256272],
            [16.787761038947597, 5.246427001136423],
            [16.758791788811276, 5.245094063644191],
            [16.722481139087428, 5.255018315351156],
            [16.69409872774238, 5.2620225628704675],
            [16.671954803761686, 5.267014427440382],
            [16.632380251069307, 5.276691099454491],
            [16.600293369588393, 5.283964241467205],
            [16.594392761867667, 5.283909088356255],
            [16.594341032273714, 5.279329985910206],
            [16.584821050770508, 5.279461705598304],
            [16.58447637326346, 5.296526231274865],
            [16.583430652452865, 5.311330275032975],
            [16.585212339932667, 5.323405028815574],
            [16.587161196870685, 5.330000780016239]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.6318140440438, "lat": 42.250093315025325 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36021"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00974109"
      },
      "bbox": [
        16.583430652452865, 5.245094063644191, 16.901920907041287,
        5.798022559834962
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.47916579142866, 7.068061295137126],
            [15.550148463194862, 7.093297657258839],
            [15.557727664958657, 7.095685415443521],
            [15.618275119023725, 7.118089169529229],
            [15.695307187797354, 7.146744405761555],
            [15.797329420211737, 7.182670959468729],
            [15.804325329668723, 7.184977662653476],
            [15.867077901946702, 7.207907183312214],
            [15.908773991707877, 7.094355742807845],
            [15.91941739240763, 7.065862719627167],
            [15.873074863680792, 7.009585360790517],
            [15.873493840501398, 7.009113165372941],
            [15.928545808864618, 6.964631165975252],
            [15.931716166930642, 6.9617782334966885],
            [15.98518203329791, 6.918480345128881],
            [15.986749927441252, 6.919835313165351],
            [15.990659857232147, 6.929411319773235],
            [15.99896396130763, 6.935326932131094],
            [16.009107864146223, 6.937210126478738],
            [16.01286703004567, 6.941026227903408],
            [16.017302669154212, 6.941308730757673],
            [16.01967105916656, 6.944495342223398],
            [16.02614653557508, 6.947162179427468],
            [16.032088379911478, 6.946405627445944],
            [16.035610512621687, 6.941942444961847],
            [16.036144375249528, 6.937310734600833],
            [16.0400944274435, 6.938043738897365],
            [16.042876689542975, 6.936093639739527],
            [16.04872256924638, 6.93501896080259],
            [16.053603432847748, 6.932477347171487],
            [16.058833896910013, 6.932855163743841],
            [16.063950166229354, 6.9308797609646575],
            [16.068108198865904, 6.932804263511991],
            [16.07209883885876, 6.931969830964032],
            [16.074006704876254, 6.935679227791875],
            [16.076986424754512, 6.937077960472829],
            [16.081921563147908, 6.934617267272557],
            [16.093376282344174, 6.931982878787553],
            [16.105155420511366, 6.931502355113318],
            [16.105547436970664, 6.9261004222353515],
            [16.104088825430885, 6.9229543035192425],
            [16.109280721018788, 6.916966734292169],
            [16.106203355432903, 6.905112250721574],
            [16.106409040001086, 6.900159894078598],
            [16.108385372143957, 6.890983677683214],
            [16.10817789997375, 6.881950860024218],
            [16.110106530904886, 6.879582551350165],
            [16.003306085378235, 6.838560761245471],
            [16.026864985167606, 6.772436939530408],
            [16.0732762653822, 6.641910120436285],
            [16.095718801384425, 6.578393243483412],
            [16.12323781463807, 6.500419503475603],
            [16.16422516845173, 6.389382379312706],
            [16.106234248401748, 6.369951137077144],
            [16.11468267353586, 6.344457086667319],
            [16.044560962282777, 6.321348522704189],
            [16.035609555653902, 6.34692449521249],
            [15.944847880374473, 6.317082710710391],
            [15.892621685916602, 6.300859806099042],
            [15.891575985383978, 6.300003844057372],
            [15.821769614216935, 6.315336191651569],
            [15.751958620680766, 6.330656122389028],
            [15.7528724638382, 6.327932857865078],
            [15.72518096941418, 6.334075107275295],
            [15.631429169763248, 6.3555272100315126],
            [15.642900951639506, 6.412046689540496],
            [15.663751380370387, 6.513153354091536],
            [15.611081572432063, 6.671878279454693],
            [15.580767370138602, 6.763183125950146],
            [15.572652152931534, 6.787095130437727],
            [15.538942706119668, 6.8889253624865345],
            [15.47916579142866, 7.068061295137126]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.49737150362661, "lat": 43.66112023560453 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36041"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00974119"
      },
      "bbox": [
        15.47916579142866, 6.300003844057372, 16.16422516845173,
        7.207907183312214
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.03360353540669, 7.120088913157128],
            [15.123383962341002, 7.088692649723848],
            [15.141545226357474, 7.081597988741002],
            [15.170022777280469, 7.072594348523854],
            [15.190784009364616, 7.06495131016281],
            [15.254159242959522, 7.045198655510044],
            [15.254422239570161, 7.044373236095522],
            [15.268882567022326, 6.998937877117141],
            [15.286465406877742, 6.942078257468788],
            [15.325355205479921, 6.819914761393595],
            [15.350473883172823, 6.740462649026871],
            [15.387340676244795, 6.623673634138524],
            [15.399591526090475, 6.585300588118644],
            [15.325924744655799, 6.5114743243029976],
            [15.275489915560279, 6.4616386510826915],
            [15.229281043680324, 6.415657717629199],
            [15.143967234137596, 6.32961801824359],
            [15.125785976219287, 6.330505290965679],
            [15.101913673907159, 6.333808144395562],
            [15.09096127259783, 6.334968162198952],
            [15.063855579057186, 6.337069584778795],
            [14.975715764499784, 6.34495996291049],
            [14.970207139692485, 6.36635972609322],
            [14.934140238652764, 6.498718493114353],
            [14.926275991406909, 6.524348312049696],
            [14.91710143864383, 6.555362487145312],
            [14.88667769634769, 6.6508108328747335],
            [14.841051789453742, 6.644297366426159],
            [14.828989770326142, 6.735591208388769],
            [14.840433585063515, 6.73718905765121],
            [14.887505808776154, 6.7429137589326915],
            [14.926003872379999, 6.791463324621386],
            [14.966437992158326, 6.843724424491916],
            [14.976440362056758, 6.856450442993764],
            [14.981818313441893, 6.852823713445206],
            [14.993613422398301, 6.857366021169172],
            [14.996492407210578, 6.854502438024969],
            [15.019550383820595, 6.86241941210254],
            [15.005563930733418, 6.899097076343053],
            [15.041579530914882, 6.910146011895498],
            [15.038134798585412, 6.918198992254337],
            [15.034229665873477, 6.935288677036655],
            [15.03754005893221, 6.94652134711015],
            [15.028848831182042, 6.949191581018291],
            [15.03756681957226, 6.974101087710735],
            [14.98746441690256, 6.991779547855515],
            [14.993473976522957, 7.009600040015009],
            [15.03360353540669, 7.120088913157128]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.44865949090618, "lat": 43.78504823583984 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36049"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00974123"
      },
      "bbox": [
        14.828989770326142, 6.32961801824359, 15.399591526090475,
        7.120088913157128
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.265923571926416, -3.208880675624153],
            [14.268178893442194, -3.2044853890239136],
            [14.268482481338822, -3.1992149826246727],
            [14.273215677621812, -3.1998423821280633],
            [14.275683672052782, -3.1932744615170963],
            [14.277995204501497, -3.191032279397609],
            [14.284726209156917, -3.1938333367835625],
            [14.290027481092553, -3.1900861187493694],
            [14.288055208226131, -3.184151365383859],
            [14.291479289988551, -3.1804893091489665],
            [14.288784786145166, -3.1772809984442305],
            [14.289880715130543, -3.1732968255634986],
            [14.288682598283472, -3.1646576629209378],
            [14.292352941113196, -3.1599558363383617],
            [14.291891164616459, -3.1556098761459586],
            [14.293776367753201, -3.150153621503325],
            [14.30513227692196, -3.1477724132918747],
            [14.305078211024226, -3.1445114935963834],
            [14.31055904256503, -3.135193171807313],
            [14.306776112349862, -3.1280047472404626],
            [14.300798630539783, -3.1197352112171552],
            [14.303317672727728, -3.1158256958279646],
            [14.306108465791066, -3.1149169766367644],
            [14.308182256013614, -3.1073931378731214],
            [14.3106984048296, -3.10542910629788],
            [14.318661585750915, -3.103440339610265],
            [14.32417490390331, -3.10331641215497],
            [14.33145367387411, -3.096839788336525],
            [14.330534806044886, -3.091302269060493],
            [14.324942399376086, -3.0759612711121305],
            [14.326460158467658, -3.0737738711979796],
            [14.323647999413673, -3.067118768616181],
            [14.326475167052921, -3.0630331710685215],
            [14.326182048434083, -3.0590065735309033],
            [14.329057109381166, -3.0560629394029584],
            [14.329943086164308, -3.0505400436307846],
            [14.332981404779197, -3.049574772226688],
            [14.335381229194823, -3.0434952444656687],
            [14.34232909075217, -3.039142150987298],
            [14.345207792454463, -3.03879244418022],
            [14.352314470668297, -3.034013545858135],
            [14.356055775533731, -3.035586961120411],
            [14.362523546767777, -3.0339481947946005],
            [14.358462469170037, -3.0292102617520507],
            [14.36389249957315, -3.027682776989939],
            [14.369842302024015, -3.030179700802691],
            [14.369509247884658, -3.0235968572987675],
            [14.374741542984024, -3.0246735851419313],
            [14.37802000802063, -3.022093091126565],
            [14.38282331505766, -3.01268678404767],
            [14.387345985157605, -3.0092113637824816],
            [14.387111911540241, -3.0069884897131995],
            [14.395415258752234, -2.9981741304317207],
            [14.395552024198931, -2.9957169151758305],
            [14.400059158664902, -2.994928324522579],
            [14.403542249958042, -2.997266880244864],
            [14.406193215881448, -3.00438824086856],
            [14.412456332831983, -3.0038983450224603],
            [14.417933930027827, -3.0079073083478782],
            [14.42386686280195, -3.0081776861872775],
            [14.430628903709652, -3.012043806604891],
            [14.434908317085508, -3.012098199933552],
            [14.486420116731392, -2.999398912699697],
            [14.541439521785378, -2.9856769856683547],
            [14.557945265577796, -2.98122905322342],
            [14.56027640883231, -2.9810495571937343],
            [14.562156805662504, -2.9858144417693175],
            [14.565924720211854, -2.9880992861193096],
            [14.56982114438897, -2.988219787523568],
            [14.572357813347988, -2.993345702218447],
            [14.576725452000062, -2.987216452456665],
            [14.578611856226187, -2.9868205348905477],
            [14.58898122320092, -2.9912876702049225],
            [14.600836935004873, -2.9937858977938556],
            [14.60731164542507, -2.9970412514090783],
            [14.616831250759475, -2.999801938546198],
            [14.6274919714955, -3.0082023437423207],
            [14.637897145486534, -3.008334775034314],
            [14.661648513453105, -3.012345258403632],
            [14.756077896674983, -3.0391973078401318],
            [14.776244456500276, -3.0347071086218214],
            [14.796271278461976, -3.038500709259991],
            [14.815555815346192, -3.033667365438136],
            [14.82101074442461, -3.031762331673812],
            [14.846616507312904, -3.0322648308705844],
            [14.848814987307657, -3.0309568455243343],
            [14.904232336468286, -2.9888003355088055],
            [14.90799718363109, -2.995842905813743],
            [14.911625568750662, -2.993395224564304],
            [14.914017297636546, -2.994644380546036],
            [14.91508292159957, -3.0004904363716522],
            [14.922188419818474, -3.0037322787068317],
            [14.924600942980495, -3.0088331825968093],
            [14.928513562988478, -3.0093747261484665],
            [14.92896020739643, -3.005828789496438],
            [14.934278234130323, -3.0097279828070884],
            [14.945697320536814, -3.011818699239544],
            [14.947290530761537, -3.013860329363497],
            [14.946805765784582, -3.018525174857772],
            [14.94892887027143, -3.0228811775803504],
            [14.955967802257492, -3.0263173963168013],
            [14.963847164352947, -3.025472550811639],
            [14.974314445622712, -3.0208233996678144],
            [14.978193940679448, -3.024063368662966],
            [14.982973617639455, -3.017130140158855],
            [14.987606793348872, -3.016532323427761],
            [14.97052620212716, -3.0713521028413933],
            [14.942047325981402, -3.1626236509252954],
            [14.939677509860342, -3.169718974064385],
            [14.845299502539921, -3.1991437186776523],
            [14.848729429053346, -3.2064876403289815],
            [14.852904184846983, -3.2103410665581356],
            [14.852569099083496, -3.214894056336953],
            [14.84969272512311, -3.2150131972820124],
            [14.847956296074129, -3.21839021739114],
            [14.840021793215413, -3.2280163657261127],
            [14.839668524445898, -3.230583352714194],
            [14.835612669688627, -3.235056187411711],
            [14.835150411183115, -3.2387305911675544],
            [14.828574866840095, -3.249890590476133],
            [14.828200147790625, -3.253268939345984],
            [14.820154116306318, -3.265423910314933],
            [14.819610517284868, -3.2699287499554006],
            [14.814438434619971, -3.2715302795782946],
            [14.80647656307647, -3.27033490636465],
            [14.80155685117477, -3.26734308229412],
            [14.787201047522446, -3.266425523563891],
            [14.779628710566588, -3.2627273329498734],
            [14.773696572459077, -3.2638874608231143],
            [14.763715975364912, -3.2615369212105585],
            [14.761134239808905, -3.257894901672374],
            [14.756586443229239, -3.2575230524104044],
            [14.754041375593179, -3.254321264387018],
            [14.744443382414104, -3.2544569540803643],
            [14.73880106956917, -3.2588733737898647],
            [14.737385019385178, -3.2655980240351705],
            [14.733078464802471, -3.272165371477488],
            [14.726389223500941, -3.27442315340199],
            [14.724805206900054, -3.2816725135074565],
            [14.721046252234348, -3.2803211736042255],
            [14.718300500843618, -3.2833507623466063],
            [14.71962518636775, -3.2860572718417855],
            [14.719399576032764, -3.2919972401879654],
            [14.723086043968651, -3.296746083531169],
            [14.723690021679836, -3.302358141226064],
            [14.718775741696694, -3.3045064616711413],
            [14.71968059862783, -3.309254280853932],
            [14.715653886569585, -3.313509245517237],
            [14.721551575951123, -3.317825722239146],
            [14.718919688665306, -3.3231082634301248],
            [14.725394950179664, -3.326971619239904],
            [14.72529714737798, -3.3336792882264725],
            [14.719669297735113, -3.3346764257662627],
            [14.716084807676337, -3.33870266407874],
            [14.720154465643292, -3.3460743339424464],
            [14.71696720449646, -3.348656866136868],
            [14.71653892646846, -3.353310506644834],
            [14.718955900961726, -3.3550061639405517],
            [14.723348827885449, -3.3530790523252585],
            [14.724948140347044, -3.357385632277005],
            [14.724837343272519, -3.362639322907007],
            [14.72179815906168, -3.363634213937886],
            [14.723670982922098, -3.370082502309339],
            [14.721448732675265, -3.371357678646393],
            [14.721572142533159, -3.3757104355053906],
            [14.714568759185264, -3.3785787896666855],
            [14.710233914984569, -3.3782067973754133],
            [14.706159840706727, -3.3850578345244733],
            [14.7076321201468, -3.3907893559803086],
            [14.71078980086657, -3.394525122586119],
            [14.705862067287617, -3.3980280077351406],
            [14.70845753344136, -3.3997850802628564],
            [14.705062722539152, -3.403333583899463],
            [14.70326033730939, -3.4074681449824604],
            [14.696484064587052, -3.4077941428133007],
            [14.693519191326233, -3.4118158573566735],
            [14.682751230693688, -3.4151447557180497],
            [14.682454748179444, -3.419138525686815],
            [14.680092152947335, -3.420980058460794],
            [14.676591852134207, -3.4199629418149042],
            [14.672400660593121, -3.4253706751080766],
            [14.666058187003745, -3.431598123406398],
            [14.667929226701803, -3.438146676592209],
            [14.674429107377833, -3.4440787614975057],
            [14.677741909541936, -3.449199256805557],
            [14.679211118882112, -3.453690184592752],
            [14.68299577227716, -3.45941683202871],
            [14.682450414538538, -3.465805263036252],
            [14.677231500124579, -3.4711226644688984],
            [14.66798361800752, -3.4770000669671464],
            [14.670383918606175, -3.4817037730647082],
            [14.674347223222254, -3.483437865825877],
            [14.672478576413333, -3.48798544001064],
            [14.67405309890977, -3.491898311476285],
            [14.670231636862276, -3.498267431330278],
            [14.658519756935371, -3.4900128609966816],
            [14.61960162988239, -3.4616365700032286],
            [14.610605111890871, -3.4556559946507774],
            [14.555437239370146, -3.4161613667866058],
            [14.454185781983266, -3.3434657031410446],
            [14.40914318970246, -3.3113504414339348],
            [14.338171724861073, -3.2606397951284247],
            [14.265923571926416, -3.208880675624153]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.6550163500123, "lat": 34.26566451494789 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37047"],
        "coty_name": ["Columbus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbus County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01026339"
      },
      "bbox": [
        14.265923571926416, -3.498267431330278, 14.987606793348872,
        -2.9810495571937343
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.769817590563056, -2.5210756525954814],
            [10.772050034416301, -2.5245235570773383],
            [10.77992020262596, -2.524896857698684],
            [10.787474629636417, -2.5234313590152366],
            [10.792544631780725, -2.530587939462383],
            [10.79200228719689, -2.535472048791799],
            [10.798427027012217, -2.537388705154707],
            [10.808453085377185, -2.5370899754519467],
            [10.81239651550535, -2.5412848465265445],
            [10.810631036082157, -2.546325340295743],
            [10.814473186479935, -2.550807524164156],
            [10.815491881867933, -2.565734000936477],
            [10.820178650458786, -2.566400402566783],
            [10.828976881632498, -2.5634488493659333],
            [10.837295589615195, -2.5634495475720853],
            [10.845840140630493, -2.564570083630075],
            [10.85343188270395, -2.5675196564368354],
            [10.85515669845075, -2.570835454659273],
            [10.85584026750212, -2.57650491887783],
            [10.864363037390689, -2.5761647597617574],
            [10.864485384747093, -2.582296413412225],
            [10.866167452350929, -2.5852414394025254],
            [10.865622502774206, -2.5890299114012456],
            [10.871513960516817, -2.593175672416282],
            [10.877335498082951, -2.5937254252233175],
            [10.882147900491583, -2.596521655759971],
            [10.885873712001603, -2.5951856818147414],
            [10.889257728386292, -2.599665308906376],
            [10.896900225292779, -2.6047414565488003],
            [10.89749646924609, -2.6115782328317887],
            [10.899394082727072, -2.61549815594355],
            [10.90025154456903, -2.6253416229122344],
            [10.912012746890035, -2.6307665364436015],
            [10.914444992766386, -2.6348416627803286],
            [10.920501319473358, -2.638580064849853],
            [10.923108453057539, -2.6368895309539515],
            [10.932341667321058, -2.63830072036833],
            [10.940419272735317, -2.6415635694587856],
            [10.950467156863867, -2.6528759032509854],
            [10.951562502444316, -2.6574626168911903],
            [10.959275711427322, -2.6615338174316165],
            [10.959554227247915, -2.6671586411011714],
            [10.964686590445748, -2.668808652327382],
            [10.971796114750836, -2.6775295166840967],
            [10.974061526110766, -2.686232212952229],
            [10.973008387154177, -2.6916691723238975],
            [10.974399420882275, -2.695620656976361],
            [10.981891995546464, -2.693471387415422],
            [10.985789023007587, -2.6973597495034354],
            [10.986649710514333, -2.702401514098065],
            [10.997278750203469, -2.7027700023422585],
            [11.001542100731013, -2.702206328403688],
            [11.006096196473788, -2.7039470565332846],
            [11.012746575099895, -2.713978349546192],
            [11.012852365903775, -2.722666452743731],
            [11.017030600219023, -2.734841773361657],
            [11.016908029486913, -2.7402277243962025],
            [11.014517251724016, -2.753746648612778],
            [11.016022465962243, -2.759960095531612],
            [11.013711661215082, -2.7654906611820373],
            [11.01522539473159, -2.769312469844128],
            [11.012743773015622, -2.7740385104745666],
            [11.012580804718219, -2.778007617340333],
            [11.010381436798923, -2.7821960412532944],
            [11.00255273984121, -2.7856563754937826],
            [10.996437091175522, -2.791823993739425],
            [10.992248825868119, -2.794646445344502],
            [10.993159051127257, -2.8045849461653374],
            [10.991327597959689, -2.8093257903043987],
            [10.988028730778327, -2.8115034101815626],
            [10.987771492561986, -2.8165437450595494],
            [10.9741915823715, -2.8254861858509956],
            [10.973141924148395, -2.828478212861461],
            [10.97550516531665, -2.8308877131418693],
            [10.976399838428232, -2.835416297081891],
            [10.97463247285679, -2.838786714347172],
            [10.981198724971955, -2.8431377206172446],
            [10.981527447674566, -2.8448142084024015],
            [10.96974431923784, -2.850786993409594],
            [10.969572602867336, -2.8546871828036116],
            [10.97255307395963, -2.8604074190672835],
            [10.977096019263387, -2.864211276338432],
            [10.981012639741598, -2.862600490161797],
            [10.984431556447328, -2.8640305404451887],
            [10.984718720478813, -2.8690818050789386],
            [10.98744351174476, -2.871640509630285],
            [10.990075939077185, -2.878537868395028],
            [10.98860265085697, -2.8817213421281935],
            [10.984395232902987, -2.8813802482892354],
            [10.9594441434928, -2.9210703076506306],
            [10.949182959901185, -2.9352970758924104],
            [10.948612991959019, -2.9383959380062836],
            [10.942765500320887, -2.9421751496403474],
            [10.944224072980633, -2.949604780905542],
            [10.941789875104048, -2.9542520349538517],
            [10.941853235052651, -2.958889633510518],
            [10.937774321424198, -2.966389886341791],
            [10.944488066498705, -2.9690341529274336],
            [10.947290388997851, -2.9677190547973384],
            [10.951370494566142, -2.970498808514433],
            [10.953048733357019, -2.9761055505006695],
            [10.969917711425035, -2.9798523679383138],
            [10.97309800789526, -2.9814237502579357],
            [10.978701098204478, -2.9875736615025903],
            [10.901950926572978, -3.0247827897753323],
            [10.900495883708173, -3.016349020033341],
            [10.895481742773969, -3.013453109850054],
            [10.891373613909455, -3.0139302794881857],
            [10.885784033807452, -3.0123980059155335],
            [10.884827087846983, -3.005302007989619],
            [10.882226977128221, -3.0035486406009637],
            [10.877973498947881, -2.9947612695333596],
            [10.871322404095853, -2.987478804406954],
            [10.86299820488129, -2.9769497228971695],
            [10.856885616954349, -2.9748951222388027],
            [10.84992202677682, -2.97564217758968],
            [10.843507510053694, -2.9725907268329435],
            [10.84437470818126, -2.968753739075795],
            [10.84186748105662, -2.963848616936154],
            [10.845631638615005, -2.962466886755438],
            [10.852067924157446, -2.956664233145456],
            [10.851610050678657, -2.9541728409446018],
            [10.859104274528434, -2.9520754501961095],
            [10.863448766387009, -2.952235292907016],
            [10.861259551003494, -2.945207409536553],
            [10.858694501976062, -2.941891209271088],
            [10.857883035984374, -2.936842301422352],
            [10.853342595948051, -2.932104748435235],
            [10.846897686868544, -2.9337168796612443],
            [10.840199894878495, -2.927867571716342],
            [10.836811696249042, -2.9282387057323755],
            [10.83184187312629, -2.9249885955442205],
            [10.82971699389395, -2.917874949701185],
            [10.826227783773628, -2.9157758768811854],
            [10.825328514864514, -2.909457676260363],
            [10.822362662077474, -2.9064488534559447],
            [10.820788093303223, -2.9009763447024115],
            [10.817041120021763, -2.899599053801502],
            [10.813717265518825, -2.89506878844976],
            [10.802928602045952, -2.8873925135999943],
            [10.796638884019172, -2.8795998941710073],
            [10.789714454427967, -2.8801310486639067],
            [10.78714678630278, -2.8739076715980674],
            [10.787447953815942, -2.8695972769456377],
            [10.784207252353623, -2.8620424272716787],
            [10.784911349223881, -2.858510150935397],
            [10.783423710730274, -2.8504642100593305],
            [10.784158641469027, -2.846539332732868],
            [10.787459571639442, -2.8448713458245094],
            [10.78505438572612, -2.83232949532035],
            [10.787227716842153, -2.829667958122603],
            [10.786691171911441, -2.8248451462389657],
            [10.784396194337717, -2.8214667569316316],
            [10.784954387926417, -2.815048151080611],
            [10.780341297711454, -2.8099616999740844],
            [10.776425026638101, -2.80050053471032],
            [10.76970428076913, -2.7999581792073265],
            [10.763046884804888, -2.8021060293551945],
            [10.760501764581075, -2.8101140428377804],
            [10.751849556742302, -2.8110992657439926],
            [10.735911331297626, -2.816820346509816],
            [10.73137915577555, -2.816324767945255],
            [10.72938612274277, -2.813776693041654],
            [10.723746446777541, -2.8126325467549225],
            [10.720930084307792, -2.8101074717769365],
            [10.720200413645937, -2.805452833111666],
            [10.718029405754518, -2.8044726395064097],
            [10.71840573329335, -2.799021825724793],
            [10.714801241426963, -2.791450142252153],
            [10.706658177228835, -2.791019235647208],
            [10.704357770727976, -2.7888656091440134],
            [10.704379086558152, -2.7842686307320954],
            [10.69969862470945, -2.784322007952451],
            [10.70055148733465, -2.7794762639548507],
            [10.698752806398657, -2.776428676202009],
            [10.700514305961635, -2.766979610850507],
            [10.694415192722863, -2.760077055641405],
            [10.695459278281177, -2.754615853979694],
            [10.694379389355822, -2.7511606290904607],
            [10.689396701039351, -2.7484379974532036],
            [10.688348575810181, -2.742543498415042],
            [10.68911397474837, -2.7377245151702714],
            [10.686655988071694, -2.7360917487210026],
            [10.68004366393831, -2.7349472991841197],
            [10.677571151150392, -2.7308080686349805],
            [10.676650344021436, -2.7252785926678045],
            [10.671833964984655, -2.7207555508429158],
            [10.670476957769134, -2.7142707064633282],
            [10.67316087684601, -2.7080978812470398],
            [10.672241023990127, -2.704951270852443],
            [10.675332820322485, -2.6971669681183785],
            [10.6723145050811, -2.6928494432877517],
            [10.670759903647923, -2.6881995959795],
            [10.67068313042944, -2.6823523575688206],
            [10.666654965585032, -2.675572001457479],
            [10.666752628498664, -2.66949897722185],
            [10.65920349537608, -2.6633959504888707],
            [10.66171073074352, -2.6546140195598396],
            [10.654787774515322, -2.6516317444872803],
            [10.655189703130295, -2.6473755805016372],
            [10.651094263773349, -2.6419110027212827],
            [10.648675706751355, -2.643545029108231],
            [10.644114508736553, -2.642289888023354],
            [10.641818077985926, -2.6366617374123327],
            [10.641571936753289, -2.631311698417272],
            [10.639706229371676, -2.6277967670090834],
            [10.64138344164965, -2.6200401036316014],
            [10.643769224036369, -2.585109455099695],
            [10.648279066665731, -2.578951888191947],
            [10.655609512274209, -2.576694446882409],
            [10.659590605848958, -2.5812296073596297],
            [10.665034241139866, -2.581762250775732],
            [10.67085892257831, -2.584359668431188],
            [10.675358321497876, -2.5769863784854303],
            [10.676499837381877, -2.569303624585838],
            [10.679809499385376, -2.569594690186285],
            [10.685341562891272, -2.563077411272638],
            [10.68965519682251, -2.5637253967200406],
            [10.6941315229056, -2.5571955681430008],
            [10.692749016213936, -2.553684559221733],
            [10.695777992925832, -2.546693005836696],
            [10.70050987224355, -2.5445837796550426],
            [10.702072532048776, -2.5404557871910876],
            [10.708494078755784, -2.537302854405318],
            [10.707818607140636, -2.5331658129114865],
            [10.709546026630159, -2.529027525196957],
            [10.714812372954212, -2.5293187766893372],
            [10.724809096981666, -2.5224162991785906],
            [10.72845459716318, -2.516399248461656],
            [10.731552395115894, -2.5171741783678647],
            [10.735382668366228, -2.5143205163411366],
            [10.742001758002768, -2.5141992327083083],
            [10.744239045955737, -2.512676195916067],
            [10.750066169877293, -2.518843721449558],
            [10.761800048795248, -2.5171387542111296],
            [10.769817590563056, -2.5210756525954814]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.14086682450518, "lat": 35.28759885854196 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37099"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01008566"
      },
      "bbox": [
        10.639706229371676, -3.0247827897753323, 11.017030600219023,
        -2.512676195916067
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9147449197841417, 0.14735545273876868],
            [1.915831132260934, 0.16801008058628247],
            [1.9164066972877123, 0.18559351474219604],
            [1.917278817778011, 0.2320307592611076],
            [1.9168551940970573, 0.2323657064703261],
            [1.9199216247402116, 0.23273362119062704],
            [1.9771755240009468, 0.23140621555201568],
            [2.0598674995302866, 0.23008477833228844],
            [2.091753200379039, 0.2289840123639497],
            [2.1311189872712015, 0.22825083948621275],
            [2.131680156497709, 0.2577535058537413],
            [2.17462691102774, 0.25665108506490025],
            [2.207876562249299, 0.25627229323444595],
            [2.2539341425624473, 0.2562035180027766],
            [2.2892137618954393, 0.25564063252249025],
            [2.3038209600886463, 0.2560215008549106],
            [2.391810680115507, 0.2545693434276663],
            [2.3915541188904, 0.2251407406187904],
            [2.3957895983030735, 0.22510893498737303],
            [2.3948325577679905, 0.18032003087403325],
            [2.393505440061996, 0.09743745855751369],
            [2.391842004324614, 0.032773240210396015],
            [2.391357572945523, 0.0032145164353770193],
            [2.3901539517866914, -0.03179755484678905],
            [2.3900967363772327, -0.0410101247730801],
            [2.391636248862118, -0.041022284332968416],
            [2.391059949319757, -0.1214185205957744],
            [2.351784733984458, -0.1212034619742609],
            [2.306804652660337, -0.12067523459271602],
            [2.2624828554925025, -0.12069232312825547],
            [2.2192474282244903, -0.12054167228073279],
            [2.2189623266702627, -0.12092926331694072],
            [2.1905327077171375, -0.12077977753251302],
            [2.1192751715265956, -0.12097626474517016],
            [2.065957506240166, -0.1209173111482119],
            [1.9624632890213207, -0.1201146602873991],
            [1.9195893490106337, -0.11963019770797884],
            [1.920026649725024, -0.08422252824906254],
            [1.9203729676577355, -0.031944703483863274],
            [1.910342016945107, -0.03179541994083177],
            [1.911911109180538, 0.05757509809045679],
            [1.913370639088124, 0.07129741187455108],
            [1.9136930580115945, 0.08750283182410652],
            [1.9135914453737428, 0.11729314765708686],
            [1.914379026925074, 0.14705029246703324],
            [1.9147449197841417, 0.14735545273876868]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.80642509738868,
          "lat": 38.744070114529215
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29101"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00758505"
      },
      "bbox": [
        1.910342016945107, -0.1214185205957744, 2.3957895983030735,
        0.2577535058537413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.10776033489852, 0.3849377702924385],
            [4.1193387606285965, 0.38558278903822657],
            [4.144533107519833, 0.3863137500537631],
            [4.166143520715938, 0.38724475624465365],
            [4.167170588598838, 0.35711341751497494],
            [4.168471433157841, 0.32671654101210623],
            [4.229393733132394, 0.3295754157844393],
            [4.2316478427118085, 0.2698480801425665],
            [4.247763293019446, 0.2703226181986853],
            [4.260539100703844, 0.2713704907280295],
            [4.310276615402344, 0.27324174938974954],
            [4.349339922939877, 0.274137491104734],
            [4.350335689711998, 0.21893821138393701],
            [4.352286724894036, 0.16249942689871705],
            [4.357398522027526, 0.05039411439377883],
            [4.3605544141251364, -0.0156522133591595],
            [4.36206619955295, -0.05211219593963795],
            [4.358040814056156, -0.05019498995038051],
            [4.3400460712895645, -0.04561095060609617],
            [4.329679419294757, -0.04013443054992458],
            [4.322670400962734, -0.03551674934863426],
            [4.31663022264495, -0.02824293852212712],
            [4.307152836642786, -0.008546711219405017],
            [4.303099510025026, -0.00361600392297038],
            [4.295544102962859, 0.0023636849525569604],
            [4.2881554260388945, 0.005403309269392269],
            [4.2780308819892445, 0.0065259936033733685],
            [4.271540360652153, 0.005628065801314609],
            [4.257238378318451, 0.0005797348378846955],
            [4.24454347796259, -0.005611509003400033],
            [4.235182562056691, -0.008015759470174792],
            [4.229442868602196, -0.00772881238904256],
            [4.213703166347684, -0.003060966241126263],
            [4.189975630152762, -0.000017861676246853404],
            [4.174189374487339, 0.0060682736843627955],
            [4.163662722879185, 0.00856633617437917],
            [4.155591946396661, 0.012067854602223552],
            [4.153667230337656, 0.020693259534512388],
            [4.154834408852664, 0.02727707722966338],
            [4.153693093450849, 0.03361949905483808],
            [4.149108891793145, 0.041843408338980856],
            [4.1454981380276905, 0.045328187288943535],
            [4.127618016619699, 0.05619666446643929],
            [4.115465868448584, 0.0681162636122104],
            [4.102310318011117, 0.0777657480407238],
            [4.087213958202511, 0.09246935125807886],
            [4.079814027650215, 0.09605103366876894],
            [4.072958824654478, 0.09459938581247723],
            [4.062864984277343, 0.08414464809719431],
            [4.054226062745412, 0.08192192368284432],
            [4.041533109103222, 0.08503126734830747],
            [4.021082087243485, 0.09279753598651329],
            [4.01312156456066, 0.09365439261880443],
            [4.002852704649933, 0.09372340244314911],
            [4.002156408771975, 0.12401284923962973],
            [3.9992710495897694, 0.20557043630519806],
            [3.9985254760857845, 0.21597676066698268],
            [3.9984204048224923, 0.23050695765637796],
            [4.037725309132336, 0.23162019104173906],
            [4.077042247089202, 0.2343382218638678],
            [4.086175544636206, 0.23535256524279968],
            [4.086249343626784, 0.23379838156417687],
            [4.100529913280055, 0.23365201073476516],
            [4.114756618170455, 0.23473200507261016],
            [4.112939326277256, 0.26588344311565604],
            [4.111168680783668, 0.31040320717884773],
            [4.110080572618226, 0.3483540407632193],
            [4.108692646385802, 0.3555430819170309],
            [4.10776033489852, 0.3849377702924385]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.16067033216167,
          "lat": 38.764640052451604
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29219"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "219",
        "coty_gnis_code": "00758562"
      },
      "bbox": [
        3.9984204048224923, -0.05211219593963795, 4.36206619955295,
        0.38724475624465365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.406601308460987, 8.239465877583601],
            [-9.401229644662568, 8.274828165422623],
            [-9.363942811605298, 8.26951679512791],
            [-9.250709623611204, 8.252073311574922],
            [-9.13748262617914, 8.234591550493898],
            [-9.023907989966348, 8.217888117728466],
            [-8.970612540054216, 8.21054312662686],
            [-8.983013536599472, 8.125536237408177],
            [-8.948894579010013, 8.12067824653459],
            [-8.962016333412029, 8.035181953045793],
            [-8.832677412376311, 8.01661720622315],
            [-8.83457172610437, 8.011060779650657],
            [-8.838355801370291, 8.005692330387],
            [-8.848628244973925, 7.934212392523669],
            [-8.906348907744261, 7.941467725732722],
            [-8.916044962316546, 7.8700878993089045],
            [-8.918482016197293, 7.85434448283775],
            [-8.947977997831352, 7.859062331804777],
            [-8.958796785606394, 7.773332097202135],
            [-8.97078760222651, 7.775034106127343],
            [-8.980179264055163, 7.710176631434299],
            [-8.979736535977553, 7.704248413682975],
            [-8.994299442082708, 7.603919172110372],
            [-9.079719430385975, 7.616042294066269],
            [-9.085947268604185, 7.5734667341714985],
            [-9.17141196228209, 7.586121979357152],
            [-9.177735821534348, 7.543509066505903],
            [-9.263132051069734, 7.555937989460692],
            [-9.288479003009034, 7.385524473186917],
            [-9.380620024433156, 7.399080629465598],
            [-9.406634843682367, 7.225687475683977],
            [-9.520548183244845, 7.242632689766596],
            [-9.494321526631477, 7.415987911698754],
            [-9.488180523219174, 7.415113839200114],
            [-9.46274445104517, 7.58287807768934],
            [-9.461254599436463, 7.5863522851453284],
            [-9.44660730927294, 7.684290444123468],
            [-9.439586364341267, 7.729432550928566],
            [-9.437862874553524, 7.7500100139318375],
            [-9.435132056865037, 7.770681153480155],
            [-9.430992087796945, 7.794766263102088],
            [-9.424212604339239, 7.842670676026802],
            [-9.473715673339633, 7.850166509666143],
            [-9.452298871047475, 7.9911689397096],
            [-9.434923774383051, 8.103976299183419],
            [-9.421592042876817, 8.191209719503613],
            [-9.414143018162335, 8.190083956819443],
            [-9.406601308460987, 8.239465877583601]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.94104272770826,
          "lat": 45.813889295332295
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30097"],
        "coty_name": ["Sweet Grass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sweet Grass County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01719569"
      },
      "bbox": [
        -9.520548183244845, 7.225687475683977, -8.832677412376311,
        8.274828165422623
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5545370058032505, 2.7255677147863953],
            [-0.5519489899455436, 2.7264920918397553],
            [-0.5450427998816397, 2.7242095023078488],
            [-0.5381186691173948, 2.7208520024454077],
            [-0.5312977611714149, 2.720479953775776],
            [-0.5228418173991366, 2.7243387217029187],
            [-0.5116749337286047, 2.7285456735022424],
            [-0.5073618412908676, 2.7295063180838404],
            [-0.49462655013121637, 2.728982425634286],
            [-0.4899214753496518, 2.727188148228004],
            [-0.4841924794923881, 2.7232469661830048],
            [-0.4752866036208441, 2.714312313087555],
            [-0.46936310087602856, 2.7121065226988357],
            [-0.44902427936208233, 2.7112333380194786],
            [-0.43198346533149506, 2.713389941016529],
            [-0.4289608531028054, 2.713224914043462],
            [-0.4189659742716521, 2.7063033418141957],
            [-0.411462823337728, 2.7041894522920216],
            [-0.39980061762938685, 2.7085550403431564],
            [-0.3955208259530178, 2.7095108523882407],
            [-0.3867172419378973, 2.7091488550652434],
            [-0.3770346368289105, 2.7130183584594123],
            [-0.37042054500973337, 2.714574252834598],
            [-0.3598370812423202, 2.7144503889868092],
            [-0.35305518881339504, 2.7180125593674065],
            [-0.34844619900762225, 2.719354008100452],
            [-0.34154889326513416, 2.7261477866305612],
            [-0.33140874374012563, 2.733415077263154],
            [-0.32264035079243003, 2.7388373745113714],
            [-0.29753984791645466, 2.739070445225883],
            [-0.2920443492090956, 2.739834104297258],
            [-0.2844690092867548, 2.742788053986126],
            [-0.27932491152601313, 2.745769273915445],
            [-0.2739595118111562, 2.7521000182791724],
            [-0.25379160678919205, 2.7675735538794144],
            [-0.24635630187173874, 2.769267354589872],
            [-0.23225621656896261, 2.77722216264989],
            [-0.2211203909449033, 2.7816657482082614],
            [-0.20992303560846087, 2.7818753615792233],
            [-0.2099166101606423, 2.7788079372622225],
            [-0.21041771235387585, 2.7191177216260938],
            [-0.21225084893828003, 2.7191351960969827],
            [-0.21285324030495356, 2.675475964235666],
            [-0.21264690924016935, 2.660916166631889],
            [-0.21316703156704844, 2.64634376519855],
            [-0.21403266590989042, 2.5921191089573927],
            [-0.21410294946429312, 2.544249525479924],
            [-0.21442736539923413, 2.5296881796237423],
            [-0.2153566988202494, 2.44132820860277],
            [-0.21535172599026065, 2.42255831713914],
            [-0.21580813398571536, 2.368682445159018],
            [-0.21762768046816636, 2.3687250332595458],
            [-0.3594689060846135, 2.370526017885759],
            [-0.4735511037579872, 2.3721772531940477],
            [-0.5595573738600743, 2.373658513530874],
            [-0.5582704004953847, 2.461319852674585],
            [-0.5563488504371583, 2.5928631430263906],
            [-0.555009179922011, 2.6951313246337016],
            [-0.5545370058032505, 2.7255677147863953]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.13176028729562, "lat": 41.2260870759357 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31023"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00835833"
      },
      "bbox": [
        -0.5595573738600743, 2.368682445159018, -0.2099166101606423,
        2.7818753615792233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2477483768096655, 2.207218917705169],
            [-1.2418987519648994, 2.2180677328814165],
            [-1.2119655985909383, 2.2514572440771254],
            [-1.2047372270740853, 2.2559279985617837],
            [-1.195986873816247, 2.268329215188029],
            [-1.1894540878354398, 2.274297073787945],
            [-1.1612029993689243, 2.2919624512431622],
            [-1.1471620416960417, 2.312504891452837],
            [-1.1429280916687437, 2.321294742265318],
            [-1.132599824639687, 2.3269749097404566],
            [-1.1082385554869867, 2.3451493136630694],
            [-1.0994704967673594, 2.345899407605575],
            [-1.095454486416033, 2.351185380739682],
            [-1.089258977867408, 2.3547189152504457],
            [-1.0728290465676042, 2.3736641111236083],
            [-1.0588013067185953, 2.3820151165639656],
            [-1.0516214207609809, 2.3890511939589567],
            [-1.047813087305842, 2.3963871696740986],
            [-1.0431226196516283, 2.401730673365943],
            [-1.0394585080952563, 2.408190339910175],
            [-1.0317776272240102, 2.413594218762332],
            [-1.00905461527103, 2.425770729664757],
            [-1.0064843365583047, 2.420453124139949],
            [-0.9982009757516697, 2.42473464343375],
            [-0.9891704688454367, 2.4267781854462194],
            [-0.9744776482936963, 2.435291190980191],
            [-0.9643475703152312, 2.43862632487828],
            [-0.9453273115874139, 2.4484646813214477],
            [-0.9364342089399645, 2.456852406978861],
            [-0.9350013643369312, 2.4602747307692576],
            [-0.9159052184485654, 2.483362400773054],
            [-0.9012320400761077, 2.5068309914711624],
            [-0.9020504774564599, 2.4706148391407634],
            [-0.9018989392267692, 2.466572135816549],
            [-0.9034597792951926, 2.379056504484978],
            [-0.9022196283311018, 2.379043764922026],
            [-0.9037994664748403, 2.291257250096079],
            [-0.9054257031901758, 2.203573612735484],
            [-0.9062364129199869, 2.152045889395796],
            [-0.9085392050031429, 2.0283966279700594],
            [-1.0088223533504195, 2.0303167943205715],
            [-1.09284510828203, 2.0319723278212463],
            [-1.1808327344005467, 2.033931735678796],
            [-1.2485120615751872, 2.035466723360534],
            [-1.2520802046940063, 2.0355452420338684],
            [-1.2504516752945551, 2.10135230634067],
            [-1.2477483768096655, 2.207218917705169]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.02286065797438,
          "lat": 40.873011899303336
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31081"],
        "coty_name": ["Hamilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hamilton County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00835862"
      },
      "bbox": [
        -1.2520802046940063, 2.0283966279700594, -0.9012320400761077,
        2.5068309914711624
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.569869189169268, 8.539499711586219],
            [17.567337833607958, 8.552124961889508],
            [17.56934145979674, 8.56086143899874],
            [17.569397153813867, 8.568482595120614],
            [17.567010260734857, 8.571953607835043],
            [17.561908604051034, 8.569945651116958],
            [17.558002250578085, 8.572696161025682],
            [17.561587599289616, 8.57973273914784],
            [17.559756475692005, 8.582281711217483],
            [17.56006457643889, 8.589912394285854],
            [17.557339093091933, 8.593856801667629],
            [17.562645762026754, 8.599269927558034],
            [17.56329527963875, 8.604494481777405],
            [17.56831339778761, 8.610351943857655],
            [17.574174421213076, 8.613054692515377],
            [17.57425275004281, 8.622217885723844],
            [17.5770312316129, 8.625026500652663],
            [17.57849513390492, 8.63196031503183],
            [17.581934854030745, 8.635995233192824],
            [17.580785579309783, 8.643463482931887],
            [17.584911345164905, 8.64552304743907],
            [17.58580679611989, 8.650612119628777],
            [17.58931921133303, 8.6542324846266],
            [17.590906183254084, 8.658156298893129],
            [17.59083671676912, 8.664065808428516],
            [17.587852991621975, 8.66945583514827],
            [17.582121938277602, 8.672010007066968],
            [17.58147180125228, 8.681570429704815],
            [17.584804218444265, 8.686628522771011],
            [17.58493257049137, 8.694684878809666],
            [17.58302919967068, 8.699075067439349],
            [17.585632605544674, 8.704479796585307],
            [17.586504340804428, 8.713637734735748],
            [17.584804204832714, 8.719019968379342],
            [17.587351452501014, 8.720979724652791],
            [17.589243665307055, 8.728480378176092],
            [17.587690528978055, 8.733314286571975],
            [17.591630255787354, 8.739885210088188],
            [17.5894523026897, 8.744508219201212],
            [17.584895455891083, 8.750191799643463],
            [17.575855993911496, 8.750541713047973],
            [17.573870176585057, 8.75339058278401],
            [17.556434510387557, 8.76057006727362],
            [17.55170433175408, 8.763729248782225],
            [17.55483827996292, 8.76653553994295],
            [17.558946428419283, 8.766229910437545],
            [17.562332331884274, 8.763607849278621],
            [17.5688352212396, 8.763763934398527],
            [17.572995416452393, 8.771093439180797],
            [17.578346822390237, 8.776349165730974],
            [17.58428690883832, 8.776498929400871],
            [17.58702649112199, 8.773123651984623],
            [17.592318419174198, 8.770414535090804],
            [17.593557994937232, 8.77246821030885],
            [17.595399705707297, 8.783188845460044],
            [17.60385721096629, 8.788774782558075],
            [17.606457904769748, 8.794705969915345],
            [17.6057572197659, 8.798449928955101],
            [17.599043520483843, 8.806157564559582],
            [17.599906230148967, 8.809868013766076],
            [17.606186456247393, 8.810863622226494],
            [17.60818469973114, 8.814380928602597],
            [17.610873037582394, 8.81410586973723],
            [17.61557692089362, 8.817282468931277],
            [17.616971183827253, 8.82471023944882],
            [17.623713990692746, 8.828889115419589],
            [17.626992137276503, 8.834567189956672],
            [17.630547919096383, 8.835710690429638],
            [17.63351957247573, 8.846030879863786],
            [17.635968127246255, 8.849361631701823],
            [17.63911335896935, 8.849930379446407],
            [17.643964379041876, 8.854314451435013],
            [17.645753550190175, 8.850201706003972],
            [17.648797617529567, 8.84842915131674],
            [17.653044233288735, 8.851297484816325],
            [17.658894991616666, 8.849513714046426],
            [17.65823236881627, 8.847072173336155],
            [17.661000060637747, 8.843198389492173],
            [17.66431525799372, 8.834523606961719],
            [17.668010090790695, 8.830419847533042],
            [17.669849582889825, 8.831814691930441],
            [17.67669373024826, 8.828186168557338],
            [17.679302844224527, 8.828991952876374],
            [17.68440656102486, 8.823977398791659],
            [17.687519303481604, 8.823184652051347],
            [17.695240453933618, 8.8143109988602],
            [17.699911186090663, 8.817006705992268],
            [17.706087389197307, 8.817955707336154],
            [17.711054141162403, 8.823201030066645],
            [17.715569906794215, 8.823667957000845],
            [17.717574756907474, 8.821045739898766],
            [17.723357555889947, 8.819687915990558],
            [17.731013087927764, 8.815252795324138],
            [17.733272435620847, 8.820925481575511],
            [17.737001522190987, 8.823080619686058],
            [17.739394253269772, 8.826620873740156],
            [17.75142011557879, 8.821692969796983],
            [17.76059775266917, 8.825917139336473],
            [17.761659814239426, 8.827483901805003],
            [17.76223667487959, 8.836080702048038],
            [17.764163959392093, 8.83822657674772],
            [17.763685262303632, 8.842286510533722],
            [17.765474650514687, 8.845756315421584],
            [17.764446452801423, 8.849016568767384],
            [17.76578603452154, 8.853405178803444],
            [17.76503563479849, 8.858204578335645],
            [17.768299775610977, 8.859983988364828],
            [17.769788997289705, 8.86360875579535],
            [17.765931867533645, 8.868691579655529],
            [17.766199443111415, 8.873254605793482],
            [17.76834951314662, 8.876703169775043],
            [17.767123720571988, 8.879302567383318],
            [17.770250303951947, 8.887572445004356],
            [17.7787337237348, 8.893448955344688],
            [17.798677460581334, 8.838814904726974],
            [17.81872836307618, 8.776574718973421],
            [17.830490433405615, 8.74190252660069],
            [17.873686891835444, 8.610809378756715],
            [17.875731167208823, 8.606360959810077],
            [17.897229732419056, 8.541110029117561],
            [17.925039124271034, 8.460491242489411],
            [17.95317318776637, 8.376196802938443],
            [17.95870081935921, 8.358051932398668],
            [17.983670387946574, 8.281484710147224],
            [18.012007814930318, 8.189074632388786],
            [18.029650424112422, 8.134078540114311],
            [18.038030767806884, 8.109257668731995],
            [18.066664976392865, 8.018574521824862],
            [18.07819305674416, 7.983256331688673],
            [18.08936135059287, 7.946180798206963],
            [18.09447030572751, 7.930097437817771],
            [18.071247477410395, 7.922768665868124],
            [18.075114595247676, 7.914709268820301],
            [18.084744856555453, 7.87876445929813],
            [18.06537252811647, 7.87363301702992],
            [18.046545872987057, 7.866485875353953],
            [17.938337599979175, 7.846897312562513],
            [17.928592738567296, 7.734276279163025],
            [17.931038089651196, 7.735054190796246],
            [17.93636770619784, 7.689494770512337],
            [17.92786923439488, 7.68709246303797],
            [17.921225549581425, 7.679331015194],
            [17.914271905534164, 7.683985865891318],
            [17.906437565884268, 7.7142471995360955],
            [17.886370793171647, 7.752548633143861],
            [17.863845590435663, 7.760009754557463],
            [17.847293400664054, 7.792514102967293],
            [17.833416884735943, 7.7862940874801145],
            [17.804978651401957, 7.816883750029741],
            [17.784017918757684, 7.822462638657936],
            [17.76019185354915, 7.8117356418529065],
            [17.757230057446794, 7.818505644596543],
            [17.712115669498818, 7.798212468061727],
            [17.691608868725854, 7.844414098464776],
            [17.61457141515751, 7.857096398110348],
            [17.60882865865539, 7.851025727523489],
            [17.570097525506128, 7.885100790204886],
            [17.55804085836568, 7.896454391711062],
            [17.55513613528927, 7.898524819803804],
            [17.542581874994937, 7.910063227050892],
            [17.549175009625383, 7.911861531598237],
            [17.554821149256277, 7.908756475889765],
            [17.559933873992545, 7.909518153446134],
            [17.561824005698206, 7.918254338681437],
            [17.57111815184325, 7.922122290941529],
            [17.576965458747242, 7.922288177176569],
            [17.58445000823221, 7.928606342688342],
            [17.588046020149243, 7.934104325720512],
            [17.594447242862998, 7.9416143985750365],
            [17.594449924037953, 7.945066197599551],
            [17.598723624593617, 7.947581928463137],
            [17.595029928142374, 7.952398783183976],
            [17.605057996685826, 7.958540407846258],
            [17.60670532927549, 7.962741962461825],
            [17.60679056975498, 7.970094094467121],
            [17.60552482580458, 7.976492099212158],
            [17.606792804485586, 7.982321550881948],
            [17.612993200737346, 7.984005098756448],
            [17.615145752691323, 7.988484665188862],
            [17.609471762525946, 7.991646496848295],
            [17.607410102062627, 7.9943970329375],
            [17.608333062678817, 7.997788455891401],
            [17.61217673684272, 8.001551925482877],
            [17.614456306709236, 8.00829865820378],
            [17.61791381733373, 8.00952165056886],
            [17.61983091930277, 8.005932444734041],
            [17.6154581445099, 8.002730036769494],
            [17.61765743867633, 7.99900247798229],
            [17.622341271734303, 8.001409253184999],
            [17.624252071627428, 8.012844785660182],
            [17.63039423691967, 8.012756232571679],
            [17.636879779869677, 8.016579853572146],
            [17.637901050916884, 8.024159499778781],
            [17.636874230148653, 8.031715531833395],
            [17.64092354826392, 8.029862858667933],
            [17.64784486884509, 8.037699456067797],
            [17.642644233162166, 8.040553517262685],
            [17.637929012430558, 8.046608858242216],
            [17.6339208792506, 8.048267746031632],
            [17.631359435750888, 8.051473857851327],
            [17.638714217519038, 8.055102421417088],
            [17.64236529697286, 8.064665721940589],
            [17.642812983066108, 8.070147421626151],
            [17.640159295093284, 8.073214919787718],
            [17.629573548015475, 8.07742903732646],
            [17.621191937389813, 8.081841631613921],
            [17.62008371680186, 8.088786370827615],
            [17.622173332078987, 8.093697534232064],
            [17.624661065930223, 8.095004142007246],
            [17.63429697989765, 8.096185911071233],
            [17.637849084457677, 8.095335056933283],
            [17.644675873857025, 8.098824652202227],
            [17.644023997139964, 8.104628996387667],
            [17.650001406435855, 8.105542206552535],
            [17.650056254769027, 8.108670778582548],
            [17.643668498487134, 8.114140610065553],
            [17.645244757913446, 8.116346697098793],
            [17.649868201575547, 8.113899065279462],
            [17.653268702112424, 8.117885818020547],
            [17.654396113402075, 8.122712847781775],
            [17.65134196831882, 8.126749820331575],
            [17.641253676272775, 8.127407418966241],
            [17.639497132677707, 8.13186453260324],
            [17.63472847883984, 8.132477950528054],
            [17.63285412775287, 8.135436195783734],
            [17.637205413724498, 8.137498495717495],
            [17.63722882308121, 8.141880223968904],
            [17.63235176905536, 8.152178445696713],
            [17.632688616385188, 8.163044741616922],
            [17.6233658676122, 8.167353174770327],
            [17.6259178408963, 8.172705176474116],
            [17.621879780030344, 8.177402334931358],
            [17.61968746166272, 8.182508016868065],
            [17.61594444199903, 8.17941491152762],
            [17.60905035124526, 8.178331268051656],
            [17.611035522903336, 8.182796404920552],
            [17.6061927359542, 8.182170689026224],
            [17.60252563797863, 8.183729917828579],
            [17.601636571854566, 8.188844180964601],
            [17.5984899491625, 8.195572200922467],
            [17.598053267913876, 8.199437758357513],
            [17.59040352438849, 8.200820195694272],
            [17.590111133959436, 8.20707960272127],
            [17.585527236479656, 8.214042681247895],
            [17.586833201666977, 8.21967828583651],
            [17.58201026062656, 8.220275867931736],
            [17.58202493858263, 8.224931766066522],
            [17.569204699698965, 8.235339791215228],
            [17.568540952936733, 8.237743892858456],
            [17.56346405165643, 8.239793637126747],
            [17.563156652588148, 8.245638475561433],
            [17.55663927545912, 8.244756696831782],
            [17.55390917697015, 8.258102744567696],
            [17.551565225886467, 8.26186544434204],
            [17.548391964828014, 8.262574550847397],
            [17.54682303376789, 8.266220532792968],
            [17.556278497007536, 8.272606453222025],
            [17.558206191054065, 8.275873527399844],
            [17.55759307735648, 8.281195193627678],
            [17.561632389010914, 8.285722051521537],
            [17.562686087283613, 8.290433030790608],
            [17.566203809947005, 8.294768378932751],
            [17.564951442467173, 8.299308632611924],
            [17.566146080485684, 8.302198915126018],
            [17.574370142702424, 8.306443878999808],
            [17.57793529088291, 8.316200149487537],
            [17.575519109470537, 8.320294798026012],
            [17.576150171196687, 8.330205975265454],
            [17.569830741887163, 8.333658321066373],
            [17.568567808975768, 8.33616675699393],
            [17.569515520424016, 8.341995483830715],
            [17.576446805393246, 8.346501798775007],
            [17.577382894200962, 8.357935389017465],
            [17.580584274757634, 8.363173103118777],
            [17.57911936264209, 8.366543567159866],
            [17.575106686282545, 8.370465281766428],
            [17.57542068966127, 8.375518986696928],
            [17.578076622751418, 8.381220073873449],
            [17.57535324455657, 8.385338561791437],
            [17.577048347171278, 8.390563985047542],
            [17.58385767076881, 8.395757310303988],
            [17.58664736857534, 8.400612333452624],
            [17.585677097138387, 8.403878270004414],
            [17.588890202853456, 8.407033110285298],
            [17.59060691644432, 8.41323484215742],
            [17.592586021226513, 8.414329543373675],
            [17.594695822996776, 8.42006309451829],
            [17.591662052354664, 8.42205823485958],
            [17.598653323392448, 8.435791869698603],
            [17.60000103014472, 8.440368708902295],
            [17.59749643439751, 8.441784057540334],
            [17.591617594185294, 8.448595799122977],
            [17.587273329442397, 8.45193712908048],
            [17.582122699160557, 8.4541740752985],
            [17.583000028564733, 8.456333764925818],
            [17.578717316056782, 8.462458143392618],
            [17.578069347865828, 8.470774066966962],
            [17.573779246594086, 8.475757031685752],
            [17.57524390377228, 8.478845895476477],
            [17.574410287339166, 8.484756941084996],
            [17.572087208845147, 8.489629287965476],
            [17.56317807410218, 8.49465804252767],
            [17.553263361179038, 8.5044754713885],
            [17.550876490502258, 8.50783162771065],
            [17.55068610497688, 8.51529448561505],
            [17.556598663985536, 8.524339171080953],
            [17.563064319540242, 8.528417715185585],
            [17.566443227118906, 8.533064646509182],
            [17.569018023609978, 8.534028652406816],
            [17.58077859639753, 8.529841809729184],
            [17.58670276624255, 8.532610164914209],
            [17.58681624884461, 8.537916009103657],
            [17.58956672070357, 8.541808559668087],
            [17.594735643485485, 8.546282501950733],
            [17.569869189169268, 8.539499711586219]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.30556708944094, "lat": 44.68960056924974 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33007"],
        "coty_name": ["Coos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coos County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00873177"
      },
      "bbox": [
        17.542581874994937, 7.679331015194, 18.09447030572751, 8.893448955344688
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [18.158981868382504, 6.631894284108177],
            [18.154273624543226, 6.638490954333743],
            [18.15121222295182, 6.646357569680717],
            [18.143379560879698, 6.660589756187365],
            [18.151372207716324, 6.660864243032022],
            [18.156166537563596, 6.694878117047827],
            [18.16057052412437, 6.728120315918095],
            [18.169375279119947, 6.77063493691267],
            [18.171947589381684, 6.793463992163246],
            [18.17357702844257, 6.79353859591359],
            [18.18461293925491, 6.862612995547676],
            [18.187770554285574, 6.888181689166367],
            [18.191678901273328, 6.9035793849925895],
            [18.19208586996049, 6.915311219244919],
            [18.220530021650877, 6.901557831819259],
            [18.227353578197604, 6.898653281335794],
            [18.255788302730487, 6.884311552350192],
            [18.295183196083286, 6.865023031296831],
            [18.33138838138954, 6.848137395539041],
            [18.38232753629253, 6.824043254633633],
            [18.376386433780844, 6.803413945108802],
            [18.364574782788562, 6.761141351647896],
            [18.406841636778488, 6.772745852786848],
            [18.429027593495032, 6.779065815709903],
            [18.459778388880952, 6.795307694112221],
            [18.49072841052174, 6.797225212725094],
            [18.49130376206894, 6.796544073753992],
            [18.503430184324746, 6.797008719290505],
            [18.510161823797997, 6.807244998666844],
            [18.509862768363945, 6.813423104496126],
            [18.50472473465222, 6.82944060728961],
            [18.50516319961439, 6.833850507122933],
            [18.500950510637434, 6.837428426281604],
            [18.50098816387314, 6.841793454314207],
            [18.50667293281178, 6.8461622159384765],
            [18.511430856165713, 6.846388431678048],
            [18.519522126766987, 6.841734939901852],
            [18.522652249981398, 6.8410572081849],
            [18.528349894782096, 6.842607939349839],
            [18.531199188170582, 6.848090672428531],
            [18.54056501507328, 6.844903766078494],
            [18.5536647694385, 6.837726436782862],
            [18.56223153726987, 6.833990870552213],
            [18.566895925145886, 6.830097703879902],
            [18.575281764517353, 6.829982741208473],
            [18.579868491892206, 6.82697951373142],
            [18.58700151467192, 6.819077339800409],
            [18.59785198463925, 6.819318916353397],
            [18.60147104485095, 6.816606437426556],
            [18.62320533295072, 6.824045590103765],
            [18.62918678603264, 6.809621263148216],
            [18.624266358399883, 6.806375108806522],
            [18.627648214079723, 6.792543847824014],
            [18.62585050903281, 6.780285686448893],
            [18.620438227139207, 6.773902874766333],
            [18.61921722622911, 6.76821091955545],
            [18.620285127688522, 6.762807700014467],
            [18.619571158181657, 6.75773499836176],
            [18.61641714556386, 6.755816355860095],
            [18.614725557133518, 6.747961485208823],
            [18.617064433934576, 6.746154281505191],
            [18.614484332694868, 6.739041307869411],
            [18.614818590097393, 6.735221544100069],
            [18.610186525255052, 6.733605724925718],
            [18.608065189977744, 6.728213951863183],
            [18.607604026766708, 6.721382814357117],
            [18.609478071025237, 6.715213262340551],
            [18.605728199678463, 6.7083146202149715],
            [18.608183336923563, 6.705204896309998],
            [18.605924362200636, 6.6971365849068825],
            [18.603595186573543, 6.696082457762243],
            [18.60092268119367, 6.6891406489319944],
            [18.601981258479462, 6.682436634126976],
            [18.59756928693334, 6.676951824139397],
            [18.59748969608925, 6.666731830945539],
            [18.59964721030003, 6.65788298004125],
            [18.602778168398714, 6.6558281510210415],
            [18.595306864450297, 6.652181775009911],
            [18.594542289129823, 6.641974262506025],
            [18.598141856291406, 6.627922392044327],
            [18.596872733777584, 6.619458098954246],
            [18.599005136503877, 6.607362704381934],
            [18.590399930572033, 6.601553095677222],
            [18.586803838713962, 6.596524316776394],
            [18.57995923630865, 6.590481481784752],
            [18.547880094015664, 6.604284989795935],
            [18.535154342348644, 6.604923152423347],
            [18.526607688445914, 6.602689336345978],
            [18.51594996489579, 6.597759403449471],
            [18.505235914127134, 6.586089522285363],
            [18.494924625007865, 6.575978636533273],
            [18.451986132008376, 6.554246882799193],
            [18.445385184058306, 6.541825800364477],
            [18.443006662072513, 6.524944790008711],
            [18.442535070072555, 6.497085470767985],
            [18.390490667208944, 6.498843304511339],
            [18.379909391197955, 6.489924734488809],
            [18.370475259503074, 6.480381930639291],
            [18.366119415599478, 6.471879105654507],
            [18.360704392699773, 6.459163926872058],
            [18.37752609717923, 6.408687884596803],
            [18.345470384062462, 6.409598065053434],
            [18.339080877985978, 6.406663038509476],
            [18.33127813863842, 6.401573112983805],
            [18.31760483158139, 6.4115751462096044],
            [18.249210604441792, 6.410522572260498],
            [18.24645045395634, 6.4156808112650365],
            [18.24668224619271, 6.41856746433558],
            [18.240918471465196, 6.421734107701693],
            [18.23640557687148, 6.420648196849949],
            [18.234275288212388, 6.42686380898736],
            [18.235503008544704, 6.4346042846930835],
            [18.21046784162332, 6.453445317659974],
            [18.182036743370052, 6.447292076211431],
            [18.152015481646874, 6.5131400914219535],
            [18.137873799135757, 6.544845828481313],
            [18.138717514843872, 6.545742115375443],
            [18.18893131292011, 6.567445749003959],
            [18.176623139002274, 6.594570399645106],
            [18.158981868382504, 6.631894284108177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.12539583835506, "lat": 42.98756673759557 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33015"],
        "coty_name": ["Rockingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rockingham County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00873181"
      },
      "bbox": [
        18.137873799135757, 6.401573112983805, 18.62918678603264,
        6.915311219244919
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.830092416338571, -2.1926380945950035],
            [14.901321316220425, -2.1940492199419426],
            [14.924242318191862, -2.1718181642704004],
            [14.932860292248353, -2.170917187347131],
            [14.938962242796368, -2.167852764483006],
            [14.943274727264663, -2.1669405655787695],
            [14.948655425551621, -2.169221786485695],
            [14.954815955577455, -2.167759187424361],
            [14.961575948549989, -2.1695507080773795],
            [14.965662589397787, -2.1735176857594514],
            [14.974053508589643, -2.1714866009508107],
            [14.977700734909975, -2.1761295206779616],
            [14.98135945597184, -2.183657259995955],
            [14.988457212922658, -2.186836351790733],
            [15.001789462378085, -2.1846948168859828],
            [15.007630974534159, -2.1763620454882506],
            [15.014608691718367, -2.1766211731470455],
            [15.019129824012758, -2.17309640682664],
            [15.032562998465533, -2.1773801139633844],
            [15.037295831864064, -2.1811488120865503],
            [15.038493662775885, -2.1859356906043073],
            [15.043008169222365, -2.1877681036292347],
            [15.049910571433147, -2.1930286455117574],
            [15.052584833674281, -2.1912589610686313],
            [15.051339473261999, -2.1868590947301],
            [15.053920947059012, -2.1810862541224116],
            [15.057881074600756, -2.1771466838414737],
            [15.094288988496604, -2.154211467229389],
            [15.152259730480525, -2.176114632713183],
            [15.174976738498065, -2.2096594292971012],
            [15.194400125770363, -2.2944595490711346],
            [15.209100599941683, -2.3061824984439485],
            [15.260531819779505, -2.331317122726192],
            [15.256857606904262, -2.3348664584299224],
            [15.284093792124393, -2.360974642491513],
            [15.289205316779642, -2.3774395327523163],
            [15.293459708705504, -2.4627157562911055],
            [15.292413780642143, -2.5040055707161177],
            [15.293861716408832, -2.5191964291309947],
            [15.305219864480684, -2.5826216039940384],
            [15.170866197302468, -2.609247172017771],
            [15.112187849180694, -2.6208748177423487],
            [15.104348993080945, -2.6190525838052587],
            [15.099544738605324, -2.622795704876397],
            [15.097634166332515, -2.62014620071461],
            [15.094222666737023, -2.6252265286135366],
            [15.09232120384136, -2.625383542064901],
            [15.085467582598023, -2.6307284050642155],
            [15.079513075918172, -2.627693704648609],
            [15.071371845708303, -2.629110869457172],
            [15.065892740602546, -2.635679269393721],
            [15.060096707171846, -2.6332527990493895],
            [15.056443491003604, -2.635418312543402],
            [15.051892698519525, -2.63152817901004],
            [15.041839784714517, -2.62773732826871],
            [15.038252328681784, -2.6229134862825947],
            [15.032959778905907, -2.6232051208602165],
            [15.028517919528644, -2.6259478403335828],
            [15.027297157803169, -2.630850542849138],
            [15.021825536169146, -2.630243362165724],
            [15.0154518672573, -2.6313515377098544],
            [15.009705315094727, -2.6349041482660636],
            [14.99806960217023, -2.6344251110674173],
            [14.994839083962523, -2.6350240036449866],
            [14.984333824335096, -2.6422353104097547],
            [14.978021873212658, -2.6400307315511182],
            [14.973365241388478, -2.6430618689247583],
            [14.966283591169613, -2.6429481089356175],
            [14.957704794456538, -2.6483242081578533],
            [14.953537894928903, -2.6551794749646938],
            [14.947995376385995, -2.6609126681662767],
            [14.94289980770931, -2.6630129341725612],
            [14.928407185020387, -2.6537185905846874],
            [14.886201008950211, -2.6415508161311814],
            [14.889729756171329, -2.5796972012090036],
            [14.891520544588749, -2.5606604801311863],
            [14.897152619002297, -2.4745227802490986],
            [14.874709351954994, -2.385417308853512],
            [14.853634461836537, -2.3009248216147133],
            [14.841479115250198, -2.289157683465627],
            [14.838365231853684, -2.2678506959269247],
            [14.84028711398888, -2.2445145012071874],
            [14.83301847651179, -2.213278377810508],
            [14.830092416338571, -2.1926380945950035]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.93298673470866, "lat": 34.93656035233981 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37061"],
        "coty_name": ["Duplin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Duplin County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01026132"
      },
      "bbox": [
        14.830092416338571, -2.6630129341725612, 15.305219864480684,
        -2.154211467229389
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.831083161024852, -1.4697495863216785],
            [12.828393975499708, -1.4498778442484153],
            [12.86494614384598, -1.4440877536390115],
            [12.940073580227892, -1.4325669221800814],
            [13.069182263386233, -1.4127955277915334],
            [13.15750903965697, -1.399259358671366],
            [13.169038648143077, -1.4800074267742434],
            [13.170032807737385, -1.4823012891866916],
            [13.17152758662376, -1.496792316268348],
            [13.178574402934377, -1.5473034450926006],
            [13.192677104080161, -1.645486926220728],
            [13.17868334591162, -1.6450690968239647],
            [13.10579050781809, -1.6437760318929553],
            [13.0552848576112, -1.652215823735627],
            [13.060121984249049, -1.6817799972515302],
            [13.057426235160557, -1.682659236502041],
            [12.968135565776219, -1.697706554164323],
            [12.921442644221393, -1.7297878009579066],
            [12.90752701231235, -1.7250663688321086],
            [12.899334462954013, -1.7202013458608194],
            [12.896330256159635, -1.7166754494231293],
            [12.896178213166952, -1.7120143992133459],
            [12.901583678561314, -1.7042225638769373],
            [12.900658920747869, -1.7002904651642112],
            [12.895124644638235, -1.6894955102979738],
            [12.891519051468155, -1.6869585491811137],
            [12.883993361398256, -1.684074290302851],
            [12.874276978897116, -1.6784017210524176],
            [12.869028644193405, -1.6711523436226479],
            [12.863985281061924, -1.6675090341460106],
            [12.858157948601283, -1.6596051084155052],
            [12.855999531344755, -1.6528044875777657],
            [12.851715890024643, -1.6494698382135065],
            [12.845751577732294, -1.6517801205797025],
            [12.843871248100488, -1.655179915159618],
            [12.845080609408594, -1.6630215051489357],
            [12.83881239284318, -1.6682439721659366],
            [12.83642115050118, -1.6717561410008666],
            [12.83158011236088, -1.6717880935044596],
            [12.82866958400304, -1.6696587244160797],
            [12.819319094217718, -1.6636816207285896],
            [12.817108286882064, -1.6598950302537574],
            [12.81555803262177, -1.651562457211814],
            [12.812698041029016, -1.643338757801788],
            [12.807948325898508, -1.6383261584980409],
            [12.806405585288461, -1.6349745129729238],
            [12.805720869340496, -1.6258563669504544],
            [12.808969939480047, -1.6211978294613094],
            [12.810457359186644, -1.6092275695168243],
            [12.823805288397361, -1.5993506375938784],
            [12.828133795780149, -1.598254542674656],
            [12.83499066297162, -1.5947681102620461],
            [12.84324667872497, -1.5943122851465408],
            [12.849611979040864, -1.5885892451725703],
            [12.852202278496089, -1.5807090933556363],
            [12.85873353868703, -1.572286393899227],
            [12.858845336164412, -1.5702492412446873],
            [12.853850418408976, -1.5594005392326007],
            [12.852945837575724, -1.5524731553288],
            [12.855063795260502, -1.5483978871753254],
            [12.855561710628422, -1.540555642074196],
            [12.85267265958935, -1.533325894181651],
            [12.848962786302371, -1.5308632916400422],
            [12.847920258505729, -1.5266675632921958],
            [12.850008014483139, -1.5225573256921743],
            [12.849804605774432, -1.5189920707673708],
            [12.841809758438405, -1.5038794042303103],
            [12.841875469368773, -1.4999168517751709],
            [12.844499094140753, -1.496054560353982],
            [12.851357780780807, -1.4924569484810997],
            [12.851070835519078, -1.4906429860963777],
            [12.845041215424317, -1.4795411228586075],
            [12.831083161024852, -1.4697495863216785]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.25633557295157,
          "lat": 36.130631508671044
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37067"],
        "coty_name": ["Forsyth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Forsyth County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01008552"
      },
      "bbox": [
        12.805720869340496, -1.7297878009579066, 13.192677104080161,
        -1.399259358671366
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.866496103420104, -0.7924772524175722],
            [15.867805575701889, -0.787929662927293],
            [15.881209017542972, -0.7830066479636096],
            [15.943672702932963, -0.7485507205709562],
            [15.951517691107304, -0.7619053584837449],
            [16.000060719592074, -0.8156270739756547],
            [16.003251393560863, -0.8162146009917517],
            [16.007125183308077, -0.8202372804082939],
            [16.007320087633023, -0.8236633286063023],
            [16.010802714746795, -0.8281379355626141],
            [16.016070880294713, -0.8313694155485709],
            [16.02142117434183, -0.8377296056215676],
            [16.026275443091336, -0.8390497805300688],
            [16.025626154095754, -0.8443531254064695],
            [16.029934304385915, -0.8536793278091894],
            [16.04121794354819, -0.8572673502871762],
            [16.05321832371216, -0.8579408675255321],
            [16.057037123711567, -0.8602438837915855],
            [16.057730896453783, -0.8638768766703886],
            [16.06269016078325, -0.8652865919788528],
            [16.065986536502752, -0.8608047872212605],
            [16.07295408837508, -0.8634526486879138],
            [16.078402881622868, -0.8623277967879536],
            [16.082389669850567, -0.8694292917822708],
            [16.088623257753284, -0.8705119889745928],
            [16.09203324590172, -0.8744568256810745],
            [16.09355122220348, -0.8784249721796016],
            [16.10307529714713, -0.8745831404180684],
            [16.109162670016858, -0.8874022048783203],
            [16.11556435127205, -0.8928991371112269],
            [16.117215506225783, -0.8976527621369786],
            [16.122563430657518, -0.8996880507153646],
            [16.123302798538976, -0.9040636064861605],
            [16.119731507317187, -0.907685408663187],
            [16.122549497857314, -0.9146108492428102],
            [16.12848861838196, -0.9151404735576214],
            [16.13050938123873, -0.9210475596818498],
            [16.13433330038491, -0.9225008520074396],
            [16.13950680417964, -0.9268700291844983],
            [16.146696774705852, -0.9287191298738198],
            [16.151508684115797, -0.9312671378149131],
            [16.15338423314341, -0.9346322004517242],
            [16.161617206261816, -0.9420640462426046],
            [16.16372152004563, -0.9504666635447749],
            [16.171029214677297, -0.9560302016753904],
            [16.172981108828065, -0.9611849002378898],
            [16.181162578835462, -0.9667840557515072],
            [16.188423232542252, -0.9680231512879919],
            [16.197603500272365, -0.9728178308160053],
            [16.20474721928766, -0.9730951871528851],
            [16.201517964201294, -0.9775367002793192],
            [16.19432657348867, -0.981235026926093],
            [16.18986389474852, -0.9877238867139702],
            [16.181041469795915, -0.9884542359611493],
            [16.177147742137876, -0.9864469069290429],
            [16.173796450332354, -0.9892684620287802],
            [16.169738431796123, -0.9893891722737808],
            [16.166654373473627, -0.9864824189055491],
            [16.160323237520355, -0.9850440523718894],
            [16.15890217970042, -0.9875228922433076],
            [16.153075548642015, -0.9847894883470044],
            [16.14891412962347, -0.9862603306674843],
            [16.13057384098505, -0.9811195346024902],
            [16.1263066740023, -0.9767619436753899],
            [16.119113570203158, -0.9749099022052112],
            [16.108948768863492, -0.9750503260205793],
            [16.095981632358946, -0.9674962422539067],
            [16.09163444433654, -0.9690030287183528],
            [16.085772334772333, -0.9688475930800404],
            [16.082277038910593, -0.9670082585751181],
            [16.076281212348565, -0.968068099435536],
            [16.066617358492444, -0.9683135834264849],
            [16.062441080810473, -0.9715635366965807],
            [16.055884139149832, -0.9724422848073135],
            [16.05036868760025, -0.9687738652024086],
            [16.046470873948145, -0.9630342706330958],
            [16.04121630280062, -0.9574599595509636],
            [16.0377777698778, -0.9512001772536013],
            [16.028408528708546, -0.9474997586355468],
            [16.02425763167593, -0.9441363724409539],
            [16.014031392981945, -0.9407353521236976],
            [16.00993005298154, -0.9378342519927804],
            [16.00498631754769, -0.939262920511849],
            [15.997132727055083, -0.9314094051743769],
            [15.994318550038017, -0.9300194488991794],
            [15.989149194227414, -0.9312952810633136],
            [15.984700653964406, -0.9304439904896892],
            [15.981098289289493, -0.9317882254272728],
            [15.980036133692973, -0.9397233421205794],
            [15.988541330894252, -0.9460578060362798],
            [15.99430507490491, -0.9476243095705358],
            [15.999839305617476, -0.9518106532293291],
            [16.00223475876207, -0.9586295043457237],
            [16.010501714923706, -0.9585475498396465],
            [16.031603709777254, -0.9708942412243494],
            [16.037860848444218, -0.9752108332371545],
            [16.039888285740112, -0.9798481026320464],
            [16.04467971483297, -0.9799146973817584],
            [16.05080209726862, -0.9845092358221706],
            [16.052469255721668, -0.9888938600505868],
            [16.061547937009944, -0.9923367165940605],
            [16.069994558092418, -0.9872012962008495],
            [16.08070889062181, -0.9849588666633801],
            [16.08300898690359, -0.9917975760256867],
            [16.086892096125716, -0.9917748654902564],
            [16.088472295792897, -0.9956019710894861],
            [16.091385192524612, -0.9955846614368616],
            [16.09799327203953, -0.9983552775948287],
            [16.108804551267315, -0.999847554255463],
            [16.11935121448677, -0.9982250494528602],
            [16.11943068350887, -1.004150308539947],
            [16.114443035367692, -1.0089419214500859],
            [16.109467533904642, -1.0104028532126728],
            [16.10574187866846, -1.013958231040736],
            [16.10617497261396, -1.0168845026823745],
            [16.09979232164842, -1.019310396583205],
            [16.095193136541734, -1.015578800137455],
            [16.086918833358066, -1.0169188045803523],
            [16.081092662422755, -1.0205193290637282],
            [16.070126996076304, -1.0240032263413894],
            [16.059452814119894, -1.0305957974502962],
            [16.04414321772733, -1.0361620160362432],
            [16.038296229106667, -1.0354173825742736],
            [16.038920644600196, -1.0408217921656542],
            [16.02452131847645, -1.044120244402109],
            [16.018610234442164, -1.0433142449234718],
            [16.0123272141612, -1.0457842699415452],
            [16.009791651819306, -1.0425835757795758],
            [16.004073634499548, -1.043326867604029],
            [15.99778998999044, -1.0366984894466755],
            [15.993878489342658, -1.0358099024761618],
            [15.986107585356887, -1.0360933005389785],
            [15.981335691095545, -1.034456654823868],
            [15.976878290585066, -1.0419067565945497],
            [15.972265723257202, -1.0451985454645099],
            [15.96755210871005, -1.0451259634214718],
            [15.961586814747314, -1.0433879893235254],
            [15.95798699084841, -1.0388004398421251],
            [15.951511943180833, -1.0362896314705776],
            [15.943042957834372, -1.0397729300967815],
            [15.938685874265033, -1.0396874693658107],
            [15.93521548199832, -1.0425911387405558],
            [15.927626449267656, -1.0394068658527607],
            [15.91764075011754, -1.0395142112362195],
            [15.908502276702347, -1.035323201425728],
            [15.905035458606992, -1.0311401606163229],
            [15.896358730070983, -1.003548938102082],
            [15.873778669662352, -0.9328436626886314],
            [15.865666179032944, -0.9082949906290128],
            [15.866591750720398, -0.9050895710033947],
            [15.865976125788666, -0.8978640709689982],
            [15.869032387082175, -0.8952685276124444],
            [15.875150048468393, -0.8874052202322309],
            [15.874420941468015, -0.8772859889694063],
            [15.875534855500154, -0.8701994922718087],
            [15.874586365812714, -0.8616572794938352],
            [15.873097580414655, -0.8572625260944537],
            [15.87372196171968, -0.8508319039818967],
            [15.871581051020314, -0.8468156024418256],
            [15.867949170309117, -0.8352506761578552],
            [15.86774842780968, -0.828759117211878],
            [15.870676534626888, -0.8219907930724608],
            [15.868592051379721, -0.8171092332039113],
            [15.86946805096701, -0.8074192307418235],
            [15.86658516634409, -0.7991953095093673],
            [15.866496103420104, -0.7924772524175722]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.44116803456171, "lat": 36.20587234396556 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37143"],
        "coty_name": ["Perquimans"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perquimans County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01025841"
      },
      "bbox": [
        15.865666179032944, -1.0457842699415452, 16.20474721928766,
        -0.7485507205709562
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.81256179860618, -0.9935048405808478],
            [13.823241686599047, -0.9917638870661799],
            [13.942912150619852, -0.9696244466881092],
            [13.98709837131439, -0.9617626069664441],
            [14.080429948067524, -0.9450124022644459],
            [14.08432236450517, -0.9599736734888902],
            [14.099272712395665, -1.053316410889326],
            [14.112231243781316, -1.133262073986003],
            [14.126242712078671, -1.2185796167785758],
            [14.131256979525599, -1.249598264276079],
            [14.049171697839947, -1.261833822752838],
            [14.01406571931118, -1.2673215345704325],
            [13.949698363858092, -1.277880202505813],
            [13.918818151773593, -1.2828108061927654],
            [13.8536619128468, -1.2936038870952806],
            [13.832706129657394, -1.1405999528640258],
            [13.8194718675728, -1.0425639763436296],
            [13.81256179860618, -0.9935048405808478]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.9717763993736, "lat": 36.390007912608816 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37145"],
        "coty_name": ["Person"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Person County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01008577"
      },
      "bbox": [
        13.81256179860618, -1.2936038870952806, 14.131256979525599,
        -0.9450124022644459
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.34582005341199, -0.8951782104838538],
            [14.44958777433511, -0.874361353854203],
            [14.489428166175584, -0.9867799855705283],
            [14.53068725266985, -1.1031990263586542],
            [14.522866917785734, -1.121014562695359],
            [14.52254753979545, -1.1270570282318095],
            [14.51654785737759, -1.1394728525668842],
            [14.514770588469004, -1.147218075469725],
            [14.51049075126942, -1.1583136991094172],
            [14.4987905198444, -1.1762457232094619],
            [14.496222618959386, -1.1833044933325683],
            [14.46468900515416, -1.188591070061491],
            [14.450178823938659, -1.2585259765907832],
            [14.442560267232365, -1.2617684912232272],
            [14.441385287563515, -1.2662476769263378],
            [14.436380678515597, -1.2661896653225289],
            [14.427975512938755, -1.2645236522505028],
            [14.420704046134023, -1.26455860705258],
            [14.41752081382612, -1.2662729395634493],
            [14.415495406461467, -1.2711031736707736],
            [14.41286615786751, -1.2692451553827058],
            [14.41190987699963, -1.2652999938744305],
            [14.4065191302927, -1.263626554498702],
            [14.400986977034428, -1.2646511808070573],
            [14.391215330924496, -1.2636282535754013],
            [14.391084558297292, -1.2595148015755762],
            [14.38408046741789, -1.2561389207153346],
            [14.382406686123968, -1.2608501820958775],
            [14.38269471632983, -1.2653736048551643],
            [14.380827369516169, -1.2652666046760956],
            [14.372049816702711, -1.2593929974330402],
            [14.347574979492148, -1.1338135725668448],
            [14.31956509431637, -0.9900843370373527],
            [14.321687449744003, -0.9566818330865016],
            [14.318651509277082, -0.9545519240054434],
            [14.317608063868644, -0.949018095046833],
            [14.31849788238155, -0.942192038876997],
            [14.32113910471217, -0.9331227751438049],
            [14.319063461117285, -0.9289146395755391],
            [14.327097294750386, -0.9235593901649355],
            [14.332144399879382, -0.9228928033365669],
            [14.33490753396426, -0.9183864606201662],
            [14.341730436546131, -0.9149349219155547],
            [14.33908494220852, -0.9126478382712312],
            [14.339670806818797, -0.9072740240743858],
            [14.342336239507624, -0.9049530341227077],
            [14.348367000528619, -0.9040050299601297],
            [14.34582005341199, -0.8951782104838538]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.4079289079253, "lat": 36.36497374619198 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37181"],
        "coty_name": ["Vance"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vance County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "01008591"
      },
      "bbox": [
        14.317608063868644, -1.2711031736707736, 14.53068725266985,
        -0.874361353854203
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.185574878867753, 10.36938052920787],
            [-3.159189471272122, 10.367573022492692],
            [-3.098637531598521, 10.364259436134045],
            [-3.0060846438575752, 10.35930548229265],
            [-2.93945821080549, 10.355292123877442],
            [-2.8286007536770392, 10.349884101334004],
            [-2.7505813484656145, 10.34601766297224],
            [-2.6629645105142488, 10.34163423462652],
            [-2.5757190333805613, 10.337388627770729],
            [-2.479160386975665, 10.33281770736732],
            [-2.4014599221987982, 10.329221294664833],
            [-2.3138801899841717, 10.325280704707595],
            [-2.316120278337195, 10.27783141810687],
            [-2.3201610649564364, 10.187250086987579],
            [-2.3205507838216506, 10.181757338391938],
            [-2.326352242136472, 10.052909079693569],
            [-2.3013304030431407, 10.051795769434937],
            [-2.30520336765569, 9.96745562508706],
            [-2.3090640221143652, 9.882775155732618],
            [-2.3964782782434475, 9.886204982396574],
            [-2.483299051733167, 9.889933228826163],
            [-2.479476485765226, 9.97487909799758],
            [-2.523463504491203, 9.97728754694929],
            [-2.59389010547384, 9.980976946530053],
            [-2.595872245538679, 9.980917956728293],
            [-2.6535867143588803, 9.983750181253573],
            [-2.6906301307900327, 9.985721772000863],
            [-2.7521274795009307, 9.988812559535926],
            [-2.8136254948911867, 9.99189050704364],
            [-2.8716899970106486, 9.994782313110232],
            [-2.8755277832138213, 9.994766614813452],
            [-2.9150895743659606, 9.99673293170789],
            [-2.919692561986465, 9.91213229301621],
            [-2.9878983003414055, 9.915887840800815],
            [-3.0561049605484927, 9.919627656192661],
            [-3.057052512035998, 9.919804369900882],
            [-3.132735097830454, 9.924120854294353],
            [-3.1812519628996863, 9.92703795570585],
            [-3.1771504108143325, 9.997473828849378],
            [-3.171236574904211, 10.096184858909716],
            [-3.201632488247776, 10.097970709351486],
            [-3.1965946353160852, 10.182342049396535],
            [-3.1915677171429504, 10.266440740847205],
            [-3.185574878867753, 10.36938052920787]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.83328646452858,
          "lat": 48.792172612426874
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38009"],
        "coty_name": ["Bottineau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bottineau County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01034227"
      },
      "bbox": [
        -3.201632488247776, 9.882775155732618, -2.3013304030431407,
        10.36938052920787
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.938375682732156, -3.380035874311116],
            [8.024784064356071, -3.371449451142215],
            [8.086856718448304, -3.366165876280951],
            [8.144750096384554, -3.3609789507319974],
            [8.193798654379849, -3.356052253990224],
            [8.2507543874991, -3.3493296814991576],
            [8.31419711692957, -3.343401563215087],
            [8.32025238500137, -3.3428329973846953],
            [8.322891794296917, -3.348835290701382],
            [8.323057412231869, -3.3535346281822966],
            [8.320418256498673, -3.3582480996791695],
            [8.325919576261045, -3.358630467123827],
            [8.3271157009447, -3.3614067855195606],
            [8.335720025349152, -3.3654791121897336],
            [8.33987658804296, -3.363417317288389],
            [8.343261034275983, -3.374243006950202],
            [8.34995807478419, -3.3781356468392887],
            [8.353691241425294, -3.377408972195403],
            [8.360262336157698, -3.383346903911737],
            [8.365531952418372, -3.384406219369788],
            [8.368783399231065, -3.3897854507971594],
            [8.368063145086067, -3.393493661861967],
            [8.371487978683394, -3.40020195167085],
            [8.370826616714329, -3.403046879909308],
            [8.363941984248804, -3.407865359844761],
            [8.358701334304753, -3.4067047020680827],
            [8.356949914347304, -3.400969071892209],
            [8.351694151722157, -3.3975011324032307],
            [8.35079237113232, -3.392179220508386],
            [8.343900572280644, -3.392510502171081],
            [8.33954506017159, -3.3874690561085443],
            [8.333936973016927, -3.3902730617372923],
            [8.326233118649252, -3.3992998300914463],
            [8.322086725387912, -3.396513148938094],
            [8.31893128689059, -3.398246851641736],
            [8.313691663791738, -3.3981477472924726],
            [8.317892393493494, -3.4066812751018585],
            [8.317984276801873, -3.409119810337759],
            [8.323109296537861, -3.411507281682628],
            [8.328054330762162, -3.419256894155572],
            [8.323278917663036, -3.4325583025062354],
            [8.31476895638074, -3.4341637753875283],
            [8.313582527690874, -3.43694291313432],
            [8.307940723870315, -3.4416844864889367],
            [8.308416089552635, -3.4480806327664864],
            [8.30336739710695, -3.4609409137696225],
            [8.299910026128023, -3.4637451984861154],
            [8.305470236149882, -3.4693051390330374],
            [8.305050930284706, -3.479383809460444],
            [8.313766657236965, -3.4848234203357067],
            [8.316473602886967, -3.490209656866535],
            [8.315661902172724, -3.497546712786644],
            [8.314417687921946, -3.4991414720850105],
            [8.320383459798979, -3.5032668140228185],
            [8.324282388231522, -3.5040997447768367],
            [8.318184902325926, -3.5129505809494783],
            [8.31760481404907, -3.5178507675489814],
            [8.311979022566998, -3.519785224245033],
            [8.311413406134665, -3.524391399258114],
            [8.312354131900166, -3.530757365906659],
            [8.311212107796448, -3.5327987890139187],
            [8.31547498140889, -3.536132513778846],
            [8.317229726305227, -3.5422343724627874],
            [8.321343251790752, -3.5426906229216053],
            [8.32266719215531, -3.5481290526361207],
            [8.31937796236705, -3.5491165314720856],
            [8.317130155303207, -3.555882611155194],
            [8.31803206367359, -3.562642605866542],
            [8.320336492476692, -3.5711706854331102],
            [8.322113391116801, -3.573404501516802],
            [8.321616538553878, -3.5834081823969957],
            [8.319374894491837, -3.5867843662971666],
            [8.31948261687857, -3.5911342872958008],
            [8.316006317771286, -3.5966944125626976],
            [8.308546353504315, -3.60311327328201],
            [8.318263672499095, -3.705719931416741],
            [8.34755192284351, -3.7260232673965565],
            [8.343910487012042, -3.7277029477679497],
            [8.344021671880643, -3.7331374204818313],
            [8.347792725713957, -3.736297736957914],
            [8.350340165563233, -3.7371231888186354],
            [8.356394411331108, -3.735142534613532],
            [8.361383537873072, -3.7389212603000983],
            [8.36775371644311, -3.741107397632663],
            [8.365326736441949, -3.7482391196340243],
            [8.36582809998517, -3.751870975629193],
            [8.369132465956577, -3.754129387377616],
            [8.36029998108857, -3.7581489096595546],
            [8.354178703276029, -3.758795538911342],
            [8.350685186525682, -3.7634999506563456],
            [8.346757328312107, -3.7628393680525534],
            [8.348366070847279, -3.7699532001903577],
            [8.355429343678818, -3.7701585965167794],
            [8.362400695366013, -3.7716124965629745],
            [8.366271334947648, -3.7705550477275445],
            [8.368173989823662, -3.7733185997900422],
            [8.364792437447596, -3.7805421120575438],
            [8.36432943409007, -3.7866565419400704],
            [8.366685625284134, -3.795171876358035],
            [8.363741468325511, -3.7977484661036414],
            [8.356903025708737, -3.806415717029911],
            [8.353982289554846, -3.817649618952221],
            [8.35421683627032, -3.8228804096845694],
            [8.350918158566977, -3.8267935933894277],
            [8.34581858104095, -3.8244179596571755],
            [8.332262338695475, -3.8146461223654335],
            [8.331019902129034, -3.8178632148057594],
            [8.327355398205551, -3.819460776436977],
            [8.324414112651485, -3.824285856014857],
            [8.321094312324636, -3.825335477561525],
            [8.317741262796671, -3.8225584778174313],
            [8.3100789102548, -3.8194668025050813],
            [8.304875299290316, -3.8269688895392884],
            [8.304010685747103, -3.8330992501697145],
            [8.308265398985759, -3.835073722955663],
            [8.307431221379765, -3.8412039765717343],
            [8.299535068193634, -3.846821294828045],
            [8.29513016962819, -3.8450940641037414],
            [8.288953625016292, -3.848685275707025],
            [8.287350126763373, -3.853041620340885],
            [8.281103097120752, -3.8642109507524296],
            [8.274517046473113, -3.8632909005372227],
            [8.271590677271611, -3.861271818789188],
            [8.25957857735021, -3.861554095116817],
            [8.256231690845743, -3.862452747977306],
            [8.249571105086048, -3.8686930650644147],
            [8.244955268397964, -3.871820199483661],
            [8.239121582124486, -3.868249026174602],
            [8.230059632482286, -3.868939242499373],
            [8.218935760576596, -3.8677160428390085],
            [8.194441204422764, -3.8539324718108503],
            [8.18863776797328, -3.848512970638837],
            [8.186545432433645, -3.839308574131533],
            [8.171429932953965, -3.81260667978605],
            [8.171737713677363, -3.808063382059276],
            [8.171344804299562, -3.8024252033438923],
            [8.167422907567213, -3.792625354772648],
            [8.163041883368606, -3.7863808675030626],
            [8.156997570897826, -3.7814822243747885],
            [8.144882568946752, -3.7749536033072033],
            [8.13893504322722, -3.7741363406744792],
            [8.133229685508768, -3.774637165546748],
            [8.123720530199792, -3.777778548500699],
            [8.116594901474196, -3.7819285110894603],
            [8.104526656047161, -3.796920985043206],
            [8.101760755383527, -3.803998859349184],
            [8.097354586542645, -3.8103779754563445],
            [8.093209580366532, -3.812849494672609],
            [8.083112157448298, -3.812611417368159],
            [8.077653962836616, -3.8111751697052196],
            [8.071706361685418, -3.8071474707690593],
            [8.068532206234453, -3.8012236687146563],
            [8.067347624078488, -3.789439716042526],
            [8.061317695389626, -3.78157512526677],
            [8.054582736015371, -3.7787363443080677],
            [8.043900446464638, -3.7771762251149763],
            [8.038101186883598, -3.778385777621277],
            [8.02957108194583, -3.7840738281422226],
            [8.010000587046113, -3.808663984889517],
            [8.005756106402929, -3.814591863058935],
            [7.999675557827535, -3.8184371522423457],
            [7.985879210913978, -3.8221381663149674],
            [7.976215369778751, -3.8223969157742212],
            [7.972306889082108, -3.7683679300432464],
            [7.9666733584311515, -3.6959795665819652],
            [7.9618330621108075, -3.6436757224642347],
            [7.957936321890519, -3.599703432932079],
            [7.948848570011397, -3.4921847293968815],
            [7.941252243535777, -3.4093960643019052],
            [7.938375682732156, -3.380035874311116]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.55024603875933, "lat": 34.76307099055595 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01089"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00161570"
      },
      "bbox": [
        7.938375682732156, -3.871820199483661, 8.371487978683394,
        -3.3428329973846953
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.864210486660235, -4.39045769070463],
            [6.864721556079743, -4.360782928478702],
            [6.866415573042794, -4.3007509753531865],
            [6.866380132300105, -4.285858661583906],
            [6.867669030916599, -4.270974998973344],
            [6.867109965487471, -4.254710783726701],
            [6.869064155523362, -4.181022353567878],
            [6.869470260706748, -4.153557644481408],
            [6.988794211744726, -4.149134331901015],
            [7.059352200956424, -4.145566550626909],
            [7.107499252613398, -4.142762837668579],
            [7.1560471107811425, -4.139571882985405],
            [7.186514371481329, -4.137039082156609],
            [7.231907495160061, -4.133838977545258],
            [7.262875986755708, -4.132287002968546],
            [7.310697838177671, -4.130163571627537],
            [7.317813087129518, -4.207036166909393],
            [7.319522872063804, -4.227075498163743],
            [7.3243177832517725, -4.295022385920234],
            [7.325301185538001, -4.3124280696395365],
            [7.336555294689174, -4.435372601765614],
            [7.344407339245388, -4.522359698236152],
            [7.259594550264226, -4.530297323196557],
            [7.197844754005124, -4.532987270384172],
            [7.157510628068156, -4.534279067361194],
            [7.14226944342942, -4.536178218753881],
            [7.084807013628707, -4.540042635890051],
            [7.07728934755329, -4.454115685123108],
            [7.075973838361509, -4.437694125387384],
            [7.0468162977192454, -4.439449420681409],
            [7.044748573095411, -4.410185570566166],
            [7.030061686578386, -4.410883306765083],
            [7.016023628986991, -4.410946155675524],
            [6.982400747930732, -4.4129681137523455],
            [6.863717624873123, -4.41894679955899],
            [6.864210486660235, -4.39045769070463]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.88714547242863, "lat": 34.1365502522333 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01093"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00161573"
      },
      "bbox": [
        6.863717624873123, -4.540042635890051, 7.344407339245388,
        -4.130163571627537
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.627563555748126, -6.157440433058324],
            [7.6335599880503615, -6.158511412516798],
            [7.639350151016556, -6.1578072149379075],
            [7.642461101924774, -6.152929407400191],
            [7.650336293738214, -6.151371102989962],
            [7.657190923754894, -6.154365335373353],
            [7.657198635618815, -6.161217555539499],
            [7.660290693996733, -6.164410851946004],
            [7.666377096464308, -6.166715674340706],
            [7.670881272809558, -6.174427603449143],
            [7.67292879577513, -6.173393438063908],
            [7.6781785758201035, -6.1752659163780965],
            [7.683007033689606, -6.180743300124248],
            [7.688466256796612, -6.18068869003403],
            [7.698275664098253, -6.178334419363921],
            [7.699369097185617, -6.182099007535779],
            [7.70223444469994, -6.184049792994852],
            [7.700495998431344, -6.187976772910927],
            [7.701404255048237, -6.192700161121097],
            [7.713317306741288, -6.192871513013407],
            [7.7147346574831905, -6.196629544534549],
            [7.713981771872655, -6.200629035594951],
            [7.715282833829492, -6.205063739395992],
            [7.721802004224073, -6.211758200819777],
            [7.725618514280042, -6.211387428732483],
            [7.72599084282126, -6.217652837354285],
            [7.732123029462894, -6.213990606653933],
            [7.73524158212536, -6.214947933878398],
            [7.737290149790249, -6.211221125221289],
            [7.743122979985089, -6.211219387395383],
            [7.746873391129817, -6.213843724024725],
            [7.751880993390274, -6.213295244838358],
            [7.756576611815565, -6.215051550608816],
            [7.761254780087391, -6.218350387366736],
            [7.759068539451327, -6.22107891000497],
            [7.761052802299311, -6.224069972060628],
            [7.7681082330027795, -6.227933562403377],
            [7.769410008993236, -6.232413324409765],
            [7.777805405949589, -6.239694711448549],
            [7.7793309440539735, -6.245372798416513],
            [7.783047017781935, -6.245149089989949],
            [7.785907095201143, -6.241071341970267],
            [7.788328300666985, -6.242368258078558],
            [7.791249660142397, -6.250555323657798],
            [7.796309715096176, -6.2556661684360995],
            [7.798956185546848, -6.262918675062926],
            [7.801360169344829, -6.260227736203233],
            [7.809242159631214, -6.262270340660954],
            [7.813821859164285, -6.258887095009078],
            [7.819127256329713, -6.265561222837164],
            [7.823692119716596, -6.26347705939093],
            [7.822920198206017, -6.2717757287495655],
            [7.817528137092997, -6.281677511357082],
            [7.831171432152533, -6.28239522181838],
            [7.835112568703407, -6.287837885851576],
            [7.839802535423862, -6.2902429892401805],
            [7.838432112184674, -6.292443570762999],
            [7.842081410260868, -6.299115407877973],
            [7.842196335122554, -6.301742186513205],
            [7.852056953912339, -6.309032927758886],
            [7.863326040334354, -6.310128564630781],
            [7.867277225978687, -6.307534174260438],
            [7.868538359290779, -6.310060188783844],
            [7.8744843981247525, -6.312959320076912],
            [7.87568036451253, -6.3159988096948005],
            [7.880266461937091, -6.3150686357770835],
            [7.8818554651246915, -6.317681492987163],
            [7.8801488334272625, -6.323046476638113],
            [7.881447268329882, -6.328364440949678],
            [7.886265059512911, -6.3315675062741175],
            [7.8899185477588585, -6.331629921217567],
            [7.894623938130062, -6.335317355739692],
            [7.895251729129555, -6.341051097247732],
            [7.894385059619709, -6.351277244547708],
            [7.93877844050293, -6.34704029287223],
            [7.944283906109981, -6.346910859123932],
            [8.043746749364816, -6.337162764198171],
            [8.053407537259321, -6.336693664808231],
            [8.121830065014791, -6.329451538158165],
            [8.152319619671646, -6.325909454499159],
            [8.16409221922, -6.325026011713756],
            [8.163513329912108, -6.338084466845652],
            [8.171564198936021, -6.410775496540545],
            [8.156992605822245, -6.412705018758343],
            [8.128446689804463, -6.415393691053718],
            [8.13898697857782, -6.5105952761739125],
            [8.140996752255171, -6.531403395731014],
            [8.142737841763719, -6.5454442028998985],
            [8.126518343626994, -6.546953837067859],
            [7.979699012166608, -6.562473517164253],
            [7.960417070200658, -6.564625877837689],
            [7.927444540519691, -6.567896654755067],
            [7.884274200321409, -6.57180196555991],
            [7.87204557409545, -6.570000816654447],
            [7.8583102386201, -6.570884728161883],
            [7.853771676136234, -6.571730058654283],
            [7.80729775710853, -6.5761814249724075],
            [7.772020145570573, -6.579740372860586],
            [7.642595220076045, -6.592939259457478],
            [7.573442377569726, -6.601120381737448],
            [7.542377607004973, -6.603934411425427],
            [7.537843412054643, -6.560981225692756],
            [7.527171775273094, -6.556262816775961],
            [7.498733286450922, -6.559043898844809],
            [7.487777943637569, -6.444150821705212],
            [7.486679569376759, -6.433418694162686],
            [7.522492454814205, -6.426924833221952],
            [7.524376133825626, -6.4267855030715575],
            [7.51210545710561, -6.3006671668639145],
            [7.57001961680935, -6.295161719269939],
            [7.59757171817051, -6.292676036288703],
            [7.585571285833104, -6.171308746057462],
            [7.588701128192686, -6.164264503344522],
            [7.592396273372387, -6.159500587275841],
            [7.602992290042944, -6.156516760081962],
            [7.614167790020902, -6.155401357191412],
            [7.6189365586443705, -6.156995429555091],
            [7.623720662410181, -6.155002449002855],
            [7.627563555748126, -6.157440433058324]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.30818860732911,
          "lat": 31.989257780009975
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01131"],
        "coty_name": ["Wilcox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilcox County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "00161591"
      },
      "bbox": [
        7.486679569376759, -6.603934411425427, 8.171564198936021,
        -6.151371102989962
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.312968092029983, -11.357806764357766],
              [-18.311931953041825, -11.357855803787817],
              [-18.30805365955713, -11.359054970393194],
              [-18.307459068094772, -11.360134526142241],
              [-18.306797425904215, -11.362846744389243],
              [-18.30817368321148, -11.364138095221756],
              [-18.31052055870942, -11.365600308320884],
              [-18.31314809778668, -11.35881788709699],
              [-18.312968092029983, -11.357806764357766]
            ]
          ],
          [
            [
              [-18.348485835403743, -11.27305512208047],
              [-18.34802609874089, -11.271975255752585],
              [-18.34591721361001, -11.271420382014073],
              [-18.344437621155805, -11.272386215015743],
              [-18.344515397115803, -11.275675631903262],
              [-18.343278635877212, -11.27625704949281],
              [-18.343219780596133, -11.277219681273891],
              [-18.341578905015037, -11.277859811706898],
              [-18.340910236281797, -11.279431472145252],
              [-18.339937097934346, -11.280073769004073],
              [-18.340529710417062, -11.281317756401489],
              [-18.339855790898905, -11.282613733913971],
              [-18.340821752040906, -11.283915189482151],
              [-18.34320226584771, -11.281774868754239],
              [-18.343471887355527, -11.27940915542058],
              [-18.344577409532338, -11.27835031803678],
              [-18.344327064961327, -11.277309561872038],
              [-18.346027042622904, -11.275940560192572],
              [-18.348323003498024, -11.27562231114947],
              [-18.348485835403743, -11.27305512208047]
            ]
          ],
          [
            [
              [-18.36892949646308, -11.326237518419358],
              [-18.368065410117147, -11.323584217318224],
              [-18.365793601118188, -11.321575350160472],
              [-18.365928700179715, -11.318957960815208],
              [-18.366477009611266, -11.317924663194459],
              [-18.36398712790196, -11.314101461743226],
              [-18.36124168152337, -11.317003814662126],
              [-18.36009899923128, -11.317707783053695],
              [-18.361027885666267, -11.318816903913623],
              [-18.36037299554697, -11.32054297349657],
              [-18.360808125068807, -11.321911748652264],
              [-18.361521526636537, -11.3261594973214],
              [-18.36185317704076, -11.329589331873093],
              [-18.360764640151288, -11.33131441349156],
              [-18.35960403909127, -11.330952079539445],
              [-18.358216799628643, -11.33137987773054],
              [-18.356693628531417, -11.334897290294984],
              [-18.35675850572377, -11.337370791415465],
              [-18.35794977848308, -11.339398340443537],
              [-18.35834829252015, -11.34128615911024],
              [-18.36112541528193, -11.344921068246917],
              [-18.36304013340066, -11.345000248591907],
              [-18.362886180964104, -11.342960806682665],
              [-18.361622214572023, -11.341538420174714],
              [-18.361961402835412, -11.339667934252164],
              [-18.36118423011377, -11.337003563239481],
              [-18.3627657373458, -11.334547861540901],
              [-18.36516426345894, -11.332486494385765],
              [-18.366108316390196, -11.332398461126765],
              [-18.36674492890817, -11.330928475598634],
              [-18.36891527007684, -11.328759869143548],
              [-18.36892949646308, -11.326237518419358]
            ]
          ],
          [
            [
              [-18.391014151674657, -11.324578172740868],
              [-18.388262526027663, -11.320396631037134],
              [-18.387495606491207, -11.316582861386244],
              [-18.3876280809643, -11.314862112574076],
              [-18.386434211886936, -11.310663634243936],
              [-18.385666326203886, -11.309456141820903],
              [-18.38424481189479, -11.306006723647133],
              [-18.383426205870517, -11.30471915817834],
              [-18.382275553125872, -11.30444429036515],
              [-18.380319879423645, -11.310475703067635],
              [-18.37973854383989, -11.311597690988787],
              [-18.379356702184648, -11.314750295549036],
              [-18.379613398040604, -11.317800271204344],
              [-18.380369028521514, -11.32020591190325],
              [-18.382339162247863, -11.322197986475821],
              [-18.382786359590895, -11.323223954163788],
              [-18.385173727980835, -11.325048440726759],
              [-18.388373678190028, -11.32807806306618],
              [-18.39053048267914, -11.326248314418192],
              [-18.391014151674657, -11.324578172740868]
            ]
          ],
          [
            [
              [-17.564367556337608, -10.610396921274306],
              [-17.56810234410603, -10.732132632845971],
              [-17.574488773369005, -10.940180587719516],
              [-17.577213726268816, -11.028900515228818],
              [-17.60621974769042, -11.02800811651289],
              [-17.60721189344996, -11.057878135561085],
              [-17.667207849782105, -11.055807878572097],
              [-17.668355552480733, -11.085669452689006],
              [-17.698427680832015, -11.084518475229396],
              [-17.69965296313727, -11.114373839899338],
              [-17.716395216398194, -11.113700291326808],
              [-17.717663747923066, -11.14355021238945],
              [-17.777495730210774, -11.140952545585485],
              [-17.778918538093308, -11.170792884506195],
              [-17.808906504800248, -11.169378552743396],
              [-17.81190628524992, -11.229041488233197],
              [-17.797783691408792, -11.229716591906529],
              [-17.80175327617672, -11.31059333363712],
              [-17.803348181934854, -11.311173429458025],
              [-17.803405465108632, -11.31233647021016],
              [-17.80457189062911, -11.312917322930957],
              [-17.808630784736756, -11.312936100424745],
              [-17.810798797913, -11.313786382380144],
              [-17.814149611860962, -11.314664126342995],
              [-17.820125628983092, -11.31435306958038],
              [-17.826047464589, -11.31550516943505],
              [-17.82700122355512, -11.316094403923456],
              [-17.828742684852333, -11.318214639280162],
              [-17.83211313766977, -11.319829693677862],
              [-17.83557770007892, -11.321990869644933],
              [-17.83928102780909, -11.323354632687439],
              [-17.841061663381524, -11.32574812668652],
              [-17.843405289428826, -11.327795331980322],
              [-17.844882564690604, -11.328485022761763],
              [-17.852985523642133, -11.330407564918495],
              [-17.859678392193285, -11.332651899296525],
              [-17.863824458699636, -11.334547948875779],
              [-17.866025699883796, -11.336401553437124],
              [-17.866894724423485, -11.338523686068665],
              [-17.868152957034333, -11.339881837629756],
              [-17.87158092696731, -11.341235828838663],
              [-17.87597245336571, -11.341891809208736],
              [-17.880393601890244, -11.343165737511285],
              [-17.892068910379894, -11.346214713718199],
              [-17.896045073524256, -11.347550142619381],
              [-17.899754197994152, -11.349474280475562],
              [-17.90286535630133, -11.351472854902566],
              [-17.906685545968994, -11.35341057290281],
              [-17.912812724060597, -11.357156163062223],
              [-17.913171052963186, -11.3577533904224],
              [-17.916636659936774, -11.360199159746735],
              [-17.925517816099163, -11.364041061040345],
              [-17.944257394847735, -11.371142150998976],
              [-17.951283163385146, -11.374207991864106],
              [-17.95666172255222, -11.3764238399644],
              [-17.965375950366692, -11.37957164745787],
              [-17.969829945904944, -11.380833911051852],
              [-17.976971284780866, -11.382492702051874],
              [-17.98281118477845, -11.382692408384163],
              [-17.988326794885605, -11.382009504402943],
              [-17.990288938273558, -11.381391736163753],
              [-17.994456732018566, -11.378809045405015],
              [-17.997591737086708, -11.376477832769256],
              [-18.00061832683779, -11.374657643980555],
              [-18.00477482124296, -11.371055742862556],
              [-18.008488389416264, -11.366996429163258],
              [-18.010435116019543, -11.363779449227637],
              [-18.0108171223778, -11.361729266093636],
              [-18.0102361713945, -11.360383552267425],
              [-18.010151874854344, -11.355646299035856],
              [-18.011688313270497, -11.34341397230183],
              [-18.01261336708244, -11.340799889528093],
              [-18.014306769647447, -11.337115029387714],
              [-18.01710079437114, -11.332508599418302],
              [-18.019146282397283, -11.330248725385603],
              [-18.02183147699124, -11.327904316654436],
              [-18.02769510120155, -11.323863408297527],
              [-18.030181183747057, -11.322743162078499],
              [-18.036480983990685, -11.320944508962691],
              [-18.04252764573951, -11.31850047524],
              [-18.0460435999632, -11.316436949216596],
              [-18.04848611981359, -11.313509593416853],
              [-18.04907743769349, -11.312428583138878],
              [-18.049184995434942, -11.309361778783828],
              [-18.046493196965802, -11.306866839123181],
              [-18.04737148257199, -11.303133955582725],
              [-18.047159697419286, -11.300112390532428],
              [-18.04616642603267, -11.298820860249968],
              [-18.043447094036477, -11.299894978456361],
              [-18.041691943162956, -11.29969433285676],
              [-18.039950447086117, -11.298452416547129],
              [-18.039155253655686, -11.296595484504245],
              [-18.037501221480767, -11.2959843177577],
              [-18.037986521627847, -11.293066691409443],
              [-18.03683408723648, -11.29038591855589],
              [-18.036472743368353, -11.288268249780199],
              [-18.036824055349676, -11.28714221186449],
              [-18.036267607135862, -11.284995391461948],
              [-18.03668012795807, -11.284556402307748],
              [-18.035550627580974, -11.281461042748232],
              [-18.035870555030808, -11.279282385704208],
              [-18.034575284414863, -11.272945086804222],
              [-18.033427245337556, -11.270607470052454],
              [-18.03333916365825, -11.26436808805482],
              [-18.031849785670946, -11.263281749462708],
              [-18.031155346672254, -11.26097903993268],
              [-18.03187233553305, -11.258329235469485],
              [-18.03197796561108, -11.255826294531179],
              [-18.031504066480288, -11.252685765026202],
              [-18.030416104871854, -11.249946049250918],
              [-18.030574515150818, -11.248519216523317],
              [-18.029747817780194, -11.246460240776257],
              [-18.027405629204893, -11.244918581143516],
              [-18.02531166308148, -11.244714996354848],
              [-18.02019646102593, -11.243058293810577],
              [-18.015055136279646, -11.23893052366799],
              [-18.009092788317098, -11.236091596041623],
              [-18.00607152343221, -11.235188966691231],
              [-18.00458641851003, -11.233921805261902],
              [-18.003922688256157, -11.231917097574188],
              [-18.004436728165395, -11.22962399820888],
              [-18.00597039563147, -11.227863526703786],
              [-18.010951654547274, -11.22602886894158],
              [-18.013015835432387, -11.225867539242927],
              [-18.01490668421356, -11.223882981012405],
              [-18.01658800187754, -11.223628916515528],
              [-18.01799144657642, -11.223960127818527],
              [-18.0192292754714, -11.225332405449036],
              [-18.01940388422053, -11.22686132157579],
              [-18.021635596471775, -11.23060457674232],
              [-18.024113389382617, -11.233373741231492],
              [-18.028016754881875, -11.233362077030414],
              [-18.02878355533035, -11.233865480720285],
              [-18.030942125061706, -11.233941480877284],
              [-18.03264029811072, -11.233588166902052],
              [-18.034795573599993, -11.234545971646996],
              [-18.037126427692225, -11.236738925612952],
              [-18.038519683583914, -11.237560296718739],
              [-18.039388012157307, -11.24023483042981],
              [-18.039263015728856, -11.244235990124741],
              [-18.038822418461827, -11.245495499265292],
              [-18.039185716948296, -11.246969734491943],
              [-18.04223330355254, -11.250811546240167],
              [-18.047354916907196, -11.256238591379548],
              [-18.050436603809228, -11.26089455681211],
              [-18.054080408956025, -11.265384074283983],
              [-18.054900874482822, -11.27085380783201],
              [-18.055865217630064, -11.274402092259596],
              [-18.05764330521459, -11.275340252420913],
              [-18.06066335263194, -11.277699456427774],
              [-18.06300777895408, -11.28006270454589],
              [-18.070770231953684, -11.2834755242858],
              [-18.074076711868315, -11.286135294503964],
              [-18.076045822989304, -11.286960599586973],
              [-18.07852512532163, -11.286787166227112],
              [-18.082564522583986, -11.28500518904785],
              [-18.083386033660815, -11.283668954547217],
              [-18.084707064305018, -11.283296417683445],
              [-18.08573229232566, -11.283901538911039],
              [-18.08576119082659, -11.286103005990583],
              [-18.084841843258328, -11.289296150368726],
              [-18.085563892288135, -11.291676188630895],
              [-18.086088145148285, -11.29532533754359],
              [-18.088602228583607, -11.301648589917258],
              [-18.09083694952663, -11.307753218604718],
              [-18.090703987077116, -11.310036733910726],
              [-18.089876941721574, -11.311783104751516],
              [-18.089765398933626, -11.314411343692107],
              [-18.08870868649479, -11.315981849108963],
              [-18.088097833164205, -11.318513388295875],
              [-18.088049920532196, -11.320792765123889],
              [-18.090588050266135, -11.327464648115118],
              [-18.093973258404695, -11.333015221745748],
              [-18.095738195611375, -11.334423009757957],
              [-18.098122915060483, -11.335743889095722],
              [-18.102648563154865, -11.336250837291619],
              [-18.104936005430485, -11.335763393033263],
              [-18.106998561061502, -11.334353603248893],
              [-18.10854045294995, -11.327157738665148],
              [-18.110658346539875, -11.326429246192294],
              [-18.112104903198105, -11.327907583196737],
              [-18.11207616573171, -11.334323856670562],
              [-18.1116306217172, -11.338692222628765],
              [-18.110720488036502, -11.341040042981556],
              [-18.109123881636823, -11.341409570113198],
              [-18.10822377643836, -11.343879311094991],
              [-18.106446349539784, -11.346025755591286],
              [-18.105625866281372, -11.348244324992802],
              [-18.104985549369662, -11.352064207871907],
              [-18.104232656651572, -11.354497971062353],
              [-18.10414363075131, -11.357711906857258],
              [-18.102795048538336, -11.361473762508117],
              [-18.10217578179745, -11.365821850658428],
              [-18.10252156527186, -11.36914874412323],
              [-18.102356478182553, -11.371120260046292],
              [-18.100834154082378, -11.374862137904913],
              [-18.098256433464794, -11.385932880355615],
              [-18.095759578545767, -11.39214986139226],
              [-18.09491959263383, -11.395666947764358],
              [-18.09374962202083, -11.396664238095273],
              [-18.09333137916795, -11.400953362498242],
              [-18.092610318631287, -11.404429545554384],
              [-18.09237112935402, -11.407680124275164],
              [-18.091038552606495, -11.411715355690161],
              [-18.090128454405843, -11.412036401684158],
              [-18.08681528095873, -11.414839538166559],
              [-18.081822641830165, -11.416966216131886],
              [-18.080904029343653, -11.418080092562123],
              [-18.081861058337513, -11.41989974886979],
              [-18.083857531310297, -11.421368502166779],
              [-18.085222922037232, -11.42281681346769],
              [-18.088144127904147, -11.428317368629354],
              [-18.089882376834378, -11.430984446938846],
              [-18.09297128385864, -11.43426514738382],
              [-18.096192507420884, -11.438137933901107],
              [-18.09965187287745, -11.44268424048454],
              [-18.1004581815064, -11.442906620777485],
              [-18.104036297753964, -11.446339532412553],
              [-18.110060771433243, -11.448267353814844],
              [-18.114668068731294, -11.448564236000614],
              [-18.118921436362417, -11.449174556634883],
              [-18.12107966477934, -11.449148713634886],
              [-18.12789273913707, -11.446417601301794],
              [-18.13592004926289, -11.442820602016388],
              [-18.139543213637698, -11.440709814437824],
              [-18.144747020133707, -11.438646928377109],
              [-18.148268043354985, -11.436715604854761],
              [-18.148967117227734, -11.435889770732766],
              [-18.151339704121227, -11.428536905785856],
              [-18.1500042251315, -11.42575681380574],
              [-18.151388086350355, -11.421593702565666],
              [-18.151399339607106, -11.419936198891868],
              [-18.15491440672073, -11.419004924467385],
              [-18.166206818005627, -11.394162327185057],
              [-18.168519428590166, -11.389212030807698],
              [-18.17470641149706, -11.373284979198095],
              [-18.17726443602366, -11.36686616388933],
              [-18.179181101718637, -11.361652991245398],
              [-18.18321148315432, -11.35188789766712],
              [-18.191846861525153, -11.331934919452694],
              [-18.197919028849626, -11.319988981706597],
              [-18.202385877787766, -11.312222116205868],
              [-18.208969713978867, -11.302797444720905],
              [-18.211215775487183, -11.300041953475773],
              [-18.217481729664378, -11.293898144085237],
              [-18.223675505017333, -11.290266910535243],
              [-18.224698413280112, -11.290650666456925],
              [-18.227329350963927, -11.288436492560376],
              [-18.231825259872814, -11.286896512089443],
              [-18.23372138473057, -11.287419900103192],
              [-18.233895427412147, -11.2891910954771],
              [-18.234679935889133, -11.28955160718569],
              [-18.23610079040196, -11.288051887841752],
              [-18.23860063132798, -11.286589786820345],
              [-18.240158136488613, -11.287671997349902],
              [-18.24353786453479, -11.284945328859376],
              [-18.240935950789193, -11.283483694320804],
              [-18.240934771566465, -11.282230037602526],
              [-18.239756956870117, -11.279955191987934],
              [-18.23816282622024, -11.278296670838907],
              [-18.23785295041214, -11.277196247900896],
              [-18.236106850890504, -11.274665895346839],
              [-18.233605676428628, -11.27209181494299],
              [-18.23246944866203, -11.270381533428399],
              [-18.23174754044563, -11.270483814883605],
              [-18.230409053781155, -11.267665276268707],
              [-18.230483938969744, -11.265536970568366],
              [-18.231694457506958, -11.261475249733074],
              [-18.234867930171482, -11.25472349594534],
              [-18.234884370959897, -11.253803921436067],
              [-18.236711687022616, -11.253588254119006],
              [-18.239522257996054, -11.25233602435745],
              [-18.2407740954446, -11.25216777985199],
              [-18.245097221891296, -11.252759684461505],
              [-18.24838849589238, -11.253818430694349],
              [-18.25103653083598, -11.254146518820013],
              [-18.252801811725746, -11.253954758616118],
              [-18.25336996167798, -11.253334100095582],
              [-18.255851301654435, -11.253717789577944],
              [-18.25783279708653, -11.25475827008999],
              [-18.255477739256623, -11.259221778339016],
              [-18.257827766530852, -11.262481216812802],
              [-18.257056878290335, -11.265432981762642],
              [-18.25878712468287, -11.26628383174068],
              [-18.25981289218712, -11.268404530649835],
              [-18.26117917642946, -11.269264949887695],
              [-18.264214332197504, -11.27293514002504],
              [-18.2644678418606, -11.274336581737426],
              [-18.263987867395667, -11.275715942814472],
              [-18.262173001481408, -11.275870735438684],
              [-18.26165570828127, -11.277317106432873],
              [-18.260542910193863, -11.278601825005529],
              [-18.261122693490368, -11.280036360406221],
              [-18.26217097881128, -11.280949721289204],
              [-18.261871067891903, -11.28290959689705],
              [-18.26552552079933, -11.285276631833161],
              [-18.265801081958493, -11.282511785386458],
              [-18.265370368720873, -11.281590559892747],
              [-18.266049038474506, -11.280023758211565],
              [-18.267914843115317, -11.279949134656466],
              [-18.268368093538985, -11.280930247568815],
              [-18.27012553188642, -11.27939791628444],
              [-18.272839771914317, -11.282310635233177],
              [-18.271724481373536, -11.28476661422133],
              [-18.270970637441447, -11.287659868556448],
              [-18.271345210933585, -11.28992477597237],
              [-18.269517765976882, -11.29093238466625],
              [-18.27048155873456, -11.292317707967019],
              [-18.270759118137434, -11.295187617954497],
              [-18.272676429473762, -11.297108772114138],
              [-18.274031604508732, -11.297800917533934],
              [-18.276338938881022, -11.298049243984922],
              [-18.277194655717913, -11.299657080825085],
              [-18.27861305625034, -11.298406501485236],
              [-18.278512108140657, -11.29752114767069],
              [-18.280130134340084, -11.297296201101032],
              [-18.28245303478035, -11.298670205007975],
              [-18.282724521520013, -11.302160097061599],
              [-18.28467305860429, -11.302480570138808],
              [-18.28635840375803, -11.303228511407266],
              [-18.28623470639387, -11.304006134277673],
              [-18.28819503283987, -11.304453327311286],
              [-18.290969429960153, -11.304594709284553],
              [-18.29162113121658, -11.306305951728069],
              [-18.294150134565204, -11.305168385282025],
              [-18.29187703798809, -11.303663092193506],
              [-18.293017926999866, -11.301028822007325],
              [-18.294440953691947, -11.299839512693682],
              [-18.29453730625618, -11.298531989368913],
              [-18.296615383144076, -11.296406954959059],
              [-18.297227588400126, -11.294229301189624],
              [-18.298699776940577, -11.29335488394027],
              [-18.299281506049685, -11.292175289436097],
              [-18.29861917394144, -11.291063118428324],
              [-18.299430498286004, -11.288629428482096],
              [-18.300711287647093, -11.287792986190093],
              [-18.30244790592998, -11.28789716820669],
              [-18.30208150885772, -11.285119104897872],
              [-18.301623169894018, -11.284351097758115],
              [-18.303101529593082, -11.282391257476053],
              [-18.305344720663406, -11.282192462075248],
              [-18.305260812245546, -11.280583471453532],
              [-18.304309267306127, -11.279838543028575],
              [-18.30321980082647, -11.276894485627272],
              [-18.302907034243606, -11.272330788557378],
              [-18.303417385438134, -11.271329293335954],
              [-18.30512646754147, -11.270030128298234],
              [-18.305201270019385, -11.267879509164626],
              [-18.306632526896127, -11.266539355358493],
              [-18.310526188933043, -11.264917845455924],
              [-18.31299278862578, -11.264378819870684],
              [-18.31694264260713, -11.264308703869421],
              [-18.321158371504847, -11.265897218681285],
              [-18.322318747948067, -11.267258863028243],
              [-18.321989723350168, -11.268797377721185],
              [-18.322750557291943, -11.27144095065476],
              [-18.323568163153134, -11.272544594852139],
              [-18.324521845826517, -11.271927143996303],
              [-18.32666580171201, -11.271605558717198],
              [-18.326668847295622, -11.270266263684084],
              [-18.328210351217304, -11.269722532822264],
              [-18.331277306085372, -11.270060428135643],
              [-18.334659115117322, -11.2698586040922],
              [-18.335501583823977, -11.267847585222745],
              [-18.33302901130457, -11.264693997606797],
              [-18.332291114013444, -11.261446769284442],
              [-18.332988699220774, -11.258366882525939],
              [-18.33309538493113, -11.256383147689512],
              [-18.33187623151446, -11.25411515447898],
              [-18.33239587008237, -11.252793974309176],
              [-18.331250343100596, -11.250457278745428],
              [-18.33262528551039, -11.249546601895647],
              [-18.333772379357683, -11.250312020423129],
              [-18.33436570072445, -11.252486898892265],
              [-18.33523147442367, -11.253002160086503],
              [-18.337474949102358, -11.252181395381964],
              [-18.339226297875985, -11.252063057102294],
              [-18.341025229986787, -11.253902849716845],
              [-18.342415926498585, -11.25372344544218],
              [-18.344996946828495, -11.254632347309798],
              [-18.346463633628275, -11.258936425064343],
              [-18.348045003991757, -11.25972524999514],
              [-18.349816063395863, -11.258902690040468],
              [-18.35001352417334, -11.255145897960304],
              [-18.34919060828733, -11.25441485806247],
              [-18.349108821826583, -11.252893442089176],
              [-18.350211120702085, -11.250498370763337],
              [-18.349600398240497, -11.249278511712632],
              [-18.348215090939505, -11.24807218240482],
              [-18.348392832235632, -11.246569959756135],
              [-18.35016802183527, -11.243137368938415],
              [-18.3497097971124, -11.24061267822955],
              [-18.351512112084063, -11.238811833820304],
              [-18.35332153688644, -11.239534721455348],
              [-18.35317419550204, -11.242455136255955],
              [-18.355065792963757, -11.244464696913834],
              [-18.355562469491446, -11.243824293913029],
              [-18.354654141934972, -11.241765519569924],
              [-18.35454610482023, -11.239760233015444],
              [-18.356819467097907, -11.237511838044092],
              [-18.359200876464463, -11.238371166370715],
              [-18.361821265425633, -11.239695961937292],
              [-18.36230916640685, -11.238971252483298],
              [-18.36161308938255, -11.236236123987057],
              [-18.360657696904493, -11.236347080787853],
              [-18.358891911803443, -11.233203579541788],
              [-18.357660888256593, -11.23312796077823],
              [-18.356765283132027, -11.231642544996332],
              [-18.355292950104467, -11.230912333621516],
              [-18.354983975623426, -11.229104931204843],
              [-18.353360483607958, -11.228513537166132],
              [-18.352067484335418, -11.229168853098624],
              [-18.349449638305824, -11.229390893774891],
              [-18.348164090323273, -11.228021050593032],
              [-18.347415317021117, -11.22619373555805],
              [-18.347659971705056, -11.222932014326483],
              [-18.348288992894624, -11.220297628968536],
              [-18.350523538422998, -11.212972770743484],
              [-18.3498541306999, -11.2115067085612],
              [-18.351083824170594, -11.211239369643534],
              [-18.353077415549286, -11.20959005190894],
              [-18.355948149253944, -11.206342073425043],
              [-18.357125717808362, -11.204572294018492],
              [-18.35961329222823, -11.202223303886646],
              [-18.359612971579708, -11.201292596695477],
              [-18.355034617106337, -11.20069480448894],
              [-18.35426142152529, -11.199800004877254],
              [-18.355104770848335, -11.197236386793694],
              [-18.35604874030236, -11.195913790213124],
              [-18.35691140524638, -11.195748560317336],
              [-18.358195639115547, -11.194301457094866],
              [-18.360184854055888, -11.194758552447045],
              [-18.362581550012678, -11.194375647346806],
              [-18.363699469976638, -11.194582225564853],
              [-18.364977757834932, -11.197078263294383],
              [-18.36960147940366, -11.2007089672771],
              [-18.370775480842685, -11.201368655192208],
              [-18.38122732519416, -11.206223051755961],
              [-18.38545535108363, -11.207968665010952],
              [-18.38656430242601, -11.209290266009502],
              [-18.388337106858728, -11.21042022919545],
              [-18.39190649814281, -11.211700197116423],
              [-18.393259666959402, -11.212455912610704],
              [-18.394548867027, -11.214074870252766],
              [-18.396320226000427, -11.215070291782114],
              [-18.39616953156468, -11.215915760748153],
              [-18.39798346025045, -11.216822378366958],
              [-18.39839782370736, -11.218762519413604],
              [-18.40291442156279, -11.220148545527074],
              [-18.404009921386592, -11.220688673361376],
              [-18.405556727755044, -11.222364985845479],
              [-18.409370905353548, -11.224622218745786],
              [-18.41379218015004, -11.226501336410712],
              [-18.416362203058373, -11.227903595352947],
              [-18.42251830628587, -11.231795667217346],
              [-18.426362445443857, -11.234683629511967],
              [-18.42952096753978, -11.237598810192102],
              [-18.430126422597155, -11.23908885916916],
              [-18.431380567639312, -11.239155335647515],
              [-18.434794168145476, -11.241952892546513],
              [-18.439428671548708, -11.244832156061648],
              [-18.444519224058812, -11.250263893777007],
              [-18.448027679045275, -11.255398186779914],
              [-18.45074899739258, -11.26049434731598],
              [-18.45463974646898, -11.269120103233266],
              [-18.454789596876314, -11.264803554507708],
              [-18.45511055447199, -11.261705462321178],
              [-18.456754959101243, -11.25767603945578],
              [-18.459177723061682, -11.253685568200588],
              [-18.463039059002003, -11.25048459162269],
              [-18.46582361225764, -11.249328288764241],
              [-18.467990880708005, -11.249659723264076],
              [-18.468294689305747, -11.250692244232964],
              [-18.46995993733877, -11.252372511700692],
              [-18.474779338132322, -11.252515859684372],
              [-18.476700548773415, -11.252147594477071],
              [-18.477939392859522, -11.251445219900269],
              [-18.479430696292024, -11.252291595154235],
              [-18.479509311391375, -11.25402849999864],
              [-18.481400161109992, -11.254577774493441],
              [-18.483340921258296, -11.2565905964332],
              [-18.484091194694333, -11.25815227392131],
              [-18.48746368314688, -11.260634388068128],
              [-18.488038404226625, -11.260490505052584],
              [-18.492450764312878, -11.262558364118462],
              [-18.49194574927527, -11.262275793345333],
              [-18.48602159966819, -11.207587830725137],
              [-18.456232826779168, -11.21065575306727],
              [-18.453091631846977, -11.180947604933316],
              [-18.44372208197958, -11.181897427264976],
              [-18.437488051259567, -11.122466179705093],
              [-18.40761944625114, -11.125444693626683],
              [-18.404579043914893, -11.095716055511993],
              [-18.3747798582262, -11.098613013805206],
              [-18.371826028017054, -11.068873494911696],
              [-18.36181578169194, -11.069829826432692],
              [-18.357656050250164, -11.027730206989819],
              [-18.355940445612816, -11.01033744323313],
              [-18.326059755345504, -11.013142445516092],
              [-18.320339654295186, -10.953623389279391],
              [-18.279955618664527, -10.957294172050673],
              [-18.27444649377484, -10.897744577151043],
              [-18.244553452585205, -10.900372558210822],
              [-18.241245088011897, -10.863545144260275],
              [-18.239201672959158, -10.840797788205833],
              [-18.22819314073651, -10.841746353156994],
              [-18.225546252871965, -10.811952469621758],
              [-18.195568133578956, -10.814483055682587],
              [-18.190433080412497, -10.754873882881395],
              [-18.16060757852392, -10.75731487369553],
              [-18.15811963973758, -10.727500256464785],
              [-18.14642262401332, -10.728436155977613],
              [-18.141509144835744, -10.668795319647861],
              [-18.111597545920684, -10.67113582590515],
              [-18.109221010914112, -10.641305773421557],
              [-18.07938363899205, -10.643562690425549],
              [-18.077087707121454, -10.613724126231986],
              [-18.064679995926767, -10.614640057924099],
              [-18.062417740157308, -10.584796886492239],
              [-18.047336663919978, -10.585891700822275],
              [-17.882303258634952, -10.596566086114217],
              [-17.88407693289452, -10.626439317740278],
              [-17.85395941019595, -10.628129737536199],
              [-17.85226672184996, -10.598251094332117],
              [-17.822225545440237, -10.59985720989503],
              [-17.820612819663552, -10.569973343310433],
              [-17.760679737929014, -10.57294144854554],
              [-17.762129809432118, -10.602833078197762],
              [-17.729241047565377, -10.604327979963616],
              [-17.565208758211195, -10.610370945710773],
              [-17.564367556337608, -10.610396921274306]
            ]
          ],
          [
            [
              [-18.510600651333384, -11.346386495775123],
              [-18.509933684097774, -11.34618535765313],
              [-18.50786418708391, -11.34174976329319],
              [-18.508267293856765, -11.33827790818524],
              [-18.50713138507726, -11.3338328725983],
              [-18.50832238629083, -11.33122328206465],
              [-18.506859661584155, -11.328356583831034],
              [-18.505549154584234, -11.32508939175414],
              [-18.504816945931, -11.320756867536474],
              [-18.502822953377105, -11.318568745153513],
              [-18.502665120283343, -11.316467544681995],
              [-18.501272972734036, -11.31308310015031],
              [-18.50147660843607, -11.310174873249096],
              [-18.502219067724702, -11.309434343297887],
              [-18.498303573655217, -11.308475095648577],
              [-18.494839010284586, -11.307275553500212],
              [-18.491918567104094, -11.305292074496956],
              [-18.490573032863665, -11.303252063710689],
              [-18.488166337287154, -11.302005812299962],
              [-18.48650147296793, -11.30181517402742],
              [-18.483565967209884, -11.300067662591962],
              [-18.47872280453019, -11.298473547280553],
              [-18.475037480298273, -11.296567163710565],
              [-18.471434711527266, -11.297255935538006],
              [-18.46924519837918, -11.297202199573587],
              [-18.46639653135544, -11.297663244334744],
              [-18.46298620605133, -11.29689991102414],
              [-18.460835201739325, -11.295773346157526],
              [-18.456955160833278, -11.292175425456678],
              [-18.455651352823438, -11.291283004204407],
              [-18.453273927797056, -11.291041594107773],
              [-18.451090250529408, -11.28899099412637],
              [-18.449182332866325, -11.288577647323988],
              [-18.446586416766618, -11.28950740072944],
              [-18.4439770673402, -11.286228467056993],
              [-18.443090337476427, -11.285592220116607],
              [-18.44145096521879, -11.281739072752126],
              [-18.440617422367083, -11.281413101824377],
              [-18.436762478171854, -11.281648472992945],
              [-18.43546853624729, -11.281033902372927],
              [-18.4338405120674, -11.279188798189999],
              [-18.43382202014558, -11.277692672035716],
              [-18.43244672495353, -11.275680029828454],
              [-18.430721456149495, -11.27559143462764],
              [-18.4302672093599, -11.276311141940946],
              [-18.431457380974567, -11.278007234898396],
              [-18.43253334888381, -11.280540202951242],
              [-18.43486803603313, -11.285132853584082],
              [-18.43657693710404, -11.28807031769511],
              [-18.441532677295132, -11.295921293379198],
              [-18.448811940508033, -11.306113307755721],
              [-18.45078847778183, -11.30925695832468],
              [-18.451618161435746, -11.311743289930922],
              [-18.453601927257083, -11.315313007049877],
              [-18.453828362220456, -11.31640282746423],
              [-18.455338439527527, -11.31883154093484],
              [-18.456157829116027, -11.321185005948896],
              [-18.459507163011747, -11.325656840385413],
              [-18.460964113413148, -11.328688165415292],
              [-18.46458999508312, -11.333769206982344],
              [-18.46693533480493, -11.337403951109222],
              [-18.469480899081034, -11.342094541818652],
              [-18.47055732727238, -11.34452974111573],
              [-18.471723908388302, -11.34801320303296],
              [-18.473548215204854, -11.352159939191418],
              [-18.474908535121408, -11.354080207454064],
              [-18.48043738225004, -11.358423742224703],
              [-18.481778388276254, -11.359304079193205],
              [-18.4843105623364, -11.360086239602152],
              [-18.487186921137102, -11.360348530141376],
              [-18.488085014824257, -11.361221899911891],
              [-18.490405037280226, -11.362450547034362],
              [-18.493589420100626, -11.360457395336516],
              [-18.49697846010133, -11.360069256828135],
              [-18.50142503813446, -11.358694516458705],
              [-18.504096146109347, -11.35858162641399],
              [-18.50567878099256, -11.35920894438965],
              [-18.50600680777997, -11.360255283589218],
              [-18.50869388454743, -11.360734614226896],
              [-18.510015855107014, -11.361816322194805],
              [-18.512148711102256, -11.359105843339192],
              [-18.51152079856732, -11.358628472240541],
              [-18.51103464279988, -11.356392796026823],
              [-18.509197429309868, -11.352783505806148],
              [-18.509636441441913, -11.350330252546437],
              [-18.51108963053466, -11.348015991436405],
              [-18.510600651333384, -11.346386495775123]
            ]
          ],
          [
            [
              [-18.498327175832674, -11.266438746326658],
              [-18.50163122043175, -11.26931794255843],
              [-18.50388108130441, -11.269322695631253],
              [-18.507570889482597, -11.270334420411947],
              [-18.5094211253852, -11.27165308419265],
              [-18.51140455295651, -11.273981117926535],
              [-18.513657654691464, -11.272868309892248],
              [-18.515310697653852, -11.272778341509659],
              [-18.51798327070372, -11.27390224093677],
              [-18.51954416715488, -11.27493084566046],
              [-18.520666660472454, -11.27726495664746],
              [-18.520443277102572, -11.27876078726057],
              [-18.52133622947862, -11.27960460333318],
              [-18.522488443924683, -11.278692296820868],
              [-18.526999713695243, -11.2780612931294],
              [-18.531144469314594, -11.278406880165246],
              [-18.534961800296465, -11.279106491703308],
              [-18.538841344635394, -11.280161383133878],
              [-18.540718557659996, -11.280898034362941],
              [-18.54291641923094, -11.282368276322314],
              [-18.54352887155998, -11.28319874194842],
              [-18.542947204370442, -11.284372253373554],
              [-18.543348609606397, -11.286016282617378],
              [-18.54433503049835, -11.287002704254549],
              [-18.546108225229585, -11.287660868492281],
              [-18.548730997422535, -11.289619502121322],
              [-18.54963230442936, -11.290923856755857],
              [-18.555702225607455, -11.290252534060347],
              [-18.552312808301643, -11.26059112373585],
              [-18.498327175832674, -11.266438746326658]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -158.23456645153072,
          "lat": 59.800289954260435
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02070"],
        "coty_name": ["Dillingham"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Dillingham Census Area"],
        "coty_fp_code": "070",
        "coty_gnis_code": "01419968"
      },
      "bbox": [
        -18.555702225607455, -11.449174556634883, -17.564367556337608,
        -10.569973343310433
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.9927447311618, -4.921354492710982],
            [-13.866602678772233, -4.9443948099716515],
            [-13.740456947223576, -4.967414398225242],
            [-13.647799149960372, -4.983780221940867],
            [-13.49060576488174, -5.011775067115953],
            [-13.366050531479788, -5.033038595991872],
            [-13.321288036256604, -5.040162275584284],
            [-13.190301530235292, -5.062881556499511],
            [-13.05931127278562, -5.085578597403685],
            [-12.956610094487703, -5.103090153828054],
            [-12.853906647104997, -5.120588058317807],
            [-12.719447527032942, -5.143180470664858],
            [-12.552566416856635, -5.170809087844047],
            [-12.5347211601258, -5.173685905189171],
            [-12.535600137414342, -5.179002399489582],
            [-12.449903059956608, -5.193109469450429],
            [-12.37051340025729, -5.206042470757135],
            [-12.256986106857514, -5.224093225870686],
            [-12.251168913792926, -5.224824579116068],
            [-12.194790908375785, -5.234109979527301],
            [-12.193191614807661, -5.224597497563076],
            [-12.101867014556383, -5.239072943109409],
            [-12.00346004592837, -5.254766007274228],
            [-11.979203852303483, -5.258099924741839],
            [-11.934485796458972, -5.265737526923376],
            [-11.934071145382076, -5.263018889566887],
            [-11.884840695986187, -5.270752422762432],
            [-11.774882760661205, -5.28788464996951],
            [-11.653485863980983, -5.306469894843749],
            [-11.64856463269378, -5.306933767289248],
            [-11.607931161420606, -5.313339689022285],
            [-11.62066649828378, -5.398956412511837],
            [-11.633799113533623, -5.484679326906283],
            [-11.647096480814417, -5.570880461617987],
            [-11.644361189691086, -5.571285411833718],
            [-11.66261857650726, -5.686047098123135],
            [-11.672718779202118, -5.743071501125224],
            [-11.674075987129603, -5.742906060061761],
            [-11.688087388740197, -5.834132528690344],
            [-11.700043364250348, -5.915476275365313],
            [-11.713524657841685, -6.001389341605839],
            [-11.714515567583183, -6.001222159828273],
            [-11.727740032267581, -6.087006651842809],
            [-11.816627976637088, -6.07329206053432],
            [-11.901231116033562, -6.060165819071856],
            [-12.024554407417124, -6.040750661177938],
            [-12.065276844294718, -6.034358194524225],
            [-12.06605817216425, -6.039283260710063],
            [-12.151145780672524, -6.025875833675117],
            [-12.257223016814711, -6.009879620818231],
            [-12.324128064537287, -5.999235614354936],
            [-12.338504342787225, -6.085669388227362],
            [-12.339365236580386, -6.0929258515232165],
            [-12.352205832968398, -6.1722223424311045],
            [-12.352054693726243, -6.17888416511118],
            [-12.356309751865991, -6.200568094157691],
            [-12.373194476481675, -6.198783190871148],
            [-12.526676958029094, -6.173494822449327],
            [-12.534272506875393, -6.223772806914813],
            [-12.541615871037127, -6.267432557496864],
            [-12.608270227258362, -6.229165749688989],
            [-12.69404259733936, -6.179786426270779],
            [-12.743498296436258, -6.151521247513445],
            [-12.85898608159828, -6.085318717175465],
            [-12.940983212245888, -6.038086674973773],
            [-13.02296805103489, -5.990838458475878],
            [-13.12729753203318, -5.930774557431272],
            [-13.231607406577975, -5.870684946529904],
            [-13.324528818940047, -5.817216078330564],
            [-13.332975053062185, -5.812855636337823],
            [-13.351372665646624, -5.801788172704988],
            [-13.478642872565993, -5.728753550888908],
            [-13.513921340148327, -5.7084490257641605],
            [-13.614847780339996, -5.650126932366202],
            [-13.715756462278698, -5.591781831706286],
            [-13.8164532949026, -5.534404267390564],
            [-13.917133052769584, -5.477004506089251],
            [-13.987690633705364, -5.434355188018197],
            [-14.077714581734472, -5.380584444891297],
            [-14.008500567543358, -5.006612569487533],
            [-13.9927447311618, -4.921354492710982]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.78991433831504,
          "lat": 32.09743874856121
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04019"],
        "coty_name": ["Pima"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pima County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00025446"
      },
      "bbox": [
        -14.077714581734472, -6.267432557496864, -11.607931161420606,
        -4.921354492710982
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.727740032267581, -6.087006651842809],
            [-11.745536788702406, -6.202768872137851],
            [-11.752674378024118, -6.201734697591651],
            [-11.7615208804331, -6.258887991413416],
            [-11.77473031244618, -6.343802394397809],
            [-11.773892218431488, -6.3439301125333865],
            [-11.784525991578404, -6.412933453645621],
            [-11.79459315291056, -6.479054471297993],
            [-11.931181638596566, -6.457736848280317],
            [-12.076800815181747, -6.434744129212527],
            [-12.202773672258763, -6.416067234488738],
            [-12.249499463810404, -6.409088187928254],
            [-12.311833061835104, -6.399142115526766],
            [-12.35187663849217, -6.375856478902541],
            [-12.446754700050043, -6.321655782375301],
            [-12.541615871037127, -6.267432557496864],
            [-12.534272506875393, -6.223772806914813],
            [-12.526676958029094, -6.173494822449327],
            [-12.373194476481675, -6.198783190871148],
            [-12.356309751865991, -6.200568094157691],
            [-12.352054693726243, -6.17888416511118],
            [-12.352205832968398, -6.1722223424311045],
            [-12.339365236580386, -6.0929258515232165],
            [-12.338504342787225, -6.085669388227362],
            [-12.324128064537287, -5.999235614354936],
            [-12.257223016814711, -6.009879620818231],
            [-12.151145780672524, -6.025875833675117],
            [-12.06605817216425, -6.039283260710063],
            [-12.065276844294718, -6.034358194524225],
            [-12.024554407417124, -6.040750661177938],
            [-11.901231116033562, -6.060165819071856],
            [-11.816627976637088, -6.07329206053432],
            [-11.727740032267581, -6.087006651842809]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.84653701213925,
          "lat": 31.525950168177232
        },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04023"],
        "coty_name": ["Santa Cruz"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Santa Cruz County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00040472"
      },
      "bbox": [
        -12.541615871037127, -6.479054471297993, -11.727740032267581,
        -5.999235614354936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1546857581911523, -4.369072615692465],
            [2.155285242338135, -4.441708002845708],
            [2.155304542224286, -4.456717166575125],
            [2.165656248612963, -4.456555751334691],
            [2.1661343375054094, -4.53335086800299],
            [2.1804518319777944, -4.533738421893869],
            [2.2115530115472852, -4.533626636078721],
            [2.2524691800213152, -4.5341700482663025],
            [2.2527215494334776, -4.593071090616917],
            [2.2531351964334125, -4.643744256491925],
            [2.25457397223749, -4.709846204923572],
            [2.2545579528514423, -4.768119789845516],
            [2.2544007390708867, -4.85577477034328],
            [2.254002347120997, -4.8850681159040725],
            [2.25357245265269, -4.971594078213543],
            [2.202742792190776, -4.971897068834153],
            [2.1500459920419512, -4.971178447853966],
            [2.148426474223484, -4.971081630811072],
            [2.147998515879192, -4.967008620389185],
            [2.1439447498254123, -4.960900146090503],
            [2.141456200559127, -4.960958241096394],
            [2.139727248474929, -4.956095739480835],
            [2.139555559854294, -4.948323168818189],
            [2.1430237057855397, -4.945435630853887],
            [2.1465454229025096, -4.936580130448656],
            [2.141291370326955, -4.934718805136976],
            [2.1430060019691513, -4.927184622276919],
            [2.1375482152873047, -4.921328025099165],
            [2.135326494726984, -4.914673468693349],
            [2.1308975605980214, -4.9074411307991115],
            [2.123617956025532, -4.901651011412328],
            [2.118303382097355, -4.894460530641749],
            [2.1175839134203946, -4.8916074481635325],
            [2.1100810517111133, -4.8880192041380806],
            [2.1114442954562347, -4.884343329103544],
            [2.106941619890468, -4.881728893789645],
            [2.107133379255817, -4.878067467163299],
            [2.0994098874938296, -4.869846357867086],
            [2.0943028996971123, -4.865556989157697],
            [2.0949031326427527, -4.861059673444101],
            [2.097992379246152, -4.854997530499274],
            [2.0930990155480607, -4.848612089489689],
            [2.0881641592304585, -4.846530456499897],
            [2.0862240396702236, -4.847415934918487],
            [2.0770846112457866, -4.842534667674327],
            [2.071470618793886, -4.84105327950494],
            [2.069518900844643, -4.838012741869182],
            [2.0699419560082837, -4.8331002366761915],
            [2.0664219164423656, -4.828120594364414],
            [2.0655983755140768, -4.823050662152279],
            [2.067361820267794, -4.819362764099003],
            [2.0642047507550547, -4.814487909414169],
            [2.061577953917334, -4.815571607964846],
            [2.059213376509258, -4.808128890010198],
            [2.057589532627229, -4.808049393558416],
            [2.05291656628793, -4.796206745542594],
            [2.0556069961663037, -4.791003865012357],
            [2.052880552882373, -4.781708061933663],
            [2.0556441955761007, -4.779713962068015],
            [2.0565524066208245, -4.772730287203428],
            [2.0549566370287993, -4.76801865128527],
            [2.05682842718854, -4.763670469515675],
            [2.0604263489153625, -4.762164299335147],
            [2.060600701218245, -4.754035237620396],
            [2.0563570544968477, -4.749748822880593],
            [2.05549179334694, -4.744830278687478],
            [2.055072923328632, -4.7337913305602015],
            [2.0530420386448767, -4.72832773924084],
            [2.054426624408888, -4.725638167035355],
            [2.0491709899298387, -4.721314351070698],
            [2.05072838753495, -4.712443404903939],
            [2.044521458096606, -4.708628536092829],
            [2.0450221391536783, -4.705405389287729],
            [2.04157061395553, -4.703906028447148],
            [2.041619792271956, -4.700525216557711],
            [2.038199311301048, -4.694889882455272],
            [2.0405149204957445, -4.691952616710924],
            [2.037159620831185, -4.688504490585129],
            [2.038128208019549, -4.67875693702789],
            [2.0403082780392676, -4.6741869868603585],
            [2.036633287735591, -4.669614075613441],
            [2.0392685362834295, -4.665439723921695],
            [2.0397034766048923, -4.661168872967941],
            [2.046909801617526, -4.659040743673401],
            [2.0473921789510463, -4.654537773418425],
            [2.0450215857442315, -4.650568514603834],
            [2.039505284250581, -4.653610843834708],
            [2.0370980480375, -4.650166448999844],
            [2.032794196470247, -4.6485942430826865],
            [2.029295891745133, -4.645164379684647],
            [2.0335347620757003, -4.64230400720274],
            [2.0336509952134842, -4.637835402215852],
            [2.0365078638899927, -4.633449409318804],
            [2.0391716669500513, -4.619704256205797],
            [2.0353770189059164, -4.618808012244041],
            [2.03113697388118, -4.614073805510107],
            [2.0300785417055747, -4.610933410216829],
            [2.0369817639299574, -4.600578798505226],
            [2.0404881838972693, -4.597187862104387],
            [2.0310693573305363, -4.59019752096829],
            [2.0234954637704132, -4.588646816216038],
            [2.0217504197869234, -4.584909946739966],
            [2.0245222186146226, -4.583273347944563],
            [2.0292501201592286, -4.5850798497740115],
            [2.0311593877698684, -4.582188300886206],
            [2.0255691513743646, -4.578544415622114],
            [2.0304197315499675, -4.5735253780757565],
            [2.030940091902423, -4.56637129585242],
            [2.022870577356995, -4.564891692819817],
            [2.0266703606635708, -4.5596012457296],
            [2.024126376902547, -4.555519408744774],
            [2.0272095016486507, -4.553412162612705],
            [2.0268364600744286, -4.543433032367357],
            [2.030810534945441, -4.542703442293403],
            [2.031697820859063, -4.536093104880439],
            [2.0244907028901262, -4.531696405961661],
            [1.9766785150900925, -4.531490079026453],
            [1.9477439822093097, -4.531771941574821],
            [1.905103250915005, -4.532600254055837],
            [1.9035916462119997, -4.455700582186779],
            [1.8934491324814504, -4.455723973297504],
            [1.8931576815172768, -4.368711862369566],
            [1.9028583604297082, -4.368666303506441],
            [2.06669546179965, -4.369001068025184],
            [2.1546857581911523, -4.369072615692465]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.99356384262568, "lat": 34.08895432182177 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05061"],
        "coty_name": ["Howard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Howard County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00066872"
      },
      "bbox": [
        1.8931576815172768, -4.971897068834153, 2.25457397223749,
        -4.368666303506441
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.8646054357412507, -3.619214742569674],
            [2.8834100474501567, -3.619510119825413],
            [2.9279559936789425, -3.618908384106962],
            [2.92810878999599, -3.618406997897554],
            [2.9710351854935597, -3.6180858684234227],
            [3.006734632933181, -3.617589419956623],
            [3.0424014583530816, -3.617433092037422],
            [3.0998741504818104, -3.6160718897966238],
            [3.125599622752947, -3.6157142584882744],
            [3.1276628806679323, -3.6129991879228625],
            [3.133348639804127, -3.615105341948736],
            [3.1434310695809344, -3.6135877878576195],
            [3.1583093117168897, -3.60908549515734],
            [3.161292428482733, -3.606454185191311],
            [3.171624334310302, -3.593018347195436],
            [3.175301075544463, -3.5850667596499264],
            [3.184310074236102, -3.5748530426466942],
            [3.1930188639967487, -3.570010632949944],
            [3.1965000227055564, -3.5699378186338855],
            [3.2033372885314315, -3.575756495313028],
            [3.2043404395781274, -3.584934749251713],
            [3.203074095793255, -3.5888265626852562],
            [3.196921282664473, -3.5945776535202363],
            [3.1867108220605007, -3.599545686203273],
            [3.1830680574006363, -3.6031440765068377],
            [3.182711653499512, -3.6082422400822614],
            [3.1898580128078966, -3.6100088121206295],
            [3.2000712988071647, -3.6083482355527057],
            [3.2117565761467595, -3.604880273796524],
            [3.2196267405264445, -3.601408751235057],
            [3.224988419208407, -3.596870773897153],
            [3.2287097347307836, -3.5918814356515165],
            [3.2341298830985608, -3.581181879314678],
            [3.242163033749595, -3.571016234875545],
            [3.24809112548271, -3.5680072064867896],
            [3.252649332755454, -3.5676471984968305],
            [3.257475709579481, -3.569196227668209],
            [3.2609530152441537, -3.5722041553727237],
            [3.2631251078431927, -3.576693725496885],
            [3.26954707671483, -3.594635782783678],
            [3.269764174379793, -3.6107567090721013],
            [3.2684695408226325, -3.6223953781280884],
            [3.266336776299219, -3.629256616395772],
            [3.262336702907197, -3.6382965031253756],
            [3.2531285933345195, -3.6506575769752057],
            [3.248922982837618, -3.6544543001724232],
            [3.2366757712617233, -3.663249241159565],
            [3.2301943936595277, -3.670098515655373],
            [3.226188627041406, -3.6780299732745974],
            [3.2252441512721775, -3.6838929417705186],
            [3.226612513822729, -3.6915182191515497],
            [3.2328025569574903, -3.705141237133006],
            [3.238338964870352, -3.7127969352671775],
            [3.2471875991260757, -3.7206139962694467],
            [3.25780524317088, -3.726707506746166],
            [3.2716602403127393, -3.7303588593309915],
            [3.2719769125512164, -3.746989483674111],
            [3.188044262849202, -3.7471193323905494],
            [3.1872730673346643, -3.7477597280129644],
            [3.1875397866920356, -3.7763877743543257],
            [3.1590112529503562, -3.7771245998969074],
            [3.102774853720074, -3.777908410839962],
            [3.1035399917306505, -3.836110438736644],
            [3.1162866884483758, -3.8358220347686878],
            [3.1166922130464525, -3.861750665849695],
            [3.1122560968464628, -3.8552178333926594],
            [3.1080484141193456, -3.8536883641500306],
            [3.103201713410218, -3.847306876026014],
            [3.0943857225079396, -3.8509872675559813],
            [3.090921793634651, -3.8478440178299365],
            [3.0835786292410305, -3.850977903569973],
            [3.068671179744193, -3.843585819135592],
            [3.0649587286966318, -3.8395980667532053],
            [3.0599225728321366, -3.8442881911168327],
            [3.0486820253510802, -3.8423868289540706],
            [3.044108340483747, -3.8394416114711345],
            [3.0429649615307004, -3.8365380318810565],
            [2.9292852680572685, -3.8364994150103917],
            [2.8442661057828142, -3.8400272104763564],
            [2.845170368019926, -3.8973022848215013],
            [2.845994792601462, -3.9268467454739597],
            [2.6873335854243616, -3.931489532235987],
            [2.6728373309570013, -3.930612492503371],
            [2.669911034269562, -3.8424995701559634],
            [2.655606391764525, -3.8427253954812772],
            [2.6553424165911435, -3.828223934215141],
            [2.6694423454854532, -3.8280200148756567],
            [2.669185954297554, -3.8143332543965776],
            [2.6834208805156674, -3.813673912141722],
            [2.683237548474686, -3.7990252817414394],
            [2.697702913231829, -3.798497545672682],
            [2.6975053457167117, -3.7839887679718602],
            [2.711555217525955, -3.78370087615935],
            [2.7110932706936604, -3.7691157470519214],
            [2.725400364375204, -3.7685922799371685],
            [2.725047680032826, -3.7534165758482967],
            [2.7387391703563853, -3.753207548554571],
            [2.738687337388338, -3.738373897998102],
            [2.7535511411965823, -3.7383612709796625],
            [2.7534285930804954, -3.7238745537935483],
            [2.77063552840142, -3.7236703617702895],
            [2.7702118187500453, -3.7091166257326096],
            [2.7848331612874557, -3.708973163251977],
            [2.784715758962801, -3.6944027648026427],
            [2.7991040498839665, -3.6945122285787204],
            [2.7989284776915055, -3.6799119018339694],
            [2.8133796288065844, -3.6799543077836976],
            [2.8131961687336573, -3.663698271258408],
            [2.828057075254238, -3.663582398929765],
            [2.8276644189639377, -3.6491609471058286],
            [2.842092077468352, -3.6489075142924157],
            [2.841803850362373, -3.6342749790020785],
            [2.8561957546332692, -3.6341065337385294],
            [2.8559350809961783, -3.6195361478421697],
            [2.8646054357412507, -3.619214742569674]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.93126649357308, "lat": 34.94750269903122 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05105"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00069171"
      },
      "bbox": [
        2.6553424165911435, -3.931489532235987, 3.2719769125512164,
        -3.5676471984968305
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.084306113134627, -3.0523042324662346],
              [-18.079917597368766, -3.054000681493562],
              [-18.070551723017534, -3.060529240527774],
              [-18.06567454118246, -3.060384469445843],
              [-18.057650699001503, -3.0621059462145883],
              [-18.037142741302603, -3.0682917555576066],
              [-18.031702200213015, -3.066609164225881],
              [-18.02903428812396, -3.070896291217356],
              [-18.027438585476993, -3.0768899346853424],
              [-18.023066509252622, -3.079719591149923],
              [-18.022373659114944, -3.0843748804743054],
              [-18.01421394750892, -3.0932753760204377],
              [-18.008497339865073, -3.0967329692792447],
              [-18.007248580634624, -3.100871050082433],
              [-18.00878338720114, -3.106955202571454],
              [-18.00360851019623, -3.109021837671484],
              [-17.99306085703871, -3.105613458012295],
              [-17.98935353802537, -3.1064209287148317],
              [-17.9873023126761, -3.1126181678132845],
              [-17.984749885004714, -3.113150553182665],
              [-17.974217466961782, -3.1249856359010586],
              [-17.970410612788758, -3.1272326109956152],
              [-17.968297787050055, -3.131634758568214],
              [-17.9611835324934, -3.1336231225231685],
              [-17.95992822232542, -3.135843832937574],
              [-17.95584203590015, -3.1352771480527184],
              [-17.950766377164538, -3.13755043874186],
              [-17.94052305909814, -3.146269297293596],
              [-17.93829937232783, -3.14643459965284],
              [-17.930535504767832, -3.153833033829472],
              [-17.926659936495575, -3.152943374172097],
              [-17.92136941761598, -3.162564929766034],
              [-17.91722459060416, -3.1625880726312596],
              [-17.912066077853574, -3.16541144572571],
              [-17.910946561962675, -3.1679280655293947],
              [-17.91152910790866, -3.174014197705175],
              [-17.915051714470454, -3.1784173229477144],
              [-17.91493212870767, -3.185144901697292],
              [-17.91275912117788, -3.1868632662256253],
              [-17.90500188078029, -3.2036446256943],
              [-17.893527985161672, -3.2226248533482886],
              [-17.89242483600281, -3.2298652552626708],
              [-17.889265744998948, -3.2334066256576715],
              [-17.888828456616096, -3.2377011284939594],
              [-17.88586292313605, -3.2405107158002893],
              [-17.881055006603265, -3.2498380798510027],
              [-17.881719509574033, -3.261358704078348],
              [-17.88040519950011, -3.2643408190654224],
              [-17.882633806141463, -3.2747373743001713],
              [-17.889126338291934, -3.277037905184922],
              [-17.8942337839191, -3.2814607645285125],
              [-17.901545321995187, -3.2818451839285303],
              [-17.914638695662017, -3.2723503870555586],
              [-17.921504205190203, -3.2625671015966984],
              [-17.93164224131461, -3.2558587051185373],
              [-17.93660159255834, -3.251765734350582],
              [-17.94428394279315, -3.248939462746666],
              [-17.951456499070353, -3.2486264732476324],
              [-17.963524906959393, -3.2438359999009494],
              [-17.97706739160383, -3.2443649556967027],
              [-17.986294322754116, -3.2398080681932613],
              [-17.990463272483986, -3.2404081032925203],
              [-18.001994733229807, -3.2342615700440285],
              [-18.00830603397705, -3.2283645464847215],
              [-18.013464598279118, -3.2186992779592445],
              [-18.018169909825257, -3.2070959581662755],
              [-18.02026651895253, -3.1998164366273376],
              [-18.019742796173908, -3.190089176257703],
              [-18.016560889704007, -3.1853127022511614],
              [-18.011869202646665, -3.1821590123660406],
              [-18.013724622922865, -3.178606070908154],
              [-18.009217929857535, -3.1765596875133437],
              [-18.009309322710816, -3.1720756752990136],
              [-18.002857473995213, -3.1705499046759447],
              [-18.0060983368935, -3.163817843984826],
              [-18.005390447988308, -3.156631611037472],
              [-18.006883673664134, -3.1510312327217207],
              [-18.00649594123663, -3.142792461689424],
              [-18.00379389894154, -3.140445966109679],
              [-18.005469373127454, -3.137704362333981],
              [-18.005041092023642, -3.132187754321574],
              [-18.009581516096368, -3.1287126306574606],
              [-18.012249463082735, -3.1287753613795335],
              [-18.016250472270304, -3.1249290871290136],
              [-18.021206791852567, -3.1181155710778534],
              [-18.024575135761488, -3.123664410339892],
              [-18.030247768180836, -3.1148332861177104],
              [-18.03903436468052, -3.114317003068122],
              [-18.040731364663124, -3.1082962015629994],
              [-18.047331557933365, -3.107167589886476],
              [-18.05273516326778, -3.1043547603353367],
              [-18.055359967099754, -3.10603482278899],
              [-18.06178022451504, -3.1034484769555406],
              [-18.06298386263939, -3.099928140790554],
              [-18.07003444024226, -3.095455871563586],
              [-18.067543204719186, -3.0924850004826965],
              [-18.068527950523798, -3.087459346478141],
              [-18.0711275038231, -3.0857539332897646],
              [-18.074841936652813, -3.0776750365635848],
              [-18.076647494422446, -3.071777918195123],
              [-18.079999273957693, -3.067195957457607],
              [-18.078589071581472, -3.0654348906687026],
              [-18.083769281093723, -3.061434422145109],
              [-18.086607139030676, -3.0518537410241913],
              [-18.084306113134627, -3.0523042324662346]
            ]
          ],
          [
            [
              [-18.194916059568243, -3.4863529496941776],
              [-18.184683489289437, -3.485327138490951],
              [-18.1820123814801, -3.4919462445167913],
              [-18.175956154668462, -3.4921745946710265],
              [-18.169765791603837, -3.4908670468714833],
              [-18.16584724645058, -3.4958540255810147],
              [-18.16274153418999, -3.502371215887627],
              [-18.163873537985914, -3.5070397948907597],
              [-18.16241469603496, -3.5211926450819866],
              [-18.158949662409007, -3.5220293648068153],
              [-18.155271655759876, -3.5270363780967524],
              [-18.156120456282835, -3.5406329419647293],
              [-18.15261086280562, -3.550544039487766],
              [-18.147923692055617, -3.5551010843984865],
              [-18.147558226924218, -3.5608287147346798],
              [-18.14145187308451, -3.5701297508159695],
              [-18.13855755087414, -3.576829114161061],
              [-18.13884532376279, -3.5812663988779168],
              [-18.128472540162427, -3.6049889958526324],
              [-18.121767237988582, -3.616907383426859],
              [-18.10944648993883, -3.627856894054149],
              [-18.10501178923839, -3.6353642085885283],
              [-18.101680639149592, -3.6452333123755647],
              [-18.08040669275994, -3.6763130941869377],
              [-18.063516252857855, -3.6992979582722008],
              [-18.056974185765196, -3.7103788921313434],
              [-18.04851568605499, -3.7218883301454],
              [-18.03705340874898, -3.7433457319120462],
              [-18.04343801223672, -3.745784034940204],
              [-18.047953755963515, -3.740785879332758],
              [-18.055880073265275, -3.737239102719787],
              [-18.059538461209648, -3.733805907741786],
              [-18.066378684848658, -3.7308069372539863],
              [-18.074277265252398, -3.7313893177007404],
              [-18.079181132263127, -3.733100823488751],
              [-18.083182751217958, -3.7403911182364364],
              [-18.09546568463699, -3.741364922717762],
              [-18.099744742048856, -3.7430197638294938],
              [-18.10467866456033, -3.7472337997536513],
              [-18.10592355277093, -3.7366272492721744],
              [-18.107498149671557, -3.7318856570791707],
              [-18.111014533318766, -3.7299602680756507],
              [-18.115350033330234, -3.7233491725118695],
              [-18.118646206396825, -3.7236715553272357],
              [-18.122931986400808, -3.7153027091099164],
              [-18.12681980485079, -3.7101579808491674],
              [-18.13216250331304, -3.7059033203627765],
              [-18.132772518938772, -3.7003120409463195],
              [-18.141860475572358, -3.69466077720892],
              [-18.145772222384576, -3.691244734697859],
              [-18.145368156956202, -3.6875474340241605],
              [-18.15294863826954, -3.6824223556936655],
              [-18.15104236178289, -3.678591953949441],
              [-18.151540609112143, -3.671872906090334],
              [-18.15473343663837, -3.6654951568375393],
              [-18.154332055629467, -3.6611378797542424],
              [-18.151702765281726, -3.6556676752923094],
              [-18.160304460892736, -3.6460077108407165],
              [-18.16277833533506, -3.6366699216187444],
              [-18.16439098571553, -3.6246126575754274],
              [-18.169394092219736, -3.6228696938040095],
              [-18.17219595084623, -3.6169165453234635],
              [-18.170454329987557, -3.6106203932277894],
              [-18.174467799811133, -3.6087819175200213],
              [-18.171293921221917, -3.6044358301527195],
              [-18.17132540288988, -3.5978324411626867],
              [-18.173694616966216, -3.5934687373737706],
              [-18.171445543221914, -3.5808215355618813],
              [-18.174319539611492, -3.575181442043588],
              [-18.17520012682076, -3.5680447759013987],
              [-18.18154824731247, -3.5599177351725024],
              [-18.1844042562592, -3.549501608433362],
              [-18.183979886765847, -3.5410321902590307],
              [-18.18246314893277, -3.536124269880612],
              [-18.184244886076566, -3.533386978453032],
              [-18.18500858150396, -3.5170504195905665],
              [-18.18597114223821, -3.5097619534409907],
              [-18.18904710603626, -3.5081642957340327],
              [-18.19137349061806, -3.503646175178744],
              [-18.196292170132445, -3.5044332116457193],
              [-18.198787702308973, -3.503129536320809],
              [-18.194916059568243, -3.4863529496941776]
            ]
          ],
          [
            [
              [-17.991649616679172, -1.7171933594131519],
              [-17.99585140991569, -1.6857342605351353],
              [-17.98464105673396, -1.6886199542285465],
              [-17.98870897676692, -1.692276573148359],
              [-17.9882893008396, -1.6982955068911925],
              [-17.98523950281963, -1.7036675489454356],
              [-17.96734192573608, -1.7079775357211284],
              [-17.963799590615473, -1.6938961926856944],
              [-17.95006822444364, -1.6974471513670022],
              [-17.83467571253882, -1.72499973691432],
              [-17.752933329967455, -1.7446641004646775],
              [-17.72076000632627, -1.7523035251921604],
              [-17.54575609435862, -1.793007326531224],
              [-17.51730173970013, -1.7994174337113775],
              [-17.461537784674295, -1.8126761627725299],
              [-17.42199934171502, -1.8216877698066771],
              [-17.30529698545959, -1.8475965879577685],
              [-17.220687208427982, -1.8670996131064834],
              [-17.10765465727283, -1.8927557131136663],
              [-17.023061409699565, -1.9132211137780173],
              [-17.052946548278015, -2.0432321118654455],
              [-17.083093191430137, -2.1730269010452874],
              [-17.07774883726514, -2.174280197342192],
              [-17.101376853927132, -2.2787131916978556],
              [-17.1102228137983, -2.3328917463161654],
              [-17.127747110292642, -2.4405335322886335],
              [-17.182383600469226, -2.5593208019796636],
              [-17.18635787432671, -2.564771712051912],
              [-17.194461934032468, -2.581189939319307],
              [-17.218279283493576, -2.6199279165726614],
              [-17.234657868363133, -2.6454686730513934],
              [-17.24991355753094, -2.672415739477278],
              [-17.255787185379496, -2.6876033152168852],
              [-17.261014167624865, -2.689299189772909],
              [-17.28536675870164, -2.6785130438215647],
              [-17.287694322756362, -2.6906981999162043],
              [-17.28956452026001, -2.6969780609676657],
              [-17.30371876414874, -2.6937530746436398],
              [-17.32429630669842, -2.7190029826932385],
              [-17.3258803462311, -2.7261189565614274],
              [-17.318883589113224, -2.7279293273610206],
              [-17.322068376984628, -2.741978251659473],
              [-17.315541738619803, -2.751312946708593],
              [-17.322368532762287, -2.749356005469236],
              [-17.370483441120072, -2.737794808926044],
              [-17.386780583534396, -2.735225306987692],
              [-17.418718655110364, -2.727387805253185],
              [-17.470507688436303, -2.71525396382396],
              [-17.48056735599016, -2.757591860291262],
              [-17.48768388786055, -2.7561495283132316],
              [-17.489235806159652, -2.7630035964982196],
              [-17.49632109600226, -2.761429403569434],
              [-17.49794331000347, -2.768589397403767],
              [-17.50501267602095, -2.7669841593928375],
              [-17.506611409455928, -2.774120643814277],
              [-17.513616650304623, -2.7725205320086674],
              [-17.51525825379364, -2.7797998384801517],
              [-17.529239765961847, -2.776617881485348],
              [-17.530826009785454, -2.783563813874132],
              [-17.538003181808897, -2.782108287287349],
              [-17.538797030459044, -2.78568857484338],
              [-17.542293592101696, -2.7849021315595213],
              [-17.543106214284514, -2.7884500536060055],
              [-17.546590159130456, -2.7876560825839145],
              [-17.54768088115285, -2.7926478582734955],
              [-17.551010230050796, -2.791911919691269],
              [-17.551969123248142, -2.795403557066043],
              [-17.555491386950223, -2.794723252806621],
              [-17.556297217792487, -2.798258223250867],
              [-17.559795129163394, -2.7974563304884175],
              [-17.562299484620265, -2.808225657170325],
              [-17.566630374935833, -2.8110089304271457],
              [-17.56925351741857, -2.8226359230692455],
              [-17.578127630173, -2.8255286320073374],
              [-17.590458753085187, -2.8349658560634707],
              [-17.59304909973193, -2.8405890098026627],
              [-17.605589607997814, -2.8560210862718507],
              [-17.60711912060377, -2.8612030201295258],
              [-17.605455153444748, -2.8710986097206046],
              [-17.60657054795399, -2.8770999118361136],
              [-17.626141245437967, -2.8842378832923967],
              [-17.628922555713963, -2.887503585464277],
              [-17.640502089395767, -2.8745031190479007],
              [-17.65338541417172, -2.8644553941739863],
              [-17.666978806601524, -2.857607149744627],
              [-17.67637611790211, -2.8537563815254265],
              [-17.67843081672204, -2.855702778438318],
              [-17.67722446419724, -2.8593240787248724],
              [-17.686304145848602, -2.8609537698357195],
              [-17.68756058722747, -2.8671783311345056],
              [-17.686764071280756, -2.8813789143309263],
              [-17.687808304067428, -2.884228906178882],
              [-17.695888468931923, -2.8823542027664364],
              [-17.70823995431781, -2.8664933705370887],
              [-17.7223559155523, -2.8681583964098127],
              [-17.731197489486053, -2.8631622352960453],
              [-17.732094494759632, -2.864125583695612],
              [-17.73059877311879, -2.8782352947804917],
              [-17.731651500940778, -2.8795307714016927],
              [-17.742363492002717, -2.8802997586466508],
              [-17.743142674455978, -2.8816644142454426],
              [-17.740035121047896, -2.888752266083996],
              [-17.7412582324171, -2.889857116393002],
              [-17.74911383560873, -2.886557737898238],
              [-17.751290265329192, -2.8802589835471997],
              [-17.756287659347812, -2.87912065912686],
              [-17.770459548836797, -2.8821018415544755],
              [-17.770508219858783, -2.8865871768956595],
              [-17.7763743499137, -2.8909909104537714],
              [-17.781337618620203, -2.890723920861475],
              [-17.781892734194333, -2.887010773293687],
              [-17.79539705190734, -2.8772792697947267],
              [-17.8154497559598, -2.8610359609930796],
              [-17.822169418497246, -2.8580027522210676],
              [-17.82366269906528, -2.8525060564905305],
              [-17.827262997266583, -2.846988950460498],
              [-17.829955064679236, -2.8449477784304995],
              [-17.83772495084709, -2.8439889869544825],
              [-17.83927711755387, -2.840359287376775],
              [-17.845919444845713, -2.837061505406381],
              [-17.8584408010553, -2.8397704024617996],
              [-17.860415675826854, -2.835017448446791],
              [-17.866377475741942, -2.8332445919712286],
              [-17.867224361774902, -2.8266149676563685],
              [-17.86610603233934, -2.8248460586725486],
              [-17.8673155247629, -2.8107537305475496],
              [-17.870307077476525, -2.809139442537298],
              [-17.868853592732492, -2.8037879754753483],
              [-17.86968559712488, -2.799881678721213],
              [-17.87273949613615, -2.7972556851119],
              [-17.868921033035527, -2.7945861277418476],
              [-17.867118444650963, -2.7906687336573777],
              [-17.861220015166662, -2.7869140465516318],
              [-17.851733088571464, -2.7845985562251663],
              [-17.850697701766336, -2.7787801353714836],
              [-17.848485554690185, -2.776806745819129],
              [-17.83831007219723, -2.7746427271111496],
              [-17.83483872179595, -2.7683808087849417],
              [-17.831344837504425, -2.7595248089841284],
              [-17.827746263957287, -2.7440420262133536],
              [-17.828608104350497, -2.741227653348715],
              [-17.833641468155548, -2.735068851665597],
              [-17.83427095173651, -2.730319983029554],
              [-17.83182319762593, -2.7283168844839025],
              [-17.830521608577158, -2.7237879818515642],
              [-17.8337552201201, -2.6936214983767264],
              [-17.84405647448812, -2.6323475949910025],
              [-17.84785134824462, -2.6120057625198987],
              [-17.863885652503384, -2.5703555629812027],
              [-17.87566504070728, -2.545157318428781],
              [-17.88927919683894, -2.527921264802684],
              [-17.902883767463113, -2.5159887674345858],
              [-17.908017850889603, -2.5142163106412267],
              [-17.912622950889467, -2.514641605443432],
              [-17.920013309950797, -2.5091682903653956],
              [-17.924330294343576, -2.5080022677454386],
              [-17.93492038083255, -2.5091775653837707],
              [-17.941828995132166, -2.505713758363066],
              [-17.950619292916794, -2.504426518625373],
              [-17.95610173737823, -2.5058165645511576],
              [-17.967297664433758, -2.5015600853352566],
              [-17.976991504779388, -2.5008928838759044],
              [-17.985590761198136, -2.49664785931899],
              [-17.987280558552463, -2.496998155974055],
              [-17.998114285383274, -2.4928286865894274],
              [-18.004579759324034, -2.4915773838788025],
              [-18.01104499180253, -2.4930502770241594],
              [-18.01615408269143, -2.497047664046804],
              [-18.025081326958976, -2.4927885289488803],
              [-18.03529580772835, -2.4935963180989202],
              [-18.041107419676113, -2.4903055711032436],
              [-18.04475239371835, -2.489506298183226],
              [-18.056988333832788, -2.484579250451468],
              [-18.06297958201908, -2.4834560171718527],
              [-18.07164201352252, -2.4843119126895377],
              [-18.075929597993927, -2.487781082964262],
              [-18.085106822797304, -2.4860480010375805],
              [-18.096533293672696, -2.485997782829322],
              [-18.100216537175505, -2.486650733895152],
              [-18.104811277852477, -2.489643627492522],
              [-18.111578062784275, -2.4984601587563713],
              [-18.1179375500335, -2.4983331357458916],
              [-18.12205205445818, -2.5027069004161726],
              [-18.130504378760183, -2.485547952245297],
              [-18.141971590327774, -2.469382482099444],
              [-18.152425434183616, -2.4595483484392244],
              [-18.158044473593584, -2.4582254374466883],
              [-18.16839562527355, -2.452186470703498],
              [-18.18380404705274, -2.447250490434844],
              [-18.189514433583884, -2.4432601821854067],
              [-18.19889094455421, -2.4411201080936467],
              [-18.205294561036197, -2.435115784270433],
              [-18.211934142067093, -2.4338652140330908],
              [-18.215310632482964, -2.435096061223196],
              [-18.221431066443543, -2.431312911808348],
              [-18.211545094083213, -2.40366196230472],
              [-18.131632773947775, -2.3694358629642256],
              [-18.067788247199445, -2.3420882272991226],
              [-18.015617326570702, -2.3551788985951907],
              [-18.006358825313182, -2.356647560369339],
              [-17.97148538254452, -2.3655670532175836],
              [-17.95395817638995, -2.2950564239113276],
              [-17.925874097399273, -2.3018257094951995],
              [-17.92045718036517, -2.279346558574822],
              [-17.91707265288813, -2.250680813294362],
              [-17.934523185941664, -2.127981887757798],
              [-17.94973055517862, -2.0209194071664394],
              [-17.96662730686331, -1.9018807764422887],
              [-17.974038503979877, -1.8489389049952059],
              [-17.991649616679172, -1.7171933594131519]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -118.2246754268036,
          "lat": 34.321916207979044
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06037"],
        "coty_name": ["Los Angeles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Los Angeles County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00277283"
      },
      "bbox": [
        -18.221431066443543, -3.7472337997536513, -17.023061409699565,
        -1.6857342605351353
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.231970140325416, 2.053149467192462],
            [-19.22154479974501, 2.053319595387744],
            [-19.218078497912547, 2.0566576542069686],
            [-19.218332536541897, 2.0607651927383275],
            [-19.222954968744464, 2.0658251900576876],
            [-19.228085739328005, 2.069451304493701],
            [-19.22946575892217, 2.0724132904791155],
            [-19.22808181943791, 2.0791011767292185],
            [-19.220028769080756, 2.086020259615916],
            [-19.207606361619476, 2.0899513224827184],
            [-19.203832038337417, 2.089715709644956],
            [-19.203035049153055, 2.096964902018172],
            [-19.195483715366834, 2.097163305862392],
            [-19.18877479929354, 2.100306316860061],
            [-19.183803422966, 2.099725372790426],
            [-19.181351395317805, 2.103421699082751],
            [-19.181920988334728, 2.106091517023282],
            [-19.177028232507002, 2.109918109412025],
            [-19.173867999495343, 2.1152461020447015],
            [-19.17011684549217, 2.1165756137585343],
            [-19.168788777670812, 2.1199437572094606],
            [-19.16953633769493, 2.126613453642666],
            [-19.165809937600404, 2.1302942783949814],
            [-19.16710732653013, 2.1393507824218143],
            [-19.1596718442757, 2.1457626176030895],
            [-19.157644058874837, 2.146511208584378],
            [-19.152448413852927, 2.144463243664452],
            [-19.14716856153806, 2.1499938076267915],
            [-19.14358419332615, 2.152039663499344],
            [-19.143155575296703, 2.1628395813332837],
            [-19.13714861089452, 2.1656724096094555],
            [-19.12991775546958, 2.1645683928142807],
            [-19.128030535380827, 2.168755198700643],
            [-19.12507047870678, 2.1705544041560167],
            [-19.122709028806963, 2.175950510303315],
            [-19.11532457001237, 2.1797154609064657],
            [-19.11429289347561, 2.1873675582314287],
            [-19.109822202031843, 2.1908641283398445],
            [-19.105768454117197, 2.1916478182226804],
            [-19.098923655321634, 2.1890197091140604],
            [-19.091784660601792, 2.18228210469972],
            [-19.086772905928697, 2.183240553972607],
            [-19.079875264857503, 2.178654935644915],
            [-19.075774101603653, 2.177953061218784],
            [-19.073902508612324, 2.1729706104950854],
            [-19.07696317753241, 2.167950643932178],
            [-19.073991230551457, 2.1592266577241905],
            [-19.070802349469343, 2.156647022731047],
            [-19.068442777402907, 2.152147631554865],
            [-19.05785608123869, 2.145125285797562],
            [-19.051474428532345, 2.1487992242579237],
            [-19.038780378613374, 2.141730082204606],
            [-19.035423760208474, 2.142396754205761],
            [-19.03233461560979, 2.14015827675605],
            [-19.026252745202836, 2.139673990832563],
            [-19.018992504070464, 2.134792968633398],
            [-19.0150740703884, 2.1344274634713374],
            [-19.00673324188504, 2.136223864613036],
            [-19.00111483989376, 2.1345438782559345],
            [-18.997423682138436, 2.1361763910266807],
            [-18.990742152063703, 2.134962549762474],
            [-18.988215105791618, 2.1331880657139286],
            [-18.980093125437918, 2.1339800125798516],
            [-18.97619654439364, 2.135724816239915],
            [-18.972436530570437, 2.1402744422719255],
            [-18.966054244744686, 2.143153142499199],
            [-18.96300174722948, 2.141491708977456],
            [-18.955850749026084, 2.1426987374031814],
            [-18.949370981983115, 2.138839965269437],
            [-18.942060853321333, 2.1317892228704687],
            [-18.93815289805014, 2.1307132321653417],
            [-18.933947605944567, 2.1317308113565763],
            [-18.929007310017194, 2.1296092888646942],
            [-18.923514914116293, 2.125682820396582],
            [-18.916727322077033, 2.1284334026665377],
            [-18.90802514288779, 2.126024127888143],
            [-18.899217193972408, 2.1309485696240387],
            [-18.889842845567127, 2.1295343523364503],
            [-18.88888519895045, 2.127698985105875],
            [-18.883556458266806, 2.1261362981844014],
            [-18.8798084309683, 2.1281338344228504],
            [-18.87341590011768, 2.1292310022429217],
            [-18.870008731842518, 2.1283049069407967],
            [-18.861696921089056, 2.129307653008132],
            [-18.85265883229415, 2.1348830413632305],
            [-18.849695052466874, 2.134391481454064],
            [-18.843689862647725, 2.1385918854997636],
            [-18.835496633517145, 2.136273422855269],
            [-18.829026990158248, 2.1384078675864444],
            [-18.822896078412334, 2.1390160946989],
            [-18.81831664882522, 2.136108258774584],
            [-18.8086604319899, 2.1384423527173735],
            [-18.802748531960216, 2.1424018239544163],
            [-18.799091873748036, 2.143074615389749],
            [-18.793638102784577, 2.147091329613583],
            [-18.790615118668466, 2.1472738153795925],
            [-18.783719209352522, 2.138852762526392],
            [-18.77983369683738, 2.135661298898275],
            [-18.772908415434877, 2.1406674447165654],
            [-18.765049321686362, 2.1397953243460686],
            [-18.7621228030586, 2.140409449033568],
            [-18.75963409264336, 2.087749937931787],
            [-18.758069552553174, 2.06109165230314],
            [-18.755305194332493, 2.0110390889195955],
            [-18.751419996874183, 1.9160463963006467],
            [-18.744939048855887, 1.9029164610167955],
            [-18.760755493082964, 1.8442551182824805],
            [-18.76949889724, 1.8111718485390396],
            [-18.779549436769884, 1.7740514454895233],
            [-18.79478938611201, 1.7170025884212265],
            [-18.815206971744608, 1.6321526032895695],
            [-18.827639081225833, 1.5832450583695625],
            [-18.8292450342985, 1.5712907221870032],
            [-18.830762963480872, 1.5706684766149728],
            [-18.83837150967073, 1.57482470378456],
            [-18.84232093715851, 1.5784592851622397],
            [-18.846333838545405, 1.5797113708846653],
            [-18.854646176838276, 1.5780944466688795],
            [-18.859586688193566, 1.5829476597478542],
            [-18.86652534429221, 1.5912246571454538],
            [-18.870672008886036, 1.6013378815340074],
            [-18.874235104587907, 1.6021792422923071],
            [-18.880351894608577, 1.6077242616134562],
            [-18.883339561261582, 1.6031310836800665],
            [-18.88814054557011, 1.600988258051801],
            [-18.894230705402816, 1.6020551523482112],
            [-18.895169042140928, 1.607885171199269],
            [-18.898289660066805, 1.6074293765701946],
            [-18.905338041554643, 1.600325929465634],
            [-18.90845983314812, 1.5960485424105475],
            [-18.91307133484047, 1.5984424414235223],
            [-18.91987067266088, 1.5990188011383795],
            [-18.92742064004805, 1.601932204949303],
            [-18.927468744455375, 1.6092252720115354],
            [-18.931786026075518, 1.610173708597888],
            [-18.933690784831196, 1.6076315442330809],
            [-18.938267705707865, 1.6072022809602076],
            [-18.939172577104294, 1.6026755455273212],
            [-18.947328857276823, 1.6021475096757258],
            [-18.950966864193887, 1.6070552671239082],
            [-18.955439344643896, 1.607974843816773],
            [-18.960400586738746, 1.602725645338579],
            [-18.965870861523435, 1.6072940144064767],
            [-18.96612985520102, 1.6111075663969712],
            [-18.973081747422757, 1.6116727571706944],
            [-18.972313360783748, 1.6033628552593224],
            [-18.98086318554551, 1.5977077145339051],
            [-18.98484881282497, 1.5963597533625118],
            [-18.995435528519085, 1.5999640274361133],
            [-19.00414570685881, 1.599122192635387],
            [-19.012050460504003, 1.6011127647167511],
            [-19.015066492593146, 1.598906395172993],
            [-19.018114742161295, 1.5936549056336955],
            [-19.01866908120862, 1.586794700508566],
            [-19.025001120064093, 1.5862014762321688],
            [-19.027410048930612, 1.5836059297800573],
            [-19.03253590255001, 1.5882975876003396],
            [-19.03355750875426, 1.5849369252123184],
            [-19.03828585709421, 1.5839349619523762],
            [-19.037120458461597, 1.5778275856303798],
            [-19.042946772791453, 1.5770064074856018],
            [-19.047650151605303, 1.584731887293711],
            [-19.05295521655213, 1.5813790019532914],
            [-19.05344694909065, 1.5873553617322467],
            [-19.060877792650352, 1.57927364260674],
            [-19.0654978495594, 1.5810450224550476],
            [-19.071882125771097, 1.5784151632481986],
            [-19.071585821972167, 1.5691534991925111],
            [-19.0758917770726, 1.5661024583926197],
            [-19.081025943723883, 1.5665728241669685],
            [-19.082109009208374, 1.5620677492178319],
            [-19.084450695677603, 1.5608714246390498],
            [-19.090243574245395, 1.5648887905152193],
            [-19.11868155837566, 1.5482300477489082],
            [-19.17136296506716, 1.5178342379735335],
            [-19.181287579831025, 1.5117257133041146],
            [-19.221029589446353, 1.4891227619608138],
            [-19.314567284203118, 1.4345224056407868],
            [-19.310487013418257, 1.4413342908793911],
            [-19.313969717190055, 1.44847936626726],
            [-19.31627077273937, 1.4503800010330443],
            [-19.316993148383602, 1.4557656262696086],
            [-19.325152890035934, 1.4590351349444333],
            [-19.32662607186512, 1.4620750035671417],
            [-19.325532295356552, 1.4696524681598082],
            [-19.327816521776366, 1.4765691092609898],
            [-19.3236499112075, 1.4795666321086902],
            [-19.325389021844558, 1.4827414617281287],
            [-19.34126010000632, 1.48679352358912],
            [-19.348686823120033, 1.4932155442167083],
            [-19.354552413656112, 1.49622055976691],
            [-19.356899842353947, 1.4992928775440384],
            [-19.358634447121915, 1.5068905315528989],
            [-19.362416650134204, 1.5114923319605138],
            [-19.337674047327546, 1.6018429294413024],
            [-19.318445482909738, 1.6721135802622478],
            [-19.289233122305443, 1.7779628221652035],
            [-19.285826319554257, 1.7794712645721624],
            [-19.282516237242298, 1.7851303514824066],
            [-19.281815442434223, 1.7900715681148158],
            [-19.27896689115024, 1.7930184551507615],
            [-19.276591559464382, 1.7910756847997242],
            [-19.269433679233384, 1.7944309809171475],
            [-19.266016114719456, 1.802743897681378],
            [-19.26312140927019, 1.805744343690706],
            [-19.268592229353498, 1.808739753479641],
            [-19.26619477540906, 1.814812430288499],
            [-19.27167872188123, 1.813684953607646],
            [-19.27344180697973, 1.8195871780794823],
            [-19.276781385368157, 1.8180015715812199],
            [-19.288337702853777, 1.821188476202956],
            [-19.288582863410067, 1.8238452258049695],
            [-19.294520818645083, 1.8234026358807587],
            [-19.29423489633652, 1.8260198486168702],
            [-19.289060637652724, 1.8279983725044378],
            [-19.29116128691979, 1.8369282328273306],
            [-19.283996750832994, 1.8465696381885206],
            [-19.283194731047438, 1.852688020130613],
            [-19.276906887535105, 1.8540761559372878],
            [-19.274163104505874, 1.8588071982267618],
            [-19.277349732772084, 1.867006660358968],
            [-19.27026568458315, 1.8696025372028886],
            [-19.268232079920335, 1.8724008281933453],
            [-19.26922912922772, 1.8767397129686114],
            [-19.267797903021062, 1.8795636508934292],
            [-19.260141822067126, 1.8817773783188128],
            [-19.260768855698437, 1.8867909695977318],
            [-19.258385922679018, 1.8906582971319508],
            [-19.2605580021634, 1.8950652317905423],
            [-19.25905312044297, 1.898833081388537],
            [-19.259776116624515, 1.90363131824021],
            [-19.263370364721926, 1.9058632549106171],
            [-19.26230782285679, 1.9094566521104697],
            [-19.257512163167004, 1.9126799985572571],
            [-19.25826305565505, 1.9145650642692322],
            [-19.264896638551882, 1.914970237722027],
            [-19.264728629262876, 1.918256325973123],
            [-19.257791154803215, 1.9172302964945989],
            [-19.256900037182298, 1.9191455997954379],
            [-19.26158655645055, 1.9273309496414641],
            [-19.260469918874094, 1.9326546118779901],
            [-19.26367630511272, 1.9380402331349935],
            [-19.257763979030717, 1.9408034870532245],
            [-19.261903375586897, 1.9432436844675225],
            [-19.26347555214505, 1.9461604468892681],
            [-19.260889035189894, 1.9513133573007464],
            [-19.25574064920481, 1.955474287935714],
            [-19.255934565594167, 1.9598933850879883],
            [-19.250465542717098, 1.9583860935424897],
            [-19.249620343230763, 1.9626202946077536],
            [-19.25519304451456, 1.9651643680839312],
            [-19.255147623580477, 1.9688453767310456],
            [-19.25280454605263, 1.9713789741989964],
            [-19.245335729094933, 1.9699100459522139],
            [-19.24386874010404, 1.9717514077790375],
            [-19.247341297930923, 1.9762488516150447],
            [-19.244981881859268, 1.9774558424857858],
            [-19.23892078636829, 1.9723909662902612],
            [-19.235848841338523, 1.9732156255042772],
            [-19.238328387578953, 1.9810967807392936],
            [-19.23746907574774, 1.986917188512393],
            [-19.242721120762557, 1.9901198885323033],
            [-19.240197866926756, 1.9963622176788487],
            [-19.240297810112736, 1.999958553569934],
            [-19.243990976035256, 2.0025969875487437],
            [-19.247480696198114, 1.9991923433045953],
            [-19.246681885985826, 1.9937669610450375],
            [-19.249885097771788, 1.9931193966304055],
            [-19.25093114922577, 1.9972499575772342],
            [-19.249160422743078, 2.004634521026909],
            [-19.245226549018398, 2.0118110629650086],
            [-19.24413751098705, 2.0203686191215517],
            [-19.24058823039789, 2.0283159009352976],
            [-19.234128948624264, 2.0301126192178383],
            [-19.232052544307027, 2.0320517988245963],
            [-19.233866212054725, 2.0366909290319986],
            [-19.231423207012153, 2.050198354320732],
            [-19.231970140325416, 2.053149467192462]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.27144465223763,
          "lat": 37.934739911925426
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06077"],
        "coty_name": ["San Joaquin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Joaquin County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00277303"
      },
      "bbox": [
        -19.362416650134204, 1.4345224056407868, -18.744939048855887,
        2.1916478182226804
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.572266218736473, -2.377014464315404],
              [-18.57039905550626, -2.3760171472554767],
              [-18.56202418465905, -2.3764717938498277],
              [-18.56025953186827, -2.378901710834084],
              [-18.571052751317826, -2.379460064343455],
              [-18.572266218736473, -2.377014464315404]
            ]
          ],
          [
            [
              [-18.62627809185172, -2.3640706869212056],
              [-18.621913026218447, -2.364762706554338],
              [-18.61923034231951, -2.3633268416629614],
              [-18.609466121613032, -2.3667812233366536],
              [-18.604254428492542, -2.37440226109342],
              [-18.59165362340778, -2.3806953827511355],
              [-18.585793471846344, -2.3809549690650242],
              [-18.57991767958314, -2.3781072641473187],
              [-18.577210739538472, -2.3805332553517617],
              [-18.588066682739388, -2.3847667915581114],
              [-18.594787061510434, -2.3824414180498428],
              [-18.606380552349297, -2.3765805182900928],
              [-18.61248745892616, -2.3759448614469605],
              [-18.613911620747647, -2.373329086772326],
              [-18.62356494241219, -2.368329498301803],
              [-18.62627809185172, -2.3640706869212056]
            ]
          ],
          [
            [
              [-18.40915535906521, -1.4965537370411237],
              [-18.36193133737418, -1.5087923243093568],
              [-18.366554655857268, -1.529630736985466],
              [-18.367059973078433, -1.5353888812540597],
              [-18.3463628671315, -1.5409031632135108],
              [-18.34664667375247, -1.542020970040162],
              [-18.2842368946314, -1.5576974172033013],
              [-18.28859212214932, -1.572400047324761],
              [-18.261149203845463, -1.5789246562772032],
              [-18.27167779580575, -1.6212580260296985],
              [-18.21607790441273, -1.6358684337731664],
              [-18.158847177026644, -1.6507839178592187],
              [-18.099263405428157, -1.666027355933216],
              [-18.063208195101996, -1.675659564407069],
              [-18.068572411892056, -1.6970777340602428],
              [-18.040718399364295, -1.704008235314653],
              [-17.991649616679172, -1.7171933594131519],
              [-17.974038503979877, -1.8489389049952059],
              [-17.96662730686331, -1.9018807764422887],
              [-17.94973055517862, -2.0209194071664394],
              [-17.934523185941664, -2.127981887757798],
              [-17.91707265288813, -2.250680813294362],
              [-17.92045718036517, -2.279346558574822],
              [-17.925874097399273, -2.3018257094951995],
              [-17.95395817638995, -2.2950564239113276],
              [-17.97148538254452, -2.3655670532175836],
              [-18.006358825313182, -2.356647560369339],
              [-18.015617326570702, -2.3551788985951907],
              [-18.067788247199445, -2.3420882272991226],
              [-18.131632773947775, -2.3694358629642256],
              [-18.211545094083213, -2.40366196230472],
              [-18.221431066443543, -2.431312911808348],
              [-18.228782275829406, -2.4268635448428606],
              [-18.23535181673417, -2.420900025439258],
              [-18.23908707086211, -2.4156368456370605],
              [-18.24452637208333, -2.411104465347901],
              [-18.248834767456337, -2.4095119984887856],
              [-18.251654116065612, -2.4060869477551154],
              [-18.258397995493933, -2.4013384333303356],
              [-18.26777127056146, -2.3981450973119425],
              [-18.286580835976572, -2.3765787919808097],
              [-18.29332717253127, -2.3730211738019364],
              [-18.297952792701498, -2.3726080126222344],
              [-18.304957852855576, -2.369675992937193],
              [-18.32136128686919, -2.35122134656867],
              [-18.33088699857984, -2.348250290604414],
              [-18.3403729190111, -2.349982802799455],
              [-18.345821122628475, -2.3476115624237566],
              [-18.355481258280463, -2.3411327805179836],
              [-18.364334244064583, -2.331078464131941],
              [-18.393550876742484, -2.292079001822241],
              [-18.40376764177113, -2.283829667550578],
              [-18.413977413175306, -2.279627321663323],
              [-18.419174163769757, -2.2621196715254523],
              [-18.423228558269724, -2.2465007528119405],
              [-18.429924343349594, -2.205909060322384],
              [-18.432199867123572, -2.1906140660474254],
              [-18.43084662523251, -2.1777625772279636],
              [-18.430680143608313, -2.1646155087504937],
              [-18.434022075342554, -2.1492485028974206],
              [-18.4418513263637, -2.1389872117606017],
              [-18.44519076800994, -2.137772603522898],
              [-18.451272304198646, -2.1388550264895763],
              [-18.458499067756996, -2.1333152621268248],
              [-18.46313708277077, -2.125377099637361],
              [-18.47501892315534, -2.1144159967314984],
              [-18.480947060601956, -2.0985942357947818],
              [-18.49406997683513, -2.0796209340779797],
              [-18.49798031033842, -2.076945263201769],
              [-18.508803223763056, -2.078092705436645],
              [-18.510355246736193, -2.076872291740776],
              [-18.518397208620684, -2.0582117259505366],
              [-18.52173715779317, -2.0541175900525293],
              [-18.531451332424183, -2.0354092669538035],
              [-18.533508286481226, -2.0325226942483066],
              [-18.543147529581937, -2.0293738485489516],
              [-18.54707036657641, -2.0185109207716496],
              [-18.55268976166838, -2.00820070916503],
              [-18.55761360565547, -2.005240220240547],
              [-18.564979800251066, -2.005060865226224],
              [-18.564710517358694, -1.9996113375596767],
              [-18.561574255573394, -2.000715406913823],
              [-18.559370763383672, -1.9963722650467746],
              [-18.545907292432517, -1.9898557031931372],
              [-18.53986790215479, -1.9876955532297509],
              [-18.53335844311499, -1.9818989362604695],
              [-18.531713150221726, -1.977311977777234],
              [-18.534088388448794, -1.9735009805643995],
              [-18.536463720354874, -1.966470287018423],
              [-18.53425988529322, -1.9619688095942796],
              [-18.533214404998333, -1.956438052148392],
              [-18.526084776766204, -1.9572975967007766],
              [-18.523493297507837, -1.9505113024792522],
              [-18.51963552304013, -1.9461088697867448],
              [-18.517607544751858, -1.9320038254734409],
              [-18.509088019918202, -1.8977428814948767],
              [-18.491986691803067, -1.8298657793314292],
              [-18.450018210767155, -1.6608036094006566],
              [-18.437478143411447, -1.6085914000771544],
              [-18.40915535906521, -1.4965537370411237]
            ]
          ],
          [
            [
              [-18.91592300786711, -3.0536125634696334],
              [-18.90932348900824, -3.0592997296611912],
              [-18.905569139063527, -3.063867761607544],
              [-18.902026853914908, -3.063432613627477],
              [-18.89613946469368, -3.0599761230743443],
              [-18.894493964104175, -3.056923302206977],
              [-18.891031908707003, -3.059064967799701],
              [-18.875195948818455, -3.056814908841908],
              [-18.86991484380729, -3.063635627601614],
              [-18.85931201877486, -3.0740546625222236],
              [-18.85554629546267, -3.0813292087133797],
              [-18.848192295022212, -3.083970236144109],
              [-18.834712222358323, -3.0936192215528164],
              [-18.830629160294798, -3.09517559395499],
              [-18.82737062345269, -3.0986824904034953],
              [-18.82301935684653, -3.107401261034306],
              [-18.817155517268635, -3.116368019898847],
              [-18.812787975990783, -3.1285098040406267],
              [-18.813555308484553, -3.1328764037694774],
              [-18.81886754595283, -3.138719812135345],
              [-18.825933408789183, -3.13728129537106],
              [-18.834806568538873, -3.1388680608705855],
              [-18.83909815281165, -3.1375167476434553],
              [-18.845507059897322, -3.137578869648442],
              [-18.851892700308184, -3.134293051755321],
              [-18.853745155845594, -3.1317181629431197],
              [-18.860993150447992, -3.1283873136708875],
              [-18.866930777853618, -3.127923608061983],
              [-18.869601012628777, -3.124428837716132],
              [-18.877819927361795, -3.120865867702104],
              [-18.88228010035471, -3.1138243900696927],
              [-18.89018265672443, -3.108972013483342],
              [-18.902278645189504, -3.1047806684534174],
              [-18.91085151383059, -3.090958574871323],
              [-18.914623280241376, -3.0866280791210037],
              [-18.912844439888804, -3.083752394860763],
              [-18.91375113078025, -3.0789089236219165],
              [-18.919278857459553, -3.0740488904585086],
              [-18.916669348752933, -3.0680370148860634],
              [-18.917284675277575, -3.053671547737049],
              [-18.91592300786711, -3.0536125634696334]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -119.0835847958292, "lat": 34.45606330690704 },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06111"],
        "coty_name": ["Ventura"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ventura County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00277320"
      },
      "bbox": [
        -18.919278857459553, -3.1388680608705855, -17.91707265288813,
        -1.4965537370411237
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.875381959482685, 1.6163821363437079],
            [-6.839870140465144, 1.6124006366461223],
            [-6.837494654324741, 1.6124634846222696],
            [-6.708973461194821, 1.5994224611662757],
            [-6.702765204051769, 1.6030683613914505],
            [-6.69655534840914, 1.6043706689534374],
            [-6.689176823634037, 1.5963580892860738],
            [-6.683644414786084, 1.5962305838337936],
            [-6.681691950374586, 1.5931908109039632],
            [-6.675570507535702, 1.5965069727577295],
            [-6.6715170136418696, 1.5951445016457857],
            [-6.665105502057133, 1.5976754098771604],
            [-6.667203154021633, 1.5755998322472382],
            [-6.670010689191407, 1.545769544586448],
            [-6.672509261954186, 1.5229021301164982],
            [-6.6727980881289115, 1.5161481812221076],
            [-6.674446052937375, 1.5033779108802667],
            [-6.683902231556159, 1.4080958144203766],
            [-6.689908207865352, 1.4142046215348192],
            [-6.696771595649099, 1.4128725027774622],
            [-6.701695690431757, 1.4096761078160889],
            [-6.702662262290254, 1.4143341145172592],
            [-6.701666599355403, 1.4191478216170292],
            [-6.7071059384766105, 1.4191788585798917],
            [-6.715765005872102, 1.4210215852892267],
            [-6.722922175758385, 1.4190195373513697],
            [-6.725903265607084, 1.4222990984280988],
            [-6.735094088398253, 1.4236578100652633],
            [-6.743876218482493, 1.4273395199020937],
            [-6.747971680451868, 1.4280403422486225],
            [-6.7548739790606875, 1.4262450920481273],
            [-6.757892743874828, 1.4274622567069857],
            [-6.755595414663771, 1.4335251825584008],
            [-6.7643962743897115, 1.4338610244991257],
            [-6.767940603887809, 1.4367305423973131],
            [-6.772736986337257, 1.4361108878869904],
            [-6.778820169196417, 1.4406354583484415],
            [-6.781664936280806, 1.4412003830321],
            [-6.791282938197643, 1.4477022037110376],
            [-6.79416489115457, 1.4553567677352979],
            [-6.7924270486026606, 1.4614587672996697],
            [-6.802164604447902, 1.4696424929165448],
            [-6.804465851875636, 1.474607413810057],
            [-6.809041406664084, 1.4758766111457582],
            [-6.8105103389914285, 1.4786697125979216],
            [-6.814713163190541, 1.4814349381516048],
            [-6.813182869278738, 1.4905813655842053],
            [-6.810229341002037, 1.4946068613503285],
            [-6.812577422065661, 1.4985029083130486],
            [-6.816732023481627, 1.4985498080748985],
            [-6.825956353251569, 1.494437267327831],
            [-6.831706330863915, 1.4959993720312772],
            [-6.833657512418707, 1.5007889616535266],
            [-6.841220314656965, 1.5043935229916463],
            [-6.847696872945918, 1.5110708488805176],
            [-6.851481829974227, 1.517485329555526],
            [-6.852307061597113, 1.5240391872007677],
            [-6.871672592983119, 1.5328519638918359],
            [-6.878002540427902, 1.5305353126925796],
            [-6.884245836049627, 1.532887529635517],
            [-6.888124872146375, 1.5313254694539589],
            [-6.894643570557848, 1.536767469025517],
            [-6.898036635403867, 1.5467692824276738],
            [-6.898615397295596, 1.5533900186382414],
            [-6.897539131337358, 1.5570463714965384],
            [-6.899761443650003, 1.5646182064862615],
            [-6.897746535606843, 1.566454392261705],
            [-6.897673080857382, 1.5771387516269366],
            [-6.890977125175241, 1.5834458263257642],
            [-6.8869264405671125, 1.5889123205522429],
            [-6.887605126889556, 1.5919793561823712],
            [-6.884599245699725, 1.6004722288493043],
            [-6.88238573975537, 1.6016930704694046],
            [-6.881356941220294, 1.6063074020884374],
            [-6.875381959482685, 1.6163821363437079]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.52255909012922,
          "lat": 39.85750545003374
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08047"],
        "coty_name": ["Gilpin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gilpin County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00198139"
      },
      "bbox": [
        -6.899761443650003, 1.4080958144203766, -6.665105502057133,
        1.6163821363437079
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.449469106087774, 1.669680549295271],
            [-7.419857175832852, 1.6660941715192974],
            [-7.421154863649742, 1.6555066661861109],
            [-7.400065327376706, 1.6530020289924345],
            [-7.344998476372369, 1.6471311519455962],
            [-7.34457294100993, 1.652117980357851],
            [-7.3408089751121235, 1.6516389329512016],
            [-7.312731520391334, 1.644394255618147],
            [-7.309083668398681, 1.6419579524903565],
            [-7.298871369490251, 1.6287852805804353],
            [-7.297147111940072, 1.6212030113464757],
            [-7.2920502680941635, 1.6147361670143112],
            [-7.29138724466621, 1.6105297780166319],
            [-7.288017086869844, 1.6052855958008119],
            [-7.283384716013807, 1.6043782825661246],
            [-7.279464217034072, 1.5939358908491585],
            [-7.279324963487502, 1.5893730669835167],
            [-7.275049672625441, 1.5844877170285323],
            [-7.26536084077551, 1.576114523435824],
            [-7.264155708114105, 1.5732778376561574],
            [-7.259097067362659, 1.5681734352103411],
            [-7.2563927225914, 1.5681347173809579],
            [-7.242893663773793, 1.560504601858627],
            [-7.238754412861149, 1.5599597387321262],
            [-7.235341672224925, 1.5633109951431583],
            [-7.229215404913844, 1.563861852409511],
            [-7.2245257799628595, 1.5612550316710656],
            [-7.219599193103805, 1.550447358827741],
            [-7.216354118908313, 1.5477813830779872],
            [-7.211734229462493, 1.5398561693084536],
            [-7.207948190379498, 1.536837661989334],
            [-7.2027116854839415, 1.5292451155318405],
            [-7.201544351535226, 1.5255340514009887],
            [-7.197396581966298, 1.5223721326286566],
            [-7.197021886424841, 1.5118623051354738],
            [-7.1952114830777845, 1.5075400766177691],
            [-7.197253160065297, 1.5028191183629278],
            [-7.19336878268579, 1.495872549572925],
            [-7.191121176302785, 1.4872312687231455],
            [-7.190700909394592, 1.480657331791469],
            [-7.187696906465355, 1.47474631591078],
            [-7.189247865636149, 1.4678755138100261],
            [-7.187309724547165, 1.464929997270182],
            [-7.188669990595693, 1.4598236456623819],
            [-7.1859101448255265, 1.4529432637636488],
            [-7.186992405891116, 1.4467104304084528],
            [-7.185958996062199, 1.4421726422067875],
            [-7.186782979308824, 1.4380887995220308],
            [-7.185166510418152, 1.4345717586165856],
            [-7.18160478627997, 1.4342738698678004],
            [-7.1768818278875175, 1.4311762988044932],
            [-7.17263797433867, 1.423759665069662],
            [-7.1729493198248315, 1.4192479386330719],
            [-7.170728853972438, 1.4143238487752858],
            [-7.170881703108013, 1.4080510606871381],
            [-7.165827251464466, 1.399781945013278],
            [-7.156329375870653, 1.3959392106621185],
            [-7.153013361276012, 1.3970427599467847],
            [-7.143941861520912, 1.3923792677996074],
            [-7.1395170612976875, 1.3953602007867512],
            [-7.135303769225393, 1.3947698093550804],
            [-7.131676530213032, 1.3968155386549785],
            [-7.124952222824671, 1.3980563954200687],
            [-7.117156179544433, 1.3963147940336385],
            [-7.10842733929462, 1.3998280630751792],
            [-7.104969126376712, 1.3930901785359278],
            [-7.094651322049647, 1.3979083808980886],
            [-7.092297365725243, 1.4005389049282293],
            [-7.087995773623478, 1.401563271388308],
            [-7.085061126379534, 1.39609784832149],
            [-7.087044256930302, 1.3865880272204563],
            [-7.0921678067602, 1.3794069115679588],
            [-7.09199783302001, 1.3756168656354832],
            [-7.087566672502917, 1.3715498740378727],
            [-7.081337442894959, 1.3636537068661114],
            [-7.075755831232497, 1.365242145050628],
            [-7.070513899043028, 1.3649266252449699],
            [-7.0688894159216344, 1.359434517485425],
            [-7.062242967877185, 1.3563726451675884],
            [-7.0575753176948135, 1.3625350822780262],
            [-7.052811789541332, 1.3642937506442063],
            [-7.045939375720331, 1.3649544760021322],
            [-7.041065633449124, 1.3529525373438978],
            [-7.039925614177997, 1.3459280126598523],
            [-7.036133263890999, 1.34053704544723],
            [-7.030519875787443, 1.342011114708008],
            [-7.027173284892857, 1.3383825573444434],
            [-7.019472551449702, 1.3355319924956952],
            [-7.015300759046376, 1.3367601240482796],
            [-7.01339059884284, 1.3274214276022311],
            [-7.008422886300519, 1.3287257812379192],
            [-7.004888588012926, 1.3279530227025105],
            [-6.9987075063617805, 1.3287408315856502],
            [-6.99452578103327, 1.3280649570605159],
            [-6.987627870389812, 1.3201596213687468],
            [-6.988799922965184, 1.3090533908112834],
            [-6.984530574580412, 1.3016360355028158],
            [-6.984667527449878, 1.2970322194930708],
            [-6.990676842227638, 1.291177031480437],
            [-6.997683017918601, 1.2896141731090893],
            [-7.000058612000528, 1.2867543162789992],
            [-7.004827712411948, 1.2856050397531773],
            [-7.0116574823223266, 1.2763532013339365],
            [-7.019524053706647, 1.2745759260802196],
            [-7.026010566732388, 1.2745991868311144],
            [-7.030027392847543, 1.2728650821666305],
            [-7.035747311177717, 1.2682561680990039],
            [-7.03483694031683, 1.263938904986273],
            [-7.029976665839917, 1.2594521266739171],
            [-7.027977910072954, 1.2499237375068282],
            [-7.025646584278117, 1.2469770621753067],
            [-7.020793087097417, 1.2454228574334731],
            [-7.023805715417958, 1.2394842061436768],
            [-7.023601342015264, 1.2318484903434224],
            [-7.029196040758987, 1.2245653369409124],
            [-7.033666102120066, 1.2265337362701714],
            [-7.045175188824842, 1.2215894396201088],
            [-7.04620572127179, 1.2194217240091665],
            [-7.052756598090216, 1.2242812205451519],
            [-7.054727928825078, 1.22873770733636],
            [-7.0592472339017585, 1.2240182056674618],
            [-7.0610639326960225, 1.2193086076369182],
            [-7.063895391247632, 1.216940035359753],
            [-7.063293171030069, 1.214048403511377],
            [-7.0584924710514105, 1.2089277147187345],
            [-7.056523411059, 1.2016018527586385],
            [-7.062286494698108, 1.1993352946081703],
            [-7.065399316003862, 1.1915886903377109],
            [-7.069784319969445, 1.1925092963021275],
            [-7.074839712196988, 1.1877700603884553],
            [-7.076014451755032, 1.1819555160302753],
            [-7.083737183232053, 1.182338247235213],
            [-7.086271013802412, 1.1802628723501167],
            [-7.094628622410953, 1.169542742798304],
            [-7.095362065544252, 1.1641691894450836],
            [-7.098981090476948, 1.1598888478947664],
            [-7.102578314842241, 1.1589652304782163],
            [-7.111273061038727, 1.1599556708015433],
            [-7.117167426708674, 1.1614694247778212],
            [-7.123980212452232, 1.1613315496171766],
            [-7.127251314650361, 1.1558651064490837],
            [-7.13001201798822, 1.1441161978639054],
            [-7.137462772160345, 1.1424936912891483],
            [-7.143487082655848, 1.1447010589571849],
            [-7.147534412854386, 1.1430403373696059],
            [-7.146671269154384, 1.1382822349148842],
            [-7.143875774895473, 1.1335045831249244],
            [-7.139689748253186, 1.1302249483346551],
            [-7.140469205335443, 1.1268878636341033],
            [-7.138524952102037, 1.1183293160166967],
            [-7.158321198531891, 1.114273059475884],
            [-7.162444364325169, 1.1120728579073056],
            [-7.164110809061504, 1.1086628926021598],
            [-7.169393879555629, 1.1089774192661839],
            [-7.1742675837226475, 1.1021833103194825],
            [-7.180252581139721, 1.099531953016187],
            [-7.1845743051045, 1.095512698595869],
            [-7.188772342603696, 1.0954916067387206],
            [-7.192806468245467, 1.0903411249361528],
            [-7.192277822559497, 1.0837742994822586],
            [-7.193913403546536, 1.074320429766795],
            [-7.197626701120017, 1.0708665688016452],
            [-7.2012878374579214, 1.0708683940329216],
            [-7.207693085734856, 1.0685454994721388],
            [-7.21481332282758, 1.0682873179528427],
            [-7.223970268222182, 1.0703278369059994],
            [-7.232755104102496, 1.077349266571369],
            [-7.236663261201689, 1.0820289759957218],
            [-7.245257950664972, 1.0840531856684466],
            [-7.253186677154288, 1.0932863143747515],
            [-7.259917205939892, 1.0939473952753331],
            [-7.270925874720491, 1.0937618146266994],
            [-7.2790824515936405, 1.0975989757092948],
            [-7.2821971353740125, 1.0979677918390711],
            [-7.282853491521601, 1.0981882749312109],
            [-7.33639468767027, 1.103880296468961],
            [-7.33894711120824, 1.107362353879871],
            [-7.336802716300414, 1.110694369410336],
            [-7.33256363513092, 1.113594618730001],
            [-7.330421541788995, 1.1186456387729893],
            [-7.331184760558458, 1.121087049181634],
            [-7.341757029025792, 1.1336036825612488],
            [-7.342179458570583, 1.1376915865361876],
            [-7.349211158039906, 1.140807944595177],
            [-7.350545577451509, 1.1452340261008802],
            [-7.349529383967875, 1.1485686561090722],
            [-7.351097050746885, 1.1527854433678588],
            [-7.34702560746508, 1.154224634950405],
            [-7.3430913222954075, 1.1591272560288632],
            [-7.346335921523612, 1.1659846380398553],
            [-7.348869456992175, 1.1674907144195408],
            [-7.353114635957127, 1.1784968416576005],
            [-7.352193561050231, 1.1812365884675042],
            [-7.356751660252012, 1.1891583155406606],
            [-7.361298531912909, 1.1932673348920722],
            [-7.359716912930594, 1.1990783192732972],
            [-7.360324054725326, 1.2025630099438096],
            [-7.35721363609374, 1.2126851624337465],
            [-7.354022419639327, 1.217201222715239],
            [-7.355136185516621, 1.2192585685088753],
            [-7.364069949768109, 1.2235808517141566],
            [-7.361517591707403, 1.2284368025935586],
            [-7.35900365231963, 1.228838586885973],
            [-7.3548920282618555, 1.232996995066329],
            [-7.352145690564385, 1.2407109444540159],
            [-7.353362685889544, 1.2438341142221347],
            [-7.35847411502209, 1.2486488525352362],
            [-7.356586351642696, 1.2572117647473513],
            [-7.357138250982578, 1.2610273504592266],
            [-7.352507903381654, 1.2669311601479123],
            [-7.3497238551879, 1.272601495413428],
            [-7.346466380481907, 1.2719364243115725],
            [-7.340910315631584, 1.2758779994714509],
            [-7.340325314116927, 1.2717027991224392],
            [-7.3360251548818045, 1.265007794966106],
            [-7.333443593591372, 1.257434861053953],
            [-7.327939044387856, 1.2576670068118037],
            [-7.324448897640375, 1.2562389568458898],
            [-7.322411747482116, 1.2596713877244827],
            [-7.322913195960627, 1.2649173373227216],
            [-7.321483765369542, 1.2703113384026525],
            [-7.319078265013396, 1.273087936194492],
            [-7.311864736384541, 1.2741915523482976],
            [-7.310472366630276, 1.2767110728147606],
            [-7.311041045316356, 1.2820858324968774],
            [-7.3163040856737505, 1.2829837096453967],
            [-7.318156620305899, 1.286655713694564],
            [-7.31810806278315, 1.295488101909747],
            [-7.321534400767542, 1.3007772921688334],
            [-7.319978138396165, 1.3075408439918637],
            [-7.317117226876186, 1.3120920967686278],
            [-7.316695930699531, 1.3185527045192544],
            [-7.314366869787272, 1.3245771922604728],
            [-7.3113226011238615, 1.3287859744101627],
            [-7.3070677011476475, 1.3309035312487374],
            [-7.296365085799643, 1.3266052577175387],
            [-7.290466442839833, 1.3305991628822567],
            [-7.287781062001091, 1.3367624555880606],
            [-7.286813127245572, 1.34650109922356],
            [-7.286922322085975, 1.3543864864612145],
            [-7.285726595796509, 1.3583632752849029],
            [-7.289548319671119, 1.3754498288058827],
            [-7.293488906195042, 1.3770793672804094],
            [-7.297663900001358, 1.3752776088084488],
            [-7.303239717947442, 1.3788324291454144],
            [-7.314557940718527, 1.380618911393266],
            [-7.314939133378004, 1.3876762091296242],
            [-7.319023102942581, 1.389219197346147],
            [-7.320920954508602, 1.3877494779655595],
            [-7.326758491719066, 1.3894843259877567],
            [-7.3304289711521395, 1.394882710299607],
            [-7.3281360758366585, 1.4081506619772062],
            [-7.3311757649196, 1.4091329709619766],
            [-7.342970944456515, 1.4092790209793589],
            [-7.344865400936687, 1.4156449883117992],
            [-7.347502173702927, 1.4183798172135043],
            [-7.344324386372167, 1.4277422991006374],
            [-7.345096551435225, 1.4309590819663298],
            [-7.350763673039938, 1.4350344634099537],
            [-7.355340923210849, 1.4306502051041374],
            [-7.365089219765532, 1.4363035207248647],
            [-7.366992681289036, 1.441868365763935],
            [-7.366475205052691, 1.4448285672337917],
            [-7.368918156079092, 1.4534695631342422],
            [-7.381717940343633, 1.4615685172902249],
            [-7.384472614463976, 1.4664339711170333],
            [-7.388039297193762, 1.4684050949887426],
            [-7.391720288501046, 1.4758078101229455],
            [-7.393990190966692, 1.4855911009661922],
            [-7.3985108543345355, 1.4896410811200615],
            [-7.39877194697312, 1.4954548959858127],
            [-7.40463016010648, 1.4942162644151593],
            [-7.407559167224674, 1.4901497271752933],
            [-7.416105451570571, 1.4914510643698935],
            [-7.419647449627711, 1.4955882451065896],
            [-7.4218007343754095, 1.5015141558757943],
            [-7.425512847429455, 1.5027511836648662],
            [-7.429797016050888, 1.5074108050031436],
            [-7.432925483965798, 1.5176786582521375],
            [-7.430003907644344, 1.527105073864054],
            [-7.433903043168097, 1.5316121601504893],
            [-7.434927287968572, 1.537019771092481],
            [-7.438155832630405, 1.5415093430104623],
            [-7.4377689125798785, 1.5492720444333432],
            [-7.440614622919937, 1.5533360441858717],
            [-7.443437303238706, 1.571933056136346],
            [-7.445131846059277, 1.574335071275755],
            [-7.448349860203371, 1.5833792096381636],
            [-7.451496996675579, 1.5892926704276606],
            [-7.449512345655227, 1.5937612741451261],
            [-7.451295911871651, 1.6016398011567832],
            [-7.454650627987483, 1.610426251625901],
            [-7.455142167112175, 1.617618510974274],
            [-7.454313093947986, 1.6219665031517168],
            [-7.449355486341541, 1.6262809289904931],
            [-7.449844562069899, 1.6313586509660616],
            [-7.448363437636087, 1.6393077526713267],
            [-7.4492129747234, 1.6460114059165505],
            [-7.44813563196597, 1.6532873084294497],
            [-7.44959629783292, 1.6572043325896857],
            [-7.4540240059912595, 1.6607623262749973],
            [-7.454573858336175, 1.6635540298827927],
            [-7.449469106087774, 1.669680549295271]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.11636166246855, "lat": 39.634185693794 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08117"],
        "coty_name": ["Summit"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Summit County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00198174"
      },
      "bbox": [
        -7.455142167112175, 1.0682873179528427, -6.984530574580412,
        1.669680549295271
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.256653126205423, -8.403396760575587],
            [12.35963866411286, -8.389376534945711],
            [12.42173109246999, -8.38054583248681],
            [12.424557115225005, -8.38026138768201],
            [12.425982105562227, -8.38447144645363],
            [12.423014593572278, -8.387260763661413],
            [12.426172537091212, -8.390026563433164],
            [12.42669180301206, -8.392970712976267],
            [12.433430120548868, -8.391070735347697],
            [12.436198266193578, -8.395202186459379],
            [12.440522030760699, -8.397913759080064],
            [12.447290795636784, -8.400107227323025],
            [12.44873943535047, -8.406419594882513],
            [12.444742292509295, -8.408230782944981],
            [12.439740067660512, -8.406375400638204],
            [12.444039602882455, -8.401729504783292],
            [12.434591640645765, -8.40232556546763],
            [12.427546942606831, -8.399905082204176],
            [12.424079186427976, -8.404215980809795],
            [12.423427946401102, -8.407411011864438],
            [12.429824466709793, -8.414074990819753],
            [12.429768663778807, -8.426564995904872],
            [12.430946738481273, -8.431645402874107],
            [12.434073879690388, -8.434459945474885],
            [12.441309421771763, -8.435506860624434],
            [12.443349557071794, -8.437515711224652],
            [12.449423871812805, -8.439797405460784],
            [12.458331708183351, -8.438156023103124],
            [12.47045742085424, -8.431984899572507],
            [12.478625897980125, -8.43162589211649],
            [12.480524491615208, -8.433765467580034],
            [12.48565396181696, -8.428985559522332],
            [12.488850798367261, -8.437837810280024],
            [12.495481821957005, -8.433978903299655],
            [12.490715071022546, -8.431288563383674],
            [12.498334315558502, -8.418603484008512],
            [12.50379796331425, -8.420605356043184],
            [12.507217102513756, -8.423481094316216],
            [12.513124574887248, -8.423098534878381],
            [12.513202431380027, -8.41957822753301],
            [12.516501320743776, -8.418695203736476],
            [12.51779029803816, -8.415801275778744],
            [12.522875818404788, -8.414364897521821],
            [12.52660778023269, -8.411217835489746],
            [12.532293839648197, -8.418384326696229],
            [12.536465812211905, -8.41715627255907],
            [12.538647054318963, -8.412071244019133],
            [12.543711544473942, -8.4066513074394],
            [12.548294803473556, -8.407618112977813],
            [12.550511101998202, -8.411396835945578],
            [12.553588813368458, -8.411358380831818],
            [12.551606986059378, -8.40261424333418],
            [12.55509365122773, -8.401578098904759],
            [12.558414988979688, -8.405314319289403],
            [12.564623443056378, -8.404032068504899],
            [12.565297544310177, -8.402037760175164],
            [12.56078168218782, -8.373314397663124],
            [12.56557760377574, -8.369539976048033],
            [12.571298021701908, -8.363304682067406],
            [12.574371475919563, -8.35638112216081],
            [12.578394729498445, -8.350599250117018],
            [12.582835633884194, -8.346577102695916],
            [12.60067673496039, -8.336983273090333],
            [12.60557823885907, -8.335837658348158],
            [12.612388365924609, -8.335719742322592],
            [12.628820489117198, -8.330700248084726],
            [12.634998963182403, -8.329839081424836],
            [12.639868265918434, -8.32627017280362],
            [12.649509585091192, -8.321906651625627],
            [12.66097248312193, -8.313375300049868],
            [12.667578096476781, -8.316001127683666],
            [12.6724203800162, -8.316534772046356],
            [12.674205768165566, -8.318746251636576],
            [12.681504474721665, -8.321939961035193],
            [12.68338620463411, -8.317261806264405],
            [12.682926285510918, -8.312344328626981],
            [12.686977922599528, -8.310024463507066],
            [12.691514152386642, -8.310232056848744],
            [12.699809950164834, -8.31488465428477],
            [12.700947053953678, -8.311248514485028],
            [12.708734166410133, -8.30948507117358],
            [12.711435914167186, -8.307318818717901],
            [12.722023520456743, -8.305898490477427],
            [12.723392418019623, -8.303753305744264],
            [12.728025056550168, -8.303085079239413],
            [12.736728151600591, -8.297600567035492],
            [12.742041772777222, -8.331302450795306],
            [12.752319027156574, -8.329888856841526],
            [12.79921310283104, -8.321877610579296],
            [12.809009398175593, -8.378643680408395],
            [12.837394925783594, -8.373712625209887],
            [12.841659545192847, -8.39863712864881],
            [12.846546203195354, -8.431251810622012],
            [12.885608368279545, -8.425473644804917],
            [12.909275650609041, -8.42119267585468],
            [12.917392913750085, -8.431618405248463],
            [12.918357386354618, -8.438576986043351],
            [12.922142537683326, -8.442936723691597],
            [12.92026939667976, -8.447976284037205],
            [12.924306804875714, -8.4503595500914],
            [12.922640272476317, -8.453685664336628],
            [12.917737301521544, -8.450388324120395],
            [12.908309989420882, -8.454402391606683],
            [12.905239653754903, -8.463109263412724],
            [12.905700910271024, -8.469011303802425],
            [12.912411641724981, -8.481805597718836],
            [12.916138226146924, -8.48659962142281],
            [12.920371517306686, -8.489749352286347],
            [12.927471494692616, -8.491009937407044],
            [12.931133983562878, -8.489679165911468],
            [12.934724999645983, -8.492726825186894],
            [12.938846436643022, -8.498285339502921],
            [12.940045484060871, -8.502269580791289],
            [12.946489208838095, -8.510540719278513],
            [12.95046245734515, -8.536249788508211],
            [12.969530482917106, -8.652170366550596],
            [12.983712882082566, -8.733790069985883],
            [12.965976350182236, -8.736457426929126],
            [12.973136861548124, -8.782813657599647],
            [12.979533495494996, -8.821705647305736],
            [12.947209605861667, -8.82683233780697],
            [12.927109954804068, -8.828807645762902],
            [12.86975644721538, -8.837600195168578],
            [12.820488095216357, -8.844768379223638],
            [12.820552078439658, -8.8458895640743],
            [12.80971527693607, -8.847608556975025],
            [12.792341299464539, -8.849637850427714],
            [12.774060260390652, -8.852748399046],
            [12.723597761589126, -8.860047013387277],
            [12.687681106080197, -8.865453801908435],
            [12.66968706582994, -8.867872138661182],
            [12.615729761569318, -8.875639349526958],
            [12.53388114184721, -8.887793938067487],
            [12.468927122766525, -8.896853316963474],
            [12.467315705576329, -8.896863902989034],
            [12.41368903481592, -8.904703690167429],
            [12.410913032426743, -8.896042950140412],
            [12.406619783006075, -8.892721345723675],
            [12.39544649972336, -8.88881081328293],
            [12.392914838460984, -8.88616173677701],
            [12.38830648883696, -8.885276373616607],
            [12.384051092358101, -8.881640074962586],
            [12.380294631049079, -8.882847126331447],
            [12.373995741522862, -8.879621042598528],
            [12.365694762713511, -8.878406380019266],
            [12.363536879054994, -8.873293952235604],
            [12.36022307250842, -8.870245947635222],
            [12.354161951907365, -8.87135799962754],
            [12.342591352765309, -8.867313867267717],
            [12.335976709685756, -8.868328012310705],
            [12.331949770077225, -8.865426397885164],
            [12.333711401351193, -8.862131211709793],
            [12.33107753970303, -8.860046228980485],
            [12.327316191085995, -8.861486124774387],
            [12.321800621415955, -8.861352609509042],
            [12.320936555678458, -8.86329533964839],
            [12.313834490069052, -8.866449150842476],
            [12.31110907295363, -8.861362305687054],
            [12.302799877699542, -8.859756954392921],
            [12.302323651009177, -8.857395545368377],
            [12.295891120209143, -8.85439915787337],
            [12.2931324333609, -8.849651358329474],
            [12.290239956620221, -8.84743032462643],
            [12.281172162024944, -8.844147620470377],
            [12.278977325840561, -8.844467831744845],
            [12.27462440828653, -8.840805963754784],
            [12.270130167331386, -8.84115070215536],
            [12.266562441411857, -8.83827763537393],
            [12.263742554121919, -8.840119979843095],
            [12.261028624969995, -8.835896216132625],
            [12.252933461831972, -8.835765621246889],
            [12.247871177599436, -8.83751285035794],
            [12.24684377191643, -8.840703522428425],
            [12.243432527251459, -8.843360636276312],
            [12.24030969015181, -8.848219323528506],
            [12.231654437475473, -8.850888795903858],
            [12.227448543619813, -8.848666813775717],
            [12.221441222758346, -8.85287375454082],
            [12.216355827465428, -8.850270826420923],
            [12.207636700900222, -8.849768094768642],
            [12.206882343865612, -8.840965426894007],
            [12.195221522574304, -8.765549523339788],
            [12.193489654330005, -8.746774592584378],
            [12.190579113635097, -8.72551020049803],
            [12.184310779659892, -8.68365830976705],
            [12.202651787544172, -8.681030348122952],
            [12.266200139197775, -8.67152212665981],
            [12.297967268531927, -8.66661254613421],
            [12.29625770294659, -8.655200294180199],
            [12.287784499245342, -8.604933134609192],
            [12.28209173748992, -8.569474915137533],
            [12.279978606713689, -8.554718029507068],
            [12.271279843344308, -8.497634790661392],
            [12.265584735205662, -8.458135357371386],
            [12.26435941664829, -8.458290912005037],
            [12.256653126205423, -8.403396760575587]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.0566213618651, "lat": 29.210294446357153 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12083"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00306922"
      },
      "bbox": [
        12.184310779659892, -8.904703690167429, 12.983712882082566,
        -8.297600567035492
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.108976661646771, -10.391529569254015],
            [14.194946870935494, -10.377692734464945],
            [14.28231644075214, -10.363242133664935],
            [14.37552024535631, -10.34886437950959],
            [14.3789199210927, -10.347792931776306],
            [14.407749822546966, -10.343492530523578],
            [14.455232920930118, -10.33538039798499],
            [14.451531426020649, -10.31121564323795],
            [14.444589402676895, -10.30647318360891],
            [14.442750478882902, -10.301763802201048],
            [14.447086780456699, -10.301079902632692],
            [14.449205589675856, -10.29878488586072],
            [14.446441029208131, -10.2795929827029],
            [14.482267248519195, -10.274410187025412],
            [14.521785332720121, -10.267881935359927],
            [14.529597367429018, -10.279964182380239],
            [14.566831479313446, -10.330090190909328],
            [14.572334908358977, -10.342660307013169],
            [14.577851309033024, -10.351581266020101],
            [14.575180928786114, -10.358149607771418],
            [14.583827353027376, -10.372421415345782],
            [14.591114854961951, -10.386191654333446],
            [14.595989389777085, -10.397683926330215],
            [14.606321800796886, -10.41374682520241],
            [14.614501057628889, -10.424022630686284],
            [14.626173940407972, -10.43966781857439],
            [14.628599676881942, -10.444985315546141],
            [14.632591265909978, -10.450366923269385],
            [14.655278244933918, -10.488173229153938],
            [14.667334754924916, -10.517403205580374],
            [14.675581269064173, -10.53243437126438],
            [14.620848375686712, -10.541095882359183],
            [14.622988047131987, -10.554907900203123],
            [14.579960551202394, -10.561978970346129],
            [14.52317863483441, -10.570898223842953],
            [14.494139101063203, -10.574951022482018],
            [14.407987280877467, -10.588500135109912],
            [14.35580198365383, -10.597688081994326],
            [14.321578639960068, -10.602967403275152],
            [14.23498316737654, -10.616956660205597],
            [14.20151312871716, -10.622434349727897],
            [14.082961468368488, -10.640773986251435],
            [13.964403217046886, -10.659070265903491],
            [14.002488206825511, -10.61451009106868],
            [14.04056202797522, -10.569935016964202],
            [14.078624712945821, -10.525345103243296],
            [14.116676294226894, -10.480740409605378],
            [14.12282537807177, -10.472894081018909],
            [14.108976661646771, -10.391529569254015]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.4314538781175, "lat": 27.07749304233229 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12085"],
        "coty_name": ["Martin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Martin County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00308550"
      },
      "bbox": [
        13.964403217046886, -10.659070265903491, 14.675581269064173,
        -10.267881935359927
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.146282847434763, -5.277672481254037],
            [12.212055123759642, -5.245968733504091],
            [12.272719991519008, -5.216166951797259],
            [12.278011250934933, -5.211028589954613],
            [12.283942188379585, -5.212502522573545],
            [12.291223787535385, -5.215850313483099],
            [12.29593632116126, -5.216100897148516],
            [12.298641657204048, -5.214081109901241],
            [12.301336625919566, -5.216958221596191],
            [12.304377831389262, -5.216354627200324],
            [12.307378925293571, -5.218644776759314],
            [12.306506452079143, -5.223941399165482],
            [12.310929774054248, -5.22841779775738],
            [12.308564316708168, -5.230487211011773],
            [12.31226579576969, -5.233390311057052],
            [12.31486259675606, -5.230694585520259],
            [12.325357597473632, -5.2386331354067535],
            [12.325010355402627, -5.242656739649108],
            [12.331304347130533, -5.247654481463796],
            [12.335644030239903, -5.249681847077309],
            [12.338992652315277, -5.247799316327463],
            [12.342596648592762, -5.252275572754445],
            [12.346161280298523, -5.254433053287727],
            [12.351437897458345, -5.25474478594904],
            [12.356044382427246, -5.256864703152368],
            [12.364091524881394, -5.264492108049884],
            [12.371382323689025, -5.265506223256587],
            [12.371149851153284, -5.2706146581483],
            [12.373339048389058, -5.274600706672965],
            [12.378562839423383, -5.27813254851941],
            [12.38956441653484, -5.2841475184305535],
            [12.394506482938548, -5.281907149115572],
            [12.400009403171065, -5.285513084732949],
            [12.400761459898122, -5.28790333766942],
            [12.413844517738536, -5.299148344967926],
            [12.418411632217179, -5.295421752339472],
            [12.424995242509969, -5.296687151086301],
            [12.429218159380424, -5.299665376149291],
            [12.432599845586246, -5.298284742271856],
            [12.434477857575253, -5.303595579152995],
            [12.43811909512255, -5.304735959439697],
            [12.441690815521888, -5.301267059032836],
            [12.445195709433198, -5.306043693904277],
            [12.444887349496979, -5.30935987630234],
            [12.451793939786743, -5.3112043190511375],
            [12.455414073777835, -5.310454139257624],
            [12.457182204522184, -5.306521561160107],
            [12.465628585927364, -5.309520056701973],
            [12.46707294275325, -5.313411179891411],
            [12.470761026716925, -5.312361332518975],
            [12.476179477337958, -5.3131351440745265],
            [12.477814436133954, -5.318743357483015],
            [12.482359127355442, -5.321627601506459],
            [12.487875072892967, -5.32146519154475],
            [12.497493391340077, -5.326749849464702],
            [12.497774082261323, -5.323895411424525],
            [12.503093035763131, -5.319843025678224],
            [12.51109514092485, -5.3188043524329425],
            [12.526119224791712, -5.331236320080083],
            [12.533532213262047, -5.335365134095536],
            [12.537946389366208, -5.335348197359564],
            [12.539566173643266, -5.337734638030256],
            [12.541803836052516, -5.339933568093376],
            [12.550709071987756, -5.344068175723143],
            [12.551662976382158, -5.350178152102384],
            [12.548491433809083, -5.349221053647481],
            [12.547067421267931, -5.359067724465827],
            [12.555728905498672, -5.358955670087428],
            [12.557907282020157, -5.361160150088916],
            [12.557942422147395, -5.36554751356509],
            [12.56259496367375, -5.370814513329207],
            [12.563641639249445, -5.377979309081299],
            [12.560297828710146, -5.386927668512476],
            [12.555724350151415, -5.388825142558166],
            [12.560359560191625, -5.402260327448333],
            [12.555200565520451, -5.408397997450285],
            [12.557168768575862, -5.411454649948237],
            [12.564966160896086, -5.417852153154075],
            [12.563503410028277, -5.422115039966098],
            [12.565019020362906, -5.430777647449855],
            [12.56939938770124, -5.433371374976165],
            [12.574234557075329, -5.43139018456837],
            [12.576025952854168, -5.432752855676862],
            [12.576511805125028, -5.441706150029355],
            [12.57952187544843, -5.445541595922408],
            [12.584762692264421, -5.445931227752825],
            [12.58572649043572, -5.449908180242896],
            [12.590460291451834, -5.453309511461013],
            [12.593046585216367, -5.462586026621879],
            [12.60208487818085, -5.467947598763784],
            [12.60932106446026, -5.470365328066807],
            [12.609937886902683, -5.47573662347089],
            [12.613771675067149, -5.478799581040916],
            [12.613221773678667, -5.483850290115641],
            [12.620567026877426, -5.487758058441336],
            [12.62298405914527, -5.485093174986054],
            [12.628068859661305, -5.48596292269553],
            [12.634179451767277, -5.489935357205131],
            [12.634759590462425, -5.500970877465936],
            [12.638483493069666, -5.500838905906799],
            [12.646703969338548, -5.507777230836264],
            [12.648219596824603, -5.5139555518898895],
            [12.65118544671104, -5.5163815739769335],
            [12.648710493272892, -5.521690303328435],
            [12.653274363370029, -5.5226113547373075],
            [12.655244204894741, -5.527023731787552],
            [12.65390230816188, -5.529427852070802],
            [12.655494007733125, -5.5333656891966685],
            [12.662155891120069, -5.536049599893387],
            [12.663991153925164, -5.5402596171237555],
            [12.661732705587394, -5.542988878193278],
            [12.665426495976066, -5.544990654912426],
            [12.668370776222815, -5.55049292157368],
            [12.667482721153045, -5.555982837005431],
            [12.671153354092327, -5.563063831958244],
            [12.668962462115623, -5.567072335266554],
            [12.67062426558944, -5.5687888968186385],
            [12.614512882634058, -5.596726105410555],
            [12.569381648299728, -5.619379608454162],
            [12.521301813530622, -5.643718876355838],
            [12.486700085427117, -5.6593899849595735],
            [12.396871437092065, -5.699805448005725],
            [12.395462610347892, -5.692147044489286],
            [12.396666344454891, -5.68844269532934],
            [12.393971769992524, -5.686375943288202],
            [12.393495503891517, -5.677603280555612],
            [12.389447006982806, -5.675787978989881],
            [12.385976216166789, -5.668725350856389],
            [12.381039316526657, -5.6612550861462445],
            [12.378178251112837, -5.662058079797178],
            [12.372732560481847, -5.658945216066306],
            [12.369208462612848, -5.651967604503687],
            [12.367534264189722, -5.651361534519101],
            [12.366826020366245, -5.640805007705092],
            [12.367674615739245, -5.636453657257325],
            [12.360109878694784, -5.62997210744131],
            [12.359070420949182, -5.624614532547897],
            [12.354725646934968, -5.620566862002943],
            [12.343981157705244, -5.621141988035611],
            [12.339842455894177, -5.618119897768629],
            [12.333057035303725, -5.620304048856844],
            [12.325707625524775, -5.613774166476435],
            [12.319776315933295, -5.609720836929767],
            [12.310733641416727, -5.6048514235509215],
            [12.30851749368492, -5.605460024881385],
            [12.303471719364245, -5.601107648193286],
            [12.298404105860918, -5.599309451014738],
            [12.285563410899982, -5.593141766994526],
            [12.271509175861532, -5.594963943767302],
            [12.264381519580207, -5.59669572205827],
            [12.25154439384178, -5.603305024611778],
            [12.23642215519686, -5.608481438599273],
            [12.227458764098259, -5.604721430211163],
            [12.222941418520332, -5.60850435709218],
            [12.227890304722704, -5.597773499753973],
            [12.228180676841818, -5.591742484801074],
            [12.2304641908601, -5.589745394667224],
            [12.229283266818147, -5.581376991786544],
            [12.23236023220856, -5.571463023959188],
            [12.230638039448566, -5.564718039060177],
            [12.232347697409566, -5.559238680552534],
            [12.236108747047664, -5.5171365370013525],
            [12.239091254134273, -5.492834157352892],
            [12.243110308601466, -5.457168763812829],
            [12.238192692123501, -5.454245938304936],
            [12.230869550799767, -5.454130969656354],
            [12.224179082205179, -5.4494353565299605],
            [12.2227041779409, -5.4404560176292565],
            [12.218750519981958, -5.436652299249267],
            [12.216576693524397, -5.436716603080288],
            [12.211438627973907, -5.431809970251153],
            [12.207186881071669, -5.4292916559930555],
            [12.205583908106483, -5.426151996135721],
            [12.20153731919605, -5.4257920481550945],
            [12.198982289315115, -5.420071871287301],
            [12.198128084730678, -5.414917433172295],
            [12.1942053490831, -5.411486433999999],
            [12.188996185029549, -5.409975281645811],
            [12.185794990676639, -5.399419262766983],
            [12.186830397954914, -5.3943744922385966],
            [12.182535809039603, -5.382757055071706],
            [12.179666116514962, -5.379812158236797],
            [12.182834732314511, -5.376881730614049],
            [12.185184661450274, -5.366744968806915],
            [12.132294685605583, -5.348716375878954],
            [12.132691648557307, -5.332064547044648],
            [12.146064704689845, -5.277737106426854],
            [12.146282847434763, -5.277672481254037]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.74313119680292, "lat": 32.39671209870679 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13031"],
        "coty_name": ["Bulloch"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bulloch County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00350302"
      },
      "bbox": [
        12.132294685605583, -5.699805448005725, 12.671153354092327,
        -5.211028589954613
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.068736361341177, -4.5052284909596425],
            [10.125001411081332, -4.498944455966886],
            [10.126140370869217, -4.506833796865669],
            [10.134037781950155, -4.505997348595775],
            [10.13486895255958, -4.514010569529055],
            [10.142681192013418, -4.513252674964359],
            [10.145333380413424, -4.537256592201967],
            [10.15331974582201, -4.5362912638143404],
            [10.154346524326447, -4.544430376951804],
            [10.162053643222078, -4.543618214948352],
            [10.163055904394755, -4.551914980059384],
            [10.155418177131645, -4.55286927021642],
            [10.156517818774276, -4.560937297654448],
            [10.147898234155985, -4.5619323967507],
            [10.149047064681648, -4.56923751230672],
            [10.15193073302259, -4.5951422416819625],
            [10.12817658498205, -4.597852799051375],
            [10.129827774379503, -4.613993870103358],
            [10.138459077787648, -4.613035491301512],
            [10.141996811310378, -4.6503392363267215],
            [10.143327908932818, -4.661523824817235],
            [10.134914296293367, -4.662578535372343],
            [10.140492370669541, -4.711045649505368],
            [10.132590843755562, -4.712184837465807],
            [10.133660913406674, -4.720262269428862],
            [10.117828677672343, -4.721611577756073],
            [10.116971801016238, -4.7137182170425085],
            [10.091985826072548, -4.7165594609930235],
            [10.101679322800603, -4.799083780746375],
            [10.101608609221925, -4.799945604909789],
            [10.073848874614601, -4.803396655426865],
            [10.073165499408509, -4.8000688490700725],
            [10.067166115558758, -4.796338996279473],
            [10.068024182487225, -4.789210958736582],
            [10.064531674965892, -4.783516487370902],
            [10.071656222103016, -4.780487886129671],
            [10.071105061563879, -4.775838669361665],
            [10.068305437624316, -4.774323238788746],
            [10.068265418225035, -4.770464589403637],
            [10.064085408782283, -4.768200007514458],
            [10.063200294440733, -4.762342009458341],
            [10.068794490640302, -4.755256595983638],
            [10.067972847939062, -4.7461616929276484],
            [10.062466782358932, -4.744596095614487],
            [10.06148021154328, -4.736598803400473],
            [10.053865712781755, -4.737444865830715],
            [10.051972856290686, -4.721254950061437],
            [10.05983285661777, -4.7201371987424485],
            [10.05893008662286, -4.712169563819716],
            [10.066164826389556, -4.711391413660821],
            [10.061278399261283, -4.706060674241734],
            [10.06446517271788, -4.701488893610253],
            [10.063563239363397, -4.697245602533245],
            [10.065608061297123, -4.692617240192632],
            [10.061633539672291, -4.689626628971518],
            [10.061876791163812, -4.68473240818091],
            [10.059601298875446, -4.680069575428212],
            [10.055101285534189, -4.677447289442749],
            [10.050970817956255, -4.672258816645619],
            [10.038719593423348, -4.66469534978059],
            [10.029739014103917, -4.665690682895466],
            [10.028013513211487, -4.650123316547624],
            [10.015373092460718, -4.6366682654963025],
            [10.01467076353878, -4.629306400998453],
            [10.012196444124394, -4.619687934729095],
            [10.007356336212126, -4.611075477416761],
            [9.991544205919741, -4.612785046465614],
            [9.989562883427265, -4.598385280809144],
            [9.989102097042087, -4.59102668788167],
            [9.980413211011745, -4.5154877240993825],
            [9.984226349554437, -4.514620125181248],
            [9.985156438387074, -4.522261934143867],
            [9.989093282420159, -4.521782670125413],
            [9.988111336602508, -4.514264503710019],
            [10.044210990692951, -4.507858224388161],
            [10.068736361341177, -4.5052284909596425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.35758168267816,
          "lat": 33.541893206689856
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13063"],
        "coty_name": ["Clayton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clayton County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01672399"
      },
      "bbox": [
        9.980413211011745, -4.803396655426865, 10.163055904394755,
        -4.498944455966886
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.073483445683713, -3.522131141587927],
            [10.080628125329552, -3.5304295388809352],
            [10.082026303553137, -3.5365132405224116],
            [10.087949843407651, -3.6001767514403182],
            [10.109140234274262, -3.616129875370035],
            [10.122487437900196, -3.62750235364338],
            [10.131169721271435, -3.6356391209228422],
            [10.157595335368338, -3.6582910620115796],
            [10.169388242279805, -3.658843768578552],
            [10.169503163112648, -3.6656511218019547],
            [10.191929865169982, -3.6728188681287475],
            [10.209121536229945, -3.678923080279252],
            [10.232589876033735, -3.6860975794743274],
            [10.255495946800053, -3.6940778846658406],
            [10.273867744157315, -3.699277016985259],
            [10.271899074283771, -3.7008936461864685],
            [10.271345618917042, -3.7064779611825416],
            [10.275878315261783, -3.705978995992096],
            [10.28252786555108, -3.7112504014840555],
            [10.282732551206667, -3.7178133091128185],
            [10.279858686050277, -3.7192458252647462],
            [10.27909797077006, -3.7266287052998037],
            [10.275567223607753, -3.73178337223287],
            [10.27538068852253, -3.735010044355645],
            [10.281628270247587, -3.73799329854966],
            [10.279953689462008, -3.7403390935801766],
            [10.279898309321913, -3.747982918017562],
            [10.284217232893171, -3.7524385001430174],
            [10.280929847639259, -3.759785555651831],
            [10.285309998936233, -3.760500169592214],
            [10.289534731903624, -3.768257421404652],
            [10.293156861068647, -3.7721328087732906],
            [10.295091986780118, -3.7764403029311557],
            [10.298178341266372, -3.7729670915871596],
            [10.303752005649645, -3.781035804606828],
            [10.253759020999702, -3.7870680627835798],
            [10.175427944110115, -3.7966322997821593],
            [10.058939516071261, -3.8106009222899675],
            [10.053643623950348, -3.7648034675802946],
            [10.043502483070833, -3.67854929278885],
            [9.992455408044371, -3.684321301411116],
            [9.961434981651204, -3.6064849108666586],
            [9.959754490012028, -3.5921693095820197],
            [9.958538574147228, -3.588967267173252],
            [9.961922557705298, -3.5870870733446227],
            [9.965865578299134, -3.582153222009735],
            [9.96993405550238, -3.5809872334737847],
            [9.965122449809403, -3.5766990729791956],
            [9.972706261923232, -3.569388041485671],
            [9.97797295708157, -3.5702506467389536],
            [9.980984365635154, -3.5730740559259058],
            [9.985554995178282, -3.5739338021500746],
            [9.988478242300566, -3.5696585425539693],
            [9.997278038630197, -3.5748612126183033],
            [9.999728949781055, -3.5793814848762113],
            [10.00574902378193, -3.5803814179302527],
            [10.012954294287786, -3.5786356844554854],
            [10.01477127596838, -3.5742609671557712],
            [10.01854578403466, -3.5766408767948983],
            [10.023811096091162, -3.576287009674974],
            [10.03220271387079, -3.5775630146072457],
            [10.029104382708558, -3.5483618023470065],
            [10.054098002249376, -3.5457702221958654],
            [10.057800502029021, -3.5417952298239115],
            [10.060250326121892, -3.532094235036077],
            [10.064985767652734, -3.527506432045805],
            [10.071503110711575, -3.525167667124266],
            [10.073483445683713, -3.522131141587927]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.17059371424266, "lat": 34.44428086947921 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13085"],
        "coty_name": ["Dawson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dawson County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00351312"
      },
      "bbox": [
        9.958538574147228, -3.8106009222899675, 10.303752005649645,
        -3.522131141587927
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.732917199491638, -6.901974018228901],
            [9.735097740141914, -6.892162906987077],
            [9.73361777820804, -6.8821988709607975],
            [9.728845876301792, -6.876748031546925],
            [9.729776261899096, -6.870598010653271],
            [9.729654402498635, -6.860708319083442],
            [9.727857787319197, -6.856662774502074],
            [9.723107542789304, -6.854150978362618],
            [9.722673250177543, -6.847076264466299],
            [9.725977692373673, -6.836768363038525],
            [9.728604345577281, -6.82636891945482],
            [9.729237026211118, -6.816873618102442],
            [9.73101346545776, -6.8117056540071745],
            [9.730759081387587, -6.807757605385399],
            [9.727692676022254, -6.8004554604624525],
            [9.729789437753281, -6.794697580008427],
            [9.729810344486259, -6.785875226972534],
            [9.731798511302687, -6.7821181900317695],
            [9.734919380208401, -6.782421521768053],
            [9.737286378352026, -6.7791727128313415],
            [9.736525260454286, -6.770271887622765],
            [9.73466298228488, -6.762715395289142],
            [9.731784956222207, -6.756837721470815],
            [9.728081153388596, -6.742297310957207],
            [9.73127570412409, -6.726135649567162],
            [9.733849244000021, -6.721930941193914],
            [9.73561483406636, -6.713726697951303],
            [9.742412446961472, -6.695184139331264],
            [9.744502459545762, -6.691485457765414],
            [9.749440535146627, -6.690360659233889],
            [9.751301154439401, -6.69193440339506],
            [9.757855201858357, -6.688510769144457],
            [9.761815411834426, -6.720668788665463],
            [9.78099176228894, -6.718659117259231],
            [9.784672112855844, -6.716253929459202],
            [9.788769325544793, -6.716307832461911],
            [9.797677695305236, -6.713735685388186],
            [9.803584835211034, -6.710227851054753],
            [9.809276654920321, -6.703905541580232],
            [9.819549838356814, -6.707272132167814],
            [9.82138144745855, -6.704048277378341],
            [9.832918039527499, -6.696981963646505],
            [9.837750580112203, -6.695317606351692],
            [9.883259500801127, -6.690674183553179],
            [9.890173115098113, -6.690227483708372],
            [9.936712111987424, -6.685155134595584],
            [9.937878713725638, -6.694686355798229],
            [9.948724867140877, -6.69324590014907],
            [9.947389823414067, -6.683747499318051],
            [9.956265640505336, -6.6827632570186655],
            [9.95912778973721, -6.710239232237735],
            [9.950504029786284, -6.711864429788691],
            [9.955102085931877, -6.718244525153182],
            [9.95634996037394, -6.722268321499984],
            [9.96352337025757, -6.724298090090483],
            [9.96644584720634, -6.727787354356491],
            [9.966540546029238, -6.737755292619686],
            [9.96993461531542, -6.7432558506193585],
            [9.970326818990983, -6.746298657747492],
            [10.009832086966226, -6.742193814487862],
            [10.027773612024907, -6.74052924098295],
            [10.098437340463882, -6.733558574982799],
            [10.098663694132018, -6.737503743245109],
            [10.104033205604088, -6.788523102897238],
            [10.105589690093568, -6.796652482947308],
            [10.108909788319275, -6.824912852990763],
            [10.117859567213214, -6.823952364243228],
            [10.11907491007188, -6.833302636986834],
            [10.110204811926707, -6.834399152071795],
            [10.109955718062475, -6.843670783739882],
            [10.11096564025465, -6.853883890927923],
            [10.109525017223795, -6.854129924295204],
            [10.115918534493114, -6.907090074624385],
            [10.11620551942819, -6.909498162051693],
            [10.099736670826609, -6.9111335570410155],
            [10.099428527429735, -6.908659764920073],
            [10.089633274730678, -6.909742529635787],
            [10.089944154807208, -6.912042410917421],
            [10.080992347429097, -6.913035845111386],
            [10.081651644101882, -6.918755812506474],
            [10.07232701213804, -6.919593808606407],
            [10.071668852664802, -6.913671044215679],
            [10.06242434399438, -6.914698133591354],
            [10.063106079778988, -6.920437492473282],
            [10.035759536304736, -6.923284974891991],
            [10.035225541108284, -6.9173947525003605],
            [10.02586350024788, -6.91829205152854],
            [10.02648422739101, -6.924203104620357],
            [9.970793407097226, -6.929593585119694],
            [9.883014868110996, -6.937499351217976],
            [9.88704764777082, -6.97896739850794],
            [9.887397513993614, -6.986165069053162],
            [9.889561982223448, -7.006690703240206],
            [9.895123504635038, -7.067047504380219],
            [9.896713891557509, -7.082047766688018],
            [9.898380840763283, -7.10269344954796],
            [9.900182070743652, -7.119386941544136],
            [9.809907449302738, -7.126881756066698],
            [9.810947042952744, -7.118089745633111],
            [9.806452148116474, -7.106597796383242],
            [9.803318138496023, -7.102541564904462],
            [9.800078479458259, -7.095275130881158],
            [9.786496014551613, -7.086087748543699],
            [9.782463215049713, -7.084644456891065],
            [9.775497913644312, -7.072006085047713],
            [9.772040112615969, -7.064113497358803],
            [9.76611395514133, -7.058593492200165],
            [9.75970218900793, -7.051061747991925],
            [9.753499463644182, -7.049062708963895],
            [9.746201337005408, -7.04923338729827],
            [9.738741063901125, -7.044877201264703],
            [9.738497463500602, -7.0302067126628245],
            [9.734968782524657, -7.026017906658634],
            [9.730143743683437, -7.024848072582566],
            [9.728567162012212, -7.015819495569467],
            [9.728748329672246, -7.008725138812452],
            [9.734755325146018, -6.999423710304593],
            [9.733808203922214, -6.991285795301148],
            [9.734748785769122, -6.985022213407404],
            [9.732197757492925, -6.9784228394426835],
            [9.726540420181868, -6.969699725048677],
            [9.720940556474076, -6.9575652560355445],
            [9.718380876676099, -6.954435357042369],
            [9.716344185963322, -6.948329652482672],
            [9.716558506636355, -6.940148662047037],
            [9.713720518577025, -6.935603218544658],
            [9.716846888860596, -6.930833768290591],
            [9.726044294912978, -6.927343621572027],
            [9.730440486166946, -6.921301924437919],
            [9.732691048376395, -6.915690933677572],
            [9.7334116430466, -6.906555058490624],
            [9.732917199491638, -6.901974018228901]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.90363222060734,
          "lat": 31.322828117658457
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13099"],
        "coty_name": ["Early"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Early County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00345041"
      },
      "bbox": [
        9.713720518577025, -7.126881756066698, 10.11907491007188,
        -6.6827632570186655
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.381206236633167, -5.841693164832649],
            [12.390202976085563, -5.8389851311814684],
            [12.39257036722895, -5.835166647148556],
            [12.428547400604664, -5.801220559502745],
            [12.458238145928787, -5.754840631689852],
            [12.465767569531002, -5.751186868419216],
            [12.470836356599019, -5.753754922372366],
            [12.474758496413, -5.750933392142404],
            [12.477392582966873, -5.753877415031011],
            [12.480035370256317, -5.752603820276653],
            [12.483644253309443, -5.756089254192606],
            [12.48538239995055, -5.760877385435728],
            [12.489590339808293, -5.763679468056066],
            [12.49569309519317, -5.764231119952442],
            [12.499643215227815, -5.769988277804977],
            [12.50030796332166, -5.774258629191336],
            [12.50593657537455, -5.774636526028473],
            [12.50762008647438, -5.77781732770053],
            [12.511796643721894, -5.779129383334827],
            [12.519137667956025, -5.7769941897667705],
            [12.522211501571752, -5.7811343741913825],
            [12.525028115814239, -5.7805683698284644],
            [12.528266406875806, -5.783014787208231],
            [12.532307872264429, -5.79011673383144],
            [12.534851998368813, -5.789936568117443],
            [12.540085121332046, -5.795330493445467],
            [12.543302677903915, -5.7959743367714855],
            [12.54644269368462, -5.7990467668471934],
            [12.549559718486078, -5.798782330696546],
            [12.55383777375438, -5.805963559282194],
            [12.55348372713402, -5.809388788142104],
            [12.565330089024155, -5.817929645117502],
            [12.565363011417258, -5.8249829599927345],
            [12.56828741183588, -5.826927366664705],
            [12.573850646469745, -5.8361002571517435],
            [12.576748056573114, -5.835579155096485],
            [12.578144731352348, -5.845098429015682],
            [12.580984635639298, -5.8475981981994565],
            [12.5812124544483, -5.854426155896274],
            [12.591431666208333, -5.854270935840805],
            [12.59325914445014, -5.8525075913655895],
            [12.601807565882778, -5.856442520429602],
            [12.606687204796378, -5.863674503917341],
            [12.612315177602044, -5.862976113069193],
            [12.616689508704468, -5.8642995635535335],
            [12.618583892957407, -5.861190748566218],
            [12.625029549808621, -5.861191915100866],
            [12.628885826231672, -5.8570747010049375],
            [12.638221785373302, -5.85603717112142],
            [12.641748335431616, -5.858872079573086],
            [12.647424457934385, -5.8548550802081225],
            [12.646672334011631, -5.849264576919372],
            [12.650282806866324, -5.8474093070520485],
            [12.652114165546198, -5.849814272981189],
            [12.657443472040589, -5.852547954678283],
            [12.662300058504963, -5.846098465561333],
            [12.66987800189723, -5.847096788857493],
            [12.672192124795139, -5.840487496042053],
            [12.67752062883204, -5.837898442434725],
            [12.682259622967075, -5.839298102216975],
            [12.691923160282304, -5.860232491229488],
            [12.724502459894126, -5.866695470927075],
            [12.731910420924626, -5.86468651168196],
            [12.734500809499826, -5.861635222109946],
            [12.739879930945479, -5.8587451662603955],
            [12.743117363799302, -5.8656610285047135],
            [12.748522522565077, -5.872337874537625],
            [12.747344199182942, -5.874949575179466],
            [12.74853198574931, -5.879813113098325],
            [12.74620471664027, -5.882547029930455],
            [12.75041258618147, -5.887578438766557],
            [12.750467042541633, -5.890444097101815],
            [12.756822876678283, -5.896070623284265],
            [12.760920048588416, -5.906713647159134],
            [12.758500950367623, -5.913300277532158],
            [12.758466959794465, -5.917608124479845],
            [12.761958540539972, -5.919960142075271],
            [12.7669566329481, -5.919451746939075],
            [12.770828657672563, -5.922859092432271],
            [12.773742907579177, -5.931222053044958],
            [12.77241401296929, -5.938191490235975],
            [12.775228418127744, -5.944556298122613],
            [12.777502360389153, -5.944493797559866],
            [12.779088138178075, -5.949297662779346],
            [12.78458010417178, -5.950219852118969],
            [12.786927574194584, -5.952431864532578],
            [12.789877017723732, -5.949879597239588],
            [12.794212021928855, -5.958771280585937],
            [12.799382794270965, -5.956122414789133],
            [12.798509417090735, -5.963952706739696],
            [12.80532802554812, -5.968590661402027],
            [12.810589870559395, -5.968591340680559],
            [12.810282351500613, -5.974780072059721],
            [12.804857852654415, -5.974617406455064],
            [12.801828405004274, -5.976975017036191],
            [12.803662666816841, -5.980136245689326],
            [12.80850980239315, -5.979598647721345],
            [12.815167304626428, -5.975668842855163],
            [12.816165958984822, -5.972200148881136],
            [12.811725717196866, -5.965222744740947],
            [12.819417209580573, -5.957892677806694],
            [12.815910039031012, -5.956471621422868],
            [12.809805085782925, -5.9589798843992146],
            [12.808163275166896, -5.956579518775372],
            [12.812167992234164, -5.9524082494661865],
            [12.81775914099697, -5.951625327057022],
            [12.820433944973582, -5.9526776273827045],
            [12.825298373515528, -5.960923929955853],
            [12.824724315260466, -5.968196748302282],
            [12.829307567546914, -5.968749155829292],
            [12.835469329031405, -5.971508766308818],
            [12.836635072498497, -5.974732574181409],
            [12.833753267325589, -5.981054277536656],
            [12.834746552045692, -5.983023698580469],
            [12.842774445839668, -5.988352047642947],
            [12.844215180814212, -5.998642570396562],
            [12.848618583998105, -5.998870108148419],
            [12.853997692349786, -5.997126260305112],
            [12.8662600569952, -5.990673990322491],
            [12.87158049912507, -5.989645680654521],
            [12.877857945676537, -5.993624925758238],
            [12.880655189273632, -5.99834580448733],
            [12.880654125529725, -6.008153251630838],
            [12.88213218418396, -6.018472613353631],
            [12.886016768986737, -6.023930935202627],
            [12.891629085157492, -6.027278438325988],
            [12.914614289375484, -6.030301552266681],
            [12.920245801294564, -6.032141870904151],
            [12.928432390115217, -6.033225589186697],
            [12.932768444350371, -6.035715954741178],
            [12.941171173614508, -6.044334235722796],
            [12.94832747572293, -6.0469973309215765],
            [12.945026761796745, -6.054207369128547],
            [12.952830961289505, -6.058658505741556],
            [12.962272434018873, -6.069649741563298],
            [12.984955557755914, -6.076320983875807],
            [12.989975816380918, -6.0730349010822],
            [12.991556638574947, -6.0682004875189826],
            [13.00177668487862, -6.065076499217738],
            [13.009334568587121, -6.068080075058197],
            [13.007514382180283, -6.080783639617836],
            [13.008199204081583, -6.089430151973608],
            [13.011763102510116, -6.101851578303216],
            [13.015535944634145, -6.122523479921341],
            [13.021320527274186, -6.131237215054648],
            [13.009559546721222, -6.1714502264326505],
            [13.004447319104633, -6.195534140561951],
            [12.996597178588127, -6.208356499542405],
            [12.990944787024908, -6.210058615508405],
            [12.987188081133954, -6.206961623571614],
            [12.981001213101854, -6.1968454608112955],
            [12.98041654893939, -6.189570324801311],
            [12.976205471918375, -6.190002153351581],
            [12.975190707292226, -6.1721515269690235],
            [12.97293455573029, -6.168278695658434],
            [12.967642010091199, -6.163009246972757],
            [12.960414870236376, -6.158928623122705],
            [12.949711091669153, -6.1546780424114225],
            [12.946550494352138, -6.148069282790289],
            [12.943269226586828, -6.144470554030937],
            [12.929221352592347, -6.137563202767976],
            [12.91831690094735, -6.136431469371435],
            [12.906997652773242, -6.130184456106085],
            [12.90083906805377, -6.129064641438367],
            [12.891188408905135, -6.130688622679363],
            [12.880361373864252, -6.13517182439531],
            [12.872948303741643, -6.134889194368067],
            [12.866117651720627, -6.130109741267668],
            [12.861447565850836, -6.127913630367839],
            [12.856517592273793, -6.129248913426073],
            [12.852053880616142, -6.135295479147595],
            [12.845654131363245, -6.139203721560791],
            [12.841848154922877, -6.1431065010359],
            [12.83762627855326, -6.139450457296654],
            [12.827814699230585, -6.1378761896532295],
            [12.82481088643977, -6.140508390158933],
            [12.820299141825313, -6.140186265072056],
            [12.81382381044657, -6.143963913312264],
            [12.810811330994783, -6.142733028626205],
            [12.80803619289911, -6.1446239531524025],
            [12.805573094955928, -6.149611955012038],
            [12.799838170916201, -6.150474380825359],
            [12.799365895145336, -6.1534882551443255],
            [12.795469550925208, -6.154375252920974],
            [12.784503394567356, -6.150774045167267],
            [12.782354457701999, -6.152106873462876],
            [12.776081516213393, -6.148505927542379],
            [12.770408963290766, -6.152685624375102],
            [12.769267960353725, -6.159483357348196],
            [12.764044890440685, -6.161417154049279],
            [12.76111500242274, -6.1591999855881845],
            [12.755883647017644, -6.15109252197026],
            [12.753468304620174, -6.149103212844693],
            [12.747755334200951, -6.14812995071075],
            [12.743177486519269, -6.14570424578671],
            [12.739421717761275, -6.140343667988918],
            [12.736873660765236, -6.134501726526662],
            [12.730863117572806, -6.1295741804949975],
            [12.729891407597247, -6.126723410211984],
            [12.735184400731816, -6.123021608168682],
            [12.734082571770157, -6.118575176035906],
            [12.72953678270763, -6.1130914376559495],
            [12.721260796322786, -6.110581503784413],
            [12.706843632539627, -6.111096855147757],
            [12.70024840350139, -6.111708387299337],
            [12.599009285287215, -6.074700587658227],
            [12.587324050236223, -6.070282265629367],
            [12.571305534373726, -6.065165632385459],
            [12.566955763828298, -6.045362583029602],
            [12.5540280994374, -6.034879622678371],
            [12.550427849758757, -6.03260297669322],
            [12.526542933175369, -6.027856746921006],
            [12.519249154139622, -6.025180270708172],
            [12.518081465587455, -6.022056461311704],
            [12.508053491503258, -6.011979966947536],
            [12.49979553902808, -6.005484318361693],
            [12.486802722900153, -6.000434993185087],
            [12.479509010998195, -5.989843486464464],
            [12.46730737921092, -5.984553016809661],
            [12.46440872386322, -5.98453581650653],
            [12.455991116915092, -5.976182437746867],
            [12.45151650850612, -5.97299918311677],
            [12.448978838198713, -5.961563420897987],
            [12.450891390290224, -5.952509059457756],
            [12.45340404836152, -5.946247346067446],
            [12.4513878631316, -5.941082863659793],
            [12.455582838726828, -5.932089071821305],
            [12.456771388044581, -5.919824139033983],
            [12.458918295042503, -5.9094986378097865],
            [12.456555412153554, -5.900467132501619],
            [12.45826346048549, -5.891724001738682],
            [12.456950436352505, -5.88569593425443],
            [12.452866552187258, -5.877340875123941],
            [12.448933773859437, -5.873367000558184],
            [12.442894160859794, -5.872283990711815],
            [12.430884417928377, -5.871910554023567],
            [12.42876984341991, -5.869777593717094],
            [12.423940073161821, -5.869539715962947],
            [12.412191610300107, -5.874543193684982],
            [12.40758688866514, -5.871927644231391],
            [12.402048715081527, -5.866479888619714],
            [12.400514441852312, -5.860343570354851],
            [12.39126471419909, -5.852094629549658],
            [12.384002762669667, -5.849235391673142],
            [12.381206236633167, -5.841693164832649]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.49494126151338,
          "lat": 31.828320528003328
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13179"],
        "coty_name": ["Liberty"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Liberty County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "00357095"
      },
      "bbox": [
        12.381206236633167, -6.210058615508405, 13.021320527274186,
        -5.750933392142404
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-8.630456097307563, -11.08182223039596],
              [-8.628611337767046, -11.070344887735136],
              [-8.626489010233245, -11.065480309126546],
              [-8.62567793424135, -11.05184023408769],
              [-8.620222482874778, -11.043097629792987],
              [-8.617999666472203, -11.035549949028862],
              [-8.614081410749014, -11.026406041917854],
              [-8.607922093307176, -11.017184086137243],
              [-8.601236973515642, -11.003894986303052],
              [-8.600789352151342, -10.996497475388317],
              [-8.594823526230355, -10.996544379369363],
              [-8.591236012951665, -10.994610909414067],
              [-8.585519432996845, -10.995132055579319],
              [-8.581687082761634, -10.98971132475306],
              [-8.574552482008311, -10.987454698244001],
              [-8.577677215008263, -10.981780035647015],
              [-8.577670245265724, -10.977458085948172],
              [-8.571060467638553, -10.975634253912528],
              [-8.562514012180396, -10.978866971606504],
              [-8.556643566932163, -10.976389181319314],
              [-8.551653623526033, -10.977375970890938],
              [-8.54670014095469, -10.976038811510778],
              [-8.54221018065055, -10.969685654586529],
              [-8.528323012397399, -10.97002898810973],
              [-8.528007189165931, -10.976472408852821],
              [-8.524463953516047, -10.97894385257881],
              [-8.52355164612157, -10.981938484867324],
              [-8.519067473233862, -10.98363272832892],
              [-8.51405428928568, -10.982635303914801],
              [-8.510267617267326, -10.98451198937768],
              [-8.506829477692898, -10.9884955203293],
              [-8.501620721357574, -10.98650825770854],
              [-8.49673760590366, -10.991622843487763],
              [-8.494068351472226, -10.99934791786647],
              [-8.491607673444337, -11.001724120198835],
              [-8.48801048051117, -10.997775499691269],
              [-8.486136578433005, -10.998754647322379],
              [-8.478607329247058, -11.014677572526303],
              [-8.474180224566494, -11.014985729507956],
              [-8.468949783988494, -11.012377302320093],
              [-8.469181801930068, -11.026799702055605],
              [-8.468676153943939, -11.034857963930689],
              [-8.464702427087355, -11.037138390376658],
              [-8.460027795498393, -11.04669903122904],
              [-8.45293557343828, -11.051293302153978],
              [-8.451810463417935, -11.061572500536187],
              [-8.448966324480914, -11.063929875369295],
              [-8.441605988356573, -11.06738088730086],
              [-8.437920830089258, -11.075250235335329],
              [-8.437214563118118, -11.082497066078286],
              [-8.433158437270954, -11.088231074979031],
              [-8.431185088632123, -11.086836085335165],
              [-8.427184796159947, -11.09272909573402],
              [-8.42582444739755, -11.099344303442459],
              [-8.418105134786824, -11.096748522879551],
              [-8.41481355315587, -11.098803092558144],
              [-8.397705041324274, -11.100233761466699],
              [-8.385611814639807, -11.094138247638915],
              [-8.374757367436041, -11.087799006400736],
              [-8.371390642819277, -11.087281356753884],
              [-8.368650494207344, -11.089293623061273],
              [-8.36191044989319, -11.087863983053685],
              [-8.355435454004864, -11.085258274192883],
              [-8.347995835207273, -11.084484153314852],
              [-8.344674818433171, -11.082594644515133],
              [-8.335659814232384, -11.081677947432306],
              [-8.333347560645585, -11.078502959536545],
              [-8.326208491170355, -11.074135983525265],
              [-8.322186543561044, -11.06861642897844],
              [-8.303395684564242, -11.059581534200694],
              [-8.291556150404531, -11.059452169620808],
              [-8.28843777501289, -11.05585905747037],
              [-8.284084390194847, -11.053510451094724],
              [-8.280603210891838, -11.054579444110317],
              [-8.277541860348315, -11.05117851058788],
              [-8.271168042083442, -11.05317343026928],
              [-8.263684259582355, -11.058306511395044],
              [-8.253543916863363, -11.05537900900201],
              [-8.240304773340693, -11.052572307981421],
              [-8.237413417083326, -11.05496419032028],
              [-8.232217146660899, -11.06321170141486],
              [-8.227731009501206, -11.063033307668064],
              [-8.22183467851803, -11.058325264393027],
              [-8.21546435815677, -11.063665845653093],
              [-8.212309042994084, -11.059909724016208],
              [-8.200953597843359, -11.061891384445763],
              [-8.193115181061202, -11.069015260179752],
              [-8.1888401221366, -11.06891969840528],
              [-8.187560545019371, -11.076163200425036],
              [-8.188900031115512, -11.08150726395239],
              [-8.186348283100463, -11.08318833404279],
              [-8.181561905019056, -11.081842442098912],
              [-8.176362312851621, -11.084035422597614],
              [-8.176373145634027, -11.091378268576571],
              [-8.172211076181888, -11.093770352298012],
              [-8.16152938727559, -11.101617014944337],
              [-8.15759201426303, -11.102414551124658],
              [-8.154614772977068, -11.108840803724096],
              [-8.149600387184128, -11.111910730142423],
              [-8.145464527487226, -11.11673239319569],
              [-8.138903527514563, -11.119318245230646],
              [-8.131737194208956, -11.124711426576766],
              [-8.131630567759219, -11.130214846606446],
              [-8.123617635414584, -11.133702824067637],
              [-8.121423163160019, -11.136160794112675],
              [-8.118078065457874, -11.135872896066926],
              [-8.11299698955079, -11.130604256287675],
              [-8.110495398370315, -11.130491675702636],
              [-8.11041134614899, -11.137497392047926],
              [-8.097408575005224, -11.136145234169565],
              [-8.096161266812658, -11.140761963569155],
              [-8.094552866608614, -11.154055332725685],
              [-8.08869401404838, -11.156995237053133],
              [-8.08325833935581, -11.164374819893244],
              [-8.08388719049517, -11.168115916710113],
              [-8.075008376334702, -11.17159633517799],
              [-8.072154810161672, -11.169898986178008],
              [-8.066382167870623, -11.169592276594388],
              [-8.057169946863603, -11.166437735118004],
              [-8.04265889735125, -11.175788995785874],
              [-8.03662889685117, -11.178170010094897],
              [-8.034326957728956, -11.182366937303353],
              [-8.028172626465263, -11.186993747471961],
              [-8.020321690398795, -11.186760367865197],
              [-8.016441682260519, -11.188778033888639],
              [-8.010981374124501, -11.187820546670682],
              [-7.995559384918285, -11.192242431142457],
              [-7.987840680853769, -11.19683695832344],
              [-7.9837390661361365, -11.19676775862994],
              [-7.975071560677822, -11.202016681196886],
              [-7.975008186974295, -11.207302324041446],
              [-7.971538833450284, -11.20825077156065],
              [-7.960557124075387, -11.219448111605416],
              [-7.959050654864906, -11.226456485293571],
              [-7.961712272749383, -11.232809965413356],
              [-7.959303164035218, -11.236771476553951],
              [-7.955419511289709, -11.235423899190637],
              [-7.954982196801808, -11.23936868351617],
              [-7.9583365578585745, -11.242326539076576],
              [-7.958300998212843, -11.250397824501734],
              [-7.959414457671758, -11.258273574966887],
              [-7.96095693033047, -11.26054442912886],
              [-7.958559471743949, -11.26480727040754],
              [-7.95869374728599, -11.26996072344615],
              [-7.962815168459956, -11.275222324797861],
              [-7.96266350586521, -11.283203174808836],
              [-7.96820442107992, -11.285904925979766],
              [-7.9712829284740945, -11.291020846852248],
              [-7.972918512593824, -11.296200415214273],
              [-7.979278634143566, -11.302807390364464],
              [-7.98623442882342, -11.308719044229512],
              [-7.990116978885699, -11.307101968767487],
              [-7.993511270543212, -11.309588205648721],
              [-8.001002183595055, -11.311541547655992],
              [-8.012521897637836, -11.323325232315819],
              [-8.012112158152897, -11.329367797770502],
              [-8.017939272016726, -11.337636439579244],
              [-8.02099374488885, -11.339628443289808],
              [-8.026189833062036, -11.339749728143257],
              [-8.034901549331236, -11.343614087412021],
              [-8.04242279400603, -11.342328187872466],
              [-8.048149233706383, -11.339200192213793],
              [-8.053806245922116, -11.343451969430333],
              [-8.062193017771301, -11.3483645997989],
              [-8.071961058942643, -11.34910349461719],
              [-8.078218047910468, -11.350426934161135],
              [-8.07966112134977, -11.354959171398868],
              [-8.08618554673407, -11.359747538751611],
              [-8.090517490568544, -11.359873313648695],
              [-8.094399076679561, -11.36667918032977],
              [-8.100076079580836, -11.366119754755323],
              [-8.101708531312031, -11.369632276121038],
              [-8.10475305472266, -11.371558765521213],
              [-8.11000094663642, -11.365813111843863],
              [-8.119231254630451, -11.363614693783166],
              [-8.127797967711565, -11.367946238387828],
              [-8.130806368617895, -11.365229960489698],
              [-8.134384848137165, -11.368763104722905],
              [-8.140422120980007, -11.367349548212905],
              [-8.142130723732073, -11.363024684359967],
              [-8.149707730212109, -11.3631137728662],
              [-8.153973572815806, -11.361592916036914],
              [-8.16716542621219, -11.36459832963506],
              [-8.174655631519498, -11.36688173886471],
              [-8.18356389043127, -11.370962676089674],
              [-8.187918656891048, -11.37505810778992],
              [-8.194179044129298, -11.378780644459056],
              [-8.198069933068727, -11.37896563750278],
              [-8.207943162628817, -11.383774046950156],
              [-8.220037568244274, -11.391700371445769],
              [-8.222814719725168, -11.390893880854694],
              [-8.234716097698975, -11.39590190975397],
              [-8.24035855770328, -11.39767292757274],
              [-8.243470616813994, -11.401518074977773],
              [-8.247411436682649, -11.403821616966031],
              [-8.255739022624695, -11.40618372007053],
              [-8.277791144211886, -11.404354857672008],
              [-8.286629629630188, -11.405796610986712],
              [-8.289713080909092, -11.408333272684551],
              [-8.29342853883713, -11.408882987381253],
              [-8.295194136863488, -11.40626211478149],
              [-8.301887370637871, -11.40588492452427],
              [-8.303382552273105, -11.408801684890983],
              [-8.310251194432853, -11.410866690000962],
              [-8.317331848098842, -11.41175198452544],
              [-8.31987940679654, -11.413511637435871],
              [-8.325521544072817, -11.414325911178897],
              [-8.334946716986348, -11.408586689090793],
              [-8.33769502218884, -11.409872673445806],
              [-8.352296012978348, -11.409257064488001],
              [-8.353612000479053, -11.406286584880698],
              [-8.361778913524768, -11.406623049502416],
              [-8.363584157441492, -11.403212802471549],
              [-8.36218041413739, -11.399120457166832],
              [-8.363485555606267, -11.39507709752259],
              [-8.369323674027925, -11.390766860056162],
              [-8.37509132181503, -11.39536621160229],
              [-8.383652671026903, -11.3917052749852],
              [-8.388544462162823, -11.385827230903821],
              [-8.388058006773504, -11.38077726965895],
              [-8.384994127122939, -11.376341024150921],
              [-8.387222866455398, -11.369261466273372],
              [-8.393693206189724, -11.361061507936467],
              [-8.399463145135433, -11.35717646344385],
              [-8.400863545498988, -11.353918042372802],
              [-8.394984099274415, -11.35119142448877],
              [-8.394246513434325, -11.346517230385171],
              [-8.390608040013184, -11.343838144624572],
              [-8.389270948078215, -11.338491610494705],
              [-8.391453713812629, -11.335379202372732],
              [-8.389758961256865, -11.331405100357546],
              [-8.39044857622986, -11.325861921202783],
              [-8.392557874664234, -11.324432706255985],
              [-8.393144782703544, -11.305749636462508],
              [-8.392369545805419, -11.300745481716866],
              [-8.393746857894868, -11.290377574427055],
              [-8.395420663134711, -11.287103946489594],
              [-8.394061864637248, -11.281463512587614],
              [-8.395881301626925, -11.270957838561502],
              [-8.398530223561972, -11.26765595468298],
              [-8.400288967665572, -11.261984931590147],
              [-8.403572842005314, -11.257653321808288],
              [-8.406993798139212, -11.241137374892139],
              [-8.406743247253, -11.223878086105902],
              [-8.408253323305296, -11.215984262908874],
              [-8.420183748447325, -11.204339656053648],
              [-8.434814238653603, -11.199494529247684],
              [-8.44443963631784, -11.198497769541262],
              [-8.450522614379462, -11.199822300983],
              [-8.454922073762846, -11.204398530088369],
              [-8.45915985168656, -11.207100571558627],
              [-8.463068436772316, -11.214826313185048],
              [-8.469094804210345, -11.218522467780229],
              [-8.480093871448185, -11.21990487615945],
              [-8.485728180559578, -11.214503201981287],
              [-8.507221336822099, -11.202592914047013],
              [-8.523385032529081, -11.20009485521485],
              [-8.530630885883795, -11.196004632187167],
              [-8.5382721964543, -11.18961080428573],
              [-8.546399894223557, -11.185728225232044],
              [-8.551049828691768, -11.185588856107055],
              [-8.556011045224881, -11.187844563029184],
              [-8.560299020008836, -11.18649103988737],
              [-8.564779210372183, -11.181643674413593],
              [-8.567403531703334, -11.173608734374119],
              [-8.576871638401883, -11.163811809942981],
              [-8.582542396986009, -11.162035447490647],
              [-8.589278321737522, -11.152597100444737],
              [-8.602432660073433, -11.138755640821728],
              [-8.607979513911214, -11.135520146123069],
              [-8.612456662478767, -11.128592925388848],
              [-8.613888431276983, -11.122427623546141],
              [-8.622748597052535, -11.115390375544731],
              [-8.619107548681718, -11.11030558577584],
              [-8.618879763404392, -11.095612159967779],
              [-8.624734366843516, -11.085647387582595],
              [-8.630456097307563, -11.08182223039596]
            ]
          ],
          [
            [
              [-8.632429996447728, -11.460697504231547],
              [-8.630869837432627, -11.455725212771288],
              [-8.62662692548161, -11.45041818676245],
              [-8.620864531919542, -11.446417951594078],
              [-8.620523313854054, -11.444577353012571],
              [-8.614159960424802, -11.439709262143818],
              [-8.611245729227752, -11.434292328566935],
              [-8.600170240252035, -11.431341061525119],
              [-8.594720599882596, -11.428470800892313],
              [-8.581317774990735, -11.425936910982983],
              [-8.572331496766715, -11.41826127627786],
              [-8.568852332122958, -11.41711343681229],
              [-8.560940001142363, -11.410373094544559],
              [-8.551364100664168, -11.405719921518338],
              [-8.546617460308173, -11.39992676115983],
              [-8.527236810624574, -11.390116180894383],
              [-8.519534039565231, -11.387584819081663],
              [-8.508699233658538, -11.387220913533703],
              [-8.505494584232682, -11.38827081367055],
              [-8.502978426925893, -11.39160488915584],
              [-8.494758474834127, -11.395351513192248],
              [-8.48101018906283, -11.413421168093185],
              [-8.48000471353702, -11.420828165508375],
              [-8.4894273530458, -11.424452007051732],
              [-8.488208246496775, -11.42938154783909],
              [-8.489276905721717, -11.436903226875804],
              [-8.494396302247639, -11.443342516562712],
              [-8.495072098489235, -11.451765434350218],
              [-8.491935261501894, -11.454364775518735],
              [-8.48527459651605, -11.451269672541956],
              [-8.481222562904389, -11.454533327548557],
              [-8.475809709353838, -11.454126808964102],
              [-8.474108135652898, -11.46013966241363],
              [-8.476456366472117, -11.46320202340573],
              [-8.483017098603598, -11.468050508746526],
              [-8.482763105172195, -11.472086286137575],
              [-8.486707354205514, -11.475985075994215],
              [-8.489486788250463, -11.475515001192745],
              [-8.494313660136376, -11.47069429365655],
              [-8.498135608907038, -11.469857287606892],
              [-8.500020570167965, -11.47271771931336],
              [-8.507560151670512, -11.47203894561218],
              [-8.51316254618962, -11.474722075191398],
              [-8.52636593952789, -11.479575237123402],
              [-8.531658257193586, -11.472892965466785],
              [-8.54142716812186, -11.47245358574061],
              [-8.546907569730651, -11.475151360343931],
              [-8.548287103619012, -11.471736446223431],
              [-8.559212966872378, -11.474249907851123],
              [-8.567291368914143, -11.47766576233914],
              [-8.576203140543104, -11.482973314345783],
              [-8.5793210209546, -11.480739611522024],
              [-8.581687001132476, -11.47234572034669],
              [-8.587385868871669, -11.477336466657649],
              [-8.591357426662322, -11.482548094712769],
              [-8.596868085752757, -11.48434372216636],
              [-8.600684294260516, -11.48699909371511],
              [-8.603128909828706, -11.484101133101525],
              [-8.606613643579195, -11.486912991337892],
              [-8.610673480049503, -11.483977970970928],
              [-8.613136034551399, -11.484596329375995],
              [-8.619089246448391, -11.479689764638502],
              [-8.61659765113717, -11.476012351304865],
              [-8.618505620176407, -11.472978003412678],
              [-8.624606231844234, -11.471869699528687],
              [-8.63335345460009, -11.463728435532621],
              [-8.632429996447728, -11.460697504231547]
            ]
          ],
          [
            [
              [-8.971398315222851, -11.096071225732446],
              [-8.967745565379454, -11.087745987637607],
              [-8.963698495114574, -11.084352982273684],
              [-8.95991705293399, -11.083690351246078],
              [-8.948119133651574, -11.076082142125264],
              [-8.935208870261683, -11.07254725176414],
              [-8.921734370742989, -11.072201690194118],
              [-8.916151009107603, -11.070902371867898],
              [-8.908557802114958, -11.070902296423895],
              [-8.902528207476152, -11.069819223428338],
              [-8.885107674766635, -11.075231948309714],
              [-8.860654795003837, -11.076342795645663],
              [-8.855952111738546, -11.075104735924848],
              [-8.842588263093905, -11.078471619962594],
              [-8.835184521718649, -11.078775640914541],
              [-8.821183503193295, -11.083401518909072],
              [-8.814506635478754, -11.086531285172434],
              [-8.806489610903556, -11.093644293563063],
              [-8.804405326409327, -11.093576052048903],
              [-8.761629341790423, -11.133439345139855],
              [-8.753888017454226, -11.140937790289657],
              [-8.746947036026455, -11.1497553308648],
              [-8.738098502520016, -11.165831595809081],
              [-8.732330593297462, -11.174298213092433],
              [-8.732625697837094, -11.188992525709214],
              [-8.740057812224226, -11.203463588285999],
              [-8.747353084682336, -11.211992889049514],
              [-8.754799140257408, -11.227719530952527],
              [-8.757218706413113, -11.228721861976737],
              [-8.761396513202909, -11.234192605511952],
              [-8.766858857565943, -11.236856844621752],
              [-8.775525786531118, -11.236529312181382],
              [-8.780512239295962, -11.239736264041877],
              [-8.789298836536465, -11.242636856516636],
              [-8.794272398295412, -11.247766964872987],
              [-8.802437254311489, -11.252001080436544],
              [-8.80641333623799, -11.24942590976762],
              [-8.811705257389596, -11.258860110966012],
              [-8.815127229641115, -11.254633266628035],
              [-8.81870372000335, -11.25398411655569],
              [-8.821929996537149, -11.256684231561662],
              [-8.827257645446075, -11.258117068808167],
              [-8.838182590990696, -11.2565464685008],
              [-8.841059339355764, -11.259124293805096],
              [-8.84937931677766, -11.257793316658251],
              [-8.853401764682731, -11.25974120550745],
              [-8.85647552202004, -11.257464454755388],
              [-8.8732468646624, -11.259449832951518],
              [-8.880309766574346, -11.261898139545982],
              [-8.883189453898305, -11.26050179376001],
              [-8.883077975372583, -11.25731718030875],
              [-8.889439604450363, -11.24897061704328],
              [-8.892953883504198, -11.246783166713305],
              [-8.897791411880046, -11.24083660506241],
              [-8.9047818360099, -11.215702813453008],
              [-8.906815538479124, -11.215141049463845],
              [-8.907480489140449, -11.208016620002795],
              [-8.905428221896091, -11.204146073850595],
              [-8.905362773266638, -11.195059957846288],
              [-8.903636052014807, -11.188691270529208],
              [-8.903416556923668, -11.178533005849987],
              [-8.90711036891901, -11.169552177264515],
              [-8.920654706714245, -11.147116557799167],
              [-8.925310981743271, -11.142818458110384],
              [-8.944720200392618, -11.133793657283093],
              [-8.94801737848165, -11.134161965241857],
              [-8.952449141881381, -11.129440945643683],
              [-8.95446906170401, -11.130262963008258],
              [-8.958055046515952, -11.127139815791683],
              [-8.961464840146924, -11.12702408178123],
              [-8.969538039042746, -11.113998566934333],
              [-8.972233605651518, -11.107083577635066],
              [-8.971398315222851, -11.096071225732446]
            ]
          ],
          [
            [
              [-8.928482233869568, -10.821342212773844],
              [-8.928502172674797, -10.822489585660618],
              [-8.918653945003827, -10.826231794819034],
              [-8.908153106534291, -10.827039623568645],
              [-8.89978687382753, -10.825569833065664],
              [-8.890288188708285, -10.829297252765546],
              [-8.887958618555027, -10.835610806049672],
              [-8.88815820393074, -10.838776986238464],
              [-8.88147745733068, -10.84493186241377],
              [-8.87883884608921, -10.84376455244353],
              [-8.880686165612216, -10.838004276787386],
              [-8.87967585068839, -10.833472961580622],
              [-8.88012567950704, -10.825758098708969],
              [-8.877872011807154, -10.825399682662503],
              [-8.876607437503482, -10.832433374132556],
              [-8.876236745296167, -10.843368021793882],
              [-8.874983999932288, -10.846203201623299],
              [-8.868820288298817, -10.850669833933102],
              [-8.863142802866081, -10.845776557505362],
              [-8.8555893814059, -10.850779192128709],
              [-8.848955697109554, -10.862314067693374],
              [-8.847945564614996, -10.865544290988286],
              [-8.842103334439528, -10.871503072840248],
              [-8.837868318456177, -10.874062938129352],
              [-8.821128465656061, -10.871963287058252],
              [-8.822460379935006, -10.870348065028018],
              [-8.821366625119744, -10.860893259095077],
              [-8.81985322177459, -10.856372304738173],
              [-8.829023693575795, -10.849990757142388],
              [-8.83696678007368, -10.840663786570092],
              [-8.83790094723074, -10.835917791099316],
              [-8.835063632988877, -10.833406863692622],
              [-8.833637880497083, -10.838514207559706],
              [-8.82858137613817, -10.840168243004012],
              [-8.824168461667396, -10.840171524934663],
              [-8.822217890237225, -10.842346607397094],
              [-8.817309825878597, -10.841047016749519],
              [-8.813519621181472, -10.835855711331027],
              [-8.806825746701536, -10.83585284559402],
              [-8.805260633905748, -10.842556201111465],
              [-8.801467863477221, -10.84320331240027],
              [-8.798792947251615, -10.83844356115866],
              [-8.790823485799224, -10.839854417088853],
              [-8.788868384712222, -10.84290833785924],
              [-8.774107696735033, -10.839950741607334],
              [-8.767081937322395, -10.837591249099379],
              [-8.762669480828668, -10.839865832926497],
              [-8.755822234282194, -10.840228338649863],
              [-8.752544263308085, -10.836087250524491],
              [-8.749762684882246, -10.836379074971457],
              [-8.745060238391144, -10.833137487137725],
              [-8.736757773739999, -10.831561666440594],
              [-8.730683377419576, -10.829377432703746],
              [-8.726077723540952, -10.831189712802946],
              [-8.723382951316202, -10.835585126399796],
              [-8.718028248067881, -10.836013110815065],
              [-8.712308805503813, -10.830469351440005],
              [-8.707952499200948, -10.831417018336108],
              [-8.70531629563604, -10.82973167554856],
              [-8.701726754653333, -10.830814535794232],
              [-8.699042481542703, -10.828374859087726],
              [-8.688737126059344, -10.829997904664419],
              [-8.669841433955819, -10.83099638204447],
              [-8.666043431054018, -10.835533485740006],
              [-8.666703164912267, -10.844616972328282],
              [-8.660058556076562, -10.846568364766968],
              [-8.649204314682208, -10.843659957983174],
              [-8.64171302298676, -10.845455770947199],
              [-8.643610305811467, -10.851090585419914],
              [-8.644820798910313, -10.85973363728989],
              [-8.64818673940824, -10.862741478586775],
              [-8.654622492804917, -10.874452720621537],
              [-8.661360199212925, -10.879246478301603],
              [-8.666879956085765, -10.888959116270879],
              [-8.670048806744159, -10.891654181425071],
              [-8.673869749340238, -10.892121419279787],
              [-8.675139940563163, -10.895988260106522],
              [-8.687533620068104, -10.906083562715608],
              [-8.694678046741455, -10.91040738174978],
              [-8.702651684525254, -10.91704204270264],
              [-8.703450827944033, -10.92014725272861],
              [-8.709693372168582, -10.920347698212558],
              [-8.714882886431358, -10.923208692191833],
              [-8.718395932404903, -10.929896653527937],
              [-8.72422004601768, -10.93110130064212],
              [-8.7290336209234, -10.934869998073005],
              [-8.742983626855317, -10.936513413997215],
              [-8.747403491113781, -10.941170260403387],
              [-8.75211037404649, -10.941154899628303],
              [-8.758115755736734, -10.94442328740491],
              [-8.76077226934738, -10.947749922769443],
              [-8.772400410819923, -10.946812559801614],
              [-8.775080127941058, -10.944650156860119],
              [-8.781195010594077, -10.94599116329032],
              [-8.783782194992225, -10.949632634468779],
              [-8.788691757203656, -10.952015744345756],
              [-8.795585710857253, -10.95289824012234],
              [-8.796915897786748, -10.956002345253623],
              [-8.80562001486896, -10.954401484289999],
              [-8.808383806875408, -10.952750969566958],
              [-8.813915714125589, -10.952244037131702],
              [-8.816336683096585, -10.945968809167962],
              [-8.821307973718186, -10.94726346918536],
              [-8.834286762651589, -10.945065113059734],
              [-8.840421115026476, -10.94234894532187],
              [-8.853611453746629, -10.941079399330928],
              [-8.86097932002428, -10.93901473799105],
              [-8.866446922489336, -10.938552453168109],
              [-8.871467894201636, -10.935880150720724],
              [-8.882509157739245, -10.933867165014128],
              [-8.888802298137845, -10.931224907141686],
              [-8.896901833552196, -10.931674428200683],
              [-8.89832193307967, -10.92870955433823],
              [-8.907554075940748, -10.924120573042764],
              [-8.91527496615497, -10.925515851808479],
              [-8.917841369572189, -10.922314740039832],
              [-8.932331382363857, -10.91706123796736],
              [-8.93684242646215, -10.916765250576555],
              [-8.942418107819854, -10.914745085921876],
              [-8.946737657149646, -10.90841353976086],
              [-8.953226736519387, -10.90670715731988],
              [-8.960346143909293, -10.90690984672976],
              [-8.970913565221199, -10.903380643286932],
              [-8.977571521660341, -10.902338970388142],
              [-8.981538092428568, -10.903682379187295],
              [-8.990523149016022, -10.90089717686143],
              [-9.001153046784989, -10.900716082372577],
              [-9.004534647378714, -10.899323570102192],
              [-9.009719843825145, -10.902387140482741],
              [-9.013745634157473, -10.901207921293436],
              [-9.020621101287276, -10.902085087963695],
              [-9.02493557191314, -10.903940839227586],
              [-9.033865687318066, -10.9049132877647],
              [-9.044769333550663, -10.908785973080883],
              [-9.05214559376718, -10.909614174940884],
              [-9.054757792318597, -10.911052760640702],
              [-9.0625610715625, -10.90985006428452],
              [-9.078626602758082, -10.910213502552548],
              [-9.082394809705209, -10.911549547100494],
              [-9.090161769356902, -10.910917729008013],
              [-9.10499380825461, -10.912739895153642],
              [-9.117687120811059, -10.912517974202155],
              [-9.142416743572213, -10.914401653156043],
              [-9.1492624751153, -10.917552393535932],
              [-9.151919921199681, -10.914751661473485],
              [-9.181062904031892, -10.909484345805176],
              [-9.195396260105523, -10.909144397477883],
              [-9.200324782815086, -10.907382507715162],
              [-9.206566872917108, -10.901075298988065],
              [-9.202544060523993, -10.89467580402468],
              [-9.19729913835818, -10.888387881035534],
              [-9.195281838909757, -10.882428841637648],
              [-9.19698115325472, -10.879231546430653],
              [-9.193374867267023, -10.870435048398896],
              [-9.189272714362112, -10.86770484746932],
              [-9.188037558654788, -10.860711530481545],
              [-9.185565184201309, -10.856996900876188],
              [-9.175024214336348, -10.845688333765764],
              [-9.168107360616041, -10.84374517792094],
              [-9.155767442770193, -10.833379099196199],
              [-9.150743548637625, -10.826798942356596],
              [-9.151741608128992, -10.82238678055053],
              [-9.149160203677388, -10.820375395705094],
              [-9.147855080340117, -10.816159597834364],
              [-9.149025672366745, -10.813455737878774],
              [-9.147228788578191, -10.808311501327289],
              [-9.149667843130041, -10.797603503306497],
              [-9.157782321328835, -10.790107802113162],
              [-9.15906618481822, -10.786455321110981],
              [-9.153259427223157, -10.781592128587409],
              [-9.138932751065582, -10.787769426828731],
              [-9.132645425333648, -10.787501909359317],
              [-9.122263312523192, -10.788195914270446],
              [-9.117121607023291, -10.787567951058953],
              [-9.113824316557208, -10.783868716454577],
              [-9.10526572619824, -10.790266607601358],
              [-9.102944279960521, -10.7884808620203],
              [-9.099181184726618, -10.791315310829743],
              [-9.095400104019276, -10.797742347585435],
              [-9.09010606174499, -10.801951590043878],
              [-9.08237513646212, -10.80201360791061],
              [-9.075444187978244, -10.803924831952658],
              [-9.062269275461746, -10.803684330919694],
              [-9.061598963337232, -10.806423592496467],
              [-9.049125113732737, -10.807946067591237],
              [-9.049018778745937, -10.805816122687338],
              [-9.036620993794664, -10.805691873042221],
              [-9.028688455118436, -10.808350642108296],
              [-9.025949362686548, -10.80775085888734],
              [-9.020308482270126, -10.809935074150625],
              [-9.010152480680247, -10.809007435746558],
              [-9.001834191054105, -10.810275075770667],
              [-8.991798104711236, -10.814225230849445],
              [-8.984033580311156, -10.816384866473719],
              [-8.97593796073881, -10.816406541165478],
              [-8.971173222949693, -10.81913481351351],
              [-8.961647016587056, -10.819091943372895],
              [-8.955333351774602, -10.816691835839512],
              [-8.93890388465619, -10.818783993645622],
              [-8.928482233869568, -10.821342212773844]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -156.5649875940633,
          "lat": 20.859630654820915
        },
        "year": "2023",
        "ste_code": ["15"],
        "ste_name": ["Hawaii"],
        "coty_code": ["15009"],
        "coty_name": ["Maui"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Maui County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00365283"
      },
      "bbox": [
        -9.206566872917108, -11.48699909371511, -7.954982196801808,
        -10.781592128587409
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.511047112656057, 4.7100293416192685],
            [-10.521666917097326, 4.644625491534901],
            [-10.537418442790758, 4.547100891427056],
            [-10.548306919810125, 4.479083938355652],
            [-10.570283834917902, 4.342001006002326],
            [-10.592349556832646, 4.202332016486536],
            [-10.686790738254324, 4.217171238470117],
            [-10.789120663483045, 4.23342949122344],
            [-10.885585655419971, 4.248154983636133],
            [-10.906839755536003, 4.250995068529408],
            [-10.928535766747435, 4.254493290953512],
            [-10.928539618520588, 4.254493912622223],
            [-10.927202905013045, 4.262727037256759],
            [-10.928052570058062, 4.272090272352776],
            [-10.925242236883056, 4.277148519838492],
            [-10.925731675671901, 4.2889295733418775],
            [-10.922702948937584, 4.290414938404284],
            [-10.92213695442098, 4.295169681396762],
            [-10.92510080697666, 4.301746649858523],
            [-10.921459217248344, 4.311734219993012],
            [-10.924857747268039, 4.316776456051604],
            [-10.922698459142177, 4.323751376736049],
            [-10.926248925139603, 4.3281398089414305],
            [-10.933294635866849, 4.334120738049944],
            [-10.940495506465448, 4.334317869115936],
            [-10.945547097218732, 4.336470168112997],
            [-10.947401501280071, 4.34131858095361],
            [-10.951011104472174, 4.344745292255158],
            [-10.957623774143098, 4.344287716832793],
            [-10.961514826175131, 4.346838336699155],
            [-10.966637972561752, 4.356949709100728],
            [-10.9711094472866, 4.356154678713682],
            [-10.976986337669835, 4.358826380516369],
            [-10.97864934341279, 4.363982143412155],
            [-10.978417837507187, 4.372039055968492],
            [-10.972517427781401, 4.377328896811896],
            [-10.97122406924547, 4.383661232463668],
            [-10.968182201873523, 4.38778146449716],
            [-10.968197346422281, 4.395487667501457],
            [-10.962926355556595, 4.4051167575168755],
            [-10.965042047134464, 4.406022514151958],
            [-10.968894779192896, 4.413623034891759],
            [-10.976007766379476, 4.419633522165444],
            [-10.978269030431527, 4.428229461624509],
            [-10.976778664905805, 4.439710821518205],
            [-10.976733259868421, 4.450504683754817],
            [-10.982852692515833, 4.457963675545719],
            [-10.980697016819146, 4.467767145057442],
            [-10.980380213708314, 4.474717207950519],
            [-10.972982431922187, 4.48580531689289],
            [-10.97061201035885, 4.487801415682716],
            [-10.967979590110112, 4.49324808836691],
            [-10.967626691963519, 4.498468092568745],
            [-10.965863844559644, 4.502354194289458],
            [-10.966796822879843, 4.506089580910558],
            [-10.965667047393351, 4.51109045889512],
            [-10.961592670978671, 4.5150970406539015],
            [-10.952657450971598, 4.513933691708944],
            [-10.95093240119299, 4.519347935520046],
            [-10.945968158708284, 4.525369927163858],
            [-10.93791238685369, 4.527681858569441],
            [-10.92637273296559, 4.532979805240147],
            [-10.924753845482345, 4.537757418281345],
            [-10.933770187413261, 4.5412645249594],
            [-10.93436353102126, 4.54609235910932],
            [-10.93839780593519, 4.549550943094739],
            [-10.93804655108462, 4.555063155861585],
            [-10.935051789019884, 4.555727760037429],
            [-10.93567475949191, 4.565111139958009],
            [-10.931624869876272, 4.570911210398766],
            [-10.935243519469973, 4.581938668958101],
            [-10.934211139778046, 4.586327016102296],
            [-10.92563411807905, 4.58854249459085],
            [-10.917932221582534, 4.593493473973525],
            [-10.920369178189308, 4.596490510556385],
            [-10.916144985693059, 4.598728617289905],
            [-10.909207058634822, 4.606013839878087],
            [-10.903165172984266, 4.609173572628889],
            [-10.906589442177221, 4.61406845827658],
            [-10.906045360407767, 4.621392423476226],
            [-10.910159515711118, 4.626153959427268],
            [-10.916758544235167, 4.627009377059983],
            [-10.920809407575817, 4.63606391165241],
            [-10.917928592503664, 4.643064352334718],
            [-10.9196460455201, 4.646774516502242],
            [-10.920252283387486, 4.653982621311164],
            [-10.930673694415765, 4.652869009305628],
            [-10.929085590028405, 4.668109497018289],
            [-10.931146210941609, 4.670904445009816],
            [-10.930459458979378, 4.674110122290731],
            [-10.926684883179096, 4.67726765811331],
            [-10.92489507439703, 4.681681227628311],
            [-10.920610427740316, 4.6855010593208535],
            [-10.915667081488508, 4.685644454352316],
            [-10.910216946836252, 4.68930811187741],
            [-10.91266081976145, 4.694609851709625],
            [-10.910144203817232, 4.700551653629918],
            [-10.909668757583006, 4.705945346311207],
            [-10.91483599732417, 4.7233100800065815],
            [-10.915938511305823, 4.73800209043664],
            [-10.914816844425989, 4.742955150194586],
            [-10.91838049254059, 4.747875320555299],
            [-10.917169210650343, 4.752704644913658],
            [-10.91948488823856, 4.755647874755293],
            [-10.917979158128725, 4.762711753748818],
            [-10.919114585211268, 4.7719896439552505],
            [-10.926075020468122, 4.781873098862628],
            [-10.927199066486201, 4.786368145364272],
            [-10.926348437747533, 4.799391823358565],
            [-10.92816752688714, 4.804473320824214],
            [-10.92861551699741, 4.81116795724325],
            [-10.9262699941809, 4.817436067760897],
            [-10.928129616365608, 4.824544856779203],
            [-10.926685647773025, 4.8347937716401725],
            [-10.92093803737563, 4.839131736744046],
            [-10.915837533793438, 4.839657731733571],
            [-10.912402552125835, 4.845335802515985],
            [-10.90227432960478, 4.848042568564666],
            [-10.90073966562767, 4.850765053427175],
            [-10.88024167627215, 4.847527960900335],
            [-10.802023976904485, 4.834392597222147],
            [-10.731037537620654, 4.822987603140032],
            [-10.72544449730497, 4.819018705485745],
            [-10.718130509716005, 4.816222705725317],
            [-10.711605386756556, 4.815619886215633],
            [-10.710897348683098, 4.811663796038937],
            [-10.71396293240268, 4.806218908297171],
            [-10.715153603371359, 4.800842596805899],
            [-10.711666162609923, 4.795742526471494],
            [-10.708169833620948, 4.795802357929075],
            [-10.705623001909737, 4.7913997310203085],
            [-10.700065916586775, 4.788491585780129],
            [-10.69286345528677, 4.7869176449811395],
            [-10.683936106870167, 4.783828009691943],
            [-10.68175467255541, 4.780703673829556],
            [-10.67303215744166, 4.775556922613272],
            [-10.670107992363826, 4.7819113922369265],
            [-10.667312388647847, 4.7832660311855255],
            [-10.662655085516418, 4.7895589848872575],
            [-10.659240901741331, 4.792468771630015],
            [-10.65793021069456, 4.798666115166065],
            [-10.65242067700912, 4.805054192081449],
            [-10.648985954718619, 4.807120776874493],
            [-10.643047593797874, 4.8191972285603955],
            [-10.640607810553572, 4.821613343351116],
            [-10.637395279240138, 4.820186411128806],
            [-10.639838331253923, 4.809934267000199],
            [-10.637920978375776, 4.80759678249943],
            [-10.639958477269321, 4.802911355601245],
            [-10.636663073200618, 4.797900747540497],
            [-10.63337254944011, 4.796572269871173],
            [-10.634744221288777, 4.792178524580034],
            [-10.628663742643615, 4.788496384448187],
            [-10.635765149828705, 4.768979119431398],
            [-10.638042357648013, 4.755595012177424],
            [-10.642804807838479, 4.7459510513885705],
            [-10.64285616622885, 4.743535307138284],
            [-10.647476977632053, 4.735227650916627],
            [-10.649223347579115, 4.72726741346312],
            [-10.659321818187859, 4.720886190846681],
            [-10.660290258207896, 4.7150090916494865],
            [-10.658130855076191, 4.711546634038862],
            [-10.65748439721585, 4.706302121128914],
            [-10.653790297776425, 4.70132026252436],
            [-10.653486812927502, 4.698130651291162],
            [-10.648555210310109, 4.694846714496981],
            [-10.642482447235055, 4.69614176933891],
            [-10.634315760812708, 4.694322561610429],
            [-10.628680059484521, 4.695218649242642],
            [-10.623932846837983, 4.692336119157421],
            [-10.61969949908696, 4.692295999322537],
            [-10.615499509848004, 4.688000357084748],
            [-10.610851616986782, 4.689587916281453],
            [-10.601627965152007, 4.686019164231653],
            [-10.598763177852002, 4.691401607162704],
            [-10.596251815626875, 4.6999575641850155],
            [-10.592977268665532, 4.6971224330280235],
            [-10.58876850140061, 4.698913654199898],
            [-10.585885782171395, 4.693669949751698],
            [-10.581272009259186, 4.694438770301685],
            [-10.577395769444758, 4.6902900761278],
            [-10.577117735296836, 4.687538177806186],
            [-10.570684221435835, 4.688937998936397],
            [-10.568556927747945, 4.691793791211707],
            [-10.56514410637861, 4.69222236950549],
            [-10.56023215458041, 4.695166547122917],
            [-10.55453185591789, 4.692864219662658],
            [-10.55001863480506, 4.693308746281434],
            [-10.54684401241845, 4.691648044474526],
            [-10.539104222650211, 4.693759353223935],
            [-10.533716182095501, 4.691470030279605],
            [-10.532146368194908, 4.696166689356608],
            [-10.527807643731784, 4.696462616236177],
            [-10.5248078522525, 4.6989070698862045],
            [-10.524237637598292, 4.703781202384548],
            [-10.526322002852362, 4.707394083913681],
            [-10.51221102139027, 4.70817408979681],
            [-10.511047112656057, 4.7100293416192685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.32972207878606,
          "lat": 42.28482359372082
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16007"],
        "coty_name": ["Bear Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bear Lake County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00395090"
      },
      "bbox": [
        -10.982852692515833, 4.202332016486536, -10.511047112656057,
        4.850765053427175
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.954771740866303, 4.765165680243651],
            [-11.872110609836641, 4.750702853845285],
            [-11.789451755029443, 4.736226649968026],
            [-11.789308919983851, 4.737012433503753],
            [-11.7044294059151, 4.722000918940114],
            [-11.689082313839515, 4.808224489238843],
            [-11.600727262662968, 4.79263935768879],
            [-11.576325034639131, 4.788252869710481],
            [-11.561416568987207, 4.874199274590557],
            [-11.504893211201432, 4.864419880730611],
            [-11.47939581637736, 4.860008751546328],
            [-11.481890573936836, 4.84575339021993],
            [-11.478824308126931, 4.845216388140485],
            [-11.480024293290757, 4.838151501370321],
            [-11.473007889185052, 4.836802538667486],
            [-11.474241854836574, 4.829726072054884],
            [-11.470664929831008, 4.829076596000086],
            [-11.471875872853367, 4.822006158420234],
            [-11.457819026643122, 4.819513619396499],
            [-11.459209386835925, 4.811383848951179],
            [-11.461567108175082, 4.805370726683993],
            [-11.458934310921572, 4.800082750366893],
            [-11.435688879488875, 4.801271592086215],
            [-11.43457662775566, 4.803671052471703],
            [-11.429879635571691, 4.804023424610384],
            [-11.424866018553269, 4.8005136078874315],
            [-11.42416063435386, 4.792618320381169],
            [-11.426354726186029, 4.783677956405177],
            [-11.424794497265914, 4.773262026683066],
            [-11.427681310029124, 4.768927828223083],
            [-11.427738408404199, 4.762562126630718],
            [-11.430249186093485, 4.755021376175351],
            [-11.42951418382891, 4.75300412610092],
            [-11.429921106187447, 4.743773688550121],
            [-11.432687279595614, 4.741934888624446],
            [-11.433950061518468, 4.733723258262528],
            [-11.439428942404255, 4.730912091440964],
            [-11.4486935691905, 4.719872911282923],
            [-11.448484641899835, 4.715981091377182],
            [-11.452010972143148, 4.714260671271268],
            [-11.456954578881772, 4.707641411471562],
            [-11.466063467103801, 4.699036944556262],
            [-11.468036526052435, 4.695541392875704],
            [-11.467339303355537, 4.689264375424142],
            [-11.468979618225795, 4.6815076542517575],
            [-11.46727014772461, 4.675685734978212],
            [-11.460939442184095, 4.673286028225787],
            [-11.45418952105677, 4.6760871912397555],
            [-11.452398091132828, 4.675587406687001],
            [-11.444064527802563, 4.664300276921859],
            [-11.435895311836013, 4.662629618256795],
            [-11.428993723874314, 4.671251680840119],
            [-11.42107665972267, 4.678411012874138],
            [-11.416572134846561, 4.685322398605345],
            [-11.41511930613036, 4.693824105248238],
            [-11.365449425450445, 4.685410375251784],
            [-11.364300203575135, 4.671524063202085],
            [-11.361050259046463, 4.666417526121714],
            [-11.35994479905069, 4.658931792699223],
            [-11.354826778942783, 4.646444303818657],
            [-11.353103498806197, 4.64575734308896],
            [-11.351176196958853, 4.639838250824916],
            [-11.352783959506972, 4.630898639667706],
            [-11.349453640144404, 4.627810003167727],
            [-11.349982102351603, 4.625377541723925],
            [-11.34461632263309, 4.6230802364263495],
            [-11.339068572714753, 4.62284039086479],
            [-11.336579114331073, 4.624384926501239],
            [-11.331927035877806, 4.6193966704392695],
            [-11.329958889763494, 4.612543787509166],
            [-11.32534832366885, 4.607596737130573],
            [-11.323334331958337, 4.595241474559844],
            [-11.317974333205111, 4.593155279581585],
            [-11.312344136942384, 4.593972886957239],
            [-11.312020217034716, 4.587189081912564],
            [-11.308764276593736, 4.5802089436740125],
            [-11.30563824174864, 4.568419058075113],
            [-11.301038567381879, 4.564306562084658],
            [-11.30029077476091, 4.559688278965506],
            [-11.297907008403664, 4.559263221848494],
            [-11.309030524860338, 4.491288345832847],
            [-11.337286017696472, 4.496372913982048],
            [-11.346243745504637, 4.443906245092898],
            [-11.366656777512896, 4.326010560288405],
            [-11.39904066875811, 4.331015969402906],
            [-11.402714980018285, 4.332851698826931],
            [-11.412345376920264, 4.337664450935757],
            [-11.421765169957467, 4.338964183070244],
            [-11.551781076518884, 4.361227831138835],
            [-11.606977446284226, 4.370539128869106],
            [-11.6563205188829, 4.379147551880236],
            [-11.75753580567266, 4.396423405234202],
            [-11.850117784938172, 4.412347996452412],
            [-11.92813365644475, 4.42553498793895],
            [-12.013808003898284, 4.439999505538162],
            [-11.992059006295756, 4.559890775215734],
            [-11.980358515249769, 4.624596783641701],
            [-11.954771740866303, 4.765165680243651]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.5393461436612,
          "lat": 42.194995887268995
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16071"],
        "coty_name": ["Oneida"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oneida County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00399759"
      },
      "bbox": [
        -12.013808003898284, 4.326010560288405, -11.297907008403664,
        4.874199274590557
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.918780174447917, -0.9158833315789698],
            [5.990997865259895, -0.9108708089725431],
            [6.007138416794793, -0.9087593787460092],
            [6.049178066007229, -0.9057842470267515],
            [6.078834370768144, -0.9030286304496722],
            [6.092570138725781, -0.8987814331289128],
            [6.136079484948388, -0.8957963768647641],
            [6.1790050751490835, -0.8936063134664923],
            [6.1790219469595025, -0.8938257779543172],
            [6.184918853346672, -0.981628944877177],
            [6.190574472556914, -1.065464840919956],
            [6.1943273295512205, -1.1135220816983635],
            [6.197576161380279, -1.1576811258744284],
            [6.183617816871391, -1.1605383171460908],
            [6.112000987422368, -1.1658617803085696],
            [6.09742234972314, -1.1666952732030964],
            [6.045099804502229, -1.1705936117360631],
            [6.052322483950869, -1.1757934392324223],
            [6.053400451754715, -1.179579031405985],
            [6.0507535445711245, -1.184697337945996],
            [6.052372678323685, -1.1885274700444233],
            [6.043647538376367, -1.1931819364180547],
            [6.030688437242965, -1.2045814994038755],
            [6.028970236782959, -1.205099314728352],
            [6.018460519735117, -1.2046993611090155],
            [6.008162897353645, -1.2120750501369535],
            [6.002396782217322, -1.2124887035631138],
            [5.997718697446819, -1.2071300922762256],
            [5.988988395141016, -1.2055676528280503],
            [5.978903014162003, -1.2017254145277507],
            [5.97301471438629, -1.2025143580173372],
            [5.9695970561299285, -1.2010030101618832],
            [5.95809514142315, -1.204015416093776],
            [5.949096378243249, -1.2147793194541154],
            [5.945921946283826, -1.2173962490477204],
            [5.93853843730232, -1.220627345055361],
            [5.9371341981702, -1.1991723491822057],
            [5.935823286524666, -1.1847839838414091],
            [5.932054711269817, -1.1301065563542712],
            [5.930027816950577, -1.103422052383178],
            [5.925456538321136, -1.034824897036152],
            [5.924019122699633, -1.0054587928083851],
            [5.918780174447917, -0.9158833315789698]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.88097519644226, "lat": 37.45963732813525 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17087"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00424245"
      },
      "bbox": [
        5.918780174447917, -1.220627345055361, 6.197576161380279,
        -0.8936063134664923
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.718382998261278, 0.1336530168481831],
            [6.719514598856443, 0.1386423912446655],
            [6.712962789298604, 0.22259033611918524],
            [6.70582716523552, 0.31166376902381443],
            [6.703568840294043, 0.3413868768452894],
            [6.697560348390725, 0.4156283039845053],
            [6.790969912027054, 0.42359847886206337],
            [6.790733108343713, 0.42237297164584436],
            [6.816168733015843, 0.4253054659770833],
            [6.869236353112972, 0.43215317325014463],
            [6.869380651369496, 0.43258239689859906],
            [6.9527614015601555, 0.4394707531290661],
            [6.9527050196302005, 0.4401661717334704],
            [6.98629582588818, 0.4432740261365947],
            [6.991369583217053, 0.43996820161530914],
            [6.991671918057352, 0.4296382996129123],
            [6.995844614676362, 0.4218054697235505],
            [6.996604099771306, 0.4179128461655687],
            [6.99301367866919, 0.4090209428607846],
            [6.997890206496284, 0.40427892858261577],
            [7.009735920909509, 0.3878049012165503],
            [7.01389920163997, 0.3852969362073021],
            [7.020124522736446, 0.3783129440369423],
            [7.020979124097146, 0.3748871141046898],
            [7.019673241703453, 0.37016652740514683],
            [7.014713227241089, 0.36608042951773817],
            [7.008973664544, 0.3652742953269747],
            [7.007388236108196, 0.3606860997343636],
            [7.012316496011999, 0.359241871769687],
            [7.016507252708345, 0.3615039997918731],
            [7.019892430433778, 0.3609296283609928],
            [7.02109991456652, 0.3579956605586909],
            [7.020279455466876, 0.35028647018932674],
            [7.017115695848859, 0.34182790873624125],
            [7.017882055793428, 0.3392304247979751],
            [7.023901597279288, 0.3347348750940199],
            [7.02381053603247, 0.33191148318144914],
            [7.0174186793561075, 0.32691230562959633],
            [7.015803931280104, 0.3174390311986905],
            [7.010349049328064, 0.30738482178874726],
            [7.008713565106243, 0.3012806553554848],
            [7.010067208296296, 0.2903224364877429],
            [7.008312460461601, 0.28390451053645416],
            [7.0020723733743795, 0.2739046241606385],
            [6.995720069202542, 0.2683771458176343],
            [6.991631949181173, 0.2664613921375047],
            [6.966016231535484, 0.2589728660698008],
            [6.959856542337196, 0.25589678456694204],
            [6.952907107371763, 0.2505505238889919],
            [6.95090213113925, 0.24748178270128793],
            [6.9493788442950555, 0.24116432342277622],
            [6.949768611685358, 0.2360016505074748],
            [6.9465148641201955, 0.2293759233647123],
            [6.939509155853507, 0.2258903895205409],
            [6.937282869547247, 0.2195820849466617],
            [6.94204818068577, 0.2110465060782845],
            [6.942090253559866, 0.20691742124484724],
            [6.938063505860488, 0.20289390140083882],
            [6.937543096532002, 0.20030052266559212],
            [6.939696971929022, 0.19550456566870694],
            [6.935359612999008, 0.19122369380735815],
            [6.9350403893534, 0.188276092317295],
            [6.938265221900495, 0.1799598470334832],
            [6.94207838800919, 0.17813667964192614],
            [6.9484261588218645, 0.17746851081729983],
            [6.946534093140961, 0.17111652762864105],
            [6.94018201547843, 0.16922495482668748],
            [6.935956928674954, 0.17078076007269355],
            [6.930409316778336, 0.17494485104786942],
            [6.926512632781694, 0.1716644902356779],
            [6.927539696148754, 0.1638514320639785],
            [6.929222199728885, 0.15977278654480342],
            [6.928395129843977, 0.15598470375158996],
            [6.92270946677572, 0.15275773321984976],
            [6.919700628900264, 0.14913946821216031],
            [6.917563338750744, 0.1488448448213261],
            [6.850414235689966, 0.14337890762052838],
            [6.828748270065125, 0.14196808438460615],
            [6.7948915352696435, 0.13940863117998656],
            [6.762341416978624, 0.13732070049655076],
            [6.718382998261278, 0.1336530168481831]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.72677353053253, "lat": 38.71995552998165 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17101"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00424252"
      },
      "bbox": [
        6.697560348390725, 0.1336530168481831, 7.023901597279288,
        0.4432740261365947
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.361178372849556, 2.495113960104168],
            [4.448953870227334, 2.498820402470367],
            [4.4803070902246915, 2.4996381769141847],
            [4.539093692930943, 2.500356697391554],
            [4.60485167508132, 2.5038011832007525],
            [4.619595012537374, 2.5049681037832654],
            [4.620909727818471, 2.4756153221389954],
            [4.623931130238421, 2.4169210990870544],
            [4.6274947412718275, 2.343707884989412],
            [4.629488527423616, 2.2997348872745316],
            [4.632469922966805, 2.240865477987407],
            [4.636493122217773, 2.1535772147522887],
            [4.639185660786156, 2.0989149924691657],
            [4.6406656429361295, 2.065747683182332],
            [4.554601945665973, 2.063604807658886],
            [4.540093562639921, 2.0630814240818474],
            [4.469495691802767, 2.0598423375936132],
            [4.411177640096923, 2.0593494599492947],
            [4.381776001128428, 2.0592705645661025],
            [4.378355915960824, 2.1218413002870045],
            [4.377766816355193, 2.1432863031555596],
            [4.37293749011171, 2.238247010252241],
            [4.371707878376782, 2.2640369465932535],
            [4.366583189194753, 2.3786470350382225],
            [4.36512171025997, 2.4071505064195122],
            [4.361178372849556, 2.495113960104168]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.61501660959928, "lat": 40.84879831992757 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17187"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "187",
        "coty_gnis_code": "01785134"
      },
      "bbox": [
        4.361178372849556, 2.0592705645661025, 4.6406656429361295,
        2.5049681037832654
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.722813961841552, 3.236098915314866],
            [4.737054614184233, 3.247209142224885],
            [4.740889519532064, 3.249661137194928],
            [4.7617700189732375, 3.2588222398931963],
            [4.765957776053532, 3.2630152410708813],
            [4.766637432127687, 3.2680033363267924],
            [4.765187570015044, 3.278615546137771],
            [4.762878939568498, 3.2890248406845517],
            [4.764064245919556, 3.300762005695657],
            [4.769473695351426, 3.3139445205759337],
            [4.769111678162505, 3.3227351401841534],
            [4.770486343141974, 3.3331865994728282],
            [4.773704132337143, 3.3407768891450638],
            [4.778758438778339, 3.3554355327074368],
            [4.780759763404033, 3.364217481860894],
            [4.780367480232716, 3.373238975959996],
            [4.78066568541126, 3.386680154939202],
            [4.799784087496292, 3.387925736391593],
            [4.807767230833087, 3.389149714416281],
            [4.823308277096174, 3.390089093713798],
            [4.880345340175756, 3.394430774204441],
            [4.90867688276806, 3.396962884560667],
            [4.929893043377392, 3.398362195818893],
            [5.009382545753506, 3.4025107171225324],
            [5.0627348766515, 3.4061420724640565],
            [5.080399751358851, 3.4075619758109355],
            [5.124417475197882, 3.4100999328997923],
            [5.166046299663463, 3.412579016341154],
            [5.167652368957967, 3.3840396330179456],
            [5.170845679411647, 3.3258048664463074],
            [5.17575464310489, 3.239960223876289],
            [5.180920170077837, 3.1530231717067627],
            [5.187418166180279, 3.066119468222543],
            [5.103458997640389, 3.060100828462412],
            [5.073408771652779, 3.0578310423711703],
            [5.0164897946805125, 3.0539216620422494],
            [4.995186347728842, 3.052310244292235],
            [4.916137038680461, 3.0472035120588816],
            [4.8219507710618466, 3.0422264956369673],
            [4.77703191778529, 3.039440386322017],
            [4.776843940388202, 3.0438384623363564],
            [4.779691628695697, 3.046074330432901],
            [4.787782130789025, 3.0473442631600562],
            [4.79088600123887, 3.0499531870901433],
            [4.791575745569272, 3.0531832165915924],
            [4.789860619433129, 3.0656591464140845],
            [4.793382527356482, 3.074004608632959],
            [4.792136427033898, 3.0776539237903964],
            [4.793200183424469, 3.086724289611713],
            [4.790973616648303, 3.0916590184183312],
            [4.782822308915846, 3.093275808686138],
            [4.782217689835781, 3.0957013622189424],
            [4.789746663213353, 3.0953043471153867],
            [4.7908667992143155, 3.100813449012473],
            [4.788510724825224, 3.103768444833267],
            [4.784368441742891, 3.1045293687950277],
            [4.781456181165872, 3.1106649400584456],
            [4.77538745157115, 3.1132385914513323],
            [4.7692201838084465, 3.118397171238832],
            [4.754576658416711, 3.1236279549038097],
            [4.7472555414953055, 3.125109521097761],
            [4.738723006445651, 3.128635913643116],
            [4.733711215033985, 3.132485472066221],
            [4.734524180855883, 3.134430622150954],
            [4.740364763893522, 3.1369086858826054],
            [4.73986382227015, 3.1459865375973144],
            [4.736433794163733, 3.1490428217883073],
            [4.731916947794666, 3.1499531240196865],
            [4.7317659343536445, 3.1525956436716758],
            [4.725823987477669, 3.1550707898702894],
            [4.7293459563774345, 3.1596268675812906],
            [4.729261088165942, 3.1669960118079477],
            [4.73230771668113, 3.173690167428334],
            [4.73248401136851, 3.1782833461373974],
            [4.728956876131801, 3.180341092563701],
            [4.731346137779979, 3.1894007773242175],
            [4.729729354040128, 3.1939747663797324],
            [4.720922230577538, 3.1996189266819544],
            [4.721331046654109, 3.2075876264032135],
            [4.723942368495161, 3.2129848354051633],
            [4.72820012367374, 3.215902150371799],
            [4.722091986334714, 3.2203691362029914],
            [4.721569791018996, 3.2246937819920105],
            [4.723454947182183, 3.230006552962269],
            [4.722813961841552, 3.236098915314866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.91406352388049, "lat": 41.75623481989506 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17195"],
        "coty_name": ["Whiteside"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Whiteside County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "01785167"
      },
      "bbox": [
        4.720922230577538, 3.039440386322017, 5.187418166180279,
        3.412579016341154
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.3510642149448335, 2.4073679152202567],
            [5.412496570757139, 2.412270021006059],
            [5.478934567585628, 2.4189025236675388],
            [5.583902708598736, 2.429697466421181],
            [5.668243087127312, 2.4344674509829654],
            [5.755018167176303, 2.442885192187341],
            [5.756075643810553, 2.4282017219463468],
            [5.762065294774231, 2.3552474612981253],
            [5.769629013632432, 2.2677536736362596],
            [5.7265878341098855, 2.2635103913021393],
            [5.733208893190101, 2.190520380638198],
            [5.7347204107320895, 2.1759220789301326],
            [5.689338521986829, 2.1714786102699315],
            [5.692745278535985, 2.134828515081812],
            [5.664384211714456, 2.1321347955528274],
            [5.649994351821985, 2.1292918591245127],
            [5.6512505712161, 2.1165378400330566],
            [5.626478502911679, 2.1138972219401344],
            [5.6279018996602, 2.0990871065895598],
            [5.526226929627655, 2.089365150841768],
            [5.5243467376275985, 2.11124049002988],
            [5.4812107718159435, 2.1076594581137775],
            [5.476996941387146, 2.1530549354077175],
            [5.476308256757994, 2.152995438621827],
            [5.469762602692421, 2.2409236985650067],
            [5.426485255665633, 2.237717317740765],
            [5.375645973078405, 2.2337238941117077],
            [5.302440640668553, 2.228741180327868],
            [5.300150393033679, 2.2343575453210645],
            [5.298418281608466, 2.2483824050878756],
            [5.296460227595916, 2.254891875028849],
            [5.29244732285713, 2.262908417464376],
            [5.294383224968715, 2.2801750711675095],
            [5.2996595979991, 2.2910363719418605],
            [5.301795906324863, 2.298355607111892],
            [5.306466525679463, 2.3037271563199764],
            [5.307589834695536, 2.309704000571084],
            [5.315945771981848, 2.3252612463017317],
            [5.314318820312583, 2.328784280435863],
            [5.315312991636929, 2.336225827884991],
            [5.317026130764959, 2.3399158666528717],
            [5.331627802662302, 2.3537254103945178],
            [5.336684931995591, 2.363485272548748],
            [5.338645048380388, 2.3713233513428937],
            [5.338998573434337, 2.379396690447719],
            [5.342244137152189, 2.3847717927012226],
            [5.346012600302966, 2.3934166436999433],
            [5.349402312727436, 2.39802127759122],
            [5.3510642149448335, 2.4073679152202567]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.21132230886685, "lat": 40.78825050112098 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17203"],
        "coty_name": ["Woodford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woodford County"],
        "coty_fp_code": "203",
        "coty_gnis_code": "01785231"
      },
      "bbox": [
        5.29244732285713, 2.089365150841768, 5.769629013632432,
        2.442885192187341
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.523428539138318, 1.5785886544069299],
            [7.552014624108387, 1.5817253143891714],
            [7.583204302122732, 1.5843932143003752],
            [7.613362899246508, 1.5873959649666471],
            [7.666369369723224, 1.592909754774077],
            [7.694629575256043, 1.59561279288739],
            [7.724494259764257, 1.5995131600541732],
            [7.799627897182697, 1.6076597186233865],
            [7.802144517916353, 1.6077746406185622],
            [7.806726126245473, 1.565955462034346],
            [7.808772988629622, 1.5497835621795022],
            [7.806699127532734, 1.5495201164424126],
            [7.816900885360928, 1.46248562960818],
            [7.816666711407914, 1.4609718459697565],
            [7.825666177488092, 1.3773201610639292],
            [7.826328349226998, 1.3687307162185822],
            [7.8320375170631396, 1.3148278503035822],
            [7.806820045870885, 1.3115463720470897],
            [7.794843502306863, 1.3096298649763014],
            [7.726289989916613, 1.301933022731366],
            [7.729495608995857, 1.2725762923506247],
            [7.690147540674148, 1.2686082893047699],
            [7.588656347142157, 1.2589146084189957],
            [7.584320460487554, 1.2587495966870454],
            [7.585784463286944, 1.2655227510473794],
            [7.591045062522006, 1.272862248591865],
            [7.593093153136773, 1.2771114893459943],
            [7.590591367213004, 1.2858488256288068],
            [7.592800548944472, 1.288633470515291],
            [7.5580887437101785, 1.2856164042204878],
            [7.549767577711872, 1.3728169380894575],
            [7.54565759833817, 1.4165917508818824],
            [7.535370612035394, 1.5210394887462007],
            [7.5291002592583185, 1.5204266276283966],
            [7.523428539138318, 1.5785886544069299]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.5099730458473, "lat": 39.769524670310275 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18063"],
        "coty_name": ["Hendricks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hendricks County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00450358"
      },
      "bbox": [
        7.523428539138318, 1.2587495966870454, 7.8320375170631396,
        1.6077746406185622
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.366565038621362, 1.6896887781632202],
            [8.361535993631373, 1.734139444921763],
            [8.360149967046587, 1.7487448988621956],
            [8.352048908082121, 1.8214182280037468],
            [8.424368306045366, 1.8291609290998039],
            [8.496371615119267, 1.8367065291611242],
            [8.55805192318965, 1.8439601820739029],
            [8.624725233802385, 1.851696139594902],
            [8.626733976945793, 1.8370992627036185],
            [8.633682085871317, 1.7791091410215882],
            [8.642733249962099, 1.7802840167774332],
            [8.650015992167537, 1.722839782600414],
            [8.658088642691313, 1.6493153324830754],
            [8.643167202695322, 1.647388446526292],
            [8.647633064491334, 1.6059452045573597],
            [8.65259529541045, 1.5620251236224576],
            [8.591822254208772, 1.554248379475868],
            [8.578255443435268, 1.5524902154278526],
            [8.510423677776423, 1.544823905514521],
            [8.481171519213518, 1.5416818122970875],
            [8.424733968058755, 1.5348320187114866],
            [8.368471298816944, 1.5282848537604177],
            [8.359124914636984, 1.6149572223900415],
            [8.374164984978524, 1.616491265525726],
            [8.366565038621362, 1.6896887781632202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.39643629340632,
          "lat": 39.931056278715445
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18065"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00450359"
      },
      "bbox": [
        8.352048908082121, 1.5282848537604177, 8.658088642691313,
        1.851696139594902
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.802144517916353, 1.6077746406185622],
            [7.852257857093467, 1.6140048504014766],
            [7.866609880385625, 1.6164471524068094],
            [7.895008967234092, 1.6199490066677942],
            [7.938188163583888, 1.6249777214531558],
            [7.948005466362283, 1.625702332783284],
            [7.981431223619866, 1.6292005726383927],
            [8.026173786778063, 1.6341268454047593],
            [8.038293849545187, 1.6356753522371157],
            [8.071047048694755, 1.6386031460984332],
            [8.095601501434311, 1.641493278419472],
            [8.095646231699439, 1.637500015094149],
            [8.101352107429308, 1.5839480654692537],
            [8.089310955584274, 1.582501625769968],
            [8.099809612520948, 1.495376782205944],
            [8.104680486950121, 1.4535377233610725],
            [8.10941761058609, 1.4096045923034142],
            [8.112064138339933, 1.3819706532832792],
            [8.115407255914441, 1.3505832361960513],
            [8.086540998920759, 1.3471442446189894],
            [8.064901582566955, 1.3442254779189318],
            [8.04530018907226, 1.3420429241633556],
            [8.002282755744934, 1.3361406532138447],
            [7.959204974742765, 1.3308912718518482],
            [7.930425335339667, 1.3271868059673766],
            [7.8899176699116405, 1.3222504826815997],
            [7.8609366326939165, 1.3183880741641938],
            [7.8320375170631396, 1.3148278503035822],
            [7.826328349226998, 1.3687307162185822],
            [7.825666177488092, 1.3773201610639292],
            [7.816666711407914, 1.4609718459697565],
            [7.816900885360928, 1.46248562960818],
            [7.806699127532734, 1.5495201164424126],
            [7.808772988629622, 1.5497835621795022],
            [7.806726126245473, 1.565955462034346],
            [7.802144517916353, 1.6077746406185622]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.13846260931147, "lat": 39.78170119618224 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18097"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00450371"
      },
      "bbox": [
        7.802144517916353, 1.3148278503035822, 8.115407255914441,
        1.641493278419472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.7350713625591352, 3.1992389640066783],
            [1.7925117901866023, 3.2006291389463333],
            [1.8207491406167289, 3.2010845428401558],
            [1.9465562985845235, 3.2034653335063643],
            [1.993225696292489, 3.2045568690056068],
            [2.0784968214520627, 3.206704581086067],
            [2.0791794027073713, 3.18887938590002],
            [2.0817963180800017, 3.092947298425973],
            [2.082818337315199, 3.0609564336125787],
            [2.084006339346095, 3.007830213521486],
            [2.0856525276182882, 2.9422490854128496],
            [2.103199596514331, 2.9426231317243112],
            [2.104147528530214, 2.905669525847819],
            [2.105287583106345, 2.853570790724132],
            [2.0435670430817243, 2.8453265475859526],
            [2.0263647819514223, 2.842905530653666],
            [1.9942411142753254, 2.842368955931855],
            [1.9404421536068084, 2.8411513375122674],
            [1.856879628264521, 2.839356787208313],
            [1.7704110695179693, 2.8382958569672057],
            [1.7702009374523904, 2.856577374740779],
            [1.7687731429052889, 2.9361998227544506],
            [1.740051329591803, 2.936018060859367],
            [1.7393422586280922, 2.980670211351938],
            [1.7381394925105085, 3.0235542075439],
            [1.7363624285806183, 3.1123117721083635],
            [1.7350713625591352, 3.1992389640066783]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.03977585818946, "lat": 41.68484821314198 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19049"],
        "coty_name": ["Dallas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dallas County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00465213"
      },
      "bbox": [
        1.7350713625591352, 2.8382958569672057, 2.105287583106345,
        3.206704581086067
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.5448000470462038, 3.2540724795953273],
            [3.63110681730814, 3.2580925257654347],
            [3.6590396962525693, 3.259024164631893],
            [3.7305301364595604, 3.261126511664928],
            [3.8029890181662696, 3.263757356965009],
            [3.8453914381976646, 3.265641119590793],
            [3.8884306417504977, 3.268176586520416],
            [3.892880624654972, 3.180638103129368],
            [3.8971079303054106, 3.0928741833552005],
            [3.898298742470994, 3.063597430297026],
            [3.9011116312434804, 3.005220594258344],
            [3.9026718106519556, 2.9678547595834086],
            [3.904520976230822, 2.916676327458659],
            [3.9069479142074233, 2.8614200724903163],
            [3.908175093040214, 2.8290298299485994],
            [3.891022143544579, 2.8286479098852038],
            [3.8532639654252483, 2.8267806424692266],
            [3.838771347463622, 2.826739516123578],
            [3.8223303693734105, 2.8255758265568116],
            [3.820670392648162, 2.8316746058578746],
            [3.816546916813073, 2.842008902350095],
            [3.8088288200471423, 2.847939577302016],
            [3.807307147620184, 2.852127193448093],
            [3.8100303965125253, 2.8548156246015717],
            [3.8096607085221557, 2.860613553521734],
            [3.8047714493777107, 2.862681827355097],
            [3.797559094523175, 2.867823032952027],
            [3.7980146928872935, 2.8769336225263764],
            [3.8037383557149593, 2.8772583190793486],
            [3.8063177785721964, 2.8788323076092404],
            [3.8056050574867384, 2.886580643750183],
            [3.806368798213512, 2.8891963152695945],
            [3.8043401161615757, 2.8947722973892924],
            [3.7931412503054456, 2.898184437564523],
            [3.7925853657562674, 2.9035096014947768],
            [3.786343859614053, 2.9075544316435153],
            [3.786943613318687, 2.9106900144313372],
            [3.791561690010767, 2.911951276957945],
            [3.7042170749285184, 2.9075972104355348],
            [3.6044786113038736, 2.9040868254231325],
            [3.561873860783916, 2.9019546837354184],
            [3.5610194199160494, 2.931195404440683],
            [3.559549277508831, 2.9915010779255473],
            [3.5550892014582334, 2.9912672628352652],
            [3.553825754725042, 3.020483558960162],
            [3.550458902490488, 3.0779695343502818],
            [3.548928746939286, 3.1491191073048768],
            [3.5480591711505745, 3.1763903535695985],
            [3.5477993642796513, 3.1957652542705652],
            [3.5469546137336185, 3.2083603300501746],
            [3.5448000470462038, 3.2540724795953273]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.58810275672674,
          "lat": 41.671499583452885
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19103"],
        "coty_name": ["Johnson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Johnson County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00465240"
      },
      "bbox": [
        3.5448000470462038, 2.8255758265568116, 3.908175093040214,
        3.268176586520416
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.52570831293775, 3.6931305470348685],
            [3.6114427863123746, 3.6944051910465943],
            [3.697659225694054, 3.6982037797502487],
            [3.7547561050860505, 3.7006785321657993],
            [3.80471032090088, 3.7030402823662443],
            [3.8691852926823143, 3.7063871794374674],
            [3.8732663871185884, 3.6115872829685376],
            [3.8758431928790102, 3.5462419016539757],
            [3.8808604643662457, 3.4434241012559523],
            [3.884396885451223, 3.3559130373936967],
            [3.8884306417504977, 3.268176586520416],
            [3.8453914381976646, 3.265641119590793],
            [3.8029890181662696, 3.263757356965009],
            [3.7305301364595604, 3.261126511664928],
            [3.6590396962525693, 3.259024164631893],
            [3.63110681730814, 3.2580925257654347],
            [3.5448000470462038, 3.2540724795953273],
            [3.5434521846173928, 3.279601037084033],
            [3.538610366397109, 3.3566287789557863],
            [3.534206258807058, 3.4298419971352634],
            [3.5325686160736596, 3.475587175973175],
            [3.5308768074314214, 3.5178872898541904],
            [3.5293490804768037, 3.569825805576515],
            [3.5284303638838237, 3.6057227865559405],
            [3.52570831293775, 3.6931305470348685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.59902901889782, "lat": 42.07896049568616 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19113"],
        "coty_name": ["Linn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Linn County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "00465245"
      },
      "bbox": [
        3.52570831293775, 3.2540724795953273, 3.8884306417504977,
        3.7063871794374674
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9234966313292444, 2.4816778360580978],
            [0.9658858232891282, 2.481812715973558],
            [1.0089099339895804, 2.4817622092190432],
            [1.0941376930848947, 2.4822064858077115],
            [1.0947202386819352, 2.4821199979876347],
            [1.188570192695728, 2.4825078907499614],
            [1.2646035925009145, 2.4831903770995947],
            [1.265254624023731, 2.425746046145256],
            [1.266102909877681, 2.332078233723715],
            [1.2667621889934955, 2.2245514637166233],
            [1.266883562355521, 2.22342720780022],
            [1.1815821586506898, 2.222578695882978],
            [1.0464318111658955, 2.221828603060995],
            [0.9891946068317414, 2.221711244944591],
            [0.9677683329200801, 2.221352986175028],
            [0.9247237394763104, 2.2212974480193477],
            [0.9248424075154232, 2.228549427571942],
            [0.9243264301149826, 2.307846264906011],
            [0.9244060704637859, 2.33297917316542],
            [0.9237873106603559, 2.3942888311558823],
            [0.9234966313292444, 2.4816778360580978]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.15635478698188,
          "lat": 41.030140454868125
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19137"],
        "coty_name": ["Montgomery"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montgomery County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00465257"
      },
      "bbox": [
        0.9234966313292444, 2.2212974480193477, 1.266883562355521,
        2.4831903770995947
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9247237394763104, 2.2212974480193477],
            [0.9677683329200801, 2.221352986175028],
            [0.9891946068317414, 2.221711244944591],
            [1.0464318111658955, 2.221828603060995],
            [1.1815821586506898, 2.222578695882978],
            [1.266883562355521, 2.22342720780022],
            [1.2667822488654912, 2.2125395608013467],
            [1.2674008958035836, 2.1460513521672118],
            [1.2676730625850767, 2.14307824046075],
            [1.2682282315698976, 2.072355633823797],
            [1.2687432448528844, 2.070783973045964],
            [1.2688008295142603, 2.048832798187715],
            [1.280376348704331, 2.048849242263909],
            [1.279890278755009, 1.9870897079352978],
            [1.2807978325091274, 1.8954017539723231],
            [1.2419411246812018, 1.8957462371701153],
            [1.222991167928384, 1.895394578798959],
            [1.164806744586338, 1.8959989974043012],
            [1.1257181911476972, 1.8961643129507606],
            [1.0643928447470592, 1.8967475000682272],
            [1.0498885362990558, 1.8969289800673526],
            [0.9472725687221495, 1.8974458748726653],
            [0.9351320205061773, 1.8977695691884187],
            [0.9346631613904338, 1.973243279453283],
            [0.9366336447759044, 2.0467111793037547],
            [0.925635975155905, 2.046777334045596],
            [0.925441437943792, 2.050250491621997],
            [0.9255962825342291, 2.104412475124133],
            [0.9251588379535653, 2.1920899891046393],
            [0.9247237394763104, 2.2212974480193477]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.15021938694869, "lat": 40.73913378503908 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19145"],
        "coty_name": ["Page"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Page County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00465261"
      },
      "bbox": [
        0.9247237394763104, 1.895394578798959, 1.2807978325091274,
        2.22342720780022
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.475187292735222, 2.897493129861229],
            [3.4903542025305314, 2.898367913800818],
            [3.561873860783916, 2.9019546837354184],
            [3.6044786113038736, 2.9040868254231325],
            [3.7042170749285184, 2.9075972104355348],
            [3.791561690010767, 2.911951276957945],
            [3.786943613318687, 2.9106900144313372],
            [3.786343859614053, 2.9075544316435153],
            [3.7925853657562674, 2.9035096014947768],
            [3.7931412503054456, 2.898184437564523],
            [3.8043401161615757, 2.8947722973892924],
            [3.806368798213512, 2.8891963152695945],
            [3.8056050574867384, 2.886580643750183],
            [3.8063177785721964, 2.8788323076092404],
            [3.8037383557149593, 2.8772583190793486],
            [3.7980146928872935, 2.8769336225263764],
            [3.797559094523175, 2.867823032952027],
            [3.8047714493777107, 2.862681827355097],
            [3.8096607085221557, 2.860613553521734],
            [3.8100303965125253, 2.8548156246015717],
            [3.807307147620184, 2.852127193448093],
            [3.8088288200471423, 2.847939577302016],
            [3.816546916813073, 2.842008902350095],
            [3.820670392648162, 2.8316746058578746],
            [3.8223303693734105, 2.8255758265568116],
            [3.825991864209287, 2.738059928970767],
            [3.8273150511956375, 2.708834065508719],
            [3.831311730020155, 2.606445608871818],
            [3.8335631421553313, 2.5625671213962673],
            [3.793406772648456, 2.561006413359417],
            [3.747628994546584, 2.5597071901679906],
            [3.661731357439187, 2.555022400120106],
            [3.6403702590181317, 2.553630603948108],
            [3.5833504584715574, 2.5502758308779145],
            [3.554214507946517, 2.549144384988861],
            [3.490460854868407, 2.5482883084928947],
            [3.4886412054314353, 2.6071301571028656],
            [3.48704355099966, 2.636651875425657],
            [3.481965528139773, 2.7233034431268406],
            [3.479210371810961, 2.796288011591896],
            [3.47844199117686, 2.810873188793853],
            [3.47724753322677, 2.847522398576654],
            [3.475187292735222, 2.897493129861229]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.71789257517817, "lat": 41.33557877016094 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19183"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00465280"
      },
      "bbox": [
        3.475187292735222, 2.5482883084928947, 3.8335631421553313,
        2.911951276957945
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3238127052994932, -1.281196986045466],
            [-2.2798536418814574, -1.2828969159969088],
            [-2.2787613226192156, -1.28263595292246],
            [-2.1623775476007867, -1.2858944440984401],
            [-2.068590794587591, -1.288150086886491],
            [-1.9920240293919556, -1.290213287269097],
            [-1.9838557855580154, -1.2902649751811401],
            [-1.9055652219765111, -1.2924505269428896],
            [-1.8975380309406145, -1.2926711303269154],
            [-1.898520574407763, -1.307294537144906],
            [-1.8994603429477674, -1.3423647155116796],
            [-1.9027154134062, -1.4281197389831837],
            [-1.902523605415322, -1.429412469489733],
            [-1.9041041127426162, -1.498523075805539],
            [-1.9058329569748866, -1.5542572798866425],
            [-1.9056140429101462, -1.5554800632719266],
            [-1.9090216299155904, -1.680904969774108],
            [-1.9319725039910007, -1.6800915045461733],
            [-1.9480789764314839, -1.679954118273105],
            [-2.007512836557319, -1.6778227358926956],
            [-2.128159497691037, -1.6735988322060642],
            [-2.2055148702144103, -1.670287592949194],
            [-2.2305340660186603, -1.669998821269258],
            [-2.2694189719597917, -1.668703914386186],
            [-2.310808220887571, -1.6669985197214234],
            [-2.3365334204356825, -1.666130750521799],
            [-2.332922366227053, -1.5462335952629536],
            [-2.3315796357948004, -1.471797828179218],
            [-2.329573451322871, -1.4028197623105916],
            [-2.328008680353838, -1.361466157086921],
            [-2.3238127052994932, -1.281196986045466]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.2718649902731, "lat": 37.191262616078376 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20033"],
        "coty_name": ["Comanche"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Comanche County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00484986"
      },
      "bbox": [
        -2.3365334204356825, -1.680904969774108, -1.8975380309406145,
        -1.281196986045466
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.742753967202443, 0.5587564412047215],
            [-3.676402297391418, 0.5553182260607753],
            [-3.6154104480965374, 0.5522139382925372],
            [-3.5573322522304514, 0.5486348980637578],
            [-3.4874144722991045, 0.5435225417354184],
            [-3.4454339053526315, 0.5406917033071018],
            [-3.418983137204342, 0.5391289012874482],
            [-3.3337546181708326, 0.5345731476853758],
            [-3.231638685498368, 0.5296457960542386],
            [-3.235908371766911, 0.4631648125525648],
            [-3.2423642030122495, 0.3554342831390609],
            [-3.2505003300612456, 0.23999945319697596],
            [-3.2507975612143274, 0.23755075412740723],
            [-3.253874984252695, 0.18141450432332468],
            [-3.2582158153906096, 0.11107374433677658],
            [-3.2590685948823412, 0.09278903637796779],
            [-3.300079712087334, 0.09474709696718508],
            [-3.3027980667222514, 0.09452970314016124],
            [-3.328035690076236, 0.09557598777339507],
            [-3.372651597306215, 0.09805533425968199],
            [-3.3996569549819147, 0.09972535345653079],
            [-3.4980549651022157, 0.1060566211848309],
            [-3.5547325395000273, 0.10951291880658515],
            [-3.5616038378238764, 0.11050048813938101],
            [-3.6010494930702417, 0.11258894190598699],
            [-3.772806595575521, 0.12097027634624509],
            [-3.7685100095010893, 0.17973272849109898],
            [-3.7665318650024315, 0.20896207498521985],
            [-3.7632784162616653, 0.25234352903841495],
            [-3.7590059525194137, 0.32054578420138935],
            [-3.7545100849629702, 0.3844908137967534],
            [-3.7521052180211143, 0.4230245661787547],
            [-3.751722933790424, 0.42439809846989435],
            [-3.74572510546357, 0.5158084013597116],
            [-3.742753967202443, 0.5587564412047215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.14842856555221,
          "lat": 38.91731626192957
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20109"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00485019"
      },
      "bbox": [
        -3.772806595575521, 0.09278903637796779, -3.231638685498368,
        0.5587564412047215
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.8639539337519395, 1.350498283149519],
            [-1.7636304952624529, 1.3473655326568237],
            [-1.6874983630017666, 1.3452142844183534],
            [-1.6054950400568102, 1.3426731995385888],
            [-1.578104597953115, 1.3422215341784298],
            [-1.549436912209147, 1.3411099705563767],
            [-1.5404885033310478, 1.3411110929224335],
            [-1.4907952529806652, 1.3397344369375004],
            [-1.4796913481112588, 1.33922653531174],
            [-1.4371035353891615, 1.3381468572272863],
            [-1.4382729220390784, 1.2905344241501422],
            [-1.4394216205437385, 1.2503634178270857],
            [-1.4413654184234983, 1.1626265300084397],
            [-1.4425220197474236, 1.1314569034378676],
            [-1.4427199444155436, 1.1186614256202418],
            [-1.4439798261441146, 1.0749413869643913],
            [-1.4467515824394102, 0.9873332647649089],
            [-1.4468888135859832, 0.9768606141186005],
            [-1.4492829754138474, 0.8996386563802308],
            [-1.5206470254236901, 0.9014389589000815],
            [-1.5420303390533974, 0.9022600946849093],
            [-1.6058045454672913, 0.903913608600827],
            [-1.7060313574130928, 0.9071150457005493],
            [-1.7264879577656933, 0.9078881763322181],
            [-1.7759506601764041, 0.9093324635149933],
            [-1.860822283093587, 0.9120918046315628],
            [-1.8774758682645303, 0.9127181561875788],
            [-1.8747080650803483, 1.0001960013678424],
            [-1.8719933779597495, 1.0881234449569703],
            [-1.8692923939581685, 1.1759918793381465],
            [-1.8670731353701115, 1.2494216296388374],
            [-1.8668155281672802, 1.2635472346096497],
            [-1.8639539337519395, 1.350498283149519]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.78546469811198, "lat": 39.78516189755125 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20183"],
        "coty_name": ["Smith"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Smith County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "00484969"
      },
      "bbox": [
        -1.8774758682645303, 0.8996386563802308, -1.4371035353891615,
        1.350498283149519
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9568197404601764, -1.2256958797453181],
            [-0.8704581037174624, -1.2269600841684456],
            [-0.784078840198771, -1.2277895016271205],
            [-0.6979094430556869, -1.2285783736566025],
            [-0.6121249470779302, -1.2283354308839727],
            [-0.5260358500781437, -1.2313016263656573],
            [-0.48573288475591697, -1.23164500232593],
            [-0.4426574246612262, -1.2323304747304713],
            [-0.4415532408271528, -1.2672345512487901],
            [-0.4406930007391413, -1.3179977350685521],
            [-0.4416934271863346, -1.3179583723244317],
            [-0.4421121781959284, -1.361957726215129],
            [-0.4426350914653923, -1.3912830090378636],
            [-0.44308122294735314, -1.4600050343386985],
            [-0.4427542737906825, -1.4603491920772382],
            [-0.442762616654411, -1.4871016762745066],
            [-0.4432286956796548, -1.4977208266677386],
            [-0.4430242432250754, -1.5088547644350643],
            [-0.44362961067930523, -1.568085959414118],
            [-0.4437315196639274, -1.6184966704025274],
            [-0.444058004150235, -1.71326708824608],
            [-0.529517860381884, -1.7123082823038829],
            [-0.5983013872901003, -1.7114660282900322],
            [-0.6929022236523971, -1.710281293741514],
            [-0.806948958437267, -1.7084439614218443],
            [-0.8311328632051108, -1.707619593146765],
            [-0.878562815398253, -1.707054409838249],
            [-0.9617690135835076, -1.7056372150447399],
            [-0.9590921635923177, -1.5782452983582909],
            [-0.9591035557940052, -1.5484223383859297],
            [-0.9576850691754883, -1.4969532858494345],
            [-0.9570064736834394, -1.4287298756190443],
            [-0.9564265205987847, -1.3437804001021922],
            [-0.9561205623525658, -1.3144496738201183],
            [-0.9580803799116691, -1.3144174914324067],
            [-0.9568197404601764, -1.2256958797453181]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.47654216834594, "lat": 37.23730337125469 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20191"],
        "coty_name": ["Sumner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sumner County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "00481812"
      },
      "bbox": [
        -0.9617690135835076, -1.71326708824608, -0.4406930007391413,
        -1.2256958797453181
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.759677698542658, -0.5083945533377305],
            [7.765441355244464, -0.5089247462865475],
            [7.772910914940007, -0.5068750197921118],
            [7.78218794813627, -0.5013427786158242],
            [7.7975405094896555, -0.4886538073632972],
            [7.801701593057549, -0.478996639245737],
            [7.801784718159093, -0.47483196030281594],
            [7.799969267945689, -0.471688807284106],
            [7.79995566562187, -0.46174556949648415],
            [7.796781273532784, -0.44514966956462276],
            [7.79642210151179, -0.4395676168344502],
            [7.798565150623153, -0.43170871962621765],
            [7.803744229661076, -0.4242229699414356],
            [7.809965923425914, -0.42158926258880564],
            [7.820997871862651, -0.42148701443739134],
            [7.835227781818151, -0.42445461947277063],
            [7.846467370584793, -0.42417976253429235],
            [7.857543761673792, -0.41783960127479564],
            [7.863546405034485, -0.41322282386767145],
            [7.866491471642188, -0.408260420986846],
            [7.86558675235823, -0.4025460840905622],
            [7.860219801560896, -0.39241657925630735],
            [7.855080202539864, -0.3880111513414265],
            [7.8499539677987356, -0.3779991008074929],
            [7.848301691134886, -0.3720154249091853],
            [7.847156381460184, -0.35832199112778834],
            [7.84475059803794, -0.3417658842385879],
            [7.844004576250543, -0.3329504338593271],
            [7.843850763640103, -0.32133159080181156],
            [7.842465745769538, -0.3120624669810143],
            [7.843855613559606, -0.30132025264929213],
            [7.846942592320108, -0.296640322768481],
            [7.85105057620304, -0.2943880191967766],
            [7.860004649852156, -0.2921621364973656],
            [7.867215341709458, -0.2915244191935732],
            [7.956386092582212, -0.35898440940307835],
            [8.023877314063299, -0.40493900860511867],
            [8.076982001792704, -0.44131966525417804],
            [8.106461712907182, -0.4699513704526699],
            [8.15637161345007, -0.5124869442392972],
            [8.113676756185574, -0.6369392229510504],
            [8.081051155693913, -0.7287370086543389],
            [8.077421373197124, -0.7273018125824683],
            [8.075363820290493, -0.7306412528554158],
            [8.071110681778334, -0.7323259340922577],
            [8.068539387417204, -0.7359137042607599],
            [8.064485545443656, -0.733264752705362],
            [8.06410080162269, -0.7378402454427059],
            [8.059379479795862, -0.7364753673594832],
            [8.062956903154378, -0.732002345767751],
            [8.061253283221431, -0.7291926860805203],
            [8.057228851845903, -0.7325421017930861],
            [8.05807448084023, -0.7388460053286214],
            [8.055712075872714, -0.7459095320662635],
            [8.04932383294215, -0.7429880133821588],
            [8.041461966360949, -0.7439292794822289],
            [8.04248287933335, -0.7388800509155444],
            [8.033217271652942, -0.7383429424224236],
            [8.028825791192078, -0.7363051501354756],
            [8.028569517381335, -0.7412954470301775],
            [8.022109267771699, -0.7398862931856546],
            [8.021284465021152, -0.7414917107094823],
            [8.024114156378348, -0.7523719750600563],
            [8.024661827607066, -0.7605118729231057],
            [8.023567905897691, -0.7658218262815986],
            [8.014070425365082, -0.7674989066597648],
            [8.016461298780122, -0.7588936645217529],
            [8.014050435037333, -0.7571973828315623],
            [8.008176551699103, -0.7614473802421059],
            [8.004995657184056, -0.7670867480008472],
            [7.996344243724488, -0.7627424473709628],
            [8.000579634260049, -0.7586974041877809],
            [7.994066116421822, -0.7569927746573792],
            [7.991660285247551, -0.7637697300217962],
            [7.98436293299483, -0.7661332502568994],
            [7.977748799076162, -0.7640811530420782],
            [7.9797146661082925, -0.7582606920223333],
            [7.9767748951962405, -0.755950077714062],
            [7.972922828069951, -0.7607353268066208],
            [7.970761361657243, -0.7549733239471774],
            [7.965384357777979, -0.7537206763714851],
            [7.963582189773241, -0.7574771574929275],
            [7.958023055789527, -0.7583025365727748],
            [7.9571320528428915, -0.7512682136945281],
            [7.954036649210195, -0.7546952631451319],
            [7.9534532320865186, -0.7589809859943204],
            [7.9485716823753005, -0.7594236804431734],
            [7.949261827143795, -0.7461306482688935],
            [7.945719317376359, -0.7470247428360568],
            [7.944570663801224, -0.7538669001803291],
            [7.937821160261669, -0.7564415888305045],
            [7.933631191865763, -0.7555086118254064],
            [7.933728582013733, -0.7525192876413278],
            [7.941226273443203, -0.7503282672579168],
            [7.940944466050974, -0.7448552315896375],
            [7.935839028008172, -0.745382661938848],
            [7.933633303044961, -0.7475146249898813],
            [7.925420427263915, -0.7477441301780953],
            [7.925298051354643, -0.743986392463568],
            [7.928833993677983, -0.7412175253349853],
            [7.927044390107572, -0.7366836910374042],
            [7.92328483103644, -0.7371246582248564],
            [7.920327000974319, -0.7341430876173232],
            [7.918020491810925, -0.7273229068548409],
            [7.912190479475666, -0.7285903870787108],
            [7.909984865665663, -0.7323331474023552],
            [7.903677297853567, -0.7392839850523198],
            [7.9009457270838785, -0.7384486500576817],
            [7.90086007899645, -0.7330402966520939],
            [7.906764392203066, -0.7300736173903966],
            [7.907005850310871, -0.7263433460983533],
            [7.902535273862248, -0.7197358509901026],
            [7.900096851674569, -0.7179964004251252],
            [7.893575019656909, -0.7179060517029401],
            [7.886754568092711, -0.7254091543044395],
            [7.877327912534312, -0.7268621547816574],
            [7.875198294492878, -0.7293205841752021],
            [7.874879838866156, -0.7361157326894199],
            [7.872548350920999, -0.74307837314223],
            [7.878148914482382, -0.7398420817332362],
            [7.886533080328414, -0.7403413291103939],
            [7.886213663248109, -0.7441238520814358],
            [7.878790208904262, -0.7529271741459795],
            [7.875237961308393, -0.7549289229363717],
            [7.865948352086344, -0.7556743501680121],
            [7.864491662946677, -0.7482882790301163],
            [7.859778925280794, -0.7469224564799087],
            [7.855246241179892, -0.7478367644214047],
            [7.846427567386485, -0.7462346197415867],
            [7.845232699260026, -0.7509551759983996],
            [7.8467866464477565, -0.7556448156767264],
            [7.852918899046845, -0.7640512898167521],
            [7.846759957876076, -0.7714220315290444],
            [7.841689377635339, -0.7787478999235552],
            [7.836060534719157, -0.7830684650621775],
            [7.833486674550344, -0.7832600614456241],
            [7.827627223674285, -0.7784565805332281],
            [7.822257118635117, -0.7706576137869465],
            [7.8171368381040285, -0.7675984474702752],
            [7.812381767652747, -0.7623375365721775],
            [7.812386232987386, -0.7578117195421266],
            [7.80752253358148, -0.7530138621129049],
            [7.806919548108207, -0.7457101675255785],
            [7.802717539008765, -0.7403707284872894],
            [7.794224803673529, -0.7317760154048054],
            [7.793266698434552, -0.7317955850690934],
            [7.7903468419981685, -0.688648771591452],
            [7.8039950917394165, -0.6942688124941697],
            [7.747023032799658, -0.5600419103068608],
            [7.751942774202985, -0.5159604726900782],
            [7.757468516302943, -0.5123444269143159],
            [7.759677698542658, -0.5083945533377305]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.42930068035825,
          "lat": 37.773452084258246
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21027"],
        "coty_name": ["Breckinridge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Breckinridge County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00516860"
      },
      "bbox": [
        7.747023032799658, -0.7832600614456241, 8.15637161345007,
        -0.2915244191935732
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.68504552792831, -0.5071210922799357],
            [10.68866187151862, -0.5083878320050801],
            [10.688256770564044, -0.5125661193079495],
            [10.69134390648386, -0.5132270169372608],
            [10.692737364201816, -0.5198569541679146],
            [10.69628531097113, -0.5176588656341073],
            [10.70229982907077, -0.5173221254612178],
            [10.705314266682326, -0.5212821135698458],
            [10.704231127269827, -0.5271314099341962],
            [10.781190739313772, -0.5306551465399347],
            [10.783919505099094, -0.5346004416806397],
            [10.7837834500497, -0.5384049046666346],
            [10.787455900984469, -0.5460967793529918],
            [10.784795984431826, -0.5484762271434811],
            [10.789876270812401, -0.5583186381168549],
            [10.785434961197206, -0.5612381045476189],
            [10.785817555299431, -0.5659744164426824],
            [10.78325212376175, -0.5681039800698804],
            [10.783081277929735, -0.5752174041608902],
            [10.786088451144092, -0.5761684140571042],
            [10.785400310030022, -0.583638396292862],
            [10.789532011084152, -0.5854806036136102],
            [10.793268833546753, -0.5820884667492252],
            [10.801231270794046, -0.5847953623367589],
            [10.805246918284544, -0.5838400772226414],
            [10.811437074643413, -0.5759974809913794],
            [10.815201812753152, -0.5757444574886244],
            [10.815027065134776, -0.5676287190297907],
            [10.825013501518452, -0.5627936280731315],
            [10.828194845919121, -0.5667824569821357],
            [10.834533068798274, -0.5655430285621189],
            [10.836403006579543, -0.5629175931962953],
            [10.840249570574633, -0.564650190546846],
            [10.84022032725442, -0.5700388506215769],
            [10.847547853064508, -0.5758102697556656],
            [10.843992188558758, -0.5788201671623261],
            [10.847640880958142, -0.5863675790181732],
            [10.852817708907903, -0.5889705066909221],
            [10.851163594542781, -0.5942985936683158],
            [10.852175267204752, -0.5992618967837833],
            [10.850984304623086, -0.6037938886779428],
            [10.8516640346293, -0.6092350282795108],
            [10.853992367438382, -0.6156083093315369],
            [10.856331359202555, -0.6180678169216177],
            [10.852476470592238, -0.6206201807046475],
            [10.852719692744104, -0.6256300309338935],
            [10.84906110782315, -0.6292802386682527],
            [10.85060292561575, -0.6332760362472816],
            [10.849532852714107, -0.637952991559338],
            [10.854955004758366, -0.6455259575159612],
            [10.857642631108714, -0.645824030114954],
            [10.860077761410684, -0.6554184166682825],
            [10.86043936954889, -0.6623834987619952],
            [10.863142048933714, -0.6629882839618357],
            [10.867117693694418, -0.6717729947619033],
            [10.865162817721227, -0.6738815393632709],
            [10.865085148914988, -0.6809806071285676],
            [10.872339511425722, -0.6816387877690295],
            [10.875760489391702, -0.6856416608890967],
            [10.882070808032255, -0.6810653045741104],
            [10.885704049106081, -0.6816110230115977],
            [10.887395178029612, -0.6847054305427558],
            [10.885995917136697, -0.6929571107883967],
            [10.888569482014098, -0.6973131455745154],
            [10.898290966914352, -0.6959286108717594],
            [10.900685194102, -0.6991400430057084],
            [10.895116342154125, -0.7050695896091403],
            [10.890557961485857, -0.7049366647739254],
            [10.885548705120792, -0.715360582504486],
            [10.878419186931405, -0.7157868460384964],
            [10.875087527690802, -0.7224341872980302],
            [10.872351960111478, -0.7229149047865773],
            [10.866304506496546, -0.7199601678517765],
            [10.86423766800145, -0.7207311946238872],
            [10.86062148886666, -0.7271698089763805],
            [10.853341022986754, -0.7253350102536321],
            [10.851402728911138, -0.7280767430499308],
            [10.845897114799742, -0.7289982641784878],
            [10.841644840400757, -0.7281556702971921],
            [10.837274586366975, -0.7319487013631053],
            [10.833149051912475, -0.7331737800711435],
            [10.827530085132208, -0.7279082163207735],
            [10.82287808462455, -0.7309291939337004],
            [10.817906454208979, -0.727682934111099],
            [10.814341022865896, -0.7340443503211431],
            [10.810857645539757, -0.7342885856154721],
            [10.809397499607748, -0.7389920147188959],
            [10.800804875680916, -0.7418990917928765],
            [10.797274729647347, -0.7450606125796407],
            [10.794364677020964, -0.7441262684670295],
            [10.790465525895167, -0.7504601845528723],
            [10.7861251796649, -0.7508641962304641],
            [10.782790835390932, -0.7542270087978477],
            [10.782157114074291, -0.7577290186910063],
            [10.778773150219171, -0.7602116182471201],
            [10.779667771536298, -0.7703880082917038],
            [10.776523756370322, -0.7734568230953814],
            [10.773199548751053, -0.7735219997777665],
            [10.771843521278218, -0.7782035781376772],
            [10.768943767026885, -0.7801861040714131],
            [10.767543720319354, -0.7895849871927353],
            [10.762389892354141, -0.7937595283092085],
            [10.758907410291101, -0.7935268585535874],
            [10.75687859899824, -0.7998454411149062],
            [10.748955161598165, -0.8047593990285503],
            [10.739628489843845, -0.8058006721577236],
            [10.73402905220231, -0.8131615841796723],
            [10.732570105471426, -0.819342186658033],
            [10.727843281253367, -0.8171181463638248],
            [10.720696741837747, -0.8213708596752645],
            [10.720772678425801, -0.8246198370919621],
            [10.718019307370888, -0.8301989260132601],
            [10.710935168264427, -0.8342695794053195],
            [10.708043878256815, -0.8400353050962062],
            [10.704273296427942, -0.8396224962931725],
            [10.701615047041246, -0.8367549625400168],
            [10.700358569134087, -0.8321746529108375],
            [10.700552744917152, -0.8265098106221189],
            [10.697547859128886, -0.8237297001991124],
            [10.691711384003314, -0.8245640480641538],
            [10.687221221249235, -0.8202004507628038],
            [10.683991226425334, -0.8167160589861262],
            [10.681134001518938, -0.810771004165759],
            [10.674965426054035, -0.8129105406290621],
            [10.673925965453078, -0.8088250087247176],
            [10.668989370681462, -0.8082254586835074],
            [10.66292069375157, -0.810720214465156],
            [10.659948644769704, -0.8083949839649819],
            [10.658654061327118, -0.8026016765027272],
            [10.652707611738906, -0.8026717253199765],
            [10.650439759608284, -0.804894660281932],
            [10.643713248168078, -0.8067188319923809],
            [10.642130736309047, -0.8059003252864437],
            [10.639375564844705, -0.7991096040876763],
            [10.629697914581005, -0.7916893005500905],
            [10.62758730282394, -0.7818078475264363],
            [10.628785704235986, -0.7786059017982997],
            [10.625111180521067, -0.7749041908298124],
            [10.615723160680187, -0.7769986969040735],
            [10.616133785734787, -0.7818686804980927],
            [10.609679635666762, -0.783521320962616],
            [10.609450953933534, -0.787303667877832],
            [10.602525641489084, -0.7913250243622975],
            [10.597777909971727, -0.7912832361234876],
            [10.590126690664226, -0.787689529026913],
            [10.58232266638878, -0.7919469168241347],
            [10.58624069370979, -0.7818383980377092],
            [10.585095931868853, -0.7771073208969128],
            [10.580737260899294, -0.7732514381323056],
            [10.58355483045429, -0.7697431393423825],
            [10.579524980698228, -0.764970140010001],
            [10.577964505021841, -0.7610843544352401],
            [10.57949825539421, -0.7533081865924495],
            [10.578572023310876, -0.7487072316630342],
            [10.581679257697779, -0.744858742047137],
            [10.578552616901561, -0.7411039466278307],
            [10.580280468576056, -0.7336099010800727],
            [10.5833895643538, -0.7330514117702531],
            [10.586907416191249, -0.7287236379131855],
            [10.585550033679148, -0.7219345147739018],
            [10.581161307202049, -0.721093275241146],
            [10.580865031154868, -0.7180877811291657],
            [10.584177592932733, -0.706867658729881],
            [10.577814810667334, -0.6998512463184678],
            [10.58221823016819, -0.695806195746374],
            [10.582287505579517, -0.6914046122216372],
            [10.579807570662489, -0.6853147626837337],
            [10.561604608248455, -0.6241424476816367],
            [10.54641265030659, -0.573008993337659],
            [10.573194754530265, -0.5276529605902046],
            [10.573496554009736, -0.5234668802477014],
            [10.570591251694466, -0.5178896374010376],
            [10.569253286784384, -0.507621140217261],
            [10.572733745459345, -0.5080984649419102],
            [10.572581338109833, -0.5032365490712699],
            [10.576892059177425, -0.5028123704008273],
            [10.580014540720363, -0.506370293177975],
            [10.5824544577606, -0.505163126673773],
            [10.587750564057776, -0.5065093849052382],
            [10.59103864906947, -0.49736459774784014],
            [10.599158156364814, -0.5013473092669493],
            [10.602889909113305, -0.49585495989021966],
            [10.609674542875165, -0.50046295052074],
            [10.613820121114717, -0.5047263018747699],
            [10.616604144543295, -0.5056294559464447],
            [10.620232419863179, -0.5128133131702478],
            [10.6251736184568, -0.5113315643609582],
            [10.628994895461304, -0.5124047271762937],
            [10.633439500184968, -0.5087533766907868],
            [10.63521339787128, -0.5114581970108805],
            [10.641312320969243, -0.5128413329187406],
            [10.652736646402577, -0.5125927021157801],
            [10.65593036562537, -0.5077187792371471],
            [10.66234165916886, -0.513756209718573],
            [10.666484015047159, -0.5151420925538819],
            [10.672108493408698, -0.5113581135963292],
            [10.67917054357448, -0.5111130411343863],
            [10.68504552792831, -0.5071210922799357]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.95412125013914, "lat": 37.35403027836403 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21119"],
        "coty_name": ["Knott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knott County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00516906"
      },
      "bbox": [
        10.54641265030659, -0.8400353050962062, 10.900685194102,
        -0.49585495989021966
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.88264927472404, -0.21334515827704154],
            [7.885347056330687, -0.20966690425962334],
            [7.890749590084312, -0.2063902305477477],
            [7.898562377633511, -0.20541029180680104],
            [7.9066431020638275, -0.20675713971157747],
            [7.916264558672003, -0.21409597084054732],
            [7.927593535768353, -0.22440926747481724],
            [7.930215664266349, -0.22563766786649594],
            [7.934372671147747, -0.22235099429234964],
            [7.939078817949496, -0.2043750688873635],
            [7.944806535436764, -0.1988383137617432],
            [7.948117645417004, -0.19712659781167385],
            [7.966053604343617, -0.19750450439774575],
            [7.975357384213363, -0.19728913444499102],
            [7.98054406828001, -0.19523943756076878],
            [7.983789639434625, -0.1921024940551555],
            [7.987210593895276, -0.18524346756959853],
            [7.988386423209079, -0.17640080409731657],
            [7.985711052287755, -0.1712242300417797],
            [7.982291247631367, -0.16912517370214195],
            [7.968826828400172, -0.16625494370264582],
            [7.9588965811520485, -0.16631239393207775],
            [7.952143069017997, -0.16535120117502342],
            [7.947468454916481, -0.16313468365158085],
            [7.94232338604136, -0.15635347604444258],
            [7.940702489245796, -0.14921715297756735],
            [7.94029170760196, -0.141876702696413],
            [7.942893787918796, -0.13399260685917208],
            [7.947365666077863, -0.12952561139399013],
            [7.954789625229761, -0.12724566336479287],
            [7.962869746368983, -0.12991846843748617],
            [7.978256684391144, -0.14221577653377054],
            [7.988865533897516, -0.1500593201610412],
            [8.006347865319638, -0.1572414516384815],
            [8.013663651764661, -0.16271415261369665],
            [8.026476313209283, -0.178761840637269],
            [8.028735089015786, -0.18366232419557033],
            [8.02961419388515, -0.18965873776642278],
            [8.027284656610338, -0.20581214686223154],
            [8.025764126009427, -0.21952215863046198],
            [8.028730576913002, -0.2377669847524186],
            [8.033476525624854, -0.2525451406266445],
            [8.035749574450753, -0.25788067219542127],
            [8.039524146742057, -0.26272993118573773],
            [8.046265040499827, -0.26770444819919964],
            [8.056502440585856, -0.2732859037161489],
            [8.067569316712667, -0.27727609396413233],
            [8.067634435278823, -0.27873629816800405],
            [8.076176725516559, -0.2846200741366496],
            [8.078553431316731, -0.28776337271042934],
            [8.102884359601427, -0.29716563811551816],
            [8.114682423009066, -0.30224528244067617],
            [8.123446362728703, -0.3017042458371209],
            [8.136452048181406, -0.295396000517637],
            [8.151508036966607, -0.29236311206226406],
            [8.159949285602066, -0.2922452064701131],
            [8.170608329599695, -0.29398920850687704],
            [8.185250029662056, -0.30027174428236125],
            [8.191098154393126, -0.30403134989482233],
            [8.194321233942112, -0.3089043719967577],
            [8.200244589852003, -0.32024725306686613],
            [8.205009560792716, -0.3279636894827086],
            [8.2111747220749, -0.33538569706785726],
            [8.21811791343772, -0.3419376418311301],
            [8.22435988095352, -0.34364634010366474],
            [8.22740704166569, -0.3418870629567493],
            [8.229852925446409, -0.33651928542990384],
            [8.229863244960967, -0.3308218766393351],
            [8.227247755560787, -0.31979687369673027],
            [8.228624666071982, -0.3107774655975955],
            [8.23351960712365, -0.30578923920386547],
            [8.238823556967427, -0.3031762051109132],
            [8.253546985178772, -0.29811465907342627],
            [8.284643482631948, -0.420933521192393],
            [8.26627499328935, -0.4810289906973287],
            [8.15637161345007, -0.5124869442392972],
            [8.106461712907182, -0.4699513704526699],
            [8.076982001792704, -0.44131966525417804],
            [8.023877314063299, -0.40493900860511867],
            [7.956386092582212, -0.35898440940307835],
            [7.867215341709458, -0.2915244191935732],
            [7.875276463141332, -0.29081064913627874],
            [7.889284726587727, -0.2874183869737003],
            [7.89666123520222, -0.28367311133909745],
            [7.906481538814944, -0.272598121424801],
            [7.910022606271676, -0.2653947419268221],
            [7.910951410574948, -0.25366244691536005],
            [7.907059663179129, -0.2458090561793362],
            [7.8869022616002376, -0.2384609957401624],
            [7.8824828248573136, -0.2336578649893056],
            [7.880087070540659, -0.22821141948813875],
            [7.8794182850605, -0.22050852771844454],
            [7.88264927472404, -0.21334515827704154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.21699180376221, "lat": 37.96973782570622 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21163"],
        "coty_name": ["Meade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meade County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00516928"
      },
      "bbox": [
        7.867215341709458, -0.5124869442392972, 8.284643482631948,
        -0.12724566336479287
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.416571082847341, -8.419542929224004],
            [5.413004188054249, -8.43906211576302],
            [5.412386987022236, -8.449754492695925],
            [5.4108999430734235, -8.463328112556612],
            [5.408966928021722, -8.475179226621991],
            [5.4092367682648055, -8.486726556729355],
            [5.407562518170107, -8.494037006491604],
            [5.407972733068198, -8.504812060179033],
            [5.40769166911294, -8.525656455853639],
            [5.406609300388267, -8.530150890550539],
            [5.409393615395005, -8.589277994334982],
            [5.4104731940152, -8.609170300758823],
            [5.412977721200628, -8.619877139491312],
            [5.419417675107712, -8.659058831491098],
            [5.424935307156162, -8.675356146024217],
            [5.429011680675318, -8.681531854453095],
            [5.432743831738342, -8.682269316154091],
            [5.437528451566165, -8.689480505896253],
            [5.447951641585285, -8.697819282026266],
            [5.448368352651282, -8.701909452657366],
            [5.45114837876795, -8.707181934442643],
            [5.450169225289346, -8.71010984110732],
            [5.451830090388561, -8.716237087492528],
            [5.504221328161141, -8.747287077784637],
            [5.511876684124933, -8.746896312825472],
            [5.517562343204804, -8.755532865726241],
            [5.514694690391039, -8.760687147406708],
            [5.516394802754269, -8.76756551722542],
            [5.513906380147386, -8.769868625176038],
            [5.491346932785446, -8.824282065222054],
            [5.472552455410466, -8.883491592747642],
            [5.396419022168203, -8.88761442703669],
            [5.370168746441618, -8.888317568661874],
            [5.36354072023493, -8.884175313964386],
            [5.356604523316303, -8.876298686514916],
            [5.355688800264709, -8.873218380107337],
            [5.356169911174914, -8.858251020389838],
            [5.3530876803917, -8.851671012116094],
            [5.354915388536013, -8.845888084993298],
            [5.351688736745133, -8.8411939005489],
            [5.345590424772715, -8.837384855770141],
            [5.344050885547786, -8.832501218693288],
            [5.34391264481647, -8.824561043279823],
            [5.341287972641965, -8.821374916636215],
            [5.336025300558123, -8.819122524707568],
            [5.3260117952211345, -8.817508779377423],
            [5.314587449174538, -8.811507897869356],
            [5.3108374541956165, -8.813659670855431],
            [5.302209176092556, -8.810707496348835],
            [5.292751386368848, -8.81055810044846],
            [5.284818408995266, -8.804642786790296],
            [5.277380039647442, -8.797581664138763],
            [5.2679106050618, -8.79346796865974],
            [5.262703140598876, -8.788119012301818],
            [5.256407408336632, -8.784071530432634],
            [5.2544454973441725, -8.779447329933774],
            [5.250882686403791, -8.776792335985311],
            [5.249211178717416, -8.76911180586014],
            [5.249735667586193, -8.765009939961729],
            [5.248767889480032, -8.757863122902167],
            [5.2455417725067015, -8.750994473863235],
            [5.24531456481005, -8.742970337870709],
            [5.239719438671397, -8.737580688257557],
            [5.2365587902090835, -8.731699167505253],
            [5.2278806514314855, -8.726449661102064],
            [5.223466332938734, -8.726615173320337],
            [5.218222962722538, -8.728780817439551],
            [5.213320038916949, -8.727612281023648],
            [5.2055054690802605, -8.71839910736275],
            [5.200148368669101, -8.70827795624571],
            [5.193124661226185, -8.626472354257677],
            [5.178310382646112, -8.627208502678933],
            [5.175978458941942, -8.592988006078482],
            [5.1852433013604, -8.592978146079524],
            [5.185317428942261, -8.578347072125696],
            [5.222098662166425, -8.563301943228364],
            [5.237931909917067, -8.556517815862804],
            [5.239192269785405, -8.560978234191037],
            [5.260150539528872, -8.558012108077962],
            [5.294509306375951, -8.506423883882592],
            [5.3417258007099955, -8.46681129706315],
            [5.347752774873521, -8.459008869216731],
            [5.355139549320753, -8.443092955636365],
            [5.359836562138481, -8.43603797856051],
            [5.3642683495701355, -8.43445209715338],
            [5.395986049532177, -8.426171355932945],
            [5.416571082847341, -8.419542929224004]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.35821148154163, "lat": 29.90547749478498 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22089"],
        "coty_name": ["St. Charles"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Charles Parish"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01629449"
      },
      "bbox": [
        5.175978458941942, -8.888317568661874, 5.517562343204804,
        -8.419542929224004
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.381519152232543, -8.680233069569098],
              [4.474806200589101, -8.668162774265776],
              [4.568089339087607, -8.656074189688821],
              [4.568125004580354, -8.65621411973343],
              [4.5721483677255215, -8.665076450464392],
              [4.572131969179853, -8.669754825016689],
              [4.5764547128380295, -8.670354465710272],
              [4.575670194580035, -8.675965394069218],
              [4.584325735804542, -8.687872415503366],
              [4.590366038506764, -8.690590489335587],
              [4.592176869642854, -8.693404304530457],
              [4.590182566214634, -8.704729432297725],
              [4.591052990345879, -8.70817619562763],
              [4.596763503702762, -8.713121982147886],
              [4.605297327780452, -8.716331916102455],
              [4.610983446842143, -8.72253779599654],
              [4.61376815392094, -8.727905333591425],
              [4.613911966492326, -8.738008254781745],
              [4.615630477187845, -8.74509348282427],
              [4.618986535234395, -8.752098670057114],
              [4.621172948679312, -8.762213294809277],
              [4.626976623928021, -8.767311727362099],
              [4.630541314924163, -8.772003829297391],
              [4.635582181563823, -8.77641771864205],
              [4.653771451408681, -8.779811013556278],
              [4.660829427499973, -8.781751977629055],
              [4.665749815517974, -8.784695475037422],
              [4.673371195288277, -8.783755896089236],
              [4.681655374970622, -8.783732717149128],
              [4.687727110308801, -8.787951488070432],
              [4.691804776404674, -8.792204690361379],
              [4.700188953385937, -8.793131222704234],
              [4.704289660990668, -8.799123408639325],
              [4.710880245538299, -8.804370409424385],
              [4.717328422950958, -8.816988948732208],
              [4.712517693093131, -8.829106013328571],
              [4.711854550501829, -8.833619940277616],
              [4.715696351658984, -8.839509842178924],
              [4.712227217150697, -8.845979391425878],
              [4.719109750705267, -8.855003424955585],
              [4.72255000902051, -8.86229094872504],
              [4.719607781109266, -8.872218551821911],
              [4.718394007644663, -8.880830940084836],
              [4.710893123146092, -8.881805298195964],
              [4.708880672614701, -8.88482480029053],
              [4.716307376650284, -8.91818164100001],
              [4.705491038463201, -8.915243779441946],
              [4.68546970226759, -8.895331197036029],
              [4.6633089658913285, -8.896699539938348],
              [4.644680152167637, -8.892957092669844],
              [4.631614854134569, -8.881861638000046],
              [4.613818531115095, -8.872067372341354],
              [4.601624895724181, -8.8749392051896],
              [4.540870483591154, -8.862052072884515],
              [4.4942054433620156, -8.862751758791084],
              [4.463788188934689, -8.847262077722869],
              [4.4724503192244285, -8.79663264653204],
              [4.471111385500473, -8.795280215526116],
              [4.446756928410571, -8.75912383452832],
              [4.437361606695782, -8.732403510620715],
              [4.4344815432456794, -8.728546626880208],
              [4.38191067043925, -8.68847643760954],
              [4.381519152232543, -8.680233069569098]
            ]
          ],
          [
            [
              [4.111520128707053, -8.155176100670966],
              [4.158669549145042, -8.153460516517558],
              [4.158924497599718, -8.1586036054676],
              [4.167048974506102, -8.169414750747782],
              [4.173258308430208, -8.174058598018492],
              [4.180101887972499, -8.174128888145773],
              [4.1825523980577755, -8.175424404851428],
              [4.195071587145541, -8.187969029825712],
              [4.193282634387799, -8.188707167360915],
              [4.20694875186468, -8.19960311443733],
              [4.208900186429299, -8.20434052063381],
              [4.213820652760018, -8.205653918028647],
              [4.21667737378401, -8.21327452716459],
              [4.21488584883776, -8.219147517393141],
              [4.21962116850616, -8.225449292480034],
              [4.219484044757309, -8.22817348690156],
              [4.2254521163770296, -8.233673142342573],
              [4.224105516624621, -8.240515167560726],
              [4.227254161769798, -8.24545885723521],
              [4.229134351030954, -8.25248997882255],
              [4.228292049739037, -8.260836993715094],
              [4.226394480855154, -8.264051875151981],
              [4.226296913656696, -8.269349329681225],
              [4.220343505585062, -8.273352956895668],
              [4.214261436905566, -8.275318441503627],
              [4.2104690189901985, -8.282836526362653],
              [4.230443304708473, -8.29270499949138],
              [4.22918882284143, -8.297729983712289],
              [4.231934902992268, -8.308222856556846],
              [4.22978054477511, -8.316657297640484],
              [4.236295937031262, -8.336367642342802],
              [4.2519495935672476, -8.355970334150406],
              [4.264594826166643, -8.367704045576083],
              [4.266687828401475, -8.371342935056578],
              [4.264314934556039, -8.377870363326771],
              [4.265082802879058, -8.384410036522457],
              [4.267174937722618, -8.387360263964467],
              [4.278278477600198, -8.396114078552031],
              [4.289660329387486, -8.401365740627565],
              [4.296497896050321, -8.401102003871262],
              [4.304351098407177, -8.402626626465803],
              [4.312690400141096, -8.402270048204556],
              [4.317907625573895, -8.400778465085816],
              [4.328919496510851, -8.400297745104414],
              [4.336688346763652, -8.400817447643375],
              [4.3529356099572984, -8.404466833451389],
              [4.362706574842004, -8.408404409274004],
              [4.365640514434656, -8.410434499296436],
              [4.364192777967931, -8.41518347362516],
              [4.360575188512979, -8.418605182400196],
              [4.360943167363905, -8.42149699003638],
              [4.356881986429462, -8.426122553020962],
              [4.354194382908221, -8.43415954088016],
              [4.35545842685592, -8.440963246701466],
              [4.361114804461999, -8.445741337644822],
              [4.366218620925288, -8.44758964461054],
              [4.370506105186861, -8.452341218372359],
              [4.37013349228959, -8.458290153151497],
              [4.374822717369389, -8.472177229827723],
              [4.37430174312461, -8.475621901613305],
              [4.375585165089359, -8.489575278436906],
              [4.372187435703208, -8.495937564236808],
              [4.376008864458256, -8.498805193467506],
              [4.382357419142148, -8.506815973525468],
              [4.381079640322279, -8.512871663358846],
              [4.377311833058529, -8.517081712539808],
              [4.373832334616549, -8.524158870639614],
              [4.3748395574873795, -8.527541527204788],
              [4.381491820645585, -8.53517521037276],
              [4.446278288014541, -8.532324679606912],
              [4.446080165907495, -8.53549567112424],
              [4.452890950535112, -8.537239345236122],
              [4.455982055366907, -8.539386603117139],
              [4.458032492790445, -8.548262396661135],
              [4.462036871396465, -8.55226865172563],
              [4.465002118919023, -8.561006505608564],
              [4.464788838674363, -8.567263563546332],
              [4.462704073046246, -8.571180218192435],
              [4.465670622466687, -8.574632283906993],
              [4.36348757463232, -8.580258663602267],
              [4.35822939036249, -8.588435259789483],
              [4.357189642728542, -8.597091300415206],
              [4.351245242328475, -8.598100248304052],
              [4.347980077011775, -8.59990906259578],
              [4.346935996140062, -8.605317221157852],
              [4.344489454540274, -8.605696197755124],
              [4.2670677642177735, -8.609526305849931],
              [4.2656431170053635, -8.605687257141046],
              [4.259950989909996, -8.596734707394456],
              [4.261188875168207, -8.591965900918801],
              [4.260942528137398, -8.585535515503924],
              [4.255098476874506, -8.575719619379571],
              [4.239053075696674, -8.572310316804124],
              [4.228332340808394, -8.561374769011612],
              [4.225826695580085, -8.556481131553854],
              [4.217413372117655, -8.545644005571853],
              [4.21295040154914, -8.537468998052375],
              [4.207173274041759, -8.53597145831466],
              [4.203618530359708, -8.533264121484667],
              [4.199609707634539, -8.53496239223354],
              [4.198882852739709, -8.539292145590313],
              [4.195689055670007, -8.541344000600475],
              [4.190587651384558, -8.538211129622173],
              [4.189063780762987, -8.533992476486059],
              [4.180249784705668, -8.5312733768032],
              [4.178586534452168, -8.52741454903967],
              [4.174052867450925, -8.526413101585256],
              [4.1709167642806255, -8.529935551814967],
              [4.166460283104463, -8.530662969225085],
              [4.153846147553835, -8.526056739333962],
              [4.149243959732745, -8.526447745302228],
              [4.145653921255527, -8.530126163967854],
              [4.137064225246257, -8.53131689053426],
              [4.132075200007831, -8.537004288838881],
              [4.126744890410913, -8.540033051306196],
              [4.121065377011769, -8.54136702608995],
              [4.118727828916984, -8.55338471641428],
              [4.123136068736679, -8.55312795784838],
              [4.125980820316846, -8.558512059770658],
              [4.115646461882629, -8.560465095799842],
              [4.110012621549926, -8.564370933423644],
              [4.104619224886815, -8.569868269168474],
              [4.091702532151259, -8.58066513830302],
              [4.094107063257256, -8.583685550325999],
              [4.078243702544996, -8.607170721237571],
              [4.027635070987901, -8.585747667805217],
              [4.0106695476541985, -8.596911476072243],
              [4.00025747704767, -8.582118551361168],
              [3.962198019052518, -8.583550091958415],
              [3.9748967843067047, -8.536497770286447],
              [3.998059025791234, -8.500920837764012],
              [3.9957033956417347, -8.501028170694237],
              [3.9924538514489383, -8.496065182134254],
              [3.9957113821820998, -8.48847440839639],
              [3.9869919552600166, -8.475680689920424],
              [3.987470365676498, -8.473647732119632],
              [3.98187597639077, -8.468844899981054],
              [3.972935514359808, -8.474076139921117],
              [3.9670646734744186, -8.474289842701927],
              [3.9568485731209884, -8.47092392042491],
              [3.9552659466372675, -8.475839698031645],
              [3.948269558223862, -8.47959715459501],
              [3.9377398069235077, -8.480920558797065],
              [3.9326841148280414, -8.476023669129985],
              [3.933203244801227, -8.467018606395214],
              [3.9317065106135685, -8.46314914420129],
              [3.9325888476142166, -8.449959002258359],
              [3.9341334099568344, -8.44778829127123],
              [3.9408726642887624, -8.446646006050067],
              [3.9504383859960672, -8.446144756310055],
              [3.9544744414270347, -8.433579960485671],
              [3.962163566735115, -8.431668915071665],
              [3.9615752451463515, -8.426041427616065],
              [3.962400093503477, -8.421148424277147],
              [3.9550584776724014, -8.419078282892684],
              [3.948507695935082, -8.421154126936147],
              [3.9442287020554816, -8.417875140704156],
              [3.9393215945550852, -8.410330167727613],
              [3.940624681564375, -8.40659913224974],
              [3.9396423548984694, -8.39985980661606],
              [3.932860745678892, -8.398147878562456],
              [3.955408122687216, -8.381548935056667],
              [3.9485947856684116, -8.351446683023706],
              [3.94266693302416, -8.34614994602798],
              [3.9385029725151885, -8.335028684167348],
              [3.940277054838986, -8.330771548140468],
              [3.9470676509526097, -8.325540174081569],
              [3.9480861423225857, -8.320312440110238],
              [3.945210702064477, -8.31432593046661],
              [3.950800040079961, -8.31077056147652],
              [3.9477012522966524, -8.299373821899865],
              [3.926312115236675, -8.297331699762028],
              [3.9261672451601757, -8.29471132628422],
              [3.9172636326043526, -8.292107133968848],
              [3.919471383706317, -8.284987624686847],
              [3.9229438947971103, -8.278876644427186],
              [3.92119179060593, -8.272060265323498],
              [3.921571382148079, -8.267654218691078],
              [3.9246828565336767, -8.253289010974694],
              [3.9315730339228043, -8.250218205076472],
              [3.9352951277849484, -8.249902055269201],
              [3.9430263060610695, -8.25644439063745],
              [3.9492197202890673, -8.259525738235824],
              [3.951353126003134, -8.259344388860846],
              [3.9569161639770494, -8.263658504944868],
              [3.960719749281893, -8.264336152430248],
              [3.9704006969598273, -8.260427539730426],
              [4.017919139094711, -8.239571119619],
              [4.022522764312642, -8.243539466258955],
              [4.032016873134446, -8.243435484950016],
              [4.035444559356192, -8.249180821119678],
              [4.044653958843095, -8.248350299510415],
              [4.050205310687187, -8.250193669566817],
              [4.050683091303145, -8.252029874464164],
              [4.060638299505102, -8.254826486323548],
              [4.0675698624995364, -8.260222122938421],
              [4.119335127449568, -8.257753928581568],
              [4.122610187594817, -8.257835211216792],
              [4.1826385377701, -8.254654116285838],
              [4.181461061302925, -8.252305174451237],
              [4.169072003671404, -8.248299151650603],
              [4.1648772108058205, -8.2357235926057],
              [4.160191579389402, -8.228517558406791],
              [4.151374909751475, -8.219168845961837],
              [4.148582185044637, -8.20805412833869],
              [4.145979199011336, -8.202528535949234],
              [4.142420228829461, -8.199284059453223],
              [4.130507083539153, -8.200645156313543],
              [4.127738529933373, -8.199224374378367],
              [4.125488762104895, -8.194919302672483],
              [4.124861151857856, -8.186119171829223],
              [4.123380206656485, -8.182012011251636],
              [4.11892029361551, -8.17527266437157],
              [4.117176600576856, -8.17435107656443],
              [4.113855532112888, -8.167781234064364],
              [4.111520128707053, -8.155176100670966]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.60816492783395,
          "lat": 30.129031747163808
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22099"],
        "coty_name": ["St. Martin"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Martin Parish"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01629486"
      },
      "bbox": [
        3.9172636326043526, -8.91818164100001, 4.72255000902051,
        -8.153460516517558
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.170409192337313, -7.683142711172942],
              [4.173019304537975, -7.681882228092784],
              [4.17480657289264, -7.677311559942793],
              [4.183430576620575, -7.666845961719648],
              [4.187920241280114, -7.656711380079329],
              [4.19090265173701, -7.65330055193041],
              [4.201007726216122, -7.6530876539327295],
              [4.274743640945073, -7.649468184404047],
              [4.307735296942791, -7.648619260345873],
              [4.310047259081583, -7.648197153985579],
              [4.373016398222828, -7.645235978704202],
              [4.437707233809829, -7.64191204276206],
              [4.5241784597178905, -7.637388867159569],
              [4.542671829472003, -7.636758951905845],
              [4.584237070552856, -7.634715921784135],
              [4.583428425893233, -7.639829132706971],
              [4.581251746364603, -7.642641238843582],
              [4.581636614013952, -7.655604755624481],
              [4.58000526720819, -7.660319164711763],
              [4.574279860043936, -7.661672823482784],
              [4.5718446549397065, -7.665190100424724],
              [4.569786935461296, -7.671897144528273],
              [4.569611192034345, -7.677677558506032],
              [4.572048536716154, -7.683963744160602],
              [4.571087090624452, -7.688726356663502],
              [4.574506852254191, -7.6935188969683495],
              [4.578399340331885, -7.696412543921442],
              [4.576124942681876, -7.700850800863942],
              [4.572509946616587, -7.702168667096297],
              [4.570113654354597, -7.707500403931034],
              [4.5696298378484705, -7.712435596959734],
              [4.56761271329403, -7.715455303232667],
              [4.561322189607072, -7.71630448541499],
              [4.560583581708215, -7.71983118555147],
              [4.563238914028836, -7.723850823005454],
              [4.561008455977926, -7.729387383116624],
              [4.563378435487928, -7.7345096816773005],
              [4.563610027653988, -7.741427298123055],
              [4.561548142336906, -7.743032825331797],
              [4.556188914321886, -7.741868782956494],
              [4.553736521474686, -7.7428737295155585],
              [4.553627491544126, -7.7502548148895976],
              [4.550943774971405, -7.753324715299346],
              [4.552060054534335, -7.759039587949939],
              [4.549077513496659, -7.765854014840411],
              [4.552739887394318, -7.766519103976177],
              [4.553891417169748, -7.770190438734428],
              [4.551138810424264, -7.778282428934528],
              [4.5462331692762135, -7.780780021121827],
              [4.550380087338491, -7.787855419586016],
              [4.549482167057432, -7.794842624041619],
              [4.546557431520901, -7.8009894815513],
              [4.546029309812392, -7.804846407970524],
              [4.5432663005021805, -7.808917858063428],
              [4.543864825974134, -7.81458858381867],
              [4.547352341788265, -7.818833367439331],
              [4.547276445047397, -7.824187286451646],
              [4.541649959260349, -7.82912480133787],
              [4.537262687766918, -7.830628670198899],
              [4.53643877864897, -7.834944263900015],
              [4.543260754202147, -7.839797128737729],
              [4.543165335199937, -7.844705963187449],
              [4.539953856183614, -7.847848058638345],
              [4.532831658667185, -7.848931333706054],
              [4.531141865424713, -7.853727989385246],
              [4.532018585286388, -7.857821586038807],
              [4.5276691270669405, -7.862627379592637],
              [4.524088270387186, -7.864220598897316],
              [4.521259505343849, -7.873102336204027],
              [4.518287158382263, -7.878581014459113],
              [4.514587142191822, -7.880416212335036],
              [4.5100398149361975, -7.878027154241244],
              [4.507604973352034, -7.879954821861528],
              [4.506047181452554, -7.884895857949292],
              [4.502872195030998, -7.889957045608951],
              [4.502329156321668, -7.896231932011742],
              [4.5035276316775255, -7.901991512399485],
              [4.498682101867135, -7.905184526613173],
              [4.494931140364884, -7.911441392905207],
              [4.499135926006275, -7.918042344759873],
              [4.4910064658998605, -7.922964604218719],
              [4.490888964457618, -7.927969961773998],
              [4.488573375421098, -7.929522890509748],
              [4.4833771361175705, -7.9295326003025055],
              [4.484003548546428, -7.935380196713202],
              [4.482748360249802, -7.93879764909385],
              [4.477627360358936, -7.937517932473272],
              [4.477020746002283, -7.9419115791967565],
              [4.480427534673677, -7.943668737759914],
              [4.483380530007006, -7.954429112368623],
              [4.4870560214725685, -7.956858662900399],
              [4.490204804669699, -7.963427973100669],
              [4.490142974550192, -7.97110444972607],
              [4.491057259916581, -7.980625297111073],
              [4.487009722357847, -7.982887693911376],
              [4.476454899844511, -7.981351813359952],
              [4.468940948428698, -7.979082168808228],
              [4.4652767564817895, -7.977822310867899],
              [4.459988730065324, -7.968026780001018],
              [4.455536881722748, -7.950822359131907],
              [4.453143778894589, -7.944548831147036],
              [4.4519754831969305, -7.9355823361813105],
              [4.4468028754632325, -7.917440785706934],
              [4.438323792774837, -7.900419997534738],
              [4.426281375172171, -7.884545586170694],
              [4.421422219287154, -7.881846648118779],
              [4.4130439367964716, -7.882446770294947],
              [4.407420335487853, -7.8837351145467265],
              [4.397739419108332, -7.888522440998653],
              [4.385760047628267, -7.896819514496318],
              [4.37140073667446, -7.903592222884999],
              [4.362785150617876, -7.907156026520208],
              [4.352627618632043, -7.908164276447016],
              [4.337046077011706, -7.9039880539758425],
              [4.331261541755724, -7.903506946360115],
              [4.311606080926851, -7.905481563624872],
              [4.301657812808988, -7.908195565138784],
              [4.287696911620277, -7.91379512881937],
              [4.2751414804879655, -7.916606148005095],
              [4.269057295885924, -7.916016275766661],
              [4.2593014613001206, -7.912820116243151],
              [4.253446415242122, -7.909297843613617],
              [4.238558229509604, -7.898765431186991],
              [4.236885638310373, -7.891723074903754],
              [4.239313267870659, -7.883248365527142],
              [4.246246709089302, -7.876219304809722],
              [4.252953672445915, -7.873466270040577],
              [4.269298174412679, -7.869791356230465],
              [4.27789550094158, -7.8640312333685864],
              [4.28390068474698, -7.856122546967359],
              [4.286455812796205, -7.845133081931966],
              [4.291067929294333, -7.828329919879966],
              [4.293289555175339, -7.817908344860287],
              [4.295206804668346, -7.8134458866587435],
              [4.296010127876253, -7.807232173345529],
              [4.299524479767757, -7.79556841645667],
              [4.30099116940776, -7.785556360232915],
              [4.300372516870093, -7.77185552067252],
              [4.294687226918026, -7.7573024743142565],
              [4.282749030881205, -7.741743480170234],
              [4.274027823301095, -7.734767511946251],
              [4.2696159369992985, -7.732455465305293],
              [4.260502002307584, -7.730593934837188],
              [4.253260986605964, -7.730652486458572],
              [4.223045054591593, -7.733791977096874],
              [4.21375306013356, -7.733665505318134],
              [4.213728876351283, -7.74432117185981],
              [4.215121915569041, -7.7493109717045385],
              [4.220858327827825, -7.752880150026029],
              [4.231948505855265, -7.754098088138345],
              [4.239541262371851, -7.7541924275136465],
              [4.2478061039926835, -7.756172965923621],
              [4.254264453948109, -7.7601292297607785],
              [4.258938540122588, -7.765675562976941],
              [4.263371914347455, -7.776873604927648],
              [4.266717512905347, -7.7998190025059415],
              [4.264859684413196, -7.808706032613352],
              [4.261190535091856, -7.812168846558108],
              [4.2578202880211125, -7.812029371922823],
              [4.254370032095555, -7.8068203008101],
              [4.2478941971678275, -7.803041540954261],
              [4.239788991480112, -7.802390575596185],
              [4.22696797339482, -7.804316330595941],
              [4.208343428590406, -7.810857144258767],
              [4.198903773500216, -7.809988554014524],
              [4.189443286873243, -7.807051237508968],
              [4.180947219672541, -7.801372948963059],
              [4.176561124041637, -7.7955386123017885],
              [4.176052099084184, -7.792657505403353],
              [4.175376366789024, -7.7579141265254],
              [4.177340241615208, -7.747847886796989],
              [4.181555814104853, -7.734577194003426],
              [4.187331214589352, -7.72355766180395],
              [4.180422299982004, -7.711763389417207],
              [4.175836292572891, -7.701631845673858],
              [4.1715196573673206, -7.689058637076001],
              [4.170409192337313, -7.683142711172942]
            ]
          ],
          [
            [
              [4.09341621109531, -7.638376843893672],
              [4.096892858256711, -7.631834339819109],
              [4.107034538013172, -7.623166717614746],
              [4.11251289182905, -7.616554807083011],
              [4.114728037836909, -7.612109495113693],
              [4.119770700492842, -7.615571929365778],
              [4.127707894681078, -7.614903348537162],
              [4.138163802163428, -7.616104571362882],
              [4.148542187225371, -7.611352954554394],
              [4.165399933444878, -7.6092950137310105],
              [4.1693417395210055, -7.609915830907015],
              [4.176615633350327, -7.614241262783367],
              [4.181272104837935, -7.620508378795534],
              [4.18386893491105, -7.628008349327771],
              [4.183143992315251, -7.632006461613965],
              [4.177139010817197, -7.641699092995879],
              [4.173369392498955, -7.652169298098489],
              [4.172883637775594, -7.659145472640983],
              [4.169486981404978, -7.6551286143621295],
              [4.166825521166529, -7.64895857456033],
              [4.161264569982997, -7.64350650611784],
              [4.152611198607191, -7.638881098696121],
              [4.143853613364875, -7.635617902841951],
              [4.139232378770982, -7.63513985877681],
              [4.133602161262318, -7.636761942146706],
              [4.1312507039449535, -7.6392269966015185],
              [4.1287876329800985, -7.646038950838669],
              [4.124787227753815, -7.648967623767528],
              [4.120270878810567, -7.649209295250099],
              [4.116096673419848, -7.647718798857354],
              [4.107534051216361, -7.642132359407097],
              [4.096976950475146, -7.638161133662367],
              [4.09341621109531, -7.638376843893672]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.42001049271823, "lat": 30.87983538620663 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22125"],
        "coty_name": ["West Feliciana"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["West Feliciana Parish"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00559584"
      },
      "bbox": [
        4.09341621109531, -7.982887693911376, 4.584237070552856,
        -7.6092950137310105
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.003660393764475, 1.5396022440728372],
            [15.003435884670454, 1.546033719265387],
            [15.025902193074733, 1.5813370641979545],
            [15.039192144994193, 1.6008155699081292],
            [15.05453788060443, 1.6252477222218185],
            [15.056998138754244, 1.6286310312181818],
            [15.081108810712488, 1.6659757317273014],
            [15.057570859009834, 1.68230110613446],
            [14.996137935385878, 1.7235660830306176],
            [15.00051560408908, 1.7345511889866123],
            [15.00571636905699, 1.7372401944042513],
            [15.005220108832978, 1.7477488896908302],
            [14.999410762508868, 1.751949817512717],
            [15.002840098191866, 1.7619461584131135],
            [15.01141678308108, 1.7891874904048484],
            [15.021133669234928, 1.8181504151831978],
            [15.032959707210095, 1.8553514252085463],
            [15.039585875638052, 1.8773268584504705],
            [15.040568758613436, 1.8861564543599463],
            [15.037349395540863, 1.8888891429036891],
            [15.045951167650491, 1.8967706527287727],
            [15.048862636621914, 1.9046813988964475],
            [15.061619568400904, 1.8927227126403203],
            [15.067329641659652, 1.8891332537824541],
            [15.072813303282194, 1.8883300669454819],
            [15.0768808817985, 1.889556531829171],
            [15.082958339504943, 1.8891121331280292],
            [15.089255466593935, 1.8870652105219776],
            [15.090729834403598, 1.8845659893676716],
            [15.094108998084616, 1.8787759298693596],
            [15.101291478797364, 1.878341245147094],
            [15.103396606887422, 1.8734445594964277],
            [15.09893594170029, 1.8653644706236994],
            [15.10198588409809, 1.858852093536018],
            [15.09944327544924, 1.855919389761017],
            [15.101425953033518, 1.8504732344077701],
            [15.104251503220793, 1.85233083711693],
            [15.10874846195191, 1.8496789855047262],
            [15.116496844801572, 1.8472245878744047],
            [15.121737018019152, 1.8474188753795928],
            [15.126398072170907, 1.8499423926332788],
            [15.130232291779667, 1.8434591505050695],
            [15.134195200205438, 1.8434299075656007],
            [15.138223024182148, 1.8356082403227498],
            [15.142325957568772, 1.834852958483957],
            [15.144915163724088, 1.837053161986122],
            [15.150526519510427, 1.8372326739929803],
            [15.164008209881153, 1.8297667153127315],
            [15.16677426772958, 1.8327880093371232],
            [15.174703287114834, 1.829941185550872],
            [15.173684603919318, 1.8262140023263898],
            [15.177090527088804, 1.8250474723276964],
            [15.180083522005784, 1.821033275700227],
            [15.180374649159987, 1.8143153182586576],
            [15.186133785616263, 1.810781603757582],
            [15.190938600243573, 1.8058776772003917],
            [15.194132219426184, 1.8067965485379935],
            [15.198475984220584, 1.8046953082160582],
            [15.19782042570893, 1.8003725507705197],
            [15.201437908167815, 1.8007070793673952],
            [15.212046588075538, 1.7963998384731175],
            [15.21530571237323, 1.7925039694432467],
            [15.221879871303424, 1.7885011537203852],
            [15.21988078534282, 1.784021981229388],
            [15.221773529007493, 1.7744130792197914],
            [15.224151337620691, 1.7737968598113203],
            [15.225785786527023, 1.7675575481715646],
            [15.230615153708694, 1.7624786814026399],
            [15.232240700930568, 1.7573111450091679],
            [15.231607358093175, 1.753404431956785],
            [15.236235729466438, 1.7472105908666595],
            [15.236282693076422, 1.7425670124754116],
            [15.23932702669544, 1.7403293718302861],
            [15.245428365216949, 1.7392367312156158],
            [15.245158238267482, 1.7340609273579972],
            [15.239880109529352, 1.7313942578961643],
            [15.24534614256497, 1.725548162596404],
            [15.246895895780124, 1.7268504143367938],
            [15.251450511726501, 1.7228869979486041],
            [15.25184687478515, 1.7192024000696529],
            [15.259888953378477, 1.7145606566128282],
            [15.259407836291182, 1.7093019279797577],
            [15.2565264452179, 1.7051323683587736],
            [15.257318174845896, 1.7011334837814989],
            [15.261533177524798, 1.6965581971056647],
            [15.259394731164285, 1.6951261447451336],
            [15.26036220856324, 1.6853288902158146],
            [15.25727170426182, 1.6751674725836043],
            [15.253982361070113, 1.6722600308611286],
            [15.252225244817515, 1.6663903909882951],
            [15.253734085193306, 1.6617435304762627],
            [15.251143904042376, 1.6537528144345108],
            [15.250865423392167, 1.6429931561505178],
            [15.256255983868055, 1.629620554299741],
            [15.256609496965154, 1.6256332438461785],
            [15.253635080978041, 1.6216761069335812],
            [15.247705962972825, 1.6212042539676765],
            [15.24620679682807, 1.617453132342225],
            [15.251154248096457, 1.608363093190155],
            [15.251306544958046, 1.6010667696685275],
            [15.258175678582491, 1.5967032523168059],
            [15.256413250583671, 1.5914643237158406],
            [15.252062596699835, 1.5892203992179668],
            [15.251176668858687, 1.5853336375118783],
            [15.253760285292724, 1.5798357170928836],
            [15.263788534206778, 1.5755481011156933],
            [15.268179336839736, 1.5606468035487457],
            [15.272803580664215, 1.5569335426038011],
            [15.278953094280672, 1.557779462892179],
            [15.280397254942095, 1.5564816340502892],
            [15.282787174192023, 1.5481327427797795],
            [15.281023616329218, 1.5452435567136298],
            [15.275851432861476, 1.5441928618413818],
            [15.275444019705855, 1.5396085756816522],
            [15.278313370246561, 1.5332091010379765],
            [15.274808134388023, 1.518165932120075],
            [15.27878085590385, 1.5150324968998332],
            [15.282239416836141, 1.5088160140990508],
            [15.281132184538535, 1.502894163643382],
            [15.281639565201226, 1.4985269629682532],
            [15.284814308191493, 1.494375986649097],
            [15.292029904820481, 1.4913169702400082],
            [15.291086866090414, 1.48319948121459],
            [15.284946896638992, 1.4792825774198377],
            [15.286034359738403, 1.474003098308756],
            [15.290232898843312, 1.4728804691589508],
            [15.295442889239927, 1.4739039219783494],
            [15.299036415589939, 1.4719491018329713],
            [15.29898030332566, 1.4653343281762938],
            [15.29533077375347, 1.4581258232873824],
            [15.296862900923639, 1.4460027905365775],
            [15.302821534524648, 1.4410894797285767],
            [15.309620286315289, 1.4392354340032405],
            [15.316264303052114, 1.430516639095103],
            [15.317493645956542, 1.420170536638095],
            [15.3198193893181, 1.4124271434364948],
            [15.319302624160901, 1.4049357376468612],
            [15.317437712144475, 1.3974448182289092],
            [15.317471710359527, 1.3925952421242125],
            [15.321329323901228, 1.3850158262016325],
            [15.321459148634897, 1.37922945657264],
            [15.32951308071897, 1.366507985719882],
            [15.330451481217084, 1.3605552437251272],
            [15.330547140694941, 1.3492967924957515],
            [15.328494440060169, 1.3483542495024137],
            [15.319294428991892, 1.348784127071295],
            [15.316510966635837, 1.3518564340644856],
            [15.3092653710446, 1.3539834021237787],
            [15.299867765224137, 1.3552395209901065],
            [15.297620152575231, 1.3568394983503618],
            [15.291107491371836, 1.357171935449045],
            [15.276543518967799, 1.361680769830176],
            [15.274321929718003, 1.3757904474632792],
            [15.271527048533526, 1.379105719164711],
            [15.267685625609891, 1.3964915102879842],
            [15.263695628922221, 1.4013122731416459],
            [15.263052919576536, 1.406913131005186],
            [15.259283245731227, 1.418589869163988],
            [15.252952515527536, 1.420195317006886],
            [15.250558308591424, 1.4193608307686962],
            [15.218150890937688, 1.4278343743094912],
            [15.163167273544266, 1.4413382716288963],
            [15.159089837388466, 1.4399191744884967],
            [15.151275661775925, 1.4394258902812138],
            [15.146197732227947, 1.436963991813219],
            [15.143385238428436, 1.4336598491474686],
            [15.13746857884691, 1.4320888668101668],
            [15.133378148150207, 1.4281201184919936],
            [15.128151206774318, 1.4284354843699498],
            [15.123881361905855, 1.427144241585384],
            [15.115339571094657, 1.4278296392636582],
            [15.106242242793845, 1.4257114818383734],
            [15.10003302016981, 1.4289255751909087],
            [15.094137047543942, 1.427237838167724],
            [15.085048312764487, 1.4282893787407216],
            [15.080548550865823, 1.4244779664417615],
            [15.077172502234056, 1.424032163327363],
            [15.068055692097593, 1.4198756560220382],
            [15.066507575197026, 1.4202643569515032],
            [15.056820727125276, 1.413781612618548],
            [15.052593447856118, 1.4121378417293853],
            [15.04743986082261, 1.4075271589919403],
            [15.045980045248779, 1.4005878316385325],
            [15.043659055243566, 1.3965517544159833],
            [15.042834190827527, 1.3913105881397667],
            [15.03633667832626, 1.3862233370964863],
            [15.035838163930586, 1.3819597816580051],
            [15.032281694330715, 1.375258508975037],
            [15.029151537156741, 1.375204915248739],
            [15.019539346891376, 1.3927864892731499],
            [14.992953907954643, 1.4434835342696448],
            [14.984767033166396, 1.454100884997192],
            [14.988957330614268, 1.458016648269004],
            [14.989503990065812, 1.462675277576768],
            [14.994889272732344, 1.460320210501517],
            [15.009039435326962, 1.4630015593970713],
            [15.013440793523591, 1.4685412508663314],
            [15.014752883367725, 1.4735229091431394],
            [15.014710828586022, 1.4806190912826973],
            [15.011032675409922, 1.495709052152319],
            [15.003660393764475, 1.5396022440728372]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.84725663122376,
          "lat": 38.829481839026535
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24033"],
        "coty_name": ["Prince George's"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prince George's County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01714670"
      },
      "bbox": [
        14.984767033166396, 1.3483542495024137, 15.330547140694941,
        1.9046813988964475
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.753566051396078, 6.020650820812318],
              [18.763521769215263, 6.020225341035554],
              [18.782230294547638, 6.0159244749021275],
              [18.786705241752973, 6.0115972852111135],
              [18.788755900827073, 6.012290493043599],
              [18.78701114397405, 6.009309138776912],
              [18.787512470517484, 6.002464907078209],
              [18.79163691701596, 6.00032141264676],
              [18.78788953145779, 5.9953296511093885],
              [18.790145385219184, 5.985782000493009],
              [18.769065988793063, 5.957240955363489],
              [18.756028579215897, 5.9665201314202045],
              [18.740122437741384, 5.9897142361456615],
              [18.747816285229867, 5.9956667514024895],
              [18.741000644610605, 5.997963703281129],
              [18.739975611879004, 6.002676205792439],
              [18.740851804741535, 6.011507926524369],
              [18.743541586125573, 6.012817021634859],
              [18.745688143668712, 6.017208050249136],
              [18.752329308864518, 6.018691997506929],
              [18.753566051396078, 6.020650820812318]
            ]
          ],
          [
            [
              [18.500890537507857, 6.019790842402073],
              [18.504881757548468, 6.025251938838543],
              [18.50748125673178, 6.031526393292288],
              [18.512342991645447, 6.039039593412916],
              [18.51954569460795, 6.047007957239459],
              [18.53160190749286, 6.048200979068036],
              [18.533939369943635, 6.042502156729161],
              [18.531223824469464, 6.038247266032301],
              [18.532218811196667, 6.034121224357006],
              [18.531301188978496, 6.021202224489162],
              [18.526530324524753, 6.01866350166604],
              [18.5232305644358, 6.007899107697088],
              [18.520232618158246, 5.995667825313331],
              [18.513698672734556, 5.986094193777861],
              [18.50235933325829, 5.992656135375351],
              [18.489532073681872, 6.000112811473611],
              [18.500890537507857, 6.019790842402073]
            ]
          ],
          [
            [
              [18.317597799946565, 5.791458243045264],
              [18.327280410717375, 5.795469218074229],
              [18.337178328128754, 5.815362928318737],
              [18.34590683430306, 5.822317793634785],
              [18.350943054240595, 5.822342487099105],
              [18.365895211599323, 5.82696570947785],
              [18.36189472418879, 5.835899804064488],
              [18.37911587311749, 5.845658697613474],
              [18.390193341651006, 5.850951995686662],
              [18.40158775948291, 5.859080278262574],
              [18.394186946861904, 5.864036415581245],
              [18.3940330986248, 5.870814115192493],
              [18.395866128694628, 5.872995267135349],
              [18.401183883979645, 5.872621061754539],
              [18.40134981212028, 5.875795330072486],
              [18.397159369752874, 5.878542580223414],
              [18.397693934947277, 5.882682414716746],
              [18.403450411462778, 5.893379227602953],
              [18.401291373312475, 5.897219974662126],
              [18.400540292389604, 5.905017688123163],
              [18.397390840058915, 5.908095190094667],
              [18.418612972508654, 5.9128738408032175],
              [18.408875730972408, 5.933545703477117],
              [18.391174542349106, 5.956536654847256],
              [18.382826817653843, 5.970467746839899],
              [18.421363617533643, 5.996296834317729],
              [18.431212367198643, 5.995171299327037],
              [18.433787550626096, 5.998209614365675],
              [18.439619715962408, 5.993854567149304],
              [18.445376300969574, 5.99613691006885],
              [18.45098055690678, 5.99652053871687],
              [18.453354136446897, 5.995201056200772],
              [18.457215904381695, 5.985245942812306],
              [18.462080696827076, 5.984626821941275],
              [18.467278540063244, 5.985751288808921],
              [18.470161732234946, 5.979852354591336],
              [18.473444871616373, 5.978057531340169],
              [18.477290222543576, 5.971213897544386],
              [18.488932847813246, 5.967491017779021],
              [18.494058394196458, 5.965230694210438],
              [18.496514955864388, 5.962169001697106],
              [18.5023043727431, 5.963802206568382],
              [18.505221473550247, 5.9586637227741095],
              [18.504546043710278, 5.9564889305950635],
              [18.51936390377809, 5.946729129930318],
              [18.523151474333872, 5.950941995664213],
              [18.527688908687395, 5.949566479449382],
              [18.535645047595015, 5.93120381635564],
              [18.546227310700186, 5.925638154296739],
              [18.549015579386214, 5.932705989476944],
              [18.546402513295003, 5.9373488458291135],
              [18.55619764651127, 5.949111333834526],
              [18.55412314711366, 5.9562526546531505],
              [18.551366357101628, 5.961071209482841],
              [18.55716892673721, 5.961533890111309],
              [18.560685627894483, 5.965961255440441],
              [18.564700487513875, 5.9738754836154655],
              [18.5696912781305, 5.974112511442821],
              [18.57365236886966, 5.977113646132171],
              [18.581702239006376, 5.979418612928228],
              [18.584680482888036, 5.976585440431806],
              [18.58942421034964, 5.982559718146641],
              [18.587314008105665, 5.985472160842819],
              [18.590615328156616, 5.989514374999479],
              [18.594587963253584, 5.988674721098991],
              [18.596441461510018, 5.991069587478957],
              [18.597172492571424, 5.998125442703644],
              [18.60053085316455, 6.000663609869805],
              [18.599155288958258, 6.004172237791108],
              [18.59248657966496, 6.01286224935685],
              [18.59375732537666, 6.014502051758703],
              [18.60197620603276, 6.014943900230086],
              [18.606436675836274, 6.0105884281513395],
              [18.609967277319747, 6.017989227430658],
              [18.616377410139467, 6.019732066362289],
              [18.61839713472212, 6.013929596291444],
              [18.613735976378678, 6.008229700539384],
              [18.60837553954189, 6.007114517840441],
              [18.607488798859674, 6.0044853657797495],
              [18.614052756862016, 5.99758431596233],
              [18.628627249114015, 5.993783251375043],
              [18.631746070232715, 5.9888408288768264],
              [18.640009642785582, 5.988472713618647],
              [18.642994626686043, 5.9902795887566045],
              [18.64882125038912, 5.989447069504393],
              [18.653271151162418, 5.9968240171106535],
              [18.658943390588433, 6.000235017583387],
              [18.65939487855965, 6.004503216555218],
              [18.66297004986084, 6.0048528094710845],
              [18.66476169631908, 5.991180920101308],
              [18.65886283160009, 5.991712799383461],
              [18.655551594409502, 5.9858136208475745],
              [18.66234204648964, 5.984755167519479],
              [18.660438474463543, 5.977364500349908],
              [18.66329549774508, 5.974992645599591],
              [18.673105600010885, 5.984651715902685],
              [18.6768425288854, 5.990545074360403],
              [18.68303764294197, 5.9927928177101695],
              [18.683174609854, 5.9990089031050085],
              [18.680886596150316, 6.004441724782166],
              [18.685616095269218, 6.008503297942256],
              [18.692809886605126, 6.0067289569667],
              [18.694553365187122, 6.003494266085441],
              [18.68830732643947, 6.000968796863313],
              [18.690706105216304, 5.993005978710359],
              [18.6805846924715, 5.987220991142639],
              [18.683587795189887, 5.979372392931623],
              [18.689460804201914, 5.973171997725199],
              [18.69384388649911, 5.966570307939533],
              [18.69395562063976, 5.963073648444376],
              [18.700370994265036, 5.963983371681461],
              [18.710909453190673, 5.896755505771534],
              [18.66390733469613, 5.8527368116784295],
              [18.66423761194599, 5.852018190813467],
              [18.616482775073187, 5.807103638853544],
              [18.581041593990836, 5.774040576471482],
              [18.562647965853987, 5.757098485030644],
              [18.48955484107524, 5.689270778005598],
              [18.44283962263508, 5.6466769933654595],
              [18.430678844270286, 5.643252757165724],
              [18.422028087409416, 5.675926347112304],
              [18.339091891585493, 5.652476214109241],
              [18.319622570551537, 5.726332141792537],
              [18.319792011288314, 5.733160699979122],
              [18.31592314345176, 5.735801409228611],
              [18.311764529338152, 5.741751367574824],
              [18.31306500206218, 5.744589616191086],
              [18.31132408333028, 5.748258900491637],
              [18.317454915249026, 5.758215596851137],
              [18.323837689712917, 5.766775150906893],
              [18.317597799946565, 5.791458243045264]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.21195514832965, "lat": 42.16019889902004 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25021"],
        "coty_name": ["Norfolk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Norfolk County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00606937"
      },
      "bbox": [
        18.31132408333028, 5.643252757165724, 18.79163691701596,
        6.048200979068036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.248978546540062, 5.940007505128559],
            [8.298757124457232, 5.944730208961642],
            [8.345267808437937, 5.9489603992429645],
            [8.397361083777541, 5.954348362873812],
            [8.416702601678761, 5.9565752491941995],
            [8.46260499531397, 5.961491468782925],
            [8.534921726835073, 5.969914876057351],
            [8.5897656086822, 5.976184389462582],
            [8.594051753956359, 5.94663755612212],
            [8.608022929145095, 5.834707210642264],
            [8.61172875165706, 5.806187433661564],
            [8.621967945242108, 5.719966399654703],
            [8.63265882662897, 5.634224577284736],
            [8.545357681058123, 5.623443474706674],
            [8.432229882003858, 5.609157049818969],
            [8.373754414736698, 5.602079198309859],
            [8.34530812755966, 5.598988824517697],
            [8.288283354133402, 5.592123758541459],
            [8.285216151270951, 5.620418871896338],
            [8.283993267631296, 5.635284331671801],
            [8.280313173830844, 5.664247600693046],
            [8.269335261953676, 5.7612409726450355],
            [8.268693103275039, 5.768524507909457],
            [8.259249761520072, 5.8501775097261435],
            [8.25772523048473, 5.8644594874053135],
            [8.248978546540062, 5.940007505128559]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.84784068126856, "lat": 43.98789812736964 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26035"],
        "coty_name": ["Clare"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clare County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01622960"
      },
      "bbox": [
        8.248978546540062, 5.592123758541459, 8.63265882662897,
        5.976184389462582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.418908056632992, 4.556180461845094],
            [8.504778851084593, 4.56579102686834],
            [8.590836687392802, 4.575877855846595],
            [8.675854387010839, 4.585691054110043],
            [8.712635086696059, 4.589740580911172],
            [8.760696985141008, 4.595462872075323],
            [8.767718792908529, 4.535236479077056],
            [8.776163135064275, 4.466362557346999],
            [8.789305906979742, 4.365122486761841],
            [8.798825367896216, 4.292594794910221],
            [8.804292589099012, 4.249146690551254],
            [8.71835525587027, 4.2384029141611155],
            [8.66114691705457, 4.231738081330097],
            [8.582468708873744, 4.222937196636854],
            [8.508923248349646, 4.214247081748835],
            [8.461151080981143, 4.208202509075379],
            [8.453319251736893, 4.265994805058415],
            [8.446860264032145, 4.3152532641218295],
            [8.440245220909945, 4.367888502315843],
            [8.4332121763156, 4.42549053609713],
            [8.427999549873913, 4.46919584843011],
            [8.418908056632992, 4.556180461845094]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.83831577564396,
          "lat": 42.596072323328734
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26045"],
        "coty_name": ["Eaton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eaton County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01622965"
      },
      "bbox": [
        8.418908056632992, 4.208202509075379, 8.804292589099012,
        4.595462872075323
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.341780435504313, 5.147035602562195],
            [7.388042719002098, 5.15185254262664],
            [7.4646549509831885, 5.157405376769605],
            [7.510281293352585, 5.160987525168654],
            [7.559805467614782, 5.165647340546466],
            [7.645534196792943, 5.173269010284536],
            [7.647961022859189, 5.151700864363509],
            [7.654916494520109, 5.0869002774396535],
            [7.664204940570942, 5.000173734832329],
            [7.721268124346546, 5.006051472232655],
            [7.749906167706293, 5.008846893274225],
            [7.828715148410142, 5.017013565996195],
            [7.843212418929938, 5.018647882473864],
            [7.852523722406783, 4.931183419069549],
            [7.7882997627419455, 4.925128753645278],
            [7.767564207869043, 4.922867357007848],
            [7.777522230719946, 4.836278352008571],
            [7.6983670132056705, 4.8275444849417815],
            [7.605306556977176, 4.816677807398305],
            [7.562594469839937, 4.8126333176545755],
            [7.51433249377861, 4.808283049246345],
            [7.506194098418225, 4.82522523601323],
            [7.490966891160179, 4.853864020399126],
            [7.466274918430716, 4.895757145806707],
            [7.460248170466791, 4.904892249593258],
            [7.456448824275493, 4.908341527492149],
            [7.45200922772029, 4.915914659399798],
            [7.447541017858392, 4.926631604248862],
            [7.439330764746562, 4.939252563176916],
            [7.429489545286407, 4.9564993673334135],
            [7.404882638065104, 4.996343906652466],
            [7.393093749218571, 5.021529523123737],
            [7.380976417249443, 5.045263386638253],
            [7.376409354625851, 5.052553599262516],
            [7.374130760573607, 5.06221604010771],
            [7.368397530502838, 5.0736402523015265],
            [7.355039766592749, 5.107818815685955],
            [7.341780435504313, 5.147035602562195]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.15200688155258, "lat": 43.29124514753075 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26121"],
        "coty_name": ["Muskegon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Muskegon County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01623003"
      },
      "bbox": [
        7.341780435504313, 4.808283049246345, 7.852523722406783,
        5.173269010284536
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.14238337826987982, 5.874179796273672],
            [0.1429645558598693, 5.961624931681519],
            [0.23874685723640812, 5.960602170704237],
            [0.31088997394504675, 5.961022321183461],
            [0.33877083280207804, 5.960818712038627],
            [0.39773922447654964, 5.960037961711893],
            [0.3974832073543672, 5.933013054117703],
            [0.39756243013004233, 5.874229943979071],
            [0.4065693985908552, 5.872936409605137],
            [0.4069131051434225, 5.840472859108075],
            [0.4068746881726379, 5.78910500072955],
            [0.40720895021787223, 5.745463319913253],
            [0.4071722592749074, 5.701740388355573],
            [0.40732525529056185, 5.665640574365864],
            [0.40717031419780686, 5.614361308678429],
            [0.40758320940542286, 5.527161371648623],
            [0.33235415717769023, 5.5277330736258],
            [0.28879659956855136, 5.528261220318772],
            [0.2153590664595324, 5.5282643890173375],
            [0.1419215733564132, 5.528254605044084],
            [0.1401688452901463, 5.528065157286642],
            [0.1406917151977728, 5.613847593095413],
            [0.14103764155866536, 5.629770308722257],
            [0.14107323292886753, 5.657054714924263],
            [0.14211054926412414, 5.7911645117175405],
            [0.1419530121713898, 5.803774640131865],
            [0.14238337826987982, 5.874179796273672]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.26712339959661, "lat": 44.41259957699138 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27081"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00659486"
      },
      "bbox": [
        0.1401688452901463, 5.527161371648623, 0.40758320940542286,
        5.961624931681519
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.07123911518028396, 7.257937844817463],
            [0.07292855273072563, 7.268247585292703],
            [0.07054125535478432, 7.272912017742514],
            [0.07021303994969469, 7.279825944959704],
            [0.06816209629471581, 7.281179433096854],
            [0.06675903187623927, 7.286056791891904],
            [0.06544337492020659, 7.302544097834434],
            [0.06472680234825223, 7.324416445793982],
            [0.06318635513789295, 7.330061174044317],
            [0.06435428158086272, 7.338517980245187],
            [0.06278307062119066, 7.343776906959043],
            [0.10633622224912011, 7.3435234924198625],
            [0.1927542817599347, 7.342838764362264],
            [0.2786598431295033, 7.3425943314669295],
            [0.27835020959163864, 7.299471651756325],
            [0.2784029122121237, 7.256516585769368],
            [0.28709649762779127, 7.256431573967838],
            [0.2867335527447851, 7.234155802335693],
            [0.28664297134877953, 7.169495113185318],
            [0.28638806686071566, 7.08314214314632],
            [0.2861743347903556, 6.99676721623029],
            [0.2866196649522318, 6.910228246648455],
            [0.2585145319873657, 6.910351096048137],
            [0.25188085176740344, 6.910020391102751],
            [0.16417565308797202, 6.910696459894067],
            [0.10602111732456956, 6.910873455368506],
            [0.04579008916776663, 6.911495952199217],
            [0.018381055813483337, 6.911654628114313],
            [-0.0689662885533693, 6.9125570240564045],
            [-0.12107075244992178, 6.913144306277281],
            [-0.13650126456715647, 6.932964693629121],
            [-0.13267162102838911, 6.941741151972986],
            [-0.13209122037067897, 6.946273157857477],
            [-0.1267278981125768, 6.966241775496273],
            [-0.12425393223486568, 6.971886791335657],
            [-0.11854202037459267, 6.97820896383384],
            [-0.11397608639468947, 6.980598331503524],
            [-0.09567306123907315, 6.994522685744055],
            [-0.06805151200217126, 7.013308749732217],
            [-0.06061284662652187, 7.024423967178745],
            [-0.05691248976317588, 7.02716663012966],
            [-0.033084438878454, 7.0428412872737995],
            [-0.01630431534482527, 7.051020619503397],
            [-0.006089333851284535, 7.057300696867932],
            [0.000988252064523696, 7.063545237828244],
            [0.008285508342682758, 7.071555102962363],
            [0.015555654482876474, 7.084459533158254],
            [0.017869407055011, 7.094657944193861],
            [0.027325363660702484, 7.112198859786426],
            [0.03632444836185154, 7.118603351496711],
            [0.039766941591524066, 7.123169988927845],
            [0.04746413608533895, 7.135743557067486],
            [0.0541975896362425, 7.140305967158778],
            [0.05701537942590307, 7.143836868061859],
            [0.05938394087431718, 7.149568333688782],
            [0.0610016731319421, 7.156783252277796],
            [0.06099607652297569, 7.161563251296118],
            [0.06313116836011803, 7.166673231021599],
            [0.06431155379560913, 7.185007285517274],
            [0.06316983779762604, 7.190181918277218],
            [0.06514899254926475, 7.19515536864794],
            [0.06463319790231238, 7.199745203738198],
            [0.06559837068483151, 7.209847161901266],
            [0.06740595002947251, 7.211222843857524],
            [0.06781297126173959, 7.225916655432645],
            [0.07056509551041704, 7.232354282340196],
            [0.06656427138532804, 7.234978100320264],
            [0.06751948610525085, 7.239974398490952],
            [0.07091640156653815, 7.242404720705952],
            [0.07123911518028396, 7.257937844817463]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.47158520657638,
          "lat": 45.772178971744914
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27155"],
        "coty_name": ["Traverse"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Traverse County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00659522"
      },
      "bbox": [
        -0.13650126456715647, 6.910020391102751, 0.28709649762779127,
        7.343776906959043
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.422028343698391, -6.296941907320288],
            [6.511830796379438, -6.289552645147147],
            [6.543133584406095, -6.286497756674448],
            [6.584603825318025, -6.283709719235191],
            [6.665621144387327, -6.27629253032832],
            [6.708360507090549, -6.272595330220096],
            [6.826667990946857, -6.2623956713042155],
            [6.824878307969032, -6.317509966838827],
            [6.821726266323471, -6.45110123032887],
            [6.8187465623019365, -6.5580393114052145],
            [6.8180258561115785, -6.597460257144682],
            [6.745174765941418, -6.624996992816433],
            [6.695207175275581, -6.6437447771109195],
            [6.6800116025256715, -6.64820100618098],
            [6.577954671373907, -6.673990939100008],
            [6.501816690143494, -6.685384829475044],
            [6.4546413968263225, -6.692529045529593],
            [6.450998383133466, -6.647659723366387],
            [6.450532940019807, -6.644301110296869],
            [6.446936526518815, -6.599759583531671],
            [6.444383595291532, -6.572833881977181],
            [6.4433753916641265, -6.557143007147559],
            [6.432614835626742, -6.432724237510633],
            [6.428565650256786, -6.38186911575809],
            [6.4259826418000685, -6.3462216475081545],
            [6.4237829695223425, -6.325120688371335],
            [6.422028343698391, -6.296941907320288]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.68942035730282, "lat": 32.04139396232107 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28023"],
        "coty_name": ["Clarke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarke County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00695736"
      },
      "bbox": [
        6.422028343698391, -6.692529045529593, 6.826667990946857,
        -6.2623956713042155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.078890520396829, -6.322395127335344],
            [6.193762687250738, -6.313956426268087],
            [6.250962218534866, -6.309673563152136],
            [6.364902221760121, -6.30129800422325],
            [6.422028343698391, -6.296941907320288],
            [6.4237829695223425, -6.325120688371335],
            [6.4259826418000685, -6.3462216475081545],
            [6.428565650256786, -6.38186911575809],
            [6.432614835626742, -6.432724237510633],
            [6.4433753916641265, -6.557143007147559],
            [6.444383595291532, -6.572833881977181],
            [6.446936526518815, -6.599759583531671],
            [6.450532940019807, -6.644301110296869],
            [6.450998383133466, -6.647659723366387],
            [6.4546413968263225, -6.692529045529593],
            [6.427049671785723, -6.696657109202859],
            [6.385524676285687, -6.702840223372123],
            [6.374745265026729, -6.704199422369866],
            [6.331221731553271, -6.710583369986679],
            [6.312877893060729, -6.712987685321935],
            [6.284469729619004, -6.717510250070682],
            [6.2729306998979615, -6.718944372778908],
            [6.237938996658111, -6.724060618928804],
            [6.201118001371971, -6.729188360741778],
            [6.179954327016847, -6.732538288446462],
            [6.167654148837739, -6.734017972543148],
            [6.113788748871731, -6.741664151685668],
            [6.108248184687714, -6.669826156369888],
            [6.105157961269915, -6.6700092601408905],
            [6.104075791848457, -6.659270716107428],
            [6.095125953950245, -6.54483197090483],
            [6.087272499652549, -6.439682492673335],
            [6.078890520396829, -6.322395127335344]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.1188624020175, "lat": 32.019128188746265 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28061"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00695754"
      },
      "bbox": [
        6.078890520396829, -6.741664151685668, 6.4546413968263225,
        -6.296941907320288
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.560865874825987, -6.818848798611539],
            [5.592686921727096, -6.814638171097928],
            [5.640638406795189, -6.808533133481516],
            [5.745415017183898, -6.794011863648116],
            [5.750751625601968, -6.878522945368023],
            [5.755856392506959, -6.958106278290638],
            [5.773172823691609, -6.956385102330472],
            [5.777028295620967, -6.959387908082145],
            [5.77802340552725, -6.962462269997518],
            [5.782269666443912, -6.966437063425025],
            [5.782704506910976, -6.968855831616732],
            [5.78833109820432, -6.972715668605935],
            [5.789893121368887, -6.976684462166328],
            [5.7989982164083225, -6.980177006567819],
            [5.803485210491221, -6.983678209047248],
            [5.806006416459035, -6.987353657586578],
            [5.813747974549119, -6.98782597378124],
            [5.817004986089959, -6.99060748157335],
            [5.824998542103971, -6.994813714613001],
            [5.828782267876402, -6.998335961336257],
            [5.833445156966198, -6.997320113028095],
            [5.839096697429186, -6.9998501843557275],
            [5.859693056600965, -7.002057879940757],
            [5.863882969372867, -7.0041601241172495],
            [5.866916016091974, -7.008006249427495],
            [5.87129059962192, -7.008933184053765],
            [5.876834543458067, -7.013820962201898],
            [5.878332311910956, -7.017104845962631],
            [5.883908254714427, -7.020480775627836],
            [5.889886663260909, -7.0200790223910445],
            [5.893183091597699, -7.024042244788832],
            [5.890915764189106, -7.0274888633702695],
            [5.896118993527842, -7.032647589867317],
            [5.895982449792663, -7.041717016635729],
            [5.8979594498764945, -7.044671556995902],
            [5.9028254605497, -7.04196561205297],
            [5.905131074079564, -7.044417592056035],
            [5.9106144389632105, -7.123688723771176],
            [5.883098118926034, -7.125255656849558],
            [5.853453580943152, -7.127384745937119],
            [5.781530953982022, -7.132157738140745],
            [5.709233207465926, -7.136537588513475],
            [5.712872996140005, -7.180290689381767],
            [5.655446469365717, -7.183470321483092],
            [5.597756060460223, -7.187174757336449],
            [5.592771955452483, -7.109779766464564],
            [5.589210333120984, -7.056024808373731],
            [5.574840412008947, -7.05687526674628],
            [5.573044402650925, -7.028324516067652],
            [5.569200913996073, -6.95462175786004],
            [5.562705824138305, -6.852311898369969],
            [5.560865874825987, -6.818848798611539]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.82298191445057,
          "lat": 31.569677752680672
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28065"],
        "coty_name": ["Jefferson Davis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jefferson Davis County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00695756"
      },
      "bbox": [
        5.560865874825987, -7.187174757336449, 5.9106144389632105,
        -6.794011863648116
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.545797078311333, 10.203372665625569],
            [-3.540167897200136, 10.287575099636245],
            [-3.533509192436391, 10.389535736180495],
            [-3.4465725790115873, 10.38421975802262],
            [-3.3597081001997045, 10.379026285709832],
            [-3.271076324530801, 10.373848883548284],
            [-3.185574878867753, 10.36938052920787],
            [-3.1915677171429504, 10.266440740847205],
            [-3.1965946353160852, 10.182342049396535],
            [-3.201632488247776, 10.097970709351486],
            [-3.171236574904211, 10.096184858909716],
            [-3.1771504108143325, 9.997473828849378],
            [-3.1812519628996863, 9.92703795570585],
            [-3.132735097830454, 9.924120854294353],
            [-3.057052512035998, 9.919804369900882],
            [-3.0561049605484927, 9.919627656192661],
            [-2.9878983003414055, 9.915887840800815],
            [-2.919692561986465, 9.91213229301621],
            [-2.924386454279673, 9.82745529242493],
            [-3.0323113402662942, 9.83340483516338],
            [-3.0989437585253157, 9.837198094115807],
            [-3.1863021237567803, 9.842266713363355],
            [-3.26553723876523, 9.846910592805617],
            [-3.3318738414285147, 9.850915306643069],
            [-3.4480192278622606, 9.858129492585064],
            [-3.4427608833746146, 9.942789386078884],
            [-3.438248956594075, 10.013181852566559],
            [-3.4317825950763834, 10.111488892576185],
            [-3.551088638215603, 10.11904238475947],
            [-3.545797078311333, 10.203372665625569]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.65778162484979,
          "lat": 48.71901483577597
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38075"],
        "coty_name": ["Renville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Renville County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01034229"
      },
      "bbox": [
        -3.551088638215603, 9.82745529242493, -2.919692561986465,
        10.389535736180495
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.645961852232912, 3.117566016248974],
            [10.653071637644546, 3.118844312164031],
            [10.68044876589794, 3.1223255447382736],
            [10.70399735706139, 3.1249302189772075],
            [10.768386423645316, 3.133107431957331],
            [10.77744930315448, 3.061723173369511],
            [10.810096102699882, 3.0662273343368214],
            [10.814513829684602, 3.038780354219736],
            [10.819158334203227, 3.011949426190409],
            [10.819748318378466, 3.0047159016840426],
            [10.824489813254706, 2.975817935389038],
            [10.828780370129635, 2.9615469088547215],
            [10.833697434996026, 2.925661595899732],
            [10.8390907969327, 2.8795747345616673],
            [10.851303043800028, 2.802243772590426],
            [10.859866710544935, 2.7442592826549057],
            [10.833665910437208, 2.7397018220775955],
            [10.789384946162038, 2.7329256299922453],
            [10.79743522298823, 2.6812300066417127],
            [10.804469303033597, 2.634146432313978],
            [10.766331842146405, 2.6224420434438342],
            [10.719410776639133, 2.608366672177859],
            [10.708459970192761, 2.676581172276822],
            [10.692930118123627, 2.779317321050789],
            [10.671873131436044, 2.7763009535373477],
            [10.66372258373973, 2.775571474959481],
            [10.655777037752431, 2.8293152959647636],
            [10.654654585788844, 2.8354145858202577],
            [10.651778715411762, 2.836383233128882],
            [10.649848829285746, 2.8398829216922343],
            [10.645410028036098, 2.8430375431163517],
            [10.64450247862472, 2.8552645429082557],
            [10.630228613108319, 2.853289654403671],
            [10.629141936277733, 2.8595648406157363],
            [10.622569682310417, 2.858619984700007],
            [10.619198515578645, 2.8667068594920955],
            [10.620718299529269, 2.873658680002907],
            [10.614172766128801, 2.921405551203706],
            [10.61065439820231, 2.9457701593023167],
            [10.61024744907521, 2.9460718550789773],
            [10.596170555572385, 3.036310052431206],
            [10.585091208642796, 3.034725132305295],
            [10.571692908983014, 3.1064822012957207],
            [10.645961852232912, 3.117566016248974]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.27069862972114, "lat": 40.84599954295167 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39005"],
        "coty_name": ["Ashland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ashland County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01074016"
      },
      "bbox": [
        10.571692908983014, 2.608366672177859, 10.859866710544935,
        3.133107431957331
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.107889379392262, 3.3379924253845656],
            [9.119977866372814, 3.339760999243453],
            [9.152094232673624, 3.34367696331288],
            [9.191183719448045, 3.3487224297191505],
            [9.22199356269278, 3.3523756458207723],
            [9.27526374882538, 3.359589504391684],
            [9.303588041545408, 3.362914442301677],
            [9.403131432626628, 3.3766755783980296],
            [9.446124613911609, 3.382498363492387],
            [9.452426516769986, 3.333694611884674],
            [9.45526916714393, 3.3095810088477893],
            [9.46242610093595, 3.2522827423848115],
            [9.466223773328798, 3.2233866042242805],
            [9.476421061862387, 3.150555766221081],
            [9.480293102793517, 3.1215209182795207],
            [9.488427706461014, 3.0635234526935253],
            [9.460139069431161, 3.0595829179912095],
            [9.331542287122684, 3.0422827960072465],
            [9.231555751879952, 3.029123047683558],
            [9.221236659765205, 3.1164133560628793],
            [9.210445874086492, 3.203633446715832],
            [9.198764388472105, 3.2907247320044934],
            [9.115211059787132, 3.2801452398856785],
            [9.107889379392262, 3.3379924253845656]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.06823906929554, "lat": 41.3338778647222 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39069"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01074047"
      },
      "bbox": [
        9.107889379392262, 3.029123047683558, 9.488427706461014,
        3.382498363492387
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.829225036659627, 3.1069292567966027],
            [9.818516847526483, 3.1940769028280944],
            [9.897446719190983, 3.2051911457936204],
            [9.919492800053415, 3.207146108987842],
            [9.933927116979817, 3.2088081855095263],
            [9.968979785089934, 3.2134792926331235],
            [9.989940260527474, 3.2180014041085427],
            [10.031231695711414, 3.225111466767362],
            [10.074646563996918, 3.2315217168120527],
            [10.103967987972098, 3.235084414488045],
            [10.119431373494761, 3.2366712572300638],
            [10.161030968859288, 3.242514760177918],
            [10.246748428738924, 3.2536842947005415],
            [10.261616598366654, 3.166560587215307],
            [10.27653419255951, 3.0801835352311566],
            [10.290588097838194, 2.996825172820242],
            [10.273155956148113, 2.994723794420237],
            [10.273450637837945, 2.991428091213069],
            [10.15249607767656, 2.9747607903571245],
            [10.08101054975315, 2.9647240067421743],
            [10.061509070124467, 2.9621144304560105],
            [9.972423853526559, 2.9493182424735123],
            [9.967759962820184, 2.948918879707753],
            [9.924209312988797, 2.942727569313336],
            [9.920666603752853, 2.942028443565791],
            [9.88087248471465, 2.936532201900438],
            [9.853039694268796, 2.932455131301168],
            [9.84989268438508, 2.9541928327445492],
            [9.84100458888786, 3.01963038285309],
            [9.834919947254816, 3.06321265201463],
            [9.829225036659627, 3.1069292567966027]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.12766512909089,
          "lat": 41.123849657038896
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39147"],
        "coty_name": ["Seneca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seneca County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01074086"
      },
      "bbox": [
        9.818516847526483, 2.932455131301168, 10.290588097838194,
        3.2536842947005415
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.826205544662422, 2.8009721727805723],
            [8.91592584023214, 2.8118012735851305],
            [8.983287298733352, 2.820121768499436],
            [9.083322995782005, 2.832591207551058],
            [9.126183505145367, 2.838012682929353],
            [9.137673428143444, 2.7510890004481783],
            [9.180361030973364, 2.756668684507693],
            [9.186177763065915, 2.7122244200945955],
            [9.191799001113191, 2.669316704109177],
            [9.149165612108131, 2.6638737516623925],
            [9.165701111685962, 2.5329103044732024],
            [9.121379612713524, 2.527426727620197],
            [9.116076656266369, 2.5708791444429266],
            [9.030095104177994, 2.5601056759671175],
            [8.98321051088113, 2.554123118366161],
            [8.94235082476557, 2.549301401326452],
            [8.857916147175795, 2.539713715124469],
            [8.853334941486303, 2.576912716887059],
            [8.849317783453042, 2.6123611019309765],
            [8.83437576079923, 2.7341620870248127],
            [8.826205544662422, 2.8009721727805723]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.5861287504072, "lat": 40.855391684660546 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39161"],
        "coty_name": ["Van Wert"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Van Wert County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01074092"
      },
      "bbox": [
        8.826205544662422, 2.527426727620197, 9.191799001113191,
        2.838012682929353
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.255336690346211, -2.2082407423279413],
            [1.2544415758425425, -2.1197011148598],
            [1.2593996732886923, -2.1192758145179593],
            [1.2586654183389798, -2.0460319303783034],
            [1.3483405065275593, -2.045217824393698],
            [1.4309901846522306, -2.0440404350847747],
            [1.433600203931759, -2.0468826986015958],
            [1.4841599205388143, -2.0462157498919926],
            [1.5616773787921725, -2.0449703884383275],
            [1.5626519081783166, -2.100772444564189],
            [1.5642308322079228, -2.2149504691715425],
            [1.567827561976075, -2.238269310331657],
            [1.5753394996612762, -2.2929370990251527],
            [1.578362923218654, -2.3128956611492226],
            [1.5860509791040935, -2.36965240217155],
            [1.592480239428368, -2.4157268496953335],
            [1.6057640904372632, -2.505361120757124],
            [1.613246050815706, -2.5546724724678302],
            [1.5134641405386404, -2.556488094213856],
            [1.4256329227691469, -2.5575189894401564],
            [1.3256949976530266, -2.5588265959843666],
            [1.2545354045560033, -2.559377533310013],
            [1.2539392604944695, -2.501359012956818],
            [1.2545440460246606, -2.471581871028401],
            [1.2582481838941886, -2.4716602266431313],
            [1.257511473420785, -2.427088231936099],
            [1.256789625206594, -2.324850528879337],
            [1.256367173958956, -2.306665965653731],
            [1.2560101008437365, -2.2574177494437833],
            [1.2558079949300414, -2.2567581072891723],
            [1.255336690346211, -2.2082407423279413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.80260499129919,
          "lat": 36.408243385449914
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40041"],
        "coty_name": ["Delaware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delaware County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01101808"
      },
      "bbox": [
        1.2539392604944695, -2.559377533310013, 1.613246050815706,
        -2.0440404350847747
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2486706281527276, -1.7142430841496825],
            [1.3708149519100283, -1.7135150223056637],
            [1.4625749957300929, -1.7125632419593388],
            [1.4921910276408201, -1.7120227547425988],
            [1.5511238112432528, -1.7113279689232503],
            [1.556862308451191, -1.711009596695432],
            [1.5575289167708957, -1.76020178651948],
            [1.5576170825134414, -1.7809023070911627],
            [1.5581370503878265, -1.8138174522147437],
            [1.5580572896219667, -1.8309386541783772],
            [1.5587580774469383, -1.8639748924909074],
            [1.56000124691184, -1.9454585288513584],
            [1.5616773787921725, -2.0449703884383275],
            [1.4841599205388143, -2.0462157498919926],
            [1.433600203931759, -2.0468826986015958],
            [1.4309901846522306, -2.0440404350847747],
            [1.3483405065275593, -2.045217824393698],
            [1.2586654183389798, -2.0460319303783034],
            [1.2579595562718853, -1.9727743349590032],
            [1.256773823358188, -1.855708060599795],
            [1.2559687983391232, -1.7711028465329206],
            [1.258823316324495, -1.770948608263615],
            [1.2604596012097347, -1.7641521327540473],
            [1.258082797724219, -1.7622980164161608],
            [1.2515122752054864, -1.7615334341415774],
            [1.2375164821528262, -1.7534319666722153],
            [1.2328432847751942, -1.7477240306552937],
            [1.229900149773479, -1.7388684267603347],
            [1.2320197065405396, -1.7348954897027893],
            [1.2278713785674817, -1.7294563366565792],
            [1.227853492799617, -1.7197613070476232],
            [1.2376591798236782, -1.7185689925795857],
            [1.2429235278913624, -1.7188598167353233],
            [1.2486706281527276, -1.7142430841496825]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.81040275372153, "lat": 36.83550389224531 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40115"],
        "coty_name": ["Ottawa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ottawa County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01101845"
      },
      "bbox": [
        1.227853492799617, -2.0468826986015958, 1.5616773787921725,
        -1.711009596695432
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.040174501691421755, -3.3288027479358595],
            [-0.0350406614272583, -3.333768411515938],
            [-0.02652335098163762, -3.333771800434443],
            [-0.024937395674683883, -3.3302517036831785],
            [-0.02082260430154484, -3.332721170629957],
            [-0.018843266241553584, -3.3308401034176285],
            [-0.014269157411032801, -3.320848067677653],
            [-0.00936979019049048, -3.3181689749342484],
            [-0.0037640464903727156, -3.3225302089989053],
            [-0.002171524897890495, -3.3278216116973356],
            [0.005668562619610373, -3.3304380410600176],
            [0.010386936908172285, -3.3296562164383974],
            [0.013835395852532361, -3.3274465462763594],
            [0.013898150843628655, -3.3349272755252564],
            [0.01931884760815401, -3.3377748459380805],
            [0.02586203387632403, -3.337427628183251],
            [0.03131752604700442, -3.338656014658018],
            [0.03414966299741813, -3.330170294528696],
            [0.028983112074208287, -3.324679272559287],
            [0.029799294846201453, -3.318937804422142],
            [0.02424179074538734, -3.317997746048911],
            [0.019455786435784224, -3.3148478943801725],
            [0.02127083603966293, -3.3112283517033636],
            [0.017372847035880535, -3.3067327445868853],
            [0.011331640103473083, -3.3081357583713586],
            [0.012214574716258841, -3.300446701931822],
            [0.014946163596527166, -3.295055812783662],
            [0.007757968179991491, -3.2935117066235806],
            [0.004668037481114264, -3.2913700280691165],
            [0.00416437239551703, -3.287826506100258],
            [0.009659798711679738, -3.2853430197585287],
            [0.010571647688521054, -3.2820365034480763],
            [0.01440553412060885, -3.2821698098840284],
            [0.017003524106467827, -3.279615400768074],
            [0.016742762315657075, -3.2751798451211713],
            [0.02413883854498936, -3.276809976207409],
            [0.027486798339172766, -3.2761672689011876],
            [0.03054764525500562, -3.2824548622232435],
            [0.033899708037143955, -3.2832734502605567],
            [0.04256286861879845, -3.2912565953521824],
            [0.04487994891322486, -3.298610063994794],
            [0.050702447710741116, -3.300215876175383],
            [0.055317570945228385, -3.299878932001411],
            [0.0626668224466918, -3.3010306146385533],
            [0.07001250147704068, -3.297417346971444],
            [0.073689096543466, -3.2900620370475613],
            [0.07268844688831429, -3.2853349335112685],
            [0.06972366625011366, -3.284011360607035],
            [0.0699266230978085, -3.2806582039107353],
            [0.07533870204674868, -3.2759273840505925],
            [0.07885828462863603, -3.270917748853356],
            [0.0796724251893183, -3.2663416770592524],
            [0.08309391262967272, -3.2667948576688794],
            [0.08785293875883537, -3.271731831226503],
            [0.09057045268146471, -3.268920644644649],
            [0.09519718021415394, -3.2685914272014194],
            [0.09837618384751906, -3.2716828561838422],
            [0.10350546767833531, -3.2714703572451036],
            [0.1057133069592249, -3.268761003852618],
            [0.10751448492202753, -3.262153472455803],
            [0.10747402930640976, -3.2951635484708226],
            [0.10661951815812014, -3.4410076858949266],
            [0.10621780755382504, -3.5580046295123955],
            [0.10585389078085788, -3.616544111862528],
            [0.06601241168639843, -3.6162626381961913],
            [0.06540414071006932, -3.7114442396978684],
            [0.06465789438609888, -3.8228524491517963],
            [0.05876071816581583, -3.830771130936323],
            [0.056841357463621324, -3.8400384382048784],
            [0.0520052636119269, -3.847036202313187],
            [0.04672983322268678, -3.858095166921821],
            [0.04313885332831794, -3.8619797078110607],
            [0.03946927170937169, -3.8636691824574356],
            [0.033690408288933854, -3.863940186867112],
            [0.02947453251658439, -3.8613026549847267],
            [0.021405054696343417, -3.853295121008239],
            [0.016714048339172602, -3.84620974281866],
            [0.011647099009070508, -3.8351401627192865],
            [0.012190445839600654, -3.8256847221231203],
            [0.010928147948952048, -3.81893546672559],
            [0.005092380180025264, -3.8157817158223675],
            [-0.005481776163882389, -3.816422760054561],
            [-0.02075407424175488, -3.8269950347566604],
            [-0.03493927831251843, -3.8324393321381667],
            [-0.04202438740300373, -3.8339027492085602],
            [-0.0512168904763418, -3.8342446820363176],
            [-0.05739237369980634, -3.8332977754711757],
            [-0.06160744674059884, -3.8313574556109344],
            [-0.06731904980908975, -3.8222662982462814],
            [-0.07123101279673325, -3.8115699062972754],
            [-0.0745299821294133, -3.806616249045429],
            [-0.07905640315261694, -3.802861363880157],
            [-0.09194232765956231, -3.799296205717636],
            [-0.09876289146705883, -3.7989661974363167],
            [-0.10489920561321447, -3.8019815511861457],
            [-0.11064087328436074, -3.808268779423029],
            [-0.11476313768736304, -3.815987477651365],
            [-0.11434389587210081, -3.8205862434986666],
            [-0.10834155936703628, -3.8230559020463724],
            [-0.10200770455398366, -3.828829011412674],
            [-0.09678303940771243, -3.836948095772095],
            [-0.09448468620742621, -3.8440454808062627],
            [-0.09465956611500831, -3.849438512630538],
            [-0.09792198931543593, -3.857653668842173],
            [-0.10163862146681144, -3.862027689834234],
            [-0.10104087464228766, -3.864173192646974],
            [-0.11592517386540518, -3.872931652507612],
            [-0.12448768492538476, -3.875783990538037],
            [-0.12977054239914915, -3.8749387974686655],
            [-0.13325386402593975, -3.8727971046085243],
            [-0.1400131235325906, -3.8629859010597016],
            [-0.14406399828882613, -3.8504774317379886],
            [-0.14529795908371257, -3.841914908358505],
            [-0.15069051090833702, -3.8322869355001203],
            [-0.15485980949120082, -3.831216314223055],
            [-0.16708746830909235, -3.83200521584985],
            [-0.16663694190357684, -3.8303183854266276],
            [-0.16654064830546605, -3.7900966925380515],
            [-0.16565176490492067, -3.687835056764684],
            [-0.1651580086973556, -3.5856826749039383],
            [-0.16554505210106427, -3.5556206099223293],
            [-0.1650640523793805, -3.4395320528924427],
            [-0.16442692360507896, -3.39571362487751],
            [-0.1637448771983105, -3.323165089302551],
            [-0.15214364076766504, -3.3194183456853144],
            [-0.149461010921226, -3.321180254102306],
            [-0.13754187992494202, -3.32219394748975],
            [-0.13416977137730288, -3.3199308361084894],
            [-0.135198291476531, -3.3143579308696425],
            [-0.1310110676384925, -3.3110998093353228],
            [-0.12695185775239914, -3.3053304191341244],
            [-0.12167590188033824, -3.3037652227858714],
            [-0.11802646314500265, -3.3053380312406535],
            [-0.1153146052912363, -3.309681562595884],
            [-0.11788144096409375, -3.314434444006997],
            [-0.11693341783858405, -3.3169354921419223],
            [-0.11119859095855451, -3.3133989072227137],
            [-0.1036444217347178, -3.312924204878236],
            [-0.10234206985573421, -3.3193558425588616],
            [-0.09597919443688943, -3.3202363860926485],
            [-0.09260085622717559, -3.3255014020959317],
            [-0.08767394977285049, -3.3232434756344555],
            [-0.08484313514844058, -3.3268735363271253],
            [-0.08185687163788309, -3.325275196848654],
            [-0.07941870296985722, -3.3286081551787934],
            [-0.07388775953647998, -3.3303975175864733],
            [-0.0704802185285436, -3.3340723215463974],
            [-0.0653821850672632, -3.333928278022075],
            [-0.06344601012422643, -3.337784981009344],
            [-0.05788222324595159, -3.3367975991621295],
            [-0.05032077749973276, -3.3304599216369173],
            [-0.048405189989663436, -3.336409052566829],
            [-0.04546602793137028, -3.336852586789582],
            [-0.04180210563390351, -3.329591778848513],
            [-0.040174501691421755, -3.3288027479358595]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.61548190987725, "lat": 35.16747149183245 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40133"],
        "coty_name": ["Seminole"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seminole County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01101854"
      },
      "bbox": [
        -0.16708746830909235, -3.875783990538037, 0.10751448492202753,
        -3.262153472455803
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.22547024957135117, -2.562593178061616],
            [0.24914609813034336, -2.562965123355676],
            [0.31205149527743814, -2.5639453762181645],
            [0.3964949723126417, -2.5643401076388166],
            [0.46275941454247727, -2.563957398535833],
            [0.4626067320802887, -2.5041188631638476],
            [0.46268827738561125, -2.4448869565438516],
            [0.46253583856768843, -2.4387229960284564],
            [0.4628066709728013, -2.299333979222858],
            [0.5703617128751365, -2.2991924435724536],
            [0.6133202571788673, -2.2992933542688188],
            [0.6276455257969906, -2.299263739279984],
            [0.6278047142968485, -2.328590088031143],
            [0.6134466446795519, -2.32854918100451],
            [0.6137547067544638, -2.4455880117779096],
            [0.6138908561177846, -2.4748336636569572],
            [0.611271940950975, -2.4748387923241664],
            [0.6115831105572184, -2.4951281791235673],
            [0.61132215399366, -2.502302667715971],
            [0.611394370681867, -2.5624690220863675],
            [0.6543865064504649, -2.562252456693358],
            [0.6546953404470357, -2.6795289217428273],
            [0.6550442955984543, -2.793583988980806],
            [0.654744435267788, -2.825988192951063],
            [0.6086347078416553, -2.8261470394958565],
            [0.6087351128997046, -2.871342340921036],
            [0.5444786710989469, -2.8713364430901485],
            [0.4799740885498431, -2.870846194266968],
            [0.4371427085847874, -2.870901749447534],
            [0.43727043561564927, -2.8546197232312096],
            [0.4370322638647332, -2.826274767056906],
            [0.4400060418203088, -2.826268693153145],
            [0.4400863176622763, -2.7823021773987686],
            [0.4400503494826465, -2.6505959125916054],
            [0.40440022863322084, -2.6503758498718892],
            [0.32538698922759135, -2.650142271795511],
            [0.22518295473320904, -2.649822835654379],
            [0.22547024957135117, -2.562593178061616]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.94145524653429, "lat": 36.12113200933062 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40143"],
        "coty_name": ["Tulsa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tulsa County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "01101859"
      },
      "bbox": [
        0.22518295473320904, -2.871342340921036, 0.6550442955984543,
        -2.2991924435724536
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.111491454347233, 8.103179767092405],
            [-15.111285401324679, 8.105465124566855],
            [-15.102375379447032, 8.103402383020127],
            [-15.099979694341373, 8.112209401649324],
            [-15.095404077188833, 8.117989808175933],
            [-15.092292389754599, 8.11980982934514],
            [-15.08791308101973, 8.126432370154294],
            [-15.08318706535643, 8.127869970242989],
            [-15.078478045309012, 8.14319795993005],
            [-15.079171812966273, 8.145516449110689],
            [-15.073573601942009, 8.147031864627866],
            [-15.06363032796522, 8.15195023707234],
            [-15.055345518542234, 8.152097719646791],
            [-15.0524914584237, 8.15000697488847],
            [-15.041025763436272, 8.144929507601695],
            [-15.035941577120349, 8.146909819548174],
            [-15.03502146474864, 8.150262121716795],
            [-15.02952043625835, 8.153502617849623],
            [-15.025142970610279, 8.153489892605757],
            [-15.022916788164185, 8.15920003487727],
            [-15.019116524201, 8.164596380579786],
            [-15.012893534125, 8.168234231919014],
            [-15.002660534610328, 8.165973524970505],
            [-14.998761513452425, 8.166892300077103],
            [-14.99127014913644, 8.163027638231474],
            [-14.987520813295808, 8.1584274464236],
            [-14.987093495685475, 8.15066624399324],
            [-14.983097270648127, 8.14151273457693],
            [-14.981621293848818, 8.140224932565271],
            [-14.977627302487658, 8.131294270502009],
            [-14.970397160738807, 8.12521838460341],
            [-14.966382762051577, 8.124499288246566],
            [-14.958309203103893, 8.113670768988836],
            [-14.952371524439599, 8.111667947415988],
            [-14.944732026146642, 8.107023459649362],
            [-14.937189224834407, 8.099401007582076],
            [-14.925165531091782, 8.096341407709696],
            [-14.913206377763801, 8.094868578812447],
            [-14.900475638934685, 8.099119810971873],
            [-14.896256255423385, 8.101818906146535],
            [-14.890694141582731, 8.103316689356959],
            [-14.88768808629352, 8.106123276396302],
            [-14.883764032017172, 8.106085153264335],
            [-14.87552092910897, 8.10972084140011],
            [-14.872157917532498, 8.114443501601809],
            [-14.862279704902383, 8.117999450981554],
            [-14.854032966904708, 8.125602362989598],
            [-14.85099125401437, 8.130657278445826],
            [-14.84439709256244, 8.133398205159763],
            [-14.841948509524311, 8.140233711220889],
            [-14.838399157201188, 8.14237540045643],
            [-14.832814556454073, 8.142190480184254],
            [-14.826438523363665, 8.134413203239058],
            [-14.822544689006458, 8.138832257637006],
            [-14.819406475873274, 8.138807343300707],
            [-14.812739164127278, 8.135261662955497],
            [-14.812807526008056, 8.12731870708964],
            [-14.810006452290164, 8.117972091542622],
            [-14.807460567939337, 8.112784770852306],
            [-14.807725254758731, 8.108487191749614],
            [-14.802730429318588, 8.099793382640092],
            [-14.798457765103201, 8.10045720227551],
            [-14.79745808362545, 8.105053063840105],
            [-14.78892907265712, 8.100037482778621],
            [-14.785816002459116, 8.09576651136614],
            [-14.789237342541398, 8.089120081008664],
            [-14.786380197161186, 8.084759538939197],
            [-14.780624371300501, 8.082136075431745],
            [-14.779529821079839, 8.075814168222076],
            [-14.784562330921439, 8.072999150458347],
            [-14.786455180560699, 8.065252422370982],
            [-14.78323067544849, 8.064068878662363],
            [-14.782525382902469, 8.060767353213382],
            [-14.76194056840616, 8.056286960477761],
            [-14.63550345747355, 8.027705060052046],
            [-14.625327729572994, 8.069387875924175],
            [-14.615627913576505, 8.11124761430009],
            [-14.490661890125555, 8.083371067838664],
            [-14.481121415588534, 8.081791797806432],
            [-14.410857638711382, 8.065922717480099],
            [-14.291059573022679, 8.038625825080914],
            [-14.24364290627556, 8.027619150643902],
            [-14.24376743992152, 8.027070772046178],
            [-14.161639485510332, 8.008442371702285],
            [-14.079515815304203, 7.989795025837481],
            [-14.079754149208695, 7.9885335720895005],
            [-14.092761991162424, 7.974430807071359],
            [-14.102598632888657, 7.966831388924946],
            [-14.107294121269813, 7.965280025233822],
            [-14.117600701378517, 7.95656009512511],
            [-14.130742346845295, 7.951495985672938],
            [-14.135824966053006, 7.94566474150366],
            [-14.135243985582454, 7.938129750242007],
            [-14.138149190921698, 7.924671264275177],
            [-14.15024440657748, 7.9099286625216765],
            [-14.152526250881328, 7.9048059697244915],
            [-14.152378322392599, 7.9011270116453804],
            [-14.146973642619004, 7.896613176393521],
            [-14.143726357340698, 7.898917431840344],
            [-14.140823956935721, 7.904250961985242],
            [-14.134870723134696, 7.9080158205755815],
            [-14.129621571342904, 7.903541995981792],
            [-14.133323552982903, 7.8969202755550025],
            [-14.139525337993808, 7.892258541847873],
            [-14.148387664534484, 7.889671328103848],
            [-14.151802723418701, 7.883662035578443],
            [-14.15028999742766, 7.876628294797286],
            [-14.145240119204033, 7.864447324219773],
            [-14.144824013146991, 7.854943660861795],
            [-14.150857618517149, 7.848375558977022],
            [-14.160096957066814, 7.831760373087381],
            [-14.168343196956291, 7.81561604532521],
            [-14.1809602363455, 7.801142330320117],
            [-14.18917796392495, 7.798978697736247],
            [-14.19626167303459, 7.791988004221216],
            [-14.20127806761393, 7.7899488472429335],
            [-14.20524198028875, 7.791417171472129],
            [-14.208001614180157, 7.78819745064093],
            [-14.207170056075958, 7.784296391229245],
            [-14.2112003039238, 7.77733525506823],
            [-14.213251178560528, 7.772778128328084],
            [-14.21670565565044, 7.772642198002316],
            [-14.231344818909896, 7.755123273664699],
            [-14.237910047025938, 7.750476920011153],
            [-14.243881326337098, 7.742035938005315],
            [-14.243584593683892, 7.734035308242786],
            [-14.247834660002498, 7.727755175439707],
            [-14.259013622298994, 7.724233785025128],
            [-14.27193362557706, 7.724254783939738],
            [-14.276721814727468, 7.722673565523588],
            [-14.28111858447252, 7.718970573261295],
            [-14.292868717875374, 7.712630694524427],
            [-14.298254787573471, 7.710980044022031],
            [-14.308456602978785, 7.71371862842492],
            [-14.315040185645485, 7.709022407016147],
            [-14.320517911662396, 7.710565813368744],
            [-14.332061987941474, 7.707072399302182],
            [-14.335343951466047, 7.70414980320729],
            [-14.336831279060302, 7.69874845220754],
            [-14.33919077414294, 7.695774680525855],
            [-14.345256147053272, 7.694876973901337],
            [-14.348511933001182, 7.692426091383307],
            [-14.348459409914632, 7.686841449144581],
            [-14.35269649742606, 7.6725042385649305],
            [-14.354765254998402, 7.6698806899433665],
            [-14.361259907630393, 7.668169378866394],
            [-14.363498722083666, 7.664451850552341],
            [-14.367872545032638, 7.6611543603604995],
            [-14.370782460905659, 7.653645687800897],
            [-14.37010607391709, 7.649592056942206],
            [-14.37326497587131, 7.643534501010019],
            [-14.381402227105871, 7.640387001149617],
            [-14.38551566630856, 7.637162798333202],
            [-14.38777670087836, 7.6301823256862455],
            [-14.387700070326435, 7.62469291241693],
            [-14.392450719621035, 7.6142260969984985],
            [-14.402380640844312, 7.602619281219083],
            [-14.407390635398423, 7.601472750899856],
            [-14.413644582739801, 7.592459109592031],
            [-14.42153634401966, 7.5729996583087535],
            [-14.423386830837522, 7.563243953436276],
            [-14.431669062008956, 7.556345076971104],
            [-14.438415150255482, 7.553975974201666],
            [-14.441502591111506, 7.551788230236751],
            [-14.444250028727712, 7.5458229058972455],
            [-14.441866108160529, 7.540288840300901],
            [-14.44528274115995, 7.529247340114003],
            [-14.454063492820076, 7.51710973704693],
            [-14.461515788151786, 7.512019972390917],
            [-14.466168490865819, 7.5112964237352635],
            [-14.476258212096086, 7.513082617754138],
            [-14.479715750803006, 7.510089905869617],
            [-14.486125075114844, 7.501976078602975],
            [-14.486603908883067, 7.498922253262116],
            [-14.49020667979329, 7.4926997507787645],
            [-14.496056622037505, 7.486007035030316],
            [-14.503505225542943, 7.481193801605962],
            [-14.508554654161804, 7.4828387521427295],
            [-14.514458745198107, 7.481694971115796],
            [-14.51669207682534, 7.477768726150413],
            [-14.516882420311003, 7.472199864607467],
            [-14.515701624655108, 7.468123470361598],
            [-14.515019997897202, 7.45665027255372],
            [-14.515813231398804, 7.4456023752681855],
            [-14.520747108083052, 7.4254370534920895],
            [-14.533810148438352, 7.406375231000597],
            [-14.540581299584934, 7.401869886478306],
            [-14.546722113878603, 7.400071094520982],
            [-14.548205615530213, 7.394721106639815],
            [-14.546513319655439, 7.376878886677561],
            [-14.536898174682, 7.36075084459089],
            [-14.533047511954313, 7.357375053085839],
            [-14.525524615123764, 7.34411555914],
            [-14.523255913326462, 7.33363340462096],
            [-14.526036250792782, 7.327155548940863],
            [-14.537910878840082, 7.312897203821796],
            [-14.547048664521611, 7.310967413922816],
            [-14.5493104840347, 7.309501715878919],
            [-14.552136115895395, 7.304245591850295],
            [-14.610657026087047, 7.31751104969975],
            [-14.6810581393449, 7.333042817471426],
            [-14.738075048449213, 7.345282069922901],
            [-14.71834554472283, 7.429496493430414],
            [-14.733973722011825, 7.43295768284697],
            [-14.730743746873364, 7.446829720528685],
            [-14.744802491509233, 7.449906352138156],
            [-14.741527771129707, 7.463843675788138],
            [-14.76951278835036, 7.470200171084779],
            [-14.766237034669446, 7.484126932269364],
            [-14.780958787554777, 7.487568645934696],
            [-14.777690973487852, 7.501556375897798],
            [-14.88785523637665, 7.526453174371859],
            [-14.958343371123673, 7.542675844887564],
            [-14.973105526396647, 7.545557514420067],
            [-15.04200450562517, 7.561941872008864],
            [-15.04545879671546, 7.547887156121806],
            [-15.07273598877509, 7.554583834609182],
            [-15.076118309254177, 7.540620897547516],
            [-15.090108042684081, 7.54391652904969],
            [-15.096017379582342, 7.519519457381596],
            [-15.109972361940766, 7.522867448082425],
            [-15.114091981260088, 7.505415488358425],
            [-15.127974090736023, 7.508673993833377],
            [-15.131281451723668, 7.494689076982828],
            [-15.141765422808795, 7.497234004134794],
            [-15.14511953406342, 7.483243877183003],
            [-15.14861900867856, 7.4840896444711165],
            [-15.151987168188349, 7.470089648843793],
            [-15.165826114527954, 7.473359758226698],
            [-15.169191801836163, 7.459349162851552],
            [-15.18324311121807, 7.462691756727784],
            [-15.186531858324477, 7.448310638912704],
            [-15.200630199040187, 7.451654206821186],
            [-15.207647787579125, 7.423840287720167],
            [-15.235742713783742, 7.430484772313879],
            [-15.239068396746044, 7.41643589493703],
            [-15.266083516154987, 7.4227407176772315],
            [-15.265770693624951, 7.4239081595443235],
            [-15.350581994860539, 7.443473190973556],
            [-15.350934575962082, 7.442084132851455],
            [-15.415571490919794, 7.457298807221238],
            [-15.45048881467858, 7.465678730136125],
            [-15.445239559817947, 7.486713939065128],
            [-15.445643756379662, 7.48834514501318],
            [-15.440971261178184, 7.497467818260261],
            [-15.437613873095838, 7.4973810878788445],
            [-15.43043214906821, 7.509341670540625],
            [-15.428384297116772, 7.510815113070202],
            [-15.423108537307247, 7.521195250587807],
            [-15.414239249495932, 7.525347164481776],
            [-15.41426556957062, 7.528901356895761],
            [-15.411979048426037, 7.537628249311073],
            [-15.40610272413613, 7.538236686450706],
            [-15.40078035236803, 7.547066802387539],
            [-15.393583269485454, 7.549734185680495],
            [-15.38837194049451, 7.548715992890519],
            [-15.383508996051146, 7.550665865820681],
            [-15.38368940832019, 7.552905275769751],
            [-15.380051959569641, 7.558912296323233],
            [-15.379803010995944, 7.564256730549337],
            [-15.377009425351282, 7.565378996017994],
            [-15.364327806079043, 7.566100125120284],
            [-15.36141025159519, 7.564757035771578],
            [-15.360685264473275, 7.570422148984422],
            [-15.367013951241505, 7.579252941685799],
            [-15.367868861608333, 7.58499063346643],
            [-15.369905971879799, 7.58847261151516],
            [-15.368253528110614, 7.591481055208834],
            [-15.371203992054864, 7.593335467232966],
            [-15.373365883960345, 7.5972521356288105],
            [-15.37082784174001, 7.602010000019306],
            [-15.36577914438285, 7.605472144346936],
            [-15.365037220446565, 7.610426960992895],
            [-15.359337873236527, 7.614195133459084],
            [-15.359110207476434, 7.618694713609131],
            [-15.354083658305836, 7.623896822569283],
            [-15.352786088675304, 7.64046868854401],
            [-15.348998640558653, 7.647519917012863],
            [-15.342660464312784, 7.641801703363643],
            [-15.334479699731494, 7.6450960741124385],
            [-15.330059191694914, 7.6431162277537075],
            [-15.323225197900424, 7.64442461107858],
            [-15.320504099577477, 7.6463691069583275],
            [-15.317985713773362, 7.642658599972835],
            [-15.312225337588425, 7.648382285801218],
            [-15.304940671924781, 7.652299042857721],
            [-15.307621804586864, 7.66030644437875],
            [-15.304070488265907, 7.660677527214723],
            [-15.300075604843279, 7.664105781264612],
            [-15.302944684682712, 7.668704786650835],
            [-15.302502198757118, 7.674127276740484],
            [-15.306050190558446, 7.689542068500523],
            [-15.304387351433094, 7.695423953316546],
            [-15.298943703777331, 7.701506372611884],
            [-15.29989310842938, 7.704322787791253],
            [-15.29850469453413, 7.711552554848943],
            [-15.29274146312603, 7.717253193018227],
            [-15.288861621046356, 7.714215945936341],
            [-15.28387168757264, 7.719674700640789],
            [-15.283632511880352, 7.722526033618976],
            [-15.27906767140305, 7.724727159765818],
            [-15.273917146228742, 7.7348503107897395],
            [-15.268920539658188, 7.739075633635722],
            [-15.26114026982961, 7.7359675258155685],
            [-15.260136913061306, 7.733086383469813],
            [-15.252438504438375, 7.738109976670094],
            [-15.2491392785232, 7.74670918193567],
            [-15.24501240545948, 7.74976697281909],
            [-15.239602037780559, 7.7564257167803365],
            [-15.243138741505552, 7.759684858785613],
            [-15.240713696288594, 7.763703314791086],
            [-15.242670367082747, 7.770222231398572],
            [-15.245157617376858, 7.774725669679954],
            [-15.251196616290338, 7.779556787613108],
            [-15.254017152828892, 7.7798203697977755],
            [-15.25805746174563, 7.789357238485612],
            [-15.255930431649, 7.7989417599618465],
            [-15.25575362426745, 7.804173479205673],
            [-15.26168826187047, 7.809441577112921],
            [-15.261707787951627, 7.813185209065375],
            [-15.265773133394037, 7.812825219770881],
            [-15.274064333202887, 7.823102985922256],
            [-15.276829597648454, 7.824056268393007],
            [-15.285825697714488, 7.822732634964803],
            [-15.292948419808756, 7.824956846008895],
            [-15.295801387247035, 7.823515872516213],
            [-15.299067115757731, 7.825907478449716],
            [-15.303867964562922, 7.8328319671040685],
            [-15.306622071293075, 7.839768661575164],
            [-15.312098764035927, 7.838782953673051],
            [-15.314762151047724, 7.84123620890033],
            [-15.322373174835581, 7.8386369693681806],
            [-15.32781237331822, 7.845389073789257],
            [-15.339026384738263, 7.849326972243903],
            [-15.341066668665873, 7.854703464066277],
            [-15.3482077837828, 7.859537706523324],
            [-15.351573016764963, 7.859404175041958],
            [-15.354293267248027, 7.862231362415198],
            [-15.358611520925793, 7.862771202746771],
            [-15.357776116582938, 7.867384465407494],
            [-15.36010945627778, 7.87734227368573],
            [-15.359988607581222, 7.886910121032752],
            [-15.362112087742712, 7.888992528640861],
            [-15.358413155472974, 7.900757251127968],
            [-15.355645695366835, 7.903810056533526],
            [-15.350909217430283, 7.905539588520982],
            [-15.345364073042708, 7.904369456447563],
            [-15.33921002972582, 7.9075609133933344],
            [-15.33692253150523, 7.904281414635236],
            [-15.329574291692222, 7.90074528078878],
            [-15.328082305574751, 7.896397226332795],
            [-15.319353641360328, 7.896593208206634],
            [-15.318803087018676, 7.899871727879904],
            [-15.315782683431756, 7.904166906638411],
            [-15.30298833001169, 7.909690416439235],
            [-15.29964380588753, 7.906212764753369],
            [-15.291639865049866, 7.90125091276586],
            [-15.287298040493948, 7.903577464940279],
            [-15.284379097061882, 7.9081291953452135],
            [-15.275369105914042, 7.903761887624306],
            [-15.269730512740944, 7.903642470095184],
            [-15.265585111866567, 7.908161203886529],
            [-15.264932923959087, 7.9109966291109535],
            [-15.256088990940604, 7.916766305370579],
            [-15.254372306574814, 7.918721995480713],
            [-15.24531951697655, 7.9194860513717025],
            [-15.234474235693224, 7.913628321657509],
            [-15.229251819045789, 7.912846357560322],
            [-15.22484122019465, 7.90992759656698],
            [-15.220085345525817, 7.909790750724146],
            [-15.217783424254709, 7.907244944122884],
            [-15.21072637162272, 7.9079868601475205],
            [-15.193202595200589, 7.907309541604087],
            [-15.187789988518498, 7.90968768680978],
            [-15.18675331153983, 7.917914037207209],
            [-15.187456447390185, 7.924366354040559],
            [-15.181588622178724, 7.9283659579300325],
            [-15.185911765881064, 7.943614624324251],
            [-15.184829496394933, 7.94897247333597],
            [-15.186865290601972, 7.9558557634851645],
            [-15.182213303016818, 7.966348110700249],
            [-15.18066998759604, 7.967550689301255],
            [-15.18007511157975, 7.974366626754164],
            [-15.183255165688385, 7.975386610859952],
            [-15.187069586248024, 7.979330477785898],
            [-15.188691694365211, 7.983620341569017],
            [-15.185077945033909, 7.99028913862418],
            [-15.188433732028036, 7.992929062099417],
            [-15.190835964473788, 7.997427111014719],
            [-15.183201103548255, 8.000548186510898],
            [-15.180209541821121, 8.005456519399065],
            [-15.169633161595364, 8.009484342906063],
            [-15.168739758356155, 8.019496657273052],
            [-15.163916948341669, 8.021800352965226],
            [-15.159906776837586, 8.019409809439527],
            [-15.14808090133325, 8.021079300185638],
            [-15.142911790765567, 8.013703927999341],
            [-15.139510581473488, 8.01443008334582],
            [-15.128591037870954, 8.008598179856005],
            [-15.121642201119986, 8.010918925806774],
            [-15.12005274546364, 8.017465186517395],
            [-15.11713229490775, 8.020075714627714],
            [-15.119046062938773, 8.027440897036367],
            [-15.118703323769681, 8.036208664473445],
            [-15.11735197312225, 8.038984070088622],
            [-15.119664642947683, 8.04419907544334],
            [-15.117306763847983, 8.049280420327017],
            [-15.118111118947906, 8.053764183228148],
            [-15.111353768083093, 8.057745108694384],
            [-15.109186535052025, 8.06182829688755],
            [-15.111093813755106, 8.065509636606908],
            [-15.107742422080202, 8.069307189811548],
            [-15.10189590320991, 8.079016373877163],
            [-15.105058018380406, 8.084639377773591],
            [-15.108158957249382, 8.083749232779068],
            [-15.110091683807996, 8.0868462096455],
            [-15.114818631174998, 8.090513059206813],
            [-15.111163699670607, 8.101195446441317],
            [-15.111491454347233, 8.103179767092405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.67530798557814,
          "lat": 44.709151518788595
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41001"],
        "coty_name": ["Baker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Baker County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01135845"
      },
      "bbox": [
        -15.45048881467858, 7.304245591850295, -14.079515815304203,
        8.168234231919014
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.764018160973976, 9.213755322485435],
            [-16.7627768955588, 9.2121431991344],
            [-16.749933006597665, 9.211705503548686],
            [-16.715585186559803, 9.231836425667812],
            [-16.666678236520475, 9.233946706448181],
            [-16.617788115894935, 9.24170772756227],
            [-16.59187504015922, 9.244500968318071],
            [-16.574364597692643, 9.254504165339272],
            [-16.562191726161434, 9.258562086341982],
            [-16.560481664593635, 9.253724532056662],
            [-16.560560355058065, 9.244559696836983],
            [-16.556290475076796, 9.240278249346902],
            [-16.551682468160173, 9.238868127749077],
            [-16.546461167933074, 9.238931701147612],
            [-16.542630697114998, 9.237317473722054],
            [-16.53552831969522, 9.226888474553716],
            [-16.536516123040478, 9.216737527660406],
            [-16.52641982707883, 9.21287584076619],
            [-16.520768204398394, 9.208338381289417],
            [-16.51654784682595, 9.202236147069433],
            [-16.51682588946063, 9.194450686092908],
            [-16.50892690532098, 9.183715015944193],
            [-16.509595277436553, 9.17878650891844],
            [-16.507920365663892, 9.174777611411447],
            [-16.50189204992709, 9.175366289292947],
            [-16.49614041946243, 9.174616156873771],
            [-16.490473430810184, 9.16852672739292],
            [-16.483791802772195, 9.164480102426502],
            [-16.47902583838997, 9.15421368589506],
            [-16.47188673108987, 9.150844508796228],
            [-16.47575824878817, 9.145915232233286],
            [-16.47682042056356, 9.140605913672642],
            [-16.46840089359242, 9.140096593050515],
            [-16.46850257701765, 9.135532465449556],
            [-16.47484481622993, 9.133615066858972],
            [-16.471965369796898, 9.129824582226204],
            [-16.471188682514924, 9.123063903102667],
            [-16.466818855959694, 9.118942243366611],
            [-16.46689083707862, 9.113341127638405],
            [-16.45910758790343, 9.1140689619911],
            [-16.454543214109986, 9.116806392190684],
            [-16.448874189293026, 9.116529065116776],
            [-16.4459316087361, 9.111495849942974],
            [-16.45143428889942, 9.107982874416939],
            [-16.45380705100101, 9.104453222310015],
            [-16.453871195462394, 9.09784565285443],
            [-16.451538204393167, 9.092045453889085],
            [-16.448342714917693, 9.08720748957882],
            [-16.43473412771939, 9.081256368250893],
            [-16.43409042401191, 9.077456780640786],
            [-16.43614565633747, 9.068953301376833],
            [-16.43524533785295, 9.054715771343607],
            [-16.435926346847392, 9.05194728103848],
            [-16.440003435216735, 9.048972155209647],
            [-16.441223197094708, 9.045871634278893],
            [-16.438350744786664, 9.039409832164857],
            [-16.433046807822944, 9.035530677183239],
            [-16.42993683966001, 9.029651927815845],
            [-16.430211861477396, 9.024410356976112],
            [-16.42640529084332, 9.019347666042767],
            [-16.418211638602624, 9.016933903915405],
            [-16.414169980275414, 9.012277805299291],
            [-16.416069243241207, 9.009301312767906],
            [-16.42454329797775, 9.011830097658432],
            [-16.43195361658805, 9.00669141251562],
            [-16.432355987288222, 9.002402180801411],
            [-16.42401149755314, 8.994944013869631],
            [-16.42203202768455, 8.988094990601091],
            [-16.428141763635246, 8.97866526215894],
            [-16.430615226375892, 8.977263444821977],
            [-16.437911966102426, 8.976804630056417],
            [-16.442993132454117, 8.982039428598862],
            [-16.451338411964368, 8.984369129019683],
            [-16.461661272356658, 8.988884788379663],
            [-16.46638240990769, 8.991907301069535],
            [-16.46993109587709, 8.99021401489214],
            [-16.469084010539287, 8.983866476095558],
            [-16.471193780787004, 8.978388389121617],
            [-16.469498266987866, 8.974680068259064],
            [-16.463310514989093, 8.972053147742468],
            [-16.46278492586378, 8.963028128643963],
            [-16.465484433733657, 8.960853256125047],
            [-16.473872901328505, 8.960665427833074],
            [-16.483654939085064, 8.971122260707203],
            [-16.4869376004531, 8.980066558052334],
            [-16.491855544253827, 8.982880707741355],
            [-16.498824321802427, 8.97816940343106],
            [-16.50659907852367, 8.977475146870628],
            [-16.5107451932306, 8.974978435109286],
            [-16.520367307616347, 8.97370273863012],
            [-16.525014428314762, 8.971234852167436],
            [-16.524075158889904, 8.968231962426984],
            [-16.519489633182843, 8.966118868425529],
            [-16.517559231897522, 8.960304120144444],
            [-16.528312437206136, 8.95697323658606],
            [-16.53057990411775, 8.950922576974003],
            [-16.525399827322783, 8.948041406401511],
            [-16.523083090736247, 8.943350540203072],
            [-16.526742636692134, 8.940012738421137],
            [-16.536601953428384, 8.942222202368502],
            [-16.54036434134836, 8.940903169852586],
            [-16.541392673796633, 8.937594683718148],
            [-16.533250906506378, 8.935474222122085],
            [-16.530189076360212, 8.933348735984131],
            [-16.527680892276106, 8.926156304990483],
            [-16.532899029502577, 8.923733769858014],
            [-16.536851776948726, 8.926602274457801],
            [-16.541890999756983, 8.926484071113762],
            [-16.546756932945346, 8.918043482990118],
            [-16.549753181105054, 8.916064861714997],
            [-16.553393122923122, 8.916298020185502],
            [-16.560153866001812, 8.918980179430005],
            [-16.563847980097236, 8.914935547520342],
            [-16.55855668502479, 8.909467826865464],
            [-16.558379618105935, 8.907684204048977],
            [-16.56298242055206, 8.902956160873781],
            [-16.56867020049426, 8.900964170852529],
            [-16.569675233124304, 8.89611561963939],
            [-16.564497574951154, 8.896196471096484],
            [-16.55848912901787, 8.89340370177069],
            [-16.561980707365574, 8.88930534275299],
            [-16.564975394387627, 8.892232520266665],
            [-16.56715931748244, 8.888406659189386],
            [-16.573585884782325, 8.887731585300868],
            [-16.576066327084167, 8.88551641032276],
            [-16.57452476192888, 8.8804120431932],
            [-16.578017597921757, 8.875496251917307],
            [-16.579345541882123, 8.870526751685857],
            [-16.58708379157833, 8.867127441503388],
            [-16.586610140222422, 8.864550173354935],
            [-16.581795976482773, 8.862169500418942],
            [-16.58066972961775, 8.85686614127026],
            [-16.582796913292245, 8.850264268632431],
            [-16.589116338386404, 8.850277100955664],
            [-16.58965332319592, 8.84745212943229],
            [-16.58282474075927, 8.846079609066491],
            [-16.582393690618897, 8.841979679202984],
            [-16.583763842192727, 8.837122498779944],
            [-16.59228550634271, 8.835971408055707],
            [-16.593911742998618, 8.830158318462107],
            [-16.589333173663004, 8.828247938121931],
            [-16.585894013610393, 8.823976493239778],
            [-16.586303305057623, 8.81835796200991],
            [-16.589891064819987, 8.814997836911592],
            [-16.59481202862338, 8.815361246004723],
            [-16.596204033020282, 8.818587781913436],
            [-16.595496060644283, 8.823413770972353],
            [-16.59755098883738, 8.825790701527088],
            [-16.603145411481684, 8.820910809485868],
            [-16.602106682610803, 8.810106331814584],
            [-16.602991855003747, 8.807882933749745],
            [-16.6105397277277, 8.807398958737755],
            [-16.603726403280586, 8.801324803390104],
            [-16.60347232314355, 8.798190307861185],
            [-16.6056334010329, 8.794458808379403],
            [-16.609869616615953, 8.790859830029685],
            [-16.611443917298093, 8.786872754785305],
            [-16.60551892264896, 8.784814792872325],
            [-16.603326705625783, 8.780766218882441],
            [-16.60468825245433, 8.777848470920436],
            [-16.61091294445238, 8.777426308612478],
            [-16.619084066342236, 8.77843458787484],
            [-16.620760373444224, 8.776519718402206],
            [-16.61901102912165, 8.772175793773146],
            [-16.619337229209144, 8.766327969187026],
            [-16.616192728592754, 8.76121058549044],
            [-16.61569220050621, 8.75627200034997],
            [-16.620254304466656, 8.749278979982112],
            [-16.61769543471612, 8.74441656878373],
            [-16.609663769258006, 8.747232035773937],
            [-16.606388556227248, 8.744229334701851],
            [-16.609979527608775, 8.739232701812451],
            [-16.618547035260793, 8.741774344375928],
            [-16.621580687895936, 8.737919506239086],
            [-16.620837108161147, 8.735108347732103],
            [-16.614940710151334, 8.734286603752295],
            [-16.61550322366123, 8.729727241789309],
            [-16.61080665701362, 8.726864979993127],
            [-16.606619691675093, 8.720452929788722],
            [-16.6007390690168, 8.715748177956867],
            [-16.59519015031889, 8.713892781195794],
            [-16.59170906701123, 8.714929578050093],
            [-16.58836829286621, 8.713632704188333],
            [-16.58470323221944, 8.708705754563177],
            [-16.586888121927917, 8.702420243948119],
            [-16.590921819016568, 8.700401511947083],
            [-16.590877050926775, 8.696195103771906],
            [-16.583470734854004, 8.694471185985238],
            [-16.582575740838106, 8.692089701271746],
            [-16.58648979761311, 8.688606959947982],
            [-16.591886335959483, 8.68694275871758],
            [-16.583701417936584, 8.67937875713756],
            [-16.584005065492466, 8.67660316254017],
            [-16.590431180678692, 8.67244380958639],
            [-16.591194564960265, 8.667117115237431],
            [-16.58661324389694, 8.661459092525773],
            [-16.585882188553793, 8.658720931922124],
            [-16.57688045099713, 8.657662023882276],
            [-16.575147114242014, 8.65489360505163],
            [-16.578997832304594, 8.651871783871304],
            [-16.58437906914787, 8.651938455183085],
            [-16.589954606836898, 8.645384081269395],
            [-16.587728436544765, 8.633878446249392],
            [-16.590316199492396, 8.63127697883862],
            [-16.591147376565058, 8.626785605734637],
            [-16.59478020663615, 8.621078667957498],
            [-16.59800400476811, 8.623760003089558],
            [-16.60226011179448, 8.629678363596428],
            [-16.608033712459996, 8.624427048136228],
            [-16.614033951214363, 8.62680904001344],
            [-16.62498664952038, 8.626519557210827],
            [-16.62752336845501, 8.625719344942253],
            [-16.632506818106556, 8.620160842473704],
            [-16.630099640728087, 8.611958082406549],
            [-16.627778474703206, 8.607490588333876],
            [-16.71127783879034, 8.629431004711686],
            [-16.781833100897405, 8.648106526870563],
            [-16.780328728623925, 8.652866332051415],
            [-16.777577304973914, 8.65452544607829],
            [-16.77741861461559, 8.660876362133603],
            [-16.773650465372853, 8.666318168510829],
            [-16.76932181170095, 8.668230987967984],
            [-16.766829447242507, 8.672142558723325],
            [-16.76499458286309, 8.680438700274106],
            [-16.767074533546808, 8.687600779255394],
            [-16.765269807683644, 8.691665123628516],
            [-16.770928538975795, 8.697818270975286],
            [-16.775553246574987, 8.698757177743506],
            [-16.778833593664842, 8.702449094454098],
            [-16.78002139340589, 8.70757446499145],
            [-16.782147150279414, 8.709933445958836],
            [-16.787634079326377, 8.711826516917956],
            [-16.786195531150348, 8.71637364084139],
            [-16.78812204503862, 8.717820259660355],
            [-16.79010705059569, 8.723714939667243],
            [-16.78802948397889, 8.726548279344613],
            [-16.79015238204104, 8.731159384268148],
            [-16.7966558627219, 8.732888464617742],
            [-16.798834186932492, 8.734974261411676],
            [-16.806198171183038, 8.737223172778126],
            [-16.814184020936924, 8.745976403054323],
            [-16.81894964401262, 8.749116870913292],
            [-16.82025807096506, 8.752641790193417],
            [-16.824082369012757, 8.75370225764308],
            [-16.82986321259161, 8.760637379181139],
            [-16.829860753238982, 8.763679866617611],
            [-16.8377767828124, 8.77139735815303],
            [-16.840556381618523, 8.777662815680097],
            [-16.843651697067816, 8.778008680276882],
            [-16.847454210430726, 8.783459813234412],
            [-16.85053969921951, 8.783403100773162],
            [-16.857834563387332, 8.787038465328108],
            [-16.859833548590473, 8.79013087979447],
            [-16.87135274192767, 8.793993139427949],
            [-16.872955509244374, 8.791592779124754],
            [-16.87868959354664, 8.790913443631462],
            [-16.886939239891724, 8.794731874580611],
            [-16.90075095483657, 8.799067579228256],
            [-16.905210446712598, 8.795947471280602],
            [-16.912682914311993, 8.799914322558195],
            [-16.914764762392757, 8.80241038628974],
            [-16.924022022678898, 8.804877457237772],
            [-16.927354170500323, 8.80458269827998],
            [-16.928166089008606, 8.810275033784709],
            [-16.930929524168, 8.810036140950825],
            [-16.932133382076316, 8.815534746615388],
            [-16.936818339003917, 8.816628860311363],
            [-16.938077430965205, 8.819883967659177],
            [-16.945221431851483, 8.823431876452174],
            [-16.943223231331526, 8.827952125985643],
            [-16.947091817644363, 8.830948842261622],
            [-16.943838922977786, 8.833542139934886],
            [-16.9451998985911, 8.836270410894658],
            [-16.941407312119996, 8.837916999546012],
            [-16.943789518245858, 8.843041186941285],
            [-16.940437065831986, 8.845373254523414],
            [-16.942489834148237, 8.850223176408665],
            [-16.938565745843178, 8.855274310504104],
            [-16.938176012834667, 8.861033076928251],
            [-16.93516691596728, 8.87024220694261],
            [-16.935305079127357, 8.873458377391469],
            [-16.932248953246056, 8.874871591413386],
            [-16.93054639505309, 8.878712540994238],
            [-16.93302801368316, 8.880694204255786],
            [-16.932994913553905, 8.884176877768672],
            [-16.926167486474103, 8.889313967540255],
            [-16.92732050016472, 8.893932298587517],
            [-16.93301837840336, 8.893553575704821],
            [-16.934508220357777, 8.895515889022812],
            [-16.928865255307734, 8.897973073322058],
            [-16.922966115635717, 8.903872839102293],
            [-16.921870527426506, 8.908169575331762],
            [-16.918434207348934, 8.913032605847421],
            [-16.910818343378423, 8.913616074680801],
            [-16.90636231692064, 8.909201968168455],
            [-16.90074696252401, 8.91057469157547],
            [-16.894533028158655, 8.920091856976041],
            [-16.8899393798645, 8.92132314841124],
            [-16.886096109100027, 8.917909800215567],
            [-16.8888883009875, 8.911108258601407],
            [-16.887058750149087, 8.904984273110815],
            [-16.88320409487429, 8.903354290686247],
            [-16.87740678759641, 8.905397045905135],
            [-16.874183562156475, 8.911091683549094],
            [-16.867692905025894, 8.916225824269295],
            [-16.86516771734292, 8.92364059428417],
            [-16.870402336640176, 8.928202762056545],
            [-16.86852171942742, 8.93056894812387],
            [-16.863698088299135, 8.92877680011863],
            [-16.85973803385826, 8.922199684637471],
            [-16.85531278517476, 8.92214933279284],
            [-16.854138612286697, 8.925931260451256],
            [-16.857705417881785, 8.93261124709411],
            [-16.855716420565344, 8.936994370799841],
            [-16.852564770861775, 8.93707920479185],
            [-16.845544418301337, 8.934807988286725],
            [-16.841783244611317, 8.938210704707613],
            [-16.8401939151727, 8.94566700406024],
            [-16.835267821342583, 8.94773867630955],
            [-16.829179999302344, 8.944181472828483],
            [-16.82467764567402, 8.946569689425631],
            [-16.82339445699387, 8.952368350205829],
            [-16.82122106205757, 8.956089548401158],
            [-16.812795641063428, 8.962758678897886],
            [-16.80790997055386, 8.965693247406692],
            [-16.804929889872472, 8.970299419199003],
            [-16.800230290627525, 8.964620504793709],
            [-16.794892802571788, 8.966292623095518],
            [-16.794232906371974, 8.976259706445752],
            [-16.79041692669151, 8.983637414253309],
            [-16.789876262748574, 8.98697184926976],
            [-16.78389986217689, 8.995618690608394],
            [-16.783591166470107, 9.000241425646367],
            [-16.77827373997561, 8.998425465007024],
            [-16.77446958960785, 8.999056201053302],
            [-16.774439471141136, 9.004263640328732],
            [-16.7791566818087, 9.007761413385191],
            [-16.781668293619735, 9.013231826589472],
            [-16.78097854787965, 9.017651113293327],
            [-16.776964994548802, 9.022009417504941],
            [-16.774829912428316, 9.027477834745657],
            [-16.770477657397276, 9.03174646251179],
            [-16.764344733476623, 9.030534571630175],
            [-16.756377772000175, 9.033950898511526],
            [-16.753744278557523, 9.037242647550979],
            [-16.754038233854647, 9.045805808991487],
            [-16.751785719318306, 9.051445958318387],
            [-16.746626360359866, 9.057649245073035],
            [-16.746330428467814, 9.061965686556498],
            [-16.74814885261711, 9.067041812741438],
            [-16.743647938538707, 9.071885091657677],
            [-16.73707014167213, 9.073954904671892],
            [-16.736615762367116, 9.07776091141992],
            [-16.74436303416698, 9.080459650241686],
            [-16.752924782092904, 9.088752126250421],
            [-16.75305263731799, 9.090421323367712],
            [-16.75817956740162, 9.097193751759761],
            [-16.765968316854707, 9.097411480427846],
            [-16.771061542034836, 9.099392574042318],
            [-16.771427719114847, 9.103712012500957],
            [-16.769503480306692, 9.110446721502928],
            [-16.777490924707624, 9.117872680657086],
            [-16.77674417642958, 9.123073733507848],
            [-16.780575983236492, 9.133266621217434],
            [-16.780447224052484, 9.136203632497917],
            [-16.777347690163808, 9.139996222552153],
            [-16.773494044411827, 9.149610536826476],
            [-16.765573629852284, 9.157575454695094],
            [-16.763688871508503, 9.160579549768471],
            [-16.764154298965938, 9.167913879839277],
            [-16.768058400027243, 9.172979597365572],
            [-16.770574442276224, 9.178652772261147],
            [-16.76937783694778, 9.182008196823311],
            [-16.762288336521973, 9.188617619604154],
            [-16.761663646625017, 9.193049925162184],
            [-16.76474869854616, 9.208885407567223],
            [-16.764018160973976, 9.213755322485435]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.68943551038583,
          "lat": 45.405270807935146
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41055"],
        "coty_name": ["Sherman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sherman County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01135863"
      },
      "bbox": [
        -16.947091817644363, 8.607490588333876, -16.414169980275414,
        9.258562086341982
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.522112539738755, 4.214998591571107],
            [12.517910219793606, 4.239483823534021],
            [12.512873813036943, 4.271767251856565],
            [12.497319793512606, 4.362258053009725],
            [12.550020841275092, 4.370959577558588],
            [12.598018203730179, 4.379072203781372],
            [12.663865587947312, 4.3908670830819405],
            [12.75973907517958, 4.408155669377745],
            [12.811345848766242, 4.418002727569611],
            [12.896577580779935, 4.43305275806662],
            [12.953417878340668, 4.442968574651726],
            [13.000156221251483, 4.450577724658094],
            [13.008592569558367, 4.405989654559512],
            [13.010756779046925, 4.4063898936703865],
            [13.026034835878566, 4.316136659509462],
            [13.026802444597577, 4.3162665537947],
            [13.030832694175455, 4.295642881888421],
            [13.026540595058561, 4.294850980613396],
            [13.028433304785155, 4.2850219111165355],
            [13.008713461803458, 4.281005500815654],
            [13.020709785279031, 4.2025406400527485],
            [13.023333971700772, 4.18691869514667],
            [13.030530840791867, 4.138866796192571],
            [13.03849395416717, 4.092125297875249],
            [13.040461027743326, 4.075208528978541],
            [12.941011620971423, 4.06037253611979],
            [12.858215159070916, 4.045636934770617],
            [12.79461492768706, 4.033771408944987],
            [12.714416675751448, 4.019737676579126],
            [12.647793522971794, 4.006758996570753],
            [12.634217914836224, 4.004224246421085],
            [12.560471862981228, 3.990662622033346],
            [12.559772195009197, 3.9972413722436846],
            [12.548640840689156, 4.06091126275247],
            [12.546530880789666, 4.071273307674083],
            [12.53481857718716, 4.139953452864527],
            [12.522112539738755, 4.214998591571107]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.27404733285557, "lat": 41.814497830852 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42123"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "01213691"
      },
      "bbox": [
        12.497319793512606, 3.990662622033346, 13.040461027743326,
        4.450577724658094
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.259712774476624, -4.661532222986887],
            [12.263478544388589, -4.657453571138281],
            [12.346468628540995, -4.553141778909355],
            [12.429433064680781, -4.448798580767538],
            [12.467003759330627, -4.4026399527530256],
            [12.52884130193761, -4.324460174931716],
            [12.530274963507763, -4.323461105479235],
            [12.540546516117297, -4.327225518335803],
            [12.550688642849275, -4.3258366561783745],
            [12.555236413004616, -4.3292757109732865],
            [12.566794923491315, -4.328155049101498],
            [12.572682111192618, -4.324470360758386],
            [12.582706267234904, -4.3277324984297865],
            [12.586545456170244, -4.325621859570752],
            [12.592923138193788, -4.324933330143612],
            [12.599386847028526, -4.328749015056263],
            [12.604516071784674, -4.333119443564089],
            [12.61122361973749, -4.335126059491664],
            [12.613997219645634, -4.339236666439005],
            [12.62099358077549, -4.3425023790965644],
            [12.626057852578494, -4.348070625616555],
            [12.63078190918796, -4.348967259620037],
            [12.63469871246589, -4.352175409666164],
            [12.641289589883431, -4.3545688346105305],
            [12.646789352422457, -4.354988877101132],
            [12.652590265494037, -4.352962178140989],
            [12.653986650626457, -4.354978782674749],
            [12.661095717770705, -4.354352768787881],
            [12.675440038338076, -4.394927001572476],
            [12.678744952569875, -4.42653062691529],
            [12.686586073215716, -4.497289584224301],
            [12.69080854089488, -4.533456328950865],
            [12.692936430099813, -4.542260563445963],
            [12.69571483245105, -4.5638045189544405],
            [12.699179980535497, -4.570080237793579],
            [12.697059831580503, -4.578021931299571],
            [12.701097598484841, -4.5834157338469],
            [12.699273154588937, -4.5860987692175925],
            [12.701640103659178, -4.607811050320143],
            [12.701342055019278, -4.613488881482595],
            [12.702225755154343, -4.622588131098186],
            [12.700142907143709, -4.630034217358457],
            [12.70272847256475, -4.635818769973277],
            [12.707236548792036, -4.637208421001456],
            [12.71183303146532, -4.640908463504657],
            [12.712243917919468, -4.643520027632319],
            [12.716530113505984, -4.646849934460222],
            [12.717804669981161, -4.65144365635552],
            [12.722820542994148, -4.659987223711351],
            [12.729966496385982, -4.661963346044277],
            [12.730911279821362, -4.6649024526686125],
            [12.735500713324164, -4.669139472110425],
            [12.733350871858805, -4.670196939003073],
            [12.71973836567426, -4.669535921088148],
            [12.71397755443036, -4.67474362772416],
            [12.7083964344502, -4.674546316866412],
            [12.703296167148745, -4.6759499137522935],
            [12.696743542332797, -4.67511654892892],
            [12.690190778272594, -4.679817263157571],
            [12.67815716888472, -4.686059602064679],
            [12.67498983249677, -4.686923497553592],
            [12.667203085795425, -4.686249383269247],
            [12.662613227010446, -4.690781921402363],
            [12.595920934615036, -4.701629195304928],
            [12.587270236191346, -4.7000089541301655],
            [12.519395905964425, -4.686164645845506],
            [12.442653791216074, -4.674221778716322],
            [12.392887309431469, -4.745827579342167],
            [12.39206145493293, -4.7455851367215836],
            [12.369927663017316, -4.751380057857199],
            [12.36634161846822, -4.75050363002917],
            [12.355165251297548, -4.743472860457021],
            [12.34344371524814, -4.740582339150111],
            [12.338726969169167, -4.738355143938516],
            [12.321461722515787, -4.734979409393484],
            [12.315141619937908, -4.736036696722269],
            [12.309009517733312, -4.731686261191563],
            [12.299565448040896, -4.728241897968117],
            [12.292049492508108, -4.721970604271678],
            [12.278445744808675, -4.715498811476629],
            [12.276378646755628, -4.7118535790533995],
            [12.269286585963696, -4.708356047898467],
            [12.260547472555219, -4.700642882746102],
            [12.258562153781687, -4.694752940787706],
            [12.255114057097499, -4.69253226147335],
            [12.25578474666483, -4.689184909941701],
            [12.253171328963134, -4.682476078170536],
            [12.256048289112357, -4.680927425271639],
            [12.25298044648555, -4.676215510229083],
            [12.25397971493898, -4.672818590257286],
            [12.25812653977182, -4.670774396386967],
            [12.258204595239961, -4.665183336363505],
            [12.259712774476624, -4.661532222986887]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.43491792920581,
          "lat": 33.266058664909835
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45011"],
        "coty_name": ["Barnwell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barnwell County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01247983"
      },
      "bbox": [
        12.25298044648555, -4.751380057857199, 12.735500713324164,
        -4.323461105479235
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.478867326675976, -4.218349282877989],
            [13.480904646396915, -4.2139320208792155],
            [13.4854074471728, -4.216656475307423],
            [13.49199548312274, -4.217932298082522],
            [13.489584469740228, -4.207542501979764],
            [13.495090066540463, -4.206252851413898],
            [13.498198032922868, -4.20818568161978],
            [13.496601239851651, -4.2132324850442435],
            [13.500726272567222, -4.213737521430858],
            [13.504337388907699, -4.208593652806891],
            [13.507573759091269, -4.206770701706092],
            [13.510756198449018, -4.201899748987711],
            [13.514138905163941, -4.202862399297928],
            [13.51612132863248, -4.207127711320336],
            [13.520116738604381, -4.205312405624947],
            [13.523573017699157, -4.198815476092538],
            [13.524691129110423, -4.1933835575141245],
            [13.528906285812834, -4.198344450611227],
            [13.527688527762516, -4.2048490868172035],
            [13.533951921721709, -4.2048378349688935],
            [13.538284499519065, -4.202133977810411],
            [13.537147170198573, -4.196914473779667],
            [13.53419808687051, -4.1956457725968574],
            [13.534615716264103, -4.192161131016451],
            [13.540254142707052, -4.193165584929809],
            [13.542670936695025, -4.19650114505772],
            [13.545817942298362, -4.195179184127083],
            [13.54354124598387, -4.1905695898055635],
            [13.539223736317085, -4.187475857229367],
            [13.543553976040071, -4.185774921682675],
            [13.54718313416188, -4.189219369096816],
            [13.549539381257096, -4.186456626865281],
            [13.546371132435889, -4.183622235732284],
            [13.539853581106769, -4.181314724072025],
            [13.53431567006549, -4.178203712738845],
            [13.530431935533295, -4.174219958482148],
            [13.531334756613123, -4.165644062226608],
            [13.534929915055262, -4.167367499100315],
            [13.541502261124494, -4.162577710796449],
            [13.542237761346936, -4.1583303547708965],
            [13.548195733676632, -4.156262526526361],
            [13.546752373173268, -4.149486734328373],
            [13.548079838475154, -4.146951514367803],
            [13.558842062779005, -4.148859732130764],
            [13.562075745598946, -4.1471543434205085],
            [13.56848550332258, -4.149164379160016],
            [13.571044461369087, -4.146063740928814],
            [13.575202810472453, -4.146000781055957],
            [13.575729308036793, -4.141538285818152],
            [13.58188158058625, -4.143756682068401],
            [13.582946451673449, -4.137726295533961],
            [13.589794852981646, -4.135100291379289],
            [13.597307807119511, -4.1353032838342],
            [13.610204970900787, -4.132467929426263],
            [13.61615735245388, -4.136987177563019],
            [13.618077175988434, -4.135869051221661],
            [13.62000074749027, -4.130346404236075],
            [13.622879473403875, -4.131001482929061],
            [13.623870925478228, -4.134950353378521],
            [13.62677106027602, -4.134623736936754],
            [13.630385234412396, -4.129138598367369],
            [13.633847251911424, -4.132741580969732],
            [13.640217592862731, -4.128613785998084],
            [13.646192534087554, -4.130283904637735],
            [13.64808652121173, -4.136895531175707],
            [13.651755184156404, -4.137197748563412],
            [13.653300399031744, -4.131112584243308],
            [13.649764752522517, -4.126571252905878],
            [13.652924142374182, -4.124760129405361],
            [13.656866358156732, -4.126378797378978],
            [13.658095829672657, -4.1306834819399105],
            [13.662569094544157, -4.132211832889679],
            [13.665551027781579, -4.129920939419037],
            [13.671418770242159, -4.131019602933216],
            [13.673728078199737, -4.1272450441619455],
            [13.680162001149514, -4.128490412820521],
            [13.68386362432112, -4.132136448235452],
            [13.690882976585106, -4.134079281189272],
            [13.69274919773151, -4.138307984697905],
            [13.702284894924235, -4.14287238841508],
            [13.703031624377592, -4.146987717872619],
            [13.708021680596437, -4.145058565701518],
            [13.712632491734226, -4.149913888481597],
            [13.721818945072952, -4.155090918727298],
            [13.72614166864873, -4.155773597073227],
            [13.731796748413641, -4.1634402388890805],
            [13.736640220170129, -4.162081547803083],
            [13.74527996908771, -4.163242406349183],
            [13.749494591339024, -4.167708037307821],
            [13.754328271636643, -4.169091703466689],
            [13.758548674116545, -4.172009303152088],
            [13.762959668861349, -4.178908404927742],
            [13.76971013315152, -4.1785995127197415],
            [13.770340750189934, -4.183806047975543],
            [13.76805423328185, -4.185592626983744],
            [13.763047308351599, -4.185862248774189],
            [13.763827274925424, -4.189835867467019],
            [13.768774785036253, -4.189522393434156],
            [13.772552491019537, -4.1929428811116445],
            [13.776175327499038, -4.193053040532485],
            [13.77959146443187, -4.196647120519847],
            [13.780199237885968, -4.203269401029237],
            [13.785313245833413, -4.204597416807189],
            [13.786073046860142, -4.207953801448449],
            [13.794090231475804, -4.208931332333095],
            [13.798798577143218, -4.210781362925744],
            [13.801496558623255, -4.216121535079113],
            [13.823017662961467, -4.222616554310727],
            [13.830278848134418, -4.231287229070714],
            [13.834066727287858, -4.231026427877505],
            [13.840034174571205, -4.224425865145689],
            [13.843761535834398, -4.2283920072738335],
            [13.847183508615595, -4.228960603332663],
            [13.851766327029216, -4.232047904551107],
            [13.852470000960345, -4.236271380041697],
            [13.855842946723897, -4.240591331497738],
            [13.861897353206128, -4.2425917443894665],
            [13.866187455245852, -4.248388840256813],
            [13.867021302361506, -4.253478157407854],
            [13.872762137299855, -4.254899101552996],
            [13.873795019639077, -4.26152612014425],
            [13.879771350877599, -4.26161730187036],
            [13.878924132726922, -4.266127755544243],
            [13.88428160097984, -4.265030239571764],
            [13.889353251827972, -4.267125697547823],
            [13.892728664386933, -4.271776944930342],
            [13.900522492421864, -4.272797561250646],
            [13.904471294411255, -4.269945622859906],
            [13.911311379478775, -4.272317629668968],
            [13.918736383348419, -4.26837401907344],
            [13.921932489739334, -4.270796382160661],
            [13.92776160774405, -4.2705039900865644],
            [13.931557049208653, -4.273498015890143],
            [13.944227621874978, -4.27903021861747],
            [13.94817090185989, -4.279898012554608],
            [13.955520438025461, -4.282181444655143],
            [13.95975062142815, -4.284641551829118],
            [13.973740673677355, -4.284422507880989],
            [13.98788668986715, -4.285262216533186],
            [13.997908732465403, -4.2876642707671975],
            [14.004296157928282, -4.290344873480693],
            [14.010211822307399, -4.295252963904402],
            [14.019237560742589, -4.293714997377463],
            [14.034496000757144, -4.295642460236739],
            [14.047650417292395, -4.295666268838929],
            [14.052078496160101, -4.298904766824029],
            [14.050426894313947, -4.305585010126171],
            [14.055059637223163, -4.305754018538579],
            [14.059174168932277, -4.301345816746086],
            [14.063351058130463, -4.309777855651899],
            [14.065496838825998, -4.311155411903076],
            [14.071677526579425, -4.311467279500261],
            [14.073576702918709, -4.314494718435467],
            [14.084160577814197, -4.316449364076698],
            [14.089769438171453, -4.315762208626534],
            [14.095335423334557, -4.316966439508052],
            [14.109837791758737, -4.321999537940751],
            [14.113753680533112, -4.3204889227907355],
            [14.116213564720704, -4.316319247342067],
            [14.117404839739368, -4.310599191109494],
            [14.12160293216688, -4.3125577890308815],
            [14.118347865855915, -4.319597200717651],
            [14.12251727215206, -4.32074854970359],
            [14.126911172612619, -4.315889192740255],
            [14.130167417871679, -4.3179379674906855],
            [14.12650783920309, -4.323038820708766],
            [14.127344743703711, -4.325313692234319],
            [14.133707119861759, -4.322398205434052],
            [14.13883442684565, -4.317747955672036],
            [14.142397912423847, -4.323253459008643],
            [14.146280981173058, -4.326440206563724],
            [14.144283461359755, -4.3327586643949605],
            [14.14696854694952, -4.33582522260289],
            [14.152479152227382, -4.337532821640524],
            [14.150604362082577, -4.3441028534453325],
            [14.146394127346603, -4.342032556443783],
            [14.140628844676636, -4.345682767312363],
            [14.133145968817123, -4.344041664673255],
            [14.128232918593651, -4.346457271026051],
            [14.128706661755606, -4.35233376065872],
            [14.123895378826086, -4.352373073783847],
            [14.12574678376514, -4.357610872084811],
            [14.123675229405768, -4.364072257744267],
            [14.118489576823274, -4.365537001590883],
            [14.116588468602233, -4.37267017621234],
            [14.117792168777534, -4.37787132164929],
            [14.111523060203437, -4.38180218108368],
            [14.112839051567477, -4.3844658621998045],
            [14.10993041617401, -4.391428009129341],
            [14.106424831576405, -4.393796109389877],
            [14.107010508343159, -4.399497259059666],
            [14.108604552755999, -4.401648732864779],
            [14.105119661793639, -4.411423986844196],
            [14.100110809577805, -4.415562874976344],
            [14.095389119757975, -4.41654392856271],
            [14.093096420463416, -4.41866166286733],
            [14.083711678058078, -4.414233874090076],
            [14.077971525784248, -4.409496909993586],
            [14.06923119715723, -4.410222255547791],
            [14.061410730571742, -4.418248630116581],
            [14.049660974904578, -4.423285952220902],
            [14.041749436844174, -4.429875907461136],
            [14.040811509793826, -4.437983141297228],
            [14.033410066422581, -4.440167282776427],
            [14.029705005901125, -4.435520088515675],
            [14.023228418272284, -4.4390288150996176],
            [14.02226130154724, -4.442389837574137],
            [14.018602630003368, -4.447058020528698],
            [14.013436701886691, -4.447799099034499],
            [14.007669126753497, -4.453531901879506],
            [14.00506927567561, -4.460599473549572],
            [14.00544548177457, -4.4669302204215615],
            [14.000958122987456, -4.478695225809771],
            [13.998547128581418, -4.489284261667485],
            [13.988722144716009, -4.501544331333112],
            [13.985668999587414, -4.508795037601605],
            [13.978123844768255, -4.52406017623219],
            [13.973394658952994, -4.530127838976756],
            [13.971373067905528, -4.539699466537008],
            [13.964383799756142, -4.5447368979729585],
            [13.961664549006274, -4.54888747957388],
            [13.958698274025243, -4.55711206914395],
            [13.955500428015101, -4.574858067753671],
            [13.954700652731344, -4.576473023765136],
            [13.945479767333469, -4.585449860067596],
            [13.941599576943267, -4.59158522223794],
            [13.938354876430909, -4.594663993865042],
            [13.932606004757465, -4.604243953655],
            [13.929658964245226, -4.618556756822078],
            [13.930198527328072, -4.625572411908512],
            [13.933743250997662, -4.629438312779471],
            [13.936691971365141, -4.6350115994556],
            [13.933446724756653, -4.642072051572113],
            [13.932872373849433, -4.652287088078466],
            [13.926565884788095, -4.651436996509544],
            [13.922028384070307, -4.6535586531622855],
            [13.91267194317936, -4.663461707515952],
            [13.90860865236473, -4.669781138329513],
            [13.899880302166496, -4.673096032996084],
            [13.89763381022595, -4.6780662216390905],
            [13.89238963334076, -4.68321389413651],
            [13.883103122880966, -4.684870940403708],
            [13.881157616735178, -4.690780828393692],
            [13.883375196181523, -4.698651166994791],
            [13.882790681167224, -4.706749452137598],
            [13.88080793207393, -4.716269928698728],
            [13.8771998225751, -4.7287262886870645],
            [13.873041394613121, -4.734666272933372],
            [13.86152161188976, -4.740150876430969],
            [13.852278902743977, -4.743489250448264],
            [13.844365245923903, -4.75069420946434],
            [13.8433079855548, -4.755825272304654],
            [13.84808830951892, -4.767249275846641],
            [13.849210003799582, -4.779231499614489],
            [13.845594223265556, -4.785850937056633],
            [13.840731918340975, -4.7895008547423314],
            [13.838825597093717, -4.793030416348339],
            [13.832378920099947, -4.7944667923504],
            [13.824038286882502, -4.790809020213761],
            [13.821885466566908, -4.788767869249136],
            [13.819617524211806, -4.781463550609959],
            [13.819118798155111, -4.769382806656828],
            [13.814376685155933, -4.763709308855936],
            [13.806247406614084, -4.761465432799195],
            [13.797175132232205, -4.760839515525415],
            [13.791691055132436, -4.755979462130232],
            [13.786135920233914, -4.746018020238991],
            [13.784079078534754, -4.737759059572595],
            [13.784408316423622, -4.72934810869546],
            [13.786100537080976, -4.723009463346566],
            [13.794143560301924, -4.710784103543843],
            [13.790691755772063, -4.708774593450385],
            [13.742523252139119, -4.72744634481789],
            [13.708803441026626, -4.6770720069306595],
            [13.70697980933073, -4.6719634001684245],
            [13.705311930416588, -4.6494474219795885],
            [13.70018841020327, -4.647995552990818],
            [13.695328216182366, -4.64324156544309],
            [13.689410065348723, -4.635237569114511],
            [13.68606324729478, -4.637375151217977],
            [13.667447886143401, -4.645102877076858],
            [13.656614324031999, -4.652208724823954],
            [13.650251445812241, -4.6488191988126975],
            [13.649786574545269, -4.645320965519442],
            [13.646601837426067, -4.642042280697054],
            [13.64250237013165, -4.644456976168225],
            [13.609080825814898, -4.6261265972958965],
            [13.594966824516632, -4.617616911891839],
            [13.51387575558625, -4.572782530534183],
            [13.435212658072016, -4.529138174716189],
            [13.44608375821802, -4.519245239136406],
            [13.448322828389164, -4.515178056095726],
            [13.453581620794939, -4.512976406289842],
            [13.455354458736496, -4.505573386810524],
            [13.458138912489614, -4.500659188448512],
            [13.458464971678952, -4.496013959400234],
            [13.46177225509266, -4.491618849715728],
            [13.460670560629515, -4.487909688066597],
            [13.450695207349147, -4.483461218233858],
            [13.450043848536524, -4.480935546791937],
            [13.443716174134693, -4.479212087849225],
            [13.43567950694874, -4.475094163465694],
            [13.430666955412994, -4.476018316303244],
            [13.423238377724267, -4.460004509157181],
            [13.423276730425265, -4.452260131310239],
            [13.420244432456865, -4.447308788012301],
            [13.41130053729404, -4.440914690834101],
            [13.40883765418078, -4.435381230453282],
            [13.40949503687298, -4.431892509162497],
            [13.407910006239723, -4.428416161057107],
            [13.404947023104185, -4.42824775145026],
            [13.398751532674524, -4.423218203329292],
            [13.395487124668904, -4.421804223320778],
            [13.39534157942374, -4.407022662723501],
            [13.398389833668597, -4.40166964775827],
            [13.406218313244837, -4.399265592165111],
            [13.41226768879523, -4.40027336106292],
            [13.41904165178613, -4.402856686252268],
            [13.426502887699588, -4.407903793230525],
            [13.430969210826959, -4.409130249971905],
            [13.435489857249628, -4.4079186236052035],
            [13.442918978994475, -4.403745686831858],
            [13.448403570181544, -4.398970262520279],
            [13.451372635497735, -4.390481258486542],
            [13.459578406886571, -4.385574554393847],
            [13.463929243441553, -4.381657848824393],
            [13.465118547286142, -4.376680822949565],
            [13.470277518374282, -4.373888864568869],
            [13.475448226063968, -4.365214136977409],
            [13.477050280233126, -4.365702214674552],
            [13.476710892347414, -4.354508594383189],
            [13.474818942565639, -4.343653920363241],
            [13.47752449251229, -4.335672956152427],
            [13.475449635101226, -4.326374017100658],
            [13.479894322535312, -4.311343540890031],
            [13.47857202020806, -4.300733594121085],
            [13.47678211047165, -4.297340260328938],
            [13.475931898140175, -4.29128183982586],
            [13.474154290545329, -4.288020720060604],
            [13.473176722321215, -4.281027523476722],
            [13.474366431264222, -4.2726147953036335],
            [13.480493772094299, -4.278746425733559],
            [13.482259777914681, -4.278471893595652],
            [13.481319387616185, -4.271024373887401],
            [13.487344084557677, -4.270310187492165],
            [13.48569095228568, -4.257093093169397],
            [13.482188288654333, -4.252796613053151],
            [13.482349750861031, -4.246957374617466],
            [13.4798902692425, -4.236749390889724],
            [13.481025957161876, -4.227286447215387],
            [13.478867326675976, -4.218349282877989]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.95216461937409, "lat": 33.19727717847503 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45015"],
        "coty_name": ["Berkeley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Berkeley County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01247985"
      },
      "bbox": [
        13.39534157942374, -4.7944667923504, 14.152479152227382,
        -4.124760129405361
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.841063401707462, -4.746008964131453],
            [12.87887632989232, -4.712781516569614],
            [12.948413171876531, -4.651852219237808],
            [12.953640651179885, -4.655414008761193],
            [12.95608512266224, -4.6625489488232015],
            [12.959390683650632, -4.667198858471227],
            [12.966465518638907, -4.67063095677367],
            [12.970598835254199, -4.6794951677505985],
            [12.978649321487257, -4.684191797118472],
            [12.98074095231141, -4.689724303926608],
            [12.988735224501005, -4.687247093534928],
            [12.989940586633024, -4.672750202703719],
            [12.995605364444218, -4.657408657477325],
            [12.999437948336245, -4.6532602521723065],
            [12.994976425717285, -4.648561700986034],
            [12.988030123164625, -4.645909997630017],
            [12.987392135322787, -4.6357932424951045],
            [12.98407167415079, -4.629140778088316],
            [12.979084354235361, -4.623832422767526],
            [13.013340194437959, -4.593935582193086],
            [13.05092333650213, -4.559886901465762],
            [13.056550515569413, -4.555021996996596],
            [13.060370487316579, -4.560245301887931],
            [13.066410354885791, -4.55757567872799],
            [13.073058572606488, -4.561793163842648],
            [13.079836602432644, -4.558584815607291],
            [13.087837267496512, -4.556694074286666],
            [13.093066932376683, -4.557898485445967],
            [13.09680362950619, -4.561392677291389],
            [13.101640223615243, -4.5583960647418085],
            [13.12371626357885, -4.5686543676827105],
            [13.13272632767842, -4.571550198820409],
            [13.130595489168206, -4.574527619045589],
            [13.134077045725183, -4.579553659901672],
            [13.141640877587955, -4.582030097904948],
            [13.144510894981778, -4.584849454239525],
            [13.143822713992972, -4.590199588511498],
            [13.145960527207396, -4.594161984030296],
            [13.155231985375796, -4.596402391281204],
            [13.159044935668362, -4.604726810572685],
            [13.163688793656023, -4.607443955444437],
            [13.16412366253572, -4.611658584257854],
            [13.16741633682922, -4.615666895091843],
            [13.17248429987192, -4.619013052486972],
            [13.17727912316038, -4.620121453461846],
            [13.176332643566314, -4.623326238603254],
            [13.179482695650425, -4.625190297346997],
            [13.18324727961856, -4.623650203815603],
            [13.187003916032527, -4.626416651076126],
            [13.189645527982112, -4.630368242635607],
            [13.19299494997183, -4.631198294971177],
            [13.203032020997746, -4.636162364310116],
            [13.208020307210553, -4.643666259151515],
            [13.211657348500683, -4.645706089685952],
            [13.219091740553685, -4.646238462022386],
            [13.224853555422621, -4.647766205360234],
            [13.236461219506225, -4.64882788359133],
            [13.23970307571237, -4.65039530600829],
            [13.247312433850984, -4.648499885338499],
            [13.25048391886392, -4.6492154286701],
            [13.256256904601676, -4.646061500441018],
            [13.261399048340994, -4.645221929200958],
            [13.270495672805623, -4.641196646331789],
            [13.273472894541383, -4.6443663634332975],
            [13.27759802121916, -4.639711296436227],
            [13.274612374710992, -4.636634552524791],
            [13.282557534436666, -4.634125460058804],
            [13.286651884502513, -4.630698603197606],
            [13.29105932490481, -4.633372473483201],
            [13.292924602119689, -4.63828506865589],
            [13.297455029920988, -4.636674030363669],
            [13.302607249074912, -4.639468292156821],
            [13.307027522162171, -4.639956691181053],
            [13.31902971379182, -4.635543645342778],
            [13.322347591198508, -4.631038475041807],
            [13.326877100690108, -4.6324583658203045],
            [13.333453605141463, -4.631678315223603],
            [13.334530042263772, -4.628194322917825],
            [13.34035998245021, -4.629004347546968],
            [13.345784930816677, -4.628482624006503],
            [13.351243678084845, -4.630937917530149],
            [13.354148300085736, -4.629201429647036],
            [13.364277797434397, -4.634615521272464],
            [13.372022391754461, -4.6352036527995155],
            [13.377759559713825, -4.634212533990226],
            [13.379565756506576, -4.630420320235699],
            [13.389022726534126, -4.6373190574107435],
            [13.397307803018904, -4.62966430340386],
            [13.407966055732153, -4.637854337041934],
            [13.41117405277159, -4.647645422767831],
            [13.407543552358097, -4.655115119922127],
            [13.398108474166717, -4.663865701104267],
            [13.3993593411498, -4.678332516823199],
            [13.400732807776857, -4.686642379112378],
            [13.39876034936395, -4.689674957945715],
            [13.401943674237183, -4.698210540295616],
            [13.399012025663923, -4.699788961505243],
            [13.398761313700543, -4.70437019982821],
            [13.395279108145159, -4.70871672218378],
            [13.396471514383137, -4.716740616071746],
            [13.400276435407408, -4.721960105182853],
            [13.402783051786978, -4.723364207139952],
            [13.408054373123168, -4.7296222399224375],
            [13.410846579598495, -4.731496381028031],
            [13.409139847252122, -4.7345539553721006],
            [13.417569973293633, -4.744999371103666],
            [13.417010463205598, -4.747879810124421],
            [13.41993608452825, -4.753898975337006],
            [13.418743204846757, -4.763776072323005],
            [13.415969532429282, -4.767120273904924],
            [13.416017068628303, -4.771488883858362],
            [13.41917972895051, -4.772479379966061],
            [13.420788477960695, -4.776541523483228],
            [13.425131430845775, -4.779598392236088],
            [13.429795441523538, -4.785560594170051],
            [13.437355286027282, -4.7924700657910995],
            [13.436017257634473, -4.794257252248922],
            [13.430949728715076, -4.794379688536866],
            [13.430928964877547, -4.799149567367891],
            [13.427592580756391, -4.802552035833258],
            [13.428043040046473, -4.807125083077831],
            [13.425309855294229, -4.811202126530875],
            [13.42644938222957, -4.81484632961552],
            [13.429424461973287, -4.81580247003481],
            [13.42873424539298, -4.8219293878863905],
            [13.43239537698008, -4.834322354314156],
            [13.436959734634435, -4.834828982137791],
            [13.434193191820553, -4.844465736093925],
            [13.434559658656907, -4.8516615146930135],
            [13.432100382339703, -4.8578825445470155],
            [13.433072089672955, -4.861753091229238],
            [13.43127631437054, -4.86997372433349],
            [13.42637873618801, -4.872814504480192],
            [13.42233441624307, -4.884102650650117],
            [13.41822043573137, -4.885236689967924],
            [13.41412601772391, -4.893999204329404],
            [13.411814934672242, -4.8966513820659525],
            [13.415622331427778, -4.9005738456009205],
            [13.415831743375144, -4.905395487038425],
            [13.412197116597248, -4.911823124963072],
            [13.4141794992212, -4.914055822220893],
            [13.41160809249981, -4.9197362257860995],
            [13.407851308744206, -4.920051687132196],
            [13.405579971745489, -4.928651590833725],
            [13.408379361461998, -4.937138390249229],
            [13.405862344364783, -4.943146307300914],
            [13.405540839183194, -4.947129182295025],
            [13.410127599541072, -4.952044807799353],
            [13.41231597413826, -4.956862105936293],
            [13.426360385972085, -4.960444004648161],
            [13.427837903817506, -4.964469894744555],
            [13.42423311935528, -4.9673356289642605],
            [13.424502287279843, -4.970348645908811],
            [13.428449132371556, -4.970683049027055],
            [13.43174412755567, -4.966358792395668],
            [13.43468860375395, -4.967187079377631],
            [13.4348532368184, -4.971605853831793],
            [13.441360400477137, -4.98111237010834],
            [13.443630007235413, -4.985873717570004],
            [13.442544338209549, -4.989462343028463],
            [13.439518405944138, -4.992204603840273],
            [13.439545242043216, -4.99503796144742],
            [13.44430098087801, -5.0000405356646045],
            [13.442859078758634, -5.0071205269936545],
            [13.443536705548777, -5.010961685194365],
            [13.449573886596935, -5.017468088726923],
            [13.459645672877638, -5.02623157379658],
            [13.462953777774443, -5.026138837741477],
            [13.468770762246821, -5.021846685922419],
            [13.472802044286885, -5.024188458629447],
            [13.471623693157383, -5.029570771872019],
            [13.46820773332997, -5.031363473483464],
            [13.463874334206151, -5.038622857671722],
            [13.463020229683472, -5.049556931706006],
            [13.458573235814372, -5.052634011049832],
            [13.451234018565893, -5.052990587186926],
            [13.44700304626453, -5.0544573220403795],
            [13.44545766585141, -5.058988991938656],
            [13.44895253475413, -5.069545758319473],
            [13.452701963235523, -5.075148664634484],
            [13.456383824241332, -5.075628561845804],
            [13.461585186237686, -5.067757617163343],
            [13.466884927847456, -5.06119497502782],
            [13.473703135768913, -5.057224575734244],
            [13.477549532598871, -5.057526997747705],
            [13.480910408496511, -5.062935227464766],
            [13.480597584420071, -5.066442644906078],
            [13.476369387168951, -5.078552482670204],
            [13.476281660987722, -5.086438628532566],
            [13.483006443518072, -5.096428283782497],
            [13.48546068087201, -5.103741150948587],
            [13.484155496551622, -5.111799280904098],
            [13.480068626220632, -5.1160679746507745],
            [13.473723969672807, -5.1178718901903775],
            [13.469237644231008, -5.121673675053329],
            [13.467574746469738, -5.126917542473838],
            [13.468810282458824, -5.132283652883394],
            [13.476757026187322, -5.136722027623513],
            [13.492965274831544, -5.13920941314497],
            [13.50003239951938, -5.142075079917044],
            [13.508579251989545, -5.149104972686792],
            [13.519363158156985, -5.161299246710926],
            [13.529839208959626, -5.170717615974127],
            [13.53566412244582, -5.171599184241921],
            [13.543378547036967, -5.174415135831655],
            [13.550177496621432, -5.172791137126895],
            [13.551590562887004, -5.165621553706705],
            [13.548986517714106, -5.161135101291348],
            [13.545330301068713, -5.160150057293652],
            [13.542102112372387, -5.154672299733436],
            [13.53605931913175, -5.153457824075932],
            [13.532038677994839, -5.151013683306076],
            [13.527838916409564, -5.15128955409581],
            [13.526913469631918, -5.145411800526333],
            [13.535398301790787, -5.145058924325917],
            [13.538615080760154, -5.1411683622946285],
            [13.541975406670291, -5.144198846264822],
            [13.544986848433282, -5.142122941223944],
            [13.55030449390788, -5.142591837082212],
            [13.552658261690368, -5.1465280017222925],
            [13.552272786247604, -5.152221016736118],
            [13.553825455100625, -5.154165821020425],
            [13.559718865492314, -5.150451932370088],
            [13.573850770836627, -5.13496449822577],
            [13.578862397609354, -5.130849820480029],
            [13.58419254430838, -5.135373151977091],
            [13.588241693394677, -5.134868417423183],
            [13.595622842385977, -5.129609020022195],
            [13.595173224037799, -5.125033850432133],
            [13.598947202183636, -5.124218837331106],
            [13.601485087731406, -5.120141408576036],
            [13.604114886426547, -5.124277282319713],
            [13.587230751895332, -5.1415811227205985],
            [13.574593468624713, -5.158214599392854],
            [13.548262803284048, -5.18857247330465],
            [13.543263696038723, -5.188765020373028],
            [13.539521164327502, -5.184263066487544],
            [13.533721316927961, -5.174335023890088],
            [13.521537837015691, -5.170956907323498],
            [13.520479053653391, -5.175381659269447],
            [13.515713147049077, -5.180078022736347],
            [13.515095163431003, -5.184436756198877],
            [13.510603617134098, -5.184771840101949],
            [13.501691955941721, -5.1913313641747365],
            [13.501090632610921, -5.197385199306505],
            [13.498960709228845, -5.199538494413154],
            [13.48240554499458, -5.2069987408023355],
            [13.48014245994528, -5.205948600165366],
            [13.476384665277807, -5.199575180861498],
            [13.475084111336827, -5.189093822697664],
            [13.47175580927277, -5.184226670084885],
            [13.467867572120678, -5.182968835217147],
            [13.463018801668309, -5.179502801339899],
            [13.451475069692966, -5.177323703798263],
            [13.44855814787807, -5.179227535529233],
            [13.442952918517511, -5.180149018891935],
            [13.441150831505862, -5.184514447809398],
            [13.436905663091029, -5.186941505686184],
            [13.42961235133485, -5.188995866181731],
            [13.427380284837264, -5.201052567854191],
            [13.419199636367033, -5.199909170875584],
            [13.404274075325718, -5.1944830615994295],
            [13.400636830792077, -5.188198712269949],
            [13.388182003237613, -5.1732833567094625],
            [13.377697971511836, -5.171329664221223],
            [13.371047159947128, -5.165847384564874],
            [13.364588084895566, -5.1504016337250045],
            [13.357319772038545, -5.140200868323043],
            [13.352672416460834, -5.131756709840731],
            [13.347727029812676, -5.132129849384896],
            [13.347259106266629, -5.137212339412248],
            [13.348241746559115, -5.143198797877151],
            [13.346040129776119, -5.1478738849195045],
            [13.34074611056298, -5.146700693818541],
            [13.340169134472141, -5.143140910708103],
            [13.342158163597027, -5.135423131151856],
            [13.339490951258279, -5.1332294686214315],
            [13.332069474730558, -5.135828510226658],
            [13.32670244421218, -5.1355575565573375],
            [13.325332905895413, -5.131180845021443],
            [13.330328992105393, -5.123230805605403],
            [13.329969541783505, -5.119938783996712],
            [13.326237298806742, -5.117288022175935],
            [13.320535655817626, -5.116289795741698],
            [13.310263225950118, -5.123164993613963],
            [13.307304018767441, -5.122907822131026],
            [13.302794613064345, -5.116150051093479],
            [13.299014341437559, -5.116039416626925],
            [13.29445446010434, -5.124527406614183],
            [13.292797053148988, -5.125851438792256],
            [13.286959598621932, -5.123870154273234],
            [13.284028580131418, -5.1176314928862805],
            [13.28028574122248, -5.1162654896813935],
            [13.271323123499409, -5.115920422427061],
            [13.268060363745994, -5.114471890404254],
            [13.255566186477095, -5.0999428446829596],
            [13.254954808494874, -5.094635179126126],
            [13.258436945927656, -5.086789688214187],
            [13.2550550549853, -5.083950150210865],
            [13.251450896406817, -5.085899875198595],
            [13.246725322292328, -5.091076161788908],
            [13.240821172054623, -5.0896466781116505],
            [13.239671231230231, -5.08346694821755],
            [13.242390098935982, -5.080485837689452],
            [13.251385690711986, -5.079121952743666],
            [13.252295016036744, -5.073351109110362],
            [13.249842341898855, -5.069814508420449],
            [13.244695315795429, -5.0681885348959295],
            [13.237091996393795, -5.072679006579191],
            [13.233736086006761, -5.071782276111344],
            [13.227810134041462, -5.060374614582162],
            [13.228556539752967, -5.054836334271784],
            [13.23029482696154, -5.053121523390314],
            [13.238311959760447, -5.0530509060858355],
            [13.240423946794879, -5.048750672486951],
            [13.238281076146116, -5.044540103305299],
            [13.233824542590098, -5.042842249101929],
            [13.224269453606947, -5.043986875540092],
            [13.221721467525692, -5.050019930441644],
            [13.211178340633944, -5.0544491082990834],
            [13.209578190056071, -5.053943533414041],
            [13.207164202099097, -5.046309825536798],
            [13.202163777451037, -5.047517070797463],
            [13.198496210806706, -5.046777985542572],
            [13.196362839357118, -5.041704289967976],
            [13.191212403590356, -5.043748181354213],
            [13.190641782404693, -5.047269134889519],
            [13.18701325560612, -5.047998075846739],
            [13.185081481345732, -5.043444852036119],
            [13.178656531220035, -5.0417177215686495],
            [13.17819282546746, -5.045904392878568],
            [13.175291807960457, -5.0504566973869816],
            [13.168423766282581, -5.0514137857849954],
            [13.16339341540766, -5.047128216625247],
            [13.159938082322231, -5.051774206282338],
            [13.153095644882802, -5.051294737675862],
            [13.147045182100292, -5.048405661099163],
            [13.14695516783094, -5.043026642190284],
            [13.144170910696523, -5.0427235832158015],
            [13.141557530324336, -5.045947321697784],
            [13.138894470966571, -5.042883192604804],
            [13.130336577354901, -5.043341545358449],
            [13.127717903190971, -5.045299984959291],
            [13.125021189209955, -5.0416207522880345],
            [13.120819063012988, -5.043786644053023],
            [13.117353869129845, -5.036832612795737],
            [13.11568441559362, -5.038932603412155],
            [13.11085138913694, -5.036206868050077],
            [13.105576413266007, -5.03624841621347],
            [13.103213581921665, -5.031507144038489],
            [13.100488068763715, -5.0273618528022945],
            [13.094203352013862, -5.022627009232246],
            [13.089827673062372, -5.021194934034912],
            [13.08477883824408, -5.0152139145243995],
            [13.07922801049551, -5.00678975993425],
            [13.076513892561325, -4.997129398213592],
            [13.073162821988513, -4.991313086670505],
            [13.067914418240937, -4.988183551910266],
            [13.064022321349952, -4.9770372226195],
            [13.060069057856845, -4.972323535905038],
            [13.058907951982052, -4.9662758303186205],
            [13.056189608181567, -4.965223614762736],
            [13.055446798346557, -4.961481102458351],
            [13.051566725904655, -4.958360077378545],
            [13.051056282604758, -4.955627892425167],
            [13.045801382964077, -4.953084767079999],
            [13.041218699296365, -4.946130926762784],
            [13.032697787204501, -4.939891144306218],
            [13.028919112767454, -4.935536784899046],
            [13.028202087118602, -4.930895438526356],
            [13.023574237703556, -4.9215519613190395],
            [13.021878633556783, -4.914280005948085],
            [13.01753172564087, -4.910122314088336],
            [13.013637387683472, -4.908135735573883],
            [13.011106777363155, -4.904413762334208],
            [13.007999505065072, -4.904428180154547],
            [13.00540836648734, -4.89842136471716],
            [12.998517461174933, -4.893032848286304],
            [12.994712466105684, -4.892700168455525],
            [12.99368361938934, -4.888929198841666],
            [12.989385828223268, -4.885555100731953],
            [12.985247383500838, -4.885169553738852],
            [12.983495903376088, -4.882250551617458],
            [12.977433449600005, -4.876975133386865],
            [12.974511043826222, -4.878745744172878],
            [12.9674645120997, -4.878802706119421],
            [12.956274181159282, -4.865907927376822],
            [12.95428441881686, -4.865794665089008],
            [12.948601012880543, -4.860373767157552],
            [12.93917626418439, -4.8579666463422475],
            [12.93644897827922, -4.852988397874667],
            [12.934950858818764, -4.846141888143266],
            [12.930392350217419, -4.842721960509652],
            [12.924401192185217, -4.829673913761449],
            [12.914582107942413, -4.822209879678704],
            [12.913573600827252, -4.817668953179779],
            [12.909145419646375, -4.811848380258757],
            [12.909043096929755, -4.808153654739005],
            [12.903819634643169, -4.804980787730831],
            [12.901729045216802, -4.8000515261690255],
            [12.896032084635786, -4.798372592719132],
            [12.8927168949457, -4.791375799258709],
            [12.885542522276515, -4.787193695056145],
            [12.878598807542794, -4.781719574300684],
            [12.870795377697814, -4.778950577542832],
            [12.86820352148075, -4.774557558537602],
            [12.866970290497736, -4.767044848828367],
            [12.859578619404791, -4.763048258138195],
            [12.857624594397244, -4.756611689282959],
            [12.853473574376928, -4.755888155474212],
            [12.848289544123045, -4.751821329597647],
            [12.844992860526636, -4.750929070930002],
            [12.841063401707462, -4.746008964131453]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.66702373474564,
          "lat": 32.863672790488685
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45029"],
        "coty_name": ["Colleton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colleton County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01247991"
      },
      "bbox": [
        12.841063401707462, -5.2069987408023355, 13.604114886426547,
        -4.555021996996596
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9303942138585195, 6.581624404680974],
            [-0.9278997732310511, 6.6824455471716515],
            [-0.9260222425496475, 6.75443941352672],
            [-0.9238511574261039, 6.840851348114395],
            [-0.9218314031847467, 6.927253919916619],
            [-0.8352689737268961, 6.925079076030341],
            [-0.7482907530132983, 6.92332524291281],
            [-0.6688876891997234, 6.921899313510015],
            [-0.6511833357331238, 6.9213989125012105],
            [-0.5607106963062987, 6.920034072101479],
            [-0.497565291243934, 6.918981328566406],
            [-0.4918727708368802, 6.89020638860931],
            [-0.4534771398394895, 6.889594597775598],
            [-0.4389667857128947, 6.889108752351357],
            [-0.39556330673944806, 6.888336818941358],
            [-0.39635022706045786, 6.81650315678899],
            [-0.39639016086059964, 6.802212150867629],
            [-0.39738456355965235, 6.741367411877759],
            [-0.3976461055729419, 6.715792800018256],
            [-0.39777859791622494, 6.6729479480302025],
            [-0.39833326060677227, 6.629599854872604],
            [-0.39890097504638494, 6.571534245012804],
            [-0.40024203828137667, 6.484637940507645],
            [-0.4100805078590546, 6.4841272452893515],
            [-0.5024583589826508, 6.486081632665216],
            [-0.5384390731302389, 6.486426090012783],
            [-0.5890325951795328, 6.487128856589273],
            [-0.6755542020588825, 6.4885798536407195],
            [-0.747407826187923, 6.490371096937767],
            [-0.8370953523698887, 6.4918856221334815],
            [-0.9324478034674529, 6.495024330194229],
            [-0.9318563162762453, 6.513772670579657],
            [-0.9303942138585195, 6.581624404680974]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.60742129831932,
          "lat": 45.367136637157714
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46037"],
        "coty_name": ["Day"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Day County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01265790"
      },
      "bbox": [
        -0.9324478034674529, 6.4841272452893515, -0.39556330673944806,
        6.927253919916619
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.20398844371473177, 4.8338609481988835],
            [-0.1359933629915925, 4.8335225371080295],
            [-0.028224132080212305, 4.832705351233934],
            [0.03131650927215039, 4.832415886978624],
            [0.031105725429821405, 4.827982208537955],
            [0.034309033884673955, 4.825262098861548],
            [0.04039527785982082, 4.823006887123196],
            [0.04034754855992956, 4.815413386114756],
            [0.0441460530724492, 4.813257638171741],
            [0.04011858059866498, 4.810393872043078],
            [0.04214883790124725, 4.806179395718862],
            [0.04109283913561137, 4.803021045371369],
            [0.04299040627947745, 4.798914436427521],
            [0.03512074596869199, 4.7947317250038894],
            [0.034614565343341126, 4.790736886437718],
            [0.030240004004017662, 4.7890100632983925],
            [0.02833670786005958, 4.781581587720005],
            [0.03427530787956998, 4.766027970321241],
            [0.03886348112605597, 4.763528219767769],
            [0.04804453452903704, 4.7635433336337085],
            [0.05160800102675188, 4.760362671386102],
            [0.05117112965280955, 4.755512671264003],
            [0.04912635134090064, 4.750991689458211],
            [0.05278631755173963, 4.748955976861646],
            [0.05693159532481717, 4.7444901748956525],
            [0.06061350650409147, 4.738470049090173],
            [0.07534625252250461, 4.726639510451003],
            [0.08479697831547418, 4.726285489140371],
            [0.08653419308158465, 4.717140444194245],
            [0.0866534573956724, 4.706090069289081],
            [0.08226140042514826, 4.699606178938764],
            [0.08268437590177928, 4.683302080293528],
            [0.08435624084111602, 4.678666397992941],
            [0.07660787535686718, 4.667950785547975],
            [0.07787480598400166, 4.660044492430853],
            [0.08090834084214095, 4.6479810828913335],
            [0.08324054105590702, 4.643867096482981],
            [0.0796754546702209, 4.631431960593276],
            [0.0719417171849084, 4.626989405622735],
            [0.06319989646719838, 4.624338707004071],
            [0.06164779603507237, 4.6262942276607655],
            [0.051612432691129015, 4.627086709412489],
            [0.04841489565486682, 4.630747378326503],
            [0.04160829812690321, 4.629741787944216],
            [0.03758191160361645, 4.627977319676605],
            [0.03862406367285887, 4.623430726474762],
            [0.04288435125728722, 4.626688544906864],
            [0.043173702218868557, 4.620610811706383],
            [0.04521048382866625, 4.611499787544566],
            [0.04294440160278218, 4.606366017780993],
            [0.0390203959035354, 4.605908137942154],
            [0.03978136404935268, 4.600452257761121],
            [0.04587472644549015, 4.59984405337416],
            [0.05498279319159225, 4.591705239714278],
            [0.06164702994855898, 4.5914256710453145],
            [0.06335403114927522, 4.589181486370193],
            [0.06302316536265579, 4.578675104605248],
            [0.05409887553338693, 4.575681484683497],
            [0.049761564679949036, 4.570416922759177],
            [0.05166588700785139, 4.562983784680991],
            [0.05746816355906101, 4.555599648195287],
            [0.061472331656449046, 4.558137397581227],
            [0.07222993928663937, 4.556996446500414],
            [0.07539205205440536, 4.558924525588128],
            [0.0818061348533775, 4.555312572504813],
            [0.08727461364323928, 4.548888580330688],
            [0.10071316659774335, 4.551899972707639],
            [0.10384920983885336, 4.554774430242963],
            [0.11196375048391756, 4.555264729160643],
            [0.118163130060083, 4.553060059305701],
            [0.12236762127374977, 4.536089374602553],
            [0.12016344761905799, 4.529754031062854],
            [0.12007719889714258, 4.520773472443958],
            [0.12110008489975868, 4.516599495917186],
            [0.12652150377579957, 4.512955078737956],
            [0.12469473940791304, 4.494956732739513],
            [0.12517450309567038, 4.481138554729355],
            [0.1299014126743209, 4.474335237274105],
            [0.13312254478363078, 4.474962230703191],
            [0.13687500587169812, 4.473020024332588],
            [0.14186519989716187, 4.464565317778111],
            [0.14311963734588168, 4.455400262924834],
            [0.14677163419823253, 4.451529429313821],
            [0.14474583485864506, 4.44459638664676],
            [0.13557510023731667, 4.431165089234029],
            [0.12927432085715135, 4.425647832721764],
            [0.1277085439244603, 4.420316417183861],
            [0.13300291339374415, 4.418802285846984],
            [0.13381448177678243, 4.414036917331762],
            [0.06497597305073112, 4.414779872697358],
            [0.007558266898039478, 4.415016042895637],
            [-0.028112385245684914, 4.41548879475773],
            [-0.0350689840001727, 4.41533806230482],
            [-0.12150581044112073, 4.416015677132851],
            [-0.20755177522855925, 4.416859563081841],
            [-0.20656966624890874, 4.504165842362992],
            [-0.20615768763822306, 4.591434492780579],
            [-0.2047968356060212, 4.7224137749104935],
            [-0.20461331784521516, 4.765948763133898],
            [-0.20398844371473177, 4.8338609481988835]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.72180198740318, "lat": 43.27889345267167 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46083"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01265769"
      },
      "bbox": [
        -0.20755177522855925, 4.414036917331762, 0.14677163419823253,
        4.8338609481988835
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.557514427597102, -1.878048103231723],
            [8.559259847205558, -1.788926900922271],
            [8.594356757314706, -1.7671562588981236],
            [8.607040514083454, -1.784201857104984],
            [8.637124933727431, -1.7824983567407922],
            [8.634941360839465, -1.7789739578518036],
            [8.618494556344752, -1.7627827258006576],
            [8.64369080645594, -1.7565342859065127],
            [8.645059547200464, -1.7640355442150484],
            [8.648723108303916, -1.7677195153667937],
            [8.648832282201452, -1.7744319735161929],
            [8.651970467414067, -1.7759115449763714],
            [8.65043539441271, -1.7803292884795734],
            [8.652882857204517, -1.782355926687878],
            [8.675638677297904, -1.779813989788581],
            [8.697403075650024, -1.7830994428420177],
            [8.710520170885511, -1.7883152994138245],
            [8.718040226082504, -1.789429935589049],
            [8.7234664632048, -1.7888622054317287],
            [8.72444043507717, -1.791273750343457],
            [8.732452766067079, -1.793433350698254],
            [8.7392091604901, -1.7935315114544474],
            [8.750681119189123, -1.7963737656147891],
            [8.757247573864609, -1.790855310770471],
            [8.75946788686239, -1.791739509396451],
            [8.764111158999823, -1.806833239814928],
            [8.778567437374981, -1.8200298166224536],
            [8.79086829393158, -1.8263695901719148],
            [8.792527968152179, -1.8301288603212866],
            [8.800598008029358, -1.8369998975530821],
            [8.801111999390118, -1.839895016606673],
            [8.806804324170223, -1.8444450799762369],
            [8.809674912854877, -1.8496180043083823],
            [8.814071524295406, -1.854161883574339],
            [8.822079566015177, -1.8580644710442475],
            [8.823483457378195, -1.886355534539756],
            [8.823969012913796, -1.8887775299160658],
            [8.833538798823012, -1.959109951835853],
            [8.836931803024182, -1.9815319467672656],
            [8.825827872090247, -1.9848912528109106],
            [8.825877492257526, -1.9961500085179538],
            [8.824731307583352, -1.9983880842766868],
            [8.824740742260213, -2.0061647072184567],
            [8.818599243614997, -2.006199981732906],
            [8.818550738189199, -2.0031503430972375],
            [8.809974889282056, -2.003400472285411],
            [8.807586579482175, -2.00617030129851],
            [8.807719078587814, -2.0140883507303586],
            [8.809545938448204, -2.01692009473628],
            [8.809552997373292, -2.0223603012642717],
            [8.8157402393913, -2.021871222989918],
            [8.81583685731531, -2.0246607149045532],
            [8.805806172761237, -2.0245269784873527],
            [8.80538610983882, -2.0294814509397012],
            [8.801696190982048, -2.031650707302537],
            [8.79310026930689, -2.0328659543274106],
            [8.790818789743943, -2.04112786586318],
            [8.79277478467236, -2.0439010283704135],
            [8.784541647283831, -2.047032784804241],
            [8.780737704601227, -2.0461221724866165],
            [8.780706376781854, -2.041971848670238],
            [8.777924282099681, -2.0381395170324783],
            [8.766667142793812, -2.0401184196379916],
            [8.766665650961459, -2.043531460345564],
            [8.758534327424341, -2.044623548951255],
            [8.755727815350614, -2.0475082260230204],
            [8.755867251783526, -2.050467321061259],
            [8.748881481151528, -2.0506846502629235],
            [8.74956919460692, -2.0568238209500613],
            [8.743893598723718, -2.055655878814351],
            [8.737057019159286, -2.0576325865360117],
            [8.73297660060685, -2.0604456470785224],
            [8.730467438568107, -2.0569554240938963],
            [8.731064770172907, -2.0522942049850057],
            [8.727596874091677, -2.0511909949103253],
            [8.7249953240659, -2.0544385767790407],
            [8.719425540283845, -2.0545673449070643],
            [8.71677655486165, -2.059252578896249],
            [8.712144785460751, -2.0574091882638337],
            [8.71001494558889, -2.053745066759002],
            [8.706557003995878, -2.0527362423377116],
            [8.699015283100351, -2.0548371342856813],
            [8.695887271455716, -2.0530480919273466],
            [8.690579524840345, -2.053636319695197],
            [8.687005051813458, -2.0524982814608244],
            [8.686656034149587, -2.0497011730844377],
            [8.67754113838364, -2.0546661359061082],
            [8.673600279612828, -2.0490570229313656],
            [8.663652547220408, -2.0479374516381137],
            [8.658793403777285, -2.0485356798316254],
            [8.65329994572678, -2.0533695578594573],
            [8.647629028747437, -2.055364915993999],
            [8.644852011333597, -2.054833624229339],
            [8.64037663193688, -2.050549229244962],
            [8.636272475836146, -2.050904983620846],
            [8.633112024436333, -2.047601175219332],
            [8.62813720856411, -2.046571309632803],
            [8.62142057605044, -2.0394720146555625],
            [8.617260832200278, -2.040630303180088],
            [8.61352090911393, -2.0373954140099455],
            [8.611399897820107, -2.0418795075001444],
            [8.614295184211638, -2.0483133778728555],
            [8.611262240345846, -2.046819276841654],
            [8.610446893770453, -2.043019213916975],
            [8.605737145353372, -2.039477630835242],
            [8.603753950014388, -2.035940333209007],
            [8.593681212033315, -2.0326186307291674],
            [8.59198905792454, -2.0373694602685934],
            [8.586677127071086, -2.0403271187572765],
            [8.578102268360261, -2.0387487071060555],
            [8.574687240920749, -2.0350632455690576],
            [8.56792275784628, -2.023933994859407],
            [8.56609921424704, -2.0138011946546346],
            [8.563621839187393, -2.009349117219735],
            [8.55619534542107, -2.003672292868165],
            [8.557673893868582, -1.949166530390358],
            [8.56384542818192, -1.9464180765168966],
            [8.561500662629575, -1.939161214766163],
            [8.557841351575924, -1.9388832155291094],
            [8.557514427597102, -1.878048103231723]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.67321240799764, "lat": 36.35926133648084 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47087"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01639758"
      },
      "bbox": [
        8.55619534542107, -2.0604456470785224, 8.836931803024182,
        -1.7565342859065127
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.2431216497721875, -8.04809911721504],
            [-6.172217466903495, -7.999329763898503],
            [-6.1688143858805695, -7.9973322456167795],
            [-6.131464433258225, -7.9717547937590245],
            [-6.129302606830249, -7.970055267792439],
            [-6.021528700975369, -7.896034462160011],
            [-5.913785101933905, -7.821965491091961],
            [-5.838108003361263, -7.893019106138172],
            [-5.821929698362363, -7.908572052623734],
            [-5.761718678556998, -7.964992777849195],
            [-5.72223407283486, -8.001669122347028],
            [-5.7176862419673355, -8.00657579271462],
            [-5.666089398628629, -8.055021895114562],
            [-5.578087054817015, -8.137550848086875],
            [-5.506574335990197, -8.204599931883912],
            [-5.435041038003579, -8.271620128955846],
            [-5.3634870180351175, -8.33861117600404],
            [-5.291912133599244, -8.405572809840805],
            [-5.255937030389001, -8.439230867625412],
            [-5.209192744546373, -8.483134441192316],
            [-5.13998412358846, -8.547637224183735],
            [-5.136079245333018, -8.55113063689842],
            [-5.072187741387718, -8.61017828712735],
            [-5.008279374488164, -8.6692020152992],
            [-5.012030137497435, -8.674656419556912],
            [-5.011186761672925, -8.680373681506364],
            [-5.013329857504329, -8.684660626736084],
            [-5.0187393044849715, -8.684425998980316],
            [-5.01996111393767, -8.679149806201696],
            [-5.0264901037031, -8.677470462094702],
            [-5.0298401755971796, -8.681833027886661],
            [-5.034589138099565, -8.683864019217681],
            [-5.035751470764093, -8.690642441857491],
            [-5.03840227032481, -8.69387380669691],
            [-5.0453066493998735, -8.696229428709477],
            [-5.048416127936549, -8.699734404689208],
            [-5.047481131385851, -8.711922552838706],
            [-5.0501470858640225, -8.717883517800338],
            [-5.054397558417885, -8.724114861707946],
            [-5.059501843154201, -8.737632706194105],
            [-5.06244343838495, -8.743636773147518],
            [-5.0631782859158365, -8.753690599018176],
            [-5.074370269772148, -8.760251653781859],
            [-5.071296578420962, -8.769577759028405],
            [-5.073069312557533, -8.77705876223677],
            [-5.076015844444139, -8.780334532799369],
            [-5.078990134012227, -8.7737330291892],
            [-5.083972818373149, -8.773089883886568],
            [-5.088406633447903, -8.776582330444425],
            [-5.092966709063301, -8.776737938266468],
            [-5.0975625686890265, -8.771771722451222],
            [-5.102791734222716, -8.771580769583768],
            [-5.10587636052834, -8.768084775115623],
            [-5.114083036925955, -8.76339107314262],
            [-5.117947176695228, -8.766600184452496],
            [-5.123738723535374, -8.762083253328388],
            [-5.134264137696417, -8.764001665090836],
            [-5.13789489065818, -8.756542245069962],
            [-5.1407236978727555, -8.754773714020908],
            [-5.147130196213154, -8.761903196513225],
            [-5.153209505465214, -8.761500059952327],
            [-5.153915183634577, -8.755078719390585],
            [-5.1585415930963165, -8.750658432233879],
            [-5.169580511384896, -8.755018938727748],
            [-5.183434999853975, -8.751239855007388],
            [-5.186809020626401, -8.754827292057684],
            [-5.183137359017987, -8.759984295418903],
            [-5.179638051292892, -8.762520361095909],
            [-5.182578212597696, -8.769673869567917],
            [-5.188655446570064, -8.773970605256922],
            [-5.199100998617974, -8.777879604268099],
            [-5.208965007418827, -8.786377308648138],
            [-5.214225053772191, -8.788498590948182],
            [-5.219631823836114, -8.783679403627128],
            [-5.219441608582441, -8.776976135714564],
            [-5.222730106781415, -8.772276233814006],
            [-5.2244226102995235, -8.76649764034622],
            [-5.229165565341883, -8.760847262933675],
            [-5.234554197449341, -8.763711052210173],
            [-5.235131643702498, -8.766837621134671],
            [-5.234025143953965, -8.775122808701726],
            [-5.237873269314534, -8.777262030250117],
            [-5.2402852277331435, -8.776036194856442],
            [-5.248725216081551, -8.781444356126974],
            [-5.2530333460049645, -8.780985079920166],
            [-5.25607068435837, -8.778684003692662],
            [-5.267751536801581, -8.781684893188027],
            [-5.269915568311249, -8.781127499659458],
            [-5.279077900405674, -8.79194425294972],
            [-5.285833954982058, -8.793774535658141],
            [-5.293641741810348, -8.7940368863415],
            [-5.312633557424294, -8.790127575869214],
            [-5.317746622984124, -8.786285604707162],
            [-5.3186704436329, -8.779813096390793],
            [-5.32307410543644, -8.781025702160939],
            [-5.326221290900422, -8.784003644097528],
            [-5.326283214763268, -8.787060257532964],
            [-5.330736523732516, -8.796544521308928],
            [-5.3338974764390725, -8.797824152570302],
            [-5.33689136845782, -8.801956967794265],
            [-5.339748401920775, -8.802863050597406],
            [-5.33974301903118, -8.816630100112635],
            [-5.338977026976887, -8.819202793448179],
            [-5.346079868366349, -8.824745264538674],
            [-5.347603285348019, -8.827866839782573],
            [-5.349187618309245, -8.838223392044515],
            [-5.346817491144545, -8.8407769718109],
            [-5.344719071883459, -8.846980003779926],
            [-5.348477431542249, -8.8515467707964],
            [-5.354281325522099, -8.851433119304032],
            [-5.358831410160296, -8.85589454445452],
            [-5.362862473655191, -8.864009636177991],
            [-5.371929598879801, -8.869930878689868],
            [-5.374448339704327, -8.876608108190224],
            [-5.378720138131321, -8.880131400926567],
            [-5.382710555086562, -8.878374376309086],
            [-5.390045279794067, -8.887404050094789],
            [-5.387538554897272, -8.898063067406977],
            [-5.389236326518792, -8.912528790067531],
            [-5.3916120416496085, -8.916700071084236],
            [-5.390515633412324, -8.920528497019294],
            [-5.394675531132427, -8.925666945575157],
            [-5.405410003595888, -8.92071230453948],
            [-5.4095295564783985, -8.919586291267446],
            [-5.415404989005301, -8.923044781529311],
            [-5.4112021305664255, -8.93848175299346],
            [-5.412858836293929, -8.942703601387134],
            [-5.416417929602975, -8.945692857556487],
            [-5.421820413607614, -8.944038232888856],
            [-5.421940921020586, -8.950482832907516],
            [-5.425530150064826, -8.955278089112955],
            [-5.42609893368684, -8.96016544155159],
            [-5.424839033135886, -8.964521081554617],
            [-5.421371186521538, -8.96837366347608],
            [-5.42548623531535, -8.969371978556675],
            [-5.4294718936481425, -8.973823767679903],
            [-5.437194550388239, -8.972076969926643],
            [-5.4407244867432665, -8.975524489487759],
            [-5.4397424742285425, -8.979280051554696],
            [-5.440861077030552, -8.982944453261522],
            [-5.444243951852806, -8.984440238554527],
            [-5.446373121833181, -8.98827561267087],
            [-5.455578914772835, -8.991929455842422],
            [-5.454128407564623, -8.998526517827774],
            [-5.4558434992312685, -9.010198705291035],
            [-5.453519830653305, -9.014115185200733],
            [-5.456420202511422, -9.01990322687218],
            [-5.451199038992206, -9.027970334251565],
            [-5.453842766510964, -9.029944564783772],
            [-5.46297613176789, -9.030530944952128],
            [-5.465385076411987, -9.042050962979186],
            [-5.467974054557509, -9.045996739221724],
            [-5.472321027058413, -9.049180957855821],
            [-5.474961181888243, -9.057093644880162],
            [-5.4713964562198525, -9.062551073715328],
            [-5.480518301679851, -9.067439786921335],
            [-5.4826826130360695, -9.078331315980854],
            [-5.478910790307842, -9.093851906523138],
            [-5.484899523526115, -9.100081559196074],
            [-5.483318032160965, -9.102927744928223],
            [-5.479201949462817, -9.103973464980864],
            [-5.478839264208459, -9.107232719608374],
            [-5.468498681296252, -9.10980748319766],
            [-5.471197353381403, -9.114826875324656],
            [-5.473528980284718, -9.113623259588278],
            [-5.4792586989505185, -9.114368474851688],
            [-5.4865377327833, -9.123283782909715],
            [-5.488493910711139, -9.131975200969558],
            [-5.494564147903986, -9.132826784493604],
            [-5.497953692829718, -9.136074766030465],
            [-5.498759312059564, -9.144384285666098],
            [-5.494235962491316, -9.14828357814433],
            [-5.493954466766272, -9.150952584134682],
            [-5.499969349170738, -9.152066973181432],
            [-5.512928231821026, -9.156910713818526],
            [-5.52269309085192, -9.155659909498173],
            [-5.527875035585507, -9.15286980650741],
            [-5.533885265682718, -9.159177118675991],
            [-5.530569224198844, -9.168294219602569],
            [-5.5360165152884475, -9.181439515691363],
            [-5.535917050105907, -9.185796970653833],
            [-5.539616194756037, -9.190919996088999],
            [-5.539333301836863, -9.194863006813238],
            [-5.544164820816312, -9.196610053430486],
            [-5.54217454111699, -9.203416733865891],
            [-5.541370299454024, -9.213829974094068],
            [-5.544064771849298, -9.218418745802685],
            [-5.549009824364391, -9.220321456803473],
            [-5.550112009067955, -9.223050709748295],
            [-5.554701865957332, -9.225244643750804],
            [-5.555331509289571, -9.227851415992086],
            [-5.552514780124517, -9.235249735264974],
            [-5.555452343332826, -9.239653102560293],
            [-5.559250870225101, -9.242115146655022],
            [-5.558881863640486, -9.247068312636866],
            [-5.557053299221211, -9.25021136356398],
            [-5.551333106174969, -9.250537885521048],
            [-5.544352838649527, -9.259447078656605],
            [-5.5384308855763065, -9.25946569999849],
            [-5.5302254796289345, -9.264401190348648],
            [-5.531021627853447, -9.273127105295755],
            [-5.527234301816126, -9.278342262342829],
            [-5.529071180820859, -9.283021953919816],
            [-5.5371700316110255, -9.288170444870923],
            [-5.537982003005772, -9.290474705452956],
            [-5.552272432113419, -9.295417754271217],
            [-5.556881051086314, -9.29489037666578],
            [-5.5588659063074, -9.29039404176969],
            [-5.564445217771342, -9.283989847596747],
            [-5.567520063924316, -9.28368871612519],
            [-5.571236215911665, -9.287790335598373],
            [-5.568583942186852, -9.296628598970194],
            [-5.57114051640883, -9.302714812559815],
            [-5.57493212828724, -9.304186255278564],
            [-5.574381241848966, -9.311595229673594],
            [-5.580850014137134, -9.30813751128113],
            [-5.587321166951731, -9.306894917012094],
            [-5.591915871927705, -9.312470410272574],
            [-5.596965719011304, -9.309504386355366],
            [-5.600678296969878, -9.319507387563108],
            [-5.603155353880185, -9.320103529121013],
            [-5.606083499759033, -9.325876522319044],
            [-5.608270921595101, -9.321556802839353],
            [-5.61286550150692, -9.319758967947687],
            [-5.623050556698505, -9.313062611449336],
            [-5.630345278745929, -9.312605373124738],
            [-5.637340176477998, -9.314480098543722],
            [-5.643701761003993, -9.31887127688771],
            [-5.645359416737426, -9.321333273350465],
            [-5.644404531676444, -9.335673900981684],
            [-5.65108999633908, -9.346020904218673],
            [-5.656402073288705, -9.34757948253009],
            [-5.6575707211982, -9.358096029811255],
            [-5.663809324566142, -9.361174188350464],
            [-5.6611651285820646, -9.366598452533886],
            [-5.661570927480181, -9.369394056950208],
            [-5.668339907490135, -9.368951531019343],
            [-5.675546409335822, -9.378084749501053],
            [-5.683018148141906, -9.379573624446028],
            [-5.683367526653106, -9.38269337053078],
            [-5.680218225163239, -9.386666024044166],
            [-5.681602294877856, -9.391606760489227],
            [-5.684181660274513, -9.394538464916327],
            [-5.692086858094186, -9.39720754949648],
            [-5.700284182149661, -9.391479692066865],
            [-5.70414426094265, -9.395963555558431],
            [-5.709338280333535, -9.399894517051543],
            [-5.714564963314908, -9.39733095508607],
            [-5.7196802688172665, -9.399260629963116],
            [-5.723506395613375, -9.403380305037528],
            [-5.721001149482276, -9.41058209023811],
            [-5.721466248251714, -9.414215568889608],
            [-5.731360566681253, -9.422333218227577],
            [-5.73021565381934, -9.430827730523983],
            [-5.731025063877263, -9.435572873540853],
            [-5.734872760199901, -9.43527050221696],
            [-5.73595880262261, -9.431179176735323],
            [-5.735274148553699, -9.426046248346118],
            [-5.738565758496524, -9.424154998200319],
            [-5.740556260047227, -9.428131192676895],
            [-5.742928467964097, -9.427837488888398],
            [-5.743784423838657, -9.43647085484189],
            [-5.749291204848226, -9.445373972214815],
            [-5.750063776955381, -9.450092705147323],
            [-5.747924522821206, -9.4551519324618],
            [-5.743441081167137, -9.461041076256398],
            [-5.74738777625821, -9.469556426376162],
            [-5.753124603554134, -9.473392100534916],
            [-5.762371101128235, -9.486148158259763],
            [-5.76034678123636, -9.497819317473143],
            [-5.761819429014818, -9.500947751476154],
            [-5.764997068749667, -9.502254730555983],
            [-5.768574145354425, -9.501273683205005],
            [-5.772028046656781, -9.503299876515667],
            [-5.779069616666485, -9.501393790524174],
            [-5.786764518805325, -9.506207679794706],
            [-5.794110437434804, -9.50860373542642],
            [-5.797148667104594, -9.511819539054374],
            [-5.801461950192613, -9.509355892842766],
            [-5.805197361805709, -9.510739372429903],
            [-5.806460431348085, -9.505313638837814],
            [-5.810637645631862, -9.501964479845514],
            [-5.816005854211645, -9.504035875937872],
            [-5.818299295263218, -9.500145154956034],
            [-5.828147267319862, -9.497177652673384],
            [-5.8377230246208605, -9.493396423690875],
            [-5.842232190921474, -9.493705766547508],
            [-5.848484661810655, -9.492065207637607],
            [-5.854687628022093, -9.494917379940459],
            [-5.857714871717561, -9.489147266480414],
            [-5.861932418529749, -9.490262946154473],
            [-5.867228069355885, -9.493562832371142],
            [-5.868885781632327, -9.496326037835964],
            [-5.879427276655629, -9.496862942303258],
            [-5.882184874651068, -9.490556961547027],
            [-5.892869347070254, -9.480567315887434],
            [-5.895844521286083, -9.483333434036856],
            [-5.898091785790189, -9.49066496128058],
            [-5.9056744025302645, -9.498351308551463],
            [-5.9125893820065905, -9.496196412607611],
            [-5.906791199387218, -9.487700633482625],
            [-5.909852933867255, -9.475056152433899],
            [-5.917586142075047, -9.468543870454763],
            [-5.9239775971722, -9.46660215435627],
            [-5.928917903845193, -9.470502732044286],
            [-5.934017609536445, -9.465763993445426],
            [-5.934636578054604, -9.461326250958892],
            [-5.932089568959911, -9.460813389362555],
            [-5.9275160807717855, -9.455309670125121],
            [-5.927263154537511, -9.449283622818495],
            [-5.933266795512283, -9.448242055191878],
            [-5.938088761685599, -9.454126017442787],
            [-5.943111045200133, -9.456537391681346],
            [-5.947956635322294, -9.456274844209396],
            [-5.953867442936969, -9.452431226914744],
            [-5.956489309393134, -9.443894646200865],
            [-5.951677625055118, -9.444995242228783],
            [-5.944597169364011, -9.442642310283032],
            [-5.942692806924106, -9.434321160745053],
            [-5.947496693058498, -9.4291523371252],
            [-5.95242028433971, -9.429311429818299],
            [-5.955319717621219, -9.426225634848901],
            [-5.957672033060904, -9.42704132754799],
            [-5.960581433919757, -9.431664265789617],
            [-5.964113798401724, -9.442950400190286],
            [-5.967295753042983, -9.448975125088586],
            [-5.973185858452813, -9.452205943240271],
            [-5.978675685125349, -9.45007872761865],
            [-5.984643351355585, -9.446363761986113],
            [-5.996956790274291, -9.444508299848064],
            [-5.99589968761131, -9.440838633433104],
            [-5.9965316273484826, -9.43523230857954],
            [-6.000470111005881, -9.434201114242528],
            [-6.00234542019192, -9.436057464995077],
            [-6.008895224420191, -9.435996283506176],
            [-6.01027806187972, -9.42881950123899],
            [-6.013866814437106, -9.42819906355639],
            [-6.0197615805602, -9.429471486003175],
            [-6.021243315646415, -9.426213854803242],
            [-6.026429787629889, -9.4234155001335],
            [-6.0301815377781836, -9.424265484260525],
            [-6.03398250638816, -9.42263925423689],
            [-6.0304959238308005, -9.4179532573558],
            [-6.034479457827663, -9.414386146549402],
            [-6.036690174045084, -9.408252134814116],
            [-6.039910176140349, -9.408392510440049],
            [-6.047693003468052, -9.400116204787826],
            [-6.047153364720355, -9.392919083523532],
            [-6.05692829474292, -9.392400291677436],
            [-6.057523397384522, -9.397387433986532],
            [-6.065262275222661, -9.397960002872626],
            [-6.067951831197032, -9.392900523812337],
            [-6.063912147295769, -9.384245889514029],
            [-6.063838297876899, -9.37895689081535],
            [-6.067761426266523, -9.377519804217348],
            [-6.068069259487928, -9.37321246302774],
            [-6.072483491863931, -9.372182849029103],
            [-6.075527596788943, -9.369150532604287],
            [-6.0833126513837765, -9.35480375742714],
            [-6.087647638036181, -9.353378845699186],
            [-6.087553746844451, -9.347073841611888],
            [-6.09321442940774, -9.346140453389413],
            [-6.096667672056528, -9.341703184028747],
            [-6.102323114801314, -9.341757535224191],
            [-6.108471917224193, -9.340398189094994],
            [-6.107137382466365, -9.335471572278982],
            [-6.106719218423414, -9.325273607126913],
            [-6.119515863038844, -9.314708145419944],
            [-6.1240655663405015, -9.315597430965388],
            [-6.127209654744812, -9.317865930182972],
            [-6.130918151371821, -9.312912770345871],
            [-6.128228487362079, -9.303984101589776],
            [-6.141401222781439, -9.305009689201993],
            [-6.14486048486854, -9.303496837681275],
            [-6.149113430743986, -9.30505413033869],
            [-6.152748683385251, -9.308109094378873],
            [-6.156974596550208, -9.308504815003124],
            [-6.165185596723703, -9.306994961192991],
            [-6.168469719864042, -9.305098291662487],
            [-6.171747848416099, -9.298940256262584],
            [-6.1766400379886175, -9.29604737628197],
            [-6.179784833435445, -9.29049380366707],
            [-6.186358752387362, -9.292234501161348],
            [-6.196313132772475, -9.292214515077596],
            [-6.200817148866746, -9.295936735690775],
            [-6.205603960659596, -9.292967321407133],
            [-6.210875489889557, -9.294443612352211],
            [-6.213180044015478, -9.296540592294523],
            [-6.217160436362621, -9.290403527768278],
            [-6.219819295538854, -9.284023087149182],
            [-6.226231625673037, -9.281745862054551],
            [-6.229716514445352, -9.27849468718793],
            [-6.237665192653539, -9.277865916941893],
            [-6.246106791875875, -9.272565375814148],
            [-6.251622952042004, -9.27376636833579],
            [-6.256404058291621, -9.272178245256294],
            [-6.259878477120117, -9.265398853207806],
            [-6.268143275409949, -9.264417162054814],
            [-6.269958332837289, -9.267965260356698],
            [-6.273147160541269, -9.267590410986909],
            [-6.277769198047437, -9.256063940442464],
            [-6.280265229707761, -9.255806809296722],
            [-6.281636251938223, -9.250534858098497],
            [-6.287630734071846, -9.245410065038556],
            [-6.290958679655378, -9.239225878759816],
            [-6.291308948622901, -9.232792450166176],
            [-6.288990434013927, -9.22868197877873],
            [-6.291281010477792, -9.22603595138999],
            [-6.296455669772618, -9.227759498225703],
            [-6.30319941773877, -9.22630471499269],
            [-6.3001827027053805, -9.219790208567554],
            [-6.303229980524811, -9.214156781026684],
            [-6.3069293455502775, -9.214046999464392],
            [-6.312364296135519, -9.219025817596094],
            [-6.3116257203711, -9.220514776566072],
            [-6.315123314905618, -9.226466440324584],
            [-6.320076612919851, -9.225548005822224],
            [-6.320643117764618, -9.221704415302193],
            [-6.324090259380437, -9.217375052875246],
            [-6.322112677515766, -9.208234844715491],
            [-6.321631368666494, -9.20189614033292],
            [-6.317431067171968, -9.201949162283206],
            [-6.316382912826711, -9.198230861456796],
            [-6.319011794977375, -9.193974282534336],
            [-6.319013925470998, -9.19043710156647],
            [-6.3227599898977775, -9.180377569380536],
            [-6.326389245703437, -9.180073504370272],
            [-6.330512950688782, -9.182716526318051],
            [-6.330357989244394, -9.180449589599428],
            [-6.310941428594097, -8.945689975275153],
            [-6.295349008598465, -8.727609922568156],
            [-6.2806526535498755, -8.532984468995556],
            [-6.274775036817127, -8.455605093694443],
            [-6.249685203319916, -8.149313929352004],
            [-6.2431216497721875, -8.04809911721504]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.25174286329438,
          "lat": 29.811941165487692
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48043"],
        "coty_name": ["Brewster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brewster County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01383807"
      },
      "bbox": [
        -6.330512950688782, -9.511819539054374, -5.008279374488164,
        -7.821965491091961
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.107072791315379, -2.0167843711479536],
            [-4.940111874323867, -2.0289224054741464],
            [-4.764168514292834, -2.0413119556687644],
            [-4.614751432485739, -2.0515102102233453],
            [-4.509748029033519, -2.058499441021239],
            [-4.505385172664488, -2.058447761581952],
            [-4.4398360036543405, -2.0631117966593675],
            [-4.440239301505393, -2.0655362585162034],
            [-4.469386493914187, -2.511047340122018],
            [-4.536898084382549, -2.506648686320495],
            [-4.594279885614079, -2.502641022149772],
            [-4.715499659511905, -2.4944315142707176],
            [-4.744731498775756, -2.4928023447894763],
            [-4.771211058220258, -2.490995694767299],
            [-4.919460039512317, -2.480595300961727],
            [-4.920541128043952, -2.4802478119017537],
            [-4.955255033444237, -2.4780588484437023],
            [-5.072555579463011, -2.4695796249232345],
            [-5.170816225323626, -2.4623102406595185],
            [-5.158282364858883, -2.2874956802067987],
            [-5.151899095787713, -2.1977029584218473],
            [-5.138428724799877, -2.0144223977961406],
            [-5.107072791315379, -2.0167843711479536]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.60222212810997,
          "lat": 36.27788621782024
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48111"],
        "coty_name": ["Dallam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dallam County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01383841"
      },
      "bbox": [
        -5.170816225323626, -2.511047340122018, -4.4398360036543405,
        -2.0144223977961406
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.01187614454994, -2.090470723798738],
            [-3.9793644408156594, -2.092410244753107],
            [-3.8075231711016144, -2.1024285322893284],
            [-3.678687899865295, -2.109682525927513],
            [-3.5835679461437127, -2.114896881134512],
            [-3.5899845720400463, -2.240035265502857],
            [-3.5904848669843608, -2.241649962720106],
            [-3.5977742587940416, -2.3729147315467753],
            [-3.6078578795000893, -2.559693020137034],
            [-3.6079970174368015, -2.562003930216484],
            [-3.8126427146067003, -2.5507960569820023],
            [-3.923344552983874, -2.5444730318240545],
            [-4.03802864379426, -2.5376447163654317],
            [-4.033086103456053, -2.45389427126553],
            [-4.027168415314337, -2.35115343876903],
            [-4.020140255630873, -2.232607573531937],
            [-4.01187614454994, -2.090470723798738]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.35456476250909,
          "lat": 36.277429417313165
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48195"],
        "coty_name": ["Hansford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hansford County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "01383883"
      },
      "bbox": [
        -4.03802864379426, -2.562003930216484, -3.5835679461437127,
        -2.090470723798738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.8445936088846047, -5.2746366862631575],
            [-2.687200432454708, -5.280450674830513],
            [-2.61984201051841, -5.28271246394091],
            [-2.4821335951856454, -5.287600593756701],
            [-2.4148978094793336, -5.289820489344408],
            [-2.417611976892559, -5.367805256515432],
            [-2.4255050965224605, -5.597519258340726],
            [-2.4301603090441306, -5.732399602610492],
            [-2.547441220553924, -5.72811228383143],
            [-2.6325202952748588, -5.72400132156112],
            [-2.691933864576774, -5.721176720420082],
            [-2.752601911063054, -5.718087608636383],
            [-2.8152755798625324, -5.714766277884723],
            [-2.8612769283755357, -5.712453601824613],
            [-2.8563873438280667, -5.581930333227866],
            [-2.851394583243558, -5.465719222545774],
            [-2.849423633837408, -5.4185695513315055],
            [-2.84631797375569, -5.308674718674178],
            [-2.8453128448992597, -5.296994221100188],
            [-2.8445936088846047, -5.2746366862631575]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.7302997736059, "lat": 33.178230534397485 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48207"],
        "coty_name": ["Haskell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Haskell County"],
        "coty_fp_code": "207",
        "coty_gnis_code": "01383889"
      },
      "bbox": [
        -2.8612769283755357, -5.732399602610492, -2.4148978094793336,
        -5.2746366862631575
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.7109188148496658, -11.184335664327707],
              [-0.7059796607208164, -11.17215538329595],
              [-0.7045439036581317, -11.175468139562685],
              [-0.7087914284289968, -11.18374656920949],
              [-0.7109188148496658, -11.184335664327707]
            ]
          ],
          [
            [
              [-0.6655903261842139, -11.1054405611636],
              [-0.6423140675413854, -11.098950882453744],
              [-0.6250589495668007, -11.105450417541025],
              [-0.6290054617071976, -11.112950691184867],
              [-0.6445404433721139, -11.144748193924096],
              [-0.6568024986580444, -11.169353177466787],
              [-0.6669015188310542, -11.191594152432291],
              [-0.6730837005599208, -11.203532330480966],
              [-0.6881692383228903, -11.239637998765659],
              [-0.6994635431097205, -11.26787153657791],
              [-0.7136146594017552, -11.30606179383769],
              [-0.7235197368851428, -11.336062113029085],
              [-0.7317172029356815, -11.363139038320634],
              [-0.7405153368641391, -11.395257969443769],
              [-0.7604447131619569, -11.394851587986969],
              [-0.7594589786199032, -11.391794377942487],
              [-0.7599976820671072, -11.385091888540464],
              [-0.761930253137482, -11.379297728946415],
              [-0.7611187615931876, -11.374675305985612],
              [-0.7534941281217656, -11.36880983084956],
              [-0.7489194673660499, -11.368255733945105],
              [-0.7476006773291066, -11.365184728661472],
              [-0.7503620227130027, -11.357938051061536],
              [-0.7533661486979155, -11.352849780887736],
              [-0.7527558798792054, -11.347401491063989],
              [-0.7565235819959598, -11.343743610544923],
              [-0.7541742077455036, -11.328228854038496],
              [-0.7521099803964365, -11.324962790952485],
              [-0.7520853453127487, -11.316005190804503],
              [-0.7494318047587889, -11.308732702669253],
              [-0.7441307433921243, -11.301702665820342],
              [-0.7437756198828024, -11.299132978881769],
              [-0.7386246625887221, -11.287776875227067],
              [-0.7344185624068532, -11.28299672795383],
              [-0.7326496009726419, -11.27797667418005],
              [-0.7286640577327693, -11.27370714609892],
              [-0.7246997944544875, -11.2634669785034],
              [-0.7229900889175265, -11.25515270570019],
              [-0.7230261155558626, -11.242798967304457],
              [-0.7174650204572127, -11.231963541138748],
              [-0.7130445988621018, -11.219259859555944],
              [-0.7080632401898984, -11.21171086147014],
              [-0.7067121018500491, -11.206068399560758],
              [-0.7041289089182148, -11.20322164956353],
              [-0.7019303775823511, -11.197590274295873],
              [-0.696476943454835, -11.19406136806574],
              [-0.6931536507496885, -11.186736051400752],
              [-0.6986690201949254, -11.172048102015031],
              [-0.688618794374332, -11.1500564574175],
              [-0.6776193139221756, -11.12797561548171],
              [-0.6655903261842139, -11.1054405611636]
            ]
          ],
          [
            [
              [-0.7921517075310756, -11.378159773288695],
              [-0.7887358898327639, -11.362865580826584],
              [-0.7861021883854307, -11.364242629451056],
              [-0.7899047346822088, -11.37706017850373],
              [-0.7921517075310756, -11.378159773288695]
            ]
          ],
          [
            [
              [-1.2645048848208025, -11.036930285462708],
              [-1.2557117818397663, -11.037201991736339],
              [-1.2551680958684481, -11.040390921083894],
              [-1.2491018740348228, -11.04570186318114],
              [-1.2459051358084083, -11.04997909336907],
              [-1.2390910246377136, -11.04944853653425],
              [-1.236519442946559, -11.050897684067783],
              [-1.2280829442284773, -11.050610305804067],
              [-1.2235367261310555, -11.05285608871214],
              [-1.2192291030584024, -11.05225922403508],
              [-1.216549520634044, -11.056705840454155],
              [-1.2113832793747918, -11.059803314101678],
              [-1.207243095185442, -11.064397006870742],
              [-1.2056688052961277, -11.074444513473583],
              [-1.2076116021665888, -11.076378541094183],
              [-1.2046340449648003, -11.085213668447942],
              [-1.2013961738452672, -11.085586939726202],
              [-1.19729353093877, -11.090636867152503],
              [-1.1907375243643616, -11.092341645807332],
              [-1.1898930204011307, -11.095018024719657],
              [-1.1848896263974187, -11.098187186762136],
              [-1.1812609674703767, -11.106156485875795],
              [-1.1763682018729682, -11.107399415310791],
              [-1.1742376621677746, -11.114055936748885],
              [-1.1395695457305097, -11.114937794784689],
              [-1.0385979076329124, -11.115841141395922],
              [-0.9376262330144878, -11.116716150934291],
              [-0.8455883104487415, -11.118027411882283],
              [-0.8375605820808392, -11.118447760497112],
              [-0.7876808403271256, -11.119316636573569],
              [-0.7166066117033886, -11.119482317536956],
              [-0.7160888271657673, -11.11931277535152],
              [-0.7256974016470458, -11.146935346849906],
              [-0.7312397541348189, -11.159742764569561],
              [-0.734657730694819, -11.165990527487299],
              [-0.7348873475766136, -11.170292349297029],
              [-0.7372602667774658, -11.175730058268325],
              [-0.7395809961139552, -11.187208728830244],
              [-0.7407726469205776, -11.196352478654326],
              [-0.7403274678616225, -11.1995353543438],
              [-0.7461052396386015, -11.205953227911708],
              [-0.7473709576108125, -11.212832109187671],
              [-0.7559952928491607, -11.233720010487259],
              [-0.7559459784725184, -11.241121699690598],
              [-0.7581217650678364, -11.252105457144232],
              [-0.7570510516146391, -11.258606345254169],
              [-0.7581114602211769, -11.265797026750915],
              [-0.7645188753048299, -11.280308837787906],
              [-0.7710122908087562, -11.291867261820412],
              [-0.7709552770872667, -11.293919894885342],
              [-0.7758584886185136, -11.303844095062981],
              [-0.7760371677249236, -11.306068807012032],
              [-0.7835691823981629, -11.324069305705988],
              [-0.786985490972568, -11.331174950298182],
              [-0.7882471576880501, -11.338399126189817],
              [-0.7910565926631272, -11.343817600124002],
              [-0.799611271638821, -11.351894741457372],
              [-0.8054957959819065, -11.354898420197795],
              [-0.8178794524557993, -11.35930858219437],
              [-0.8322063209307947, -11.359095341597556],
              [-0.8610877760857105, -11.374043432546772],
              [-0.8680024334900891, -11.379807864531406],
              [-0.8722437780022427, -11.384661108123058],
              [-0.8841805993465605, -11.396018240407004],
              [-0.8886091993704093, -11.392810514637992],
              [-0.8959051771854184, -11.391114746931978],
              [-0.905497245662166, -11.392209821682801],
              [-0.9130769098826848, -11.388989897386457],
              [-0.9163205941599796, -11.386579510234379],
              [-0.9186857786759708, -11.381382403638442],
              [-0.9155814158817207, -11.379887261825058],
              [-0.9126745117066858, -11.383950097041573],
              [-0.9069394621872362, -11.383937673303947],
              [-0.9026277202903525, -11.380908770201424],
              [-0.8996620554830739, -11.380550817282103],
              [-0.898367374930975, -11.373465151218802],
              [-0.8924711673993582, -11.369438440806505],
              [-0.891890011302823, -11.366618425877968],
              [-0.8805248501794243, -11.366795592014713],
              [-0.8767963378181716, -11.365357386237367],
              [-0.8737557326092966, -11.361182558692759],
              [-0.8731358559603557, -11.355631104059055],
              [-0.878434042409912, -11.349952796519522],
              [-0.8751650058657892, -11.344543432454378],
              [-0.8591800978239712, -11.332573332540214],
              [-0.8603190541062989, -11.32411234563614],
              [-0.8646195586507316, -11.320957049783608],
              [-0.8596069488211039, -11.312693078497333],
              [-0.8619745267130363, -11.308127271406166],
              [-0.8563550454517825, -11.301726424403423],
              [-0.8618039305360415, -11.297421535943416],
              [-0.8633347656942624, -11.286999272306588],
              [-0.8692193937714557, -11.283511314790031],
              [-0.8739085730999226, -11.291469009584835],
              [-0.8733257570742764, -11.301362383874515],
              [-0.8838919322019807, -11.305214066408077],
              [-0.8854365895353792, -11.310391825326425],
              [-0.8938642172298651, -11.318134638271292],
              [-0.9003122524334011, -11.323078583592425],
              [-0.9058609523468129, -11.332262783990656],
              [-0.9105926859897958, -11.335067259628314],
              [-0.9357723051067309, -11.353079841834205],
              [-0.9449334083530535, -11.35716996025379],
              [-0.9510625260113373, -11.361704567127989],
              [-0.9723950993843444, -11.382937642359545],
              [-0.9775777890994144, -11.384542447285616],
              [-0.9850595214824378, -11.381121650420415],
              [-0.9889124698254803, -11.376731274684754],
              [-0.9892919001982025, -11.374150410869756],
              [-0.9969920662963621, -11.371137193626925],
              [-0.9986504854397898, -11.368843760400269],
              [-0.9942406206728923, -11.365622779150732],
              [-0.992038082311224, -11.361127785025305],
              [-0.9946088493915641, -11.356347531809824],
              [-0.9949553180691795, -11.345837293034561],
              [-1.0111936715108625, -11.34556215727328],
              [-1.017370491255679, -11.340515363223805],
              [-1.0181153002178005, -11.334837349131165],
              [-1.0257889953834536, -11.32471677355683],
              [-1.0183668451226833, -11.313208951579835],
              [-1.019385161512044, -11.310822790566014],
              [-1.02568265185491, -11.306904887781911],
              [-1.032339900061872, -11.30534903577614],
              [-1.033102683133997, -11.300599114721525],
              [-1.0356505956282196, -11.294788772262732],
              [-1.0438438861109047, -11.290218616490737],
              [-1.0505107131778553, -11.289278650041224],
              [-1.0560673860219454, -11.285680246356607],
              [-1.0613625201161907, -11.28517527101821],
              [-1.0650368212627879, -11.288817244568843],
              [-1.0640673394599984, -11.293776370865887],
              [-1.0585472339663962, -11.299434101433523],
              [-1.0571993911519983, -11.30697414925589],
              [-1.0519797457369662, -11.311699863159307],
              [-1.050839816662285, -11.319030716898618],
              [-1.0459323733793076, -11.329310564174756],
              [-1.0473289998400355, -11.336083195438816],
              [-1.0400400742813718, -11.343933458068662],
              [-1.0424293893690808, -11.346878537949378],
              [-1.0407810363998995, -11.34968796082215],
              [-1.0334050876086782, -11.352802328609188],
              [-1.033168589356596, -11.357336782193412],
              [-1.02800823304529, -11.359692434665007],
              [-1.0194506274994932, -11.362105021718909],
              [-1.0146342858542816, -11.364548505136547],
              [-1.0183308592820484, -11.37077464968824],
              [-1.0173386590730433, -11.373318403450888],
              [-1.0206942808388653, -11.380238408596018],
              [-1.0271324127400228, -11.384477014418788],
              [-1.0338302865956104, -11.385777376182023],
              [-1.0385128257697407, -11.385190202235524],
              [-1.0438482004710787, -11.386108725308775],
              [-1.0489994092438906, -11.388345573463118],
              [-1.0513436121109683, -11.391034917782292],
              [-1.0558633912694408, -11.392978107263277],
              [-1.0657266620157562, -11.390478922060408],
              [-1.0722846265591721, -11.395419734703012],
              [-1.0781803612617002, -11.398348454164084],
              [-1.0817717140800542, -11.395149606598018],
              [-1.0895923510179526, -11.394182973370505],
              [-1.0911995670633556, -11.38936432134066],
              [-1.097621083029632, -11.390238566159576],
              [-1.107038365600652, -11.384356956429524],
              [-1.1136184866553491, -11.388092124753177],
              [-1.1247174499357233, -11.383384134432989],
              [-1.1305316645959496, -11.383256839851166],
              [-1.1393069508256208, -11.386379209756754],
              [-1.1427778491402012, -11.395146567798813],
              [-1.1469967294960564, -11.39328087716876],
              [-1.1509965036876157, -11.396304300580681],
              [-1.154248747843425, -11.394657149848879],
              [-1.1588486881815463, -11.394607199533754],
              [-1.1604472840622162, -11.396867736022815],
              [-1.1586231567182734, -11.402530000015656],
              [-1.1591868685993145, -11.410032025058015],
              [-1.168313434167262, -11.41572907483546],
              [-1.1723416858426652, -11.416056759533129],
              [-1.1823681984541534, -11.421149205624644],
              [-1.18614855178625, -11.417477804678235],
              [-1.1913880271127442, -11.415573233257392],
              [-1.1953010730644036, -11.420569183295264],
              [-1.2006218068237757, -11.419016444500306],
              [-1.206381289003931, -11.424235651195396],
              [-1.2130788885898511, -11.422446031295493],
              [-1.2214008880709522, -11.428384707016821],
              [-1.2243426250898863, -11.423905249675029],
              [-1.230198867752291, -11.42495213532478],
              [-1.232491491658871, -11.42173486308472],
              [-1.2364364771004586, -11.425616771890923],
              [-1.2398627870881749, -11.423099499384607],
              [-1.2435216351378398, -11.423124025784453],
              [-1.2462744342282999, -11.426231453197628],
              [-1.24967656897827, -11.425811347085373],
              [-1.250701307085279, -11.421506241943945],
              [-1.2538817894589052, -11.422229079094173],
              [-1.2559547590861526, -11.425829354085005],
              [-1.2652343142871014, -11.425724694966364],
              [-1.268169112803747, -11.428637652492542],
              [-1.2729397274891296, -11.42796798145264],
              [-1.2788616322718567, -11.430522326244217],
              [-1.2813290663851309, -11.429495836856253],
              [-1.28213165408843, -11.435230538385653],
              [-1.2841931889277487, -11.438510345829522],
              [-1.2852318797554396, -11.44371938381336],
              [-1.2916477429197424, -11.446932347592675],
              [-1.2928533527526098, -11.44955254141881],
              [-1.2973968235156832, -11.451205235228475],
              [-1.3059652327669826, -11.451510376142185],
              [-1.3099674180450358, -11.450705319215647],
              [-1.3122910198757014, -11.45236069029734],
              [-1.3113964576053168, -11.40247658056186],
              [-1.332733360903088, -11.402032922031923],
              [-1.3757308155054508, -11.400659790372648],
              [-1.3734949077237857, -11.272841779283922],
              [-1.3721365805339698, -11.197131225678364],
              [-1.3691863271986697, -11.034828409581014],
              [-1.326579154329808, -11.03588167240315],
              [-1.2645048848208025, -11.036930285462708]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.7275082437314, "lat": 27.433721320761386 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48273"],
        "coty_name": ["Kleberg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kleberg County"],
        "coty_fp_code": "273",
        "coty_gnis_code": "01383922"
      },
      "bbox": [
        -1.3757308155054508, -11.45236069029734, -0.6250589495668007,
        -11.034828409581014
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0717138075745454, -7.776474824378961],
            [-1.995490369260978, -7.779416178338936],
            [-1.9910952687458212, -7.779196914668637],
            [-1.8885188377039062, -7.782952474686647],
            [-1.8856776555654717, -7.78250902647571],
            [-1.7820678814287547, -7.784396431756306],
            [-1.723619456570422, -7.785870561224984],
            [-1.7000921114242526, -7.786741110352246],
            [-1.6747236308270648, -7.787208597079439],
            [-1.6280963054698878, -7.788917872275204],
            [-1.6313683743728395, -7.803160364818234],
            [-1.632096562633481, -7.820621418410807],
            [-1.6382002274706033, -7.826770283342905],
            [-1.6391183638048215, -7.830918843878712],
            [-1.6351060558249955, -7.837567707993348],
            [-1.6315852013606484, -7.839368948015024],
            [-1.6225639632909963, -7.839619587769269],
            [-1.6172667600694728, -7.840881974332692],
            [-1.6095356642105911, -7.846288838628493],
            [-1.6070850453828696, -7.851385924560034],
            [-1.6075368345154466, -7.85956760785345],
            [-1.6100416494073873, -7.87107656563609],
            [-1.6096207990086169, -7.8752932147917445],
            [-1.6018067041292465, -7.87537384826376],
            [-1.5986737848056272, -7.874016800119135],
            [-1.595173349902229, -7.866886861308224],
            [-1.5854966695820052, -7.86798641195648],
            [-1.5751095916630247, -7.872972630222244],
            [-1.5713458301687082, -7.876356815984471],
            [-1.572095470880572, -7.881686745264208],
            [-1.5776808542487644, -7.8890018602866965],
            [-1.58303962709725, -7.892414481586927],
            [-1.5923038388793458, -7.89172115367106],
            [-1.5944251038780801, -7.892626804779359],
            [-1.5987813358059608, -7.901387716810189],
            [-1.6003699266240186, -7.91116044532012],
            [-1.6028997323311798, -7.915209757198855],
            [-1.6055250936066274, -7.915859967303409],
            [-1.6135821046638885, -7.914277799851929],
            [-1.6196690797581854, -7.9193114630650365],
            [-1.6198622917700154, -7.92340542275604],
            [-1.6120867666518404, -7.933790353568755],
            [-1.6123142558207362, -7.936766673304496],
            [-1.615889205824106, -7.941865538065489],
            [-1.6188984258319887, -7.94861147135943],
            [-1.6179919296659524, -7.955277539442483],
            [-1.6160691282685025, -7.958052712662608],
            [-1.6124202491544797, -7.959201742927827],
            [-1.6056675009515, -7.957888024758795],
            [-1.5934168052576887, -7.959920676674512],
            [-1.5884492503426917, -7.963750559447298],
            [-1.580344326829741, -7.96429606121675],
            [-1.575834968797651, -7.963185355075725],
            [-1.5721547185880456, -7.96407112400987],
            [-1.5691533211720228, -7.9677725891327515],
            [-1.5694516764779236, -7.9701856462916565],
            [-1.58137632133229, -7.979974739649796],
            [-1.5877197737595554, -7.98885236872649],
            [-1.5958076684140472, -7.988047471107983],
            [-1.6007434589629483, -7.993186279969345],
            [-1.6020695797637006, -7.999248587682553],
            [-1.606414093244227, -8.005108722249917],
            [-1.6065126572192423, -8.007646458819302],
            [-1.6013272798275429, -8.014997022794716],
            [-1.5969067102546275, -8.028780120430909],
            [-1.5976284138379062, -8.032172799674813],
            [-1.6018561218190424, -8.034389291395268],
            [-1.6066845517673851, -8.033381319767084],
            [-1.6122730900184776, -8.03486898474209],
            [-1.6210132453268533, -8.033789240837763],
            [-1.6286772356849342, -8.035434707951698],
            [-1.6312264831259708, -8.042253736189645],
            [-1.6290333040313143, -8.046124183843363],
            [-1.6240476592348347, -8.045953876330087],
            [-1.6198701050207476, -8.048123875271758],
            [-1.619837972141347, -8.054828432912933],
            [-1.6118767987208649, -8.063023641212917],
            [-1.6107763955834893, -8.070219265559135],
            [-1.6120759099722992, -8.075846229827917],
            [-1.6114951687747563, -8.081550202366268],
            [-1.6057935456228396, -8.095110777150644],
            [-1.5977226082678626, -8.109184000930028],
            [-1.5993159144552982, -8.115701106829974],
            [-1.6080818425038055, -8.120907536833334],
            [-1.6092637519683457, -8.12477947737722],
            [-1.607300419281221, -8.133896352743223],
            [-1.6048710229367187, -8.138892910511444],
            [-1.600491285678245, -8.144662602955881],
            [-1.595877940213155, -8.14466382727621],
            [-1.5894821695086796, -8.141147325036362],
            [-1.5817970913945207, -8.138173396050053],
            [-1.577089016248908, -8.135394049486322],
            [-1.572236217367765, -8.13497411966565],
            [-1.5671347842738497, -8.13792448354721],
            [-1.5569561299738337, -8.151195165250636],
            [-1.5575155720222398, -8.19203362986047],
            [-1.557327293406426, -8.196816686993785],
            [-1.5578774261125272, -8.222986592870683],
            [-1.6004547395812014, -8.208546336863334],
            [-1.6094146043424329, -8.205835430009026],
            [-1.6482413659213178, -8.205202278780982],
            [-1.7643645651928868, -8.204000586899042],
            [-1.8627963884021856, -8.20210616928835],
            [-1.9007298961702033, -8.201306952024833],
            [-1.9568473445186108, -8.199199863781732],
            [-2.008173694097582, -8.197715194954997],
            [-2.0846089194088715, -8.196115723870804],
            [-2.084435170011586, -8.193878378741676],
            [-2.077961690832934, -7.991055649090613],
            [-2.0717138075745454, -7.776474824378961]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.68412287378092, "lat": 30.70577838180128 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48299"],
        "coty_name": ["Llano"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Llano County"],
        "coty_fp_code": "299",
        "coty_gnis_code": "01383935"
      },
      "bbox": [
        -2.0846089194088715, -8.222986592870683, -1.5569561299738337,
        -7.776474824378961
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.832789848218994, -6.480657875756909],
            [-4.769036928788125, -6.4850199937146575],
            [-4.669879673109967, -6.491345374936715],
            [-4.56603424574932, -6.497979188593421],
            [-4.504775605467479, -6.50165686804202],
            [-4.402886153542893, -6.507867441850369],
            [-4.413664390269536, -6.686689097457377],
            [-4.418506331163541, -6.765608023217819],
            [-4.429225116007523, -6.941676109093165],
            [-4.610041458097407, -6.930297580051502],
            [-4.7906194353074545, -6.91877266927348],
            [-4.861974588885332, -6.9144201506950616],
            [-4.8577992102816685, -6.850563902710557],
            [-4.847281978384336, -6.693085807045434],
            [-4.842142945889525, -6.6165582212107825],
            [-4.836723288841409, -6.5406279023453715],
            [-4.832789848218994, -6.480657875756909]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.03160021310713,
          "lat": 31.86913148696111
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48329"],
        "coty_name": ["Midland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Midland County"],
        "coty_fp_code": "329",
        "coty_gnis_code": "01383950"
      },
      "bbox": [
        -4.861974588885332, -6.941676109093165, -4.402886153542893,
        -6.480657875756909
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.7905667250748608, -7.806012440697877],
            [0.868491588442383, -7.7421895189797905],
            [0.9463977372337474, -7.678338971917957],
            [0.9474019444939747, -7.794791239164798],
            [0.9474991007191703, -7.79829444073914],
            [0.9556161089216142, -7.7983057972645415],
            [0.9640646532846768, -7.801984992138111],
            [0.968304826714589, -7.807817658795585],
            [0.9650133712905392, -7.817413438806228],
            [0.9676646005616779, -7.821692533815668],
            [0.9640751909643424, -7.8258507759714],
            [0.9660149068554866, -7.828910042003715],
            [0.971720963103934, -7.82951278986035],
            [0.973058232273993, -7.8372312732889835],
            [0.9787689400580163, -7.843278917698972],
            [0.9932231199969521, -7.848032217001549],
            [0.9941424769512702, -7.854963649920613],
            [0.9888705011089156, -7.856400283406985],
            [0.9836496555078231, -7.855045662603616],
            [0.97962258781687, -7.851911874238246],
            [0.9783947340665733, -7.855295340280806],
            [0.9839184146980486, -7.857701421977434],
            [0.984018839124851, -7.860927449570967],
            [0.979595297503604, -7.865964145629598],
            [0.978192417619561, -7.8703915561145665],
            [0.9801942050603244, -7.877277936272975],
            [0.9871131369330308, -7.879021177204009],
            [0.9899398439941834, -7.881236150038719],
            [1.0018905934690394, -7.878715097359325],
            [1.0085132789467288, -7.88010881187363],
            [1.018399775466274, -7.877778803353851],
            [1.020365188740514, -7.874287748015342],
            [1.0192054635502865, -7.86910220753663],
            [1.0240399184043507, -7.85947796947977],
            [1.026441763572579, -7.859143646599632],
            [1.031268681909317, -7.8631179097458785],
            [1.0363653823395558, -7.873672126325471],
            [1.039433027869333, -7.875055306754965],
            [1.0317641630496084, -7.9837186307735655],
            [1.0307420804322502, -7.995997554921754],
            [1.0268514572854772, -8.065331997128872],
            [1.024792952725062, -8.107833633312632],
            [1.0147187476726502, -8.227773198498705],
            [1.0123582116320389, -8.223279079864376],
            [0.9008985653316278, -8.224028813227664],
            [0.8085949620183305, -8.224318185126448],
            [0.7236291093188285, -8.173183827382692],
            [0.6513448504130036, -8.129400235482171],
            [0.609470306398035, -8.104566432125191],
            [0.5961583970354691, -7.99843831481459],
            [0.5931420509794081, -7.972606659742139],
            [0.5809591075918409, -7.872441684151805],
            [0.5868277990032018, -7.871366228946034],
            [0.5918887336257473, -7.868943609591662],
            [0.5928957997628587, -7.873511505250522],
            [0.6002082166906622, -7.873304983018761],
            [0.6049001202977724, -7.871467285660316],
            [0.6093017202955712, -7.874411858481127],
            [0.6121031647314725, -7.87101552247674],
            [0.6204279302415519, -7.86729179986427],
            [0.6249442435538558, -7.867932729176063],
            [0.6270964036097513, -7.864297649389804],
            [0.631253912601189, -7.862847854305224],
            [0.6379740185212651, -7.85835955124419],
            [0.6440825930810498, -7.8585708750834025],
            [0.6481422049281247, -7.857236633720718],
            [0.6510511274094596, -7.852808272846152],
            [0.6611271461547183, -7.846907377220685],
            [0.6616282102079427, -7.843963495955511],
            [0.6703392150215327, -7.837344226340805],
            [0.6761562448036288, -7.836584245467449],
            [0.68334450886325, -7.8341878377887255],
            [0.6893894043291791, -7.83670690370413],
            [0.6957639272477721, -7.833224723783673],
            [0.7005673233688731, -7.82805950017831],
            [0.7092215482941169, -7.826312241368256],
            [0.7120590496082959, -7.830135830449617],
            [0.7204007071340742, -7.829642210539419],
            [0.7224583863462106, -7.832075884001976],
            [0.7316644464402148, -7.8354849494096825],
            [0.732751203118053, -7.8329667813678805],
            [0.7392830071756062, -7.83032317012469],
            [0.7447124767165312, -7.8330747445552955],
            [0.7492608052031219, -7.8314127620241925],
            [0.757411603313197, -7.840072338283377],
            [0.7580163524407938, -7.842830103852619],
            [0.763795548820416, -7.840977180949457],
            [0.7687163213491646, -7.836198154826985],
            [0.7776500134665051, -7.836928491831102],
            [0.7806571722295661, -7.836190675592759],
            [0.7806154385536588, -7.827756699883428],
            [0.7843621418960008, -7.826562795908024],
            [0.7875736393520397, -7.822713024708151],
            [0.7913150462074126, -7.82597894507551],
            [0.793856946250916, -7.823314937539911],
            [0.7930472930327064, -7.818829176946824],
            [0.7898714444055943, -7.813845023885301],
            [0.7905667250748608, -7.806012440697877]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.57228240719729,
          "lat": 30.738998227932182
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48471"],
        "coty_name": ["Walker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walker County"],
        "coty_fp_code": "471",
        "coty_gnis_code": "01384021"
      },
      "bbox": [
        0.5809591075918409, -8.227773198498705, 1.039433027869333,
        -7.678338971917957
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.508492660002727, 0.7726298636480258],
            [-13.356616475072142, 0.7440922377325209],
            [-13.204742988817321, 0.7155401956729952],
            [-13.052872178426078, 0.6869737388176351],
            [-12.901004020585253, 0.6583928711939515],
            [-12.673992383957534, 0.6166035658562262],
            [-12.59962846624263, 0.6027193022449833],
            [-12.571550923762107, 0.5979881932530691],
            [-12.564685261060687, 0.5962689209419382],
            [-12.523685945453092, 0.5888844930298834],
            [-12.471313730072325, 0.5796450096041789],
            [-12.409034085662714, 0.5691564396019543],
            [-12.305371864445418, 0.5502860565755947],
            [-12.330930548479397, 0.4036076558033289],
            [-12.335043039077812, 0.38152496037724903],
            [-12.325859662020406, 0.3799161720035961],
            [-12.34203622922315, 0.2932847472200294],
            [-12.434586326081497, 0.309445116352438],
            [-12.436059987068136, 0.30128137288537676],
            [-12.428294316942033, 0.2999073650222437],
            [-12.441956769366252, 0.2227386633005553],
            [-12.49103373535521, 0.23360060744912273],
            [-12.512895810592676, 0.23629645916681508],
            [-12.527098446135113, 0.23887027932268123],
            [-12.542553398699587, 0.1509739526125975],
            [-12.539936686040049, 0.15063793843054962],
            [-12.550779318870807, 0.09409601243518737],
            [-12.554503511760036, 0.0660712071172316],
            [-12.553351668577177, 0.06532642645337715],
            [-12.569011417423111, -0.022291829248935316],
            [-12.647201485920828, -0.008594213297029373],
            [-12.737100486984447, 0.007508050525992058],
            [-12.744680142077002, -0.035722925555027915],
            [-12.85000683314979, -0.016996743127991865],
            [-12.854526329648552, -0.04211501671536869],
            [-12.938870566538519, -0.026962496998126504],
            [-12.937671305353229, -0.02027319268750291],
            [-12.99244366142273, -0.010245986378974418],
            [-12.992284158652648, -0.009353318844994622],
            [-13.020470903667055, -0.003954158715618404],
            [-13.011820189263554, 0.04252253601140781],
            [-13.069805438205192, 0.05337636800885286],
            [-13.153035888635065, 0.06880926754878779],
            [-13.18223442711206, 0.07411161235241338],
            [-13.17770450638205, 0.09843353628967919],
            [-13.166117969054108, 0.16273755704878262],
            [-13.25348569581877, 0.1789702658923867],
            [-13.25603332091331, 0.16546291065249516],
            [-13.303040607356674, 0.17454497956285905],
            [-13.614170087053147, 0.23357878906592155],
            [-13.586673862949054, 0.37350950161327817],
            [-13.581548623667883, 0.3926674239487792],
            [-13.571997651199778, 0.43635885315467127],
            [-13.57029510959211, 0.45020542895374493],
            [-13.564985833413429, 0.47886412994452054],
            [-13.559277080236818, 0.5074428599775407],
            [-13.537256525186326, 0.6251551448946355],
            [-13.508492660002727, 0.7726298636480258]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.28949504359547,
          "lat": 37.85917471822227
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49021"],
        "coty_name": ["Iron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iron County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01448025"
      },
      "bbox": [
        -13.614170087053147, -0.04211501671536869, -12.305371864445418,
        0.7726298636480258
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.614170087053147, 0.23357878906592155],
            [-13.303040607356674, 0.17454497956285905],
            [-13.25603332091331, 0.16546291065249516],
            [-13.25348569581877, 0.1789702658923867],
            [-13.166117969054108, 0.16273755704878262],
            [-13.17770450638205, 0.09843353628967919],
            [-13.18223442711206, 0.07411161235241338],
            [-13.153035888635065, 0.06880926754878779],
            [-13.069805438205192, 0.05337636800885286],
            [-13.011820189263554, 0.04252253601140781],
            [-13.020470903667055, -0.003954158715618404],
            [-12.992284158652648, -0.009353318844994622],
            [-12.99244366142273, -0.010245986378974418],
            [-12.937671305353229, -0.02027319268750291],
            [-12.938870566538519, -0.026962496998126504],
            [-12.854526329648552, -0.04211501671536869],
            [-12.85000683314979, -0.016996743127991865],
            [-12.744680142077002, -0.035722925555027915],
            [-12.783984713895125, -0.25282030027301516],
            [-12.782284108053192, -0.25312694459047086],
            [-12.800134221109065, -0.35211862479582745],
            [-12.83258400058527, -0.5325771679066764],
            [-12.884975837334446, -0.5232468194298298],
            [-12.97326546281445, -0.5072909732724957],
            [-13.124714546375145, -0.4796672271397344],
            [-13.229762339354448, -0.46031853245015286],
            [-13.288005236425622, -0.4495242652339974],
            [-13.396724686764585, -0.4292479954822152],
            [-13.62343578048976, -0.38643324437511356],
            [-13.662216517631201, -0.37898684834543167],
            [-13.727936259507592, -0.36600235568978384],
            [-13.71204656811846, -0.2785380944619556],
            [-13.709922866621769, -0.26298150811477006],
            [-13.70339626748691, -0.2330496756538629],
            [-13.701194637246603, -0.22029328193916276],
            [-13.69598747952014, -0.195323561634908],
            [-13.684058848969125, -0.13439490529242362],
            [-13.67496876886508, -0.08473627275030551],
            [-13.6730810481051, -0.07564335999358121],
            [-13.658368622566499, 0.001413955350946733],
            [-13.649216870253005, 0.048342304636840985],
            [-13.647197939168526, 0.06168889177103749],
            [-13.635844864374363, 0.121793534932297],
            [-13.616834138704448, 0.22175861855196285],
            [-13.614170087053147, 0.23357878906592155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.50478520248899,
          "lat": 37.28040320673851
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49053"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01448040"
      },
      "bbox": [
        -13.727936259507592, -0.5325771679066764, -12.744680142077002,
        0.23357878906592155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.767754131313726, 1.5603893811323848],
              [14.771278053597568, 1.5568102125127041],
              [14.775399403210125, 1.5572750868544913],
              [14.778565506338166, 1.5540026541805099],
              [14.78186605413726, 1.5529944172845878],
              [14.784797432201803, 1.5482572571680324],
              [14.790889442527872, 1.549956093578022],
              [14.799500525865126, 1.549720343855255],
              [14.799363608894643, 1.5520910789950078],
              [14.806769626489205, 1.5523406211064366],
              [14.806555654809083, 1.5580605184728853],
              [14.812163604113294, 1.5594425044739986],
              [14.818486913613915, 1.559597797188374],
              [14.81606141909507, 1.566921558395169],
              [14.817378399691597, 1.5711099156290609],
              [14.815373650366961, 1.5814889620645454],
              [14.813452300096841, 1.584501942667658],
              [14.797243523608897, 1.5827334811840146],
              [14.79597878485193, 1.5866886452784636],
              [14.788224378354197, 1.5826959951798971],
              [14.788152503446087, 1.5766868449997973],
              [14.782491979547087, 1.5788599348571],
              [14.77801397284256, 1.5782884315090875],
              [14.769686442192743, 1.5745184476007388],
              [14.767311265041583, 1.5627094046029069],
              [14.767754131313726, 1.5603893811323848]
            ],
            [
              [14.782685588880094, 1.5578586907909644],
              [14.790131351994944, 1.559457665371411],
              [14.789171884152845, 1.555747850559881],
              [14.782685588880094, 1.5578586907909644]
            ]
          ],
          [
            [
              [14.616347708723906, 1.526201355084552],
              [14.674253125462378, 1.645955777224282],
              [14.732044034230618, 1.7655774124658155],
              [14.743235419044998, 1.7620558374490178],
              [14.754253561091186, 1.7614718185100042],
              [14.760805225050694, 1.7596903117035576],
              [14.777138652478722, 1.7501696918845067],
              [14.792584947317176, 1.749052312847918],
              [14.800611036367547, 1.7454071768677957],
              [14.802617511901085, 1.7408682398188262],
              [14.801930989156606, 1.7352765540899562],
              [14.79890605301432, 1.7311730935631162],
              [14.797743309168428, 1.72167855393244],
              [14.801106857739478, 1.7154550943391962],
              [14.804371032380287, 1.7140488802063296],
              [14.810041633593293, 1.703682008551329],
              [14.8186866459743, 1.6990034187048186],
              [14.819968328046272, 1.702544955662122],
              [14.82310986425937, 1.7020431980661377],
              [14.826698084678375, 1.6975582634916624],
              [14.829719862749855, 1.6960642557909882],
              [14.837646965060696, 1.6956953376122754],
              [14.8391097442853, 1.6970174854603708],
              [14.848733399837718, 1.6952396893718307],
              [14.85928428442102, 1.699413164817161],
              [14.867923837397445, 1.6998079785481894],
              [14.872807432202158, 1.7013026960744089],
              [14.8839741785464, 1.7013029266131237],
              [14.887681500785167, 1.700378029285201],
              [14.896172582193905, 1.6929226692893997],
              [14.906846067848363, 1.6793182964472482],
              [14.913863712788537, 1.6749240686738776],
              [14.882397628975683, 1.626265253549331],
              [14.869294061686977, 1.6267470322553919],
              [14.867199872645545, 1.6158771085305594],
              [14.87218746091275, 1.6086644163049384],
              [14.879864605338026, 1.6112867218795017],
              [14.884176400693825, 1.6116740309307593],
              [14.89887017959119, 1.608346001874289],
              [14.90334796744176, 1.6100031051632349],
              [14.902955326466667, 1.6123002460570224],
              [14.938981824566467, 1.5877590777108581],
              [14.938784941403561, 1.5863305385705837],
              [14.93137587047758, 1.581797996905703],
              [14.928729110477207, 1.5821756191267393],
              [14.92522953477495, 1.5731890233249852],
              [14.919335403075959, 1.5653882233632301],
              [14.923196139399387, 1.5606017276268829],
              [14.919698432218679, 1.552375863810428],
              [14.920982372326968, 1.5460386991876338],
              [14.927559744806391, 1.5374565248453986],
              [14.952025870872136, 1.5478436321734228],
              [14.955593102629113, 1.5484808378921573],
              [14.972497968190426, 1.5492246928232953],
              [14.984302502244018, 1.5470902550027528],
              [14.986934336153725, 1.5453005473997663],
              [15.003660393764475, 1.5396022440728372],
              [15.011032675409922, 1.495709052152319],
              [15.014710828586022, 1.4806190912826973],
              [15.014752883367725, 1.4735229091431394],
              [15.013440793523591, 1.4685412508663314],
              [15.009039435326962, 1.4630015593970713],
              [14.994889272732344, 1.460320210501517],
              [14.989503990065812, 1.462675277576768],
              [14.988957330614268, 1.458016648269004],
              [14.984767033166396, 1.454100884997192],
              [14.976597853729238, 1.4448213411146589],
              [14.971728716663211, 1.441987091118636],
              [14.961719988840887, 1.428646810837],
              [14.956152012030044, 1.4151708033082167],
              [14.958352993818805, 1.3909025626020906],
              [14.962501190699557, 1.3859705626247636],
              [14.965623336512248, 1.3771254181553192],
              [14.954962687604324, 1.3757141391108614],
              [14.952384014325233, 1.3745565151496109],
              [14.94410150121035, 1.374708981357711],
              [14.93816865272006, 1.3617606424522417],
              [14.93003107614653, 1.3578730399572867],
              [14.92216455278885, 1.3520805306300139],
              [14.917382603981995, 1.3513743446116677],
              [14.914630541488771, 1.3490335556791213],
              [14.911536736165578, 1.351535346101389],
              [14.91022625622012, 1.3567077626799764],
              [14.905311623506535, 1.3598837884564647],
              [14.90081341605755, 1.3670802476920159],
              [14.905556083953597, 1.3677437082228872],
              [14.909115322644377, 1.3710366167452803],
              [14.911845298050851, 1.3784639591080268],
              [14.914639199679518, 1.3832285367086983],
              [14.910164715516933, 1.3877780316970851],
              [14.905379143161978, 1.3892076936194837],
              [14.90044863216381, 1.3862136488621264],
              [14.889414297681446, 1.3851517187711118],
              [14.887907600409477, 1.387524810426893],
              [14.881757676672933, 1.3874018085305797],
              [14.872046755552137, 1.3957849192157705],
              [14.866734766447593, 1.3975943646286915],
              [14.864690130281781, 1.4009750757955337],
              [14.858834466763419, 1.406218459914513],
              [14.852980106937933, 1.4081725317988565],
              [14.84480815551468, 1.4133073531468956],
              [14.839112054431116, 1.4144076486035926],
              [14.827871618674463, 1.4193096820194608],
              [14.82408325337602, 1.420143855645918],
              [14.820931336349242, 1.4229052130182975],
              [14.817303234639285, 1.4220990501149877],
              [14.813653642836107, 1.4156186213910005],
              [14.804966053316072, 1.4134703409242233],
              [14.802786221474914, 1.4156992003919715],
              [14.806608391596786, 1.4218941976448294],
              [14.804526669891036, 1.4246159393012219],
              [14.799028092492481, 1.4221838300566765],
              [14.796489382528113, 1.4233595215560844],
              [14.795592724228273, 1.428933405353277],
              [14.79334723795751, 1.4295911200746654],
              [14.782695534831447, 1.429264263395095],
              [14.776631178640127, 1.4324147135627006],
              [14.774504027573684, 1.4302796725445936],
              [14.772843597823698, 1.4213071550186864],
              [14.77036906005427, 1.4194985229661645],
              [14.769017117205435, 1.4152782555915813],
              [14.765224616208764, 1.4166414022788982],
              [14.760543351337105, 1.4215259703690153],
              [14.75828923277323, 1.4275950548571836],
              [14.759482081808374, 1.4332633289999874],
              [14.755518928546529, 1.4406933440794325],
              [14.747543457707588, 1.4447375024670843],
              [14.74761936070484, 1.4506254502109903],
              [14.740429730655421, 1.4496868362960953],
              [14.736902962596215, 1.4521367762945934],
              [14.732952171977361, 1.4439326537787778],
              [14.730050836220201, 1.4458976362101787],
              [14.73253304078298, 1.453030612268005],
              [14.724685688998887, 1.4558281541466542],
              [14.723142729965588, 1.4586847830843916],
              [14.726189655483672, 1.4608130840866973],
              [14.722945982277238, 1.4651254316861617],
              [14.724544221512314, 1.4697163728123752],
              [14.709568975929669, 1.4764688488071087],
              [14.707258669456557, 1.4747811809449838],
              [14.706131561892306, 1.4817516194595235],
              [14.698930070968363, 1.4927013420614192],
              [14.69521911158635, 1.496779875676938],
              [14.691972395430097, 1.4963891341729763],
              [14.689674277540758, 1.4881533718558442],
              [14.682213658932847, 1.4858132490305669],
              [14.658778063039342, 1.4834225052719279],
              [14.657137636889587, 1.4859314219079331],
              [14.659464423710425, 1.4919931029459055],
              [14.65724544395071, 1.49721917854123],
              [14.649110224769293, 1.4983264712959337],
              [14.645842803720221, 1.4999428879286896],
              [14.643953578479673, 1.5049738047429817],
              [14.644846780189809, 1.5094582791320075],
              [14.637536892512317, 1.5129193554639924],
              [14.639573345684148, 1.5199013978935583],
              [14.636272554147823, 1.52395057665295],
              [14.62893524612431, 1.5183323300663898],
              [14.623191959598165, 1.5168934770447928],
              [14.618728055430436, 1.5184214688588962],
              [14.616501940407144, 1.52148325272482],
              [14.616347708723906, 1.526201355084552]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.27697413279441,
          "lat": 38.836775205414575
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51059"],
        "coty_name": ["Fairfax"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fairfax County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01480119"
      },
      "bbox": [
        14.616347708723906, 1.3490335556791213, 15.014752883367725,
        1.7655774124658155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.903149890243547, 1.069922676016523],
            [14.910683424813081, 1.0617931293309468],
            [14.923555494247267, 1.057153491710662],
            [14.942471179228296, 1.0594361562108252],
            [14.95093940613134, 1.0637421202611084],
            [14.962077793786227, 1.0711271781387588],
            [14.967724630035459, 1.0741899143852438],
            [14.986098024800576, 1.0785848254971873],
            [14.998446132785924, 1.0861037962013256],
            [15.003152722357205, 1.0922525681077075],
            [15.008253672406063, 1.1040039049875958],
            [15.012712534386159, 1.1115466585337712],
            [15.02323804070219, 1.112472208937836],
            [15.034150019607733, 1.1174060996839692],
            [15.03787033878137, 1.1183994639454624],
            [15.04947887380609, 1.1182875140161483],
            [15.053292785666022, 1.120109056594159],
            [15.057603106406686, 1.1247963672881531],
            [15.062155318678887, 1.1315155207243606],
            [15.071080800948236, 1.155129271721484],
            [15.079855667756027, 1.158316452389566],
            [15.101026214847796, 1.1438050059552707],
            [15.107582207227622, 1.137522804397523],
            [15.105181862656082, 1.133400723436922],
            [15.108042348012477, 1.12490776045978],
            [15.109428244235065, 1.1171989146611632],
            [15.110280559055203, 1.104223335552935],
            [15.112570227777203, 1.101063925985774],
            [15.11361224225154, 1.0956947948961129],
            [15.10971266858821, 1.0913105615394072],
            [15.110123807910204, 1.0863700049384406],
            [15.103372554003581, 1.0798055110196585],
            [15.097601565586068, 1.0780628858617713],
            [15.094774134538032, 1.081332436405596],
            [15.085559004925203, 1.079854729603053],
            [15.083400595915531, 1.0770188653030415],
            [15.086579321137435, 1.072474700730338],
            [15.088898038784482, 1.0726546598638609],
            [15.096933432980931, 1.0683236238629454],
            [15.10583318598285, 1.072344790153816],
            [15.110958105143087, 1.064174507550309],
            [15.118626596111294, 1.061513044953884],
            [15.124994959398899, 1.0555882388451734],
            [15.126197928728317, 1.0529886416587844],
            [15.133769609903135, 1.0472142028431697],
            [15.135558837440838, 1.0417974743493044],
            [15.130331176638505, 1.0417688438549517],
            [15.130178517818562, 1.0378233956818836],
            [15.126937627405779, 1.0334587668316917],
            [15.116357121334302, 1.0300816545267568],
            [15.114047118756373, 1.0247493063754152],
            [15.113383314609573, 1.0193832349627043],
            [15.109740540796908, 1.0209201403214028],
            [15.105520341308672, 1.0195696027657473],
            [15.117890081852822, 0.9440189865300264],
            [15.116064140278054, 0.9395286871835036],
            [15.117699258802434, 0.937013927289764],
            [15.109303421645263, 0.9310639859236556],
            [15.108209328742323, 0.9286593592379094],
            [15.109274889902444, 0.9224819079604075],
            [15.112194717582524, 0.919127285404036],
            [15.108039800645008, 0.9176704420676278],
            [15.10717269488448, 0.9140962340763258],
            [15.111023618196727, 0.9044699058036347],
            [15.109970005998415, 0.9002399949722197],
            [15.105756118877872, 0.8967115027622933],
            [15.0991974334036, 0.9012596867098577],
            [15.094995325881305, 0.9142145942716585],
            [15.086930523158925, 0.9140306924269322],
            [15.08231793674038, 0.9101142121142575],
            [15.07566552391395, 0.9009464727304556],
            [15.073080081148444, 0.8991899650803703],
            [15.067251126862141, 0.9013125435754759],
            [15.06414725851738, 0.9068675860868775],
            [15.057310212429877, 0.9108477586219943],
            [15.051820319565769, 0.9112886248074085],
            [15.04279756123995, 0.9139025424862366],
            [15.039063971672546, 0.9123285124581594],
            [15.032972867245537, 0.9066768015805081],
            [15.026875653908832, 0.9065856419362136],
            [15.012897596615106, 0.9125709044377487],
            [15.006238408529153, 0.9188201927452493],
            [14.993690912281853, 0.9255738549294034],
            [14.9886855541218, 0.9307488382666729],
            [14.983973076060883, 0.9324826325715367],
            [14.978685022163072, 0.9319391141653752],
            [14.9749693669321, 0.9279006609402263],
            [14.978837792977341, 0.9212617862217234],
            [14.978680012569704, 0.9192737817472191],
            [14.972378767033288, 0.9158510183443073],
            [14.960180644912601, 0.9169135564472025],
            [14.958795637828047, 0.9238433395503677],
            [14.963118819249605, 0.936754341168757],
            [14.964833688707898, 0.940083212230605],
            [14.963216396098607, 0.944599294850138],
            [14.954958344081437, 0.9537600143779258],
            [14.953616007126058, 0.9573004147889493],
            [14.958222879614118, 0.9615325241729993],
            [14.970144345446679, 0.9662458558638969],
            [14.972693230625119, 0.969649330635022],
            [14.97180390942682, 0.9738897705429186],
            [14.964317059687982, 0.9761573729149453],
            [14.954868043465526, 0.9738715256151378],
            [14.950965394528325, 0.9784960849708818],
            [14.948674706571394, 0.9784501789243233],
            [14.94033987013254, 0.9745200835117486],
            [14.935280266259088, 0.9744365306464394],
            [14.932735238190016, 0.972487110304565],
            [14.931709369115183, 0.9661048795571104],
            [14.93486954966548, 0.9562337568123318],
            [14.934865888927071, 0.9510861139290574],
            [14.93282538053426, 0.9477961207319902],
            [14.924571440125176, 0.9454291098548411],
            [14.921354536312155, 0.9496266277413972],
            [14.922448306616372, 0.9604480775629471],
            [14.919296494297045, 0.9635260186259538],
            [14.915733978481903, 0.9623010695274653],
            [14.908653316942836, 0.9535897979506726],
            [14.899583172873934, 0.9602089770517416],
            [14.893426359850011, 0.9612637606705902],
            [14.89073470758308, 0.9687466796273557],
            [14.883529711864202, 0.9711377098225891],
            [14.879187873677154, 0.9744352407752491],
            [14.876167083994009, 0.974643755564177],
            [14.876185438800691, 0.9818740108999853],
            [14.872263533787812, 0.9849536350312217],
            [14.875307633469632, 0.9962062123207006],
            [14.875181184962317, 1.0041406286928116],
            [14.873623641806049, 1.006393135851923],
            [14.872390792907272, 1.0167891475534385],
            [14.87493388812293, 1.0167112499980584],
            [14.876188104130838, 1.0224095354161236],
            [14.874465009937023, 1.0263903829897616],
            [14.878868273297039, 1.0344344590587449],
            [14.876490512500448, 1.0438799532498384],
            [14.873315334932096, 1.0487535645687518],
            [14.874562393414083, 1.0514054303552884],
            [14.87898697619697, 1.0541359456365385],
            [14.877683002777951, 1.0611854386335289],
            [14.886858754820329, 1.0628488987789653],
            [14.903149890243547, 1.069922676016523]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.15718745334875, "lat": 38.27334337033542 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51099"],
        "coty_name": ["King George"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["King George County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01480137"
      },
      "bbox": [
        14.872263533787812, 0.8967115027622933, 15.135558837440838,
        1.158316452389566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.442802094309622, -1.3255552123102945],
            [11.420463563927871, -1.328936486204878],
            [11.391560028108616, -1.3319758581781969],
            [11.36878313090005, -1.3353362256943726],
            [11.373250356022403, -1.3304040443654817],
            [11.374412772907114, -1.3270307844897717],
            [11.37979009329379, -1.3242593497910455],
            [11.39017500571869, -1.3163415309195015],
            [11.40299755118508, -1.3044829858375362],
            [11.407723956994044, -1.301363695048768],
            [11.411308659183005, -1.297440094403354],
            [11.42030583207263, -1.2956071446300668],
            [11.428456459946052, -1.2949815935612057],
            [11.427572422871576, -1.2913490527713811],
            [11.440624427478944, -1.281682925072007],
            [11.443768067701717, -1.2864077299428844],
            [11.446630592633138, -1.2849701781112326],
            [11.45451604691633, -1.2840255802274034],
            [11.460967156234036, -1.2783136443079819],
            [11.453706829691042, -1.2706761448966426],
            [11.449055908643956, -1.264672536211455],
            [11.449463195470447, -1.2593699331696384],
            [11.441012203420732, -1.24973251568821],
            [11.445524201513324, -1.2465037724247396],
            [11.449788831652135, -1.2464430988978643],
            [11.454741463591846, -1.2490437241114705],
            [11.457044341351406, -1.2547711482129538],
            [11.453743839905126, -1.2594128881991062],
            [11.456667503953959, -1.2610732958122377],
            [11.462151989873366, -1.2669732480262952],
            [11.467291433246526, -1.2644385666599136],
            [11.468704396957778, -1.269019438928987],
            [11.466040220173257, -1.2710072507716705],
            [11.461867577160637, -1.2789238783641304],
            [11.469041931251487, -1.2859725226591872],
            [11.46492636942233, -1.290015240836147],
            [11.453180228837802, -1.3055402040073094],
            [11.442802094309622, -1.3255552123102945]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.16043240504409,
          "lat": 36.617894912192696
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51520"],
        "coty_name": ["Bristol"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Bristol city"],
        "coty_fp_code": "520",
        "coty_gnis_code": "01498416"
      },
      "bbox": [
        11.36878313090005, -1.3353362256943726, 11.469041931251487,
        -1.2464430988978643
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.72561140064298, 0.9939657705995519],
            [14.728622174641185, 0.9949246398036177],
            [14.725734416147755, 1.0058031680652757],
            [14.728608306189878, 1.0085884774931912],
            [14.7323298549404, 1.009421030026206],
            [14.735997427068764, 1.0126614245382008],
            [14.742480390925792, 1.015054226619773],
            [14.746474219617765, 1.0148020401371178],
            [14.753865241319478, 1.0123302876251958],
            [14.759433707559895, 1.0090169113647671],
            [14.763242095249378, 1.0091179634603495],
            [14.765650508659995, 1.0140473761485647],
            [14.771960930685902, 1.0128634448118805],
            [14.77624407893525, 1.0062366378575218],
            [14.784011251896812, 0.9974196832543893],
            [14.793818168039055, 0.9821426428498692],
            [14.788473591371032, 0.9800148752865054],
            [14.793368667165893, 0.971968602966362],
            [14.788484572553433, 0.9674907597525589],
            [14.784898370570481, 0.973411244754018],
            [14.779980053409188, 0.9746298922628479],
            [14.776278569098773, 0.9637926898766082],
            [14.768950703812646, 0.9646878271920079],
            [14.759690602836281, 0.9643577232622876],
            [14.760071486354661, 0.969167773993775],
            [14.758142528342848, 0.9726085036809191],
            [14.75505863870171, 0.9694071738359635],
            [14.7455055182156, 0.9678117893852496],
            [14.746035284440808, 0.980593334327574],
            [14.73734151850508, 0.9843843248737216],
            [14.738163855226565, 0.9924813152534662],
            [14.729249524790172, 0.9925588926784986],
            [14.72561140064298, 0.9939657705995519]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.48718890880636, "lat": 38.29912503248098 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51630"],
        "coty_name": ["Fredericksburg"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Fredericksburg city"],
        "coty_fp_code": "630",
        "coty_gnis_code": "01498425"
      },
      "bbox": [
        14.72561140064298, 0.9637926898766082, 14.793818168039055,
        1.015054226619773
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.896662327402876, 10.999901327134596],
            [-17.882569398951087, 10.995267802540027],
            [-17.827099761269366, 10.980156419753104],
            [-17.813443194833955, 10.975642549825972],
            [-17.807754464276588, 10.994020113814619],
            [-17.806542773237304, 10.995496678034023],
            [-17.795786480230035, 11.000326598430823],
            [-17.78708819207554, 10.999843216834792],
            [-17.778123702323466, 10.99628874247887],
            [-17.773414089984794, 10.995712676958577],
            [-17.76890143476804, 10.996749297065344],
            [-17.764619799336163, 10.999679870382407],
            [-17.762141460118002, 11.003075740856676],
            [-17.754705113156053, 11.018350443624776],
            [-17.74721714648765, 11.024318044242433],
            [-17.741607231777103, 11.026381670361978],
            [-17.733311717043083, 11.028018129130407],
            [-17.722510221992305, 11.02764017911596],
            [-17.71651717160792, 11.028886822215137],
            [-17.709424603792026, 11.032620294791903],
            [-17.7037869767875, 11.038962778012037],
            [-17.70131313050868, 11.04610199522579],
            [-17.69355885261624, 11.04866018609631],
            [-17.69478344432347, 11.041965326069178],
            [-17.691785197036726, 11.037598003116582],
            [-17.686814899512385, 11.03564793441665],
            [-17.68058305391235, 11.030329037954582],
            [-17.68124676952508, 11.023276147706833],
            [-17.6805710293695, 11.01159048794798],
            [-17.664878453802068, 11.007925551393978],
            [-17.658511577008404, 11.008972248022525],
            [-17.653106486820317, 11.01174670606623],
            [-17.64806669507692, 11.012798900953992],
            [-17.642538099955605, 11.005864246297088],
            [-17.63845880409068, 11.005359047818212],
            [-17.639590112260244, 10.993520872324604],
            [-17.64432103341276, 10.99125133728495],
            [-17.645526506275793, 10.984416177782483],
            [-17.64919330429731, 10.980701344572315],
            [-17.647417171508174, 10.963027643258421],
            [-17.64557181906237, 10.958388942614317],
            [-17.640003794852, 10.96749589272278],
            [-17.640469217396554, 10.96993094666351],
            [-17.63644966748351, 10.976789168708406],
            [-17.63640840853928, 10.980632656845504],
            [-17.632883242322016, 10.989309922215831],
            [-17.62988099587569, 11.000616454460575],
            [-17.621466924587192, 11.014102696104914],
            [-17.616614818901287, 11.015293063484384],
            [-17.61712120036169, 11.007171732546409],
            [-17.616547555163187, 11.00109442083694],
            [-17.613717399568092, 10.999796281203613],
            [-17.611292989051446, 10.993684656735514],
            [-17.611565917360252, 10.988175273638527],
            [-17.609583102702672, 10.986296833919111],
            [-17.61039211487812, 10.978966060133946],
            [-17.60867729607549, 10.976177542597402],
            [-17.611224285402198, 10.970983615101666],
            [-17.612025324531196, 10.961087238286728],
            [-17.607546758817357, 10.958522884343358],
            [-17.607686508956963, 10.95397020074299],
            [-17.60013760221398, 10.95082290100674],
            [-17.595284157358165, 10.944786137787913],
            [-17.594749566705335, 10.940671396484372],
            [-17.587978993330385, 10.933297811243133],
            [-17.584749407657057, 10.930964832178955],
            [-17.580443832703814, 10.925105187564233],
            [-17.58142224658077, 10.91866154642304],
            [-17.573284477098728, 10.91592593471229],
            [-17.57126641669147, 10.917630830962722],
            [-17.566110129607356, 10.916196931810697],
            [-17.562333540571323, 10.92038319787842],
            [-17.557667953256704, 10.91946999900797],
            [-17.55920450918199, 10.914912656650785],
            [-17.562413415498302, 10.91363431243258],
            [-17.563824670885865, 10.909306412182673],
            [-17.57183249261536, 10.907229016475227],
            [-17.571376253243287, 10.904458538868418],
            [-17.57433748317891, 10.900083483548768],
            [-17.57212070113192, 10.889511257910133],
            [-17.574647777143543, 10.8873530164903],
            [-17.57081504380839, 10.88297147145427],
            [-17.56792935614517, 10.877726378199796],
            [-17.571243888397746, 10.874473573818044],
            [-17.566756575638067, 10.87144788023588],
            [-17.56355197102027, 10.86210992476246],
            [-17.56403085904011, 10.856057705628466],
            [-17.567903357042226, 10.852642587930342],
            [-17.56938887394829, 10.848415184755194],
            [-17.5658412377739, 10.842769692782944],
            [-17.568314256354164, 10.83885615055707],
            [-17.567634718685046, 10.83434602276679],
            [-17.56065260992245, 10.826951295139908],
            [-17.558461447405747, 10.821793745497722],
            [-17.550016901188982, 10.815714269337564],
            [-17.550171236594608, 10.812479821503441],
            [-17.544987726874275, 10.811141638994654],
            [-17.548611304645213, 10.801730094082371],
            [-17.55338612447878, 10.798016931365689],
            [-17.55550766112908, 10.792502416940323],
            [-17.551605448219444, 10.785666278876775],
            [-17.544955045797014, 10.78251182908979],
            [-17.541236631037428, 10.778411718458276],
            [-17.538261170821084, 10.787224515084832],
            [-17.53194505612751, 10.784868979420127],
            [-17.529075595485402, 10.781923183008875],
            [-17.521452121831526, 10.780022897311676],
            [-17.516578466011197, 10.78025745797737],
            [-17.5174874883116, 10.774998372884856],
            [-17.522288180781945, 10.777397728569639],
            [-17.515006875446304, 10.766215929715521],
            [-17.517387170512656, 10.76252012012195],
            [-17.517135297671274, 10.751634570989783],
            [-17.51884392070882, 10.744225900400052],
            [-17.518237380089662, 10.739773655610458],
            [-17.5148618286079, 10.7350922578672],
            [-17.50840504315825, 10.732103155111952],
            [-17.49765059994964, 10.723137859488524],
            [-17.497589220973605, 10.718124947045048],
            [-17.495441803327086, 10.712981550082201],
            [-17.48968929413414, 10.711081519658904],
            [-17.48223976288027, 10.702384045493416],
            [-17.482431797874142, 10.69725602546231],
            [-17.485085072501157, 10.691286374309321],
            [-17.484318152594792, 10.678767818585243],
            [-17.487356317916635, 10.67450360643162],
            [-17.483909259416244, 10.67241459672534],
            [-17.487287856152523, 10.669406248215363],
            [-17.48902261868683, 10.662164199747453],
            [-17.4852708283978, 10.661815620212819],
            [-17.4797753017112, 10.657907140450781],
            [-17.479270481550063, 10.653843259296378],
            [-17.4734013870457, 10.656284918299429],
            [-17.468464843285012, 10.652448127948915],
            [-17.470152683631, 10.6483926283834],
            [-17.467231558061385, 10.640971073283183],
            [-17.462488253346628, 10.643211075399348],
            [-17.461882345617404, 10.639863107558527],
            [-17.45520954742354, 10.634909109735048],
            [-17.45105912514524, 10.634369606739137],
            [-17.449187701839165, 10.631906601056318],
            [-17.442325756679875, 10.627331718641006],
            [-17.439791801408585, 10.622936630026924],
            [-17.42881165076656, 10.623103516775474],
            [-17.425275719842848, 10.616301265544962],
            [-17.422504477148138, 10.614900246530468],
            [-17.41601444985283, 10.619241926740433],
            [-17.41235236794917, 10.614399237232742],
            [-17.409474604657635, 10.615269185790316],
            [-17.407710380594146, 10.610432736203226],
            [-17.400478496227663, 10.606389647869253],
            [-17.396293728309733, 10.60614061191075],
            [-17.392439687446974, 10.609282694866875],
            [-17.387564319604365, 10.610200718149443],
            [-17.386963561692927, 10.607041867860966],
            [-17.390163610317373, 10.605399006910648],
            [-17.387772480502925, 10.600114408201886],
            [-17.38963622219773, 10.596680230252902],
            [-17.385900312296865, 10.593472646530298],
            [-17.379900653460936, 10.593317323631465],
            [-17.37605518108927, 10.590472674936805],
            [-17.37994543598387, 10.578458187356198],
            [-17.380523119894058, 10.572283506791235],
            [-17.383763040913006, 10.570430807717408],
            [-17.39071945118964, 10.561843344871376],
            [-17.389889054985577, 10.554691227519381],
            [-17.383103211227354, 10.549193774631288],
            [-17.382047819792064, 10.543680914469789],
            [-17.378388524247875, 10.535761549329743],
            [-17.373469188027126, 10.535670722928549],
            [-17.370285828502414, 10.526445188583835],
            [-17.365210217873067, 10.524211413801936],
            [-17.363323523858103, 10.529117519104767],
            [-17.360247447213915, 10.529591552383387],
            [-17.35594542622134, 10.527496772220564],
            [-17.353626488151836, 10.530226118488445],
            [-17.348620187483217, 10.529702729124793],
            [-17.346442007930232, 10.5260453444547],
            [-17.342950604723086, 10.524410403927686],
            [-17.341243061211628, 10.520404841739587],
            [-17.338371729815307, 10.520918616754193],
            [-17.334213107290644, 10.518363584130759],
            [-17.33078712152718, 10.518870927774586],
            [-17.329853483305993, 10.513906488524478],
            [-17.32729809546866, 10.51067021894358],
            [-17.419273596973028, 10.536404042719797],
            [-17.511256724620857, 10.562109351346345],
            [-17.515184095140466, 10.562183098465288],
            [-17.530124380936414, 10.567028067354666],
            [-17.570522737697335, 10.579037487043886],
            [-17.6004343108139, 10.586341912667049],
            [-17.621144031622748, 10.59333426872002],
            [-17.647116914144334, 10.601169467545756],
            [-17.695696057254267, 10.614836276537437],
            [-17.70953246059794, 10.618892803690619],
            [-17.72395376851313, 10.622592085217043],
            [-17.730780078476283, 10.62522447283156],
            [-17.785946794689348, 10.640669267806151],
            [-17.848920713611257, 10.659530776214456],
            [-17.875353968593792, 10.667110092536364],
            [-17.931669325273134, 10.68266735828915],
            [-17.95977731170503, 10.691225831609193],
            [-17.951407328144484, 10.718448247908464],
            [-17.94186531398884, 10.750145879875472],
            [-17.918791397392017, 10.827618504349891],
            [-17.897882817824286, 10.89464395588375],
            [-17.89310785639892, 10.908039597760382],
            [-17.90743365744496, 10.9130358834935],
            [-17.92220719108541, 10.917563980091757],
            [-17.91697698291128, 10.929738934072972],
            [-17.900829381589443, 10.983832983255558],
            [-17.896662327402876, 10.999901327134596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.83334308444942,
          "lat": 46.925625718072595
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53067"],
        "coty_name": ["Thurston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Thurston County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01529226"
      },
      "bbox": [
        -17.95977731170503, 10.51067021894358, -17.32729809546866,
        11.04866018609631
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.999164405117067, 1.517351727151824],
            [12.036195924632155, 1.573310705411674],
            [12.100520141534513, 1.6371841902948356],
            [12.10893546697011, 1.6729943105467684],
            [12.112037847587702, 1.6735281104544215],
            [12.121746185880784, 1.6783184829274465],
            [12.127575329826374, 1.673545406354035],
            [12.13254682201913, 1.6784125400259118],
            [12.137778923639578, 1.6760283634603965],
            [12.138989117113477, 1.678133748060781],
            [12.150742654174472, 1.6836289324088323],
            [12.150750262476011, 1.6894492498561506],
            [12.156837507613053, 1.6948558201600514],
            [12.162404148992113, 1.694819047693441],
            [12.164943276830945, 1.7002035111304648],
            [12.168853334556832, 1.6973597976975905],
            [12.17819365010176, 1.7043601755653048],
            [12.178186272618898, 1.705852666429427],
            [12.181832156378636, 1.7067115102170178],
            [12.188980470298514, 1.7007056003195413],
            [12.195280076304922, 1.6998770559995615],
            [12.195027752067807, 1.7078883919890295],
            [12.197187286676268, 1.707385590395945],
            [12.201749361703488, 1.7107212662995197],
            [12.206469674966232, 1.7106600458824752],
            [12.209348573940327, 1.706584247374281],
            [12.211647732460763, 1.69914890705978],
            [12.210333662343107, 1.6952908617144842],
            [12.21754272969905, 1.6981414700812736],
            [12.22020957065182, 1.7017038624762797],
            [12.226171672214333, 1.7003543378981691],
            [12.226688338352655, 1.6959461438179873],
            [12.232062971969038, 1.6978791157495001],
            [12.23613146838983, 1.6964694191817546],
            [12.237603484518004, 1.6938405862213304],
            [12.239838263896308, 1.6877559524381929],
            [12.24365836813986, 1.6881044581200668],
            [12.243584231289535, 1.6821185899895226],
            [12.244793331105802, 1.675765467399998],
            [12.239322150657673, 1.6681193402874466],
            [12.240713371298583, 1.6611446134960275],
            [12.24316398836231, 1.6608276085565432],
            [12.244480371586068, 1.6561822396194437],
            [12.248804948175632, 1.6488378116186568],
            [12.246760363233578, 1.646394903579672],
            [12.249573383776452, 1.6425175168524921],
            [12.250139777708789, 1.6386612032071757],
            [12.247997348362052, 1.635450636989391],
            [12.248162266723389, 1.6315192533267546],
            [12.25438835001797, 1.630028082982055],
            [12.25848862410392, 1.6267107581904785],
            [12.258020753864574, 1.6214268103839884],
            [12.25005312782127, 1.6168493721770814],
            [12.249851027090322, 1.6092121590037174],
            [12.242978851339622, 1.6006329821547844],
            [12.244094407680663, 1.5981007941027467],
            [12.239531189279484, 1.58971033172043],
            [12.240243522932355, 1.5837159831616117],
            [12.235594268267231, 1.5811344508256333],
            [12.232387290963864, 1.5765539366836583],
            [12.22770450223745, 1.5771047744498645],
            [12.228645567060802, 1.5734486265802126],
            [12.22635960830843, 1.5699026623516812],
            [12.226575280008335, 1.563612298228984],
            [12.222932953697185, 1.5641895681352094],
            [12.217127974395796, 1.5506305089240433],
            [12.21575732134764, 1.5439664923938847],
            [12.219280137461263, 1.5424713592529695],
            [12.22171542285587, 1.545070939721129],
            [12.225977653333702, 1.5451163170516404],
            [12.230288257730066, 1.5428066370782392],
            [12.233292164875952, 1.5447501076282115],
            [12.236471318551134, 1.5433692710370934],
            [12.236161335042675, 1.5331200413701898],
            [12.232057249501404, 1.530299142748427],
            [12.232804873688304, 1.5216003907999296],
            [12.236281169700733, 1.5175927811507965],
            [12.241803414105272, 1.5169838800529016],
            [12.253340142779098, 1.5102825639925874],
            [12.255743979158428, 1.5054678967435224],
            [12.260688386860128, 1.5026557552311546],
            [12.263355406466095, 1.5035725513638079],
            [12.267437142398686, 1.500003710782391],
            [12.267795380576707, 1.4937359928138527],
            [12.264823639949554, 1.4911573515943575],
            [12.260622827321356, 1.4926349266487333],
            [12.257407901685163, 1.4959728962226875],
            [12.252841689521016, 1.4920403512113607],
            [12.255419388362215, 1.483651092330109],
            [12.262030948457703, 1.4824638298092003],
            [12.265226203480703, 1.4785479181107484],
            [12.269881623159199, 1.4817891527916305],
            [12.283653574208868, 1.4798165946906945],
            [12.287871282559054, 1.4770194365778497],
            [12.28728054690958, 1.4707541464797227],
            [12.287860039241718, 1.4638085617540126],
            [12.28523354357552, 1.4617593710741004],
            [12.280594001748542, 1.461830500283219],
            [12.279300645959996, 1.4559665731406624],
            [12.272568646569024, 1.45123589719268],
            [12.268812298137748, 1.4566685943324078],
            [12.266196125354062, 1.4537034903162025],
            [12.265737377483738, 1.4425501593502612],
            [12.25586184264495, 1.4372430253154735],
            [12.251982402999381, 1.4400464539435378],
            [12.245781908974156, 1.440795227727932],
            [12.24208281203161, 1.4425813539666674],
            [12.245535041597638, 1.4314678599383621],
            [12.241325141111213, 1.4264751135192058],
            [12.241438679607917, 1.422359999975949],
            [12.237475717930447, 1.4179029186512242],
            [12.236595856632428, 1.4139067623353718],
            [12.226968540034495, 1.4102075684055966],
            [12.224309525564863, 1.398612419330929],
            [12.220714720513556, 1.3948609060947716],
            [12.214918644675851, 1.3920229137883802],
            [12.199448594059284, 1.3931064289612003],
            [12.195458757069865, 1.389111083647162],
            [12.195502116657646, 1.3807032369039303],
            [12.187233124526962, 1.374408935355908],
            [12.184044987766606, 1.3705427517370852],
            [12.185765703152171, 1.3611447859424006],
            [12.181795686743452, 1.358739763161888],
            [12.179601181974041, 1.352121030227236],
            [12.180340330242586, 1.349829876409937],
            [12.175146255697348, 1.3426495260168725],
            [12.173494667968106, 1.3370620485439453],
            [12.152653479167865, 1.3390412201339297],
            [12.136131692581081, 1.3406236561319564],
            [12.086216685828623, 1.3423364270216973],
            [12.058401325300915, 1.3848251836245136],
            [12.020330837012125, 1.4401803822265544],
            [12.001973154979737, 1.4662404013151027],
            [11.998406457231253, 1.4720367119879356],
            [11.98357526885907, 1.4930329674046496],
            [11.999164405117067, 1.517351727151824]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.70698495461596, "lat": 39.26914058192991 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54017"],
        "coty_name": ["Doddridge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Doddridge County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01689476"
      },
      "bbox": [
        11.98357526885907, 1.3370620485439453, 12.287871282559054,
        1.7107212662995197
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.191454114309199, 0.03981501077938717],
            [12.226377729107657, 0.0632576304653368],
            [12.290705657522146, 0.10662220885344618],
            [12.338361094215331, 0.08053425450482507],
            [12.3561765553438, 0.06683363118737874],
            [12.361426069337647, 0.059958712028354906],
            [12.414396872930803, 0.01831137056689627],
            [12.423240963081067, -0.012241849954696269],
            [12.428264487085121, -0.02895306457742821],
            [12.42295187794768, -0.046794128582120516],
            [12.415165166394388, -0.06939170052339463],
            [12.396262558165173, -0.12145493093325793],
            [12.380935136085593, -0.16652267868529705],
            [12.354765752988214, -0.23200953503199587],
            [12.341674258796186, -0.27251838420209057],
            [12.32135260942381, -0.3382879946063423],
            [12.320982487747278, -0.3391291247697078],
            [12.319934915515473, -0.33801133194537236],
            [12.29872970335798, -0.32432424799664356],
            [12.221430620318298, -0.276802333419172],
            [12.112289584354318, -0.20842320390955704],
            [12.114636343184612, -0.20491652337396055],
            [12.116394268960772, -0.1982517707035812],
            [12.121140157792155, -0.19500110123796333],
            [12.12429369816648, -0.19510102650518343],
            [12.129011905214554, -0.18876448123558084],
            [12.128774676306676, -0.18518073354893422],
            [12.132223647466166, -0.1825251208474763],
            [12.12968305749962, -0.17872148088390924],
            [12.129046421269697, -0.17319913168620266],
            [12.126980201242947, -0.17168613167439348],
            [12.126038811274123, -0.16591862718086114],
            [12.122139102492719, -0.16164614418352288],
            [12.126768917208274, -0.1599763012496177],
            [12.127548401812621, -0.15769961969838459],
            [12.124543795879333, -0.15305235662826605],
            [12.131137969623053, -0.14778590666980554],
            [12.133614262907628, -0.14766633157166617],
            [12.136923753480925, -0.14381966948855804],
            [12.144608287398126, -0.1377898716114074],
            [12.146106738920444, -0.1343272003706216],
            [12.153199078830639, -0.1304709827097891],
            [12.151597886731274, -0.1264023008637956],
            [12.155982832489071, -0.11873131929082122],
            [12.161361627189311, -0.11629456136704389],
            [12.163363385722871, -0.11288626882043609],
            [12.166032682125289, -0.11345152536725393],
            [12.167839027452455, -0.10661190952009553],
            [12.178769995726686, -0.09855675122146602],
            [12.178879180497312, -0.09441441590476742],
            [12.181099837340884, -0.08971995367718712],
            [12.188257006753748, -0.0868225731406335],
            [12.189293526297531, -0.08335543824748871],
            [12.184239159462646, -0.07986432462320339],
            [12.18215975537641, -0.0769521498125515],
            [12.183371025105062, -0.06844975062123036],
            [12.189533308830336, -0.06806751661483658],
            [12.195521056779716, -0.06911152523592685],
            [12.206494215234303, -0.06381033849523711],
            [12.219299058006193, -0.066409919909459],
            [12.224706169198225, -0.07235403666930534],
            [12.23338194739773, -0.07203249953253923],
            [12.240943838325252, -0.07553527828654914],
            [12.245033360972057, -0.0807289787339104],
            [12.24866611887664, -0.08311375992212006],
            [12.249437291889718, -0.09397397874121907],
            [12.248914006298826, -0.09707887007774672],
            [12.253836665650427, -0.10018649195317725],
            [12.254319791064512, -0.09537596713378138],
            [12.26208908024252, -0.09038082345711634],
            [12.263931917263118, -0.08814301306099123],
            [12.264805317798881, -0.08290658599794853],
            [12.261443582152374, -0.07600252955053616],
            [12.252849493353917, -0.07064523799560318],
            [12.248748551409754, -0.05432053215700505],
            [12.246307596336134, -0.04924337815391245],
            [12.241640754857526, -0.04401051777097077],
            [12.233328115637994, -0.04047917224647142],
            [12.225894604661917, -0.038282053852437624],
            [12.220547527334496, -0.034211428523366234],
            [12.220191669671175, -0.030628703025138152],
            [12.223132775079467, -0.023833944477572058],
            [12.226498714790944, -0.02063829009452735],
            [12.234781875792489, -0.01706085270879864],
            [12.239060001936368, -0.0061104011326245595],
            [12.23756325612911, 0.001635036799604795],
            [12.231648944873216, 0.0072745360971313185],
            [12.213845756925314, 0.01708910383204689],
            [12.210520243299852, 0.023798586743846148],
            [12.209583321671783, 0.029556638367334506],
            [12.207467162473263, 0.032760654106357534],
            [12.202260532800137, 0.03481502802599613],
            [12.195934242007803, 0.039104218737627164],
            [12.191454114309199, 0.03981501077938717]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.85856825290865, "lat": 37.65586540697207 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54089"],
        "coty_name": ["Summers"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Summers County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01557805"
      },
      "bbox": [
        12.112289584354318, -0.3391291247697078, 12.428264487085121,
        0.10662220885344618
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.814702799694284, 5.718840680090978],
            [4.860682785282762, 5.721642285433617],
            [4.941686429005908, 5.725280879397493],
            [5.03214150200159, 5.729338653750868],
            [5.035931710396589, 5.680648977160105],
            [5.041138520159056, 5.596115220125009],
            [5.045712762281804, 5.528289173534017],
            [5.049967448675153, 5.4666757711605305],
            [5.057113051041045, 5.368193275925652],
            [5.058576957087473, 5.34567675555785],
            [5.059097401896134, 5.33204611679349],
            [5.060671222285878, 5.31019928052099],
            [5.0638310186641275, 5.251846428730617],
            [5.066172046515589, 5.215889211288952],
            [5.069716905790692, 5.156972812155906],
            [5.071760519081522, 5.127987876482289],
            [4.986044084356569, 5.122803026742487],
            [4.938611627373667, 5.1175844117979805],
            [4.9352351804623, 5.121487634671712],
            [4.937162964533068, 5.126858421895558],
            [4.934355664901016, 5.144925237899963],
            [4.930423206187211, 5.1476010946150925],
            [4.921860974283777, 5.150933288704786],
            [4.917538052457005, 5.156004119018021],
            [4.906811877183872, 5.174581102638859],
            [4.905220323278808, 5.180115827190982],
            [4.902103870858256, 5.185643914671402],
            [4.9009470659878716, 5.190979122132001],
            [4.896541080114735, 5.1981675494068895],
            [4.891878649711133, 5.210400357565995],
            [4.889338029488952, 5.231083211132561],
            [4.884608459573638, 5.236406422846404],
            [4.882181001947956, 5.243054650187226],
            [4.877034656554483, 5.2475706065801875],
            [4.8717042013232295, 5.25593258434536],
            [4.8627374973666715, 5.262739383113238],
            [4.853162310023092, 5.268067305860057],
            [4.847423164921228, 5.275665640094172],
            [4.8456742061820135, 5.281124028177953],
            [4.842674328691935, 5.284800191448273],
            [4.837302906876067, 5.2865506301270395],
            [4.832619256031909, 5.291605223212549],
            [4.830497942002269, 5.302380226175958],
            [4.82714659998838, 5.308234048232669],
            [4.816761389382661, 5.31579672551052],
            [4.813588001840186, 5.319542569755973],
            [4.807145361260767, 5.322983715647679],
            [4.7976179167194655, 5.331959208497354],
            [4.795587265046776, 5.336768515988414],
            [4.795145683043301, 5.351205221928067],
            [4.789029065814256, 5.360861387484361],
            [4.782905602477695, 5.36627097832897],
            [4.781537980513455, 5.371842880785947],
            [4.778315065416732, 5.377191429891552],
            [4.778893644823302, 5.383091255007757],
            [4.78111983274046, 5.385664215383818],
            [4.786505355221195, 5.388008334089491],
            [4.7932009259881045, 5.387510739201667],
            [4.7987729842218005, 5.390078954817844],
            [4.800805835372129, 5.39481532399214],
            [4.796255089138817, 5.408615875913857],
            [4.796061674777899, 5.423257731949124],
            [4.790506146101592, 5.431384395295831],
            [4.789287496783869, 5.446802011425868],
            [4.788313703559615, 5.4512045981944315],
            [4.784526551426152, 5.458891036432486],
            [4.779850628392752, 5.463048384658454],
            [4.7654221055691135, 5.4703009490718495],
            [4.756471902840402, 5.473919169090707],
            [4.756416336539753, 5.477364265804221],
            [4.76022367124417, 5.482254505011166],
            [4.76042267386874, 5.489837645474839],
            [4.754819017677063, 5.499916313913776],
            [4.747385313112889, 5.506778242656281],
            [4.744806821143237, 5.512840081073697],
            [4.745322612228038, 5.515200496528887],
            [4.743261615032429, 5.521719996993912],
            [4.7431203332269005, 5.52857691271111],
            [4.738412083967726, 5.537668382739085],
            [4.739368840578239, 5.543511834765788],
            [4.7372969570166354, 5.548133620105464],
            [4.736865844342697, 5.556119485513665],
            [4.738354641751102, 5.56045077616195],
            [4.742737730713003, 5.565319803064752],
            [4.747028846022214, 5.565340977179009],
            [4.751284144171807, 5.567960970165978],
            [4.750774718671977, 5.573389643914288],
            [4.746554382762983, 5.578536011999772],
            [4.7463281736394505, 5.583811149580229],
            [4.748476685493824, 5.586726840068295],
            [4.753770964189015, 5.587987302099198],
            [4.757407638653507, 5.592462794880369],
            [4.76366122626463, 5.588172016218164],
            [4.769935603639032, 5.589010260966839],
            [4.770636788445688, 5.594527928137631],
            [4.7646321128835565, 5.59453911318461],
            [4.764628177638084, 5.598281085994175],
            [4.770883822628004, 5.599510503136236],
            [4.7730224163379065, 5.614785143667547],
            [4.773049043121147, 5.624817972376525],
            [4.771696134031891, 5.633721713344765],
            [4.778629337303708, 5.633062858729016],
            [4.78303557555531, 5.630763772085878],
            [4.792458347858228, 5.631355655862252],
            [4.795351300366025, 5.623508406127748],
            [4.799519336479533, 5.618723734397196],
            [4.806240961601197, 5.621208780179606],
            [4.806896365278359, 5.635698997484534],
            [4.803275506200744, 5.642929827829171],
            [4.806673181770077, 5.647414232747758],
            [4.816300671740014, 5.645732551449811],
            [4.818786706817184, 5.647436119995935],
            [4.8207639045523765, 5.65405542166459],
            [4.817856220016915, 5.660986485967646],
            [4.81436960837249, 5.661190888218903],
            [4.807036325974433, 5.659174317290781],
            [4.8034926352092855, 5.659208574544331],
            [4.801003738655041, 5.662152260032204],
            [4.802082678460133, 5.665085041164885],
            [4.80606418957379, 5.667277456188192],
            [4.812944117607405, 5.66748231515775],
            [4.81619101686364, 5.6710539512245],
            [4.812473766609557, 5.676786585477413],
            [4.804697251171232, 5.67757790299146],
            [4.80129237942335, 5.682036425639982],
            [4.804838689311573, 5.687313888353783],
            [4.812851720448027, 5.689797754941359],
            [4.814129221026374, 5.698222614834991],
            [4.816730279435297, 5.696616397799129],
            [4.819670374022316, 5.699525134242225],
            [4.8163342814765615, 5.705620296877628],
            [4.814817654587445, 5.710765484460395],
            [4.814702799694284, 5.718840680090978]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.77038251873098, "lat": 43.96956973958348 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55001"],
        "coty_name": ["Adams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adams County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01581060"
      },
      "bbox": [
        4.736865844342697, 5.1175844117979805, 5.071760519081522,
        5.729338653750868
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.540801421198937, 6.254651404708064],
            [3.561569283662398, 6.256044579669651],
            [3.6267940135586176, 6.260021376142675],
            [3.672207261005959, 6.262067237677849],
            [3.6913501739269083, 6.263120253880361],
            [3.8117776907863257, 6.2685561637032325],
            [3.9009868708215465, 6.272962901365774],
            [3.9972911120788526, 6.278354839900929],
            [4.055440426744634, 6.281396776907618],
            [4.060593979255628, 6.1950811350542505],
            [4.062002989464576, 6.166144939119206],
            [4.065878276445394, 6.095301737340164],
            [4.06933349261591, 6.021732551764672],
            [4.00762563996435, 6.018815443576647],
            [3.926404676790938, 6.014556058787294],
            [3.896707760262945, 6.013465230132183],
            [3.85940904628068, 6.011636032413517],
            [3.8109822964588793, 6.0089917439039935],
            [3.7709044165505596, 6.006212929962311],
            [3.7250470979745343, 6.004021005659471],
            [3.6534315001360995, 6.000883266213662],
            [3.638829044107582, 6.000112220347232],
            [3.5528345188296893, 5.996591846296177],
            [3.548766133622383, 6.083189524510723],
            [3.544852679088084, 6.179578764271968],
            [3.5431157009325243, 6.21370932969199],
            [3.540801421198937, 6.254651404708064]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.28598066992434, "lat": 44.72677168157919 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55035"],
        "coty_name": ["Eau Claire"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Eau Claire County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01581077"
      },
      "bbox": [
        3.540801421198937, 5.996591846296177, 4.06933349261591,
        6.281396776907618
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.213182729238676, 4.76164356516031],
            [6.256173171746015, 4.765709408146525],
            [6.336957098678693, 4.772005780273774],
            [6.340677457965688, 4.766857810080037],
            [6.346747783874764, 4.751289173504097],
            [6.340527643038059, 4.7287387181593825],
            [6.335718502096015, 4.716865555805602],
            [6.335273777777039, 4.712704762847826],
            [6.336549375694535, 4.705472393584338],
            [6.338409443334449, 4.700773571940234],
            [6.342848785938034, 4.694042779247644],
            [6.356507830388614, 4.680122512508768],
            [6.362236745729186, 4.665808218472648],
            [6.362338022301738, 4.662063271942354],
            [6.367832522095296, 4.65253727093042],
            [6.355919666723892, 4.633893958965967],
            [6.35305463845664, 4.63263661085879],
            [6.347656744551062, 4.622563209417948],
            [6.346830391647155, 4.617745955752821],
            [6.346440964239999, 4.605574264826734],
            [6.34778234045672, 4.599996826540315],
            [6.3531506006528184, 4.587328160150599],
            [6.363774661342449, 4.573518225105246],
            [6.3747203370677505, 4.56609608300056],
            [6.380595799465269, 4.560468598056835],
            [6.386455255013616, 4.553564244305942],
            [6.390867885626176, 4.544361680306183],
            [6.391033092232616, 4.537900936347234],
            [6.3928631547936385, 4.534300644346541],
            [6.393582096403939, 4.527392106743465],
            [6.3927004707965525, 4.515280581833078],
            [6.3950040605076754, 4.5051736158590945],
            [6.398762830612071, 4.498213256500128],
            [6.397191792725458, 4.490324540083079],
            [6.3956448552915175, 4.488115743269029],
            [6.394407616163754, 4.479475579999246],
            [6.395759024586964, 4.473648642167055],
            [6.398362552275577, 4.4686757563521535],
            [6.396434928237542, 4.467364137818306],
            [6.399552519125451, 4.456707508994226],
            [6.403557022229537, 4.448900607329987],
            [6.4067622054726625, 4.440431192329048],
            [6.412833539823982, 4.430296427898549],
            [6.414104919143198, 4.4266869536176365],
            [6.402148437961442, 4.425555168935198],
            [6.365631589896257, 4.4230909960731095],
            [6.350919145638692, 4.421790139860181],
            [6.323371263014493, 4.420281636974084],
            [6.302048418077203, 4.418543827885121],
            [6.237663323919752, 4.412857273364723],
            [6.2359019841471195, 4.436802071374298],
            [6.231160878426895, 4.493310072870576],
            [6.227490104163409, 4.543156527191323],
            [6.2250930737716885, 4.585941982128404],
            [6.221797891411076, 4.628808725069535],
            [6.217134903601896, 4.694913006624332],
            [6.216123126570831, 4.717528807441166],
            [6.214192458061459, 4.743189921636874],
            [6.213182729238676, 4.76164356516031]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.96688198521545, "lat": 43.00716685370433 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55079"],
        "coty_name": ["Milwaukee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Milwaukee County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01581100"
      },
      "bbox": [
        6.213182729238676, 4.412857273364723, 6.414104919143198,
        4.772005780273774
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.0838125585163025, 5.453144700268392],
            [6.14118785378117, 5.458147387350345],
            [6.169987565729391, 5.460471210045583],
            [6.212630000689904, 5.46412249369139],
            [6.239578686388629, 5.46682953455324],
            [6.295852852796794, 5.471012393110195],
            [6.318699987926128, 5.473010565051413],
            [6.378683659861606, 5.478906249389776],
            [6.391803390050004, 5.479857052544185],
            [6.389452877283759, 5.46845375416873],
            [6.390181038333315, 5.460524930263724],
            [6.39729890966692, 5.439593172759548],
            [6.398245389989049, 5.4335244439033215],
            [6.398511614401757, 5.419846663035115],
            [6.399975903709352, 5.410083999795868],
            [6.402251815160034, 5.4048906508162995],
            [6.402659619153071, 5.398798419550238],
            [6.411468296233434, 5.381219475836877],
            [6.418038031322131, 5.369844652913505],
            [6.420872461651251, 5.363241384700519],
            [6.428530950024959, 5.353507887463148],
            [6.425801509200783, 5.351590893281988],
            [6.423339362090609, 5.345801295553932],
            [6.424955482218138, 5.33811079805321],
            [6.421544813048679, 5.33265291309766],
            [6.420677552435144, 5.326805303522826],
            [6.423366447671842, 5.312737662967651],
            [6.427263015053497, 5.3026772280059635],
            [6.429018143826699, 5.291808529424357],
            [6.428624010347834, 5.285044545353234],
            [6.430400266654502, 5.277917406429175],
            [6.428581104073259, 5.2696736735277145],
            [6.411937249662672, 5.227714730640379],
            [6.395982190495235, 5.193464721532979],
            [6.38350586516942, 5.164307200895607],
            [6.378463734987394, 5.148368058834938],
            [6.377539416948527, 5.137902356834887],
            [6.378921821350868, 5.128289452446704],
            [6.34371180796607, 5.125322184668921],
            [6.2860565924937335, 5.120702990459525],
            [6.250212999289943, 5.117031798428308],
            [6.200237739608334, 5.112452570181029],
            [6.157981211636698, 5.108936700865265],
            [6.113653607994577, 5.105852759316272],
            [6.107021963639816, 5.19399137004222],
            [6.101361546793887, 5.255183866137062],
            [6.098337317203264, 5.294151098900929],
            [6.093066022060196, 5.352164411317695],
            [6.089297440240393, 5.395451530074625],
            [6.0838125585163025, 5.453144700268392]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.94542750483753, "lat": 43.72115361737383 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55117"],
        "coty_name": ["Sheboygan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sheboygan County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01581118"
      },
      "bbox": [
        6.0838125585163025, 5.105852759316272, 6.430400266654502,
        5.479857052544185
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.605491550608076, 7.431800348650001],
            [4.635926899228101, 7.433695109388767],
            [4.638523251687085, 7.434254783861413],
            [4.685436056702134, 7.436841637960389],
            [4.681331871227134, 7.508093073555271],
            [4.680068256502261, 7.523154268904174],
            [4.676046382599134, 7.581482270206523],
            [4.674669904473181, 7.594211458976872],
            [4.674046464696944, 7.613691861251282],
            [4.668822453025335, 7.694386515624585],
            [4.666913294564472, 7.719500355411055],
            [4.664966619111791, 7.750598298363178],
            [4.67969019645998, 7.747855119853395],
            [4.780821091291409, 7.726667485869832],
            [4.849017347536168, 7.713023240642406],
            [4.869609332829635, 7.708448825360567],
            [4.9432874336439845, 7.693873329831588],
            [4.97015890023739, 7.687943724850563],
            [5.047524286580381, 7.672279101622689],
            [5.05681043249709, 7.670633912113177],
            [5.124506557572939, 7.65678096400345],
            [5.164666762471587, 7.648906040152806],
            [5.182670470001733, 7.644850885246177],
            [5.2021537256014945, 7.6412064167490525],
            [5.231656937925606, 7.6350497717298245],
            [5.255290290512489, 7.630773980906078],
            [5.328068252356011, 7.595216060958231],
            [5.3700922382647525, 7.5748383463062945],
            [5.375833194269807, 7.493084469499995],
            [5.376535400443385, 7.484713110288357],
            [5.309148004548824, 7.479820102206355],
            [5.297033744259768, 7.4788296261214695],
            [5.303518050329954, 7.392919034613265],
            [5.296449668515143, 7.392613327757877],
            [5.25207591532208, 7.389307895386644],
            [5.228102697825605, 7.389135011336108],
            [5.212816199710709, 7.390307593662939],
            [5.217594376002866, 7.3482162829047875],
            [5.204329545958223, 7.348266621876213],
            [5.1892954171297205, 7.34985887324724],
            [5.159662981201074, 7.3494198500468055],
            [5.137064217084694, 7.346071093480127],
            [5.129895371378803, 7.346100123984433],
            [5.1273535617713115, 7.386416548561766],
            [5.0844112291551715, 7.380986787524618],
            [5.077052341258074, 7.380913628516505],
            [5.040830524115228, 7.377320541221301],
            [4.939855598406331, 7.370865192636971],
            [4.845569238039759, 7.364475819833461],
            [4.782990454725654, 7.360049954757482],
            [4.740100459938869, 7.35720691742551],
            [4.667657084253037, 7.352077756978828],
            [4.6542405723009495, 7.3509080677505],
            [4.611553949235287, 7.348136078103758],
            [4.605491550608076, 7.431800348650001]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.5148195970303, "lat": 46.052903511742 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55125"],
        "coty_name": ["Vilas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vilas County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01581122"
      },
      "bbox": [
        4.605491550608076, 7.346071093480127, 5.376535400443385,
        7.750598298363178
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -65.92219217735283, "lat": 18.01806426938748 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72095"],
        "coty_name": ["Maunabo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Maunabo Municipio"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01804528"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.24660765719985,
          "lat": 18.362586471909104
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72135"],
        "coty_name": ["Toa Alta"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Toa Alta Municipio"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01804548"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.579355774310239, -3.8371741962606674],
            [8.582327254147781, -3.8376881156557907],
            [8.587743841165164, -3.8356063084625918],
            [8.594118747964682, -3.8346846900136162],
            [8.598221909465165, -3.8377957583056452],
            [8.605178581807793, -3.834959321658865],
            [8.607844945478206, -3.8285712863267656],
            [8.622740951612954, -3.8285340015098557],
            [8.633855587077935, -3.8204543779696047],
            [8.638331677338133, -3.8197717088087746],
            [8.637306398225384, -3.8163357678999836],
            [8.645181318884681, -3.81339232512721],
            [8.647816828849495, -3.8088737108276502],
            [8.65438959120913, -3.805243422150378],
            [8.65800242480931, -3.797406282552249],
            [8.671010057495936, -3.7775886386561925],
            [8.684706714189758, -3.764296114732248],
            [8.691065038593644, -3.7571438078568646],
            [8.700121133046407, -3.749076384937183],
            [8.78466547912036, -3.6650446801620227],
            [8.800628282302002, -3.6339020264085016],
            [8.807157115074551, -3.619978016162885],
            [8.846610826860722, -3.5372215229819775],
            [8.862463478007838, -3.5348240232936194],
            [8.87204133250842, -3.5236079914575025],
            [8.879680028160168, -3.5010911898478048],
            [8.8837289502152, -3.4924581005194955],
            [8.888213040651676, -3.4772785742344663],
            [8.886763145905707, -3.4632775242688627],
            [8.890427679809186, -3.4437217173017016],
            [8.8976769750127, -3.4405528519398496],
            [8.90097346615102, -3.434159603490173],
            [8.904590399960469, -3.432718305035689],
            [8.909887397668848, -3.426314850185607],
            [8.908434950427104, -3.422021366739104],
            [8.915160284908637, -3.4182435702306977],
            [8.920604556269458, -3.4117306838652093],
            [8.922824102440405, -3.4113177820526173],
            [8.952588687962006, -3.519729757374934],
            [8.96496750645273, -3.5625271561202614],
            [8.98870721482279, -3.643538264415538],
            [8.99814647732624, -3.6781031498810366],
            [9.01152843706526, -3.723272285161812],
            [9.016306677287334, -3.7413959029672],
            [9.011615099626072, -3.739804121427901],
            [9.007957229245184, -3.7418963871870123],
            [9.006823685255833, -3.7455548262658414],
            [9.009516414451356, -3.7485032715049003],
            [9.001401783463736, -3.7532510548941356],
            [8.998769137614605, -3.7599519052989807],
            [8.995909500179467, -3.762074764793815],
            [8.994042107576234, -3.768229392383888],
            [8.987547401232554, -3.7656598954476324],
            [8.981753532454462, -3.7684068352184577],
            [8.983344949602794, -3.7739343633980185],
            [8.982176822565105, -3.779834350211053],
            [8.97667673419896, -3.780091283493141],
            [8.973936869131082, -3.784539614129019],
            [8.969451536728481, -3.7867711048151023],
            [8.972963219396723, -3.79220293854979],
            [8.975038973260126, -3.7976062567966284],
            [8.972828012694706, -3.8012787040974505],
            [8.968134549544198, -3.8012155061069093],
            [8.970498457115179, -3.8071670036667458],
            [8.970429363448243, -3.8114853178736157],
            [8.96657565511502, -3.8138786822307176],
            [8.969870777887698, -3.819818886559221],
            [8.972135146909858, -3.831250210256862],
            [8.96946766697418, -3.839237215944703],
            [8.964369651239739, -3.8433431894450734],
            [8.965807557656966, -3.848121054903259],
            [8.957020620025125, -3.8524003584251174],
            [8.958174772046197, -3.858321277782716],
            [8.953466028952805, -3.8618290612977564],
            [8.95000553267213, -3.8688137768093775],
            [8.948433968001998, -3.8799225891144853],
            [8.945207581190235, -3.880995995567332],
            [8.939273555360861, -3.8778278585825134],
            [8.939405956463524, -3.8823771639852747],
            [8.944397486986619, -3.8862291124737767],
            [8.94150362622629, -3.8931063697492947],
            [8.93757208708012, -3.8968250728725145],
            [8.939754621741741, -3.9017732793083857],
            [8.935414145009016, -3.9062071563618828],
            [8.934143289199055, -3.909564980243332],
            [8.930475961086708, -3.9105663507950523],
            [8.925461484133326, -3.908192102103705],
            [8.92529662382114, -3.9131437119451777],
            [8.911841488483418, -3.917015060162852],
            [8.908433390198528, -3.9216479402645397],
            [8.909078885304762, -3.9248449960286655],
            [8.903424628943252, -3.932663563008564],
            [8.904807074465099, -3.9365359928211463],
            [8.855130831676359, -4.001135687732448],
            [8.833402991681004, -4.0295270393426765],
            [8.804982675752523, -4.032758741658031],
            [8.807602817509986, -4.052239108504484],
            [8.797362303020098, -4.053649413606981],
            [8.778183544068881, -4.050116542023199],
            [8.78312647850507, -4.09466860942884],
            [8.73029691356013, -4.1003332684607035],
            [8.648558172388116, -4.109525007581148],
            [8.59900703150885, -4.114095247752686],
            [8.568839534020324, -4.11653935750674],
            [8.565658314786187, -4.09146823131083],
            [8.554841761613783, -4.002372682138876],
            [8.547317277306965, -3.9424823050224345],
            [8.54550429082647, -3.9246912828318017],
            [8.538332739719312, -3.9253997270946317],
            [8.537142767254881, -3.91454109037465],
            [8.544364015348393, -3.913766797310039],
            [8.541580980586089, -3.8898600944874793],
            [8.579355774310239, -3.8371741962606674]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.80412876763168, "lat": 34.45979859449094 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01049"],
        "coty_name": ["DeKalb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeKalb County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00161550"
      },
      "bbox": [
        8.537142767254881, -4.11653935750674, 9.016306677287334,
        -3.4113177820526173
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.084807013628707, -4.540042635890051],
            [7.14226944342942, -4.536178218753881],
            [7.157510628068156, -4.534279067361194],
            [7.197844754005124, -4.532987270384172],
            [7.259594550264226, -4.530297323196557],
            [7.344407339245388, -4.522359698236152],
            [7.348148355846214, -4.565636562773851],
            [7.407281663821189, -4.563836134057084],
            [7.434278212677924, -4.56243076715807],
            [7.441952745114012, -4.638808535940713],
            [7.44912533482941, -4.706870953631234],
            [7.452700634221937, -4.7377634132190325],
            [7.476057826901514, -4.736121999248798],
            [7.538940929580862, -4.732994657451394],
            [7.546955137469392, -4.819963010969873],
            [7.495580426989449, -4.8229971796582864],
            [7.4838588856787425, -4.822879662913867],
            [7.444071000435762, -4.825235848085217],
            [7.413939545408557, -4.826731314432999],
            [7.374917239858825, -4.827489619987216],
            [7.377588908443465, -4.856634475738923],
            [7.348803747469309, -4.8600293935939884],
            [7.353907643524067, -4.918143510001088],
            [7.296367762858788, -4.925275559491697],
            [7.242073197446031, -4.926222495416539],
            [7.210106402101874, -4.927411045454684],
            [7.195319419319248, -4.928187107631502],
            [7.122874927018694, -4.935620995314469],
            [7.112768234280895, -4.818415463322034],
            [7.111652923692158, -4.801895667946247],
            [7.104143526539204, -4.7307097104054145],
            [7.10329436401499, -4.725411900640921],
            [7.099814667004079, -4.692397625237206],
            [7.089980350054037, -4.601106947293674],
            [7.084807013628707, -4.540042635890051]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.73882917636378, "lat": 33.72120598944884 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01057"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00161554"
      },
      "bbox": [
        7.084807013628707, -4.935620995314469, 7.546955137469392,
        -4.522359698236152
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.965409293491189, -3.4542130696456046],
            [7.051988277449902, -3.447275701114543],
            [7.073077693526557, -3.4452794823604025],
            [7.136494665655543, -3.440530379925754],
            [7.225183663133975, -3.4342352827985163],
            [7.2720516020298955, -3.4299867773330206],
            [7.339869662369716, -3.42436644377393],
            [7.415766968814657, -3.4180052465150386],
            [7.5206247309084455, -3.4103685914379556],
            [7.581536298149538, -3.406368311999101],
            [7.592316130852224, -3.405677125077994],
            [7.5953777604509884, -3.445307117792766],
            [7.595644911590606, -3.4460568268118217],
            [7.600350088547584, -3.505272863041406],
            [7.6014493149610995, -3.526172132528332],
            [7.604105556081373, -3.569278142027315],
            [7.605960660413785, -3.5891021916300017],
            [7.6001149191325235, -3.5972918735305837],
            [7.593878484035302, -3.6026132470260297],
            [7.588614410275471, -3.6082788672088584],
            [7.575345693554291, -3.6203542221390266],
            [7.563013710458712, -3.6261981622445165],
            [7.558234041540115, -3.631285028303471],
            [7.558524514966065, -3.636697303632857],
            [7.5618151673768885, -3.6402493637378206],
            [7.569099925962772, -3.6436381996654763],
            [7.5707511255482745, -3.648459342937065],
            [7.574205217399623, -3.650350652234859],
            [7.5602268495337395, -3.6575635440771554],
            [7.544720329379752, -3.660954466340925],
            [7.512993404007867, -3.628232626977818],
            [7.502945435788974, -3.618610001009957],
            [7.48106211193561, -3.6120128388439148],
            [7.471914261436599, -3.61396724233995],
            [7.462404783999271, -3.616946629761355],
            [7.446718038129905, -3.619420488234278],
            [7.440389697932523, -3.621361592351838],
            [7.435889250914871, -3.6211263291558873],
            [7.428380280013161, -3.6178781307801566],
            [7.416106421036392, -3.6145652258797],
            [7.400972615574445, -3.6122389847252743],
            [7.392911926681829, -3.6124624814198443],
            [7.385845303307942, -3.6110318838517674],
            [7.378377924499251, -3.6070760959046595],
            [7.366910195566808, -3.6039815650886373],
            [7.362069054019852, -3.5972835558952094],
            [7.353619039212896, -3.5958100457845195],
            [7.344855580661724, -3.599459155715635],
            [7.3360165254926795, -3.599352163029419],
            [7.328578839939177, -3.6043867933012455],
            [7.320197467709712, -3.6052082475078775],
            [7.30893784260358, -3.6104759785248732],
            [7.305047822663474, -3.6148903811247877],
            [7.302748764690158, -3.6222007037300763],
            [7.2977117291590385, -3.6263210692646295],
            [7.290906369985856, -3.630289196461528],
            [7.284154969198908, -3.635675359374118],
            [7.275493272229063, -3.639459276217982],
            [7.260446625413191, -3.6441324134454733],
            [7.252425559705533, -3.6497664777555134],
            [7.241377750466734, -3.655934808436371],
            [7.233972121373201, -3.657660844850153],
            [7.210295097975014, -3.668536951539445],
            [7.203574713968952, -3.6765365172636764],
            [7.194652013960106, -3.6952105362740526],
            [7.191502307337556, -3.6981441351575324],
            [7.18100724780884, -3.7017230957332],
            [7.170764654314592, -3.709693371762664],
            [7.16077341934757, -3.7115076353704297],
            [7.144308253097024, -3.7155354072734252],
            [7.133181207450963, -3.7164957592962806],
            [7.123747444430722, -3.7142193026196906],
            [7.108943906470019, -3.7093129367423847],
            [7.097815473220219, -3.701839510399035],
            [7.086378505964086, -3.689288703137318],
            [7.074429301315758, -3.680765313635232],
            [7.067636414113335, -3.676549637902523],
            [7.055191345213822, -3.6664912082395213],
            [7.040379780397272, -3.6569433473177164],
            [7.034953370371169, -3.651779409280507],
            [7.027952116791512, -3.640062750485724],
            [7.025227282094604, -3.633013096978225],
            [7.0221522223893595, -3.6206146132808783],
            [7.017558565406382, -3.609930450365367],
            [7.006134809538563, -3.593621070087337],
            [6.998755891558695, -3.586227017325904],
            [6.994428081954331, -3.5839044213409514],
            [6.985364687765598, -3.5771172624635],
            [6.981879409325549, -3.5769409553376303],
            [6.972847824514254, -3.573368849331789],
            [6.9675507325892365, -3.5724598578032283],
            [6.952647657755948, -3.566757869221685],
            [6.936476599790681, -3.559322168249547],
            [6.928500319961819, -3.557595914836914],
            [6.920497330152593, -3.5587033148183314],
            [6.910374136241112, -3.5637029665622237],
            [6.903737663240657, -3.5696445298348887],
            [6.8985616310622255, -3.5724124070967527],
            [6.894137704109845, -3.5733153986447803],
            [6.883542719749762, -3.5734065395187518],
            [6.8835026249364235, -3.5759075779596516],
            [6.881633082697914, -3.574151144025142],
            [6.860659543559931, -3.5676791229496616],
            [6.850767378061669, -3.563079888260382],
            [6.842388109561713, -3.556923255131314],
            [6.83501016137596, -3.5494347194807774],
            [6.828437793034878, -3.5388025518343587],
            [6.818119596379098, -3.51767817055474],
            [6.814270791927082, -3.510615812109614],
            [6.804074830989247, -3.4989402434810084],
            [6.7935120630655925, -3.4833611745045365],
            [6.792130435242689, -3.478987803252178],
            [6.788762571932351, -3.466745045054992],
            [6.953171725334941, -3.455185738540186],
            [6.965409293491189, -3.4542130696456046]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.6540650881971, "lat": 34.901410552582064 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01077"],
        "coty_name": ["Lauderdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lauderdale County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00161564"
      },
      "bbox": [
        6.788762571932351, -3.7164957592962806, 7.605960660413785,
        -3.405677125077994
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.02355913043228, -4.7800307945748335],
            [9.039945757392601, -4.778759464432545],
            [9.11832364023867, -4.7709410783740855],
            [9.143904470652947, -4.768090570104886],
            [9.242695824689877, -4.759018720602149],
            [9.26339500592914, -4.756993737201307],
            [9.261093011954786, -4.750760573988406],
            [9.26455874412203, -4.747998868680786],
            [9.26765951720812, -4.748020695774534],
            [9.269108500661229, -4.751132090750749],
            [9.281259739528382, -4.756426887183706],
            [9.28992763437182, -4.758133845272894],
            [9.29394195903992, -4.757775251954422],
            [9.301514090688206, -4.763677022681993],
            [9.30408840833018, -4.762069277713806],
            [9.318963718524529, -4.815734886619013],
            [9.336622111646502, -4.879373256881904],
            [9.363134182351887, -4.974781116197336],
            [9.400192496055682, -5.107864373328422],
            [9.406051864388282, -5.128876938329145],
            [9.361672417423895, -5.133773442831752],
            [9.265151701914291, -5.1441719000231885],
            [9.221134482454495, -5.14864937614008],
            [9.17275558058531, -5.154364967270126],
            [9.150382997625483, -5.157411935842798],
            [9.107715319918052, -5.16285667263451],
            [9.057759090599312, -5.169022198347122],
            [9.046698361276333, -5.063847327364836],
            [9.050233710613073, -5.063545061092782],
            [9.049102132346118, -5.04908592036254],
            [9.045405265284284, -5.049380580635442],
            [9.041207915328272, -4.99828174894225],
            [9.038570313728323, -4.9698694464884285],
            [9.046044424548075, -4.9692517934164115],
            [9.045028041508367, -4.9581885149728775],
            [9.041431837064854, -4.9586460512430985],
            [9.041082648698826, -4.9550700034655515],
            [9.044704483039018, -4.954725700125506],
            [9.044326281730477, -4.951305131767217],
            [9.03704930443461, -4.9518165953604125],
            [9.034696960856934, -4.9168741624355],
            [9.033265086239949, -4.889377522187023],
            [9.028781823510595, -4.83426980209279],
            [9.024631244086185, -4.794836387270134],
            [9.02355913043228, -4.7800307945748335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.45908215422818, "lat": 33.29378591118139 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01111"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00161582"
      },
      "bbox": [
        9.02355913043228, -5.169022198347122, 9.406051864388282,
        -4.747998868680786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.698609784557146, -11.947976314394644],
              [-17.69807402465432, -11.946973922679051],
              [-17.69675987186925, -11.948088365784429],
              [-17.69468759591425, -11.948297534539622],
              [-17.69385183645096, -11.950105460192056],
              [-17.69401287230798, -11.951966761674383],
              [-17.695162506546527, -11.952458270861882],
              [-17.696110235728618, -11.950023238292191],
              [-17.6979952782288, -11.949643165447538],
              [-17.698609784557146, -11.947976314394644]
            ]
          ],
          [
            [
              [-17.70286304201797, -11.9410211643874],
              [-17.70119501425328, -11.937618486364],
              [-17.699249675815317, -11.9375569175971],
              [-17.6989449779499, -11.939033958171372],
              [-17.697602914258045, -11.939394025221535],
              [-17.69715916651399, -11.940787140316127],
              [-17.69550532161839, -11.943646236551487],
              [-17.699977079522842, -11.942371702572807],
              [-17.70067806316539, -11.942967845458616],
              [-17.70289223044105, -11.941775320014948],
              [-17.70286304201797, -11.9410211643874]
            ]
          ],
          [
            [
              [-17.744779394826427, -11.955525895131782],
              [-17.74479102959241, -11.954724824091066],
              [-17.743432708354238, -11.952555520262955],
              [-17.740048532736502, -11.95224652883072],
              [-17.742624857741294, -11.95487846630894],
              [-17.744779394826427, -11.955525895131782]
            ]
          ],
          [
            [
              [-17.75277424163214, -11.96753162201042],
              [-17.751873599451482, -11.966858470787395],
              [-17.750595211706983, -11.967373125401586],
              [-17.75183159286672, -11.968602790308744],
              [-17.75277424163214, -11.96753162201042]
            ]
          ],
          [
            [
              [-17.866383957563393, -12.103204919452097],
              [-17.863690257899712, -12.101627676243691],
              [-17.86287164790006, -12.099958521761163],
              [-17.860901341687924, -12.098165523068152],
              [-17.860472009048294, -12.096028254744114],
              [-17.85822167708134, -12.094114246394957],
              [-17.856617980142286, -12.093202901929535],
              [-17.855455798726336, -12.091955621864512],
              [-17.854261086812663, -12.091878323666432],
              [-17.85382343892619, -12.09046141058469],
              [-17.854333168367265, -12.089672715572501],
              [-17.851243560986386, -12.089237319346783],
              [-17.849308711842376, -12.087173140709243],
              [-17.849017360697232, -12.088669690260518],
              [-17.847192723942193, -12.090644067326352],
              [-17.84493326732901, -12.091245812429333],
              [-17.844027471264493, -12.09052500643635],
              [-17.842085145674204, -12.09106625289733],
              [-17.840701429830986, -12.090861750363183],
              [-17.838775499343694, -12.089873873000117],
              [-17.836571832479592, -12.089752760362089],
              [-17.834476994585987, -12.089041975575618],
              [-17.83222585129051, -12.089820651820446],
              [-17.830216043191527, -12.088970343211706],
              [-17.829345833729224, -12.089909274546658],
              [-17.82764242935234, -12.090662123615218],
              [-17.826615807484025, -12.090260144296979],
              [-17.823161337686265, -12.09077818486919],
              [-17.820695228451832, -12.089947330168146],
              [-17.81837087418991, -12.091131584003328],
              [-17.817176831538923, -12.091050882838296],
              [-17.81536099195489, -12.092346395562215],
              [-17.813748733956157, -12.094081733003167],
              [-17.80966430823388, -12.096826893751532],
              [-17.809556571730244, -12.097460815936769],
              [-17.806959554452042, -12.097756560702521],
              [-17.808275456983154, -12.099450985064932],
              [-17.807704147456416, -12.099971019454674],
              [-17.805815144124697, -12.099740378867484],
              [-17.80478026424275, -12.100145993003927],
              [-17.803695499223533, -12.10145289625404],
              [-17.8020120982501, -12.101707136992424],
              [-17.799209581137724, -12.104528290529181],
              [-17.79760977795578, -12.106622147985076],
              [-17.798139776941845, -12.107183699935868],
              [-17.80084238452426, -12.10814461866632],
              [-17.80221076738969, -12.107004673743038],
              [-17.803930302831617, -12.106524064222784],
              [-17.804269196429065, -12.103945473423261],
              [-17.80617299753704, -12.102512253284548],
              [-17.80739515613567, -12.102187774556189],
              [-17.809515227796464, -12.10245317382262],
              [-17.811836737154767, -12.102124038017717],
              [-17.813401025650688, -12.1012894147158],
              [-17.81545643582877, -12.101151779164354],
              [-17.817872145792155, -12.101851730547738],
              [-17.820417667884737, -12.101421317953099],
              [-17.821798003530922, -12.101538219782611],
              [-17.823803791053585, -12.100367422745485],
              [-17.825769802780304, -12.100277212575845],
              [-17.82840981148671, -12.102763751737529],
              [-17.830097153746852, -12.103540384719349],
              [-17.83124692616299, -12.105511080942492],
              [-17.83211821088084, -12.108349877818725],
              [-17.83590169599799, -12.106958732566426],
              [-17.83845442171514, -12.10665939765706],
              [-17.84082546093768, -12.108257560094803],
              [-17.843869538177575, -12.106764318310486],
              [-17.84649243815995, -12.106954682387537],
              [-17.849690724823578, -12.105812756485328],
              [-17.85193120600394, -12.106605170157941],
              [-17.853837541896162, -12.10804346562586],
              [-17.854473977275315, -12.107022947892993],
              [-17.858453498546513, -12.106830805622499],
              [-17.861698875575843, -12.105728237101193],
              [-17.86340741362726, -12.10686006010929],
              [-17.865825000727263, -12.107506596457583],
              [-17.866383957563393, -12.103204919452097]
            ]
          ],
          [
            [
              [-17.883708179443172, -12.065506945788242],
              [-17.88257255235383, -12.064778992954784],
              [-17.880597726944803, -12.06503541065701],
              [-17.878363154965943, -12.066875458388356],
              [-17.877470483630592, -12.066852874394488],
              [-17.87689874966923, -12.068160164333728],
              [-17.87718013564384, -12.069604682675235],
              [-17.879821321787155, -12.069831448102033],
              [-17.88168007842377, -12.068660821376612],
              [-17.882902787379674, -12.068868372485383],
              [-17.88368546384144, -12.066809484916034],
              [-17.883708179443172, -12.065506945788242]
            ]
          ],
          [
            [
              [-17.9464647316913, -12.115877184229195],
              [-17.944881345401143, -12.114297435021948],
              [-17.94339862424874, -12.110865431483788],
              [-17.944096981383304, -12.108642970834048],
              [-17.94247073181358, -12.10909245929078],
              [-17.942297230900866, -12.110070234423018],
              [-17.940233011673662, -12.11209742499384],
              [-17.939669589467734, -12.113884753645408],
              [-17.941822180506684, -12.114194815322156],
              [-17.945190593334594, -12.116082294667388],
              [-17.9464647316913, -12.115877184229195]
            ]
          ],
          [
            [
              [-17.980883185847162, -12.162993532770805],
              [-17.978991211746273, -12.162198040046423],
              [-17.9782210610391, -12.162422782184695],
              [-17.975807729434063, -12.161385533803038],
              [-17.97394663383794, -12.158779514436503],
              [-17.97186396337082, -12.157858653576632],
              [-17.967979756685118, -12.156858614406042],
              [-17.966226789343377, -12.156822080606105],
              [-17.96435802392071, -12.158735434889689],
              [-17.96435998459535, -12.159548869048503],
              [-17.962026789343447, -12.160629112344825],
              [-17.962214014463743, -12.162245654369983],
              [-17.964216100730702, -12.162585232156523],
              [-17.964773835398084, -12.164226879992981],
              [-17.96406515201369, -12.16707009328054],
              [-17.962242252211617, -12.169795524778683],
              [-17.960534873401947, -12.17056973823499],
              [-17.959949146576736, -12.171597524432219],
              [-17.96120013663668, -12.172477604698281],
              [-17.96330199411514, -12.17213356678929],
              [-17.96460800868987, -12.172376634148927],
              [-17.965811858495435, -12.174797318726634],
              [-17.965907567717952, -12.176420897222895],
              [-17.96687610078552, -12.176411613018736],
              [-17.968787834629794, -12.17440315824192],
              [-17.9713422862848, -12.17312745536783],
              [-17.97215550356321, -12.169733562351807],
              [-17.973651689122352, -12.167748507627692],
              [-17.975657793103963, -12.167362912837598],
              [-17.979091625373623, -12.168477979396487],
              [-17.978869897180925, -12.166319862484542],
              [-17.980024009241173, -12.164806360263722],
              [-17.981396977305216, -12.163868170891364],
              [-17.980883185847162, -12.162993532770805]
            ]
          ],
          [
            [
              [-18.034700789486806, -12.229105115731532],
              [-18.0335429935277, -12.228403476432714],
              [-18.03141825371544, -12.228533351547819],
              [-18.03018575018856, -12.22810883401762],
              [-18.027561738412498, -12.228404762437506],
              [-18.025673689813686, -12.229337153527819],
              [-18.023684897474592, -12.228685021560796],
              [-18.021804453740355, -12.226072635026359],
              [-18.020826201669134, -12.225995369051864],
              [-18.020977520896903, -12.228394050611811],
              [-18.021799232015507, -12.229662339009765],
              [-18.025040819117137, -12.231057104480021],
              [-18.026252645326533, -12.23334683183095],
              [-18.02869007924085, -12.232289728931883],
              [-18.029588100204304, -12.231099124603482],
              [-18.03388718393978, -12.230881940874422],
              [-18.034700789486806, -12.229105115731532]
            ]
          ],
          [
            [
              [-18.15829940903238, -11.968037175575287],
              [-18.15201683321547, -11.965132663076028],
              [-18.148217801432793, -11.964837335684543],
              [-18.14785148773371, -11.965836790781124],
              [-18.151442637705706, -11.965825467662933],
              [-18.1538462308897, -11.967053881365894],
              [-18.156917897577678, -11.969698675933397],
              [-18.158506161028573, -11.97075104462589],
              [-18.15829940903238, -11.968037175575287]
            ]
          ],
          [
            [
              [-18.1865769520854, -12.328192958115036],
              [-18.186102875362455, -12.326257121928949],
              [-18.182741181200193, -12.320773749544147],
              [-18.181471717752107, -12.319445107721002],
              [-18.181517254552613, -12.317564714141147],
              [-18.183286858222267, -12.315605881657389],
              [-18.183288587346212, -12.315010920660889],
              [-18.180768014718115, -12.312582921148943],
              [-18.180219423385875, -12.31088310776049],
              [-18.179508447596387, -12.310751201932401],
              [-18.174647615432423, -12.311373751457309],
              [-18.172752814643186, -12.310410558237729],
              [-18.17197406718868, -12.309368025085192],
              [-18.16949012257557, -12.309270088691548],
              [-18.16928529020348, -12.307774754452264],
              [-18.171375872403928, -12.306985636899023],
              [-18.170132661440782, -12.305976045957186],
              [-18.16810484158101, -12.306348989602666],
              [-18.16717287811794, -12.30700954754515],
              [-18.165469345965708, -12.306718621878002],
              [-18.16439506534578, -12.307983849261737],
              [-18.16389257847721, -12.310032333849882],
              [-18.163218678589306, -12.310400114421206],
              [-18.16107318880943, -12.309819563607617],
              [-18.159513177431425, -12.31084427474587],
              [-18.158574095203207, -12.312054129252147],
              [-18.155725062960354, -12.31335201609878],
              [-18.15588174857482, -12.3148511060147],
              [-18.156696152844486, -12.316395773709267],
              [-18.15676707113759, -12.319274598451262],
              [-18.155940551708532, -12.322033925262625],
              [-18.153973111467675, -12.32262915091724],
              [-18.150612832697686, -12.322725937991091],
              [-18.149070286817622, -12.324023509194186],
              [-18.147450646843243, -12.326196434559586],
              [-18.148105402549984, -12.326838046126184],
              [-18.14740349545737, -12.328123370689301],
              [-18.150145963170193, -12.33109385494837],
              [-18.153907498780143, -12.330053161476458],
              [-18.15216823600357, -12.326739054464495],
              [-18.153095759030993, -12.325346082951313],
              [-18.157105095647587, -12.325157659428124],
              [-18.15951284551712, -12.326729455649764],
              [-18.16063126209037, -12.3234906373617],
              [-18.161661146696286, -12.322868789826115],
              [-18.165132229467208, -12.323631721906644],
              [-18.166318589958767, -12.323227359101706],
              [-18.167217349051228, -12.321469438607807],
              [-18.166915661532105, -12.319292951685211],
              [-18.16520315122455, -12.318269470667296],
              [-18.165188246259525, -12.31680573816277],
              [-18.167573833124234, -12.316819896847633],
              [-18.16854533199993, -12.315423501713664],
              [-18.169618427063458, -12.315393348859304],
              [-18.16941812189802, -12.317101324139866],
              [-18.175468220445357, -12.318593271673572],
              [-18.176524652088226, -12.320211904156423],
              [-18.179106023128725, -12.322820903079066],
              [-18.179670634417604, -12.324108661549147],
              [-18.178950539677665, -12.326358857707685],
              [-18.179876726819156, -12.328720981754204],
              [-18.182286773062376, -12.329647609488664],
              [-18.182139645117115, -12.330803783264416],
              [-18.18094557274925, -12.332355988554264],
              [-18.177318956207486, -12.332065913295024],
              [-18.17461918563982, -12.332900015499721],
              [-18.175074438456647, -12.33460918862524],
              [-18.1777101746326, -12.334787872722748],
              [-18.178865548516498, -12.33520935681112],
              [-18.180877292466157, -12.334561072817467],
              [-18.18431691127948, -12.334222268516788],
              [-18.18585752098696, -12.331681758195627],
              [-18.186676931562708, -12.32951465602642],
              [-18.1865769520854, -12.328192958115036]
            ]
          ],
          [
            [
              [-18.22193899277418, -12.312729120567564],
              [-18.22061396044548, -12.31312601847582],
              [-18.21731443979343, -12.313097912603773],
              [-18.21795411258729, -12.31440110571662],
              [-18.22118585991573, -12.31475480840576],
              [-18.22193899277418, -12.312729120567564]
            ]
          ],
          [
            [
              [-18.23007976808869, -12.30449381096033],
              [-18.229151777675263, -12.303694564535885],
              [-18.227000516850413, -12.304863618518311],
              [-18.228372037949814, -12.30595022542137],
              [-18.23007976808869, -12.30449381096033]
            ]
          ],
          [
            [
              [-18.242124164109597, -12.318491663002408],
              [-18.2400849647973, -12.317380084039637],
              [-18.237580629186635, -12.313265006517677],
              [-18.2354182421875, -12.311368658305737],
              [-18.23397688142218, -12.307357159811263],
              [-18.229355830781653, -12.310705796284509],
              [-18.22747486371651, -12.310870712820625],
              [-18.227364610095044, -12.31213837342636],
              [-18.22498444354713, -12.312798184703887],
              [-18.224019050645996, -12.31419903933776],
              [-18.224528228941516, -12.315582481478101],
              [-18.227630915147337, -12.31669828903341],
              [-18.227783439732157, -12.317740101976055],
              [-18.226989588298974, -12.319540849698093],
              [-18.224840740927085, -12.319588129610056],
              [-18.22246260987955, -12.322675688968308],
              [-18.224678283506766, -12.322876137385403],
              [-18.22671140524292, -12.324406863589909],
              [-18.227447129273642, -12.324320251311635],
              [-18.229076789920992, -12.325523976058243],
              [-18.230733919330945, -12.32457395341143],
              [-18.232007014593552, -12.324982049372464],
              [-18.23387178339017, -12.324290901583058],
              [-18.235349852043896, -12.321978829545726],
              [-18.23797305641195, -12.319946430958327],
              [-18.24037703622322, -12.320450611434953],
              [-18.242657203685688, -12.319406097852324],
              [-18.242124164109597, -12.318491663002408]
            ]
          ],
          [
            [
              [-18.278789268129902, -12.332640077352938],
              [-18.277090550740617, -12.330736708688415],
              [-18.276369068125298, -12.328247819004547],
              [-18.27167188371011, -12.326966467750587],
              [-18.27077551603744, -12.325752985177365],
              [-18.26815785794614, -12.325820611465156],
              [-18.2681048509506, -12.32859956657109],
              [-18.26620009893865, -12.33056190544396],
              [-18.26642032721865, -12.332056845569223],
              [-18.26429864654191, -12.331901144141359],
              [-18.264504503248723, -12.334706737177148],
              [-18.26522666483216, -12.337518340049566],
              [-18.263972423074218, -12.338809259253406],
              [-18.263350062070934, -12.338077352789593],
              [-18.261313514453384, -12.340415973688899],
              [-18.26370639914267, -12.34505174284808],
              [-18.264263627466367, -12.344960612490029],
              [-18.267067228960506, -12.346830967731895],
              [-18.268290143564712, -12.34882550541321],
              [-18.26951273827512, -12.34861448654437],
              [-18.268790468472332, -12.346673231330731],
              [-18.268814327264927, -12.345247936848175],
              [-18.269631400928485, -12.344058870798568],
              [-18.268720993800628, -12.342110325954254],
              [-18.2697113929653, -12.340747301964264],
              [-18.271368805247988, -12.339515870573017],
              [-18.272075509267438, -12.337449369367839],
              [-18.271700600465334, -12.33613938598654],
              [-18.27304282408092, -12.334221290761787],
              [-18.27393282382092, -12.33364651078063],
              [-18.275824644895323, -12.333566466174231],
              [-18.277642139006826, -12.335419038554097],
              [-18.278778279173533, -12.334985186731524],
              [-18.278789268129902, -12.332640077352938]
            ]
          ],
          [
            [
              [-18.278634960363473, -12.319127188994939],
              [-18.27657481531203, -12.318281524775525],
              [-18.276005208778226, -12.31988492217941],
              [-18.2748138955499, -12.320483405616201],
              [-18.274953604664933, -12.322741588018248],
              [-18.27544959209637, -12.323642687553503],
              [-18.277636811039958, -12.322621382557326],
              [-18.27739347907036, -12.321379976804591],
              [-18.278634960363473, -12.319127188994939]
            ]
          ],
          [
            [
              [-18.287612702698897, -12.357431167785316],
              [-18.285960926620167, -12.355607602058509],
              [-18.284641963538277, -12.354748976576431],
              [-18.283245760724665, -12.350379883782058],
              [-18.283654069442886, -12.347094270467366],
              [-18.282627507721607, -12.34528794915493],
              [-18.281827011836537, -12.34516461847693],
              [-18.28151207011681, -12.342503147290083],
              [-18.280922870097783, -12.341670129401002],
              [-18.28051663582348, -12.339552153727702],
              [-18.278015730444654, -12.339084154689559],
              [-18.275213613649584, -12.340361020352088],
              [-18.27356893496348, -12.340605155054568],
              [-18.27206851780064, -12.342605285236868],
              [-18.273646379144964, -12.344759018747535],
              [-18.27617425884753, -12.346598432622054],
              [-18.27675736656834, -12.347976290340593],
              [-18.280559315586963, -12.351948163660607],
              [-18.281494254566706, -12.353597022587733],
              [-18.28454018953892, -12.356066867765655],
              [-18.284649941665577, -12.357666650032469],
              [-18.28722085975795, -12.359209211590544],
              [-18.287612702698897, -12.357431167785316]
            ]
          ],
          [
            [
              [-18.303934160626476, -12.311530495232583],
              [-18.30336115304702, -12.309468624485277],
              [-18.30234227125642, -12.31042195428085],
              [-18.30278933289357, -12.311554275425435],
              [-18.30248286055543, -12.313733429569506],
              [-18.303219057783576, -12.313857197519004],
              [-18.303934160626476, -12.311530495232583]
            ]
          ],
          [
            [
              [-18.160194510652072, -11.992950355697298],
              [-18.158670431626707, -11.993566350459133],
              [-18.15701756095343, -11.994972941345571],
              [-18.155083024915864, -11.995861177451046],
              [-18.153861000281623, -11.996888944700732],
              [-18.151972444738853, -11.997539130097236],
              [-18.145804614220317, -12.0004192908656],
              [-18.143207544028986, -12.000133375977372],
              [-18.142167006543893, -12.001399171266396],
              [-18.139746477196134, -12.002034890734128],
              [-18.138095439572414, -12.00190504741102],
              [-18.13532903222444, -12.000241374680451],
              [-18.133282823796495, -11.999377572130017],
              [-18.12847239026662, -11.999042502089049],
              [-18.12664074759104, -11.998610517305861],
              [-18.123418124578215, -11.998476335720621],
              [-18.121461231186604, -11.999775658406922],
              [-18.11969671288672, -11.998375466600098],
              [-18.118612627542422, -11.999457573277152],
              [-18.116725794418407, -11.99952048567275],
              [-18.113733044251237, -11.99782363584836],
              [-18.115494886276394, -11.994122943858335],
              [-18.11462736647264, -11.992191649976517],
              [-18.114416257285978, -11.986078857266765],
              [-18.113075995786012, -11.983577314826762],
              [-18.11435926413094, -11.980017136582976],
              [-18.11667361236781, -11.978234054705498],
              [-18.117000488200222, -11.97519503638351],
              [-18.116938023870247, -11.971804095681927],
              [-18.12005320158619, -11.96803759285938],
              [-18.119584231129107, -11.964698679252205],
              [-18.118271069918702, -11.961619675679234],
              [-18.117964113346897, -11.958627845990966],
              [-18.11686916049705, -11.95636053275678],
              [-18.118935963099254, -11.953540525660104],
              [-18.119451424133345, -11.950939490642943],
              [-18.11887684531139, -11.946764675125756],
              [-18.11818150435925, -11.944540522051712],
              [-18.117020745862135, -11.938980035202553],
              [-18.114850072098033, -11.9330923908549],
              [-18.113894008006042, -11.93177735193181],
              [-18.1124839382698, -11.928244776225526],
              [-18.111040257674965, -11.925494665055284],
              [-18.109064457101294, -11.922581031902412],
              [-18.107347367779635, -11.919471830586007],
              [-18.102962426078843, -11.912898214173786],
              [-18.091611949707183, -11.8988652153621],
              [-18.08997582882507, -11.895843572185857],
              [-18.08519639457621, -11.888882177420276],
              [-18.078295752063163, -11.880340801953906],
              [-18.077060460505887, -11.878996592406564],
              [-18.07351702051503, -11.874397489973628],
              [-18.07067538079402, -11.871769727022127],
              [-18.068463772338827, -11.86812573597383],
              [-18.06466929746807, -11.863389734301444],
              [-18.062844446777497, -11.861737353333899],
              [-18.05819156972802, -11.85590731034705],
              [-18.056179094117013, -11.854112415685572],
              [-18.052005155788446, -11.849292846960656],
              [-18.046744958615747, -11.844322603561386],
              [-18.044083263343808, -11.841508027624755],
              [-18.04142197748688, -11.839356729517187],
              [-18.037361943718537, -11.835415612880357],
              [-18.033086347452212, -11.83259295293891],
              [-18.029705596291443, -11.83207711429576],
              [-18.024734285189957, -11.82783890914058],
              [-18.02242976422816, -11.82623862682719],
              [-18.017008564369466, -11.823056317109113],
              [-18.013134784720787, -11.820987334417463],
              [-18.010496659634796, -11.820098662234443],
              [-18.007165641811845, -11.819566814437886],
              [-18.0006322501657, -11.816686513786106],
              [-17.99962583830433, -11.81669500113257],
              [-17.99385793929558, -11.814837804544252],
              [-17.993895485223014, -11.812585767354333],
              [-17.993040228840933, -11.810035123974219],
              [-17.990302697577885, -11.80744714451649],
              [-17.98776352940613, -11.805713907829283],
              [-17.984296713035075, -11.803800110495311],
              [-17.979499273224185, -11.800528629808825],
              [-17.97500285140732, -11.796637576939224],
              [-17.972626742204262, -11.79362724465896],
              [-17.969560933613966, -11.788958602676125],
              [-17.967225668871276, -11.784660960214124],
              [-17.9655033099009, -11.78086370744239],
              [-17.962528235136364, -11.776497092105297],
              [-17.959603689243067, -11.774687257699064],
              [-17.953066160817404, -11.771831922331387],
              [-17.950949173896444, -11.770414393961634],
              [-17.942253259480292, -11.762295989216343],
              [-17.939259910067967, -11.758819261319378],
              [-17.934552665940856, -11.75460495244451],
              [-17.928431135235368, -11.750929979039466],
              [-17.926696943658254, -11.750235862187544],
              [-17.920359916254316, -11.74933451786984],
              [-17.91772246256216, -11.74763599734566],
              [-17.915356626148377, -11.747567786288018],
              [-17.914727601269917, -11.749049384340085],
              [-17.9156761627284, -11.750840547637722],
              [-17.91669005297292, -11.751816645474426],
              [-17.915236099762254, -11.752905102445888],
              [-17.915477557289172, -11.754505512510569],
              [-17.91486485691392, -11.75534954929482],
              [-17.914604886116933, -11.757267613356703],
              [-17.91377213540626, -11.759360216433446],
              [-17.910508159097464, -11.763604313674643],
              [-17.910104302396807, -11.766309933452842],
              [-17.910709957270825, -11.768439096539685],
              [-17.910092320078753, -11.77155631097217],
              [-17.90849816858072, -11.774191971027262],
              [-17.90515402361247, -11.773626082011434],
              [-17.903243429662467, -11.774735876459793],
              [-17.900181746586345, -11.77488230893581],
              [-17.89801564200611, -11.773261443147433],
              [-17.897323014999163, -11.770419786401364],
              [-17.894886012777313, -11.766290821794993],
              [-17.894164941957193, -11.764129948565012],
              [-17.89526156244922, -11.756894173527554],
              [-17.895674989883723, -11.751058024821193],
              [-17.896097366559154, -11.749829310300441],
              [-17.8964517437286, -11.742938883228097],
              [-17.898400850632786, -11.732575900380425],
              [-17.900433041558962, -11.732681082968863],
              [-17.902155462348524, -11.731840293641257],
              [-17.907634525813226, -11.730804936782212],
              [-17.910304759630957, -11.731338046179637],
              [-17.913148008362985, -11.73100666852718],
              [-17.915102372703195, -11.731476468941395],
              [-17.916358819280596, -11.73077883168774],
              [-17.91769542361793, -11.72451658860129],
              [-17.91832238371616, -11.722642971013228],
              [-17.91807103910902, -11.719022827009237],
              [-17.91642307061508, -11.70489334176015],
              [-17.91581313136626, -11.69775723379537],
              [-17.91495317572625, -11.693958475003756],
              [-17.9132940479316, -11.689402839801698],
              [-17.90948729271594, -11.680870828537959],
              [-17.907619030775628, -11.67564814300451],
              [-17.905322275428876, -11.667899253254376],
              [-17.90280275427079, -11.654959831402277],
              [-17.900486624939127, -11.640455732857971],
              [-17.899075403697935, -11.634571543579158],
              [-17.89760641218861, -11.62447639197608],
              [-17.897042639055304, -11.619118808016431],
              [-17.896160048497375, -11.612781517518098],
              [-17.894492040686757, -11.60467175280681],
              [-17.89404180259236, -11.60085035855335],
              [-17.89260526912262, -11.592036693522786],
              [-17.89128685905982, -11.586905657677837],
              [-17.89094807296027, -11.584367083374827],
              [-17.889291289715928, -11.575945108937459],
              [-17.888451510482597, -11.572612172562943],
              [-17.886373541318125, -11.562100635330227],
              [-17.88567493998367, -11.559693007678051],
              [-17.883973611669404, -11.555480619847662],
              [-17.879919818716527, -11.547915309797343],
              [-17.878577697498095, -11.545092829998977],
              [-17.876477638894794, -11.539026221097338],
              [-17.875003756266626, -11.536081361332519],
              [-17.873692174077227, -11.536516618011504],
              [-17.874637003205503, -11.540611875688196],
              [-17.874705220890757, -11.543479890712797],
              [-17.874049500187205, -11.544312889958254],
              [-17.87202191238985, -11.544893328566378],
              [-17.865748172070102, -11.54513127881034],
              [-17.862448905027986, -11.544500260756314],
              [-17.856780192326386, -11.54412063720314],
              [-17.853500284316826, -11.542969295394695],
              [-17.8518926525427, -11.541539181492016],
              [-17.851195010620525, -11.540343893986012],
              [-17.84870159748401, -11.534513069821358],
              [-17.84792184177243, -11.53088499853624],
              [-17.855201033702496, -11.529575148543488],
              [-17.85772491245769, -11.529700658040879],
              [-17.85841181368194, -11.529040152262914],
              [-17.860678900982467, -11.525194138848004],
              [-17.865754804933555, -11.518725496394174],
              [-17.87072502659179, -11.511616876728779],
              [-17.873822493986104, -11.506717452045194],
              [-17.87453916298837, -11.503837824513946],
              [-17.87425417006225, -11.503013053641087],
              [-17.87239515036302, -11.500936323685034],
              [-17.873684891082686, -11.499771257507943],
              [-17.87493704525078, -11.497123283900338],
              [-17.87512569555891, -11.492982718772758],
              [-17.87456830038436, -11.485163093741283],
              [-17.873530934768816, -11.478125015747361],
              [-17.872447471661417, -11.473026094082162],
              [-17.871341394874513, -11.466298825023255],
              [-17.869010135725947, -11.459016851597882],
              [-17.866961819508667, -11.45491919649478],
              [-17.864594385071463, -11.448502434993822],
              [-17.862758582448006, -11.445875331434356],
              [-17.86098218779439, -11.441102927644987],
              [-17.860044585987115, -11.436974693712774],
              [-17.85821163531244, -11.433083924155357],
              [-17.85624934280265, -11.430510917698745],
              [-17.8541170067707, -11.427104957435889],
              [-17.853309762655343, -11.426562580552659],
              [-17.85156308443544, -11.427218380195306],
              [-17.848421950292195, -11.424810151632334],
              [-17.846756705203887, -11.422413001413872],
              [-17.845717598707214, -11.421456524016952],
              [-17.843554816038118, -11.420456776633298],
              [-17.84228066703735, -11.420541997823058],
              [-17.840413252224753, -11.421725829010995],
              [-17.837661649675244, -11.419232802473429],
              [-17.834255451535352, -11.415360885883814],
              [-17.832268733961243, -11.413791839481359],
              [-17.8286556840992, -11.408953927914283],
              [-17.82709349905341, -11.406370988239866],
              [-17.82316869971819, -11.398730798157443],
              [-17.821427115354552, -11.396118965501376],
              [-17.817253387809654, -11.390655235191101],
              [-17.747437185707504, -11.393820733970797],
              [-17.68129900344931, -11.396449087842043],
              [-17.645559982533914, -11.397724628290053],
              [-17.644210839435246, -11.35973784510962],
              [-17.642267036104997, -11.305098307024862],
              [-17.65965066642855, -11.304491057924333],
              [-17.76694137364517, -11.300200127367766],
              [-17.764563330075937, -11.298566671016177],
              [-17.76332562693279, -11.29728779675669],
              [-17.761958024778107, -11.295040894723964],
              [-17.76070936479734, -11.290694805266504],
              [-17.76103946891998, -11.288078603615482],
              [-17.759981869556437, -11.27899100492639],
              [-17.7575294413117, -11.273145949468526],
              [-17.75564037071007, -11.27244093328314],
              [-17.75173255378148, -11.272103489539317],
              [-17.751726294390416, -11.27054080085051],
              [-17.754564564377667, -11.267102328049804],
              [-17.759135354788466, -11.267008006934613],
              [-17.767293978730564, -11.271905873286578],
              [-17.76993457052678, -11.27487264487058],
              [-17.77029831441805, -11.276115267527222],
              [-17.77172306290521, -11.277434067787727],
              [-17.773191192965932, -11.280454113606462],
              [-17.773106798761056, -11.281853345098767],
              [-17.771894986096402, -11.28340873935879],
              [-17.772334763218236, -11.284573380788666],
              [-17.77299533396317, -11.290000780837545],
              [-17.774606093271853, -11.291917023769171],
              [-17.77590439830348, -11.292641448821577],
              [-17.778001020315802, -11.295297628061743],
              [-17.778972421513533, -11.299529591548444],
              [-17.78017716815337, -11.30233376613781],
              [-17.78093349029662, -11.303358154604352],
              [-17.785181139675476, -11.305621191349367],
              [-17.789539695414195, -11.307030538601309],
              [-17.794907446319268, -11.307543809672191],
              [-17.79726964592958, -11.30934035900616],
              [-17.80175327617672, -11.31059333363712],
              [-17.797783691408792, -11.229716591906529],
              [-17.81190628524992, -11.229041488233197],
              [-17.808906504800248, -11.169378552743396],
              [-17.778918538093308, -11.170792884506195],
              [-17.777495730210774, -11.140952545585485],
              [-17.717663747923066, -11.14355021238945],
              [-17.716395216398194, -11.113700291326808],
              [-17.69965296313727, -11.114373839899338],
              [-17.698427680832015, -11.084518475229396],
              [-17.668355552480733, -11.085669452689006],
              [-17.667207849782105, -11.055807878572097],
              [-17.60721189344996, -11.057878135561085],
              [-17.60621974769042, -11.02800811651289],
              [-17.577213726268816, -11.028900515228818],
              [-17.574488773369005, -10.940180587719516],
              [-17.56810234410603, -10.732132632845971],
              [-17.564367556337608, -10.610396921274306],
              [-17.47931395955075, -10.612597539901246],
              [-17.39532568803824, -10.613835750916977],
              [-17.311337610638212, -10.615086602014179],
              [-17.26907595745918, -10.615324267110358],
              [-17.13052279837955, -10.615007356960806],
              [-17.130266828179217, -10.64492889320654],
              [-17.122854687512177, -10.644864136605507],
              [-17.12174809641521, -10.764523321457823],
              [-17.14428618767377, -10.764705512082289],
              [-17.143412892241965, -10.884328794628916],
              [-17.16574431890447, -10.884464673833055],
              [-17.1655931596397, -10.912838427133924],
              [-17.16511472497125, -11.004042340268468],
              [-17.187244311457242, -11.0041373666862],
              [-17.187144501088994, -11.034024667668307],
              [-17.217080900375038, -11.034085768681566],
              [-17.217059534846285, -11.062121988348578],
              [-17.21703497707598, -11.093852305226548],
              [-17.247130285963742, -11.09384115446778],
              [-17.24718575791975, -11.123715579659631],
              [-17.27714647153288, -11.123622218604806],
              [-17.29838399036234, -11.12351482414427],
              [-17.298759127956785, -11.183260922636364],
              [-17.3588015786174, -11.182748175046934],
              [-17.35948336867106, -11.242476434053028],
              [-17.349857217123677, -11.242579076283564],
              [-17.351119317791383, -11.361990834660153],
              [-17.341620994136225, -11.3620846151162],
              [-17.34191317350848, -11.391927809733996],
              [-17.281997040133017, -11.392348701612107],
              [-17.28230743528467, -11.456998253513184],
              [-17.292368166459877, -11.456948128260441],
              [-17.292441245774114, -11.471864757832293],
              [-17.307531751294487, -11.47177373672964],
              [-17.30758058189327, -11.481717656102624],
              [-17.3135925446544, -11.481676281958409],
              [-17.313658807749576, -11.49161957925594],
              [-17.333513317139, -11.491462934440708],
              [-17.333605117064902, -11.501405527136628],
              [-17.363548083708608, -11.501109194523965],
              [-17.36366450039112, -11.511051379224396],
              [-17.388820687336818, -11.510746767897684],
              [-17.388878923680778, -11.515717336809896],
              [-17.41382726147693, -11.515364962629464],
              [-17.413968351951805, -11.525305754975063],
              [-17.42384762941811, -11.525152328263228],
              [-17.42401326564611, -11.53509257336016],
              [-17.454041517266454, -11.53457773028949],
              [-17.454327247359632, -11.549486502405873],
              [-17.474452004104165, -11.549101168491095],
              [-17.475022714061364, -11.578914900287323],
              [-17.4649612459143, -11.579111906016701],
              [-17.465342494919216, -11.5989852423131],
              [-17.475063185300407, -11.598795073809413],
              [-17.476140477497488, -11.653787901455415],
              [-17.496124257471024, -11.653373835403658],
              [-17.496453144024017, -11.668272752415945],
              [-17.51154959258221, -11.66793866405384],
              [-17.511769176500465, -11.67787082800128],
              [-17.541875046030146, -11.677151636667348],
              [-17.542364844826455, -11.697011142278614],
              [-17.552391070584385, -11.696757422843115],
              [-17.552795001232035, -11.71165155864018],
              [-17.55676017440036, -11.711548208773783],
              [-17.55702011149849, -11.72147591530415],
              [-17.581916941355505, -11.72080033384643],
              [-17.58234226768127, -11.735691478527828],
              [-17.572278794994695, -11.735971132620445],
              [-17.57242060934502, -11.74093421101517],
              [-17.567602705623674, -11.74106560516589],
              [-17.56773236378782, -11.746018898516098],
              [-17.577594022094548, -11.745759016818525],
              [-17.577735841502847, -11.750722155538933],
              [-17.58276755931436, -11.750581683851776],
              [-17.582909372185874, -11.755544682984013],
              [-17.587941205120316, -11.755401870883874],
              [-17.588083008145656, -11.760364731104774],
              [-17.593114963828572, -11.760219923602554],
              [-17.592689357165487, -11.745330901114766],
              [-17.60255052435534, -11.745041290705233],
              [-17.602704416782526, -11.75000444094037],
              [-17.612763545895522, -11.749675330152536],
              [-17.61307567199562, -11.759626520448823],
              [-17.618107320300243, -11.759471804851819],
              [-17.618261551305988, -11.764434181587797],
              [-17.623293139950334, -11.764277820441405],
              [-17.623601376583704, -11.774202158819808],
              [-17.638565996967504, -11.773728813675822],
              [-17.638400695871727, -11.76876327752239],
              [-17.66844373171752, -11.767751742710171],
              [-17.66880209758079, -11.777673531663801],
              [-17.673833186429285, -11.777498048979165],
              [-17.674011707740327, -11.782459097098489],
              [-17.684074151483568, -11.782100776769989],
              [-17.684609972177277, -11.796983415850205],
              [-17.694601064273506, -11.79661945251542],
              [-17.695554258279163, -11.821419579120526],
              [-17.705616884510473, -11.821045114166417],
              [-17.705807801383035, -11.826004764351323],
              [-17.703480461634566, -11.826092156467178],
              [-17.703666463404662, -11.831051496900562],
              [-17.718490356186628, -11.830488299234407],
              [-17.719083525199412, -11.845365171790302],
              [-17.729146246786094, -11.844972606783427],
              [-17.729937838764954, -11.864806363040797],
              [-17.74484413723321, -11.864211034264443],
              [-17.74589333739313, -11.888997877547672],
              [-17.66655078138296, -11.891965846865984],
              [-17.667741161244454, -11.893158779709003],
              [-17.66807799581377, -11.894386571659108],
              [-17.66913059638147, -11.89485931921403],
              [-17.67037810216682, -11.8963653859947],
              [-17.66948190543, -11.897070382280118],
              [-17.670568831932272, -11.899148070099477],
              [-17.673417530901787, -11.901927587113775],
              [-17.673864423046354, -11.903683773705529],
              [-17.677490395030688, -11.90426533429293],
              [-17.679178539876126, -11.905446207678038],
              [-17.681222476934746, -11.904665213874424],
              [-17.681371655835935, -11.90747319882878],
              [-17.680992784019264, -11.908195614316055],
              [-17.682075896997098, -11.910660909372234],
              [-17.685156254146953, -11.911659222021258],
              [-17.686099989368195, -11.90916565708877],
              [-17.688970184616842, -11.909372642750695],
              [-17.689527089414113, -11.908599243126528],
              [-17.691085241470873, -11.909273860266302],
              [-17.692549270826802, -11.909243062455682],
              [-17.69200616306626, -11.911567348110918],
              [-17.69341365275619, -11.913599852701777],
              [-17.692494007313364, -11.914320283550882],
              [-17.691420443199092, -11.913960095339691],
              [-17.689317093644842, -11.91439097939818],
              [-17.686753776312464, -11.916389550565025],
              [-17.68924283719624, -11.916610534600405],
              [-17.689680777308563, -11.917459286989578],
              [-17.688508650807616, -11.919267038881085],
              [-17.687858348628527, -11.921183678736595],
              [-17.688390498244363, -11.923937051532356],
              [-17.691052252556982, -11.923907650654506],
              [-17.69204588001675, -11.925113654575199],
              [-17.693272841293233, -11.9247366299117],
              [-17.69515050066153, -11.925444485444038],
              [-17.696315569303476, -11.928175441087141],
              [-17.697963460834764, -11.928758375949752],
              [-17.69717087157925, -11.929874857794267],
              [-17.699263891235486, -11.931462778105375],
              [-17.699949187183304, -11.93251155290745],
              [-17.702333651600384, -11.934345831938364],
              [-17.702886894559757, -11.935213523477442],
              [-17.70686796194392, -11.935353851912428],
              [-17.71088252971248, -11.936335587932614],
              [-17.712242478814773, -11.93473007560187],
              [-17.713415676468195, -11.935263055595668],
              [-17.713483884325516, -11.93641486919094],
              [-17.715415991803816, -11.936141969909619],
              [-17.717162750522466, -11.934054753996232],
              [-17.7177077278812, -11.935254991418098],
              [-17.72110058977977, -11.934236986709486],
              [-17.72156960297787, -11.93635055376181],
              [-17.72004878641297, -11.937297256302806],
              [-17.71693173887511, -11.938460345512395],
              [-17.71621446039763, -11.939175990336057],
              [-17.715670900167787, -11.941417844111948],
              [-17.71398882162792, -11.94174824063793],
              [-17.714107624725813, -11.943609722995603],
              [-17.713676081331563, -11.94527017007148],
              [-17.71256643106012, -11.94522353732465],
              [-17.71073587575315, -11.9486923009915],
              [-17.710994960380464, -11.95068306050631],
              [-17.710351440928804, -11.951574092344769],
              [-17.71078709928105, -11.95344725407469],
              [-17.711795284585623, -11.954921048506092],
              [-17.711626830154717, -11.95581686459252],
              [-17.710162720911576, -11.957139509841609],
              [-17.712035712129623, -11.959303984834838],
              [-17.71265651180559, -11.957823788120827],
              [-17.714641209481353, -11.957081438643684],
              [-17.715860772280816, -11.95587883507867],
              [-17.718561865306643, -11.955832557502397],
              [-17.72041143155273, -11.95423758328745],
              [-17.721993775799145, -11.95419910304601],
              [-17.724667974868666, -11.952628376458891],
              [-17.72670485268819, -11.953483213475815],
              [-17.72869280282581, -11.951738380915337],
              [-17.72938002019294, -11.949733266012135],
              [-17.731519869075406, -11.948960154694792],
              [-17.732347362401356, -11.949283478055431],
              [-17.731625456218612, -11.951256822143984],
              [-17.733327845662792, -11.951945844871924],
              [-17.734861181230784, -11.950729305577442],
              [-17.73410863668111, -11.948658408275522],
              [-17.73573867121421, -11.94541590688935],
              [-17.737427832009654, -11.941438107177474],
              [-17.73846169992907, -11.939664458662246],
              [-17.740630573035418, -11.938556044704741],
              [-17.742012226132882, -11.937012708326918],
              [-17.745824778407616, -11.937925148627356],
              [-17.748183748400837, -11.940528859575203],
              [-17.74996855691407, -11.938645753728478],
              [-17.752370501444556, -11.938258861752871],
              [-17.75394925397202, -11.940815817296322],
              [-17.752935475526044, -11.943012452678243],
              [-17.75143091883108, -11.943784965769446],
              [-17.751642027197697, -11.945554251542891],
              [-17.75121607516552, -11.946705132824347],
              [-17.749258549847006, -11.949607862615645],
              [-17.747693571700047, -11.950582908631858],
              [-17.748894915124055, -11.951779638439007],
              [-17.74901540433655, -11.952820613807145],
              [-17.750929416893815, -11.95432034264266],
              [-17.751642482795152, -11.956181717721599],
              [-17.753436362346495, -11.957703490192108],
              [-17.755386882180392, -11.960099561970912],
              [-17.75641875335429, -11.963038710964549],
              [-17.756450691814166, -11.969581433364688],
              [-17.7569201213528, -11.971417725034511],
              [-17.758124453745047, -11.973721001401632],
              [-17.75858851389001, -11.976597318851063],
              [-17.75821754547631, -11.977459156463402],
              [-17.759357058980168, -11.979171843962167],
              [-17.758893855429978, -11.980334207504646],
              [-17.760343986946832, -11.982146957550595],
              [-17.761758658250923, -11.981211619733672],
              [-17.762908158551234, -11.982612436254488],
              [-17.762447738016952, -11.983500748321823],
              [-17.76442684078238, -11.984721345875382],
              [-17.766836974197297, -11.983228474506657],
              [-17.767429037969297, -11.982245528864556],
              [-17.767501795001305, -11.98028117501311],
              [-17.768203320518747, -11.978692228844203],
              [-17.768589912216648, -11.976136287116997],
              [-17.768241254103074, -11.974391146653788],
              [-17.771374203381892, -11.970896469363309],
              [-17.773558333199905, -11.96802060292891],
              [-17.774754617374423, -11.965365277654307],
              [-17.774908393898766, -11.962710218412962],
              [-17.77425865971112, -11.961847563851336],
              [-17.77516898085114, -11.960805188249763],
              [-17.777268468190538, -11.960272862024272],
              [-17.780739856120807, -11.960925008377238],
              [-17.782536485837543, -11.9620937715816],
              [-17.783933019575457, -11.963925352430335],
              [-17.784304153665687, -11.967627117694796],
              [-17.784844510785522, -11.969050784779544],
              [-17.784631796863103, -11.970271760825264],
              [-17.78588964986737, -11.972368403142308],
              [-17.786265355216038, -11.973876745545224],
              [-17.784332307465746, -11.976348898027737],
              [-17.786740249263552, -11.977010128894461],
              [-17.788467498369197, -11.97820237453354],
              [-17.79069621997831, -11.977780207867472],
              [-17.793430217275027, -11.977778871566317],
              [-17.794828521335535, -11.978271368847656],
              [-17.79836989674448, -11.980768871901983],
              [-17.802609325427035, -11.985003114990084],
              [-17.80414866508104, -11.987289084439425],
              [-17.80684627371051, -11.992105961625068],
              [-17.809793178999893, -11.998733935992085],
              [-17.813029917783123, -12.003743804931187],
              [-17.81291696762322, -12.007120666428406],
              [-17.815252906472686, -12.009382110320761],
              [-17.817010590382846, -12.004277345092442],
              [-17.820012339295918, -12.003827419242509],
              [-17.821893742148923, -12.004187414457707],
              [-17.82451322286287, -12.003821002966832],
              [-17.82669936193954, -12.0053050703885],
              [-17.82652316557355, -12.00636279747743],
              [-17.827610130411433, -12.007674756881514],
              [-17.82814413338668, -12.009772023257888],
              [-17.827517467721684, -12.010917982057837],
              [-17.82526059026732, -12.012698167622226],
              [-17.825605334195924, -12.014648644099928],
              [-17.827348017249854, -12.015394832074206],
              [-17.82740643042816, -12.016598891794441],
              [-17.82594423733502, -12.018728518299653],
              [-17.826563922346423, -12.020348181186561],
              [-17.828017564073665, -12.020750189948862],
              [-17.83151566608182, -12.024483225547325],
              [-17.831884225173447, -12.02347665903862],
              [-17.83333168788711, -12.023744449527676],
              [-17.83341453173391, -12.024970650595003],
              [-17.836904423497348, -12.02554469652106],
              [-17.83784160934253, -12.026999144978149],
              [-17.83850232653997, -12.025156134434994],
              [-17.839915924233047, -12.024731453562435],
              [-17.840501987318145, -12.023227691814931],
              [-17.84235764441957, -12.023452811372108],
              [-17.842802446191765, -12.0209497406238],
              [-17.84508885921251, -12.019320382416305],
              [-17.84575475103723, -12.017611908511256],
              [-17.847283577904822, -12.016778674587428],
              [-17.851361588850963, -12.016403587027005],
              [-17.851177924621453, -12.015298646089404],
              [-17.854084764428134, -12.01309801978912],
              [-17.854677492742642, -12.011326204249565],
              [-17.854625621937775, -12.008960524874421],
              [-17.855547769566495, -12.007531197601145],
              [-17.8581901584068, -12.006150827834807],
              [-17.85887051244315, -12.004330794260838],
              [-17.860030420537512, -12.003447608015286],
              [-17.862017174149408, -12.000513913096764],
              [-17.86426705750267, -11.999175126321415],
              [-17.8656184226452, -11.99761242701266],
              [-17.866733074565655, -11.995436427941252],
              [-17.869102214186675, -11.994671675491878],
              [-17.869995228697654, -11.99261832078063],
              [-17.870976756447664, -11.991832884630353],
              [-17.875230471503244, -11.990877998813312],
              [-17.879453576117598, -11.991876266984123],
              [-17.881292564738985, -11.992528358416873],
              [-17.884017944944013, -11.994390434104313],
              [-17.886073788852066, -11.996718990992067],
              [-17.888290247851042, -12.000759423448086],
              [-17.88777235906934, -12.005681842490043],
              [-17.88703566683133, -12.009041266468515],
              [-17.884986464423026, -12.011681108565533],
              [-17.882653486624296, -12.011100555073522],
              [-17.88138555234672, -12.011305259134813],
              [-17.879011178602546, -12.012804297165072],
              [-17.878896242091756, -12.014508990581673],
              [-17.879368814663813, -12.017861280589672],
              [-17.878611519641364, -12.019911868389332],
              [-17.876111818465272, -12.022184496020747],
              [-17.876270328626536, -12.025643803837106],
              [-17.87807093372746, -12.024792628886237],
              [-17.878176042850786, -12.023758323800749],
              [-17.879315186459287, -12.022895892092167],
              [-17.881233922859046, -12.023000348168052],
              [-17.8831260080097, -12.023888648311056],
              [-17.88618372187108, -12.026552567212585],
              [-17.888355257327202, -12.027963435244127],
              [-17.88950971644258, -12.02696435279488],
              [-17.890700874609994, -12.024531650122164],
              [-17.89399653926423, -12.024384979901415],
              [-17.895357121909857, -12.023844932924051],
              [-17.896910430910708, -12.023921294278582],
              [-17.897309233192455, -12.024974405643315],
              [-17.89921064386193, -12.025925894648159],
              [-17.900769728071435, -12.02743523461088],
              [-17.90215727972181, -12.029351776435615],
              [-17.9044148322626, -12.033669672829454],
              [-17.90698542115214, -12.042292221663269],
              [-17.90796652893909, -12.043540061380334],
              [-17.907304446585552, -12.045613911129436],
              [-17.907047866595292, -12.04842855333492],
              [-17.906330185565817, -12.05220589390369],
              [-17.90512576251138, -12.054201035496972],
              [-17.904118130888612, -12.05456752617998],
              [-17.9029593792257, -12.053843176299004],
              [-17.901192819504438, -12.054114311675882],
              [-17.898819909213167, -12.057533469287042],
              [-17.896528682974374, -12.057831412642836],
              [-17.895069865158703, -12.056805915103952],
              [-17.89297831845958, -12.05595078234731],
              [-17.89222549893566, -12.056819053028045],
              [-17.892381263293505, -12.058022268368186],
              [-17.891521286728143, -12.061587531605113],
              [-17.888632177093466, -12.064404518362117],
              [-17.887755380813044, -12.066827400769938],
              [-17.88818533150928, -12.068466105663754],
              [-17.889854972009914, -12.071478295819324],
              [-17.891307002200705, -12.07297578748915],
              [-17.89275601044684, -12.072699425847263],
              [-17.895935495256158, -12.074526769349315],
              [-17.89852041678286, -12.075254379595409],
              [-17.899198569471835, -12.074680588052571],
              [-17.904815005579117, -12.075736143340624],
              [-17.905965811652592, -12.073767579616446],
              [-17.90910061117306, -12.073783113095267],
              [-17.90962590285396, -12.073351374605965],
              [-17.91365145503882, -12.072510997880444],
              [-17.91787578736722, -12.072376854356865],
              [-17.918901344918634, -12.073130703834382],
              [-17.92059006446976, -12.073467251795666],
              [-17.921759788729165, -12.075156534788686],
              [-17.923436074216994, -12.075673338367407],
              [-17.92524899584703, -12.074543154847213],
              [-17.926693865630693, -12.074195917835574],
              [-17.927240411102627, -12.075015767066658],
              [-17.92879736448419, -12.074576408885013],
              [-17.93107997444481, -12.074879905146924],
              [-17.931743812722065, -12.07327175933693],
              [-17.933042531608862, -12.07156212471837],
              [-17.936609590328743, -12.069784686380123],
              [-17.937526570965034, -12.066589672948806],
              [-17.938727645190628, -12.064441255056037],
              [-17.938297917953378, -12.0630648547004],
              [-17.9389191934129, -12.060075330885512],
              [-17.940595504396924, -12.05836663409093],
              [-17.941441973234927, -12.056630197362523],
              [-17.941277616301104, -12.055641432132248],
              [-17.94207489323844, -12.052145179746322],
              [-17.945321423980158, -12.050642792040984],
              [-17.94715678650907, -12.050617004659141],
              [-17.95158786154038, -12.051403668239132],
              [-17.957581176174564, -12.054270638651337],
              [-17.961179735787347, -12.057163713933095],
              [-17.96075457769715, -12.059252193063239],
              [-17.963245946644445, -12.06117601628937],
              [-17.96713844531117, -12.061269157359067],
              [-17.967913670507972, -12.059698764028662],
              [-17.97015182961132, -12.05966057639515],
              [-17.971851218792917, -12.060550855842889],
              [-17.975706561516827, -12.061541181917816],
              [-17.976352398921023, -12.06087565303],
              [-17.979613452403502, -12.062617414677543],
              [-17.982693670909054, -12.06513289907953],
              [-17.984275948667264, -12.06782571577364],
              [-17.985725124292934, -12.072076357516995],
              [-17.988022728521035, -12.072593749561804],
              [-17.988480051190777, -12.074454220276047],
              [-17.989714645761904, -12.073834676116723],
              [-17.99120164475659, -12.07627219195625],
              [-17.992823341862582, -12.075858396891784],
              [-17.99405325576774, -12.07409790700868],
              [-17.99647342040367, -12.073399489480972],
              [-17.997825754933377, -12.074198491131517],
              [-17.998763684695984, -12.073780801733102],
              [-18.00217618437666, -12.076004899970567],
              [-18.00337412982091, -12.077956480821724],
              [-18.005330674580687, -12.079210940299356],
              [-18.006435770417028, -12.080763473236704],
              [-18.005972709292667, -12.082882182911469],
              [-18.008656409864265, -12.082563979520966],
              [-18.011131024869815, -12.083292161248538],
              [-18.01433330282272, -12.085010596119291],
              [-18.018313705705186, -12.089583430330528],
              [-18.019402753339598, -12.089764899968106],
              [-18.019298431049915, -12.093169297227604],
              [-18.02090050379356, -12.093476779257184],
              [-18.02071206266649, -12.097359937425479],
              [-18.019436476882333, -12.09786521182375],
              [-18.0165127172188, -12.097344653725285],
              [-18.013892468262945, -12.096175165447098],
              [-18.013166858632182, -12.09630895321218],
              [-18.010754668757325, -12.094903035857557],
              [-18.00857707744049, -12.094446803548053],
              [-18.006359495980075, -12.094557303097156],
              [-18.004032096597644, -12.093278395481196],
              [-18.002356873157485, -12.09362584924364],
              [-18.000483036270985, -12.092252011713828],
              [-17.998540420352242, -12.091984568706478],
              [-17.997448427779137, -12.091344719614511],
              [-17.99517486902349, -12.090946257492934],
              [-17.99458294677121, -12.091386110504653],
              [-17.99110013670666, -12.090668306590848],
              [-17.990212182727085, -12.089836268685803],
              [-17.988712429462588, -12.089480987624864],
              [-17.9875962050081, -12.087342160262258],
              [-17.986092419745187, -12.088239471982682],
              [-17.984362680567475, -12.087305656260122],
              [-17.981894822683678, -12.087044012181323],
              [-17.97879570221997, -12.08618914664981],
              [-17.977564870113824, -12.084776050843574],
              [-17.975856829857296, -12.086470820375784],
              [-17.974203491148675, -12.086790770522898],
              [-17.973726752254024, -12.087627641380866],
              [-17.969924712324712, -12.089576766091506],
              [-17.967366916778662, -12.089339834097748],
              [-17.96550314518412, -12.089985538044388],
              [-17.964054670087382, -12.088358661464087],
              [-17.96283452924653, -12.09058648101732],
              [-17.961244745617343, -12.092385429124816],
              [-17.96125131888664, -12.093560247510185],
              [-17.9603042679757, -12.094710466084548],
              [-17.962384163954084, -12.095380693468067],
              [-17.963419463356992, -12.098157118381353],
              [-17.96329099548663, -12.100640015591674],
              [-17.96215417256086, -12.105476051218886],
              [-17.963229299901126, -12.10658636893864],
              [-17.962530047460277, -12.109125346554178],
              [-17.963507249217272, -12.11168267161489],
              [-17.9664636682341, -12.111988289881944],
              [-17.967421592431158, -12.112654730436718],
              [-17.969022256657, -12.114861729440198],
              [-17.96965294671548, -12.119287694738013],
              [-17.971395288632298, -12.12038272008555],
              [-17.97458982524712, -12.119636723472537],
              [-17.977760966099975, -12.117741956964538],
              [-17.97932254006064, -12.116209812143563],
              [-17.980262223826834, -12.116178282132374],
              [-17.98117443617325, -12.114931269724678],
              [-17.982180240950683, -12.115233681731022],
              [-17.98609936598619, -12.114618282564791],
              [-17.988779805600164, -12.113858729725472],
              [-17.990354067626306, -12.11218942401117],
              [-17.990262035240313, -12.110685469460197],
              [-17.991268419085557, -12.109500118364627],
              [-17.992964796139223, -12.109085359856486],
              [-17.993607866391688, -12.109836105379038],
              [-17.996067337029693, -12.110254586762274],
              [-17.99747393579797, -12.10960836155146],
              [-18.000980402841673, -12.10543638970557],
              [-18.002206854709126, -12.105228569529098],
              [-18.00344494498107, -12.105943149974628],
              [-18.00448891155164, -12.105385349548538],
              [-18.005627352854578, -12.105970692185265],
              [-18.007561418976504, -12.10423359432984],
              [-18.010130323214394, -12.104935160495923],
              [-18.01208245030429, -12.104953120045446],
              [-18.01253350157297, -12.104095442117806],
              [-18.015244419386924, -12.103771459271128],
              [-18.016693989843148, -12.101656515276112],
              [-18.020100430053716, -12.101810417895807],
              [-18.02067477830326, -12.100379164900763],
              [-18.022414946624984, -12.100318108439074],
              [-18.02437411629708, -12.10188741976059],
              [-18.025747045078074, -12.105046685071187],
              [-18.025673179221087, -12.106402846570816],
              [-18.024319969075716, -12.108580889959269],
              [-18.021842503489754, -12.109340363253372],
              [-18.02079603354517, -12.108412803173671],
              [-18.01961202078382, -12.110377669915016],
              [-18.01842643425783, -12.111598875759961],
              [-18.019642592354298, -12.115559373568773],
              [-18.02053367724564, -12.116925088984733],
              [-18.020252900170323, -12.118655641982123],
              [-18.021384463046115, -12.120909260148728],
              [-18.02209637619951, -12.121239608586555],
              [-18.024212345780803, -12.120917595142819],
              [-18.027899197756952, -12.118910481555432],
              [-18.029205726678136, -12.119213585701106],
              [-18.031047036413963, -12.120389364702293],
              [-18.031902478937198, -12.12218244309218],
              [-18.035834241155683, -12.119706647567643],
              [-18.03785375826671, -12.120010065135824],
              [-18.04060162397465, -12.119139827419534],
              [-18.042174493591013, -12.119290074171529],
              [-18.04433945645185, -12.1200567467318],
              [-18.04451268728193, -12.118489896873523],
              [-18.047799531820377, -12.115690272703523],
              [-18.050614350126363, -12.114115247182324],
              [-18.052172814744274, -12.112664051585757],
              [-18.05549661530853, -12.11254382981481],
              [-18.059389059152295, -12.111304039044388],
              [-18.06172912333175, -12.112281714657694],
              [-18.06915749118543, -12.11884054612105],
              [-18.071057444978916, -12.11871788055244],
              [-18.073075068717433, -12.119309431465753],
              [-18.075779609758012, -12.120870872181605],
              [-18.080136667511233, -12.127086402564053],
              [-18.081141077028008, -12.129662187205218],
              [-18.085275396605947, -12.134901197489366],
              [-18.08715212274918, -12.136743172602054],
              [-18.08805584074989, -12.138829664124966],
              [-18.090083269559756, -12.13917045311165],
              [-18.09473673579146, -12.144489805088536],
              [-18.09576438120124, -12.144353957233381],
              [-18.09679183877335, -12.14620699147251],
              [-18.095724449279594, -12.153739753362055],
              [-18.09413063573344, -12.15703497076952],
              [-18.09413031983327, -12.16036088105042],
              [-18.0922518437472, -12.159557326754907],
              [-18.090913772994632, -12.158220205450034],
              [-18.08854453035324, -12.157641525523118],
              [-18.08429319804246, -12.157546703537728],
              [-18.082828563897152, -12.158640207104488],
              [-18.084023706658403, -12.161025707131643],
              [-18.083716688581706, -12.162946439264907],
              [-18.08094480507385, -12.164598278961726],
              [-18.081370195935445, -12.162714939016151],
              [-18.07968650553534, -12.162052519044137],
              [-18.079379196803323, -12.162957559667902],
              [-18.077633258243697, -12.163749957681118],
              [-18.076994205103954, -12.165896310897923],
              [-18.078258009953515, -12.167172238715203],
              [-18.079629434007384, -12.169346670235187],
              [-18.079866994563215, -12.17216137198026],
              [-18.07828369583884, -12.17468734470334],
              [-18.076200177808577, -12.174958010417582],
              [-18.07396886916894, -12.17338143914406],
              [-18.073380712483218, -12.17219652667109],
              [-18.073285192109786, -12.17009723783662],
              [-18.07234367377984, -12.168460120522372],
              [-18.063966292938147, -12.165376625430474],
              [-18.062349388854013, -12.16594438318305],
              [-18.062002537930752, -12.167764877731601],
              [-18.060933055414708, -12.169025901104009],
              [-18.057289343825108, -12.168728634576448],
              [-18.056724284825467, -12.170657491492307],
              [-18.05496316440193, -12.173349275500275],
              [-18.05383435172491, -12.173737406378631],
              [-18.050955652243733, -12.17314904334399],
              [-18.048706028827187, -12.173697385034941],
              [-18.048468308820095, -12.175002969831706],
              [-18.04685645846882, -12.177186927310423],
              [-18.04528123374243, -12.177466197368531],
              [-18.043929069070394, -12.176916627824484],
              [-18.039165687870472, -12.178955790166848],
              [-18.038629201880678, -12.180302227443441],
              [-18.04101718555643, -12.181151039992463],
              [-18.041982105173727, -12.183560061386128],
              [-18.043541511169146, -12.18479974860274],
              [-18.043176300656533, -12.186018259137471],
              [-18.046401475287656, -12.186841897088724],
              [-18.0498440539278, -12.188235497404527],
              [-18.051054858313474, -12.190834115221733],
              [-18.052713225246833, -12.191092538763327],
              [-18.055388461868603, -12.192164917647428],
              [-18.056487497305447, -12.19187481524948],
              [-18.05889122842691, -12.19360430381402],
              [-18.059609327169618, -12.194669842449848],
              [-18.061274643499857, -12.19501776858634],
              [-18.06200107451137, -12.195856056460716],
              [-18.064261318119513, -12.195757582274434],
              [-18.066204842400644, -12.19610983578303],
              [-18.068861480127712, -12.197436558985379],
              [-18.070405069978193, -12.197337608450463],
              [-18.07309592322094, -12.194352644915487],
              [-18.076782300632754, -12.194137447072025],
              [-18.080020454566878, -12.192771192352755],
              [-18.08055473064188, -12.193824975448054],
              [-18.078229973818345, -12.19535917009586],
              [-18.07534195726465, -12.198154338322963],
              [-18.077462047466632, -12.200762074489216],
              [-18.07826980982935, -12.20243407678075],
              [-18.078475226452824, -12.204100054652255],
              [-18.079894760212017, -12.205914292536432],
              [-18.0788725898794, -12.206548057428597],
              [-18.076638825363766, -12.20467270112008],
              [-18.074238970144275, -12.20135571714033],
              [-18.070426346163963, -12.201101959661061],
              [-18.068058026571578, -12.201858945920241],
              [-18.066898437683253, -12.203369523092807],
              [-18.060087559242255, -12.204324557285675],
              [-18.060466525993824, -12.206546789535777],
              [-18.061571275298085, -12.208542047072568],
              [-18.06412281198824, -12.211739473191269],
              [-18.066109025312056, -12.213043155119],
              [-18.06848512738462, -12.213935768202315],
              [-18.068457404733625, -12.215254763863578],
              [-18.066906579557095, -12.215966916482193],
              [-18.064196151276686, -12.215276538717468],
              [-18.063303924060875, -12.215446878255774],
              [-18.060323671366675, -12.214523297943142],
              [-18.05631242668296, -12.211302985893646],
              [-18.05355464153775, -12.2112722405312],
              [-18.050908061078516, -12.209758900749422],
              [-18.04724703123614, -12.206878589897451],
              [-18.044979083949894, -12.205817313496299],
              [-18.043248356530228, -12.204472768970469],
              [-18.035686010687012, -12.197566402362252],
              [-18.03397867298919, -12.197787708730983],
              [-18.02905376150701, -12.197143775566891],
              [-18.02539999496174, -12.197812826451923],
              [-18.02944336972472, -12.199924864855879],
              [-18.03241889309081, -12.20051389121147],
              [-18.033159846192007, -12.201965137688935],
              [-18.033238508677822, -12.204273928188428],
              [-18.0318918171343, -12.204923484913657],
              [-18.032134255729687, -12.206178701282491],
              [-18.033989910878265, -12.20588373983026],
              [-18.035761496730302, -12.205003609966843],
              [-18.036912992419794, -12.205635760077021],
              [-18.037870880758785, -12.20721034089516],
              [-18.038862440933205, -12.212527355724568],
              [-18.04188745841402, -12.213112033520572],
              [-18.043284821583025, -12.21216317320509],
              [-18.04470444937369, -12.211916110112874],
              [-18.04766900407968, -12.21334320310155],
              [-18.048172234608774, -12.214310712541737],
              [-18.051894934298033, -12.214214215202768],
              [-18.052853338446056, -12.214698886610575],
              [-18.05337173632085, -12.216596202995014],
              [-18.05124352130339, -12.218409871351755],
              [-18.052170627197974, -12.219828152052699],
              [-18.054404673508824, -12.220323688655464],
              [-18.057431294595535, -12.218429901598604],
              [-18.060431053821244, -12.219989336116374],
              [-18.06226314476356, -12.22000954073918],
              [-18.067517053865092, -12.223062714546455],
              [-18.068878999745255, -12.222245937734234],
              [-18.071164421636254, -12.223485828506766],
              [-18.071566075950724, -12.224982514249671],
              [-18.069630595662066, -12.226607901539124],
              [-18.069272936414066, -12.229174349226144],
              [-18.0697536076928, -12.23144242127628],
              [-18.070946759704523, -12.23199973820718],
              [-18.071941530635854, -12.23368661862002],
              [-18.07609398803535, -12.230374749154839],
              [-18.076761085483845, -12.229300573281389],
              [-18.07717078202707, -12.226258122121509],
              [-18.07785844219225, -12.223424198749738],
              [-18.07684876821692, -12.22301597987945],
              [-18.076007472358597, -12.216391425470567],
              [-18.076787620419786, -12.211822442740115],
              [-18.077599476557115, -12.211497401933942],
              [-18.078881265211223, -12.21332196907414],
              [-18.07908088993494, -12.214898592316931],
              [-18.080092575053737, -12.21649092344458],
              [-18.079247777220754, -12.217703952620061],
              [-18.081131777898864, -12.220194089089073],
              [-18.08267643965837, -12.223820348899565],
              [-18.082654559609512, -12.23032226730415],
              [-18.083898840431594, -12.230196122985856],
              [-18.088741668489416, -12.227061265156848],
              [-18.089879604956216, -12.227759912342183],
              [-18.087714641288404, -12.230466557420465],
              [-18.08745926757494, -12.23171459632567],
              [-18.086198303794475, -12.233638878656702],
              [-18.08488038362169, -12.238136735574754],
              [-18.08342735021361, -12.238959217017307],
              [-18.083072859207554, -12.241257327198518],
              [-18.08164377906642, -12.245171673665771],
              [-18.082584624197896, -12.24911732159826],
              [-18.08253917281661, -12.25221652944672],
              [-18.08340727526648, -12.254391895029254],
              [-18.084973154134904, -12.253834809061278],
              [-18.087428672501172, -12.25167127596989],
              [-18.088341792407842, -12.251429486513818],
              [-18.088404528506288, -12.24928529908884],
              [-18.087284700004336, -12.248197476101986],
              [-18.08743544114905, -12.24666261539098],
              [-18.089440961525135, -12.245802317209305],
              [-18.08962217385778, -12.243652337874346],
              [-18.090802161621415, -12.242232309000427],
              [-18.0891442708188, -12.239724385559565],
              [-18.090250304799184, -12.238923978462743],
              [-18.0904356179237, -12.23654600378787],
              [-18.091685236358973, -12.23446279750471],
              [-18.09284575823955, -12.235478291339543],
              [-18.092771536550686, -12.237097962044981],
              [-18.094114700164063, -12.2387388249938],
              [-18.09501014476694, -12.238930181699347],
              [-18.097409652434603, -12.237702735145762],
              [-18.098543990568345, -12.235307523990018],
              [-18.10000792561257, -12.235665557964337],
              [-18.099733023908442, -12.238732181261746],
              [-18.102057016727414, -12.241103792326182],
              [-18.10174001627368, -12.242558707334766],
              [-18.09921446289118, -12.241974798800108],
              [-18.098231362947004, -12.24219902983571],
              [-18.09724793978278, -12.243766088192006],
              [-18.097181470057716, -12.245158650324305],
              [-18.095196360622158, -12.247702161996832],
              [-18.094806182700466, -12.249458162871964],
              [-18.094932527474644, -12.251293796650796],
              [-18.097483429502855, -12.252560666721953],
              [-18.1017514788826, -12.257130149013467],
              [-18.101581393789047, -12.258029723067372],
              [-18.09956441416933, -12.258117432919569],
              [-18.097916398402365, -12.261529768146948],
              [-18.094363991606475, -12.265683252766088],
              [-18.092712913817262, -12.265016510208438],
              [-18.092402979716084, -12.26287182619225],
              [-18.09551328755585, -12.258042842138204],
              [-18.09559257944666, -12.256830134782899],
              [-18.09394078980404, -12.25579978810568],
              [-18.092498293763505, -12.25612228655403],
              [-18.090846658508227, -12.25848538859062],
              [-18.089863609517337, -12.25839002797543],
              [-18.088729600494048, -12.259831073936644],
              [-18.085808100092216, -12.2599529765755],
              [-18.085656784182863, -12.260463896021818],
              [-18.088184810167284, -12.268890774435983],
              [-18.08648598995435, -12.270254962406675],
              [-18.087457706261027, -12.272563178109136],
              [-18.087626487068075, -12.273939330213752],
              [-18.088817662985196, -12.274412586949959],
              [-18.090404854472826, -12.27583727685525],
              [-18.091085575008197, -12.277617509818073],
              [-18.093761308177843, -12.275789073875433],
              [-18.093623002100138, -12.274212960104208],
              [-18.09488325877919, -12.273163576097865],
              [-18.09496633811179, -12.27038510260418],
              [-18.096301978184083, -12.269499432128393],
              [-18.098009906439486, -12.265474777890208],
              [-18.099699447619034, -12.26444317766941],
              [-18.100945215544304, -12.26160337863477],
              [-18.10415577776498, -12.261276724973277],
              [-18.10478544060104, -12.263308754473627],
              [-18.104237156544496, -12.26747075278149],
              [-18.105070458490708, -12.26907972563473],
              [-18.10342695745754, -12.27021496333184],
              [-18.102955066594884, -12.271840786078007],
              [-18.103622307051833, -12.275378623546683],
              [-18.10359865233027, -12.278014579139056],
              [-18.104717782534205, -12.280758362235058],
              [-18.106298949545078, -12.281383736278915],
              [-18.10733449308583, -12.280196784992484],
              [-18.108470605288122, -12.276447880460811],
              [-18.110105412802543, -12.272849071534713],
              [-18.112424374043183, -12.270390667478994],
              [-18.111924901553905, -12.268577171115009],
              [-18.113856805930347, -12.266920337486047],
              [-18.114557380436466, -12.265300241793161],
              [-18.114920299653754, -12.262529184263897],
              [-18.113463471871814, -12.25933412485812],
              [-18.11053974289917, -12.26076050002209],
              [-18.1060582807179, -12.257869226296323],
              [-18.10374279820439, -12.25533509829095],
              [-18.100833478527203, -12.25092760372293],
              [-18.101648555697874, -12.250281513149337],
              [-18.104499701702025, -12.25184573281586],
              [-18.10748236631858, -12.25494974143497],
              [-18.11085806491399, -12.256341752165227],
              [-18.11297952206162, -12.256085679404752],
              [-18.11686714534056, -12.258125319618538],
              [-18.119196355931287, -12.258173519016617],
              [-18.11957444423674, -12.259902439501165],
              [-18.12174667523713, -12.258388276886459],
              [-18.122295607764954, -12.256299653574278],
              [-18.121916597009022, -12.253569783856369],
              [-18.12003273580656, -12.251920438471469],
              [-18.120766927608194, -12.250800383971074],
              [-18.120642739087476, -12.249373815122238],
              [-18.119834406475064, -12.248791000280454],
              [-18.116980276970846, -12.247868002325133],
              [-18.11456298023327, -12.247529882975211],
              [-18.11257219710284, -12.247640925090927],
              [-18.111788601424184, -12.246076925601596],
              [-18.113152279279223, -12.244983712318577],
              [-18.11710890899974, -12.245081704241182],
              [-18.118671852773222, -12.245499743811264],
              [-18.120880349317435, -12.244530881889636],
              [-18.120714736463206, -12.240558620335761],
              [-18.120050166592563, -12.239374879491365],
              [-18.118864711832508, -12.23870389177747],
              [-18.118326231032057, -12.237329578498114],
              [-18.11902045579096, -12.235985903173084],
              [-18.118668830785918, -12.23364379177473],
              [-18.116594887462895, -12.232873705343229],
              [-18.11588735481795, -12.231397715533971],
              [-18.11443589594605, -12.231222551375527],
              [-18.112258962372287, -12.232938256271849],
              [-18.111227857053876, -12.234781722073837],
              [-18.11027336150678, -12.235072964353652],
              [-18.1103527767259, -12.232565540856445],
              [-18.110865186342664, -12.232258601363224],
              [-18.111475553348928, -12.229715840891238],
              [-18.11009805309539, -12.228603112938508],
              [-18.11089793338675, -12.226776170671354],
              [-18.10991701617576, -12.223045617851099],
              [-18.10820036691535, -12.222046750642674],
              [-18.107802403696223, -12.220005393277798],
              [-18.102462814480855, -12.218907009649913],
              [-18.100279494206323, -12.219847481813522],
              [-18.099474668085854, -12.220945928799344],
              [-18.098051410946574, -12.219813064276632],
              [-18.098959543524824, -12.216526966966898],
              [-18.10063197070657, -12.214576104485921],
              [-18.102991060402623, -12.213510818461986],
              [-18.10315862644617, -12.212591141072199],
              [-18.099746252963804, -12.212499898174482],
              [-18.09896072276196, -12.21153014163548],
              [-18.102898971535335, -12.210859685896596],
              [-18.102587092169962, -12.21004022900445],
              [-18.098931643144333, -12.210441913497572],
              [-18.096035003716835, -12.210429220885308],
              [-18.09552408627026, -12.211416776861197],
              [-18.094156103665917, -12.212074532851288],
              [-18.091712468504063, -12.211576777191006],
              [-18.091085353287088, -12.209869663258466],
              [-18.094098372615207, -12.207877792308695],
              [-18.095303925487766, -12.208229885777952],
              [-18.098506606266913, -12.207654860388566],
              [-18.099857068299972, -12.207088400496938],
              [-18.10266643943889, -12.206856385925404],
              [-18.102863838315354, -12.206366643115661],
              [-18.106185639406046, -12.20650801832147],
              [-18.109279437329057, -12.207027500979287],
              [-18.111245387917897, -12.20830339747931],
              [-18.117141125566015, -12.207156573909966],
              [-18.120689469374923, -12.204282092429008],
              [-18.123146598249065, -12.203660925092036],
              [-18.123655455493164, -12.204625243959788],
              [-18.12227518498812, -12.206058902043514],
              [-18.121756318850238, -12.208205801023363],
              [-18.12025436482645, -12.208262519607398],
              [-18.11735719634159, -12.210207429604386],
              [-18.116374376590024, -12.212363385942801],
              [-18.11540426833426, -12.21306483900111],
              [-18.113577401584834, -12.213120020844363],
              [-18.111999284644337, -12.212431305221127],
              [-18.109699040805367, -12.213335339884363],
              [-18.11022538438832, -12.215548743631057],
              [-18.11263984590774, -12.216590736792444],
              [-18.112868257398326, -12.217529582387312],
              [-18.114868564409708, -12.218281090168661],
              [-18.11521570831513, -12.219257558696379],
              [-18.11683927243378, -12.2199205342428],
              [-18.11688032776867, -12.223122345767509],
              [-18.11723104385869, -12.224675682567545],
              [-18.118999291363426, -12.226184624367937],
              [-18.122925886346405, -12.230830270380075],
              [-18.1264996333345, -12.231473791293965],
              [-18.127412946167343, -12.233208551053327],
              [-18.12903412802237, -12.233802990117612],
              [-18.131370498894658, -12.232391764719734],
              [-18.132237368732746, -12.233469825254813],
              [-18.133101100076598, -12.232568924101706],
              [-18.133325156453292, -12.231165648215342],
              [-18.1314532946836, -12.230634599183848],
              [-18.12838627034493, -12.225727852804622],
              [-18.129934455740287, -12.223052715624648],
              [-18.130193282738013, -12.221489066517078],
              [-18.133373508789628, -12.221202295854482],
              [-18.134264536198238, -12.220049994197508],
              [-18.13566075723648, -12.220112739644264],
              [-18.137438219010807, -12.219035339640307],
              [-18.143029181450114, -12.218420661784364],
              [-18.142434050431742, -12.21980306749431],
              [-18.141024621868958, -12.219559945280128],
              [-18.13965111487875, -12.220768850730364],
              [-18.13733948252744, -12.2218381257855],
              [-18.136321363063843, -12.223159078632408],
              [-18.134360380529927, -12.22395357979247],
              [-18.13389765736231, -12.225258702080302],
              [-18.134520238091806, -12.22617078296334],
              [-18.13372138088936, -12.228932256639087],
              [-18.13629707713682, -12.230210390858193],
              [-18.137208675922544, -12.231262070762334],
              [-18.137541051885158, -12.232968334300528],
              [-18.139596453630972, -12.234100143284655],
              [-18.139821895325536, -12.235927736448803],
              [-18.138301627800438, -12.236101196927063],
              [-18.137052760587085, -12.235208849919397],
              [-18.134667514915318, -12.237876623969234],
              [-18.133120767543197, -12.238005625393932],
              [-18.132857051797107, -12.239184247119194],
              [-18.131064363599034, -12.242038813593515],
              [-18.13237487825875, -12.242495207737198],
              [-18.134226205518697, -12.244007147430407],
              [-18.13506538857638, -12.245657178080915],
              [-18.134560679134196, -12.246716729310087],
              [-18.133032389904272, -12.247117658609469],
              [-18.13335566475991, -12.249490139918116],
              [-18.13399627264809, -12.251470009236279],
              [-18.135780561744117, -12.253648243774286],
              [-18.138317579589962, -12.253678403060057],
              [-18.139065369183914, -12.255016535473988],
              [-18.14031991191647, -12.25531746186951],
              [-18.142973138983187, -12.255019774196066],
              [-18.14557170146836, -12.253335208144819],
              [-18.147045965252214, -12.254417781542472],
              [-18.146991402244023, -12.258136030190343],
              [-18.14541548865526, -12.260137674570542],
              [-18.142169586363927, -12.259975253023217],
              [-18.140629810922356, -12.260241430032913],
              [-18.139531255668114, -12.26113782123056],
              [-18.138392610143974, -12.260190609768973],
              [-18.135618274762464, -12.259789117263406],
              [-18.133510139797202, -12.261240463608852],
              [-18.133900412731965, -12.262756427507345],
              [-18.132282040917815, -12.26485084105908],
              [-18.131108082654045, -12.265683635523352],
              [-18.131481665994833, -12.267322612739607],
              [-18.131304733639727, -12.26972900229768],
              [-18.130705090325975, -12.270134876990113],
              [-18.13258012881139, -12.275504257954722],
              [-18.13177617955104, -12.276602730233904],
              [-18.13190181770482, -12.27774126822835],
              [-18.135952983851134, -12.278353701760206],
              [-18.13701605183136, -12.276614837282173],
              [-18.138981406418424, -12.276730463760567],
              [-18.14245629027958, -12.277745858364423],
              [-18.142688992898822, -12.279669530466359],
              [-18.14193487965469, -12.280520776966197],
              [-18.138931809912513, -12.280887603307352],
              [-18.137925903035057, -12.281482025435462],
              [-18.136928881060406, -12.28317103449171],
              [-18.13518277052876, -12.284820711399716],
              [-18.13516558945853, -12.286853809688816],
              [-18.136456281688748, -12.286970839971085],
              [-18.138249321415568, -12.288880206766432],
              [-18.14051831288022, -12.288655282599558],
              [-18.142405610277233, -12.286378382985896],
              [-18.14361467153665, -12.284079791675143],
              [-18.143625039025267, -12.28293776523382],
              [-18.145546820092555, -12.282758930016785],
              [-18.14665982771617, -12.283320814190407],
              [-18.14762873507667, -12.28606199531316],
              [-18.14923930179578, -12.28704594994093],
              [-18.1500894307005, -12.286552856597893],
              [-18.151279558032737, -12.2875205621785],
              [-18.15177485160195, -12.286321321771979],
              [-18.154163509759524, -12.284236154290456],
              [-18.153353872858165, -12.281141938631691],
              [-18.152129416546046, -12.279697931652477],
              [-18.14726507266942, -12.279146904066746],
              [-18.146610870381924, -12.278804135399193],
              [-18.147745590671445, -12.276785413933883],
              [-18.149116526501395, -12.276735616260703],
              [-18.14963638916466, -12.27587791364392],
              [-18.14941443341515, -12.274113464956299],
              [-18.14994884392594, -12.272821136616079],
              [-18.148949085152534, -12.271248204748384],
              [-18.147118440130747, -12.271056410489413],
              [-18.14712346550884, -12.269527729898636],
              [-18.14874348049666, -12.26747597656937],
              [-18.14928776850285, -12.266001299570659],
              [-18.150774919291823, -12.265646523134247],
              [-18.152024261078424, -12.26779549007495],
              [-18.152944545488275, -12.26761916611957],
              [-18.154476279118374, -12.266276928830075],
              [-18.155740592209064, -12.264158479750433],
              [-18.157183327888315, -12.264467663063522],
              [-18.157350299062234, -12.26641731176767],
              [-18.15704192850915, -12.270134093204993],
              [-18.15820822274819, -12.271421153698151],
              [-18.158562043631303, -12.273061622227566],
              [-18.16052981131241, -12.274155392170488],
              [-18.161383690803227, -12.275304584785326],
              [-18.164452140493196, -12.27426601487857],
              [-18.16562665662348, -12.273452516590957],
              [-18.16571032343682, -12.270502951933782],
              [-18.16772913561678, -12.269150321673308],
              [-18.16718249258248, -12.267752003369814],
              [-18.167755132868784, -12.266684703966282],
              [-18.167401208860152, -12.264748036769474],
              [-18.170016055756726, -12.264219813845056],
              [-18.171615173514112, -12.264744286010469],
              [-18.172244809340608, -12.265999549992973],
              [-18.174034893323537, -12.267513701316163],
              [-18.173811978943576, -12.27000894650752],
              [-18.17437128988396, -12.271687998442312],
              [-18.180446958257104, -12.279651967837847],
              [-18.180781361896365, -12.280997752418692],
              [-18.183932393093084, -12.286275235120039],
              [-18.18542183870764, -12.289617524170245],
              [-18.18646869328701, -12.293884256436382],
              [-18.186137292145844, -12.29628558629442],
              [-18.18702833488964, -12.29756989465323],
              [-18.188661619893082, -12.29786313541313],
              [-18.18793064790805, -12.294692559477546],
              [-18.18713308063186, -12.293104560520584],
              [-18.191599108717988, -12.29106606997288],
              [-18.193499196270153, -12.290584976927287],
              [-18.197421180657507, -12.290298315531972],
              [-18.199487835768462, -12.29046678213717],
              [-18.20397357109179, -12.291736771129012],
              [-18.206230231054832, -12.294656505485287],
              [-18.205871202337566, -12.296351974608411],
              [-18.204686098054108, -12.298543338633353],
              [-18.205055696258707, -12.30000267121643],
              [-18.205011088672656, -12.30275078770819],
              [-18.20582884721535, -12.304566330119947],
              [-18.207436178108413, -12.303898672967106],
              [-18.208886843000712, -12.304161127396966],
              [-18.210965726551194, -12.303317008195434],
              [-18.21197355346968, -12.300954605948736],
              [-18.213938910369325, -12.297697827159835],
              [-18.21569376837628, -12.295646034397619],
              [-18.21603393345313, -12.29417066778959],
              [-18.21760544601465, -12.292324820461765],
              [-18.22059772285305, -12.29207815281528],
              [-18.223263633657975, -12.293021106990155],
              [-18.230047595507806, -12.29642021678904],
              [-18.233422783840144, -12.29598139571984],
              [-18.235932650800347, -12.29787224424854],
              [-18.23689883216402, -12.299148543472562],
              [-18.237738990865545, -12.302356283704817],
              [-18.23874236370756, -12.302920534388635],
              [-18.23922843598164, -12.301475585143683],
              [-18.24142555573339, -12.299946864892663],
              [-18.24466613599386, -12.29869173252346],
              [-18.246611198435254, -12.298473976144422],
              [-18.250361670857313, -12.298619818004068],
              [-18.255613606213224, -12.299700819295284],
              [-18.259547355546488, -12.301121183605206],
              [-18.26046072897942, -12.302390778054189],
              [-18.26143252390586, -12.30570322339826],
              [-18.26076266888943, -12.307254773217007],
              [-18.26206352900475, -12.308561703541171],
              [-18.26708104228799, -12.311559297126443],
              [-18.26845552355533, -12.310351912665304],
              [-18.26825393415498, -12.308466893623237],
              [-18.266875400322643, -12.306491088044945],
              [-18.26874909869477, -12.304535260446073],
              [-18.271184366081847, -12.303725622579757],
              [-18.272845121569357, -12.303732178978779],
              [-18.275546825291684, -12.304732665866151],
              [-18.2763444560761, -12.305764517225203],
              [-18.278407246354725, -12.305948793754576],
              [-18.28014477226683, -12.307436903893132],
              [-18.280760972531443, -12.309220289634139],
              [-18.284037536388425, -12.31035725059651],
              [-18.2846591455072, -12.31275927187644],
              [-18.284259611528114, -12.314142885017572],
              [-18.28482563811898, -12.317558281149378],
              [-18.28586272711613, -12.31848396404834],
              [-18.28648637816244, -12.321185112687639],
              [-18.2861095251307, -12.32389797672053],
              [-18.286766617074406, -12.326780771906703],
              [-18.28671594374076, -12.328137850579386],
              [-18.28586912871993, -12.330063491953368],
              [-18.28678517387898, -12.330931086075887],
              [-18.287687338669347, -12.333313775933812],
              [-18.289659732223555, -12.333913516520653],
              [-18.29266478273582, -12.331084445646837],
              [-18.293485377346872, -12.329225326779957],
              [-18.293476282435904, -12.326886314665174],
              [-18.294278670237503, -12.325285062311384],
              [-18.295780452523964, -12.324201380445718],
              [-18.297302105064468, -12.322244237048816],
              [-18.298779787532943, -12.318112881971452],
              [-18.298407007547425, -12.316194495718529],
              [-18.29872793944043, -12.313899648029793],
              [-18.297283670776963, -12.312320085669498],
              [-18.296693507836565, -12.310655433697375],
              [-18.296867230780204, -12.309604131172751],
              [-18.295694903993045, -12.307637011547568],
              [-18.296089315374857, -12.305932816970449],
              [-18.297447992971726, -12.303464511641588],
              [-18.29497408723645, -12.300755525655546],
              [-18.294347053999132, -12.29831047037603],
              [-18.293257888491233, -12.296025508068604],
              [-18.29566520221447, -12.29481660360653],
              [-18.29810112763806, -12.294048051995594],
              [-18.300700566580723, -12.294041130247694],
              [-18.30379213658664, -12.29582991568731],
              [-18.308749728223066, -12.298036544914948],
              [-18.309215102226023, -12.30006732724999],
              [-18.31237661992715, -12.304885674265432],
              [-18.310363948254498, -12.307341069643911],
              [-18.30880421579245, -12.304696153068981],
              [-18.307319102567767, -12.303740581539287],
              [-18.306573757409694, -12.304328203204722],
              [-18.308789314891555, -12.306988261147898],
              [-18.309768724908114, -12.311055895252592],
              [-18.308041194781218, -12.313029922199263],
              [-18.306202663765237, -12.313706742974922],
              [-18.305852021597357, -12.31756334084865],
              [-18.305095811077276, -12.321063910913344],
              [-18.305368774632484, -12.324550563265394],
              [-18.30484897563173, -12.325326693914885],
              [-18.306076390517678, -12.327360288013846],
              [-18.304925852001194, -12.332799642783824],
              [-18.305429324717498, -12.335191698102264],
              [-18.304831131042125, -12.338614315131748],
              [-18.305288188541432, -12.341263825571136],
              [-18.305905983650405, -12.34187379431367],
              [-18.30732269028717, -12.34477333532452],
              [-18.30726499147901, -12.345850473897098],
              [-18.30938936309251, -12.348096878964846],
              [-18.311207881662877, -12.349051608012653],
              [-18.311318856336303, -12.350352309559037],
              [-18.31236259886887, -12.351025522960239],
              [-18.31368786060054, -12.350871788565245],
              [-18.31516319192639, -12.352198789236029],
              [-18.316474059066387, -12.354068272004076],
              [-18.31845336605309, -12.35769912641998],
              [-18.31838474445581, -12.359636333569597],
              [-18.314566484726818, -12.362523772672844],
              [-18.315129104556377, -12.363880891130437],
              [-18.31483390123456, -12.365100938002172],
              [-18.31599412278917, -12.367122415444218],
              [-18.315831320362445, -12.368792090911526],
              [-18.31673692912068, -12.370305834788219],
              [-18.31619293664491, -12.372743439410499],
              [-18.3145405402549, -12.373223286412502],
              [-18.316374709037504, -12.374592640581584],
              [-18.31700702609851, -12.378132031778854],
              [-18.31778653807606, -12.379541963633718],
              [-18.31946044849296, -12.380947708472254],
              [-18.321776300402895, -12.382151055564558],
              [-18.319420949006478, -12.35473870095764],
              [-18.314477600932022, -12.297409330882983],
              [-18.37437353106942, -12.29236249586944],
              [-18.371691795199414, -12.262784848594817],
              [-18.359695352389693, -12.26381751392137],
              [-18.349076040582155, -12.145441244270247],
              [-18.367171797615683, -12.143878700834714],
              [-18.361780127896814, -12.084663474278146],
              [-18.301807874366602, -12.089746190327649],
              [-18.299253518110536, -12.060118975021553],
              [-18.239399923423633, -12.064915066744584],
              [-18.236987607049453, -12.035271506197393],
              [-18.193958365790785, -12.038548338721311],
              [-18.191648704066235, -12.008891883017302],
              [-18.16157497977624, -12.011097341365094],
              [-18.160194510652072, -11.992950355697298]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -156.18891807599928,
          "lat": 58.65491720458001
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02164"],
        "coty_name": ["Lake and Peninsula"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Lake and Peninsula Borough"],
        "coty_fp_code": "164",
        "coty_gnis_code": "01419975"
      },
      "bbox": [
        -18.37437353106942, -12.382151055564558, -17.12174809641521,
        -10.610396921274306
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.200279177645326, -3.2289222621668143],
            [-12.19854790546151, -3.2317507669876075],
            [-12.198551950453169, -3.2388835119006707],
            [-12.192169630873245, -3.236435395750582],
            [-12.190715955498225, -3.230990041696091],
            [-12.186037698604627, -3.2283954088708815],
            [-12.18329953763911, -3.234729992115039],
            [-12.179355610793333, -3.2336951191890297],
            [-12.174360253880847, -3.2271932364693146],
            [-12.17243771018688, -3.2272698352815503],
            [-12.170687303079461, -3.2189332404319146],
            [-12.172184861677145, -3.2098172987012257],
            [-12.168793408959726, -3.2070304394401066],
            [-12.165954006083886, -3.2116859326590865],
            [-12.1614256096831, -3.2095947881583977],
            [-12.159960846026202, -3.212404107560093],
            [-12.163883194710255, -3.2142818395617296],
            [-12.161662898756017, -3.217544861439953],
            [-12.164785692922234, -3.2217777102830687],
            [-12.162347651451723, -3.222983360591804],
            [-12.166807408671096, -3.2381798561491544],
            [-12.173300625023451, -3.2390275888927618],
            [-12.174234384793237, -3.24161681313517],
            [-12.18131090114478, -3.2413550868074297],
            [-12.18868634185869, -3.2434987305066736],
            [-12.19068787481186, -3.248317210782229],
            [-12.184062155699333, -3.2497978402259973],
            [-12.177011503441937, -3.249528098213002],
            [-12.173935684604604, -3.246959797838834],
            [-12.166203796467485, -3.2519153718333844],
            [-12.16068985248177, -3.248634560670591],
            [-12.152730334547215, -3.2465761188760296],
            [-12.142794088568708, -3.247479903239523],
            [-12.141546055427625, -3.249717403058135],
            [-12.136330065264417, -3.251245085212175],
            [-12.142138177050063, -3.2553094124571444],
            [-12.145591628852241, -3.256397097444985],
            [-12.150343050140721, -3.2553632851673613],
            [-12.153858995301897, -3.2565974369843262],
            [-12.157026198708573, -3.261500330769179],
            [-12.163762130011069, -3.262946684204354],
            [-12.167822823336765, -3.265624763812102],
            [-12.171699572008663, -3.261400258510856],
            [-12.174657707419273, -3.2603640410427706],
            [-12.177448257449978, -3.267376320795344],
            [-12.177195758248423, -3.274861465465829],
            [-12.182425527813383, -3.2750843535825704],
            [-12.187373436505016, -3.273639752779763],
            [-12.187184474892502, -3.2807269230731695],
            [-12.19195007808362, -3.2795018123084096],
            [-12.195539468851727, -3.2749032608826423],
            [-12.197684916939965, -3.2780443176161325],
            [-12.204388544336549, -3.2809064899727125],
            [-12.20193946016533, -3.2861661566305416],
            [-12.199192214047148, -3.285347877105722],
            [-12.196189571562496, -3.2899813934842435],
            [-12.18618156935577, -3.2926171271786933],
            [-12.175379759279698, -3.2901855968314346],
            [-12.171141402509251, -3.284225395590306],
            [-12.163097863215851, -3.286465965944689],
            [-12.160846569131214, -3.2897148407770223],
            [-12.157623753209391, -3.285878959860002],
            [-12.157439471102691, -3.278825081606911],
            [-12.152500598790123, -3.2795053362833304],
            [-12.149693724560883, -3.2783423397930664],
            [-12.139720047192569, -3.281260317666875],
            [-12.13894579049763, -3.2849720320121203],
            [-12.147022896415622, -3.2828264010056354],
            [-12.149247260517717, -3.2872058611091535],
            [-12.149457645484537, -3.294806965057242],
            [-12.145782662930866, -3.2975840686078466],
            [-12.13915592362659, -3.297584492617133],
            [-12.137685056400588, -3.2996500200343406],
            [-12.133819872350726, -3.290331079996049],
            [-12.13159016796917, -3.287694069898455],
            [-12.126156149260204, -3.286624119146233],
            [-12.121538061582514, -3.280610787852955],
            [-12.116089242926298, -3.2812181915799288],
            [-12.116005142257192, -3.273813805393187],
            [-12.110639873243976, -3.2776696044197813],
            [-12.107370569777926, -3.276106639995764],
            [-12.10840779163042, -3.2701209973199963],
            [-12.102861565584163, -3.2715236808613195],
            [-12.101044478249882, -3.269335501946938],
            [-12.095612573842665, -3.2749592559443146],
            [-12.089665361124014, -3.2764865948952964],
            [-12.08325207978964, -3.27500170620707],
            [-12.079848175106381, -3.278994861591708],
            [-12.08532339527957, -3.280617908460558],
            [-12.086739286947427, -3.2916059175511942],
            [-12.089694734544544, -3.2900445001649024],
            [-12.090731014259951, -3.2860461408499355],
            [-12.096115583921508, -3.2837725481911084],
            [-12.099218079579163, -3.285400958837065],
            [-12.100974805467702, -3.289454978861735],
            [-12.104173011936558, -3.2921046755962102],
            [-12.104914982884148, -3.298681116430259],
            [-12.10388034957739, -3.3094799100843733],
            [-12.107985150136109, -3.322664767575255],
            [-12.112110316788424, -3.325703096549544],
            [-12.10920729607737, -3.3290644190161056],
            [-12.10484757467525, -3.3298472765633536],
            [-12.105399213514008, -3.338004166512156],
            [-12.099515155258768, -3.3366721402861548],
            [-12.09884705025873, -3.341197297197692],
            [-12.096668169083552, -3.3426195932834144],
            [-12.090836655526097, -3.341527111590782],
            [-12.085752416160863, -3.3360676717403406],
            [-12.08074206232629, -3.334112552769726],
            [-12.079822221801376, -3.3282274269914085],
            [-12.076523535482549, -3.3245827993994665],
            [-12.090245866946699, -3.3223931612099316],
            [-12.092053000859043, -3.315677293029289],
            [-12.094923944946691, -3.3111797135340626],
            [-12.086316670295275, -3.309673708401524],
            [-12.083001248671986, -3.2985821135718973],
            [-12.080660287343633, -3.295091262095583],
            [-12.077583402167656, -3.297837587419527],
            [-12.07357434557019, -3.297730742009468],
            [-12.07225503148807, -3.2933256554282297],
            [-12.06752164125719, -3.2905824632176985],
            [-12.065029921287566, -3.2926588221346336],
            [-12.06249043735023, -3.2876785102189747],
            [-12.057818824239591, -3.284978778113684],
            [-12.052081977313547, -3.28694493967543],
            [-12.049507931493546, -3.2893451803384472],
            [-12.046645988676731, -3.286495046081576],
            [-12.041593361567624, -3.287336518712159],
            [-12.04373558046912, -3.290781100694067],
            [-12.043309445370069, -3.296403372546104],
            [-12.046034818386909, -3.302215399585174],
            [-12.035183852714448, -3.3039392498971623],
            [-12.03278434806718, -3.3068874029472752],
            [-12.028159240480367, -3.304860556151745],
            [-12.026812613116089, -3.307285676262055],
            [-12.02232435669384, -3.308122667868815],
            [-12.018616478082748, -3.3034484230646295],
            [-12.013620605462082, -3.302825779450837],
            [-12.010748746310972, -3.304540701158265],
            [-12.007504654790322, -3.2998427724701545],
            [-12.000043874676662, -3.3006508527744542],
            [-11.997750788921348, -3.2972135478190525],
            [-11.991620495500124, -3.2994527571307564],
            [-11.989378873016362, -3.295875402967943],
            [-11.983039290611314, -3.296815328151312],
            [-11.977792907443217, -3.29425831794302],
            [-11.9723027672709, -3.293761076682484],
            [-11.9687115478098, -3.2961861516665882],
            [-11.966470597280942, -3.2916804420682726],
            [-11.963645968252653, -3.292976128862575],
            [-11.960800979537735, -3.2878400098502745],
            [-11.957978420198483, -3.2872001955984222],
            [-11.955064712521777, -3.290251249385612],
            [-11.954225175540362, -3.295277243604955],
            [-11.955776130750532, -3.3028122951440477],
            [-11.953103734315448, -3.302963552216501],
            [-11.952721976103781, -3.3103783524350288],
            [-11.949729615571256, -3.3123834380592014],
            [-11.9455668625556, -3.3112152566180475],
            [-11.939318070221377, -3.3184416077698433],
            [-11.940557397234388, -3.32740177671892],
            [-11.9348234900359, -3.3271366774478373],
            [-11.935278420417267, -3.332056084372644],
            [-11.932762776925149, -3.332233206228218],
            [-11.929304900563178, -3.3361459837442977],
            [-11.922279363759216, -3.3384588495825964],
            [-11.920276802194067, -3.341879882603309],
            [-11.91156986125058, -3.338869549315853],
            [-11.906713646738554, -3.3410541129191342],
            [-11.903198174911006, -3.3443101267650297],
            [-11.902283934657508, -3.3479663221334923],
            [-11.893397441851436, -3.3480864144019087],
            [-11.89346837058738, -3.3520917428765147],
            [-11.889927003697027, -3.3534380530642744],
            [-11.887719385408245, -3.358736535941768],
            [-11.886632575680753, -3.3685105144531096],
            [-11.889200787118128, -3.3736802534135855],
            [-11.885676876547318, -3.378077696673733],
            [-11.879565564136923, -3.3695647625815077],
            [-11.87712716699785, -3.368252816042271],
            [-11.872000005330449, -3.369040138206604],
            [-11.869484554707805, -3.3656286920937206],
            [-11.862249234364784, -3.3742538235514474],
            [-11.860479529525971, -3.372642715382326],
            [-11.855309784024586, -3.3731707329849545],
            [-11.855989245879712, -3.368041926041633],
            [-11.847128002354344, -3.369413008176724],
            [-11.841573944086825, -3.367134974868963],
            [-11.835417092951541, -3.366363310451222],
            [-11.835344022657564, -3.3712379306957936],
            [-11.82999587818916, -3.373329495395566],
            [-11.827589882427372, -3.375932185679372],
            [-11.828460749785343, -3.381128707106617],
            [-11.825486168338438, -3.3848012952083555],
            [-11.82125065471246, -3.383931535074055],
            [-11.816829575452319, -3.3873556074988236],
            [-11.814616717386926, -3.384321502123829],
            [-11.810976154179468, -3.3867637540646105],
            [-11.808800046999625, -3.393603487592114],
            [-11.805512086407486, -3.3914772672811755],
            [-11.802895746042834, -3.387202956919656],
            [-11.800236392325548, -3.389535144000337],
            [-11.800247452503278, -3.3940910812515552],
            [-11.803327386235832, -3.399455173989852],
            [-11.808178567382138, -3.4019223126625033],
            [-11.810312406315804, -3.406520922373017],
            [-11.814232283364937, -3.406004007683716],
            [-11.817623327304636, -3.4092200306592866],
            [-11.81400082020523, -3.4129756788844214],
            [-11.812711359536555, -3.4187383354869314],
            [-11.807452518415257, -3.4239687968491537],
            [-11.800083422258343, -3.4270864592716834],
            [-11.795231003337836, -3.4223112803975293],
            [-11.79733914871016, -3.419172818556483],
            [-11.792133717351714, -3.415221881929214],
            [-11.796025389837133, -3.40682838114586],
            [-11.790575234427925, -3.404492540949433],
            [-11.786997475593623, -3.39675280350293],
            [-11.784431911326546, -3.3967473127285905],
            [-11.785958393831217, -3.4068960652763125],
            [-11.779401689045375, -3.4109841752619103],
            [-11.774691532193097, -3.4108821449870668],
            [-11.7737790121639, -3.4151289888555323],
            [-11.77526862210368, -3.4200179861379323],
            [-11.771013848088206, -3.4222965872231246],
            [-11.769264168034676, -3.42581123122007],
            [-11.770563131529444, -3.4285278384457953],
            [-11.764483932323492, -3.4313228837338494],
            [-11.756841790506744, -3.438187677663455],
            [-11.754363911710637, -3.438525696785281],
            [-11.75047093950568, -3.4484571402225845],
            [-11.750862470390512, -3.4518566188010595],
            [-11.744907533270938, -3.4598037769686814],
            [-11.744143731505522, -3.4629318700540153],
            [-11.73918102668204, -3.463573211857683],
            [-11.738332978793114, -3.459625762549289],
            [-11.733368597437712, -3.461774622750958],
            [-11.730167793949128, -3.469204753081835],
            [-11.724514198804078, -3.46930044934998],
            [-11.719098215359624, -3.470934960544044],
            [-11.717226633213356, -3.4740909594015488],
            [-11.712017318377343, -3.4779208516716373],
            [-11.708755589568444, -3.4780000693707906],
            [-11.704825512879493, -3.4831093087767884],
            [-11.701361629508026, -3.4842233471206296],
            [-11.695899978855186, -3.4828035755357347],
            [-11.695621223161732, -3.4899322971707605],
            [-11.688965100861793, -3.494012826018343],
            [-11.688419375466122, -3.4971675050624706],
            [-11.691793141284197, -3.4998540542130825],
            [-11.690337295796244, -3.504180823939891],
            [-11.684290705208841, -3.5117636656548896],
            [-11.67160897682693, -3.5197779797935262],
            [-11.667881592707106, -3.5195863343459655],
            [-11.661868270868306, -3.5240544732801844],
            [-11.651565945726867, -3.5235206319039376],
            [-11.647787465566822, -3.520118113003396],
            [-11.647008300803117, -3.516538799587488],
            [-11.64898497367487, -3.5120622835204545],
            [-11.645449397187623, -3.5093761045956184],
            [-11.636116266559487, -3.5068125310149014],
            [-11.638431259685323, -3.499031490721341],
            [-11.652985194261285, -3.4865951260667005],
            [-11.647569494714684, -3.4839193628438228],
            [-11.644800293837644, -3.490324318097472],
            [-11.634304208144984, -3.495544592246316],
            [-11.632690633593567, -3.495103241027598],
            [-11.627417255455674, -3.50045394578027],
            [-11.62323976583645, -3.48800168918126],
            [-11.621156429614944, -3.4875624913593284],
            [-11.620394429421808, -3.499150612910033],
            [-11.614718615865547, -3.4989768171408397],
            [-11.612269650764066, -3.4932524776885843],
            [-11.606541078705817, -3.4905324482463125],
            [-11.6058144501908, -3.496350860694972],
            [-11.601531631755101, -3.5011392014614082],
            [-11.590337887738398, -3.5095758591648614],
            [-11.588333889699566, -3.5145353403918076],
            [-11.586932622558704, -3.5234458927802166],
            [-11.590562890552336, -3.526115536056733],
            [-11.591533770684439, -3.529188484392058],
            [-11.596463733921844, -3.5341982392720532],
            [-11.597455488259945, -3.542506451620032],
            [-11.593978167995576, -3.542859593230778],
            [-11.583590317117993, -3.5402814283509474],
            [-11.624594125644585, -3.8018519411037097],
            [-11.450555571204172, -3.8288208889120776],
            [-11.33254587461579, -3.8468803946809906],
            [-11.219451841605718, -3.8640137169818103],
            [-11.071741528158942, -3.8861375866443213],
            [-11.014524336784643, -3.8946296404463334],
            [-11.032333612299466, -4.014383291129689],
            [-11.046492945109101, -4.109590474828004],
            [-11.054890760142264, -4.1660442556272494],
            [-11.077073262772249, -4.31514715414844],
            [-11.093479033393013, -4.425406577218941],
            [-11.232071552426566, -4.4053122406337115],
            [-11.231279665170339, -4.410739356500374],
            [-11.232999884497541, -4.412486784212525],
            [-11.233707830955147, -4.419038387940364],
            [-11.240424897827964, -4.421308242421419],
            [-11.24309049375248, -4.419452005854791],
            [-11.247564837567905, -4.420655379615078],
            [-11.24953330167045, -4.417017150396056],
            [-11.253494534954116, -4.418723526963212],
            [-11.253267134341423, -4.426174728107415],
            [-11.257483465437975, -4.424181854152473],
            [-11.26131846760827, -4.426469243293629],
            [-11.265951121958539, -4.426644860232225],
            [-11.269367908496772, -4.42372060745926],
            [-11.273878417865642, -4.428882625088977],
            [-11.276967014395922, -4.428915987721309],
            [-11.27867030818367, -4.42392289380186],
            [-11.281999791054144, -4.423366514756752],
            [-11.284229465763623, -4.41905850865393],
            [-11.28853277901926, -4.422883460723376],
            [-11.290084961823524, -4.420457959011794],
            [-11.300115386571944, -4.424500661043622],
            [-11.303680058215246, -4.421883451817418],
            [-11.30821479823822, -4.423654192900489],
            [-11.315215361817808, -4.4232385841666995],
            [-11.31960658588656, -4.415824390774392],
            [-11.323498556388381, -4.416837352373543],
            [-11.33454944017184, -4.4241812274859145],
            [-11.33796852795122, -4.42566297151034],
            [-11.346888433422295, -4.425211490344435],
            [-11.34729180588229, -4.422627325022395],
            [-11.351883150910437, -4.423067173504978],
            [-11.354362478086797, -4.419312925765508],
            [-11.361429953599746, -4.4189693545987945],
            [-11.363164685425025, -4.421414804961087],
            [-11.368822976480752, -4.42351783719725],
            [-11.37371318623447, -4.4218062292324065],
            [-11.378381183474692, -4.422316215588495],
            [-11.380783275403132, -4.428418224295625],
            [-11.384833403679197, -4.428441753606756],
            [-11.384288279897817, -4.434179229059937],
            [-11.39149261962994, -4.4440922992948275],
            [-11.394210906961879, -4.4425933799432125],
            [-11.400585273586147, -4.448097920309385],
            [-11.414469204498007, -4.4414051434819966],
            [-11.418464665306582, -4.436913594633588],
            [-11.420945052652566, -4.440500666210837],
            [-11.425994438352047, -4.437932083991828],
            [-11.437486413522663, -4.441224341284709],
            [-11.441139724404756, -4.438550539552917],
            [-11.44335253456317, -4.4447286839295295],
            [-11.446379897393259, -4.4473269449391974],
            [-11.448096992322538, -4.45296100669781],
            [-11.451512057395176, -4.452964385379878],
            [-11.455267663867728, -4.449844893516697],
            [-11.467507859501978, -4.454715875867644],
            [-11.469255409193986, -4.457861090028264],
            [-11.470902339527973, -4.468238499681864],
            [-11.477684517144588, -4.470323216395966],
            [-11.478925342053534, -4.473389201837891],
            [-11.474739277137811, -4.481332570327664],
            [-11.474959530803323, -4.485093535285533],
            [-11.477768604505227, -4.487200033943195],
            [-11.479155529516873, -4.493188234027515],
            [-11.479608526835637, -4.5014735855395545],
            [-11.478144456430924, -4.509234119578359],
            [-11.482831572142747, -4.513972761569143],
            [-11.485074102241226, -4.518385027493236],
            [-11.484637475781057, -4.528095138844224],
            [-11.485995122652193, -4.5300980803402044],
            [-11.484574755969698, -4.534742656430351],
            [-11.487286195088661, -4.537213967198506],
            [-11.493518406391384, -4.538474121499943],
            [-11.49395437440618, -4.542314277902771],
            [-11.491096769381283, -4.543549911698695],
            [-11.493786213988596, -4.55174834352334],
            [-11.491650588049009, -4.553742643242055],
            [-11.490141233189242, -4.5601731333321665],
            [-11.490977930410628, -4.569345564760154],
            [-11.487317287468153, -4.573012963420391],
            [-11.488609572102865, -4.579564443635855],
            [-11.483468241827268, -4.584654325951221],
            [-11.484042900679501, -4.596847395100723],
            [-11.478307389519415, -4.601028310320206],
            [-11.474895097685938, -4.608920836264092],
            [-11.471004657970987, -4.611398630834446],
            [-11.471999325005791, -4.615022932580594],
            [-11.476178492881301, -4.620382712962223],
            [-11.470716770618639, -4.626923223679417],
            [-11.468735060380208, -4.632825624210667],
            [-11.46477018234535, -4.635485612421797],
            [-11.461718763155542, -4.641678304110337],
            [-11.469324941743267, -4.646954973238099],
            [-11.478529827564591, -4.646487540988834],
            [-11.478969177722997, -4.643923855901954],
            [-11.486863441511684, -4.6453561883469],
            [-11.489739594563373, -4.6482303133792024],
            [-11.49327332733779, -4.64772270334508],
            [-11.500749334541593, -4.644385302609131],
            [-11.502168674686569, -4.639419486782135],
            [-11.50567847425708, -4.635317735678466],
            [-11.515004481707148, -4.639661908432673],
            [-11.514070591104648, -4.645105001470408],
            [-11.515604294603227, -4.648720426602894],
            [-11.521780724175592, -4.648996094923326],
            [-11.53692311003607, -4.645515572339522],
            [-11.544233322309198, -4.640797404423125],
            [-11.549215029572709, -4.640623604377498],
            [-11.554237122242943, -4.646171330367386],
            [-11.557483156754714, -4.646386041905284],
            [-11.560312070631287, -4.649635718595541],
            [-11.56955256941661, -4.647599251193925],
            [-11.570236901065595, -4.651542300834883],
            [-11.576372513264204, -4.655270320445237],
            [-11.576869529139005, -4.658234094905212],
            [-11.573791896344696, -4.661835197967552],
            [-11.571370329319215, -4.660138380803539],
            [-11.568728184424469, -4.6628999205431985],
            [-11.572664941763865, -4.66507874906642],
            [-11.58219192227428, -4.658348134016562],
            [-11.58315641858306, -4.653563009920959],
            [-11.58577341703957, -4.652758734364001],
            [-11.590984676223032, -4.663499937422574],
            [-11.591257331927586, -4.667821770855631],
            [-11.596125320343543, -4.664848992575622],
            [-11.600754562122969, -4.666073428914283],
            [-11.601734016968402, -4.670010391665046],
            [-11.605961626231045, -4.670492434943996],
            [-11.608388493643295, -4.673594371738895],
            [-11.61242370058741, -4.673446942280814],
            [-11.616623266327192, -4.669968844584238],
            [-11.621278006878395, -4.674020348830421],
            [-11.624329940200278, -4.678747098669657],
            [-11.63017665838801, -4.681284566767824],
            [-11.633532644627616, -4.68026132635023],
            [-11.63537990930786, -4.67671272896731],
            [-11.641224296920642, -4.671004960564017],
            [-11.65098875028096, -4.667833770252569],
            [-11.662544194379272, -4.667717077222336],
            [-11.669372257066774, -4.676804256163246],
            [-11.676825294860079, -4.683884544662944],
            [-11.677487261442497, -4.685657041818802],
            [-11.685385569809965, -4.693444202313817],
            [-11.689837102485303, -4.69250266456892],
            [-11.689153026523243, -4.687254716481882],
            [-11.694806309777462, -4.6874320869667585],
            [-11.698826812650244, -4.69328947373571],
            [-11.703086254611991, -4.6929079072491335],
            [-11.706208416711425, -4.7027416094480525],
            [-11.709270235723332, -4.703505955838083],
            [-11.709644201001453, -4.710255480391338],
            [-11.711121263757837, -4.715260243443036],
            [-11.717601001590703, -4.713433041262976],
            [-11.720830520148517, -4.716623526267648],
            [-11.716760471533648, -4.718382384549188],
            [-11.71629323430518, -4.721430237476272],
            [-11.72095927036973, -4.724990468002169],
            [-11.723752499049795, -4.723244059948929],
            [-11.729711372152778, -4.716791702335156],
            [-11.735404706053993, -4.718120595560818],
            [-11.736860725253155, -4.721499986508953],
            [-11.741452870731466, -4.723036284904693],
            [-11.748874857866198, -4.728238182241652],
            [-11.744187989383523, -4.7459544494716654],
            [-11.744276273291504, -4.754230807015465],
            [-11.745844296851738, -4.757890806337097],
            [-11.750282562776405, -4.7548047465026055],
            [-11.752707218753589, -4.755719579897294],
            [-11.75699548843304, -4.761578905048172],
            [-11.75621080442921, -4.764146326476079],
            [-11.758452027688238, -4.769632893026516],
            [-11.7667308914994, -4.775642708763293],
            [-11.771259528201604, -4.776185608819474],
            [-11.775614283970151, -4.783894086369156],
            [-11.779246986449694, -4.783357194827981],
            [-11.781602575164401, -4.786616569659275],
            [-11.790276252159856, -4.787368665252254],
            [-11.792188598021708, -4.791480533402792],
            [-11.792559764409674, -4.801824430672503],
            [-11.794079575211788, -4.805562969895992],
            [-11.80782335709341, -4.806154364702974],
            [-11.809419681117026, -4.8048402004484005],
            [-11.815554657754474, -4.7861026132047995],
            [-11.85617724957988, -4.660758053636108],
            [-11.858990151467664, -4.651603313854458],
            [-11.902206903096573, -4.52086879392316],
            [-11.910625909912, -4.4263490255588565],
            [-11.917378443684887, -4.399827127073385],
            [-11.944483644414877, -4.294647639918255],
            [-11.947726321310132, -4.281342822669426],
            [-11.994780662858714, -4.103234114543683],
            [-12.003402298289414, -4.070011279895472],
            [-12.007920130051339, -4.0732631463882765],
            [-12.01835103527147, -4.078078914305081],
            [-12.021013765470073, -4.083696651591901],
            [-12.023715300121154, -4.085233770448934],
            [-12.028496735792817, -4.08410946814858],
            [-12.035643946813835, -4.090814295033506],
            [-12.047672653208739, -4.100904221108471],
            [-12.052155128790215, -4.102531417320854],
            [-12.056234007431417, -4.106402970239193],
            [-12.05596242829765, -4.116032950422708],
            [-12.056683345579719, -4.119484344983653],
            [-12.063834739786891, -4.124961033219338],
            [-12.066238928147826, -4.130415359915407],
            [-12.073196902551185, -4.134584411301399],
            [-12.075272430156256, -4.130124901188507],
            [-12.078455926543509, -4.127236783897379],
            [-12.0770331297817, -4.124515304060787],
            [-12.080941137832607, -4.120786701699357],
            [-12.082251178569111, -4.117526775785491],
            [-12.088607824551238, -4.113401590236981],
            [-12.090430035490426, -4.1102195154098276],
            [-12.095978095280747, -4.11258315654046],
            [-12.101467537849643, -4.109631706387801],
            [-12.105765787306165, -4.10275796233469],
            [-12.106221341074674, -4.098242214431859],
            [-12.111819880442253, -4.087325875632894],
            [-12.111646141391457, -4.0848768556228015],
            [-12.116693904351315, -4.077376686134593],
            [-12.115909662968125, -4.0708515334162785],
            [-12.121665707143487, -4.067985963150846],
            [-12.125538523405421, -4.063016831494872],
            [-12.12821136003408, -4.055483493332965],
            [-12.131092030831521, -4.05323849967488],
            [-12.136642461151457, -4.0431890586126915],
            [-12.143131887547723, -4.040575940582688],
            [-12.146880117130097, -4.035937721518708],
            [-12.147713884755804, -4.028597433809609],
            [-12.150196468243347, -4.020732694623459],
            [-12.14817163024563, -4.014616688260087],
            [-12.148307365915342, -4.007649884522202],
            [-12.146563897785745, -4.00258032252765],
            [-12.150944364190964, -3.9981204528238794],
            [-12.15553748891492, -3.989853731330609],
            [-12.158714132432662, -3.988298904642363],
            [-12.158725914796845, -3.9833277172326826],
            [-12.16114069069527, -3.9800405909595016],
            [-12.166250894566751, -3.977826731019666],
            [-12.170875582171677, -3.9741388545410588],
            [-12.172207077010984, -3.969204009082356],
            [-12.177593343541826, -3.970527192991699],
            [-12.182047020285141, -3.967398814495207],
            [-12.177080508257788, -3.959855718178071],
            [-12.177116761732822, -3.95522312352179],
            [-12.180063918533369, -3.954427344231517],
            [-12.180760081768666, -3.9464674773958337],
            [-12.178142030456238, -3.9442405610155533],
            [-12.179868572088413, -3.940649935531782],
            [-12.17556845935176, -3.9347095617419896],
            [-12.171763609892666, -3.9332480544392676],
            [-12.172593966152169, -3.9301588326003234],
            [-12.168819981144459, -3.9269580772045214],
            [-12.168923245204628, -3.9230117522827523],
            [-12.174309623130043, -3.9145194731884776],
            [-12.170718513984374, -3.9075059253865634],
            [-12.169097886903273, -3.9021538769903095],
            [-12.158424330015826, -3.9011853156147387],
            [-12.158253858792115, -3.896045078223322],
            [-12.16233832741666, -3.891847430961712],
            [-12.165832667158394, -3.884934898157479],
            [-12.169044257692505, -3.884316916059917],
            [-12.170737175610153, -3.8799654275477318],
            [-12.17435188175065, -3.8761732965443416],
            [-12.17404945475997, -3.8727457255206565],
            [-12.167140602124626, -3.859866481415391],
            [-12.164265707347399, -3.8578713858747338],
            [-12.16466784458601, -3.8547871725050924],
            [-12.170528392214509, -3.8485816438846463],
            [-12.170173511304812, -3.839211321573467],
            [-12.176343898447342, -3.8364611375679885],
            [-12.175651157810469, -3.8343079408472955],
            [-12.180873414231481, -3.830560000702665],
            [-12.1811765203788, -3.826903822392955],
            [-12.17914125794681, -3.8239114607799696],
            [-12.180017447114725, -3.8177069094814096],
            [-12.177233570761091, -3.8116749822901492],
            [-12.17418390001437, -3.810690665469235],
            [-12.173320545818392, -3.8034986719208344],
            [-12.16941831539269, -3.7971722013766986],
            [-12.174841851371522, -3.793508273462409],
            [-12.1788590786894, -3.7921668517894846],
            [-12.185631887007915, -3.78754415085268],
            [-12.189423408438405, -3.7890342370862715],
            [-12.196092970119635, -3.795825425425916],
            [-12.200817957822782, -3.793939285610397],
            [-12.20706110391174, -3.789209733342829],
            [-12.203683945681702, -3.781230658384562],
            [-12.205225397705346, -3.7764990286717772],
            [-12.201098565309204, -3.776167847826203],
            [-12.200146724414196, -3.7692127763511425],
            [-12.202916301967793, -3.761736198084235],
            [-12.201593418201249, -3.7565307707131956],
            [-12.19804221355263, -3.7534768963602048],
            [-12.201113378958825, -3.7479668932213346],
            [-12.200396516951441, -3.7445245055329552],
            [-12.196983375970905, -3.7423587976265713],
            [-12.195572453993451, -3.737818552015869],
            [-12.189205010355932, -3.7336744492930247],
            [-12.183780345145685, -3.7321999162000368],
            [-12.18158284904416, -3.728781398548296],
            [-12.188338243590085, -3.7205743896563215],
            [-12.185520192699244, -3.7158962146435277],
            [-12.192307720021025, -3.7107061659812954],
            [-12.195577586308959, -3.70575912194969],
            [-12.19920844312072, -3.70775572444919],
            [-12.205220616145859, -3.70296426858385],
            [-12.215347634445589, -3.7052375283436363],
            [-12.222936131929362, -3.704335263392448],
            [-12.229302923074695, -3.705121520039017],
            [-12.231724555521499, -3.7003627220222652],
            [-12.230722561748896, -3.6938201916134608],
            [-12.227088643012229, -3.6906056916459398],
            [-12.227258012159473, -3.6875819950440274],
            [-12.224919587440708, -3.6815531534827635],
            [-12.22619559771317, -3.676191444711608],
            [-12.223527956013005, -3.6738382012199913],
            [-12.221009849279, -3.6678192707077493],
            [-12.214759521902893, -3.670256217234475],
            [-12.212942271963342, -3.6669244863079564],
            [-12.208357265598154, -3.6674990828030536],
            [-12.203229577079837, -3.666416763466887],
            [-12.19982453585557, -3.6621680406976385],
            [-12.201618301266468, -3.653724796430097],
            [-12.200892569936373, -3.6504288876233377],
            [-12.192889212673052, -3.650608098296736],
            [-12.190659958986943, -3.643942803612474],
            [-12.192716830560352, -3.640569066282162],
            [-12.192115614620143, -3.6373545495196207],
            [-12.200241924693593, -3.6279199199466574],
            [-12.202046574215888, -3.6241936490392863],
            [-12.202999417763076, -3.615108672434638],
            [-12.205999888655887, -3.6119717557735167],
            [-12.202908090457363, -3.6082779257317474],
            [-12.19560083700452, -3.602921928067844],
            [-12.191458561515521, -3.5975704957563552],
            [-12.193459293005477, -3.5943877969070575],
            [-12.193137087172069, -3.590275170023216],
            [-12.197482071421762, -3.5890653344176897],
            [-12.197963774077596, -3.583572238579598],
            [-12.195043818557453, -3.579014105353852],
            [-12.196615346324268, -3.5764702136754316],
            [-12.204987378321665, -3.575793730166719],
            [-12.205765236848896, -3.57283045975745],
            [-12.20127887134573, -3.5676081268697324],
            [-12.196440114227027, -3.5658120682112306],
            [-12.193602093737601, -3.5596563950375204],
            [-12.190021638673011, -3.557769803438127],
            [-12.209203856592772, -3.554460816598786],
            [-12.324334133998484, -3.5353935894746904],
            [-12.380387887357676, -3.5260947601443857],
            [-12.381131679056871, -3.5228046243861173],
            [-12.385522795440327, -3.5164145827208384],
            [-12.384546673632943, -3.512165697414852],
            [-12.380491628993106, -3.5113921006688873],
            [-12.370975015022527, -3.5019570493635843],
            [-12.36841660872918, -3.495894048524193],
            [-12.361616432142426, -3.498493991294769],
            [-12.360058338625633, -3.4943355369570455],
            [-12.362026532138339, -3.4893079769242217],
            [-12.369686172134724, -3.4870511914525526],
            [-12.372838703858909, -3.480999907181132],
            [-12.371744584168407, -3.477958422360949],
            [-12.365112700024135, -3.480683982138928],
            [-12.363499656271069, -3.4860810082852804],
            [-12.36037978708192, -3.486507273156536],
            [-12.354629505772868, -3.480486270578311],
            [-12.354065652187435, -3.4755279561794006],
            [-12.358476591308259, -3.4677350822589665],
            [-12.364597766081143, -3.466266682059755],
            [-12.363659453526385, -3.4607249469099703],
            [-12.361554960929718, -3.458334865022267],
            [-12.361633232184426, -3.451967030286011],
            [-12.356060208588133, -3.449518692176397],
            [-12.357042451694937, -3.445156409463676],
            [-12.35578852161372, -3.4392416425363854],
            [-12.350426481674853, -3.436835398483395],
            [-12.353551636444571, -3.4344613096413577],
            [-12.35142551446892, -3.429641053607965],
            [-12.345209020315812, -3.42425269011492],
            [-12.344617824294042, -3.42077517719584],
            [-12.337472660720902, -3.4205372689954907],
            [-12.335214487437192, -3.4162638272022727],
            [-12.334697148949004, -3.411467453181884],
            [-12.335922815929033, -3.3991631479962123],
            [-12.326715783304495, -3.399844576459632],
            [-12.320791651286829, -3.398920174512057],
            [-12.317416736643692, -3.3888191275607302],
            [-12.318910315896739, -3.3872207269379655],
            [-12.325398223334854, -3.388516603621293],
            [-12.328080834311441, -3.393666407517179],
            [-12.331186830842414, -3.3906197423282927],
            [-12.331002414815268, -3.387735312584424],
            [-12.333929985361145, -3.3846772998149115],
            [-12.332781049368844, -3.382083729267651],
            [-12.324267734083127, -3.3772500979917677],
            [-12.320432580840572, -3.377080369736517],
            [-12.319224636538378, -3.3737906108359517],
            [-12.315406357007507, -3.3701805187676213],
            [-12.315472303234234, -3.3679837300564386],
            [-12.311568645515642, -3.3605177745828505],
            [-12.311134470195487, -3.3546258575839896],
            [-12.313018297084371, -3.35366944216281],
            [-12.310373029265058, -3.3426975619509465],
            [-12.312448438212003, -3.3407698120598024],
            [-12.309281842307781, -3.3319019264160463],
            [-12.30277177092308, -3.3239275475872607],
            [-12.300007016865623, -3.3185321965575736],
            [-12.299114826886516, -3.299742059603133],
            [-12.289764735935778, -3.297333479411495],
            [-12.28784798426859, -3.2946522751198466],
            [-12.283461330400096, -3.2941831313032965],
            [-12.279131406088197, -3.2965045132641912],
            [-12.27457005513619, -3.2967309585591904],
            [-12.273548617316127, -3.2925280949240947],
            [-12.268743269377591, -3.2907748958611944],
            [-12.26377380776806, -3.2908092557600472],
            [-12.260235121344065, -3.286912818531398],
            [-12.257566996942527, -3.287403358547463],
            [-12.254300620271586, -3.2829903539066327],
            [-12.250548483103909, -3.2818769344732117],
            [-12.25050059294852, -3.2788389114373038],
            [-12.246333622088146, -3.2748183731649316],
            [-12.243746754185565, -3.2754307413368733],
            [-12.23799121000449, -3.2732617137782944],
            [-12.234854658622737, -3.275746668139998],
            [-12.22650738006069, -3.2767662392295533],
            [-12.222996612486478, -3.274579471700179],
            [-12.221119972501366, -3.2683405687741165],
            [-12.21385230805858, -3.2671824716685776],
            [-12.212179459292123, -3.2639443899414724],
            [-12.206982827420395, -3.262914324041434],
            [-12.205494798750294, -3.261047176480067],
            [-12.200652144804321, -3.233472608515226],
            [-12.200279177645326, -3.2289222621668143]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -110.8115486583989, "lat": 33.79965047826725 },
        "year": "2023",
        "ste_code": ["04"],
        "ste_name": ["Arizona"],
        "coty_code": ["04007"],
        "coty_name": ["Gila"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gila County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00040471"
      },
      "bbox": [
        -12.385522795440327, -4.806154364702974, -11.014524336784643,
        -3.2070304394401066
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.493312089811434, -4.974302608960103],
            [3.530965057050455, -4.974975699396327],
            [3.614434453668162, -4.9718926628668525],
            [3.6497881278142312, -4.970803355855066],
            [3.7478107751793637, -4.967572936832942],
            [3.786442453343052, -4.965819373457286],
            [3.7905865487315604, -5.06900519685762],
            [3.792842735462749, -5.126748371968443],
            [3.793660216615471, -5.140962967142544],
            [3.767140718752952, -5.142061344108415],
            [3.767259011620387, -5.149165552090787],
            [3.7719712556955676, -5.152518713905541],
            [3.769785018396441, -5.159793545296284],
            [3.774494813996756, -5.163130525994682],
            [3.7759908055856424, -5.171519583794219],
            [3.7730305307113907, -5.1728813485759195],
            [3.768685939340461, -5.17775886226224],
            [3.7683678436240435, -5.18503318418718],
            [3.7712474272302683, -5.191289243208216],
            [3.7743445274179748, -5.19265701374079],
            [3.77628635800451, -5.1986409364379025],
            [3.770383636873902, -5.203037464587369],
            [3.769002071855815, -5.208242075641798],
            [3.764440433667624, -5.215523543630393],
            [3.765181823177066, -5.220641174030623],
            [3.769191934773698, -5.226681868043814],
            [3.7784597266850266, -5.230226774436156],
            [3.7812852372768035, -5.229960677559734],
            [3.781514283336725, -5.23821260453562],
            [3.777902773907433, -5.244636415241543],
            [3.779316245533986, -5.249770507027575],
            [3.777119293757328, -5.256268169725433],
            [3.7786687461485053, -5.260121949681986],
            [3.783452068317557, -5.265933246114504],
            [3.787645075395431, -5.273092590717414],
            [3.7898114553773707, -5.27800982844519],
            [3.7908550410589066, -5.284041862175948],
            [3.8004987479691996, -5.285431744004678],
            [3.8135813119513444, -5.291314809711469],
            [3.8128530918432255, -5.294342904117547],
            [3.80689660500904, -5.300321387622924],
            [3.8055001120970338, -5.304353866886641],
            [3.8080583041250633, -5.309965080793228],
            [3.808086708479028, -5.315558687346077],
            [3.805334115082951, -5.320396780883769],
            [3.799029622004979, -5.324854723348266],
            [3.7954148442078304, -5.325487592503869],
            [3.790490670078918, -5.323033925694647],
            [3.7923618404679176, -5.330456089678063],
            [3.8023442473981217, -5.343518935230797],
            [3.8028894943147096, -5.34905105177275],
            [3.804798187609351, -5.350213558298819],
            [3.801307383953772, -5.360372187887571],
            [3.8035162481697253, -5.363584670547319],
            [3.80241900557856, -5.368632966153974],
            [3.7983518706767905, -5.372650609390707],
            [3.7941441377808904, -5.372580903714291],
            [3.7877268331893115, -5.366859460499123],
            [3.7828139323097294, -5.3678289868154945],
            [3.7761537363616804, -5.374947595645684],
            [3.7832754070776446, -5.384912745500317],
            [3.779636432856707, -5.38956626759225],
            [3.7757468195226482, -5.387343555761956],
            [3.7736770105736577, -5.389662050993701],
            [3.7660107233999347, -5.3935581661625],
            [3.765563021564991, -5.396866023729401],
            [3.758489911192769, -5.390182895739529],
            [3.749702717681989, -5.397002912530422],
            [3.7523358159214077, -5.401464727818727],
            [3.7545547230430922, -5.402086780395399],
            [3.754162559082416, -5.4071696041784305],
            [3.74838304849965, -5.40597103079444],
            [3.745360250952567, -5.410063404236873],
            [3.7484088776709497, -5.416844052599424],
            [3.7447788210913058, -5.417179006903085],
            [3.743263586109588, -5.4206931525682425],
            [3.740053457999379, -5.420276287727789],
            [3.7357985191393963, -5.4166726999741615],
            [3.7325100147424384, -5.419321007352075],
            [3.732711708702036, -5.423088038650065],
            [3.7243329735473463, -5.4243660273296594],
            [3.727524548333681, -5.427777236900696],
            [3.7282296994199524, -5.433359898483548],
            [3.7225698087701398, -5.434495498164828],
            [3.721385604749208, -5.437682460763789],
            [3.7160985255372263, -5.434073278028141],
            [3.71263355961973, -5.436428931663831],
            [3.7114160196803136, -5.439865809309498],
            [3.7133457909992895, -5.443574841622785],
            [3.713624068204159, -5.448311316895754],
            [3.7091646471594086, -5.453832526986045],
            [3.702109983168383, -5.456968235822685],
            [3.698747855911103, -5.452503188831685],
            [3.6915658690851614, -5.454832818882594],
            [3.6907429035853987, -5.461021032458535],
            [3.6933920842265797, -5.46348553923935],
            [3.6908163643626946, -5.470364723296497],
            [3.6811702777197066, -5.467134399478361],
            [3.6809905804216863, -5.4720917402149585],
            [3.6771446653828836, -5.476000271416858],
            [3.6751193423590878, -5.480064502009287],
            [3.6764394504644993, -5.490173387387501],
            [3.6810107643766856, -5.488884037042169],
            [3.6819559960147297, -5.492845791898492],
            [3.677994693829761, -5.500022742889294],
            [3.680423152603151, -5.5030739497084395],
            [3.67517983975151, -5.513849081921627],
            [3.667663155681383, -5.515758275325068],
            [3.6660048355059516, -5.513443796189477],
            [3.6687056078842124, -5.50951842339216],
            [3.66433797514682, -5.50678783819999],
            [3.6604298280887844, -5.509331872582876],
            [3.6550937131861936, -5.510536360234033],
            [3.6572351279030064, -5.514467039007498],
            [3.6544589647940975, -5.516429696509964],
            [3.6486459246071106, -5.5154499716417025],
            [3.6462572995917784, -5.513358932405402],
            [3.6529577578978416, -5.507740444056127],
            [3.6537816398078844, -5.5042930482012595],
            [3.6519864865605944, -5.500825560449224],
            [3.646288877072192, -5.495391837425769],
            [3.643612839054768, -5.495251474066563],
            [3.644887145458324, -5.489892770987034],
            [3.639853071869306, -5.491664829914618],
            [3.6371624278583488, -5.488912637329801],
            [3.6386276952277874, -5.485472647488046],
            [3.642669774540439, -5.484095371974151],
            [3.638891324958453, -5.479147533960669],
            [3.639696986413841, -5.471456812885565],
            [3.638790051011082, -5.4657499237495015],
            [3.636002396539286, -5.465147477531037],
            [3.6323173239357636, -5.47351998881384],
            [3.625309203267973, -5.476927439006048],
            [3.621271092727092, -5.474176184517553],
            [3.6131255848403474, -5.476968975368248],
            [3.6093164498710038, -5.4703873460748005],
            [3.6042021466586283, -5.470364421824263],
            [3.6011296836288516, -5.46789477795109],
            [3.600567640264336, -5.46383854153773],
            [3.6024727102803724, -5.457620773605929],
            [3.6105360825623722, -5.45591520111881],
            [3.6098016810178795, -5.452176600167458],
            [3.60323253780309, -5.452304641307446],
            [3.5942275741319003, -5.448719483641382],
            [3.5933131931065527, -5.443323001637212],
            [3.5971138143806254, -5.440310603811408],
            [3.5994175979209837, -5.434489897933951],
            [3.599643020649235, -5.427120507890581],
            [3.5892994042052337, -5.421429252477616],
            [3.5871632774502866, -5.427166045053061],
            [3.582879648206671, -5.430024602579225],
            [3.5790966689394623, -5.429037091404971],
            [3.5742470440796845, -5.424142744465715],
            [3.5718941528707964, -5.423591180824681],
            [3.5663125974508, -5.426073513828264],
            [3.562560286733744, -5.424671813211641],
            [3.5628640183240905, -5.41808568190061],
            [3.560288992286342, -5.4144654040517155],
            [3.5539158578621346, -5.412897862305254],
            [3.5455566831341803, -5.418303362630676],
            [3.5413477547165253, -5.416174227611376],
            [3.543157090618799, -5.407244808214402],
            [3.540222871518108, -5.40182738424428],
            [3.5376402051772566, -5.400837393948792],
            [3.5345821414686855, -5.403733251201796],
            [3.532856226714759, -5.40958725626438],
            [3.5285018452057084, -5.408415861258025],
            [3.5255181755349394, -5.411338492879012],
            [3.529055383024561, -5.415591617090166],
            [3.5283520759816853, -5.417633720678856],
            [3.5220277933499022, -5.420912917410552],
            [3.5142963626213133, -5.420101702876846],
            [3.5153147358272747, -5.415248441053467],
            [3.513047034656305, -5.411325993729863],
            [3.513287247547409, -5.405719264736344],
            [3.51153794091671, -5.403046480399189],
            [3.508264279692598, -5.4063657893706685],
            [3.504252511911926, -5.407372366190171],
            [3.5000314357836766, -5.403032975899936],
            [3.493243786360356, -5.401534639100243],
            [3.4878541662723292, -5.402603111305528],
            [3.486274117000382, -5.401301389945507],
            [3.486849605339741, -5.395657773661082],
            [3.4917196563272013, -5.390437752825493],
            [3.4931429531484226, -5.384687252378444],
            [3.4900167344696773, -5.378487722623086],
            [3.4868730775728833, -5.376568623666304],
            [3.480410273066128, -5.378289533700917],
            [3.476525683083289, -5.372967863819376],
            [3.468966362958655, -5.369565911410991],
            [3.469789964195525, -5.367429240475197],
            [3.467340063162526, -5.358934949764917],
            [3.467622277494329, -5.353462425805496],
            [3.4695573710063714, -5.346655115012626],
            [3.465930443048022, -5.346730563365424],
            [3.465249269976843, -5.338063288008486],
            [3.4660621842482437, -5.332899343461929],
            [3.4691683789535226, -5.327960234022566],
            [3.4676703273341274, -5.326000732779974],
            [3.469388326457878, -5.318792795579133],
            [3.4721082481125087, -5.315685834480731],
            [3.4683767882405143, -5.31113157845381],
            [3.4686492044250685, -5.307235734852996],
            [3.475429469265487, -5.303275948282021],
            [3.479574528066269, -5.305545888731484],
            [3.4820672007747153, -5.3039539812860355],
            [3.4817952113669515, -5.2986761985879385],
            [3.4848791669508956, -5.289001239764011],
            [3.4844545186615887, -5.282609370590968],
            [3.4873919657093007, -5.279555391172729],
            [3.4895991146867593, -5.273729910859236],
            [3.4923000636520474, -5.270001421014279],
            [3.4960010336087692, -5.2684980255246305],
            [3.49788942324279, -5.259284869355358],
            [3.496051143850373, -5.252829330395493],
            [3.5010666552292062, -5.241906197949756],
            [3.504429694802465, -5.240495496210107],
            [3.5066484882488256, -5.22980254545402],
            [3.504872619730579, -5.2237857960572],
            [3.5114282974539903, -5.2134329056761155],
            [3.5119247363303177, -5.206993154580377],
            [3.509122802237866, -5.201215407893456],
            [3.516081334637613, -5.189059451435428],
            [3.517833383962843, -5.182043758491335],
            [3.512731934951628, -5.170618862886124],
            [3.5141445562121927, -5.167976890973486],
            [3.5115483319225973, -5.162221797834204],
            [3.506982411695835, -5.157810146226156],
            [3.5067747446509663, -5.151997767631547],
            [3.508600029869416, -5.144358422424153],
            [3.511043222892599, -5.140964889584332],
            [3.510346613721564, -5.134196476219567],
            [3.5117087197073955, -5.128721588882338],
            [3.5096446455702868, -5.124159860295342],
            [3.5087188706324692, -5.11796711263385],
            [3.50279705847461, -5.111174864705835],
            [3.5041359877663587, -5.10972797555439],
            [3.506298952080233, -5.096470273025632],
            [3.502351380586925, -5.088804385420779],
            [3.4993581470055917, -5.078326663624768],
            [3.498424040232362, -5.0698855948399375],
            [3.499471632275428, -5.063529528967973],
            [3.501974679976236, -5.059864071993776],
            [3.5019718430550024, -5.055062245916208],
            [3.5045800072957527, -5.047812355586806],
            [3.502158047221727, -5.041988219476888],
            [3.5042615091860663, -5.03515310506213],
            [3.501233353958612, -5.031791940831103],
            [3.50167193984661, -5.027390408128309],
            [3.499157312580888, -5.024613742989611],
            [3.498549996397389, -5.017426994794803],
            [3.502388829203033, -5.008107732930089],
            [3.503230093246953, -4.999439948835785],
            [3.5009788183041133, -4.992931683205454],
            [3.4953814045372598, -4.9871646717278715],
            [3.496490211815508, -4.985083546687675],
            [3.49407527967563, -4.98134463950458],
            [3.493312089811434, -4.974302608960103]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.16239210909968, "lat": 33.46640506184608 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05011"],
        "coty_name": ["Bradley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bradley County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00063757"
      },
      "bbox": [
        3.465249269976843, -5.516429696509964, 3.8135813119513444,
        -4.965819373457286
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.228553724804693, -4.637067117261616],
            [4.241377155675165, -4.646183657684562],
            [4.24497713225943, -4.650529447626797],
            [4.251010374318399, -4.661753127758098],
            [4.254777669248022, -4.6660580942749865],
            [4.2609054556605646, -4.6682860400466115],
            [4.264692090800486, -4.667668201239017],
            [4.2699730956827135, -4.664784856631986],
            [4.273185497073559, -4.660669507081903],
            [4.278106123302816, -4.646275683477316],
            [4.28093327465746, -4.642510324395426],
            [4.285786592237576, -4.641448269539673],
            [4.288427201464334, -4.6428668500939105],
            [4.293303823031013, -4.648827370351811],
            [4.297484929389177, -4.658183741414439],
            [4.30077226178968, -4.662092869120349],
            [4.3044892365483385, -4.661658467536291],
            [4.308292629040842, -4.65868595009712],
            [4.306551137509388, -4.6495282474158905],
            [4.3033743213474, -4.643363583015539],
            [4.298262693842618, -4.638529165980314],
            [4.295856212020253, -4.6348069304314645],
            [4.296869699452627, -4.629612208565379],
            [4.299561965410754, -4.62828790955915],
            [4.305809557920202, -4.6297142831422455],
            [4.308080856457104, -4.63145904431693],
            [4.31309849792902, -4.638568950532154],
            [4.314237238522491, -4.644121611000446],
            [4.318387074503726, -4.653712891225987],
            [4.321279048253393, -4.662395428681656],
            [4.320733162211332, -4.66985742675475],
            [4.315198413762052, -4.676918038149548],
            [4.309864122524152, -4.678127986651662],
            [4.304746639768362, -4.6762836312306915],
            [4.299709479985993, -4.671998937624036],
            [4.291630743912336, -4.674692143841443],
            [4.285108271460908, -4.6809289871856326],
            [4.283875538727311, -4.683605016915507],
            [4.285989078836029, -4.688062312617709],
            [4.292353077122111, -4.6911318325380185],
            [4.3066893420813175, -4.687078697875997],
            [4.316080965148883, -4.6864137670970205],
            [4.325453437146417, -4.6837177771119265],
            [4.338127564006701, -4.675065392092933],
            [4.339172385496208, -4.676419319288049],
            [4.338091670354189, -4.685212669945282],
            [4.342848776831727, -4.693345254726078],
            [4.352200985394744, -4.700791295013798],
            [4.358351842152096, -4.700075906787937],
            [4.360459098214835, -4.694455774697699],
            [4.362355351851712, -4.6852526909991346],
            [4.367926967393947, -4.686342819196834],
            [4.371109692879968, -4.685325667506892],
            [4.375284049295006, -4.678533052984354],
            [4.3775370190337535, -4.672717785927931],
            [4.381931267428374, -4.666095551447478],
            [4.387824368376593, -4.6633625037932855],
            [4.388357933534177, -4.670385106338574],
            [4.387415408949367, -4.6792088054452705],
            [4.383267623659221, -4.683644076821357],
            [4.3816981207940575, -4.69244341062815],
            [4.382929200095111, -4.6967090926170805],
            [4.387484388570269, -4.700821550353235],
            [4.3917447138246315, -4.699534544267588],
            [4.394844889987266, -4.691075650511244],
            [4.401092335771192, -4.685992515311134],
            [4.40776030203841, -4.68572979690264],
            [4.4122322315759375, -4.686914346122998],
            [4.421228823317564, -4.6853146059279265],
            [4.430912399733675, -4.6803761504198675],
            [4.438172207783831, -4.680022555844549],
            [4.443048680391101, -4.684633581331875],
            [4.4452909628862445, -4.690165330912445],
            [4.445850438097444, -4.6949167481766345],
            [4.441468259840196, -4.699791209829717],
            [4.437026930396104, -4.707202931142144],
            [4.437180415973031, -4.713688910048246],
            [4.439203102665428, -4.715882693154898],
            [4.444989282193234, -4.7172893252779655],
            [4.447317092406703, -4.711862765746741],
            [4.451424297899981, -4.708438836657396],
            [4.454619713849371, -4.707955596163276],
            [4.4639336858488, -4.709702072676302],
            [4.463511224278693, -4.705665807288092],
            [4.454628424741549, -4.700656902533152],
            [4.455893675339204, -4.695146123300734],
            [4.4620101136434105, -4.692855815982809],
            [4.461735890874447, -4.689167744894153],
            [4.45438151760144, -4.686986511316636],
            [4.455705264760198, -4.682719330839736],
            [4.463821276085922, -4.681951775057036],
            [4.466384310874572, -4.675249150075561],
            [4.460073388265895, -4.669945366327587],
            [4.456055158807798, -4.663319704552373],
            [4.449123535642324, -4.661715708247166],
            [4.446475377751427, -4.659197755808461],
            [4.447394133347591, -4.651883100610823],
            [4.44729262759196, -4.644504520202289],
            [4.442276435262111, -4.6324139676616545],
            [4.435570425781994, -4.623951244295026],
            [4.431389616511961, -4.622375131725796],
            [4.423502569414083, -4.621610703121658],
            [4.422749761638035, -4.619571172604009],
            [4.42364258070117, -4.611460990788675],
            [4.421428878215755, -4.607527217191973],
            [4.415412306289623, -4.6064593165629475],
            [4.413657366909891, -4.604219788772634],
            [4.411554084767884, -4.590715279856825],
            [4.412603051508846, -4.585314174688775],
            [4.418400168666898, -4.577093640665073],
            [4.413948048133823, -4.571172467162339],
            [4.414685549586552, -4.565791794366018],
            [4.419420351370112, -4.567256391377327],
            [4.421551736132507, -4.564901828204746],
            [4.41858118830817, -4.560821791081019],
            [4.421016385514528, -4.554914567841691],
            [4.428087629614752, -4.550010578147094],
            [4.433267526892479, -4.5438751580521455],
            [4.437977359975518, -4.546477499678001],
            [4.441727723520702, -4.551922427633428],
            [4.446480121155662, -4.552897730375416],
            [4.4496435054878445, -4.549683085512752],
            [4.448506329644386, -4.537224629672616],
            [4.454583400574975, -4.535423251998965],
            [4.4521399154974, -4.531209644368389],
            [4.4549090674979235, -4.525482905082884],
            [4.461072808196418, -4.5293878045667295],
            [4.4676159702906215, -4.530438292574073],
            [4.469657821602905, -4.5283572506432455],
            [4.472843060822014, -4.5170056601721],
            [4.603845978667571, -4.510708567853001],
            [4.606039819218252, -4.510228845576273],
            [4.613010225580126, -4.519217493359252],
            [4.635531204023074, -4.534175617438745],
            [4.641503674653782, -4.534619457933559],
            [4.6520163153324186, -4.532135023153107],
            [4.658087061633837, -4.528663112293265],
            [4.667093790773001, -4.52936679248592],
            [4.672236508368703, -4.532816493865311],
            [4.676419650019818, -4.53888777662223],
            [4.677406605404235, -4.5443422752576605],
            [4.6750646490528185, -4.553658626891051],
            [4.666100652551921, -4.567697050828647],
            [4.664546005365055, -4.574632540720672],
            [4.666637737960602, -4.581143881387882],
            [4.6672307988265525, -4.58710588888581],
            [4.665884707942697, -4.594602167584327],
            [4.66374203955075, -4.598624700319667],
            [4.659774505892314, -4.6015771838887005],
            [4.651872803584305, -4.6044753839466415],
            [4.640882053785373, -4.606479471378574],
            [4.632192379228386, -4.606374170858743],
            [4.608809159549749, -4.602759366875647],
            [4.598293206419486, -4.604494973120834],
            [4.584583363002108, -4.611610964821591],
            [4.593564916120693, -4.633304652135413],
            [4.600199034962349, -4.638269683695422],
            [4.608560038787208, -4.649835419925263],
            [4.609030530371726, -4.653625925083424],
            [4.607429021376969, -4.66222117985559],
            [4.601873368742031, -4.668367251795604],
            [4.597007059689882, -4.669996605331321],
            [4.588952670563427, -4.670396720244498],
            [4.582077446362864, -4.668152757105112],
            [4.57758462303267, -4.665060192553959],
            [4.565317823637662, -4.6385354477501295],
            [4.560155410123157, -4.628969201410329],
            [4.546783349152944, -4.638673767143618],
            [4.536252968372438, -4.640819700323662],
            [4.530808921182936, -4.637857305008595],
            [4.5200606455142465, -4.6284717790905985],
            [4.514051322802134, -4.625540481159595],
            [4.506991905472257, -4.626013736919994],
            [4.5047291155768345, -4.628636529116345],
            [4.502722433682364, -4.635864838182222],
            [4.50199118330195, -4.643861871894352],
            [4.504044352310342, -4.670825685318781],
            [4.505906615547167, -4.6759432989971925],
            [4.508669739057312, -4.678767043153765],
            [4.5137911002679605, -4.680818340419084],
            [4.5402620216544305, -4.686137198115752],
            [4.5598904154517985, -4.689327388638883],
            [4.565693446361594, -4.691532792275957],
            [4.569500192242126, -4.695469215347085],
            [4.5711355225980705, -4.70042915234636],
            [4.569220445702533, -4.7088919647942955],
            [4.558719066113028, -4.72645789097023],
            [4.55281220895354, -4.734893600862078],
            [4.543451216045483, -4.745240494379814],
            [4.530688739179461, -4.755825533493192],
            [4.525208726318624, -4.762006413680972],
            [4.523026992576544, -4.7675749730967185],
            [4.523092619470346, -4.774748221608459],
            [4.5262956156012555, -4.78947526499844],
            [4.528136151223918, -4.793774853715296],
            [4.534436960059343, -4.803545810009459],
            [4.545214630006697, -4.8179606802924715],
            [4.551897277760846, -4.822066067026469],
            [4.559772725259044, -4.825482491510812],
            [4.568428576784057, -4.82775069654093],
            [4.581595313807168, -4.830114388174814],
            [4.589280682836359, -4.834843533632963],
            [4.593681276930345, -4.838977695502177],
            [4.596812652110809, -4.846921417732491],
            [4.594954136377533, -4.854797630010087],
            [4.5929627005351, -4.858108501942662],
            [4.587065031214126, -4.863473604770331],
            [4.5782370886306705, -4.867386504637884],
            [4.573249636774721, -4.868659454952819],
            [4.56702696237168, -4.868353321121464],
            [4.5596343728685875, -4.865137767363991],
            [4.543648374393348, -4.85597789117875],
            [4.529272940820777, -4.85994390608645],
            [4.498632037835188, -4.8649055341979075],
            [4.488299939552156, -4.856689552823573],
            [4.480691147000009, -4.853750128356802],
            [4.476931231729417, -4.854779378302165],
            [4.47084628970874, -4.864208237234737],
            [4.468708113994186, -4.870090828268653],
            [4.469092435008323, -4.874230821173442],
            [4.472536613145593, -4.877879165768576],
            [4.472142302874035, -4.882093933702176],
            [4.469558957288415, -4.887816040001077],
            [4.4707973478470775, -4.89015572418943],
            [4.468303032295221, -4.898427573025488],
            [4.467426737069983, -4.907051905307149],
            [4.475313800666252, -4.916579155783081],
            [4.487186533298073, -4.928328417269859],
            [4.494712882173926, -4.931885142063886],
            [4.507504639008733, -4.931582509180413],
            [4.517270015457179, -4.9286121625446455],
            [4.528751979942718, -4.921152572645143],
            [4.534807399542533, -4.918829706584191],
            [4.541066713667978, -4.919578775632898],
            [4.552251737337648, -4.927218237489566],
            [4.557755483375719, -4.933983194297309],
            [4.561194183129432, -4.939729811818449],
            [4.562598761499043, -4.944302025731767],
            [4.567353166889962, -4.945709224161247],
            [4.567310250760014, -4.954105706091264],
            [4.565200700620715, -4.96009773289814],
            [4.562906671130702, -4.962469947708977],
            [4.555145944055215, -4.965702104983443],
            [4.5450714755542165, -4.968182298374319],
            [4.5311657442292335, -4.9763309444988035],
            [4.5248124603861735, -4.978346807640052],
            [4.51862989753532, -4.978379092739171],
            [4.512421846783311, -4.976305329749964],
            [4.50282852298785, -4.971470044771937],
            [4.487419822037903, -4.964479488356905],
            [4.4829309805582875, -4.961093767359801],
            [4.473383716027726, -4.948713851142893],
            [4.4591637966059565, -4.9323497425186575],
            [4.450669044124267, -4.936968567648434],
            [4.440842305249345, -4.93834901298512],
            [4.42611340349721, -4.939320085529269],
            [4.417994597273076, -4.940661868488944],
            [4.4121635148266085, -4.943368042787489],
            [4.407396960936048, -4.9478851933174015],
            [4.402923138651851, -4.957546489648481],
            [4.402691104094116, -4.964790853975605],
            [4.404368342809985, -4.97062141839783],
            [4.408379079713438, -4.97651784138049],
            [4.413273240706978, -4.981365050405416],
            [4.418905152795043, -4.984263054496089],
            [4.42508885571899, -4.985336614809375],
            [4.434740896416945, -4.985170963319512],
            [4.443629220587862, -4.9864843966327745],
            [4.4524986997380305, -4.9898693631137485],
            [4.462744101012219, -4.99617326654299],
            [4.475043933389819, -5.00523335217698],
            [4.482180674716267, -5.011280988536157],
            [4.4876032727966635, -5.020839099641361],
            [4.4903637825641844, -5.0293463512877885],
            [4.490031156311685, -5.036266556250056],
            [4.4877979662847824, -5.042901971961213],
            [4.484549790149479, -5.048007895251551],
            [4.474009214306282, -5.060178690384272],
            [4.467754441938361, -5.06576392830369],
            [4.4570900749663185, -5.071404266935603],
            [4.450128975023213, -5.072842289887477],
            [4.44455795215359, -5.072930911806567],
            [4.427529496176742, -5.071775999652597],
            [4.420688538587796, -5.072254205677041],
            [4.412751079115176, -5.0739538331544765],
            [4.408907967209344, -5.075974180796123],
            [4.4059025287206985, -5.080957105884312],
            [4.398826698623954, -5.081197421214472],
            [4.39902709665235, -5.088987136211037],
            [4.397208309834038, -5.089167256420571],
            [4.3982672349198895, -5.125681198005694],
            [4.3329636313949855, -5.127415126780427],
            [4.333028769311802, -5.120147591906069],
            [4.325363904839047, -5.120269044186117],
            [4.325241209518371, -5.1128770324778925],
            [4.314549881911527, -5.113372498669525],
            [4.314998723733924, -5.127700510267889],
            [4.311339342460915, -5.127805722710808],
            [4.31011765457432, -5.083449081731796],
            [4.281553927459546, -5.084992772670668],
            [4.22426916249639, -5.0874861121330985],
            [4.222902047839286, -5.044621684908934],
            [4.222236791982656, -5.044440488994943],
            [4.21783380954573, -4.915714784555679],
            [4.217615039609845, -4.913880576341582],
            [4.2164437026362735, -4.870007863791444],
            [4.17347254941964, -4.871948781029572],
            [4.144815226820164, -4.8723663321407775],
            [4.127815455597032, -4.871396046087994],
            [4.125366801739473, -4.783479395998826],
            [4.126828024866401, -4.783409231707405],
            [4.126656437265823, -4.742891997361891],
            [4.126107083903429, -4.677008417416203],
            [4.194349134929859, -4.674852487295049],
            [4.193351368301292, -4.645769369576399],
            [4.209876650806847, -4.645172183027993],
            [4.210046890633614, -4.650627449130263],
            [4.228958852025794, -4.6502982482596575],
            [4.228553724804693, -4.637067117261616]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.25509372546237, "lat": 33.83087587974256 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05041"],
        "coty_name": ["Desha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Desha County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00066850"
      },
      "bbox": [
        4.125366801739473, -5.127805722710808, 4.677406605404235,
        -4.510228845576273
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.0258298024901835, -3.1172220830669075],
            [4.065096787133745, -3.1168939709372414],
            [4.112207422355229, -3.1163172549382394],
            [4.197178357055022, -3.1130678346386786],
            [4.19217152120352, -2.9987319185822434],
            [4.199460281718806, -2.9960612800347883],
            [4.202332275603171, -2.9967977954774105],
            [4.206781415930108, -3.0005573648415984],
            [4.212731941686424, -3.0006899541652907],
            [4.217843170695525, -2.997823503880072],
            [4.224179313569358, -2.999598919315316],
            [4.2291211022826705, -2.9993227507658182],
            [4.229439043136429, -2.9913812975312037],
            [4.221832810788342, -2.987954570624632],
            [4.217075227520629, -2.9869601615140953],
            [4.2143170424817225, -2.984729493748179],
            [4.214046997475297, -2.9808574589186065],
            [4.216285571129971, -2.9748829683665226],
            [4.214958341841491, -2.9722683558402334],
            [4.209271431111007, -2.9729131127697954],
            [4.2082158188787435, -2.971212286278307],
            [4.211763953198315, -2.9665277314228358],
            [4.203026010743035, -2.959675800939691],
            [4.20768916739753, -2.957404699344978],
            [4.2074464487576595, -2.9490897831756047],
            [4.204807815147471, -2.9454030032284266],
            [4.200874731858281, -2.9434804644215946],
            [4.199362158089506, -2.9361879380864684],
            [4.202278736792467, -2.93292976095342],
            [4.20078792388099, -2.928450123393982],
            [4.20564131916343, -2.924052803950932],
            [4.204813954363201, -2.918139224664413],
            [4.209683156929485, -2.9179533466205707],
            [4.210069421812688, -2.924096351766736],
            [4.213319421134096, -2.924051105745323],
            [4.217902043084214, -2.9177067255072924],
            [4.216516112618492, -2.9122958373680023],
            [4.220960826244423, -2.9062959040410696],
            [4.219842516962897, -2.9005156396812475],
            [4.215838680939905, -2.896334035269113],
            [4.219715398830302, -2.892718992193315],
            [4.221517669335018, -2.8887001808958903],
            [4.227389474683149, -2.887002674397297],
            [4.226394939236656, -2.880768203423654],
            [4.232950528212312, -2.8789749991135456],
            [4.230901553737626, -2.871596724187442],
            [4.233160915630648, -2.869323859562441],
            [4.241205831955727, -2.868397876906352],
            [4.24788291301828, -2.8693380052064943],
            [4.249635719153645, -2.867444905045709],
            [4.247480313422037, -2.8630924204656014],
            [4.253208255096506, -2.858824608729662],
            [4.249990085957322, -2.852295684411671],
            [4.255210886065278, -2.8484018993897733],
            [4.255275999411165, -2.842253007384527],
            [4.25816704737807, -2.8412880232864874],
            [4.2627514360941605, -2.845718408369459],
            [4.265893831863864, -2.8416435601846173],
            [4.269117663608761, -2.8408180098684386],
            [4.275122214783628, -2.8357978067291696],
            [4.281834870570764, -2.833458368357377],
            [4.278423120802756, -2.829365059258286],
            [4.2707072365237675, -2.829448274514713],
            [4.271508531916565, -2.8222482030720664],
            [4.2745333662304805, -2.824813052013698],
            [4.277357935211962, -2.82440160743531],
            [4.280027334584614, -2.820940973560248],
            [4.283554634588034, -2.8196403915115913],
            [4.293187874728248, -2.8194788902572543],
            [4.29362897182485, -2.8155773824944546],
            [4.289382656756383, -2.815418833208843],
            [4.287215963760484, -2.8110575591445763],
            [4.2921547600268815, -2.8093124349523846],
            [4.285886155101014, -2.8039233716189043],
            [4.279807301900353, -2.802496612463869],
            [4.280295093976385, -2.797976138510577],
            [4.285047858267949, -2.7976203255372982],
            [4.288140020014508, -2.7991307288276284],
            [4.292833295972028, -2.7952380211269148],
            [4.2944651157669, -2.7887262573047416],
            [4.303466576159274, -2.781947974157202],
            [4.299922860342355, -2.7797372217360294],
            [4.301795971110006, -2.7740769198107302],
            [4.306238641726467, -2.7730388914926793],
            [4.308718467806284, -2.7669390198806947],
            [4.304857813823989, -2.762946888418552],
            [4.30428611574486, -2.757814108553427],
            [4.301168591662845, -2.7526509099917207],
            [4.302921665289075, -2.748581992131509],
            [4.305874535153029, -2.749543595383177],
            [4.307233356468265, -2.7556632497175433],
            [4.310373926683289, -2.7549710649833568],
            [4.306881181633323, -2.7476529094536426],
            [4.311604867340631, -2.7457655842595408],
            [4.31659483982695, -2.7466341022586804],
            [4.316489616121401, -2.7402200662528364],
            [4.364477115081849, -2.7377773549120374],
            [4.4127982913003505, -2.7383415539457205],
            [4.449829777348367, -2.7384121639995143],
            [4.452512571825612, -2.8275620131667134],
            [4.454026174355131, -2.8573513339740897],
            [4.453916643328545, -2.8622882226286896],
            [4.454964358539103, -2.9015251161646045],
            [4.455564430990546, -2.9163628835433206],
            [4.456888384473064, -2.955432754782187],
            [4.46166826078046, -3.0650441604329117],
            [4.465552053225933, -3.1393679234047274],
            [4.467739545623223, -3.183570617310105],
            [4.472099481521646, -3.272804949332578],
            [4.456822619778691, -3.273300615002201],
            [4.360518725750419, -3.2758039063036435],
            [4.343289207484658, -3.2769144947216913],
            [4.307438541610526, -3.277831218254355],
            [4.300829277849021, -3.278211863662321],
            [4.29996383956316, -3.2635174045326907],
            [4.296018427810526, -3.2058401609637044],
            [4.295213591642826, -3.1895220435297182],
            [4.2167562143845645, -3.1941399112199442],
            [4.21953177310061, -3.199991895164247],
            [4.114033963437035, -3.2040501790351414],
            [4.056131244616556, -3.205192701557388],
            [4.028052782900252, -3.2058890984949167],
            [4.027303539286489, -3.1675182082896676],
            [4.0258298024901835, -3.1172220830669075]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.21452058495414, "lat": 35.59928458783683 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05067"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00066861"
      },
      "bbox": [
        4.0258298024901835, -3.278211863662321, 4.472099481521646,
        -2.7377773549120374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.717518250644932, -4.788588341045163],
            [1.7210828928216255, -4.7896458954990795],
            [1.7265019758330018, -4.784718082854047],
            [1.7290838985129302, -4.787016125384604],
            [1.7311417019704198, -4.792375027861541],
            [1.7373831638894937, -4.796175992488561],
            [1.7435655577898117, -4.7922247466860215],
            [1.7463594250518706, -4.798299165392213],
            [1.7523982943621137, -4.796842771228101],
            [1.756905018519969, -4.797274759032547],
            [1.758840806151038, -4.800213978292091],
            [1.7699348411043907, -4.802517388684848],
            [1.770823122463637, -4.79880152632049],
            [1.7692050144425586, -4.791888059200534],
            [1.7630930869223467, -4.78921705703502],
            [1.7657084753419756, -4.784367983286633],
            [1.774153882116985, -4.783255491043296],
            [1.780831114028788, -4.787657354722955],
            [1.7885091828846162, -4.7882421323773725],
            [1.793077915264437, -4.787252168289084],
            [1.7972541545253755, -4.790767099570864],
            [1.7980387110139526, -4.794791332803873],
            [1.7928502593522875, -4.802840834646849],
            [1.7882160178661686, -4.804247528107715],
            [1.784941593228283, -4.800838564671658],
            [1.7814099110686985, -4.802271493095913],
            [1.785161473224307, -4.809830445698782],
            [1.7920945800176589, -4.80906085866299],
            [1.7940592681113732, -4.8128260067800115],
            [1.7939909820614117, -4.81785548902262],
            [1.7918846035783156, -4.822130210628244],
            [1.7906553217434236, -4.8329824148383755],
            [1.797956558942449, -4.834153955110051],
            [1.8032393185003752, -4.8369716844903525],
            [1.8073872842468073, -4.83751833064755],
            [1.8127268908773655, -4.840015163274373],
            [1.813593818778538, -4.842013287278614],
            [1.8088652601920359, -4.847149429573695],
            [1.8034644574043206, -4.847300914642162],
            [1.8059388335728246, -4.850951306950929],
            [1.8129885508488202, -4.849762377221219],
            [1.8170392390501526, -4.850406558593675],
            [1.8243049420316502, -4.848379588788054],
            [1.8306016281730995, -4.845492310271318],
            [1.836374739570761, -4.849879492599967],
            [1.8321982311438534, -4.857157786858359],
            [1.8365920305392047, -4.86677827269451],
            [1.8409392851420439, -4.867019478482363],
            [1.846496600822375, -4.864456257731988],
            [1.8490943989607158, -4.867344024113588],
            [1.8434204503664111, -4.870872216921401],
            [1.8432242572899886, -4.873952669781007],
            [1.851826881635637, -4.871674958638677],
            [1.8558587854859323, -4.8745090118435535],
            [1.8597128191594716, -4.873328335699347],
            [1.8637541820430779, -4.876576425584195],
            [1.8626543771141444, -4.881367562089607],
            [1.860551010875436, -4.883540240334383],
            [1.8609208897204375, -4.892735237195707],
            [1.8625728890267195, -4.895826885091942],
            [1.8678433033328439, -4.896995823508393],
            [1.8686757646334566, -4.90040409929377],
            [1.863533837558094, -4.901631130156961],
            [1.8657099920866176, -4.906015289008372],
            [1.871006974921852, -4.903857812684936],
            [1.8751328267921141, -4.898571904570081],
            [1.8784999984840103, -4.897051797590872],
            [1.8822537806104678, -4.89807035977571],
            [1.8853003297314672, -4.904497217136298],
            [1.8889986951018813, -4.904940241591516],
            [1.892033576957443, -4.9097377342425395],
            [1.8962353868191157, -4.907256143118271],
            [1.899750514133918, -4.909430601444644],
            [1.9047887005557875, -4.908212163369335],
            [1.9060175986692145, -4.913964668118805],
            [1.9164912090197208, -4.9193862940090005],
            [1.9160820581301392, -4.923248454182526],
            [1.9250854058403097, -4.922791644224206],
            [1.9242050440720115, -4.918553856473533],
            [1.9286104560217159, -4.914901368327979],
            [1.930015997510938, -4.91049848569347],
            [1.9329547771180235, -4.911443472041838],
            [1.9335993995953762, -4.921894244741833],
            [1.9376926806023291, -4.922828498338123],
            [1.9399049745071135, -4.918570013647105],
            [1.949965922889528, -4.916363914776082],
            [1.9553240949199422, -4.913466841088223],
            [1.959962414349094, -4.913963993178092],
            [1.9620553196998496, -4.919209305313633],
            [1.9591611383012992, -4.923128048968457],
            [1.9610593969634735, -4.930391572246574],
            [1.9567810854330756, -4.937297560888996],
            [1.9602211661498457, -4.9399584487798505],
            [1.9636430274007206, -4.937059667527855],
            [1.9679924412640741, -4.935805242003992],
            [1.9718129975448304, -4.929946299581345],
            [1.977195687748515, -4.93392536056527],
            [1.9790761808194204, -4.940131649917019],
            [1.9828634900608366, -4.942140442039112],
            [1.9870112463436762, -4.940319738493348],
            [1.98611551710051, -4.935306151531599],
            [1.9894497094550496, -4.9331306163716215],
            [1.9928707391540328, -4.935990245230684],
            [1.9927898648491575, -4.939741924890204],
            [1.9954614551493317, -4.943333645761486],
            [2.000610582208715, -4.943721090216895],
            [2.00299100175396, -4.937705143145794],
            [2.01153633741996, -4.940001808095501],
            [2.0131922293872697, -4.935031619522009],
            [2.027189290317598, -4.934411470338656],
            [2.0313226809142035, -4.9366710835445735],
            [2.040209747455367, -4.937539497545479],
            [2.0425507686059845, -4.941041945366209],
            [2.0801497917394323, -4.941476179718674],
            [2.079986878941297, -4.9702288811840045],
            [2.1093463144935116, -4.970348385420187],
            [2.148426474223484, -4.971081630811072],
            [2.1500459920419512, -4.971178447853966],
            [2.1521232804452053, -4.973775722020389],
            [2.1512440615119424, -4.977145967484333],
            [2.1538811804337623, -4.983055402844999],
            [2.1461528133033743, -4.983706686423653],
            [2.144127640616829, -4.981461511712671],
            [2.1399607974542514, -4.982148522785524],
            [2.1414641260165905, -4.986054974301163],
            [2.1402937537374336, -4.994552879075765],
            [2.1442495704726987, -5.003957043838518],
            [2.144777139418075, -5.008977971241359],
            [2.149374168911217, -5.0084090382419975],
            [2.1499725292026626, -4.999310322640901],
            [2.148426094708147, -4.995657000580575],
            [2.1528242647457416, -4.993948913232037],
            [2.15540975510286, -5.000458326246031],
            [2.151549205265739, -5.007953990956164],
            [2.1556381344933095, -5.015247867390737],
            [2.152112022537592, -5.017338746799533],
            [2.147209973793645, -5.015391284786688],
            [2.1429768223487504, -5.018305752798053],
            [2.1441250161797556, -5.023373474084814],
            [2.1480027576645035, -5.0271905746742105],
            [2.148070120309598, -5.031430201146991],
            [2.1460874016487543, -5.035325198196779],
            [2.1465409955139676, -5.039085824989028],
            [2.142778374298539, -5.046696541384494],
            [2.145606120493564, -5.054099330823859],
            [2.1545627594609607, -5.060010948570554],
            [2.159448567590487, -5.061034921873922],
            [2.1614838507494496, -5.0635961449807745],
            [2.163127258847122, -5.072390204138114],
            [2.1681196681090196, -5.074091662734974],
            [2.1729277662410436, -5.068822798219675],
            [2.174496297684911, -5.06509501216815],
            [2.1724222542292737, -5.059797462858441],
            [2.179326176168413, -5.058452359469002],
            [2.184028653662094, -5.05638904558577],
            [2.1880696128941124, -5.058410107902176],
            [2.186629616648271, -5.062721473395552],
            [2.196358905905635, -5.0697332734168565],
            [2.197825169165576, -5.07412027783492],
            [2.1953329230452736, -5.0791812452659375],
            [2.1900764857670043, -5.081108703716763],
            [2.1861482340733707, -5.091173596412572],
            [2.1908438594494544, -5.09321216854303],
            [2.196046796941153, -5.084387429663086],
            [2.203502579823725, -5.081598319153622],
            [2.2070033862105753, -5.083639252924962],
            [2.211371086571078, -5.093016857679043],
            [2.215303324276309, -5.093536687438716],
            [2.2201165246910515, -5.086807103417157],
            [2.228355804323507, -5.089450820237499],
            [2.232600655637899, -5.0950581246013735],
            [2.2320330514393483, -5.1022551616375305],
            [2.2348074188258655, -5.105086672067002],
            [2.240675369028229, -5.106312277933722],
            [2.2437997446390487, -5.102256400800743],
            [2.2497725939485997, -5.1039124338152275],
            [2.2531897942732724, -5.111096421394955],
            [2.2573805634527173, -5.113204639391867],
            [2.261462763953679, -5.110252128528955],
            [2.2610365299379005, -5.114419783733244],
            [2.257594399421423, -5.117157013052085],
            [2.253017699259173, -5.117390371576847],
            [2.24546319157714, -5.113455620529816],
            [2.2331681106508263, -5.11009817177165],
            [2.2255330182583757, -5.114299532237953],
            [2.2221415372125595, -5.119637721801379],
            [2.222050730467191, -5.122555422743591],
            [2.2173747318257044, -5.130520448079794],
            [2.207573085133193, -5.137131628553165],
            [2.203071433800617, -5.141131702257382],
            [2.2013058605788944, -5.139203177273039],
            [2.2029248688978766, -5.1350931945402785],
            [2.2008210518837092, -5.12891509426665],
            [2.195755676941822, -5.1263887495333496],
            [2.1873094298011035, -5.13272290210772],
            [2.1875210297399494, -5.135681983040479],
            [2.191160956831712, -5.1389914621537836],
            [2.195631000822154, -5.140461608813879],
            [2.1991458906961263, -5.145682630566756],
            [2.198423106232433, -5.150782980139919],
            [2.1952153649860793, -5.152723443086802],
            [2.1918062232058615, -5.15203268069775],
            [2.18580030361384, -5.142765515431535],
            [2.17881748802232, -5.140809711575401],
            [2.174816389182622, -5.142078399098975],
            [2.1713937472935196, -5.1466180018853525],
            [2.16659888643422, -5.160036403107736],
            [2.1656402185674986, -5.169012588446948],
            [2.16354878907231, -5.171236543800411],
            [2.1574454597428976, -5.172487239521296],
            [2.1533716503046327, -5.169746576501855],
            [2.1526682912508037, -5.158128605883682],
            [2.151779295716517, -5.154705595339853],
            [2.1481129535806556, -5.15023529639851],
            [2.140109369797681, -5.150170923495751],
            [2.134398059573622, -5.153363877012089],
            [2.131753992191801, -5.158491017673894],
            [2.1326956518579565, -5.16104632802494],
            [2.138116160205451, -5.162956999788287],
            [2.1406759120010914, -5.169170560720007],
            [2.1370436309346257, -5.182140176845822],
            [2.1319866210026293, -5.188222797163883],
            [2.1257380379763275, -5.186338268979363],
            [2.1224387976518786, -5.182504463594545],
            [2.1202549846376013, -5.176010824546672],
            [2.1233805272240156, -5.168540856565994],
            [2.122000326900622, -5.162267875152029],
            [2.118167272081462, -5.159005654067731],
            [2.1145430399665335, -5.158057258411556],
            [2.1094900916910078, -5.159019490734981],
            [2.104808779861346, -5.16374063598579],
            [2.0998236760946805, -5.1669820332262715],
            [2.0828087337429153, -5.172619597878362],
            [2.0675692418101046, -5.174753159953135],
            [2.058996261346948, -5.170813930668637],
            [2.0575921740842364, -5.1664073321820165],
            [2.063377565327832, -5.163612871965711],
            [2.0690671525308537, -5.165207793380499],
            [2.072476751808829, -5.162492020277439],
            [2.072008043697476, -5.1571194848142445],
            [2.0630814387887733, -5.155638551091289],
            [2.0615691924771413, -5.151000280886738],
            [2.058195878090874, -5.152401750689949],
            [2.049881932248935, -5.149300808295203],
            [2.037676789876847, -5.151323802617758],
            [2.0329998893468706, -5.15479668094703],
            [2.0250705074606676, -5.158323603528553],
            [2.019230880958327, -5.158430857525312],
            [2.0170443790400987, -5.172404736528349],
            [2.0137680346956928, -5.174941841780517],
            [2.0100126395195943, -5.172721311258131],
            [2.0085349328618127, -5.167715473195528],
            [2.007269991536796, -5.156448608286895],
            [2.0051202703678133, -5.1546939152994335],
            [1.9998201360992223, -5.160309671100483],
            [1.995582836137128, -5.160218456877361],
            [1.9931009530161323, -5.15754899130902],
            [1.9931988558500757, -5.15413027180844],
            [2.0008250885396626, -5.14616022752321],
            [1.9973076928063045, -5.143835994470886],
            [1.9919855919347533, -5.150010604128639],
            [1.988551358426551, -5.1502515754143605],
            [1.9841271468008916, -5.145192515919843],
            [1.9837590739081268, -5.137144779351379],
            [1.9720884807892871, -5.135190689485618],
            [1.9657455450069916, -5.131695008891224],
            [1.9555545780686352, -5.14489303853454],
            [1.949739089627726, -5.145908629406112],
            [1.9435917652120793, -5.143689685198134],
            [1.9384836621774455, -5.1461989846507254],
            [1.9394400383885377, -5.150539955767245],
            [1.9434699178642638, -5.153090833122663],
            [1.9518865964890169, -5.15084900444173],
            [1.9574759098493237, -5.152923343940505],
            [1.9614258821692434, -5.164108001740813],
            [1.9603188795374829, -5.168932029212794],
            [1.9561794332782165, -5.171561339264232],
            [1.9521217613657438, -5.168926477021422],
            [1.9500057322529105, -5.160218927420643],
            [1.9462893823460319, -5.159922654150998],
            [1.9417894647889538, -5.163795926552832],
            [1.9372753387096318, -5.170940356505535],
            [1.9314020970059507, -5.174243670206997],
            [1.921881427516732, -5.174657794696015],
            [1.9116342499097265, -5.170743630037739],
            [1.9097743969404881, -5.165671809688351],
            [1.9107227378046354, -5.162218691175754],
            [1.91614642654507, -5.153824011068728],
            [1.9206351022916128, -5.1505582301191515],
            [1.9225339016197724, -5.141223589657676],
            [1.9193117735176124, -5.137727714082736],
            [1.9145617735982867, -5.138238533188661],
            [1.9090558442344654, -5.141319074472151],
            [1.9048677522055364, -5.145043271083602],
            [1.8985240474793992, -5.154106156250524],
            [1.8915145247990242, -5.169217136438536],
            [1.8877242876931202, -5.170916649640601],
            [1.8807037753674498, -5.170890478264935],
            [1.8779187870526792, -5.169241135553215],
            [1.8771850665932228, -5.164630887779689],
            [1.8781928347075885, -5.1601749731662725],
            [1.8848837968277403, -5.1549547967502125],
            [1.885901717442957, -5.150725187319202],
            [1.883555551602593, -5.146048489532664],
            [1.8789630011164322, -5.145877164036528],
            [1.8714083607854202, -5.151957047923505],
            [1.8672621638768359, -5.159993882681118],
            [1.8644328871561102, -5.168553650867832],
            [1.8651457924911647, -5.1727349966849685],
            [1.862591933643558, -5.176735490942125],
            [1.8544420983257357, -5.179697109717489],
            [1.844151122416056, -5.175379843510562],
            [1.841881547103198, -5.166202975173705],
            [1.8384574881254827, -5.161702477939862],
            [1.8325872474233997, -5.161572756707943],
            [1.8269522721361502, -5.166827292398869],
            [1.8267975058572767, -5.168395817859903],
            [1.831381878214098, -5.176756592564836],
            [1.8300796171257496, -5.18062895228812],
            [1.8243775194029486, -5.185922276508394],
            [1.8182627140530387, -5.184244956391224],
            [1.8030771315396465, -5.185428773289782],
            [1.7965359232825546, -5.182788052062095],
            [1.7939311208019464, -5.178454590578029],
            [1.790032789186424, -5.175868032009057],
            [1.786309014375964, -5.170321234989754],
            [1.7894650994557866, -5.164726166558227],
            [1.7974266118380644, -5.163982183916482],
            [1.8019651362854638, -5.162354566045777],
            [1.8051785239400497, -5.15801467773476],
            [1.8057847606183375, -5.154714085834607],
            [1.8041192074437387, -5.148725495085531],
            [1.8013953493853656, -5.146102292095772],
            [1.7989045425872794, -5.147528829217761],
            [1.7896374917957956, -5.157997355965928],
            [1.7847279544488368, -5.161273606387208],
            [1.7765940977365662, -5.160462345019935],
            [1.765698366751609, -5.143532214433017],
            [1.7622647347602243, -5.13887488186274],
            [1.754375201730225, -5.135964663259101],
            [1.7527492798753235, -5.138651669618635],
            [1.7464945241067362, -5.139363509663212],
            [1.7424335071751038, -5.138096192996021],
            [1.7388314529509423, -5.132088223514802],
            [1.7306636619709908, -5.131050055335242],
            [1.727212605125957, -5.126327149399691],
            [1.729407084548146, -5.1231649734569435],
            [1.7414187386373994, -5.115106071453628],
            [1.7433793515872715, -5.111401415059478],
            [1.7429978628392735, -5.10759121850135],
            [1.7367062348221414, -5.105887125031163],
            [1.7345751628509471, -5.099411248531596],
            [1.746324360763717, -5.095622274022462],
            [1.7475368541590446, -5.089902784827524],
            [1.7460346874483217, -5.0873306468390656],
            [1.7408895286006565, -5.085270044972878],
            [1.7354285660189661, -5.086649568040318],
            [1.7317281073505368, -5.094087467273142],
            [1.7231381430772157, -5.091531244073183],
            [1.7153364813237575, -5.092739001057705],
            [1.7152137328270045, -5.067134909244435],
            [1.7156528312761063, -5.042523531473976],
            [1.715723336609005, -5.0135982536160535],
            [1.7167918155194735, -4.878486670733559],
            [1.7172222310977812, -4.8482066712284295],
            [1.717518250644932, -4.788588341045163]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.23529095388783, "lat": 33.70093678061953 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05081"],
        "coty_name": ["Little River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Little River County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00066874"
      },
      "bbox": [
        1.7152137328270045, -5.188222797163883, 2.261462763953679,
        -4.783255491043296
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.80579954888685, 1.5549177069815263],
            [-19.802116331805788, 1.5504392268448297],
            [-19.7966662482831, 1.548618750290431],
            [-19.789645705216458, 1.535672477332753],
            [-19.774853971569648, 1.529468564866221],
            [-19.768135007552168, 1.5238753962335518],
            [-19.75810465549921, 1.5234299971311474],
            [-19.751056286941026, 1.5272900180267384],
            [-19.74902750309226, 1.5345065056411733],
            [-19.75052534209785, 1.535782258390381],
            [-19.74640132336474, 1.5368283833452283],
            [-19.73476847371581, 1.5337430817005853],
            [-19.715784073783958, 1.530408268641026],
            [-19.713561311584726, 1.5272687687840145],
            [-19.705005026869145, 1.5209418313430265],
            [-19.70102887490037, 1.5196682142436058],
            [-19.688621787503486, 1.5191018291132685],
            [-19.68358601873439, 1.5155386748027249],
            [-19.680608853347202, 1.515107818341998],
            [-19.67633508872107, 1.5176979777866386],
            [-19.673478011293795, 1.5136877102325739],
            [-19.671153865445078, 1.5135982516207271],
            [-19.668954158502153, 1.5071767966329832],
            [-19.665217684699293, 1.5027733204809655],
            [-19.65408045511768, 1.5064350498260815],
            [-19.652649932321314, 1.5076975996451372],
            [-19.635498857383954, 1.5089872557365038],
            [-19.630964017786983, 1.5112184524458898],
            [-19.626590813194568, 1.5101789009487394],
            [-19.623309420394325, 1.5131187908032395],
            [-19.61753475732625, 1.5157140998962164],
            [-19.61169498112224, 1.5197399232896744],
            [-19.51465424809183, 1.4919502723455382],
            [-19.46466879729032, 1.4768989714899274],
            [-19.384426481662903, 1.4544173351087841],
            [-19.31519846264549, 1.435271450855702],
            [-19.315011682693417, 1.4350495365960902],
            [-19.317191312829877, 1.432689521471936],
            [-19.320394882106676, 1.4339564884449516],
            [-19.324971826542594, 1.4307212854699487],
            [-19.32746065935316, 1.4316446368067521],
            [-19.32812225867949, 1.421755245202147],
            [-19.323520361100382, 1.4175769344864895],
            [-19.321504348353002, 1.4138001085656022],
            [-19.32213972422813, 1.4104099817242342],
            [-19.31976168209756, 1.4067328056193031],
            [-19.31604857912362, 1.4056749569958082],
            [-19.317812182676505, 1.3976314235842864],
            [-19.31842942301185, 1.3905849747052397],
            [-19.326672542398747, 1.3845490308872705],
            [-19.327273009989526, 1.3788650608825275],
            [-19.330710008058222, 1.3777776548977902],
            [-19.32811223989741, 1.3683641002006761],
            [-19.32582372508887, 1.3686781785404425],
            [-19.322820874858103, 1.3582243708446402],
            [-19.32381306800005, 1.3525296746909805],
            [-19.326041546022722, 1.3473835158621157],
            [-19.32241179641634, 1.3454456210770998],
            [-19.320632195756545, 1.3418610404248097],
            [-19.31623032021232, 1.341790717730544],
            [-19.31027852841019, 1.3436834460574525],
            [-19.307343502782206, 1.3408953324277155],
            [-19.3018127323571, 1.3387516615572472],
            [-19.29909610640947, 1.334971884705386],
            [-19.294206105433403, 1.3322717780082323],
            [-19.293907323337, 1.323017744777783],
            [-19.300317527650993, 1.3197951393678455],
            [-19.30599034913796, 1.3093421108888443],
            [-19.308788456088127, 1.3086914049534988],
            [-19.31079683621734, 1.3047888415707833],
            [-19.309490815334463, 1.2981192087180746],
            [-19.31235813315978, 1.29045758139482],
            [-19.307311162278786, 1.2743164761766193],
            [-19.31108124098055, 1.2688676739294065],
            [-19.309946436398786, 1.2654366629456237],
            [-19.31071678622281, 1.2569076106645594],
            [-19.31269087416725, 1.2540599722251793],
            [-19.31762796559094, 1.2518867069120179],
            [-19.326046638412677, 1.2464774074526792],
            [-19.327607813054925, 1.2428741124112876],
            [-19.333718114978936, 1.2442418827237804],
            [-19.33864722219362, 1.2424285994376212],
            [-19.34251797652561, 1.2483753334536],
            [-19.347872750205994, 1.2470185471487494],
            [-19.348091229858483, 1.2432690585233757],
            [-19.353826979042132, 1.238299707596527],
            [-19.35800854258249, 1.2380745813080498],
            [-19.355628948967734, 1.2316064169098444],
            [-19.360052475250598, 1.2181190961505144],
            [-19.362468596282216, 1.216481012337516],
            [-19.362210890029697, 1.2107646085433454],
            [-19.364398536651027, 1.2049685275272342],
            [-19.3586433596976, 1.1842192193461327],
            [-19.351780706963847, 1.1788718453023068],
            [-19.349008913708264, 1.1735900962064234],
            [-19.34624745794201, 1.1711983696457777],
            [-19.3472742571227, 1.1640393174681931],
            [-19.34502593747251, 1.1596927511855497],
            [-19.3471212326439, 1.147432538807925],
            [-19.345455442909437, 1.1427087309801658],
            [-19.34573921009021, 1.1372094511829913],
            [-19.347858071116928, 1.1334049658215142],
            [-19.347082005755528, 1.1284141031608148],
            [-19.352129185263912, 1.1198345684866307],
            [-19.34934251173187, 1.116644048666335],
            [-19.35078428066049, 1.1110044713387974],
            [-19.350461384210664, 1.1033252268186111],
            [-19.348085753610437, 1.1015558965670542],
            [-19.348301941405232, 1.0973685888275841],
            [-19.34402055026045, 1.093337164560001],
            [-19.341577377546596, 1.0954066927169324],
            [-19.3356089829598, 1.0945482614614563],
            [-19.332550827264313, 1.100146535138261],
            [-19.33360663003205, 1.103079198444228],
            [-19.332634942150236, 1.1084088100896283],
            [-19.32824059451333, 1.109822354155314],
            [-19.32184137385912, 1.1143071082515166],
            [-19.320187760358685, 1.1169937732130455],
            [-19.313453080836187, 1.1186650304108432],
            [-19.311564479928368, 1.1214884983957427],
            [-19.304909966288207, 1.1200718545417576],
            [-19.299959800005045, 1.1145552939001762],
            [-19.29822134359793, 1.1080921928485385],
            [-19.295288976378945, 1.106585046271361],
            [-19.29133719609131, 1.1018370957827166],
            [-19.289776123714567, 1.0971611631308822],
            [-19.278310655551376, 1.0960838442219982],
            [-19.275924709906594, 1.097663034055157],
            [-19.272564499837436, 1.0931887732019074],
            [-19.269553214054035, 1.0939572205229253],
            [-19.267040208111993, 1.090973153875809],
            [-19.25938924417106, 1.0953430585092707],
            [-19.258745775539804, 1.098615536826451],
            [-19.25350185172776, 1.1031635451764565],
            [-19.24994189287216, 1.1048472621033798],
            [-19.24600431793841, 1.0986099983829756],
            [-19.245707356001848, 1.0928642774437642],
            [-19.243542383250244, 1.0900209898640965],
            [-19.241152172646505, 1.0771305619763507],
            [-19.23132847433589, 1.072561534708552],
            [-19.227339666103333, 1.072427583497591],
            [-19.22257444699384, 1.0697025496457653],
            [-19.223821425536208, 1.062215834825062],
            [-19.223123677847465, 1.0503273257789172],
            [-19.220665989950284, 1.0457171819256252],
            [-19.218571248202114, 1.0410196190607919],
            [-19.219167374162822, 1.0360301921513926],
            [-19.216560952876833, 1.0323278364296768],
            [-19.22692414258458, 1.0211940670215274],
            [-19.22709941590877, 1.0182433004367466],
            [-19.231263380274886, 1.0174176490993703],
            [-19.2334573796694, 1.009614024693306],
            [-19.240441001767618, 1.0078237561257253],
            [-19.24416788102415, 1.0080996888632376],
            [-19.24699130680307, 1.005139842158277],
            [-19.245383251510574, 1.0004965426152526],
            [-19.240147004858184, 1.0002297837876941],
            [-19.233802384311254, 0.9908771787391165],
            [-19.23385457795143, 0.9855254383085557],
            [-19.229636287702757, 0.979576258334262],
            [-19.225196607907744, 0.9773450320125634],
            [-19.227209928645458, 0.9678906452096697],
            [-19.231287566311355, 0.9652477435674272],
            [-19.235074859890013, 0.9684118928274661],
            [-19.241811669052694, 0.9649405157742637],
            [-19.244084307115426, 0.9526606451281532],
            [-19.253698410921935, 0.952346834059633],
            [-19.25887306202237, 0.9482811255406929],
            [-19.264015484910733, 0.9515359385408536],
            [-19.264227064911548, 0.9433144157209437],
            [-19.25936236857642, 0.929165520193203],
            [-19.262136243079038, 0.926409662745962],
            [-19.261370040606288, 0.9150956149754387],
            [-19.268286841815183, 0.9149205928298294],
            [-19.272231692781585, 0.9113283151800723],
            [-19.274934390088394, 0.9059177740446666],
            [-19.27542451157723, 0.9018535031313789],
            [-19.271540544479283, 0.8904236422117251],
            [-19.268667620405594, 0.8852180204480204],
            [-19.263483677546997, 0.8822824836387316],
            [-19.260755458433902, 0.8768729823714048],
            [-19.257922489382736, 0.8743007012029365],
            [-19.36314580957607, 0.9018619917312232],
            [-19.37640631663648, 0.9058621748277562],
            [-19.412970953435014, 0.915869776042806],
            [-19.421837944592077, 0.9323624323144721],
            [-19.423020621947163, 0.9374256353543727],
            [-19.42919561163572, 0.943772256709613],
            [-19.431987288924063, 0.9496708376819325],
            [-19.441125461790246, 0.9490577339352856],
            [-19.443603522812506, 0.9468809370644433],
            [-19.44281253084821, 0.9426290487851986],
            [-19.446559676428357, 0.9420642550143284],
            [-19.460883472296427, 0.9526735354546005],
            [-19.473461013423073, 0.9443484547305023],
            [-19.480747744659702, 0.9377181485557726],
            [-19.487276601161312, 0.9245346787379343],
            [-19.490025196604975, 0.9209056108131703],
            [-19.497909639625316, 0.9173534389623438],
            [-19.499648258769323, 0.9151083767943221],
            [-19.50959643290053, 0.9113993575985075],
            [-19.516088508629128, 0.9065846534316121],
            [-19.516560689095265, 0.9026696149695744],
            [-19.52834153666137, 0.9000859010064864],
            [-19.533396408899428, 0.8965244740355856],
            [-19.53668374898718, 0.8896853822326083],
            [-19.53836918705992, 0.8839075747066384],
            [-19.546871353682022, 0.8862134033844409],
            [-19.551942010218426, 0.8841180016092787],
            [-19.553918707432672, 0.8903318714628548],
            [-19.54836945616439, 0.9098510141251644],
            [-19.55523921443219, 0.9117461149156186],
            [-19.553538938654494, 0.9185021423228747],
            [-19.56638845120795, 0.921943992541748],
            [-19.576024531474744, 0.9393134774262554],
            [-19.580275475261786, 0.9409594818442948],
            [-19.585708508272518, 0.9408995097883475],
            [-19.590403930885945, 0.9393675174138655],
            [-19.59086991860007, 0.9351819970579613],
            [-19.594183390133097, 0.9362008721261513],
            [-19.597190457132193, 0.9469006208871972],
            [-19.595561504140292, 0.9557022676477794],
            [-19.602252736166616, 0.9588807835836416],
            [-19.599981541486727, 0.9658989703916654],
            [-19.600224576410746, 0.970745952050875],
            [-19.604166653991996, 0.9717605791911478],
            [-19.609383793854096, 0.977614024080891],
            [-19.61687077910109, 0.9787458574623539],
            [-19.620754447749917, 0.9811616518590589],
            [-19.62325468268331, 0.9864376829866356],
            [-19.617758875157566, 0.9980567927141198],
            [-19.625000347957904, 1.0012109123730148],
            [-19.62436205582382, 1.0042973073681631],
            [-19.627305412611356, 1.0064155099819676],
            [-19.63211745728722, 1.0129441387070308],
            [-19.64299568985502, 1.010997062865278],
            [-19.640446478526584, 1.017675925620906],
            [-19.629553535228403, 1.024800730398325],
            [-19.635830460248275, 1.0289569021271165],
            [-19.640729572297808, 1.0360578386324306],
            [-19.632354575615295, 1.0414950587937561],
            [-19.63977528128221, 1.0481958095265569],
            [-19.646012612693692, 1.06963575420561],
            [-19.647778201019996, 1.073940067578305],
            [-19.650671140948457, 1.0726167729064253],
            [-19.65328105407355, 1.0750393627064976],
            [-19.653919630042992, 1.07947087619031],
            [-19.658659667213723, 1.0800967420126257],
            [-19.664026135163134, 1.0861687862725777],
            [-19.66637647924508, 1.0922282700394625],
            [-19.671182466394995, 1.0958285055487975],
            [-19.673113767271023, 1.0955799066474112],
            [-19.67638182256594, 1.1006075002603402],
            [-19.68165134946735, 1.1039719586786165],
            [-19.68268446887815, 1.1103941648934788],
            [-19.68550408114541, 1.1140349048090725],
            [-19.6848157879417, 1.1200680670532763],
            [-19.688076966817714, 1.1249061994100829],
            [-19.6935208316693, 1.1275022031675115],
            [-19.694931118088164, 1.1306514014378413],
            [-19.701447182966273, 1.136135578536449],
            [-19.704053352334995, 1.1413341464394424],
            [-19.713696209011506, 1.1443892963050732],
            [-19.71096033167291, 1.1486830791169982],
            [-19.71913389933856, 1.148947025419796],
            [-19.728834346901724, 1.1575013284513103],
            [-19.731477285941743, 1.1552091378363891],
            [-19.7381967901003, 1.1631538998650521],
            [-19.747031354807795, 1.168318719653059],
            [-19.75518422752595, 1.178968503332708],
            [-19.76175435415507, 1.182682768810672],
            [-19.7664076001027, 1.1870039595276967],
            [-19.77577856272823, 1.1929819078400055],
            [-19.781576337023143, 1.1988620344608831],
            [-19.78617532188772, 1.2088721199067143],
            [-19.79248083123236, 1.211428793164575],
            [-19.796590116630078, 1.2152407295311762],
            [-19.799733094925834, 1.215546437321482],
            [-19.800571270695645, 1.2217053562494256],
            [-19.803751940685462, 1.2273943323987144],
            [-19.804864793902706, 1.2318617255053412],
            [-19.807120182046315, 1.2323079044914327],
            [-19.813595275141523, 1.2412509510878493],
            [-19.820232316315497, 1.2449787696397956],
            [-19.819241460053572, 1.2579104082225558],
            [-19.819869987935085, 1.2650998533554743],
            [-19.817390518205833, 1.2684404485501148],
            [-19.823594642656452, 1.2756161346423605],
            [-19.826064579917038, 1.2865499949470076],
            [-19.830107111181782, 1.2932714033453407],
            [-19.833488364262667, 1.2967462358945567],
            [-19.83852711153263, 1.2957975120799188],
            [-19.839910680474134, 1.3027504300629673],
            [-19.846102414300073, 1.3115168719686678],
            [-19.8531360860084, 1.31339188259173],
            [-19.854203319928374, 1.3199534430813418],
            [-19.85843974931788, 1.3257086546504222],
            [-19.861069176719123, 1.327162486945014],
            [-19.860314166890717, 1.333735489844762],
            [-19.863492740225094, 1.3439025141354324],
            [-19.867623788185313, 1.3544853109257882],
            [-19.872455086970625, 1.356505041792948],
            [-19.87610611390752, 1.3616388742175067],
            [-19.876299583769413, 1.3641163526316418],
            [-19.881506410942606, 1.3706198897443163],
            [-19.883481570306373, 1.3787923431312261],
            [-19.881989945436136, 1.3820740828719837],
            [-19.883324017724654, 1.3877528835199433],
            [-19.88474409073569, 1.3941924166555901],
            [-19.891843946757817, 1.399789679130363],
            [-19.88713005694458, 1.4044030378781747],
            [-19.885907708361096, 1.4077386817391748],
            [-19.88880204653248, 1.4098189181251672],
            [-19.890259601617327, 1.4169072647156293],
            [-19.89384264933094, 1.4187239563286878],
            [-19.899656313375687, 1.4169877159692272],
            [-19.901531335318907, 1.4197645821707352],
            [-19.901446848456533, 1.4239504324636294],
            [-19.90483601101302, 1.4281730021055676],
            [-19.89940212324293, 1.4300317370599818],
            [-19.89576090498798, 1.433412775583481],
            [-19.889712775272933, 1.431185735359411],
            [-19.893554055102587, 1.4397356954317873],
            [-19.89439694590698, 1.4461043162182787],
            [-19.89838730462399, 1.4538368884704587],
            [-19.898594777938065, 1.4597523305199065],
            [-19.900978851356918, 1.470593857308389],
            [-19.89643144905723, 1.4815734577000705],
            [-19.887710437094608, 1.4904090148904643],
            [-19.885669919807448, 1.4915777762876352],
            [-19.882046042041555, 1.501521952070322],
            [-19.881894756165597, 1.5148572991034226],
            [-19.878600782544247, 1.5204908760502622],
            [-19.874694324739334, 1.5204073948760168],
            [-19.87320239792401, 1.5278123141140039],
            [-19.874672006633926, 1.531374704100096],
            [-19.87249875740315, 1.5366914855919118],
            [-19.86713679837826, 1.5384667738407312],
            [-19.863853732779244, 1.5431878193818247],
            [-19.858296704440765, 1.5441416412433653],
            [-19.856322929343243, 1.546620810121423],
            [-19.851632573279048, 1.5480600332483925],
            [-19.84741780633147, 1.5525644541654267],
            [-19.83744669795225, 1.5537711007156154],
            [-19.830537763523285, 1.5534189388738995],
            [-19.82680998398219, 1.548803345840837],
            [-19.81911542003244, 1.5444676272698823],
            [-19.814099822345973, 1.5446310817010425],
            [-19.813749381189346, 1.5518465589432646],
            [-19.80579954888685, 1.5549177069815263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.69512099231221,
          "lat": 37.231780087610126
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06085"],
        "coty_name": ["Santa Clara"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Santa Clara County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00277307"
      },
      "bbox": [
        -19.90483601101302, 0.8743007012029365, -19.216560952876833,
        1.5549177069815263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.994969198686266, 1.077978830185206],
            [-4.994653612840567, 1.0782637235836563],
            [-4.903064868234174, 1.0732175679453595],
            [-4.8987310574609975, 1.072745647412769],
            [-4.841288096311101, 1.0693142434700686],
            [-4.774200897804481, 1.064554305158245],
            [-4.727133411190245, 1.0604939239083633],
            [-4.67866144671775, 1.057180093680444],
            [-4.581893233491085, 1.0512563076390018],
            [-4.550241830460307, 1.049500110980589],
            [-4.535799588922378, 1.049862319021377],
            [-4.469894266724381, 1.0455227370288693],
            [-4.406366531486368, 1.0411027866849902],
            [-4.370633953696431, 1.0390225514367841],
            [-4.305928468564808, 1.0358666513043835],
            [-4.304947497177056, 1.0356554058926624],
            [-4.152897677225161, 1.0279029195450224],
            [-4.153242954374165, 1.0219805494774408],
            [-4.154960938041075, 0.992511334637946],
            [-4.157159008992807, 0.9595313009129723],
            [-4.162242097950218, 0.8760626106721703],
            [-4.16925607881352, 0.7549380954427215],
            [-4.174117278870607, 0.67144468362787],
            [-4.179203854447333, 0.5836176248985563],
            [-4.184257398984513, 0.49683040895674296],
            [-4.362805146155954, 0.5077286111898576],
            [-4.430869118196243, 0.5115289564173262],
            [-4.436859057417131, 0.5111458920170221],
            [-4.471369199301867, 0.5127843046382315],
            [-4.50640987271436, 0.513696028341302],
            [-4.5670290376719045, 0.5161139246671592],
            [-4.662664937766667, 0.5211785630713246],
            [-4.698449891581454, 0.5229413244497126],
            [-4.704744186474453, 0.5249295547573138],
            [-4.719126228192557, 0.5257851550256218],
            [-4.899095976826971, 0.538057161520341],
            [-4.955783657564042, 0.5425032853650437],
            [-5.005269988397128, 0.5450804009165916],
            [-5.012718580079566, 0.5457892966808501],
            [-5.0416934554592805, 0.5469679402531401],
            [-5.034858812262803, 0.6379573129096858],
            [-5.028868583842952, 0.6374981843857147],
            [-5.027686595344995, 0.651452114567194],
            [-5.016745030890194, 0.7975462030783325],
            [-5.00903861624527, 0.9002058506243286],
            [-5.000179267099778, 1.0132871317935048],
            [-4.994969198686266, 1.077978830185206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.60296490794163,
          "lat": 39.30551262723369
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08063"],
        "coty_name": ["Kit Carson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kit Carson County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00198147"
      },
      "bbox": [
        -5.0416934554592805, 0.49683040895674296, -4.152897677225161,
        1.0782637235836563
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.269317283882478, 1.196843392623483],
            [-8.205971788080399, 1.1891048288354986],
            [-8.135826027959787, 1.1808288101271178],
            [-8.095711585325391, 1.1758609477509272],
            [-8.027885824640997, 1.1679668157662866],
            [-7.988713627623835, 1.1635752824748626],
            [-7.9567478917122285, 1.1597158146817126],
            [-7.921409099658271, 1.1551116781267488],
            [-7.74503735227953, 1.1316146779099399],
            [-7.732136115373989, 1.1303641842597818],
            [-7.723563551266005, 1.1287525383570538],
            [-7.715560461135769, 1.1282240960977563],
            [-7.620854385465917, 1.1172918424153586],
            [-7.561988881330221, 1.110966171312306],
            [-7.553500392670858, 1.1095133838531195],
            [-7.505631036074499, 1.1042826691942575],
            [-7.511805845165418, 1.097147121570086],
            [-7.513805399953481, 1.0903619546383716],
            [-7.513702621118823, 1.0804164961313025],
            [-7.510915814060503, 1.0769585089606204],
            [-7.510238354619162, 1.0656793952853256],
            [-7.514887997458326, 1.0594316703320505],
            [-7.520673778772092, 1.0607020519756067],
            [-7.523007713686989, 1.0588980250379412],
            [-7.527370994547423, 1.0608041382059237],
            [-7.530468245013238, 1.0601051396784156],
            [-7.532240109554581, 1.0568379445041818],
            [-7.5358533144607875, 1.058031130090028],
            [-7.541417262877878, 1.056881056321408],
            [-7.543493791804742, 1.053060774303924],
            [-7.546879671428898, 1.0545604290549575],
            [-7.548726232191994, 1.0611878830834593],
            [-7.5557457722092805, 1.0597490900052677],
            [-7.562331226586713, 1.0517755308374075],
            [-7.568235440960463, 1.0498780425143592],
            [-7.570742808643249, 1.0466870179414989],
            [-7.573246044207835, 1.033451600395642],
            [-7.569669810470042, 1.0275342644199876],
            [-7.565807668481979, 1.0253867281159479],
            [-7.563716013865109, 1.0205930113926618],
            [-7.558786153989398, 1.019568617983667],
            [-7.560187404689799, 1.0123376099643138],
            [-7.559390244650662, 1.007615315879852],
            [-7.560568002809511, 1.0020747915455175],
            [-7.563053001077101, 1.000987097698305],
            [-7.565898277035824, 0.9958486349584266],
            [-7.572831610461698, 0.990716540452328],
            [-7.574759830285421, 0.983012743464597],
            [-7.5687058039391175, 0.9750161260608549],
            [-7.572848655324703, 0.966344974882731],
            [-7.572460846396509, 0.9633871889825284],
            [-7.574560056070259, 0.9577628359195485],
            [-7.574949601034607, 0.9458572461494336],
            [-7.579213442061108, 0.9399193292454512],
            [-7.581106613795359, 0.9318355936400452],
            [-7.587099563110607, 0.9273887419290803],
            [-7.590061755035118, 0.9234903925916039],
            [-7.589892070143957, 0.9153747080962874],
            [-7.592122851086207, 0.9124240355450384],
            [-7.600510773874256, 0.907056587893849],
            [-7.604829304692069, 0.9112855828710834],
            [-7.610870413955586, 0.913995124827588],
            [-7.613703895698788, 0.9090969257550767],
            [-7.6185531072478625, 0.9106302865799656],
            [-7.6233428659090885, 0.9137977452463223],
            [-7.628079877209553, 0.9094961347534979],
            [-7.631309102870024, 0.908807088142391],
            [-7.63276945574822, 0.9051813385945721],
            [-7.630659249816755, 0.8967184642657395],
            [-7.632751249507221, 0.8908340259819747],
            [-7.636439299577709, 0.8857584765455773],
            [-7.633707720830041, 0.8814170990948131],
            [-7.632915505642235, 0.8729741888721643],
            [-7.638816301154463, 0.8673185963736738],
            [-7.63894691058072, 0.8592415878221509],
            [-7.64295103161078, 0.8576244927606568],
            [-7.648797768860542, 0.8582693874727509],
            [-7.651849174068049, 0.8567443846033059],
            [-7.657225332954668, 0.8491032895388574],
            [-7.658071399272421, 0.8427912404669603],
            [-7.656239645716893, 0.8377268078503187],
            [-7.651926302469623, 0.8336670552437111],
            [-7.653958099746662, 0.831963068945902],
            [-7.653065690956739, 0.8270098312745723],
            [-7.6535643852389565, 0.8175281485969867],
            [-7.655020532223205, 0.8121435147286554],
            [-7.6552301235321005, 0.8073946382450898],
            [-7.6581640882999755, 0.8031584610602748],
            [-7.664939555606728, 0.8007314796743528],
            [-7.671217180529176, 0.8006609487448082],
            [-7.674202166353214, 0.7897873030651696],
            [-7.67070301438238, 0.7855058801606107],
            [-7.66921544550445, 0.7802235919736219],
            [-7.672146663169847, 0.7763724103810753],
            [-7.67365737350267, 0.7596538402518289],
            [-7.677993143395466, 0.7538499794722916],
            [-7.687755826727277, 0.7523431375782453],
            [-7.689168249747615, 0.7560144452221541],
            [-7.692848591214423, 0.7601870508134881],
            [-7.696450890807403, 0.7616498452563598],
            [-7.6999721061143935, 0.7707565268746484],
            [-7.705691293926122, 0.7739327132871247],
            [-7.705523506298589, 0.7785047470819297],
            [-7.712884170643281, 0.7823080184168556],
            [-7.713435997979081, 0.7876569345820198],
            [-7.710476755221583, 0.790870587090873],
            [-7.71119512889441, 0.7962320939843732],
            [-7.713918610352322, 0.7994521635053161],
            [-7.7157979349553765, 0.8052583221784371],
            [-7.721714100015765, 0.8033654552739087],
            [-7.727611223182691, 0.8059978753171197],
            [-7.729829495223591, 0.808252428106194],
            [-7.738484898203667, 0.808794196966589],
            [-7.743259377532318, 0.8191698043373653],
            [-7.7508428226137385, 0.820892520654476],
            [-7.754794923833164, 0.8188412609328687],
            [-7.757346236081701, 0.8131509254651431],
            [-7.7625401609654245, 0.8144744122273735],
            [-7.767057245867967, 0.8117958110324608],
            [-7.772131413375122, 0.8137119528910326],
            [-7.776217915187094, 0.8125883171530986],
            [-7.780756077136096, 0.814110027359162],
            [-7.786385540792533, 0.8087687687163414],
            [-7.785872503242249, 0.7981702639887908],
            [-7.786440023637376, 0.7953613634242653],
            [-7.791186649699026, 0.7948599807078062],
            [-7.800126911758085, 0.7861118226878265],
            [-7.807338244204515, 0.778035442227484],
            [-7.811527750589524, 0.7771883419846541],
            [-7.81445824603758, 0.7725970742874952],
            [-7.819366246993719, 0.7676042340579932],
            [-7.818794024276585, 0.7623864238746323],
            [-7.823685287933138, 0.7564265317201764],
            [-7.828949369788269, 0.7575307283867614],
            [-7.8335667708565095, 0.7553658155301319],
            [-7.835255563175003, 0.7516231021026085],
            [-7.841951582078452, 0.7527727725606996],
            [-7.846419862196158, 0.7560279143953555],
            [-7.854732816676275, 0.7532563393892713],
            [-7.8597448339965235, 0.7570044064447384],
            [-7.860691282166218, 0.7598919702918981],
            [-7.868696389403099, 0.7642924234314713],
            [-7.871091021779389, 0.7713925841773747],
            [-7.874886531970274, 0.7781962731628868],
            [-7.877424963045991, 0.7880884121784993],
            [-7.882359438532297, 0.7860331482157084],
            [-7.889031308606104, 0.7868819354757701],
            [-7.8911699287367085, 0.7829836779037974],
            [-7.889942566665233, 0.779925082935837],
            [-7.891677562746721, 0.774315866309463],
            [-7.89695097584148, 0.7709904676985294],
            [-7.902114743006034, 0.7722105465189613],
            [-7.903767412526314, 0.7708794687979518],
            [-7.9089272770403785, 0.7744877448017333],
            [-7.913633832540956, 0.7746235152522379],
            [-7.91551230428114, 0.7828683677896178],
            [-7.92157148675744, 0.7827470479158443],
            [-7.928990677581611, 0.7890658012861043],
            [-7.933916685848384, 0.7911785484639616],
            [-7.94026727538704, 0.8003975695243507],
            [-7.944863283635908, 0.8031376505214959],
            [-7.9504377903172925, 0.8026772329174529],
            [-7.955237654510224, 0.8052993459774177],
            [-7.954975718166928, 0.811142183928309],
            [-7.953388208801727, 0.8162317978379384],
            [-7.955710225626236, 0.8188789952811457],
            [-7.960867266919567, 0.8174757581734526],
            [-7.965036478824851, 0.819867991271667],
            [-7.971516378871883, 0.8206556904863805],
            [-7.977339854628765, 0.8247652857511076],
            [-7.980581135623398, 0.8333722588087819],
            [-7.979034448607304, 0.8336996035795687],
            [-7.976099980323408, 0.8400368071863581],
            [-7.9703833110456985, 0.8420527124377304],
            [-7.970280102830423, 0.8502331823679707],
            [-7.966597694928654, 0.8522741730267749],
            [-7.967602525219163, 0.8607671732418515],
            [-7.973861449955006, 0.8601080226484673],
            [-7.979556965497353, 0.8672491366305065],
            [-7.982941746580043, 0.875087393038861],
            [-7.988790853652056, 0.882193427549476],
            [-7.9959012949443435, 0.8856063322262262],
            [-8.000942470222236, 0.8892583444942747],
            [-8.003811861152082, 0.8938169785030883],
            [-8.009210124599887, 0.899731030901595],
            [-8.01201552436088, 0.9064514934080549],
            [-8.017163789047682, 0.9084606977634562],
            [-8.021039922794031, 0.9158728885087325],
            [-8.179869970886076, 0.9345396386096074],
            [-8.185219968670681, 0.9357853272854557],
            [-8.187470116756728, 0.941813896312762],
            [-8.185708170013484, 0.9449657206901356],
            [-8.186861833171161, 0.9478004254593851],
            [-8.187856151499824, 0.9568836223869644],
            [-8.191567362776047, 0.9623537315560187],
            [-8.191908948550166, 0.9714841351429322],
            [-8.195150744307403, 0.974852002213898],
            [-8.19766801657892, 0.9741574377064751],
            [-8.203133863952411, 0.9787623577724468],
            [-8.208092281091355, 0.985275268597037],
            [-8.21534985802073, 0.9861703559521946],
            [-8.219700055323006, 0.9878137745050948],
            [-8.221621201121073, 0.9907116815888879],
            [-8.226082978497073, 0.9906222583920214],
            [-8.233610662333678, 0.9961907377545937],
            [-8.233772633845918, 0.9993059638955571],
            [-8.237084723475215, 1.0086696579761225],
            [-8.239712279407541, 1.0104268707973676],
            [-8.24159244298868, 1.0164651181558426],
            [-8.247521102096554, 1.0231660122856303],
            [-8.247905772040086, 1.0295187884440755],
            [-8.249860016159284, 1.0359505502882633],
            [-8.245757828155705, 1.0457612162610574],
            [-8.246257497293286, 1.056980308627289],
            [-8.242902436763064, 1.0623352147067855],
            [-8.2394277425855, 1.0641968294594242],
            [-8.242276566411826, 1.0682450303440607],
            [-8.242122208201021, 1.071134106108383],
            [-8.252454970860272, 1.0772980280750482],
            [-8.254860720420703, 1.0833908849100593],
            [-8.252011706012311, 1.0874113217862718],
            [-8.251645026614472, 1.090711988136416],
            [-8.241657754448179, 1.0948169895844437],
            [-8.239991881770177, 1.0977753328201258],
            [-8.241359679579727, 1.1015306048944682],
            [-8.25181593695687, 1.1069309584212033],
            [-8.253453149416975, 1.1109365469169807],
            [-8.252115417331785, 1.1168275149922382],
            [-8.25323948323098, 1.1226531030411178],
            [-8.257570752321131, 1.1208123827602767],
            [-8.261007554744745, 1.1225605997127341],
            [-8.264619664013974, 1.1208653505202977],
            [-8.270269371684678, 1.1264820853563564],
            [-8.28235508240547, 1.130695372407477],
            [-8.283716314434933, 1.1338358177120258],
            [-8.281634684335229, 1.1378389644352003],
            [-8.287203887407184, 1.1403872930117387],
            [-8.292549598127687, 1.136975550486871],
            [-8.295902440288685, 1.1398205824438912],
            [-8.298683277313645, 1.1459435118976362],
            [-8.301285826249373, 1.155919658333764],
            [-8.298056612565045, 1.1607175900441025],
            [-8.288809599945086, 1.16245464862918],
            [-8.28786601681969, 1.165014314659102],
            [-8.282148991513665, 1.1702609653136644],
            [-8.278137228266095, 1.1723316920653375],
            [-8.276135327920406, 1.1775460555578725],
            [-8.271161336372382, 1.178811479523549],
            [-8.267871192711505, 1.192909189462707],
            [-8.269317283882478, 1.196843392623483]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.91658117880377,
          "lat": 39.21707694507665
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08097"],
        "coty_name": ["Pitkin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pitkin County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00198164"
      },
      "bbox": [
        -8.301285826249373, 0.7516231021026085, -7.505631036074499,
        1.196843392623483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.754330006837215, 5.053267767036086],
            [17.78829339240818, 5.068765367510032],
            [17.790269581038142, 5.080860893793515],
            [17.79852626299821, 5.076559980835276],
            [17.801617334018474, 5.076421148495338],
            [17.811311634620726, 5.073535475423218],
            [17.813499719441733, 5.08017107154709],
            [17.81539739856274, 5.081450175873323],
            [17.816001624631568, 5.0869906873980115],
            [17.819086116451405, 5.0857451073848985],
            [17.825793092000076, 5.08879483870693],
            [17.830710912100525, 5.086744959394119],
            [17.832854591652477, 5.088778638466485],
            [17.839278452294728, 5.090689439538437],
            [17.848722509856504, 5.099445992922412],
            [17.848046706531342, 5.112840055428769],
            [17.84191706394995, 5.122706276267267],
            [17.83484587604349, 5.135413469370602],
            [17.854245922854282, 5.151082627694884],
            [17.86771418900839, 5.17313231729818],
            [17.8752869096324, 5.174187364793236],
            [17.87440333014799, 5.181118695813245],
            [17.870959589329075, 5.18817736520849],
            [17.865864632298184, 5.192034262262824],
            [17.871754505285548, 5.193520627512391],
            [17.87438624692758, 5.199028115571745],
            [17.87396032747453, 5.202336078415387],
            [17.87826359724041, 5.205349324403347],
            [17.881537103677015, 5.212838681895753],
            [17.881684052577725, 5.2170419218313056],
            [17.885285903241254, 5.221312742944117],
            [17.88113836696183, 5.223317123215037],
            [17.878063762552532, 5.228495795022703],
            [17.872968012999145, 5.229292299229528],
            [17.872402599409128, 5.232545925523238],
            [17.9115362905311, 5.242475748102333],
            [17.915299300389748, 5.245751032987311],
            [17.915234316977855, 5.248429072325],
            [17.911074347182044, 5.251527020342076],
            [17.912320510747257, 5.265376061379364],
            [17.915269511601927, 5.272361559140228],
            [17.92546598316197, 5.26703911083102],
            [17.926794901312597, 5.271275976159959],
            [17.932833356841765, 5.270633307175706],
            [17.935204757583165, 5.274726331547662],
            [17.960631704454816, 5.276328267336193],
            [17.96886534152225, 5.275459380526929],
            [17.96967451261164, 5.2413374010808065],
            [17.974504857102293, 5.226721576603068],
            [17.98437892241212, 5.19234827568696],
            [18.00519690720008, 5.192860821596248],
            [18.11182719227093, 5.196544612792795],
            [18.158568069093793, 5.215725120639671],
            [18.161792668720448, 5.204966230725922],
            [18.181121672486967, 5.15694472608463],
            [18.183177508782222, 5.15112222720531],
            [18.20562299254819, 5.096955491610242],
            [18.22237874642743, 5.09810566532932],
            [18.25817527904876, 5.101048853052154],
            [18.277821841186967, 5.013773436997032],
            [18.275412719798904, 5.011941195937126],
            [18.266180513979954, 5.013551752769231],
            [18.260835902305182, 5.012144206905627],
            [18.25883226338232, 5.007323110131318],
            [18.2528924504783, 5.001995399265367],
            [18.24876499801884, 5.0014840183544695],
            [18.247605390498435, 4.994659835110515],
            [18.250950569088587, 4.988678808344139],
            [18.251224957597717, 4.984734018815766],
            [18.255285907511997, 4.980842854141247],
            [18.26013087980494, 4.978529392009897],
            [18.260713647505774, 4.973712904884109],
            [18.263710531989428, 4.97075812054426],
            [18.263041710483574, 4.967315814139002],
            [18.265003476021185, 4.962924717710872],
            [18.26203421707378, 4.95655343111516],
            [18.263218420992217, 4.951305156898561],
            [18.266449737211392, 4.945317871743632],
            [18.27019754174814, 4.94392992325668],
            [18.27383304785745, 4.935655662094203],
            [18.270573569725002, 4.928171099440544],
            [18.26386802612457, 4.919785585297964],
            [18.26208101074154, 4.914197562720151],
            [18.257004923044498, 4.908302539355107],
            [18.2571402032517, 4.91056933197155],
            [18.249165234379277, 4.914126387132668],
            [18.240745754482152, 4.920467919654932],
            [18.234316687174367, 4.919206116259683],
            [18.230522692834093, 4.914968482490566],
            [18.2266379374153, 4.914231884403812],
            [18.223372277450096, 4.906983623979847],
            [18.211290447199637, 4.9044613594362465],
            [18.205555279521676, 4.907508208286225],
            [18.201658325860087, 4.907600868358539],
            [18.19788267654402, 4.911410636733539],
            [18.191167229067567, 4.9095138499106925],
            [18.18754732095812, 4.898326405549802],
            [18.183161987886887, 4.890581022630125],
            [18.178364442380527, 4.888825093477849],
            [18.168763076457346, 4.89564165264144],
            [18.16681336338923, 4.8950093061314774],
            [18.164854099367805, 4.88487557059748],
            [18.15640729433944, 4.880276360585387],
            [18.156093963494204, 4.868215848287233],
            [18.15189728139, 4.867496167704821],
            [18.141449053059922, 4.874981616974496],
            [18.137611391897536, 4.873162173339911],
            [18.136600501485898, 4.86884421393417],
            [18.13275943578178, 4.868584119387006],
            [18.13119463607557, 4.871344684693233],
            [18.126870827266597, 4.872950144506708],
            [18.121229222525272, 4.872165306248449],
            [18.118479260501363, 4.865104608178905],
            [18.114758108254854, 4.863225243920575],
            [18.110714831283985, 4.865435652631137],
            [18.10842000247428, 4.868637797819707],
            [18.103236828791786, 4.867413032348915],
            [18.089770910275536, 4.85895598113128],
            [18.09193024055868, 4.854598684320872],
            [18.088523566915814, 4.851873357441694],
            [18.08738679647306, 4.847568137609452],
            [18.08297791664557, 4.845496099599203],
            [18.08100643137115, 4.841089463297518],
            [18.07223899720885, 4.841597919827809],
            [18.06475966432347, 4.837245788620837],
            [18.05679091299363, 4.8388510209074935],
            [18.05074168265968, 4.84554575088705],
            [18.045356965405098, 4.84657706989272],
            [18.042289597621103, 4.842770482460836],
            [18.043489447251723, 4.839621024216521],
            [18.04189090290767, 4.835880527032794],
            [18.034417930657995, 4.840070838454773],
            [18.031545946457737, 4.847633399868668],
            [18.027650135957032, 4.851719619545622],
            [18.022583603106195, 4.851982386143845],
            [18.017803180976077, 4.849933979021007],
            [18.01216959150632, 4.8407225199772785],
            [18.011638928100844, 4.837995485130453],
            [18.014438363909427, 4.8240908646645595],
            [18.016932418008643, 4.819552995914991],
            [18.017648195247112, 4.812597176146378],
            [18.013121631599862, 4.810138499191828],
            [18.009640960362375, 4.81547342066186],
            [18.00445790462353, 4.815791379874641],
            [17.998572002293795, 4.822484790477612],
            [17.997628161984345, 4.819106424292833],
            [17.991106040821542, 4.819945844295407],
            [17.982036096083295, 4.81609073200348],
            [17.97277148394281, 4.830584922766008],
            [17.969510560002437, 4.837268942943553],
            [17.96993414662212, 4.8405484909821705],
            [17.96032848640797, 4.85196933744225],
            [17.95348610849874, 4.861810158375934],
            [17.94934795292939, 4.866610609848163],
            [17.94520438314872, 4.876134675753352],
            [17.93793046503848, 4.896992923964495],
            [17.931429596142895, 4.913677388476788],
            [17.926807071914457, 4.948305459631511],
            [17.919984064147563, 4.94514823133707],
            [17.90837773912372, 4.935627520382163],
            [17.891493033305704, 4.978676396904601],
            [17.889620888545032, 4.977870206062625],
            [17.8741385927128, 5.015412076909203],
            [17.869797416496827, 5.031021135449312],
            [17.845167253765855, 5.021869523713802],
            [17.794884882324276, 5.002052746552063],
            [17.77999048315131, 5.0209287139490435],
            [17.7712982559109, 5.031313706561742],
            [17.754330006837215, 5.053267767036086]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.10001340604802, "lat": 41.50230085260414 },
        "year": "2023",
        "ste_code": ["09"],
        "ste_name": ["Connecticut"],
        "coty_code": ["09180"],
        "coty_name": ["Southeastern Connecticut"],
        "coty_area_code": "USA",
        "coty_type": null,
        "coty_name_long": ["Southeastern Connecticut Planning Region"],
        "coty_fp_code": "180",
        "coty_gnis_code": "02830253"
      },
      "bbox": [
        17.754330006837215, 4.810138499191828, 18.277821841186967,
        5.276328267336193
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.767084975300317, -8.1328134277833],
            [11.768724832002256, -8.132648597289483],
            [11.773842903673549, -8.135028973587977],
            [11.777033988725266, -8.134409155850646],
            [11.781363917565832, -8.130703540531142],
            [11.788821471718803, -8.128190245698532],
            [11.79058691898802, -8.125269280758806],
            [11.790029173450382, -8.111379143446971],
            [11.791166107838759, -8.103530951707626],
            [11.79298205044858, -8.098649003311422],
            [11.798493733613459, -8.09050364568238],
            [11.79988651936676, -8.085486300425062],
            [11.798045398488123, -8.081125855645073],
            [11.798742516598416, -8.075329635533498],
            [11.796159305350882, -8.066796173987635],
            [11.79349088487171, -8.066465948190917],
            [11.797447146033607, -8.062094849896567],
            [11.798821999863062, -8.054121732668893],
            [11.803035316581905, -8.053237527222988],
            [11.801908467257062, -8.04987779248374],
            [11.803735350911376, -8.046666581306448],
            [11.804341774652848, -8.040756688208825],
            [11.810837877984412, -8.037655319301493],
            [11.816443095857162, -8.036341256928356],
            [11.822170922448443, -8.037508472776123],
            [11.823920247907854, -8.034803531254466],
            [11.831369196670824, -8.035270313096152],
            [11.832555442860997, -8.031506105134492],
            [11.836674209285212, -8.024640791237832],
            [11.84148094668759, -8.020788195899836],
            [11.843636778120175, -8.016540186292524],
            [11.848259164262315, -8.01265040163171],
            [11.852963487460062, -8.014064161268255],
            [11.855277523179304, -8.012633020414366],
            [11.8633634964342, -8.008630030983005],
            [11.865323118574569, -8.010873641104524],
            [11.869608136660565, -8.010437012938466],
            [11.873303349966438, -8.016514211734657],
            [11.88008409893371, -8.01299981979307],
            [11.881860948853426, -8.018829313347252],
            [11.881993230968252, -8.025648365240704],
            [11.880562044250988, -8.029569710914132],
            [11.887196031091252, -8.034007432838749],
            [11.88827144671126, -8.039159073986461],
            [11.887080947872436, -8.043026872957533],
            [11.89727647411297, -8.043086777474592],
            [11.900803243454117, -8.044976663742835],
            [11.903330964424194, -8.057927566527198],
            [11.908183758198708, -8.060902714689059],
            [11.908617993656861, -8.063861286591088],
            [11.916411313334187, -8.071297277226709],
            [11.918932034257063, -8.07126496088388],
            [11.920381819965504, -8.07564306521457],
            [11.925734397504087, -8.078267462413082],
            [11.934530711136606, -8.080445122045438],
            [11.939028494421702, -8.08254733669908],
            [11.954835846281785, -8.094050948989507],
            [11.960530179696509, -8.095982143762733],
            [11.970194201872731, -8.096107065060886],
            [11.977741517412712, -8.094437474824097],
            [11.99123985615479, -8.095766106468998],
            [11.992803493006937, -8.103918120104133],
            [12.003393889880849, -8.172781021760036],
            [12.009294917112658, -8.212123060865661],
            [12.013304021874166, -8.240900590199724],
            [12.013985769199381, -8.24291703372251],
            [12.021497640047144, -8.293840849004352],
            [12.030319102025224, -8.35562725218646],
            [11.944391430225307, -8.369938478769402],
            [11.94192509443057, -8.355079794846132],
            [11.928016537541744, -8.357041492485184],
            [11.927112165592234, -8.349940405339577],
            [11.919869197958178, -8.350796991863248],
            [11.89488625191659, -8.355065599949802],
            [11.855204232832332, -8.360509511402155],
            [11.85414823545436, -8.353589207211721],
            [11.79502421462969, -8.362179479600323],
            [11.784655430201084, -8.363247358171998],
            [11.782778474118219, -8.36149821474199],
            [11.778860015146437, -8.363051208763904],
            [11.775545515127249, -8.37026738758565],
            [11.772801241849882, -8.371583517418044],
            [11.767272154866301, -8.367933773801457],
            [11.76027493681649, -8.354423495125596],
            [11.752229190186286, -8.34992348821367],
            [11.754398161479179, -8.340868920750033],
            [11.750283985865037, -8.337676028336974],
            [11.749968817553334, -8.332715660563156],
            [11.753223516343338, -8.3274007299451],
            [11.761199414506464, -8.318816697332611],
            [11.761877328605431, -8.315711522697526],
            [11.75870520770102, -8.301498394377445],
            [11.762253597530446, -8.299131799185739],
            [11.76249050190919, -8.295671876093875],
            [11.759730599817923, -8.29173717305864],
            [11.755090861005469, -8.28852988504363],
            [11.7581460718955, -8.282740951302648],
            [11.75760937503021, -8.279159659596102],
            [11.754103645367271, -8.27667963895895],
            [11.75282399484608, -8.27308782606225],
            [11.75438854780887, -8.266986526115293],
            [11.752481787997409, -8.260671825353343],
            [11.753583568555916, -8.256231554099866],
            [11.756182003684271, -8.254509061008026],
            [11.762866729578715, -8.25757083601982],
            [11.767904552232022, -8.255887051119597],
            [11.7686391663284, -8.25216230584642],
            [11.763938156056067, -8.25246577736321],
            [11.759998595790432, -8.246447859602654],
            [11.751766935146016, -8.242768645656875],
            [11.750607917880675, -8.238614021550942],
            [11.754153963250866, -8.237488541929967],
            [11.759994601917796, -8.242992999940485],
            [11.762265994470571, -8.23719565638229],
            [11.755859019260438, -8.234719471394799],
            [11.755514092752893, -8.23224268091366],
            [11.759657054488795, -8.222470457415193],
            [11.762606578095495, -8.213074751218063],
            [11.760286566819982, -8.204714756751576],
            [11.753722394496481, -8.205938825912513],
            [11.751191578012273, -8.201206347749492],
            [11.75183481666529, -8.192928321861078],
            [11.75640924423034, -8.185574749597942],
            [11.758241661930276, -8.174584508071979],
            [11.75990227207594, -8.171542452583852],
            [11.771343184865755, -8.161723508232342],
            [11.771177646020167, -8.159082288274444],
            [11.76582490650453, -8.157048018612182],
            [11.761109342693581, -8.157390076153318],
            [11.757269171863085, -8.153578115490753],
            [11.7564349256685, -8.148961388812495],
            [11.75977308343412, -8.139452918429766],
            [11.762835616550587, -8.135234044137524],
            [11.767084975300317, -8.1328134277833]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.8003706320509, "lat": 29.725823651991032 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12041"],
        "coty_name": ["Gilchrist"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gilchrist County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00303633"
      },
      "bbox": [
        11.749968817553334, -8.371583517418044, 12.030319102025224,
        -8.008630030983005
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.490097655882021, -7.022309056405322],
            [12.492716438767156, -7.020264378862874],
            [12.50264835247749, -7.026289513779135],
            [12.50309485660653, -7.031977001157927],
            [12.509524751077727, -7.036278043375359],
            [12.51406630904633, -7.047287743583118],
            [12.518574906713818, -7.0467306947081685],
            [12.523864957355691, -7.048280955879959],
            [12.526323845957565, -7.052577147978213],
            [12.52994520332692, -7.050604884028065],
            [12.538560969497139, -7.048967984802938],
            [12.551841627883872, -7.055068517826752],
            [12.56054130204243, -7.050998863260626],
            [12.56497506062534, -7.052878521330863],
            [12.568319446666681, -7.049280404252377],
            [12.578255335754026, -7.047588197326407],
            [12.582970695850513, -7.049824397177069],
            [12.587051343554597, -7.054191882162732],
            [12.588111681128726, -7.0506432837106345],
            [12.591543249175404, -7.050274348651243],
            [12.600972034048423, -7.061541752752251],
            [12.598871746532096, -7.064952082818967],
            [12.60291349200482, -7.068099928045242],
            [12.603989212800451, -7.072700509687648],
            [12.612265095114696, -7.06897681325538],
            [12.610488886939535, -7.066037745956592],
            [12.612234538652745, -7.055592850332649],
            [12.619154870503717, -7.055983457851394],
            [12.622549403314633, -7.06011903914981],
            [12.63033915639346, -7.06294860291556],
            [12.635530605364341, -7.062889654361536],
            [12.63904358333666, -7.065177351800867],
            [12.638358583097583, -7.0698366221205475],
            [12.64710767363253, -7.072322530823968],
            [12.647404276535969, -7.077118211047381],
            [12.659227527412515, -7.081231450452506],
            [12.667890479342425, -7.076566468291235],
            [12.673904211579236, -7.078214073535141],
            [12.67997476934103, -7.074307888888675],
            [12.68640069506046, -7.080316379185558],
            [12.693447433978463, -7.079136286514669],
            [12.70000787952264, -7.080829514144209],
            [12.702100580334672, -7.079205794531583],
            [12.702274178813598, -7.074398426270919],
            [12.698879262154291, -7.071439279504559],
            [12.693639472201996, -7.075942418225475],
            [12.68986357609999, -7.072740462989872],
            [12.69342573948846, -7.069609398682274],
            [12.700616031209936, -7.067922804856226],
            [12.70571178444316, -7.064403821588493],
            [12.70948548161382, -7.06882730662552],
            [12.706849964185817, -7.072961628129445],
            [12.710484767800061, -7.0759839107250775],
            [12.71460526710505, -7.073143034220329],
            [12.717815339218577, -7.076390153807533],
            [12.716766926202363, -7.084180675426161],
            [12.718074704359672, -7.0872981623246405],
            [12.721904534436751, -7.0890345511815145],
            [12.727715873209966, -7.0867248574757],
            [12.730314238510156, -7.081857982464557],
            [12.732880219331417, -7.081562787490567],
            [12.735429795619165, -7.0857201938712215],
            [12.738572463237722, -7.085282313573596],
            [12.738252732208366, -7.078619047669379],
            [12.741470381850178, -7.077180364521692],
            [12.745186405972673, -7.08136847650258],
            [12.743930234862761, -7.088542824435564],
            [12.746290504356041, -7.090339403674126],
            [12.751415626942059, -7.089411914851024],
            [12.756132725122152, -7.09521309617255],
            [12.75970111910462, -7.091177634100929],
            [12.75855169409905, -7.084780957471421],
            [12.762421344764594, -7.080949087213651],
            [12.766503949757087, -7.082538564382243],
            [12.767148867535258, -7.090415655031271],
            [12.770044457526023, -7.090827205777262],
            [12.775200314691356, -7.08475777700167],
            [12.786516974115251, -7.0844487768161795],
            [12.791524334181402, -7.087067206771712],
            [12.79562363746984, -7.087682561115148],
            [12.796563822383499, -7.091893630489315],
            [12.799159765892377, -7.093244424746787],
            [12.807827785549044, -7.085281292484657],
            [12.810736092154057, -7.0861092029932795],
            [12.815609869250267, -7.092380959376141],
            [12.818539548785138, -7.093350291991885],
            [12.82190372071391, -7.089417269555993],
            [12.820413082893188, -7.083724946481202],
            [12.820553097379861, -7.0781707758922],
            [12.822306689133223, -7.07711266938624],
            [12.835355350378848, -7.077120931510299],
            [12.842791821286374, -7.075282561753513],
            [12.857292551937778, -7.069884792092417],
            [12.86250323017389, -7.071312614829797],
            [12.870704524602667, -7.079256938386072],
            [12.88083904369018, -7.081440864851708],
            [12.89444451942674, -7.081061794819179],
            [12.898283094300744, -7.080110493388119],
            [12.904149812921592, -7.083911666813491],
            [12.91231463701727, -7.0870117809994815],
            [12.915193045673545, -7.086842152502939],
            [12.914958433437656, -7.0951053100899335],
            [12.916909163478588, -7.11641209588417],
            [12.916846103589585, -7.132574814309045],
            [12.916290841403077, -7.156222628833609],
            [12.916745467912914, -7.186308018071917],
            [12.92019364973348, -7.216868705429119],
            [12.924183323902124, -7.23412196982381],
            [12.933409921674063, -7.259525400152491],
            [12.933040259434266, -7.267011527522111],
            [12.930082506674388, -7.268696746093209],
            [12.924712578764959, -7.263885135516348],
            [12.917276907976252, -7.266074112777002],
            [12.913260719460618, -7.263957734454098],
            [12.89481222660327, -7.258003442650999],
            [12.886633895724705, -7.250487161405948],
            [12.882222450562576, -7.2386320919823595],
            [12.873511070259958, -7.230736918058259],
            [12.860710484108614, -7.22912347901497],
            [12.854061374210374, -7.241201193706376],
            [12.85895379014304, -7.250170573923324],
            [12.858799665319639, -7.258117843456134],
            [12.853172314206656, -7.271557655973581],
            [12.847580400725462, -7.274597956401573],
            [12.842678856617955, -7.275568708632659],
            [12.839024281960885, -7.274062674944579],
            [12.834921038181633, -7.269031305014867],
            [12.833055255535161, -7.257784143028575],
            [12.829153596371919, -7.256867390535892],
            [12.82605063959206, -7.259333163946872],
            [12.821972228961275, -7.265006264264557],
            [12.819682511597701, -7.266242912759431],
            [12.811476814370717, -7.266079128996871],
            [12.801160205190252, -7.25894330143595],
            [12.799752963907137, -7.255355036046662],
            [12.802154495298007, -7.245390170033698],
            [12.802355849357573, -7.240858799537559],
            [12.799223676385193, -7.23912198825716],
            [12.794680732842563, -7.241180460861957],
            [12.785443098587244, -7.249358500794225],
            [12.784785698578037, -7.253666928960419],
            [12.780508473924192, -7.253706932785499],
            [12.777295981141606, -7.248828669061805],
            [12.777062974328308, -7.244995936635608],
            [12.786400550529386, -7.2400823887665275],
            [12.784072438367389, -7.235485551585804],
            [12.777046256375296, -7.233177855667985],
            [12.78150292890207, -7.2243652394673505],
            [12.77708350645138, -7.224301070359448],
            [12.774015399933454, -7.229030024125744],
            [12.768169368468541, -7.228181458270632],
            [12.76401807610998, -7.2247951309882055],
            [12.756208363169598, -7.230432179098394],
            [12.75459599121015, -7.234180817060768],
            [12.750217532888248, -7.233058978410832],
            [12.74756708109352, -7.2379668437514955],
            [12.74330310726106, -7.238684900126307],
            [12.743598030509608, -7.24238157199231],
            [12.739570498789025, -7.244779383793894],
            [12.737359195456333, -7.249877736134055],
            [12.736712654401854, -7.260743391815005],
            [12.733421323176568, -7.264141724181863],
            [12.731399029952014, -7.261317194089085],
            [12.731081977144893, -7.2554742087059605],
            [12.727185602476533, -7.254404190320007],
            [12.719420512929997, -7.254860944646432],
            [12.716321562991979, -7.251974910253836],
            [12.706553258380653, -7.252477645148882],
            [12.703534285415229, -7.250906515582355],
            [12.694839360946329, -7.255674923161454],
            [12.688631361708767, -7.251238030124552],
            [12.683151460234974, -7.252359681005963],
            [12.68307988667307, -7.256013495359755],
            [12.679336411814392, -7.2586548689626795],
            [12.6740924101436, -7.265692882079445],
            [12.67574362079175, -7.270966174100303],
            [12.673283851293592, -7.275034155316739],
            [12.675841270857166, -7.279678683072861],
            [12.674225633089044, -7.28216507634829],
            [12.6758838666903, -7.285938948131505],
            [12.675026386602656, -7.290144347013122],
            [12.668365801078481, -7.294915985085873],
            [12.660482285911968, -7.295764375036388],
            [12.653454151835472, -7.293030712876448],
            [12.654553605700606, -7.309216067718165],
            [12.642979134432519, -7.326343067588919],
            [12.634584603520912, -7.325389265629916],
            [12.631367779483666, -7.325997424120657],
            [12.627007857732622, -7.33745331783879],
            [12.622058961036716, -7.348361942610148],
            [12.606159680498607, -7.367904880186887],
            [12.580950135643258, -7.402994996065739],
            [12.53125428427942, -7.47291817829802],
            [12.517255293407977, -7.492043155299365],
            [12.476484698631005, -7.549132568354719],
            [12.449099529025638, -7.585960046665611],
            [12.445924956172824, -7.5673979272070815],
            [12.435445430358198, -7.49866729913286],
            [12.442160929782071, -7.489875296874113],
            [12.444368232353268, -7.481793630951411],
            [12.444095096141647, -7.474399905811563],
            [12.437892734798083, -7.463707335147968],
            [12.43624730913782, -7.457496502731136],
            [12.436351617202755, -7.446420192073187],
            [12.440246512398845, -7.437736826272268],
            [12.439020889239686, -7.432200942636022],
            [12.43573509600477, -7.426184828660339],
            [12.436013230505182, -7.422184693437184],
            [12.441503637673321, -7.412403168674313],
            [12.442327729395805, -7.401876734213427],
            [12.442394207874992, -7.392289809436997],
            [12.446316686837982, -7.383885893799837],
            [12.446451559038787, -7.380151057125826],
            [12.443442198632075, -7.367225616862505],
            [12.444922587045081, -7.363578090825523],
            [12.44330429271654, -7.346223309826689],
            [12.441648625429298, -7.341285094915302],
            [12.438230204127459, -7.336098412137616],
            [12.437580750966422, -7.328802458716069],
            [12.439176664998874, -7.309568734262739],
            [12.4437839518552, -7.295420748503505],
            [12.439574363823242, -7.28244919998083],
            [12.43369760630306, -7.2664735587885385],
            [12.4286847353665, -7.2584550499459715],
            [12.419279245150566, -7.256149421084723],
            [12.418569172449208, -7.249066973276198],
            [12.415654378463442, -7.240925049023862],
            [12.403690166515792, -7.227286963197452],
            [12.403826003530023, -7.223258129053172],
            [12.399906373782382, -7.215469604732048],
            [12.392869209720763, -7.210373831978726],
            [12.393480869529155, -7.199850967353088],
            [12.3890466920917, -7.1901060331380435],
            [12.393653284143262, -7.180916501008207],
            [12.394153787936773, -7.171936848725325],
            [12.392116917848268, -7.167545274412163],
            [12.396484632618149, -7.158530309580386],
            [12.393750968142111, -7.146809804158842],
            [12.390778352547938, -7.141268031147683],
            [12.38617529362818, -7.138025835656383],
            [12.389452408004136, -7.128782848404432],
            [12.387726224341463, -7.118443591175821],
            [12.38916793345258, -7.1114866596755775],
            [12.393894431938241, -7.11477311562957],
            [12.397820444588367, -7.11354058402497],
            [12.404038391917215, -7.107149339756166],
            [12.409501959249186, -7.1002849505778425],
            [12.404915579113315, -7.091534099957901],
            [12.39646637073588, -7.081991771919339],
            [12.396751708264901, -7.076377294164571],
            [12.399513861656693, -7.076203539972772],
            [12.4014314227515, -7.072311367071705],
            [12.404613520048539, -7.074114637076299],
            [12.407986573377105, -7.0708822442941],
            [12.410880069992022, -7.071124319042277],
            [12.419952618823611, -7.07513591605484],
            [12.422840601186566, -7.077805697013879],
            [12.430911680849345, -7.08151704752218],
            [12.435963075596868, -7.0822690189766595],
            [12.439267600845085, -7.07957659377383],
            [12.440742546436722, -7.074301067476983],
            [12.440711768824714, -7.069054432241928],
            [12.4428233849949, -7.063874766176012],
            [12.445693186850571, -7.061507484147225],
            [12.44592949913459, -7.056295530101713],
            [12.44262271028856, -7.050285635672925],
            [12.444222123400053, -7.04905448655153],
            [12.441537150613673, -7.039733049270616],
            [12.44781655068024, -7.034126154412851],
            [12.452316228110686, -7.0283137266334705],
            [12.457512700784626, -7.029443186724214],
            [12.461247095919685, -7.026018234824691],
            [12.467558093791224, -7.033562720110666],
            [12.472855826147724, -7.035637176847295],
            [12.479916611862725, -7.034668075269282],
            [12.486736648663687, -7.035034045632782],
            [12.491903903308184, -7.032639980800443],
            [12.49188314105035, -7.029959451474621],
            [12.488428223184942, -7.0252945965483224],
            [12.490097655882021, -7.022309056405322]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.80193354805803,
          "lat": 30.610722913133515
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12089"],
        "coty_name": ["Nassau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nassau County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00295730"
      },
      "bbox": [
        12.38617529362818, -7.585960046665611, 12.933409921674063,
        -7.020264378862874
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.325778534850144, -7.362425557494656],
            [8.360252093541918, -7.359777029390599],
            [8.377087609333861, -7.357562539351559],
            [8.393560016867854, -7.358129663186751],
            [8.40883552890311, -7.356748903849944],
            [8.42894058564234, -7.354848691551729],
            [8.511457325179288, -7.34616740537005],
            [8.514975122591439, -7.345705964867014],
            [8.552162120586528, -7.344001025710874],
            [8.569149670881727, -7.342218143343954],
            [8.604483798081816, -7.338037911130002],
            [8.607578476351739, -7.33793564813345],
            [8.66370664191346, -7.331916378406946],
            [8.670912408095885, -7.403804589446259],
            [8.675013436953735, -7.447790870294474],
            [8.675464702785867, -7.458548581783719],
            [8.680120353529896, -7.511566899073485],
            [8.685882811352691, -7.575421570355039],
            [8.68874925859939, -7.601528768428611],
            [8.690070632307663, -7.6164027759217525],
            [8.697814459232212, -7.694971407768476],
            [8.698866964022814, -7.701856459772094],
            [8.703909140417561, -7.7589567614057655],
            [8.710074425648001, -7.823747285190266],
            [8.713243803585463, -7.866435553339908],
            [8.716942454340812, -7.9217152445083],
            [8.718532248864117, -7.941102878191638],
            [8.705755791266878, -7.940704619936225],
            [8.678212657997566, -7.940610953514527],
            [8.65504660565062, -7.942228245237784],
            [8.639085981567002, -7.944203815809954],
            [8.624962724373612, -7.9468155790413055],
            [8.612472220860742, -7.943725558901125],
            [8.594355683986377, -7.9432215887428494],
            [8.578429677246536, -7.943530583146041],
            [8.56015624449972, -7.942609851561482],
            [8.554768968492965, -7.943319692683624],
            [8.536414149106665, -7.9426959195571065],
            [8.521612109230617, -7.942717101459651],
            [8.50568784595724, -7.943867456559923],
            [8.494203615310774, -7.945194369181224],
            [8.446446628834757, -7.951888771003933],
            [8.424693467653324, -7.955428365857667],
            [8.37312980526795, -7.9665138312623585],
            [8.36936619560443, -7.923234545351396],
            [8.355177292664791, -7.749773750610721],
            [8.353688449900192, -7.730320830720778],
            [8.354811347634838, -7.730178792954297],
            [8.350315527990654, -7.671774000644506],
            [8.34227991193844, -7.576849804884305],
            [8.341010686176416, -7.557927436044808],
            [8.333749353176067, -7.458176825285286],
            [8.32584842126941, -7.36571727110623],
            [8.325778534850144, -7.362425557494656]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.59170053141511,
          "lat": 30.691286346464928
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12091"],
        "coty_name": ["Okaloosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Okaloosa County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00306915"
      },
      "bbox": [
        8.325778534850144, -7.9665138312623585, 8.718532248864117,
        -7.331916378406946
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.881306315505109, -5.963985725094732],
            [11.888710090019792, -5.965745733293057],
            [11.893685240702336, -5.968871367618992],
            [11.902436209832164, -5.971556017966666],
            [11.902732755647753, -5.97595573493981],
            [11.907044395537099, -5.976853560517697],
            [11.90782408504629, -5.972805463452917],
            [11.905584155199115, -5.970299476174692],
            [11.906628811033324, -5.9663142963589735],
            [11.910395444652119, -5.966986102602265],
            [11.91482633126943, -5.969885655273398],
            [11.917442756471218, -5.975569200217248],
            [11.920987865270845, -5.976474242890232],
            [11.921542340332266, -5.972054376298628],
            [11.918041847591503, -5.967913170738526],
            [11.918923506959828, -5.965161661046343],
            [11.922703203135358, -5.9648456139369825],
            [11.926369985335395, -5.9688436765042],
            [11.932729546893578, -5.96894139197317],
            [11.933332996826428, -5.971058802819832],
            [11.928937623800618, -5.976637013642819],
            [11.929459282971457, -5.981408264606747],
            [11.934256208158672, -5.981362749909377],
            [11.942366444885993, -5.977942289812081],
            [11.9465571468269, -5.981382569568024],
            [11.964210259697564, -5.981388446441893],
            [11.970951552824642, -5.982828743932219],
            [11.976338075141918, -5.982337391787355],
            [11.984225343822093, -5.984948276213956],
            [11.988640619409262, -5.982377896720517],
            [11.988882219731103, -5.977509611396405],
            [11.984924266253268, -5.976155056066917],
            [11.981782484858936, -5.973162009328409],
            [11.98143940660173, -5.969368486303482],
            [11.98700566831508, -5.96963492803152],
            [11.993545396599949, -5.980455478803796],
            [11.997462376599886, -5.979801183034432],
            [11.99907224651825, -5.974645307705135],
            [12.001856435056737, -5.970589918779933],
            [12.006001195224039, -5.970031463939032],
            [12.01413373645923, -5.974280300113107],
            [12.020394847461441, -5.974586405342218],
            [12.024095862728956, -5.981371636826598],
            [12.027540445236987, -5.981547605574985],
            [12.02978072635179, -5.976726789643641],
            [12.03357005449579, -5.977176704689001],
            [12.034774189056092, -5.9809868612815515],
            [12.040227058622929, -5.985861643399716],
            [12.041747166906706, -5.990246838657082],
            [12.044391613198236, -5.992590895194222],
            [12.047194183880688, -5.990769977437056],
            [12.049520935616444, -5.986292579263919],
            [12.053910110369834, -5.986565749211832],
            [12.055998598895155, -5.9921194022271465],
            [12.061559485820029, -5.99164055833596],
            [12.06485760656791, -5.991440434405773],
            [12.066812479604485, -5.994286859720759],
            [12.077344176762269, -5.992150867727769],
            [12.082356621712515, -5.9954613024171515],
            [12.09077545721016, -5.99463956566331],
            [12.091560892446159, -5.99997816443951],
            [12.099235001888545, -5.9981542105904655],
            [12.112431009114328, -5.993807922016937],
            [12.121198969883396, -5.993034066651165],
            [12.127511364691356, -5.996454221487105],
            [12.132287726754043, -5.99525191495782],
            [12.133433024936089, -5.989126349259229],
            [12.136938805443831, -5.985685474985965],
            [12.139381796889307, -5.986035419182329],
            [12.141384814421675, -5.991499134404575],
            [12.138296590462504, -5.999173079178136],
            [12.14144674688753, -6.002901671996541],
            [12.148154706622929, -6.002628021234369],
            [12.15241513449393, -6.00543748766943],
            [12.156732186865131, -6.002281236743743],
            [12.154135033878893, -5.991654378296583],
            [12.156244945535711, -5.989842865843846],
            [12.159748893266649, -5.992649623338617],
            [12.15920942571065, -5.999393982632063],
            [12.162955221101525, -6.004501037533554],
            [12.162994679499333, -6.012271238341295],
            [12.164301624113383, -6.0198486145054835],
            [12.159203836341293, -6.024595546069213],
            [12.160497687676573, -6.027940516139654],
            [12.167253185564777, -6.025991430703266],
            [12.17550044231275, -6.030248638356759],
            [12.178298152989447, -6.0333498020411405],
            [12.188587406902261, -6.038876738969453],
            [12.19201456519771, -6.043559347271122],
            [12.205436164418428, -6.046225484445539],
            [12.214631030782614, -6.052212930420369],
            [12.221704439517744, -6.055084121563974],
            [12.21314481815407, -6.055968545217607],
            [12.211293398432522, -6.05823379663319],
            [12.203883059286003, -6.058832235970687],
            [12.199898915999754, -6.056044468732731],
            [12.190245650717584, -6.065834036228675],
            [12.193390704996661, -6.08707445958277],
            [12.177198862444937, -6.089154836059652],
            [12.17879432216085, -6.102749188544752],
            [12.193633574320867, -6.100775346596507],
            [12.195451040972952, -6.113622889667018],
            [12.158892838121634, -6.118477235514423],
            [12.168632571584725, -6.185083545063901],
            [12.176127722042919, -6.237303713992966],
            [12.176072103537654, -6.238788014773331],
            [12.188751054202902, -6.320061694510895],
            [12.176180316363551, -6.322085305432001],
            [12.177921666917145, -6.333748522195184],
            [12.190535985603223, -6.331699428412982],
            [12.19212674541741, -6.343172369439846],
            [12.203187248173819, -6.416837218933947],
            [12.19395088108694, -6.420211149944352],
            [12.184479993498899, -6.419713969917573],
            [12.176393664072643, -6.416056665350269],
            [12.15990067796119, -6.404994111436876],
            [12.143275632837144, -6.391373197958226],
            [12.13211356116352, -6.386301287383562],
            [12.123802618348023, -6.380550043740893],
            [12.115728495681717, -6.369630949848507],
            [12.111579661442022, -6.362730080542222],
            [12.109149470726708, -6.356424811761642],
            [12.100192667540185, -6.346694605719203],
            [12.0939977529751, -6.343704368853076],
            [12.085567607827674, -6.3437802070272],
            [12.08058161638178, -6.3417828432479295],
            [12.073149823965942, -6.334157660958409],
            [12.061152106748278, -6.330300543753713],
            [12.04949947809636, -6.32521507349889],
            [12.042508639455038, -6.32392431183566],
            [12.03479247450009, -6.3196748232281434],
            [12.029706356544022, -6.317943074279435],
            [12.02456368657326, -6.313387385042527],
            [12.013781666650408, -6.307502045109346],
            [11.999377638711254, -6.295020085307126],
            [11.994453976777073, -6.294239142773366],
            [11.98181961322913, -6.287772775685912],
            [11.976639575484064, -6.289054700260106],
            [11.971820433225778, -6.286426022492214],
            [11.966402612986862, -6.286068313407802],
            [11.962931658348278, -6.283405200434251],
            [11.95698404899253, -6.284359223250996],
            [11.952551240623945, -6.283164674639293],
            [11.948195031203689, -6.284354062621452],
            [11.945752479906298, -6.281896044171703],
            [11.933297538289017, -6.27422000019886],
            [11.927449905831768, -6.269641234204887],
            [11.9200040028964, -6.266085028765784],
            [11.916100625169662, -6.2691333635236335],
            [11.908626266417444, -6.267639558878157],
            [11.905471106307527, -6.26116944263643],
            [11.899419944662263, -6.259883299696328],
            [11.895309627446558, -6.254298233744539],
            [11.887632449688791, -6.251696979968063],
            [11.883673631202655, -6.24747542587857],
            [11.883002946693228, -6.2434985176540225],
            [11.873344607012513, -6.2360133878841815],
            [11.863893718389104, -6.22438468523963],
            [11.842436525684958, -6.227223275630729],
            [11.839545198072946, -6.202010755388167],
            [11.814254399343271, -6.205462475288826],
            [11.81246362992459, -6.192828269274762],
            [11.838043962809776, -6.1891225332086295],
            [11.825301303273038, -6.10094591249302],
            [11.899770874427622, -6.090736091176045],
            [11.898786045430391, -6.084437443171534],
            [11.886130947915804, -5.990997869841256],
            [11.881306315505109, -5.963985725094732]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.28891465244882,
          "lat": 31.749233643349402
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13001"],
        "coty_name": ["Appling"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Appling County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00349113"
      },
      "bbox": [
        11.81246362992459, -6.420211149944352, 12.221704439517744,
        -5.963985725094732
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.351100369031975, -6.5356241825891175],
            [11.35597779887016, -6.535246479921981],
            [11.364237839576253, -6.532187068212997],
            [11.370417572819619, -6.53187778863817],
            [11.378851616030914, -6.525874876044752],
            [11.379425097054428, -6.521666738690325],
            [11.385145872495187, -6.509475756750075],
            [11.387617473968415, -6.496533600399168],
            [11.391728520394937, -6.490797469978428],
            [11.396529929629526, -6.4875728763434175],
            [11.397384176942639, -6.4759462796681495],
            [11.403351623866817, -6.465244136756348],
            [11.403833499747954, -6.460388526084927],
            [11.406258157146985, -6.454761022473229],
            [11.410404490362248, -6.4337247643366515],
            [11.405212129396379, -6.388385134818151],
            [11.416996525227203, -6.387189676332512],
            [11.41553039638393, -6.373937083441896],
            [11.42755346073221, -6.372772710398635],
            [11.42654173257846, -6.36032171937947],
            [11.439362165089733, -6.359044442072226],
            [11.436563985821602, -6.334153647083148],
            [11.448890619753344, -6.332804692554542],
            [11.44751616382265, -6.32019982534366],
            [11.441044835184428, -6.264374052640404],
            [11.439394038721822, -6.252312795712658],
            [11.434980540090844, -6.21325800784493],
            [11.438039020888214, -6.211618651570894],
            [11.439481827497172, -6.205329768588646],
            [11.444455839374958, -6.204071842418556],
            [11.44788212887136, -6.199175029081532],
            [11.452739626727366, -6.20055240274592],
            [11.455988403137102, -6.203016077779677],
            [11.463252365119077, -6.204359114449022],
            [11.468604509497885, -6.206616267590954],
            [11.47693915815379, -6.2010792346405745],
            [11.483228086832106, -6.2012056866186684],
            [11.485528323784305, -6.199704852628134],
            [11.489825089306496, -6.201396128299092],
            [11.499096435024116, -6.20127428184177],
            [11.497429675949888, -6.205163187311978],
            [11.50106399040413, -6.205933975817733],
            [11.50110881759893, -6.201902437944032],
            [11.508322719189778, -6.199289521848488],
            [11.513746630154996, -6.192103725054313],
            [11.515256500035084, -6.200071648711235],
            [11.521110082005478, -6.199895300402245],
            [11.52329952004139, -6.201746586837596],
            [11.53007262449679, -6.199092679549648],
            [11.53465989796082, -6.193670204004166],
            [11.536735856057131, -6.195930061873871],
            [11.542707200645571, -6.194066262482061],
            [11.549548706369396, -6.188037586009995],
            [11.549698289404104, -6.180397520738913],
            [11.554095598389079, -6.180058136661117],
            [11.562905309427183, -6.168279062243518],
            [11.559560975048637, -6.16608341887332],
            [11.563670169470393, -6.160075012664233],
            [11.5835185843442, -6.303254120323341],
            [11.602487876951228, -6.300602505576421],
            [11.684743092789889, -6.28850109423802],
            [11.758979129669921, -6.277463802770002],
            [11.774298762901552, -6.390565030397278],
            [11.801238980359539, -6.387202050953264],
            [11.80469291753533, -6.412813630560079],
            [11.812711912439308, -6.474869896492664],
            [11.786906880371134, -6.478474253523948],
            [11.801073750386006, -6.582640139606126],
            [11.7683583595626, -6.587258064384231],
            [11.690925842039375, -6.59757600908405],
            [11.642454373135067, -6.60423809168637],
            [11.636883898744067, -6.598329642316356],
            [11.63641078223962, -6.59425844143201],
            [11.63030199162599, -6.5928025306784575],
            [11.622002247758772, -6.579505719386801],
            [11.622315055516136, -6.573749708421254],
            [11.618625757632783, -6.5700590220544015],
            [11.61439404366968, -6.569017727905757],
            [11.590413288743628, -6.573162513609985],
            [11.518452343525135, -6.582569472238394],
            [11.516106375954703, -6.568520066639146],
            [11.479843425784365, -6.572882198256487],
            [11.362422205966515, -6.586311288561297],
            [11.362672449214154, -6.578841029886536],
            [11.364889778412936, -6.575797538580697],
            [11.361117723787233, -6.5703133255380175],
            [11.36113118246266, -6.565216731959993],
            [11.359532051362757, -6.561559037608615],
            [11.354324964239982, -6.554307715246134],
            [11.349082295143246, -6.551487493018864],
            [11.347921444485156, -6.5468482461618835],
            [11.351312230139515, -6.538967590276802],
            [11.351100369031975, -6.5356241825891175]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.84922434314684, "lat": 31.54936332917752 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13069"],
        "coty_name": ["Coffee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coffee County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00347456"
      },
      "bbox": [
        11.347921444485156, -6.60423809168637, 11.812711912439308,
        -6.160075012664233
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.125001411081332, -4.498944455966886],
            [10.15448245165234, -4.495686218409355],
            [10.156755012854783, -4.5117870812882135],
            [10.17417130998042, -4.5097006611824435],
            [10.172422571838156, -4.4938150507452],
            [10.205125686414704, -4.490167712698336],
            [10.205535985792078, -4.493308033879639],
            [10.210612828522493, -4.503149150866452],
            [10.209345930615271, -4.5068262051072345],
            [10.218019590045026, -4.513095934694449],
            [10.225420111269965, -4.523271411336068],
            [10.228757959889629, -4.526357726448761],
            [10.23597983559036, -4.535569963742936],
            [10.240802808083895, -4.5457803870579605],
            [10.249517239641527, -4.551412348295096],
            [10.25027723197809, -4.555709369864033],
            [10.255934010643337, -4.560897333176849],
            [10.258915935126048, -4.5660028259552945],
            [10.264452893144824, -4.568766891629526],
            [10.27038695695466, -4.566256189016904],
            [10.271762141730203, -4.562764304641361],
            [10.27712359288621, -4.5614963706134555],
            [10.293089070481086, -4.570667260360447],
            [10.301599469827464, -4.570802232829438],
            [10.30498759476458, -4.574105818360466],
            [10.311168254376847, -4.577200723004674],
            [10.314880200814606, -4.5747293797505755],
            [10.320599319037838, -4.582558149658349],
            [10.326357582090305, -4.579736575564607],
            [10.329853753045636, -4.583169242846947],
            [10.327940579823187, -4.586115810317182],
            [10.328859335362639, -4.592078799982813],
            [10.331835007384091, -4.5914033690221085],
            [10.334863228526446, -4.59571327363985],
            [10.332370551855346, -4.59917197155419],
            [10.326934180503368, -4.603721659700741],
            [10.33092961573596, -4.605879247478104],
            [10.33788029940783, -4.6026226336248035],
            [10.338222703286336, -4.611628432349928],
            [10.344280174447055, -4.6114432694387295],
            [10.34606572661915, -4.616421333233598],
            [10.3494262912011, -4.618847325777334],
            [10.349037385102127, -4.622120733829361],
            [10.346226531359411, -4.624754729431018],
            [10.353288003895582, -4.627495665408665],
            [10.353463012589392, -4.623669561745799],
            [10.36239418649146, -4.620616267578524],
            [10.365306344740967, -4.6255679174210185],
            [10.37756142673292, -4.6223669015963615],
            [10.385908642227571, -4.624519429522751],
            [10.387854911275982, -4.627238362816126],
            [10.391839643637358, -4.627766514727739],
            [10.3950041906835, -4.625458262151186],
            [10.400086236404174, -4.627505181539496],
            [10.405712429864412, -4.6263836800645],
            [10.413553376711038, -4.628297158938819],
            [10.418245691193668, -4.62571596199592],
            [10.420923741226611, -4.629354032258834],
            [10.420385960179132, -4.634014870991616],
            [10.424056447620282, -4.639461187106597],
            [10.430218516908417, -4.642831008408625],
            [10.436215957865237, -4.654405415921661],
            [10.444260871404117, -4.657526519900164],
            [10.444296800489102, -4.664389608848345],
            [10.437115761367734, -4.664978829282184],
            [10.437454714498603, -4.667618759506266],
            [10.428504445144398, -4.6688379207727015],
            [10.430590594433216, -4.685258178703616],
            [10.421954588999087, -4.686421180266419],
            [10.42271605641224, -4.692377004015613],
            [10.415255681958676, -4.693380741218237],
            [10.41673142049141, -4.704931882907483],
            [10.408495380330155, -4.706002883758038],
            [10.411263063485945, -4.728273642930518],
            [10.417209510577559, -4.727585232080423],
            [10.419904147773229, -4.733940454259191],
            [10.419815329361805, -4.737342211102533],
            [10.409549086269767, -4.739061830507227],
            [10.40452653971117, -4.746325190837932],
            [10.385107766952407, -4.748624704364293],
            [10.381961173880534, -4.7569627309098435],
            [10.375269244981224, -4.76146405774317],
            [10.372151987277377, -4.757400620967713],
            [10.365317612854376, -4.757899988816636],
            [10.367332470819017, -4.776738360721856],
            [10.363074596902525, -4.777207572603103],
            [10.35980392540405, -4.779359264248796],
            [10.360269152987078, -4.783921071005569],
            [10.358486770665099, -4.791219311769095],
            [10.352115582384533, -4.792021821588057],
            [10.3535596171373, -4.803779237205374],
            [10.348358941275448, -4.8126839786718705],
            [10.346416105945034, -4.812703952294821],
            [10.345480459429632, -4.804929577004697],
            [10.33768347246779, -4.8059101238136295],
            [10.339392820839574, -4.82166608644538],
            [10.333704563723119, -4.822322262070048],
            [10.329849378681851, -4.826714341371403],
            [10.326860377718479, -4.823180776306705],
            [10.315389501327438, -4.82440159215991],
            [10.315762603531496, -4.828296939125266],
            [10.310215569727413, -4.825864090406312],
            [10.30645718614788, -4.82985243457344],
            [10.302081015787676, -4.825733559101988],
            [10.297338854598626, -4.827967125198827],
            [10.288881248720873, -4.82604772868384],
            [10.28811854945601, -4.822217276167416],
            [10.284786834271937, -4.821465080617351],
            [10.283148032799252, -4.817425598525064],
            [10.27827537625239, -4.814377572203019],
            [10.27420692433074, -4.818478973856893],
            [10.271534041641, -4.795968931650004],
            [10.249776110155835, -4.798338330792788],
            [10.191893545567549, -4.805697829154717],
            [10.190149902472635, -4.789948573019054],
            [10.18685198116966, -4.789508762901505],
            [10.101608609221925, -4.799945604909789],
            [10.101679322800603, -4.799083780746375],
            [10.091985826072548, -4.7165594609930235],
            [10.116971801016238, -4.7137182170425085],
            [10.117828677672343, -4.721611577756073],
            [10.133660913406674, -4.720262269428862],
            [10.132590843755562, -4.712184837465807],
            [10.140492370669541, -4.711045649505368],
            [10.134914296293367, -4.662578535372343],
            [10.143327908932818, -4.661523824817235],
            [10.141996811310378, -4.6503392363267215],
            [10.138459077787648, -4.613035491301512],
            [10.129827774379503, -4.613993870103358],
            [10.12817658498205, -4.597852799051375],
            [10.15193073302259, -4.5951422416819625],
            [10.149047064681648, -4.56923751230672],
            [10.147898234155985, -4.5619323967507],
            [10.156517818774276, -4.560937297654448],
            [10.155418177131645, -4.55286927021642],
            [10.163055904394755, -4.551914980059384],
            [10.162053643222078, -4.543618214948352],
            [10.154346524326447, -4.544430376951804],
            [10.15331974582201, -4.5362912638143404],
            [10.145333380413424, -4.537256592201967],
            [10.142681192013418, -4.513252674964359],
            [10.13486895255958, -4.514010569529055],
            [10.134037781950155, -4.505997348595775],
            [10.126140370869217, -4.506833796865669],
            [10.125001411081332, -4.498944455966886]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.15416563021397, "lat": 33.45304365897358 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13151"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01671894"
      },
      "bbox": [
        10.091985826072548, -4.82985243457344, 10.444296800489102,
        -4.490167712698336
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.548272045231066, -3.0811535961859713],
            [10.601634787862729, -3.073106957869668],
            [10.730286438342016, -3.0535504244362492],
            [10.836343577064836, -3.035624472133281],
            [10.89827863859475, -3.0253949901404456],
            [10.901176457974957, -3.0250479223237448],
            [10.907097660029962, -3.028245761409203],
            [10.906980522398369, -3.0317360768797665],
            [10.911069305061291, -3.033093573715902],
            [10.905585344715174, -3.0427130308775285],
            [10.903524649543034, -3.0500195413285494],
            [10.900229342957655, -3.05319047520345],
            [10.8969289858118, -3.058956801839788],
            [10.89670468652848, -3.064719851616361],
            [10.901621796943097, -3.066548594915236],
            [10.898706992033468, -3.0698219282872152],
            [10.899035719142624, -3.07413949711331],
            [10.893734222423134, -3.078625746734643],
            [10.89949941489475, -3.084912911010292],
            [10.903212501239118, -3.0841938896845655],
            [10.90833953110809, -3.090478956218911],
            [10.90322114016258, -3.091086686605924],
            [10.901398496110977, -3.0942853176503244],
            [10.896018222581553, -3.0897174152548215],
            [10.89229257182776, -3.092643198789748],
            [10.893845337901794, -3.097463810360097],
            [10.886554864955414, -3.1045703582026962],
            [10.884449779481159, -3.1050180673475],
            [10.873151958212402, -3.100223250589964],
            [10.8710662316986, -3.1026924056724536],
            [10.874873258388694, -3.114142161916417],
            [10.871721471281033, -3.1165232198782475],
            [10.867211235962486, -3.112775505005613],
            [10.864456155728554, -3.113808760970828],
            [10.860802583649555, -3.1231463739564713],
            [10.856274103360144, -3.124236722263464],
            [10.856869952540823, -3.12913436155797],
            [10.851105321537274, -3.1374888172590967],
            [10.846685158004929, -3.135737834588117],
            [10.843615883168889, -3.1432622198273252],
            [10.839485207290391, -3.145666284037039],
            [10.843330782391721, -3.151208377403054],
            [10.839803683611455, -3.1568798305029344],
            [10.830434403645043, -3.155398661452353],
            [10.82898163002328, -3.1599316038001533],
            [10.821669801989975, -3.159306388969292],
            [10.81926845196813, -3.1614147090423783],
            [10.81276419871886, -3.1613451891598836],
            [10.81038713602173, -3.1631735479130825],
            [10.815768359643094, -3.1710994986161563],
            [10.815640528147012, -3.174596673199956],
            [10.808892218433357, -3.1739317075089724],
            [10.808783959386176, -3.1826291722369278],
            [10.805064498175785, -3.1857038717063633],
            [10.806235828036622, -3.1898569204125473],
            [10.804739219316907, -3.197705788224222],
            [10.800671806920741, -3.1971654172338684],
            [10.79999706998383, -3.194212427831683],
            [10.795517972733432, -3.193978179376589],
            [10.792510902170674, -3.208937154779428],
            [10.796929593852392, -3.2107260486848896],
            [10.797655378079023, -3.2220544045168067],
            [10.795263447374928, -3.225507196937475],
            [10.791470184426919, -3.227184595525621],
            [10.780774032235454, -3.220719572527726],
            [10.77901490789605, -3.2224593562202735],
            [10.780556637770763, -3.2270614125688284],
            [10.777081800187425, -3.230299324401796],
            [10.772874295282689, -3.2313558046230253],
            [10.769886921187986, -3.228203262166096],
            [10.767560034300473, -3.2324721309257334],
            [10.770024986896766, -3.236028027717334],
            [10.773743555185316, -3.2365062719276705],
            [10.773439149330768, -3.242696950495562],
            [10.772033761908727, -3.2447140055596764],
            [10.763820336441952, -3.248148871368634],
            [10.764190617118517, -3.251225837439117],
            [10.759304703449668, -3.255728438300795],
            [10.757119405706316, -3.261674932727371],
            [10.760621901796872, -3.269776614728034],
            [10.759642395663715, -3.271349175050736],
            [10.76346421310255, -3.277249453210416],
            [10.760929111940351, -3.282886100834816],
            [10.7640501654955, -3.2837111883761283],
            [10.759865903623323, -3.292799575727531],
            [10.760288617498626, -3.298466355972198],
            [10.755601158933422, -3.3009729425429524],
            [10.755747717632017, -3.303888594904029],
            [10.75146240208095, -3.3085551290768924],
            [10.75172844380333, -3.312209358216184],
            [10.746492676099777, -3.312892366152193],
            [10.743803220163418, -3.315100361860419],
            [10.741394731700654, -3.323759367894086],
            [10.743916892315562, -3.335865636151463],
            [10.7412679443285, -3.336340059640555],
            [10.732379794392736, -3.3322897838895718],
            [10.724348665488213, -3.324736345355208],
            [10.72362110467295, -3.3225260344082437],
            [10.718507347344817, -3.323853920549675],
            [10.712757146247764, -3.3184732253005347],
            [10.707028902045558, -3.324620788101014],
            [10.700734318453739, -3.3286770159709715],
            [10.698843453858938, -3.3264690618187784],
            [10.690454343012146, -3.3259783901758775],
            [10.684167296985569, -3.323614216908982],
            [10.682325771516405, -3.3191134494117542],
            [10.683245867036097, -3.31609291482736],
            [10.680564675184435, -3.3133894079043835],
            [10.676018530275396, -3.3132529418221313],
            [10.67273681389319, -3.318844365452965],
            [10.664589769531622, -3.3191282381291565],
            [10.665171172180965, -3.3253379283420497],
            [10.662310066599579, -3.328347392165089],
            [10.65679462624055, -3.331541949874458],
            [10.649163402728004, -3.331092607923081],
            [10.647759398230297, -3.334548170059847],
            [10.640579414432551, -3.341716691320086],
            [10.625823115283787, -3.3386614700988377],
            [10.619366974786516, -3.3340097042821273],
            [10.612196332660266, -3.3376040981224784],
            [10.608856253621317, -3.3346797669667536],
            [10.60503058604007, -3.3343343618134593],
            [10.601003744035149, -3.3320069242219934],
            [10.594932542538128, -3.3324016589959045],
            [10.590610334228497, -3.3263162601010388],
            [10.590505350006527, -3.3232941852796065],
            [10.580604711344595, -3.3237249371060513],
            [10.573175787889907, -3.316130309961096],
            [10.573768128226083, -3.308073813138344],
            [10.568392375448067, -3.3024395039817627],
            [10.569326292731168, -3.300399752685681],
            [10.565758312401197, -3.293540689141598],
            [10.569926183305295, -3.289405547744364],
            [10.56051495599287, -3.2839568839549407],
            [10.557592671715026, -3.2843213723496474],
            [10.554436011559382, -3.2807047340049333],
            [10.550373493666067, -3.2729757124545618],
            [10.547274273540616, -3.271686672474409],
            [10.539882044685548, -3.2567976640232628],
            [10.53233290311893, -3.25356819333064],
            [10.524681588339522, -3.251704959402077],
            [10.520198335515557, -3.2540576369474348],
            [10.519311212532678, -3.2580880439539657],
            [10.514509137962735, -3.2570449862846678],
            [10.509581822206847, -3.2583381331933925],
            [10.505559661975507, -3.2565224361714997],
            [10.497684549523006, -3.260137256837203],
            [10.490138604456332, -3.25849349917486],
            [10.487613462699123, -3.2612363655668255],
            [10.483850668874618, -3.259176615662501],
            [10.481097653580303, -3.254692464674476],
            [10.479383522100552, -3.244642760443079],
            [10.47667760616369, -3.2371123017013943],
            [10.477012440094995, -3.2299326716269445],
            [10.478394960807911, -3.2283745660752095],
            [10.479852951049269, -3.2190012652274445],
            [10.477842214059686, -3.2121485400730814],
            [10.478562266999463, -3.2080447575145707],
            [10.476736374297074, -3.2061911057990966],
            [10.48176329956267, -3.2030841652646598],
            [10.485284888410849, -3.19467972284738],
            [10.484298311471838, -3.1922068876984477],
            [10.495695213357719, -3.1875805887040727],
            [10.497098984748956, -3.182014982284116],
            [10.495711956681259, -3.1751892529413235],
            [10.4968794572133, -3.1715838692282223],
            [10.503682974359972, -3.172133177128378],
            [10.505910995228469, -3.1661952522610117],
            [10.518763433630088, -3.1659961134485037],
            [10.52229253956055, -3.1602901764470173],
            [10.522277895076302, -3.156623771130393],
            [10.517186167727358, -3.1570706662653416],
            [10.516077659622159, -3.1486605175220994],
            [10.513811182629933, -3.147198412734509],
            [10.513237377922783, -3.141059063646942],
            [10.519691217093914, -3.138765073680091],
            [10.520985286685775, -3.1366545523835434],
            [10.528336756760874, -3.1342390121493775],
            [10.556344932577598, -3.126816091767897],
            [10.548272045231066, -3.0811535961859713]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.40204487539042, "lat": 34.88179423403024 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13241"],
        "coty_name": ["Rabun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rabun County"],
        "coty_fp_code": "241",
        "coty_gnis_code": "00351489"
      },
      "bbox": [
        10.47667760616369, -3.341716691320086, 10.911069305061291,
        -3.0250479223237448
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.995297052666391, -4.9090093768711],
            [10.048588546836621, -4.903464248830119],
            [10.047728632906352, -4.898763291305879],
            [10.049283631773683, -4.891253876894543],
            [10.048156918602455, -4.884278298867178],
            [10.050717507698659, -4.881528785942784],
            [10.053290029477422, -4.8726265203881125],
            [10.056309019563525, -4.8714336132548794],
            [10.054826817443006, -4.866955746291977],
            [10.060664479528919, -4.8635167629845855],
            [10.064240338093821, -4.863481339340759],
            [10.065717643188098, -4.855105874588556],
            [10.06782712185942, -4.851606048778621],
            [10.072823578331292, -4.853574504913909],
            [10.075275891565552, -4.848304295148645],
            [10.073983589278008, -4.83936733744756],
            [10.079378938721234, -4.8392965648260615],
            [10.081088277582468, -4.835368024698759],
            [10.079588235334551, -4.828001594200209],
            [10.077384300546946, -4.823884746982993],
            [10.074105852021582, -4.82176710471028],
            [10.074553818534906, -4.818935809901602],
            [10.078524895912414, -4.816227257207918],
            [10.079395358874445, -4.812152461114417],
            [10.073848874614601, -4.803396655426865],
            [10.101608609221925, -4.799945604909789],
            [10.18685198116966, -4.789508762901505],
            [10.190149902472635, -4.789948573019054],
            [10.191893545567549, -4.805697829154717],
            [10.249776110155835, -4.798338330792788],
            [10.271534041641, -4.795968931650004],
            [10.27420692433074, -4.818478973856893],
            [10.27827537625239, -4.814377572203019],
            [10.283148032799252, -4.817425598525064],
            [10.284786834271937, -4.821465080617351],
            [10.28811854945601, -4.822217276167416],
            [10.288881248720873, -4.82604772868384],
            [10.297338854598626, -4.827967125198827],
            [10.302081015787676, -4.825733559101988],
            [10.30645718614788, -4.82985243457344],
            [10.310215569727413, -4.825864090406312],
            [10.315762603531496, -4.828296939125266],
            [10.328536669881927, -4.839377898034763],
            [10.304965649707501, -4.875672308657769],
            [10.30540811327325, -4.879527062284143],
            [10.309173885297922, -4.87912537375038],
            [10.309709549384081, -4.883412197071425],
            [10.305679495860545, -4.883824722450193],
            [10.310275957901899, -4.925391374442879],
            [10.313135801754875, -4.949496985251023],
            [10.29669607103413, -4.951219990663087],
            [10.230287509611752, -4.959044115056039],
            [10.229782421918692, -4.954520922751971],
            [10.226442103464448, -4.949903738263033],
            [10.209364344121997, -4.951904931298364],
            [10.178967262632396, -4.955584821317348],
            [10.105736888720697, -4.964054091403477],
            [10.104867207063746, -4.953314345068845],
            [10.087973013662593, -4.955471735687948],
            [10.087121655119796, -4.9474525202286594],
            [10.039306893733567, -4.952700185193686],
            [10.036811373575086, -4.959320999716444],
            [10.020408742827259, -4.963330442289648],
            [10.019259918326966, -4.972843693737451],
            [10.017068612598115, -4.976040182789109],
            [10.007584443858848, -4.979374318666555],
            [10.00485014833894, -4.982162384907224],
            [10.005879325121311, -4.978449585159221],
            [10.003837938979352, -4.974070366359311],
            [10.006102000300812, -4.9657063761963025],
            [10.002575168074687, -4.9644265432527],
            [10.002543923528902, -4.958889311365572],
            [9.9991562404191, -4.954232467666408],
            [9.995736153268705, -4.945698017432617],
            [9.9917434300009, -4.94109082389448],
            [9.995688041055837, -4.935479939800179],
            [9.99212271041746, -4.927868820179651],
            [9.98837189886789, -4.927605636775361],
            [9.987378554673954, -4.9222944879072905],
            [9.992652614701377, -4.915351437737643],
            [9.99610287432358, -4.914061512872154],
            [9.995297052666391, -4.9090093768711]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.28406198124675, "lat": 33.26085986963867 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13255"],
        "coty_name": ["Spalding"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spalding County"],
        "coty_fp_code": "255",
        "coty_gnis_code": "00353055"
      },
      "bbox": [
        9.987378554673954, -4.982162384907224, 10.328536669881927,
        -4.789508762901505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.860583748003622, -5.216533473879747],
            [10.941669177665327, -5.151888214363261],
            [11.018646335075031, -5.270687114013341],
            [11.055441713722415, -5.327278209068686],
            [11.116391326212149, -5.421094325654342],
            [11.133242426340344, -5.443640090185057],
            [11.127338975293386, -5.449209049471894],
            [11.078676341300692, -5.485769670552288],
            [11.000343971950334, -5.546290268095046],
            [10.996747776029457, -5.541456207479241],
            [10.990099383702695, -5.545696515503746],
            [10.993615966318497, -5.551670208336279],
            [10.925290880612067, -5.604631398733735],
            [10.927423864165878, -5.600071457482254],
            [10.93111499087844, -5.596906090457851],
            [10.926523935750861, -5.593984790640258],
            [10.927863018352499, -5.589256633075484],
            [10.92315798300613, -5.584328113186715],
            [10.926056170403086, -5.576504206516305],
            [10.92078783269571, -5.575500024484014],
            [10.925507924652145, -5.569709487077451],
            [10.912383011503275, -5.565495293320773],
            [10.901993057853254, -5.5601502870355874],
            [10.901314851656814, -5.555129025025685],
            [10.896697007881194, -5.555161525206494],
            [10.898301312421328, -5.550331874936252],
            [10.893780713550708, -5.548831029044947],
            [10.889104264900737, -5.542841578458191],
            [10.88729106348157, -5.538790902512477],
            [10.88430141514751, -5.53793556796006],
            [10.883105477106781, -5.528061963376455],
            [10.879760402586943, -5.524494800053387],
            [10.881332863961182, -5.517428756147966],
            [10.87853797389713, -5.509830250677405],
            [10.871549796409935, -5.504095365575218],
            [10.870679774447916, -5.499618340744469],
            [10.868519032150198, -5.498639617833473],
            [10.867761869814817, -5.490276361946791],
            [10.871234606364677, -5.488533349672691],
            [10.872778932765117, -5.485152970768231],
            [10.876676379615823, -5.487478847393305],
            [10.87672867661912, -5.475353503631927],
            [10.872096426997723, -5.471871882927358],
            [10.869518780890862, -5.463491341292248],
            [10.870260217217202, -5.459973684852516],
            [10.866497694092715, -5.452161345607888],
            [10.862861670400601, -5.449932936251908],
            [10.864687381416452, -5.443586623514883],
            [10.865014701588997, -5.4372812205497425],
            [10.85686578039213, -5.4275015727460145],
            [10.858436855494427, -5.424562595546604],
            [10.852424497625085, -5.420216415023731],
            [10.850371901170144, -5.411969421945278],
            [10.845680750410937, -5.411322792363018],
            [10.844046885239626, -5.40581630701621],
            [10.838552841378705, -5.406181459867008],
            [10.835723373783672, -5.408587043219837],
            [10.829326812437754, -5.410493725894964],
            [10.825386154522002, -5.410015386914658],
            [10.825085967059929, -5.406160238829659],
            [10.819916983307547, -5.403125483739363],
            [10.814551160274316, -5.404958905302418],
            [10.811392515836179, -5.397722076452744],
            [10.80594848479176, -5.396876664612162],
            [10.80540213077722, -5.387885410851489],
            [10.802965025385378, -5.3866178903876225],
            [10.801780407034995, -5.378046021870148],
            [10.799012578442918, -5.37614180685823],
            [10.80201007419096, -5.3690206093312405],
            [10.804772149226432, -5.370696214437336],
            [10.807384670120676, -5.366126849581023],
            [10.806441507494721, -5.361684493879103],
            [10.807327199681321, -5.35635769464979],
            [10.804299581522042, -5.350084447353145],
            [10.806033787603301, -5.346550723367108],
            [10.807051158615886, -5.336627368739408],
            [10.80226713049162, -5.332945070275287],
            [10.800582248638896, -5.329079986508469],
            [10.803066570794655, -5.32655827169685],
            [10.808697390118985, -5.330454143756111],
            [10.81401499368499, -5.323718777281186],
            [10.820597411874747, -5.329644216169011],
            [10.838486722965992, -5.306301217847607],
            [10.875384748783883, -5.258797112007857],
            [10.87925455683482, -5.258674405356417],
            [10.882858210769166, -5.253740003885298],
            [10.877269692103914, -5.248993116491777],
            [10.878514352106109, -5.246709973485469],
            [10.87808917974584, -5.2409480824357155],
            [10.883266579731378, -5.234574967231538],
            [10.860583748003622, -5.216533473879747]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.42702585994884, "lat": 32.66716057932368 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13289"],
        "coty_name": ["Twiggs"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Twiggs County"],
        "coty_fp_code": "289",
        "coty_gnis_code": "00345456"
      },
      "bbox": [
        10.799012578442918, -5.604631398733735, 11.133242426340344,
        -5.151888214363261
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.610415958438962, 6.64083520124325],
            [-11.567977483897588, 6.633270422794733],
            [-11.568657569507861, 6.629423212636865],
            [-11.483644794728567, 6.614306437808517],
            [-11.457899440305725, 6.757385866039229],
            [-11.456789185993697, 6.7648270658923035],
            [-11.454525731622459, 6.768641616569602],
            [-11.455560597998621, 6.775704076530846],
            [-11.452002416379047, 6.779293655025582],
            [-11.45796826189126, 6.781688093766766],
            [-11.45805942780618, 6.789025794654295],
            [-11.462737748385129, 6.798410266912144],
            [-11.465170276052135, 6.804995494478294],
            [-11.467420012990676, 6.807218122479511],
            [-11.457566762514475, 6.814737904726653],
            [-11.456818101579511, 6.822043782812362],
            [-11.45438595236448, 6.825340663104218],
            [-11.448467233946289, 6.827391350674674],
            [-11.443310879289827, 6.833971899200412],
            [-11.440049105272955, 6.832035877817381],
            [-11.431406218498207, 6.839372635366805],
            [-11.430278674650834, 6.8442581845677655],
            [-11.423857449488244, 6.848793690264922],
            [-11.419921909951498, 6.8546920943117255],
            [-11.415635463015475, 6.85714002245957],
            [-11.414976603922257, 6.859434840396406],
            [-11.409765384065835, 6.857492794137584],
            [-11.403039122506772, 6.860067550739089],
            [-11.392345986263795, 6.860956621440813],
            [-11.389342118704098, 6.858567334118365],
            [-11.385434341028484, 6.860715731314768],
            [-11.380157651088906, 6.868617631980943],
            [-11.368965445194837, 6.871248540389615],
            [-11.361285726551719, 6.8685583316517445],
            [-11.354978490833915, 6.864264018889412],
            [-11.348696766534895, 6.861436636255178],
            [-11.347614499637888, 6.85632791348604],
            [-11.338218038431211, 6.852711537351915],
            [-11.33322642756243, 6.846659528970163],
            [-11.32728195747146, 6.846480623136036],
            [-11.317830545094088, 6.847633085056783],
            [-11.310963396781695, 6.847598780257809],
            [-11.309092432198097, 6.844536010671821],
            [-11.309272514893081, 6.838958324173261],
            [-11.306570923905149, 6.838777385831682],
            [-11.30210538735256, 6.842024253573953],
            [-11.289275112872703, 6.843448269084902],
            [-11.278959820364456, 6.831940047797052],
            [-11.27372735655384, 6.830319844878916],
            [-11.268041327601704, 6.831651102990288],
            [-11.260539287403711, 6.830462926868559],
            [-11.253489416763676, 6.83090303966451],
            [-11.248263414011788, 6.829266809995938],
            [-11.244283003845574, 6.823082754677658],
            [-11.23001656609923, 6.8169248746829645],
            [-11.229945947545472, 6.8091803916123075],
            [-11.222763912594523, 6.803789243888029],
            [-11.219758109622623, 6.807829388453763],
            [-11.215156761980275, 6.8099271829257475],
            [-11.210767628802673, 6.809690030584587],
            [-11.201561349463656, 6.81647954985987],
            [-11.195578627419671, 6.811165738585492],
            [-11.192730834771444, 6.810847862675904],
            [-11.190042309805854, 6.806364617012515],
            [-11.190631583068148, 6.801960417983928],
            [-11.185147375133559, 6.802312036288593],
            [-11.1813322885231, 6.799778234697859],
            [-11.177223505686317, 6.79409405841122],
            [-11.177981840943842, 6.78870225958011],
            [-11.173460247473093, 6.785659345910023],
            [-11.170026132691506, 6.78625062225764],
            [-11.1657206341356, 6.784069430421736],
            [-11.160019546673826, 6.786924480475706],
            [-11.155468058247084, 6.785370428629383],
            [-11.153273622001759, 6.781840487142924],
            [-11.148156012016408, 6.778407274340942],
            [-11.145508665618832, 6.775066078474238],
            [-11.138564397898044, 6.781823177350445],
            [-11.131035503405226, 6.790629959468113],
            [-11.12844294321639, 6.791609036272876],
            [-11.124955626123665, 6.800371147174685],
            [-11.12471781294691, 6.80341607004975],
            [-11.119485525749253, 6.8088977812821625],
            [-11.116896453314979, 6.8159188695835855],
            [-11.113450713347302, 6.842336529416972],
            [-11.111583613840125, 6.846754468463183],
            [-11.112387487574894, 6.851229191258018],
            [-11.10792395911393, 6.857319321751097],
            [-11.1036058124601, 6.859658484440756],
            [-11.09944445565497, 6.858029661454192],
            [-11.082800216948723, 6.856496347469141],
            [-11.07938704788705, 6.858727021853461],
            [-11.078018999444254, 6.866722808104757],
            [-11.07591739083191, 6.869883204688884],
            [-11.068988302120625, 6.874319995061426],
            [-11.064700680738978, 6.873407917774311],
            [-11.060463843177955, 6.8754520188900505],
            [-11.058948096063336, 6.878684017575025],
            [-11.054528995514469, 6.88142518687184],
            [-11.047668954517698, 6.8774130802704105],
            [-11.04116216546654, 6.8763568326902815],
            [-11.033692882301853, 6.880571460512332],
            [-11.0300258548834, 6.876281854562685],
            [-11.024322717973181, 6.875723533568697],
            [-11.019802705162457, 6.871909497439627],
            [-11.015585930179423, 6.870204839660378],
            [-11.017438720514043, 6.8663895880428205],
            [-11.015292255532477, 6.863510492966668],
            [-11.018169813885496, 6.855888370145873],
            [-11.013737254412606, 6.849095222332264],
            [-10.995454996544783, 6.839264332825542],
            [-10.989054426207069, 6.834320355364688],
            [-10.984240982430114, 6.83561760135305],
            [-10.974099791977006, 6.840318732820604],
            [-10.96386418472467, 6.833750114465619],
            [-10.960789306697917, 6.835842943836972],
            [-10.955076721634809, 6.835294448006469],
            [-10.954200848875544, 6.8324995722133295],
            [-10.950130248243754, 6.830612243056854],
            [-10.949334118546329, 6.823272471879606],
            [-10.937778286241047, 6.816184773326549],
            [-10.937029759561902, 6.81310068594593],
            [-10.933387620565263, 6.812500165716844],
            [-10.929297004406655, 6.814193833142086],
            [-10.92605036180743, 6.820499417443816],
            [-10.916669786035111, 6.822771156789665],
            [-10.912542288127284, 6.821821776087982],
            [-10.908258822579189, 6.824448022087643],
            [-10.898003109568696, 6.822058237462353],
            [-10.890206042074762, 6.816714632966034],
            [-10.887365773063918, 6.8167753017919095],
            [-10.883561989742192, 6.812011275490839],
            [-10.882792801972975, 6.818321149839033],
            [-10.883061218768662, 6.826028021152828],
            [-10.880771586401272, 6.829629977048286],
            [-10.876605917296999, 6.828129097775838],
            [-10.870155864581985, 6.8230733009350475],
            [-10.86609946626013, 6.823635092935991],
            [-10.863045494787752, 6.818334807732635],
            [-10.843857953923061, 6.81248977514787],
            [-10.839482161850624, 6.813541560013064],
            [-10.83478352922515, 6.819976739943467],
            [-10.831607768131727, 6.819921580180985],
            [-10.830348190520642, 6.82351448145332],
            [-10.823064328746204, 6.823204396128359],
            [-10.82041927424954, 6.829203044653269],
            [-10.814975314936623, 6.828137201070705],
            [-10.810375219485207, 6.829251691432624],
            [-10.799470338632808, 6.826856800500685],
            [-10.797743773455979, 6.825425311644446],
            [-10.785676435336445, 6.824632368127338],
            [-10.777535957218506, 6.830427352969744],
            [-10.771056344603554, 6.825065371148338],
            [-10.764162087899845, 6.827062391114138],
            [-10.761396605888523, 6.820124798567094],
            [-10.761440419150677, 6.814301099586849],
            [-10.757353856819364, 6.8113112158661435],
            [-10.757208446477469, 6.808057924032924],
            [-10.75333508094931, 6.801335922305919],
            [-10.750700951669408, 6.787103068653971],
            [-10.743171968782477, 6.7791046216340485],
            [-10.74424054127625, 6.7766099621838185],
            [-10.739000389145307, 6.767754465811009],
            [-10.73149669917473, 6.768918553933897],
            [-10.72697166413989, 6.77299639536114],
            [-10.728116867349186, 6.775475666654382],
            [-10.72480974441672, 6.780257132173658],
            [-10.72185387403234, 6.782100272277967],
            [-10.717714400483459, 6.782025365478979],
            [-10.711260345453683, 6.777926624966925],
            [-10.70552136414194, 6.778484587707623],
            [-10.701173418848171, 6.782814040869662],
            [-10.694001502935857, 6.778287855931455],
            [-10.691270924663424, 6.784059429500658],
            [-10.68103108145045, 6.79022873315239],
            [-10.674193225446707, 6.79140889419111],
            [-10.667145865984923, 6.791184462870268],
            [-10.659034576991406, 6.789207114291659],
            [-10.653493149297748, 6.795204783170233],
            [-10.648288423089268, 6.803854694558725],
            [-10.646550674950548, 6.8038737462233225],
            [-10.639718262298581, 6.799340405503517],
            [-10.634704701530266, 6.802833955555546],
            [-10.627359787609581, 6.797417066398455],
            [-10.6203092325365, 6.794973882907901],
            [-10.617963767792297, 6.791792561891163],
            [-10.612693219145918, 6.7931777906008355],
            [-10.608262311753196, 6.792233833456451],
            [-10.602161684408099, 6.789053374227823],
            [-10.599256746053456, 6.789317163223058],
            [-10.588924680465926, 6.784600872167844],
            [-10.598374322858088, 6.72760608551401],
            [-10.599441621432645, 6.7228465668263775],
            [-10.612203422728975, 6.646436136636271],
            [-10.613462017044837, 6.638226177959098],
            [-10.735818433941139, 6.658852045139076],
            [-10.749790087519996, 6.575736819454069],
            [-10.792522121467448, 6.582844327767963],
            [-10.8068966052084, 6.498791075941589],
            [-10.810713188615573, 6.499410396887295],
            [-10.817973632602717, 6.456489464852687],
            [-10.857360649360398, 6.463123846848383],
            [-10.864525323125058, 6.4203918537814335],
            [-10.922677800384779, 6.43011286947811],
            [-10.925646067642749, 6.430156981195128],
            [-10.949232716797036, 6.434382312110699],
            [-10.964299056356676, 6.349239364603858],
            [-11.05007416959459, 6.3642422152977804],
            [-11.106383121081082, 6.3738919054934495],
            [-11.16697721258443, 6.384445661416515],
            [-11.282550831108303, 6.404716270653733],
            [-11.398130160072725, 6.424954060551518],
            [-11.430053382565333, 6.430850916363537],
            [-11.445579748004455, 6.345943780729206],
            [-11.551083301209871, 6.364951525943515],
            [-11.656591716139644, 6.383932129326695],
            [-11.640942394288233, 6.469534587728905],
            [-11.641630870979501, 6.469654177388413],
            [-11.610415958438962, 6.64083520124325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -112.3512230071909, "lat": 44.28389859085517 },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16033"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00399755"
      },
      "bbox": [
        -11.656591716139644, 6.345943780729206, -10.588924680465926,
        6.88142518687184
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.294312146578727, 1.796226668460921],
            [5.365565703350885, 1.8025851660384349],
            [5.435463992902626, 1.8092737726827102],
            [5.464123701322049, 1.811904091006533],
            [5.549690285300738, 1.8191617609410964],
            [5.552234189867921, 1.788927319216495],
            [5.553686498941272, 1.7745326842715297],
            [5.589526634026812, 1.7776727403076604],
            [5.639455107746668, 1.7822901370927209],
            [5.639496166540836, 1.78180575579249],
            [5.645594876316543, 1.709592823250548],
            [5.652192111494064, 1.635412115840255],
            [5.65946899739682, 1.5474423699856619],
            [5.664199038218694, 1.4887821695604229],
            [5.670006210629836, 1.415494538687081],
            [5.613660841835613, 1.4107814968962493],
            [5.596476055870059, 1.409445315410425],
            [5.528678351098285, 1.4050059406295907],
            [5.500462207698802, 1.4033856565683938],
            [5.47170820442557, 1.4019888793279403],
            [5.470702886717285, 1.4166136343723357],
            [5.427443779853757, 1.4141307253619786],
            [5.4111474970751745, 1.4129393438088715],
            [5.407885818597944, 1.4567873202579422],
            [5.336363229411244, 1.4513005458839807],
            [5.330553592434056, 1.524354581764363],
            [5.3310747965514755, 1.5244050002912068],
            [5.3278058173101766, 1.5682987248006826],
            [5.3111801188919205, 1.5670437386001672],
            [5.308707713721225, 1.5973016502087747],
            [5.300749383819589, 1.693812401760791],
            [5.302700361422751, 1.693979249367082],
            [5.294312146578727, 1.796226668460921]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.36752200358198, "lat": 40.12453455531245 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17107"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "107",
        "coty_gnis_code": "00424255"
      },
      "bbox": [
        5.294312146578727, 1.4019888793279403, 5.670006210629836,
        1.8191617609410964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.316859219586785, 2.1243068774233973],
            [8.337553339418905, 2.125809611332253],
            [8.388771637208977, 2.13156922241207],
            [8.403578874229154, 2.1338001777686513],
            [8.417660211127586, 2.135078931633406],
            [8.417709519977414, 2.13468474311709],
            [8.487841399967627, 2.14220863682409],
            [8.50225043504066, 2.143625276162845],
            [8.585423488080378, 2.154050607681653],
            [8.58606608805362, 2.153940095245107],
            [8.589529401964159, 2.1249383600928384],
            [8.59518341233986, 2.0815841979224334],
            [8.60331404663048, 2.017093717683165],
            [8.604380344797224, 2.0097912517050163],
            [8.614268921843891, 1.9325018383792765],
            [8.624725233802385, 1.851696139594902],
            [8.55805192318965, 1.8439601820739029],
            [8.496371615119267, 1.8367065291611242],
            [8.424368306045366, 1.8291609290998039],
            [8.352048908082121, 1.8214182280037468],
            [8.341187536048249, 1.9236106799290003],
            [8.33682216727161, 1.9635886140286447],
            [8.33340604665645, 1.9928923305211954],
            [8.332172082593129, 2.0005069780459133],
            [8.327973783858459, 2.0364841637196918],
            [8.317390041634757, 2.117288656624862],
            [8.316859219586785, 2.1243068774233973]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.39691018078351, "lat": 40.22755439901871 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18035"],
        "coty_name": ["Delaware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delaware County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00450347"
      },
      "bbox": [
        8.316859219586785, 1.8214182280037468, 8.624725233802385,
        2.154050607681653
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.443343233824484, -0.17267509771289336],
            [7.501484044998546, -0.16780005743485615],
            [7.516068202536235, -0.16630512442759646],
            [7.531038036791596, -0.16377912931643893],
            [7.560572333276261, -0.16006658512195954],
            [7.618250203126439, -0.15431318140451034],
            [7.620838334921136, -0.17948577579663672],
            [7.611212335994049, -0.1790419343332169],
            [7.612770342909912, -0.18381232704791237],
            [7.612970025934119, -0.19008321603332282],
            [7.616587307587576, -0.1920928814481265],
            [7.616170330681041, -0.1976343406564475],
            [7.618637754274392, -0.2000112655366918],
            [7.617668894709881, -0.20826449816221937],
            [7.6129259450420115, -0.21815626270903082],
            [7.617731233682981, -0.2208481603896664],
            [7.619746054022891, -0.22850117388829053],
            [7.623306302818649, -0.2368725108614392],
            [7.618050551781591, -0.23950943860552884],
            [7.616539177320923, -0.24378437689664417],
            [7.617475935780232, -0.24750819954904746],
            [7.620464309974944, -0.24994726745903004],
            [7.626156555135054, -0.24332012886009236],
            [7.62924323398606, -0.24845111469980094],
            [7.633115284569481, -0.24970806049673297],
            [7.630899460218327, -0.2549700505940557],
            [7.637018325433369, -0.2575971764025685],
            [7.6406037252760095, -0.25367583290597545],
            [7.646651053030089, -0.2580877413873367],
            [7.646190281066725, -0.26283325372740385],
            [7.647036455025002, -0.27104410593547457],
            [7.644437578945811, -0.27556564089647845],
            [7.638956773672312, -0.28083322675018474],
            [7.643719062075571, -0.2867423037578827],
            [7.64526983275082, -0.2911894179593766],
            [7.6514660523192655, -0.30144805063635877],
            [7.648298587536433, -0.30312836647601255],
            [7.64326297478352, -0.3092009027782187],
            [7.643215143456815, -0.3193128154122588],
            [7.644475923122298, -0.32376486448930736],
            [7.648251114289556, -0.32514447413427033],
            [7.653406548733056, -0.32912984138606877],
            [7.643693112061151, -0.33133574154420314],
            [7.644503411068088, -0.33510417779333346],
            [7.647678800458275, -0.3344877010556101],
            [7.649181924586617, -0.3472701954100331],
            [7.651059149516562, -0.34994042665183916],
            [7.653911686888236, -0.35797815806404903],
            [7.6533880672495265, -0.3607644812821538],
            [7.643442302962019, -0.36004522702788155],
            [7.638694432991861, -0.35676411638922445],
            [7.637210282238598, -0.3512217235596737],
            [7.633032133441471, -0.3459856951411845],
            [7.628494977007003, -0.3480424688654091],
            [7.629462296901613, -0.3538319687106859],
            [7.627098329803833, -0.3586502366190279],
            [7.621389175237562, -0.3639814526901609],
            [7.613542198390595, -0.3639617287931177],
            [7.60498232856192, -0.3700545908692504],
            [7.594573474669753, -0.3748447563988869],
            [7.589460064203632, -0.3781059706896428],
            [7.584274067218465, -0.3834727656153906],
            [7.5755808178329, -0.39620524519568506],
            [7.573014207877399, -0.39797608194192785],
            [7.568083837458279, -0.4047391507412429],
            [7.5656682448119374, -0.4106960326774171],
            [7.557639836026134, -0.42260402734888053],
            [7.546115966382946, -0.43305044215663846],
            [7.5401979179289595, -0.43577914935056544],
            [7.525726336258072, -0.4387612282259017],
            [7.510168102314864, -0.4414128935936653],
            [7.507606574075968, -0.44103628956146185],
            [7.499450522177834, -0.4446175138051333],
            [7.481173429871796, -0.4543039759296444],
            [7.474469933682494, -0.4586799207084474],
            [7.4587045627214446, -0.4727944519471267],
            [7.454519730548536, -0.4783124637880515],
            [7.451251341365498, -0.485602772430079],
            [7.451357280745826, -0.4924473255749243],
            [7.4540177393559786, -0.4999389906229563],
            [7.455194798758541, -0.5113784560082207],
            [7.452837294531075, -0.5215401911866543],
            [7.448674392553232, -0.5536008999470838],
            [7.446909022430128, -0.5591714700571612],
            [7.445731714418286, -0.5674229691649205],
            [7.441007519801909, -0.5807128247226182],
            [7.4344108270672065, -0.5888547215912433],
            [7.427026375519205, -0.5958741805509258],
            [7.422009028465151, -0.5989857698560164],
            [7.410615279303326, -0.6030016153647348],
            [7.404660452220038, -0.6030913431897982],
            [7.395704679324001, -0.6000842946522366],
            [7.391543936048039, -0.5940487870865392],
            [7.3879941302636984, -0.5799348360561584],
            [7.383657849662454, -0.5710808040120855],
            [7.3703235923141195, -0.552438214980714],
            [7.363208429468417, -0.5475989955912689],
            [7.358758781634013, -0.547157731318369],
            [7.354605372918532, -0.5487412602660239],
            [7.332452777071603, -0.5472794490879553],
            [7.319198257804945, -0.543851629397628],
            [7.307343421919999, -0.5366921125531414],
            [7.289276846045106, -0.527028508499382],
            [7.278618123670259, -0.5183003426808378],
            [7.278956877292316, -0.5170624376227516],
            [7.275079665813251, -0.4707644687396423],
            [7.280678834937908, -0.46205160435345644],
            [7.28599460666596, -0.45236546026118274],
            [7.288667589211144, -0.45043935482310316],
            [7.293587847953569, -0.44157796516206504],
            [7.2985539472032235, -0.44361151669175813],
            [7.3014313598405405, -0.44114675857732943],
            [7.300608452811207, -0.4373804287154839],
            [7.302716026280393, -0.43137149304473954],
            [7.300764638452785, -0.4269338053439087],
            [7.303613695232713, -0.4209788878071322],
            [7.3076948664296335, -0.4195543659618521],
            [7.312225951138795, -0.4158892656102622],
            [7.332302615299312, -0.3931144182140219],
            [7.33387659914737, -0.3866386190789413],
            [7.3368157417410576, -0.38847763616888287],
            [7.3394269245937735, -0.38622042198697876],
            [7.338663128874905, -0.38169530973493276],
            [7.333912675083387, -0.3811557281577041],
            [7.333704829291888, -0.37852606473687045],
            [7.340265994100154, -0.3792165016979917],
            [7.342968228508586, -0.3775124937564953],
            [7.342400236571852, -0.3719965588511352],
            [7.3437061385572715, -0.369790739902078],
            [7.353561614624534, -0.36967491343597786],
            [7.355411164099884, -0.36351853103060816],
            [7.35255992326986, -0.36073801232507696],
            [7.34731008693184, -0.3611415256740482],
            [7.3449577743469545, -0.3570191106567995],
            [7.348182828692582, -0.35485837586005375],
            [7.351918712309343, -0.3573424900061031],
            [7.353758622274966, -0.35404908081309433],
            [7.351410597802043, -0.34979054916576713],
            [7.351181344121464, -0.34567199990486536],
            [7.354563371365473, -0.3401078296954554],
            [7.352049934534078, -0.333395216872438],
            [7.35587453511299, -0.32754720401235454],
            [7.367530318545077, -0.33028217696272966],
            [7.369522698750064, -0.33554616463393316],
            [7.3756372910614445, -0.34100632786737756],
            [7.3819605563052875, -0.33737721852120683],
            [7.391955414675007, -0.3368797336054375],
            [7.3943855207196165, -0.3344901766074595],
            [7.4029292098096935, -0.3324559479855484],
            [7.400383338003312, -0.32728727155924714],
            [7.395120320613293, -0.32612862017425803],
            [7.394655715958065, -0.3235838860839982],
            [7.397818197000318, -0.3114128049271369],
            [7.397628176574544, -0.30420202536898827],
            [7.403225558070732, -0.28880948586256905],
            [7.408811380112242, -0.2846423990278274],
            [7.409452339888558, -0.27963842721507065],
            [7.4072581570550815, -0.27708420606776063],
            [7.409905062808989, -0.27419980116649206],
            [7.408247100497123, -0.2670095364594139],
            [7.410561415758376, -0.26249398159667264],
            [7.451498629168686, -0.2584038479578543],
            [7.446360778522562, -0.20616654196287135],
            [7.443343233824484, -0.17267509771289336]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.00757999636754, "lat": 38.01405896424525 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18147"],
        "coty_name": ["Spencer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Spencer County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00450388"
      },
      "bbox": [
        7.275079665813251, -0.6030913431897982, 7.653911686888236,
        -0.15431318140451034
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.098264392184965, -0.24327751883859658],
            [7.095434205698583, -0.20715075323045046],
            [7.2114216435492375, -0.19614347474371704],
            [7.2074443487829845, -0.15156159725196774],
            [7.22192535046355, -0.15042718399973162],
            [7.223106065235655, -0.16473359330641069],
            [7.27393272567858, -0.16079081546437077],
            [7.291876735599936, -0.15875244174910155],
            [7.299524634418577, -0.15831954825036215],
            [7.3254182435498345, -0.15528887312848877],
            [7.357283113114024, -0.15099424835267336],
            [7.397538150269244, -0.14757230547061956],
            [7.400206016455342, -0.17650694187852484],
            [7.443343233824484, -0.17267509771289336],
            [7.446360778522562, -0.20616654196287135],
            [7.451498629168686, -0.2584038479578543],
            [7.410561415758376, -0.26249398159667264],
            [7.408247100497123, -0.2670095364594139],
            [7.409905062808989, -0.27419980116649206],
            [7.4072581570550815, -0.27708420606776063],
            [7.409452339888558, -0.27963842721507065],
            [7.408811380112242, -0.2846423990278274],
            [7.403225558070732, -0.28880948586256905],
            [7.397628176574544, -0.30420202536898827],
            [7.397818197000318, -0.3114128049271369],
            [7.394655715958065, -0.3235838860839982],
            [7.395120320613293, -0.32612862017425803],
            [7.400383338003312, -0.32728727155924714],
            [7.4029292098096935, -0.3324559479855484],
            [7.3943855207196165, -0.3344901766074595],
            [7.391955414675007, -0.3368797336054375],
            [7.3819605563052875, -0.33737721852120683],
            [7.3756372910614445, -0.34100632786737756],
            [7.369522698750064, -0.33554616463393316],
            [7.367530318545077, -0.33028217696272966],
            [7.35587453511299, -0.32754720401235454],
            [7.352049934534078, -0.333395216872438],
            [7.354563371365473, -0.3401078296954554],
            [7.351181344121464, -0.34567199990486536],
            [7.351410597802043, -0.34979054916576713],
            [7.353758622274966, -0.35404908081309433],
            [7.351918712309343, -0.3573424900061031],
            [7.348182828692582, -0.35485837586005375],
            [7.3449577743469545, -0.3570191106567995],
            [7.34731008693184, -0.3611415256740482],
            [7.35255992326986, -0.36073801232507696],
            [7.355411164099884, -0.36351853103060816],
            [7.353561614624534, -0.36967491343597786],
            [7.3437061385572715, -0.369790739902078],
            [7.342400236571852, -0.3719965588511352],
            [7.342968228508586, -0.3775124937564953],
            [7.340265994100154, -0.3792165016979917],
            [7.333704829291888, -0.37852606473687045],
            [7.333912675083387, -0.3811557281577041],
            [7.338663128874905, -0.38169530973493276],
            [7.3394269245937735, -0.38622042198697876],
            [7.3368157417410576, -0.38847763616888287],
            [7.33387659914737, -0.3866386190789413],
            [7.332302615299312, -0.3931144182140219],
            [7.312225951138795, -0.4158892656102622],
            [7.3076948664296335, -0.4195543659618521],
            [7.303613695232713, -0.4209788878071322],
            [7.300764638452785, -0.4269338053439087],
            [7.302716026280393, -0.43137149304473954],
            [7.300608452811207, -0.4373804287154839],
            [7.3014313598405405, -0.44114675857732943],
            [7.2985539472032235, -0.44361151669175813],
            [7.293587847953569, -0.44157796516206504],
            [7.288667589211144, -0.45043935482310316],
            [7.28599460666596, -0.45236546026118274],
            [7.280678834937908, -0.46205160435345644],
            [7.275079665813251, -0.4707644687396423],
            [7.278956877292316, -0.5170624376227516],
            [7.278618123670259, -0.5183003426808378],
            [7.269040122554139, -0.5114063241857645],
            [7.25416053869813, -0.5023484170505672],
            [7.250393880113386, -0.5008854374397713],
            [7.236592826912907, -0.49422361290576317],
            [7.225608032110748, -0.49237538050079616],
            [7.223891193737724, -0.4934804286884696],
            [7.216483131654405, -0.490343601224656],
            [7.209958386259258, -0.4859432066903524],
            [7.206826123303735, -0.48254713109290004],
            [7.200886555742275, -0.48053433205538715],
            [7.192496259777824, -0.47225679807954934],
            [7.1923640506252475, -0.47117476011363346],
            [7.18254801253669, -0.4665586514792995],
            [7.174264535789531, -0.46476398715508027],
            [7.169020462183084, -0.4627039622301389],
            [7.1602123699321, -0.46144308775263887],
            [7.151828493173492, -0.4626036015012185],
            [7.148529825516841, -0.4621628248845751],
            [7.14122066958644, -0.4636588814672656],
            [7.131106916275946, -0.46775468683469784],
            [7.128779648552925, -0.4318746486599971],
            [7.127933528151822, -0.424857732315737],
            [7.126559779939214, -0.4027924330113474],
            [7.123585197509424, -0.3730390733885347],
            [7.105609565404024, -0.3746937856740871],
            [7.104799207191346, -0.3674788959331627],
            [7.10211413234514, -0.33138384775977986],
            [7.098486044342597, -0.2875260698276617],
            [7.101229061506426, -0.28344875550540005],
            [7.098264392184965, -0.24327751883859658]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.2721174237622, "lat": 38.09219006019711 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18173"],
        "coty_name": ["Warrick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warrick County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00450335"
      },
      "bbox": [
        7.095434205698583, -0.5183003426808378, 7.451498629168686,
        -0.14757230547061956
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9057558766931442, 4.832266868832983],
            [0.9646570865137672, 4.83293207340431],
            [1.004534338463844, 4.833204652931773],
            [1.0089506027737247, 4.833972299078611],
            [1.0331859053846078, 4.833787012124928],
            [1.0648585338776928, 4.8342394099698325],
            [1.0738677923766726, 4.833769021055918],
            [1.096249143734209, 4.83440845196643],
            [1.1335721625459236, 4.834862495204533],
            [1.247395182709142, 4.83594860625554],
            [1.2472311224752315, 4.834450009058848],
            [1.2488553471697337, 4.734664082790047],
            [1.2508327803424368, 4.589784675759584],
            [1.121467237420646, 4.588813679584],
            [0.9932200651526383, 4.587649635721203],
            [0.9071309603758816, 4.5868911989449455],
            [0.906910632099631, 4.630418588486574],
            [0.9069210427868236, 4.674061493462477],
            [0.9062128306457335, 4.791530195460569],
            [0.9057558766931442, 4.832266868832983]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.15080799119409, "lat": 43.37797147129154 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19059"],
        "coty_name": ["Dickinson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dickinson County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00465218"
      },
      "bbox": [
        0.9057558766931442, 4.5868911989449455, 1.2508327803424368,
        4.83594860625554
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.247395182709142, 4.83594860625554],
            [1.2907245832660252, 4.836538285512279],
            [1.4178453118125025, 4.8380411630218045],
            [1.4648594310810807, 4.83863364819859],
            [1.4986704697629964, 4.838748055410061],
            [1.5879509105631382, 4.840170280215661],
            [1.588054032656571, 4.8396138349969755],
            [1.5899725858973532, 4.739388005761201],
            [1.590361684008918, 4.699669947662846],
            [1.590914665842681, 4.666916944171736],
            [1.5917839445490634, 4.594470568891055],
            [1.5069006034542407, 4.59335407922894],
            [1.4851727549623275, 4.59320875834438],
            [1.4719348291333862, 4.592743751180785],
            [1.3791888734600442, 4.591657884431007],
            [1.3354553434200496, 4.590992001933585],
            [1.3214626323767107, 4.5910302783877],
            [1.2508327803424368, 4.589784675759584],
            [1.2488553471697337, 4.734664082790047],
            [1.2472311224752315, 4.834450009058848],
            [1.247395182709142, 4.83594860625554]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.67850918283555, "lat": 43.37803583426174 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19063"],
        "coty_name": ["Emmet"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Emmet County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00465220"
      },
      "bbox": [
        1.2472311224752315, 4.589784675759584, 1.5917839445490634,
        4.840170280215661
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.2851870191090238, 4.261811121278876],
            [2.392845303171013, 4.264101832486522],
            [2.4575270257787714, 4.265761850140176],
            [2.5570515592682597, 4.268578927862914],
            [2.557948327734041, 4.268487588642008],
            [2.6298853507256426, 4.270750549000279],
            [2.6338386414297497, 4.129641079964478],
            [2.637236986365945, 4.005690331712425],
            [2.6395700023191737, 3.918926327170926],
            [2.5535437874209523, 3.9162256436833864],
            [2.467513948233993, 3.9140710442586797],
            [2.3733845841756254, 3.9119479567133926],
            [2.3520703320112526, 3.9112789135363335],
            [2.2938392827723795, 3.9098854698548973],
            [2.2924546908937664, 3.96087912400625],
            [2.291197808893626, 4.0191139475995215],
            [2.288765986027806, 4.124116746183103],
            [2.2874599766486354, 4.172716042210295],
            [2.2851870191090238, 4.261811121278876]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.26247663185517, "lat": 42.73254722838088 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19069"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00465223"
      },
      "bbox": [
        2.2851870191090238, 3.9098854698548973, 2.6395700023191737,
        4.270750549000279
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.20138470097950198, 3.542264976104132],
            [0.20145415354340404, 3.5421293018737265],
            [0.2787793636467714, 3.5415226867804637],
            [0.34998907379848404, 3.540602096384188],
            [0.40559899048257825, 3.539288777609583],
            [0.4068099867243173, 3.5394757021701477],
            [0.44911410954122355, 3.53830849061001],
            [0.46330603601788456, 3.5383823339166884],
            [0.534270294478659, 3.538118373166107],
            [0.6141995716499895, 3.5383087639010284],
            [0.6203254716642354, 3.5385412619112766],
            [0.6429739687269328, 3.5381151971379396],
            [0.6474423617855398, 3.5383619242304043],
            [0.7058963590232693, 3.5384451399141197],
            [0.7060972618666985, 3.501971456488684],
            [0.705881567153957, 3.436548978332988],
            [0.7058738053622594, 3.360658155578525],
            [0.7058249117255463, 3.2759820334945635],
            [0.7056701324007854, 3.188319850063745],
            [0.6254047574834076, 3.1881932932825197],
            [0.5477202412963692, 3.188297088974772],
            [0.4762354336895809, 3.188251109312596],
            [0.44798283859527277, 3.1885223127971214],
            [0.41966361408566405, 3.189486802278248],
            [0.36097070680903065, 3.191151216370363],
            [0.35693267306161547, 3.196742128485857],
            [0.3552604869169809, 3.202461273360968],
            [0.35483351246530065, 3.209776521203102],
            [0.3512761277721245, 3.217097589992881],
            [0.3468320429783204, 3.2222217714885306],
            [0.3442151901249433, 3.2268995455989837],
            [0.3440501692364606, 3.2306539784878665],
            [0.3461931281605296, 3.2351798422514992],
            [0.3497411750806883, 3.2375513552783777],
            [0.3586379267406219, 3.240512187085077],
            [0.36272534503276, 3.245983876880397],
            [0.36283055883128806, 3.2523603533583985],
            [0.3577641761900989, 3.262645031585136],
            [0.3569655332903891, 3.266826446378338],
            [0.35843878760988995, 3.271212542546736],
            [0.36376766470949706, 3.277554872650744],
            [0.36836850629585827, 3.290532980073107],
            [0.3681419758601341, 3.297106333540602],
            [0.3659079595825295, 3.3000776526575657],
            [0.35949785326416017, 3.303543762420152],
            [0.3482007948540118, 3.3056468137954176],
            [0.3396863693884832, 3.3045140676030944],
            [0.33294100572010477, 3.3018406281184025],
            [0.327745293069904, 3.3022235301630563],
            [0.3230596780400405, 3.3062798545168954],
            [0.3219313824536074, 3.3100426233989957],
            [0.32738270871427144, 3.321090929679575],
            [0.3282888343617732, 3.3256408278126695],
            [0.32498174147510306, 3.3320177022836943],
            [0.32019890009495355, 3.3343789957137915],
            [0.3116957472166954, 3.3350051655272006],
            [0.3049451039818932, 3.3324401910695967],
            [0.3000625227063037, 3.323081742155328],
            [0.2942066416156755, 3.3201074303208937],
            [0.28923209486214163, 3.322148612832461],
            [0.28612111663427137, 3.325095328662787],
            [0.28524115405145073, 3.3327529308327617],
            [0.2875219685203946, 3.338126158555501],
            [0.2956465930456738, 3.344476483163339],
            [0.29879564348632753, 3.348491587387111],
            [0.3000732436657165, 3.3554317399211695],
            [0.2973172164147857, 3.361127567550948],
            [0.2925559552630249, 3.3650880355413233],
            [0.2879391785015013, 3.3670528284279624],
            [0.2817165411146268, 3.367599505728452],
            [0.27488196533354586, 3.3640626543205534],
            [0.2691353736480179, 3.365865855723242],
            [0.265638713614673, 3.368344757499552],
            [0.2625083987456632, 3.3733474023931014],
            [0.2584593641710766, 3.386546570285807],
            [0.258032250596008, 3.400246774520379],
            [0.2597647140392937, 3.407670549141953],
            [0.26652962226443855, 3.422489370939872],
            [0.2673174412526351, 3.4296090063001534],
            [0.26680384398793, 3.4366497442013837],
            [0.2631577521698874, 3.444833069821346],
            [0.25808714506779884, 3.4499579297575655],
            [0.2533302265320609, 3.452122034111864],
            [0.24202976043191715, 3.4545922899866826],
            [0.23537013533734844, 3.4591176320976826],
            [0.23263283072825683, 3.462961118669947],
            [0.22846343848824718, 3.4733365497878435],
            [0.223808917087581, 3.4782169127987177],
            [0.2149145915433608, 3.483986853017804],
            [0.21167617115859133, 3.487309079078444],
            [0.20775574484076198, 3.4936701440115283],
            [0.20590267639050144, 3.504364358392168],
            [0.20820368471364994, 3.5136833232912017],
            [0.20762763550023242, 3.521751371407441],
            [0.2051111859271305, 3.527527074033493],
            [0.19956789863223737, 3.53489791358779],
            [0.19900233450726595, 3.5376595888724363],
            [0.20138470097950198, 3.542264976104132]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.95986273101512, "lat": 42.05163066471535 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19133"],
        "coty_name": ["Monona"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monona County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "00465255"
      },
      "bbox": [
        0.19900233450726595, 3.1881932932825197, 0.7060972618666985,
        3.542264976104132
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.09866844200947351, 3.8901779830612093],
            [0.14246920653974393, 3.891010287725036],
            [0.17021344605792052, 3.890909054785913],
            [0.29273923485857467, 3.889811161435455],
            [0.307045252631155, 3.89028255300146],
            [0.33613770190623177, 3.889722250042978],
            [0.44398432490250184, 3.8892257681225444],
            [0.479705814842567, 3.889265961031181],
            [0.5662492956629902, 3.8888726280708426],
            [0.6528638851154448, 3.889721419299995],
            [0.6531538350426055, 3.8518464985617156],
            [0.6529464299075812, 3.8029460465970475],
            [0.7061196424019656, 3.8028894903030546],
            [0.7062327129601456, 3.7891737853238276],
            [0.7061605618074555, 3.7272018219248038],
            [0.7058237086766364, 3.7244906727138827],
            [0.7062250081347888, 3.7028054915123954],
            [0.7058005783269533, 3.6975946399666353],
            [0.705430239835935, 3.6526567585350866],
            [0.7058493156973501, 3.632870463475278],
            [0.706379515558469, 3.5900764641493885],
            [0.7060703361420014, 3.5844907120165654],
            [0.7063223830134127, 3.558307440919843],
            [0.7058963590232693, 3.5384451399141197],
            [0.6474423617855398, 3.5383619242304043],
            [0.6429739687269328, 3.5381151971379396],
            [0.6203254716642354, 3.5385412619112766],
            [0.6141995716499895, 3.5383087639010284],
            [0.534270294478659, 3.538118373166107],
            [0.46330603601788456, 3.5383823339166884],
            [0.44911410954122355, 3.53830849061001],
            [0.4068099867243173, 3.5394757021701477],
            [0.40559899048257825, 3.539288777609583],
            [0.34998907379848404, 3.540602096384188],
            [0.2787793636467714, 3.5415226867804637],
            [0.20145415354340404, 3.5421293018737265],
            [0.20138470097950198, 3.542264976104132],
            [0.21635441396672617, 3.546014342831427],
            [0.21951122799906758, 3.5486793182392544],
            [0.22566003167274645, 3.5570007253604583],
            [0.22630165923741927, 3.5607668184044363],
            [0.2210768639457391, 3.5674037371558533],
            [0.22280056321951386, 3.5772130476978536],
            [0.22016848742424655, 3.5867055903980756],
            [0.21276476100616132, 3.596463132462636],
            [0.2017995371880492, 3.6039165961248942],
            [0.19493773404316148, 3.6133690469260364],
            [0.19300488364822815, 3.6193777363764172],
            [0.19301189707563354, 3.631207103304332],
            [0.19196626034145928, 3.638501116672355],
            [0.18807472290799315, 3.6460121206943366],
            [0.18159622345475884, 3.653607929836296],
            [0.17273062952792934, 3.6586503070437457],
            [0.1641455244202646, 3.6652677670773626],
            [0.15984159791788002, 3.6712988423352453],
            [0.15702033348637323, 3.6794040357746343],
            [0.15695552033270854, 3.6866883654362246],
            [0.16399124084846067, 3.7041285371217425],
            [0.16348843720906459, 3.7095539610749375],
            [0.15926491941625204, 3.721576675299118],
            [0.15890694100754804, 3.7284607063254738],
            [0.16166834630190263, 3.7390956042268226],
            [0.1795082287178049, 3.7607153500729398],
            [0.18194836422741617, 3.76552631517208],
            [0.1846247245120239, 3.7746549299093317],
            [0.18508514076570456, 3.7797750538031227],
            [0.18424661661678093, 3.790022120787624],
            [0.18085391701839082, 3.802891253195955],
            [0.1734924171610186, 3.812562034616949],
            [0.16376133404181387, 3.816117906765625],
            [0.1373248837675174, 3.819284287914901],
            [0.12983015676877158, 3.8212618552824025],
            [0.12413298562154124, 3.819180536844126],
            [0.1196631651357091, 3.8201383417598778],
            [0.11540916061460674, 3.818376992439604],
            [0.1136101511218108, 3.8231308127572907],
            [0.11699849844499963, 3.83234326963228],
            [0.11260889149758875, 3.8399977842639506],
            [0.10952265192264352, 3.8392170983672265],
            [0.10477470273475151, 3.841346045782578],
            [0.10268980444463195, 3.8462178101944167],
            [0.10429347450541648, 3.8492710969170556],
            [0.11229070127950955, 3.8531102388498826],
            [0.11239136739025228, 3.858531867188088],
            [0.11395946565173565, 3.8645484869305],
            [0.11461718415781542, 3.8851120894956157],
            [0.10904874682475309, 3.88594943014296],
            [0.10101301650728259, 3.8855439802490617],
            [0.09866844200947351, 3.8901779830612093]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.04474253878874, "lat": 42.3896922979038 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19193"],
        "coty_name": ["Woodbury"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woodbury County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "00465285"
      },
      "bbox": [
        0.09866844200947351, 3.5381151971379396, 0.706379515558469,
        3.891010287725036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8389111834001103, -0.6687495566272071],
            [0.8485366745103459, -0.6687820099609779],
            [0.9251717337949228, -0.6680447047248746],
            [0.9818812730371322, -0.668036573992532],
            [1.0246242864368005, -0.6677830560642442],
            [1.0969975543508743, -0.6675273137719624],
            [1.163595487070453, -0.666745713176617],
            [1.1829318258092911, -0.6667393736923161],
            [1.182845382274361, -0.6959477369723801],
            [1.182931308789892, -0.7548915895692363],
            [1.1827606847844299, -0.8281021745888784],
            [1.1836462059024786, -0.8867697831483796],
            [1.177193101209623, -0.8869359874155803],
            [1.1778393852755968, -0.9457896490884975],
            [1.1779294429669855, -0.9749991730576941],
            [1.1562901037908517, -0.9752743081035684],
            [1.1490138226267133, -0.9738088910590695],
            [1.120993190793373, -0.9737990315051113],
            [1.1140971608193262, -0.9752348272539518],
            [1.0636816723918021, -0.9759520174613484],
            [1.0211562849621985, -0.9762088684360882],
            [0.950253655336567, -0.9764010645377248],
            [0.9157418407206365, -0.9767316907743436],
            [0.9141653580087389, -0.9764878127881966],
            [0.8781001177005476, -0.9770355318974885],
            [0.8353590739864636, -0.977211680246519],
            [0.8357265359936791, -0.9479499705657504],
            [0.8354161015176986, -0.8888361908412435],
            [0.8397608062514021, -0.8888405991059475],
            [0.8397347892278383, -0.8373336651142363],
            [0.8390418915307651, -0.75674557849325],
            [0.8389111834001103, -0.6687495566272071]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.30137249981556, "lat": 37.88571459766819 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20001"],
        "coty_name": ["Allen"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allen County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00484970"
      },
      "bbox": [
        0.8353590739864636, -0.977211680246519, 1.1836462059024786,
        -0.6667393736923161
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.17120072933392913, -0.1780092540988941],
            [-0.08566430483704494, -0.1791283033176315],
            [0.000760298878489278, -0.17977086118232394],
            [0.0500061316482292, -0.1803649287580758],
            [0.10556297332303209, -0.18069448369949145],
            [0.1896319588869849, -0.18103621574785198],
            [0.18908335903047285, -0.23946605513800515],
            [0.1882415729018745, -0.3089340898012716],
            [0.1873521097039733, -0.44486442142200117],
            [0.18682799312741874, -0.44487154758364106],
            [0.1861725526083271, -0.5034902131292393],
            [0.18559773944436853, -0.5334331797618892],
            [0.1846273961797759, -0.6211216228372395],
            [0.09898195012798294, -0.6201334801991064],
            [0.05627288906302525, -0.6199684413608026],
            [-0.02112588464131967, -0.6197688846481666],
            [-0.03464077546081795, -0.6194348287437885],
            [-0.14875127704890573, -0.619010454791983],
            [-0.19157657544816417, -0.6189459362299472],
            [-0.19082902351277528, -0.5456252456824372],
            [-0.19060552829125912, -0.5023222972825814],
            [-0.19083548910340753, -0.5015740075271993],
            [-0.19012947533333233, -0.4415727661348922],
            [-0.18767093630721643, -0.4400100699581571],
            [-0.18680564021012683, -0.3533922252586952],
            [-0.17268883691993878, -0.353650608450348],
            [-0.17217594827628208, -0.2803998054089694],
            [-0.17184213072105572, -0.2220041313945376],
            [-0.17120072933392913, -0.1780092540988941]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.59395373069194,
          "lat": 38.302037681135225
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20017"],
        "coty_name": ["Chase"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chase County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00484978"
      },
      "bbox": [
        -0.19157657544816417, -0.6211216228372395, 0.1896319588869849,
        -0.1780092540988941
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.3851010072664982, -1.3073391013830502],
            [-1.3604121074508868, -1.3077878518439632],
            [-1.3028150899612498, -1.3091594440103216],
            [-1.2161780918726197, -1.311068859562555],
            [-1.1300498222394628, -1.3120279273523385],
            [-1.0274158072058464, -1.313737711045174],
            [-0.9580803799116691, -1.3144174914324067],
            [-0.9561205623525658, -1.3144496738201183],
            [-0.9564265205987847, -1.3437804001021922],
            [-0.9570064736834394, -1.4287298756190443],
            [-0.9576850691754883, -1.4969532858494345],
            [-0.9591035557940052, -1.5484223383859297],
            [-0.9590921635923177, -1.5782452983582909],
            [-0.9617690135835076, -1.7056372150447399],
            [-1.0906619336153474, -1.7033297333255357],
            [-1.206674519568244, -1.7011810711730118],
            [-1.3061006897590661, -1.6990690734396863],
            [-1.3926391388593338, -1.696992514955731],
            [-1.3919515549097214, -1.6584779289903873],
            [-1.3895660884103234, -1.5411547058980835],
            [-1.3886110796529945, -1.4829237740935408],
            [-1.387965388295722, -1.4536515642390087],
            [-1.3863405871662757, -1.3655422032950475],
            [-1.3851010072664982, -1.3073391013830502]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.0754703388266, "lat": 37.19162094566061 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20077"],
        "coty_name": ["Harper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harper County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00485004"
      },
      "bbox": [
        -1.3926391388593338, -1.7056372150447399, -0.9561205623525658,
        -1.3073391013830502
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8405552206390572, -1.3293066713136692],
            [0.9521754784105285, -1.3286308646741285],
            [1.0406421531703751, -1.3280009290491304],
            [1.1263827520927574, -1.3269806313941597],
            [1.1812230943087731, -1.3269694227517774],
            [1.1916230581239597, -1.326883084054996],
            [1.1919016160390408, -1.3711852923631713],
            [1.1924959612001365, -1.4450382743358148],
            [1.1936073696091756, -1.469879808967432],
            [1.194607929524899, -1.5668901289650516],
            [1.1965569773285054, -1.7147739842025458],
            [1.114463786075376, -1.715517990014669],
            [1.042824567515624, -1.716177434647649],
            [0.9322053485857114, -1.717155686347217],
            [0.8414960431281987, -1.7176255622030951],
            [0.8409293963303974, -1.6539590825673443],
            [0.8415413851088066, -1.6390979547841869],
            [0.8414538001981913, -1.5954912100694385],
            [0.8410721165499874, -1.5651477493687587],
            [0.8415854381650003, -1.552660209704773],
            [0.8412990433491592, -1.5213443096026515],
            [0.8422826002232334, -1.5030276907131526],
            [0.843682095066603, -1.4628171405883459],
            [0.8436393498710703, -1.448020905204927],
            [0.8423214520001537, -1.4040613709635665],
            [0.8420109829960173, -1.374127606579778],
            [0.8405552206390572, -1.3293066713136692]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.29757838408158, "lat": 37.19129624467168 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20099"],
        "coty_name": ["Labette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Labette County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00485014"
      },
      "bbox": [
        0.8405552206390572, -1.7176255622030951, 1.1965569773285054,
        -1.326883084054996
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7065217642349486, 1.3820347783551685],
            [-2.632901893578551, 1.3787880031409068],
            [-2.5648080157307747, 1.3758519797933138],
            [-2.5323657615262563, 1.3748096329876813],
            [-2.518928219854864, 1.3739526352195486],
            [-2.430169813620717, 1.3702186758749442],
            [-2.401519036065571, 1.3693239284942125],
            [-2.3872679053661754, 1.3684511276735574],
            [-2.3795069679229925, 1.368627314445953],
            [-2.2897181131635413, 1.3651893887571895],
            [-2.287495234443632, 1.3651044363423661],
            [-2.28934812368162, 1.3243300870277657],
            [-2.289729267616328, 1.3212551212374977],
            [-2.2919204365118437, 1.2775696271294341],
            [-2.294200243174311, 1.2267568272757299],
            [-2.2955362501555845, 1.190278741276913],
            [-2.3005330367185404, 1.0811615023750056],
            [-2.300903788216118, 1.065764781896434],
            [-2.3032188198318058, 1.0072940024647015],
            [-2.306222072559883, 0.9271265153961159],
            [-2.3919142971395386, 0.9304039112229076],
            [-2.4779192589452843, 0.9333822396821552],
            [-2.605706067152881, 0.9386521787322175],
            [-2.6734619427591597, 0.9414604009595414],
            [-2.6762485288979576, 0.9419476998054943],
            [-2.7134789788142863, 0.9436610845481281],
            [-2.7277512506260133, 0.9438967796861014],
            [-2.723592054511462, 1.0315849952418212],
            [-2.7207021499639152, 1.0968950908599437],
            [-2.7198086714998477, 1.1208670075069866],
            [-2.7178500674233876, 1.1628514877837637],
            [-2.714731778170894, 1.2211504694212645],
            [-2.714220267865697, 1.2357829545093955],
            [-2.711384439174992, 1.294043746034395],
            [-2.706991746819906, 1.3776758053476104],
            [-2.7065217642349486, 1.3820347783551685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.90347661074922, "lat": 39.7843893222368 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20137"],
        "coty_name": ["Norton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Norton County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00485032"
      },
      "bbox": [
        -2.7277512506260133, 0.9271265153961159, -2.287495234443632,
        1.3820347783551685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.020443961465085987, 0.8743749793706994],
            [0.034710237411293594, 0.8743811090387442],
            [0.08216753997579754, 0.8738274820487116],
            [0.1956101005081327, 0.8734601230496188],
            [0.2812387000137848, 0.8732609616558975],
            [0.3658454875016139, 0.87310866477259],
            [0.43628333459181773, 0.8729156331545943],
            [0.4361026295632407, 0.8576379717961603],
            [0.4364101018700595, 0.8424608781028724],
            [0.43677552010198856, 0.7255811357101848],
            [0.43721013467411746, 0.6813615453122153],
            [0.43681892705243597, 0.5633923237027144],
            [0.4364406956964809, 0.5200438502563958],
            [0.43634265080362067, 0.44691523921930093],
            [0.436157442167999, 0.4324794477730341],
            [0.4337273697545176, 0.42919221732134455],
            [0.43162270048664786, 0.4324762534655579],
            [0.43289903940002467, 0.4400525498171319],
            [0.42995381222450574, 0.44398108138310605],
            [0.41994405399773155, 0.44419941833718524],
            [0.41669055858596926, 0.4452382696233274],
            [0.41060278826860014, 0.44981578731484045],
            [0.40410300041746994, 0.4530786754107787],
            [0.3959744554296256, 0.4552765223400216],
            [0.39380379496621365, 0.4576722436479972],
            [0.393932092715897, 0.46171844310015475],
            [0.3993315654180802, 0.4663019254658432],
            [0.40933085118474133, 0.4654497967211016],
            [0.4150499537471474, 0.46063318800041786],
            [0.4194565290106085, 0.46114323861526263],
            [0.41861199063813714, 0.4678452060860372],
            [0.41382881466929067, 0.4741832791431851],
            [0.4091729237281454, 0.48430937835158244],
            [0.3995964813566355, 0.4968314858413512],
            [0.39642246116078644, 0.49712004542536214],
            [0.3898431665498826, 0.4951618435007424],
            [0.38358963662247814, 0.5035446009185697],
            [0.3780620973753766, 0.5034559862324686],
            [0.3750640117328987, 0.4940940587715871],
            [0.3727040610006826, 0.4915811811364054],
            [0.36689094223840135, 0.49046100314463836],
            [0.3536177670790934, 0.4951217124574694],
            [0.34640674202052235, 0.49596077725625537],
            [0.3354074823847763, 0.4941974494385844],
            [0.3296398601659243, 0.4921372449209385],
            [0.32609739291852086, 0.49567623747682366],
            [0.3264939621145785, 0.5061151507726943],
            [0.32303616349462705, 0.5105404797641088],
            [0.31739441998526174, 0.5114571326943613],
            [0.3126999361037614, 0.5101603623635875],
            [0.31016295987134884, 0.5060053563469786],
            [0.30621948363999585, 0.5032981038367716],
            [0.29457170386267795, 0.504516448688649],
            [0.2908266565079713, 0.5106702869475281],
            [0.28440634293924144, 0.5159777705312548],
            [0.27958338048873016, 0.5146794117406873],
            [0.274231502681603, 0.5080867118654467],
            [0.27204909990709986, 0.5012689304125927],
            [0.2683509640596486, 0.4947742474564585],
            [0.2595416869691301, 0.484061813239726],
            [0.2536837736260257, 0.48287505281084836],
            [0.24720460802169092, 0.4871603568051066],
            [0.24251200459915553, 0.4945077969107146],
            [0.2378963208161334, 0.4991204195983283],
            [0.23089445735266653, 0.5012331956468947],
            [0.2247619632755688, 0.49960948602624816],
            [0.21696365134993326, 0.4935286946448607],
            [0.21443251118495893, 0.48970504713643004],
            [0.20941134174542997, 0.46918395153057424],
            [0.21154403018648724, 0.4643104557918094],
            [0.20921837711706387, 0.4622973778919768],
            [0.20468027426847987, 0.465604524619282],
            [0.19749303093102602, 0.45731256407224213],
            [0.18855258569860447, 0.45998977874420016],
            [0.18743006083456903, 0.46272792777047594],
            [0.19009119523865517, 0.4731487178211428],
            [0.18912754427794945, 0.4766423870365976],
            [0.1847806941126706, 0.4756775799387795],
            [0.17742157054156601, 0.46775274441907777],
            [0.17238409343869657, 0.4682562595870347],
            [0.16499957087099323, 0.47659178339201874],
            [0.15792258253687283, 0.4833407210875804],
            [0.1471596928557199, 0.48891595928897263],
            [0.13375110932208686, 0.49069261675057774],
            [0.1215966688588278, 0.494722201815026],
            [0.11288703693490469, 0.49487057443208277],
            [0.10943945056716871, 0.4920574502878294],
            [0.11079208891923906, 0.48806819303264903],
            [0.10773431873918973, 0.48230028832105376],
            [0.10806366423022414, 0.4780353002573124],
            [0.11029242883827453, 0.47288174943594563],
            [0.10818640932685225, 0.4706032901299323],
            [0.0980866929716143, 0.4683947818319874],
            [0.09640383149530611, 0.47247179233130515],
            [0.09617509854007754, 0.4796600404337299],
            [0.09161295851275296, 0.4835225274449991],
            [0.08786769287913085, 0.48191632584817234],
            [0.08560749172097765, 0.47367884371119573],
            [0.07896224356406102, 0.47156824088775673],
            [0.06743000262740051, 0.4751159885587908],
            [0.06534555483280234, 0.4802599749558603],
            [0.06904714550377684, 0.4880195558962012],
            [0.06676366172601003, 0.4919500454956421],
            [0.04477123624921216, 0.48690202865675647],
            [0.038474596483208605, 0.48334944773299915],
            [0.03517545307708203, 0.4874403240230026],
            [0.034752161280776815, 0.4937980065774762],
            [0.03308375499129152, 0.501315923132158],
            [0.034644080166407104, 0.5030936440459475],
            [0.04308927942072673, 0.5011979861950046],
            [0.04880711253905394, 0.5024897803469172],
            [0.052239632861467, 0.5002573946921473],
            [0.05614974705941748, 0.5002041501042676],
            [0.06519450868103198, 0.5033514399581271],
            [0.06560746351235947, 0.5100980344527857],
            [0.058859888381603845, 0.5154766915356438],
            [0.05365309026605323, 0.5169524578902742],
            [0.050002188972124835, 0.5195191492208368],
            [0.04696773946930592, 0.5132136299435366],
            [0.04422038687362559, 0.5132748078066677],
            [0.041576916568135794, 0.5184205809374395],
            [0.04067190614977433, 0.527254287767796],
            [0.034212595697241104, 0.5441250684243847],
            [0.031830476124614995, 0.54606936501606],
            [0.027501507441595664, 0.5432785393608692],
            [0.021732029579481664, 0.5423723979281216],
            [0.018829096093964368, 0.5393866834046207],
            [0.013198698741319766, 0.5437975906105247],
            [0.012472758234502342, 0.5477362316121606],
            [0.018267352488665567, 0.5510441651351342],
            [0.02278755249274057, 0.5489421030414413],
            [0.025912346616977836, 0.5519175370927262],
            [0.025756320496854095, 0.5553145256633364],
            [0.021256002893072123, 0.5579866593180485],
            [0.020368652804112937, 0.5539711049154621],
            [0.010405090554591184, 0.5548622094564005],
            [0.007232408725218842, 0.5576743602986076],
            [0.00773946481305244, 0.5656494603636107],
            [0.005894627688781799, 0.5692680440580193],
            [-0.002406595737029047, 0.571312441492108],
            [-0.005704848445185147, 0.5736100754507489],
            [-0.0163251759912793, 0.586458713137206],
            [-0.023092668625584203, 0.5928655452172933],
            [-0.026484590628992794, 0.5985475842985617],
            [-0.021193643584946225, 0.6009198474086527],
            [-0.02182789581895769, 0.6045592909405141],
            [-0.030151405584497314, 0.6135795963251406],
            [-0.03471369017592594, 0.6154459351130919],
            [-0.03946792517760747, 0.6232194227186479],
            [-0.034268643874791734, 0.6257195294241454],
            [-0.03168488602737793, 0.6324271142255403],
            [-0.03889232838543106, 0.6306664899332908],
            [-0.04716811989164095, 0.6348387408299809],
            [-0.05092932143188401, 0.6409534201208807],
            [-0.049232468572685574, 0.6442898943295462],
            [-0.044427698091429914, 0.645314139138688],
            [-0.04271048877476856, 0.6497620438906095],
            [-0.0497923447843625, 0.650289128124646],
            [-0.05611815891983801, 0.6573357296834975],
            [-0.06087386720698832, 0.6613330255565083],
            [-0.06558833297173612, 0.6668223181820799],
            [-0.06096046150031673, 0.6728021925898449],
            [-0.059890294941728824, 0.6770978173134014],
            [-0.06313820694830487, 0.6808875447571917],
            [-0.06774201930565568, 0.6795208994390388],
            [-0.07272946437773778, 0.6853497545086761],
            [-0.07315568333449761, 0.6882944472247962],
            [-0.08556747834305448, 0.700064398160479],
            [-0.09218275731575579, 0.711283123425181],
            [-0.0871629929188201, 0.7118818952324454],
            [-0.08307089148735343, 0.718709132622505],
            [-0.08337351124861746, 0.7270119589202073],
            [-0.08485869798435727, 0.7292741686871015],
            [-0.08902301168380455, 0.729002868862659],
            [-0.0931118721857697, 0.7344920236501405],
            [-0.08550478282355647, 0.7374533598143673],
            [-0.08179295957244692, 0.7441794405932352],
            [-0.08611638592506872, 0.7468324454150902],
            [-0.08851187571327034, 0.7518633439640546],
            [-0.07822737118821185, 0.7682180557927483],
            [-0.07605558438484589, 0.7694020712912983],
            [-0.07136678913357676, 0.7659172827287453],
            [-0.06838107308159058, 0.7656611867277026],
            [-0.06336779699903188, 0.7681269625157015],
            [-0.062350130229393085, 0.770403854322031],
            [-0.06379482710944531, 0.7761012467796372],
            [-0.057794724483404725, 0.7906657766061229],
            [-0.0548383964057107, 0.7891073346783141],
            [-0.05709558554037482, 0.7847316509320865],
            [-0.05272250170482926, 0.7803096168668022],
            [-0.04678650965164595, 0.7831757208706189],
            [-0.044346714743120956, 0.7937369318208611],
            [-0.041986563696654385, 0.8008627978512382],
            [-0.038238441514243694, 0.808132521172986],
            [-0.03277745161857723, 0.8147234803386262],
            [-0.026675825507239233, 0.8143539943733219],
            [-0.02520722594100185, 0.8181413009183243],
            [-0.028958530609039735, 0.8246699172345935],
            [-0.02732558971054921, 0.8301699105255361],
            [-0.023747993424448277, 0.832623757547035],
            [-0.013019118329556777, 0.8447312387184306],
            [-0.006630202362662427, 0.8397872280840097],
            [0.0009812398076412448, 0.8456025710619771],
            [0.011396324656089665, 0.8518442540010046],
            [0.013945040814751987, 0.854212451145396],
            [0.0122533128620012, 0.861028816452487],
            [0.016265048624249608, 0.8685778976297485],
            [0.020443961465085987, 0.8743749793706994]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.34233877383186, "lat": 39.37896311338808 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20149"],
        "coty_name": ["Pottawatomie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pottawatomie County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00485038"
      },
      "bbox": [
        -0.0931118721857697, 0.42919221732134455, 0.43721013467411746,
        0.8743811090387442
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4956807141146491, -0.6677078393026068],
            [0.5960777363890246, -0.6681166223309438],
            [0.6104250384564426, -0.6680411530242065],
            [0.6673755215064918, -0.6685043666630682],
            [0.6959124252666038, -0.6682649815000937],
            [0.6964576883847755, -0.6685429758910125],
            [0.7429981052344758, -0.6681904097225551],
            [0.7680974589717109, -0.668844894858009],
            [0.7759445577643479, -0.6686870514334577],
            [0.817723188398835, -0.66907489723964],
            [0.8389111834001103, -0.6687495566272071],
            [0.8390418915307651, -0.75674557849325],
            [0.8397347892278383, -0.8373336651142363],
            [0.8397608062514021, -0.8888405991059475],
            [0.8354161015176986, -0.8888361908412435],
            [0.8357265359936791, -0.9479499705657504],
            [0.8353590739864636, -0.977211680246519],
            [0.7435387557814047, -0.9771479375912809],
            [0.7222066253967296, -0.9769716260745281],
            [0.6366616507405657, -0.9768832543170183],
            [0.5580413103212578, -0.9767779967218891],
            [0.5316849867430459, -0.976387701785336],
            [0.4943806242509131, -0.9765729405214661],
            [0.4939280280781712, -0.8880424897699146],
            [0.4964890822330187, -0.8880888619947237],
            [0.4961887198131484, -0.852300838699365],
            [0.4961436742083008, -0.7706130126236947],
            [0.4956807141146491, -0.6677078393026068]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.74012300970197, "lat": 37.88669564774866 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20207"],
        "coty_name": ["Woodson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woodson County"],
        "coty_fp_code": "207",
        "coty_gnis_code": "00485064"
      },
      "bbox": [
        0.4939280280781712, -0.977211680246519, 0.8397608062514021,
        -0.6677078393026068
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.945257225323468, -0.18387497967936556],
            [8.951348124593114, -0.18053742578177143],
            [8.9589078894851, -0.17845604064447687],
            [8.96270261531966, -0.1736440533838382],
            [8.966100559965655, -0.16064981640383255],
            [8.973254121529278, -0.1546999017046014],
            [8.974747148918043, -0.14909485845638565],
            [8.982918191115848, -0.14387597671720692],
            [8.978809630509417, -0.14120110002427924],
            [8.976308320462799, -0.1325620499806436],
            [8.979416541378647, -0.1215468523336934],
            [8.979475716500824, -0.1161949192400023],
            [8.981068248853168, -0.10847070795769391],
            [8.97960394361808, -0.10500295799274031],
            [8.98263352289593, -0.10211380867348546],
            [8.983756192735738, -0.09602870509921603],
            [8.989661612101093, -0.09042416269271697],
            [8.993170299607826, -0.08995736475988057],
            [8.994960338686065, -0.08482944602037139],
            [9.007571637714035, -0.08280118193503219],
            [9.019800181772933, -0.08483195032042759],
            [9.039681016531468, -0.08957496944987502],
            [9.048058378678451, -0.09823472369057101],
            [9.079345955774857, -0.10494719491517951],
            [9.08425599683205, -0.10850193600898136],
            [9.088806288657285, -0.10986074291856732],
            [9.09297390380132, -0.10710569127410406],
            [9.104172326059114, -0.10466264353906371],
            [9.108296357371948, -0.09893871315403964],
            [9.109768712609608, -0.09216069968342915],
            [9.114481265517297, -0.08754249437813781],
            [9.113461955759057, -0.0830116224109567],
            [9.119258663691806, -0.08263361886913578],
            [9.120692586689502, -0.09196371824121222],
            [9.121498778546487, -0.10319996227974174],
            [9.124611707495346, -0.10807917473974321],
            [9.129564323426404, -0.1085920557949678],
            [9.138850677801145, -0.09753273976328555],
            [9.143565051284655, -0.09841030550121256],
            [9.149072702055927, -0.10390492775010214],
            [9.152290840479187, -0.11329266801010082],
            [9.151506882580485, -0.11536096307595645],
            [9.142695066825823, -0.12495751328591709],
            [9.141767667544947, -0.12769028795124363],
            [9.147807842045394, -0.13328104210607955],
            [9.155332050037835, -0.13580020335619303],
            [9.156709255769167, -0.14119864959079684],
            [9.154332649619308, -0.14430510651688172],
            [9.143246978388696, -0.14510783381642317],
            [9.139337598316516, -0.14943160196117342],
            [9.139296455362272, -0.15253365911969874],
            [9.142305976837477, -0.15721315842718214],
            [9.152389828617455, -0.1625659615532097],
            [9.155598578450476, -0.1662484380513724],
            [9.157507873695973, -0.17299952773808044],
            [9.156750769962663, -0.1766468204501188],
            [9.15276156266721, -0.18310270136623938],
            [9.153607209804566, -0.18951061146228357],
            [9.1640304019761, -0.1925660063524655],
            [9.17007787840748, -0.19553441415624603],
            [9.170957493822295, -0.19939920863058647],
            [9.16796325060476, -0.20659240883652372],
            [9.167195258277095, -0.2136820833893897],
            [9.17252028279152, -0.22230105699180036],
            [9.177351449954246, -0.2239628908303435],
            [9.181533331333787, -0.22291200310793574],
            [9.189760373889088, -0.22362005265016435],
            [9.146522935518183, -0.24767886954556034],
            [9.145075797086827, -0.25040556153085575],
            [9.125542378496453, -0.26189814768529873],
            [9.118366543377078, -0.25894741228088225],
            [9.115442016828444, -0.25513321349170626],
            [9.111449790543993, -0.2650431259003369],
            [9.108917858936998, -0.2626904582106529],
            [9.10500618395447, -0.2633097098819194],
            [9.104557496997383, -0.25482684614419115],
            [9.099875829402047, -0.2550104821879271],
            [9.094784951899541, -0.25798381949751903],
            [9.094617975148653, -0.25213285161637006],
            [9.085596352051985, -0.2520489167700568],
            [9.074614298886152, -0.2586468475241351],
            [9.074661594937327, -0.2629825579944462],
            [9.06856303916912, -0.2622773884299656],
            [9.06873511764368, -0.2712426475719339],
            [9.060606277911026, -0.27474881202018103],
            [9.056550615205154, -0.2744265415100478],
            [9.05433770894252, -0.28149795756438045],
            [9.055362417043108, -0.2901654400920137],
            [9.054438615864651, -0.2953603310836237],
            [9.0490115172913, -0.2989404929865747],
            [9.049163622428448, -0.3058765432801983],
            [9.04438191030261, -0.3044576257432026],
            [9.043039107572469, -0.30828483121542427],
            [9.03909693388867, -0.30531111867345634],
            [9.039021596552823, -0.31160559559671663],
            [9.03450692452512, -0.31545759659531136],
            [9.036037796711849, -0.31997340041146666],
            [9.034690826280395, -0.322282037773828],
            [9.030471112377423, -0.3216081025541384],
            [9.027849285386683, -0.3185140092448877],
            [9.024274425698447, -0.3280263130552148],
            [9.017306106564732, -0.32369157100007856],
            [9.014011992791993, -0.32722779081387365],
            [9.005964615656936, -0.32469544061658584],
            [9.002924919126517, -0.32099226692012245],
            [8.998300583047737, -0.32332864858095944],
            [8.994875496576487, -0.32741173846689486],
            [8.988263341218948, -0.32197917016240435],
            [8.990059444020632, -0.3295236958337781],
            [8.982533580678215, -0.33077614817448003],
            [8.979266816287721, -0.3284147245631348],
            [8.974864581780036, -0.32821717846387777],
            [8.972797140949323, -0.33279405304149656],
            [8.960664999008841, -0.3305631675574393],
            [8.957733123143067, -0.3281714676460759],
            [8.955908723976654, -0.3182675011773775],
            [8.956520522092099, -0.3127121440368557],
            [8.94866868997424, -0.30887787091906826],
            [8.941050605156018, -0.3074798972136744],
            [8.939448000078018, -0.3096359775839004],
            [8.939989644046651, -0.31628032164685227],
            [8.937269634768713, -0.3197071833930777],
            [8.936446191229177, -0.32583030381939915],
            [8.928032016385185, -0.3234468610216143],
            [8.928431338218155, -0.32699617973587725],
            [8.932338954559707, -0.3279626824442262],
            [8.933272269096884, -0.33333925722353214],
            [8.926544340702792, -0.33469050572411],
            [8.924754788509587, -0.3290929299727034],
            [8.921678024794817, -0.3284912430534138],
            [8.901488729433048, -0.2554384988240476],
            [8.899312040566256, -0.24596973427856522],
            [8.900880912775767, -0.23953921561568653],
            [8.897147402169184, -0.23267075436442625],
            [8.89744235230533, -0.2293661887747983],
            [8.900264278485583, -0.22640047930356033],
            [8.90393946464296, -0.23608485696627118],
            [8.908954730620678, -0.2338118398305947],
            [8.914025059499501, -0.22892497451210053],
            [8.920843613094055, -0.22646456758187697],
            [8.927241689546237, -0.22801902179290864],
            [8.931502131399862, -0.21258545930324482],
            [8.927993834724681, -0.20311875353379744],
            [8.93350872085487, -0.2018139727431019],
            [8.932005787489052, -0.19691050915458827],
            [8.937701713695283, -0.19656239608414983],
            [8.9404929454511, -0.19469107249208026],
            [8.945257225323468, -0.18387497967936556]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.99091913265157, "lat": 38.00398172434625 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21005"],
        "coty_name": ["Anderson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Anderson County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00516849"
      },
      "bbox": [
        8.897147402169184, -0.33469050572411, 9.189760373889088,
        -0.08263361886913578
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.6306267125454985, -1.1602606473787782],
            [7.637984416868061, -1.1538833540215137],
            [7.640475512929992, -1.148886191868337],
            [7.63961731070255, -1.1411684409119298],
            [7.640759766447725, -1.1361487433040034],
            [7.648817256763231, -1.1237278068815817],
            [7.656169139567521, -1.1176407588389112],
            [7.662928255290152, -1.1184258980421968],
            [7.665696946436153, -1.105636506612086],
            [7.669727299155087, -1.103029980328439],
            [7.669965318497731, -1.0986445709195036],
            [7.675279581311508, -1.0929630300643274],
            [7.678783486274847, -1.0855828157827294],
            [7.67740613957478, -1.0814621213331752],
            [7.681522776619743, -1.0730871628622514],
            [7.687084856382403, -1.0722207786642843],
            [7.694371693911818, -1.0739081311297705],
            [7.6847167709904, -1.0607480067109614],
            [7.681313830331335, -1.0467736341747156],
            [7.683849125974934, -1.0381790462296416],
            [7.687037632009071, -1.034891894379674],
            [7.6957197578550085, -1.0301007640107223],
            [7.701286927949611, -1.0302803305327077],
            [7.705186734678976, -1.0330093954053512],
            [7.716859308224556, -1.036685154287418],
            [7.71863655939806, -1.0395217912387638],
            [7.718298339737576, -1.043816127663787],
            [7.7220845937247535, -1.0524155407637266],
            [7.731328000028993, -1.0574184170288763],
            [7.738917916037251, -1.0496826107405681],
            [7.837848965056227, -0.9546048629933015],
            [7.938956255881773, -0.9776195922166127],
            [7.957258966605862, -1.0177910536358115],
            [8.012265376482889, -1.1333853687767599],
            [8.027474875030109, -1.1641280814921375],
            [8.020151503766494, -1.167192492503887],
            [8.018285536952943, -1.1731123216657982],
            [8.021384449726275, -1.1803610891200509],
            [8.019033714520399, -1.1832838682091098],
            [8.015721671766919, -1.1823699076016272],
            [8.00935075534189, -1.1777702926716032],
            [8.002186760606435, -1.1756296784704],
            [7.9977668979660805, -1.1709731759220605],
            [7.99364121032224, -1.171953619806004],
            [7.992675757366841, -1.1766615689438233],
            [7.993641115641619, -1.1836423724305127],
            [7.990057640190553, -1.1870171835374965],
            [7.9834823723863035, -1.1881596365803353],
            [7.975632485816709, -1.1860429554330547],
            [7.974220694765062, -1.179306890572149],
            [7.970281688296528, -1.1734824474683256],
            [7.959975479973878, -1.1629860677047648],
            [7.959189513927864, -1.15885739805904],
            [7.95232792399378, -1.1559210073483865],
            [7.948959479121279, -1.1509271787378665],
            [7.945569637133979, -1.1545300801850058],
            [7.939259922301284, -1.1571530192934292],
            [7.934089077858518, -1.156661274961364],
            [7.928704564529965, -1.160562361506196],
            [7.926325326520971, -1.1672022229979717],
            [7.921909944302871, -1.1630627942376826],
            [7.917643144973004, -1.1642469104696664],
            [7.915463266696677, -1.1691934041336625],
            [7.906884565066965, -1.1697429399621375],
            [7.897561944518764, -1.1667173380052294],
            [7.896843227062114, -1.1596232896159298],
            [7.889072373407646, -1.1637031428605573],
            [7.883074704155241, -1.163223183447957],
            [7.882456598701703, -1.1680670209466435],
            [7.877763396298791, -1.1700398664510625],
            [7.872613833689822, -1.1643688356180335],
            [7.863048896671047, -1.165058977073692],
            [7.859888817900032, -1.1697648746520277],
            [7.85412085065561, -1.1672795776630993],
            [7.8503032444272325, -1.1705557943482614],
            [7.85075027422149, -1.1768975940505793],
            [7.854846287238498, -1.1819367880044183],
            [7.858933568790485, -1.184017467666543],
            [7.85960258328129, -1.1919451657836988],
            [7.861124630406792, -1.1968108953246124],
            [7.858869575323422, -1.204529036951808],
            [7.847822026632049, -1.2586091420687942],
            [7.834807422069721, -1.3229419522297723],
            [7.828125121468721, -1.356633999737785],
            [7.728499292112135, -1.3254744585653493],
            [7.688085831750528, -1.3127340849377727],
            [7.611328365270892, -1.3074654911869232],
            [7.608175920054694, -1.3032785287360773],
            [7.609389999598887, -1.2997705114334492],
            [7.623514425880479, -1.2950243176412979],
            [7.627721489107301, -1.2944722838568539],
            [7.632723602551096, -1.2907568881150449],
            [7.63814077681115, -1.289707914439529],
            [7.638089142401024, -1.2861361295123874],
            [7.642044482003783, -1.2862980003169122],
            [7.64571602799887, -1.284481010127095],
            [7.643856707350973, -1.2813201263049916],
            [7.6422924922481315, -1.271210524304603],
            [7.639674145929953, -1.2681731494522794],
            [7.63914370640621, -1.2643937397653808],
            [7.641026140250988, -1.2611026718377805],
            [7.646507598466742, -1.2625191463814383],
            [7.652011787571957, -1.2622394416979883],
            [7.648026526223478, -1.256772076712213],
            [7.645316142951851, -1.2577272659507233],
            [7.641101098706951, -1.2548890020540195],
            [7.638110806844063, -1.2498408006116946],
            [7.640031463072094, -1.2469851429608547],
            [7.637113417895362, -1.242017185448154],
            [7.632869187753203, -1.2433413095581876],
            [7.632461138255334, -1.2471144788725814],
            [7.625838374057788, -1.2484300243271842],
            [7.627383059548166, -1.2380707500699955],
            [7.618176770878092, -1.2318915886728703],
            [7.611706184572483, -1.2397790834707982],
            [7.607927063647002, -1.2365637939226264],
            [7.612774637892911, -1.2347513303897555],
            [7.617511858125209, -1.2301663548062252],
            [7.6148841552960125, -1.223720692212234],
            [7.6139556581107275, -1.2146388524771319],
            [7.616124652473651, -1.2120287017868254],
            [7.618027610237145, -1.2050395546835997],
            [7.6178787994989765, -1.1979122247818497],
            [7.622024052782643, -1.1960211215667855],
            [7.629615047421253, -1.195171323204561],
            [7.6329026891995655, -1.1963049847667429],
            [7.637089385528448, -1.1950875078988612],
            [7.6400137809090385, -1.186910124094262],
            [7.637954622233052, -1.1845614152202402],
            [7.632447601193896, -1.1884229634090422],
            [7.6258115010615395, -1.1838703576596334],
            [7.624630661635728, -1.1804107279691805],
            [7.630791626151405, -1.1808864196630786],
            [7.6297349982188924, -1.1762962859994723],
            [7.626707575859226, -1.170690438251603],
            [7.625611777465034, -1.1652683283354228],
            [7.627610256418259, -1.161159771911099],
            [7.6306267125454985, -1.1602606473787782]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.68160251911883, "lat": 37.20728568837013 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21031"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00516862"
      },
      "bbox": [
        7.607927063647002, -1.356633999737785, 8.027474875030109,
        -0.9546048629933015
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.708208484696693, -0.615505380350613],
            [9.72541152731149, -0.5780544116565253],
            [9.747687342080908, -0.5678457434104146],
            [9.78777731059918, -0.5613944749114879],
            [9.82342388338804, -0.5595969145965856],
            [9.862285585721759, -0.5446517145759692],
            [9.883274637745183, -0.5338367970693385],
            [9.904100840368192, -0.5395787046775148],
            [9.917056122687104, -0.5502025393935392],
            [9.9346715982736, -0.5665348713411729],
            [9.939708665942815, -0.5730783206370842],
            [9.945566962697702, -0.5770884329665187],
            [9.946471347741374, -0.5815902527592827],
            [9.953719006597886, -0.5897168764142829],
            [9.954825972290658, -0.5938740515268959],
            [9.952816389219798, -0.6008544504447016],
            [9.953822633499426, -0.6055549113282923],
            [9.959686377795515, -0.611585333755979],
            [9.959919342748211, -0.6300016335483408],
            [9.977935754980905, -0.6541150569196486],
            [9.981998378191271, -0.6544699519391226],
            [9.987082174993905, -0.6568923687740157],
            [9.990212202456807, -0.6561317910971689],
            [9.99993290696398, -0.6695141204489375],
            [9.998827089103182, -0.6718146030405912],
            [10.001017923799477, -0.6784900760634915],
            [10.011294682030744, -0.6901231347509146],
            [10.023668402564576, -0.7186421808434565],
            [10.026603180075979, -0.7196077531055072],
            [10.03049216629572, -0.7264455377451654],
            [10.02985074478231, -0.7299509546790703],
            [10.034761891708742, -0.7352457623153912],
            [10.03892627533144, -0.7351493025264317],
            [10.038649774021264, -0.7384305823230167],
            [10.043590579619242, -0.743927778178908],
            [10.047811119354922, -0.7471496982669039],
            [10.053715234320808, -0.7488690671356422],
            [10.056729037277407, -0.7540922832199991],
            [10.054750812315543, -0.7600268101835764],
            [10.056042120745632, -0.7631870321731399],
            [10.05160046428345, -0.7641314597332024],
            [10.050745889655733, -0.7679832424469452],
            [10.047062462158715, -0.7690340604710466],
            [10.027299399296302, -0.7700546644469689],
            [9.99806232621268, -0.7989428458372625],
            [9.983336796306588, -0.8004644030127692],
            [9.984131452133251, -0.8047732361247042],
            [9.987102753877632, -0.8074623882803756],
            [9.988931662023802, -0.8122472996602136],
            [9.981101331733122, -0.8223481390451454],
            [9.982191520587, -0.8304281071222643],
            [9.98116206296869, -0.8337653772639755],
            [9.975907907076017, -0.8391307134895507],
            [9.974488398688292, -0.8424536250493905],
            [9.976595438789214, -0.8523078384206362],
            [9.974846210340008, -0.8556963126851287],
            [9.96745491757466, -0.8541999470543645],
            [9.960096543258361, -0.8500105239543362],
            [9.95307566763934, -0.8517226283075731],
            [9.947929219159438, -0.8541017515693894],
            [9.94184381482991, -0.8608710078402645],
            [9.942300539309471, -0.8630998086910896],
            [9.893549053455846, -0.8664588511176402],
            [9.86113272276191, -0.8559154311647353],
            [9.860176617979288, -0.8571557700478035],
            [9.852142199770022, -0.8538246062243368],
            [9.85119532525199, -0.8487194724450211],
            [9.856239160317427, -0.8420157306351785],
            [9.84691891022669, -0.8394064430549347],
            [9.84420615600394, -0.8422320682529553],
            [9.840293672065108, -0.8408207987564844],
            [9.835114962122411, -0.8422007038664027],
            [9.833915977473664, -0.838966173277351],
            [9.82779443140472, -0.8349193213168183],
            [9.819516976711096, -0.8320889378143443],
            [9.813892370873015, -0.8258659287611108],
            [9.807157233643666, -0.8216750531377506],
            [9.81132533153748, -0.8173549415187841],
            [9.816007069591569, -0.8162853292850066],
            [9.813607772375756, -0.8126073929166707],
            [9.806294704188705, -0.813853207672162],
            [9.80654517205049, -0.8107016647824778],
            [9.803662281750093, -0.8065816015817461],
            [9.804191294282196, -0.80324035341353],
            [9.799105583626314, -0.8009195286726352],
            [9.79445290502094, -0.7951075038930692],
            [9.78986364314928, -0.7958091590941891],
            [9.787303937456468, -0.7979673495806585],
            [9.788180924519805, -0.8019744617482545],
            [9.783801883628794, -0.805821128831818],
            [9.78173833038256, -0.8129752092159538],
            [9.778077508985263, -0.8083169508006736],
            [9.774489900570044, -0.8060305080944397],
            [9.775301678401265, -0.802599221782964],
            [9.78137388393687, -0.8032266607001826],
            [9.781236350146186, -0.7972167241705954],
            [9.7760155124464, -0.7927948462077237],
            [9.776391271136232, -0.7886610864022231],
            [9.781894092509205, -0.7881427102258077],
            [9.781260553143811, -0.7823303042003401],
            [9.775804764887669, -0.783283406869869],
            [9.773641969171987, -0.7808356278232085],
            [9.783800322153194, -0.7739703884229262],
            [9.78193996288028, -0.7706656877437037],
            [9.774934971177712, -0.7643349305674937],
            [9.769592752490501, -0.7648227058135038],
            [9.760523674223794, -0.7598617556908369],
            [9.759131721147172, -0.7571960211161837],
            [9.748827492552946, -0.7502974237676485],
            [9.747501607586182, -0.7390298866101711],
            [9.750786581468532, -0.7304038917423152],
            [9.750546311599306, -0.724039463257888],
            [9.752777734250488, -0.7172780373773887],
            [9.743658578172179, -0.7094076762175302],
            [9.74367633508213, -0.7057177268248008],
            [9.740145431656897, -0.7033213879467289],
            [9.736028774924167, -0.6951236670583546],
            [9.730722362586896, -0.6914866936731425],
            [9.729349741359556, -0.6889484223949979],
            [9.730252404838405, -0.6839929880025747],
            [9.728144097375111, -0.6812535825870241],
            [9.724446339538757, -0.680654201448216],
            [9.72225250435362, -0.6726736800023425],
            [9.720317591854268, -0.6714642475705054],
            [9.716422615302815, -0.6604357335436409],
            [9.712643230316937, -0.6549780786266571],
            [9.709627438717744, -0.6526537453500557],
            [9.708834833736182, -0.6477543677861348],
            [9.71107939529862, -0.6427711423906989],
            [9.708005489501174, -0.6400154776055197],
            [9.705992412457904, -0.6313171200336914],
            [9.705986094427292, -0.6272751198076401],
            [9.71015123654375, -0.6229466428762251],
            [9.708208484696693, -0.615505380350613]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.00575695326094, "lat": 37.41977087100388 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21109"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00516901"
      },
      "bbox": [
        9.705986094427292, -0.8664588511176402, 10.056729037277407,
        -0.5338367970693385
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.9723379797060123, -5.685092185718959],
            [3.007517601549186, -5.684467183485939],
            [3.07336821368946, -5.683080446154197],
            [3.0928869954453466, -5.682465723826605],
            [3.1325174679408176, -5.682346244772846],
            [3.192318703534295, -5.680807246558839],
            [3.195147586703627, -5.7712773390470105],
            [3.1985004078631003, -5.877136148594715],
            [3.1913518845696704, -5.877361890745763],
            [3.19185574191304, -5.892159513292077],
            [3.1990525694530922, -5.891962161039587],
            [3.200600318063293, -5.935831953301513],
            [3.13791810271603, -5.93786811056522],
            [3.11490725914346, -5.938734680378043],
            [3.1161553614199633, -5.986985311672892],
            [3.1130737433825653, -5.985086599848586],
            [3.1111439416059365, -5.988062421799722],
            [3.105798578328082, -5.9900190937738795],
            [3.101986361619292, -5.993707479308736],
            [3.1024615376156657, -5.997786657484054],
            [3.096460015366422, -6.0035407694845055],
            [3.090662226940746, -6.007415917180818],
            [3.087252988365003, -6.0114374059814475],
            [3.0881892574136796, -6.01351453071001],
            [3.0837515874989334, -6.021428858834855],
            [3.0858290979526695, -6.026383985416619],
            [3.084236252321528, -6.0292055231580335],
            [3.086736286073863, -6.032452273379357],
            [3.0865161694145007, -6.0409633317688085],
            [3.089358560082889, -6.050043159508008],
            [3.0887880909162475, -6.052664856988174],
            [3.0918468884887673, -6.057626160230792],
            [3.0902997794595395, -6.0636052901084785],
            [3.0916132212694345, -6.0697795376410095],
            [3.0903039224435562, -6.071474686192922],
            [3.0908114939469633, -6.078281649391152],
            [3.088385719463233, -6.082065718538294],
            [3.089150302955461, -6.086193319040639],
            [3.087678626159747, -6.091972209127337],
            [3.083474652214819, -6.096816836597157],
            [3.0760587593278186, -6.098775303692814],
            [3.0764159570049214, -6.114315470054294],
            [3.0749740923875613, -6.1145416197068245],
            [2.9631174400480327, -6.11825467196162],
            [2.8270352023512766, -6.122524101193311],
            [2.8244856891707153, -6.121097685776532],
            [2.8251194194513976, -6.108013064469673],
            [2.8288628570820165, -6.106499852547276],
            [2.8270213314469967, -6.100397227613642],
            [2.825902133084332, -6.082195576347658],
            [2.8286946607840737, -6.078900247633197],
            [2.829914805493389, -6.074154424683874],
            [2.8271466440624673, -6.0720619697651275],
            [2.8265314811501905, -6.064564569478556],
            [2.8274884916508567, -6.060854981830345],
            [2.8243819765904106, -6.055967545327155],
            [2.8262459449967854, -6.044019541091363],
            [2.82174675246335, -6.042441170675741],
            [2.8216833411066577, -6.036664982396838],
            [2.8182633457536643, -6.034591222135745],
            [2.8164680412720555, -5.991331932665376],
            [2.7737984891442955, -5.992831233532184],
            [2.7721769178337663, -5.938212294902051],
            [2.766742456684802, -5.762012019046512],
            [2.764216013250654, -5.690688200757464],
            [2.7833552105438266, -5.689730786757912],
            [2.798568680557168, -5.689728518332816],
            [2.878493682632748, -5.6875538591707375],
            [2.9041072924274802, -5.68672009658165],
            [2.9723379797060123, -5.685092185718959]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.9957729547077, "lat": 32.822714878628155 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22027"],
        "coty_name": ["Claiborne"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Claiborne Parish"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00558505"
      },
      "bbox": [
        2.764216013250654, -6.122524101193311, 3.200600318063293,
        -5.680807246558839
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.234181839134971, -6.901457811767451],
            [4.234197910859853, -6.9009369897627035],
            [4.260730951502587, -6.899772841140132],
            [4.271796711402746, -6.899898975847693],
            [4.329230683597185, -6.8979128452447895],
            [4.333952828376941, -6.8941942158081],
            [4.337489126895635, -6.893134590750812],
            [4.346430742559547, -6.894455259764589],
            [4.357998238245905, -6.894118269992823],
            [4.357844513097897, -6.897168501935498],
            [4.3607750531572895, -6.9000732917952945],
            [4.375436915707446, -6.898895020888265],
            [4.3742367228833094, -6.91327133088445],
            [4.3610265446991905, -6.935746649096428],
            [4.359228968102408, -6.949307831404673],
            [4.359615642299437, -6.958970642933173],
            [4.362632294166343, -6.984273993042908],
            [4.36547903132197, -7.002598807656459],
            [4.364147435236238, -7.020524623073697],
            [4.362147263525109, -7.026507900884048],
            [4.349383115008077, -7.034336321151665],
            [4.345547083505402, -7.036084463703009],
            [4.338356314755221, -7.036627779493309],
            [4.332279153331944, -7.0356207318796296],
            [4.308952796866791, -7.029047058151537],
            [4.299819099333692, -7.0244906709697155],
            [4.294988816924477, -7.021126954943142],
            [4.28808126157777, -7.013370766536427],
            [4.283308724961979, -7.0063973593874875],
            [4.279093115320254, -7.005506179944182],
            [4.271224964113248, -7.012165310740124],
            [4.267174666236258, -7.016691824146592],
            [4.2638634386216125, -7.024220620484137],
            [4.263205914165181, -7.032921833536024],
            [4.264675977491712, -7.039661382725104],
            [4.267923036031799, -7.044430821741153],
            [4.2771172377085644, -7.055131211313677],
            [4.284723827773383, -7.060322281862709],
            [4.292456020450256, -7.06394737070407],
            [4.2974043642857085, -7.064412107857249],
            [4.3084774796392775, -7.063289701436829],
            [4.315862581748696, -7.061443033102411],
            [4.33347108932054, -7.053223521947397],
            [4.33814351382352, -7.051504021656956],
            [4.34489265725481, -7.050582856276099],
            [4.353194262915107, -7.051881439329383],
            [4.361176206931763, -7.057084535106229],
            [4.360550552941223, -7.070383434862604],
            [4.358776187480921, -7.077551686753207],
            [4.3531919776373815, -7.085002064582855],
            [4.3438104763959675, -7.093032373242121],
            [4.334720798515383, -7.101845355432275],
            [4.324519460299033, -7.10881461720691],
            [4.299780377757275, -7.119263033903684],
            [4.291199516469536, -7.115777942404913],
            [4.282374406307463, -7.117839077562655],
            [4.27676031705684, -7.1177537424996995],
            [4.269149495617957, -7.120177288694117],
            [4.263862681270916, -7.129217618081489],
            [4.263802968859615, -7.133793228723763],
            [4.265942009533277, -7.137967687757499],
            [4.270890970336749, -7.1408216224979615],
            [4.271006256261171, -7.147531017892334],
            [4.26956011744464, -7.152571164752149],
            [4.26941064639944, -7.167447907649768],
            [4.27146997412182, -7.190195392437084],
            [4.273594584406936, -7.201430822305623],
            [4.275319829236681, -7.206145846233857],
            [4.287761638968972, -7.229366473455342],
            [4.305358080669108, -7.24461719370823],
            [4.308479149547197, -7.251044362569456],
            [4.31269744970351, -7.252710140924282],
            [4.313418278219558, -7.266414748540414],
            [4.314427638942508, -7.271576391841058],
            [4.313533462110884, -7.27719178636654],
            [4.308395438969939, -7.2837850224783125],
            [4.286903234280992, -7.284802040765727],
            [4.27661088593015, -7.279966034140008],
            [4.2667889392287135, -7.269890544722204],
            [4.261768757379886, -7.2607349887055825],
            [4.254600429677707, -7.237397491313457],
            [4.254378219472175, -7.233530801513084],
            [4.256254407150432, -7.228185477575572],
            [4.252802676941771, -7.220795282054322],
            [4.248988975591637, -7.218711676678988],
            [4.246074902023902, -7.219204153998976],
            [4.240884257730451, -7.223530951881593],
            [4.23231560561456, -7.229035741937249],
            [4.228328926077907, -7.233168162534897],
            [4.223506661128798, -7.242352292589283],
            [4.2221341418385645, -7.24903390912026],
            [4.2222830990865905, -7.2538039137308745],
            [4.22640535405527, -7.261768433879069],
            [4.231254318885824, -7.274758478658966],
            [4.236428417275823, -7.268946908942821],
            [4.242119380222414, -7.265499195128106],
            [4.2503519770803555, -7.269037028009073],
            [4.247491376064904, -7.275315161766844],
            [4.2474201590590335, -7.291008007133967],
            [4.249407533698444, -7.297469849937397],
            [4.249662331547197, -7.3041784865200325],
            [4.252673911110719, -7.30751970642252],
            [4.261051144888077, -7.312518341512693],
            [4.265103855335073, -7.318861076649602],
            [4.276681649816346, -7.326760062090829],
            [4.284182782214099, -7.332896262867783],
            [4.286128439622197, -7.336670592822864],
            [4.286389048589249, -7.357882622077652],
            [4.281278816399161, -7.371507991419978],
            [4.2788959000201086, -7.374535951948278],
            [4.262972635365566, -7.383164642938624],
            [4.249417178429784, -7.3880982095493275],
            [4.24073090932961, -7.389912759553499],
            [4.231982255069665, -7.390660225995674],
            [4.220643791773802, -7.389914116995891],
            [4.20438816517957, -7.387336816980976],
            [4.191804482421463, -7.386009203123052],
            [4.177930218001577, -7.3867728625064775],
            [4.174918511508459, -7.387670144212465],
            [4.168823606531385, -7.3926087969695935],
            [4.164562023774205, -7.3992628725526135],
            [4.164068999770825, -7.404842089164238],
            [4.166870193819065, -7.412170391392891],
            [4.173772638487949, -7.4201019288222065],
            [4.190531936852348, -7.427648793079893],
            [4.211351257343628, -7.444124831230706],
            [4.217266665380018, -7.45043088345484],
            [4.222520153908516, -7.460975043439819],
            [4.223449706884702, -7.473435562334294],
            [4.217323451662294, -7.48874967327846],
            [4.21166012199533, -7.497919693357467],
            [4.1975887708972754, -7.516164773886942],
            [4.194523513136372, -7.524377231918129],
            [4.1948266435523145, -7.536179290267313],
            [4.198934279904487, -7.542601825324062],
            [4.2049802743332485, -7.548199543831536],
            [4.209577291505445, -7.550776740169262],
            [4.222690896640733, -7.560243274746931],
            [4.246745307326735, -7.580297195468408],
            [4.249885750760846, -7.583492771665467],
            [4.252608493953842, -7.589263942052128],
            [4.254100140863162, -7.5959510298685435],
            [4.253339553903447, -7.603844207309261],
            [4.25097915683476, -7.611180109890588],
            [4.245181479348621, -7.620588676434384],
            [4.239717281256838, -7.626566125850546],
            [4.229748623984582, -7.6337536780702395],
            [4.216350994530209, -7.64039437316377],
            [4.200721240711668, -7.646923556141986],
            [4.19090265173701, -7.65330055193041],
            [4.187920241280114, -7.656711380079329],
            [4.183430576620575, -7.666845961719648],
            [4.17480657289264, -7.677311559942793],
            [4.173019304537975, -7.681882228092784],
            [4.170409192337313, -7.683142711172942],
            [4.169059975195935, -7.674289034547192],
            [4.16922411698171, -7.669234520023762],
            [4.172930140681132, -7.661656089224015],
            [4.172883637775594, -7.659145472640983],
            [4.173369392498955, -7.652169298098489],
            [4.177139010817197, -7.641699092995879],
            [4.183143992315251, -7.632006461613965],
            [4.18386893491105, -7.628008349327771],
            [4.181272104837935, -7.620508378795534],
            [4.176615633350327, -7.614241262783367],
            [4.1693417395210055, -7.609915830907015],
            [4.165399933444878, -7.6092950137310105],
            [4.148542187225371, -7.611352954554394],
            [4.138163802163428, -7.616104571362882],
            [4.127707894681078, -7.614903348537162],
            [4.119770700492842, -7.615571929365778],
            [4.114728037836909, -7.612109495113693],
            [4.121028311410764, -7.597158646839489],
            [4.125095743823446, -7.582626815883483],
            [4.124699954316738, -7.577747904873808],
            [4.117835371941426, -7.574992895852442],
            [4.11635553544242, -7.570712752075846],
            [4.118948482050747, -7.563057913315744],
            [4.125424746434772, -7.559244914481314],
            [4.129118082988023, -7.552424106125981],
            [4.12902480631552, -7.547253257999641],
            [4.12673812514198, -7.54255597869515],
            [4.123031235244172, -7.540390306110505],
            [4.118151814505079, -7.539558258026744],
            [4.115568426570431, -7.533896098299776],
            [4.1147415810683645, -7.522153330356192],
            [4.116031468741393, -7.517260560289854],
            [4.12086728933257, -7.505110311825951],
            [4.125669326159932, -7.496596317962843],
            [4.129725839018474, -7.493277539632498],
            [4.140550007011884, -7.493799716908769],
            [4.143500429750135, -7.492588359414456],
            [4.144699625328785, -7.488076958506506],
            [4.143103881165034, -7.478629411299705],
            [4.147541533845549, -7.4702230842772535],
            [4.147844837984796, -7.467459647244185],
            [4.14365691945564, -7.463977505183562],
            [4.141077549464186, -7.4588102057030445],
            [4.13558311006892, -7.454209158972834],
            [4.129194939930169, -7.452144770883365],
            [4.124023501986844, -7.448576149208128],
            [4.1206263542553, -7.447891793513001],
            [4.115889537162755, -7.450183524808144],
            [4.109379218945837, -7.457730207370537],
            [4.102700247541591, -7.455073230313153],
            [4.095115996145629, -7.453932993181501],
            [4.091661260796626, -7.4511226248740146],
            [4.0893596118294715, -7.444974106491771],
            [4.077191782296535, -7.436557659739462],
            [4.06856059441548, -7.436366690972098],
            [4.060934561639071, -7.437473139060699],
            [4.049052933987045, -7.434083688886206],
            [4.0427264980638755, -7.4282188936282845],
            [4.031804012921884, -7.423771819862073],
            [4.0286027492414265, -7.419558962486383],
            [4.029525234936561, -7.414085009861162],
            [4.027293587996029, -7.409383302182757],
            [4.018216660663132, -7.4051932214659635],
            [4.010701958375656, -7.395548977749481],
            [4.016571393859005, -7.3889000120104615],
            [4.019234144726593, -7.383987235798081],
            [4.020278700772458, -7.373904621657189],
            [4.018566234675448, -7.368442068754467],
            [4.013767558730495, -7.366835965349595],
            [4.003815155297561, -7.369851100653534],
            [3.992463236245613, -7.366721845089166],
            [3.985400261524483, -7.360811491669151],
            [3.982050670247768, -7.354992278317688],
            [3.980326254222515, -7.347208653829721],
            [3.9799137176134134, -7.332813910512711],
            [3.9812239822064663, -7.322587850656667],
            [3.982160746993577, -7.309005335197067],
            [3.98341287809305, -7.303505299751499],
            [3.986808004063071, -7.296997602837233],
            [3.99104811840027, -7.292000655531925],
            [3.996757838681828, -7.286979476560732],
            [4.002793941549044, -7.284274662241187],
            [4.00801038569331, -7.283429851085672],
            [4.01410837512021, -7.284516574700519],
            [4.027590136630852, -7.290947677887785],
            [4.03408442429046, -7.287836813482988],
            [4.039617443686595, -7.2877305434310085],
            [4.044170320641331, -7.286173073346949],
            [4.052606987445645, -7.279061367753933],
            [4.054330426761764, -7.27519307797769],
            [4.051306223289389, -7.268058600703321],
            [4.046340784748638, -7.26577159234821],
            [4.0408004807260784, -7.265490988680636],
            [4.032454119160544, -7.26693577215425],
            [4.019671684325696, -7.266345003725619],
            [4.004615716560582, -7.261028170492107],
            [3.994855846024416, -7.253595094218409],
            [3.986812210557544, -7.243602483401896],
            [3.985424385666389, -7.239714347218658],
            [3.983308365934869, -7.224542771292122],
            [3.9809170423264977, -7.213139437575692],
            [3.976576748385257, -7.197893826493049],
            [3.9786428630272956, -7.189015338070288],
            [3.9831366561441315, -7.183614653786832],
            [3.983872365813533, -7.176738288753082],
            [3.9810304575504327, -7.172065554255325],
            [3.9822498301245575, -7.16789494270364],
            [3.990236018931305, -7.160993026268922],
            [3.996426570973398, -7.160463930678427],
            [4.0052326515349135, -7.1656953074994485],
            [4.009437880397796, -7.172288067350714],
            [4.01382163903377, -7.183177826472316],
            [4.017742403495891, -7.194800994839524],
            [4.021719298437866, -7.204124088229993],
            [4.023599378411137, -7.212357144919179],
            [4.02328316101706, -7.2186753398463],
            [4.026198027040594, -7.223023694641784],
            [4.032263866888695, -7.223138624814535],
            [4.045222942769049, -7.219609354550911],
            [4.052456874052481, -7.220619376077031],
            [4.060927912344948, -7.227136628976806],
            [4.067058586328847, -7.2289058926478145],
            [4.0749438839026055, -7.22908658313032],
            [4.084632887780565, -7.22766303317436],
            [4.092021486763004, -7.224504677725728],
            [4.096651448485419, -7.219868803725222],
            [4.09876193586004, -7.213061220194013],
            [4.098586214213509, -7.206550005017408],
            [4.095228689709966, -7.1989554730951175],
            [4.089240452389421, -7.193333390165764],
            [4.082739928457944, -7.19202975235145],
            [4.064149342213807, -7.19328777413414],
            [4.056471863295333, -7.192521696742122],
            [4.048788649829879, -7.192800005632432],
            [4.03174969639386, -7.1883262256519656],
            [4.028226087605194, -7.185375096219201],
            [4.025921717986201, -7.178767095779169],
            [4.026772037090854, -7.173192202357372],
            [4.0299958430704805, -7.169028635076465],
            [4.034916350622221, -7.166011770682536],
            [4.04287903084973, -7.159002790018013],
            [4.048307738059963, -7.145762603187372],
            [4.048888230115534, -7.137532043545637],
            [4.045332124892315, -7.130275505329068],
            [4.039682038405803, -7.123644378555022],
            [4.033233708158887, -7.118143824154821],
            [4.016032405778821, -7.107728264947115],
            [4.007687433140486, -7.099615584200603],
            [4.003895203353543, -7.090705036402764],
            [4.0024902032657, -7.081989224232687],
            [4.0026251964530255, -7.071611052622305],
            [4.00439109757249, -7.063554293308591],
            [4.011409179220671, -7.0437970441379525],
            [4.017464269582561, -7.035368819215596],
            [4.018394558448618, -7.031649882579881],
            [4.033285690338288, -7.0204887784296055],
            [4.039995201369485, -7.016440942285458],
            [4.0433815327910665, -7.013006143770168],
            [4.050093003727269, -7.01418621001262],
            [4.0532019257182785, -7.0170337628791],
            [4.057342340742647, -7.028791481995096],
            [4.06123911821567, -7.03811118043052],
            [4.065963454995867, -7.043040193656524],
            [4.070383585945842, -7.045410619930818],
            [4.077664961519357, -7.0459425453224265],
            [4.081019884231324, -7.043673154073157],
            [4.086808675805755, -7.036374684668524],
            [4.09799774887373, -7.02593854480173],
            [4.102827436284109, -7.0161101950534785],
            [4.101912561410709, -7.0064013927935695],
            [4.095695521272953, -6.992370992937867],
            [4.09427732808744, -6.983438171462919],
            [4.095203078857288, -6.9792845812724025],
            [4.10371591691603, -6.956083686492202],
            [4.104775405857683, -6.935735037423686],
            [4.108345552694432, -6.923633802517294],
            [4.113591878237007, -6.917762336993631],
            [4.119907722351943, -6.914773561948042],
            [4.124110461613591, -6.917167810117018],
            [4.131430003174049, -6.925109846762534],
            [4.135688321984978, -6.928305363297081],
            [4.142959865709279, -6.930064337306793],
            [4.150595677745047, -6.9295883749441165],
            [4.158239527870239, -6.92752836764067],
            [4.164521837067614, -6.923133398533932],
            [4.172444498741263, -6.915308019863581],
            [4.175832541579847, -6.910316753097544],
            [4.1787811873448515, -6.901922619069736],
            [4.182604373761923, -6.895525283875961],
            [4.185231363378911, -6.893707587045377],
            [4.19119621548338, -6.89328841600284],
            [4.195697491794339, -6.894407680496251],
            [4.200817362882985, -6.898978936011641],
            [4.207721143933113, -6.913054874052664],
            [4.211545384579741, -6.918084349722771],
            [4.226735377240434, -6.929880551412381],
            [4.232637331695506, -6.9305483556844],
            [4.237006599865293, -6.927290691454545],
            [4.240033065966402, -6.923217994464833],
            [4.242864282724101, -6.915028802526639],
            [4.240335655946637, -6.90754258690197],
            [4.234181839134971, -6.901457811767451]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.64001477409009,
          "lat": 31.445973667625157
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22029"],
        "coty_name": ["Concordia"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Concordia Parish"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00558515"
      },
      "bbox": [
        3.976576748385257, -7.683142711172942, 4.375436915707446,
        -6.893134590750812
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.031743904833552, -7.35206028995433],
            [3.06091892641038, -7.3512483289178],
            [3.0601527849122268, -7.330384551884587],
            [3.088991477332834, -7.328992268672636],
            [3.088164516839292, -7.30756382981431],
            [3.1094445835564706, -7.306975963373514],
            [3.108950572468006, -7.292683802827219],
            [3.1233662589315148, -7.291755973694295],
            [3.1227545517270294, -7.27768498576703],
            [3.143738783084678, -7.2768205593063175],
            [3.143347458576721, -7.2621496989350645],
            [3.1572991348051147, -7.261673243965572],
            [3.157146888180639, -7.254238392284191],
            [3.171731402659901, -7.253805220594229],
            [3.1710538380455517, -7.23997754904023],
            [3.1859850882074414, -7.238988115245262],
            [3.1856199920133244, -7.232300076918629],
            [3.192747650336569, -7.232099167977726],
            [3.1925056920227393, -7.2250500791451415],
            [3.1996015814036167, -7.224534711753176],
            [3.1994627450870783, -7.217462014965539],
            [3.2142260598596217, -7.217050832136025],
            [3.2139941249641977, -7.20725739214162],
            [3.2491194474341976, -7.174923987062818],
            [3.25577424045425, -7.187950916505428],
            [3.2643064336512353, -7.197421820521141],
            [3.270117965609265, -7.19667927984227],
            [3.275921098808392, -7.1904758579600765],
            [3.279962158984574, -7.192273531316192],
            [3.281041495536022, -7.196259685484609],
            [3.2794553412517353, -7.198496301507352],
            [3.271059376940276, -7.198490586847],
            [3.267130995195879, -7.1998151068209175],
            [3.2667646894270543, -7.209304603425361],
            [3.2687544042498793, -7.212723094139673],
            [3.2731750202578054, -7.21516164177227],
            [3.2725854925995783, -7.220163861968872],
            [3.2623006083782173, -7.220220388406235],
            [3.260895461601147, -7.22136492965646],
            [3.260174163898227, -7.230528940700009],
            [3.262190913552539, -7.241041380185621],
            [3.2680232766710633, -7.246435738644915],
            [3.2732182749727996, -7.24656046374746],
            [3.28089830209276, -7.243185968305121],
            [3.284569644605722, -7.246843360401391],
            [3.2829020131778144, -7.250344889493177],
            [3.2755499158305312, -7.257894093187708],
            [3.273007876623107, -7.263109355237472],
            [3.2748447839890686, -7.267754836478711],
            [3.278946871089114, -7.270431797117744],
            [3.2866296304807836, -7.272890785853571],
            [3.287764219426251, -7.275973997630247],
            [3.2735308357863837, -7.283936921939519],
            [3.272754042643411, -7.288812705156353],
            [3.2753093793421546, -7.291489196887748],
            [3.282045415788653, -7.29424316743819],
            [3.287106960831385, -7.294523127551579],
            [3.293385066886045, -7.290675762725856],
            [3.2973292462227493, -7.290617310911893],
            [3.297691478814593, -7.2960712864122215],
            [3.301264011175891, -7.300287589779344],
            [3.3048141600863445, -7.301942123191545],
            [3.3124461908217553, -7.300949251555149],
            [3.3201893915152425, -7.297039669671781],
            [3.3239235384189496, -7.296092652778363],
            [3.327423419014378, -7.298759217735235],
            [3.3827881384143974, -7.282478287071491],
            [3.4294174654857703, -7.269641388749694],
            [3.5374734839923456, -7.23917577684757],
            [3.605585954167112, -7.2203076726195325],
            [3.6240441931209, -7.217130764594732],
            [3.694275630063627, -7.1979257067278235],
            [3.698610219294259, -7.205655048551248],
            [3.702855826485629, -7.20734108041061],
            [3.705173223068284, -7.204326160514978],
            [3.705185896389314, -7.20081790542823],
            [3.70795259750602, -7.1996659054401375],
            [3.7117861844102173, -7.204232761510718],
            [3.715528054497056, -7.205777782433846],
            [3.7204975391970834, -7.202527709703211],
            [3.724784613681455, -7.20735088465621],
            [3.7240217825491486, -7.210292084713533],
            [3.719506840494496, -7.213980584828611],
            [3.719486841325374, -7.219134601501712],
            [3.7253996739263604, -7.221738433050609],
            [3.729147548934262, -7.22171465405254],
            [3.730892401579981, -7.227209319567455],
            [3.725939239954603, -7.233854751235622],
            [3.7247208221774923, -7.237041146590226],
            [3.7286888668879996, -7.2486385330814125],
            [3.728778878961429, -7.251138443020393],
            [3.7332443961774526, -7.254988470639104],
            [3.7371939972092596, -7.268731010416267],
            [3.749249457901773, -7.275736346290768],
            [3.7521789631640803, -7.280819906209911],
            [3.757468681866295, -7.28510629404147],
            [3.7641255669986897, -7.284712165128698],
            [3.7669369250245066, -7.2867137220808935],
            [3.762525342184308, -7.29322818402493],
            [3.772300130476603, -7.29955272164277],
            [3.777633409403747, -7.29485281360551],
            [3.783279168495753, -7.299230491799044],
            [3.7857816803111475, -7.305319324707184],
            [3.7947275113701364, -7.3064286563522804],
            [3.7966533017039787, -7.315167103163837],
            [3.800073063030561, -7.314841776947536],
            [3.801196875706901, -7.319478754090533],
            [3.799617322345586, -7.32392049254073],
            [3.8043355340015474, -7.3255006718896265],
            [3.8039569968587377, -7.3288419984987305],
            [3.7962774077005528, -7.332381600403818],
            [3.7924838721268714, -7.332235784663142],
            [3.793033725423498, -7.335959459776191],
            [3.7896244067649714, -7.335183086198502],
            [3.7867998970288097, -7.338649881209241],
            [3.7857389445765453, -7.347310919912225],
            [3.7821501565610522, -7.3501101452886575],
            [3.779769474936397, -7.349293489293725],
            [3.774131620955025, -7.352422739557342],
            [3.771278809687457, -7.3560193677931185],
            [3.7698630835078477, -7.360630463867575],
            [3.7640898832305316, -7.360789708511661],
            [3.7607783772479415, -7.366489382093873],
            [3.7561288402477486, -7.366882512602287],
            [3.7503055977459896, -7.3657059294984055],
            [3.74917876268658, -7.368085361252436],
            [3.7430830607967245, -7.371370050882078],
            [3.739020340207285, -7.370554168038693],
            [3.730134606210826, -7.373404995242097],
            [3.729719835589557, -7.3702927554079025],
            [3.7241720681447448, -7.367669838814244],
            [3.7174649073509967, -7.363088540590988],
            [3.7156757846715744, -7.351117022783207],
            [3.714034402972857, -7.347232490665695],
            [3.7069360340287654, -7.346462278546026],
            [3.707029354926705, -7.343653172584218],
            [3.7019926688026246, -7.341092890161106],
            [3.6995571814753294, -7.345512309316643],
            [3.694628544966533, -7.343473317473751],
            [3.6916593075456823, -7.347235177412393],
            [3.6876191787808166, -7.3481402700868514],
            [3.684568177387709, -7.344749239648995],
            [3.679824581528763, -7.343234034801289],
            [3.67302417326384, -7.3512028339445115],
            [3.6723555714123597, -7.3547795670459974],
            [3.6690025327840736, -7.354709275197641],
            [3.6723932324092408, -7.431618265174301],
            [3.6752685604454842, -7.523803534847294],
            [3.6812132318200197, -7.527810417134524],
            [3.6831822535742886, -7.533316416276757],
            [3.6787163751955005, -7.538306179373827],
            [3.6756836358873177, -7.543726021707835],
            [3.6772441303217875, -7.557229697019854],
            [3.6783973006309543, -7.5618684326502],
            [3.696219643848578, -7.682326627901573],
            [3.7006515201875367, -7.687758414185197],
            [3.7002876777793965, -7.697509811899903],
            [3.7069077975830873, -7.699577733755948],
            [3.7040690511253005, -7.708516437687225],
            [3.7012861790460287, -7.710716358468803],
            [3.6978609293357527, -7.708306148443367],
            [3.6425897229869895, -7.710589608991484],
            [3.6137832355135058, -7.711600717926883],
            [3.6118720024446835, -7.713374067944446],
            [3.5999096460254965, -7.713973054059457],
            [3.604231669020183, -7.706840792121853],
            [3.599773899553343, -7.704301001345566],
            [3.5954277818550677, -7.7049516693780635],
            [3.5910596392035217, -7.707810155381198],
            [3.587577123475214, -7.703982159019388],
            [3.591205106519856, -7.7002627956788405],
            [3.5898234694501063, -7.696274967203121],
            [3.586995476303343, -7.695016078384571],
            [3.5783480196382746, -7.694115844816267],
            [3.57392915875307, -7.691700408843113],
            [3.5747112882538192, -7.688237818255597],
            [3.5724630304674507, -7.686341615186629],
            [3.56844617886287, -7.688653602437218],
            [3.561748517962683, -7.686299949284077],
            [3.5593898739054013, -7.683503312164244],
            [3.5590778371098897, -7.67897292902847],
            [3.5494049606151403, -7.677855721459821],
            [3.546084630576576, -7.681431666168046],
            [3.53603775208223, -7.6847845199139035],
            [3.5320738185282594, -7.686958433949766],
            [3.5328778463374784, -7.690144307951522],
            [3.528593038042495, -7.700922281114571],
            [3.5243985195971947, -7.705245797991011],
            [3.5171599853735906, -7.70747736701894],
            [3.501599061693464, -7.716410709040705],
            [3.497943130857564, -7.7167431004798415],
            [3.4927331227982927, -7.723314175903646],
            [3.489302734705532, -7.725830853868009],
            [3.4817190202728767, -7.724130303420245],
            [3.4788120868451773, -7.7298257235276395],
            [3.472554152993157, -7.729740435929959],
            [3.47115719266877, -7.740579264482385],
            [3.472466018104694, -7.749037015513636],
            [3.4748202837167805, -7.75665156855083],
            [3.4739861478543768, -7.763322902298739],
            [3.4682452911456845, -7.772849784577047],
            [3.461611663118416, -7.7772469248245155],
            [3.4547921512083133, -7.783942088161161],
            [3.4502536406190942, -7.7865096897386366],
            [3.4353653347781465, -7.789515235101834],
            [3.4337527217710986, -7.784284043810581],
            [3.423099389826127, -7.785592799655528],
            [3.413368780087716, -7.781105071044907],
            [3.411623339342951, -7.7836366600893925],
            [3.4077780360020005, -7.784378303603087],
            [3.400308583809173, -7.788080288922391],
            [3.374199169831372, -7.789245488586522],
            [3.374160948266913, -7.786316764008787],
            [3.319721833981328, -7.788477855058165],
            [3.2975961620877605, -7.788949939696182],
            [3.268847296479483, -7.790221443253965],
            [3.269036527601846, -7.797521307600647],
            [3.1810091032614336, -7.799779261230434],
            [3.180354129923423, -7.7878013967484785],
            [3.1768352125625254, -7.6816120597902735],
            [3.173688887442712, -7.681781876101559],
            [3.1701213762537312, -7.59530101835809],
            [3.166399767724797, -7.49916570481823],
            [3.1641283373722504, -7.442194053504887],
            [3.150024106741927, -7.441778407030737],
            [3.1490155079434445, -7.420763191763031],
            [3.1350910568216426, -7.421096852384906],
            [3.134709256108469, -7.406893274845663],
            [3.1202701886733823, -7.407381743783906],
            [3.1192416253766058, -7.3785615571445025],
            [3.104806900548049, -7.378998547550408],
            [3.104768279484523, -7.371775690204228],
            [3.0758816393745905, -7.372982225295415],
            [3.075516130327635, -7.365264797589008],
            [3.0468374310384685, -7.366000342951066],
            [3.0464797976483635, -7.358784341410397],
            [3.0320382691621135, -7.359468730388896],
            [3.031743904833552, -7.35206028995433]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.53321992973984,
          "lat": 31.198573925293523
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22079"],
        "coty_name": ["Rapides"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Rapides Parish"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00559460"
      },
      "bbox": [
        3.031743904833552, -7.799779261230434, 3.8043355340015474,
        -7.174923987062818
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.103823460509701, -7.6063141374955725],
            [5.120528299316876, -7.60537462165211],
            [5.210222247870812, -7.600220683426983],
            [5.263055363111245, -7.596988463916796],
            [5.272552210987832, -7.595969534666343],
            [5.2913744904907265, -7.59483694474046],
            [5.291941867283725, -7.601696778071508],
            [5.294983914528858, -7.652744867532464],
            [5.2974476657882805, -7.688814338611899],
            [5.308299270620935, -7.688207062396429],
            [5.311999992487804, -7.691362300273327],
            [5.312673691918283, -7.702326856567538],
            [5.3237654836378, -7.701661626359948],
            [5.324341863454079, -7.710989797465598],
            [5.325905944962785, -7.715208700130629],
            [5.324259259005951, -7.7192735662947625],
            [5.326426733133863, -7.72141474506423],
            [5.329110151977609, -7.729251278434757],
            [5.33321214841418, -7.737322759164254],
            [5.339718107792133, -7.740904816538793],
            [5.342916212847936, -7.746080850497367],
            [5.342730110449074, -7.749873471157914],
            [5.345445360119991, -7.7553258150179145],
            [5.344676312194449, -7.761161623074058],
            [5.350851573795172, -7.7687535062115165],
            [5.350750558243635, -7.771527495940222],
            [5.347629216053976, -7.778402798416656],
            [5.349069812045741, -7.784439869859512],
            [5.354102259387867, -7.789136109343595],
            [5.357065692744428, -7.790253186089732],
            [5.358188655437068, -7.793550051029815],
            [5.3621295081634965, -7.795719271307566],
            [5.36156956430291, -7.803404748768878],
            [5.363488429796596, -7.804893404413298],
            [5.3641157319117925, -7.810025803238113],
            [5.366497382149518, -7.814065123688033],
            [5.377672569280095, -7.823161813065399],
            [5.377428847372859, -7.827034380248975],
            [5.3750126230422905, -7.833399175352225],
            [5.374913955394624, -7.837344468004973],
            [5.379779068336236, -7.839208499676979],
            [5.380819202656769, -7.848667482069807],
            [5.386346319773209, -7.8511192611966845],
            [5.385100998189898, -7.855648415352007],
            [5.386951301042543, -7.864803423197727],
            [5.3856340865117796, -7.871915392840343],
            [5.386911087098538, -7.875760694855472],
            [5.385571752758507, -7.877196977388448],
            [5.38625280554998, -7.883846572754501],
            [5.391017345452257, -7.887333339549079],
            [5.392543681399339, -7.8922278115508355],
            [5.390941958307562, -7.898639835775961],
            [5.393680936701028, -7.902491434137872],
            [5.393618742636863, -7.907292863981734],
            [5.391597897665845, -7.912436473481878],
            [5.393964963655437, -7.916440458763524],
            [5.391836376062569, -7.920430519427453],
            [5.396396159534636, -7.929569523519101],
            [5.394743068782267, -7.933818329771357],
            [5.396657985919364, -7.937279104570703],
            [5.401226719930043, -7.940068230985447],
            [5.398998149991649, -7.951438774839633],
            [5.400067959668342, -7.953883800558106],
            [5.399287278947971, -7.9592136038423575],
            [5.39609792636157, -7.963864319914515],
            [5.3987921676045545, -7.970900749703565],
            [5.397632112024632, -7.973648423897456],
            [5.40059608053518, -7.980573862743766],
            [5.3991568618319405, -7.981910209820296],
            [5.4047419513917525, -7.990494729284859],
            [5.401362135522108, -7.9998696077072236],
            [5.404298062018416, -8.006277813720397],
            [5.404302896511287, -8.010081729914578],
            [5.40893722328442, -8.07636179222903],
            [5.4100021420310265, -8.08902470659825],
            [5.411479723720608, -8.118186913905333],
            [5.412306115587601, -8.126107568683778],
            [5.413612343574854, -8.148826308593346],
            [5.416371241539145, -8.18759956207075],
            [5.41855216097839, -8.222661744693328],
            [5.430857690146166, -8.235730507630288],
            [5.466009526942117, -8.270256106933596],
            [5.473030857470635, -8.292279974141811],
            [5.482780975565118, -8.314163370701463],
            [5.490936208249625, -8.329032563344303],
            [5.497742829833425, -8.344240307928443],
            [5.388833064937942, -8.29830656022093],
            [5.3768342275684615, -8.293816463668277],
            [5.373328840771019, -8.291806422692114],
            [5.363571695699617, -8.291747986266985],
            [5.3562573788610415, -8.288543970029595],
            [5.345147172261727, -8.292926673393893],
            [5.339077878434446, -8.292874834895663],
            [5.333458966256705, -8.291510111673814],
            [5.330707439787529, -8.29219152539862],
            [5.320294465506933, -8.299209619926678],
            [5.3113538720315265, -8.306672941481208],
            [5.3036000281536415, -8.30406818200225],
            [5.295979098214175, -8.305516878695643],
            [5.290395956074766, -8.30521159872363],
            [5.284446351218947, -8.307349949872446],
            [5.279610717144313, -8.310478359607531],
            [5.271280279731335, -8.312542865976816],
            [5.26135894139182, -8.313722881185386],
            [5.23910837362779, -8.317157603818215],
            [5.215249406111397, -8.318606729604564],
            [5.217620247549006, -8.30689126653093],
            [5.214165663481076, -8.287406983186298],
            [5.213045303446393, -8.274350459306872],
            [5.213910913949976, -8.262793660513879],
            [5.215742715887254, -8.258834279245555],
            [5.221823044838756, -8.252035208879114],
            [5.220842350943758, -8.247215559564783],
            [5.21753567849575, -8.239579101328426],
            [5.215075259553063, -8.237909197641397],
            [5.2085262119526705, -8.24111919293669],
            [5.206858646778274, -8.239166143056611],
            [5.20771988505838, -8.233050461715573],
            [5.203290739788879, -8.230886434727655],
            [5.1969762586517225, -8.235284875285735],
            [5.194020370336435, -8.228127646262003],
            [5.197650491055821, -8.222102402227907],
            [5.195417366460941, -8.219185206015245],
            [5.195970445568343, -8.213248681370349],
            [5.193210096371145, -8.20893620373374],
            [5.1897479413128975, -8.210007589510187],
            [5.183494269036981, -8.206326772204353],
            [5.186992210457775, -8.202917356551788],
            [5.184077427270695, -8.199874754535923],
            [5.183052188871732, -8.19209107819396],
            [5.179004901725377, -8.18668218192602],
            [5.1730585814478305, -8.180972118457724],
            [5.164458539611912, -8.1784585362012],
            [5.163316930370999, -8.174021465353453],
            [5.159981896074968, -8.173237835211257],
            [5.153813810687107, -8.168566980033988],
            [5.153788035727737, -8.16212196163869],
            [5.1499966255495755, -8.157871809882684],
            [5.153198042121578, -8.152355778537741],
            [5.150498521485833, -8.149495914343598],
            [5.147127478092332, -8.141737175822119],
            [5.146885935812585, -8.137852167383187],
            [5.149026906148822, -8.133019972908096],
            [5.145041269078388, -8.12806872185449],
            [5.146113805528784, -8.125154140586702],
            [5.141740536100148, -8.124106733527833],
            [5.141678677892565, -8.116329013171356],
            [5.137631698105704, -8.117383323560576],
            [5.133436040972951, -8.114630208234495],
            [5.130053762345791, -8.058035631587346],
            [5.123916591644339, -7.953188627294286],
            [5.12423928843327, -7.939360977676724],
            [5.119506023530815, -7.866338341208372],
            [5.118607906453716, -7.856202721990279],
            [5.113843463790684, -7.77988539965498],
            [5.110278768113174, -7.712609031534948],
            [5.108007660153526, -7.678191369816289],
            [5.103823460509701, -7.6063141374955725]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.40566541788803, "lat": 30.62660315538333 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22105"],
        "coty_name": ["Tangipahoa"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Tangipahoa Parish"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00559500"
      },
      "bbox": [
        5.103823460509701, -8.344240307928443, 5.497742829833425,
        -7.59483694474046
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5290345697001992, -5.6965162599512675],
            [2.554389223031568, -5.6960281863641775],
            [2.5739714322710356, -5.695342126697389],
            [2.648866420152524, -5.69369790128265],
            [2.6794980616234882, -5.692747448284907],
            [2.764216013250654, -5.690688200757464],
            [2.766742456684802, -5.762012019046512],
            [2.7721769178337663, -5.938212294902051],
            [2.7737984891442955, -5.992831233532184],
            [2.8164680412720555, -5.991331932665376],
            [2.8182633457536643, -6.034591222135745],
            [2.8216833411066577, -6.036664982396838],
            [2.82174675246335, -6.042441170675741],
            [2.8262459449967854, -6.044019541091363],
            [2.8243819765904106, -6.055967545327155],
            [2.8274884916508567, -6.060854981830345],
            [2.8265314811501905, -6.064564569478556],
            [2.8271466440624673, -6.0720619697651275],
            [2.829914805493389, -6.074154424683874],
            [2.8286946607840737, -6.078900247633197],
            [2.825902133084332, -6.082195576347658],
            [2.8270213314469967, -6.100397227613642],
            [2.8288628570820165, -6.106499852547276],
            [2.8251194194513976, -6.108013064469673],
            [2.8244856891707153, -6.121097685776532],
            [2.8270352023512766, -6.122524101193311],
            [2.831398204953552, -6.139824148527747],
            [2.831940928042373, -6.145859282596837],
            [2.8353344553232365, -6.150799581909695],
            [2.8369573776753687, -6.157332641046733],
            [2.833943284664466, -6.164631062798502],
            [2.835092266283569, -6.171690016485897],
            [2.8378784872638176, -6.178434224070066],
            [2.836502410091162, -6.1816647465209655],
            [2.8387768339131982, -6.190993387405903],
            [2.8405595125499747, -6.1922237837026],
            [2.841717630590721, -6.2036944678242865],
            [2.8468887175922886, -6.2131522509322945],
            [2.8483974929505314, -6.220456228610985],
            [2.854326137383046, -6.2295644810689215],
            [2.8575552836193543, -6.23649157622146],
            [2.8529446310519657, -6.240560262255061],
            [2.8549318638747736, -6.242378089849125],
            [2.8536077584255573, -6.246738660356427],
            [2.857006935369355, -6.251799328133928],
            [2.781865613703135, -6.254328407143015],
            [2.7834255344952985, -6.298466458804191],
            [2.7505626596752455, -6.2995495763661635],
            [2.7429316151193945, -6.299471715254228],
            [2.6694464146709644, -6.301650945842371],
            [2.6120048776793774, -6.3029311006436295],
            [2.611331591909815, -6.285859963435091],
            [2.6100637388991372, -6.229823472822245],
            [2.609545138447397, -6.215666065518225],
            [2.605152432666426, -6.215619530375508],
            [2.604383330727064, -6.178480124461369],
            [2.603421486965761, -6.14230949166085],
            [2.6020741928847033, -6.069567463569836],
            [2.599397935165367, -5.952222650176157],
            [2.5786143905217718, -5.952942957863624],
            [2.582227063921388, -5.94166279326547],
            [2.5746408655313595, -5.931083347703194],
            [2.574170069992331, -5.926636392697254],
            [2.5785989536227025, -5.919770376263774],
            [2.582922756064636, -5.917302281061489],
            [2.58333566991701, -5.912849720201069],
            [2.585795924938994, -5.907705000816841],
            [2.579803964658824, -5.903821815473671],
            [2.5847730677530634, -5.902016088705692],
            [2.5845002095321266, -5.896991880316011],
            [2.587483989316848, -5.895645125770438],
            [2.588590840453839, -5.887871047190507],
            [2.586589360297441, -5.886118297080724],
            [2.5881010019272104, -5.880660890567414],
            [2.581614633412022, -5.873227569186382],
            [2.5781621680980393, -5.865689164511996],
            [2.5805000412131123, -5.863814979909658],
            [2.5874050009396665, -5.862000441315587],
            [2.591499647833204, -5.8578543921483135],
            [2.5874781893459127, -5.854043791317641],
            [2.586738266009508, -5.851034748898758],
            [2.5915178884182786, -5.843479019338329],
            [2.5805157527230884, -5.845502071507743],
            [2.5789807755698426, -5.834816144294645],
            [2.571929112399235, -5.829369637079356],
            [2.569449228101139, -5.828581071025914],
            [2.5673275923902503, -5.818996339599471],
            [2.564428895615101, -5.812404811588089],
            [2.567269485450284, -5.8082102550092065],
            [2.5747533221924894, -5.809705669609021],
            [2.572526630587659, -5.8052223759192945],
            [2.574566885965203, -5.796379067283671],
            [2.5688423654536856, -5.7963402586825925],
            [2.5649408854031446, -5.787105956277312],
            [2.560807682015031, -5.78776165445963],
            [2.554710333909008, -5.793085286656657],
            [2.5502153383202724, -5.790836778989322],
            [2.5520505077041555, -5.788067810714482],
            [2.546463941883334, -5.780304659674575],
            [2.5412730119611653, -5.779156352173309],
            [2.5383393530288245, -5.767741884233216],
            [2.5325029112134803, -5.76157323359927],
            [2.5316322589146236, -5.750072250676871],
            [2.527409665075276, -5.747915303360986],
            [2.522270677862684, -5.747767906819775],
            [2.5257477903028662, -5.742095220234596],
            [2.5258543815046988, -5.738105180492572],
            [2.52201406751586, -5.736761285849086],
            [2.5220195472296174, -5.732213908815127],
            [2.526594143419603, -5.728742102514825],
            [2.5258935547166876, -5.723605915705133],
            [2.528833189362986, -5.72120991090507],
            [2.530374755966051, -5.714565026694559],
            [2.533353618692456, -5.712506320813021],
            [2.532403606373749, -5.706075223888254],
            [2.533658827078943, -5.701531955313936],
            [2.5298632930794644, -5.69957812249718],
            [2.5290345697001992, -5.6965162599512675]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.33501524123305, "lat": 32.71348081178502 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22119"],
        "coty_name": ["Webster"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Webster Parish"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00559567"
      },
      "bbox": [
        2.52201406751586, -6.3029311006436295, 2.8575552836193543,
        -5.690688200757464
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.980664121837826, 7.599509700260234],
              [18.983363021778185, 7.601049067382339],
              [18.98946517577354, 7.595823707716515],
              [18.984109383702965, 7.594014792383781],
              [18.980664121837826, 7.599509700260234]
            ]
          ],
          [
            [
              [18.915098942262038, 7.6921900563088075],
              [18.916334031520652, 7.697848359853371],
              [18.91973649096011, 7.697732586364154],
              [18.91921807153774, 7.687666477454831],
              [18.914006634641304, 7.687280363779606],
              [18.915098942262038, 7.6921900563088075]
            ]
          ],
          [
            [
              [18.90418876902797, 7.668070043647969],
              [18.904981837793226, 7.674670794537087],
              [18.91329239899678, 7.683538149712641],
              [18.91415114993917, 7.679877809695626],
              [18.9172191425079, 7.677187294341853],
              [18.914286198251368, 7.66874987442903],
              [18.911644341486195, 7.66429385718461],
              [18.90418876902797, 7.668070043647969]
            ]
          ],
          [
            [
              [18.918204168852505, 7.566399705908435],
              [18.921179702332388, 7.579124436756513],
              [18.927079608471256, 7.578988728425014],
              [18.922697752438424, 7.5674710679755774],
              [18.918204168852505, 7.566399705908435]
            ]
          ],
          [
            [
              [18.88930938874515, 7.639120594950032],
              [18.890221500591245, 7.64287821441076],
              [18.89525918739538, 7.649459594673391],
              [18.895260472985715, 7.657613787560715],
              [18.900016839059642, 7.658793279816263],
              [18.90036638275505, 7.653360364526067],
              [18.89796561141183, 7.643651718218589],
              [18.89522534789616, 7.638280442215279],
              [18.89819348007284, 7.633429582020266],
              [18.893835792811267, 7.629038608424204],
              [18.88930938874515, 7.639120594950032]
            ]
          ],
          [
            [
              [18.90815715497961, 7.571779129354226],
              [18.910950857154717, 7.578237336885459],
              [18.913180943684598, 7.577258373986244],
              [18.910502039769938, 7.569767082293959],
              [18.90815715497961, 7.571779129354226]
            ]
          ],
          [
            [
              [18.893341492008116, 7.591989425299562],
              [18.89746833346574, 7.60395871335208],
              [18.900810149850372, 7.605405203967466],
              [18.894412572852797, 7.587960799693618],
              [18.893341492008116, 7.591989425299562]
            ]
          ],
          [
            [
              [18.889185073622375, 7.607515432854644],
              [18.888378083439104, 7.612258797674356],
              [18.88942397000568, 7.616097128838516],
              [18.89370957211883, 7.611609063023262],
              [18.889185073622375, 7.607515432854644]
            ]
          ],
          [
            [
              [18.86755548163106, 7.636986456706227],
              [18.871222170288128, 7.644739564539901],
              [18.87520462363126, 7.64194406471706],
              [18.8736434746549, 7.63867445954675],
              [18.86755548163106, 7.636986456706227]
            ]
          ],
          [
            [
              [18.88833217150883, 7.555802309618351],
              [18.893210651218606, 7.563703719085258],
              [18.8951636387562, 7.558886480820364],
              [18.891466538144275, 7.550849282479602],
              [18.88833217150883, 7.555802309618351]
            ]
          ],
          [
            [
              [18.882080380344327, 7.556555432959563],
              [18.884712377337006, 7.562967173050115],
              [18.887402815858252, 7.559096520249119],
              [18.882080380344327, 7.556555432959563]
            ]
          ],
          [
            [
              [18.875171336466988, 7.564051390542282],
              [18.87717407309801, 7.572062968458327],
              [18.880772018943286, 7.572527846371279],
              [18.87917990761653, 7.567470320218877],
              [18.875171336466988, 7.564051390542282]
            ]
          ],
          [
            [
              [18.884775351164766, 7.516408408220451],
              [18.88724133272785, 7.529878020635786],
              [18.890256194656494, 7.534014563934974],
              [18.89201479691898, 7.5246031322687585],
              [18.889236567992775, 7.514344434976199],
              [18.884775351164766, 7.516408408220451]
            ]
          ],
          [
            [
              [18.847064434909772, 7.614643996197941],
              [18.85207287250089, 7.621168519324591],
              [18.854742381118022, 7.620138729392771],
              [18.857851282621056, 7.625655175678857],
              [18.863136268822874, 7.623819916715839],
              [18.856836463694233, 7.613417911932579],
              [18.849644338180084, 7.615079237577007],
              [18.847064434909772, 7.614643996197941]
            ]
          ],
          [
            [
              [18.87007476810702, 7.523612726321744],
              [18.876332464968538, 7.540399928511505],
              [18.876910290365206, 7.545753380481743],
              [18.879449661173926, 7.5498847041217045],
              [18.8818869476863, 7.550756490668611],
              [18.880696556178723, 7.5415996437285315],
              [18.885101804666128, 7.539907239244647],
              [18.885577406562025, 7.533514880137395],
              [18.880529359958913, 7.535802581608219],
              [18.877391651024432, 7.534119801413693],
              [18.872563913694687, 7.520790199582946],
              [18.87007476810702, 7.523612726321744]
            ]
          ],
          [
            [
              [18.86222060079762, 7.540044167909953],
              [18.86539592780697, 7.546428425454695],
              [18.86863566794709, 7.54501728348764],
              [18.863545829046668, 7.535970342442596],
              [18.86222060079762, 7.540044167909953]
            ]
          ],
          [
            [
              [18.845115309063203, 7.559270810200457],
              [18.848699286601594, 7.56984912618805],
              [18.848821567948512, 7.578791599258195],
              [18.851184281688344, 7.582349533488278],
              [18.855296768989895, 7.584406671376333],
              [18.860557269574155, 7.584581691314433],
              [18.861467222557703, 7.593309378653677],
              [18.866208612919763, 7.595787531433849],
              [18.865861318092534, 7.591157345274534],
              [18.86766493855458, 7.586998937547674],
              [18.865921254968168, 7.584228694526301],
              [18.865491972004826, 7.578286821946119],
              [18.86301357727356, 7.567451925734736],
              [18.8670431346711, 7.563126986954521],
              [18.86116059387084, 7.558945162353006],
              [18.863691852911906, 7.553745085557201],
              [18.861279935682635, 7.5521130057324894],
              [18.86126081466918, 7.54824920534587],
              [18.856691099531318, 7.5497648550047725],
              [18.857439834118384, 7.553659943043156],
              [18.854828409992116, 7.554922748740648],
              [18.851107297767584, 7.551680246171488],
              [18.847554700583775, 7.553080842936585],
              [18.845115309063203, 7.559270810200457]
            ]
          ],
          [
            [
              [18.83870904577881, 7.542086303187157],
              [18.841109924645558, 7.544726201156826],
              [18.844519910450956, 7.5446024825082665],
              [18.844215781900687, 7.539731923795841],
              [18.83870904577881, 7.542086303187157]
            ]
          ],
          [
            [
              [18.82378976443444, 7.576279037440898],
              [18.830897473998505, 7.59012941419141],
              [18.82842762240657, 7.595122644681269],
              [18.826961421757645, 7.604116198035686],
              [18.836727284061737, 7.60591399254385],
              [18.839112281432282, 7.611378796364088],
              [18.845245513929374, 7.605982186103313],
              [18.84250936697601, 7.603097276417254],
              [18.838511558847486, 7.602167835441417],
              [18.838224864426227, 7.594994528975084],
              [18.847449810454755, 7.5987881841394875],
              [18.847183977521183, 7.590909261728244],
              [18.84032024264827, 7.584398042116775],
              [18.83780876235594, 7.585122228168805],
              [18.8368472061211, 7.579710968962965],
              [18.832966248442883, 7.578993298783418],
              [18.830500376255582, 7.574851761635161],
              [18.828262345791043, 7.5780473468268035],
              [18.82378976443444, 7.576279037440898]
            ]
          ],
          [
            [
              [18.83236562498707, 7.51045464186417],
              [18.83288619490969, 7.514538572729513],
              [18.836746942987812, 7.520626535875702],
              [18.841047998064525, 7.524194606166532],
              [18.84657922646606, 7.53288572019139],
              [18.84881553616458, 7.53970994383648],
              [18.85503195546496, 7.535923486146842],
              [18.852076753326365, 7.531908924809263],
              [18.852219650020345, 7.528371008296119],
              [18.850062406488586, 7.522145094138997],
              [18.845380930845266, 7.5165568630793365],
              [18.848070822085567, 7.512681055426172],
              [18.843093941808043, 7.508072973997673],
              [18.836823337829927, 7.506552075670354],
              [18.83343873317383, 7.5072160780334976],
              [18.83236562498707, 7.51045464186417]
            ]
          ],
          [
            [
              [18.807623961830256, 7.561168589560059],
              [18.809097407396305, 7.564768356564376],
              [18.813724335576957, 7.564094954845954],
              [18.810459655840607, 7.559289513625041],
              [18.807623961830256, 7.561168589560059]
            ]
          ],
          [
            [
              [18.807885636003505, 7.536214438828425],
              [18.810273468189894, 7.544151784504336],
              [18.81372814796179, 7.543863278695045],
              [18.81098523274768, 7.53529443419493],
              [18.807885636003505, 7.536214438828425]
            ]
          ],
          [
            [
              [18.821786870076348, 7.4746752514432595],
              [18.822246901012978, 7.477469093258224],
              [18.81915336646288, 7.485325010281238],
              [18.821086060832567, 7.48603614449782],
              [18.825589050357582, 7.498474405613582],
              [18.829355788373814, 7.498981116722408],
              [18.831276040030836, 7.491515026456607],
              [18.83533012057618, 7.490303716381744],
              [18.83667977628609, 7.486873508341115],
              [18.83389482749543, 7.477129600512516],
              [18.8294668866821, 7.476440434258815],
              [18.82347108738389, 7.472474131708696],
              [18.821786870076348, 7.4746752514432595]
            ]
          ],
          [
            [
              [18.818658495909965, 7.462991409039944],
              [18.82149706187921, 7.46967594937549],
              [18.826324092711985, 7.4683689431512565],
              [18.83075902962505, 7.470574126642841],
              [18.827950047742917, 7.462728985488232],
              [18.823405467620884, 7.456192444607971],
              [18.82181125817364, 7.461638700415895],
              [18.818658495909965, 7.462991409039944]
            ]
          ],
          [
            [
              [18.809086588659635, 7.485865781639305],
              [18.812999099167882, 7.4926896741994415],
              [18.811104055236843, 7.502643074009291],
              [18.812248548977802, 7.506708525685133],
              [18.82340182298809, 7.519543734133459],
              [18.824070204354644, 7.516531517851121],
              [18.822656587550366, 7.510812144056172],
              [18.82271577588239, 7.503011492426951],
              [18.821605633439027, 7.496841412112861],
              [18.81744575917602, 7.492673147867042],
              [18.81615529074198, 7.488406926940907],
              [18.81245582938243, 7.4821789976472886],
              [18.809086588659635, 7.485865781639305]
            ]
          ],
          [
            [
              [18.82436289241738, 7.36719214034881],
              [18.83384343082487, 7.369706422748903],
              [18.833856485772934, 7.360467356255751],
              [18.829363625458313, 7.358238100061489],
              [18.821210972432443, 7.35840282499355],
              [18.82436289241738, 7.36719214034881]
            ]
          ],
          [
            [
              [18.526886385754057, 7.786272868757447],
              [18.528726518554798, 7.780805367723674],
              [18.554674475846397, 7.770492703044844],
              [18.556231842691915, 7.774400084135143],
              [18.592049694809216, 7.7607752953208875],
              [18.5940450356041, 7.763368948376152],
              [18.593162769014242, 7.774473707968702],
              [18.619340587572918, 7.764466148337318],
              [18.63908754638332, 7.822872264213759],
              [18.694242336421787, 7.79117927745858],
              [18.741617276461866, 7.76251717357286],
              [18.74038745453132, 7.757981486576656],
              [18.74551853068885, 7.757354451689243],
              [18.812170929598796, 7.735250088299982],
              [18.821614282089367, 7.763934355030431],
              [18.83103882400615, 7.7608704327164295],
              [18.8499116489551, 7.816918312533744],
              [18.853795935468895, 7.810701693780063],
              [18.85808103158629, 7.806210428299675],
              [18.860327450674607, 7.801652864091089],
              [18.867598498085492, 7.79126100806418],
              [18.877122221946294, 7.789727088129011],
              [18.883346517094974, 7.782767132059098],
              [18.888970250739337, 7.782916545263356],
              [18.892656205567715, 7.780755843647137],
              [18.901843179377508, 7.77152131122259],
              [18.906348662763016, 7.770233578809203],
              [18.907855174339662, 7.7732200925490496],
              [18.91477500707258, 7.780521681732187],
              [18.919514547947955, 7.781882906175535],
              [18.936360756756365, 7.775665618124463],
              [18.94029137696698, 7.777798797763946],
              [18.942937908066728, 7.785456322063192],
              [18.949406389103416, 7.789227953911765],
              [18.95391401021362, 7.795933024482267],
              [18.954673736559776, 7.800577626696523],
              [18.959426583545245, 7.808319768123361],
              [18.96042282912287, 7.814521362905385],
              [18.964110921677644, 7.818906249403396],
              [18.966071511873537, 7.826470404868716],
              [18.980649713327807, 7.821402834541767],
              [18.980476678986324, 7.8077531628760966],
              [18.982181395420284, 7.795628039505174],
              [18.981443362752803, 7.7833373180136896],
              [18.97889875725058, 7.773843265332499],
              [18.978175557203866, 7.764491131105948],
              [18.974421489025822, 7.758012804544756],
              [18.973689685658552, 7.751023717869627],
              [18.974784795056117, 7.740202823174661],
              [18.97638980508741, 7.737080117008174],
              [18.986707543686116, 7.729804761330955],
              [18.993761857209392, 7.72860456524635],
              [18.99678629496877, 7.714724978557868],
              [19.00653821234202, 7.6962676729322075],
              [19.004693836948817, 7.676613672569937],
              [19.00243112000355, 7.665418273125457],
              [19.005364921045462, 7.6549839302948826],
              [18.996869305645202, 7.646989388252101],
              [18.989373078384734, 7.651185026500355],
              [18.98209245054602, 7.648894927728538],
              [18.97788813359576, 7.652238948318842],
              [18.972768728262736, 7.6527619650891126],
              [18.96977384164749, 7.632814595285772],
              [18.964941312290048, 7.633816615324354],
              [18.962592970248576, 7.638194832172659],
              [18.958971376863396, 7.637197135672648],
              [18.952993236777516, 7.615992091835082],
              [18.94764425805216, 7.614887585092227],
              [18.9475738742006, 7.605105576083138],
              [18.94442384553289, 7.5877451591489775],
              [18.94670794943711, 7.58459863407332],
              [18.94409632552641, 7.574047856672197],
              [18.94614917732718, 7.570614424817921],
              [18.94120486712795, 7.567996514114733],
              [18.938541379018798, 7.5749202928772315],
              [18.942792443772372, 7.588834902901111],
              [18.939437411606416, 7.593685059172021],
              [18.940233967883927, 7.602176235301164],
              [18.93450335139643, 7.603599948803244],
              [18.928591548062528, 7.598760738464283],
              [18.927450225338184, 7.594005454843067],
              [18.922128305811768, 7.582052093733589],
              [18.920988886796295, 7.594872716462664],
              [18.921167328746336, 7.599892543630282],
              [18.918869881448327, 7.6017392148293865],
              [18.91537280087459, 7.595265131578087],
              [18.911679444781903, 7.593883673374439],
              [18.905272924912214, 7.597074667647935],
              [18.90891708831831, 7.605540366600486],
              [18.911034570351116, 7.614983803127275],
              [18.916696622033836, 7.620251227623657],
              [18.915464393160487, 7.631603237440517],
              [18.91637969221132, 7.6355527555253735],
              [18.921891287099857, 7.6415615066633125],
              [18.923095829914775, 7.6469528114667895],
              [18.921874301516446, 7.651562931055083],
              [18.92310466636003, 7.665175905568138],
              [18.9259562923215, 7.669514196570346],
              [18.93081898093347, 7.670512756989464],
              [18.932574671336788, 7.678091484888501],
              [18.929635462693078, 7.685957987512776],
              [18.935351193710893, 7.699224491755866],
              [18.93688264479523, 7.707749208841807],
              [18.939979740353174, 7.709765229760233],
              [18.939138789351738, 7.718815411990275],
              [18.942927028585206, 7.723262637606485],
              [18.94020275777537, 7.727168353694462],
              [18.936788815641236, 7.726467269750122],
              [18.936387726301803, 7.723090009024793],
              [18.933324727616586, 7.7197070905918945],
              [18.933546954393716, 7.716614005458645],
              [18.925622525146025, 7.711126559012144],
              [18.921286580200118, 7.710917987413917],
              [18.919024021055556, 7.707641920263907],
              [18.913108513239806, 7.702974692381802],
              [18.9114519080194, 7.697553812971224],
              [18.912385107453243, 7.695509947199585],
              [18.909459382358406, 7.68955943878298],
              [18.903147682259945, 7.681780296192039],
              [18.90198578647305, 7.677737214533783],
              [18.896939234096443, 7.6718470968041705],
              [18.896899055271945, 7.680044013633729],
              [18.90446907085759, 7.692777816925616],
              [18.90611666462729, 7.7009053172680595],
              [18.91011335576962, 7.706037374511276],
              [18.910303884429993, 7.716008147053055],
              [18.91118498830454, 7.721034293489635],
              [18.906726235215377, 7.720501910357672],
              [18.902821854192446, 7.716760707938857],
              [18.898413978909208, 7.709160105775176],
              [18.891982848882897, 7.707820339099452],
              [18.88548195770707, 7.69697882486079],
              [18.880890744822455, 7.687113580265232],
              [18.883113321224048, 7.684896337675675],
              [18.88122155380894, 7.680296946800843],
              [18.875943074038354, 7.673871219910924],
              [18.87409729729062, 7.667670853626824],
              [18.877812512610472, 7.665867292115742],
              [18.876556845059355, 7.6603977462748025],
              [18.87224385515164, 7.652528095426364],
              [18.870640050680787, 7.652948204275613],
              [18.86980416631365, 7.661226738162132],
              [18.870208848539303, 7.667570725598886],
              [18.86806240899983, 7.668573869118143],
              [18.863949526886692, 7.664258151735001],
              [18.860120913089904, 7.667436109230281],
              [18.85797054376488, 7.666214929079497],
              [18.859972652164217, 7.6587632915886745],
              [18.85157948664458, 7.652411938364721],
              [18.850066637158253, 7.644902710622658],
              [18.84505398137479, 7.641919162707509],
              [18.84246047921047, 7.634333093367732],
              [18.83806896703916, 7.633671358060226],
              [18.82823503573651, 7.624320335348314],
              [18.824136055352838, 7.625344105590441],
              [18.822161718973263, 7.622216221880106],
              [18.825647614124097, 7.6176802440428375],
              [18.81982545017473, 7.6066237695463785],
              [18.821668152685888, 7.602419373670834],
              [18.81677948592985, 7.596159318077873],
              [18.809897381611073, 7.583882160373814],
              [18.80659795382375, 7.5837708227145075],
              [18.807003898464668, 7.595587463996763],
              [18.80590241154673, 7.599644471028166],
              [18.798961593715585, 7.593899129939357],
              [18.798355989634047, 7.590445379267395],
              [18.79515156366654, 7.587882076962549],
              [18.79739318650812, 7.584953698996587],
              [18.797884489168414, 7.579413791003205],
              [18.79699269052906, 7.572488827086353],
              [18.80176007714056, 7.568775486167073],
              [18.8027394231507, 7.5621267951923805],
              [18.79179360975525, 7.536717280360982],
              [18.796666992778285, 7.530634285549057],
              [18.796681099410815, 7.522400942125641],
              [18.799930338329688, 7.519637590862017],
              [18.800169312863886, 7.515619320471705],
              [18.793454822979594, 7.518029862219491],
              [18.789783028055744, 7.517486907722035],
              [18.78616857197459, 7.5195031020814005],
              [18.785246490919192, 7.513104524263143],
              [18.789053045638997, 7.507759735668923],
              [18.792416707680285, 7.50779903564378],
              [18.79456840581958, 7.505194623206518],
              [18.7895102416876, 7.500571042381754],
              [18.781934781050296, 7.5064640492163655],
              [18.77798094927884, 7.49694563061575],
              [18.779406059192336, 7.493411072937339],
              [18.779635615399506, 7.486895410364304],
              [18.78436551065266, 7.485059340327808],
              [18.789574353976683, 7.484988374330799],
              [18.79230689085574, 7.480943646154676],
              [18.790381688326683, 7.477036703277003],
              [18.792213390395847, 7.473949767190295],
              [18.79734480186878, 7.4718464247384375],
              [18.800900345533403, 7.468018011473005],
              [18.80558880371654, 7.468430750286686],
              [18.806419496753875, 7.461369472585936],
              [18.80842327601487, 7.460856174023738],
              [18.8129023865727, 7.452490218638561],
              [18.815782787750376, 7.4491940349933925],
              [18.81872659900975, 7.449472489571338],
              [18.825057363129467, 7.44615543718338],
              [18.826103750131203, 7.435853783184756],
              [18.824729979332425, 7.431322956675666],
              [18.825954629450617, 7.424356608743988],
              [18.825220869180637, 7.418915607636035],
              [18.8289204262995, 7.412761800308279],
              [18.83536819703898, 7.412767424262188],
              [18.838145428688062, 7.411309761751887],
              [18.838697281774373, 7.40672130351594],
              [18.837041031750807, 7.402673269567983],
              [18.841428035650825, 7.400026000868519],
              [18.84811723573913, 7.392202988326671],
              [18.843740558733135, 7.3832198600576255],
              [18.836535224477927, 7.380453337587124],
              [18.833028985755984, 7.384940812910251],
              [18.83002561884509, 7.386060643659834],
              [18.82484212296315, 7.381617420071537],
              [18.818738570780088, 7.370351205731],
              [18.80889239844673, 7.36958397952632],
              [18.804592236206823, 7.3678302625988525],
              [18.799397221400117, 7.371106656356003],
              [18.79626659685758, 7.375295620542498],
              [18.780943778091643, 7.358646489270174],
              [18.776661517621974, 7.350982932561943],
              [18.774647125585755, 7.341066567587558],
              [18.781011136814364, 7.336377214993221],
              [18.777598712676884, 7.333301281904865],
              [18.771949705857292, 7.332057426164385],
              [18.76988980669496, 7.333499459361109],
              [18.7720113089258, 7.339830633733959],
              [18.768328984248235, 7.343120019027424],
              [18.76299268433083, 7.3435412575463905],
              [18.75402523663465, 7.340805535379568],
              [18.74731880328388, 7.333715059465874],
              [18.697944493561035, 7.350888469427951],
              [18.66424496556208, 7.363134494332827],
              [18.664966786918228, 7.365027365219346],
              [18.63187956590817, 7.375890279162278],
              [18.646200516937764, 7.416580232249761],
              [18.631625552421845, 7.426137825718712],
              [18.587584303577245, 7.453735425501303],
              [18.580923151869072, 7.4582806389588425],
              [18.56262046770472, 7.469630776434776],
              [18.55117142010729, 7.436975810393596],
              [18.53605727339868, 7.4432057430872485],
              [18.531426128213962, 7.432145999592808],
              [18.527115351330984, 7.430354511819473],
              [18.526151120975303, 7.436631489768915],
              [18.522458207766242, 7.440687365017772],
              [18.516828464699756, 7.440368030317137],
              [18.515009578955567, 7.442294629181877],
              [18.509464662680415, 7.443482351986947],
              [18.501731964963433, 7.439873801205695],
              [18.49777056534429, 7.434826900662014],
              [18.491832447215156, 7.435702072264694],
              [18.489764038741594, 7.438039527562525],
              [18.4877932021147, 7.444268209833457],
              [18.488291056201806, 7.451049703015858],
              [18.486668522346005, 7.465148941523032],
              [18.486938325620205, 7.470801981014363],
              [18.489397371171037, 7.476520654886182],
              [18.487853463288875, 7.4822601232352195],
              [18.48838284824056, 7.487105947733626],
              [18.48683209361984, 7.490131963233187],
              [18.481143626821563, 7.49154361980273],
              [18.475796736438305, 7.497935878504781],
              [18.479372453796774, 7.501303873243148],
              [18.472165841323505, 7.511617242816366],
              [18.472118406677446, 7.519125285111439],
              [18.464322866401925, 7.520834496000053],
              [18.458753327793172, 7.517079425173145],
              [18.456032047307087, 7.516685584082913],
              [18.453665680712817, 7.520075753685935],
              [18.447926680952285, 7.522129442573839],
              [18.444532124304814, 7.5202300750373094],
              [18.440561174682603, 7.522370352802721],
              [18.439733101083515, 7.527584956629913],
              [18.435892418292525, 7.526309290373244],
              [18.43573774278431, 7.520001571322243],
              [18.429976622193948, 7.520769122567054],
              [18.427557223564293, 7.519523184143875],
              [18.4235360622176, 7.513255517219193],
              [18.417973523070284, 7.510282107661101],
              [18.41592659940278, 7.50600184337951],
              [18.40794212817968, 7.502272515977003],
              [18.400809882153023, 7.501423492425519],
              [18.3923906645789, 7.502608262916327],
              [18.383916823860375, 7.50890515732405],
              [18.37957377409619, 7.510604715587896],
              [18.37493737122335, 7.520321786486811],
              [18.37338628308285, 7.5296132560009745],
              [18.36720626536108, 7.537276864580173],
              [18.36119361267864, 7.538583778231105],
              [18.359668915524242, 7.544328435632627],
              [18.360129845694733, 7.5492781965847],
              [18.35652283405391, 7.554570204618561],
              [18.350985417812417, 7.557124256963325],
              [18.35254228153083, 7.560031771359669],
              [18.351455436125665, 7.564697474488567],
              [18.360238408780862, 7.577967943939892],
              [18.362425921078295, 7.572732693052484],
              [18.36989595514547, 7.584035206705546],
              [18.37209060750107, 7.578747455622302],
              [18.383152514751117, 7.596489196440289],
              [18.379047253956724, 7.595319937974341],
              [18.37509888002936, 7.597013715616718],
              [18.36787810569085, 7.614040756884758],
              [18.36977094109879, 7.621915560080094],
              [18.381713178487775, 7.63990734911694],
              [18.36480980204884, 7.653463536762009],
              [18.382818773423903, 7.674731187595716],
              [18.34225878837628, 7.7092766983459855],
              [18.31859997652297, 7.729133990457331],
              [18.312534432318618, 7.726243780163404],
              [18.31027289532811, 7.729440717364849],
              [18.30892219582754, 7.735180712273772],
              [18.26799093290998, 7.734204503270792],
              [18.258164210377338, 7.741990418755934],
              [18.256760670665617, 7.747743387816491],
              [18.253234674243085, 7.753155256341902],
              [18.25156906982485, 7.758336938906445],
              [18.247281110243264, 7.759741018894958],
              [18.248109066331438, 7.766767953883808],
              [18.25116018871154, 7.769368817945201],
              [18.248751505898255, 7.776166649133353],
              [18.278909476463433, 7.765538932998264],
              [18.32428848404677, 7.8213519508395395],
              [18.34700285036458, 7.847872998217472],
              [18.35078859027293, 7.8437649798133355],
              [18.36452706466279, 7.861223305205781],
              [18.3904424457197, 7.892426946418375],
              [18.406206781243363, 7.8792578330253935],
              [18.40856829040261, 7.879914619470017],
              [18.4137773123781, 7.8768387230265615],
              [18.42246542756353, 7.862383050358056],
              [18.423844000394563, 7.858158765808792],
              [18.428816362745124, 7.852834970960387],
              [18.423583621017368, 7.840609336030678],
              [18.422969129089125, 7.8328974112204675],
              [18.421437186118723, 7.828960236710066],
              [18.42394612947565, 7.825127352043463],
              [18.42492460551789, 7.818084080355675],
              [18.426986103456148, 7.8173753893609845],
              [18.42683004654563, 7.811050778156571],
              [18.42534359705539, 7.807047307828153],
              [18.427194071967943, 7.802750908770558],
              [18.425604332111707, 7.79848022052935],
              [18.428466576163643, 7.7962690873767615],
              [18.427159942643364, 7.790843239683368],
              [18.43066519631206, 7.787329171875022],
              [18.431363469064575, 7.784234242581082],
              [18.436583940775474, 7.778891599394515],
              [18.439537987296536, 7.7740537696097025],
              [18.443870704766812, 7.771172400574874],
              [18.447953760138603, 7.763877768206052],
              [18.457785665835832, 7.758109291578118],
              [18.459618551040144, 7.754170159574206],
              [18.467315543146704, 7.753796920883399],
              [18.470896823846946, 7.763728092459828],
              [18.479158263768248, 7.758078711349333],
              [18.489685648170898, 7.748886929121277],
              [18.504417295343657, 7.78981990577907],
              [18.508697331862418, 7.792134196345642],
              [18.526886385754057, 7.786272868757447]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -70.40014321495133, "lat": 43.84679703229024 },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23005"],
        "coty_name": ["Cumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cumberland County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00581288"
      },
      "bbox": [
        18.247281110243264, 7.332057426164385, 19.00653821234202,
        7.892426946418375
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.895985226551087, 5.798022559834962],
            [16.89919581992571, 5.925154702651294],
            [16.902060924292833, 6.042522196775324],
            [16.989354265792787, 6.061250362451748],
            [17.074748820262887, 6.079683743329353],
            [17.083516294139653, 6.042219794894953],
            [17.102178823272588, 6.04532897235791],
            [17.135456627261284, 6.057471524908495],
            [17.135991682788596, 6.053536284864019],
            [17.13412923235416, 6.04997901559567],
            [17.136729082659407, 6.046282591321282],
            [17.135697872909056, 6.042241249247195],
            [17.12966884156606, 6.037889261373154],
            [17.123772145928626, 6.03805062330627],
            [17.1203380537421, 6.033968477001561],
            [17.122999855154784, 6.02896537523834],
            [17.11348588638373, 6.024355623863932],
            [17.114816972416016, 6.020574419335715],
            [17.110615779067743, 6.018432802524672],
            [17.116944254128974, 6.014029683336917],
            [17.12379616961919, 6.012344573574401],
            [17.12801504574985, 6.009996401296874],
            [17.131762270182858, 6.014445570762994],
            [17.13516710484249, 6.015331080294267],
            [17.13582342612943, 6.018305323992162],
            [17.141392128037598, 6.018232845380278],
            [17.143471763422347, 6.007291497569494],
            [17.146430091222413, 6.004246486094239],
            [17.14995251171179, 5.994962503364608],
            [17.153167292236947, 5.90815309982648],
            [17.154070452879655, 5.893506594433251],
            [17.16188762763401, 5.893773219031899],
            [17.164456972026017, 5.850934140389387],
            [17.166861310282513, 5.81939853897539],
            [17.165626951028457, 5.819343812952479],
            [17.16672014740497, 5.801199197576468],
            [17.169811907117438, 5.738666537987419],
            [17.16990213232938, 5.730383456930534],
            [17.129093369710247, 5.730103515719143],
            [17.129162100083374, 5.721465535395407],
            [17.14202946930345, 5.682336360636597],
            [17.145622879471315, 5.672094609702957],
            [17.154040055600397, 5.669347100025841],
            [17.16036057290167, 5.665848078669848],
            [17.163517976916907, 5.667434060933662],
            [17.166059351958104, 5.662663307406602],
            [17.172892993044087, 5.65850667179143],
            [17.18108710827746, 5.659440886255663],
            [17.18297460767605, 5.662848883947944],
            [17.189008578241605, 5.657694472746104],
            [17.191704204859004, 5.658508027508206],
            [17.194211034109497, 5.667139009763591],
            [17.207945140473438, 5.60696607441626],
            [17.20612100076328, 5.606858604492241],
            [17.206691026501375, 5.59364606866096],
            [17.21020544976568, 5.496702871666304],
            [17.183231870640533, 5.494792266960805],
            [17.183625247826985, 5.490080626144121],
            [17.186835313706524, 5.486138242106556],
            [17.18775480632406, 5.480439462191853],
            [17.19211126538522, 5.472797392215884],
            [17.197123369197765, 5.468448903905472],
            [17.1965666958602, 5.464659169519383],
            [17.19090286556778, 5.458971192484377],
            [17.190680496517228, 5.453199809312744],
            [17.194808862912506, 5.441891965233095],
            [17.208555711785984, 5.420920611061491],
            [17.212104913738028, 5.417779253163962],
            [17.210694583552158, 5.412463274697193],
            [17.216815372222754, 5.409483378727511],
            [17.217977849902717, 5.407073464233836],
            [17.217907685156746, 5.399238969612625],
            [17.22206211135859, 5.392454279396467],
            [17.09444152233837, 5.366470206246002],
            [17.047644004338768, 5.357280425773723],
            [16.947623291808405, 5.336821038843018],
            [16.908785599680986, 5.326495530562303],
            [16.901920907041287, 5.324884086481278],
            [16.88521080237491, 5.358602322746027],
            [16.88755195109097, 5.449654790706349],
            [16.889891681911838, 5.542942512935105],
            [16.891883746094003, 5.624307759720129],
            [16.89403914848875, 5.7145069684595695],
            [16.895985226551087, 5.798022559834962]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.20635709924706, "lat": 42.3707066113136 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25003"],
        "coty_name": ["Berkshire"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Berkshire County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00606928"
      },
      "bbox": [
        16.88521080237491, 5.324884086481278, 17.22206211135859,
        6.079683743329353
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.65981819566032, 6.064661558335853],
              [18.66232610854675, 6.064947263552858],
              [18.667713613834454, 6.060863485384432],
              [18.661461071055616, 6.060508265188215],
              [18.65981819566032, 6.064661558335853]
            ]
          ],
          [
            [
              [18.633037860291672, 6.036320748368267],
              [18.63697434611151, 6.041472566273028],
              [18.637250595192736, 6.048441569965728],
              [18.642239928827152, 6.058868483052754],
              [18.645755377198025, 6.055933828438255],
              [18.642778220319734, 6.0516627810677175],
              [18.641006825729953, 6.039675537428572],
              [18.63775292581229, 6.036420348238421],
              [18.633037860291672, 6.036320748368267]
            ]
          ],
          [
            [
              [18.620504404190932, 6.049561239641665],
              [18.625119343741073, 6.049607531308699],
              [18.626006191679902, 6.043791422015456],
              [18.623160414998615, 6.040846511487089],
              [18.620504404190932, 6.049561239641665]
            ]
          ],
          [
            [
              [18.60482830875891, 6.030255570620106],
              [18.607917481596445, 6.033802705122232],
              [18.610240442058355, 6.039147878520796],
              [18.612811271078275, 6.038398206810385],
              [18.60964513710319, 6.026949849352653],
              [18.60482830875891, 6.030255570620106]
            ]
          ],
          [
            [
              [18.50235933325829, 5.992656135375351],
              [18.513698672734556, 5.986094193777861],
              [18.520232618158246, 5.995667825313331],
              [18.5232305644358, 6.007899107697088],
              [18.526530324524753, 6.01866350166604],
              [18.531301188978496, 6.021202224489162],
              [18.532218811196667, 6.034121224357006],
              [18.531223824469464, 6.038247266032301],
              [18.533939369943635, 6.042502156729161],
              [18.53160190749286, 6.048200979068036],
              [18.51954569460795, 6.047007957239459],
              [18.512342991645447, 6.039039593412916],
              [18.50748125673178, 6.031526393292288],
              [18.504881757548468, 6.025251938838543],
              [18.500890537507857, 6.019790842402073],
              [18.497292135910527, 6.022200586556232],
              [18.492627418290006, 6.020754828119596],
              [18.490352629613653, 6.025339573091374],
              [18.491533841221468, 6.0272702228157815],
              [18.483122614823323, 6.035661479741255],
              [18.482920518926164, 6.038853123366057],
              [18.485659838165965, 6.04649900705137],
              [18.488713022082695, 6.045704808889509],
              [18.49906897204313, 6.051149780245119],
              [18.500828186968054, 6.05545512356143],
              [18.50418927056378, 6.055953931076221],
              [18.50836163793355, 6.061677123607596],
              [18.506892696295658, 6.064857887370963],
              [18.51009909412005, 6.066990475061551],
              [18.514850065352242, 6.063453935547725],
              [18.519494737427703, 6.063063381528084],
              [18.52288451998959, 6.051549553492439],
              [18.526069795136408, 6.050040711664439],
              [18.532550959032655, 6.051035599662506],
              [18.541321935733126, 6.055380035685041],
              [18.54959284160433, 6.0621439993612265],
              [18.55051846489301, 6.067612517708633],
              [18.55386126584049, 6.076840761142792],
              [18.549848522702295, 6.076642081580981],
              [18.54561954003781, 6.083325386039184],
              [18.54182457045307, 6.083186211249992],
              [18.544123877120214, 6.094947650460985],
              [18.551009393934674, 6.091396954855657],
              [18.558248697753317, 6.093849624985985],
              [18.560824151631273, 6.104421609425793],
              [18.564795243171126, 6.111025375548748],
              [18.566864600812888, 6.123390971863872],
              [18.56712138342616, 6.12905794083049],
              [18.56961534592024, 6.149899903279356],
              [18.564061384064317, 6.15510771569937],
              [18.567658789502747, 6.161675041311086],
              [18.57457666527701, 6.155283348185459],
              [18.577375815458637, 6.148160530085824],
              [18.587885648655547, 6.147328970440164],
              [18.59192124644075, 6.152374889097048],
              [18.598400071609028, 6.150399092679518],
              [18.601960226062968, 6.1571570115423],
              [18.60298937982363, 6.16344402226325],
              [18.606642561907673, 6.165248350933536],
              [18.61194243652319, 6.163741481217574],
              [18.60312801870258, 6.151964496801157],
              [18.59981617938312, 6.143212576006191],
              [18.598399362949234, 6.135266958273311],
              [18.598857692609982, 6.1254417293304],
              [18.601027564444436, 6.121358741573679],
              [18.60409681636659, 6.121603616744212],
              [18.606777589992124, 6.116315202306048],
              [18.610841731318562, 6.111511415944643],
              [18.613959155035808, 6.111210790092939],
              [18.61888415708498, 6.113201644644644],
              [18.617443899339676, 6.10755999916327],
              [18.62011721566278, 6.100335112141425],
              [18.626185434528015, 6.091821473402743],
              [18.62522864010279, 6.088097254484027],
              [18.62781104054169, 6.081882141346969],
              [18.632514524539726, 6.0804323724254035],
              [18.635043835324247, 6.0816643608101435],
              [18.64032930907123, 6.077056610362429],
              [18.642021909349054, 6.071575149981497],
              [18.636377896204078, 6.072687280989175],
              [18.622765030301217, 6.082249268435053],
              [18.62137639191709, 6.085024407893247],
              [18.622546481364065, 6.093935105374464],
              [18.62065667023692, 6.094826940866141],
              [18.610708704239066, 6.088620005455088],
              [18.603166196390582, 6.090931770315237],
              [18.601102376907214, 6.090096154829021],
              [18.60096653253515, 6.083350001550004],
              [18.6059923674415, 6.079115673155508],
              [18.61251124297625, 6.082227974682565],
              [18.615371047451593, 6.079299529829068],
              [18.61337115848485, 6.074802674376734],
              [18.610131264828418, 6.073327372281131],
              [18.605762668791396, 6.074748029501006],
              [18.60290807216017, 6.073599135302652],
              [18.603875261959985, 6.064865288713368],
              [18.60235247690095, 6.064232696704392],
              [18.5852471220623, 6.07155593832412],
              [18.58263750332235, 6.07575772938758],
              [18.576605991750803, 6.074560638672409],
              [18.572428534892012, 6.077004309845937],
              [18.56968013265501, 6.081453124596688],
              [18.565292932816128, 6.080988643024907],
              [18.57019974948569, 6.065432239688886],
              [18.59946589888867, 6.057794866979599],
              [18.603180811980664, 6.054514998537666],
              [18.601131423782522, 6.04666939740073],
              [18.59442216288216, 6.047612121458135],
              [18.58808782177323, 6.041359909936769],
              [18.582316604482585, 6.041247517789264],
              [18.579084021255007, 6.038253301235772],
              [18.580458700853754, 6.033791122690097],
              [18.592531909365526, 6.029438730642605],
              [18.593451503661566, 6.026943655025166],
              [18.591305174517384, 6.023302170547243],
              [18.587990995226832, 6.024115233780584],
              [18.586018106656578, 6.020520350837333],
              [18.5855623325285, 6.014370250961728],
              [18.588268422754997, 6.01314247516477],
              [18.587528418023588, 6.009431302910389],
              [18.59108111545695, 6.004981682067658],
              [18.593905656425584, 6.005276455659322],
              [18.597172492571424, 5.998125442703644],
              [18.596441461510018, 5.991069587478957],
              [18.594587963253584, 5.988674721098991],
              [18.590615328156616, 5.989514374999479],
              [18.587314008105665, 5.985472160842819],
              [18.58942421034964, 5.982559718146641],
              [18.584680482888036, 5.976585440431806],
              [18.581702239006376, 5.979418612928228],
              [18.57365236886966, 5.977113646132171],
              [18.5696912781305, 5.974112511442821],
              [18.564700487513875, 5.9738754836154655],
              [18.560685627894483, 5.965961255440441],
              [18.55716892673721, 5.961533890111309],
              [18.551366357101628, 5.961071209482841],
              [18.55412314711366, 5.9562526546531505],
              [18.55619764651127, 5.949111333834526],
              [18.546402513295003, 5.9373488458291135],
              [18.549015579386214, 5.932705989476944],
              [18.546227310700186, 5.925638154296739],
              [18.535645047595015, 5.93120381635564],
              [18.527688908687395, 5.949566479449382],
              [18.523151474333872, 5.950941995664213],
              [18.51936390377809, 5.946729129930318],
              [18.504546043710278, 5.9564889305950635],
              [18.505221473550247, 5.9586637227741095],
              [18.5023043727431, 5.963802206568382],
              [18.496514955864388, 5.962169001697106],
              [18.494058394196458, 5.965230694210438],
              [18.488932847813246, 5.967491017779021],
              [18.494870329244133, 5.981093971777434],
              [18.50235933325829, 5.992656135375351]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.07419992295632, "lat": 42.33288139988796 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25025"],
        "coty_name": ["Suffolk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Suffolk County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00606939"
      },
      "bbox": [
        18.482920518926164, 5.925638154296739, 18.667713613834454,
        6.165248350933536
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.246690071478481, 3.4115212082293382],
            [7.279378600619193, 3.4394431860579204],
            [7.304691363087762, 3.4637343297034047],
            [7.320318126704861, 3.4784012261630606],
            [7.327672106563508, 3.4877187905955367],
            [7.342257175487155, 3.5015957364998984],
            [7.347029648723327, 3.510640837183768],
            [7.352089935178064, 3.518238466630222],
            [7.364272713268287, 3.532225504159344],
            [7.383254626825321, 3.5579201782385406],
            [7.391973956155107, 3.5735692088718447],
            [7.398187153735442, 3.5860241070671743],
            [7.40734371287069, 3.6111258845396352],
            [7.4123292886863785, 3.6305378453478117],
            [7.414321957644584, 3.64216427200013],
            [7.4205106504375955, 3.6708193288872617],
            [7.422347375103883, 3.6771795120128585],
            [7.443772537021969, 3.7338167492586827],
            [7.452475062172925, 3.7593489109766343],
            [7.458615988114184, 3.7807660108705963],
            [7.4593839551786445, 3.7895356364016513],
            [7.460888961106354, 3.794222582591649],
            [7.473155846482565, 3.811778813005894],
            [7.493773069920438, 3.8467379757693814],
            [7.499955176933423, 3.8564367472543313],
            [7.5123806751619195, 3.8783076734342856],
            [7.5241402526252505, 3.900599690923281],
            [7.532459154834038, 3.9177515490375376],
            [7.536809473222888, 3.9279980231741773],
            [7.554330404557934, 3.929619273561396],
            [7.582714260249863, 3.9330067741484984],
            [7.639705246285865, 3.9387554279421413],
            [7.646575969522078, 3.876376707781666],
            [7.652885427470932, 3.816633948348405],
            [7.6579345062784006, 3.767022985888392],
            [7.667007836181827, 3.680170803922775],
            [7.671927514866228, 3.63063154316722],
            [7.678076407071352, 3.565702986855315],
            [7.681739569472679, 3.52203584112452],
            [7.687825171151937, 3.455337110640402],
            [7.658786953656775, 3.452544837348585],
            [7.549014704015803, 3.4409524414960404],
            [7.46827265055841, 3.4325014308119903],
            [7.382076882258495, 3.424126860597102],
            [7.303264098891888, 3.4167371420290453],
            [7.246690071478481, 3.4115212082293382]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.41231265226583, "lat": 41.95461806686451 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26021"],
        "coty_name": ["Berrien"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Berrien County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01622953"
      },
      "bbox": [
        7.246690071478481, 3.4115212082293382, 7.687825171151937,
        3.9387554279421413
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.338969642483391, 3.8406028705001747],
            [8.367031379646527, 3.8442128099267268],
            [8.424409141410798, 3.851296673789746],
            [8.459518330758867, 3.855307969359158],
            [8.51675796371428, 3.8622294699079456],
            [8.620121990679632, 3.873817847339287],
            [8.680918414013743, 3.8809732090650657],
            [8.68274072179741, 3.866933729712127],
            [8.69146496451973, 3.794394115169833],
            [8.70258245903209, 3.7068866323112935],
            [8.712660892241749, 3.620051676910992],
            [8.718835682591864, 3.5691830568915566],
            [8.639926721893197, 3.5596219250977987],
            [8.610312765786034, 3.5558418241024805],
            [8.562445685505736, 3.550730736713236],
            [8.561233568722862, 3.5507768421864125],
            [8.504018463405455, 3.5438972227046763],
            [8.445528129836179, 3.537243905711975],
            [8.375314388389617, 3.5295094734762515],
            [8.369635585081285, 3.5803201980026067],
            [8.35877110236988, 3.6743225947203086],
            [8.350897723670139, 3.7397895970183206],
            [8.346470648001082, 3.7782344933970005],
            [8.338969642483391, 3.8406028705001747]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.05903256005183, "lat": 41.91613057012244 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26023"],
        "coty_name": ["Branch"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Branch County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01622954"
      },
      "bbox": [
        8.338969642483391, 3.5295094734762515, 8.718835682591864,
        3.8809732090650657
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0144717640965424, 5.212355536905459],
            [3.013952333291594, 5.2265195926451264],
            [3.1077685127401633, 5.229875047878322],
            [3.1864717697707463, 5.232051375757802],
            [3.2794360182480276, 5.2357614198254305],
            [3.3436661209791954, 5.238448735602898],
            [3.425851252710729, 5.241635250989612],
            [3.48289440012242, 5.2444971668363145],
            [3.514209106935613, 5.245539415142865],
            [3.5297080219777732, 5.246315519997562],
            [3.530140553783743, 5.235268055151018],
            [3.535004724970094, 5.13062916034646],
            [3.537307773170829, 5.073131478439954],
            [3.5413289899231373, 4.986862353186823],
            [3.5441293912558254, 4.923371443590087],
            [3.545473051108448, 4.900301461291438],
            [3.4749238024826288, 4.897218634162584],
            [3.3837824864700874, 4.893209302490908],
            [3.2933067699875656, 4.889504097755734],
            [3.22686565464259, 4.886850731047097],
            [3.1816769365352426, 4.8848618029908355],
            [3.11605649597245, 4.882263390569806],
            [3.080217148907216, 4.880961606964],
            [3.0270035015300496, 4.878729864562153],
            [3.0260136886831184, 4.900527649368224],
            [3.0233936396192247, 4.965672340227147],
            [3.0200282769095623, 5.052759997863559],
            [3.017233594496378, 5.138713163210989],
            [3.0144717640965424, 5.212355536905459]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.09015904375107, "lat": 43.67399843895849 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27045"],
        "coty_name": ["Fillmore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fillmore County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00659468"
      },
      "bbox": [
        3.013952333291594, 4.878729864562153, 3.545473051108448,
        5.246315519997562
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.1401688452901463, 5.528065157286642],
            [0.1419215733564132, 5.528254605044084],
            [0.2153590664595324, 5.5282643890173375],
            [0.28879659956855136, 5.528261220318772],
            [0.33235415717769023, 5.5277330736258],
            [0.40758320940542286, 5.527161371648623],
            [0.4181612607648885, 5.526958766666987],
            [0.4178868188032754, 5.440413935966555],
            [0.4175341306878946, 5.353395808206056],
            [0.4178105845827149, 5.26639070355492],
            [0.4173224893272951, 5.179842998888993],
            [0.382715866410758, 5.179597202866686],
            [0.2875290363239939, 5.179614814745081],
            [0.18554454120045843, 5.180462765257337],
            [0.13815705338936562, 5.181067316142762],
            [0.13835446764716983, 5.210205374132428],
            [0.138682581304729, 5.309572932622421],
            [0.13907095906504555, 5.340377953058554],
            [0.13911592319321295, 5.369818162773781],
            [0.13960016326732672, 5.442577436132967],
            [0.1401688452901463, 5.528065157286642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.25864914237721,
          "lat": 44.022998996754865
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27117"],
        "coty_name": ["Pipestone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pipestone County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00659504"
      },
      "bbox": [
        0.13815705338936562, 5.179597202866686, 0.4181612607648885,
        5.5282643890173375
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6323436500054188, 7.083230576613104],
            [0.7045973859214796, 7.083093813473711],
            [0.8008684085462171, 7.082824650270869],
            [0.8705040221034265, 7.084068792259705],
            [0.8942533264384852, 7.0834886082453],
            [1.0136531337771109, 7.084093225183621],
            [1.0644025022162447, 7.08468356161396],
            [1.0653619612823506, 6.99865381185722],
            [1.0657435304392915, 6.9552922363504885],
            [1.06584543685357, 6.912192766436868],
            [1.0717083910841847, 6.912259593974659],
            [1.0725116195819038, 6.82324248438913],
            [1.0730050015579404, 6.740951981166395],
            [0.986409514933093, 6.740463682015563],
            [0.9144974523546036, 6.739710137786933],
            [0.8285291275929061, 6.73880181256926],
            [0.8143506275838313, 6.738508763183871],
            [0.7275764517120376, 6.738654226241617],
            [0.6410212059068253, 6.7382418662165655],
            [0.6406805064658805, 6.824421621472684],
            [0.6404687262163797, 6.896257233193791],
            [0.6403153948289565, 6.910136490408104],
            [0.6327203652820651, 6.910094082225486],
            [0.6327216846901358, 6.996737060548253],
            [0.6324032658225779, 7.0400258802567555],
            [0.6323436500054188, 7.083230576613104]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.44452528215142, "lat": 45.58601128189719 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27121"],
        "coty_name": ["Pope"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pope County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00659506"
      },
      "bbox": [
        0.6323436500054188, 6.7382418662165655, 1.0730050015579404,
        7.08468356161396
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.563539884481058, 6.483996832065587],
            [2.5888391328681157, 6.484547061304791],
            [2.589767331419424, 6.45773978681111],
            [2.5905294433268624, 6.427138661081103],
            [2.5932970186616906, 6.343103860919467],
            [2.596535523511121, 6.2530007894852835],
            [2.571191166726915, 6.25214211220875],
            [2.567861019676949, 6.255349472340447],
            [2.5605851206613175, 6.258865724216648],
            [2.5551330960162786, 6.26593827350517],
            [2.552750093365271, 6.273042057132518],
            [2.5479588222546248, 6.280060402216532],
            [2.5202035866952666, 6.2793753339315765],
            [2.5200765623262362, 6.282925103260402],
            [2.5164668378915698, 6.282866137902147],
            [2.5165892407011117, 6.279276388060397],
            [2.4935484360953124, 6.27854945773719],
            [2.491317331725798, 6.2748740443191355],
            [2.488399645667578, 6.264903185982836],
            [2.4797422100749174, 6.256019638594595],
            [2.476491573511637, 6.251395617079642],
            [2.469182825665849, 6.24863040271973],
            [2.4660133651649985, 6.246408793414085],
            [2.459207668266785, 6.246341034332921],
            [2.4599754031453513, 6.2519318053671125],
            [2.4527486730912953, 6.252906082818548],
            [2.4505464260178775, 6.255697008739783],
            [2.449064420130659, 6.262017130881151],
            [2.443146446829404, 6.267071595899896],
            [2.4421463150063474, 6.277140483867776],
            [2.4430289200204807, 6.284302209808284],
            [2.4421190034527362, 6.29161736173513],
            [2.442391873872543, 6.2988006075001195],
            [2.439645072655241, 6.308152748798228],
            [2.4366408839334666, 6.310286580603121],
            [2.435649619396239, 6.34856783688258],
            [2.433976895754042, 6.3923821917779575],
            [2.4206896275173935, 6.391922835804252],
            [2.4184426137379234, 6.449094468508031],
            [2.417553988910087, 6.480270095146894],
            [2.488181879981658, 6.481954665179903],
            [2.5350581648790267, 6.483358213507009],
            [2.563539884481058, 6.483996832065587]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.09954819183412, "lat": 45.01713799791398 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27123"],
        "coty_name": ["Ramsey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ramsey County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00659507"
      },
      "bbox": [
        2.417553988910087, 6.246341034332921, 2.596535523511121,
        6.484547061304791
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.1944283863048518, 10.266435046511335],
            [0.25972140361664303, 10.266234782112866],
            [0.32501437269030625, 10.266019828568979],
            [0.37060726802320343, 10.265937453011073],
            [0.4800883611858946, 10.265871945598468],
            [0.5454153978687424, 10.265724157909512],
            [0.6189088578367515, 10.265637398133906],
            [0.7125949076910666, 10.26573236537789],
            [0.8062808362470069, 10.265797091060547],
            [0.8831159604859138, 10.266020765909206],
            [0.9155392980884579, 10.26628019401453],
            [0.9169863382571055, 10.263776801641077],
            [0.9110928857535151, 10.250024978412426],
            [0.9120051261050064, 10.238154636832798],
            [0.9158827008485837, 10.232102605927196],
            [0.9149612159678997, 10.22847022419387],
            [0.9173011082608733, 10.221264750215765],
            [0.9251738917650785, 10.218557946505511],
            [0.9259768695508623, 10.215089105993838],
            [0.9189194810171206, 10.214965770623605],
            [0.9139550638899769, 10.209336579983278],
            [0.9140730400764703, 10.204705540992052],
            [0.9186534896184022, 10.193968388948397],
            [0.922092225934271, 10.188075879539458],
            [0.9285613949680405, 10.180711447293888],
            [0.9318024090447531, 10.178417583523915],
            [0.928747193030031, 10.174452903643179],
            [0.9355592878036106, 10.171820366722864],
            [0.9374704641262007, 10.168280761008962],
            [0.9445854532999454, 10.166197868105014],
            [0.9464478006299325, 10.16372299697031],
            [0.9596230063216082, 10.15548309096378],
            [0.9724594195542668, 10.152642093278983],
            [0.978520979938525, 10.152915055725918],
            [0.9886663113084103, 10.15594722902399],
            [0.9970428855845711, 10.156757368208545],
            [1.021431228675377, 10.163291372128576],
            [1.0304121700738673, 10.163645202959835],
            [1.0372000595374071, 10.166204031210382],
            [1.0473316648240405, 10.171812642437459],
            [1.051610705670501, 10.17489861453925],
            [1.0533310988522946, 10.178003086355604],
            [1.0610370572092416, 10.184254391155383],
            [1.0680161606147927, 10.19156233973738],
            [1.0697527615623592, 10.088341629202288],
            [1.070279252262405, 10.032257818228128],
            [1.0707475857385669, 10.025448944363378],
            [1.0710454292683906, 9.98960761493469],
            [1.021413542424677, 9.98898920338581],
            [0.9023187916972822, 9.988204287616135],
            [0.9031874644546645, 9.883232290857007],
            [0.9036281083253145, 9.819805934621533],
            [0.8896705847313342, 9.819843943182704],
            [0.8307927647979818, 9.819074626864493],
            [0.8053531244168551, 9.818247516469768],
            [0.7433869370474674, 9.817361282980398],
            [0.7298267694004876, 9.81756429827884],
            [0.686785851058979, 9.81795016455018],
            [0.6575982504953712, 9.817937796410064],
            [0.6137449075751349, 9.818817492378367],
            [0.5845826378981132, 9.81845597652574],
            [0.5724104995428306, 9.818613745340127],
            [0.555948562621794, 9.819522238012858],
            [0.4976758467772873, 9.820442294907052],
            [0.4680821561973101, 9.821442695901714],
            [0.3951097357357691, 9.821637975768462],
            [0.30580978650922613, 9.82323974359139],
            [0.29129447436696004, 9.823219372011726],
            [0.2114783091261864, 9.822571326196519],
            [0.20426573509644802, 9.822823209465803],
            [0.20380030368557703, 9.89470903333387],
            [0.20448751427251188, 9.907502241148578],
            [0.2045316063281089, 9.935381805125775],
            [0.20506392654704875, 9.971367114224229],
            [0.20570831474152915, 9.977417663026818],
            [0.20520540771672838, 9.991195261328413],
            [0.19356077521652118, 9.991213852168194],
            [0.19357295420206586, 10.020544413737596],
            [0.19410490891934074, 10.077090680060762],
            [0.19401318039334522, 10.161887463758953],
            [0.1944283863048518, 10.266435046511335]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.8108433239452, "lat": 48.77511186988778 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27135"],
        "coty_name": ["Roseau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roseau County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "00659513"
      },
      "bbox": [
        0.19356077521652118, 9.817361282980398, 1.0710454292683906,
        10.266435046511335
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.759563965526071, 6.896255287246839],
            [1.7868444133746397, 6.89704734478067],
            [1.8520532736146031, 6.8982024270666065],
            [1.9601675358540422, 6.901581360683827],
            [2.018219012782401, 6.902134109293241],
            [2.0326116783701536, 6.902638244276664],
            [2.1125653928576313, 6.904670654071499],
            [2.156811072047225, 6.905071768677897],
            [2.206772216010143, 6.906101271476263],
            [2.2076976002767776, 6.870394823357046],
            [2.2099831983895273, 6.791639870179764],
            [2.210987550683099, 6.763205894582746],
            [2.2119459700888315, 6.734230214405106],
            [2.2133650017061393, 6.648521725917992],
            [2.213579197451313, 6.59617361821831],
            [2.2139284278476583, 6.595180343437843],
            [2.207248270917836, 6.59593669997647],
            [2.2034172924493802, 6.601045140767362],
            [2.1996596218719673, 6.603990847769838],
            [2.1931688990363094, 6.6051630972882105],
            [2.185474177232184, 6.613643238144056],
            [2.1843997951629146, 6.616247660671908],
            [2.18273903113667, 6.6325298638494345],
            [2.179347352343747, 6.638998026474201],
            [2.1768877298142844, 6.648478283779807],
            [2.172035497340395, 6.64992060677179],
            [2.16882555771302, 6.642110639192147],
            [2.1640881970331804, 6.6398562176605695],
            [2.158489885150099, 6.640565922028326],
            [2.147092313206869, 6.639804466877433],
            [2.1417329946574446, 6.640223293956111],
            [2.134584123497448, 6.642810049822789],
            [2.1208566255091577, 6.64312951354288],
            [2.116222317388153, 6.642047189110473],
            [2.1091589790473586, 6.642514230280707],
            [2.103511504788803, 6.641612796946861],
            [2.09932410229658, 6.642529818114203],
            [2.0903398355955236, 6.651109787771121],
            [2.084643139645195, 6.645597133752706],
            [2.077484452414496, 6.643510306040025],
            [2.066281965227536, 6.645630279595467],
            [2.0546056835170265, 6.6451671533505765],
            [2.0455483373715775, 6.640829941076503],
            [2.039327208237955, 6.640125213853835],
            [2.0316829206397164, 6.6426197257298005],
            [2.0173461149796323, 6.652384824731244],
            [2.008450906293021, 6.654924450583289],
            [2.00060795137621, 6.661419571842211],
            [1.9984083539120376, 6.665667353347968],
            [1.9914687362775771, 6.67164505682114],
            [1.987765862060515, 6.6783118151766026],
            [1.9814705358882307, 6.679820272547168],
            [1.9754008293186265, 6.67952248744037],
            [1.9637384106782367, 6.681542230409388],
            [1.9536009818295028, 6.689195202345936],
            [1.9493163010914911, 6.695387380601299],
            [1.9471053357924466, 6.704576916119813],
            [1.944971936311363, 6.706768826856112],
            [1.937164287068704, 6.710686478516111],
            [1.9317802976899165, 6.714601209484959],
            [1.929293717933301, 6.723430638725138],
            [1.9250810084504222, 6.726145009535531],
            [1.9189171244670284, 6.727353649139104],
            [1.9149447841413494, 6.726018686162429],
            [1.905042689906015, 6.725203350457232],
            [1.9031199954471312, 6.721412003462047],
            [1.899688078734886, 6.7189308590423575],
            [1.8952558863173241, 6.72167622791318],
            [1.888851926879792, 6.72795217575751],
            [1.8823197006970096, 6.73227334608382],
            [1.8777320596476839, 6.740009195793036],
            [1.8701851934266898, 6.742145907202127],
            [1.864372719282173, 6.73735461226966],
            [1.8640435048466646, 6.732101514904744],
            [1.8601215126858046, 6.7319105737771245],
            [1.8591190923834917, 6.7361622504302625],
            [1.863547293556148, 6.741560129571267],
            [1.8615481123339572, 6.744801228893645],
            [1.854281039383437, 6.742927547850439],
            [1.8486293011684007, 6.745377126098271],
            [1.844564006979719, 6.752298808139012],
            [1.8372373361216068, 6.756602428847226],
            [1.8335878770806122, 6.762444033230556],
            [1.8310119455467075, 6.773900461788601],
            [1.8282960645457038, 6.774451183361678],
            [1.8221524739416077, 6.771401009052397],
            [1.8180887676027142, 6.777666730588034],
            [1.8110417265710925, 6.777108707156335],
            [1.8114196106074723, 6.781984809413731],
            [1.8093675319403646, 6.7857342715836575],
            [1.801649181378043, 6.788125907737839],
            [1.7944073064325725, 6.7915876975113925],
            [1.7956019410448283, 6.797622810346832],
            [1.7957890005030823, 6.8053004637190195],
            [1.7917633717428223, 6.808844990309902],
            [1.785185664236449, 6.817325215462367],
            [1.7781211577413474, 6.8198640560765424],
            [1.7713683846076762, 6.825497359876074],
            [1.7690015234241738, 6.8294257684490445],
            [1.766086323521783, 6.831022648142392],
            [1.76497258667387, 6.846360883571592],
            [1.767405450093254, 6.8540106660852445],
            [1.7605025740200015, 6.863014199077433],
            [1.7571018774979763, 6.871028016935422],
            [1.7607599289156286, 6.8711115843222785],
            [1.761860452443217, 6.874442237526559],
            [1.7614256995269946, 6.886233081868515],
            [1.7624038093258525, 6.890750535571114],
            [1.759563965526071, 6.896255287246839]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.77475903107242, "lat": 45.44397939298423 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27141"],
        "coty_name": ["Sherburne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sherburne County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00659515"
      },
      "bbox": [
        1.7571018774979763, 6.595180343437843, 2.2139284278476583,
        6.906101271476263
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0478911225086665, 7.68850143492259],
            [1.087711485795829, 7.6887404398954295],
            [1.1347066184233168, 7.689204030802235],
            [1.148747974810928, 7.689182441976242],
            [1.2216597492887622, 7.690128575482391],
            [1.2722472189525316, 7.690352129807772],
            [1.3412791591063398, 7.691461660478304],
            [1.3411789617635261, 7.687085894641693],
            [1.3474967143582324, 7.675445716824938],
            [1.3530050599399694, 7.67545307020987],
            [1.3613203742921953, 7.673340546555175],
            [1.3675849136430742, 7.673078558603568],
            [1.3721725997146963, 7.674510509031851],
            [1.3797845663320756, 7.674243419340387],
            [1.3812798848938252, 7.6817263764117625],
            [1.384314657057479, 7.684284449000977],
            [1.3865418795898905, 7.682630786152914],
            [1.387600298660422, 7.675815987175648],
            [1.3919768002898716, 7.675854327383499],
            [1.3955007825844379, 7.672500716760993],
            [1.3961122684357785, 7.642900891404951],
            [1.396543663359141, 7.607205332570032],
            [1.4002830563314543, 7.607067075713209],
            [1.401481969688384, 7.5491856242119955],
            [1.401282030123283, 7.541907991913276],
            [1.402337602424218, 7.4807360835043335],
            [1.402993198729199, 7.41835436313725],
            [1.403670643517037, 7.3731690389941456],
            [1.4046214961513783, 7.261097465985044],
            [1.4082504874060526, 7.261104157472298],
            [1.4093784509340905, 7.175961679295497],
            [1.409640113896975, 7.142392261308807],
            [1.410240902702863, 7.1036187174380085],
            [1.3886345806180334, 7.102991028415774],
            [1.3565720519646123, 7.102560079812851],
            [1.2878501782321126, 7.102247774057466],
            [1.2697868575253228, 7.102295278488128],
            [1.2373374007921976, 7.101495412564912],
            [1.2157711394038784, 7.101498227488803],
            [1.1505930179533315, 7.100505258871786],
            [1.0642285442880373, 7.099085697363915],
            [1.0630537328968352, 7.185379042421674],
            [1.0634143383623063, 7.256955791297453],
            [1.0582445125133806, 7.257015539553238],
            [1.0576731483598674, 7.314422222677053],
            [1.0571640902125437, 7.343217637055281],
            [1.0571515433419048, 7.385830036874255],
            [1.0569446629287385, 7.429288367396486],
            [1.0556896823848578, 7.530103205487256],
            [1.055873033085952, 7.544456179946205],
            [1.0554313975479988, 7.603029267662229],
            [1.0495675055545477, 7.603036625464493],
            [1.0481245514231616, 7.667095841270283],
            [1.0478911225086665, 7.68850143492259]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.89757092794143, "lat": 46.07062293020368 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27153"],
        "coty_name": ["Todd"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Todd County"],
        "coty_fp_code": "153",
        "coty_gnis_code": "00659521"
      },
      "bbox": [
        1.0478911225086665, 7.099085697363915, 1.410240902702863,
        7.691461660478304
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.49038541961474, -5.635746950419626],
            [4.489890231212415, -5.628658618566938],
            [4.571243591567356, -5.624651995450933],
            [4.571351104178505, -5.625544980300266],
            [4.589405017146081, -5.624227740541514],
            [4.65705049863561, -5.620856733599995],
            [4.657198737549472, -5.62348251776776],
            [4.699721419635338, -5.6214500159884855],
            [4.7008430470299, -5.650790627369995],
            [4.703386236654712, -5.6849331119238],
            [4.6989649131746045, -5.691537878698761],
            [4.699664767559911, -5.69487569925481],
            [4.698535712537502, -5.702168144650634],
            [4.695323679182727, -5.712074786546245],
            [4.696069680516503, -5.718372714537691],
            [4.693541527974816, -5.71988571808377],
            [4.690937929708904, -5.725928357453679],
            [4.69121864108025, -5.729447555965133],
            [4.684655694274459, -5.744992495472806],
            [4.688332858894292, -5.750536871372361],
            [4.688735107672693, -5.753799730774976],
            [4.684113934073437, -5.760632135645635],
            [4.686016427545618, -5.768199125064716],
            [4.682653033839259, -5.7731991127818585],
            [4.678374190410713, -5.774643603499511],
            [4.678181733937052, -5.776971387182996],
            [4.673294027287459, -5.778057850054698],
            [4.671408496430074, -5.782679319141314],
            [4.673815776109336, -5.786545650258551],
            [4.667969286789597, -5.793031030379701],
            [4.6705642011188715, -5.851023624344797],
            [4.670893306544126, -5.854292372986082],
            [4.673016019216587, -5.9069839138224225],
            [4.674067773351143, -5.93779027306235],
            [4.676050107211517, -5.968419232689742],
            [4.740836444812301, -5.96551507470577],
            [4.878090795670588, -5.95817864733619],
            [4.8771529544908425, -5.963028769532533],
            [4.882517460097284, -5.973537818582311],
            [4.88783811595944, -5.97745928251749],
            [4.892781122739214, -5.977939792045075],
            [4.8999844885230095, -5.977159352911597],
            [4.904520791887493, -5.978770827368687],
            [4.906078257907097, -5.982520469474196],
            [4.905535691182918, -5.986145376212936],
            [4.90155574662515, -5.993941587610945],
            [4.897400846686758, -5.995464622132906],
            [4.894213155777568, -5.993328198431576],
            [4.8909796685194, -5.995461010259833],
            [4.8822699223059285, -5.9961044223281315],
            [4.883061968712391, -6.001255035441464],
            [4.88656505056855, -6.008354310646786],
            [4.882597779228128, -6.022060468118018],
            [4.882360424561136, -6.028080947158622],
            [4.875124898268348, -6.033330805857413],
            [4.876138208989773, -6.038031900459972],
            [4.88054184339963, -6.042657890416845],
            [4.880642426242129, -6.050438190098084],
            [4.879102754678129, -6.05415714542387],
            [4.874816976591278, -6.054255436535976],
            [4.869445243093788, -6.049172808098223],
            [4.862306742837197, -6.0509059736421325],
            [4.857639947041901, -6.050183948032212],
            [4.853371695998553, -6.045754765917168],
            [4.84966928144431, -6.044604720108627],
            [4.8453845650670395, -6.047511990576375],
            [4.799515441441695, -6.049618634966531],
            [4.797815794471449, -6.049443348544575],
            [4.767983177452863, -6.05129307196158],
            [4.774498216187798, -6.183525829821466],
            [4.770398081801445, -6.181191458058319],
            [4.767981501800735, -6.176055348410945],
            [4.764437177731855, -6.176268726593619],
            [4.7629150967471325, -6.182661547597497],
            [4.7577719294329075, -6.186426229724861],
            [4.755256344472178, -6.185762127436348],
            [4.746219744262779, -6.179201830040938],
            [4.739873094498891, -6.17945874157391],
            [4.728888491489336, -6.18459228571055],
            [4.726309478490349, -6.18472553020712],
            [4.719521889036094, -6.178645297769402],
            [4.71195679397896, -6.177209780905845],
            [4.704310077376205, -6.179924438645781],
            [4.699099374261152, -6.1859242505051295],
            [4.697627755457406, -6.189336570467664],
            [4.69436231866491, -6.202553507072438],
            [4.693891076867415, -6.20967545564505],
            [4.690692344731178, -6.219605634972614],
            [4.685102929199581, -6.13085048377041],
            [4.684576760379688, -6.12734679500995],
            [4.681380791762599, -6.055474805332281],
            [4.61490217374679, -6.05828761475257],
            [4.620821945666143, -6.054688859460802],
            [4.624956035199713, -6.050677237356015],
            [4.631242036502535, -6.0418360778458835],
            [4.638608703510997, -6.034870665874644],
            [4.645640659437541, -6.023124280000965],
            [4.6467216562609455, -6.018161878324628],
            [4.646334585016184, -6.010292360367969],
            [4.642648544144626, -6.001764850189109],
            [4.635919522568798, -5.99288005296309],
            [4.63170500248614, -5.989731335643657],
            [4.625998538463508, -5.987296201622401],
            [4.622442630342288, -5.990006646971762],
            [4.615958093262301, -5.9979656299969335],
            [4.614503324310487, -6.001969687309821],
            [4.614015261914196, -6.00939308712281],
            [4.612725881495652, -6.01382305320915],
            [4.608390027680458, -6.021282490770961],
            [4.607974077255996, -6.027682024149037],
            [4.598401482617196, -6.02999652021687],
            [4.583462330606876, -6.035466928906163],
            [4.576725254520547, -6.0394292318518135],
            [4.562054670977099, -6.046382713338391],
            [4.556183908979996, -6.0473774095608555],
            [4.551527572874474, -6.052669885783727],
            [4.546114203062516, -6.052898352818118],
            [4.537270722647818, -6.046876022548841],
            [4.5320757235626985, -6.041574419622483],
            [4.527489952681645, -6.034862412091692],
            [4.522608164325727, -6.023317738846331],
            [4.520210269068074, -6.0131617052151025],
            [4.519589273932102, -6.004132041878425],
            [4.520179583108848, -5.998564276292398],
            [4.526789322074342, -5.990944686204788],
            [4.532264977108901, -5.98806979160199],
            [4.53744971053496, -5.979542893345274],
            [4.539795205286167, -5.972939329019556],
            [4.547255559936189, -5.9638112784534565],
            [4.562967763934226, -5.951770592400497],
            [4.577385212435491, -5.945182641217718],
            [4.581496485510449, -5.942341944887092],
            [4.591139739836326, -5.932652079936235],
            [4.596402041351692, -5.922711684226681],
            [4.598035521020618, -5.912925564215085],
            [4.5925126532095, -5.907966356376419],
            [4.578545120108725, -5.903638012721021],
            [4.567171829969122, -5.900650745415878],
            [4.5476987583659, -5.897772273031786],
            [4.539619824565496, -5.895351869281373],
            [4.5324735937588265, -5.895407012624788],
            [4.517049019138047, -5.89751565883657],
            [4.509977793670372, -5.896208356722802],
            [4.505804985663767, -5.892852969662405],
            [4.503966385148339, -5.8886457376004655],
            [4.503720495288937, -5.877954120973267],
            [4.509140159738035, -5.863602110032915],
            [4.509500259333222, -5.859265020796361],
            [4.502977667888144, -5.854106397665649],
            [4.504742838071278, -5.839804300539333],
            [4.503890482021229, -5.827359909525865],
            [4.506167195312917, -5.817384108438105],
            [4.511083441913848, -5.812755984415996],
            [4.516233935863396, -5.796261025859597],
            [4.521851106070242, -5.78985621799467],
            [4.529879890268932, -5.783348824737438],
            [4.539684959363261, -5.782264363097344],
            [4.548264134650878, -5.7790634851923],
            [4.563283219704079, -5.763260341640745],
            [4.5758924407975, -5.7473061406674555],
            [4.5777354330930216, -5.743932885236545],
            [4.580372854217664, -5.734638882126567],
            [4.5807335038520085, -5.7293069545268285],
            [4.579228196337933, -5.719203123754624],
            [4.579721474566558, -5.712989845551111],
            [4.57875053371332, -5.70925836714544],
            [4.572100523307941, -5.698204559821362],
            [4.564860665561788, -5.693190063224779],
            [4.562406296874096, -5.688601210898972],
            [4.5656839971696135, -5.684512940291432],
            [4.563904166836594, -5.6735994796706954],
            [4.55783537192111, -5.660403791498012],
            [4.548876887243341, -5.650690868943197],
            [4.540712170956611, -5.648577047976252],
            [4.536433420317655, -5.649374934308291],
            [4.525510966262249, -5.653635771253431],
            [4.517102939839848, -5.659090425598972],
            [4.51497601718892, -5.667526109155254],
            [4.5217239118945765, -5.674739135673839],
            [4.521626187056137, -5.6776387643319595],
            [4.517326159505949, -5.681446461177053],
            [4.516534024508967, -5.686091861862322],
            [4.518835483748712, -5.692583737336758],
            [4.523178870562653, -5.708518658866068],
            [4.522847602057232, -5.715480115860269],
            [4.521523429935543, -5.721007338513152],
            [4.512955073123551, -5.73365595422789],
            [4.5076260953809895, -5.737494580484015],
            [4.500827011046838, -5.739900692158962],
            [4.4923014145137685, -5.740821775142028],
            [4.482699257122613, -5.739247135099148],
            [4.469798899242302, -5.734546428517415],
            [4.459799385877136, -5.726458140757154],
            [4.45564618608131, -5.719899944542131],
            [4.454238594246485, -5.711734134313858],
            [4.454952526970946, -5.705927904596228],
            [4.459012370923174, -5.6973861020676475],
            [4.465294238768537, -5.689129098305328],
            [4.462861549511122, -5.684220485568271],
            [4.462821095073075, -5.680332453554024],
            [4.466309323872766, -5.676539581467144],
            [4.474431806666213, -5.66472639232763],
            [4.478324376230699, -5.662078460619916],
            [4.485312012450959, -5.654256379151431],
            [4.4886117823347185, -5.6480290442281165],
            [4.49038541961474, -5.635746950419626]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.98920132908422, "lat": 32.74145864544102 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28055"],
        "coty_name": ["Issaquena"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Issaquena County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00695751"
      },
      "bbox": [
        4.454238594246485, -6.219605634972614, 4.906078257907097,
        -5.620856733599995
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.1305296762288, -3.5311423754268434],
            [6.2049685912831904, -3.5257421234045467],
            [6.235883332572271, -3.5223990768129703],
            [6.265054351061265, -3.521000866707888],
            [6.287717937047429, -3.5192195730425095],
            [6.293531496087429, -3.6011872428237512],
            [6.29665464481609, -3.639740867919944],
            [6.297760934468553, -3.6562719705564914],
            [6.354964572466907, -3.6517845666573368],
            [6.3626969027924805, -3.7539480987648446],
            [6.3907849606072675, -3.7519823743121226],
            [6.3925665546846915, -3.779243250384323],
            [6.394199021511818, -3.7957132888870597],
            [6.3968447285360845, -3.8337500086508003],
            [6.399202575784657, -3.855793426812584],
            [6.4037372336913725, -3.9127372417368056],
            [6.389370857731074, -3.9138251411704803],
            [6.260611142347241, -3.9228705502067602],
            [6.231720589035783, -3.924684363615026],
            [6.1704641131494515, -3.9282125881219523],
            [6.145624484661084, -3.929828209042342],
            [6.101784632953563, -3.933482639358486],
            [6.097211687744042, -3.8706526109108634],
            [6.0900417271197105, -3.7740705156547367],
            [6.086226764650085, -3.715662311979751],
            [6.129042677399155, -3.7125851311204436],
            [6.126099583922162, -3.668905965730071],
            [6.140269866821597, -3.6679058548189793],
            [6.136601972440448, -3.616268138305268],
            [6.132846728431354, -3.5574574693244077],
            [6.1305296762288, -3.5311423754268434]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.90886705893887,
          "lat": 34.768336008288586
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28139"],
        "coty_name": ["Tippah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tippah County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00695790"
      },
      "bbox": [
        6.086226764650085, -3.933482639358486, 6.4037372336913725,
        -3.5192195730425095
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.014251260967113, 8.862812064769981],
            [-4.927194778845845, 8.85533433856939],
            [-4.84169922217138, 8.848123481276858],
            [-4.805314311996987, 8.84485262364293],
            [-4.7570877656873245, 8.84088975395489],
            [-4.762470356249739, 8.781795518543717],
            [-4.7632874440939545, 8.767622383093004],
            [-4.773616951007016, 8.640776985886458],
            [-4.785373007189754, 8.498335839705454],
            [-4.746099699786129, 8.495271682143228],
            [-4.748827671630561, 8.456767059548506],
            [-4.759944017793278, 8.321852497799515],
            [-4.767268970630939, 8.231208610479358],
            [-4.772135455663736, 8.169758465873729],
            [-4.773764797696932, 8.15138709406744],
            [-4.854177758901411, 8.157734839475868],
            [-4.905390982861732, 8.16184448995084],
            [-4.9126416639929085, 8.07429489034439],
            [-4.920929632029972, 8.075048675859593],
            [-5.000736672174209, 8.081720371402708],
            [-5.080545343548998, 8.088372982528677],
            [-5.0721828180787645, 8.187332179407631],
            [-5.065525325174718, 8.265781869498058],
            [-5.0566700652987775, 8.373313634066358],
            [-5.047142461313571, 8.481691014186739],
            [-5.0384064965837325, 8.579388166446224],
            [-5.035439529645382, 8.616379972978487],
            [-5.030943725876586, 8.664236913858169],
            [-5.024018989322198, 8.750732442092186],
            [-5.018594992909768, 8.81074705524677],
            [-5.014251260967113, 8.862812064769981]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.84657442266787,
          "lat": 46.94021256683237
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38033"],
        "coty_name": ["Golden Valley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Golden Valley County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01035617"
      },
      "bbox": [
        -5.080545343548998, 8.07429489034439, -4.746099699786129,
        8.862812064769981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.5349357592720008, 8.976888991956685],
            [-0.463672026696918, 8.97583709207383],
            [-0.3624534201863579, 8.974566115557888],
            [-0.29747433140862845, 8.973776533368431],
            [-0.23249542356811112, 8.972973410143341],
            [-0.1376465899666373, 8.972019128929466],
            [-0.13956802779804012, 8.968637439364107],
            [-0.13686644658282035, 8.963566697002332],
            [-0.13828845643557328, 8.959077265322104],
            [-0.1379102039380814, 8.953380184392515],
            [-0.13483118628053295, 8.949404295780925],
            [-0.1352249103714755, 8.942235495972414],
            [-0.13913306189422417, 8.939069237772351],
            [-0.13498595798732346, 8.934163814652356],
            [-0.13439834177077833, 8.930764700316944],
            [-0.1302565627223938, 8.929412150069735],
            [-0.13297883156821297, 8.925462290234163],
            [-0.1331389978429796, 8.921477190766558],
            [-0.12730877696046905, 8.918937772417436],
            [-0.12332008317694214, 8.913319554413262],
            [-0.1180361996084824, 8.911709123794651],
            [-0.11651467600612135, 8.907346580099302],
            [-0.11796983895580382, 8.90343530587855],
            [-0.11484319335659803, 8.900932639591712],
            [-0.11404948520636363, 8.88992648929813],
            [-0.11570939855527936, 8.880994500225434],
            [-0.12022770801519017, 8.875794648959682],
            [-0.11631936130911458, 8.873665316475352],
            [-0.11473764160159348, 8.870204215260895],
            [-0.11934447079905086, 8.868918139469846],
            [-0.1235367210144847, 8.871218107868565],
            [-0.1260871740047446, 8.86762610249051],
            [-0.1220996306125316, 8.864396252974538],
            [-0.11304760154607936, 8.868486318510861],
            [-0.11184029454109058, 8.866708897616403],
            [-0.11630660211290104, 8.862370633600133],
            [-0.12164318801668318, 8.861429776241415],
            [-0.11877718286780337, 8.857251035217471],
            [-0.11364892096855471, 8.854507057878022],
            [-0.11984291133249438, 8.847321441441514],
            [-0.1139588990278621, 8.845333297088072],
            [-0.11070424509356094, 8.841765602210133],
            [-0.11411438766444719, 8.840243579384106],
            [-0.11768792163060415, 8.84437584410413],
            [-0.12284341060746874, 8.841124379515223],
            [-0.11642502276065197, 8.838285879299287],
            [-0.12108258561965093, 8.832013760700864],
            [-0.12715644814648533, 8.831371327095889],
            [-0.12509277997704038, 8.827491340318053],
            [-0.1230424811554649, 8.819984549409154],
            [-0.11692299177696715, 8.817084498184537],
            [-0.1111933096356409, 8.819605336658395],
            [-0.10858632069388735, 8.817865204834964],
            [-0.11116646925463183, 8.813224934691371],
            [-0.10986089490413614, 8.810151916483102],
            [-0.11620715555886568, 8.809674722470522],
            [-0.11620454568443724, 8.80382338950527],
            [-0.11360929082006971, 8.801940142122131],
            [-0.12340834511749438, 8.792905188190009],
            [-0.11644131336453722, 8.790557841656497],
            [-0.11847081529215206, 8.78644147266111],
            [-0.12344570246315334, 8.786991705433453],
            [-0.1269039539466686, 8.782453277087958],
            [-0.12422897021006932, 8.780588741604054],
            [-0.12153522771891821, 8.78402151704865],
            [-0.1161744569211387, 8.783319705917034],
            [-0.11625862150312866, 8.780192508151353],
            [-0.12192002265422193, 8.776101397350619],
            [-0.12098722144075587, 8.770472263723374],
            [-0.11734135831073052, 8.765397299131212],
            [-0.11846893636125647, 8.756559510820347],
            [-0.12116553256447814, 8.749647772534653],
            [-0.11870782546405942, 8.743932401196927],
            [-0.12316732905205385, 8.741453542971712],
            [-0.1221794619226251, 8.73450430032108],
            [-0.11885108907227736, 8.728357164689792],
            [-0.12368100827014171, 8.726729223006508],
            [-0.1230101959083379, 8.718891053996781],
            [-0.11556924026643402, 8.70940839877575],
            [-0.11168326027511062, 8.707718540898387],
            [-0.10819982497617087, 8.70295009175463],
            [-0.114263733939619, 8.699773568252668],
            [-0.10662569477015447, 8.694120413260704],
            [-0.10956404421747533, 8.691913511181331],
            [-0.10717117942797082, 8.687182702850038],
            [-0.11008140482796176, 8.68571839126093],
            [-0.11264955712252138, 8.679892862282534],
            [-0.11712715291676912, 8.680159429632685],
            [-0.1179931989133232, 8.677818390641724],
            [-0.11233199280834598, 8.675664299250018],
            [-0.10951363475425427, 8.678225165569573],
            [-0.10701156443143538, 8.67597740717086],
            [-0.11196355102875671, 8.673299493609528],
            [-0.11692040009055087, 8.675013940602962],
            [-0.11415386513452538, 8.668187681867211],
            [-0.11689361361863981, 8.665347029579992],
            [-0.11535013594369192, 8.66233968437137],
            [-0.11127517022198276, 8.66012483361355],
            [-0.11067219043593746, 8.65646429539106],
            [-0.11369968098763557, 8.655006769319915],
            [-0.10919040023576229, 8.646656727130045],
            [-0.10535136949825705, 8.64667340079907],
            [-0.10241322761284063, 8.644324287233777],
            [-0.10532570160597121, 8.638284638917833],
            [-0.11014124136988007, 8.638062211732304],
            [-0.11302732360643274, 8.635822739654966],
            [-0.10926576750021033, 8.632668694400694],
            [-0.10630638481334129, 8.63632620490254],
            [-0.10205880203903163, 8.635369309877733],
            [-0.10150583022743691, 8.632751706248449],
            [-0.10691279994636765, 8.630469784484685],
            [-0.10533230695313645, 8.626259432923378],
            [-0.11376819097423921, 8.622001816590465],
            [-0.11066493233617815, 8.619188465894945],
            [-0.10927307027194184, 8.615384421477541],
            [-0.1061473805352237, 8.617028472802904],
            [-0.1033000575450049, 8.613203021532907],
            [-0.1042586893455551, 8.610766242906353],
            [-0.11188730406290978, 8.59955563372965],
            [-0.1095032810892019, 8.583764080794293],
            [-0.11334758491760061, 8.579942159087516],
            [-0.11205782585715163, 8.575551938519517],
            [-0.10731901359366838, 8.575978587762537],
            [-0.10575002416872284, 8.573928381310987],
            [-0.10975862653217877, 8.569782913945737],
            [-0.10720221374762627, 8.559355857437286],
            [-0.1044850243205493, 8.555190828212053],
            [-0.1074149495210704, 8.549797132102649],
            [-0.10510559858515238, 8.545595077588336],
            [-0.11452310318752573, 8.545209215166372],
            [-0.1800669117425541, 8.546857297369234],
            [-0.2883378782388404, 8.547995328686918],
            [-0.3573021097710845, 8.548832863389126],
            [-0.42626651479363414, 8.549655559536895],
            [-0.5271099157272124, 8.551450300291648],
            [-0.5259056511765969, 8.635416325841136],
            [-0.5412957280409796, 8.635801943860805],
            [-0.5393175951457669, 8.74823801876579],
            [-0.5390170205297093, 8.75004297178219],
            [-0.5383480077331227, 8.783277929956627],
            [-0.5378953079327693, 8.822363463569259],
            [-0.5369700010526448, 8.863276459203979],
            [-0.5349357592720008, 8.976888991956685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.16141150000107, "lat": 47.45413433477183 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38097"],
        "coty_name": ["Traill"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Traill County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01034221"
      },
      "bbox": [
        -0.5412957280409796, 8.545209215166372, -0.10150583022743691,
        8.976888991956685
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.131534249048824, 2.0708077662857174],
            [10.158711497981292, 2.0738195190689006],
            [10.15407442020273, 2.109829670135041],
            [10.191949647294818, 2.1120332910778954],
            [10.278600932244645, 2.119980277352325],
            [10.356008034105653, 2.126402177613933],
            [10.38979304960298, 2.1289035437349018],
            [10.462710634296814, 2.134863122035224],
            [10.465208241924286, 2.1065453641830514],
            [10.468944859447587, 2.059542044114339],
            [10.474665438451124, 1.9840645141273057],
            [10.47040508755611, 1.9836393688145166],
            [10.473246365575271, 1.9467311341661075],
            [10.45174200703296, 1.9452537678131527],
            [10.454129470602076, 1.9155447706375435],
            [10.46833786451806, 1.9166349952597876],
            [10.469660193268691, 1.8900930047780158],
            [10.470814809592808, 1.881070593916443],
            [10.47259091143783, 1.8502357288311277],
            [10.47451534351571, 1.8280406129585325],
            [10.459996812720586, 1.827356494108003],
            [10.462001084763022, 1.797818259250244],
            [10.408389936080466, 1.7940898816106763],
            [10.375608973324503, 1.7919450211053052],
            [10.299643112047725, 1.7861277432564515],
            [10.294536236599006, 1.785137229627115],
            [10.271623540907415, 1.782871293560879],
            [10.236952370311107, 1.779853315639552],
            [10.200942050458593, 1.775883389941217],
            [10.1878949446565, 1.7747300707233662],
            [10.181363954128043, 1.774786503339213],
            [10.143288728979055, 1.7719147890929348],
            [10.134056566512552, 1.8198076537333607],
            [10.122854565259011, 1.8758922769964799],
            [10.13746970756569, 1.8892533437160128],
            [10.140713442623886, 1.8934677616713638],
            [10.134325102113811, 1.9054310837260109],
            [10.12588327666378, 1.9121159738760982],
            [10.12601287272277, 1.9198349567759734],
            [10.121621324613356, 1.9224675639180235],
            [10.119430144207998, 1.9301622942447787],
            [10.117241115350573, 1.9321691243312753],
            [10.11541149313116, 1.9418482900560385],
            [10.117866710545936, 1.946422407328682],
            [10.113574971503946, 1.9499285990610122],
            [10.108820310798048, 1.9568052688087063],
            [10.104669184543637, 1.960400978812621],
            [10.109472776960654, 1.963326095196942],
            [10.110836117412125, 1.9668998759393337],
            [10.108838904732645, 1.972684768584239],
            [10.10925768303512, 1.978142071145139],
            [10.107322131055541, 1.9868518276050038],
            [10.104208539250585, 1.9908425580743856],
            [10.105890461684748, 1.9990151640441696],
            [10.102840695903103, 2.003625009958493],
            [10.103708169523708, 2.0075021397190165],
            [10.12869036296016, 2.0095164653799538],
            [10.135161702952828, 2.0105809074610965],
            [10.131396582669757, 2.0687813595297104],
            [10.131534249048824, 2.0708077662857174]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.00929417553921, "lat": 39.96953847049133 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39049"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01074037"
      },
      "bbox": [
        10.102840695903103, 1.7719147890929348, 10.474665438451124,
        2.134863122035224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.485572171040406, 2.3678347107977804],
            [9.492012048502215, 2.36853880026888],
            [9.485317354303984, 2.420693232191669],
            [9.549064306647313, 2.429030269506879],
            [9.56993581524483, 2.435057829416129],
            [9.570836695437771, 2.4282628051604576],
            [9.689825279784689, 2.43397189814123],
            [9.754864831953297, 2.4372543659522123],
            [9.842956802216635, 2.441011355454253],
            [9.84331570335943, 2.435420592335571],
            [9.844875990129534, 2.39625189497842],
            [9.84891476737096, 2.308085893741648],
            [9.853856750060082, 2.209450168353429],
            [9.856263934357976, 2.157803849557053],
            [9.767021521205878, 2.154548326241936],
            [9.708366790526274, 2.152333136655465],
            [9.678632521677772, 2.150752254038322],
            [9.677832407472087, 2.165443108678524],
            [9.670455946323333, 2.165257345275384],
            [9.591104302722645, 2.1611872947262185],
            [9.502906185284559, 2.1569863927447988],
            [9.500681832565306, 2.201137501278631],
            [9.506192650338624, 2.197513913651663],
            [9.498585198234354, 2.2532599645512446],
            [9.495503738993019, 2.2748714013028075],
            [9.497636944715929, 2.2754518124435092],
            [9.485572171040406, 2.3678347107977804]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.76582579753261, "lat": 40.38847014074032 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39091"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01074058"
      },
      "bbox": [
        9.485317354303984, 2.150752254038322, 9.856263934357976,
        2.441011355454253
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.967524278580326, 1.535764437213562],
            [8.957352524919775, 1.6230171017983566],
            [8.946459797028396, 1.7265932295140503],
            [9.006225276087752, 1.7335366326655115],
            [9.013842157814352, 1.7342040603644486],
            [9.109600562517084, 1.7458891765930569],
            [9.193043885201988, 1.7577702214559707],
            [9.194650865770155, 1.7445582190751447],
            [9.201058757287434, 1.6992148322940808],
            [9.210938248714772, 1.6276235673209998],
            [9.228884452853615, 1.4964228720183974],
            [9.237651819631889, 1.4303746096193235],
            [9.240582421279248, 1.4081295041250874],
            [9.226173176393802, 1.405860832617098],
            [9.183986343971373, 1.4002321627172571],
            [9.124657450728469, 1.392646270209577],
            [9.056705527717957, 1.3847300500927862],
            [9.025386050891163, 1.3800273863841594],
            [9.020022933904318, 1.3804262342086762],
            [8.985933183521443, 1.3764790361931085],
            [8.985694026893787, 1.3771002950079343],
            [8.978907095781993, 1.4373798334522856],
            [8.967524278580326, 1.535764437213562]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.64801782794514,
          "lat": 39.741536816029885
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39135"],
        "coty_name": ["Preble"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Preble County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01074080"
      },
      "bbox": [
        8.946459797028396, 1.3764790361931085, 9.240582421279248,
        1.7577702214559707
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.203847246837366, 2.567760445135704],
            [11.233342558627388, 2.5713307948140858],
            [11.226241575082696, 2.6292761113589562],
            [11.220094315728849, 2.68174804415937],
            [11.218793131701112, 2.688407632644052],
            [11.214899399484635, 2.7190099616831453],
            [11.210755877512678, 2.7548047355001737],
            [11.206701694917198, 2.7543890528212733],
            [11.20613340205173, 2.7593104786448936],
            [11.219821662750816, 2.7635762811950517],
            [11.28005232144801, 2.7823925105680796],
            [11.30082817900167, 2.7887535463236968],
            [11.350554951134157, 2.8043785889800135],
            [11.35162683186449, 2.805535370571102],
            [11.354915883364502, 2.8166926478971828],
            [11.358862256385608, 2.817523700940289],
            [11.372200964216605, 2.8159223476950164],
            [11.374677035829304, 2.811331807348272],
            [11.371080771716898, 2.8100299468992347],
            [11.36724204489034, 2.8056226316957997],
            [11.43405608745736, 2.8148578508274067],
            [11.46342642330903, 2.8187762759354564],
            [11.463583339068379, 2.8184387345223203],
            [11.468145706397669, 2.7823407758781684],
            [11.47384784858274, 2.7334360191673523],
            [11.516447566349134, 2.7384356071670264],
            [11.523596918681069, 2.679451855323165],
            [11.533058749251236, 2.6068533465122363],
            [11.537494084924504, 2.5722745940705702],
            [11.543971925020609, 2.5187678436242096],
            [11.549303304456664, 2.4767205545622963],
            [11.50489122839034, 2.470704827140492],
            [11.506803270427007, 2.4545503389080006],
            [11.516294711678063, 2.380416508143006],
            [11.40427755188539, 2.367024897460403],
            [11.302546021683247, 2.3549075149893404],
            [11.297475559917457, 2.396018834764319],
            [11.29367456067033, 2.4287363692160806],
            [11.28918023543181, 2.464205738187593],
            [11.284735084820753, 2.5019033599238094],
            [11.221765393499856, 2.494844726814215],
            [11.212604709109508, 2.4936403510754666],
            [11.203847246837366, 2.567760445135704]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.47374572947959, "lat": 40.44091580301431 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39157"],
        "coty_name": ["Tuscarawas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tuscarawas County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01074090"
      },
      "bbox": [
        11.203847246837366, 2.3549075149893404, 11.549303304456664,
        2.8187762759354564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.84331570335943, 2.435420592335571],
            [9.919046216620702, 2.4466252668153468],
            [10.046079891807144, 2.465520611846301],
            [10.052003287169349, 2.421721390333612],
            [10.054364460502594, 2.4024745890872645],
            [10.05735261667847, 2.377181637083451],
            [10.062070419190727, 2.340197769143129],
            [10.067760266723539, 2.297831557338528],
            [10.075693592671948, 2.240864704916201],
            [10.081415785949497, 2.203162376386103],
            [10.138492014178741, 2.210671212782489],
            [10.15407442020273, 2.109829670135041],
            [10.158711497981292, 2.0738195190689006],
            [10.131534249048824, 2.0708077662857174],
            [10.106623699400929, 2.067977065877813],
            [10.07725549662567, 2.0649825136040145],
            [9.991219249924583, 2.05467618168952],
            [9.90758608951862, 2.044655061097486],
            [9.906424788021608, 2.0593690260958253],
            [9.899419216095964, 2.1595284383025812],
            [9.891233351989715, 2.1589945502709815],
            [9.856263934357976, 2.157803849557053],
            [9.853856750060082, 2.209450168353429],
            [9.84891476737096, 2.308085893741648],
            [9.844875990129534, 2.39625189497842],
            [9.84331570335943, 2.435420592335571]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.37156737005081, "lat": 40.29939943011299 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39159"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "01074091"
      },
      "bbox": [
        9.84331570335943, 2.044655061097486, 10.158711497981292,
        2.465520611846301
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.251528854019577, 1.5605913779915332],
            [11.266138302663462, 1.5617188271889586],
            [11.261368689764383, 1.6068182846358556],
            [11.29160812454869, 1.6098366483218256],
            [11.291847662166118, 1.606709360555583],
            [11.309214673108107, 1.6084205058812047],
            [11.310093069235807, 1.6026240358892099],
            [11.331688573743081, 1.6044438415585103],
            [11.350030461691581, 1.6066223478344706],
            [11.345045000733087, 1.6571140252488452],
            [11.332010264878065, 1.655712145824338],
            [11.332204015572094, 1.6596785371258638],
            [11.328607038027094, 1.6715842641486303],
            [11.33104754517985, 1.6872739668459553],
            [11.330917383334816, 1.6943587816399914],
            [11.328869963055118, 1.703774910478326],
            [11.329916747471414, 1.7091601335069324],
            [11.334056020929742, 1.7117981912726483],
            [11.344635676989375, 1.7145196547597386],
            [11.348232903360794, 1.7183132900730151],
            [11.424805533686163, 1.726382049279528],
            [11.473073758399693, 1.7315467900029529],
            [11.511936510335689, 1.73601314600067],
            [11.50254203606723, 1.7985281199206224],
            [11.518625741026003, 1.8004684032316849],
            [11.520238102691179, 1.7861357691321273],
            [11.549784578148648, 1.7900209457924934],
            [11.551902177308868, 1.775414795881368],
            [11.566121425486655, 1.7774176384582812],
            [11.568382050152913, 1.7633377306792657],
            [11.59763725894681, 1.7671766488995606],
            [11.598659356165038, 1.759827834246117],
            [11.653921620652632, 1.7667185834882815],
            [11.652091924481551, 1.7806859719395118],
            [11.666350762412359, 1.7824505014425203],
            [11.669979109747922, 1.7538794604946124],
            [11.684007346405723, 1.7558516538425528],
            [11.683617801707586, 1.7582855305080909],
            [11.763489276454054, 1.767548250927486],
            [11.843119407285482, 1.7763467460069202],
            [11.846749983503027, 1.7441605750763387],
            [11.842667645437913, 1.7396846162044461],
            [11.838430314374774, 1.7318719638772109],
            [11.833130883242124, 1.7243245388095687],
            [11.826487467035745, 1.7163738198334173],
            [11.823443963915182, 1.709424602902353],
            [11.813756004355215, 1.6949338684365998],
            [11.80820287085418, 1.684045149186601],
            [11.801223236858169, 1.6615928036706695],
            [11.79724640676823, 1.6522635627031141],
            [11.79323038851475, 1.6430678453664758],
            [11.786856174830826, 1.6363424480871422],
            [11.776068620040046, 1.6340303489082801],
            [11.763017799874367, 1.6278909994053452],
            [11.756624722731672, 1.6227450307225197],
            [11.752768688183858, 1.6176550056410224],
            [11.75028777040002, 1.6099425570828811],
            [11.7413190916806, 1.595484888735151],
            [11.73820736415431, 1.587618957800416],
            [11.739188626399057, 1.581183490941807],
            [11.738539285649065, 1.5744871978580686],
            [11.735803612716643, 1.5709265756777653],
            [11.73130309003972, 1.5686605363304205],
            [11.716834179873091, 1.570699296782348],
            [11.711396355115617, 1.5695585255261537],
            [11.70381673464729, 1.5650090560977092],
            [11.695672648622738, 1.5629359727419194],
            [11.692251392599132, 1.560228320433979],
            [11.688623348908548, 1.5550373525730725],
            [11.677193065908158, 1.5482704627588586],
            [11.672281224849476, 1.5435831049351634],
            [11.662519006868175, 1.5326177946613566],
            [11.651727972584096, 1.5222622240436863],
            [11.643758480347957, 1.513850219634529],
            [11.637086940743101, 1.5101670416338109],
            [11.626389314777823, 1.507367040145779],
            [11.620024740735618, 1.5064000241098228],
            [11.616117332597256, 1.5071915140035084],
            [11.610221298726124, 1.5117569464576988],
            [11.605672194795089, 1.5179343537067187],
            [11.599881685135415, 1.5309954543151858],
            [11.592469354272298, 1.5491166343450882],
            [11.586909473063084, 1.5549226239711045],
            [11.573195127131337, 1.5637860399878296],
            [11.567422383846601, 1.5660599085306162],
            [11.558884130940243, 1.5666821950705572],
            [11.551791856056987, 1.5644652518338016],
            [11.543862090150967, 1.5576275174905956],
            [11.540297603250647, 1.553398751240712],
            [11.534562099865557, 1.5417992308252269],
            [11.530772882030343, 1.5354985737519795],
            [11.521730202756359, 1.5230487894417737],
            [11.514880486476256, 1.515674592623849],
            [11.507526533259508, 1.5089916208019727],
            [11.500351188711141, 1.504444223292697],
            [11.495208479631616, 1.498183553681454],
            [11.485853935756728, 1.48235535288853],
            [11.485485948634059, 1.4741314520934024],
            [11.487078204216315, 1.4612048604260697],
            [11.487032038938317, 1.43669461154631],
            [11.48958374921202, 1.419014710657408],
            [11.4888319621973, 1.4132842530308056],
            [11.487091755411287, 1.4099550902533549],
            [11.475320792143778, 1.4092501342766068],
            [11.467335353695171, 1.4127676814998062],
            [11.456888482663658, 1.4138849370112843],
            [11.447477452776935, 1.4099998222351997],
            [11.430356656036034, 1.4110187336921922],
            [11.420508040665798, 1.4096841074667812],
            [11.410069061802567, 1.4066768685952986],
            [11.404229772288408, 1.4035363016470772],
            [11.400641350990291, 1.4001171203107976],
            [11.396942973342565, 1.3945582196224127],
            [11.393076982313726, 1.3847766535872397],
            [11.393870347293648, 1.3764365375405796],
            [11.395720225618778, 1.3707064709236347],
            [11.399415489323781, 1.3643578878110199],
            [11.401303983285132, 1.3563306782490587],
            [11.399409150411925, 1.3521233734901599],
            [11.395119501680943, 1.34814218021594],
            [11.387230467679727, 1.3452974092900956],
            [11.37715435719372, 1.3403089496566218],
            [11.37189890611449, 1.3943623328656178],
            [11.298234435481012, 1.3863286847750254],
            [11.295134822043716, 1.4159464679159033],
            [11.280747102669226, 1.4145498133842647],
            [11.27915060785714, 1.4293691519037228],
            [11.264636125611553, 1.427806252321941],
            [11.2614601930478, 1.4635460389767045],
            [11.251528854019577, 1.5605913779915332]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.49530518634013, "lat": 39.45530890048793 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39167"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "01074095"
      },
      "bbox": [
        11.251528854019577, 1.3403089496566218, 11.846749983503027,
        1.8004684032316849
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.4256329227691469, -2.5575189894401564],
            [1.5134641405386404, -2.556488094213856],
            [1.613246050815706, -2.5546724724678302],
            [1.622692738101908, -2.614798626450414],
            [1.6264974173546083, -2.6387872476376453],
            [1.6380974881825097, -2.7148404817805507],
            [1.639155516154136, -2.720746653683279],
            [1.6489439673719268, -2.7836624342420024],
            [1.6535344455397527, -2.8162385423101832],
            [1.6623984164195598, -2.872516789044701],
            [1.6695909890927736, -2.921786401771558],
            [1.6755800797400222, -2.9596545901132965],
            [1.6804208083534258, -2.992937378695506],
            [1.6938571332343273, -3.0809955004021408],
            [1.6696337929829363, -3.0815849771844888],
            [1.5953316001792157, -3.0827430729556964],
            [1.5098151361670398, -3.0839074093275816],
            [1.4239786721629069, -3.084861430824028],
            [1.422568040278895, -2.9610478488167127],
            [1.4225941093471848, -2.953202333048396],
            [1.4208990423780161, -2.820463184467071],
            [1.428970569730032, -2.8203626071092867],
            [1.427979502604583, -2.74472866309676],
            [1.4271251760472974, -2.674124323080702],
            [1.4256329227691469, -2.5575189894401564]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.65872628398428,
          "lat": 35.883943483880046
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40001"],
        "coty_name": ["Adair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adair County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01101788"
      },
      "bbox": [
        1.4208990423780161, -3.084861430824028, 1.6938571332343273,
        -2.5546724724678302
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.6449050949896307, -4.581630404259507],
            [0.7274744344215818, -4.5813526151399975],
            [0.8167036484008924, -4.580957001944401],
            [0.884448853866991, -4.580562013122476],
            [0.9709386132935215, -4.580022366754104],
            [1.060442660795493, -4.579339141843747],
            [1.1563506005578161, -4.578509252180204],
            [1.15702709120002, -4.652271741841989],
            [1.1580022465680302, -4.7609442543556],
            [1.1580876227337347, -4.793460033952166],
            [1.1588410238677964, -4.799502786458437],
            [1.1526254605500914, -4.795577415369601],
            [1.1461845526899248, -4.789961940644842],
            [1.1347847237056266, -4.787025000617587],
            [1.122906079995465, -4.7826636673416205],
            [1.1201933058269864, -4.779740518859506],
            [1.1106643393070303, -4.77456337161004],
            [1.1005769374623273, -4.77483460687248],
            [1.0971009089249049, -4.777026472218981],
            [1.0973478298943946, -4.781071808733538],
            [1.0953371035310158, -4.7871443628238355],
            [1.0896994146268948, -4.789391335226905],
            [1.0847082080601782, -4.793242214057108],
            [1.0811896379684023, -4.798540986630514],
            [1.0828983989282537, -4.816907304303858],
            [1.0818263168962772, -4.834419232180069],
            [1.0794627341203316, -4.842991966321937],
            [1.0730046517423975, -4.849651799318069],
            [1.0701669189659557, -4.847558598621005],
            [1.068580737317505, -4.8419280299458585],
            [1.0690484546077226, -4.831696718841737],
            [1.0682751439470888, -4.82747919534968],
            [1.0645153347737668, -4.825764218247866],
            [1.0580155267598161, -4.827137825922147],
            [1.0544089782254267, -4.829964949191867],
            [1.0522895734575095, -4.83404166423455],
            [1.0533860098979926, -4.838168500823524],
            [1.0566567369737638, -4.840640564680961],
            [1.0587138571661994, -4.849903829981801],
            [1.058105831728225, -4.859547395079921],
            [1.0563490147838748, -4.8620732545305865],
            [1.0494603168176742, -4.864433685169351],
            [1.0358594871690048, -4.862825336963232],
            [1.0320369449835516, -4.860279717318423],
            [1.0286911645229897, -4.856024001340165],
            [1.0187643577280017, -4.851639643137274],
            [1.0159467335918484, -4.8521885204013175],
            [1.014251585410898, -4.858016689326687],
            [1.0118930828554848, -4.860962357126639],
            [1.0048612520371767, -4.865316474128243],
            [0.9940717064288304, -4.868562048344943],
            [0.9891653551788738, -4.871406646727401],
            [0.9786737389255086, -4.869807746076302],
            [0.9709202250105494, -4.86967545591057],
            [0.9641992052804544, -4.871040533098005],
            [0.9565930141381052, -4.874019663110452],
            [0.9357365137477759, -4.8678658758642985],
            [0.924539255396077, -4.871964566046797],
            [0.9099733201091335, -4.866779645326378],
            [0.9068621259561972, -4.866797243634709],
            [0.9053731966746351, -4.862347693252294],
            [0.9091575068356121, -4.852074209191161],
            [0.9036675720013371, -4.851882275608323],
            [0.8983965929103106, -4.858152453999689],
            [0.8885411184799397, -4.862663302236457],
            [0.8779372792017324, -4.8642798148908195],
            [0.8739084702017467, -4.8639004184332695],
            [0.8711519194210795, -4.861418265485555],
            [0.8720328543051048, -4.854950054814719],
            [0.8714246610323524, -4.843586617239304],
            [0.8668369795041685, -4.8407131180031575],
            [0.8591367890497014, -4.8493332375151725],
            [0.8483460619012149, -4.857585125074952],
            [0.8429900378293788, -4.858873961028527],
            [0.8385323899891789, -4.858503850474431],
            [0.8359429694802336, -4.8560567782985045],
            [0.8337516734731167, -4.845779735406879],
            [0.8357456568146711, -4.841980742557393],
            [0.8356893394411742, -4.830168322299354],
            [0.8323430142409641, -4.818816788092043],
            [0.8306585635074698, -4.810577320990991],
            [0.822956246201888, -4.805709606040126],
            [0.8088743500200694, -4.804881227206416],
            [0.8017098196247618, -4.797110513154844],
            [0.7958575094441263, -4.796689711449365],
            [0.7942463267518003, -4.804721262601248],
            [0.7900612151391767, -4.809642081104669],
            [0.7832983677818812, -4.810115637962671],
            [0.7796463579544116, -4.811467665892536],
            [0.7747644143516104, -4.8206259390794015],
            [0.7711477721309756, -4.831115933387356],
            [0.7667699206977753, -4.834030160636254],
            [0.7601851944208948, -4.834055278378744],
            [0.7523111946546496, -4.831633097770021],
            [0.7506587128718003, -4.829856236353833],
            [0.7437053870181874, -4.828989860411441],
            [0.7393203386730985, -4.83011968621885],
            [0.7356144506972654, -4.8332787854585275],
            [0.729920961974138, -4.841938618183405],
            [0.7234306491181626, -4.8489923216129185],
            [0.7126902213009338, -4.853164894388218],
            [0.7022657335872055, -4.854311472508205],
            [0.6993361031878343, -4.853428907566999],
            [0.6958483094266734, -4.849650808568429],
            [0.6837569824862416, -4.843444661280659],
            [0.6730910819891269, -4.8430280855882355],
            [0.6644809209527432, -4.84676279594522],
            [0.6599321201269965, -4.856032652713381],
            [0.6594249991820489, -4.865103347671422],
            [0.6603427542087081, -4.866287930052319],
            [0.6569328854954769, -4.868473226526898],
            [0.6534142444974856, -4.868045145742157],
            [0.6490330471536006, -4.864970932436828],
            [0.6438628085515155, -4.8712295373707075],
            [0.6394925919065808, -4.865988607771956],
            [0.6310084230215847, -4.865830449548952],
            [0.6243781610252108, -4.8694498955576355],
            [0.6168331479758744, -4.8667306265427195],
            [0.6099927463755248, -4.865917527137985],
            [0.6053479752571581, -4.866451015690302],
            [0.6016132337225085, -4.86384175857822],
            [0.5981551796852493, -4.866228755261548],
            [0.5942485906602484, -4.864197629848127],
            [0.593337717037512, -4.861591256331674],
            [0.5862964800890266, -4.858387344133446],
            [0.5841939182085346, -4.854418478414168],
            [0.578148859853153, -4.85218094270563],
            [0.5741041610946931, -4.843100944402735],
            [0.5731619739583301, -4.835723858232009],
            [0.563741744510043, -4.823728887214572],
            [0.5572888462668565, -4.823727800561246],
            [0.5565376567595602, -4.820981996865062],
            [0.5488887915680618, -4.817761059885577],
            [0.5451455079067388, -4.8194957832982475],
            [0.5414965118237741, -4.8168290535900935],
            [0.5383436337815658, -4.817669381906248],
            [0.5305582924144477, -4.814432707927796],
            [0.5274354424471921, -4.810717734516285],
            [0.5281718028156632, -4.807838830539192],
            [0.5245386185099452, -4.804995528484451],
            [0.522293965368211, -4.799807762419243],
            [0.5164850854211452, -4.796988712484685],
            [0.514797393913531, -4.791190827961084],
            [0.5146042610691569, -4.6707307846216075],
            [0.514447108390157, -4.669262600255039],
            [0.514510741232851, -4.613070947423267],
            [0.5097815596757529, -4.6145835442035015],
            [0.5049903680473384, -4.609494681862887],
            [0.5042133153435823, -4.596920164418141],
            [0.4998675891355981, -4.589450878960199],
            [0.4946437304360538, -4.58733963895184],
            [0.4926321317991333, -4.5883067410255025],
            [0.4858256336358012, -4.584540040318742],
            [0.47630731656526515, -4.584247824112577],
            [0.4706557700238134, -4.581733216454636],
            [0.5302383190258454, -4.581776603377871],
            [0.6449050949896307, -4.581630404259507]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.55221000722443, "lat": 34.02661856985639 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40023"],
        "coty_name": ["Choctaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Choctaw County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01101799"
      },
      "bbox": [
        0.4706557700238134, -4.874019663110452, 1.1588410238677964,
        -4.578509252180204
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.692355272083685, -3.639380622974387],
            [-2.60676611969042, -3.6426060311023787],
            [-2.603101379668157, -3.5552779648404567],
            [-2.545331156442529, -3.5575734981602585],
            [-2.4224419064631832, -3.5624427720082337],
            [-2.420349902554869, -3.5622731605313227],
            [-2.3678067569213326, -3.5642037935133417],
            [-2.325726088863359, -3.5658853513926],
            [-2.328614304259263, -3.569820406438256],
            [-2.3259708492010662, -3.573391352671779],
            [-2.3181137294526732, -3.5748635982829957],
            [-2.312456477919069, -3.5691854170070183],
            [-2.3059982193706343, -3.5717252742656886],
            [-2.300563506827968, -3.569156979395025],
            [-2.298784852982892, -3.5730465318104496],
            [-2.2928019201837526, -3.577115478759022],
            [-2.2918247678332166, -3.58137304865492],
            [-2.2946964378590935, -3.584475754372449],
            [-2.2914665465082114, -3.5864616680493864],
            [-2.29229243632506, -3.5899154367388078],
            [-2.284583523284734, -3.5956618460597563],
            [-2.2819964732279296, -3.5910488542413423],
            [-2.274782922676688, -3.5929932790240655],
            [-2.274375893437599, -3.5967910622457584],
            [-2.2682079862434636, -3.5983220274226775],
            [-2.2699572459599837, -3.605786398229334],
            [-2.2690219969672687, -3.6127342768314854],
            [-2.266584806896351, -3.6198106971529973],
            [-2.266491795163674, -3.6236192817273642],
            [-2.272804122045029, -3.624765718956628],
            [-2.2708708961282604, -3.6325202327582007],
            [-2.2649549253040275, -3.634459804395472],
            [-2.2604317352614935, -3.634499586574516],
            [-2.256450477960176, -3.6328682194966766],
            [-2.2546666278251544, -3.6349494352363183],
            [-2.255190100619115, -3.642087078811077],
            [-2.2490077482541793, -3.6449794592510236],
            [-2.2416338627948487, -3.6457154092962742],
            [-2.237077845646128, -3.644743757234363],
            [-2.2337827037352436, -3.6480858229308275],
            [-2.2350212812350216, -3.6559104438499928],
            [-2.2442573560812917, -3.6607862011319092],
            [-2.2430652232569344, -3.6638272148202295],
            [-2.2391396334030955, -3.6639495011152374],
            [-2.237045641979287, -3.6676926735233017],
            [-2.2389534846767836, -3.6747533390637477],
            [-2.242004744518757, -3.676210627562688],
            [-2.2456293487665744, -3.6888304810635817],
            [-2.2442458812525428, -3.695295037613324],
            [-2.244857231002811, -3.6980944192738416],
            [-2.2556245555072723, -3.7029209893314365],
            [-2.2527995263773306, -3.7152891297467416],
            [-2.2477985636398206, -3.713368991602584],
            [-2.244822656938349, -3.713890186030845],
            [-2.2411572200741006, -3.7348998378497966],
            [-2.242961452719132, -3.742159509977449],
            [-2.238022234815218, -3.745866611644861],
            [-2.23491418914715, -3.7455551750810647],
            [-2.226629024792687, -3.7549213793034744],
            [-2.2310177460052985, -3.759699653612588],
            [-2.2291368758217702, -3.7622794329813756],
            [-2.2173436340316237, -3.763889143652504],
            [-2.216672484160413, -3.7706949577668465],
            [-2.2115606430986032, -3.7828075081046397],
            [-2.210894221683945, -3.7859729951479606],
            [-2.216382503833957, -3.786993448659945],
            [-2.217391338194648, -3.791175283724124],
            [-2.2138087216937965, -3.792618256218184],
            [-2.2126003086341695, -3.801692490742594],
            [-2.217873093033831, -3.801445628336866],
            [-2.2251114243059984, -3.7988184502651348],
            [-2.2288074738683035, -3.7990585203844014],
            [-2.2328937050540407, -3.8020526622007615],
            [-2.235039238030996, -3.809727575285977],
            [-2.234543174235322, -3.8162308398086147],
            [-2.2297618990262738, -3.821839089045886],
            [-2.226036583207554, -3.8304779860810765],
            [-2.2183011549426803, -3.836996264160964],
            [-2.211339078424813, -3.8365241838567075],
            [-2.2068402768404187, -3.839862780586136],
            [-2.203675076036352, -3.8496335807283844],
            [-2.1972643583837654, -3.848127448941579],
            [-2.18599665127597, -3.853292528620342],
            [-2.181075754879799, -3.8608650128830653],
            [-2.1786627022134395, -3.8678653456261642],
            [-2.1789755107382724, -3.878045289576151],
            [-2.1821583693089694, -3.8771877506988632],
            [-2.2003292655871425, -3.8766569865153646],
            [-2.308643929648786, -3.872461958627119],
            [-2.310144412729705, -3.9167156693849052],
            [-2.3358709522275736, -3.9156825739641805],
            [-2.33564995570417, -3.9190749135319947],
            [-2.3388706260243435, -3.9232891916290944],
            [-2.337608986554456, -3.9367832820866506],
            [-2.338804086471202, -3.943650457734732],
            [-2.3368380597761687, -3.948532950250231],
            [-2.341333353669642, -3.952845840853583],
            [-2.3394527806575005, -3.95840061839174],
            [-2.333452477324159, -3.9545365033360786],
            [-2.32731799983795, -3.9576170349003665],
            [-2.325981322165437, -3.9604431981424795],
            [-2.43897762831792, -3.956250651862088],
            [-2.5244639351396287, -3.953522298609357],
            [-2.523569795122237, -3.924174448114584],
            [-2.5378728984989496, -3.923620265729503],
            [-2.537404351841681, -3.9089056846922494],
            [-2.565858803142713, -3.907725796649584],
            [-2.564835492147994, -3.8805941089360414],
            [-2.565026687200731, -3.876910673692735],
            [-2.5634089113797867, -3.844266530786373],
            [-2.5623713899134524, -3.8187016914100393],
            [-2.5713624673145086, -3.8183669971746723],
            [-2.5696915745957436, -3.7766194022942363],
            [-2.5697840067086415, -3.7746046914459783],
            [-2.5681032624390716, -3.7308082844343704],
            [-2.6957221730434258, -3.7258631480211193],
            [-2.692653523544437, -3.6532299250226603],
            [-2.692355272083685, -3.639380622974387]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.56077590831111,
          "lat": 34.935747242908796
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40055"],
        "coty_name": ["Greer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greer County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01101815"
      },
      "bbox": [
        -2.6957221730434258, -3.9604431981424795, -2.1786627022134395,
        -3.5552779648404567
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7011464549258046, -1.6495044572804936],
            [-2.695331825784767, -1.6498249089955592],
            [-2.6006624590703464, -1.6537170480155257],
            [-2.52068724735861, -1.6577665977570162],
            [-2.428624528047017, -1.6620122646401922],
            [-2.4215293404775027, -1.662883938948823],
            [-2.3365334204356825, -1.666130750521799],
            [-2.310808220887571, -1.6669985197214234],
            [-2.2694189719597917, -1.668703914386186],
            [-2.2669400925849947, -1.6727549702248568],
            [-2.2594562390310386, -1.6730850612643995],
            [-2.256890182098385, -1.6779821902342247],
            [-2.256669268967093, -1.6884498927778404],
            [-2.2529838088169143, -1.6989983257445516],
            [-2.2479446481588607, -1.7093932974986017],
            [-2.2489052915890735, -1.714023330921333],
            [-2.2477618676322604, -1.7185050295768425],
            [-2.243331635980724, -1.7285593908205377],
            [-2.2383742103010182, -1.734473684352823],
            [-2.2315580463561067, -1.7451328666589574],
            [-2.2262973339661647, -1.7489616440077513],
            [-2.2225856532843493, -1.7579939845991046],
            [-2.2180648045871796, -1.765074605221572],
            [-2.219275181746809, -1.769368676901511],
            [-2.2159865075651672, -1.7800738039400665],
            [-2.2114467483246156, -1.7854327756045119],
            [-2.2089089806500515, -1.791935174618872],
            [-2.201925407898698, -1.7942306317431558],
            [-2.1950829590541243, -1.8000809576494434],
            [-2.190168143916991, -1.8020547941695881],
            [-2.1746867906093073, -1.8099298023625634],
            [-2.168441208636039, -1.8159625867103844],
            [-2.162282980625287, -1.8172105487265193],
            [-2.161677914877514, -1.8195278298468816],
            [-2.1656352475311595, -1.8233247958807088],
            [-2.16525111236482, -1.831102173684882],
            [-2.160235927722083, -1.838965204941704],
            [-2.158605334309391, -1.844913777501807],
            [-2.151370731345519, -1.8501865985008996],
            [-2.148435688918129, -1.8546736199317766],
            [-2.149897247066722, -1.9023260303920653],
            [-2.153435753695104, -1.9938737675866571],
            [-2.1563653010793877, -2.079654049013191],
            [-2.160059095834649, -2.0810048389308866],
            [-2.271411873134326, -2.078134724179565],
            [-2.2786852150362784, -2.0777318637398716],
            [-2.4030687129312542, -2.073244696082739],
            [-2.403107537458013, -2.0744345768771377],
            [-2.457479583416592, -2.0718690367899693],
            [-2.587615961219601, -2.0666714158723747],
            [-2.7189826164720228, -2.0612914194458156],
            [-2.7117931237436728, -1.877542769103933],
            [-2.703640888564548, -1.7076799829989504],
            [-2.7014835832808046, -1.6540461292842479],
            [-2.7011464549258046, -1.6495044572804936]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.66731777476241, "lat": 36.78877458080338 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40059"],
        "coty_name": ["Harper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harper County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01101817"
      },
      "bbox": [
        -2.7189826164720228, -2.0810048389308866, -2.148435688918129,
        -1.6495044572804936
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6986030043471924, -2.118961545642294],
            [-0.6135836430674753, -2.11998632379851],
            [-0.5564821125785281, -2.1208164909534135],
            [-0.5277661662273918, -2.121071271864775],
            [-0.42920527014658405, -2.122236588912034],
            [-0.3772968755267187, -2.1229799329518566],
            [-0.37598067570755717, -2.124417141901216],
            [-0.36013411356815245, -2.130894128868995],
            [-0.3350606074787418, -2.134815320267125],
            [-0.32592567960678637, -2.1325281912409553],
            [-0.31616365582371153, -2.1316175352064923],
            [-0.31240957268146463, -2.1324148464864083],
            [-0.2907123710985477, -2.127802707522664],
            [-0.2850499715519918, -2.123768851509075],
            [-0.278806065160434, -2.1223261205081325],
            [-0.27297374076355857, -2.1182920067359796],
            [-0.2682319807418759, -2.1172625431829615],
            [-0.26209714790077565, -2.1190509525591477],
            [-0.25891027856018284, -2.1222666078587165],
            [-0.2555931822968319, -2.1292072233408286],
            [-0.242873528510941, -2.142799893294461],
            [-0.2435051265824993, -2.1520595679558787],
            [-0.24462866329104213, -2.1548749198253105],
            [-0.25165878223949295, -2.1652818587029175],
            [-0.2545113826320524, -2.1671071125377224],
            [-0.2625061042111177, -2.1654953232384653],
            [-0.2720585054249657, -2.165758171749304],
            [-0.28301329549563464, -2.171433681495629],
            [-0.28748321543792255, -2.17477619069229],
            [-0.2922636097305453, -2.180951216095675],
            [-0.2991470861409725, -2.1839026563093675],
            [-0.30334286263875637, -2.1840105733721624],
            [-0.30944618367026583, -2.182135571401914],
            [-0.31541486932490403, -2.1828249568671536],
            [-0.32918633711697026, -2.1889691184907485],
            [-0.3334437597108435, -2.19239786732551],
            [-0.33850694061539527, -2.1996272154225474],
            [-0.3402401998362652, -2.2110913587893823],
            [-0.3580205684047795, -2.2108783039350404],
            [-0.35894604274486297, -2.298232619008512],
            [-0.35991405881898686, -2.385976152037545],
            [-0.27439187150121974, -2.3868659993290975],
            [-0.275232085712904, -2.4730414255626063],
            [-0.27535147394638787, -2.4744703278398106],
            [-0.3468301641670086, -2.473749698180849],
            [-0.44783873767005417, -2.4726365872267544],
            [-0.44865543367165006, -2.560569978207751],
            [-0.540622112060593, -2.5593048091143986],
            [-0.6193922829460533, -2.5584915891912727],
            [-0.6191682894012879, -2.553218543905634],
            [-0.7046165490392404, -2.5517950838513728],
            [-0.7031481153062142, -2.470532277600012],
            [-0.7037371382127287, -2.4691888791469734],
            [-0.7020243405663751, -2.367642678583562],
            [-0.7010008172780344, -2.2948539463990585],
            [-0.7002342195881425, -2.2292454258037226],
            [-0.6986030043471924, -2.118961545642294]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.23049235248311,
          "lat": 36.388614428261526
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40103"],
        "coty_name": ["Noble"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Noble County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01101839"
      },
      "bbox": [
        -0.7046165490392404, -2.560569978207751, -0.242873528510941,
        -2.1172625431829615
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.301615725541687, -1.5736760782677106],
            [-4.228175200459979, -1.5778722136527925],
            [-4.142351388907685, -1.5826788533668863],
            [-4.056812881998866, -1.5873713366403288],
            [-3.9890795311144016, -1.5910177301599422],
            [-3.928055808477083, -1.594144989848795],
            [-3.8728184870842006, -1.597156342248768],
            [-3.8172646483892243, -1.5999853775330177],
            [-3.7131374503481855, -1.6051390100261942],
            [-3.656466579138274, -1.6078097687140518],
            [-3.5418690028397304, -1.613202995717289],
            [-3.499352188212645, -1.61520190363783],
            [-3.4462940808618296, -1.6180061779290753],
            [-3.4542097491347046, -1.7686776319044004],
            [-3.4608371131070736, -1.7688062836714107],
            [-3.465532763008632, -1.856013287456799],
            [-3.4705255832041604, -1.9474848893010845],
            [-3.4793788132645966, -2.1200423669765174],
            [-3.557519080947953, -2.115964194383954],
            [-3.5835679461437127, -2.114896881134512],
            [-3.678687899865295, -2.109682525927513],
            [-3.8075231711016144, -2.1024285322893284],
            [-3.9793644408156594, -2.092410244753107],
            [-4.01187614454994, -2.090470723798738],
            [-4.071309857634084, -2.086948910818208],
            [-4.079745346913781, -2.0862261030269553],
            [-4.172942430513291, -2.080635739742341],
            [-4.255288181124038, -2.074658131690034],
            [-4.336416546021332, -2.069464138179698],
            [-4.323118974626819, -1.8645239127309858],
            [-4.319257563220053, -1.8059701077408654],
            [-4.313894999214296, -1.7184653665962097],
            [-4.310905397470378, -1.718472183889541],
            [-4.301615725541687, -1.5736760782677106]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.49011412068621,
          "lat": 36.74790540510157
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40139"],
        "coty_name": ["Texas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Texas County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01101857"
      },
      "bbox": [
        -4.336416546021332, -2.1200423669765174, -3.4462940808618296,
        -1.5736760782677106
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.058926407137232, 2.9005546949258045],
            [12.043367184572318, 2.9949151444975346],
            [12.02414436814603, 3.1117810272119137],
            [12.095393445224827, 3.124459513898092],
            [12.137533477952356, 3.1318252737142855],
            [12.198924845220665, 3.143188069103307],
            [12.250930224426563, 3.1524736395432154],
            [12.290242047499833, 3.159798060233354],
            [12.3012687366354, 3.10576907159151],
            [12.313245808900419, 3.050256087804767],
            [12.319529028983522, 3.0197489689292785],
            [12.328021845289426, 2.9809652091053938],
            [12.340636153382343, 2.9214676462158087],
            [12.336666654453474, 2.9189287709820464],
            [12.334196250298703, 2.914833946358586],
            [12.329635212031569, 2.9155774075710736],
            [12.326533546797776, 2.9115209126986654],
            [12.316982751410036, 2.913443838300958],
            [12.312862192730208, 2.90672872174069],
            [12.312797359210148, 2.899098431852922],
            [12.30764264021111, 2.89905843058446],
            [12.300959918473092, 2.8893936673175875],
            [12.298194292897472, 2.8884114818517572],
            [12.294602314567394, 2.880591118486483],
            [12.291056561540296, 2.8810211044057943],
            [12.285413124564279, 2.8709621680314132],
            [12.271286063884775, 2.851185719599331],
            [12.254724221171884, 2.828720805947828],
            [12.202956476777661, 2.759849897259037],
            [12.202981677173028, 2.7597029063245504],
            [12.17869870516648, 2.755368174320234],
            [12.146179568275734, 2.7504901443563297],
            [12.08533105647404, 2.7400575612784683],
            [12.062522439393513, 2.878260443120732],
            [12.058926407137232, 2.9005546949258045]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.34930299041677, "lat": 40.68227987431121 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42007"],
        "coty_name": ["Beaver"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beaver County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01214112"
      },
      "bbox": [
        12.02414436814603, 2.7400575612784683, 12.340636153382343,
        3.159798060233354
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.83985974464064, 4.229066116558844],
            [11.849256402547283, 4.235330883370703],
            [11.856646950620226, 4.241714614746438],
            [11.860310620078096, 4.242809818812764],
            [11.88161082533655, 4.256044572272479],
            [11.895262821793605, 4.267125199573045],
            [11.897270372824922, 4.26720864643969],
            [11.906904111701413, 4.273155904793479],
            [11.91913645464977, 4.278703079481743],
            [11.92897167503246, 4.285563544508774],
            [11.938043136850817, 4.292861179572682],
            [11.940691257914043, 4.293500904703917],
            [11.945117250003758, 4.29787388431482],
            [11.953534028643187, 4.300952672597736],
            [11.96772356465707, 4.3096404315857875],
            [11.97587380722319, 4.315599791459902],
            [11.991953235608236, 4.328291351941654],
            [11.993528965231526, 4.3308033272012985],
            [12.009432310978516, 4.341824067893681],
            [12.016089158353179, 4.348887037016031],
            [12.022430741423452, 4.354288585020598],
            [12.026541736667992, 4.360810052354276],
            [12.031597960249158, 4.3628186470067725],
            [12.043773965631463, 4.370414369186539],
            [12.049440008915303, 4.376518319358088],
            [12.055056827117367, 4.379326095721212],
            [12.061582521089603, 4.384996760163883],
            [12.075778776867718, 4.3991853870587745],
            [12.08036608060457, 4.404702160787482],
            [12.082864797019722, 4.4094351034384935],
            [12.085608176977422, 4.420020526513877],
            [12.08706485785377, 4.4325431246389115],
            [12.090508349784953, 4.445933664779162],
            [12.093930312368608, 4.453455704541054],
            [12.101026261957434, 4.46349936746949],
            [12.10976736392102, 4.470276982072577],
            [12.122095624669, 4.474793377428979],
            [12.127274182062697, 4.474176711801102],
            [12.134420929729774, 4.475464295627677],
            [12.132999563169555, 4.471544151176268],
            [12.127947195036349, 4.4692445446232],
            [12.128455451841415, 4.466855238149041],
            [12.13472737565119, 4.459939904268785],
            [12.13140467458511, 4.456444363251888],
            [12.135443323779887, 4.450799627653938],
            [12.138216466684412, 4.449939659184286],
            [12.14536287561194, 4.450598702972125],
            [12.17123971350531, 4.473110721550007],
            [12.175006806185998, 4.477455502826231],
            [12.177146082368436, 4.477774885337067],
            [12.194254736191418, 4.493395252682719],
            [12.194292326527199, 4.495703791538035],
            [12.202075601613636, 4.501471760958422],
            [12.229073071664441, 4.52779143358809],
            [12.234302405644732, 4.5295052251313015],
            [12.237873190998911, 4.53349273704836],
            [12.24933603445604, 4.541388370131761],
            [12.266916972389023, 4.559950090417994],
            [12.269370589104891, 4.558598431362512],
            [12.287019880054665, 4.5669523591694725],
            [12.293276342976155, 4.572366072661171],
            [12.295278608743798, 4.575666995306709],
            [12.304077429130503, 4.579144591220926],
            [12.30777986280503, 4.584599789946033],
            [12.311396696534965, 4.587426576144562],
            [12.323817771775218, 4.599172715850358],
            [12.326604177280691, 4.602808948417542],
            [12.330457580022353, 4.604815022021945],
            [12.333491600401993, 4.603898485027159],
            [12.34107876064715, 4.611228174705898],
            [12.34552149749032, 4.584694094908852],
            [12.359565954867294, 4.505242574709046],
            [12.364683105776251, 4.474106924056771],
            [12.367081129950476, 4.462033817217496],
            [12.384129310538132, 4.363130614057905],
            [12.387857959324206, 4.3434164872075876],
            [12.45415554271507, 4.355128126029702],
            [12.497319793512606, 4.362258053009725],
            [12.512873813036943, 4.271767251856565],
            [12.517910219793606, 4.239483823534021],
            [12.522112539738755, 4.214998591571107],
            [12.472160025640527, 4.207560574135577],
            [12.412752511565616, 4.196686357384051],
            [12.304966682423949, 4.178004701384814],
            [12.16974377149105, 4.154121005170634],
            [12.132810018722644, 4.14719045686993],
            [12.089017937728416, 4.1398568933225715],
            [12.044870302983618, 4.132918177638262],
            [11.941875323177591, 4.115829363001802],
            [11.860785011901875, 4.1025898494564075],
            [11.83985974464064, 4.229066116558844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.03271006316899, "lat": 41.99250462624992 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42049"],
        "coty_name": ["Erie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Erie County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01209178"
      },
      "bbox": [
        11.83985974464064, 4.1025898494564075, 12.522112539738755,
        4.611228174705898
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.439551943113322, 3.3888907813877895],
            [14.528399403634447, 3.3917113509788552],
            [14.54413190841723, 3.392828230118632],
            [14.544495411714696, 3.3964586354310677],
            [14.55070448427522, 3.40083287847793],
            [14.560826203354225, 3.4050251885849354],
            [14.567981875579061, 3.4098440415566675],
            [14.571406433165787, 3.4132017484395045],
            [14.579066627574301, 3.4109873682085166],
            [14.583081838131545, 3.4019793306503305],
            [14.586047530744978, 3.400344181000091],
            [14.589989454019648, 3.403381776690603],
            [14.592484758005615, 3.402959709816424],
            [14.604341801732806, 3.407775086395669],
            [14.606335649466907, 3.4065714563382836],
            [14.616179489897265, 3.4053861781655046],
            [14.62037075260192, 3.4074416178943348],
            [14.626208653394592, 3.412065899303797],
            [14.628903152482547, 3.409727422854484],
            [14.630661774554238, 3.401451658251176],
            [14.63365859556579, 3.398107952164869],
            [14.633140232711028, 3.3931300083915654],
            [14.637631385911686, 3.3895517791960494],
            [14.640294208471945, 3.3906042235658087],
            [14.641717078661214, 3.395846206457429],
            [14.644474140169738, 3.394979404594492],
            [14.647890556425496, 3.3984064910639153],
            [14.652302643731499, 3.3969848553084168],
            [14.654253745969353, 3.3885063672301907],
            [14.6583977351943, 3.383485362283277],
            [14.657508651854943, 3.3802677206066774],
            [14.660444420829371, 3.3768567432344776],
            [14.665557478644665, 3.3748714822731474],
            [14.670591624785944, 3.383917034911331],
            [14.678685227743854, 3.3873874597938003],
            [14.680495709322097, 3.3851188338450426],
            [14.68621004310251, 3.3846798139485306],
            [14.685308118844498, 3.3886324525930998],
            [14.689511503726454, 3.38988905749168],
            [14.700041595982423, 3.3965942215950564],
            [14.70500821952111, 3.393546435843424],
            [14.707192065586309, 3.3857358046673434],
            [14.702364679901779, 3.3745072576032413],
            [14.697301417318961, 3.373245227130433],
            [14.676374059587253, 3.3569353517726297],
            [14.668242137943365, 3.349870299123054],
            [14.652463198299587, 3.339843352229598],
            [14.645492046868931, 3.337599152459831],
            [14.638711659806937, 3.3370287117532667],
            [14.635130128854716, 3.3345595319275882],
            [14.619175847414507, 3.3271727510060796],
            [14.613413399917324, 3.325208479347266],
            [14.60649199144824, 3.3241948086787656],
            [14.600423266696705, 3.321148928083026],
            [14.59509699127777, 3.3196962529853304],
            [14.59315238956718, 3.316105291242479],
            [14.58422623325004, 3.314166949585014],
            [14.57784672650106, 3.3110115149059007],
            [14.562470221802446, 3.3050597358687055],
            [14.550826094967588, 3.3010317279099666],
            [14.539071076072029, 3.2943121159745252],
            [14.554910214279717, 3.2742404858192544],
            [14.551430001592486, 3.2716899429804185],
            [14.544104591671863, 3.2691859602400264],
            [14.533523266481026, 3.2625389010024133],
            [14.521791656616735, 3.252108918418729],
            [14.511709290990954, 3.244000281511052],
            [14.486800620122617, 3.225970480804193],
            [14.479204723849298, 3.2186416276563463],
            [14.472888020192741, 3.2156888921084406],
            [14.441579821207622, 3.1857178116511724],
            [14.407542653502913, 3.153954651746333],
            [14.392696299373066, 3.140347024696657],
            [14.3823580551708, 3.1320176709924685],
            [14.37756752331119, 3.1270520742443937],
            [14.371312147998832, 3.12233161241157],
            [14.350225948589827, 3.1026168948523405],
            [14.336300846797736, 3.0880147391283983],
            [14.330832792346232, 3.0814792867966028],
            [14.32555183289941, 3.076809832455612],
            [14.310890359380787, 3.061209947125404],
            [14.32124608386102, 3.0394084489701285],
            [14.31514713495488, 3.03775225489719],
            [14.298179984118324, 3.0260055581156893],
            [14.28749187303794, 3.013312222503535],
            [14.276889406775025, 3.0021039176721467],
            [14.268371499879455, 2.989683298898871],
            [14.256808415114858, 2.9744327952803187],
            [14.244089043173442, 2.953904893710102],
            [14.234542762861587, 2.9339516814666338],
            [14.232492219353023, 2.928289224445267],
            [14.22721081997562, 2.918641051951579],
            [14.21900838597098, 2.906233736633067],
            [14.216407257384752, 2.903469729259752],
            [14.172950317999899, 2.982938637769564],
            [14.157830739123474, 3.0100970261544444],
            [14.165302864883888, 3.0267020423080844],
            [14.175174049289653, 3.0453583178317527],
            [14.185882369360707, 3.0619625605640963],
            [14.189745963833808, 3.0670829549949783],
            [14.206684638771286, 3.0938057472119285],
            [14.219087888652128, 3.114227987995732],
            [14.231093805098919, 3.1315333197164956],
            [14.239537494967097, 3.141357781495864],
            [14.234987759397752, 3.164349972426213],
            [14.244987850929888, 3.1770860837453507],
            [14.263534507822396, 3.198288193308112],
            [14.268109995307055, 3.2024835476324096],
            [14.285367257247712, 3.2207119145642906],
            [14.295833624663995, 3.233129307157637],
            [14.297291361735248, 3.2370024724179696],
            [14.306849417696, 3.2477899168250888],
            [14.301248208062844, 3.275165175562118],
            [14.30648018282716, 3.2820870058689704],
            [14.336641841745267, 3.3104924253378893],
            [14.351477292233806, 3.3224842407229755],
            [14.35956103993652, 3.3305231826237893],
            [14.374959738007698, 3.343252574094107],
            [14.388623816438358, 3.3532358321082936],
            [14.39364850390945, 3.3575780372724475],
            [14.401556859490569, 3.3627589339150843],
            [14.415736287069722, 3.3733600625985805],
            [14.439551943113322, 3.3888907813877895]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.40226087300742, "lat": 40.53100637923527 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42067"],
        "coty_name": ["Juniata"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Juniata County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01209180"
      },
      "bbox": [
        14.157830739123474, 2.903469729259752, 14.707192065586309,
        3.4132017484395045
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.150572399815161, -3.3205884599123228],
            [12.15422654567513, -3.3262949955993366],
            [12.16150180667918, -3.3253629573350545],
            [12.164687234146637, -3.3280893243436767],
            [12.172659920166469, -3.3257837029420503],
            [12.174438762476594, -3.332964001813055],
            [12.177976428986913, -3.336680776767797],
            [12.186724300898259, -3.336264420180821],
            [12.195538514950725, -3.343656717993069],
            [12.20071471186967, -3.3504660099050163],
            [12.209048590375408, -3.3517170382516945],
            [12.212459606337287, -3.3547248892905546],
            [12.221875444196987, -3.3598756052875287],
            [12.223159524277762, -3.3615658685272467],
            [12.232497361112888, -3.3659974084833246],
            [12.234377592442948, -3.3723140641670506],
            [12.231112489845058, -3.379301342793113],
            [12.233141210830619, -3.380664831597888],
            [12.238043849827648, -3.3794355592247403],
            [12.240454211833121, -3.381375762354859],
            [12.235948863410629, -3.385405092002001],
            [12.237689558787336, -3.390222919849484],
            [12.242451578154048, -3.3932265760304627],
            [12.245872517101082, -3.3926257466362837],
            [12.247412001843086, -3.396042832341227],
            [12.2696358563146, -3.3648702073519514],
            [12.285621085185543, -3.3443920922384227],
            [12.293752755724801, -3.3428784187534597],
            [12.298093216743919, -3.338166367192515],
            [12.307035277128579, -3.3441838782606186],
            [12.311807090018826, -3.3401194045313614],
            [12.318018206790496, -3.3414557654645134],
            [12.317977820367123, -3.3345813730821745],
            [12.32088343610255, -3.331919748315933],
            [12.324329117099508, -3.33206571816746],
            [12.326629664017073, -3.3356314969289325],
            [12.330754767082274, -3.3317101156710636],
            [12.334566747151836, -3.3323989283259245],
            [12.337079752568082, -3.344395995867937],
            [12.3427260547768, -3.3462759102712756],
            [12.346127983610415, -3.35237577771994],
            [12.34703350950965, -3.3573916313794885],
            [12.345590522577368, -3.3635897992335586],
            [12.342506626639, -3.3697875528947807],
            [12.342429873627516, -3.372482520091845],
            [12.347956805137565, -3.380444391213588],
            [12.35022734236845, -3.386239952086494],
            [12.35463061315627, -3.3930165072511933],
            [12.355625971777698, -3.397360289095753],
            [12.359225543408986, -3.402606084467063],
            [12.360620203411155, -3.4097268388130826],
            [12.36941756008963, -3.4221690064909702],
            [12.371210480751191, -3.430383501887181],
            [12.374062182133583, -3.4355374885204273],
            [12.381246115336603, -3.4413927903918173],
            [12.38413710501167, -3.4461534514830383],
            [12.386968868033978, -3.4538177735912194],
            [12.391423184825255, -3.4583148533999704],
            [12.398652864264143, -3.469093520257669],
            [12.400229063628398, -3.4735226399989183],
            [12.400095819210787, -3.47875604349409],
            [12.406292569166013, -3.488251202980943],
            [12.406489812394058, -3.492905923848846],
            [12.411615521008853, -3.500266657378282],
            [12.414923201381331, -3.507178894659305],
            [12.420142868814919, -3.514142733634989],
            [12.429371942857747, -3.5174973038401682],
            [12.433735909556797, -3.5251703375021632],
            [12.431122493296847, -3.5329516180382092],
            [12.431327398682882, -3.5398617762037405],
            [12.435180312337513, -3.548414962550445],
            [12.441830967270548, -3.5520381618210757],
            [12.447990656576714, -3.5565107975395427],
            [12.454088400152004, -3.566797290406131],
            [12.460008926562905, -3.5725237695109016],
            [12.452256941908407, -3.5860689803320316],
            [12.442305048677314, -3.6103179825143306],
            [12.448620513935708, -3.616914123386008],
            [12.437902043663323, -3.6194906871871053],
            [12.432752597795838, -3.6280486927132527],
            [12.422452504469302, -3.6398787029750665],
            [12.412763599478104, -3.643674873402822],
            [12.399177704230254, -3.6446309304502953],
            [12.37936891005721, -3.6964445638455117],
            [12.380895598079587, -3.697291928318685],
            [12.384742670591816, -3.704477940479897],
            [12.389606070624284, -3.707685202523236],
            [12.3947966943868, -3.7087893533364515],
            [12.394629615675385, -3.7143972757958124],
            [12.398782649220767, -3.7139528552731904],
            [12.407694609723299, -3.7242572422480777],
            [12.41184571056962, -3.724058748906904],
            [12.412071073998064, -3.7277684133757893],
            [12.41501323476702, -3.7297243947752303],
            [12.418752401192902, -3.7351214610032764],
            [12.421021174522249, -3.7356458795199337],
            [12.426905343738873, -3.740609276895757],
            [12.425990103806953, -3.7449144174881184],
            [12.4233585442172, -3.7490961110866317],
            [12.41636969913402, -3.750894354621701],
            [12.414803981472284, -3.749482819127618],
            [12.406174731440052, -3.7490590347965176],
            [12.401023663005216, -3.7440412199600965],
            [12.396674489799194, -3.7413881146056025],
            [12.392161824605763, -3.7417482464715506],
            [12.384209393661553, -3.748165815776569],
            [12.381284153535189, -3.749138356378668],
            [12.367918998979587, -3.744650866714864],
            [12.362746876772311, -3.7421562424688455],
            [12.361007925941554, -3.745639612186426],
            [12.361026672888126, -3.75093112715864],
            [12.359312100304258, -3.7538744517644056],
            [12.354722426365342, -3.7530742013754717],
            [12.350225600482501, -3.749828998201861],
            [12.345908063714239, -3.7533355793414978],
            [12.334937887252375, -3.7603357212273343],
            [12.32865442499344, -3.758174241968472],
            [12.324416463580324, -3.7534312721896685],
            [12.320498922676697, -3.7549065042873315],
            [12.311059144590558, -3.754826420941648],
            [12.304143736650033, -3.757053683939465],
            [12.300955207268373, -3.7550268656716397],
            [12.297298682438244, -3.7486851258764813],
            [12.29445558302038, -3.7461647721604407],
            [12.289871269541006, -3.746695722853014],
            [12.281553868153278, -3.7426891318768583],
            [12.275039881351915, -3.7432220210795473],
            [12.261699575645999, -3.7331179586472016],
            [12.257555205025438, -3.7280900507952284],
            [12.252744371638808, -3.7275549155262726],
            [12.250520108928391, -3.733331912963782],
            [12.247464469451002, -3.7321231079487838],
            [12.245150089543092, -3.7268433350570924],
            [12.240903478479993, -3.724191204510345],
            [12.231765124572982, -3.7243766909656686],
            [12.227189441511516, -3.7209795237711125],
            [12.219941647744815, -3.7089911634216355],
            [12.214690176303067, -3.70514677789737],
            [12.206223058987813, -3.706576418316573],
            [12.199804316902153, -3.705165534303711],
            [12.194986170400577, -3.701914360039741],
            [12.184210666297005, -3.69977571674446],
            [12.179874929397885, -3.693093891774446],
            [12.173300159801192, -3.690517623291477],
            [12.166362369729196, -3.685254515147011],
            [12.162003676784087, -3.684789220379621],
            [12.159227308884283, -3.686283430638869],
            [12.152095166734263, -3.6871728992069035],
            [12.143820591589849, -3.6849377738662605],
            [12.136394962886724, -3.678183682578755],
            [12.131592487388897, -3.675588808136793],
            [12.126748884953447, -3.6783032019347854],
            [12.12285633423666, -3.6855067151822003],
            [12.118921418564424, -3.6881962880100185],
            [12.115029634418569, -3.6881604638602634],
            [12.107892734106889, -3.693049706880906],
            [12.101674060665486, -3.694092821179102],
            [12.10064597657954, -3.7016342542370118],
            [12.096739282347642, -3.704178821179238],
            [12.091183256029714, -3.6968641837488785],
            [12.087616631257072, -3.698047278078948],
            [12.084041419822402, -3.701358018578472],
            [12.078377858643549, -3.699044083640774],
            [12.069142453943865, -3.6974297181639275],
            [12.059017182362679, -3.701946782703118],
            [12.054800943713186, -3.701369779526643],
            [12.053564728611747, -3.698396463984118],
            [12.049762322408219, -3.6976768478410547],
            [12.046806460891698, -3.704030089488728],
            [12.043791288761875, -3.7035390068726164],
            [12.0338869039913, -3.697932778637548],
            [12.028152508197664, -3.6995116384529685],
            [12.02443231091778, -3.707513543142164],
            [12.017059101085273, -3.7129035150812393],
            [12.018158936031366, -3.7188290472591863],
            [12.0166959683608, -3.7242750675671625],
            [12.0192063447206, -3.724836559929703],
            [12.024078646828258, -3.729992852450768],
            [12.023263538890088, -3.734372029856968],
            [12.02889504163483, -3.7384953931658185],
            [12.029102242327607, -3.74256413829896],
            [12.026999556178922, -3.7444412244164775],
            [12.020801379950605, -3.7438380838435505],
            [12.014950523238005, -3.7388369426496917],
            [12.005581768006717, -3.737651620830313],
            [12.002323964446965, -3.73566584699991],
            [12.000680661396778, -3.7269288009995165],
            [11.992496500041726, -3.7226005150250043],
            [11.991711945332796, -3.716882141257476],
            [11.993460156216853, -3.7113535040226706],
            [11.992951337725502, -3.7077830830954874],
            [11.9896225363359, -3.705607124134079],
            [11.982703890592019, -3.7087275592900224],
            [11.979327758514673, -3.702469709517429],
            [11.97687611883909, -3.700194147705598],
            [11.978645442995349, -3.695360098456307],
            [11.971973829712205, -3.6911331028604244],
            [11.962021278505707, -3.6930114904310964],
            [11.956059302999568, -3.6860859044662706],
            [11.957732776461807, -3.6803005602556644],
            [11.9625992829894, -3.6726673674792134],
            [11.96844259610708, -3.6673917436230252],
            [11.969174781536484, -3.6559200537079284],
            [11.976957219216256, -3.639049235138098],
            [11.97730278614837, -3.6295938255001152],
            [11.98104618391775, -3.6212109890470305],
            [11.979317905571971, -3.6111124079849515],
            [11.98221954862934, -3.587917792424055],
            [11.981882763628104, -3.583240578833173],
            [11.987055321535218, -3.578045162015724],
            [11.99010640634302, -3.5703496182343746],
            [11.999575906363502, -3.5684760799001376],
            [12.002010235110385, -3.5640688956786235],
            [12.00721854190944, -3.5641495502127682],
            [12.013489867042233, -3.5561548183535554],
            [12.016426489162491, -3.554651196512672],
            [12.013879069395832, -3.5493604479115204],
            [12.013919639425572, -3.545407461212071],
            [12.01774784599718, -3.5426461375580365],
            [12.022946234977539, -3.534064878371761],
            [12.026434546932528, -3.5314118576046534],
            [12.0331976410417, -3.528399772476177],
            [12.041563954059175, -3.52643739289881],
            [12.046343054929178, -3.522637287711976],
            [12.052799040704858, -3.5149110446741365],
            [12.06353175948846, -3.505300479029563],
            [12.06478425973223, -3.5024341460585053],
            [12.063707152586229, -3.4970236237993992],
            [12.064875760168752, -3.4910594351198805],
            [12.067192011721021, -3.485563402403078],
            [12.073110320217914, -3.4770827214156785],
            [12.075123310599091, -3.470015965177417],
            [12.07854517545801, -3.4689834446060996],
            [12.080242662633408, -3.463743603473069],
            [12.079960402187623, -3.459240665536027],
            [12.085628431386338, -3.452035227944395],
            [12.083799920039366, -3.4467904950598434],
            [12.089877850975837, -3.4362141798313797],
            [12.092243908523677, -3.429550616577323],
            [12.091589751117024, -3.4271499732854203],
            [12.0983047738936, -3.4183841735920413],
            [12.09946917847414, -3.4138239553017287],
            [12.105995204832986, -3.4131622955984247],
            [12.10995668667755, -3.409346213433349],
            [12.114288533817945, -3.4077647889468095],
            [12.11490442334907, -3.4050264372943415],
            [12.137736721035811, -3.3513635573063616],
            [12.14025547276253, -3.348899674867858],
            [12.14223084733567, -3.342549143744544],
            [12.14802163192632, -3.3372060419483778],
            [12.147707056662917, -3.3344910046382985],
            [12.150572399815161, -3.3205884599123228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.60014300443784, "lat": 34.28983414221209 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45071"],
        "coty_name": ["Newberry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newberry County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01248013"
      },
      "bbox": [
        11.956059302999568, -3.7603357212273343, 12.460008926562905,
        -3.3205884599123228
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [11.16719871684439, -3.377355839045088],
              [11.160129992542068, -3.387933995163373],
              [11.158286567237138, -3.3884390618549856],
              [11.15205508013595, -3.385028612339002],
              [11.155450937955735, -3.3759309291843884],
              [11.160927507359398, -3.3780203421987927],
              [11.16719871684439, -3.377355839045088]
            ]
          ],
          [
            [
              [11.064155512982786, -2.946928380308666],
              [11.131555518072078, -2.914428986633748],
              [11.148275425719776, -2.9057111857622524],
              [11.151878015212663, -2.9046218176247596],
              [11.158037408055595, -2.908084521988427],
              [11.157818105340674, -2.91265574271365],
              [11.155556795700596, -2.923212397781987],
              [11.159625212252534, -2.925363334304369],
              [11.16532962669671, -2.923209549984035],
              [11.169731184667723, -2.9198548817375456],
              [11.174535966265147, -2.9297864011513797],
              [11.184177632281173, -2.938749531545517],
              [11.189473183801729, -2.938310343399787],
              [11.193095637689508, -2.9364068189706],
              [11.194420093105808, -2.933218375259154],
              [11.199012973470067, -2.9329655422140437],
              [11.19950502927987, -2.9291583515086566],
              [11.203354482957355, -2.9282660039754105],
              [11.208053967485123, -2.9301622207082185],
              [11.210285538353226, -2.928042174321611],
              [11.210521527170458, -2.9235038019075197],
              [11.21549435422315, -2.919576215337037],
              [11.218964485843559, -2.9203445692369323],
              [11.23065712159138, -2.9166261527100596],
              [11.236616604183077, -2.916919105314058],
              [11.241732922971428, -2.913030386415683],
              [11.245378799623902, -2.915068827885533],
              [11.24936782734953, -2.911916280888934],
              [11.255982542612614, -2.909963673041836],
              [11.262096583442462, -2.912198285815087],
              [11.263541589344367, -2.91471658344055],
              [11.269442545248646, -2.913989817212134],
              [11.272244767642828, -2.90941354155763],
              [11.281498253685603, -2.907639055837589],
              [11.286146312070782, -2.9042598509906163],
              [11.291064792281402, -2.903544198166664],
              [11.29186615608498, -2.8984861610059918],
              [11.295945728255019, -2.899846441013396],
              [11.30905530840009, -2.8945103693691703],
              [11.32027374428995, -2.892909955100749],
              [11.325098886175248, -2.8957368932544134],
              [11.322774019212309, -2.9019103910175126],
              [11.32083910115425, -2.9014119102557347],
              [11.308469415696925, -2.9057617947564607],
              [11.305388286102724, -2.9148619075349633],
              [11.307683829851335, -2.9196610431448398],
              [11.306269718714152, -2.9230184753725816],
              [11.306378998705854, -2.9285232538772643],
              [11.313677761395134, -2.9258299155854792],
              [11.31378443704916, -2.929035818714478],
              [11.318136784394794, -2.9353242921075404],
              [11.315526160673949, -2.937557485667651],
              [11.31582831128691, -2.942893411784185],
              [11.317641837938567, -2.946966002456783],
              [11.313457905255296, -2.9526329079512603],
              [11.312728117081582, -2.9560091311467773],
              [11.315008514917153, -2.960706262787783],
              [11.32798838526898, -2.9572754304568507],
              [11.330846109067567, -2.953749398094976],
              [11.339164490487986, -2.9528930704083423],
              [11.344211878682467, -2.9492881317108695],
              [11.352239844356646, -2.9486801872948925],
              [11.359017417176604, -2.9467365655187177],
              [11.359346334888796, -2.948994184043419],
              [11.356308190425928, -2.958219185090026],
              [11.357461219949574, -2.9615497912552],
              [11.361122096435286, -2.964320834713678],
              [11.366212834689108, -2.974734126465747],
              [11.366523935834921, -2.9779291367073872],
              [11.361033166338286, -2.9801465582114526],
              [11.35604720025343, -2.9845461440427963],
              [11.360576789624048, -2.985751013699855],
              [11.365422343378443, -2.9899545498041054],
              [11.367915153245441, -2.98825559492582],
              [11.370027628973489, -2.9951096924817926],
              [11.37264906277803, -2.994327234385916],
              [11.375535232879729, -2.999710750665384],
              [11.375282176397459, -3.0070390807898675],
              [11.379454049199273, -3.0083133162644464],
              [11.378888508173873, -3.017314838199048],
              [11.379829398951117, -3.0210485490891275],
              [11.386965584173254, -3.0256822691202703],
              [11.385052241385374, -3.032671329859516],
              [11.38918725434834, -3.040372593804327],
              [11.394585737224388, -3.040848678112714],
              [11.395944673788211, -3.044519455172534],
              [11.400640335544697, -3.047031353441166],
              [11.403159054301662, -3.0541528918100336],
              [11.407271538026368, -3.058541169547299],
              [11.410484395841662, -3.0597149949002156],
              [11.41154210254121, -3.063697092053128],
              [11.409275949864544, -3.065852900323619],
              [11.410542035431776, -3.06946035178627],
              [11.418007096666079, -3.070996904014522],
              [11.415836073532642, -3.078095344203112],
              [11.41909930495502, -3.080250465422203],
              [11.421158498568927, -3.0895416420715276],
              [11.420283573174078, -3.0947284281637946],
              [11.425633513399406, -3.0974893898782634],
              [11.424584145538658, -3.1013502422004273],
              [11.426238523488571, -3.1112146223081445],
              [11.42308663921477, -3.114961851832651],
              [11.430209959037498, -3.1154479705818794],
              [11.425647092697622, -3.11898912866525],
              [11.426329329999062, -3.1252337091045153],
              [11.431564834563266, -3.1247913876843336],
              [11.435269181299022, -3.126635688579947],
              [11.43396887516427, -3.1302688886697507],
              [11.430685495223544, -3.1316131658657484],
              [11.42794879802897, -3.1367656878202954],
              [11.362271858416172, -3.1901943198225804],
              [11.253811286063884, -3.2781269873041143],
              [11.206128136494128, -3.316831745511583],
              [11.170641871129872, -3.3720063669401608],
              [11.165321005592727, -3.3758589431527946],
              [11.157875227349678, -3.3708526843450826],
              [11.16230638872936, -3.35918875065555],
              [11.171479801280517, -3.3584188947530436],
              [11.169325473597352, -3.348359151436572],
              [11.175966926185707, -3.3406257675432354],
              [11.174080160707588, -3.3400043084389583],
              [11.16937891298045, -3.343844644271659],
              [11.166507253114249, -3.3429067994882167],
              [11.166785595691485, -3.3381028396453014],
              [11.168879639119176, -3.336156979924279],
              [11.1619156021793, -3.3335210947719296],
              [11.160955255346693, -3.3290885512728368],
              [11.15527867414264, -3.3281948518250912],
              [11.152078747224937, -3.3192329683449873],
              [11.155062849701833, -3.3141778028115167],
              [11.151405174340432, -3.3124656184140493],
              [11.150249483172432, -3.3071300829052013],
              [11.15292628554228, -3.300684517138045],
              [11.144166304826296, -3.299790967862313],
              [11.139011220621256, -3.296240435250057],
              [11.142945223390608, -3.291732472336138],
              [11.142460298921343, -3.2864457976967785],
              [11.144419633421741, -3.2843045379883513],
              [11.142277262491918, -3.280762424108097],
              [11.14443222519304, -3.276530730795025],
              [11.14387579448587, -3.2721085969096353],
              [11.139217742707391, -3.266480677496174],
              [11.132663443124006, -3.2677750400273506],
              [11.128280253808791, -3.262753786659053],
              [11.12300751869612, -3.2624222213935363],
              [11.117368195886591, -3.265097676789813],
              [11.109367548980478, -3.2653374152690935],
              [11.105418473824738, -3.26004556035889],
              [11.109637679353309, -3.2533640814531735],
              [11.10873178181697, -3.247284715674102],
              [11.111959212020752, -3.240459700823059],
              [11.107920030916924, -3.2363024150253112],
              [11.11243033498466, -3.2323374281618],
              [11.111357919609652, -3.2257615211813477],
              [11.116064444784012, -3.218638305596955],
              [11.114371354372224, -3.2159437425230006],
              [11.116232127347478, -3.2115995223598266],
              [11.112998467960548, -3.210195030912408],
              [11.107299420783473, -3.2040031631076284],
              [11.10689757911512, -3.194651469161775],
              [11.105278472010857, -3.1938086106540426],
              [11.100821271474098, -3.1995990639295653],
              [11.099235971141354, -3.197023424507375],
              [11.098770835554047, -3.1865541913568816],
              [11.093537281025016, -3.1795294385018282],
              [11.09604846167877, -3.1776568956948448],
              [11.093891635067104, -3.17061550131489],
              [11.095708487810377, -3.1652924405322334],
              [11.090157078121303, -3.156047600719619],
              [11.090306290998617, -3.1493503177577375],
              [11.088802042306352, -3.1458431700446616],
              [11.085634253692959, -3.1436184571033405],
              [11.086942212262269, -3.1380069076711976],
              [11.08440958768574, -3.134864677812377],
              [11.08361788695959, -3.1294238178199993],
              [11.08033703530684, -3.1172642414569665],
              [11.077064719615878, -3.1091665674569664],
              [11.08199047605328, -3.1080251340571228],
              [11.08322952334934, -3.1005063815090494],
              [11.077936362152313, -3.097082326293804],
              [11.078034081905775, -3.0930561287339136],
              [11.080616801930159, -3.088399084473119],
              [11.07444207041622, -3.084915956373932],
              [11.073668310194652, -3.082623753849208],
              [11.077022355050067, -3.0771635238737316],
              [11.074289246007218, -3.0734335535555424],
              [11.076290583617086, -3.0682418041591215],
              [11.0688273996933, -3.062014776954612],
              [11.064866998706018, -3.055643166947085],
              [11.069191484612091, -3.0495575505085006],
              [11.06009204450215, -3.0452226383906957],
              [11.059566116556855, -3.0374564872468106],
              [11.060990964920025, -3.032383139220891],
              [11.05368654052201, -3.0312226165735265],
              [11.049298519219189, -3.0293534296539453],
              [11.045772016930561, -3.030219944486199],
              [11.04150545249045, -3.026418075246414],
              [11.04199842342357, -3.021622229752168],
              [11.039255125353165, -3.01900377550562],
              [11.040062288639591, -3.0114914766806544],
              [11.042874294023681, -3.008942446928293],
              [11.041915747270314, -3.00627878989627],
              [11.045455272501732, -2.996687556244189],
              [11.054341283408325, -2.99904308207953],
              [11.058891209364926, -2.9949330473527285],
              [11.05757348127672, -2.9917822908109413],
              [11.051465743856939, -2.990238760101977],
              [11.053152944275494, -2.987148147978067],
              [11.052412310752317, -2.983161967204056],
              [11.054732762488646, -2.975172985074067],
              [11.05027549217036, -2.969127286724869],
              [11.056305366870532, -2.9627276312018656],
              [11.060137140191795, -2.9616449719341977],
              [11.060288829151757, -2.953979005608924],
              [11.063849515610386, -2.9537501978209986],
              [11.064155512982786, -2.946928380308666]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.72534482646172, "lat": 34.88709488847524 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45077"],
        "coty_name": ["Pickens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pickens County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01248015"
      },
      "bbox": [
        11.039255125353165, -3.3884390618549856, 11.435269181299022,
        -2.892909955100749
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.346785900119545, 5.0538585826508164],
            [-5.307672772106581, 5.050859253346832],
            [-5.261353099271913, 5.0476788562301245],
            [-5.17484150371055, 5.039573169680069],
            [-5.086941253352255, 5.032498306735973],
            [-5.008593004217952, 5.025934440874708],
            [-4.922546418703342, 5.01907732762448],
            [-4.8338197342460445, 5.012381890156183],
            [-4.746778749148218, 5.005082247811531],
            [-4.694237102272662, 5.0007827067361275],
            [-4.588090829831606, 4.992901146679106],
            [-4.594421561920708, 4.90677540828364],
            [-4.602047172474749, 4.803337429654538],
            [-4.609355355023897, 4.704749053074704],
            [-4.613674820208047, 4.646506838443135],
            [-4.623109631755891, 4.516997332879608],
            [-4.719073277746229, 4.524436129166684],
            [-4.858058365777025, 4.535082413133943],
            [-4.916047154231561, 4.539435344018847],
            [-4.988927099079139, 4.545178660239987],
            [-5.071027170723168, 4.55161231829379],
            [-5.096040143018974, 4.554353921128693],
            [-5.141138381094347, 4.557567979934311],
            [-5.212761399791492, 4.563810923548373],
            [-5.213953933417598, 4.563809313659681],
            [-5.293238108118626, 4.570005624824257],
            [-5.3231389703517085, 4.57329784826666],
            [-5.341118356292819, 4.574788809950294],
            [-5.38610727169448, 4.577472383580555],
            [-5.383704213613649, 4.607507429095052],
            [-5.376673106016143, 4.690666703740471],
            [-5.366501778048347, 4.815366882103244],
            [-5.362021683704941, 4.868517876976407],
            [-5.36120008335653, 4.880149806124605],
            [-5.353536078436803, 4.973391876649692],
            [-5.346785900119545, 5.0538585826508164]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.52752700709166,
          "lat": 43.239366860633865
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46047"],
        "coty_name": ["Fall River"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fall River County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01265787"
      },
      "bbox": [
        -5.38610727169448, 4.516997332879608, -4.588090829831606,
        5.0538585826508164
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.952647525262487, 5.173834141664148],
            [-3.9453799539386702, 5.177667037490198],
            [-3.9404391840960034, 5.176514570748747],
            [-3.936586402844436, 5.181253284837528],
            [-3.9336662021146704, 5.181884711320714],
            [-3.932597923088977, 5.17697742784164],
            [-3.929799771647762, 5.173273156970118],
            [-3.9302987435052827, 5.169313153316822],
            [-3.933905670353471, 5.163981788920661],
            [-3.9315792908082376, 5.157333743129017],
            [-3.924734833879537, 5.156238860402794],
            [-3.921886344048979, 5.159157722239082],
            [-3.922575932185601, 5.164809585721553],
            [-3.914021036840051, 5.1638478992862185],
            [-3.9039247042637695, 5.159543756189734],
            [-3.891094335279062, 5.158156418780781],
            [-3.8869035847283895, 5.164051201315598],
            [-3.8843700664882546, 5.1641861488723855],
            [-3.8796360090641104, 5.156463506235155],
            [-3.87746519406314, 5.157400452975828],
            [-3.8794823356183747, 5.166992273315507],
            [-3.877167544175124, 5.170698164682909],
            [-3.8721074782869893, 5.174499974344632],
            [-3.8700742756174233, 5.1782448151785685],
            [-3.8657563523412186, 5.1759786683555475],
            [-3.8638553131325164, 5.215366380184986],
            [-3.863335407127399, 5.217248414981678],
            [-3.8588451236175394, 5.288199393152898],
            [-3.853584406219191, 5.374544935604891],
            [-3.8494761891106974, 5.437659369116384],
            [-3.847779004433284, 5.461188629247026],
            [-3.8393276484611487, 5.4606936844021465],
            [-3.8313581696743286, 5.4605164052589705],
            [-3.81124925587373, 5.458883396689838],
            [-3.744949700082861, 5.455011209330417],
            [-3.676862680690073, 5.450901004719783],
            [-3.591481563930757, 5.445818051527907],
            [-3.5060888788238964, 5.440870496627619],
            [-3.4766186714338163, 5.4393055034043325],
            [-3.4638557925765503, 5.437924057457473],
            [-3.456419815218292, 5.438146502477198],
            [-3.4099519812694017, 5.435602112534697],
            [-3.287145273370565, 5.428774835451227],
            [-3.164340583879797, 5.421912016945966],
            [-3.1675345573107454, 5.364662367487213],
            [-3.172749914660733, 5.268384034629154],
            [-3.1815745966688067, 5.269934542306109],
            [-3.18715342389967, 5.269390797752738],
            [-3.1861640091808274, 5.2737301660096305],
            [-3.18912808409672, 5.2775094163609175],
            [-3.197408715713997, 5.2727166518211],
            [-3.2002408607639814, 5.27639827036965],
            [-3.2037818195458803, 5.275129162449621],
            [-3.2010631957910958, 5.2703861886310035],
            [-3.2008458228530654, 5.266962498790336],
            [-3.2036655858865632, 5.265680748970064],
            [-3.209206621487471, 5.270343976569517],
            [-3.2159831515488646, 5.273939670236513],
            [-3.2182107243445928, 5.270246884142482],
            [-3.2255455212271076, 5.271439663684863],
            [-3.2292779581570734, 5.264972774792249],
            [-3.228598538691646, 5.2626343014459875],
            [-3.2235802374935196, 5.260597712806372],
            [-3.225976108447926, 5.253835133520312],
            [-3.229871288244023, 5.250319356069375],
            [-3.239583040839058, 5.247593605434401],
            [-3.2374564105214314, 5.25329613977722],
            [-3.2393488569238893, 5.2577479668429765],
            [-3.2430563211078023, 5.2610824944129835],
            [-3.245483254893448, 5.255434592796465],
            [-3.2493991227691605, 5.2538234595305795],
            [-3.2503869934202587, 5.24668167693708],
            [-3.254238906721457, 5.250352197633379],
            [-3.25740178686226, 5.250185531310296],
            [-3.259017936054999, 5.238385564132903],
            [-3.265824925986826, 5.234920626073838],
            [-3.2682040157467336, 5.236652387799572],
            [-3.2694061132678582, 5.242888247277185],
            [-3.2718038328587644, 5.245072726785328],
            [-3.275978724812563, 5.244926048074725],
            [-3.2782442629094004, 5.239301000642856],
            [-3.2852670843613696, 5.236014963485182],
            [-3.2843226745406433, 5.232072879790614],
            [-3.2928434199575762, 5.2293461098765],
            [-3.2931318502565197, 5.222723463565359],
            [-3.2997716228715426, 5.102119447821331],
            [-3.305743218569489, 4.997004334745841],
            [-3.309703859657688, 4.924941842581905],
            [-3.3129999285214646, 4.8666906133892756],
            [-3.3152853482771225, 4.8232649412011765],
            [-3.412844253621417, 4.828743423909871],
            [-3.510404330878679, 4.8342010384067375],
            [-3.5129587172260353, 4.834235164036976],
            [-3.6054840066987124, 4.839666787051264],
            [-3.6980103952690238, 4.845079633716308],
            [-3.781730727536709, 4.850607394472975],
            [-3.782479906601613, 4.851144158569376],
            [-3.8223272649809403, 4.85308763967767],
            [-3.864895700204326, 4.855965674967393],
            [-3.872663374428931, 4.85709962028944],
            [-3.9523655751553766, 4.861896488060562],
            [-3.9489408957234913, 4.914513764419901],
            [-3.948436155666729, 4.918985527113575],
            [-3.9469782303648016, 4.948760033436884],
            [-3.9671118117354496, 4.949896016804339],
            [-3.967088389915187, 4.952107243761599],
            [-3.9542619729415773, 5.1470980689749455],
            [-3.952647525262487, 5.173834141664148]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.62811908597583,
          "lat": 43.694254725998974
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46071"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01265794"
      },
      "bbox": [
        -3.9671118117354496, 4.8232649412011765, -3.164340583879797,
        5.461188629247026
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6269507748068848, 5.559126735910472],
            [-1.553330530403858, 5.5566822548313795],
            [-1.5425761084518523, 5.556681761463152],
            [-1.4658643569168588, 5.554531585188374],
            [-1.3793010756667108, 5.552176887741146],
            [-1.2924550928037437, 5.549777992252905],
            [-1.2025805447885147, 5.547552525986597],
            [-1.203269938590542, 5.520954201775566],
            [-1.2063946967098604, 5.390422357951287],
            [-1.208373434811684, 5.296075610117093],
            [-1.2086679892667611, 5.288897252017768],
            [-1.2948149706401113, 5.2902613068497155],
            [-1.3659428628391361, 5.2918646180135225],
            [-1.3799961796179674, 5.29190874846636],
            [-1.464465809355342, 5.293676171331005],
            [-1.5429687480633412, 5.295092700360478],
            [-1.550277709041146, 5.295611353342107],
            [-1.5713159531997691, 5.296128632107008],
            [-1.6357746584537614, 5.298100492250092],
            [-1.6340209312471021, 5.355640140007441],
            [-1.632400585984862, 5.392278145486378],
            [-1.6324017544740899, 5.398958576271697],
            [-1.6300337067232722, 5.471026026297553],
            [-1.6269507748068848, 5.559126735910472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.62967218971022, "lat": 44.06632176897784 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46073"],
        "coty_name": ["Jerauld"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jerauld County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01265778"
      },
      "bbox": [
        -1.6357746584537614, 5.288897252017768, -1.2025805447885147,
        5.559126735910472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.906237923891728, 6.146412793039489],
            [-4.835084825844782, 6.141182465380711],
            [-4.8207886979520165, 6.14037880986883],
            [-4.778256061922707, 6.137101942261474],
            [-4.7495862142034895, 6.13458019967972],
            [-4.71045947118944, 6.131774440925503],
            [-4.686987792309884, 6.129557906636416],
            [-4.679067134676387, 6.129261628150101],
            [-4.578914026529722, 6.12166623070124],
            [-4.478762888877941, 6.114045513483547],
            [-4.4720904358145175, 6.199806010641797],
            [-4.468555311084227, 6.199552140887891],
            [-4.462249381151885, 6.28563310449762],
            [-4.447658336448154, 6.481824049736537],
            [-4.447605605655559, 6.484745317197037],
            [-4.443078323827797, 6.545993366679784],
            [-4.442086913966751, 6.545926117135717],
            [-4.4204814930288965, 6.544124155143193],
            [-4.356039277126532, 6.539479990699466],
            [-4.270403657978919, 6.533089539751479],
            [-4.269256871435587, 6.532869329016038],
            [-4.214899868780979, 6.528819071091033],
            [-4.1292405436880575, 6.5239424177350855],
            [-4.057590635923663, 6.51848474648075],
            [-3.9592349827325366, 6.51186639218107],
            [-3.9394074574910887, 6.510682189776982],
            [-3.8671399411567853, 6.50578783588983],
            [-3.7948734114414213, 6.500879741754859],
            [-3.7680626946438687, 6.498916379046221],
            [-3.773707355165726, 6.411945121366368],
            [-3.781262909819888, 6.296658682939077],
            [-3.79038732287588, 6.152897298925669],
            [-3.795823420157499, 6.067373105287541],
            [-3.8016611031276675, 5.97550617878819],
            [-3.8021592224002956, 5.974801194824724],
            [-3.8038564840907596, 5.9726460605508676],
            [-3.810151451988519, 5.969673432561253],
            [-3.8141320101736316, 5.970196054990095],
            [-3.828542924674961, 5.969285879077778],
            [-3.833765513111954, 5.96648724547292],
            [-3.8373288649631934, 5.960596296587348],
            [-3.841360236630152, 5.956655457918862],
            [-3.8418780093437386, 5.9496939846837185],
            [-3.843742056580851, 5.94731425032753],
            [-3.8480686021230874, 5.947688920335294],
            [-3.857601612952763, 5.9424996907604815],
            [-3.858038876699019, 5.939030132406714],
            [-3.8554927871772593, 5.935370615728097],
            [-3.8573698862050527, 5.931692802988125],
            [-3.86063703061054, 5.930801635678762],
            [-3.8643615959086697, 5.9272416317277825],
            [-3.863862296111094, 5.922812756951519],
            [-3.8664969531000604, 5.921781549994919],
            [-3.8717676649633526, 5.923017358835837],
            [-3.87968412036239, 5.915328579743684],
            [-3.8815167102733414, 5.90685097423895],
            [-3.886123266373422, 5.9051470642968695],
            [-3.893720828834222, 5.907932890009202],
            [-3.9000811365556056, 5.909094929984921],
            [-3.908017684475413, 5.914816486923519],
            [-3.91481154024848, 5.916332664100404],
            [-3.9191821399868334, 5.913386517897091],
            [-3.915521851572745, 5.908971668339488],
            [-3.9191034043844923, 5.901543836959106],
            [-3.922285936591472, 5.899386524655755],
            [-3.927281520535866, 5.900408012026516],
            [-3.934535833746319, 5.899609107874754],
            [-3.941340012641691, 5.900019160386468],
            [-3.9478699479318986, 5.901986318709306],
            [-3.946345921471751, 5.907143703752609],
            [-3.9557604935426753, 5.914141539090763],
            [-3.960842468605961, 5.91537006144314],
            [-3.963694399236828, 5.917983695458384],
            [-3.9616527399086596, 5.923877281571631],
            [-3.9628987490376995, 5.926580039175822],
            [-3.9681010479303636, 5.926542688587637],
            [-3.973977805153275, 5.924472969816043],
            [-3.9804172457535176, 5.924387499871273],
            [-3.986361541088912, 5.922515107313768],
            [-3.9957416973160496, 5.922959726372912],
            [-4.000565843832069, 5.927364660636508],
            [-4.006324992090557, 5.925687725436122],
            [-4.0079003778342015, 5.918401180915956],
            [-4.01396843523477, 5.91268298974682],
            [-4.014889308467772, 5.909618129620152],
            [-4.018827822356416, 5.908706541156799],
            [-4.021809565088179, 5.911789191253141],
            [-4.024568419007111, 5.911388764843053],
            [-4.024177825846038, 5.907021813722056],
            [-4.027869341179953, 5.902880699724171],
            [-4.022484901192945, 5.897954566931471],
            [-4.025141709345836, 5.887163107559687],
            [-4.0230227310296796, 5.885835497105834],
            [-4.023975453324955, 5.8736292666714975],
            [-4.025523259803088, 5.869892605024611],
            [-4.02116665395576, 5.866952563159953],
            [-4.024047289091196, 5.863031831673211],
            [-4.022046600686743, 5.857210043161911],
            [-4.023382826545392, 5.853199152762596],
            [-4.027844185886186, 5.851119381551797],
            [-4.0278055289673524, 5.8462647145214595],
            [-4.032440197536919, 5.842648838242138],
            [-4.040137103965146, 5.847363855230466],
            [-4.042685904731465, 5.846344022144245],
            [-4.0450080746510535, 5.837494288409704],
            [-4.050190038780113, 5.831826880310477],
            [-4.054744487442177, 5.829066752237876],
            [-4.051815571111142, 5.822609513095916],
            [-4.056218255091982, 5.820639218369177],
            [-4.056462312002933, 5.809366633177531],
            [-4.060655623397732, 5.807037518140992],
            [-4.058692801370708, 5.801672781606712],
            [-4.061811923188136, 5.798931170681763],
            [-4.0639703753410465, 5.790651255914618],
            [-4.062013856124062, 5.787058696402057],
            [-4.064677192147655, 5.782960511879294],
            [-4.067720772438397, 5.784076341163273],
            [-4.0715489991042935, 5.779625901891472],
            [-4.071703116676674, 5.774747444094109],
            [-4.075386616360568, 5.770502384824125],
            [-4.078111804859539, 5.759344960587409],
            [-4.076174454761782, 5.753593317839528],
            [-4.072555605040704, 5.747135342808421],
            [-4.076030870577752, 5.740393125070594],
            [-4.074198272733482, 5.72900228514834],
            [-4.078505965125159, 5.726435638604542],
            [-4.078649599775202, 5.722329721758272],
            [-4.074322039885968, 5.715174429494371],
            [-4.073595127075429, 5.712084752397827],
            [-4.0852577303733275, 5.7040762763177355],
            [-4.086188147833295, 5.70173735237766],
            [-4.086123977192714, 5.691770270843051],
            [-4.088938706509884, 5.689866345020879],
            [-4.093977892417938, 5.690390539913907],
            [-4.098189017030934, 5.689371855284329],
            [-4.101489768192046, 5.686347336502862],
            [-4.103822363775853, 5.6795809153246655],
            [-4.103165577440555, 5.677126491083686],
            [-4.1084652090246205, 5.662187731626963],
            [-4.1052498069065315, 5.660621123364051],
            [-4.101438757937261, 5.6614382985730725],
            [-4.098850965587548, 5.658015845987806],
            [-4.099488895986904, 5.64866834114186],
            [-4.101456290007923, 5.643367369211877],
            [-4.105480624207021, 5.645299295759428],
            [-4.110525301093313, 5.645200480574682],
            [-4.111923892839217, 5.639846471365399],
            [-4.107636739007986, 5.640003038775648],
            [-4.109141491742681, 5.635163375415514],
            [-4.106769648136181, 5.632519392692036],
            [-4.104866501312392, 5.6265593335900865],
            [-4.101815282610453, 5.623544679557847],
            [-4.158647148754336, 5.627298527322248],
            [-4.244901116793989, 5.633315736676421],
            [-4.301977592910691, 5.637427721956064],
            [-4.416181754635345, 5.6458385058999925],
            [-4.48829422504168, 5.650924602592083],
            [-4.560048905427778, 5.656341322444483],
            [-4.675057714142118, 5.664980217421777],
            [-4.732337985162009, 5.669546015510091],
            [-4.754964233995038, 5.671108640441066],
            [-4.804512054647654, 5.674951170481611],
            [-4.8103486969060185, 5.675172562718895],
            [-4.861056602341642, 5.6792444311239745],
            [-4.85776882320153, 5.721698863637727],
            [-4.8523545402666235, 5.794548648190469],
            [-4.938793176301806, 5.800828752232212],
            [-4.93168248330428, 5.888466321213014],
            [-4.928213845794542, 5.888241899366535],
            [-4.92125462002873, 5.966967262755789],
            [-4.921245088532251, 5.970808217204824],
            [-4.913616741077619, 6.06048947796618],
            [-4.913689817444601, 6.062557399130187],
            [-4.906237923891728, 6.146412793039489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.71687088755387,
          "lat": 44.56680231220803
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46093"],
        "coty_name": ["Meade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meade County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01266991"
      },
      "bbox": [
        -4.938793176301806, 5.623544679557847, -3.7680626946438687,
        6.545993366679784
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.3915363101803638, 7.262168563236061],
            [-0.3335320770465625, 7.261585830590572],
            [-0.31477596023224425, 7.261569414406353],
            [-0.3044407422376036, 7.261950958780582],
            [-0.2328312193496387, 7.260413787209062],
            [-0.23163635170855434, 7.260864029279614],
            [-0.1588224338414036, 7.260000754717338],
            [-0.09690736557451837, 7.259329223457833],
            [-0.08739924380948044, 7.259672073788113],
            [-0.02459849786010189, 7.2591332824912564],
            [0.018741390134158438, 7.258345627859485],
            [0.07123911518028396, 7.257937844817463],
            [0.07091640156653815, 7.242404720705952],
            [0.06751948610525085, 7.239974398490952],
            [0.06656427138532804, 7.234978100320264],
            [0.07056509551041704, 7.232354282340196],
            [0.06781297126173959, 7.225916655432645],
            [0.06740595002947251, 7.211222843857524],
            [0.06559837068483151, 7.209847161901266],
            [0.06463319790231238, 7.199745203738198],
            [0.06514899254926475, 7.19515536864794],
            [0.06316983779762604, 7.190181918277218],
            [0.06431155379560913, 7.185007285517274],
            [0.06313116836011803, 7.166673231021599],
            [0.06099607652297569, 7.161563251296118],
            [0.0610016731319421, 7.156783252277796],
            [0.05938394087431718, 7.149568333688782],
            [0.05701537942590307, 7.143836868061859],
            [0.0541975896362425, 7.140305967158778],
            [0.04746413608533895, 7.135743557067486],
            [0.039766941591524066, 7.123169988927845],
            [0.03632444836185154, 7.118603351496711],
            [0.027325363660702484, 7.112198859786426],
            [0.017869407055011, 7.094657944193861],
            [0.015555654482876474, 7.084459533158254],
            [0.008285508342682758, 7.071555102962363],
            [0.000988252064523696, 7.063545237828244],
            [-0.006089333851284535, 7.057300696867932],
            [-0.01630431534482527, 7.051020619503397],
            [-0.033084438878454, 7.0428412872737995],
            [-0.05691248976317588, 7.02716663012966],
            [-0.06061284662652187, 7.024423967178745],
            [-0.06805151200217126, 7.013308749732217],
            [-0.09567306123907315, 6.994522685744055],
            [-0.11397608639468947, 6.980598331503524],
            [-0.11854202037459267, 6.97820896383384],
            [-0.12425393223486568, 6.971886791335657],
            [-0.1267278981125768, 6.966241775496273],
            [-0.13209122037067897, 6.946273157857477],
            [-0.13267162102838911, 6.941741151972986],
            [-0.13650126456715647, 6.932964693629121],
            [-0.12107075244992178, 6.913144306277281],
            [-0.09790583811501795, 6.882458352658889],
            [-0.09223964751790265, 6.8777554159198715],
            [-0.08603040446126456, 6.86834880521398],
            [-0.0833935570957973, 6.863037829387053],
            [-0.072473567787591, 6.848496388395242],
            [-0.06392733948875332, 6.8293146014411015],
            [-0.05886186446208415, 6.815918623361212],
            [-0.05752222588353017, 6.807901538996877],
            [-0.05404427963483779, 6.800774313393262],
            [-0.05296823434181863, 6.794088536868881],
            [-0.04922787421399642, 6.784371952172646],
            [-0.0442582973466639, 6.7788340580062245],
            [-0.03492349370279905, 6.764310970517069],
            [-0.028842773949200044, 6.753655058683129],
            [-0.02226643028573328, 6.744757755475061],
            [-0.013833221859788629, 6.737903772131699],
            [-0.006707183430214101, 6.7378991781564554],
            [-0.0010730292966093739, 6.736336133203707],
            [0.009020158440411293, 6.737374647752198],
            [0.0301758163515238, 6.7352142578267875],
            [0.04175775302314077, 6.730262012301705],
            [0.05323437101883073, 6.722764181731897],
            [0.05734482833082623, 6.719351583882328],
            [0.0690579936464086, 6.713117365093861],
            [0.08038122319266285, 6.708044663426243],
            [0.09091955382890461, 6.7054469800736864],
            [0.09733373813724783, 6.702580195896509],
            [0.10688059755080977, 6.69476633589013],
            [0.11117036298555244, 6.6923998913791625],
            [0.12021577637682275, 6.684004967745576],
            [0.12697067520802421, 6.666654573567815],
            [0.13318460065195864, 6.653667166924964],
            [0.030357313702623304, 6.654273670134978],
            [0.024300978466657117, 6.654160932645008],
            [-0.05614703538331248, 6.654525117968603],
            [-0.1422498565802628, 6.654999507626516],
            [-0.2340213536727923, 6.656747825545071],
            [-0.2445968828019809, 6.627028974294658],
            [-0.36252579849989264, 6.628781716183954],
            [-0.39833326060677227, 6.629599854872604],
            [-0.39777859791622494, 6.6729479480302025],
            [-0.3976461055729419, 6.715792800018256],
            [-0.39738456355965235, 6.741367411877759],
            [-0.39639016086059964, 6.802212150867629],
            [-0.39635022706045786, 6.81650315678899],
            [-0.39556330673944806, 6.888336818941358],
            [-0.3944942882162268, 6.974668107642524],
            [-0.3935771862080178, 7.060785777055759],
            [-0.3925469746059638, 7.1756712722543545],
            [-0.3915455591918164, 7.26216866017695],
            [-0.3915363101803638, 7.262168563236061]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.94609893026134,
          "lat": 45.629574775760815
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46109"],
        "coty_name": ["Roberts"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Roberts County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01265786"
      },
      "bbox": [
        -0.39833326060677227, 6.627028974294658, 0.13318460065195864,
        7.26216866017695
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.619071411030271, -2.1532952852775566],
            [10.622492714817492, -2.148442202310087],
            [10.62859452342923, -2.146246913806333],
            [10.63071495177642, -2.1372463723084234],
            [10.631142533048077, -2.0378941368524552],
            [10.636125729677026, -2.0443047471442615],
            [10.640603254133739, -2.046780424175645],
            [10.645532969197276, -2.045369211139363],
            [10.646475223060316, -2.0412811097400034],
            [10.643330857509087, -2.0281685935609883],
            [10.644010881233534, -2.019425803285132],
            [10.639750175255353, -2.010026705714478],
            [10.642074567841961, -1.9991007875430415],
            [10.64993382717114, -1.996235267434804],
            [10.653717767712529, -1.990127547272532],
            [10.653501686686138, -1.9843539532036532],
            [10.64910935431455, -1.9799602803399403],
            [10.64345249223444, -1.9680002428142027],
            [10.639186585806653, -1.960941591594072],
            [10.640274235455454, -1.9570288201854078],
            [10.644128613275651, -1.953862432523081],
            [10.648928117664637, -1.9529093723234479],
            [10.65411026968777, -1.9559759070036824],
            [10.659481684799134, -1.9590582951958884],
            [10.661642567899447, -1.9572984856505562],
            [10.661030323191087, -1.9515791467213819],
            [10.659216700302885, -1.947746474021154],
            [10.653537936603401, -1.940988221685343],
            [10.650981725935662, -1.935225955065426],
            [10.642193881451696, -1.9239936775917892],
            [10.639772086145094, -1.9186201170538613],
            [10.641944453747085, -1.9155785731720119],
            [10.656314026856545, -1.9185240314637884],
            [10.660194818273203, -1.9119934871189728],
            [10.659127066098035, -1.9047076972701864],
            [10.653916014449655, -1.8966585720250753],
            [10.653143302950536, -1.8909595110110162],
            [10.655265922956405, -1.8887363863343045],
            [10.659098462966105, -1.8890315549490153],
            [10.666822798107788, -1.895855704300495],
            [10.6719116653535, -1.8989110934855127],
            [10.679358375965384, -1.9079767518541533],
            [10.687761807647998, -1.9103988817289708],
            [10.692372211867593, -1.909987455779295],
            [10.695467262940253, -1.9078257292750658],
            [10.695364029475563, -1.9030885668377104],
            [10.692439655398816, -1.896082153088252],
            [10.68900642164188, -1.8821150099730253],
            [10.685409867660839, -1.8734565782004649],
            [10.679872215195953, -1.8665719453722107],
            [10.680139244077694, -1.8596128984382305],
            [10.689725824920716, -1.8541384301677182],
            [10.692003408612981, -1.8518949152065256],
            [10.695443312874417, -1.8528542577839182],
            [10.694579944321823, -1.8589772628330998],
            [10.69573328465729, -1.8668636086993626],
            [10.693450411425902, -1.8750127112425914],
            [10.694521374605758, -1.8787360283976076],
            [10.698978324723592, -1.8830177274725792],
            [10.705925628112306, -1.8848229364731628],
            [10.711103491973395, -1.8872743150968339],
            [10.720560406818114, -1.8950493075567365],
            [10.723402685769937, -1.9016874307143283],
            [10.72736086392302, -1.9028795107520895],
            [10.73175353776989, -1.906659290931956],
            [10.74181310590683, -1.905823326558089],
            [10.743851186766143, -1.917313845584017],
            [10.748094271108164, -1.9158373820149441],
            [10.749721166710097, -1.91073159347752],
            [10.753808992099298, -1.905981236335983],
            [10.757224731332284, -1.907002544064105],
            [10.758655013897895, -1.9123082952616792],
            [10.774322881108631, -1.9208848854338463],
            [10.781721250580887, -1.9307022414973127],
            [10.785749634833314, -1.92840293005701],
            [10.79030291385439, -1.9301235280289046],
            [10.796119770802187, -1.9346510008559519],
            [10.79981359789063, -1.943481592760261],
            [10.81338782220784, -1.9540424833837755],
            [10.842877323643524, -1.9783143398979697],
            [10.885877163028487, -2.0108615455732766],
            [10.900570309616896, -2.0237952334167173],
            [10.940166918871089, -2.0593667091189265],
            [10.938607002391644, -2.0670925324332132],
            [10.941774061101157, -2.074119159376998],
            [10.937740318583135, -2.0790351819605246],
            [10.933032607559255, -2.078844300177743],
            [10.92965261967864, -2.076509276069307],
            [10.925353584107247, -2.078388357856889],
            [10.928477164746832, -2.082304667453406],
            [10.931253901742757, -2.0819588977081795],
            [10.935283863899398, -2.0931547496537872],
            [10.938673152624425, -2.0979512887673804],
            [10.94200004059299, -2.1080651247751105],
            [10.945080761885013, -2.1144976095782826],
            [10.942212691933232, -2.1211923708693177],
            [10.94508650958901, -2.124572538617236],
            [10.950852511963564, -2.123852692982267],
            [10.947963120915496, -2.132100173812355],
            [10.93980508970419, -2.137360983398387],
            [10.933177231529415, -2.1383436926772355],
            [10.933339186414932, -2.1430514125926567],
            [10.93526011300278, -2.1461483625702735],
            [10.935295575072784, -2.1557644670609424],
            [10.940158232292065, -2.164970930458322],
            [10.931776498006563, -2.168964054363178],
            [10.928672011826427, -2.171668743151471],
            [10.925481968878184, -2.1813036803980395],
            [10.919420358942977, -2.1848470982586794],
            [10.915409346880477, -2.1940326421410314],
            [10.911673060196383, -2.207639548156824],
            [10.90985543523019, -2.2107731840838825],
            [10.91012909753158, -2.2196488443358557],
            [10.905040047867953, -2.2224595680463457],
            [10.901602044853265, -2.2258579494259463],
            [10.895241025118, -2.235671464129663],
            [10.889362801987259, -2.2406153285480315],
            [10.881886965288464, -2.2418432683488163],
            [10.877588097158563, -2.237699238567197],
            [10.872368158818865, -2.2369773902133168],
            [10.85234618575462, -2.2320035287009157],
            [10.847477964391992, -2.234704625214166],
            [10.844517082386258, -2.2346564923926135],
            [10.83893755923086, -2.2316601130871536],
            [10.830337799711259, -2.235794192563793],
            [10.818197983264652, -2.234575270436674],
            [10.813545612007193, -2.2389543542104993],
            [10.813165638956177, -2.2412117231917934],
            [10.80532613122044, -2.2499762721420944],
            [10.801378082803094, -2.251528681586264],
            [10.793006054286442, -2.2576164280856763],
            [10.788353277333337, -2.2622978077278892],
            [10.782105586680558, -2.261256929409085],
            [10.767162714858179, -2.266311446892924],
            [10.757443646811302, -2.2678682725368615],
            [10.753329817027867, -2.2747278707789658],
            [10.754407928626767, -2.2787352969868593],
            [10.75125825911658, -2.287823405298607],
            [10.74571743277434, -2.290807637153695],
            [10.741095265098654, -2.305703227297529],
            [10.738967374002737, -2.306085220120184],
            [10.731661056149209, -2.311454251935128],
            [10.72714486491742, -2.3109881048107495],
            [10.71886235349537, -2.3142646580900696],
            [10.714200276955557, -2.3126901241213087],
            [10.704652792734969, -2.314491828698312],
            [10.697685477654282, -2.314758841173872],
            [10.695998439588909, -2.319287141523374],
            [10.690175694272536, -2.3227350672810427],
            [10.687454573464299, -2.3280111846589775],
            [10.683489781158599, -2.328206378171947],
            [10.675512324339415, -2.3317652228579444],
            [10.67096148421984, -2.3317581695498357],
            [10.671000181804635, -2.323257956711458],
            [10.667459619119112, -2.314642101656309],
            [10.665186649294437, -2.3131105130654825],
            [10.662565764484492, -2.295749290407117],
            [10.663564978149948, -2.2924090186654222],
            [10.663339170363784, -2.285669523730817],
            [10.664504288756746, -2.273739032780997],
            [10.662148369190316, -2.2720476534115774],
            [10.660487660853645, -2.265960931766016],
            [10.656254298301576, -2.267931421123402],
            [10.653248652738567, -2.262894352957532],
            [10.652889642826029, -2.25518766714707],
            [10.651170943096602, -2.2511637847380843],
            [10.654675717619316, -2.245826956219233],
            [10.656883219689131, -2.2391595678000984],
            [10.653678341609155, -2.2282946116056643],
            [10.654668460914724, -2.2244872186286275],
            [10.659009646103453, -2.225332580149806],
            [10.659631486731325, -2.2307993563086406],
            [10.664735685598504, -2.227715894080446],
            [10.66718833006572, -2.2246687596225097],
            [10.667610010209977, -2.218486437419085],
            [10.660729533590018, -2.2174340689160763],
            [10.659556104388118, -2.211839991097692],
            [10.65608080884528, -2.2123678542292016],
            [10.649413797314919, -2.2050107971090025],
            [10.64676313135474, -2.198696438153518],
            [10.641910379395082, -2.1939123292862246],
            [10.638212514375814, -2.1927314854953632],
            [10.640434277440905, -2.1839537659858324],
            [10.640428085695602, -2.1803932031234594],
            [10.62394521510975, -2.1772186477719275],
            [10.624252786717605, -2.172666672013826],
            [10.622012130580503, -2.1683824572898027],
            [10.62251095165934, -2.1618612643967223],
            [10.615314851683952, -2.159749930054294],
            [10.615905155755529, -2.156288445829097],
            [10.619071411030271, -2.1532952852775566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.12116774177686, "lat": 35.92543057786035 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47029"],
        "coty_name": ["Cocke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cocke County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01639734"
      },
      "bbox": [
        10.615314851683952, -2.3317652228579444, 10.950852511963564,
        -1.8518949152065256
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.970311191429019, -1.6145746894835407],
            [9.034338816337147, -1.6083238307105654],
            [9.113066872513704, -1.602359714826743],
            [9.120803613798502, -1.6020471891372103],
            [9.169896398677537, -1.5989708317553284],
            [9.200359772091366, -1.5981613371764365],
            [9.209629364380968, -1.5982162282175043],
            [9.23440174404528, -1.598357300014822],
            [9.30161680785989, -1.5966475790466974],
            [9.314924409532289, -1.596470106834591],
            [9.34609783190828, -1.5936646791742597],
            [9.360689326460527, -1.5928416280413753],
            [9.394632669659, -1.6394742906906818],
            [9.41237966773242, -1.6666803238125392],
            [9.371080845309415, -1.6712822658152553],
            [9.341230541018176, -1.6493089003041035],
            [9.303882528577766, -1.6335954355840543],
            [9.293526028086486, -1.6313607518413304],
            [9.27326422276897, -1.6286582715490534],
            [9.265594359724188, -1.6281348974803083],
            [9.25120974404842, -1.6283986141248832],
            [9.238704342043288, -1.6296552502068427],
            [9.228214957278217, -1.6331160238844322],
            [9.213515564765201, -1.6396055887491339],
            [9.19596532919764, -1.6505906904133898],
            [9.186156071534976, -1.643081540030292],
            [9.184709114711184, -1.6470124479648078],
            [9.18548051275687, -1.6518327963386594],
            [9.180419965901317, -1.6517058292666689],
            [9.178466782563804, -1.6590984790879637],
            [9.171821055557327, -1.6588773626111064],
            [9.166301396223725, -1.665641416481894],
            [9.161689537280266, -1.6614474968275719],
            [9.159935511990208, -1.666649503847689],
            [9.156752644246135, -1.6691022306565702],
            [9.156213583082922, -1.673164958677871],
            [9.16088718219772, -1.6766521441027553],
            [9.160786661118227, -1.6851521085482983],
            [9.161814600878968, -1.6885215471795878],
            [9.15821989534113, -1.6978095227955174],
            [9.1489492631119, -1.694544491725369],
            [9.14522873940782, -1.6990983109265647],
            [9.140643217030492, -1.7068173170249987],
            [9.133280702412483, -1.7243827913786376],
            [9.132627950449793, -1.7724588522452025],
            [9.132314156766135, -1.8160345127124817],
            [9.118690011106837, -1.8204197570634146],
            [9.112214574127107, -1.8227377750209846],
            [9.107101593895344, -1.821926219278555],
            [9.10708056993128, -1.8158055889928675],
            [9.10480549690278, -1.8102990545269342],
            [9.094432943358244, -1.7941502319494695],
            [9.091279072865476, -1.7738002472149021],
            [9.088952581875533, -1.770101875612947],
            [9.081493308794824, -1.7671223616296128],
            [9.082301897652908, -1.7640539910250645],
            [9.057737368265565, -1.7429091048145],
            [9.037409569928668, -1.7282750402958267],
            [9.0249217224833, -1.721610246046972],
            [9.011198491226958, -1.7175366254228577],
            [9.002893736725326, -1.715889281375682],
            [8.9935718871874, -1.710295231398601],
            [8.995050933026862, -1.706530338909706],
            [8.985705263194639, -1.700421242387738],
            [8.978813750661269, -1.705274305830915],
            [8.974341245267267, -1.7108196860940297],
            [8.973561912031244, -1.7074256309764313],
            [8.975168576791084, -1.7027510686854102],
            [8.974947138957216, -1.6940668414205173],
            [8.977577434877622, -1.689003042232256],
            [8.976966280342165, -1.6859707379806452],
            [8.983663863899118, -1.6671661485905918],
            [8.973951213163616, -1.6551665659797374],
            [8.97197769396187, -1.633907122034503],
            [8.969120026482551, -1.6334121424926213],
            [8.968010476503851, -1.6299262668514898],
            [8.970989553731693, -1.6233683015511353],
            [8.970311191429019, -1.6145746894835407]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.0748329367821, "lat": 36.55845370528816 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47137"],
        "coty_name": ["Pickett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pickett County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01648580"
      },
      "bbox": [
        8.968010476503851, -1.8227377750209846, 9.41237966773242,
        -1.5928416280413753
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.232222577793891, -1.8355489243639627],
            [8.232103383069207, -1.8366435269879202],
            [8.263111042641809, -1.837172553676087],
            [8.270087849568352, -1.8523910702345996],
            [8.277428636766542, -1.8646112811680817],
            [8.28439146066147, -1.8739517126562493],
            [8.32070897415387, -1.8742921312568073],
            [8.356675927931398, -1.8749735628293844],
            [8.417057700864957, -1.8755687046706595],
            [8.436406530940367, -1.8765094486354792],
            [8.443318195487038, -1.8825088156615848],
            [8.439572291087588, -1.886996002555819],
            [8.440024742682194, -1.8974295981107587],
            [8.436586636700977, -1.9070996817674049],
            [8.430533114391048, -1.9083076147688607],
            [8.421384039065588, -1.9116445639884316],
            [8.408983800999344, -1.917598417114939],
            [8.40716573822172, -1.920516868937055],
            [8.395756522809817, -1.9255299872510558],
            [8.382455059223096, -1.9357319309038623],
            [8.373083402873942, -1.9445473967549567],
            [8.362783716737226, -1.9562308680657958],
            [8.35471732279631, -1.9674365615409424],
            [8.348942721659803, -1.9772564473115501],
            [8.34258560160435, -1.9906561041111466],
            [8.338276373030181, -2.002454710173255],
            [8.333490638279022, -2.0212045189242938],
            [8.32484659243725, -2.0203064427923985],
            [8.31770467111817, -2.0122833202893715],
            [8.30060087896217, -1.9974297117558641],
            [8.290349642556835, -1.9904430361956786],
            [8.287207324494197, -1.9981209287067885],
            [8.284706067043075, -2.0007127820888866],
            [8.280673661705658, -2.000317966993413],
            [8.27341185869682, -1.9948360690524027],
            [8.267638480442498, -1.9892595394654438],
            [8.265350049496877, -1.9852485320898952],
            [8.264587659701405, -1.9790898649260855],
            [8.259778959226358, -1.977543020832604],
            [8.255706791119918, -1.9810558338121569],
            [8.248363660547607, -1.9807313210274995],
            [8.24830579333384, -1.9743832987697116],
            [8.24523186552241, -1.9744822178642598],
            [8.23515519711234, -1.9884684600600102],
            [8.233015768909194, -1.9978060103042636],
            [8.23539196575439, -2.013680402623922],
            [8.23401074849658, -2.0204570127020687],
            [8.228124021647805, -2.0257131783369924],
            [8.223895509403045, -2.027106070570639],
            [8.215765991763314, -2.019992295728911],
            [8.214991658780257, -2.0118016781378563],
            [8.21996766312702, -1.998258134030175],
            [8.218143268855542, -1.9892401379264213],
            [8.214695819535367, -1.9819951431973801],
            [8.211531126354144, -1.9795645802244788],
            [8.206396856427418, -1.9791340441032146],
            [8.203211487110504, -1.9804981830013315],
            [8.20131233777332, -1.9773036230179935],
            [8.202945422020205, -1.9663912623502502],
            [8.210562227018778, -1.9680448051490014],
            [8.20846910579855, -1.9397591344362783],
            [8.203820635482272, -1.8735414377001287],
            [8.218914719620969, -1.873893701896547],
            [8.21877009475821, -1.8724895915412056],
            [8.228942319398506, -1.8719484046076647],
            [8.228860166474929, -1.8421784223850142],
            [8.22420435754581, -1.8419399955883409],
            [8.224916780436823, -1.8386927525446501],
            [8.228197981701763, -1.8353024882621762],
            [8.232222577793891, -1.8355489243639627]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.15668982067457, "lat": 36.39212779341017 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47169"],
        "coty_name": ["Trousdale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Trousdale County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "01648581"
      },
      "bbox": [
        8.20131233777332, -2.027106070570639, 8.443318195487038,
        -1.8353024882621762
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.803928727190927, -2.477095376611312],
            [8.808217351617726, -2.4751600589725427],
            [8.803981720264732, -2.4676122106251315],
            [8.806267272680856, -2.4653692963030904],
            [8.809458454713727, -2.468779884877072],
            [8.814719107550438, -2.4684819489149885],
            [8.817417449224772, -2.4636240887823635],
            [8.827655306289254, -2.4627424224792],
            [8.838090199166073, -2.469665228108158],
            [8.843351226782524, -2.4718341622600164],
            [8.849166275019309, -2.4661586266344715],
            [8.852208905639536, -2.4695505569371603],
            [8.857639464360437, -2.466764013419755],
            [8.863593222415163, -2.4719843856362824],
            [8.867242224069528, -2.4736360927281935],
            [8.868508266932547, -2.468990300789891],
            [8.86813349058805, -2.463527777053186],
            [8.863893327308206, -2.460499049098936],
            [8.863519139153066, -2.4580693971514718],
            [8.868889578790869, -2.4494760603085095],
            [8.873815764898922, -2.449084107771255],
            [8.880261467483772, -2.4521632284550097],
            [8.88531694986412, -2.456435714400735],
            [8.888112039027574, -2.449511870275764],
            [8.893307900456895, -2.4470710492183168],
            [8.896441370363055, -2.4433533447675497],
            [8.903632750236659, -2.4380292654119513],
            [8.907730070444218, -2.444202444209282],
            [8.912640156728076, -2.443658577485018],
            [8.911026511242428, -2.4401686883854046],
            [8.914136588035294, -2.4375706602092975],
            [8.918947404310604, -2.4385398298988252],
            [8.923601446416654, -2.436920957355786],
            [8.932090462512502, -2.4417506461893375],
            [8.936478627602522, -2.4385110427623835],
            [8.940280688285771, -2.438515016158866],
            [8.94752716580398, -2.4419305502985647],
            [8.98545414867182, -2.4521126810279306],
            [8.995938527091232, -2.4539767253605924],
            [9.061468065327038, -2.424288831699399],
            [9.070705648827369, -2.4199741350338213],
            [9.066348622329768, -2.430456611204812],
            [9.062241768390798, -2.433628829297455],
            [9.064335393418936, -2.4437599009177657],
            [9.070842930665835, -2.4453293041419575],
            [9.07052662274306, -2.4489997378038915],
            [9.06853146919436, -2.454978925258396],
            [9.067970601048037, -2.4591700974008615],
            [9.073140063182498, -2.4627386217750815],
            [9.078850122972451, -2.462542005415696],
            [9.082217865588023, -2.469901062332754],
            [9.086190972646044, -2.4740732288857523],
            [9.08590618464225, -2.475440833725028],
            [9.085694203828188, -2.4783749246685476],
            [9.082117725309594, -2.4815495124728306],
            [9.07885461957791, -2.486980433754992],
            [9.083177868352504, -2.4891507360805747],
            [9.079018149726833, -2.4918280684417704],
            [9.078783463264111, -2.4994785205553867],
            [9.077034817736308, -2.5047476468876875],
            [9.076736537264159, -2.514032517621558],
            [9.080632498215714, -2.516414770154105],
            [9.08190479156204, -2.520917413574073],
            [9.06445268218074, -2.551941127327168],
            [9.05476153729017, -2.5675390239475484],
            [9.017011781811302, -2.6251822173711896],
            [8.972486141947519, -2.689248690075371],
            [8.94971563163114, -2.7012099121422897],
            [8.949146101507827, -2.7067524655795214],
            [8.945253518989508, -2.709504752617486],
            [8.945898023448066, -2.713073612567171],
            [8.93410297464205, -2.7135896298773696],
            [8.924599068231634, -2.7152044252435594],
            [8.917043242864656, -2.715498824109204],
            [8.900444565314054, -2.721120172675848],
            [8.890488658928858, -2.7258255595625434],
            [8.887847431750286, -2.7247099269506427],
            [8.878343579524792, -2.7249336698337068],
            [8.877919089937327, -2.7313167241317142],
            [8.87230765958282, -2.733037670759893],
            [8.869143922367908, -2.735638306471798],
            [8.8300411350383, -2.653831633239871],
            [8.829389185299933, -2.6466326794935915],
            [8.816830642229334, -2.5890807439003978],
            [8.811643923296817, -2.5639438496517486],
            [8.815030108616988, -2.5585401192313837],
            [8.817033347694663, -2.5485163324271394],
            [8.81493716686112, -2.5442932265471674],
            [8.817357985093699, -2.5415285139088537],
            [8.818722942322001, -2.5366423652451155],
            [8.812422092939066, -2.5306151534397254],
            [8.81515673848128, -2.524786545372792],
            [8.81379909729355, -2.5213889306283415],
            [8.81724582765975, -2.5169413931251836],
            [8.808972773599894, -2.5121599490926276],
            [8.801922655398954, -2.5166006663416884],
            [8.798060347933873, -2.5130778004150587],
            [8.802903901009001, -2.5114900011230006],
            [8.805844493665791, -2.5039543434349416],
            [8.802480104140868, -2.5011914686744126],
            [8.802887991731678, -2.497093877428313],
            [8.805913419480005, -2.4915954340938398],
            [8.806596512812005, -2.4810533790328355],
            [8.803928727190927, -2.477095376611312]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.4526207225736, "lat": 35.69593906981358 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47175"],
        "coty_name": ["Van Buren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Van Buren County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "01648584"
      },
      "bbox": [
        8.798060347933873, -2.735638306471798, 9.086190972646044,
        -2.4199741350338213
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.583078753764459, -5.464745025274482],
            [1.584862699528795, -5.4660066506975955],
            [1.5858474608122224, -5.474879124709748],
            [1.5921699919724472, -5.4767666995415665],
            [1.5923505635311725, -5.4799109305669464],
            [1.5977996043689495, -5.4820840492282805],
            [1.6031010717404943, -5.482767701132608],
            [1.6072757366587274, -5.48149100141982],
            [1.611470280692151, -5.486420127771895],
            [1.6224254418044448, -5.47915053789196],
            [1.623258793520987, -5.4758321881466],
            [1.6345468726166845, -5.473459530783348],
            [1.638359945827625, -5.483126231699818],
            [1.6447306244045015, -5.485040951809265],
            [1.6438229665124735, -5.481698230030513],
            [1.649151324416841, -5.480608585062896],
            [1.6517845121103072, -5.478044710779995],
            [1.6507148484998815, -5.471746957054296],
            [1.652315577410419, -5.46828042148279],
            [1.6603592036194381, -5.471440657746809],
            [1.6644934933912305, -5.463322394415151],
            [1.667104496668458, -5.466702379222996],
            [1.6770219045037067, -5.466528201255071],
            [1.6767811087140967, -5.462607187472205],
            [1.6806976503415754, -5.462502071507888],
            [1.6846733356768318, -5.46476010107693],
            [1.6944789612156335, -5.449829386482573],
            [1.7009605096500175, -5.45005122599415],
            [1.7035294017701403, -5.447740945130104],
            [1.7091292799005702, -5.448357767299107],
            [1.71615131612682, -5.451801193326545],
            [1.7204194428383244, -5.4512265032616405],
            [1.7184834020409494, -5.447479599785705],
            [1.7214850249623472, -5.443549176992695],
            [1.725881507018332, -5.441482722870959],
            [1.730290028856554, -5.441464522728683],
            [1.7353198528130735, -5.436939763487929],
            [1.7376799691386602, -5.437715742792303],
            [1.740773615732614, -5.443818097420734],
            [1.74333594844072, -5.445520764476253],
            [1.74634853870082, -5.443968638059874],
            [1.7491586892029554, -5.447561431351563],
            [1.7556371062945666, -5.449707244615255],
            [1.7622138755674097, -5.4489873990258575],
            [1.761376387720182, -5.444795507707537],
            [1.7637841005968793, -5.443297713167559],
            [1.7682814233361615, -5.445266509582518],
            [1.7792454274773783, -5.446542653638574],
            [1.781420601248367, -5.4506559980799025],
            [1.7808543334805076, -5.4540350618270494],
            [1.7838605668698078, -5.456723257053432],
            [1.7831577541352726, -5.459684606061184],
            [1.7886325143549457, -5.459236506525811],
            [1.7928396434789318, -5.461390096194506],
            [1.7924148659900603, -5.465056416940767],
            [1.7957568104752628, -5.465496455688138],
            [1.7967240842162369, -5.468600160804419],
            [1.8098963560373111, -5.474458138398577],
            [1.81015031062881, -5.4725025063732335],
            [1.818758551670341, -5.469678931686717],
            [1.8206188454389807, -5.467044313167128],
            [1.8251077778475207, -5.464910765798426],
            [1.831535767288304, -5.468433276433868],
            [1.8346711239680464, -5.474817454805063],
            [1.8399320526682164, -5.4768630624362125],
            [1.8473922244574092, -5.474215676616894],
            [1.8534002733870216, -5.4743742070919925],
            [1.8601000904944933, -5.4786272020991555],
            [1.865979580275908, -5.480359517633809],
            [1.8701302314580404, -5.478704530624881],
            [1.8804512349937526, -5.477628857343615],
            [1.8838507851299868, -5.479951330350309],
            [1.8862243851606106, -5.478374398068693],
            [1.8933898989157827, -5.478826838881607],
            [1.892074288531953, -5.483061844064234],
            [1.89864735124917, -5.484990703820926],
            [1.9028887863904342, -5.482641853891811],
            [1.9061405942957326, -5.4836110490923895],
            [1.9089483216169367, -5.489211346337112],
            [1.9129862856645856, -5.486060924522333],
            [1.9170656697947699, -5.484942986490104],
            [1.9254240427235707, -5.485102079960339],
            [1.927801214494523, -5.487408406267587],
            [1.9328197383175867, -5.487103147313748],
            [1.934754456634833, -5.484891497926806],
            [1.9303984981562878, -5.481330118149471],
            [1.934316403095731, -5.479689089279767],
            [1.928207230038891, -5.473834836594705],
            [1.9280639224789842, -5.466145187209333],
            [1.9314485088149855, -5.458007257906648],
            [1.9273000581705535, -5.451676252141211],
            [1.930836800615179, -5.4517181269996415],
            [1.941389039442901, -5.442002056952051],
            [1.9436563786266556, -5.435213940151018],
            [1.9427486092193211, -5.4307112134357585],
            [1.9467929169620677, -5.431514717000152],
            [1.9554180249752278, -5.429304991476272],
            [1.9643048687970863, -5.42951812872329],
            [1.9652977392465902, -5.424421218673675],
            [1.968094940391762, -5.425622164664119],
            [1.9709149545590956, -5.422036124403341],
            [1.978833176261357, -5.422649962525039],
            [1.980521304239132, -5.425447447542941],
            [1.9857776495010346, -5.415557100417218],
            [1.9950102782606587, -5.419265611857643],
            [2.0006604887309414, -5.424779753610522],
            [2.0038053849006285, -5.4255146063893935],
            [2.008558001934683, -5.432626299612139],
            [2.0159194567469547, -5.433650245573704],
            [2.0242088104331875, -5.433630811136665],
            [2.0213612398047203, -5.427438921773641],
            [2.0271019486534843, -5.4255676638540455],
            [2.026564426372304, -5.4291017085724205],
            [2.029994488305985, -5.431412674825771],
            [2.027756182436415, -5.420850424060184],
            [2.030977951026692, -5.421061433033146],
            [2.033902053907981, -5.417762699763084],
            [2.0381907878736283, -5.4199260490207],
            [2.0378562781038765, -5.422210199717122],
            [2.04079549465543, -5.4278635028461055],
            [2.042968847563972, -5.425021499672214],
            [2.040845941207686, -5.4221878450084215],
            [2.042594362701664, -5.419652981633718],
            [2.0469924787044134, -5.427265803265654],
            [2.0508305530949515, -5.42093294740741],
            [2.0539966195518833, -5.4240060529262815],
            [2.053197449580213, -5.427722992317698],
            [2.056491795537379, -5.4314118496153],
            [2.059455604523453, -5.427605248333004],
            [2.0636235703610044, -5.429402732941303],
            [2.0656530587533366, -5.42455216433149],
            [2.0700056755975518, -5.427338988049949],
            [2.072952948088422, -5.425236272964042],
            [2.0819515703449962, -5.4369836406977505],
            [2.0815854220920005, -5.44013458282143],
            [2.0838032768503933, -5.445060035194594],
            [2.0827880360629925, -5.448676231507612],
            [2.0889860794815487, -5.453601059841812],
            [2.0898118447060114, -5.483071797667512],
            [2.0904888642300192, -5.52230073946031],
            [2.09151095763117, -5.564742451829376],
            [2.091471895539537, -5.581591528604094],
            [2.0927855999602607, -5.632408797941081],
            [2.0929218374589094, -5.645671544767428],
            [2.0942305385462805, -5.706011006132126],
            [2.096386187959325, -5.815317624118338],
            [2.097157669834274, -5.844268422978633],
            [2.090028820082942, -5.844555877880636],
            [2.0316297079725723, -5.845756746743584],
            [1.9777354518213965, -5.847144750544377],
            [1.8323392283939754, -5.849969257509498],
            [1.7886124384829654, -5.850978101630559],
            [1.7164795711557808, -5.852209090256317],
            [1.6917791798663415, -5.852784528489498],
            [1.5871879552940946, -5.8546690828109],
            [1.5863898123172335, -5.779800477859392],
            [1.585721603239789, -5.728362055936185],
            [1.5852512072888092, -5.705740234610691],
            [1.5843733587724749, -5.627230731682884],
            [1.5845717102836523, -5.583838827518607],
            [1.5827905746995075, -5.486158511087442],
            [1.583401292621763, -5.483536298363816],
            [1.583078753764459, -5.464745025274482]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.34353789660503, "lat": 33.07761492640572 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48067"],
        "coty_name": ["Cass"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cass County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01383819"
      },
      "bbox": [
        1.5827905746995075, -5.8546690828109, 2.097157669834274,
        -5.415557100417218
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6774892840607678, -8.932565352420783],
            [-0.5948814603503285, -8.849315983059629],
            [-0.5151270605128391, -8.768959492442171],
            [-0.4941479495862845, -8.748060121876264],
            [-0.42194085465949854, -8.67364428244958],
            [-0.41756937464925326, -8.692926497701452],
            [-0.386280994043064, -8.675832876834223],
            [-0.2822328334118619, -8.619114635856599],
            [-0.26696064843450024, -8.611210187166902],
            [-0.22226878763835173, -8.567511038652105],
            [-0.21042267432073794, -8.575947035751947],
            [-0.2037654540280574, -8.578632865398495],
            [-0.19860293272229332, -8.589290096142548],
            [-0.17133932118936107, -8.58094002416358],
            [-0.15369342859873308, -8.583459544911115],
            [-0.14238353715586388, -8.570812615160323],
            [-0.12950531761013614, -8.56445805968327],
            [-0.12636624054993756, -8.577662636667297],
            [-0.10779572248633408, -8.579678949312521],
            [-0.09517329957274129, -8.583685098272325],
            [-0.10036318343740584, -8.598684476220763],
            [-0.0896623764493154, -8.608074279686342],
            [-0.08373287042379371, -8.622406783204474],
            [-0.0828477114566347, -8.644292581591555],
            [-0.08446847589682614, -8.652536541137001],
            [-0.08152961865568083, -8.657914933348636],
            [-0.07551660593677763, -8.661491823664111],
            [-0.07403595553785733, -8.683701931584082],
            [-0.051553629183569434, -8.72490255453252],
            [-0.02945549364354311, -8.765877817442803],
            [-0.09533798095169847, -8.85081098110838],
            [-0.10049407069699387, -8.857181371695988],
            [-0.1195099330339143, -8.882416942908748],
            [-0.15647072940029327, -8.929535622092537],
            [-0.15812750989871754, -8.931958059594395],
            [-0.18719757441102827, -8.965256787867958],
            [-0.19077395593393995, -8.968482521464413],
            [-0.21319622907643065, -8.994400660398384],
            [-0.29591249938804504, -9.0889234218461],
            [-0.3230198593801739, -9.089174606004821],
            [-0.4009850771690941, -9.089508201132917],
            [-0.42352981381529675, -9.090188732122531],
            [-0.5113387499757667, -9.090955542891084],
            [-0.5292015748158568, -9.09102789246443],
            [-0.5184839510110545, -9.076144467158054],
            [-0.5602713809004838, -9.039456279807043],
            [-0.6386338623853478, -8.970231091660786],
            [-0.6405648198469877, -8.968956236394531],
            [-0.6793106308338321, -8.934401917364374],
            [-0.6774892840607678, -8.932565352420783]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.91977633929368,
          "lat": 29.876782562885445
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48149"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01383860"
      },
      "bbox": [
        -0.6793106308338321, -9.09102789246443, -0.02945549364354311,
        -8.56445805968327
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.815067992924365, -4.445118178363127],
            [-2.667194389682264, -4.5596767984042605],
            [-2.6353919725890855, -4.584227508560851],
            [-2.630048587620643, -4.584831871470431],
            [-2.623151914124543, -4.582275342220275],
            [-2.6143780335614473, -4.577304053407451],
            [-2.609038609185362, -4.579767551042512],
            [-2.6059545054914386, -4.584308533901923],
            [-2.603613964362701, -4.585250679318076],
            [-2.596201476336782, -4.581577117404549],
            [-2.5893866410256625, -4.580435843432236],
            [-2.584373159129507, -4.581941998764229],
            [-2.579004394095661, -4.581896505425263],
            [-2.578814977827305, -4.586347915186623],
            [-2.5744920399431463, -4.586975153174488],
            [-2.567350375339326, -4.585593353873843],
            [-2.558673686120887, -4.587241549295051],
            [-2.554835320013099, -4.592179337628981],
            [-2.5435673687381923, -4.586605906624063],
            [-2.537422602514125, -4.582329355412501],
            [-2.529679193151977, -4.582927343870011],
            [-2.524101353047365, -4.585054275534408],
            [-2.517723960395126, -4.589952347912933],
            [-2.5129507851203, -4.586497226691031],
            [-2.5070686811893856, -4.599864065832282],
            [-2.4979134392552536, -4.599677096706484],
            [-2.4892332604131853, -4.600691379912807],
            [-2.4809227705307872, -4.604893108459614],
            [-2.4747819447736727, -4.614401842979076],
            [-2.4733346765436055, -4.619889598966802],
            [-2.4675633949208273, -4.623582296991834],
            [-2.4567985539833255, -4.623361206413546],
            [-2.454695538735579, -4.628251768807543],
            [-2.4515979950476527, -4.628368096455831],
            [-2.4486466747572737, -4.624564203762069],
            [-2.4448725345754885, -4.622356609791218],
            [-2.4447605281205, -4.618170663880622],
            [-2.4413684096052677, -4.611068036838564],
            [-2.4375979816267863, -4.610172552027286],
            [-2.423947595403668, -4.611488087558952],
            [-2.41701171687127, -4.608892083018216],
            [-2.4125479301466632, -4.61490663793187],
            [-2.409036418828304, -4.616115936774444],
            [-2.40513702637104, -4.620976545416386],
            [-2.3978385633176207, -4.614539815745117],
            [-2.395402501648086, -4.611059804584111],
            [-2.3919770838870766, -4.60119030087619],
            [-2.3951084219504777, -4.684242479827722],
            [-2.3986715879345573, -4.785285666913415],
            [-2.401537874008945, -4.853653803772014],
            [-2.404275976523736, -4.95414105237643],
            [-2.407054224337452, -4.9435018619715505],
            [-2.4046635936276757, -4.937451323750031],
            [-2.4062225653943474, -4.9342221549209775],
            [-2.409589252746315, -4.9382417002222825],
            [-2.411879950992091, -4.937056402219394],
            [-2.417970282621799, -4.920114957359979],
            [-2.42229422134657, -4.922412893250152],
            [-2.4266276798147035, -4.921769757425227],
            [-2.4271180623085025, -4.9162322527078794],
            [-2.4340551912621695, -4.9143952781088585],
            [-2.4387464245718418, -4.918125993015292],
            [-2.441370851496184, -4.917125269692977],
            [-2.4423550724995082, -4.911307203511026],
            [-2.441582601462925, -4.90508290993333],
            [-2.4455530318378553, -4.902015583729533],
            [-2.4487553926497845, -4.902403249250985],
            [-2.457594912731846, -4.905819564881264],
            [-2.4620227311771172, -4.903007583509264],
            [-2.4577472705284764, -4.892525481073041],
            [-2.4612766525370664, -4.889904473535436],
            [-2.4660625170798665, -4.890370118059596],
            [-2.4681806362473955, -4.886801985197739],
            [-2.4717853975546715, -4.889099097084346],
            [-2.4751106232919717, -4.895281317807988],
            [-2.479246643610418, -4.8927975352760855],
            [-2.4829017301492873, -4.89278018995162],
            [-2.483394459038926, -4.884903464321977],
            [-2.486715270965034, -4.881948548139918],
            [-2.4876546319814437, -4.891795452084538],
            [-2.491123036699281, -4.900153084810605],
            [-2.505830361449256, -4.8961632377076025],
            [-2.5046386471664173, -4.887165785073194],
            [-2.5128585125641583, -4.888502281345258],
            [-2.516238898929786, -4.884665007174517],
            [-2.5257586878755185, -4.879223321966185],
            [-2.5314581410122328, -4.881295499544453],
            [-2.533853507757624, -4.879761866064351],
            [-2.532367378560697, -4.874121366741999],
            [-2.532304198654162, -4.868260811481205],
            [-2.5372916601179134, -4.86417426656022],
            [-2.544517671201567, -4.864884468067222],
            [-2.547192828439864, -4.863905147140829],
            [-2.5532953331290447, -4.871610479928979],
            [-2.5581287924550495, -4.873607529733535],
            [-2.561268140508027, -4.86830780005563],
            [-2.5629570977237144, -4.863076771115143],
            [-2.568066790836321, -4.857169320611354],
            [-2.5745744886406983, -4.853890452581561],
            [-2.58236620937057, -4.853731514305944],
            [-2.5868523647821484, -4.862578004242179],
            [-2.5866842681291096, -4.869892160606468],
            [-2.587830927554997, -4.8747514834981365],
            [-2.587081855262591, -4.879959528833147],
            [-2.59177814298368, -4.880037324528045],
            [-2.595779024079897, -4.883119087893541],
            [-2.5975879807717206, -4.879353308670899],
            [-2.5942167855946585, -4.8700696286417555],
            [-2.6001628690762737, -4.868712095920236],
            [-2.6031803821713395, -4.865994815968888],
            [-2.607052448316463, -4.86851360158599],
            [-2.604774104506344, -4.872898730658253],
            [-2.605045814601782, -4.8798731883063],
            [-2.608427147624337, -4.880267482893887],
            [-2.6149882174102914, -4.874497327287001],
            [-2.6184065496491327, -4.868661934651094],
            [-2.6218295368005493, -4.867613570102344],
            [-2.6246835758516407, -4.870358286097159],
            [-2.6265689997342654, -4.876343250106308],
            [-2.6350146947636612, -4.875957605277871],
            [-2.6353862418212417, -4.872154035863396],
            [-2.6313264683658124, -4.871926229378738],
            [-2.6325291165938336, -4.867428951183449],
            [-2.631791723983871, -4.858057733281199],
            [-2.633502272585132, -4.855385598361975],
            [-2.640141892410492, -4.856170416373562],
            [-2.6444797295671787, -4.861077919533306],
            [-2.6475619393860272, -4.857521490097419],
            [-2.650952131235661, -4.857304853950642],
            [-2.65507447998044, -4.8602705296377104],
            [-2.660867398207739, -4.858504536520636],
            [-2.6636578978776444, -4.860890845514494],
            [-2.667002319964831, -4.860331792719287],
            [-2.6726413950552566, -4.853346372674627],
            [-2.677586463730096, -4.849646970292456],
            [-2.6859067516948003, -4.856670422113654],
            [-2.6894034417077965, -4.855494528850442],
            [-2.6939510310944685, -4.8588138632820455],
            [-2.697245555485259, -4.85617205668113],
            [-2.6954863867099923, -4.8538207735035135],
            [-2.6993295182245967, -4.84617102809509],
            [-2.6975077837674895, -4.840866716807632],
            [-2.8305453826055906, -4.834870707665961],
            [-2.8734211408200854, -4.8330544505423205],
            [-2.8619401187134375, -4.580847634533952],
            [-2.85533403126213, -4.437962322345971],
            [-2.852255716908466, -4.440098398555228],
            [-2.8474362282075045, -4.429616086605829],
            [-2.835025314188306, -4.429567848024358],
            [-2.8257437172769624, -4.426968199456973],
            [-2.8226122534751514, -4.428921344051401],
            [-2.8218232478823477, -4.432180846230145],
            [-2.8227572814130775, -4.438130498538322],
            [-2.8219231637020297, -4.443509786628764],
            [-2.815067992924365, -4.445118178363127]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.77800702969152, "lat": 33.97455500881141 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48155"],
        "coty_name": ["Foard"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Foard County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "01383863"
      },
      "bbox": [
        -2.8734211408200854, -4.95414105237643, -2.3919770838870766,
        -4.426968199456973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.3864501179175063, -9.123002025978737],
            [0.44216036185448204, -9.121809358241645],
            [0.4422024498272493, -9.107267749779814],
            [0.4439953326428885, -9.100532309694614],
            [0.4494551410479416, -9.09790517929347],
            [0.4469610355049567, -9.089571353732657],
            [0.450636341296202, -9.08581659940137],
            [0.44850434688203605, -9.079774046871826],
            [0.4420510414287481, -9.075279136361388],
            [0.4349646933013368, -9.067137298791991],
            [0.43726915287229445, -9.065004297912392],
            [0.44293668733711755, -9.067050756140741],
            [0.4479494085275989, -9.065073183764909],
            [0.4498080597014119, -9.061740454298961],
            [0.44767327882784164, -9.055715923906657],
            [0.43797653026423056, -9.050369854393644],
            [0.43447867271024726, -9.051374413536378],
            [0.42566015753513375, -9.059681117145256],
            [0.421469501858908, -9.058923370205852],
            [0.4168663520747108, -9.053614898199722],
            [0.4137661240141842, -9.052826720887007],
            [0.41162896019635176, -9.049626511097511],
            [0.41200973755091536, -9.046302322241516],
            [0.41582524379136093, -9.042797342435069],
            [0.4221760719567824, -9.041113286481602],
            [0.4284924318642174, -9.03820262745414],
            [0.4366398990093062, -9.037283869808379],
            [0.44288941563601997, -9.04130083239991],
            [0.4451156572389852, -9.046742061674088],
            [0.4492914794721918, -9.045592913050912],
            [0.4515186306461943, -9.037015671501427],
            [0.44966166700631993, -9.029217964963593],
            [0.4443264612016401, -9.023835001766846],
            [0.4465063858642563, -9.020667732759192],
            [0.4514174153565158, -9.022990566841015],
            [0.45715982245905185, -9.022991216419857],
            [0.459769095371282, -9.01741367879787],
            [0.4570906852310989, -9.008425622967707],
            [0.45366643380808475, -9.006286942368718],
            [0.44988086342813954, -9.006515649938498],
            [0.4420365584164114, -9.008973459235936],
            [0.436535584052628, -9.009003469152516],
            [0.43471959937089544, -9.006509782262842],
            [0.435348328076731, -8.998277590131037],
            [0.488962699071028, -8.997675813049637],
            [0.4886579234321355, -8.98591611623445],
            [0.506323206808629, -8.985597678646918],
            [0.5491789822627751, -8.966675555297618],
            [0.5635612494670443, -8.960775918820264],
            [0.6144631259309723, -8.938514338399637],
            [0.6146750037641687, -8.938181826350585],
            [0.6615351231319984, -8.968045544642186],
            [0.6977263416806376, -8.99167757368001],
            [0.7501880668746199, -9.024787824889867],
            [0.7657558586109858, -9.034412810623342],
            [0.8064411515988462, -9.060297303813556],
            [0.8412591656635893, -9.078429378753267],
            [0.9287780808308904, -9.123778937457445],
            [0.9643264372076256, -9.142620440620796],
            [0.9451714312452735, -9.224439403578529],
            [0.9318085171802811, -9.282068138936925],
            [0.8551489825621007, -9.283380566367823],
            [0.8556287427288221, -9.28643238157824],
            [0.8541894685720408, -9.292748353189461],
            [0.8505810662302914, -9.296191955557257],
            [0.8505721405895751, -9.298722900395328],
            [0.8541020422395473, -9.301799834111682],
            [0.8594732061797375, -9.313524759188896],
            [0.8559790548940572, -9.318588677023882],
            [0.8580063293854221, -9.325901590015938],
            [0.8481982403728929, -9.33059275741946],
            [0.8408525023200933, -9.33140840396258],
            [0.8364769209188352, -9.337217832641956],
            [0.8335496945111739, -9.345020066184373],
            [0.8316801293691662, -9.355709433556466],
            [0.8294819326847366, -9.359900387652914],
            [0.8338542436922897, -9.36280980136779],
            [0.8351084779544314, -9.365991216608016],
            [0.82970786887376, -9.368110924166226],
            [0.8276495401029439, -9.370716904302428],
            [0.8309966694866853, -9.377647981087915],
            [0.8289683213609166, -9.38134949425361],
            [0.8237413397728393, -9.383556655212741],
            [0.8220777210505426, -9.385816393087307],
            [0.8206372175968294, -9.392859343542789],
            [0.8129582394753898, -9.392784113023382],
            [0.806461036455321, -9.39124178237098],
            [0.8010102682736678, -9.396796504744374],
            [0.7985833570187886, -9.40096004294804],
            [0.7901825501887854, -9.407286789008221],
            [0.7880877656332406, -9.410725673269488],
            [0.7934877049012384, -9.41505146870885],
            [0.793812393789718, -9.418980777113067],
            [0.7917845756895446, -9.424361828381933],
            [0.7854147105264858, -9.427333753387707],
            [0.7772703546390558, -9.4234528494551],
            [0.7763149538975873, -9.425733214643406],
            [0.7667388699089911, -9.42570023934331],
            [0.7651032101609859, -9.429104022792725],
            [0.7565313461498869, -9.423543422327105],
            [0.7559387828125463, -9.421307109848664],
            [0.7492229691244215, -9.420703043613871],
            [0.6792905448548122, -9.396281724769995],
            [0.6521883354476418, -9.424208918143961],
            [0.6401168468886261, -9.41267622345344],
            [0.5967139134445751, -9.457501721542494],
            [0.593852978732925, -9.453835714271257],
            [0.5886074980558417, -9.452209032284772],
            [0.5814794923910925, -9.452905507040855],
            [0.5780013978267907, -9.451052845764943],
            [0.5751881764384442, -9.453442525615127],
            [0.5688262469385756, -9.453429026116394],
            [0.5683088585062115, -9.449478123966719],
            [0.5641537170631722, -9.446007771198925],
            [0.5643851335194565, -9.441157580566117],
            [0.5599414394228563, -9.4329820349348],
            [0.5589143273478502, -9.428419897818305],
            [0.553132147655683, -9.421380912098503],
            [0.5543341278313381, -9.414038202705667],
            [0.55729637280238, -9.409884390754092],
            [0.5557958156361985, -9.405899092533383],
            [0.5524843268201188, -9.406492370361837],
            [0.5364809553785366, -9.401590766127498],
            [0.5340449984599215, -9.394784203210472],
            [0.5311014737620663, -9.391722452908141],
            [0.5234019071295377, -9.392616855429916],
            [0.5157571331364528, -9.389418681835572],
            [0.5123058523792272, -9.388950314641408],
            [0.5067830576830886, -9.38463948954338],
            [0.5077103367684562, -9.380263927790953],
            [0.5043920203089964, -9.376255349768273],
            [0.5121662753403335, -9.369744504750665],
            [0.5164817129847209, -9.368895631026854],
            [0.5171288242644175, -9.363793823556495],
            [0.5158957003247826, -9.36055239853406],
            [0.5126847012254251, -9.360397497077054],
            [0.5095091533916002, -9.348797145438208],
            [0.5032856549779983, -9.34239131129149],
            [0.4921637236528127, -9.339871418033358],
            [0.4924565365670055, -9.334784942074485],
            [0.490298771058217, -9.329960574910778],
            [0.4901518060135021, -9.322851528133592],
            [0.48769816846722, -9.317826612430585],
            [0.4892165595365292, -9.313769242886135],
            [0.48689016608999025, -9.310794260686217],
            [0.4793702134434596, -9.311465919532324],
            [0.4778578121973939, -9.307383480212335],
            [0.4740003117807775, -9.30362092821208],
            [0.4757369352367498, -9.299732203805965],
            [0.4741759844451112, -9.294357855411551],
            [0.47068757465321165, -9.288747680703537],
            [0.462665147698654, -9.291463457403777],
            [0.46038805339155553, -9.293609520192417],
            [0.45645333028771984, -9.293003425073652],
            [0.4528991018108255, -9.287570080806105],
            [0.4474973811461412, -9.2852177736097],
            [0.4442625294893727, -9.281158498413955],
            [0.4380497516637919, -9.281599889637347],
            [0.43300317878631867, -9.279649295125763],
            [0.4318728406976381, -9.277001302566442],
            [0.43797834770390975, -9.273263386538215],
            [0.43807320100799674, -9.27072529713724],
            [0.42988178578597724, -9.268875029624793],
            [0.4308193730053618, -9.265317803365242],
            [0.42573931120450964, -9.264886370415162],
            [0.4257635711697972, -9.261403712294493],
            [0.42196287574045765, -9.261059457136403],
            [0.42021460883096207, -9.25085493053103],
            [0.41478961307013074, -9.250829239165046],
            [0.4109153439917571, -9.24661164978468],
            [0.41348919178810856, -9.241807691496154],
            [0.4115391697294961, -9.239060705884873],
            [0.41186574135501824, -9.233381671718107],
            [0.41756188455867266, -9.229050946709105],
            [0.4226505801505971, -9.23202753301281],
            [0.4328230162352804, -9.231014274420204],
            [0.43663662726169444, -9.227708019817433],
            [0.4408848881531106, -9.228313359251445],
            [0.44257654950515973, -9.21647086595415],
            [0.43720107353827836, -9.215686559569923],
            [0.4321450596980003, -9.212726416040587],
            [0.42895077748148275, -9.21388600562552],
            [0.42276069257205, -9.213817070021326],
            [0.41755695572667917, -9.211606165868371],
            [0.4151935381725537, -9.20553783488526],
            [0.41952706287835906, -9.20053230536852],
            [0.4153945943784203, -9.198110416008875],
            [0.41627105062527975, -9.188653337815522],
            [0.41474242437126735, -9.18440824634073],
            [0.42198144869421456, -9.18561761647718],
            [0.4277824982941575, -9.177260013986267],
            [0.42731655524321116, -9.170731666473776],
            [0.4246788809161953, -9.16623608128969],
            [0.42504258932812733, -9.162242352440687],
            [0.41727014383020294, -9.159013601338218],
            [0.4115638104969595, -9.155606667928742],
            [0.4088684135176131, -9.148447083219514],
            [0.4091692211382681, -9.1407351828982],
            [0.4119554173003745, -9.135997963085153],
            [0.4095577783123402, -9.133027976766728],
            [0.40543477077437085, -9.133513041149433],
            [0.4017070012557295, -9.132094253122068],
            [0.39782340422595097, -9.127868575994327],
            [0.390380491078968, -9.123602056391716],
            [0.3864501179175063, -9.123002025978737]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.77099698616611,
          "lat": 29.527545615338287
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48157"],
        "coty_name": ["Fort Bend"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fort Bend County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01383864"
      },
      "bbox": [
        0.3864501179175063, -9.457501721542494, 0.9643264372076256,
        -8.938181826350585
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.95295225209058, -4.23687023536492],
            [-4.879757410026338, -4.241780346235965],
            [-4.806433820728479, -4.246617979543653],
            [-4.684764601759514, -4.254816901654391],
            [-4.642112054334348, -4.257538371896967],
            [-4.591850755986268, -4.261301429102595],
            [-4.583754007078543, -4.261662031465071],
            [-4.523880890359155, -4.26527067083033],
            [-4.532658932287063, -4.4196397431164005],
            [-4.539278351842119, -4.538103710426673],
            [-4.542154039187142, -4.5874093658015385],
            [-4.548373145238813, -4.697339602163298],
            [-4.551545772903932, -4.755174163443257],
            [-4.682000377453357, -4.746725436866105],
            [-4.68707731487827, -4.746075469749974],
            [-4.7883189794539085, -4.739416343332816],
            [-4.840791681120858, -4.735762964485099],
            [-4.902421112156568, -4.73166193346915],
            [-4.987377815322324, -4.725660478755564],
            [-4.981448507926108, -4.639160791365912],
            [-4.967836401980649, -4.447993437568239],
            [-4.965390445420801, -4.411859467781418],
            [-4.958712860678599, -4.315990545858914],
            [-4.95295225209058, -4.23687023536492]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.35172993336964,
          "lat": 34.068610893509344
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48279"],
        "coty_name": ["Lamb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lamb County"],
        "coty_fp_code": "279",
        "coty_gnis_code": "01383926"
      },
      "bbox": [
        -4.987377815322324, -4.755174163443257, -4.523880890359155,
        -4.23687023536492
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.19220191037787962, -7.381836207829879],
            [0.19394957141633704, -7.376986384012491],
            [0.19239016153563715, -7.3714615268472174],
            [0.1893717253651449, -7.367805081025976],
            [0.19140365121482852, -7.363868846415436],
            [0.2625620521763206, -7.326029621551566],
            [0.31868193734305517, -7.29597965731616],
            [0.3231238594084977, -7.2932590959405825],
            [0.33906670985918796, -7.285116760899483],
            [0.3857108009760865, -7.260155451524808],
            [0.47015001602927353, -7.214691505811101],
            [0.5560354660106237, -7.168769435495444],
            [0.5789883274069513, -7.156768964117577],
            [0.6441134815997418, -7.121899405193893],
            [0.6459482370272159, -7.128813426819144],
            [0.6523890118965987, -7.137950521036355],
            [0.6601558425974151, -7.142762459084348],
            [0.6664956114393507, -7.140085624166369],
            [0.6666629483600361, -7.13616749183278],
            [0.6729074425298416, -7.133340866070971],
            [0.6737736905846418, -7.125055542651562],
            [0.6768749879071675, -7.122493632203676],
            [0.6767014060074275, -7.119408131445419],
            [0.6730246181093081, -7.111030517381127],
            [0.6732622785479224, -7.104976263294609],
            [0.6695165715346278, -7.0967646199492345],
            [0.6727069702990035, -7.091363207050788],
            [0.6846587487156497, -7.086481315300951],
            [0.6881521511890999, -7.0868713571921536],
            [0.690279175434083, -7.091452604590171],
            [0.6949712595717387, -7.096456952021169],
            [0.6980341956013928, -7.102243922777109],
            [0.7024424098126456, -7.107781570302621],
            [0.7034016024928087, -7.112956433899793],
            [0.7095786854410551, -7.124515649050507],
            [0.7076939551922896, -7.132461687560543],
            [0.7087043864650525, -7.136160209792906],
            [0.7045645612440433, -7.1412709899899305],
            [0.7047602463913385, -7.1459721692445815],
            [0.7010450517211992, -7.148064444581716],
            [0.6997062189024305, -7.153744367207234],
            [0.6932948722922859, -7.156899085171695],
            [0.7001832227427526, -7.162145695105629],
            [0.7038480924637203, -7.1721791897596425],
            [0.7037251447303233, -7.181265053659381],
            [0.7026392777127605, -7.186235253299867],
            [0.6963226661042037, -7.184880829547967],
            [0.6936278065659724, -7.188334274419086],
            [0.6888650195006428, -7.188733119603093],
            [0.6819644668974452, -7.185798274273223],
            [0.6744696888210587, -7.188412087079291],
            [0.6724283804325973, -7.19390021504954],
            [0.6752068421295029, -7.199186517178239],
            [0.6702467558869157, -7.203346111751215],
            [0.6685745221727409, -7.206691277497522],
            [0.6704612884348566, -7.208843047782518],
            [0.6774678684181874, -7.211159761836431],
            [0.6784990647095054, -7.215478009027092],
            [0.6835210424524136, -7.217353125266312],
            [0.6870172501718073, -7.22126803792301],
            [0.6897263209924204, -7.231378146624728],
            [0.6851509613395224, -7.235693417806492],
            [0.6815804421996756, -7.240556442149458],
            [0.6840715893591968, -7.243409135293647],
            [0.680305362671654, -7.247351242075175],
            [0.6830119500077335, -7.253135310355649],
            [0.6884978115947261, -7.253862300868054],
            [0.6931960557400576, -7.250038797325205],
            [0.6957029875088974, -7.2575100049820165],
            [0.6992449044818317, -7.262305995180559],
            [0.6992389047779572, -7.268933505551086],
            [0.6958199693599451, -7.269446230461978],
            [0.6925410921879221, -7.266361383606503],
            [0.6881890367403407, -7.265529006864157],
            [0.6787943405633114, -7.2758165634812535],
            [0.6788552363296791, -7.2814079013195],
            [0.6831914873208786, -7.279604871585673],
            [0.6879817313560017, -7.28039444083251],
            [0.6969241928017585, -7.277243458214607],
            [0.7009825123833987, -7.277054476720858],
            [0.7049881708913505, -7.279416732490381],
            [0.7092403575904237, -7.285341979734761],
            [0.7091925039197969, -7.2927437122185035],
            [0.7077669575050568, -7.29848151265318],
            [0.7095775317454012, -7.304671462636984],
            [0.7088362542535455, -7.315751740023292],
            [0.7099624957971732, -7.320417980866892],
            [0.7135800973915469, -7.327331609711056],
            [0.7193048377255834, -7.330898065352145],
            [0.7202439604110193, -7.332900259438843],
            [0.7171540921321762, -7.336930125531061],
            [0.7183887947940127, -7.345781831178182],
            [0.7249617031409642, -7.347660525546953],
            [0.7241781542192248, -7.352014502264061],
            [0.7266694309867815, -7.354168769879525],
            [0.727536431693445, -7.360479440435234],
            [0.7261951771626153, -7.36439899751716],
            [0.7322277545832097, -7.366980509985867],
            [0.7342866951790225, -7.370132287335241],
            [0.7400108201628873, -7.37088456297703],
            [0.7402757965910783, -7.373225941948956],
            [0.7481364933680731, -7.372590685755679],
            [0.751633013363074, -7.381650699038589],
            [0.7431594419889052, -7.382445642524446],
            [0.7411674086377931, -7.388005725404549],
            [0.7384634679683301, -7.391002988540151],
            [0.7409305445934246, -7.394065327188676],
            [0.7532062343401393, -7.393471251136491],
            [0.7550305924076406, -7.399097417679362],
            [0.7568942586026911, -7.409122513848861],
            [0.7555261867180361, -7.420713364398813],
            [0.7520824352213208, -7.421713886752412],
            [0.7508595088220699, -7.417743167367037],
            [0.7441744553231898, -7.4201769262503126],
            [0.743118473634336, -7.422720411276585],
            [0.7458762841444941, -7.430186045218282],
            [0.7419372750427297, -7.436307087312687],
            [0.7435163512963898, -7.4430867561287695],
            [0.7336808066761475, -7.449730610618646],
            [0.7270353335550758, -7.441322441937621],
            [0.7233482041017691, -7.441691517647503],
            [0.716684934992429, -7.446258294141546],
            [0.7127352021761294, -7.452364613738028],
            [0.7162248736926535, -7.456186060535575],
            [0.7150675961477516, -7.45863557989989],
            [0.7103675756526044, -7.459724612095328],
            [0.7071443431561983, -7.463689725877182],
            [0.6977611617123861, -7.467586962533479],
            [0.6953204519102943, -7.478886536964869],
            [0.7001724971903096, -7.48269144575901],
            [0.6959117748237754, -7.488074584655958],
            [0.6990988379421054, -7.492459215194264],
            [0.6963001413353335, -7.499214911801964],
            [0.6980377125854533, -7.508366074628401],
            [0.6955966829617838, -7.513783180705314],
            [0.6906759580539957, -7.517921676141055],
            [0.6860218742107766, -7.519737130103522],
            [0.6829286382778681, -7.52300854398911],
            [0.6785805249775391, -7.530095202970833],
            [0.6787504092928698, -7.537517828763436],
            [0.6808496341781987, -7.546232258574529],
            [0.6807883581568068, -7.556368529646235],
            [0.6838145707066625, -7.5636086397671285],
            [0.6902930278547531, -7.570413226566805],
            [0.6951063997498576, -7.574061958501642],
            [0.6930070280987553, -7.5789394601938485],
            [0.6875327684485868, -7.578749737859083],
            [0.6838701419658355, -7.584828640380137],
            [0.6812504847629627, -7.5856641275485925],
            [0.6785512601330942, -7.582919272860475],
            [0.6730341196369498, -7.588295302623684],
            [0.67190776561218, -7.595043176867188],
            [0.6665215643123824, -7.59399056898365],
            [0.6621614446652373, -7.598022131485302],
            [0.6582852219562759, -7.598432232787425],
            [0.6551970089819906, -7.601981958721487],
            [0.6577666058333972, -7.609056648504889],
            [0.655422263000746, -7.615947798589294],
            [0.6576837181166197, -7.621027003676313],
            [0.6632398427739834, -7.636917907387779],
            [0.6648286975935125, -7.643608925417371],
            [0.5702395864823211, -7.644989782702692],
            [0.48606875587516507, -7.645902184911265],
            [0.48324701250279106, -7.646639693138078],
            [0.47332216123587967, -7.651853588701722],
            [0.45685178955757644, -7.664833978875277],
            [0.44882315395123684, -7.667912042166834],
            [0.4408046998206039, -7.6660668898634485],
            [0.4353993103473556, -7.668615388686263],
            [0.4260852429818176, -7.668135402682915],
            [0.4219775570808583, -7.669770890943288],
            [0.4111010524424809, -7.679549499939957],
            [0.39272094520658657, -7.693135559549995],
            [0.3803328245436258, -7.700276460484983],
            [0.3703465471050231, -7.707209295230598],
            [0.359776636985955, -7.715565408876091],
            [0.34668886095581003, -7.724126039958499],
            [0.33843750938027384, -7.728727892036807],
            [0.317116590781963, -7.743067875687393],
            [0.2992270936628044, -7.745960972140374],
            [0.2863354691121759, -7.753421003281701],
            [0.2799546063684801, -7.755827000842327],
            [0.26790816818837265, -7.756726379065905],
            [0.2632704507775536, -7.761108954653607],
            [0.25771017733483365, -7.763357128873294],
            [0.2563896214141023, -7.7596468024708924],
            [0.25894600676158835, -7.754048891719816],
            [0.2601075795137388, -7.739525011702476],
            [0.25618568195519315, -7.738959569399535],
            [0.2513103593485593, -7.731838394511238],
            [0.2440839798096559, -7.730870113142185],
            [0.2409152553375707, -7.728816968509526],
            [0.24155382206220766, -7.721906522247239],
            [0.24515983485152976, -7.713234459151189],
            [0.2454507248739417, -7.709297820721396],
            [0.25055628882033215, -7.704904584114128],
            [0.25239740760998963, -7.700563231761795],
            [0.2510875959270478, -7.697799237408831],
            [0.25246438960966344, -7.694247865146526],
            [0.25733375575936535, -7.69284962420631],
            [0.25740214196546674, -7.689829633194498],
            [0.2531805168801516, -7.685939741832933],
            [0.25721775923155604, -7.680813185441607],
            [0.2507087314976747, -7.674119551697357],
            [0.2456088758891359, -7.672090871087352],
            [0.24422562494020558, -7.668335991338527],
            [0.24665713619079238, -7.665235499010144],
            [0.2432692352415174, -7.661524867615983],
            [0.23610979916002456, -7.658776031732154],
            [0.23352516978946578, -7.659221195209285],
            [0.23145705620271448, -7.653446563888753],
            [0.22689917072639432, -7.650029036785349],
            [0.22673837265444582, -7.6452131155792555],
            [0.22410799926797897, -7.641659676028669],
            [0.22658663397167073, -7.632125042652397],
            [0.22610414674923654, -7.624430022902889],
            [0.22737808273316337, -7.6215697970862175],
            [0.22262108862425314, -7.618627329119944],
            [0.22260419498436038, -7.6154410933960826],
            [0.21257990109694452, -7.599120343243061],
            [0.2085380827054799, -7.589952154131168],
            [0.20994186820024563, -7.581925374445637],
            [0.20737017662049245, -7.57904198699002],
            [0.20881252929541633, -7.572008618121987],
            [0.20850405227507973, -7.553951514278759],
            [0.20577697721079066, -7.551696906910667],
            [0.20333351219707652, -7.542742562202216],
            [0.19799038551301626, -7.540081308347084],
            [0.19945910482111162, -7.5375126158448476],
            [0.19812608571497206, -7.52843483053914],
            [0.19917304236687564, -7.521104399974386],
            [0.19301887654972488, -7.516551719396398],
            [0.19351504227985125, -7.512193864641409],
            [0.1960416663664209, -7.5099079938452284],
            [0.19088141748876192, -7.498780805764753],
            [0.19102135163019776, -7.496965521451407],
            [0.18364471367342022, -7.492075269002642],
            [0.18166410653531584, -7.485961332625857],
            [0.18317193101666884, -7.481092064517473],
            [0.18652437773897126, -7.47873639552908],
            [0.18927794041202237, -7.481577481412949],
            [0.1956348119820307, -7.472777776975967],
            [0.19637647331904456, -7.46772737043937],
            [0.19316176174033123, -7.465830146746791],
            [0.1944357349089976, -7.461300809727742],
            [0.1892172634862995, -7.455737773295723],
            [0.18698221403377588, -7.45614020845803],
            [0.18445080766726005, -7.452134225068375],
            [0.1851953107733537, -7.442981501634096],
            [0.1839506425904431, -7.440259456622009],
            [0.18667834365622382, -7.437850494439252],
            [0.19159583779408326, -7.438873164000841],
            [0.19056509668792565, -7.434286906136985],
            [0.18623729726958532, -7.428014457803855],
            [0.18872350472859808, -7.425885140492807],
            [0.19007027540999222, -7.4198694759534565],
            [0.19377135394554032, -7.415534518090929],
            [0.19190752476293968, -7.402927920471449],
            [0.19504222029744886, -7.400003096780433],
            [0.19495690062339754, -7.39270594287174],
            [0.1915762818154097, -7.388443512563383],
            [0.19220191037787962, -7.381836207829879]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.99563383582132,
          "lat": 31.296514348455407
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48289"],
        "coty_name": ["Leon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leon County"],
        "coty_fp_code": "289",
        "coty_gnis_code": "01383930"
      },
      "bbox": [
        0.18166410653531584, -7.763357128873294, 0.7568942586026911,
        -7.086481315300951
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.245155734433161, -7.560943753762467],
            [2.3004179771151527, -7.555952195509179],
            [2.3957285176677643, -7.54736556389189],
            [2.50971404749089, -7.536753952717305],
            [2.5200460627238925, -7.547018966811365],
            [2.527917273775688, -7.544988756753795],
            [2.535885184376101, -7.534685557861763],
            [2.543106458977948, -7.529618343085956],
            [2.550188033555127, -7.526330085883241],
            [2.5532381960727424, -7.525261121087156],
            [2.5564318729937825, -7.527868130895328],
            [2.5666101024275023, -7.527045593991128],
            [2.56834751134844, -7.532483772000694],
            [2.5673018539780066, -7.537175546767223],
            [2.5646684087037106, -7.539090097710753],
            [2.5592049857025807, -7.540043311436778],
            [2.5592693131631057, -7.543130241543179],
            [2.5622791978854518, -7.546374390701336],
            [2.564580767674073, -7.552960871677727],
            [2.5615034369121132, -7.555444770937258],
            [2.55423106334388, -7.555844991125612],
            [2.5545786554848737, -7.563136099218977],
            [2.5567695565396726, -7.568201947806782],
            [2.5581568735645215, -7.575593397705352],
            [2.564117805124123, -7.584536635591625],
            [2.562979488148155, -7.596799283270327],
            [2.5583780346298415, -7.599567387095772],
            [2.5555230924117436, -7.605360420677015],
            [2.5551996241346, -7.611236746345182],
            [2.5468719443286276, -7.614202632199984],
            [2.543226767829631, -7.61765651667863],
            [2.5470415545800362, -7.619758775292448],
            [2.5492245064622794, -7.624023130955893],
            [2.556196558460387, -7.622771870444574],
            [2.553430447580634, -7.626799414519463],
            [2.553229633420295, -7.632379639056169],
            [2.563559758690868, -7.633038278570839],
            [2.570052121127474, -7.636303972564649],
            [2.5742166021168273, -7.636178785893876],
            [2.5733074896532124, -7.640915789020543],
            [2.5766587388433067, -7.64409169033437],
            [2.5804143842273706, -7.644416371947208],
            [2.5820897583953233, -7.648614013408453],
            [2.580303685545027, -7.6532233608787275],
            [2.573372078855538, -7.65311186757488],
            [2.571030736683105, -7.655462656864872],
            [2.5718497939107285, -7.659008041308144],
            [2.575984360288287, -7.663195895503968],
            [2.581631290127194, -7.665230025069031],
            [2.581734527352958, -7.668501302992381],
            [2.577712860853349, -7.671458456869628],
            [2.5804655700897197, -7.6740784401995805],
            [2.591931052006707, -7.67770847739117],
            [2.591864135029648, -7.680605111625873],
            [2.5864424470087894, -7.684470038586969],
            [2.580277859296464, -7.690196396674344],
            [2.5723635426785174, -7.690308042045815],
            [2.570813602566215, -7.691561111505521],
            [2.5662133811760337, -7.702298363610395],
            [2.5605145037286126, -7.700713232429503],
            [2.5556612428737178, -7.701628822588605],
            [2.5519924720473233, -7.707184390619277],
            [2.5474077368587724, -7.703303851717976],
            [2.543461259119361, -7.6980425221833],
            [2.5385694219885697, -7.7017035287170605],
            [2.536087055978816, -7.708961422113795],
            [2.533056057446077, -7.71139258359569],
            [2.5374015691586185, -7.719403170564658],
            [2.5435448014657736, -7.720355111421937],
            [2.5454067149928035, -7.722994367528751],
            [2.541279877847015, -7.734852051719905],
            [2.537039210569057, -7.737428061093428],
            [2.538405173588609, -7.7403611886222405],
            [2.5421915784044855, -7.741878841033398],
            [2.548893437720261, -7.7395353209500355],
            [2.5603590052019007, -7.745735916823952],
            [2.5613825484879027, -7.752622152580775],
            [2.5674440924042816, -7.753741336144628],
            [2.57382397121076, -7.751890307216501],
            [2.574964946899112, -7.755478638353579],
            [2.5735440451236262, -7.761083327347861],
            [2.5759037120510353, -7.767787446913595],
            [2.5792741153019074, -7.772310114024831],
            [2.5778883262726096, -7.777006003402945],
            [2.5793553227917148, -7.779763427043921],
            [2.57540404691788, -7.785333388055233],
            [2.5650214382646404, -7.78997462236076],
            [2.5658471665888043, -7.784271741682647],
            [2.5631711704845794, -7.783137518795451],
            [2.5595090347332605, -7.786517375746919],
            [2.557594765224026, -7.791642585286566],
            [2.5522253665754815, -7.796857652396738],
            [2.5521403713156783, -7.798991847041102],
            [2.556940084456929, -7.802141589860916],
            [2.556248835956491, -7.807453864087845],
            [2.560917918532789, -7.810196123452768],
            [2.560486167613337, -7.812647177709657],
            [2.553144614352723, -7.81352320807121],
            [2.5459144938734073, -7.815602317151222],
            [2.5404200571984785, -7.822965909061219],
            [2.5395372120659925, -7.826010501688681],
            [2.5425520287398773, -7.834827823111699],
            [2.5477078878023045, -7.834602675867043],
            [2.5493713712555435, -7.837413597632479],
            [2.5484538064777595, -7.841658460640777],
            [2.5530405766585207, -7.841332492293742],
            [2.5506214697379477, -7.851763430114712],
            [2.554716490450013, -7.8578709307900345],
            [2.545829110092114, -7.867094493625832],
            [2.5542940685672453, -7.869912069323473],
            [2.558809198974789, -7.876616312795082],
            [2.5554492558545605, -7.881024141162568],
            [2.5577444672125322, -7.886442313919635],
            [2.5497416238724555, -7.892317166215667],
            [2.5524081286540476, -7.902148924979408],
            [2.545715286895383, -7.9068968046116295],
            [2.5411541039922083, -7.908597836371677],
            [2.534642345282331, -7.907029577382947],
            [2.533063283472684, -7.913481186862476],
            [2.5356556775334824, -7.91841884282663],
            [2.53378002567189, -7.9223056841934],
            [2.5289358012637333, -7.923506390751663],
            [2.533299763353038, -7.92887222919518],
            [2.533901479833506, -7.932945815849241],
            [2.528721357588377, -7.93236882815367],
            [2.5257690526615253, -7.937891497092463],
            [2.5275635037683553, -7.9428598248130005],
            [2.527190253349614, -7.946398442981061],
            [2.516208074026876, -7.948352996665446],
            [2.5147487526636443, -7.952190723365024],
            [2.507953628152, -7.954438854182633],
            [2.5136733438213943, -7.962469934750281],
            [2.5123808456454166, -7.965666562772448],
            [2.5081539396298966, -7.966097519789642],
            [2.5045770045012863, -7.9684945789605415],
            [2.505901198753428, -7.9719557825834775],
            [2.5120431620347765, -7.975974430686985],
            [2.51326767688508, -7.9870076340527705],
            [2.5119831542829765, -7.992090610467606],
            [2.5067946723711114, -7.991696248021715],
            [2.507629275423661, -7.997824743291807],
            [2.5049570269890404, -8.00131617629121],
            [2.5041185250684905, -8.006120501615964],
            [2.5010291358026944, -8.0092148709938],
            [2.504658093838449, -8.01592212972922],
            [2.499003010272569, -8.022840256247525],
            [2.4968948954438175, -8.030311672797342],
            [2.4916247337497177, -8.034239594241557],
            [2.4899400171379864, -8.037316392735725],
            [2.483798018401827, -8.03713370697313],
            [2.481460101500468, -8.042764110346313],
            [2.475637170918024, -8.040520713123938],
            [2.4717428877816148, -8.048689748312995],
            [2.4676203722048373, -8.049114833952242],
            [2.462740617333153, -8.052897986385894],
            [2.462717332439084, -8.058267686391778],
            [2.4522278087419083, -8.070298875129],
            [2.45442496456332, -8.074478837077544],
            [2.4510850111844285, -8.080207033664147],
            [2.450873507070515, -8.085780130788873],
            [2.453728432252049, -8.09227967988866],
            [2.4505892087733203, -8.094505500519533],
            [2.4477655136469236, -8.09954858109646],
            [2.452772319628326, -8.102768017381498],
            [2.456547626120812, -8.110891450153881],
            [2.457178293538336, -8.11650200174451],
            [2.449425719256533, -8.120618556838084],
            [2.444973568671984, -8.116513384127236],
            [2.438198326009353, -8.119057039381287],
            [2.436156175662302, -8.12229191494615],
            [2.4304111493576586, -8.12232793981188],
            [2.4273425926683867, -8.123859081208819],
            [2.4271433231663995, -8.130932318812604],
            [2.423872881970542, -8.13350817116115],
            [2.420354969744671, -8.131054002325873],
            [2.415431427189185, -8.137377505499371],
            [2.4169492328127404, -8.141513744018498],
            [2.41569726852897, -8.144896755919719],
            [2.4191361570746706, -8.152023021313022],
            [2.4131586946875596, -8.158007547364615],
            [2.414984528470935, -8.16638428469733],
            [2.4065564034565186, -8.170576226984954],
            [2.4062852292883417, -8.173350090878793],
            [2.412027192881934, -8.174608834034402],
            [2.411354992507347, -8.179821176614947],
            [2.4166966054110954, -8.185375475380734],
            [2.422947678466941, -8.186559841774933],
            [2.4265171179664424, -8.191532316003133],
            [2.4314114918150223, -8.192910007111776],
            [2.4319288934593026, -8.197421043171023],
            [2.4346292181525473, -8.199119689530873],
            [2.4326224335546645, -8.204007331843368],
            [2.4280910701115563, -8.209317056871544],
            [2.4287357319847622, -8.212840581768978],
            [2.4269481734060507, -8.216548912800937],
            [2.432663653916725, -8.224104334236824],
            [2.428748087004276, -8.225207530962399],
            [2.4271637968131645, -8.228513010007687],
            [2.432689394329382, -8.234773025304458],
            [2.4316877199403546, -8.240809380935914],
            [2.4364586124909406, -8.243208226123313],
            [2.442635911762943, -8.251979084176748],
            [2.4367031725394304, -8.251894854959207],
            [2.4362574278567197, -8.254682892905826],
            [2.4405492304721528, -8.260117120190667],
            [2.4360513300545876, -8.264019591953588],
            [2.4385338625864312, -8.266752402004595],
            [2.4439322487458224, -8.2648278933558],
            [2.4432801979724346, -8.272334033711372],
            [2.4391580080159025, -8.275431009083379],
            [2.4407775369671847, -8.278795203521875],
            [2.4357291338675586, -8.279580355072456],
            [2.4330791757723356, -8.276770276180612],
            [2.4258806216185316, -8.283235513569647],
            [2.4230400163869223, -8.27805233434192],
            [2.419767860476476, -8.28053201062487],
            [2.420112345803331, -8.290722282376793],
            [2.4185219636519637, -8.296556628799223],
            [2.414017707561076, -8.295286521813981],
            [2.413336229720011, -8.301843953477105],
            [2.41053105024224, -8.30624970504532],
            [2.4076233919940666, -8.30729791007027],
            [2.4040840421143628, -8.313823869996849],
            [2.3993841075895546, -8.314122459988186],
            [2.397873442308555, -8.318186815900537],
            [2.3949128839069562, -8.31931606365025],
            [2.3936239569871365, -8.32640932777854],
            [2.396685663648511, -8.335096305738746],
            [2.3951255269896663, -8.345958173212816],
            [2.399955000920098, -8.3490537180171],
            [2.3917290278894305, -8.357986575711136],
            [2.394739792169884, -8.360599173631687],
            [2.3906425227165213, -8.366025546645263],
            [2.394305821296518, -8.371491937630363],
            [2.3884860702915285, -8.376811368598323],
            [2.3899001057708404, -8.379846682360848],
            [2.3974135945981336, -8.380309877181778],
            [2.3970917252615185, -8.384156819041069],
            [2.4015091293908983, -8.388775121480627],
            [2.402681224544048, -8.395250510845461],
            [2.407638642280869, -8.398803895701663],
            [2.40802935142116, -8.405385485224881],
            [2.412551768231342, -8.4055150578299],
            [2.416523125612529, -8.410358724593257],
            [2.4252352296872997, -8.413799396369841],
            [2.43378778379841, -8.41444082875858],
            [2.4351565792299, -8.420695284606424],
            [2.4422816474409825, -8.418533087178366],
            [2.4403846293637272, -8.432886504876844],
            [2.4387997269600565, -8.43657750813152],
            [2.4394161707949, -8.442830371810803],
            [2.444231787423177, -8.448161193035105],
            [2.440511940279676, -8.453949424477846],
            [2.442901009318642, -8.464194704810664],
            [2.433350309101688, -8.463969407932705],
            [2.404482571456532, -8.465131219893033],
            [2.3188909580688777, -8.467672457436624],
            [2.273664965594832, -8.469242438900414],
            [2.2734371996518026, -8.459079534742097],
            [2.2752425254650763, -8.42056602238997],
            [2.2776115306390823, -8.352425908036173],
            [2.279877575843702, -8.27518491670841],
            [2.2816730900291002, -8.218914632522523],
            [2.2837479752407654, -8.14473889359766],
            [2.2867189445499156, -8.039482432950637],
            [2.287639107899166, -7.9846783362228715],
            [2.288083979605549, -7.907782017238021],
            [2.2884766285768325, -7.824593450101568],
            [2.2886291924766735, -7.769667616878129],
            [2.263102889805626, -7.647367036607132],
            [2.245155734433161, -7.560943753762467]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.7447703954845, "lat": 30.786429443654498 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48351"],
        "coty_name": ["Newton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newton County"],
        "coty_fp_code": "351",
        "coty_gnis_code": "01383961"
      },
      "bbox": [
        2.245155734433161, -8.469242438900414, 2.591931052006707,
        -7.525261121087156
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.300794644969867, -6.457720659158645],
            [-6.263493528689474, -6.460733518986479],
            [-6.267160058896878, -6.466450571828861],
            [-6.2648713298146275, -6.475510067306909],
            [-6.261962970715766, -6.481011176782564],
            [-6.254812024600263, -6.481873049655932],
            [-6.250706238007265, -6.481266975260782],
            [-6.2468677864817606, -6.4774864890155746],
            [-6.240795708588067, -6.4753587180008765],
            [-6.23780643139285, -6.481434643407854],
            [-6.23944843314638, -6.486769002976008],
            [-6.238993586765284, -6.492464240277879],
            [-6.2339712053877765, -6.499049476923228],
            [-6.233963427859891, -6.502093556107934],
            [-6.2407589976950835, -6.508357933014489],
            [-6.237231896020084, -6.513190555276434],
            [-6.235115869492827, -6.518782018595667],
            [-6.231062667875741, -6.516826217815257],
            [-6.226539001433273, -6.51686968683885],
            [-6.219714562646445, -6.522084407645648],
            [-6.218448438779149, -6.525059333445923],
            [-6.21866937257037, -6.531296437271307],
            [-6.215065031478795, -6.5341586836302215],
            [-6.217471086506333, -6.539286816928436],
            [-6.218679808143842, -6.5476862350291976],
            [-6.215353698917909, -6.55770545185771],
            [-6.214523647098845, -6.56268285577487],
            [-6.209289396542907, -6.565816694673199],
            [-6.205884097198643, -6.56930651376715],
            [-6.190253774020262, -6.575213670660475],
            [-6.189189708074559, -6.579119104959373],
            [-6.191300787298934, -6.583641578466187],
            [-6.192122973175324, -6.591723276237221],
            [-6.194573622982041, -6.595848931524892],
            [-6.193083375163365, -6.600675532994167],
            [-6.189926136053661, -6.6026755842781375],
            [-6.184762893060702, -6.599697951566181],
            [-6.1828764309245425, -6.593680001442719],
            [-6.176591083718862, -6.593882636104375],
            [-6.168838780526127, -6.586187341142068],
            [-6.162300195823208, -6.587637471411005],
            [-6.154459339192785, -6.580687091125491],
            [-6.148678397773924, -6.580616888975304],
            [-6.146186727431174, -6.582410539273184],
            [-6.146980130989847, -6.593160411493166],
            [-6.149051802614816, -6.5972162006511],
            [-6.146492142612858, -6.602352741722587],
            [-6.14744180924317, -6.608145596327784],
            [-6.1434239860933, -6.609143857619628],
            [-6.139674325547376, -6.6162047385607226],
            [-6.136768968937731, -6.6194404177042765],
            [-6.135633439911682, -6.625358603507705],
            [-6.1403604064975355, -6.631115135147317],
            [-6.142402231747763, -6.635931915042209],
            [-6.139663765590507, -6.637107315512111],
            [-6.137078488767108, -6.6415319175868115],
            [-6.133787589830981, -6.643959686621478],
            [-6.132642231989965, -6.6501994116495275],
            [-6.135060316346787, -6.65537970484153],
            [-6.133929351437537, -6.659143279942005],
            [-6.1345812711427605, -6.666956525685555],
            [-6.136508824692406, -6.671160527411344],
            [-6.136874618828335, -6.677323095334026],
            [-6.134687771606235, -6.679651149017992],
            [-6.132315375722619, -6.686238551187812],
            [-6.132130609065119, -6.69086521396865],
            [-6.1290191940183885, -6.695386549212422],
            [-6.128550494834952, -6.702157206612771],
            [-6.12164520926682, -6.700771990178615],
            [-6.117581460540286, -6.698314791572534],
            [-6.1161569728183816, -6.701670935652705],
            [-6.1154833319831345, -6.709521933057436],
            [-6.111400764114344, -6.711591059570894],
            [-6.106498490757711, -6.711828996946904],
            [-6.1028166678283515, -6.716485297396935],
            [-6.103309182872726, -6.720799941553921],
            [-6.099375124095614, -6.721289929813263],
            [-6.0964449503042655, -6.7261718567217414],
            [-6.097798706177273, -6.730066111212593],
            [-6.0947144664057324, -6.734083613965715],
            [-6.088523087395236, -6.736119325044022],
            [-6.075020213754491, -6.73791813903955],
            [-6.0685383798419705, -6.731705523151934],
            [-6.065160323302255, -6.73453862514299],
            [-6.057478866553036, -6.73213793560576],
            [-6.051918099761808, -6.732052346878887],
            [-6.048805463069065, -6.7304389990292375],
            [-6.041356519496717, -6.7316517930965665],
            [-6.039321156362399, -6.736873419119759],
            [-6.03683189129133, -6.737640211433919],
            [-6.031605113866733, -6.751040638896978],
            [-6.030143648759096, -6.757606316650451],
            [-6.026874685054918, -6.7595330472775945],
            [-6.02488827022564, -6.7655141683090845],
            [-6.017162852142594, -6.77100600999672],
            [-6.010300694290324, -6.770294348513799],
            [-6.007293236020096, -6.772773499424903],
            [-5.9994044573177945, -6.774616479504196],
            [-5.9947222675492835, -6.7786147379981365],
            [-5.989107787939892, -6.778619986790837],
            [-5.987660255597345, -6.791362796785334],
            [-5.986089521512253, -6.79355810591197],
            [-5.993390255426371, -6.794892141856863],
            [-5.998666486590284, -6.792608633171052],
            [-5.998885522349756, -6.799210182799356],
            [-5.996772516538782, -6.806545177563548],
            [-5.996790666522689, -6.8099581374182145],
            [-5.991894619387284, -6.815167082442975],
            [-5.990285411185636, -6.818394699312483],
            [-5.986838067195769, -6.819556088273581],
            [-5.987118337335229, -6.82936809488619],
            [-5.98556602797616, -6.831518536164084],
            [-5.980854188706116, -6.8325303102904735],
            [-5.976036122839315, -6.834270470129259],
            [-5.971428673835223, -6.838538272144774],
            [-5.967808782751245, -6.83898621783762],
            [-5.9654502365279205, -6.844161993872205],
            [-5.962191478592939, -6.847817723502008],
            [-5.957000664508644, -6.849612173574483],
            [-5.956405967547102, -6.8515117665949115],
            [-5.950424274564278, -6.854464715918736],
            [-5.945895874422002, -6.854348499970154],
            [-5.939110966217526, -6.851583102099361],
            [-5.937673707715131, -6.8469648736089965],
            [-5.934008388814925, -6.848462071504754],
            [-5.928097152792985, -6.844212354530739],
            [-5.919566957210765, -6.848041532716938],
            [-5.915324469105705, -6.847280961217938],
            [-5.9127209080127034, -6.850477764926655],
            [-5.914467128757114, -6.8535856778607505],
            [-5.913875513297151, -6.857184882153612],
            [-5.908830433024925, -6.8576994092461225],
            [-5.900112434377971, -6.864851366366798],
            [-5.898440400130873, -6.869877332682142],
            [-5.900002483718451, -6.882987386507108],
            [-5.8971933373280025, -6.884963256931121],
            [-5.897850781621158, -6.888641677940776],
            [-5.895106033733806, -6.89012635121464],
            [-5.897684563678728, -6.8964177498849075],
            [-5.896894218445292, -6.900358762405566],
            [-5.9026147496461165, -6.908458790537375],
            [-5.9056622513986285, -6.911303940206659],
            [-5.903526140284155, -6.923456840525036],
            [-5.897920980174322, -6.928028780832322],
            [-5.895402681930005, -6.939159768212841],
            [-5.892568222991276, -6.943155491775884],
            [-5.89260225807621, -6.951720949919341],
            [-5.896714444626199, -6.959014367758041],
            [-5.897120736064445, -6.963430279410965],
            [-5.894456612455934, -6.9701654360127785],
            [-5.896783468767804, -6.973715691682078],
            [-5.901616023793125, -6.976865169571839],
            [-5.901705214940872, -6.98511233221766],
            [-5.899596467540003, -6.988956536295848],
            [-5.8955649395349194, -6.992568611804984],
            [-5.896761327719173, -6.997514726738274],
            [-5.89485899396562, -7.004238128230854],
            [-5.89154448588687, -7.004452000359714],
            [-5.891725968444968, -7.009035690053955],
            [-5.885821534444858, -7.014660754574092],
            [-5.887762575466928, -7.0224837393004504],
            [-5.891906748648966, -7.024901673954536],
            [-5.893834068341289, -7.03147201977697],
            [-5.891356417841462, -7.036306557463484],
            [-5.888981002758331, -7.044457907798164],
            [-5.883456578380947, -7.047156883018129],
            [-5.883557102361338, -7.051953986817057],
            [-5.877282997720852, -7.054561152200764],
            [-5.8749477844323685, -7.060698606850424],
            [-5.868051277476739, -7.06461962861629],
            [-5.866006660459451, -7.067667064493613],
            [-5.858600533887827, -7.0667204337928],
            [-5.853772257346306, -7.06199906216488],
            [-5.8501112214932816, -7.06404971689593],
            [-5.845739266151778, -7.063458401344275],
            [-5.842819052973708, -7.066645228750833],
            [-5.835692456824822, -7.06964786403289],
            [-5.830309387419611, -7.066124443340326],
            [-5.822810133953521, -7.064728154776133],
            [-5.814618429097102, -7.0660057959028535],
            [-5.812402482789132, -7.067958834647492],
            [-5.810830840274011, -7.073168406595292],
            [-5.807200266568655, -7.075276533316137],
            [-5.807839037986924, -7.079180000560013],
            [-5.804751972004067, -7.081187999919527],
            [-5.7972615994318515, -7.079966551234779],
            [-5.793617389335904, -7.083694664948331],
            [-5.786648035733054, -7.081970476238404],
            [-5.777127931303379, -7.076729945565559],
            [-5.771870266874051, -7.080441230218986],
            [-5.770450105326421, -7.084021338694394],
            [-5.759783588299127, -7.088442586513075],
            [-5.749617825026346, -7.084408523192001],
            [-5.745368381788838, -7.0864860942165055],
            [-5.738392364096621, -7.081964841031209],
            [-5.735291110913286, -7.083764336880462],
            [-5.7301772756755085, -7.082116494603174],
            [-5.724473734422832, -7.083354757036399],
            [-5.719915014451636, -7.0888134683944415],
            [-5.7166660447997675, -7.089117813604461],
            [-5.714540055773092, -7.083508926269653],
            [-5.7074698050961326, -7.077946210645287],
            [-5.7029312247965676, -7.078325100698712],
            [-5.697983294089776, -7.085925229386703],
            [-5.701199143101498, -7.088311633498905],
            [-5.7022613708425105, -7.093494985754048],
            [-5.701185360248589, -7.098704732113098],
            [-5.698515678441619, -7.10451681688094],
            [-5.694335434677216, -7.108538166520509],
            [-5.693704433463054, -7.113689734522028],
            [-5.688952911433825, -7.1183992331311545],
            [-5.685510189953849, -7.118017641452918],
            [-5.682992732531355, -7.120707510038391],
            [-5.679214902392397, -7.120760567169595],
            [-5.6765154011934005, -7.123782604271925],
            [-5.671752811033003, -7.124064569908979],
            [-5.663928632407503, -7.127392124900899],
            [-5.662970982979826, -7.12928830075134],
            [-5.654287654065094, -7.13335980973196],
            [-5.649540756927944, -7.138138982593457],
            [-5.646433669255029, -7.138013141620527],
            [-5.639085166675947, -7.140413264677522],
            [-5.631524394659181, -7.139214952622128],
            [-5.6197302155295334, -7.1397862973982305],
            [-5.6065934985588886, -7.147676313698576],
            [-5.596274466590591, -7.149995590032275],
            [-5.594436274217716, -7.14660811049229],
            [-5.590862190533954, -7.149068731323326],
            [-5.577046468934942, -7.1519366046733],
            [-5.570331890929034, -7.150445052601646],
            [-5.567654550498516, -7.152136882436664],
            [-5.562186674455827, -7.1510205189912215],
            [-5.555122188141044, -7.152728533120249],
            [-5.542865293529752, -7.152624776911567],
            [-5.539022853761928, -7.1496420164218755],
            [-5.543086059960948, -7.147419262750086],
            [-5.541742240297599, -7.142199463194185],
            [-5.531798117044054, -7.134236942336035],
            [-5.528620200290272, -7.133835212051042],
            [-5.5151720042636, -7.139675837643006],
            [-5.497949619575583, -7.145423480850321],
            [-5.493931190815344, -7.143963551709966],
            [-5.49464386768569, -7.150074051994881],
            [-5.5268405772969285, -7.183912523312294],
            [-5.62326504134478, -7.285484614411536],
            [-5.7197216846868875, -7.3869969749950455],
            [-5.77664308140417, -7.447456559233531],
            [-5.833576000331589, -7.507894520960796],
            [-5.882637828675568, -7.559115387933883],
            [-5.931708212758936, -7.610320304277817],
            [-5.980787205166179, -7.661509147786096],
            [-6.029874858313747, -7.712681796381014],
            [-6.1012148360832565, -7.648294081419177],
            [-6.179854466637432, -7.577661361771022],
            [-6.25847200663691, -7.5069985881876145],
            [-6.337067632952275, -7.4363060785446695],
            [-6.415641522851968, -7.365584150739584],
            [-6.442743412186868, -7.340874480923579],
            [-6.438523162049629, -7.313110200092369],
            [-6.417976849691067, -7.187124757452736],
            [-6.388675858201202, -7.004968009831423],
            [-6.359378541137729, -6.822679554371613],
            [-6.300794644969867, -6.457720659158645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.69297943254618,
          "lat": 31.323014906237557
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48389"],
        "coty_name": ["Reeves"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Reeves County"],
        "coty_fp_code": "389",
        "coty_gnis_code": "01383980"
      },
      "bbox": [
        -6.442743412186868, -7.712681796381014, -5.493931190815344,
        -6.457720659158645
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3160435022183232, -6.366773522259787],
            [1.3522781957892107, -6.366817592639288],
            [1.3912780941557876, -6.367143199163522],
            [1.4116450645238376, -6.365840237974088],
            [1.4405855697842855, -6.365343641220325],
            [1.498913202059134, -6.364992920288553],
            [1.5380385182654392, -6.364607120801128],
            [1.5870699750531565, -6.363669623105664],
            [1.5952346992283786, -6.365623588687409],
            [1.6075805567914867, -6.363432149170019],
            [1.617048625400329, -6.368139388507432],
            [1.6284197585407119, -6.370527527154415],
            [1.6347498426168987, -6.373357412690687],
            [1.639294715407873, -6.373461917231825],
            [1.6444765053990469, -6.3673532165178655],
            [1.6468344694684238, -6.367827168789791],
            [1.6568803445864795, -6.338353600191878],
            [1.668724011398719, -6.333831298996563],
            [1.6764154775901008, -6.325484144463981],
            [1.6807730427947476, -6.326084840687063],
            [1.6804045229085605, -6.329214688393515],
            [1.6843172721650346, -6.329763959512057],
            [1.6892510835114254, -6.33339669711748],
            [1.6958275035993176, -6.329361282264285],
            [1.701458502986034, -6.330276113521297],
            [1.6999790828431018, -6.336442387447986],
            [1.7092324536011694, -6.3449082603967115],
            [1.7173586790427569, -6.340400456163159],
            [1.7174006440504193, -6.337794337067341],
            [1.7219313289158948, -6.334363417657554],
            [1.7302842063626938, -6.338007919345458],
            [1.7306612412014861, -6.359094892930121],
            [1.729691338844399, -6.363547235790133],
            [1.7295884848841336, -6.37563947228211],
            [1.7240369577349866, -6.387998699488127],
            [1.722378461914984, -6.3949233736407605],
            [1.718302157933077, -6.400787503127712],
            [1.7148880566315372, -6.410036169569363],
            [1.7151930747320514, -6.416799673594903],
            [1.708351591824707, -6.426864117846191],
            [1.7029922157780688, -6.44293607695109],
            [1.703268282630037, -6.453349680257739],
            [1.699523272821431, -6.460683987146183],
            [1.6804315770204028, -6.480371506060315],
            [1.6777625349017786, -6.483780120371528],
            [1.6721382269146516, -6.5001533005753656],
            [1.6648844525161661, -6.516478517956237],
            [1.6615760301843074, -6.522442511748743],
            [1.6588982539999366, -6.530515188262351],
            [1.6584636510967776, -6.5392993184684585],
            [1.6592721180471797, -6.545522114590961],
            [1.6593412741959273, -6.5613775889598225],
            [1.6586080468404982, -6.567176393728029],
            [1.659134454779645, -6.573729288554028],
            [1.657746239496761, -6.58349577229734],
            [1.6529260541493882, -6.595481330851809],
            [1.6526733502813187, -6.608228542960708],
            [1.6478366877522708, -6.6217005577295],
            [1.6453747204429314, -6.642543499660851],
            [1.6427781253495815, -6.653143541436501],
            [1.6426769282035587, -6.6629919127080015],
            [1.6439000990231984, -6.705181689843793],
            [1.6456922839584716, -6.759674886994268],
            [1.7204286766669536, -6.757757646549095],
            [1.7211460841478026, -6.805381650035966],
            [1.7230733202692063, -6.809398444541708],
            [1.727154765670689, -6.811083773883689],
            [1.7288151860299326, -6.817108895686612],
            [1.7362085811032029, -6.820476821989684],
            [1.7396884035410447, -6.825702678850923],
            [1.7447005365593378, -6.827432207300787],
            [1.746965575485658, -6.831904683091639],
            [1.7489705946894811, -6.839212402918731],
            [1.753377522159582, -6.848507718573871],
            [1.7596605176958375, -6.851916789383927],
            [1.763845957719397, -6.859436054208333],
            [1.7633283712847434, -6.861397548952525],
            [1.7654949478613966, -6.870181783874503],
            [1.7625793407052672, -6.874331322220372],
            [1.771955524223942, -6.8825311418663],
            [1.7722887827651763, -6.88650458004395],
            [1.7321366100982916, -6.887096832554331],
            [1.611605920719104, -6.889233867474355],
            [1.578934605540904, -6.889568875567978],
            [1.542093574268118, -6.890182731350978],
            [1.4782431390343056, -6.8908624970346715],
            [1.4152652581511105, -6.891012878626702],
            [1.3950194571722312, -6.890641923339915],
            [1.3621634775799, -6.890657181836745],
            [1.322215929256957, -6.890503234951756],
            [1.3218968606100838, -6.883718489510315],
            [1.3207270368439543, -6.808729805358055],
            [1.3200559452315628, -6.741275195229639],
            [1.3189935137953686, -6.651216575965545],
            [1.3193048299460968, -6.64088422984406],
            [1.3186590001008656, -6.599308444606198],
            [1.3172613018817525, -6.490000306774629],
            [1.3172828331824875, -6.481040483366675],
            [1.315657826515901, -6.373575474524433],
            [1.3160435022183232, -6.366773522259787]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.76185534686681, "lat": 32.10770003641408 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48401"],
        "coty_name": ["Rusk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rusk County"],
        "coty_fp_code": "401",
        "coty_gnis_code": "01383986"
      },
      "bbox": [
        1.315657826515901, -6.891012878626702, 1.7722887827651763,
        -6.325484144463981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.1087992937975173, -9.025369471449403],
            [-3.0237777133473918, -9.028731943382892],
            [-2.9031789687214586, -9.032806108834585],
            [-2.8388569693411885, -9.03522658288536],
            [-2.7958573519151497, -9.036670646478589],
            [-2.790403759520437, -9.036441266309124],
            [-2.724835366433538, -9.037993933364522],
            [-2.666692547388723, -9.039227204464115],
            [-2.568833276906257, -9.042331227422475],
            [-2.500539497365573, -9.044956266577097],
            [-2.5056618708372747, -9.167331157514282],
            [-2.506169433490345, -9.18645125680726],
            [-2.5072402869626496, -9.20987058246622],
            [-2.5110664640436884, -9.323698350092632],
            [-2.5123470398638195, -9.354514639009887],
            [-2.519685408078799, -9.54013937721817],
            [-2.5215799595263584, -9.573499667647328],
            [-2.596684523315714, -9.571194279615657],
            [-2.597161740299189, -9.571410585657473],
            [-2.702203085969242, -9.568394199338925],
            [-2.7064269403869208, -9.56852027937448],
            [-2.758279318313923, -9.566818248967133],
            [-2.7665665566195856, -9.566096645999151],
            [-2.815116106514919, -9.564760251026483],
            [-2.9136533812550622, -9.561144170214506],
            [-2.919666731557779, -9.56117005661732],
            [-2.963766973121628, -9.560013259731797],
            [-2.9647550036615202, -9.560235334587396],
            [-3.034955243687879, -9.558001472035203],
            [-3.13141087293662, -9.554626942006992],
            [-3.116804830138482, -9.204591877017863],
            [-3.1158103701518858, -9.181519647406017],
            [-3.1087992937975173, -9.025369471449403]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.7622188844695, "lat": 29.357295697218337 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48463"],
        "coty_name": ["Uvalde"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Uvalde County"],
        "coty_fp_code": "463",
        "coty_gnis_code": "01384017"
      },
      "bbox": [
        -3.13141087293662, -9.573499667647328, -2.500539497365573,
        -9.025369471449403
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.402714980018285, 4.332851698826931],
            [-11.39904066875811, 4.331015969402906],
            [-11.366656777512896, 4.326010560288405],
            [-11.29580574777543, 4.314573498267951],
            [-11.239688385910833, 4.305326688442387],
            [-11.174013740736545, 4.294354990980208],
            [-11.10543132401479, 4.283551601176585],
            [-11.005430354109292, 4.266947534147751],
            [-10.928539618520588, 4.254493912622223],
            [-10.928535766747435, 4.254493290953512],
            [-10.930534767962836, 4.243083317337203],
            [-10.923807808473546, 4.239515911528061],
            [-10.921873865824448, 4.233215392434654],
            [-10.915579572489964, 4.228072928722617],
            [-10.91659646089943, 4.216265825922897],
            [-10.914022834514224, 4.213958795981868],
            [-10.912159304383046, 4.208039513176518],
            [-10.914037001100544, 4.205680151135655],
            [-10.911955265187997, 4.198288707250802],
            [-10.914214357760876, 4.194409796169295],
            [-10.916398759368564, 4.187064577993284],
            [-10.91374504394717, 4.179481393618453],
            [-10.920584901760456, 4.169365000545698],
            [-10.920835814993179, 4.165583321309492],
            [-10.923712802196272, 4.163940311062805],
            [-10.931100973294537, 4.164251715905785],
            [-10.935271497649822, 4.167366073668936],
            [-10.941317542119096, 4.166622524376457],
            [-10.943613732641754, 4.167726459782548],
            [-10.947051906379338, 4.1613739425217755],
            [-10.942074751460142, 4.1578963076320745],
            [-10.93972003413981, 4.153136923106575],
            [-10.940946796778537, 4.146472905934225],
            [-10.94339271455517, 4.143401419192906],
            [-10.936533826599629, 4.141291336914567],
            [-10.936095930192407, 4.137805623710292],
            [-10.93824488171639, 4.1292389382879815],
            [-10.948177473105801, 4.1235307680616025],
            [-10.94972011809849, 4.120466654213568],
            [-10.946999536824604, 4.116815643453755],
            [-10.952575989735474, 4.108802111453323],
            [-10.948752967748325, 4.106006581097716],
            [-10.943888170248288, 4.097710774247938],
            [-10.93597064314142, 4.0877499711203304],
            [-10.933466343185499, 4.081916201329818],
            [-10.928171903081425, 4.076511385595014],
            [-10.924106977957942, 4.069210669560252],
            [-10.92569404439853, 4.0636570910437175],
            [-10.924910737707032, 4.059285600016792],
            [-10.921195450931242, 4.0539240808376995],
            [-10.92081223136975, 4.0424776076698326],
            [-10.924058852856792, 4.038706358711177],
            [-10.925710607984392, 4.030072148494738],
            [-10.92321669719189, 4.021894914804305],
            [-10.918839514674888, 4.0208123559769],
            [-10.922112086378299, 4.00979701731343],
            [-10.919640841902343, 4.004932282200825],
            [-10.921492514745987, 3.997225203091622],
            [-10.924465475702451, 3.994551186906389],
            [-10.921713754717848, 3.989516171884326],
            [-10.92309330708948, 3.984449865397979],
            [-10.92025957728063, 3.9818793910604766],
            [-10.915633978589138, 3.974819191932154],
            [-10.909475544003447, 3.971471862571452],
            [-10.908228531220002, 3.9669245472017947],
            [-10.910360584092878, 3.9559645411293483],
            [-10.913175862450071, 3.9534359791248055],
            [-10.913816611027286, 3.9458376411519227],
            [-10.919264229322705, 3.9424047811652456],
            [-10.917632483367598, 3.939768094044659],
            [-10.921941554003679, 3.925864848883408],
            [-10.920140875923513, 3.922208370969034],
            [-10.91416337943699, 3.9228100540789352],
            [-10.913862784767085, 3.9125731960813557],
            [-10.90927577462541, 3.9124113352904386],
            [-10.909651516894964, 3.9088037212729834],
            [-10.906915490117992, 3.9044653796898676],
            [-10.907377936292217, 3.8992634897224705],
            [-10.913022060571791, 3.8951635500423736],
            [-10.914013749484624, 3.8910257569806723],
            [-10.92069297370179, 3.886225146392354],
            [-10.91850862646419, 3.8784211300137383],
            [-10.918319037793072, 3.8739110871661366],
            [-10.924275366276337, 3.8697828499004343],
            [-10.92775979442231, 3.8719909805682087],
            [-10.933841882647684, 3.867235006495987],
            [-10.932667563474983, 3.859186636806894],
            [-10.933787686964882, 3.8578547751253502],
            [-10.936089394210764, 3.841494542450669],
            [-10.937980339803522, 3.8390099978097623],
            [-10.936968199050842, 3.8345544477369446],
            [-10.938626848952413, 3.827615324212412],
            [-10.940980225354204, 3.826174158172536],
            [-10.941878760795495, 3.8162181696603015],
            [-10.94416836450892, 3.8122255302889445],
            [-10.947142176354362, 3.8027469710000865],
            [-10.954236726659875, 3.7998354763275803],
            [-10.956819548946433, 3.7960202579741855],
            [-10.956113741075589, 3.7859996964194433],
            [-10.957736239821095, 3.7824327938831703],
            [-10.961858108287968, 3.783387359602573],
            [-10.967973854524793, 3.779572646266352],
            [-10.969078632835606, 3.7741266082815144],
            [-10.976137619275683, 3.7689198482572364],
            [-10.97886882271053, 3.763482309855029],
            [-10.98795677756298, 3.7592874267617002],
            [-10.986154955786796, 3.755479259912187],
            [-10.98852837979929, 3.74393569643636],
            [-10.990935999017864, 3.742365556078012],
            [-10.995000806536966, 3.7349789105528943],
            [-10.994744132777587, 3.7331706321032208],
            [-11.00218866756914, 3.7294713523173493],
            [-11.002481720103832, 3.7237743121853444],
            [-11.01093974173824, 3.7229999195802628],
            [-11.01380468567677, 3.7183355795781203],
            [-11.014942166546088, 3.708518574831027],
            [-11.018017823231007, 3.702200823688826],
            [-11.015294848615637, 3.696607317536101],
            [-11.020449094767944, 3.6925939257705123],
            [-11.021081487491754, 3.6893361716791357],
            [-11.024052513375675, 3.6880537685004415],
            [-11.025083678188588, 3.6832163248774465],
            [-11.0302782359868, 3.682580849404847],
            [-11.034032837226313, 3.6774510873734094],
            [-11.041620924011346, 3.6772721447741947],
            [-11.044179684699747, 3.674246683611219],
            [-11.049065081506999, 3.672728676008805],
            [-11.052320054115421, 3.67359188740767],
            [-11.056400021085498, 3.6787728094656234],
            [-11.056851967995613, 3.689167695412837],
            [-11.058717390637408, 3.690476167114891],
            [-11.064384053643451, 3.6897028623197627],
            [-11.069352785798246, 3.692529610768696],
            [-11.071274680021965, 3.6967133532142524],
            [-11.079398201045631, 3.687429683059039],
            [-11.083093645188578, 3.6881479906558914],
            [-11.090500979775552, 3.6921345761738564],
            [-11.094318626025885, 3.690884705503486],
            [-11.098963676982459, 3.6913704218537955],
            [-11.099798677876528, 3.6940032347399487],
            [-11.104203754129118, 3.6954966615700564],
            [-11.110998677250137, 3.6917736049176844],
            [-11.11418403929415, 3.6929739663090366],
            [-11.12141095567687, 3.6903234668725955],
            [-11.124261347088645, 3.6868522042723657],
            [-11.125466251013238, 3.682658578106513],
            [-11.12833913902456, 3.6822131304824057],
            [-11.131535592990398, 3.6850708923861113],
            [-11.131311570850354, 3.6887623638016938],
            [-11.13386400855215, 3.6925401737539105],
            [-11.137615484019042, 3.702296045594899],
            [-11.138355675865872, 3.70750655197072],
            [-11.147757136736422, 3.707701546421309],
            [-11.156177958727922, 3.7021074843494817],
            [-11.162000332770525, 3.6996639273855765],
            [-11.167294539174698, 3.7046008019642116],
            [-11.169413358755415, 3.709334824373666],
            [-11.172476338018114, 3.7076432816534006],
            [-11.176782533140479, 3.709776634164351],
            [-11.180713817596345, 3.7092221739937967],
            [-11.178615877956043, 3.702211167667381],
            [-11.171532721551003, 3.6966186583353777],
            [-11.171776454628379, 3.688836257205124],
            [-11.17697439064044, 3.683211145538289],
            [-11.18544299939945, 3.676574904357776],
            [-11.189894901698404, 3.671563256957036],
            [-11.190654645113813, 3.6628372128076037],
            [-11.198138276818659, 3.662541769538918],
            [-11.206787728429356, 3.658907923168164],
            [-11.211653344775396, 3.660451230933158],
            [-11.21744331113241, 3.659700612955326],
            [-11.22161583551454, 3.6616265755590334],
            [-11.225345449626975, 3.6687902429829404],
            [-11.228040813460161, 3.66983949734214],
            [-11.235844545003282, 3.6788488274228395],
            [-11.237277738224739, 3.685968665646303],
            [-11.240400194894026, 3.687566256356479],
            [-11.247677035803198, 3.6856477025539838],
            [-11.253172739800306, 3.6852385613569725],
            [-11.257174318463719, 3.6898094187413664],
            [-11.26342896832304, 3.6909797015299493],
            [-11.264612643909873, 3.688662122620588],
            [-11.271856740858723, 3.6893372027788196],
            [-11.273853901794089, 3.6929954592655414],
            [-11.282225952954024, 3.696526220327534],
            [-11.286779008499737, 3.6994047804955708],
            [-11.287440847169167, 3.702852327517482],
            [-11.291745576264942, 3.702594954412886],
            [-11.295513801187337, 3.709628089402011],
            [-11.294990935483636, 3.7147684284473907],
            [-11.297229168677827, 3.7176755639777017],
            [-11.296383645367017, 3.721866014827323],
            [-11.290782650664418, 3.726229322866092],
            [-11.299539861827114, 3.7321366642952003],
            [-11.297918032365345, 3.733464925366308],
            [-11.295081493476994, 3.740605218040251],
            [-11.294177976449209, 3.7461513188909543],
            [-11.30101819890465, 3.747970980189051],
            [-11.305086908564686, 3.7525279065274972],
            [-11.30715726508214, 3.756976785990476],
            [-11.305643808503222, 3.7610573382115735],
            [-11.311071121831354, 3.764233223057035],
            [-11.3166046751319, 3.769722297188576],
            [-11.31625879472675, 3.7730102485124117],
            [-11.312535647540704, 3.778576057881769],
            [-11.307162570963758, 3.7800535453929545],
            [-11.300137068349262, 3.7762730775551185],
            [-11.29634732144208, 3.7764873388956928],
            [-11.286034345846657, 3.780385776991064],
            [-11.283779434656845, 3.7839009818890554],
            [-11.283928116832202, 3.7874911798215476],
            [-11.280634636997837, 3.7889542310728745],
            [-11.281609465060917, 3.793722485877999],
            [-11.284787170886966, 3.79568178818505],
            [-11.286848700061206, 3.801063358873152],
            [-11.293638952236222, 3.8021291802097714],
            [-11.301344869881724, 3.8048389032753165],
            [-11.301654944615311, 3.8105489730742637],
            [-11.303282063064591, 3.815124719527635],
            [-11.300452658882373, 3.8232178816006646],
            [-11.303403307134142, 3.826791965254784],
            [-11.303639301982392, 3.8328941980607953],
            [-11.302437381440908, 3.8399806073336973],
            [-11.304415265940413, 3.847911156127894],
            [-11.311146037979903, 3.846916627415156],
            [-11.315891275476826, 3.855155693718915],
            [-11.316174882628161, 3.861773708138174],
            [-11.32059168420219, 3.8650181168475957],
            [-11.328630901464415, 3.8636061869020626],
            [-11.335846602415097, 3.8578502095552842],
            [-11.34361250754235, 3.8591316718732847],
            [-11.347423233618414, 3.8557679355732577],
            [-11.34887569924301, 3.8514409825314018],
            [-11.35200442932537, 3.850897969028169],
            [-11.355142876329772, 3.86171465482958],
            [-11.356474633154697, 3.8729808728827018],
            [-11.358861271797533, 3.8759951102236148],
            [-11.355588249260888, 3.884162597455741],
            [-11.35815474956243, 3.890548093900423],
            [-11.357916580756756, 3.898325255364488],
            [-11.360092984326405, 3.911826696451585],
            [-11.359517148891403, 3.9204884931363715],
            [-11.356453734330506, 3.9249573076573374],
            [-11.354756996924364, 3.931328149096115],
            [-11.356256620930235, 3.9334546355648894],
            [-11.35471634233965, 3.946598969543615],
            [-11.35257302836254, 3.948402192708269],
            [-11.356948823697715, 3.954235576795562],
            [-11.358472006756788, 3.961827296376241],
            [-11.35538348088022, 3.9676839812207683],
            [-11.355948296732794, 3.978187938622297],
            [-11.356918279289069, 3.9826746112827074],
            [-11.360997976330493, 3.9896641982806393],
            [-11.362949454382191, 4.003401983120463],
            [-11.366968769584592, 4.005060595311049],
            [-11.372454070342815, 4.010126307261907],
            [-11.37520926417277, 4.023906227668408],
            [-11.373037468696216, 4.029786621653532],
            [-11.36679653365398, 4.033208274619565],
            [-11.367375411289975, 4.041609494155584],
            [-11.365563212229533, 4.050249367313909],
            [-11.361642698447417, 4.060930413015638],
            [-11.35714549647176, 4.065148027702722],
            [-11.353644550779096, 4.070956068541643],
            [-11.35016177117885, 4.080430799757646],
            [-11.350230602566107, 4.087879717674656],
            [-11.344240499093189, 4.092843815458529],
            [-11.343646586053726, 4.096534828748886],
            [-11.338345432360605, 4.099342067437103],
            [-11.334319202972239, 4.099281585175542],
            [-11.329019288666787, 4.108167423931569],
            [-11.327619050591679, 4.112391151354812],
            [-11.330654423950783, 4.120087578087376],
            [-11.332917136390314, 4.123412006424457],
            [-11.339248970667073, 4.126900428006243],
            [-11.340959310505617, 4.13036172386459],
            [-11.340367399503478, 4.135820054439934],
            [-11.338135372856778, 4.140893763155945],
            [-11.341768658559454, 4.144643921714948],
            [-11.346974834965375, 4.1639872342402295],
            [-11.345806292064001, 4.172703217641383],
            [-11.348184225405602, 4.185562505110672],
            [-11.351558867187016, 4.191721362850061],
            [-11.355580583543167, 4.19186351700978],
            [-11.354266372646343, 4.199645105988017],
            [-11.356131364115996, 4.206138368213784],
            [-11.359296740220666, 4.211256144328493],
            [-11.362041285770362, 4.221611894582963],
            [-11.365391357801572, 4.229716785885343],
            [-11.379157947143812, 4.2411281190583505],
            [-11.379927562675082, 4.245248167920811],
            [-11.383905497307017, 4.249189266944058],
            [-11.387563621421465, 4.258686062985845],
            [-11.388163780341216, 4.264846947483668],
            [-11.387173361042079, 4.271607335293764],
            [-11.390663597156129, 4.285579545651445],
            [-11.391243044783076, 4.290711517125749],
            [-11.393642267474977, 4.296545855280023],
            [-11.39672575941112, 4.296321084968322],
            [-11.397386283362872, 4.300206436396732],
            [-11.401421121586388, 4.3042553270714805],
            [-11.40111628305451, 4.318925587270794],
            [-11.402958721499811, 4.32577049358536],
            [-11.408062760132562, 4.331493649436899],
            [-11.402714980018285, 4.332851698826931]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -111.7436204465726, "lat": 41.72242235750632 },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49005"],
        "coty_name": ["Cache"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cache County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01448017"
      },
      "bbox": [
        -11.408062760132562, 3.658907923168164, -10.906915490117992,
        4.332851698826931
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.978096430940214, 3.085951609559799],
            [-9.959371409187849, 3.083749692174041],
            [-9.870384280599879, 3.0703427346067134],
            [-9.791174849595297, 3.05923415925064],
            [-9.737781487500882, 3.0518237510865207],
            [-9.63299175375873, 3.0364845327812207],
            [-9.60748723855648, 3.033838453821618],
            [-9.514733132886537, 3.021679985761781],
            [-9.421980690416571, 3.0095084068374383],
            [-9.407935875336277, 3.0086092727599927],
            [-9.364885832817475, 3.001378482748694],
            [-9.27327646575219, 2.988473635073093],
            [-9.296167829565377, 2.81414283608019],
            [-9.31203169768867, 2.7029239453787515],
            [-9.318670827653037, 2.6509995016188603],
            [-9.374554306395986, 2.6585066676771483],
            [-9.371616973968475, 2.6802162392293774],
            [-9.399671164633316, 2.6837468512951688],
            [-9.388005643150073, 2.7714154255659924],
            [-9.389021005406512, 2.771560850890808],
            [-9.387201076640485, 2.7859545125114376],
            [-9.415475169917709, 2.789685206381721],
            [-9.405883203915696, 2.862250558362497],
            [-9.548755418842239, 2.8820969712412166],
            [-9.558246051618742, 2.815144403745896],
            [-9.574071420397782, 2.81310224109596],
            [-9.579122943493552, 2.811351025850062],
            [-9.589881289099015, 2.8054437588504237],
            [-9.592363711502848, 2.798619303956999],
            [-9.596594518217236, 2.794256461678047],
            [-9.593995170187908, 2.790832341775955],
            [-9.594460453377089, 2.786124342523637],
            [-9.60359457920997, 2.7869746847553434],
            [-9.609766435145302, 2.784623449485163],
            [-9.612373032155642, 2.7870754871195604],
            [-9.617659625127738, 2.7878448386522368],
            [-9.620122917805197, 2.7861729522385383],
            [-9.622349871568497, 2.778546154698624],
            [-9.624245697548343, 2.776552272073258],
            [-9.632158576210143, 2.7742025939299673],
            [-9.638523249406516, 2.778561656275248],
            [-9.644781566518189, 2.7843104931658798],
            [-9.652137799026873, 2.7884696752187508],
            [-9.6539671222798, 2.791947983876888],
            [-9.65182013808439, 2.7955354233477006],
            [-9.652140356735003, 2.8031461597325587],
            [-9.65073164915909, 2.805892723332617],
            [-9.650168050980168, 2.8135397553990282],
            [-9.651878541208946, 2.8197555769001283],
            [-9.647461394359624, 2.8240998500325016],
            [-9.644492452036879, 2.832444713266495],
            [-9.644570315963167, 2.8450275415898445],
            [-9.649634463738224, 2.858732405093738],
            [-9.649589952148673, 2.8626628082157928],
            [-9.653400649325816, 2.8659259440508853],
            [-9.664992368592266, 2.86258290528486],
            [-9.67198686412728, 2.8624255405070844],
            [-9.673172189323203, 2.8604555814410233],
            [-9.684968098292233, 2.8573238255274456],
            [-9.687130670263905, 2.8641255963556573],
            [-9.692052547767041, 2.869165561217963],
            [-9.69636997412086, 2.8687379519582525],
            [-9.701888989692279, 2.8627745491886687],
            [-9.70880168028224, 2.861247368107063],
            [-9.718001843040268, 2.865568018502349],
            [-9.722688920802446, 2.8606665365213826],
            [-9.72574024408944, 2.8612742512832843],
            [-9.730310725113275, 2.8649995540390085],
            [-9.73468350435664, 2.8600136938083742],
            [-9.741645152435412, 2.859250694248752],
            [-9.746523990103588, 2.856230362990565],
            [-9.750532404525915, 2.851007286265952],
            [-9.75650145681659, 2.853062807491483],
            [-9.766753648675005, 2.8492176772381383],
            [-9.77063508862569, 2.850580484275878],
            [-9.77912291808673, 2.858025532895311],
            [-9.783656514542622, 2.860027146858263],
            [-9.795217859982387, 2.859780485916145],
            [-9.798776537447397, 2.8605993673036116],
            [-9.805507853691568, 2.8549761823378996],
            [-9.808431677851527, 2.854687466721881],
            [-9.815498306137734, 2.8592528568492623],
            [-9.822630651952574, 2.865239401048916],
            [-9.825844965615047, 2.862891771816306],
            [-9.82598912119108, 2.8575168643722213],
            [-9.831897390326045, 2.8513524833952197],
            [-9.834516447612064, 2.8463277067992796],
            [-9.838928466930476, 2.8457255734850313],
            [-9.853856109113435, 2.848799379618015],
            [-9.860575371945465, 2.8474135040786823],
            [-9.867259253254725, 2.849110666083866],
            [-9.874060254533482, 2.848615490779518],
            [-9.88064671195745, 2.845678825926526],
            [-9.885348316831335, 2.846768021885913],
            [-9.888242651275513, 2.839664212185549],
            [-9.897862853892539, 2.8400715991907544],
            [-9.904341141735568, 2.838495375016599],
            [-9.90940109294639, 2.8398667361153165],
            [-9.915517496265663, 2.839169967898689],
            [-9.91970786157513, 2.843163402616483],
            [-9.923675332760435, 2.8515318750927885],
            [-9.930991928129716, 2.8503104031146247],
            [-9.932941756352214, 2.8601473195347786],
            [-9.945442273276848, 2.8623495496228264],
            [-9.945950211622014, 2.8684335199548907],
            [-9.947517338014311, 2.8711099589775357],
            [-9.951021400615568, 2.8704950638227635],
            [-9.956910363220056, 2.8785422169592576],
            [-9.962483962913447, 2.8772729932793273],
            [-9.965600397597068, 2.881380989809008],
            [-9.97020983592668, 2.8820023889283424],
            [-9.972952326252226, 2.885951702748715],
            [-9.978745718634368, 2.888597628628463],
            [-9.98346096307613, 2.896666412887149],
            [-9.987828544618413, 2.896340007048113],
            [-9.996642242858965, 2.895538715688479],
            [-9.999736894093509, 2.9036489285749565],
            [-10.005284366394816, 2.902989290706283],
            [-9.978096430940214, 3.085951609559799]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.50767735640619,
          "lat": 40.887336923724284
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49009"],
        "coty_name": ["Daggett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Daggett County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01448019"
      },
      "bbox": [
        -10.005284366394816, 2.6509995016188603, -9.27327646575219,
        3.085951609559799
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.305371864445418, 0.5502860565755947],
            [-12.300997309700824, 0.5509952333712476],
            [-12.29234800920332, 0.5506531990372324],
            [-12.278374353279805, 0.5482098253573962],
            [-12.173403205187538, 0.5297812824647349],
            [-12.10215298244973, 0.5178227542361971],
            [-12.060543940212712, 0.5106311532588265],
            [-12.046907976534003, 0.5078723852743048],
            [-11.98452807010404, 0.496947308531446],
            [-11.985109871589776, 0.4932317983294637],
            [-11.942249791490973, 0.4859621895804046],
            [-11.900725276787366, 0.4792110100641457],
            [-11.899831456589576, 0.4843279363082065],
            [-11.816876839418326, 0.47032440935231573],
            [-11.657125580226722, 0.44357474934520474],
            [-11.657281493900763, 0.4425309593271236],
            [-11.55878327972648, 0.4260928556080542],
            [-11.487457192794098, 0.4144640018829823],
            [-11.486809080638222, 0.4181694593555522],
            [-11.312184988946475, 0.38891704946280964],
            [-11.282510828964913, 0.38410113248624334],
            [-11.274996130524148, 0.38246098995795846],
            [-11.256760519389442, 0.3794409917995683],
            [-11.077172171843626, 0.35066169160561983],
            [-10.893777888886872, 0.32258059288664204],
            [-10.71038680675912, 0.2944787439260827],
            [-10.526998885721397, 0.26635614358868737],
            [-10.343614085175524, 0.23821279632280518],
            [-10.343761701635497, 0.23389536745352066],
            [-10.346310425419764, 0.2269752204259087],
            [-10.35085891368567, 0.22328403738474323],
            [-10.357980414775186, 0.2235459321505883],
            [-10.367397418513079, 0.22074565294154705],
            [-10.369526034666452, 0.21910462871055464],
            [-10.376050497608727, 0.20830511401734067],
            [-10.377073003383554, 0.20467942047032417],
            [-10.38406667827726, 0.20365063609528064],
            [-10.391613345248631, 0.20027991651851879],
            [-10.39658042587103, 0.1937506985902938],
            [-10.40219695287378, 0.19444974383516306],
            [-10.405943729908445, 0.1984162639300064],
            [-10.408290613348374, 0.20360142650323798],
            [-10.411565880569421, 0.20546987204685857],
            [-10.416023806072479, 0.20440244902235324],
            [-10.427476972569236, 0.19472118313393832],
            [-10.43479741411615, 0.18395068635742515],
            [-10.438444941485967, 0.18203998945755714],
            [-10.445555268977554, 0.17357686247473514],
            [-10.447652775504485, 0.1699543844907146],
            [-10.446039582324362, 0.1651342577607114],
            [-10.446030784590903, 0.15792200805311846],
            [-10.45086082125781, 0.14891544721070818],
            [-10.456648999743315, 0.14958550523488057],
            [-10.462609993206401, 0.14665221103555007],
            [-10.468079682089146, 0.14100477204702094],
            [-10.474557085813409, 0.12925739386988502],
            [-10.478242563248985, 0.12385070583117541],
            [-10.47710965242017, 0.11482654894439209],
            [-10.478905211169293, 0.10656599787046842],
            [-10.48073596624093, 0.10329012631683634],
            [-10.486660183590573, 0.09987782674206473],
            [-10.494397287838057, 0.10026026123164408],
            [-10.498546629292512, 0.10395863720075511],
            [-10.5017691370531, 0.1098324380002314],
            [-10.508016034276308, 0.1161057412198956],
            [-10.520117439782371, 0.11671425165307063],
            [-10.526010860393745, 0.11567335982970794],
            [-10.535343104037773, 0.10225082381535033],
            [-10.547094623287096, 0.09679437831592505],
            [-10.55010907766525, 0.09331752538428201],
            [-10.554364662700122, 0.0816189937902696],
            [-10.560339724552172, 0.07669686101151675],
            [-10.56729285400503, 0.0734099505707385],
            [-10.574447329527219, 0.0688733133061035],
            [-10.585356780049091, 0.0650780803896],
            [-10.587519566374276, 0.06266176320055462],
            [-10.590260077834234, 0.053126808594481496],
            [-10.589620764318393, 0.04529691126393765],
            [-10.587296654760646, 0.040207614648287905],
            [-10.58735080602379, 0.03376993755545178],
            [-10.59313906393566, 0.024794835532654408],
            [-10.595203223668474, 0.016911450134360573],
            [-10.598662783246313, 0.01315561749569056],
            [-10.60470228645193, 0.01255719312235986],
            [-10.61434259109312, 0.017210236942517245],
            [-10.628231500612156, 0.0200205042108416],
            [-10.639347886430219, 0.024617209280763212],
            [-10.645035497482224, 0.023709496662628664],
            [-10.649035633833341, 0.02088205633549876],
            [-10.653896249866289, 0.01225212658835184],
            [-10.655180542751717, 0.005679194135739939],
            [-10.65527769451506, -0.0025410856386704787],
            [-10.660467988798692, -0.006257358076306853],
            [-10.666033544666302, -0.002180793268294721],
            [-10.667245754465863, 0.0036673083771761963],
            [-10.66624653038099, 0.014663990456879255],
            [-10.670800608310863, 0.020007631849642844],
            [-10.675763341396769, 0.021678461737476458],
            [-10.681572530167834, 0.0217346019566239],
            [-10.703236873823947, 0.02573674692318682],
            [-10.713794712682311, 0.029429910368784708],
            [-10.731462829301972, 0.029247083010770177],
            [-10.739225142278766, 0.027973209476469463],
            [-10.751656022386294, 0.022955008980936092],
            [-10.75308777803257, 0.0202020316900632],
            [-10.753763690156342, 0.01236485448017048],
            [-10.753312933617494, 0.006855314269952888],
            [-10.75479344666713, 0.0025570384425846024],
            [-10.754897965656145, -0.005937404823534003],
            [-10.758160265671313, -0.009186155236283433],
            [-10.773295938848754, -0.012598536430474736],
            [-10.778161590927809, -0.016426777666650978],
            [-10.781074877147782, -0.020455509359424234],
            [-10.785600438251771, -0.03539822174098924],
            [-10.786371820266245, -0.04231990067485032],
            [-10.789894960245718, -0.047951993674541435],
            [-10.792157500677165, -0.04765971264668693],
            [-10.798569838119443, -0.04254101137243629],
            [-10.808513824173128, -0.04227937156201724],
            [-10.814346449309811, -0.04116395103190749],
            [-10.820255260009436, -0.049217968777267106],
            [-10.821020422142904, -0.05303693980013575],
            [-10.818422074530634, -0.05523386648388251],
            [-10.81876103009927, -0.06542384737949918],
            [-10.817494023677838, -0.07205459611383312],
            [-10.814410009871922, -0.07815381116597611],
            [-10.811416486346852, -0.08057539850737383],
            [-10.808488321814211, -0.07967882264696381],
            [-10.80033944998522, -0.08035944663988932],
            [-10.795161424063593, -0.07918072243983837],
            [-10.788779437560684, -0.07586590350619196],
            [-10.785895043222393, -0.07572186774419092],
            [-10.785128279203741, -0.08080297293430887],
            [-10.787771113665755, -0.08403546546389384],
            [-10.80126066607715, -0.091580568686569],
            [-10.804086161953235, -0.09675328881455982],
            [-10.8063263464591, -0.1100168169103233],
            [-10.807711762315844, -0.11456625861282924],
            [-10.812599475899292, -0.12011449747845623],
            [-10.820574861342363, -0.1226125402899228],
            [-10.825118635962777, -0.12554747545625172],
            [-10.826664244253037, -0.12858672514293],
            [-10.82723748716647, -0.1351639154513952],
            [-10.83360790002505, -0.141545174062375],
            [-10.842985218224447, -0.14431340531030626],
            [-10.8441335082232, -0.14567868897891784],
            [-10.841425716770189, -0.15309605022102823],
            [-10.844234067544951, -0.1663068905022985],
            [-10.846771748816922, -0.17351516029561276],
            [-10.853359981400368, -0.17909261802333706],
            [-10.857661312915717, -0.18731898579158224],
            [-10.85946801021898, -0.19468539798119344],
            [-10.861602791680996, -0.1957231554063259],
            [-10.868576901320811, -0.18818824137949441],
            [-10.870541640254228, -0.187667248858099],
            [-10.878180869122898, -0.19240892457631073],
            [-10.882893045104101, -0.19775929722695101],
            [-10.885457677291894, -0.20310218047804507],
            [-10.890727990145733, -0.20808729570049966],
            [-10.895843833556402, -0.2075478997404295],
            [-10.903602090569054, -0.19821586787038942],
            [-10.908038607835435, -0.19688222483187057],
            [-10.912443802987317, -0.2020557504747988],
            [-10.914634358655942, -0.2131613635320491],
            [-10.918905474791236, -0.22434407001240544],
            [-10.931663300593295, -0.22810853007269166],
            [-10.945160865240133, -0.22928059329303827],
            [-10.948920406293126, -0.2315851206466638],
            [-10.94990465534338, -0.23720710961614763],
            [-10.948529543559635, -0.2475965219067037],
            [-10.949323557047705, -0.26178329272717027],
            [-10.951745506014513, -0.26645307735475754],
            [-10.956501516455612, -0.26863079518056326],
            [-10.96735069988735, -0.2681184738317309],
            [-10.982478202925638, -0.27659836223805834],
            [-10.991754278863787, -0.2878365846000342],
            [-11.152597192922343, -0.2626365341059039],
            [-11.408672018802019, -0.22159342779027905],
            [-11.664751257056444, -0.18057750247563695],
            [-11.664841679606562, -0.18112650509974249],
            [-11.877188202347813, -0.14568751864794785],
            [-11.9174833756648, -0.1389528040351729],
            [-11.91813209842543, -0.14285156751241987],
            [-12.080892750717556, -0.11527921616549755],
            [-12.169028680170284, -0.10009177513243174],
            [-12.168870921399016, -0.09917317608502954],
            [-12.25593091496968, -0.0841214785622924],
            [-12.320724302943287, -0.07289995831734193],
            [-12.319693476937372, -0.06698481704424838],
            [-12.34672428299287, -0.062430676103217356],
            [-12.47231531599137, -0.040571071254682387],
            [-12.479429179944885, -0.03889415848289316],
            [-12.556224779240216, -0.02514516787975136],
            [-12.569011417423111, -0.022291829248935316],
            [-12.553351668577177, 0.06532642645337715],
            [-12.554503511760036, 0.0660712071172316],
            [-12.550779318870807, 0.09409601243518737],
            [-12.539936686040049, 0.15063793843054962],
            [-12.542553398699587, 0.1509739526125975],
            [-12.527098446135113, 0.23887027932268123],
            [-12.512895810592676, 0.23629645916681508],
            [-12.49103373535521, 0.23360060744912273],
            [-12.441956769366252, 0.2227386633005553],
            [-12.428294316942033, 0.2999073650222437],
            [-12.436059987068136, 0.30128137288537676],
            [-12.434586326081497, 0.309445116352438],
            [-12.34203622922315, 0.2932847472200294],
            [-12.325859662020406, 0.3799161720035961],
            [-12.335043039077812, 0.38152496037724903],
            [-12.330930548479397, 0.4036076558033289],
            [-12.305371864445418, 0.5502860565755947]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -111.4432245082847, "lat": 37.85493145288014 },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49017"],
        "coty_name": ["Garfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garfield County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01448023"
      },
      "bbox": [
        -12.569011417423111, -0.2878365846000342, -10.343614085175524,
        0.5509952333712476
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.171504577034153, 2.5137541948860767],
            [-13.08021698402404, 2.4961153793099276],
            [-12.9133702289441, 2.464088675685249],
            [-12.744204027560892, 2.4325676411895687],
            [-12.575044134347143, 2.401012102847953],
            [-12.575154353041018, 2.400416187195484],
            [-12.407988217902965, 2.370157464901248],
            [-12.23835971412635, 2.3389647394828894],
            [-12.238449499862025, 2.3384624511585335],
            [-12.093142096605344, 2.3126648127576797],
            [-11.983521473378941, 2.293635694240605],
            [-11.89688487335997, 2.279133921093653],
            [-11.896601646455911, 2.2856239417109636],
            [-11.890871707307483, 2.2928648066280926],
            [-11.88913020312043, 2.301787280688698],
            [-11.887517853424187, 2.304262775369632],
            [-11.888459547312415, 2.317815995546535],
            [-11.884311005551751, 2.31914019442403],
            [-11.881286028711202, 2.3258932168424726],
            [-11.878699750066682, 2.3191875847205514],
            [-11.875937739012137, 2.3164532114600718],
            [-11.865422146760785, 2.317594258110878],
            [-11.863381537151469, 2.3152770407529277],
            [-11.863445980286862, 2.309681034253296],
            [-11.861421875340973, 2.3059278735468474],
            [-11.85385900598776, 2.308114098169061],
            [-11.84473237221675, 2.3078785871725453],
            [-11.843192682925842, 2.3054378526201424],
            [-11.83724881272603, 2.304177529897724],
            [-11.834483034532422, 2.3065139697528902],
            [-11.829499419627716, 2.3066614082175136],
            [-11.82322590251402, 2.3136033146645705],
            [-11.819201919081408, 2.3130952703331102],
            [-11.815968302834758, 2.3180386192667934],
            [-11.808097295148887, 2.321358785932284],
            [-11.807379565839435, 2.3272834405057696],
            [-11.804974678762942, 2.3313169164368026],
            [-11.798612764091521, 2.3371120425836196],
            [-11.795761421448614, 2.341164903342633],
            [-11.794351781043783, 2.347526789807114],
            [-11.783051202453384, 2.3516854684561155],
            [-11.771109608779044, 2.3587802194679712],
            [-11.76332943321295, 2.3599546570145233],
            [-11.757076153901762, 2.3646925331206408],
            [-11.753110846235877, 2.3633854779454695],
            [-11.750701292571586, 2.3596765357147147],
            [-11.74601779197571, 2.35931574333893],
            [-11.74312125237981, 2.357286279645919],
            [-11.74029530667237, 2.350325719730295],
            [-11.737630068692521, 2.3469643134716773],
            [-11.738538347491062, 2.3428907624167135],
            [-11.732545872506055, 2.3379628212471335],
            [-11.733106191817903, 2.3350572319488623],
            [-11.729473242342646, 2.3300654429768906],
            [-11.727693041735634, 2.3246801464421925],
            [-11.721986321425122, 2.320260629607891],
            [-11.711404786729641, 2.318173087188823],
            [-11.711698114483955, 2.3149537207901525],
            [-11.708261971160804, 2.3089238480974754],
            [-11.708359219505427, 2.302995772732039],
            [-11.703517184518777, 2.299370398443402],
            [-11.702718512276073, 2.2968820688770704],
            [-11.71005982917878, 2.291779543135215],
            [-11.711563633748783, 2.286079482951353],
            [-11.714277360925205, 2.2817003160463907],
            [-11.712321593144079, 2.2784421265601567],
            [-11.714172228485562, 2.272540370055951],
            [-11.706062081270577, 2.2704076848356016],
            [-11.70099069395895, 2.2669400194840126],
            [-11.69894990131561, 2.257841662966394],
            [-11.700098827699225, 2.2541563935694016],
            [-11.693634881807393, 2.251181170029795],
            [-11.687523434735207, 2.2433490843977983],
            [-11.687549861331922, 2.2366640770498942],
            [-11.683744718233411, 2.2291019296154952],
            [-11.688250344585875, 2.2255598663138847],
            [-11.689096176192544, 2.2187576324725704],
            [-11.694953244249728, 2.2154103595185988],
            [-11.699672961089757, 2.209643199827829],
            [-11.70490060792022, 2.20664131532868],
            [-11.708240450975556, 2.2063714049692176],
            [-11.708323693251556, 2.198075967677375],
            [-11.705847544442825, 2.1875409852932557],
            [-11.708051733991235, 2.180364454131257],
            [-11.704665790107386, 2.177943095420636],
            [-11.70458103080351, 2.1737584091626014],
            [-11.702341331702454, 2.1695131134655],
            [-11.704902639480155, 2.1673839650921445],
            [-11.710852261720378, 2.1526538420437484],
            [-11.714604707566197, 2.1509327219790193],
            [-11.718038785387838, 2.143459339536675],
            [-11.71593005808404, 2.141225981229493],
            [-11.72066955517526, 2.135898938750595],
            [-11.72543064530622, 2.1331276219007833],
            [-11.726341207055984, 2.1285845511531747],
            [-11.728844339241055, 2.1248107434148436],
            [-11.721938367166894, 2.1229735731691286],
            [-11.720992250785665, 2.1203154514743368],
            [-11.713604624132682, 2.117524179143344],
            [-11.709173809721252, 2.121441375561939],
            [-11.70399621755781, 2.1158439163903924],
            [-11.697687715468529, 2.114299360705788],
            [-11.694824823062136, 2.118580610743905],
            [-11.689348123725388, 2.11948047677161],
            [-11.685433508088538, 2.1166359321339745],
            [-11.680947331536347, 2.117421604082523],
            [-11.67922677255245, 2.121056618622273],
            [-11.675444862440735, 2.1210016821497035],
            [-11.671600432988066, 2.1253427238774507],
            [-11.666480744356196, 2.12789161698139],
            [-11.661402760895509, 2.1288406704363227],
            [-11.660912428460655, 2.131505287743145],
            [-11.65433952002417, 2.132189587118956],
            [-11.650583350235777, 2.135009773887137],
            [-11.64884829018043, 2.1411981258086072],
            [-11.638964905630779, 2.1352135757062967],
            [-11.634238950336727, 2.1344747483177895],
            [-11.62767892985714, 2.142416305462932],
            [-11.627725846087772, 2.151729029721531],
            [-11.624488431063781, 2.1554165092406934],
            [-11.620419685166373, 2.1624145987305985],
            [-11.615545175022573, 2.1591229173630175],
            [-11.611857204120891, 2.1687971945422087],
            [-11.611278977495923, 2.173428146103484],
            [-11.601813900051551, 2.178347389386908],
            [-11.602243245121567, 2.1804943765061737],
            [-11.595950431608639, 2.1865552904923184],
            [-11.593259322287688, 2.1869236955645484],
            [-11.587040567199944, 2.1954032807552397],
            [-11.585617524076396, 2.2009641703875285],
            [-11.580735833769383, 2.203719225533032],
            [-11.574501670007864, 2.2138320335955397],
            [-11.566978787377783, 2.216786156927617],
            [-11.564300722840638, 2.2150057592199124],
            [-11.56012473546268, 2.2152739832128203],
            [-11.558590107911522, 2.2185589130280667],
            [-11.554423828204445, 2.219707563728739],
            [-11.551423743132936, 2.2230635892073867],
            [-11.541170705572327, 2.220448583978037],
            [-11.533645840591673, 2.223098619010709],
            [-11.53328501706109, 2.227511988732107],
            [-11.526847061296792, 2.2279760284800103],
            [-11.51837807203508, 2.234220520181724],
            [-11.512468553647778, 2.2336159371175834],
            [-11.51026125575202, 2.239667943998878],
            [-11.50991597768981, 2.246028647389406],
            [-11.50399158019766, 2.2555770857631265],
            [-11.50148795875205, 2.255866290222321],
            [-11.499554939164451, 2.25105788963732],
            [-11.491777687874517, 2.245037817443856],
            [-11.489747491531551, 2.2407053249511417],
            [-11.481944177160917, 2.2351924363433087],
            [-11.478840520049523, 2.2299094944486466],
            [-11.477665727036646, 2.224943684727781],
            [-11.480044385229117, 2.2182019062712715],
            [-11.480257694360954, 2.213003317431386],
            [-11.47690438622906, 2.210619504978824],
            [-11.47813620282423, 2.2071763997731733],
            [-11.47501491513477, 2.2018897663557873],
            [-11.468316035283562, 2.1998216871606022],
            [-11.461559674874668, 2.190602486563512],
            [-11.464979426321344, 2.18450246459443],
            [-11.463564066106041, 2.1761510449419004],
            [-11.45105879344004, 2.162023308664959],
            [-11.449783473092513, 2.1515770818574094],
            [-11.452851278027572, 2.1492436682151017],
            [-11.45969450956681, 2.149091239372578],
            [-11.46398069601571, 2.1402599784222054],
            [-11.464218118004768, 2.132549668301926],
            [-11.470362359939115, 2.127976074700995],
            [-11.478400772520306, 2.1181291011785732],
            [-11.481212903592835, 2.1124485189923856],
            [-11.47215603247403, 2.1124646317816986],
            [-11.413249960389109, 2.102864325589068],
            [-11.387432970588991, 2.0989684092219205],
            [-11.389924556973616, 2.084500655567756],
            [-11.374926890556116, 2.0821858926114367],
            [-11.377642806227367, 2.067640514452435],
            [-11.349288275611933, 2.0633745865438304],
            [-11.356475043024563, 2.0194824320713454],
            [-11.399965279812372, 2.0262293751236147],
            [-11.402443401579484, 2.011782635323151],
            [-11.416540077966074, 2.0140175345067384],
            [-11.417775531963224, 2.0066528864186512],
            [-11.432088212788878, 2.0088386418899153],
            [-11.433225496327726, 2.001594633421073],
            [-11.44021051676103, 2.002924940717556],
            [-11.442633382594567, 1.987857051271435],
            [-11.46380027990253, 1.99069817676583],
            [-11.473190843016841, 1.9333765401231422],
            [-11.471638341992305, 1.9331176033872564],
            [-11.486787516686773, 1.844841448095354],
            [-11.484932199662392, 1.8445289560846643],
            [-11.499454648210133, 1.7570358636725742],
            [-11.525586365985353, 1.7611757290274646],
            [-11.537938435531702, 1.6841321818412547],
            [-11.653290402431926, 1.702281671374288],
            [-11.67052790942925, 1.705233238595786],
            [-11.672485454833676, 1.690490688733163],
            [-11.700602882047917, 1.6945029688623983],
            [-11.705050922644638, 1.665207472999258],
            [-11.748624152260726, 1.6726956736290446],
            [-11.752544432873677, 1.650534050904382],
            [-11.780826820520316, 1.6552694891398774],
            [-11.79495242183162, 1.6581291921517403],
            [-11.792359548564535, 1.6728087936556992],
            [-11.84164087194672, 1.680931449130861],
            [-11.880630202858383, 1.687618629580843],
            [-11.873141383946377, 1.7310716212359452],
            [-11.876679862321728, 1.7316810684188453],
            [-11.856457123159691, 1.847726771352704],
            [-11.863496916602053, 1.8489622315014222],
            [-11.86102501043806, 1.8633455227150466],
            [-11.86453867465134, 1.863961418617317],
            [-11.863288525565284, 1.8711500230647118],
            [-11.866808241846245, 1.8717691826885374],
            [-11.864339055254879, 1.8861505490679737],
            [-11.850236854332568, 1.8837047679980177],
            [-11.847805118974708, 1.8980565375932108],
            [-11.854865803024628, 1.8992535853352834],
            [-11.854251423199083, 1.9028475477257203],
            [-11.857764819445633, 1.9034848827821562],
            [-11.857150673695097, 1.9070809174388874],
            [-11.860665023012475, 1.9077206407260998],
            [-11.85960494809508, 1.9139435088651637],
            [-11.877667152177303, 1.9166847101565012],
            [-11.966851395962129, 1.9321786458553858],
            [-12.048082878714611, 1.9463559318891204],
            [-12.048297849747737, 1.9451102525007207],
            [-12.174031908727917, 1.9671578034110104],
            [-12.304482863678041, 1.9905414217331465],
            [-12.395004661955701, 2.0066914426902835],
            [-12.562552018912257, 2.037711060428117],
            [-12.730104929720824, 2.068700088696457],
            [-12.897663392268578, 2.0996585175735265],
            [-13.065227403732308, 2.130586341015507],
            [-13.0668537365932, 2.1221121500625144],
            [-13.241170788499485, 2.1539887019575263],
            [-13.206199464911439, 2.3342550963391036],
            [-13.199550955208803, 2.36852441473509],
            [-13.193312965880958, 2.4030072866207464],
            [-13.187770128693506, 2.4295277132252417],
            [-13.171504577034153, 2.5137541948860767]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.78482316609686,
          "lat": 39.702723277361564
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49023"],
        "coty_name": ["Juab"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Juab County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01455158"
      },
      "bbox": [
        -13.241170788499485, 1.650534050904382, -11.349288275611933,
        2.5137541948860767
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.259151341709648, 0.9782902876903532],
            [-12.257120052250972, 0.9764095551528067],
            [-12.250068579928854, 0.9751919999060198],
            [-12.244919711843638, 1.0042104863824515],
            [-12.230968476469886, 1.00183075199134],
            [-12.223036355220556, 1.0455553293852575],
            [-12.215977093678159, 1.0443477966201975],
            [-12.213556356006778, 1.0588696321328297],
            [-12.206557897917724, 1.0576549911816704],
            [-12.203889828149704, 1.0722031213855572],
            [-12.189925228222616, 1.0697672631580937],
            [-12.188533579821668, 1.0770537793089454],
            [-12.167404485836984, 1.0734851528271905],
            [-12.15329243425049, 1.070598133547975],
            [-12.139992209886893, 1.0706774604000757],
            [-12.125911631133164, 1.069158104955265],
            [-12.118795879915412, 1.0675491659956806],
            [-12.120100820096436, 1.0604851787598388],
            [-12.112979428117386, 1.0587550672291002],
            [-12.084616231262899, 1.0538663322750972],
            [-12.083378645597039, 1.060947168244818],
            [-12.069221204154891, 1.0583806418201507],
            [-12.06858041512636, 1.0620227780791833],
            [-12.061697241941364, 1.0607426526948882],
            [-12.059243461026405, 1.0753310769918731],
            [-12.052346813669876, 1.0739601632438711],
            [-12.051751532554373, 1.077592717433716],
            [-12.03814251820295, 1.0752904595673263],
            [-12.036834860193796, 1.0825015088124286],
            [-12.026220825813626, 1.0808927377595676],
            [-12.024891811008525, 1.0881021336047307],
            [-12.021346008542244, 1.0875662574232845],
            [-12.020039906635516, 1.0947631890476663],
            [-12.006074708866835, 1.0926190839507617],
            [-12.002156500800014, 1.1140981029367212],
            [-12.002556853085945, 1.1164863459482253],
            [-12.000374492155451, 1.1291572000702284],
            [-12.007423656071998, 1.1303720670431423],
            [-11.994853118323771, 1.2035197646182563],
            [-11.99196245985748, 1.2030276547134524],
            [-11.98714791765983, 1.2301515902328588],
            [-11.973136058994653, 1.228054649118962],
            [-11.959852513884147, 1.225436321866568],
            [-11.957289539100792, 1.2400115318590756],
            [-11.94457793005739, 1.2369757365089078],
            [-11.940681773341693, 1.2501214485589],
            [-11.938200179413636, 1.2640630816230531],
            [-11.924014051551051, 1.26201424547606],
            [-11.921512799126942, 1.2754628406361914],
            [-11.919955327738636, 1.2909822574553915],
            [-11.906369226907364, 1.2886323408651281],
            [-11.902172943936291, 1.312337686392159],
            [-11.850020861583353, 1.3034204497686694],
            [-11.845452130806045, 1.3324675978757357],
            [-11.838436229086927, 1.331207430458556],
            [-11.837183577940735, 1.338480996551558],
            [-11.808704225242709, 1.333857885664524],
            [-11.80400746918283, 1.3620397093680423],
            [-11.800189069212873, 1.3614670531728348],
            [-11.796643620838315, 1.3826065548593947],
            [-11.672098125427727, 1.36159788665984],
            [-11.675457526152426, 1.357116124606372],
            [-11.676811804611637, 1.3498945921921763],
            [-11.638130273720357, 1.3432439589652554],
            [-11.521720005238736, 1.3229090970140631],
            [-11.389077471027631, 1.3011196632073847],
            [-11.256437537458266, 1.2793142213195785],
            [-11.258798144035595, 1.2648807947989429],
            [-11.257895599884533, 1.2647353062604123],
            [-11.29533196981443, 1.0369762049105566],
            [-11.30112217168667, 0.999692860302961],
            [-11.302733219138377, 0.9927887172504314],
            [-11.314522279905525, 0.9205802493316426],
            [-11.32053061714053, 0.9215580257447545],
            [-11.334543941257825, 0.8351709194696412],
            [-11.333388617115107, 0.8349832556660082],
            [-11.34575871947402, 0.7597825465903385],
            [-11.474009527838234, 0.7806629813107839],
            [-11.690318590725798, 0.8165654399788692],
            [-11.699348971454908, 0.8099852257978485],
            [-11.783637558598919, 0.8241409196731831],
            [-11.86209412509284, 0.8370794328919401],
            [-11.925241348057927, 0.848005666957467],
            [-11.923962232721633, 0.8563768585013178],
            [-12.096598524486787, 0.8869333413433552],
            [-12.272417712629712, 0.9166216379779769],
            [-12.272176971040507, 0.9220697539239937],
            [-12.273595075902058, 0.9280336169653981],
            [-12.269423626571859, 0.9308685552422195],
            [-12.266835684269372, 0.9363525757832389],
            [-12.264914403840626, 0.9473721363746733],
            [-12.265513202727131, 0.9520910842921445],
            [-12.263715061035741, 0.9603480976579832],
            [-12.26202433539941, 0.9619794835574932],
            [-12.262357750459323, 0.9735812295238789],
            [-12.259151341709648, 0.9782902876903532]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.80457773741853,
          "lat": 38.74769912657904
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49041"],
        "coty_name": ["Sevier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sevier County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01448034"
      },
      "bbox": [
        -12.273595075902058, 0.7597825465903385, -11.256437537458266,
        1.3826065548593947
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [14.020412159673482, 0.5641208086758457],
              [14.02204171011134, 0.560112125767237],
              [14.024649922086839, 0.5596564266539473],
              [14.026036739278437, 0.5531786609781796],
              [14.033100794224149, 0.5535881641365756],
              [14.03827410729421, 0.5549887505979479],
              [14.047799178256247, 0.5643053129639629],
              [14.052701844360277, 0.5625566352914302],
              [14.053493402421848, 0.5597325744870146],
              [14.058685869082506, 0.5632203942890514],
              [14.063920314159162, 0.5613555267931649],
              [14.064176881964649, 0.567717610583533],
              [14.067609553328726, 0.5731203181495095],
              [14.07347165002264, 0.5732654971538758],
              [14.074218053499134, 0.5797007746383025],
              [14.067306665431852, 0.5840056820842118],
              [14.070643689181683, 0.5908567280665628],
              [14.069034375075878, 0.5967555394288235],
              [14.074330684197648, 0.5981915042904156],
              [14.074730077092177, 0.6020751139084358],
              [14.070662005382943, 0.6110020604519941],
              [14.064747928867384, 0.6018381653506553],
              [14.061114180485763, 0.5996694650053791],
              [14.060218274133465, 0.5955434436291466],
              [14.057041503399377, 0.5960385460882838],
              [14.05428771058151, 0.6014661243056147],
              [14.058020978542558, 0.6146492114014179],
              [14.05553721821319, 0.617401900751981],
              [14.049732097983766, 0.6160704134689476],
              [14.048035287119966, 0.6130237441930614],
              [14.04129031107532, 0.615920149609869],
              [14.037712320921193, 0.6079821734644223],
              [14.034427522060652, 0.6109056497742593],
              [14.029681202215741, 0.6050154555302459],
              [14.031534203431837, 0.6028717697589554],
              [14.026459604999033, 0.600107942302965],
              [14.025454819087892, 0.5954755696009162],
              [14.030250793314666, 0.5915757810457931],
              [14.029188056008657, 0.5890011782640167],
              [14.022338643923337, 0.5862115042792031],
              [14.024020390517572, 0.5794969552464384],
              [14.029868628525346, 0.5797502543987331],
              [14.031511378642737, 0.5872808502528454],
              [14.034273219987234, 0.5852724635603701],
              [14.033257379382546, 0.5813209334932877],
              [14.03523202794191, 0.5769329891885944],
              [14.02938357139995, 0.5758904444798043],
              [14.026303610357122, 0.5717634666930698],
              [14.02172068465164, 0.5720201413470308],
              [14.020412159673482, 0.5641208086758457]
            ]
          ],
          [
            [
              [13.81366216998072, 0.7151955820374751],
              [13.815474505978978, 0.7235182560637203],
              [13.81819526409934, 0.7286518465264874],
              [13.820353042412313, 0.7294063448379118],
              [13.82697213041845, 0.7415845837051618],
              [13.82674102253822, 0.7435779390457052],
              [13.834211158143122, 0.7489673137080479],
              [13.83702107839329, 0.7523299555442611],
              [13.83917070541718, 0.7607323566025669],
              [13.846046440915114, 0.7612789488962441],
              [13.851565548758813, 0.7654778329422409],
              [13.8571514114152, 0.7727358110181273],
              [13.861437778225394, 0.7714414381187241],
              [13.867124112733467, 0.7667933115102239],
              [13.867337794098455, 0.7702702469068944],
              [13.871824049319882, 0.773973520202364],
              [13.874311874355644, 0.7817122002149665],
              [13.866301034561726, 0.785868338627893],
              [13.869744314609457, 0.7895405220627105],
              [13.866612170372163, 0.798123443642745],
              [13.90168698677778, 0.7895460152294632],
              [13.924190918700129, 0.7837005351395605],
              [13.982101293042565, 0.7717969381536147],
              [14.029554653806954, 0.7627445325932336],
              [14.048420533362394, 0.759332682725994],
              [14.069490018015598, 0.7550576007101671],
              [14.086216164118552, 0.7507682475523545],
              [14.091365920034514, 0.750314492459033],
              [14.10889945042039, 0.7468755600371203],
              [14.128950108429155, 0.7441065227973974],
              [14.166063997542715, 0.7357365678848979],
              [14.240942304531076, 0.7172904174575881],
              [14.219608668522639, 0.6430508040940284],
              [14.20750188937891, 0.6198184922189327],
              [14.202087646328634, 0.6058261506200746],
              [14.189705143078612, 0.5795179350820083],
              [14.156546119124606, 0.5032244619857523],
              [14.126515206006431, 0.4347034258922963],
              [14.099739931885027, 0.37374926409723536],
              [14.086899302726902, 0.345009281354044],
              [14.08335473312699, 0.3413310786909813],
              [14.082598269951136, 0.3363152140845612],
              [14.083582036149298, 0.3317641996012512],
              [14.088322467942659, 0.3200950831235671],
              [14.088882092951065, 0.3119058867492371],
              [14.087133280064537, 0.3087297536128709],
              [14.079470895020176, 0.3030918234122392],
              [14.067743240668358, 0.3016526668389362],
              [14.058501022719168, 0.3041303272306956],
              [14.051259453916874, 0.3045268898039263],
              [14.042685725019972, 0.3013183643877171],
              [14.025978511723068, 0.2896160069813969],
              [14.01475758654707, 0.28978306622544775],
              [14.00152090484405, 0.2874222058441422],
              [13.99178026715362, 0.27708084739546507],
              [13.988382850680043, 0.27116739789356575],
              [13.983610152077688, 0.26654358935996636],
              [13.981226530523154, 0.2598085191502242],
              [13.975072521799081, 0.25757872694092404],
              [13.97158810433246, 0.2539064321660063],
              [13.971674614179275, 0.24744189761607163],
              [13.96896675256695, 0.24693103795390184],
              [13.962061093289975, 0.24887970374273927],
              [13.958108413213573, 0.25193384397221413],
              [13.950136932464039, 0.25569646692294656],
              [13.947939697290176, 0.25820884126813504],
              [13.947328432733404, 0.272867836838754],
              [13.945493444519292, 0.27757755136536943],
              [13.94647632072656, 0.28120869954725297],
              [13.951292294648646, 0.2813096433365899],
              [13.955476103763717, 0.2796842718608428],
              [13.958277883059536, 0.28260573140706235],
              [13.951343571162797, 0.2865897679355956],
              [13.942662188059417, 0.2945485961644936],
              [13.938174435467998, 0.2908644097115875],
              [13.936223940747185, 0.2931923412465798],
              [13.938147965292227, 0.2984454810936176],
              [13.942769813473417, 0.30202508854609394],
              [13.938750273346514, 0.30464634870487683],
              [13.935992366806703, 0.30871481228362596],
              [13.932911364577862, 0.31630629651432646],
              [13.915022217055222, 0.3420907934425047],
              [13.900471864230202, 0.36186372165534175],
              [13.891330295191581, 0.37486272144338995],
              [13.8871088808666, 0.38189735699212035],
              [13.858503476364262, 0.42333700021458653],
              [13.80854758237249, 0.4938473197891279],
              [13.791950113678386, 0.5185406155701978],
              [13.774057206784024, 0.5444424681762995],
              [13.779713463710321, 0.5523064305912662],
              [13.78226007587938, 0.5531842324202914],
              [13.785086053688032, 0.5586318174566961],
              [13.788389979798616, 0.5596451871187229],
              [13.79602953937867, 0.5647107246629869],
              [13.805386477782097, 0.5728899292306662],
              [13.803057226710028, 0.5806831838239291],
              [13.808355930521001, 0.5859226666334689],
              [13.812318854164424, 0.5857111830537219],
              [13.813323832128757, 0.5896032605433391],
              [13.812268488332679, 0.5997875799891312],
              [13.806797313027099, 0.6043011817666746],
              [13.808997669729361, 0.6119148074930628],
              [13.80681651500395, 0.6175812552301644],
              [13.800716845815646, 0.6210878198949096],
              [13.802072670673413, 0.6233419674248435],
              [13.798653462897226, 0.6300680542647926],
              [13.80419060475981, 0.6369211551407901],
              [13.80309435130252, 0.6447244455588554],
              [13.805681599735491, 0.6463471745969117],
              [13.80505994379895, 0.6552999216303571],
              [13.80597605516402, 0.6590833812480361],
              [13.805900445645406, 0.6669330692524628],
              [13.803919695215516, 0.6717840045782708],
              [13.805198713751032, 0.6795780993888036],
              [13.80885337049568, 0.687231950094328],
              [13.808495933752566, 0.6895131766359498],
              [13.811522533723187, 0.6948347024902831],
              [13.811184027764828, 0.6980946619163438],
              [13.81346318182784, 0.7024189709641487],
              [13.81388922801404, 0.707332424458741],
              [13.812424781045966, 0.7094618560943444],
              [13.81366216998072, 0.7151955820374751]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.55673272480222,
          "lat": 38.022892548798296
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51003"],
        "coty_name": ["Albemarle"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Albemarle County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01675170"
      },
      "bbox": [
        13.774057206784024, 0.24693103795390184, 14.240942304531076,
        0.798123443642745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.50946558297938, -0.49825388242571883],
            [15.509406895672267, -0.4898250112658455],
            [15.514696417956598, -0.4823382952093695],
            [15.51366458331939, -0.4752158549233086],
            [15.510175567863058, -0.47132787376739066],
            [15.51088029783366, -0.4683707610593591],
            [15.514361119206162, -0.4652915121007043],
            [15.51444881265511, -0.46251968800885673],
            [15.519503826410048, -0.46367971196064106],
            [15.520160577681477, -0.46021908333131906],
            [15.5247471076062, -0.4546472363464085],
            [15.51752848309212, -0.4454447185453517],
            [15.523203402633921, -0.4390163325542687],
            [15.525325781534459, -0.4405414535589673],
            [15.528613863961796, -0.43397244169412924],
            [15.524020110691229, -0.4295510011446352],
            [15.524632117491976, -0.4238664472426845],
            [15.526695364853213, -0.4190667665384314],
            [15.52946910746986, -0.4185228225947017],
            [15.534328061829244, -0.4137028445080742],
            [15.53420597673482, -0.41017596632101355],
            [15.538879306487484, -0.40793334569352885],
            [15.537821772175231, -0.4020377686600073],
            [15.54008617817897, -0.39936224785010194],
            [15.537348270370563, -0.39242473486832274],
            [15.532511535988395, -0.3897836787524249],
            [15.534143314622195, -0.38430785495710185],
            [15.533263758047909, -0.3809499006700101],
            [15.534576432863906, -0.3747971851447962],
            [15.53412996467332, -0.3705367742048291],
            [15.53902213136961, -0.36912582433834096],
            [15.534150306807092, -0.36136990377527006],
            [15.536440560978072, -0.35798509031506875],
            [15.53613885897768, -0.35493470481340783],
            [15.540097730250793, -0.3492768048760056],
            [15.539905680642073, -0.34114947003645996],
            [15.54473068416654, -0.3385447278714123],
            [15.545014262598153, -0.33468421932231257],
            [15.548723589170645, -0.3304109533532106],
            [15.544182671037415, -0.3273149805739468],
            [15.55009253396424, -0.3225969016467225],
            [15.549821869789556, -0.3168596199236334],
            [15.553005573472745, -0.31609207901750774],
            [15.55735006142806, -0.30885614721452975],
            [15.550340143693516, -0.30753956723632514],
            [15.549365488568823, -0.30104652585664726],
            [15.553855910833304, -0.298405920128742],
            [15.55312249534081, -0.29475009341199865],
            [15.555793906876533, -0.2902038332499044],
            [15.553095235304705, -0.2817488213240613],
            [15.55248577248754, -0.2766454039910012],
            [15.545133105535022, -0.27500640529055814],
            [15.542093214471917, -0.2720891820585113],
            [15.53995831909893, -0.27552567781949405],
            [15.536121330717421, -0.2739027683576545],
            [15.534649903664594, -0.27021535851458545],
            [15.537106733987747, -0.26401005706679725],
            [15.530574411548375, -0.26588122801603264],
            [15.52610760624123, -0.2631613593189306],
            [15.525413738387142, -0.2575033315072129],
            [15.522494939301932, -0.2535622548071464],
            [15.519409229127003, -0.2522912685910213],
            [15.515342959986176, -0.24410577883761062],
            [15.5097684708699, -0.24032747031341012],
            [15.51188260584502, -0.23406314289411137],
            [15.511029578568678, -0.23045534832337308],
            [15.512772313756987, -0.22305996752161267],
            [15.509526511244184, -0.2190927105602499],
            [15.511064165415581, -0.21045099095657802],
            [15.509679007187117, -0.20776082644516006],
            [15.509487237458714, -0.20099950559835716],
            [15.517648566585663, -0.19312182909812778],
            [15.562969230272387, -0.15429364379307645],
            [15.604310216803114, -0.1205737531706343],
            [15.608529495693716, -0.11932192698863317],
            [15.613340139106453, -0.11558115158837863],
            [15.61380053567533, -0.11255036115123333],
            [15.610307672816804, -0.10818932372144327],
            [15.612899391510211, -0.10109089237438806],
            [15.613422518625791, -0.09285134790869683],
            [15.612324242108246, -0.08877247318102935],
            [15.61876065327546, -0.08380108530775553],
            [15.617217645297, -0.07499836941893284],
            [15.61847862117413, -0.07303950828095984],
            [15.615778383634883, -0.06820210998714117],
            [15.617351602434585, -0.06494175783719307],
            [15.620534571437027, -0.0669248989451898],
            [15.621790456604192, -0.06206379319234745],
            [15.6179802374158, -0.05997909426135077],
            [15.619191681034836, -0.05715610173498795],
            [15.616234701398744, -0.053889255320813734],
            [15.614232549432339, -0.045427492907193154],
            [15.614990501630313, -0.04103196055562016],
            [15.618625440993965, -0.03670302032570507],
            [15.61539418417814, -0.0320412081186565],
            [15.617743466092884, -0.028446356081771252],
            [15.621547702786277, -0.029319594150567948],
            [15.625207777672946, -0.03637846844812481],
            [15.626183356039988, -0.04389417557825976],
            [15.629287518081117, -0.050581037135219185],
            [15.635679453118046, -0.05796165956465179],
            [15.635835958298827, -0.0646679755276609],
            [15.637403197897772, -0.07106665619958638],
            [15.634219105660398, -0.09291952959182893],
            [15.6357738072242, -0.1094479187789372],
            [15.640598476749513, -0.11842530803582921],
            [15.64770593779787, -0.12497784723891983],
            [15.652344161545983, -0.12738368234780487],
            [15.659127474066517, -0.1290185169841915],
            [15.665148559634721, -0.128614191709137],
            [15.685492609672753, -0.12421273380601774],
            [15.69535211336922, -0.12481414652356884],
            [15.706742857286443, -0.12689131760582809],
            [15.71473905978503, -0.13224427453676268],
            [15.71755333676465, -0.1384119810853529],
            [15.712643412515758, -0.1489736554061794],
            [15.71810696850487, -0.1572188131957554],
            [15.725105281834653, -0.1546051524132678],
            [15.726389007649983, -0.14917491202513058],
            [15.730104197401873, -0.14777028777706075],
            [15.740142370428904, -0.1506889590304788],
            [15.750547234555599, -0.15955785127246486],
            [15.7562334341134, -0.16150876276809034],
            [15.763687457767602, -0.1613841767138363],
            [15.765371688560535, -0.1667236126942512],
            [15.768854912014795, -0.17128897898957107],
            [15.77583039377414, -0.17512915695877354],
            [15.786493193154467, -0.17584510755975352],
            [15.789942079849979, -0.175355258127183],
            [15.799047016048682, -0.1821754386192036],
            [15.799049547317393, -0.18647352127719904],
            [15.803463246486178, -0.1997826815596412],
            [15.795340397381787, -0.1985211916433218],
            [15.793101964629457, -0.2030029812122388],
            [15.794322220477559, -0.21117476794381906],
            [15.799297783060227, -0.21722981277694156],
            [15.796844498648367, -0.22586045999240492],
            [15.791194758967324, -0.22975226721772127],
            [15.78252096979886, -0.23739481270963064],
            [15.776880922054286, -0.23383052487294745],
            [15.776684266394685, -0.2300506809296897],
            [15.774048675208881, -0.2284636852957614],
            [15.770993716813797, -0.2302687919107403],
            [15.722370548569447, -0.3008531399251527],
            [15.685865656077214, -0.35456986944265284],
            [15.642034419218321, -0.41986468724015524],
            [15.633025833857722, -0.43351990435932],
            [15.609352724462006, -0.4657792223538479],
            [15.59544316679852, -0.4827680151346686],
            [15.587732214405184, -0.4951272466306683],
            [15.56114463774256, -0.5323593967251851],
            [15.543337811742367, -0.5569637952847899],
            [15.533099525726433, -0.5547991295160646],
            [15.529749125154865, -0.5514560436521312],
            [15.527643803236726, -0.5444483263433674],
            [15.524176993475281, -0.5431439289956244],
            [15.526903797591123, -0.5342893032277402],
            [15.52633224635508, -0.5308924996793593],
            [15.521697877078617, -0.5256893451633938],
            [15.518224996247444, -0.5235062532591612],
            [15.516674669202752, -0.5191660609285789],
            [15.519024239007603, -0.5174598973435016],
            [15.51810364943626, -0.5116264734177638],
            [15.520997763260482, -0.5055100717750309],
            [15.5177154237195, -0.5035232041443028],
            [15.510531041352188, -0.5077213818455915],
            [15.50719511445765, -0.5018476448243405],
            [15.50946558297938, -0.49825388242571883]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.7258783216608, "lat": 36.89125993014185 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51093"],
        "coty_name": ["Isle of Wight"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Isle of Wight County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01702378"
      },
      "bbox": [
        15.50719511445765, -0.5569637952847899, 15.803463246486178,
        -0.028446356081771252
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.478140871253611, 0.7929140544474804],
            [15.48047141289423, 0.7955969215310171],
            [15.483897585935607, 0.7946295035888993],
            [15.485485191693078, 0.7905209218020565],
            [15.48914539630816, 0.7896494863220399],
            [15.49195390841971, 0.7868791269290183],
            [15.5016176349458, 0.7836151823327614],
            [15.503773256284221, 0.7800614691617146],
            [15.513163873314356, 0.7814061174606091],
            [15.521585882905596, 0.7792628947854335],
            [15.526346544823644, 0.774390070053913],
            [15.531004809751934, 0.7727919220543751],
            [15.538681340050251, 0.7730800331512584],
            [15.545116241424378, 0.7705806542734747],
            [15.548069216112099, 0.7640581421641977],
            [15.551194431606486, 0.7612931930340102],
            [15.556198386279181, 0.7533690469254382],
            [15.55956782062819, 0.7456378423891603],
            [15.560180971756052, 0.7397249592407453],
            [15.565021310999645, 0.7322310819074611],
            [15.566240981749354, 0.7238091574726374],
            [15.564807298791807, 0.7191223837810149],
            [15.56392926864832, 0.7099845362380659],
            [15.571374820512453, 0.7034583473389662],
            [15.577586012652661, 0.7002930403876712],
            [15.591876939406239, 0.6986404064199143],
            [15.596215940218277, 0.6967590004964119],
            [15.601053618355664, 0.686588248144665],
            [15.598060487862615, 0.6856553130873809],
            [15.594693276704868, 0.6810123292928156],
            [15.591025530530652, 0.6802571453186089],
            [15.583483347488825, 0.6810795379276589],
            [15.577721885966776, 0.6780719320368066],
            [15.5680589673921, 0.6772076949533814],
            [15.562174917644873, 0.6750237136953242],
            [15.557792091207375, 0.6760297381940767],
            [15.552682596921608, 0.6688995321445265],
            [15.54918625182222, 0.6682646057093268],
            [15.546786873959633, 0.6611522313323245],
            [15.54850187461034, 0.6564340184052908],
            [15.546999913437281, 0.6475308726918674],
            [15.541595514355395, 0.6500516751138706],
            [15.53762534200969, 0.6474725367776607],
            [15.536621446130239, 0.6428090385309428],
            [15.532225190574104, 0.6415527349913309],
            [15.530724749566529, 0.6380199269612016],
            [15.526578317495579, 0.6394131540672193],
            [15.5223073026873, 0.6355107268304114],
            [15.516904598290507, 0.6361415433831433],
            [15.514518448974739, 0.6340027286809005],
            [15.515707465848418, 0.6293799458935644],
            [15.511868842433378, 0.6291751375022172],
            [15.50798656504254, 0.6323427976071345],
            [15.50477499133568, 0.6322609963809311],
            [15.500983860659511, 0.6262496285626802],
            [15.49979034991565, 0.6217016630267318],
            [15.492352507494964, 0.631070966402475],
            [15.482744541712453, 0.6345998125275041],
            [15.479391523068124, 0.6371354621806553],
            [15.47173455514082, 0.6462422601346521],
            [15.462707546371043, 0.6414090207214382],
            [15.45593917531352, 0.6399193936639028],
            [15.449729303037735, 0.6435618340513016],
            [15.444895755876002, 0.6478960613264364],
            [15.437345769150868, 0.6505295716258037],
            [15.434383665863903, 0.6494534970176317],
            [15.432361717758557, 0.6552602060311365],
            [15.427757584657245, 0.662098923247823],
            [15.423127706078404, 0.6652172528960957],
            [15.418998334103577, 0.6659016940063922],
            [15.41815298064695, 0.6741335699763173],
            [15.419073769930943, 0.6763525005189527],
            [15.412632466161936, 0.6811112529952243],
            [15.409930171961312, 0.6852888179924336],
            [15.395333799097552, 0.6858077300576957],
            [15.393617064046847, 0.6956747636567905],
            [15.38896072503426, 0.7049665387389543],
            [15.384867951708863, 0.7082831568461648],
            [15.378444702449979, 0.7155687988789904],
            [15.360936286989036, 0.7260887412817222],
            [15.359455121618746, 0.7245300060472826],
            [15.352213822392898, 0.7233371178596215],
            [15.346868514987685, 0.7286200069248886],
            [15.342317021969482, 0.7304901590207333],
            [15.333345273287195, 0.7271095007630669],
            [15.329923207012827, 0.7290185206360797],
            [15.32032582077122, 0.7386683143051032],
            [15.31962076204899, 0.7418850708390089],
            [15.316218839646245, 0.7437007206939882],
            [15.317760237270885, 0.7491345247492743],
            [15.313450462940871, 0.7577171158970047],
            [15.312079232161963, 0.7630372660069779],
            [15.309213751625279, 0.7664600070017624],
            [15.305916192701766, 0.7645829959341017],
            [15.300718647940846, 0.7676690311264319],
            [15.295925545504025, 0.7730617721458627],
            [15.293017627629157, 0.7747851396228059],
            [15.276946394792278, 0.7718947789651667],
            [15.271084583834089, 0.7769740500171195],
            [15.268412202549717, 0.782769155218101],
            [15.268700778065492, 0.7897290088456304],
            [15.264599564135715, 0.798497572062745],
            [15.259859202645748, 0.8021517247520107],
            [15.258735372914089, 0.810863080779731],
            [15.254247802593422, 0.8168883827408233],
            [15.248763271894415, 0.8291778634321914],
            [15.248362743565917, 0.8334591721565928],
            [15.246126268027512, 0.8350205020723895],
            [15.236532165275284, 0.8510489496814605],
            [15.233100963598483, 0.8504560927497525],
            [15.228945612248136, 0.8543044361565943],
            [15.224394655123087, 0.8547464726110228],
            [15.224894184032363, 0.860160607816245],
            [15.220916749870357, 0.8622752223352738],
            [15.226882831317686, 0.8650213167498415],
            [15.231502729854979, 0.8693591325954485],
            [15.232274748772964, 0.8723466734037398],
            [15.23982287456357, 0.8788647308765507],
            [15.24339869213831, 0.8873137167914886],
            [15.24706641843998, 0.8915167809176702],
            [15.260719120633157, 0.9109537457920177],
            [15.268445728684021, 0.9051484229433497],
            [15.274369332146788, 0.8929378502463151],
            [15.281133426656503, 0.8882332592680225],
            [15.283229215822262, 0.8845101453438096],
            [15.286813289203293, 0.8820380384656041],
            [15.31396443825658, 0.860750652260494],
            [15.31953306168133, 0.8598739186470934],
            [15.323032233581637, 0.8558386932458006],
            [15.329638388423822, 0.8589079996392158],
            [15.33492280081068, 0.8579576532357149],
            [15.337836170702882, 0.8545182501651037],
            [15.348036106769268, 0.8495706895697401],
            [15.358975420357085, 0.8431462837279279],
            [15.364400722851203, 0.8381210988226953],
            [15.371006045331079, 0.8368780120699072],
            [15.373198124629107, 0.8303393030492969],
            [15.37117824918966, 0.8249986736426437],
            [15.373909701853336, 0.8168059302648032],
            [15.371188926891653, 0.8073355816643154],
            [15.377183023112337, 0.8043023545620036],
            [15.38473923617682, 0.8028169113226954],
            [15.387982216400225, 0.8074061874346653],
            [15.399064568913847, 0.8101854479240364],
            [15.423769584462724, 0.8001705883296913],
            [15.432336784696997, 0.8023493343752778],
            [15.438765317490363, 0.8012480801746331],
            [15.445896545326235, 0.80520067176441],
            [15.458101385957136, 0.8047974710371328],
            [15.462136398752305, 0.8013391622476544],
            [15.467313348622392, 0.7923563964270118],
            [15.47527333483507, 0.7912205048056841],
            [15.478140871253611, 0.7929140544474804]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.72515298764041,
          "lat": 37.942608401382444
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51159"],
        "coty_name": ["Richmond"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richmond County"],
        "coty_fp_code": "159",
        "coty_gnis_code": "01480164"
      },
      "bbox": [
        15.220916749870357, 0.6217016630267318, 15.601053618355664,
        0.9109537457920177
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.781927347655069, -1.4205714986593667],
            [10.800146713034536, -1.3343701903395273],
            [10.809293701000062, -1.3253497506080167],
            [10.828921434810177, -1.3094795804426758],
            [10.833932543069173, -1.3040465540040282],
            [10.84283812669784, -1.2970005971610528],
            [10.84879578021839, -1.2931478816217659],
            [10.865839791256668, -1.2838570605897],
            [10.869051201949594, -1.2827579460951948],
            [10.87483453725431, -1.2782554854635109],
            [10.886857755872505, -1.2676127240873893],
            [10.889842512529455, -1.2630862423549583],
            [10.887628708425053, -1.2530293206348508],
            [10.882869664940435, -1.2501820569524429],
            [10.895810964728193, -1.2223150085545411],
            [10.902416020330504, -1.2159670106408205],
            [10.91022838620422, -1.21563305874343],
            [10.908522038013105, -1.212775287047764],
            [10.910764024410236, -1.2097352724268455],
            [10.911401983749377, -1.2048046514456014],
            [10.918014262239208, -1.1984537980750518],
            [10.921231557914584, -1.1909948165065796],
            [10.919090132648057, -1.1881023588798758],
            [10.92056996765857, -1.1813299554005394],
            [10.9244449062774, -1.1776925379684704],
            [10.930064897985533, -1.1629820832450664],
            [10.935073179354708, -1.1558231776684706],
            [10.937125462357457, -1.1582904485422005],
            [10.940316358118269, -1.1567335469588176],
            [10.943165447032673, -1.1598278459946019],
            [10.946973750571736, -1.1567110007292136],
            [10.950941420157951, -1.157047536246946],
            [10.95552456511035, -1.1540180390105101],
            [10.956316777322648, -1.1601971815069856],
            [10.963255523102031, -1.1620949775566252],
            [10.969288870279902, -1.1608973459466188],
            [10.972523716953198, -1.166020052700701],
            [10.976167611829824, -1.1661603589289522],
            [10.981608507637931, -1.1615639312745034],
            [10.98715545785254, -1.1500219740202016],
            [10.994266382765444, -1.141594191526538],
            [10.99686116260058, -1.1415276594708639],
            [11.004863061219266, -1.1332490438670657],
            [11.006162674446132, -1.1282748478039493],
            [11.006330697717306, -1.1214184731894048],
            [11.0095239074954, -1.1102072340519797],
            [11.017600825560839, -1.09762863960272],
            [11.030618512761345, -1.093273894882874],
            [11.080083704996348, -1.0849084469934005],
            [11.193893478559625, -1.0655451574624455],
            [11.197795303370336, -1.0644621830595038],
            [11.199567456374641, -1.067718488704816],
            [11.196818908815821, -1.0740368512859326],
            [11.219169803811079, -1.1095815247747718],
            [11.25018305564952, -1.1647637465999918],
            [11.259643687347882, -1.1861726869647673],
            [11.279500497130417, -1.232816833218576],
            [11.285560332085254, -1.2471347620257394],
            [11.311504678443182, -1.3192567053580913],
            [11.319493887790056, -1.3323370659415983],
            [11.325746942006635, -1.3416275478608122],
            [11.19016647209001, -1.3624334404264],
            [11.178245404391092, -1.3628400439327475],
            [11.13532447758715, -1.3695960028288074],
            [11.077979299903916, -1.3788157787861406],
            [11.022361487382051, -1.387089465935186],
            [10.903780411732477, -1.4036530619023277],
            [10.858466695675865, -1.410262182345723],
            [10.781927347655069, -1.4205714986593667]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.60294535234567, "lat": 36.71430283493753 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51169"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "01498172"
      },
      "bbox": [
        10.781927347655069, -1.4205714986593667, 11.325746942006635,
        -1.0644621830595038
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.384299917094802, -1.102715204135842],
            [12.383880647240987, -1.098131119181411],
            [12.38814719637034, -1.091142807295954],
            [12.39249229808405, -1.0947136262132593],
            [12.394644282349104, -1.09269795290371],
            [12.393279587036039, -1.0893435389498185],
            [12.393333463061515, -1.0790816794721139],
            [12.397765805569492, -1.0769145184707885],
            [12.40287243237036, -1.084144246436446],
            [12.405117494975597, -1.0804939624547383],
            [12.40372136502338, -1.0777846414846488],
            [12.412669454402614, -1.0732615307462112],
            [12.414573462666937, -1.0763820734305252],
            [12.418017975935584, -1.0733343184627822],
            [12.424143917125447, -1.0752530592033458],
            [12.417819868501715, -1.093419701285823],
            [12.413599970887557, -1.0982527179277966],
            [12.401903885502938, -1.1217210332304404],
            [12.400144089697145, -1.1272937059373447],
            [12.403230637053646, -1.1319334138355728],
            [12.40377165449674, -1.1427897184799138],
            [12.397673051113388, -1.147158044991428],
            [12.392565687208135, -1.1487474523753933],
            [12.39165272986806, -1.1455958157867847],
            [12.397059520342788, -1.1293583369015643],
            [12.382069762152186, -1.1299544793327854],
            [12.375852505535205, -1.1278124611399398],
            [12.372971331712248, -1.1211959699157723],
            [12.372075335175216, -1.1134600672205515],
            [12.374585172160794, -1.1049001676092716],
            [12.37426287921931, -1.099504344890819],
            [12.378357085631793, -1.0965309063583313],
            [12.380314572488862, -1.099430935105817],
            [12.379443955843247, -1.103058858769153],
            [12.384299917094802, -1.102715204135842]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.91775595691419, "lat": 36.66612823785883 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51640"],
        "coty_name": ["Galax"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Galax city"],
        "coty_fp_code": "640",
        "coty_gnis_code": "01498426"
      },
      "bbox": [
        12.372075335175216, -1.1487474523753933, 12.424143917125447,
        -1.0732615307462112
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.044193954420944, -0.15801499374847078],
            [16.046338723295957, -0.16689174033109647],
            [16.037622790325674, -0.16679469348039186],
            [16.037173546523526, -0.1709496343464932],
            [16.034751307400672, -0.17243509574777377],
            [16.038585651252312, -0.1778171909479291],
            [16.045276126652794, -0.18193958517791214],
            [16.0386975176769, -0.19656239293004465],
            [16.03671485530065, -0.2044169922338845],
            [16.04277657350232, -0.21264703651197447],
            [16.046101175091078, -0.21584586174033232],
            [16.046605894596343, -0.22017355101867775],
            [16.045214233259212, -0.22469897432713956],
            [16.04851260184099, -0.22689096047273577],
            [16.0596226743336, -0.23019156448300315],
            [16.05915973995217, -0.23781078607746328],
            [16.055189157448567, -0.24596252709476293],
            [16.052005862427315, -0.24989996751673677],
            [16.05061111042733, -0.25671072370606113],
            [16.051433539399728, -0.2597916168519369],
            [16.04765355964933, -0.26267428131170045],
            [16.04147574903692, -0.2591309015243103],
            [16.03603143134974, -0.26059073131962057],
            [16.025060437911673, -0.25506503216480897],
            [16.011971435798127, -0.261010210644506],
            [16.011283429584967, -0.26525792036650453],
            [16.004690668094696, -0.27916282490799027],
            [15.989804090533124, -0.27478539127118595],
            [15.98871087826821, -0.27826254981554743],
            [15.98359861545617, -0.28233182467017265],
            [15.979217093242513, -0.28319502904658894],
            [15.972989255684833, -0.2728466457104636],
            [15.971807448157419, -0.26453291216106367],
            [15.964130202909619, -0.2565919390325521],
            [15.959061680261945, -0.2526039876198065],
            [15.957364784988387, -0.24802190073267505],
            [15.939747485976872, -0.23826284309402637],
            [15.938581565538932, -0.23600690688212228],
            [15.941496983371943, -0.22599086388560394],
            [15.944651006548552, -0.2255645377306065],
            [15.945546221379693, -0.22204302473495593],
            [15.943758439005926, -0.20766115489403106],
            [15.952806885082042, -0.20479861363745774],
            [15.960012733947513, -0.20763607439829157],
            [15.96338623735023, -0.20660134524115217],
            [15.963867372307297, -0.202472080611773],
            [15.951004661653341, -0.19868688444848853],
            [15.949628649040587, -0.20031744851480543],
            [15.939004747750081, -0.19935293954051722],
            [15.936867210973487, -0.20067584485694606],
            [15.93664640867136, -0.20768410499643516],
            [15.934290845918872, -0.20837484880866836],
            [15.930606548852765, -0.1977896914061498],
            [15.925513417732777, -0.18109762880900693],
            [15.923092185939156, -0.17117253942869487],
            [15.922226789377623, -0.14955860714768449],
            [15.925717394632706, -0.14970757343869412],
            [15.927544612507294, -0.1540366235641269],
            [15.931441811974624, -0.15570738905002832],
            [15.943158671478129, -0.15221375640770818],
            [15.942806985898843, -0.14280062570175103],
            [15.943877581872677, -0.13900964674943775],
            [15.956558681261056, -0.13698920203981915],
            [15.966715751340217, -0.13885588003133187],
            [15.983561310265952, -0.1459833594628653],
            [15.996227305034289, -0.152594629175183],
            [16.007696867348894, -0.15595239581639306],
            [16.02093024698745, -0.15769756411948127],
            [16.033941713029893, -0.1587651043924124],
            [16.044193954420944, -0.15801499374847078]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.25701854238817, "lat": 36.89473158350148 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51710"],
        "coty_name": ["Norfolk"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Norfolk city"],
        "coty_fp_code": "710",
        "coty_gnis_code": "01498557"
      },
      "bbox": [
        15.922226789377623, -0.28319502904658894, 16.0596226743336,
        -0.13698920203981915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.378626578069976, 11.019383904956499],
              [-18.37346381343347, 11.01901274842047],
              [-18.365866820291355, 11.01493912109293],
              [-18.360372369287518, 11.009006959485479],
              [-18.363176133821394, 11.004869570737453],
              [-18.365672345732364, 11.00560909160087],
              [-18.371697523852582, 11.012030894048285],
              [-18.374862270251924, 11.013427330102001],
              [-18.378626578069976, 11.019383904956499]
            ]
          ],
          [
            [
              [-18.521071572831666, 11.640718795859145],
              [-18.492102617142624, 11.632146221201676],
              [-18.486715243658857, 11.630078636801567],
              [-18.47335132962243, 11.626506718587722],
              [-18.407256496930955, 11.606632602261355],
              [-18.362730194675866, 11.593610833519763],
              [-18.32064071661367, 11.580830498896125],
              [-18.32517023949582, 11.566772435167183],
              [-18.267046135396136, 11.548929588541043],
              [-18.196092666426964, 11.527890782094069],
              [-18.12514433716496, 11.506833841757606],
              [-18.05591116886912, 11.4863816932531],
              [-17.973370404918313, 11.462236595307141],
              [-18.022066697793203, 11.299921911381483],
              [-18.026385354719544, 11.286213964432202],
              [-18.04630725592253, 11.219969527824366],
              [-18.037101442216915, 11.21694876623629],
              [-18.045673136163543, 11.188595265039917],
              [-18.05753022437156, 11.147191171757477],
              [-18.06183385379353, 11.133612734748807],
              [-18.06449411782664, 11.127603900961649],
              [-18.06692457234314, 11.116683764984858],
              [-18.083907935771133, 11.060103290036002],
              [-18.085694658411942, 11.052350309000879],
              [-18.076005438683612, 11.049127043636023],
              [-18.060849221345933, 11.045427488517051],
              [-18.047509148650448, 11.041442824680301],
              [-18.03349123850387, 11.037785402950549],
              [-18.02003004090772, 11.033017791202553],
              [-18.00687013986878, 11.029180283840642],
              [-17.980535440540482, 11.022923451559844],
              [-17.93494367720956, 11.010960035568493],
              [-17.924698782947324, 11.007755498793852],
              [-17.91068844462599, 11.004107547993105],
              [-17.896662327402876, 10.999901327134596],
              [-17.900829381589443, 10.983832983255558],
              [-17.91697698291128, 10.929738934072972],
              [-17.92220719108541, 10.917563980091757],
              [-17.90743365744496, 10.9130358834935],
              [-17.89310785639892, 10.908039597760382],
              [-17.897882817824286, 10.89464395588375],
              [-17.918791397392017, 10.827618504349891],
              [-17.94186531398884, 10.750145879875472],
              [-17.951407328144484, 10.718448247908464],
              [-17.97898828037399, 10.727481903375613],
              [-17.994305112179685, 10.730871104168155],
              [-18.021116437906628, 10.739083356249152],
              [-18.028500161936, 10.740513856009002],
              [-18.063315663829357, 10.751146287416633],
              [-18.077159971440466, 10.755012350861938],
              [-18.083885981790367, 10.75528568192329],
              [-18.09044055557299, 10.75746731787648],
              [-18.16401264382983, 10.779688770183508],
              [-18.196195469441523, 10.79027603417987],
              [-18.233123287880062, 10.800750535685308],
              [-18.24828633013341, 10.804673553176505],
              [-18.262032023165553, 10.809112132582671],
              [-18.275808672836952, 10.81281543190649],
              [-18.30355983809721, 10.82115697519013],
              [-18.333058053424306, 10.829210815832015],
              [-18.371822798240814, 10.840480726122264],
              [-18.410359439539757, 10.850860133648615],
              [-18.423762590372462, 10.855123372215699],
              [-18.42979125441014, 10.857970579430093],
              [-18.436768339358757, 10.859634494387928],
              [-18.502557126423042, 10.879987556546533],
              [-18.51634163360356, 10.883604512181284],
              [-18.55767863660119, 10.897433353360883],
              [-18.56870706478832, 10.900552655233147],
              [-18.565791990101598, 10.916641593362852],
              [-18.562822672209403, 10.942058809983898],
              [-18.561684672956854, 10.987388929504084],
              [-18.561639216346453, 11.003025901845751],
              [-18.56050449231408, 11.010289772674259],
              [-18.55185130517256, 11.00958720417428],
              [-18.545591700992464, 11.015417363010455],
              [-18.542409349631505, 11.013756395955502],
              [-18.537500792138278, 11.003808325543444],
              [-18.533957141564795, 11.00012824806043],
              [-18.534075547050982, 10.993874780851508],
              [-18.53788809946065, 10.986398561770963],
              [-18.54085142170522, 10.982819947750519],
              [-18.538905488122165, 10.97656686785797],
              [-18.541387939839638, 10.96766911554987],
              [-18.532569472042226, 10.958674491111081],
              [-18.52359304389224, 10.95970729763972],
              [-18.518138143403412, 10.963496672232127],
              [-18.508293330575704, 10.981835479549387],
              [-18.505578720315427, 10.983803336061978],
              [-18.497641266204873, 10.98603366679954],
              [-18.48132335528059, 10.98643663053865],
              [-18.47526879572213, 10.993796081080113],
              [-18.466566091865587, 10.99306161119168],
              [-18.45727490030437, 10.997951198115382],
              [-18.45320629890956, 10.997886049806166],
              [-18.44986676839577, 10.995562501631854],
              [-18.439352167657592, 10.99194957104432],
              [-18.423810927017968, 10.994860983673462],
              [-18.40824750059651, 10.994657533413353],
              [-18.384984248073486, 10.99488337422606],
              [-18.3757383967863, 10.995429574285184],
              [-18.36028600708333, 10.99987329521482],
              [-18.35208133441114, 10.999431232886884],
              [-18.353820030300945, 11.00706646689098],
              [-18.36142356458626, 11.016106016802741],
              [-18.371687925675477, 11.021465790942175],
              [-18.380924628970213, 11.023240992770235],
              [-18.385856500128128, 11.027789691783592],
              [-18.40120934681293, 11.032282267667993],
              [-18.418686398189113, 11.03428418757121],
              [-18.422999841679594, 11.048858291484084],
              [-18.43889146754719, 11.053443839357236],
              [-18.444714147012473, 11.053742624023403],
              [-18.456793837577486, 11.062405119855354],
              [-18.459783642324012, 11.067517620348797],
              [-18.458161798470936, 11.07136614339198],
              [-18.451710282391268, 11.073862398727199],
              [-18.446806096176847, 11.078560350211541],
              [-18.44917164637606, 11.08327571941392],
              [-18.453665133454916, 11.086239599170293],
              [-18.451348238379296, 11.091073769349375],
              [-18.45303711797451, 11.107234057885714],
              [-18.456547361056227, 11.108731522059417],
              [-18.463508028039314, 11.114410088581987],
              [-18.466265939777756, 11.120097358331542],
              [-18.47179191086499, 11.126311634803576],
              [-18.475754044269863, 11.12518935265188],
              [-18.501862966515805, 11.1345191205617],
              [-18.512419651103336, 11.136665010388736],
              [-18.527054889717625, 11.134399874718932],
              [-18.533683044173827, 11.130413360036753],
              [-18.53753054022912, 11.12321118766225],
              [-18.537768286252668, 11.111809199604576],
              [-18.534913994837083, 11.103860781401135],
              [-18.53483807324425, 11.099980043794883],
              [-18.539469260115837, 11.090356398936533],
              [-18.54341279877766, 11.073754572473668],
              [-18.54263793387284, 11.063787619863886],
              [-18.542903757353777, 11.052995753519252],
              [-18.54385569711862, 11.047896246769698],
              [-18.53888486448164, 11.04524852146465],
              [-18.533454654610452, 11.046873618015299],
              [-18.53007035046475, 11.04286047203996],
              [-18.532260058110886, 11.036293219911819],
              [-18.53519989136317, 11.03543063024062],
              [-18.544705763928455, 11.044462876479686],
              [-18.54973856591219, 11.047647565069083],
              [-18.55444745972715, 11.045705471648578],
              [-18.562368450083916, 11.044694936708465],
              [-18.5639829368032, 11.040162154942813],
              [-18.56897950099445, 11.038996430519475],
              [-18.57962648777783, 11.039935331786111],
              [-18.579096890282564, 11.043738942390805],
              [-18.575852665045936, 11.053504562724191],
              [-18.568769799107013, 11.068565038879111],
              [-18.556941533627192, 11.101858009590392],
              [-18.538925021370005, 11.169835097022643],
              [-18.533307294810147, 11.195333034879996],
              [-18.52781710265446, 11.232104736635243],
              [-18.52574885052325, 11.236285860128095],
              [-18.526147388392644, 11.248117893917561],
              [-18.522277418059925, 11.2746805653572],
              [-18.51800951881548, 11.318435368335702],
              [-18.51572962329747, 11.388247273117036],
              [-18.518119664207756, 11.395765404152524],
              [-18.52460843909308, 11.408010890904812],
              [-18.53328667557208, 11.411602712674306],
              [-18.537394081969715, 11.414215376563911],
              [-18.53731027323368, 11.43333930780394],
              [-18.53769445598637, 11.44787468760435],
              [-18.5393911128258, 11.45760992645615],
              [-18.543180391360448, 11.462732783856952],
              [-18.549952726460102, 11.468124820218984],
              [-18.548924619213008, 11.471967554200614],
              [-18.549506901855565, 11.480264426469647],
              [-18.546415943189206, 11.490639795524006],
              [-18.543961988784535, 11.51175214911022],
              [-18.546553876014748, 11.517566924762649],
              [-18.54551374306935, 11.52424930558131],
              [-18.543603972965958, 11.527799510485497],
              [-18.53918327270146, 11.54377410932366],
              [-18.539070771032613, 11.54856371635918],
              [-18.534593024227494, 11.563316706577437],
              [-18.533478162860153, 11.573796747329453],
              [-18.532308718767652, 11.576072292044696],
              [-18.52776412447998, 11.597420206331188],
              [-18.521071572831666, 11.640718795859145]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.77348815703049,
          "lat": 47.150287436626066
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53027"],
        "coty_name": ["Grays Harbor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grays Harbor County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01531823"
      },
      "bbox": [
        -18.57962648777783, 10.718448247908464, -17.89310785639892,
        11.640718795859145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.21534597883968, 1.7577249628134806],
            [13.217116213852659, 1.7662093680511177],
            [13.223344747113849, 1.7652089136973577],
            [13.226430642437357, 1.7674357059427006],
            [13.226927459731739, 1.770810978882407],
            [13.223706251243115, 1.7737583347250137],
            [13.225906107438519, 1.7779295845355914],
            [13.22492987462343, 1.782811659250654],
            [13.22189693629137, 1.7885135285640177],
            [13.22736747727865, 1.7878595699104112],
            [13.23207644687612, 1.7925792512152436],
            [13.239109146621763, 1.7940328670043513],
            [13.239190792367975, 1.799118718663519],
            [13.247954160266039, 1.7992326077059941],
            [13.252478282012271, 1.800372588852446],
            [13.252849834645616, 1.8079107572933595],
            [13.258471684466665, 1.8161911690070587],
            [13.260948831921143, 1.8276240479922496],
            [13.263666004354349, 1.8281861667808104],
            [13.270722177055667, 1.8259393006511155],
            [13.276074350658876, 1.8307704123095823],
            [13.271919501438584, 1.8357399435719604],
            [13.276888668015276, 1.837279170980568],
            [13.279903583160259, 1.8336875809659061],
            [13.285280499742512, 1.8304888769486398],
            [13.286897101218393, 1.8356059732459167],
            [13.281849251814172, 1.8439596740012079],
            [13.282492686934322, 1.8489855682875733],
            [13.285723593574897, 1.8548096926468678],
            [13.283876660730618, 1.860201727894485],
            [13.287149510181223, 1.8627545096630211],
            [13.292129060620637, 1.8597018376455494],
            [13.293604826479076, 1.8510227879683971],
            [13.298219343442625, 1.851312176343548],
            [13.2993043287305, 1.856782434307016],
            [13.297259374817145, 1.8629127197174258],
            [13.301244713368968, 1.8658819208129669],
            [13.3076102174012, 1.8655818098238186],
            [13.307478114331856, 1.8708135690738577],
            [13.304958666719974, 1.877469478742729],
            [13.308079652729736, 1.8817828631866587],
            [13.317384804601513, 1.881072184604215],
            [13.318286431787874, 1.883097597271101],
            [13.312833292658883, 1.8876112308587711],
            [13.313779915227984, 1.893175960575127],
            [13.317967702328936, 1.896415457587032],
            [13.321111952177032, 1.9025481784513385],
            [13.320480036410705, 1.908682460118035],
            [13.315964228844395, 1.9076840231019698],
            [13.31562847045632, 1.9126608326974766],
            [13.317961568062618, 1.9141673201143015],
            [13.324382547776157, 1.9147886177386753],
            [13.322214324335395, 1.920229651708946],
            [13.31689357639232, 1.9211108994494979],
            [13.314933888824356, 1.9250754596150348],
            [13.318000895332634, 1.9284604634765976],
            [13.32570679215665, 1.925132687982496],
            [13.331955926545167, 1.9252021804603898],
            [13.342415573769271, 1.9302982536492255],
            [13.342375535312014, 1.9352671990605554],
            [13.345026520202385, 1.9347937476080312],
            [13.348820800133634, 1.9286054319184607],
            [13.352891591206394, 1.9290883047718195],
            [13.352514844167413, 1.9378355370776954],
            [13.354463298227776, 1.9414720389782447],
            [13.3570710277758, 1.9419951647236946],
            [13.359677932370536, 1.9388195262211367],
            [13.365871961427844, 1.9368605583113325],
            [13.369772069798277, 1.9283024131865307],
            [13.37456496000959, 1.9263978309210272],
            [13.382508754732738, 1.9297965895482538],
            [13.388878619493179, 1.9248681314255518],
            [13.399866767675354, 1.9206125632211064],
            [13.414637874022707, 1.916841755402548],
            [13.422155186542112, 1.9127157518481084],
            [13.426520227220045, 1.9085106241074286],
            [13.432768714203364, 1.911497192277735],
            [13.431951647190402, 1.9192084500343463],
            [13.428303717914158, 1.922356750001483],
            [13.432018923035388, 1.9261663035729266],
            [13.428054782069564, 1.9299021732607176],
            [13.427802805690554, 1.934776037464325],
            [13.43113112414086, 1.9351739883984511],
            [13.435746100770189, 1.9385686103964501],
            [13.439208287981593, 1.9437088607913995],
            [13.440131143925495, 1.9475254278318708],
            [13.436313911196157, 1.953894736423121],
            [13.441907827208532, 1.960233864980392],
            [13.446734817695756, 1.9619535780632995],
            [13.454724400061048, 1.962933375465116],
            [13.455440697701627, 1.970455385119687],
            [13.458734992183622, 1.9740745640740387],
            [13.460920596884494, 1.9826921663423607],
            [13.458465376197736, 1.989248269291478],
            [13.45954947169029, 1.9905096084861837],
            [13.46770395017737, 1.9921683932826355],
            [13.46790096862184, 1.998505235503021],
            [13.465655736538896, 2.001310474035345],
            [13.467363832772193, 2.004709554438322],
            [13.471145904006976, 2.002869939097622],
            [13.476591252580283, 2.002449840563141],
            [13.479599778573649, 2.004439190788166],
            [13.481988146314714, 2.0142893995968136],
            [13.479726511237468, 2.0210287563479334],
            [13.486285535040942, 2.0244772660066395],
            [13.49022680710599, 2.032718979054586],
            [13.491744011249509, 2.0388835134957426],
            [13.49054363384484, 2.044694144984706],
            [13.495368010760819, 2.0481086436900067],
            [13.49870603648975, 2.053746212461526],
            [13.505260522408346, 2.0529477956310442],
            [13.51280230328719, 2.0494650734267394],
            [13.51609330616322, 2.0511685494173233],
            [13.517442059688372, 2.057597554090106],
            [13.515579483566274, 2.060980758363717],
            [13.510935258433728, 2.065194116967013],
            [13.506046252126387, 2.065374002036435],
            [13.504224492991584, 2.076829807213599],
            [13.50928464987923, 2.0793340220370053],
            [13.509581610600144, 2.0837145891886473],
            [13.512970528275517, 2.0875412854859334],
            [13.513245581850612, 2.0982007532875615],
            [13.523579017262731, 2.0989321832687997],
            [13.522177433765634, 2.106131958338112],
            [13.515427568278303, 2.1185186192120646],
            [13.51833073835748, 2.121066489135672],
            [13.521571026980446, 2.1307158046727497],
            [13.529048234724547, 2.1305459325972054],
            [13.532006902279356, 2.140214160646446],
            [13.538551360034495, 2.1442841642543775],
            [13.539745661843037, 2.1398883509367894],
            [13.538500031900634, 2.1348404034316553],
            [13.535559807747243, 2.13184071491683],
            [13.53344979922959, 2.118654388196728],
            [13.534660992271604, 2.1161145277634184],
            [13.541044245022167, 2.1149443786307893],
            [13.545940977229206, 2.1152939005491826],
            [13.550066800786661, 2.120228036513194],
            [13.555612073884902, 2.1246198239592817],
            [13.560043264511126, 2.124228684268461],
            [13.565681361581467, 2.121796931860358],
            [13.568923462210833, 2.1144162057085207],
            [13.565723713279121, 2.109486665324623],
            [13.563352115514684, 2.108735621427238],
            [13.560438567670674, 2.104407588831767],
            [13.556321457249672, 2.1080182838246553],
            [13.549571075595388, 2.10681870952157],
            [13.544085031488525, 2.104500803801767],
            [13.538370549165988, 2.098657908309311],
            [13.5378931723521, 2.0958395882392438],
            [13.544781214408326, 2.0905684551276593],
            [13.548416022963524, 2.0835356281787156],
            [13.557721452725229, 2.0782702703851257],
            [13.561204461256112, 2.080081101656978],
            [13.56568523436521, 2.0785553331176683],
            [13.56780274005219, 2.080141680944616],
            [13.569208695762297, 2.085469161385868],
            [13.573739208371947, 2.0872883148692125],
            [13.577283860616882, 2.0763967874353],
            [13.582946084064558, 2.0694601564032684],
            [13.584605974105148, 2.066058331230467],
            [13.59372991001821, 2.065743874000687],
            [13.599542657802964, 2.060478836164155],
            [13.609387905100682, 2.0596166921348114],
            [13.614640192310151, 2.0529097865536037],
            [13.620274743426462, 2.051975591303559],
            [13.626015225721446, 2.0494662404105717],
            [13.631225181838001, 2.0502138059658277],
            [13.635417639938566, 2.047513183158234],
            [13.640669779467329, 2.046727107773143],
            [13.62175931951739, 2.010133914408638],
            [13.617174760010478, 2.005630318383371],
            [13.612849690490423, 2.0031042860411614],
            [13.599357206295533, 1.9654094655834424],
            [13.594575581290545, 1.9655460562933127],
            [13.593357530021827, 1.9581802540207598],
            [13.585830049397652, 1.9548133828416536],
            [13.582700415911585, 1.9428129211836767],
            [13.581340856119576, 1.9419061887682725],
            [13.575755764758048, 1.9449628287985528],
            [13.572245976469816, 1.9429443044017602],
            [13.570249480551448, 1.9392081664478964],
            [13.570239602178352, 1.9351220422184343],
            [13.565028262669102, 1.922878082355821],
            [13.561660350044326, 1.9190841319380838],
            [13.56300198752784, 1.9134124515223705],
            [13.561539271100168, 1.9041146396740267],
            [13.561858296140498, 1.8984639926193745],
            [13.56010501230549, 1.8888853589149883],
            [13.556920528985332, 1.8809129194895198],
            [13.554264718454622, 1.868339664891351],
            [13.5479134581072, 1.8598056019820364],
            [13.54704102427774, 1.8540173217269023],
            [13.540990911178794, 1.840945174821118],
            [13.535770057154359, 1.8393299583540048],
            [13.534967181945493, 1.830728966177455],
            [13.532353493004255, 1.817640760436206],
            [13.523855612931056, 1.813054945734949],
            [13.521135739250274, 1.810262012004502],
            [13.51709697400443, 1.8109346417823924],
            [13.51039985059347, 1.8082405956063325],
            [13.508073006512973, 1.8105175713729318],
            [13.505563096215196, 1.8068640892651104],
            [13.500741377399274, 1.7941076227710244],
            [13.495955969550005, 1.786110869808467],
            [13.492826754971588, 1.7834203021678752],
            [13.489846103792065, 1.7774176206124943],
            [13.487993589535773, 1.7764053087566456],
            [13.485249918599886, 1.7699259883555738],
            [13.48465852336027, 1.764862054058113],
            [13.4858651878409, 1.7616177574358147],
            [13.484564008776962, 1.7553850325304725],
            [13.479893285987892, 1.7517058303701498],
            [13.4764346120642, 1.7438205287473785],
            [13.472274789436185, 1.7387886296636952],
            [13.466945563853411, 1.737497560352561],
            [13.463244418276755, 1.7328325016221322],
            [13.45351141487363, 1.7132435403342003],
            [13.451781872381337, 1.7071456504995917],
            [13.348181193848697, 1.7497491273000654],
            [13.321741464422127, 1.7604999001724493],
            [13.306283346562592, 1.7602688911534674],
            [13.242669412886556, 1.7561121338554506],
            [13.220553439696339, 1.757015476578444],
            [13.21534597883968, 1.7577249628134806]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.94377897451047, "lat": 39.41466744484581 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54057"],
        "coty_name": ["Mineral"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mineral County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01717890"
      },
      "bbox": [
        13.21534597883968, 1.7071456504995917, 13.640669779467329,
        2.1442841642543775
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.06153762222322, 5.371205242284036],
            [-10.052676299557355, 5.426964935869651],
            [-10.014641770429616, 5.421143199838879],
            [-9.884940092843706, 5.400878479283071],
            [-9.872017216116449, 5.486711919793208],
            [-9.7694230793903, 5.471274457232257],
            [-9.66683247972556, 5.4558134011743284],
            [-9.662861830476325, 5.48075490953141],
            [-9.654091748006891, 5.541889166506783],
            [-9.649846520925923, 5.541287043257527],
            [-9.543884540692034, 5.524960671858202],
            [-9.43792658934523, 5.508608842795001],
            [-9.451843279246937, 5.412278335537127],
            [-9.445322902289243, 5.411854308551535],
            [-9.443367943961075, 5.410010920243406],
            [-9.436387406864306, 5.410174159719207],
            [-9.430889219267602, 5.413307555981318],
            [-9.425759786001263, 5.413764085330279],
            [-9.42075949597448, 5.416086622704276],
            [-9.417406891866571, 5.415699848483682],
            [-9.415821308374134, 5.4098731221421685],
            [-9.40919772489397, 5.406354294655776],
            [-9.4092467940541, 5.402877702479771],
            [-9.412076711264131, 5.388602202708456],
            [-9.416640857130469, 5.383847733160643],
            [-9.417672289755064, 5.379918315934054],
            [-9.417001250686905, 5.371538847155837],
            [-9.414619607317746, 5.36533764779901],
            [-9.409189960580207, 5.3579866148349575],
            [-9.405215309278955, 5.3572511810224075],
            [-9.404402646191656, 5.352416204458825],
            [-9.401126812382465, 5.34843415648015],
            [-9.40312124986872, 5.3429878341300725],
            [-9.402116344353873, 5.339339355761267],
            [-9.40392376186337, 5.33535023763047],
            [-9.410141762378663, 5.332768002042466],
            [-9.40962103693022, 5.328965670236014],
            [-9.414153298348573, 5.325763189512067],
            [-9.414590832359728, 5.321969619531531],
            [-9.410839092023114, 5.3143627187049125],
            [-9.415255446163549, 5.308694021731587],
            [-9.422194995588798, 5.3059867830093514],
            [-9.415793605737692, 5.29886832116725],
            [-9.415997556930803, 5.294605824580141],
            [-9.413154598138071, 5.28803465797888],
            [-9.415598943654228, 5.275540324550556],
            [-9.412497889541957, 5.272365286795326],
            [-9.411209107367108, 5.267660604736825],
            [-9.415955660587136, 5.263651442809837],
            [-9.417408435658462, 5.254804845875583],
            [-9.41397243519522, 5.251905009653561],
            [-9.414226686805195, 5.248741495096147],
            [-9.411444238510635, 5.243122208225287],
            [-9.407686129964512, 5.241096693457826],
            [-9.408705424791988, 5.237894663623254],
            [-9.407222211053737, 5.23315055227437],
            [-9.406539259452478, 5.222017806470317],
            [-9.408431094847579, 5.214020164387591],
            [-9.40641180296681, 5.204414941963614],
            [-9.401834131477685, 5.198973128315285],
            [-9.39499510541218, 5.201822755232287],
            [-9.392909690594678, 5.1988088178222736],
            [-9.393127526229854, 5.187239521442812],
            [-9.394547724813735, 5.184873315378461],
            [-9.392401265036533, 5.16893926840187],
            [-9.39052790344003, 5.160396739780491],
            [-9.384423314180964, 5.158861120177574],
            [-9.379489901560824, 5.152110173048924],
            [-9.373649881846726, 5.1505559194667985],
            [-9.371094458118762, 5.147266739748332],
            [-9.363105374536945, 5.1301544560423675],
            [-9.359032331567906, 5.130095137405337],
            [-9.357421695769435, 5.124041265049067],
            [-9.359009634291585, 5.121864819087068],
            [-9.356546467876484, 5.114575906934505],
            [-9.353296661113076, 5.112502205798142],
            [-9.354943364307728, 5.106916341506061],
            [-9.353254454864858, 5.10325803985545],
            [-9.34954682059588, 5.100597999658586],
            [-9.349328901224688, 5.0961161396793635],
            [-9.352156452020806, 5.0906775276931615],
            [-9.350759442805696, 5.088151649208619],
            [-9.354487400283023, 5.084347257058513],
            [-9.361535536169288, 5.0800973589877225],
            [-9.35796611090024, 5.076968914890763],
            [-9.35949154384037, 5.068845484490132],
            [-9.353484228168124, 5.068436445998244],
            [-9.351540647238608, 5.064873053077972],
            [-9.356250989153716, 5.060730112882111],
            [-9.358510806268608, 5.05065304063463],
            [-9.357781799753802, 5.041303778427608],
            [-9.351307000073437, 5.038187275160381],
            [-9.348422360604994, 5.040527531060182],
            [-9.340639657242152, 5.040189127379461],
            [-9.336926332716576, 5.035148033572541],
            [-9.332934399957788, 5.03624208341472],
            [-9.330697799939704, 5.032008039224591],
            [-9.324651003666043, 5.034643131075918],
            [-9.32195626535878, 5.034138723830411],
            [-9.319598187612009, 5.0302601922780825],
            [-9.319481699507024, 5.026711082687224],
            [-9.317169666802661, 5.023532321144858],
            [-9.316663530285643, 5.018047552694649],
            [-9.313238880228424, 5.016142381769897],
            [-9.307434743557494, 5.016191901870549],
            [-9.304530413835474, 5.014817572339054],
            [-9.303319589348078, 5.01121203668592],
            [-9.298857075625591, 5.012071338249588],
            [-9.294743309071663, 5.007548614723607],
            [-9.295162016359583, 5.002461530007854],
            [-9.297876687462079, 5.001151163336117],
            [-9.293285559451549, 4.994210979710636],
            [-9.292987130729356, 4.9893001606800835],
            [-9.285232915883942, 4.988280680757223],
            [-9.283800994256346, 4.985556839672039],
            [-9.277533013378232, 4.984961594026034],
            [-9.275995178679734, 4.977165270261267],
            [-9.27080627989139, 4.973010847081723],
            [-9.264086157577436, 4.97021371644971],
            [-9.26014797220061, 4.964744570132978],
            [-9.25780300122351, 4.953742851373216],
            [-9.251748706725353, 4.953168408131402],
            [-9.248382629272612, 4.951197179106141],
            [-9.241486202230844, 4.953317910524725],
            [-9.236241395276188, 4.956432184389017],
            [-9.231073824020482, 4.946002044850137],
            [-9.228917263499639, 4.9389099346308365],
            [-9.228930315237662, 4.93416772265575],
            [-9.222630587218013, 4.9286443667703885],
            [-9.221709611457221, 4.916208972588806],
            [-9.219872217068325, 4.9053322691790475],
            [-9.215390478340264, 4.902584452452607],
            [-9.216014909970403, 4.884065707715114],
            [-9.2137956919008, 4.8704273382316465],
            [-9.208971125041165, 4.86191843055346],
            [-9.1994877872388, 4.856086683694334],
            [-9.19347957548113, 4.849521077473076],
            [-9.186769023900952, 4.849742055817349],
            [-9.18409935321244, 4.83820316587511],
            [-9.181761652317485, 4.836545725100853],
            [-9.17979393837264, 4.825785263074878],
            [-9.176618024871452, 4.8250764613974955],
            [-9.174616965072012, 4.819933955505909],
            [-9.174913085944981, 4.816442898933574],
            [-9.167319282647647, 4.805497743526105],
            [-9.164399673032152, 4.804185743476847],
            [-9.158835461099143, 4.807720187215869],
            [-9.15755283784155, 4.803445780930398],
            [-9.143768646891402, 4.79580944962742],
            [-9.14195599212872, 4.7887852480464215],
            [-9.14941560907763, 4.786907391843602],
            [-9.153535130972937, 4.788168517460117],
            [-9.154501109257136, 4.785331471570124],
            [-9.159760618977165, 4.78059261806692],
            [-9.163761760954484, 4.77522468117814],
            [-9.164007094138192, 4.766875202016295],
            [-9.156099029217906, 4.759324741270438],
            [-9.151703911748463, 4.756644404279386],
            [-9.149402571359548, 4.758091906914334],
            [-9.147950353018219, 4.763002424323306],
            [-9.144727040467048, 4.766174894825174],
            [-9.139992274369414, 4.763617041276054],
            [-9.134481792343024, 4.762837334402749],
            [-9.133184732995074, 4.759638217652179],
            [-9.12793115115655, 4.7536149634505325],
            [-9.125502206861603, 4.7438812242303525],
            [-9.116983945405224, 4.7396946186967215],
            [-9.112877469033178, 4.739324559353945],
            [-9.112591256993129, 4.734735681352005],
            [-9.110343721898968, 4.733266553124132],
            [-9.104644628001285, 4.733077791543132],
            [-9.099838713144452, 4.730436172018218],
            [-9.099709264659946, 4.727858214169152],
            [-9.094784324594388, 4.724079906269078],
            [-9.098232066546451, 4.722071721276364],
            [-9.101813727553385, 4.722553228628084],
            [-9.105944738910855, 4.717392677547742],
            [-9.099575552234816, 4.71029267528828],
            [-9.097489586557188, 4.7063530899301265],
            [-9.097024960970183, 4.69860714065203],
            [-9.094501272912291, 4.696394730246262],
            [-9.10167439473971, 4.694078528950422],
            [-9.099777394936714, 4.687051907070284],
            [-9.100834733096583, 4.683000109130614],
            [-9.086932107070021, 4.68058138034659],
            [-9.056357318303016, 4.676064855192286],
            [-9.057407652592875, 4.664922297683684],
            [-9.063580850919429, 4.619719227705707],
            [-9.078017373539435, 4.509678649233929],
            [-9.079722634682094, 4.4999092227937805],
            [-9.081036295092877, 4.483468336060218],
            [-9.089785744212689, 4.417337288326922],
            [-9.071112207177105, 4.414932591467479],
            [-9.093661601840282, 4.250277791114216],
            [-9.094564575326551, 4.245943671382147],
            [-9.151210557253103, 4.253507528994997],
            [-9.154148081351195, 4.25407679813385],
            [-9.285158475733716, 4.272392601800824],
            [-9.336103215749347, 4.279818088386324],
            [-9.424221698639418, 4.291774235366102],
            [-9.427117169915013, 4.292430490395481],
            [-9.515033637573314, 4.306239274069529],
            [-9.602952512946532, 4.320033214571416],
            [-9.608503626016557, 4.320745100447991],
            [-9.697671766850736, 4.335853837735253],
            [-9.786842655765554, 4.35094723593085],
            [-9.790859778403767, 4.351875411080503],
            [-9.828307446864462, 4.358119030948287],
            [-9.927145529975208, 4.372863519914223],
            [-9.939690405699793, 4.374648679921769],
            [-9.93851513581563, 4.380461466858366],
            [-10.000508752890385, 4.389042199504615],
            [-10.097277444007636, 4.4040772479814825],
            [-10.096626403801485, 4.40783663242055],
            [-10.181853189253987, 4.4184016084554845],
            [-10.15684105827505, 4.588230067288304],
            [-10.190756512466338, 4.593409716559658],
            [-10.185440780317009, 4.625628722429887],
            [-10.182707752774364, 4.644385892230613],
            [-10.15046526656134, 4.8526604725868525],
            [-10.174559449358688, 4.856474786001259],
            [-10.163886574763302, 4.924839101208836],
            [-10.138096493714661, 4.920841883979009],
            [-10.128507925252935, 4.983983761671507],
            [-10.116396382982167, 5.064239229020035],
            [-10.098930858089943, 5.179394505922848],
            [-10.098254065176857, 5.179390545639232],
            [-10.0850940866901, 5.263123610130739],
            [-10.078214823727413, 5.263458121579412],
            [-10.06153762222322, 5.371205242284036]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.91472231208785,
          "lat": 42.766848004756326
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56035"],
        "coty_name": ["Sublette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sublette County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01605082"
      },
      "bbox": [
        -10.190756512466338, 4.245943671382147, -9.056357318303016,
        5.541889166506783
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.66920940814053,
          "lat": 18.317238894755185
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72053"],
        "coty_name": ["Fajardo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Fajardo Municipio"],
        "coty_fp_code": "053",
        "coty_gnis_code": "01804506"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.79642008377186, "lat": 18.41051398228201 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72065"],
        "coty_name": ["Hatillo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Hatillo Municipio"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01804513"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -67.04047166218407, "lat": 18.01242172686029 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72079"],
        "coty_name": ["Lajas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Lajas Municipio"],
        "coty_fp_code": "079",
        "coty_gnis_code": "01804520"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.9834855146991, "lat": 18.237022939662392 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72083"],
        "coty_name": ["Las Marías"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Las Marías Municipio"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01804522"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -65.72509906707938,
          "lat": 18.342113095291506
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72089"],
        "coty_name": ["Luquillo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Luquillo Municipio"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01804525"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.21492410301045,
          "lat": 18.430747295248395
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72137"],
        "coty_name": ["Toa Baja"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Toa Baja Municipio"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01804549"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.246624171895078, -1.7400161340294198],
            [4.2442083136761015, -1.6579440997959958],
            [4.243245592867397, -1.6134542169473982],
            [4.240841551933781, -1.5358313460606563],
            [4.325702220561358, -1.5336736162959796],
            [4.325636904482725, -1.531039065547599],
            [4.340831717782873, -1.5302461844407473],
            [4.354818212843884, -1.527222617001046],
            [4.360440559471623, -1.5273916495860516],
            [4.359124107468867, -1.5221234052367032],
            [4.383340248200923, -1.5209538308154962],
            [4.397655724198083, -1.5181899395654666],
            [4.411506428476406, -1.5126842904808833],
            [4.4115730342350385, -1.5154654491168662],
            [4.4403247298853845, -1.5142386161973023],
            [4.441952381662519, -1.5583998448577727],
            [4.486089835326762, -1.5572781801511895],
            [4.511426194112355, -1.556312089136421],
            [4.588075182877666, -1.5538064039583228],
            [4.627447451676845, -1.5524306697240515],
            [4.629236793686473, -1.6020016511177357],
            [4.643416006283272, -1.6012450734995922],
            [4.644718848378779, -1.6308067252515603],
            [4.658957372476175, -1.6303161453269635],
            [4.659851148100724, -1.6501646999230015],
            [4.660247462196253, -1.6742810984717584],
            [4.669999200339469, -1.673468148781662],
            [4.674775935353538, -1.6741720900059505],
            [4.676304067080036, -1.7179383852741217],
            [4.690936250945408, -1.7173175394351616],
            [4.693899620206643, -1.789376566757864],
            [4.621566983657289, -1.793162424605691],
            [4.557809165173717, -1.7955204322285754],
            [4.513441470088985, -1.7976813831860206],
            [4.509255724709436, -1.7981085192978417],
            [4.468742390377534, -1.7978489978222192],
            [4.468518343424588, -1.795132375208436],
            [4.449963858044635, -1.7956117340767037],
            [4.4361852785878835, -1.7948241419401216],
            [4.420176113930906, -1.7955438207568422],
            [4.419810009494253, -1.7912854445494817],
            [4.40613356455833, -1.7941866086229064],
            [4.334325473594547, -1.7963723914332899],
            [4.247995672093328, -1.7987328759875068],
            [4.246606298858818, -1.750190410686496],
            [4.246624171895078, -1.7400161340294198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.96232474492807,
          "lat": 36.941234444849336
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29035"],
        "coty_name": ["Carter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carter County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00758472"
      },
      "bbox": [
        4.240841551933781, -1.7987328759875068, 4.693899620206643,
        -1.5126842904808833
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.544725174396295, -0.6630013911058943],
            [1.5443291624115925, -0.6397817111526356],
            [1.6203016985442775, -0.640674725645387],
            [1.63416770402785, -0.6410185138062715],
            [1.6764022924387538, -0.6415088653612154],
            [1.8045585157204218, -0.6436627113288536],
            [1.835612608677107, -0.6442880801578093],
            [1.8380680715786448, -0.6513232358333206],
            [1.836018798977177, -0.6572107399760034],
            [1.840563678122287, -0.6636869812267718],
            [1.8346701656136928, -0.6626570099393931],
            [1.833195176770502, -0.6676521222564251],
            [1.83924008418841, -0.6693368731335854],
            [1.8481042217067376, -0.6680973033006877],
            [1.8465596628868153, -0.6605405172613761],
            [1.8469897477066695, -0.6568755177442598],
            [1.8501809582272828, -0.6544950598404423],
            [1.8562324286555456, -0.6598837545607137],
            [1.8566144542658973, -0.6551399688744088],
            [1.8591883317269573, -0.6521405123831472],
            [1.8584656250655822, -0.6453642914554204],
            [1.8598340236309794, -0.6424854424585414],
            [1.8664546651604084, -0.6399224157899395],
            [1.8708647866800192, -0.6407315947110308],
            [1.8709616273129583, -0.6437363591397743],
            [1.8668443373650008, -0.6480218483292969],
            [1.8691357310464358, -0.6544269110378718],
            [1.875588187687645, -0.6489313801696475],
            [1.8798582494607172, -0.6491528950546287],
            [1.8946869323688977, -0.6427689819989315],
            [1.8982654209490357, -0.6381014874665896],
            [1.9019479689020906, -0.6366888876712031],
            [1.9061728292760958, -0.6398254894406683],
            [1.9176481781925532, -0.6353543594309468],
            [1.9225105049463918, -0.6366909156402583],
            [1.9245801401867637, -0.6415464224193698],
            [1.9288842823608428, -0.644565053382578],
            [1.9338789032987242, -0.6462376088606473],
            [1.9308168558538144, -0.651212748290633],
            [1.937810055371679, -0.6559611849200505],
            [1.9411262503107483, -0.655451786036902],
            [1.9424555189923127, -0.6525579987487168],
            [1.9422151634624119, -0.6454769016211321],
            [1.9461781145840817, -0.6462471133405979],
            [1.9490499612417604, -0.6523120105600825],
            [1.9515626172925837, -0.6534806392257984],
            [1.95714778962263, -0.6604774518033651],
            [1.9607371511213507, -0.6612816975819098],
            [1.9657243653334557, -0.6590295809969234],
            [1.9678576792849984, -0.656281628958186],
            [1.9719535023087131, -0.6567518613265348],
            [1.9728140897543205, -0.6607802788456306],
            [1.9758094033820337, -0.6610222280227741],
            [1.978081656922136, -0.655849233045522],
            [1.977194817856094, -0.6831031489121462],
            [1.9774429263140871, -0.6901718765865916],
            [1.9769825694939307, -0.7206679470676326],
            [1.9751064792545412, -0.7929003557003791],
            [1.9732356529613262, -0.8661734319345712],
            [1.9720185316737766, -0.9347809546804591],
            [1.972090533910063, -0.9396835464433251],
            [1.9757144907284816, -0.9397493611724337],
            [1.9743847535358907, -1.0388664854139333],
            [1.9743219153793532, -1.0567674175439568],
            [1.9034398163776056, -1.0542774865304818],
            [1.8553183204678543, -1.0532850302865244],
            [1.8092000863243731, -1.0526555739094139],
            [1.734910643667396, -1.0520653996997553],
            [1.731707812758727, -1.0517766339850387],
            [1.6972508671786783, -1.0515289320468395],
            [1.5951010582005032, -1.0504485987623455],
            [1.5475546605002561, -1.0502055131931156],
            [1.5471436966995895, -1.030492163396008],
            [1.5462341643391688, -0.9809553260005194],
            [1.545687140939183, -0.9296720771630366],
            [1.5455466016088446, -0.823279079307552],
            [1.5455977382507373, -0.7565976824392857],
            [1.5450731030830736, -0.7127404045115842],
            [1.5452018866953035, -0.7080295647861191],
            [1.544725174396295, -0.6630013911058943]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.34246224130072, "lat": 37.8505526015182 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29217"],
        "coty_name": ["Vernon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vernon County"],
        "coty_fp_code": "217",
        "coty_gnis_code": "00758561"
      },
      "bbox": [
        1.5443291624115925, -1.0567674175439568, 1.978081656922136,
        -0.6353543594309468
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.382812006399165, 8.24087002971923],
            [-11.375144734378354, 8.244003206786164],
            [-11.368012072831895, 8.245018531212342],
            [-11.364225507504132, 8.246641385741714],
            [-11.35919567808252, 8.243055598188155],
            [-11.35406397710094, 8.243960317040075],
            [-11.346913777257667, 8.242074978144673],
            [-11.33876061862724, 8.243758307418952],
            [-11.334433624670838, 8.25027502309355],
            [-11.329318861911778, 8.254647351222724],
            [-11.316143952325369, 8.260312939084706],
            [-11.312115079282888, 8.25783843861659],
            [-11.307209839797462, 8.259303043861566],
            [-11.305524591021525, 8.263652702227475],
            [-11.292354108081328, 8.269760524507957],
            [-11.293637832964755, 8.273559435115258],
            [-11.290285683005091, 8.28211883108199],
            [-11.285873741079191, 8.285725225959387],
            [-11.278517330219376, 8.286428286979685],
            [-11.272963462745507, 8.284485809432445],
            [-11.26345572257217, 8.286231017494451],
            [-11.261447084941075, 8.291823273569547],
            [-11.259060325970827, 8.292271833716626],
            [-11.258450957291561, 8.300807294783391],
            [-11.260135406890287, 8.30398422274695],
            [-11.261176337064686, 8.313864491108383],
            [-11.259401051843, 8.32160291597166],
            [-11.262812064970307, 8.327628584502799],
            [-11.2603011034497, 8.331065668514762],
            [-11.261397599928548, 8.335507005527878],
            [-11.259609592857304, 8.340042590363954],
            [-11.261922052591602, 8.34597348078432],
            [-11.258889099386918, 8.351631104418985],
            [-11.255231820556403, 8.352266380547775],
            [-11.249958044494331, 8.355376562594273],
            [-11.245217842180798, 8.360499285520902],
            [-11.239070199531579, 8.35641773551395],
            [-11.232105193354238, 8.35344322084314],
            [-11.223484425685307, 8.353478751743998],
            [-11.220316567994805, 8.349888526796702],
            [-11.215902591054926, 8.352702114282685],
            [-11.207280998988876, 8.359836827540954],
            [-11.208307426074112, 8.366233791271183],
            [-11.206151140217077, 8.368107329961529],
            [-11.205483333688079, 8.377464052233243],
            [-11.19938320022293, 8.385087666255266],
            [-11.195777916090854, 8.385415605807172],
            [-11.190054214806581, 8.395017723995098],
            [-11.138722028633378, 8.385816823635443],
            [-11.122971936715443, 8.47082218215487],
            [-11.057303566271214, 8.459115528140895],
            [-11.055434314366316, 8.463666784075697],
            [-11.04643634093767, 8.466788704966017],
            [-11.044914011396504, 8.468797886539717],
            [-11.037376028280676, 8.47286029262942],
            [-11.022645379976447, 8.49181156761304],
            [-11.016965543151708, 8.491012596035578],
            [-11.014001182725952, 8.48855363420788],
            [-11.01038046178054, 8.488521235255742],
            [-11.007178894266072, 8.480136918900424],
            [-11.00317864404843, 8.483286545073433],
            [-10.999300009661253, 8.48357763661044],
            [-10.997216101371524, 8.478762185376247],
            [-10.992981453012257, 8.477504989745855],
            [-10.99157165040077, 8.483359594693912],
            [-10.97877469834351, 8.488803151189758],
            [-10.975278247331518, 8.486019901484399],
            [-10.965313477136892, 8.48313101493275],
            [-10.961977048632244, 8.48627983923145],
            [-10.957680153985564, 8.481141325151656],
            [-10.947134935179688, 8.484383342866195],
            [-10.942965569585727, 8.488532643680927],
            [-10.935293960852858, 8.487005893100246],
            [-10.928855777758498, 8.484449373696641],
            [-10.939992936688284, 8.46891262737803],
            [-10.938304612638689, 8.460508841762287],
            [-10.94093480176025, 8.451356899858956],
            [-10.94701943619352, 8.44146310547805],
            [-10.944111570208198, 8.431773501459734],
            [-10.945305795362728, 8.428753795896752],
            [-10.937253139578448, 8.423609758707547],
            [-10.939491091350698, 8.41847913758983],
            [-10.938207792502629, 8.414765586894879],
            [-10.931218844544972, 8.408658957839473],
            [-10.926964079501348, 8.401137999708542],
            [-10.92061569864487, 8.396901102457928],
            [-10.917903440429885, 8.391763319511856],
            [-10.922738197012993, 8.382343410970046],
            [-10.917737511950588, 8.374712455923653],
            [-10.921481138985298, 8.369958872646981],
            [-10.921865057224649, 8.367289852337327],
            [-10.926513647035007, 8.361619907850306],
            [-10.927107055135773, 8.357245140887171],
            [-10.932252302401007, 8.353124248572144],
            [-10.929749178803952, 8.348809523284398],
            [-10.931738130238324, 8.34340048139508],
            [-10.931214681091758, 8.34025593607394],
            [-10.924663285767993, 8.339649984554889],
            [-10.92283685523794, 8.336439437725994],
            [-10.917596702247808, 8.332098711832085],
            [-10.914071987395596, 8.332193102848896],
            [-10.912133658400798, 8.327341793939357],
            [-10.913866731719445, 8.323480261608344],
            [-10.91166767248147, 8.319666930647966],
            [-10.910540015350904, 8.311818251113626],
            [-10.916197058871946, 8.306315688218982],
            [-10.918671395279869, 8.300945859273488],
            [-10.919728748554144, 8.287920689511521],
            [-10.919275639525361, 8.273276080169325],
            [-10.920202602161549, 8.266724659897458],
            [-10.918560442280688, 8.260220499344936],
            [-10.916070487052606, 8.256683989151167],
            [-10.919672574725205, 8.251104007705704],
            [-10.918691219942184, 8.243548723568829],
            [-10.923546246156848, 8.239871635575605],
            [-10.922392110974355, 8.237135509388876],
            [-10.921995621881965, 8.228770584799168],
            [-10.91401701408003, 8.222641832809321],
            [-10.912971624131455, 8.219853305390806],
            [-10.916033931852354, 8.21603804399027],
            [-10.918061110954737, 8.208699187890028],
            [-10.914577127641666, 8.206360392886026],
            [-10.915664247183024, 8.2020903072359],
            [-10.911602430939453, 8.199279583142893],
            [-10.912390221827502, 8.19657041764053],
            [-10.910609215279019, 8.185184178771436],
            [-10.915964574289394, 8.181615118595886],
            [-10.915646469950218, 8.177297570087912],
            [-10.91752690744, 8.173161715126925],
            [-10.922748337151496, 8.170311349902601],
            [-10.922690061887357, 8.167868183900072],
            [-10.929188299362362, 8.163868435946993],
            [-10.929879445627963, 8.15933518596532],
            [-10.934444006963927, 8.154982352341893],
            [-10.933355083874082, 8.151951192429927],
            [-10.933404890810278, 8.144629387453936],
            [-10.931043692583799, 8.142946425995973],
            [-10.926197619266729, 8.136315756091571],
            [-10.92192445402258, 8.134063072979329],
            [-10.918253013109492, 8.130092386020268],
            [-10.847625681802606, 8.08071400475253],
            [-10.843836370189504, 8.075951517699917],
            [-10.837279402612403, 8.075061554835862],
            [-10.83351206858895, 8.069810538376911],
            [-10.832136280355465, 8.058575360327428],
            [-10.826801160435176, 8.052519221301933],
            [-10.821501101915489, 8.05383506656693],
            [-10.814639001824554, 8.050775085803942],
            [-10.811739405781179, 8.046977713948856],
            [-10.807273021792005, 8.04411685082821],
            [-10.801109755347152, 8.043433689254476],
            [-10.797834614322891, 8.03721952676398],
            [-10.79214821638984, 8.031328439665739],
            [-10.787254952251445, 8.02395342127535],
            [-10.796138982091918, 8.025314620272542],
            [-10.919374894540029, 8.042493919606045],
            [-10.975103685468229, 8.050277762468163],
            [-10.988433438457575, 8.06908505209283],
            [-10.997325934271377, 8.071389689162439],
            [-11.008283394718088, 8.063938959780433],
            [-11.01128773923842, 8.060692995495367],
            [-11.021633133267375, 8.043353613915382],
            [-11.023958013365531, 8.03006769937705],
            [-11.023990134275307, 8.02362769945802],
            [-11.031898471337472, 8.015698868349794],
            [-11.036354243474035, 8.014812348501728],
            [-11.040476704997742, 8.011500530876242],
            [-11.045845336441575, 8.003864597958934],
            [-11.06589613513244, 8.00131641627022],
            [-11.074400658651342, 7.997046035008414],
            [-11.076681801331155, 7.994002993710721],
            [-11.084727032510308, 7.987638895759663],
            [-11.090986554744088, 7.9862613446383515],
            [-11.103377705625567, 7.980302818399019],
            [-11.110764099696619, 7.978601291868971],
            [-11.11292334642521, 7.976766837168032],
            [-11.12576717782376, 7.971516936961044],
            [-11.132205975838797, 7.966999981633501],
            [-11.139350794458517, 7.9667848208033485],
            [-11.142071957137084, 7.967902974825061],
            [-11.146413906128677, 7.966666642332494],
            [-11.150568230195054, 7.962572218854304],
            [-11.15071027601111, 7.9661977438730025],
            [-11.155695186282538, 7.972282039194335],
            [-11.155758554323988, 7.9837579281525155],
            [-11.15305916354507, 7.983695595277059],
            [-11.148652294590315, 7.993958789524165],
            [-11.150591233016058, 7.997028979580133],
            [-11.151472856218744, 8.002510009747777],
            [-11.150382033708588, 8.00645595733962],
            [-11.151275050609904, 8.014658919301782],
            [-11.156611597719001, 8.014542907471618],
            [-11.162381922934133, 8.01771944852701],
            [-11.167077321044438, 8.016469110644733],
            [-11.166997109752256, 8.022400045219342],
            [-11.173757917077083, 8.028324484182185],
            [-11.176078058523295, 8.036159855858333],
            [-11.175243119586343, 8.03977010246128],
            [-11.171881593130944, 8.041815312199734],
            [-11.17055279877672, 8.046042034763406],
            [-11.177378009573712, 8.048298270312362],
            [-11.181258445838942, 8.0550394378571],
            [-11.178641534932469, 8.060643759321318],
            [-11.175189921281637, 8.064373084683078],
            [-11.174056861804164, 8.071821685966684],
            [-11.175861352884242, 8.075792057555606],
            [-11.1804717149435, 8.077639329937737],
            [-11.178045553317835, 8.083387061324391],
            [-11.178729944665927, 8.091527345906568],
            [-11.18403309817805, 8.094708141898103],
            [-11.187204127175754, 8.098816337554132],
            [-11.19204235612175, 8.10125853429159],
            [-11.192848742040873, 8.108553979623458],
            [-11.199043573618166, 8.109513011578262],
            [-11.204283089556434, 8.106643710939986],
            [-11.210357934725216, 8.111506888020529],
            [-11.218299001535469, 8.12469223272823],
            [-11.228311096335414, 8.130749963633008],
            [-11.231880863590904, 8.130239215318266],
            [-11.23973958409976, 8.134024815969648],
            [-11.247179313840991, 8.132835939151418],
            [-11.250242396581598, 8.1355967713738],
            [-11.251888838182257, 8.1399320834202],
            [-11.257676460552224, 8.146757861779793],
            [-11.262882194792253, 8.14700799101463],
            [-11.266652140017047, 8.14448873128279],
            [-11.27031172675323, 8.139962086771988],
            [-11.27752648851081, 8.144663070753671],
            [-11.280737555177039, 8.15038638399894],
            [-11.27936227631142, 8.156712880247632],
            [-11.284599992211238, 8.163737782735456],
            [-11.288923439981508, 8.165755401542327],
            [-11.295692792263024, 8.163744554942758],
            [-11.30800940722079, 8.169828640470925],
            [-11.312403352688904, 8.170343996319195],
            [-11.315700600525835, 8.173646474027596],
            [-11.320981681403042, 8.175263630938817],
            [-11.326117121312548, 8.178388800098835],
            [-11.330321034764426, 8.176918733635333],
            [-11.334033281848303, 8.179465360510692],
            [-11.333509579201966, 8.187043679203558],
            [-11.338401532274792, 8.187925442078438],
            [-11.342685660139534, 8.19141817496755],
            [-11.345188640137257, 8.195632191919037],
            [-11.344353003902036, 8.199864041735081],
            [-11.346595140014008, 8.203307742027016],
            [-11.355418028609584, 8.207436046969452],
            [-11.356236542099694, 8.212592404386236],
            [-11.360310343229196, 8.215907937749598],
            [-11.362868996538351, 8.220250093197828],
            [-11.365366172262094, 8.221391764478417],
            [-11.370452240512249, 8.22864198095902],
            [-11.37633540999632, 8.2300236495729],
            [-11.383165606727703, 8.235594742067494],
            [-11.382812006399165, 8.24087002971923]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -112.65671006491796,
          "lat": 45.90246832909212
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30093"],
        "coty_name": ["Silver Bow"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Silver Bow County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01719575"
      },
      "bbox": [
        -11.383165606727703, 7.962572218854304, -10.787254952251445,
        8.49181156761304
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.22822308809385158, 1.6668570997828425],
            [-0.22623811167133795, 1.6725643503392396],
            [-0.22557580815926476, 1.7543076016176686],
            [-0.2239567646272803, 1.842175249181625],
            [-0.1378746080594289, 1.8408472351014782],
            [-0.059520480001545556, 1.8402271672276183],
            [-0.05238070348133837, 1.840402243871854],
            [0.032572009051904056, 1.8403770906211805],
            [0.11437373252231754, 1.839109833813542],
            [0.11392360487082258, 1.7513637482023479],
            [0.11337453020035936, 1.6563538199482362],
            [0.113063584724984, 1.576078079351663],
            [0.11313983036446872, 1.5596142253234881],
            [0.11264977715613926, 1.4883376825948684],
            [0.11203372611988324, 1.385869760485844],
            [0.11174288187901157, 1.3125940130214555],
            [0.030415437104055816, 1.3131603524105184],
            [0.00043455707620530077, 1.3131347371868856],
            [-0.008711950295315407, 1.313473506465764],
            [-0.06348798057212397, 1.3139374733150617],
            [-0.14789735439524943, 1.3147338524526675],
            [-0.23187676614854122, 1.3156306081789535],
            [-0.2313591654317932, 1.3450649172903832],
            [-0.23150481142646556, 1.3966489245134617],
            [-0.2308960758446078, 1.4132222336025113],
            [-0.2301643326426086, 1.4912897203522313],
            [-0.2294423480353855, 1.5646519392938747],
            [-0.22822308809385158, 1.6668570997828425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.68947408301676, "lat": 40.26189228261118 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31067"],
        "coty_name": ["Gage"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gage County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00835855"
      },
      "bbox": [
        -0.23187676614854122, 1.3125940130214555, 0.11437373252231754,
        1.842175249181625
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.4564573118517257, 2.8253330963164154],
            [-3.328661872671979, 2.8184997071461533],
            [-3.2722905757644107, 2.8152948238430953],
            [-3.1868529373398617, 2.8103395429965037],
            [-3.116137723685043, 2.8061265046513117],
            [-3.0429356852952805, 2.8021876374787658],
            [-2.9067609707278637, 2.7955353293992933],
            [-2.7680882873515085, 2.788992253594875],
            [-2.7542873637157728, 2.7885294771560902],
            [-2.7399642445896695, 2.7874421142741537],
            [-2.7290172765830865, 2.787268751110192],
            [-2.699348954474753, 2.7857769801654997],
            [-2.688200179811078, 2.7853056562421705],
            [-2.689175298247301, 2.7706605766344823],
            [-2.69055984413126, 2.727916959593715],
            [-2.6914572430677564, 2.713580210973754],
            [-2.691154381110201, 2.697842069805365],
            [-2.6920905409136235, 2.6686424452903887],
            [-2.698208437788106, 2.5669568675546763],
            [-2.6996935758345906, 2.5525955848057276],
            [-2.7010024327495303, 2.523421783460207],
            [-2.705307508433412, 2.4364919190019307],
            [-2.6949030694174554, 2.436090351776356],
            [-2.6982140566547956, 2.3622981306505664],
            [-2.70157061643, 2.2904291273667132],
            [-2.705288127007081, 2.1938634720337014],
            [-2.7054380078080946, 2.192774614438986],
            [-2.70957666113675, 2.092910448420415],
            [-2.709727337774703, 2.0874104245115954],
            [-2.830197431008406, 2.0928229757725085],
            [-2.9554771134198172, 2.0987913991899547],
            [-3.0006137151787953, 2.1007853591517933],
            [-3.126079933094492, 2.1070073105513116],
            [-3.2115507657163067, 2.111459876333462],
            [-3.264763996112214, 2.1141312844320637],
            [-3.291770502309514, 2.1149997911076905],
            [-3.2931865459678966, 2.115410396944917],
            [-3.338914020165443, 2.116758538740265],
            [-3.3391706019094993, 2.117056842346774],
            [-3.4113288994216635, 2.1199753221666895],
            [-3.4790985428327046, 2.1232764746887383],
            [-3.467938628685627, 2.3276366328103717],
            [-3.468192333850229, 2.327650645145712],
            [-3.465126919009905, 2.386637180149341],
            [-3.463563328780151, 2.4313839840670908],
            [-3.461285080158551, 2.475079982155024],
            [-3.4763849620975305, 2.475922834438157],
            [-3.4724577875336697, 2.545781483873563],
            [-3.4721470376721246, 2.55397342560944],
            [-3.4689341733855907, 2.6092498752199718],
            [-3.4671527878473944, 2.636560091007437],
            [-3.4614310101280736, 2.738243329963446],
            [-3.4610902622952975, 2.741393798137775],
            [-3.4564573118517257, 2.8253330963164154]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.74529452079251,
          "lat": 41.04773257715328
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31111"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00835877"
      },
      "bbox": [
        -3.4790985428327046, 2.0874104245115954, -2.688200179811078,
        2.8253330963164154
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.646228885703398, 7.0345917815912316],
            [17.649091272164124, 7.043459895548103],
            [17.65952257419551, 7.069725298993297],
            [17.664879166418217, 7.086488380311719],
            [17.68559671941338, 7.129493998049911],
            [17.724358417426846, 7.070493669527277],
            [17.72323542631503, 7.074258300423666],
            [17.724600059955844, 7.077471064141882],
            [17.727609041903012, 7.077839887790019],
            [17.731724120029583, 7.0811892204126545],
            [17.73477816785187, 7.088846682862809],
            [17.737910414213918, 7.088571143802524],
            [17.742552879907784, 7.09307120520254],
            [17.746624577644987, 7.091514299622167],
            [17.750482885233655, 7.0857848346014665],
            [17.75812895087979, 7.103449481637225],
            [17.76257334770523, 7.102248595062913],
            [17.766167058209973, 7.10541102945429],
            [17.770054681631517, 7.1039500866130165],
            [17.771457601383755, 7.107763418630637],
            [17.775192441269777, 7.109500113033171],
            [17.779396958748823, 7.108955222605819],
            [17.782568250733807, 7.105328238595253],
            [17.78217709089546, 7.102584315377879],
            [17.788971436112085, 7.096217932871771],
            [17.794008775021922, 7.0957544633556315],
            [17.799306715584606, 7.09054095529689],
            [17.799954166099972, 7.087996895316404],
            [17.80393277279072, 7.084295985509095],
            [17.80716615318324, 7.083774419869811],
            [17.81840354789775, 7.0794417776161636],
            [17.820347413384408, 7.075371926781736],
            [17.819790454103334, 7.0662711777891705],
            [17.83017456147061, 7.058407402956042],
            [17.83365829492088, 7.053744584511464],
            [17.839501761469325, 7.051755932503163],
            [17.843893393236005, 7.051945490879329],
            [17.851487540035706, 7.049625079388642],
            [17.853571802433702, 7.045653283729313],
            [17.86329519014133, 7.052443726079869],
            [17.872570331774515, 7.0400162934958805],
            [17.87407379869915, 7.041139415638773],
            [17.878608988883478, 7.033849109951774],
            [17.875914120018788, 7.03189834647826],
            [17.88060627496089, 7.023701157235045],
            [17.87866897377473, 7.022219659551743],
            [17.888122065374464, 7.009536370914398],
            [17.89189510842103, 7.0093227504105045],
            [17.895316147277665, 7.005179088569751],
            [17.89750924873167, 7.008653694019322],
            [17.90092493128609, 7.00884337982146],
            [17.903593186294636, 7.004432692808308],
            [17.907028973531627, 7.0084820686321585],
            [17.907087004013203, 7.013698973259758],
            [17.91065391531151, 7.013122303625711],
            [17.912619946782545, 7.016649741842576],
            [17.915956474340565, 7.017268149547653],
            [17.918664820120195, 7.020256301965974],
            [17.920729801577412, 7.026183446329342],
            [17.92699908009331, 7.026536556390308],
            [17.92644110976143, 7.0307968593840435],
            [17.930394428137973, 7.032000903222381],
            [17.935254111567605, 7.030611400202549],
            [17.985581730957605, 7.011345264162874],
            [18.00026521542512, 7.005237227046522],
            [18.10249016935388, 6.965313741715952],
            [18.197485083753342, 6.926820100222151],
            [18.19208586996049, 6.915311219244919],
            [18.191678901273328, 6.9035793849925895],
            [18.187770554285574, 6.888181689166367],
            [18.18461293925491, 6.862612995547676],
            [18.17357702844257, 6.79353859591359],
            [18.171947589381684, 6.793463992163246],
            [18.169375279119947, 6.77063493691267],
            [18.16057052412437, 6.728120315918095],
            [18.156166537563596, 6.694878117047827],
            [18.151372207716324, 6.660864243032022],
            [18.143379560879698, 6.660589756187365],
            [18.15121222295182, 6.646357569680717],
            [18.154273624543226, 6.638490954333743],
            [18.158981868382504, 6.631894284108177],
            [18.11574281412831, 6.6316499108476705],
            [18.106208270514788, 6.653869756878493],
            [18.10493864823908, 6.6518735440054515],
            [18.09495614995778, 6.641904869975765],
            [18.093086398601606, 6.643820497252254],
            [18.086561342693077, 6.646352602526768],
            [18.080090554588452, 6.655057417472676],
            [18.064019699005875, 6.648614063368834],
            [18.05577446246376, 6.666382840674226],
            [18.037277659466067, 6.657979738079765],
            [17.999511694178604, 6.641217761406023],
            [17.972519171799586, 6.62943289169353],
            [17.953600220761224, 6.6690595471828304],
            [17.92886032370303, 6.71961614481312],
            [17.886609494286514, 6.695491928625925],
            [17.8450200340421, 6.67213141529614],
            [17.83595156049162, 6.666371121908289],
            [17.806062994845913, 6.649229343088137],
            [17.78509990031162, 6.675411436627044],
            [17.742741165081352, 6.7277798470650785],
            [17.686419780452937, 6.6957818042885915],
            [17.680269622944838, 6.691928367152603],
            [17.648728016179973, 6.719775506592353],
            [17.638071043752337, 6.750079645036394],
            [17.62384731533745, 6.74676640105554],
            [17.589630342117196, 6.80756085711579],
            [17.603242428839344, 6.866224855225822],
            [17.60281592432332, 6.876042967895603],
            [17.597881768147317, 6.9006466281037],
            [17.596920029774047, 6.902247742158818],
            [17.58691807700633, 6.910599917261416],
            [17.585447940554157, 6.9286116844916315],
            [17.616170962946807, 6.932117016341284],
            [17.620204360523864, 6.950486791867815],
            [17.623861712990067, 6.9629816777987905],
            [17.646228885703398, 7.0345917815912316]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.68023706287278, "lat": 43.29745302954869 },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33013"],
        "coty_name": ["Merrimack"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Merrimack County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00873180"
      },
      "bbox": [
        17.585447940554157, 6.62943289169353, 18.197485083753342,
        7.129493998049911
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.436805633426262, -1.3064177198718745],
            [-7.4288075441795245, -1.307188716191141],
            [-7.210287255460195, -1.3294935541745416],
            [-7.1679886440838185, -1.3337920949300923],
            [-7.138695027911062, -1.336972436981272],
            [-7.045307364546682, -1.3461840481557277],
            [-6.996825933589092, -1.3509097536230035],
            [-6.974846053798887, -1.3532612065712877],
            [-6.842610356350481, -1.3665424176336427],
            [-6.818412965649006, -1.369342474181656],
            [-6.817765543550356, -1.37162779205572],
            [-6.821573798574469, -1.3776150868145505],
            [-6.826947178105909, -1.3778941575152368],
            [-6.832037487343966, -1.3814235123897194],
            [-6.8338859849901095, -1.39009105086621],
            [-6.832426917000356, -1.394328482613555],
            [-6.833948151285926, -1.401123241372755],
            [-6.82863168849675, -1.4095333409609574],
            [-6.828566790154891, -1.4179601462465228],
            [-6.827002778683421, -1.4190819256719605],
            [-6.824263793136055, -1.426180723691743],
            [-6.824770236817098, -1.4304841048471433],
            [-6.818710637305021, -1.4330164770671006],
            [-6.819376364468816, -1.438764688897188],
            [-6.8189239535949095, -1.4458009744377405],
            [-6.816898548827738, -1.448117288598299],
            [-6.810122091389709, -1.4508137469370916],
            [-6.812993476927991, -1.4578648394322071],
            [-6.814942163130022, -1.459257581975325],
            [-6.8175098186460055, -1.466640219143583],
            [-6.823143232910315, -1.4756566372112132],
            [-6.825359322290983, -1.4824252021760222],
            [-6.831539490843221, -1.492091686837674],
            [-6.831773074477563, -1.4961749806630402],
            [-6.834681716193515, -1.5045663655651151],
            [-6.839827800863889, -1.516800132421771],
            [-6.840327566250163, -1.52228829037988],
            [-6.836433424982598, -1.53189127039033],
            [-6.837848760354473, -1.5341071478114692],
            [-6.838424682777646, -1.542727310430254],
            [-6.841621832072246, -1.5455271821212992],
            [-6.846532809218685, -1.5523632195175565],
            [-6.846976684943043, -1.5571204713207532],
            [-6.841944851868132, -1.5602257014899132],
            [-6.842777763850885, -1.563916820937402],
            [-6.850091037824304, -1.573656161004151],
            [-6.850046582678542, -1.5783412557769592],
            [-6.845136402025158, -1.5936322222889034],
            [-6.8457639198511675, -1.5979049935107406],
            [-6.8445723328711265, -1.6098249145974473],
            [-6.848381226580772, -1.6268734328645889],
            [-6.846964974383172, -1.6313287882730203],
            [-6.851117489534071, -1.6355158320002694],
            [-6.852954231247432, -1.6411855637808643],
            [-6.8628751831406465, -1.6418918069828994],
            [-6.867312739843701, -1.6458454383232146],
            [-6.873114277860723, -1.6434083313825925],
            [-6.878809073782263, -1.642916901945682],
            [-6.883515399870405, -1.6453345618963793],
            [-6.885551761437462, -1.6419656095465707],
            [-6.889768941854757, -1.6400714885073227],
            [-6.893107378274341, -1.6427897597927945],
            [-6.896488400960879, -1.6395199702059606],
            [-6.896171856131082, -1.636421689059483],
            [-6.898538426447493, -1.6325808519312257],
            [-6.905478411987556, -1.6322421088567083],
            [-6.918265685218443, -1.6353521410822227],
            [-6.9178800982542645, -1.6412391035087865],
            [-6.922087524040339, -1.6439701934542976],
            [-6.92711941270479, -1.6542466886965426],
            [-6.927659199070365, -1.659576171687361],
            [-6.931357421560867, -1.659797445750474],
            [-6.93777037326347, -1.6545683437540275],
            [-6.944825120109672, -1.6586585436483288],
            [-6.951740872229853, -1.6584317505293713],
            [-6.958664384022226, -1.662674661347861],
            [-6.963121362503683, -1.6671972811336897],
            [-6.963246239410846, -1.6712443149204521],
            [-6.967877628632175, -1.673609741970947],
            [-6.968525430782095, -1.6828022170453343],
            [-6.965689439624296, -1.6852283253692506],
            [-6.961476664632116, -1.6921994285213124],
            [-6.961395860756034, -1.6968102026930763],
            [-6.965334505562336, -1.7008454654731384],
            [-6.959173523007275, -1.7127705927485966],
            [-6.959893377558899, -1.716492016843064],
            [-6.956978608774894, -1.719083532129744],
            [-6.95704767248156, -1.722637961986767],
            [-6.959803835083448, -1.7253522804460066],
            [-6.963345245794711, -1.725017891266519],
            [-6.969301930681847, -1.7274999707460157],
            [-6.972860768745198, -1.7319902179096867],
            [-6.971973006765878, -1.7357264446465208],
            [-6.97664129211796, -1.737981465212418],
            [-6.976649165854243, -1.743291140302515],
            [-6.9783055124289755, -1.7456562964578397],
            [-6.976509437623186, -1.751243710760002],
            [-6.973351591093989, -1.756809465010092],
            [-6.970519187761824, -1.7579938282322225],
            [-6.966829009524763, -1.7659277341373552],
            [-6.966386887327075, -1.7732943609593965],
            [-6.964655266320156, -1.7766319192992712],
            [-6.9650933132957356, -1.7810501569754702],
            [-6.962421077524158, -1.7838994317719017],
            [-6.964224040308211, -1.7915036899705812],
            [-6.962809045220302, -1.7947023755005427],
            [-6.968150467115541, -1.7975669927364024],
            [-6.973243413931812, -1.79761469437176],
            [-6.979694688760917, -1.8002300064060148],
            [-6.983916048475042, -1.7982388960047406],
            [-6.986207320595587, -1.8019900413332377],
            [-6.9852628386561495, -1.8047664448375231],
            [-6.97982486328448, -1.809117686592264],
            [-6.979210262086748, -1.8124352527410212],
            [-6.975839492845992, -1.8145538773357832],
            [-6.971556413498351, -1.8149200776716041],
            [-6.970812884307292, -1.8188312282221106],
            [-6.964553103152326, -1.8246543601982952],
            [-6.963271777756053, -1.8391366611671232],
            [-6.963498549130193, -1.845950005570401],
            [-6.9590191653904725, -1.8475797169438624],
            [-6.95876777926395, -1.8524052214726507],
            [-6.95097043619685, -1.8584581940865132],
            [-6.950314558288111, -1.8623683017203538],
            [-6.945489673708933, -1.8674507692618216],
            [-6.948727933844279, -1.872203617119177],
            [-6.952850232085948, -1.8715466546409159],
            [-6.960293038167711, -1.8743005611849466],
            [-6.960089310519222, -1.8773074477760427],
            [-6.96285042724691, -1.8804146369742976],
            [-6.964124459518848, -1.8871397050515146],
            [-6.967533251369508, -1.8889612345495705],
            [-6.973370005632945, -1.9011824913082467],
            [-6.979168896354071, -1.904074625035124],
            [-6.979877376198981, -1.9068363656230973],
            [-6.975759424076847, -1.9116194811769047],
            [-6.969373773836876, -1.9109474064860072],
            [-6.966605447050695, -1.9119268569417744],
            [-6.964396255996685, -1.9190648016831795],
            [-6.967864138451736, -1.9227551076327674],
            [-6.96581769824321, -1.9315882459260998],
            [-6.970004693308129, -1.9423113029711885],
            [-6.9635278581225935, -1.9460777319077576],
            [-6.960979393586476, -1.9504657724360999],
            [-6.963388707508753, -1.9548514487552375],
            [-6.961151178292619, -1.9596264871336937],
            [-6.961996263058345, -1.9659766371207335],
            [-6.9607514822258025, -1.970438966895296],
            [-6.963338824028561, -1.9786045678562132],
            [-6.966941569822711, -1.9828290628992162],
            [-6.971047233388905, -1.9848669096431764],
            [-6.972444738179063, -1.9892525732388484],
            [-6.968608098627211, -1.9910526552850276],
            [-6.967804555213101, -1.9962865631149536],
            [-6.9677681360273676, -2.009169417959552],
            [-6.970746521740727, -2.01273139103603],
            [-6.968591450012279, -2.0185097565262753],
            [-6.968879020395964, -2.021713121832375],
            [-6.972355595445636, -2.0271520219142753],
            [-6.972108049493629, -2.035811991457608],
            [-6.975431327318842, -2.0436996694745053],
            [-6.977740271928462, -2.0571102083426],
            [-6.9760077906213525, -2.065635343259637],
            [-6.973697986063529, -2.0822825846571447],
            [-6.986123766759178, -2.096438828942454],
            [-6.98902293464372, -2.0965757837686487],
            [-7.011087887748372, -2.1004844940661704],
            [-7.023658569543083, -2.1018752135380456],
            [-7.029675112209245, -2.1107204743517096],
            [-7.043006085881704, -2.1162041044309796],
            [-7.035478029656093, -2.1240333757988337],
            [-7.034781487644756, -2.1321933449797306],
            [-7.032604683569851, -2.1330000497277175],
            [-7.031645407466905, -2.138307197076549],
            [-7.035449615814804, -2.1429375079029467],
            [-7.0380077634127405, -2.1506692239824137],
            [-7.03598971303304, -2.156342790713355],
            [-7.037445221581243, -2.1626126232586613],
            [-7.0426074180898395, -2.1686050601045683],
            [-7.04556014522022, -2.1696044868239475],
            [-7.059357725670986, -2.182628537146961],
            [-7.059733521879431, -2.190385769389001],
            [-7.057346766157464, -2.1913932550180477],
            [-7.05498870106927, -2.195793314427228],
            [-7.056976627579028, -2.200399228193708],
            [-7.060857423728787, -2.203924044576502],
            [-7.061706206128442, -2.2208878998650086],
            [-7.066923450614851, -2.227009140139368],
            [-7.071080602039712, -2.2340260791455506],
            [-7.074830947652531, -2.2364138622683254],
            [-7.101236729701207, -2.271008609066339],
            [-7.126415034925734, -2.3100171302482178],
            [-7.13152841658586, -2.311938603175593],
            [-7.137832253110093, -2.3185759453148287],
            [-7.142063133962706, -2.325300105830869],
            [-7.14691687882421, -2.328349387487085],
            [-7.161591117083688, -2.331202337432949],
            [-7.223920927903275, -2.2888815714138873],
            [-7.233335884183353, -2.283131476228892],
            [-7.316454891498118, -2.2271518910563453],
            [-7.326600793467234, -2.2102992773668246],
            [-7.333728766629554, -2.195275284877369],
            [-7.352753952829338, -2.16328109495676],
            [-7.399239784740941, -2.0864663858411343],
            [-7.4308010623239005, -2.069058861163654],
            [-7.448536010277112, -2.0595170875622455],
            [-7.502346826200764, -2.0300146420952063],
            [-7.552222514525473, -2.0028924603395035],
            [-7.550006641857523, -2.000567114086082],
            [-7.549455711014223, -1.995148374257857],
            [-7.5443152967900975, -1.9931311933350844],
            [-7.542728232384438, -1.9879379583770276],
            [-7.531286720023735, -1.9749254809908958],
            [-7.5239687640060176, -1.973236101445523],
            [-7.517241272362747, -1.9751641216003828],
            [-7.511711413261603, -1.9718845384301087],
            [-7.506025887911973, -1.973078568592862],
            [-7.50053311733977, -1.9709781826079509],
            [-7.498219068076655, -1.9667719296585997],
            [-7.490656579691225, -1.9651022468295425],
            [-7.488398094763305, -1.9628457382340896],
            [-7.482605921665828, -1.9635846924979636],
            [-7.478273067190263, -1.962182359855521],
            [-7.4766779647814205, -1.9597370335269861],
            [-7.471556483167673, -1.9572720336486729],
            [-7.465092521962656, -1.947975621015338],
            [-7.464853026132675, -1.9456077378525696],
            [-7.4594887852813665, -1.9340244108733182],
            [-7.458604285637313, -1.9287549536821118],
            [-7.458706201009886, -1.9209694852120356],
            [-7.4573648326373405, -1.9151981070602717],
            [-7.4589307777321086, -1.9122022403425207],
            [-7.457133005231871, -1.9011152312314175],
            [-7.458075218021913, -1.894662533412183],
            [-7.457632688266587, -1.8889923761163854],
            [-7.4535449995468515, -1.8738553338696564],
            [-7.446534615913534, -1.8622316990525905],
            [-7.439819363219131, -1.8469313666652354],
            [-7.439172380092947, -1.8405641220928215],
            [-7.439874298607269, -1.83189538030975],
            [-7.438232445442028, -1.821874549987527],
            [-7.439099291867532, -1.8088429658067162],
            [-7.442835897042117, -1.7924285553144388],
            [-7.44421510948632, -1.7907151477698486],
            [-7.444227988398779, -1.7795410768980726],
            [-7.4428641072575985, -1.7741436051730572],
            [-7.444441927388529, -1.7685699721916077],
            [-7.44023960649843, -1.765530284240817],
            [-7.441098359145445, -1.7519172368025913],
            [-7.441277259184591, -1.7319394883212365],
            [-7.4429078713306005, -1.725314909472196],
            [-7.445553083185995, -1.7084205438822369],
            [-7.445373560713227, -1.6996593557574797],
            [-7.444121824632333, -1.6935029697833623],
            [-7.448052912021412, -1.6735379519332112],
            [-7.4481124129361795, -1.6637253741597606],
            [-7.446978960312565, -1.6582768522008502],
            [-7.4542404101899535, -1.6579880130160838],
            [-7.4566204737976625, -1.659604335666375],
            [-7.4550527837845815, -1.6452119042792583],
            [-7.442396695647082, -1.646574138579174],
            [-7.442018940427672, -1.6402788388357052],
            [-7.443130618543588, -1.634442707965755],
            [-7.441918582394909, -1.6227696318409992],
            [-7.444038568216189, -1.6131374905296345],
            [-7.443822173693556, -1.6102427853762802],
            [-7.446253536881147, -1.6040197834422474],
            [-7.444907563476998, -1.5953419892372],
            [-7.446679638953307, -1.5912635466960376],
            [-7.4429286765615075, -1.5834458653464503],
            [-7.443755320055566, -1.5779366645794297],
            [-7.442937623397622, -1.562791374512563],
            [-7.444118802628771, -1.5583183740450954],
            [-7.441460901198633, -1.5459241276734523],
            [-7.442352091376812, -1.540551002876363],
            [-7.440190030353497, -1.53747243573478],
            [-7.439657876172477, -1.5314109819882014],
            [-7.440355171693111, -1.5224087909726267],
            [-7.439145920631741, -1.4928998277112107],
            [-7.428516240402559, -1.4675106618014206],
            [-7.426233542015664, -1.457872976996534],
            [-7.425066217262495, -1.4391388205193194],
            [-7.42125919561916, -1.418791501755354],
            [-7.42240422947481, -1.4023009536267914],
            [-7.4285742180333605, -1.3833084448563384],
            [-7.427679018128551, -1.3810186394072204],
            [-7.42820187358259, -1.3630338306579726],
            [-7.433438959656125, -1.3422776716041853],
            [-7.434677914458947, -1.3310222361523065],
            [-7.437533320032445, -1.3255085037461025],
            [-7.438163458802935, -1.3147829834784195],
            [-7.436805633426262, -1.3064177198718745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.63100149349219,
          "lat": 36.57827993970374
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35055"],
        "coty_name": ["Taos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taos County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00933056"
      },
      "bbox": [
        -7.552222514525473, -2.331202337432949, -6.810122091389709,
        -1.3064177198718745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.863036259101317, -1.4550594123417042],
            [-5.6472966178118105, -1.4711360546518002],
            [-5.440215575690302, -1.4867408028458098],
            [-5.3899755438579655, -1.4904327974154257],
            [-5.190993485281601, -1.5047230305346424],
            [-5.1359276654412875, -1.5089139165892804],
            [-5.069750699194865, -1.5138966209814764],
            [-5.076367158846497, -1.6029924642311797],
            [-5.076293330059413, -1.6050361162961084],
            [-5.087289822950848, -1.7520298129289635],
            [-5.090609088714052, -1.7963958083015077],
            [-5.0941503071790395, -1.8408990602975206],
            [-5.09927421921763, -1.9138445552714696],
            [-5.1052305197532055, -1.990424123892198],
            [-5.107072791315379, -2.0167843711479536],
            [-5.138428724799877, -2.0144223977961406],
            [-5.151899095787713, -2.1977029584218473],
            [-5.158282364858883, -2.2874956802067987],
            [-5.170816225323626, -2.4623102406595185],
            [-5.187450655632798, -2.6810050171704565],
            [-5.189088527470658, -2.6934957080063073],
            [-5.189544471597679, -2.70472741516658],
            [-5.191022598835575, -2.722439096512465],
            [-5.190767463168358, -2.7273683582088215],
            [-5.194763548030378, -2.7797820051532574],
            [-5.4625150745328055, -2.759376129583604],
            [-5.460894799834797, -2.738633991160603],
            [-5.442039833436955, -2.49893117098954],
            [-5.434205588312036, -2.4995322239413325],
            [-5.427309989879654, -2.4116849960780313],
            [-5.7415451540732265, -2.387150785278818],
            [-5.770170532505747, -2.3846232877078135],
            [-5.762449439166779, -2.295973568053951],
            [-5.933651480904607, -2.281157530457152],
            [-5.929915831063925, -2.23735387329372],
            [-5.924589528507146, -2.173942912571486],
            [-5.923637245894323, -2.1642030847057883],
            [-5.918668162745938, -2.105431739894683],
            [-5.91812061247873, -2.1054334108547956],
            [-5.909608740883094, -2.0032377297484922],
            [-5.89992583790296, -1.8860485103897608],
            [-5.89093218281084, -1.7742045780437268],
            [-5.889582574073942, -1.7552350569958637],
            [-5.888087862913362, -1.755363266877929],
            [-5.885551412182745, -1.7220043601455601],
            [-5.881101497846693, -1.6672924447580952],
            [-5.875070382359318, -1.5959762154781465],
            [-5.8711868428048675, -1.5524943879440167],
            [-5.863036259101317, -1.4550594123417042]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.47100580189614,
          "lat": 36.481600259937046
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35059"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00929115"
      },
      "bbox": [
        -5.933651480904607, -2.7797820051532574, -5.069750699194865,
        -1.4550594123417042
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.8506698694551, 3.905659030488094],
            [16.852075078913945, 3.9054889146214684],
            [16.85504623408854, 3.9194918601961612],
            [16.854192299309982, 3.919970666160149],
            [16.85447281942334, 3.921110844740856],
            [16.857178358119413, 3.9260835881216383],
            [16.865802331901378, 3.92793696807103],
            [16.870871765802995, 3.9332698679536757],
            [16.873153268820925, 3.931691774557471],
            [16.873034085212492, 3.94113804743448],
            [16.875737470746486, 3.949404648931707],
            [16.872057889312874, 3.9619013359750754],
            [16.875471093668722, 3.9651504259626713],
            [16.878761671364707, 3.9659888620639108],
            [16.887172002597538, 3.9643011110599233],
            [16.891923393084664, 3.959359803220872],
            [16.89860808555873, 3.9587374172527845],
            [16.905851730179783, 3.94885609271139],
            [16.90545327007223, 3.946208167033828],
            [16.908095035266623, 3.9420629176372834],
            [16.916855625457032, 3.937967287295381],
            [16.91766723185748, 3.9345429492657473],
            [16.924173042706123, 3.9316971150507416],
            [16.927371919005136, 3.928045591609292],
            [16.92825708246151, 3.9245734042913623],
            [16.932928547918703, 3.9200092810637677],
            [16.940709804753283, 3.926288909384336],
            [16.94335599016216, 3.931609505224163],
            [16.94664286090904, 3.935447883602945],
            [16.95015296264249, 3.937269986704445],
            [16.955346818565108, 3.9248149818874194],
            [16.9592110295837, 3.9215596378908684],
            [16.961950765201866, 3.915364796453448],
            [16.964446882903353, 3.9149659159759573],
            [16.967116278468268, 3.9089322785100156],
            [16.966576808135873, 3.904928246412412],
            [16.962939882728037, 3.9021623349431684],
            [16.970193599608574, 3.8944894176166405],
            [16.97260416830094, 3.8882877118538817],
            [16.977232073217266, 3.890284460930275],
            [16.991985592352442, 3.8779960263494733],
            [16.995855799530855, 3.857120876987459],
            [16.990167557631235, 3.8413080337752104],
            [16.988901867700484, 3.8363120541002176],
            [16.9706478898535, 3.8174969718423384],
            [16.96653270755781, 3.8209497855286023],
            [16.957915780929483, 3.817921864649161],
            [16.953412660998865, 3.826683628096134],
            [16.94786972840871, 3.8253058300864793],
            [16.944430942031946, 3.8229308645618074],
            [16.942110810949316, 3.8183535142548464],
            [16.93670287295227, 3.8186365240828617],
            [16.931246821091232, 3.8174358290234873],
            [16.9293857636764, 3.81562226118679],
            [16.931740080967938, 3.809458305595288],
            [16.921280801892344, 3.806815649795063],
            [16.889743910914834, 3.7942460269174174],
            [16.881612720677584, 3.7923065184322216],
            [16.880581735193037, 3.793825117535722],
            [16.873775520820182, 3.794473025856633],
            [16.871960022065156, 3.7975920521120785],
            [16.87601796567905, 3.802808312119842],
            [16.88009125066108, 3.802933692246518],
            [16.88196633611688, 3.810657611412664],
            [16.880399947477848, 3.8135423170744986],
            [16.868088866143463, 3.8203416065645412],
            [16.860736487643184, 3.821326968131119],
            [16.852080111582005, 3.8211424062275205],
            [16.843401737984724, 3.829067812841438],
            [16.839621632703437, 3.8401137031689414],
            [16.83969394005763, 3.8495957431848478],
            [16.841640534026013, 3.8587268209393195],
            [16.845720101522563, 3.8605160309843973],
            [16.8467725228594, 3.8666314486022255],
            [16.856269898647987, 3.8813647433023584],
            [16.858927265080137, 3.8809845317520884],
            [16.861512469529192, 3.8839682817533965],
            [16.858953280735545, 3.8872105010020275],
            [16.853183307410852, 3.886975800611614],
            [16.85266358618593, 3.883260974964194],
            [16.848025566060016, 3.8827603705586378],
            [16.844079122434845, 3.8961775734395663],
            [16.8506698694551, 3.905659030488094]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.93836839656217, "lat": 40.64131126634357 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36047"],
        "coty_name": ["Kings"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kings County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00974122"
      },
      "bbox": [
        16.839621632703437, 3.7923065184322216, 16.995855799530855,
        3.9659888620639108
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.535094091006362, 5.4322063338490345],
            [13.526506996913811, 5.474513389345895],
            [13.54113930550658, 5.47670235214393],
            [13.534190379957403, 5.516474707799458],
            [13.550599671988431, 5.5190932736398635],
            [13.543606111477347, 5.5612764965023125],
            [13.583250343934269, 5.5690465777635625],
            [13.671233384010169, 5.586495747874347],
            [13.671057652859105, 5.579874991204111],
            [13.680287055489927, 5.578890719079047],
            [13.683492633751584, 5.573569406508258],
            [13.679729276880147, 5.571660249566443],
            [13.678935817476237, 5.565143668436163],
            [13.681065572153626, 5.558678419086817],
            [13.678944997300652, 5.547248359665502],
            [13.673655277906247, 5.545533544019624],
            [13.668730897551354, 5.540839877462833],
            [13.663560550154392, 5.541446464214224],
            [13.659328305447607, 5.5394479930104685],
            [13.660595124380436, 5.535583559928257],
            [13.74728814869025, 5.551900957307156],
            [13.748205071346021, 5.556669252318639],
            [13.78733466540236, 5.563790257462832],
            [13.789922032880806, 5.559607561951376],
            [13.794341965518237, 5.556391933665009],
            [13.798412489875284, 5.557923025965785],
            [13.799792726853601, 5.5506542759801665],
            [13.803863660517685, 5.548185803655506],
            [13.80585318562789, 5.544425929024186],
            [13.804809326131585, 5.540210539957122],
            [13.810215589703775, 5.530835400952943],
            [13.810054491535226, 5.523439966496853],
            [13.815013123051223, 5.521788906929884],
            [13.81701284681488, 5.518169523604323],
            [13.817115697857359, 5.510765104284101],
            [13.822073831982292, 5.504381937625697],
            [13.819668139096704, 5.4991248713913095],
            [13.821774184314442, 5.495845368557991],
            [13.825820541106395, 5.494936315091385],
            [13.82634517357231, 5.490355521210657],
            [13.821144456739612, 5.488022574637397],
            [13.825095420375721, 5.479456069094702],
            [13.799308556292035, 5.474361107968517],
            [13.816782267763077, 5.384861603251525],
            [13.799946356956253, 5.38178468278423],
            [13.804066625416748, 5.369536801804636],
            [13.808873989635599, 5.352247587947125],
            [13.809716328438476, 5.347639102417233],
            [13.81292860561321, 5.340218456460825],
            [13.826806803323205, 5.293929362370992],
            [13.886312641214495, 5.304157061145211],
            [13.907399191111356, 5.307990663611836],
            [13.910155620513269, 5.288761386978026],
            [13.909888679719682, 5.284019606395323],
            [13.922628207163765, 5.216012314561807],
            [13.828877503200623, 5.20058512634511],
            [13.800653824760115, 5.19535247591945],
            [13.808399330057336, 5.1505578566965875],
            [13.782675196826515, 5.145557132286024],
            [13.777815884785825, 5.144123454205794],
            [13.765781018628322, 5.142277341395823],
            [13.776375234161714, 5.07912671476975],
            [13.757029360962063, 5.075900425852187],
            [13.691363417372399, 5.066124567170398],
            [13.682774840078597, 5.1085731536664705],
            [13.613784447701844, 5.095868935980284],
            [13.537225455572877, 5.0815706787332715],
            [13.539972981565159, 5.085043539024626],
            [13.531748372161585, 5.088993242564025],
            [13.533963739503273, 5.0957690060726595],
            [13.532939664325157, 5.098400844133115],
            [13.528349721704156, 5.100553706621047],
            [13.52416040632825, 5.093446483768373],
            [13.521776118042034, 5.093078508105095],
            [13.521599656714791, 5.099109752788187],
            [13.527570693441428, 5.10403837759446],
            [13.525275518601218, 5.109900891015778],
            [13.525269880090889, 5.115192975126447],
            [13.526837526518623, 5.120801888240998],
            [13.532108967720879, 5.129061264273078],
            [13.538482692752169, 5.1314136360095155],
            [13.534518342797368, 5.136433801639677],
            [13.525880323948714, 5.131708668398156],
            [13.521476996896922, 5.134728446588863],
            [13.521498240223814, 5.139633422502095],
            [13.528513869465257, 5.15023252747035],
            [13.536007599544881, 5.150373859541693],
            [13.539005226886264, 5.149401455144813],
            [13.546121218472532, 5.152721878400293],
            [13.550417911991165, 5.161106120100486],
            [13.548383698492843, 5.16550768124562],
            [13.543149182375629, 5.165332391690956],
            [13.538221950692105, 5.160641755799268],
            [13.534372724618226, 5.161726199277605],
            [13.531164890884202, 5.166443047724811],
            [13.532979662092131, 5.16930817532035],
            [13.536539606984816, 5.169703220510329],
            [13.539731600196271, 5.172639361813373],
            [13.539974609372692, 5.176886478020128],
            [13.542623048000813, 5.178154923538031],
            [13.546566862533048, 5.176510640737397],
            [13.550173510854574, 5.179823414253147],
            [13.551720411923109, 5.183548178246088],
            [13.556743752716432, 5.183650370728801],
            [13.557647857050185, 5.18958508918523],
            [13.554967249752645, 5.194348253484101],
            [13.555712346840348, 5.197619952700418],
            [13.559071393670518, 5.200242180493435],
            [13.558229369605778, 5.203468788225359],
            [13.561815059457418, 5.208914881048824],
            [13.56057755936607, 5.213153447053861],
            [13.563572027408151, 5.2168776027800705],
            [13.560677875554427, 5.22424177524226],
            [13.564251833204017, 5.23392288856037],
            [13.567861230276028, 5.233707249245396],
            [13.571430223346495, 5.240404592437289],
            [13.55606904382593, 5.323287757322124],
            [13.552219492806659, 5.341877422092305],
            [13.544844159791447, 5.38080806982559],
            [13.53755071721366, 5.420726091549495],
            [13.535094091006362, 5.4322063338490345]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.77547926733054,
          "lat": 42.728041319337365
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36051"],
        "coty_name": ["Livingston"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Livingston County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00974124"
      },
      "bbox": [
        13.521476996896922, 5.066124567170398, 13.922628207163765,
        5.586495747874347
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.378271815230754, 6.165864297516723],
            [14.384146761565667, 6.172509739695872],
            [14.389739066842996, 6.174671425478582],
            [14.391330009575867, 6.181024955615796],
            [14.396630899697907, 6.185297220895452],
            [14.403210472307196, 6.194771999829177],
            [14.408125938220415, 6.199235244708696],
            [14.410691941767178, 6.203398044886949],
            [14.418995679696922, 6.208875177202861],
            [14.420373548693476, 6.212068971899223],
            [14.429882564093525, 6.21960617269407],
            [14.433637056916066, 6.221020302327048],
            [14.445724723528201, 6.231886105629881],
            [14.451459637930196, 6.2344097589167555],
            [14.455262086702394, 6.23973738532099],
            [14.458520044061498, 6.240882023366602],
            [14.463392856535792, 6.252411032691532],
            [14.466573629073554, 6.263127619038791],
            [14.486558413935787, 6.281239474313682],
            [14.488495401776543, 6.284881489598193],
            [14.492254615010458, 6.286490260167329],
            [14.495947666806488, 6.2900901334800965],
            [14.498134003448317, 6.295958208001787],
            [14.502655406912787, 6.298809415628844],
            [14.519322772682957, 6.304447289196429],
            [14.522002372681934, 6.303264450386016],
            [14.531627196750632, 6.307553534337368],
            [14.535624422137534, 6.306939461273133],
            [14.545149424183897, 6.300511258632555],
            [14.550680645659758, 6.298888209550509],
            [14.558380652828047, 6.301457523746545],
            [14.56128287609908, 6.299611241136479],
            [14.569419809837628, 6.303788291228921],
            [14.575654289791224, 6.305734322374831],
            [14.57985164874242, 6.304202198440851],
            [14.588922142052107, 6.307226912340241],
            [14.593672926721412, 6.310967548347228],
            [14.596788177097121, 6.315922463237735],
            [14.602363689417759, 6.317047575918155],
            [14.608834769529397, 6.3225629285815055],
            [14.62486169219219, 6.330542510617349],
            [14.62912449949473, 6.3352440065553],
            [14.633031185096769, 6.3427783876940484],
            [14.636794800430856, 6.36455767141577],
            [14.638214646964462, 6.380000298659082],
            [14.635980594355056, 6.405524384154106],
            [14.627528988590454, 6.454050205414384],
            [14.62475650066037, 6.467135323916683],
            [14.619041643086398, 6.483306482689805],
            [14.662188452852078, 6.48901800977284],
            [14.689107881234687, 6.492030876817289],
            [14.714779570642204, 6.494443713944086],
            [14.746712889916102, 6.497955556628438],
            [14.73639554364163, 6.535431460442667],
            [14.786864287360952, 6.540470827312387],
            [14.916318558549047, 6.555351628243937],
            [14.91710143864383, 6.555362487145312],
            [14.926275991406909, 6.524348312049696],
            [14.934140238652764, 6.498718493114353],
            [14.970207139692485, 6.36635972609322],
            [14.975715764499784, 6.34495996291049],
            [14.931828942992727, 6.348986520021565],
            [14.923346353889814, 6.265595874943434],
            [14.914370868365946, 6.183250359860843],
            [14.932454968166814, 6.1811887770076135],
            [14.942680408597484, 6.0923685968516725],
            [14.951908608582118, 6.018036738422652],
            [14.93701504952664, 6.017230307906822],
            [14.923136618965978, 6.0176230832658755],
            [14.919762035140181, 6.018512898691464],
            [14.917869435502016, 6.024858653542163],
            [14.913067339418511, 6.031241465184317],
            [14.909718330209513, 6.028211977037958],
            [14.904235932585115, 6.026426452163591],
            [14.90232756320321, 6.023553980669989],
            [14.897805806173487, 6.023490857664561],
            [14.893227335656462, 6.030148168177255],
            [14.883528286528184, 6.02834105493898],
            [14.879760860043271, 6.024987117253203],
            [14.87569808385394, 6.026432724584497],
            [14.873134326395638, 6.030261093691541],
            [14.868641726418806, 6.028731819250432],
            [14.86519388144015, 6.0251144872124165],
            [14.861101233490976, 6.023016498593203],
            [14.855252943893717, 6.028035999606962],
            [14.844221228841755, 6.030811099999839],
            [14.839245140502339, 6.0304794085635],
            [14.836462095905356, 6.034415358757264],
            [14.827295560075903, 6.039160075632323],
            [14.822548275173267, 6.038865654376604],
            [14.82039086081726, 6.0347731687223565],
            [14.813648629748535, 6.034636453940498],
            [14.804613248851144, 6.031617538297138],
            [14.801992146157788, 6.033816433412412],
            [14.800550436354873, 6.038290409971298],
            [14.801547961263665, 6.041650172350305],
            [14.794380368039475, 6.049603874654357],
            [14.78485801135792, 6.053456864243759],
            [14.781930585857495, 6.051559933123676],
            [14.779207888729454, 6.054234358176668],
            [14.77131173350128, 6.059171080060792],
            [14.763684669799458, 6.058047598416406],
            [14.757468383132453, 6.059425512657053],
            [14.752864347099292, 6.062458860139327],
            [14.746854694265004, 6.060456237940274],
            [14.73963114845327, 6.062644990237152],
            [14.7308407432554, 6.064267405788366],
            [14.726154900174938, 6.068087881104035],
            [14.721899451121912, 6.069460324002285],
            [14.703620343363955, 6.082973630414133],
            [14.700260065860283, 6.082810841782683],
            [14.696686252748975, 6.079360060353192],
            [14.699085779374613, 6.07339894007257],
            [14.69761890226443, 6.06825374721311],
            [14.701926883680436, 6.0554645169573655],
            [14.700780531345046, 6.051153592389667],
            [14.70726835201008, 6.0498523703343015],
            [14.709225102847245, 6.04164899397795],
            [14.712160697949333, 6.035408428707682],
            [14.719128958598498, 6.031560484098314],
            [14.716872640740137, 6.026488228680114],
            [14.710762953231212, 6.02933587166289],
            [14.708980772426251, 6.02533222358626],
            [14.708325613541609, 6.019276710458012],
            [14.705075968562255, 6.016093886480324],
            [14.700218849804656, 6.015224093712642],
            [14.69564370259761, 6.01722659521168],
            [14.692013759665505, 6.021062349583412],
            [14.683894836832545, 6.021606677988622],
            [14.677895743192177, 6.031201317473246],
            [14.671824750996667, 6.036953992072376],
            [14.66900251303238, 6.041878834935655],
            [14.665826277614286, 6.040089576462574],
            [14.661941843983744, 6.0425558939531046],
            [14.656960301679673, 6.040684159727648],
            [14.66318539332216, 6.036471728537151],
            [14.665471762082843, 6.030923580012165],
            [14.66961381735736, 6.027807303948778],
            [14.670741745145355, 6.0228335550551115],
            [14.670075324566385, 6.01758589182453],
            [14.667148056515138, 6.00726725272904],
            [14.660877923120818, 6.003015062220844],
            [14.65836526643209, 6.008276504483538],
            [14.654598035102184, 6.011508988665096],
            [14.651135802972705, 6.019300188166132],
            [14.644227390993349, 6.022709216392607],
            [14.641445766525756, 6.025494327929959],
            [14.635921802441322, 6.028131065508341],
            [14.630119479037793, 6.025529187516534],
            [14.6237813003107, 6.027146810178134],
            [14.609493669816377, 6.023364420502318],
            [14.609221878073205, 6.02447719740792],
            [14.559702092277552, 6.011183939333001],
            [14.514785980325133, 5.999582122094558],
            [14.507451251958022, 6.0277984991578695],
            [14.457171399500162, 6.016040391867807],
            [14.420201819629122, 6.006647988524633],
            [14.409493166151375, 6.048513498554533],
            [14.391572090963164, 6.117052980326541],
            [14.388222641681809, 6.128650888375466],
            [14.382440140776335, 6.151026645634176],
            [14.378271815230754, 6.165864297516723]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.14132960523814, "lat": 43.42692049163033 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36075"],
        "coty_name": ["Oswego"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oswego County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00974136"
      },
      "bbox": [
        14.378271815230754, 5.999582122094558, 14.975715764499784,
        6.555362487145312
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.894857742651194, 4.028577323097729],
            [16.912236518142816, 4.026491628492754],
            [16.91461088970863, 4.023845676478401],
            [16.92229957648079, 4.023958445449755],
            [16.92599624611247, 4.02534757912017],
            [16.92692471520393, 4.030792670198778],
            [16.93064072111472, 4.038662228181319],
            [16.937297172242552, 4.042763619141417],
            [16.949710334896935, 4.047860358812904],
            [16.96201063886168, 4.054489025238304],
            [16.966570358723036, 4.055164059010245],
            [16.980254076371022, 4.053388035606668],
            [16.981526000055005, 4.0445182328126],
            [16.9831155013715, 4.042147941353789],
            [16.989984238887097, 4.044890599359971],
            [16.992003117118955, 4.0472046784555085],
            [16.991187531819143, 4.050905483476403],
            [16.994953171737535, 4.051784565899983],
            [17.00023375939999, 4.045558296739768],
            [16.99804300577083, 4.0428008034268075],
            [17.004509582531227, 4.036701202890318],
            [17.00720021833988, 4.032879216948905],
            [17.014573374114896, 4.026801062544057],
            [17.016659125364054, 4.027609430168611],
            [17.014336451763295, 4.036716834918499],
            [17.01647308475832, 4.04331664962361],
            [17.059039421494752, 4.022439840687959],
            [17.063012102219254, 4.009492650327157],
            [17.060227289726523, 3.997149859270565],
            [17.05428381298969, 3.9943710813627105],
            [17.04518101552552, 3.987757964860134],
            [17.050312896664565, 3.977144175352464],
            [17.058583720042343, 3.9469139117370196],
            [17.05935416332622, 3.935184914595418],
            [17.06148021799305, 3.9284712216134623],
            [17.065193569269308, 3.9220175639728607],
            [17.06316435892031, 3.918401588994821],
            [17.058622456873334, 3.9160361847139806],
            [17.054676978212544, 3.912155749743029],
            [17.056178547702032, 3.9059054830459177],
            [17.05405478206453, 3.899927243130216],
            [17.040403200791665, 3.88777696000992],
            [17.039982382538792, 3.8853802772677053],
            [17.043632626523824, 3.87654203319025],
            [17.04939083653929, 3.874129912238467],
            [17.053483708167445, 3.87412675371447],
            [17.059920563466598, 3.877106704116317],
            [17.06236032683696, 3.8731836751696154],
            [17.06728397150223, 3.8693977066336],
            [17.07041257060709, 3.8601115592756767],
            [17.065093126416112, 3.858782222729214],
            [17.06119938528984, 3.853825500901956],
            [17.059579059716338, 3.856337203184236],
            [17.055448533037904, 3.8556350211949812],
            [17.043289752249006, 3.851377512518349],
            [17.021355965746665, 3.839816435615945],
            [17.002775634838997, 3.8279636900999128],
            [16.9738473638405, 3.8052639714544894],
            [16.962202818815967, 3.797628647358271],
            [16.955898888949594, 3.795128586966013],
            [16.934762101499775, 3.7770406242385945],
            [16.932819399421714, 3.7768958098869216],
            [16.93096512866035, 3.786766057183604],
            [16.93350687910675, 3.7908624420804777],
            [16.936232554972335, 3.791650278137806],
            [16.939874172540335, 3.7963840144401964],
            [16.949457982860373, 3.802371104682796],
            [16.953966084038097, 3.800981446288923],
            [16.958212916463317, 3.802957060137374],
            [16.962704301700054, 3.8090102593891406],
            [16.969786420832563, 3.8106494896182017],
            [16.9706478898535, 3.8174969718423384],
            [16.988901867700484, 3.8363120541002176],
            [16.990167557631235, 3.8413080337752104],
            [16.995855799530855, 3.857120876987459],
            [16.991985592352442, 3.8779960263494733],
            [16.977232073217266, 3.890284460930275],
            [16.97260416830094, 3.8882877118538817],
            [16.970193599608574, 3.8944894176166405],
            [16.962939882728037, 3.9021623349431684],
            [16.966576808135873, 3.904928246412412],
            [16.967116278468268, 3.9089322785100156],
            [16.964446882903353, 3.9149659159759573],
            [16.961950765201866, 3.915364796453448],
            [16.9592110295837, 3.9215596378908684],
            [16.955346818565108, 3.9248149818874194],
            [16.95015296264249, 3.937269986704445],
            [16.94664286090904, 3.935447883602945],
            [16.94335599016216, 3.931609505224163],
            [16.940709804753283, 3.926288909384336],
            [16.932928547918703, 3.9200092810637677],
            [16.92825708246151, 3.9245734042913623],
            [16.927371919005136, 3.928045591609292],
            [16.924173042706123, 3.9316971150507416],
            [16.91766723185748, 3.9345429492657473],
            [16.916855625457032, 3.937967287295381],
            [16.908095035266623, 3.9420629176372834],
            [16.90545327007223, 3.946208167033828],
            [16.905851730179783, 3.94885609271139],
            [16.89860808555873, 3.9587374172527845],
            [16.891923393084664, 3.959359803220872],
            [16.887172002597538, 3.9643011110599233],
            [16.878761671364707, 3.9659888620639108],
            [16.875471093668722, 3.9651504259626713],
            [16.872057889312874, 3.9619013359750754],
            [16.871469329054328, 3.967965626284576],
            [16.88054713520128, 3.9950364225514554],
            [16.884096313504738, 3.999560960876048],
            [16.881324647706553, 4.00366388638265],
            [16.882996635189826, 4.007166835717352],
            [16.886741637465832, 4.006115922579654],
            [16.894177697900634, 4.016111201148451],
            [16.897698985160275, 4.023625167918746],
            [16.894857742651194, 4.028577323097729]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -73.81957946072446, "lat": 40.70345400311084 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36081"],
        "coty_name": ["Queens"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Queens County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00974139"
      },
      "bbox": [
        16.871469329054328, 3.7768958098869216, 17.07041257060709,
        4.055164059010245
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.498549418817456, 5.300446572119991],
            [14.52301881634588, 5.306321039977049],
            [14.57725511507004, 5.319825447081343],
            [14.560981633782035, 5.3261944268243955],
            [14.550724407273623, 5.331488465764695],
            [14.543146609472409, 5.337311417867993],
            [14.526217619520615, 5.352080438565697],
            [14.51573893917099, 5.363317478112222],
            [14.511636006164675, 5.368641786407671],
            [14.504555089077007, 5.380106556334542],
            [14.54147903036355, 5.389517456506038],
            [14.542251797146958, 5.386473668366703],
            [14.583732186415851, 5.397026861425543],
            [14.617173538151851, 5.405806367106289],
            [14.652452114972704, 5.414696048866705],
            [14.654587952643892, 5.406133586622838],
            [14.695925494125754, 5.416245000263941],
            [14.79156884556502, 5.4398077640593],
            [14.811938469595868, 5.35986219744531],
            [14.82126994963191, 5.322343525620975],
            [14.825273198796745, 5.3071441338650605],
            [14.845159903126575, 5.229841595040268],
            [14.81681271746373, 5.222703489652304],
            [14.815266278829842, 5.2114049741806285],
            [14.818058810949408, 5.205776203772194],
            [14.816716244203448, 5.20077167540832],
            [14.820612894470209, 5.196566358709004],
            [14.828046361189381, 5.1973853309478315],
            [14.831234937715635, 5.198929578064474],
            [14.835384357771433, 5.196553163917306],
            [14.843485450172357, 5.196285444921242],
            [14.852166099528333, 5.1927891571319],
            [14.855901823303665, 5.190056328742157],
            [14.860956304076335, 5.188430472495795],
            [14.864851872547582, 5.18494260862557],
            [14.86806969972167, 5.176697667180593],
            [14.866952037151016, 5.175474104412649],
            [14.86438658792551, 5.164656370033274],
            [14.865849632027755, 5.153482674710504],
            [14.863760415095154, 5.149045768319203],
            [14.867097976461356, 5.140367859014601],
            [14.866839918417341, 5.134341784490862],
            [14.869676406479014, 5.1284151681422285],
            [14.87049333745152, 5.121544788721556],
            [14.843136567225763, 5.115895719355533],
            [14.840727279308608, 5.127136262418761],
            [14.79582385834837, 5.117955775742482],
            [14.793607051982884, 5.127584876224839],
            [14.776819836070452, 5.123961405633899],
            [14.762088650552796, 5.1212347392433415],
            [14.747267754269087, 5.118003021028495],
            [14.758034148486216, 5.063499775481071],
            [14.715924379747568, 5.05555001638706],
            [14.712739606562875, 5.072683122260829],
            [14.666285723252136, 5.063695240220306],
            [14.636511831964386, 5.0583978860226395],
            [14.607806870497736, 5.052748225774248],
            [14.555617944222163, 5.043507450669997],
            [14.549967643264202, 5.072051853757217],
            [14.550907961919133, 5.072371760014203],
            [14.538173716192118, 5.130950107362412],
            [14.541258624559958, 5.13351881794203],
            [14.526480838733047, 5.1924781616652504],
            [14.512059723603336, 5.247284858172496],
            [14.498549418817456, 5.300446572119991]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.47365128018298, "lat": 42.4520187369981 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36109"],
        "coty_name": ["Tompkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tompkins County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00974152"
      },
      "bbox": [
        14.498549418817456, 5.043507450669997, 14.87049333745152,
        5.4398077640593
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.68800483329862, -2.2449160215100266],
            [12.72540911501479, -2.2390919134475635],
            [12.771903186824133, -2.2315579408969906],
            [12.776150112356678, -2.2302242349524435],
            [12.789006597095048, -2.2289372143362916],
            [12.827553643357748, -2.223563921158818],
            [12.857364436136042, -2.2201146479167173],
            [12.889588960338711, -2.215359431070814],
            [12.897538843092553, -2.2146553575241157],
            [12.910410842806304, -2.212158699125484],
            [12.976776527480839, -2.2018983335410307],
            [13.026497292641894, -2.1929890538515013],
            [13.077649342859592, -2.1841816312946705],
            [13.03479571545068, -2.3120703221317185],
            [13.017503946629107, -2.3638452439420616],
            [13.001376988332199, -2.412811630884202],
            [12.974238889263425, -2.494090488013738],
            [12.975646441771204, -2.497882992623541],
            [12.970780931919826, -2.5020549702102692],
            [12.966995555716746, -2.507668736059752],
            [12.965301861984187, -2.513888148284394],
            [12.96071115218896, -2.520586563877891],
            [12.963035914161319, -2.5249718540938852],
            [12.962889187995412, -2.5279954392911197],
            [12.922797079398594, -2.510662612366333],
            [12.920874121579498, -2.50967866229523],
            [12.85423877157692, -2.480757197967496],
            [12.82065567639112, -2.4667437642812806],
            [12.8153110366755, -2.456276389570349],
            [12.799383668949027, -2.4212890592852947],
            [12.78639319305525, -2.3920161879497757],
            [12.772320249407025, -2.385138439352361],
            [12.750589107578383, -2.3717277230115417],
            [12.739883076869631, -2.364539677433748],
            [12.728907147019186, -2.351859514388593],
            [12.718977725247985, -2.34666845388248],
            [12.719552384142247, -2.3357302321041007],
            [12.72831469634324, -2.3323217618198404],
            [12.704936536651038, -2.2919129711185833],
            [12.703659114336881, -2.286653825322523],
            [12.697327687908825, -2.2781379657419802],
            [12.693127463529578, -2.2662295100485306],
            [12.688013939563426, -2.2582251777182036],
            [12.687278603498324, -2.248165310237775],
            [12.68800483329862, -2.2449160215100266]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.55184842185072, "lat": 35.38676333398828 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37025"],
        "coty_name": ["Cabarrus"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cabarrus County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01008540"
      },
      "bbox": [
        12.687278603498324, -2.5279954392911197, 13.077649342859592,
        -2.1841816312946705
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.275267522243103, -1.268752294509719],
            [15.313298262241982, -1.1997442557931024],
            [15.318802843922935, -1.1951811058832786],
            [15.32118556635302, -1.191329228946036],
            [15.3273882665023, -1.2032264265309542],
            [15.331330465805186, -1.2057032537464158],
            [15.35368718294869, -1.211891282387046],
            [15.370329752416767, -1.2202893447334373],
            [15.37870066453926, -1.221905925135066],
            [15.38676167171122, -1.2250962061510848],
            [15.398151758664909, -1.227087264720157],
            [15.408453096505749, -1.2313176732751363],
            [15.418975105100728, -1.2296102813160894],
            [15.42924298048606, -1.2362066584985272],
            [15.428879562978453, -1.243261785190117],
            [15.42653610776425, -1.2487683937380771],
            [15.427577678426845, -1.2528901243545876],
            [15.43409678215662, -1.2489016204839338],
            [15.439548958800756, -1.2484101206754317],
            [15.444459633639182, -1.25589943941839],
            [15.441632076403831, -1.2584811496850168],
            [15.444665250179758, -1.2642196049208405],
            [15.448394082143965, -1.2664359010965316],
            [15.444744510013603, -1.2734407433921389],
            [15.447048422341464, -1.2805169386022726],
            [15.445214432517947, -1.2863220425123063],
            [15.445625156867804, -1.290455768910202],
            [15.444155977026153, -1.2943085774801282],
            [15.450169089083207, -1.3030648086901222],
            [15.460390039657206, -1.3080792602867934],
            [15.467040100323745, -1.3086317302511707],
            [15.472775003715613, -1.3067647434706977],
            [15.474233579932486, -1.3003200202025538],
            [15.477121154638533, -1.2977325189079003],
            [15.491446538062377, -1.2966877678836828],
            [15.495192178735453, -1.2978522277229452],
            [15.50163928758946, -1.2896253775851232],
            [15.504999979353247, -1.2938534960855557],
            [15.509128262388925, -1.3026006521132447],
            [15.513200613198205, -1.3023307961293598],
            [15.51536796567913, -1.2989211906367264],
            [15.520424307141317, -1.2990549358795844],
            [15.523159823976513, -1.2933125922905904],
            [15.52662991521706, -1.293011924555027],
            [15.533819870128237, -1.2995790359623638],
            [15.537083815732792, -1.29462601258672],
            [15.53783377648843, -1.291178037205274],
            [15.541606637326142, -1.2909535525240112],
            [15.541915529181418, -1.2847329651864465],
            [15.546428719450642, -1.2866367359018596],
            [15.549554161096559, -1.2862017189425414],
            [15.554286453558875, -1.2801627752516427],
            [15.558340182347314, -1.2802481431539268],
            [15.559916829969387, -1.2741252088396455],
            [15.568537187624415, -1.272891272586313],
            [15.57053222376556, -1.2741691047687498],
            [15.575522658240391, -1.2843170112543094],
            [15.581284898956095, -1.2853384942146717],
            [15.585112835557815, -1.2841865587853512],
            [15.585446794257544, -1.288126514296942],
            [15.583904546797699, -1.2949648228662816],
            [15.587721606783289, -1.2959047512258668],
            [15.589816439062547, -1.3036668247513268],
            [15.587566587078157, -1.3087304335816856],
            [15.592299054883398, -1.310431144391312],
            [15.593515806216768, -1.3174586775209123],
            [15.592007652986231, -1.3206171705798306],
            [15.585100194939884, -1.3243937585857115],
            [15.586632157311183, -1.3280522159308097],
            [15.591964269950827, -1.3332181829491392],
            [15.58657680954684, -1.3405884265476005],
            [15.58740054322665, -1.348801676539409],
            [15.586492981055775, -1.3545680970762681],
            [15.593206150557423, -1.3568508508729848],
            [15.598520298016835, -1.3554767671585206],
            [15.608428134254433, -1.3484674957463911],
            [15.613490754140457, -1.3486326430555913],
            [15.616919613340844, -1.3510944722925287],
            [15.621627471293868, -1.3450927477592578],
            [15.626256003538538, -1.3423524192835983],
            [15.628044414058614, -1.3375675081654308],
            [15.62703093868021, -1.331127857260816],
            [15.633735542825963, -1.3301093307795617],
            [15.641231487349213, -1.3214709504358608],
            [15.64624626307689, -1.3204964743059762],
            [15.651471624406001, -1.3117120683436785],
            [15.655543753555369, -1.3069726978195686],
            [15.654825847894783, -1.3035613974060505],
            [15.660370061370902, -1.297932563259885],
            [15.66882892338448, -1.2977450270854103],
            [15.673430641238518, -1.29855023638376],
            [15.679857678763481, -1.3023372959678514],
            [15.68700531284369, -1.3137664392889006],
            [15.69149364536202, -1.3160672728995328],
            [15.694777177635642, -1.3233444284954312],
            [15.698157842096563, -1.3257150493603733],
            [15.702100785340114, -1.3262473873774778],
            [15.703751441266744, -1.3298505607801587],
            [15.699875106646596, -1.3342150356647873],
            [15.70340746314697, -1.341324907733346],
            [15.701175522722952, -1.3478943842063857],
            [15.701232663814832, -1.3555903871523156],
            [15.70314603309476, -1.3574731088628802],
            [15.708128720781168, -1.3580789011503747],
            [15.710144178878815, -1.360698490279747],
            [15.708891277702712, -1.3638438347643709],
            [15.703855154821811, -1.3672272499901026],
            [15.706442690044932, -1.3713952805323382],
            [15.713270027013417, -1.372417005382052],
            [15.710221609441763, -1.3772315222382325],
            [15.71242843446545, -1.3783099335726525],
            [15.722830976072983, -1.3775152992816198],
            [15.72826966184283, -1.3744985406720098],
            [15.735715822949542, -1.3629507261894762],
            [15.73871233269573, -1.3595219823426392],
            [15.746148250867899, -1.3438760804971175],
            [15.749735971560815, -1.3387657431501965],
            [15.753633374989338, -1.3297322253859007],
            [15.75403026379907, -1.3257564735074252],
            [15.750914375039502, -1.3165805079680881],
            [15.74587084509023, -1.306672801165965],
            [15.746090465829662, -1.2996149900240375],
            [15.749719022324198, -1.2956129208150684],
            [15.75792067085294, -1.2933065399778083],
            [15.767840209292201, -1.2940997110445074],
            [15.771404160862392, -1.295716220598479],
            [15.778520524138006, -1.3028338592933224],
            [15.792295559524666, -1.3097657879295814],
            [15.79997090377494, -1.3093622296853633],
            [15.8081269422906, -1.3054727876642946],
            [15.805315176580269, -1.3094268536610572],
            [15.800414029928755, -1.3109666208955422],
            [15.795566139012626, -1.3165756197394645],
            [15.796278248812541, -1.3190044083481713],
            [15.793298542210277, -1.3246441095724735],
            [15.792815282981019, -1.3333446921795327],
            [15.79114672171671, -1.3370573102179044],
            [15.795631239246127, -1.3409201244755542],
            [15.796356128071917, -1.3449116402279195],
            [15.799113302847097, -1.3466751314908099],
            [15.79653097630181, -1.3529570982015395],
            [15.792478456644327, -1.3550540281941308],
            [15.787969430674105, -1.3625940784204502],
            [15.787182998154526, -1.3711964023810184],
            [15.791480204951712, -1.3760865498112769],
            [15.79614891887096, -1.379296002089465],
            [15.797856316656173, -1.3848007345436848],
            [15.79524431997622, -1.3901973299209145],
            [15.791655429212677, -1.391267856785097],
            [15.790546560938326, -1.394487372117261],
            [15.793280967513295, -1.3997241748709977],
            [15.790812671839273, -1.4081163228035856],
            [15.78983640606146, -1.4149723524809446],
            [15.786187441556116, -1.4165211053364444],
            [15.78444128864875, -1.4197676858513975],
            [15.784122992973948, -1.4260614793996993],
            [15.786359139920643, -1.431283936859833],
            [15.781530447742787, -1.4345459962758742],
            [15.781952871835442, -1.4392671862595816],
            [15.777413792764976, -1.4437278447976285],
            [15.777352051243794, -1.447585179810017],
            [15.779610174430857, -1.4494969941276092],
            [15.769215300758395, -1.4626583565658653],
            [15.672219832150722, -1.5453247972251287],
            [15.652340805221582, -1.5390443352576297],
            [15.629682933699232, -1.533245030430212],
            [15.610786475089519, -1.5260710669318014],
            [15.601641358523128, -1.5237278224831319],
            [15.565561384220999, -1.5105193120544602],
            [15.546254530487664, -1.5042014224891505],
            [15.521815816294705, -1.4954405394825738],
            [15.515707551209314, -1.4939290883999021],
            [15.509926346764534, -1.4984240681586107],
            [15.509014135591483, -1.502106324725819],
            [15.503992477220432, -1.4963612445475147],
            [15.499442851539593, -1.4959125248741805],
            [15.491809677233546, -1.4930095134070565],
            [15.490411450630726, -1.4910972863980163],
            [15.482449599245438, -1.4913653981351425],
            [15.484042804914555, -1.4886459693058904],
            [15.479933986645491, -1.4859679372065708],
            [15.47054742659172, -1.4817805522344167],
            [15.46557291924386, -1.4841198036229264],
            [15.460187643822195, -1.482969940476375],
            [15.451225632717366, -1.483606865406315],
            [15.447805744491703, -1.4857821777446594],
            [15.442847218656192, -1.4857463859799485],
            [15.438194220476873, -1.4827914505868052],
            [15.43494097751701, -1.483609919878949],
            [15.42946491054286, -1.4773284801538409],
            [15.429300195337115, -1.474439806355907],
            [15.434981357202341, -1.4652986127327583],
            [15.43438358532945, -1.4619840493399763],
            [15.35288855123867, -1.4444024191583944],
            [15.346278994825655, -1.4090453778739576],
            [15.344181402072717, -1.3963843095548292],
            [15.346539408850939, -1.3879591006600758],
            [15.342219758105848, -1.3580257006598295],
            [15.271320798097115, -1.2759920477531796],
            [15.275267522243103, -1.268752294509719]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.10922422559973, "lat": 35.84317847427461 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37117"],
        "coty_name": ["Martin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Martin County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01026328"
      },
      "bbox": [
        15.271320798097115, -1.5453247972251287, 15.8081269422906,
        -1.191329228946036
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.146668621371273, -6.4743880968435406],
            [7.1666716365825325, -6.47298163743949],
            [7.212751257825606, -6.469195579321982],
            [7.320123659720344, -6.45941270344928],
            [7.362486733456445, -6.455825759299224],
            [7.418736841530374, -6.45139855009987],
            [7.487777943637569, -6.444150821705212],
            [7.498733286450922, -6.559043898844809],
            [7.527171775273094, -6.556262816775961],
            [7.537843412054643, -6.560981225692756],
            [7.542377607004973, -6.603934411425427],
            [7.573442377569726, -6.601120381737448],
            [7.642595220076045, -6.592939259457478],
            [7.643942352977455, -6.608080669733902],
            [7.629240121101269, -6.609020118126222],
            [7.635808584009844, -6.669529361834989],
            [7.641557431253315, -6.724674246389083],
            [7.59883008473051, -6.729170604021635],
            [7.602489210289027, -6.7660271261550236],
            [7.610539974493764, -6.85066071260976],
            [7.612810203678101, -6.8716296871406675],
            [7.607790019288533, -6.875531686432202],
            [7.596760679214414, -6.886796054252216],
            [7.586516188427684, -6.900098529924769],
            [7.573965718769449, -6.9062728740235455],
            [7.569847406481648, -6.909960420817622],
            [7.569344369493869, -6.916038087396742],
            [7.584423237857519, -6.927740945308658],
            [7.592142727284397, -6.931474294785808],
            [7.60828397889537, -6.937680241054583],
            [7.618957549259699, -6.94302344150167],
            [7.62246329444663, -6.949031910943199],
            [7.622456032764638, -6.959709569820321],
            [7.620036390926808, -6.97006860999997],
            [7.6186275039998215, -6.981833428703334],
            [7.615579570147099, -6.99119745210661],
            [7.604773387683076, -7.002060834760431],
            [7.600224566166302, -7.011306444852092],
            [7.596294106246293, -7.015674081001516],
            [7.588372308716734, -7.019606000443537],
            [7.583365843749474, -7.019688582749711],
            [7.57832885019434, -7.018287282106527],
            [7.570629008343129, -7.013037336857796],
            [7.561411829409, -7.005018861351894],
            [7.557426816183422, -7.003781250078426],
            [7.548875145541482, -7.005037040127255],
            [7.539601394136712, -7.008527313838217],
            [7.53663551912123, -7.011018434064751],
            [7.524068707442251, -7.025493136847346],
            [7.519936566837632, -7.028156910388506],
            [7.511240333251693, -7.030444039283828],
            [7.5072706148807375, -7.033552978859221],
            [7.501461378722548, -7.05086525851797],
            [7.494872819536348, -7.058460085568356],
            [7.492880318567389, -7.062016445733569],
            [7.493754882464158, -7.067708158437882],
            [7.497382616040966, -7.075747877326806],
            [7.498118950947903, -7.091678438979608],
            [7.497006511547489, -7.0949761599903844],
            [7.493009789151113, -7.099154414370696],
            [7.48541137488837, -7.103296980082094],
            [7.478980193347222, -7.103691873465025],
            [7.473337470326106, -7.100052235839739],
            [7.472258058883705, -7.096976197051933],
            [7.472411637445708, -7.082583998605524],
            [7.4695485780018585, -7.075446407342798],
            [7.4664859989304295, -7.07378498487847],
            [7.462172984524213, -7.07417597102267],
            [7.460497319281273, -7.076309103024581],
            [7.460223101795045, -7.0823476467110105],
            [7.461652238532958, -7.089669919428545],
            [7.459740680326909, -7.094548560478527],
            [7.449060821605085, -7.106202094071277],
            [7.447156812777165, -7.110780475798216],
            [7.447169938218403, -7.115019949887021],
            [7.449990147381007, -7.127393861398694],
            [7.454070603178741, -7.133353339809537],
            [7.463772266127107, -7.138277622995914],
            [7.466200028535282, -7.140697307330825],
            [7.465913290568736, -7.142801126388445],
            [7.461062428240915, -7.144765344399762],
            [7.4535983982623435, -7.141405579500826],
            [7.446399548087195, -7.142338438474929],
            [7.43987873600779, -7.137572960758784],
            [7.437318236859386, -7.132502050636259],
            [7.435917622791379, -7.124443567470572],
            [7.432443548823362, -7.122137692059722],
            [7.4288269519472045, -7.123529476335314],
            [7.427172837628267, -7.130918352991373],
            [7.42822691391875, -7.134673348524908],
            [7.433906305344654, -7.139424973412298],
            [7.44084283647348, -7.1478924232991945],
            [7.442167695344249, -7.152293462480953],
            [7.449954735951347, -7.156490958239437],
            [7.451997418619516, -7.161489678451724],
            [7.450788277921289, -7.16356959375595],
            [7.443732676601854, -7.169166088369138],
            [7.437747524207634, -7.170664273668185],
            [7.4228022222905246, -7.1631392313880955],
            [7.417760921131173, -7.162934088720095],
            [7.414523918936598, -7.167164727580299],
            [7.413576575961845, -7.177575512257036],
            [7.411352327010476, -7.183653878713931],
            [7.405180967782497, -7.1873179468666875],
            [7.398044816420739, -7.183859627357849],
            [7.395005446894166, -7.1881630769057345],
            [7.39725306808378, -7.1906386028383285],
            [7.401307508265958, -7.1883101104619564],
            [7.404624584664686, -7.1902484932550115],
            [7.409478573224499, -7.195627983796156],
            [7.408336672102681, -7.198866288816736],
            [7.403774094348588, -7.2040283206567635],
            [7.404504309736206, -7.207153621588904],
            [7.411879197330512, -7.211612044118934],
            [7.412316251371896, -7.213986850283898],
            [7.407761489525889, -7.217601304150657],
            [7.400779626171869, -7.2087884129254105],
            [7.396943697363044, -7.206958158770877],
            [7.391006655060017, -7.209048859917726],
            [7.388242148049746, -7.213580906068942],
            [7.388809355689832, -7.2185166079409475],
            [7.3944359087330955, -7.227690403148203],
            [7.401770068917575, -7.23193411337326],
            [7.402456989464288, -7.237343783432179],
            [7.399326738373159, -7.240268311151844],
            [7.393749494910202, -7.239556582350792],
            [7.388695412861343, -7.234891431755944],
            [7.384448511871047, -7.229226064890059],
            [7.380101950501916, -7.230618818607675],
            [7.379549273997631, -7.233212566833327],
            [7.38238481237436, -7.24061564036149],
            [7.382178631796208, -7.24367538035313],
            [7.377993988276722, -7.247527791938345],
            [7.368605500843069, -7.241977941392725],
            [7.361024498486139, -7.249611240613665],
            [7.35490232105198, -7.248321657997208],
            [7.34962373909185, -7.260562713970039],
            [7.345854604094118, -7.2626247071585235],
            [7.339499139620202, -7.262650368014147],
            [7.332431040784112, -7.2593841633315215],
            [7.326591743368995, -7.260106507833536],
            [7.321158524883755, -7.257397753980315],
            [7.3174719435123965, -7.249781401680768],
            [7.318431333919145, -7.243749507837356],
            [7.3246237051403265, -7.238666021670111],
            [7.325586515103371, -7.229609221951232],
            [7.331426123074895, -7.224938228226419],
            [7.3315276406803775, -7.222382915997497],
            [7.32704007881473, -7.218410486426203],
            [7.318964763190795, -7.206269391689522],
            [7.315830171982521, -7.204261431638853],
            [7.307313311931376, -7.203739615409213],
            [7.302044930613622, -7.20181875162714],
            [7.2963863587680295, -7.19411204292956],
            [7.291993181765811, -7.19322009283919],
            [7.286898021989436, -7.197428744801284],
            [7.283265325289261, -7.198228074154532],
            [7.281837949576617, -7.193936375978676],
            [7.2909784810327105, -7.1825286638665125],
            [7.297728408598405, -7.1809672728611655],
            [7.303678829761688, -7.1840641726050505],
            [7.307568046782836, -7.183793826062259],
            [7.308972604488758, -7.179518629419279],
            [7.304633717012993, -7.172147396271939],
            [7.305515611184839, -7.167118582411115],
            [7.30881475832994, -7.165154935767682],
            [7.312254916112703, -7.1599883195674945],
            [7.311602043368538, -7.1549465620888855],
            [7.308541712433539, -7.152015364964341],
            [7.300653984079364, -7.148771785366214],
            [7.296851576028275, -7.143936729991972],
            [7.296284031420964, -7.138542619859637],
            [7.299636118617475, -7.136031897572296],
            [7.316814009450368, -7.136520633942008],
            [7.320230782352576, -7.139844371706764],
            [7.324969349990391, -7.140864556999099],
            [7.329682188466248, -7.136795412742757],
            [7.328830473034944, -7.129012457466623],
            [7.330767253636026, -7.122378904395091],
            [7.32893871239511, -7.115207849332378],
            [7.3297681841697635, -7.110215871924526],
            [7.332183172933262, -7.108741192789767],
            [7.337734636411157, -7.110909380547232],
            [7.340097626792586, -7.114770606397123],
            [7.335657604744728, -7.120124167253561],
            [7.336002189307698, -7.125108657986164],
            [7.338706454755916, -7.126616988330121],
            [7.342775592010379, -7.125558834783376],
            [7.344337898924386, -7.122013106631605],
            [7.3437362832803394, -7.117224248609157],
            [7.345374514403744, -7.111923671039227],
            [7.350539591769021, -7.105283315347852],
            [7.349889125113282, -7.098999849842152],
            [7.352222033146855, -7.091584452150931],
            [7.355512118066134, -7.086879638047822],
            [7.355561330373386, -7.083508472439982],
            [7.351495766623792, -7.075534866998016],
            [7.3544293316687215, -7.0632377428236035],
            [7.346351359503976, -7.067237455691271],
            [7.340928686206034, -7.060376804521375],
            [7.334698778679622, -7.058362064998673],
            [7.328135230875383, -7.060229244152235],
            [7.326508204305046, -7.065614607935856],
            [7.33037638758674, -7.072935442779439],
            [7.3288493848393745, -7.074319262082028],
            [7.323504031528795, -7.0705923526583305],
            [7.319283699117704, -7.071188866687113],
            [7.31132716352932, -7.076111263444527],
            [7.3081296409851335, -7.076592878934902],
            [7.306003739960131, -7.07373703387428],
            [7.311655920632356, -7.069984304296955],
            [7.315445730800954, -7.06524263384971],
            [7.315236362115509, -7.0589868400179805],
            [7.319861638522768, -7.053995191526936],
            [7.33328646193882, -7.054899371481766],
            [7.338921773990777, -7.050670794568178],
            [7.338449686261415, -7.04561964407133],
            [7.336303997376359, -7.043105840019599],
            [7.327582881743839, -7.041616470591904],
            [7.324421483660315, -7.0450373669628075],
            [7.319914288402223, -7.045447365383464],
            [7.318805897098447, -7.0428124816567195],
            [7.32350446320857, -7.03407751717558],
            [7.331696621223376, -7.027031991792276],
            [7.331522825376391, -7.025178865654201],
            [7.321307287843357, -7.013909034321297],
            [7.313695922228396, -7.01437730444356],
            [7.309574964620465, -7.010255503842201],
            [7.313046681236966, -7.006238455013696],
            [7.32115058177434, -7.004442536093488],
            [7.32570822542938, -7.00030794462146],
            [7.325577617041341, -6.9975069460317245],
            [7.3211465775522955, -6.983318144482257],
            [7.321541051263959, -6.9801865144081265],
            [7.325349995174253, -6.973717513777365],
            [7.327814792614737, -6.967120947518279],
            [7.330003509386979, -6.957954031038755],
            [7.328711252600851, -6.955377014885838],
            [7.313558892644817, -6.948074707939431],
            [7.3115294043650785, -6.946095813910309],
            [7.308923751935021, -6.939245410943573],
            [7.30392999253697, -6.9324354326552795],
            [7.2956344060316605, -6.925584522576592],
            [7.272355476624925, -6.924016878587893],
            [7.268148368519349, -6.922187867795629],
            [7.264325276486057, -6.917334554554524],
            [7.250895716667, -6.914305044270881],
            [7.235776703164577, -6.906648266635675],
            [7.229701420929345, -6.905765741551349],
            [7.218319490276124, -6.898585581403799],
            [7.209905454716193, -6.887516228807874],
            [7.210006301071993, -6.885265017813825],
            [7.216050095868172, -6.8846820408376415],
            [7.224146469243005, -6.887672602256766],
            [7.228131977129041, -6.886291254508642],
            [7.228385659011312, -6.88172130182262],
            [7.2243206303897125, -6.876675786452868],
            [7.219351727151301, -6.874733733157896],
            [7.211341051407482, -6.876231344704394],
            [7.199330933859306, -6.877149728414047],
            [7.1916134948312145, -6.873961154155003],
            [7.180838762919347, -6.867686335878867],
            [7.1738166644940895, -6.860255589499115],
            [7.173363145782437, -6.857029777401876],
            [7.176869628063129, -6.85040601850702],
            [7.177295087404778, -6.84608866083556],
            [7.170735343111393, -6.837849411641318],
            [7.167922282610758, -6.832920926850518],
            [7.164957944732587, -6.8241036459616975],
            [7.16362491541164, -6.81461953591516],
            [7.159594098810734, -6.806856490635146],
            [7.160974433367839, -6.805053100527196],
            [7.167884270238072, -6.803091522727653],
            [7.169546072442624, -6.800532120591457],
            [7.168964619114098, -6.792447878587117],
            [7.166776102518157, -6.785456369473747],
            [7.16074591263504, -6.777619217405529],
            [7.158517023785374, -6.764671896061038],
            [7.153777863548796, -6.749367695901106],
            [7.151025944629375, -6.727038684685544],
            [7.1393527044355025, -6.704708240227861],
            [7.13321597908625, -6.703496742963576],
            [7.124923214037227, -6.705924141571532],
            [7.116338415011263, -6.714093150704099],
            [7.111958772191502, -6.7166008897424305],
            [7.108232583983936, -6.715590383685407],
            [7.1032107103653725, -6.71181458289434],
            [7.093638107431208, -6.703130244844188],
            [7.089177728396596, -6.696010149346255],
            [7.086104446654785, -6.680892777551406],
            [7.0772553845595585, -6.667650659866143],
            [7.071251085767408, -6.6565077909619],
            [7.070696704429276, -6.650964874522085],
            [7.0769553742460625, -6.6457035203481984],
            [7.084623886817206, -6.629123185528078],
            [7.084771038692805, -6.622173434497636],
            [7.086050610269805, -6.6174955345447835],
            [7.089867665312028, -6.612401741500701],
            [7.096690298988278, -6.608950904835166],
            [7.099489907773537, -6.604313631845815],
            [7.100263424322283, -6.59763197923137],
            [7.1039332630966605, -6.584022136890792],
            [7.105367141328006, -6.570483522246735],
            [7.106694364091712, -6.563086249026453],
            [7.111608972519949, -6.56059370058577],
            [7.120158146488599, -6.560218270400234],
            [7.126632374421242, -6.5566634157749935],
            [7.132040891444657, -6.556723675364864],
            [7.140554219359417, -6.554439034447578],
            [7.144088800288035, -6.551389643899767],
            [7.149407967373301, -6.542647022694068],
            [7.156865591108426, -6.540581253568877],
            [7.16427212179924, -6.542921218392824],
            [7.1676086107828185, -6.539468360941783],
            [7.166673301323706, -6.534650112462827],
            [7.16093119478124, -6.5292700842331515],
            [7.15598702250437, -6.526985618368162],
            [7.149759322957883, -6.533923644519131],
            [7.140092108662854, -6.54330361058614],
            [7.137407531215411, -6.542246045869757],
            [7.132133696854913, -6.533392828386564],
            [7.126627701276457, -6.526327210524649],
            [7.123026511532711, -6.524405439639603],
            [7.114130152985295, -6.528071544204541],
            [7.108907928116493, -6.520097813370758],
            [7.109677846110553, -6.517447942508243],
            [7.129266229683386, -6.501040023996718],
            [7.135439727594876, -6.501808803896368],
            [7.138646873759763, -6.5040593283640495],
            [7.143457973481959, -6.51099401559706],
            [7.145731878376049, -6.511188969838809],
            [7.151602988813669, -6.505572467184756],
            [7.152069155266638, -6.502513408639246],
            [7.14701032182345, -6.494401422275644],
            [7.1458472218816755, -6.489205454783241],
            [7.1469270803700855, -6.485586359920262],
            [7.153262217866506, -6.480899315356319],
            [7.146668621371273, -6.4743880968435406]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.83084302414905,
          "lat": 31.676594365199247
        },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01025"],
        "coty_name": ["Clarke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clarke County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00161538"
      },
      "bbox": [
        7.070696704429276, -7.262650368014147, 7.643942352977455,
        -6.444150821705212
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.765292767325665, -5.216810172116379],
            [8.772865688055251, -5.215569654825464],
            [8.793918085441682, -5.213548304775892],
            [8.792223720770057, -5.1988311769890805],
            [8.808757874847462, -5.197079035034799],
            [8.878265832294462, -5.1901460507429],
            [8.902761385731141, -5.187934652534959],
            [8.959293558540397, -5.181629461500812],
            [8.98027568682898, -5.178745296274185],
            [9.057759090599312, -5.169022198347122],
            [9.107715319918052, -5.16285667263451],
            [9.117900205684258, -5.253691206125712],
            [9.121115701186413, -5.28544423748071],
            [9.136166821887265, -5.424063426420939],
            [9.140872869326598, -5.463460245262338],
            [9.149388760972165, -5.5400791208616305],
            [9.135451294767554, -5.54218815151268],
            [9.13677460429624, -5.556164836310284],
            [9.079055678083748, -5.5638575839834585],
            [9.080813552040164, -5.578370229821285],
            [9.06664545309361, -5.58041068279199],
            [9.075302498569187, -5.655999403748146],
            [9.078440814594375, -5.681326621104829],
            [9.064387246838704, -5.683050815031553],
            [9.065982043258213, -5.696868001779835],
            [9.05631686157788, -5.698192308620966],
            [8.994484434883317, -5.705316076710746],
            [9.000119511908473, -5.752447943216218],
            [9.005033121554172, -5.791592963695123],
            [8.931897286082108, -5.800673851593387],
            [8.930942635032965, -5.800691798738033],
            [8.928861746340882, -5.798759789767361],
            [8.925660154813697, -5.789991265744032],
            [8.925380787467722, -5.7798515198905855],
            [8.92427188847094, -5.777384394706425],
            [8.92474778962203, -5.7609826216234215],
            [8.926251976192557, -5.750798260118521],
            [8.925561858391081, -5.745940734986888],
            [8.91925707702855, -5.7258589699077795],
            [8.91945961497502, -5.719720673721097],
            [8.91607648673323, -5.704681963109017],
            [8.912179349272199, -5.691912324776087],
            [8.910941326598431, -5.680369476490333],
            [8.912035994222967, -5.669784269696853],
            [8.913102203823193, -5.647044879655635],
            [8.910959619040886, -5.643153433121211],
            [8.900733480320474, -5.635712181445972],
            [8.895872479648109, -5.628727401656817],
            [8.894403328561486, -5.623505598041756],
            [8.889930362017349, -5.619073389235142],
            [8.889322554834996, -5.612555003634008],
            [8.891173707901006, -5.597335090221081],
            [8.89388212681013, -5.592711538889067],
            [8.89789214932473, -5.590714278234485],
            [8.900931604211236, -5.586108540450526],
            [8.903307629944257, -5.578223330077016],
            [8.89990092187877, -5.5710540156098105],
            [8.899848521954326, -5.567859752515248],
            [8.908389549924282, -5.556988613464073],
            [8.908946233744093, -5.549587852997699],
            [8.906844509352531, -5.543389058851269],
            [8.908237331925122, -5.539916894039873],
            [8.845858949035078, -5.546230092618314],
            [8.843757666742528, -5.53205122911443],
            [8.829448981823875, -5.533461002209756],
            [8.831465471322762, -5.547641830062556],
            [8.802338649987517, -5.550652165491964],
            [8.798063402540349, -5.509369061652622],
            [8.800218497940154, -5.504433122259261],
            [8.797433256967265, -5.503583842866732],
            [8.79619733858016, -5.4936851669512015],
            [8.790211563953749, -5.486670589144057],
            [8.791822223730012, -5.482648637069838],
            [8.790298278146295, -5.478436120864247],
            [8.794339763198591, -5.478199006470221],
            [8.790434143225397, -5.442091895095467],
            [8.778095586903797, -5.3308931141432305],
            [8.773447227582373, -5.288317430468395],
            [8.765292767325665, -5.216810172116379]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.79753016448618, "lat": 32.86236242564079 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01123"],
        "coty_name": ["Tallapoosa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tallapoosa County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00161587"
      },
      "bbox": [
        8.765292767325665, -5.800691798738033, 9.149388760972165,
        -5.16285667263451
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.06533856823538, -9.985466245267215],
            [-16.99784020954349, -9.984030107537171],
            [-16.930341516165456, -9.982609287062605],
            [-16.888544438062087, -9.981381695734166],
            [-16.889384803079277, -9.956437231003596],
            [-16.886598115370962, -9.95634945713547],
            [-16.820191176959657, -9.919527857426214],
            [-16.753771823699672, -9.882720720750942],
            [-16.687556137150363, -9.846047598145358],
            [-16.621327034143423, -9.809389734103027],
            [-16.570395329717954, -9.781215506364518],
            [-16.51945514586907, -9.753050734059135],
            [-16.499976347746582, -9.751727293016234],
            [-16.4760770941733, -9.75005379207582],
            [-16.44566157543535, -9.74784499584147],
            [-16.36658098818427, -9.741689732625266],
            [-16.29032303491657, -9.735186991729355],
            [-16.294874409719384, -9.685468032197901],
            [-16.22504418684147, -9.678777299861329],
            [-16.155212049545288, -9.672105876445848],
            [-16.135687910949855, -9.670087771850469],
            [-16.057305712529658, -9.661608187997938],
            [-16.045090048077142, -9.767661488980261],
            [-16.040238947306406, -9.809769008158254],
            [-16.03673295080016, -9.84019595758529],
            [-16.02976963760853, -9.839414932963832],
            [-16.025752352543574, -9.87407006315842],
            [-16.023659861712723, -9.87383448531293],
            [-16.0098342515441, -9.992879931622683],
            [-16.007771062332424, -9.992646983675076],
            [-16.001094608152165, -10.050024795957984],
            [-15.997381185783613, -10.081934037397836],
            [-16.039485988534334, -10.086603215776679],
            [-16.08712035291888, -10.09168728522577],
            [-16.083910848800826, -10.121473254239094],
            [-16.08086026968535, -10.121154188656588],
            [-16.075505839830893, -10.170679389871367],
            [-16.07140640123752, -10.208582873226751],
            [-16.067979526618437, -10.240280637359875],
            [-16.064973667569816, -10.239965527554777],
            [-16.052054004365374, -10.359068771847642],
            [-16.095793623858505, -10.363576035391187],
            [-16.09419975500533, -10.378836765410286],
            [-16.177915845862305, -10.386971898752183],
            [-16.183452467991437, -10.38748569378903],
            [-16.302765574668584, -10.397936078189314],
            [-16.306185684892444, -10.398216001583721],
            [-16.42208994173426, -10.407112381739811],
            [-16.422822331408025, -10.39715686859282],
            [-16.43285363761716, -10.397869010371812],
            [-16.43358910605189, -10.387915943271977],
            [-16.445686091266463, -10.388762195773756],
            [-16.451273868024483, -10.386493759044734],
            [-16.45651687306482, -10.38361267205675],
            [-16.4575884784387, -10.378930000571389],
            [-16.461080963560022, -10.378245087345421],
            [-16.46721230584718, -10.380416927748788],
            [-16.473391822186976, -10.384424309500936],
            [-16.482847950379586, -10.386370938012698],
            [-16.48517792467804, -10.387674340385981],
            [-16.48907589958264, -10.388853813178926],
            [-16.491703610274833, -10.388817924967048],
            [-16.493051686158026, -10.387452393961661],
            [-16.494571550808352, -10.388505179322657],
            [-16.49602823967361, -10.388447314701224],
            [-16.498723105789125, -10.390330011521442],
            [-16.500547678736616, -10.391122575973643],
            [-16.50477712266168, -10.394394241079974],
            [-16.506522940393502, -10.39702440627267],
            [-16.510601639246165, -10.39954507460179],
            [-16.511688199713678, -10.400518192986086],
            [-16.5129949029406, -10.40297970169564],
            [-16.514933564203453, -10.403377761003288],
            [-16.5186210422655, -10.406481159949884],
            [-16.52076624220273, -10.410746388979828],
            [-16.52145290486891, -10.414595791773175],
            [-16.5224055554405, -10.41671209646858],
            [-16.52500367670123, -10.420182311449501],
            [-16.525928415803513, -10.422799465527739],
            [-16.527605768887046, -10.424538230245524],
            [-16.529221474179845, -10.425386712721771],
            [-16.53206903535255, -10.426251708749282],
            [-16.533439271494267, -10.426277191387243],
            [-16.535663254907853, -10.427260389609506],
            [-16.53798665165467, -10.429825876952773],
            [-16.53849425082243, -10.430920896159243],
            [-16.539022173214384, -10.434224095102971],
            [-16.539026159933215, -10.438581133663929],
            [-16.540007907419486, -10.440376042297329],
            [-16.541891233444748, -10.444895186755076],
            [-16.54258309856472, -10.44789053742101],
            [-16.542673292120792, -10.452178822924681],
            [-16.54136545793508, -10.454922858781183],
            [-16.541135638988376, -10.457318212870826],
            [-16.541828438809077, -10.460263690894676],
            [-16.542281178803968, -10.464183378400666],
            [-16.5422023843855, -10.467676999504887],
            [-16.541341268576343, -10.46995795675972],
            [-16.542828071878755, -10.472677824564295],
            [-16.5471737329976, -10.475352278314986],
            [-16.550343121875198, -10.478351027419006],
            [-16.55219084819271, -10.48097949793871],
            [-16.562125485878827, -10.477702994087869],
            [-16.567415739384725, -10.476343736520821],
            [-16.57718964246755, -10.475380501022256],
            [-16.589319052009987, -10.475504290694497],
            [-16.593489444271086, -10.476629404157435],
            [-16.59901201339165, -10.47715599983564],
            [-16.60062782643459, -10.477522165776522],
            [-16.603019162023404, -10.476994927471749],
            [-16.60577791069867, -10.477690284830196],
            [-16.607179763024558, -10.478404277290181],
            [-16.610869338815455, -10.479549127915504],
            [-16.619825664059576, -10.481888482529795],
            [-16.624103568067092, -10.482512043225602],
            [-16.633225540113596, -10.483050187854943],
            [-16.63588427605769, -10.482277521484248],
            [-16.637856747186458, -10.481002338742357],
            [-16.64353730598487, -10.475513365423815],
            [-16.643870184209312, -10.47405206462802],
            [-16.64526444447408, -10.470715429499599],
            [-16.64802723154071, -10.466488055069998],
            [-16.65334889459483, -10.467627666833113],
            [-16.654740317563537, -10.4699885698566],
            [-16.655275926572187, -10.471951237746032],
            [-16.657647040627023, -10.473137307411166],
            [-16.65923765436389, -10.472841789135154],
            [-16.660679886800942, -10.470694370097771],
            [-16.662723061258404, -10.468276147371727],
            [-16.665441236419355, -10.46773981277687],
            [-16.666907956757363, -10.470241170186643],
            [-16.667754741944137, -10.474351513670205],
            [-16.670751269110475, -10.479359714440639],
            [-16.6733832208951, -10.4817614446747],
            [-16.677449559863863, -10.4834414215882],
            [-16.68075994945313, -10.486308495378964],
            [-16.686738807699825, -10.489325280566408],
            [-16.687947745388225, -10.489459158618315],
            [-16.69240027411861, -10.491551240480197],
            [-16.694254574948634, -10.492844913790911],
            [-16.697256291540004, -10.496032211921598],
            [-16.700595514918152, -10.498047451707485],
            [-16.702090794706628, -10.498532253408511],
            [-16.71046033953946, -10.499845810665025],
            [-16.711952793952026, -10.499122020977206],
            [-16.71349640966748, -10.502002354584608],
            [-16.713657384831613, -10.503366457273955],
            [-16.715273015436633, -10.50505230527115],
            [-16.716999943941087, -10.505949432137646],
            [-16.718004600308475, -10.48429392480173],
            [-16.778121440431104, -10.486830588544882],
            [-16.78056275933886, -10.427010902272738],
            [-16.812090716274188, -10.428215408291777],
            [-16.91205332905766, -10.431449320957258],
            [-17.05881870046657, -10.434587948485014],
            [-17.060993763760642, -10.29086751351446],
            [-17.063382279920962, -10.13520515202965],
            [-17.065701868170866, -9.98547162917381],
            [-17.06533856823538, -9.985466245267215]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -149.5729111255543,
          "lat": 62.315967623904555
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02170"],
        "coty_name": ["Matanuska-Susitna"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Matanuska-Susitna Borough"],
        "coty_fp_code": "170",
        "coty_gnis_code": "01419976"
      },
      "bbox": [
        -17.065701868170866, -10.505949432137646, -15.997381185783613,
        -9.661608187997938
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-16.41416481277403, -7.367736106468194],
              [-16.411706521098647, -7.365296004950088],
              [-16.410295850995528, -7.362769203175889],
              [-16.40995839070295, -7.360875420694754],
              [-16.408709328797087, -7.360280448199402],
              [-16.406813633564404, -7.361203123634737],
              [-16.404448371382415, -7.364006374010687],
              [-16.40573878988022, -7.364206998994303],
              [-16.407698101881262, -7.366019245932303],
              [-16.408946284996585, -7.366490872323876],
              [-16.409995204902792, -7.368058499102442],
              [-16.411225096460665, -7.3674525947049245],
              [-16.41416481277403, -7.367736106468194]
            ]
          ],
          [
            [
              [-16.505997958192964, -7.340908328017173],
              [-16.50438570275176, -7.3400521333719455],
              [-16.502365208766644, -7.3401946681906525],
              [-16.501236631182415, -7.341587114637869],
              [-16.503426792342193, -7.342111849705834],
              [-16.505997958192964, -7.340908328017173]
            ]
          ],
          [
            [
              [-16.623319239450776, -7.2943350690794295],
              [-16.61803012421773, -7.293580416475061],
              [-16.61955975816621, -7.2946734169748755],
              [-16.623186946169444, -7.294822223454538],
              [-16.623319239450776, -7.2943350690794295]
            ]
          ],
          [
            [
              [-16.66305240915693, -7.280149620994075],
              [-16.660622590664833, -7.280719109365496],
              [-16.66129746251719, -7.2826992908088295],
              [-16.66305240915693, -7.280149620994075]
            ]
          ],
          [
            [
              [-16.70174282756819, -7.272227355314923],
              [-16.701174770984345, -7.271780983217892],
              [-16.690634390470446, -7.272791826913352],
              [-16.68615190883326, -7.273506118653762],
              [-16.68213912767468, -7.274698652467506],
              [-16.681967319633227, -7.275349321233922],
              [-16.683983082191588, -7.276198165476967],
              [-16.685567643188364, -7.275242466077384],
              [-16.69128553461872, -7.27391818731765],
              [-16.69632772507385, -7.27355278147916],
              [-16.69828662060422, -7.274921037359913],
              [-16.700488095573085, -7.2746725848160505],
              [-16.70174282756819, -7.272227355314923]
            ]
          ],
          [
            [
              [-16.956084269902252, -7.300745612750664],
              [-16.95515880185453, -7.300072708278901],
              [-16.953808707066223, -7.301032785754991],
              [-16.9540282562203, -7.302360237175372],
              [-16.95604408009348, -7.301797900872544],
              [-16.956084269902252, -7.300745612750664]
            ]
          ],
          [
            [
              [-16.978773634458445, -7.280284871270458],
              [-16.97394149140057, -7.280819417264385],
              [-16.972720171055734, -7.28146696895489],
              [-16.97327123265959, -7.28277600918421],
              [-16.97631406555858, -7.2812573194640855],
              [-16.97841062240304, -7.281497693299188],
              [-16.978773634458445, -7.280284871270458]
            ]
          ],
          [
            [
              [-16.986961426607937, -7.2789474430819805],
              [-16.984284200577715, -7.279243146975838],
              [-16.9828065140983, -7.280005251595081],
              [-16.983623738113724, -7.280971677701259],
              [-16.9852163863375, -7.2792312033147875],
              [-16.986961426607937, -7.2789474430819805]
            ]
          ],
          [
            [
              [-17.02956278233971, -7.273996348907057],
              [-17.02935157912282, -7.271170816131643],
              [-17.02736498127925, -7.2711215226329164],
              [-17.027267000876165, -7.272206638116735],
              [-17.02795357320846, -7.274050437891685],
              [-17.02956278233971, -7.273996348907057]
            ]
          ],
          [
            [
              [-17.09096018622138, -7.175150287177785],
              [-17.089588040697365, -7.174809711277908],
              [-17.088066682059257, -7.1773863678741945],
              [-17.08981070122032, -7.177192154567937],
              [-17.09096018622138, -7.175150287177785]
            ]
          ],
          [
            [
              [-17.50941374637247, -7.004198378653145],
              [-17.50674241162272, -7.004914081488292],
              [-17.50661480953805, -7.005413551501949],
              [-17.508783387521948, -7.006793975697755],
              [-17.50941374637247, -7.004198378653145]
            ]
          ],
          [
            [
              [-15.552133037098226, -7.832393438264398],
              [-15.558620202018405, -7.833641817673566],
              [-15.621986993259425, -7.845302225976165],
              [-15.685348964362312, -7.856989316530644],
              [-15.750088068361345, -7.868093685553255],
              [-15.814822303033843, -7.8792258462907],
              [-15.878650844859964, -7.889232327749172],
              [-15.942475029136183, -7.899265797131504],
              [-16.00729162848792, -7.908433690780986],
              [-16.072104181969035, -7.917629395328092],
              [-16.131764085148088, -7.9251895388707565],
              [-16.19142092366405, -7.93277323023968],
              [-16.177262200156555, -8.048618233259045],
              [-16.170578004863515, -8.10328012546783],
              [-16.243936899255903, -8.11176127923093],
              [-16.30627471435972, -8.118246253865884],
              [-16.368609824320234, -8.124756558201486],
              [-16.42467824187688, -8.129830615567688],
              [-16.480744758078604, -8.134925156489052],
              [-16.544387048759386, -8.139814584901034],
              [-16.60802726053907, -8.144730396626647],
              [-16.63191742314273, -8.1463649853822],
              [-16.6970671538785, -8.150493539745261],
              [-16.782208083153552, -8.155164020346582],
              [-16.843097997107787, -8.157778713834514],
              [-16.90398684807446, -8.160417544762488],
              [-16.96720972285669, -8.162245367693556],
              [-17.03043182452591, -8.164099209740508],
              [-17.088500623592466, -8.164985722471004],
              [-17.14656907526581, -8.165894183059953],
              [-17.19780612037768, -8.166044091429809],
              [-17.249043111943987, -8.166211086539578],
              [-17.304592921368158, -8.165702473781396],
              [-17.36014291629933, -8.16521394569542],
              [-17.364643362257407, -8.16515880134097],
              [-17.399592034943172, -8.164520055803873],
              [-17.399351898110723, -8.152524370339481],
              [-17.459912398533525, -8.150910014305117],
              [-17.52047354213658, -8.149319561970318],
              [-17.519463431932312, -8.119587737846473],
              [-17.579788753981866, -8.117152816378251],
              [-17.640115049305074, -8.114741685856133],
              [-17.638690324716606, -8.085033906968649],
              [-17.701528535097022, -8.081615678081937],
              [-17.764368174934308, -8.07822333780038],
              [-17.84382377255567, -8.072989095924811],
              [-17.907247359688277, -8.06804447261569],
              [-17.97067304112363, -8.063126234530465],
              [-17.968102919684245, -8.033499710976502],
              [-18.02872645628397, -8.028132389567048],
              [-18.031506154808326, -8.05774040498517],
              [-18.092276128983077, -8.05170904197734],
              [-18.153048557411775, -8.045701915706571],
              [-18.149849682148552, -8.016134543768025],
              [-18.210344614783494, -8.009504814185163],
              [-18.213755686827373, -8.039049751018831],
              [-18.274408362515064, -8.031975537013295],
              [-18.27079068102191, -8.002454539532561],
              [-18.27939920994834, -8.001414957133331],
              [-18.361362382781774, -7.991091893061486],
              [-18.365293561609043, -8.020574041070377],
              [-18.418228821644785, -8.013315736627675],
              [-18.471166668832524, -8.006075846001949],
              [-18.533486178513847, -7.9966850881672356],
              [-18.595809636554524, -7.987319866648871],
              [-18.605266931574846, -8.046082680319754],
              [-18.662312517155108, -8.036686596063323],
              [-18.719361709162335, -8.02731180037997],
              [-18.724574679114337, -8.02275190795957],
              [-18.73099683580547, -8.017814143339438],
              [-18.73685479394338, -8.013888793320527],
              [-18.739797465449286, -8.012097688052418],
              [-18.753258273536094, -8.00329543867013],
              [-18.759194829205608, -7.999985545884798],
              [-18.761488711033824, -7.998953786313655],
              [-18.769645145303826, -7.995946064282304],
              [-18.77110305176887, -7.995528989043744],
              [-18.77205764877147, -7.994542619089607],
              [-18.779214914706344, -7.990540651764657],
              [-18.781135793254204, -7.989051042155466],
              [-18.781403394726954, -7.988104710883877],
              [-18.782915081451048, -7.9861646616667405],
              [-18.789680735419264, -7.979622711051401],
              [-18.791322033438252, -7.976702863931893],
              [-18.790980652581688, -7.975883470178745],
              [-18.791778148600713, -7.97340608938124],
              [-18.79202926693312, -7.96982635082331],
              [-18.7925523656051, -7.9659926834237655],
              [-18.793664060797987, -7.961624718890951],
              [-18.795816862514204, -7.955872020580773],
              [-18.798915862109062, -7.949354675217909],
              [-18.80029888630484, -7.946914918088329],
              [-18.80498022935371, -7.939722614607954],
              [-18.810554867207664, -7.932785207120021],
              [-18.8160833498943, -7.926868587143534],
              [-18.82303355385603, -7.92041056738239],
              [-18.82934410976249, -7.91528866036064],
              [-18.835932410187972, -7.910663717386861],
              [-18.848094798923853, -7.902957314958097],
              [-18.851064771426895, -7.9014607608161365],
              [-18.857119414589732, -7.897934444450117],
              [-18.869598052213288, -7.892549299008915],
              [-18.87568135324474, -7.890855270039565],
              [-18.880281248575393, -7.88994753042894],
              [-18.88445379822096, -7.889643450829421],
              [-18.88828525759616, -7.88988265049891],
              [-18.888115049058538, -7.8888691207694],
              [-18.88589421766108, -7.887358283556275],
              [-18.882495870193623, -7.886011715308703],
              [-18.87499843263899, -7.883954107205079],
              [-18.85731138459081, -7.880101133513094],
              [-18.84348550194049, -7.877703275885914],
              [-18.840704270496293, -7.877138143093282],
              [-18.833502710414866, -7.87530573488449],
              [-18.8304081665342, -7.874060470652825],
              [-18.82356418090825, -7.872056840678393],
              [-18.821010215561667, -7.870698824259148],
              [-18.81809815176474, -7.868614840593005],
              [-18.816768712450134, -7.866934337259042],
              [-18.816068104579774, -7.865264697916004],
              [-18.81633055613538, -7.864498985511528],
              [-18.81410821236561, -7.862441166328128],
              [-18.812759781726186, -7.860755261398049],
              [-18.81177271986529, -7.858104459705495],
              [-18.812050614114376, -7.857467061507301],
              [-18.8115462425127, -7.854632069512107],
              [-18.812080626944955, -7.853688187803864],
              [-18.810986827608307, -7.851780830621127],
              [-18.810534965009712, -7.850161213409897],
              [-18.80868345448018, -7.847334746947759],
              [-18.808398827591063, -7.84521579367931],
              [-18.80911320789766, -7.84362327293006],
              [-18.808353174823928, -7.842425265245351],
              [-18.805005338732347, -7.839419827956907],
              [-18.802494844135044, -7.836313921472615],
              [-18.8012905549847, -7.83429207624298],
              [-18.79791282233061, -7.829987363103289],
              [-18.795844837040686, -7.82553136762544],
              [-18.795078876358026, -7.822499163711984],
              [-18.795534518001492, -7.817929665164185],
              [-18.794493309565393, -7.813936148303529],
              [-18.793639674818376, -7.8121461345155145],
              [-18.793356033283793, -7.810404548642621],
              [-18.79140234187417, -7.806260955526542],
              [-18.790324569749238, -7.803321039747379],
              [-18.790191331110762, -7.801780166248637],
              [-18.791675328598924, -7.7992816077699345],
              [-18.7899560533466, -7.797037292641067],
              [-18.786986975273052, -7.792228693938654],
              [-18.78463144277859, -7.786844277112583],
              [-18.783787477334975, -7.783717673479136],
              [-18.78352664862265, -7.780716946417193],
              [-18.784099484581226, -7.77923351102787],
              [-18.78179504065596, -7.771909529905286],
              [-18.78101819659343, -7.768683849026067],
              [-18.780607841392598, -7.76502484823431],
              [-18.779494314125404, -7.762301640937112],
              [-18.77855068731562, -7.759194183957488],
              [-18.777488292570204, -7.753184347635234],
              [-18.777382600568274, -7.746952783216308],
              [-18.777556870726517, -7.745277399072837],
              [-18.776699625927446, -7.72971283911855],
              [-18.77720544322588, -7.727713797482757],
              [-18.776576608006813, -7.725636364034583],
              [-18.776621511089267, -7.723738794596742],
              [-18.774901659203564, -7.722068794632848],
              [-18.77257976799298, -7.722351819774012],
              [-18.770232855123105, -7.723582064592556],
              [-18.764401952973607, -7.725642826237495],
              [-18.754888336045294, -7.729164817191064],
              [-18.74905129885148, -7.7311320371170735],
              [-18.746108984167506, -7.731967897925795],
              [-18.7319597105491, -7.736463505392936],
              [-18.7236377887223, -7.738599126526736],
              [-18.71847654238596, -7.740248583640095],
              [-18.70775982191886, -7.743981990281163],
              [-18.701330482192137, -7.745782429289811],
              [-18.695166932278777, -7.74698955838541],
              [-18.690314123957197, -7.746824972160915],
              [-18.685149904711274, -7.747421734361738],
              [-18.6772599379879, -7.748636833990357],
              [-18.671052751163664, -7.749342063630528],
              [-18.662865086265988, -7.749772669462732],
              [-18.659404003114716, -7.749824754851289],
              [-18.65555899139016, -7.749575672052248],
              [-18.652644226634063, -7.7497192032258],
              [-18.651428954154728, -7.749450355733479],
              [-18.645257366717797, -7.749718560975465],
              [-18.641531957386878, -7.749700220687912],
              [-18.63891107486805, -7.7493950769905435],
              [-18.63715826779915, -7.748586438908755],
              [-18.626955120113504, -7.748930173787156],
              [-18.617575948003676, -7.748507819224338],
              [-18.614473708437856, -7.748482137989514],
              [-18.607599554624514, -7.747739426739391],
              [-18.604953839357652, -7.747622348453035],
              [-18.59822691857974, -7.748170348812085],
              [-18.5961837557287, -7.748032027825394],
              [-18.589095696712825, -7.74800242999728],
              [-18.58459180371179, -7.747585582134296],
              [-18.576975861629062, -7.746047365093195],
              [-18.571163621368665, -7.745106439760119],
              [-18.569689612884854, -7.745282293323918],
              [-18.564740218132258, -7.746530554107123],
              [-18.555424040540455, -7.747604535203494],
              [-18.543951234950324, -7.747834036455988],
              [-18.539992740298125, -7.747992378793287],
              [-18.532634527308044, -7.747861322796853],
              [-18.526541371723333, -7.747484509429293],
              [-18.520169060680374, -7.746583426031586],
              [-18.513213902375956, -7.744672086125518],
              [-18.510124892599666, -7.743320826532475],
              [-18.501266360417098, -7.738025680419897],
              [-18.499571532033592, -7.737439477818498],
              [-18.487304091043775, -7.7338341809968405],
              [-18.483990586633574, -7.732614758433321],
              [-18.479441387078804, -7.730506300951888],
              [-18.47625808966211, -7.728324154302935],
              [-18.474553879619172, -7.726836973779547],
              [-18.470452040884254, -7.722285405449941],
              [-18.46632860576744, -7.719182599148807],
              [-18.454016436193925, -7.712862221903048],
              [-18.449586612949467, -7.711068031033617],
              [-18.44637935993369, -7.708826769655333],
              [-18.44086370486841, -7.7037156043791395],
              [-18.4377291969897, -7.701221971582802],
              [-18.43382588904282, -7.697624517326034],
              [-18.428051402793386, -7.693070355575932],
              [-18.42325300443605, -7.68787587360588],
              [-18.420528127183278, -7.684293809848961],
              [-18.41678376198972, -7.678196463825935],
              [-18.413933949525113, -7.674046353839303],
              [-18.411899249087597, -7.6718403998475715],
              [-18.408267809991916, -7.668464851378652],
              [-18.404264992116676, -7.665117962382183],
              [-18.397164581932405, -7.658293880929452],
              [-18.38810619964392, -7.648094855343584],
              [-18.383890680496037, -7.643218452769093],
              [-18.381008406795342, -7.639335411271241],
              [-18.377448986677976, -7.633938471080689],
              [-18.374249115949944, -7.628292954192496],
              [-18.371218428330018, -7.622153601324305],
              [-18.368569888668535, -7.616205093992048],
              [-18.365155856626096, -7.606938450345298],
              [-18.364334172284263, -7.603600456514691],
              [-18.36303376197031, -7.601903363900101],
              [-18.363191821327224, -7.600251062371108],
              [-18.362785010743618, -7.596701564101887],
              [-18.36115138900332, -7.590152920969443],
              [-18.361266205582627, -7.58840907228395],
              [-18.36006639526737, -7.57972345821101],
              [-18.35860671118828, -7.571846496025387],
              [-18.357340884849712, -7.563952995727454],
              [-18.356156187870745, -7.5538057280675615],
              [-18.35548787749519, -7.545710071830827],
              [-18.354739098603122, -7.538926019757063],
              [-18.353381378339883, -7.532069927818832],
              [-18.35207009771691, -7.527884755628924],
              [-18.349860385060587, -7.52251117296478],
              [-18.347420238467, -7.517364580300241],
              [-18.345931776391833, -7.515503167897151],
              [-18.345114561097386, -7.512184097204609],
              [-18.342458804043993, -7.504681102703968],
              [-18.337848812655512, -7.49318090902232],
              [-18.33728320997644, -7.491016379926571],
              [-18.33533354436383, -7.487168850488517],
              [-18.333176740857223, -7.481800274772036],
              [-18.329990273240377, -7.47474571051111],
              [-18.327592418835646, -7.470828609173175],
              [-18.32248145336756, -7.464388128550708],
              [-18.31771714810536, -7.459161207605055],
              [-18.31380245270996, -7.455230020106742],
              [-18.309844110226663, -7.450854625203109],
              [-18.303592000940206, -7.444536845912249],
              [-18.301168810184564, -7.443350378630083],
              [-18.296945354675, -7.436808472733394],
              [-18.290909805296273, -7.429942463388824],
              [-18.286506822238618, -7.425443015158719],
              [-18.282035561673492, -7.420394446860162],
              [-18.277922588702953, -7.41492448462178],
              [-18.273877227425388, -7.4090442659780535],
              [-18.268433523555696, -7.401465044089398],
              [-18.263849428923603, -7.393490584303855],
              [-18.261237119454776, -7.390091446060964],
              [-18.25630788448989, -7.385640808447114],
              [-18.25512750820994, -7.383480565158174],
              [-18.253378139658007, -7.381533626386866],
              [-18.248941308151277, -7.373970565175188],
              [-18.24470600229829, -7.369019377739964],
              [-18.239219655040028, -7.3637757385616185],
              [-18.236686011519133, -7.36107303977026],
              [-18.232024828642878, -7.355522208024806],
              [-18.22889071200675, -7.35249580979536],
              [-18.22072805198714, -7.346676905753947],
              [-18.212101905130076, -7.341215763590275],
              [-18.205488447271396, -7.337321478085515],
              [-18.199082635392116, -7.33334612917524],
              [-18.194656975516512, -7.330301280892032],
              [-18.19138901802137, -7.328796352440521],
              [-18.191194421901322, -7.327681432340475],
              [-18.187479198579293, -7.325564990547643],
              [-18.18399604328471, -7.323328378833903],
              [-18.180393315384357, -7.3216283073163275],
              [-18.176646553183375, -7.319418268439252],
              [-18.175482016518895, -7.31782999882823],
              [-18.172441545982007, -7.316048159931393],
              [-18.16895794570854, -7.3132929004932645],
              [-18.164918150489676, -7.315028673806373],
              [-18.15910131483018, -7.316857375811241],
              [-18.13946454440835, -7.32476561568581],
              [-18.128975310217555, -7.328293772280057],
              [-18.125196910109366, -7.329447901690246],
              [-18.118534110460196, -7.330909371945689],
              [-18.113552110413192, -7.331477802661537],
              [-18.109419072726716, -7.3314134194293805],
              [-18.105057466850493, -7.33212770534276],
              [-18.1038593963739, -7.332726642845473],
              [-18.100393430895117, -7.332968969759056],
              [-18.099688646520406, -7.332317867256784],
              [-18.090176780434604, -7.329469155682746],
              [-18.08257898086042, -7.326950111750153],
              [-18.072610202922426, -7.324488874021961],
              [-18.070672539466734, -7.324748862276717],
              [-18.068043973550914, -7.32338186759266],
              [-18.05931129165832, -7.319887425489289],
              [-18.052739259979678, -7.3167638143540445],
              [-18.044686140742662, -7.3132333527555495],
              [-18.039874766199638, -7.311429562944775],
              [-18.0350455075446, -7.309011128844612],
              [-18.028077773046615, -7.304527233732046],
              [-18.024134486963185, -7.3023040283771685],
              [-18.02227287748466, -7.301501193871293],
              [-18.020438128513835, -7.3000959890001935],
              [-18.01401190157075, -7.2964684487126235],
              [-18.00515519503338, -7.290638276662911],
              [-17.997685051064362, -7.285019433433171],
              [-17.98824292004053, -7.277350476504937],
              [-17.980331048249642, -7.270815181031228],
              [-17.977154303211453, -7.268436771133604],
              [-17.969622775629148, -7.261518503595916],
              [-17.961893208602095, -7.2546181055431935],
              [-17.9570811903896, -7.249373136838832],
              [-17.954316365188056, -7.245947752669816],
              [-17.95167922248325, -7.241671659366286],
              [-17.949943671586155, -7.240213173110923],
              [-17.948116662043912, -7.240353431984722],
              [-17.948097663526582, -7.2383200460358506],
              [-17.947231225289112, -7.237065533162824],
              [-17.94486753905385, -7.236227929040137],
              [-17.943041661023436, -7.23479601054204],
              [-17.940392606297664, -7.232233967904437],
              [-17.934992079536656, -7.226330425284715],
              [-17.93193483803533, -7.223326448428573],
              [-17.926978508656912, -7.218000757914821],
              [-17.92229534779693, -7.213766968856537],
              [-17.920343079083903, -7.2116463927845],
              [-17.914604891882604, -7.207617660042589],
              [-17.90848366774283, -7.2024790145191595],
              [-17.899574657302015, -7.194031682221227],
              [-17.894950225960873, -7.18833672392153],
              [-17.89081270935864, -7.1840056303199304],
              [-17.889044109491085, -7.182368424880731],
              [-17.885641190273116, -7.180233620106491],
              [-17.88177730960286, -7.178581597842005],
              [-17.87635177533093, -7.175930355014404],
              [-17.862519291556463, -7.17082261850703],
              [-17.852005552302188, -7.167220314902163],
              [-17.84727178262468, -7.16543208298285],
              [-17.84199435526787, -7.163631970903978],
              [-17.835462359791176, -7.16115061401559],
              [-17.830971370368914, -7.159783586235139],
              [-17.824080310150645, -7.158719905423575],
              [-17.817443566773775, -7.158336657310362],
              [-17.81344712679504, -7.157577731544089],
              [-17.802617405693425, -7.154117869906266],
              [-17.790942928799264, -7.151528725230052],
              [-17.78466975495889, -7.151953720967182],
              [-17.782922905834063, -7.15267446022634],
              [-17.783981118696428, -7.153803310935669],
              [-17.78696423771014, -7.152416055000593],
              [-17.79047519762267, -7.15219937406106],
              [-17.79518796317636, -7.1539120637007585],
              [-17.796225522435805, -7.15393715891912],
              [-17.798846400854096, -7.155574567154086],
              [-17.803177055826097, -7.155653499030925],
              [-17.804858654591047, -7.156035178054253],
              [-17.808121354341047, -7.158041836865133],
              [-17.811027763180004, -7.159444842437287],
              [-17.813472866405643, -7.158463887169691],
              [-17.814656196014937, -7.158414668377066],
              [-17.81688082284979, -7.159373669098913],
              [-17.819184518951005, -7.158814816198718],
              [-17.82024640490568, -7.158999172527915],
              [-17.823157935445884, -7.160514755585111],
              [-17.82437173655427, -7.159413749341387],
              [-17.82618688881619, -7.1620963641279705],
              [-17.829568545036533, -7.161720445724747],
              [-17.83021370898615, -7.162639669045391],
              [-17.83272250488149, -7.162724077651367],
              [-17.833637419411588, -7.163157335571446],
              [-17.83591095636217, -7.162913831351071],
              [-17.837508475675914, -7.163665161996693],
              [-17.839794549588788, -7.163751825618483],
              [-17.844945338821358, -7.165550107243952],
              [-17.84612028056399, -7.16572286457054],
              [-17.848447653302234, -7.1668266616912915],
              [-17.84814560597198, -7.168976879660431],
              [-17.84156161733653, -7.169590716474819],
              [-17.8403400423935, -7.168836382239688],
              [-17.838835328710992, -7.169445852036968],
              [-17.834927267238886, -7.168860818236604],
              [-17.833854185213234, -7.167496255116448],
              [-17.831750857790368, -7.165653638388683],
              [-17.83036664173116, -7.169041687980998],
              [-17.82974926109433, -7.172052830680016],
              [-17.831267423599478, -7.172494139633743],
              [-17.830699124383926, -7.173814374800639],
              [-17.829041178199127, -7.173556482303003],
              [-17.827285605597883, -7.177787988130315],
              [-17.825848766711445, -7.179841146231237],
              [-17.831054947165676, -7.179099953992681],
              [-17.83447982216904, -7.1791485946704725],
              [-17.835883953760522, -7.17957216185578],
              [-17.83883768387616, -7.179687640749134],
              [-17.83982666202229, -7.180142662057978],
              [-17.8415696601314, -7.179859332725306],
              [-17.84298525695015, -7.180213973216541],
              [-17.84434032108808, -7.181385510491829],
              [-17.84619329660105, -7.180200342215102],
              [-17.84766818854921, -7.180416522148369],
              [-17.849888795173356, -7.1820513305924045],
              [-17.851176640286198, -7.182374865561733],
              [-17.853124622511608, -7.182019443944626],
              [-17.853745633905284, -7.183621944317019],
              [-17.853229818573087, -7.185902274981104],
              [-17.85386918847702, -7.189971410354031],
              [-17.852769205728737, -7.191806906599251],
              [-17.851224863851854, -7.1918902092912],
              [-17.849445032207058, -7.196449647209675],
              [-17.849111802569706, -7.198238739519461],
              [-17.846612233017495, -7.198423356030587],
              [-17.844970936829178, -7.196696885034388],
              [-17.84380340338816, -7.192984989428848],
              [-17.837125064201487, -7.198515691552512],
              [-17.83468509546873, -7.198568789449507],
              [-17.83354827665794, -7.1980427674078244],
              [-17.831288540194496, -7.19931201694457],
              [-17.828193541610585, -7.1996034372912625],
              [-17.82556292573875, -7.1990035071361484],
              [-17.823507994483794, -7.197852037451301],
              [-17.82222084369513, -7.197909640785422],
              [-17.819652031458617, -7.19535569583159],
              [-17.81892858081364, -7.195436959027021],
              [-17.81744220458258, -7.198204515385002],
              [-17.814826331668822, -7.1988844476803475],
              [-17.812799143454924, -7.1988060810390415],
              [-17.809589004478404, -7.19756425327684],
              [-17.808288945844527, -7.195901335842044],
              [-17.80747112503478, -7.193853578814711],
              [-17.80741409850113, -7.1917914207926446],
              [-17.80998113291408, -7.189388548515542],
              [-17.81303588889739, -7.188441058694762],
              [-17.816631211594444, -7.186505862178931],
              [-17.819086725644222, -7.186719966632043],
              [-17.820400962388053, -7.185035591243688],
              [-17.820483142431854, -7.180689760190749],
              [-17.820039359319296, -7.1805230275501994],
              [-17.814587994952635, -7.183772537835552],
              [-17.811272754464877, -7.18608188985495],
              [-17.806996444692253, -7.1882913035024805],
              [-17.80307825668449, -7.189510575643612],
              [-17.798035534472767, -7.1906950602395],
              [-17.78859534649695, -7.192350180571631],
              [-17.786938145178183, -7.192293341420745],
              [-17.782091919506502, -7.193346998343848],
              [-17.780827827936843, -7.193308017808421],
              [-17.776119214702046, -7.194327398551486],
              [-17.77419486779801, -7.1944753306254485],
              [-17.771514037017653, -7.19412517608478],
              [-17.76832121386332, -7.194083100316334],
              [-17.76522008011635, -7.193485977156853],
              [-17.762117214699057, -7.191694486572964],
              [-17.760551202754773, -7.191782265134559],
              [-17.75862525876301, -7.193317043305119],
              [-17.75567087386738, -7.1930677126958695],
              [-17.754038710926125, -7.192276751309052],
              [-17.751711896352734, -7.190297010373215],
              [-17.75020394949172, -7.190518163141945],
              [-17.748384090559583, -7.189083049938778],
              [-17.747741267214845, -7.19175183411446],
              [-17.746276785623493, -7.19238110668416],
              [-17.742381176610134, -7.192025401238782],
              [-17.7411130993547, -7.191348926085145],
              [-17.739427419033376, -7.1895427113948625],
              [-17.736031486715394, -7.186658512623346],
              [-17.733994139923922, -7.185633675382296],
              [-17.72922164468201, -7.18657996343292],
              [-17.72459235402661, -7.187088217486937],
              [-17.720245864281917, -7.18717275242013],
              [-17.71518580515552, -7.186652204342983],
              [-17.713815570201596, -7.186721586285814],
              [-17.708940907539187, -7.186111330137189],
              [-17.704323090943152, -7.18529317102233],
              [-17.698392325235112, -7.183850403132933],
              [-17.696242122920232, -7.183024921863709],
              [-17.68815390042819, -7.180423840547594],
              [-17.680529402490258, -7.177351394419894],
              [-17.67560647191291, -7.175052813520941],
              [-17.66682333733797, -7.170510922108442],
              [-17.66037910065426, -7.166330679239046],
              [-17.649066496681623, -7.158010049482249],
              [-17.647274001734925, -7.1570958090894115],
              [-17.642665566009878, -7.153346061384044],
              [-17.637453976830184, -7.14950217711914],
              [-17.63437606977418, -7.147507829588877],
              [-17.629136262249173, -7.143055232561123],
              [-17.62437504355789, -7.138456365181711],
              [-17.613400115465154, -7.126988615491744],
              [-17.607709643348326, -7.120554180420353],
              [-17.602559577462948, -7.1140202987946735],
              [-17.598692995127962, -7.108373482766848],
              [-17.590651879801154, -7.095783617037565],
              [-17.587250768018798, -7.090073524631872],
              [-17.584419344999723, -7.085806253328355],
              [-17.580151824328638, -7.080443950638369],
              [-17.574978112682064, -7.072583719689619],
              [-17.572187351056133, -7.068049092535987],
              [-17.56735168275775, -7.061332752615576],
              [-17.553478947256306, -7.043361016225156],
              [-17.548626183097696, -7.03669554719192],
              [-17.544338789614194, -7.032594389898497],
              [-17.529065348750397, -7.0201564816113216],
              [-17.526058605918564, -7.018173937111416],
              [-17.520041286163472, -7.015576051282917],
              [-17.520006086889108, -7.024308284936271],
              [-17.519768793680377, -7.0280465768796745],
              [-17.51937478005115, -7.029868874847055],
              [-17.5185569420249, -7.0299391037372985],
              [-17.517211397425818, -7.032637799940802],
              [-17.51671135664917, -7.034930690286493],
              [-17.51351927683137, -7.036989538055615],
              [-17.50892597578705, -7.03859524628779],
              [-17.50772801087743, -7.038406668513565],
              [-17.506202340824053, -7.037130875426997],
              [-17.505210894216066, -7.038821767576953],
              [-17.50429809132354, -7.041545015476029],
              [-17.502961899020896, -7.043572727900507],
              [-17.502590737480283, -7.045035520940843],
              [-17.50153672103466, -7.045060496287445],
              [-17.498214254141452, -7.047146526347584],
              [-17.494740507040234, -7.0481101416537015],
              [-17.490876077394162, -7.048115052757154],
              [-17.48949105418442, -7.046501977899411],
              [-17.484804496025344, -7.047687371858885],
              [-17.483107171301814, -7.048547016214912],
              [-17.48078709667714, -7.048831461447216],
              [-17.47807565915475, -7.0501250434003015],
              [-17.47671758325457, -7.050384788153191],
              [-17.473614688182238, -7.053275289438534],
              [-17.470763874098186, -7.0545846900430575],
              [-17.469889976380102, -7.054275351450785],
              [-17.465131677019, -7.056006100323501],
              [-17.465905107335264, -7.059210318687431],
              [-17.46682196070681, -7.059999052274352],
              [-17.46653143821403, -7.061655450114997],
              [-17.465122032399723, -7.061790248126875],
              [-17.463754531317882, -7.063701424998703],
              [-17.462161009086543, -7.06455498124076],
              [-17.46154486408676, -7.066378641154377],
              [-17.459814243497792, -7.068600157155638],
              [-17.462087637142243, -7.072350724850992],
              [-17.462117566720377, -7.0746379258095535],
              [-17.46413718750787, -7.075473130398192],
              [-17.464686134475517, -7.076314465501184],
              [-17.46701325969248, -7.076411061954647],
              [-17.466919117284384, -7.079081300436235],
              [-17.464598448892268, -7.080090128240249],
              [-17.458170152420088, -7.078633638871194],
              [-17.457301817829286, -7.077671137277429],
              [-17.456258679630686, -7.0777413544615895],
              [-17.455106163378815, -7.07555161076312],
              [-17.452635138026587, -7.07522127576773],
              [-17.451299327593443, -7.074220359954951],
              [-17.450619200447235, -7.072602478947848],
              [-17.449908940892108, -7.069491660898541],
              [-17.449606979583013, -7.065773546151157],
              [-17.448451955309785, -7.0657160967281225],
              [-17.447170162009044, -7.066493070230521],
              [-17.44651487456005, -7.069459629003902],
              [-17.445700259584584, -7.071691700335927],
              [-17.443785358330313, -7.074397244465104],
              [-17.442242184151677, -7.074752751020119],
              [-17.43943177336104, -7.074532219754382],
              [-17.43707329733958, -7.0737522058889395],
              [-17.43395460304854, -7.072290273900007],
              [-17.43209778240702, -7.072730212159166],
              [-17.42945170000544, -7.073982911398033],
              [-17.426918778308245, -7.072764876863296],
              [-17.42575488004196, -7.07346873866304],
              [-17.424681956485156, -7.076057320972023],
              [-17.422757515827332, -7.077654084253406],
              [-17.419793912342715, -7.0773651803922375],
              [-17.418279171393795, -7.076726758209273],
              [-17.41610338492626, -7.077131776598933],
              [-17.41384326767091, -7.078578872680268],
              [-17.412627251645837, -7.08001301503291],
              [-17.410891250971762, -7.081017486097447],
              [-17.4088555157885, -7.081586697702076],
              [-17.406728488629412, -7.083536741978311],
              [-17.407146022005396, -7.085466614945619],
              [-17.407199427851058, -7.0923313840807785],
              [-17.406188889787188, -7.0953698255600655],
              [-17.403841898515363, -7.099557141507312],
              [-17.401166994096744, -7.1061471199374795],
              [-17.400825745859233, -7.109109219143784],
              [-17.40092980845948, -7.110844749955578],
              [-17.402007504231374, -7.113867607018989],
              [-17.403300544956213, -7.114819636578146],
              [-17.40359120687698, -7.116029722521366],
              [-17.404841411398564, -7.118082223978835],
              [-17.40685917940592, -7.118664003934155],
              [-17.40910286574739, -7.1199992458346495],
              [-17.41007207859866, -7.121207430059087],
              [-17.410675018068353, -7.123839771780732],
              [-17.4112362964715, -7.12474360727668],
              [-17.413469972498852, -7.123314119496292],
              [-17.41541510944759, -7.124223466151975],
              [-17.417214256676814, -7.1275747672992775],
              [-17.41818043649652, -7.128573786797432],
              [-17.418157100666537, -7.13039780723654],
              [-17.418991673900784, -7.131098898618671],
              [-17.42218196793972, -7.130782658483876],
              [-17.423651423556684, -7.131926231797015],
              [-17.424857477965936, -7.135020474242042],
              [-17.425151463741084, -7.1379544407244016],
              [-17.425017733812034, -7.140270282329786],
              [-17.427221762611556, -7.1439601653021265],
              [-17.428533976951297, -7.143229272200351],
              [-17.43085207168919, -7.142787214244011],
              [-17.4341803140324, -7.143803570559463],
              [-17.436067913853847, -7.148909933776504],
              [-17.437840301870164, -7.151271330486781],
              [-17.439917973058353, -7.148607780289425],
              [-17.442727173310438, -7.147819572654255],
              [-17.444897597039947, -7.148495873213544],
              [-17.450428408536084, -7.149181787000527],
              [-17.453176966387712, -7.148852108782734],
              [-17.45545438178921, -7.1497163568784865],
              [-17.457865829759665, -7.149083477408192],
              [-17.460213642420428, -7.150298887063324],
              [-17.460691196471643, -7.151977143495145],
              [-17.461836242425978, -7.151176920818906],
              [-17.46632827992364, -7.150567828973313],
              [-17.467746858288546, -7.151757361351075],
              [-17.466464550813598, -7.154760256933482],
              [-17.462587509172867, -7.154983860852756],
              [-17.461788029345513, -7.15382490613856],
              [-17.45897484855805, -7.154527413189739],
              [-17.457423712662894, -7.160215887042004],
              [-17.456904830722525, -7.1637669018547845],
              [-17.45699093565556, -7.1657046769490265],
              [-17.45625304498367, -7.166148797197657],
              [-17.456101757609026, -7.168067828227777],
              [-17.45769317086682, -7.169156633795933],
              [-17.458703400768265, -7.168505822594545],
              [-17.460273187446784, -7.169779954906306],
              [-17.460267750133045, -7.172343171819087],
              [-17.457762887487835, -7.1733166475230155],
              [-17.454399721753827, -7.172609689936212],
              [-17.45436407926773, -7.174223067383529],
              [-17.45312021181697, -7.175489067300396],
              [-17.452253532798256, -7.178701323827885],
              [-17.45186211691879, -7.183410529922784],
              [-17.450975028338473, -7.185978543348645],
              [-17.451468706659654, -7.189024533185318],
              [-17.453236176897356, -7.190762595917283],
              [-17.452452880438795, -7.193078910118909],
              [-17.44574264254439, -7.195697263085413],
              [-17.443183062994777, -7.196047012433096],
              [-17.439793651144484, -7.1956891808169],
              [-17.43760797607044, -7.194409000022393],
              [-17.43531765085738, -7.195412372481029],
              [-17.43327786965891, -7.1958907938761865],
              [-17.428557985046265, -7.19482058696849],
              [-17.425517724413453, -7.194408184933096],
              [-17.423850701829497, -7.191467494324999],
              [-17.42242107496813, -7.191768582817693],
              [-17.420721111423113, -7.191320645898306],
              [-17.42004246375745, -7.194293923720088],
              [-17.420078821751975, -7.195738151065205],
              [-17.418897360975397, -7.197067366314676],
              [-17.416711932902714, -7.197916877633761],
              [-17.41422034938771, -7.1982558404938946],
              [-17.413265087326877, -7.197455890059499],
              [-17.414127097075124, -7.1950082252173075],
              [-17.413406929394974, -7.19180402517556],
              [-17.41370082369593, -7.188974977976189],
              [-17.414752611661648, -7.18806204569272],
              [-17.414440751244506, -7.186718774717612],
              [-17.41314638296954, -7.187398562646423],
              [-17.412628251931167, -7.18904039512726],
              [-17.410233512617594, -7.1915612754835525],
              [-17.40620864256066, -7.190701080024978],
              [-17.402784954601444, -7.187427907563075],
              [-17.400042660347104, -7.187648104662346],
              [-17.398991688149735, -7.185566369054235],
              [-17.399668204262365, -7.1827984250386985],
              [-17.39896160785825, -7.179268618320153],
              [-17.399215152709807, -7.1787737508855205],
              [-17.39914766937853, -7.17454544169048],
              [-17.399733840773433, -7.169684636103033],
              [-17.40215239321496, -7.160486859337136],
              [-17.402001637861837, -7.15815721671006],
              [-17.40086846765735, -7.15781354557869],
              [-17.39691980486079, -7.157664120946176],
              [-17.393510121018995, -7.15483985932318],
              [-17.390908310137405, -7.151379848656561],
              [-17.389455510456603, -7.150291561943524],
              [-17.38907567086119, -7.148746977377892],
              [-17.387012038869198, -7.146948154333521],
              [-17.385814175224574, -7.145381702886396],
              [-17.385545994315, -7.143165226265229],
              [-17.384708599257536, -7.140895625516067],
              [-17.383663060136417, -7.139931621558419],
              [-17.38007448493349, -7.13859805103292],
              [-17.37564167957046, -7.135822110879207],
              [-17.371592238891097, -7.134100907337042],
              [-17.370252087333792, -7.138668245935921],
              [-17.36791132567149, -7.14394121432118],
              [-17.366445491971657, -7.1464131616555875],
              [-17.365034808594242, -7.147398750255362],
              [-17.363321468780168, -7.146994941624521],
              [-17.36173911627607, -7.14536616048823],
              [-17.360923377935933, -7.143145639606564],
              [-17.360061102820833, -7.138246982336055],
              [-17.36054243282168, -7.134116409686757],
              [-17.36287222522598, -7.128907525717298],
              [-17.36397693713394, -7.12724916881228],
              [-17.36576072123185, -7.1260142896358545],
              [-17.36769377495752, -7.122301662708609],
              [-17.369360691670234, -7.1199983995986],
              [-17.372399256596317, -7.11771620946514],
              [-17.371384005163915, -7.113757625646477],
              [-17.37008939635184, -7.11175491511192],
              [-17.366750815565897, -7.108914424391191],
              [-17.36517075209037, -7.1085511105902],
              [-17.36130391376103, -7.106072227326474],
              [-17.358872204075453, -7.103502560082915],
              [-17.35806383174339, -7.1053967572813335],
              [-17.356558086579014, -7.111707743261951],
              [-17.355381627098858, -7.11478732313073],
              [-17.353042390615858, -7.116134285816446],
              [-17.350193449737795, -7.115932146763399],
              [-17.34964807105591, -7.11467207520039],
              [-17.349048888561846, -7.110928648658564],
              [-17.349095741156564, -7.104394014972892],
              [-17.349799548545956, -7.101081658041589],
              [-17.350790772540474, -7.099317507600701],
              [-17.354248202165316, -7.0967300531290665],
              [-17.353562266657914, -7.0954801474386],
              [-17.35138582220339, -7.095975826023311],
              [-17.350227076439435, -7.094565407752862],
              [-17.351581584658476, -7.092818205133934],
              [-17.35216980959441, -7.090098345361583],
              [-17.349463304300563, -7.087902161413204],
              [-17.342664548154413, -7.0928212508716335],
              [-17.341108984062444, -7.093769998788107],
              [-17.334636921885018, -7.098662223876501],
              [-17.331513349208127, -7.100511708721195],
              [-17.32713900709541, -7.104174541926539],
              [-17.32056130379562, -7.110428777150131],
              [-17.31807105460078, -7.11221069745198],
              [-17.31342669161722, -7.116501741168369],
              [-17.298109514365287, -7.133316683501668],
              [-17.296299209534507, -7.1351438475082025],
              [-17.295647215386474, -7.136514601765458],
              [-17.292611553570747, -7.140927015526364],
              [-17.291362679568905, -7.143933130856765],
              [-17.29064374872821, -7.1474093852771885],
              [-17.291499840552646, -7.146981205992208],
              [-17.292702751476313, -7.144999180567783],
              [-17.29395849462392, -7.1459085823881905],
              [-17.295110138249505, -7.147528613317934],
              [-17.296157332671015, -7.149807438496446],
              [-17.29693680398947, -7.153063455438077],
              [-17.297385424247754, -7.1594852689428174],
              [-17.296609725446288, -7.165714560304818],
              [-17.29649651718001, -7.1686178891641],
              [-17.296673198339946, -7.1725760099913],
              [-17.297211212987868, -7.173574736328812],
              [-17.296136445203366, -7.179458631050348],
              [-17.295324335447248, -7.180330408473427],
              [-17.296032496249786, -7.181619960415458],
              [-17.295665929889743, -7.184188989695115],
              [-17.296462976642694, -7.186007745042795],
              [-17.29601579636432, -7.189072353348868],
              [-17.29554924321484, -7.189748872713195],
              [-17.29391671480929, -7.194346497858669],
              [-17.292860107381706, -7.1947796725716335],
              [-17.29391697514142, -7.197527754833462],
              [-17.29151865015521, -7.201075984760248],
              [-17.28989795018717, -7.200983103209131],
              [-17.289046666899903, -7.199345460382647],
              [-17.28695749092918, -7.199972032522814],
              [-17.285139876728003, -7.199641525271611],
              [-17.283682200415278, -7.198883209419891],
              [-17.28257044039371, -7.200515898083224],
              [-17.279058714553234, -7.2005077195346],
              [-17.278690919814938, -7.199820457091252],
              [-17.272956958374078, -7.19823925808978],
              [-17.27046746048212, -7.198605615362527],
              [-17.26598483199593, -7.198268559842107],
              [-17.2634207839522, -7.199160060759278],
              [-17.26157974630821, -7.201032128470536],
              [-17.256921172163945, -7.202299254165177],
              [-17.25527653827867, -7.203154836871759],
              [-17.251799466666483, -7.20746792523204],
              [-17.251279713490696, -7.210843484343833],
              [-17.252598321362058, -7.2120879478677535],
              [-17.252720395031126, -7.214101144055277],
              [-17.255573220181397, -7.214761926881233],
              [-17.254459398558662, -7.216149034978733],
              [-17.251616987132902, -7.217535514715673],
              [-17.249224671660926, -7.21771613087392],
              [-17.246735375237396, -7.2194458034240565],
              [-17.24512898246542, -7.219430290513945],
              [-17.241472366945647, -7.217722577176705],
              [-17.237983478872412, -7.214936265671654],
              [-17.234245418186614, -7.212256556627373],
              [-17.23116644594394, -7.208685742861166],
              [-17.2283275511465, -7.204836905680691],
              [-17.225324046135718, -7.202528560128712],
              [-17.22403947978402, -7.2001937985429425],
              [-17.222037949791552, -7.194842631047121],
              [-17.21944945259863, -7.18898041039123],
              [-17.218494070152033, -7.187366011011058],
              [-17.21780832219387, -7.184187173721276],
              [-17.218707158237226, -7.182735830187861],
              [-17.21334939863745, -7.1810260123071155],
              [-17.21132796700637, -7.18055765969307],
              [-17.204966012980854, -7.179684716426668],
              [-17.20120693108954, -7.179475697960762],
              [-17.19660151554082, -7.178508455604716],
              [-17.190614344723507, -7.178590221004668],
              [-17.187865539798093, -7.179806483638639],
              [-17.184923738061183, -7.180492626736427],
              [-17.182989056897398, -7.18028405648589],
              [-17.18200522342762, -7.179460419767611],
              [-17.180276623595397, -7.179753668491771],
              [-17.172420097886086, -7.180127511041061],
              [-17.168117160622568, -7.180084064960068],
              [-17.16313566729323, -7.179583516151804],
              [-17.15570434194726, -7.177485762764469],
              [-17.15060288795723, -7.175232364861249],
              [-17.145743711817, -7.172714598242024],
              [-17.140856770214423, -7.169191679489714],
              [-17.137936433360718, -7.167945823387088],
              [-17.135939061728706, -7.167514037666346],
              [-17.13164686328862, -7.167160588325866],
              [-17.129457163071233, -7.167701259329941],
              [-17.126579882003323, -7.167612866751578],
              [-17.122205512650506, -7.168216391811583],
              [-17.117223643481697, -7.169442560670934],
              [-17.114703023967213, -7.169658027839366],
              [-17.113171060218484, -7.170235724151399],
              [-17.11345895854487, -7.171304653829708],
              [-17.11209911025367, -7.173647822668463],
              [-17.108729615310608, -7.175593351439413],
              [-17.105122868392005, -7.176569496591396],
              [-17.103749266488176, -7.176270788975616],
              [-17.099406622434554, -7.177061339657],
              [-17.097446767637464, -7.178536213718744],
              [-17.096403964921066, -7.180105947511367],
              [-17.097257255262914, -7.180728024233145],
              [-17.09611409120929, -7.184942710116347],
              [-17.092496483982774, -7.190257730367192],
              [-17.091074117777822, -7.191041550383059],
              [-17.088289895398177, -7.191509951698903],
              [-17.086273175696654, -7.19116972186513],
              [-17.085403939669426, -7.189101309512033],
              [-17.085080829447, -7.1869240570930915],
              [-17.08256910656834, -7.181757666575408],
              [-17.0824666933839, -7.179758501346568],
              [-17.078045832134983, -7.180761174549419],
              [-17.076425533845438, -7.182423876718651],
              [-17.07534182619468, -7.181543333643372],
              [-17.074385972554825, -7.179832067847868],
              [-17.072444928663614, -7.179684740109727],
              [-17.06922789523278, -7.180709917248476],
              [-17.065216231653952, -7.180668475912752],
              [-17.062770716050114, -7.180353853880075],
              [-17.061624830450512, -7.179205792207596],
              [-17.059142348486766, -7.179338748450254],
              [-17.05497594612614, -7.181921247632211],
              [-17.049193017434387, -7.1837387977846205],
              [-17.048452162774655, -7.184436710033357],
              [-17.045253124646873, -7.185317092400233],
              [-17.04270536467021, -7.185719682712428],
              [-17.03764158247743, -7.18699245773431],
              [-17.035222790932746, -7.188378173628805],
              [-17.033250475822722, -7.190847349450776],
              [-17.03116361274299, -7.191710576113096],
              [-17.02786663548744, -7.192245917636889],
              [-17.02514083533612, -7.193640397033248],
              [-17.023499212244296, -7.195030638952001],
              [-17.01717832515892, -7.196961553599362],
              [-17.015788411042685, -7.198264529383255],
              [-17.01358329686022, -7.201258261033654],
              [-17.012793179538214, -7.203573998665065],
              [-17.013095511130164, -7.2058006483896255],
              [-17.014764999416787, -7.207117936511053],
              [-17.0192808122829, -7.2077055472762686],
              [-17.020445896831603, -7.208068089695055],
              [-17.023954306534517, -7.210298976863496],
              [-17.025797405341155, -7.213151647801638],
              [-17.0279819724536, -7.2186954462872155],
              [-17.03007936184437, -7.223175658355895],
              [-17.03122294224865, -7.227091153452725],
              [-17.03242796279932, -7.230164841150071],
              [-17.033176080612275, -7.2288361222828605],
              [-17.03519465265551, -7.227711835483119],
              [-17.035974870870223, -7.229063912201892],
              [-17.039067025765785, -7.230510934552702],
              [-17.03806584253077, -7.231901219267446],
              [-17.035729003711513, -7.232245721974162],
              [-17.034305438383164, -7.235374139370301],
              [-17.036074752474704, -7.236484589778598],
              [-17.036608369974093, -7.238206662964996],
              [-17.03811942187892, -7.239003737750023],
              [-17.039611873225727, -7.242940001525666],
              [-17.041118940984727, -7.243362642558207],
              [-17.04402867687728, -7.242862899983405],
              [-17.045629911284777, -7.2438942821668375],
              [-17.045495434383454, -7.246671756771626],
              [-17.04405719435106, -7.252968486449325],
              [-17.043668079163947, -7.2563457041348025],
              [-17.043426947073918, -7.262463498493908],
              [-17.041831443550173, -7.263244633984299],
              [-17.041086867793265, -7.264610406286285],
              [-17.039646537928384, -7.268782265718931],
              [-17.038560082208924, -7.2710705718311],
              [-17.037252345884472, -7.272100333361406],
              [-17.034464908420617, -7.271926622045812],
              [-17.029399648331797, -7.275443029421188],
              [-17.02770467896416, -7.274971230813176],
              [-17.025897095201902, -7.273394685483034],
              [-17.025619961485834, -7.271548771461458],
              [-17.022101301315057, -7.274560979071658],
              [-17.01999804480736, -7.275989974050988],
              [-17.015015652400677, -7.277697058290873],
              [-17.009624608334438, -7.278909134456121],
              [-17.007786750194107, -7.278509492624983],
              [-17.005321121087213, -7.277352487872959],
              [-17.003063512058045, -7.276846173914131],
              [-16.997237569025774, -7.278710934871321],
              [-16.994527602332813, -7.28013882775441],
              [-16.995518207526974, -7.281499093330569],
              [-16.995868299255527, -7.285451960836925],
              [-16.997545630494425, -7.284611742059277],
              [-16.99954562185628, -7.286284301463576],
              [-17.000046562099392, -7.284589038549425],
              [-17.002019644208247, -7.2837562825457045],
              [-17.00367960319066, -7.284489283516776],
              [-17.004173021569382, -7.2835206775767105],
              [-17.006799888942417, -7.282005811899514],
              [-17.008547788484048, -7.28167994829794],
              [-17.01134146879824, -7.280125335340908],
              [-17.013200647028533, -7.2797582488614605],
              [-17.015108941932873, -7.281758827942972],
              [-17.017874756551098, -7.283943754305041],
              [-17.020435429880315, -7.282691605248065],
              [-17.022273623061885, -7.282590714267691],
              [-17.0250784955563, -7.283334731368837],
              [-17.026106432814945, -7.284006202716564],
              [-17.028584793647063, -7.282601694930063],
              [-17.03070905066915, -7.2823446117682415],
              [-17.03442821715732, -7.282676769703623],
              [-17.036688186168725, -7.283806861427985],
              [-17.03744737837201, -7.285442829256745],
              [-17.038982383138688, -7.282932864838334],
              [-17.04007266618294, -7.282205195196464],
              [-17.04163243168978, -7.283115353594383],
              [-17.04566384379334, -7.281553509307095],
              [-17.04899306200205, -7.281022982790978],
              [-17.052194800549696, -7.283675338465145],
              [-17.05306585246818, -7.28579305100308],
              [-17.054323450801405, -7.2870583249835175],
              [-17.054413524596786, -7.288109869046856],
              [-17.053529588916522, -7.2904065682714165],
              [-17.050856632322564, -7.294308602338996],
              [-17.049246674945486, -7.295485947281535],
              [-17.046337931966995, -7.295299920946061],
              [-17.04183879528608, -7.293593947923167],
              [-17.040471229189937, -7.291635752982307],
              [-17.039319783473154, -7.290720207474173],
              [-17.036660916871064, -7.291384665303473],
              [-17.0356854222062, -7.290809386937044],
              [-17.034020645801377, -7.291267860273951],
              [-17.031613058216536, -7.29088626095185],
              [-17.02861503204564, -7.290861397996089],
              [-17.02948609689929, -7.293986929050291],
              [-17.025683259789542, -7.294512360784219],
              [-17.024442913339414, -7.292702203705484],
              [-17.021338419982904, -7.29299770083975],
              [-17.01811307844194, -7.293618031079729],
              [-17.016993069336, -7.294262826658806],
              [-17.014047183114066, -7.294427580093674],
              [-17.01077878971323, -7.291389083108454],
              [-17.009288474838826, -7.291092778999629],
              [-17.008422784346422, -7.290193695294015],
              [-17.007197266293286, -7.290550989298815],
              [-17.003692873564923, -7.290507948825362],
              [-17.00231608615446, -7.290122259774135],
              [-16.999501992441424, -7.29220902847768],
              [-16.997336381380947, -7.290826762626876],
              [-16.993852553958973, -7.291992954981459],
              [-16.992487877732884, -7.290807920545234],
              [-16.99147553277477, -7.289202039767739],
              [-16.991127991134082, -7.286646487622364],
              [-16.986632476362214, -7.286028433812288],
              [-16.985728424807537, -7.285099485886356],
              [-16.983726144386676, -7.28588689220744],
              [-16.981947889246978, -7.285819397716047],
              [-16.98012395175257, -7.287661959550593],
              [-16.978179100662576, -7.288382746572713],
              [-16.975673828046133, -7.288048510340121],
              [-16.974542255580378, -7.287191426720103],
              [-16.973278846323403, -7.2882426279097485],
              [-16.971880584898372, -7.288642497223674],
              [-16.970179009321534, -7.28837260174529],
              [-16.968117774710294, -7.289918660493346],
              [-16.96636531700928, -7.290418492025083],
              [-16.96349143910252, -7.289677891422648],
              [-16.961233596185277, -7.289609744106783],
              [-16.959777084039416, -7.2891370346868385],
              [-16.957805014953166, -7.287683194013164],
              [-16.95469101534709, -7.2869854363921815],
              [-16.952747893554683, -7.287578933832147],
              [-16.95236541028242, -7.288818799190099],
              [-16.95433024302891, -7.290058262308937],
              [-16.955642719228027, -7.291773987738844],
              [-16.95557941396521, -7.293200923420375],
              [-16.956387399080125, -7.293565359368995],
              [-16.957432389513176, -7.295272483870873],
              [-16.957463537254846, -7.296433665552513],
              [-16.958398567445133, -7.29723394950509],
              [-16.96138960726849, -7.302556664251017],
              [-16.961438734074566, -7.304043414104821],
              [-16.963162997202666, -7.305005145159775],
              [-16.960691437417566, -7.308410878266056],
              [-16.95861135824638, -7.308314350397463],
              [-16.956343140103222, -7.305169967265924],
              [-16.95472895432883, -7.307195902865438],
              [-16.95734248321976, -7.309095004472165],
              [-16.958729452229, -7.30957401603862],
              [-16.96052501027518, -7.310972311284416],
              [-16.961966685751385, -7.310681825004586],
              [-16.96429613271416, -7.310974641511734],
              [-16.964688387229756, -7.311541931407719],
              [-16.96671896665428, -7.311445880151683],
              [-16.967747033474907, -7.312087407020047],
              [-16.970132152484606, -7.314611811869117],
              [-16.971091695963274, -7.31388496267896],
              [-16.974506679582515, -7.314412254986869],
              [-16.97679080926204, -7.315282018377218],
              [-16.977698621217552, -7.317029508136164],
              [-16.980905527696482, -7.321160634384197],
              [-16.97995509785623, -7.322460909758365],
              [-16.97942067140513, -7.325069658923345],
              [-16.97613073601389, -7.326268667926168],
              [-16.974408210687887, -7.329227502601809],
              [-16.971515211401346, -7.330285621229818],
              [-16.968249891976118, -7.328811177054897],
              [-16.965467890422463, -7.328721267862927],
              [-16.964473801636107, -7.328311443810557],
              [-16.958187180473693, -7.328047699071176],
              [-16.955142621352646, -7.328989271403817],
              [-16.9523943506909, -7.328847918457767],
              [-16.9511349910961, -7.3294644267174345],
              [-16.948257593353585, -7.328097872681684],
              [-16.946236324169917, -7.32765043466633],
              [-16.944115622104412, -7.328478313212935],
              [-16.941243571886268, -7.32825755823403],
              [-16.938807441097158, -7.326386706774846],
              [-16.93530525112404, -7.3261374359277855],
              [-16.933935156712202, -7.326553367963547],
              [-16.932616856218424, -7.327777450195382],
              [-16.931125009993206, -7.328011976546924],
              [-16.92950365351898, -7.327454703109789],
              [-16.926855487490617, -7.330074680389794],
              [-16.924192168574457, -7.330521076240746],
              [-16.922515008550317, -7.330350086268626],
              [-16.920451114086546, -7.33151341285973],
              [-16.907561941110508, -7.335458183552234],
              [-16.901997123198832, -7.338005875471862],
              [-16.895453033880315, -7.347381669465071],
              [-16.88991598948326, -7.3468798796576245],
              [-16.886838793630357, -7.345526020817819],
              [-16.883578999908313, -7.345115647122956],
              [-16.882221421811497, -7.340297417695445],
              [-16.876697867127326, -7.336389296155935],
              [-16.872412720224958, -7.327506198642879],
              [-16.86936845340646, -7.325341562433148],
              [-16.867916677123524, -7.322707946569173],
              [-16.86573420868912, -7.319624105613211],
              [-16.862709588719436, -7.318441067270725],
              [-16.86144416990518, -7.31621868163803],
              [-16.85587291094129, -7.31550307145973],
              [-16.852627631192192, -7.317304486495371],
              [-16.849939922556814, -7.318350742521601],
              [-16.846287041861803, -7.317500608007266],
              [-16.841910123053967, -7.314039970486843],
              [-16.83663491703307, -7.314462110561373],
              [-16.831162289382096, -7.318801744537452],
              [-16.827460306184598, -7.313332782586838],
              [-16.827282007082307, -7.308448924466587],
              [-16.822247917450206, -7.306977902798573],
              [-16.813380564681413, -7.305577499014674],
              [-16.810394480467455, -7.305693318520079],
              [-16.80748995262443, -7.309603033504979],
              [-16.801575518095046, -7.311322952729698],
              [-16.797507121134984, -7.313002853351539],
              [-16.79246213917532, -7.319947231443987],
              [-16.793662612715615, -7.32351118489612],
              [-16.79018261987428, -7.329842322093578],
              [-16.787719866950177, -7.329454558528168],
              [-16.783774491793075, -7.3273172201828585],
              [-16.779618161274676, -7.324077137690351],
              [-16.77822264863154, -7.32398930412974],
              [-16.77776000203214, -7.322995849106997],
              [-16.775951710878335, -7.322204423358254],
              [-16.77480861116662, -7.322415627144123],
              [-16.770777036323206, -7.3201051482072685],
              [-16.768137490960953, -7.320824569009226],
              [-16.76398505685589, -7.320067769850564],
              [-16.760563444965136, -7.321289368331626],
              [-16.75968841469947, -7.320257109537108],
              [-16.756770127644746, -7.317980257426099],
              [-16.75436977275562, -7.315448415594995],
              [-16.75322748868935, -7.3148819519233275],
              [-16.750636744014592, -7.311471723147215],
              [-16.74315389127124, -7.303690397413299],
              [-16.741461025349864, -7.301450795386855],
              [-16.736494287748204, -7.296118945439825],
              [-16.73452449021145, -7.29469707769823],
              [-16.733010420505185, -7.291793516914377],
              [-16.729986211673097, -7.295274790477078],
              [-16.7287170538304, -7.295562712789987],
              [-16.72820565208509, -7.2972040460947785],
              [-16.726264950616244, -7.298364774556358],
              [-16.724662378177364, -7.297540784444994],
              [-16.722332917034056, -7.299404055881736],
              [-16.721667946134062, -7.299145450306781],
              [-16.72039358645057, -7.296345602990718],
              [-16.71801832291522, -7.295226297914753],
              [-16.71670062689787, -7.293558915411182],
              [-16.71530148749012, -7.2927275429980085],
              [-16.713737911569037, -7.294037957479652],
              [-16.712280685331635, -7.293754876336922],
              [-16.710696491586226, -7.292813863552817],
              [-16.70886839703979, -7.290868202847255],
              [-16.70738869486668, -7.292288576429105],
              [-16.703459629014265, -7.293395396200113],
              [-16.70036746189336, -7.294037079520101],
              [-16.69907803608882, -7.294767967055233],
              [-16.697179823855812, -7.294451578852042],
              [-16.695546041323226, -7.293308663531216],
              [-16.692958837825714, -7.292755335537484],
              [-16.69099394364843, -7.290291547488581],
              [-16.68815116591727, -7.288873702470883],
              [-16.68598266219002, -7.28691854054343],
              [-16.685363984913316, -7.286834604410849],
              [-16.684505221602905, -7.288861079467461],
              [-16.683104399171906, -7.289780374894003],
              [-16.68123470477463, -7.29196870599112],
              [-16.67985380633856, -7.295175322006197],
              [-16.67580324045027, -7.296149789980084],
              [-16.673342226629305, -7.294943943718582],
              [-16.6697969548697, -7.290879324096354],
              [-16.66851073714655, -7.291525807365923],
              [-16.66715704793728, -7.2936272115287],
              [-16.666256798160223, -7.294137342536695],
              [-16.663160656860406, -7.294820601703154],
              [-16.66078903258254, -7.294444284339559],
              [-16.658841879584838, -7.29315349484626],
              [-16.657953150782163, -7.293995953447917],
              [-16.653860542580475, -7.295166716348213],
              [-16.650754116435486, -7.295228841897216],
              [-16.64896117494104, -7.294082487528819],
              [-16.64825160531086, -7.295627092868013],
              [-16.646902945255746, -7.296764856992884],
              [-16.645248879215217, -7.299011433889259],
              [-16.641806880023257, -7.300325220264446],
              [-16.638055530429707, -7.301360524665636],
              [-16.636319778903243, -7.3013167445474485],
              [-16.631869106734264, -7.304665303335647],
              [-16.63017023790441, -7.307748189506421],
              [-16.627239414781524, -7.3104549493227164],
              [-16.625840806955324, -7.310322664709916],
              [-16.623293712856402, -7.314316561720557],
              [-16.62133997900538, -7.31508012817311],
              [-16.617145923085367, -7.313541096898216],
              [-16.611956071184963, -7.314824689600176],
              [-16.610142490104856, -7.315455005862813],
              [-16.608535401016407, -7.316731435461729],
              [-16.60795953444582, -7.317980139460433],
              [-16.60499743245134, -7.319333547998896],
              [-16.602158247697894, -7.3197779993440575],
              [-16.59940805242314, -7.317627385329577],
              [-16.596872811275546, -7.316407181170877],
              [-16.594217851579284, -7.315762543552954],
              [-16.59225931677844, -7.317915220642066],
              [-16.590174393052568, -7.3180270916635095],
              [-16.58565976651314, -7.317177838723323],
              [-16.584583778176814, -7.3193414754678034],
              [-16.5827758902815, -7.321515966262971],
              [-16.580825084377818, -7.321127169612804],
              [-16.579778985830373, -7.319810542842686],
              [-16.578020118791255, -7.319603284524188],
              [-16.57578160209203, -7.322938546943975],
              [-16.574059809460156, -7.324346142021244],
              [-16.57277574751373, -7.326678101727684],
              [-16.570610609546083, -7.325617635418567],
              [-16.56811169776648, -7.327379839474897],
              [-16.5662334930358, -7.328137475350502],
              [-16.563523137620695, -7.331594911502566],
              [-16.561428173470876, -7.338129289313528],
              [-16.561592808595268, -7.339742502240078],
              [-16.563552605818884, -7.343127778008317],
              [-16.5638780495933, -7.3445734285271165],
              [-16.56352009333841, -7.346586970094088],
              [-16.563659355289005, -7.348513062268822],
              [-16.562399856026683, -7.3488309303534445],
              [-16.5612996587824, -7.347175341860725],
              [-16.55991683053764, -7.346743732717547],
              [-16.55794054461909, -7.348611438593953],
              [-16.55534838807223, -7.348689314181612],
              [-16.553681263730333, -7.349847499073768],
              [-16.55160095445508, -7.350008446517863],
              [-16.547641260437203, -7.349344801581738],
              [-16.543312134787126, -7.345720450984243],
              [-16.536761401631242, -7.338395367741639],
              [-16.535849167109, -7.336283925646534],
              [-16.533781214055264, -7.336296360886954],
              [-16.534152437608746, -7.338866502923831],
              [-16.533773652008673, -7.342401708536636],
              [-16.533292934254906, -7.343860879341779],
              [-16.533024798775102, -7.347215739139961],
              [-16.531944604544865, -7.348745628879704],
              [-16.529072204246, -7.350692637028999],
              [-16.526887480431522, -7.3509750560518325],
              [-16.525699278190096, -7.349767319028154],
              [-16.525841022174024, -7.348337920055289],
              [-16.524523010607275, -7.34590713131448],
              [-16.52427758364408, -7.344273615794497],
              [-16.52352634554512, -7.343241593509384],
              [-16.52362060529355, -7.341983976402902],
              [-16.522073244934653, -7.339529305380254],
              [-16.520832582889042, -7.339477723703089],
              [-16.52028558485863, -7.338392201739318],
              [-16.522383130960332, -7.3357785836118605],
              [-16.52042215197747, -7.333796888859349],
              [-16.5192732957528, -7.333640545369183],
              [-16.517086107904053, -7.335501133462701],
              [-16.51781481509422, -7.336940199224298],
              [-16.516626215527832, -7.337792098925859],
              [-16.51247372770118, -7.338798897470505],
              [-16.510760030285617, -7.339536921143837],
              [-16.508053582793227, -7.3425031393955065],
              [-16.507291082205917, -7.3441060387137655],
              [-16.50511838425942, -7.3440342189995205],
              [-16.50157111465939, -7.34456413491817],
              [-16.50044119155511, -7.345305397145404],
              [-16.498089458783802, -7.3446533556330635],
              [-16.497303266964074, -7.346055322194413],
              [-16.49925881027427, -7.34740699722638],
              [-16.497992531521078, -7.348846354116233],
              [-16.494732753230856, -7.347584681551066],
              [-16.49342610972509, -7.345936268693056],
              [-16.49263484264619, -7.34612335212108],
              [-16.49330693808431, -7.3480784305582105],
              [-16.49298310719201, -7.349010770058233],
              [-16.493513274977325, -7.35284361705184],
              [-16.49295328192732, -7.356025151762439],
              [-16.489394358171158, -7.356888212424957],
              [-16.488258363919815, -7.355701088300657],
              [-16.484123137517805, -7.354549096999283],
              [-16.481545989133263, -7.352443199941262],
              [-16.480144615909307, -7.350810246114054],
              [-16.479889894301287, -7.349309715502063],
              [-16.480514419193963, -7.347766008268141],
              [-16.479716606805773, -7.347287992504911],
              [-16.47848422515861, -7.349099510803227],
              [-16.479652998250113, -7.352924967650097],
              [-16.479057891402814, -7.3558769479321775],
              [-16.47938607303874, -7.3593923987269685],
              [-16.48058151425389, -7.362075467794315],
              [-16.480635725740875, -7.363591478030296],
              [-16.48474989241429, -7.364794010526516],
              [-16.484845857823995, -7.366503108945525],
              [-16.482464915184703, -7.368157958439647],
              [-16.481316227116427, -7.369766842816295],
              [-16.479985902469256, -7.3701393464916904],
              [-16.478380693318016, -7.369258077798509],
              [-16.47772626167308, -7.370852907019755],
              [-16.47612234262283, -7.372742131605159],
              [-16.472173158432923, -7.371404304365054],
              [-16.47041057323283, -7.372324787450357],
              [-16.468358377013338, -7.374498004986384],
              [-16.4637670467665, -7.3769922627171125],
              [-16.46268438593537, -7.375695237445848],
              [-16.456199029485983, -7.375403922905613],
              [-16.453968081803637, -7.376118847253655],
              [-16.45239563491586, -7.3746582261948745],
              [-16.449741218323588, -7.375864256818359],
              [-16.44855336806899, -7.375777412673019],
              [-16.44633703651336, -7.3738395417914235],
              [-16.442185186054683, -7.374942558148721],
              [-16.441150522318985, -7.374838690591098],
              [-16.436972872552577, -7.376112766084667],
              [-16.433770787877744, -7.377720697174486],
              [-16.432611318509654, -7.377478097850924],
              [-16.43143976139755, -7.378232501731692],
              [-16.42764862248626, -7.378528181968101],
              [-16.426342607508147, -7.377851794605571],
              [-16.424802941224463, -7.378099002627928],
              [-16.422725978554254, -7.377809228141887],
              [-16.42047461225269, -7.375831690914046],
              [-16.41835616843824, -7.378642546095283],
              [-16.41762897030109, -7.380254244045905],
              [-16.415631421253682, -7.378617354711756],
              [-16.416359090680334, -7.377710098723809],
              [-16.415516254653227, -7.376217245252192],
              [-16.41593868454693, -7.374203699960345],
              [-16.414793266067786, -7.372432924419641],
              [-16.413501024913305, -7.371254012138812],
              [-16.410236168494293, -7.374814661763206],
              [-16.4089988569434, -7.378278793754642],
              [-16.410014656307755, -7.37850581986998],
              [-16.408925910245053, -7.380246528045973],
              [-16.408893648014622, -7.381679997825799],
              [-16.407727489455034, -7.383744971456632],
              [-16.407083114719565, -7.382712285897475],
              [-16.40764794493433, -7.381857607866301],
              [-16.406583606193863, -7.379929139203017],
              [-16.405828911518814, -7.381575686217655],
              [-16.40470340477147, -7.381986163207036],
              [-16.40100899814469, -7.3869593791256385],
              [-16.399431503308563, -7.385456451406821],
              [-16.398144929774443, -7.38573924613204],
              [-16.396247945032925, -7.384672813241929],
              [-16.392779252112078, -7.38578133641122],
              [-16.39017289552502, -7.385691220634374],
              [-16.386835769644165, -7.387862945499169],
              [-16.386788896983116, -7.385436730365598],
              [-16.384389959991527, -7.385297073384203],
              [-16.383467280880787, -7.384730617436284],
              [-16.378869740318546, -7.38446997051649],
              [-16.378028051753265, -7.385446884904541],
              [-16.376718012445284, -7.385266128618331],
              [-16.373943239833444, -7.382830086422967],
              [-16.370429184210852, -7.3786962590752445],
              [-16.368316766465146, -7.377655796063462],
              [-16.367843734395382, -7.378822121339901],
              [-16.365956638251355, -7.379035822906999],
              [-16.36594026895712, -7.378121511353856],
              [-16.36475115279754, -7.3768329101656605],
              [-16.36308808890196, -7.373268700508233],
              [-16.36036942497359, -7.3740961807991265],
              [-16.35821835140437, -7.374085806133486],
              [-16.353206641387942, -7.372769890156553],
              [-16.34850569497725, -7.374000553781988],
              [-16.344499619483212, -7.373645892463171],
              [-16.341912306921472, -7.372878117490331],
              [-16.340324943557956, -7.373118356790642],
              [-16.337021419560465, -7.371910927519508],
              [-16.335526382905787, -7.370292755371874],
              [-16.33398420899534, -7.3709110081061535],
              [-16.330679461694668, -7.370876102793991],
              [-16.328382052015012, -7.3689636650059915],
              [-16.32673221310069, -7.368735152679027],
              [-16.324291989861365, -7.367328692135319],
              [-16.32230185386125, -7.367298855668598],
              [-16.318820934749898, -7.368552026644384],
              [-16.316256524821792, -7.368359195037096],
              [-16.31356905578411, -7.366976562199758],
              [-16.310402655790927, -7.368360802336816],
              [-16.3085584510645, -7.36694570570541],
              [-16.307409505748904, -7.368003769504459],
              [-16.304883855558685, -7.367973046520421],
              [-16.303919730111666, -7.3673141089401195],
              [-16.30167023618776, -7.368010448216659],
              [-16.29748089618191, -7.367859872148481],
              [-16.29614580420181, -7.3670414194724705],
              [-16.293880981515557, -7.367858526529343],
              [-16.29118014598187, -7.367800498888541],
              [-16.29049797210561, -7.369444578262043],
              [-16.287838730914917, -7.370768459138724],
              [-16.28548832994205, -7.369608259606938],
              [-16.284200785703213, -7.370094546093264],
              [-16.283018975270018, -7.3712715186438285],
              [-16.28082017778409, -7.369933317949176],
              [-16.279249073229444, -7.37157673538495],
              [-16.276233430301566, -7.370778056280739],
              [-16.275169986436094, -7.3725226429935145],
              [-16.273984930636807, -7.3720872160825675],
              [-16.272992667401777, -7.373775489684194],
              [-16.271358094363574, -7.375563786442498],
              [-16.27040480090823, -7.375783501192981],
              [-16.26887738204423, -7.374876010699518],
              [-16.26709926560619, -7.374614271988149],
              [-16.266646933957464, -7.373457520134407],
              [-16.263573028119367, -7.375385707380101],
              [-16.263064526122086, -7.376350915569477],
              [-16.26152722219844, -7.375373440580178],
              [-16.259856380075473, -7.376521388507689],
              [-16.258556226239055, -7.376490327939665],
              [-16.257771966811365, -7.374329102617651],
              [-16.25579811036976, -7.374225426407629],
              [-16.25520836274569, -7.375750727575382],
              [-16.253481908223566, -7.375421793232689],
              [-16.25087786318669, -7.377298414133615],
              [-16.248104591395755, -7.377572674849397],
              [-16.24762360066605, -7.376889613756993],
              [-16.248567002702572, -7.375353287948168],
              [-16.247304757940693, -7.3746172354299615],
              [-16.246437427037733, -7.376106673135172],
              [-16.243477683692166, -7.37716824471218],
              [-16.24188965539054, -7.375720817655378],
              [-16.242574933102382, -7.373730192739148],
              [-16.244571580875782, -7.371108371624168],
              [-16.24426939374539, -7.367018717456245],
              [-16.242922879840087, -7.365958891448165],
              [-16.23962635808195, -7.367897114357408],
              [-16.23923540854725, -7.3696376096783025],
              [-16.23577209479358, -7.37184701826847],
              [-16.235486764490652, -7.372505709037869],
              [-16.23319792859187, -7.373999694342412],
              [-16.230503939418867, -7.376748754709675],
              [-16.22771004182715, -7.377513714763725],
              [-16.225690306106454, -7.378804675586342],
              [-16.225378474713523, -7.379780282860284],
              [-16.22186407219936, -7.3816357994376745],
              [-16.220631211499256, -7.383344945979468],
              [-16.2185316654202, -7.384556570783817],
              [-16.2173002671733, -7.384305269830688],
              [-16.215466170237928, -7.386732508596408],
              [-16.21418763817715, -7.386961715848808],
              [-16.21181855417523, -7.3888873611021],
              [-16.208847850266178, -7.389365677302497],
              [-16.207167527051393, -7.390601669155636],
              [-16.20603265841106, -7.389817932383434],
              [-16.202549691283547, -7.3893210163929455],
              [-16.201773430690874, -7.391617845988671],
              [-16.198318732409728, -7.391568534336446],
              [-16.197286889282104, -7.3935829396998445],
              [-16.19537004760943, -7.394676391829543],
              [-16.19313212398526, -7.394989864353754],
              [-16.191803381126284, -7.397371499619642],
              [-16.19041094619611, -7.397890671610647],
              [-16.189272379977197, -7.400429685482447],
              [-16.18742045545781, -7.402725667079307],
              [-16.1842925758425, -7.404026467231117],
              [-16.18222211195747, -7.403591708704665],
              [-16.179914593829825, -7.4038517652191125],
              [-16.17685045888912, -7.405424255193046],
              [-16.174559583977267, -7.405768361058699],
              [-16.171221527261128, -7.4068095304290305],
              [-16.169865221157607, -7.408247668866794],
              [-16.168735774638435, -7.408233935783773],
              [-16.16583637132304, -7.407386467343877],
              [-16.164147531423836, -7.40539865393056],
              [-16.163446602795272, -7.4029951744499725],
              [-16.161724514984062, -7.402034990712224],
              [-16.158735459857247, -7.401277474337909],
              [-16.157176448698756, -7.4013787344733055],
              [-16.155669890799043, -7.403037844784899],
              [-16.15777290690093, -7.403232174879406],
              [-16.159569605389244, -7.402882611174911],
              [-16.160336439844023, -7.404884613336609],
              [-16.160542951253987, -7.407260892847361],
              [-16.16024950453546, -7.410103544034092],
              [-16.1546432067225, -7.4134773300837455],
              [-16.151895743079738, -7.41349003996052],
              [-16.148230216398826, -7.41413782171655],
              [-16.143841335565174, -7.414616415878292],
              [-16.141336502703954, -7.414449074286657],
              [-16.138987334320746, -7.4149603724916195],
              [-16.13772382171178, -7.414457486595668],
              [-16.135028926073304, -7.414413840136221],
              [-16.13173611506922, -7.415510580457479],
              [-16.129711826643188, -7.41657174641303],
              [-16.12706345947061, -7.4205569921044106],
              [-16.12536961924511, -7.420958081038745],
              [-16.12519252798666, -7.419699612762703],
              [-16.12077826692844, -7.41894971623757],
              [-16.119523449375066, -7.418491646391147],
              [-16.115154357326954, -7.414717400404555],
              [-16.112981078449852, -7.414369458404054],
              [-16.11214681967489, -7.413182331027586],
              [-16.111949867364476, -7.410915848021424],
              [-16.106792488757957, -7.411327116476139],
              [-16.102626121858396, -7.412768998085667],
              [-16.09781411435962, -7.413796760164598],
              [-16.093709630207414, -7.413953046053406],
              [-16.0910917264989, -7.413838898334701],
              [-16.087633990375757, -7.412945951979049],
              [-16.085395202324303, -7.4117183773007],
              [-16.083577838313982, -7.410311426201597],
              [-16.0809628841296, -7.407640601907407],
              [-16.079866864185462, -7.406110698008039],
              [-16.07677870330651, -7.4010004791671475],
              [-16.072294026585713, -7.392970064389832],
              [-16.072644201817077, -7.391733135202077],
              [-16.071831496584995, -7.389751749773585],
              [-16.069009264371783, -7.386576801633563],
              [-16.063778577600665, -7.384117658384646],
              [-16.06103163382139, -7.383441406920463],
              [-16.052965236808255, -7.382313254418902],
              [-16.049770675596342, -7.38209928932402],
              [-16.046740920822156, -7.3801874843275135],
              [-16.047971122480956, -7.378884828190347],
              [-16.046946299737833, -7.376553466681193],
              [-16.045667214333626, -7.375345532246414],
              [-16.04294855003754, -7.374401155433985],
              [-16.04045036667589, -7.373935623403958],
              [-16.03636101711486, -7.372213908912159],
              [-16.033190104503237, -7.367021414127254],
              [-16.031190140162646, -7.365202224070367],
              [-16.025500755004423, -7.362148116274153],
              [-16.021835034820516, -7.3611387410507],
              [-16.01962779357851, -7.360891495422954],
              [-16.017017930398676, -7.359368205055381],
              [-16.01514011564718, -7.357828745368599],
              [-16.01166282936116, -7.355796189245362],
              [-16.00851644848045, -7.350965997821222],
              [-16.008314815532724, -7.349345371495243],
              [-16.007514981641567, -7.348206011334765],
              [-16.00582128870827, -7.347669749160859],
              [-16.00419077390653, -7.347853936162656],
              [-16.001061534759604, -7.348966575366371],
              [-15.997150002950047, -7.350977621584894],
              [-15.994220800630755, -7.3504170280832755],
              [-15.991391193981542, -7.348753991300608],
              [-15.991765209793794, -7.344221845778991],
              [-15.990810735315614, -7.343344834296126],
              [-15.988263028166868, -7.3420364665128695],
              [-15.981613023306945, -7.33951608808528],
              [-15.978821763685325, -7.338927441278905],
              [-15.974966466143393, -7.338535603155311],
              [-15.972804549339799, -7.337751622093076],
              [-15.973730338390858, -7.336599910011859],
              [-15.97249763496489, -7.334372060859608],
              [-15.970720309133245, -7.333466261148798],
              [-15.966008093496084, -7.333437041957539],
              [-15.961838808900271, -7.334829083112105],
              [-15.956122192236688, -7.336407235137955],
              [-15.953307981007942, -7.337411661777077],
              [-15.952712665800847, -7.338028988382955],
              [-15.95009591118666, -7.3376264628838355],
              [-15.9446398514828, -7.3354993556641945],
              [-15.942490130916667, -7.333843251278788],
              [-15.941803387165047, -7.332603010813163],
              [-15.939292260443175, -7.329688970525068],
              [-15.936929612434843, -7.327746634960105],
              [-15.935451002588268, -7.32699238460653],
              [-15.933775356944704, -7.3251324244435745],
              [-15.931039059728251, -7.3251221154458666],
              [-15.926375843766381, -7.3297224062702995],
              [-15.92493806180127, -7.33039567473021],
              [-15.92005453265445, -7.331359289918838],
              [-15.918486428851157, -7.331920801891406],
              [-15.915173910405413, -7.3342210617392105],
              [-15.910734456656304, -7.336078519175887],
              [-15.908371941141596, -7.3368505887264615],
              [-15.904799147322217, -7.3385737344770785],
              [-15.90182605148779, -7.339659864884216],
              [-15.898423217536648, -7.341475626595627],
              [-15.89675210379203, -7.342892774711773],
              [-15.893984875080857, -7.34282255707661],
              [-15.892529403601264, -7.343227782064836],
              [-15.890130264225851, -7.344789482925774],
              [-15.884974556638907, -7.3456943636790974],
              [-15.878511686133747, -7.348275501046264],
              [-15.870357446706546, -7.3505443643694734],
              [-15.867375078569113, -7.351022638964679],
              [-15.864447736761324, -7.352197102850168],
              [-15.856302833544582, -7.356150232170409],
              [-15.854956810839266, -7.356618593636548],
              [-15.848389000323031, -7.359732488613969],
              [-15.841920671119741, -7.363814763144101],
              [-15.838752990424348, -7.366550750091453],
              [-15.836858010322802, -7.367886212330942],
              [-15.83434693381582, -7.3688757297327045],
              [-15.830321997441484, -7.370857529858506],
              [-15.83128688244166, -7.374311966439577],
              [-15.83074548703367, -7.3767162975481835],
              [-15.825853464373989, -7.378747387885685],
              [-15.824890769982307, -7.378471116440091],
              [-15.823674009430212, -7.380246750823167],
              [-15.82133273400084, -7.381407271266967],
              [-15.819827499108886, -7.381012240363657],
              [-15.81812080442022, -7.381260802503379],
              [-15.816505888813438, -7.3828684612239295],
              [-15.813527404423944, -7.381554985721259],
              [-15.817822881221877, -7.379522582355979],
              [-15.81548763507434, -7.379634277665238],
              [-15.812260785813098, -7.38179946885077],
              [-15.81324311767972, -7.382240488536674],
              [-15.813430039693179, -7.384511243225781],
              [-15.814298380576176, -7.385168891111922],
              [-15.81498724395728, -7.3869304543863405],
              [-15.816167137680168, -7.387674610079686],
              [-15.815195157531223, -7.389160098925273],
              [-15.813948538781233, -7.389451570519301],
              [-15.81082231034859, -7.3881250855719856],
              [-15.809196905064859, -7.388306698306955],
              [-15.80700979479587, -7.387752151293607],
              [-15.807928060759412, -7.385422930335005],
              [-15.807214923085583, -7.38495794504967],
              [-15.803143926142134, -7.386688604636072],
              [-15.795602629924705, -7.391529541569852],
              [-15.792840332116356, -7.3925981916278385],
              [-15.788125428736505, -7.395389292016989],
              [-15.78099711086191, -7.39915400086614],
              [-15.776927944858988, -7.400625757879733],
              [-15.773170078114322, -7.401598220445625],
              [-15.766873141282469, -7.403787693536269],
              [-15.764235026509626, -7.4053595216659325],
              [-15.762614123310625, -7.4056039450735955],
              [-15.756359241325764, -7.409024773834812],
              [-15.75442096720476, -7.408686405390515],
              [-15.74665526002499, -7.409632591886588],
              [-15.728928805141326, -7.414368259523991],
              [-15.723279237448784, -7.4162875971756],
              [-15.719636484155792, -7.417794632276194],
              [-15.71264247142658, -7.421046756989454],
              [-15.706019946127707, -7.4248105532715405],
              [-15.703021113387145, -7.426757925106742],
              [-15.697521953137908, -7.430783424169625],
              [-15.691541516817296, -7.435614921759192],
              [-15.687522603947025, -7.438438951445595],
              [-15.685261601953423, -7.43910016404493],
              [-15.68221186164538, -7.438821916706152],
              [-15.680810861965213, -7.439541900422867],
              [-15.681692582141814, -7.4405028590847735],
              [-15.684403741264479, -7.44022759216809],
              [-15.687986393704467, -7.438741908364627],
              [-15.68937390358707, -7.437656487158794],
              [-15.69047667505375, -7.438668639134316],
              [-15.690051538313115, -7.440180351418451],
              [-15.688374054898961, -7.441684975480434],
              [-15.687216027563228, -7.4435899213007035],
              [-15.686645759478225, -7.446238914667813],
              [-15.68588300154664, -7.446941692841229],
              [-15.683893508105662, -7.446262514221112],
              [-15.682392297562446, -7.449188635024436],
              [-15.681784409957489, -7.452386168191499],
              [-15.68034508813589, -7.452486429739885],
              [-15.679029934272513, -7.454667916839543],
              [-15.67641993573397, -7.457607435566974],
              [-15.674028719319116, -7.459315196848201],
              [-15.672503398462954, -7.459842243443935],
              [-15.668876201087711, -7.459177419837578],
              [-15.662498798380007, -7.45841531601593],
              [-15.660378742623472, -7.45854318817296],
              [-15.658199294378166, -7.457818357517493],
              [-15.658395468217893, -7.4558250445613385],
              [-15.658236215177306, -7.451143973317642],
              [-15.656035684304824, -7.44536663138601],
              [-15.655757711118632, -7.442523318492372],
              [-15.656497503543477, -7.43997824622578],
              [-15.659569158880993, -7.44183638893954],
              [-15.661052722446188, -7.4424244153222245],
              [-15.665742180155473, -7.440295494431465],
              [-15.66735777048361, -7.441582461942405],
              [-15.667927616701565, -7.440729587210775],
              [-15.667255082123823, -7.439508672272592],
              [-15.66368887736886, -7.440331198658393],
              [-15.661479166606199, -7.441773636252085],
              [-15.660483042672498, -7.441595869087195],
              [-15.656844798321579, -7.439427622182238],
              [-15.655602801858214, -7.438958575335801],
              [-15.647635923830013, -7.439596724486097],
              [-15.645240515444666, -7.440220803597127],
              [-15.640685400106134, -7.442226022473767],
              [-15.631573289374348, -7.445864017924272],
              [-15.62904770559883, -7.446543689787722],
              [-15.604908106831504, -7.567304077778926],
              [-15.58202901678544, -7.6817338987029515],
              [-15.577754190932785, -7.703111220419579],
              [-15.554570588859466, -7.818964119206576],
              [-15.551904904106976, -7.832350031015982],
              [-15.552133037098226, -7.832393438264398]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -153.48140687399842,
          "lat": 69.31192490308779
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02185"],
        "coty_name": ["North Slope"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["North Slope Borough"],
        "coty_fp_code": "185",
        "coty_gnis_code": "01419978"
      },
      "bbox": [
        -18.88828525759616, -8.166211086539578, -15.551904904106976,
        -7.004198378653145
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.225804536360318, -8.729123725019994],
              [-18.223693266725636, -8.728997771985322],
              [-18.22382948556378, -8.731223765275278],
              [-18.225806212708484, -8.729894995535057],
              [-18.225804536360318, -8.729123725019994]
            ]
          ],
          [
            [
              [-18.281098565624003, -8.466650063328895],
              [-18.27992671302057, -8.464687562184494],
              [-18.280237645570487, -8.463970810880031],
              [-18.278922783095723, -8.461605287014965],
              [-18.278407048632886, -8.464084244495064],
              [-18.278768987688665, -8.46520455073238],
              [-18.280668157120754, -8.467214053544456],
              [-18.281098565624003, -8.466650063328895]
            ]
          ],
          [
            [
              [-18.281548746427713, -8.45259662866043],
              [-18.279588747114012, -8.45354765787733],
              [-18.27866241273665, -8.45602351832648],
              [-18.280149212423346, -8.456916595491705],
              [-18.28094890940587, -8.456163346714023],
              [-18.281548746427713, -8.45259662866043]
            ]
          ],
          [
            [
              [-18.33941459542076, -8.69806289037481],
              [-18.337049665903724, -8.691720136434805],
              [-18.337563273689327, -8.69059930694823],
              [-18.33696676269049, -8.687529226953549],
              [-18.337194398899015, -8.68660306195715],
              [-18.337127523844906, -8.682926320917764],
              [-18.335194531163417, -8.682317875886996],
              [-18.33270584132472, -8.68104138776483],
              [-18.331536375970536, -8.681501785954323],
              [-18.332718998006303, -8.682783009830274],
              [-18.333814232866626, -8.685175880398031],
              [-18.334467987106567, -8.68770170866622],
              [-18.334455419698685, -8.690697327400295],
              [-18.333674573000778, -8.691617987530131],
              [-18.332412564192, -8.691545461008154],
              [-18.33038736109871, -8.692932374443302],
              [-18.33043216672275, -8.695383624317191],
              [-18.329638603941298, -8.697090606522707],
              [-18.3284254714307, -8.697947068423723],
              [-18.33290840348653, -8.699655778496929],
              [-18.336411443711935, -8.69915865854714],
              [-18.338795131466227, -8.699117792979914],
              [-18.33941459542076, -8.69806289037481]
            ]
          ],
          [
            [
              [-18.42198827298031, -8.417708833265106],
              [-18.420871458692993, -8.417256980274166],
              [-18.419872344199753, -8.417974113399854],
              [-18.42183238851731, -8.424618336903945],
              [-18.423579044777018, -8.424136731464975],
              [-18.42198827298031, -8.417708833265106]
            ]
          ],
          [
            [
              [-18.719361709162335, -8.02731180037997],
              [-18.662312517155108, -8.036686596063323],
              [-18.605266931574846, -8.046082680319754],
              [-18.595809636554524, -7.987319866648871],
              [-18.533486178513847, -7.9966850881672356],
              [-18.471166668832524, -8.006075846001949],
              [-18.418228821644785, -8.013315736627675],
              [-18.365293561609043, -8.020574041070377],
              [-18.361362382781774, -7.991091893061486],
              [-18.27939920994834, -8.001414957133331],
              [-18.27079068102191, -8.002454539532561],
              [-18.274408362515064, -8.031975537013295],
              [-18.213755686827373, -8.039049751018831],
              [-18.210344614783494, -8.009504814185163],
              [-18.149849682148552, -8.016134543768025],
              [-18.153048557411775, -8.045701915706571],
              [-18.092276128983077, -8.05170904197734],
              [-18.031506154808326, -8.05774040498517],
              [-18.02872645628397, -8.028132389567048],
              [-17.968102919684245, -8.033499710976502],
              [-17.97067304112363, -8.063126234530465],
              [-17.907247359688277, -8.06804447261569],
              [-17.84382377255567, -8.072989095924811],
              [-17.764368174934308, -8.07822333780038],
              [-17.701528535097022, -8.081615678081937],
              [-17.638690324716606, -8.085033906968649],
              [-17.640115049305074, -8.114741685856133],
              [-17.579788753981866, -8.117152816378251],
              [-17.519463431932312, -8.119587737846473],
              [-17.52047354213658, -8.149319561970318],
              [-17.459912398533525, -8.150910014305117],
              [-17.399351898110723, -8.152524370339481],
              [-17.399592034943172, -8.164520055803873],
              [-17.400542543355606, -8.212032719306594],
              [-17.407223807911528, -8.211899234105045],
              [-17.407842106182375, -8.241663887806174],
              [-17.377691633789023, -8.242226520504866],
              [-17.378207802945543, -8.27200043922332],
              [-17.347952849871174, -8.27246298856994],
              [-17.348366672029016, -8.302244981910928],
              [-17.318008351671246, -8.302606756762026],
              [-17.31831976529583, -8.332396664999584],
              [-17.326193960082296, -8.332312574060259],
              [-17.327208371614603, -8.421719816525751],
              [-17.266556621214985, -8.422192962466115],
              [-17.26669241912583, -8.452009047428572],
              [-17.24528983914727, -8.452080332394212],
              [-17.24554278314601, -8.571402195915551],
              [-17.254409045855336, -8.571379006781765],
              [-17.25450254791476, -8.601223298597548],
              [-17.34472813906521, -8.600508600918147],
              [-17.345508423379094, -8.660208271908601],
              [-17.436315134278196, -8.65861009384006],
              [-17.437001563355512, -8.688462725857812],
              [-17.443225247033865, -8.688321051555006],
              [-17.444638966788872, -8.748038401990325],
              [-17.50492027304079, -8.746453307460746],
              [-17.50401901966625, -8.716597500947817],
              [-17.534058279040217, -8.715664082994625],
              [-17.5330531705454, -8.685769788387454],
              [-17.592934598656022, -8.683669067636187],
              [-17.59531963793116, -8.743356628806657],
              [-17.655567771030423, -8.740812563412433],
              [-17.65279476018629, -8.681140632750386],
              [-17.712626495694092, -8.678031329194173],
              [-17.772459358391036, -8.674943294293898],
              [-17.779563935942424, -8.794227288258158],
              [-17.839532848454592, -8.790350877148024],
              [-17.899503129954674, -8.786495188129525],
              [-17.93054681082782, -8.784246265298611],
              [-17.935069307153586, -8.843846034890355],
              [-18.025173406116103, -8.836747712428927],
              [-18.03027156240283, -8.89632313636035],
              [-18.02867256958851, -8.896456642178748],
              [-18.036293715944677, -8.985849973740466],
              [-18.06640366499546, -8.98329533104745],
              [-18.069044393638958, -9.013088993198714],
              [-18.12937916704367, -9.007486188213363],
              [-18.189715801204333, -9.001902888103537],
              [-18.226725531055667, -8.998173755617799],
              [-18.295884059877118, -8.990546134960779],
              [-18.36504550161591, -8.982944142744122],
              [-18.435380451653494, -8.97417719108857],
              [-18.505718806244097, -8.96543674918128],
              [-18.573222267713042, -8.956041078830363],
              [-18.640729241121825, -8.946669827422738],
              [-18.631867836317035, -8.887486426615041],
              [-18.661647910125712, -8.883087398137306],
              [-18.65260262231683, -8.823944475907004],
              [-18.692486035040297, -8.817904558912137],
              [-18.67390463501695, -8.69973438312417],
              [-18.684386015296656, -8.698118142211271],
              [-18.66568077869895, -8.580036504438253],
              [-18.676334134103023, -8.578378438865338],
              [-18.670615241632163, -8.542496603339723],
              [-18.66468604243188, -8.543685825808092],
              [-18.65776979574532, -8.543804002215836],
              [-18.65415848241264, -8.544054998766079],
              [-18.647120686716033, -8.544192135242364],
              [-18.642424280812914, -8.544532850709484],
              [-18.637111599916988, -8.544684920779854],
              [-18.628480207072336, -8.545259505041864],
              [-18.61890041168748, -8.546351836511276],
              [-18.599637528966806, -8.549380698210344],
              [-18.58341926284445, -8.553607284799986],
              [-18.57180200041321, -8.559237724435842],
              [-18.566117004401082, -8.56361419728377],
              [-18.565779776561037, -8.566128595194902],
              [-18.568013604605863, -8.567261457491874],
              [-18.5806858572062, -8.561416496694047],
              [-18.58594624295685, -8.558448310871025],
              [-18.592975003149093, -8.555882806525073],
              [-18.598863842868788, -8.554433208826174],
              [-18.599669008668027, -8.555400601747989],
              [-18.602619885514027, -8.555854945662805],
              [-18.6030997803791, -8.554295121753885],
              [-18.604934344308823, -8.5539783961643],
              [-18.60639062255227, -8.554949218330414],
              [-18.607083157342235, -8.55795763521784],
              [-18.60634801656648, -8.560740595316991],
              [-18.605011299615008, -8.562269707693726],
              [-18.602796265153085, -8.562223793674942],
              [-18.601268861087377, -8.561337810838877],
              [-18.599082860068453, -8.562296048079258],
              [-18.596041428900634, -8.560695189440606],
              [-18.594589254790247, -8.561398846358625],
              [-18.589935525041074, -8.564834843396342],
              [-18.589254108205164, -8.566705308519886],
              [-18.587711429401345, -8.566900746524054],
              [-18.58741144273242, -8.565328949574843],
              [-18.585760722610882, -8.564980676085622],
              [-18.583642644011814, -8.566608410211199],
              [-18.584478956026047, -8.568923576262646],
              [-18.584841260933462, -8.572871933753902],
              [-18.584277597573312, -8.576230529029743],
              [-18.582303054475577, -8.576697500696804],
              [-18.581845394480492, -8.57745081215458],
              [-18.5817122449396, -8.580016872854202],
              [-18.583787364234343, -8.587831571407294],
              [-18.585676786871282, -8.591389169272603],
              [-18.58859433709926, -8.595872380705398],
              [-18.59024749478383, -8.599620476557696],
              [-18.59252795417599, -8.601134213515298],
              [-18.595752254353727, -8.604095724556828],
              [-18.603938925866245, -8.610396816475218],
              [-18.608569059295885, -8.620022937427242],
              [-18.608876838381775, -8.621692344814273],
              [-18.608559561222247, -8.626897207645559],
              [-18.607755277759637, -8.628482772574277],
              [-18.609636596493306, -8.631304831338841],
              [-18.609999220913135, -8.63621041419955],
              [-18.610756677374106, -8.638482918472528],
              [-18.61298379461543, -8.64154779287449],
              [-18.612826846770545, -8.643376599971043],
              [-18.611177925088363, -8.646354640287164],
              [-18.60937650140384, -8.647085990059418],
              [-18.607669813019854, -8.649331743838228],
              [-18.608368277337718, -8.650221950709224],
              [-18.60874332995832, -8.652107077630108],
              [-18.6080991373287, -8.655398547362715],
              [-18.60790797019295, -8.65806496443934],
              [-18.60824293967784, -8.660076099655369],
              [-18.610137923430994, -8.663707056981568],
              [-18.61154988377014, -8.664724710582451],
              [-18.613558944353493, -8.665351777405128],
              [-18.618331315567755, -8.669787004411129],
              [-18.625036213318257, -8.676426551882493],
              [-18.62692234745227, -8.677087831787924],
              [-18.629572684503486, -8.676289543293231],
              [-18.633294446863353, -8.676020430083605],
              [-18.641424211127127, -8.676851780755628],
              [-18.64299499161474, -8.67638427555038],
              [-18.645760894871934, -8.677369140902274],
              [-18.64767620966088, -8.679672904408365],
              [-18.648631411734723, -8.68222442286511],
              [-18.647714397779538, -8.685242793326616],
              [-18.645350591924746, -8.686484832698792],
              [-18.642573418715884, -8.68599194800336],
              [-18.641171342054417, -8.6854150876608],
              [-18.638475756915796, -8.688181121086926],
              [-18.636528404416534, -8.688015642535676],
              [-18.634457309836662, -8.685331009097562],
              [-18.631815900309995, -8.683059867438242],
              [-18.631013333206127, -8.683712451301641],
              [-18.631553682483997, -8.686100454086475],
              [-18.632391098547238, -8.686205998712019],
              [-18.633655772965547, -8.68917505504198],
              [-18.634000041610335, -8.690989254871127],
              [-18.633061098066648, -8.691504913079541],
              [-18.62931026747352, -8.69108901333095],
              [-18.628725891815428, -8.6894166904363],
              [-18.62637136159589, -8.689185240356327],
              [-18.626053921396093, -8.687393550674232],
              [-18.624190316466304, -8.685429106199775],
              [-18.622386904917523, -8.68549775319335],
              [-18.621965017458518, -8.687151396462808],
              [-18.62089537687627, -8.698086617102716],
              [-18.619684246630822, -8.705326133268903],
              [-18.618387975920335, -8.7105345945631],
              [-18.61564370362916, -8.715538326871858],
              [-18.61024608150523, -8.726691923727312],
              [-18.60250769230028, -8.73238390445707],
              [-18.60124391618473, -8.73196806757517],
              [-18.598615373634395, -8.733034560153747],
              [-18.596427138106428, -8.735220156614885],
              [-18.591944279661703, -8.737611483311769],
              [-18.5889696524284, -8.737477514071605],
              [-18.58794003625225, -8.735875421793907],
              [-18.585898252904816, -8.735805052565352],
              [-18.585361976866814, -8.73474259736696],
              [-18.584044436000372, -8.734600882541775],
              [-18.580849397084723, -8.735491297696075],
              [-18.577876361661158, -8.735167229106183],
              [-18.575049135375178, -8.733935662669158],
              [-18.571731767182367, -8.732012588481235],
              [-18.57118978410995, -8.731195944153315],
              [-18.564745578172058, -8.732293434642834],
              [-18.562772048652732, -8.733701001409768],
              [-18.55998190793192, -8.733994614871454],
              [-18.559088566390137, -8.733181315611148],
              [-18.556071691665903, -8.733468115008884],
              [-18.555618805419098, -8.734093117534298],
              [-18.553662092571745, -8.734443696481225],
              [-18.551720421613034, -8.734032461555664],
              [-18.550030519416286, -8.73426365213227],
              [-18.54852653636717, -8.733670591982394],
              [-18.547607324723867, -8.734749381252826],
              [-18.547502447471874, -8.73627972615876],
              [-18.545976958317755, -8.738265654589528],
              [-18.54276723744441, -8.74055618501723],
              [-18.538816016286606, -8.742046251623288],
              [-18.536440593247384, -8.742184447231942],
              [-18.534080991761602, -8.743155976634846],
              [-18.52854886324853, -8.744034191327412],
              [-18.527295818134323, -8.745820732593904],
              [-18.52510906925173, -8.74658832857309],
              [-18.51704550139909, -8.74658586788055],
              [-18.51125880594724, -8.745839015429825],
              [-18.504248406170213, -8.744550774488275],
              [-18.501136774403456, -8.743642485258336],
              [-18.494339610242218, -8.739661491975015],
              [-18.490443500750782, -8.740263056017291],
              [-18.488871564979448, -8.74166376109614],
              [-18.486379285053975, -8.742228300869236],
              [-18.48375905872779, -8.74403050086366],
              [-18.48039645686357, -8.744074804887381],
              [-18.473954160179307, -8.742667783800783],
              [-18.472637195829613, -8.743164465761033],
              [-18.46917970691905, -8.742332315464665],
              [-18.46687622340106, -8.74116393312945],
              [-18.464871058975437, -8.739642686989443],
              [-18.4640375243136, -8.740847777950998],
              [-18.466137706166155, -8.742302106728534],
              [-18.465985163994883, -8.743860638252416],
              [-18.46478684948034, -8.746483560083467],
              [-18.462773899815343, -8.748655270128824],
              [-18.458028204619314, -8.750895023995445],
              [-18.45723440515146, -8.752602050816497],
              [-18.45732533747393, -8.755958046597122],
              [-18.45632254548817, -8.75787798343601],
              [-18.451623591669946, -8.763231632308015],
              [-18.45054842700939, -8.763611021303806],
              [-18.448341502111727, -8.763024011862019],
              [-18.441460989451052, -8.763369984355062],
              [-18.434644786335955, -8.762630885677009],
              [-18.432345608605686, -8.762149239935653],
              [-18.425330204018305, -8.759854536426587],
              [-18.424719115951365, -8.761645563851118],
              [-18.422250464730265, -8.762822274715147],
              [-18.420659599718476, -8.768716010761318],
              [-18.419107503193228, -8.770360446448061],
              [-18.415813010261044, -8.771577286688332],
              [-18.411693782742447, -8.77158287009008],
              [-18.40222637174685, -8.76972692860636],
              [-18.395398741735615, -8.766951560355867],
              [-18.394071721694488, -8.767006815597927],
              [-18.388632198572846, -8.763999219554453],
              [-18.38090332114382, -8.759060887791295],
              [-18.379461226490072, -8.759247907533457],
              [-18.379087192639602, -8.761805885429531],
              [-18.377358157286725, -8.76312036599229],
              [-18.370180260339257, -8.764152268744931],
              [-18.366770283352235, -8.762972916176203],
              [-18.365399233690454, -8.763105368704506],
              [-18.364772171640873, -8.76406308918863],
              [-18.36482551735153, -8.765678982147104],
              [-18.359526620259953, -8.769164997444],
              [-18.358065986015124, -8.77195543750047],
              [-18.355423500238096, -8.774330633760034],
              [-18.35113952833621, -8.776681192551155],
              [-18.34633473273922, -8.778802497548199],
              [-18.341240821418808, -8.781707611395554],
              [-18.3415834835319, -8.782539507577257],
              [-18.347169530680183, -8.78013586027124],
              [-18.34812359003746, -8.778860121857962],
              [-18.352595482620643, -8.7769835130357],
              [-18.35267584411801, -8.778621792544438],
              [-18.349679247499633, -8.781680825311756],
              [-18.346687572524395, -8.7830859045741],
              [-18.34646811633815, -8.785198511458402],
              [-18.347096985168502, -8.786155428865802],
              [-18.345930895976927, -8.787597080433699],
              [-18.345295184073937, -8.789390170441262],
              [-18.34606776185576, -8.789943029162268],
              [-18.347320866442594, -8.792740503939495],
              [-18.34963177031102, -8.795258431350492],
              [-18.351205074111345, -8.79766292045566],
              [-18.351493006037575, -8.799382793380051],
              [-18.35043523273174, -8.801552608130317],
              [-18.3482866860251, -8.802491521341945],
              [-18.346698620256326, -8.801554220292902],
              [-18.343900866693286, -8.802141233212065],
              [-18.34306804747944, -8.80272245858012],
              [-18.34128817126731, -8.801193292055588],
              [-18.339603671951394, -8.80130277446361],
              [-18.33656518443974, -8.802539327111322],
              [-18.33341926374957, -8.800252165830665],
              [-18.332493207243186, -8.79758309794575],
              [-18.334360257085457, -8.794645510346902],
              [-18.337738497674362, -8.79133565849844],
              [-18.339410084501754, -8.790246551718525],
              [-18.337359374937126, -8.786897923059723],
              [-18.334409683515457, -8.783301496304935],
              [-18.33282889516893, -8.77954757139926],
              [-18.330637848993618, -8.777903913305046],
              [-18.327607618804837, -8.774559136987317],
              [-18.324335968632678, -8.773540374381989],
              [-18.321711273132845, -8.77055630121527],
              [-18.31926803985599, -8.766698827625122],
              [-18.319497209308967, -8.765477799176848],
              [-18.31845322347769, -8.76435759280176],
              [-18.319799600752738, -8.762655842165339],
              [-18.319546904523214, -8.761693987565566],
              [-18.315630194571558, -8.759204285044285],
              [-18.315296791588583, -8.758175228452703],
              [-18.315920840719542, -8.756235952091284],
              [-18.314914363603403, -8.754327072293016],
              [-18.308690144249987, -8.74590745427317],
              [-18.306121260901712, -8.741421778360912],
              [-18.304564102207564, -8.73828014451435],
              [-18.302768028672702, -8.732776068976042],
              [-18.30107831677994, -8.730159281949438],
              [-18.300018228488078, -8.729801854758033],
              [-18.29683685915245, -8.723940698938124],
              [-18.29452658779268, -8.720809388929395],
              [-18.290763603282794, -8.711754000049318],
              [-18.28795476085954, -8.71118997934753],
              [-18.286394292940205, -8.710527596843034],
              [-18.282674839825965, -8.707011411000696],
              [-18.281460906871732, -8.706326521627425],
              [-18.276982189251385, -8.706875915469896],
              [-18.274974047776553, -8.707844031329104],
              [-18.271339100827802, -8.708891497189127],
              [-18.269511744841644, -8.708348145946596],
              [-18.26835266774464, -8.709249558252713],
              [-18.265861568732614, -8.709519411083892],
              [-18.263792427954538, -8.709093651611033],
              [-18.261791046572977, -8.709202289019146],
              [-18.26195627696175, -8.710956404545215],
              [-18.261087739300166, -8.713921069957268],
              [-18.26094825657538, -8.71626411065631],
              [-18.258635636518523, -8.722852436592563],
              [-18.25702709008656, -8.723789168542694],
              [-18.246181649318235, -8.727981934212314],
              [-18.2411882725251, -8.728375721968144],
              [-18.23927860260295, -8.728059732836973],
              [-18.236557093462476, -8.726703301782766],
              [-18.231397692060217, -8.725023653674144],
              [-18.228827276080526, -8.723361141748251],
              [-18.226821150367417, -8.722463480194113],
              [-18.22343753640545, -8.72319628216531],
              [-18.221921217861233, -8.72402778220778],
              [-18.222351588163782, -8.725638320752447],
              [-18.223553949883975, -8.72716356308439],
              [-18.226259841464522, -8.728324563878306],
              [-18.226716425291624, -8.729634851750413],
              [-18.226361884319207, -8.731798319050615],
              [-18.226680155260183, -8.734107826598182],
              [-18.226179754214982, -8.73517516653394],
              [-18.226663134187966, -8.736192561288487],
              [-18.22863132175782, -8.737240409398014],
              [-18.228117227575563, -8.739293552174196],
              [-18.225399040231572, -8.740235619175733],
              [-18.221868883392442, -8.74064499154995],
              [-18.21992256405122, -8.740184766993616],
              [-18.2175353607864, -8.738924733728137],
              [-18.217204878656506, -8.737306243117567],
              [-18.21356892500616, -8.7358253565888],
              [-18.211629130602258, -8.734505549577744],
              [-18.20894414342405, -8.731722758046386],
              [-18.20752969883916, -8.728177105805385],
              [-18.20738613902344, -8.72701030176734],
              [-18.208997812161773, -8.724232240042959],
              [-18.20994120512877, -8.724403584351949],
              [-18.213411605840754, -8.720988382924565],
              [-18.21437934868359, -8.717696716394602],
              [-18.21391555827866, -8.716923313990325],
              [-18.215305835230396, -8.713573736344882],
              [-18.218297956608, -8.710147048608038],
              [-18.21884690853656, -8.708213846340461],
              [-18.220472923788257, -8.70592586576898],
              [-18.221136128928634, -8.703222960791853],
              [-18.220283260312538, -8.701670065456916],
              [-18.221797721476417, -8.700814400743166],
              [-18.222173123195024, -8.698281301204002],
              [-18.221737648894816, -8.697235767477338],
              [-18.22270997365664, -8.69588272345741],
              [-18.223111354897075, -8.694304834316046],
              [-18.225417187837092, -8.690146630533437],
              [-18.22511084745941, -8.689459178661634],
              [-18.22835661840045, -8.685742521245142],
              [-18.23249352089866, -8.68342819635274],
              [-18.233793946047506, -8.683350306084595],
              [-18.240296413509377, -8.680137745424197],
              [-18.241458369618066, -8.679899131662612],
              [-18.247904107604146, -8.674833643702828],
              [-18.248800035246486, -8.674607709255824],
              [-18.25443065628651, -8.67148859644222],
              [-18.258905359009336, -8.668681151736155],
              [-18.266416951148365, -8.667401950221752],
              [-18.269557716573, -8.665509810980184],
              [-18.271227408460682, -8.664077332002579],
              [-18.276039379608036, -8.66099067526348],
              [-18.279482531565574, -8.659204671374386],
              [-18.283204507904227, -8.658297576280637],
              [-18.28729044852158, -8.658171688258767],
              [-18.291046208109755, -8.658317666521652],
              [-18.298707158144463, -8.656388175835605],
              [-18.304108630358467, -8.656060176737178],
              [-18.306055411624854, -8.65683940459129],
              [-18.31239285323556, -8.660684541723642],
              [-18.318613674695833, -8.663384741437236],
              [-18.324194059264357, -8.665301035719667],
              [-18.326300327354886, -8.666190638543965],
              [-18.32916216800164, -8.665645487873718],
              [-18.332754645950445, -8.66595135750641],
              [-18.336842812711147, -8.668377876336377],
              [-18.337416641927547, -8.669903752096726],
              [-18.33699573605853, -8.671557105960364],
              [-18.335575772424043, -8.673288910880931],
              [-18.337754210368406, -8.675399968116821],
              [-18.338616344188452, -8.677074529920258],
              [-18.338566332001346, -8.678644094638818],
              [-18.340274719399705, -8.677944768700037],
              [-18.342211288571367, -8.677772946530288],
              [-18.339477097679126, -8.671164838583195],
              [-18.336307379940635, -8.66481207748451],
              [-18.33291507149582, -8.656930478214584],
              [-18.329840924982562, -8.64831177837124],
              [-18.326830923932537, -8.636399309914108],
              [-18.32579001966525, -8.630590477124017],
              [-18.324929631331077, -8.622632000362174],
              [-18.325256276498294, -8.61664139558533],
              [-18.32615866827271, -8.611882353341773],
              [-18.328182972247777, -8.607009707850107],
              [-18.330994919836954, -8.601928083652394],
              [-18.332499633237344, -8.600312116326483],
              [-18.33505800293095, -8.59520131588813],
              [-18.336974734680087, -8.59212917845644],
              [-18.341247088014278, -8.587079528838489],
              [-18.34652484212032, -8.582662254259628],
              [-18.350606436393456, -8.579001925393065],
              [-18.35167876831615, -8.577002939719641],
              [-18.351905456708472, -8.572905410251886],
              [-18.352886954150666, -8.565027417309352],
              [-18.353641088909928, -8.562233577666923],
              [-18.356071002089926, -8.55576828563924],
              [-18.35821702517813, -8.550836953950839],
              [-18.362310706031153, -8.544795046938328],
              [-18.36558807818107, -8.541443686095258],
              [-18.368758471794774, -8.538959575946008],
              [-18.376562766139894, -8.535324779268326],
              [-18.378443093491132, -8.534317081699863],
              [-18.381710619348315, -8.533052938321783],
              [-18.38480002336783, -8.532711034048663],
              [-18.389458419918164, -8.530919537213851],
              [-18.392697286730165, -8.52992767897827],
              [-18.399800299462544, -8.52885160686537],
              [-18.40159996105835, -8.527776725432961],
              [-18.402129172900334, -8.526213231563316],
              [-18.401490121589056, -8.524350728331836],
              [-18.400802228560504, -8.51868437786995],
              [-18.401178287734403, -8.514874438475978],
              [-18.401858355874698, -8.511728226827916],
              [-18.403998345182632, -8.504808963024768],
              [-18.406148396499873, -8.498331192713634],
              [-18.408276524606766, -8.493794079515643],
              [-18.410764647576233, -8.489989263288798],
              [-18.41233087357284, -8.486920248683896],
              [-18.413112800331884, -8.483471062088935],
              [-18.412934280171783, -8.480588735758609],
              [-18.412115215377966, -8.476603490552428],
              [-18.41060670679992, -8.47343342870364],
              [-18.40835924118674, -8.469495487374303],
              [-18.405020894030788, -8.467983803769611],
              [-18.400425079206606, -8.469622990934203],
              [-18.398282086513717, -8.469227609856022],
              [-18.395558369215255, -8.468166290516553],
              [-18.3933383625654, -8.464586212270053],
              [-18.39284495789019, -8.462170714840632],
              [-18.393128866885625, -8.461313826459026],
              [-18.392816102140866, -8.458957743384653],
              [-18.391725731924105, -8.457890030116173],
              [-18.391336466389863, -8.45615353261154],
              [-18.388000779768905, -8.454036175034028],
              [-18.387388582269978, -8.455508097452253],
              [-18.38684478746505, -8.458355527471221],
              [-18.38673162557615, -8.460617505446873],
              [-18.38603763905555, -8.463274021652875],
              [-18.38444081998754, -8.464920513482676],
              [-18.38214115249821, -8.466035083286174],
              [-18.380551873925086, -8.46596422176648],
              [-18.375855280604473, -8.463487869723268],
              [-18.371003189115772, -8.461268975065801],
              [-18.368881032477333, -8.459326947125053],
              [-18.366453775933397, -8.460705637819883],
              [-18.364045809807234, -8.464912365467377],
              [-18.363744193777727, -8.466407562745818],
              [-18.3640287279702, -8.46935491844544],
              [-18.362708068034454, -8.474245565695096],
              [-18.361363235999058, -8.477567183281872],
              [-18.360366766472392, -8.482270682236791],
              [-18.35900719321752, -8.48690935356024],
              [-18.355232095082414, -8.49213972031437],
              [-18.353887205918316, -8.496493453562637],
              [-18.35218683032156, -8.498099243726994],
              [-18.349851014755288, -8.501916141049254],
              [-18.34831207974014, -8.507216586456703],
              [-18.34653930972452, -8.512192887048833],
              [-18.343260698046283, -8.516477309668428],
              [-18.339273286686627, -8.51880438376375],
              [-18.333762794676392, -8.519681297021572],
              [-18.333054032321364, -8.521110576912331],
              [-18.33352609240046, -8.526179633032054],
              [-18.336927142258663, -8.535434674152242],
              [-18.339582456738196, -8.53974152711644],
              [-18.344613209327957, -8.544842544510963],
              [-18.345950659689294, -8.54964632981851],
              [-18.344678257169917, -8.553870103911914],
              [-18.346223092690792, -8.558046462107304],
              [-18.34632574757806, -8.564218440527663],
              [-18.345085131410784, -8.567190623747914],
              [-18.341671347495083, -8.569338121479484],
              [-18.34151951615693, -8.572282938672299],
              [-18.337885308917045, -8.577773173057999],
              [-18.333542903387812, -8.586363001374364],
              [-18.330779391820155, -8.598362725090006],
              [-18.328281558489973, -8.60233980870904],
              [-18.320906713851457, -8.609450547165732],
              [-18.318057576649174, -8.613636272043196],
              [-18.314127646359594, -8.61835501601457],
              [-18.309232374783363, -8.622201979153973],
              [-18.306139160270533, -8.625955839904643],
              [-18.304718534306737, -8.627049607787788],
              [-18.29951279279025, -8.62952185091888],
              [-18.294817545015373, -8.637132938754702],
              [-18.290759412953406, -8.640128331755575],
              [-18.2870781054269, -8.64343764596834],
              [-18.285566623819257, -8.643704349077924],
              [-18.281125109530834, -8.64378459295807],
              [-18.277942493970617, -8.643593252444855],
              [-18.271714473612906, -8.641114524886087],
              [-18.267288724546518, -8.64036818979403],
              [-18.261668245275654, -8.638666887925096],
              [-18.257215324941146, -8.63545881274588],
              [-18.252659846183278, -8.635057403152462],
              [-18.24992802254555, -8.634255482427045],
              [-18.246952098260046, -8.629984791157492],
              [-18.244974702857903, -8.627882677873343],
              [-18.2371692491798, -8.621404674919216],
              [-18.236154602369588, -8.621288299406618],
              [-18.232427407085346, -8.619618605952944],
              [-18.23055591675205, -8.619471540285092],
              [-18.227929572895075, -8.617739666261185],
              [-18.226610488582846, -8.61853093153845],
              [-18.22719278523357, -8.627632101902057],
              [-18.2245930013418, -8.633220102215008],
              [-18.22280777861727, -8.634465555624374],
              [-18.220585512898676, -8.634959600346859],
              [-18.21829940214927, -8.63496798717959],
              [-18.215808262331826, -8.633986385639616],
              [-18.21484104260461, -8.634774496295158],
              [-18.21101330747974, -8.639076846416636],
              [-18.208180892706963, -8.64325176071245],
              [-18.205358279204514, -8.652261066797404],
              [-18.203248124249445, -8.656354661863524],
              [-18.200939480915867, -8.658278998517948],
              [-18.199018595791834, -8.658454977219499],
              [-18.195858168585993, -8.661354847348461],
              [-18.187702529760124, -8.66840375460711],
              [-18.181748554486095, -8.6779242568315],
              [-18.179619404465893, -8.68074840030516],
              [-18.177753750446964, -8.68192652316322],
              [-18.17060475605512, -8.682710764140829],
              [-18.16775912236775, -8.682321180319956],
              [-18.163288469391002, -8.682035398434472],
              [-18.16064947108797, -8.684382253079109],
              [-18.157349106470942, -8.686627010699464],
              [-18.15499168817096, -8.68637099638574],
              [-18.14906812029455, -8.684260678617594],
              [-18.14609960344765, -8.68672796321076],
              [-18.14374449871216, -8.686815266073369],
              [-18.13582842188509, -8.681793862533553],
              [-18.132785502636438, -8.681763850019376],
              [-18.130492944666585, -8.682631833185894],
              [-18.122935504633773, -8.682711713837957],
              [-18.12136704258682, -8.683250774682547],
              [-18.119286360756796, -8.68326920884945],
              [-18.116076824128182, -8.682417596843143],
              [-18.113727644956395, -8.68132641538882],
              [-18.112477128587066, -8.681400441381484],
              [-18.109716927094897, -8.682623683879786],
              [-18.105483598601555, -8.683497848625771],
              [-18.09971091447923, -8.681081043279569],
              [-18.0982156833078, -8.67935801812312],
              [-18.09764873821793, -8.677930193094301],
              [-18.09790284386322, -8.675774837002825],
              [-18.097125392635633, -8.674854377948636],
              [-18.097609182884778, -8.673368230881902],
              [-18.09705500438322, -8.671472939661767],
              [-18.095870103549405, -8.669234598927664],
              [-18.09655025644888, -8.66800297600082],
              [-18.095616180493202, -8.662366087600198],
              [-18.094033927658568, -8.655438707473879],
              [-18.094687549239694, -8.654503429336756],
              [-18.09396728325642, -8.651813751071796],
              [-18.09391446536273, -8.64993381861148],
              [-18.09454533737346, -8.648608157619563],
              [-18.093935015195974, -8.643092823090807],
              [-18.092417072121687, -8.642132639427025],
              [-18.092607754085577, -8.639810426791467],
              [-18.094076492485993, -8.634000676713553],
              [-18.09521325894151, -8.632193227500908],
              [-18.09508881669361, -8.63115246753048],
              [-18.09588723208911, -8.62931748216034],
              [-18.095987274546125, -8.62680620759917],
              [-18.100252214753834, -8.618567332762588],
              [-18.104414094416608, -8.611391910311736],
              [-18.109181786965163, -8.603775758818951],
              [-18.1115857633939, -8.601156643565039],
              [-18.113858175330293, -8.59940672484451],
              [-18.11850980158526, -8.597862148194007],
              [-18.127610762299046, -8.598519090900515],
              [-18.129374584430433, -8.599827935137453],
              [-18.131015114664738, -8.599600747623672],
              [-18.13264277085601, -8.601092067473372],
              [-18.13294383038931, -8.602025660952574],
              [-18.131749648973493, -8.60280710677143],
              [-18.13130031325096, -8.60441309989081],
              [-18.132341983636497, -8.60737451561735],
              [-18.135494824246223, -8.607199429062415],
              [-18.136395159633143, -8.608085933210171],
              [-18.134777682920944, -8.611109404968865],
              [-18.13730953218458, -8.610713309461017],
              [-18.14151536160728, -8.609253032664103],
              [-18.146888433664056, -8.606988634282038],
              [-18.149326217110303, -8.606673642491623],
              [-18.152241243957526, -8.605413303677112],
              [-18.15598511659591, -8.603203522776278],
              [-18.15876803395166, -8.599351928295292],
              [-18.16018851515972, -8.59386471729551],
              [-18.16336088184682, -8.587969667283193],
              [-18.16844310817467, -8.583323071721823],
              [-18.175238641539803, -8.579670338363558],
              [-18.180248867598017, -8.578833395457464],
              [-18.18800691363242, -8.579669715021073],
              [-18.18956636829818, -8.579056054605031],
              [-18.190634157932234, -8.58015003123359],
              [-18.190452591339067, -8.581023137071437],
              [-18.196131592942134, -8.583520663629617],
              [-18.197116655675025, -8.582952159807396],
              [-18.19980444138896, -8.58261758630077],
              [-18.207867806057667, -8.583503552543474],
              [-18.213130859085958, -8.582057696458048],
              [-18.216366466373717, -8.5819743105434],
              [-18.218350522587425, -8.582897835092485],
              [-18.222607962147972, -8.587258236967873],
              [-18.226799744980845, -8.592073506957494],
              [-18.22773583005396, -8.594037026056487],
              [-18.229592003187975, -8.595878825883196],
              [-18.227577582161732, -8.596773904585133],
              [-18.227245286051858, -8.598591897888703],
              [-18.227811451492833, -8.599700692008533],
              [-18.229816442688872, -8.60057335483076],
              [-18.232460595707238, -8.600954075512531],
              [-18.233578459674604, -8.602363096933082],
              [-18.232003798298933, -8.608132347977584],
              [-18.23328046975867, -8.61404513210612],
              [-18.23569440791721, -8.6146893229034],
              [-18.237106249625135, -8.616409560232173],
              [-18.23944680124195, -8.616764900160193],
              [-18.2436030668278, -8.619088025263228],
              [-18.24490560514616, -8.619034411014846],
              [-18.24612456029727, -8.619821826386199],
              [-18.247413750561186, -8.618994847728267],
              [-18.25285252972382, -8.61784320678849],
              [-18.257347755437994, -8.617488764711451],
              [-18.25945944925315, -8.615923207331832],
              [-18.259166588622854, -8.615087344871563],
              [-18.260077891602947, -8.613910900546147],
              [-18.262295405260197, -8.614300626007717],
              [-18.264112716245545, -8.61597340464251],
              [-18.26562741307944, -8.616688749988286],
              [-18.267045997237773, -8.615570240528875],
              [-18.2664167114961, -8.612723648462916],
              [-18.265148318528308, -8.610761496988646],
              [-18.265612262307037, -8.609571771313448],
              [-18.267542951088675, -8.609517693866218],
              [-18.271037265628756, -8.610788554946193],
              [-18.271753636507373, -8.610633972277915],
              [-18.273314672607544, -8.607835437744436],
              [-18.27719536491335, -8.605762029803055],
              [-18.27588367376952, -8.604441980396263],
              [-18.275953441599086, -8.603110972236516],
              [-18.277795430701296, -8.602573123334935],
              [-18.277765548914537, -8.601569192789546],
              [-18.27563592443164, -8.600706307866668],
              [-18.274013426698563, -8.598011296954827],
              [-18.27466497892535, -8.594523669010107],
              [-18.28105047007128, -8.593602846756026],
              [-18.283595454422613, -8.590849455302788],
              [-18.284181498560113, -8.589060760194334],
              [-18.28638985491467, -8.585867394104483],
              [-18.287915920935085, -8.584519951553204],
              [-18.29144412541884, -8.583063434307757],
              [-18.291950202219642, -8.582057362847186],
              [-18.29434639597785, -8.580594997983363],
              [-18.29471765967182, -8.578730785508553],
              [-18.29607515587205, -8.577789278166286],
              [-18.296938447421486, -8.576321988454268],
              [-18.297017621085523, -8.574948514940656],
              [-18.29778093640638, -8.573334682785415],
              [-18.298909831719058, -8.572362097700523],
              [-18.29906013619392, -8.570779357422799],
              [-18.300328159551615, -8.568715636835654],
              [-18.302772698938153, -8.567222098253882],
              [-18.304035592896305, -8.565723548570327],
              [-18.304485391669242, -8.563797879658594],
              [-18.305785266362406, -8.562762727694482],
              [-18.307188740739893, -8.559559236199455],
              [-18.309221537976505, -8.557312746761273],
              [-18.30967540861487, -8.555754948824593],
              [-18.30687807911904, -8.551876898775852],
              [-18.304372260672963, -8.549448193353854],
              [-18.303062980718458, -8.546581692173932],
              [-18.303392620407838, -8.545671984209793],
              [-18.308377963486684, -8.544517942460539],
              [-18.311066570250002, -8.542931070991242],
              [-18.315740001122034, -8.545434257639485],
              [-18.31721695830007, -8.544728688157528],
              [-18.317336879024946, -8.543393738160646],
              [-18.314405733989858, -8.538151424907342],
              [-18.313396574862573, -8.535580098249376],
              [-18.310139637671995, -8.529087560153764],
              [-18.309971959955607, -8.526351824082038],
              [-18.312222479723168, -8.522418955773754],
              [-18.311240206142035, -8.519870028308985],
              [-18.311158984939496, -8.516955508291238],
              [-18.30883534188843, -8.516500865114494],
              [-18.308793341332244, -8.514712480417707],
              [-18.30936766649741, -8.512139067119325],
              [-18.30850769016294, -8.511126798149617],
              [-18.304013872439057, -8.50993537595439],
              [-18.30278976071795, -8.507822959441349],
              [-18.301492480413653, -8.507630785594726],
              [-18.300214555220915, -8.505473422425158],
              [-18.300534592008333, -8.504441717173336],
              [-18.299925248418962, -8.502158174640506],
              [-18.297976474149433, -8.499783890157614],
              [-18.297122466274445, -8.49663618067259],
              [-18.29712763037909, -8.493862273842002],
              [-18.297945352387227, -8.492766855472624],
              [-18.298456810343193, -8.488774798541005],
              [-18.296261227197217, -8.485511908620827],
              [-18.29292671247408, -8.483099690695573],
              [-18.28801865072681, -8.481130834745962],
              [-18.2857527200171, -8.478879939514176],
              [-18.284975573027285, -8.473860429687445],
              [-18.28530090535142, -8.472263988662217],
              [-18.284021137862677, -8.47040163975546],
              [-18.281823557660786, -8.469323457843698],
              [-18.27818821480434, -8.470395600862203],
              [-18.276559662394316, -8.469517790350453],
              [-18.27525467719051, -8.467338258122576],
              [-18.2737978048365, -8.467355224154153],
              [-18.270756303933325, -8.468307011808374],
              [-18.2680943094243, -8.470661484330808],
              [-18.26711173061714, -8.471018225824293],
              [-18.266590574162766, -8.472295547399604],
              [-18.26386560471436, -8.473636619396176],
              [-18.26178582622754, -8.47340806207043],
              [-18.253935131989007, -8.473634797471226],
              [-18.25232563174226, -8.470792037099399],
              [-18.252902128340114, -8.466672333868871],
              [-18.251959349400952, -8.465568863574731],
              [-18.25399091584746, -8.461727025236955],
              [-18.254686386038, -8.45941422694813],
              [-18.25912048947947, -8.455431773069293],
              [-18.260959503776366, -8.455163891467485],
              [-18.264235853628062, -8.456525345462799],
              [-18.265963897012583, -8.456757071307385],
              [-18.266709953021564, -8.45583472961147],
              [-18.269497939454276, -8.447789647887774],
              [-18.271098242337974, -8.447049699635603],
              [-18.273566490962924, -8.447419346539288],
              [-18.274774335054808, -8.446170702703334],
              [-18.27474423046325, -8.44484770536417],
              [-18.27646963438375, -8.444097937213591],
              [-18.278790575559576, -8.441449133501887],
              [-18.280272446846134, -8.44102420825865],
              [-18.281432508530333, -8.44212644524475],
              [-18.28176736692524, -8.44716477950523],
              [-18.28297714241465, -8.44814918639551],
              [-18.284085935284235, -8.447865343672065],
              [-18.284978414664096, -8.444236025487875],
              [-18.288462703191325, -8.437162402829244],
              [-18.29030193258621, -8.436894737873857],
              [-18.293180216351285, -8.433574830018166],
              [-18.293154149477214, -8.432300778257527],
              [-18.29598026779174, -8.430850365796903],
              [-18.301739838483652, -8.42992947412672],
              [-18.30584011229757, -8.43058740402743],
              [-18.308764655084335, -8.431951747259708],
              [-18.312734000107163, -8.431251191994484],
              [-18.316137028320917, -8.431394534864824],
              [-18.31894166875275, -8.43188484247389],
              [-18.325268283398817, -8.433431766047054],
              [-18.33211868670361, -8.434133380381303],
              [-18.33834490866044, -8.435286202249012],
              [-18.34671312923421, -8.438085915342628],
              [-18.35379621616785, -8.441797472709867],
              [-18.35427754299053, -8.443109452566913],
              [-18.356412333050237, -8.44245009160733],
              [-18.362191147279166, -8.441772856995325],
              [-18.365283399597356, -8.44177418411539],
              [-18.370197063168835, -8.440649706263216],
              [-18.37361827528468, -8.440992973288282],
              [-18.377834288502694, -8.4431146552203],
              [-18.381618200494408, -8.442644167923332],
              [-18.383593106939806, -8.438388940443199],
              [-18.381933571215704, -8.433635652805764],
              [-18.381662089519534, -8.43159713242204],
              [-18.380767554615765, -8.428450771594068],
              [-18.382101045677224, -8.427829822540982],
              [-18.38673756804908, -8.432397357159443],
              [-18.387909886891006, -8.432280010053661],
              [-18.38895092034972, -8.431142511017503],
              [-18.39043233747205, -8.430484486364852],
              [-18.393306978390154, -8.432811091890187],
              [-18.395530361535773, -8.43231664961068],
              [-18.39566049248322, -8.431422666867839],
              [-18.397706819400007, -8.43059832139731],
              [-18.399457903678243, -8.430803442071431],
              [-18.40155401668146, -8.429656274992066],
              [-18.403345683611796, -8.430373892183114],
              [-18.403723932102707, -8.432686754243539],
              [-18.404590719661062, -8.433073694176846],
              [-18.406160135315613, -8.431943330229355],
              [-18.411188274448932, -8.425606266656727],
              [-18.410985337213816, -8.423364283646476],
              [-18.411749467955957, -8.42190484614232],
              [-18.413797848648738, -8.42110472461581],
              [-18.41368762084273, -8.420033361390502],
              [-18.412668357093594, -8.418592326088636],
              [-18.413526195508343, -8.416413610221246],
              [-18.415401193671123, -8.414694392863879],
              [-18.418081014587884, -8.41409013771985],
              [-18.42952909321959, -8.415787369226909],
              [-18.435371865880153, -8.415915030304518],
              [-18.44285342615119, -8.414833162923683],
              [-18.446394211424856, -8.416050658446396],
              [-18.45364875754715, -8.419085765066672],
              [-18.460655476267736, -8.415341113566333],
              [-18.47247667430868, -8.411336655466394],
              [-18.47836800965202, -8.408057662286698],
              [-18.484757202557045, -8.40505140547352],
              [-18.490551202657702, -8.403141237422608],
              [-18.497342522539824, -8.400506828180845],
              [-18.49965040298692, -8.399213107341994],
              [-18.50370258061354, -8.397610397587936],
              [-18.50880419529094, -8.394398218592588],
              [-18.514318427227145, -8.391677725646696],
              [-18.517526231155827, -8.390393414828184],
              [-18.524627980353443, -8.388092816839938],
              [-18.53393151950204, -8.384920009115943],
              [-18.540519900870724, -8.382482117330236],
              [-18.543665101764038, -8.380815167720296],
              [-18.548083878042835, -8.376951663255488],
              [-18.550889246730605, -8.373915249354988],
              [-18.552485543929627, -8.37151004300192],
              [-18.553281957402195, -8.369253873285738],
              [-18.551386487802006, -8.362279688979546],
              [-18.55002024644439, -8.355512932793054],
              [-18.549446361745595, -8.351022213728386],
              [-18.54905595906166, -8.34528886347002],
              [-18.548812227236354, -8.338784927488552],
              [-18.548690550427835, -8.328434352303269],
              [-18.549415263542613, -8.314034849842775],
              [-18.549764782874234, -8.310551668313552],
              [-18.55078042189666, -8.308961369427616],
              [-18.55140542588111, -8.29834759766505],
              [-18.552217114160666, -8.29295239507877],
              [-18.552537878441083, -8.287815457000397],
              [-18.553792469958772, -8.278758679585868],
              [-18.55477601266299, -8.272696124926787],
              [-18.555915137976097, -8.26736509943888],
              [-18.557935493737652, -8.259373311842289],
              [-18.558463164159146, -8.258025175698354],
              [-18.560216084588646, -8.251719722238397],
              [-18.562447619913673, -8.242171648854038],
              [-18.564106734654914, -8.235867817153327],
              [-18.567549182325973, -8.223454761922143],
              [-18.571483534518304, -8.212060895579278],
              [-18.57570886888611, -8.203306584745047],
              [-18.576221684707065, -8.202898744150849],
              [-18.580953492453038, -8.195230386337098],
              [-18.58336615306732, -8.191905514448601],
              [-18.585632674309707, -8.1891836280157],
              [-18.592466904498263, -8.182248860413775],
              [-18.59931102916059, -8.176386584360662],
              [-18.603372982549775, -8.172582182239417],
              [-18.608027233937822, -8.167939460968649],
              [-18.612151352855022, -8.164158627898125],
              [-18.614581744682646, -8.162198609617567],
              [-18.617436820180668, -8.159394888612816],
              [-18.61900388884716, -8.157365850014754],
              [-18.62297902007412, -8.153707329541573],
              [-18.62690536681359, -8.15074312875589],
              [-18.6294840312827, -8.147366753907557],
              [-18.632718857512042, -8.142493948601617],
              [-18.637137365377818, -8.135529205116779],
              [-18.640388836189288, -8.13114986606278],
              [-18.643326065389797, -8.127884393773211],
              [-18.647174850989014, -8.12180324086442],
              [-18.657331112626135, -8.107411014834867],
              [-18.66381995790304, -8.098573244444047],
              [-18.665985962327404, -8.096111078652925],
              [-18.66918967521883, -8.092919340868692],
              [-18.67401232913355, -8.08636228986748],
              [-18.67581037364092, -8.084291928661385],
              [-18.682257631273288, -8.075270159761404],
              [-18.685952646119347, -8.070345264974742],
              [-18.688962077307846, -8.06657300810299],
              [-18.691687476822192, -8.063549255030342],
              [-18.69425322940601, -8.06128319159401],
              [-18.69689768012487, -8.058551999124349],
              [-18.69903422790435, -8.055072773943378],
              [-18.70046169612448, -8.051436506884922],
              [-18.703523667240386, -8.046071289663757],
              [-18.70761278094915, -8.040474100270078],
              [-18.714821680482213, -8.031784329203505],
              [-18.719361709162335, -8.02731180037997]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -159.70623861316423,
          "lat": 67.05976544126025
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02188"],
        "coty_name": ["Northwest Arctic"],
        "coty_area_code": "USA",
        "coty_type": "borough",
        "coty_name_long": ["Northwest Arctic Borough"],
        "coty_fp_code": "188",
        "coty_gnis_code": "01419979"
      },
      "bbox": [
        -18.719361709162335, -9.013088993198714, -17.24528983914727,
        -7.987319866648871
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-13.011149177632761, -11.618649249296919],
              [-13.010331947748478, -11.618330290853432],
              [-13.009143916046325, -11.620697256524265],
              [-13.01024670914379, -11.621340100560815],
              [-13.011149177632761, -11.618649249296919]
            ]
          ],
          [
            [
              [-13.020851475634407, -11.597950342227469],
              [-13.020021385304883, -11.593756826479279],
              [-13.019843111816426, -11.58614963264742],
              [-13.018929993252835, -11.585121917119213],
              [-13.016680365045705, -11.586311007034926],
              [-13.01373164347035, -11.588978303591727],
              [-13.005977869054036, -11.600394482539961],
              [-13.0028846298882, -11.603710750361248],
              [-13.001602572822211, -11.607148098941126],
              [-13.00195472495565, -11.607756195246235],
              [-13.001833661591638, -11.611024671778688],
              [-13.004179316680219, -11.611836799172668],
              [-13.004043765454552, -11.6146408901873],
              [-13.00324536765822, -11.616421340800299],
              [-13.00356689508995, -11.618428623115975],
              [-13.00547015688928, -11.621384025533459],
              [-13.007167674922437, -11.621636766307942],
              [-13.006481657421665, -11.61946369507126],
              [-13.007380567622997, -11.615347456025743],
              [-13.009155773085343, -11.613290910377223],
              [-13.011403752814488, -11.613253568213933],
              [-13.011985025455532, -11.612354807944588],
              [-13.010415497565997, -11.61076217609842],
              [-13.011290338083883, -11.608705682337954],
              [-13.013510466966979, -11.606294397282365],
              [-13.014321705209854, -11.606129820303336],
              [-13.014844094766248, -11.608145066838373],
              [-13.014381222772945, -11.61004502748656],
              [-13.015478299596296, -11.61029790854278],
              [-13.021090796686755, -11.601042135093566],
              [-13.020851475634407, -11.597950342227469]
            ]
          ],
          [
            [
              [-13.029697222239369, -11.58371804267971],
              [-13.02925067678423, -11.582513495613856],
              [-13.028019597086647, -11.582447504663596],
              [-13.028042853180922, -11.584317542773501],
              [-13.029697222239369, -11.58371804267971]
            ]
          ],
          [
            [
              [-13.028477022216238, -11.609304547589076],
              [-13.028702924099628, -11.605286043934607],
              [-13.027171670662794, -11.604965523130081],
              [-13.02690804962475, -11.603263642622466],
              [-13.024772954183721, -11.607268220040673],
              [-13.023983426693365, -11.609316510782255],
              [-13.02451598866988, -11.610530929853914],
              [-13.025532636963947, -11.61014900316009],
              [-13.027917207283558, -11.610345785767592],
              [-13.028477022216238, -11.609304547589076]
            ]
          ],
          [
            [
              [-13.029784169611826, -11.650544259583121],
              [-13.027295999461554, -11.648568008554852],
              [-13.025323340952623, -11.647553399474125],
              [-13.023879723199551, -11.648313292544147],
              [-13.026469086613622, -11.649228772661717],
              [-13.027877163595695, -11.650377307137276],
              [-13.029784169611826, -11.650544259583121]
            ]
          ],
          [
            [
              [-13.149403797690347, -11.47311920389039],
              [-13.149337051621876, -11.471481253314886],
              [-13.150401487685883, -11.4695034105021],
              [-13.15152729904064, -11.466500649211731],
              [-13.151750350654188, -11.464864151331806],
              [-13.150984812941696, -11.464279640615656],
              [-13.147858113363146, -11.46396188423906],
              [-13.14674454357861, -11.463547306818382],
              [-13.145217948907186, -11.465039471572192],
              [-13.14426697237261, -11.467387062354645],
              [-13.142883427025433, -11.4691644857822],
              [-13.14323745865582, -11.471229979864026],
              [-13.144634292365566, -11.47349698788856],
              [-13.144327116821533, -11.474251665469136],
              [-13.146237871095508, -11.474881251348561],
              [-13.14831219643173, -11.474470747402096],
              [-13.149403797690347, -11.47311920389039]
            ]
          ],
          [
            [
              [-13.155946799389252, -11.456986352860014],
              [-13.154599967699856, -11.4531728265483],
              [-13.15449026290993, -11.451523338337145],
              [-13.153221360545174, -11.446644791133728],
              [-13.148724996928696, -11.44342634165312],
              [-13.146075901738728, -11.440490741667304],
              [-13.144789979842443, -11.440831797746462],
              [-13.145081312499496, -11.44296168436367],
              [-13.144090730484217, -11.44766543737772],
              [-13.146062483244123, -11.44993043018211],
              [-13.146715201621292, -11.452946808834414],
              [-13.147979552196857, -11.455168267056193],
              [-13.149482791937432, -11.457049748393915],
              [-13.150646776934904, -11.457804305230447],
              [-13.155854768455923, -11.458522470431959],
              [-13.155946799389252, -11.456986352860014]
            ]
          ],
          [
            [
              [-13.149569207161651, -11.479971310492349],
              [-13.149240955499392, -11.478389577505872],
              [-13.14796605144891, -11.478159910861317],
              [-13.146830897543605, -11.479355351779747],
              [-13.147015964457198, -11.480367397774861],
              [-13.14866653795267, -11.481053429624545],
              [-13.149569207161651, -11.479971310492349]
            ]
          ],
          [
            [
              [-13.150073888747674, -11.521603376920105],
              [-13.150776915570216, -11.519260222654765],
              [-13.150943831014274, -11.515932049538938],
              [-13.150641479863, -11.514546941536404],
              [-13.148424863798729, -11.511533150057884],
              [-13.1484284537854, -11.51010509450693],
              [-13.14915821931427, -11.508820438695256],
              [-13.146381414357617, -11.50405134739093],
              [-13.145328611729166, -11.50146744914709],
              [-13.144080984506019, -11.501009428328459],
              [-13.143300268613674, -11.499895623312794],
              [-13.140919730082354, -11.4994932475276],
              [-13.139971647376827, -11.50070514803515],
              [-13.136438791059273, -11.501542391165504],
              [-13.132613226206953, -11.502806483937524],
              [-13.131205496278744, -11.502389747257789],
              [-13.130097228470666, -11.503358487841778],
              [-13.126724845977991, -11.503580260894099],
              [-13.12408838699114, -11.504902139796997],
              [-13.123095326005469, -11.5059567825095],
              [-13.122057591961353, -11.510382289552716],
              [-13.122386316821586, -11.51168318153616],
              [-13.12047769877814, -11.512436059153277],
              [-13.120633420995121, -11.513393806269674],
              [-13.124007469532526, -11.51345856117257],
              [-13.125173387257922, -11.512889678893018],
              [-13.127761697338974, -11.512980581927833],
              [-13.129203857200322, -11.516126531498506],
              [-13.12798626927072, -11.518825396125903],
              [-13.129538303323349, -11.520100085086437],
              [-13.13058568455797, -11.52015880780454],
              [-13.133965579961714, -11.523179671095011],
              [-13.134038389374187, -11.527783177414046],
              [-13.134937735522835, -11.52884229860028],
              [-13.139068967604487, -11.529818278374538],
              [-13.144806820097257, -11.528505671018568],
              [-13.14823278360968, -11.525575771030388],
              [-13.150073888747674, -11.521603376920105]
            ]
          ],
          [
            [
              [-13.166872436965562, -11.475008805131418],
              [-13.166273937232482, -11.470538832765767],
              [-13.16563963640996, -11.469286129701507],
              [-13.165605762460626, -11.465287082254921],
              [-13.16439656576126, -11.462611816611886],
              [-13.162299066530183, -11.462112931101904],
              [-13.161559852100586, -11.462439840915541],
              [-13.161491931760132, -11.466025488014687],
              [-13.16062124986085, -11.466736883622167],
              [-13.159556902705026, -11.469284071679466],
              [-13.16057463249254, -11.47322817493023],
              [-13.161746252799903, -11.474039993614332],
              [-13.15983009996538, -11.475406284016282],
              [-13.159363896232252, -11.476346169367911],
              [-13.159488355826209, -11.478667805946687],
              [-13.161426427189083, -11.480349133719264],
              [-13.163036277864913, -11.480021636418602],
              [-13.163589196991325, -11.4789677565756],
              [-13.16649292797299, -11.476404361528399],
              [-13.166872436965562, -11.475008805131418]
            ]
          ],
          [
            [
              [-13.173331961284346, -11.485815731486994],
              [-13.17340691755425, -11.484034964699035],
              [-13.17220529232661, -11.483024418491377],
              [-13.171132802531206, -11.482911209667389],
              [-13.167874172278099, -11.481417119482883],
              [-13.166859476939596, -11.481559746683383],
              [-13.16500158896678, -11.482756749091],
              [-13.165026836864461, -11.484665968277161],
              [-13.164517791993836, -11.485449473498544],
              [-13.161864664658035, -11.485292943655761],
              [-13.161399509368575, -11.485806004125973],
              [-13.162873341518843, -11.48842810062802],
              [-13.16294368784971, -11.489497059066634],
              [-13.166422654689843, -11.490494004711437],
              [-13.171354768693963, -11.489778409721787],
              [-13.171704633237999, -11.488467154428148],
              [-13.173011686222788, -11.486898710415675],
              [-13.173331961284346, -11.485815731486994]
            ]
          ],
          [
            [
              [-13.177315028647405, -11.496196781365756],
              [-13.177243927598706, -11.4942727861366],
              [-13.175082820646574, -11.49408988050796],
              [-13.174155283050073, -11.493264374205976],
              [-13.174026163093599, -11.492081374190318],
              [-13.171734653201948, -11.491997908987777],
              [-13.164956583671616, -11.494439951086374],
              [-13.16393817254995, -11.49600866675389],
              [-13.162878875417427, -11.495994733554031],
              [-13.160770562720428, -11.498063112587282],
              [-13.160300855835652, -11.500858671106382],
              [-13.161995692173607, -11.502983869254168],
              [-13.164709727035904, -11.503681777421871],
              [-13.165742021633148, -11.502639475981216],
              [-13.171521409097211, -11.500866155235864],
              [-13.174628160943815, -11.499693268390857],
              [-13.176893285362809, -11.497580427571986],
              [-13.177315028647405, -11.496196781365756]
            ]
          ],
          [
            [
              [-13.149181382829148, -11.61870768052656],
              [-13.147882187859853, -11.618276231909755],
              [-13.147259862227846, -11.619176365793216],
              [-13.148395692332013, -11.619929099860908],
              [-13.149181382829148, -11.61870768052656]
            ]
          ],
          [
            [
              [-13.185815533059088, -11.414126085126624],
              [-13.184115983137062, -11.414239994071409],
              [-13.181119861540411, -11.413221776180965],
              [-13.178885863193177, -11.411220848751682],
              [-13.177958161849913, -11.408905126648095],
              [-13.17590945069177, -11.406407157407642],
              [-13.174898691051734, -11.405825826025453],
              [-13.173212351836536, -11.405779166750914],
              [-13.171764606108217, -11.403910200710957],
              [-13.17103615884948, -11.400239304166782],
              [-13.171345040993833, -11.398900866127232],
              [-13.170432530893342, -11.395347313306189],
              [-13.170986160851992, -11.392773194350188],
              [-13.170452839875281, -11.391872195900046],
              [-13.170517884859251, -11.389166188633038],
              [-13.169361469444716, -11.387774659337605],
              [-13.166036797176215, -11.386825200735842],
              [-13.164483508168582, -11.3840863845769],
              [-13.160639385447594, -11.384289309495532],
              [-13.15846348016191, -11.382534552334489],
              [-13.155947682712496, -11.382829950147526],
              [-13.154969527675595, -11.38336415417549],
              [-13.153862745731868, -11.382848553494814],
              [-13.15394963610156, -11.381336700243407],
              [-13.15497416019978, -11.379527722238732],
              [-13.152417859261876, -11.376614412326612],
              [-13.150792348203662, -11.373826579991507],
              [-13.14914808321663, -11.371957359628736],
              [-13.148620417108182, -11.369083931522107],
              [-13.14946286501089, -11.367580917725927],
              [-13.147889370180996, -11.365637639113945],
              [-13.147593027325021, -11.364593648988174],
              [-13.148618961858311, -11.358644195375419],
              [-13.149756970649324, -11.356585502023243],
              [-13.149711806327808, -11.354890719602155],
              [-13.148178946821691, -11.35363922288609],
              [-13.147726171720548, -11.35073440367045],
              [-13.144658192813443, -11.348721463925706],
              [-13.144405864741895, -11.347758797387726],
              [-13.144773773593892, -11.344603447589462],
              [-13.146243467335054, -11.342135627043481],
              [-13.145899621647846, -11.340524173158931],
              [-13.14470340692924, -11.338811843960846],
              [-13.143625472241741, -11.336247627783598],
              [-13.141268349602523, -11.333662886624664],
              [-13.138485302313594, -11.332939538068532],
              [-13.138332738378802, -11.332028888765345],
              [-13.13692491216472, -11.330140063002032],
              [-13.134917980437939, -11.329087568660658],
              [-13.128159750009873, -11.330076751680554],
              [-13.125460535813847, -11.330632743573737],
              [-13.124944558137935, -11.336525310891009],
              [-13.099964095076281, -11.33972479557065],
              [-13.071937591802469, -11.343251029828602],
              [-13.07103949547933, -11.361982157102053],
              [-13.057910479381691, -11.375970947337752],
              [-13.041396969249227, -11.408118294720696],
              [-13.026305022749767, -11.401377235348162],
              [-12.996740790119057, -11.388103587434236],
              [-12.97001730693759, -11.40058985599056],
              [-12.945982657159448, -11.40588949139012],
              [-12.903658928903265, -11.415093706086742],
              [-12.882845291103223, -11.423664695119015],
              [-12.880303438226074, -11.425808338189082],
              [-12.87976958444056, -11.430584486076242],
              [-12.880006617085442, -11.431648013035316],
              [-12.882438575701737, -11.434025392763072],
              [-12.881663986981097, -11.438403997072706],
              [-12.882176121974238, -11.440688810981825],
              [-12.881087279691556, -11.442449381694859],
              [-12.87822198605525, -11.445562318827639],
              [-12.876065390326234, -11.447141446607183],
              [-12.874939596897512, -11.447453288149456],
              [-12.87263686133546, -11.447169322992353],
              [-12.870245113151318, -11.4462792008593],
              [-12.867698636731417, -11.446304926372546],
              [-12.86453799116571, -11.447998826657125],
              [-12.86286989351579, -11.448234490480845],
              [-12.859871600704066, -11.44802593706118],
              [-12.858435846171597, -11.44857402658254],
              [-12.858257622391049, -11.450574938009039],
              [-12.860165581311303, -11.452221602132642],
              [-12.861495354638924, -11.455005685232333],
              [-12.861025138072339, -11.457379400709922],
              [-12.859425866034945, -11.459573605395954],
              [-12.855943034939916, -11.46020374617734],
              [-12.854537284691126, -11.462109986830503],
              [-12.85343664426174, -11.461803907807242],
              [-12.851854575409728, -11.459447689480989],
              [-12.851029509142348, -11.460435284201596],
              [-12.851340070562836, -11.462823010879562],
              [-12.850894640278325, -11.465205550245802],
              [-12.851293620952202, -11.469550650275576],
              [-12.85252669972989, -11.471686146354443],
              [-12.855446438109814, -11.473356772054101],
              [-12.85610724082344, -11.47515480631492],
              [-12.85798737486417, -11.476705874851282],
              [-12.857061698992904, -11.480131249641108],
              [-12.859115341666389, -11.482333188527035],
              [-12.859082885755198, -11.486102604014985],
              [-12.860221734647656, -11.48922942012082],
              [-12.861334288748024, -11.49077250865869],
              [-12.861385448189097, -11.493091529210897],
              [-12.86530457855208, -11.492591974662002],
              [-12.86899186978322, -11.495559435962747],
              [-12.867937795039756, -11.496672055427736],
              [-12.868422177801312, -11.498218394922452],
              [-12.87059717203175, -11.49943462437283],
              [-12.873690170666814, -11.499553963065441],
              [-12.876049938438221, -11.500630323729178],
              [-12.879159346890528, -11.503139055436195],
              [-12.880053130145496, -11.505678110164599],
              [-12.881575234174568, -11.50860368541019],
              [-12.883227196606924, -11.508963636534299],
              [-12.884880395519462, -11.505915458788552],
              [-12.886055488114934, -11.505236244353124],
              [-12.887140077207702, -11.503702336822856],
              [-12.887587928109484, -11.50114328258535],
              [-12.889616413758425, -11.498712449376214],
              [-12.891633661592612, -11.499272338911823],
              [-12.892520846671994, -11.500991376916884],
              [-12.895145581430087, -11.501559178593975],
              [-12.89593394161246, -11.502214439822836],
              [-12.895864304899632, -11.503519746702912],
              [-12.89504033091087, -11.505381500640542],
              [-12.896132232866034, -11.506497196135648],
              [-12.898933243275028, -11.506830373614688],
              [-12.899045025394651, -11.51109906847087],
              [-12.899883625569524, -11.512584774239052],
              [-12.901787024094926, -11.512316451175009],
              [-12.903431132356882, -11.517410369438776],
              [-12.903560815017244, -11.519341660788871],
              [-12.90291828188726, -11.521168059442438],
              [-12.903914421816408, -11.524007800460872],
              [-12.904684277150416, -11.525075796616623],
              [-12.906327148949018, -11.525752776883602],
              [-12.907321931607052, -11.529331171262115],
              [-12.908330739738156, -11.53036065230484],
              [-12.91066261581316, -11.530818981534402],
              [-12.913212034827842, -11.52967922384993],
              [-12.914649494041514, -11.530418065405785],
              [-12.915488817537335, -11.53215624375258],
              [-12.914719002316943, -11.535575562503846],
              [-12.913029607616526, -11.537004257367844],
              [-12.911815052840527, -11.53716374155435],
              [-12.911293746477908, -11.538348261394397],
              [-12.90925585751702, -11.539992494648592],
              [-12.909635150533264, -11.542250289256142],
              [-12.908211499023137, -11.543458628154948],
              [-12.906192636363231, -11.543857735334399],
              [-12.904438099983022, -11.54471798251303],
              [-12.903588984089284, -11.546277528815617],
              [-12.902130817895895, -11.547740521771562],
              [-12.897962193723915, -11.547965365371613],
              [-12.897315927894907, -11.549457857215055],
              [-12.894797767204748, -11.550429489421909],
              [-12.895131089687785, -11.55266803828997],
              [-12.894677712238519, -11.554434373968723],
              [-12.895952486713195, -11.556235743616883],
              [-12.89587273087694, -11.556918364629114],
              [-12.893605168586902, -11.557759315723219],
              [-12.89396080870614, -11.559735834429208],
              [-12.892592923310172, -11.56238840326218],
              [-12.891162768717727, -11.563959293770953],
              [-12.889611453678691, -11.564794457547096],
              [-12.887807371436036, -11.566931745161426],
              [-12.888646327835183, -11.568931967590078],
              [-12.890163437063284, -11.569397999506636],
              [-12.894312572489024, -11.567537455089564],
              [-12.89779130269221, -11.567334437946055],
              [-12.899063446639966, -11.568210912088723],
              [-12.901238586050612, -11.568944067267616],
              [-12.905185120096828, -11.571202230660479],
              [-12.908083990557989, -11.572051093381885],
              [-12.910459435088962, -11.574846153993088],
              [-12.912723962379275, -11.575141471762073],
              [-12.912932974263596, -11.573502077589655],
              [-12.913848099426291, -11.571508016588451],
              [-12.917318454751618, -11.572303059275873],
              [-12.918263454618698, -11.571673939681565],
              [-12.920003955308076, -11.57171796555185],
              [-12.920933383309992, -11.570261172934627],
              [-12.921033111516788, -11.567091568091662],
              [-12.92187697155844, -11.565900423626285],
              [-12.924740974912439, -11.56591466926862],
              [-12.926983218251845, -11.564942691328705],
              [-12.928964941204091, -11.566224735298963],
              [-12.929888343189697, -11.5662466809408],
              [-12.931819985124564, -11.56517114504947],
              [-12.933676555432557, -11.565366095542707],
              [-12.93550578318113, -11.564365572693132],
              [-12.936746740663791, -11.562595839558831],
              [-12.938768095620992, -11.561345984601202],
              [-12.93945604703052, -11.559609901417197],
              [-12.940251469551306, -11.55921839900947],
              [-12.94233715231471, -11.56101082861348],
              [-12.945343810924376, -11.560468797977645],
              [-12.946904690881937, -11.560534158201687],
              [-12.949571132736459, -11.558774247700129],
              [-12.951022127984283, -11.557474189665616],
              [-12.953602767035113, -11.559518919149117],
              [-12.95434977242324, -11.560855650943074],
              [-12.956031563420934, -11.562439032585667],
              [-12.955647207657126, -11.56425434011364],
              [-12.954365942759834, -11.564059595217298],
              [-12.952939191128447, -11.564820559280802],
              [-12.953095945689471, -11.567288783990337],
              [-12.950066951573302, -11.567198137266933],
              [-12.948808820009875, -11.569937359024292],
              [-12.948959454812409, -11.571185904052143],
              [-12.950618741551496, -11.572700299666373],
              [-12.9502276915879, -11.573792773676415],
              [-12.950560488532775, -11.575542814704882],
              [-12.952100998151817, -11.577209513301653],
              [-12.953791350715704, -11.576338105404513],
              [-12.955715178605141, -11.577556031351984],
              [-12.958026267193354, -11.575423005661754],
              [-12.96107506944027, -11.575192652194353],
              [-12.96191712627117, -11.575928335731565],
              [-12.96313123290617, -11.575774018784902],
              [-12.963779716632871, -11.577090594103849],
              [-12.967087122097407, -11.580164370523988],
              [-12.97119674072184, -11.581590417587766],
              [-12.971523998300384, -11.582934218944553],
              [-12.972774510670723, -11.583962604866576],
              [-12.974019168014882, -11.582916296197254],
              [-12.97662260203243, -11.584127726181167],
              [-12.977972378992016, -11.583898143087263],
              [-12.978337220326983, -11.585095111654592],
              [-12.977539843993378, -11.586110911264695],
              [-12.97590840324237, -11.58678986505373],
              [-12.974904179916015, -11.588796345410415],
              [-12.97484714646031, -11.590132328701946],
              [-12.97607539062045, -11.591441297365098],
              [-12.978782055586192, -11.590666555059466],
              [-12.98132324248883, -11.592283531290462],
              [-12.981598270871393, -11.595177029025733],
              [-12.982637452012545, -11.59760833388136],
              [-12.981043528405593, -11.600520724912034],
              [-12.981402204208147, -11.601949268766539],
              [-12.980800841004609, -11.60605920229089],
              [-12.979892978126378, -11.6078179130974],
              [-12.982136060395389, -11.6099779577628],
              [-12.983174890492723, -11.613780531490866],
              [-12.982662077524873, -11.615135130958132],
              [-12.981144799925431, -11.616617455186187],
              [-12.978275863119487, -11.617778475757147],
              [-12.977064682264247, -11.619309378622344],
              [-12.974750144566075, -11.619982183158674],
              [-12.973494084367113, -11.62146320428083],
              [-12.974102338022279, -11.623535808832179],
              [-12.97323786500979, -11.62605821382658],
              [-12.9746289328889, -11.632139771026528],
              [-12.975656793762594, -11.632893356404729],
              [-12.976815373332682, -11.634655806443861],
              [-12.979570084978725, -11.635110086844783],
              [-12.981613954092929, -11.636338637179717],
              [-12.981383435404389, -11.637766277007875],
              [-12.983336735984224, -11.639580865002348],
              [-12.984715838288883, -11.640127794449654],
              [-12.984743545126255, -11.643229435163322],
              [-12.984235799760981, -11.644649740792417],
              [-12.982931225759033, -11.645301275918941],
              [-12.982056347815934, -11.647765693585193],
              [-12.982827771093724, -11.64875997708892],
              [-12.98532996253792, -11.649800793977219],
              [-12.987660331001408, -11.652260145442522],
              [-12.98787552111944, -11.653609688652054],
              [-12.989598349194113, -11.655634953446315],
              [-12.988092667680009, -11.658507294633443],
              [-12.988515999878768, -11.660694885853404],
              [-12.98750594962015, -11.661740175601334],
              [-12.983448037200624, -11.664297678184171],
              [-12.97841243336329, -11.666538828700938],
              [-12.974208175492842, -11.670101229869417],
              [-12.97353902903938, -11.671100946371181],
              [-12.970693549989125, -11.671921073072683],
              [-12.969804061973392, -11.673865409533883],
              [-12.968085204200586, -11.67425597158945],
              [-12.96812752387862, -11.675791365179924],
              [-12.967214588996955, -11.678720685911147],
              [-12.965999301819007, -11.679984663620177],
              [-12.968506558324448, -11.682361178969986],
              [-12.96807816817377, -11.684761163599891],
              [-12.968697185377813, -11.68729251589994],
              [-12.97002653490595, -11.689289680201782],
              [-12.970919934570608, -11.691566233661403],
              [-12.970412287317727, -11.693425071070402],
              [-12.96819002878283, -11.696723740686688],
              [-12.968198556965568, -11.69979962487876],
              [-12.968842588712345, -11.700914279999902],
              [-12.966822821697884, -11.70325331059494],
              [-12.964493251691696, -11.703707053464246],
              [-12.963313787542653, -11.706146368493963],
              [-12.96197509739364, -11.70763686160159],
              [-12.963462780426553, -11.709708501844023],
              [-12.964830907954253, -11.710425894736682],
              [-12.964867401093889, -11.71307113162502],
              [-12.966470922651224, -11.713496432945478],
              [-12.969013299185885, -11.71498009003922],
              [-12.971987309676756, -11.71351529825041],
              [-12.974422916971633, -11.713930808462715],
              [-12.976494878970287, -11.713239771525156],
              [-12.977306183810825, -11.71207232635105],
              [-12.98000929193006, -11.710413316161487],
              [-12.98103622519103, -11.710362938187746],
              [-12.983576442282752, -11.71182558114286],
              [-12.983218740425675, -11.712629817592596],
              [-12.985068225309902, -11.716638168387302],
              [-12.98485333456306, -11.718104452720516],
              [-12.983141150075282, -11.721518437802569],
              [-12.983459435714966, -11.722863249418875],
              [-12.982393373879471, -11.724871038373145],
              [-12.982434115278293, -11.725814964071729],
              [-12.98136608683098, -11.728684863920515],
              [-12.983305379665408, -11.73031216171344],
              [-12.985792370609152, -11.733223195437864],
              [-12.987860086120863, -11.733736178281868],
              [-12.989554420865277, -11.735342030819103],
              [-12.991186061160578, -11.735958953193617],
              [-12.993873679755955, -11.739579110668682],
              [-12.99399037052639, -11.741138871050767],
              [-12.995473217237903, -11.742979222033078],
              [-12.998579603343574, -11.744177806087995],
              [-13.00122114987675, -11.740594700582793],
              [-13.002567427549646, -11.73793391131688],
              [-13.004326497944259, -11.73665001065265],
              [-13.005837960495496, -11.733583648303684],
              [-13.00712218706684, -11.732239177400112],
              [-13.006856721668534, -11.730937064761944],
              [-13.009554802582164, -11.727587955561495],
              [-13.009925519712388, -11.72644956139103],
              [-13.011390176055539, -11.724583518523032],
              [-13.010922422309674, -11.723651339168962],
              [-13.015741543699946, -11.720598477283941],
              [-13.019143962272885, -11.717632376769192],
              [-13.020701595235886, -11.71591991243939],
              [-13.022210177846175, -11.714918821689944],
              [-13.02342173443276, -11.712849521494384],
              [-13.023467907664116, -11.711362580672965],
              [-13.024596219354867, -11.710743938968056],
              [-13.026110483688525, -11.712289266980303],
              [-13.027606972810547, -11.710678492087856],
              [-13.028171409608277, -11.709048986256686],
              [-13.029345602071812, -11.708082715793038],
              [-13.029047818437709, -11.705949129215615],
              [-13.025599369647061, -11.706056724592479],
              [-13.02445025433371, -11.706819506765514],
              [-13.022624407261599, -11.707038344221742],
              [-13.021807935320869, -11.708314846033852],
              [-13.018798611115725, -11.709339507365012],
              [-13.017620677924059, -11.710628904437897],
              [-13.01314314852056, -11.711852545144279],
              [-13.011899306621387, -11.711947110722422],
              [-13.011541151461154, -11.710276069797203],
              [-13.00923153600066, -11.709384769781536],
              [-13.009137487822715, -11.707098522760354],
              [-13.009914186804304, -11.703092062533456],
              [-13.01074670811916, -11.702160840210452],
              [-13.011501507658103, -11.698460428518183],
              [-13.01274314514119, -11.695531657024455],
              [-13.01440023554912, -11.694316614561243],
              [-13.014561957381307, -11.692432967517325],
              [-13.0132476094065, -11.690323735565332],
              [-13.015183543611155, -11.688306536163841],
              [-13.01389089091596, -11.687342207046498],
              [-13.012447344398316, -11.687731946512981],
              [-13.010353925602159, -11.687153679304867],
              [-13.008375143792211, -11.686104731829984],
              [-13.008253112173218, -11.684756254932921],
              [-13.00576357142449, -11.682214686223006],
              [-13.003606528389245, -11.681312742776749],
              [-13.001341890957546, -11.681014342869393],
              [-12.999347237449015, -11.68022473363647],
              [-12.997793273714723, -11.68057551813445],
              [-12.995213317572986, -11.679201565048562],
              [-12.992349059779434, -11.680613915224423],
              [-12.988399577891451, -11.680328873728623],
              [-12.985545423137392, -11.680580871741835],
              [-12.98629293889371, -11.678942276917182],
              [-12.989355860651022, -11.678445540013321],
              [-12.99098632140745, -11.677103928144156],
              [-12.992978620244719, -11.677264608967429],
              [-12.99366781204897, -11.674662495028857],
              [-12.993284031507935, -11.673855655878148],
              [-12.994860520617552, -11.672665789126484],
              [-12.995462120228257, -11.673061485495035],
              [-13.000583805994413, -11.67256363153635],
              [-13.00158248161637, -11.671290417933879],
              [-13.001183674514753, -11.66968020277627],
              [-13.002916373436708, -11.669027025887827],
              [-13.003904717890437, -11.667398472218318],
              [-13.003426971458342, -11.666295322801993],
              [-13.002095154819203, -11.66517077962503],
              [-13.002946246507559, -11.663230705935204],
              [-13.002557937036258, -11.661310435430659],
              [-13.001372363220375, -11.660331842719055],
              [-13.001493245479603, -11.65843754866632],
              [-12.999691267164138, -11.654857738383345],
              [-12.998637974771368, -11.653996294846477],
              [-12.998875772048963, -11.65226256701163],
              [-12.997472843672444, -11.651766674302081],
              [-12.998242476754278, -11.650695683996656],
              [-12.999803830553525, -11.650035539579713],
              [-13.002779912443504, -11.645476230769802],
              [-13.005527494919344, -11.643886324359872],
              [-13.007474617186286, -11.641979116023316],
              [-13.007663607894976, -11.640665769288328],
              [-13.009058188107646, -11.637172923093162],
              [-13.008620985265893, -11.634346038455893],
              [-13.005483247870913, -11.63235025336672],
              [-13.004960199569098, -11.631667139985973],
              [-13.00630036627679, -11.628544861156218],
              [-13.00496955857412, -11.628483503730687],
              [-13.004499203384979, -11.62694922395961],
              [-13.002620690829225, -11.626486312242674],
              [-13.001065625054887, -11.62678382499519],
              [-13.000214509468416, -11.625144945263548],
              [-13.001489505588962, -11.624174399692933],
              [-13.000098850070348, -11.622812855719474],
              [-12.998392400451928, -11.624241530779392],
              [-12.997288424513807, -11.622903978846484],
              [-12.99613383956298, -11.62290097919562],
              [-12.995106178625335, -11.621347086985205],
              [-12.993447621851162, -11.62102897744852],
              [-12.992255242727659, -11.619105783538094],
              [-12.995492998780756, -11.61774536056132],
              [-12.99663464805019, -11.615321363205249],
              [-12.99656019197188, -11.612038670319718],
              [-12.994548099746323, -11.6105633100378],
              [-12.99609994010355, -11.608457466614734],
              [-12.996981148493504, -11.606511485946886],
              [-12.998754624243963, -11.6045278775643],
              [-13.001238243474193, -11.600062884738108],
              [-13.00398625275999, -11.597133350196668],
              [-13.004256167662785, -11.595248179408568],
              [-13.004957608934154, -11.594858463725142],
              [-13.006724719347151, -11.59157531590251],
              [-13.006093664043277, -11.590230384544618],
              [-13.00811941754006, -11.587156735654936],
              [-13.008572245627345, -11.584924290163348],
              [-13.010097224628659, -11.580095181464587],
              [-13.009871196430735, -11.57867976150985],
              [-13.01136766767654, -11.571115052131542],
              [-13.011995324486229, -11.570653202843848],
              [-13.015158969713726, -11.561236616640658],
              [-13.016416106742719, -11.559043770930668],
              [-13.017810098503706, -11.555017222690184],
              [-13.01719318342126, -11.553920316477198],
              [-13.015964400169887, -11.553790662593933],
              [-13.011393511044048, -11.551356628657192],
              [-13.007807746070995, -11.548417517419677],
              [-13.003869980768876, -11.54689203668263],
              [-13.004213396923362, -11.546142865574527],
              [-13.004900883434008, -11.54182320487935],
              [-13.004058593121822, -11.540192159447482],
              [-13.002500271843006, -11.538861086878322],
              [-13.00091513714257, -11.538501872457225],
              [-12.999032282409885, -11.538847880593995],
              [-12.997200487747836, -11.538634557095525],
              [-12.99253514828092, -11.539861511074342],
              [-12.991613417279016, -11.538803004053866],
              [-12.991802898770395, -11.537021519523503],
              [-12.988805920819328, -11.537199205807473],
              [-12.988641170613269, -11.536421873013321],
              [-12.98639687541919, -11.535369597466133],
              [-12.984280263384672, -11.532028539382074],
              [-12.982912263135438, -11.531610263899642],
              [-12.98101773271445, -11.53274317730814],
              [-12.975879821118465, -11.532672979097018],
              [-12.972475382823193, -11.533506107189709],
              [-12.970974146176811, -11.534147500889723],
              [-12.969465060560896, -11.533367176515824],
              [-12.968172219158534, -11.53136162596098],
              [-12.966697431795987, -11.530279697566788],
              [-12.964079061195937, -11.530345516219404],
              [-12.96050599991766, -11.53157536967329],
              [-12.959175102365679, -11.531119183520275],
              [-12.959475302662845, -11.529730351081593],
              [-12.961186665636712, -11.526034574632634],
              [-12.96215577274142, -11.52667965934992],
              [-12.964712672870293, -11.52630487099902],
              [-12.967720055001555, -11.524665422470566],
              [-12.969437390759273, -11.525133140336836],
              [-12.97161717873807, -11.524027614253226],
              [-12.974727841973069, -11.525115147070023],
              [-12.976904084867003, -11.525185806380126],
              [-12.978748313846559, -11.52646442900863],
              [-12.98393326718848, -11.525085611687674],
              [-12.985319906773437, -11.52517402480546],
              [-12.987314660656258, -11.52616620753585],
              [-12.988765213018377, -11.528485947027786],
              [-12.990246234500763, -11.52968677989674],
              [-12.992119523131734, -11.530540547831517],
              [-12.994959785218285, -11.530665604529457],
              [-12.99750388990409, -11.531626541908707],
              [-12.998372899880259, -11.531104979282262],
              [-13.000706380902729, -11.531417222383403],
              [-13.005935538382115, -11.530309986586582],
              [-13.009566619468458, -11.533172985426797],
              [-13.011165821718794, -11.532586294257126],
              [-13.01505790624403, -11.53200761916473],
              [-13.016992415728087, -11.53206170971246],
              [-13.017414587731261, -11.532804655175843],
              [-13.015620204379317, -11.534501681677924],
              [-13.013816148668196, -11.535115495554468],
              [-13.011541318175171, -11.537202651476399],
              [-13.012213637675211, -11.538414793562943],
              [-13.012711393212005, -11.540816134160176],
              [-13.011668266578516, -11.541904173017395],
              [-13.013066143574074, -11.544431748986566],
              [-13.013861484755266, -11.54497562772007],
              [-13.014077686686973, -11.546513772136782],
              [-13.016050467709956, -11.546603846762224],
              [-13.018962927030856, -11.54763559809792],
              [-13.019762561781864, -11.548697987781045],
              [-13.02181792093522, -11.549943752949641],
              [-13.023995918847472, -11.549309298368824],
              [-13.025251130301678, -11.550188450036426],
              [-13.024748849020318, -11.551553127373177],
              [-13.026857565497721, -11.554595753860028],
              [-13.025277938254858, -11.55812302839598],
              [-13.025188473179988, -11.559702518468209],
              [-13.024200347014975, -11.563286480340137],
              [-13.023908017086333, -11.567538045936221],
              [-13.023096487023583, -11.569050809272065],
              [-13.023152185109197, -11.571333918097118],
              [-13.024753744547684, -11.572245926937805],
              [-13.027289169192727, -11.570533410717355],
              [-13.027610533493114, -11.569889282866752],
              [-13.029979017967857, -11.568714582406185],
              [-13.031050167729688, -11.569218580093485],
              [-13.028547805315803, -11.572872382583084],
              [-13.028787073524445, -11.57386641615544],
              [-13.028237216234842, -11.577744837280564],
              [-13.029843710714752, -11.579799291318833],
              [-13.030902893517135, -11.579361097789572],
              [-13.034460249667273, -11.576395985491],
              [-13.036020835365722, -11.57550113372244],
              [-13.036458030494067, -11.574109723158692],
              [-13.037373085741656, -11.573311136637068],
              [-13.038387106080593, -11.571248651139074],
              [-13.04110326090152, -11.569373078011852],
              [-13.041916666095336, -11.567723370633583],
              [-13.044764782580163, -11.566636599282923],
              [-13.044938655730746, -11.56851973943856],
              [-13.046014676961917, -11.570200783493878],
              [-13.048387172785924, -11.571423117916313],
              [-13.050464789575821, -11.568231735765101],
              [-13.051573442656624, -11.568626730180528],
              [-13.053102612106827, -11.567673568690266],
              [-13.055025586671176, -11.567763921417813],
              [-13.056941547440122, -11.569699951378087],
              [-13.054621000530455, -11.572717819997044],
              [-13.049279228651441, -11.575423533582434],
              [-13.048562725985482, -11.577129676348058],
              [-13.047493591913968, -11.577180366718691],
              [-13.04584629556561, -11.578960124583704],
              [-13.044191518486242, -11.578205532941128],
              [-13.043171166003011, -11.579266402217236],
              [-13.038272861812345, -11.580822903991232],
              [-13.038190229062822, -11.581900854072464],
              [-13.039667801438727, -11.583838370354858],
              [-13.039053581896543, -11.584546326012138],
              [-13.037257310164373, -11.583872500169408],
              [-13.036239842417531, -11.582930323815173],
              [-13.034508967918034, -11.584802845171655],
              [-13.033073912024708, -11.585476055900543],
              [-13.034315410859591, -11.587599892544901],
              [-13.03419748501172, -11.588498719968099],
              [-13.032311965447299, -11.588708551634866],
              [-13.031441354804638, -11.590148633339622],
              [-13.032069606976625, -11.59155053099354],
              [-13.033095380959722, -11.590462519185717],
              [-13.035757365780583, -11.591186013197596],
              [-13.03625802670935, -11.592628621559276],
              [-13.034711755772932, -11.593410052771473],
              [-13.03494117205256, -11.594858337112655],
              [-13.036092446566304, -11.595700937055044],
              [-13.037148206124492, -11.594851297485892],
              [-13.037592836234317, -11.593436465657138],
              [-13.037813183891938, -11.589926059878767],
              [-13.038860941534363, -11.589098388246862],
              [-13.039850266942363, -11.58998276785737],
              [-13.041001458994435, -11.5899108133395],
              [-13.04137320049843, -11.591935038448907],
              [-13.040277183368657, -11.594166277778529],
              [-13.041168406622957, -11.595474609257915],
              [-13.03850585334146, -11.597781539484458],
              [-13.040045961899873, -11.59905982655573],
              [-13.040893847292214, -11.598582254589568],
              [-13.042918857148692, -11.599379434583247],
              [-13.044502258429688, -11.599475277582034],
              [-13.045676346310914, -11.600324323363662],
              [-13.04650080739541, -11.599926043930271],
              [-13.047255781663848, -11.598037116607877],
              [-13.048425746025856, -11.596503924406584],
              [-13.049290909396888, -11.596480009161095],
              [-13.050647482211042, -11.598423487878108],
              [-13.050714532237505, -11.599287569546147],
              [-13.053958701131956, -11.600873742429966],
              [-13.051593077905672, -11.604582976866155],
              [-13.049012886044787, -11.60432441940092],
              [-13.04682479169215, -11.60561561023199],
              [-13.045404155629805, -11.605261982458309],
              [-13.043771760321311, -11.605727859325638],
              [-13.042959302727434, -11.605171517617952],
              [-13.041872641368847, -11.606537547593364],
              [-13.039237698437795, -11.608473641271026],
              [-13.039666031458141, -11.60907411173611],
              [-13.044126388179413, -11.609287916291146],
              [-13.045325298578284, -11.609928384673596],
              [-13.045251379701208, -11.610986921275178],
              [-13.044280539550106, -11.612227814572526],
              [-13.041193881062705, -11.611727459822255],
              [-13.038759228679606, -11.61329822213545],
              [-13.03861391575732, -11.614983626383019],
              [-13.035699029103744, -11.61771927289162],
              [-13.034283253106667, -11.618402360537482],
              [-13.032765048379902, -11.619942963615797],
              [-13.03196074268485, -11.622180616249844],
              [-13.033223441057638, -11.625109077126302],
              [-13.033169855281429, -11.626320578492114],
              [-13.0319065142267, -11.627127849994602],
              [-13.02967532633919, -11.627611856888803],
              [-13.027407865168719, -11.629126518492695],
              [-13.026566301091044, -11.630189139036903],
              [-13.024690168686055, -11.631029974939688],
              [-13.024762613562045, -11.632190908479439],
              [-13.023035134980463, -11.633832513271809],
              [-13.021694666090465, -11.636510300881012],
              [-13.021331257861547, -11.63811508141943],
              [-13.021436174485352, -11.64096460115558],
              [-13.022341909463536, -11.641902293262259],
              [-13.022505305275592, -11.643960606624763],
              [-13.023562713521384, -11.645946764442515],
              [-13.026799865559813, -11.647133989313467],
              [-13.02905544789686, -11.64699993192222],
              [-13.030127567285716, -11.64521754668774],
              [-13.031264269612196, -11.645353275691125],
              [-13.031783979061142, -11.644234521578742],
              [-13.033926123196608, -11.641596978536858],
              [-13.035928752500656, -11.638719131534243],
              [-13.037168438934344, -11.639180747081026],
              [-13.035971421396152, -11.642978803507201],
              [-13.036018340749395, -11.644531943473766],
              [-13.037464679858369, -11.646178728050202],
              [-13.035800281446335, -11.647361237857321],
              [-13.036639770284847, -11.649382083165309],
              [-13.037967907856217, -11.65003835035452],
              [-13.038078656923222, -11.651947410343768],
              [-13.039456011457995, -11.650991996432593],
              [-13.040355828284405, -11.654067103638477],
              [-13.042084599150616, -11.65092583077295],
              [-13.043169945452533, -11.650418469322153],
              [-13.045613971689146, -11.650386696604743],
              [-13.0469442703564, -11.650732071414783],
              [-13.047443827194773, -11.652056264847994],
              [-13.046181372775877, -11.65454570291179],
              [-13.048444351185845, -11.65711710737405],
              [-13.050183365758102, -11.65692254978135],
              [-13.051183947650498, -11.658364362103944],
              [-13.050430594325185, -11.660044873297592],
              [-13.049484846235796, -11.660575655356341],
              [-13.047269029162823, -11.660371026246398],
              [-13.045618435830207, -11.662936959928684],
              [-13.048358919338098, -11.664256759380466],
              [-13.047623447255809, -11.665259798338187],
              [-13.047777467817344, -11.666719557503034],
              [-13.0496428088787, -11.667869385252034],
              [-13.049604058701773, -11.668872365782393],
              [-13.053798331563119, -11.669439641717561],
              [-13.053457824027092, -11.671137669534627],
              [-13.052437921133093, -11.673093503982212],
              [-13.051168629367456, -11.673349314595034],
              [-13.050186554497376, -11.67227512232533],
              [-13.049427777289734, -11.6735450932705],
              [-13.047969061535118, -11.673351320621546],
              [-13.045993298921214, -11.674652355268426],
              [-13.044624891019042, -11.676686900655898],
              [-13.04627333222404, -11.678683376761212],
              [-13.045893582656236, -11.680707768550157],
              [-13.043079334816921, -11.682650432505406],
              [-13.04429489712781, -11.682981111502885],
              [-13.045976782909685, -11.681677896500837],
              [-13.048601798393697, -11.677715713121577],
              [-13.050216043850252, -11.67788796955725],
              [-13.049105463294223, -11.680105222848967],
              [-13.049188798673724, -11.68114739337569],
              [-13.051738684212111, -11.681605304502295],
              [-13.052934578039483, -11.682919232135202],
              [-13.05512673530588, -11.684526234153244],
              [-13.056698934536316, -11.683336042929012],
              [-13.057191038663111, -11.681283166126232],
              [-13.058004322170936, -11.680851646873709],
              [-13.059696688014563, -11.67836833961755],
              [-13.0611868244026, -11.678185003219596],
              [-13.06417725330729, -11.675358538789757],
              [-13.06352188246746, -11.673476674575792],
              [-13.0634052676614, -11.671531493475918],
              [-13.065956361695639, -11.66940646191308],
              [-13.065914807791454, -11.668106063438712],
              [-13.063858006363873, -11.667434489255573],
              [-13.062963132544033, -11.666607771105221],
              [-13.063226656542989, -11.665343967212717],
              [-13.064959199926347, -11.663311514699394],
              [-13.062863212676804, -11.66269101610557],
              [-13.062091861301239, -11.660723381422699],
              [-13.062285545738598, -11.658737660610399],
              [-13.065630501404032, -11.658155664263216],
              [-13.067822203684699, -11.656927516040366],
              [-13.069273856763541, -11.654851972443623],
              [-13.07254537418747, -11.653835540306751],
              [-13.073898419573496, -11.655635540624596],
              [-13.07741270441893, -11.65659814479345],
              [-13.078134268736946, -11.654499000670096],
              [-13.080080218289654, -11.655477906914625],
              [-13.081369870349345, -11.654866903836066],
              [-13.082345881971813, -11.65345405559838],
              [-13.081702027210076, -11.652471055282607],
              [-13.079449931721323, -11.652812958140546],
              [-13.079060337701666, -11.65080548299788],
              [-13.080272510194954, -11.649206238736928],
              [-13.082935568221137, -11.648879941283168],
              [-13.085719013981999, -11.649813375035803],
              [-13.086549021213074, -11.64792723178937],
              [-13.08343780594816, -11.646204342287978],
              [-13.082640424851055, -11.645098894847985],
              [-13.082727300651293, -11.64349034733434],
              [-13.084441097467492, -11.643140843000573],
              [-13.088267715755082, -11.643847575262049],
              [-13.088807589254012, -11.642845994934147],
              [-13.087519255987836, -11.64138692156111],
              [-13.085206126726668, -11.64091385283533],
              [-13.08350988983971, -11.639987534924401],
              [-13.083123326364538, -11.63843355562737],
              [-13.08148658209604, -11.637473193227725],
              [-13.080426765615258, -11.63791774773704],
              [-13.078221186557585, -11.636491705386451],
              [-13.0775592153931, -11.63492526674616],
              [-13.075990305544032, -11.632577939987861],
              [-13.075643542344157, -11.631308087333586],
              [-13.075724255982358, -11.628158762519801],
              [-13.076345349823656, -11.625645580545292],
              [-13.077140412233968, -11.625186803928731],
              [-13.078932847723262, -11.626525189121788],
              [-13.07784354578448, -11.628762963023478],
              [-13.078017802108846, -11.630889709649017],
              [-13.079141638743467, -11.632536368169081],
              [-13.080711065715072, -11.633102389778594],
              [-13.082071123052067, -11.632781623797362],
              [-13.083271732569107, -11.633779009385927],
              [-13.08651773003718, -11.633815079233047],
              [-13.087509800047242, -11.635705775119549],
              [-13.090163138079724, -11.635184531211705],
              [-13.092456795511177, -11.636709416949259],
              [-13.09323160074602, -11.635593517649987],
              [-13.092913006126038, -11.634165951028413],
              [-13.093703621920653, -11.632646436570015],
              [-13.094696978569853, -11.634319897710101],
              [-13.0958051312699, -11.634516030230214],
              [-13.09560541711397, -11.632599043086655],
              [-13.096562744165707, -11.63166366267648],
              [-13.09628427795435, -11.629048307774125],
              [-13.09685130939744, -11.626110290054605],
              [-13.096180225854154, -11.624855978100957],
              [-13.09587926013346, -11.622666348359893],
              [-13.095112025300104, -11.621764778708249],
              [-13.096291283265462, -11.62011093597076],
              [-13.095914494414622, -11.618785612842922],
              [-13.097856922796153, -11.61690279675979],
              [-13.098940221981536, -11.617523743839547],
              [-13.099586972466913, -11.619345864567897],
              [-13.099404026595252, -11.620998854883855],
              [-13.10178089066704, -11.622612970996716],
              [-13.104323877049438, -11.622296221864195],
              [-13.106814397626142, -11.620664595028405],
              [-13.10748886389296, -11.620766228331032],
              [-13.1090611945166, -11.622531002668241],
              [-13.110533923339709, -11.623158278478627],
              [-13.109814415732998, -11.624497706693791],
              [-13.109149303203882, -11.62899672226864],
              [-13.11162303941374, -11.628486589992724],
              [-13.112652145520647, -11.627550852041525],
              [-13.114119857115098, -11.627263348845394],
              [-13.117034753220013, -11.6255288082013],
              [-13.118511171525121, -11.624211555574737],
              [-13.12009610336671, -11.623506272495419],
              [-13.12133483000188, -11.62388733491175],
              [-13.121266743224659, -11.625305455176852],
              [-13.119975577303, -11.62572303300946],
              [-13.119189048259551, -11.626810175579807],
              [-13.120868049615982, -11.627191554613626],
              [-13.122387292574066, -11.626392105137812],
              [-13.123743397716765, -11.627003365916897],
              [-13.123032943142722, -11.628355057114733],
              [-13.123234010988337, -11.629933745456986],
              [-13.12181700483119, -11.63100705956978],
              [-13.121498846298962, -11.633304387137917],
              [-13.122678755072505, -11.634578686241872],
              [-13.121649554483929, -11.636379792833312],
              [-13.119307245103654, -11.637151347272395],
              [-13.11641291167956, -11.638823649338052],
              [-13.115505701883672, -11.641771040719426],
              [-13.115885460023073, -11.643385376941952],
              [-13.11523779259376, -11.644495410076868],
              [-13.116711461000524, -11.64670791237255],
              [-13.117692273597056, -11.64579429596379],
              [-13.118595131069625, -11.64362243114674],
              [-13.120822580951046, -11.643201048426706],
              [-13.12080099979538, -11.64081070529992],
              [-13.122057431591836, -11.639563643048684],
              [-13.124346126448764, -11.64182437697728],
              [-13.125506250327222, -11.641722537026446],
              [-13.126939129189633, -11.639235768199287],
              [-13.127766996252081, -11.639240299531101],
              [-13.128826401283415, -11.637137730402504],
              [-13.130426190459108, -11.63710737692298],
              [-13.133134418277722, -11.634461239280363],
              [-13.135145013609161, -11.631420388198995],
              [-13.135995977488461, -11.628986292964008],
              [-13.13733069219476, -11.628869080082877],
              [-13.139068364521615, -11.627276109565765],
              [-13.139486188586709, -11.626332723483447],
              [-13.141487154995561, -11.624466110023048],
              [-13.142674099752972, -11.62439158434461],
              [-13.143781009179046, -11.62331825260369],
              [-13.143714576845253, -11.621210898249343],
              [-13.145499079502603, -11.62101560904468],
              [-13.146249080117242, -11.619566713382198],
              [-13.145955668625515, -11.617841308294539],
              [-13.147500453358747, -11.616163320515037],
              [-13.149609115007724, -11.61462049005021],
              [-13.15269853754424, -11.610299581995417],
              [-13.152080545602749, -11.607975339922213],
              [-13.15358612285316, -11.603891730338743],
              [-13.155071424269117, -11.604111218760853],
              [-13.156591581483028, -11.601996435811047],
              [-13.155172268329778, -11.601295663421517],
              [-13.151610767235212, -11.604254996601993],
              [-13.149371845988846, -11.604100995889208],
              [-13.148559574013582, -11.602974811757814],
              [-13.150366449687917, -11.601240648466064],
              [-13.149920068805992, -11.599682905879966],
              [-13.151265812794968, -11.599235273666725],
              [-13.151631249360687, -11.5977268641537],
              [-13.15385402691695, -11.59620054574161],
              [-13.15533030499596, -11.594216672178167],
              [-13.155666006335416, -11.592579528751502],
              [-13.154028305919104, -11.589870022565107],
              [-13.15344362935599, -11.588077161637642],
              [-13.159405646439344, -11.586788625004491],
              [-13.159719391039335, -11.5861496965783],
              [-13.159199910245134, -11.583733634437971],
              [-13.157943177138927, -11.581555844021413],
              [-13.157461047006416, -11.5794627392519],
              [-13.158512489173958, -11.579016152381197],
              [-13.157855208305802, -11.577440227991557],
              [-13.154226857627945, -11.575804281335166],
              [-13.152788163853101, -11.576817334805364],
              [-13.151503391920343, -11.576374581649974],
              [-13.148743128585236, -11.576693169515723],
              [-13.146867223177516, -11.575842026099721],
              [-13.146007447128905, -11.57386367793995],
              [-13.143232996235305, -11.57365080453647],
              [-13.140891647395824, -11.571952784378167],
              [-13.140581025263218, -11.569651466309505],
              [-13.141051947310016, -11.56705688632061],
              [-13.14170302482224, -11.556875532395392],
              [-13.142190067319216, -11.553524027692921],
              [-13.142142851683419, -11.551454622526132],
              [-13.141461410159256, -11.549464534731163],
              [-13.140408036591515, -11.547782262977208],
              [-13.138880994013649, -11.546278743975375],
              [-13.13880779850887, -11.543222484128423],
              [-13.140436087890121, -11.541584479682273],
              [-13.140650434577223, -11.54024656209836],
              [-13.139982739007724, -11.539144487844984],
              [-13.139848444284457, -11.537406344841749],
              [-13.138699835259096, -11.535240667667003],
              [-13.137248401979575, -11.53471518977492],
              [-13.136045339260859, -11.535322416903682],
              [-13.13307090622392, -11.534010904112195],
              [-13.131604583947633, -11.532550113124394],
              [-13.128850755669664, -11.530808745842576],
              [-13.127523061340538, -11.529440668116077],
              [-13.12545303033238, -11.526204898205433],
              [-13.122926141535613, -11.524913619960826],
              [-13.119559634315499, -11.525549761490073],
              [-13.117757906235965, -11.52803477829133],
              [-13.114936227822081, -11.528893466573424],
              [-13.111230120346907, -11.533377176884834],
              [-13.108921678202956, -11.534645032811039],
              [-13.107626458796206, -11.535793566245092],
              [-13.107419641002261, -11.537876253957158],
              [-13.106815555411925, -11.539206205511894],
              [-13.107843359695305, -11.544697520965498],
              [-13.106984529657966, -11.547474610440203],
              [-13.105486325570705, -11.548092146804576],
              [-13.104900657519755, -11.550134168832317],
              [-13.102879944745279, -11.551619065170643],
              [-13.102346345414107, -11.553308918969313],
              [-13.102568340999309, -11.555262717975728],
              [-13.103426166760025, -11.556537180592164],
              [-13.103637671945007, -11.558186525924967],
              [-13.103248019675267, -11.559969160322613],
              [-13.09774851373354, -11.562128676677574],
              [-13.0956146033841, -11.562380228413636],
              [-13.092850016134827, -11.563698578837299],
              [-13.092446624588103, -11.564780399863597],
              [-13.08788401433932, -11.568108887842621],
              [-13.083531173962815, -11.57011681034197],
              [-13.081195121822265, -11.569533478646715],
              [-13.080311512460645, -11.568137609701385],
              [-13.075160826295166, -11.567080823108645],
              [-13.074044390257177, -11.567349632135707],
              [-13.070987517469126, -11.565325561182481],
              [-13.069131650081738, -11.565187151495246],
              [-13.06891092353764, -11.56329114267484],
              [-13.07093644124056, -11.562095643184154],
              [-13.075082658017484, -11.562804086355914],
              [-13.077291636407127, -11.562483690276002],
              [-13.081792784704163, -11.560049344865645],
              [-13.083868741313257, -11.559828210260084],
              [-13.08662942278265, -11.55734314609875],
              [-13.089221157151966, -11.556191055883868],
              [-13.090425244178205, -11.556468874173033],
              [-13.095181423579534, -11.550740460192134],
              [-13.097903258128216, -11.546000768832702],
              [-13.10135785036357, -11.544298149276171],
              [-13.102373654556459, -11.543390226237793],
              [-13.102566751092938, -11.54196673962856],
              [-13.102013202339535, -11.54045158265259],
              [-13.101789630318509, -11.535426625950846],
              [-13.104422849766921, -11.522775436799176],
              [-13.107721170399072, -11.522053662595361],
              [-13.108414768499436, -11.520806545803655],
              [-13.108291988068357, -11.518708920988043],
              [-13.110992732294662, -11.516170942568248],
              [-13.112366336685579, -11.513700678922419],
              [-13.111616566987422, -11.509071093912391],
              [-13.11185814515267, -11.507385868661505],
              [-13.110019848858181, -11.505822669904575],
              [-13.10966308087854, -11.504607019891603],
              [-13.112612778852748, -11.499575063987846],
              [-13.113907438565088, -11.499336774027693],
              [-13.117329399016306, -11.497589662366446],
              [-13.123462208748807, -11.491679946868604],
              [-13.123991231578017, -11.490331598015329],
              [-13.125596397705085, -11.48862406490062],
              [-13.12674325586253, -11.48557445556356],
              [-13.128478117646674, -11.48291029670521],
              [-13.130051372745456, -11.47979047429273],
              [-13.129857742746184, -11.477513002675291],
              [-13.128698753261395, -11.477225089837813],
              [-13.124128950368753, -11.477425974000363],
              [-13.121899873863418, -11.479258092205594],
              [-13.117364451833529, -11.480754954224128],
              [-13.112181204735688, -11.481178377343971],
              [-13.108613487053143, -11.480708119986259],
              [-13.10644092883972, -11.479986012321081],
              [-13.10448455253143, -11.481717773991283],
              [-13.100565984766765, -11.482397256015478],
              [-13.097825600169815, -11.485126555118443],
              [-13.096319593587557, -11.488630326364719],
              [-13.094084727569875, -11.490318550306908],
              [-13.092792286048429, -11.492225549316936],
              [-13.093859976292304, -11.493344369549998],
              [-13.093749106845797, -11.49464347577355],
              [-13.092098525694563, -11.495763861656727],
              [-13.091876520885783, -11.49836232917098],
              [-13.089161067671633, -11.499891940920003],
              [-13.086463900474612, -11.502764840523211],
              [-13.084432771615813, -11.503997675415645],
              [-13.081092547053236, -11.505080475683169],
              [-13.079184902943341, -11.505255789082602],
              [-13.07657243393739, -11.504383084327063],
              [-13.076213865482316, -11.503737696149722],
              [-13.07811576070863, -11.500646810059715],
              [-13.079543938019889, -11.50031204698301],
              [-13.080544741449929, -11.498831618562498],
              [-13.081322888174043, -11.494221068172438],
              [-13.084060611003794, -11.491794099873836],
              [-13.08595997351565, -11.490519146262262],
              [-13.087194048885948, -11.488783904531605],
              [-13.093569169555579, -11.477415027403678],
              [-13.093647644653876, -11.476630738153531],
              [-13.097660669375196, -11.47568131780551],
              [-13.10016959021103, -11.473896758740667],
              [-13.10648650101073, -11.47090352491538],
              [-13.110952216453004, -11.473388460903783],
              [-13.113660556110853, -11.471716978717936],
              [-13.114654977647055, -11.470381247382898],
              [-13.116197876988387, -11.469418056801107],
              [-13.117308230915922, -11.46802566493731],
              [-13.119286144145537, -11.466921860049517],
              [-13.121735666207655, -11.46697295732122],
              [-13.125062319294074, -11.465602177906081],
              [-13.128652870154127, -11.463462891930009],
              [-13.13133851814171, -11.459598016071789],
              [-13.13230675343668, -11.454405905680682],
              [-13.134092565294628, -11.45156426856436],
              [-13.135992936357582, -11.446933696777165],
              [-13.136614924223288, -11.444148400833287],
              [-13.137566555646254, -11.441947399191738],
              [-13.135193840006341, -11.439452902356209],
              [-13.13497633774166, -11.434349808853181],
              [-13.13380100308028, -11.425183017210388],
              [-13.13601248358834, -11.424921010939475],
              [-13.137757340213787, -11.425452086743848],
              [-13.142135271006104, -11.43064876643001],
              [-13.144450723284917, -11.432743014835768],
              [-13.146315430865343, -11.436548297578703],
              [-13.149443496302682, -11.440654234900647],
              [-13.152572332531415, -11.44263537012485],
              [-13.159238820308863, -11.446112682606634],
              [-13.160556451631994, -11.445502985358003],
              [-13.163939882235217, -11.445335593777157],
              [-13.1683771685883, -11.445466478864782],
              [-13.171849405936051, -11.444188993647211],
              [-13.173005204188152, -11.44433126294025],
              [-13.177632633141494, -11.442910756273163],
              [-13.17903645776511, -11.441760004781889],
              [-13.179895104375587, -11.438678336795057],
              [-13.179669290613111, -11.436236325704323],
              [-13.178577207970392, -11.433936699650777],
              [-13.180762696428097, -11.431481315015091],
              [-13.18180289283339, -11.43111195923839],
              [-13.18333134230916, -11.431849525130529],
              [-13.183372287338877, -11.432999085933552],
              [-13.184564753613328, -11.434116642054583],
              [-13.187099477796822, -11.431237929695923],
              [-13.187782086891737, -11.428811278723769],
              [-13.187511998950724, -11.426640889726876],
              [-13.185622240679248, -11.426542342150757],
              [-13.184203782102985, -11.428585895835544],
              [-13.18301988675228, -11.428955019341211],
              [-13.182242973003065, -11.427848258862284],
              [-13.178739872669297, -11.426415381150509],
              [-13.17955453880734, -11.423748443833531],
              [-13.179601171091136, -11.422485973579512],
              [-13.178679765883196, -11.421805056404187],
              [-13.179510152259098, -11.418671198451843],
              [-13.18163260081414, -11.417664871478117],
              [-13.182722494362032, -11.41597478454171],
              [-13.185815533059088, -11.414126085126624]
            ]
          ],
          [
            [
              [-13.186919311190062, -11.61068434612461],
              [-13.186194466750763, -11.61045071583345],
              [-13.183704559115919, -11.613026672996003],
              [-13.184897008824281, -11.613028390481867],
              [-13.186423072786786, -11.612109272554793],
              [-13.186919311190062, -11.61068434612461]
            ]
          ],
          [
            [
              [-13.195478446111599, -11.60637172144007],
              [-13.196541285040716, -11.603129821093278],
              [-13.19513616300379, -11.602606107754626],
              [-13.194020183062184, -11.603250506790694],
              [-13.194381212640337, -11.606162134747716],
              [-13.195478446111599, -11.60637172144007]
            ]
          ],
          [
            [
              [-13.191463178819983, -11.628084410795871],
              [-13.191166079214147, -11.625117587132793],
              [-13.189215872163684, -11.624322680932476],
              [-13.191332997989962, -11.622802798605182],
              [-13.190197864829749, -11.620595558417072],
              [-13.189103340482509, -11.621535193003899],
              [-13.187435835615808, -11.62193150221534],
              [-13.186426817632269, -11.620075461844216],
              [-13.183062892408886, -11.62102522733373],
              [-13.182566116331577, -11.618951043797589],
              [-13.181212535523686, -11.61913659211049],
              [-13.181818908233543, -11.621174655517486],
              [-13.180611162107706, -11.621287958590138],
              [-13.178992257286128, -11.623494224874518],
              [-13.176718974573188, -11.62496336631612],
              [-13.175192383815917, -11.626529802449625],
              [-13.172799183127422, -11.627337752690803],
              [-13.172635881141598, -11.629344582136481],
              [-13.17340090787456, -11.63054975968346],
              [-13.174914948506489, -11.629601377537847],
              [-13.178100370932006, -11.629120060820942],
              [-13.179649102755551, -11.630098218104267],
              [-13.180058749578587, -11.632217822032311],
              [-13.178274764818891, -11.633463120605697],
              [-13.180023904776888, -11.635080885460749],
              [-13.181919820672803, -11.634445961056779],
              [-13.182721591315051, -11.633219373110967],
              [-13.18589354437555, -11.633067077378142],
              [-13.186481554565301, -11.631604309918727],
              [-13.188044746126051, -11.630431382507311],
              [-13.191138840492131, -11.629415948271912],
              [-13.191463178819983, -11.628084410795871]
            ]
          ],
          [
            [
              [-13.210622239132833, -11.609442658992837],
              [-13.20573519193506, -11.606824661464717],
              [-13.203235527564157, -11.606810289860217],
              [-13.200427607427232, -11.608297483167119],
              [-13.196132777504573, -11.609354252245053],
              [-13.195178351505131, -11.610242313850781],
              [-13.192833827924762, -11.611065769937408],
              [-13.19205525234374, -11.612153751246156],
              [-13.190518902984833, -11.612018058378158],
              [-13.187907995049581, -11.614357546057771],
              [-13.18772257163265, -11.61585219394586],
              [-13.190133536683158, -11.616939230225034],
              [-13.193092473065374, -11.615810930635478],
              [-13.19523676845832, -11.616022400444937],
              [-13.196682478576442, -11.617156218379636],
              [-13.198563498859384, -11.615608945528516],
              [-13.200899896876502, -11.61466223936473],
              [-13.201911603762934, -11.613529230563334],
              [-13.203588502351879, -11.61404356305788],
              [-13.204301122068452, -11.613149014021094],
              [-13.203879441846084, -11.612010091507331],
              [-13.204985310034049, -11.610812156060552],
              [-13.206356276622065, -11.61165799219116],
              [-13.207708192362768, -11.611542021513609],
              [-13.210622239132833, -11.609442658992837]
            ]
          ],
          [
            [
              [-13.21743678026039, -11.589908381731837],
              [-13.218186765937158, -11.586571956500137],
              [-13.217319779275247, -11.58524485716239],
              [-13.218137800449759, -11.583957786451892],
              [-13.217242353077152, -11.582716842732586],
              [-13.214917501290419, -11.583139373699883],
              [-13.214325305962577, -11.581137561827793],
              [-13.212756710537137, -11.581039513885214],
              [-13.211011437583512, -11.582267175299808],
              [-13.209911912082443, -11.584537267987589],
              [-13.20996242010987, -11.58612761486952],
              [-13.208981350353563, -11.587100449107348],
              [-13.208969197475048, -11.58945840904321],
              [-13.210186943393865, -11.590899077635912],
              [-13.211638243957518, -11.590625188776297],
              [-13.212021951802935, -11.591583316702541],
              [-13.213865385145622, -11.592460714214532],
              [-13.217221856686193, -11.590769814219039],
              [-13.21743678026039, -11.589908381731837]
            ]
          ],
          [
            [
              [-13.214263466445823, -11.600939898424349],
              [-13.21381678832913, -11.599221693051875],
              [-13.212731760950467, -11.598324795489859],
              [-13.215655472430075, -11.595897280662872],
              [-13.21594238279254, -11.59482014666935],
              [-13.211600064788884, -11.59357142627378],
              [-13.209315762042321, -11.59372114408602],
              [-13.207727816235307, -11.592877463058336],
              [-13.206348172798407, -11.592863642868764],
              [-13.2049427248757, -11.593796490909126],
              [-13.204574448614979, -11.594823686080979],
              [-13.201073943439884, -11.594104214178042],
              [-13.198432548766219, -11.598794069785765],
              [-13.197691139702338, -11.597815378724334],
              [-13.19564640133991, -11.600142548566085],
              [-13.195256085012867, -11.601378704260332],
              [-13.198999167536874, -11.599931481237792],
              [-13.199678290542856, -11.601750041698894],
              [-13.199573913437852, -11.603149660490296],
              [-13.20050650198602, -11.604285601596485],
              [-13.201879110996867, -11.603962419428024],
              [-13.20473285822446, -11.604878907260211],
              [-13.20777962656519, -11.604781771636613],
              [-13.209873251928002, -11.604044598255213],
              [-13.212100911624807, -11.603923077375269],
              [-13.214263466445823, -11.600939898424349]
            ]
          ],
          [
            [
              [-13.210986956276862, -11.613739218558905],
              [-13.209687301693672, -11.6126062180513],
              [-13.208479469898212, -11.612291032377835],
              [-13.2068928996459, -11.613836821786698],
              [-13.205920980328276, -11.613979273992596],
              [-13.204432773089401, -11.616393460761437],
              [-13.202249378091102, -11.618848262063802],
              [-13.201305783156126, -11.620505687869962],
              [-13.199651147555043, -11.621959456670556],
              [-13.201972995634684, -11.62244108417582],
              [-13.203352522814402, -11.623266030625933],
              [-13.20543159279705, -11.623454565243899],
              [-13.206516531432388, -11.622319824147961],
              [-13.207556526608743, -11.619569779713544],
              [-13.207708197011042, -11.617658433701203],
              [-13.209200052323183, -11.617634661879585],
              [-13.210013703608215, -11.615052214773627],
              [-13.210986956276862, -11.613739218558905]
            ]
          ],
          [
            [
              [-13.239946788257619, -11.56200408007875],
              [-13.23872997801495, -11.560497637207286],
              [-13.238143771288089, -11.558479030568156],
              [-13.23838049523436, -11.556533351178528],
              [-13.237231312808685, -11.555262319907479],
              [-13.238110855319771, -11.552404975208264],
              [-13.237755026467468, -11.549771349947543],
              [-13.236325791170174, -11.547602705388941],
              [-13.236107359406645, -11.546082678196338],
              [-13.236741214119341, -11.544907390096363],
              [-13.235891924526324, -11.542235239367288],
              [-13.236387877673922, -11.541110824253767],
              [-13.235950628431937, -11.53937922405955],
              [-13.235016280110168, -11.53848571611458],
              [-13.236382297372558, -11.536999304570767],
              [-13.236019348615825, -11.533961356226992],
              [-13.234407347593422, -11.53249473312191],
              [-13.232107261620346, -11.533015536966516],
              [-13.232693435464258, -11.530899654961626],
              [-13.231442102369956, -11.530379527283989],
              [-13.232553306869022, -11.528717313740357],
              [-13.231589582298955, -11.527481854154763],
              [-13.232798699027372, -11.526682851712257],
              [-13.23195164567504, -11.525532511532795],
              [-13.230063634632884, -11.527205876485338],
              [-13.228392001757653, -11.52678745726448],
              [-13.229054832358122, -11.525456725681314],
              [-13.2292856444116, -11.523251453705363],
              [-13.227189861579408, -11.521865531088796],
              [-13.226027966742537, -11.521729416654216],
              [-13.225013071723119, -11.520001801276885],
              [-13.222413977341803, -11.519830176703499],
              [-13.21997864607139, -11.518594439483394],
              [-13.217482713817699, -11.518906362170368],
              [-13.216443862080512, -11.518618753760228],
              [-13.214552914191142, -11.517201107085405],
              [-13.210570084381724, -11.518124568165748],
              [-13.208588649032778, -11.518268292047631],
              [-13.207421402576536, -11.519007743842469],
              [-13.204684980072116, -11.51938261339041],
              [-13.201772326965335, -11.518915592303788],
              [-13.200666762317738, -11.517749425318035],
              [-13.200838954662656, -11.516450574348259],
              [-13.199435191041852, -11.51473639459153],
              [-13.197081231289742, -11.513260646301699],
              [-13.195859731555833, -11.511438400742735],
              [-13.19241766088793, -11.509537114410083],
              [-13.189586485143183, -11.508546184623818],
              [-13.186095060987956, -11.507934163727903],
              [-13.184280731242364, -11.508722752545657],
              [-13.18101417793985, -11.509014479130121],
              [-13.176192966312607, -11.510035883310664],
              [-13.174006901193259, -11.510845561803654],
              [-13.172807917867292, -11.512095760112734],
              [-13.171442533267587, -11.511983407497627],
              [-13.169930974056738, -11.513084376348715],
              [-13.165838860895704, -11.515294240151382],
              [-13.165248813283595, -11.516744040032977],
              [-13.165290732196897, -11.51840025821643],
              [-13.164359442673373, -11.51935799141412],
              [-13.163724300758123, -11.521793867252645],
              [-13.16137308110337, -11.52457430240194],
              [-13.162823743198107, -11.528002457975838],
              [-13.164910586290869, -11.528778940489177],
              [-13.165607499443853, -11.530578705059424],
              [-13.164290615787413, -11.531101899104181],
              [-13.164384387842277, -11.532180971323896],
              [-13.16633357764082, -11.532935935824245],
              [-13.166681544418466, -11.535479929364648],
              [-13.16627365622487, -11.536252670059525],
              [-13.167422582057966, -11.538509879535924],
              [-13.1673275453912, -11.540290228772918],
              [-13.165499115432194, -11.544462250613591],
              [-13.160821722155285, -11.548446649614714],
              [-13.15910077718306, -11.551225352433413],
              [-13.15923871331161, -11.552105427260637],
              [-13.158093664276551, -11.553474131226292],
              [-13.156473963370138, -11.55623936845116],
              [-13.156298147723993, -11.55775731926033],
              [-13.157251831475719, -11.56002621168115],
              [-13.156449505672242, -11.560671616964468],
              [-13.155471236333895, -11.562692582266157],
              [-13.156783170429108, -11.564409967093308],
              [-13.157234955667116, -11.565870655605648],
              [-13.158927002383688, -11.567043021936101],
              [-13.159926230099863, -11.56947029027084],
              [-13.16092582572775, -11.568888150895498],
              [-13.162764632820217, -11.570632944076412],
              [-13.16311526142082, -11.57167838983196],
              [-13.165903529397825, -11.573922621952066],
              [-13.170159582229083, -11.575854174237907],
              [-13.171210499503204, -11.575908754284898],
              [-13.172745187482258, -11.577911104404699],
              [-13.17450369556209, -11.57759766870986],
              [-13.17541736776805, -11.57863424635528],
              [-13.178624366290924, -11.580508989904253],
              [-13.179005474702452, -11.581468164310122],
              [-13.180291525925327, -11.582194718151452],
              [-13.181528509124087, -11.583932225401247],
              [-13.18372829871616, -11.58504927519399],
              [-13.188133619373088, -11.589290310039665],
              [-13.190123109342673, -11.590457591658542],
              [-13.191119301857059, -11.58901188537995],
              [-13.19275161799463, -11.587914802596218],
              [-13.193913677325208, -11.585902505500068],
              [-13.196052571093876, -11.58597126188405],
              [-13.196631336961213, -11.58439191455649],
              [-13.197425504377163, -11.583979788066403],
              [-13.199536768347112, -11.584707538088688],
              [-13.202083557877502, -11.582616632291312],
              [-13.203557634414297, -11.582709304060115],
              [-13.207228175567975, -11.581027673094026],
              [-13.211046545320269, -11.57650883317355],
              [-13.212864984497479, -11.57549634067609],
              [-13.216347858888998, -11.575089159124946],
              [-13.220050693834013, -11.573513366134543],
              [-13.222493534269526, -11.573819873767087],
              [-13.22292114441553, -11.57333759621413],
              [-13.226008215247703, -11.572802114859781],
              [-13.22698200165633, -11.572280393687329],
              [-13.228485505262324, -11.572785491611786],
              [-13.231667046615469, -11.57101792065811],
              [-13.236561623680796, -11.569702198132143],
              [-13.238754529071501, -11.563550100282951],
              [-13.239946788257619, -11.56200408007875]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -132.02179312238596,
          "lat": 56.332387859202946
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02275"],
        "coty_name": ["Wrangell"],
        "coty_area_code": "USA",
        "coty_type": "city and borough",
        "coty_name_long": ["Wrangell City and Borough"],
        "coty_fp_code": "275",
        "coty_gnis_code": "02516402"
      },
      "bbox": [
        -13.239946788257619, -11.744177806087995, -12.850894640278325,
        -11.329087568660658
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.162333814476749, -2.204527315472288],
            [2.2727175288217443, -2.201719986895591],
            [2.2799813445905723, -2.201403816965943],
            [2.387160704266452, -2.19904151094914],
            [2.4483380160712334, -2.197447493422765],
            [2.5123610113599755, -2.196071182062483],
            [2.6012508204953066, -2.193792387163512],
            [2.6189279720286973, -2.193357147308276],
            [2.614555613893804, -2.1948142627668488],
            [2.616838757059441, -2.1999890361243817],
            [2.617214974084263, -2.2043309133927873],
            [2.6129462565280384, -2.2081770428304384],
            [2.6170742049784206, -2.210270856726869],
            [2.61887105122787, -2.2644891123432105],
            [2.6190655687746696, -2.283274952790883],
            [2.6200550070528, -2.3201189916571208],
            [2.6210320100874074, -2.382129863314535],
            [2.621736710114152, -2.461609568013493],
            [2.6229167773724114, -2.5310416797818753],
            [2.6229598427149763, -2.558926649226293],
            [2.6235969611145, -2.573393978346189],
            [2.5805378103504792, -2.5736787523406752],
            [2.5164368499367686, -2.573672375048676],
            [2.4805431360704295, -2.5737846841703957],
            [2.4232212267879456, -2.5740545055402024],
            [2.422781634990961, -2.5451027920770337],
            [2.394956776375899, -2.5451232438497153],
            [2.39470389150955, -2.5148645535145446],
            [2.373253488303083, -2.514502379132613],
            [2.373241111766836, -2.4998650786163887],
            [2.366188733880518, -2.49987341136212],
            [2.366135417974783, -2.4417413814564184],
            [2.360120395775038, -2.4416022416201995],
            [2.3567427647018646, -2.4398776940048155],
            [2.3512570553209837, -2.43319565946528],
            [2.3512090551080003, -2.4289245217960977],
            [2.3555487638923633, -2.42280195762762],
            [2.351719049319807, -2.4215242422866257],
            [2.3473049083143795, -2.4179395176372034],
            [2.345864806305698, -2.4229346108670144],
            [2.342690231072101, -2.418493678920627],
            [2.339494729884703, -2.4202624539446744],
            [2.3390802189906377, -2.4238832646238415],
            [2.336275401099398, -2.425212481780971],
            [2.3294667160114484, -2.4244791664392435],
            [2.3289855472475236, -2.417683466693781],
            [2.3338077188137474, -2.4158256595859817],
            [2.3347617501368148, -2.4134737812828715],
            [2.331773049959725, -2.4066802219963477],
            [2.3359837133807697, -2.401825875348894],
            [2.3336502774966563, -2.398015456232355],
            [2.306891244761885, -2.3976155439203835],
            [2.2502526368578692, -2.3983913413102997],
            [2.2078814209158963, -2.3974456557159414],
            [2.2078870364151646, -2.3909931378084717],
            [2.2039504907068412, -2.3917553497893222],
            [2.2025634047003204, -2.395091004032124],
            [2.1978875946923906, -2.3919283846585926],
            [2.193784088566576, -2.3912936441685684],
            [2.1932581609462467, -2.3813001346227196],
            [2.1861683072710276, -2.3797735794836385],
            [2.182896694249274, -2.3777332459310703],
            [2.1748064716858413, -2.367728863783835],
            [2.170754524697264, -2.36825088525991],
            [2.1683444333833126, -2.3653653025206323],
            [2.1669424943484774, -2.356972929093499],
            [2.1655201570229505, -2.356008098124689],
            [2.166338969391174, -2.3484445034691084],
            [2.1650866634321257, -2.347119714634558],
            [2.1634084288817186, -2.332362266237588],
            [2.156486808579927, -2.336271061421951],
            [2.1523213339022056, -2.3285168722217207],
            [2.149773037520686, -2.332380049333346],
            [2.1473068894401597, -2.3296503308854546],
            [2.1492939879225954, -2.3216481411860035],
            [2.152415276650232, -2.319064557414863],
            [2.150724782055622, -2.312433392206308],
            [2.1525446483781536, -2.3102741967277503],
            [2.159907367333097, -2.3105971661169646],
            [2.16288394047734, -2.3179499717314784],
            [2.1643956804255895, -2.3100012680399358],
            [2.1637883354874567, -2.27462382174949],
            [2.162333814476749, -2.204527315472288]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.5382052158714, "lat": 36.34106843568288 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05015"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00066975"
      },
      "bbox": [
        2.1473068894401597, -2.5740545055402024, 2.6235969611145,
        -2.193357147308276
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.1500459920419512, -4.971178447853966],
            [2.202742792190776, -4.971897068834153],
            [2.25357245265269, -4.971594078213543],
            [2.254002347120997, -4.8850681159040725],
            [2.2544007390708867, -4.85577477034328],
            [2.2545579528514423, -4.768119789845516],
            [2.25457397223749, -4.709846204923572],
            [2.3148549848750433, -4.710476750544214],
            [2.3191570142029825, -4.715123139849997],
            [2.3238533033945687, -4.7160595539406325],
            [2.3319581377815175, -4.715424994895478],
            [2.335465463810213, -4.718970438389933],
            [2.339744864817512, -4.719289078018026],
            [2.3442161356064664, -4.721655953662583],
            [2.3509682383034853, -4.722139667279325],
            [2.356147923025692, -4.72121837587273],
            [2.360327892529503, -4.72528684116679],
            [2.367616702831556, -4.7287161945475304],
            [2.3716177076396625, -4.732797384698192],
            [2.3760468436290902, -4.732467587997727],
            [2.3888721538922577, -4.73417283965484],
            [2.3907795199290542, -4.733069373766747],
            [2.3976899497763453, -4.734167933292411],
            [2.400387797192357, -4.732512400524281],
            [2.402056716795748, -4.738544885439482],
            [2.4099630633262814, -4.742241257878614],
            [2.4160061659525116, -4.741275576816887],
            [2.4161487333526384, -4.74637537240372],
            [2.4236926365573166, -4.750202875882465],
            [2.4249996030719383, -4.755249360316747],
            [2.4315232073295205, -4.755275905737577],
            [2.434344917709679, -4.751969008601769],
            [2.437341290625564, -4.752642987427855],
            [2.449476118277683, -4.751028192164308],
            [2.449804806269133, -4.754265041333068],
            [2.4583869528225573, -4.756244993137593],
            [2.4598466377359824, -4.753848593550519],
            [2.464040190874995, -4.752704298432148],
            [2.464992680357854, -4.755643957654221],
            [2.4697421645404316, -4.755492584463545],
            [2.4770441079205208, -4.7575233014088],
            [2.4861660091970452, -4.7627706801670975],
            [2.4908658884601667, -4.761517523166783],
            [2.4949547886527483, -4.758219904889742],
            [2.498536871250989, -4.7642929961818075],
            [2.4982492641104153, -4.769084229701135],
            [2.5074050695803534, -4.768822310769321],
            [2.5131458123882524, -4.766145671709263],
            [2.51793150864517, -4.765622856390912],
            [2.521333888455119, -4.766896681073891],
            [2.526954681137122, -4.763568298215367],
            [2.5236457233125433, -4.7583480285178235],
            [2.540613268091033, -4.755410996774084],
            [2.5399446882966035, -4.750593451022336],
            [2.5452913518534275, -4.750177622123426],
            [2.5512666376251087, -4.752725825097812],
            [2.556969681006131, -4.7501814024694635],
            [2.557336898226828, -4.754655328834833],
            [2.5576243697584164, -4.798982882974677],
            [2.5573387720310996, -4.8394725585638],
            [2.5574017064876946, -4.886980167966397],
            [2.5488603861676458, -4.88692898610919],
            [2.5487836466724354, -4.955740090697966],
            [2.548360893734577, -4.988275473070417],
            [2.5486017794164244, -5.012237788891308],
            [2.548653855780672, -5.047480461885775],
            [2.548411603013694, -5.070465177752635],
            [2.5486486068573426, -5.106427837995596],
            [2.548483285698764, -5.149683881899702],
            [2.5483035533985783, -5.237351823985043],
            [2.532623491576464, -5.237148950302908],
            [2.475503244298212, -5.237223278407479],
            [2.3521231216138556, -5.236406849480017],
            [2.339612685065467, -5.224830656373062],
            [2.3357825210511, -5.215728257658538],
            [2.328270348491302, -5.207678447215859],
            [2.327073881148795, -5.203547741919771],
            [2.3329847889453172, -5.190297972650604],
            [2.3315226096106123, -5.186275744722132],
            [2.3280252665765024, -5.1844021843005335],
            [2.3167884554434264, -5.197057668025804],
            [2.3143287137377135, -5.203917566568222],
            [2.316148949097878, -5.208467165765028],
            [2.3226336986249763, -5.214774819845464],
            [2.3180941717934296, -5.220214891322575],
            [2.308070197039753, -5.220525739878538],
            [2.3070236341694543, -5.209525224660094],
            [2.3025638283401224, -5.202653516865976],
            [2.301313863135589, -5.19791072367522],
            [2.3042298818478417, -5.194185379668325],
            [2.3103919001779882, -5.1917062143545625],
            [2.3085357966793794, -5.186131881683919],
            [2.3047707966260624, -5.18943688771751],
            [2.2999434977030186, -5.191628807789729],
            [2.293508291682494, -5.190791054440225],
            [2.287868589511548, -5.187412470965167],
            [2.2868790487631507, -5.181041116795391],
            [2.2883471687359607, -5.178633679021273],
            [2.2957268271932145, -5.174129018111007],
            [2.2984079333293512, -5.171005986895598],
            [2.29925796387585, -5.1669382537618915],
            [2.297608505336395, -5.163522475835069],
            [2.293367875474082, -5.163517532621347],
            [2.2888720937123765, -5.173839327955808],
            [2.2841737941755142, -5.178706926120699],
            [2.2795918160991557, -5.178082104757644],
            [2.2762203805236374, -5.173812737509316],
            [2.2765862642027694, -5.171308376634189],
            [2.2836684305794885, -5.161272769465005],
            [2.2831373078055357, -5.155014747221771],
            [2.278638739134879, -5.151751380411719],
            [2.268271509510798, -5.151938900691358],
            [2.261897636607365, -5.1493946210443875],
            [2.2609585415761537, -5.144175938426188],
            [2.2700845716155675, -5.132095612305935],
            [2.272830725905915, -5.121786727676511],
            [2.271678473457354, -5.112876268342875],
            [2.2686514554136927, -5.107661820440913],
            [2.266112961407206, -5.106045217082447],
            [2.261462763953679, -5.110252128528955],
            [2.2573805634527173, -5.113204639391867],
            [2.2531897942732724, -5.111096421394955],
            [2.2497725939485997, -5.1039124338152275],
            [2.2437997446390487, -5.102256400800743],
            [2.240675369028229, -5.106312277933722],
            [2.2348074188258655, -5.105086672067002],
            [2.2320330514393483, -5.1022551616375305],
            [2.232600655637899, -5.0950581246013735],
            [2.228355804323507, -5.089450820237499],
            [2.2201165246910515, -5.086807103417157],
            [2.215303324276309, -5.093536687438716],
            [2.211371086571078, -5.093016857679043],
            [2.2070033862105753, -5.083639252924962],
            [2.203502579823725, -5.081598319153622],
            [2.196046796941153, -5.084387429663086],
            [2.1908438594494544, -5.09321216854303],
            [2.1861482340733707, -5.091173596412572],
            [2.1900764857670043, -5.081108703716763],
            [2.1953329230452736, -5.0791812452659375],
            [2.197825169165576, -5.07412027783492],
            [2.196358905905635, -5.0697332734168565],
            [2.186629616648271, -5.062721473395552],
            [2.1880696128941124, -5.058410107902176],
            [2.184028653662094, -5.05638904558577],
            [2.179326176168413, -5.058452359469002],
            [2.1724222542292737, -5.059797462858441],
            [2.174496297684911, -5.06509501216815],
            [2.1729277662410436, -5.068822798219675],
            [2.1681196681090196, -5.074091662734974],
            [2.163127258847122, -5.072390204138114],
            [2.1614838507494496, -5.0635961449807745],
            [2.159448567590487, -5.061034921873922],
            [2.1545627594609607, -5.060010948570554],
            [2.145606120493564, -5.054099330823859],
            [2.142778374298539, -5.046696541384494],
            [2.1465409955139676, -5.039085824989028],
            [2.1460874016487543, -5.035325198196779],
            [2.148070120309598, -5.031430201146991],
            [2.1480027576645035, -5.0271905746742105],
            [2.1441250161797556, -5.023373474084814],
            [2.1429768223487504, -5.018305752798053],
            [2.147209973793645, -5.015391284786688],
            [2.152112022537592, -5.017338746799533],
            [2.1556381344933095, -5.015247867390737],
            [2.151549205265739, -5.007953990956164],
            [2.15540975510286, -5.000458326246031],
            [2.1528242647457416, -4.993948913232037],
            [2.148426094708147, -4.995657000580575],
            [2.1499725292026626, -4.999310322640901],
            [2.149374168911217, -5.0084090382419975],
            [2.144777139418075, -5.008977971241359],
            [2.1442495704726987, -5.003957043838518],
            [2.1402937537374336, -4.994552879075765],
            [2.1414641260165905, -4.986054974301163],
            [2.1399607974542514, -4.982148522785524],
            [2.144127640616829, -4.981461511712671],
            [2.1461528133033743, -4.983706686423653],
            [2.1538811804337623, -4.983055402844999],
            [2.1512440615119424, -4.977145967484333],
            [2.1521232804452053, -4.973775722020389],
            [2.1500459920419512, -4.971178447853966]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.66847746352569, "lat": 33.73530934319631 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05057"],
        "coty_name": ["Hempstead"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hempstead County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00066858"
      },
      "bbox": [
        2.1399607974542514, -5.237351823985043, 2.5576243697584164,
        -4.709846204923572
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.744507963784005, -2.9658788653698642],
            [2.759052822492473, -2.9665469754963616],
            [2.8156649459066263, -2.965682023909164],
            [2.8583817385610972, -2.965401815927312],
            [2.8828346526899096, -2.9648938794558144],
            [2.9159772309546894, -2.9648493074789863],
            [3.0010756429702705, -2.963667145254434],
            [3.0299324276825157, -2.9633492163107626],
            [3.030549719652013, -3.006907475575861],
            [3.0305527553079443, -3.026938917498916],
            [3.032211293377513, -3.0951015363588086],
            [3.0328120920571062, -3.1381713498661954],
            [3.0039290937606626, -3.138571712795897],
            [3.005126434314256, -3.1963796353114335],
            [3.005471569804097, -3.225723273535144],
            [3.0072348929866193, -3.312938268075213],
            [3.007939006396827, -3.3566101538190156],
            [3.0091804159062194, -3.4081561230995296],
            [3.0102603894063398, -3.458783835782544],
            [3.0117764301579406, -3.516836815168461],
            [3.003934169749817, -3.5165364372926082],
            [2.9970435491995024, -3.5177996439616614],
            [2.987298195089969, -3.5210474603464137],
            [2.9801149006526937, -3.52220587926517],
            [2.9747963337673786, -3.5219239071811064],
            [2.9620651309791253, -3.5167245282059194],
            [2.95315148204066, -3.5157203624013262],
            [2.940464776781581, -3.5165206827135713],
            [2.9373024887111874, -3.5175670387811984],
            [2.928005097505265, -3.5231399539566963],
            [2.9235168671710996, -3.523912785165731],
            [2.916470951821273, -3.5220097470315235],
            [2.911157626919146, -3.5220284437134852],
            [2.8892809801633415, -3.5270840968292325],
            [2.874076418337937, -3.5337272246682008],
            [2.871385943017575, -3.537145273441387],
            [2.8707641334349905, -3.5442194526754722],
            [2.873117726158936, -3.5658294877255443],
            [2.8693262918249927, -3.5709182725712316],
            [2.8627446339057943, -3.575735023478765],
            [2.8518719294148, -3.578627382948081],
            [2.8424937023828005, -3.5778433211996514],
            [2.8339654048847316, -3.573803047024482],
            [2.8247810247772582, -3.5672558946453568],
            [2.8201363833008894, -3.5579252391323153],
            [2.8279158061580585, -3.5529433550454756],
            [2.830419687736966, -3.546020540229689],
            [2.8263409929918284, -3.5362787040543897],
            [2.8271143652685455, -3.532132360111082],
            [2.8311454972043975, -3.5280935508867275],
            [2.832657265949021, -3.524241699060804],
            [2.831121924894506, -3.5176448740309367],
            [2.826230809595368, -3.5131291340395703],
            [2.8228516635760674, -3.5125879169158227],
            [2.8185619709354635, -3.5142329670695984],
            [2.81191677823526, -3.522259051542719],
            [2.8060658613193867, -3.525878755775867],
            [2.8019152131234413, -3.5263461474314837],
            [2.795212615340914, -3.5241537952975266],
            [2.78922882372718, -3.5187774130645355],
            [2.783798306400212, -3.509388044856312],
            [2.782102143878627, -3.504780388607022],
            [2.781952809913666, -3.496985422136981],
            [2.779053254312214, -3.4860233911917495],
            [2.767884760885867, -3.4647769081870647],
            [2.7639439359151536, -3.4598105030675965],
            [2.753809519605311, -3.4493264632916896],
            [2.7436200717307564, -3.4367331119763995],
            [2.738089291794628, -3.4321426842542286],
            [2.730702376542118, -3.4274080309763972],
            [2.7274797081072544, -3.426579017521294],
            [2.7146942882100364, -3.427184412431915],
            [2.7045825336517173, -3.4265222199314795],
            [2.6981720191083434, -3.4243350157552537],
            [2.6919144653987415, -3.4198459676508],
            [2.6835369378318217, -3.4110272030121784],
            [2.665058463783369, -3.3878990148747476],
            [2.6596545305553794, -3.3817375785564754],
            [2.647909920198174, -3.373588830706122],
            [2.647073350258321, -3.3100019269047904],
            [2.646261200525919, -3.230010741880426],
            [2.660626997886773, -3.22934524536512],
            [2.704434945490085, -3.2293243595784507],
            [2.7039830754461023, -3.1783622800449565],
            [2.7033022113029435, -3.1418247461528934],
            [2.7027759379254723, -3.1417030333516265],
            [2.7026278948627587, -3.097979090346031],
            [2.7313925031800563, -3.0977425352417063],
            [2.7457348391633145, -3.0979540377049792],
            [2.7454692855867013, -3.0829014201755673],
            [2.744507963784005, -2.9658788653698642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.03455305003139,
          "lat": 35.447917792918375
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05115"],
        "coty_name": ["Pope"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pope County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00069901"
      },
      "bbox": [
        2.646261200525919, -3.578627382948081, 3.0328120920571062,
        -2.9633492163107626
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.622692738101908, -2.614798626450414],
            [1.67987908938642, -2.6149907791817526],
            [1.6956017104479406, -2.6153390809951222],
            [1.7516358580463596, -2.615481982964835],
            [1.7519411802239764, -2.5717849231087317],
            [1.7948585145155704, -2.5717654460402124],
            [1.795608269584132, -2.4984522421094284],
            [1.8671040653452615, -2.4991359582775377],
            [1.891961221620961, -2.499137038418767],
            [1.9521509407876874, -2.4999271600138853],
            [2.016527399673541, -2.5001122438388985],
            [2.0377477627120038, -2.5005231531234835],
            [2.048384670100747, -2.5002003316717527],
            [2.0513550323623053, -2.495615612116157],
            [2.047857538745001, -2.4916872646674677],
            [2.0441449002212884, -2.49360935190725],
            [2.0409467043930616, -2.4904037170887117],
            [2.042599020767313, -2.4845192277253916],
            [2.051486953435054, -2.4794178784679906],
            [2.060337297153795, -2.4774471443285644],
            [2.064316348674343, -2.480745527791707],
            [2.0634859622233175, -2.484353857704758],
            [2.0582191354465724, -2.484523018916509],
            [2.0541983446947487, -2.4871611758481036],
            [2.054328858819994, -2.4914805289346633],
            [2.056665456130843, -2.493106974840037],
            [2.060664886880046, -2.491455624186757],
            [2.0631167891788946, -2.4960045376037363],
            [2.0661234219996363, -2.498260108562522],
            [2.073248433499651, -2.496314213375986],
            [2.077553512952199, -2.4969743977093217],
            [2.0800784289108525, -2.5030180356464196],
            [2.0834793880792817, -2.5034056040319257],
            [2.08363800644601, -2.4989994805486795],
            [2.0818184130148625, -2.4917345633267636],
            [2.0817185790687947, -2.4826294568167326],
            [2.0842452088378995, -2.4788768288540837],
            [2.0876960255502626, -2.480111432024543],
            [2.090632690408137, -2.483681876090554],
            [2.095956689474414, -2.4852058257445955],
            [2.0963216356804457, -2.4769409651019636],
            [2.098470703976215, -2.4739211735934985],
            [2.102980829345144, -2.475238211707476],
            [2.10746168824503, -2.4747541027901385],
            [2.106250120774258, -2.470775797943077],
            [2.1379955009999696, -2.4704754727613696],
            [2.151369248958641, -2.4707697689021977],
            [2.1399821973124893, -2.510994578919495],
            [2.109601451403963, -2.6169308997352827],
            [2.1094633521164563, -2.6746824668940037],
            [2.109617954627681, -2.716212847072617],
            [2.109271091183299, -2.7858112028113062],
            [2.108997601137826, -2.8770912604861665],
            [2.1019611910578155, -2.8771022691052717],
            [2.101576084185961, -2.9499488093814157],
            [2.0575923326521397, -2.9498838104421536],
            [2.0290939015716294, -2.949284750846852],
            [1.9718916564709894, -2.948833005334603],
            [1.9716499316442708, -2.9633828302149805],
            [1.89460810830672, -2.9619300143362657],
            [1.8439929741843395, -2.961237923319006],
            [1.799542566817847, -2.9611932118614965],
            [1.7995400848672465, -2.9604080806449526],
            [1.7151143519884653, -2.960000870548407],
            [1.6755800797400222, -2.9596545901132965],
            [1.6695909890927736, -2.921786401771558],
            [1.6623984164195598, -2.872516789044701],
            [1.6535344455397527, -2.8162385423101832],
            [1.6489439673719268, -2.7836624342420024],
            [1.639155516154136, -2.720746653683279],
            [1.6380974881825097, -2.7148404817805507],
            [1.6264974173546083, -2.6387872476376453],
            [1.622692738101908, -2.614798626450414]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.21560729863528,
          "lat": 35.979052564576044
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05143"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00069905"
      },
      "bbox": [
        1.622692738101908, -2.9633828302149805, 2.151369248958641,
        -2.4704754727613696
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.739943910887302, 3.5470082447397484],
            [-19.71132908686127, 3.53845343289933],
            [-19.69196515966313, 3.534666224164704],
            [-19.599539140533395, 3.508533699522201],
            [-19.581273155904487, 3.5030699003188976],
            [-19.569355009193174, 3.49886146751024],
            [-19.5021682447239, 3.4796230548499483],
            [-19.384659490888527, 3.4471477833604838],
            [-19.345180417943457, 3.4361672964334584],
            [-19.336921266623175, 3.4340899429357776],
            [-19.29535393612616, 3.4226181183031223],
            [-19.287517428251956, 3.450779730738993],
            [-19.246364525088943, 3.438893032133209],
            [-19.193986899321445, 3.4235304271275324],
            [-19.19441829569097, 3.414962177534663],
            [-19.192967211015752, 3.4126895111369695],
            [-19.19480174667649, 3.406412884094767],
            [-19.198723271001928, 3.40258916639797],
            [-19.200788228143246, 3.3964272424615447],
            [-19.202737514767488, 3.394893698329038],
            [-19.114468914050807, 3.370219395774899],
            [-19.11263751234854, 3.359310309109078],
            [-19.115710505503376, 3.358298351560266],
            [-19.122718432557466, 3.35058221871833],
            [-19.123659528062433, 3.3480634303114614],
            [-19.127859669124888, 3.346791697302471],
            [-19.12972090953879, 3.3432393880593154],
            [-19.130636798279983, 3.332838259644629],
            [-19.12931661955332, 3.329597611745476],
            [-19.13133900542897, 3.3266405373866137],
            [-19.135153990458555, 3.3252373137296263],
            [-19.142447425729557, 3.314076588259232],
            [-19.1488685596014, 3.3004203614198553],
            [-19.149670260662027, 3.2963408944354775],
            [-19.158243400643265, 3.290201698965088],
            [-19.15909566868968, 3.286653249352544],
            [-19.16455467178458, 3.282821231678024],
            [-19.164966917584305, 3.2773288231766275],
            [-19.171981939974856, 3.272601318811071],
            [-19.174447601514007, 3.2684400682718935],
            [-19.18059196693562, 3.2673747530537853],
            [-19.185359427689605, 3.262854149008148],
            [-19.187764231092377, 3.2569730716062995],
            [-19.190808779833805, 3.254688186845223],
            [-19.196410948717702, 3.2429464993064725],
            [-19.19359302607904, 3.2298987708301428],
            [-19.19640335089578, 3.2232598689617125],
            [-19.192607432242728, 3.211721568010352],
            [-19.193914219856165, 3.209675055952449],
            [-19.193081464870875, 3.198412150837396],
            [-19.200834020249808, 3.195702508016139],
            [-19.200691582126243, 3.1907189287903943],
            [-19.204433497590678, 3.1901850542790013],
            [-19.208728862851743, 3.1871859684792],
            [-19.210923018124966, 3.183628922980875],
            [-19.207927670269942, 3.176896209932992],
            [-19.207969733681285, 3.16402104385643],
            [-19.19945197864722, 3.1523170346048004],
            [-19.198852351656285, 3.146168445456309],
            [-19.20152742027239, 3.1416554789526434],
            [-19.210922937467874, 3.144442137879478],
            [-19.214142072989407, 3.1472300855705044],
            [-19.21698642516663, 3.144994455111266],
            [-19.21807902465248, 3.1365943898601167],
            [-19.215906374660744, 3.132888638004706],
            [-19.209771570923746, 3.1292444055776376],
            [-19.209159132058687, 3.123247901904699],
            [-19.201580556231498, 3.122433873288002],
            [-19.20068271450661, 3.119348571901887],
            [-19.20248247709908, 3.1113501507990713],
            [-19.199048781704214, 3.1121910942934434],
            [-19.199382665193134, 3.1052625831106724],
            [-19.202209824481073, 3.102007967833421],
            [-19.198931145830432, 3.0967676788876797],
            [-19.198764137368634, 3.0931892844334814],
            [-19.195848408858982, 3.09178643629928],
            [-19.19638192202055, 3.0873693206919977],
            [-19.198898415778746, 3.0837472128619487],
            [-19.196483714411926, 3.076303096619589],
            [-19.20059281842818, 3.0741395018583413],
            [-19.198400137657806, 3.0676344776498454],
            [-19.189379968737533, 3.062715748531011],
            [-19.185254524216013, 3.0582581082038267],
            [-19.177583873565037, 3.057734642681527],
            [-19.170930889318882, 3.059073772925205],
            [-19.168354298217572, 3.0576319222776003],
            [-19.163263564579385, 3.0479837362609317],
            [-19.168296043113077, 3.03758474543911],
            [-19.168499532502604, 3.030745981740932],
            [-19.163911731041793, 3.0227139593468846],
            [-19.16485304815193, 3.016158024230536],
            [-19.161458627841668, 3.014855601457154],
            [-19.16206162945601, 3.0029848759621083],
            [-19.167465140286254, 2.998010428011758],
            [-19.16835507235829, 2.9946574988584596],
            [-19.16529006292708, 2.989454847934729],
            [-19.160108964610238, 2.987435004037424],
            [-19.15512029940084, 2.983219899787442],
            [-19.153727269679564, 2.9796959298141648],
            [-19.149636932032706, 2.9748289536811154],
            [-19.15041784856793, 2.972852290041968],
            [-19.156325266289485, 2.969454729205298],
            [-19.169638410539736, 2.9715993317998337],
            [-19.171381185052912, 2.968835223752854],
            [-19.174937201664207, 2.9586541312901193],
            [-19.183604842473706, 2.957566778727314],
            [-19.187093452674688, 2.952307536453504],
            [-19.18663058285843, 2.9469533111479977],
            [-19.194264175205735, 2.9431158643639486],
            [-19.19292447329362, 2.9370986528690715],
            [-19.194340809579398, 2.931932413752521],
            [-19.191029183965917, 2.9253674685057267],
            [-19.19507360764403, 2.921971034597098],
            [-19.199694566725814, 2.916189375125055],
            [-19.198782413805326, 2.9129290172810234],
            [-19.23359174940585, 2.9233242012952676],
            [-19.32087169697593, 2.948135895679476],
            [-19.36582297558599, 2.96108508483441],
            [-19.4908882751654, 2.995183685157395],
            [-19.50444656614727, 2.9981140527354815],
            [-19.514878951209074, 3.001237183449544],
            [-19.56077540877529, 3.0142488881697744],
            [-19.57315909865779, 3.0179625400886905],
            [-19.57328507601801, 3.0210383202085236],
            [-19.579272845657755, 3.024449353840868],
            [-19.583078301335917, 3.0288183849158905],
            [-19.589384098272248, 3.0380752334762477],
            [-19.5931977717707, 3.0399817440468664],
            [-19.597651208486887, 3.0488985275990945],
            [-19.604390680866665, 3.059722537775598],
            [-19.60887809803817, 3.060718076753873],
            [-19.61358895683469, 3.07009158274697],
            [-19.60993404753907, 3.07571015516174],
            [-19.61009971814126, 3.079615494001912],
            [-19.614957553365855, 3.0864678971847934],
            [-19.6138134759333, 3.0975991189580707],
            [-19.610837504746844, 3.099197151645492],
            [-19.605858785822157, 3.10472655932593],
            [-19.60392732082611, 3.111464744330655],
            [-19.6009301148066, 3.112985601970411],
            [-19.59905980072574, 3.1231074081259953],
            [-19.600852103205654, 3.12644956555126],
            [-19.608879062327794, 3.1289557853141647],
            [-19.61569495400317, 3.1330887581256706],
            [-19.61820194891475, 3.1325884225345524],
            [-19.62111743640224, 3.1376796284808783],
            [-19.62461038824254, 3.1462656815070287],
            [-19.62879516986727, 3.1540964743886697],
            [-19.631555369173757, 3.155972530125334],
            [-19.63455959874656, 3.1617936178938106],
            [-19.631720364213564, 3.1642659319798994],
            [-19.642321777337028, 3.1723677945649764],
            [-19.649357752127667, 3.1746494298900223],
            [-19.64824700110821, 3.1811874398553868],
            [-19.64518146622223, 3.1844060575751874],
            [-19.64000845436973, 3.1866200528226893],
            [-19.64237389397401, 3.1909509193667556],
            [-19.642044274086693, 3.1980506121390357],
            [-19.637425999510533, 3.2022274411844913],
            [-19.63642382516275, 3.205621355678241],
            [-19.635319229790003, 3.2195893065307986],
            [-19.637959040863407, 3.228874102772643],
            [-19.634274367720135, 3.2354362632076383],
            [-19.637560465245343, 3.242665228046387],
            [-19.633660876258045, 3.247498691545377],
            [-19.631242382174786, 3.253980045314483],
            [-19.626553781663816, 3.2587946191504917],
            [-19.622303216841, 3.25982174793656],
            [-19.617890582192018, 3.2552106204352715],
            [-19.61152211704085, 3.259994786331768],
            [-19.612640390549885, 3.262667699234247],
            [-19.611460554477784, 3.2705311741322523],
            [-19.6123933720166, 3.279353333786299],
            [-19.607153152498878, 3.282172945079967],
            [-19.605079102147844, 3.2848347923324077],
            [-19.605431513901898, 3.2889212104966474],
            [-19.616624188751654, 3.296466904444176],
            [-19.614836916910203, 3.3016510214684005],
            [-19.616355181707053, 3.3100116521671046],
            [-19.623851371958814, 3.311347087482231],
            [-19.62624345852092, 3.317992315739868],
            [-19.625681370222072, 3.3257701690305286],
            [-19.623710134661515, 3.331115272614365],
            [-19.633039607676242, 3.336084136738173],
            [-19.640552582995184, 3.3365230729160484],
            [-19.643596975266274, 3.334393779452875],
            [-19.652402237562637, 3.3367346472999317],
            [-19.663524166384246, 3.3367311576848997],
            [-19.667954629077, 3.3386163971946217],
            [-19.67026282457581, 3.345960675946951],
            [-19.672743512147417, 3.348379017273641],
            [-19.679021216147817, 3.350352353593269],
            [-19.67997583019873, 3.352578709278755],
            [-19.686161622168548, 3.3542160232447267],
            [-19.691746573032095, 3.3578868105726243],
            [-19.69259208688971, 3.3609116410901927],
            [-19.69890574194597, 3.3673050629886454],
            [-19.708008313428927, 3.369934416489183],
            [-19.711246918805728, 3.3675090084994896],
            [-19.72183835577742, 3.3641871818665323],
            [-19.72630886592917, 3.3662088274798734],
            [-19.73205176580553, 3.370927302101839],
            [-19.734503021237508, 3.378583141539964],
            [-19.739933355917316, 3.3829494166593173],
            [-19.736270148314865, 3.38529238314668],
            [-19.73934046049732, 3.390868596796306],
            [-19.737605661663817, 3.394737719396848],
            [-19.741295385685152, 3.398341230916778],
            [-19.742861270299723, 3.405381034148595],
            [-19.74683858660041, 3.4091024593283947],
            [-19.751457338540654, 3.4156322858461783],
            [-19.755724829732163, 3.419133870616017],
            [-19.757032546642762, 3.425729768113279],
            [-19.76063397305031, 3.4308545206049157],
            [-19.76381649531722, 3.4387486074916698],
            [-19.768153952525353, 3.438362138254629],
            [-19.770174557384593, 3.4421904731125954],
            [-19.77587795127335, 3.448092802273165],
            [-19.78096221714049, 3.4550465121502096],
            [-19.779091365480213, 3.4646187572551006],
            [-19.782924521402208, 3.4731534710235326],
            [-19.783613599562514, 3.482786166562708],
            [-19.786404575526618, 3.4862589204254895],
            [-19.782754662287065, 3.4919161318275593],
            [-19.781189906368557, 3.496721707803969],
            [-19.777657828707454, 3.4972907831517275],
            [-19.77603066634889, 3.5027527862005763],
            [-19.772435598809388, 3.5057751387939704],
            [-19.770618301790925, 3.5133576650759064],
            [-19.759883478524586, 3.5140411211207607],
            [-19.752508230872333, 3.522265264891259],
            [-19.748728411615033, 3.523985678789404],
            [-19.747437944703343, 3.5332952126257267],
            [-19.753196692530686, 3.5375276179920045],
            [-19.754228654399785, 3.5431662367673438],
            [-19.75921169359849, 3.546839867036842],
            [-19.763896570097668, 3.544182728143154],
            [-19.76813997145455, 3.546354385935623],
            [-19.770327308988815, 3.551657073751359],
            [-19.77387895581625, 3.556500304127168],
            [-19.739943910887302, 3.5470082447397484]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -122.23690271938926,
          "lat": 39.17749228567385
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06011"],
        "coty_name": ["Colusa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Colusa County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01675902"
      },
      "bbox": [
        -19.786404575526618, 2.9129290172810234, -19.11263751234854,
        3.556500304127168
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.267663255565846, 0.8841123381715056],
            [-17.153827603944038, 0.8563695569453438],
            [-17.12628456779163, 0.8499363693919865],
            [-17.06796770800829, 0.8352147815067803],
            [-17.043379248557713, 0.8293317562413647],
            [-17.024003690448403, 0.8249916565228733],
            [-16.985126572180267, 0.815444920349246],
            [-16.941785276447863, 0.8050874212720894],
            [-16.622553408358705, 0.7311249805849156],
            [-16.611170152754465, 0.7291394281353923],
            [-16.600880518644658, 0.7263201679661704],
            [-16.546852902737555, 0.7137501685134714],
            [-16.47529286641765, 0.6037549761748605],
            [-16.45587273548098, 0.5769229116511863],
            [-16.396728219393072, 0.4860480537949266],
            [-16.372187660692482, 0.4503263709232094],
            [-16.348193584040075, 0.4140771748620506],
            [-16.34756271062745, 0.4140335187434233],
            [-16.273150625501074, 0.30005818291412667],
            [-16.20693403494016, 0.20009519598105377],
            [-16.193930303080325, 0.18195114093287762],
            [-16.146243523610035, 0.11002481658279598],
            [-16.125649603797125, 0.07902229313748439],
            [-16.08624158736432, 0.0189708554934203],
            [-16.04613676166095, -0.04041047390724319],
            [-15.978478436227963, -0.14301059714733247],
            [-15.869390943736642, -0.3076151358634902],
            [-15.810872671845628, -0.395500791476891],
            [-15.76635152389733, -0.4621727868169373],
            [-15.741239176505815, -0.5004716377092787],
            [-15.733366752325097, -0.5116266975720368],
            [-15.667460629425868, -0.6129554351411057],
            [-15.664494780487018, -0.6160733336502936],
            [-15.587457506095861, -0.7315171509333739],
            [-15.5544646264341, -0.781327796839766],
            [-15.492629514890622, -0.8744346862173669],
            [-15.490340445217106, -0.8775488353308135],
            [-15.416960275702136, -0.9883757918547873],
            [-15.3660720735335, -1.0648896876345646],
            [-15.336706094338206, -1.1080059662958381],
            [-15.277656174536778, -1.1977517121413346],
            [-15.226382805375513, -1.2732576496415635],
            [-15.213380053418623, -1.2933924084519708],
            [-15.213882551305627, -1.2937967212608668],
            [-15.282479550127222, -1.2794199496816336],
            [-15.285814315169267, -1.294674976816958],
            [-15.538700847352265, -1.2405967026035256],
            [-15.548769088420027, -1.2389555336788085],
            [-15.659295778843811, -1.2153639920030956],
            [-15.6924324479192, -1.2079482809785125],
            [-15.714975167275961, -1.2031774660107057],
            [-16.2179833170753, -1.0904038415205457],
            [-16.370476892591174, -1.056274644503476],
            [-16.376884343710536, -1.054399822367158],
            [-16.48957915128287, -1.029463064060494],
            [-16.567086874097345, -1.011669959596232],
            [-16.608545471393185, -1.001730753163666],
            [-16.774854319764774, -0.9616910262578816],
            [-16.774769947984662, -0.9612983508373399],
            [-16.92108104035555, -0.9270982810099642],
            [-16.92817569553233, -0.9249602541070582],
            [-17.001688925828503, -0.9076506429772727],
            [-17.003284272046063, -0.9193746995098607],
            [-17.069345519258032, -0.9015002197446348],
            [-17.06887180602239, -0.895001975322092],
            [-17.066490473386192, -0.8919038772340676],
            [-17.067633537903088, -0.885885886488561],
            [-17.063985515049325, -0.8809238500733834],
            [-17.062539590448203, -0.8739238188617916],
            [-17.056116747817835, -0.8721234485210141],
            [-17.054079685193855, -0.8689937518986195],
            [-17.058573160996172, -0.8624660302437954],
            [-17.05558223963133, -0.8558580775991792],
            [-17.054681989397086, -0.8486235120145458],
            [-17.052322581271138, -0.8408951840523644],
            [-17.052867393450114, -0.837060420057767],
            [-17.050225881680227, -0.8295353695310208],
            [-17.047417836325895, -0.8289562912277116],
            [-17.04316572933453, -0.8248929271058432],
            [-17.039377833353228, -0.8249260166282321],
            [-17.037815951795615, -0.8292210448832349],
            [-17.03014330270293, -0.8298991062088548],
            [-17.02971326486674, -0.8216705627465702],
            [-17.033232681925604, -0.8158426871327292],
            [-17.032390861668812, -0.8115343649938753],
            [-17.02818100554324, -0.8087885417845436],
            [-17.02457899134705, -0.8012653320623669],
            [-17.027375300337187, -0.7970290627158148],
            [-17.02462402178178, -0.7908698877507386],
            [-17.026889818385346, -0.7881746235029965],
            [-17.02583897597475, -0.7801064224783979],
            [-17.023871123315462, -0.7788924986414067],
            [-17.01809695808811, -0.7708947574302696],
            [-17.0192564135863, -0.7648148692239597],
            [-17.017979082445084, -0.7630629329087466],
            [-17.02023518664246, -0.7576338740535326],
            [-17.0208752988955, -0.7523997773179835],
            [-17.02681440480842, -0.7481418858306931],
            [-17.03191066702536, -0.7469872635091704],
            [-17.03342272087309, -0.7444244068546381],
            [-17.033301494714713, -0.7382423592340714],
            [-17.03777762829579, -0.7372385832263901],
            [-17.037419749364865, -0.7306601512083475],
            [-17.030860561279347, -0.723137730880454],
            [-17.026702100757593, -0.7153527393758486],
            [-17.023572115443464, -0.7173462915899534],
            [-17.020707782736558, -0.7110217768988998],
            [-17.021383369589337, -0.7046009918183862],
            [-17.024385275639442, -0.7018329794640269],
            [-17.023961628129, -0.6951299622252392],
            [-17.028203807629787, -0.6889045565441193],
            [-17.032770941377464, -0.6862716873701127],
            [-17.038295061707284, -0.6807165442576393],
            [-17.037703348279006, -0.6691387058146855],
            [-17.036672454051892, -0.6661675123230159],
            [-17.037030050281945, -0.654781176406345],
            [-17.04027857919578, -0.6472736048567868],
            [-17.0362079606471, -0.6401464007845357],
            [-17.040672422432202, -0.6276847305136047],
            [-17.03705682956261, -0.6141241801477842],
            [-17.035200163599114, -0.6111416243569501],
            [-17.035472481912926, -0.601847602506978],
            [-17.03863049529913, -0.594671575725521],
            [-17.04193797703375, -0.5964825173733073],
            [-17.04495949408087, -0.5915161652891557],
            [-17.041664786786377, -0.5814056058652077],
            [-17.042232315602604, -0.5765007467990912],
            [-17.039165855413437, -0.5753589482090532],
            [-17.038166470504677, -0.5662623035898915],
            [-17.038284156718035, -0.5598043616814745],
            [-17.039994633213873, -0.5555625298735266],
            [-17.03848209573941, -0.5512531156961591],
            [-17.039275411049687, -0.545568669168246],
            [-17.036641417827752, -0.5417318753526836],
            [-17.03087016423817, -0.5385330782100104],
            [-17.026512998474338, -0.5374888044239008],
            [-17.024602249466636, -0.5346216370841427],
            [-17.023567069004507, -0.5288510102935637],
            [-17.025369914050398, -0.5250034021864493],
            [-17.020921329092886, -0.5176541365020577],
            [-17.022070810574732, -0.5131301949449404],
            [-17.027275013270053, -0.5073363476746195],
            [-17.02676281644778, -0.49926384621118414],
            [-17.02764536239761, -0.4960473168028001],
            [-17.032320130773947, -0.48871834485412424],
            [-17.035255307892694, -0.48584568447142606],
            [-17.03903619373413, -0.48515830694955303],
            [-17.040304061570932, -0.4769762142394002],
            [-17.045075537083203, -0.4718011228156998],
            [-17.04728956742184, -0.463808347671817],
            [-17.046259136310237, -0.4577249853200315],
            [-17.046867844487373, -0.45405398946901504],
            [-17.043595585200052, -0.45202844515356405],
            [-17.04187266910639, -0.44683516968190695],
            [-17.045826311460218, -0.4392598211105653],
            [-17.045721615256863, -0.43119457394343264],
            [-17.04777192370069, -0.42269734294317063],
            [-17.044655420430367, -0.4156932494127415],
            [-17.04259967072604, -0.40773646399524965],
            [-17.044640921764568, -0.4004745623670199],
            [-17.048208980555824, -0.3975985279233576],
            [-17.047458613508525, -0.39375555923983196],
            [-17.04490560116999, -0.39102879965733006],
            [-17.042857231862467, -0.38004618188396894],
            [-17.038521657654467, -0.37761017167775857],
            [-17.037583183778555, -0.3719206078328271],
            [-17.032080226953305, -0.3730723391355479],
            [-17.028184720576103, -0.37103576618607936],
            [-17.027806634447554, -0.365191663042583],
            [-17.02890186644268, -0.361089752428906],
            [-17.022290495197826, -0.3560730454419555],
            [-17.015766518801883, -0.354282117729836],
            [-17.014344384351734, -0.3503512703339852],
            [-17.014641671267157, -0.3436418674670021],
            [-17.011895126372178, -0.33723831986697117],
            [-17.015367107980737, -0.33423758094225897],
            [-17.026857883193625, -0.32944007208530424],
            [-17.028628139517885, -0.31615643607749055],
            [-17.029994184365382, -0.31396514932014413],
            [-17.030079300694226, -0.30741013512713183],
            [-17.037553100822432, -0.30470359575850375],
            [-17.038700402613124, -0.29882899814569325],
            [-17.041012250809402, -0.29579039172016897],
            [-17.045101717718584, -0.29471594138465823],
            [-17.045610748921703, -0.28650249625894986],
            [-17.05042870115578, -0.28297207556684084],
            [-17.047121492982612, -0.2793998552181886],
            [-17.041689371739825, -0.27757707557830685],
            [-17.035296002253276, -0.27722710317993926],
            [-17.029576837382592, -0.27350047019252366],
            [-17.024795003018045, -0.26301506552284587],
            [-17.024336326645294, -0.2597001698078615],
            [-17.028631976615323, -0.25536097824518345],
            [-17.030243674942202, -0.25145095605465434],
            [-17.034856766006577, -0.24776212573084067],
            [-17.035745490621874, -0.2418446488791068],
            [-17.04200509514415, -0.2433670258350385],
            [-17.047363917459776, -0.24282029946729222],
            [-17.050924943986285, -0.24436058644592476],
            [-17.05839262843223, -0.24268934498331063],
            [-17.062245547577238, -0.24063183842305452],
            [-17.06554998351418, -0.2410911203867033],
            [-17.07228333443157, -0.23461227164584808],
            [-17.077223364714012, -0.23437048590791898],
            [-17.07947284626096, -0.22729754164748006],
            [-17.075678991964907, -0.22581400144207478],
            [-17.074144745249818, -0.22005683436361578],
            [-17.076488748313885, -0.21545181336977667],
            [-17.075780908197718, -0.2073186781456103],
            [-17.079008967488438, -0.2033341090262875],
            [-17.079493226120174, -0.20020936233579897],
            [-17.086478206724433, -0.19480947972939425],
            [-17.08589321749861, -0.19235446892165314],
            [-17.08963790765198, -0.18264095090965154],
            [-17.09611415024765, -0.17580411669492052],
            [-17.09437932990122, -0.17196278069801002],
            [-17.08580411209584, -0.16964841606661132],
            [-17.081925860212024, -0.16745936793150734],
            [-17.08540960205393, -0.16009096062779274],
            [-17.08149597128054, -0.15500459277606304],
            [-17.081707008705784, -0.15142578214496139],
            [-17.07802665478966, -0.1373586572225066],
            [-17.08463555387582, -0.13796252871138961],
            [-17.08677349779456, -0.1331976000875411],
            [-17.083330035956852, -0.12665013465766511],
            [-17.083760871880813, -0.11679168006524873],
            [-17.088434067851466, -0.11443153943624138],
            [-17.091854443023472, -0.10510482806300667],
            [-17.09951915313723, -0.1043131685502508],
            [-17.101923433345377, -0.09896465468394473],
            [-17.10971629939196, -0.09357421853680707],
            [-17.108723889288612, -0.08291275098685459],
            [-17.105726794160287, -0.07926940898950374],
            [-17.108326399748947, -0.07543055501277486],
            [-17.10679491814493, -0.07278639701654883],
            [-17.101871243524677, -0.06929298085791975],
            [-17.101002730646517, -0.06223472633521973],
            [-17.092118459013495, -0.06269599586622812],
            [-17.08831616925135, -0.05841418655711145],
            [-17.09204291857562, -0.0500510970326371],
            [-17.09934595587499, -0.04913693091181996],
            [-17.10329621272558, -0.04445621316647058],
            [-17.103100434114562, -0.04055861838063179],
            [-17.10516910320922, -0.03861094913728338],
            [-17.104550603277325, -0.03294594731065706],
            [-17.11008298682319, -0.02736725849036487],
            [-17.109990967862903, -0.024586565143705785],
            [-17.117074393251723, -0.020712238635620703],
            [-17.11429167926558, -0.010789756122312064],
            [-17.115753177663752, -0.00016308797999037928],
            [-17.11778305533453, 0.001256999104160763],
            [-17.123850010665688, 0.01039142520715276],
            [-17.120383290726934, 0.015997686339996087],
            [-17.11437610979065, 0.01967956757572237],
            [-17.11637974933568, 0.0252127156983475],
            [-17.12109610706114, 0.027691560229609096],
            [-17.127061880174256, 0.028705213847041427],
            [-17.126191631341577, 0.032337903792349146],
            [-17.128814582479325, 0.04116783154816553],
            [-17.136292505555325, 0.04711396797748593],
            [-17.13696797526538, 0.051195142372837794],
            [-17.130309815072597, 0.053672895245318514],
            [-17.125014455753263, 0.05157333557215215],
            [-17.120752862164014, 0.052317227937591956],
            [-17.115265414100918, 0.0568165261774445],
            [-17.109368996908113, 0.058934275874651706],
            [-17.107683371991286, 0.07347985727875636],
            [-17.1076284412966, 0.08291384508251284],
            [-17.109460866247435, 0.08480610759563684],
            [-17.113837949722758, 0.09685929229600698],
            [-17.12010312557125, 0.10224259515520481],
            [-17.12554254572196, 0.10932028653986224],
            [-17.12482820821264, 0.12046581743657149],
            [-17.12646014286279, 0.12386815964712253],
            [-17.123694008601877, 0.12621564262524668],
            [-17.12588776582834, 0.1320369379448395],
            [-17.12407193102663, 0.13824624304654107],
            [-17.126440410094048, 0.14265604053217193],
            [-17.12304047935583, 0.14526667947190852],
            [-17.120936282422498, 0.15097803348376299],
            [-17.117813519281672, 0.15336353236024353],
            [-17.11750275724734, 0.15949469562043692],
            [-17.119686754090424, 0.16381970200446141],
            [-17.119657850655653, 0.16873317632058024],
            [-17.122666373237088, 0.17078197337634277],
            [-17.12207370983245, 0.17598386167924132],
            [-17.12520138593931, 0.18143803651588525],
            [-17.124467757200875, 0.18720836823587234],
            [-17.125349940837282, 0.19292428381103174],
            [-17.121481653762107, 0.19569835113111197],
            [-17.110816360564943, 0.19316930349814546],
            [-17.107022131458347, 0.19390803641093476],
            [-17.099229318963264, 0.19869471615595755],
            [-17.09717309919464, 0.20108396484629504],
            [-17.097239067776425, 0.20581342592868324],
            [-17.093926326303585, 0.21701107632370653],
            [-17.09661851467632, 0.2199790983355423],
            [-17.095184959181946, 0.22514232933045858],
            [-17.097760826173477, 0.22698306829372514],
            [-17.09298236472359, 0.23762784866429265],
            [-17.088843690956114, 0.23891978108920436],
            [-17.086646123500177, 0.24264984259091935],
            [-17.089198859286668, 0.24627276529183806],
            [-17.090589624833914, 0.25678132846753904],
            [-17.08718735346278, 0.26281813106061486],
            [-17.08958304715044, 0.26505386762661803],
            [-17.090647084052502, 0.27216179020263154],
            [-17.093593587561127, 0.2839785357322613],
            [-17.0926988099854, 0.29279723046997513],
            [-17.094287210460575, 0.304496236767944],
            [-17.097816704310123, 0.31759711150678155],
            [-17.10201317586941, 0.31808563565918635],
            [-17.102454640826195, 0.32099528761980756],
            [-17.100353440973535, 0.3334704209168691],
            [-17.103522487998752, 0.33755454397650275],
            [-17.10196468203723, 0.34268381649972346],
            [-17.106962761803615, 0.3489730040062534],
            [-17.108326500845383, 0.3534544832924309],
            [-17.106129285787677, 0.358533891086938],
            [-17.100156866887836, 0.3607559592767529],
            [-17.10275549478148, 0.3645153938417948],
            [-17.104800768443294, 0.37143174388072314],
            [-17.1071859658303, 0.37242881059692695],
            [-17.10904160158052, 0.3770318798825066],
            [-17.10412537470914, 0.3810047696968942],
            [-17.10197777728954, 0.3881958326529071],
            [-17.105022241519457, 0.39888034783468296],
            [-17.110243719084373, 0.40381132710846523],
            [-17.111809448153494, 0.41200784226247794],
            [-17.105196062511357, 0.41651074638255164],
            [-17.106553772952932, 0.42203910656842414],
            [-17.104783927470585, 0.4256925393344051],
            [-17.110960827354628, 0.43640377799603935],
            [-17.11528278639802, 0.43602129463512546],
            [-17.126347186096297, 0.4380770961389723],
            [-17.12787590342454, 0.44458956802005795],
            [-17.133608145557034, 0.4475495367572404],
            [-17.138609675234402, 0.45211301965345535],
            [-17.14040069553926, 0.4575375364822143],
            [-17.140451542158623, 0.461842459116061],
            [-17.147083861918443, 0.4726520041739046],
            [-17.154379437421415, 0.4719094573401891],
            [-17.15773242142413, 0.47738264702186717],
            [-17.16094972110409, 0.4792532880353001],
            [-17.163283216465693, 0.48644391689861255],
            [-17.169492822140477, 0.4971298192155744],
            [-17.18672537236336, 0.5020528357552354],
            [-17.18965253487774, 0.5016214552399332],
            [-17.192462158226597, 0.5044693835846589],
            [-17.191202188909944, 0.5117531614321231],
            [-17.19652121865208, 0.5142072957022884],
            [-17.2020395949876, 0.5141669904836098],
            [-17.203711593400687, 0.517206528534235],
            [-17.20423490169396, 0.5276193238317931],
            [-17.20564276272667, 0.5314012261183906],
            [-17.211732583850623, 0.5312655624500731],
            [-17.22060886431784, 0.5400719085301828],
            [-17.23076854003346, 0.5392771936759037],
            [-17.234080129694682, 0.537545669988161],
            [-17.23667679470964, 0.5396803840791767],
            [-17.242105740807087, 0.5393078793885866],
            [-17.24634324697098, 0.5440119865247312],
            [-17.252282246440007, 0.5465394801480439],
            [-17.252617970312386, 0.5522153925446023],
            [-17.258894689487768, 0.5622957402682186],
            [-17.256751064054402, 0.5679520508492414],
            [-17.25949080259933, 0.5759947737298494],
            [-17.254346479772032, 0.579215284888799],
            [-17.251020380906443, 0.5839711020128988],
            [-17.252215729640394, 0.5887339483716926],
            [-17.250113510764443, 0.5961013431909628],
            [-17.25730131438385, 0.6098375136760609],
            [-17.257878049731392, 0.6137602639207177],
            [-17.251203199184026, 0.6210410366961395],
            [-17.253750388698474, 0.6223619713210665],
            [-17.2523667397132, 0.6266651431844169],
            [-17.253020086571777, 0.6309889170132763],
            [-17.256228502078134, 0.6366015075833918],
            [-17.25150006087185, 0.6421099506433592],
            [-17.252406646196214, 0.6460745461819059],
            [-17.251200313120144, 0.6512189067099252],
            [-17.244686395353906, 0.6559294278130201],
            [-17.24266902823427, 0.655390985384223],
            [-17.234178310696887, 0.6642257183495576],
            [-17.231966382257262, 0.6654430517653395],
            [-17.23747638197596, 0.6773868647548835],
            [-17.237185438872636, 0.6817573282646765],
            [-17.24028886987061, 0.6876922799139296],
            [-17.2410606051364, 0.6946656486789043],
            [-17.240291586358843, 0.6980791962299002],
            [-17.24322149746396, 0.7027824904494605],
            [-17.244987058347235, 0.7109779036961945],
            [-17.250733053169377, 0.7251485263867926],
            [-17.25147711876248, 0.733478176134454],
            [-17.25484463433079, 0.7408414627766189],
            [-17.265835435206235, 0.7381097679625311],
            [-17.270280033691463, 0.7338817031559174],
            [-17.276317933520275, 0.7325959217555592],
            [-17.28017297716374, 0.7407418426711019],
            [-17.282307768631256, 0.7416140361575889],
            [-17.286702367485745, 0.7492676381328469],
            [-17.29290538903169, 0.7531300492604707],
            [-17.297895126286242, 0.7581975856241843],
            [-17.301396608865137, 0.7584969862721556],
            [-17.30244180943403, 0.7634005703722677],
            [-17.30530927684805, 0.7689252706210716],
            [-17.301223243396716, 0.7772521660953734],
            [-17.295224223749948, 0.781999720967187],
            [-17.288927395561025, 0.7810144206741226],
            [-17.286222315598224, 0.7906549054875875],
            [-17.28749396259545, 0.7973680478754148],
            [-17.290625261512005, 0.7984250978631433],
            [-17.290651846556162, 0.8050587428389407],
            [-17.292752742001312, 0.8067341734535085],
            [-17.29366601808511, 0.8136251562045169],
            [-17.295682104735597, 0.8192204506972388],
            [-17.285928167773715, 0.8318880724839726],
            [-17.286112545985546, 0.8369212016205004],
            [-17.2812028169324, 0.844416989745226],
            [-17.275361562584035, 0.8460633581583855],
            [-17.271372776832923, 0.8440549616406043],
            [-17.268071818249545, 0.849578537284521],
            [-17.262459939600156, 0.8542812566709582],
            [-17.259813740021855, 0.8629341872930903],
            [-17.26106326023636, 0.8676408204495407],
            [-17.260269159738087, 0.8755350867002158],
            [-17.26421279249587, 0.8766238483540211],
            [-17.26721933424186, 0.8802694393521332],
            [-17.267663255565846, 0.8841123381715056]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.41069403502678,
          "lat": 36.511115794985805
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06027"],
        "coty_name": ["Inyo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Inyo County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01804637"
      },
      "bbox": [
        -17.30530927684805, -1.294674976816958, -15.213380053418623,
        0.8841123381715056
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.941781681497183, 3.230016485830086],
            [-18.936346061322627, 3.2351833223480853],
            [-18.932054141301617, 3.2448462975971517],
            [-18.927650080325407, 3.24772339136689],
            [-18.92612559691707, 3.25043784899532],
            [-18.92130741598168, 3.247791977123312],
            [-18.92205420124926, 3.2424696353690976],
            [-18.916646206749718, 3.235857754647901],
            [-18.91377386262218, 3.2352754539746744],
            [-18.909839025807, 3.2375655671931174],
            [-18.906207257643743, 3.235114009792185],
            [-18.901156322500952, 3.2343745428534807],
            [-18.894468727351917, 3.2267926545836385],
            [-18.888764600077266, 3.227851487025633],
            [-18.882812871924163, 3.227524256163982],
            [-18.879784452629412, 3.230254324194195],
            [-18.875218696647465, 3.231434748329746],
            [-18.872252233996747, 3.230304518319484],
            [-18.866832382859226, 3.2330445518860733],
            [-18.85962390853643, 3.2323475417782115],
            [-18.857165237399595, 3.229467426422469],
            [-18.851344949448446, 3.227482165608946],
            [-18.847582695233683, 3.227518561915756],
            [-18.84427963754986, 3.2249121239242684],
            [-18.8410768160573, 3.2264184821202586],
            [-18.83615412001273, 3.22595093529319],
            [-18.832097611994097, 3.223595232196465],
            [-18.831077596107967, 3.2301609344761877],
            [-18.82519506304849, 3.232597864533416],
            [-18.821729652954765, 3.236431630947725],
            [-18.815440992108094, 3.23424138487647],
            [-18.813988531019476, 3.2317131458447244],
            [-18.809044039508976, 3.234962189855176],
            [-18.80528180429998, 3.233206024331404],
            [-18.80306751959048, 3.228970637183395],
            [-18.798859787678296, 3.2282362784859453],
            [-18.790958160538047, 3.232328945196626],
            [-18.78819657832395, 3.229109704040858],
            [-18.784697960053307, 3.228160579358319],
            [-18.779012005313128, 3.2306775006716286],
            [-18.77496976458167, 3.230795515968235],
            [-18.77019088865974, 3.229021441751501],
            [-18.76855162786465, 3.2334597549638153],
            [-18.76549661255879, 3.2336924707888803],
            [-18.762286549153927, 3.23752892470308],
            [-18.75132723896755, 3.240837128869693],
            [-18.74604341191604, 3.2454125063317125],
            [-18.737990458077036, 3.2461755334158933],
            [-18.735354343950508, 3.2548482909403087],
            [-18.731365790672918, 3.2568490415889806],
            [-18.72611795692229, 3.2640292974322076],
            [-18.719434893338562, 3.276770266563803],
            [-18.720736321192295, 3.2819086076185857],
            [-18.715915600725033, 3.286650774271366],
            [-18.711550321974666, 3.2880413560492046],
            [-18.70894431120716, 3.291272324499695],
            [-18.69963589191726, 3.2961386796526098],
            [-18.693027762525308, 3.297862936685979],
            [-18.692597033712634, 3.3021927984312587],
            [-18.696315629312434, 3.304821740587962],
            [-18.69709711172284, 3.318180406431138],
            [-18.6940778256135, 3.326110505450693],
            [-18.68863757538084, 3.3265221239685916],
            [-18.685690183449154, 3.336844188537999],
            [-18.682114034629503, 3.335930939212171],
            [-18.68113833927535, 3.3394664131802316],
            [-18.674319813561034, 3.337481783810702],
            [-18.67237674541263, 3.3443742425752196],
            [-18.665481544801352, 3.34269014647216],
            [-18.66268473844955, 3.3534833263805335],
            [-18.659167034173468, 3.352389524724198],
            [-18.65629002857677, 3.3630228122246963],
            [-18.6527539032006, 3.362117432642654],
            [-18.64674867758897, 3.383220050802074],
            [-18.625676684941162, 3.3782030960926863],
            [-18.627867965693866, 3.371008785660793],
            [-18.60063043931648, 3.3638989797960654],
            [-18.597225755389932, 3.3770954903133124],
            [-18.574604125533966, 3.3715909974604035],
            [-18.55641873357296, 3.3661138746047077],
            [-18.558427245334094, 3.359383482273814],
            [-18.53921006857783, 3.354041433801432],
            [-18.53724938267695, 3.3603348652425784],
            [-18.530476147314083, 3.358831212841145],
            [-18.52285492539607, 3.3868820911886064],
            [-18.5161412701764, 3.385338896090233],
            [-18.51460750395872, 3.3919479242264634],
            [-18.496019269554132, 3.3882448812206714],
            [-18.494980982099484, 3.3916754159963367],
            [-18.48806813706101, 3.3899055918058973],
            [-18.483666808650298, 3.4075939409495617],
            [-18.463090197832038, 3.4020287219424494],
            [-18.457831812557554, 3.4131364814605996],
            [-18.434488656469185, 3.4241043129036663],
            [-18.397211957653806, 3.440847172116956],
            [-18.405177848093608, 3.4229324958576544],
            [-18.413692774863694, 3.401756853900145],
            [-18.414782288358683, 3.3999701203644412],
            [-18.429316671073593, 3.36557105686057],
            [-18.43332576258866, 3.3652692203473036],
            [-18.44274489453916, 3.3599856610432908],
            [-18.44906258917734, 3.3600411137549595],
            [-18.45364117667541, 3.354401508474201],
            [-18.458735709609236, 3.3536020796488892],
            [-18.460045225291307, 3.3508779438465757],
            [-18.45992342401874, 3.343448996564118],
            [-18.458238147433008, 3.338153958375317],
            [-18.458332673504128, 3.3295172005462828],
            [-18.455792228368555, 3.325780970536111],
            [-18.44842876636821, 3.324153113354148],
            [-18.45103776060775, 3.3085208757051463],
            [-18.471621723029635, 3.202134319950285],
            [-18.474024696832185, 3.2003790128657146],
            [-18.47797067031954, 3.2081993871585217],
            [-18.48688880694594, 3.2026972142933774],
            [-18.490906584724122, 3.205429918856213],
            [-18.48999699934116, 3.2106061434091835],
            [-18.49281612541042, 3.2121068793655194],
            [-18.498828106439355, 3.2126726067334346],
            [-18.50076421675165, 3.210125132146744],
            [-18.50608763091688, 3.213027100082477],
            [-18.517780039668697, 3.216292518378275],
            [-18.52013517955914, 3.2105915586386415],
            [-18.524832972743415, 3.210522874955969],
            [-18.527541835575185, 3.213172034559591],
            [-18.535548859662452, 3.2075687485620863],
            [-18.538306119683334, 3.209576766370687],
            [-18.543529052169443, 3.208251879829777],
            [-18.550996766099487, 3.2114057730607097],
            [-18.554858571931614, 3.2043131612572116],
            [-18.559355137729074, 3.204995118488763],
            [-18.562634934918364, 3.202166539101519],
            [-18.56405637205126, 3.197581352714908],
            [-18.572005971098907, 3.19186488630587],
            [-18.57351618007447, 3.185638017824041],
            [-18.58102123266564, 3.1868090429423437],
            [-18.58565598876308, 3.1782643974092375],
            [-18.58732910314062, 3.171662680257901],
            [-18.59097687537943, 3.1728056227239088],
            [-18.591235430876996, 3.1791647466472672],
            [-18.601575970994894, 3.1818835083287],
            [-18.6055662377419, 3.1802605234435175],
            [-18.606561901738473, 3.1764361676491464],
            [-18.609281339988964, 3.175377627197669],
            [-18.61625532302208, 3.1764843587598213],
            [-18.619707250027894, 3.1715303863471425],
            [-18.627661523388745, 3.165880644880362],
            [-18.62891483937249, 3.157258635924026],
            [-18.626800249655787, 3.1509258283533694],
            [-18.633699483574752, 3.1485924968170553],
            [-18.63659032182219, 3.1455901158934965],
            [-18.64160189290797, 3.143375162234504],
            [-18.643257488455724, 3.1385962594642987],
            [-18.6464869011291, 3.1361068592135832],
            [-18.65685648015523, 3.138686438191981],
            [-18.66125675976099, 3.1410784619938834],
            [-18.6649027153411, 3.1407033598251983],
            [-18.67007135213077, 3.1377940350346627],
            [-18.68086295124235, 3.1368321939784685],
            [-18.684343105865025, 3.134410108189523],
            [-18.684439582085737, 3.1292763726303727],
            [-18.682859088851373, 3.126633961486874],
            [-18.682651571803973, 3.118082805281582],
            [-18.68403989476698, 3.11677499612436],
            [-18.69011797989355, 3.11692083950272],
            [-18.691986002791765, 3.113802372986923],
            [-18.694049257804892, 3.104286490045386],
            [-18.701788013776174, 3.0971633771424916],
            [-18.70457874157056, 3.097002008607803],
            [-18.73676960351964, 2.9796469975574578],
            [-18.756573422202486, 2.906419785169321],
            [-18.76390313381186, 2.910768083228239],
            [-18.764763206754875, 2.919118593880671],
            [-18.770109389804915, 2.9244329277555257],
            [-18.770361805672806, 2.9288254040658406],
            [-18.77572315034392, 2.929792519113584],
            [-18.782808182598146, 2.9280231826110668],
            [-18.784821812953357, 2.924024357659027],
            [-18.792775715427254, 2.9248505777448326],
            [-18.797188888681195, 2.9218458884466174],
            [-18.80799968481227, 2.9202605863142708],
            [-18.816269496532854, 2.9180844286060177],
            [-18.81771331699187, 2.920974792772343],
            [-18.82125023073842, 2.9210435717527163],
            [-18.827318815522005, 2.9185058627051665],
            [-18.83259010844314, 2.9129250398142705],
            [-18.83941876891821, 2.9113452018652994],
            [-18.839876029623095, 2.9081008051134276],
            [-18.85046221652532, 2.905408677172452],
            [-18.851902489626813, 2.9023901020874927],
            [-18.86132394953893, 2.8978176761490735],
            [-18.867128320647936, 2.8966893712400266],
            [-18.872571634786212, 2.898053489329199],
            [-18.8847699016264, 2.8985659508723907],
            [-18.889527031551285, 2.899552134480793],
            [-18.89207500789317, 2.904160769897645],
            [-18.897498376903453, 2.906823294190919],
            [-18.90451770483126, 2.906478436565355],
            [-18.91253719423121, 2.9046549104384756],
            [-18.91785497929287, 2.90750136931465],
            [-18.922932803875756, 2.905900836718946],
            [-18.928956285165608, 2.9009293081918752],
            [-18.94074757043966, 2.902586898927644],
            [-18.955377715323195, 2.8947700378641517],
            [-18.968976097249918, 2.8994827600321],
            [-18.981558732596504, 2.8834388432764855],
            [-18.98754864806171, 2.8847548175161934],
            [-18.99874200156545, 2.872649666184],
            [-19.005804489466225, 2.8593695409703797],
            [-19.00958272404671, 2.860550494418166],
            [-19.007703835013622, 2.871699700266668],
            [-19.001582835063104, 2.881646632025622],
            [-19.002625512354886, 2.891268765296454],
            [-18.999539927159457, 2.8962733682890915],
            [-18.999199270676797, 2.9003615505572977],
            [-19.001425574914858, 2.909430042174163],
            [-18.999042280450574, 2.915680257054886],
            [-18.998373792126575, 2.926341215334855],
            [-18.99576646305088, 2.9303559392899197],
            [-18.98838017246209, 2.937146996426862],
            [-18.98627628743631, 2.9410295709611978],
            [-18.98926252563411, 2.9439274595968703],
            [-18.996256557500278, 2.9466570743389977],
            [-19.000420382002194, 2.9496688676075755],
            [-18.99393862571245, 2.956818169515188],
            [-18.993284568763002, 2.959837592162755],
            [-18.999058325604945, 2.970759713862348],
            [-18.999188291028585, 2.9752285575539497],
            [-18.995956055220375, 2.9953001316392474],
            [-18.99309639296979, 2.999028064848396],
            [-18.988464014276865, 3.002399022535832],
            [-18.981624592071654, 3.011046214514347],
            [-18.973709213012246, 3.0174035599160938],
            [-18.96910748077402, 3.022189231769915],
            [-18.967001048595954, 3.034078863632203],
            [-18.970188259173526, 3.0356913206037404],
            [-18.973690738854124, 3.0336559467717694],
            [-18.978721165314663, 3.035786284399417],
            [-18.976655435334273, 3.039419253661253],
            [-18.976780369367674, 3.048434903689963],
            [-18.970654423555487, 3.0564341393436343],
            [-18.967591431747792, 3.0616203284830634],
            [-18.968914278910503, 3.06976624421233],
            [-18.971401865064596, 3.0763748921443668],
            [-18.970420593623597, 3.080505348600331],
            [-18.96783792900599, 3.08330314616975],
            [-18.9689718271297, 3.0994919911543173],
            [-18.97011572330308, 3.1041844241601106],
            [-18.96663965027166, 3.1068087898783223],
            [-18.964699601830482, 3.1109340369720537],
            [-18.967679442705826, 3.114566079888166],
            [-18.967958340630567, 3.119892133340279],
            [-18.962143835399562, 3.1258235946537862],
            [-18.968672852483497, 3.133621494605019],
            [-18.968121814952077, 3.136622679168507],
            [-18.970140902560157, 3.142378746083814],
            [-18.956137836085496, 3.1491703644543114],
            [-18.9577722665448, 3.156022486973356],
            [-18.952772692713932, 3.1631133150635846],
            [-18.955426508624992, 3.1649234950307235],
            [-18.960807329619406, 3.164220157427891],
            [-18.96305124570482, 3.167815720251587],
            [-18.961365762127485, 3.173996708796616],
            [-18.964641321656643, 3.1779607801108987],
            [-18.964425898369402, 3.184453345817403],
            [-18.962152645181128, 3.1892975118454805],
            [-18.96001070152508, 3.198964484905883],
            [-18.95785458821845, 3.1992509537936975],
            [-18.95395531048405, 3.1955039616673573],
            [-18.949224777170677, 3.197655011480219],
            [-18.953024964676402, 3.202633476303288],
            [-18.954881569291135, 3.2072389645467285],
            [-18.953087262382567, 3.209935433787152],
            [-18.94818919008285, 3.206982838006954],
            [-18.946069460191868, 3.210333137596009],
            [-18.948577112915, 3.2149914823914525],
            [-18.947996703955575, 3.221321168482465],
            [-18.948583952987192, 3.227853840063305],
            [-18.943956103689654, 3.2273297365450047],
            [-18.941781681497183, 3.230016485830086]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.3512237408437,
          "lat": 39.269048750938396
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06115"],
        "coty_name": ["Yuba"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yuba County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "00277322"
      },
      "bbox": [
        -19.00958272404671, 2.8593695409703797, -18.397211957653806,
        3.440847172116956
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.087995773623478, 1.401563271388308],
            [-7.087472922818157, 1.4060242908196454],
            [-7.0844082809316555, 1.412311029042489],
            [-7.080506860192123, 1.4155954345170756],
            [-7.076543845928892, 1.416924645445318],
            [-7.0750074745727956, 1.422260605144095],
            [-7.069787360371447, 1.429897722357236],
            [-7.066172226939365, 1.4295218488342465],
            [-7.0579103124662375, 1.4314659862185375],
            [-7.052998511323388, 1.4364965018824187],
            [-7.0510621555492365, 1.4449854740256367],
            [-7.052000361380256, 1.4524686640098707],
            [-7.048213949591981, 1.4586108194210077],
            [-7.0522350366072475, 1.4658271733497445],
            [-7.053645861607455, 1.4737400412075614],
            [-7.054601066676645, 1.4844406956906602],
            [-7.050563960581931, 1.4890041466258757],
            [-7.049714441936758, 1.4966027829467083],
            [-7.040308040320554, 1.4983179108327158],
            [-7.03810833689833, 1.4954856797178222],
            [-7.028851480649012, 1.4947772406949305],
            [-7.0257051302007865, 1.4929901318548304],
            [-7.022694984201906, 1.4861707663364752],
            [-7.0174912543879655, 1.486062992735691],
            [-7.013486803502918, 1.4842410724047657],
            [-7.006956083833864, 1.4836513846745074],
            [-7.001894741148863, 1.4804748512808812],
            [-6.997997005477713, 1.4845420876877704],
            [-6.991861004086197, 1.485389394974914],
            [-6.988909794973969, 1.4917571569789834],
            [-6.9845537149932415, 1.492606703555917],
            [-6.982337926577231, 1.4963799925952181],
            [-6.978067213079871, 1.4945812178092504],
            [-6.971149646326111, 1.4943634537321895],
            [-6.967752483369218, 1.4905802866983155],
            [-6.957772090052442, 1.485295796313013],
            [-6.9406349439296, 1.4921728677393444],
            [-6.934381772735262, 1.4929763088498824],
            [-6.932727294723917, 1.4983136510060255],
            [-6.9296140061787055, 1.5021400214135012],
            [-6.924572017177188, 1.5046741259849683],
            [-6.922308732943411, 1.51258093666794],
            [-6.919027846820405, 1.5144664373397367],
            [-6.916498999772409, 1.5222476397132443],
            [-6.913483048462772, 1.5247172733334418],
            [-6.9059946678035065, 1.5224286883183697],
            [-6.900525720521972, 1.5241070836694908],
            [-6.897486241493591, 1.5328566126377323],
            [-6.894643570557848, 1.536767469025517],
            [-6.888124872146375, 1.5313254694539589],
            [-6.884245836049627, 1.532887529635517],
            [-6.878002540427902, 1.5305353126925796],
            [-6.871672592983119, 1.5328519638918359],
            [-6.852307061597113, 1.5240391872007677],
            [-6.851481829974227, 1.517485329555526],
            [-6.847696872945918, 1.5110708488805176],
            [-6.841220314656965, 1.5043935229916463],
            [-6.833657512418707, 1.5007889616535266],
            [-6.831706330863915, 1.4959993720312772],
            [-6.825956353251569, 1.494437267327831],
            [-6.816732023481627, 1.4985498080748985],
            [-6.812577422065661, 1.4985029083130486],
            [-6.810229341002037, 1.4946068613503285],
            [-6.813182869278738, 1.4905813655842053],
            [-6.814713163190541, 1.4814349381516048],
            [-6.8105103389914285, 1.4786697125979216],
            [-6.809041406664084, 1.4758766111457582],
            [-6.804465851875636, 1.474607413810057],
            [-6.802164604447902, 1.4696424929165448],
            [-6.7924270486026606, 1.4614587672996697],
            [-6.79416489115457, 1.4553567677352979],
            [-6.791282938197643, 1.4477022037110376],
            [-6.781664936280806, 1.4412003830321],
            [-6.778820169196417, 1.4406354583484415],
            [-6.772736986337257, 1.4361108878869904],
            [-6.767940603887809, 1.4367305423973131],
            [-6.7643962743897115, 1.4338610244991257],
            [-6.755595414663771, 1.4335251825584008],
            [-6.757892743874828, 1.4274622567069857],
            [-6.7548739790606875, 1.4262450920481273],
            [-6.747971680451868, 1.4280403422486225],
            [-6.743876218482493, 1.4273395199020937],
            [-6.735094088398253, 1.4236578100652633],
            [-6.725903265607084, 1.4222990984280988],
            [-6.722922175758385, 1.4190195373513697],
            [-6.715765005872102, 1.4210215852892267],
            [-6.7071059384766105, 1.4191788585798917],
            [-6.701666599355403, 1.4191478216170292],
            [-6.702662262290254, 1.4143341145172592],
            [-6.701695690431757, 1.4096761078160889],
            [-6.696771595649099, 1.4128725027774622],
            [-6.689908207865352, 1.4142046215348192],
            [-6.683902231556159, 1.4080958144203766],
            [-6.690310550442848, 1.3481496665970634],
            [-6.695036716430019, 1.2982144616710047],
            [-6.698518624654121, 1.2679569134163304],
            [-6.702596417132786, 1.2274378787261973],
            [-6.737540689040641, 1.2308436326505308],
            [-6.84602777679684, 1.243980537371302],
            [-6.873414190410574, 1.2455795995480794],
            [-6.947843017476291, 1.2513863227303574],
            [-6.949311462880713, 1.251620215616893],
            [-7.029976665839917, 1.2594521266739171],
            [-7.03483694031683, 1.263938904986273],
            [-7.035747311177717, 1.2682561680990039],
            [-7.030027392847543, 1.2728650821666305],
            [-7.026010566732388, 1.2745991868311144],
            [-7.019524053706647, 1.2745759260802196],
            [-7.0116574823223266, 1.2763532013339365],
            [-7.004827712411948, 1.2856050397531773],
            [-7.000058612000528, 1.2867543162789992],
            [-6.997683017918601, 1.2896141731090893],
            [-6.990676842227638, 1.291177031480437],
            [-6.984667527449878, 1.2970322194930708],
            [-6.984530574580412, 1.3016360355028158],
            [-6.988799922965184, 1.3090533908112834],
            [-6.987627870389812, 1.3201596213687468],
            [-6.99452578103327, 1.3280649570605159],
            [-6.9987075063617805, 1.3287408315856502],
            [-7.004888588012926, 1.3279530227025105],
            [-7.008422886300519, 1.3287257812379192],
            [-7.01339059884284, 1.3274214276022311],
            [-7.015300759046376, 1.3367601240482796],
            [-7.019472551449702, 1.3355319924956952],
            [-7.027173284892857, 1.3383825573444434],
            [-7.030519875787443, 1.342011114708008],
            [-7.036133263890999, 1.34053704544723],
            [-7.039925614177997, 1.3459280126598523],
            [-7.041065633449124, 1.3529525373438978],
            [-7.045939375720331, 1.3649544760021322],
            [-7.052811789541332, 1.3642937506442063],
            [-7.0575753176948135, 1.3625350822780262],
            [-7.062242967877185, 1.3563726451675884],
            [-7.0688894159216344, 1.359434517485425],
            [-7.070513899043028, 1.3649266252449699],
            [-7.075755831232497, 1.365242145050628],
            [-7.081337442894959, 1.3636537068661114],
            [-7.087566672502917, 1.3715498740378727],
            [-7.09199783302001, 1.3756168656354832],
            [-7.0921678067602, 1.3794069115679588],
            [-7.087044256930302, 1.3865880272204563],
            [-7.085061126379534, 1.39609784832149],
            [-7.087995773623478, 1.401563271388308]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.6444192951718,
          "lat": 39.689141119677046
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08019"],
        "coty_name": ["Clear Creek"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clear Creek County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00198125"
      },
      "bbox": [
        -7.0921678067602, 1.2274378787261973, -6.683902231556159,
        1.536767469025517
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.318670827653037, 2.6509995016188603],
            [-9.31203169768867, 2.7029239453787515],
            [-9.296167829565377, 2.81414283608019],
            [-9.27327646575219, 2.988473635073093],
            [-9.150306875384137, 2.9710401708504883],
            [-9.05645936004316, 2.958422111695891],
            [-8.962613634909033, 2.945790625978963],
            [-8.885197670693213, 2.934941352023809],
            [-8.86583283172655, 2.9328922141929854],
            [-8.717079887973021, 2.9134004012631483],
            [-8.680288600482735, 2.9086285604364357],
            [-8.628712102590624, 2.9023175116758044],
            [-8.528513625240134, 2.8911269625129794],
            [-8.43338678720787, 2.879056896434331],
            [-8.264755834450005, 2.8580993227364075],
            [-8.215907393206912, 2.8521046310531797],
            [-8.119936278120374, 2.840941747788259],
            [-8.023966758867122, 2.8297648859520534],
            [-7.987083810334168, 2.8252402957941523],
            [-8.003163833604802, 2.681623043976147],
            [-8.032608290989929, 2.422102221269554],
            [-8.07545553775364, 2.4272568876335554],
            [-8.082308147277347, 2.369303202845241],
            [-8.12532595787877, 2.374288539059581],
            [-8.127143486676408, 2.358876635861099],
            [-8.137999417650898, 2.272832037636535],
            [-8.147282620591534, 2.2079601545165395],
            [-8.152857799969743, 2.167098692113513],
            [-8.160768149222655, 2.1679286171733465],
            [-8.169175221639666, 2.082843437282675],
            [-8.169043186303666, 2.0801380141477144],
            [-8.171854438784342, 2.056153356023649],
            [-8.172198282097222, 2.053224006329736],
            [-8.214509754422762, 2.0578804357069598],
            [-8.222747943794195, 2.059405719581299],
            [-8.295044516374151, 2.0708833868900416],
            [-8.301553787872573, 2.0722253294677233],
            [-8.33290646551142, 2.0767134866346018],
            [-8.333042579889774, 2.075894114617187],
            [-8.401699762911804, 2.084363740983071],
            [-8.416039463781111, 2.086417502872389],
            [-8.416174001593737, 2.085330745093525],
            [-8.447713558428172, 2.089393390913212],
            [-8.474014200928604, 2.092471847984601],
            [-8.586451354360669, 2.1064804178223784],
            [-8.637084773835308, 2.1124063773450334],
            [-8.755578636961028, 2.1274819694147937],
            [-8.838342753201236, 2.138402492234689],
            [-8.969587254687356, 2.15623054077658],
            [-9.100834741206498, 2.174036510207811],
            [-9.232085202640112, 2.1918203964796383],
            [-9.363338628674226, 2.2095821969311964],
            [-9.381359885475707, 2.2119980690546406],
            [-9.350722291586779, 2.433404587672387],
            [-9.343245910547752, 2.483981603603303],
            [-9.342860056539948, 2.488884120994572],
            [-9.336816606898928, 2.5291464724405746],
            [-9.3244135710859, 2.607669606357837],
            [-9.318670827653037, 2.6509995016188603]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.20744766141551,
          "lat": 40.61839527082953
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08081"],
        "coty_name": ["Moffat"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moffat County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00198156"
      },
      "bbox": [
        -9.381359885475707, 2.053224006329736, -7.987083810334168,
        2.988473635073093
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.084591373050252, -0.06452297020501453],
            [-8.056548225868372, 0.17319604623669627],
            [-8.051707331579024, 0.2148267632537607],
            [-8.011070567403824, 0.20978434233078258],
            [-7.951978645876826, 0.20293910381234362],
            [-7.711468048632128, 0.17486177171205242],
            [-7.4709620567479265, 0.1467439381046161],
            [-7.348505805907465, 0.13309808607648627],
            [-7.338940924897836, 0.1336110097560798],
            [-7.333176591642116, 0.1394887904722647],
            [-7.3228561581329386, 0.1531274308726322],
            [-7.3255416232196975, 0.1591389585646321],
            [-7.322003338134452, 0.16548032727550654],
            [-7.317283541575945, 0.16221300761156363],
            [-7.310098805834805, 0.16495392788949606],
            [-7.300845737558904, 0.15977631923630123],
            [-7.29203818949168, 0.15976789531941027],
            [-7.291346230171044, 0.15385095297050097],
            [-7.286227879331764, 0.15114987193274804],
            [-7.288454616804336, 0.14484300229050184],
            [-7.284422072577813, 0.13669453150709607],
            [-7.280780489211083, 0.13488011628973082],
            [-7.2802052056652995, 0.1272160214807044],
            [-7.278226980377616, 0.12363703071205653],
            [-7.271086688685293, 0.12135947993119535],
            [-7.268666611352458, 0.12203944629872954],
            [-7.2613347160874095, 0.11084494409534054],
            [-7.25883231825768, 0.11117136196338688],
            [-7.252190576365186, 0.10342067765626302],
            [-7.2519182094096575, 0.09729985484621903],
            [-7.249244906167711, 0.09431991952521354],
            [-7.245448893440073, 0.09320612357697859],
            [-7.2434344358988785, 0.08973824469404232],
            [-7.242396289920821, 0.07755873099242484],
            [-7.233985708747093, 0.06834412101901127],
            [-7.224467347351798, 0.064020184516179],
            [-7.223696720365987, 0.06060717735448911],
            [-7.219372757079946, 0.05778366590485445],
            [-7.218171554506101, 0.05245344233586033],
            [-7.215467446178959, 0.04897735807541843],
            [-7.209116335069009, 0.04504703518963648],
            [-7.2047107314635905, 0.03577700341454576],
            [-7.203225520051198, 0.035050289373968604],
            [-7.203897432999766, 0.028570799085476856],
            [-7.201675656692045, 0.02278519670806393],
            [-7.199585350175996, 0.02114766337704769],
            [-7.198021290365457, 0.014015555326422312],
            [-7.194436862911004, 0.008071892548111866],
            [-7.193417921599143, 0.0035928614261546547],
            [-7.189943379151741, -0.0019826765515617933],
            [-7.186167122308109, -0.004688797254693491],
            [-7.1841395900165015, -0.010040181589003577],
            [-7.178255889214727, -0.01461496367680948],
            [-7.175949267941454, -0.01908742499308456],
            [-7.1725065142309425, -0.016511236048841863],
            [-7.168857029011962, -0.021729076110855033],
            [-7.164232716311331, -0.02560929127352033],
            [-7.162090604137355, -0.03242453199892932],
            [-7.156306414380259, -0.038071175307737556],
            [-7.142026648425938, -0.04328115644507944],
            [-7.140123437316383, -0.04842716587114115],
            [-7.1396805105553955, -0.053455574319495915],
            [-7.135664872311372, -0.06194158134104628],
            [-7.136752362560688, -0.06977710928988093],
            [-7.132730311572, -0.07499153899690807],
            [-7.126566446720399, -0.0794694772595904],
            [-7.12119469032235, -0.08214137640677699],
            [-7.119468616269608, -0.08532427667073034],
            [-7.114928202978465, -0.08806321827068635],
            [-7.113058050426462, -0.09191656350683758],
            [-7.113633258092722, -0.09793302499206204],
            [-7.109544875425057, -0.10318822465342063],
            [-7.105048775977348, -0.10325506051317165],
            [-7.102315580424401, -0.10792163712230585],
            [-7.099324994274438, -0.10896207633814498],
            [-7.097494155098531, -0.11708658390847648],
            [-7.0928189104889015, -0.1196357284290673],
            [-7.0858167823384255, -0.13500466390635812],
            [-7.080172707547317, -0.1390479987629352],
            [-7.078457336455294, -0.14472769886474887],
            [-7.076225467079777, -0.14722511486599707],
            [-7.075362987056651, -0.15241229798887673],
            [-7.070141259333729, -0.15644085214532677],
            [-7.065088291280056, -0.15583410973573228],
            [-7.061049016447256, -0.16268574345353345],
            [-7.05519474893355, -0.16468060414853392],
            [-7.053587628661366, -0.17096454675022177],
            [-7.056357606212323, -0.1758829002513878],
            [-7.059024606105403, -0.1774376070354574],
            [-7.057697703674799, -0.18648241700495033],
            [-7.051244134460416, -0.20565387371665214],
            [-7.04755038000364, -0.20776025235161777],
            [-7.051010660115504, -0.21345302105588454],
            [-7.05220397953706, -0.22407667589044825],
            [-7.048184511310437, -0.22999016450411194],
            [-7.048726899649486, -0.23318201383122503],
            [-7.041541402964464, -0.2439498614385433],
            [-7.0354144316363705, -0.25149601534535865],
            [-7.036313541114183, -0.25423342058259957],
            [-7.03423914144241, -0.2578518929184608],
            [-7.02906385539033, -0.2605400914758385],
            [-7.028726781155568, -0.266815684114244],
            [-7.030691017737594, -0.27010262640377375],
            [-7.028975536561788, -0.2723405071416696],
            [-7.02320695282543, -0.27539600356903693],
            [-7.0239655683640105, -0.28140799525559496],
            [-7.021974793002457, -0.2852631095063367],
            [-7.021215903173998, -0.29100079994005323],
            [-7.018127126126127, -0.2944931833802487],
            [-7.018801828728104, -0.29707895052350386],
            [-7.014369297897267, -0.2986196079467979],
            [-7.014468351381366, -0.3027903051835554],
            [-7.011187590124813, -0.31035460065922077],
            [-7.011185173139621, -0.31683144491208914],
            [-7.017305794946231, -0.32117739572347154],
            [-7.017904020406378, -0.32490366016539834],
            [-7.015046747233682, -0.32797438582367033],
            [-7.013886795093869, -0.33342364447157435],
            [-7.011995753343776, -0.3342759952743744],
            [-7.00697400565296, -0.34461048278603984],
            [-7.005941889103602, -0.3518217485214235],
            [-7.002987671604754, -0.3566494122269566],
            [-7.0062161282908075, -0.36116821558785916],
            [-7.005667803884584, -0.36452740362431246],
            [-7.000985000699462, -0.36668587837396327],
            [-6.996298192653521, -0.3745382939453444],
            [-6.993693038339768, -0.37593921764361393],
            [-6.988880840673495, -0.3817626413824737],
            [-6.982420672567724, -0.38373579591080675],
            [-6.980747504764681, -0.38056843834088694],
            [-6.974759314624854, -0.37849354949150366],
            [-6.967573876639966, -0.38056485598538403],
            [-6.96335304337705, -0.38672471868646796],
            [-6.960726330860165, -0.3885051055562291],
            [-6.9519234133307455, -0.39842812680439565],
            [-6.950114495689894, -0.4016919097869367],
            [-6.949598824266408, -0.4068931481620351],
            [-6.947282990972784, -0.41452901342174464],
            [-6.943023527663603, -0.41839252184555514],
            [-6.938834192774307, -0.4240023838682912],
            [-6.937043596145693, -0.4296416716155486],
            [-6.9332228826725295, -0.43493712173296073],
            [-6.93008270511189, -0.43693094924019227],
            [-6.930776058560541, -0.43974777977471113],
            [-6.926822448542168, -0.4447455487301908],
            [-6.930621973481828, -0.45249333149464255],
            [-6.931786913488568, -0.46000734061730436],
            [-6.92540084567568, -0.4623579813018702],
            [-6.91820468957992, -0.46145322869327227],
            [-6.910987260326027, -0.46444982562869497],
            [-6.90610571927104, -0.4724360048246699],
            [-6.904220105906547, -0.4737503654625795],
            [-6.903660100855808, -0.4822664961527765],
            [-6.899767543902381, -0.48646880965849887],
            [-6.896791211717092, -0.4926335964054632],
            [-6.8988034962945814, -0.496870924618934],
            [-6.897427628954077, -0.5007564687046863],
            [-6.904321330921427, -0.5154551797156379],
            [-6.903564942687899, -0.5195886169518271],
            [-6.906150684445331, -0.5246972400102065],
            [-6.905668082627367, -0.5293940168942677],
            [-6.906382661793242, -0.5393387026171949],
            [-6.9163628078183645, -0.5431196481512407],
            [-6.922655661918323, -0.5469214112245807],
            [-6.923359426398057, -0.5518054027180336],
            [-6.921010541461881, -0.5560167679555643],
            [-6.921468009531802, -0.560294131682529],
            [-6.919957618471077, -0.5638240486686918],
            [-6.9215994018545395, -0.5678310481666012],
            [-6.921527046609894, -0.5724910607427982],
            [-6.924563397822059, -0.5755632958358863],
            [-6.9283976486958245, -0.5824403942068465],
            [-6.927299723580296, -0.5862357085613508],
            [-6.928917208757905, -0.5911826929621486],
            [-6.960691451814396, -0.5884716598752],
            [-7.05348930095753, -0.5777863568192297],
            [-7.059997391787175, -0.5775495621099808],
            [-7.125425208564648, -0.5713467644717818],
            [-7.20327409082798, -0.5643087917219426],
            [-7.260354447723969, -0.5593482638259756],
            [-7.360529985651117, -0.549826584662045],
            [-7.381893427364851, -0.5477213639170566],
            [-7.468001931214313, -0.5387435234496553],
            [-7.548686425338272, -0.5300965288284637],
            [-7.575952440146671, -0.5269428145202582],
            [-7.693710498948849, -0.5140643685122657],
            [-7.730875898918638, -0.510180099684238],
            [-7.8084930833902355, -0.5018065732682246],
            [-7.8083980004354325, -0.49958995951411045],
            [-7.799365246950655, -0.4148169247257754],
            [-7.824176874226108, -0.41169197465792373],
            [-7.829247779953914, -0.41139926818268885],
            [-7.882204980426088, -0.40467277484435343],
            [-7.877615201659965, -0.36629518859579496],
            [-7.880147014542544, -0.36337499937737683],
            [-7.885865162657937, -0.36299981623902117],
            [-7.890743619419051, -0.3657771259558647],
            [-7.894230817500754, -0.36606025646159246],
            [-7.900267278232113, -0.36222820987847654],
            [-7.909490525189158, -0.3480908597776515],
            [-7.921036920389885, -0.35327422459340363],
            [-7.925194323903585, -0.3536829854751949],
            [-7.938019799845097, -0.347192383239875],
            [-7.941206975839612, -0.3373907810067428],
            [-7.952630134336557, -0.32108843066516407],
            [-7.956511014351025, -0.3165008762838395],
            [-7.961682714559672, -0.31420088610254476],
            [-7.969978879042271, -0.31461693177371064],
            [-7.974169905604598, -0.30936978205140503],
            [-7.991776359345183, -0.30690653982652455],
            [-8.00479033677879, -0.29024721056582825],
            [-8.006663065004854, -0.2825479897746126],
            [-8.01008389835171, -0.2809037086096737],
            [-8.011563828152074, -0.2747395371081128],
            [-8.013545039795815, -0.2732117172887632],
            [-8.01169448562768, -0.2619902198215587],
            [-8.019701224247694, -0.26029573087485586],
            [-8.022941590973629, -0.2546034860256163],
            [-8.02538987187339, -0.2535215935528258],
            [-8.031563119431157, -0.2568662278901995],
            [-8.036213273306451, -0.2537106337914828],
            [-8.043318688814487, -0.25293669038215644],
            [-8.050977526897398, -0.2552392125362542],
            [-8.055286387375947, -0.25772490940408394],
            [-8.057344474461887, -0.26126450481723923],
            [-8.060850448396616, -0.2632866874586253],
            [-8.064601530083872, -0.2631110529634567],
            [-8.068893041729945, -0.2591154791697183],
            [-8.068442729735908, -0.2546886407405744],
            [-8.070343793324986, -0.25125216655247984],
            [-8.07464505707816, -0.2477704084739013],
            [-8.074989265778889, -0.24329319571631366],
            [-8.079228729091556, -0.24030112454632777],
            [-8.08736037437573, -0.24514147099383468],
            [-8.094674813570357, -0.24419997497663193],
            [-8.095508003967568, -0.24963558070994],
            [-8.09751532575256, -0.2521523776561572],
            [-8.103064470387382, -0.252158287936232],
            [-8.106469303156475, -0.25618580689073145],
            [-8.097869734712052, -0.17505376148517823],
            [-8.084591373050252, -0.06452297020501453]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.2814860791795,
          "lat": 38.080487978695935
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08109"],
        "coty_name": ["Saguache"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saguache County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00198170"
      },
      "bbox": [
        -8.106469303156475, -0.5911826929621486, -6.896791211717092,
        0.2148267632537607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.989861094591769, 1.7919138456863328],
            [16.114954539227377, 1.8250962857240474],
            [16.118522679956097, 1.8314827549779165],
            [16.12486367331352, 1.8355096832205262],
            [16.126035569217457, 1.8422284329256464],
            [16.136673581383107, 1.8506000417007795],
            [16.13800387104445, 1.85942415323308],
            [16.140840007392384, 1.8721977759791448],
            [16.140905199916972, 1.8755023608088894],
            [16.14396764477577, 1.8789269492868739],
            [16.148042469761137, 1.8803461041812994],
            [16.149356785026857, 1.886579391266284],
            [16.153083897897584, 1.8924601428361703],
            [16.151645679791628, 1.8985491795399294],
            [16.152525128228294, 1.9035292454430424],
            [16.158394306776696, 1.9071132876972696],
            [16.16629617668253, 1.9144962776744208],
            [16.170159631718956, 1.9133519691576453],
            [16.1778187528937, 1.9178048900052163],
            [16.184541829493703, 1.9203794269300203],
            [16.18981626947191, 1.9191503304116106],
            [16.192241482839556, 1.9223013630022368],
            [16.200908348144605, 1.9251487355245236],
            [16.20132441081744, 1.929133468033355],
            [16.206799300983896, 1.9320651817743277],
            [16.212742880379547, 1.9319800440140416],
            [16.21032528977127, 1.9360130409785385],
            [16.212619142240204, 1.9407924646702945],
            [16.210675633891075, 1.943021280759208],
            [16.211557693585608, 1.9473856640593448],
            [16.20749383973786, 1.9505778915490406],
            [16.2100554689152, 1.954518303204258],
            [16.206892272527664, 1.9610311730639525],
            [16.211119984572388, 1.967261270719185],
            [16.218796667075345, 1.9721135116119664],
            [16.21891087183838, 1.9783042631979888],
            [16.225411960360624, 1.9792851043386956],
            [16.229008049521394, 1.9781598680134875],
            [16.23149769105964, 1.9728755921121595],
            [16.23461326629089, 1.9772803980432119],
            [16.242909508920803, 1.969181728387451],
            [16.24494179610982, 1.9691268170000442],
            [16.24682826192275, 1.975748423073094],
            [16.250118154799768, 1.9743994457783454],
            [16.24997880567732, 1.9702393043883148],
            [16.25641336588907, 1.9715315369071482],
            [16.25759470241592, 1.9752976760976921],
            [16.263685075134802, 1.9756124767608663],
            [16.265402683488674, 1.9798621032704913],
            [16.271877043695792, 1.9781666707180343],
            [16.27407302526241, 1.9739878997115234],
            [16.272425320703295, 1.9672247763772093],
            [16.272901783753287, 1.9608348212643523],
            [16.2784518987892, 1.952919453102681],
            [16.28711807076111, 1.9430185265892672],
            [16.309574137029053, 1.9264813765003852],
            [16.31662612828422, 1.9192791449543716],
            [16.325765030113637, 1.9145624627109692],
            [16.35640807998279, 1.887146190939661],
            [16.38108670184278, 1.8710541622880499],
            [16.395840637411478, 1.8572500365897273],
            [16.423253658082306, 1.8461182804895608],
            [16.443838074441445, 1.8424850467176197],
            [16.45926197596495, 1.8467084103919427],
            [16.470232133374882, 1.8550578838376313],
            [16.471665240839584, 1.8608474344002748],
            [16.471136800813984, 1.8644789749796444],
            [16.4654285115104, 1.8693180778041902],
            [16.466151441560257, 1.8719696458040052],
            [16.470717170028387, 1.8708834381564863],
            [16.474108333691902, 1.86470876229372],
            [16.48514212078016, 1.8412799354451317],
            [16.494829448955063, 1.8083684999127012],
            [16.522198510410302, 1.734640926773809],
            [16.528737243913163, 1.706486575949377],
            [16.536417124958245, 1.6838734349927529],
            [16.538098865230758, 1.6830500771440575],
            [16.572650883150224, 1.5652941361658144],
            [16.58101801504701, 1.5308344569992172],
            [16.47762623361203, 1.5076938544474736],
            [16.42673187050271, 1.4965866320352668],
            [16.359572691777377, 1.4823191598792258],
            [16.32700455988805, 1.4752947622144101],
            [16.29316757226496, 1.4684150958630784],
            [16.23875307799007, 1.457997823673759],
            [16.193145422846147, 1.4495063915018467],
            [16.139210924512437, 1.4401518983577317],
            [16.114486652600082, 1.4356597697359719],
            [16.090842820310915, 1.4318920773046542],
            [16.07371830816584, 1.4921384504509954],
            [16.063317166901307, 1.5298922586314851],
            [16.042959145686613, 1.602598651632878],
            [16.023762066723176, 1.6709773638343683],
            [15.989861094591769, 1.7919138456863328]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.39004628213428, "lat": 38.6605694506443 },
        "year": "2023",
        "ste_code": ["10"],
        "ste_name": ["Delaware"],
        "coty_code": ["10005"],
        "coty_name": ["Sussex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sussex County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00217269"
      },
      "bbox": [
        15.989861094591769, 1.4318920773046542, 16.58101801504701,
        1.9798621032704913
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.565228638410344, -7.663646634251491],
            [9.580597438969546, -7.661901764612513],
            [9.60364948899721, -7.659936313212077],
            [9.659988968106617, -7.65423285493685],
            [9.673877744622777, -7.6523525680537015],
            [9.746539653744927, -7.645807487149269],
            [9.744553446320744, -7.6413286220845675],
            [9.744000798817822, -7.632765706929078],
            [9.746910948137984, -7.629148091186921],
            [9.743716393393886, -7.625283929131071],
            [9.744062671994705, -7.620001184409121],
            [9.74681601369325, -7.615053197659836],
            [9.74639678192921, -7.608317095233971],
            [9.7476070935394, -7.604412843932922],
            [9.74512594232653, -7.6022824212900275],
            [9.805395914252099, -7.596054593786919],
            [9.877181462379353, -7.589117306371401],
            [9.945934525361563, -7.580881477136683],
            [9.943830137967803, -7.587227334606452],
            [9.936626557441476, -7.592863326080894],
            [9.936335598464801, -7.59699705043251],
            [9.939066273859043, -7.603282295425196],
            [9.938744376015292, -7.606420228486725],
            [9.933132624285447, -7.6101705700974],
            [9.929200267487499, -7.609825491805626],
            [9.923464255994206, -7.607388403505637],
            [9.920714724009642, -7.611206878212299],
            [9.922000476843268, -7.618459316326402],
            [9.925664596072966, -7.623136302878617],
            [9.925574709761845, -7.626047001830347],
            [9.916990640322876, -7.6376397349171175],
            [9.910040895264132, -7.658740727540484],
            [9.906345905962937, -7.667066263477896],
            [9.905039454445578, -7.677315573914362],
            [9.90786979366962, -7.6873874074111965],
            [9.906497342311711, -7.696283729128473],
            [9.905932887348063, -7.705909291440623],
            [9.90037759556589, -7.713729133415061],
            [9.900435140857562, -7.717852124620438],
            [9.903955218291003, -7.719706888582933],
            [9.913903032518991, -7.718860155448311],
            [9.915844447669006, -7.725038036738409],
            [9.911923460462585, -7.72813020618592],
            [9.90583197471449, -7.735703472853798],
            [9.905191868247671, -7.742192426535797],
            [9.906895238693014, -7.744765963079299],
            [9.912682321822103, -7.7461761638742335],
            [9.921444792279159, -7.742466863850643],
            [9.923382050318528, -7.744416385237289],
            [9.921777917623523, -7.748220861976499],
            [9.916493974268432, -7.749593951625811],
            [9.910614420612262, -7.753030342922162],
            [9.89531509951621, -7.758741718577704],
            [9.886028912524194, -7.767012299695365],
            [9.881760603513596, -7.774353476792676],
            [9.88560020457544, -7.78119884101432],
            [9.897458133964852, -7.779671897863217],
            [9.89901884668642, -7.7836437319201615],
            [9.894566823016541, -7.786458230818032],
            [9.888268324090312, -7.78829240502761],
            [9.886329794356836, -7.790847507759642],
            [9.889029114433141, -7.795606856305663],
            [9.897947404304729, -7.795911795475657],
            [9.900463950583275, -7.798216529398294],
            [9.900862001160013, -7.806613599317569],
            [9.896198156751673, -7.810983960418413],
            [9.892639809823814, -7.817781858727502],
            [9.888010446637368, -7.815247110741807],
            [9.881104324252991, -7.82260352045435],
            [9.883239183954755, -7.828813003512844],
            [9.891439478293806, -7.828110277109342],
            [9.89292492639858, -7.832482709774467],
            [9.885238881991581, -7.836192762824161],
            [9.881166329585577, -7.8422019939049],
            [9.879850138567342, -7.851136580118819],
            [9.877121945807954, -7.855093815600788],
            [9.877032569691695, -7.85858256562081],
            [9.881229557177022, -7.863244084842133],
            [9.882796110480982, -7.868098186190223],
            [9.881891104577507, -7.874382390445191],
            [9.885712503858658, -7.8767210969274855],
            [9.892846763053427, -7.87898105638912],
            [9.891333930801865, -7.883091378932037],
            [9.888143079886701, -7.883656311932872],
            [9.881148307926699, -7.881960331473829],
            [9.879457980373493, -7.884690255716814],
            [9.88295850291573, -7.890190219177041],
            [9.88164810994636, -7.892044481062276],
            [9.876190211809563, -7.89035467904156],
            [9.874661823339437, -7.894058645346308],
            [9.880093813512664, -7.9073145443766215],
            [9.87427824550072, -7.911355533923563],
            [9.876695016330554, -7.917553511725763],
            [9.876210448876586, -7.920829841803844],
            [9.87242731654022, -7.924714466642527],
            [9.876350445958671, -7.929776958459894],
            [9.877129776523327, -7.933478594866803],
            [9.872124939645818, -7.935722265684094],
            [9.869973332123955, -7.938360172480672],
            [9.870251872014508, -7.945601072097296],
            [9.863731757355518, -7.9455558984474965],
            [9.86231340308929, -7.947859964511867],
            [9.863256489698388, -7.954089926066547],
            [9.85958656521059, -7.958347642912213],
            [9.86060411853976, -7.962267308035724],
            [9.863491777934884, -7.964990679972057],
            [9.862396450127472, -7.9681332428824065],
            [9.853960402683537, -7.967935628605874],
            [9.855025814159832, -7.973857560354027],
            [9.853209281993568, -7.976956366858904],
            [9.847836573929907, -7.978655733235114],
            [9.848490862920576, -7.984519490698603],
            [9.844053840464024, -7.986098774599223],
            [9.84031672254715, -7.981011819686881],
            [9.837542691633097, -7.9833806167102965],
            [9.840338813753503, -7.988562906370288],
            [9.838963483216231, -7.991033787538658],
            [9.834333072908544, -7.989179282600219],
            [9.832681098892921, -7.993009304489755],
            [9.836258582714525, -7.997127192241236],
            [9.836248170171592, -7.999625110787057],
            [9.756830560519562, -8.00768786791396],
            [9.738265450112761, -8.009932919641722],
            [9.643534186749797, -8.020736967716834],
            [9.604056464072933, -8.024333839199384],
            [9.601172880565338, -8.025065119151733],
            [9.595834784726684, -7.977734370536271],
            [9.594773254603439, -7.960982444743021],
            [9.590085237226806, -7.9217365375134845],
            [9.589280053770018, -7.910056887837091],
            [9.577986717828876, -7.807243985590017],
            [9.578608816794898, -7.80363482735198],
            [9.57747979453274, -7.793483404105278],
            [9.570779858872955, -7.721376629826108],
            [9.567158818980932, -7.6853312989006195],
            [9.566991212775523, -7.67816602137313],
            [9.565228638410344, -7.663646634251491]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.19714229787716, "lat": 30.40603246000543 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12013"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00306919"
      },
      "bbox": [
        9.565228638410344, -8.025065119151733, 9.945934525361563,
        -7.580881477136683
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.428048274957604, -7.741853394381911],
            [11.43482868046385, -7.741208564504178],
            [11.4365971864664, -7.738479079441381],
            [11.433268401552409, -7.735117854510066],
            [11.438259064297116, -7.71730374431889],
            [11.43601725347802, -7.709387567399515],
            [11.438763211405314, -7.702589045515379],
            [11.441668154705111, -7.698667828287048],
            [11.450978011976297, -7.692426000997567],
            [11.453066798779949, -7.687210089265273],
            [11.448494594754186, -7.680635613355261],
            [11.4481273311245, -7.677150490952503],
            [11.452215813401452, -7.668080297916448],
            [11.448981266314293, -7.663019046912594],
            [11.446286997062789, -7.655596763014659],
            [11.448907799575347, -7.649041163231557],
            [11.452098129282655, -7.647922619374956],
            [11.458097031556768, -7.650065886956154],
            [11.46376232235394, -7.646425125280809],
            [11.464447083039294, -7.644612693026734],
            [11.460858232420495, -7.6403314644392575],
            [11.4613323370443, -7.634183504264092],
            [11.460089405091537, -7.630256183986581],
            [11.459711659666551, -7.622856585663056],
            [11.470639415583626, -7.612446401016],
            [11.476445890057498, -7.610576669787919],
            [11.477321298129198, -7.604682280994881],
            [11.48105730956636, -7.602012444568215],
            [11.479390734207076, -7.596794853641124],
            [11.484731202374798, -7.591719681516804],
            [11.486592564161855, -7.586130727034167],
            [11.482735089975384, -7.585114055073611],
            [11.483568352538587, -7.580668844728054],
            [11.486192594180217, -7.5770345725846635],
            [11.491426974056587, -7.576218571085138],
            [11.495504811904873, -7.57333103768048],
            [11.49640772261128, -7.570367506647069],
            [11.502844152411235, -7.570754739038639],
            [11.506710863317211, -7.563068413705887],
            [11.51172388098901, -7.558324228688499],
            [11.515086690929564, -7.55897439236712],
            [11.519831023307411, -7.556037242900835],
            [11.526170253197195, -7.55535003784552],
            [11.533528027755274, -7.55122617325442],
            [11.543371178169691, -7.548566192988442],
            [11.544989664730975, -7.543892456936624],
            [11.547977305542615, -7.547896575379506],
            [11.551915762470134, -7.559504986499808],
            [11.558084424443962, -7.5601377402988295],
            [11.561141088222795, -7.55632633256609],
            [11.567029850389376, -7.553865481012591],
            [11.572392894390553, -7.554828139967135],
            [11.574183107622396, -7.552466436347669],
            [11.580769115153041, -7.551864740963626],
            [11.586820474499376, -7.549904573153641],
            [11.590817759387901, -7.55173466094514],
            [11.601758352311995, -7.554069536586428],
            [11.603778400424158, -7.555543793792873],
            [11.610506648862081, -7.55503566584785],
            [11.612278162290524, -7.549528339926443],
            [11.618002373685005, -7.545833700101458],
            [11.620283013901215, -7.547962882850909],
            [11.6297120214167, -7.549406565766856],
            [11.632398221292503, -7.5555617669572435],
            [11.644944862818221, -7.556041369706513],
            [11.656040800312883, -7.557865766911699],
            [11.657435366577108, -7.561463821452719],
            [11.66405398910659, -7.56366250292273],
            [11.663828012392681, -7.569316172663859],
            [11.672262116545697, -7.569172040521649],
            [11.679995571446627, -7.577741641480397],
            [11.68321296634564, -7.576699705277925],
            [11.690381572434394, -7.580796017607275],
            [11.693954596864492, -7.580699436299473],
            [11.700019457727251, -7.583148854349992],
            [11.70156267373711, -7.5806578794451385],
            [11.714080787181533, -7.57588558447757],
            [11.716902186354847, -7.5769762659901705],
            [11.715276458331084, -7.581780020738122],
            [11.716618144888692, -7.585010336168079],
            [11.714717650652664, -7.5887789156202965],
            [11.719692646535718, -7.5939204164539325],
            [11.729585673556546, -7.595614247927287],
            [11.733994874992304, -7.594404268255013],
            [11.740081148551274, -7.601609169721813],
            [11.742660523147498, -7.602347366287121],
            [11.74791068902634, -7.600546522503616],
            [11.753010607903539, -7.6091868308080794],
            [11.761267077415937, -7.616167735050404],
            [11.76337450824343, -7.613456574734652],
            [11.768054460792877, -7.6137625114263106],
            [11.770693705587941, -7.608984499568426],
            [11.775126788747015, -7.609360230589017],
            [11.776909887698459, -7.612975606326599],
            [11.788871647966547, -7.612904759738745],
            [11.79116851883876, -7.615580502711018],
            [11.795031807167046, -7.606991629190452],
            [11.79890160971466, -7.607632608858682],
            [11.802717844896593, -7.610760322618902],
            [11.804169926612653, -7.614122334462498],
            [11.811075064769172, -7.664820649109247],
            [11.811884495691602, -7.66920610186782],
            [11.81727733858899, -7.70795434629885],
            [11.817990762350895, -7.711405204164436],
            [11.830292880030527, -7.80125276479273],
            [11.843170704699565, -7.889105450607213],
            [11.853355787813978, -7.958772928981086],
            [11.874752121793232, -7.955448268592046],
            [11.882115604162326, -7.95478150986144],
            [11.885141298283605, -7.964870811796185],
            [11.88361106970015, -7.97642509535416],
            [11.876986255140801, -7.981184362288841],
            [11.869960834923376, -7.984691209080262],
            [11.863267509906821, -7.99249430683105],
            [11.861631622615683, -8.001765922571455],
            [11.858590304936982, -8.004190829693707],
            [11.855277523179304, -8.012633020414366],
            [11.852963487460062, -8.014064161268255],
            [11.848259164262315, -8.01265040163171],
            [11.843636778120175, -8.016540186292524],
            [11.84148094668759, -8.020788195899836],
            [11.836674209285212, -8.024640791237832],
            [11.832555442860997, -8.031506105134492],
            [11.831369196670824, -8.035270313096152],
            [11.823920247907854, -8.034803531254466],
            [11.822170922448443, -8.037508472776123],
            [11.816443095857162, -8.036341256928356],
            [11.810837877984412, -8.037655319301493],
            [11.804341774652848, -8.040756688208825],
            [11.803735350911376, -8.046666581306448],
            [11.801908467257062, -8.04987779248374],
            [11.803035316581905, -8.053237527222988],
            [11.798821999863062, -8.054121732668893],
            [11.797447146033607, -8.062094849896567],
            [11.79349088487171, -8.066465948190917],
            [11.790341960121696, -8.071414004197912],
            [11.784926432061937, -8.069575394512777],
            [11.788245881000012, -8.062456090614981],
            [11.78162818410101, -8.058213337831841],
            [11.778576426316013, -8.055100974747504],
            [11.773647028997425, -8.054506486831196],
            [11.768062743557422, -8.058663796998342],
            [11.768961255019157, -8.063519687011926],
            [11.768073471677079, -8.067310096483125],
            [11.764601518898388, -8.06750340627055],
            [11.758883435738236, -8.06167398796609],
            [11.759635741211126, -8.057175868643943],
            [11.763304845058446, -8.052615620940356],
            [11.756906406847017, -8.050072702950509],
            [11.756335856576614, -8.043331548996662],
            [11.75314159320394, -8.039501362728108],
            [11.749216435433516, -8.038044428614333],
            [11.74921153574391, -8.03468929315273],
            [11.752594829822435, -8.028835386494245],
            [11.748782369842193, -8.022911326186257],
            [11.748286607873824, -8.016309173788505],
            [11.74504832047707, -8.010042783087929],
            [11.74006649279755, -8.003208522295346],
            [11.735836266563615, -8.004351472646674],
            [11.72297568507654, -8.004630114573107],
            [11.719758964643303, -8.002021171490673],
            [11.718723675968668, -7.997148407335273],
            [11.715707550047933, -7.994816034103252],
            [11.712261328471069, -7.989247022058024],
            [11.708718790701846, -7.977989667987434],
            [11.707467203398249, -7.9719929759519585],
            [11.704121361803228, -7.9696991125981045],
            [11.697518529190214, -7.969764556666198],
            [11.694357780703227, -7.962863353870153],
            [11.691529539354713, -7.959815720264337],
            [11.67980663566951, -7.962738464819608],
            [11.672579236637267, -7.961003690598174],
            [11.67069446195478, -7.959252964384746],
            [11.664584165550885, -7.94672249114655],
            [11.659130361730426, -7.939482421654508],
            [11.652876462453136, -7.935835884106033],
            [11.644699991520431, -7.9293786422003745],
            [11.63891647412565, -7.928560685483497],
            [11.631911522848519, -7.920718743541403],
            [11.626573052298095, -7.91947816924631],
            [11.620298511140403, -7.9160932274610705],
            [11.609005649035186, -7.913014215093535],
            [11.60469717939103, -7.9064026364001645],
            [11.605054483606878, -7.899160157331268],
            [11.602355634084509, -7.8971216879788315],
            [11.588735559364967, -7.898173272228211],
            [11.579765751313525, -7.892167280429823],
            [11.574776023234636, -7.891476928111429],
            [11.567331970210457, -7.893075957115798],
            [11.56447429236285, -7.890760507289498],
            [11.563127197395774, -7.882137743089524],
            [11.556017121050054, -7.880574633047768],
            [11.550761445269647, -7.887412267797833],
            [11.545858824245295, -7.889174858191967],
            [11.541844406228073, -7.884711478558021],
            [11.538374254231497, -7.883577833319666],
            [11.533120401599767, -7.884686378934044],
            [11.52247939336718, -7.880213948765182],
            [11.519802813367546, -7.881676325790811],
            [11.517614465855287, -7.889878261859883],
            [11.514333870150644, -7.891886042413162],
            [11.50700948615627, -7.893306313327241],
            [11.506132837863356, -7.897727921413866],
            [11.503491916136536, -7.898182905399791],
            [11.496593156181074, -7.891102642995017],
            [11.493471874598942, -7.889319816432735],
            [11.488343947324987, -7.888807085301276],
            [11.479189768336042, -7.892637309410707],
            [11.476684985798407, -7.892172436872587],
            [11.471202593751597, -7.886502691814144],
            [11.465501418397704, -7.883062772952522],
            [11.464241286624002, -7.862555375383193],
            [11.461245082418454, -7.857102936948178],
            [11.450022675851647, -7.84770932535668],
            [11.453685687003917, -7.840107604991727],
            [11.454546593218115, -7.834079948960033],
            [11.452578693436474, -7.8306323404773375],
            [11.441267760712995, -7.823901753282916],
            [11.436962971812079, -7.8175015307364255],
            [11.435105407263821, -7.8111862780540955],
            [11.43543320479982, -7.808164923506623],
            [11.43367650263321, -7.801208146550536],
            [11.43711941088383, -7.787295787395409],
            [11.436675420461968, -7.78230661425659],
            [11.439098656596508, -7.775718043131949],
            [11.438576762926887, -7.773632973943511],
            [11.4292318474718, -7.770405971188184],
            [11.426034943392903, -7.764099178821814],
            [11.429343970242009, -7.756737001489898],
            [11.424339398397255, -7.751935389606098],
            [11.42395356772383, -7.746283705594312],
            [11.428048274957604, -7.741853394381911]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.99149825678242,
          "lat": 30.195570415083125
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12121"],
        "coty_name": ["Suwannee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Suwannee County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00295729"
      },
      "bbox": [
        11.42395356772383, -8.071414004197912, 11.885141298283605,
        -7.543892456936624
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.075214268204972, -5.766146651739202],
            [11.080221357763017, -5.75967086057795],
            [11.074056801389721, -5.754868670865568],
            [11.078950709129467, -5.748213954655758],
            [11.085596691737514, -5.753113100207769],
            [11.100832379984217, -5.732854713995952],
            [11.120424885325201, -5.707806824380718],
            [11.100741264199835, -5.69262839862664],
            [11.113553081970746, -5.675938213159983],
            [11.116495704340567, -5.672753933904399],
            [11.14021112948472, -5.640559412459078],
            [11.164459729710945, -5.609100225178511],
            [11.195295064825814, -5.568272942264892],
            [11.22778144228392, -5.593633854733484],
            [11.245762530146731, -5.62203181356829],
            [11.297775679136983, -5.705149822276772],
            [11.360957053464976, -5.80596061628388],
            [11.388729898531583, -5.85014368985629],
            [11.413769453659738, -5.830701755922626],
            [11.422830757023815, -5.824336837857873],
            [11.468510630566971, -5.7879894125537],
            [11.470575637832615, -5.789624380900262],
            [11.483273650578873, -5.801338991898208],
            [11.443042772155891, -5.854795042135526],
            [11.4365027419633, -5.849945182482688],
            [11.441735116792909, -5.842963939922931],
            [11.4349710186035, -5.837737954800189],
            [11.420006556519995, -5.857963503330796],
            [11.432732140619898, -5.867517961774795],
            [11.391569453140448, -5.9229254371342925],
            [11.37916846988644, -5.939817939752818],
            [11.36950641039808, -5.951353215371952],
            [11.366794381459243, -5.955828555743093],
            [11.322536694639224, -6.013683296883804],
            [11.265013035374945, -6.089784012424228],
            [11.242767790105034, -6.119056880936839],
            [11.24300815690864, -6.114786651979914],
            [11.238379420066416, -6.115467342419945],
            [11.233111520818287, -6.110161242637471],
            [11.23010181965932, -6.1052304562198145],
            [11.227539664849546, -6.098573936542133],
            [11.228113154769892, -6.094794010538084],
            [11.2186084523491, -6.0895526264837665],
            [11.220641880458404, -6.0861399509226235],
            [11.21349320222797, -6.082595424901238],
            [11.208543519312858, -6.082422587459162],
            [11.20850654926252, -6.07334815327589],
            [11.20519749464618, -6.07220571663002],
            [11.203958012778209, -6.079200357908514],
            [11.199253704472953, -6.075752871086779],
            [11.189095757822914, -6.074099111635246],
            [11.184922037435733, -6.068064365130688],
            [11.18101283667283, -6.066857261382023],
            [11.178257591050528, -6.06272700229786],
            [11.172936006728076, -6.060240845532727],
            [11.169313300898335, -6.054858319741191],
            [11.166892341042276, -6.053587438016414],
            [11.166765848758315, -6.047687296920167],
            [11.16430826240116, -6.044564121089632],
            [11.161353579912516, -6.046591757126575],
            [11.160386281700845, -6.038724033795771],
            [11.16353860500078, -6.03729701618796],
            [11.166640280408565, -6.039346994265237],
            [11.169325860544712, -6.03411458469974],
            [11.165319349464724, -6.030217689654607],
            [11.163727126826329, -6.026249527837867],
            [11.155140848992577, -6.027968036890478],
            [11.155279864060015, -6.024833908923302],
            [11.151554862863481, -6.019470953477927],
            [11.15244551568145, -6.010378971167564],
            [11.155904297704012, -6.009067290777004],
            [11.155669392843295, -6.003661757346575],
            [11.153143529847215, -6.002087845065215],
            [11.148933239977445, -6.003310393694712],
            [11.14647688893743, -5.999660892600102],
            [11.149723540875817, -5.9941335246019],
            [11.146644164165266, -5.989822064211396],
            [11.14173848756779, -5.987972028235545],
            [11.137215059396981, -5.981382613234012],
            [11.142593549997136, -5.976496001793028],
            [11.141193140592486, -5.961299224299479],
            [11.13632780030683, -5.958941268230498],
            [11.138589124476988, -5.949591722192773],
            [11.133294812069847, -5.942264399972137],
            [11.127254232005646, -5.940799181838205],
            [11.127565270285933, -5.947217251393713],
            [11.123951125937825, -5.947874327146921],
            [11.116089552537794, -5.936597456269212],
            [11.116200575382496, -5.930642294413585],
            [11.112128816735261, -5.931608125922572],
            [11.109451769102336, -5.934845563758645],
            [11.105140748697037, -5.930231417534743],
            [11.117779105333023, -5.914104549537645],
            [11.12620225414906, -5.90742601917998],
            [11.12444394501913, -5.9050706986296735],
            [11.128741498863084, -5.899530699257046],
            [11.109645464803062, -5.884764692219304],
            [11.114203426860849, -5.87814221035565],
            [11.122594446002537, -5.86786569678467],
            [11.133967370158492, -5.852806249033405],
            [11.105365290482384, -5.8311164964685345],
            [11.055397854669971, -5.791737641352892],
            [11.075214268204972, -5.766146651739202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.16842699729307, "lat": 32.17217933636917 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13091"],
        "coty_name": ["Dodge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dodge County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00348116"
      },
      "bbox": [
        11.055397854669971, -6.119056880936839, 11.483273650578873,
        -5.568272942264892
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.87714353361691, -5.339945124204182],
            [9.939825755168606, -5.332383248213968],
            [9.943547063134012, -5.331634889508384],
            [9.98475125707074, -5.326528899200235],
            [10.028244257772235, -5.292567056293718],
            [10.03356481216062, -5.288056131685115],
            [10.033181226681636, -5.283741614195831],
            [10.040113847080528, -5.281078711581468],
            [10.05338475101328, -5.28498123012003],
            [10.059463148807746, -5.285535838005836],
            [10.060484874133722, -5.2898445906788965],
            [10.050245091925628, -5.301341165594395],
            [10.050127750011116, -5.306808122989785],
            [10.058353091969819, -5.3106682752323735],
            [10.061529071531554, -5.306267414483447],
            [10.069478449889523, -5.308389799978321],
            [10.072383643007853, -5.3129962885653805],
            [10.077004941544915, -5.317558657551361],
            [10.078688631882875, -5.321164799269126],
            [10.080604311486914, -5.330375880731652],
            [10.088596027472272, -5.334305851817808],
            [10.09324385320801, -5.333554787628306],
            [10.097021121370908, -5.326378965568785],
            [10.099293724431435, -5.319439460024471],
            [10.108685052264182, -5.318106539362742],
            [10.115169136958798, -5.321475995141279],
            [10.119968499311772, -5.328182183129519],
            [10.121918503793609, -5.333345551641212],
            [10.128333561191942, -5.338523825497216],
            [10.127820051853641, -5.341980448896901],
            [10.131763486668541, -5.345548750085632],
            [10.138786637769115, -5.358869500620557],
            [10.140805037625281, -5.366356865983073],
            [10.144712368980436, -5.366485715331204],
            [10.14865322697343, -5.372133234122712],
            [10.155347826914863, -5.374360709761779],
            [10.160133608206836, -5.3748475509790286],
            [10.164666024336396, -5.372186372460626],
            [10.168540647201205, -5.375226446505145],
            [10.172212086468889, -5.373046743515818],
            [10.169326692046143, -5.3681266149287],
            [10.172271795479574, -5.365911722624032],
            [10.175913248826808, -5.36727055575691],
            [10.180473564420643, -5.37274489323262],
            [10.186309301451352, -5.385228271093886],
            [10.190026756582935, -5.387972793107331],
            [10.195845356559014, -5.3845555752602],
            [10.199620623737303, -5.384469001566291],
            [10.20665308964226, -5.389934605023777],
            [10.217113358596581, -5.382739542135862],
            [10.222490644537125, -5.38882449551775],
            [10.227716075706438, -5.388920226570706],
            [10.232563808869738, -5.394781170237059],
            [10.230920076157469, -5.39985301413932],
            [10.231899232351614, -5.406444021998451],
            [10.228312736405469, -5.409103158229717],
            [10.21944156466858, -5.410443218820995],
            [10.213790865805851, -5.416256810154614],
            [10.211871175073346, -5.419710881967538],
            [10.205939078545413, -5.4247671519819285],
            [10.192991749244845, -5.426874379083237],
            [10.197329856589358, -5.468317544651087],
            [10.176229120357545, -5.470580980215548],
            [10.172271975605067, -5.503958524287433],
            [10.172877571181248, -5.513048463163866],
            [10.170279196264822, -5.519284239252563],
            [10.165764584420211, -5.5237508915597875],
            [10.159068319790826, -5.534804638976146],
            [10.155011442443765, -5.537219419140017],
            [10.14799861599568, -5.543491298912077],
            [10.153536724186367, -5.591807266867726],
            [10.129932330637862, -5.5942887222630455],
            [10.123997822383496, -5.595243531989489],
            [10.084322619009694, -5.60018613696254],
            [10.086212924862666, -5.613706732729895],
            [10.075511991151794, -5.615106686133638],
            [10.076157885369637, -5.621473974129644],
            [10.052922489472582, -5.6234058885426785],
            [10.05216618201498, -5.616303910327732],
            [10.044179702296288, -5.617189540778464],
            [10.044943062740032, -5.624487234390787],
            [10.037652983947243, -5.625217571397818],
            [10.03691737636344, -5.618690809664599],
            [10.028927104365705, -5.624638124349027],
            [10.025435585723665, -5.629369914962587],
            [10.026483935900536, -5.634211638223921],
            [10.03001494151538, -5.63388856675497],
            [10.030729635034676, -5.640832849923903],
            [10.023395518086913, -5.641573031518169],
            [10.021455679014712, -5.6441187325522275],
            [10.014256131569034, -5.646484930427185],
            [10.01082441557477, -5.648675248090868],
            [10.003510826718198, -5.648794144067086],
            [9.996783738388114, -5.643726463407574],
            [9.997080726232142, -5.641360328740289],
            [9.993673100084461, -5.638274130752972],
            [9.988745701443946, -5.639052202512784],
            [9.980512136155534, -5.645121638674807],
            [9.966721001296964, -5.641656960452148],
            [9.957008683866148, -5.642715596217636],
            [9.950226071166936, -5.649771443319505],
            [9.943833901444343, -5.651663774857459],
            [9.93939702337192, -5.657477069915922],
            [9.934305483772839, -5.661637416537668],
            [9.927802109214849, -5.661650777815985],
            [9.92104409863978, -5.663353813161607],
            [9.92456162595291, -5.660327076908458],
            [9.926489828850215, -5.653774274250596],
            [9.931622498019763, -5.649193140566682],
            [9.930536345344576, -5.635822379005925],
            [9.932950344834754, -5.6327659906078615],
            [9.933229247223457, -5.624004720469589],
            [9.938153335925117, -5.615741853245036],
            [9.915550462866722, -5.618685488449179],
            [9.913183978156757, -5.598557671657174],
            [9.911641801783832, -5.582237922583954],
            [9.903472102210602, -5.515586269785146],
            [9.901663265388967, -5.497265095129069],
            [9.89386764030244, -5.497763616196006],
            [9.892108198953558, -5.483330039531689],
            [9.895030590551725, -5.482765775205709],
            [9.894143317668904, -5.475498704132441],
            [9.899346083790748, -5.475020018813559],
            [9.897774096131382, -5.460728519682948],
            [9.90633827098746, -5.459414551423136],
            [9.905446353973016, -5.451860090234365],
            [9.901150038737512, -5.452356525720786],
            [9.900258212588147, -5.444000088358831],
            [9.895982340552434, -5.444452517577809],
            [9.894308333854095, -5.428147555170495],
            [9.885688669071653, -5.35431022951799],
            [9.87714353361691, -5.339945124204182]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.5329907193073, "lat": 32.699506317894404 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13263"],
        "coty_name": ["Talbot"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Talbot County"],
        "coty_fp_code": "263",
        "coty_gnis_code": "00326757"
      },
      "bbox": [
        9.87714353361691, -5.663353813161607, 10.232563808869738,
        -5.281078711581468
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.055601950675692, 6.615538876613781],
            [-13.05252425203571, 6.614338583416154],
            [-13.043557750266631, 6.622391901664323],
            [-13.039137373094105, 6.620994843808874],
            [-13.032773353878614, 6.623538351902005],
            [-13.027936368726971, 6.628561225806601],
            [-13.024091763634374, 6.636627053999982],
            [-13.021198788980332, 6.639577325296702],
            [-13.01436447549205, 6.641478275749713],
            [-13.013360352832654, 6.643774948087391],
            [-13.00228420221177, 6.646965745721988],
            [-13.000064230884634, 6.649151201290673],
            [-12.993372792154434, 6.651176958718936],
            [-12.990925978649763, 6.65048090214792],
            [-12.987001264466373, 6.653456389160083],
            [-12.97588348524158, 6.655137279722241],
            [-12.934071898084259, 6.646785632509331],
            [-12.946877525082309, 6.583065811057556],
            [-12.853581601407155, 6.564475064211121],
            [-12.849083508045311, 6.561516233203003],
            [-12.84862348108741, 6.558243690627016],
            [-12.839868754161254, 6.555845183244447],
            [-12.838090152073958, 6.5476725639601865],
            [-12.834984997197331, 6.548703393461176],
            [-12.830349484465712, 6.546207946004887],
            [-12.829409991326918, 6.5429120999070625],
            [-12.824628584554732, 6.538548930323016],
            [-12.824851694281392, 6.533051345929752],
            [-12.819988073814846, 6.527658570476275],
            [-12.815329915426622, 6.525930648273977],
            [-12.807445796571892, 6.52070916565351],
            [-12.806976942832344, 6.516700039243688],
            [-12.804401106930095, 6.515106684204538],
            [-12.800107150845314, 6.504168115156074],
            [-12.795085802889977, 6.499446965201924],
            [-12.796274028085726, 6.490874813951205],
            [-12.799247235950562, 6.485559944985759],
            [-12.797118218066354, 6.48105607019523],
            [-12.798658568860834, 6.476097616291733],
            [-12.79118206065035, 6.471372705536132],
            [-12.786198236077892, 6.4664451339576665],
            [-12.776604085870344, 6.466975077390531],
            [-12.762054004594305, 6.463019469787884],
            [-12.758003128030133, 6.465169589031984],
            [-12.755764403106962, 6.468710361665331],
            [-12.751628245824916, 6.470164741181633],
            [-12.747935490914, 6.478099675730629],
            [-12.75081310980357, 6.487268597506778],
            [-12.744193563528013, 6.497169810570014],
            [-12.741070413967979, 6.499034278853758],
            [-12.740508496239883, 6.503718688646216],
            [-12.743115823868228, 6.509204164327579],
            [-12.737108410008823, 6.512450035164908],
            [-12.725273781656872, 6.512902186150602],
            [-12.720063378299793, 6.514615777933084],
            [-12.714200323548726, 6.505349508789244],
            [-12.704474624160689, 6.503950072210675],
            [-12.700869265841694, 6.501659736755949],
            [-12.692353197680532, 6.501767069172171],
            [-12.691703643274325, 6.499725162341526],
            [-12.682023871162121, 6.493973287598923],
            [-12.676825974178984, 6.493196268420515],
            [-12.668910051438651, 6.495626329056393],
            [-12.665659147918753, 6.4917280175177865],
            [-12.661309632605642, 6.489780912530003],
            [-12.657582785663156, 6.4854955915715955],
            [-12.655924444357543, 6.481532856385511],
            [-12.645087865304129, 6.476526355490058],
            [-12.644273475492607, 6.4741277535829935],
            [-12.63732718088528, 6.467652394116685],
            [-12.631763667540312, 6.470902227138456],
            [-12.630464809647432, 6.476755338932181],
            [-12.6270925571565, 6.477212162912042],
            [-12.62190450617094, 6.480341200301554],
            [-12.615910017703872, 6.476487340498626],
            [-12.608668832552587, 6.47412510694178],
            [-12.604131646809092, 6.47533884728252],
            [-12.602433412572207, 6.472767650151092],
            [-12.58776970360464, 6.47113396147044],
            [-12.583166594167354, 6.4669684338365006],
            [-12.579712814554327, 6.461227876537763],
            [-12.583695030791217, 6.454865173035437],
            [-12.584286902334645, 6.449680660442167],
            [-12.58641832978076, 6.44445047472124],
            [-12.583012541091469, 6.434348413001322],
            [-12.587096703741366, 6.426640601057347],
            [-12.587567158792345, 6.422409814611849],
            [-12.586689692145233, 6.4140861276586305],
            [-12.580493698688331, 6.409700080256023],
            [-12.575305027082983, 6.401177239494807],
            [-12.57024029305948, 6.398794835429732],
            [-12.566535622587205, 6.389493177106162],
            [-12.562903490336891, 6.3862415358442615],
            [-12.553971777965522, 6.38085149329476],
            [-12.549058289399898, 6.374324471983701],
            [-12.543651990695983, 6.3718226324770395],
            [-12.543294828710868, 6.367809894906843],
            [-12.537990801053152, 6.362448632132987],
            [-12.533476663707797, 6.360796581724257],
            [-12.527365833792121, 6.360892813080703],
            [-12.522086860770436, 6.352315664194947],
            [-12.522592261057227, 6.349961166407102],
            [-12.51594536413562, 6.342901233637372],
            [-12.508603354156739, 6.343049404380361],
            [-12.503467319614106, 6.340339907927722],
            [-12.50060280790685, 6.333372992932316],
            [-12.500531199506788, 6.3263730451947255],
            [-12.503591936907913, 6.321989015081608],
            [-12.501132159935105, 6.315891386099594],
            [-12.496200352297018, 6.311280329211161],
            [-12.491998194269883, 6.303556745063908],
            [-12.485796733035235, 6.298430637947735],
            [-12.482126764907942, 6.297015681187175],
            [-12.472530329641602, 6.297766419322025],
            [-12.467931414209543, 6.293635210761555],
            [-12.459882928753975, 6.291661088981901],
            [-12.456015138096781, 6.293245976440767],
            [-12.453730745609903, 6.2962284696579545],
            [-12.448961374787679, 6.296852508562422],
            [-12.445717820301955, 6.30091009916107],
            [-12.444930942902158, 6.30773108262562],
            [-12.442889972849994, 6.310648296846748],
            [-12.44322627455801, 6.315040157680916],
            [-12.434213831990133, 6.3177993935679435],
            [-12.427721305846543, 6.318308829617807],
            [-12.424085561327958, 6.324118984638051],
            [-12.420930755156865, 6.3223158030781565],
            [-12.41751356197347, 6.31648516268234],
            [-12.410108027682563, 6.3146250137045215],
            [-12.407611308045066, 6.312474416360765],
            [-12.405752436198824, 6.3046345707212055],
            [-12.401912618828838, 6.302077941285625],
            [-12.406005561314672, 6.29527720930601],
            [-12.404066877508125, 6.289481937726269],
            [-12.399829471832616, 6.282725608165415],
            [-12.399366365918372, 6.2790874548802025],
            [-12.402339167403447, 6.2707045180548935],
            [-12.398237023385645, 6.264000317024085],
            [-12.397263028716663, 6.252401960417335],
            [-12.394761389714258, 6.249426697888657],
            [-12.38909980143592, 6.247038844193598],
            [-12.386014630921839, 6.243604392178685],
            [-12.381562275425194, 6.235324294186591],
            [-12.380875766640234, 6.23039636166527],
            [-12.377232969081662, 6.2267364896908335],
            [-12.373844870214686, 6.2190238683095185],
            [-12.36983740049757, 6.215138693872933],
            [-12.362281702112714, 6.211253681112669],
            [-12.359995476273031, 6.2086297365488905],
            [-12.35853277960107, 6.199188118069992],
            [-12.360171716686962, 6.195043601562442],
            [-12.359192185494502, 6.1861099546332134],
            [-12.351332725341939, 6.182856134483501],
            [-12.346564381501755, 6.184371329644471],
            [-12.344177211414692, 6.182039912343872],
            [-12.33810472980213, 6.182914410405487],
            [-12.334238091368203, 6.1782034810880715],
            [-12.32982659113229, 6.17476606774635],
            [-12.331416429036668, 6.171377929586999],
            [-12.330320168306098, 6.164800364223137],
            [-12.327441678982566, 6.16311776305982],
            [-12.325628133011003, 6.157329659017008],
            [-12.320639971518512, 6.153659984695482],
            [-12.320073191864205, 6.146140545697948],
            [-12.31728289141151, 6.1398153745258535],
            [-12.318931836281681, 6.13686361685395],
            [-12.318535644893403, 6.13286795830236],
            [-12.313816050390622, 6.131295957806161],
            [-12.308311606179824, 6.131479204827946],
            [-12.303683279480673, 6.125135262408572],
            [-12.302804638671972, 6.118626322517215],
            [-12.304611053934734, 6.116511912446467],
            [-12.30476967133733, 6.108760877267433],
            [-12.303188766167047, 6.101211376159922],
            [-12.304362808484075, 6.097498343668813],
            [-12.298887039566777, 6.0928776526313655],
            [-12.288369674312232, 6.0882323186856215],
            [-12.284225999158272, 6.087713672954017],
            [-12.280891783002238, 6.091659931472419],
            [-12.278170250969827, 6.0907362263893505],
            [-12.275164197158489, 6.09317986680012],
            [-12.269854142566784, 6.094397496570153],
            [-12.265459396587453, 6.09271250502944],
            [-12.260256716712664, 6.101026842042222],
            [-12.260031061202803, 6.1038519382092185],
            [-12.2487736947834, 6.103205735365848],
            [-12.244823322153275, 6.103980876131662],
            [-12.227083444300636, 6.094975888965192],
            [-12.225006819973665, 6.089545475359187],
            [-12.22438417324747, 6.076416467100477],
            [-12.222654246324383, 6.070733742211367],
            [-12.224841456254628, 6.066649440267682],
            [-12.222906765801428, 6.062235449941277],
            [-12.226347581513435, 6.051503799973006],
            [-12.22462843483029, 6.048464701887454],
            [-12.225531379108896, 6.041584908566331],
            [-12.224227993270095, 6.038915371621051],
            [-12.217315172314134, 6.032220745079672],
            [-12.216049517237954, 6.027659456134898],
            [-12.215370333995285, 6.018794730114491],
            [-12.222648786574796, 6.00855924408061],
            [-12.21834080423879, 6.004471626691345],
            [-12.21488613863936, 6.004546472546962],
            [-12.210255728985864, 5.999502472719887],
            [-12.202196166203365, 6.000424538380652],
            [-12.1997597664511, 6.0025233197510826],
            [-12.195861045365586, 6.000620213848746],
            [-12.204308159111928, 5.95674550508575],
            [-12.215533123331541, 5.900144081170184],
            [-12.220588152273564, 5.873117979771346],
            [-12.1428848750559, 5.858620782306016],
            [-12.065184128047038, 5.8441098506120035],
            [-12.06321316587228, 5.843532993037632],
            [-12.026279366032462, 5.83673006759829],
            [-12.04137202979227, 5.755638100808408],
            [-11.915024060595169, 5.732725985167626],
            [-11.788682484013869, 5.709778022868787],
            [-11.81212701882377, 5.58190262367335],
            [-11.820068405955944, 5.538692273337421],
            [-11.904277035641037, 5.553974561471205],
            [-11.988488443514608, 5.569241285026233],
            [-12.0363352201305, 5.310564815893753],
            [-12.031537930488799, 5.309637807295351],
            [-12.04707883723414, 5.224951770987068],
            [-12.005368593685832, 5.217493720344394],
            [-12.020908496758016, 5.131815017269101],
            [-12.06277499443263, 5.13929329966021],
            [-12.071950012470346, 5.089970395191957],
            [-12.080439512210733, 5.082996719357074],
            [-12.083664182939998, 5.082529420805973],
            [-12.087595413908794, 5.085196532889444],
            [-12.08776413684983, 5.092296205700742],
            [-12.089523781447266, 5.096289472739808],
            [-12.104118775644405, 5.0979224251562485],
            [-12.108787739665113, 5.101937675658285],
            [-12.1134321849356, 5.1033787974814535],
            [-12.11981159724136, 5.102291154767217],
            [-12.123799351437976, 5.105474412655919],
            [-12.126458380641118, 5.112555571945168],
            [-12.133489172583328, 5.120693152437222],
            [-12.135086800804089, 5.129979583347715],
            [-12.14145667771185, 5.135024217185707],
            [-12.143933873709084, 5.138406179349588],
            [-12.146548489064728, 5.145475897560947],
            [-12.15237529983124, 5.152467075158766],
            [-12.153473275948413, 5.160368746477331],
            [-12.15708929273474, 5.1683628818986],
            [-12.15981651705247, 5.1698493170933855],
            [-12.173136470148599, 5.1701723731812255],
            [-12.178064879925778, 5.169201826977415],
            [-12.188488928080094, 5.161495328886267],
            [-12.194983085869843, 5.160899284072261],
            [-12.20523807740104, 5.16370034024379],
            [-12.215699939100631, 5.1627591148096945],
            [-12.232978228826326, 5.164525492862432],
            [-12.22289806354222, 5.219145702913421],
            [-12.19988914964111, 5.341653393198129],
            [-12.157600633646737, 5.333805614690124],
            [-12.094272043709633, 5.676422544089769],
            [-12.093874645933369, 5.679031963542222],
            [-12.20108005933843, 5.69894791675523],
            [-12.308290133440863, 5.718838290045352],
            [-12.413709220507705, 5.738984200224672],
            [-12.519132982399222, 5.759105315891567],
            [-12.606909175609687, 5.775965464959751],
            [-12.69468860616158, 5.792808409568454],
            [-12.748027587344032, 5.802758731860769],
            [-12.778562285303888, 5.808609281032289],
            [-12.76724033336743, 5.865374867493129],
            [-12.781517044449433, 5.868204697005978],
            [-12.76807631485141, 5.935519813688382],
            [-12.777628072040736, 5.940897889866807],
            [-12.783581327558833, 5.940688499108312],
            [-12.789023749327006, 5.944152000725273],
            [-12.791949971365712, 5.94832447208379],
            [-12.797215874376224, 5.946500939017004],
            [-12.801126772927116, 5.946777283357986],
            [-12.806176094646597, 5.949053069926563],
            [-12.81598296965604, 5.943653768624501],
            [-12.827669932636912, 5.953493748251411],
            [-12.834102567147184, 5.951300311698798],
            [-12.844573732194666, 5.953427391588086],
            [-12.847764421017553, 5.957914535521754],
            [-12.854792795498424, 5.959539225442533],
            [-12.862989257437054, 5.959832181966463],
            [-12.866024731318733, 5.961996454501597],
            [-12.85905004205856, 5.996521488226815],
            [-12.853812435130891, 5.99547856967115],
            [-12.847712019392587, 6.024599086884585],
            [-12.861801027073883, 6.0274066060190385],
            [-12.854894042083297, 6.064377753389345],
            [-12.850018633811692, 6.068701490455242],
            [-12.844849382780707, 6.067084079270136],
            [-12.84149554792851, 6.072381268761429],
            [-12.829969059189587, 6.081203859874423],
            [-12.827290706330508, 6.081263905329138],
            [-12.82475006685724, 6.087296110639626],
            [-12.820599114532305, 6.09333414319275],
            [-12.818579257110105, 6.1035616646340864],
            [-12.82224156111713, 6.106328741449125],
            [-12.822820982579028, 6.113739167554397],
            [-12.824070262182772, 6.116545151414851],
            [-12.83180759564392, 6.115535580749418],
            [-12.835713900082316, 6.11822515197748],
            [-12.840336075309967, 6.123910844498491],
            [-12.847945456390999, 6.124929892351892],
            [-12.853197914869208, 6.128073673556053],
            [-12.85292273864305, 6.131716924776671],
            [-12.856581442490851, 6.134419267860965],
            [-12.857698241182934, 6.139179492196432],
            [-12.860952449602884, 6.146400985902234],
            [-12.8624257032018, 6.156641254887259],
            [-12.870835324725038, 6.16446408021162],
            [-12.869010436931884, 6.171053800975168],
            [-12.864490479290916, 6.178677326905598],
            [-12.85958305460522, 6.1812651379722325],
            [-12.861979230055537, 6.184424916103889],
            [-12.859110042801085, 6.190246473517027],
            [-12.863560657168874, 6.195574277850128],
            [-12.86724112522385, 6.197879595300711],
            [-12.86838147260745, 6.200856271566366],
            [-12.87235295334431, 6.199850355161983],
            [-12.878361718546927, 6.20475043711737],
            [-12.88130373745019, 6.211494511041004],
            [-12.89034525265567, 6.211220543186004],
            [-12.894457904207393, 6.216993095116854],
            [-12.893790397551339, 6.221888721953578],
            [-12.896425119478902, 6.2263584703164145],
            [-12.898343717793079, 6.232774912713646],
            [-12.90331621809591, 6.2337303116873715],
            [-12.90566141296152, 6.2358901708206345],
            [-12.913947770303784, 6.236005126799503],
            [-12.92057703885981, 6.234477540041926],
            [-12.920540067865867, 6.237543005289095],
            [-12.916806087796445, 6.246333524938016],
            [-12.91668263300135, 6.252608042979866],
            [-12.913179170069794, 6.259395355267377],
            [-12.905851363668877, 6.265804583347967],
            [-12.903245802103607, 6.270895258832554],
            [-12.9045822680367, 6.2782202690414675],
            [-12.901944651208893, 6.281611489134527],
            [-12.896061893130707, 6.284778325421369],
            [-12.895274342128046, 6.290967158352308],
            [-12.892810620153316, 6.295284401641762],
            [-12.892615471643008, 6.300568176779539],
            [-12.895477556957424, 6.309196422232403],
            [-12.90052229191377, 6.309989786987821],
            [-12.902699091857935, 6.311968659073623],
            [-12.90187454669856, 6.31610684049619],
            [-12.903595013894988, 6.318140993489625],
            [-12.905811328461358, 6.328984765634894],
            [-12.90345444742538, 6.334979016477798],
            [-12.895110937255339, 6.339079023039503],
            [-12.897405914345049, 6.346661220374644],
            [-12.895227164869372, 6.357810239545744],
            [-12.892750120897484, 6.365119262342848],
            [-12.889771768303833, 6.366174424518109],
            [-12.888015014907511, 6.37000719086884],
            [-12.883482070199992, 6.373251118190204],
            [-12.879934699873955, 6.377697439301152],
            [-12.881576257706048, 6.383281688410763],
            [-12.886118158092922, 6.384542327928526],
            [-12.88931906196739, 6.382976738806781],
            [-12.89470130037379, 6.392242472531047],
            [-12.894467140639044, 6.396319154720343],
            [-12.891138098870796, 6.404562237246181],
            [-12.893509647832502, 6.41735537161678],
            [-12.889786145441612, 6.42574135121149],
            [-12.889917179843803, 6.430297783702106],
            [-12.89173510391223, 6.436208652094508],
            [-12.891262882970791, 6.441778816066276],
            [-12.892278188800319, 6.447755417914641],
            [-12.895584403565858, 6.451542839380043],
            [-12.900387290712219, 6.459514353122551],
            [-12.908268475582924, 6.45131967347134],
            [-12.911951243635478, 6.453685155405613],
            [-12.916361880388001, 6.453055637312588],
            [-12.91901183146729, 6.454505414814692],
            [-12.92694125174866, 6.450380253525659],
            [-12.930606406060688, 6.450500881793224],
            [-12.935996790635748, 6.4424176543883975],
            [-12.943516315301096, 6.445890479128606],
            [-12.94619425513303, 6.445229476273035],
            [-12.94847398523863, 6.4541069702375635],
            [-12.952621026509096, 6.456882695962746],
            [-12.957925549626804, 6.456959709714128],
            [-12.96217971689981, 6.458911854085111],
            [-12.96410347922955, 6.456952629097216],
            [-12.973318978391179, 6.456855442477991],
            [-12.980244958445876, 6.450525846209366],
            [-12.985130676617873, 6.448497199671385],
            [-12.986150578506463, 6.453843806339882],
            [-12.991521342174131, 6.45643585611594],
            [-13.000449492790898, 6.4546891251591365],
            [-13.002714732034987, 6.459650884483119],
            [-12.999092337744957, 6.469481311499086],
            [-12.994221723393345, 6.472818211266375],
            [-12.992819584350524, 6.478910339715078],
            [-12.995535513546772, 6.481171349682437],
            [-12.99929997691463, 6.481278116203748],
            [-13.004087378520104, 6.486876881988504],
            [-13.018040433069583, 6.4919880987401815],
            [-13.019020615158588, 6.496052121013938],
            [-13.022994741026805, 6.498658790480788],
            [-13.027756465691862, 6.4982810488751],
            [-13.03262688676453, 6.502284904234827],
            [-13.036870946333803, 6.5084258122288166],
            [-13.04249538276981, 6.509916458297257],
            [-13.046769935089397, 6.513779658334613],
            [-13.052919202035122, 6.521700081698558],
            [-13.058624529527322, 6.530646298630763],
            [-13.063708712631723, 6.531124887927402],
            [-13.072004873307517, 6.527543679540258],
            [-13.07476437766526, 6.533631334308542],
            [-13.07917689179471, 6.5354506829164105],
            [-13.084080738838793, 6.540126046402896],
            [-13.077752511723158, 6.545495333397304],
            [-13.07458541745979, 6.54400066178014],
            [-13.071509471899159, 6.546548079263533],
            [-13.069922544046827, 6.550563002323738],
            [-13.069382223858517, 6.5576658675225],
            [-13.074441658293857, 6.564570606985099],
            [-13.078028049725727, 6.56665137622135],
            [-13.07708917056129, 6.5754941069027355],
            [-13.075105918940913, 6.58148708375207],
            [-13.078773734669388, 6.589739087898148],
            [-13.078179460522339, 6.595762904801112],
            [-13.0724459904065, 6.6018777966339774],
            [-13.067767235916037, 6.6003934601155905],
            [-13.062248748683057, 6.607921372549254],
            [-13.06238953756863, 6.611448316918899],
            [-13.055601950675692, 6.615538876613781]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.98015797601852,
          "lat": 43.411950666254015
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16013"],
        "coty_name": ["Blaine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blaine County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00395696"
      },
      "bbox": [
        -13.084080738838793, 5.082529420805973, -11.788682484013869,
        6.655137279722241
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.38170560975227, 5.984685087166],
            [-11.34120186847362, 5.977333346817146],
            [-11.198585612169314, 5.952722651374048],
            [-11.1316858000678, 5.941474185329396],
            [-11.06377906652913, 5.9294067700851665],
            [-11.00095427292944, 5.919010969429433],
            [-10.873596870359764, 5.8981736135546505],
            [-10.819443935852712, 5.888972641114912],
            [-10.746730825369637, 5.876983229109343],
            [-10.704057992116148, 5.870035469540621],
            [-10.704795562768766, 5.865296707332338],
            [-10.586602178287455, 5.8459101161416465],
            [-10.47570079818021, 5.82784438724652],
            [-10.471978721289192, 5.819603083270511],
            [-10.465545883392963, 5.810546487243691],
            [-10.467581184306681, 5.804400197062768],
            [-10.46502471542598, 5.80060718349142],
            [-10.46833678547334, 5.79457274122245],
            [-10.466625208420782, 5.789639890194082],
            [-10.466733152399053, 5.7855066389857],
            [-10.464713162640876, 5.778667509882768],
            [-10.46304147141222, 5.777192191063897],
            [-10.465803052542189, 5.772470723269641],
            [-10.464351038352461, 5.769307568816905],
            [-10.464748200525708, 5.76461813091569],
            [-10.467587598518945, 5.762237520317322],
            [-10.465494944266132, 5.759629408100311],
            [-10.462372090069634, 5.746742548091786],
            [-10.456820591616715, 5.7416739311425715],
            [-10.450800145071605, 5.740722201603101],
            [-10.440566107577158, 5.7413331763542415],
            [-10.436512392801157, 5.7458206874777185],
            [-10.432058938211545, 5.741501264815062],
            [-10.423518569008651, 5.738734211409326],
            [-10.415195175228618, 5.741518364303643],
            [-10.41350382422953, 5.736088982241035],
            [-10.406049434168114, 5.7255567736767174],
            [-10.401237557394209, 5.7239907232385185],
            [-10.39688831270623, 5.719190395910603],
            [-10.39170865785319, 5.715148842310851],
            [-10.387276731322688, 5.715254153093735],
            [-10.37926361677891, 5.710741796233371],
            [-10.372996359706125, 5.711983170158217],
            [-10.369272189030477, 5.715189708062205],
            [-10.365603225557924, 5.713342552773696],
            [-10.362318796725452, 5.706551819906008],
            [-10.358136642607858, 5.705434392085066],
            [-10.361794324867091, 5.697140628223355],
            [-10.353484870698784, 5.686015101376792],
            [-10.382421452081857, 5.50292348966981],
            [-10.400422347295132, 5.388958953394926],
            [-10.420642962290767, 5.262362204437053],
            [-10.429036113304402, 5.209999780893528],
            [-10.56632586057536, 5.232083102987745],
            [-10.566153462342479, 5.233085938487507],
            [-10.650689915917463, 5.246682771280478],
            [-10.650600519344723, 5.247283077674488],
            [-10.734933603203602, 5.260349673402237],
            [-10.82030587211489, 5.27399405334581],
            [-10.791815339243897, 5.446394427920155],
            [-10.790919487113596, 5.446255955975408],
            [-10.776302007237934, 5.532319136967365],
            [-10.860428422761395, 5.546340550700567],
            [-10.943725797716283, 5.560559906012699],
            [-10.929764930889675, 5.643165427308222],
            [-11.017674416767823, 5.658198376724403],
            [-11.05588142193235, 5.665051478307298],
            [-11.08753273010165, 5.670416842590212],
            [-11.080093655241424, 5.7132133089303],
            [-11.122635556939793, 5.720559819961675],
            [-11.120058593902016, 5.735130260665455],
            [-11.134220322705916, 5.737495644358985],
            [-11.247604843067654, 5.757137634930417],
            [-11.332211893165201, 5.771788230157398],
            [-11.416821722693602, 5.786422526063091],
            [-11.394748616850773, 5.911490786203057],
            [-11.38170560975227, 5.984685087166]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.61480668444105,
          "lat": 43.387730667157804
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16019"],
        "coty_name": ["Bonneville"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bonneville County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00395407"
      },
      "bbox": [
        -11.416821722693602, 5.209999780893528, -10.353484870698784,
        5.984685087166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.94555300859652, 6.21454425516627],
            [-10.88359497320742, 6.203914291299219],
            [-10.846870728988812, 6.197740188315964],
            [-10.85182312437771, 6.169688458802924],
            [-10.809586533624529, 6.162253575335207],
            [-10.753152206873354, 6.152533819849381],
            [-10.755383273032118, 6.138270695188319],
            [-10.727457239763671, 6.133718305896698],
            [-10.688263425321933, 6.126944426595436],
            [-10.65696103251215, 6.12189613119216],
            [-10.654017181100752, 6.139366652336001],
            [-10.653151458920965, 6.140930076577134],
            [-10.646440913166368, 6.140910808806122],
            [-10.64553281979269, 6.1427657490303895],
            [-10.639180747897779, 6.144463944456273],
            [-10.630547733457655, 6.152972639148158],
            [-10.623064084417582, 6.155457548663671],
            [-10.615215414562314, 6.155132210270082],
            [-10.608675182232615, 6.1604127760622625],
            [-10.604188709021747, 6.160620537016399],
            [-10.598712431365893, 6.156820398159996],
            [-10.592954512748877, 6.156507581758403],
            [-10.59045334106709, 6.150948955161352],
            [-10.587153755347291, 6.149419987961634],
            [-10.586629968041823, 6.143992166585402],
            [-10.581292977009914, 6.1438250799355165],
            [-10.571608895589442, 6.139990247938676],
            [-10.570824297552143, 6.137700983430626],
            [-10.566042131248796, 6.136756806425858],
            [-10.561241481737083, 6.138935136281412],
            [-10.557916305256242, 6.133065739302221],
            [-10.554070645155262, 6.136458972978573],
            [-10.545823589654116, 6.138626633913172],
            [-10.542865564423867, 6.138255863787198],
            [-10.537161513504515, 6.142363994424725],
            [-10.543657561242025, 6.102927220831291],
            [-10.545077626980905, 6.103130722366918],
            [-10.55914281724565, 6.018081143837012],
            [-10.558482963056123, 6.017969825511535],
            [-10.586602178287455, 5.8459101161416465],
            [-10.704795562768766, 5.865296707332338],
            [-10.704057992116148, 5.870035469540621],
            [-10.746730825369637, 5.876983229109343],
            [-10.74197590603889, 5.905032355852354],
            [-10.804563132257305, 5.915197942444143],
            [-10.806920528750553, 5.915881947905825],
            [-10.809613678895547, 5.922284505529446],
            [-10.815393467683219, 5.926891721587195],
            [-10.823536341948241, 5.931646275725562],
            [-10.827620842895275, 5.9309450956895535],
            [-10.832693719145466, 5.933954590174998],
            [-10.837158905602175, 5.933261629479486],
            [-10.842089752777506, 5.93837017780123],
            [-10.843928247662264, 5.942464504633762],
            [-10.846647208424724, 5.943423986260692],
            [-10.850156416171936, 5.954286157020372],
            [-10.852659163535844, 5.955589698339621],
            [-10.856654477798632, 5.963877559756872],
            [-10.859167937240251, 5.966439047091115],
            [-10.860618606402662, 5.97206620345825],
            [-10.871919538621473, 5.976246507130475],
            [-10.872438380739982, 5.980516066777554],
            [-10.876783233285384, 5.9845207058382694],
            [-10.877428595288062, 5.989778605919899],
            [-10.883499010217818, 5.987907430760245],
            [-10.886169122670221, 5.992306102872566],
            [-10.888939599626157, 5.993845359252222],
            [-10.895847054198901, 5.994351693418628],
            [-10.898626059053585, 5.998493698291153],
            [-10.90029321902316, 6.005258975623862],
            [-10.903228524358774, 6.009959046085829],
            [-10.903967402305586, 6.014799379251733],
            [-10.907582090970985, 6.01570323999238],
            [-10.911985166262902, 6.019619894618777],
            [-10.912994432589675, 6.022908552511944],
            [-10.922773111459964, 6.028246787959425],
            [-10.921119563576813, 6.032914368846779],
            [-10.924957629742336, 6.041927343011695],
            [-10.933498809262254, 6.039079042056592],
            [-10.93745528257418, 6.045814880506723],
            [-10.937257308556541, 6.0497788678244895],
            [-10.942504448105455, 6.050796441300204],
            [-10.948661824441455, 6.043666004616967],
            [-10.952187633881833, 6.04195664805839],
            [-10.953919199266124, 6.037075853080163],
            [-10.956450679688727, 6.036507695431256],
            [-10.962547074242538, 6.04001550967235],
            [-10.968676137331526, 6.0369803172051],
            [-10.979446135540899, 6.044511267247385],
            [-10.972060381031818, 6.087301345686669],
            [-10.967853618946759, 6.086538652669531],
            [-10.94555300859652, 6.21454425516627]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.65926914540954,
          "lat": 43.78412615204426
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16065"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00394803"
      },
      "bbox": [
        -10.979446135540899, 5.8459101161416465, -10.537161513504515,
        6.21454425516627
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.025712404411213, 1.3559468208083088],
            [5.110659485727261, 1.3609718811622185],
            [5.132675890029298, 1.3625010626217713],
            [5.164583805138448, 1.3652887617216363],
            [5.196617670644508, 1.3673901629020966],
            [5.195676983778959, 1.3820044189234915],
            [5.202204237463712, 1.3822683104765008],
            [5.246701879959767, 1.385292594116902],
            [5.244925289598231, 1.4072494626559022],
            [5.248459596427628, 1.4075163658013965],
            [5.245522590947054, 1.4443859019953562],
            [5.336363229411244, 1.4513005458839807],
            [5.407885818597944, 1.4567873202579422],
            [5.4111474970751745, 1.4129393438088715],
            [5.427443779853757, 1.4141307253619786],
            [5.470702886717285, 1.4166136343723357],
            [5.47170820442557, 1.4019888793279403],
            [5.500462207698802, 1.4033856565683938],
            [5.528678351098285, 1.4050059406295907],
            [5.596476055870059, 1.409445315410425],
            [5.613660841835613, 1.4107814968962493],
            [5.617039611194615, 1.3665120066054555],
            [5.621378829893063, 1.3068178910988082],
            [5.615374887653144, 1.3076909670759027],
            [5.608740344243602, 1.3053311054871861],
            [5.607319038780493, 1.3110634966954307],
            [5.5986641384259075, 1.317622079546633],
            [5.594598001327362, 1.3139016826381513],
            [5.591515055227831, 1.3007873060151889],
            [5.5878288330674595, 1.2950398470504725],
            [5.585533043021472, 1.2969374446983197],
            [5.5776754855004915, 1.2890182535445764],
            [5.574068503172225, 1.2886252455727434],
            [5.572747122760573, 1.2833171710089173],
            [5.5668201615542525, 1.2790874662121297],
            [5.5627592432014765, 1.2782098007349085],
            [5.561014429389937, 1.2730672922310435],
            [5.5608962257040435, 1.266862174053737],
            [5.559046942615171, 1.2641006036834268],
            [5.552182198056244, 1.259051416195718],
            [5.544727701707756, 1.2590920064267768],
            [5.5397707693403015, 1.2556531552000358],
            [5.5401351439852045, 1.25039545654857],
            [5.523856501331987, 1.2553809954009723],
            [5.517639983223739, 1.255960258821355],
            [5.516400818144831, 1.2527125477893597],
            [5.517674841374312, 1.246978328499057],
            [5.515023801949982, 1.2405972595846786],
            [5.507599611581974, 1.2425567113248757],
            [5.4989601524679035, 1.2378310107002615],
            [5.498000884179401, 1.2336836819997203],
            [5.49248108313397, 1.226432032028161],
            [5.490028025102863, 1.2252164314637068],
            [5.4799285294938285, 1.2264141499711998],
            [5.472608176242169, 1.2333944013182274],
            [5.473062433197955, 1.2412862109451446],
            [5.467297866832962, 1.2437360235701502],
            [5.467990372302573, 1.2297000323317855],
            [5.47285365301926, 1.1648926557723078],
            [5.431857506838682, 1.162335430011795],
            [5.435184012656436, 1.1189445011943426],
            [5.392117905492995, 1.1162976714669954],
            [5.394287947905235, 1.0890644333913597],
            [5.394124285142856, 1.087189015671153],
            [5.397836361676397, 1.0428209221923181],
            [5.401258934059007, 0.9990263011893861],
            [5.347992500347657, 0.9952924060205764],
            [5.2731541331097205, 0.9891213476745232],
            [5.2290480596324125, 0.9858379631021642],
            [5.201766357001776, 0.9840383915156481],
            [5.102136296899517, 0.976750269788695],
            [5.101365492546605, 1.0136894841332653],
            [5.083536454703336, 1.0635809460367853],
            [5.05250854743962, 1.1497412257678685],
            [5.044852837672025, 1.1712817377664309],
            [5.039937358043828, 1.238994543707315],
            [5.033873638114721, 1.2386480682008216],
            [5.031147400288941, 1.2753101976124057],
            [5.027641286513206, 1.3266851278504894],
            [5.025712404411213, 1.3559468208083088]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.65889039383093, "lat": 39.75815371663413 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17167"],
        "coty_name": ["Sangamon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sangamon County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "01785010"
      },
      "bbox": [
        5.025712404411213, 0.976750269788695, 5.621378829893063,
        1.4567873202579422
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.843405378832722, 2.09063368589357],
            [6.835674086756643, 2.17842306940538],
            [6.8283089763637665, 2.260590252987532],
            [6.821581650204397, 2.3372665500251255],
            [6.929584467614713, 2.3466216182252184],
            [7.015206489026043, 2.354520088662609],
            [7.085864827016198, 2.3611940433895158],
            [7.141561673962731, 2.366224286084785],
            [7.14274157123361, 2.366283413197769],
            [7.143868227582023, 2.351251297021446],
            [7.150583543895126, 2.279017210443784],
            [7.160215933591472, 2.1921956414675563],
            [7.169702512006495, 2.104847712449632],
            [7.0846698951005935, 2.096830525148578],
            [7.0417136321466165, 2.09345700079808],
            [6.998712261748254, 2.0896578782884863],
            [6.941696964653521, 2.0849524896768616],
            [6.913295073730138, 2.0822120116972442],
            [6.844522301894536, 2.076198192317737],
            [6.843405378832722, 2.09063368589357]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.31092934347492,
          "lat": 40.606258533062565
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18007"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00450403"
      },
      "bbox": [
        6.821581650204397, 2.076198192317737, 7.169702512006495,
        2.366283413197769
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.474175501174878, 3.3043326462309426],
            [8.562170158010874, 3.315029205846883],
            [8.612215223854093, 3.321263387023892],
            [8.640463561399688, 3.3251370981854445],
            [8.693084500621762, 3.3319159972099945],
            [8.755853299632518, 3.34087943634775],
            [8.761084186934797, 3.34137768602517],
            [8.772622713716636, 3.248232722806682],
            [8.773873265632165, 3.23743627121384],
            [8.781060568185575, 3.1771732791642666],
            [8.792600990957613, 3.0824471420130064],
            [8.675212522279601, 3.0653745190035013],
            [8.632740864214734, 3.0592767225278923],
            [8.590140989145617, 3.05341211689506],
            [8.547762927848844, 3.048069261029585],
            [8.50563424612424, 3.042312609948173],
            [8.497945753804618, 3.0999303513155727],
            [8.494989402334776, 3.1291569804972545],
            [8.491757469372114, 3.158044503653844],
            [8.484961668397547, 3.2153793927032273],
            [8.484015247358949, 3.2220308476087665],
            [8.474175501174878, 3.3043326462309426]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.99904266760439, "lat": 41.39757943729943 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18033"],
        "coty_name": ["DeKalb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeKalb County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00450346"
      },
      "bbox": [
        8.474175501174878, 3.042312609948173, 8.792600990957613,
        3.34137768602517
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.654619916666204, 0.33769945495640386],
            [7.6992700406588925, 0.34263076875717446],
            [7.725692933702238, 0.34525847452207326],
            [7.795337282440747, 0.3531246163843119],
            [7.82598479038526, 0.3568794984414952],
            [7.8295613513096995, 0.35608998054840224],
            [7.870885127777338, 0.3604299235228869],
            [7.91388416184605, 0.3656452457677282],
            [7.942445529802952, 0.36813977817146454],
            [7.944839752351159, 0.3516383875091055],
            [7.945737574521514, 0.3390590148715343],
            [7.94766338285158, 0.3243801898831947],
            [7.953460007256628, 0.26588020231227427],
            [7.960046367498199, 0.20102165869062708],
            [7.964758255239996, 0.14942278932070593],
            [7.965087351235243, 0.14946661386060653],
            [7.969727478160799, 0.1017191040542225],
            [7.972538579502523, 0.0727668129942066],
            [7.921412389523638, 0.06831076504230801],
            [7.9154359779393255, 0.0684852443801174],
            [7.862003071497603, 0.06396859908313422],
            [7.8140938356143765, 0.05910939669559595],
            [7.771098773826664, 0.05442580068717376],
            [7.684753122952277, 0.04459882244238172],
            [7.678963717453548, 0.0997576930632332],
            [7.671022980528244, 0.17678810112612853],
            [7.661336032135845, 0.27294134793423147],
            [7.658940141024979, 0.29410183252932404],
            [7.654619916666204, 0.33769945495640386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.49505702536723, "lat": 38.54180318153464 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18117"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00451681"
      },
      "bbox": [
        7.654619916666204, 0.04459882244238172, 7.972538579502523,
        0.36813977817146454
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.068325711159374, 0.12725292563210008],
            [7.081751805620431, 0.12754481985820917],
            [7.086946164490136, 0.12413468470365732],
            [7.092342150607659, 0.12637422143015867],
            [7.091487886746922, 0.13346720434372875],
            [7.0941058784552204, 0.13613417775459555],
            [7.098653334586935, 0.1361703953768258],
            [7.09932853554642, 0.12945665269398318],
            [7.10162134648312, 0.1255670042892402],
            [7.108782300674252, 0.12383691930252051],
            [7.110520381779338, 0.12879529402234274],
            [7.109513800521064, 0.1352407245573012],
            [7.113622830317153, 0.13934142489250723],
            [7.12100937294377, 0.13724272422161546],
            [7.1289504188828365, 0.13705062066473112],
            [7.132650591097251, 0.1314139751226024],
            [7.131977395612513, 0.1196539509856407],
            [7.1360477175750425, 0.11344772129556405],
            [7.139983086493063, 0.11208212295385155],
            [7.143732508712093, 0.11322148651327374],
            [7.145979767185385, 0.11653396655986686],
            [7.147574339559593, 0.12382969170806832],
            [7.1467521390516096, 0.1266708954448337],
            [7.141347179489498, 0.1331342047538359],
            [7.139507225712089, 0.138271627410223],
            [7.142057898206315, 0.14389709754481936],
            [7.1465560169281455, 0.14509785954279636],
            [7.153979106916515, 0.14321462884199754],
            [7.16537214286057, 0.1339856067167955],
            [7.176382353672885, 0.12745776300730768],
            [7.185820363434916, 0.12538880560371277],
            [7.190514494410541, 0.1221049224777408],
            [7.194350572328343, 0.11529590319051111],
            [7.202442682380682, 0.1166788083613424],
            [7.206630647066416, 0.11881394287107795],
            [7.210357910769908, 0.12338323085767149],
            [7.216271171061909, 0.12844199802354156],
            [7.222935533357379, 0.13122707120213253],
            [7.228670398896489, 0.13483968244143135],
            [7.2286542265123, 0.14139813414901306],
            [7.229772392982577, 0.14676529634561059],
            [7.233478640525476, 0.15249921971416702],
            [7.237602075046394, 0.15426737723941322],
            [7.242705202442886, 0.15478475723467852],
            [7.249154783950245, 0.1509408170334105],
            [7.254483979384021, 0.14964239048780476],
            [7.257924906148278, 0.15262929467273426],
            [7.261778358353929, 0.16126361981621362],
            [7.2639458340700775, 0.16358110593299405],
            [7.269274957655561, 0.16400474280410157],
            [7.274307652825286, 0.1621022274563313],
            [7.280981203063155, 0.16192248495197803],
            [7.289058143232314, 0.15805072645596815],
            [7.2919022070446236, 0.15290619338953643],
            [7.293181208428949, 0.14709363309029716],
            [7.298673646218933, 0.14746655956489205],
            [7.304214926561545, 0.14502307754751378],
            [7.3073486536933485, 0.13968390882801465],
            [7.305948970945098, 0.1356376106905224],
            [7.310404933988624, 0.13150300598088663],
            [7.3197290883568344, 0.133974587559317],
            [7.322339257226484, 0.13600466108566153],
            [7.318782462245076, 0.14289195346759617],
            [7.321041991347178, 0.14883335481784032],
            [7.32447609253785, 0.14734028814899938],
            [7.330056177541796, 0.14260109761834372],
            [7.334091698812461, 0.1451089595127115],
            [7.3331776429377715, 0.15113483039715087],
            [7.336310423880323, 0.15531486121972973],
            [7.341969030502518, 0.15665899746024886],
            [7.347788685784653, 0.15385943330332025],
            [7.353073296948433, 0.1480647100260547],
            [7.355978006839987, 0.1422219765682036],
            [7.3634919057248345, 0.14140940379316197],
            [7.359870759945405, 0.13434336574021596],
            [7.363303958674571, 0.13250602257359523],
            [7.36865593023565, 0.13596733485981277],
            [7.37135985932431, 0.13609016771179472],
            [7.375722971403433, 0.08766919796998882],
            [7.375508081856181, 0.08710632894777533],
            [7.379434842289052, 0.04318870629269483],
            [7.382280723039297, 0.01393767947407878],
            [7.386554218163404, -0.02631060148862689],
            [7.391242309006416, -0.0758584609091567],
            [7.393225592497867, -0.10236436664338006],
            [7.397538150269244, -0.14757230547061956],
            [7.357283113114024, -0.15099424835267336],
            [7.3254182435498345, -0.15528887312848877],
            [7.299524634418577, -0.15831954825036215],
            [7.291876735599936, -0.15875244174910155],
            [7.27393272567858, -0.16079081546437077],
            [7.223106065235655, -0.16473359330641069],
            [7.22192535046355, -0.15042718399973162],
            [7.2074443487829845, -0.15156159725196774],
            [7.203351234306003, -0.10762521554764522],
            [7.198916765914577, -0.055670879681337396],
            [7.196261416056271, -0.021556840176056174],
            [7.189063016711363, -0.01935548731299122],
            [7.19001087390507, -0.014398391319593935],
            [7.180583975770706, -0.018778385958251004],
            [7.176133545454747, -0.014691028139650824],
            [7.17120678134043, -0.016326325124582226],
            [7.170352149285163, -0.012821897829070212],
            [7.166722635649831, -0.013706756448059252],
            [7.162903175754142, -0.01192777296608037],
            [7.163378989005784, -0.017342668964613388],
            [7.157915955067783, -0.021745425389077533],
            [7.150252340952406, -0.020425395267847524],
            [7.145979412651837, -0.01795168482300246],
            [7.1420928110391, -0.023232884754900058],
            [7.140563516724015, -0.018962160413225636],
            [7.135515083925139, -0.021196160581824504],
            [7.137337895446772, -0.024925222905072802],
            [7.132991380249575, -0.02776953230514357],
            [7.125404069638796, -0.027803737007316694],
            [7.1200572107277225, 0.033377984045227314],
            [7.091318968420062, 0.030580684168724597],
            [7.088688995803429, 0.060115189628314365],
            [7.074770046868665, 0.05909844906833423],
            [7.074285511026672, 0.06087369176070756],
            [7.071907945845602, 0.0936396358248205],
            [7.068325711159374, 0.12725292563210008]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.23215326884461,
          "lat": 38.398786787190936
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18125"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00450381"
      },
      "bbox": [
        7.068325711159374, -0.16473359330641069, 7.397538150269244,
        0.16400474280410157
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5641368163100491, 4.830742637884935],
            [0.6444605975701208, 4.830778769978017],
            [0.734489202833593, 4.831041837180704],
            [0.8326619641279014, 4.831653956901072],
            [0.8576367296028983, 4.832202654228327],
            [0.8725357611642535, 4.8319431815262055],
            [0.9057558766931442, 4.832266868832983],
            [0.9062128306457335, 4.791530195460569],
            [0.9069210427868236, 4.674061493462477],
            [0.906910632099631, 4.630418588486574],
            [0.9071309603758816, 4.5868911989449455],
            [0.8218509397547511, 4.586924537553836],
            [0.8067003595420817, 4.587216373594012],
            [0.7359182963605563, 4.589207661804539],
            [0.7215356875556386, 4.589213611763854],
            [0.649679682545006, 4.5886442034399195],
            [0.563792652864076, 4.587890337766177],
            [0.5647055623721441, 4.675982583215174],
            [0.5645342028571171, 4.741273754104916],
            [0.5641368163100491, 4.830742637884935]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.6236981434866, "lat": 43.378582381052894 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19143"],
        "coty_name": ["Osceola"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Osceola County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00465260"
      },
      "bbox": [
        0.563792652864076, 4.5868911989449455, 0.9071309603758816,
        4.832266868832983
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.2508327803424368, 4.589784675759584],
            [1.3214626323767107, 4.5910302783877],
            [1.3354553434200496, 4.590992001933585],
            [1.3791888734600442, 4.591657884431007],
            [1.4719348291333862, 4.592743751180785],
            [1.4851727549623275, 4.59320875834438],
            [1.5069006034542407, 4.59335407922894],
            [1.5917839445490634, 4.594470568891055],
            [1.5937550785033312, 4.49435448291988],
            [1.59584797479882, 4.370069630319453],
            [1.5968434050401157, 4.2902769923778274],
            [1.5976309322840991, 4.246729373608138],
            [1.5404637291948364, 4.246232152869584],
            [1.5120260906058933, 4.246244149686482],
            [1.4689840256812972, 4.245780870880027],
            [1.4259270476220016, 4.244938838862264],
            [1.3398952181280448, 4.244054169755073],
            [1.2546796888705478, 4.2436054281907065],
            [1.2537092063590152, 4.329939610913868],
            [1.2529198164612387, 4.417446176348826],
            [1.2520158416936686, 4.503309046772097],
            [1.2508327803424368, 4.589784675759584]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.67812698265259, "lat": 43.08207159637289 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19147"],
        "coty_name": ["Palo Alto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Palo Alto County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00465262"
      },
      "bbox": [
        1.2508327803424368, 4.2436054281907065, 1.5976309322840991,
        4.594470568891055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.46658281690126807, 2.8295246040891144],
            [0.4964904705139705, 2.8290970796989945],
            [0.5821131244363503, 2.829238898803193],
            [0.6802994001470767, 2.829212745071972],
            [0.6941558067820663, 2.829368263384338],
            [0.7205696329837825, 2.829037523120483],
            [0.7676144273029146, 2.8292431604522523],
            [0.7833021209506553, 2.8294965120197064],
            [0.8367849381944382, 2.8296175147347626],
            [0.8802345774790896, 2.829681919570799],
            [0.9923316365946819, 2.830205540975608],
            [1.0918793739554316, 2.830554713190004],
            [1.0915014249058443, 2.825341298480314],
            [1.0930062610883082, 2.713027227831968],
            [1.092508902580079, 2.681317370678817],
            [1.0930420055693773, 2.663254468012595],
            [1.0932400126704291, 2.6261785607398727],
            [1.094009911106804, 2.540728329727313],
            [1.0941376930848947, 2.4822064858077115],
            [1.0089099339895804, 2.4817622092190432],
            [0.9658858232891282, 2.481812715973558],
            [0.9234966313292444, 2.4816778360580978],
            [0.8518748613024044, 2.4814347557288188],
            [0.780687166366098, 2.480882066628804],
            [0.7126320081382513, 2.48069565276451],
            [0.6672092565338327, 2.480462405866047],
            [0.6320197671684206, 2.480488181688086],
            [0.6174222036286465, 2.480197258546973],
            [0.6072225017767185, 2.480590897150194],
            [0.5526554151339262, 2.480505645711642],
            [0.5593833873346152, 2.4884239657026286],
            [0.5644912708213651, 2.4881087244381432],
            [0.5736675233603942, 2.4857010301686007],
            [0.5785938092198124, 2.487018181684721],
            [0.5817973020242457, 2.491455082565699],
            [0.5822387371138085, 2.4953838406464137],
            [0.5801389221139649, 2.501020557600061],
            [0.5755781890720928, 2.5052433330748904],
            [0.5706476462474017, 2.5075522111149136],
            [0.5646731925859763, 2.508752058362515],
            [0.5311589691341609, 2.5047844099818137],
            [0.5247368400688864, 2.5070950751291274],
            [0.5209844817891524, 2.5116284168109875],
            [0.5189817013321167, 2.5161547234409194],
            [0.5178563443939636, 2.5227002444354847],
            [0.5197896550109142, 2.53176584383383],
            [0.5270922111312312, 2.543655798727666],
            [0.530217589438156, 2.552520993195293],
            [0.5298387502176454, 2.5587644709031343],
            [0.5224366435262248, 2.579402372531532],
            [0.5219841451821624, 2.5855448169307933],
            [0.5230994519124014, 2.589372378791724],
            [0.5278687887363979, 2.5923975402067208],
            [0.5169008368426812, 2.6024583824454317],
            [0.5162217492601555, 2.6134328536779483],
            [0.5177823627685765, 2.6195764497027536],
            [0.5231463724500314, 2.6222994956881966],
            [0.5338794883023109, 2.6221079111596697],
            [0.5350794665654284, 2.6146576678991758],
            [0.5289796779462493, 2.6005551956677593],
            [0.536441918811119, 2.5944198061265804],
            [0.5514181645351983, 2.6024916453027838],
            [0.5584902239072357, 2.6106572316400065],
            [0.5595252145286622, 2.617002473175922],
            [0.5571250911631991, 2.628377734359234],
            [0.5545098251114438, 2.6338117464186994],
            [0.5508532920360051, 2.6380362155405],
            [0.5466770194566155, 2.640447794943334],
            [0.5387767313717103, 2.6425534977694607],
            [0.5279740374451385, 2.6415359802566494],
            [0.5191059244312792, 2.643542309515958],
            [0.5089679680862248, 2.65028132265341],
            [0.5033030778589971, 2.6555127288159905],
            [0.4986815651632024, 2.661350169808804],
            [0.49599743085875664, 2.666987330210715],
            [0.49592125348397326, 2.670712655186316],
            [0.49934506024293673, 2.67504373122011],
            [0.5076843240686599, 2.679075764597883],
            [0.5151259713949551, 2.6863299264440528],
            [0.5167600470650162, 2.6917679306090414],
            [0.5163841687080849, 2.6966003133582355],
            [0.5119850481294359, 2.7061606852906994],
            [0.5102671462171088, 2.714918458190596],
            [0.5107115315280746, 2.718233008048502],
            [0.5152533781977031, 2.7280942409730877],
            [0.515908276607817, 2.737131121389291],
            [0.5141115289243555, 2.744144598049207],
            [0.5134575770547014, 2.75150008486474],
            [0.5152873374559586, 2.7559952450544074],
            [0.5203410124814001, 2.761886151881303],
            [0.5228126030380092, 2.766478570278007],
            [0.5230266187769077, 2.7737910872308174],
            [0.5189807159530058, 2.781655705097635],
            [0.513617625459473, 2.7860969850820068],
            [0.5068883384990628, 2.7885728722836416],
            [0.5035454447398687, 2.788474277336049],
            [0.4957011451520711, 2.785096106355843],
            [0.4894072720983778, 2.7857941531364707],
            [0.4834814534923265, 2.7896254559092806],
            [0.47640783457678754, 2.7921001022641843],
            [0.4602397864480645, 2.7946799957759927],
            [0.45499952090490176, 2.798575993910812],
            [0.44921405163749695, 2.809050474498073],
            [0.4518583309311416, 2.8151316730032834],
            [0.4582893904182861, 2.8201354917638435],
            [0.46658281690126807, 2.8295246040891144]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.54227195290365, "lat": 41.33661700784007 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19155"],
        "coty_name": ["Pottawattamie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pottawattamie County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "00465266"
      },
      "bbox": [
        0.44921405163749695, 2.480197258546973, 1.0941376930848947,
        2.830554713190004
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.00944301015406, 0.9763562895508494],
            [-0.9778810796619987, 0.9757671877652621],
            [-0.9732623364001046, 0.9754211127093554],
            [-0.8985461548343926, 0.9741491512200416],
            [-0.8379151429563283, 0.9729453266776408],
            [-0.7564350123791709, 0.9712455379297094],
            [-0.6944050080752542, 0.9704703213781215],
            [-0.5802058956717061, 0.969183102448584],
            [-0.5811105617964868, 0.8913689119448058],
            [-0.5813975047030122, 0.881360913964847],
            [-0.5827371916660721, 0.7935964266682396],
            [-0.584369448793322, 0.7052511102540497],
            [-0.5861608072582731, 0.6179457611395877],
            [-0.6709476817309424, 0.6197219388690847],
            [-0.7854058331841683, 0.6216816548696622],
            [-0.8423587424819552, 0.6227775364331165],
            [-0.9288975954900549, 0.6243594980459547],
            [-1.0006368382806148, 0.6253817801720533],
            [-1.0147408688879296, 0.6257737311415489],
            [-1.0140655857764247, 0.6548849840959933],
            [-1.0132691709862174, 0.7137309585917111],
            [-1.0111086651735224, 0.8018628405564796],
            [-1.0089185762275057, 0.8886720971534512],
            [-1.0115007421325775, 0.8887305938707394],
            [-1.00944301015406, 0.9763562895508494]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.64924797009158, "lat": 39.48028178538685 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20029"],
        "coty_name": ["Cloud"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cloud County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00484984"
      },
      "bbox": [
        -1.0147408688879296, 0.6179457611395877, -0.5802058956717061,
        0.9763562895508494
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.49576707232485123, -0.5356868298009353],
            [0.49600819851355643, -0.44603963273656805],
            [0.5026238799363892, -0.4460485655487345],
            [0.5021627862925682, -0.357938302971756],
            [0.5023078125091002, -0.269943978489327],
            [0.6022790400978593, -0.2701611726396776],
            [0.6872956176817823, -0.2695404169491891],
            [0.7027531082141123, -0.26961007184307484],
            [0.7167348675045676, -0.26913123277059403],
            [0.7741366041721343, -0.2692754388108671],
            [0.8451913801697317, -0.2691409868046255],
            [0.8453721041559074, -0.3132225437697124],
            [0.8458799513844177, -0.3573428847573396],
            [0.8467206317846716, -0.4455289784029426],
            [0.8395021314794767, -0.44551756202610443],
            [0.8390713422349331, -0.5660543335736083],
            [0.8387650575217706, -0.6026221295647417],
            [0.8389111834001103, -0.6687495566272071],
            [0.817723188398835, -0.66907489723964],
            [0.7759445577643479, -0.6686870514334577],
            [0.7680974589717109, -0.668844894858009],
            [0.7429981052344758, -0.6681904097225551],
            [0.6964576883847755, -0.6685429758910125],
            [0.6959124252666038, -0.6682649815000937],
            [0.6673755215064918, -0.6685043666630682],
            [0.6104250384564426, -0.6680411530242065],
            [0.5960777363890246, -0.6681166223309438],
            [0.4956807141146491, -0.6677078393026068],
            [0.49600865202567845, -0.5505132381983524],
            [0.49576707232485123, -0.5356868298009353]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.73407213396813,
          "lat": 38.236864097411974
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20031"],
        "coty_name": ["Coffey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coffey County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00484985"
      },
      "bbox": [
        0.4956807141146491, -0.66907489723964, 0.8467206317846716,
        -0.26913123277059403
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.191413604366213, -1.1490680648944693],
            [-3.1053622510933, -1.1532464387419237],
            [-3.0335808318086928, -1.1567732217100726],
            [-2.9770380418419915, -1.1594338019848667],
            [-2.8915329435556814, -1.1628648801157182],
            [-2.8664881906481052, -1.1637258196207616],
            [-2.848785241827129, -1.164716726255668],
            [-2.763232612914343, -1.1688222336392362],
            [-2.767197125566816, -1.257316672168728],
            [-2.7547119707082026, -1.2580574893701426],
            [-2.758019670056803, -1.3318802637207012],
            [-2.7608664911470773, -1.39999884489759],
            [-2.7658325642532176, -1.5226576611181792],
            [-2.765715406739048, -1.5333496943026113],
            [-2.767541569746947, -1.5894567321792108],
            [-2.7698172733480213, -1.6461911173282973],
            [-2.7905459502801326, -1.6451805192420639],
            [-2.852209137652015, -1.6425581120887136],
            [-2.912460414096512, -1.6402153951116036],
            [-3.0422994416149827, -1.6349612506005964],
            [-3.1350172531619678, -1.6310717254547515],
            [-3.135868901033424, -1.630914719650089],
            [-3.1996198485064373, -1.6286401481133599],
            [-3.19709923909701, -1.5765582156818925],
            [-3.1956726091345717, -1.517403511859431],
            [-3.1936276289846095, -1.4716508847228431],
            [-3.1894990924275195, -1.390440924979166],
            [-3.1870285003575467, -1.3400955076337018],
            [-3.183619817313652, -1.28167420228469],
            [-3.180942093513728, -1.2377913467073345],
            [-3.19579097248928, -1.237014970273012],
            [-3.191413604366213, -1.1490680648944693]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.36620565663532,
          "lat": 37.23816477562301
        },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20119"],
        "coty_name": ["Meade"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meade County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00485024"
      },
      "bbox": [
        -3.1996198485064373, -1.6461911173282973, -2.7547119707082026,
        -1.1490680648944693
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.273895321496587, -0.8544644136179718],
            [8.395946929417656, -0.8513104293818027],
            [8.508365645028215, -0.8485292743100512],
            [8.522260987074823, -0.8529335437395549],
            [8.582033780170395, -0.8498122621907479],
            [8.583468671755815, -0.8544505507606863],
            [8.582173560253615, -0.8589198481794936],
            [8.587966570985255, -0.8682659676401566],
            [8.589465936200678, -0.8747273814857138],
            [8.589369672323622, -0.8796385547878323],
            [8.584666850354122, -0.8833639405927245],
            [8.58429508298222, -0.8872498604677806],
            [8.581522072213243, -0.891894607240002],
            [8.576685196410411, -0.8941338611911089],
            [8.56666023439534, -0.9131294214129871],
            [8.565244418677295, -0.9225339046758635],
            [8.563891954551709, -0.9738267095589049],
            [8.5699154371573, -0.977896583277474],
            [8.572201930239078, -0.9827214687322982],
            [8.577123141792562, -0.9859897575966695],
            [8.580695308928945, -0.9960722122156324],
            [8.581088688526183, -1.0036279730115392],
            [8.588938387006612, -1.004286220040406],
            [8.588159316946996, -1.0073397998770357],
            [8.582620167788216, -1.012903951382087],
            [8.581756468401958, -1.0151704202150738],
            [8.584117731577155, -1.0205078728774264],
            [8.583924046848372, -1.0242947515521146],
            [8.585441900033553, -1.092749360984522],
            [8.54152235152275, -1.110329074691228],
            [8.517680823490464, -1.1152266268887117],
            [8.496747092594862, -1.1219893304504802],
            [8.454996498800876, -1.138611683267007],
            [8.441088169186314, -1.141618892984126],
            [8.416488360875405, -1.1455129012318417],
            [8.389568937130575, -1.1451192019408132],
            [8.366561056730774, -1.142988108163045],
            [8.348294634821915, -1.1439256454872662],
            [8.335639939643766, -1.1419980681277153],
            [8.296792981689025, -1.1390729661641184],
            [8.29745706903208, -1.0901999192031078],
            [8.275823186860341, -1.0655501638870966],
            [8.199819621948292, -0.9782210320764322],
            [8.202619699091064, -0.9742016644955155],
            [8.199181303480898, -0.9711128787274369],
            [8.195220145152415, -0.9641174743664341],
            [8.200275191794779, -0.9649757687307858],
            [8.199976872488428, -0.9688518642972512],
            [8.211016401403366, -0.9689400841653496],
            [8.216061853340555, -0.9681569616261684],
            [8.219198855747798, -0.972501658936932],
            [8.223139995014341, -0.9728624336585135],
            [8.225113553176637, -0.9666158091644104],
            [8.22763542764886, -0.964482977189502],
            [8.231661782820828, -0.967065603774454],
            [8.226789429241018, -0.9727103452535681],
            [8.227523069834957, -0.9786808084049924],
            [8.230560577978693, -0.9775021539173949],
            [8.23254633385466, -0.9716489079170485],
            [8.238164612113321, -0.9763013896624708],
            [8.246135099240346, -0.9788103939468152],
            [8.248950809604569, -0.9756715986839344],
            [8.24342306418893, -0.9745054799487851],
            [8.239746301864047, -0.9711174311799793],
            [8.242669006494811, -0.967367734852973],
            [8.23948166003295, -0.9595929312330722],
            [8.240858543479222, -0.95667369673576],
            [8.244251063005299, -0.9574997214909167],
            [8.245879034208624, -0.9622204563383177],
            [8.250756283630588, -0.963070646899587],
            [8.251105486436792, -0.9571117487757047],
            [8.256410763039137, -0.9559514192080214],
            [8.259432124542995, -0.9594499732049256],
            [8.25171853708032, -0.9656164521654866],
            [8.256206342465205, -0.9672877127410716],
            [8.25835997434622, -0.9630889145971624],
            [8.261878409379609, -0.9656166226762063],
            [8.266913944058452, -0.9664228283274815],
            [8.264270041878532, -0.9589116148316877],
            [8.271313348668977, -0.9575964702441974],
            [8.271778393425484, -0.9545376820268159],
            [8.266519580636142, -0.9523888610622249],
            [8.268597206005646, -0.9492716555539696],
            [8.269773780559627, -0.9426378913349661],
            [8.265452276711688, -0.9385522471223353],
            [8.266347663835921, -0.9329804331170415],
            [8.273517386354882, -0.9322373158242925],
            [8.273031065659673, -0.9295574889852929],
            [8.267374529317323, -0.9304738506297501],
            [8.261847836754585, -0.9257236368955942],
            [8.266868925106822, -0.9222084230579408],
            [8.262672815685194, -0.9180252928122031],
            [8.267508654498217, -0.9170704223606632],
            [8.2726382734097, -0.9204284358571263],
            [8.276822203043935, -0.920391131286911],
            [8.277790571985095, -0.917709770732919],
            [8.273274187066303, -0.9153861680983769],
            [8.274871276380415, -0.9109251560950595],
            [8.282470602251871, -0.912436318313852],
            [8.28453584398691, -0.9150049614838146],
            [8.281573893218669, -0.92043301100285],
            [8.282709403785256, -0.9232110863315064],
            [8.287545079958287, -0.9210854212613088],
            [8.28694191090242, -0.916660562100147],
            [8.2831725694885, -0.91187420419703],
            [8.283688934526076, -0.9091712032857618],
            [8.288640672968311, -0.9090524435864517],
            [8.291635758027317, -0.9122905965525238],
            [8.300533904935111, -0.9087312192964738],
            [8.301753563737389, -0.9061092455066246],
            [8.296677990752157, -0.9049170411403702],
            [8.295504766167747, -0.8998699618459668],
            [8.285475255795248, -0.9000645898805497],
            [8.282296446272419, -0.898811043996232],
            [8.281325596150094, -0.8954156532535994],
            [8.285563741118747, -0.8925303760630219],
            [8.283407560742589, -0.8867926520974552],
            [8.288865602138033, -0.8851564922610656],
            [8.287546225329033, -0.8807815641747208],
            [8.288309099523204, -0.8764220142616157],
            [8.27959699653254, -0.875434870879046],
            [8.278896680796048, -0.8731815723199426],
            [8.282687107988348, -0.8691575629499823],
            [8.27686137294168, -0.8689772061928767],
            [8.27867252493162, -0.8648842375012253],
            [8.274432895600256, -0.8639339042869887],
            [8.272029786833333, -0.8612361166432163],
            [8.275924124529508, -0.8564826890602689],
            [8.273895321496587, -0.8544644136179718]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.88464649999499, "lat": 37.29990880967812 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21099"],
        "coty_name": ["Hart"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hart County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00516896"
      },
      "bbox": [
        8.195220145152415, -1.1455129012318417, 8.589465936200678,
        -0.8485292743100512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.017306106564732, -0.32369157100007856],
            [9.024274425698447, -0.3280263130552148],
            [9.027849285386683, -0.3185140092448877],
            [9.030471112377423, -0.3216081025541384],
            [9.034690826280395, -0.322282037773828],
            [9.036037796711849, -0.31997340041146666],
            [9.03450692452512, -0.31545759659531136],
            [9.039021596552823, -0.31160559559671663],
            [9.03909693388867, -0.30531111867345634],
            [9.043039107572469, -0.30828483121542427],
            [9.04438191030261, -0.3044576257432026],
            [9.049163622428448, -0.3058765432801983],
            [9.0490115172913, -0.2989404929865747],
            [9.054438615864651, -0.2953603310836237],
            [9.055362417043108, -0.2901654400920137],
            [9.05433770894252, -0.28149795756438045],
            [9.056550615205154, -0.2744265415100478],
            [9.060606277911026, -0.27474881202018103],
            [9.06873511764368, -0.2712426475719339],
            [9.06856303916912, -0.2622773884299656],
            [9.074661594937327, -0.2629825579944462],
            [9.074614298886152, -0.2586468475241351],
            [9.085596352051985, -0.2520489167700568],
            [9.094617975148653, -0.25213285161637006],
            [9.094784951899541, -0.25798381949751903],
            [9.099875829402047, -0.2550104821879271],
            [9.104557496997383, -0.25482684614419115],
            [9.10500618395447, -0.2633097098819194],
            [9.108917858936998, -0.2626904582106529],
            [9.111449790543993, -0.2650431259003369],
            [9.115442016828444, -0.25513321349170626],
            [9.118366543377078, -0.25894741228088225],
            [9.125542378496453, -0.26189814768529873],
            [9.145075797086827, -0.25040556153085575],
            [9.146522935518183, -0.24767886954556034],
            [9.189760373889088, -0.22362005265016435],
            [9.191500622321858, -0.22761364822472774],
            [9.182727355368261, -0.2378213166697336],
            [9.176609123247493, -0.24118871493003088],
            [9.17381927367909, -0.24497270461460213],
            [9.174363861746023, -0.2484164630799003],
            [9.177734039055878, -0.25153538795450375],
            [9.18434092568991, -0.2507418242319556],
            [9.193613872161233, -0.2580709914750474],
            [9.192462980650578, -0.26113078125696043],
            [9.184033957396666, -0.26315127723329107],
            [9.175734069355695, -0.26922186130861653],
            [9.172625060112434, -0.27533022311268224],
            [9.172756375121073, -0.2801650153262649],
            [9.178146524653965, -0.28373895326024384],
            [9.182652865862815, -0.28288089448086234],
            [9.18936627558276, -0.2764615463684019],
            [9.193075242390938, -0.27543682851466267],
            [9.197391275993985, -0.27917931719935785],
            [9.19751267147035, -0.28593019679009907],
            [9.19424067057855, -0.2937346523229371],
            [9.194397675972352, -0.2994216917408552],
            [9.196415409014117, -0.3050389591360506],
            [9.200686862079154, -0.30697669503709374],
            [9.202400345781847, -0.30465964632470915],
            [9.20188544307465, -0.29981524102188717],
            [9.204971871229374, -0.2899630399778941],
            [9.208997855629704, -0.2842345195420238],
            [9.214663045609909, -0.2862653821965918],
            [9.213760628667089, -0.2902051488266939],
            [9.210394164487608, -0.2939714131342923],
            [9.209346947547536, -0.29792113316661073],
            [9.211330890144778, -0.3017503754881616],
            [9.219062023579593, -0.3002565166804986],
            [9.222986676594898, -0.30213147507081234],
            [9.2239235819689, -0.309397885588354],
            [9.230073764607683, -0.3162717833727233],
            [9.230756477219877, -0.3201688337552688],
            [9.228731484827033, -0.3225520633209327],
            [9.22144563289157, -0.32618624439832555],
            [9.220451692063492, -0.3346610595060535],
            [9.223714096626006, -0.3392810671794454],
            [9.228446973406829, -0.343350103885408],
            [9.232013473725175, -0.34375524679679914],
            [9.244055178452813, -0.33837691569633105],
            [9.25046436660996, -0.33166598276350767],
            [9.26128605413515, -0.32484125088772553],
            [9.269685764492015, -0.3240843313637196],
            [9.282184959632632, -0.3251024646951213],
            [9.286708400076794, -0.32932839734179237],
            [9.286393883881637, -0.3356419212140715],
            [9.282861467333792, -0.33932870904270246],
            [9.272613811414388, -0.3420251866087244],
            [9.266776806151094, -0.3458172960745559],
            [9.262668755452891, -0.35441841526891055],
            [9.262665779545392, -0.36267339174886914],
            [9.264396218658721, -0.36686748561527516],
            [9.269815138308404, -0.37142205788000304],
            [9.27359660738488, -0.38009007171483034],
            [9.272090071196498, -0.38724412193324975],
            [9.277180885074264, -0.38610993136157024],
            [9.276362378108354, -0.3930721360741271],
            [9.281426688297778, -0.39267613305996535],
            [9.283310442594846, -0.39465091550090103],
            [9.283576066617512, -0.4002674738253095],
            [9.278973942343685, -0.40516135607869475],
            [9.278794623073765, -0.41198115528799567],
            [9.276142718481756, -0.4168372498999713],
            [9.280970421283252, -0.4203107655910921],
            [9.287284469744755, -0.4186986199014975],
            [9.29406194275695, -0.421987297706451],
            [9.293137241006065, -0.42796578722135925],
            [9.28769064290487, -0.4304307078586463],
            [9.286975302421846, -0.43763388054899566],
            [9.290024994364018, -0.44023720957190693],
            [9.298034500155186, -0.43979068320701986],
            [9.300673959327451, -0.4426257284111889],
            [9.301519557517421, -0.44815362874592635],
            [9.300026557488138, -0.4495789621841966],
            [9.295128970092069, -0.4458930332036469],
            [9.287934105300003, -0.449739243567446],
            [9.288401055285979, -0.45438999354192433],
            [9.29463074504636, -0.45467412619238035],
            [9.301735241939193, -0.4575430696168858],
            [9.29658355067064, -0.462355891719466],
            [9.292042868139694, -0.4602948748444028],
            [9.286469517901054, -0.4621094411867651],
            [9.280345897090907, -0.4626783481181481],
            [9.275547236927652, -0.4617362919649238],
            [9.271636305194708, -0.4592532819812173],
            [9.270275844420999, -0.46284954510735626],
            [9.275957564538514, -0.47155776230485796],
            [9.27433071726005, -0.47419127096463665],
            [9.268700317012197, -0.47056246327641904],
            [9.264422602892562, -0.4704392769873337],
            [9.25983123120703, -0.47350049808259165],
            [9.26029968250873, -0.4766022627000967],
            [9.221929641958601, -0.4769128583734397],
            [9.212430802347209, -0.49072741679234755],
            [9.14295914743708, -0.5112080758847517],
            [9.065781782746614, -0.5329287292129142],
            [9.046326623619624, -0.5365327382573953],
            [9.046330670417603, -0.4738971644188362],
            [9.045223036013127, -0.39661916849044715],
            [9.040325231452336, -0.39661879651903026],
            [9.040127090592334, -0.3779223125768776],
            [9.045058722978103, -0.3779125246930932],
            [9.04489366268116, -0.35791477209856587],
            [9.036942453150997, -0.35423245808606174],
            [9.023530202130802, -0.3364852175182987],
            [9.0181194768793, -0.33377521444476005],
            [9.017306106564732, -0.32369157100007856]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.87450643257478, "lat": 37.81101592219581 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21167"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00516930"
      },
      "bbox": [
        9.017306106564732, -0.5365327382573953, 9.301735241939193,
        -0.22362005265016435
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.627279393473894, -6.867047595140133],
            [2.627074064941507, -6.852554909403701],
            [2.626143804945861, -6.837213708063701],
            [2.6261505485804557, -6.81853856728081],
            [2.6284584345362974, -6.813958305882987],
            [2.625914936040249, -6.798882610800086],
            [2.6287327995790153, -6.797231396454222],
            [2.6300627185277037, -6.793391455846928],
            [2.634521141790923, -6.78862216417884],
            [2.6375479687532946, -6.788362174079171],
            [2.6395737008002613, -6.780717678944391],
            [2.6429383548119474, -6.77799018666243],
            [2.6462512671228704, -6.777670236919654],
            [2.646259956719515, -6.782430676187478],
            [2.6478646167734246, -6.7877008224549025],
            [2.6536384179452748, -6.792840035111256],
            [2.661087042096141, -6.793614942373862],
            [2.667322408701816, -6.790699690343453],
            [2.6702658839860893, -6.786023506275374],
            [2.673292339679296, -6.785358975958676],
            [2.6789526861139947, -6.787606299451981],
            [2.6798212302356395, -6.782461566883259],
            [2.6783326504688243, -6.778371427890537],
            [2.697306733471341, -6.778338315346594],
            [2.698996644609993, -6.781315719377585],
            [2.69369059667608, -6.786724979541692],
            [2.695968529850759, -6.790297918215859],
            [2.7000334777971475, -6.79185524643994],
            [2.701770406295542, -6.801732275987506],
            [2.706058184548683, -6.804905787168686],
            [2.7028555805957972, -6.808286825770809],
            [2.7024418467788847, -6.811615468754749],
            [2.7101986296421368, -6.814778361496561],
            [2.724258777632515, -6.816890339927253],
            [2.727647725120678, -6.8208930090770385],
            [2.7325854064791573, -6.819525187778536],
            [2.7373909781151253, -6.814360623973809],
            [2.7419010377352064, -6.811627034452257],
            [2.745222324523078, -6.815810598318052],
            [2.7523016092028145, -6.819590320214661],
            [2.755127637985071, -6.818367659576689],
            [2.760296673616538, -6.821263716089917],
            [2.7623417933548593, -6.818119007268383],
            [2.767251088772827, -6.814298881632131],
            [2.773379486501311, -6.812712951347461],
            [2.775181834352225, -6.807285371948516],
            [2.7798764753935195, -6.799147067888872],
            [2.7837553605678846, -6.794784262886491],
            [2.7866685750955016, -6.79729447591306],
            [2.791715814974978, -6.798801012602135],
            [2.7960478024241864, -6.804110318098789],
            [2.7948978202996098, -6.735096937321906],
            [2.8555566331426605, -6.733759588089248],
            [2.8905293591356216, -6.732714306779939],
            [2.8865840160667275, -6.725247612968901],
            [2.8809715459767937, -6.722123326762427],
            [2.8823686478488377, -6.717180633405578],
            [2.8781029272449983, -6.715753861683383],
            [2.8703050756453172, -6.703879376925383],
            [2.8660069750501225, -6.703026965216703],
            [2.86450435460082, -6.697772122429343],
            [2.861624016921452, -6.696577763982407],
            [2.863375095198165, -6.690249582761161],
            [2.86163105615299, -6.684590260994904],
            [2.8640601056014807, -6.676682986927149],
            [2.8715580923898822, -6.666840921614575],
            [2.873079202028021, -6.661023933464064],
            [2.877604498290868, -6.65636017732576],
            [2.8777293916199933, -6.649238522461469],
            [2.8760710242249505, -6.645162895197379],
            [2.8729203499203693, -6.642202292234744],
            [2.8724778688704813, -6.637256303801834],
            [2.8702513028298253, -6.633121463397169],
            [2.8574207879606095, -6.624951742593329],
            [2.8538721072184474, -6.613017669172769],
            [2.863294087177738, -6.603560341493398],
            [2.863571546879096, -6.601548561870262],
            [2.8592098446801346, -6.59506838833827],
            [2.8541689089194646, -6.590651554294985],
            [2.8524483887506866, -6.585384887171368],
            [2.848775473422109, -6.578960306783119],
            [2.844622719610512, -6.575972697971248],
            [2.8404498105933054, -6.5668573527250285],
            [2.83439960894805, -6.564028949683995],
            [2.8329918789029973, -6.5585074706233675],
            [2.891292747296026, -6.556823644649206],
            [2.9345314990913236, -6.5558107190352315],
            [3.0418688511267375, -6.552681632606426],
            [3.0428386629933053, -6.55758262901398],
            [3.0483693337205966, -6.565838711082924],
            [3.0475058281187493, -6.570266786074109],
            [3.0489231112300197, -6.577013057581366],
            [3.0534352253073496, -6.5810436309663],
            [3.0549741902199528, -6.587855564188075],
            [3.058423976685072, -6.591399462405217],
            [3.065489823800039, -6.596374762308956],
            [3.066181323860901, -6.6017352157280795],
            [3.072503637341485, -6.609328674954476],
            [3.0728638067770038, -6.618073450069985],
            [3.0688779241382873, -6.617145626440528],
            [3.067958854840481, -6.62476094690904],
            [3.0759329603997867, -6.631853768474471],
            [3.0768102779344817, -6.641741555498781],
            [3.081336924007061, -6.644215340999119],
            [3.0810561840181254, -6.650150590660392],
            [3.079460798773757, -6.654375723169921],
            [3.081776227926496, -6.655697720414707],
            [3.082548693699118, -6.660527017649219],
            [3.087477389763106, -6.6679653474678116],
            [3.0889715868976726, -6.67237147464512],
            [3.0904167420239834, -6.682450924298462],
            [3.092137826883232, -6.6867615153474835],
            [3.0854352907233107, -6.698519292249401],
            [3.0825249442797324, -6.702203299017137],
            [3.0784936009596193, -6.704265012699672],
            [3.0791386129192357, -6.711202334749102],
            [3.0870378458198804, -6.710921101898044],
            [3.091114688102582, -6.712102486776127],
            [3.091604780870954, -6.716128195444802],
            [3.0941748320007987, -6.717556124945859],
            [3.093162032568573, -6.7234637585526285],
            [3.094770993735559, -6.7288535770564275],
            [3.093685575661772, -6.742111146648826],
            [3.0954725087644563, -6.746637245157178],
            [3.104303724692593, -6.750556929546886],
            [3.102485388298195, -6.755815451996225],
            [3.094581261447349, -6.759079027327983],
            [3.0940480918686353, -6.763970884035782],
            [3.091440835968567, -6.771684222522677],
            [3.089305737783871, -6.772142926944656],
            [3.086871464754939, -6.781667937117638],
            [3.089125296428744, -6.797278735097938],
            [3.0864883779874144, -6.801419671065484],
            [3.082188168213721, -6.805026458998629],
            [3.0814545895896557, -6.823760790365323],
            [3.078734086903311, -6.830293944600818],
            [3.085758259629451, -6.839336791321537],
            [3.079726256315242, -6.846642478386413],
            [3.070730215816078, -6.847943783252012],
            [3.0692450721898377, -6.84619635198171],
            [3.062321237654223, -6.8448622785999325],
            [3.052549983473265, -6.846309212648036],
            [3.0487053331297864, -6.845665746051531],
            [3.045479115130343, -6.842904705980333],
            [3.04534973110729, -6.850824358108519],
            [3.0414182193126607, -6.851633281398545],
            [3.0456450117989027, -6.857567692335615],
            [3.0439212916446183, -6.862215888367737],
            [3.049539598610588, -6.863336760020529],
            [3.0527378096748774, -6.870342182417466],
            [3.0517030609505618, -6.877756171977374],
            [3.044805417481256, -6.8728566472234895],
            [3.042058437277214, -6.87521125456376],
            [3.0430111662331263, -6.879367696447072],
            [3.0500346911230594, -6.8856571432132085],
            [3.0447398618799055, -6.889822208588804],
            [3.047271864604396, -6.897099827446143],
            [3.046781960766329, -6.899826287877935],
            [3.0425148621202474, -6.903397447854388],
            [3.0431476207925336, -6.912156980562201],
            [3.042267875025803, -6.916295387450625],
            [3.0380067017386434, -6.920898427590848],
            [3.034817173852398, -6.921719045289412],
            [3.029744013997443, -6.919104510929758],
            [3.030232467181414, -6.9241041435518635],
            [3.0285510313315624, -6.9332835205632355],
            [3.026737359293069, -6.93569423043925],
            [3.0283925128996265, -6.941529499753792],
            [3.026388460551849, -6.945799585933365],
            [3.0296043901609, -6.950142810951627],
            [3.030378718312451, -6.969226200728881],
            [3.028786389161925, -6.976021301122859],
            [3.0246820013785847, -6.9879413813604385],
            [3.026915517298198, -6.9913625980650025],
            [3.037153065411381, -6.994933977282752],
            [3.0387348137383685, -6.998595893978441],
            [3.034767897501846, -7.012730066726564],
            [3.035711675744364, -7.019690038873354],
            [3.0470906243530345, -7.023615601477828],
            [3.0555199282105856, -7.023850296504211],
            [3.065256665291648, -7.021114236404687],
            [3.0682428277403218, -7.024394125738183],
            [3.0676453009735023, -7.028069218410032],
            [3.0696738765889724, -7.032864578193338],
            [3.0773424916191496, -7.036923847711971],
            [3.0867089779036636, -7.037549946719922],
            [3.088412247266102, -7.038673558212959],
            [3.0884933644043713, -7.044551392033084],
            [3.0840422010353032, -7.059880898310765],
            [3.0833293944086, -7.069708427168234],
            [3.0866030115712966, -7.074511309158813],
            [3.090783251485519, -7.076863796557038],
            [3.106536429866467, -7.080870096997678],
            [3.118393915164055, -7.079890943410547],
            [3.1243035826463346, -7.083534122414648],
            [3.132490265822095, -7.089863783425359],
            [3.142755099333222, -7.095006315883203],
            [3.1529609802603074, -7.095251178691836],
            [3.1597270996077453, -7.096799476871943],
            [3.172296538160891, -7.096703184870957],
            [3.1764091507867906, -7.098097296282534],
            [3.1834107545447887, -7.104748338816424],
            [3.1889403969335977, -7.115973202183671],
            [3.1922947597301192, -7.1175733224250015],
            [3.2016129798619213, -7.127077429292807],
            [3.21532667772499, -7.134845401034803],
            [3.216187246957988, -7.138336198896126],
            [3.2119845361733366, -7.1435973033529345],
            [3.212106913395328, -7.146368355349294],
            [3.2194169498568983, -7.150226696473593],
            [3.2270345686943105, -7.15736232469232],
            [3.2324474825526783, -7.159932222727589],
            [3.241586583737101, -7.166860932514512],
            [3.2477712966435437, -7.166821763627324],
            [3.2512225355771585, -7.169227271443876],
            [3.2491194474341976, -7.174923987062818],
            [3.2139941249641977, -7.20725739214162],
            [3.2142260598596217, -7.217050832136025],
            [3.1994627450870783, -7.217462014965539],
            [3.1996015814036167, -7.224534711753176],
            [3.1925056920227393, -7.2250500791451415],
            [3.192747650336569, -7.232099167977726],
            [3.1856199920133244, -7.232300076918629],
            [3.1859850882074414, -7.238988115245262],
            [3.1710538380455517, -7.23997754904023],
            [3.171731402659901, -7.253805220594229],
            [3.157146888180639, -7.254238392284191],
            [3.1572991348051147, -7.261673243965572],
            [3.143347458576721, -7.2621496989350645],
            [3.143738783084678, -7.2768205593063175],
            [3.1227545517270294, -7.27768498576703],
            [3.1233662589315148, -7.291755973694295],
            [3.108950572468006, -7.292683802827219],
            [3.1094445835564706, -7.306975963373514],
            [3.088164516839292, -7.30756382981431],
            [3.088991477332834, -7.328992268672636],
            [3.0601527849122268, -7.330384551884587],
            [3.06091892641038, -7.3512483289178],
            [3.031743904833552, -7.35206028995433],
            [3.0285696413223877, -7.34895626268511],
            [3.0223381449133795, -7.3388447608987635],
            [2.9882939502198704, -7.339696466696231],
            [2.9880424606118963, -7.3367919832436685],
            [2.8700215517472567, -7.33960476488512],
            [2.8142151002509874, -7.341557282032557],
            [2.814198251525087, -7.341069766103416],
            [2.811757775323289, -7.252064806923046],
            [2.8090461755772345, -7.168493584153669],
            [2.727913955955463, -7.170499085701904],
            [2.7234415010580064, -7.170508938409693],
            [2.7223937152300617, -7.127213296193556],
            [2.7199932901563786, -7.069928968976887],
            [2.719489547322725, -7.045413452709631],
            [2.717806651398883, -6.995277313400292],
            [2.6519544601783793, -6.997000621405659],
            [2.6303761274710435, -6.9973816894469785],
            [2.6302607855578986, -6.96855455941847],
            [2.6295920194952793, -6.950366547761409],
            [2.6292379217094295, -6.923084762723],
            [2.627279393473894, -6.867047595140133]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.09620180123464,
          "lat": 31.723378061168827
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22069"],
        "coty_name": ["Natchitoches"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Natchitoches Parish"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00558108"
      },
      "bbox": [
        2.625914936040249, -7.35206028995433, 3.2512225355771585,
        -6.552681632606426
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.965623336512248, 1.3771254181553192],
            [14.962501190699557, 1.3859705626247636],
            [14.958352993818805, 1.3909025626020906],
            [14.956152012030044, 1.4151708033082167],
            [14.961719988840887, 1.428646810837],
            [14.971728716663211, 1.441987091118636],
            [14.976597853729238, 1.4448213411146589],
            [14.984767033166396, 1.454100884997192],
            [14.992953907954643, 1.4434835342696448],
            [15.019539346891376, 1.3927864892731499],
            [15.029151537156741, 1.375204915248739],
            [15.032281694330715, 1.375258508975037],
            [15.035838163930586, 1.3819597816580051],
            [15.03633667832626, 1.3862233370964863],
            [15.042834190827527, 1.3913105881397667],
            [15.043659055243566, 1.3965517544159833],
            [15.045980045248779, 1.4005878316385325],
            [15.04743986082261, 1.4075271589919403],
            [15.052593447856118, 1.4121378417293853],
            [15.056820727125276, 1.413781612618548],
            [15.066507575197026, 1.4202643569515032],
            [15.068055692097593, 1.4198756560220382],
            [15.077172502234056, 1.424032163327363],
            [15.080548550865823, 1.4244779664417615],
            [15.085048312764487, 1.4282893787407216],
            [15.094137047543942, 1.427237838167724],
            [15.10003302016981, 1.4289255751909087],
            [15.106242242793845, 1.4257114818383734],
            [15.115339571094657, 1.4278296392636582],
            [15.123881361905855, 1.427144241585384],
            [15.128151206774318, 1.4284354843699498],
            [15.133378148150207, 1.4281201184919936],
            [15.13746857884691, 1.4320888668101668],
            [15.143385238428436, 1.4336598491474686],
            [15.146197732227947, 1.436963991813219],
            [15.151275661775925, 1.4394258902812138],
            [15.159089837388466, 1.4399191744884967],
            [15.163167273544266, 1.4413382716288963],
            [15.218150890937688, 1.4278343743094912],
            [15.250558308591424, 1.4193608307686962],
            [15.252952515527536, 1.420195317006886],
            [15.259283245731227, 1.418589869163988],
            [15.263052919576536, 1.406913131005186],
            [15.263695628922221, 1.4013122731416459],
            [15.267685625609891, 1.3964915102879842],
            [15.271527048533526, 1.379105719164711],
            [15.274321929718003, 1.3757904474632792],
            [15.276543518967799, 1.361680769830176],
            [15.291107491371836, 1.357171935449045],
            [15.297620152575231, 1.3568394983503618],
            [15.299867765224137, 1.3552395209901065],
            [15.3092653710446, 1.3539834021237787],
            [15.316510966635837, 1.3518564340644856],
            [15.319294428991892, 1.348784127071295],
            [15.328494440060169, 1.3483542495024137],
            [15.330547140694941, 1.3492967924957515],
            [15.33542204993864, 1.3470332872893938],
            [15.341891129764061, 1.3420910869011928],
            [15.342711171992878, 1.3398193916941916],
            [15.340828901684066, 1.3335404328780684],
            [15.339576483213104, 1.3241404618609687],
            [15.338955677105156, 1.313661704076329],
            [15.331940714551026, 1.3074613008978195],
            [15.320335943455955, 1.3072524302244786],
            [15.317220024187266, 1.3112934725211476],
            [15.31485998217695, 1.3108232180496484],
            [15.309084709927966, 1.31759992046576],
            [15.30521905621494, 1.3168696807072422],
            [15.296625267622618, 1.3174679847444264],
            [15.280220539393989, 1.3148192356575799],
            [15.27692834556604, 1.3154459962282843],
            [15.264761045552312, 1.312141447070496],
            [15.260743933207275, 1.307241928813772],
            [15.256673811502498, 1.2893793497518289],
            [15.250727943960651, 1.2669463220202155],
            [15.24110339426793, 1.2270259753734063],
            [15.240575181761116, 1.2200375147348699],
            [15.23770345195456, 1.2161610519210908],
            [15.236828146539711, 1.211791230241164],
            [15.233424324135896, 1.207814509802722],
            [15.231056489369657, 1.2002401683176729],
            [15.227672312724406, 1.1977362554499578],
            [15.225740290883653, 1.1940319070979482],
            [15.225651352202156, 1.186031059208069],
            [15.2216858964929, 1.1814469876292446],
            [15.211269081387199, 1.1744413587602263],
            [15.210553786640794, 1.166710838097389],
            [15.213872491880192, 1.1623048606441075],
            [15.224982529941428, 1.1584647114764561],
            [15.232515428529913, 1.1539221530530406],
            [15.235685515088957, 1.1483869220819454],
            [15.236180756443133, 1.1439844510900254],
            [15.229285848743887, 1.145794133707417],
            [15.227304203135834, 1.144429252818576],
            [15.228682064657217, 1.1395254014863383],
            [15.226381977556146, 1.1300284184953517],
            [15.223257403482467, 1.124107948097422],
            [15.224197144730107, 1.117191877313205],
            [15.227976341218763, 1.1134486558523744],
            [15.234112041394223, 1.1120103947449298],
            [15.237756647628864, 1.1070859342923218],
            [15.241329787585375, 1.1043572974784086],
            [15.23976153348853, 1.1009621945474004],
            [15.242505233404792, 1.0930664595076551],
            [15.248205328985486, 1.089617134145792],
            [15.250306992733007, 1.081253333299894],
            [15.255274371069419, 1.0796053601136468],
            [15.259981211023309, 1.0681187066339968],
            [15.262592178375373, 1.0654659809204838],
            [15.260176205179903, 1.0549752689490153],
            [15.262825888244366, 1.0527322717233607],
            [15.260951042278512, 1.045014000348401],
            [15.256853736515206, 1.0458968973859764],
            [15.251200844047862, 1.0502194937043856],
            [15.241153549677376, 1.05586614634886],
            [15.220560843565181, 1.0615628270777149],
            [15.204375134458108, 1.0684851169280283],
            [15.195643013587038, 1.0698318137206189],
            [15.19058522620162, 1.0679868475123278],
            [15.188927147215635, 1.0714854507236848],
            [15.189317550991946, 1.0760528875439197],
            [15.18851968194603, 1.08882407105666],
            [15.186690730165076, 1.092153916107465],
            [15.179996798444504, 1.0991987051449057],
            [15.166241955388744, 1.1054435714002775],
            [15.16106314314435, 1.1057958039544642],
            [15.148198407774588, 1.1117781143341239],
            [15.143905461013397, 1.1121556392667886],
            [15.139608429509007, 1.1107689118246629],
            [15.140709654958824, 1.117652368198882],
            [15.13851805235901, 1.1246178714825354],
            [15.131392807187549, 1.1304437911632843],
            [15.128503246230986, 1.141897293005216],
            [15.121401746873667, 1.1613580987051608],
            [15.117692287558599, 1.1646824593913983],
            [15.110691440548838, 1.1739379015228286],
            [15.105831496941866, 1.1859923212546675],
            [15.099510415209469, 1.1943629557087427],
            [15.094644828678211, 1.1989288616095402],
            [15.08989585812726, 1.2070958950139805],
            [15.071638783722541, 1.202420626988918],
            [15.056043615094039, 1.185247489702854],
            [15.05309119638721, 1.1796285654577716],
            [15.049119127701925, 1.1773687148831389],
            [15.042813783307084, 1.1658441911560768],
            [15.040692792395609, 1.157992012255889],
            [15.033962396622881, 1.1569085702552024],
            [15.029164222711808, 1.1543209849750256],
            [15.025517088906144, 1.1566482952160517],
            [15.01554004618062, 1.1561188459943126],
            [15.014138401655114, 1.1457311206012977],
            [15.009096349840286, 1.1354136365673306],
            [15.002162149597394, 1.1282487074096719],
            [14.995830993035847, 1.1236875678328422],
            [14.989924987587464, 1.1152952732012915],
            [14.986006562133436, 1.1130217718326278],
            [14.98119483697107, 1.105855179281256],
            [14.976279193141343, 1.101881998604545],
            [14.961716173185991, 1.0930229319171127],
            [14.953893404167161, 1.094846035095001],
            [14.947294575757187, 1.0991419070169541],
            [14.93870161960284, 1.1030805019980248],
            [14.936745388512486, 1.1028303055555342],
            [14.924546446281, 1.1091791442952827],
            [14.921343208342734, 1.1139927096021593],
            [14.91977068870039, 1.1192978866374659],
            [14.916264206092624, 1.1225621951819234],
            [14.915063230885004, 1.1273403320330868],
            [14.907088485651723, 1.1373196966988768],
            [14.906983773036995, 1.1448586253960835],
            [14.910132942190685, 1.155373191044079],
            [14.908834511094375, 1.1587511725465565],
            [14.900521080246072, 1.167203923987164],
            [14.901667696971511, 1.1731518307605342],
            [14.899017883695711, 1.179508082686258],
            [14.894577890205914, 1.1829908525890234],
            [14.892718781633478, 1.1865153524874033],
            [14.894767569650549, 1.1904503617442674],
            [14.8943627483942, 1.1969264024383415],
            [14.889330317402147, 1.1999048892439974],
            [14.886673323499, 1.203527516732217],
            [14.88644359943712, 1.2118873276693887],
            [14.888828839696622, 1.2212560879850123],
            [14.88797361029244, 1.2239709775456682],
            [14.888700800103582, 1.2354074973189655],
            [14.892615296228207, 1.243000375256387],
            [14.891420379387167, 1.2456782303334881],
            [14.900534544460054, 1.278463999678336],
            [14.905996274901375, 1.2821692928355632],
            [14.912482870759876, 1.284300126778451],
            [14.918190553473082, 1.2982607403000919],
            [14.919855475924528, 1.3046511045714237],
            [14.924280100460333, 1.3104753475945672],
            [14.928796661601321, 1.3186679386525397],
            [14.928541690354482, 1.321372002995535],
            [14.93229963228869, 1.3347699292416146],
            [14.94128151893824, 1.3432530801591438],
            [14.957482896313715, 1.345198936887697],
            [14.9624360834847, 1.351217144848117],
            [14.970583208528112, 1.3568567531403517],
            [14.972883481770024, 1.362894321190182],
            [14.978958489097833, 1.3679268184363698],
            [14.984004258349561, 1.3763990068037928],
            [14.981214122155993, 1.3786102391564563],
            [14.965623336512248, 1.3771254181553192]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.992199196858, "lat": 38.50727903429342 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24017"],
        "coty_name": ["Charles"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Charles County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01676992"
      },
      "bbox": [
        14.88644359943712, 1.045014000348401, 15.342711171992878,
        1.454100884997192
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.49625722005113, 2.3999274248985003],
            [14.503741401767966, 2.4014036088502153],
            [14.584892791025185, 2.417462399707703],
            [14.684705226192923, 2.4373481286593126],
            [14.687142555394523, 2.4346105998177525],
            [14.687273088979158, 2.4306710532126092],
            [14.680200925917235, 2.426006632998774],
            [14.682319037987062, 2.4209589507660088],
            [14.686870635320046, 2.4202639238781845],
            [14.690190106776427, 2.4170795457858336],
            [14.688825868056435, 2.413843615452007],
            [14.683203447635668, 2.4101448705033635],
            [14.670246525933555, 2.4087625353429165],
            [14.669705469338133, 2.405844834742283],
            [14.677441713132835, 2.400118628957321],
            [14.68006406575797, 2.392819380984873],
            [14.675064813200422, 2.38392502527881],
            [14.670989960273237, 2.38059244794098],
            [14.667220160082731, 2.3801893367331752],
            [14.666930820740667, 2.3753946548947686],
            [14.661823193348907, 2.376387744771374],
            [14.65923792670522, 2.3720071060220116],
            [14.660831794255056, 2.365807071316894],
            [14.656796913217654, 2.361374926894465],
            [14.655316835576828, 2.356534183371983],
            [14.659583783727959, 2.3521146258230448],
            [14.654765750633338, 2.3452722396894643],
            [14.657261073428828, 2.3406359593191817],
            [14.646732989019176, 2.3378081939497957],
            [14.641322375782291, 2.3412171060007734],
            [14.64002185874546, 2.3442416531736407],
            [14.63289423915179, 2.3458847592858203],
            [14.630183483700144, 2.343925003347132],
            [14.633148729634913, 2.3352919824575276],
            [14.637156213174807, 2.3316215712244963],
            [14.640997484786922, 2.331087658271304],
            [14.640847201193829, 2.3269925324598235],
            [14.637055022942121, 2.3240757950414492],
            [14.644122615435963, 2.3184726342664788],
            [14.647317778043702, 2.318201004634533],
            [14.65465536074507, 2.3125823983345155],
            [14.655460193392786, 2.3160636238077754],
            [14.666424541796083, 2.3166825654119694],
            [14.667901785961881, 2.3118369637998506],
            [14.671764533899578, 2.310047741531901],
            [14.674581938080234, 2.3065299370963794],
            [14.67570375506513, 2.31471849272185],
            [14.678185183840153, 2.3165097485866304],
            [14.682854892488248, 2.315197969112199],
            [14.68597730952843, 2.309115626706426],
            [14.694385763320303, 2.3045275933520517],
            [14.69781915309885, 2.3042757535719427],
            [14.702060071087466, 2.3003612738258092],
            [14.70772668174933, 2.3011529703402602],
            [14.710894944989388, 2.2985579610022597],
            [14.709360980213804, 2.2945851620763187],
            [14.714574815205946, 2.293687240580613],
            [14.717118745038233, 2.2986811154663966],
            [14.7253820121345, 2.3000443357282],
            [14.730875925852187, 2.294615849665936],
            [14.733626721801544, 2.293874942553497],
            [14.737523972458586, 2.2899723010187136],
            [14.738119955892632, 2.2866034506870543],
            [14.742228566394099, 2.2836217801866314],
            [14.745594884562259, 2.285866475429377],
            [14.74827061613889, 2.28500602807535],
            [14.753932387437215, 2.276205076276716],
            [14.752970317493578, 2.27271394180261],
            [14.755895829863906, 2.26882159750897],
            [14.754659275360254, 2.265427620740672],
            [14.756085648728105, 2.2611048953978714],
            [14.763026195516076, 2.2601271305119166],
            [14.767370677904085, 2.262275866443984],
            [14.770321635705015, 2.2616420041115575],
            [14.774238013526618, 2.2515703595624186],
            [14.783082737378002, 2.2518799759142483],
            [14.784295927672437, 2.247513492213992],
            [14.789162155984224, 2.240789423781104],
            [14.791806370052228, 2.242359093964911],
            [14.807190653348153, 2.233038685925144],
            [14.809017451779747, 2.2333919126486905],
            [14.812544727189827, 2.228114469884728],
            [14.811153334514211, 2.222013674754762],
            [14.807013815751299, 2.213582002179602],
            [14.807912463596402, 2.200351524542184],
            [14.811881429185867, 2.195757218518948],
            [14.80781875677567, 2.1858038549049428],
            [14.807180416790144, 2.177822470569801],
            [14.804399111050856, 2.1655002275982387],
            [14.800788597850877, 2.156270283178564],
            [14.796770945520716, 2.150183598545359],
            [14.798232461516672, 2.1436511033364285],
            [14.798615102812747, 2.1364429410808228],
            [14.79686822576938, 2.1216938745030745],
            [14.797844189595894, 2.1189953577674703],
            [14.797172050087067, 2.113113616982828],
            [14.79756364691118, 2.1034694735011965],
            [14.793971689728052, 2.0972815898183024],
            [14.793469836495694, 2.0881125694465994],
            [14.794008660638962, 2.082697147068824],
            [14.793557622813523, 2.082138467732757],
            [14.761370319316175, 2.0529568079013547],
            [14.73227109893455, 2.0257456589629244],
            [14.728291147139661, 2.0224615328993925],
            [14.706177816386155, 2.0012277335270587],
            [14.69784114600129, 1.994035020386202],
            [14.643289381775128, 1.9436270485715326],
            [14.604554568397171, 1.9088822915021646],
            [14.601676228900303, 1.9069493644565858],
            [14.601694857468667, 1.9117702059474646],
            [14.5991369464103, 1.914699263407586],
            [14.589651687766638, 1.919152028471194],
            [14.581031683788314, 1.9248100126676218],
            [14.575354134758161, 1.929780784169245],
            [14.567308467629676, 1.9317521131993007],
            [14.558102972012632, 1.9315686011976554],
            [14.546263393110324, 1.9358769633201145],
            [14.536613555196821, 1.9373464427111216],
            [14.529124824243452, 1.9405796535033983],
            [14.526259214011407, 1.944744526865205],
            [14.519284833604448, 1.9513257990552342],
            [14.512121710935295, 1.956997413319138],
            [14.509057002167223, 1.9649803904284069],
            [14.508323054968237, 1.9724574986351113],
            [14.503916611889755, 1.9759191382868913],
            [14.495143959582851, 1.9732794625687977],
            [14.488451282240892, 1.9686016905614416],
            [14.480449269853217, 1.9669592245297596],
            [14.474827420544033, 1.9677136464385483],
            [14.467463640899398, 1.9652785329426963],
            [14.451316444846762, 1.9673214480297607],
            [14.439530242663565, 1.96810392644456],
            [14.426942805288698, 1.972044020555653],
            [14.4221204394507, 1.9759003942862783],
            [14.417307123469994, 1.9774307793322496],
            [14.416014992596496, 1.9915152712513557],
            [14.41617788396583, 1.9979213974934864],
            [14.41984707767176, 2.0053264036716683],
            [14.422121457186138, 2.0185037588617454],
            [14.426653622063208, 2.0317172931641],
            [14.42766773786137, 2.0443712441575004],
            [14.429711091939327, 2.0605076093892327],
            [14.426963995287215, 2.0725064360973624],
            [14.427397536913649, 2.082963088016555],
            [14.425907828074108, 2.0883264962185324],
            [14.425291423970991, 2.096640109724957],
            [14.426061449611431, 2.1053121339343113],
            [14.429152948443393, 2.107747480072408],
            [14.429344863385865, 2.11652853893468],
            [14.432566002118726, 2.119798469329886],
            [14.431825778345448, 2.1240613697529898],
            [14.435156725411023, 2.1292453945418535],
            [14.43251765335122, 2.135358963256631],
            [14.428156867713335, 2.1416320789026377],
            [14.431968832309865, 2.152448513496448],
            [14.423745610245478, 2.159958628731482],
            [14.424394208093673, 2.164050064856563],
            [14.422708708100666, 2.1671307469663126],
            [14.423944226220899, 2.1786574949367874],
            [14.425722923864269, 2.182681294070442],
            [14.42546069536021, 2.1893254859222626],
            [14.429455332914117, 2.198384021573626],
            [14.434940277070663, 2.203633673510702],
            [14.431921415261801, 2.2122190779068327],
            [14.434279841281132, 2.2141201825758317],
            [14.434565961783695, 2.2188972637834414],
            [14.433244042674774, 2.2270841833284925],
            [14.436122173736456, 2.2309096910008424],
            [14.437200521496674, 2.2355131560370776],
            [14.436896710596187, 2.245980959223405],
            [14.438493594461447, 2.2639588225300407],
            [14.43802770422421, 2.2750925439311778],
            [14.440164577931379, 2.2860820913209907],
            [14.453669660830556, 2.2941955140086354],
            [14.454254561820319, 2.3003882140842085],
            [14.459613686807996, 2.303842388683207],
            [14.463887232076658, 2.302718138259889],
            [14.467706540934882, 2.303510225764825],
            [14.47000626926188, 2.3099665314035667],
            [14.473584550017028, 2.3139053308916444],
            [14.476967902884612, 2.324068087589282],
            [14.476998719051338, 2.3284818542531402],
            [14.481201850051786, 2.3370054188670384],
            [14.48064612631918, 2.3395901524379066],
            [14.484598229074225, 2.343686694775595],
            [14.487029985106233, 2.353297890031107],
            [14.482572073219728, 2.359314795657969],
            [14.473952124100428, 2.3585823167122277],
            [14.47683653657066, 2.364453152627789],
            [14.48129902075249, 2.366529646578239],
            [14.485039206306118, 2.372582929263843],
            [14.48648545779143, 2.38217152918261],
            [14.493872482487122, 2.3929420397315995],
            [14.49625722005113, 2.3999274248985003]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.39798433449775, "lat": 39.47222526817092 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24021"],
        "coty_name": ["Frederick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Frederick County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01711211"
      },
      "bbox": [
        14.416014992596496, 1.9069493644565858, 14.812544727189827,
        2.4373481286593126
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.074748820262887, 6.079683743329353],
            [17.141074096909044, 6.093941587081962],
            [17.227427691409908, 6.112605343879432],
            [17.31563716071278, 6.130972791253574],
            [17.36526485448615, 6.141358566780849],
            [17.47809209521186, 6.165109857488111],
            [17.603604693931644, 6.1913249148940634],
            [17.623097630484953, 6.147866220440208],
            [17.63241215524161, 6.151004548078869],
            [17.635131839014196, 6.143968004271437],
            [17.644599450560797, 6.14772080405882],
            [17.647473933986245, 6.140597617925091],
            [17.656162103182474, 6.143860917054162],
            [17.66529293788519, 6.121679099458971],
            [17.665210251674775, 6.117537012759223],
            [17.667142247154395, 6.113360420643692],
            [17.66636145806034, 6.109105939487763],
            [17.668944618229418, 6.099151705122679],
            [17.66653664022721, 6.096192841289291],
            [17.66088984251469, 6.094522455264033],
            [17.650971230852964, 6.0898292917975985],
            [17.653549470235113, 6.084000666520111],
            [17.650053963629926, 6.0814450668388655],
            [17.648545857202997, 6.077480309740939],
            [17.644926461558477, 6.07714268504377],
            [17.65517978421309, 6.054039072863311],
            [17.647157823545168, 6.054461411509044],
            [17.64411091613502, 6.0527316388305294],
            [17.645674778858318, 6.045965341903946],
            [17.650198514870834, 6.037364344643915],
            [17.660231855561996, 6.011430223320078],
            [17.682407223119345, 5.996413262492588],
            [17.657887775912872, 5.955161957541596],
            [17.67311771320956, 5.919418605574509],
            [17.670896855941454, 5.916034219556965],
            [17.668576110858684, 5.906730591218092],
            [17.662410172404954, 5.895183340940323],
            [17.66168054397821, 5.889144743091516],
            [17.66167498077377, 5.873120844779902],
            [17.665328823951207, 5.863183728469188],
            [17.66744499879764, 5.8623970010646245],
            [17.66580579475308, 5.856057317525574],
            [17.66872739037118, 5.851398212845682],
            [17.66790066233896, 5.844005516580503],
            [17.67285127609959, 5.839901280054693],
            [17.672122646232022, 5.832997061897105],
            [17.674554433897992, 5.828170157732215],
            [17.675301070584233, 5.819228369875592],
            [17.671482414608306, 5.807757345912019],
            [17.670678333830853, 5.802340365034181],
            [17.67183424537152, 5.794354208361431],
            [17.66848137458255, 5.792412482289889],
            [17.667444223791332, 5.787740499509869],
            [17.662772418745863, 5.785720755543545],
            [17.661150179825537, 5.780802794663979],
            [17.656288026856167, 5.775145438369183],
            [17.651379776314226, 5.776082351383967],
            [17.65290155894273, 5.779152689394924],
            [17.652462085083325, 5.787110205499194],
            [17.6536870444456, 5.794328866400701],
            [17.651271236057944, 5.796619843420074],
            [17.651308843552858, 5.80357848398649],
            [17.64652547944268, 5.810943777215477],
            [17.642726137461274, 5.812929496886708],
            [17.64354552399884, 5.818407211198073],
            [17.64024574319743, 5.823801720939038],
            [17.64074358622284, 5.827028231755593],
            [17.638263284407262, 5.8307595649583455],
            [17.638420329053893, 5.833777962833917],
            [17.63248852456053, 5.839346171534505],
            [17.63106243760035, 5.844336594443088],
            [17.628801140814126, 5.845871938343783],
            [17.627336672355558, 5.853670871524932],
            [17.622064946271564, 5.864241483787613],
            [17.62324903898013, 5.867870084941335],
            [17.615852637652193, 5.876214692551998],
            [17.616328950619366, 5.878998041882458],
            [17.612956331905135, 5.88315540509936],
            [17.538978795267774, 5.850745261578307],
            [17.528082601489928, 5.875203904131017],
            [17.465984928716722, 5.848032807432885],
            [17.46265838956158, 5.847783920783956],
            [17.43850221919361, 5.833449434432975],
            [17.38244024850389, 5.8096063133941],
            [17.37337042672866, 5.8562425026067135],
            [17.33463037118805, 5.839351107866206],
            [17.33350002902021, 5.845809203405248],
            [17.327399834700586, 5.843539766335711],
            [17.326961359667703, 5.847768137436484],
            [17.331082356276777, 5.849420401122653],
            [17.330588452820326, 5.853871290747118],
            [17.326499608738786, 5.852061879487604],
            [17.32600605396908, 5.855560336625664],
            [17.318464468949593, 5.856905525187825],
            [17.274615122064283, 5.8565829894804855],
            [17.274715011074473, 5.855965991885955],
            [17.244713794577248, 5.856457312397162],
            [17.236228617661116, 5.878301619945032],
            [17.235324938936152, 5.896542614051607],
            [17.2314898956546, 5.896366074778196],
            [17.229224306871995, 5.901825998437466],
            [17.226794240870984, 5.910987026708591],
            [17.153167292236947, 5.90815309982648],
            [17.14995251171179, 5.994962503364608],
            [17.146430091222413, 6.004246486094239],
            [17.143471763422347, 6.007291497569494],
            [17.141392128037598, 6.018232845380278],
            [17.13582342612943, 6.018305323992162],
            [17.13516710484249, 6.015331080294267],
            [17.131762270182858, 6.014445570762994],
            [17.12801504574985, 6.009996401296874],
            [17.12379616961919, 6.012344573574401],
            [17.116944254128974, 6.014029683336917],
            [17.110615779067743, 6.018432802524672],
            [17.114816972416016, 6.020574419335715],
            [17.11348588638373, 6.024355623863932],
            [17.122999855154784, 6.02896537523834],
            [17.1203380537421, 6.033968477001561],
            [17.123772145928626, 6.03805062330627],
            [17.12966884156606, 6.037889261373154],
            [17.135697872909056, 6.042241249247195],
            [17.136729082659407, 6.046282591321282],
            [17.13412923235416, 6.04997901559567],
            [17.135991682788596, 6.053536284864019],
            [17.135456627261284, 6.057471524908495],
            [17.102178823272588, 6.04532897235791],
            [17.083516294139653, 6.042219794894953],
            [17.074748820262887, 6.079683743329353]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.59180936922112, "lat": 42.5831269196174 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25011"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00606932"
      },
      "bbox": [
        17.074748820262887, 5.775145438369183, 17.682407223119345,
        6.1913249148940634
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [19.436656623279497, 5.188127953405291],
              [19.451952861858725, 5.186036731532737],
              [19.455404935822738, 5.182897944182771],
              [19.46233338814466, 5.185748431140893],
              [19.466953231752143, 5.1909378554768315],
              [19.466799387798662, 5.19740910814567],
              [19.462786913654718, 5.200577357258081],
              [19.458902866689968, 5.196709147677043],
              [19.45551480883264, 5.199178615393962],
              [19.45890147416942, 5.20526890178988],
              [19.462852275258655, 5.2069226567271],
              [19.468060404775258, 5.2060607858083605],
              [19.513135408028482, 5.217887042588922],
              [19.523379644152385, 5.222328571884202],
              [19.526582681965298, 5.22525003354114],
              [19.5352801732739, 5.2281021883119605],
              [19.542141326499817, 5.231421811464547],
              [19.553525379376804, 5.2446342318132215],
              [19.561835897179282, 5.260423573679863],
              [19.567613485987607, 5.280465120786674],
              [19.566778288078694, 5.3024231195969875],
              [19.564883927287838, 5.3102233382603155],
              [19.554454035540257, 5.318132452615569],
              [19.545356426575232, 5.320393144724259],
              [19.541335622265578, 5.323755375376799],
              [19.54066854871268, 5.327531648284886],
              [19.54584339276159, 5.326482911979713],
              [19.567394522490915, 5.311333759244397],
              [19.635099861949506, 5.236146724460901],
              [19.639037522734263, 5.222457691383431],
              [19.6387023877508, 5.21280810341785],
              [19.637060735543493, 5.207756418639671],
              [19.633322963859403, 5.202070469854679],
              [19.616007486644186, 5.1903350219145015],
              [19.60675520473375, 5.1857150894632635],
              [19.57784473509236, 5.183967663542274],
              [19.555870309373486, 5.178624788216168],
              [19.549861203488025, 5.175434755684482],
              [19.544799584242273, 5.17114138412829],
              [19.531255408852545, 5.169247449219593],
              [19.49003944610117, 5.173511383839084],
              [19.4481143518415, 5.182324765331084],
              [19.434581955887143, 5.186995243165004],
              [19.436656623279497, 5.188127953405291]
            ]
          ],
          [
            [
              [19.398923845147436, 5.20358588389758],
              [19.408945504377414, 5.207341241450029],
              [19.42214016594114, 5.20550410887315],
              [19.425583163756365, 5.20353740441745],
              [19.42977353925729, 5.196819263480864],
              [19.428009166125804, 5.19351896357675],
              [19.429464289776128, 5.189822754724969],
              [19.426070886084634, 5.188311885651604],
              [19.42138766573608, 5.191592370121968],
              [19.41546948632728, 5.193053139935481],
              [19.40748716393132, 5.1968514309294465],
              [19.399866443621274, 5.201893036410786],
              [19.398923845147436, 5.20358588389758]
            ]
          ],
          [
            [
              [19.36927714484298, 5.222015633019153],
              [19.371979814929244, 5.225222779165663],
              [19.380973515219154, 5.227047271807743],
              [19.38292222919657, 5.223288590202777],
              [19.371677420513556, 5.218859465592976],
              [19.36927714484298, 5.222015633019153]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -70.06894934811324,
          "lat": 41.283132702676696
        },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25019"],
        "coty_name": ["Nantucket"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nantucket County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00606936"
      },
      "bbox": [
        19.36927714484298, 5.169247449219593, 19.639037522734263,
        5.327531648284886
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.20371744742902, 5.554890447375125],
              [9.20501974289662, 5.561899701197006],
              [9.209560386994566, 5.564820992933331],
              [9.214366622907008, 5.56122053672191],
              [9.213764796761504, 5.555796515130705],
              [9.209527305778728, 5.555926359339534],
              [9.207408147770606, 5.552980779620999],
              [9.20371744742902, 5.554890447375125]
            ]
          ],
          [
            [
              [8.944288955558504, 5.6829136107316565],
              [8.936192097969988, 5.754803266583911],
              [8.934537611726899, 5.768576538554103],
              [8.923642682788042, 5.852461597709495],
              [9.009659766423962, 5.8632995979026745],
              [9.020870145952793, 5.778321677691548],
              [9.091124263579937, 5.786574012719355],
              [9.117598883873896, 5.789890027762483],
              [9.116470425556246, 5.786584288839339],
              [9.116223146249334, 5.779044523898087],
              [9.114138125942384, 5.777931509186865],
              [9.115894092364815, 5.77311328483683],
              [9.116148486482079, 5.766306595361348],
              [9.114613017453888, 5.762174162647797],
              [9.116714140306204, 5.757881852082205],
              [9.115318965525395, 5.755872737433356],
              [9.117786486261895, 5.74685875277917],
              [9.11399416574194, 5.74043312233648],
              [9.113539389155958, 5.7372645894951955],
              [9.116856627057986, 5.726729457801056],
              [9.116445388503394, 5.724292393953057],
              [9.119105525205223, 5.712081929743903],
              [9.118812288099164, 5.706129651647717],
              [9.120847633495224, 5.69618567736467],
              [9.118542850359546, 5.679218039571929],
              [9.121288112378561, 5.66669388395788],
              [9.120593702898482, 5.655979364468306],
              [9.11757717154045, 5.651482112900926],
              [9.114341428635631, 5.651648389809997],
              [9.11198285907712, 5.645101355290893],
              [9.111707218184499, 5.641006668919441],
              [9.104175113321162, 5.640664613084596],
              [9.102872526591597, 5.637241627646461],
              [9.106017199008145, 5.627014383937039],
              [9.111218803568923, 5.6169046574186465],
              [9.113232361234322, 5.615884697714862],
              [9.113679428138585, 5.610555450818717],
              [9.120889528119262, 5.593790620271221],
              [9.14452136670259, 5.558710609100202],
              [9.150901946271414, 5.5519294657710425],
              [9.161778026189165, 5.545571402699867],
              [9.178732255065128, 5.538183597720511],
              [9.189094437829946, 5.533226686640302],
              [9.19181528142243, 5.53294672963593],
              [9.193803938442956, 5.5295282253591465],
              [9.196489174228587, 5.530239717309113],
              [9.194769718360433, 5.536308158045623],
              [9.196840089551147, 5.540517089344905],
              [9.202263565812057, 5.54145542443295],
              [9.204330303499948, 5.537768083654329],
              [9.213615028930684, 5.533906252974983],
              [9.217823943378999, 5.533817134034621],
              [9.220121597705601, 5.525735519758936],
              [9.23069674655128, 5.52481515844762],
              [9.233747754842605, 5.526018658285578],
              [9.2528102868014, 5.522998336463994],
              [9.259504161348513, 5.51985455937846],
              [9.279375807368657, 5.515267734527616],
              [9.284279771498545, 5.511265692413373],
              [9.299432888365718, 5.501841606831924],
              [9.30718509515774, 5.490429335984159],
              [9.3084690121714, 5.490093665846566],
              [9.312615298391687, 5.460014392115303],
              [9.32320021218661, 5.381405950441522],
              [9.23805380614687, 5.370522244197174],
              [9.232816164199864, 5.413510911492679],
              [9.204435095695866, 5.4098853230156045],
              [9.162004503717682, 5.404748453759231],
              [9.065237659783289, 5.39394986855605],
              [9.060494724492857, 5.436961394866537],
              [9.003552256542264, 5.4307194206563825],
              [8.975760109832235, 5.427939864226398],
              [8.96917169367166, 5.48536054134028],
              [8.95519658203678, 5.598153198120995],
              [8.944288955558504, 5.6829136107316565]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.99245085281296, "lat": 43.70748678058163 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26017"],
        "coty_name": ["Bay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bay County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01622951"
      },
      "bbox": [
        8.923642682788042, 5.370522244197174, 9.32320021218661,
        5.8632995979026745
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [6.991544547499511, 7.2216706221995555],
              [6.994677749338859, 7.230515359984285],
              [6.998219010161371, 7.22711763433248],
              [7.001123090468651, 7.227913306084738],
              [7.007292588161485, 7.217817549162042],
              [7.01094677937035, 7.216533287280843],
              [7.015664155301494, 7.218382591174633],
              [7.0198307931164745, 7.209517988649528],
              [7.020291892351966, 7.205418670226771],
              [7.017131674488042, 7.198473680836701],
              [7.017504943806157, 7.1951609884920265],
              [7.012994592152779, 7.190072167614013],
              [7.008677822065174, 7.187874527533506],
              [7.00308159441106, 7.188651063870507],
              [7.000841876186914, 7.197122000487507],
              [6.99722988833949, 7.20011266060021],
              [6.996399728439052, 7.205249466661748],
              [6.991544547499511, 7.2216706221995555]
            ]
          ],
          [
            [
              [6.98968640790347, 7.172603084243567],
              [6.991114204510516, 7.1749277902164215],
              [6.995645129953435, 7.176577002004068],
              [6.997210367229878, 7.1721035060392335],
              [6.997553637282258, 7.16632502630153],
              [6.992653760917549, 7.165037394147064],
              [6.98968640790347, 7.172603084243567]
            ]
          ],
          [
            [
              [6.960308235713892, 7.24565164446998],
              [6.961987830868037, 7.2536823387092255],
              [6.965657691120136, 7.257532427442319],
              [6.97652321931241, 7.255167401419822],
              [6.982508710492058, 7.250372897460564],
              [6.977851964526943, 7.241715751276883],
              [6.974457076789681, 7.240556308644327],
              [6.972486583836857, 7.236958891612415],
              [6.969296948087759, 7.23655718672457],
              [6.96060638216989, 7.243135624193703],
              [6.960308235713892, 7.24565164446998]
            ]
          ],
          [
            [
              [6.898857903099106, 7.434094647423649],
              [6.903798972427895, 7.433830904908786],
              [6.901990652641852, 7.430191740981012],
              [6.898857903099106, 7.434094647423649]
            ]
          ],
          [
            [
              [6.913322821472252, 7.1379723345774675],
              [6.914026278490153, 7.145441300306511],
              [6.919217190977698, 7.147377179073216],
              [6.926082232936986, 7.142955597950495],
              [6.931254792838536, 7.141561908768124],
              [6.932192898480771, 7.134305127443212],
              [6.931663931468424, 7.129878149690023],
              [6.933026927370116, 7.123421809239754],
              [6.933153546979442, 7.116960244900209],
              [6.928097515748848, 7.116158972342513],
              [6.92073735661981, 7.1240857771501505],
              [6.917243868881924, 7.125162086826758],
              [6.913051758426868, 7.134595473284389],
              [6.913322821472252, 7.1379723345774675]
            ]
          ],
          [
            [
              [6.461792366847594, 7.576668501350712],
              [6.505001239649075, 7.580418472948288],
              [6.548398284324429, 7.584341209339747],
              [6.535897222713767, 7.726722807060654],
              [6.533369512534557, 7.755844052930974],
              [6.62000300040652, 7.763781359443774],
              [6.706618409675938, 7.771713813908478],
              [6.713965237173336, 7.7725205496311105],
              [6.8127861807226, 7.7815155801104625],
              [6.8506773968463905, 7.7853657368116025],
              [6.922592978846595, 7.792098743093142],
              [6.965798469571255, 7.796453093045314],
              [7.0524865643939965, 7.804508397911613],
              [7.055742783618096, 7.7740808641312],
              [7.061178118846566, 7.718747056782835],
              [7.061730278966048, 7.7187980127927975],
              [7.072909203947146, 7.604133618433036],
              [7.078527734817996, 7.546694239768247],
              [7.100110019701862, 7.548871570850982],
              [7.113450786268387, 7.412351238355226],
              [7.106008877252896, 7.4153090705510865],
              [7.103668550901563, 7.418120096355355],
              [7.099925646291234, 7.417015925105333],
              [7.097984400892306, 7.4126098020966635],
              [7.099631165140298, 7.409342961191401],
              [7.096813550779818, 7.40648374455295],
              [7.097038576536183, 7.402530333924974],
              [7.0932132466425735, 7.39990150824568],
              [7.084580701696492, 7.404305225218319],
              [7.076517338692617, 7.402689321528107],
              [7.0753794197804085, 7.398404377921647],
              [7.072093499193707, 7.398739522689505],
              [7.064173920813009, 7.396219196881611],
              [7.062827213137636, 7.391377920530204],
              [7.064222522368234, 7.389120905171096],
              [7.072664979025664, 7.3862729750171825],
              [7.072163818434202, 7.381771100618162],
              [7.065483860660279, 7.379083799319381],
              [7.066143441725723, 7.372538483672762],
              [7.071776848890829, 7.371249360145341],
              [7.0652910573557035, 7.36526438288343],
              [7.067125259737872, 7.360879038241975],
              [7.064606791765144, 7.3581511452661905],
              [7.059031188209448, 7.3589138719436615],
              [7.0568096765742805, 7.36201798019862],
              [7.0496809823426805, 7.3607810184843885],
              [7.038518400416961, 7.36299442876594],
              [7.0338867195519414, 7.358659877244871],
              [7.031715928757739, 7.351448402899284],
              [7.0320871378682215, 7.344506224131253],
              [7.034080251678554, 7.340777902088124],
              [7.035441222764809, 7.332384835361989],
              [7.034177200591306, 7.328891058693403],
              [7.029905880990309, 7.326062305876301],
              [7.031764765140052, 7.320751220683316],
              [7.030964120545278, 7.311999835002719],
              [7.019850429606377, 7.313799165997029],
              [7.016929951209648, 7.314965559244695],
              [7.010841709001891, 7.311742258599231],
              [7.007893045313835, 7.308186023707543],
              [7.006675193322643, 7.304138186555809],
              [7.009025451000886, 7.296448225582525],
              [7.010364414748698, 7.2874441347697445],
              [7.012421413841121, 7.2800436105428865],
              [7.014574586127168, 7.2763660146390245],
              [7.015951145278047, 7.269470256697311],
              [7.018119815668243, 7.266690883398703],
              [7.0183096705622425, 7.262423600608689],
              [7.0222236650678465, 7.26005389507769],
              [7.024181493252495, 7.255449046891771],
              [7.027250124010882, 7.25422612453145],
              [7.026956928131541, 7.250356490076216],
              [7.02173120710641, 7.24607457281719],
              [7.0192439142962275, 7.252482295725442],
              [7.006744719992579, 7.262668464522081],
              [6.995133102380585, 7.259359297574213],
              [6.993570464660708, 7.261229177689263],
              [6.983497772821126, 7.263820284221284],
              [6.967591125372693, 7.2747862439267115],
              [6.965943482069572, 7.280320705358417],
              [6.960897193478615, 7.286760236259584],
              [6.960017238853884, 7.293553768133314],
              [6.955009211715117, 7.295217969493965],
              [6.951926708451574, 7.291772840140174],
              [6.947565123903642, 7.29593428318063],
              [6.943592887804509, 7.303513752828937],
              [6.941779793894853, 7.312240192602947],
              [6.942855341614885, 7.321886439264084],
              [6.94627404759928, 7.327238049252285],
              [6.951931417680785, 7.329887210677856],
              [6.958068305396041, 7.3273791088011215],
              [6.961031598891685, 7.327553344053979],
              [6.969625502313874, 7.33237596787512],
              [6.975918623123369, 7.3433047826047275],
              [6.975366397532275, 7.350036707694374],
              [6.972578200215207, 7.351586975285503],
              [6.97000784722578, 7.3612826368367825],
              [6.972923476270301, 7.362869116346506],
              [6.975323890879359, 7.369885909437847],
              [6.977943100860896, 7.371060200966368],
              [6.983262772350248, 7.369824803574994],
              [6.985699985967159, 7.374539985854622],
              [6.987521784865502, 7.382041116233336],
              [6.9927494081348796, 7.387406164650213],
              [6.994078437871437, 7.39033478191275],
              [6.992586914731384, 7.396420389466785],
              [6.994843320094457, 7.3990455039848175],
              [6.997805365661952, 7.397767683770388],
              [7.0017923952368415, 7.403773309030688],
              [6.999707334124321, 7.407118547128571],
              [6.994116474055699, 7.405496566732784],
              [6.989739919736936, 7.406921582347614],
              [6.991740286763859, 7.4135182390273116],
              [6.995438451503492, 7.413138125607407],
              [6.998313409791435, 7.415236429061955],
              [6.9935557274703655, 7.419474339847958],
              [6.992108389006288, 7.424457144149849],
              [6.997595841768144, 7.426606494320967],
              [7.003272082670107, 7.425999928192941],
              [7.00420220941819, 7.42194825316414],
              [7.009149125465875, 7.4220192379482395],
              [7.011735824651587, 7.416059294324012],
              [7.015674340503443, 7.417520176294838],
              [7.016899510970403, 7.421853694753706],
              [7.0235172881625765, 7.424242988185046],
              [7.028224735382609, 7.422883834872408],
              [7.032687511780774, 7.419114009399256],
              [7.037969666086325, 7.417158913777691],
              [7.041007509323594, 7.417624258035669],
              [7.042545059086707, 7.422233261227056],
              [7.036061169786127, 7.428690452962149],
              [7.034231076705431, 7.431975852575029],
              [7.026863864414781, 7.435622082648481],
              [7.027156387903138, 7.446171887752053],
              [7.031418189127224, 7.451558428374557],
              [7.036916914926066, 7.4511226533968475],
              [7.040838433636942, 7.455196838043418],
              [7.04146839538171, 7.460562577817783],
              [7.03771107464362, 7.466697170935208],
              [7.038123810778027, 7.472647349896881],
              [7.039915307445276, 7.478524593170633],
              [7.0436599185033835, 7.48366018352892],
              [7.049196224011868, 7.485020346952736],
              [7.051400382079447, 7.494034322235482],
              [7.056629040144839, 7.501638722132427],
              [7.05543442082163, 7.50440392552744],
              [7.053389064692593, 7.522936215253042],
              [7.0484068674578575, 7.533222083424608],
              [7.043628003640912, 7.537156637616334],
              [7.030230895761643, 7.54480314440713],
              [7.0244076351878695, 7.5454729906890545],
              [7.014716544523534, 7.540151580437846],
              [7.011574636883447, 7.536227708795599],
              [7.0101940286908055, 7.530173581083803],
              [7.00804679394791, 7.527329952413029],
              [7.005168422044182, 7.519768857971471],
              [6.99505812910261, 7.518183792955494],
              [6.992273193644593, 7.51233911121512],
              [6.988131141767954, 7.5113334496467274],
              [6.983006237853457, 7.50116306496789],
              [6.985039946640505, 7.490535664987608],
              [6.985132378786306, 7.484691165261384],
              [6.976920038125503, 7.483568044721059],
              [6.975619652208081, 7.474045506419998],
              [6.970504798407909, 7.477748497803988],
              [6.966676883517159, 7.476879511196972],
              [6.9656577683549505, 7.473731104468984],
              [6.957443402142452, 7.477012732437339],
              [6.948290517206569, 7.4780249821167795],
              [6.93894281607352, 7.480238710573401],
              [6.933394801231663, 7.480149773143134],
              [6.92662508842701, 7.4777271077601055],
              [6.923417778392609, 7.480781596418112],
              [6.917953811292488, 7.483563418502662],
              [6.915737091898651, 7.4831811749952895],
              [6.914444669185644, 7.489450103855917],
              [6.908614892245717, 7.494242037500263],
              [6.906725708291267, 7.4983580670860155],
              [6.901451278556913, 7.500909319263135],
              [6.895389308112429, 7.4998033456594655],
              [6.884113834811634, 7.494225920019021],
              [6.879679783617347, 7.491241566271541],
              [6.878641832853309, 7.487264385875428],
              [6.881438939015786, 7.480132108195517],
              [6.881247773820019, 7.4724206922247065],
              [6.877873551790579, 7.466598592023565],
              [6.879529657976583, 7.463693852718813],
              [6.886243662099294, 7.4590207555986625],
              [6.8885888432443165, 7.453785819937149],
              [6.890512785440341, 7.443708402308896],
              [6.887719846250896, 7.431286715933245],
              [6.890137831537377, 7.428715909176572],
              [6.88477849799379, 7.426452697419588],
              [6.8718390572478025, 7.424147705955518],
              [6.869758046071617, 7.4181737123301295],
              [6.877190139524752, 7.406099768142712],
              [6.870250778495048, 7.406838455946102],
              [6.86096658371227, 7.400019378272105],
              [6.8598932016713885, 7.395067856434634],
              [6.8633639566175395, 7.390657275807792],
              [6.86282040327673, 7.385982390551926],
              [6.855501817947697, 7.380303479211084],
              [6.854775777502215, 7.376088900475704],
              [6.851804180035565, 7.370739863716972],
              [6.849432266963434, 7.370247607519553],
              [6.847760082235438, 7.365352811098686],
              [6.85162283095615, 7.358895359002229],
              [6.851677355101756, 7.3540592139591014],
              [6.853620794942439, 7.351473310230118],
              [6.8511396298548295, 7.348623471443597],
              [6.842561330748308, 7.3441481955704155],
              [6.838395113309086, 7.342927006847796],
              [6.835549923256654, 7.337717681412424],
              [6.828471378445356, 7.3381038353614985],
              [6.815310582537828, 7.336561489473286],
              [6.80999632244929, 7.334119426692623],
              [6.806409472354108, 7.326652968940508],
              [6.80184167322703, 7.32084196102407],
              [6.799856014917209, 7.32073584976912],
              [6.7953185901343485, 7.3262557748713135],
              [6.789496163973522, 7.32694273753512],
              [6.7841150550919425, 7.324779257713737],
              [6.782290307760835, 7.316469444358994],
              [6.7794738802517385, 7.31390117600076],
              [6.778334163230544, 7.306997465436633],
              [6.77505882120924, 7.305551044208534],
              [6.771032001562479, 7.29426687600495],
              [6.767750675652612, 7.299232923939324],
              [6.767762826385258, 7.30606979430214],
              [6.765397013435787, 7.312789167765978],
              [6.758536070240409, 7.315946984575055],
              [6.757360912014082, 7.315178804001827],
              [6.75376660852991, 7.325549086567406],
              [6.754039814573927, 7.344104812395567],
              [6.756414623786978, 7.348656088031868],
              [6.755809824646632, 7.354787738341569],
              [6.755233325885509, 7.375476587098129],
              [6.751219298019926, 7.379562332796255],
              [6.750311191242176, 7.385305015379988],
              [6.748440515120415, 7.388327792195384],
              [6.747393914588366, 7.396034988135519],
              [6.74868683758092, 7.40457478516429],
              [6.746702543720627, 7.412738255879463],
              [6.743507345237965, 7.415451540999323],
              [6.741173130087238, 7.428696058138814],
              [6.739202292456063, 7.431563504416564],
              [6.73200754205151, 7.434872266295323],
              [6.732229961494236, 7.438643945892661],
              [6.729780280158692, 7.44056277387776],
              [6.727591965474802, 7.4455055139130275],
              [6.730335931247691, 7.449092427557009],
              [6.739244455198362, 7.454298339305255],
              [6.740940285784746, 7.465249625963515],
              [6.745980906657927, 7.469102474011746],
              [6.749151158417554, 7.473355064124718],
              [6.752305652125914, 7.482959198382278],
              [6.760108633417849, 7.490942519024734],
              [6.762813738316672, 7.496549314549782],
              [6.762462885479852, 7.506228094789625],
              [6.760774695531706, 7.516847144405125],
              [6.748972478739996, 7.52280623691063],
              [6.739467892948153, 7.523059313644675],
              [6.735588825143321, 7.518415909845612],
              [6.736101750021284, 7.51393913676298],
              [6.739739321411778, 7.511567610839741],
              [6.731937947525942, 7.507000830281445],
              [6.726914919102541, 7.4934426138997505],
              [6.722717691845998, 7.485144230739651],
              [6.718137409289125, 7.482573397694269],
              [6.713176905490811, 7.475273151051288],
              [6.7210114413426965, 7.46818623459],
              [6.7275505677954826, 7.466825497343904],
              [6.730342305603217, 7.464616791910728],
              [6.717350813531615, 7.454580631806616],
              [6.70880505142555, 7.452138276700701],
              [6.703249859322378, 7.4486390399440845],
              [6.699886435756488, 7.441122540770913],
              [6.695763626994272, 7.436008731184814],
              [6.693074884696525, 7.4260307689623595],
              [6.69312892349449, 7.415115838154699],
              [6.69437792877021, 7.404066279760438],
              [6.693296326691866, 7.3974639901539145],
              [6.6972520433145935, 7.389967221270892],
              [6.693092034143571, 7.386351130079188],
              [6.6933412611638765, 7.372654199856537],
              [6.695178248540334, 7.367319323587353],
              [6.7001096146343855, 7.366027784720282],
              [6.7006123382169065, 7.363369185190354],
              [6.713524229095461, 7.359371731240201],
              [6.713113150488657, 7.3572754470154225],
              [6.706427967220051, 7.352879722952049],
              [6.700174298489445, 7.351387205407946],
              [6.6975758379484125, 7.347160936293613],
              [6.698407037606319, 7.344521842426422],
              [6.692367757906236, 7.332506960479564],
              [6.683750313917702, 7.324945979706642],
              [6.686299341234384, 7.320816996968042],
              [6.691528765684217, 7.321938591535901],
              [6.695525120359161, 7.325075019983673],
              [6.6981709093636645, 7.322254802964422],
              [6.682492580543055, 7.316444273755443],
              [6.6770891674618165, 7.313605599233749],
              [6.67395280039631, 7.309881260558206],
              [6.674949284400398, 7.299245261455012],
              [6.6729797954408845, 7.297898806097959],
              [6.6663417051996445, 7.297443311410941],
              [6.653636399820043, 7.291509071290331],
              [6.648732889049672, 7.288131590800887],
              [6.641856212828863, 7.281843253225588],
              [6.639928758473416, 7.278703295057301],
              [6.631244998063631, 7.273930553099144],
              [6.625940538391046, 7.26743162522877],
              [6.6253512586837155, 7.257997387495081],
              [6.619365365708614, 7.254489102400639],
              [6.6187035288613725, 7.251509132149649],
              [6.611994902854417, 7.245499865489432],
              [6.612585631292144, 7.240563775075382],
              [6.610682225234929, 7.233946677904087],
              [6.607735768170805, 7.2305201517514295],
              [6.603982701478501, 7.22220390757253],
              [6.600651202651379, 7.212582734373184],
              [6.598389027066096, 7.209367738945381],
              [6.595033369104537, 7.199768085326442],
              [6.590597680911954, 7.1938454642079845],
              [6.5884825859249165, 7.181010331214947],
              [6.586117311877746, 7.17722113994521],
              [6.580267748391378, 7.171865561455908],
              [6.575465448360127, 7.160732445447873],
              [6.573728381878947, 7.1541203650222425],
              [6.529272897273449, 7.1508248896434985],
              [6.523212277972883, 7.221833821376432],
              [6.5190511817692665, 7.272261958282986],
              [6.516547833522659, 7.300467511637492],
              [6.512376788718342, 7.351781097134822],
              [6.509488078819232, 7.380082415986762],
              [6.5069975302001515, 7.408563948864765],
              [6.499100725241216, 7.4938888210153545],
              [6.469736609077984, 7.491533089950766],
              [6.461792366847594, 7.576668501350712]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.92422555279678, "lat": 45.91943932551406 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26041"],
        "coty_name": ["Delta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delta County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01622963"
      },
      "bbox": [
        6.461792366847594, 7.116158972342513, 7.113450786268387,
        7.804508397911613
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.6261529545219071, 5.604769645384629],
            [1.6308585319783715, 5.604145154017774],
            [1.6347914743015157, 5.60101660051916],
            [1.6376029089131592, 5.602119307697091],
            [1.6425016746334, 5.598463643641369],
            [1.6509662145594524, 5.597558143256568],
            [1.6558243857044523, 5.59476632523833],
            [1.6572755687483505, 5.590562136129373],
            [1.662991216969937, 5.587066826866062],
            [1.663638476334444, 5.584404196022438],
            [1.6749686100473367, 5.582984905320287],
            [1.6777295164294923, 5.583887741984499],
            [1.679127344146028, 5.579084728936175],
            [1.6843131803002946, 5.580912816875029],
            [1.6884099335294156, 5.57455859102953],
            [1.6873883048589062, 5.569947815225162],
            [1.6923476179377377, 5.570471357234967],
            [1.6978232262410868, 5.565801940320912],
            [1.7051451953072392, 5.566461078159547],
            [1.709504545564449, 5.5655110020475975],
            [1.7111034353826975, 5.562692182693421],
            [1.715245262914596, 5.562047049111988],
            [1.7129975835862241, 5.556664166321955],
            [1.7196959210874032, 5.556016214653506],
            [1.7221208939399406, 5.551812627136111],
            [1.7258672492186822, 5.554630147035043],
            [1.732261805676214, 5.554005759302198],
            [1.7342070390508355, 5.547844209884279],
            [1.7375163013579085, 5.547828020407175],
            [1.7428582750356094, 5.5426678423417375],
            [1.744525508252289, 5.544227136170482],
            [1.7507397403944183, 5.545291845823332],
            [1.7567282149289252, 5.540962824654369],
            [1.7639240729791938, 5.540423440812645],
            [1.7692778262522655, 5.538084785470502],
            [1.7809595018405704, 5.5371068278167765],
            [1.784431411491066, 5.535090561643375],
            [1.7906359169523502, 5.537470099212945],
            [1.797323468656494, 5.530451379777161],
            [1.8037829679725192, 5.527974113802082],
            [1.8037889272148173, 5.5235975287023065],
            [1.809976516747565, 5.52272050864132],
            [1.8138117219059133, 5.523396554811779],
            [1.8156549521200254, 5.519496727934547],
            [1.8148784111330916, 5.516314074790214],
            [1.819495542103753, 5.515061204528406],
            [1.822118932781278, 5.512185754924909],
            [1.826330578749307, 5.512552380065028],
            [1.827767028453797, 5.508376877804547],
            [1.8324370985706588, 5.507799123613059],
            [1.833248276262304, 5.505069484869945],
            [1.8409625213270375, 5.502977197248922],
            [1.8497189766632207, 5.507289815300137],
            [1.8515717892394319, 5.5014070409957645],
            [1.8542540241530707, 5.4987545865371805],
            [1.8603059192515685, 5.499160820423445],
            [1.8623581760535584, 5.500741158989916],
            [1.8630063778992583, 5.507299204685443],
            [1.874220271667907, 5.51150854005383],
            [1.8827313564340094, 5.510397404601573],
            [1.8910875994436556, 5.514739931736114],
            [1.8919163057104413, 5.519449888114537],
            [1.8886475313861948, 5.529574573083495],
            [1.8787254189182283, 5.52989547276881],
            [1.8789885209107173, 5.534744068540424],
            [1.8812350107210083, 5.537147817123927],
            [1.8848032120305602, 5.537265985924445],
            [1.8851975651380315, 5.541934439425651],
            [1.8808257321133652, 5.5539041784341965],
            [1.8742060802171485, 5.55761896757638],
            [1.874055971700983, 5.566042682795355],
            [1.8757796210500173, 5.567333656751564],
            [1.8816501653770925, 5.566927159367884],
            [1.8818899818909023, 5.57184149985451],
            [1.8800235716460527, 5.574201432610427],
            [1.8795914121466177, 5.582002614044807],
            [1.8835462525002968, 5.584753086484751],
            [1.9358176593545773, 5.585661796595162],
            [1.942648552968758, 5.586307912791394],
            [1.9811002123955412, 5.5866224741222945],
            [2.0576531451835933, 5.58846487335607],
            [2.0587218363489015, 5.544997396823788],
            [2.0619866423550266, 5.396797988488509],
            [2.0648436825139003, 5.28449589447924],
            [2.067071045096728, 5.1974964498316165],
            [2.0229458259355146, 5.196422380381587],
            [1.923454816787418, 5.1945482229457784],
            [1.8079616303633252, 5.191940796140107],
            [1.722808413547816, 5.190297674081555],
            [1.635291625690685, 5.1888469370494725],
            [1.6332736724810002, 5.304643382193632],
            [1.6321399744634966, 5.362516301368506],
            [1.6308910373544896, 5.449298190392496],
            [1.629591961407368, 5.521694697865152],
            [1.629166616830121, 5.536413617415294],
            [1.6274373769100212, 5.536676720531977],
            [1.6265387434345833, 5.589952141664434],
            [1.6261529545219071, 5.604769645384629]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.06698996086456,
          "lat": 44.034517340948035
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27013"],
        "coty_name": ["Blue Earth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blue Earth County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00659452"
      },
      "bbox": [
        1.6261529545219071, 5.1888469370494725, 2.067071045096728,
        5.604769645384629
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5705198224255263, 5.834489846988564],
            [2.569750605092432, 5.849001894574946],
            [2.5690873408826147, 5.8749974816539945],
            [2.5781267699379398, 5.878981793115704],
            [2.5845055765808, 5.877995358047929],
            [2.5879162806594005, 5.879081694006326],
            [2.59483994647275, 5.8791419206366955],
            [2.5981416940898905, 5.880941717211107],
            [2.6078480782236944, 5.882505541999211],
            [2.613969255278772, 5.880928084105095],
            [2.616301549810005, 5.878652294261717],
            [2.6279360958632307, 5.8788823016148095],
            [2.6296160275979674, 5.871425711103927],
            [2.632056438681316, 5.8721800527469785],
            [2.6353451350705557, 5.877143219285179],
            [2.641382409593725, 5.876196056385649],
            [2.6447514023502148, 5.877297912605361],
            [2.654640537560955, 5.882748592017422],
            [2.653927691236211, 5.908347256532592],
            [2.737962829304234, 5.9110600666173605],
            [2.7437405250913813, 5.911025368143743],
            [2.740818045520252, 5.997461001449322],
            [2.783789726452976, 5.998689006239399],
            [2.7833576744841553, 6.005450022085651],
            [2.7817890886989, 6.048935741938911],
            [2.78089048950096, 6.08252819039556],
            [2.7946825849103183, 6.070453302080217],
            [2.803621633825116, 6.063448987541021],
            [2.8069317903506072, 6.059260951598735],
            [2.8142641574681564, 6.052196080850259],
            [2.8303888830118864, 6.034094132626254],
            [2.836884089702519, 6.028996009280814],
            [2.8540167611148095, 6.020609560649908],
            [2.861732642857391, 6.01086504486837],
            [2.863470745418158, 6.001183404930059],
            [2.861688723336479, 5.995439277051378],
            [2.861457061449408, 5.9901508195211886],
            [2.862782837545157, 5.986998959188802],
            [2.8677884283125565, 5.98389759762429],
            [2.8770420904037364, 5.9845473647551195],
            [2.885104605130642, 5.978734183024132],
            [2.886442509989928, 5.974554594034656],
            [2.8915882409232676, 5.973905636456872],
            [2.894591171898172, 5.978193674205994],
            [2.900121943405006, 5.97688088292637],
            [2.9065651898126594, 5.96855090364028],
            [2.9148913840107253, 5.955058832541789],
            [2.9153689659209348, 5.951658295613413],
            [2.9140070091953585, 5.9455266012029035],
            [2.91520525616912, 5.942957050969712],
            [2.921948948270156, 5.941475030730066],
            [2.9311038219020924, 5.94808842286287],
            [2.9374208447493317, 5.949943532750431],
            [2.9444166309563244, 5.945352338630201],
            [2.955192713852556, 5.941495016929769],
            [2.964206930772059, 5.944034377958222],
            [2.980113173358791, 5.939104041812621],
            [2.993368286998716, 5.930162240508613],
            [2.99579680367073, 5.929750915825865],
            [3.0033466796443533, 5.9360363789598205],
            [3.0113187435443045, 5.937887598314894],
            [3.0226256438352377, 5.936250609885717],
            [3.0299226663722996, 5.935932439340166],
            [3.044599258201215, 5.9379705712879245],
            [3.05940274951966, 5.936506632994133],
            [3.0676594900646412, 5.933684882477058],
            [3.0728239978720158, 5.93078106607714],
            [3.0795017390234265, 5.925096084770813],
            [3.082292051125343, 5.9212383964391035],
            [3.0839390600522116, 5.918356153149307],
            [3.086604097845949, 5.909220714865779],
            [3.092139749577555, 5.900519384012494],
            [3.093023833958534, 5.897225469791879],
            [3.093174399600325, 5.884371379296663],
            [3.09383350764809, 5.881100472875928],
            [3.102382927498955, 5.866626965609311],
            [3.1129587422733582, 5.855245871404218],
            [3.1234692669559636, 5.847172146129064],
            [3.1332262227849466, 5.841939908934185],
            [3.138457695114488, 5.836885009163831],
            [3.090538626167412, 5.835539119343673],
            [3.048164871094218, 5.834108271414037],
            [3.004484753920876, 5.832809734546045],
            [3.0075109495748245, 5.746038066675692],
            [2.953643051368297, 5.744042623121756],
            [2.9219467275110826, 5.743122844582469],
            [2.9249437893713086, 5.656364521947906],
            [2.928166289719661, 5.569949128842476],
            [2.836836320831796, 5.5673096507968225],
            [2.762555839068279, 5.56560883119014],
            [2.7380838945735477, 5.565208020093134],
            [2.626002054486319, 5.56168866522163],
            [2.5779182044182054, 5.560001523192952],
            [2.5762898951965143, 5.617907923203209],
            [2.5739713193024722, 5.704871310941293],
            [2.5729195900718214, 5.741085661002761],
            [2.572529068102129, 5.762643306726641],
            [2.571625653912449, 5.791356405861069],
            [2.5705198224255263, 5.834489846988564]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.72285033166904, "lat": 44.40970625750058 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27049"],
        "coty_name": ["Goodhue"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Goodhue County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00659470"
      },
      "bbox": [
        2.5690873408826147, 5.560001523192952, 3.138457695114488,
        6.08252819039556
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.027627599001307, -7.262241715867785],
            [5.051083540348769, -7.260931072823174],
            [5.099905750908007, -7.257889422347681],
            [5.104188075696521, -7.330990213317269],
            [5.107006313573892, -7.383304607626547],
            [5.108381028634161, -7.402932173295309],
            [5.111878258840523, -7.4604739008692205],
            [5.114721470798498, -7.510757539023392],
            [5.120234867113831, -7.602297374594952],
            [5.120528299316876, -7.60537462165211],
            [5.103823460509701, -7.6063141374955725],
            [4.961130992736869, -7.61479953549221],
            [4.940374866190779, -7.615570410099193],
            [4.883171502475499, -7.6189018314463075],
            [4.824363651366938, -7.621788581221069],
            [4.759947265914221, -7.625503557474687],
            [4.683182484446143, -7.629864179954288],
            [4.683355902730732, -7.628636674763464],
            [4.680502465132847, -7.5603083090436565],
            [4.679224164445328, -7.533429906109787],
            [4.677069524595775, -7.5044890588426725],
            [4.674305274102635, -7.452785783701703],
            [4.672818856600061, -7.419916882001154],
            [4.66906595937955, -7.34872534761063],
            [4.665945267885108, -7.34925110475591],
            [4.658582872616894, -7.346187854401424],
            [4.657031135283812, -7.3437620277110325],
            [4.6512862901679295, -7.342756749909041],
            [4.65008760396464, -7.338122847482782],
            [4.651259858555769, -7.33552694809126],
            [4.647878444481892, -7.332176208898646],
            [4.647324481567077, -7.325434703256276],
            [4.643006245108148, -7.314587022017948],
            [4.6399360053999805, -7.314568054724674],
            [4.636489115041845, -7.311473166446786],
            [4.643673979746487, -7.305427794423211],
            [4.647450915507086, -7.3066972359253874],
            [4.651765486783378, -7.3061186197982755],
            [4.652442180206753, -7.303819966564808],
            [4.658346062338592, -7.303014685456276],
            [4.6587648241682125, -7.294475756586991],
            [4.662006551286237, -7.292495320301789],
            [4.664347373430482, -7.297372063121613],
            [4.668455989756446, -7.300137730508856],
            [4.675960571761186, -7.299343186512995],
            [4.678267404729329, -7.29496707628474],
            [4.683100957953186, -7.293770700389871],
            [4.6884600096982325, -7.294833695290251],
            [4.692721603523616, -7.293910659539774],
            [4.696828489397145, -7.289641753731955],
            [4.697451735620512, -7.2854720141999945],
            [4.700872956551983, -7.281703968362641],
            [4.709737957599961, -7.282045689328625],
            [4.71375866978657, -7.290587244135062],
            [4.717422042590837, -7.291613224809934],
            [4.7273101499903065, -7.290865786757314],
            [4.7270928279270485, -7.284012062171019],
            [4.730559154099895, -7.278988091965164],
            [4.811187763301041, -7.274316515433846],
            [4.9107819655344285, -7.268433131656675],
            [4.9549844207099545, -7.265914488650556],
            [4.97581127422476, -7.264967080754363],
            [5.027627599001307, -7.262241715867785]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.8044333830359, "lat": 31.17442646499197 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28005"],
        "coty_name": ["Amite"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Amite County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "00695727"
      },
      "bbox": [
        4.636489115041845, -7.629864179954288, 5.120528299316876,
        -7.257889422347681
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.589252384634566, -4.013350996746113],
            [5.632361120985466, -4.010400282830834],
            [5.666419021701859, -4.007436695426163],
            [5.747113802420297, -4.002272751868834],
            [5.788710715353863, -4.0001914586204235],
            [5.7890534613290585, -4.0052364794244815],
            [5.791738896894367, -4.00735366602279],
            [5.796006712488635, -4.007500254511769],
            [5.799110584422936, -4.012874702053054],
            [5.802932780735767, -4.014781348693208],
            [5.807313594823996, -4.020594846109399],
            [5.813548763802011, -4.022205912476605],
            [5.817641324107061, -4.021203182896566],
            [5.820549064614574, -4.028812964532075],
            [5.825601687677452, -4.031879579746371],
            [5.833679903173327, -4.032262092425753],
            [5.841274574351535, -4.028647103190588],
            [5.847333982520067, -4.028133655225243],
            [5.84787370106713, -4.02434426673356],
            [5.8622103125675595, -4.025135511623636],
            [5.864410515590715, -4.028156978407055],
            [5.870880128915905, -4.029841001169374],
            [5.874655205884886, -4.027953133466203],
            [5.878257972025239, -4.029677925195316],
            [5.882593891491968, -4.026232394301471],
            [5.880120062017741, -4.022321168274213],
            [5.886499926656292, -4.022818599675204],
            [5.890363910442557, -4.021879369061481],
            [5.891169737000971, -4.025118538886405],
            [5.896371151741649, -4.025010994704055],
            [5.89706167137427, -4.021477684907304],
            [5.904571934850278, -4.023505523628987],
            [5.908108644332097, -4.02161952865832],
            [5.919829340195603, -4.025139096491904],
            [5.920772871923872, -4.022337781871441],
            [5.926718614977254, -4.0273475834092185],
            [5.933781890918765, -4.028569379625518],
            [5.937577956413413, -4.026901694286413],
            [5.941290720206486, -4.02811890874492],
            [5.9437901826544595, -4.032677794736321],
            [5.946867393401082, -4.035176544013624],
            [5.955629919643808, -4.037805781971709],
            [5.960944008314319, -4.035690939175569],
            [5.965229563795744, -4.036871551300031],
            [5.970477820835414, -4.0439145036390105],
            [5.980750279921401, -4.0456435939414],
            [5.988904988273805, -4.162282964364114],
            [5.992104700756294, -4.2079220916338995],
            [6.000132490012548, -4.314702973476103],
            [6.005215148236769, -4.380941948697632],
            [6.001469983936934, -4.381372891795918],
            [5.861552217342231, -4.390331340950874],
            [5.788693373340714, -4.395106296933435],
            [5.786959828561747, -4.366139600675851],
            [5.761357010664919, -4.367886482872316],
            [5.695577327922703, -4.37195137254094],
            [5.678897371399599, -4.372666680129676],
            [5.613559685810807, -4.376175465062891],
            [5.6052428067861255, -4.2301809228372065],
            [5.603790570983155, -4.225963116652105],
            [5.600585584306256, -4.185358144607745],
            [5.5999860555288175, -4.1741801991025795],
            [5.597328696695198, -4.145839993464263],
            [5.59645595214367, -4.117018466630857],
            [5.589252384634566, -4.013350996746113]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.48497175594656, "lat": 34.35671440977309 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28071"],
        "coty_name": ["Lafayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lafayette County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00695759"
      },
      "bbox": [
        5.589252384634566, -4.395106296933435, 6.005215148236769,
        -4.0001914586204235
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.064477222670851, -5.27818579166132],
            [5.0596270961566265, -5.188910027516656],
            [5.059447904865849, -5.188360971962129],
            [5.056221592119396, -5.128106302940662],
            [5.051940914445344, -5.058091788182555],
            [5.050600098591898, -5.024511614730248],
            [5.049296947281139, -5.009754559885979],
            [5.04437423658867, -4.913100950357619],
            [5.043728455460342, -4.898452936361887],
            [5.0421473340822915, -4.884147333333721],
            [5.0400402351019205, -4.8473876890783565],
            [5.038413298106862, -4.810852895073623],
            [5.037479787967382, -4.7954997004454745],
            [5.107572561368492, -4.791938253721739],
            [5.118863088970783, -4.7917776118523605],
            [5.166668579467256, -4.789588880821535],
            [5.172845541014584, -4.788922039092535],
            [5.2010512542766, -4.78732406622589],
            [5.206142966067254, -4.786668759436473],
            [5.259257751007467, -4.784705087387202],
            [5.2617882678906645, -4.788279710447989],
            [5.260432170703475, -4.794232861103042],
            [5.263759071959191, -4.7985884000108525],
            [5.267185841020484, -4.800520000473052],
            [5.269846808958672, -4.805836159796084],
            [5.267841265895965, -4.8089738411196095],
            [5.2671926826144535, -4.815758424928009],
            [5.262204279431435, -4.8249248830898335],
            [5.259348764203519, -4.828399640097962],
            [5.244394439440316, -4.835412832153958],
            [5.231609968899402, -4.835576185134228],
            [5.225036291038595, -4.836755086995012],
            [5.219651235041008, -4.830834640329135],
            [5.216890471971739, -4.834593565160138],
            [5.213269828823678, -4.833617891227572],
            [5.206370521912234, -4.833995394054364],
            [5.193807760294832, -4.839696838969396],
            [5.184557021237103, -4.842940851691567],
            [5.177077815018926, -4.847117169238845],
            [5.170514820942789, -4.848384260734443],
            [5.163474810379787, -4.854763991192903],
            [5.1583352816515875, -4.865299545183689],
            [5.156085059692096, -4.874619401380018],
            [5.158373518972206, -4.880307075405628],
            [5.15839946683255, -4.883971169933924],
            [5.165349651929929, -4.893766501087848],
            [5.168172926559525, -4.900593922547255],
            [5.174120631339218, -4.901755015303169],
            [5.179256013200836, -4.904260257986024],
            [5.185503714562217, -4.9047078271991955],
            [5.194704748589151, -4.900997123383702],
            [5.200187766651204, -4.894569530978962],
            [5.200547760708996, -4.891447234358889],
            [5.204267923993716, -4.8831225146246435],
            [5.2061665905311685, -4.873820395330904],
            [5.206512297862612, -4.866998654849049],
            [5.208185946087209, -4.863846070394257],
            [5.216586772411894, -4.859422236280642],
            [5.225585753819583, -4.86390807656591],
            [5.231346479991227, -4.870141791459087],
            [5.233305123858879, -4.873616533812746],
            [5.281829924417244, -4.871207773644766],
            [5.302281147313269, -4.869878369811468],
            [5.304872349162935, -4.914667096274823],
            [5.312488167368542, -4.914185993894976],
            [5.317192082850198, -4.917160483573738],
            [5.321658637244714, -4.928784613680481],
            [5.332058320903491, -4.927777902174768],
            [5.332810188299352, -4.93349018352749],
            [5.335148293563833, -4.937455411244358],
            [5.335213542012583, -4.942923509571974],
            [5.333738430888632, -4.950838309044056],
            [5.3308890138188545, -4.956722723218555],
            [5.331043143110705, -4.960752483285964],
            [5.3353388928540255, -4.972644613803829],
            [5.335047284584498, -4.9777482452722746],
            [5.3332638829805274, -4.983924167318463],
            [5.326275766707918, -4.981008577482232],
            [5.325968366211889, -4.986588465497079],
            [5.319345619538362, -4.983337101642229],
            [5.314986584295174, -4.987500965797434],
            [5.3383240446714915, -4.986143269707015],
            [5.339837181526794, -5.008569028404513],
            [5.340834139766739, -5.031224361541409],
            [5.343048192487072, -5.054063250128109],
            [5.344801266333885, -5.0883345049765945],
            [5.347854798538543, -5.131133425416721],
            [5.31790063704098, -5.132806829046933],
            [5.320377082980124, -5.175515554078817],
            [5.304036890399609, -5.1758296690305725],
            [5.289778920221965, -5.176841006576381],
            [5.295053648975295, -5.260522459091434],
            [5.237257631379562, -5.2445018543170026],
            [5.174314816373292, -5.227211870529986],
            [5.170859665780572, -5.2260889107675395],
            [5.170250741266991, -5.2310166889464655],
            [5.1715868204872795, -5.235538278069122],
            [5.174447316736775, -5.238015413367499],
            [5.17846549234547, -5.23861046324642],
            [5.1806356905441024, -5.2368066422084505],
            [5.193592493840685, -5.23812746618492],
            [5.200811618759754, -5.243524649008946],
            [5.20515773935013, -5.251317217028388],
            [5.207695459569403, -5.259654844739914],
            [5.206891074453237, -5.26380987168858],
            [5.200203806474466, -5.271587512318003],
            [5.198493110831821, -5.2760687253735865],
            [5.198942296241477, -5.280767011409941],
            [5.203711200714705, -5.285363121890903],
            [5.201161674216048, -5.287966292519227],
            [5.196493379305967, -5.285064273097616],
            [5.193630808493605, -5.286285984436869],
            [5.190921692680253, -5.290289230765794],
            [5.187533867584783, -5.289160006684535],
            [5.189229408659284, -5.285280706433092],
            [5.186775181936619, -5.28141024340157],
            [5.1833246119009075, -5.280308683660737],
            [5.177495277886794, -5.283716353723902],
            [5.180379205460079, -5.2895950319563845],
            [5.178485065476584, -5.291701380509423],
            [5.173196002315949, -5.289471745954925],
            [5.170183230593923, -5.290248601146389],
            [5.168601272375117, -5.297854303601121],
            [5.166855553256567, -5.298935212165516],
            [5.1639882146257525, -5.295109886876274],
            [5.159051231989988, -5.292783102148438],
            [5.1563725408845, -5.293295554386115],
            [5.154578090753221, -5.29856763730462],
            [5.1488083522074195, -5.3046565339185205],
            [5.146147193064726, -5.305929727124617],
            [5.145467001558224, -5.3099595331077225],
            [5.142600747254168, -5.315677017348926],
            [5.144856528361647, -5.321710977327158],
            [5.1422682662505705, -5.3269237851760485],
            [5.137989422690371, -5.3225085303704125],
            [5.132819234621344, -5.321935168213117],
            [5.134185378196614, -5.330309101803194],
            [5.136955555787283, -5.333167876763347],
            [5.13646753038793, -5.337923888642275],
            [5.13962625091927, -5.341348970311522],
            [5.136937658009187, -5.345790042697488],
            [5.136691326511845, -5.352832839932139],
            [5.134167753625529, -5.3575259433699935],
            [5.139723484853283, -5.357477115367288],
            [5.140679057383389, -5.359420662143796],
            [5.135683512858968, -5.365415293593246],
            [5.128587504416509, -5.359863949358121],
            [5.118941412010374, -5.359328322589297],
            [5.104602315898564, -5.36056069210175],
            [5.104630845010875, -5.3659694306299155],
            [5.103183368461134, -5.370473676889563],
            [5.067657522646002, -5.340438231234277],
            [5.064652393987896, -5.279343481963891],
            [5.064477222670851, -5.27818579166132]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.3010878461091, "lat": 33.550534651113416 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28083"],
        "coty_name": ["Leflore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leflore County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00695765"
      },
      "bbox": [
        5.037479787967382, -5.370473676889563, 5.347854798538543,
        -4.784705087387202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.557483665342933, -3.5708315920474405],
            [5.622537635230394, -3.566429618902783],
            [5.730274303305297, -3.5596943438108557],
            [5.749984265769624, -3.559133673403552],
            [5.792091456615612, -3.556460664433564],
            [5.858732677163797, -3.55145797464716],
            [5.864006054371379, -3.6286512134967683],
            [5.867936745886733, -3.685170844067583],
            [5.86926206922486, -3.701749590468062],
            [5.912679329108287, -3.6987192910673268],
            [5.9209996431686, -3.812510372586682],
            [5.922004878419401, -3.8240109551379065],
            [5.925552092577055, -3.8732225754106158],
            [5.9279578650649745, -3.903255539420618],
            [5.931979896586256, -3.9610845461385598],
            [5.974877443146156, -3.957739507284998],
            [5.980750279921401, -4.0456435939414],
            [5.970477820835414, -4.0439145036390105],
            [5.965229563795744, -4.036871551300031],
            [5.960944008314319, -4.035690939175569],
            [5.955629919643808, -4.037805781971709],
            [5.946867393401082, -4.035176544013624],
            [5.9437901826544595, -4.032677794736321],
            [5.941290720206486, -4.02811890874492],
            [5.937577956413413, -4.026901694286413],
            [5.933781890918765, -4.028569379625518],
            [5.926718614977254, -4.0273475834092185],
            [5.920772871923872, -4.022337781871441],
            [5.919829340195603, -4.025139096491904],
            [5.908108644332097, -4.02161952865832],
            [5.904571934850278, -4.023505523628987],
            [5.89706167137427, -4.021477684907304],
            [5.896371151741649, -4.025010994704055],
            [5.891169737000971, -4.025118538886405],
            [5.890363910442557, -4.021879369061481],
            [5.886499926656292, -4.022818599675204],
            [5.880120062017741, -4.022321168274213],
            [5.882593891491968, -4.026232394301471],
            [5.878257972025239, -4.029677925195316],
            [5.874655205884886, -4.027953133466203],
            [5.870880128915905, -4.029841001169374],
            [5.864410515590715, -4.028156978407055],
            [5.8622103125675595, -4.025135511623636],
            [5.84787370106713, -4.02434426673356],
            [5.847333982520067, -4.028133655225243],
            [5.841274574351535, -4.028647103190588],
            [5.833679903173327, -4.032262092425753],
            [5.825601687677452, -4.031879579746371],
            [5.820549064614574, -4.028812964532075],
            [5.817641324107061, -4.021203182896566],
            [5.813548763802011, -4.022205912476605],
            [5.807313594823996, -4.020594846109399],
            [5.802932780735767, -4.014781348693208],
            [5.799110584422936, -4.012874702053054],
            [5.796006712488635, -4.007500254511769],
            [5.791738896894367, -4.00735366602279],
            [5.7890534613290585, -4.0052364794244815],
            [5.788710715353863, -4.0001914586204235],
            [5.747113802420297, -4.002272751868834],
            [5.666419021701859, -4.007436695426163],
            [5.632361120985466, -4.010400282830834],
            [5.625964956582842, -3.9243095391663196],
            [5.622955564818359, -3.878738752739495],
            [5.5797111384385625, -3.88169854639531],
            [5.575651752721845, -3.832147705563062],
            [5.573032590761989, -3.7946160951583807],
            [5.568717084798805, -3.7356703745275013],
            [5.565644690646102, -3.688225038607434],
            [5.562229315779736, -3.6386887317158076],
            [5.560401381168214, -3.61636321745105],
            [5.559205612251936, -3.5951076496504646],
            [5.557483665342933, -3.5708315920474405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.50301810151848, "lat": 34.76220942882503 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28093"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00695770"
      },
      "bbox": [
        5.557483665342933, -4.0456435939414, 5.980750279921401,
        -3.55145797464716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.044071866275937, -4.17881981042198],
            [5.090120306319231, -4.175506606132565],
            [5.123792272206623, -4.173344027937381],
            [5.12096207647856, -4.13033355944096],
            [5.118482233105578, -4.116976535530335],
            [5.1166416225107705, -4.088080032886545],
            [5.160342271209247, -4.084961785063156],
            [5.162838575369718, -4.084521819945371],
            [5.202859358514592, -4.081394335762027],
            [5.206015439387489, -4.123435272160477],
            [5.206308317512578, -4.123949287078369],
            [5.209596689994408, -4.166889677064861],
            [5.210965352159611, -4.198395965477953],
            [5.21292905411344, -4.229938232240592],
            [5.214101913510672, -4.252781410266129],
            [5.217551088560519, -4.252547919721987],
            [5.219393176376228, -4.2915743139188285],
            [5.269938502574744, -4.323914550492915],
            [5.270379407028364, -4.324493541026667],
            [5.27221107832138, -4.356756438901005],
            [5.276140033320301, -4.4303898326303015],
            [5.281360864111928, -4.517812502822374],
            [5.239350370655957, -4.52029591547317],
            [5.210004020382994, -4.522863887781087],
            [5.194945008536533, -4.522832116357973],
            [5.161907081809849, -4.524907732474605],
            [5.155189506091325, -4.52554734991063],
            [5.11052457919101, -4.528341825793215],
            [5.1033435049429965, -4.528572795585666],
            [5.022649207714024, -4.533284223943116],
            [5.018129384256977, -4.452293990581731],
            [5.01456204550036, -4.387605451250052],
            [5.011842601706953, -4.343222981245],
            [5.025573801401862, -4.343266028778865],
            [5.054101016719249, -4.341632275744956],
            [5.050578099234336, -4.282880659123104],
            [5.049085812685386, -4.26807492731996],
            [5.045126562539408, -4.195347190099709],
            [5.045753927544003, -4.179927314973611],
            [5.044071866275937, -4.17881981042198]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.28909113622053, "lat": 34.25140808767288 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28119"],
        "coty_name": ["Quitman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Quitman County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00695780"
      },
      "bbox": [
        5.011842601706953, -4.533284223943116, 5.281360864111928,
        -4.081394335762027
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.241672309719918, 11.163070037608069],
            [-10.209169263384062, 11.15760910576865],
            [-10.117614228679509, 11.141929917833568],
            [-10.115599255453182, 11.141938867176846],
            [-10.0195918722572, 11.125163908483936],
            [-9.95907508711361, 11.114785752165774],
            [-9.873669281367565, 11.100552725020343],
            [-9.788268037684857, 11.086293610330246],
            [-9.712535847277394, 11.074297903785139],
            [-9.636806887940693, 11.062281735295489],
            [-9.650010135041661, 10.982708407809028],
            [-9.652209809670461, 10.983058395928026],
            [-9.657343100521864, 10.952066547109839],
            [-9.67968998512604, 10.816701007869707],
            [-9.685452852742268, 10.781958740964535],
            [-9.707278001929446, 10.649815786447924],
            [-9.708670492258289, 10.650036647213899],
            [-9.724184451989226, 10.555906129105127],
            [-9.744022945906503, 10.434891094817692],
            [-9.763493291849597, 10.31659787230315],
            [-9.852233059044156, 10.330825117308207],
            [-9.936823214035089, 10.344288032366077],
            [-9.93964662132795, 10.344942815136083],
            [-10.022461368204388, 10.358454382173019],
            [-10.001450329537754, 10.483320330108608],
            [-10.087503684584107, 10.4978058539589],
            [-10.080451731018856, 10.539358779425024],
            [-10.166395375487431, 10.553472681471364],
            [-10.16622643665031, 10.554454538894008],
            [-10.209186275580791, 10.561890445985581],
            [-10.201881131181, 10.604383650462648],
            [-10.20782684938575, 10.60898313399574],
            [-10.212682344748918, 10.60946085474269],
            [-10.210322860375843, 10.61650345667903],
            [-10.216776214215836, 10.616966351176863],
            [-10.218212830312691, 10.611862996464573],
            [-10.222692293657978, 10.612266777889866],
            [-10.223449016019135, 10.615691987046214],
            [-10.218440531451622, 10.618027341107377],
            [-10.222644788751365, 10.621481301120355],
            [-10.229038640535562, 10.617615468344232],
            [-10.230032271762127, 10.622161121739314],
            [-10.233906848285748, 10.623878878330611],
            [-10.236878579374341, 10.620267811418213],
            [-10.24411823071908, 10.61992654604273],
            [-10.248672208951199, 10.6148180780326],
            [-10.251056764955814, 10.619172297708209],
            [-10.255185969571096, 10.618759595719741],
            [-10.254693363825744, 10.613584455867898],
            [-10.259646943657634, 10.610918408685164],
            [-10.261666960589663, 10.613730363367564],
            [-10.262117124396008, 10.618763309492596],
            [-10.269807028505173, 10.617834075791153],
            [-10.27273888521445, 10.620953611019697],
            [-10.270293695035617, 10.623848471675737],
            [-10.271635686857241, 10.627336377328591],
            [-10.276355555733799, 10.628576108676302],
            [-10.279189690560024, 10.62622473571178],
            [-10.281685260058508, 10.62979147582196],
            [-10.281638376334705, 10.63520364670235],
            [-10.286121444872869, 10.63562651266041],
            [-10.286244976613828, 10.64023712823164],
            [-10.291472683675728, 10.647355483405278],
            [-10.295407915836313, 10.648433042391627],
            [-10.3027218749283, 10.653739392029216],
            [-10.304982885370428, 10.647372394444556],
            [-10.309090668202272, 10.64714738051098],
            [-10.31832411515263, 10.652365072139114],
            [-10.319849874773668, 10.66240624331005],
            [-10.323375978788185, 10.663315864429919],
            [-10.308338696346457, 10.74847950861289],
            [-10.311313484765764, 10.74898902835858],
            [-10.296775941019751, 10.832150530446055],
            [-10.25301376031977, 11.081476565438573],
            [-10.255752238678582, 11.081972309021404],
            [-10.241672309719918, 11.163070037608069]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -111.6956254177724, "lat": 48.65540759247087 },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30101"],
        "coty_name": ["Toole"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Toole County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01719566"
      },
      "bbox": [
        -10.323375978788185, 10.31659787230315, -9.636806887940693,
        11.163070037608069
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.232044386295385, 3.260453580088288],
            [-1.175724799928432, 3.2594507413097684],
            [-1.0616595716365682, 3.2568262686118574],
            [-0.947967161033659, 3.255331836968485],
            [-0.8905501724990922, 3.254386589260797],
            [-0.8924608124717162, 3.1376866391707887],
            [-0.8931574151120416, 3.0793388334315206],
            [-0.8918622465114399, 3.079317934967707],
            [-0.8929709024480981, 3.0324104520168462],
            [-0.8940769265224401, 2.9922631988309853],
            [-0.8953566978452331, 2.9192420398318055],
            [-0.8955743648458606, 2.861933883921358],
            [-0.9026122825687518, 2.8622115217192996],
            [-0.9369121753638113, 2.8624329022490893],
            [-0.9378872684606158, 2.8478793013853396],
            [-0.9810952027268621, 2.8485508258592462],
            [-1.0246158165542933, 2.848857685377637],
            [-1.0529908927255827, 2.8493912983881367],
            [-1.0534037941122358, 2.8347558340897274],
            [-1.0967642541737408, 2.8350964205390334],
            [-1.0968859259771715, 2.820387695736267],
            [-1.1541168048196855, 2.8214663657023125],
            [-1.2183265967146648, 2.8233621331116727],
            [-1.2394458391328584, 2.8236269700620045],
            [-1.2391740065875418, 2.838181453681823],
            [-1.2365768798845773, 2.939965512410307],
            [-1.2347754165955684, 3.0071737529864824],
            [-1.2328217781449495, 3.085666595703845],
            [-1.236389101491184, 3.0857203634046524],
            [-1.2343809715022056, 3.1731196542105806],
            [-1.232044386295385, 3.260453580088288]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.06725273245465,
          "lat": 41.706811888980084
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31011"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00835828"
      },
      "bbox": [
        -1.2394458391328584, 2.820387695736267, -0.8905501724990922,
        3.260453580088288
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.683829148070835, 3.1341494926882016],
            [-2.6797261273441766, 3.134221004195477],
            [-2.575855707949865, 3.128590240179898],
            [-2.5012088837975095, 3.1251939546513587],
            [-2.498269576874521, 3.1254055766840607],
            [-2.4704314318712606, 3.1247076042288358],
            [-2.427591610397321, 3.123064953985711],
            [-2.357360335209524, 3.120574593836672],
            [-2.313183378019239, 3.1192611779394785],
            [-2.266165495631819, 3.1172361202026737],
            [-2.170825986120919, 3.1140338744204237],
            [-2.0388150767368884, 3.1099817801178506],
            [-1.9916842153341539, 3.1080797731567977],
            [-1.9673256452056802, 3.1074091767527174],
            [-1.921980135973512, 3.105208834414214],
            [-1.9147218702706048, 3.1047832555340755],
            [-1.9173052594560682, 3.0323795073743542],
            [-1.9185467503837186, 2.992597505740668],
            [-1.9231647202364646, 2.8643329053757083],
            [-1.9230612980510644, 2.8636758142810064],
            [-1.9268495369064988, 2.7564095333422074],
            [-1.9200061072860368, 2.7560830432354058],
            [-1.9230722757785208, 2.6834429967208093],
            [-1.9240451230618079, 2.645149227240879],
            [-1.9251767508575426, 2.6250860071287923],
            [-1.9288248061145552, 2.540793378325517],
            [-1.9315921177720188, 2.483553886257467],
            [-1.935014808782968, 2.4068018453119713],
            [-2.0060495616283887, 2.409171976621484],
            [-2.0983110466293335, 2.4119614849767625],
            [-2.169443021416137, 2.4143392368101675],
            [-2.27742270073786, 2.4187022758615524],
            [-2.2858181648007503, 2.4188832841208834],
            [-2.353648134656529, 2.4219087092871048],
            [-2.4110680326806264, 2.4241256008390453],
            [-2.4341885143058226, 2.4255461653009815],
            [-2.4958107247753434, 2.427986897145486],
            [-2.5237528898711137, 2.429505468857579],
            [-2.5392391069121087, 2.429584233623978],
            [-2.5626226236277225, 2.430504238127261],
            [-2.619786202132371, 2.4333257401845825],
            [-2.620251899048051, 2.4331876370917636],
            [-2.6949030694174554, 2.436090351776356],
            [-2.705307508433412, 2.4364919190019307],
            [-2.7010024327495303, 2.523421783460207],
            [-2.6996935758345906, 2.5525955848057276],
            [-2.698208437788106, 2.5669568675546763],
            [-2.6920905409136235, 2.6686424452903887],
            [-2.691154381110201, 2.697842069805365],
            [-2.6914572430677564, 2.713580210973754],
            [-2.69055984413126, 2.727916959593715],
            [-2.689175298247301, 2.7706605766344823],
            [-2.688200179811078, 2.7853056562421705],
            [-2.699348954474753, 2.7857769801654997],
            [-2.697310629778755, 2.8473933288100537],
            [-2.6975153444947844, 2.850299289964224],
            [-2.692798300737397, 2.960244022526105],
            [-2.6901850623128105, 3.018659935263852],
            [-2.683829148070835, 3.1341494926882016]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.72615778453992, "lat": 41.39426548987439 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31041"],
        "coty_name": ["Custer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Custer County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00835842"
      },
      "bbox": [
        -2.705307508433412, 2.4068018453119713, -1.9147218702706048,
        3.134221004195477
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.91923514899055, 5.028150946946971],
            [-14.913058538814575, 5.0255141109891985],
            [-14.883997628083016, 5.019903411444217],
            [-14.807117575388395, 5.0023737861913],
            [-14.722381260268776, 4.98321916340998],
            [-14.637647976291905, 4.964050829095016],
            [-14.637135378409369, 4.963557040986793],
            [-14.609025434748029, 4.957379129541589],
            [-14.605523464597471, 4.957088168159065],
            [-14.545044786209996, 4.943458410018657],
            [-14.522757144672598, 4.938133329828769],
            [-14.451783118264759, 4.921975426511769],
            [-14.425815893781039, 4.917378529908844],
            [-14.303992045292413, 4.891400658662102],
            [-14.233353613523978, 4.8761831530517625],
            [-14.219984748009061, 4.872182347881086],
            [-14.143816408854718, 4.856136770638951],
            [-14.09218657125436, 4.8454747031213765],
            [-13.993249597113465, 4.82500593246908],
            [-13.915681194920893, 4.809061191114107],
            [-13.875397193979856, 4.800070546617587],
            [-13.782950785804825, 4.780591259019899],
            [-13.69050772247273, 4.76109580987815],
            [-13.647344990394098, 4.752879855109436],
            [-13.644902095362921, 4.75180093810439],
            [-13.491193354153205, 4.720373952144766],
            [-13.486584581317997, 4.719437143031464],
            [-13.400754365568384, 4.706125686000769],
            [-13.389921050680053, 4.703949126884722],
            [-13.372762727629704, 4.701949054267855],
            [-13.340178504676063, 4.6963304660604095],
            [-13.32239080314261, 4.692379548193095],
            [-13.261114564614005, 4.676487713777388],
            [-13.173224431979156, 4.655258112380211],
            [-13.100808403934991, 4.641080671273838],
            [-13.078423007116074, 4.637599808644719],
            [-12.944129556663693, 4.610086793351392],
            [-12.817851731672297, 4.585437385442725],
            [-12.77007841343745, 4.576176516246913],
            [-12.789476815955162, 4.468387208877647],
            [-12.797072552848467, 4.4348463945105],
            [-12.814565005668276, 4.339174471633488],
            [-12.839109208499528, 4.21203777807266],
            [-12.841265142270704, 4.2026856226024325],
            [-12.863585088278239, 4.088799624167505],
            [-12.864631214677818, 4.080574848952529],
            [-12.917160092315427, 3.8124069395824307],
            [-12.91972655032272, 3.803644727123602],
            [-12.919519194158664, 3.800356979654098],
            [-12.959573582221127, 3.5950859948170337],
            [-12.970777107472497, 3.537926672547639],
            [-13.003760398778065, 3.369638153838723],
            [-13.006719305456466, 3.3568685744266755],
            [-13.012640367871054, 3.3248122737382464],
            [-13.019811883044499, 3.2887281797411037],
            [-13.055774587154618, 3.1077765076036723],
            [-13.058255933993884, 3.095829009202687],
            [-13.070255123877699, 3.032283545883202],
            [-13.071745016776664, 3.0269692927797296],
            [-13.077053471975887, 3.0007917184826356],
            [-13.108709471064282, 2.836191454035291],
            [-13.131010705382673, 2.7224128323091557],
            [-13.245334894075928, 2.7449805081359546],
            [-13.359662318553848, 2.7675314357500636],
            [-13.48990573754841, 2.794464556585527],
            [-13.63231283089888, 2.824694441622016],
            [-13.653821534033483, 2.8293705125008204],
            [-13.653954249261883, 2.8287073706656884],
            [-13.73793742894122, 2.8472898793390655],
            [-13.752561974454508, 2.8491991390257487],
            [-13.839283345141068, 2.868038407290194],
            [-13.845172191029668, 2.8687388616362415],
            [-13.927907372860819, 2.8858119151767854],
            [-13.932202528721001, 2.8864420621507616],
            [-14.021265574173126, 2.904677534217954],
            [-14.207905041650044, 2.948060800576956],
            [-14.209386651024708, 2.9492446552487106],
            [-14.29960243505346, 2.96848569567066],
            [-14.302120971720022, 2.9685183265102717],
            [-14.412334663737838, 2.99239362595591],
            [-14.423429507186176, 2.994194970324053],
            [-14.457151463233764, 3.001127773523641],
            [-14.554013159305182, 3.0215264328561453],
            [-14.580229155907201, 3.0267887743008837],
            [-14.581315573022941, 3.280825101781686],
            [-14.581040166082404, 3.2819961089392686],
            [-14.581178029436273, 3.3568569858591233],
            [-14.58164652324294, 3.4582582666815163],
            [-14.582357867719498, 3.466994035346112],
            [-14.581729008978074, 3.5673203298367087],
            [-14.582034022119636, 3.5824006024903285],
            [-14.57282312715895, 3.624700011703297],
            [-14.512637593423873, 3.90471398135181],
            [-14.511465672092193, 3.9105623354007575],
            [-14.616429672456295, 3.933363083082182],
            [-14.720633921247838, 3.9562505736890667],
            [-14.824841840615308, 3.9791208325563066],
            [-14.976150368921404, 4.012634644066992],
            [-15.127466682170136, 4.046112064717695],
            [-15.140234290701743, 4.048955559635738],
            [-15.112290868018725, 4.171174029861178],
            [-15.085022221980473, 4.293865611113052],
            [-15.046589538630906, 4.463004961891295],
            [-15.030412553655776, 4.533259733239666],
            [-15.029644309018273, 4.538949599620867],
            [-15.002491150173942, 4.65900407305824],
            [-15.00217552708072, 4.661482040017788],
            [-14.974659084605621, 4.783962843891892],
            [-14.97222537332043, 4.797740179774354],
            [-14.946364250385406, 4.907441917661304],
            [-14.937103686391337, 4.949457430775001],
            [-14.91923514899055, 5.028150946946971]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -115.3577281078068, "lat": 41.14576578117373 },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32007"],
        "coty_name": ["Elko"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elko County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00857664"
      },
      "bbox": [
        -15.140234290701743, 2.7224128323091557, -12.77007841343745,
        5.028150946946971
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.207883526453084, 1.6805994296572255],
            [-16.17186478077354, 1.612482245097876],
            [-16.07460424615873, 1.4251071619379707],
            [-16.04841161332052, 1.3749939819144172],
            [-15.999995052510391, 1.2835088304128284],
            [-15.992527060782848, 1.269687971260124],
            [-15.96386977025159, 1.2149701075773351],
            [-15.958165127790716, 1.2048895201114713],
            [-15.962709733464008, 1.1854366940558172],
            [-15.946081113372214, 1.1819002775769016],
            [-15.916130289100355, 1.1247392615558707],
            [-15.916194572611554, 1.1229329072851655],
            [-15.97214844095011, 0.8767917201191479],
            [-15.973090411298152, 0.8742418703968513],
            [-15.977792163832524, 0.853492247155461],
            [-16.028324100617493, 0.6306892044218707],
            [-16.043403659933176, 0.5612793882978372],
            [-16.146243523610035, 0.11002481658279598],
            [-16.193930303080325, 0.18195114093287762],
            [-16.20693403494016, 0.20009519598105377],
            [-16.273150625501074, 0.30005818291412667],
            [-16.34756271062745, 0.4140335187434233],
            [-16.348193584040075, 0.4140771748620506],
            [-16.372187660692482, 0.4503263709232094],
            [-16.396728219393072, 0.4860480537949266],
            [-16.45587273548098, 0.5769229116511863],
            [-16.47529286641765, 0.6037549761748605],
            [-16.546852902737555, 0.7137501685134714],
            [-16.572466442692253, 0.7532800468470736],
            [-16.590135234360485, 0.7766804670556811],
            [-16.632170401014083, 0.8420056477863587],
            [-16.670455973717914, 0.898701427937257],
            [-16.677627725002367, 0.9104431610419441],
            [-16.70662616687037, 0.9538551986488893],
            [-16.795644527197098, 1.0875599625700407],
            [-16.900150923039803, 1.245064640152401],
            [-16.89259791300177, 1.2435349899994659],
            [-16.890998525628376, 1.2404323381496554],
            [-16.842755113207538, 1.2286696735590075],
            [-16.745412973430664, 1.2981610557190446],
            [-16.7289216125564, 1.311737190217671],
            [-16.62472194801502, 1.384259858332996],
            [-16.621492491668608, 1.3870634853856254],
            [-16.591289977620452, 1.408757614456585],
            [-16.577948487976126, 1.4188324063314333],
            [-16.504313216273108, 1.470417555161474],
            [-16.502022600760377, 1.471767524070885],
            [-16.207883526453084, 1.6805994296572255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -117.63228133532537, "lat": 37.7846167742577 },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32009"],
        "coty_name": ["Esmeralda"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Esmeralda County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00858641"
      },
      "bbox": [
        -16.900150923039803, 0.11002481658279598, -15.916130289100355,
        1.6805994296572255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.201219070403738, 2.300606607185332],
            [-16.129560808917375, 2.304355938174757],
            [-15.95555303579947, 2.300488558144058],
            [-15.78154702089762, 2.296593762947766],
            [-15.665796162988782, 2.270121438930483],
            [-15.543587447866699, 2.242658355302348],
            [-15.346646937496727, 2.1968168754248865],
            [-15.337647979095301, 2.195584985990205],
            [-15.234251602814526, 2.171924003511973],
            [-15.13021292616878, 2.1493570817658605],
            [-14.959654940776495, 2.112391037129233],
            [-14.877706603750656, 2.0946086836453683],
            [-14.784967016484048, 2.074292990094126],
            [-14.783796675243016, 2.0746797118628955],
            [-14.713328278353792, 2.059676780080388],
            [-14.693333374845526, 2.038496101721932],
            [-14.689249558042654, 2.0347916119436835],
            [-14.613059673946452, 1.953672374916912],
            [-14.607933812684125, 1.947447701291901],
            [-14.517240630975984, 1.8513769336432089],
            [-14.51595456246916, 1.8511080244415872],
            [-14.365891657561312, 1.6913188394205456],
            [-14.21584797958238, 1.531488264202367],
            [-14.208153226810825, 1.523183705024267],
            [-14.12903139965285, 1.439036930752514],
            [-14.16459843094441, 1.2635496161181967],
            [-14.24705493717522, 0.8566803097309637],
            [-14.25467843748804, 0.8190604305474742],
            [-14.445629404696474, 0.8580058140265566],
            [-14.447944201590554, 0.8583750007363462],
            [-14.69225307424414, 0.9093632995494689],
            [-14.936569271471559, 0.9603158164963649],
            [-15.00861666464172, 0.6254678479391996],
            [-15.080147725210495, 0.29374237563010536],
            [-15.081078105447784, 0.2868976630866605],
            [-15.099994388025923, 0.19466805738404927],
            [-15.106427063534635, 0.1699755355012948],
            [-15.156360953852708, -0.06633234306973763],
            [-15.186472564912247, -0.21377327650608346],
            [-15.192502563150072, -0.23275590827990741],
            [-15.22474489019462, -0.38903753479391906],
            [-15.246312727542431, -0.49198416083910096],
            [-15.279397963651704, -0.6488118916532547],
            [-15.300583840410674, -0.7475025584458999],
            [-15.332119908183536, -0.8943828288763348],
            [-15.293315851362646, -0.9041242675192318],
            [-15.30904670077681, -0.9783490762303779],
            [-15.336706094338206, -1.1080059662958381],
            [-15.3660720735335, -1.0648896876345646],
            [-15.416960275702136, -0.9883757918547873],
            [-15.490340445217106, -0.8775488353308135],
            [-15.492629514890622, -0.8744346862173669],
            [-15.5544646264341, -0.781327796839766],
            [-15.587457506095861, -0.7315171509333739],
            [-15.664494780487018, -0.6160733336502936],
            [-15.667460629425868, -0.6129554351411057],
            [-15.733366752325097, -0.5116266975720368],
            [-15.741239176505815, -0.5004716377092787],
            [-15.76635152389733, -0.4621727868169373],
            [-15.810872671845628, -0.395500791476891],
            [-15.869390943736642, -0.3076151358634902],
            [-15.978478436227963, -0.14301059714733247],
            [-16.04613676166095, -0.04041047390724319],
            [-16.08624158736432, 0.0189708554934203],
            [-16.125649603797125, 0.07902229313748439],
            [-16.146243523610035, 0.11002481658279598],
            [-16.043403659933176, 0.5612793882978372],
            [-16.028324100617493, 0.6306892044218707],
            [-15.977792163832524, 0.853492247155461],
            [-15.973090411298152, 0.8742418703968513],
            [-15.97214844095011, 0.8767917201191479],
            [-15.916194572611554, 1.1229329072851655],
            [-15.916130289100355, 1.1247392615558707],
            [-15.946081113372214, 1.1819002775769016],
            [-15.962709733464008, 1.1854366940558172],
            [-15.958165127790716, 1.2048895201114713],
            [-15.96386977025159, 1.2149701075773351],
            [-15.992527060782848, 1.269687971260124],
            [-15.999995052510391, 1.2835088304128284],
            [-16.04841161332052, 1.3749939819144172],
            [-16.07460424615873, 1.4251071619379707],
            [-16.17186478077354, 1.612482245097876],
            [-16.207883526453084, 1.6805994296572255],
            [-16.2240137513121, 1.7114208794645127],
            [-16.224699182007207, 1.711580238295117],
            [-16.30704916909954, 1.8683178855585423],
            [-16.389408835401742, 2.0250293767531278],
            [-16.485140733126254, 2.2073182338597057],
            [-16.466274588751734, 2.2866970690089308],
            [-16.40993033741863, 2.289735649163671],
            [-16.40843572176461, 2.289581682818827],
            [-16.201219070403738, 2.300606607185332]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -116.47179736076566,
          "lat": 38.042216284544736
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32023"],
        "coty_name": ["Nye"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nye County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00863599"
      },
      "bbox": [
        -16.485140733126254, -1.1080059662958381, -14.12903139965285,
        2.304355938174757
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.268425693256706, -4.227257759797019],
            [-10.254541094735462, -4.13013808255927],
            [-10.237781221287975, -4.005636678560503],
            [-10.22563865120182, -3.9187727565204287],
            [-10.214554255937534, -3.839469110684387],
            [-10.183878432423443, -3.619951729964119],
            [-10.171214466390543, -3.5293086352425007],
            [-10.157203945374619, -3.4286384161786323],
            [-10.106431025271943, -3.435506430688444],
            [-10.034689356764655, -3.445374200866804],
            [-10.013877026564955, -3.447516661689251],
            [-9.9572235281394, -3.4559735363538375],
            [-9.95036060225398, -3.456620054705179],
            [-9.943275693827376, -3.458461738055179],
            [-9.936184386716397, -3.458517346099515],
            [-9.923271318590386, -3.4606570569957213],
            [-9.623996490216637, -3.5006238728631],
            [-9.609606920369464, -3.5026289266383683],
            [-9.35909151217676, -3.5339409905802603],
            [-9.318837233407145, -3.539618063044064],
            [-9.185997942424056, -3.5566626713968135],
            [-9.17201141407112, -3.5581873300838693],
            [-9.087392685068563, -3.5697587858452082],
            [-9.096419621390872, -3.6298158548042063],
            [-9.100635307223293, -3.672076486309117],
            [-9.104057988701324, -3.7038015551843717],
            [-9.11507808548775, -3.786823940003421],
            [-9.12738380428068, -3.887442587174629],
            [-9.119958419154296, -3.8883274084044164],
            [-9.12154483334351, -3.9012614208007155],
            [-9.173323169508786, -4.32147095600424],
            [-9.169746869357763, -4.3219137127242195],
            [-9.172615057969828, -4.3359929124852625],
            [-9.180933119061894, -4.4087452775594045],
            [-9.214037537714821, -4.669341086372038],
            [-9.227903813877273, -4.667746338509216],
            [-9.241632470424124, -4.66496671018292],
            [-9.255818478973078, -4.664035280062576],
            [-9.400275996901335, -4.648602900880139],
            [-9.423508142620626, -4.6420626799962825],
            [-9.45047490264441, -4.638593756524574],
            [-9.485559810692083, -4.9140507275788385],
            [-9.634737951906244, -4.895203524074933],
            [-9.661427578161115, -4.891914449142321],
            [-9.856073248159039, -4.866560961551398],
            [-9.931949636307461, -4.849523204414059],
            [-10.017175566525824, -4.838428973970965],
            [-10.01697291798312, -4.83682674764468],
            [-10.098906006862867, -4.826205517816705],
            [-10.103812528687598, -4.826756240678045],
            [-10.159016154544512, -4.817953158657622],
            [-10.191280767922514, -4.814113028753001],
            [-10.272420810544505, -4.804153009352641],
            [-10.28657512886212, -4.801293569441999],
            [-10.34700396489143, -4.7925540596340435],
            [-10.341524809952203, -4.751618966931861],
            [-10.32512420289199, -4.637183981957351],
            [-10.32355958837059, -4.627483661363779],
            [-10.319378453699798, -4.592881083585155],
            [-10.289192281391495, -4.378871973748453],
            [-10.273743632029213, -4.264450246407879],
            [-10.268425693256706, -4.227257759797019]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.40459018475639,
          "lat": 33.91520940364856
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35003"],
        "coty_name": ["Catron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Catron County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00929108"
      },
      "bbox": [
        -10.34700396489143, -4.9140507275788385, -9.087392685068563,
        -3.4286384161786323
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.822358383519017, -1.011957823660947],
            [-9.751218009274192, -1.0219292058697416],
            [-9.590672354069358, -1.043530342410286],
            [-9.488812416240279, -1.0570922259578133],
            [-9.42350897042423, -1.0657097505154773],
            [-9.300287495806487, -1.081811657769058],
            [-9.19935461445599, -1.0948570412146987],
            [-9.198423776931506, -1.0955334649141495],
            [-9.149218505211099, -1.1016398579020954],
            [-9.003153533422367, -1.1195724909484932],
            [-8.907039978496298, -1.1317069974264224],
            [-8.776953644506646, -1.1479302370676179],
            [-8.689128420237209, -1.1587527747599464],
            [-8.595859677603729, -1.1701312034340023],
            [-8.548098635966415, -1.1759120622682342],
            [-8.550228109445177, -1.1796703686029],
            [-8.554315617984406, -1.1819526357163428],
            [-8.555124773464174, -1.1865383589075837],
            [-8.558029666714704, -1.1885982797045236],
            [-8.557540651644786, -1.201246540456128],
            [-8.559345099902902, -1.2049524001859164],
            [-8.565129623483184, -1.2059238960970198],
            [-8.573097186281815, -1.2087814312780143],
            [-8.573767153734094, -1.2122612872280283],
            [-8.580400687829759, -1.215258210154187],
            [-8.581898872740707, -1.2194318797588186],
            [-8.579169074335702, -1.2252705506800279],
            [-8.576365620419809, -1.2285291493859565],
            [-8.58283476282951, -1.2332246637864563],
            [-8.583269549779448, -1.2416848144382293],
            [-8.581502909966188, -1.2519955951283432],
            [-8.577822552092726, -1.2583780383737704],
            [-8.581971633082137, -1.2623478253944636],
            [-8.583720486531655, -1.269187603742293],
            [-8.587416980716464, -1.2713969632611963],
            [-8.58878586916459, -1.2746354240393147],
            [-8.592083264873786, -1.2746478336862306],
            [-8.59971908886705, -1.277656428380402],
            [-8.604910847282687, -1.2769972938116065],
            [-8.611959434527424, -1.2845245765339155],
            [-8.616495827606176, -1.2868208590987265],
            [-8.619390144264008, -1.2925580529631018],
            [-8.62258654235327, -1.2923018697168742],
            [-8.625098622709915, -1.286924560152302],
            [-8.628075172299107, -1.2866012902554902],
            [-8.629200225961146, -1.292922445262005],
            [-8.631064704479249, -1.2929620924996172],
            [-8.637470652086964, -1.288663274923421],
            [-8.643402415492124, -1.2909895334655956],
            [-8.648259450625256, -1.2980161569802842],
            [-8.651042324084294, -1.30482557466518],
            [-8.651430051863759, -1.3114814754972361],
            [-8.658511747588173, -1.3092045805767494],
            [-8.661956437164713, -1.3139368431008738],
            [-8.665866754424172, -1.3148354630455352],
            [-8.670664510009534, -1.3104953113432056],
            [-8.67167815508702, -1.3062266372126123],
            [-8.676297687434054, -1.3070238168642552],
            [-8.680264777792212, -1.3104488740276834],
            [-8.680650116835803, -1.3164187838218404],
            [-8.684325436145471, -1.3196078377462257],
            [-8.68890686923362, -1.3200327555194358],
            [-8.693213451102922, -1.325932565754321],
            [-8.700527694746144, -1.322930795583912],
            [-8.707494773890383, -1.325018896293898],
            [-8.709906438217626, -1.3288763540600617],
            [-8.708860549905344, -1.3336001243332685],
            [-8.71178434375927, -1.3382571005001431],
            [-8.711265671186002, -1.343893471380078],
            [-8.707184232149137, -1.343769449361371],
            [-8.7051720932592, -1.346650870863622],
            [-8.707557408696246, -1.3494377618546418],
            [-8.717065294354732, -1.3476464099659007],
            [-8.71862524544345, -1.3522701646401905],
            [-8.71577698911946, -1.3586377494549606],
            [-8.717882295133245, -1.3606217956064837],
            [-8.7243347888533, -1.3574604492164153],
            [-8.727084666887821, -1.353158751905631],
            [-8.743906593857066, -1.4821892770497356],
            [-8.747086255442861, -1.4818027343762954],
            [-8.754974848872303, -1.5464904303822213],
            [-8.760191606748252, -1.5765805188397803],
            [-8.765645416809186, -1.6188424627679605],
            [-8.778991424110426, -1.720923116068242],
            [-8.781955818414621, -1.764221186722608],
            [-8.789172142209466, -1.8075225723375707],
            [-8.79667848590816, -1.8796514164159452],
            [-8.80387035323113, -1.937938550157841],
            [-8.814965474310794, -2.0254087946307093],
            [-8.821530888870457, -2.0692564357491925],
            [-8.832674344848705, -2.157493817827975],
            [-8.975026188453965, -2.138891364936168],
            [-9.035395546280013, -2.130897597213775],
            [-9.131300695033987, -2.118233826472674],
            [-9.261115142883552, -2.1010305636072006],
            [-9.290452903196014, -2.097606336941216],
            [-9.34557569115901, -2.0907866343423454],
            [-9.426804771865017, -2.0799980236047437],
            [-9.653335831784966, -2.049638911785774],
            [-9.786822878143953, -2.0316651132558063],
            [-9.89192801098703, -2.0173612755200394],
            [-9.954391282648594, -2.0091080302995663],
            [-9.960578936348764, -2.007911671977885],
            [-9.944596999624972, -1.8936998524233786],
            [-9.936017786782543, -1.828970656370649],
            [-9.915414173091197, -1.6819113829585886],
            [-9.902223761731115, -1.5877541251550327],
            [-9.887338230325641, -1.4810814449120027],
            [-9.854292096483833, -1.2418952602492161],
            [-9.839722017547011, -1.1364306847160826],
            [-9.822358383519017, -1.011957823660947]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -108.32063364440762,
          "lat": 36.50851007307321
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35045"],
        "coty_name": ["San Juan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["San Juan County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00936844"
      },
      "bbox": [
        -9.960578936348764, -2.157493817827975, -8.548098635966415,
        -1.011957823660947
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.709995669717824, 3.687383187720213],
            [16.711352476338288, 3.6938516094329374],
            [16.715863393444224, 3.6996672499973027],
            [16.716336135053506, 3.702547266764692],
            [16.714850542294208, 3.712650598347466],
            [16.70761750768484, 3.723499099375544],
            [16.719209972210525, 3.7386072385764826],
            [16.726264564852297, 3.7393838591526887],
            [16.730542731538634, 3.7431137525919604],
            [16.730437731578494, 3.7717737433932417],
            [16.72918325029796, 3.7759992997252323],
            [16.73272027667016, 3.7847828357103315],
            [16.73266211499832, 3.789698373155889],
            [16.728862536841692, 3.803657903782996],
            [16.72390813339259, 3.8059535587251094],
            [16.722072556851053, 3.81786702602754],
            [16.72893128790248, 3.831028010062331],
            [16.733019837328612, 3.834061599074756],
            [16.7360757858426, 3.832607934426095],
            [16.738331257264644, 3.8352805827215763],
            [16.749090789544333, 3.8316485278153327],
            [16.75458904722435, 3.831374336417132],
            [16.762844818410706, 3.835663016603352],
            [16.768099817714504, 3.8396060862657873],
            [16.7736980822723, 3.8386270674944556],
            [16.787443772625263, 3.8480695901450135],
            [16.79691734983534, 3.850471955008126],
            [16.801703301403677, 3.8541965966330682],
            [16.80725296376612, 3.855052085395391],
            [16.81401039756257, 3.851122539653986],
            [16.813650530240356, 3.84581040897287],
            [16.818077236204633, 3.832640454573129],
            [16.82542747170856, 3.826965427764402],
            [16.836502604650892, 3.815911613236037],
            [16.837151305104797, 3.81174415873266],
            [16.83322277788688, 3.804156159715931],
            [16.825571138508245, 3.787111448981686],
            [16.816310150846938, 3.771764135978125],
            [16.809826973544034, 3.7587983411337134],
            [16.8075291603886, 3.7580218068429025],
            [16.805466553207204, 3.751057908423669],
            [16.80296289359647, 3.7504484686648834],
            [16.799302559302124, 3.7450817107546093],
            [16.793065225362064, 3.7299881451835306],
            [16.788816337300226, 3.7319624337133055],
            [16.792400463239936, 3.734772513016662],
            [16.795927938770937, 3.741837312541056],
            [16.793973719590984, 3.745679190359909],
            [16.789185915367728, 3.74558778377726],
            [16.785658244029584, 3.7400699942249327],
            [16.786516631493278, 3.735577001231957],
            [16.782372513712446, 3.73171017042313],
            [16.777564752112454, 3.724896418677003],
            [16.76746614583425, 3.716581912107884],
            [16.764302898831957, 3.7121038480817568],
            [16.759555900885275, 3.7108480079761748],
            [16.75413290425644, 3.6999513496004854],
            [16.749040767310007, 3.701934262228362],
            [16.74348433693979, 3.698836113560371],
            [16.737523092845187, 3.688290466788084],
            [16.727946299855883, 3.6847140018441378],
            [16.719263274969027, 3.6773237853198655],
            [16.716556356717774, 3.6773147271775475],
            [16.712044733575997, 3.682054536217237],
            [16.709995669717824, 3.687383187720213]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.15306272124613, "lat": 40.58071879671016 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36085"],
        "coty_name": ["Richmond"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Richmond County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00974141"
      },
      "bbox": [
        16.70761750768484, 3.6773147271775475, 16.837151305104797,
        3.855052085395391
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.38269471632983, -1.2653736048551643],
            [14.382406686123968, -1.2608501820958775],
            [14.38408046741789, -1.2561389207153346],
            [14.391084558297292, -1.2595148015755762],
            [14.391215330924496, -1.2636282535754013],
            [14.400986977034428, -1.2646511808070573],
            [14.4065191302927, -1.263626554498702],
            [14.41190987699963, -1.2652999938744305],
            [14.41286615786751, -1.2692451553827058],
            [14.415495406461467, -1.2711031736707736],
            [14.41752081382612, -1.2662729395634493],
            [14.420704046134023, -1.26455860705258],
            [14.427975512938755, -1.2645236522505028],
            [14.436380678515597, -1.2661896653225289],
            [14.441385287563515, -1.2662476769263378],
            [14.442560267232365, -1.2617684912232272],
            [14.450178823938659, -1.2585259765907832],
            [14.46468900515416, -1.188591070061491],
            [14.496222618959386, -1.1833044933325683],
            [14.4987905198444, -1.1762457232094619],
            [14.51049075126942, -1.1583136991094172],
            [14.514770588469004, -1.147218075469725],
            [14.567887778261344, -1.145360822785302],
            [14.574679215729116, -1.144662253938938],
            [14.576902301700763, -1.1460258908631753],
            [14.58100774546455, -1.1446145318062286],
            [14.588969365892781, -1.1478613630621055],
            [14.593626171982164, -1.1464024597862152],
            [14.603480509139853, -1.1473419974801773],
            [14.606852215629905, -1.1496982509939755],
            [14.610746889453518, -1.1481259272646576],
            [14.622077591374152, -1.138076594581829],
            [14.627817133703573, -1.14097288976425],
            [14.633307421565203, -1.145949067171818],
            [14.636585258438792, -1.1465458999072304],
            [14.644714036207578, -1.1423059528414974],
            [14.647772572930657, -1.1427539334257917],
            [14.65094646359199, -1.1405798028812903],
            [14.655263405902344, -1.1410799473534754],
            [14.657921517186322, -1.1465902074624492],
            [14.661886627265568, -1.1503672986562403],
            [14.664551090535625, -1.1598138362083488],
            [14.671818175451111, -1.162272880927765],
            [14.675486096086571, -1.1681473099816475],
            [14.67801688028005, -1.1674270690474198],
            [14.680106945872028, -1.1734559304616168],
            [14.685579054193607, -1.1735611032489983],
            [14.69194744580462, -1.1711321648086606],
            [14.698047018856705, -1.171612009828808],
            [14.700490688303917, -1.1670436874185663],
            [14.705404748982463, -1.167345255152444],
            [14.709169295929785, -1.1615278929642492],
            [14.713173143038908, -1.1606772742987548],
            [14.72131817116291, -1.1646513733040036],
            [14.730036353784337, -1.1584831738042711],
            [14.73152897964486, -1.1621987598747088],
            [14.737013444280613, -1.162386157550416],
            [14.741099477688255, -1.1648000921425665],
            [14.74238095584172, -1.1606731236384844],
            [14.74704275749869, -1.1613788575734116],
            [14.749657488302867, -1.165024375001363],
            [14.75445911589766, -1.1632451531949766],
            [14.760437241837991, -1.1634350301783611],
            [14.762586580485657, -1.1654379872853693],
            [14.76051389302852, -1.1724542962490632],
            [14.71966815252378, -1.304224842103688],
            [14.699740451768946, -1.3683444107404017],
            [14.674302140334111, -1.4533221938781578],
            [14.649973840814313, -1.5414080626390534],
            [14.63873472371489, -1.5839184244730236],
            [14.637891119817874, -1.5727951689474897],
            [14.634939178599414, -1.5716637583345405],
            [14.626798318594433, -1.5640994367457453],
            [14.62319302985078, -1.5598294046879029],
            [14.62147591454028, -1.5539906039377236],
            [14.617898037715062, -1.547182557393984],
            [14.612124385527325, -1.5384149567460321],
            [14.609461368718993, -1.537674910049472],
            [14.60579698880765, -1.5321722029035694],
            [14.600981290343967, -1.5310071711240132],
            [14.599149294792177, -1.5271587223525955],
            [14.596102651968083, -1.5272882547128215],
            [14.594809193627004, -1.5236688393833737],
            [14.589907459594029, -1.5216221959849738],
            [14.583637241280025, -1.5155140764666328],
            [14.578925543852035, -1.513885856046891],
            [14.575917516594819, -1.5172832009581076],
            [14.564193307865867, -1.516027787402121],
            [14.559577702462308, -1.5088011664181977],
            [14.552772674956541, -1.5090749633633196],
            [14.546576303345958, -1.506824636706801],
            [14.540860036777538, -1.4864108867806154],
            [14.507404556629721, -1.486711167769915],
            [14.474674491121107, -1.4536923062777771],
            [14.417004125054557, -1.4360689092919574],
            [14.371807942226772, -1.4248123556347727],
            [14.362219415931099, -1.3662008224515856],
            [14.38269471632983, -1.2653736048551643]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.28571301217883,
          "lat": 36.082733153912116
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37069"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01008553"
      },
      "bbox": [
        14.362219415931099, -1.5839184244730236, 14.762586580485657,
        -1.138076594581829
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.549133414768741, -0.6590252854452887],
            [15.54770779057388, -0.6570393590446441],
            [15.547598331292933, -0.6508322070743178],
            [15.63273979415984, -0.6349852309404855],
            [15.67753009117721, -0.626033696329663],
            [15.686253533598716, -0.6236193751033184],
            [15.813200914631038, -0.5976704659491351],
            [15.839748873207375, -0.59260734285268],
            [15.887014902310753, -0.6236479453372157],
            [15.89560901562327, -0.6651946812302728],
            [15.943672702932963, -0.7485507205709562],
            [15.881209017542972, -0.7830066479636096],
            [15.867805575701889, -0.787929662927293],
            [15.866496103420104, -0.7924772524175722],
            [15.861251242544848, -0.8108424732380608],
            [15.853745830759776, -0.8116557841229389],
            [15.849339934930576, -0.8141569506609205],
            [15.844855495378093, -0.8183655303084469],
            [15.844958848871588, -0.8240163378735698],
            [15.839388426801207, -0.8270505142779966],
            [15.836139790715254, -0.8264766392639308],
            [15.830295164700969, -0.8278991092765559],
            [15.82186794153079, -0.8246717176838272],
            [15.818575068462957, -0.8256316908609165],
            [15.813504551286389, -0.8247964882028229],
            [15.808128528902559, -0.826871748059686],
            [15.808343702629385, -0.8360525443681275],
            [15.804664022312915, -0.837197814833832],
            [15.800054307835902, -0.8442217160983467],
            [15.796313836027533, -0.8460932186954815],
            [15.7876014005431, -0.845736410074686],
            [15.78478148326379, -0.8554567651655244],
            [15.786066383465183, -0.860431165890719],
            [15.779457869781124, -0.8625434064299043],
            [15.770692402881732, -0.8688790565261071],
            [15.76761260946887, -0.8658745370596649],
            [15.758514470961815, -0.8636943113334024],
            [15.751944976364818, -0.859657583237067],
            [15.743218238080305, -0.851705192568881],
            [15.734706995534065, -0.8475080135530857],
            [15.728794366891822, -0.8413718276663557],
            [15.71647200641596, -0.8309697620020627],
            [15.71128688011317, -0.8253571552033323],
            [15.707516417932304, -0.8235467125195396],
            [15.701406233435598, -0.822811621253314],
            [15.695724602489038, -0.81800175664622],
            [15.689734873226035, -0.8166662156418975],
            [15.684717903641774, -0.8206555488207347],
            [15.681131430955844, -0.8217756485732102],
            [15.670598552403677, -0.820949791532404],
            [15.659271066330424, -0.8216924193906611],
            [15.647862457908456, -0.8153536971591482],
            [15.643338431745887, -0.8143621142551896],
            [15.635055572478223, -0.8152847263163305],
            [15.629908559380144, -0.8146205147475332],
            [15.618378242064152, -0.8116581608221309],
            [15.614275353565233, -0.8112445421617233],
            [15.606436056261996, -0.8124362198141916],
            [15.599841190934264, -0.8083125281405119],
            [15.595604415103319, -0.8075781087511451],
            [15.586346239423014, -0.8091670354514948],
            [15.57674538478207, -0.8057411669303993],
            [15.567203233057702, -0.8035898687148811],
            [15.554980400052187, -0.7962347913748864],
            [15.55077565766147, -0.7909884098604514],
            [15.54926941939144, -0.7799941423576241],
            [15.547515131543431, -0.7733227389488374],
            [15.547194858465453, -0.7661724648641919],
            [15.543923515178408, -0.7559610289341673],
            [15.540632618805569, -0.7484243630496495],
            [15.541107936101689, -0.7421938960423141],
            [15.537161240249176, -0.737792958701343],
            [15.539313006583017, -0.7346612090484963],
            [15.548299212907832, -0.7345849437493005],
            [15.549956327026367, -0.7322167170940307],
            [15.546710969518529, -0.72692576817596],
            [15.546631729392535, -0.7204564758444678],
            [15.550358446849769, -0.71887150903566],
            [15.553142729480397, -0.7154590248279971],
            [15.554299655219777, -0.6975663241051134],
            [15.559250713109266, -0.6978865564115991],
            [15.561567455684159, -0.6958398420101148],
            [15.563295138798779, -0.6902867931494817],
            [15.562228212473652, -0.6858497456378979],
            [15.564095644956382, -0.6824572340800246],
            [15.561994244208133, -0.678318403527429],
            [15.551306580751545, -0.6719272979405796],
            [15.54741058614905, -0.674879263848449],
            [15.54532557654688, -0.6716660132590011],
            [15.54795996180558, -0.6692685592549089],
            [15.546003917118243, -0.6652121800475955],
            [15.549910940957128, -0.6641328199762195],
            [15.549133414768741, -0.6590252854452887]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.70044476633937, "lat": 36.44494124021965 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37073"],
        "coty_name": ["Gates"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gates County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01026126"
      },
      "bbox": [
        15.537161240249176, -0.8688790565261071, 15.943672702932963,
        -0.59260734285268
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.52640842328991, -2.538132551559796],
            [11.529142083505842, -2.534691655926308],
            [11.535195258257096, -2.529867132341739],
            [11.542789030263451, -2.5262160679139334],
            [11.553652687573589, -2.5318463328337417],
            [11.558791248476654, -2.5319515603233054],
            [11.563188918096124, -2.527709285941835],
            [11.567563406283007, -2.5275821282429054],
            [11.570264079855146, -2.521115911394397],
            [11.575160201184346, -2.5211514673003808],
            [11.577402449628357, -2.524777108736897],
            [11.5808706613375, -2.5259886637726368],
            [11.583558228717552, -2.523810132178036],
            [11.58679877325269, -2.5258411014647453],
            [11.589701445347524, -2.5188299964700938],
            [11.594691161200226, -2.515838425792994],
            [11.595766864960144, -2.5115930460192653],
            [11.600807616123681, -2.51242576924036],
            [11.605010490413846, -2.5102026246005154],
            [11.612066683609886, -2.510974622712385],
            [11.620387800692367, -2.517111398540076],
            [11.629696996501524, -2.520550455120602],
            [11.631486038111158, -2.519055113778097],
            [11.63770101696937, -2.5225726959664696],
            [11.640462274836313, -2.526826644581239],
            [11.644104984008743, -2.5268699134982997],
            [11.651031416099684, -2.5322460958616086],
            [11.654348827642998, -2.545005710942443],
            [11.661050072460895, -2.5421859862571536],
            [11.66804680644562, -2.551265844625553],
            [11.6699678823761, -2.5551974269259916],
            [11.67340598894867, -2.557253115072007],
            [11.677552169710893, -2.5569743057648],
            [11.6789182998635, -2.564283091289853],
            [11.681241805675594, -2.5676416792728225],
            [11.685296637679807, -2.5701479731419896],
            [11.688931578113989, -2.569313433385815],
            [11.69207622856505, -2.573533714850204],
            [11.698134739365099, -2.570271064303929],
            [11.70067810927377, -2.5714451113680705],
            [11.703788990984043, -2.5775475500476075],
            [11.709082951512869, -2.585205957633604],
            [11.711174710318106, -2.5849376661765517],
            [11.717019535498402, -2.591228553250222],
            [11.722508737456002, -2.594754804906852],
            [11.725262416679781, -2.602371214764133],
            [11.730702913093884, -2.60483857034784],
            [11.735821416615426, -2.603202827766727],
            [11.737626104191534, -2.6092203660712565],
            [11.742487324475169, -2.6122362819178044],
            [11.747006187377512, -2.616948969323206],
            [11.751168399843824, -2.617852172040994],
            [11.75308887761488, -2.6240458063043555],
            [11.756884039018166, -2.6291545903727687],
            [11.768534006612311, -2.634806360446662],
            [11.772448943414814, -2.6342466492453265],
            [11.776616606361271, -2.6375735250056476],
            [11.78035040316159, -2.6387641044585624],
            [11.78096473768512, -2.644094751648446],
            [11.785522931856008, -2.646465664486565],
            [11.785075272242173, -2.651473204897679],
            [11.786802609758427, -2.665008390383781],
            [11.789727459452752, -2.6688544990693814],
            [11.786975430957995, -2.676066484332071],
            [11.785524252747196, -2.685035812156963],
            [11.786275835028256, -2.6909487392624247],
            [11.790369298639986, -2.7091314810015903],
            [11.764475508320864, -2.7116854328289954],
            [11.693488882361017, -2.7199257165709088],
            [11.653568295624412, -2.7233246251077157],
            [11.623069209125852, -2.727112848066536],
            [11.591426725030477, -2.7294554018364727],
            [11.579312471703776, -2.7304533860802866],
            [11.543558444622592, -2.732308454686766],
            [11.532922219128634, -2.735345267931515],
            [11.527917397635044, -2.7397773484013985],
            [11.518730146560832, -2.743097620353096],
            [11.512088560373872, -2.746435964468839],
            [11.510893043314574, -2.7494800744430696],
            [11.50694373610967, -2.7531762507116326],
            [11.500885082116644, -2.7520391797073605],
            [11.497607949736475, -2.7485488629095385],
            [11.494575882732398, -2.7506680989951735],
            [11.48873812523523, -2.747332815534058],
            [11.481570185364506, -2.749276791121573],
            [11.47854724301807, -2.712996632079887],
            [11.471869830515177, -2.713923162633058],
            [11.469621022050811, -2.697791361718177],
            [11.47725894063893, -2.696875728964515],
            [11.474052534626757, -2.6548951029112153],
            [11.477129321780724, -2.6517807184886797],
            [11.482081421560915, -2.638627114886754],
            [11.484300043551913, -2.6360507733479834],
            [11.483736097867766, -2.632657077640952],
            [11.486360134074536, -2.629445626888748],
            [11.494585655969827, -2.6292557993250005],
            [11.495708219958948, -2.624302193809456],
            [11.498493037614848, -2.6221187905270247],
            [11.4970311664835, -2.6168460220890917],
            [11.49942556044804, -2.61416002534714],
            [11.500539581700497, -2.6094904747129606],
            [11.500030617529333, -2.603645715675287],
            [11.504921734879238, -2.5999263795338],
            [11.504836487985974, -2.5957186850442593],
            [11.50682871715669, -2.5881147993240536],
            [11.511518273681501, -2.5769693416907216],
            [11.51442651076205, -2.5730336311391198],
            [11.515661951822308, -2.5684831705244844],
            [11.514083948631756, -2.5661428257132965],
            [11.517287511052787, -2.557063597192202],
            [11.52562900896544, -2.545752182294411],
            [11.526972230589939, -2.5428874034726463],
            [11.52640842328991, -2.538132551559796]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.1696960537913, "lat": 35.27929651774662 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37149"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01008579"
      },
      "bbox": [
        11.469621022050811, -2.7531762507116326, 11.790369298639986,
        -2.5102026246005154
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.204993591609588, -1.7355543414399965],
            [13.289483749676435, -1.7255734365982098],
            [13.290098139883863, -1.7253335916438057],
            [13.33897470035156, -1.7195709768579948],
            [13.451264072964294, -1.706634840456085],
            [13.539298051186087, -1.695908225591043],
            [13.608079896793972, -1.6875158848213612],
            [13.617358885389882, -1.7438017901687461],
            [13.632401465435242, -1.8442868330170548],
            [13.6373344532601, -1.8778308561581767],
            [13.64374975649571, -1.9281452527660217],
            [13.647049227374094, -1.955490843385226],
            [13.651207878807057, -1.987731179834224],
            [13.663800043953499, -2.0717650763325546],
            [13.598584621623134, -2.0844789119814426],
            [13.495780475675, -2.104554471478125],
            [13.38998004416173, -2.124367816230619],
            [13.335138068093315, -2.1360160762402027],
            [13.259071839165438, -2.1509236074885565],
            [13.2441752364027, -2.0440644882276633],
            [13.236649973443335, -1.9872598137980482],
            [13.226229901199899, -1.9064475387756377],
            [13.222355476850355, -1.8752460016001917],
            [13.211843426180309, -1.7888357297803095],
            [13.204993591609588, -1.7355543414399965]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.80601101660025, "lat": 35.71032816568983 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37151"],
        "coty_name": ["Randolph"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Randolph County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01008580"
      },
      "bbox": [
        13.204993591609588, -2.1509236074885565, 13.663800043953499,
        -1.6875158848213612
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.244097094731957, 9.162439182263649],
            [-1.2423102784515492, 9.229782057547826],
            [-1.2395515438248064, 9.333570305762267],
            [-1.1700120572878305, 9.331774897935887],
            [-1.1676583492009254, 9.416713293142429],
            [-1.1653440734751859, 9.50155360128005],
            [-1.0779990099437344, 9.499802862548504],
            [-0.9909269588027912, 9.497369464879272],
            [-0.9764871390269468, 9.497185771551036],
            [-0.900288148942649, 9.495250711391437],
            [-0.8164867673109171, 9.493784521193904],
            [-0.818593884036536, 9.394683652182477],
            [-0.8201325629441775, 9.323705702775882],
            [-0.8056120165418773, 9.323368429133454],
            [-0.8076362196181343, 9.222664363486116],
            [-0.809078243346373, 9.152202652798806],
            [-0.81126777874314, 9.052938268972307],
            [-0.812602534246605, 8.98185578338125],
            [-0.8817394045715924, 8.983366669891064],
            [-0.9421453128229267, 8.984716006546826],
            [-0.9683895421898939, 8.985457563388255],
            [-1.0013288697753335, 8.986004561956102],
            [-1.0679355818733374, 8.987397087736644],
            [-1.1182082919458771, 8.988762648607517],
            [-1.1615084567732117, 8.989741724625551],
            [-1.23150816092532, 8.991626338185013],
            [-1.2486003097721425, 8.991979568932088],
            [-1.2473410720562448, 9.048596813758165],
            [-1.246133960898906, 9.091151402628112],
            [-1.2438845809557988, 9.093495535907495],
            [-1.2430976411488057, 9.124326878942787],
            [-1.2449100473467245, 9.129450113002619],
            [-1.244097094731957, 9.162439182263649]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.19203140653362, "lat": 47.92164724161245 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38063"],
        "coty_name": ["Nelson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nelson County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01034217"
      },
      "bbox": [
        -1.2486003097721425, 8.98185578338125, -0.8056120165418773,
        9.50155360128005
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.516294711678063, 2.380416508143006],
            [11.506803270427007, 2.4545503389080006],
            [11.50489122839034, 2.470704827140492],
            [11.549303304456664, 2.4767205545622963],
            [11.543971925020609, 2.5187678436242096],
            [11.537494084924504, 2.5722745940705702],
            [11.533058749251236, 2.6068533465122363],
            [11.576295441192103, 2.6116675388724913],
            [11.576030610818199, 2.6135438423941992],
            [11.591943789875677, 2.615672925484367],
            [11.66012992059384, 2.6238536197278317],
            [11.660376991958596, 2.6221907884388678],
            [11.73557129734743, 2.6311312312064232],
            [11.778928960595943, 2.6366968061760123],
            [11.8178730770619, 2.641544493959263],
            [11.836142363377544, 2.644044285822925],
            [11.84184407069904, 2.6005058427603935],
            [11.838586766298812, 2.6000650631112694],
            [11.838972566312043, 2.594270920047595],
            [11.841102123639715, 2.5813609249146148],
            [11.84956317959188, 2.5123218188250127],
            [11.854662526244391, 2.4681154499752975],
            [11.865284118142085, 2.379784350815973],
            [11.820393473395995, 2.374871736579637],
            [11.793783757496186, 2.3717368108644643],
            [11.738279693840232, 2.365648557024839],
            [11.69253457000408, 2.3609085391193316],
            [11.692125530306974, 2.3640927943172505],
            [11.670523478534784, 2.3606372504392095],
            [11.606698678907616, 2.3522912388526027],
            [11.607023276147501, 2.3496694055758174],
            [11.521695309540977, 2.3383243487125887],
            [11.516294711678063, 2.380416508143006]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.09115380934848, "lat": 40.29381815488068 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39067"],
        "coty_name": ["Harrison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harrison County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01074046"
      },
      "bbox": [
        11.50489122839034, 2.3383243487125887, 11.865284118142085,
        2.644044285822925
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.126183505145367, 2.838012682929353],
            [9.168914634121116, 2.843643484962929],
            [9.165089276629091, 2.872729152954263],
            [9.15997907366286, 2.9158754443596924],
            [9.152788720389148, 2.9746365124775003],
            [9.147576182918211, 3.018390571509149],
            [9.15477299767033, 3.0191927618228322],
            [9.231555751879952, 3.029123047683558],
            [9.331542287122684, 3.0422827960072465],
            [9.460139069431161, 3.0595829179912095],
            [9.488427706461014, 3.0635234526935253],
            [9.500451388483867, 2.9721871670102926],
            [9.514177218877643, 2.8662198232289584],
            [9.520687067878447, 2.816501896384132],
            [9.478102627927488, 2.810891107065068],
            [9.435426782629717, 2.8050409604594972],
            [9.43735076539789, 2.7902820325679896],
            [9.418640130755064, 2.78773575305065],
            [9.352364279991539, 2.7792135533742997],
            [9.353363693370316, 2.7687498612300705],
            [9.357815573927947, 2.735497539319076],
            [9.272251648007225, 2.7230891346675064],
            [9.272141653784661, 2.723892605682014],
            [9.251439793607444, 2.72095821316377],
            [9.199052654883555, 2.7141218095975423],
            [9.186177763065915, 2.7122244200945955],
            [9.180361030973364, 2.756668684507693],
            [9.137673428143444, 2.7510890004481783],
            [9.126183505145367, 2.838012682929353]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.13174338948964, "lat": 41.02210784270346 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39137"],
        "coty_name": ["Putnam"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Putnam County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01074081"
      },
      "bbox": [
        9.126183505145367, 2.7122244200945955, 9.520687067878447,
        3.0635234526935253
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6450795170918613, -2.531102706174334],
            [-1.6308089768765839, -2.5310148196844584],
            [-1.5173625745377333, -2.5344908536437027],
            [-1.3894941455888925, -2.5377780514343655],
            [-1.3040650229709223, -2.539797136993468],
            [-1.3065530815741402, -2.6549777119136286],
            [-1.3078984209998032, -2.713480629087258],
            [-1.3099781834955397, -2.8082109295856523],
            [-1.3074550040959503, -2.8082573985862163],
            [-1.3098966539853292, -2.9100483659865506],
            [-1.3117295952363421, -2.982984377558403],
            [-1.3970351267972612, -2.981407758946728],
            [-1.3999078546839987, -3.0936006058962997],
            [-1.4013659616913996, -3.1558876396882236],
            [-1.446640916168897, -3.1549692941963836],
            [-1.4601684515382174, -3.154421688219371],
            [-1.5505460368122532, -3.1520519439318635],
            [-1.5661713404754813, -3.1517489947291617],
            [-1.6512444801776427, -3.1494077557097704],
            [-1.6584683957612123, -3.1492143297637427],
            [-1.6551548372407112, -3.030498821758246],
            [-1.6536465288148052, -2.9818413727857482],
            [-1.653065816504792, -2.954522833926743],
            [-1.651001102808676, -2.8864330520546404],
            [-1.6486770462799027, -2.799391074306218],
            [-1.6519276563761367, -2.7992819090009737],
            [-1.6502927847120905, -2.740971167639854],
            [-1.6456101071391205, -2.5528829865299127],
            [-1.6450795170918613, -2.531102706174334]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.43343424981082,
          "lat": 35.875181429390814
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40011"],
        "coty_name": ["Blaine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blaine County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "01101793"
      },
      "bbox": [
        -1.6584683957612123, -3.1558876396882236, -1.3040650229709223,
        -2.5310148196844584
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.9917444482790709, -3.673197948806504],
            [1.0128844021334613, -3.6733284556562174],
            [1.077376795974318, -3.6732429532411133],
            [1.130062007063146, -3.672926503298917],
            [1.2269763332286043, -3.6721007211421206],
            [1.3338527471238233, -3.6703795589078547],
            [1.3353367038013337, -3.787337363112552],
            [1.2780687198000091, -3.788022313228693],
            [1.2783211185407743, -3.7992927469066577],
            [1.2792324878481434, -3.875604708812574],
            [1.2290423827298005, -3.8760118451163326],
            [1.2295726812160177, -3.963726671229777],
            [1.2298373047088327, -3.992799206154692],
            [1.2306965250718405, -4.051321837595993],
            [1.1715930610595404, -4.052034574604828],
            [1.1161255025146968, -4.052568316840666],
            [1.0222801085145983, -4.052908260310335],
            [0.9165491082537, -4.053689816144462],
            [0.8597283816769224, -4.054115794810693],
            [0.8595399973274721, -3.9667402793440516],
            [0.8591337160000836, -3.8788718349449423],
            [0.8645319750247552, -3.878836063050912],
            [0.8639421731801581, -3.784212316959495],
            [0.8634025040557979, -3.7034137454706153],
            [0.9919234560100453, -3.7026084463896978],
            [0.9917444482790709, -3.673197948806504]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.25037105961503,
          "lat": 34.876031418555826
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40077"],
        "coty_name": ["Latimer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Latimer County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01101826"
      },
      "bbox": [
        0.8591337160000836, -4.054115794810693, 1.3353367038013337,
        -3.6703795589078547
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.23975625367467, -3.013786326374234],
            [12.32458157474623, -2.9999868659868487],
            [12.363479029913195, -2.9938592822775707],
            [12.448100506106146, -2.9816754976874082],
            [12.511269016218037, -2.9724947320185477],
            [12.540007355415415, -2.968034762077179],
            [12.598169381477991, -2.9583070848661723],
            [12.645215174798565, -2.950756295646966],
            [12.706524062148008, -2.9413270084524012],
            [12.709470314266143, -2.9476124003514097],
            [12.715170273653605, -2.955078450184854],
            [12.71848000376721, -2.9570115196234337],
            [12.721639568208381, -2.9644066427117055],
            [12.7295087628294, -2.9709959686542344],
            [12.731273069295021, -2.9770365380652906],
            [12.73490737124351, -2.9952451775981723],
            [12.732402161386997, -3.000076886059367],
            [12.73537901758685, -3.015090021704935],
            [12.738527422548147, -3.0203004809478493],
            [12.739864643222733, -3.026961664379397],
            [12.745829897219558, -3.034535967546879],
            [12.746787847482068, -3.041094597628071],
            [12.750404490223834, -3.050681798889724],
            [12.756714055998811, -3.0561881063766956],
            [12.756955228670181, -3.0607362950790113],
            [12.74569678575245, -3.075622464676867],
            [12.74417820225581, -3.084976691061207],
            [12.738647249300161, -3.091338119465918],
            [12.74208326140995, -3.1025678530506],
            [12.74205514396635, -3.1071107196678813],
            [12.738739086169806, -3.114413864066256],
            [12.73776380786415, -3.1189124125772483],
            [12.738129387036144, -3.1289650546667254],
            [12.74280755760693, -3.134983166793483],
            [12.74610022593584, -3.141542999858735],
            [12.747162198779124, -3.1519456387640545],
            [12.74630073200577, -3.155689609292025],
            [12.74698991673396, -3.1619339308771277],
            [12.75579731673262, -3.1703548551332763],
            [12.755922843340462, -3.1734116118349154],
            [12.760915964430067, -3.1769691332008976],
            [12.762159849715648, -3.1869739374098636],
            [12.768879515491586, -3.2004257009554036],
            [12.769694313336993, -3.2042638728107833],
            [12.766964768187492, -3.2100299098681644],
            [12.767529653998794, -3.214620640683253],
            [12.707951886651344, -3.2218589436663976],
            [12.663944704128482, -3.226159862293607],
            [12.618685949490212, -3.2280286123095903],
            [12.609816426451829, -3.229069886538663],
            [12.569612492791112, -3.2324389758116174],
            [12.442465679908553, -3.243539753943465],
            [12.413563174645928, -3.2464239796068903],
            [12.3230396750641, -3.2550978441013023],
            [12.318709709074286, -3.249175336899971],
            [12.320898454693687, -3.2374322241778097],
            [12.322006805800616, -3.222582815272303],
            [12.320265572058332, -3.2142579378338154],
            [12.318108455247549, -3.1975946421865027],
            [12.319051745620495, -3.193010851804805],
            [12.313913186879672, -3.1869600462900802],
            [12.30571341330496, -3.1797748836287014],
            [12.294965843326857, -3.176213851927302],
            [12.293055009906928, -3.173951637842118],
            [12.28809322464971, -3.163832215558487],
            [12.281766363823792, -3.156387818158503],
            [12.279628227078296, -3.1392410473173635],
            [12.277605566937503, -3.132476823810038],
            [12.275206414321302, -3.120625016353229],
            [12.27478217430342, -3.1108780675402956],
            [12.272500576881823, -3.10827616408993],
            [12.267646952418843, -3.10625762973206],
            [12.256774117234942, -3.1112851728249824],
            [12.254065048852253, -3.111062007836936],
            [12.245422311704196, -3.1030480340020015],
            [12.245473037928654, -3.0978071966125302],
            [12.248451537987657, -3.0910099677043146],
            [12.257777753792327, -3.080355003923956],
            [12.263147269672627, -3.07532411656992],
            [12.26947566143628, -3.0709600523551024],
            [12.265805875623677, -3.0584732641533923],
            [12.265839373194028, -3.0497794803626266],
            [12.263030872066878, -3.0448661701985476],
            [12.262033676555198, -3.039892875347445],
            [12.258968080004852, -3.0352594508670814],
            [12.251268291030794, -3.0322704373241147],
            [12.249640064458752, -3.0296743016272147],
            [12.248962103401777, -3.0230755161248664],
            [12.239552597604401, -3.026959899150328],
            [12.23386011589205, -3.0229566771605354],
            [12.23357215787302, -3.01973043636516],
            [12.23975625367467, -3.013786326374234]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.15955999995994, "lat": 34.69203371455766 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45023"],
        "coty_name": ["Chester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chester County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01247988"
      },
      "bbox": [
        12.23357215787302, -3.2550978441013023, 12.769694313336993,
        -2.9413270084524012
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.659302333141527, -2.68806150036512],
            [12.680062901627961, -2.7081130758938903],
            [12.724052876472614, -2.754004803867855],
            [12.742648833062212, -2.773381915584867],
            [12.781405212577173, -2.811944636665745],
            [12.787596609355505, -2.9292878767067188],
            [12.910657095707599, -2.9106014333540684],
            [12.925642587614927, -2.9085188806489284],
            [12.977479346260818, -2.9008033568929847],
            [12.976038100534458, -2.90381365093293],
            [12.980427074809763, -2.910820705855992],
            [12.982680641772676, -2.916246311613407],
            [12.986733549100933, -2.9191290430386045],
            [12.99000261004652, -2.9257801414892413],
            [12.994199207653846, -2.9258499518783205],
            [12.996733673321339, -2.9318078042247047],
            [13.001974394004433, -2.9329195561135855],
            [13.006281419999643, -2.9320909849438337],
            [13.006080918029431, -2.9377050833960694],
            [13.010181178018161, -2.938594101777796],
            [13.010719695196128, -2.942712347401651],
            [13.021948991738661, -2.9440314424455423],
            [13.021654798264388, -2.9494527970529734],
            [13.023581862498919, -2.953014449408004],
            [13.028801262742084, -2.9564304268767723],
            [13.033089727589799, -2.9651117926144166],
            [13.039544934846012, -2.970155990680796],
            [13.039006247903975, -2.9733733729335574],
            [13.042901662111456, -2.979118523153121],
            [13.047589650501513, -2.9836249509517256],
            [13.052466075083325, -2.9860744614184767],
            [13.053674204626333, -2.9887515406809784],
            [13.052892164147837, -2.9935284824460866],
            [13.05497874366635, -2.99488852904056],
            [13.054378860662363, -3.001978470750337],
            [13.059857456999906, -3.0024652201052797],
            [13.066381141973947, -3.0068747995193723],
            [13.066850199401701, -3.0096467774309863],
            [13.073630228462289, -3.0198425954546706],
            [13.080359601601849, -3.021545719533418],
            [13.081618793769131, -3.027081502331717],
            [13.090253418094768, -3.026866805633485],
            [13.088424570195343, -3.031336915493587],
            [13.094929527495593, -3.0342780593269727],
            [13.095808463235464, -3.036288370020191],
            [13.101014039277644, -3.0373778837012018],
            [13.103608848517148, -3.0401775745993413],
            [13.107756329615999, -3.0400819690606404],
            [13.109971873420276, -3.043995179770609],
            [13.108019409240136, -3.046043076363149],
            [13.107197770005879, -3.053131120811629],
            [13.108075886622142, -3.05834258945801],
            [13.111924906273584, -3.062613699223524],
            [13.116246030064218, -3.062335080695058],
            [13.121639357762687, -3.067016132579903],
            [13.127443721123054, -3.069715584910792],
            [13.129250385725049, -3.07368358722545],
            [13.124383100469384, -3.0773021380519174],
            [13.12775034952281, -3.0809623294036608],
            [13.134038048882026, -3.0819233217216504],
            [13.062723031809275, -3.130963854399834],
            [13.034128606544662, -3.150861854414365],
            [13.028371584183061, -3.1552159594687503],
            [13.031681379338574, -3.159324432869796],
            [13.03213753697386, -3.162801591969164],
            [13.035018357488642, -3.1649920876030997],
            [13.037801080530194, -3.176641189089758],
            [13.040005798686812, -3.1798786852890104],
            [13.044465409890352, -3.1791254336393],
            [13.046530043603578, -3.185563170297335],
            [13.053341351095254, -3.1907563920744355],
            [13.054893167126306, -3.1969974773227365],
            [13.057196640493183, -3.1983261899088475],
            [13.05593059568168, -3.2077853852497733],
            [13.05121721846553, -3.2085326666518443],
            [13.045070952904513, -3.2079507989849683],
            [13.04155280748952, -3.209957148137196],
            [13.04256561867086, -3.213902745014821],
            [13.040674110293812, -3.221238995844559],
            [13.032065503076026, -3.2222749256428593],
            [13.026564948024271, -3.227367683132192],
            [13.019323277678836, -3.2286578407249604],
            [13.020283197316127, -3.2325865717435187],
            [13.017511030977708, -3.233896363872275],
            [13.013629056365533, -3.225994370402502],
            [13.010190655398674, -3.2226306013875314],
            [13.001423030636515, -3.218610130677914],
            [13.00073045304746, -3.225808180440314],
            [12.995819449973517, -3.2265963657782697],
            [12.991817667704845, -3.2337821991697138],
            [12.988653015379256, -3.2342839841751965],
            [12.987367287428716, -3.2231419762151985],
            [12.978465065093923, -3.2293891869876887],
            [12.974686693436459, -3.226468034620331],
            [12.975863742563742, -3.2339349698003304],
            [12.979781409160333, -3.2333171379802876],
            [12.979294818136548, -3.2409285619122414],
            [12.975576885848705, -3.241863552636403],
            [12.973754358683559, -3.234034796740601],
            [12.96293234444448, -3.235679173201179],
            [12.962363629571103, -3.2384526393421513],
            [12.964484738637525, -3.243382671369907],
            [12.958561888463255, -3.2488604859912082],
            [12.954686157391452, -3.2502116087508215],
            [12.951142947418802, -3.246041840338407],
            [12.93809738304315, -3.23811708827777],
            [12.935762229340357, -3.2339412241663217],
            [12.931860177911643, -3.2310413922400962],
            [12.930411768618074, -3.2251979784432154],
            [12.924001870260597, -3.2177591872735882],
            [12.917308782935239, -3.219607552705166],
            [12.911021924007523, -3.2255140847289203],
            [12.90942943404428, -3.230531970245969],
            [12.909673591652753, -3.235340895936782],
            [12.90871588392265, -3.2488502450319006],
            [12.903491256645705, -3.2521984404577697],
            [12.892405300455632, -3.2575456519472494],
            [12.886440933734264, -3.2548121686519993],
            [12.882293710475277, -3.249137809009157],
            [12.885236078242963, -3.23955114180098],
            [12.884114136009623, -3.2323230813868853],
            [12.878827190748982, -3.2278615302591813],
            [12.88174518931153, -3.2158761333415304],
            [12.880899092650449, -3.2000919349468675],
            [12.87625745656812, -3.20041521519711],
            [12.798273362631411, -3.2811568918770635],
            [12.784032258204336, -3.2963183879216],
            [12.77976320904963, -3.2996819909658894],
            [12.775878451643853, -3.2946014504669963],
            [12.770867478486327, -3.290814067756195],
            [12.761993937283767, -3.275953504441318],
            [12.759405943355096, -3.2734656832141233],
            [12.75984421968908, -3.268318519407546],
            [12.763416351812694, -3.2639867097352036],
            [12.767076315737434, -3.2633641450628543],
            [12.770988957780624, -3.2579294556266767],
            [12.770374743275598, -3.2517058784627912],
            [12.771491602754235, -3.2324891859856164],
            [12.770311807382331, -3.221555488597962],
            [12.767529653998794, -3.214620640683253],
            [12.766964768187492, -3.2100299098681644],
            [12.769694313336993, -3.2042638728107833],
            [12.768879515491586, -3.2004257009554036],
            [12.762159849715648, -3.1869739374098636],
            [12.760915964430067, -3.1769691332008976],
            [12.755922843340462, -3.1734116118349154],
            [12.75579731673262, -3.1703548551332763],
            [12.74698991673396, -3.1619339308771277],
            [12.74630073200577, -3.155689609292025],
            [12.747162198779124, -3.1519456387640545],
            [12.74610022593584, -3.141542999858735],
            [12.74280755760693, -3.134983166793483],
            [12.738129387036144, -3.1289650546667254],
            [12.73776380786415, -3.1189124125772483],
            [12.738739086169806, -3.114413864066256],
            [12.74205514396635, -3.1071107196678813],
            [12.74208326140995, -3.1025678530506],
            [12.738647249300161, -3.091338119465918],
            [12.74417820225581, -3.084976691061207],
            [12.74569678575245, -3.075622464676867],
            [12.756955228670181, -3.0607362950790113],
            [12.756714055998811, -3.0561881063766956],
            [12.750404490223834, -3.050681798889724],
            [12.746787847482068, -3.041094597628071],
            [12.745829897219558, -3.034535967546879],
            [12.739864643222733, -3.026961664379397],
            [12.738527422548147, -3.0203004809478493],
            [12.73537901758685, -3.015090021704935],
            [12.732402161386997, -3.000076886059367],
            [12.73490737124351, -2.9952451775981723],
            [12.731273069295021, -2.9770365380652906],
            [12.7295087628294, -2.9709959686542344],
            [12.721639568208381, -2.9644066427117055],
            [12.71848000376721, -2.9570115196234337],
            [12.715170273653605, -2.955078450184854],
            [12.709470314266143, -2.9476124003514097],
            [12.706524062148008, -2.9413270084524012],
            [12.705356540514781, -2.9360083110782207],
            [12.708478280977621, -2.9314238236993764],
            [12.716930833418271, -2.9267727059552993],
            [12.722819494340127, -2.9210739198361995],
            [12.7274803758644, -2.9093900792932152],
            [12.725864565449681, -2.904400139298541],
            [12.717503448433318, -2.899327657864641],
            [12.714975177024499, -2.896470780730194],
            [12.712985173279895, -2.8884998293486195],
            [12.712271640535182, -2.874627161911238],
            [12.709600769614228, -2.8620736349656606],
            [12.709429203274109, -2.8570118689531494],
            [12.71444863882261, -2.850684362062827],
            [12.716560332890639, -2.845218546370732],
            [12.716911814933628, -2.836382763987894],
            [12.716153974967863, -2.8327195221844246],
            [12.712127057223395, -2.827061755865483],
            [12.710719268875193, -2.823261907508147],
            [12.712065570136549, -2.8191305558668116],
            [12.70906953252983, -2.8120973249825254],
            [12.70955954602158, -2.80826849425494],
            [12.70435527652304, -2.80299500333232],
            [12.704551709454375, -2.7978104331868234],
            [12.702707662292353, -2.794457777361489],
            [12.698644431252724, -2.7979758308019878],
            [12.694554596833074, -2.7953083368899505],
            [12.69525177273014, -2.7900262322164884],
            [12.691521315949695, -2.784643375906659],
            [12.687944596337875, -2.777114695774891],
            [12.689388161249145, -2.7701387090336933],
            [12.684509388802134, -2.7716332311826624],
            [12.682207761580587, -2.7689328996500753],
            [12.682172349342153, -2.7642526289816596],
            [12.67373215323509, -2.7578640624429984],
            [12.67144343104641, -2.75279851542474],
            [12.666152381443386, -2.7477224016715964],
            [12.67034666704402, -2.742698024726537],
            [12.673256020452493, -2.7300319553533656],
            [12.671730066640633, -2.7240615845020453],
            [12.666760365571655, -2.718131093502657],
            [12.664307928930171, -2.7174990923863276],
            [12.666900863885298, -2.706255606971557],
            [12.665780100234935, -2.7015894202705653],
            [12.661545485238522, -2.7006446716536217],
            [12.659470904532022, -2.694789260992338],
            [12.659302333141527, -2.68806150036512]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.70551414500925, "lat": 34.68682140804102 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45057"],
        "coty_name": ["Lancaster"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lancaster County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01248008"
      },
      "bbox": [
        12.659302333141527, -3.2996819909658894, 13.134038048882026,
        -2.68806150036512
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.973120318928425, -3.2851376252558113],
            [11.976441154613163, -3.2323400309274017],
            [11.982530769821292, -3.2116636628704716],
            [11.985061528075546, -3.187444476183156],
            [11.985886303887728, -3.1639705936008053],
            [11.986781074562234, -3.147970184076761],
            [11.98828155946443, -3.0929117631319167],
            [11.989523029312792, -3.074697831767424],
            [11.990332706677737, -3.0551071281609765],
            [11.992462769382668, -3.035414609693781],
            [12.00687636601707, -3.0013139963702455],
            [12.017676357827181, -2.9859239615377504],
            [12.036325582973483, -2.9517433004860623],
            [12.042140831110453, -2.952003371547005],
            [12.045803636313234, -2.9565697050298945],
            [12.05467084553811, -2.955328867459808],
            [12.058211270220658, -2.949160263672862],
            [12.065663233747179, -2.95325339530433],
            [12.067489175988467, -2.9592199637541965],
            [12.070475247743556, -2.9556672528501005],
            [12.079043972832869, -2.9597212432635267],
            [12.087936787530163, -2.9550019786047033],
            [12.091995742473339, -2.9559265669074395],
            [12.09479373350291, -2.9598522691045246],
            [12.09691610703809, -2.9675051553780607],
            [12.101707521191138, -2.971684813668262],
            [12.100118722007348, -2.97417873880321],
            [12.110161661831176, -2.9773555943824963],
            [12.112405549281034, -2.979446812494719],
            [12.124302791359739, -2.975793398890842],
            [12.127801477941363, -2.9738248800061227],
            [12.133609005123533, -2.9655586061136736],
            [12.1366854621015, -2.9659176775810883],
            [12.142205577541448, -2.9615473819225753],
            [12.149095195324465, -2.965362481691915],
            [12.15953274278706, -2.968474959298754],
            [12.16198895505384, -2.9715655789627027],
            [12.165968433501652, -2.9700209059669773],
            [12.169480001848903, -2.9721929622812557],
            [12.173862399707986, -2.9716865928790877],
            [12.179998329502672, -2.973665497620636],
            [12.184345824547163, -2.9695000674827075],
            [12.183815767606148, -2.9643921474630535],
            [12.186590694263801, -2.9631795188543624],
            [12.190054002997542, -2.9728499017078613],
            [12.195546663338508, -2.9673233161143435],
            [12.195587668576078, -2.9637295077634622],
            [12.20193768174464, -2.962922842901323],
            [12.206783062107046, -2.965961668333583],
            [12.2114371131766, -2.96681345242342],
            [12.21561606409208, -2.9703789784015053],
            [12.220231739834382, -2.9682955433044063],
            [12.230044722507825, -2.969442832538114],
            [12.22852435950049, -2.9745868385208483],
            [12.230294743751841, -2.979748658574585],
            [12.23363063962383, -2.978567350931743],
            [12.236993892843355, -2.9833934153279364],
            [12.246044592492142, -2.9871709619394236],
            [12.254080027774895, -2.993475013062187],
            [12.251731277336393, -3.0022550896858684],
            [12.245498458547234, -3.006751024441106],
            [12.23975625367467, -3.013786326374234],
            [12.23357215787302, -3.01973043636516],
            [12.23386011589205, -3.0229566771605354],
            [12.239552597604401, -3.026959899150328],
            [12.248962103401777, -3.0230755161248664],
            [12.249640064458752, -3.0296743016272147],
            [12.251268291030794, -3.0322704373241147],
            [12.258968080004852, -3.0352594508670814],
            [12.262033676555198, -3.039892875347445],
            [12.263030872066878, -3.0448661701985476],
            [12.265839373194028, -3.0497794803626266],
            [12.265805875623677, -3.0584732641533923],
            [12.26947566143628, -3.0709600523551024],
            [12.263147269672627, -3.07532411656992],
            [12.257777753792327, -3.080355003923956],
            [12.248451537987657, -3.0910099677043146],
            [12.245473037928654, -3.0978071966125302],
            [12.245422311704196, -3.1030480340020015],
            [12.254065048852253, -3.111062007836936],
            [12.256774117234942, -3.1112851728249824],
            [12.267646952418843, -3.10625762973206],
            [12.272500576881823, -3.10827616408993],
            [12.27478217430342, -3.1108780675402956],
            [12.275206414321302, -3.120625016353229],
            [12.277605566937503, -3.132476823810038],
            [12.279628227078296, -3.1392410473173635],
            [12.281766363823792, -3.156387818158503],
            [12.28809322464971, -3.163832215558487],
            [12.293055009906928, -3.173951637842118],
            [12.294965843326857, -3.176213851927302],
            [12.30571341330496, -3.1797748836287014],
            [12.313913186879672, -3.1869600462900802],
            [12.319051745620495, -3.193010851804805],
            [12.318108455247549, -3.1975946421865027],
            [12.320265572058332, -3.2142579378338154],
            [12.322006805800616, -3.222582815272303],
            [12.320898454693687, -3.2374322241778097],
            [12.318709709074286, -3.249175336899971],
            [12.3230396750641, -3.2550978441013023],
            [12.326200053625444, -3.26015164019716],
            [12.326249677296431, -3.266908734376909],
            [12.324219903316664, -3.2712510605658247],
            [12.325594390986636, -3.281575832164162],
            [12.324652736502323, -3.2885079496865663],
            [12.32568469712449, -3.2980216050142563],
            [12.328648107607625, -3.3030728827250733],
            [12.331509310040106, -3.314042361340235],
            [12.335173931704762, -3.325074953809225],
            [12.334566747151836, -3.3323989283259245],
            [12.330754767082274, -3.3317101156710636],
            [12.326629664017073, -3.3356314969289325],
            [12.324329117099508, -3.33206571816746],
            [12.32088343610255, -3.331919748315933],
            [12.317977820367123, -3.3345813730821745],
            [12.318018206790496, -3.3414557654645134],
            [12.311807090018826, -3.3401194045313614],
            [12.307035277128579, -3.3441838782606186],
            [12.298093216743919, -3.338166367192515],
            [12.293752755724801, -3.3428784187534597],
            [12.285621085185543, -3.3443920922384227],
            [12.2696358563146, -3.3648702073519514],
            [12.247412001843086, -3.396042832341227],
            [12.245872517101082, -3.3926257466362837],
            [12.242451578154048, -3.3932265760304627],
            [12.237689558787336, -3.390222919849484],
            [12.235948863410629, -3.385405092002001],
            [12.240454211833121, -3.381375762354859],
            [12.238043849827648, -3.3794355592247403],
            [12.233141210830619, -3.380664831597888],
            [12.231112489845058, -3.379301342793113],
            [12.234377592442948, -3.3723140641670506],
            [12.232497361112888, -3.3659974084833246],
            [12.223159524277762, -3.3615658685272467],
            [12.221875444196987, -3.3598756052875287],
            [12.212459606337287, -3.3547248892905546],
            [12.209048590375408, -3.3517170382516945],
            [12.20071471186967, -3.3504660099050163],
            [12.195538514950725, -3.343656717993069],
            [12.186724300898259, -3.336264420180821],
            [12.177976428986913, -3.336680776767797],
            [12.174438762476594, -3.332964001813055],
            [12.172659920166469, -3.3257837029420503],
            [12.164687234146637, -3.3280893243436767],
            [12.16150180667918, -3.3253629573350545],
            [12.15422654567513, -3.3262949955993366],
            [12.150572399815161, -3.3205884599123228],
            [12.146875681105199, -3.3220286538320845],
            [12.13989930308283, -3.3145937776810803],
            [12.137866157765083, -3.3154725300488583],
            [12.13428543117177, -3.307735446162179],
            [12.12896440313816, -3.308929679574462],
            [12.127031312268342, -3.3062676082492723],
            [12.11875650412157, -3.30527350472059],
            [12.119610690007141, -3.300529380779343],
            [12.11542333621159, -3.3018939578821347],
            [12.109554791004546, -3.3074148812724053],
            [12.10023253059985, -3.3020485098750183],
            [12.09235614171219, -3.30774252821081],
            [12.089208786187355, -3.311772050688291],
            [12.083036511940096, -3.307934885908097],
            [12.079375937974481, -3.3079972830496254],
            [12.07369598497881, -3.3044861498281715],
            [12.070483416094522, -3.306561129989957],
            [12.065822390016654, -3.303888137485395],
            [12.063898045850479, -3.300251370800666],
            [12.059665442016405, -3.299035199061108],
            [12.051736107220405, -3.30263391449774],
            [12.04930070008606, -3.300594627306327],
            [12.044288991780464, -3.3013475917563904],
            [12.038463301624645, -3.2996536595097177],
            [12.034976690159121, -3.3010914820295874],
            [12.028788869210468, -3.2977942896026615],
            [12.017782553835616, -3.2987579402642324],
            [12.015221482053992, -3.293038788781023],
            [12.006233032554738, -3.2950503814407477],
            [12.00131255436308, -3.287601578891464],
            [11.99512038010885, -3.288677235192639],
            [11.992857405642972, -3.284278704098811],
            [11.989922246041669, -3.2859646718890794],
            [11.983465099972337, -3.2851554894615664],
            [11.982896954577658, -3.280756161727426],
            [11.979526098182005, -3.2782139147173304],
            [11.977322724710957, -3.283362274212067],
            [11.973120318928425, -3.2851376252558113]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.61914105264354, "lat": 34.68956520063908 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45087"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "01248017"
      },
      "bbox": [
        11.973120318928425, -3.396042832341227, 12.335173931704762,
        -2.949160263672862
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.130723784112959, 6.968041121705096],
            [-2.0512806829499515, 6.9647314560403],
            [-1.9582243432716981, 6.961160517955283],
            [-1.9033241706601125, 6.958951424202218],
            [-1.8722849123225722, 6.957974828257561],
            [-1.8283832172072767, 6.956291192662205],
            [-1.7001857997556198, 6.951752762726306],
            [-1.612179000355193, 6.94899327889475],
            [-1.5249519646139242, 6.946194942371713],
            [-1.443361813392192, 6.942818683892637],
            [-1.4413834558226941, 6.94275246372461],
            [-1.443966457321365, 6.856768641282531],
            [-1.4463558222353208, 6.770335863911308],
            [-1.4492409451844606, 6.670200458189099],
            [-1.451552466277863, 6.597768694679605],
            [-1.4922798030875424, 6.599275377528055],
            [-1.5382740442870135, 6.601228768151173],
            [-1.6613024924600999, 6.605267307906594],
            [-1.711315890273158, 6.60704648482627],
            [-1.7986101272635726, 6.609701326256424],
            [-1.8914821518840705, 6.6130594288893185],
            [-1.9559787646627698, 6.615481516350014],
            [-2.0498245761815714, 6.619050727219634],
            [-2.116280338079328, 6.62183720245852],
            [-2.145181754145119, 6.62318067119024],
            [-2.141374693842889, 6.709044826586635],
            [-2.1378665258960226, 6.79582282824293],
            [-2.132588117332653, 6.924743454595298],
            [-2.130723784112959, 6.968041121705096]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.21529903370389, "lat": 45.41877763726912 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46045"],
        "coty_name": ["Edmunds"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edmunds County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01266972"
      },
      "bbox": [
        -2.145181754145119, 6.597768694679605, -1.4413834558226941,
        6.968041121705096
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.254651334339054, 6.141862406569729],
            [-5.247840959991938, 6.146589877888342],
            [-5.2440166097187175, 6.145380131301504],
            [-5.24195891364851, 6.149195325930594],
            [-5.2388003707998365, 6.150475385682197],
            [-5.235283799572045, 6.146457630430526],
            [-5.232003736704617, 6.15179637206653],
            [-5.230402928081364, 6.146875994886902],
            [-5.217257549021304, 6.141246786668576],
            [-5.213800364549216, 6.1455544037099195],
            [-5.207480575502928, 6.14571371012628],
            [-5.205226977434937, 6.142684571200359],
            [-5.194956958078025, 6.146149774724039],
            [-5.188564345850683, 6.142870383521448],
            [-5.181862823489455, 6.142333141957329],
            [-5.1719860898456025, 6.146652557189675],
            [-5.166969818359003, 6.143185877024161],
            [-5.159970397057034, 6.149750410914539],
            [-5.1557130157229984, 6.151796893562005],
            [-5.148461415088317, 6.150190204492529],
            [-5.1445152896004105, 6.1564561502181245],
            [-5.140812511733242, 6.155485433224316],
            [-5.1398645237051, 6.158623878238574],
            [-5.132436531805649, 6.158912235937296],
            [-5.125679879803999, 6.157617911255369],
            [-5.121713765703267, 6.1521586588218735],
            [-5.119884383109695, 6.147511795463816],
            [-5.117074125204241, 6.145885045744582],
            [-5.108655224764484, 6.150981306329092],
            [-5.101141785703301, 6.145892322181426],
            [-5.095768099969807, 6.149636579875241],
            [-5.089940599619053, 6.1522429862606405],
            [-5.091070987245689, 6.158358259300783],
            [-5.0852147635847675, 6.161528464060813],
            [-5.001980299888898, 6.154567318989525],
            [-4.906237923891728, 6.146412793039489],
            [-4.913689817444601, 6.062557399130187],
            [-4.913616741077619, 6.06048947796618],
            [-4.921245088532251, 5.970808217204824],
            [-4.92125462002873, 5.966967262755789],
            [-4.928213845794542, 5.888241899366535],
            [-4.93168248330428, 5.888466321213014],
            [-4.938793176301806, 5.800828752232212],
            [-4.8523545402666235, 5.794548648190469],
            [-4.85776882320153, 5.721698863637727],
            [-4.861056602341642, 5.6792444311239745],
            [-4.958751772128464, 5.686851155877604],
            [-5.055964757760299, 5.694910317103327],
            [-5.173139946597301, 5.704710117987192],
            [-5.2903179262235085, 5.714476878259264],
            [-5.287107619735032, 5.753580515005293],
            [-5.275931046341002, 5.890205440224414],
            [-5.266461334246054, 6.002869370346298],
            [-5.259847964474999, 6.081676450411823],
            [-5.254651334339054, 6.141862406569729]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.79229060611767,
          "lat": 44.358626714734704
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46081"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01266996"
      },
      "bbox": [
        -5.2903179262235085, 5.6792444311239745, -4.8523545402666235,
        6.161528464060813
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.17173364388277276, 5.529183483486715],
            [-0.08615008306665635, 5.528315324785385],
            [-0.07019282679836587, 5.528394312012323],
            [-0.04220962525258583, 5.527838578792558],
            [0.049936359785026425, 5.527348406001313],
            [0.08802566962838672, 5.527288834796461],
            [0.1401688452901463, 5.528065157286642],
            [0.13960016326732672, 5.442577436132967],
            [0.13911592319321295, 5.369818162773781],
            [0.13907095906504555, 5.340377953058554],
            [0.138682581304729, 5.309572932622421],
            [0.13835446764716983, 5.210205374132428],
            [0.13815705338936562, 5.181067316142762],
            [0.13815704416418823, 5.181062575626108],
            [0.11278479813309852, 5.180197726889996],
            [0.10115672186985188, 5.179441337781293],
            [0.08152552652832606, 5.179377001098666],
            [0.009921775345360423, 5.180194589672547],
            [-0.008658157739900835, 5.180824056714961],
            [-0.04225060763102379, 5.180838805312681],
            [-0.1314991226389208, 5.181607672062605],
            [-0.17459829422942214, 5.182145452915877],
            [-0.17375614097883477, 5.290015689368406],
            [-0.17282678120844855, 5.370649679908732],
            [-0.17185852888051453, 5.471835387667398],
            [-0.17173364388277276, 5.529183483486715]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.67087068014511, "lat": 44.02195863444892 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46101"],
        "coty_name": ["Moody"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moody County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01265775"
      },
      "bbox": [
        -0.17459829422942214, 5.179377001098666, 0.1401688452901463,
        5.529183483486715
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.408181893203093, -2.2244086744313805],
            [8.41059890999448, -2.219675820620182],
            [8.421392820687023, -2.2197208522544494],
            [8.433631742085339, -2.224444659268203],
            [8.436261755831762, -2.222806896507162],
            [8.445330494057085, -2.2231173956191195],
            [8.445511786067982, -2.2164900726370913],
            [8.45077595711662, -2.216754514502012],
            [8.450959878806792, -2.2232754318163903],
            [8.454596660035707, -2.221270174841221],
            [8.453803037852158, -2.2180568578350996],
            [8.466691802314623, -2.217162479278588],
            [8.46829876083438, -2.210719875723922],
            [8.473686054518131, -2.2058236156739004],
            [8.478843189746678, -2.2037210767119473],
            [8.481505954981285, -2.1935554928479415],
            [8.48755848586443, -2.1937936106958382],
            [8.49509702997908, -2.1990473227155287],
            [8.501353973357748, -2.1944703384751705],
            [8.502716956985577, -2.191035343948783],
            [8.507461803099428, -2.191078042262706],
            [8.510911047877654, -2.1952828261458843],
            [8.51981807906464, -2.1958985832613687],
            [8.522207828146563, -2.20106865739661],
            [8.525143905321485, -2.200380825336935],
            [8.52041476944791, -2.1886113068874415],
            [8.523901775065537, -2.185772320378434],
            [8.524017923291868, -2.181034291712953],
            [8.534542775246738, -2.1803641964837204],
            [8.538151138114658, -2.182715018885156],
            [8.539255620778237, -2.1878848803719464],
            [8.537808524051572, -2.19148994632859],
            [8.546622161399743, -2.1966719100842806],
            [8.550219874080662, -2.197738218130369],
            [8.556957050800296, -2.1969929886276045],
            [8.562343570271445, -2.200242074742659],
            [8.565193008252594, -2.1884690053804103],
            [8.567846259158449, -2.186582322730476],
            [8.570223327536041, -2.1816637341047955],
            [8.567927118053465, -2.1766602258230248],
            [8.569144695375996, -2.1725970918467796],
            [8.577576447391305, -2.1724432746522533],
            [8.579876363061631, -2.162755603373966],
            [8.58244741978078, -2.1631270121466186],
            [8.588203020632317, -2.168167748800275],
            [8.593969857646055, -2.165988261678234],
            [8.604131123336229, -2.157383954615894],
            [8.606137604588499, -2.1617391979312472],
            [8.610428184226377, -2.1632829942473917],
            [8.613080216092554, -2.1663573249254173],
            [8.613241461189245, -2.1713909057893077],
            [8.616669149635596, -2.174839113451013],
            [8.617562433390043, -2.178186927134114],
            [8.620681453153376, -2.179747882479586],
            [8.622496796152628, -2.1842369381581874],
            [8.629466577130161, -2.1860448654174],
            [8.630660988086193, -2.1844085405105784],
            [8.637997603204317, -2.190863939420825],
            [8.63814900406684, -2.1964047484362785],
            [8.635663341800415, -2.2024198747295203],
            [8.634914277404414, -2.2080902213732543],
            [8.640931554426258, -2.208477414669344],
            [8.64284581108558, -2.2155938526429395],
            [8.651285893296885, -2.21771296689155],
            [8.654286197578505, -2.2164897488958983],
            [8.657965447765639, -2.2065102341544267],
            [8.670376711925643, -2.2008474669142246],
            [8.671533600459657, -2.2027124843147163],
            [8.676970445686907, -2.1998291615539736],
            [8.696415015188586, -2.209042405761852],
            [8.704443285614236, -2.2103280442556517],
            [8.70743002761035, -2.2139524837508975],
            [8.72599318111502, -2.2473981152574023],
            [8.737583578509321, -2.2586857359017967],
            [8.739927870474967, -2.258692486818771],
            [8.74160482950948, -2.2634610805010174],
            [8.746439754785882, -2.260168263853208],
            [8.750002080903231, -2.266305134141338],
            [8.75283789053855, -2.268624610457234],
            [8.748172155091178, -2.273068979510914],
            [8.747737441656406, -2.2867855988429473],
            [8.736621308622054, -2.305422549924862],
            [8.739317765222482, -2.327903967372473],
            [8.748300797967113, -2.349576830365244],
            [8.746189527167179, -2.3604531311156727],
            [8.751919825349562, -2.362227463783568],
            [8.75288701057881, -2.37111210275918],
            [8.756930170631165, -2.373536981880834],
            [8.756976220137082, -2.3765912417950394],
            [8.75378258047962, -2.381024886551611],
            [8.748874637179615, -2.3851007622442344],
            [8.74245526776993, -2.3886959837672],
            [8.742083871174692, -2.393930762728319],
            [8.753698549246455, -2.3901407527974574],
            [8.759956919833973, -2.386013393293374],
            [8.766028869714358, -2.3868457155945215],
            [8.766868356741135, -2.3930854425738546],
            [8.760071259082396, -2.40068435244744],
            [8.75579823195783, -2.4074520224226728],
            [8.746247612633502, -2.4155791310806856],
            [8.74132135475363, -2.421533443838831],
            [8.74158771238387, -2.425179078349323],
            [8.74495046544116, -2.4283319867538893],
            [8.751683931762031, -2.4279910895429033],
            [8.761247826976977, -2.4220468886322974],
            [8.771950239644163, -2.4208565864301788],
            [8.774540840764168, -2.4227833230807203],
            [8.774545038224913, -2.4271778397605006],
            [8.765566422762156, -2.4371989855010665],
            [8.759603658448718, -2.4485690356456504],
            [8.755811567406127, -2.451044944068137],
            [8.750946285924206, -2.4509205688275353],
            [8.745406361201718, -2.446564032081379],
            [8.740067263166424, -2.4449449675921318],
            [8.736668571313137, -2.4476731938961653],
            [8.718280063928347, -2.4448314904111577],
            [8.709792346142441, -2.4429895563667214],
            [8.70542072166221, -2.439359534555136],
            [8.693445548858762, -2.439617229004009],
            [8.684702302397797, -2.435752718534118],
            [8.678969537007559, -2.434895290082839],
            [8.679743374654288, -2.439666354661582],
            [8.675059092000852, -2.4402336697461986],
            [8.674928230765342, -2.4368615807119265],
            [8.666386545748516, -2.4375633045423686],
            [8.660098235402822, -2.441488256588482],
            [8.661873068638469, -2.444326944263971],
            [8.651179418763135, -2.4449852447543616],
            [8.649419303082704, -2.4360824137702584],
            [8.631231372733685, -2.4398887800309246],
            [8.63004294134673, -2.4444409706713968],
            [8.621327558358011, -2.444363219451302],
            [8.60719755208832, -2.4457817594379336],
            [8.607208854352521, -2.452364697640519],
            [8.604228343501838, -2.4521294092625645],
            [8.604044248040426, -2.447576859536883],
            [8.593680340449142, -2.4474606157389567],
            [8.582606870238966, -2.4488850580736523],
            [8.582892162666436, -2.4549608855699003],
            [8.578505823617673, -2.456587430283175],
            [8.573574095341131, -2.456733703386189],
            [8.572745254598663, -2.4536058079021656],
            [8.56581987776959, -2.453061902553818],
            [8.56320445320359, -2.450575636780007],
            [8.568764331062559, -2.442525853751011],
            [8.564875598040691, -2.441500760367374],
            [8.551781099010881, -2.4257555582981545],
            [8.51990353263904, -2.39871299871366],
            [8.476530041043299, -2.3562192181390214],
            [8.4720574090138, -2.352655683140064],
            [8.457126658852268, -2.3459823270375164],
            [8.44447083076678, -2.315353568019286],
            [8.443859284612012, -2.3093530665669566],
            [8.43743179386048, -2.3038720757530537],
            [8.434888081949813, -2.304759096774684],
            [8.431435553520512, -2.3003124811426807],
            [8.435099501722851, -2.2922643203152835],
            [8.434590669937274, -2.2822838582049654],
            [8.433004983817069, -2.2771957654695667],
            [8.42737323398168, -2.2766053021876136],
            [8.424528525359184, -2.2729452928885427],
            [8.42371329761323, -2.2674090050700793],
            [8.417626447694289, -2.266243069080964],
            [8.417668776900609, -2.26073028163183],
            [8.421131934656035, -2.259577756706126],
            [8.421011761150858, -2.2519949929041068],
            [8.413590871911182, -2.250951689505027],
            [8.41264780288749, -2.2441843650090227],
            [8.413615978741936, -2.2378806602060193],
            [8.408102424010062, -2.2365830203027155],
            [8.407218986880702, -2.232073762308099],
            [8.408181893203093, -2.2244086744313805]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.83281020636787,
          "lat": 35.979856994810575
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47041"],
        "coty_name": ["DeKalb"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeKalb County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01639738"
      },
      "bbox": [
        8.407218986880702, -2.456733703386189, 8.774545038224913,
        -2.157383954615894
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.754400462546385, -2.967605304702903],
            [7.755895559780418, -2.9450411761666024],
            [7.755761419845966, -2.9326044073184985],
            [7.76998188751596, -2.923554745538522],
            [7.77335991395506, -2.9269163951878907],
            [7.781887928250266, -2.926768970669936],
            [7.783679177251663, -2.92345969362872],
            [7.779102936246081, -2.9180266725680344],
            [7.800728939937206, -2.8983425106773852],
            [7.811447222132008, -2.8840468756457915],
            [7.811251450780408, -2.874731017586296],
            [7.812713269398127, -2.8682430807202883],
            [7.812841119134265, -2.856505644223167],
            [7.816916784918236, -2.856574172158403],
            [7.816821057709338, -2.874142745223532],
            [7.818116733272088, -2.874994993429577],
            [7.833317011475278, -2.85021665094329],
            [7.840075396035883, -2.82398934051353],
            [7.83914597142867, -2.8153597666664822],
            [7.836320651271548, -2.8153602258111654],
            [7.836555034673271, -2.8076134356568643],
            [7.8415216222270985, -2.8075883295038317],
            [7.839057019583885, -2.7990906543954805],
            [7.844384741477488, -2.799947754307738],
            [7.845621651411098, -2.7917280868329137],
            [7.834792000514079, -2.7916232709563484],
            [7.834717311140728, -2.783246885384152],
            [7.843416237179024, -2.7776282314056604],
            [7.845876024524884, -2.772643550631225],
            [7.846948414566024, -2.6758558806085415],
            [7.853569518817001, -2.672173008207158],
            [7.854641594783469, -2.679535822792822],
            [7.8593885056579875, -2.6796455478881707],
            [7.861897058974885, -2.6692231630950713],
            [7.861153764214658, -2.667924067535373],
            [7.869862884179605, -2.663319871190612],
            [7.869962771931376, -2.666570219548969],
            [7.876108821481114, -2.6665236129100154],
            [7.877550031963065, -2.668799864064085],
            [7.882010078502801, -2.6664284369360245],
            [7.880958359657653, -2.6601311106144085],
            [7.887253897939952, -2.659996092887689],
            [7.887382969859365, -2.6664612489166983],
            [7.8942128446405135, -2.665863479491635],
            [7.898436218731219, -2.6640123951511074],
            [7.908796296091301, -2.6673711813203544],
            [7.910626955471485, -2.6591800024809618],
            [7.938129954232586, -2.6578332626456955],
            [7.938699295881033, -2.652274575759832],
            [7.946264656120596, -2.652355454847995],
            [7.950749428612391, -2.6524020880271504],
            [7.949707573886928, -2.6580478810800185],
            [7.956949489375314, -2.6581372546951165],
            [7.957118517606871, -2.6645462608712562],
            [7.967667376994698, -2.665653518263624],
            [7.967664508617989, -2.667861860132646],
            [7.976121400162484, -2.6681205696868413],
            [7.983755972664202, -2.6699494582349566],
            [7.986103345182454, -2.6728952263751107],
            [7.987203490270493, -2.6824798768485367],
            [7.986925548615944, -2.7190080425924665],
            [7.986853175274161, -2.760438744335755],
            [7.985654884388614, -2.7729243326058723],
            [7.9784990252467916, -2.7724342444815786],
            [7.976903500981303, -2.779139471905257],
            [7.983252281738525, -2.7823433149648418],
            [7.987469624306164, -2.780709454452993],
            [7.988996608783065, -2.777498505365366],
            [7.9940500951668705, -2.7767965403942756],
            [7.996820954183612, -2.7824546324115706],
            [7.995390270043006, -2.7856876242206474],
            [7.986157763041507, -2.786099742576683],
            [7.985507810475248, -2.869573875626363],
            [7.988202807307666, -2.8866615744166246],
            [7.987906164646589, -2.9053260752606653],
            [7.994085429325248, -2.904937480744049],
            [7.995849689780912, -2.92573134750907],
            [7.998217387715376, -2.929450828900395],
            [8.020444263454221, -2.969361319694839],
            [8.028035264457039, -2.9724778806696928],
            [8.026086596505314, -2.97721824492015],
            [8.027899489082104, -2.9808599620764746],
            [8.031079515428292, -2.982708159808981],
            [8.031306237952641, -2.9861178161462414],
            [8.034827365757904, -2.991222466437926],
            [8.043540691492613, -2.9899876728532937],
            [8.047310533210906, -2.9927852085032463],
            [8.05008663725147, -2.991579748451793],
            [8.048881532613951, -3.012085864299963],
            [8.047111467204367, -3.014102686982638],
            [8.05092020460606, -3.023005850782451],
            [8.051342873491345, -3.029862192310563],
            [8.023903856718254, -3.038706869454938],
            [8.021006729933816, -3.0418069121496285],
            [8.014915868793583, -3.050909630088907],
            [8.010375878875248, -3.0460931366564097],
            [8.000446807194008, -3.0517268932187904],
            [7.992769501142009, -3.052178008438075],
            [7.990971110977761, -3.0537657618631124],
            [7.9914138310780345, -3.058779376593686],
            [7.977703187941108, -3.069244946822059],
            [7.958704131061792, -3.0901893381566325],
            [7.942484664464501, -3.1156018609699254],
            [7.875847807774979, -3.111142713957884],
            [7.8728009146366675, -3.0813813326984896],
            [7.870035554690772, -3.080534322268608],
            [7.867608944980361, -3.0722675716184162],
            [7.8634378797715865, -3.070345717552197],
            [7.8639490105157615, -3.066962655374421],
            [7.859095906835308, -3.0666133900284986],
            [7.8590275589079575, -3.05657020727624],
            [7.85653361014968, -3.055107550244017],
            [7.849158274766353, -3.0612555430273227],
            [7.849401949033244, -3.0677789801370507],
            [7.846159080570116, -3.07077939004604],
            [7.847309217130937, -3.078183890494947],
            [7.843519032211375, -3.0772140590387673],
            [7.84301564977659, -3.072615333861931],
            [7.82487920115135, -3.0727735729612498],
            [7.822793907638716, -3.0693984244919403],
            [7.822774164860453, -3.064138881968336],
            [7.811235679174615, -3.0641318234557713],
            [7.808027632354402, -3.066667750190577],
            [7.804265346039741, -3.0629033337996883],
            [7.802783204381995, -3.059112674763671],
            [7.804920754570972, -3.055931612513732],
            [7.8096076527230585, -3.055683820226012],
            [7.8091111987630635, -3.042881728393923],
            [7.801043376884202, -3.040922360504877],
            [7.801595664086947, -3.0339876048029595],
            [7.803108598284352, -3.030662802889961],
            [7.793365280629351, -3.029508929348056],
            [7.794091646899481, -3.017818004168805],
            [7.788698955301358, -3.0189280615966583],
            [7.788335269230966, -3.0100566874019186],
            [7.7857433157747735, -3.0050417916098837],
            [7.785721702469599, -2.993810701278816],
            [7.784396190771476, -2.9935326230469745],
            [7.784024628443702, -2.979499847047291],
            [7.785844410391237, -2.9747712142969363],
            [7.778678392993374, -2.970293571006172],
            [7.776068113385051, -2.9743890851916985],
            [7.768803354447006, -2.9697196111751096],
            [7.757168357327632, -2.9649904313580517],
            [7.754400462546385, -2.967605304702903]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.76503259703523, "lat": 35.46884079814824 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47117"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01639771"
      },
      "bbox": [
        7.754400462546385, -3.1156018609699254, 8.051342873491345,
        -2.652274575759832
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.974483383945928, -2.388021530066081],
            [7.978099804337926, -2.388108480680553],
            [7.977940589176346, -2.3802538276700322],
            [7.980519114100186, -2.3800836408130706],
            [7.982029553579919, -2.3755726804256065],
            [7.98207633188125, -2.369792030720873],
            [7.979765562631275, -2.369734135217564],
            [7.979645695139489, -2.3645060194607823],
            [7.9747919788234105, -2.3642792617415385],
            [7.975558843163107, -2.345588055244737],
            [7.980734214974274, -2.3448798735299663],
            [7.9846175448318135, -2.3427834093451927],
            [7.988468759030955, -2.334861878990119],
            [7.993968153392785, -2.3279438326177706],
            [8.000878946923741, -2.326042323092417],
            [8.007872531523455, -2.317660075288111],
            [8.012828945884964, -2.316219286349136],
            [8.013771628458535, -2.311542578292192],
            [8.009389601682816, -2.305430763039067],
            [8.008837842868743, -2.300880468658845],
            [8.01122095978752, -2.2972339444487004],
            [8.011037082955605, -2.2931294035431455],
            [8.009018014254233, -2.2896463615379226],
            [8.01020877389199, -2.2839505845403094],
            [8.013801953684757, -2.2853177620167853],
            [8.019343687935443, -2.2851669536004238],
            [8.022410572977233, -2.2836470196217618],
            [8.021624626463653, -2.2725787022644015],
            [8.01944492187179, -2.270059511527633],
            [8.018472407325236, -2.264381364823369],
            [8.021508445871925, -2.2633671367803445],
            [8.025918040006383, -2.272048072967807],
            [8.027373502349915, -2.272914343830296],
            [8.03485200328257, -2.271255460058494],
            [8.03679638363025, -2.274609621950068],
            [8.033903543522696, -2.2890890370890675],
            [8.03581644456646, -2.2913294279366334],
            [8.040778108026386, -2.289413735355417],
            [8.039302554581472, -2.2795302677572193],
            [8.042211754656062, -2.2755886612814598],
            [8.042249567214867, -2.263752615114149],
            [8.043667923025248, -2.2637252928357134],
            [8.043605682030488, -2.246978079681912],
            [8.063094982126778, -2.2598031069402826],
            [8.081207164113982, -2.2721264680105002],
            [8.088327190943312, -2.2748598368743167],
            [8.098079969608879, -2.279938526482262],
            [8.11068168067702, -2.2874472558044476],
            [8.127219375838717, -2.2980168450943212],
            [8.146642580673495, -2.3071312468611693],
            [8.146875265170388, -2.3016157550240988],
            [8.15625013403987, -2.301878547305542],
            [8.156070745907044, -2.3105675245602315],
            [8.152423199815008, -2.310434678472306],
            [8.163024901701622, -2.3247157264179656],
            [8.166106197841833, -2.3175323956778673],
            [8.169982348113066, -2.3180782795546158],
            [8.172860563309923, -2.3214095748068333],
            [8.172835221173395, -2.3251961035938153],
            [8.18875574281454, -2.3342440181566877],
            [8.206259617468193, -2.34771918619422],
            [8.207732048414574, -2.3453388559745085],
            [8.219131496655015, -2.3452509495444125],
            [8.21959454617001, -2.352890296306221],
            [8.238508929131044, -2.3545815156006897],
            [8.238358623555392, -2.356918261242283],
            [8.268381355932055, -2.3589189654079754],
            [8.268161320119503, -2.3655713056756285],
            [8.279484783705673, -2.3661465188245168],
            [8.279732220814363, -2.362207026278778],
            [8.289223533788345, -2.361600893198959],
            [8.290243062309711, -2.355050316723783],
            [8.300972797315945, -2.3562988236557514],
            [8.301004918224349, -2.360357664752167],
            [8.307251775605147, -2.359235755989359],
            [8.320552458658655, -2.3591077419767537],
            [8.320543389332526, -2.363475061110713],
            [8.3333867395211, -2.3627677389531088],
            [8.337405441918865, -2.3594300931234136],
            [8.340792119891024, -2.3625174689631407],
            [8.347456307237929, -2.364209925908278],
            [8.348436952837465, -2.369836099727506],
            [8.348056008459238, -2.3862890741023945],
            [8.360771475143785, -2.4034031365808284],
            [8.358319865366887, -2.409565315394222],
            [8.352429099433538, -2.4095915607064873],
            [8.352199371729458, -2.430882715932226],
            [8.350771420959285, -2.431439529476077],
            [8.35086715798969, -2.4384901358129514],
            [8.347244803547596, -2.435953748120203],
            [8.342452997742399, -2.435730144835628],
            [8.342735696679341, -2.442420649995243],
            [8.340311556820716, -2.4475022508012736],
            [8.339932717597513, -2.470576108894215],
            [8.339864755043829, -2.4971199856195887],
            [8.342199709927472, -2.5013186850762934],
            [8.342005777216132, -2.515973062751798],
            [8.340367812763175, -2.5203156313822985],
            [8.34027539188469, -2.5251173665859112],
            [8.33571241019642, -2.526061074199649],
            [8.336923675600744, -2.534484023426124],
            [8.335473286966833, -2.5397788680699036],
            [8.337820452301607, -2.544799258555395],
            [8.337186899038374, -2.550412881616064],
            [8.34319887636273, -2.5531675893094663],
            [8.343175877225477, -2.5582203584788585],
            [8.340262409415725, -2.5582361800619413],
            [8.338766930719453, -2.565331467902421],
            [8.34030253913406, -2.5680630542896057],
            [8.337501695717991, -2.570650475603334],
            [8.335882887806454, -2.581283151273276],
            [8.329306735831803, -2.5862306582824894],
            [8.326864885563655, -2.591484303664903],
            [8.331292669129935, -2.595647151054432],
            [8.328864633895774, -2.599286964050085],
            [8.329523348830591, -2.606736546421887],
            [8.328249150495411, -2.6114944215930516],
            [8.330440973804007, -2.6199935035581143],
            [8.324065124284912, -2.623545056051322],
            [8.318573445309111, -2.618544070740977],
            [8.314961810701956, -2.6277663329710714],
            [8.310585857997832, -2.634838575792032],
            [8.3045975935225, -2.6358828297995442],
            [8.301354798567104, -2.638082104246992],
            [8.300583860706016, -2.6416787031277376],
            [8.30218450955055, -2.6472910180499674],
            [8.305302730937397, -2.6526204395954585],
            [8.306457858101194, -2.658264284042902],
            [8.301673846213953, -2.6607547552459696],
            [8.302060911863592, -2.664855283689599],
            [8.304759164357687, -2.665196828858884],
            [8.308205016944184, -2.668704905049724],
            [8.305894957792182, -2.6782922453882803],
            [8.306586675064851, -2.6845844405009403],
            [8.309953242412684, -2.690354083923259],
            [8.307439152412602, -2.695199816322585],
            [8.297426542213941, -2.696221176738364],
            [8.294472403147013, -2.6904695381891077],
            [8.28948885735217, -2.68908450045191],
            [8.28731729837178, -2.6864075022176777],
            [8.283787576686713, -2.6868112248825144],
            [8.278238996171682, -2.6840345321245667],
            [8.277066043743133, -2.681395731293392],
            [8.271767981039021, -2.6823064238744765],
            [8.27279606676499, -2.6871081610140037],
            [8.267109211224563, -2.6837754396863187],
            [8.261012652032171, -2.6859799104600888],
            [8.256575440036483, -2.6834274721327707],
            [8.25926871195866, -2.6804022207587996],
            [8.2607946637373, -2.675846733450602],
            [8.257352808927145, -2.6723312799324797],
            [8.252140759582833, -2.670803188056549],
            [8.246745020510696, -2.6721355889468534],
            [8.243291686016699, -2.6709359277878577],
            [8.238057907031221, -2.671422371709834],
            [8.233517419504143, -2.676278603468905],
            [8.231532436209584, -2.6723369799344563],
            [8.226582428316895, -2.670703496504196],
            [8.222869834403472, -2.6766905257712117],
            [8.218322574334865, -2.675371134973291],
            [8.217511924939974, -2.6804394010231802],
            [8.220690420070506, -2.6824624928303837],
            [8.219822746273021, -2.6855983694168044],
            [8.213935025370992, -2.6859986249682453],
            [8.211076098893658, -2.6844179564941975],
            [8.208341324759546, -2.688554908149318],
            [8.203267874107771, -2.691764072157029],
            [8.200406536332327, -2.6906918558761026],
            [8.199369449110069, -2.695187956111033],
            [8.20266627107782, -2.698550233411063],
            [8.202616027525728, -2.7029826256982403],
            [8.20517638092202, -2.7069007662585887],
            [8.19987868123512, -2.7082610648695407],
            [8.197648501649077, -2.7116187502102647],
            [8.188584869801852, -2.7127268841634136],
            [8.1881874195056, -2.7161973981926697],
            [8.182538553097329, -2.7214628402003758],
            [8.180221289867651, -2.7180240085874794],
            [8.173292123602327, -2.7177320166792462],
            [8.169392093530478, -2.712977888012228],
            [8.171780073478214, -2.7008188958129207],
            [8.167334133888883, -2.7006664708955705],
            [8.16824265579649, -2.691437750342739],
            [8.157318239712465, -2.692439705588116],
            [8.155656413409936, -2.695472334861933],
            [8.15122791333517, -2.6976178935576676],
            [8.146065576605409, -2.6971799009591857],
            [8.14601853340181, -2.6998641384186373],
            [8.137979563619236, -2.699644474633134],
            [8.137914976574754, -2.707141276847237],
            [8.132932922225127, -2.7069374651523157],
            [8.132855817886254, -2.699523849215944],
            [8.123242294696821, -2.6993303373116855],
            [8.123288757925003, -2.6908051629861385],
            [8.110512572668917, -2.690325119875842],
            [8.105393497817772, -2.6892419300569217],
            [8.10539509762891, -2.686406358197743],
            [8.100407175443134, -2.686254848344078],
            [8.098386547902246, -2.680724642758091],
            [8.09543193135097, -2.6773179712525734],
            [8.091655025348771, -2.6771328163650123],
            [8.091779818802564, -2.672827180177832],
            [8.083034137856863, -2.671520991988929],
            [8.08496475921992, -2.668456067803638],
            [8.085108757565129, -2.66052997298607],
            [8.081338600971257, -2.660782351307608],
            [8.075708334681755, -2.658436603895173],
            [8.067105476165766, -2.658439505269721],
            [8.061958513073014, -2.6568833405687857],
            [8.06207950290917, -2.653488844766151],
            [8.041923347805328, -2.6538480627563],
            [8.031448750491975, -2.654777692224276],
            [8.01583982302907, -2.6540735455551236],
            [7.9968540340836824, -2.6546918484011295],
            [7.986969496542084, -2.656520299000898],
            [7.986103345182454, -2.6728952263751107],
            [7.983755972664202, -2.6699494582349566],
            [7.976121400162484, -2.6681205696868413],
            [7.967664508617989, -2.667861860132646],
            [7.967667376994698, -2.665653518263624],
            [7.957118517606871, -2.6645462608712562],
            [7.956949489375314, -2.6581372546951165],
            [7.949707573886928, -2.6580478810800185],
            [7.950749428612391, -2.6524020880271504],
            [7.946264656120596, -2.652355454847995],
            [7.943616577446092, -2.6493712496252178],
            [7.943550239803052, -2.6441938758116876],
            [7.935016010328976, -2.6455731687913393],
            [7.933756481614758, -2.6408511199640796],
            [7.93412629656782, -2.6314862430760795],
            [7.933517396107958, -2.6107784347740903],
            [7.945819690101037, -2.611867978424463],
            [7.947076797354591, -2.6054723385808085],
            [7.94720587929229, -2.5958224384134176],
            [7.952100733480053, -2.589299789548241],
            [7.958149995543292, -2.5894682826442916],
            [7.960545891760493, -2.5928294758164965],
            [7.960416143195566, -2.5787272452853407],
            [7.956653882129269, -2.577544777596653],
            [7.958512402090905, -2.573866931876873],
            [7.956948110526467, -2.5693753022232038],
            [7.96900180467878, -2.5686575896545336],
            [7.9691332873716805, -2.563490317467004],
            [7.98120671131548, -2.563386600817731],
            [7.987650797608305, -2.562468109722324],
            [7.988240889407827, -2.5660273952980712],
            [7.996625351327393, -2.566069154986937],
            [7.997189198680414, -2.552049080369301],
            [7.994509367399014, -2.5463877958491508],
            [7.990268837195537, -2.548292606623972],
            [7.98787587817117, -2.5518440901703365],
            [7.985285458279181, -2.5483822210459763],
            [7.986130817996743, -2.5413711647137984],
            [7.991085997097153, -2.5403825845765144],
            [7.994619934502692, -2.542780358625817],
            [7.994445388534387, -2.5317000565338756],
            [7.9828707007573465, -2.5307611525997205],
            [7.982696137617738, -2.5249803956847474],
            [7.989346606407316, -2.5252972689561384],
            [7.989360855731607, -2.517689314457223],
            [7.999724325812793, -2.5167552689595247],
            [8.000983960311356, -2.51379969742696],
            [8.000681134863195, -2.5019889098646573],
            [7.995086330768629, -2.499865505591962],
            [7.995515401898079, -2.496634561955078],
            [7.990699660326245, -2.496168228212582],
            [7.986006197883678, -2.4923511279794837],
            [7.981020601036693, -2.4741644155380706],
            [7.986975131813508, -2.4723725757303083],
            [7.982289972470813, -2.456515543589896],
            [7.9745948265347915, -2.449791990706526],
            [7.972983700203476, -2.4470007617820513],
            [7.974371862127607, -2.4365489041714588],
            [7.980040473045829, -2.412313435136547],
            [7.971043186511107, -2.402852870944388],
            [7.97241492134368, -2.392447555297238],
            [7.974483383945928, -2.388021530066081]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.41677409815775,
          "lat": 35.842729134563655
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47149"],
        "coty_name": ["Rutherford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rutherford County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01639787"
      },
      "bbox": [
        7.933517396107958, -2.7214628402003758, 8.360771475143785,
        -2.246978079681912
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.04456247704954, -1.5489623565608892],
            [11.048806498815143, -1.5436758191902111],
            [11.05709908708464, -1.536288663500204],
            [11.0615021791343, -1.5395395821503985],
            [11.100906177180736, -1.5432378972641758],
            [11.10799304037245, -1.5484970044960358],
            [11.132361864998128, -1.5408447727898387],
            [11.181697822439105, -1.5244680278682263],
            [11.233779135853574, -1.5079280920689369],
            [11.235791790625958, -1.5158317548330766],
            [11.24016596761204, -1.5137760638455282],
            [11.241966245030822, -1.5100367346265413],
            [11.246784555425862, -1.5044126178217023],
            [11.24840651450318, -1.506061432115851],
            [11.24771363633618, -1.5127492728827114],
            [11.261384178118474, -1.513240430861977],
            [11.262711800656696, -1.5175985100207598],
            [11.260055512259253, -1.5238830279949929],
            [11.264433572693797, -1.527485881492026],
            [11.269203410328739, -1.5263951992968654],
            [11.26919204837543, -1.521115556067699],
            [11.271143109138299, -1.5168367567340095],
            [11.273737413180084, -1.5163384950728576],
            [11.275005403960561, -1.5218020977835536],
            [11.278210276265037, -1.5273096573850709],
            [11.280679172670197, -1.5286074173452173],
            [11.28738156259195, -1.5282381043715672],
            [11.282166044279775, -1.53569614916646],
            [11.287184223631703, -1.5381625648967678],
            [11.288326092656524, -1.5405926247566546],
            [11.28140733060699, -1.549447162694717],
            [11.281161960299713, -1.5539114213856078],
            [11.283666302790905, -1.5549970940683329],
            [11.292246028924604, -1.5461658020535591],
            [11.294298472573486, -1.5426283413483397],
            [11.310841368093302, -1.541591480169141],
            [11.313547273361136, -1.5458547451288864],
            [11.319643500912967, -1.5401491202086162],
            [11.326800373911754, -1.5441440936757118],
            [11.331663851813627, -1.5411445591549224],
            [11.350132289871462, -1.5412283096950383],
            [11.353724350439148, -1.5665710262020405],
            [11.351447679449118, -1.5880425406436829],
            [11.349544866346305, -1.6020893794245434],
            [11.344080173812259, -1.6476454564564782],
            [11.33868578635965, -1.6723319118279585],
            [11.335812794252494, -1.6784260771638264],
            [11.339055266590204, -1.6833001593797632],
            [11.338868042613106, -1.6893717332150295],
            [11.334261681624245, -1.6920187341835042],
            [11.326913645365154, -1.7027216560278668],
            [11.329629986099995, -1.7138905736099788],
            [11.323181764035143, -1.7228416177816104],
            [11.320230442071868, -1.7283320072528623],
            [11.322457483613329, -1.7332155565707947],
            [11.320774405387294, -1.7362291652196313],
            [11.31627252965536, -1.7386116635295923],
            [11.31407995001669, -1.7430053657542395],
            [11.308081395826068, -1.746214706880883],
            [11.29906048315854, -1.7542418595379248],
            [11.299816826955794, -1.7578024801117171],
            [11.294873360796329, -1.7610624144141311],
            [11.289195429129732, -1.7715625659488137],
            [11.288525432507614, -1.7764494973207112],
            [11.291223864110302, -1.7822789204813698],
            [11.288329637460295, -1.7879952777685666],
            [11.281405231165783, -1.7881751884848107],
            [11.279911241284921, -1.7942055810646838],
            [11.277486347958142, -1.7980131355917743],
            [11.273026215605793, -1.7987840283546357],
            [11.236432280991362, -1.803083644057875],
            [11.205687535415889, -1.814359565919261],
            [11.15974154389931, -1.874643529605761],
            [11.118944264993043, -1.8363555065734345],
            [11.120117770811204, -1.8320997221900714],
            [11.116310191287095, -1.828936668829676],
            [11.110871129547101, -1.8304178509066136],
            [11.107837715186955, -1.8000334070057669],
            [11.103373536503467, -1.8004829821441537],
            [11.106934160858325, -1.790954254050644],
            [11.10576410563907, -1.777076845597821],
            [11.101927058019685, -1.7775550403891567],
            [11.102694746719827, -1.7720696415357589],
            [11.0996931159564, -1.766180555862299],
            [11.104710155884586, -1.7657729752351659],
            [11.097531498652485, -1.6789680573443455],
            [11.091647292867638, -1.6106232005715],
            [11.08770565605792, -1.5635146295150704],
            [11.083797773358409, -1.562033469092354],
            [11.084983157032646, -1.5565323948859717],
            [11.030298534981537, -1.5727681966604463],
            [11.040314065159947, -1.5639305178971459],
            [11.04158268116757, -1.5615097319866753],
            [11.046164269956074, -1.559742814083265],
            [11.049298663547912, -1.556854900648987],
            [11.04456247704954, -1.5489623565608892]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.49739396852088, "lat": 36.29332167465856 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47179"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "01639797"
      },
      "bbox": [
        11.030298534981537, -1.874643529605761, 11.353724350439148,
        -1.5044126178217023
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6246616615844353, -7.451993897709129],
            [-0.594293070111185, -7.434569776588985],
            [-0.5812621748680274, -7.427714075482288],
            [-0.5555884670707315, -7.412522954500803],
            [-0.49905883288373665, -7.380224218442017],
            [-0.4791705688364707, -7.368509812667846],
            [-0.4496181926990635, -7.351479074964385],
            [-0.4338907652912712, -7.342766176711679],
            [-0.36906309860906883, -7.30562684202208],
            [-0.3219507030549371, -7.277888955288746],
            [-0.2906772607372602, -7.259288782973904],
            [-0.25977770107973985, -7.240493725738825],
            [-0.21643261890966156, -7.215010342488742],
            [-0.18006632512470566, -7.277958523267347],
            [-0.1630450119279801, -7.307879114718308],
            [-0.1321772452896146, -7.3630733201203995],
            [-0.07839662836961997, -7.457463985170452],
            [-0.04491241979827729, -7.516269424708343],
            [-0.06542666569921964, -7.527925076629998],
            [-0.06942136539413438, -7.53057417343026],
            [-0.13302807939606948, -7.5671049993452035],
            [-0.1582410079769465, -7.582122102990106],
            [-0.16103386602674502, -7.583477344668042],
            [-0.20338272471783428, -7.607304574368811],
            [-0.21237308695936352, -7.6119625813061065],
            [-0.24502863786679685, -7.629839938101215],
            [-0.24422023555361702, -7.624684870131704],
            [-0.31434522074365767, -7.665275286899848],
            [-0.33921633385764727, -7.680737267387967],
            [-0.38157729380362104, -7.706020069569205],
            [-0.4508140762730231, -7.746296270373826],
            [-0.5056746455353613, -7.6531182413741226],
            [-0.5318028995804017, -7.609219269880167],
            [-0.5782795336227717, -7.530802060630322],
            [-0.5861968207578713, -7.517056763530652],
            [-0.5908720050416664, -7.509855892507665],
            [-0.6044631943290196, -7.486343543455816],
            [-0.6246616615844353, -7.451993897709129]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.93587608762043,
          "lat": 31.253249763350095
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48145"],
        "coty_name": ["Falls"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Falls County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01383858"
      },
      "bbox": [
        -0.6246616615844353, -7.746296270373826, -0.04491241979827729,
        -7.215010342488742
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.987377815322324, -4.725660478755564],
            [-4.902421112156568, -4.73166193346915],
            [-4.840791681120858, -4.735762964485099],
            [-4.7883189794539085, -4.739416343332816],
            [-4.68707731487827, -4.746075469749974],
            [-4.682000377453357, -4.746725436866105],
            [-4.551545772903932, -4.755174163443257],
            [-4.554746062986133, -4.824592001216099],
            [-4.56011550146455, -4.944592156336807],
            [-4.562759781320019, -4.9978482158334545],
            [-4.565646018755441, -5.061213882643456],
            [-4.565943295110048, -5.0746251930355815],
            [-4.568236518844263, -5.112358781788634],
            [-4.571470124523009, -5.191327415841979],
            [-4.6066695397925885, -5.1892332380059605],
            [-4.612493852468326, -5.189345421651046],
            [-4.636007290837641, -5.187627635954823],
            [-4.73639845581619, -5.181217628260271],
            [-4.817577266970439, -5.176227020738541],
            [-4.920635212783718, -5.169557065344916],
            [-4.9228326304227945, -5.169164955934079],
            [-5.000909289919493, -5.1638789387276995],
            [-4.997598902527985, -5.05236006993439],
            [-4.99637905034022, -5.023552802373102],
            [-4.992980768556484, -4.909704887906226],
            [-4.992641379336899, -4.894356191806631],
            [-4.9899338728014, -4.802152339033915],
            [-4.989727064649318, -4.80099349517682],
            [-4.987377815322324, -4.725660478755564]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.34318880545611,
          "lat": 33.60762825872733
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48219"],
        "coty_name": ["Hockley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hockley County"],
        "coty_fp_code": "219",
        "coty_gnis_code": "01383895"
      },
      "bbox": [
        -5.000909289919493, -5.191327415841979, -4.551545772903932,
        -4.725660478755564
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-0.7604447131619569, -11.394851587986969],
              [-0.7405153368641391, -11.395257969443769],
              [-0.749628775700721, -11.431480778440708],
              [-0.753276824851703, -11.448425551521382],
              [-0.7575420446929344, -11.471129228871694],
              [-0.7626510991819124, -11.504448182286803],
              [-0.7657169154382536, -11.534587666640066],
              [-0.7678092878093377, -11.550596027426124],
              [-0.7692388042888598, -11.565760862887153],
              [-0.7708563196449196, -11.592202648489664],
              [-0.7719706491296094, -11.6196489730312],
              [-0.7723259401328431, -11.655794123887029],
              [-0.7719270219104176, -11.674569106234635],
              [-0.7705971778385141, -11.704169625737755],
              [-0.7694366624627166, -11.720163796828313],
              [-0.7665768795740645, -11.752428072363728],
              [-0.7606954411127013, -11.796133280236326],
              [-0.7550032026077611, -11.828874947423962],
              [-0.7497629160002186, -11.855560113998994],
              [-0.738912192744528, -11.906005989967747],
              [-0.7311833882884363, -11.937556215496638],
              [-0.7172601030162373, -11.990875266933234],
              [-0.703522535335445, -12.038105028727077],
              [-0.6983366878683763, -12.05512663657497],
              [-0.713470797617837, -12.054993718329468],
              [-0.715281152582236, -12.051314255753166],
              [-0.7178981107778675, -12.039518088098456],
              [-0.7260998397996243, -12.021663377396592],
              [-0.7326694395768876, -12.00960758584885],
              [-0.7343106167808973, -11.997207133890937],
              [-0.7385676247147523, -11.98817414794593],
              [-0.7491015467057, -11.954816122891307],
              [-0.756800569831542, -11.932843309671936],
              [-0.7586504346521635, -11.920440901932313],
              [-0.7654462520478164, -11.902813337680726],
              [-0.7635566558377374, -11.897890186451825],
              [-0.7722489100617985, -11.885908156635907],
              [-0.7765346696251066, -11.872337455902697],
              [-0.7776386031010609, -11.860360217989696],
              [-0.7859402371097022, -11.844052023721613],
              [-0.7836861038825147, -11.821812740289412],
              [-0.791913445178705, -11.793855985727602],
              [-0.7853848441577119, -11.778382355612253],
              [-0.7873795596866059, -11.747734625560861],
              [-0.7832507325534857, -11.714085063340294],
              [-0.7802678013921619, -11.70711866771195],
              [-0.7835848990671458, -11.700783886469013],
              [-0.7860316532054954, -11.693327457623218],
              [-0.783224569170759, -11.676669882026102],
              [-0.781742519595097, -11.648760042871087],
              [-0.7816242054976589, -11.626604093042747],
              [-0.7822866325769804, -11.621030356435568],
              [-0.7801007502132608, -11.58870332041314],
              [-0.7775676744573691, -11.5830726637395],
              [-0.7805287413872882, -11.574580735437596],
              [-0.7801941843378704, -11.566445219276913],
              [-0.7824649677654074, -11.559582002989588],
              [-0.7846897906344661, -11.544713035312583],
              [-0.7805680553835616, -11.539414473469042],
              [-0.7803523000307724, -11.517884505117056],
              [-0.77749103933815, -11.504326844351828],
              [-0.7774655621176603, -11.49546705922633],
              [-0.7725168770277613, -11.477304300740451],
              [-0.7765010833840089, -11.473539290183833],
              [-0.7793639918344681, -11.465875148354618],
              [-0.7698374383912765, -11.46147920614467],
              [-0.7699095797040508, -11.44479067511783],
              [-0.7720634204946062, -11.432399912335796],
              [-0.7721783783080706, -11.425806480029905],
              [-0.761290875150129, -11.422459348710893],
              [-0.7587723303591382, -11.41734557263153],
              [-0.755081355633576, -11.404729216751544],
              [-0.7527860253135721, -11.400333068616343],
              [-0.7604447131619569, -11.394851587986969]
            ]
          ],
          [
            [
              [-0.8161487039526993, -11.906004407419116],
              [-0.8081243048051627, -11.905399565912186],
              [-0.8090528023942054, -11.917245941598004],
              [-0.8159981495660045, -11.917144457520171],
              [-0.8161487039526993, -11.906004407419116]
            ]
          ],
          [
            [
              [-1.3122910198757014, -11.45236069029734],
              [-1.3099674180450358, -11.450705319215647],
              [-1.3059652327669826, -11.451510376142185],
              [-1.2973968235156832, -11.451205235228475],
              [-1.2928533527526098, -11.44955254141881],
              [-1.2916477429197424, -11.446932347592675],
              [-1.2852318797554396, -11.44371938381336],
              [-1.2841931889277487, -11.438510345829522],
              [-1.28213165408843, -11.435230538385653],
              [-1.2813290663851309, -11.429495836856253],
              [-1.2788616322718567, -11.430522326244217],
              [-1.2729397274891296, -11.42796798145264],
              [-1.268169112803747, -11.428637652492542],
              [-1.2652343142871014, -11.425724694966364],
              [-1.2559547590861526, -11.425829354085005],
              [-1.2538817894589052, -11.422229079094173],
              [-1.250701307085279, -11.421506241943945],
              [-1.24967656897827, -11.425811347085373],
              [-1.2462744342282999, -11.426231453197628],
              [-1.2435216351378398, -11.423124025784453],
              [-1.2398627870881749, -11.423099499384607],
              [-1.2364364771004586, -11.425616771890923],
              [-1.232491491658871, -11.42173486308472],
              [-1.230198867752291, -11.42495213532478],
              [-1.2243426250898863, -11.423905249675029],
              [-1.2214008880709522, -11.428384707016821],
              [-1.2130788885898511, -11.422446031295493],
              [-1.206381289003931, -11.424235651195396],
              [-1.2006218068237757, -11.419016444500306],
              [-1.1953010730644036, -11.420569183295264],
              [-1.1913880271127442, -11.415573233257392],
              [-1.18614855178625, -11.417477804678235],
              [-1.1823681984541534, -11.421149205624644],
              [-1.1723416858426652, -11.416056759533129],
              [-1.168313434167262, -11.41572907483546],
              [-1.1591868685993145, -11.410032025058015],
              [-1.1586231567182734, -11.402530000015656],
              [-1.1604472840622162, -11.396867736022815],
              [-1.1588486881815463, -11.394607199533754],
              [-1.154248747843425, -11.394657149848879],
              [-1.1509965036876157, -11.396304300580681],
              [-1.1469967294960564, -11.39328087716876],
              [-1.1427778491402012, -11.395146567798813],
              [-1.1393069508256208, -11.386379209756754],
              [-1.1305316645959496, -11.383256839851166],
              [-1.1247174499357233, -11.383384134432989],
              [-1.1136184866553491, -11.388092124753177],
              [-1.107038365600652, -11.384356956429524],
              [-1.097621083029632, -11.390238566159576],
              [-1.0911995670633556, -11.38936432134066],
              [-1.0895923510179526, -11.394182973370505],
              [-1.0914558552655689, -11.399831184963526],
              [-1.0879664518437575, -11.402928087448705],
              [-1.0805093781789465, -11.405791380461858],
              [-1.0748436731316864, -11.40407180191271],
              [-1.0644283224253974, -11.404963981542542],
              [-1.057301810775074, -11.403167600775832],
              [-1.0554642101746983, -11.399660444923361],
              [-1.0506910989014635, -11.401058366405511],
              [-1.0403430643817282, -11.399924259801951],
              [-1.0268133490983804, -11.395809319885327],
              [-1.0180435889860877, -11.395353261182073],
              [-1.0150928110919297, -11.393683645330231],
              [-1.0083999856771455, -11.39268506172763],
              [-1.002030731770464, -11.398074028096532],
              [-1.0028295015051663, -11.408051556914648],
              [-1.0021095715227435, -11.414536569083545],
              [-0.9980864425839816, -11.423100009064907],
              [-0.9944889523305009, -11.426195432500903],
              [-0.981980204359044, -11.426909953074729],
              [-0.9752878269027881, -11.426114684245531],
              [-0.963911132109239, -11.425895314379819],
              [-0.9434386855781547, -11.430303045587213],
              [-0.9360687101809083, -11.433125588828535],
              [-0.928063061945571, -11.43737697088099],
              [-0.915843510072885, -11.440172045065514],
              [-0.9039443828403805, -11.440415161618144],
              [-0.8953361174713893, -11.438512264287779],
              [-0.8861721710696008, -11.434686062119344],
              [-0.8801853898542196, -11.43031439394607],
              [-0.8773842449124287, -11.425892968144183],
              [-0.86708058037459, -11.42132558449257],
              [-0.8585409526426345, -11.420183078327419],
              [-0.847673842399323, -11.417417634599428],
              [-0.8461515041419154, -11.415213945439858],
              [-0.8346846241738192, -11.409115684023082],
              [-0.8217304568003397, -11.40789317256848],
              [-0.8077824932941154, -11.40981781079208],
              [-0.8075842163245417, -11.414045131598547],
              [-0.8195605872198416, -11.467939654537332],
              [-0.8262196641298561, -11.505268750873123],
              [-0.8184521752185956, -11.50666124303323],
              [-0.8168055904234982, -11.508303949960482],
              [-0.8200712656704624, -11.523632082143964],
              [-0.8224127454913508, -11.54676535454306],
              [-0.8225344816338196, -11.554655570004167],
              [-0.8255933437745243, -11.590325848777177],
              [-0.8066341040733357, -11.594754519878022],
              [-0.8064454183195432, -11.596071910559285],
              [-0.8254722296477247, -11.595994296023896],
              [-0.82743856161987, -11.635227721625691],
              [-0.8311226289774039, -11.677172334772566],
              [-0.8288570795812472, -11.67953411585187],
              [-0.8293400774874475, -11.683675968824678],
              [-0.8320731748290539, -11.684445060450175],
              [-0.8350981637021911, -11.710716304108587],
              [-0.840450468979043, -11.745051395756374],
              [-0.8388240798455739, -11.748214164514044],
              [-0.8276194577025646, -11.7483809788398],
              [-0.827247311992163, -11.751422709715873],
              [-0.8390726362919945, -11.750740800170785],
              [-0.8404498064343087, -11.75173290764616],
              [-0.8425072675833034, -11.769417173153624],
              [-0.844225463241143, -11.778806001648167],
              [-0.8043795388220257, -11.783748359307241],
              [-0.8024444437690261, -11.787420841607522],
              [-0.8041682551381326, -11.790534312458066],
              [-0.8419410154657234, -11.786838170668954],
              [-0.8450013298860434, -11.78820935206735],
              [-0.84780190210489, -11.813073380660366],
              [-0.8358502637368747, -11.826414611517572],
              [-0.8234415703777677, -11.830749511625973],
              [-0.8141834306935635, -11.835542975493455],
              [-0.8066045688526745, -11.840514059826983],
              [-0.8065680581794856, -11.844969405431264],
              [-0.8101351468792442, -11.84511961902272],
              [-0.830539420839038, -11.835504071733286],
              [-0.8363378591457539, -11.837544237074447],
              [-0.8439812545338476, -11.836822315962719],
              [-0.8479421854279514, -11.835345249464037],
              [-0.8522200180891986, -11.8356852953215],
              [-0.8539325877327929, -11.849532469813086],
              [-0.864882987054515, -11.852302450263105],
              [-0.8610698086327627, -11.889624702226984],
              [-0.856910771504616, -11.916341082737278],
              [-0.8566038583161001, -11.9299995690106],
              [-0.8557023579174496, -11.934550917479008],
              [-0.857343403092668, -11.936897927627083],
              [-0.8544453519053978, -11.942924006566935],
              [-0.8569556980754416, -11.946186618056418],
              [-0.8542412379261275, -11.950353873257983],
              [-0.8549476329321369, -11.954468405463679],
              [-0.8541004115862265, -11.961804427422813],
              [-0.8506285002694979, -11.968037170941168],
              [-0.8501111043488665, -11.973313979247726],
              [-0.8469489874990956, -11.982825607797961],
              [-0.8472405825289507, -11.988108203365167],
              [-0.8401028083837565, -12.009750346506962],
              [-0.8372533668614764, -12.020949219942063],
              [-0.8392165772758162, -12.029284856705681],
              [-0.8380997721333574, -12.039820488260704],
              [-0.8383053076239457, -12.044406217793018],
              [-0.8338703645998468, -12.053651153772654],
              [-0.8642029337259057, -12.053293339338602],
              [-0.8875645278302341, -12.051793042805652],
              [-0.9978824145241206, -12.051405892971767],
              [-1.0001773931521551, -12.051686003792723],
              [-1.12548113458592, -12.050624943799297],
              [-1.213127066637138, -12.0490644337426],
              [-1.299048201199046, -12.034000915371708],
              [-1.3240850219729707, -12.029569679025336],
              [-1.3208324222533911, -11.86921084431668],
              [-1.3166323194498442, -11.657322050794587],
              [-1.316493298183342, -11.655850045443767],
              [-1.3130911167396881, -11.49021833780228],
              [-1.3122910198757014, -11.45236069029734]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.70171893118213,
          "lat": 26.928538864588706
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48261"],
        "coty_name": ["Kenedy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kenedy County"],
        "coty_fp_code": "261",
        "coty_gnis_code": "01383916"
      },
      "bbox": [
        -1.3240850219729707, -12.05512663657497, -0.6983366878683763,
        -11.383256839851166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.260754611070187, -4.815973073136383],
            [-3.076487610996848, -4.82405168250848],
            [-2.892219483140052, -4.832103118156804],
            [-2.8734211408200854, -4.8330544505423205],
            [-2.8305453826055906, -4.834870707665961],
            [-2.8344506613317466, -4.957066778976464],
            [-2.837357093787677, -5.046393244374449],
            [-2.8372778919733013, -5.049555485084626],
            [-2.8415087141917197, -5.175351242137215],
            [-2.8445936088846047, -5.2746366862631575],
            [-2.8554849644445026, -5.2739344128620385],
            [-3.059459864580571, -5.264721333200539],
            [-3.065107901588021, -5.264955191398278],
            [-3.280679890039239, -5.254722858386963],
            [-3.275897187215574, -5.15233226517051],
            [-3.275978593005826, -5.149245989771609],
            [-3.2728259344431114, -5.081692930692614],
            [-3.260754611070187, -4.815973073136383]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.25584421420317,
          "lat": 33.61654973309501
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48269"],
        "coty_name": ["King"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["King County"],
        "coty_fp_code": "269",
        "coty_gnis_code": "01383920"
      },
      "bbox": [
        -3.280679890039239, -5.2746366862631575, -2.8305453826055906,
        -4.815973073136383
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5904021236888151, -4.899700887359894],
            [0.5977166096780995, -4.904104792546423],
            [0.6053602718216743, -4.903675871886653],
            [0.6115036489979377, -4.899137876536696],
            [0.6129868755215586, -4.895228625580348],
            [0.6107460670131333, -4.883010375127184],
            [0.614078329207702, -4.8806051036200815],
            [0.6243518546430077, -4.878295212945734],
            [0.6279022179030923, -4.878380226669464],
            [0.6369565409781689, -4.881900054049998],
            [0.6431311425657691, -4.888547063386871],
            [0.6452005230573609, -4.888260265405028],
            [0.6484927691300875, -4.892287602398098],
            [0.6529051197574625, -4.894326717558448],
            [0.6586476265838749, -4.892751905135509],
            [0.6636857069554507, -4.889512264871637],
            [0.668385915355923, -4.883961525501081],
            [0.6684554063641125, -4.878397521221247],
            [0.6603427542087081, -4.866287930052319],
            [0.6594249991820489, -4.865103347671422],
            [0.6599321201269965, -4.856032652713381],
            [0.6644809209527432, -4.84676279594522],
            [0.6730910819891269, -4.8430280855882355],
            [0.6837569824862416, -4.843444661280659],
            [0.6958483094266734, -4.849650808568429],
            [0.6993361031878343, -4.853428907566999],
            [0.7022657335872055, -4.854311472508205],
            [0.7126902213009338, -4.853164894388218],
            [0.7234306491181626, -4.8489923216129185],
            [0.729920961974138, -4.841938618183405],
            [0.7356144506972654, -4.8332787854585275],
            [0.7393203386730985, -4.83011968621885],
            [0.7437053870181874, -4.828989860411441],
            [0.7506587128718003, -4.829856236353833],
            [0.7523111946546496, -4.831633097770021],
            [0.7601851944208948, -4.834055278378744],
            [0.7667699206977753, -4.834030160636254],
            [0.7711477721309756, -4.831115933387356],
            [0.7747644143516104, -4.8206259390794015],
            [0.7796463579544116, -4.811467665892536],
            [0.7832983677818812, -4.810115637962671],
            [0.7900612151391767, -4.809642081104669],
            [0.7942463267518003, -4.804721262601248],
            [0.7958575094441263, -4.796689711449365],
            [0.8017098196247618, -4.797110513154844],
            [0.8088743500200694, -4.804881227206416],
            [0.822956246201888, -4.805709606040126],
            [0.8306585635074698, -4.810577320990991],
            [0.8323430142409641, -4.818816788092043],
            [0.8356893394411742, -4.830168322299354],
            [0.8357456568146711, -4.841980742557393],
            [0.8337516734731167, -4.845779735406879],
            [0.8359429694802336, -4.8560567782985045],
            [0.8385323899891789, -4.858503850474431],
            [0.8429900378293788, -4.858873961028527],
            [0.8483460619012149, -4.857585125074952],
            [0.8591367890497014, -4.8493332375151725],
            [0.8668369795041685, -4.8407131180031575],
            [0.8714246610323524, -4.843586617239304],
            [0.8720328543051048, -4.854950054814719],
            [0.8711519194210795, -4.861418265485555],
            [0.8739084702017467, -4.8639004184332695],
            [0.8779372792017324, -4.8642798148908195],
            [0.8885411184799397, -4.862663302236457],
            [0.8983965929103106, -4.858152453999689],
            [0.9036675720013371, -4.851882275608323],
            [0.9091575068356121, -4.852074209191161],
            [0.9053731966746351, -4.862347693252294],
            [0.9068621259561972, -4.866797243634709],
            [0.9099733201091335, -4.866779645326378],
            [0.924539255396077, -4.871964566046797],
            [0.9357365137477759, -4.8678658758642985],
            [0.9565930141381052, -4.874019663110452],
            [0.9641992052804544, -4.871040533098005],
            [0.9709202250105494, -4.86967545591057],
            [0.9786737389255086, -4.869807746076302],
            [0.9891653551788738, -4.871406646727401],
            [0.9940717064288304, -4.868562048344943],
            [1.0048612520371767, -4.865316474128243],
            [1.0118930828554848, -4.860962357126639],
            [1.014251585410898, -4.858016689326687],
            [1.0159467335918484, -4.8521885204013175],
            [1.0187643577280017, -4.851639643137274],
            [1.0286911645229897, -4.856024001340165],
            [1.0320369449835516, -4.860279717318423],
            [1.0320106080175866, -4.873571958066681],
            [1.0324476184387958, -4.988011469938995],
            [1.0332173523316046, -5.041344672136329],
            [1.033381576724977, -5.075243996105322],
            [1.033809976654036, -5.10138073723199],
            [1.033870675379197, -5.130146384818024],
            [1.0344584297892658, -5.18766339221256],
            [1.0344553084454027, -5.207003590756635],
            [1.0352308091195643, -5.238771992141851],
            [1.0357584102770947, -5.243776101490799],
            [1.0371333078541796, -5.358515633824528],
            [1.0353141111523718, -5.359722705113737],
            [1.0291562411416444, -5.357372068686891],
            [1.0215210801588503, -5.3585569946167375],
            [1.0194733192498526, -5.353873886106777],
            [1.016004102147586, -5.354806393571639],
            [1.0089657976439355, -5.350687931724364],
            [0.9995624218450708, -5.352531519340312],
            [0.9982728212580322, -5.349366418375325],
            [0.9915659756408146, -5.345738339351727],
            [0.9867741074836797, -5.3452989795443875],
            [0.9834972042070507, -5.34709495828588],
            [0.9769125325625676, -5.341978121022786],
            [0.9732029279434515, -5.341511865107827],
            [0.9692059211735896, -5.337357062148604],
            [0.9642168170496555, -5.338781246465432],
            [0.9613815295318829, -5.329839644907153],
            [0.9571282154236448, -5.330742484912691],
            [0.9505211513270552, -5.327795863841611],
            [0.9471517276813698, -5.327505732795187],
            [0.9475212061641953, -5.323427147425377],
            [0.9419183914202306, -5.323913350682897],
            [0.9356609333419624, -5.316740548159411],
            [0.9338477622905658, -5.31254455686324],
            [0.9279132504754227, -5.310507265672707],
            [0.9240028671940884, -5.306734316842417],
            [0.919992937158948, -5.305018042813112],
            [0.9074824752571885, -5.305981515151133],
            [0.9055561017211199, -5.301681118562727],
            [0.9027264108185676, -5.300452636323901],
            [0.9024082087002221, -5.295719046172323],
            [0.8998266750777798, -5.2918280837668314],
            [0.8861933019070669, -5.286278263386623],
            [0.878887503136201, -5.291770312093929],
            [0.8773443609913945, -5.296611052214426],
            [0.87209214253152, -5.297924697907064],
            [0.8692984222238462, -5.295188888673905],
            [0.861947817908447, -5.296005271797207],
            [0.8557416626502947, -5.2941954582795585],
            [0.851942371531632, -5.28788758054557],
            [0.847101625650067, -5.28637915218735],
            [0.8393692501364788, -5.281059077147144],
            [0.8372320250566888, -5.2722807649803185],
            [0.8335852221642622, -5.271769490303535],
            [0.8309581452706237, -5.268751600026335],
            [0.8233796393646038, -5.263129179784374],
            [0.8207085548206398, -5.266487317458966],
            [0.8149265107869375, -5.267817723306247],
            [0.810015275219124, -5.271098136483626],
            [0.8072090816184678, -5.269149112480656],
            [0.8033594277753138, -5.270494307631006],
            [0.8008162429505359, -5.2680165059706745],
            [0.8009050312898645, -5.2601538951151685],
            [0.7953045062648294, -5.259909855523308],
            [0.7946921469251768, -5.256716739783643],
            [0.7889524181362659, -5.2581925075388245],
            [0.7872964787120755, -5.25594717679385],
            [0.7816074735528038, -5.256469615622259],
            [0.777622305562815, -5.25329684796329],
            [0.770253374072338, -5.255211907365941],
            [0.7649710092220315, -5.258322617074932],
            [0.7639560285975284, -5.256295958817606],
            [0.7584181834041861, -5.254328379860241],
            [0.7478233980158321, -5.261508556839045],
            [0.7389052840220731, -5.264981390812467],
            [0.7357577034068937, -5.267915147808266],
            [0.728097616616084, -5.268455511355906],
            [0.7245756584901866, -5.26410547099996],
            [0.7145342390224716, -5.263845171067753],
            [0.7103506721636976, -5.2595206038783315],
            [0.7085747504252661, -5.253945959384313],
            [0.7018031895566123, -5.257027971198787],
            [0.6991294334015914, -5.254805912902101],
            [0.6935087001748885, -5.254758274816541],
            [0.6897401145222772, -5.256484805178301],
            [0.6884769341624877, -5.253866270689908],
            [0.6843551967194397, -5.25403530991665],
            [0.681674877415925, -5.251620136430145],
            [0.6696347519544723, -5.247455929309318],
            [0.6613515146623139, -5.245257979093508],
            [0.6528561650369668, -5.246939321469425],
            [0.65245335591785, -5.249216521855065],
            [0.6476820031350919, -5.249886571365427],
            [0.6446025215321418, -5.254465150561492],
            [0.6391511529527925, -5.254561663952632],
            [0.6311412307430301, -5.262779251646644],
            [0.6229384526532514, -5.265787250798121],
            [0.6212947180856818, -5.270615485675183],
            [0.6180330303077297, -5.271790040847069],
            [0.6130422453262812, -5.276868128007158],
            [0.6075172431867106, -5.278338242802866],
            [0.6080178192585456, -5.281575908714671],
            [0.6019819655134436, -5.280206037198816],
            [0.5888960233577379, -5.283199685127233],
            [0.585157044871509, -5.27965011362756],
            [0.5816062163970891, -5.279238380551387],
            [0.5820631883123688, -5.24496720487683],
            [0.5823402199960634, -5.143027076487539],
            [0.5820594058569811, -5.115384584543653],
            [0.5829010708942043, -5.115383317797589],
            [0.5833378053188355, -4.973450720837707],
            [0.5837481097149856, -4.916080145270635],
            [0.5832707537584089, -4.9118574386804745],
            [0.5864142670067584, -4.903461797144681],
            [0.5904021236888151, -4.899700887359894]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.5712525607831, "lat": 33.66728111783532 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48277"],
        "coty_name": ["Lamar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lamar County"],
        "coty_fp_code": "277",
        "coty_gnis_code": "01383925"
      },
      "bbox": [
        0.5816062163970891, -5.359722705113737, 1.0371333078541796,
        -4.796689711449365
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.233731154670362, -7.745307684371865],
            [-7.230920091086779, -7.745856051005591],
            [-7.097793209796178, -7.790043086807251],
            [-6.964645871039277, -7.834190776870988],
            [-6.847951215261946, -7.872451335119135],
            [-6.731240865339827, -7.9106814518248525],
            [-6.614514738022873, -7.948880967426379],
            [-6.497772749904652, -7.987049721562871],
            [-6.412778417098382, -8.014481975201162],
            [-6.4088591443957945, -8.016192364757616],
            [-6.329213790744824, -8.041377077292601],
            [-6.2431216497721875, -8.04809911721504],
            [-6.249685203319916, -8.149313929352004],
            [-6.274775036817127, -8.455605093694443],
            [-6.2806526535498755, -8.532984468995556],
            [-6.295349008598465, -8.727609922568156],
            [-6.310941428594097, -8.945689975275153],
            [-6.330357989244394, -9.180449589599428],
            [-6.330512950688782, -9.182716526318051],
            [-6.337128909103405, -9.18604489860506],
            [-6.341603858069991, -9.183810359326985],
            [-6.344427120812465, -9.177705225150637],
            [-6.342874101872317, -9.17410004140481],
            [-6.347572725766833, -9.16994886865461],
            [-6.359127054014751, -9.173723907473626],
            [-6.367968822467622, -9.168306136086096],
            [-6.368899080978348, -9.1639163649405],
            [-6.384774253541743, -9.159106365888572],
            [-6.390594054966521, -9.161236183994761],
            [-6.39535498583618, -9.159432353596738],
            [-6.398964672670442, -9.156363093354342],
            [-6.405139085766667, -9.154358585994093],
            [-6.408899235192828, -9.15477679044404],
            [-6.41268232502667, -9.159664598522006],
            [-6.416172571008289, -9.156836075654402],
            [-6.421185540197789, -9.15061641093518],
            [-6.4249421649788765, -9.15073316281575],
            [-6.432608610523822, -9.153306316542398],
            [-6.438441787787323, -9.151540274946482],
            [-6.437643405887988, -9.146666765129591],
            [-6.441672392537706, -9.143028977128411],
            [-6.454162848694215, -9.14252641236654],
            [-6.459170523058108, -9.140020869353943],
            [-6.465092088057943, -9.13862969114984],
            [-6.474246591529413, -9.13509245734697],
            [-6.478079152773794, -9.134848936039903],
            [-6.486500798512268, -9.136695195564219],
            [-6.493284424896693, -9.133004028744542],
            [-6.501455776534831, -9.127268402619386],
            [-6.507838222189367, -9.125690060818577],
            [-6.520791883791515, -9.117872809495529],
            [-6.523562910984476, -9.11792670781958],
            [-6.539276073518639, -9.108386829270753],
            [-6.54019447374236, -9.106563624791956],
            [-6.5534140418788756, -9.096549474222293],
            [-6.552835421983119, -9.090261995795014],
            [-6.56187062758095, -9.086009461639666],
            [-6.5665232935706195, -9.080580839652528],
            [-6.575214641184394, -9.079844758979009],
            [-6.582262480340757, -9.0715541716033],
            [-6.581391681431774, -9.065750290249225],
            [-6.5876928303360565, -9.06254589944329],
            [-6.587252993446536, -9.058664312569144],
            [-6.589693408695466, -9.057281330541928],
            [-6.59402489736384, -9.051305517025261],
            [-6.59662961223683, -9.050136287715063],
            [-6.607068611829886, -9.05189160979483],
            [-6.607942935592394, -9.042839079022283],
            [-6.612270898339225, -9.044686494249307],
            [-6.61778770796673, -9.038303327997099],
            [-6.620609323143718, -9.040130329032863],
            [-6.621119581624036, -9.043625725371479],
            [-6.624231337374063, -9.043715650901794],
            [-6.62501390468049, -9.038580580643226],
            [-6.6308773146328805, -9.035531267064902],
            [-6.631482418147375, -9.0302028421515],
            [-6.639725912121707, -9.030836384723605],
            [-6.645834761459377, -9.023763131118411],
            [-6.642126587253964, -9.020257054044084],
            [-6.647555665017035, -9.016390759251045],
            [-6.645711416411754, -9.012564488921173],
            [-6.649024124470134, -9.010068339208054],
            [-6.654653421383757, -9.008525348920227],
            [-6.654895300706728, -9.004947507691213],
            [-6.657445535235968, -9.001607952222914],
            [-6.6544202377929205, -8.997177526393806],
            [-6.654581379368478, -8.992766798466926],
            [-6.65835273169806, -8.991238941701006],
            [-6.663762679627653, -8.983796989085508],
            [-6.664027888626914, -8.977755258557066],
            [-6.678343303972676, -8.968191806009601],
            [-6.683693216293871, -8.959825634987295],
            [-6.679285853885616, -8.955915033203318],
            [-6.6782116832492155, -8.950184234112722],
            [-6.676021411618517, -8.945906089032947],
            [-6.675800486735828, -8.941442491570966],
            [-6.673797942193274, -8.93763786931143],
            [-6.6769654117487365, -8.93422870366983],
            [-6.679811758441274, -8.93365588081568],
            [-6.688133522893005, -8.935553743785793],
            [-6.693103546481469, -8.937867224348699],
            [-6.6948198854148275, -8.930304211936818],
            [-6.69399129920278, -8.924238400428164],
            [-6.695690772383005, -8.920116225331771],
            [-6.699278476524616, -8.919237073750438],
            [-6.704888183340061, -8.913193058018061],
            [-6.7108228202142906, -8.908932297246428],
            [-6.717024980362857, -8.907423739390984],
            [-6.716694921459717, -8.90173095207144],
            [-6.72429242311927, -8.898887710029019],
            [-6.742340673722406, -8.893576253103516],
            [-6.746146084901713, -8.888612604824038],
            [-6.759133523830603, -8.888133305102357],
            [-6.757850314865034, -8.884666880203188],
            [-6.7594217238669785, -8.880249884958717],
            [-6.763949535792313, -8.879062992386558],
            [-6.766340022606385, -8.881187632294505],
            [-6.768019224159437, -8.88902842749766],
            [-6.771445791205092, -8.887317799525313],
            [-6.775691564074224, -8.887512652148658],
            [-6.778793926635711, -8.890298130406407],
            [-6.782329169892257, -8.889603188707897],
            [-6.798069458574394, -8.875901621444617],
            [-6.809622914288655, -8.863522484283294],
            [-6.815366315860953, -8.865072575522642],
            [-6.817474044926489, -8.863291360716623],
            [-6.828094872305082, -8.849782673368438],
            [-6.827173690576721, -8.846937595984851],
            [-6.8309956118284845, -8.833424578074121],
            [-6.8738678955523715, -8.798559971772914],
            [-6.8777000554735706, -8.792779894712929],
            [-6.885677536373588, -8.79192528320401],
            [-6.885682910774813, -8.782233565761711],
            [-6.891278075020185, -8.781985568114342],
            [-6.8922127270841385, -8.772805726452429],
            [-6.897596849008423, -8.772574904542108],
            [-6.901114911985312, -8.770843384727465],
            [-6.901913774563628, -8.765947892720346],
            [-6.907972363631436, -8.765683469504163],
            [-6.910104199192098, -8.759629412576578],
            [-6.918338193782857, -8.761661868816098],
            [-6.920330779142735, -8.76505249015194],
            [-6.925488604731439, -8.757382418200367],
            [-6.920136984927719, -8.754774315124434],
            [-6.9219725651129504, -8.75167517330972],
            [-6.926240243142252, -8.750795976394148],
            [-6.924918222632052, -8.745704816514161],
            [-6.931740027695249, -8.738312578053659],
            [-6.931821356021855, -8.729545318476331],
            [-6.936894580924262, -8.726569476906173],
            [-6.942615394390069, -8.71809193895118],
            [-6.946479465887787, -8.715359951997419],
            [-6.943044817512118, -8.71185928208804],
            [-6.937050903039031, -8.711616481661848],
            [-6.933860815805552, -8.70616049972206],
            [-6.944795543777515, -8.700316766248314],
            [-6.946327715074466, -8.69688964065181],
            [-6.943652478978757, -8.693144297545365],
            [-6.945700099177923, -8.687427971352886],
            [-6.943524805965559, -8.685644770920689],
            [-6.943918048090309, -8.681297089554086],
            [-6.949756116932663, -8.67313215249219],
            [-6.946539157710042, -8.669481501875605],
            [-6.946711347750897, -8.665637786298442],
            [-6.9518323063784395, -8.665011175388686],
            [-6.951584070653016, -8.661509751666374],
            [-6.95395499324437, -8.657987039472312],
            [-6.946595198778029, -8.658653623268506],
            [-6.945967717462486, -8.656179059397598],
            [-6.96237525679579, -8.642580436449537],
            [-6.957196639654866, -8.634506279903738],
            [-6.95973918936522, -8.628833948084702],
            [-6.957017850883169, -8.625573766912417],
            [-6.96059142945402, -8.617283931555452],
            [-6.963262894274081, -8.614173257052414],
            [-6.967361719020897, -8.612196307251663],
            [-6.966318806791598, -8.607691232077764],
            [-6.969522496328134, -8.602562584935445],
            [-6.968460314831713, -8.600063819492782],
            [-6.975059895355634, -8.598826034829619],
            [-6.976315604231299, -8.596080847184309],
            [-6.9724708267205475, -8.594223799519598],
            [-6.97189123921151, -8.591756257037083],
            [-6.976761873612308, -8.587556473809272],
            [-6.979290636072202, -8.589173716755974],
            [-6.982261644663286, -8.583035567841073],
            [-6.982948736839226, -8.578293328969472],
            [-6.990946533035765, -8.573957744455194],
            [-6.988591895156154, -8.565391712311449],
            [-6.993200661234411, -8.565273783568626],
            [-6.998104316757355, -8.562663858054288],
            [-6.98977508048639, -8.557254791086615],
            [-6.98855025930431, -8.55390782232214],
            [-6.991744512161186, -8.547421146087096],
            [-7.00139435430757, -8.549842567145685],
            [-6.998252548142246, -8.545538205495694],
            [-6.998735790172473, -8.541841747261227],
            [-7.002342978202675, -8.541567841892205],
            [-7.00515209927249, -8.538939864454731],
            [-7.004181063590218, -8.527788468808923],
            [-7.006330934974774, -8.521768970257655],
            [-7.01168568422824, -8.51836645846363],
            [-7.016675178188585, -8.512828769477006],
            [-7.016978616652295, -8.507526668047095],
            [-7.021094823316292, -8.502594937255505],
            [-7.026307718133026, -8.499022935043262],
            [-7.025265018745709, -8.495399621916622],
            [-7.025748403084917, -8.489276569380488],
            [-7.03136854076941, -8.488475312283608],
            [-7.030925427346674, -8.481320426447343],
            [-7.034605235878906, -8.478135553624929],
            [-7.037920025770748, -8.479109988423861],
            [-7.040374404168823, -8.475908474647467],
            [-7.039184381202392, -8.47356475284428],
            [-7.041894364442313, -8.468421262790555],
            [-7.0402948691541996, -8.462884543634285],
            [-7.042087530536746, -8.459379739144568],
            [-7.040761230198905, -8.455835291317744],
            [-7.043006769150557, -8.453627524142384],
            [-7.038444456267821, -8.448774422417033],
            [-7.040352637180984, -8.444014129806861],
            [-7.037011967817554, -8.439750055800149],
            [-7.03439374639305, -8.43940149548782],
            [-7.033292332002668, -8.433556356237238],
            [-7.042559839996041, -8.43340098479313],
            [-7.039257450424035, -8.420462616988887],
            [-7.039210823682955, -8.412930380830298],
            [-7.044665444018083, -8.415838733974649],
            [-7.04740924746311, -8.413133682027697],
            [-7.043796309491425, -8.40933852484329],
            [-7.0404642608722625, -8.399923895309426],
            [-7.042719222199416, -8.395952345703558],
            [-7.041311022921615, -8.393009041644175],
            [-7.042156029473954, -8.387802704464464],
            [-7.046673028596616, -8.38759381456439],
            [-7.045698270579403, -8.383404742223515],
            [-7.042109076701097, -8.37937518710119],
            [-7.041764551991925, -8.37493580827773],
            [-7.04479024036279, -8.370556580553629],
            [-7.052094172026117, -8.367660496684653],
            [-7.053282682445076, -8.364679999816884],
            [-7.049389220866655, -8.355590313609962],
            [-7.045000013624049, -8.352392043189166],
            [-7.045945246351136, -8.34936389102372],
            [-7.053334759516017, -8.338340310924579],
            [-7.05015674322067, -8.333995433254039],
            [-7.048451838789491, -8.329328534464231],
            [-7.049232965248646, -8.324940038237386],
            [-7.044559318482755, -8.324611485655133],
            [-7.04050112144136, -8.321379601295096],
            [-7.036973310207767, -8.31263755982037],
            [-7.032267703718171, -8.308768469521873],
            [-7.035378869106976, -8.301143817655797],
            [-7.031051401576062, -8.298062016842463],
            [-7.036509612586473, -8.294702402414373],
            [-7.037895856366232, -8.288801730414292],
            [-7.0337740236584345, -8.28487242621155],
            [-7.031291457537709, -8.285964280957938],
            [-7.0297484084970225, -8.280806786164774],
            [-7.034728393795827, -8.279648538517094],
            [-7.033510964855007, -8.273279269679698],
            [-7.035370867619714, -8.272633838194004],
            [-7.0368456412174005, -8.265289577448575],
            [-7.03671987469797, -8.2572066830601],
            [-7.032590052699389, -8.252689446945404],
            [-7.027294876683983, -8.24940518053309],
            [-7.026427489610817, -8.24636895407703],
            [-7.029802018553644, -8.241935759028639],
            [-7.026922738016936, -8.23296230462179],
            [-7.026969653743122, -8.226860098179255],
            [-7.024445769078421, -8.218975451511737],
            [-7.024287299824462, -8.213678799737332],
            [-7.02735696211869, -8.209002844954943],
            [-7.028749569471397, -8.202863399686995],
            [-7.0321171116441885, -8.199847153877975],
            [-7.030879023025746, -8.196813105670232],
            [-7.033581402446281, -8.192823835207111],
            [-7.033643806205905, -8.18606799417499],
            [-7.037340435571761, -8.182751552457209],
            [-7.034706364035983, -8.178727276220862],
            [-7.038863106366949, -8.172615166307423],
            [-7.041330440225216, -8.166631461749278],
            [-7.03829418331914, -8.16516043187453],
            [-7.035670989202802, -8.156516327634437],
            [-7.0415838698652875, -8.153035406933606],
            [-7.045440435503329, -8.146427689265991],
            [-7.045670757850227, -8.143761218570607],
            [-7.050040332389301, -8.140220783533762],
            [-7.054386822220772, -8.130972614901347],
            [-7.057188235255943, -8.128449778261963],
            [-7.063040505057299, -8.129675197978871],
            [-7.070788090055981, -8.12716914183473],
            [-7.072202608577806, -8.12466590204536],
            [-7.06837383911447, -8.116006761876315],
            [-7.070856262192757, -8.114594841810042],
            [-7.074455465770321, -8.116290288331992],
            [-7.0791608560673, -8.11540075138931],
            [-7.078774961510623, -8.110720716309133],
            [-7.0759070263060035, -8.10565322771146],
            [-7.076093083008589, -8.094365522197348],
            [-7.077141098166954, -8.08739955246955],
            [-7.081590204330353, -8.081784226657268],
            [-7.087222604796711, -8.084406568820423],
            [-7.090079198130136, -8.080003329019991],
            [-7.089414614231902, -8.077284376682078],
            [-7.094713638721564, -8.070130813704484],
            [-7.097189422196915, -8.070257198163409],
            [-7.100817232895089, -8.063945628430643],
            [-7.100679397319871, -8.060433074512384],
            [-7.105288491218555, -8.055210260438358],
            [-7.11048599420914, -8.054116772070538],
            [-7.1123189832471265, -8.05214611462655],
            [-7.117479713624541, -8.05083836800024],
            [-7.1151313792417605, -8.043309179277754],
            [-7.1196033428816, -8.040607130957218],
            [-7.124941693886294, -8.034147783979664],
            [-7.117798507946285, -8.030990256294242],
            [-7.116727451161084, -8.024219553784976],
            [-7.113756660339912, -8.022142824361294],
            [-7.113981670020575, -8.01818270284775],
            [-7.118189194084157, -8.018629145231476],
            [-7.12075914426231, -8.016099816303091],
            [-7.118499157467357, -8.008754728340453],
            [-7.127595821798917, -8.010603323843242],
            [-7.135725004217339, -8.008996180627362],
            [-7.136532672655044, -8.00698362268784],
            [-7.142193858619078, -8.00311764159174],
            [-7.143901815838104, -7.998420038932201],
            [-7.14865551671359, -7.996429916847685],
            [-7.153073251498221, -7.990947065024115],
            [-7.149960344306615, -7.986632426167079],
            [-7.148416287455126, -7.980449472599365],
            [-7.149560373816294, -7.972792798716855],
            [-7.143366198047226, -7.96838508552803],
            [-7.141423388858211, -7.964805660185362],
            [-7.147804334609116, -7.960139229906386],
            [-7.147431809998907, -7.957757902759048],
            [-7.151440886353956, -7.954975879061999],
            [-7.148181052333207, -7.950310405561923],
            [-7.147369020663257, -7.944783286476488],
            [-7.149055719174197, -7.941987886023793],
            [-7.153017713529585, -7.940272376824189],
            [-7.154995204905989, -7.93743886890516],
            [-7.151751703644916, -7.931717132898419],
            [-7.154825036121761, -7.927461255961857],
            [-7.15557563947137, -7.922712791253917],
            [-7.154153144986775, -7.918274320231653],
            [-7.1517875680241625, -7.916938530411227],
            [-7.151838418695295, -7.911952681946749],
            [-7.153712132223082, -7.907462663569308],
            [-7.153331236511776, -7.902316242739719],
            [-7.150875522769722, -7.896949307971407],
            [-7.149450049779115, -7.889895627661026],
            [-7.155549267133074, -7.886268533638242],
            [-7.153550822032377, -7.879963609715004],
            [-7.154366026627162, -7.877624841993864],
            [-7.152451685463787, -7.870946958278436],
            [-7.156605244986206, -7.870420090065485],
            [-7.159335986505174, -7.8606677398917215],
            [-7.158158297636109, -7.852407472740685],
            [-7.159116171932836, -7.849365081957707],
            [-7.165121508488612, -7.84555959720375],
            [-7.165953889755047, -7.839537162157346],
            [-7.162635364878822, -7.836987619338691],
            [-7.166560024572043, -7.8276021412271035],
            [-7.170660823020787, -7.825631198598832],
            [-7.1683265766453435, -7.818247210889209],
            [-7.170054049865921, -7.809942634745585],
            [-7.1764137680255065, -7.802743367724109],
            [-7.1763113527724185, -7.797344211153315],
            [-7.177746253067762, -7.794454802554709],
            [-7.185533798417398, -7.793398884575588],
            [-7.1873150483455, -7.7889199595914125],
            [-7.18470458098551, -7.784451551272176],
            [-7.186986111582315, -7.779856963043589],
            [-7.187382281947403, -7.7749672985075335],
            [-7.190427258471333, -7.773400390352665],
            [-7.193796927054609, -7.779002903126692],
            [-7.197444804751551, -7.778014868105846],
            [-7.2006905642514365, -7.773936097827479],
            [-7.206655932735907, -7.77393597757217],
            [-7.211203851375842, -7.772538901969747],
            [-7.214212725914826, -7.767016210663653],
            [-7.2183346782509705, -7.765272488433808],
            [-7.224896811981978, -7.7673887715173935],
            [-7.228784110408057, -7.764697877971877],
            [-7.23469686432408, -7.752391194745264],
            [-7.233731154670362, -7.745307684371865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.24050348676552,
          "lat": 29.99976360111073
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48377"],
        "coty_name": ["Presidio"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Presidio County"],
        "coty_fp_code": "377",
        "coty_gnis_code": "01383974"
      },
      "bbox": [
        -7.23469686432408, -9.18604489860506, -6.2431216497721875,
        -7.745307684371865
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.4210414686012935, -3.833421158924118],
            [-4.298209489480496, -3.8411311067749705],
            [-4.120755269900089, -3.852316748339607],
            [-3.992482471883529, -3.8599876987750146],
            [-3.9978818929773157, -3.9552109574275027],
            [-3.9998280513160154, -3.985870437771507],
            [-4.004992539987994, -4.073657017350494],
            [-4.00512886231186, -4.0784104300236885],
            [-4.011061156244826, -4.174608070080873],
            [-4.017739144368234, -4.296856466475363],
            [-4.041302339472493, -4.295585277253313],
            [-4.0940379776562335, -4.292229658435438],
            [-4.255501258826166, -4.282133405773372],
            [-4.348052868524908, -4.276446648474319],
            [-4.448323054707809, -4.270162520649849],
            [-4.4411770983013295, -4.155573305205719],
            [-4.434808989905094, -4.052514100846948],
            [-4.427395187253563, -3.934993380351779],
            [-4.4210414686012935, -3.833421158924118]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.73499731911815,
          "lat": 34.53038545947845
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48437"],
        "coty_name": ["Swisher"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Swisher County"],
        "coty_fp_code": "437",
        "coty_gnis_code": "01384004"
      },
      "bbox": [
        -4.448323054707809, -4.296856466475363, -3.992482471883529,
        -3.833421158924118
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.136435694169915, 1.8957906395962805],
            [-10.09274737281975, 2.1899803579672574],
            [-10.079667356482238, 2.2780625830797483],
            [-10.069407886662061, 2.347165667381023],
            [-10.047955315600813, 2.4916283279119154],
            [-10.026520058772585, 2.6359028469490595],
            [-9.987828544618413, 2.896340007048113],
            [-9.98346096307613, 2.896666412887149],
            [-9.978745718634368, 2.888597628628463],
            [-9.972952326252226, 2.885951702748715],
            [-9.97020983592668, 2.8820023889283424],
            [-9.965600397597068, 2.881380989809008],
            [-9.962483962913447, 2.8772729932793273],
            [-9.956910363220056, 2.8785422169592576],
            [-9.951021400615568, 2.8704950638227635],
            [-9.947517338014311, 2.8711099589775357],
            [-9.945950211622014, 2.8684335199548907],
            [-9.945442273276848, 2.8623495496228264],
            [-9.932941756352214, 2.8601473195347786],
            [-9.930991928129716, 2.8503104031146247],
            [-9.923675332760435, 2.8515318750927885],
            [-9.91970786157513, 2.843163402616483],
            [-9.915517496265663, 2.839169967898689],
            [-9.90940109294639, 2.8398667361153165],
            [-9.904341141735568, 2.838495375016599],
            [-9.897862853892539, 2.8400715991907544],
            [-9.888242651275513, 2.839664212185549],
            [-9.885348316831335, 2.846768021885913],
            [-9.88064671195745, 2.845678825926526],
            [-9.874060254533482, 2.848615490779518],
            [-9.867259253254725, 2.849110666083866],
            [-9.860575371945465, 2.8474135040786823],
            [-9.853856109113435, 2.848799379618015],
            [-9.838928466930476, 2.8457255734850313],
            [-9.834516447612064, 2.8463277067992796],
            [-9.831897390326045, 2.8513524833952197],
            [-9.82598912119108, 2.8575168643722213],
            [-9.825844965615047, 2.862891771816306],
            [-9.822630651952574, 2.865239401048916],
            [-9.815498306137734, 2.8592528568492623],
            [-9.808431677851527, 2.854687466721881],
            [-9.805507853691568, 2.8549761823378996],
            [-9.798776537447397, 2.8605993673036116],
            [-9.795217859982387, 2.859780485916145],
            [-9.783656514542622, 2.860027146858263],
            [-9.77912291808673, 2.858025532895311],
            [-9.77063508862569, 2.850580484275878],
            [-9.766753648675005, 2.8492176772381383],
            [-9.75650145681659, 2.853062807491483],
            [-9.750532404525915, 2.851007286265952],
            [-9.746523990103588, 2.856230362990565],
            [-9.741645152435412, 2.859250694248752],
            [-9.73468350435664, 2.8600136938083742],
            [-9.730310725113275, 2.8649995540390085],
            [-9.72574024408944, 2.8612742512832843],
            [-9.722688920802446, 2.8606665365213826],
            [-9.718001843040268, 2.865568018502349],
            [-9.70880168028224, 2.861247368107063],
            [-9.701888989692279, 2.8627745491886687],
            [-9.69636997412086, 2.8687379519582525],
            [-9.692052547767041, 2.869165561217963],
            [-9.687130670263905, 2.8641255963556573],
            [-9.684968098292233, 2.8573238255274456],
            [-9.673172189323203, 2.8604555814410233],
            [-9.67198686412728, 2.8624255405070844],
            [-9.664992368592266, 2.86258290528486],
            [-9.653400649325816, 2.8659259440508853],
            [-9.649589952148673, 2.8626628082157928],
            [-9.649634463738224, 2.858732405093738],
            [-9.644570315963167, 2.8450275415898445],
            [-9.644492452036879, 2.832444713266495],
            [-9.647461394359624, 2.8240998500325016],
            [-9.651878541208946, 2.8197555769001283],
            [-9.650168050980168, 2.8135397553990282],
            [-9.65073164915909, 2.805892723332617],
            [-9.652140356735003, 2.8031461597325587],
            [-9.65182013808439, 2.7955354233477006],
            [-9.6539671222798, 2.791947983876888],
            [-9.652137799026873, 2.7884696752187508],
            [-9.644781566518189, 2.7843104931658798],
            [-9.638523249406516, 2.778561656275248],
            [-9.632158576210143, 2.7742025939299673],
            [-9.624245697548343, 2.776552272073258],
            [-9.622349871568497, 2.778546154698624],
            [-9.620122917805197, 2.7861729522385383],
            [-9.617659625127738, 2.7878448386522368],
            [-9.612373032155642, 2.7870754871195604],
            [-9.609766435145302, 2.784623449485163],
            [-9.60359457920997, 2.7869746847553434],
            [-9.594460453377089, 2.786124342523637],
            [-9.593995170187908, 2.790832341775955],
            [-9.596594518217236, 2.794256461678047],
            [-9.592363711502848, 2.798619303956999],
            [-9.589881289099015, 2.8054437588504237],
            [-9.579122943493552, 2.811351025850062],
            [-9.574071420397782, 2.81310224109596],
            [-9.558246051618742, 2.815144403745896],
            [-9.548755418842239, 2.8820969712412166],
            [-9.405883203915696, 2.862250558362497],
            [-9.415475169917709, 2.789685206381721],
            [-9.387201076640485, 2.7859545125114376],
            [-9.389021005406512, 2.771560850890808],
            [-9.388005643150073, 2.7714154255659924],
            [-9.399671164633316, 2.6837468512951688],
            [-9.371616973968475, 2.6802162392293774],
            [-9.374554306395986, 2.6585066676771483],
            [-9.318670827653037, 2.6509995016188603],
            [-9.3244135710859, 2.607669606357837],
            [-9.336816606898928, 2.5291464724405746],
            [-9.342860056539948, 2.488884120994572],
            [-9.343245910547752, 2.483981603603303],
            [-9.350722291586779, 2.433404587672387],
            [-9.381359885475707, 2.2119980690546406],
            [-9.388184833088985, 2.1624617934500416],
            [-9.403903278523817, 2.0484419524975856],
            [-9.429118939720349, 1.8646374205922518],
            [-9.459074018911512, 1.6503271842902765],
            [-9.481808287540483, 1.4876710011759766],
            [-9.485977532129997, 1.4903962502251116],
            [-9.495522492433645, 1.487526076544168],
            [-9.498367886814941, 1.4898614346905241],
            [-9.50221270060805, 1.4818209273163325],
            [-9.506854553855257, 1.4826500142988117],
            [-9.509967440750648, 1.4860956423095073],
            [-9.512653474811746, 1.4790247540169408],
            [-9.518287191546264, 1.4735176964419097],
            [-9.519308342127722, 1.465889031134655],
            [-9.525820950344839, 1.4649012465745508],
            [-9.52677843307263, 1.4593603753616968],
            [-9.52880783369397, 1.457906886690098],
            [-9.71842493144246, 1.484832611155764],
            [-9.908047300263247, 1.51172087807745],
            [-10.038856187766804, 1.5305807163153626],
            [-10.169667626235494, 1.549422715386081],
            [-10.168564702241941, 1.5568785169773076],
            [-10.221982054617172, 1.5647928516573777],
            [-10.22016188500171, 1.574731167031507],
            [-10.214722521618343, 1.5784944978147601],
            [-10.211748553450366, 1.585342782126621],
            [-10.213640621906128, 1.592253572153715],
            [-10.216259117155548, 1.5948204973978026],
            [-10.21587604036661, 1.6021840157998883],
            [-10.21693431037809, 1.6076010279378592],
            [-10.21539113290467, 1.6167364386064884],
            [-10.216233594489092, 1.6196638869130966],
            [-10.222869239941451, 1.6200525096051022],
            [-10.22563498426373, 1.6221756184494187],
            [-10.227378704369563, 1.6273949100571121],
            [-10.230841074167806, 1.6312796438297041],
            [-10.22739625142324, 1.6332377804074107],
            [-10.218927306107396, 1.633201312546746],
            [-10.215474270591217, 1.6370357110031581],
            [-10.216013993006845, 1.6391551183318545],
            [-10.213293625448854, 1.6441307857415124],
            [-10.213157224163183, 1.650852289573763],
            [-10.21812207825173, 1.6566622922028948],
            [-10.218105302069697, 1.6639340694481564],
            [-10.21476271118501, 1.6704102958416633],
            [-10.211132606530931, 1.673892764113701],
            [-10.206974253332532, 1.6740571545698524],
            [-10.20374905629494, 1.6760455071922613],
            [-10.200538064669402, 1.6812216651160081],
            [-10.20189489734905, 1.6849606823408116],
            [-10.2046548361328, 1.6866018853693954],
            [-10.207264492174657, 1.693003869739739],
            [-10.206270866056482, 1.696482440387811],
            [-10.202837573427097, 1.6988273294093503],
            [-10.202003442645294, 1.7019664679836952],
            [-10.196609919459993, 1.7039734394322599],
            [-10.196057241656623, 1.707349204018674],
            [-10.191885866518879, 1.7102223515135249],
            [-10.189320926588788, 1.7187624656325797],
            [-10.182603009545197, 1.7173352158079418],
            [-10.178436572206133, 1.7191591085581734],
            [-10.183392910350545, 1.7274501430973281],
            [-10.187648066036564, 1.7314036445078498],
            [-10.185272222166988, 1.7404653064290907],
            [-10.181115206503398, 1.740679718251223],
            [-10.174640312072553, 1.738237432089111],
            [-10.169995982931544, 1.744716028355678],
            [-10.167435173648242, 1.7460673333003003],
            [-10.16662014333999, 1.7511726098538887],
            [-10.163085721462824, 1.7553792865402833],
            [-10.163993672644995, 1.7659912210421558],
            [-10.16114613133075, 1.771168536224476],
            [-10.164775154124841, 1.776099929256693],
            [-10.175855238340795, 1.7767393037304127],
            [-10.173670145370892, 1.7819399900631105],
            [-10.169603779070952, 1.7824016815006642],
            [-10.166341570089193, 1.7850643793950627],
            [-10.1646569721272, 1.7895305956627432],
            [-10.164553240803071, 1.7949195401380684],
            [-10.1565325340584, 1.7956198097800944],
            [-10.1521991018854, 1.7940020552995415],
            [-10.147926808287174, 1.7953827792463666],
            [-10.145992812378982, 1.7989301111901008],
            [-10.150419024611974, 1.8043336288738878],
            [-10.15226873114676, 1.813418895362763],
            [-10.154785475546142, 1.8176476726514867],
            [-10.159914467272078, 1.8225737533169306],
            [-10.159379511362177, 1.8273315501079304],
            [-10.157123674070236, 1.8308348241607517],
            [-10.152166592605177, 1.83193702857315],
            [-10.13886611403681, 1.8315578414305365],
            [-10.135437533060722, 1.828759213028748],
            [-10.134753421516557, 1.8235111895702738],
            [-10.137056402540203, 1.8137660173968657],
            [-10.136145141531829, 1.811033830770198],
            [-10.130694011246362, 1.8059642294882257],
            [-10.127322098177945, 1.8094023512659843],
            [-10.130544195278777, 1.8171352680351096],
            [-10.129959106021644, 1.8213084081336446],
            [-10.124378494491905, 1.826124093188629],
            [-10.11898680706532, 1.8365480060158175],
            [-10.113027034118847, 1.8322061137294432],
            [-10.108055829592493, 1.8365589435688503],
            [-10.106189703096623, 1.8443832174525163],
            [-10.102865423261102, 1.852120831175536],
            [-10.099037342655834, 1.8575439137721803],
            [-10.099675078802846, 1.8684903727982156],
            [-10.101573913813315, 1.8727838724542882],
            [-10.1026528355901, 1.8799277880295597],
            [-10.098954522845897, 1.8831539533345845],
            [-10.095938771663866, 1.882806073625883],
            [-10.095130618597116, 1.8758368818156128],
            [-10.09591735231671, 1.8693016251724313],
            [-10.08855548797057, 1.867198049334169],
            [-10.079081862830996, 1.8696368457980965],
            [-10.073230776425463, 1.8675431412327244],
            [-10.069260863046136, 1.863338618971733],
            [-10.064121673050533, 1.8619468969166455],
            [-10.06191822649142, 1.8680006616497506],
            [-10.064133508869874, 1.87238421765342],
            [-10.072774762045249, 1.8777822913878717],
            [-10.074454427441436, 1.8822067592906822],
            [-10.065897300694306, 1.885389404783974],
            [-10.136435694169915, 1.8957906395962805]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.51862402795176,
          "lat": 40.124827666555106
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49047"],
        "coty_name": ["Uintah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Uintah County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01448037"
      },
      "bbox": [
        -10.230841074167806, 1.457906886690098, -9.318670827653037,
        2.896666412887149
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.093852319427874, 6.614508393795146],
            [17.141970134134553, 6.609628359985612],
            [17.1963417827879, 6.6055203171470165],
            [17.202442320398923, 6.608584823659793],
            [17.28890401871245, 6.642317628164049],
            [17.32467615866558, 6.650216506360025],
            [17.370035011289072, 6.6599476964071025],
            [17.370675289060266, 6.659884236970794],
            [17.36940734589483, 6.645157055190337],
            [17.370299010780393, 6.641472626015182],
            [17.375382132184715, 6.629871878749709],
            [17.369082557371605, 6.617715513180099],
            [17.370493981043865, 6.6146557179721475],
            [17.376205665520413, 6.608933537430666],
            [17.376441999894823, 6.604613110843023],
            [17.372503354009908, 6.597595275591758],
            [17.375484716720656, 6.587245576465988],
            [17.377390529203296, 6.581350639744675],
            [17.37527130418573, 6.575021500918818],
            [17.37575501827476, 6.5720834602743174],
            [17.38108749273481, 6.56555892424389],
            [17.38965690259298, 6.564487304023732],
            [17.38961127571819, 6.558705396132926],
            [17.399220988887357, 6.550265674321997],
            [17.400816251133318, 6.544919709611339],
            [17.40030537632935, 6.540504958058305],
            [17.397193864391713, 6.535835997648296],
            [17.396767498392062, 6.530263745359005],
            [17.405809455357886, 6.517886088366217],
            [17.406312990977426, 6.512971756834418],
            [17.402526147636355, 6.501325329556876],
            [17.397768291381226, 6.492024673951132],
            [17.39285561314408, 6.484521883875006],
            [17.391525842219146, 6.479286840801899],
            [17.393826881565445, 6.474564913121917],
            [17.399488314752595, 6.468944486300859],
            [17.400551096214564, 6.456700281299055],
            [17.401701354222734, 6.453927340638055],
            [17.40752081724498, 6.44686111397015],
            [17.417919017696015, 6.442549776501075],
            [17.41960036762438, 6.438518813936371],
            [17.417361082643957, 6.432723805295083],
            [17.41153019432483, 6.431399386667378],
            [17.40970660590321, 6.4296774751293135],
            [17.407949789703405, 6.422538460918445],
            [17.408503669638783, 6.418529945242181],
            [17.412758378857326, 6.412742336591612],
            [17.4068298838319, 6.4000578030419595],
            [17.400794050548793, 6.4005419361798825],
            [17.39467152174871, 6.392473329392674],
            [17.386918300596, 6.388638929492354],
            [17.38472995375297, 6.3863955983504415],
            [17.37755287941308, 6.383564497228663],
            [17.36986270170755, 6.373159937724522],
            [17.369433022067152, 6.367846166460747],
            [17.374794794464897, 6.364474766751207],
            [17.377486460998764, 6.359563471887895],
            [17.37993499570556, 6.348511465922918],
            [17.38442984161408, 6.33924386448444],
            [17.384720786835963, 6.335051042607319],
            [17.38191283726974, 6.331474406153502],
            [17.38203000408567, 6.326955519347987],
            [17.384379102254204, 6.318045305177116],
            [17.379959920086606, 6.30810229424837],
            [17.372477571314946, 6.3016815122256045],
            [17.372997157106614, 6.291976475267327],
            [17.374514708565087, 6.2836158065107925],
            [17.377612935587727, 6.277265061871563],
            [17.377205938814914, 6.269926507320193],
            [17.381456457431725, 6.26448453666994],
            [17.3860547522993, 6.260802048916749],
            [17.394020673878995, 6.24057282457131],
            [17.396471371979477, 6.237303148796733],
            [17.401521519788364, 6.2263275428578995],
            [17.420035946392936, 6.216342725886109],
            [17.429394150000643, 6.207620947023132],
            [17.431044603249266, 6.202559182207833],
            [17.427252241524943, 6.198334272171348],
            [17.42659196705415, 6.195315782019106],
            [17.430350594205688, 6.19125796319991],
            [17.43382788472963, 6.192740794151773],
            [17.43819139172899, 6.197180625465013],
            [17.438473933135963, 6.201711566901093],
            [17.443777033543167, 6.203541865773666],
            [17.449900624354044, 6.197936273053993],
            [17.454405688185364, 6.19657037485582],
            [17.458157774091134, 6.19192498541979],
            [17.463091619085723, 6.181006258620767],
            [17.47476755761939, 6.170831527675409],
            [17.47809209521186, 6.165109857488111],
            [17.36526485448615, 6.141358566780849],
            [17.31563716071278, 6.130972791253574],
            [17.227427691409908, 6.112605343879432],
            [17.141074096909044, 6.093941587081962],
            [17.12319600623364, 6.176307903886835],
            [17.121063768323502, 6.182440374687638],
            [17.11545091472957, 6.208388283040113],
            [17.103309136781977, 6.2659691479272865],
            [17.10001641414556, 6.277807814411836],
            [17.040584591354364, 6.266601362789155],
            [17.039653984110217, 6.266181588683515],
            [17.020757874486193, 6.35742222108852],
            [17.022566487601768, 6.357744397906394],
            [17.009310310698876, 6.4075600823208125],
            [17.00657734526535, 6.428987995681647],
            [17.002382197837647, 6.449424787771532],
            [17.002908337301072, 6.450831877724619],
            [17.036717082313647, 6.457884164847624],
            [17.072740334339922, 6.4638312362127746],
            [17.094079261381076, 6.468354491536226],
            [17.087924203057636, 6.498735821950887],
            [17.076261375898763, 6.557904376305501],
            [17.08374831239081, 6.5593580744164734],
            [17.07215856371566, 6.616187656632773],
            [17.093852319427874, 6.614508393795146]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -72.71398670285625, "lat": 42.99057309645381 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50025"],
        "coty_name": ["Windham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Windham County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01461769"
      },
      "bbox": [
        17.002382197837647, 6.093941587081962, 17.47809209521186,
        6.6599476964071025
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-15.755906554640971, 10.556175716737382],
            [-15.754233423691792, 10.556703470211177],
            [-15.747713390999222, 10.580174589155241],
            [-15.742672706079382, 10.595411875333939],
            [-15.743660650596464, 10.595643300452384],
            [-15.729524067801105, 10.650291869945931],
            [-15.715169849311025, 10.647090853385256],
            [-15.711718165460999, 10.660539782553984],
            [-15.697503353719975, 10.657271574234603],
            [-15.693756126699844, 10.670273214680808],
            [-15.67980052142089, 10.667403943087091],
            [-15.67596684440517, 10.681489198542163],
            [-15.661869105002253, 10.678042614056134],
            [-15.654585579221258, 10.705424675908676],
            [-15.640488627715571, 10.701888099616099],
            [-15.636765077742833, 10.71556666806226],
            [-15.622601032914178, 10.712332231495036],
            [-15.61534927069579, 10.739929340579259],
            [-15.601097086425911, 10.736224651928458],
            [-15.530195107238901, 10.72035304750473],
            [-15.45971541079796, 10.704048165870555],
            [-15.445117110369075, 10.701160115384726],
            [-15.433481133332146, 10.69795667221062],
            [-15.38879358839639, 10.686970293977842],
            [-15.367234979305922, 10.768774107714984],
            [-15.353296865502871, 10.765190547453896],
            [-15.350056277438723, 10.778889027950676],
            [-15.335814072951921, 10.775337087795027],
            [-15.332041824269353, 10.78901723453252],
            [-15.318243094273578, 10.785664215297682],
            [-15.31475694373321, 10.799044693926742],
            [-15.300725531266464, 10.795265093114118],
            [-15.297299388477516, 10.808951051823986],
            [-15.283526113216034, 10.805422806196077],
            [-15.280017711927384, 10.818928234587306],
            [-15.265907493705235, 10.81539153538339],
            [-15.262527793392959, 10.828261658792064],
            [-15.220830388057148, 10.817732157745121],
            [-15.2171772534703, 10.831274389600315],
            [-15.203222781391483, 10.827889937122677],
            [-15.192639858852273, 10.868958349372367],
            [-15.178585605014115, 10.865675708037903],
            [-15.16450031974399, 10.92043224811091],
            [-15.150448382524194, 10.916891763188438],
            [-15.146943907908678, 10.93046484870908],
            [-15.132911756617064, 10.92693366235558],
            [-15.125948308673998, 10.954532088902674],
            [-15.111624667177775, 10.951317780851744],
            [-15.104560010786255, 10.978391793144796],
            [-15.090439910016427, 10.97496886046274],
            [-15.069439422501448, 11.057178824915313],
            [-15.055252253682845, 11.053815014039117],
            [-15.051688321450202, 11.067647493433933],
            [-15.023346580573696, 11.060915021014884],
            [-15.019821389231204, 11.07484106471278],
            [-15.005748288365352, 11.07132370069196],
            [-14.99848571582425, 11.099145997798946],
            [-14.984345693120126, 11.095592955168351],
            [-14.980686729918862, 11.109815189387097],
            [-14.906493944169872, 11.092174229856873],
            [-14.900906877373123, 11.090716484508924],
            [-14.90415573084734, 11.079228389151321],
            [-14.902175138847126, 11.07423223310611],
            [-14.899603496900346, 11.071742058948074],
            [-14.907700825402669, 11.041022539746907],
            [-14.92729015700651, 10.9655290232568],
            [-14.927495091507907, 10.965118048217324],
            [-14.95328170526947, 10.86407264762245],
            [-14.972207717317444, 10.791648937601764],
            [-14.972664914574876, 10.790275682428078],
            [-14.99503451164996, 10.703233380354932],
            [-15.00568052989262, 10.660754210228637],
            [-15.017149967701535, 10.615665584273655],
            [-15.02867339513176, 10.5720835550905],
            [-15.04067113114253, 10.525698410307145],
            [-15.041034386261126, 10.523030240269383],
            [-15.065834087406968, 10.426881574293327],
            [-15.079799494656953, 10.371517984844264],
            [-15.087352780683947, 10.343856032468246],
            [-15.109071269461905, 10.258463865620298],
            [-15.140070797226123, 10.137252666915058],
            [-15.15122555647948, 10.094258966669102],
            [-15.215291923478311, 10.110309540886027],
            [-15.253191189323413, 10.11998782887739],
            [-15.320619880994725, 10.136516458077194],
            [-15.349549001148597, 10.143926993553384],
            [-15.40793351481099, 10.158361489589218],
            [-15.417805600687448, 10.120353405838145],
            [-15.418492830309921, 10.116677358705282],
            [-15.436763860797818, 10.047245955534674],
            [-15.450837038290244, 9.99216829027093],
            [-15.465094861866772, 9.935476371057966],
            [-15.520943726869529, 9.950384138151028],
            [-15.517061393676457, 9.956503650694714],
            [-15.517919063933416, 9.959707077187726],
            [-15.524441108662202, 9.96913554603486],
            [-15.532176086388306, 9.984964299276443],
            [-15.533813328747511, 9.990443043633315],
            [-15.541854861264712, 10.00158652445324],
            [-15.54797861731383, 10.006126821496258],
            [-15.551455317452223, 10.006942010551766],
            [-15.559404928784728, 10.002367383916127],
            [-15.567922262614548, 9.992829562506214],
            [-15.571832522344659, 9.99083769191035],
            [-15.584767892711852, 9.981426853722176],
            [-15.59170100255779, 9.976967849232025],
            [-15.609005111238242, 9.9628429590936],
            [-15.625074178885468, 9.95409944232024],
            [-15.639037089175314, 9.94773897364704],
            [-15.6444540690773, 9.946142055360891],
            [-15.655766202248522, 9.9455865997299],
            [-15.663241208654107, 9.946175993360285],
            [-15.667997506105253, 9.947641163240101],
            [-15.675278676061824, 9.952118285438697],
            [-15.68112565101397, 9.957177835828803],
            [-15.688095503177871, 9.960662013724273],
            [-15.700539437766311, 9.964392147881446],
            [-15.70621379452925, 9.964429674829352],
            [-15.717111310930777, 9.961958636147141],
            [-15.724521296511377, 9.95939458112515],
            [-15.730424327698838, 9.958571579751599],
            [-15.740216763616631, 9.960532561425223],
            [-15.768219760382785, 9.962239382553594],
            [-15.78048953647561, 9.961468858243757],
            [-15.789970707725466, 9.963236285578061],
            [-15.809912835128625, 9.969443889902408],
            [-15.814397588737716, 9.97226136890587],
            [-15.81882547317313, 9.975760005191853],
            [-15.827226812949254, 9.979607319788553],
            [-15.830896878163909, 9.983850593440485],
            [-15.83607060850538, 9.999475630750645],
            [-15.83653371375203, 10.005362638936104],
            [-15.83854393842061, 10.00920129844171],
            [-15.843542686398628, 10.014360376790354],
            [-15.850875337412019, 10.029779866381636],
            [-15.851033431503907, 10.036169728253174],
            [-15.853379231990946, 10.04822948859109],
            [-15.856148478669393, 10.070113493763008],
            [-15.856626700458879, 10.079162482523875],
            [-15.853393720364963, 10.09240889123871],
            [-15.849279128292913, 10.101663754390236],
            [-15.846917948356543, 10.108842062359045],
            [-15.83805447088891, 10.11494308260693],
            [-15.831192944309272, 10.1178213704445],
            [-15.824089778043327, 10.123033682428963],
            [-15.807799397793366, 10.142947410104071],
            [-15.803358885451361, 10.154969753514163],
            [-15.803240049959335, 10.160670328466335],
            [-15.805404239005489, 10.16893385107451],
            [-15.809632632660936, 10.180944040092681],
            [-15.813361751047793, 10.189125117461908],
            [-15.817847925322276, 10.203365611278056],
            [-15.817765374943018, 10.206571299073667],
            [-15.810760738163625, 10.235643312708305],
            [-15.801692719657233, 10.26322426928152],
            [-15.80097274339188, 10.271769593465367],
            [-15.798297547273531, 10.278711093309015],
            [-15.797351266071235, 10.286874466210707],
            [-15.798843521444597, 10.291476008686216],
            [-15.801292288742644, 10.305854488231619],
            [-15.802966624394779, 10.311433584311901],
            [-15.806057496453175, 10.326746758853709],
            [-15.80827847185083, 10.340580315832499],
            [-15.807301203607587, 10.34792903728429],
            [-15.804664842340907, 10.356360924801768],
            [-15.805734525931197, 10.362800732630816],
            [-15.802401345637687, 10.379547976706021],
            [-15.803569357329131, 10.385607516750698],
            [-15.814313486078207, 10.403400926132942],
            [-15.816646781500348, 10.410666396761513],
            [-15.817024586771392, 10.41703025759974],
            [-15.816093271105334, 10.423263249287057],
            [-15.812560556606465, 10.430249803540404],
            [-15.805523077164946, 10.440893653045475],
            [-15.798040406493257, 10.450817386368806],
            [-15.791009375177078, 10.454185636367335],
            [-15.786066525670766, 10.454446454124861],
            [-15.782803037357747, 10.459074912993552],
            [-15.77595416229638, 10.466329981871592],
            [-15.771932160494536, 10.4760005568532],
            [-15.770488432786708, 10.484467660191859],
            [-15.772861815429223, 10.501030229382186],
            [-15.770063393140514, 10.511422980868046],
            [-15.76255654532497, 10.521755452483278],
            [-15.760804401641012, 10.534402756566566],
            [-15.75924030844303, 10.539436450657337],
            [-15.75492378241107, 10.547982884394834],
            [-15.755906554640971, 10.556175716737382]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -119.45175223897567,
          "lat": 47.20567608787937
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53025"],
        "coty_name": ["Grant"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grant County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01531924"
      },
      "bbox": [
        -15.856626700458879, 9.935476371057966, -14.899603496900346,
        11.109815189387097
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.070448134535017, 11.714028138407965],
              [-17.064298315243807, 11.712801665907813],
              [-17.0640643879842, 11.70859263040964],
              [-17.06150091224302, 11.704375259881958],
              [-17.058323556511464, 11.702820900894546],
              [-17.0586000266333, 11.694417774205883],
              [-17.06964625910289, 11.703446129691516],
              [-17.072764061759916, 11.713017432201967],
              [-17.070448134535017, 11.714028138407965]
            ]
          ],
          [
            [
              [-17.055431873294868, 11.943283246985262],
              [-17.049647361642787, 11.942878904802646],
              [-17.042174751131707, 11.95552155374006],
              [-17.03864844719982, 11.957219986858565],
              [-17.037662626832322, 11.960220313111028],
              [-17.020162613227683, 11.973504010533839],
              [-17.02481735949593, 11.97470315274291],
              [-17.025179130312296, 11.978835205328677],
              [-17.022011310743096, 11.980003130088152],
              [-16.94382830265925, 11.95806820621536],
              [-16.906612698753285, 11.94797243717129],
              [-16.885733862716773, 11.941756407395257],
              [-16.87165328182167, 11.938445358959187],
              [-16.780140091762103, 11.912940890931997],
              [-16.745312442271302, 11.903308210681722],
              [-16.7194627658672, 11.896456871271676],
              [-16.689175420334347, 11.888017690269136],
              [-16.674250706113597, 11.884457339316828],
              [-16.627071739187098, 11.872485457199739],
              [-16.577558043452438, 11.859169380888149],
              [-16.545543285915446, 11.84998016828162],
              [-16.507271595786204, 11.840133794544217],
              [-16.507735732739825, 11.838644968576132],
              [-16.422215814493878, 11.814290348279867],
              [-16.350382856941177, 11.795200359691187],
              [-16.278554761321683, 11.776091388226614],
              [-16.206731568848163, 11.756963443207198],
              [-16.134913320735297, 11.737816533957956],
              [-16.13566876998679, 11.732515519643314],
              [-16.139419674977464, 11.728314506556952],
              [-16.144549904777993, 11.727790157103827],
              [-16.145733645587686, 11.722772347975763],
              [-16.14339150990872, 11.7182408137671],
              [-16.1441737427175, 11.714215792238013],
              [-16.14230154731279, 11.706548079935123],
              [-16.138016578205136, 11.698071374778515],
              [-16.133980734081174, 11.69269970017869],
              [-16.13437173622725, 11.688097683091156],
              [-16.13194428135925, 11.679521686938324],
              [-16.132038474657147, 11.676068961528026],
              [-16.12534798335913, 11.666741936015438],
              [-16.131747257235084, 11.658395387277965],
              [-16.13277310605653, 11.65217571878466],
              [-16.125248653048228, 11.647968798812345],
              [-16.123892789265156, 11.639507947954575],
              [-16.11556653553208, 11.633387004092748],
              [-16.11231734306388, 11.627143796390348],
              [-16.108601463748105, 11.6247719644227],
              [-16.110247555816397, 11.622112235333828],
              [-16.11009214286494, 11.614477194678402],
              [-16.107243639098773, 11.607533167065638],
              [-16.107889299752856, 11.597242292568986],
              [-16.113870381326645, 11.59529491400205],
              [-16.124228748082686, 11.599965621691387],
              [-16.126301883944755, 11.595636398291932],
              [-16.13002825287215, 11.594904678503488],
              [-16.136632853169825, 11.596606516362066],
              [-16.142062206810767, 11.594968470894166],
              [-16.143415401716453, 11.59101969955285],
              [-16.150131439561438, 11.588046743147428],
              [-16.151594932753664, 11.585767744705146],
              [-16.15227243317977, 11.57697405415155],
              [-16.14969076834944, 11.57407389989565],
              [-16.15036968984214, 11.56765516655385],
              [-16.14909387298927, 11.561870872665667],
              [-16.145510683490823, 11.558873098490752],
              [-16.153746386232356, 11.553893172154664],
              [-16.15825263782598, 11.556738403965172],
              [-16.164243237076665, 11.557122933286916],
              [-16.16522070418452, 11.552868743784593],
              [-16.16960016668575, 11.551090086309241],
              [-16.172863883799142, 11.54597280454438],
              [-16.17768340360451, 11.545909703150286],
              [-16.18238557377214, 11.543196615645071],
              [-16.186602275761185, 11.542625004574953],
              [-16.19216680978871, 11.537219449063015],
              [-16.196972245325224, 11.53622519163878],
              [-16.201213466029028, 11.53293630781799],
              [-16.206339385342215, 11.53768335698288],
              [-16.213878994741048, 11.538337033821392],
              [-16.218220760387474, 11.535319056066815],
              [-16.223666358260665, 11.53426424255093],
              [-16.234070618856286, 11.536943340464632],
              [-16.239582681338366, 11.53592142484951],
              [-16.248298237609298, 11.53206490598501],
              [-16.25204197732418, 11.536462611122234],
              [-16.26008123736476, 11.536306804475348],
              [-16.263693281116858, 11.532330679083485],
              [-16.266999786977244, 11.532111024070218],
              [-16.270657095635592, 11.534371767606403],
              [-16.276367788623887, 11.52884686803173],
              [-16.281163328262593, 11.527259305565924],
              [-16.283432498303217, 11.524894004580796],
              [-16.293081415360508, 11.524580742622625],
              [-16.297109968598253, 11.525339185046134],
              [-16.29965510851685, 11.523676594690409],
              [-16.29829768156951, 11.517742327611037],
              [-16.2984867873006, 11.513071185738161],
              [-16.289157831017768, 11.500890611131627],
              [-16.290245501762055, 11.49515276139478],
              [-16.288997375442808, 11.491256648790259],
              [-16.285317349116596, 11.486237317607472],
              [-16.287857618511946, 11.477668222455655],
              [-16.293049145317973, 11.475638896171754],
              [-16.29859803541729, 11.470139001804991],
              [-16.303120529776017, 11.467349445762524],
              [-16.306066446521704, 11.468811119589205],
              [-16.310770259161654, 11.468013652637332],
              [-16.312659976541248, 11.465265654036177],
              [-16.31441704152924, 11.458123576578085],
              [-16.32372124769444, 11.449324501979527],
              [-16.32667652118151, 11.448993669486113],
              [-16.32938358302731, 11.445792729894517],
              [-16.328975480572826, 11.439427914539213],
              [-16.330272835335478, 11.43552671464651],
              [-16.33456818857961, 11.43070854210163],
              [-16.338098882004523, 11.429895110377975],
              [-16.34089888990007, 11.42383510395428],
              [-16.340795832208055, 11.418501204828603],
              [-16.347601640855224, 11.415414083990317],
              [-16.34810922567942, 11.412985783198664],
              [-16.34424982595727, 11.408228482460991],
              [-16.34666245026273, 11.404318507564776],
              [-16.350188874792106, 11.401909774149242],
              [-16.35416270322762, 11.396226114174652],
              [-16.35236507194099, 11.392307639417446],
              [-16.353975488160604, 11.383185219804753],
              [-16.34522326745903, 11.371552398157023],
              [-16.34334188126524, 11.36330309348705],
              [-16.342982324024852, 11.351695211179521],
              [-16.348582663284414, 11.346644329882698],
              [-16.35025507213875, 11.341308680402438],
              [-16.346422348128346, 11.338422481143793],
              [-16.3383299415649, 11.33585497670805],
              [-16.33857755010298, 11.332596227613845],
              [-16.332597658337875, 11.32964901925432],
              [-16.33130927007032, 11.321848537079392],
              [-16.324080049239583, 11.317890389135814],
              [-16.315852702822415, 11.319456689784573],
              [-16.30926283021241, 11.317769556199032],
              [-16.305304264395335, 11.318103642660882],
              [-16.300217216989, 11.312784804552043],
              [-16.301018702578812, 11.30940158568017],
              [-16.31098318684722, 11.301351805209752],
              [-16.315066885345797, 11.294061384667975],
              [-16.32075302141661, 11.292969361833356],
              [-16.322017761950164, 11.28886445298799],
              [-16.331547202633647, 11.286319738734608],
              [-16.335044434239286, 11.28429708918805],
              [-16.3378826634713, 11.27999723992121],
              [-16.344405762146526, 11.278219016081257],
              [-16.34479198830556, 11.27393991550997],
              [-16.394700577299748, 11.287376898861002],
              [-16.394979766623702, 11.286484975831327],
              [-16.479649037696657, 11.309883188895132],
              [-16.5643254314763, 11.333255691532461],
              [-16.564896712957033, 11.331239609648794],
              [-16.593987350180203, 11.338470666803786],
              [-16.620502063955335, 11.345644030180152],
              [-16.6494625327324, 11.352668920437763],
              [-16.703105080944912, 11.367361094544458],
              [-16.73338198096242, 11.375491565584872],
              [-16.753621796833084, 11.381646401030451],
              [-16.760970828291207, 11.382986015674886],
              [-16.80254445756431, 11.394214209340317],
              [-16.816494859621127, 11.398397759941686],
              [-16.870295656287613, 11.412748287142948],
              [-16.899685460240192, 11.419995467900058],
              [-16.915544393050126, 11.42351096937251],
              [-16.956476463749013, 11.435111535143166],
              [-16.977413305509174, 11.441339889961187],
              [-16.985626758978665, 11.443349516039156],
              [-17.055517226167257, 11.463313721948504],
              [-17.138729593265047, 11.487741242380094],
              [-17.177679087542284, 11.49876295675675],
              [-17.177510482413485, 11.503222897648357],
              [-17.173646594509552, 11.505219106153477],
              [-17.171217769644617, 11.511615956268772],
              [-17.170101002227035, 11.525859017619046],
              [-17.167515105872685, 11.526056918186937],
              [-17.158958360154475, 11.529922567734523],
              [-17.133325340153267, 11.54977834941292],
              [-17.12847786390461, 11.550246370309399],
              [-17.123016842113653, 11.55307070293969],
              [-17.11890181235793, 11.557572115918049],
              [-17.1158669196795, 11.565834950331515],
              [-17.11009172572326, 11.572412165334445],
              [-17.10888078314302, 11.578037252013111],
              [-17.10975278549372, 11.583260122254805],
              [-17.10225939050241, 11.595093069714707],
              [-17.101708928504653, 11.598875268891415],
              [-17.094757614324696, 11.608315880597472],
              [-17.093296331824202, 11.611889492573907],
              [-17.082764074102272, 11.621080118555644],
              [-17.081029846170118, 11.624638022355937],
              [-17.079879595336266, 11.6319946000932],
              [-17.073854726861008, 11.642842254310708],
              [-17.066831847915882, 11.64234598314006],
              [-17.053012975014504, 11.644519975573287],
              [-17.03334139049394, 11.642075455148634],
              [-17.02353647536482, 11.645947809321443],
              [-17.01794117783795, 11.649322690667338],
              [-17.0156548378577, 11.65290869406433],
              [-17.015952667835137, 11.658050261222455],
              [-17.009704586215122, 11.675758961915884],
              [-17.008403911324194, 11.684868214318088],
              [-17.002406776390934, 11.69289039935065],
              [-16.997421983127005, 11.693457253399922],
              [-16.99953474334349, 11.699979198339394],
              [-17.000020405851558, 11.70492667798665],
              [-17.007131567114058, 11.706553795258264],
              [-17.01179096069547, 11.711481687437303],
              [-17.025815452502226, 11.729547330489119],
              [-17.034708413064834, 11.736252834384587],
              [-17.032638582960587, 11.737163026932452],
              [-17.025571656185168, 11.73169468851195],
              [-17.02322519835713, 11.733257944517517],
              [-17.02293607600592, 11.737271576826574],
              [-17.02543868822173, 11.744414797294418],
              [-17.036720638780597, 11.749823859955049],
              [-17.03681424440345, 11.755916397426226],
              [-17.047433008451325, 11.76861641964716],
              [-17.046396839766846, 11.772884765572472],
              [-17.047257071411007, 11.780560262881666],
              [-17.057063215584193, 11.788086854786124],
              [-17.05610469488998, 11.795209288506936],
              [-17.056427136099344, 11.801087058537425],
              [-17.057943318312724, 11.805280494932008],
              [-17.061764598903633, 11.809482634657337],
              [-17.063559554330542, 11.818337868915826],
              [-17.06055291385464, 11.821566329597955],
              [-17.060529104080025, 11.825080215983263],
              [-17.062868599751685, 11.82733310281207],
              [-17.05901480749657, 11.831378235140665],
              [-17.056426404489716, 11.842053572208965],
              [-17.05699962991167, 11.846361657080806],
              [-17.056326627753702, 11.855646351108273],
              [-17.04331091284011, 11.869642964082022],
              [-17.04678727090042, 11.872803642979498],
              [-17.049247262721863, 11.880025195177126],
              [-17.04596301024711, 11.885326053972337],
              [-17.046246740842726, 11.89361220641368],
              [-17.041558110332307, 11.901745134240427],
              [-17.042053772774008, 11.907020644903193],
              [-17.044100915205348, 11.912090326365167],
              [-17.050234605736144, 11.915791309522506],
              [-17.054460116069606, 11.920724365676918],
              [-17.051306394454553, 11.927468154436282],
              [-17.05403001751603, 11.932936297623218],
              [-17.055431873294868, 11.943283246985262]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -121.6971399983219, "lat": 48.04736192973028 },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53061"],
        "coty_name": ["Snohomish"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Snohomish County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01529222"
      },
      "bbox": [
        -17.177679087542284, 11.27393991550997, -16.107243639098773,
        11.980003130088152
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.152653479167865, 1.3390412201339297],
            [12.173494667968106, 1.3370620485439453],
            [12.175146255697348, 1.3426495260168725],
            [12.180340330242586, 1.349829876409937],
            [12.179601181974041, 1.352121030227236],
            [12.181795686743452, 1.358739763161888],
            [12.185765703152171, 1.3611447859424006],
            [12.184044987766606, 1.3705427517370852],
            [12.187233124526962, 1.374408935355908],
            [12.195502116657646, 1.3807032369039303],
            [12.195458757069865, 1.389111083647162],
            [12.199448594059284, 1.3931064289612003],
            [12.214918644675851, 1.3920229137883802],
            [12.220714720513556, 1.3948609060947716],
            [12.224309525564863, 1.398612419330929],
            [12.226968540034495, 1.4102075684055966],
            [12.236595856632428, 1.4139067623353718],
            [12.237475717930447, 1.4179029186512242],
            [12.241438679607917, 1.422359999975949],
            [12.241325141111213, 1.4264751135192058],
            [12.24827119211605, 1.4293739492433402],
            [12.25482862114824, 1.429388271751182],
            [12.260804467275673, 1.4276337518218738],
            [12.266209247748957, 1.4245465653507055],
            [12.27330975425471, 1.4236705895210475],
            [12.27831247305394, 1.424207371630634],
            [12.281863882351583, 1.416940983074199],
            [12.287404893461275, 1.4165305101829753],
            [12.288858516328068, 1.4147316190698103],
            [12.303996335106044, 1.4151858601360607],
            [12.308945897019331, 1.4169893574135761],
            [12.311469191118887, 1.4199500261689109],
            [12.317999041044603, 1.4204316941174855],
            [12.323137538669931, 1.418055147077405],
            [12.326540352334689, 1.4214158834713102],
            [12.328420659080752, 1.4190894838307735],
            [12.33305701143729, 1.4186204115086016],
            [12.336222056083434, 1.4213011480002344],
            [12.342409557729207, 1.42118953212608],
            [12.350515147495374, 1.4159957487298906],
            [12.35581472923776, 1.4160323041048788],
            [12.40736904574874, 1.409166667489626],
            [12.476031230865749, 1.4005512198927546],
            [12.479391002221334, 1.357735364583337],
            [12.479165190559067, 1.356840247403024],
            [12.477550264386357, 1.3082851163989961],
            [12.467815266236657, 1.2894181624621073],
            [12.478179515315672, 1.268297433755899],
            [12.48336650027586, 1.2643040560637964],
            [12.48522412066888, 1.2558168712650746],
            [12.486917290853157, 1.253929293357736],
            [12.48362404960542, 1.249413736277143],
            [12.478866135330794, 1.2485258909564865],
            [12.476108267177825, 1.2404456398764616],
            [12.471935797894005, 1.235076480825234],
            [12.47074678107245, 1.2309043884775281],
            [12.474677411360451, 1.2294293104375755],
            [12.474478994871431, 1.2230620952533595],
            [12.46952085571019, 1.2146575133265574],
            [12.468754903703577, 1.2115586196649788],
            [12.470760535930504, 1.2068940632624636],
            [12.465935446829404, 1.2024823961672262],
            [12.466433666013765, 1.1987595251905094],
            [12.46154506961576, 1.196475350691605],
            [12.463286731233895, 1.1932423404521426],
            [12.462731537292767, 1.1875947666289213],
            [12.459409183295113, 1.1836133316476847],
            [12.460714050043306, 1.17570603624061],
            [12.45140457546416, 1.1751503205749874],
            [12.448473507990407, 1.1717757358711196],
            [12.450897322921108, 1.1687997640318788],
            [12.448052703665317, 1.1615266332796905],
            [12.448454900354648, 1.0526342431225348],
            [12.467735113139035, 1.0141206764207842],
            [12.464605703749491, 1.0154156235610785],
            [12.459970899795925, 1.014869131540125],
            [12.458484071552222, 1.011679918291311],
            [12.453247335175844, 1.0094368728120748],
            [12.452932811532563, 1.0125294426877178],
            [12.449016982335715, 1.0130471449370124],
            [12.444472335280281, 1.010701268906343],
            [12.441575119059827, 1.013304396727187],
            [12.436999979262668, 1.011147370414886],
            [12.435491845601943, 1.0068020536057192],
            [12.431511099218321, 1.0088653286750133],
            [12.428075840049953, 1.0068214910164113],
            [12.425455085289533, 1.0122212941384645],
            [12.421198406926466, 1.0125736521669964],
            [12.421743838321019, 1.0156678713635046],
            [12.416838734776013, 1.0175741119869999],
            [12.419910546006726, 1.0282896778756418],
            [12.418735632942347, 1.03579959858673],
            [12.416534742812466, 1.0393072029844315],
            [12.418899293095908, 1.0451757614314607],
            [12.419268192879628, 1.0498329530778616],
            [12.423063396581611, 1.0518020590209924],
            [12.419054996119868, 1.0571751490976076],
            [12.41168025805483, 1.0534736499555633],
            [12.404658801635868, 1.061194719594109],
            [12.408016805089845, 1.065568126487814],
            [12.406675882629827, 1.069460137626837],
            [12.40311388215397, 1.07333882104639],
            [12.398203647226666, 1.0742430242816963],
            [12.39468041070839, 1.0703032912080364],
            [12.388525381142037, 1.0723771096925923],
            [12.385316008996348, 1.074930245313956],
            [12.386231659949832, 1.0783509741095625],
            [12.384968200267666, 1.0845149663229379],
            [12.38768347246207, 1.0899417965971625],
            [12.386123427257708, 1.0933813901248712],
            [12.388529354110876, 1.0964778020365007],
            [12.388194614556506, 1.1014738657705259],
            [12.38954376643743, 1.1050868543610861],
            [12.388833438045145, 1.1091963650007057],
            [12.384695080845294, 1.1082177932807484],
            [12.380096506524394, 1.111807595322742],
            [12.373892580902066, 1.1190436164065234],
            [12.366476056558016, 1.1172113561220478],
            [12.361698947739383, 1.1243431810036661],
            [12.354438385221755, 1.1276560524956398],
            [12.351049890829294, 1.130439423042193],
            [12.345787741440107, 1.13239440145472],
            [12.342547314248716, 1.130926161658069],
            [12.341359833651403, 1.1252754210175162],
            [12.33204148500861, 1.1209216861923417],
            [12.324770459650564, 1.1267214208412806],
            [12.32236413323302, 1.1318591927818062],
            [12.318797428487992, 1.1327139127867858],
            [12.312944921826809, 1.1297940424557544],
            [12.306801019488475, 1.125101305475915],
            [12.3036025033764, 1.120867607755146],
            [12.301093237622535, 1.121067712930837],
            [12.298045779949922, 1.125254159503169],
            [12.291794171395466, 1.1314044235679248],
            [12.291401623931366, 1.1448128716843544],
            [12.286890432608029, 1.1478497654723883],
            [12.283822816612982, 1.1520924789835145],
            [12.28478527949615, 1.156333132399795],
            [12.276798959645811, 1.1633828527286105],
            [12.191315058067861, 1.2393095527042508],
            [12.175592290897315, 1.2534362939616823],
            [12.154198212129621, 1.3268658956798225],
            [12.152653479167865, 1.3390412201339297]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.5022113904086, "lat": 38.995958800802924 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54041"],
        "coty_name": ["Lewis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lewis County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01550027"
      },
      "bbox": [
        12.152653479167865, 1.0068020536057192, 12.486917290853157,
        1.429388271751182
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [4.253589163264651, 8.420616079720046],
              [4.258389881432037, 8.430762270648202],
              [4.259244791930864, 8.441874158377198],
              [4.257223099202112, 8.462766897280902],
              [4.257960477165989, 8.469699005986834],
              [4.261612284757695, 8.482747696820363],
              [4.269538516437786, 8.49133171207626],
              [4.282195811718611, 8.495363515897168],
              [4.28720925845466, 8.492299249672499],
              [4.29293338622753, 8.495871593949314],
              [4.297288343251268, 8.49630222464315],
              [4.296964677614677, 8.491502574739886],
              [4.299007521146411, 8.488406691574683],
              [4.298423993996922, 8.478644842960627],
              [4.295797082430357, 8.473250735009987],
              [4.294978452655956, 8.464897291928517],
              [4.291046635533502, 8.457452650904532],
              [4.294146631635801, 8.4445921473138],
              [4.290575903456961, 8.439399652965955],
              [4.287987133135455, 8.433377717473652],
              [4.283200165461933, 8.432292500902772],
              [4.277096518806888, 8.424699567979221],
              [4.2767716113348895, 8.421139804045774],
              [4.26998147495272, 8.41744784246772],
              [4.263551710579564, 8.417995033608587],
              [4.259862817542087, 8.415271596049905],
              [4.253945570400373, 8.415518920309601],
              [4.253589163264651, 8.420616079720046]
            ]
          ],
          [
            [
              [4.227148983267847, 8.29551984268572],
              [4.233407881976729, 8.299156865486728],
              [4.238642146475215, 8.304558640077394],
              [4.246207633738114, 8.30643104097323],
              [4.258728716953775, 8.313138820899924],
              [4.264347980234213, 8.31719278342345],
              [4.2692375493109065, 8.319042622309842],
              [4.270052929282085, 8.31311776321318],
              [4.263054243793462, 8.30770344766295],
              [4.260412675977036, 8.302863736322024],
              [4.255345669689335, 8.30095490427827],
              [4.253970566867816, 8.29465243154817],
              [4.247756819078947, 8.291858865348765],
              [4.237966133781626, 8.290096504528034],
              [4.227475821537891, 8.292324756412157],
              [4.227148983267847, 8.29551984268572]
            ]
          ],
          [
            [
              [4.176457930484866, 8.446870599225916],
              [4.179713984752607, 8.451426912848147],
              [4.183890590563568, 8.453851354357372],
              [4.185143451429509, 8.450502688258506],
              [4.182398439634439, 8.444516553844647],
              [4.190042691734765, 8.437382182829989],
              [4.1972211162632975, 8.432119235553513],
              [4.197670679375411, 8.41962665083915],
              [4.193861721232982, 8.414142655761614],
              [4.1899043359136305, 8.41105495375715],
              [4.1867071819369555, 8.411249551157507],
              [4.1849522479548655, 8.419433867865662],
              [4.183167690431073, 8.423070674160561],
              [4.1807320961229975, 8.439679067089768],
              [4.1773513350953095, 8.441890057880995],
              [4.176457930484866, 8.446870599225916]
            ]
          ],
          [
            [
              [4.164189194965973, 8.477112343804425],
              [4.164653565232742, 8.484200241363592],
              [4.168687141163903, 8.48498471320446],
              [4.169370826594822, 8.481249452575575],
              [4.168522049801394, 8.474747975266077],
              [4.165517267959604, 8.470982914332398],
              [4.164189194965973, 8.477112343804425]
            ]
          ],
          [
            [
              [4.1443098789585715, 8.415574033854464],
              [4.148721630866493, 8.41980065300445],
              [4.157142651260467, 8.419331558780087],
              [4.159720816470482, 8.415006893429524],
              [4.159716989089295, 8.407967680377553],
              [4.155473878835378, 8.403620296467695],
              [4.150286398396622, 8.401572524593291],
              [4.1469238702169005, 8.405240470855313],
              [4.142865098586909, 8.414163697098463],
              [4.1443098789585715, 8.415574033854464]
            ]
          ],
          [
            [
              [4.124614431468904, 8.442804494524413],
              [4.128620402339404, 8.450414169825123],
              [4.131451521168825, 8.450438083308228],
              [4.134202773999194, 8.44699672432815],
              [4.132598659309917, 8.442788420786497],
              [4.1333424598591835, 8.43934718143185],
              [4.129754203028361, 8.435775443160127],
              [4.1247610417366625, 8.440230190491654],
              [4.124614431468904, 8.442804494524413]
            ]
          ],
          [
            [
              [4.128851985555534, 8.334193733478038],
              [4.131161344211403, 8.337726486856074],
              [4.139489138251398, 8.354124402625652],
              [4.145063562450322, 8.356842447546773],
              [4.15253186123494, 8.357485834325477],
              [4.15769517762887, 8.360712664755603],
              [4.163523650849657, 8.365848770551503],
              [4.180082734450891, 8.372708600479331],
              [4.192650051559047, 8.374599953281427],
              [4.1983801937068215, 8.376702865645143],
              [4.203315598408481, 8.380482517356503],
              [4.212130688036872, 8.384425367608259],
              [4.215949946451443, 8.38376229069578],
              [4.224295908515851, 8.378125689348108],
              [4.226558179149676, 8.374586147963072],
              [4.226194782507239, 8.37150995807182],
              [4.217303961444102, 8.360481740482308],
              [4.216735519323094, 8.350554093302708],
              [4.213929178461284, 8.348690013566479],
              [4.206744450713111, 8.350309403184747],
              [4.202789396468134, 8.347483558027617],
              [4.201725113434407, 8.340076008223246],
              [4.2051084590001695, 8.330670084128032],
              [4.20798463684604, 8.326645695575573],
              [4.200931538806647, 8.324099355042435],
              [4.2007132367802775, 8.332540888288602],
              [4.194064097758889, 8.338665264720026],
              [4.187407975306995, 8.340238923420316],
              [4.181716891214586, 8.336861149567794],
              [4.1792879948106645, 8.33276413054171],
              [4.176133877464868, 8.330823729702512],
              [4.169219915795705, 8.329853752249674],
              [4.1650024724751455, 8.334081374450324],
              [4.161231748816587, 8.334905405404285],
              [4.158661743078801, 8.333233565577977],
              [4.156686025189779, 8.326143367276302],
              [4.147386395615341, 8.321241773175846],
              [4.140135686064313, 8.31918043447193],
              [4.136565278415605, 8.320848045847274],
              [4.131714902345634, 8.326340155597974],
              [4.128635017711309, 8.331413953192028],
              [4.128851985555534, 8.334193733478038]
            ]
          ],
          [
            [
              [4.110392063659172, 8.366797483393265],
              [4.114116315858929, 8.370666883083553],
              [4.116458101172302, 8.377558008514663],
              [4.123234299245684, 8.383445881301355],
              [4.125345692784384, 8.387856183033843],
              [4.13330265795717, 8.39233702803475],
              [4.139428028017453, 8.391301281529003],
              [4.13992742822703, 8.38279987258954],
              [4.135632367111455, 8.377312054815519],
              [4.130503576934963, 8.374597205315895],
              [4.127558405469233, 8.36889499254054],
              [4.1223723004141855, 8.364319929321507],
              [4.1155023584601365, 8.3597296170387],
              [4.110392063659172, 8.366797483393265]
            ]
          ],
          [
            [
              [4.096285717767156, 8.439626774010684],
              [4.096722586418268, 8.445683384758583],
              [4.098559590074555, 8.451741322892453],
              [4.1020533271254305, 8.453963846757526],
              [4.110137607386952, 8.453544473558424],
              [4.118300128710733, 8.458228847394063],
              [4.119638560571234, 8.462485668824085],
              [4.124071952984993, 8.464453024433524],
              [4.124313560847157, 8.460356154278623],
              [4.118002340389866, 8.453962793622832],
              [4.111115220517091, 8.450371647124943],
              [4.109762726331522, 8.441691645999487],
              [4.107873734579973, 8.438933397148027],
              [4.105638120433325, 8.42819525590426],
              [4.0994220778734505, 8.43007370253745],
              [4.096840004846708, 8.432075622997582],
              [4.096285717767156, 8.439626774010684]
            ]
          ],
          [
            [
              [4.0976337994348215, 8.297560855569122],
              [4.107725275573433, 8.304317260913026],
              [4.114134732807386, 8.307244158889887],
              [4.118893839137223, 8.306153369833966],
              [4.121556532065409, 8.303212443432217],
              [4.11806492711094, 8.295048387661874],
              [4.107010793902642, 8.290180042285492],
              [4.1021026816125605, 8.290753384227385],
              [4.0978535914732355, 8.294601485653937],
              [4.0976337994348215, 8.297560855569122]
            ]
          ],
          [
            [
              [4.085850825350346, 8.396180960709717],
              [4.085910672673952, 8.399163352643107],
              [4.091514641450619, 8.41355570947904],
              [4.095098606790942, 8.417273305494202],
              [4.106149971037661, 8.416711343358545],
              [4.114277071341621, 8.410119772229972],
              [4.111008459058921, 8.407482582534128],
              [4.103378343842407, 8.398717829184259],
              [4.099290102878866, 8.395481433868795],
              [4.097740834651884, 8.392190267884402],
              [4.089189430365657, 8.391718116098197],
              [4.085850825350346, 8.396180960709717]
            ]
          ],
          [
            [
              [4.067690781063659, 8.48630347305384],
              [4.072501547297791, 8.484533145233724],
              [4.074958066174089, 8.480082456943256],
              [4.075605344271671, 8.474372877280915],
              [4.074694198359797, 8.470130084911027],
              [4.071497123972061, 8.468890663987374],
              [4.069048878696705, 8.472190825134497],
              [4.067115740739591, 8.483786877360032],
              [4.067690781063659, 8.48630347305384]
            ]
          ],
          [
            [
              [4.059088820191616, 8.242462993170754],
              [4.061852557892915, 8.259511119199946],
              [4.066927952215172, 8.271691201600337],
              [4.07560999459981, 8.282399798100748],
              [4.08204752950695, 8.282277592996001],
              [4.086611644161851, 8.275937617478608],
              [4.085511701350935, 8.270485098327221],
              [4.07920720061233, 8.257650441440664],
              [4.07202164065826, 8.247469133620585],
              [4.067042457510088, 8.242778061709569],
              [4.06151535306947, 8.240238029442391],
              [4.059088820191616, 8.242462993170754]
            ]
          ],
          [
            [
              [4.051456117931345, 8.354277092611689],
              [4.061645640515912, 8.366662419075707],
              [4.067449985170504, 8.372104694875093],
              [4.072010522031058, 8.367961264773548],
              [4.076639504389531, 8.366731810898777],
              [4.0848182713552825, 8.367294113282847],
              [4.087434246037917, 8.364406812768962],
              [4.087875725306385, 8.360614437894112],
              [4.092538734637791, 8.354045847645155],
              [4.10050300586186, 8.346798414961665],
              [4.103439762188283, 8.339379714379593],
              [4.105340218887978, 8.328074050015173],
              [4.102494980820871, 8.326626022561221],
              [4.081154832487209, 8.32428105022392],
              [4.0728833716929325, 8.322320134363872],
              [4.064018587372216, 8.335539165662585],
              [4.059992095199063, 8.337842678663318],
              [4.05884992651861, 8.344766211957424],
              [4.053587750865471, 8.34912937889366],
              [4.051456117931345, 8.354277092611689]
            ]
          ],
          [
            [
              [4.040615551714857, 8.43011990909251],
              [4.044100262122428, 8.435771264831816],
              [4.051012260733789, 8.440744012660058],
              [4.052564543757081, 8.437508951311223],
              [4.064375374415076, 8.424931244131926],
              [4.065774257525713, 8.420851486191387],
              [4.065200668721048, 8.41710334037634],
              [4.058565780242721, 8.407360707227724],
              [4.055324884502839, 8.406081958673617],
              [4.051906244375615, 8.408885342858074],
              [4.048015661504434, 8.408392000526739],
              [4.044507721916947, 8.411131660778508],
              [4.041409881674048, 8.421107162007937],
              [4.040615551714857, 8.43011990909251]
            ]
          ],
          [
            [
              [4.0423058182714975, 8.1938543302004],
              [4.045771033346542, 8.197262520273544],
              [4.058758722673351, 8.201159002930464],
              [4.064323139390008, 8.206142981873727],
              [4.068434315694428, 8.208231889745631],
              [4.074779245769533, 8.208688874758527],
              [4.081659816323949, 8.211046937770988],
              [4.084488405039342, 8.215286971235713],
              [4.084652281907385, 8.221296917161778],
              [4.089074626514759, 8.226933681855055],
              [4.094672482633624, 8.232026255035874],
              [4.119329666023837, 8.246407561304467],
              [4.131426872465603, 8.256504659339381],
              [4.140258708536069, 8.267231634047901],
              [4.145952708582153, 8.277965354729071],
              [4.153701193243774, 8.286765156333473],
              [4.157446795557195, 8.288548483421566],
              [4.1670729616851245, 8.287352204493349],
              [4.17829378740935, 8.273524037347979],
              [4.183387402077246, 8.269350829175002],
              [4.19068784507095, 8.265972025777781],
              [4.191602972149238, 8.263611201990766],
              [4.187602146356419, 8.261492419968993],
              [4.185483381798794, 8.257737816360988],
              [4.181317859219392, 8.255697934266772],
              [4.1613095170861305, 8.252712623305495],
              [4.142127947338447, 8.24160146333536],
              [4.1345480265720065, 8.239091563975196],
              [4.121165482938424, 8.232432473093434],
              [4.119530449275857, 8.22536350639365],
              [4.120950937215489, 8.218318699788771],
              [4.124897054761109, 8.212721206932175],
              [4.135028734696475, 8.212965994780731],
              [4.137410859754807, 8.208495412412082],
              [4.1343267826186, 8.202684243234906],
              [4.126681264457625, 8.200952436569715],
              [4.117446633655438, 8.19714858721387],
              [4.107740469782308, 8.19453356409156],
              [4.093832094242353, 8.197101708552482],
              [4.08890026498877, 8.193195409052345],
              [4.079025947861711, 8.179108454638508],
              [4.072836385210376, 8.17671816967655],
              [4.070196847110553, 8.17144925698091],
              [4.063114754921066, 8.16530656282769],
              [4.058012669491713, 8.163158693276007],
              [4.046582170717707, 8.16227882164273],
              [4.045284732639118, 8.168337300259669],
              [4.049707083221477, 8.177441906463283],
              [4.048781785557249, 8.18231331472409],
              [4.0429125735117735, 8.1903226532619],
              [4.0423058182714975, 8.1938543302004]
            ]
          ],
          [
            [
              [4.035272912674849, 8.139422143254073],
              [4.0433488553177, 8.140568156908845],
              [4.050242919660963, 8.139368233354686],
              [4.057983689215362, 8.133492615593758],
              [4.057051798168226, 8.131413915548713],
              [4.049213671917808, 8.136396440451165],
              [4.035272912674849, 8.139422143254073]
            ]
          ],
          [
            [
              [3.9599237972010966, 7.992032301332258],
              [3.964642873883827, 7.990205300787418],
              [3.971894192122019, 7.9899601726204645],
              [3.9776115168847412, 7.993110829658369],
              [3.9833250916311536, 7.998405771453044],
              [3.985577765605464, 7.998982474232006],
              [3.99158126982056, 8.006767550349558],
              [3.99567808575344, 8.00972833565941],
              [4.000651853577036, 8.010794055943357],
              [4.025739862062167, 8.026086279458678],
              [4.030079767316466, 8.02968580139688],
              [4.0488292591985, 8.03610707265206],
              [4.065130584296359, 8.048049173226536],
              [4.079637811448092, 8.064104385183672],
              [4.086459802250378, 8.068186077337627],
              [4.084909612779166, 8.072453913568658],
              [4.080099642678332, 8.076380945560375],
              [4.070163019583808, 8.072290905271181],
              [4.0696010689440465, 8.073549728561996],
              [4.078480917299334, 8.082070763850306],
              [4.081254138864401, 8.082921281060559],
              [4.089780752056557, 8.082069048747007],
              [4.10336218749092, 8.079593292429117],
              [4.115201764084416, 8.074002999912441],
              [4.116460061021346, 8.076176437553068],
              [4.1100391617097065, 8.079403499545805],
              [4.1094732527609725, 8.081637049046154],
              [4.098084270490094, 8.089687432082872],
              [4.086741268904397, 8.09978790293809],
              [4.0878798920766615, 8.10260100853013],
              [4.117402997852246, 8.078399615770715],
              [4.125826595168872, 8.071034065640465],
              [4.163715955702525, 8.041354448466727],
              [4.1937217320930085, 8.019342077237917],
              [4.21383536936816, 8.007155238669862],
              [4.219779845155594, 8.005038289048334],
              [4.224343739785145, 7.923065862316843],
              [4.225458507805068, 7.92233794094019],
              [4.230092660462867, 7.837402938001378],
              [4.23487594808774, 7.753764597298818],
              [4.2354054325826365, 7.737445807147479],
              [4.235091408956805, 7.725877278292349],
              [4.236606012800207, 7.687755367663453],
              [4.237647664843996, 7.666564545576506],
              [4.325030096766091, 7.671194321815846],
              [4.32987832865813, 7.585878060542225],
              [4.357021029279646, 7.5877496833393785],
              [4.371390223166576, 7.589287156936497],
              [4.409172066867303, 7.591123001666304],
              [4.415187323461539, 7.5916787790728035],
              [4.415039516844831, 7.576901449866494],
              [4.418253505765048, 7.534168015570159],
              [4.422328939997721, 7.50595389476903],
              [4.4228565268679265, 7.491584785174357],
              [4.424984129530398, 7.463270117246032],
              [4.4250835785019556, 7.44899326839329],
              [4.426268517501509, 7.435176750975884],
              [4.426264602745442, 7.42029640792981],
              [4.317744041906786, 7.414084683586937],
              [4.260768544966347, 7.410940036241122],
              [4.16581469324742, 7.405508665375216],
              [4.080266217793134, 7.40061473185405],
              [3.9947190255539904, 7.395699905896908],
              [3.993371130984978, 7.395794072291865],
              [3.9918542336891205, 7.409849311260452],
              [3.992069837518625, 7.427808912208354],
              [3.991361044171273, 7.44740332368933],
              [3.989366286483755, 7.4753529207945855],
              [3.9878414837294622, 7.5100630724040665],
              [3.987025641747742, 7.517454170955641],
              [3.984548359597137, 7.567230624556071],
              [3.979788757596425, 7.6533029847809715],
              [3.9791047293352086, 7.669254494843899],
              [3.9767229236854673, 7.680470640308244],
              [3.9750389315618246, 7.695225204998585],
              [3.9760836329219615, 7.710453704216499],
              [3.975585234165776, 7.7372280626163645],
              [3.97336943678612, 7.780958307594799],
              [3.9706668894564254, 7.826298518392617],
              [3.96987178118775, 7.8341201295480145],
              [3.967387125191006, 7.880171498812277],
              [3.967291404300615, 7.89048163525506],
              [3.9661798164225184, 7.910297814570049],
              [3.963997080225899, 7.910184263063506],
              [3.9599237972010966, 7.992032301332258]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.6780411769328, "lat": 46.314498194298146 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55003"],
        "coty_name": ["Ashland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ashland County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01581061"
      },
      "bbox": [
        3.9599237972010966, 7.395699905896908, 4.426268517501509,
        8.49630222464315
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.528331738012265, 5.606853348843727],
            [4.522606245192413, 5.700075699087845],
            [4.5672086307374, 5.702441305915555],
            [4.575699848502224, 5.7035206044317865],
            [4.680388752863625, 5.710006253658764],
            [4.711180492645803, 5.71177046354969],
            [4.776013366912216, 5.716075634418273],
            [4.814702799694284, 5.718840680090978],
            [4.814817654587445, 5.710765484460395],
            [4.8163342814765615, 5.705620296877628],
            [4.819670374022316, 5.699525134242225],
            [4.816730279435297, 5.696616397799129],
            [4.814129221026374, 5.698222614834991],
            [4.812851720448027, 5.689797754941359],
            [4.804838689311573, 5.687313888353783],
            [4.80129237942335, 5.682036425639982],
            [4.804697251171232, 5.67757790299146],
            [4.812473766609557, 5.676786585477413],
            [4.81619101686364, 5.6710539512245],
            [4.812944117607405, 5.66748231515775],
            [4.80606418957379, 5.667277456188192],
            [4.802082678460133, 5.665085041164885],
            [4.801003738655041, 5.662152260032204],
            [4.8034926352092855, 5.659208574544331],
            [4.807036325974433, 5.659174317290781],
            [4.81436960837249, 5.661190888218903],
            [4.817856220016915, 5.660986485967646],
            [4.8207639045523765, 5.65405542166459],
            [4.818786706817184, 5.647436119995935],
            [4.816300671740014, 5.645732551449811],
            [4.806673181770077, 5.647414232747758],
            [4.803275506200744, 5.642929827829171],
            [4.806896365278359, 5.635698997484534],
            [4.806240961601197, 5.621208780179606],
            [4.799519336479533, 5.618723734397196],
            [4.795351300366025, 5.623508406127748],
            [4.792458347858228, 5.631355655862252],
            [4.78303557555531, 5.630763772085878],
            [4.778629337303708, 5.633062858729016],
            [4.771696134031891, 5.633721713344765],
            [4.773049043121147, 5.624817972376525],
            [4.7730224163379065, 5.614785143667547],
            [4.770883822628004, 5.599510503136236],
            [4.764628177638084, 5.598281085994175],
            [4.7646321128835565, 5.59453911318461],
            [4.770636788445688, 5.594527928137631],
            [4.769935603639032, 5.589010260966839],
            [4.76366122626463, 5.588172016218164],
            [4.757407638653507, 5.592462794880369],
            [4.753770964189015, 5.587987302099198],
            [4.748476685493824, 5.586726840068295],
            [4.7463281736394505, 5.583811149580229],
            [4.746554382762983, 5.578536011999772],
            [4.750774718671977, 5.573389643914288],
            [4.751284144171807, 5.567960970165978],
            [4.747028846022214, 5.565340977179009],
            [4.742737730713003, 5.565319803064752],
            [4.738354641751102, 5.56045077616195],
            [4.736865844342697, 5.556119485513665],
            [4.7372969570166354, 5.548133620105464],
            [4.739368840578239, 5.543511834765788],
            [4.738412083967726, 5.537668382739085],
            [4.7431203332269005, 5.52857691271111],
            [4.743261615032429, 5.521719996993912],
            [4.745322612228038, 5.515200496528887],
            [4.744806821143237, 5.512840081073697],
            [4.747385313112889, 5.506778242656281],
            [4.754819017677063, 5.499916313913776],
            [4.76042267386874, 5.489837645474839],
            [4.76022367124417, 5.482254505011166],
            [4.756416336539753, 5.477364265804221],
            [4.756471902840402, 5.473919169090707],
            [4.7654221055691135, 5.4703009490718495],
            [4.779850628392752, 5.463048384658454],
            [4.784526551426152, 5.458891036432486],
            [4.788313703559615, 5.4512045981944315],
            [4.789287496783869, 5.446802011425868],
            [4.790506146101592, 5.431384395295831],
            [4.796061674777899, 5.423257731949124],
            [4.796255089138817, 5.408615875913857],
            [4.800805835372129, 5.39481532399214],
            [4.7987729842218005, 5.390078954817844],
            [4.7932009259881045, 5.387510739201667],
            [4.786505355221195, 5.388008334089491],
            [4.78111983274046, 5.385664215383818],
            [4.778893644823302, 5.383091255007757],
            [4.778315065416732, 5.377191429891552],
            [4.781537980513455, 5.371842880785947],
            [4.782905602477695, 5.36627097832897],
            [4.789029065814256, 5.360861387484361],
            [4.795145683043301, 5.351205221928067],
            [4.795587265046776, 5.336768515988414],
            [4.7976179167194655, 5.331959208497354],
            [4.807145361260767, 5.322983715647679],
            [4.813588001840186, 5.319542569755973],
            [4.816761389382661, 5.31579672551052],
            [4.82714659998838, 5.308234048232669],
            [4.830497942002269, 5.302380226175958],
            [4.832619256031909, 5.291605223212549],
            [4.837302906876067, 5.2865506301270395],
            [4.842674328691935, 5.284800191448273],
            [4.8456742061820135, 5.281124028177953],
            [4.847423164921228, 5.275665640094172],
            [4.853162310023092, 5.268067305860057],
            [4.8627374973666715, 5.262739383113238],
            [4.8717042013232295, 5.25593258434536],
            [4.877034656554483, 5.2475706065801875],
            [4.882181001947956, 5.243054650187226],
            [4.884608459573638, 5.236406422846404],
            [4.889338029488952, 5.231083211132561],
            [4.891878649711133, 5.210400357565995],
            [4.896541080114735, 5.1981675494068895],
            [4.9009470659878716, 5.190979122132001],
            [4.902103870858256, 5.185643914671402],
            [4.905220323278808, 5.180115827190982],
            [4.906811877183872, 5.174581102638859],
            [4.917538052457005, 5.156004119018021],
            [4.921860974283777, 5.150933288704786],
            [4.930423206187211, 5.1476010946150925],
            [4.934355664901016, 5.144925237899963],
            [4.937162964533068, 5.126858421895558],
            [4.9352351804623, 5.121487634671712],
            [4.938611627373667, 5.1175844117979805],
            [4.93795893049308, 5.117539838071974],
            [4.900532691017213, 5.114989037641388],
            [4.8646326461444005, 5.112940558651984],
            [4.830627731105228, 5.11069468743534],
            [4.761571334295414, 5.106846703839255],
            [4.666800615711537, 5.101437460717171],
            [4.645827590482567, 5.099822326307808],
            [4.62856147954583, 5.098978730355561],
            [4.559287768473193, 5.093832398111646],
            [4.558660712488026, 5.10081343000576],
            [4.55400339727921, 5.184194280343939],
            [4.550566017085732, 5.240956149339122],
            [4.547750515564176, 5.2931315050243395],
            [4.5437764279902835, 5.352883593168536],
            [4.542249707898389, 5.379400153417365],
            [4.5386437063179095, 5.433493475367307],
            [4.536006573779126, 5.477824777638074],
            [4.531103422510936, 5.563406491797497],
            [4.528331738012265, 5.606853348843727]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.11375911742142, "lat": 43.92458159301118 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55057"],
        "coty_name": ["Juneau"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Juneau County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01581088"
      },
      "bbox": [
        4.522606245192413, 5.093832398111646, 4.938611627373667,
        5.718840680090978
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.139640303341567, 5.8080207095265255],
            [6.224722832272234, 5.814560195695799],
            [6.250098969033628, 5.8167744564388695],
            [6.246992413137356, 5.853470755728784],
            [6.243047833219212, 5.903427423888339],
            [6.329424247785173, 5.910428617521448],
            [6.415959304144248, 5.91831936506396],
            [6.487894701734359, 5.924633977449985],
            [6.4867130100638954, 5.918392125157184],
            [6.488480149984755, 5.90400478675373],
            [6.492234015578499, 5.890594268205029],
            [6.49879955033543, 5.876975047865275],
            [6.508988865243516, 5.858839014182761],
            [6.5211834341362325, 5.829579473666099],
            [6.523583747861689, 5.810889669530817],
            [6.521290996792236, 5.792653094261911],
            [6.517637708181272, 5.779362262656992],
            [6.504998431908278, 5.758014552538358],
            [6.494016199096717, 5.7465109111625345],
            [6.489824122480302, 5.741139321403332],
            [6.464072996999884, 5.72633570885101],
            [6.4505453127784484, 5.715322154462177],
            [6.438609935887374, 5.703339395834061],
            [6.432922987652005, 5.695526548040266],
            [6.431271032563162, 5.684027971871876],
            [6.4328447604924985, 5.680015979853364],
            [6.429762259532507, 5.673402617014487],
            [6.42977429099021, 5.666661286496726],
            [6.432268294384458, 5.658886106892999],
            [6.432737867716136, 5.649881699260727],
            [6.431768832107683, 5.643403691333598],
            [6.421932760699427, 5.628357719751991],
            [6.418552521765193, 5.621280756525927],
            [6.4148619942807015, 5.6102163582247755],
            [6.408934895876155, 5.5794219852528375],
            [6.408376821456452, 5.555722584829215],
            [6.406423569908114, 5.5474835093521],
            [6.400931834855082, 5.537800012824266],
            [6.397290416840021, 5.529954501477468],
            [6.395218553473047, 5.503865024308577],
            [6.3938332634244714, 5.498377550699414],
            [6.394045468523205, 5.490738812992823],
            [6.391803390050004, 5.479857052544185],
            [6.378683659861606, 5.478906249389776],
            [6.318699987926128, 5.473010565051413],
            [6.295852852796794, 5.471012393110195],
            [6.239578686388629, 5.46682953455324],
            [6.212630000689904, 5.46412249369139],
            [6.169987565729391, 5.460471210045583],
            [6.168298736916271, 5.4812876314952925],
            [6.162397908312482, 5.5475491060182325],
            [6.156987311642717, 5.606760700656675],
            [6.146690180639521, 5.7209430039973865],
            [6.144189476376125, 5.749499221535572],
            [6.139640303341567, 5.8080207095265255]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.80969459575215, "lat": 44.11996365577553 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55071"],
        "coty_name": ["Manitowoc"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Manitowoc County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01581095"
      },
      "bbox": [
        6.139640303341567, 5.460471210045583, 6.523583747861689,
        5.924633977449985
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.175059913337176, 6.834662304207684],
            [-10.068870655770077, 6.818279492886561],
            [-9.962685836550154, 6.801867364202123],
            [-9.959199879624695, 6.800964307459302],
            [-9.904637381735727, 6.792357120137671],
            [-9.91752379106493, 6.710242161989268],
            [-9.814771639601528, 6.69465404241749],
            [-9.712023569700342, 6.679038740933512],
            [-9.713522306188167, 6.676438856567271],
            [-9.711347010949801, 6.670476069741795],
            [-9.713747892982349, 6.664648922101045],
            [-9.721319052037314, 6.662523313979111],
            [-9.70775428838789, 6.651318142612066],
            [-9.705796263590987, 6.648419546701513],
            [-9.687833606613003, 6.639872312050043],
            [-9.685604495903519, 6.645268397044108],
            [-9.676315191789833, 6.645067554808254],
            [-9.6741269933778, 6.646207981710462],
            [-9.668865208410384, 6.643154105796798],
            [-9.661163062223775, 6.635305138672176],
            [-9.658138337097238, 6.630074268057372],
            [-9.659433840718217, 6.6257483209645445],
            [-9.662768726179795, 6.623532038054375],
            [-9.665935357343034, 6.618880395283032],
            [-9.664199531580715, 6.616407314617784],
            [-9.660690380458997, 6.6165478761465515],
            [-9.656239101544552, 6.611592682587293],
            [-9.652561990371042, 6.603228035155993],
            [-9.656574711532864, 6.592677489438471],
            [-9.65632832328552, 6.585507040651603],
            [-9.662067665584797, 6.577666218042804],
            [-9.662017168276092, 6.56655169049767],
            [-9.665108891432384, 6.560869767360864],
            [-9.66967435368902, 6.559263940090884],
            [-9.67098466762644, 6.5403971650317745],
            [-9.674910864668478, 6.532789014265512],
            [-9.675299823894882, 6.528075858274714],
            [-9.678563073469391, 6.525460862347188],
            [-9.679522236395423, 6.522143264081686],
            [-9.678290170378732, 6.518037210572491],
            [-9.674695552268691, 6.512496386113129],
            [-9.674465965410564, 6.508761864985357],
            [-9.669086491435246, 6.502303802307742],
            [-9.665008648588278, 6.500903687373842],
            [-9.657039102601498, 6.49590736428543],
            [-9.654099275590227, 6.490702775087632],
            [-9.654289702820929, 6.483281749338098],
            [-9.65558678433621, 6.476420659703205],
            [-9.64841472547969, 6.472355392712123],
            [-9.643843715522358, 6.466297707188617],
            [-9.64008009912371, 6.457484253074579],
            [-9.64127903629432, 6.454771723728796],
            [-9.640783389118466, 6.445218354035776],
            [-9.642156510261703, 6.4426698400433065],
            [-9.642273868248365, 6.4356972211962065],
            [-9.640797534274972, 6.431455735813143],
            [-9.64307683936508, 6.425944664670383],
            [-9.642424863022375, 6.419210067387202],
            [-9.63909387084561, 6.415018124575905],
            [-9.62870897439081, 6.409340236015624],
            [-9.630093537994458, 6.4017582297484115],
            [-9.635025939183773, 6.39740624489572],
            [-9.631662969687634, 6.387217346145654],
            [-9.628886551230659, 6.387926924106374],
            [-9.624085101863898, 6.3811660674271256],
            [-9.612362197472795, 6.383483807420005],
            [-9.611305581076389, 6.3812617433615015],
            [-9.61409011542642, 6.377376499842632],
            [-9.609784479522109, 6.374812453543884],
            [-9.60721987975115, 6.378203541364265],
            [-9.597484735894717, 6.3666304780000225],
            [-9.594625706884232, 6.359320779585206],
            [-9.595789779764031, 6.35454690327623],
            [-9.592810358958975, 6.351900448519842],
            [-9.59429697584548, 6.348796407238104],
            [-9.600400861536585, 6.348212131827201],
            [-9.597654458777239, 6.341244270493932],
            [-9.594268839957033, 6.339601712321976],
            [-9.598321252203297, 6.334512776744548],
            [-9.597967870646082, 6.330384301260974],
            [-9.594279263106959, 6.324823388437073],
            [-9.590362223807356, 6.324429636079953],
            [-9.593147156954926, 6.319457799402348],
            [-9.59287458824535, 6.3157757342070155],
            [-9.59673975169838, 6.312910443197389],
            [-9.592924842032835, 6.305268822669481],
            [-9.594858285603642, 6.301598431652895],
            [-9.59226604614341, 6.298745362860453],
            [-9.589223622782578, 6.286600901748109],
            [-9.586296939072723, 6.290132999259409],
            [-9.58345088550896, 6.290424546670355],
            [-9.581323306643478, 6.282648136282256],
            [-9.585407401089853, 6.2842848665173365],
            [-9.590916523668223, 6.280521782795055],
            [-9.591067380859778, 6.276847784568381],
            [-9.589033785591916, 6.273284333828704],
            [-9.58340982949484, 6.273155783436785],
            [-9.5825857587594, 6.266948076687636],
            [-9.584962350376081, 6.265503541925217],
            [-9.591265511999465, 6.269822009974385],
            [-9.592941860241439, 6.266833641458086],
            [-9.587802108092255, 6.264761190448524],
            [-9.588057173967107, 6.259071634235651],
            [-9.581495884217567, 6.258839335237887],
            [-9.585037969902064, 6.252233607650296],
            [-9.588892313743543, 6.2539693877876665],
            [-9.59252405964014, 6.252185229347922],
            [-9.594397144421029, 6.248856798243005],
            [-9.591683823600537, 6.244105792450062],
            [-9.595283801481788, 6.241542391585398],
            [-9.595770708808294, 6.237012200405591],
            [-9.601074234768324, 6.235228862580404],
            [-9.600376635368246, 6.232976918059278],
            [-9.600875428378982, 6.216432538081593],
            [-9.599203752730833, 6.208143393101018],
            [-9.552333622873922, 6.201236842228523],
            [-9.570629205896717, 6.078249637628482],
            [-9.599567082686448, 5.887247537274545],
            [-9.598018026479584, 5.886917060554301],
            [-9.60876368794025, 5.814527666085076],
            [-9.649846520925923, 5.541287043257527],
            [-9.654091748006891, 5.541889166506783],
            [-9.662861830476325, 5.48075490953141],
            [-9.66683247972556, 5.4558134011743284],
            [-9.7694230793903, 5.471274457232257],
            [-9.872017216116449, 5.486711919793208],
            [-9.884940092843706, 5.400878479283071],
            [-10.014641770429616, 5.421143199838879],
            [-10.052676299557355, 5.426964935869651],
            [-10.06153762222322, 5.371205242284036],
            [-10.147997927824443, 5.384583636519396],
            [-10.167164723982813, 5.387429711198967],
            [-10.230082794693653, 5.397314126132374],
            [-10.217796053747962, 5.475166206169532],
            [-10.299309512195833, 5.487521853704472],
            [-10.298935819104194, 5.48995361222611],
            [-10.382421452081857, 5.50292348966981],
            [-10.353484870698784, 5.686015101376792],
            [-10.328812775960134, 5.8420670459523345],
            [-10.324550398925139, 5.870463397206882],
            [-10.304719338066393, 5.996762097006375],
            [-10.289930197013367, 6.087976867231237],
            [-10.278437006225348, 6.162038702670611],
            [-10.276034156465192, 6.178290422400769],
            [-10.274068254212983, 6.198339375653054],
            [-10.266976726150595, 6.240485683365674],
            [-10.258632830832886, 6.291613967189434],
            [-10.257507413019361, 6.301628028017521],
            [-10.22173851821333, 6.526823331265312],
            [-10.21798541952571, 6.547717615141749],
            [-10.208406345131381, 6.6076184529786985],
            [-10.202187348093167, 6.645220638841391],
            [-10.203932989888141, 6.649873288870813],
            [-10.175059913337176, 6.834662304207684]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.58980775521181,
          "lat": 43.93461210214828
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56039"],
        "coty_name": ["Teton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Teton County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01605083"
      },
      "bbox": [
        -10.382421452081857, 5.371205242284036, -9.552333622873922,
        6.834662304207684
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -169.50511348018455,
          "lat": -14.221956871345661
        },
        "year": "2023",
        "ste_code": ["60"],
        "ste_name": ["American Samoa"],
        "coty_code": ["60020"],
        "coty_name": ["Manu'a"],
        "coty_area_code": "ASM",
        "coty_type": "district",
        "coty_name_long": ["Manu'a District"],
        "coty_fp_code": "020",
        "coty_gnis_code": "01805242"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -67.11395989411213,
          "lat": 18.134161553463493
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72067"],
        "coty_name": ["Hormigueros"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Hormigueros Municipio"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01804514"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.94252244721763,
          "lat": 18.172035611047523
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72093"],
        "coty_name": ["Maricao"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Maricao Municipio"],
        "coty_fp_code": "093",
        "coty_gnis_code": "01804527"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.7212051546015, "lat": 18.06103395298157 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72111"],
        "coty_name": ["Peñuelas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Peñuelas Municipio"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01804536"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.47285594009054, "lat": 18.12810307481835 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72149"],
        "coty_name": ["Villalba"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Villalba Municipio"],
        "coty_fp_code": "149",
        "coty_gnis_code": "01804555"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5376022141535408, 0.47047765686301174],
            [1.5375411765561415, 0.5070808936180067],
            [1.5368933259012398, 0.5580760292889049],
            [1.536619142040143, 0.6089358424214454],
            [1.5357733354953673, 0.638057837611085],
            [1.5354899707600256, 0.6670866265242873],
            [1.5348224692217212, 0.6967139268592941],
            [1.5345995052041848, 0.7305235343886424],
            [1.5338969828988318, 0.7698158808483054],
            [1.5361501855284125, 0.7695290797824693],
            [1.660543978311944, 0.7710334922612708],
            [1.6681992587288812, 0.7714910487981771],
            [1.7043022067874924, 0.771890247437468],
            [1.7437137632757886, 0.772650248177573],
            [1.796409740261737, 0.7731934162038057],
            [1.8323185802178021, 0.7733346363988964],
            [1.8327534230165792, 0.7440645331760682],
            [1.8329018446812362, 0.7038090963301517],
            [1.834110768646665, 0.6117486181298013],
            [1.8349977811901943, 0.5711644318907514],
            [1.8355867927328366, 0.5234148475995473],
            [1.8288069293225617, 0.5263652325128173],
            [1.8223504497081853, 0.5315173490188281],
            [1.8200733566558809, 0.5345979684208253],
            [1.8153053758527025, 0.5443741736504077],
            [1.8114894654104055, 0.5481252230515056],
            [1.8021191937268393, 0.5522084502029803],
            [1.792947782285824, 0.5512097009066093],
            [1.7756778483943811, 0.5526244634221453],
            [1.7644767825133347, 0.5466726510786137],
            [1.7574527079022808, 0.5363054961462889],
            [1.754854699627196, 0.5283758395446763],
            [1.7536375902961348, 0.5194205796336385],
            [1.7514761272035284, 0.5133605846958931],
            [1.740017450836591, 0.49508060058496034],
            [1.7336026863743654, 0.48804212912498673],
            [1.72755133458941, 0.48447278599159266],
            [1.72043376405941, 0.4774889346268822],
            [1.715934489072572, 0.47743179472147346],
            [1.7088478160606944, 0.4840644400450161],
            [1.7036956978536937, 0.5009789440916986],
            [1.6998266266357165, 0.5072733047544008],
            [1.6957108631109878, 0.5100307972565232],
            [1.6902495624134863, 0.5106455496005737],
            [1.68636398458035, 0.5088638695250906],
            [1.6850387824586142, 0.5056117030548368],
            [1.6901408418857307, 0.49468767646069084],
            [1.6923154030530607, 0.48826526427041034],
            [1.6906431272890043, 0.4781028183562713],
            [1.6881729174894295, 0.4758642311836831],
            [1.678866536706395, 0.46415167711998884],
            [1.6747440802204687, 0.4569395189027815],
            [1.669560425187915, 0.4507520646347681],
            [1.6617861889399907, 0.4433077419251363],
            [1.6458634500094533, 0.43253917978222745],
            [1.6412154686617788, 0.4369148850704536],
            [1.6397485163411225, 0.44287274227294654],
            [1.6277671077093165, 0.4576242814853652],
            [1.6193975808502503, 0.4624286978509142],
            [1.6109448956875785, 0.46282040767870525],
            [1.5998498120219338, 0.4609354680527849],
            [1.5922772552384548, 0.4586603108614515],
            [1.5858612007067034, 0.45413999529515164],
            [1.578100073316455, 0.44209872431702896],
            [1.5714612753872703, 0.4368099177434314],
            [1.565748016116932, 0.4341921780315833],
            [1.5429558315208, 0.4204774228802809],
            [1.5366593269164799, 0.4213054985168907],
            [1.5339684473667157, 0.42381851940964943],
            [1.5331826726042002, 0.428350611483101],
            [1.539062110323329, 0.43909822597270437],
            [1.5469996820063208, 0.4497929862154438],
            [1.547977110792163, 0.46080288449325],
            [1.5461772298625995, 0.4657215528945195],
            [1.5376022141535408, 0.47047765686301174]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.42088330169287,
          "lat": 39.310529133886796
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29047"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00758478"
      },
      "bbox": [
        1.5331826726042002, 0.4204774228802809, 1.8355867927328366,
        0.7733346363988964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5284770540179455, 1.063502401879155],
            [1.551813578870808, 1.0637726209070597],
            [1.572648413689896, 1.0646730661227162],
            [1.6433256607575815, 1.0657859650168384],
            [1.6577958024983248, 1.0658011122836784],
            [1.708801322904677, 1.0665582961381006],
            [1.7299139123571248, 1.0666640309029685],
            [1.744531766855745, 1.0673097156298847],
            [1.7874522767575987, 1.0670148580150398],
            [1.8194355646419451, 1.0673795603410297],
            [1.8303512080598217, 1.067204258916906],
            [1.8312952646726035, 1.022978933911469],
            [1.8316403419926097, 0.9829699522312527],
            [1.8322283873404408, 0.9463598996431956],
            [1.8323609605267919, 0.912272860885973],
            [1.8329200888987545, 0.8611347565999432],
            [1.8326357669564826, 0.846549305655138],
            [1.8321194585076286, 0.7741587193054623],
            [1.8323185802178021, 0.7733346363988964],
            [1.796409740261737, 0.7731934162038057],
            [1.7437137632757886, 0.772650248177573],
            [1.7043022067874924, 0.771890247437468],
            [1.6681992587288812, 0.7714910487981771],
            [1.660543978311944, 0.7710334922612708],
            [1.5361501855284125, 0.7695290797824693],
            [1.5338969828988318, 0.7698158808483054],
            [1.5330965693147778, 0.8061066038092713],
            [1.5324945759488344, 0.8445099957092228],
            [1.5313358474690397, 0.918093175647046],
            [1.530514682117439, 0.9318800942860009],
            [1.5284770540179455, 1.063502401879155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.40458280337886, "lat": 39.60175788517202 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29049"],
        "coty_name": ["Clinton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clinton County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00758479"
      },
      "bbox": [
        1.5284770540179455, 0.7695290797824693, 1.8329200888987545,
        1.0673795603410297
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.56000124691184, -1.9454585288513584],
            [1.635754241142065, -1.9473876386361486],
            [1.6911165737571072, -1.9489666852998568],
            [1.6921512494820068, -1.9491496624867544],
            [1.8274417121722033, -1.952881892746584],
            [1.9479961568377533, -1.9554843612334682],
            [1.9962456549884013, -1.956773486076901],
            [1.9976382300857487, -1.956823911700529],
            [1.9960354962165208, -2.0441898965538363],
            [1.996564957340935, -2.052571198371756],
            [1.9954556835572368, -2.131922964736875],
            [1.9948184566392215, -2.197695804918671],
            [1.9948336274963112, -2.208158617982089],
            [1.9680992153863486, -2.208838738620227],
            [1.841693346576116, -2.2105942568410217],
            [1.7686206682903076, -2.211516787747053],
            [1.6426121190487257, -2.213972659914814],
            [1.6109097879725103, -2.214175026485112],
            [1.5642308322079228, -2.2149504691715425],
            [1.5626519081783166, -2.100772444564189],
            [1.5616773787921725, -2.0449703884383275],
            [1.56000124691184, -1.9454585288513584]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.34832849744917, "lat": 36.6286723699436 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29119"],
        "coty_name": ["McDonald"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McDonald County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00758518"
      },
      "bbox": [
        1.56000124691184, -2.2149504691715425, 1.9976382300857487,
        -1.9454585288513584
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.37479738279332, 8.776851441811518],
            [-10.360269175828737, 8.77420612393617],
            [-10.331812180639409, 8.770009163509211],
            [-10.317486883238955, 8.767412059798115],
            [-10.268562594781503, 8.759843503018914],
            [-10.270169602266922, 8.763553475921135],
            [-10.269936968333564, 8.768117992266014],
            [-10.271947547379844, 8.772809829814504],
            [-10.259372891463594, 8.849444565296318],
            [-10.258606681638526, 8.849317848882315],
            [-10.246108461286935, 8.924060263137978],
            [-10.24223181105531, 8.927966785022434],
            [-10.235085751119758, 8.930390728629385],
            [-10.232154093356373, 8.93906410114822],
            [-10.226541173391768, 8.941027489903528],
            [-10.22342698877322, 8.946874589681881],
            [-10.220656012681424, 8.954404528621495],
            [-10.214496112579496, 8.958863114132688],
            [-10.21092759633181, 8.957250004072948],
            [-10.203538920395058, 8.960652627660735],
            [-10.197055886650467, 8.95502638439571],
            [-10.191007898711048, 8.95363279074887],
            [-10.189653409384658, 8.949462162028167],
            [-10.191040697954733, 8.946326471250082],
            [-10.188934524371891, 8.942868839406339],
            [-10.183601552619082, 8.942494401836958],
            [-10.18023482852311, 8.944420777653265],
            [-10.176898985149425, 8.943673415905117],
            [-10.171179302955563, 8.938905414893219],
            [-10.162136711048367, 8.936831404891421],
            [-10.159366412673505, 8.933187985197192],
            [-10.154163906999099, 8.930373805720189],
            [-10.146365989832436, 8.93203517492043],
            [-10.142589420089582, 8.929465726055001],
            [-10.138115023209252, 8.923536830530221],
            [-10.135042464060312, 8.92419289230995],
            [-10.133305308317063, 8.920725386703436],
            [-10.125586956494693, 8.917879373252088],
            [-10.124254027873906, 8.91357305491454],
            [-10.12061381075203, 8.907939172188627],
            [-10.123605022361295, 8.894683428782422],
            [-10.12866123004532, 8.891846439991271],
            [-10.124908162697775, 8.885219913991198],
            [-10.122287342749399, 8.886020082924434],
            [-10.12028708229122, 8.881082391189395],
            [-10.123744879611348, 8.879345362835668],
            [-10.131429581272045, 8.872034894743056],
            [-10.126473045092531, 8.868605532481952],
            [-10.121896595642905, 8.867178531965232],
            [-10.122487893288604, 8.862182399060847],
            [-10.12046213684643, 8.860951353362847],
            [-10.120847817539458, 8.856205079280404],
            [-10.12528570260061, 8.85170908203275],
            [-10.126428131693544, 8.847932218074007],
            [-10.118105874707078, 8.845876777670377],
            [-10.114884046195703, 8.846701118291614],
            [-10.110097023165958, 8.84494768373411],
            [-10.108549277544403, 8.83951712415702],
            [-10.104354446765612, 8.837251334760001],
            [-10.104838539603717, 8.827758064541902],
            [-10.102879613063722, 8.817652840180784],
            [-10.107061913554293, 8.810973635882819],
            [-10.107215056972407, 8.804115813697791],
            [-10.098171354969152, 8.80603732224084],
            [-10.08657250508885, 8.80516670652915],
            [-10.084215372850004, 8.806066677792261],
            [-10.078348819643132, 8.7991624116241],
            [-10.078118191284522, 8.794528987126343],
            [-10.070305763373248, 8.791982864863872],
            [-10.064854893060343, 8.792636850251426],
            [-10.05951051852989, 8.791489304919445],
            [-10.053199301331366, 8.78812018190046],
            [-10.052079338702718, 8.776976343214828],
            [-10.054811599270835, 8.772559695969948],
            [-10.052576373631178, 8.770494832477144],
            [-10.060483439917318, 8.763091870632072],
            [-10.060757010960327, 8.753944903327389],
            [-10.0590429527697, 8.750466409989835],
            [-10.059939821598807, 8.74273958205477],
            [-10.064354044135335, 8.73935019156041],
            [-10.064619845198177, 8.735058890043755],
            [-10.061653917272189, 8.729809494055226],
            [-10.056510740204454, 8.724841080131988],
            [-10.059136879453554, 8.713809255157738],
            [-10.064516330969369, 8.712652600545473],
            [-10.068586048064015, 8.709485620089316],
            [-10.075735472656545, 8.706440049265444],
            [-10.077067162441992, 8.704216380435188],
            [-10.074115141774042, 8.69729052620462],
            [-10.06247317271908, 8.68990380229374],
            [-10.059430478191915, 8.686137955898687],
            [-10.0438542454915, 8.680908333543787],
            [-10.037554461580646, 8.674434572669375],
            [-10.035765450131134, 8.670716128015254],
            [-10.036738300664656, 8.662017576363843],
            [-10.03444663958756, 8.658059662377946],
            [-10.033712213273018, 8.649707040961024],
            [-10.025056744326658, 8.648994896025446],
            [-10.023746971708986, 8.639536568766438],
            [-10.02749463984426, 8.632414178082476],
            [-10.025161509452444, 8.626696969872505],
            [-10.026133303198748, 8.61467041987649],
            [-10.024912518360406, 8.607994228709927],
            [-10.028909609092828, 8.599561827005443],
            [-10.029082181213008, 8.595253523931241],
            [-10.027271967955468, 8.589051639743461],
            [-10.020102678596153, 8.58537189878196],
            [-10.016054940744008, 8.577906547534107],
            [-10.011832627769715, 8.578171922665371],
            [-10.003637260253106, 8.574347206755698],
            [-9.99282086881887, 8.574389782075269],
            [-9.98858265136618, 8.575300347644198],
            [-9.979449053933738, 8.581224422393138],
            [-9.978527559813056, 8.586886441627476],
            [-9.975606707522797, 8.589522419822664],
            [-9.965513471817875, 8.590770570847],
            [-9.962495838515, 8.589127218205537],
            [-9.95906074979369, 8.590791167021267],
            [-9.952647691047057, 8.588807402688746],
            [-9.94716220623354, 8.588358675131174],
            [-9.940337482842832, 8.589712115785211],
            [-9.939175129357984, 8.586025540847949],
            [-9.944678209788048, 8.579498725021129],
            [-9.943449364473636, 8.576802997937213],
            [-9.938459126760135, 8.57513845064386],
            [-9.935425698343904, 8.571561462019488],
            [-9.929393051767727, 8.569835251590245],
            [-9.926744077587301, 8.567708794607846],
            [-9.92551172064739, 8.558161620920755],
            [-9.92253097432007, 8.557435931557203],
            [-9.919997103971582, 8.552906999042598],
            [-9.916819582379716, 8.550709255564115],
            [-9.915950642309136, 8.547084092437414],
            [-9.910072281830479, 8.542639689439772],
            [-9.906993210877316, 8.54182933106154],
            [-9.90357918937735, 8.534723788678457],
            [-9.904253705882851, 8.529551609033726],
            [-9.90902693612591, 8.526616168379043],
            [-9.911885599760117, 8.522630052077597],
            [-9.911479598022028, 8.514525621870865],
            [-9.917505947938716, 8.509116111720504],
            [-9.919843475882251, 8.503996339635588],
            [-9.91823029357903, 8.4933521823145],
            [-9.92096151546426, 8.489902698971953],
            [-9.920015614886543, 8.485386017089393],
            [-9.924968008856743, 8.48170225653977],
            [-9.93223914319368, 8.484758438016007],
            [-9.938668375034181, 8.48053898486813],
            [-9.938570706101522, 8.476078044684359],
            [-9.942062625259208, 8.474369024233631],
            [-9.950300740891105, 8.465517242479322],
            [-9.952026079736571, 8.46206137342389],
            [-9.958560256959466, 8.457432542140818],
            [-9.960155883070733, 8.449565619427878],
            [-9.96207257796335, 8.447139340721646],
            [-9.963049746395352, 8.441668486567872],
            [-9.962780863107621, 8.43566787012091],
            [-9.966834519266737, 8.427793254774247],
            [-9.971712336961124, 8.415315017432452],
            [-9.964290948835458, 8.406322829171316],
            [-9.95980487480052, 8.404391666605276],
            [-9.961420569414482, 8.399652525962486],
            [-9.952402226604086, 8.396696366836501],
            [-9.948159815659604, 8.390877906133992],
            [-9.94233858986982, 8.38582447146268],
            [-9.945800944157597, 8.380309218283555],
            [-9.947709534464613, 8.373032158253833],
            [-9.939667327223592, 8.369523796380383],
            [-9.937196794771467, 8.364423970758745],
            [-9.937717058799349, 8.36058697641244],
            [-9.935430396516578, 8.35721787783041],
            [-9.937020780692341, 8.353896896299075],
            [-9.936304533330995, 8.346932487017012],
            [-9.938655360822029, 8.339847821334326],
            [-9.937639182113704, 8.335894348090886],
            [-9.939961973476098, 8.330027779761423],
            [-10.006799404056656, 8.340626346487984],
            [-10.007601085393985, 8.33569121541781],
            [-10.135723396404794, 8.356229691034207],
            [-10.143848732085079, 8.306928659366193],
            [-10.145733659877008, 8.307232497588164],
            [-10.148046241325202, 8.292998376337902],
            [-10.151747416682579, 8.291055122697943],
            [-10.16190195651167, 8.288097629907227],
            [-10.169592093372058, 8.287162475909621],
            [-10.172591740120579, 8.280987045663698],
            [-10.174790054150936, 8.278910976610316],
            [-10.180847799402184, 8.284666624112951],
            [-10.184426455412408, 8.282100405842177],
            [-10.181649377464593, 8.267875778961214],
            [-10.183795944402664, 8.265584141614008],
            [-10.192759744724135, 8.262675565295975],
            [-10.199437839905201, 8.25415892895547],
            [-10.204789375901168, 8.246042095516465],
            [-10.208855389445798, 8.242109239717735],
            [-10.210980628096705, 8.227486609960408],
            [-10.21279878577982, 8.222265917810562],
            [-10.212656607299277, 8.212575681356936],
            [-10.213833457971344, 8.207884515444078],
            [-10.219744869015372, 8.200840034277066],
            [-10.214770535008238, 8.196761038105224],
            [-10.2130497246908, 8.182539220877985],
            [-10.216550573783724, 8.177634783944399],
            [-10.222815919062429, 8.175335844621614],
            [-10.229452259334504, 8.175692781209268],
            [-10.233443096324129, 8.174736604257122],
            [-10.236476202050925, 8.180392278588268],
            [-10.241867846548423, 8.184263546686397],
            [-10.244600603873323, 8.182905495197872],
            [-10.247792862268064, 8.176252256143034],
            [-10.25058618501835, 8.165782502148748],
            [-10.250331082284598, 8.160066108145584],
            [-10.252407329707223, 8.150710109268742],
            [-10.255544570654923, 8.143813323895644],
            [-10.25927946625485, 8.139644479573189],
            [-10.267646028282392, 8.135773180741094],
            [-10.271309863036754, 8.132451721029533],
            [-10.276274466267013, 8.129997410879998],
            [-10.278627686668404, 8.125713219010105],
            [-10.28758996289429, 8.123499762582941],
            [-10.294391942304129, 8.120230549013149],
            [-10.300606342356716, 8.119486523626644],
            [-10.307309876524272, 8.120083584648977],
            [-10.306955332380532, 8.114410647271972],
            [-10.310065439561109, 8.112526245599447],
            [-10.311547417722045, 8.116286905802076],
            [-10.314677897837305, 8.114463176127725],
            [-10.314639077465722, 8.110299716476966],
            [-10.319244981980692, 8.10769983829043],
            [-10.325790407398738, 8.113782015411935],
            [-10.331714989090429, 8.109511392052694],
            [-10.336456153085162, 8.110868604093312],
            [-10.338587575385189, 8.108751918502401],
            [-10.346545504375174, 8.10899982466515],
            [-10.35073629780255, 8.103670567205072],
            [-10.358314562460764, 8.097009214173537],
            [-10.363801202132139, 8.09376718028005],
            [-10.369126125105216, 8.080457913359334],
            [-10.375063117705023, 8.07766802069327],
            [-10.379088194342355, 8.072874081911761],
            [-10.386771744305738, 8.071332294279722],
            [-10.391442604767258, 8.062151898355113],
            [-10.39881344612181, 8.06169272561581],
            [-10.400830599358251, 8.057111328516537],
            [-10.403916707217324, 8.054521748298002],
            [-10.403609457061798, 8.051644407961474],
            [-10.405838410825544, 8.046187125424481],
            [-10.408265917399467, 8.04576745230569],
            [-10.401538929269266, 8.085639235484797],
            [-10.394300820676046, 8.130025899944016],
            [-10.380262640940344, 8.213519364450391],
            [-10.373182281817202, 8.256165289035383],
            [-10.458197912398528, 8.270833339085174],
            [-10.453116214836818, 8.29926135349178],
            [-10.443836860526384, 8.355064499976873],
            [-10.445197221580926, 8.355278101340456],
            [-10.416421364780144, 8.524548689739488],
            [-10.3874540485523, 8.695338501730001],
            [-10.38851550762602, 8.695491422281382],
            [-10.37479738279332, 8.776851441811518]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -111.49555421657504,
          "lat": 46.332478785679825
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30007"],
        "coty_name": ["Broadwater"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Broadwater County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01719625"
      },
      "bbox": [
        -10.458197912398528, 8.04576745230569, -9.90357918937735,
        8.960652627660735
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.83373835957179, -1.7859656924074945],
            [14.836729363366707, -1.7725160235941981],
            [14.886186902720185, -1.7755746637429684],
            [15.023800843119943, -1.7482068784802953],
            [15.025472082777613, -1.7489898236260237],
            [15.043917444433667, -1.8562311862505154],
            [15.053050041046955, -1.9093270476482267],
            [15.057496437132409, -1.9114359055479195],
            [15.061603291098866, -1.9165209567849812],
            [15.06671277667504, -1.9180480950804677],
            [15.07305103805367, -1.9224900436908408],
            [15.076721709891874, -1.9343184686200716],
            [15.082394913167064, -1.946584444201391],
            [15.081828084794846, -1.9563525585451544],
            [15.079924203043715, -1.9609567992143544],
            [15.074483507770738, -1.9695023165784515],
            [15.07272903812936, -1.974045376164896],
            [15.072663308533688, -1.9792432806235716],
            [15.070477343097378, -1.9884015820232033],
            [15.086306343979725, -2.098659736128605],
            [15.094288988496604, -2.154211467229389],
            [15.057881074600756, -2.1771466838414737],
            [15.053920947059012, -2.1810862541224116],
            [15.051339473261999, -2.1868590947301],
            [15.052584833674281, -2.1912589610686313],
            [15.049910571433147, -2.1930286455117574],
            [15.043008169222365, -2.1877681036292347],
            [15.038493662775885, -2.1859356906043073],
            [15.037295831864064, -2.1811488120865503],
            [15.032562998465533, -2.1773801139633844],
            [15.019129824012758, -2.17309640682664],
            [15.014608691718367, -2.1766211731470455],
            [15.007630974534159, -2.1763620454882506],
            [15.001789462378085, -2.1846948168859828],
            [14.988457212922658, -2.186836351790733],
            [14.98135945597184, -2.183657259995955],
            [14.977700734909975, -2.1761295206779616],
            [14.974053508589643, -2.1714866009508107],
            [14.965662589397787, -2.1735176857594514],
            [14.961575948549989, -2.1695507080773795],
            [14.954815955577455, -2.167759187424361],
            [14.948655425551621, -2.169221786485695],
            [14.943274727264663, -2.1669405655787695],
            [14.938962242796368, -2.167852764483006],
            [14.932860292248353, -2.170917187347131],
            [14.924242318191862, -2.1718181642704004],
            [14.901321316220425, -2.1940492199419426],
            [14.830092416338571, -2.1926380945950035],
            [14.828596868558174, -2.177935133605962],
            [14.75738701878794, -2.1691816625283797],
            [14.697849370998417, -2.1172066584699847],
            [14.70182129026169, -2.101909377970949],
            [14.706128396957974, -2.087464169074071],
            [14.716988486201556, -2.0853567828154516],
            [14.719273111465581, -2.07874674326941],
            [14.721122814760244, -2.0766824779587147],
            [14.73035967640749, -2.072120171662561],
            [14.737846617049408, -2.076026349341983],
            [14.743067014335512, -2.075491733045038],
            [14.74875368137828, -2.071087727680031],
            [14.759046610637089, -2.0594134283647314],
            [14.760164856232718, -2.050124088181699],
            [14.765392410192815, -2.0509325174166895],
            [14.772035555824669, -2.048124321328627],
            [14.77503801838785, -2.045214021280093],
            [14.783324300902214, -2.044081080288566],
            [14.783800876043388, -2.0416531488899547],
            [14.788809484789594, -2.0420089012506013],
            [14.790076783951235, -2.0395335664484415],
            [14.798912505029108, -2.0378153743761827],
            [14.804077485330415, -2.035684694357002],
            [14.807883289878449, -2.0316956124192247],
            [14.806932374663932, -2.0268414286243384],
            [14.801482239279633, -2.0268838026241225],
            [14.801780125259208, -2.0218489636021113],
            [14.797459633703356, -2.016684005381009],
            [14.799650013175459, -2.0082747262120395],
            [14.807637038788641, -1.9986872026853018],
            [14.80804246683132, -1.9939599818934715],
            [14.802803529983619, -1.9904343079220448],
            [14.799761881477945, -1.990836462899367],
            [14.793916307997291, -1.965443963931955],
            [14.800207414298983, -1.9377553963652125],
            [14.815520623909386, -1.8678298634082857],
            [14.818108950471892, -1.856714983564394],
            [14.83373835957179, -1.7859656924074945]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.00401392293819, "lat": 35.3639597047681 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37191"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "01026128"
      },
      "bbox": [
        14.697849370998417, -2.1940492199419426, 15.094288988496604,
        -1.7482068784802953
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.022641059515825, -1.6000995489158891],
            [12.021887742808165, -1.5922922970755826],
            [12.023846306204954, -1.5867728692701482],
            [12.030391456645985, -1.5873972034886346],
            [12.036610686322158, -1.589611834552528],
            [12.037824672830428, -1.5824587786645574],
            [12.043864077644969, -1.5758691844416939],
            [12.04709300914265, -1.5763235489569505],
            [12.056311180851592, -1.5679423448819165],
            [12.055090582228948, -1.5570028711852062],
            [12.064255714143693, -1.5551332871617702],
            [12.06713101193932, -1.5511640892794571],
            [12.063315920650082, -1.540754192037042],
            [12.064549634205617, -1.5379393192475264],
            [12.069341808087493, -1.5383682986256155],
            [12.071765983724111, -1.5410156335215568],
            [12.077247709167722, -1.5417050512810548],
            [12.086888168989033, -1.5446059552596334],
            [12.087691787066966, -1.5468340670456657],
            [12.094892038381346, -1.550484790780825],
            [12.097419371876994, -1.543219869436541],
            [12.103109548267051, -1.5410711473192895],
            [12.10054116130416, -1.525360080033995],
            [12.106271199579176, -1.5207518442009906],
            [12.105376680540372, -1.5138385010596032],
            [12.10246485795422, -1.5126187803477333],
            [12.102258071514456, -1.469711665583457],
            [12.121503061745397, -1.4472052429470668],
            [12.12467754638353, -1.4445287671262816],
            [12.127073364387153, -1.4453998098709226],
            [12.12808744144745, -1.4504332209368809],
            [12.133172415081019, -1.4501429585685344],
            [12.13887516261939, -1.4527066882699837],
            [12.14412451130557, -1.4500727120123584],
            [12.149863656080901, -1.4510602072818548],
            [12.154148044699049, -1.4486903467307484],
            [12.160354100974232, -1.453316861876383],
            [12.164709188079563, -1.451631926407297],
            [12.1695533008764, -1.4518262606389936],
            [12.1786400182573, -1.4501947894843847],
            [12.179766588998, -1.4466766211371498],
            [12.18277195809915, -1.44519747827464],
            [12.18775870179432, -1.4460036263199378],
            [12.191537462969984, -1.4431273219007819],
            [12.192193526966985, -1.4404138351301674],
            [12.199123723324591, -1.4335298321666727],
            [12.204359392657434, -1.4316103791887873],
            [12.209088309428626, -1.4227472373360668],
            [12.225308734731215, -1.4061078245858636],
            [12.240819376297152, -1.3697897000333137],
            [12.242761320609654, -1.3724642025064395],
            [12.252859815955915, -1.3753154509660033],
            [12.25496222998847, -1.381185669389163],
            [12.26015532622009, -1.3822310182567992],
            [12.263426220369283, -1.3866991486599562],
            [12.26726441154365, -1.3831987356775286],
            [12.269756759736644, -1.3758410073502956],
            [12.269067005866875, -1.3720990974829916],
            [12.288372992222573, -1.3561605448620044],
            [12.29323134664612, -1.3534595758351178],
            [12.2968591501748, -1.35782720659139],
            [12.302293961157833, -1.3589059437551263],
            [12.304208594506244, -1.3628351853451632],
            [12.308117476356212, -1.3659134245308346],
            [12.307902897019638, -1.369512307251679],
            [12.310184682477063, -1.3738717394364635],
            [12.337644070176792, -1.376410919171938],
            [12.340830799117738, -1.3940322310050266],
            [12.357486433347244, -1.411955522271998],
            [12.368091251428199, -1.4122376281559537],
            [12.381736594581545, -1.4017606698021596],
            [12.392710853674624, -1.4033231386199585],
            [12.393812812500698, -1.4004068657668989],
            [12.388531580969895, -1.3914154430808714],
            [12.390085284084769, -1.3883403647370836],
            [12.396034144487718, -1.38446162217864],
            [12.39827221026298, -1.3816808613312979],
            [12.399799436884214, -1.3757666498108747],
            [12.40181933405651, -1.3781383810485996],
            [12.408222637316989, -1.3791720759708426],
            [12.410768551486518, -1.3825296717815345],
            [12.409839597933997, -1.3887942727271874],
            [12.414813671182767, -1.3923049065301336],
            [12.424022182665366, -1.4009406854304658],
            [12.432201925476514, -1.4039842824445068],
            [12.43355137290005, -1.406229505483661],
            [12.44107391983787, -1.4072945177371423],
            [12.44226026039463, -1.4045007392094526],
            [12.446211634988414, -1.404254893760512],
            [12.449155799706675, -1.4073495074356577],
            [12.45464961160956, -1.4088227234036639],
            [12.459157565837327, -1.4138925742815096],
            [12.467880665236695, -1.4273010107386617],
            [12.472957346216925, -1.4287960528210213],
            [12.489369397615633, -1.4386720330025196],
            [12.50027628499905, -1.5290466701254803],
            [12.509669421420503, -1.6046469118734001],
            [12.517799997768597, -1.6747819876077201],
            [12.522531899301494, -1.7100098764686398],
            [12.468858057929332, -1.7171615372692486],
            [12.447625167509882, -1.7188242994094294],
            [12.407659796206913, -1.7386220406820196],
            [12.392815887993594, -1.7456471983139907],
            [12.38716929947041, -1.756253858918853],
            [12.355582295200405, -1.764719472904959],
            [12.354796847034503, -1.7620716815779203],
            [12.349050884269236, -1.7582679887378352],
            [12.34334675277222, -1.7568860307172192],
            [12.340818052030253, -1.7607647931135584],
            [12.33590863391542, -1.7602230030389907],
            [12.334020178315335, -1.7582903900865834],
            [12.323163167486387, -1.7614125498835576],
            [12.321491709356023, -1.7604881974299937],
            [12.316951068428606, -1.7651118726016886],
            [12.30173246358037, -1.7757708700566948],
            [12.295246936803274, -1.7756866684788628],
            [12.293702750889056, -1.7714810481211516],
            [12.28580825439452, -1.768740867578675],
            [12.278951869485734, -1.768122376862139],
            [12.277121486666896, -1.7700742060825947],
            [12.271626932775183, -1.7697549375409185],
            [12.270096620956425, -1.772472322012188],
            [12.265203725416967, -1.7727464463826665],
            [12.260210384790385, -1.7777566666831006],
            [12.250937163907244, -1.7779237816209794],
            [12.24445373067639, -1.779470745737132],
            [12.242727389402676, -1.784599214441287],
            [12.240432487382291, -1.7861712961319711],
            [12.235709190891042, -1.7845156439735923],
            [12.221260214954949, -1.7890822585696295],
            [12.219147114059622, -1.7925620972649945],
            [12.21229184379785, -1.7971617621285565],
            [12.209068401007489, -1.8037477241285982],
            [12.202654921829188, -1.810106880415411],
            [12.195081457878292, -1.8141528495592658],
            [12.18807977800002, -1.8154688144066815],
            [12.186395351984759, -1.8232715139351916],
            [12.179986705459132, -1.8263012680143946],
            [12.178262582537139, -1.8247787849362789],
            [12.1621584369744, -1.800512207667732],
            [12.147200767737417, -1.7927351115609231],
            [12.134199863609304, -1.7871532602793618],
            [12.124509379382493, -1.7852350457371944],
            [12.117755168313362, -1.7890984333748736],
            [12.116398116037294, -1.7870739086638185],
            [12.121515631615749, -1.7792061530529544],
            [12.114727960380462, -1.7730560682859],
            [12.108723975500817, -1.7650202266619315],
            [12.100630400063956, -1.7589262241338997],
            [12.096182033172546, -1.761631119540261],
            [12.089997996115887, -1.7556819574312956],
            [12.083518255264885, -1.7593093341803032],
            [12.079370433287815, -1.7596975423545738],
            [12.077468719726774, -1.762173493688519],
            [12.0715010650275, -1.75809137546784],
            [12.070650570082146, -1.7532125712224265],
            [12.065279339601586, -1.7500118935532363],
            [12.064366373353298, -1.7466105542509247],
            [12.060335249576438, -1.746263255223038],
            [12.055630505533902, -1.7499678420117921],
            [12.054495876165198, -1.7530068692866834],
            [12.045081540309162, -1.7472020410360105],
            [12.045132447517705, -1.7432949593999723],
            [12.038989295848463, -1.744713956585207],
            [12.036899715345323, -1.7432685209817418],
            [12.03151368531592, -1.744212163329416],
            [12.027357613178188, -1.7420787862490368],
            [12.020204643358548, -1.74672680641843],
            [12.0139998637159, -1.7472447533107873],
            [12.00866685800432, -1.7427281735153177],
            [11.987733039436012, -1.7307860379396005],
            [12.019585266628603, -1.7003279117489791],
            [12.02761341130902, -1.681350356754999],
            [12.045921848794176, -1.6371538933872023],
            [12.041877893341027, -1.635432259326224],
            [12.034482929769638, -1.6185744218507059],
            [12.033997774732953, -1.6117774846253077],
            [12.028724842567952, -1.6103712649693063],
            [12.023173225311274, -1.6045299847660854],
            [12.022641059515825, -1.6000995489158891]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.16299761155005, "lat": 36.20615429366756 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37193"],
        "coty_name": ["Wilkes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilkes County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "01008595"
      },
      "bbox": [
        11.987733039436012, -1.8263012680143946, 12.522531899301494,
        -1.3534595758351178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.141718280201729, 10.430815495326982],
            [-4.054687227781477, 10.424530832634382],
            [-3.9678800207594387, 10.418287575255178],
            [-3.8736774224507986, 10.41164614989777],
            [-3.7940768381246044, 10.406142652868478],
            [-3.7073278646978487, 10.400258032888631],
            [-3.6595518160866374, 10.397076163849384],
            [-3.62012385954177, 10.394787850458554],
            [-3.533509192436391, 10.389535736180495],
            [-3.540167897200136, 10.287575099636245],
            [-3.545797078311333, 10.203372665625569],
            [-3.6074548875974095, 10.207236572594267],
            [-3.6325790467867836, 10.208939697341338],
            [-3.638390254599689, 10.124564793026591],
            [-3.692355886209594, 10.128027441644715],
            [-3.6991600011332, 10.02938567163212],
            [-3.7038280996377266, 9.958973419991343],
            [-3.7615913874017113, 9.962700224803582],
            [-3.8201662595006938, 9.966640430586533],
            [-3.8777567627945757, 9.97068497201761],
            [-3.964987432490997, 9.976485279693078],
            [-4.051846244605721, 9.982464080696397],
            [-4.138895759409813, 9.988644485099405],
            [-4.132679865888291, 10.073091599835482],
            [-4.1263788502945395, 10.15775444305515],
            [-4.162477516794807, 10.160324870697886],
            [-4.155891282343341, 10.24469771603429],
            [-4.149698577915197, 10.329150707537535],
            [-4.141718280201729, 10.430815495326982]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.51821289391715,
          "lat": 48.79100719217523
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38013"],
        "coty_name": ["Burke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burke County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01034235"
      },
      "bbox": [
        -4.162477516794807, 9.958973419991343, -3.533509192436391,
        10.430815495326982
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-16.183452467991437, -10.38748569378903],
            [-16.177915845862305, -10.386971898752183],
            [-16.09419975500533, -10.378836765410286],
            [-16.095793623858505, -10.363576035391187],
            [-16.052054004365374, -10.359068771847642],
            [-16.064973667569816, -10.239965527554777],
            [-16.067979526618437, -10.240280637359875],
            [-16.07140640123752, -10.208582873226751],
            [-16.075505839830893, -10.170679389871367],
            [-16.08086026968535, -10.121154188656588],
            [-16.083910848800826, -10.121473254239094],
            [-16.08712035291888, -10.09168728522577],
            [-16.039485988534334, -10.086603215776679],
            [-15.997381185783613, -10.081934037397836],
            [-16.001094608152165, -10.050024795957984],
            [-16.007771062332424, -9.992646983675076],
            [-16.0098342515441, -9.992879931622683],
            [-16.023659861712723, -9.87383448531293],
            [-16.025752352543574, -9.87407006315842],
            [-16.02976963760853, -9.839414932963832],
            [-16.03673295080016, -9.84019595758529],
            [-16.040238947306406, -9.809769008158254],
            [-16.045090048077142, -9.767661488980261],
            [-16.04368329422309, -9.765992238131686],
            [-16.041801532608442, -9.765231411530928],
            [-16.038927800598284, -9.76347571527992],
            [-16.02838149157334, -9.760158309063154],
            [-16.02333891407498, -9.759154026853071],
            [-16.02279604686407, -9.758090615380878],
            [-16.021205770746413, -9.758374505849105],
            [-16.020123909949767, -9.757324184583714],
            [-16.018316236903292, -9.757261113541412],
            [-16.013501314834205, -9.757629819848024],
            [-16.011738827486457, -9.757315637971647],
            [-16.00972360488845, -9.75776163227593],
            [-16.00579437465691, -9.757332832525812],
            [-16.003710648994307, -9.757972440541122],
            [-16.00267542016688, -9.757339885236116],
            [-15.998020998007249, -9.758320959148566],
            [-15.994994637712676, -9.756141072299185],
            [-15.993535427534791, -9.756772237130136],
            [-15.9914436719434, -9.75662611479152],
            [-15.990325234114254, -9.756054599415119],
            [-15.987943091277133, -9.753531419670969],
            [-15.987981034857105, -9.752188152699084],
            [-15.986441320377425, -9.750299351240196],
            [-15.987198003220458, -9.744034759599026],
            [-15.913953399729632, -9.734888040773052],
            [-15.840706182598637, -9.725761422083512],
            [-15.837822392527311, -9.725380991244466],
            [-15.833784084913074, -9.755074642272552],
            [-15.755752581645991, -9.744470195479686],
            [-15.744041505569617, -9.74282795201864],
            [-15.743333417303473, -9.747701870948385],
            [-15.668169423606823, -9.736558562193059],
            [-15.59300222111012, -9.725435922520543],
            [-15.517456166084472, -9.713414507965746],
            [-15.518548865335148, -9.715342553253654],
            [-15.517763446283055, -9.717465665247001],
            [-15.516621833192515, -9.719434753160686],
            [-15.514351141537523, -9.72127037884367],
            [-15.51466612852273, -9.723370702748097],
            [-15.51353585162533, -9.726538997397693],
            [-15.513977928279283, -9.727586956147574],
            [-15.513006071090462, -9.729315016262934],
            [-15.513232417584572, -9.730424246573001],
            [-15.511336791559568, -9.733672531386844],
            [-15.512669766969129, -9.737344093610428],
            [-15.511758831901526, -9.73897692928284],
            [-15.51029254114538, -9.739513458683058],
            [-15.506152349919155, -9.740326711265315],
            [-15.505465895181764, -9.741191981279826],
            [-15.504744925522408, -9.743438526552659],
            [-15.505280831147704, -9.74549010698285],
            [-15.504952703400354, -9.746128553805661],
            [-15.505989674305242, -9.749787617347675],
            [-15.504075650752315, -9.749295488877975],
            [-15.50226494093244, -9.750648620702494],
            [-15.499956842891258, -9.750237491947168],
            [-15.498569036966508, -9.751094881476956],
            [-15.496862621680082, -9.751184227844204],
            [-15.494356095785582, -9.750626069552903],
            [-15.491978133503073, -9.75135606504552],
            [-15.490114492536035, -9.75148582043857],
            [-15.489690037888217, -9.753385943073448],
            [-15.48847033836843, -9.75585987400082],
            [-15.488869980718798, -9.758878339312522],
            [-15.48988007005573, -9.75984486985921],
            [-15.491834872503615, -9.76016154288209],
            [-15.494328361789934, -9.761431653009312],
            [-15.493207739598587, -9.763615483028648],
            [-15.492460527067818, -9.766613771258118],
            [-15.49323942749493, -9.76767926166857],
            [-15.492799390916193, -9.769532338442376],
            [-15.493299559635705, -9.770560430883945],
            [-15.491178306309765, -9.77109922457834],
            [-15.491184386343576, -9.774044520640773],
            [-15.491954487437416, -9.774587877135964],
            [-15.492430369748508, -9.776512738490117],
            [-15.494975057486675, -9.778482473844894],
            [-15.495735491115834, -9.78046872051667],
            [-15.494234203456452, -9.782223068073744],
            [-15.494569959359312, -9.78449845436613],
            [-15.495523990781878, -9.785784965388672],
            [-15.49572242173612, -9.787333762768082],
            [-15.49738523061824, -9.787765175616789],
            [-15.498306651866393, -9.790740336434062],
            [-15.4980040351144, -9.793454866500783],
            [-15.499641454043113, -9.794162406645134],
            [-15.500583639825406, -9.79512408856231],
            [-15.501887544043184, -9.795066980602446],
            [-15.502278706783265, -9.80174304641331],
            [-15.50481738241615, -9.80121015492169],
            [-15.506171033770393, -9.802495281854604],
            [-15.506986043676747, -9.804656004280558],
            [-15.506403824018012, -9.8080021775915],
            [-15.506343363683747, -9.810602279537935],
            [-15.50863997857422, -9.812364284949021],
            [-15.510373937622505, -9.811921932008906],
            [-15.51282813974565, -9.81357204735976],
            [-15.51270521483301, -9.814840871251675],
            [-15.511210842075283, -9.816676989194768],
            [-15.507050958957864, -9.818266855088972],
            [-15.506692089867093, -9.82045224692943],
            [-15.504347183315888, -9.821905223647],
            [-15.500844225932378, -9.820529467398902],
            [-15.498442636775163, -9.822089527680742],
            [-15.49693774540475, -9.822317355475395],
            [-15.496009703847335, -9.823827750831411],
            [-15.49327935688293, -9.82483657151321],
            [-15.490445436664631, -9.826638054792726],
            [-15.489228223201021, -9.828463662960864],
            [-15.487026545816448, -9.829479467255899],
            [-15.485480499235877, -9.829705849517227],
            [-15.48267964355862, -9.828934444902995],
            [-15.481776039157323, -9.82760131553164],
            [-15.48007715901929, -9.82746203529505],
            [-15.478091282563453, -9.829586711040088],
            [-15.479908376317184, -9.832286723750261],
            [-15.480551187199955, -9.834706139848144],
            [-15.48069648034312, -9.836644410315253],
            [-15.482741895000586, -9.839375090424069],
            [-15.483493247679359, -9.840992531334333],
            [-15.484826708103522, -9.840897879294756],
            [-15.485312816482066, -9.842859790024217],
            [-15.484854342131035, -9.84417063116633],
            [-15.485640351787715, -9.845501772930353],
            [-15.485371951332226, -9.84728686519403],
            [-15.486299090774548, -9.849564750344099],
            [-15.487761833042587, -9.850496829283388],
            [-15.487354197781844, -9.853056706136657],
            [-15.488884202810844, -9.854191616616648],
            [-15.491477079947105, -9.854179292278799],
            [-15.49331145536934, -9.85562524820858],
            [-15.494272943381407, -9.857422801767576],
            [-15.494626120492738, -9.85924859420755],
            [-15.493746708429924, -9.860014186697747],
            [-15.491817039978987, -9.860308425152702],
            [-15.491682356389974, -9.863840898467783],
            [-15.490523916502243, -9.865728544259673],
            [-15.48907386278255, -9.867142363477587],
            [-15.491136043418495, -9.868704976980968],
            [-15.493584755059885, -9.86807819241728],
            [-15.495220023482437, -9.868285930785621],
            [-15.497185683351367, -9.871760653828124],
            [-15.49732830104688, -9.873556891587107],
            [-15.496269746111185, -9.87383428968658],
            [-15.494868202264056, -9.87511901164561],
            [-15.494645566709865, -9.87710036177459],
            [-15.493466313618923, -9.87805968277852],
            [-15.492615191865161, -9.879839459755168],
            [-15.490972637650211, -9.880727203902659],
            [-15.488248446361286, -9.880493723208327],
            [-15.486853525575112, -9.880809194390007],
            [-15.485292043495784, -9.881859779236972],
            [-15.484419066780061, -9.884034884884947],
            [-15.48191131959304, -9.883754970441396],
            [-15.480390977315636, -9.884701991629557],
            [-15.479975758239679, -9.8836865250691],
            [-15.477396380289687, -9.882998021242397],
            [-15.47418162945671, -9.882880942432191],
            [-15.471896234184053, -9.881320661840427],
            [-15.470655866532775, -9.881619241800383],
            [-15.468837777433812, -9.880858732696588],
            [-15.468653377194642, -9.88217447179939],
            [-15.467161638873108, -9.882870668115276],
            [-15.463992856775688, -9.88516788013329],
            [-15.462819181782619, -9.885332212531214],
            [-15.46171884037337, -9.886413265554877],
            [-15.458060758461295, -9.886503834565955],
            [-15.456329480660497, -9.885112091617437],
            [-15.45644749825845, -9.882719524676931],
            [-15.456096359806063, -9.880608996509824],
            [-15.454439798856399, -9.879972280374025],
            [-15.451478576173416, -9.881524141771703],
            [-15.448495525405843, -9.881862332787307],
            [-15.446390836660992, -9.880332465446365],
            [-15.445121810133218, -9.881736120947298],
            [-15.442985484230132, -9.882231601019026],
            [-15.440279375692889, -9.881848803094842],
            [-15.441901257991148, -9.879051610272171],
            [-15.440777378395953, -9.877257399680271],
            [-15.441477706866133, -9.875090505977164],
            [-15.441307725134754, -9.873464540713739],
            [-15.439570569049193, -9.871135215687287],
            [-15.439633258929211, -9.869205021137567],
            [-15.437911546541596, -9.867816964671942],
            [-15.438661856708126, -9.866617016619102],
            [-15.43775780805112, -9.865546585806081],
            [-15.437105171692608, -9.862410427489408],
            [-15.435487617078884, -9.860937804656697],
            [-15.433097769893429, -9.860013476308378],
            [-15.431256638032508, -9.860328368913793],
            [-15.4295817956334, -9.859891701797647],
            [-15.429377252691115, -9.85878911719094],
            [-15.431761761570815, -9.856155266941572],
            [-15.432381175089047, -9.853528415460188],
            [-15.43246880982347, -9.851646348143495],
            [-15.430616455426643, -9.850855816073242],
            [-15.429761983480047, -9.849743885074705],
            [-15.430435732542906, -9.848744551755482],
            [-15.430527573157493, -9.846597849783745],
            [-15.431486319719093, -9.84560868786506],
            [-15.430795858837714, -9.842387471871097],
            [-15.4292591273703, -9.840294106937185],
            [-15.423815667217633, -9.840212257705776],
            [-15.42226462888508, -9.840976468786893],
            [-15.42146981998085, -9.842311399203506],
            [-15.41889865589262, -9.842499162495628],
            [-15.417558152367416, -9.843080286302644],
            [-15.41521513259086, -9.842580883735257],
            [-15.414344023598007, -9.843593603260075],
            [-15.413085874041215, -9.846293892404889],
            [-15.413339444136092, -9.848145405871515],
            [-15.410746578272091, -9.848093003942859],
            [-15.408465111671912, -9.847131737713859],
            [-15.407681432435128, -9.843935132961],
            [-15.406145966822024, -9.843462606064515],
            [-15.404052827899346, -9.844978847889836],
            [-15.402201424419792, -9.845357378119541],
            [-15.399575066056293, -9.84491414316061],
            [-15.397301966537405, -9.84499757263789],
            [-15.396930454307894, -9.845645004654084],
            [-15.394215325271373, -9.845520851490866],
            [-15.393747525977231, -9.844655213179117],
            [-15.363455948330804, -9.839390822070467],
            [-15.358130446382935, -9.868891782702754],
            [-15.328502169574552, -9.86365941758295],
            [-15.323046751581668, -9.89313753053135],
            [-15.299518078590639, -9.888920700942625],
            [-15.281970844598005, -9.983338683675402],
            [-15.277606001878652, -10.006821138230329],
            [-15.283639313924716, -10.007907605562453],
            [-15.280718561020619, -10.02367044392435],
            [-15.251298801000306, -10.018507985613503],
            [-15.247173477113094, -10.040428900588612],
            [-15.237660521714147, -10.090971384986215],
            [-15.10382222128971, -10.06570356583839],
            [-15.103126865708465, -10.069288435010284],
            [-15.093259691354787, -10.11805974562698],
            [-15.092462861798191, -10.122315743954081],
            [-15.083725477573097, -10.165376609945634],
            [-15.05808828302595, -10.292575665738987],
            [-15.029247830546984, -10.435604589029257],
            [-15.000467410260946, -10.578400262266388],
            [-15.036212878373648, -10.585312222748357],
            [-15.039144615344245, -10.570535421268394],
            [-15.136679529782414, -10.588804897625474],
            [-15.142248578944148, -10.559379698376112],
            [-15.171345379754767, -10.564660991762299],
            [-15.176716067416434, -10.53551168516242],
            [-15.327530448217495, -10.565960261957336],
            [-15.330902722140511, -10.546606130723159],
            [-15.340521135613482, -10.50027290559528],
            [-15.402566432384587, -10.519490035339551],
            [-15.420701859735255, -10.523575103614032],
            [-15.429014934599659, -10.524565754129583],
            [-15.433871684066183, -10.50043806921052],
            [-15.433364520887233, -10.500460750833794],
            [-15.434008631218616, -10.493889953642967],
            [-15.435744032830128, -10.494237770960648],
            [-15.485189732217016, -10.501924372618923],
            [-15.495835794065474, -10.438043919916483],
            [-15.614520521589629, -10.455701906069825],
            [-15.61520082705859, -10.45233277857552],
            [-15.61804521342742, -10.431118929209704],
            [-15.618997025284171, -10.425808105008127],
            [-15.61699927176745, -10.425542995514181],
            [-15.619756292860504, -10.406390542439595],
            [-15.621512393890006, -10.395799167077737],
            [-15.691281121270725, -10.405964796631823],
            [-15.69712038868995, -10.406662082307038],
            [-15.782076458836048, -10.418100763509537],
            [-15.78411629689146, -10.41823904675574],
            [-15.910069438024713, -10.433540914799995],
            [-15.919140052726219, -10.434761523393334],
            [-15.92305430940681, -10.404834102678134],
            [-15.925863054294535, -10.40520676206248],
            [-15.926653403657166, -10.405868378286293],
            [-15.929503746270951, -10.406627572324235],
            [-15.92998393009143, -10.406181316358785],
            [-15.937288647460294, -10.40655939821688],
            [-16.026469314010313, -10.416427387176396],
            [-16.089159751951303, -10.423225148232975],
            [-16.091233934907113, -10.40852153686905],
            [-16.18058382997083, -10.417174092613411],
            [-16.183452467991437, -10.38748569378903]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -143.96804935110734,
          "lat": 61.88343297470561
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02066"],
        "coty_name": ["Copper River"],
        "coty_area_code": "USA",
        "coty_type": "census area",
        "coty_name_long": ["Copper River Census Area"],
        "coty_fp_code": "066",
        "coty_gnis_code": "02804401"
      },
      "bbox": [
        -16.183452467991437, -10.588804897625474, -15.000467410260946,
        -9.713414507965746
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.249580137518105, -2.372200946152541],
            [4.263991233531491, -2.371693791231901],
            [4.264773281032751, -2.4039405320581078],
            [4.266506719105488, -2.401089998752676],
            [4.268201028580044, -2.3884737521185095],
            [4.272400574923069, -2.3893204220928874],
            [4.275864035000994, -2.3950154681035416],
            [4.2751767812012105, -2.4000918089781105],
            [4.277708855042355, -2.404758065618355],
            [4.281521790210044, -2.4061699695798375],
            [4.287063771468816, -2.4059385814365113],
            [4.295510263143246, -2.409578190817379],
            [4.30005733061005, -2.4068392941267787],
            [4.302537769893439, -2.4099290897774046],
            [4.302566453844573, -2.415173443105947],
            [4.308703255648868, -2.419838152430829],
            [4.312794074696513, -2.421413189007863],
            [4.31947276868357, -2.4191447276356097],
            [4.325006151042384, -2.423311691571174],
            [4.328653380996692, -2.4208056966781037],
            [4.334834964453155, -2.4288751097543324],
            [4.335624118239606, -2.431991451619248],
            [4.33413003952507, -2.436488375398675],
            [4.339467741582854, -2.4414387569867846],
            [4.343850294597144, -2.4441241847617774],
            [4.341808851629093, -2.449924476137323],
            [4.347195945203546, -2.459159181336076],
            [4.351069681447988, -2.457798886938837],
            [4.354992939391555, -2.4614805771321673],
            [4.355168989643036, -2.4650995850391886],
            [4.36065068437426, -2.4648207062892773],
            [4.363219129411218, -2.4696165243086705],
            [4.368578065604754, -2.4701047399660876],
            [4.37787155182026, -2.4730588206166098],
            [4.389335202364695, -2.4746042224867315],
            [4.39561801931671, -2.4728577145513517],
            [4.394744566616998, -2.480133759867123],
            [4.395408199094094, -2.484437317542545],
            [4.394245665707283, -2.492077557166202],
            [4.3984122884592045, -2.494891230269372],
            [4.400685508166974, -2.498458064167583],
            [4.398542963570762, -2.502789635145442],
            [4.40500949439717, -2.5087038972073596],
            [4.4125716176918806, -2.5047694412546857],
            [4.4132256118219955, -2.4964707827354444],
            [4.412446821858841, -2.490498202331541],
            [4.410522699031613, -2.4868418495817264],
            [4.409825693494114, -2.4815283477531693],
            [4.41496899834102, -2.473879758251901],
            [4.417970860086381, -2.4710245061900635],
            [4.482313782280715, -2.468624990472783],
            [4.555812992563154, -2.46477965507445],
            [4.613822267488789, -2.4624568920572614],
            [4.6636119801083025, -2.4602748526662808],
            [4.663120601413437, -2.463121814021814],
            [4.651673412934931, -2.475681929861834],
            [4.645808485584174, -2.488191560586014],
            [4.647230671727611, -2.4993777868081506],
            [4.646847299484852, -2.502079142319745],
            [4.642239410375312, -2.5058640890573285],
            [4.632592795348097, -2.511351059310063],
            [4.6326969788262895, -2.5151161965826137],
            [4.629282225948162, -2.5203314105477737],
            [4.6232381371921685, -2.526257782078948],
            [4.620571820351891, -2.525963258446097],
            [4.616987910921666, -2.529708623588938],
            [4.608937329895834, -2.5333156075235626],
            [4.606530840119865, -2.544811168012748],
            [4.606492931501254, -2.5582748497992895],
            [4.5966178200165295, -2.574149245200753],
            [4.595550262424954, -2.579436731547768],
            [4.598453241169897, -2.5913475737799647],
            [4.592658854921195, -2.603558634732676],
            [4.585860108450245, -2.6125195960450833],
            [4.586900585893444, -2.619890579619082],
            [4.583736323136395, -2.62173487324167],
            [4.587486493787008, -2.6248891132478818],
            [4.594539429154585, -2.627808590377421],
            [4.596969446722964, -2.6314337918658732],
            [4.596778214794079, -2.6368217019831888],
            [4.593140833179439, -2.636071894242782],
            [4.592200525944198, -2.642415096138775],
            [4.590063430654728, -2.6473095800788715],
            [4.590204996138889, -2.6521966914397455],
            [4.586336565350816, -2.655240160826231],
            [4.585750512990046, -2.661334717600826],
            [4.586721104433156, -2.6659174061154345],
            [4.5819259885483765, -2.6662392765320932],
            [4.581404701388326, -2.6703200447275224],
            [4.584846374992076, -2.6730952146692846],
            [4.583047140699399, -2.6770612980656625],
            [4.583380263490367, -2.68542195609799],
            [4.586456934615229, -2.686683186268459],
            [4.584812932273845, -2.69179983072881],
            [4.5762438609359, -2.691965753397994],
            [4.578091819769739, -2.7357975268467376],
            [4.449829777348367, -2.7384121639995143],
            [4.4127982913003505, -2.7383415539457205],
            [4.364477115081849, -2.7377773549120374],
            [4.316489616121401, -2.7402200662528364],
            [4.277177568110387, -2.7414050188985413],
            [4.1890865957159065, -2.7459058252194004],
            [4.1875722636589465, -2.679850717449135],
            [4.185612696772204, -2.581627717891865],
            [4.185927438293107, -2.566073229863177],
            [4.184544976945327, -2.5090907415761183],
            [4.1835436392033465, -2.4927016155924946],
            [4.183089826223054, -2.4767134320058535],
            [4.180215080854351, -2.4765087622857362],
            [4.17837074007732, -2.4028943712587525],
            [4.192488421274195, -2.402355858141721],
            [4.192641703942566, -2.3884140406833705],
            [4.249981571484666, -2.386734989460209],
            [4.249580137518105, -2.372200946152541]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.10699450326034,
          "lat": 36.041197176898784
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05075"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00066865"
      },
      "bbox": [
        4.17837074007732, -2.7459058252194004, 4.6636119801083025,
        -2.371693791231901
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.455564430990546, -2.9163628835433206],
            [4.474718169654497, -2.916057021661362],
            [4.499512775588537, -2.9150613611397036],
            [4.542120311675981, -2.91371021402825],
            [4.595377548624965, -2.9117273515176705],
            [4.688386938661785, -2.907031922191958],
            [4.699689853737208, -2.9066437979440014],
            [4.715694593786125, -2.9054557159628227],
            [4.744922404019871, -2.9042447145606767],
            [4.771705551389481, -2.9028130676984127],
            [4.800529785331809, -2.901625712139397],
            [4.852920279506581, -2.8967261931955206],
            [4.886635820840942, -2.8938049437192634],
            [4.928620053296039, -2.894589888505165],
            [4.9696346846346575, -2.8946226109490003],
            [4.987339668663539, -2.8943089931709687],
            [5.016267729625323, -2.8927735603214186],
            [5.058819521520806, -2.891077842536347],
            [5.061872326286487, -2.9351506439409563],
            [5.0629615723707895, -2.9640294329390335],
            [5.06929475420782, -3.0664648687371256],
            [5.074558310311618, -3.154064007767712],
            [5.031029381792799, -3.1560436665026597],
            [4.9854663129912105, -3.157702716344898],
            [4.900674069979148, -3.1610781459588297],
            [4.813157945036798, -3.1659903341860227],
            [4.812871567021001, -3.1589183988626286],
            [4.761597039706881, -3.1610798399632314],
            [4.727908013195812, -3.1626737187877927],
            [4.728074034287693, -3.1666245380324676],
            [4.661601610304984, -3.1702589943977966],
            [4.641299541121601, -3.171495896935505],
            [4.598357474216312, -3.175946837845498],
            [4.554891171750835, -3.1801059018524893],
            [4.476634082555407, -3.183382541306089],
            [4.467739545623223, -3.183570617310105],
            [4.465552053225933, -3.1393679234047274],
            [4.46166826078046, -3.0650441604329117],
            [4.456888384473064, -2.955432754782187],
            [4.455564430990546, -2.9163628835433206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.66299212225029,
          "lat": 35.574016785994324
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05111"],
        "coty_name": ["Poinsett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Poinsett County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00069174"
      },
      "bbox": [
        4.455564430990546, -3.183570617310105, 5.074558310311618,
        -2.891077842536347
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.401295215945792, -3.63113046355795],
            [4.457332598655203, -3.6290791057344998],
            [4.485971410675896, -3.628199895658886],
            [4.484965330184591, -3.599858866361318],
            [4.481932539045381, -3.5246402450002883],
            [4.480569146809725, -3.480157248515525],
            [4.53790888441202, -3.4778576402544097],
            [4.559819620076503, -3.4765754074736397],
            [4.567059972557355, -3.4750257704896996],
            [4.611900314066801, -3.4730197814186394],
            [4.616866340859475, -3.4729782074132274],
            [4.6459984072452, -3.470421832778256],
            [4.6535199788057815, -3.4709581085252936],
            [4.711328988413441, -3.4683766124375754],
            [4.740374528709034, -3.46641234292715],
            [4.740437527770327, -3.467441434191625],
            [4.794256680325712, -3.4657228038471874],
            [4.808716401622164, -3.4654161714037603],
            [4.808675716439987, -3.4635205857160027],
            [4.82957184974275, -3.4629608184365774],
            [4.838311697954711, -3.4640424231493574],
            [4.917568352801042, -3.4610859317043134],
            [4.917502856424007, -3.460152800823954],
            [4.928732172358541, -3.4597137606821677],
            [4.946768131865285, -3.457757912839065],
            [4.978750647542915, -3.4537030007799485],
            [5.000292081658741, -3.451272818507306],
            [5.004624361690616, -3.546198807795904],
            [5.005045927904597, -3.550581771521286],
            [5.007129981142203, -3.5978340501497423],
            [5.0030457341121926, -3.5980813338988793],
            [5.008218393176945, -3.6970583008988],
            [4.93477853624862, -3.700663381104519],
            [4.8925521655576185, -3.702180200328082],
            [4.885247607584517, -3.7027091104766794],
            [4.836720642262726, -3.7046310134360523],
            [4.804139306394412, -3.70693636535928],
            [4.697229212135729, -3.712986898332465],
            [4.6568553980072664, -3.714591820379282],
            [4.603009339779085, -3.717089329254546],
            [4.57414056183695, -3.7185654916752666],
            [4.489884570385421, -3.7177611860079587],
            [4.447010211011687, -3.7203278168006197],
            [4.4486581277913, -3.765091312967215],
            [4.434532422275229, -3.765806260058958],
            [4.43293588181072, -3.7220540118431793],
            [4.432373322728962, -3.720901876722148],
            [4.411223750544686, -3.7223822096048527],
            [4.403758888963386, -3.7223295340302913],
            [4.403186908123345, -3.7086180110423306],
            [4.402221364435248, -3.6649164716919835],
            [4.401295215945792, -3.63113046355795]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.74780149001174, "lat": 35.02203454816591 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05123"],
        "coty_name": ["St. Francis"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Francis County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00083331"
      },
      "bbox": [
        4.401295215945792, -3.765806260058958, 5.008218393176945,
        -3.451272818507306
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.1162866884483758, -3.8358220347686878],
            [3.188315769019513, -3.835252292395791],
            [3.188906720880659, -3.9229563795285363],
            [3.2742297754923135, -3.9227806324598866],
            [3.2745619249038276, -3.939386001562682],
            [3.2749553214913396, -3.995587530226822],
            [3.3181382489354094, -3.99536176791023],
            [3.3176826818092, -4.009852877622379],
            [3.364215926324585, -4.009709092011755],
            [3.364338413149163, -4.054992662226416],
            [3.387463386297416, -4.054619208368935],
            [3.4159704637649986, -4.05375782615629],
            [3.444935801014509, -4.053359539391199],
            [3.4447947248256385, -4.096987934963456],
            [3.5301077591864023, -4.095078269437448],
            [3.5322541416433166, -4.182848572699018],
            [3.4034758334078408, -4.185681646735034],
            [3.4040858272735286, -4.229739658844157],
            [3.3445683217374134, -4.230506594478043],
            [3.291899892125566, -4.2315390586087505],
            [3.2528862070707563, -4.231592558104144],
            [3.2466888064464845, -4.23479178090741],
            [3.246691718021719, -4.242918594065991],
            [3.243653100214667, -4.248603847942087],
            [3.236404278786993, -4.255919468656053],
            [3.230900148391462, -4.2568685043082635],
            [3.2262485370953775, -4.262902799192823],
            [3.2256971090108912, -4.268338898389292],
            [3.2316916963232036, -4.271217242733093],
            [3.232158798786288, -4.2743449299984535],
            [3.2256710355803433, -4.275214777998885],
            [3.1896061306249157, -4.275146466030068],
            [3.175257241260914, -4.275453772108833],
            [3.174122713067441, -4.216743590241652],
            [3.1301598120855982, -4.217426054352161],
            [3.1296012824663064, -4.18796134115876],
            [3.099113515704431, -4.188451007840387],
            [3.0847162242504123, -4.189151272387991],
            [3.0841102460588283, -4.130406619164534],
            [3.0698521079313514, -4.130620967304939],
            [3.06965323686737, -4.102296856514579],
            [3.0134085100681456, -4.10339260821923],
            [3.0131916246629684, -4.059101124548266],
            [2.987404440743589, -4.059518157668153],
            [2.9278221349506075, -4.059788980799037],
            [2.927372833262897, -4.042102717699461],
            [2.9270494163690444, -4.011878357623313],
            [2.9346339234552374, -4.011755162837439],
            [2.9331954576058803, -3.967935672769142],
            [2.932177471969678, -3.9237786557223893],
            [2.845994792601462, -3.9268467454739597],
            [2.845170368019926, -3.8973022848215013],
            [2.8442661057828142, -3.8400272104763564],
            [2.9292852680572685, -3.8364994150103917],
            [3.0429649615307004, -3.8365380318810565],
            [3.044108340483747, -3.8394416114711345],
            [3.0486820253510802, -3.8423868289540706],
            [3.0599225728321366, -3.8442881911168327],
            [3.0649587286966318, -3.8395980667532053],
            [3.068671179744193, -3.843585819135592],
            [3.0835786292410305, -3.850977903569973],
            [3.090921793634651, -3.8478440178299365],
            [3.0943857225079396, -3.8509872675559813],
            [3.103201713410218, -3.847306876026014],
            [3.1080484141193456, -3.8536883641500306],
            [3.1122560968464628, -3.8552178333926594],
            [3.1166922130464525, -3.861750665849695],
            [3.1162866884483758, -3.8358220347686878]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.67657727706464, "lat": 34.64662804168376 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05125"],
        "coty_name": ["Saline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saline County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00067102"
      },
      "bbox": [
        2.8442661057828142, -4.275453772108833, 3.5322541416433166,
        -3.835252292395791
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.24343553616359, 2.066256878265002],
            [-5.157327427943572, 2.0592984523463205],
            [-5.160350830394377, 2.0083027087617955],
            [-5.162837183598685, 1.9718438332729633],
            [-5.16454358966671, 1.9421395693056283],
            [-5.169112517518467, 1.88492523295981],
            [-5.173912424430353, 1.8851400995755885],
            [-5.17528008582535, 1.8679978582837533],
            [-5.182436790983256, 1.7848794213579589],
            [-5.183935840432731, 1.7735145884936878],
            [-5.202267584351646, 1.5350679076510125],
            [-5.273742259387347, 1.540599726150768],
            [-5.281243234828779, 1.5413501216248824],
            [-5.321558822647488, 1.5444159254732928],
            [-5.379120532102551, 1.5490489063473696],
            [-5.500479456117216, 1.5588745568547249],
            [-5.587354540122471, 1.5660401113722184],
            [-5.715502615664899, 1.5766465954633058],
            [-5.706034160413315, 1.6852154580418903],
            [-5.69953873980111, 1.7575876323075201],
            [-5.695350033628812, 1.8088275839128254],
            [-5.693703023605209, 1.8269713461468988],
            [-5.685429700803578, 1.9277401779159564],
            [-5.683131096908075, 1.9284262384740636],
            [-5.674911158700944, 2.015304294006819],
            [-5.6750449030402565, 2.015483757609668],
            [-5.668295415285039, 2.102488458474947],
            [-5.596007367111337, 2.0963071727717373],
            [-5.495751352874425, 2.087392883373914],
            [-5.3433942227491436, 2.073304548189677],
            [-5.329234904288201, 2.071782651945235],
            [-5.24343553616359, 2.066256878265002]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.80973633986652,
          "lat": 40.26266480758165
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08087"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00198159"
      },
      "bbox": [
        -5.715502615664899, 1.5350679076510125, -5.157327427943572,
        2.102488458474947
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.99123985615479, -8.095766106468998],
            [11.993914123440002, -8.095843217672334],
            [11.997405953451027, -8.099419936047761],
            [12.00636507686848, -8.096371438366063],
            [12.011201311290284, -8.089516962730176],
            [12.01054099000489, -8.083545508793616],
            [12.013467822128597, -8.07988101531948],
            [12.01160522358042, -8.076240387813963],
            [12.013684003404897, -8.07338110482858],
            [12.020004743434185, -8.07335624884377],
            [12.022731538856773, -8.070592884091068],
            [12.01846985916847, -8.068074459334802],
            [12.020488340298172, -8.062681313271327],
            [12.023494696641446, -8.063585464020866],
            [12.028643370524536, -8.06836099511448],
            [12.032917621278145, -8.067188311210655],
            [12.035550761053383, -8.062022578993073],
            [12.039881519029189, -8.06017196129396],
            [12.043121314744171, -8.056677959626931],
            [12.043972404460604, -8.052445747114884],
            [12.047551688941505, -8.050314900078709],
            [12.04201081318363, -8.045536214901597],
            [12.039816716507, -8.031537376346874],
            [12.050567935199044, -8.029899733385674],
            [12.04952482903966, -8.022828293983004],
            [12.053084371689962, -8.022313185259367],
            [12.050438673478912, -8.00443616126254],
            [12.048079283474033, -8.00201526881818],
            [12.05349291902177, -7.998819194116069],
            [12.056813842349909, -7.999432610149091],
            [12.061742447195668, -7.991008995107143],
            [12.06646173673726, -7.986714194120316],
            [12.06935291277037, -7.986135177694762],
            [12.07253939640199, -7.98883044983173],
            [12.078190598291284, -7.9881089398329665],
            [12.079413044294718, -7.98455916513338],
            [12.083215942037482, -7.983606598498927],
            [12.087333937953927, -7.978024454988599],
            [12.086172226153494, -7.9715759791234095],
            [12.09035476418325, -7.966605989939679],
            [12.097196262761567, -7.967532112702128],
            [12.101614335743545, -7.965060536158949],
            [12.112371683815113, -7.9685575229665275],
            [12.119841337401729, -7.968673872297853],
            [12.125049016068644, -7.967225676413622],
            [12.131700143349383, -7.971126129571205],
            [12.137549949248967, -7.978653589290262],
            [12.146124222996479, -7.972355252613621],
            [12.150647010752113, -7.975771428683819],
            [12.155457769934053, -7.975987028000811],
            [12.156711681700523, -7.970956940060621],
            [12.163254198597185, -7.9724330048553105],
            [12.16493767741925, -7.970319841788746],
            [12.170389539896767, -7.97126453020756],
            [12.177146045363628, -7.977481918276492],
            [12.181116351133847, -7.97909255162002],
            [12.183810959436904, -7.975534128967255],
            [12.190755673259009, -7.977058959300972],
            [12.196841959879242, -7.985582490977403],
            [12.19654589266152, -7.989455079958757],
            [12.203787771828338, -8.005798705615343],
            [12.207273783403458, -8.00926353788505],
            [12.209882301532922, -8.00836957780955],
            [12.216532372337015, -8.012113331267473],
            [12.225366794901278, -8.011367936879603],
            [12.227528299059902, -8.013015595644864],
            [12.232267722850015, -8.01262740621574],
            [12.238819191135649, -8.009677599126752],
            [12.242068535838536, -8.013000737034075],
            [12.245593412574083, -8.011337637052627],
            [12.255145465355817, -8.01188723482416],
            [12.261964510456346, -8.008806035936969],
            [12.264319050939902, -8.012150555658602],
            [12.26746136674976, -8.01248201531188],
            [12.273801032810443, -8.018605206557424],
            [12.281382328356106, -8.017145523512932],
            [12.282704929875381, -8.024611048636633],
            [12.290180446862918, -8.023572400063818],
            [12.291301820247293, -8.03017338535423],
            [12.299226841701088, -8.02974733097847],
            [12.308131946500302, -8.032973629143356],
            [12.312446161981736, -8.035867530162884],
            [12.323080934729086, -8.034747836997608],
            [12.326429349891407, -8.030784659336739],
            [12.330547280988192, -8.031140474924458],
            [12.336805187218582, -8.026710206767074],
            [12.343636290721472, -8.023417329331537],
            [12.353115707858032, -8.025465612252441],
            [12.353769486361601, -8.029059471725764],
            [12.377466092248005, -8.025440055242882],
            [12.383740480612317, -8.021810635601314],
            [12.39045114903798, -8.02095873032462],
            [12.398505080866933, -8.0272065726145],
            [12.40669883738149, -8.029730796720905],
            [12.413418058130182, -8.026166776332472],
            [12.416119807963236, -8.026592779154546],
            [12.428831903948419, -8.024762022260166],
            [12.429705926167186, -8.027472370420885],
            [12.441220189018095, -8.025743729422059],
            [12.441966997286041, -8.030782077117303],
            [12.44449434992844, -8.030401279089912],
            [12.445744653154662, -8.037378300696927],
            [12.450898007670274, -8.036617125517349],
            [12.453463829768472, -8.054667960418511],
            [12.455502694897204, -8.054327029713143],
            [12.460037568464328, -8.060821869491143],
            [12.461182012167656, -8.068258877988331],
            [12.468598156694602, -8.067060166562058],
            [12.469508956815679, -8.07456603505205],
            [12.476230016972252, -8.07331082436577],
            [12.48345031172875, -8.076458435766368],
            [12.49127403913164, -8.075717069454948],
            [12.496093062196017, -8.077777198419026],
            [12.4968085942841, -8.086652026830878],
            [12.495409106279627, -8.092651144902895],
            [12.500506924012809, -8.091949666519305],
            [12.505955751437197, -8.093114133776817],
            [12.50966233263622, -8.095315012285049],
            [12.518593782982403, -8.102709413308327],
            [12.52046423683873, -8.106055494492175],
            [12.523845634040466, -8.117077386770498],
            [12.525165535017862, -8.124396480569835],
            [12.524901276710803, -8.13141345585177],
            [12.529853425685243, -8.13342606920934],
            [12.5304451487513, -8.135372844008998],
            [12.531805460242254, -8.158123203072916],
            [12.532526457421927, -8.17897371250128],
            [12.533495695531146, -8.191605693466729],
            [12.53510730771574, -8.202870899576546],
            [12.54319674064733, -8.252259162515273],
            [12.555227390534704, -8.337334519331078],
            [12.56078168218782, -8.373314397663124],
            [12.565297544310177, -8.402037760175164],
            [12.564623443056378, -8.404032068504899],
            [12.558414988979688, -8.405314319289403],
            [12.55509365122773, -8.401578098904759],
            [12.551606986059378, -8.40261424333418],
            [12.553588813368458, -8.411358380831818],
            [12.550511101998202, -8.411396835945578],
            [12.548294803473556, -8.407618112977813],
            [12.543711544473942, -8.4066513074394],
            [12.538647054318963, -8.412071244019133],
            [12.536465812211905, -8.41715627255907],
            [12.532293839648197, -8.418384326696229],
            [12.52660778023269, -8.411217835489746],
            [12.522875818404788, -8.414364897521821],
            [12.51779029803816, -8.415801275778744],
            [12.516501320743776, -8.418695203736476],
            [12.513202431380027, -8.41957822753301],
            [12.513124574887248, -8.423098534878381],
            [12.507217102513756, -8.423481094316216],
            [12.50379796331425, -8.420605356043184],
            [12.498334315558502, -8.418603484008512],
            [12.490715071022546, -8.431288563383674],
            [12.495481821957005, -8.433978903299655],
            [12.488850798367261, -8.437837810280024],
            [12.48565396181696, -8.428985559522332],
            [12.480524491615208, -8.433765467580034],
            [12.478625897980125, -8.43162589211649],
            [12.47045742085424, -8.431984899572507],
            [12.458331708183351, -8.438156023103124],
            [12.449423871812805, -8.439797405460784],
            [12.443349557071794, -8.437515711224652],
            [12.441309421771763, -8.435506860624434],
            [12.434073879690388, -8.434459945474885],
            [12.430946738481273, -8.431645402874107],
            [12.429768663778807, -8.426564995904872],
            [12.429824466709793, -8.414074990819753],
            [12.423427946401102, -8.407411011864438],
            [12.424079186427976, -8.404215980809795],
            [12.427546942606831, -8.399905082204176],
            [12.434591640645765, -8.40232556546763],
            [12.444039602882455, -8.401729504783292],
            [12.439740067660512, -8.406375400638204],
            [12.444742292509295, -8.408230782944981],
            [12.44873943535047, -8.406419594882513],
            [12.447290795636784, -8.400107227323025],
            [12.440522030760699, -8.397913759080064],
            [12.436198266193578, -8.395202186459379],
            [12.433430120548868, -8.391070735347697],
            [12.42669180301206, -8.392970712976267],
            [12.426172537091212, -8.390026563433164],
            [12.423014593572278, -8.387260763661413],
            [12.425982105562227, -8.38447144645363],
            [12.424557115225005, -8.38026138768201],
            [12.42173109246999, -8.38054583248681],
            [12.35963866411286, -8.389376534945711],
            [12.256653126205423, -8.403396760575587],
            [12.221211894800163, -8.408100149753114],
            [12.204964818704449, -8.410721739906748],
            [12.179359187639838, -8.413920381056077],
            [12.18029609469212, -8.420910511142052],
            [12.177238875112367, -8.421036286071223],
            [12.127972791758307, -8.426614797437784],
            [12.124993077471194, -8.406860949291657],
            [12.123691720091154, -8.395315928336634],
            [12.120373114956656, -8.373224255183143],
            [12.119171413515824, -8.370345363101158],
            [12.091915188950908, -8.37393746255118],
            [12.051651115958903, -8.381380476790667],
            [12.034378550187677, -8.3842299596949],
            [12.030319102025224, -8.35562725218646],
            [12.021497640047144, -8.293840849004352],
            [12.013985769199381, -8.24291703372251],
            [12.013304021874166, -8.240900590199724],
            [12.009294917112658, -8.212123060865661],
            [12.003393889880849, -8.172781021760036],
            [11.992803493006937, -8.103918120104133],
            [11.99123985615479, -8.095766106468998]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.3578035638235, "lat": 29.674899524312487 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12001"],
        "coty_name": ["Alachua"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alachua County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00308548"
      },
      "bbox": [
        11.99123985615479, -8.439797405460784, 12.565297544310177,
        -7.965060536158949
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.066564714357675, -11.260056876139656],
            [14.142651918595611, -11.24775634763027],
            [14.21873595721869, -11.235436806530712],
            [14.294816835783728, -11.223098250706956],
            [14.370894559828097, -11.210740677908388],
            [14.374471663741215, -11.210274199016801],
            [14.480982234747751, -11.193120525538697],
            [14.587486765671672, -11.175929584211168],
            [14.584142100104915, -11.155684230390463],
            [14.627064210289166, -11.162182482702665],
            [14.671350130786957, -11.16861648325726],
            [14.75760836907734, -11.154336095481538],
            [14.76480214632894, -11.15336752200954],
            [14.765579835812682, -11.157353134585282],
            [14.771424771630127, -11.153536214858637],
            [14.776035180184449, -11.158280907078659],
            [14.787637787233516, -11.156100101841734],
            [14.787650494667602, -11.15844256697825],
            [14.793131181648498, -11.216668734735148],
            [14.790539215283362, -11.21927587071048],
            [14.789751212788437, -11.234445386406563],
            [14.789874726950524, -11.24337746004924],
            [14.790932011799658, -11.253305260752816],
            [14.79068587098826, -11.269948537399047],
            [14.792500826389295, -11.307784974353028],
            [14.792606861896832, -11.326186584405132],
            [14.793304543989622, -11.338536213367378],
            [14.798146795804499, -11.377016139279402],
            [14.795506233956331, -11.382551871627387],
            [14.796706863623568, -11.391297813265966],
            [14.797476993146557, -11.403714797535544],
            [14.798658513270848, -11.413226226148339],
            [14.799225867439333, -11.423949903578684],
            [14.806286463596026, -11.493894786595702],
            [14.80106424573005, -11.495510044160657],
            [14.792060612264624, -11.496619114606936],
            [14.755950764845899, -11.503852835833854],
            [14.738159550719223, -11.50717475327301],
            [14.722070657288295, -11.510591247832261],
            [14.691391746682573, -11.516132535929628],
            [14.648486109896588, -11.524431926138375],
            [14.65085368988208, -11.537629410325607],
            [14.636785162783122, -11.539538162906318],
            [14.600324809055058, -11.545680230335947],
            [14.579105717377875, -11.549024520188613],
            [14.524795306498548, -11.55805275418221],
            [14.420924487147428, -11.574681925610905],
            [14.306066978121576, -11.593170336602727],
            [14.30256599355607, -11.572199325753465],
            [14.216133310572893, -11.585554897722227],
            [14.129696745910044, -11.59888519611273],
            [14.127031181626807, -11.580520869294423],
            [14.093737397462677, -11.414256051215759],
            [14.079674810299654, -11.331376453606946],
            [14.066564714357675, -11.260056876139656]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.48706537056918,
          "lat": 26.152315651706925
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12011"],
        "coty_name": ["Broward"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Broward County"],
        "coty_fp_code": "011",
        "coty_gnis_code": "00295753"
      },
      "bbox": [
        14.066564714357675, -11.59888519611273, 14.806286463596026,
        -11.15336752200954
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.633744631506997, -7.425723422836608],
            [7.676591441206257, -7.42147736923788],
            [7.701325790313954, -7.4196273512133715],
            [7.753056466941775, -7.414222505191633],
            [7.7810709145684465, -7.412009989948003],
            [7.877710656814275, -7.402938669156148],
            [7.926402740310412, -7.398647711185643],
            [7.941294543861605, -7.399173710197057],
            [7.952233249004651, -7.3973948598451456],
            [8.004050282439408, -7.390767464595101],
            [7.999930352667414, -7.396964276457467],
            [7.995817514166108, -7.394681854949621],
            [7.995393825441522, -7.40196076187143],
            [7.9856798772790025, -7.410025739268812],
            [7.984350726840792, -7.415031075303937],
            [7.977652708128039, -7.415707231841476],
            [7.971656261472259, -7.422870985795401],
            [7.965033310502881, -7.426412847093865],
            [7.964470278996393, -7.431465818676938],
            [7.960742654628972, -7.429991520740843],
            [7.953108216768634, -7.433331505185246],
            [7.949805527303372, -7.430970730019932],
            [7.945807580860654, -7.431113692670519],
            [7.9409961438727, -7.43414464336098],
            [7.944302705668028, -7.437055709446122],
            [7.942642500488965, -7.446198796120558],
            [7.939033074705015, -7.449616573584923],
            [7.939119797373285, -7.452981321752062],
            [7.933902279495329, -7.453613802279289],
            [7.935624780292188, -7.457273183548704],
            [7.933708537303822, -7.459190281200012],
            [7.932109566257428, -7.464739401407888],
            [7.9288029340305215, -7.464980918899476],
            [7.926444436042751, -7.461702240861962],
            [7.92152711968663, -7.46256706729147],
            [7.914801840544975, -7.467816876946286],
            [7.915580964160017, -7.470787575766973],
            [7.909911253234273, -7.473519777419383],
            [7.90904341075037, -7.482620099365308],
            [7.911331279934828, -7.4877986596278685],
            [7.907905395071216, -7.490580390512838],
            [7.909163616008909, -7.494763316094677],
            [7.909475787451119, -7.503317892198134],
            [7.912196441422368, -7.506006348598983],
            [7.911424338846467, -7.510170412355023],
            [7.9036078517039385, -7.514409104740202],
            [7.900153046698388, -7.517924550895811],
            [7.900099089891993, -7.525666946608417],
            [7.901860447079977, -7.527256764144347],
            [7.898854797069577, -7.5325490081546675],
            [7.8991513945875225, -7.535808527305856],
            [7.893443889877568, -7.535317322666365],
            [7.892067547865495, -7.539878927981002],
            [7.892178315347834, -7.544906226294581],
            [7.889947200540437, -7.551338128258653],
            [7.892172806498544, -7.552999626508322],
            [7.896518343956928, -7.551460607962275],
            [7.895527405168838, -7.55651995781318],
            [7.900238893751962, -7.556861127635042],
            [7.899804495489926, -7.560648980521313],
            [7.902343370159563, -7.570890104629138],
            [7.906673097106742, -7.5742392354377674],
            [7.907548245620895, -7.583268657336083],
            [7.911036294844716, -7.58571290148001],
            [7.908492832271446, -7.5896025438542045],
            [7.906716963876155, -7.597046184036687],
            [7.903786551885756, -7.5970323276602265],
            [7.90174119652564, -7.60030732362218],
            [7.901190693018573, -7.611455392674207],
            [7.896777316248613, -7.6137855954229545],
            [7.8997013123176485, -7.616439990428125],
            [7.899735197681133, -7.62054554000413],
            [7.902185897608736, -7.62367990502073],
            [7.900016735926653, -7.626035602621902],
            [7.904080679851633, -7.628467393340956],
            [7.905849233353766, -7.632911976356046],
            [7.903711700056517, -7.639862057116563],
            [7.904239828437732, -7.644946078118593],
            [7.901885306599188, -7.647109866180279],
            [7.9026805386769565, -7.658256098872256],
            [7.901653140326031, -7.663985918529664],
            [7.905708413832442, -7.671459805301687],
            [7.909118891142192, -7.674602953128307],
            [7.918218730870836, -7.679406277271226],
            [7.918585747645855, -7.676091348096005],
            [7.924311201684529, -7.677306997767842],
            [7.929963145114577, -7.676781920984453],
            [7.931978182517997, -7.679480644916885],
            [7.937664570233059, -7.679259215412113],
            [7.94048887795984, -7.683480229431475],
            [7.941811507248983, -7.688777047347127],
            [7.940318545639768, -7.691877481022342],
            [7.941791658681763, -7.695373557479906],
            [7.938515417851847, -7.696656278916033],
            [7.9415269460531075, -7.703618376410756],
            [7.946004818047257, -7.706611455407671],
            [7.943980771075216, -7.716197679258319],
            [7.9463592730045685, -7.717954722768957],
            [7.94694733083378, -7.729569371249155],
            [7.949442730261717, -7.73234701660174],
            [7.951446502137981, -7.747124254290592],
            [7.958270275847246, -7.758048000997936],
            [7.956462761971329, -7.7635791884403],
            [7.958786081684729, -7.764736263320476],
            [7.959879358027011, -7.769691001531373],
            [7.958123775626668, -7.774541985173064],
            [7.960974151109705, -7.7818930321148025],
            [7.963391425190344, -7.784145353006993],
            [7.970657005868365, -7.786305064624896],
            [7.972495079238281, -7.789740034534171],
            [7.970603504329759, -7.794195443130523],
            [7.975973625591184, -7.795966643235177],
            [7.979142987653356, -7.794734939466545],
            [7.985103510244451, -7.8053179758290145],
            [7.990264268600057, -7.808888463789796],
            [7.993048714526925, -7.817404361497887],
            [7.998864254031062, -7.8254262726195165],
            [8.005943290159093, -7.833502991578596],
            [8.01417025014713, -7.8356821655829165],
            [8.01886376869598, -7.83865246523548],
            [8.023506301659062, -7.838334733322172],
            [8.03250409308439, -7.84153993600447],
            [8.05053767801511, -7.845356437081662],
            [8.055396046924148, -7.848852865296501],
            [8.072382893045393, -7.870867995970432],
            [8.08686344725063, -7.883706538620947],
            [8.084327371671213, -7.895823395326779],
            [8.07939554239574, -7.913087918099522],
            [8.078980505659086, -7.919706362449064],
            [8.075336641928947, -7.945516565364733],
            [8.07126693481549, -7.963321399781325],
            [8.06869137385485, -7.96993671283453],
            [8.061397635717288, -7.977572603724141],
            [8.016837080291639, -8.0098055022904],
            [8.01005939830915, -8.013067508539397],
            [8.002846720052428, -8.018112218047811],
            [8.006931423166913, -8.044657999395916],
            [8.02766456238756, -8.044234331968838],
            [8.037417577284435, -8.046775664481947],
            [8.052571516575888, -8.047815136877416],
            [8.073627178586918, -8.033473578747968],
            [8.087087667459002, -8.03101872522447],
            [8.117539050329427, -8.024649122543167],
            [8.140172483591304, -8.01703834389277],
            [8.175407390178737, -8.004639566765999],
            [8.225252872813702, -7.986691317143839],
            [8.270819933208191, -7.976996365843345],
            [8.27236588179621, -7.992386977967417],
            [8.243638210751211, -8.000650589869386],
            [8.16333110839618, -8.025267830912465],
            [8.125606973891205, -8.037604214854063],
            [8.073602939855352, -8.054025089827752],
            [8.03075729759383, -8.064227671322314],
            [8.01353252831002, -8.067920014019123],
            [7.993397855365628, -8.071636591477233],
            [7.975515664599468, -8.073984364574194],
            [7.9606293942792385, -8.070947158621271],
            [7.94928340098842, -8.06503188678156],
            [7.948271059953669, -8.062978455236813],
            [7.938996784167139, -8.068315676776768],
            [7.9377585757027695, -8.072718728045649],
            [7.924643707603089, -8.077688229797072],
            [7.879875309903813, -8.092968654190772],
            [7.854022024401963, -8.102648207556426],
            [7.843041317165438, -8.106288802153621],
            [7.82090102014737, -8.111639617808445],
            [7.797300974127656, -8.119055549455993],
            [7.788440047239195, -8.122295585875877],
            [7.766408790851986, -8.128941301955603],
            [7.766051296714882, -8.125522343379318],
            [7.781492844798363, -8.120170686932894],
            [7.821257091604689, -8.104384011216275],
            [7.822250710593789, -8.093442668698215],
            [7.8143482389919345, -8.096936110040781],
            [7.809089228229706, -8.098102074050368],
            [7.800391784060115, -8.098578157197839],
            [7.793974150597248, -8.102234981893293],
            [7.784341858493182, -8.102892049726092],
            [7.777353672673297, -8.101222430179336],
            [7.77431360877996, -8.096315519057505],
            [7.773557154120895, -8.089516082806746],
            [7.774207970725648, -8.084835047901446],
            [7.777819688899222, -8.07961723840595],
            [7.784597792471105, -8.077080330728668],
            [7.7985407581278565, -8.07534214609865],
            [7.807552941898121, -8.072647099635674],
            [7.811487988916071, -8.069308593298869],
            [7.8183278870239326, -8.058776970844752],
            [7.816193162658134, -8.044987355661375],
            [7.816086939517382, -8.038124422861534],
            [7.81777170396539, -8.034786664545658],
            [7.823462364049529, -8.028396429047339],
            [7.825754618770127, -8.023715064545062],
            [7.823336325647705, -8.01805430800148],
            [7.823075331475855, -8.013296235006493],
            [7.82802213934829, -8.006876796139386],
            [7.831239948741298, -7.997623010400136],
            [7.8339119585284935, -7.994693905264644],
            [7.839822566485418, -7.993168001095542],
            [7.848778960808842, -7.993759326369225],
            [7.853281510718178, -7.991960300097307],
            [7.8592986928203805, -7.984048114965386],
            [7.867007340559105, -7.9804654233673045],
            [7.879133838309847, -7.96941648382096],
            [7.882497528441723, -7.9629772707502555],
            [7.8818510321649, -7.959217271989252],
            [7.877989879003402, -7.9532031659417335],
            [7.8687785796186525, -7.9508126532515755],
            [7.859389000510448, -7.950163038315796],
            [7.855280354204106, -7.951528936253585],
            [7.848388985745629, -7.949856309703413],
            [7.845330688449647, -7.946644333697679],
            [7.839423284945423, -7.946277667971876],
            [7.829762687261692, -7.938873077901668],
            [7.825456412143586, -7.934276368680474],
            [7.824058420997332, -7.928422491397757],
            [7.819423852253496, -7.924950905562386],
            [7.822750126076131, -7.914089593445235],
            [7.821812315333526, -7.909490561000443],
            [7.8135444997836325, -7.899413142008891],
            [7.809166478974431, -7.898962497024921],
            [7.806141523339799, -7.894828688767677],
            [7.808298523005507, -7.891615984458724],
            [7.806545771015107, -7.886427445737041],
            [7.805800618330581, -7.879754293312191],
            [7.813351621069747, -7.8570779530024755],
            [7.816672703858861, -7.855661168121157],
            [7.819359117603837, -7.851536804009492],
            [7.820411731068739, -7.845546953157995],
            [7.826575895090736, -7.843235811876595],
            [7.827872169710621, -7.8386643073547395],
            [7.825992548456073, -7.835587884451294],
            [7.8306242947178495, -7.831517486674511],
            [7.833078323296685, -7.8208547144845255],
            [7.833472932915602, -7.804640142536405],
            [7.834836805558468, -7.801066675069158],
            [7.839191306117885, -7.798459742452438],
            [7.841944423816452, -7.788569803375088],
            [7.84059636349059, -7.78706765881832],
            [7.841760142507965, -7.7730310591873115],
            [7.837123200432071, -7.7562582188794895],
            [7.836492541620119, -7.750097658465456],
            [7.833294828102616, -7.747595634593922],
            [7.828021784308708, -7.738626558477618],
            [7.82632168328466, -7.730252597955253],
            [7.821120573005566, -7.727837162551165],
            [7.815146508005511, -7.7264522487230085],
            [7.810263700266327, -7.723505874154355],
            [7.805098099364327, -7.718711350307967],
            [7.800269794413086, -7.719120839460485],
            [7.7968659347349965, -7.7176191702942925],
            [7.793276718203826, -7.713825852198382],
            [7.786124252640319, -7.7092766023170505],
            [7.7815903985016055, -7.711921955083757],
            [7.773274314349084, -7.709397636371626],
            [7.7694074437937175, -7.705307838356375],
            [7.765846079416224, -7.704323648610922],
            [7.7591505885887155, -7.695023156261256],
            [7.754008781286482, -7.693493913528407],
            [7.7406808698454315, -7.691596763478099],
            [7.7378361061779115, -7.687138224086615],
            [7.731574316778978, -7.6804899868078955],
            [7.720999976507953, -7.676668463389832],
            [7.712857617241202, -7.672219343729684],
            [7.709942141797744, -7.66620667325884],
            [7.70733643160294, -7.6537127638046],
            [7.698744238628767, -7.6450049360045575],
            [7.699104819993731, -7.638342488589588],
            [7.692448997668218, -7.631360050996929],
            [7.6857326247295275, -7.627769601596222],
            [7.685073213197303, -7.626020904635928],
            [7.677578071357969, -7.619867425935372],
            [7.67411941509796, -7.618731525557328],
            [7.66934128071226, -7.611538495680985],
            [7.664682084405828, -7.607718104427629],
            [7.653673102198547, -7.604115510942583],
            [7.648070642809214, -7.600972740228161],
            [7.646695344717413, -7.596590370775987],
            [7.642613397091758, -7.590798078564305],
            [7.633658669352716, -7.5882018855048035],
            [7.632000411714003, -7.582699352127641],
            [7.622764299536196, -7.575916563563459],
            [7.62385711751629, -7.569440248752249],
            [7.620904412459497, -7.563934718641772],
            [7.614689954018194, -7.5587353234960855],
            [7.618110805213592, -7.544235537872957],
            [7.6239451493874055, -7.538441968788427],
            [7.624518262230508, -7.533885483640369],
            [7.622756712349552, -7.52646930861563],
            [7.627683940525564, -7.522099873691025],
            [7.628595488724392, -7.514950075556808],
            [7.63129644764786, -7.506635866192484],
            [7.632636785996175, -7.498670260241406],
            [7.636138936258499, -7.488592826966542],
            [7.640467888907547, -7.481370156663478],
            [7.643668381303691, -7.470744985495234],
            [7.644961228917952, -7.45768012645026],
            [7.639561642988725, -7.4450674101684085],
            [7.639739103651455, -7.439672991542256],
            [7.636494604258069, -7.435314218389101],
            [7.633744631506997, -7.425723422836608]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.36296326699821,
          "lat": 30.668960283685575
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12033"],
        "coty_name": ["Escambia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Escambia County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00295737"
      },
      "bbox": [
        7.614689954018194, -8.128941301955603, 8.27236588179621,
        -7.390767464595101
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.67405875626034, -4.690644594592475],
            [9.756450326762051, -4.681587490606976],
            [9.78910882686479, -4.677541116774941],
            [9.822519521265974, -4.672760365549596],
            [9.862988125723957, -4.6689751006995115],
            [9.864005751387962, -4.67635579080382],
            [9.87342191290654, -4.6760147020805425],
            [9.871989053956957, -4.684349384494632],
            [9.868767956329002, -4.695503180137271],
            [9.865420246174132, -4.698801560129551],
            [9.86255071017879, -4.704945406424851],
            [9.866034738341748, -4.70963124551819],
            [9.865150039261318, -4.716924794166323],
            [9.865460399126652, -4.729374167207056],
            [9.867225081609647, -4.736411467002338],
            [9.866617151556149, -4.740366371012003],
            [9.869943462759922, -4.744031681076519],
            [9.871109642239704, -4.748907854672943],
            [9.875004665685953, -4.756504919976729],
            [9.875273067660777, -4.761480459661761],
            [9.877696443483423, -4.770915087985059],
            [9.879998981829068, -4.771587913793651],
            [9.882647499724769, -4.776970021431442],
            [9.886059653505738, -4.777700564408484],
            [9.886085444715043, -4.781224446925311],
            [9.893813135477386, -4.789156569399009],
            [9.900764005917301, -4.794936804872435],
            [9.902668291271976, -4.797915497505169],
            [9.903370392676718, -4.804772615527705],
            [9.908535075018044, -4.811745970667972],
            [9.910182246622641, -4.817771729105809],
            [9.913784760262486, -4.818620807205486],
            [9.918670308631828, -4.816996165469233],
            [9.923470995746818, -4.8256645283197726],
            [9.929196233026166, -4.828856377181863],
            [9.933159089607807, -4.832391611097699],
            [9.940237483715222, -4.82992444638404],
            [9.942539651060635, -4.8335109811098285],
            [9.947049712263977, -4.833170922371348],
            [9.95059711279314, -4.837734679364318],
            [9.955172398377746, -4.834705391940818],
            [9.955325453470572, -4.8393787556214365],
            [9.96158978292434, -4.8428428132364285],
            [9.963831304596114, -4.848124621574698],
            [9.971457985835972, -4.852432736921214],
            [9.969527806601842, -4.856184723759024],
            [9.970512622877214, -4.8604046178214215],
            [9.97560672510331, -4.865143879805973],
            [9.974213660106496, -4.869963555913386],
            [9.974575398172583, -4.875533810909652],
            [9.97725065076529, -4.878138387820482],
            [9.979766995021699, -4.885105895499009],
            [9.983349278689703, -4.886597142933014],
            [9.98503408282743, -4.890424699274409],
            [9.989021966100838, -4.894983681874103],
            [9.992207789592115, -4.902105968331861],
            [9.99098472889117, -4.90549539679726],
            [9.995297052666391, -4.9090093768711],
            [9.99610287432358, -4.914061512872154],
            [9.992652614701377, -4.915351437737643],
            [9.987378554673954, -4.9222944879072905],
            [9.98837189886789, -4.927605636775361],
            [9.99212271041746, -4.927868820179651],
            [9.995688041055837, -4.935479939800179],
            [9.9917434300009, -4.94109082389448],
            [9.995736153268705, -4.945698017432617],
            [9.94318765135788, -4.951559635779921],
            [9.885529018575744, -4.9575682187303824],
            [9.871516563728909, -4.959152227063504],
            [9.869700190750674, -4.957573433264235],
            [9.868960212266627, -4.951197523907288],
            [9.856789781486306, -4.952574088057508],
            [9.85720249282303, -4.95692555439904],
            [9.853037441827473, -4.957353793223087],
            [9.853405816655748, -4.961108520470384],
            [9.837356835140023, -4.962780782866968],
            [9.836409773248668, -4.954530797139057],
            [9.828798205847972, -4.955512511950057],
            [9.829705554585619, -4.963842952994343],
            [9.792992641560586, -4.967848630603499],
            [9.70662021809527, -4.977614548400234],
            [9.710500270536079, -5.0100222770440395],
            [9.702182807433463, -5.0108668884677305],
            [9.701225860278317, -5.002932077876057],
            [9.697711247641498, -5.006603377920488],
            [9.695710496174229, -5.004340995588478],
            [9.692348424775783, -4.995602468370234],
            [9.700389416745663, -4.994550802171331],
            [9.698521048635655, -4.978294243981449],
            [9.634968685631524, -4.98487871376275],
            [9.617347039645209, -4.94561810409136],
            [9.622100308782837, -4.945019687460899],
            [9.620154687058143, -4.928459681717813],
            [9.61208763941257, -4.9293091631689965],
            [9.612655513171111, -4.934607051061563],
            [9.570869795423176, -4.84085808661125],
            [9.548638225900378, -4.792103801715907],
            [9.5514111063067, -4.786188960038139],
            [9.562487474120047, -4.780877821497456],
            [9.570526848241755, -4.773627150374296],
            [9.571106798987605, -4.768999873941423],
            [9.567190078173866, -4.763050496103093],
            [9.569032275035635, -4.758467635697556],
            [9.57245732726818, -4.7571822534017745],
            [9.577322993345843, -4.7590157577031045],
            [9.580545693531912, -4.7618136543530865],
            [9.586509638448097, -4.764223191214276],
            [9.597167746673591, -4.7725214658636075],
            [9.600572963748885, -4.770578575989195],
            [9.606756097656667, -4.774217885255213],
            [9.612631879798846, -4.7728787546717495],
            [9.614929169086281, -4.76801031955486],
            [9.62376412576117, -4.763412622158354],
            [9.625079566077783, -4.759980715296729],
            [9.623604785719092, -4.756362184932246],
            [9.626840825010214, -4.750314562833912],
            [9.631930569274726, -4.748046028817257],
            [9.631290901285942, -4.740494630919016],
            [9.632232761376605, -4.736028892258973],
            [9.635677462615792, -4.731124035000289],
            [9.64172329272264, -4.72790013655484],
            [9.648184114312674, -4.721492749108291],
            [9.654322905174885, -4.712957915262775],
            [9.666078633972244, -4.710825839588377],
            [9.670828141159976, -4.708175736377869],
            [9.673983857853353, -4.700440549688444],
            [9.67405875626034, -4.690644594592475]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.76337093421168,
          "lat": 33.353378569774605
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13077"],
        "coty_name": ["Coweta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coweta County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00326666"
      },
      "bbox": [
        9.548638225900378, -5.0108668884677305, 9.99610287432358,
        -4.6689751006995115
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.37002204572458, -3.6376560086437895],
            [9.377046906677041, -3.6368458181145096],
            [9.373060038898807, -3.6015853090009253],
            [9.381110856805561, -3.6006235353842584],
            [9.381862435346344, -3.6071197785877374],
            [9.476561584095432, -3.5963754159028256],
            [9.482647871359, -3.595230086681678],
            [9.482769143869046, -3.591092614349719],
            [9.48014071066303, -3.5861628962123167],
            [9.481944719997882, -3.5843504405698803],
            [9.489501604891288, -3.5810053436800504],
            [9.490806340006367, -3.5760768268501355],
            [9.49499414663404, -3.5756548257094085],
            [9.497178880492424, -3.5939111993915933],
            [9.5331307310222, -3.589726592399445],
            [9.534068077633027, -3.5968727902983524],
            [9.60231363655584, -3.5891035546317114],
            [9.602242723735353, -3.5844326179462787],
            [9.612065150777362, -3.580720735958182],
            [9.61591529283177, -3.581340482011293],
            [9.62106172431263, -3.585168457637274],
            [9.627551495962145, -3.585321479623247],
            [9.629184099112871, -3.5833411688978587],
            [9.628196083905873, -3.5721627926639377],
            [9.62886213795438, -3.5702343336546547],
            [9.635333559806393, -3.569401740395846],
            [9.644552788792495, -3.570585725259866],
            [9.652426047752337, -3.56840635994765],
            [9.654160787317464, -3.5721155541312855],
            [9.655610726618821, -3.58604703787786],
            [9.648796104311014, -3.5869037443642564],
            [9.647652873440567, -3.57921159779177],
            [9.64099565340559, -3.580052006761855],
            [9.642733839299801, -3.5941465758921716],
            [9.66357263801708, -3.591825318219924],
            [9.66471625904035, -3.599480683919454],
            [9.683685699120616, -3.598162296788462],
            [9.684498276837914, -3.6046521381722165],
            [9.70676433290119, -3.6021400258218486],
            [9.711002653262089, -3.636331159155209],
            [9.715632931507713, -3.673637308674173],
            [9.722170182455553, -3.72187823895223],
            [9.729308118357352, -3.721234217579587],
            [9.730254430728388, -3.7284155187232932],
            [9.72270061605618, -3.7293200547826553],
            [9.728293884607655, -3.7724146456200165],
            [9.667646783790346, -3.7791736197846593],
            [9.662711753861586, -3.7798534267375894],
            [9.66448033171415, -3.796328847236896],
            [9.58057433791629, -3.8050177562865497],
            [9.559807495588139, -3.80858802660097],
            [9.549967971145774, -3.809562869271576],
            [9.532673292246308, -3.812078196636765],
            [9.532477735607479, -3.8097709512387024],
            [9.490955153349313, -3.814323385226378],
            [9.49171314528086, -3.821677587467947],
            [9.48486392345059, -3.822192089373225],
            [9.487241473617022, -3.829642050256581],
            [9.465904714952693, -3.831537256449065],
            [9.45882043466428, -3.8325566075122115],
            [9.4562018284107, -3.8248667951703568],
            [9.444094421790066, -3.8262987700427162],
            [9.433412083261615, -3.8276681069117187],
            [9.432230761948846, -3.829040121506551],
            [9.426629651130115, -3.8267552501903666],
            [9.426101951426974, -3.821094740344702],
            [9.421971316367625, -3.819842246174795],
            [9.377216758600413, -3.8250955583507866],
            [9.365881497177195, -3.8233831630959654],
            [9.362489880942482, -3.8237374534606214],
            [9.359014174194868, -3.8173920573284392],
            [9.35883560766483, -3.813194843369989],
            [9.363318995177588, -3.8067803115051873],
            [9.371573060279283, -3.8027371990357923],
            [9.370841225918161, -3.7972588862864494],
            [9.365837292134229, -3.786260705521162],
            [9.36042525577006, -3.783816018853813],
            [9.361057257936112, -3.779610370358765],
            [9.358658029196075, -3.774761814999724],
            [9.353696789822587, -3.771276690804583],
            [9.350022456851706, -3.765331947684618],
            [9.367339772600161, -3.763191754891058],
            [9.358345573829153, -3.684848275154566],
            [9.379773539512392, -3.681738731294215],
            [9.375493427015206, -3.649481895195662],
            [9.371317265743379, -3.6498115259702795],
            [9.37002204572458, -3.6376560086437895]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.87581610165782, "lat": 34.50319737770196 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13129"],
        "coty_name": ["Gordon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gordon County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00356672"
      },
      "bbox": [
        9.350022456851706, -3.8325566075122115, 9.730254430728388,
        -3.56840635994765
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.418111039375555, -3.986467216918873],
            [11.423268537964459, -3.990083026615127],
            [11.423340626533403, -3.995596058508246],
            [11.429269109303318, -3.9946686843741777],
            [11.430792753219682, -3.988635809855902],
            [11.43504727155456, -3.985980052678943],
            [11.443980862871522, -3.986591032748683],
            [11.44692007285821, -3.98505250114529],
            [11.454491755863769, -3.9865178674391157],
            [11.455909936805872, -3.9889545140787703],
            [11.464590468472908, -3.9931227481821927],
            [11.467006127220664, -3.9953447879271873],
            [11.475614178472366, -3.996905042126568],
            [11.479999565787386, -4.003013662237754],
            [11.48808547623097, -4.005448933363308],
            [11.495833366195232, -4.014894177855669],
            [11.497957133826786, -4.016149757801942],
            [11.50763287569217, -4.017688114669464],
            [11.514599047681598, -4.013954200783522],
            [11.522462668999657, -4.013130331894102],
            [11.532800426304142, -4.0181459935887665],
            [11.54199272854644, -4.027922734176692],
            [11.549883071922737, -4.039577598404694],
            [11.553004807794544, -4.042893405370299],
            [11.564579503761442, -4.049217026885927],
            [11.574191041411241, -4.057040051927392],
            [11.583695750857391, -4.062230682119851],
            [11.587869344785252, -4.06644138132123],
            [11.594163983487192, -4.0697096196672735],
            [11.600715144307241, -4.0712280093004605],
            [11.611295189741927, -4.079131477285511],
            [11.618567728119135, -4.080214093623629],
            [11.628205124648915, -4.07622146942568],
            [11.633466267154645, -4.07715502468455],
            [11.639538250159662, -4.081935174866876],
            [11.648988809562084, -4.085307056722349],
            [11.653712537237661, -4.088010100674575],
            [11.659905069746571, -4.093561328807063],
            [11.663945504330691, -4.095456609753142],
            [11.679192511916817, -4.099522003437574],
            [11.683594809987358, -4.101234208436245],
            [11.691388307115187, -4.106884186223861],
            [11.703311712006961, -4.112393600912179],
            [11.705898508566378, -4.115325416049832],
            [11.712869402645797, -4.120069989557165],
            [11.715003676787214, -4.123777643385002],
            [11.722898808259911, -4.1265866582985335],
            [11.726931938687486, -4.130392777756133],
            [11.729246249668092, -4.144742049940351],
            [11.732910162712916, -4.146858172059372],
            [11.738114332077025, -4.146340848894882],
            [11.742255327020573, -4.148638206939411],
            [11.748464431302885, -4.154589794051276],
            [11.759717072769796, -4.159343068325661],
            [11.760933906683652, -4.162109584668507],
            [11.768265016518987, -4.164057292969334],
            [11.77595745737408, -4.170335616170916],
            [11.779047317274998, -4.179698591713277],
            [11.785953749890073, -4.190931680765223],
            [11.78705497793955, -4.196523548164017],
            [11.791082521938627, -4.206917794388826],
            [11.790852766778697, -4.213559778272603],
            [11.79410483567397, -4.220866693509726],
            [11.802650015699463, -4.228538051120431],
            [11.809147857756395, -4.232804621401606],
            [11.80133702219751, -4.234284789606538],
            [11.798494211345503, -4.232053108802849],
            [11.790139205578674, -4.228461818533406],
            [11.786413679943573, -4.232918536418691],
            [11.778920784900013, -4.236111349015606],
            [11.769440033060484, -4.238562582353536],
            [11.768659580674766, -4.242311625938041],
            [11.762444192997865, -4.2413851258324975],
            [11.75273341741931, -4.235001546387827],
            [11.750173726621213, -4.23577839885582],
            [11.742802063924215, -4.234475929054362],
            [11.738940051821178, -4.2299457739816235],
            [11.733856198702709, -4.229383226426405],
            [11.731252099613318, -4.232149180106685],
            [11.724452871474902, -4.2326988474385265],
            [11.717249422054627, -4.234585146898871],
            [11.715701504295325, -4.2395017985331895],
            [11.710098801442356, -4.24031577411471],
            [11.709203716687535, -4.244627424882035],
            [11.706847751689166, -4.245844275988123],
            [11.703844589951105, -4.2424787650123985],
            [11.698302153290403, -4.239448877274557],
            [11.701038762859627, -4.251967717503958],
            [11.699250471872405, -4.253578387371106],
            [11.695240803770888, -4.2510305946683005],
            [11.692700120045364, -4.253722789644835],
            [11.695332410444761, -4.258327404508914],
            [11.69053591314998, -4.260340824378449],
            [11.687643944415585, -4.254632820226655],
            [11.68373197387946, -4.255201206322413],
            [11.684743019898809, -4.261844840470916],
            [11.679235766372582, -4.261510071470466],
            [11.678306230753865, -4.266013567167566],
            [11.667459291529095, -4.2683233654389126],
            [11.670226970010559, -4.273395112284347],
            [11.668143074651283, -4.275624731403409],
            [11.664646343344799, -4.273087044266827],
            [11.66277521627601, -4.269335420755063],
            [11.65946291603334, -4.270782357478471],
            [11.659322883178168, -4.274969016109134],
            [11.654574332008512, -4.274860368790539],
            [11.655113606839079, -4.281036698661698],
            [11.654359699024939, -4.287388403745098],
            [11.647835133776432, -4.285431713082612],
            [11.645281908250873, -4.292686568131641],
            [11.642870508606054, -4.292965360702922],
            [11.640073914711518, -4.288921019942277],
            [11.636387386057136, -4.2925237773984675],
            [11.632841896795963, -4.292105347891517],
            [11.630754979880317, -4.2953903399203845],
            [11.626564038848757, -4.294629791372979],
            [11.623861673453716, -4.296808430549409],
            [11.624906436390964, -4.301241917263595],
            [11.620610110888391, -4.3040157615466414],
            [11.61947513388773, -4.310232144801826],
            [11.616275804970778, -4.307752506022997],
            [11.610549210458975, -4.309846493582178],
            [11.606182301898867, -4.305822798907137],
            [11.6025315025362, -4.310060619671611],
            [11.581294394818713, -4.280367427619714],
            [11.572815570712988, -4.269108742693434],
            [11.535175970746684, -4.217019405247434],
            [11.504710678167433, -4.175254255950705],
            [11.482639709060464, -4.1365669143668065],
            [11.481571237263692, -4.130319716674997],
            [11.489066701228555, -4.123706476214283],
            [11.487079240121696, -4.116823119361261],
            [11.49203169267354, -4.1132022140492825],
            [11.49167445902656, -4.109247022627431],
            [11.495260471332122, -4.105928112529785],
            [11.493788376464643, -4.10206196931351],
            [11.494858064733924, -4.096087484447545],
            [11.488805990303389, -4.087579833130645],
            [11.482282447784677, -4.091501784566424],
            [11.481967714851315, -4.09386248488531],
            [11.476569198151374, -4.096792133239999],
            [11.472750261511976, -4.102464291457046],
            [11.468095847117093, -4.105521258051898],
            [11.460651340367885, -4.089540365762657],
            [11.438383968609315, -4.036254652866633],
            [11.426003934352497, -4.005961804575517],
            [11.421855972443065, -3.9973018536689757],
            [11.418111039375555, -3.986467216918873]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.4511412792592, "lat": 33.79358901495343 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13181"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "01688000"
      },
      "bbox": [
        11.418111039375555, -4.310232144801826, 11.809147857756395,
        -3.98505250114529
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.77225453998938, 7.4422102269778865],
            [-12.769700818806747, 7.437983164924988],
            [-12.768459748517396, 7.431481166351037],
            [-12.764433009824007, 7.429641323227331],
            [-12.76481112067631, 7.426530024945653],
            [-12.771848144160973, 7.418880746464487],
            [-12.774451859716416, 7.4098230746236595],
            [-12.778297415727197, 7.404503865384889],
            [-12.78183854050858, 7.401653380676169],
            [-12.782003938163804, 7.394628233213654],
            [-12.784020338022478, 7.393260962747936],
            [-12.788342506236217, 7.385088298898914],
            [-12.78938535774966, 7.381041349952926],
            [-12.78862175964736, 7.371087106283842],
            [-12.786321102942141, 7.369802463690185],
            [-12.78622313010776, 7.362719859575857],
            [-12.782458850680484, 7.353586437823155],
            [-12.77891296231881, 7.350625490643539],
            [-12.77757894422461, 7.346631544743536],
            [-12.771192045021746, 7.346314470522843],
            [-12.765662571649704, 7.334652359689412],
            [-12.756334358506145, 7.323971322260446],
            [-12.75181507699157, 7.311240530166045],
            [-12.751937356630876, 7.304891090995687],
            [-12.749059323907456, 7.302007578835521],
            [-12.746936265171243, 7.296933264560384],
            [-12.748817181676326, 7.293076911039233],
            [-12.747594996329767, 7.2889533821142685],
            [-12.750621014020176, 7.284198520795258],
            [-12.749496898757453, 7.281053241618593],
            [-12.742373637596716, 7.276913502121571],
            [-12.734024154465486, 7.274545206035544],
            [-12.726258722090515, 7.279606113732195],
            [-12.722256348049322, 7.276893861392064],
            [-12.715422633112228, 7.27711740381913],
            [-12.713702998327822, 7.278606207999131],
            [-12.706011387023532, 7.277615113050668],
            [-12.696995326600993, 7.279154915354153],
            [-12.688585491195077, 7.272979673905141],
            [-12.685114863433796, 7.271801834383219],
            [-12.681847234222555, 7.2679732342502374],
            [-12.67532648908107, 7.2654662250221484],
            [-12.67511417393362, 7.26077425519108],
            [-12.671180802667926, 7.257952341007051],
            [-12.667047863066298, 7.252500761707434],
            [-12.662517299063142, 7.244747455538251],
            [-12.661830585585605, 7.237187813334475],
            [-12.658438748910335, 7.2305222297033085],
            [-12.662070605575584, 7.215942287895394],
            [-12.66859101927638, 7.209510314552551],
            [-12.667565568658954, 7.20459568529946],
            [-12.654449362996385, 7.194799386456393],
            [-12.652132309813448, 7.191986216864341],
            [-12.65151095879586, 7.185501769699036],
            [-12.648536048649412, 7.182486529019505],
            [-12.644129248473382, 7.181041536552189],
            [-12.638113670184575, 7.182899301542039],
            [-12.631818513858313, 7.182472484255533],
            [-12.62717991825019, 7.1848433889260646],
            [-12.617010440054415, 7.197156199071362],
            [-12.608934851742617, 7.201859817563751],
            [-12.605566067663272, 7.202273642876653],
            [-12.597370302818112, 7.199241726405471],
            [-12.592571445075112, 7.200079842407888],
            [-12.586426858907691, 7.1884878504062995],
            [-12.581015174189, 7.187487213024772],
            [-12.577968817595053, 7.190472943542888],
            [-12.575665925698972, 7.195620734456276],
            [-12.568194519405777, 7.2000492198181085],
            [-12.559385094034228, 7.201519519797274],
            [-12.558066908164161, 7.207261671781741],
            [-12.55603280453275, 7.209735806466972],
            [-12.555815676268526, 7.214984156345174],
            [-12.553576957309282, 7.219945516983001],
            [-12.549927346115824, 7.2215907980697915],
            [-12.542372808043655, 7.232831537267776],
            [-12.540612031867928, 7.23748554542579],
            [-12.535571849247205, 7.236401224511742],
            [-12.52913939689278, 7.240379476898175],
            [-12.525574743609518, 7.238116160031289],
            [-12.521151506181344, 7.238847978177738],
            [-12.516921256086297, 7.246932126406083],
            [-12.51310570799898, 7.246638751295903],
            [-12.508410371213937, 7.24901614300589],
            [-12.505001296232804, 7.247599750950617],
            [-12.502219281466193, 7.251972229794992],
            [-12.500393207028207, 7.262771324896151],
            [-12.4973817270429, 7.266221729532669],
            [-12.494417445850802, 7.273315610810816],
            [-12.490041360725359, 7.277926016798695],
            [-12.487739402649117, 7.285725515710387],
            [-12.49112246341011, 7.287888671383312],
            [-12.494200413590896, 7.292378941360479],
            [-12.496967119813378, 7.29283457262395],
            [-12.500592541238188, 7.296449152440687],
            [-12.503219228473542, 7.294373111953686],
            [-12.50751749190662, 7.300102099280862],
            [-12.504740256944675, 7.303198911269108],
            [-12.503959776590909, 7.308714705769798],
            [-12.506414818147137, 7.31141937424796],
            [-12.50192050494133, 7.319351037701564],
            [-12.498570290623814, 7.317551083319555],
            [-12.492504425585723, 7.325425377601944],
            [-12.484234074527846, 7.319901404598876],
            [-12.478085110119116, 7.326217082776257],
            [-12.474535321036889, 7.323387285232257],
            [-12.469125533227086, 7.325614264476137],
            [-12.465350605060422, 7.3301554439473735],
            [-12.462598518158309, 7.331122265527232],
            [-12.458958033884253, 7.341655288836215],
            [-12.460261740997673, 7.346699197593564],
            [-12.458537791991784, 7.348884907985886],
            [-12.453744686654076, 7.349585638042972],
            [-12.453239196668042, 7.352516860475317],
            [-12.448727525492297, 7.356935291752261],
            [-12.449839393081646, 7.364153444115058],
            [-12.446344410654227, 7.363286794706017],
            [-12.441073579706401, 7.367402257739117],
            [-12.428750812856576, 7.367867042826436],
            [-12.427991574949273, 7.371843108775794],
            [-12.420074383360804, 7.379361762871553],
            [-12.417248372191082, 7.379607764940408],
            [-12.414101307006565, 7.3833698550217335],
            [-12.404578410748591, 7.384077954218413],
            [-12.401100489640543, 7.3858827728207315],
            [-12.398249739585053, 7.383873751200308],
            [-12.384758305286908, 7.397683268593845],
            [-12.38710268849006, 7.400347891577817],
            [-12.382107919976395, 7.407814991864544],
            [-12.368138621595254, 7.408256431937401],
            [-12.368424190412304, 7.410993019954462],
            [-12.36356871095354, 7.41626225408515],
            [-12.353392486766765, 7.41692916416446],
            [-12.351389864440822, 7.42824407733469],
            [-12.348020706047576, 7.430699629648099],
            [-12.344415177783056, 7.423385867310211],
            [-12.345448283407219, 7.420135486150883],
            [-12.344401946367203, 7.413952436935264],
            [-12.337875905954009, 7.411773571959108],
            [-12.334429568154652, 7.411752514384229],
            [-12.335485887280123, 7.402372735057305],
            [-12.33904695139637, 7.394230887745361],
            [-12.335567124652131, 7.391406729750166],
            [-12.335354581364397, 7.386745623645315],
            [-12.340085988571772, 7.38380266922595],
            [-12.34173890541457, 7.380588788180592],
            [-12.337061748106159, 7.375022722743429],
            [-12.343669453425333, 7.362283795117877],
            [-12.345033453489592, 7.353481121599487],
            [-12.349562925248915, 7.352771113888911],
            [-12.352740508427908, 7.346633516116516],
            [-12.355120113177733, 7.339622643228733],
            [-12.355886283867434, 7.3337445686205935],
            [-12.353548221285923, 7.3299081319769455],
            [-12.358087542085036, 7.327318429155813],
            [-12.35809888603284, 7.323170486831506],
            [-12.363234378737666, 7.3173844536140695],
            [-12.366719456881144, 7.316222880968915],
            [-12.370317377999895, 7.30226802781894],
            [-12.369277113453315, 7.299708997556569],
            [-12.362663073743912, 7.296946216019408],
            [-12.358587599774511, 7.297977546188152],
            [-12.353085869998598, 7.297540381916448],
            [-12.349425642211848, 7.293571201560137],
            [-12.34572185176032, 7.292900130768527],
            [-12.340338090115353, 7.294022392447794],
            [-12.3383067147853, 7.289513332793166],
            [-12.334510232167164, 7.288506253576529],
            [-12.331378327299417, 7.291133460993838],
            [-12.326644433778851, 7.291043253663059],
            [-12.325906040126004, 7.2854414403254735],
            [-12.322499437318587, 7.28386301380063],
            [-12.320061573720018, 7.276258041052353],
            [-12.316774372144193, 7.274289834837991],
            [-12.311154149630614, 7.279717039570215],
            [-12.308923614824822, 7.28317888872685],
            [-12.305912540396351, 7.2803905691881425],
            [-12.300197924135466, 7.28197907321023],
            [-12.294049919643276, 7.288193715016703],
            [-12.287432620557405, 7.289968626398889],
            [-12.282994126896456, 7.292520823956182],
            [-12.276972121473337, 7.291395315656642],
            [-12.277185713249077, 7.285611435500023],
            [-12.272370899886699, 7.281216170075599],
            [-12.271776755625414, 7.273229291692461],
            [-12.270253898631678, 7.267760331069208],
            [-12.266849753670995, 7.264692516182967],
            [-12.266857891364369, 7.257226139897924],
            [-12.26454669054132, 7.250121770332318],
            [-12.261377186837029, 7.244613983495346],
            [-12.263851227419643, 7.239927390696002],
            [-12.262415421574133, 7.234172096864127],
            [-12.264550169140303, 7.230879269337001],
            [-12.26330038866576, 7.2246723229009255],
            [-12.26002782757587, 7.221703841846897],
            [-12.260216258813184, 7.219235250077167],
            [-12.256506889423987, 7.211094618066629],
            [-12.25819986189023, 7.203189617711973],
            [-12.256110254332928, 7.200493327773322],
            [-12.254327215051784, 7.193638795327755],
            [-12.252487792589466, 7.191738444187577],
            [-12.252217931534732, 7.182833242926064],
            [-12.24483619767154, 7.180896545292034],
            [-12.24294397535415, 7.178035747587841],
            [-12.242847054609731, 7.17180889057256],
            [-12.244248307705343, 7.1659721966609995],
            [-12.23736430960342, 7.157192631057586],
            [-12.237028063065251, 7.15371852806446],
            [-12.229843808370628, 7.144173898660472],
            [-12.224995951412774, 7.144160294543676],
            [-12.22093648753085, 7.138479737671281],
            [-12.2219023363928, 7.13193265218188],
            [-12.219142407365533, 7.131382455182394],
            [-12.215717625722048, 7.121720675210662],
            [-12.212726340920897, 7.118641022083047],
            [-12.210460095246853, 7.108072013623919],
            [-12.207346244359352, 7.106202748870541],
            [-12.201010854892747, 7.099261627402509],
            [-12.202362524725167, 7.097000281981603],
            [-12.1989451921724, 7.090268949307823],
            [-12.19757445923028, 7.085085777844859],
            [-12.192336273685859, 7.082312832705498],
            [-12.191027064210399, 7.077727760780283],
            [-12.184586528046848, 7.075024705191666],
            [-12.182578794101055, 7.068691447197968],
            [-12.180377028336, 7.068500981715379],
            [-12.174795961116647, 7.062980155445039],
            [-12.17136295598417, 7.055956630339853],
            [-12.16611355475572, 7.048979167543506],
            [-12.159281611384996, 7.042661573220475],
            [-12.15268892617659, 7.033571451983034],
            [-12.150137146242088, 7.024738222363026],
            [-12.150118450665222, 7.021252793670244],
            [-12.145531316250263, 7.01193463727905],
            [-12.141370626109614, 7.0074764839669434],
            [-12.138533988976294, 7.001085269382015],
            [-12.130030046824757, 6.998058800316998],
            [-12.123911671133275, 6.996953605939314],
            [-12.118773550149273, 6.997413636290596],
            [-12.113743305013614, 6.994632201027435],
            [-12.09151391431228, 6.978823247644859],
            [-12.085352707586729, 6.97709605876813],
            [-12.084326470344967, 6.975272206047076],
            [-12.074386248105224, 6.969610474335072],
            [-12.065579754609123, 6.96771714754642],
            [-12.058986375459707, 6.960706373145021],
            [-12.054728469464344, 6.959098176096316],
            [-12.049715451382259, 6.952002038872361],
            [-12.04644171071043, 6.945557188389434],
            [-12.042063581727193, 6.94369860771472],
            [-12.039714068006592, 6.9399828137500865],
            [-12.03352666744197, 6.936543560652603],
            [-12.024452341485754, 6.934128387565054],
            [-12.02086210618251, 6.931442959169369],
            [-12.01286834914005, 6.930191887127086],
            [-12.005532720086498, 6.927374101121678],
            [-11.99581267784989, 6.921173981406859],
            [-11.989143996451423, 6.922116623747329],
            [-11.98410181949733, 6.919851179431284],
            [-11.98117780641658, 6.915777993256524],
            [-11.973535271548696, 6.9117455376699],
            [-11.972449038338922, 6.906033107240305],
            [-11.967077690461522, 6.900642726232447],
            [-11.95459999105278, 6.896715640989326],
            [-11.946067111583677, 6.896412260771543],
            [-11.943562146192443, 6.894142041309752],
            [-11.936462414868172, 6.892113406190229],
            [-11.932054679061492, 6.889780313129157],
            [-11.92543495189312, 6.895184854172291],
            [-11.918299587345102, 6.899137658895018],
            [-11.916767937712562, 6.903518333933632],
            [-11.911647697217207, 6.906530503024439],
            [-11.910072114338302, 6.911913379601005],
            [-11.901507413315548, 6.915315660126059],
            [-11.890866671141493, 6.9154234147554074],
            [-11.888000984648716, 6.910977294792737],
            [-11.887708348057414, 6.904483561503463],
            [-11.884140494867317, 6.901425759179194],
            [-11.883345475599285, 6.898212724866039],
            [-11.885487597588561, 6.8908865485171455],
            [-11.884833225946107, 6.885787761302885],
            [-11.87825222945923, 6.880661724501589],
            [-11.87613944797757, 6.8747943461541725],
            [-11.875250969934937, 6.868303779747724],
            [-11.873425533536249, 6.864237827491697],
            [-11.871967015861884, 6.856526444546125],
            [-11.872540047191109, 6.852888460880135],
            [-11.870365902502352, 6.842633261655034],
            [-11.871153767858685, 6.8384715591478535],
            [-11.866097958187956, 6.831187979249754],
            [-11.86407876655905, 6.825356834045916],
            [-11.855690851728129, 6.813983463922482],
            [-11.854497729221237, 6.806326405791436],
            [-11.848322418567834, 6.798785977886169],
            [-11.846083539259741, 6.7850409622846595],
            [-11.84699805360731, 6.77996365521353],
            [-11.845213744997864, 6.775950024062043],
            [-11.839962240591511, 6.770720627742473],
            [-11.838041204358026, 6.767223959570216],
            [-11.837744235598741, 6.757006132128898],
            [-11.83965535946692, 6.753908591023388],
            [-11.839671851813987, 6.742503812280524],
            [-11.837891857657187, 6.7396354464651935],
            [-11.836540024776305, 6.72893271629846],
            [-11.83754885738184, 6.725922667982011],
            [-11.836008588204212, 6.720460464352194],
            [-11.842430513593609, 6.713529585577126],
            [-11.844443377788787, 6.709273887356146],
            [-11.845214950720852, 6.696809898256331],
            [-11.843386152760084, 6.692067085251571],
            [-11.84085010294259, 6.68966573082161],
            [-11.838625629155047, 6.6840968441183515],
            [-11.839313619916979, 6.681355684142686],
            [-11.906645266123355, 6.693916881075329],
            [-11.938284648250319, 6.523341655289662],
            [-11.967500007530335, 6.528920111623276],
            [-11.973053895815502, 6.500546425333058],
            [-11.972923977474695, 6.491337725094037],
            [-11.975092561855051, 6.475596984735117],
            [-11.973924251843714, 6.4700035520021],
            [-11.977708005947727, 6.465708315751085],
            [-11.97786222229836, 6.461178305032973],
            [-11.973145586917552, 6.452856496120605],
            [-11.975001529624677, 6.446575959678954],
            [-11.974303092887299, 6.443296377342927],
            [-11.97713450418755, 6.43457421875209],
            [-11.976840803058126, 6.425780430412048],
            [-11.97961790473355, 6.419727941929077],
            [-11.979489024855512, 6.410103699745028],
            [-11.98247493905999, 6.406532408142197],
            [-11.984227081513358, 6.388996674998455],
            [-11.985477826629939, 6.385196246612585],
            [-11.995664876597699, 6.369182092288802],
            [-12.000445911105496, 6.357080826790042],
            [-12.00021047494138, 6.348690528491306],
            [-11.99882533753703, 6.346399073429908],
            [-11.986812485842556, 6.338144516796564],
            [-11.981790618878989, 6.335290538789324],
            [-11.977544667457645, 6.329206676487217],
            [-11.970678730044913, 6.327298667944526],
            [-11.967891697991437, 6.322891712602597],
            [-11.963965321920552, 6.3128925476099536],
            [-11.96401284111682, 6.30780471613622],
            [-11.960681324714049, 6.304571485932267],
            [-11.962325797085656, 6.300475523097722],
            [-11.959810220773223, 6.298414413256903],
            [-11.959909060556908, 6.290852360993351],
            [-11.958089352471612, 6.28714218618602],
            [-11.954252186290315, 6.287000103657634],
            [-11.951108261755433, 6.284006888643178],
            [-11.952022956484695, 6.279552034144222],
            [-11.948979893891936, 6.275683313329298],
            [-11.950195708515176, 6.2694973161820835],
            [-11.949932588484034, 6.263233366818971],
            [-11.947042317610983, 6.2587959438522205],
            [-11.951857327403244, 6.25793649161971],
            [-11.949984846163282, 6.262405612640184],
            [-11.953771343101433, 6.264187223234465],
            [-11.954678007417462, 6.2708404891265435],
            [-11.956811758277563, 6.273495986003357],
            [-11.962718017356117, 6.2731090898679165],
            [-11.97127077973324, 6.27590848979296],
            [-11.972880777768292, 6.280085085359392],
            [-11.978728482229801, 6.281714804379441],
            [-11.980170380983143, 6.284911637877361],
            [-11.987785908240358, 6.284079593234541],
            [-11.991640979091102, 6.282076956874335],
            [-11.999158906593404, 6.282332434878477],
            [-12.002903813137785, 6.280977914385133],
            [-12.008368972119179, 6.265219802806459],
            [-12.008795120607827, 6.257894897860216],
            [-12.012908596339987, 6.248893975323141],
            [-12.023559319052007, 6.238520127415025],
            [-12.027324837672232, 6.237110010493366],
            [-12.033773712817373, 6.231176212828445],
            [-12.04091130865149, 6.2286374974111824],
            [-12.044943139261314, 6.224446423122985],
            [-12.045709988714771, 6.220420035694896],
            [-12.054156306940543, 6.217948680013899],
            [-12.060195577277824, 6.220148325263821],
            [-12.067220698960261, 6.217155266765861],
            [-12.071832689367723, 6.213174146479748],
            [-12.074708642696677, 6.20764858400879],
            [-12.079680010348765, 6.204016577684578],
            [-12.081622033466171, 6.206245414949598],
            [-12.087503209076385, 6.206864287205017],
            [-12.097038617067625, 6.203453787575233],
            [-12.114079484706796, 6.192075757407606],
            [-12.117466864194792, 6.19239788814077],
            [-12.127629905076418, 6.188996645028699],
            [-12.133766610377808, 6.190154340063718],
            [-12.136388584120482, 6.187613519447972],
            [-12.142107759414719, 6.18671332812802],
            [-12.145621322962088, 6.183079207782097],
            [-12.154564458085744, 6.180262472786034],
            [-12.168631085111876, 6.173550891938294],
            [-12.172282371615832, 6.174606525694524],
            [-12.18494241593855, 6.1684202105873345],
            [-12.18752498186464, 6.1691183882602045],
            [-12.198382281117388, 6.166078980968568],
            [-12.204525274802009, 6.161163594614727],
            [-12.208869915819074, 6.160297359590703],
            [-12.214113265200304, 6.154546384429049],
            [-12.217016449463713, 6.153049785515668],
            [-12.2220153197162, 6.147337544445802],
            [-12.235619966673521, 6.141679327012009],
            [-12.243373954858303, 6.141428086974301],
            [-12.250987074290503, 6.14424388054287],
            [-12.262773501774646, 6.138915464838089],
            [-12.265909049155672, 6.130130847769795],
            [-12.268880735308844, 6.129287000357296],
            [-12.272390173047514, 6.124560997104049],
            [-12.271882077371783, 6.122318689767778],
            [-12.278346970816663, 6.117761404001068],
            [-12.282516221007375, 6.113664827470127],
            [-12.285078968146504, 6.109035136178708],
            [-12.286996507921078, 6.1018014758662575],
            [-12.290192419647125, 6.1019315329271695],
            [-12.295976094315378, 6.098207319929361],
            [-12.298887039566777, 6.0928776526313655],
            [-12.304362808484075, 6.097498343668813],
            [-12.303188766167047, 6.101211376159922],
            [-12.30476967133733, 6.108760877267433],
            [-12.304611053934734, 6.116511912446467],
            [-12.302804638671972, 6.118626322517215],
            [-12.303683279480673, 6.125135262408572],
            [-12.308311606179824, 6.131479204827946],
            [-12.313816050390622, 6.131295957806161],
            [-12.318535644893403, 6.13286795830236],
            [-12.318931836281681, 6.13686361685395],
            [-12.31728289141151, 6.1398153745258535],
            [-12.320073191864205, 6.146140545697948],
            [-12.320639971518512, 6.153659984695482],
            [-12.325628133011003, 6.157329659017008],
            [-12.327441678982566, 6.16311776305982],
            [-12.330320168306098, 6.164800364223137],
            [-12.331416429036668, 6.171377929586999],
            [-12.32982659113229, 6.17476606774635],
            [-12.334238091368203, 6.1782034810880715],
            [-12.33810472980213, 6.182914410405487],
            [-12.344177211414692, 6.182039912343872],
            [-12.346564381501755, 6.184371329644471],
            [-12.351332725341939, 6.182856134483501],
            [-12.359192185494502, 6.1861099546332134],
            [-12.360171716686962, 6.195043601562442],
            [-12.35853277960107, 6.199188118069992],
            [-12.359995476273031, 6.2086297365488905],
            [-12.362281702112714, 6.211253681112669],
            [-12.36983740049757, 6.215138693872933],
            [-12.373844870214686, 6.2190238683095185],
            [-12.377232969081662, 6.2267364896908335],
            [-12.380875766640234, 6.23039636166527],
            [-12.381562275425194, 6.235324294186591],
            [-12.386014630921839, 6.243604392178685],
            [-12.38909980143592, 6.247038844193598],
            [-12.394761389714258, 6.249426697888657],
            [-12.397263028716663, 6.252401960417335],
            [-12.398237023385645, 6.264000317024085],
            [-12.402339167403447, 6.2707045180548935],
            [-12.399366365918372, 6.2790874548802025],
            [-12.399829471832616, 6.282725608165415],
            [-12.404066877508125, 6.289481937726269],
            [-12.406005561314672, 6.29527720930601],
            [-12.401912618828838, 6.302077941285625],
            [-12.405752436198824, 6.3046345707212055],
            [-12.407611308045066, 6.312474416360765],
            [-12.410108027682563, 6.3146250137045215],
            [-12.41751356197347, 6.31648516268234],
            [-12.420930755156865, 6.3223158030781565],
            [-12.424085561327958, 6.324118984638051],
            [-12.427721305846543, 6.318308829617807],
            [-12.434213831990133, 6.3177993935679435],
            [-12.44322627455801, 6.315040157680916],
            [-12.442889972849994, 6.310648296846748],
            [-12.444930942902158, 6.30773108262562],
            [-12.445717820301955, 6.30091009916107],
            [-12.448961374787679, 6.296852508562422],
            [-12.453730745609903, 6.2962284696579545],
            [-12.456015138096781, 6.293245976440767],
            [-12.459882928753975, 6.291661088981901],
            [-12.467931414209543, 6.293635210761555],
            [-12.472530329641602, 6.297766419322025],
            [-12.482126764907942, 6.297015681187175],
            [-12.485796733035235, 6.298430637947735],
            [-12.491998194269883, 6.303556745063908],
            [-12.496200352297018, 6.311280329211161],
            [-12.501132159935105, 6.315891386099594],
            [-12.503591936907913, 6.321989015081608],
            [-12.500531199506788, 6.3263730451947255],
            [-12.50060280790685, 6.333372992932316],
            [-12.503467319614106, 6.340339907927722],
            [-12.508603354156739, 6.343049404380361],
            [-12.51594536413562, 6.342901233637372],
            [-12.522592261057227, 6.349961166407102],
            [-12.522086860770436, 6.352315664194947],
            [-12.527365833792121, 6.360892813080703],
            [-12.533476663707797, 6.360796581724257],
            [-12.537990801053152, 6.362448632132987],
            [-12.543294828710868, 6.367809894906843],
            [-12.543651990695983, 6.3718226324770395],
            [-12.549058289399898, 6.374324471983701],
            [-12.553971777965522, 6.38085149329476],
            [-12.562903490336891, 6.3862415358442615],
            [-12.566535622587205, 6.389493177106162],
            [-12.57024029305948, 6.398794835429732],
            [-12.575305027082983, 6.401177239494807],
            [-12.580493698688331, 6.409700080256023],
            [-12.586689692145233, 6.4140861276586305],
            [-12.587567158792345, 6.422409814611849],
            [-12.587096703741366, 6.426640601057347],
            [-12.583012541091469, 6.434348413001322],
            [-12.58641832978076, 6.44445047472124],
            [-12.584286902334645, 6.449680660442167],
            [-12.583695030791217, 6.454865173035437],
            [-12.579712814554327, 6.461227876537763],
            [-12.583166594167354, 6.4669684338365006],
            [-12.58776970360464, 6.47113396147044],
            [-12.602433412572207, 6.472767650151092],
            [-12.604131646809092, 6.47533884728252],
            [-12.608668832552587, 6.47412510694178],
            [-12.615910017703872, 6.476487340498626],
            [-12.62190450617094, 6.480341200301554],
            [-12.6270925571565, 6.477212162912042],
            [-12.630464809647432, 6.476755338932181],
            [-12.631763667540312, 6.470902227138456],
            [-12.63732718088528, 6.467652394116685],
            [-12.644273475492607, 6.4741277535829935],
            [-12.645087865304129, 6.476526355490058],
            [-12.655924444357543, 6.481532856385511],
            [-12.657582785663156, 6.4854955915715955],
            [-12.661309632605642, 6.489780912530003],
            [-12.665659147918753, 6.4917280175177865],
            [-12.668910051438651, 6.495626329056393],
            [-12.676825974178984, 6.493196268420515],
            [-12.682023871162121, 6.493973287598923],
            [-12.691703643274325, 6.499725162341526],
            [-12.692353197680532, 6.501767069172171],
            [-12.700869265841694, 6.501659736755949],
            [-12.704474624160689, 6.503950072210675],
            [-12.714200323548726, 6.505349508789244],
            [-12.720063378299793, 6.514615777933084],
            [-12.725273781656872, 6.512902186150602],
            [-12.737108410008823, 6.512450035164908],
            [-12.743115823868228, 6.509204164327579],
            [-12.740508496239883, 6.503718688646216],
            [-12.741070413967979, 6.499034278853758],
            [-12.744193563528013, 6.497169810570014],
            [-12.75081310980357, 6.487268597506778],
            [-12.747935490914, 6.478099675730629],
            [-12.751628245824916, 6.470164741181633],
            [-12.755764403106962, 6.468710361665331],
            [-12.758003128030133, 6.465169589031984],
            [-12.762054004594305, 6.463019469787884],
            [-12.776604085870344, 6.466975077390531],
            [-12.786198236077892, 6.4664451339576665],
            [-12.79118206065035, 6.471372705536132],
            [-12.798658568860834, 6.476097616291733],
            [-12.797118218066354, 6.48105607019523],
            [-12.799247235950562, 6.485559944985759],
            [-12.796274028085726, 6.490874813951205],
            [-12.795085802889977, 6.499446965201924],
            [-12.800107150845314, 6.504168115156074],
            [-12.804401106930095, 6.515106684204538],
            [-12.806976942832344, 6.516700039243688],
            [-12.807445796571892, 6.52070916565351],
            [-12.815329915426622, 6.525930648273977],
            [-12.819988073814846, 6.527658570476275],
            [-12.824851694281392, 6.533051345929752],
            [-12.824628584554732, 6.538548930323016],
            [-12.829409991326918, 6.5429120999070625],
            [-12.830349484465712, 6.546207946004887],
            [-12.834984997197331, 6.548703393461176],
            [-12.838090152073958, 6.5476725639601865],
            [-12.839868754161254, 6.555845183244447],
            [-12.84862348108741, 6.558243690627016],
            [-12.849083508045311, 6.561516233203003],
            [-12.853581601407155, 6.564475064211121],
            [-12.946877525082309, 6.583065811057556],
            [-12.934071898084259, 6.646785632509331],
            [-12.97588348524158, 6.655137279722241],
            [-12.987001264466373, 6.653456389160083],
            [-12.990925978649763, 6.65048090214792],
            [-12.993372792154434, 6.651176958718936],
            [-13.000064230884634, 6.649151201290673],
            [-13.00228420221177, 6.646965745721988],
            [-13.013360352832654, 6.643774948087391],
            [-13.01436447549205, 6.641478275749713],
            [-13.021198788980332, 6.639577325296702],
            [-13.024091763634374, 6.636627053999982],
            [-13.027936368726971, 6.628561225806601],
            [-13.032773353878614, 6.623538351902005],
            [-13.039137373094105, 6.620994843808874],
            [-13.043557750266631, 6.622391901664323],
            [-13.05252425203571, 6.614338583416154],
            [-13.055601950675692, 6.615538876613781],
            [-13.059199534859829, 6.624921123162146],
            [-13.062894511656765, 6.624867499065227],
            [-13.066986414073094, 6.629440202875364],
            [-13.066679225801437, 6.632863614208713],
            [-13.063827987850285, 6.634229015191181],
            [-13.062274747276037, 6.638768908254673],
            [-13.054358881790698, 6.647688116165637],
            [-13.046734439852798, 6.649714921503528],
            [-13.046428558142582, 6.653540973449099],
            [-13.044072292809522, 6.657755497813138],
            [-13.049100214237024, 6.660717618210282],
            [-13.055063563261278, 6.666836201870697],
            [-13.056162582092483, 6.6705113099447],
            [-13.050816179202124, 6.678084521141567],
            [-13.051574462222218, 6.6878887213549785],
            [-13.055290782171083, 6.689431439742109],
            [-13.0575313506334, 6.693265822699564],
            [-13.058348594190868, 6.699857798734667],
            [-13.06596022660581, 6.693930853680859],
            [-13.070200488571869, 6.695548428423713],
            [-13.073837321603852, 6.698709675341183],
            [-13.076918730485273, 6.699012133804195],
            [-13.082283183939115, 6.703488253199357],
            [-13.082852227104928, 6.708273338334525],
            [-13.086606752639154, 6.709444315330043],
            [-13.08539473690143, 6.713091171389518],
            [-13.0897067100433, 6.723608520283105],
            [-13.087422991230817, 6.730256718056791],
            [-13.08684781446334, 6.7361022442054255],
            [-13.082297281381033, 6.743487755323606],
            [-13.076245599383443, 6.744002342637897],
            [-13.075993405322127, 6.750636564559762],
            [-13.072369082829024, 6.753609385122484],
            [-13.068754317939701, 6.753594701265846],
            [-13.065143010313257, 6.756470728638893],
            [-13.064208267113534, 6.759633840305815],
            [-13.055586475831177, 6.756783069176328],
            [-13.046132987560753, 6.7635493489103595],
            [-13.043230866664143, 6.7678833631804265],
            [-13.041778463044638, 6.774143779723203],
            [-13.045660423691732, 6.7745303298475505],
            [-13.049633433563033, 6.777490394963096],
            [-13.053734493881056, 6.776192119998541],
            [-13.058238744811582, 6.778870324481126],
            [-13.06120799765706, 6.78518545769681],
            [-13.062217655585208, 6.79182153203662],
            [-13.068943351468354, 6.795644733556439],
            [-13.072303460125536, 6.803650596961198],
            [-13.072007420593172, 6.806096979645107],
            [-13.066502492040012, 6.806124510163949],
            [-13.057777149991583, 6.808269734504853],
            [-13.054525912518393, 6.811163647672853],
            [-13.04730055191041, 6.820344641118854],
            [-13.048543738516717, 6.8275805097798195],
            [-13.04988183570628, 6.828924471533519],
            [-13.049413150392775, 6.835132322983631],
            [-13.053573719378395, 6.840454262645545],
            [-13.062393196247088, 6.841839738022233],
            [-13.066450146011393, 6.848521119808019],
            [-13.07338685125616, 6.847827811138415],
            [-13.076817269085117, 6.849500186055847],
            [-13.082492267696658, 6.859427846605876],
            [-13.086045153496952, 6.863545825276172],
            [-13.091541989307506, 6.860835630569621],
            [-13.097702188355864, 6.863188121515971],
            [-13.099877654114156, 6.861240222977962],
            [-13.105178610069068, 6.861213688056639],
            [-13.104912508079074, 6.86698475733526],
            [-13.108814059978272, 6.870602414472081],
            [-13.112000901211323, 6.876770485555646],
            [-13.11322161134454, 6.883163624618135],
            [-13.116520821828086, 6.886024496670249],
            [-13.126148415220603, 6.886047096992081],
            [-13.131215245745215, 6.893534639968334],
            [-13.14044704311591, 6.90168383800502],
            [-13.139871245514568, 6.9054287958077865],
            [-13.134820280137285, 6.911587416813261],
            [-13.138402296384845, 6.919546648578546],
            [-13.137280046258256, 6.924141959336704],
            [-13.138892571382959, 6.9345299831908065],
            [-13.133559555068443, 6.93644985770156],
            [-13.128056709519823, 6.936558984785939],
            [-13.12439462293372, 6.9413461063877016],
            [-13.124436764168028, 6.945567359627178],
            [-13.127459334724755, 6.949177704784738],
            [-13.129278649249523, 6.955309391641087],
            [-13.12591255404181, 6.959244360512642],
            [-13.127548787981326, 6.966881334386173],
            [-13.124727083756568, 6.971981372763625],
            [-13.125105599656205, 6.980100495941881],
            [-13.12748961844362, 6.984161389830423],
            [-13.127624188867177, 6.990695301622023],
            [-13.129509697612631, 6.994676354570247],
            [-13.137299476840319, 6.986980686991201],
            [-13.145522314027044, 6.983985073686536],
            [-13.149629536579456, 6.985289568527211],
            [-13.152182219400764, 6.990679591563793],
            [-13.15158228255628, 7.006720548876531],
            [-13.156782027712447, 7.011631875577604],
            [-13.165275894464536, 7.011666952392386],
            [-13.167634419377237, 7.014023209939993],
            [-13.170609500730492, 7.011977881464906],
            [-13.17272086580794, 7.007488363049032],
            [-13.172817781164696, 7.001031408448221],
            [-13.177628538750202, 7.004645848633926],
            [-13.177328603607553, 7.010303304103505],
            [-13.175761678981413, 7.014951403727811],
            [-13.176043311594768, 7.0189446769573305],
            [-13.185450241332527, 7.023325997008426],
            [-13.187232091236279, 7.026281891946254],
            [-13.19035548183214, 7.02605837462127],
            [-13.195503379793733, 7.035419858709521],
            [-13.199840197234336, 7.037618336731752],
            [-13.201816576310218, 7.048051101756692],
            [-13.201672138339752, 7.052991810485179],
            [-13.200571605525166, 7.056167123980772],
            [-13.193781672586969, 7.057509817061907],
            [-13.19065984684677, 7.069822777557482],
            [-13.188132958636583, 7.06757044139943],
            [-13.183140842470923, 7.068889598052459],
            [-13.171427462678663, 7.0781653051639175],
            [-13.16969343384437, 7.084171714911821],
            [-13.15828845694684, 7.093331113403728],
            [-13.157263733641631, 7.102129970510804],
            [-13.151655799943203, 7.1060920674315335],
            [-13.149085188218079, 7.113840074473714],
            [-13.145013802494685, 7.114938921027416],
            [-13.142190640142433, 7.117975118575631],
            [-13.14235113069013, 7.121816746348855],
            [-13.138353327424456, 7.125496425476429],
            [-13.13663967985785, 7.137812908994489],
            [-13.135002393594618, 7.142040823969204],
            [-13.13600711148576, 7.148741095729413],
            [-13.133395305365394, 7.153843874068313],
            [-13.13412541517201, 7.160217789989841],
            [-13.127959293941407, 7.161448887888378],
            [-13.127117470455907, 7.163760510599551],
            [-13.130209204913852, 7.167226951978778],
            [-13.13344003575929, 7.168132354802775],
            [-13.133853271448666, 7.171829616358984],
            [-13.126649880060482, 7.175819567375619],
            [-13.126201660286238, 7.185149513220043],
            [-13.124862764634242, 7.190989730293524],
            [-13.129613952455067, 7.198367916282045],
            [-13.13013412266866, 7.204241070449616],
            [-13.12837390149165, 7.206746954610263],
            [-13.127736726720974, 7.21214768239774],
            [-13.131984935544835, 7.214091035447412],
            [-13.132151107125637, 7.221919353338558],
            [-13.135950253820049, 7.223096401665813],
            [-13.138302209848229, 7.220483038249157],
            [-13.144049732059532, 7.222704387110362],
            [-13.15566125432436, 7.225545882008767],
            [-13.155750547585109, 7.230536247022388],
            [-13.15395406632299, 7.233236957536347],
            [-13.160587120852089, 7.239814629758488],
            [-13.157617263285813, 7.250462783724807],
            [-13.159673774185643, 7.25296394765542],
            [-13.159169225882065, 7.257322949162199],
            [-13.16104003081101, 7.2680288088017555],
            [-13.160385049542862, 7.288464247894747],
            [-13.156023689235091, 7.293222417107733],
            [-13.151804682064212, 7.295049781069761],
            [-13.150587640295567, 7.299540570901923],
            [-13.145157414286045, 7.305572695717942],
            [-13.14055173324755, 7.307717316429526],
            [-13.136888058750932, 7.3160221632306195],
            [-13.131881555082279, 7.314141323596456],
            [-13.128527225314416, 7.310018811708977],
            [-13.123814741640015, 7.308029113409886],
            [-13.12022018436564, 7.316456001407621],
            [-13.113946444873458, 7.318118954883687],
            [-13.109116933856406, 7.317955458437768],
            [-13.102937397410543, 7.319636443663016],
            [-13.10118814246216, 7.3164502032313745],
            [-13.097294490338314, 7.314524515747237],
            [-13.094081677417503, 7.317703875983349],
            [-13.096094082227689, 7.32235288550416],
            [-13.092292604407135, 7.32645958554141],
            [-13.087047257597757, 7.320200682246706],
            [-13.083529390567978, 7.323397415774855],
            [-13.080567109910675, 7.318845177127167],
            [-13.077577866816373, 7.316850786029259],
            [-13.075011846514974, 7.3229738422907396],
            [-13.069284078786826, 7.326909414180246],
            [-13.064592166227664, 7.327267894021501],
            [-13.062318628144364, 7.329362320439356],
            [-13.06022175095077, 7.335347040594869],
            [-13.051331413457424, 7.335302903100996],
            [-13.0491275296956, 7.3375831140031265],
            [-13.046630604687273, 7.34406993540969],
            [-13.046901542310945, 7.348473985730833],
            [-13.042588201584035, 7.350387347522956],
            [-13.041630230942692, 7.354037943103554],
            [-13.038789852798667, 7.355702159511626],
            [-13.034704495680701, 7.361966062837202],
            [-13.027497740538731, 7.384826602260837],
            [-13.018557615168175, 7.39510988580707],
            [-13.017439427491526, 7.400548720037443],
            [-13.02270043544532, 7.404302579831872],
            [-13.023920261495165, 7.411883023076553],
            [-13.014453062612152, 7.417374957364472],
            [-13.0102654456876, 7.423876231352267],
            [-12.996766766966878, 7.431095806062221],
            [-12.99482093558309, 7.433442073149621],
            [-12.986901555211098, 7.434936837004805],
            [-12.981852513920892, 7.438407283829958],
            [-12.974602313532154, 7.44057675018566],
            [-12.969705775082394, 7.444384716687632],
            [-12.962852264270804, 7.440677088444661],
            [-12.963098149918101, 7.436528463086529],
            [-12.960093223897772, 7.434368176727714],
            [-12.959750762882077, 7.430039991907996],
            [-12.946104696034283, 7.42158283550466],
            [-12.940817030775374, 7.4174683824237855],
            [-12.938780493699202, 7.409916899511698],
            [-12.939885820100066, 7.401385606352754],
            [-12.936130408914327, 7.402524755065898],
            [-12.92935413328262, 7.408499711479437],
            [-12.926284225378305, 7.4004001995824416],
            [-12.930699812405257, 7.3960211563020515],
            [-12.929277576311751, 7.378250158322605],
            [-12.92644429349222, 7.377621743388839],
            [-12.922837773708219, 7.383092936729457],
            [-12.918294485554236, 7.38499252341623],
            [-12.919263545480693, 7.389293439494823],
            [-12.915523916040089, 7.390143995412744],
            [-12.910734636388018, 7.388756252646435],
            [-12.90385884210008, 7.389109511269114],
            [-12.89965769067672, 7.386725445193066],
            [-12.898022098227603, 7.3820865481616815],
            [-12.894637717203938, 7.381253616912591],
            [-12.889368124594503, 7.377052171053255],
            [-12.879971709358534, 7.379252764496462],
            [-12.87830316832711, 7.384816583682987],
            [-12.867023588438782, 7.385628633106051],
            [-12.855503518650215, 7.3965469703516025],
            [-12.85663043464076, 7.400335224291761],
            [-12.852591203004119, 7.406757266302778],
            [-12.84855410582402, 7.40507836985556],
            [-12.840713831811112, 7.405955044280275],
            [-12.839115428472029, 7.411082319323327],
            [-12.829017218233215, 7.416096939341005],
            [-12.825337926835683, 7.419121262364064],
            [-12.8186614372036, 7.42240797680059],
            [-12.81606841722308, 7.421706242537178],
            [-12.809100486321654, 7.426264026318334],
            [-12.8056897232539, 7.422214730622847],
            [-12.802818070663603, 7.4271488058580974],
            [-12.796736028034475, 7.428062878716286],
            [-12.796182633467364, 7.430865819741934],
            [-12.788258077851827, 7.439665230544294],
            [-12.784749116676753, 7.43816827211741],
            [-12.77225453998938, 7.4422102269778865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -114.28176384612503, "lat": 44.2411564925163 },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16037"],
        "coty_name": ["Custer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Custer County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00399758"
      },
      "bbox": [
        -13.201816576310218, 6.0928776526313655, -11.836008588204212,
        7.444384716687632
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.58679381066276, 1.4492757774459772],
            [6.628982075723258, 1.4531042853987237],
            [6.673592459229571, 1.457507755337235],
            [6.708039306039128, 1.4607311092205284],
            [6.800296818380974, 1.468938375124056],
            [6.830425579431331, 1.4721893391460206],
            [6.830367437897708, 1.4590567900476006],
            [6.875718530556068, 1.46325839118182],
            [6.856220655922219, 1.4752221431838999],
            [6.892884282988741, 1.479188085432668],
            [6.902102175043374, 1.376347990407272],
            [6.912836632366518, 1.2602541368660207],
            [6.918399333378185, 1.2021753108294402],
            [6.926125376446863, 1.1177953702887153],
            [6.93049624386534, 1.071334908365404],
            [6.842082186141455, 1.063203346664383],
            [6.810473303696742, 1.0603721861196407],
            [6.811013987357214, 1.0710991729231747],
            [6.7521944050875895, 1.0647640177372084],
            [6.730880109577579, 1.0623193439893237],
            [6.646561597298176, 1.0513735111922669],
            [6.603704379843628, 1.0471428707185297],
            [6.598376892782941, 1.090980695669981],
            [6.590399152121908, 1.164389363608866],
            [6.581563909917282, 1.2525530471774646],
            [6.577157649217472, 1.2965956851511125],
            [6.570655987208237, 1.3593535070549463],
            [6.594737440659219, 1.361417997558187],
            [6.58679381066276, 1.4492757774459772]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.74561033035616,
          "lat": 39.678563964066484
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17045"],
        "coty_name": ["Edgar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edgar County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00424224"
      },
      "bbox": [
        6.570655987208237, 1.0471428707185297, 6.93049624386534,
        1.479188085432668
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.584785469971563, 0.8174227383210095],
            [4.5828713487750505, 0.8289862591827496],
            [4.5825982425311675, 0.835828389209365],
            [4.580841656972266, 0.8459742017432524],
            [4.581060214184773, 0.8527561670352689],
            [4.583614445775506, 0.8650854116022629],
            [4.58373804893489, 0.8800760691747402],
            [4.585591071835721, 0.8866332660829045],
            [4.5881734165850885, 0.8917124659218182],
            [4.596101073241915, 0.9106347410451143],
            [4.596851617398323, 0.917446845552316],
            [4.598384556368636, 0.9203082461727597],
            [4.599668857277793, 0.9277553221806313],
            [4.6023071284145, 0.9345972510058919],
            [4.6031422378158116, 0.9423897331458798],
            [4.602526831845374, 0.9461304626882481],
            [4.674755510477904, 0.9496708825853216],
            [4.815622045443835, 0.9572064448059657],
            [4.843297781514788, 0.958513802738824],
            [4.928552980668804, 0.9640431315155271],
            [4.935070681387514, 0.8769848016118795],
            [4.94175204534444, 0.7888953760341393],
            [4.942654303024816, 0.7889378277794278],
            [4.948919594673792, 0.7040104577781877],
            [4.913896689398806, 0.701873122446237],
            [4.914258716273771, 0.6981279370033484],
            [4.907385223700478, 0.6976643743320317],
            [4.910095814937732, 0.664763201304724],
            [4.895889953907668, 0.6640223404888591],
            [4.866927724649472, 0.6619219995098145],
            [4.852949805855316, 0.6604610151980013],
            [4.824211420839491, 0.6591952497010426],
            [4.82777152892414, 0.6079937747162047],
            [4.783709796084592, 0.60535264267908],
            [4.6940958534931125, 0.6008335931447845],
            [4.695203586805121, 0.5970036583968236],
            [4.694540049847831, 0.5898055812446316],
            [4.692153524177562, 0.586973131119567],
            [4.687144964785354, 0.5859060662588],
            [4.683381714665035, 0.5888259161999951],
            [4.680233441963554, 0.6004770191741051],
            [4.68173715114105, 0.6068922654125309],
            [4.6782592533585845, 0.6102181088845818],
            [4.668240027984746, 0.6125019043347881],
            [4.658788584330166, 0.6114160431519352],
            [4.655628299217489, 0.6166622117392645],
            [4.652393058068553, 0.6131108742321901],
            [4.651554793764315, 0.6073605735643809],
            [4.648750687788837, 0.6072439357097493],
            [4.648869308534896, 0.6134645058982339],
            [4.64128190717654, 0.6119237887869968],
            [4.637841490970744, 0.6101531871992117],
            [4.633462037595128, 0.6057616234587095],
            [4.633412712447807, 0.6024178627955347],
            [4.628158027893637, 0.5995469217756733],
            [4.627863181923708, 0.6062119204778728],
            [4.622262347903294, 0.6066989313254262],
            [4.623893278605859, 0.6012336290654768],
            [4.622556484991971, 0.5973158663891203],
            [4.625828678331314, 0.5958140366842388],
            [4.627366741914952, 0.5891007037585024],
            [4.623080343225749, 0.5865888596779985],
            [4.619942559283211, 0.5829637416642596],
            [4.618908698263188, 0.576150101596504],
            [4.622324835216743, 0.5705619571277116],
            [4.622896934168692, 0.5657135853691281],
            [4.618032647335271, 0.5622428794149863],
            [4.616911552622706, 0.5597036108805497],
            [4.612679560758401, 0.5586051547757486],
            [4.610999057962375, 0.5550735263028835],
            [4.612917904816316, 0.5493198261019893],
            [4.612549258674078, 0.5462905533661379],
            [4.60850233643161, 0.5378596382369965],
            [4.606962316135655, 0.5431799727560135],
            [4.601749329621593, 0.5532708276686535],
            [4.598672872700292, 0.5622757361082411],
            [4.597934116779512, 0.5738612773795858],
            [4.599153431386134, 0.5875670068807096],
            [4.601614394618207, 0.5937231088040938],
            [4.607604633406937, 0.6006674160919488],
            [4.609160966443457, 0.6086177128810429],
            [4.613316041597252, 0.6200710318089186],
            [4.611302181834446, 0.6314146901559187],
            [4.611378862540241, 0.6397852684493498],
            [4.606624856214259, 0.6565997894781578],
            [4.605572270625805, 0.6648341684978122],
            [4.599986336517818, 0.6713082488212841],
            [4.595586151357645, 0.6809318315391267],
            [4.596867640757589, 0.6909639708174087],
            [4.5970980548848885, 0.7011982535761074],
            [4.59966936584608, 0.7091388991137588],
            [4.599342332794411, 0.7143911268356383],
            [4.594246935311493, 0.7251254766529279],
            [4.591475609539293, 0.7329536238399391],
            [4.588270410769422, 0.7518070821007895],
            [4.585805960952482, 0.7590106121481233],
            [4.582950088158488, 0.7704879061569823],
            [4.580008855967055, 0.7864907690433801],
            [4.5810304030284055, 0.7972685436578985],
            [4.580229104043556, 0.8027473619204677],
            [4.582646224649589, 0.8074703185186298],
            [4.584785469971563, 0.8174227383210095]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.39052275450314, "lat": 39.35613119556634 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17061"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00424232"
      },
      "bbox": [
        4.580008855967055, 0.5378596382369965, 4.948919594673792,
        0.9640431315155271
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.172258719212667, 4.0577691354837],
            [6.233650651343308, 4.063036370704713],
            [6.281549007312277, 4.066119032861935],
            [6.348244859021664, 4.071116624212366],
            [6.462599189360064, 4.078734046600045],
            [6.465326505060163, 4.070350070693933],
            [6.465028611204786, 4.064454818240711],
            [6.467342584926983, 4.058128825403192],
            [6.467635773396789, 4.0312865022652815],
            [6.46609929476348, 4.017205499948816],
            [6.467596684404946, 4.006577389718079],
            [6.470597233141822, 3.976534009829241],
            [6.469322363859909, 3.9695552033572277],
            [6.4638369216878395, 3.9546650953778575],
            [6.46319717407711, 3.946775178737827],
            [6.4603618789269595, 3.9464534819764],
            [6.4571226128053905, 3.940106817384471],
            [6.457685183125064, 3.9219558307361564],
            [6.454952929554495, 3.9125599439546894],
            [6.457523969067907, 3.8965581968561724],
            [6.456013128952649, 3.8929988126415647],
            [6.455246815469063, 3.8855445871811316],
            [6.462516802901804, 3.854311814327771],
            [6.465259975908073, 3.846967015503926],
            [6.470662560812146, 3.836726470987182],
            [6.477755057650479, 3.817209973020655],
            [6.482077498562934, 3.808663892331763],
            [6.48728831519248, 3.7965824503742285],
            [6.492391940563756, 3.7877467593048104],
            [6.508442884018365, 3.7636498168687886],
            [6.515238050967791, 3.7551778208778135],
            [6.5236163225209935, 3.7409352930852173],
            [6.498128297819533, 3.7390267219983677],
            [6.409311102258334, 3.7320314350022628],
            [6.38452043810905, 3.7299424924908107],
            [6.37223264002689, 3.72930673114469],
            [6.290520953248128, 3.7227660022692683],
            [6.257588187174493, 3.720324229308788],
            [6.200322017168499, 3.715667544048396],
            [6.198999684769208, 3.730141286070418],
            [6.193968607847838, 3.7975917405644832],
            [6.194097461735651, 3.8031613147298144],
            [6.189651236557006, 3.85391016964611],
            [6.187238731516263, 3.8793788686069863],
            [6.185533574554134, 3.904848469964684],
            [6.1808879105775105, 3.958364197247762],
            [6.177292839990176, 4.002771687289454],
            [6.172258719212667, 4.0577691354837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.00364324748327, "lat": 42.32335655646467 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17097"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01784796"
      },
      "bbox": [
        6.172258719212667, 3.715667544048396, 6.5236163225209935,
        4.078734046600045
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.21162160641876, 2.627436348468737],
            [5.267783775129509, 2.631355674282901],
            [5.3401198760133175, 2.6361365617128283],
            [5.426552941595601, 2.641504560203876],
            [5.442115506061903, 2.6426270486102816],
            [5.439911230039791, 2.633875674064094],
            [5.440689758132505, 2.6180360806652887],
            [5.439347324415176, 2.6114762351029506],
            [5.435025091605913, 2.605227400750689],
            [5.428540620671014, 2.602044150040957],
            [5.423486761063788, 2.596816051971545],
            [5.48261150303653, 2.601017290234881],
            [5.5697430658950795, 2.6073545275815926],
            [5.605755370403626, 2.610177507097502],
            [5.655291371391732, 2.6143509512214425],
            [5.6551247101704005, 2.613374332011117],
            [5.6621479187848385, 2.522457016341554],
            [5.668243087127312, 2.4344674509829654],
            [5.583902708598736, 2.429697466421181],
            [5.478934567585628, 2.4189025236675388],
            [5.412496570757139, 2.412270021006059],
            [5.3510642149448335, 2.4073679152202567],
            [5.356346821803931, 2.412094892913985],
            [5.360460088760351, 2.4199036673163508],
            [5.362941699995284, 2.4226285960110365],
            [5.363642543268409, 2.4267476840601914],
            [5.3623625851545516, 2.4336608457507305],
            [5.366663767879593, 2.4467905226170457],
            [5.3652867891731795, 2.4547135980289183],
            [5.366010174305236, 2.460950651993357],
            [5.308728002946808, 2.456889908342844],
            [5.252439557405875, 2.453279747461292],
            [5.223268981996456, 2.4517129925297985],
            [5.217044971598141, 2.5470252236526347],
            [5.21162160641876, 2.627436348468737]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.34479291658617, "lat": 41.03313861144909 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17123"],
        "coty_name": ["Marshall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marshall County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00424260"
      },
      "bbox": [
        5.21162160641876, 2.4073679152202567, 5.668243087127312,
        2.6426270486102816
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.444850529608137, -0.3189332193825735],
            [5.4971520262873925, -0.31684805811304445],
            [5.533032893288845, -0.3159652455378084],
            [5.581637046330231, -0.3141085487290542],
            [5.617262820424997, -0.3118936441158812],
            [5.646645473201672, -0.3106611731013313],
            [5.717173013540034, -0.3051083045959978],
            [5.747727246595191, -0.30326909839350635],
            [5.762507932307804, -0.30283243407945293],
            [5.790842922424336, -0.30121367668702204],
            [5.7954891166471585, -0.3898110209661446],
            [5.811212144139703, -0.3889647497435944],
            [5.810244647674287, -0.39703814822978234],
            [5.812662425019586, -0.40454752438075037],
            [5.80958708634449, -0.40849188577942813],
            [5.8088563991346565, -0.4124406206512948],
            [5.813844601253815, -0.41306058174602084],
            [5.814985765104703, -0.41523466177192747],
            [5.8223833345550045, -0.4169663261761621],
            [5.824647839708507, -0.4193473404763558],
            [5.821864029130739, -0.4230037636077869],
            [5.82494145314021, -0.4277334303096257],
            [5.820820145155471, -0.4293100580191499],
            [5.8201375020819555, -0.4335196850873638],
            [5.822261066572263, -0.43536429233625623],
            [5.820095640964151, -0.443681583835249],
            [5.825419044702592, -0.44956970711281014],
            [5.824592178034574, -0.45434667358087943],
            [5.8185516556914525, -0.46108190123342163],
            [5.814612896511871, -0.4618925690851454],
            [5.811969478419474, -0.4744820947043576],
            [5.8075145388339715, -0.4820855737562974],
            [5.804635714863059, -0.48388003059159956],
            [5.811811662451981, -0.48976092827556994],
            [5.813985745167032, -0.49682835569446665],
            [5.810859341564659, -0.498948704798928],
            [5.811326347880552, -0.5018266719537274],
            [5.807515800379335, -0.5066731541465049],
            [5.811664898765304, -0.5148837101327502],
            [5.808783893930332, -0.5299106783036841],
            [5.80309786713, -0.5385723432377203],
            [5.802823744442309, -0.5484732101687726],
            [5.79888544203989, -0.55473139130201],
            [5.7983005313049185, -0.5593880645516989],
            [5.7961899880933965, -0.5618645986003469],
            [5.791360486901603, -0.5626780434418042],
            [5.785915007710697, -0.5651380621763598],
            [5.786578465822352, -0.5673641774033373],
            [5.764323802858221, -0.5690692895113748],
            [5.705213960775076, -0.5728475804058116],
            [5.632988784132263, -0.5764466589342863],
            [5.591537859868537, -0.5783745391188502],
            [5.547245812503212, -0.5806969656132777],
            [5.461030858019655, -0.5849595853958774],
            [5.459434098264907, -0.5519492205724983],
            [5.45463511946238, -0.4662601724266772],
            [5.4510953639764645, -0.40677759100678174],
            [5.444850529608137, -0.3189332193825735]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.3669507801903, "lat": 38.08372675223564 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17145"],
        "coty_name": ["Perry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Perry County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "01784940"
      },
      "bbox": [
        5.444850529608137, -0.5849595853958774, 5.825419044702592,
        -0.30121367668702204
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.078555642555503, 1.9771193946430075],
            [5.0917452295705194, 1.9876985082857008],
            [5.1066016795083895, 1.996214283026907],
            [5.114365912371008, 2.002870364186821],
            [5.121052632610517, 2.0074941812236715],
            [5.1270258440448195, 2.0099687340949615],
            [5.1425287372062325, 2.0177222035654374],
            [5.148934023563443, 2.0215857524760295],
            [5.154672957491242, 2.02222077226659],
            [5.17122942673, 2.0208683618025463],
            [5.199937486818253, 2.0298955545034683],
            [5.203372367588931, 2.0334138335669567],
            [5.207193018859241, 2.034847353060163],
            [5.213615331358959, 2.03164079838235],
            [5.216677086696663, 2.026854339314618],
            [5.219816406591519, 2.0258952184887287],
            [5.224081821573883, 2.0279977761873296],
            [5.2293214348189645, 2.0335279473899432],
            [5.235722469328675, 2.0421306778694057],
            [5.238102904945014, 2.0469715314148185],
            [5.238534558192481, 2.0535815929743446],
            [5.234135315360044, 2.064062621036066],
            [5.23265835406835, 2.0725332731520805],
            [5.233824055759164, 2.0776311835220196],
            [5.236735043911978, 2.0827406320020465],
            [5.244137642668382, 2.093123235379346],
            [5.254036278871972, 2.105315680585658],
            [5.256737012554009, 2.1104613158154795],
            [5.261983651641351, 2.1172985319289146],
            [5.265120644000621, 2.124010368153987],
            [5.265774777619213, 2.1299794025828445],
            [5.26153671914009, 2.134679859977837],
            [5.261154069752766, 2.1381919194997616],
            [5.262822135595455, 2.142670206308338],
            [5.269813798875436, 2.1530862240772604],
            [5.277864848132357, 2.163315776155895],
            [5.285057851680327, 2.1686211500246753],
            [5.288690363040975, 2.1726610248549716],
            [5.295587199605398, 2.1764432992020413],
            [5.302234816458262, 2.178694070209338],
            [5.305396788575482, 2.1831292214853018],
            [5.3079402728060385, 2.1939371678209487],
            [5.309387177665982, 2.204321041088685],
            [5.306542642748644, 2.211172629285777],
            [5.306238494650727, 2.2169279906369734],
            [5.302440640668553, 2.228741180327868],
            [5.375645973078405, 2.2337238941117077],
            [5.426485255665633, 2.237717317740765],
            [5.469762602692421, 2.2409236985650067],
            [5.476308256757994, 2.152995438621827],
            [5.476996941387146, 2.1530549354077175],
            [5.4812107718159435, 2.1076594581137775],
            [5.5243467376275985, 2.11124049002988],
            [5.526226929627655, 2.089365150841768],
            [5.531411382434513, 2.033807019340804],
            [5.536169603638779, 1.9801466728669743],
            [5.541137186743417, 1.9218524452220873],
            [5.543499289477541, 1.892640339478581],
            [5.549690285300738, 1.8191617609410964],
            [5.464123701322049, 1.811904091006533],
            [5.435463992902626, 1.8092737726827102],
            [5.365565703350885, 1.8025851660384349],
            [5.294312146578727, 1.796226668460921],
            [5.209962129911831, 1.7896727340740726],
            [5.20056075715051, 1.906717120762612],
            [5.175751385462173, 1.9044564674680498],
            [5.151219301165255, 1.9029420585281864],
            [5.13115545617706, 1.9008986938151267],
            [5.116791379683794, 1.8999354452808042],
            [5.088291692275356, 1.8994327738733185],
            [5.066416312338748, 1.8982404097944423],
            [5.061840839669809, 1.8975584492908635],
            [5.044264118263092, 1.8968157735007058],
            [5.051810478649292, 1.901768703830304],
            [5.057225533631098, 1.9096065925574282],
            [5.0582716497855165, 1.9197234802844625],
            [5.0618968317006505, 1.9274377007693866],
            [5.06867004924423, 1.935912268945083],
            [5.070361933358447, 1.9561675396814435],
            [5.070464135755596, 1.9632763954724537],
            [5.071743961747209, 1.9687769202621235],
            [5.078555642555503, 1.9771193946430075]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.51344302237631, "lat": 40.50750395830646 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17179"],
        "coty_name": ["Tazewell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tazewell County"],
        "coty_fp_code": "179",
        "coty_gnis_code": "01785094"
      },
      "bbox": [
        5.044264118263092, 1.7896727340740726, 5.549690285300738,
        2.2409236985650067
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.584320460487554, 1.2587495966870454],
            [7.588656347142157, 1.2589146084189957],
            [7.690147540674148, 1.2686082893047699],
            [7.729495608995857, 1.2725762923506247],
            [7.726289989916613, 1.301933022731366],
            [7.794843502306863, 1.3096298649763014],
            [7.806820045870885, 1.3115463720470897],
            [7.8320375170631396, 1.3148278503035822],
            [7.8609366326939165, 1.3183880741641938],
            [7.8899176699116405, 1.3222504826815997],
            [7.89278891135449, 1.2925192621330421],
            [7.893786358304907, 1.279433801393505],
            [7.901675271921793, 1.2048077432749953],
            [7.900689408810777, 1.2046900526332533],
            [7.905347357480846, 1.1617827080624132],
            [7.9158149941823295, 1.0586714485175055],
            [7.9187289360523225, 1.0289897123317302],
            [7.914895921694335, 1.028765820285244],
            [7.875053424007286, 1.0239096771037304],
            [7.820069925478878, 1.016956510992062],
            [7.7564033915296005, 1.0090475117342625],
            [7.647916540814474, 1.0000712700330259],
            [7.629817776938059, 0.9989092160984245],
            [7.629222295228034, 1.0051318024140468],
            [7.623225503084866, 1.0646925631482493],
            [7.621745540336308, 1.0758062312743675],
            [7.621343810844585, 1.0850841832236742],
            [7.620131140842281, 1.089220953672951],
            [7.615919318183898, 1.1288370244265458],
            [7.5752159140551445, 1.1246713335262108],
            [7.5742672644545, 1.1252149626299879],
            [7.5712897932021175, 1.150880643816401],
            [7.568688207451514, 1.1765999484351113],
            [7.575353313086595, 1.1826228423714613],
            [7.586076900113464, 1.197107241307488],
            [7.586442339457638, 1.2037794546776783],
            [7.59053832897968, 1.2087821595275205],
            [7.5932893607625935, 1.2095747620550328],
            [7.591116184414037, 1.2170826607559875],
            [7.593254394823681, 1.2194617183777072],
            [7.589091604711627, 1.2237097625150692],
            [7.587356724939184, 1.2279316491696188],
            [7.58781199056132, 1.2320672951713951],
            [7.584281633235221, 1.2362449978107213],
            [7.58757110813106, 1.245224321799535],
            [7.588461938178846, 1.2533769684381275],
            [7.585768140389566, 1.2542064471082566],
            [7.584320460487554, 1.2587495966870454]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.44621466082681, "lat": 39.48155626685236 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18109"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "00450375"
      },
      "bbox": [
        7.568688207451514, 0.9989092160984245, 7.9187289360523225,
        1.3222504826815997
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.78264483883945, 2.767877709754131],
            [6.8133995964673515, 2.774468133077119],
            [6.833255205602689, 2.776965326970323],
            [6.840136747286731, 2.781240002760846],
            [6.845069086844347, 2.7806816907584135],
            [6.861135610326867, 2.774305733431411],
            [6.8664772033851005, 2.771509863349997],
            [6.881701999656232, 2.7734713701600047],
            [6.8903449780289385, 2.7840675882409602],
            [6.902667976734512, 2.789490224931306],
            [6.915262947928165, 2.796291785779272],
            [6.926206607904652, 2.7979286575083133],
            [6.931011897880741, 2.801618576825336],
            [6.948654113694745, 2.822659585171295],
            [6.957229964402667, 2.8333422995544466],
            [6.964234125089441, 2.8374165663395154],
            [6.969027231511258, 2.787181987742416],
            [6.97782611311946, 2.6895863874367136],
            [6.984408947392191, 2.616623159669362],
            [6.987115932596945, 2.5840046071057254],
            [6.992194258859873, 2.529367904973209],
            [6.997712179277359, 2.529915981860082],
            [6.9995403219569585, 2.5147761750107476],
            [7.002726580277047, 2.4842173793848765],
            [7.012482387639321, 2.38365876148539],
            [7.015206489026043, 2.354520088662609],
            [6.929584467614713, 2.3466216182252184],
            [6.821581650204397, 2.3372665500251255],
            [6.8154469274900285, 2.407552179162864],
            [6.811260946742422, 2.454426829111442],
            [6.8071698325496355, 2.495075510121813],
            [6.807500219379835, 2.495319451244261],
            [6.80289676765583, 2.546041631182134],
            [6.796807362185515, 2.6116570071108325],
            [6.784077674808474, 2.7509519834158174],
            [6.78264483883945, 2.767877709754131]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.39756634115682,
          "lat": 40.955817735873765
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18111"],
        "coty_name": ["Newton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newton County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00450376"
      },
      "bbox": [
        6.78264483883945, 2.3372665500251255, 7.015206489026043,
        2.8374165663395154
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.972112520494292, 1.5566593517055205],
            [6.975823768501868, 1.5571066825805313],
            [7.092204585855672, 1.5680483476427518],
            [7.135494068656123, 1.5724678058295585],
            [7.177709562306359, 1.5761699236375657],
            [7.22107462166087, 1.580185389063066],
            [7.22756342507139, 1.508574180698945],
            [7.2287682186676845, 1.4940244591149938],
            [7.290956119762645, 1.4993280657629147],
            [7.293888484303324, 1.4631243160706722],
            [7.300655458651192, 1.3865444833866938],
            [7.303854000947925, 1.3457368491987132],
            [7.31320122627645, 1.2359691849140413],
            [7.2286246176134235, 1.228988078450181],
            [7.171668330170905, 1.2250710565936713],
            [7.130706496085915, 1.2220418213360515],
            [7.083930693598376, 1.2181067690583687],
            [7.03219438296988, 1.2130681439573323],
            [7.03232706494779, 1.2211229204237566],
            [7.030979095217191, 1.2248813772423979],
            [7.025321451480346, 1.232987492581197],
            [7.022158297948503, 1.2399584607370835],
            [7.022175490811185, 1.246886837966494],
            [7.018750817743904, 1.253261544635199],
            [7.01772461547845, 1.2584728757122847],
            [7.018506057246182, 1.2632524458869294],
            [7.021403935391727, 1.2666678183318338],
            [7.022431483249758, 1.2725012827120517],
            [7.019945870247829, 1.2782993489377392],
            [7.020501102273168, 1.2831941299056393],
            [7.023078059933895, 1.287795336629569],
            [7.023498280766778, 1.2946253182357434],
            [7.025065317982109, 1.2990193197212105],
            [7.02137093916841, 1.3054367912626317],
            [7.025040673515666, 1.31282142132704],
            [7.024476759258024, 1.3167825375491014],
            [7.021983888292673, 1.3191923379675905],
            [7.020565140015578, 1.324115310050934],
            [7.02290212265913, 1.3363717857728348],
            [7.023549900814542, 1.3522822322483727],
            [7.020496539434381, 1.3639753901643266],
            [7.0190826376702, 1.3728093975827613],
            [7.022838381531796, 1.384374847221954],
            [7.021263457604246, 1.3990135436037197],
            [7.015575780343441, 1.406420100888727],
            [7.0133348749322035, 1.410839344972628],
            [7.011380656601037, 1.4186310009619725],
            [7.009228404803102, 1.4393875472472872],
            [7.012761659576673, 1.4435898432013732],
            [7.018202036098486, 1.4445952478997097],
            [7.0228642147931355, 1.450258384472741],
            [7.025572753723201, 1.4592025792555043],
            [7.02643124074778, 1.4649997437522362],
            [7.029315542879333, 1.4668299055778502],
            [7.030597113212876, 1.4704206718033925],
            [7.028692620094804, 1.4729296930980813],
            [7.019388584078583, 1.4750432923188415],
            [7.012110138414598, 1.4803145438836969],
            [7.011110375044276, 1.4856201898081682],
            [7.016555545331348, 1.4895133890040042],
            [7.01783262138741, 1.4933627648986003],
            [7.016637019292927, 1.4979139725460544],
            [7.012761855972029, 1.5039607129444152],
            [7.007018319857468, 1.5107007793927005],
            [7.003349148469312, 1.5127681549092324],
            [6.997638372996531, 1.512830940907552],
            [6.987449249088092, 1.5159140557623583],
            [6.983522439892026, 1.5182497182319468],
            [6.980443134501064, 1.5228989669849082],
            [6.986099825340014, 1.5288805565462114],
            [6.984451984348031, 1.5334962485034171],
            [6.98058539178817, 1.533376888663921],
            [6.9754171902383275, 1.5298710902624935],
            [6.971074332098502, 1.5303929052254583],
            [6.965940257545783, 1.5329240713900343],
            [6.96351070516379, 1.5383709657372353],
            [6.970686071331166, 1.5476458197121383],
            [6.972112520494292, 1.5566593517055205]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.20640454396201,
          "lat": 39.773618195820795
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18121"],
        "coty_name": ["Parke"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Parke County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00450380"
      },
      "bbox": [
        6.96351070516379, 1.2130681439573323, 7.31320122627645,
        1.580185389063066
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.368471298816944, 1.5282848537604177],
            [8.424733968058755, 1.5348320187114866],
            [8.481171519213518, 1.5416818122970875],
            [8.510423677776423, 1.544823905514521],
            [8.578255443435268, 1.5524902154278526],
            [8.591822254208772, 1.554248379475868],
            [8.602170878875247, 1.467250870395939],
            [8.602036432875597, 1.4664385629335708],
            [8.611679524918161, 1.3887003824124549],
            [8.614989388618673, 1.3650573868722524],
            [8.624176505044666, 1.291746075739189],
            [8.623797955683486, 1.29170023515655],
            [8.632772429459086, 1.2193878999098757],
            [8.573056642843868, 1.2124807474520651],
            [8.509643453686179, 1.2054951614655396],
            [8.509334080739006, 1.204990551691598],
            [8.473543845518433, 1.2010363799114059],
            [8.423690824206227, 1.1951083569423255],
            [8.423551991843732, 1.1959703296345525],
            [8.394455114819793, 1.1929130051845906],
            [8.38062976675097, 1.190793320209615],
            [8.369668773312615, 1.278213738082488],
            [8.361018632492588, 1.349465639195898],
            [8.359005260331541, 1.3640112995217901],
            [8.355617288130588, 1.3945677012356381],
            [8.351213085042277, 1.4370048445506587],
            [8.350664448840318, 1.4369518863585606],
            [8.346311329213806, 1.4807062407529286],
            [8.343830417658824, 1.5025899642908391],
            [8.340828032262163, 1.5249063283660547],
            [8.368471298816944, 1.5282848537604177]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.46575900755857, "lat": 39.61995442022287 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18139"],
        "coty_name": ["Rush"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rush County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "00446854"
      },
      "bbox": [
        8.340828032262163, 1.190793320209615, 8.632772429459086,
        1.554248379475868
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.93049624386534, 1.071334908365404],
            [6.926125376446863, 1.1177953702887153],
            [6.918399333378185, 1.2021753108294402],
            [6.968537137746547, 1.2068024090874616],
            [7.03219438296988, 1.2130681439573323],
            [7.083930693598376, 1.2181067690583687],
            [7.130706496085915, 1.2220418213360515],
            [7.171668330170905, 1.2250710565936713],
            [7.178981506003157, 1.1372895492484976],
            [7.149342955302852, 1.1353164867375298],
            [7.1513538583234615, 1.1111843195994056],
            [7.154359350684724, 1.078950824274528],
            [7.1559159025475525, 1.0593063441038437],
            [7.164845772201307, 0.9604008518125496],
            [7.172566757468181, 0.8723390260479374],
            [7.087814141534214, 0.8646892474714678],
            [7.064527788476249, 0.8623514898551454],
            [7.016317681680268, 0.8583302269068874],
            [6.925548360493507, 0.8502333435186614],
            [6.894699369277579, 0.8475954067082568],
            [6.893317525554441, 0.8504521497187763],
            [6.895552027175602, 0.860625839462194],
            [6.89495019038717, 0.8635346526480923],
            [6.890737541640093, 0.8642165440439683],
            [6.888308673882129, 0.8692802387137578],
            [6.88872667755389, 0.8746617527107243],
            [6.894867908803491, 0.8821917733040053],
            [6.896540324653118, 0.8857590966159076],
            [6.895426873515124, 0.8888312587365881],
            [6.889855196571019, 0.8915105636431168],
            [6.882694065290497, 0.8885299184796963],
            [6.877686285791865, 0.8913917208021098],
            [6.8779497788751875, 0.8944256572286733],
            [6.8838377070746475, 0.8963984252196032],
            [6.888718670721905, 0.8993739176923852],
            [6.892073279687107, 0.9072235550241001],
            [6.894758933185896, 0.9110082852528025],
            [6.899541381106989, 0.9233919867920434],
            [6.902458874448759, 0.9271955951300703],
            [6.910313390813186, 0.9320419055052],
            [6.920759730242891, 0.9303646727657423],
            [6.925414489376246, 0.9324380800921577],
            [6.928317282596248, 0.9355950076361728],
            [6.92852028575343, 0.9400638758925591],
            [6.9308688140719, 0.9447392266041431],
            [6.937443750705453, 0.9452670581340941],
            [6.942097036727281, 0.9416016359029405],
            [6.939844011413122, 0.9687365061383505],
            [6.934144119679178, 1.0325965382294524],
            [6.93049624386534, 1.071334908365404]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.38996496991794, "lat": 39.4306446633837 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18167"],
        "coty_name": ["Vigo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Vigo County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "00450398"
      },
      "bbox": [
        6.877686285791865, 0.8475954067082568, 7.178981506003157,
        1.2250710565936713
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.210634402546381, 3.722642997672333],
            [4.245845580615279, 3.7242249708538155],
            [4.3191657478016, 3.7280065299219993],
            [4.336714466121852, 3.7291581065766097],
            [4.381214576720533, 3.731457745823783],
            [4.37665839248321, 3.819187503685255],
            [4.495900496629233, 3.825816160404277],
            [4.516791216159485, 3.8264843109205238],
            [4.519565640953518, 3.823523521069857],
            [4.524105739284824, 3.8148304961646287],
            [4.533541201305456, 3.8051691278196853],
            [4.540266927594551, 3.8014515633661086],
            [4.5511167757169035, 3.783614867505026],
            [4.560054357666966, 3.7757317924017104],
            [4.562662937700447, 3.7700427183306235],
            [4.559305492866876, 3.763214628735542],
            [4.560374372940356, 3.7524750954146415],
            [4.558245845139446, 3.740226520147683],
            [4.554082171609847, 3.7308100770622894],
            [4.554325481893937, 3.7248054420198917],
            [4.560004604217235, 3.713196647790304],
            [4.564209143450023, 3.7014701347987744],
            [4.578813009181691, 3.6870566339241138],
            [4.58267999127312, 3.6810844934494957],
            [4.583754259801484, 3.677047370950144],
            [4.586640331153541, 3.673608190352068],
            [4.599007172783622, 3.663606893083392],
            [4.606599342636707, 3.6597431714192163],
            [4.612905527681169, 3.6550026485382636],
            [4.626835957954199, 3.6536924350469255],
            [4.634240319777457, 3.651844536119987],
            [4.642721580649611, 3.6449014978939838],
            [4.656962389655182, 3.639642656046258],
            [4.669441531579023, 3.631603517769169],
            [4.679324020305004, 3.627823167254616],
            [4.693431644507482, 3.6256232182978527],
            [4.704975190976513, 3.6202432950929935],
            [4.719330508888637, 3.6123549671777733],
            [4.724449431920806, 3.608588941629224],
            [4.726180860405126, 3.6050990924688535],
            [4.728310928123116, 3.5951304691546877],
            [4.7317186209776425, 3.5871404480144027],
            [4.734875118879698, 3.5845399321333686],
            [4.742298190495824, 3.5822343728065773],
            [4.754445337622589, 3.582751231583724],
            [4.760905912827538, 3.5746089581539127],
            [4.7628219378730305, 3.5643089206417615],
            [4.7630294168519915, 3.5568098270582826],
            [4.762329628800387, 3.5453891145805585],
            [4.759417123330261, 3.533293645370513],
            [4.762291117936551, 3.520236566880682],
            [4.764347251333402, 3.4996845449114784],
            [4.772461099177268, 3.491086640830898],
            [4.725068084866599, 3.488316376480662],
            [4.653522674001167, 3.484381304693482],
            [4.58689716639839, 3.480191364239353],
            [4.560428408954523, 3.478807807632261],
            [4.482078520656635, 3.4736037446753008],
            [4.4247456855948455, 3.4702657849056604],
            [4.338801628892472, 3.4656294524417217],
            [4.317425693888592, 3.464239971508882],
            [4.281655400880515, 3.4625621091910928],
            [4.274401358789123, 3.462521895986637],
            [4.224512147054277, 3.4600308776735478],
            [4.219917404838117, 3.5474035445035383],
            [4.218819555362448, 3.5619334409994705],
            [4.217022974965533, 3.5994162210310305],
            [4.210634402546381, 3.722642997672333]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.57421537803599, "lat": 42.17171972229529 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19097"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00465237"
      },
      "bbox": [
        4.210634402546381, 3.4600308776735478, 4.772461099177268,
        3.8264843109205238
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.8543024680362348, 3.227737017223491],
            [2.911557921150229, 3.2296146330845272],
            [3.026398337917967, 3.2336224727658145],
            [3.1058533077068162, 3.236875357392313],
            [3.1497975777952947, 3.2385379195307933],
            [3.1999447329749744, 3.240742792571311],
            [3.202005481325706, 3.1755716967722303],
            [3.2036478741488894, 3.113402129205048],
            [3.205435804818999, 3.066064039645267],
            [3.2092064232987285, 2.978092947010467],
            [3.2104529937753203, 2.9781404449503555],
            [3.2142909181663324, 2.885888949968249],
            [3.1292796506680403, 2.8823872528121366],
            [3.0152199263932657, 2.8777418528130148],
            [2.9567701476488493, 2.8756889607273006],
            [2.873470488523108, 2.872442041064077],
            [2.8698707350317827, 2.9655831016906116],
            [2.862685083499931, 2.9652821378457763],
            [2.858991163032205, 3.0817884182084843],
            [2.8567442304635784, 3.1555072026268176],
            [2.855008248228818, 3.2065798310841935],
            [2.8541673505576397, 3.2210887642982233],
            [2.8543024680362348, 3.227737017223491]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.53145568713504,
          "lat": 41.686437478564734
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19157"],
        "coty_name": ["Poweshiek"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Poweshiek County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "00465267"
      },
      "bbox": [
        2.8541673505576397, 2.872442041064077, 3.2142909181663324,
        3.240742792571311
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.277687960306576, 0.93100031982101],
            [9.280565664229307, 0.9329366935771595],
            [9.286204136224667, 0.9395397612594417],
            [9.289769612527435, 0.9484140399656598],
            [9.294225004428014, 0.9550580000034141],
            [9.30158504765758, 0.9607342820598131],
            [9.308031972270197, 0.9618254634461479],
            [9.313313771745172, 0.961046187233407],
            [9.321740046022406, 0.9560759889327097],
            [9.32583699623082, 0.9516950656921198],
            [9.330635225930823, 0.9447558532560203],
            [9.333675752150405, 0.9369916397386289],
            [9.33320918168909, 0.9294087437143995],
            [9.334861922530129, 0.9266615178955546],
            [9.336057549194363, 0.9156205711950293],
            [9.340378443290772, 0.9011997997796625],
            [9.34225495250292, 0.8980731513959002],
            [9.347669784587113, 0.8946432445331512],
            [9.359408076358424, 0.8907150975600018],
            [9.363903892317456, 0.891978244555488],
            [9.374816877861232, 0.892096866668112],
            [9.395442462935572, 0.8907672479289704],
            [9.40698023556442, 0.8877136408391852],
            [9.414893341653425, 0.8845187494717685],
            [9.423044358612387, 0.8800316428767818],
            [9.428752333684052, 0.8752618117267622],
            [9.434161789436772, 0.8707423754735684],
            [9.442325995731546, 0.861044372501606],
            [9.447699873988908, 0.851058656419766],
            [9.45123656426287, 0.8406331258712737],
            [9.454408435234544, 0.8237211536631365],
            [9.461242738937509, 0.8118453044197618],
            [9.468866060963082, 0.8019851346167354],
            [9.473147247328495, 0.7987955556567139],
            [9.489108841557764, 0.7821560606707632],
            [9.499811990671496, 0.7670322071159245],
            [9.510094891778095, 0.7542620803313452],
            [9.512818836859799, 0.7455452659375218],
            [9.514331867469242, 0.7360733258975569],
            [9.403050196221228, 0.6587284170884049],
            [9.400387042030188, 0.6592620372928993],
            [9.396027607523523, 0.6565441127978332],
            [9.39013149591937, 0.6511184583629445],
            [9.380168119469646, 0.6501214667633637],
            [9.377911019985898, 0.6514542879481177],
            [9.380066154256385, 0.6555183752496119],
            [9.37541419969749, 0.6671478150108018],
            [9.36818234318901, 0.6709621413286051],
            [9.36242776157938, 0.6663301936674618],
            [9.360290180782064, 0.65910450606998],
            [9.356381282940744, 0.658113292312037],
            [9.352954763811857, 0.6607533800907598],
            [9.350621205295756, 0.6682973554821039],
            [9.35014979825634, 0.6761174730532468],
            [9.348662657804624, 0.6798508413989102],
            [9.34161552716806, 0.6866538391300085],
            [9.339967955346742, 0.6914265274711374],
            [9.347586832602437, 0.6988444257377052],
            [9.349531643249854, 0.7019796686818727],
            [9.346411381965664, 0.7066893374577358],
            [9.350617475336723, 0.7217060486619866],
            [9.351042277435928, 0.730407491044017],
            [9.352614460345064, 0.7389501238635094],
            [9.352244633594637, 0.7466502260423287],
            [9.34702984269791, 0.7529862354388475],
            [9.347077847543368, 0.7572313666951273],
            [9.342856601970901, 0.7616699861871349],
            [9.339359640672805, 0.7695891646627292],
            [9.331866502218313, 0.7787344911509065],
            [9.32839257703222, 0.7860647796243425],
            [9.331384399025128, 0.7897118076475796],
            [9.340163512344851, 0.7915880539838305],
            [9.342925672428187, 0.7968542392551691],
            [9.343204384584718, 0.8015190443526847],
            [9.345591087755706, 0.8080606853299831],
            [9.350788488481866, 0.8159409149109574],
            [9.35182136945361, 0.8238805096792934],
            [9.345615403126358, 0.8275711340652527],
            [9.341387138582611, 0.8262233048032173],
            [9.337544857009448, 0.8218615431946492],
            [9.334954205334595, 0.8165015531297496],
            [9.333904609955807, 0.8083010232452366],
            [9.329234522195264, 0.8052809664309043],
            [9.325662365460843, 0.8071538944052604],
            [9.322965013348405, 0.8117464033921508],
            [9.323188612025895, 0.8195478919147587],
            [9.32519393052019, 0.8237284096062923],
            [9.330945220789499, 0.8318383828973751],
            [9.332087557446533, 0.8372868197374796],
            [9.328733714557393, 0.8406271907401512],
            [9.320955174854868, 0.8437187576153949],
            [9.313741031970865, 0.8432806468979058],
            [9.306735524866943, 0.8510605572637172],
            [9.303311416188246, 0.8530834086038629],
            [9.299576264418906, 0.8585486471007008],
            [9.297769431933538, 0.8680185179176282],
            [9.30020456488842, 0.8787581782631014],
            [9.29739385895669, 0.8833920874878092],
            [9.293119704195574, 0.8864090120114867],
            [9.289322775061228, 0.8918119609983186],
            [9.288510284929217, 0.8951412846347905],
            [9.290484613756945, 0.9076894800901788],
            [9.280120541094265, 0.9219090465330265],
            [9.28022599351302, 0.9276796490248165],
            [9.277687960306576, 0.93100031982101]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.37951013858067,
          "lat": 38.946534419377315
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21037"],
        "coty_name": ["Campbell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Campbell County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00516865"
      },
      "bbox": [
        9.277687960306576, 0.6501214667633637, 9.514331867469242,
        0.9618254634461479
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.199819621948292, -0.9782210320764322],
            [8.275823186860341, -1.0655501638870966],
            [8.29745706903208, -1.0901999192031078],
            [8.296792981689025, -1.1390729661641184],
            [8.294794473653823, -1.254919436324441],
            [8.263127127607582, -1.2503276122045452],
            [8.199610849089447, -1.2410733192596952],
            [8.176056854861123, -1.2157692240224334],
            [8.167905345898149, -1.2190420574291168],
            [8.162179779129067, -1.2234674739781228],
            [8.158554111506927, -1.2247026403630885],
            [8.156498158947253, -1.2292659855235128],
            [8.148194895687592, -1.2373500836592153],
            [8.139576923993472, -1.2416395938733906],
            [8.128859814679965, -1.2444060695989496],
            [8.027474875030109, -1.1641280814921375],
            [8.012265376482889, -1.1333853687767599],
            [7.957258966605862, -1.0177910536358115],
            [8.060427198357942, -1.0023490081868136],
            [8.072987591902038, -1.0003430796254373],
            [8.159685456777162, -0.9851403738550393],
            [8.167803750716935, -0.9890266893066223],
            [8.172852075628983, -0.9888787182846052],
            [8.173944259346861, -0.9860474000349595],
            [8.172193595220785, -0.9827958653815879],
            [8.173310995625467, -0.9768772608802218],
            [8.176810421277098, -0.9788696547476597],
            [8.181922530782868, -0.9783804465566037],
            [8.184946006667339, -0.9826874029512958],
            [8.189769250769164, -0.9828823466459184],
            [8.199819621948292, -0.9782210320764322]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.23842186193718, "lat": 37.20877095078088 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21061"],
        "coty_name": ["Edmonson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Edmonson County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00516877"
      },
      "bbox": [
        7.957258966605862, -1.254919436324441, 8.29745706903208,
        -0.9768772608802218
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.9346715982736, -0.5665348713411729],
            [9.96310800079693, -0.49534442939252127],
            [9.960718505134873, -0.4958427068335501],
            [9.955951386477235, -0.49057949211155916],
            [9.960595287465871, -0.4833495226087142],
            [9.971621880941385, -0.47210383761075825],
            [9.979568713837882, -0.4656844205769119],
            [9.99210185773251, -0.467284318312528],
            [9.998526403242666, -0.4634697722505325],
            [9.998996099476411, -0.4577635560359113],
            [9.996816276420255, -0.4554708403353555],
            [9.992526475459332, -0.4554161475621533],
            [9.983697249510467, -0.4407748840738035],
            [9.982633759852849, -0.4380906382807645],
            [9.98553104917254, -0.43353691196742666],
            [9.992829008225813, -0.432106417220754],
            [9.997864846363633, -0.42588646893374693],
            [9.997694347464337, -0.42135015542532994],
            [10.006098480986527, -0.41585237763032046],
            [10.008133115289844, -0.410890615897832],
            [10.013087267132628, -0.40887680738177873],
            [10.016416878109315, -0.39890471036840763],
            [10.020017922077757, -0.39897648953503295],
            [10.019963018701855, -0.3953648650168078],
            [10.027072843080845, -0.3921861419383147],
            [10.027032648669383, -0.38842288499361044],
            [10.033812318268978, -0.3786624750310994],
            [10.041160843067376, -0.3752078131710732],
            [10.046442314046631, -0.3743321250243929],
            [10.05497119289164, -0.37431425079819886],
            [10.062170308207884, -0.3695957365485825],
            [10.065938961998592, -0.3728448950868645],
            [10.072684486937332, -0.3745629868222285],
            [10.077106733759893, -0.37735899595730293],
            [10.083046285216811, -0.37749277565194195],
            [10.08663980365884, -0.3815693720811305],
            [10.132746837196168, -0.40239051242084206],
            [10.143376261238204, -0.41318374013833387],
            [10.220452257317612, -0.431979734084017],
            [10.201165332644555, -0.5256249902570282],
            [10.193636826580304, -0.5702252697041433],
            [10.192451599019366, -0.5730839485225279],
            [10.185566033419237, -0.5714372952832161],
            [10.178153454288301, -0.5662907049711813],
            [10.17016144249602, -0.5646127820959745],
            [10.1688824786532, -0.5690454969215609],
            [10.166273934433248, -0.5711095100061782],
            [10.159398167733299, -0.5701079800515455],
            [10.159767906107335, -0.5629696186948552],
            [10.161359347636852, -0.5610828554375031],
            [10.154240825169003, -0.5586911338529368],
            [10.150161384568458, -0.5503754864038286],
            [10.149645771746085, -0.5442095301057395],
            [10.14173347019576, -0.5432649799370879],
            [10.140049933918004, -0.5416123712390161],
            [10.133119148735162, -0.5442474233620218],
            [10.128913994554829, -0.547611407608054],
            [10.124196066570281, -0.5566845496977167],
            [10.123279089622766, -0.5611585442010885],
            [10.11401785966626, -0.5748059842205544],
            [10.097997818344991, -0.581249486438592],
            [10.072312640463377, -0.5709591966065254],
            [10.068159996594904, -0.574871380823627],
            [10.064230691796498, -0.585426587179636],
            [10.067599750746794, -0.5988952838088283],
            [10.005363163716687, -0.6140729179795618],
            [10.000573624967743, -0.6149879851172593],
            [9.996211838829224, -0.6103318034140143],
            [9.991024692272779, -0.6110235894969173],
            [9.987577192341298, -0.6081480678546841],
            [9.982637624023615, -0.6084653895516905],
            [9.977848433594838, -0.6036881419559704],
            [9.972605558054036, -0.6036264053486158],
            [9.969716745518799, -0.6004972471203145],
            [9.968766264246028, -0.5919944956918242],
            [9.961590234962308, -0.5901777494025628],
            [9.956747546922978, -0.5911957292596061],
            [9.953719006597886, -0.5897168764142829],
            [9.946471347741374, -0.5815902527592827],
            [9.945566962697702, -0.5770884329665187],
            [9.939708665942815, -0.5730783206370842],
            [9.9346715982736, -0.5665348713411729]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.71614213787453, "lat": 37.59478915112338 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21129"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00516911"
      },
      "bbox": [
        9.9346715982736, -0.6149879851172593, 10.220452257317612,
        -0.3695957365485825
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.953719006597886, -0.5897168764142829],
            [9.956747546922978, -0.5911957292596061],
            [9.961590234962308, -0.5901777494025628],
            [9.968766264246028, -0.5919944956918242],
            [9.969716745518799, -0.6004972471203145],
            [9.972605558054036, -0.6036264053486158],
            [9.977848433594838, -0.6036881419559704],
            [9.982637624023615, -0.6084653895516905],
            [9.987577192341298, -0.6081480678546841],
            [9.991024692272779, -0.6110235894969173],
            [9.996211838829224, -0.6103318034140143],
            [10.000573624967743, -0.6149879851172593],
            [10.005363163716687, -0.6140729179795618],
            [10.067599750746794, -0.5988952838088283],
            [10.064230691796498, -0.585426587179636],
            [10.068159996594904, -0.574871380823627],
            [10.072312640463377, -0.5709591966065254],
            [10.097997818344991, -0.581249486438592],
            [10.11401785966626, -0.5748059842205544],
            [10.123279089622766, -0.5611585442010885],
            [10.124196066570281, -0.5566845496977167],
            [10.128913994554829, -0.547611407608054],
            [10.133119148735162, -0.5442474233620218],
            [10.140049933918004, -0.5416123712390161],
            [10.14173347019576, -0.5432649799370879],
            [10.149645771746085, -0.5442095301057395],
            [10.150161384568458, -0.5503754864038286],
            [10.154240825169003, -0.5586911338529368],
            [10.161359347636852, -0.5610828554375031],
            [10.159767906107335, -0.5629696186948552],
            [10.159398167733299, -0.5701079800515455],
            [10.166273934433248, -0.5711095100061782],
            [10.1688824786532, -0.5690454969215609],
            [10.17016144249602, -0.5646127820959745],
            [10.178153454288301, -0.5662907049711813],
            [10.185566033419237, -0.5714372952832161],
            [10.192451599019366, -0.5730839485225279],
            [10.193636826580304, -0.5702252697041433],
            [10.196452186063826, -0.5755360433890605],
            [10.19415953376921, -0.580158593174342],
            [10.203225907284486, -0.5881518940519166],
            [10.205191317165367, -0.5984413686554665],
            [10.20972487844957, -0.6042499164554535],
            [10.213263100124644, -0.6040225740840017],
            [10.21827272354685, -0.6069072081543747],
            [10.220032813674258, -0.6155329210808032],
            [10.223974296177099, -0.6241085581224469],
            [10.224572816383429, -0.6278988261195583],
            [10.221757074913361, -0.635632091024871],
            [10.224758511965778, -0.6373021903517111],
            [10.224085673773732, -0.6407802168018647],
            [10.232225901795626, -0.6472778140929001],
            [10.231561690369716, -0.6507181191511605],
            [10.235239106679284, -0.6548734680938901],
            [10.240344255687434, -0.654554667854083],
            [10.239625254147812, -0.6594607377018469],
            [10.23642079897574, -0.6613203408705414],
            [10.237060014602708, -0.6740156354638152],
            [10.235041575996355, -0.6736207200895744],
            [10.231778892920039, -0.6793801682051862],
            [10.237016788911333, -0.6882979191682593],
            [10.23543396341397, -0.6939633089791359],
            [10.234995750354054, -0.7016430023557505],
            [10.239493803550292, -0.7045353412734032],
            [10.239118287662713, -0.7112627058703443],
            [10.241465303199318, -0.7118781000341469],
            [10.243889465260704, -0.7165763568817373],
            [10.247257880556633, -0.7189379870740148],
            [10.246472513172714, -0.724030888596725],
            [10.243870296449346, -0.7268915417249376],
            [10.244011207852498, -0.7361345460580704],
            [10.240884708180056, -0.7390050400424346],
            [10.238016511027327, -0.7407934012351133],
            [10.238588456009174, -0.7467144616945726],
            [10.242679365072151, -0.7494527650004215],
            [10.241963899609221, -0.7538610245780965],
            [10.244903554795934, -0.7567030586405812],
            [10.240084840644048, -0.7634585224354313],
            [10.24501640852181, -0.7709540497852572],
            [10.243850875491495, -0.7751638979852375],
            [10.245860886851139, -0.7771752070811214],
            [10.243580869106177, -0.7813230835172741],
            [10.243870240439575, -0.7866804121349181],
            [10.248495000837, -0.7895102442903246],
            [10.253585720434707, -0.7863838683825191],
            [10.255655471922095, -0.7912182767752358],
            [10.268340687093552, -0.7993315248335461],
            [10.267913031315025, -0.8028475679992296],
            [10.270555077543236, -0.8062455320880457],
            [10.264871580928645, -0.8100153514106792],
            [10.267088395612253, -0.8128360900942806],
            [10.262754561611997, -0.815541503598827],
            [10.254512276657584, -0.8050624485920266],
            [10.250022673277986, -0.807524934674496],
            [10.245053665681718, -0.807840365490079],
            [10.238659205316948, -0.8065782449033275],
            [10.234172684914942, -0.8079975204614838],
            [10.234687331983203, -0.7999417765902194],
            [10.229821995709433, -0.7991244669196612],
            [10.22594078556063, -0.7949401525917859],
            [10.226269049899184, -0.7877664615622076],
            [10.22062674603444, -0.785256481416819],
            [10.218624316959685, -0.7824329681785931],
            [10.213639842344666, -0.7866080736158708],
            [10.21150459554042, -0.7845197708861861],
            [10.207662613575136, -0.786311225929272],
            [10.205859417754324, -0.7831792124206242],
            [10.197063516542126, -0.7785131338459982],
            [10.196503617442172, -0.7712017053176625],
            [10.193385120900372, -0.7735442655563382],
            [10.190501269794556, -0.7725983649735946],
            [10.188552406820826, -0.7659281841285276],
            [10.185098081997653, -0.7663307490411309],
            [10.184213463691648, -0.7566301475761202],
            [10.180892119869883, -0.7526527521778313],
            [10.177775203771963, -0.7541595214781215],
            [10.174927988205624, -0.751616747598329],
            [10.175167776217469, -0.7472657608467225],
            [10.16860678474942, -0.7385663910918646],
            [10.162336592402218, -0.736951479645505],
            [10.155917415448975, -0.7320298641456137],
            [10.155079716358276, -0.7261406372163033],
            [10.144079516225018, -0.7305021878585011],
            [10.140407551380406, -0.7388257392764409],
            [10.1408052694811, -0.7460451272048868],
            [10.13832259975433, -0.7497615758674783],
            [10.130717459696285, -0.7510366682551654],
            [10.107312630869632, -0.7520034199565071],
            [10.053715234320808, -0.7488690671356422],
            [10.047811119354922, -0.7471496982669039],
            [10.043590579619242, -0.743927778178908],
            [10.038649774021264, -0.7384305823230167],
            [10.03892627533144, -0.7351493025264317],
            [10.034761891708742, -0.7352457623153912],
            [10.02985074478231, -0.7299509546790703],
            [10.03049216629572, -0.7264455377451654],
            [10.026603180075979, -0.7196077531055072],
            [10.023668402564576, -0.7186421808434565],
            [10.011294682030744, -0.6901231347509146],
            [10.001017923799477, -0.6784900760634915],
            [9.998827089103182, -0.6718146030405912],
            [9.99993290696398, -0.6695141204489375],
            [9.990212202456807, -0.6561317910971689],
            [9.987082174993905, -0.6568923687740157],
            [9.981998378191271, -0.6544699519391226],
            [9.977935754980905, -0.6541150569196486],
            [9.959919342748211, -0.6300016335483408],
            [9.959686377795515, -0.611585333755979],
            [9.953822633499426, -0.6055549113282923],
            [9.952816389219798, -0.6008544504447016],
            [9.954825972290658, -0.5938740515268959],
            [9.953719006597886, -0.5897168764142829]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.68332405050363, "lat": 37.41915794798021 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21189"],
        "coty_name": ["Owsley"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Owsley County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "00516941"
      },
      "bbox": [
        9.952816389219798, -0.815541503598827, 10.270555077543236,
        -0.5416123712390161
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.885548705120792, -0.715360582504486],
            [10.890557961485857, -0.7049366647739254],
            [10.895116342154125, -0.7050695896091403],
            [10.900685194102, -0.6991400430057084],
            [10.908196694516617, -0.6927905476359931],
            [10.908158316909416, -0.6874631346086074],
            [10.906565646004523, -0.683747486575367],
            [10.911256057474231, -0.676339571902011],
            [10.913796785416435, -0.6764291360068008],
            [10.918431682521954, -0.6730296735938129],
            [10.921279377063938, -0.675137505545926],
            [10.927632309696962, -0.6734008823777158],
            [10.926841488774672, -0.6673422467027852],
            [10.92756539938805, -0.6586663133037344],
            [10.93078133300285, -0.6557679684965612],
            [10.92987671765634, -0.6522461200655814],
            [10.932217852876986, -0.6418191027726426],
            [10.929704387196745, -0.636725692077885],
            [10.932938799825903, -0.6335165008342192],
            [10.937231947878363, -0.626544484825306],
            [10.932113207050637, -0.6205967168747893],
            [10.926736979633166, -0.6186508389553326],
            [10.92595040435919, -0.6123732481046962],
            [10.92355117453735, -0.6095457800719325],
            [10.925372292477018, -0.6062436351382128],
            [10.92936713941871, -0.6035500353143269],
            [10.931874058144945, -0.5978889188662125],
            [10.936040929394547, -0.597916788902358],
            [10.943637484115914, -0.5950647299053282],
            [10.94806223247919, -0.5966106105686965],
            [10.951339074713504, -0.5946964840378108],
            [10.957909647840717, -0.5859773437672349],
            [10.95482568715833, -0.5813693123415972],
            [10.957421931011027, -0.5748447295773841],
            [10.960886591331894, -0.5740170346790212],
            [10.959845212935745, -0.5652554101984717],
            [10.965810053487232, -0.5625094473441896],
            [10.965929629198476, -0.556885339602392],
            [10.963172618620826, -0.5538589550464303],
            [10.964018444700272, -0.5477942419683014],
            [10.96706673676733, -0.5430181001299978],
            [10.966595518287706, -0.5389708471199671],
            [10.964095199781005, -0.535483856026783],
            [10.9661515267456, -0.5324914204085116],
            [10.970966570438229, -0.5316854463497708],
            [10.971242390732, -0.5271577890206676],
            [10.973172463150606, -0.524454296628704],
            [10.970183580734307, -0.5140955704426372],
            [10.972233687806375, -0.5113178775739637],
            [10.971148999677427, -0.5074607290412746],
            [10.973361044841818, -0.503511554732854],
            [10.970514717227077, -0.49782716288255613],
            [10.968186701522646, -0.496934998651737],
            [10.96690425116611, -0.48948222599194163],
            [10.962186778266556, -0.4809496509752535],
            [10.957162336768096, -0.47797497056500066],
            [10.959800975133353, -0.47372079067203754],
            [10.958003472042195, -0.46931506577661636],
            [10.951750612258293, -0.466573658488538],
            [10.947122741868426, -0.4700112440036837],
            [10.943160700765501, -0.46883409228902695],
            [10.937758478592956, -0.4708581435805225],
            [10.936627779579016, -0.46451270856572835],
            [10.937035612911718, -0.45784424306667393],
            [10.93466914766253, -0.4540980577955186],
            [10.936653235953028, -0.44673200542501007],
            [10.937381607550604, -0.36325233527336204],
            [10.937826537180337, -0.3299257787967906],
            [10.930739761605247, -0.3234554423650209],
            [10.93282907641788, -0.3196454106779163],
            [10.932420768590317, -0.3131075486269443],
            [10.92377601355702, -0.3128069745401672],
            [10.923828206770994, -0.30811618132837065],
            [10.921220206575885, -0.3036261225608742],
            [10.924413337737056, -0.2991957159818059],
            [10.93141851597658, -0.2988372896282566],
            [10.932935730417366, -0.29339686859157116],
            [10.938674807916508, -0.2903748283071716],
            [10.944244895503676, -0.29330731031345586],
            [10.945143945646388, -0.29029206293821974],
            [10.954002003728606, -0.28854811125917806],
            [10.95782669241674, -0.2868146717990929],
            [10.958714905876738, -0.28348859369317214],
            [10.963443572897908, -0.27600395150340723],
            [10.967126680729635, -0.2766493324713724],
            [10.9790991385275, -0.2747185018937171],
            [10.98368420771262, -0.27712864671757764],
            [10.986654034372886, -0.2740262590698799],
            [10.987092299967744, -0.27037520635425066],
            [10.990725919669385, -0.26927506277145713],
            [10.992306108561293, -0.27235337175183116],
            [10.995471209915785, -0.2714249711280513],
            [11.000364042462955, -0.2759455857050268],
            [11.00851053149264, -0.271265803463274],
            [11.012924160369824, -0.27220333954186254],
            [11.010825964987818, -0.27654508981175036],
            [11.013001146654394, -0.28019492295565857],
            [11.016501961309748, -0.28180355986171773],
            [11.018589102424338, -0.27959726437017807],
            [11.026926064887656, -0.2755624207412577],
            [11.031902737558557, -0.2760203981054961],
            [11.034727847369973, -0.27422703185903624],
            [11.043079844309013, -0.28039664132585906],
            [11.041590499311589, -0.28420017887165966],
            [11.04462187398297, -0.2876948922499089],
            [11.052402777803135, -0.28390936078687584],
            [11.056712786431362, -0.27837925851207285],
            [11.0591606952507, -0.27990264079332566],
            [11.06274868229147, -0.2755347832435564],
            [11.06869380716036, -0.2768621554253915],
            [11.07210496455518, -0.271352065113497],
            [11.075805438297953, -0.2736210471845728],
            [11.078871955149351, -0.27196352994604095],
            [11.083187253025745, -0.27951106583728663],
            [11.087222656148267, -0.2764037010163847],
            [11.086139210349915, -0.2730114269498043],
            [11.088603292557657, -0.26406495950537007],
            [11.09477433708777, -0.25581215539745045],
            [11.094282892736807, -0.2509664135999924],
            [11.08897123860868, -0.24803081421650897],
            [11.081666965363938, -0.24245288489995248],
            [11.079182115936186, -0.24473192218904657],
            [11.07281189837918, -0.2420273592705945],
            [11.07149371615588, -0.2394900551984288],
            [11.076734140487204, -0.23258768071311284],
            [11.083418860614579, -0.22624182547661506],
            [11.083360783501957, -0.22279155704453962],
            [11.08673365072526, -0.21958739108733377],
            [11.089671962069533, -0.22029617394079418],
            [11.090569301433613, -0.2151664397292737],
            [11.098182231892276, -0.21070917216580812],
            [11.09633816330516, -0.20783900921508908],
            [11.118667014919408, -0.20315877513048167],
            [11.120090624553283, -0.19889397343013324],
            [11.129418478854099, -0.20171598258109874],
            [11.134908871608852, -0.20573900282010466],
            [11.14198573853033, -0.2079827505014529],
            [11.145285205568102, -0.21925093803116846],
            [11.149171168311039, -0.22151390802648135],
            [11.150768061521232, -0.2268647962645641],
            [11.154243638036668, -0.23210641187399958],
            [11.159335975686222, -0.23293275766542762],
            [11.163226918444385, -0.23617605246867354],
            [11.15999047417719, -0.24295187967002757],
            [11.161137359257014, -0.24834451063855156],
            [11.165981791277616, -0.2523361084926233],
            [11.161100569068767, -0.26098529224605393],
            [11.16271828129557, -0.2636463865583425],
            [11.168512790124684, -0.26035321190928296],
            [11.16960168259837, -0.2678572594110479],
            [11.174748233766021, -0.269376070120121],
            [11.176429396817317, -0.26193791683771933],
            [11.178203449011402, -0.26111989146148273],
            [11.187924431223696, -0.2719964953054909],
            [11.200514105503478, -0.2773410875239569],
            [11.204541783443213, -0.276654498957527],
            [11.212768809680844, -0.2706389686672653],
            [11.218382434827971, -0.27523302305370445],
            [11.225096888436314, -0.2774893749092981],
            [11.228358212075088, -0.28595194480221753],
            [11.233960478715701, -0.28792506842792515],
            [11.232480936236833, -0.29598476300766857],
            [11.238993100369836, -0.3039039970140301],
            [11.244899221461438, -0.3031991766474443],
            [11.248103070755485, -0.2998427136872785],
            [11.255272271045552, -0.301130183591956],
            [11.259817473404505, -0.29759932180721627],
            [11.256663643506824, -0.2867521042784561],
            [11.253531989402257, -0.28260052093138116],
            [11.257244731404047, -0.27703498768081003],
            [11.26331665524371, -0.27612244967830096],
            [11.265950407824466, -0.27821360347889357],
            [11.26459796997099, -0.28331763398570925],
            [11.269277619758196, -0.29050485270932097],
            [11.269151214801267, -0.29353714973740846],
            [11.263352906258191, -0.29837479851123105],
            [11.264331581758606, -0.3036456050816405],
            [11.268549138834606, -0.3067428236040739],
            [11.273558631431529, -0.302155162640708],
            [11.277952024575246, -0.3033339524780059],
            [11.274851451848319, -0.31093867623351923],
            [11.276265521900017, -0.31531793922051976],
            [11.27897227042183, -0.3159009491672999],
            [11.285344507047238, -0.31346623096472725],
            [11.286458220950326, -0.3176475657099072],
            [11.286492271180208, -0.32598292350670477],
            [11.287767725281935, -0.32986088282976733],
            [11.294780445323857, -0.3308843120490941],
            [11.299190933097918, -0.32575932637928895],
            [11.306658118086835, -0.3265393293827684],
            [11.311489162922596, -0.33262674885841326],
            [11.315285495549562, -0.34253738197771955],
            [11.31187456588337, -0.34756842828605644],
            [11.302532500288113, -0.3499880711867367],
            [11.302239139382834, -0.3553108004252562],
            [11.30801225247869, -0.35641023963026025],
            [11.310535837978895, -0.3596320762366727],
            [11.309578852905238, -0.3628284430660652],
            [11.311855494214504, -0.36710615257699347],
            [11.319386764394743, -0.3674719033946018],
            [11.323299346228678, -0.3588976288106401],
            [11.328524927588823, -0.35862065749333905],
            [11.332862512951081, -0.35650519259028307],
            [11.335392033682583, -0.3582608042968671],
            [11.33330984994069, -0.36249090211842244],
            [11.337661888322547, -0.36333813102345486],
            [11.345617884435683, -0.3588995627457692],
            [11.356632570151602, -0.3574587356389678],
            [11.358136211291619, -0.3580544341450198],
            [11.366542599551442, -0.36753819062982734],
            [11.367670618873584, -0.37517614615966616],
            [11.375169112712133, -0.37418474670352414],
            [11.380494410426246, -0.37624956334886966],
            [11.381431864757014, -0.3812045442911004],
            [11.384395298974633, -0.380720393617584],
            [11.384940374753521, -0.373746535102619],
            [11.382172201727379, -0.36798643580557233],
            [11.3814717404563, -0.3630892880100694],
            [11.385803573111199, -0.361210315811209],
            [11.388156237419514, -0.36616719161410594],
            [11.395201165980605, -0.37029162514303054],
            [11.40085250005438, -0.3665361750104742],
            [11.404314010588585, -0.3680342791473378],
            [11.405721606577728, -0.372148814130014],
            [11.412426018780012, -0.3718123121152906],
            [11.416985461693887, -0.3620485474033038],
            [11.419859066841843, -0.36571264309275636],
            [11.423245271621825, -0.36546422300599635],
            [11.425346101817944, -0.3608739152620449],
            [11.430587218075337, -0.36081722523825893],
            [11.434782282600208, -0.3564993281199791],
            [11.439467614494799, -0.35470229437478373],
            [11.444004139886783, -0.3575782762387501],
            [11.442383717567298, -0.3629145599698426],
            [11.386501415119639, -0.42990530240354347],
            [11.378652592870695, -0.4408803905762795],
            [11.336818798846183, -0.4915858403145339],
            [11.284609611903814, -0.5524757771193844],
            [11.284031155276274, -0.5536491831888737],
            [11.24908017969324, -0.5957860675759016],
            [11.22360570553613, -0.6261247116409967],
            [11.213362111185964, -0.6377204602682236],
            [11.207232983938058, -0.6456033375570169],
            [11.206014653496755, -0.6532839056799826],
            [11.202228578713338, -0.6582644792242146],
            [11.19694827965275, -0.6600178826201838],
            [11.193116880483675, -0.6630965997286221],
            [11.189123905292636, -0.6625022291795669],
            [11.189933108839229, -0.6692991056972346],
            [11.184023475203666, -0.677327927845774],
            [11.180863564246451, -0.6796792442681123],
            [11.173809592184544, -0.6815197641122166],
            [11.165053228750388, -0.6873900468059263],
            [11.159797563896737, -0.6878892285216139],
            [11.13391720423382, -0.7006179422706381],
            [11.124477707223615, -0.7066248341863566],
            [11.110731927361286, -0.7115216347773075],
            [11.105410261443769, -0.7180177816758299],
            [11.100682513258477, -0.7186917594266473],
            [11.083460352277715, -0.7283886937397428],
            [11.083338700359276, -0.7318790764631479],
            [11.08039595842894, -0.7350673419997681],
            [11.074361259257776, -0.7339335078310465],
            [11.067923547690254, -0.7392568665792483],
            [11.06726767605086, -0.7432293603417434],
            [11.059783901036237, -0.7504361176194927],
            [11.056097165743179, -0.7488705908160609],
            [11.05078742169968, -0.7525451189211089],
            [11.051370592386041, -0.755454267467199],
            [11.04415132581986, -0.7591690614521587],
            [11.041128717868421, -0.7631285763153818],
            [11.03736379701558, -0.7622494220518236],
            [11.034869927545124, -0.7642760016571866],
            [11.02683757747026, -0.7722797731584745],
            [11.01729876813547, -0.7636486205043115],
            [11.00717619679691, -0.7627925745281209],
            [11.00194889158822, -0.7582177200486767],
            [10.99885178335266, -0.7483381749041699],
            [10.995753815678238, -0.7444805183566464],
            [10.991162150543957, -0.742497953444564],
            [10.976432597808996, -0.7341958137845732],
            [10.9698832397826, -0.7276293355330682],
            [10.965167780509294, -0.7276096235517442],
            [10.964052290939453, -0.7316537233864404],
            [10.959034385732757, -0.7318721834267262],
            [10.952707593230706, -0.7389218313590692],
            [10.952049339994057, -0.7425624344079906],
            [10.946749623168053, -0.742153941272417],
            [10.94390118703945, -0.7440582806047751],
            [10.942679593916246, -0.7493353325131203],
            [10.93913099392447, -0.7528657590722968],
            [10.933148553183777, -0.7512107079762105],
            [10.93103446759883, -0.7531821654849634],
            [10.927235490984074, -0.7496157927524869],
            [10.922986463159766, -0.7506552279071227],
            [10.920577649622418, -0.7484853279061737],
            [10.922202731956869, -0.7410902454266388],
            [10.918198752626656, -0.7402544827156506],
            [10.91295555566111, -0.7416873609945173],
            [10.910919498566422, -0.7381575612241095],
            [10.914857952055344, -0.7350263184960321],
            [10.913415248824325, -0.7278309985754081],
            [10.904753600284758, -0.7248271458877137],
            [10.902506922850282, -0.7276974559876602],
            [10.894185696547577, -0.7290054195095925],
            [10.892539430519502, -0.727305710969805],
            [10.893911118947308, -0.7220260553968042],
            [10.885548705120792, -0.715360582504486]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.39583737517056,
          "lat": 37.469084826290256
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21195"],
        "coty_name": ["Pike"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pike County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "00516944"
      },
      "bbox": [
        10.885548705120792, -0.7722797731584745, 11.444004139886783,
        -0.19889397343013324
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.633476839774717, 0.03289955858717856],
            [8.639175274653118, 0.03421356063291622],
            [8.636955148888756, 0.03938191509628527],
            [8.642936620654996, 0.04081820735791679],
            [8.642643818035225, 0.04809305111226522],
            [8.647307151258666, 0.04545179288299489],
            [8.649758021675904, 0.04907704100050358],
            [8.655932804470112, 0.04711289578709654],
            [8.660452275226529, 0.044211473139499684],
            [8.664697174134439, 0.044177498341737044],
            [8.662856650585677, 0.05469670460499875],
            [8.666301532181105, 0.05369969287534383],
            [8.671299512583612, 0.05452153212946743],
            [8.673978439956278, 0.04836277279526957],
            [8.678586450670554, 0.04738968307970465],
            [8.67676500898028, 0.05441446895540421],
            [8.677449342683953, 0.05679659117392139],
            [8.68744807297555, 0.0593265306673966],
            [8.689205367789228, 0.06205969402669505],
            [8.694349423272781, 0.06279488467678151],
            [8.721391397662156, 0.06077390416024734],
            [8.741633695063724, 0.0701919565069876],
            [8.768212173044631, 0.12194330685993206],
            [8.851164874449676, 0.12296249069083633],
            [8.991023101696342, 0.12467582790522026],
            [9.022819786754448, 0.12500993812204783],
            [8.99714141095062, 0.06377367153966078],
            [9.001186740041724, 0.014605808615865787],
            [9.00207410970646, -0.036499864129910284],
            [9.003840116362142, -0.041588177006599884],
            [9.006329903531348, -0.0444655999410006],
            [9.001778398142779, -0.04973590097659408],
            [9.006653702452555, -0.05133892270371632],
            [8.996382519432984, -0.07198649230683683],
            [8.99795479816578, -0.07681890480285561],
            [8.995025644720386, -0.08001846954640976],
            [8.994960338686065, -0.08482944602037139],
            [8.993170299607826, -0.08995736475988057],
            [8.989661612101093, -0.09042416269271697],
            [8.983756192735738, -0.09602870509921603],
            [8.98263352289593, -0.10211380867348546],
            [8.97960394361808, -0.10500295799274031],
            [8.981068248853168, -0.10847070795769391],
            [8.979475716500824, -0.1161949192400023],
            [8.979416541378647, -0.1215468523336934],
            [8.976308320462799, -0.1325620499806436],
            [8.978809630509417, -0.14120110002427924],
            [8.982918191115848, -0.14387597671720692],
            [8.974747148918043, -0.14909485845638565],
            [8.973254121529278, -0.1546999017046014],
            [8.966100559965655, -0.16064981640383255],
            [8.96270261531966, -0.1736440533838382],
            [8.9589078894851, -0.17845604064447687],
            [8.951348124593114, -0.18053742578177143],
            [8.945257225323468, -0.18387497967936556],
            [8.837792398268794, -0.14308845517798488],
            [8.803081516614794, -0.1339539263950851],
            [8.75207484777005, -0.12075259723936908],
            [8.683045487868897, -0.1016604000593842],
            [8.684643251106646, 0.0011382993545913872],
            [8.68480656228564, 0.01670215384066795],
            [8.633476839774717, 0.03289955858717856]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.19474887391627, "lat": 38.21546235125336 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21211"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "211",
        "coty_gnis_code": "00516952"
      },
      "bbox": [
        8.633476839774717, -0.18387497967936556, 9.022819786754448,
        0.12500993812204783
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.0490606809036653, -7.817895283397353],
            [3.092126923717348, -7.818039134021212],
            [3.1812504851923835, -7.814520829193907],
            [3.1810091032614336, -7.799779261230434],
            [3.269036527601846, -7.797521307600647],
            [3.268847296479483, -7.790221443253965],
            [3.2975961620877605, -7.788949939696182],
            [3.319721833981328, -7.788477855058165],
            [3.374160948266913, -7.786316764008787],
            [3.374199169831372, -7.789245488586522],
            [3.3766863477010216, -7.882781074635072],
            [3.379049739065208, -7.940360237313094],
            [3.3809084906336975, -7.995073970738336],
            [3.3835147010246422, -8.05679610408459],
            [3.385698798555435, -8.10107375214781],
            [3.3892296722771342, -8.10275852956002],
            [3.394227484933492, -8.11115939418971],
            [3.3974223591122694, -8.111978028822035],
            [3.3989666662079636, -8.116224046885074],
            [3.3957876154457893, -8.120820778143734],
            [3.3970590360762567, -8.12323274475629],
            [3.3929056646246174, -8.1274091762261],
            [3.3897695299030675, -8.128773430284799],
            [3.39031030028526, -8.135490114054074],
            [3.3855894362726078, -8.138411395650701],
            [3.3806208091475605, -8.152012559646947],
            [3.3729895781800487, -8.154424269400018],
            [3.3686762379724215, -8.15853695455647],
            [3.3658619919502573, -8.16507712614492],
            [3.368846426886678, -8.16633491496951],
            [3.3729428164325084, -8.173150558975145],
            [3.371642827112371, -8.177451497617547],
            [3.3669818326950884, -8.184498863556968],
            [3.367956688986492, -8.188763109578893],
            [3.3640794198709463, -8.193746781489157],
            [3.360886289125632, -8.19499830184131],
            [3.3258045775836136, -8.19584729148004],
            [3.237413334057013, -8.199036092718746],
            [3.237219447072296, -8.205725370792019],
            [3.237799865528313, -8.223875528571423],
            [3.2371206574202875, -8.23137714251013],
            [3.2376238764855882, -8.249240050631485],
            [3.1507293879735463, -8.251879558098388],
            [3.062198123631184, -8.254634814476187],
            [3.0325806878030295, -8.255643586767066],
            [3.018111532997809, -8.254879000514347],
            [3.002584619027967, -8.255891452655558],
            [2.9883186722945485, -8.256323752147175],
            [2.9889279237428052, -8.27038308952369],
            [2.932374979324386, -8.272841201039052],
            [2.929482987522771, -8.178975618562346],
            [2.9282608231113088, -8.126846709555032],
            [2.927460446233406, -8.099818895816494],
            [2.9503500113370027, -8.09931504657629],
            [3.0142913430741753, -8.096804828145348],
            [3.0576225919914104, -8.09592183251288],
            [3.056923216248959, -8.06705628900644],
            [3.05440251604602, -7.943500492718872],
            [3.0521618576667064, -7.86315408111577],
            [3.0512627292987835, -7.863141670590182],
            [3.0490606809036653, -7.817895283397353]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.82804807444349,
          "lat": 30.652975738445168
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22003"],
        "coty_name": ["Allen"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Allen Parish"],
        "coty_fp_code": "003",
        "coty_gnis_code": "00558397"
      },
      "bbox": [
        2.927460446233406, -8.272841201039052, 3.3989666662079636,
        -7.786316764008787
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.278345273285266, -6.069353369987021],
            [4.278848150223376, -6.066615034280391],
            [4.288467123423294, -6.058081475335576],
            [4.293149715549978, -6.050725206885919],
            [4.299267838158885, -6.050042478276819],
            [4.302466259635926, -6.046724845966851],
            [4.307153424908924, -6.04652472249778],
            [4.314469112475361, -6.042940443402301],
            [4.31903718660277, -6.036965541730854],
            [4.316830143632096, -6.034502436400063],
            [4.31140709379837, -6.03310935937657],
            [4.309317179907351, -6.027427955167628],
            [4.3099019838443375, -6.02268123815955],
            [4.312796004359684, -6.019652861096115],
            [4.313392502588701, -6.015083676053352],
            [4.310971682280045, -6.01336261078869],
            [4.310933246235394, -6.0092835801214415],
            [4.314609531007467, -6.010229147214223],
            [4.316924660118242, -6.008355001720341],
            [4.314319717180892, -5.99953242806012],
            [4.317101747482873, -5.9927684058649975],
            [4.314133123101756, -5.992864451089035],
            [4.311248990514756, -5.989996857156553],
            [4.313839859551137, -5.987258078687515],
            [4.310565596467219, -5.980555295272089],
            [4.310822261497782, -5.973178482227833],
            [4.308883746476646, -5.96781122344817],
            [4.311866335121072, -5.963790403475877],
            [4.312633308246713, -5.956183242827838],
            [4.32810208155623, -5.9588727799336505],
            [4.332014053302124, -5.957521493051106],
            [4.330108095785155, -5.95387067324303],
            [4.332049570918974, -5.950754667579665],
            [4.32925703041241, -5.942402774529445],
            [4.331740373348101, -5.936728119559214],
            [4.3314785417623884, -5.9296036000606165],
            [4.334842490875662, -5.9269602512260375],
            [4.345360743355443, -5.9070551052822475],
            [4.350589879660557, -5.901313614586459],
            [4.3554474948019015, -5.897678612571237],
            [4.353806484112108, -5.890740657600763],
            [4.355979538462445, -5.878287428664471],
            [4.354028694673018, -5.874617416392395],
            [4.354651033402468, -5.853772524861745],
            [4.355606383331862, -5.846495487857548],
            [4.353651507849223, -5.8354353335073235],
            [4.354838812009723, -5.825508091888469],
            [4.348039395224748, -5.822902651801217],
            [4.348535526182002, -5.811837338516836],
            [4.354255649765301, -5.792924279281408],
            [4.352179208926963, -5.7905522637110005],
            [4.35297306745267, -5.785106658567582],
            [4.355910702944075, -5.786249008285382],
            [4.35623856165072, -5.780953333715806],
            [4.360567380274032, -5.779499919221549],
            [4.3598764871704905, -5.776090044398349],
            [4.363035287996446, -5.774373968817272],
            [4.366669552271037, -5.779040791699516],
            [4.373883269699278, -5.773979446557045],
            [4.375477635835451, -5.765956187949853],
            [4.378435315069162, -5.762459204968621],
            [4.374921327131279, -5.75976330592528],
            [4.375971447323094, -5.755784685212868],
            [4.374315179820238, -5.750746198754589],
            [4.373190351814475, -5.741343341430361],
            [4.373265135251181, -5.732797468232689],
            [4.375306804362838, -5.730493913584094],
            [4.378343809312299, -5.720838757473059],
            [4.380242930579161, -5.717508470642013],
            [4.377068271467378, -5.7156898432325525],
            [4.377394515465456, -5.708555388205909],
            [4.382897987868408, -5.69969726184494],
            [4.387262717976925, -5.69897988361446],
            [4.387738922210059, -5.694409028412715],
            [4.3910322295590705, -5.6958545506609655],
            [4.398081869270287, -5.693948318473217],
            [4.401886511819363, -5.687881215663103],
            [4.402550874235865, -5.679329602757053],
            [4.398525157857725, -5.672707323620238],
            [4.399477582619345, -5.669032808978376],
            [4.406516352818155, -5.670111852627346],
            [4.407182183819275, -5.667506153983172],
            [4.404133692407803, -5.662764504170274],
            [4.402094484183645, -5.655952380141578],
            [4.409932538836581, -5.652535741402273],
            [4.411054159891593, -5.642299907360012],
            [4.408011667062225, -5.6390818730783],
            [4.49038541961474, -5.635746950419626],
            [4.4886117823347185, -5.6480290442281165],
            [4.485312012450959, -5.654256379151431],
            [4.478324376230699, -5.662078460619916],
            [4.474431806666213, -5.66472639232763],
            [4.466309323872766, -5.676539581467144],
            [4.462821095073075, -5.680332453554024],
            [4.462861549511122, -5.684220485568271],
            [4.465294238768537, -5.689129098305328],
            [4.459012370923174, -5.6973861020676475],
            [4.454952526970946, -5.705927904596228],
            [4.454238594246485, -5.711734134313858],
            [4.45564618608131, -5.719899944542131],
            [4.459799385877136, -5.726458140757154],
            [4.469798899242302, -5.734546428517415],
            [4.482699257122613, -5.739247135099148],
            [4.4923014145137685, -5.740821775142028],
            [4.500827011046838, -5.739900692158962],
            [4.5076260953809895, -5.737494580484015],
            [4.512955073123551, -5.73365595422789],
            [4.521523429935543, -5.721007338513152],
            [4.522847602057232, -5.715480115860269],
            [4.523178870562653, -5.708518658866068],
            [4.518835483748712, -5.692583737336758],
            [4.516534024508967, -5.686091861862322],
            [4.517326159505949, -5.681446461177053],
            [4.521626187056137, -5.6776387643319595],
            [4.5217239118945765, -5.674739135673839],
            [4.51497601718892, -5.667526109155254],
            [4.517102939839848, -5.659090425598972],
            [4.525510966262249, -5.653635771253431],
            [4.536433420317655, -5.649374934308291],
            [4.540712170956611, -5.648577047976252],
            [4.548876887243341, -5.650690868943197],
            [4.55783537192111, -5.660403791498012],
            [4.563904166836594, -5.6735994796706954],
            [4.5656839971696135, -5.684512940291432],
            [4.562406296874096, -5.688601210898972],
            [4.564860665561788, -5.693190063224779],
            [4.572100523307941, -5.698204559821362],
            [4.57875053371332, -5.70925836714544],
            [4.579721474566558, -5.712989845551111],
            [4.579228196337933, -5.719203123754624],
            [4.5807335038520085, -5.7293069545268285],
            [4.580372854217664, -5.734638882126567],
            [4.5777354330930216, -5.743932885236545],
            [4.5758924407975, -5.7473061406674555],
            [4.563283219704079, -5.763260341640745],
            [4.548264134650878, -5.7790634851923],
            [4.539684959363261, -5.782264363097344],
            [4.529879890268932, -5.783348824737438],
            [4.521851106070242, -5.78985621799467],
            [4.516233935863396, -5.796261025859597],
            [4.511083441913848, -5.812755984415996],
            [4.506167195312917, -5.817384108438105],
            [4.503890482021229, -5.827359909525865],
            [4.504742838071278, -5.839804300539333],
            [4.502977667888144, -5.854106397665649],
            [4.509500259333222, -5.859265020796361],
            [4.509140159738035, -5.863602110032915],
            [4.503720495288937, -5.877954120973267],
            [4.503966385148339, -5.8886457376004655],
            [4.505804985663767, -5.892852969662405],
            [4.509977793670372, -5.896208356722802],
            [4.517049019138047, -5.89751565883657],
            [4.5324735937588265, -5.895407012624788],
            [4.539619824565496, -5.895351869281373],
            [4.5476987583659, -5.897772273031786],
            [4.567171829969122, -5.900650745415878],
            [4.578545120108725, -5.903638012721021],
            [4.5925126532095, -5.907966356376419],
            [4.598035521020618, -5.912925564215085],
            [4.596402041351692, -5.922711684226681],
            [4.591139739836326, -5.932652079936235],
            [4.581496485510449, -5.942341944887092],
            [4.577385212435491, -5.945182641217718],
            [4.562967763934226, -5.951770592400497],
            [4.547255559936189, -5.9638112784534565],
            [4.539795205286167, -5.972939329019556],
            [4.53744971053496, -5.979542893345274],
            [4.532264977108901, -5.98806979160199],
            [4.526789322074342, -5.990944686204788],
            [4.520179583108848, -5.998564276292398],
            [4.519589273932102, -6.004132041878425],
            [4.520210269068074, -6.0131617052151025],
            [4.522608164325727, -6.023317738846331],
            [4.527489952681645, -6.034862412091692],
            [4.5320757235626985, -6.041574419622483],
            [4.537270722647818, -6.046876022548841],
            [4.546114203062516, -6.052898352818118],
            [4.551527572874474, -6.052669885783727],
            [4.556183908979996, -6.0473774095608555],
            [4.562054670977099, -6.046382713338391],
            [4.576725254520547, -6.0394292318518135],
            [4.583462330606876, -6.035466928906163],
            [4.598401482617196, -6.02999652021687],
            [4.607974077255996, -6.027682024149037],
            [4.608390027680458, -6.021282490770961],
            [4.612725881495652, -6.01382305320915],
            [4.614015261914196, -6.00939308712281],
            [4.614503324310487, -6.001969687309821],
            [4.615958093262301, -5.9979656299969335],
            [4.622442630342288, -5.990006646971762],
            [4.625998538463508, -5.987296201622401],
            [4.63170500248614, -5.989731335643657],
            [4.635919522568798, -5.99288005296309],
            [4.642648544144626, -6.001764850189109],
            [4.646334585016184, -6.010292360367969],
            [4.6467216562609455, -6.018161878324628],
            [4.645640659437541, -6.023124280000965],
            [4.638608703510997, -6.034870665874644],
            [4.631242036502535, -6.0418360778458835],
            [4.624956035199713, -6.050677237356015],
            [4.620821945666143, -6.054688859460802],
            [4.61490217374679, -6.05828761475257],
            [4.610136436557615, -6.061184226201308],
            [4.593227199832439, -6.0731590710609975],
            [4.561929661912129, -6.0751047491231],
            [4.562094893860617, -6.082148839260531],
            [4.543956445072291, -6.094294678357923],
            [4.5418241680763405, -6.100459130696992],
            [4.457329434817612, -6.105036721943653],
            [4.396521825292331, -6.107680546070668],
            [4.270158428648334, -6.113902166969119],
            [4.2720900651303495, -6.110442634712466],
            [4.275969718000498, -6.110876607034565],
            [4.279202073953167, -6.1087283961700924],
            [4.283510010008071, -6.1081775246149705],
            [4.285467706931877, -6.105011658012116],
            [4.282448401066804, -6.100752858978788],
            [4.282839923723707, -6.098051139307766],
            [4.2914266638421035, -6.09023331237582],
            [4.286980036495747, -6.084161532192896],
            [4.285111079537371, -6.07975546939476],
            [4.279517387147575, -6.073898089925067],
            [4.278345273285266, -6.069353369987021]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.23499405152404, "lat": 32.73250675247636 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22035"],
        "coty_name": ["East Carroll"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["East Carroll Parish"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00558534"
      },
      "bbox": [
        4.270158428648334, -6.113902166969119, 4.6467216562609455,
        -5.635746950419626
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.386911087098538, -7.875760694855472],
            [5.420811266541506, -7.880786386456156],
            [5.449581440342035, -7.884790555458471],
            [5.503024652351273, -7.89267319148461],
            [5.512323265378988, -7.8943447512846925],
            [5.605815710331967, -7.9075311407319235],
            [5.6124261910822195, -7.908723941644147],
            [5.691365318208335, -7.9040970114398155],
            [5.715810740004403, -7.902319219074496],
            [5.719554067987744, -7.90146695310574],
            [5.743770356048721, -7.899792941795812],
            [5.744265151090563, -7.900217324618261],
            [5.741093038860567, -7.902398704886419],
            [5.738215325311584, -7.9009586663882025],
            [5.73589729587818, -7.905090349832013],
            [5.749716603982554, -7.908083913547204],
            [5.75208825226834, -7.907714413271083],
            [5.759701277315171, -7.915276335172477],
            [5.759322146637155, -7.919429744319841],
            [5.7616402702616165, -7.92465488128441],
            [5.764296677125078, -7.926084413578341],
            [5.768244075106239, -7.924881615324233],
            [5.770061819746976, -7.927171950476834],
            [5.76499537390132, -7.931465472199238],
            [5.764854497864765, -7.935904695758043],
            [5.76291150096716, -7.941553330610808],
            [5.757220474552719, -7.942498940568077],
            [5.756766374218653, -7.947076454984369],
            [5.765257849840271, -7.94592750668819],
            [5.763876042248013, -7.95553772693665],
            [5.769280950821047, -7.955251849236498],
            [5.771448593396993, -7.95756705607856],
            [5.764888021009643, -7.959492322117192],
            [5.772389045027578, -7.965031624875406],
            [5.767660260992644, -7.967129217600189],
            [5.7689289621319615, -7.9711227246370795],
            [5.774508595373561, -7.971971210238374],
            [5.775180024936746, -7.9756460250891665],
            [5.772365491617899, -7.978811750956675],
            [5.7773162185803795, -7.982910410090841],
            [5.7811501439561885, -7.995344231604173],
            [5.786377195150072, -7.993208001285045],
            [5.7951765749405, -7.991615804074946],
            [5.797611388385801, -7.992776868670216],
            [5.794351590004553, -8.000630680726978],
            [5.789662248746736, -8.000587219379845],
            [5.7864638019939525, -7.9988278771413635],
            [5.783572174286277, -8.002112005005127],
            [5.784688433494013, -8.004703289918927],
            [5.791856063854871, -8.005581187135535],
            [5.794644128467359, -8.010403239707351],
            [5.792862502990958, -8.013741917945403],
            [5.797783157341466, -8.017221244765656],
            [5.805488886574488, -8.01683984275144],
            [5.8094595622570955, -8.022048893757013],
            [5.814137715284817, -8.032713090576216],
            [5.817217534357928, -8.04524061626106],
            [5.823656475732946, -8.044084867116098],
            [5.825299088335771, -8.04666183417499],
            [5.826013504483315, -8.053695355979817],
            [5.831082535029223, -8.056794708839105],
            [5.8366473993616665, -8.056306547355504],
            [5.840462220145072, -8.061330661206224],
            [5.856076827392591, -8.06569321722514],
            [5.859240361106159, -8.068761381143965],
            [5.860912428219497, -8.074062905999218],
            [5.864499579060674, -8.079166173403731],
            [5.869932412225092, -8.078754149804498],
            [5.873741185882127, -8.083975639392657],
            [5.877430163278028, -8.090926757175229],
            [5.882646781496431, -8.092419210681918],
            [5.8881345537669425, -8.096026123188828],
            [5.894099904958285, -8.103074881159085],
            [5.894996821691097, -8.10896397229993],
            [5.893710052837941, -8.115310935494763],
            [5.8981075228880435, -8.125545879916771],
            [5.9008187361772695, -8.140190619211431],
            [5.896096745947846, -8.141859681954688],
            [5.896918412178125, -8.148537954945366],
            [5.901203505980575, -8.154102132407408],
            [5.907407337185425, -8.1643430664633],
            [5.910121529272617, -8.17096922767978],
            [5.9176797416703355, -8.18156357207343],
            [5.919857643318974, -8.189151651909121],
            [5.922972789680194, -8.19587445390937],
            [5.932257586053145, -8.19924979773878],
            [5.9338403887173685, -8.203491679573368],
            [5.941768465790333, -8.207095935438305],
            [5.9477315346895905, -8.21135368724099],
            [5.947580160717252, -8.21767787191773],
            [5.948828347921862, -8.229435691362415],
            [5.952425598457017, -8.235915668973485],
            [5.948093700641619, -8.24109505933288],
            [5.941154953230604, -8.24359344006239],
            [5.9398118744732304, -8.24714214794852],
            [5.94146051799849, -8.25527532941706],
            [5.935751845964837, -8.259835436799802],
            [5.93939876722466, -8.263182305623285],
            [5.943614902689935, -8.262465590379671],
            [5.9445590706880935, -8.265472854273888],
            [5.950283161659114, -8.270427888096771],
            [5.951257548135738, -8.273442911302174],
            [5.950246193846335, -8.281415852624592],
            [5.955953557481158, -8.283709984781982],
            [5.955931240468992, -8.287264875022858],
            [5.952117681390371, -8.287768575352251],
            [5.95148286610705, -8.292936567825496],
            [5.956018240958435, -8.297779893669992],
            [5.965574791634745, -8.301465345924031],
            [5.967778674863242, -8.307179237967048],
            [5.966137844505063, -8.321194370297153],
            [5.967459808059207, -8.325377302019346],
            [5.97054921647974, -8.328845531741216],
            [5.974929688900696, -8.33093739848473],
            [5.980506519718377, -8.331558735751017],
            [5.984756397614796, -8.335545864949067],
            [5.992248595318871, -8.346466816685526],
            [5.995471551409841, -8.354394995777522],
            [6.0001757640158955, -8.359938589507959],
            [6.005905517382824, -8.364023810061992],
            [6.009703475484349, -8.36515960376783],
            [6.0163655997816, -8.362627271010428],
            [6.022679905302652, -8.35882668494066],
            [6.028814761064346, -8.351164343520566],
            [6.035778791389547, -8.348013975874958],
            [6.040410359754156, -8.348695003937546],
            [6.045336092595074, -8.354143940186885],
            [6.042997925128109, -8.360914923032936],
            [6.041238068014278, -8.362634480704617],
            [6.036095734440653, -8.361231156787971],
            [6.029996028919864, -8.361654699236476],
            [6.020587605368585, -8.364909926947368],
            [6.01110102250989, -8.372578369491505],
            [6.008327416548764, -8.379396650687703],
            [6.009382703109697, -8.38497705151188],
            [5.997143765924729, -8.395441733302428],
            [5.990337794649865, -8.396648080314542],
            [5.987578247300466, -8.394332127793012],
            [5.964745200232487, -8.390912069994855],
            [5.963712214010737, -8.393288048777697],
            [5.950593402568823, -8.391008475770642],
            [5.942038665959293, -8.391663527949047],
            [5.937683029340096, -8.390800941420569],
            [5.929118133509521, -8.383930054354527],
            [5.915422534070112, -8.378035784261941],
            [5.910873981850362, -8.376641358214412],
            [5.906461769894731, -8.377182903659516],
            [5.903417646237362, -8.37937788502017],
            [5.900728923934083, -8.384395067124334],
            [5.888987261017847, -8.391347318765364],
            [5.8824908274416075, -8.392719094629784],
            [5.876370226165197, -8.389500607362038],
            [5.866570734168707, -8.380216053959435],
            [5.858922135673211, -8.377955791302252],
            [5.856312075487289, -8.379682797349705],
            [5.850160098771209, -8.386873764449703],
            [5.833854704426862, -8.397503219001289],
            [5.815243483850923, -8.39736532005554],
            [5.7965384289866995, -8.381456430429726],
            [5.793848781119164, -8.379639038330884],
            [5.76941334990232, -8.371204279858295],
            [5.753993256328394, -8.370847284933697],
            [5.721636608641094, -8.365734338479276],
            [5.672056644142061, -8.388222677437504],
            [5.661751100154439, -8.39183882009015],
            [5.637617601934188, -8.406434269382977],
            [5.620698782627783, -8.412476784430154],
            [5.606339146749639, -8.416207741988014],
            [5.580990500500082, -8.417495405603319],
            [5.569799261146132, -8.416398743226438],
            [5.555768406193742, -8.41331946305317],
            [5.547264651235498, -8.410103091289756],
            [5.519212045078428, -8.399488241871868],
            [5.514848920038355, -8.397118270223249],
            [5.504266278427132, -8.388242237032193],
            [5.505326783825433, -8.374412309598327],
            [5.500243727053823, -8.350252494588295],
            [5.497742829833425, -8.344240307928443],
            [5.490936208249625, -8.329032563344303],
            [5.482780975565118, -8.314163370701463],
            [5.473030857470635, -8.292279974141811],
            [5.466009526942117, -8.270256106933596],
            [5.430857690146166, -8.235730507630288],
            [5.41855216097839, -8.222661744693328],
            [5.416371241539145, -8.18759956207075],
            [5.413612343574854, -8.148826308593346],
            [5.412306115587601, -8.126107568683778],
            [5.411479723720608, -8.118186913905333],
            [5.4100021420310265, -8.08902470659825],
            [5.40893722328442, -8.07636179222903],
            [5.404302896511287, -8.010081729914578],
            [5.404298062018416, -8.006277813720397],
            [5.401362135522108, -7.9998696077072236],
            [5.4047419513917525, -7.990494729284859],
            [5.3991568618319405, -7.981910209820296],
            [5.40059608053518, -7.980573862743766],
            [5.397632112024632, -7.973648423897456],
            [5.3987921676045545, -7.970900749703565],
            [5.39609792636157, -7.963864319914515],
            [5.399287278947971, -7.9592136038423575],
            [5.400067959668342, -7.953883800558106],
            [5.398998149991649, -7.951438774839633],
            [5.401226719930043, -7.940068230985447],
            [5.396657985919364, -7.937279104570703],
            [5.394743068782267, -7.933818329771357],
            [5.396396159534636, -7.929569523519101],
            [5.391836376062569, -7.920430519427453],
            [5.393964963655437, -7.916440458763524],
            [5.391597897665845, -7.912436473481878],
            [5.393618742636863, -7.907292863981734],
            [5.393680936701028, -7.902491434137872],
            [5.390941958307562, -7.898639835775961],
            [5.392543681399339, -7.8922278115508355],
            [5.391017345452257, -7.887333339549079],
            [5.38625280554998, -7.883846572754501],
            [5.385571752758507, -7.877196977388448],
            [5.386911087098538, -7.875760694855472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.95833387013244,
          "lat": 30.410255768216075
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22103"],
        "coty_name": ["St. Tammany"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["St. Tammany Parish"],
        "coty_fp_code": "103",
        "coty_gnis_code": "01629503"
      },
      "bbox": [
        5.385571752758507, -8.417495405603319, 6.045336092595074,
        -7.875760694855472
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [18.707864079938723, 6.760775755713085],
              [18.711299700418035, 6.76149602334901],
              [18.713090897387975, 6.759098375121255],
              [18.720318374553756, 6.755218332574277],
              [18.721923364079124, 6.753273299638545],
              [18.718254119306515, 6.7488393769610475],
              [18.7086587815519, 6.754403938536083],
              [18.707864079938723, 6.760775755713085]
            ]
          ],
          [
            [
              [18.237734548501866, 7.460835007630151],
              [18.241681592571556, 7.463453004024187],
              [18.244897170534422, 7.462426358438558],
              [18.249430509371592, 7.457980146671899],
              [18.254573806152642, 7.458749792244095],
              [18.25602420241592, 7.461543302043959],
              [18.26143065094209, 7.459919362754976],
              [18.264528583505555, 7.462667110509866],
              [18.26697856315995, 7.467414387819431],
              [18.27113786857256, 7.469902073518255],
              [18.27563350989945, 7.468720292423247],
              [18.28123098995079, 7.470556296223839],
              [18.282583079835018, 7.475061938962824],
              [18.288438224858627, 7.483428435433798],
              [18.29740131054345, 7.487278718725849],
              [18.302638251000772, 7.493237100722664],
              [18.306125777912214, 7.495491579576347],
              [18.308050768801532, 7.498947154648442],
              [18.312004591070373, 7.497373184382745],
              [18.3231102774229, 7.496631391377893],
              [18.327754026561184, 7.498547890155155],
              [18.336204570823927, 7.505568854311273],
              [18.343982314620355, 7.506354922201857],
              [18.34553146446189, 7.504916985010917],
              [18.350103295834984, 7.506713775850027],
              [18.352763961234864, 7.511468569204401],
              [18.361910945033898, 7.510524099947495],
              [18.365317346457957, 7.511158430238316],
              [18.369248971748352, 7.517476574589363],
              [18.37493737122335, 7.520321786486811],
              [18.37957377409619, 7.510604715587896],
              [18.383916823860375, 7.50890515732405],
              [18.3923906645789, 7.502608262916327],
              [18.400809882153023, 7.501423492425519],
              [18.40794212817968, 7.502272515977003],
              [18.41592659940278, 7.50600184337951],
              [18.417973523070284, 7.510282107661101],
              [18.4235360622176, 7.513255517219193],
              [18.427557223564293, 7.519523184143875],
              [18.429976622193948, 7.520769122567054],
              [18.43573774278431, 7.520001571322243],
              [18.435892418292525, 7.526309290373244],
              [18.439733101083515, 7.527584956629913],
              [18.440561174682603, 7.522370352802721],
              [18.444532124304814, 7.5202300750373094],
              [18.447926680952285, 7.522129442573839],
              [18.453665680712817, 7.520075753685935],
              [18.456032047307087, 7.516685584082913],
              [18.458753327793172, 7.517079425173145],
              [18.464322866401925, 7.520834496000053],
              [18.472118406677446, 7.519125285111439],
              [18.472165841323505, 7.511617242816366],
              [18.479372453796774, 7.501303873243148],
              [18.475796736438305, 7.497935878504781],
              [18.481143626821563, 7.49154361980273],
              [18.48683209361984, 7.490131963233187],
              [18.48838284824056, 7.487105947733626],
              [18.487853463288875, 7.4822601232352195],
              [18.489397371171037, 7.476520654886182],
              [18.486938325620205, 7.470801981014363],
              [18.486668522346005, 7.465148941523032],
              [18.488291056201806, 7.451049703015858],
              [18.4877932021147, 7.444268209833457],
              [18.489764038741594, 7.438039527562525],
              [18.491832447215156, 7.435702072264694],
              [18.49777056534429, 7.434826900662014],
              [18.501731964963433, 7.439873801205695],
              [18.509464662680415, 7.443482351986947],
              [18.515009578955567, 7.442294629181877],
              [18.516828464699756, 7.440368030317137],
              [18.522458207766242, 7.440687365017772],
              [18.526151120975303, 7.436631489768915],
              [18.527115351330984, 7.430354511819473],
              [18.531426128213962, 7.432145999592808],
              [18.53605727339868, 7.4432057430872485],
              [18.55117142010729, 7.436975810393596],
              [18.56262046770472, 7.469630776434776],
              [18.580923151869072, 7.4582806389588425],
              [18.587584303577245, 7.453735425501303],
              [18.631625552421845, 7.426137825718712],
              [18.646200516937764, 7.416580232249761],
              [18.63187956590817, 7.375890279162278],
              [18.664966786918228, 7.365027365219346],
              [18.66424496556208, 7.363134494332827],
              [18.697944493561035, 7.350888469427951],
              [18.74731880328388, 7.333715059465874],
              [18.74354236594016, 7.326253900024606],
              [18.736967517423047, 7.301719786723057],
              [18.735943800385932, 7.289899321999419],
              [18.73784562393215, 7.281106065953408],
              [18.74435952670068, 7.264944673428563],
              [18.747692529515863, 7.260228956594241],
              [18.755713927788, 7.2529661783490615],
              [18.762586190104592, 7.251795906328005],
              [18.763170179591842, 7.256496849548158],
              [18.76519990531263, 7.258414494001013],
              [18.77948376367837, 7.261724364319694],
              [18.78607527467611, 7.264856091255988],
              [18.78275184199111, 7.256672050417112],
              [18.78546343582364, 7.2521856299886185],
              [18.782222410344634, 7.251564605926055],
              [18.782111542838837, 7.248231937863705],
              [18.779512034213276, 7.244017521522919],
              [18.774909222015637, 7.244737867380528],
              [18.767112258461903, 7.239542743446264],
              [18.762515909620102, 7.2331692996119985],
              [18.759986586000714, 7.225765083299241],
              [18.761557381997537, 7.219029735418602],
              [18.757714036242607, 7.216191256364474],
              [18.75621885506465, 7.211317883926641],
              [18.76131755745846, 7.209377769320545],
              [18.756973054875953, 7.202468868178961],
              [18.756960252941372, 7.198082222099427],
              [18.754152736857392, 7.189547881687429],
              [18.751888751717033, 7.190394364874331],
              [18.75090484530821, 7.195558807372283],
              [18.745590462337912, 7.194181069081104],
              [18.743635338037624, 7.190738617668187],
              [18.737396878398037, 7.186621416404169],
              [18.734684938673478, 7.179133261514715],
              [18.737187030004286, 7.176962349554049],
              [18.739515555493295, 7.170528355935799],
              [18.74557320004077, 7.16482408236296],
              [18.750140152690093, 7.154201037954586],
              [18.743282577106626, 7.145868996435364],
              [18.73159440523536, 7.141630724563583],
              [18.729343467662158, 7.138019998358372],
              [18.72964653041677, 7.133741121489133],
              [18.722263621116095, 7.1294448963326404],
              [18.721029041759582, 7.125292040134451],
              [18.71584608105092, 7.1258497586997045],
              [18.713394206228738, 7.129740271169644],
              [18.70676030097867, 7.128114103006779],
              [18.705603619519742, 7.1251476034637875],
              [18.701080578347533, 7.124710561582131],
              [18.69645877479995, 7.119984890555288],
              [18.69405200360596, 7.121767022043106],
              [18.683954102478317, 7.118515982059471],
              [18.673641230202488, 7.1081913942815955],
              [18.664610202507884, 7.090338649131216],
              [18.66137547482895, 7.07780102125875],
              [18.660860689698104, 7.064180075770235],
              [18.662358209433883, 7.06080325492759],
              [18.661039243153084, 7.056767671008144],
              [18.662664671181197, 7.050815034740255],
              [18.659161383237674, 7.047504974824778],
              [18.656486736433017, 7.03458345783114],
              [18.655918976245363, 7.012896544907332],
              [18.66108695165576, 7.0086734183798995],
              [18.663516475133196, 7.001811764927632],
              [18.675872440219653, 6.989941652295882],
              [18.676357701524722, 6.985720401733058],
              [18.670812303632225, 6.974912867319368],
              [18.67104689005919, 6.969995336937599],
              [18.673306412635196, 6.966482847140798],
              [18.67345308001213, 6.962215789671188],
              [18.67196512423889, 6.95500676121159],
              [18.667894621206184, 6.948348719674458],
              [18.665077451177336, 6.939149118272216],
              [18.667052136108712, 6.9371756594972],
              [18.670767238372637, 6.939261236780596],
              [18.67560242321206, 6.9376732948152675],
              [18.68032355590818, 6.933942784254993],
              [18.677113822950478, 6.929865711828483],
              [18.665355086504487, 6.931807334873487],
              [18.661124102654494, 6.925685636791677],
              [18.660547010908928, 6.908723005642881],
              [18.661592454601063, 6.904778093394357],
              [18.664428026397868, 6.904530947435882],
              [18.666354835858947, 6.8970464643402485],
              [18.660038909988657, 6.893866459848907],
              [18.65983945332993, 6.888065440048301],
              [18.66178239126861, 6.881018449001484],
              [18.660666446015323, 6.874402421972198],
              [18.654997768306394, 6.859627354856299],
              [18.652972519499126, 6.858538894246269],
              [18.653719893733488, 6.850768441966535],
              [18.650264818335234, 6.844853019175651],
              [18.649932475091113, 6.8395536109412305],
              [18.65138281269603, 6.832614948975562],
              [18.647935068517636, 6.825553997627825],
              [18.644915609197575, 6.8225324914647745],
              [18.62918678603264, 6.809621263148216],
              [18.62320533295072, 6.824045590103765],
              [18.60147104485095, 6.816606437426556],
              [18.59785198463925, 6.819318916353397],
              [18.58700151467192, 6.819077339800409],
              [18.579868491892206, 6.82697951373142],
              [18.575281764517353, 6.829982741208473],
              [18.566895925145886, 6.830097703879902],
              [18.56223153726987, 6.833990870552213],
              [18.5536647694385, 6.837726436782862],
              [18.54056501507328, 6.844903766078494],
              [18.531199188170582, 6.848090672428531],
              [18.525250314653285, 6.851142627879603],
              [18.522077713858152, 6.8558731696335835],
              [18.520034776313327, 6.861424910888928],
              [18.51513643401478, 6.8688965990992195],
              [18.51553324443446, 6.88037892267825],
              [18.51317285968205, 6.891220842641966],
              [18.51505997478237, 6.89751981479319],
              [18.50851531913695, 6.908269356109002],
              [18.50854854456005, 6.911173512378171],
              [18.51252451281582, 6.914496268320162],
              [18.512693946424335, 6.9181547071473455],
              [18.51034536912239, 6.9223022768987805],
              [18.50914461308647, 6.93730614573127],
              [18.511095187806095, 6.9405694204656125],
              [18.51158387578877, 6.948257961851163],
              [18.509071341533282, 6.951452971453588],
              [18.506363430116142, 6.951464790042557],
              [18.50233658040004, 6.959569028579078],
              [18.496501622050022, 6.961118804523272],
              [18.486457515215033, 6.960483765570174],
              [18.483137640306825, 6.965505516579812],
              [18.483902290777063, 6.968368975232678],
              [18.48022811192086, 6.970581784303761],
              [18.473480718854216, 6.971337555099275],
              [18.471760766137887, 6.969203572822367],
              [18.468030800613388, 6.970424036309514],
              [18.463456259697786, 6.977222406381984],
              [18.458203358750676, 6.977056038253408],
              [18.453940185432334, 6.98165503941775],
              [18.44860106897246, 6.980852195458656],
              [18.44254089536247, 6.9898696588742695],
              [18.435033283479697, 6.9904365419324135],
              [18.430616538957544, 6.995643792378631],
              [18.42509492080862, 6.9963466664131],
              [18.427940515476912, 7.002465215166202],
              [18.42569513814722, 7.0081743999535195],
              [18.422157470363906, 7.007132134223331],
              [18.417852052611995, 7.011319345816923],
              [18.41499932835279, 7.020751575529615],
              [18.411792478552925, 7.020364670276071],
              [18.399321361844265, 7.026619561994494],
              [18.396073329940496, 7.033178477579869],
              [18.392857477832248, 7.032943808684008],
              [18.38349098295751, 7.027650508267106],
              [18.379990076644965, 7.026732704347917],
              [18.375593459332997, 7.032122892021001],
              [18.37013512164378, 7.033481104270548],
              [18.361089143996658, 7.045720823652487],
              [18.36028673597136, 7.0506254075662484],
              [18.357576770061247, 7.05439054716194],
              [18.349724449061558, 7.061437576795984],
              [18.347567770073304, 7.064883798833675],
              [18.346341148517848, 7.071498415752617],
              [18.343060769545026, 7.077553389059301],
              [18.345859348033102, 7.079696981909911],
              [18.34472295007507, 7.084044685620153],
              [18.340922503788207, 7.087395966980996],
              [18.338025176495105, 7.097695083534393],
              [18.339432211329758, 7.103304935926892],
              [18.34424482573362, 7.108402641270923],
              [18.346976575292913, 7.115599047514553],
              [18.34521444814223, 7.120918748415375],
              [18.349642316518395, 7.125645597655354],
              [18.348065969953925, 7.130095736165037],
              [18.34245540946871, 7.136255336279247],
              [18.342733454606154, 7.152989127380287],
              [18.338206984814963, 7.158679208691414],
              [18.333501751959886, 7.158064648665238],
              [18.330280594122538, 7.160837337921227],
              [18.333778177339163, 7.165245098661227],
              [18.33124263790447, 7.170160588179935],
              [18.333536968152938, 7.182697854301823],
              [18.33504420430216, 7.184754078221066],
              [18.3331697920599, 7.198053297471029],
              [18.333538378664375, 7.204426552058918],
              [18.33252593295875, 7.208091828609167],
              [18.329708461565797, 7.209798780636727],
              [18.327282715135873, 7.215954449940988],
              [18.322756190522, 7.218522334364848],
              [18.32206641751223, 7.224306635637071],
              [18.324509532438253, 7.224542870979764],
              [18.32727238386033, 7.229160387279027],
              [18.327338560480392, 7.2360361762537275],
              [18.323586933338174, 7.238348475489721],
              [18.321548125692765, 7.243529332208598],
              [18.3165465477131, 7.245470102369875],
              [18.3103408114705, 7.249891179128785],
              [18.30707098346144, 7.250460540010267],
              [18.290657244093794, 7.302646420907007],
              [18.266484245426337, 7.374469591609861],
              [18.26270906907363, 7.387986796701492],
              [18.250838438128326, 7.423944128674498],
              [18.237734548501866, 7.460835007630151]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -70.71444411888709,
          "lat": 43.478219506141414
        },
        "year": "2023",
        "ste_code": ["23"],
        "ste_name": ["Maine"],
        "coty_code": ["23031"],
        "coty_name": ["York"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["York County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00581301"
      },
      "bbox": [
        18.237734548501866, 6.7488393769610475, 18.78607527467611,
        7.527584956629913
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.19115281433195, 1.266234215781289],
            [16.275938844523857, 1.2901395182648447],
            [16.27915570107295, 1.290820466009192],
            [16.30816904803423, 1.299647314251893],
            [16.3711225631297, 1.3171253748478216],
            [16.377012589615827, 1.3190950020386374],
            [16.378133536069644, 1.3275982640032769],
            [16.378398997298223, 1.3429769586606348],
            [16.379967595671502, 1.3461691620047553],
            [16.384779927433684, 1.3508062076825225],
            [16.388487151451255, 1.3524837519221597],
            [16.388680271217847, 1.3571197921483122],
            [16.39373775845393, 1.3657498264225314],
            [16.39699307748126, 1.3648902844832904],
            [16.39940798545201, 1.3669829910171547],
            [16.403305374090777, 1.384365029697728],
            [16.406704067263764, 1.3922339731397515],
            [16.400335379754424, 1.3960469026377327],
            [16.396500599956077, 1.4049921059644366],
            [16.39210171924516, 1.4056574802137753],
            [16.387170688850176, 1.4100111313692174],
            [16.383506513544564, 1.4153726491233323],
            [16.386097845926454, 1.4199089275442263],
            [16.388048855222006, 1.4328166269612337],
            [16.388262949633006, 1.4393162537175972],
            [16.38430837616911, 1.4470955146008986],
            [16.380363854465497, 1.452301742989724],
            [16.37383115446892, 1.4567925832973274],
            [16.368679135067925, 1.466860057183357],
            [16.36643653311811, 1.4677190691305124],
            [16.365815338162587, 1.4736864319289744],
            [16.360581254895987, 1.479375378871395],
            [16.359572691777377, 1.4823191598792258],
            [16.42673187050271, 1.4965866320352668],
            [16.47762623361203, 1.5076938544474736],
            [16.58101801504701, 1.5308344569992172],
            [16.58478277988202, 1.4939890858552758],
            [16.585246913140054, 1.4678547950622587],
            [16.58455999689618, 1.454964704427097],
            [16.58437492114662, 1.4322934033277888],
            [16.581848195845215, 1.4117518109941973],
            [16.581326069262797, 1.3995351020836126],
            [16.580179984007838, 1.3977261395050111],
            [16.5751648201575, 1.3972908303775866],
            [16.570918722996982, 1.384025130725698],
            [16.566034665761325, 1.3395733289082807],
            [16.564423212036154, 1.3157289753113404],
            [16.55900943494182, 1.2765498093380174],
            [16.5563911944345, 1.249124839147899],
            [16.55375682223349, 1.1886729196163754],
            [16.549279883306284, 1.1562843076239029],
            [16.539797447052873, 1.1187758639446885],
            [16.52734479588741, 1.0800627457493506],
            [16.50359027287353, 1.07227651778363],
            [16.412612017289597, 1.0406485820668787],
            [16.38307062930287, 1.0308087872666714],
            [16.306275092982958, 1.0048083296320691],
            [16.304899382437046, 1.0045354839611844],
            [16.243460592026274, 0.9837355661074115],
            [16.24496159153346, 0.9884827064999494],
            [16.24420375242907, 0.9972457485587203],
            [16.24085783012722, 0.9984888614686954],
            [16.23711590366319, 0.9960024227957844],
            [16.23374443881466, 1.0007679936311658],
            [16.23292880256071, 1.0056630151202062],
            [16.225887411863788, 1.009641585929932],
            [16.22138723941622, 1.0062428810239656],
            [16.218565562015282, 1.0105094627328226],
            [16.211829714889564, 1.0135894312513776],
            [16.208239627018656, 1.0176416843651013],
            [16.20465859505109, 1.024529112715227],
            [16.20489175840426, 1.0307409373967766],
            [16.206647561583623, 1.0356077886239097],
            [16.211775012623708, 1.036663484609308],
            [16.21589092839566, 1.0311801107615408],
            [16.221553373916915, 1.0311510639785963],
            [16.22301059326329, 1.0350866451389364],
            [16.221478523322933, 1.037846989309097],
            [16.224956956125116, 1.0407995672788888],
            [16.231684358965794, 1.0439626043624903],
            [16.233544504496887, 1.047667000755608],
            [16.234439224863983, 1.0549886821514132],
            [16.23127085687554, 1.0596399684388333],
            [16.23172507021214, 1.0626166744957004],
            [16.237589770792372, 1.0665941709639386],
            [16.24142707782552, 1.0660538432392173],
            [16.246168010539073, 1.062010179652709],
            [16.25440568709309, 1.0623439373156986],
            [16.260117759520035, 1.063896773666767],
            [16.2647201605765, 1.068386723220097],
            [16.26629344183877, 1.0743116304469613],
            [16.26427145879583, 1.0781311054577896],
            [16.265253101303948, 1.0844870200647996],
            [16.27055119430643, 1.0869851708016975],
            [16.27397551018762, 1.0849613134783902],
            [16.278074439323493, 1.0849224501873562],
            [16.28338577984435, 1.0880786855919873],
            [16.28655515327878, 1.0915939063404771],
            [16.283566330734676, 1.0934085485983287],
            [16.280770461621874, 1.099121348072671],
            [16.280770916106313, 1.1081922886471773],
            [16.277870099783815, 1.108658942843267],
            [16.277174010662993, 1.112930073565011],
            [16.272585076012994, 1.1154400707354382],
            [16.270899062478815, 1.1206182610845152],
            [16.264560521257987, 1.125486001328372],
            [16.256237833001443, 1.129586100313051],
            [16.254008858520915, 1.1280113728220411],
            [16.248308820277263, 1.1359016010959742],
            [16.2473779769331, 1.1396873608338796],
            [16.249308731244795, 1.1469487297108927],
            [16.25577596370373, 1.1558972467564668],
            [16.26250576182052, 1.1620507141941447],
            [16.264617579847258, 1.1696088092323245],
            [16.262970753632043, 1.173281425703962],
            [16.263478085912787, 1.1787972005243972],
            [16.2593565759734, 1.1848898172052023],
            [16.25155705014913, 1.189485668983319],
            [16.24852283306603, 1.195107139107251],
            [16.240958413907567, 1.2019974984168718],
            [16.235955916104245, 1.2036492049370335],
            [16.233702187157323, 1.2059247277659637],
            [16.231191721380867, 1.2144477279967691],
            [16.22270171153123, 1.216260906026097],
            [16.2186744492006, 1.220030567711344],
            [16.216959109273994, 1.2239375770634633],
            [16.21136750430788, 1.2290207102001562],
            [16.20276604382364, 1.23828193017311],
            [16.201368477608803, 1.2488443361841286],
            [16.195065400544028, 1.2557248438891677],
            [16.194284876615036, 1.2611757131057535],
            [16.19115281433195, 1.266234215781289]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.33405788972073, "lat": 38.21278013784338 },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24047"],
        "coty_name": ["Worcester"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Worcester County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01668802"
      },
      "bbox": [
        16.19115281433195, 0.9837355661074115, 16.585246913140054,
        1.5308344569992172
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.328836277479278, 5.494594803671653],
            [7.352329542984372, 5.496971426528816],
            [7.4094052468764735, 5.501555333398215],
            [7.437242400580838, 5.504053896212942],
            [7.46300955037984, 5.506068276868137],
            [7.523955645577367, 5.511203760385258],
            [7.610102300093039, 5.519649153384055],
            [7.6153267268615, 5.461668666058807],
            [7.620901058902523, 5.40730332747125],
            [7.628962494646734, 5.331836662965003],
            [7.636211539901904, 5.259548329412399],
            [7.645534196792943, 5.173269010284536],
            [7.559805467614782, 5.165647340546466],
            [7.510281293352585, 5.160987525168654],
            [7.4646549509831885, 5.157405376769605],
            [7.388042719002098, 5.15185254262664],
            [7.341780435504313, 5.147035602562195],
            [7.337950125707276, 5.159037388367984],
            [7.331421487819267, 5.174516811279403],
            [7.324711931351575, 5.188576858814025],
            [7.317898785988277, 5.201183319319538],
            [7.310009544850585, 5.2140259694989615],
            [7.289174850975315, 5.246744155810442],
            [7.280826446302985, 5.262744894107547],
            [7.271976860655666, 5.286028093665333],
            [7.268679415345756, 5.301437257532422],
            [7.2676307271100375, 5.31282589380594],
            [7.267865570919505, 5.327122519100765],
            [7.269772768933309, 5.336568081841183],
            [7.272625799184343, 5.346784917320726],
            [7.284063990921819, 5.368762332744465],
            [7.301792047838934, 5.397171465992995],
            [7.31415891337163, 5.420062809084077],
            [7.318383866122144, 5.4304674990436546],
            [7.3234124639292055, 5.44598734259523],
            [7.325456653921027, 5.458747747065081],
            [7.327152500353658, 5.464215498802641],
            [7.32862215831741, 5.476901496322429],
            [7.328836277479278, 5.494594803671653]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -86.26754652504287,
          "lat": 43.640948458110785
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26127"],
        "coty_name": ["Oceana"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oceana County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01623006"
      },
      "bbox": [
        7.2676307271100375, 5.147035602562195, 7.645534196792943,
        5.519649153384055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.0232902293249935, 7.162903068453949],
            [2.0261571333004333, 7.106587262600023],
            [2.0265400039299775, 7.076769907163152],
            [2.0276642010974912, 7.044858051693624],
            [2.029511120724306, 6.998748429247375],
            [2.031568698448954, 6.931663958216955],
            [2.0326116783701536, 6.902638244276664],
            [2.018219012782401, 6.902134109293241],
            [1.9601675358540422, 6.901581360683827],
            [1.8520532736146031, 6.8982024270666065],
            [1.7868444133746397, 6.89704734478067],
            [1.759563965526071, 6.896255287246839],
            [1.751500547271905, 6.903343153661531],
            [1.7473597983160387, 6.9127651420717084],
            [1.7462204422870184, 6.921025310410085],
            [1.7439211839587963, 6.926331740987969],
            [1.7289461101390098, 6.937149627049803],
            [1.7204731326781175, 6.955555494525879],
            [1.7212800845605845, 6.9597727930955084],
            [1.7191596424472488, 6.973024690334772],
            [1.7194961234345834, 6.98225020389708],
            [1.7237921728852972, 6.988231387376319],
            [1.7242467171535885, 6.990980737058655],
            [1.723458887059139, 7.0043230164593115],
            [1.725098593740369, 7.007762243225441],
            [1.731664421200752, 7.010448231346257],
            [1.7320123473738889, 7.016059804516827],
            [1.7234332786507405, 7.012178016042828],
            [1.7197973950709446, 7.013691258020423],
            [1.718098025551405, 7.022898549539321],
            [1.7144849156918012, 7.036362457321015],
            [1.7073697579010088, 7.041668366900607],
            [1.7049078236105848, 7.045148391034116],
            [1.7039791434814695, 7.050268877429427],
            [1.711004162875409, 7.0566748845891345],
            [1.710379899836489, 7.061233268544215],
            [1.6948345716195392, 7.064991495446156],
            [1.6875373484510137, 7.069707093643575],
            [1.67900949699102, 7.076630725296527],
            [1.6774142803315273, 7.081968714336272],
            [1.673948127583924, 7.088689016319463],
            [1.6751414425108233, 7.097085318004837],
            [1.6693992290842834, 7.101608068546043],
            [1.6699994767065878, 7.109048922849943],
            [1.6607463083016627, 7.114086994356709],
            [1.6537021490539427, 7.116977881438501],
            [1.646292037227669, 7.1185946580578605],
            [1.64164924118498, 7.123796128012656],
            [1.6406277697749903, 7.133180504324367],
            [1.6377314365232052, 7.134091385544594],
            [1.6339609750930892, 7.130793689771138],
            [1.6304517959253093, 7.131553363743205],
            [1.6256846848928526, 7.1355793786199095],
            [1.6183063374746298, 7.143939056537951],
            [1.612540063310235, 7.154453553871537],
            [1.6761599808680974, 7.156377999964585],
            [1.7202284542668393, 7.157547290456607],
            [1.7720982417749067, 7.1585747805757345],
            [1.8293697363078523, 7.160185068481076],
            [1.8582098776010407, 7.16122409573778],
            [1.9017537009557421, 7.161999555518114],
            [1.909038014892874, 7.161778994448238],
            [1.9381770289824487, 7.161944840200568],
            [1.9513919481885726, 7.161665717478093],
            [1.9658269311931917, 7.162108730843696],
            [1.9801781722549865, 7.16188465685204],
            [2.0232902293249935, 7.162903068453949]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.99884849071476,
          "lat": 45.699090358808284
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27009"],
        "coty_name": ["Benton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benton County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00659450"
      },
      "bbox": [
        1.612540063310235, 6.896255287246839, 2.0326116783701536,
        7.162903068453949
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.084008686486994, -3.6001347696913455],
            [5.222441401702568, -3.592281746706728],
            [5.284776652518507, -3.58866426738309],
            [5.369823608351954, -3.5836473027882074],
            [5.456913130702542, -3.578430726464815],
            [5.5001096760977966, -3.575523445496771],
            [5.543333230500684, -3.571782062243129],
            [5.557483665342933, -3.5708315920474405],
            [5.559205612251936, -3.5951076496504646],
            [5.560401381168214, -3.61636321745105],
            [5.562229315779736, -3.6386887317158076],
            [5.565644690646102, -3.688225038607434],
            [5.568717084798805, -3.7356703745275013],
            [5.573032590761989, -3.7946160951583807],
            [5.566970185139253, -3.7951732146864643],
            [5.501060372740712, -3.798844931262176],
            [5.450715599378554, -3.801916211873272],
            [5.422507664063254, -3.804069520642604],
            [5.418395706446875, -3.8090440182330036],
            [5.419457108966738, -3.812831403994771],
            [5.417413167750736, -3.8167367774659806],
            [5.414925595903444, -3.8171952685809676],
            [5.410096560513118, -3.826093305481692],
            [5.406536721818214, -3.82614613555302],
            [5.402877358021491, -3.831962600461321],
            [5.395388377780543, -3.8336424102977267],
            [5.392156140476704, -3.8399764009710498],
            [5.387116357800267, -3.8410065321213],
            [5.3873804287273765, -3.8488921508523704],
            [5.388424672889561, -3.852340951553419],
            [5.381750210124802, -3.85571041108753],
            [5.373192892906373, -3.8550947690964334],
            [5.369847306043581, -3.856209868865606],
            [5.365909113742079, -3.854453080483849],
            [5.365613603022364, -3.860445443717764],
            [5.360537995050258, -3.859892354069812],
            [5.351785402119184, -3.8650767700702473],
            [5.345710093148383, -3.8649395634579093],
            [5.342648227071774, -3.868304570236445],
            [5.3361118173491455, -3.8706339671768935],
            [5.332562402994467, -3.869907482562715],
            [5.327854793316271, -3.875284296665962],
            [5.319047591766076, -3.8710374961200356],
            [5.312651813097999, -3.8690257872911613],
            [5.3100404898216285, -3.8718098419122167],
            [5.302753989613472, -3.863836411870017],
            [5.304853655043393, -3.860188413508285],
            [5.298094157464283, -3.856560266372523],
            [5.2943519260928324, -3.8586695002552664],
            [5.292616910082853, -3.862434589736841],
            [5.289993696066168, -3.862397406259057],
            [5.285129831746617, -3.8588647999801498],
            [5.28247021603475, -3.8544640609636325],
            [5.27682365586549, -3.850348591179003],
            [5.276735283762637, -3.854206610021182],
            [5.270847167504302, -3.8548180471559035],
            [5.267104757102962, -3.8531158064007895],
            [5.263670216963682, -3.853760041584528],
            [5.263111509002138, -3.846408152825192],
            [5.256462113694218, -3.840816147891936],
            [5.2540403730889045, -3.833505689465232],
            [5.250983986239746, -3.835020152676503],
            [5.244141005341118, -3.82748650445335],
            [5.238527632299699, -3.8279133614567784],
            [5.235053604774661, -3.8304750700228105],
            [5.223674049277249, -3.830009895288104],
            [5.220202338639582, -3.832485073942993],
            [5.2144461975549055, -3.830744700981485],
            [5.212408031359782, -3.833530743920473],
            [5.207104594440062, -3.8368654592893203],
            [5.209371822601786, -3.8430253783394903],
            [5.206989921145862, -3.8465236832383543],
            [5.202600895170055, -3.847032133484518],
            [5.201682344145639, -3.850952744533349],
            [5.198393592957835, -3.8562619360577646],
            [5.197554716222993, -3.8627779405354783],
            [5.188385908975542, -3.867312574390118],
            [5.187462174860876, -3.862536026709475],
            [5.183564151971312, -3.81866592157851],
            [5.182200041437921, -3.7903954700913283],
            [5.180213999556339, -3.7612943090798128],
            [5.178460207425411, -3.7308696705350317],
            [5.122928694705829, -3.733929773813342],
            [5.095085708369334, -3.7358649937359303],
            [5.086654841661207, -3.73280039433307],
            [5.083913728363234, -3.7258035852674714],
            [5.094278531637375, -3.71840211281803],
            [5.1059379089043215, -3.7121220491085705],
            [5.116247822577703, -3.7095789024351493],
            [5.1311854202850125, -3.700455966997771],
            [5.137907823556775, -3.6932363892205533],
            [5.142119652714725, -3.683950907648612],
            [5.143034164312738, -3.6738805868874116],
            [5.141715543274487, -3.6613660501744163],
            [5.139466180385362, -3.6476420961626626],
            [5.137488602624768, -3.6442820493381003],
            [5.116782988365072, -3.635412394437943],
            [5.09514745774498, -3.6188511154665925],
            [5.090543996559918, -3.6135882156831007],
            [5.085067168203861, -3.603869937555396],
            [5.084008686486994, -3.6001347696913455]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.99121349570567, "lat": 34.87533391020209 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28033"],
        "coty_name": ["DeSoto"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["DeSoto County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00695741"
      },
      "bbox": [
        5.083913728363234, -3.875284296665962, 5.573032590761989,
        -3.5708315920474405
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.025242268526871, -7.115580297670867],
            [6.06970619775917, -7.112523323109998],
            [6.090156134393536, -7.111134098353281],
            [6.11301838345746, -7.109107583233028],
            [6.1333243464316505, -7.108236705930027],
            [6.154614331732674, -7.106497887149872],
            [6.167535134366281, -7.105979848456923],
            [6.243690535640809, -7.100265316757365],
            [6.284280359184458, -7.097403790773704],
            [6.288589668659055, -7.1558939120009715],
            [6.289339966730896, -7.167757257922042],
            [6.294078845017263, -7.2287147519772965],
            [6.297522867029595, -7.277308816960708],
            [6.299870629332086, -7.305673901599666],
            [6.31110648288409, -7.463013138115841],
            [6.315558558197934, -7.527853794814304],
            [6.322184368364809, -7.527388986580638],
            [6.329108094126677, -7.617165576161891],
            [6.242562411700676, -7.623266801681502],
            [6.156015794426198, -7.62935485625776],
            [6.149707146704182, -7.5389777869640495],
            [6.142660998982486, -7.539457741641694],
            [6.14202047148951, -7.530204596350372],
            [6.133151659244706, -7.405874498490758],
            [6.1298793238699885, -7.3550164484829805],
            [6.126752309393842, -7.302601086395197],
            [6.124033559837078, -7.261921528805465],
            [6.121683899998493, -7.231426326715939],
            [6.119346507615226, -7.196271797216881],
            [6.031759911727628, -7.202632652168321],
            [6.025242268526871, -7.115580297670867]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -89.25790444612164,
          "lat": 31.188875204823617
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28035"],
        "coty_name": ["Forrest"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Forrest County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00695742"
      },
      "bbox": [
        6.025242268526871, -7.62935485625776, 6.329108094126677,
        -7.097403790773704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.179790825979254, -5.000546849668647],
            [6.1778319361389435, -4.971682384428497],
            [6.185856193728032, -4.970921553548863],
            [6.235304568797948, -4.967414690452392],
            [6.249513748740189, -4.966413968676526],
            [6.26323620471371, -4.96331578496914],
            [6.409212615744311, -4.95171116753916],
            [6.439716204266281, -4.9490448834831655],
            [6.470936484360837, -4.946691332092902],
            [6.475800530575332, -4.949207854635771],
            [6.485774962139827, -4.95154456636965],
            [6.490094809416873, -4.951438331430626],
            [6.4985528387584255, -4.948636889987669],
            [6.502312808094434, -4.944316362746972],
            [6.521454245576302, -4.942873520948379],
            [6.526256225296178, -5.001837671693716],
            [6.533061330967978, -5.081942877800317],
            [6.5373148562670345, -5.13281485587362],
            [6.537512494532819, -5.133239165573743],
            [6.545060841359112, -5.220914396952798],
            [6.45470097137676, -5.228329691300456],
            [6.4258935394459025, -5.230496327549953],
            [6.353669790131381, -5.235980494337648],
            [6.299300064961856, -5.240262966337113],
            [6.198032663175838, -5.247780221485716],
            [6.18931654897909, -5.129990175746814],
            [6.18636590755946, -5.092862871155144],
            [6.179790825979254, -5.000546849668647]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.87933178362681,
          "lat": 33.424942477677185
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28105"],
        "coty_name": ["Oktibbeha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oktibbeha County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "00695775"
      },
      "bbox": [
        6.1778319361389435, -5.247780221485716, 6.545060841359112,
        -4.942873520948379
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.188385908975542, -3.867312574390118],
            [5.197554716222993, -3.8627779405354783],
            [5.198393592957835, -3.8562619360577646],
            [5.201682344145639, -3.850952744533349],
            [5.202600895170055, -3.847032133484518],
            [5.206989921145862, -3.8465236832383543],
            [5.209371822601786, -3.8430253783394903],
            [5.207104594440062, -3.8368654592893203],
            [5.212408031359782, -3.833530743920473],
            [5.2144461975549055, -3.830744700981485],
            [5.220202338639582, -3.832485073942993],
            [5.223674049277249, -3.830009895288104],
            [5.235053604774661, -3.8304750700228105],
            [5.238527632299699, -3.8279133614567784],
            [5.244141005341118, -3.82748650445335],
            [5.250983986239746, -3.835020152676503],
            [5.2540403730889045, -3.833505689465232],
            [5.256462113694218, -3.840816147891936],
            [5.263111509002138, -3.846408152825192],
            [5.263670216963682, -3.853760041584528],
            [5.267104757102962, -3.8531158064007895],
            [5.270847167504302, -3.8548180471559035],
            [5.276735283762637, -3.854206610021182],
            [5.27682365586549, -3.850348591179003],
            [5.28247021603475, -3.8544640609636325],
            [5.285129831746617, -3.8588647999801498],
            [5.289993696066168, -3.862397406259057],
            [5.292616910082853, -3.862434589736841],
            [5.2943519260928324, -3.8586695002552664],
            [5.298094157464283, -3.856560266372523],
            [5.304853655043393, -3.860188413508285],
            [5.302753989613472, -3.863836411870017],
            [5.3100404898216285, -3.8718098419122167],
            [5.312651813097999, -3.8690257872911613],
            [5.319047591766076, -3.8710374961200356],
            [5.327854793316271, -3.875284296665962],
            [5.332562402994467, -3.869907482562715],
            [5.3361118173491455, -3.8706339671768935],
            [5.342648227071774, -3.868304570236445],
            [5.345710093148383, -3.8649395634579093],
            [5.351785402119184, -3.8650767700702473],
            [5.360537995050258, -3.859892354069812],
            [5.365613603022364, -3.860445443717764],
            [5.365909113742079, -3.854453080483849],
            [5.369847306043581, -3.856209868865606],
            [5.373192892906373, -3.8550947690964334],
            [5.381750210124802, -3.85571041108753],
            [5.388424672889561, -3.852340951553419],
            [5.3873804287273765, -3.8488921508523704],
            [5.387116357800267, -3.8410065321213],
            [5.392156140476704, -3.8399764009710498],
            [5.395388377780543, -3.8336424102977267],
            [5.402877358021491, -3.831962600461321],
            [5.406536721818214, -3.82614613555302],
            [5.410096560513118, -3.826093305481692],
            [5.414925595903444, -3.8171952685809676],
            [5.417413167750736, -3.8167367774659806],
            [5.419457108966738, -3.812831403994771],
            [5.418395706446875, -3.8090440182330036],
            [5.422507664063254, -3.804069520642604],
            [5.450715599378554, -3.801916211873272],
            [5.501060372740712, -3.798844931262176],
            [5.566970185139253, -3.7951732146864643],
            [5.573032590761989, -3.7946160951583807],
            [5.575651752721845, -3.832147705563062],
            [5.5797111384385625, -3.88169854639531],
            [5.622955564818359, -3.878738752739495],
            [5.625964956582842, -3.9243095391663196],
            [5.632361120985466, -4.010400282830834],
            [5.589252384634566, -4.013350996746113],
            [5.518122640242729, -4.018388382197604],
            [5.517243937688899, -4.018584635468544],
            [5.413295599459693, -4.0253777037226905],
            [5.402085728056449, -4.02568506365565],
            [5.358957570495897, -4.028520666322164],
            [5.315969933464467, -4.031002003281285],
            [5.262350867911406, -4.034403026795343],
            [5.2001167589177815, -4.03790063334736],
            [5.19501562330038, -4.038199356851206],
            [5.189371438934894, -4.03218541585613],
            [5.188823098961174, -4.019775642510332],
            [5.177734802083143, -4.017141605513934],
            [5.180342978520472, -4.014616511279203],
            [5.179760583318563, -4.010891649574508],
            [5.175275615933612, -4.007256516692412],
            [5.171053854909658, -4.00562535423594],
            [5.1711894551829465, -4.001942499182485],
            [5.164086632776975, -4.00101756782133],
            [5.165309986814847, -3.9965071124693985],
            [5.160271684700971, -3.9922345388974327],
            [5.162134325169148, -3.988633532218978],
            [5.1659124092066415, -3.9863664076581315],
            [5.1657662112887035, -3.982916115859488],
            [5.161818484452866, -3.9792707432862993],
            [5.163621711153024, -3.972886046747787],
            [5.162022242692593, -3.9678579941396355],
            [5.169649050827642, -3.962884640601523],
            [5.172496613121079, -3.957127384906475],
            [5.1737562408340105, -3.95182809231846],
            [5.180020436536237, -3.945970731956585],
            [5.18079228485057, -3.9349607730749887],
            [5.180155562587347, -3.9323380455978114],
            [5.176007068155067, -3.931216601004606],
            [5.177030155633786, -3.9271839244118354],
            [5.174632493614923, -3.922552816407599],
            [5.171412253522473, -3.920213813091528],
            [5.170944776795462, -3.916661592925048],
            [5.174581040592267, -3.9085871743629403],
            [5.1740258549813625, -3.902943983873747],
            [5.167770655480589, -3.896465586286113],
            [5.164845814851454, -3.895241111598321],
            [5.164362067125687, -3.8913762402953798],
            [5.1691571299673, -3.8890052193726365],
            [5.168879548468861, -3.881505620865352],
            [5.172517138829556, -3.8808846343298353],
            [5.170932664374239, -3.8770966037305676],
            [5.17784372686981, -3.8697424750737137],
            [5.182078950862331, -3.86739240323606],
            [5.185013362302343, -3.8705054556315317],
            [5.188385908975542, -3.867312574390118]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.94473752349944, "lat": 34.65031142569089 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28137"],
        "coty_name": ["Tate"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tate County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00695789"
      },
      "bbox": [
        5.160271684700971, -4.038199356851206, 5.632361120985466,
        -3.7946160951583807
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.87815024319504, -3.9692852587265253],
            [4.880918023190918, -3.9584455861261447],
            [4.88261437601013, -3.955114003434606],
            [4.891052159171566, -3.94337324650641],
            [4.891971825817567, -3.9407737630518733],
            [4.89196168786013, -3.930482422663423],
            [4.889177825727178, -3.916193958460263],
            [4.900459768507349, -3.9154043035621693],
            [4.909343945962981, -3.9201108118051717],
            [4.913052848423558, -3.925248355756833],
            [4.9146710673144876, -3.9314537862280075],
            [4.905340228232503, -3.949249560947003],
            [4.904112657927084, -3.9628917637096905],
            [4.905216679901542, -3.9682336858933906],
            [4.911056972841052, -3.9771830243231525],
            [4.9161258125659915, -3.97995914044113],
            [4.923941685360043, -3.9808050450000234],
            [4.930087881170747, -3.979265891865217],
            [4.935905531009702, -3.9764888499797792],
            [4.942958741658744, -3.9702851182658874],
            [4.949160883043829, -3.961563665973373],
            [4.963381222588674, -3.9476082228339773],
            [4.97300262521136, -3.9349497129806035],
            [4.975015784309499, -3.930514123626882],
            [4.977068719393465, -3.9205584069431327],
            [4.975858151726165, -3.9119934455416834],
            [4.972999809477976, -3.9047474510927054],
            [4.966585580812984, -3.899802778257131],
            [4.9591890346245115, -3.9013514497503525],
            [4.9325573413663015, -3.9115674256666595],
            [4.919673230760283, -3.91162158120966],
            [4.91126990628511, -3.9083123536160067],
            [4.902196490851509, -3.902752315761859],
            [4.89685096505361, -3.8982225804675434],
            [4.886564834207052, -3.8968511916334605],
            [4.888781731454414, -3.888048074388102],
            [4.888771633447185, -3.8760123422243704],
            [4.891906102337723, -3.8713542744561944],
            [4.902868352426131, -3.8687682848700464],
            [4.9065322779549225, -3.8693977505456485],
            [4.910556327204584, -3.852652721180347],
            [4.904969261215217, -3.8375064372937646],
            [4.902154970128785, -3.8248610808168015],
            [4.90460915958819, -3.8163215227390075],
            [4.907078781984206, -3.811981374588925],
            [4.91281314035313, -3.8075402684834425],
            [4.922758178494381, -3.804921360028725],
            [4.931100470726034, -3.8081251814621533],
            [4.931357689799453, -3.816464183890109],
            [4.938521566218656, -3.822768685210477],
            [4.9475116632568135, -3.8331673055542668],
            [4.948239893988765, -3.841145078912298],
            [4.947077090168552, -3.848377581386195],
            [4.937493516493974, -3.8566447520141924],
            [4.932894751062265, -3.862432426520601],
            [4.9243712842076075, -3.875931823349025],
            [4.937707401364169, -3.8829999955040875],
            [4.944602819561314, -3.8845616751876455],
            [4.951400372238573, -3.884448614732958],
            [4.964817310938494, -3.881151534901523],
            [4.972749141888318, -3.877242197997122],
            [4.9802669093959855, -3.8714323501942496],
            [4.985547103318911, -3.864598351190298],
            [4.984548264962656, -3.8562468862834747],
            [4.9811179494252436, -3.8481711025004954],
            [4.96520947700394, -3.8236974795213814],
            [4.959550370071837, -3.8112166216706367],
            [4.959374852397816, -3.8042756566925484],
            [4.964192092884647, -3.791780377944393],
            [4.968806810193019, -3.7870671649074334],
            [4.9750863846065645, -3.782900653844193],
            [4.96938580524358, -3.772211025726524],
            [4.957506298257551, -3.7541135723963976],
            [4.951321170537984, -3.746968209287932],
            [4.9490190933915175, -3.7412796139963516],
            [4.9483758910460285, -3.7298822038858077],
            [4.950521204938775, -3.72356757850242],
            [4.954480562344219, -3.7185234524406816],
            [4.96150894916654, -3.7135143220493414],
            [4.9653177129364545, -3.7119499881320897],
            [4.972124769474054, -3.7123659537738334],
            [4.983725486083052, -3.717215005495493],
            [4.98672555714768, -3.719780524689356],
            [4.992655851362026, -3.731045201977799],
            [4.993520647703068, -3.735634536826128],
            [4.989082296263368, -3.746336293181583],
            [4.978582941118407, -3.763409905399381],
            [4.988354926078508, -3.77762786950724],
            [4.9952506612227525, -3.7762447684432847],
            [5.005549805518732, -3.776050369580491],
            [5.0132755537029645, -3.774571868152046],
            [5.019880926752839, -3.773307124008814],
            [5.028125675875347, -3.7698327171583568],
            [5.0494515678811425, -3.756375186691486],
            [5.067849168096867, -3.7394038597318198],
            [5.076412300779983, -3.747748670867475],
            [5.084308962106933, -3.752195844457329],
            [5.090753569961798, -3.75244683242496],
            [5.093825635125262, -3.7502751647294015],
            [5.097162348477207, -3.741838406745451],
            [5.095085708369334, -3.7358649937359303],
            [5.122928694705829, -3.733929773813342],
            [5.178460207425411, -3.7308696705350317],
            [5.180213999556339, -3.7612943090798128],
            [5.182200041437921, -3.7903954700913283],
            [5.183564151971312, -3.81866592157851],
            [5.187462174860876, -3.862536026709475],
            [5.188385908975542, -3.867312574390118],
            [5.185013362302343, -3.8705054556315317],
            [5.182078950862331, -3.86739240323606],
            [5.17784372686981, -3.8697424750737137],
            [5.170932664374239, -3.8770966037305676],
            [5.172517138829556, -3.8808846343298353],
            [5.168879548468861, -3.881505620865352],
            [5.1691571299673, -3.8890052193726365],
            [5.164362067125687, -3.8913762402953798],
            [5.164845814851454, -3.895241111598321],
            [5.167770655480589, -3.896465586286113],
            [5.1740258549813625, -3.902943983873747],
            [5.174581040592267, -3.9085871743629403],
            [5.170944776795462, -3.916661592925048],
            [5.171412253522473, -3.920213813091528],
            [5.174632493614923, -3.922552816407599],
            [5.177030155633786, -3.9271839244118354],
            [5.176007068155067, -3.931216601004606],
            [5.180155562587347, -3.9323380455978114],
            [5.18079228485057, -3.9349607730749887],
            [5.180020436536237, -3.945970731956585],
            [5.1737562408340105, -3.95182809231846],
            [5.172496613121079, -3.957127384906475],
            [5.169649050827642, -3.962884640601523],
            [5.162022242692593, -3.9678579941396355],
            [5.163621711153024, -3.972886046747787],
            [5.161818484452866, -3.9792707432862993],
            [5.1657662112887035, -3.982916115859488],
            [5.1659124092066415, -3.9863664076581315],
            [5.162134325169148, -3.988633532218978],
            [5.160271684700971, -3.9922345388974327],
            [5.165309986814847, -3.9965071124693985],
            [5.164086632776975, -4.00101756782133],
            [5.1711894551829465, -4.001942499182485],
            [5.171053854909658, -4.00562535423594],
            [5.175275615933612, -4.007256516692412],
            [5.179760583318563, -4.010891649574508],
            [5.180342978520472, -4.014616511279203],
            [5.177734802083143, -4.017141605513934],
            [5.188823098961174, -4.019775642510332],
            [5.189371438934894, -4.03218541585613],
            [5.19501562330038, -4.038199356851206],
            [5.2001167589177815, -4.03790063334736],
            [5.202859358514592, -4.081394335762027],
            [5.162838575369718, -4.084521819945371],
            [5.160342271209247, -4.084961785063156],
            [5.1166416225107705, -4.088080032886545],
            [5.118482233105578, -4.116976535530335],
            [5.12096207647856, -4.13033355944096],
            [5.123792272206623, -4.173344027937381],
            [5.090120306319231, -4.175506606132565],
            [5.044071866275937, -4.17881981042198],
            [4.964170905473499, -4.126939966879151],
            [4.9583548539685935, -4.122799437361811],
            [4.900771695296502, -4.086232455124028],
            [4.912506456493366, -4.078194638011569],
            [4.917895798249255, -4.072967688396065],
            [4.920495289059059, -4.068820916763035],
            [4.922067604092836, -4.054855594525147],
            [4.921129653442535, -4.050934633829849],
            [4.91324198317485, -4.039919570369648],
            [4.8920259424327845, -4.0180861712186156],
            [4.879993273494206, -3.9998631301007657],
            [4.876303667477034, -3.991710566989849],
            [4.87592671429979, -3.9821183120710613],
            [4.87815024319504, -3.9692852587265253]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.37494993496523, "lat": 34.65065190281898 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28143"],
        "coty_name": ["Tunica"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tunica County"],
        "coty_fp_code": "143",
        "coty_gnis_code": "00695792"
      },
      "bbox": [
        4.87592671429979, -4.17881981042198, 5.202859358514592,
        -3.7119499881320897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.566292569871393, -6.426250573511069],
            [4.572215219122703, -6.430384812281032],
            [4.579503851876365, -6.428529845190835],
            [4.585810863414939, -6.418505075266821],
            [4.592477074915777, -6.412161760890652],
            [4.5994021052400305, -6.409205195488972],
            [4.606598852637915, -6.408234461740331],
            [4.610012773437805, -6.409058676826169],
            [4.618551578104452, -6.416019489868998],
            [4.625042527410661, -6.406381530805111],
            [4.626872551269273, -6.39628501590093],
            [4.629898227470072, -6.392927262899287],
            [4.636137478128448, -6.391403194703212],
            [4.640128769551812, -6.391996122163389],
            [4.651168553269545, -6.396823334209179],
            [4.661696828103206, -6.406276043358164],
            [4.667491483434161, -6.409074055926885],
            [4.66670216955005, -6.419651979618694],
            [4.669296837721006, -6.436175705649753],
            [4.670601111179668, -6.4391680061298056],
            [4.675638892820943, -6.439584424331276],
            [4.680297513261677, -6.430160582972396],
            [4.68423140924254, -6.420604112095982],
            [4.683666912330091, -6.399903025334283],
            [4.685408775907553, -6.387577442225222],
            [4.688658080443968, -6.382914018349644],
            [4.6940820859224655, -6.378198923066874],
            [4.692173775524347, -6.37307526643263],
            [4.684786532027641, -6.365950565668815],
            [4.68172860498073, -6.36106696385743],
            [4.6802991269575696, -6.351477517609461],
            [4.682487942114377, -6.3399007974119135],
            [4.686039350481157, -6.33467143993675],
            [4.6898092512695, -6.333425538603953],
            [4.6961349478126495, -6.333717701477598],
            [4.704043940278851, -6.343937180814872],
            [4.707610745185378, -6.346792352177616],
            [4.710549005875373, -6.346349881841726],
            [4.7218070661540334, -6.338893064315981],
            [4.736071020911365, -6.324888678745067],
            [4.744651071420308, -6.312509052011012],
            [4.74752732596633, -6.304461294405419],
            [4.747586782770054, -6.297460229715216],
            [4.76169261827289, -6.269512093708309],
            [4.766364876662534, -6.254367021635834],
            [4.764020795434576, -6.252376890430237],
            [4.755151144276543, -6.254155116019393],
            [4.752683920980338, -6.256956388422064],
            [4.748775727696096, -6.27339765935522],
            [4.737326842840272, -6.28892571144964],
            [4.729795427264316, -6.286705543909241],
            [4.718121135822838, -6.284429241895379],
            [4.711284598012256, -6.283801710938213],
            [4.70155406482429, -6.284413301603919],
            [4.6743137358132305, -6.2799421384124],
            [4.668358426020915, -6.277965781914902],
            [4.662727514005876, -6.274610000016541],
            [4.659639683656235, -6.270318229924692],
            [4.65848382657982, -6.264375090137786],
            [4.661042033500594, -6.250730460706988],
            [4.6643671814993715, -6.244133988241341],
            [4.6659664788364354, -6.2353256531403325],
            [4.665339920538462, -6.228268167829986],
            [4.676307874899371, -6.22330758138306],
            [4.681358836092334, -6.219280477626731],
            [4.686637381911783, -6.212718552017368],
            [4.687758750629719, -6.209908782118027],
            [4.686905926610063, -6.197099848340496],
            [4.6839807256928845, -6.1916261505089505],
            [4.676072811281001, -6.184492341901777],
            [4.671877811103828, -6.1826656102568185],
            [4.663034503353357, -6.181354720664082],
            [4.658787432006855, -6.182262941372862],
            [4.654133527557267, -6.186935124259579],
            [4.644612099352647, -6.192837046391487],
            [4.636708270751041, -6.199154934602555],
            [4.6339893737624385, -6.200197353705846],
            [4.614200783119681, -6.196319865198817],
            [4.599350423667358, -6.190382033946219],
            [4.589352216906044, -6.185592148178999],
            [4.577606514933741, -6.177887676106399],
            [4.5656053548560775, -6.165190189103987],
            [4.558999274931132, -6.154416243517482],
            [4.55729574504792, -6.142591050704304],
            [4.557534945656559, -6.137472978209277],
            [4.564913195774495, -6.122282852373621],
            [4.569118079061661, -6.111389175189632],
            [4.57132508212248, -6.099646173818091],
            [4.570993703733645, -6.092115357758009],
            [4.574229746627836, -6.087567377309915],
            [4.590885991253226, -6.102391574111281],
            [4.594803993253465, -6.107492230090087],
            [4.603961571457253, -6.122848893905875],
            [4.612648157254792, -6.134636012043945],
            [4.6171607116745035, -6.139007521374034],
            [4.62387866293993, -6.143763770086198],
            [4.635879430017876, -6.148345471842622],
            [4.652713428626044, -6.15057026698973],
            [4.656862699697483, -6.149877560680541],
            [4.663728088619367, -6.144377710830618],
            [4.666099091958757, -6.139609740049433],
            [4.664641743643075, -6.131221875076334],
            [4.659135800785893, -6.123730910177734],
            [4.648502497408027, -6.116517671276607],
            [4.63871662987995, -6.112374753509865],
            [4.610820106224204, -6.103941384343037],
            [4.601724603272693, -6.09884696718759],
            [4.589730330044005, -6.0891827493887325],
            [4.585018047752925, -6.079688488946981],
            [4.593227199832439, -6.0731590710609975],
            [4.610136436557615, -6.061184226201308],
            [4.61490217374679, -6.05828761475257],
            [4.681380791762599, -6.055474805332281],
            [4.684576760379688, -6.12734679500995],
            [4.685102929199581, -6.13085048377041],
            [4.690692344731178, -6.219605634972614],
            [4.693891076867415, -6.20967545564505],
            [4.69436231866491, -6.202553507072438],
            [4.697627755457406, -6.189336570467664],
            [4.699099374261152, -6.1859242505051295],
            [4.704310077376205, -6.179924438645781],
            [4.71195679397896, -6.177209780905845],
            [4.719521889036094, -6.178645297769402],
            [4.726309478490349, -6.18472553020712],
            [4.728888491489336, -6.18459228571055],
            [4.739873094498891, -6.17945874157391],
            [4.746219744262779, -6.179201830040938],
            [4.755256344472178, -6.185762127436348],
            [4.7577719294329075, -6.186426229724861],
            [4.7629150967471325, -6.182661547597497],
            [4.764437177731855, -6.176268726593619],
            [4.767981501800735, -6.176055348410945],
            [4.770398081801445, -6.181191458058319],
            [4.774498216187798, -6.183525829821466],
            [4.767983177452863, -6.05129307196158],
            [4.797815794471449, -6.049443348544575],
            [4.799515441441695, -6.049618634966531],
            [4.8453845650670395, -6.047511990576375],
            [4.84966928144431, -6.044604720108627],
            [4.853371695998553, -6.045754765917168],
            [4.857639947041901, -6.050183948032212],
            [4.862306742837197, -6.0509059736421325],
            [4.869445243093788, -6.049172808098223],
            [4.874816976591278, -6.054255436535976],
            [4.879102754678129, -6.05415714542387],
            [4.880642426242129, -6.050438190098084],
            [4.88054184339963, -6.042657890416845],
            [4.876138208989773, -6.038031900459972],
            [4.875124898268348, -6.033330805857413],
            [4.882360424561136, -6.028080947158622],
            [4.882597779228128, -6.022060468118018],
            [4.88656505056855, -6.008354310646786],
            [4.883061968712391, -6.001255035441464],
            [4.90828785015732, -6.000056291402281],
            [4.9096782640876455, -6.029301015820897],
            [4.938699343003252, -6.0272980403328775],
            [4.940331821184696, -6.042260646528447],
            [4.942258183861165, -6.070902370263455],
            [4.997664899404039, -6.06775489456308],
            [4.998562641848119, -6.082038353716326],
            [5.02702931499417, -6.080268423069338],
            [5.0285001903999955, -6.104556230796978],
            [5.027257356807994, -6.107184054737931],
            [5.0156336082054365, -6.1115276168535395],
            [5.006414648942989, -6.111610728033744],
            [5.007701316192658, -6.1151461183780125],
            [5.005421375954154, -6.11943571618937],
            [5.001397908209001, -6.116708515405132],
            [4.9989314977217045, -6.1207560852126965],
            [4.999343983872731, -6.125168219064473],
            [4.99306068091683, -6.131311328974751],
            [4.9904807772338975, -6.130085276439392],
            [4.987927568856863, -6.133175814588803],
            [4.988728472063205, -6.137396601408587],
            [4.992202680997307, -6.1438374858008675],
            [4.991445763276537, -6.156126056913403],
            [4.994565849184275, -6.156877857189336],
            [4.9949272427535965, -6.1638387390947615],
            [5.005335377957438, -6.168440130782703],
            [5.000658024837641, -6.173911967137207],
            [4.998411554098227, -6.172764514516078],
            [4.994044239593168, -6.178980268294275],
            [4.994585592662572, -6.189544938838395],
            [4.989417738636084, -6.198859962736282],
            [4.98497886699692, -6.200296936276581],
            [4.985266132431156, -6.204740013773072],
            [4.982454918801124, -6.205437197273719],
            [4.983833052837148, -6.210340290710526],
            [4.981650601004382, -6.2132175085234875],
            [4.9808373964297985, -6.217733425385029],
            [4.977494967354933, -6.2244990434099385],
            [4.975021051062558, -6.227159063955225],
            [4.978056820828992, -6.230314807457227],
            [4.974288966319226, -6.237396219015771],
            [4.969324545257458, -6.238599302525304],
            [4.967106822401392, -6.24127955515012],
            [4.968014541247158, -6.247672203655571],
            [4.971409665651405, -6.254047065338023],
            [4.97338194236662, -6.265919919775766],
            [4.975650399200652, -6.269931299798956],
            [4.975959318815031, -6.27583145833744],
            [4.972184042921919, -6.276555172495419],
            [4.96425504355479, -6.272570269807002],
            [4.95572348906146, -6.272046505970084],
            [4.928565440933485, -6.2651698663636415],
            [4.924050606525007, -6.266758277227079],
            [4.919370476823729, -6.265468939521042],
            [4.918749910370623, -6.269370960746267],
            [4.9142945861367355, -6.271771210866205],
            [4.911109794689733, -6.271619536570802],
            [4.9091172887384324, -6.279041444582224],
            [4.916571228860404, -6.287580820634507],
            [4.911862619406153, -6.2941742480967315],
            [4.913408369386745, -6.295931063103332],
            [4.914225324553884, -6.301981674794647],
            [4.911959595394345, -6.303271203806939],
            [4.91419119818098, -6.307929234015691],
            [4.9169958009879835, -6.309786233987589],
            [4.919042127546786, -6.314810593309119],
            [4.918859505280935, -6.321168439015794],
            [4.912646873484839, -6.328372861384435],
            [4.912531715401493, -6.336485814389226],
            [4.908039494386296, -6.339413353172997],
            [4.906817228968074, -6.343247447390538],
            [4.902619998362256, -6.342183721166557],
            [4.905075977098295, -6.348421992898617],
            [4.9035676849568075, -6.356785444282049],
            [4.897926876553408, -6.359449425015685],
            [4.902603325531421, -6.362649142345434],
            [4.906928881658276, -6.368408404848392],
            [4.906832615533736, -6.371745564512709],
            [4.901214610109931, -6.377487949131571],
            [4.8984142593125455, -6.378166833671164],
            [4.898613485594129, -6.387794658116407],
            [4.900230517777154, -6.3895522881097895],
            [4.897884176317636, -6.394624098002582],
            [4.894974236874949, -6.3944384408697],
            [4.893644266462286, -6.401055670739729],
            [4.889307186045167, -6.404744057272759],
            [4.891626267956976, -6.407932706130274],
            [4.8890345611373665, -6.412284103400399],
            [4.8836284827288345, -6.417185263502756],
            [4.879934236255697, -6.412583482328667],
            [4.877313693681196, -6.414686143226128],
            [4.878813962344328, -6.424745386520894],
            [4.876053766325604, -6.427089640057087],
            [4.8702298262549935, -6.425284329031446],
            [4.8698973014866125, -6.429669968534594],
            [4.862629708955349, -6.4292786426798525],
            [4.857598626439456, -6.432699680875976],
            [4.854751622781435, -6.437286474365571],
            [4.851407153087014, -6.439271518983485],
            [4.851811859967409, -6.442856392063873],
            [4.848574466799219, -6.444281283944134],
            [4.849040342020536, -6.447723733636295],
            [4.852699567071943, -6.450159759005507],
            [4.857063031612219, -6.450120582090217],
            [4.861676362389476, -6.455080656659766],
            [4.861821876816439, -6.458957529988704],
            [4.866878767068061, -6.4560793285093],
            [4.86924861847756, -6.458307082043899],
            [4.866103791440045, -6.4645144606078695],
            [4.862991273852864, -6.467689271441718],
            [4.852617809142314, -6.468997964346948],
            [4.847944033004552, -6.470938058119025],
            [4.848936263397058, -6.4745465301198575],
            [4.843383344129158, -6.475545077040117],
            [4.839095418814812, -6.4704085993019085],
            [4.83617207171741, -6.47224477118614],
            [4.832592232559663, -6.479757169830511],
            [4.827255923951567, -6.483878119487315],
            [4.826547721747177, -6.48639274435619],
            [4.821692752091058, -6.4851036723373054],
            [4.817369775729025, -6.479308087280288],
            [4.816896908940171, -6.47338897424679],
            [4.818401570379617, -6.467272706989782],
            [4.811573295954891, -6.465816745542246],
            [4.807781957580923, -6.466996699463117],
            [4.804660940459565, -6.465810964811659],
            [4.79964358835883, -6.468376856628838],
            [4.805168514066801, -6.471486362411728],
            [4.803907450504363, -6.4738046758361865],
            [4.793585187224013, -6.481874551029811],
            [4.798568411624664, -6.485869598422552],
            [4.802810899212493, -6.4836778018643875],
            [4.805821061885911, -6.486173646197313],
            [4.804431362284255, -6.496691195110946],
            [4.794656746389492, -6.501085840535357],
            [4.791105039749384, -6.503895885145694],
            [4.784393620894821, -6.5059664002144935],
            [4.780177162753647, -6.504410623773054],
            [4.782975320320866, -6.499390501642181],
            [4.780070499298763, -6.498563315736011],
            [4.7776131555706165, -6.50630405543626],
            [4.778708609468719, -6.509568277971241],
            [4.774505950375384, -6.511939367272807],
            [4.768282265591502, -6.507684539521859],
            [4.762346944022955, -6.501524815748651],
            [4.757230975804527, -6.499767881046086],
            [4.755585250492649, -6.495967638185164],
            [4.752379799439134, -6.495767501256138],
            [4.7478383055834215, -6.507315200126794],
            [4.747556219932337, -6.510630075573045],
            [4.742810029370339, -6.509771552237636],
            [4.74159310105858, -6.511716132808227],
            [4.744652553590084, -6.516230214088331],
            [4.7453904227712, -6.52066763157757],
            [4.73928727847507, -6.528658164583145],
            [4.741199551549294, -6.53118928761052],
            [4.746977360942187, -6.529284357909556],
            [4.749178319399604, -6.531762947011947],
            [4.743842131625452, -6.540712509626845],
            [4.750227769791065, -6.540328902158254],
            [4.747948627422673, -6.546524164024724],
            [4.732945303969882, -6.547111839863174],
            [4.728625569492535, -6.5449521343775965],
            [4.728433444118956, -6.549397459799821],
            [4.723726830631681, -6.549250599474227],
            [4.72581272982224, -6.542092571231414],
            [4.723031813390197, -6.539951081365482],
            [4.719986704135388, -6.54337349388366],
            [4.718697435954359, -6.547867769806355],
            [4.713685968265794, -6.546105756273773],
            [4.712558858054589, -6.539424463995195],
            [4.705535629724672, -6.540116622848889],
            [4.709892452450171, -6.535292801840809],
            [4.708812003545865, -6.530979425615166],
            [4.7122500369537885, -6.528182466095939],
            [4.708805229753014, -6.524799600973525],
            [4.702713620944116, -6.532395516745793],
            [4.702010123163841, -6.535603043053394],
            [4.698211199125333, -6.53513999604939],
            [4.694332749463415, -6.531849403138763],
            [4.684762551018388, -6.53424030259797],
            [4.6721137118372456, -6.529592202492523],
            [4.668756572337985, -6.526380112330308],
            [4.65925552350586, -6.521682489633517],
            [4.654910311695903, -6.521769814007895],
            [4.6498362860984015, -6.518715354432691],
            [4.649431121156811, -6.512508215744361],
            [4.658356972014462, -6.5090567777839965],
            [4.664856751209292, -6.5011183971670805],
            [4.668936100009971, -6.492106744653405],
            [4.6705437965343215, -6.485822808021555],
            [4.670713511383526, -6.469913515371945],
            [4.659253496237957, -6.471711996234776],
            [4.652097774671201, -6.470384754803063],
            [4.637338153142359, -6.459152123302788],
            [4.630069734077798, -6.455628608164275],
            [4.623127379230787, -6.4534876866716955],
            [4.623129440797458, -6.463188253671032],
            [4.626212670523218, -6.470528086310934],
            [4.631594229645563, -6.476649609938137],
            [4.63298047155209, -6.483777767478725],
            [4.63102292968569, -6.489878993291239],
            [4.630408490768517, -6.50982429685256],
            [4.623217081205222, -6.507526495936554],
            [4.616645660682057, -6.503295258926098],
            [4.605955431350905, -6.501332338896348],
            [4.5975392521629965, -6.502152969230072],
            [4.589652215683666, -6.5050253537998515],
            [4.581457504602852, -6.511544145900135],
            [4.579257146269979, -6.510961765061905],
            [4.564474137202493, -6.5112342281995526],
            [4.553322156647742, -6.5076251709855],
            [4.54427107488949, -6.506231763349621],
            [4.537702030842639, -6.506113559222326],
            [4.535407350558063, -6.504633898960221],
            [4.529639810910162, -6.494966751381397],
            [4.5266947067431, -6.484388525377229],
            [4.526969697541596, -6.4751222087685845],
            [4.528544271608475, -6.462747942380836],
            [4.5305283249618435, -6.452538463431094],
            [4.533285488019805, -6.442145411369102],
            [4.5381928806817795, -6.436828480519177],
            [4.558149665856857, -6.424337299867842],
            [4.560987337627787, -6.423958704752278],
            [4.566292569871393, -6.426250573511069]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.85206888372021,
          "lat": 32.357274684743174
        },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28149"],
        "coty_name": ["Warren"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Warren County"],
        "coty_fp_code": "149",
        "coty_gnis_code": "00695795"
      },
      "bbox": [
        4.5266947067431, -6.549397459799821, 5.0285001903999955,
        -6.000056291402281
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5286924258064716, 10.296812886038017],
            [-1.441850791844028, 10.294386660577453],
            [-1.3542621482287032, 10.291887558719583],
            [-1.267170126010293, 10.289521290973946],
            [-1.1799852811413818, 10.287271006691245],
            [-1.0923564585606702, 10.28512872854042],
            [-1.0016937264946912, 10.283038329967738],
            [-0.9166173483572579, 10.281262231823225],
            [-0.8315414919619636, 10.27946117933685],
            [-0.8330483398109952, 10.228820442968207],
            [-0.8325986163384657, 10.20119906543458],
            [-0.8329656741542077, 10.180711549474626],
            [-0.835616656433894, 10.08894897513109],
            [-0.8363074300934378, 10.047743101320137],
            [-0.8365026162671383, 10.018427542255454],
            [-0.8369004467514166, 10.004390434507247],
            [-0.8223714186249593, 10.004087844174393],
            [-0.8220881390365529, 10.002968917071335],
            [-0.8237464042348331, 9.918667723660961],
            [-0.8254712577907113, 9.834025554328086],
            [-0.9130090224428277, 9.835978335143773],
            [-0.9996986711143412, 9.83787269747056],
            [-1.086965468813101, 9.840413378618372],
            [-1.1743189244306929, 9.84240824466173],
            [-1.2616918480487023, 9.844715076096836],
            [-1.3488397961719027, 9.847351495257485],
            [-1.4617401126254979, 9.850601983980335],
            [-1.5232339115338815, 9.852822807211215],
            [-1.520496701377929, 9.937452379342563],
            [-1.5178440108513793, 10.022135702498458],
            [-1.537530893039269, 10.02278376093651],
            [-1.536980416789692, 10.05098072591034],
            [-1.5350014145358357, 10.121386365891764],
            [-1.5322905468097725, 10.191099266367482],
            [-1.5324845593021148, 10.191796104449827],
            [-1.5307776571723684, 10.24103009979222],
            [-1.5286924258064716, 10.296812886038017]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.4648208540328, "lat": 48.772337308590174 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38019"],
        "coty_name": ["Cavalier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cavalier County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01035304"
      },
      "bbox": [
        -1.537530893039269, 9.834025554328086, -0.8220881390365529,
        10.296812886038017
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8164867673109171, 9.493784521193904],
            [-0.729438648582272, 9.492123446164259],
            [-0.6420043411650791, 9.490530697098853],
            [-0.5546790373901012, 9.489002903934129],
            [-0.46706729697813354, 9.487936678095558],
            [-0.3801340996232941, 9.485722085103221],
            [-0.3508987569104395, 9.485155475594688],
            [-0.3038966660806159, 9.484545786783038],
            [-0.30839658363976136, 9.47867432447358],
            [-0.30982634899462363, 9.474664838228065],
            [-0.30126564659711114, 9.472290392799463],
            [-0.3009032609186119, 9.46727104798015],
            [-0.30764289299549835, 9.46459398915466],
            [-0.3084124122131996, 9.463805398272827],
            [-0.3063311541723964, 9.454085072200632],
            [-0.3021554210033387, 9.451151357711076],
            [-0.2949886607263394, 9.454203606069937],
            [-0.29081870772954355, 9.452545641444317],
            [-0.29253484393942664, 9.448575534822787],
            [-0.3038128487301351, 9.442717300294605],
            [-0.3076459293068175, 9.437101306314068],
            [-0.30613455617769, 9.433067379975627],
            [-0.30229907327528355, 9.43521232933992],
            [-0.29472256704438127, 9.433444337646938],
            [-0.29239750812191345, 9.428966957158117],
            [-0.29672444644630425, 9.425266368855867],
            [-0.29600401386472347, 9.419441262460456],
            [-0.29161740310807815, 9.409356036577318],
            [-0.291304001517154, 9.404810453300197],
            [-0.2928280960969447, 9.39931881409259],
            [-0.2860905396539417, 9.398790691335162],
            [-0.2836429584136842, 9.397329563814395],
            [-0.28295395404577406, 9.392529905152239],
            [-0.27882763424504226, 9.3894210130059],
            [-0.2800586473401009, 9.386610215575127],
            [-0.28401413381867696, 9.384297308403713],
            [-0.278858095697079, 9.382014699414942],
            [-0.27730051478188567, 9.378829484274045],
            [-0.2780529066846726, 9.370589567607924],
            [-0.2803656585342578, 9.367804470728526],
            [-0.2796565094442859, 9.36495048301992],
            [-0.27610498233503933, 9.364333686794206],
            [-0.274388453856529, 9.360163123476408],
            [-0.2689818577538855, 9.351673267447135],
            [-0.2613963640317538, 9.346209786846456],
            [-0.2591672525845058, 9.341628321067864],
            [-0.25799313211499975, 9.33544790575077],
            [-0.2570038296293182, 9.321667792710718],
            [-0.2594790922213938, 9.313291884611862],
            [-0.25751874517104373, 9.310401639421984],
            [-0.25348830545428425, 9.309195331936035],
            [-0.2558913252522027, 9.303906619144566],
            [-0.2543458332741955, 9.293074352083993],
            [-0.25300325582753047, 9.290553819487195],
            [-0.24810307534286094, 9.287540031169373],
            [-0.24720774375883833, 9.282659539435597],
            [-0.25128674289298436, 9.269031029341997],
            [-0.2498404914088569, 9.265588788884497],
            [-0.2528199862168584, 9.258866531364218],
            [-0.24786755466262358, 9.254992951686885],
            [-0.246908747723774, 9.250185099228615],
            [-0.24870815493179155, 9.246288460226824],
            [-0.24835257273766, 9.241878565368205],
            [-0.241927099187115, 9.236716974608747],
            [-0.23593546759699208, 9.234987649507163],
            [-0.23687940146552833, 9.229024759938639],
            [-0.23583233061343783, 9.225977909013706],
            [-0.23174036229651493, 9.223387024702943],
            [-0.22378566632015853, 9.215664140957163],
            [-0.2278803777977575, 9.211888250179515],
            [-0.22351905237093925, 9.209099899905658],
            [-0.22209529505969222, 9.203306662227343],
            [-0.22826458686909668, 9.201511166952438],
            [-0.22566253650718304, 9.198447400524469],
            [-0.22891531100253648, 9.191430028562863],
            [-0.2249022032084708, 9.187567498772713],
            [-0.22900197485992338, 9.183497135554425],
            [-0.2293001440576591, 9.180953563354352],
            [-0.225287448423272, 9.176992793819558],
            [-0.22665446115285431, 9.16946453841429],
            [-0.215931268305995, 9.166999627889679],
            [-0.21339164853074866, 9.164230205998177],
            [-0.21613223525950276, 9.160927981764768],
            [-0.21117347155749908, 9.1558849444722],
            [-0.21081936008000163, 9.147149052069436],
            [-0.2074278416881719, 9.139458066667286],
            [-0.2078877766251374, 9.135304495806972],
            [-0.20364437055541798, 9.134994349890256],
            [-0.20036357913564937, 9.127888262653652],
            [-0.20212255286577846, 9.122853923621122],
            [-0.19938048545883832, 9.11999791307091],
            [-0.1996122894809973, 9.113417987030445],
            [-0.19799929696818638, 9.109439523581258],
            [-0.20362693697164003, 9.104921288144743],
            [-0.19887479800176497, 9.101996379521518],
            [-0.19543853409620912, 9.095755769787667],
            [-0.19079283638301212, 9.097834705592078],
            [-0.188411355623745, 9.092664403519587],
            [-0.18460434463681746, 9.090097725868718],
            [-0.1897453233447015, 9.083205782835861],
            [-0.1845345098740055, 9.082413703471351],
            [-0.18535081754100458, 9.078651082617661],
            [-0.18121536268260494, 9.078063069632744],
            [-0.18329511851038588, 9.07315420964411],
            [-0.1772675537998691, 9.07343085423467],
            [-0.1763777114836066, 9.07075685493046],
            [-0.16922756979516423, 9.064888777443132],
            [-0.17174681248642845, 9.060947035926477],
            [-0.16550959832346784, 9.049043983001763],
            [-0.16519330342003596, 9.04370070171916],
            [-0.16829280679059438, 9.038892249541504],
            [-0.16818335196796141, 9.036136106053165],
            [-0.163208065730496, 9.029316828694926],
            [-0.16229504209819057, 9.025291838599262],
            [-0.15928837276140653, 9.021711502340008],
            [-0.1669158625081499, 9.016927063277107],
            [-0.16394672199515195, 9.014404755793246],
            [-0.16125958268584833, 9.01723248142622],
            [-0.15909154482578058, 9.013784548621167],
            [-0.15984404486119694, 9.009820221286468],
            [-0.15487246218255396, 9.007748830669016],
            [-0.15503825359285983, 9.004221993241133],
            [-0.16039195480225898, 9.001017143945672],
            [-0.15843568523252724, 8.998865433873831],
            [-0.15411523553327838, 9.000085545928235],
            [-0.15128906006784543, 8.993648867237505],
            [-0.14596668394674173, 8.989182576407545],
            [-0.1438050963241947, 8.97819214747974],
            [-0.14432296301551908, 8.974734578900206],
            [-0.1376465899666373, 8.972019128929466],
            [-0.23249542356811112, 8.972973410143341],
            [-0.29747433140862845, 8.973776533368431],
            [-0.3624534201863579, 8.974566115557888],
            [-0.463672026696918, 8.97583709207383],
            [-0.5349357592720008, 8.976888991956685],
            [-0.6526916079371967, 8.978885064843757],
            [-0.7372583027717198, 8.980435078228838],
            [-0.7375814830023625, 8.980309577024082],
            [-0.812602534246605, 8.98185578338125],
            [-0.81126777874314, 9.052938268972307],
            [-0.809078243346373, 9.152202652798806],
            [-0.8076362196181343, 9.222664363486116],
            [-0.8056120165418773, 9.323368429133454],
            [-0.8201325629441775, 9.323705702775882],
            [-0.818593884036536, 9.394683652182477],
            [-0.8164867673109171, 9.493784521193904]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.45686136141137, "lat": 47.92189033765049 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38035"],
        "coty_name": ["Grand Forks"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grand Forks County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "01034218"
      },
      "bbox": [
        -0.8201325629441775, 8.972019128929466, -0.1376465899666373,
        9.493784521193904
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.178440596570235, 3.0420425651415504],
            [11.188759219399762, 3.0433433729587516],
            [11.239901006079304, 3.048803074145779],
            [11.290778270401486, 3.0539936547036715],
            [11.348020187215162, 3.060362530602199],
            [11.343090204393018, 3.1045468814429418],
            [11.338373623567989, 3.14237271018931],
            [11.355440258353191, 3.145086751752945],
            [11.381835729082296, 3.149363986383345],
            [11.461878877896426, 3.161456915518442],
            [11.496137934815104, 3.166440266821313],
            [11.501626386159446, 3.1675207424855256],
            [11.582528384509885, 3.180076032726013],
            [11.595875023754958, 3.0940871707040354],
            [11.609398354233017, 3.0078253927090826],
            [11.609633497263676, 3.0068734965277066],
            [11.622811263263145, 2.9211375249500935],
            [11.597689916748838, 2.9174513443871595],
            [11.53988517955264, 2.9094422318381414],
            [11.540708626574546, 2.902496186011478],
            [11.51218903986636, 2.8993903803534793],
            [11.520591225958139, 2.8262631869423522],
            [11.463583339068379, 2.8184387345223203],
            [11.46342642330903, 2.8187762759354564],
            [11.43405608745736, 2.8148578508274067],
            [11.36724204489034, 2.8056226316957997],
            [11.371080771716898, 2.8100299468992347],
            [11.374677035829304, 2.811331807348272],
            [11.372200964216605, 2.8159223476950164],
            [11.358862256385608, 2.817523700940289],
            [11.354915883364502, 2.8166926478971828],
            [11.35162683186449, 2.805535370571102],
            [11.350554951134157, 2.8043785889800135],
            [11.30082817900167, 2.7887535463236968],
            [11.28005232144801, 2.7823925105680796],
            [11.219821662750816, 2.7635762811950517],
            [11.214918077410045, 2.7967105792966347],
            [11.214096106456783, 2.796588724997718],
            [11.214190393480928, 2.796948502157573],
            [11.20457354376895, 2.862829547699598],
            [11.203054687771907, 2.877492935021545],
            [11.187456107570398, 2.9822590176279635],
            [11.178440596570235, 3.0420425651415504]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.36561500436201,
          "lat": 40.813909691585245
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39151"],
        "coty_name": ["Stark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Stark County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01065576"
      },
      "bbox": [
        11.178440596570235, 2.7635762811950517, 11.622811263263145,
        3.180076032726013
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7665048124750595, -3.2407761923956753],
            [-2.6664054709111316, -3.2451032571613845],
            [-2.551613635074094, -3.249801067581549],
            [-2.452955550127176, -3.2541709509404457],
            [-2.42387109577657, -3.2551323705952306],
            [-2.420483341690603, -3.167348658791984],
            [-2.405371016030138, -3.1680159346429075],
            [-2.349269661890807, -3.1699374989173656],
            [-2.249894681008745, -3.1736414610146726],
            [-2.2515078969855415, -3.21739711263464],
            [-2.255552760866436, -3.326737772254574],
            [-2.2582299671321246, -3.3997865329047214],
            [-2.2611059656142207, -3.479935652032956],
            [-2.257584629549827, -3.480063072406365],
            [-2.2607181064015136, -3.5683284815958864],
            [-2.3004711769049964, -3.5667245277030197],
            [-2.300563506827968, -3.569156979395025],
            [-2.3059982193706343, -3.5717252742656886],
            [-2.312456477919069, -3.5691854170070183],
            [-2.3181137294526732, -3.5748635982829957],
            [-2.3259708492010662, -3.573391352671779],
            [-2.328614304259263, -3.569820406438256],
            [-2.325726088863359, -3.5658853513926],
            [-2.3678067569213326, -3.5642037935133417],
            [-2.420349902554869, -3.5622731605313227],
            [-2.4224419064631832, -3.5624427720082337],
            [-2.545331156442529, -3.5575734981602585],
            [-2.603101379668157, -3.5552779648404567],
            [-2.60676611969042, -3.6426060311023787],
            [-2.692355272083685, -3.639380622974387],
            [-2.6923479559620027, -3.639004158214831],
            [-2.742072392759931, -3.6372871852498556],
            [-2.7831575443717487, -3.6355763544352535],
            [-2.7766748413309297, -3.4819172305871073],
            [-2.7716882205140982, -3.3636871077595902],
            [-2.7665048124750595, -3.2407761923956753]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.68198649686968, "lat": 35.26871227241242 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40009"],
        "coty_name": ["Beckham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Beckham County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01101792"
      },
      "bbox": [
        -2.7831575443717487, -3.6426060311023787, -2.249894681008745,
        -3.167348658791984
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8132980674193976, -4.219303302320638],
            [-0.7699992992998127, -4.220049406857453],
            [-0.6415461941676881, -4.2221710637208245],
            [-0.6423034492554364, -4.273298447246929],
            [-0.6433635475613991, -4.353447684328235],
            [-0.5791613938603091, -4.354364218019136],
            [-0.5009745708832005, -4.355309572972915],
            [-0.38638083541643126, -4.357153562517632],
            [-0.3827228486679109, -4.359999598095603],
            [-0.3863754135044814, -4.364432617298071],
            [-0.3866254079122662, -4.367964816039595],
            [-0.38377659463997144, -4.372355862757041],
            [-0.38412719151949065, -4.377608596605052],
            [-0.38117624398226063, -4.38252117276249],
            [-0.39030438844526966, -4.388367734925873],
            [-0.3878463483596953, -4.395498170763259],
            [-0.38069042584025575, -4.3982542665755675],
            [-0.3794461845797351, -4.400920953158657],
            [-0.3008897452600614, -4.401401989322817],
            [-0.30183672129546674, -4.488717313794279],
            [-0.30263389840547555, -4.561966441445644],
            [-0.3313025251265665, -4.561744790523338],
            [-0.3320531030479671, -4.6638767778162995],
            [-0.3333352511059196, -4.66384466789722],
            [-0.40393448893631834, -4.6631703112482725],
            [-0.4956817521895418, -4.6620608608121685],
            [-0.6001166169272842, -4.66061858978826],
            [-0.7417617035768282, -4.65845660434954],
            [-0.8192353955976907, -4.657266931805101],
            [-0.82053324701062, -4.657245676808041],
            [-0.818986236636182, -4.555033533653387],
            [-0.817062497718967, -4.438238819839236],
            [-0.8166804809565887, -4.4091092817187185],
            [-0.8150709244414389, -4.321681078110865],
            [-0.8132980674193976, -4.219303302320638]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.28575422285138, "lat": 34.25086232618066 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40019"],
        "coty_name": ["Carter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carter County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01101797"
      },
      "bbox": [
        -0.82053324701062, -4.6638767778162995, -0.3008897452600614,
        -4.219303302320638
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6929022236523971, -1.710281293741514],
            [-0.5983013872901003, -1.7114660282900322],
            [-0.529517860381884, -1.7123082823038829],
            [-0.444058004150235, -1.71326708824608],
            [-0.3510164455138082, -1.7145163170465478],
            [-0.275528116830386, -1.7151539253308234],
            [-0.22937361922681918, -1.7154289346652487],
            [-0.18705938335888558, -1.7158584715386338],
            [-0.1652382964735053, -1.7163691179013185],
            [-0.1627528074122127, -1.7160668945970696],
            [-0.1293588647100197, -1.71653143591407],
            [-0.12996850097985294, -1.774811792702462],
            [-0.13164984398457982, -1.774805576436895],
            [-0.13210088733576, -1.8175661566264614],
            [-0.13250379207763172, -1.873945977696758],
            [-0.13309905552464338, -1.9353890626912447],
            [-0.16187671191659128, -1.935242672854024],
            [-0.16202519346100483, -1.949781259019773],
            [-0.18892044313030962, -1.9495917529793412],
            [-0.18597272638946669, -1.9535505595912153],
            [-0.1854055530952534, -1.958270819489032],
            [-0.18835138915331706, -1.9672785488982745],
            [-0.1923319999202008, -1.971980561054486],
            [-0.19827261252564757, -1.9738499270315482],
            [-0.21374381337145587, -1.9710154355106915],
            [-0.22379497764519882, -1.9640306306280788],
            [-0.22810461184878356, -1.9632798532393578],
            [-0.23365557804802536, -1.9650390253441548],
            [-0.24143074589032062, -1.9650283279645766],
            [-0.25346804421388086, -1.978227444498016],
            [-0.25654405406092645, -1.9809811266879584],
            [-0.25846130096721676, -1.9897869424280172],
            [-0.2612464691242287, -1.9941798558395447],
            [-0.2674253521605862, -1.9997860232424085],
            [-0.2689097641270111, -2.014133149320079],
            [-0.27369581361282064, -2.02335742697535],
            [-0.2728684801282612, -2.0286739074095874],
            [-0.27649176068960346, -2.030982411539912],
            [-0.2858727332936515, -2.033121822317516],
            [-0.2909976140160008, -2.033324052371817],
            [-0.30437944879629036, -2.0282429957409702],
            [-0.3133695683125195, -2.028014821762621],
            [-0.32420468235887323, -2.0289872620998834],
            [-0.32709560483667816, -2.028339532515281],
            [-0.33287654557661484, -2.0229854698486345],
            [-0.3359935159181189, -2.024134094810502],
            [-0.3425425938298876, -2.021926346786153],
            [-0.34967872232284924, -2.022856835919752],
            [-0.3522938842100214, -2.0170226806270173],
            [-0.3547433125512727, -2.0145422081037667],
            [-0.36096020220139335, -2.01679534993572],
            [-0.37276052255020037, -2.0238095034981662],
            [-0.3814853855469099, -2.0317875905377285],
            [-0.3816544672244119, -2.0508509535845048],
            [-0.380179929123517, -2.065577551249504],
            [-0.3731194231933226, -2.0725161290922496],
            [-0.37157951604999173, -2.0790894781661264],
            [-0.37175846774792537, -2.0866406271683045],
            [-0.36981913206595934, -2.093439215906199],
            [-0.3724406225894471, -2.100431568045319],
            [-0.3724585609806908, -2.1056415679735436],
            [-0.36696324578371986, -2.1141661216481946],
            [-0.36877289921439815, -2.1194774147578808],
            [-0.3745288561807073, -2.118727763477953],
            [-0.3772968755267187, -2.1229799329518566],
            [-0.42920527014658405, -2.122236588912034],
            [-0.5277661662273918, -2.121071271864775],
            [-0.5564821125785281, -2.1208164909534135],
            [-0.6135836430674753, -2.11998632379851],
            [-0.6986030043471924, -2.118961545642294],
            [-0.6992838418947911, -2.1189611686825587],
            [-0.69864630719914, -2.0824641777459423],
            [-0.6969854403879655, -1.9765548236901067],
            [-0.6957845739942721, -1.8998948932791475],
            [-0.6954301030077024, -1.8706391808138525],
            [-0.6937496789266913, -1.767764593422249],
            [-0.6929022236523971, -1.710281293741514]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.14390613536726, "lat": 36.81800669099271 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40071"],
        "coty_name": ["Kay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kay County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01101823"
      },
      "bbox": [
        -0.6992838418947911, -2.1229799329518566, -0.1293588647100197,
        -1.710281293741514
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.3040650229709223, -2.539797136993468],
            [-1.2546894654023548, -2.541096938642896],
            [-1.2189037583200668, -2.541740532998681],
            [-1.2136584961667516, -2.5416929721205013],
            [-1.133539375628329, -2.543656352598262],
            [-1.104819621020744, -2.5442639971362517],
            [-1.1017448896502087, -2.544598635927426],
            [-1.0501454634895284, -2.5454694285211743],
            [-0.9681084092635839, -2.5471352694707794],
            [-0.9116694266039979, -2.5480504421787074],
            [-0.87641557775791, -2.5487602689718907],
            [-0.8767658290637735, -2.563618472607512],
            [-0.8779840507315949, -2.6413924844823264],
            [-0.8786179478169859, -2.6706342108848586],
            [-0.8801711481951123, -2.7585318848968616],
            [-0.880983547594621, -2.8170569686671287],
            [-0.8802773644241694, -2.8170724245280883],
            [-0.8816214138182772, -2.9105679386285677],
            [-0.8829409806541927, -2.9909393355124543],
            [-0.9758967834386798, -2.9895157905047887],
            [-1.0404506744371962, -2.987980268141542],
            [-1.1121467971507062, -2.986467339835644],
            [-1.1340095520947429, -2.986457639362102],
            [-1.2192663324159332, -2.9848876949220933],
            [-1.261644829483918, -2.984001671041784],
            [-1.275879552099588, -2.983902261002744],
            [-1.3117295952363421, -2.982984377558403],
            [-1.3098966539853292, -2.9100483659865506],
            [-1.3074550040959503, -2.8082573985862163],
            [-1.3099781834955397, -2.8082109295856523],
            [-1.3078984209998032, -2.713480629087258],
            [-1.3065530815741402, -2.6549777119136286],
            [-1.3040650229709223, -2.539797136993468]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.94209798136133, "lat": 35.94539136321654 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40073"],
        "coty_name": ["Kingfisher"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kingfisher County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01101824"
      },
      "bbox": [
        -1.3117295952363421, -2.9909393355124543, -0.87641557775791,
        -2.539797136993468
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1563506005578161, -4.578509252180204],
            [1.1606026221036587, -4.578596086946827],
            [1.1598379091557922, -4.491300918259292],
            [1.2457425000694986, -4.490449802398078],
            [1.2441791902471084, -4.338004022501591],
            [1.2438141610511266, -4.314002939983417],
            [1.2429466200418522, -4.225632704084794],
            [1.3321574570702421, -4.22466915552198],
            [1.45681347843574, -4.223195811713996],
            [1.547371280687954, -4.222005771839346],
            [1.7215870668980238, -4.219192257712347],
            [1.7204994057551528, -4.367907255589834],
            [1.7202754458358804, -4.3754243447936965],
            [1.7196371034448168, -4.478818445567999],
            [1.7192679774469948, -4.538132358347934],
            [1.7187188081083935, -4.625748148014833],
            [1.7182039703126344, -4.707217568745109],
            [1.7175504055174984, -4.772013556925688],
            [1.717518250644932, -4.788588341045163],
            [1.7172222310977812, -4.8482066712284295],
            [1.7167918155194735, -4.878486670733559],
            [1.715723336609005, -5.0135982536160535],
            [1.7156528312761063, -5.042523531473976],
            [1.7152137328270045, -5.067134909244435],
            [1.7153364813237575, -5.092739001057705],
            [1.7110364747711062, -5.0944465035267275],
            [1.714124861013874, -5.101715539573024],
            [1.7108885221497157, -5.105603262926602],
            [1.7056996320929203, -5.1067907183545636],
            [1.7001193286591927, -5.110220203054148],
            [1.6943775105293926, -5.107879113468309],
            [1.6894760636481556, -5.098300019112853],
            [1.6870545021364929, -5.101271180840348],
            [1.6889703797737818, -5.10809069297945],
            [1.687574882778432, -5.113029245073753],
            [1.6813777917365884, -5.115376385916251],
            [1.6748402057908336, -5.109371327311029],
            [1.6748765745430925, -5.106164389170798],
            [1.6880243825592114, -5.093873007313747],
            [1.6855674147198525, -5.090335371502962],
            [1.680884666299391, -5.089789747948418],
            [1.6697152115169192, -5.09479217550968],
            [1.6613166949086051, -5.102984427726394],
            [1.6508760464099579, -5.105375489757898],
            [1.6455535091551752, -5.101761428724044],
            [1.6471471406805571, -5.094457811019324],
            [1.6547977276243493, -5.089558970328441],
            [1.6659775990761638, -5.085118273710786],
            [1.668247191108336, -5.079883450721808],
            [1.6675704887644034, -5.075604550504792],
            [1.6622844050222199, -5.070678405243911],
            [1.653613491784761, -5.074531131072114],
            [1.6451176851460112, -5.079415656601041],
            [1.6392085796934095, -5.086195042325506],
            [1.6347431696991874, -5.08803129230061],
            [1.6284709209885835, -5.08634834106032],
            [1.6315787649181281, -5.0816701151198105],
            [1.6408739428606909, -5.072272201538994],
            [1.6510036014156615, -5.068834358839146],
            [1.653350157607647, -5.064878871197671],
            [1.65180442885475, -5.062520190415769],
            [1.646110413389702, -5.063010152108485],
            [1.6388738991906548, -5.0660080322713394],
            [1.637223992712602, -5.065545979459875],
            [1.6366800151440961, -5.052859370594541],
            [1.630974078625789, -5.045919259787744],
            [1.6281000308486755, -5.045558399719489],
            [1.6260001328743505, -5.048585566432051],
            [1.6286820668875857, -5.055957033998612],
            [1.6271354598927814, -5.058976966398233],
            [1.6262821274475, -5.066448561991828],
            [1.6181545233382846, -5.0689459263884995],
            [1.6142471360821466, -5.066484638600553],
            [1.6108504654011966, -5.06192069755709],
            [1.6094435221748917, -5.056419608424275],
            [1.605802800347581, -5.050881577056612],
            [1.6018581981301871, -5.049748607498043],
            [1.5970766604950712, -5.051177101660529],
            [1.5949337560058892, -5.058864674168031],
            [1.5892147670086552, -5.067840277180517],
            [1.5744912936705313, -5.07247579482931],
            [1.5684427742713796, -5.071639716415993],
            [1.563342771045462, -5.0684220819219385],
            [1.5618508144507015, -5.064403417674407],
            [1.5636193224333996, -5.060877060381174],
            [1.5693913127268957, -5.057530368034394],
            [1.578141743876816, -5.062137006698776],
            [1.582856931778259, -5.058947747474089],
            [1.5799249280404513, -5.048460842666089],
            [1.5827410732091374, -5.047096427032464],
            [1.5846008136151626, -5.042074039941583],
            [1.5882272163845612, -5.036522627065482],
            [1.5834549076699247, -5.030708435278901],
            [1.5799405647119444, -5.034448942271038],
            [1.581173328034386, -5.039783748384439],
            [1.5797905738203513, -5.045125437583858],
            [1.5764981206517243, -5.045298419906344],
            [1.569222745246628, -5.039468641870374],
            [1.5641213676233103, -5.038064006273271],
            [1.5609010509960415, -5.0394133498705935],
            [1.5559311554889248, -5.044986078021105],
            [1.5502723949619812, -5.0485450689557885],
            [1.5331575464709704, -5.045081642021635],
            [1.5242885426486135, -5.045337945275267],
            [1.5233187940194814, -5.044255279740837],
            [1.5269183911843132, -5.035620624192114],
            [1.5357226189387227, -5.035600690338234],
            [1.53601888837983, -5.029615204149433],
            [1.527990538583302, -5.024202083124146],
            [1.5142682529190812, -5.017714233488298],
            [1.5105945953634572, -5.017339669463752],
            [1.508539719744466, -5.01943709761815],
            [1.511542558530471, -5.026263857726236],
            [1.5197186958772706, -5.028685390715669],
            [1.5227774068126732, -5.031366664018153],
            [1.5238544038394344, -5.0380570606768345],
            [1.520511097429656, -5.0442307657730545],
            [1.5164850705697628, -5.0428768774226755],
            [1.5079920314785542, -5.041819901187545],
            [1.5028906829618336, -5.032256559772542],
            [1.4993856566103556, -5.030752184427442],
            [1.49446190185034, -5.028638510863748],
            [1.4933615208501956, -5.023296518056518],
            [1.5054428021145076, -5.018899107190039],
            [1.5101463527251406, -5.013283558716742],
            [1.5102230240475358, -5.009387009371962],
            [1.5080830563630319, -5.0067069779994045],
            [1.502632952751132, -5.006524157639946],
            [1.5008406117036968, -5.008423307198433],
            [1.5000002993666854, -5.015552065002981],
            [1.4983497065024445, -5.018197829245935],
            [1.4942567190160987, -5.019714520378548],
            [1.4899188511733739, -5.015423124151577],
            [1.4973271619708317, -5.008759494231186],
            [1.4946194378034627, -4.9997484016174845],
            [1.4921265621824866, -5.000119173552457],
            [1.4870846701925193, -5.00654304090383],
            [1.4767443520008572, -5.006543231426116],
            [1.4688530970843674, -5.00357361928453],
            [1.464152246359726, -4.998546689480449],
            [1.4729880360272365, -4.988519104362044],
            [1.4759210672599752, -4.987160796950542],
            [1.4858786175322884, -4.986748177525075],
            [1.4890855104192515, -4.983380710960814],
            [1.4895253248824598, -4.978649196901713],
            [1.4871249953425587, -4.97519501343431],
            [1.478473465903163, -4.97264649142725],
            [1.4748591505718223, -4.975530114305464],
            [1.4700437919690588, -4.988950169638844],
            [1.4578548573902568, -4.996346437905281],
            [1.4526258148300488, -5.001229117847903],
            [1.4452946130340945, -4.999276676886978],
            [1.4411414679750678, -4.994922898371617],
            [1.4436659010687616, -4.9886375383604555],
            [1.4442216638459335, -4.98312216365109],
            [1.440446533714623, -4.978824678354684],
            [1.440761229106129, -4.9706536857966155],
            [1.4387135627337788, -4.966362625475314],
            [1.4331579351875645, -4.965607279162454],
            [1.429260577604155, -4.970536639333643],
            [1.428707501478405, -4.976145383635701],
            [1.4352782267877007, -4.986656108608453],
            [1.4378744938981303, -4.99936779372042],
            [1.4359326951237923, -5.001509179166492],
            [1.4310769983679117, -4.999330146358877],
            [1.431259130867726, -4.995100112518835],
            [1.4290301522736246, -4.993782747151212],
            [1.4192551494831094, -4.994960659448016],
            [1.4137043551253874, -4.994887314941876],
            [1.4042724668439448, -4.992632213529167],
            [1.3926452377744871, -4.9855257385801615],
            [1.390617977341936, -4.982482800825261],
            [1.3919922430015799, -4.979757027009349],
            [1.3990402756146807, -4.972738994250257],
            [1.39954287369586, -4.968391535808489],
            [1.3977937906393347, -4.9656845516663735],
            [1.3930787167229512, -4.96429417447975],
            [1.3922111628447047, -4.967197766314061],
            [1.3931067183008203, -4.9740737568604985],
            [1.3910316595044008, -4.977274505565342],
            [1.3849022438918301, -4.971487625525183],
            [1.381614841562336, -4.965732337115021],
            [1.3733896375946093, -4.966005441529131],
            [1.3679910908226902, -4.961641786811848],
            [1.367966682195509, -4.957678831423165],
            [1.3619667828973836, -4.956558245421726],
            [1.353129069328918, -4.943394638388107],
            [1.353317288056586, -4.939056732355672],
            [1.3570009199588489, -4.926567421818889],
            [1.3606324730988006, -4.92616779096102],
            [1.362578527837536, -4.922380708224182],
            [1.360938613710624, -4.9143305640904655],
            [1.3586831235993846, -4.910322262805964],
            [1.352668023613193, -4.906086426400193],
            [1.349312294059653, -4.906367184658843],
            [1.349202391723461, -4.912311549675574],
            [1.3519130144337481, -4.919463613198119],
            [1.3502451300299592, -4.926285511407218],
            [1.338090953827641, -4.929431568846315],
            [1.3315598768804453, -4.926817007791044],
            [1.3268147030864745, -4.918720174451009],
            [1.3346600593317166, -4.90576090902524],
            [1.329954100591918, -4.901562997379717],
            [1.3176139087087613, -4.898197827981977],
            [1.3162629318338628, -4.886768413849585],
            [1.3136475105768828, -4.874255134086926],
            [1.3115407914925874, -4.87306626025198],
            [1.307631468633842, -4.875393024157894],
            [1.303227540912292, -4.883031993376386],
            [1.297605367910767, -4.884380692510446],
            [1.2941407805427547, -4.882956829464868],
            [1.2900869682226708, -4.87492287775359],
            [1.2863443254405187, -4.872404381508009],
            [1.2778581645789548, -4.877548951251007],
            [1.2573488665519637, -4.875512102304021],
            [1.2496096683706537, -4.873266001244592],
            [1.2472338537456702, -4.871033118619515],
            [1.2460350681877266, -4.866400325185411],
            [1.2461592015817864, -4.858311079299641],
            [1.2397374433538784, -4.848284821453574],
            [1.2380605117719974, -4.833920438447792],
            [1.2335326259030066, -4.832272310543895],
            [1.2279129263725372, -4.833190540053819],
            [1.229434319097976, -4.8274503101170945],
            [1.2331999576790023, -4.827111336536532],
            [1.235358189242855, -4.8225131796286504],
            [1.2308007116453092, -4.818201637808606],
            [1.2264385549464274, -4.820505025593496],
            [1.225640114804386, -4.826976189559985],
            [1.222629931893599, -4.832908438151167],
            [1.2213792116904691, -4.853776448023172],
            [1.2199009367613904, -4.856173859765275],
            [1.213959223941472, -4.85525202883839],
            [1.206196661908182, -4.845263885947642],
            [1.2051111841167346, -4.840032791841317],
            [1.207888620725251, -4.836394478972739],
            [1.2160838422353584, -4.8321843114549665],
            [1.2212116332499026, -4.828199638607196],
            [1.224527359470367, -4.820494441881459],
            [1.2231951812416542, -4.817176190495185],
            [1.219510935292591, -4.8141375701768325],
            [1.2140459838948068, -4.821774888059463],
            [1.201176012079156, -4.826522919415517],
            [1.194809388206946, -4.831594038501528],
            [1.1910596613772375, -4.8326166963319075],
            [1.1833630072983778, -4.829212979382191],
            [1.1793556447079847, -4.8240662623330675],
            [1.1789970981143647, -4.820270592334982],
            [1.1862034621223536, -4.811501287274848],
            [1.1874686540105586, -4.804852300494729],
            [1.1845419661309213, -4.801497751300383],
            [1.1792872772964103, -4.799286791734467],
            [1.1718851019701924, -4.801505460513916],
            [1.1588410238677964, -4.799502786458437],
            [1.1580876227337347, -4.793460033952166],
            [1.1580022465680302, -4.7609442543556],
            [1.15702709120002, -4.652271741841989],
            [1.1563506005578161, -4.578509252180204]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.77133192805965, "lat": 34.11544037049355 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40089"],
        "coty_name": ["McCurtain"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McCurtain County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01101835"
      },
      "bbox": [
        1.1563506005578161, -5.115376385916251, 1.7215870668980238,
        -4.219192257712347
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.017257177601145, 9.237168261664637],
            [-19.002376384821186, 9.232335224199941],
            [-18.98914840049908, 9.228592699814474],
            [-18.98888697860051, 9.229427345493068],
            [-18.95097064040507, 9.218047723813854],
            [-18.86593638355535, 9.191744910137567],
            [-18.82540776582656, 9.179410080182404],
            [-18.838736479629713, 9.138272961877396],
            [-18.83793978633824, 9.138051221042234],
            [-18.85344446463316, 9.087695545852801],
            [-18.86374037020004, 9.053796963370084],
            [-18.871532827164945, 9.029509007449143],
            [-18.906443654878622, 8.914168664511392],
            [-18.913601651560803, 8.89016237635011],
            [-18.8997535132601, 8.88598745644479],
            [-18.904811213068683, 8.869062029050832],
            [-18.835618234078975, 8.848589041905923],
            [-18.85584517283962, 8.782220184584865],
            [-18.851846305120105, 8.781018499299421],
            [-18.88211791426214, 8.680859282169047],
            [-18.883047332256947, 8.677182980680891],
            [-18.90114857015116, 8.615965206089738],
            [-18.901897969742645, 8.616186601811064],
            [-18.90885816690013, 8.59466040206691],
            [-18.91493049348222, 8.574153594523947],
            [-18.92189122806032, 8.57679228825549],
            [-18.963470980843066, 8.588335291903377],
            [-18.970243575209892, 8.591369958519024],
            [-18.998352119461707, 8.599133898756275],
            [-19.011047582164778, 8.557488535304138],
            [-19.008133661789838, 8.556612142697483],
            [-19.01628133754368, 8.528965375712227],
            [-19.029705579642012, 8.532839948030729],
            [-19.03380265427632, 8.518966680281347],
            [-19.062579438863885, 8.526246300313959],
            [-19.089933820861347, 8.534470209597364],
            [-19.098291820650836, 8.50658904235377],
            [-19.070215350523075, 8.499123437983153],
            [-19.07951081173784, 8.468096882430823],
            [-19.095544230466306, 8.472618357847773],
            [-19.18953193966318, 8.50021622737276],
            [-19.19275237436542, 8.501282003976328],
            [-19.19437097039501, 8.495987163769028],
            [-19.277886695033075, 8.520847370255566],
            [-19.278525028281297, 8.518878583909467],
            [-19.29216702540964, 8.524044423270153],
            [-19.31262004160702, 8.53111010920309],
            [-19.30922566943444, 8.536564137354434],
            [-19.310632845738986, 8.54035828015956],
            [-19.301413595157918, 8.555436537650769],
            [-19.298925431141374, 8.561134908980462],
            [-19.29711362088589, 8.569365472792198],
            [-19.287377035759125, 8.580464594417379],
            [-19.270655252807238, 8.615507448546229],
            [-19.256623402523527, 8.647137007779916],
            [-19.247097631812665, 8.670402551807365],
            [-19.23294944397294, 8.715406401577528],
            [-19.23109095765759, 8.724144294672351],
            [-19.22638287085156, 8.737432376717303],
            [-19.21190417950891, 8.764648462732652],
            [-19.186915559056295, 8.823978859147921],
            [-19.184063080807416, 8.835417902194873],
            [-19.18390596599413, 8.840483488267177],
            [-19.179314682747055, 8.848669249299752],
            [-19.178144388492903, 8.854146214546176],
            [-19.17540342549955, 8.858138634916052],
            [-19.163146883845787, 8.881740027968187],
            [-19.161283165713446, 8.892041251033318],
            [-19.162730462147593, 8.895664558758305],
            [-19.169705249345547, 8.89852775203556],
            [-19.172035530233103, 8.903385471521245],
            [-19.16691360507036, 8.902587646226658],
            [-19.162982225929387, 8.90676334326483],
            [-19.147550612104578, 8.936202852934564],
            [-19.14064488594803, 8.953925910136652],
            [-19.13929392796387, 8.963775067244068],
            [-19.142151739700655, 8.965673303315217],
            [-19.139579953334728, 8.972759414515822],
            [-19.140147877843475, 8.980108997060722],
            [-19.13833763767807, 8.98168870748744],
            [-19.138760986257953, 8.987127514080726],
            [-19.141993006956774, 8.991819486268179],
            [-19.134594038316248, 9.009920315947538],
            [-19.13325111528609, 9.01681236766669],
            [-19.126854866869117, 9.021644834957788],
            [-19.124150567099477, 9.021527371055818],
            [-19.12197440150207, 9.028023786017608],
            [-19.124407311573535, 9.030662651816993],
            [-19.1187442936902, 9.046017624366621],
            [-19.108062231211356, 9.050740212863529],
            [-19.101017309098932, 9.060798620520693],
            [-19.075040276019067, 9.105519221038561],
            [-19.062230082137862, 9.12995986496118],
            [-19.06016147802013, 9.137985958475738],
            [-19.055048635709234, 9.15017862703985],
            [-19.03961591155163, 9.179729326274034],
            [-19.025682105121778, 9.210486640176576],
            [-19.024294892006573, 9.217406510317286],
            [-19.024981081378403, 9.219975300674006],
            [-19.022483850950007, 9.226843146519537],
            [-19.017467036159914, 9.230224165093414],
            [-19.01557816386174, 9.234529851259932],
            [-19.017257177601145, 9.237168261664637]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.86822186776152,
          "lat": 44.641969704682715
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41041"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "01135856"
      },
      "bbox": [
        -19.31262004160702, 8.468096882430823, -18.82540776582656,
        9.237168261664637
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.37274028182926, 9.078265801151769],
            [-18.371960066406658, 9.081197430529482],
            [-18.364180129748455, 9.085142372992474],
            [-18.353712479386868, 9.087530728383928],
            [-18.344550708104734, 9.093672266745092],
            [-18.338018975018652, 9.09469715333503],
            [-18.331458414800338, 9.093222113621664],
            [-18.324704384470245, 9.095890358714307],
            [-18.32011882665326, 9.100382899421733],
            [-18.31469427879752, 9.102528889705354],
            [-18.311980206610016, 9.105220622121468],
            [-18.313655540808007, 9.11103823705347],
            [-18.317935307570952, 9.118474886462423],
            [-18.319324792044576, 9.126581359921845],
            [-18.326906050684425, 9.133459646005583],
            [-18.32837625887313, 9.139657001806793],
            [-18.32690544174349, 9.14606685100802],
            [-18.320893626424944, 9.152629887698337],
            [-18.314034938686614, 9.15183186491526],
            [-18.307740694744258, 9.14665328213216],
            [-18.301916350357335, 9.150018358294483],
            [-18.30183929577514, 9.153050428092142],
            [-18.30653542540896, 9.160259736035119],
            [-18.30825768913493, 9.164836977942198],
            [-18.307177320456763, 9.177114494627004],
            [-18.305115943680985, 9.18420785291988],
            [-18.306496906938854, 9.189494305726237],
            [-18.31024504284404, 9.191067717004588],
            [-18.319640423622822, 9.190665756950345],
            [-18.322117594105926, 9.19363213492002],
            [-18.322973156009418, 9.203734960465207],
            [-18.32040172967423, 9.207135271499967],
            [-18.311815463381336, 9.21210289703105],
            [-18.30252342852663, 9.210742877058697],
            [-18.290358577104904, 9.206115795172188],
            [-18.28415257890063, 9.206343943788246],
            [-18.28024820480381, 9.212011662301252],
            [-18.27801480730684, 9.217458935163734],
            [-18.278705456501175, 9.224355747398384],
            [-18.276589762541352, 9.237615317109794],
            [-18.27056383661988, 9.244321900762586],
            [-18.266322603626854, 9.246086703816362],
            [-18.256549957635876, 9.248021048912983],
            [-18.253259627924912, 9.250857489628826],
            [-18.251899906703414, 9.254551145524259],
            [-18.245663508767866, 9.25800649283037],
            [-18.243314583420993, 9.257136078885015],
            [-18.240494972098457, 9.249948000574326],
            [-18.23911204260154, 9.240451284603909],
            [-18.23691100104584, 9.237385294080601],
            [-18.221606518357355, 9.234168657264872],
            [-18.21491548414506, 9.230464758209747],
            [-18.207646363748584, 9.21790163072526],
            [-18.202973399700248, 9.217990127408074],
            [-18.194512063105417, 9.211772885673511],
            [-18.186839947008668, 9.208078079087745],
            [-18.180707195160977, 9.20811692551068],
            [-18.173307171577253, 9.211116349530005],
            [-18.170683887580374, 9.212103973413297],
            [-18.162455907178156, 9.218141526299883],
            [-18.15893429217532, 9.221769159759932],
            [-18.125375460470995, 9.212180490674228],
            [-18.129315119187062, 9.19838875886615],
            [-18.09839628987071, 9.189529223772666],
            [-18.109285612166047, 9.180036045406645],
            [-18.11187674574178, 9.17590542300323],
            [-18.111178042816142, 9.17124597430681],
            [-18.11314418203793, 9.168554391414627],
            [-18.11009749822166, 9.165350385508074],
            [-18.11408452354517, 9.162497052764273],
            [-18.113157418475975, 9.158435474676487],
            [-18.115342996709316, 9.154421976468521],
            [-18.11483924071129, 9.149406315440704],
            [-18.118172872752456, 9.145298577168768],
            [-18.12135161713461, 9.144893561963721],
            [-18.12788383983094, 9.140133664138832],
            [-18.122918506413946, 9.13448335903742],
            [-18.126814989438646, 9.127940800515502],
            [-18.128008800796742, 9.123917083991156],
            [-18.131708957533977, 9.11975611500188],
            [-18.135584684994754, 9.11336763306058],
            [-18.1346027047995, 9.110662459958807],
            [-18.140316814262775, 9.107298660860966],
            [-18.143822760132426, 9.10352440819166],
            [-18.148553903705302, 9.101043668167565],
            [-18.150209486633546, 9.097469156857755],
            [-18.160252760582587, 9.08820544387041],
            [-18.1605587159136, 9.082006830645836],
            [-18.163821670804516, 9.08104726440857],
            [-18.166492716796025, 9.076289121271042],
            [-18.166552360955876, 9.073247808842826],
            [-18.15620037848852, 9.056729124930142],
            [-18.151803456262503, 9.052861355132453],
            [-18.1469244959962, 9.042109650428563],
            [-18.1466789823241, 9.035385323381936],
            [-18.140801628647264, 9.029469963596046],
            [-18.137647538657482, 9.021860144896262],
            [-18.138208470782452, 9.019153997348663],
            [-18.135299337186503, 9.01500311572756],
            [-18.13707504566876, 9.01155655712898],
            [-18.136259706021093, 9.00523945454909],
            [-18.131112624399595, 8.998204876443543],
            [-18.131163646382728, 8.992878829194085],
            [-18.125432825022056, 8.985857492014741],
            [-18.11985201111183, 8.982604276966702],
            [-18.117327666811235, 8.979679665960573],
            [-18.11663417183513, 8.97537558178749],
            [-18.110567145898564, 8.973880718637705],
            [-18.10794120387437, 8.965007617406938],
            [-18.105973103667896, 8.961606854157747],
            [-18.100370638003003, 8.95997887998207],
            [-18.094543639442488, 8.953791011035412],
            [-18.089886672867248, 8.954888594074136],
            [-18.08634145652266, 8.948282096648677],
            [-18.08140603383702, 8.945447995120348],
            [-18.077400494948428, 8.941623914586827],
            [-18.076417212051833, 8.938784036842202],
            [-18.071655366271752, 8.937347331909809],
            [-18.067745980411043, 8.934010306557898],
            [-18.069404568272734, 8.92860150255678],
            [-18.06843792618097, 8.9266186499798],
            [-18.07281573394223, 8.910551732095708],
            [-18.07514855785246, 8.908488432570035],
            [-18.07417943037641, 8.904192858685814],
            [-18.06698279536224, 8.901668691583817],
            [-18.066418638565104, 8.899013625080006],
            [-18.060943823593245, 8.89666487850337],
            [-18.05889268529866, 8.893359680670336],
            [-18.05971333445078, 8.884678684726433],
            [-18.057744553484724, 8.881537869552675],
            [-18.058511126393775, 8.875373334698134],
            [-18.0550954390955, 8.866950442500265],
            [-18.055020844114036, 8.859180104535836],
            [-18.051775852912193, 8.856661891104999],
            [-18.051969580662387, 8.8534154964589],
            [-18.049979428680764, 8.846994285729208],
            [-18.04639210386535, 8.8408928135444],
            [-18.043853826869206, 8.841214745969179],
            [-18.0387750418316, 8.836432254291172],
            [-18.039020287164043, 8.831416329320382],
            [-18.037469221067735, 8.825594369305826],
            [-18.034454610032228, 8.820318755604601],
            [-18.03042685793638, 8.818612009358533],
            [-18.020261857217537, 8.820758731967123],
            [-18.01657540233283, 8.818592476550972],
            [-18.013914955464365, 8.814575336562859],
            [-18.008851329490263, 8.810134621862847],
            [-18.003489372488612, 8.808353383455549],
            [-17.99907205225219, 8.802126998790117],
            [-17.995018326791268, 8.794377227456902],
            [-17.98752256872345, 8.790276384121146],
            [-17.98221147840421, 8.790965542997743],
            [-17.97410372820296, 8.78770459524024],
            [-17.971777801885544, 8.788906789542382],
            [-17.96646964469217, 8.786448413662956],
            [-17.96460299613701, 8.783283427301013],
            [-17.96557255455056, 8.773428418771656],
            [-17.972509150642836, 8.769255333311222],
            [-17.87484405653624, 8.741809441266524],
            [-17.798091747350732, 8.720520582290442],
            [-17.72134387340021, 8.699214816293546],
            [-17.64460045817239, 8.677892149936747],
            [-17.56786152512469, 8.656552590000693],
            [-17.51846191248604, 8.642976192940674],
            [-17.518968943306017, 8.639352983018684],
            [-17.52477056248263, 8.635410019170452],
            [-17.52940726988712, 8.635368452562464],
            [-17.534907285646074, 8.625756982168184],
            [-17.537663529582506, 8.623487992965705],
            [-17.537721954586143, 8.618443901289963],
            [-17.532721285976802, 8.613633604429165],
            [-17.533939794256366, 8.607837873675187],
            [-17.539901513250303, 8.599184230927435],
            [-17.54621654670867, 8.593241595172774],
            [-17.554132300888202, 8.58998208349543],
            [-17.556879966219878, 8.586248562246025],
            [-17.568775397905412, 8.588172878798007],
            [-17.577443647943912, 8.584435461552852],
            [-17.58064155198439, 8.584285082551904],
            [-17.59154375128333, 8.586845875136726],
            [-17.591543807073098, 8.581502014743128],
            [-17.60011553546126, 8.577442821697154],
            [-17.60211499905031, 8.567366531483987],
            [-17.599380878144743, 8.559460087430285],
            [-17.596308739546107, 8.557909763248308],
            [-17.590418025846553, 8.550648634745201],
            [-17.59085345787145, 8.546832779415631],
            [-17.58659885949231, 8.546157794168064],
            [-17.583609390792976, 8.543819565173882],
            [-17.57918108344076, 8.546393209554143],
            [-17.574406918596544, 8.541582032472292],
            [-17.572407489510702, 8.535657179658536],
            [-17.569994970496293, 8.535382821791197],
            [-17.569096480356816, 8.530029057109521],
            [-17.57817176026583, 8.53009448276784],
            [-17.582027067642592, 8.52509705286632],
            [-17.588141338106535, 8.521450055749144],
            [-17.595022761254647, 8.520634082860578],
            [-17.603804196589532, 8.511939182972641],
            [-17.60401880923818, 8.509155168195731],
            [-17.607189931717436, 8.50634970383251],
            [-17.602387445164485, 8.501715595438364],
            [-17.606612480129716, 8.49120399373083],
            [-17.61146710596254, 8.489653717272912],
            [-17.612802229760135, 8.481916771999321],
            [-17.607295227001984, 8.46540962964718],
            [-17.61380715537891, 8.461685066862438],
            [-17.617203276073536, 8.462605485315473],
            [-17.72944773527049, 8.493579539999063],
            [-17.731434954012855, 8.495771957010954],
            [-17.73389934551513, 8.503086636417397],
            [-17.737995270212423, 8.505981241811165],
            [-17.752964524175553, 8.504081285694276],
            [-17.754957690700692, 8.506029209721568],
            [-17.75942077940799, 8.504811982938742],
            [-17.76309802458853, 8.509798111012804],
            [-17.77052453002885, 8.511214287502012],
            [-17.77623200265923, 8.508417767198189],
            [-17.77781686076484, 8.510553682177788],
            [-17.78434699975259, 8.513802849246382],
            [-17.78402078394953, 8.517371868855662],
            [-17.790110179021525, 8.520463200682508],
            [-17.790778462798166, 8.524148211133458],
            [-17.795693174648125, 8.524880268776679],
            [-17.802300607539607, 8.531024348887085],
            [-17.80553774483998, 8.529973576927237],
            [-17.808123310266964, 8.534229800328136],
            [-17.81637721587249, 8.541683489265253],
            [-17.822102017318816, 8.543297258724765],
            [-17.82452694647621, 8.546994812607803],
            [-17.82788233733237, 8.548825919038807],
            [-17.829988230070462, 8.555769418236137],
            [-17.834345907346815, 8.557864000152962],
            [-17.834661350838697, 8.561182642446786],
            [-17.837669539744606, 8.566177022248196],
            [-17.84459182512327, 8.569084872856344],
            [-17.847524231343282, 8.567975135555784],
            [-17.84983807003956, 8.563873790604076],
            [-17.85982015712758, 8.56052188414255],
            [-17.86356162623079, 8.56102244186717],
            [-17.870626497983505, 8.556664103912007],
            [-17.878127744864216, 8.555346437276546],
            [-17.883556220423213, 8.556043737855104],
            [-17.886954211214423, 8.55007598427933],
            [-17.88987690064481, 8.551937810993687],
            [-17.894669185787993, 8.552302419824155],
            [-17.900777041307496, 8.550925411132171],
            [-17.902575938707546, 8.554252928834682],
            [-17.90824048908479, 8.558397323637367],
            [-17.913028014336046, 8.57908024905247],
            [-17.91317118801824, 8.582723712701865],
            [-17.916790763828338, 8.585549599178394],
            [-17.917181869719812, 8.588956695039256],
            [-17.921612460235437, 8.59646420051017],
            [-17.92652091338318, 8.601667557098708],
            [-17.925489213216864, 8.607043038978816],
            [-17.92607471413225, 8.612487937816379],
            [-17.929069871903994, 8.617961157881323],
            [-17.934990163930646, 8.623067262067783],
            [-17.939868784408645, 8.624723217036493],
            [-17.947109088527704, 8.62876786114632],
            [-17.9503764782799, 8.632470401682333],
            [-17.956073724619213, 8.633911856607842],
            [-17.96308743742991, 8.632436698275246],
            [-17.97250028622323, 8.637790618434888],
            [-17.986911242683405, 8.6402718645092],
            [-17.993975717931175, 8.637629563380745],
            [-18.00205468419235, 8.642973033140498],
            [-18.00730127128328, 8.641800476735876],
            [-18.009208324469558, 8.644845190884952],
            [-18.014695691696712, 8.645955706962557],
            [-18.016959008132837, 8.644104345406944],
            [-18.02137233357189, 8.646911878710513],
            [-18.024571017423174, 8.645671747914346],
            [-18.031293041721035, 8.652395963197106],
            [-18.035634977309464, 8.650937258929783],
            [-18.0376379574378, 8.653028475332839],
            [-18.049467956837766, 8.656915220032106],
            [-18.058636870623303, 8.656005132945609],
            [-18.062100718483705, 8.66077580209782],
            [-18.074621805372026, 8.65939724409367],
            [-18.07946267468577, 8.659448470416736],
            [-18.084420155533337, 8.663869728450685],
            [-18.090058052974026, 8.6667222986329],
            [-18.08968673798201, 8.673551247141138],
            [-18.08830904999083, 8.676653752904318],
            [-18.093762964441765, 8.681056884798988],
            [-18.099682011508303, 8.680733405422485],
            [-18.104253983909707, 8.684604276650008],
            [-18.116136481645157, 8.68870592394312],
            [-18.119425103950476, 8.697352492995726],
            [-18.126163392011424, 8.700971502250336],
            [-18.137222380495654, 8.705108727789916],
            [-18.138754018718668, 8.70995408641982],
            [-18.14516737217207, 8.71776348008669],
            [-18.14846232761578, 8.719670873120373],
            [-18.15338453210826, 8.719667106962001],
            [-18.161778145102108, 8.721233524725184],
            [-18.16761688188131, 8.718100139423811],
            [-18.178078149250823, 8.71888949710692],
            [-18.18594032521147, 8.718343210840718],
            [-18.190417058892773, 8.719978446699905],
            [-18.195054019840295, 8.719408757056813],
            [-18.200733401819832, 8.720293999541004],
            [-18.214375457882703, 8.72906978443562],
            [-18.21592999189586, 8.739019531478274],
            [-18.219862257284966, 8.744032865408045],
            [-18.22218951224198, 8.741335230902928],
            [-18.227917047270022, 8.742587454472833],
            [-18.235700201158615, 8.743016445348118],
            [-18.242595281920046, 8.747575345477747],
            [-18.245943452616427, 8.751547602027998],
            [-18.254910758412247, 8.753523696242238],
            [-18.257391829792084, 8.756030238079255],
            [-18.26621013414928, 8.755658317506246],
            [-18.27005644963165, 8.756885236088783],
            [-18.277118341922773, 8.752490154677908],
            [-18.280155958703702, 8.75312827537098],
            [-18.28270815268706, 8.74806748818964],
            [-18.286973899473555, 8.747849391960347],
            [-18.292840084394424, 8.742843330733411],
            [-18.298249859297066, 8.742940289594834],
            [-18.302474994936162, 8.744479660507563],
            [-18.303957200138914, 8.748767166353494],
            [-18.30827553995522, 8.74823442776998],
            [-18.308754751623965, 8.74310498465118],
            [-18.311986570713337, 8.738622762137846],
            [-18.31725092716178, 8.73693250272903],
            [-18.328394574119, 8.738018369219109],
            [-18.332005692920095, 8.732866750815262],
            [-18.33761614965977, 8.73437300827843],
            [-18.343413594258827, 8.733552174841149],
            [-18.345847547909468, 8.730648098205132],
            [-18.34946889515946, 8.731512543892869],
            [-18.35258158104124, 8.728370469512678],
            [-18.359728852943366, 8.725709826529762],
            [-18.361285282285937, 8.72206770472621],
            [-18.369409328204142, 8.718627110881116],
            [-18.382440117046652, 8.710899898599962],
            [-18.38875310858201, 8.712406992505398],
            [-18.39106726733972, 8.715659770229587],
            [-18.39672961357266, 8.720497254717607],
            [-18.401990721470295, 8.716300898206446],
            [-18.40702481062983, 8.715220021055968],
            [-18.412161770603017, 8.709212526788535],
            [-18.41366257152091, 8.704148923115573],
            [-18.41599451166406, 8.701787780288251],
            [-18.422541120788072, 8.702590304551538],
            [-18.42571693087925, 8.700926779294207],
            [-18.428532894482217, 8.703835990651163],
            [-18.432245525359033, 8.702887948247872],
            [-18.432314285331422, 8.697660558164348],
            [-18.436108880853247, 8.698660773853266],
            [-18.44009398289887, 8.697720432066914],
            [-18.44428663159233, 8.70637962980639],
            [-18.444369942218547, 8.712840857174944],
            [-18.439432883869596, 8.720468847569844],
            [-18.437007356491453, 8.725718062687683],
            [-18.436581826274118, 8.732054348116781],
            [-18.438236323908868, 8.736888399956342],
            [-18.440903996700058, 8.737867345541254],
            [-18.449186650350335, 8.735073355296162],
            [-18.452952563386557, 8.741003204706848],
            [-18.452712904413666, 8.744781661665526],
            [-18.44916532203235, 8.748520144292037],
            [-18.44979833777487, 8.752836473425916],
            [-18.454981805322166, 8.755258446152707],
            [-18.459009220567864, 8.754920732314526],
            [-18.462922887840307, 8.757946107862606],
            [-18.46046011850851, 8.763439055865565],
            [-18.46054591801832, 8.766723304288357],
            [-18.46370412441185, 8.767690606078233],
            [-18.47149797098127, 8.765209883331254],
            [-18.47495433870914, 8.766044225754902],
            [-18.48143481613065, 8.772262709874832],
            [-18.486839982388116, 8.772547748911315],
            [-18.48992506956164, 8.776533122685985],
            [-18.491062575399173, 8.786916323653848],
            [-18.496090625941843, 8.787750453947996],
            [-18.500544046237213, 8.781725358051137],
            [-18.508153994477695, 8.784710318988221],
            [-18.515864889514695, 8.783650243108502],
            [-18.517863685154808, 8.78684330098006],
            [-18.515625614207366, 8.795617728478948],
            [-18.511186488844142, 8.804290613112896],
            [-18.504218693889417, 8.80747065314873],
            [-18.499705139652406, 8.81090269036268],
            [-18.497440398225553, 8.815443003998626],
            [-18.491455495425832, 8.82098858318148],
            [-18.488400011343337, 8.821973232614116],
            [-18.473789220653796, 8.821626531839431],
            [-18.468485161988426, 8.823500799251951],
            [-18.464101478074415, 8.82862923923361],
            [-18.463161431021433, 8.835571647775764],
            [-18.473281578182082, 8.846391196563928],
            [-18.477811028257854, 8.848850906450403],
            [-18.4821347822159, 8.853483636589562],
            [-18.485746190200643, 8.854943400191956],
            [-18.494216900982728, 8.856285201914984],
            [-18.49764045027333, 8.858421558731068],
            [-18.500183659844772, 8.862989969812235],
            [-18.50870752567877, 8.863931475245737],
            [-18.513933025901277, 8.867899211226128],
            [-18.51551520784557, 8.87321786821636],
            [-18.51030320612169, 8.894047875548377],
            [-18.50283622267799, 8.89886022869934],
            [-18.50077110905394, 8.898396685896298],
            [-18.492381108301423, 8.891454629748445],
            [-18.4879328147242, 8.891447926749365],
            [-18.480396031097914, 8.905816007623015],
            [-18.476212635996077, 8.911239009516825],
            [-18.46988258232747, 8.915207201652366],
            [-18.463740627190635, 8.92514297086576],
            [-18.458018040503884, 8.932293148059298],
            [-18.444505641556102, 8.93686562544936],
            [-18.442565066365994, 8.9392233770266],
            [-18.444488146561252, 8.945631345539944],
            [-18.441374263784017, 8.949730583189462],
            [-18.42906677269524, 8.945583336209685],
            [-18.424284074075825, 8.940972421108421],
            [-18.416181913825135, 8.939690271964002],
            [-18.41233442585459, 8.942718477413052],
            [-18.4014385856188, 8.948309509966787],
            [-18.39332136580447, 8.94960949358828],
            [-18.390226692865053, 8.95271764224098],
            [-18.38555392927549, 8.960083114669606],
            [-18.38482708761907, 8.964597548392968],
            [-18.381749494695402, 8.970174571744527],
            [-18.377655733060056, 8.985723931547735],
            [-18.378080120826198, 8.99047233996487],
            [-18.381957247946918, 8.994568376144263],
            [-18.391531399393813, 8.995394808632014],
            [-18.394475691528392, 8.997853604295285],
            [-18.393808469715253, 9.01639387473598],
            [-18.394667576240057, 9.022429254164637],
            [-18.388559356555422, 9.037974140981026],
            [-18.382604160124508, 9.046739578407129],
            [-18.380732743168476, 9.052556171711013],
            [-18.373594543209126, 9.070011313016007],
            [-18.37274028182926, 9.078265801151769]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -122.58464044605287, "lat": 44.9033655431895 },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41047"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01135859"
      },
      "bbox": [
        -18.517863685154808, 8.461685066862438, -17.51846191248604,
        9.25800649283037
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.822065622647235, 3.940912112196193],
            [14.856916270255944, 3.950269815893371],
            [14.897163511442724, 4.016561375131406],
            [14.909211524986127, 4.039188226350342],
            [14.931236295280405, 4.075597160039782],
            [14.938626289174463, 4.088208176798117],
            [14.96080760779566, 4.126508027460941],
            [14.967372806041553, 4.12794849934416],
            [15.031677020391951, 4.1431551844465915],
            [15.03150789237188, 4.14183660549141],
            [15.044129771079866, 4.0480211295787],
            [15.046293152057572, 4.041311519417705],
            [15.06775425537594, 4.0084576989045875],
            [15.092700374547931, 3.9726389318593482],
            [15.112212057608875, 3.9800979615524117],
            [15.12670367177551, 3.986646619360317],
            [15.144731604545745, 3.9032341255966063],
            [15.143425224562264, 3.899494368775935],
            [15.16152789274093, 3.851717310241021],
            [15.181500845482693, 3.804157404154208],
            [15.15790456147546, 3.764277001738515],
            [15.138964554781268, 3.7271788335113465],
            [15.13937978870603, 3.6431638217354134],
            [15.091083868682757, 3.6059376996593806],
            [15.07745125303072, 3.625750918740577],
            [15.070919122608897, 3.63612469326317],
            [15.056208324232632, 3.658341432293836],
            [15.047517322739003, 3.6564351149338488],
            [15.042927024558896, 3.65426388875209],
            [15.022822281504217, 3.647961434668412],
            [15.01612951891222, 3.644231933086568],
            [15.002049001529993, 3.6396963645992946],
            [14.994305731170714, 3.6355926132366823],
            [14.991819244629237, 3.63596854633426],
            [14.989681983549502, 3.6426539702518275],
            [14.983510006443373, 3.6520954530155922],
            [14.982555946889503, 3.656529400081329],
            [14.988277425965247, 3.6614766242316517],
            [14.988435328136338, 3.665396154226358],
            [14.983568750234303, 3.672294565879264],
            [14.97923037293528, 3.67373753742085],
            [14.976033006796456, 3.6832789248232403],
            [14.97912122270076, 3.6883841810939098],
            [14.976194556461703, 3.6924421801153957],
            [14.960537515574561, 3.688940868242772],
            [14.956021049297693, 3.722253908591092],
            [14.952909010674928, 3.7248820158631326],
            [14.95654791944226, 3.7293592157056454],
            [14.957291429894745, 3.7335124673245517],
            [14.955056913415243, 3.7382072735753784],
            [14.95149263042534, 3.740462900254467],
            [14.947729437225812, 3.745413184488991],
            [14.958955420082615, 3.7538659205901777],
            [14.955680263433585, 3.757195507088235],
            [14.955199924866132, 3.7640308621799554],
            [14.941261214461617, 3.7779094734407757],
            [14.909204915742936, 3.798804701788051],
            [14.906714142349546, 3.807251158615572],
            [14.906134181846557, 3.822399431933141],
            [14.904357236311196, 3.8330942626399627],
            [14.894750756201654, 3.851189412242375],
            [14.856781826627827, 3.853616436816846],
            [14.85791016782744, 3.858974231780941],
            [14.856000347189225, 3.8633106119140503],
            [14.856245583625169, 3.8695307861119126],
            [14.851388963823505, 3.8741588971897616],
            [14.850253467465475, 3.878827475002833],
            [14.822065622647235, 3.940912112196193]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.40518144359646, "lat": 41.0485920882919 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42037"],
        "coty_name": ["Columbia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbia County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01213665"
      },
      "bbox": [
        14.822065622647235, 3.6059376996593806, 15.181500845482693,
        4.1431551844465915
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.993613409366365, 3.068378304826229],
            [15.997293242319508, 3.0666805613016077],
            [16.004959992942652, 3.0578374827509736],
            [16.03425252294532, 3.026436422720163],
            [16.04033634336221, 3.031489117366793],
            [16.059125549051604, 3.0119724575421816],
            [16.067595677576257, 3.0041171617833013],
            [16.075586823550925, 2.995052925445875],
            [16.073216927178052, 2.99246931533978],
            [16.078005451977905, 2.9879660639198904],
            [16.08176117022724, 2.987852703871557],
            [16.086322832245017, 2.9853496667792423],
            [16.08976755116221, 2.9872024559982084],
            [16.099476736345384, 2.987041809097905],
            [16.100338986342443, 2.979834238126066],
            [16.099477255018222, 2.974708812203475],
            [16.101686425471073, 2.969874526665064],
            [16.10475543102345, 2.966883533834523],
            [16.10996740905999, 2.966755440746382],
            [16.111462137331745, 2.962821027737952],
            [16.115284203024924, 2.9619071437272715],
            [16.114116429596447, 2.9577179375581455],
            [16.109984944532535, 2.9561641145701354],
            [16.11050472356861, 2.950438118576749],
            [16.108958330865235, 2.9454063524033187],
            [16.111150372542806, 2.937498780398352],
            [16.108732267409923, 2.9333217446498687],
            [16.11012258787631, 2.9277988047523715],
            [16.106931267894147, 2.914737158072652],
            [16.103603925070818, 2.9085348473366506],
            [16.10786390946274, 2.898554201190317],
            [16.118345678173256, 2.900797579889779],
            [16.125153020168952, 2.898069098110286],
            [16.128815620574528, 2.9038370335271346],
            [16.139841850436685, 2.9045256294849016],
            [16.142713615762112, 2.905790725349188],
            [16.14356688758557, 2.900846381774176],
            [16.147814449500622, 2.8975935553826284],
            [16.141703820990443, 2.890549535005842],
            [16.132643738609776, 2.883449533227624],
            [16.126843458948976, 2.8800821146906923],
            [16.106725965854537, 2.869940462750889],
            [16.091021929716398, 2.8661484638145613],
            [16.078612320484453, 2.864848017658004],
            [16.063447642148013, 2.860294808458113],
            [16.055668009635635, 2.855553746404493],
            [16.047623142825895, 2.8474158654231867],
            [16.037344374621394, 2.8324491607761395],
            [16.026118631665565, 2.817281439327005],
            [16.01799966067705, 2.807444267883387],
            [16.010794285063273, 2.800087211570629],
            [16.003565619720938, 2.8033459683329247],
            [15.99956677894234, 2.8051481071562496],
            [15.978057287318082, 2.8118834717931063],
            [15.97016350678806, 2.8137646389563633],
            [15.955712049359866, 2.8160674660286866],
            [15.94172259824918, 2.8173388565991604],
            [15.926506894780353, 2.8171053429607564],
            [15.910561735835715, 2.8155816410046755],
            [15.887260980625543, 2.811318042434794],
            [15.880351740696725, 2.8093114427323735],
            [15.874231330024912, 2.8139834381427065],
            [15.872451921299785, 2.812429898313195],
            [15.870772808503274, 2.8061701252820477],
            [15.869507486899623, 2.8056736644871765],
            [15.866524568238791, 2.8090073346568905],
            [15.867856354155595, 2.8131683779278434],
            [15.868345973156423, 2.821153218012095],
            [15.862978863683342, 2.8217021436358363],
            [15.860421665805228, 2.823449134620859],
            [15.86282546880606, 2.8307177282700526],
            [15.863797147673685, 2.8376404812792906],
            [15.85923408135185, 2.841792758778532],
            [15.876166591076085, 2.859587544914035],
            [15.873006057161412, 2.8630428136736894],
            [15.872740284368598, 2.8673633753385226],
            [15.881786169955458, 2.8761320357928906],
            [15.889893147697906, 2.8848623220307417],
            [15.8857743806762, 2.8893281979976075],
            [15.89093303027191, 2.894050945252971],
            [15.88844746574587, 2.898650334038751],
            [15.888865783649573, 2.902641540645654],
            [15.893191860284563, 2.9064183444891407],
            [15.899232785996743, 2.899687377732515],
            [15.904011262608806, 2.9017829375532944],
            [15.896916057344626, 2.909422250228246],
            [15.901418357282868, 2.9099386860934993],
            [15.904940451337179, 2.9133590937834857],
            [15.903541442224798, 2.9179963741566346],
            [15.89925367521314, 2.9223911821349833],
            [15.913131227151464, 2.9359939235153263],
            [15.938803275233498, 2.9605382153912307],
            [15.955532559531909, 2.9768398036869326],
            [15.955006684469184, 2.980730031547417],
            [15.94841108900452, 2.984315815172253],
            [15.940524457993398, 2.982462940869302],
            [15.969848516043792, 3.023752040630471],
            [15.958826166307873, 3.0362116504212002],
            [15.993613409366365, 3.068378304826229]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.3988981827604, "lat": 39.91671998010355 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42045"],
        "coty_name": ["Delaware"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delaware County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01209177"
      },
      "bbox": [
        15.85923408135185, 2.800087211570629, 16.147814449500622,
        3.068378304826229
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.000156221251483, 4.450577724658094],
            [13.032301213213584, 4.455829739097817],
            [13.122939027583389, 4.472912910806083],
            [13.233718185740868, 4.495077679568177],
            [13.289504899970403, 4.505274185201207],
            [13.386656650535492, 4.5231419180874655],
            [13.443081214722634, 4.533583855818049],
            [13.469938790318691, 4.538174668966248],
            [13.516815197403123, 4.547681282771006],
            [13.533200284708043, 4.4622729015239155],
            [13.538214461054555, 4.43456136168316],
            [13.551425354678821, 4.369022524587352],
            [13.567651760587536, 4.288188810515658],
            [13.590442584722497, 4.171030570226735],
            [13.501077193101121, 4.154039654395157],
            [13.43213112221441, 4.140979902122874],
            [13.435240610477699, 4.1258041011004405],
            [13.38962836344314, 4.117773755224741],
            [13.383584588891402, 4.146451794532186],
            [13.244589188117514, 4.114101793247684],
            [13.191924777526637, 4.104599674238908],
            [13.143135775581229, 4.094786685528632],
            [13.143003178313677, 4.093156387147012],
            [13.040461027743326, 4.075208528978541],
            [13.03849395416717, 4.092125297875249],
            [13.030530840791867, 4.138866796192571],
            [13.023333971700772, 4.18691869514667],
            [13.020709785279031, 4.2025406400527485],
            [13.008713461803458, 4.281005500815654],
            [13.028433304785155, 4.2850219111165355],
            [13.026540595058561, 4.294850980613396],
            [13.030832694175455, 4.295642881888421],
            [13.026802444597577, 4.3162665537947],
            [13.026034835878566, 4.316136659509462],
            [13.010756779046925, 4.4063898936703865],
            [13.008592569558367, 4.405989654559512],
            [13.000156221251483, 4.450577724658094]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.5690128645486, "lat": 41.807648067674194 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42083"],
        "coty_name": ["McKean"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McKean County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01210235"
      },
      "bbox": [
        13.000156221251483, 4.075208528978541, 13.590442584722497,
        4.547681282771006
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.30038906363955, 3.809510812597334],
            [12.299494581707325, 3.8204756986822295],
            [12.311505991941775, 3.821689643502116],
            [12.309896285382798, 3.8344178689916597],
            [12.3217705386607, 3.8364062548664624],
            [12.32689445432115, 3.838057528866975],
            [12.324141318888737, 3.8496414595776023],
            [12.336578198690018, 3.8516631494640863],
            [12.333679218928923, 3.863908209540002],
            [12.348331722974681, 3.866157514148963],
            [12.344706837987284, 3.8784037991648668],
            [12.35635485267115, 3.880329083172997],
            [12.354946264880468, 3.892353985421808],
            [12.366547080541153, 3.89432734765386],
            [12.36453096506273, 3.9061921730892637],
            [12.381122373583786, 3.9091459631839403],
            [12.377774786569502, 3.9156085153188487],
            [12.393558512300098, 3.9243303016391318],
            [12.392059363613765, 3.9349956399093737],
            [12.405890862172047, 3.94163743738925],
            [12.402905474570522, 3.961644451032088],
            [12.44752450301796, 3.9681691356188327],
            [12.448071259344166, 3.9649541530555723],
            [12.462888496839916, 3.967708049771918],
            [12.50685761006161, 3.974596892534939],
            [12.534907861686527, 3.9794754299604143],
            [12.561662080268523, 3.9837322881658546],
            [12.560471862981228, 3.990662622033346],
            [12.634217914836224, 4.004224246421085],
            [12.655357191705976, 3.8873537597870635],
            [12.661779113782423, 3.8464302175606986],
            [12.654643370403559, 3.8451615267718404],
            [12.65924290074394, 3.820785337594675],
            [12.691138643505198, 3.825937687565257],
            [12.700741883431625, 3.772836203040504],
            [12.7093597597811, 3.7225006890265853],
            [12.662879225262841, 3.7146196277156003],
            [12.665442194843447, 3.6998082382864346],
            [12.619350023690775, 3.6922581020975955],
            [12.62670371120715, 3.6481942935261253],
            [12.609827139925569, 3.645375186554986],
            [12.611481501674632, 3.635169514501178],
            [12.607818082274225, 3.6345457685734157],
            [12.609997700735645, 3.6213226914285706],
            [12.597106205341214, 3.619198503200595],
            [12.60384634531498, 3.5838130613052748],
            [12.592930911821878, 3.562685075724428],
            [12.59512143593328, 3.5604257157844503],
            [12.592683015676595, 3.5566078376459704],
            [12.597255257028083, 3.553169925448598],
            [12.594464001101258, 3.5481113230615535],
            [12.590038852435809, 3.547720875415553],
            [12.587611236930401, 3.545575798866654],
            [12.584044656331733, 3.5458255638545233],
            [12.580224072351738, 3.5424553215979024],
            [12.574570702590751, 3.5447403506124258],
            [12.572802116461004, 3.541637568091498],
            [12.573758492133672, 3.5348424541230656],
            [12.578253632593073, 3.5333791222780393],
            [12.510762588128756, 3.521841587148752],
            [12.482928908489303, 3.517223963487258],
            [12.405482676527477, 3.5027474217795858],
            [12.383669715041657, 3.498771831341931],
            [12.354126731562385, 3.4939650990687854],
            [12.349831239006468, 3.521437408842091],
            [12.347163154588895, 3.534861168905182],
            [12.336843967832856, 3.59545648160192],
            [12.320723792608955, 3.6901190819011016],
            [12.30038906363955, 3.809510812597334]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.75797351857223, "lat": 41.40098912023209 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42121"],
        "coty_name": ["Venango"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Venango County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "01213690"
      },
      "bbox": [
        12.299494581707325, 3.4939650990687854, 12.7093597597811,
        4.004224246421085
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.674547301066793, 2.7951494280633185],
            [14.735521728956313, 2.882495638764834],
            [14.739688227632056, 2.888247874183826],
            [14.744610155058933, 2.8872704035156542],
            [14.746393159181174, 2.8901961508812875],
            [14.753481959754193, 2.8923471593245855],
            [14.757672042577456, 2.897616106597459],
            [14.769424923533977, 2.9018664088434063],
            [14.775838832666983, 2.8999799213733626],
            [14.778747022847595, 2.9017999962989443],
            [14.779531629287206, 2.907619690218504],
            [14.772891735439043, 2.9081509668752243],
            [14.774012764636394, 2.912718349700556],
            [14.77802032011812, 2.9116918221779184],
            [14.78270314208639, 2.9123478828517557],
            [14.79361437610469, 2.917772057422577],
            [14.80286944242593, 2.918043101734144],
            [14.81102305188241, 2.916624096054971],
            [14.827477280871477, 2.924739187559149],
            [14.825317432674918, 2.927857177316644],
            [14.812156244986241, 2.933115752231573],
            [14.807088962372475, 2.938991591949622],
            [14.807450177662751, 2.943875490291409],
            [14.81250844904633, 2.9428404173422873],
            [14.815796604906103, 2.9401799343522517],
            [14.819043510555971, 2.9425295759740977],
            [14.816329144225765, 2.9505202759546845],
            [14.811359701263326, 2.95477935629553],
            [14.803590328990598, 2.951701517139938],
            [14.807199592489699, 2.9651384550092925],
            [14.810456441151176, 2.9667546131434213],
            [14.812565969746219, 2.9628696200093554],
            [14.818094904360397, 2.9677574423503286],
            [14.822860244958441, 2.973901341637282],
            [14.81811227968629, 2.979590842998614],
            [14.822110831433918, 2.984067168293446],
            [14.827704125393947, 2.9761858134191725],
            [14.832667342027854, 2.97524017927367],
            [14.836226237716822, 2.979905576047432],
            [14.841890236904408, 2.9787968589494422],
            [14.84626252298024, 2.980174214748234],
            [14.849934285619076, 2.9841960519756516],
            [14.84844748516473, 2.9873586900686426],
            [14.84990446468132, 2.9914371543980423],
            [14.865354453339622, 2.989741794005857],
            [14.869564717332457, 2.986844237797027],
            [14.87657471598929, 2.9749649061067],
            [14.882673163346674, 2.9724287022256237],
            [14.898535154432489, 2.9744038662631107],
            [14.909848292341639, 2.9679127368931284],
            [14.921486719591492, 2.962623064867168],
            [14.931062499133791, 2.9591134779348764],
            [14.939554304896099, 2.9572240359621724],
            [14.942345670531628, 2.9526004197766125],
            [14.94633956053357, 2.938573849434735],
            [14.950058409035693, 2.9294214599667385],
            [14.953620912609503, 2.916868632356079],
            [14.957716043651667, 2.912224283198217],
            [14.964629238642386, 2.9083467373291083],
            [14.97335905678566, 2.9074005236773575],
            [14.982559019661172, 2.9028839133860935],
            [14.985478276564153, 2.900173948686138],
            [14.995072542418479, 2.893777366851522],
            [15.004317683603654, 2.885195236074451],
            [15.0114462752835, 2.877287263283374],
            [15.017058134070757, 2.868568171518242],
            [15.027846045032577, 2.860119972049684],
            [15.036805280439127, 2.858205176676023],
            [15.04324679242472, 2.857986717759809],
            [15.049647435033622, 2.859610777720055],
            [15.061689329295804, 2.8583556234344507],
            [15.067112751314427, 2.859216508709294],
            [15.080752522208213, 2.858986169932544],
            [15.086652856525003, 2.8579411546887337],
            [15.100223662244103, 2.8569991277673767],
            [15.112873991211595, 2.8607066314488594],
            [15.121229381390716, 2.8668773504044998],
            [15.126313262189838, 2.868251980483413],
            [15.129586073900944, 2.8635875291147084],
            [15.130755202521803, 2.8556722245070207],
            [15.13713137353558, 2.8445869116565534],
            [15.143290960214213, 2.83952833936991],
            [15.149345365665225, 2.83602537217619],
            [15.153449492824514, 2.8307267485801564],
            [15.16192768572911, 2.823429836467293],
            [15.164161789632782, 2.8200942261370234],
            [15.170873530067368, 2.800069741770703],
            [15.179672122955939, 2.787492371457896],
            [15.187262797647218, 2.78153262538937],
            [15.192983137410433, 2.7750409139265084],
            [15.198333590458956, 2.7717240971948285],
            [15.204525239802342, 2.7711611180521176],
            [15.21396802013192, 2.7660111989376994],
            [15.228898747322518, 2.763531915525654],
            [15.235666069002347, 2.761777414800713],
            [15.25053023055157, 2.7541328273141636],
            [15.25821121730384, 2.754309369214802],
            [15.26216002050475, 2.752810358217972],
            [15.267080744936754, 2.7476052472304717],
            [15.270874567728676, 2.735956193317431],
            [15.275530828334489, 2.7295330734668886],
            [15.275424341713183, 2.7219149087542864],
            [15.27729513955343, 2.7167598839157936],
            [15.281960353513313, 2.709462034142167],
            [15.288267968483453, 2.705381670844059],
            [15.294891261188315, 2.7033227713516235],
            [15.305080904268543, 2.6951935202458968],
            [15.307175456379765, 2.6860176247874614],
            [15.316591813972952, 2.676722667138559],
            [15.319578577881197, 2.6724505407443373],
            [15.328461787425523, 2.666820062344159],
            [15.33887039144993, 2.66410965814512],
            [15.344193650526764, 2.6580383481121324],
            [15.363078912429668, 2.643411482816918],
            [15.36840801063924, 2.640061258228014],
            [15.371901758124856, 2.6397325984301645],
            [15.375513981461298, 2.6363503921342213],
            [15.38091959511176, 2.6273757287023067],
            [15.385333659062834, 2.621660697724325],
            [15.391998713152732, 2.6155179756454396],
            [15.395405111175359, 2.614179468146989],
            [15.402702606039421, 2.605350191587989],
            [15.406277084447481, 2.603211735170155],
            [15.411427140321608, 2.5972268703854944],
            [15.41392529889324, 2.5923742459264822],
            [15.41388313617986, 2.588461842281145],
            [15.280422560496442, 2.5603631602710295],
            [15.207065763690856, 2.5451901689604233],
            [15.168016835693777, 2.5369866567577724],
            [15.058968160175114, 2.514383443614861],
            [15.005653313253067, 2.503136435987833],
            [14.928829273454939, 2.4870370720836705],
            [14.89404425567405, 2.4802714676781505],
            [14.847378827352832, 2.469912567503313],
            [14.827127965931144, 2.568492697483845],
            [14.82431239455955, 2.579840649626928],
            [14.830880524113772, 2.5843893186036238],
            [14.835157468636979, 2.5924619513693257],
            [14.837216729632585, 2.5994168597671954],
            [14.840170916946384, 2.602023684689495],
            [14.84683826626796, 2.604519401240812],
            [14.852889586004075, 2.612128353053765],
            [14.84595403118562, 2.618807537617471],
            [14.843088316710253, 2.6276465682970773],
            [14.836657124894778, 2.6252336675915906],
            [14.830631032981113, 2.63311745001079],
            [14.830515251053471, 2.6367324779694243],
            [14.824166839669001, 2.643944136785732],
            [14.824651888158664, 2.6479852775877797],
            [14.822380428299539, 2.652319698084054],
            [14.823505653792472, 2.656007019344172],
            [14.82740953284357, 2.6601905906846266],
            [14.828137910383356, 2.6653786567676776],
            [14.832109101273065, 2.668822234027972],
            [14.830790670434258, 2.674646664447591],
            [14.82611173100727, 2.677849764465444],
            [14.826107683533609, 2.682800819543208],
            [14.824360090327852, 2.685602431774114],
            [14.82584691437524, 2.689308591307681],
            [14.82887457819982, 2.6877201153493706],
            [14.808200482910143, 2.7135553245218365],
            [14.801545237406026, 2.721274231974655],
            [14.78281454286178, 2.745485469036543],
            [14.77405384110784, 2.7576224015557336],
            [14.767521126365395, 2.760858772820962],
            [14.762265142761994, 2.7601525999761933],
            [14.756182812581432, 2.761593762895245],
            [14.743532993648309, 2.761621594124972],
            [14.73238515748886, 2.765905045318283],
            [14.73009639059326, 2.7693788561414436],
            [14.72470831778409, 2.7722609486641576],
            [14.721967316911876, 2.7772138632507732],
            [14.711588867984958, 2.785831229537421],
            [14.701551193959288, 2.7882534262941507],
            [14.699711692173073, 2.789736034086899],
            [14.68568862202966, 2.793530807408442],
            [14.68209331093412, 2.795299264182511],
            [14.674547301066793, 2.7951494280633185]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.72649589273891,
          "lat": 39.919929469849556
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42133"],
        "coty_name": ["York"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["York County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01209193"
      },
      "bbox": [
        14.674547301066793, 2.469912567503313, 15.41392529889324,
        2.9914371543980423
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.735500713324164, -4.669139472110425],
            [12.746879179832662, -4.677454008991935],
            [12.74863095816526, -4.680414702668251],
            [12.753688483615155, -4.683249221324723],
            [12.757444655127703, -4.689036227985919],
            [12.765429184985651, -4.692112776505435],
            [12.771359640964176, -4.697139710569284],
            [12.777905794736371, -4.700836854440161],
            [12.782306858066637, -4.708383741532767],
            [12.793508491762859, -4.715420189396122],
            [12.802200311346114, -4.72513254895431],
            [12.80995337735566, -4.727374329676104],
            [12.817302899665824, -4.727284636368139],
            [12.821993759526668, -4.726194560124864],
            [12.82448509752554, -4.727728335920602],
            [12.8284661089029, -4.733431123720692],
            [12.832821158528823, -4.734558237702488],
            [12.836200963359143, -4.738072799921584],
            [12.83694881637485, -4.741492527773643],
            [12.841063401707462, -4.746008964131453],
            [12.776028408592103, -4.803877824877957],
            [12.748548752244178, -4.8278003338092725],
            [12.739513465653934, -4.836339339608478],
            [12.739027559475693, -4.84199622723115],
            [12.72861619528341, -4.851787371235],
            [12.7272245120603, -4.851559008302327],
            [12.731843706467133, -4.884847262224247],
            [12.727852308032064, -4.88412127977267],
            [12.721535869176348, -4.886750020960809],
            [12.71393225164863, -4.891446769953747],
            [12.707388122005021, -4.900723251485985],
            [12.70192709283505, -4.9043684911741865],
            [12.722578216229236, -4.954872277759533],
            [12.715106230107892, -4.96372838004456],
            [12.676279780186958, -5.010984494263647],
            [12.673752650070433, -5.0167333763846536],
            [12.670066671737764, -5.034724135432593],
            [12.646970661626142, -5.046263795702975],
            [12.627901613387966, -5.065163432580002],
            [12.618712769169054, -5.066478877000825],
            [12.61743088047905, -5.06244156361201],
            [12.607084408618025, -5.065205025860517],
            [12.605787201596167, -5.0635736410587056],
            [12.609713371184428, -5.057264281245025],
            [12.610360866976453, -5.0493578159996675],
            [12.601130240300364, -5.0454613804086605],
            [12.595341221477979, -5.046821116266618],
            [12.59408024092728, -5.0427321125502305],
            [12.604220583933067, -5.039946781495472],
            [12.605873328735614, -5.034811618148126],
            [12.604206703169726, -5.033402327090046],
            [12.598487342739919, -5.03558121166328],
            [12.592414063433647, -5.033211484545297],
            [12.598547103317681, -5.0300211802092605],
            [12.593679100573802, -5.02777116572206],
            [12.595292996155216, -5.0240850643809285],
            [12.591898015614895, -5.012535206829338],
            [12.595603479905176, -5.011064130013877],
            [12.591186344924072, -5.004847341330996],
            [12.596029276122135, -5.000244825993732],
            [12.592362448824513, -4.991518969585828],
            [12.585900005860388, -4.9881997418332595],
            [12.590551192788737, -4.986306188959025],
            [12.592623756178664, -4.983029641734489],
            [12.591195379235375, -4.979238510709373],
            [12.586323603895627, -4.9743142661611115],
            [12.579022570517312, -4.972633786064548],
            [12.57526575892409, -4.9764328319333595],
            [12.569580894081376, -4.966551651292421],
            [12.561440684676997, -4.972325156033602],
            [12.559385146142953, -4.966458565647349],
            [12.561524804736854, -4.958997937263601],
            [12.560595037404235, -4.954869955166321],
            [12.561731241879432, -4.951330110839343],
            [12.559032143158449, -4.944934289471522],
            [12.552923884565661, -4.944573545469939],
            [12.548336585239726, -4.939461367113327],
            [12.546516052262266, -4.9440220208675925],
            [12.539870574263576, -4.944062256764453],
            [12.536433998325547, -4.9410995627924645],
            [12.537390342199544, -4.9344749024525365],
            [12.54393151627835, -4.928595390340765],
            [12.546348315428478, -4.924448098131617],
            [12.544705482818467, -4.920754739265959],
            [12.5399933415594, -4.921360510474759],
            [12.54155111647334, -4.92615430148616],
            [12.532622010350389, -4.923902472352784],
            [12.532889149463255, -4.916737138117696],
            [12.530526694694828, -4.913795963056162],
            [12.53101434851261, -4.909107050600481],
            [12.525005028984928, -4.908681683395442],
            [12.52436145809675, -4.905657284813496],
            [12.527104335859983, -4.901229043209298],
            [12.515799233627616, -4.893027778583818],
            [12.511738201937671, -4.892617422489839],
            [12.508429420956476, -4.886963134058716],
            [12.510161682860371, -4.880307279327413],
            [12.501452713230226, -4.873969365142393],
            [12.497030733564916, -4.860272304296297],
            [12.502722842312169, -4.862606318520594],
            [12.507114350741077, -4.8606970449707765],
            [12.507202012548372, -4.85233369887046],
            [12.50884150258539, -4.84600982422974],
            [12.508065705552978, -4.838760455344912],
            [12.505863574923048, -4.834377437939845],
            [12.508667543381137, -4.831312952998392],
            [12.508876497271983, -4.826904207886756],
            [12.501332181412794, -4.825188281580407],
            [12.501544840808606, -4.820681559822484],
            [12.506940983283354, -4.81820181354901],
            [12.497309210607856, -4.8111361736833045],
            [12.49417154725095, -4.810743233558555],
            [12.492913893225307, -4.816462136134875],
            [12.489885577297203, -4.815144245770521],
            [12.491844911635628, -4.809541156231885],
            [12.489577767510053, -4.806111037513737],
            [12.482850849875225, -4.8067825288999515],
            [12.488628703586755, -4.8016176715741095],
            [12.48603180389317, -4.799234236732266],
            [12.480663926738252, -4.7994114789225355],
            [12.472415089873431, -4.794113939482596],
            [12.469750458441169, -4.7892272364604285],
            [12.466178879829618, -4.7921828467291725],
            [12.462081411646324, -4.790654030540307],
            [12.459947343514342, -4.785833283313016],
            [12.455524237855913, -4.78331072752199],
            [12.452020760496177, -4.789373095180945],
            [12.443280187717296, -4.788217262762803],
            [12.44399883165833, -4.77891563730893],
            [12.440883233634436, -4.778471758433841],
            [12.438533050695995, -4.7812449086849975],
            [12.433894399858058, -4.77845907301688],
            [12.426350692691424, -4.7701510162369685],
            [12.422955376696583, -4.771921308902286],
            [12.42116835690006, -4.767179492109885],
            [12.418652468403891, -4.76752107117125],
            [12.413974815472777, -4.765068829622242],
            [12.407072869309093, -4.76636981201551],
            [12.409657762834106, -4.7587953370961795],
            [12.404604721287205, -4.752303815900982],
            [12.400874873849752, -4.758280932073129],
            [12.397966856796724, -4.760519919790003],
            [12.39550511934476, -4.75680040187904],
            [12.398572497434326, -4.751219542153721],
            [12.396585411655778, -4.747475489127632],
            [12.392887309431469, -4.745827579342167],
            [12.442653791216074, -4.674221778716322],
            [12.519395905964425, -4.686164645845506],
            [12.587270236191346, -4.7000089541301655],
            [12.595920934615036, -4.701629195304928],
            [12.662613227010446, -4.690781921402363],
            [12.667203085795425, -4.686249383269247],
            [12.67498983249677, -4.686923497553592],
            [12.67815716888472, -4.686059602064679],
            [12.690190778272594, -4.679817263157571],
            [12.696743542332797, -4.67511654892892],
            [12.703296167148745, -4.6759499137522935],
            [12.7083964344502, -4.674546316866412],
            [12.71397755443036, -4.67474362772416],
            [12.71973836567426, -4.669535921088148],
            [12.733350871858805, -4.670196939003073],
            [12.735500713324164, -4.669139472110425]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.35808931666051, "lat": 32.98806512976668 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45005"],
        "coty_name": ["Allendale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Allendale County"],
        "coty_fp_code": "005",
        "coty_gnis_code": "01247980"
      },
      "bbox": [
        12.392887309431469, -5.066478877000825, 12.841063401707462,
        -4.669139472110425
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.763678036523201, -3.890636309359942],
            [12.773835886416498, -3.8906942616468383],
            [12.777494297614018, -3.8948265413925407],
            [12.777173717436503, -3.901851024803495],
            [12.774714297654993, -3.9062106452609466],
            [12.776972654133548, -3.9083495702844817],
            [12.788513955149995, -3.9097098416940197],
            [12.786519979576198, -3.9148822571269712],
            [12.790314109729339, -3.918312544733501],
            [12.796816430297653, -3.917491570691062],
            [12.800939779887154, -3.9183908890980375],
            [12.806542193349106, -3.916629362228222],
            [12.819956138393099, -3.921570014023801],
            [12.826592737262766, -3.9276785798832727],
            [12.830267155976516, -3.9325602707017087],
            [12.83417663606493, -3.9340691537760075],
            [12.843727878584502, -3.9315053634432244],
            [12.843757344979037, -3.9258092077093836],
            [12.84561326946423, -3.923630050675918],
            [12.851935461529544, -3.924571731742436],
            [12.853537605370187, -3.927426268981339],
            [12.850869634905049, -3.9329036654757386],
            [12.851566360984135, -3.944171113043886],
            [12.853361949547313, -3.9462415381859377],
            [12.867648704397457, -3.946658077102981],
            [12.871790397473028, -3.9448172666211008],
            [12.881802936065696, -3.9374189050149426],
            [12.885896554969282, -3.9368979079532673],
            [12.890544246553425, -3.939305860545769],
            [12.893924313242927, -3.943879059409674],
            [12.895308327153778, -3.948387195430612],
            [12.901949978852823, -3.9484882512326602],
            [12.913127252645978, -3.952379441317204],
            [12.919756841286866, -3.9534367658506544],
            [12.92436562618176, -3.961244815907543],
            [12.927624613762703, -3.9613311818987125],
            [12.931255468174594, -3.958761107500949],
            [12.933390535807234, -3.960753063071744],
            [12.93031496553612, -3.969757386477686],
            [12.935564678597295, -3.970766494396598],
            [12.939555468607672, -3.9633227813725695],
            [12.944984319812853, -3.96508926119008],
            [12.94725260569167, -3.969065687176281],
            [12.95249475545194, -3.96932678001002],
            [12.959603121773725, -3.971848110549757],
            [12.968165184909834, -3.971106439794625],
            [12.96789078890321, -3.9791828206205913],
            [12.972268492863812, -3.977758909106363],
            [12.976805894270138, -3.9666591257887776],
            [12.980006482211953, -3.966688667774226],
            [12.982048417700259, -3.97098383111918],
            [12.986276204041785, -3.962997057510931],
            [12.988230208723943, -3.9636131844281595],
            [12.99064127594823, -3.971635417932426],
            [12.995868815421167, -3.971010431287852],
            [12.996180731253414, -3.9665278646065163],
            [12.993473435781379, -3.965330118218548],
            [12.99556129021724, -3.959654750052999],
            [13.001078818557835, -3.960748671780515],
            [13.002622123288647, -3.9656055726814095],
            [13.00705769661057, -3.9682960508748804],
            [13.004377258530011, -3.9752482512559912],
            [13.007285145579804, -3.977296843781401],
            [13.00961004729415, -3.9734997322022494],
            [13.014083574430998, -3.9709024347497515],
            [13.013465034328014, -3.9653149028592893],
            [13.017646482209553, -3.964699739206378],
            [13.02275224611617, -3.970505052457684],
            [13.02519391112078, -3.969287384229173],
            [13.024358043769837, -3.9606513529192706],
            [13.026745734081878, -3.95955631330271],
            [13.032571553793339, -3.963159615100872],
            [13.032836841915653, -3.969928336396152],
            [13.037912586084774, -3.971968934305065],
            [13.045810714453715, -3.9704294451643505],
            [13.048762310508222, -3.971218406540931],
            [13.055009705830777, -3.9630918905029118],
            [13.058501760449822, -3.9622880504798395],
            [13.059125180306463, -3.958865824373628],
            [13.063300801536844, -3.9562769927039163],
            [13.068448744935973, -3.950722930298467],
            [13.071924341391181, -3.949626799336525],
            [13.074890946510857, -3.952740845921076],
            [13.071899905563013, -3.9575590748243044],
            [13.072484989049787, -3.9618653943835422],
            [13.078665211047824, -3.964577256940692],
            [13.08109118046808, -3.9677921729986814],
            [13.08591297151029, -3.968977244532146],
            [13.08775269112694, -3.9734846264810995],
            [13.094595916942827, -3.9763227354623356],
            [13.102449065197424, -3.9730285511078223],
            [13.104995118521078, -3.9750676943020644],
            [13.098439584432587, -3.979249465667137],
            [13.098162355282037, -3.982132091647176],
            [13.102846159513408, -3.984249932739365],
            [13.100913229874601, -3.9881951831939895],
            [13.111815931119311, -3.9981270593465466],
            [13.11403851410473, -4.005565626876158],
            [13.12071286627317, -4.007297182445768],
            [13.126644000528685, -4.012841002027405],
            [13.13278938552247, -4.012094316256218],
            [13.134613869571455, -4.015289772766931],
            [13.131982582569906, -4.019743484871865],
            [13.135020979368894, -4.022128015965312],
            [13.138806500716946, -4.029006468213849],
            [13.143502353481491, -4.031432795067736],
            [13.152924156330963, -4.032657465286539],
            [13.160066277032788, -4.030759550575722],
            [13.162604483919504, -4.031685520476247],
            [13.16522739884162, -4.038237823770181],
            [13.162148380643497, -4.044302868939591],
            [13.165017844660847, -4.04696747318661],
            [13.17227570150599, -4.0476346707625686],
            [13.173235896286839, -4.052197403395323],
            [13.180812042187547, -4.058884619560402],
            [13.191283699954452, -4.062100903699664],
            [13.196393426268852, -4.066120170326517],
            [13.196730966626797, -4.07057693598703],
            [13.188570439383591, -4.07475667608415],
            [13.188756852490993, -4.078690352620692],
            [13.19639396954686, -4.084026473532931],
            [13.205963613227016, -4.087571136894115],
            [13.208630880289556, -4.092189464392831],
            [13.20812263307489, -4.100626536989579],
            [13.210537124641865, -4.106328557716099],
            [13.2156395247133, -4.108863643067236],
            [13.22491274010782, -4.109818346460777],
            [13.227042874677979, -4.113015507371942],
            [13.223990075236365, -4.118212376712939],
            [13.217128145059002, -4.121659748853171],
            [13.217964790891635, -4.128180946830025],
            [13.227877067519374, -4.131354789273825],
            [13.227222454649027, -4.137340766685276],
            [13.232554602793584, -4.138218721502391],
            [13.236096950257403, -4.141721240301614],
            [13.236187582065927, -4.146681976230754],
            [13.229452865417864, -4.148806060505405],
            [13.231471026550123, -4.154803194833177],
            [13.231225305905602, -4.161664285759719],
            [13.227180147420965, -4.1635949964705],
            [13.201543898776189, -4.146153793296863],
            [13.199734237355443, -4.144303364973155],
            [13.193720096411969, -4.1485995673131635],
            [13.191076567885402, -4.148836564851168],
            [13.18924147772398, -4.142341651388035],
            [13.179728288107803, -4.147572268653746],
            [13.172264175501036, -4.150181960302356],
            [13.167343447738023, -4.150326927689203],
            [13.150503740020888, -4.158049835910268],
            [13.144204665223706, -4.164636122803869],
            [13.164239584859907, -4.173719406360662],
            [13.14088635232589, -4.217922347996848],
            [13.145920733773078, -4.222878340261564],
            [13.142326760093628, -4.228001487551782],
            [13.147974011797155, -4.233724484347738],
            [13.156441281795441, -4.24437131350245],
            [13.152866165239688, -4.249440633611774],
            [13.142836985195334, -4.243121701930102],
            [13.13766020355731, -4.2483938519449005],
            [13.132856407292241, -4.243634057939868],
            [13.127860858909589, -4.246551190343326],
            [13.122379264961681, -4.247424574657539],
            [13.117354875136888, -4.250152306616024],
            [13.110869962469714, -4.246961526696455],
            [13.108379997020096, -4.241978516022975],
            [13.099313607148801, -4.237111971161742],
            [13.09440440743268, -4.230382280889542],
            [13.092554353599093, -4.225224807607449],
            [13.08596400312791, -4.222375904036785],
            [13.080670606109289, -4.215938600037186],
            [13.080470600478522, -4.204318245507353],
            [13.04538729767768, -4.18192245636966],
            [12.974494178751316, -4.137819325037014],
            [12.911774444630975, -4.131987094082301],
            [12.882777414056754, -4.151063386002995],
            [12.86583118209907, -4.15040106234885],
            [12.86464548512683, -4.141489953175783],
            [12.864642069061597, -4.134638335448908],
            [12.861735713218703, -4.129755865921452],
            [12.861369140984106, -4.122419731285062],
            [12.856899349710018, -4.116433202271564],
            [12.842206544995454, -4.137387226150537],
            [12.80858957254147, -4.106621488964937],
            [12.793314558021937, -4.09160446987957],
            [12.785809976775004, -4.085037715585651],
            [12.766138986477722, -4.066222370951705],
            [12.78321632952498, -4.05050074578577],
            [12.798160310212817, -4.041302406305084],
            [12.803655460707446, -4.034798460697219],
            [12.806391292123593, -4.035522705473662],
            [12.8149544944343, -4.0347223852819605],
            [12.81789688432771, -4.031479945745962],
            [12.825413438143698, -4.026619270373909],
            [12.832318812326028, -4.024495437777581],
            [12.838763406873435, -4.011788732937976],
            [12.842618709893879, -4.007994443680991],
            [12.847124360316364, -4.006617737639242],
            [12.853478942348607, -4.003045925858002],
            [12.846068761644224, -3.9948405373416698],
            [12.840214960487588, -3.9913757641027776],
            [12.831237986807814, -3.9898267089900696],
            [12.826915162648467, -3.98645906862137],
            [12.820656938101141, -3.9844983013711626],
            [12.816900031312418, -3.9868962910886108],
            [12.777950852990294, -3.9889526644134046],
            [12.778581932410063, -3.995187468140902],
            [12.772219317990398, -3.998057279716306],
            [12.773041351619973, -4.007813546333072],
            [12.765293372509907, -4.008445026732284],
            [12.765614713489816, -4.027565940630479],
            [12.747063599220203, -4.028627573428215],
            [12.7430122093325, -4.0135073703088695],
            [12.742752092575113, -4.005138850694962],
            [12.749348951730932, -3.9851570207368514],
            [12.749193379477257, -3.9770612372825864],
            [12.748119386300585, -3.9702553296110445],
            [12.748147157145732, -3.9294960334151385],
            [12.743206721861679, -3.915493328261958],
            [12.744319765150427, -3.903079826444436],
            [12.763678036523201, -3.890636309359942]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.780462592182, "lat": 33.67493249982589 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45017"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01247986"
      },
      "bbox": [
        12.742752092575113, -4.250152306616024, 13.236187582065927,
        -3.890636309359942
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.485984803646824, -2.8269309295638982],
            [13.488658493842973, -2.8265484950476276],
            [13.534383969035733, -2.8199352303661507],
            [13.612089886765613, -2.806031098365774],
            [13.677085088250877, -2.7957887359303073],
            [13.69128321028691, -2.7935645327073],
            [13.732564923840552, -2.823109789051489],
            [13.798515305285104, -2.869732026222728],
            [13.805305150973139, -2.8743056051237583],
            [13.866063095900914, -2.9173948366198053],
            [13.876419589197804, -2.9249631859305856],
            [13.883910615555259, -2.931255327531762],
            [13.893181795155648, -2.936684346493202],
            [13.90406647968841, -2.944241713356288],
            [13.890438168237308, -2.9954952601270612],
            [13.87043724387067, -3.070285102175072],
            [13.866299536818923, -3.086643651691641],
            [13.836935492887292, -3.1977134899767328],
            [13.81242601017283, -3.2903455226120553],
            [13.810272535006014, -3.2873439084390754],
            [13.80538760318963, -3.2897616240452683],
            [13.791520507309334, -3.2866233396708533],
            [13.791631857181478, -3.2826393275671353],
            [13.787265269374641, -3.2817897936317104],
            [13.788032709635814, -3.2744902102825315],
            [13.785248891066315, -3.2687743453909612],
            [13.778760211225984, -3.2661505415241083],
            [13.771120711679206, -3.2584024254497646],
            [13.767311036436283, -3.2509598888388567],
            [13.763584126390205, -3.2476576440020057],
            [13.759812169528868, -3.242126308356569],
            [13.754449189018228, -3.240619427189097],
            [13.753525018347021, -3.2377418506517546],
            [13.757344129183638, -3.2347237706526877],
            [13.76058588573281, -3.2368927926982844],
            [13.76650465534192, -3.2275274599072095],
            [13.766729048639439, -3.2202376697234696],
            [13.762462633094596, -3.2169573201184716],
            [13.754992074490614, -3.2163793948292474],
            [13.752759604312446, -3.215127421900028],
            [13.752936957552045, -3.2108262633727387],
            [13.750192479483799, -3.207422898821828],
            [13.75471862053924, -3.204228035149116],
            [13.754639765347166, -3.197046718470182],
            [13.753474710854183, -3.1958776225525365],
            [13.744948286575603, -3.1958995703572146],
            [13.742093037910095, -3.1924568844915924],
            [13.738981910243341, -3.193427999422727],
            [13.738417873300206, -3.1996641908326313],
            [13.733139355672709, -3.1973980582314354],
            [13.730571087469105, -3.1981952903364044],
            [13.72974846033309, -3.206227565627016],
            [13.725208663082677, -3.208963553044695],
            [13.724489155973812, -3.2040239278564195],
            [13.727858059827541, -3.2011725448342663],
            [13.726771266458565, -3.19748007161374],
            [13.721908163785534, -3.1929710555388175],
            [13.723294824877774, -3.184142651714124],
            [13.720648396992306, -3.182491560208457],
            [13.715965932677841, -3.18553183330864],
            [13.71259042482468, -3.1834292751707793],
            [13.708059210218135, -3.1783188595853553],
            [13.698172156518366, -3.1711454052631907],
            [13.694008056119413, -3.1690657861676983],
            [13.693798139565954, -3.160765378547459],
            [13.692228278044919, -3.1550189246920537],
            [13.68866653369294, -3.1488558269024596],
            [13.687715393194729, -3.1416981947096185],
            [13.689704159845313, -3.1379743823315263],
            [13.697985533265642, -3.136415390863752],
            [13.702100586309827, -3.1378494210045034],
            [13.704697892135103, -3.1341497777408733],
            [13.70173292005466, -3.128403887836526],
            [13.70266018681391, -3.12463284287791],
            [13.70783397234173, -3.1186697955953355],
            [13.708318140570942, -3.114274281189775],
            [13.702031608887308, -3.1063661579542123],
            [13.696980695982882, -3.105244990595977],
            [13.689794441390214, -3.1070385318704474],
            [13.67935757705501, -3.1028039984524987],
            [13.680943007485617, -3.0974599073056397],
            [13.678146250186638, -3.0923563093690567],
            [13.669203999403113, -3.0900746375518535],
            [13.669201563355378, -3.0962684645261556],
            [13.66568083162772, -3.1007319402600784],
            [13.668069596425019, -3.112791781666925],
            [13.66108890198083, -3.112106833368357],
            [13.657479646896501, -3.113079267307043],
            [13.654743512609972, -3.1207387408567557],
            [13.656159186440757, -3.1261507942019353],
            [13.653509991020515, -3.1265022263363567],
            [13.647655763486277, -3.121050456914848],
            [13.645004602194444, -3.1222987484650093],
            [13.643119804230649, -3.1288367230438663],
            [13.638090665830898, -3.1283524815390003],
            [13.631830188257489, -3.118077135627873],
            [13.62124423326924, -3.113938497539623],
            [13.614699387782114, -3.107671640846082],
            [13.61406879008104, -3.104535933638116],
            [13.61643828066584, -3.1003136489578216],
            [13.61631875065485, -3.0971607052463885],
            [13.612862200063946, -3.0930715584401542],
            [13.612189736086586, -3.089894937544125],
            [13.61373853857794, -3.0857060555704776],
            [13.614442358050335, -3.083151281369376],
            [13.613167776496535, -3.0753241717326207],
            [13.61570329880541, -3.0684713714910106],
            [13.616611475727414, -3.043075597589443],
            [13.620508801900018, -3.037050496054642],
            [13.621764099126326, -3.0303919853381522],
            [13.619072089904542, -3.016260293042681],
            [13.620285988992903, -3.009164179425502],
            [13.622070098979414, -3.0048651726475732],
            [13.625447804642796, -3.004156942084037],
            [13.630191400700495, -3.0070611525665116],
            [13.63780912112084, -3.0046199442813664],
            [13.642152906802915, -2.998810108551536],
            [13.641197199022598, -2.9962579821718505],
            [13.634592764262935, -2.993250572104849],
            [13.6299593712941, -2.9893070487599895],
            [13.628679045020236, -2.9810810754214905],
            [13.619324403787822, -2.976725941842042],
            [13.61784054011235, -2.973818898019565],
            [13.62197710566159, -2.9674681025258742],
            [13.619021638283, -2.9655486517461593],
            [13.610838797830938, -2.9647909353749653],
            [13.607006074406153, -2.960779201953653],
            [13.60264538438534, -2.9581268949345287],
            [13.595602461513337, -2.9614936204967477],
            [13.591971813790348, -2.961455566561782],
            [13.583996582497312, -2.952440413779629],
            [13.581557676833844, -2.9506988203924975],
            [13.572796787100884, -2.9506576804188973],
            [13.565200061977915, -2.945022047535075],
            [13.5523609967458, -2.9308205947060624],
            [13.55021432912411, -2.926780552838136],
            [13.54860052915003, -2.920068601703961],
            [13.543015122709713, -2.90893479728064],
            [13.535531230292149, -2.900053087720427],
            [13.528584232618808, -2.8878341605985804],
            [13.525697740221716, -2.884556407599226],
            [13.516716541627801, -2.877780274201089],
            [13.51167577601287, -2.875699552493787],
            [13.505038237959594, -2.870718740811363],
            [13.497407192362267, -2.867206455801953],
            [13.494341377477369, -2.863051078521804],
            [13.48899852536224, -2.8506281629987487],
            [13.484397554028552, -2.8364436552806054],
            [13.48401109225091, -2.832736367928213],
            [13.485984803646824, -2.8269309295638982]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -79.67861000123935,
          "lat": 34.602014389337036
        },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45069"],
        "coty_name": ["Marlboro"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marlboro County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01248011"
      },
      "bbox": [
        13.48401109225091, -3.2903455226120553, 13.90406647968841,
        -2.7935645327073
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.219909595290242, 6.5652203539821645],
            [-5.207074053444822, 6.564602139308387],
            [-5.199472475698056, 6.656466693460461],
            [-5.196326681133535, 6.689419620679886],
            [-5.196537189640807, 6.690384217570571],
            [-5.189214905096545, 6.77745491789973],
            [-5.16141505515039, 6.775016366616824],
            [-5.137580244798289, 6.773234994974804],
            [-5.057167754799814, 6.766690733176786],
            [-4.976756678121971, 6.76012913126723],
            [-4.896347042217135, 6.753550190866604],
            [-4.815938874527422, 6.746953913702421],
            [-4.801221998612129, 6.746286103752515],
            [-4.758799263938051, 6.74286427870664],
            [-4.6840409273783585, 6.737199471488206],
            [-4.609283726455686, 6.731519692984485],
            [-4.5345276832108325, 6.725824944395743],
            [-4.459772819677598, 6.7201152270019495],
            [-4.45966666046561, 6.719644028768212],
            [-4.429337840733747, 6.717754236019257],
            [-4.4356920896493, 6.631901732994238],
            [-4.442086913966751, 6.545926117135717],
            [-4.443078323827797, 6.545993366679784],
            [-4.447605605655559, 6.484745317197037],
            [-4.447658336448154, 6.481824049736537],
            [-4.462249381151885, 6.28563310449762],
            [-4.468555311084227, 6.199552140887891],
            [-4.4720904358145175, 6.199806010641797],
            [-4.478762888877941, 6.114045513483547],
            [-4.578914026529722, 6.12166623070124],
            [-4.679067134676387, 6.129261628150101],
            [-4.686987792309884, 6.129557906636416],
            [-4.71045947118944, 6.131774440925503],
            [-4.7495862142034895, 6.13458019967972],
            [-4.778256061922707, 6.137101942261474],
            [-4.8207886979520165, 6.14037880986883],
            [-4.835084825844782, 6.141182465380711],
            [-4.906237923891728, 6.146412793039489],
            [-5.001980299888898, 6.154567318989525],
            [-5.0852147635847675, 6.161528464060813],
            [-5.091070987245689, 6.158358259300783],
            [-5.089940599619053, 6.1522429862606405],
            [-5.095768099969807, 6.149636579875241],
            [-5.101141785703301, 6.145892322181426],
            [-5.108655224764484, 6.150981306329092],
            [-5.117074125204241, 6.145885045744582],
            [-5.119884383109695, 6.147511795463816],
            [-5.121713765703267, 6.1521586588218735],
            [-5.125679879803999, 6.157617911255369],
            [-5.132436531805649, 6.158912235937296],
            [-5.1398645237051, 6.158623878238574],
            [-5.140812511733242, 6.155485433224316],
            [-5.1445152896004105, 6.1564561502181245],
            [-5.148461415088317, 6.150190204492529],
            [-5.1557130157229984, 6.151796893562005],
            [-5.159970397057034, 6.149750410914539],
            [-5.166969818359003, 6.143185877024161],
            [-5.1719860898456025, 6.146652557189675],
            [-5.181862823489455, 6.142333141957329],
            [-5.188564345850683, 6.142870383521448],
            [-5.194956958078025, 6.146149774724039],
            [-5.205226977434937, 6.142684571200359],
            [-5.207480575502928, 6.14571371012628],
            [-5.213800364549216, 6.1455544037099195],
            [-5.217257549021304, 6.141246786668576],
            [-5.230402928081364, 6.146875994886902],
            [-5.232003736704617, 6.15179637206653],
            [-5.235283799572045, 6.146457630430526],
            [-5.2388003707998365, 6.150475385682197],
            [-5.24195891364851, 6.149195325930594],
            [-5.2440166097187175, 6.145380131301504],
            [-5.247840959991938, 6.146589877888342],
            [-5.254651334339054, 6.141862406569729],
            [-5.249303126659181, 6.203797866002558],
            [-5.237361903819207, 6.345050963025681],
            [-5.230028509773243, 6.435419631398318],
            [-5.2289223518098975, 6.443531305614931],
            [-5.2244424801571, 6.502028195290542],
            [-5.219909595290242, 6.5652203539821645]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -103.50792618540174, "lat": 44.9057841154388 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46019"],
        "coty_name": ["Butte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butte County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01265793"
      },
      "bbox": [
        -5.254651334339054, 6.114045513483547, -4.429337840733747,
        6.77745491789973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9324478034674529, 6.495024330194229],
            [-0.8370953523698887, 6.4918856221334815],
            [-0.747407826187923, 6.490371096937767],
            [-0.6755542020588825, 6.4885798536407195],
            [-0.5890325951795328, 6.487128856589273],
            [-0.5902071777643103, 6.403934187942136],
            [-0.5909605821462044, 6.357601834729634],
            [-0.5927361487286734, 6.271314307393724],
            [-0.5926573115941212, 6.2389691599660235],
            [-0.5930811879179777, 6.228088892944688],
            [-0.5909850785716041, 6.228048197760515],
            [-0.5924454109628078, 6.141177327028357],
            [-0.5935950889279298, 6.083648496283079],
            [-0.5957701162468955, 5.968429708669281],
            [-0.5971900195262748, 5.881949362972483],
            [-0.6824506024682869, 5.883645770335841],
            [-0.7409064807854308, 5.884642420792905],
            [-0.769518788569523, 5.8853065109478315],
            [-0.8536352462209338, 5.886951773346127],
            [-0.8559403463892233, 5.887004501486225],
            [-0.854209834232984, 5.973496285838413],
            [-0.9405019938127048, 5.9756502836782115],
            [-0.9398201364334104, 5.996189393672611],
            [-0.9382453804493445, 6.062466023490557],
            [-0.9373594046109319, 6.093628186517965],
            [-0.937137786888151, 6.112961818612174],
            [-0.9363213958803581, 6.148964493793378],
            [-0.9346454347102406, 6.2352742712019875],
            [-0.9386255304438563, 6.235379613834641],
            [-0.9384230547326152, 6.249777428862089],
            [-0.9360580831490597, 6.342478934356322],
            [-0.9357602921013205, 6.343340756295765],
            [-0.9346755573271593, 6.401250291746927],
            [-0.9324478034674529, 6.495024330194229]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.72949576667673,
          "lat": 44.858232720095415
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46025"],
        "coty_name": ["Clark"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clark County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01266985"
      },
      "bbox": [
        -0.9405019938127048, 5.881949362972483, -0.5890325951795328,
        6.495024330194229
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8536352462209338, 5.886951773346127],
            [-0.769518788569523, 5.8853065109478315],
            [-0.7409064807854308, 5.884642420792905],
            [-0.6824506024682869, 5.883645770335841],
            [-0.5971900195262748, 5.881949362972483],
            [-0.5750370716441688, 5.881653830671382],
            [-0.467731784075064, 5.879620867861088],
            [-0.38191160106900685, 5.878231963651499],
            [-0.33825443905533, 5.877642652827097],
            [-0.33821445511512255, 5.866927619817581],
            [-0.33965667333288363, 5.790963800338483],
            [-0.340803551834872, 5.705319040180383],
            [-0.34131656318547016, 5.686293663271411],
            [-0.34202788544995566, 5.617564270385358],
            [-0.3435636408875566, 5.5312277222810335],
            [-0.4297521539615489, 5.532389741854894],
            [-0.4590178949796986, 5.5326903545331225],
            [-0.5153966624400792, 5.532516364493792],
            [-0.5663542918835035, 5.533134787257981],
            [-0.6576345610591007, 5.5348894461146685],
            [-0.732165674951996, 5.535794513378798],
            [-0.8579350598778144, 5.538555270456493],
            [-0.8609132379824084, 5.538611028324979],
            [-0.8591862043576521, 5.625055405778749],
            [-0.8574229448630076, 5.701771233449286],
            [-0.8557881566957313, 5.78372618040382],
            [-0.853774411223485, 5.886454806154129],
            [-0.8536352462209338, 5.886951773346127]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.49150675198452, "lat": 44.36959419366335 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46077"],
        "coty_name": ["Kingsbury"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kingsbury County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "01265780"
      },
      "bbox": [
        -0.8609132379824084, 5.5312277222810335, -0.33821445511512255,
        5.886951773346127
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.635801509050796, 6.990939108927378],
            [-2.618438621851362, 6.989958689831825],
            [-2.562458014921096, 6.987322449191818],
            [-2.490870694355456, 6.98404058438389],
            [-2.3833020017897386, 6.978868693600531],
            [-2.2902071830921202, 6.974734788036189],
            [-2.2098217471967287, 6.971124510864067],
            [-2.1664276159534306, 6.969413037959519],
            [-2.1623544591723864, 6.969005895625721],
            [-2.1375491113699336, 6.968342642822882],
            [-2.130723784112959, 6.968041121705096],
            [-2.132588117332653, 6.924743454595298],
            [-2.1378665258960226, 6.79582282824293],
            [-2.141374693842889, 6.709044826586635],
            [-2.145181754145119, 6.62318067119024],
            [-2.1896934308371323, 6.6250411025537845],
            [-2.275194010571864, 6.628730805673009],
            [-2.278594606804658, 6.628710187571948],
            [-2.3185421712314307, 6.630788445632879],
            [-2.3907808964326884, 6.633752740492424],
            [-2.461709596823792, 6.637015268272253],
            [-2.5326389538748577, 6.640264339039248],
            [-2.5334891624415676, 6.644501948893394],
            [-2.5375007284439164, 6.654708747122431],
            [-2.5410589157084345, 6.6593367362865905],
            [-2.5483380897301515, 6.666540006139387],
            [-2.560662868133012, 6.6816487077817275],
            [-2.563742050519628, 6.686525505928623],
            [-2.5690757359470062, 6.712623740735071],
            [-2.566014080697297, 6.721205612026754],
            [-2.562518035903727, 6.726423874445844],
            [-2.543282805452649, 6.748678863604475],
            [-2.5417485126149737, 6.751995333019533],
            [-2.5398032750501147, 6.761383240504281],
            [-2.5367241725531806, 6.767943798680111],
            [-2.5363724063250355, 6.77474440824725],
            [-2.5397618912819206, 6.78178665358643],
            [-2.5448950614187926, 6.789734245544344],
            [-2.5509185556584293, 6.806025749022412],
            [-2.5559019985431424, 6.814485662025086],
            [-2.562116608172528, 6.822442477943194],
            [-2.5668500043034603, 6.827086945431214],
            [-2.5737107702210107, 6.838625517074049],
            [-2.579733710152209, 6.867222669202534],
            [-2.5832908513819497, 6.87573810004727],
            [-2.594829111251102, 6.894948035352337],
            [-2.606157414744373, 6.905936539634893],
            [-2.6127823077783523, 6.907559053921465],
            [-2.6193597104963446, 6.905624312422593],
            [-2.6254557609189764, 6.905035450254551],
            [-2.6332473892847563, 6.906218890777743],
            [-2.649477792439443, 6.907152714057859],
            [-2.660569359950217, 6.911951129842158],
            [-2.6686825818555793, 6.9180013559311915],
            [-2.673395216728207, 6.923418159933384],
            [-2.6780410793489153, 6.934982107868289],
            [-2.676614961864849, 6.94552956669082],
            [-2.6691620997786956, 6.957344298200137],
            [-2.662755116183559, 6.963352004766758],
            [-2.6540526073805415, 6.967307877248289],
            [-2.6440520451291607, 6.975557901386664],
            [-2.6390739070129046, 6.982040750570383],
            [-2.635801509050796, 6.990939108927378]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.0315230346433,
          "lat": 45.429935094509375
        },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46129"],
        "coty_name": ["Walworth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Walworth County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01266973"
      },
      "bbox": [
        -2.6780410793489153, 6.62318067119024, -2.130723784112959,
        6.990939108927378
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.7242153493434118, 4.509042380208573],
            [-0.7077456449837781, 4.508731367597462],
            [-0.6378392204024352, 4.507871221771163],
            [-0.5513359968896905, 4.506939395642652],
            [-0.46401482513030123, 4.505873271080855],
            [-0.3782065390198643, 4.50517534768865],
            [-0.379271758631458, 4.418147819754032],
            [-0.3804018178305696, 4.331101573115853],
            [-0.3815321898079697, 4.244092441758563],
            [-0.3826123133941894, 4.1339383459870955],
            [-0.39112916249694624, 4.137244948447604],
            [-0.4024220334481158, 4.139301218496454],
            [-0.4117714193974471, 4.140070563927236],
            [-0.41879309391850433, 4.1439832067077935],
            [-0.4209025740122073, 4.147733481035234],
            [-0.42144749493240624, 4.154900252749121],
            [-0.4244701004001417, 4.164388055069109],
            [-0.4236647566347788, 4.1783815645123425],
            [-0.4246653635308492, 4.180730941757056],
            [-0.43414484421232513, 4.186357654580128],
            [-0.44620912669496055, 4.190578775006156],
            [-0.46037736221074244, 4.187953786114156],
            [-0.4763074443176592, 4.191093020922989],
            [-0.48506988472737594, 4.2014059086400355],
            [-0.4883962274327486, 4.203401666674152],
            [-0.4967552923652108, 4.199145809583029],
            [-0.5028176073663523, 4.197265623018888],
            [-0.5060651657139748, 4.194418597118196],
            [-0.5137029778313501, 4.19199350954664],
            [-0.527118448932139, 4.191114161930839],
            [-0.5336789709195482, 4.1948227535515965],
            [-0.5394478595452543, 4.201703718600909],
            [-0.5520461584694346, 4.200938824761402],
            [-0.5559262995447385, 4.201582578013145],
            [-0.5624406817517662, 4.205188801257662],
            [-0.5688529312747397, 4.202860089333223],
            [-0.5733865959007047, 4.19816231860446],
            [-0.5751692143632663, 4.193664339010111],
            [-0.5799164189848584, 4.188602849566918],
            [-0.5875244232053051, 4.183382175690465],
            [-0.5947411336263497, 4.183315202219996],
            [-0.6016086683355077, 4.186558465280466],
            [-0.6080481299236035, 4.187940729989515],
            [-0.6185381896600081, 4.188016120678169],
            [-0.6267346948420748, 4.191016706677016],
            [-0.6296672701893602, 4.195064839333869],
            [-0.632930827755462, 4.1963773954174926],
            [-0.6410958986976926, 4.191766393192884],
            [-0.6527559248011303, 4.188293907467758],
            [-0.6641633173213827, 4.186394393859445],
            [-0.6747060264268403, 4.186088835638272],
            [-0.6838707351376414, 4.188347588560369],
            [-0.6964555455304778, 4.192754443025001],
            [-0.705011911511227, 4.197404641443348],
            [-0.710876463454414, 4.197541715723429],
            [-0.7170751164856185, 4.19587204385595],
            [-0.7281936467677365, 4.190895834820908],
            [-0.7264977331248919, 4.281257969153175],
            [-0.7256299823404425, 4.335762181701077],
            [-0.7252789334050683, 4.407895121507891],
            [-0.7242153493434118, 4.509042380208573]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.39476826105752, "lat": 43.00898464980979 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46135"],
        "coty_name": ["Yankton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yankton County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01266975"
      },
      "bbox": [
        -0.7281936467677365, 4.1339383459870955, -0.3782065390198643,
        4.509042380208573
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.695443312874417, -1.8528542577839182],
            [10.698641107462658, -1.849670041229421],
            [10.704869512175762, -1.847398356454448],
            [10.70791010734514, -1.8478005334020118],
            [10.715432057504609, -1.8419931495498518],
            [10.716188460038191, -1.833335617652925],
            [10.719915217625529, -1.8304865060696465],
            [10.720505761217025, -1.8254842024541944],
            [10.724927274069415, -1.8264204752066802],
            [10.730123706173845, -1.8127536158834707],
            [10.732894674745534, -1.807168595519247],
            [10.742061460349076, -1.796246550436977],
            [10.74591487331258, -1.793606477508582],
            [10.74772556027025, -1.787796310338835],
            [10.753422315405025, -1.7824355519183854],
            [10.760445299409202, -1.7817074197606482],
            [10.76510901169643, -1.7748952349728622],
            [10.768979395118357, -1.7745039275134815],
            [10.768698391422802, -1.7701645569299882],
            [10.773759915756836, -1.7659061175905129],
            [10.777952394798225, -1.7594251236119738],
            [10.776361248651206, -1.7554668435891825],
            [10.781507685087151, -1.7530301085670783],
            [10.785943725000894, -1.7455627840020236],
            [10.788760523454487, -1.7425640612382265],
            [10.791629211336977, -1.7456298814517104],
            [10.795246648939338, -1.744269613493074],
            [10.797968382060166, -1.748427810345393],
            [10.804085906717663, -1.7424951494540217],
            [10.818656364616041, -1.7265380153761445],
            [10.828846467458217, -1.711588260897048],
            [10.828625823340943, -1.708060962600112],
            [10.832113692376316, -1.706249936599741],
            [10.831450333771633, -1.7027744817729662],
            [10.83401530931559, -1.695903091379936],
            [10.838223745103786, -1.6960355110181098],
            [10.841828413864123, -1.6923804820870216],
            [10.851877724325325, -1.6776489844460458],
            [10.855508407535021, -1.6741931548376077],
            [10.859064605780274, -1.6754687246988782],
            [10.86297158630235, -1.6739758734698575],
            [10.87304735440477, -1.6780808492926653],
            [10.878854740165194, -1.6728961893004812],
            [10.881305437291388, -1.666750150469876],
            [10.887467337524367, -1.6574213050512911],
            [10.894110309651941, -1.6498972801794882],
            [10.902686649135099, -1.6490118896447887],
            [10.907937205234777, -1.6421697653431082],
            [10.91009847565912, -1.6420730414014235],
            [10.912586923917685, -1.636225682874094],
            [10.917225114109518, -1.6394517685289203],
            [10.926705200109344, -1.6279573784641768],
            [10.930132661657941, -1.6309305862464298],
            [10.932386671790939, -1.6291901687192567],
            [10.93547697347199, -1.6317129744677592],
            [10.93902277412188, -1.6282640255667933],
            [10.943265698031036, -1.6280797480582678],
            [10.948039073358403, -1.6316927805381038],
            [10.952304992827962, -1.6293652424252834],
            [10.96200592759817, -1.6192478012650808],
            [10.967825028327278, -1.611361055080784],
            [10.972491028571628, -1.6034719845524819],
            [10.976841121830395, -1.6072892632088709],
            [10.983360718804969, -1.6084141082851038],
            [10.988149063599485, -1.605806192918817],
            [10.991838157884244, -1.6056966511194455],
            [10.995134542533433, -1.6027889359410206],
            [11.009661655913778, -1.5835290785444602],
            [11.01193528649949, -1.5813754247206824],
            [11.017983269074415, -1.581442467595537],
            [11.021264753180114, -1.5830190899012986],
            [11.026227139100941, -1.5765125071550061],
            [11.030298534981537, -1.5727681966604463],
            [11.084983157032646, -1.5565323948859717],
            [11.083797773358409, -1.562033469092354],
            [11.08770565605792, -1.5635146295150704],
            [11.091647292867638, -1.6106232005715],
            [11.097531498652485, -1.6789680573443455],
            [11.104710155884586, -1.7657729752351659],
            [11.0996931159564, -1.766180555862299],
            [11.102694746719827, -1.7720696415357589],
            [11.101927058019685, -1.7775550403891567],
            [11.10576410563907, -1.777076845597821],
            [11.106934160858325, -1.790954254050644],
            [11.103373536503467, -1.8004829821441537],
            [11.107837715186955, -1.8000334070057669],
            [11.110871129547101, -1.8304178509066136],
            [11.116310191287095, -1.828936668829676],
            [11.120117770811204, -1.8320997221900714],
            [11.118944264993043, -1.8363555065734345],
            [11.15974154389931, -1.874643529605761],
            [11.176432871563515, -1.8904281318900173],
            [11.168332440258506, -1.9134651825852573],
            [11.161543059185876, -1.9318231267757282],
            [11.155441272522925, -1.9275197826410557],
            [11.148401162641706, -1.9263788834424946],
            [11.148095155927434, -1.9190868000039591],
            [11.146715735059717, -1.9173464568423273],
            [11.138172956608827, -1.9124432342808146],
            [11.134570825896889, -1.9092853281561775],
            [11.13067105570888, -1.9097351814648083],
            [11.126020027835246, -1.9134492888275394],
            [11.12149253577198, -1.9191831140532112],
            [11.116039376409427, -1.921144434065159],
            [11.107749605161588, -1.926115682236945],
            [11.0966520417684, -1.9346091102600858],
            [11.093504501821922, -1.9426928633842289],
            [11.084416950412518, -1.9482510762913277],
            [11.0799442094621, -1.953260723501977],
            [11.07404557043432, -1.9556183415902435],
            [11.074226310918544, -1.961500960353418],
            [11.067651470148569, -1.9671106950403956],
            [11.062339288416181, -1.9684680453475119],
            [11.049522341957848, -1.9820821017706558],
            [11.046268177163224, -1.9842698986052578],
            [11.0377982491005, -1.9867818926600087],
            [11.029761270048972, -1.9908608613915144],
            [11.028127781082079, -1.9988218521824503],
            [11.024108608838755, -2.004052793078925],
            [11.025294734616597, -2.0142059998661033],
            [11.028724086241109, -2.017019010818385],
            [11.034568351479768, -2.018832942302797],
            [11.03301723493244, -2.024209557339923],
            [11.029050997111177, -2.0267300723328203],
            [11.027365034281212, -2.0400211930121843],
            [11.018184097325008, -2.049459741482889],
            [11.014746349693185, -2.056271167803686],
            [11.018285893256989, -2.063729380564511],
            [11.016929043642845, -2.0669342602928036],
            [11.012156779075704, -2.0679742380883877],
            [11.004271351913642, -2.074127407969832],
            [10.99984717210075, -2.066717778101095],
            [10.986086013763538, -2.056415165405646],
            [10.976086354807444, -2.0503040205091256],
            [10.969826253142006, -2.052864097606301],
            [10.958420207806846, -2.04908481903969],
            [10.944765397364325, -2.058633426958412],
            [10.940166918871089, -2.0593667091189265],
            [10.900570309616896, -2.0237952334167173],
            [10.885877163028487, -2.0108615455732766],
            [10.842877323643524, -1.9783143398979697],
            [10.81338782220784, -1.9540424833837755],
            [10.79981359789063, -1.943481592760261],
            [10.796119770802187, -1.9346510008559519],
            [10.79030291385439, -1.9301235280289046],
            [10.785749634833314, -1.92840293005701],
            [10.781721250580887, -1.9307022414973127],
            [10.774322881108631, -1.9208848854338463],
            [10.758655013897895, -1.9123082952616792],
            [10.757224731332284, -1.907002544064105],
            [10.753808992099298, -1.905981236335983],
            [10.749721166710097, -1.91073159347752],
            [10.748094271108164, -1.9158373820149441],
            [10.743851186766143, -1.917313845584017],
            [10.74181310590683, -1.905823326558089],
            [10.73175353776989, -1.906659290931956],
            [10.72736086392302, -1.9028795107520895],
            [10.723402685769937, -1.9016874307143283],
            [10.720560406818114, -1.8950493075567365],
            [10.711103491973395, -1.8872743150968339],
            [10.705925628112306, -1.8848229364731628],
            [10.698978324723592, -1.8830177274725792],
            [10.694521374605758, -1.8787360283976076],
            [10.693450411425902, -1.8750127112425914],
            [10.69573328465729, -1.8668636086993626],
            [10.694579944321823, -1.8589772628330998],
            [10.695443312874417, -1.8528542577839182]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.84579873453758, "lat": 36.1753332439675 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47059"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01639747"
      },
      "bbox": [
        10.693450411425902, -2.074127407969832, 11.176432871563515,
        -1.5565323948859717
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2480005381659804, 0.09085873465402665],
            [3.2535906791436235, 0.08733543702064654],
            [3.272003984260364, 0.08423147067658017],
            [3.275095676336441, 0.08280081685318019],
            [3.2867688531174832, 0.07065947488440172],
            [3.2893586861264814, 0.06479226003539573],
            [3.289155428713447, 0.058018251038454774],
            [3.27563060158039, 0.04432934146309411],
            [3.2741749822993023, 0.03838251563578611],
            [3.2789089073183852, 0.03180072206892879],
            [3.2845983748232817, 0.02886737081547256],
            [3.295011187696877, 0.025978975801654845],
            [3.3101440305681264, 0.024177199643991044],
            [3.3292039838418956, 0.020657138171705954],
            [3.3431054058303125, 0.012764038801482027],
            [3.3540929862571542, 0.0012612759950740384],
            [3.3624285212673137, -0.0006486015769620339],
            [3.3667076128558238, -0.0006645519991877565],
            [3.379452893273811, 0.0018815257690163775],
            [3.38632256937284, -0.0007356403156732748],
            [3.394934021914907, -0.006403297940546498],
            [3.399138848269171, -0.01324867315302993],
            [3.40126588055316, -0.020379056343445952],
            [3.4008590906953304, -0.03190055536112306],
            [3.4014715459993043, -0.03842654465755467],
            [3.4048928175463185, -0.04352141309440009],
            [3.4153589807453697, -0.05200703424965705],
            [3.4284998012057653, -0.061203048860324676],
            [3.4369997218399284, -0.06579246527727371],
            [3.448190993338554, -0.06991804919201301],
            [3.452442522221134, -0.07261646742615653],
            [3.4639171345869606, -0.07662716738872911],
            [3.4747758038338863, -0.07953048182994517],
            [3.484503029504715, -0.08096076906941896],
            [3.50781478918352, -0.08246745339236156],
            [3.5149374104964775, -0.08184079275037241],
            [3.540261838869299, -0.07388802984009162],
            [3.548000070832937, -0.0707006822549225],
            [3.552983902987951, -0.06695214651798091],
            [3.5576771540753866, -0.0775082079369695],
            [3.5494764450068264, -0.07814385410244515],
            [3.543409438545038, -0.08149987528885813],
            [3.5407272755827415, -0.08655018513043587],
            [3.5389485836976755, -0.10068575955339569],
            [3.539734075613963, -0.10619533335388384],
            [3.5424261735703575, -0.1146641858955335],
            [3.549634862614576, -0.12762810637428945],
            [3.556206833460501, -0.13843415570122514],
            [3.55643421189116, -0.1467625994152601],
            [3.5520758253533784, -0.15782237375713684],
            [3.5480314602618677, -0.16277843241233217],
            [3.5406705229566313, -0.16873400878850492],
            [3.5306781545536206, -0.1734189100844568],
            [3.524424597877878, -0.17388327034960313],
            [3.5147234817368336, -0.1732732105707524],
            [3.5072535874799176, -0.17414325683272672],
            [3.5009374048447923, -0.17589373655817972],
            [3.48670016415055, -0.18300725865226974],
            [3.479204931521531, -0.1847445887552064],
            [3.4746563568028406, -0.1847336264354105],
            [3.463630396528848, -0.1805529503564775],
            [3.4572509108234164, -0.17285600415726232],
            [3.4537485666866328, -0.17047885793235798],
            [3.446586861136624, -0.16849648612634271],
            [3.438595942186872, -0.17058025560654194],
            [3.43458265268498, -0.17411668857648088],
            [3.433517417456226, -0.17706513308024657],
            [3.437574498680645, -0.1847537749283487],
            [3.4388910895619804, -0.19388799440174595],
            [3.440615741504483, -0.20014772795268046],
            [3.4433371797109187, -0.20473095160244587],
            [3.45015482361008, -0.21243061458803633],
            [3.4587567059309223, -0.21589042987875254],
            [3.469617021807813, -0.22297424442705507],
            [3.4740093818686133, -0.22784805423546783],
            [3.477514758794552, -0.23568771972062455],
            [3.4779578214167515, -0.24082380564996608],
            [3.4759523737212157, -0.24686850281739287],
            [3.473121577590949, -0.25173408210476844],
            [3.4643985243094444, -0.25888916446718785],
            [3.4525870865014014, -0.26449584905551926],
            [3.4436136456654522, -0.26738562349390427],
            [3.4279317102321696, -0.26662012307871574],
            [3.426737149047646, -0.26887226280064713],
            [3.418575510515554, -0.2746600670648323],
            [3.4189953826427093, -0.3103163203425757],
            [3.3955459054258337, -0.31105290248136597],
            [3.3945730305445485, -0.31392018579751885],
            [3.3894263515363563, -0.31936534673474704],
            [3.37627224272404, -0.3249740385240911],
            [3.361842899912967, -0.3198607983092117],
            [3.353838463369188, -0.31401136523542295],
            [3.345670201698272, -0.3098844532601534],
            [3.338745944943986, -0.3097504152029764],
            [3.3350083345353254, -0.3125406009826119],
            [3.3155393501053427, -0.31267227476525555],
            [3.2527228784367965, -0.3109205947809057],
            [3.253335421093132, -0.22602793837665633],
            [3.1821482868332094, -0.22616438895346275],
            [3.186976783100706, -0.20373048356503637],
            [3.2145155971802857, -0.07146346761333412],
            [3.2226298696306324, -0.033257766749447824],
            [3.244607266932882, 0.07397774792997318],
            [3.2480005381659804, 0.09085873465402665]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.28170982509097, "lat": 38.50542569540245 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29051"],
        "coty_name": ["Cole"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cole County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00758480"
      },
      "bbox": [
        3.1821482868332094, -0.3249740385240911, 3.5576771540753866,
        0.09085873465402665
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.259730354644671, -0.9171069581767921],
            [4.2647247895389135, -0.9169954783860155],
            [4.262829685871985, -0.8729989200153577],
            [4.299240444679713, -0.8719370592959939],
            [4.310243753319318, -0.871756773944211],
            [4.376989466762906, -0.8691780400289889],
            [4.391127173164632, -0.8668176941013217],
            [4.391080010245125, -0.8681659795266519],
            [4.404696929167184, -0.8679255897611053],
            [4.461528724844223, -0.8685845732359204],
            [4.475318831468828, -0.8665898170521784],
            [4.476201063453137, -0.86847657980026],
            [4.503136572355507, -0.8664332916312817],
            [4.547236445978501, -0.8621418058799405],
            [4.563578651820758, -0.8593390315648852],
            [4.563762996979334, -0.8606758389417222],
            [4.582190819061833, -0.8596540030147874],
            [4.655237754655143, -0.8579723003835494],
            [4.657600241621437, -0.93416792781376],
            [4.658325145781638, -0.950841533995828],
            [4.703464311013654, -0.9483766083135197],
            [4.7322584047021365, -0.946465572666767],
            [4.746557659848697, -0.9435808215314099],
            [4.746629799949061, -0.9449703084736917],
            [4.749159712049633, -0.9895967267695891],
            [4.748388997561184, -0.990788940516546],
            [4.739549366856924, -0.9911211011376767],
            [4.742554304471154, -1.0356445731451656],
            [4.7452584062223, -1.0811259743755135],
            [4.748070794415587, -1.1450071301440685],
            [4.751097694401922, -1.208983153754985],
            [4.753981877799087, -1.2742696056695877],
            [4.755897721688893, -1.3196480880271324],
            [4.74130785832481, -1.3196456393323066],
            [4.72689321376302, -1.3205646538853242],
            [4.712425804301008, -1.322569819359052],
            [4.697310471821788, -1.323665459247817],
            [4.683760871671657, -1.3241560770865468],
            [4.668304992232703, -1.3224400687316071],
            [4.655884582991736, -1.324533485389022],
            [4.633192472725348, -1.3272202713731502],
            [4.625963111398875, -1.3275713013261776],
            [4.610541857980989, -1.329432722686156],
            [4.596292691977537, -1.3311584538964676],
            [4.594881241466543, -1.2861682334975304],
            [4.595653254828502, -1.2860638965046032],
            [4.593642298867619, -1.2274862889315696],
            [4.575340790688208, -1.2276232679517987],
            [4.5731656970438355, -1.1707436846788994],
            [4.570993415637174, -1.1243993165275006],
            [4.569792419666113, -1.0948097755323865],
            [4.5677110057678885, -1.0503010866868119],
            [4.565942582985661, -0.9962347523846322],
            [4.548514049628199, -0.9980957975850264],
            [4.513524693757127, -0.9992939631659032],
            [4.4780913977438095, -1.001222561419565],
            [4.3950477218769395, -1.004601090288735],
            [4.384672276632649, -1.006743501765818],
            [4.321970971417797, -1.02249485918026],
            [4.306655426715948, -1.0254823979956413],
            [4.263999357418592, -1.027336981212582],
            [4.262995214251929, -0.9979155014312528],
            [4.26235721220935, -0.9900614409944676],
            [4.260417915863617, -0.9471217741524111],
            [4.259730354644671, -0.9171069581767921]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.77344996629026, "lat": 37.55514647559166 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29093"],
        "coty_name": ["Iron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iron County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00758501"
      },
      "bbox": [
        4.259730354644671, -1.3311584538964676, 4.755897721688893,
        -0.8579723003835494
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.55213577298278, -1.3683484819043743],
            [1.551834951917916, -1.3423555481917457],
            [1.583757867663169, -1.342906328486385],
            [1.631106588051278, -1.3441129733371906],
            [1.6572166373845976, -1.3455446358779988],
            [1.6790601834999594, -1.3462985815163824],
            [1.7288115308752554, -1.3469298750661998],
            [1.7288003247456671, -1.3473844034537221],
            [1.7930379619987176, -1.3478660390630657],
            [1.8152329044927675, -1.3484892217028641],
            [1.9016941107936711, -1.3492473648374501],
            [1.9735292978758916, -1.3500547872779445],
            [1.973341515665286, -1.4090644377034978],
            [1.9981862596879005, -1.4093399811061946],
            [1.99820099656073, -1.4479783061294376],
            [1.9978580835397695, -1.5656983253246421],
            [1.9977409679533678, -1.6536198454222693],
            [1.8830275190496863, -1.6524337795665995],
            [1.8396672178131181, -1.651823984912197],
            [1.7538199333714803, -1.6525211715955108],
            [1.667210602349295, -1.652564189216348],
            [1.6520891535084283, -1.653140986547286],
            [1.609572398430288, -1.6531290725798051],
            [1.5846964062009523, -1.6527028153765486],
            [1.556082678433758, -1.6525852007666537],
            [1.5549888707370734, -1.595699134438248],
            [1.5548179058453735, -1.5763444546411067],
            [1.5537592822486392, -1.5270582308516836],
            [1.5537946190940664, -1.5193956719427795],
            [1.5530000390306522, -1.4455513523154642],
            [1.55213577298278, -1.3683484819043743]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.3406008016654, "lat": 37.20354787376974 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29097"],
        "coty_name": ["Jasper"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jasper County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "00758503"
      },
      "bbox": [
        1.551834951917916, -1.6536198454222693, 1.99820099656073,
        -1.3423555481917457
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.8551252732738672, 1.3880429764550277],
            [2.9776696912032157, 1.3932095791456187],
            [3.0208996696643307, 1.3947311668230138],
            [3.111313186546628, 1.3967536095398065],
            [3.143058367606289, 1.3978266554400003],
            [3.1951526152442757, 1.3998333661625442],
            [3.236065420670254, 1.4015952515420786],
            [3.237677537017921, 1.4016098262711],
            [3.238032850391835, 1.3905686205284922],
            [3.2395912804171614, 1.317010879023259],
            [3.282755317301403, 1.3178694225633456],
            [3.2840616743372424, 1.2592216247697745],
            [3.2847292351600568, 1.2042352731232295],
            [3.2849747609818025, 1.2017890220756848],
            [3.285594509313681, 1.156207558890497],
            [3.2861434017982174, 1.0548399619934543],
            [3.286891161370985, 1.0043288171855023],
            [3.287715458586599, 0.9674961468618964],
            [3.286529287288143, 0.9674539942371908],
            [3.2057565871686236, 0.9657055455036431],
            [3.1775994875490925, 0.9652581637173662],
            [3.13825378255577, 0.9641606939278381],
            [3.1104149815337054, 0.9637440764572767],
            [3.0448838238947866, 0.96236826688583],
            [2.9879017508975125, 0.9614083882591634],
            [2.987292866048315, 1.0060714194837126],
            [2.987414880157199, 1.0163697034809431],
            [2.986963869530067, 1.0500669856017777],
            [2.9293532781873726, 1.0495427938984387],
            [2.858458876464467, 1.0476132096208937],
            [2.858105103922259, 1.0772777697612081],
            [2.856876558372512, 1.1366731176056581],
            [2.856078074073873, 1.2248884657848949],
            [2.85607202138267, 1.2913611971774783],
            [2.8551252732738672, 1.3880429764550277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.56460871032773,
          "lat": 39.830776092681994
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29121"],
        "coty_name": ["Macon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Macon County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00758514"
      },
      "bbox": [
        2.8551252732738672, 0.9614083882591634, 3.287715458586599,
        1.4016098262711
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.4938309381590524, 1.894235577991261],
            [1.567742976293633, 1.8948863429552203],
            [1.6149248974299026, 1.8957160833449502],
            [1.7161884023321754, 1.8980480096889114],
            [1.753347894225956, 1.8987772429575036],
            [1.7948331644479925, 1.899926078240064],
            [1.7972473487698393, 1.7975666653610312],
            [1.8100221374523955, 1.7979133170515524],
            [1.8114787055360833, 1.7363641669277923],
            [1.811913211795395, 1.711002427058981],
            [1.7400470216913708, 1.7120920511287374],
            [1.6969382830043487, 1.711379820560605],
            [1.6260134105426431, 1.7098826798157774],
            [1.6116263712896948, 1.7098992680781562],
            [1.5218328320226122, 1.7086213526712648],
            [1.514165179765317, 1.7086136241569432],
            [1.5142304587060398, 1.7301826809440746],
            [1.5130763543986798, 1.7949480788016143],
            [1.4953713575405472, 1.794761732950887],
            [1.4937225443351667, 1.8879554900615851],
            [1.4938309381590524, 1.894235577991261]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.42211951338525, "lat": 40.47910439473371 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29227"],
        "coty_name": ["Worth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Worth County"],
        "coty_fp_code": "227",
        "coty_gnis_code": "00758566"
      },
      "bbox": [
        1.4937225443351667, 1.7086136241569432, 1.811913211795395,
        1.899926078240064
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.378125664130932, 7.3739840142709605],
            [-8.321620098592907, 7.366386209058811],
            [-8.23902668862078, 7.356028773915243],
            [-8.239495476379064, 7.352104247749676],
            [-8.149883393556266, 7.340520886043003],
            [-8.14604673591984, 7.3690256006116455],
            [-8.060496589679126, 7.358047887046867],
            [-8.056794596244758, 7.386584532164521],
            [-7.9709934374441485, 7.375661147580592],
            [-7.95032404879987, 7.535888094941328],
            [-7.937324066785882, 7.636121469264204],
            [-7.922087991450015, 7.63416424795122],
            [-7.90731465784406, 7.747913273179361],
            [-7.7929277468519915, 7.73348618428253],
            [-7.7893451198927925, 7.761883553680886],
            [-7.760686623213481, 7.758190649415763],
            [-7.757116740918215, 7.78646382644998],
            [-7.7284216915214685, 7.782821111642974],
            [-7.72479402780208, 7.811245567545859],
            [-7.6389650418487935, 7.800770104406366],
            [-7.631877673616853, 7.857565109650981],
            [-7.5194831473449035, 7.843710185067046],
            [-7.459716915443842, 7.836502258985831],
            [-7.470236475604834, 7.75136136078397],
            [-7.384256139149777, 7.741237579432671],
            [-7.2982783249460015, 7.731092448082989],
            [-7.3033695997139025, 7.688397420644873],
            [-7.217280028554778, 7.678540430679999],
            [-7.22246150250517, 7.635846027965302],
            [-7.144181953338031, 7.626818821148582],
            [-7.148578817216542, 7.589012255776478],
            [-7.105708035636368, 7.584219188870207],
            [-7.11060080958229, 7.541412043739751],
            [-7.1353399924785545, 7.5442397544830975],
            [-7.147392501214393, 7.441585925512001],
            [-7.101247014450543, 7.436238277469191],
            [-7.102060742062715, 7.42910722492402],
            [-7.019489445770281, 7.4196564975054144],
            [-7.021284751804297, 7.416248375094819],
            [-7.028497367960523, 7.352769534432695],
            [-7.03779887700392, 7.271726078610639],
            [-7.047533531151741, 7.186841264968614],
            [-7.057466723842981, 7.0994919945269706],
            [-7.065262822515217, 7.101511516720126],
            [-7.0846287072982665, 7.103898222850815],
            [-7.103748305045927, 6.93303898160027],
            [-7.076070723051273, 6.928321693660087],
            [-7.040248048625263, 6.924295221936396],
            [-7.033044195731622, 6.92301592012904],
            [-6.939361520561684, 6.9124930303864724],
            [-6.8456815596444685, 6.901946512839457],
            [-6.845382761566872, 6.904377900590732],
            [-6.761951055829048, 6.8953138285146425],
            [-6.750731346862004, 6.894100337353503],
            [-6.770815138964442, 6.7103507446394515],
            [-6.878582045795893, 6.722680111970551],
            [-6.986352620084179, 6.734978741806166],
            [-7.096403734849928, 6.7479310856654156],
            [-7.206458781999854, 6.760851341550511],
            [-7.322887271521984, 6.774722883918581],
            [-7.33947800634055, 6.777320940389144],
            [-7.346774946556772, 6.777673927957929],
            [-7.360962653303458, 6.781229265743598],
            [-7.376227991703441, 6.784347896902717],
            [-7.412291093295996, 6.788928995416654],
            [-7.544915120327043, 6.805357177302396],
            [-7.625888663513288, 6.815567543881694],
            [-7.725549148981749, 6.8268822104901465],
            [-7.813041061806899, 6.837745748272862],
            [-7.925772037217837, 6.851645395815638],
            [-7.991346586728802, 6.859757562387052],
            [-8.10007560131196, 6.873417018798851],
            [-8.147421679654386, 6.879481137379951],
            [-8.162555270170923, 6.880916740629752],
            [-8.159620601192874, 6.8837666130432105],
            [-8.160850906270657, 6.8876187139309675],
            [-8.166985237183246, 6.888090436231543],
            [-8.167522526491778, 6.890845033038812],
            [-8.16353615053721, 6.8945468634985385],
            [-8.1634878023718, 6.8992346707593795],
            [-8.158397622923035, 6.902623090823505],
            [-8.159696719655296, 6.907688509862987],
            [-8.158740635348213, 6.91224217031163],
            [-8.155390873779421, 6.91713627100892],
            [-8.151960482695232, 6.924500466482957],
            [-8.14635357126604, 6.9269256347351735],
            [-8.138565899239962, 6.924258743454383],
            [-8.1364352389552, 6.925194862014736],
            [-8.136634101116433, 6.930403549492211],
            [-8.145246122514063, 6.932750248625865],
            [-8.148477481658825, 6.9364556141701765],
            [-8.147634801100944, 6.941742778343363],
            [-8.141648088607491, 6.941843311245237],
            [-8.138538821175176, 6.944331014990872],
            [-8.13976830610409, 6.948973224829325],
            [-8.136375743275115, 6.952922565301054],
            [-8.132028842390486, 6.955607154789526],
            [-8.131256717974882, 6.963102273733994],
            [-8.12812709987367, 6.970910809223702],
            [-8.122391748519426, 6.9692614219317],
            [-8.120473123716929, 6.970186716104809],
            [-8.117923065402337, 6.9782458698318015],
            [-8.114560381079654, 6.979338845533085],
            [-8.114095314150788, 6.974626492093826],
            [-8.11048642414757, 6.972695509812453],
            [-8.107560795652445, 6.97384985425582],
            [-8.105303716049178, 6.979146419853236],
            [-8.106289513938647, 6.982776067591553],
            [-8.110534023883455, 6.985872196363068],
            [-8.110595177940706, 6.989727065715857],
            [-8.104043479636758, 6.985521173753941],
            [-8.099143821253229, 6.997603081881431],
            [-8.103628503752969, 7.002721881091805],
            [-8.102505601294904, 7.005309920270009],
            [-8.0927982267813, 7.004103359574022],
            [-8.089865782281231, 7.004715253074982],
            [-8.085056359024883, 7.009347693968518],
            [-8.085763560014785, 7.014414315166489],
            [-8.089710554622982, 7.016679554681046],
            [-8.087362695678328, 7.022543608571391],
            [-8.089530444547115, 7.030183488017586],
            [-8.085186603041207, 7.032890522542652],
            [-8.079804272862845, 7.032538589227887],
            [-8.078375453867215, 7.03517253599177],
            [-8.083231906317865, 7.038361701502316],
            [-8.083968421404863, 7.042090369851668],
            [-8.078459967640756, 7.0432486421413065],
            [-8.075802311525598, 7.038482655932736],
            [-8.072471569309362, 7.039282479049363],
            [-8.067732415009786, 7.054338022869521],
            [-8.064186674154946, 7.053750699940814],
            [-8.061671368480146, 7.0504838613474075],
            [-8.057325856589094, 7.049770969942999],
            [-8.063258121821994, 7.062756170541368],
            [-8.055163803012364, 7.061515455852686],
            [-8.057340387977016, 7.072561287988799],
            [-8.049220732692575, 7.077434914671916],
            [-8.048822898034508, 7.084624479988429],
            [-8.045891457969486, 7.082800530583575],
            [-8.037223213529693, 7.081887206222494],
            [-8.028510578888355, 7.084796039604953],
            [-8.133551746613986, 7.097813897008027],
            [-8.238596494335454, 7.110801804985339],
            [-8.343644760133753, 7.123759758659788],
            [-8.448696482088671, 7.136687753480088],
            [-8.435711130624021, 7.23090442763019],
            [-8.432773419416248, 7.237392744095717],
            [-8.433899612128672, 7.244912361968397],
            [-8.431205423979845, 7.265804851870979],
            [-8.415824609352477, 7.306714225606323],
            [-8.40788938620377, 7.346975733366458],
            [-8.378125664130932, 7.3739840142709605]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.48979624438597,
          "lat": 45.42336029704258
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30003"],
        "coty_name": ["Big Horn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Big Horn County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01716521"
      },
      "bbox": [
        -8.448696482088671, 6.7103507446394515, -6.750731346862004,
        7.857565109650981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.20718195416166515, 3.0700032824172374],
            [-0.06863487761465237, 3.0684484837997785],
            [0.05257374603021461, 3.067259996231964],
            [0.13474638740546063, 3.0665841169556662],
            [0.13405158562748357, 3.008090318382056],
            [0.1342050789380449, 2.934914194035348],
            [0.13385158331308758, 2.891258398307718],
            [0.13395747908282418, 2.847378096797118],
            [0.1409691394471669, 2.8473437239446673],
            [0.14058878235908137, 2.818152822734942],
            [0.14770266595133863, 2.8180572622659734],
            [0.14764387560299141, 2.8034389204080457],
            [0.1619730722434191, 2.8034951197379927],
            [0.16214353108667634, 2.7887586049800785],
            [0.17642062704428854, 2.7886267091780392],
            [0.1763180956555574, 2.774034863811085],
            [0.19065381701835035, 2.773676093746734],
            [0.19049714838775, 2.7593266250067425],
            [0.19767067993876364, 2.758871454736658],
            [0.2190702722626687, 2.759144572454799],
            [0.21923612959419042, 2.7292627635946323],
            [0.21885235349258855, 2.71536784035155],
            [0.11337857991874051, 2.7159147899398604],
            [0.1004005046850595, 2.71604663084405],
            [0.09740402088518364, 2.720240171336459],
            [0.09461886247776238, 2.7168074481670534],
            [0.08844911643676921, 2.7194474157362287],
            [0.08456713552767246, 2.7271164722605565],
            [0.07656189199234886, 2.7312260620940543],
            [0.06811832006796002, 2.738485031388102],
            [0.05553482380585937, 2.7465629670146754],
            [0.04778169651154939, 2.753158782177071],
            [0.04017429976366354, 2.7566498422424437],
            [0.013917762611912084, 2.75797557991373],
            [0.01162071497460553, 2.756594926180245],
            [0.007630429607831155, 2.7578658174205417],
            [-0.007874257621236403, 2.7580207820409823],
            [-0.012568308612311329, 2.75988340349139],
            [-0.02035968093869786, 2.7565154860212275],
            [-0.024075039311343645, 2.7531383120892543],
            [-0.03672137708404182, 2.7498883147721656],
            [-0.05305990127453304, 2.7498023520765895],
            [-0.059580792849897445, 2.753939556792938],
            [-0.06458844196340305, 2.754713672164538],
            [-0.07020618224408091, 2.7602856854722684],
            [-0.07490776833364, 2.76346826067777],
            [-0.08037561680214944, 2.769088176970592],
            [-0.091416934442294, 2.773940581238976],
            [-0.10521142857270112, 2.77389612072199],
            [-0.11211200489936306, 2.7746082935949365],
            [-0.1173380770862238, 2.772819856080841],
            [-0.12281248056694603, 2.7691050323169963],
            [-0.12964618505382342, 2.7693160247446884],
            [-0.13897615004184688, 2.7648073377935005],
            [-0.14552463320458914, 2.764929850063967],
            [-0.15926127639397364, 2.7708218575120527],
            [-0.16232017463353846, 2.7695955147875786],
            [-0.17164181165273001, 2.770463816078569],
            [-0.1773287518668365, 2.7744039626775545],
            [-0.18335053750862007, 2.775010436857907],
            [-0.19787128950947613, 2.7786741562064203],
            [-0.2099166101606423, 2.7788079372622225],
            [-0.20992303560846087, 2.7818753615792233],
            [-0.20963199462632345, 2.8214848777324137],
            [-0.20888262542647948, 2.8945494203325737],
            [-0.20838149790567903, 2.9528819300331692],
            [-0.20718195416166515, 3.0700032824172374]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.6539805712474, "lat": 41.57787949863241 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31053"],
        "coty_name": ["Dodge"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dodge County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00835848"
      },
      "bbox": [
        -0.20992303560846087, 2.71536784035155, 0.21923612959419042,
        3.0700032824172374
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9078308478434189, 2.0283648844048003],
            [-0.8584119295131495, 2.0274779974703936],
            [-0.7649569357467254, 2.0259263084721884],
            [-0.7012534911674898, 2.0249009605335573],
            [-0.686865263901603, 2.024524747957116],
            [-0.5648261973761607, 2.022694689267501],
            [-0.565453030276647, 1.9788214995848237],
            [-0.5669694080594334, 1.8825071032654603],
            [-0.568649844392147, 1.7739880216469925],
            [-0.5701004158784942, 1.671635411006606],
            [-0.625006394833607, 1.6726586059777369],
            [-0.741952804361366, 1.6744491209947447],
            [-0.8548660632259013, 1.676448751393523],
            [-0.8971274017352235, 1.6771111064986968],
            [-0.9115764096936968, 1.6775175014653736],
            [-0.9140672590242117, 1.6775612143985672],
            [-0.9124816378602139, 1.7653178149759794],
            [-0.9101692798192568, 1.8968927086584695],
            [-0.9078308478434189, 2.0283648844048003]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.59651108844987,
          "lat": 40.524649441474715
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31059"],
        "coty_name": ["Fillmore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fillmore County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00835851"
      },
      "bbox": [
        -0.9140672590242117, 1.671635411006606, -0.5648261973761607,
        2.0283648844048003
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.548098635966415, -1.1759120622682342],
            [-8.479660520661934, -1.1841203260032636],
            [-8.37214944815262, -1.1968863520768096],
            [-8.206090031563233, -1.216295990849822],
            [-8.121052616545114, -1.226090556880314],
            [-8.116051019118409, -1.2345023559896153],
            [-8.02235952348491, -1.2451668910329092],
            [-7.952119991176738, -1.2523161840251724],
            [-7.917417773040539, -1.2564965133418666],
            [-7.825685347799585, -1.2659136070664998],
            [-7.8065612551499886, -1.2679596584500767],
            [-7.7018345666129955, -1.2790764343004235],
            [-7.662663202925339, -1.2836899533768924],
            [-7.627542595293818, -1.2870950671167243],
            [-7.590435192052807, -1.291270192932592],
            [-7.510567977818927, -1.2991849775330495],
            [-7.436805633426262, -1.3064177198718745],
            [-7.438163458802935, -1.3147829834784195],
            [-7.437533320032445, -1.3255085037461025],
            [-7.434677914458947, -1.3310222361523065],
            [-7.433438959656125, -1.3422776716041853],
            [-7.42820187358259, -1.3630338306579726],
            [-7.427679018128551, -1.3810186394072204],
            [-7.4285742180333605, -1.3833084448563384],
            [-7.42240422947481, -1.4023009536267914],
            [-7.42125919561916, -1.418791501755354],
            [-7.425066217262495, -1.4391388205193194],
            [-7.426233542015664, -1.457872976996534],
            [-7.428516240402559, -1.4675106618014206],
            [-7.439145920631741, -1.4928998277112107],
            [-7.440355171693111, -1.5224087909726267],
            [-7.439657876172477, -1.5314109819882014],
            [-7.440190030353497, -1.53747243573478],
            [-7.442352091376812, -1.540551002876363],
            [-7.441460901198633, -1.5459241276734523],
            [-7.444118802628771, -1.5583183740450954],
            [-7.442937623397622, -1.562791374512563],
            [-7.443755320055566, -1.5779366645794297],
            [-7.4429286765615075, -1.5834458653464503],
            [-7.446679638953307, -1.5912635466960376],
            [-7.444907563476998, -1.5953419892372],
            [-7.446253536881147, -1.6040197834422474],
            [-7.443822173693556, -1.6102427853762802],
            [-7.444038568216189, -1.6131374905296345],
            [-7.441918582394909, -1.6227696318409992],
            [-7.443130618543588, -1.634442707965755],
            [-7.442018940427672, -1.6402788388357052],
            [-7.442396695647082, -1.646574138579174],
            [-7.4550527837845815, -1.6452119042792583],
            [-7.4566204737976625, -1.659604335666375],
            [-7.4542404101899535, -1.6579880130160838],
            [-7.446978960312565, -1.6582768522008502],
            [-7.4481124129361795, -1.6637253741597606],
            [-7.448052912021412, -1.6735379519332112],
            [-7.444121824632333, -1.6935029697833623],
            [-7.445373560713227, -1.6996593557574797],
            [-7.445553083185995, -1.7084205438822369],
            [-7.4429078713306005, -1.725314909472196],
            [-7.441277259184591, -1.7319394883212365],
            [-7.441098359145445, -1.7519172368025913],
            [-7.44023960649843, -1.765530284240817],
            [-7.444441927388529, -1.7685699721916077],
            [-7.4428641072575985, -1.7741436051730572],
            [-7.444227988398779, -1.7795410768980726],
            [-7.44421510948632, -1.7907151477698486],
            [-7.442835897042117, -1.7924285553144388],
            [-7.439099291867532, -1.8088429658067162],
            [-7.438232445442028, -1.821874549987527],
            [-7.439874298607269, -1.83189538030975],
            [-7.439172380092947, -1.8405641220928215],
            [-7.439819363219131, -1.8469313666652354],
            [-7.446534615913534, -1.8622316990525905],
            [-7.4535449995468515, -1.8738553338696564],
            [-7.457632688266587, -1.8889923761163854],
            [-7.458075218021913, -1.894662533412183],
            [-7.457133005231871, -1.9011152312314175],
            [-7.4589307777321086, -1.9122022403425207],
            [-7.4573648326373405, -1.9151981070602717],
            [-7.458706201009886, -1.9209694852120356],
            [-7.458604285637313, -1.9287549536821118],
            [-7.4594887852813665, -1.9340244108733182],
            [-7.464853026132675, -1.9456077378525696],
            [-7.465092521962656, -1.947975621015338],
            [-7.471556483167673, -1.9572720336486729],
            [-7.4766779647814205, -1.9597370335269861],
            [-7.478273067190263, -1.962182359855521],
            [-7.482605921665828, -1.9635846924979636],
            [-7.488398094763305, -1.9628457382340896],
            [-7.490656579691225, -1.9651022468295425],
            [-7.498219068076655, -1.9667719296585997],
            [-7.50053311733977, -1.9709781826079509],
            [-7.506025887911973, -1.973078568592862],
            [-7.511711413261603, -1.9718845384301087],
            [-7.517241272362747, -1.9751641216003828],
            [-7.5239687640060176, -1.973236101445523],
            [-7.531286720023735, -1.9749254809908958],
            [-7.542728232384438, -1.9879379583770276],
            [-7.5443152967900975, -1.9931311933350844],
            [-7.549455711014223, -1.995148374257857],
            [-7.550006641857523, -2.000567114086082],
            [-7.552222514525473, -2.0028924603395035],
            [-7.502346826200764, -2.0300146420952063],
            [-7.448536010277112, -2.0595170875622455],
            [-7.4308010623239005, -2.069058861163654],
            [-7.399239784740941, -2.0864663858411343],
            [-7.352753952829338, -2.16328109495676],
            [-7.333728766629554, -2.195275284877369],
            [-7.326600793467234, -2.2102992773668246],
            [-7.316454891498118, -2.2271518910563453],
            [-7.233335884183353, -2.283131476228892],
            [-7.223920927903275, -2.2888815714138873],
            [-7.161591117083688, -2.331202337432949],
            [-7.165247538542351, -2.3368662022353215],
            [-7.163572758132387, -2.3427133708737404],
            [-7.168060375263924, -2.3489208771073766],
            [-7.169200099597587, -2.352867369699732],
            [-7.186168554513824, -2.3580940370061363],
            [-7.1941322375981365, -2.366692250301375],
            [-7.199204275694658, -2.3685194946961614],
            [-7.203189025741739, -2.3669190484941827],
            [-7.211867674244057, -2.365845148742572],
            [-7.214266804196484, -2.3629084395282463],
            [-7.218842849989224, -2.364957914980203],
            [-7.2238834645506005, -2.365204589328817],
            [-7.235801730557101, -2.3601213855614063],
            [-7.239628101601719, -2.3597218939933984],
            [-7.246120775325016, -2.356536606178429],
            [-7.2540622152334455, -2.3644838155768224],
            [-7.257018615635732, -2.366253885345179],
            [-7.25831318445754, -2.3729609272076204],
            [-7.2637826809734465, -2.374816610070287],
            [-7.270541188903994, -2.375404331776368],
            [-7.272550631623714, -2.3716975082933724],
            [-7.278653587212957, -2.370138576605739],
            [-7.285198374218756, -2.364128743912471],
            [-7.291610686539559, -2.3626769735118884],
            [-7.295594469404301, -2.36547897129705],
            [-7.2974243440268864, -2.36351896458936],
            [-7.307437470804063, -2.3612727494615644],
            [-7.311144709975708, -2.352223957426491],
            [-7.314302405171144, -2.350438569606055],
            [-7.311340095454519, -2.3268398585897336],
            [-7.422040348224128, -2.3155939749261263],
            [-7.543017457981643, -2.302998798944872],
            [-7.594026038288653, -2.2976842837114817],
            [-7.594283826074237, -2.3002044158993318],
            [-7.589447699687151, -2.303528397057625],
            [-7.592446227336515, -2.308085811692154],
            [-7.591064730001368, -2.31084698553747],
            [-7.5830365836886715, -2.3115684848212887],
            [-7.582031124354687, -2.3152468545599065],
            [-7.58805941807635, -2.370507808481746],
            [-7.659245217072994, -2.3630708416041775],
            [-7.740676303578183, -2.3542026183300258],
            [-7.737535051609702, -2.325527737075131],
            [-7.739691778958842, -2.3252559568066706],
            [-7.738815108434473, -2.318310462482464],
            [-7.736850032757797, -2.31154753186694],
            [-7.736503254898868, -2.3043924581405535],
            [-7.734207488673365, -2.2831985412100773],
            [-7.7994937397746025, -2.276369120867698],
            [-7.8414136656335085, -2.272579577253073],
            [-7.848702033286018, -2.270811687322395],
            [-7.893707388407434, -2.266046689764184],
            [-8.156964676977827, -2.2387520190099615],
            [-8.200877473485468, -2.2340830570784513],
            [-8.235158247490903, -2.23022204440487],
            [-8.242859341286946, -2.2289616282153135],
            [-8.232091689592684, -2.1315184927729978],
            [-8.229621276644004, -2.1100306617633438],
            [-8.217550435825954, -2.0109435504326103],
            [-8.259325754198606, -2.0061638909777604],
            [-8.35147420855877, -1.9954130973252608],
            [-8.510470881668928, -1.9766963665387172],
            [-8.55085606531028, -1.9738517324920384],
            [-8.63491365394008, -1.9603110850075],
            [-8.686408709310895, -1.9545102249239945],
            [-8.7480358633071, -1.9457462726749113],
            [-8.761900685657569, -1.9429941605113488],
            [-8.80387035323113, -1.937938550157841],
            [-8.79667848590816, -1.8796514164159452],
            [-8.789172142209466, -1.8075225723375707],
            [-8.781955818414621, -1.764221186722608],
            [-8.778991424110426, -1.720923116068242],
            [-8.765645416809186, -1.6188424627679605],
            [-8.760191606748252, -1.5765805188397803],
            [-8.754974848872303, -1.5464904303822213],
            [-8.747086255442861, -1.4818027343762954],
            [-8.743906593857066, -1.4821892770497356],
            [-8.727084666887821, -1.353158751905631],
            [-8.7243347888533, -1.3574604492164153],
            [-8.717882295133245, -1.3606217956064837],
            [-8.71577698911946, -1.3586377494549606],
            [-8.71862524544345, -1.3522701646401905],
            [-8.717065294354732, -1.3476464099659007],
            [-8.707557408696246, -1.3494377618546418],
            [-8.7051720932592, -1.346650870863622],
            [-8.707184232149137, -1.343769449361371],
            [-8.711265671186002, -1.343893471380078],
            [-8.71178434375927, -1.3382571005001431],
            [-8.708860549905344, -1.3336001243332685],
            [-8.709906438217626, -1.3288763540600617],
            [-8.707494773890383, -1.325018896293898],
            [-8.700527694746144, -1.322930795583912],
            [-8.693213451102922, -1.325932565754321],
            [-8.68890686923362, -1.3200327555194358],
            [-8.684325436145471, -1.3196078377462257],
            [-8.680650116835803, -1.3164187838218404],
            [-8.680264777792212, -1.3104488740276834],
            [-8.676297687434054, -1.3070238168642552],
            [-8.67167815508702, -1.3062266372126123],
            [-8.670664510009534, -1.3104953113432056],
            [-8.665866754424172, -1.3148354630455352],
            [-8.661956437164713, -1.3139368431008738],
            [-8.658511747588173, -1.3092045805767494],
            [-8.651430051863759, -1.3114814754972361],
            [-8.651042324084294, -1.30482557466518],
            [-8.648259450625256, -1.2980161569802842],
            [-8.643402415492124, -1.2909895334655956],
            [-8.637470652086964, -1.288663274923421],
            [-8.631064704479249, -1.2929620924996172],
            [-8.629200225961146, -1.292922445262005],
            [-8.628075172299107, -1.2866012902554902],
            [-8.625098622709915, -1.286924560152302],
            [-8.62258654235327, -1.2923018697168742],
            [-8.619390144264008, -1.2925580529631018],
            [-8.616495827606176, -1.2868208590987265],
            [-8.611959434527424, -1.2845245765339155],
            [-8.604910847282687, -1.2769972938116065],
            [-8.59971908886705, -1.277656428380402],
            [-8.592083264873786, -1.2746478336862306],
            [-8.58878586916459, -1.2746354240393147],
            [-8.587416980716464, -1.2713969632611963],
            [-8.583720486531655, -1.269187603742293],
            [-8.581971633082137, -1.2623478253944636],
            [-8.577822552092726, -1.2583780383737704],
            [-8.581502909966188, -1.2519955951283432],
            [-8.583269549779448, -1.2416848144382293],
            [-8.58283476282951, -1.2332246637864563],
            [-8.576365620419809, -1.2285291493859565],
            [-8.579169074335702, -1.2252705506800279],
            [-8.581898872740707, -1.2194318797588186],
            [-8.580400687829759, -1.215258210154187],
            [-8.573767153734094, -1.2122612872280283],
            [-8.573097186281815, -1.2087814312780143],
            [-8.565129623483184, -1.2059238960970198],
            [-8.559345099902902, -1.2049524001859164],
            [-8.557540651644786, -1.201246540456128],
            [-8.558029666714704, -1.1885982797045236],
            [-8.555124773464174, -1.1865383589075837],
            [-8.554315617984406, -1.1819526357163428],
            [-8.550228109445177, -1.1796703686029],
            [-8.548098635966415, -1.1759120622682342]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.69313955976004,
          "lat": 36.509581058222864
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35039"],
        "coty_name": ["Rio Arriba"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Rio Arriba County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01702368"
      },
      "bbox": [
        -8.80387035323113, -2.375404331776368, -7.161591117083688,
        -1.1759120622682342
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.740277522698197, 4.986664064985879],
            [12.74126765296781, 5.007604345045577],
            [12.744179630706443, 5.008889606461719],
            [12.746718881805645, 5.0127012881109145],
            [12.7468260600101, 5.021255786098955],
            [12.750206887391295, 5.022933796252437],
            [12.75092140152625, 5.032928850606023],
            [12.75686201880071, 5.041487201647987],
            [12.758854659607627, 5.043131152009909],
            [12.761002142771007, 5.051499712657183],
            [12.766692625601157, 5.05441525313646],
            [12.769630509654288, 5.063469522586971],
            [12.773605812170663, 5.064080336412883],
            [12.779586013671898, 5.070041040783285],
            [12.776563834649581, 5.089782068095184],
            [12.77726516413822, 5.096551263495255],
            [12.781011186788112, 5.101759999780517],
            [12.78124365833412, 5.109276886604706],
            [12.783504398116477, 5.118185227653556],
            [12.786238522559465, 5.118746511954514],
            [12.794178748612081, 5.1254660881808505],
            [12.796812657575524, 5.125297042699866],
            [12.801285746570272, 5.130816982968573],
            [12.804684146174472, 5.131368226781755],
            [12.810324964658323, 5.136460503772492],
            [12.813933499809771, 5.136261924026805],
            [12.820963871139444, 5.139191047276534],
            [12.829419711708882, 5.14729841449168],
            [12.834438130836968, 5.1535495726089335],
            [12.835141103797774, 5.157135538682803],
            [12.840127923117253, 5.159943718996561],
            [12.849967470821374, 5.171510441465418],
            [12.856047412080281, 5.173292441520388],
            [12.867693078784253, 5.180112358459956],
            [12.873398881193241, 5.18935476886562],
            [12.877205351654753, 5.192604092392784],
            [12.899153869153928, 5.220924128845627],
            [12.902024277077796, 5.2294204710726815],
            [12.905736903790588, 5.234563917712816],
            [12.903801997166367, 5.244609990266932],
            [12.900641398000268, 5.250236034305001],
            [12.898488260576995, 5.2502523623679185],
            [12.885584743819857, 5.270331606563865],
            [12.884861890472797, 5.273767947563967],
            [12.885969382958587, 5.279541985667172],
            [12.890022359567567, 5.27880125514446],
            [12.892467933864832, 5.281023832369876],
            [12.890812614687205, 5.2863127080731855],
            [12.892638311018072, 5.288005354179128],
            [12.884435928882317, 5.3008721563010965],
            [12.880116004566785, 5.299305472112136],
            [12.869839512357691, 5.31285928477218],
            [12.862731255956675, 5.321150688764643],
            [12.863943711737106, 5.323637293706126],
            [12.860150067008696, 5.329005302524155],
            [12.847209509203337, 5.3413990269471565],
            [12.843183693432842, 5.365130255425018],
            [12.838895674167603, 5.374429406818251],
            [12.829503019105998, 5.386570113660832],
            [12.818217770777025, 5.393688094076874],
            [12.796823886695394, 5.391757313739109],
            [12.785328276549073, 5.400876545435802],
            [12.756243282977781, 5.412426352066049],
            [12.748531642062204, 5.420704108543404],
            [12.742316199587183, 5.441559438265092],
            [12.748286620299702, 5.455449549687529],
            [12.749771228370559, 5.474127197373785],
            [12.752258373321766, 5.483729879491804],
            [12.745021112297424, 5.492293423212619],
            [12.735978820573226, 5.492878899152931],
            [12.742529700446095, 5.4957111125144005],
            [12.759796675180658, 5.4977999056864695],
            [12.785518234730917, 5.501725845905072],
            [12.789039826936808, 5.501446157382605],
            [12.815358332860576, 5.493776637267052],
            [12.819977908135339, 5.491373556850838],
            [12.828173863884556, 5.485329246859813],
            [12.831645085602107, 5.4794703094614],
            [12.836208418450132, 5.466844067720744],
            [12.839110460964077, 5.465085772745081],
            [12.841992140888422, 5.467484144297368],
            [12.846554307539188, 5.465668910244266],
            [12.851607519765828, 5.468319063587555],
            [12.860550699212311, 5.468713819251527],
            [12.864852734198658, 5.466644899812102],
            [12.873327880580566, 5.468386882751942],
            [12.876771166248796, 5.473807198756876],
            [12.878035954577575, 5.479630339544036],
            [12.880763322262872, 5.484190135411472],
            [12.878710376136747, 5.489811791961352],
            [12.873189549893446, 5.497414638278108],
            [12.874863591546514, 5.501127349804686],
            [12.885745306501384, 5.503420057660505],
            [12.89170009457645, 5.508087451398118],
            [12.888837708137324, 5.513622119084595],
            [12.891622425974452, 5.518852024432082],
            [12.90234567579557, 5.521595144556868],
            [12.908463867694985, 5.521548618546057],
            [12.914455272057081, 5.52733401635256],
            [12.921356737789125, 5.529510336648032],
            [12.927294187995734, 5.528893308247349],
            [12.932755054578704, 5.531614604905542],
            [12.937189748898785, 5.5459262615730625],
            [12.941376295612294, 5.548708484158936],
            [12.948165753881248, 5.544714564511269],
            [12.950051188068297, 5.546926745830563],
            [12.954631560026915, 5.547388741719207],
            [12.955346674610361, 5.551967246122825],
            [12.963023477834533, 5.552809711469369],
            [12.966576455045667, 5.555833709082844],
            [12.969785411906802, 5.554178266419804],
            [12.973528279919545, 5.548933168933969],
            [12.97559174278696, 5.553371702159487],
            [12.97893808713925, 5.553270198371885],
            [12.986988452614778, 5.557225473488875],
            [12.993685585486082, 5.554903880234877],
            [13.000272940479991, 5.554786181906715],
            [12.997793638328785, 5.5625325875240925],
            [13.00233821090434, 5.564432288921973],
            [13.00065300422519, 5.568108468339078],
            [13.003149869828663, 5.569681757149739],
            [13.00944401904146, 5.568667684062919],
            [13.008055071858957, 5.56578164911001],
            [13.013418393871845, 5.560814023726503],
            [13.018555906582248, 5.564134693234623],
            [13.023800563893706, 5.561234110841139],
            [13.021496143882219, 5.554955037267384],
            [13.029994841406674, 5.554171210012639],
            [13.032014151781638, 5.550921095448358],
            [13.037906758378039, 5.552457852180894],
            [13.040605144601464, 5.556709797558958],
            [13.044569432474189, 5.554338681451208],
            [13.046681425211325, 5.556805500815697],
            [13.047520901092431, 5.562069538294705],
            [13.043216980677615, 5.56575777416804],
            [13.044799021041497, 5.57048077531398],
            [13.054870912644407, 5.571357377713317],
            [13.057141210248215, 5.572724089573775],
            [13.057322085346287, 5.577590771590234],
            [13.061478386326208, 5.575346914292494],
            [13.066233515543663, 5.578487981566113],
            [13.065950595997096, 5.582182064536951],
            [13.068817940737159, 5.584847289545474],
            [13.071871058463374, 5.583164528251407],
            [13.06925402575596, 5.579430970208353],
            [13.069455938078692, 5.576385451617763],
            [13.074996346897851, 5.572968124812131],
            [13.077915219940644, 5.573099800663726],
            [13.0830811377529, 5.577189381006038],
            [13.087429461177596, 5.5775666830505575],
            [13.091588388708336, 5.580771351036679],
            [13.091494090873667, 5.585164134033837],
            [13.09902591283774, 5.585487598813297],
            [13.099370361284567, 5.581746707346308],
            [13.10264097392251, 5.580322183294295],
            [13.104471130394407, 5.575966949924002],
            [13.109279262371727, 5.5773876601806185],
            [13.1122235234384, 5.5766236412295065],
            [13.114641624298843, 5.580587021582712],
            [13.124109025997488, 5.580347918903348],
            [13.128609752575802, 5.582981350015541],
            [13.12861082827151, 5.585765602912019],
            [13.137682278233536, 5.539795351889651],
            [13.14349765951147, 5.511880905169277],
            [13.151440495867503, 5.464536224460969],
            [13.163865112855115, 5.400073683253987],
            [13.169494554192841, 5.367958978200471],
            [13.15380008882381, 5.365203637460775],
            [13.155677840358953, 5.355181035806635],
            [13.168618595611026, 5.279277694225745],
            [13.186290375139334, 5.282550333271925],
            [13.191134743970654, 5.256362930734401],
            [13.201774113597583, 5.197226060028929],
            [13.207231109931028, 5.170239971115848],
            [13.218174901321625, 5.118071790283114],
            [13.230934295089664, 5.042010732137849],
            [13.228080961060114, 5.038423097324569],
            [13.22307179973469, 5.038574258676054],
            [13.217592811721644, 5.0360667416423475],
            [13.213523691931657, 5.037237504977375],
            [13.212322512606457, 5.032111674745496],
            [13.20799129461759, 5.031150855563253],
            [13.207222474170297, 5.028864746544901],
            [13.198203374609486, 5.027223663241505],
            [13.198590060512222, 5.02453193956469],
            [13.19438192100728, 5.017692790916028],
            [13.187709518427743, 5.019337278068242],
            [13.185061526566942, 5.017947498902563],
            [13.184634643634057, 5.013799867640753],
            [13.181096809974834, 5.013748540657304],
            [13.181064741049235, 5.010158378447123],
            [13.174544870204816, 5.012623712640358],
            [13.170409191325138, 5.005716184530593],
            [13.165349045716857, 5.005738035139772],
            [13.164182292831008, 5.001523224017444],
            [13.156876636850617, 5.002005589189291],
            [13.149660303602591, 5.004432261484977],
            [13.14674396573587, 4.998497023238143],
            [13.139544167670701, 5.000949206380793],
            [13.132644343226522, 4.993298146243172],
            [13.131713214058484, 4.990341961615373],
            [13.123029512877439, 4.989244459254255],
            [13.120686573416288, 4.984600001846011],
            [13.115666788858894, 4.980150031335834],
            [13.112114184873445, 4.980983726347982],
            [13.108406648423172, 4.9729555221287125],
            [13.105232967825227, 4.974168266901349],
            [13.096050305712732, 4.972298618181983],
            [13.095687587070792, 4.969111118927878],
            [13.088573808311963, 4.9651738512616],
            [13.088029792677172, 4.9617716362869375],
            [13.08343172711366, 4.960487002618361],
            [13.084108962253229, 4.955523773764469],
            [13.08207476612393, 4.95253729300901],
            [13.078014062765169, 4.952837218616972],
            [13.076182219725307, 4.9475686021487055],
            [13.071628666399176, 4.950838172289403],
            [13.070061166868369, 4.959706006679246],
            [13.060205090648084, 4.957756743813377],
            [13.049985393933127, 4.953759532722873],
            [13.049342534600092, 4.950264375590085],
            [13.043231396969508, 4.948288704524282],
            [13.04524399037448, 4.945652577335259],
            [13.04387387688704, 4.942761481931054],
            [13.03790195670376, 4.9429506768896],
            [13.03664110671894, 4.937757423515152],
            [13.030638949399318, 4.93443080203916],
            [13.03200841328589, 4.931205718127778],
            [13.027291606707356, 4.928325395537881],
            [13.021728021060134, 4.93084883668569],
            [13.023785399984124, 4.9230189641481035],
            [13.01747520289163, 4.9198994559369735],
            [13.006158905018767, 4.925480741932152],
            [13.002766920978662, 4.924263900413196],
            [12.998767326372713, 4.919894635613943],
            [12.995995446536307, 4.91976775876579],
            [12.988726063735195, 4.9101449331703],
            [12.985002282878595, 4.906941029215052],
            [12.981656816882603, 4.907030508084513],
            [12.97943185909432, 4.901286182115771],
            [12.974037464467726, 4.901452934862974],
            [12.969300687708804, 4.898452171799976],
            [12.956947972435684, 4.895465067889329],
            [12.954826391458996, 4.892578440429845],
            [12.950029195480449, 4.893939085598221],
            [12.945420697022119, 4.889822816777011],
            [12.943160610231057, 4.893076306155882],
            [12.940027204208878, 4.889614307219294],
            [12.937003280113828, 4.89063685143091],
            [12.93377510103305, 4.897424196096621],
            [12.92916745694991, 4.894735260078316],
            [12.92437461306961, 4.895588661196859],
            [12.920567423955813, 4.88942802101884],
            [12.917598162736482, 4.890783307770616],
            [12.918516603219306, 4.899918739959158],
            [12.912376277434403, 4.904354980761455],
            [12.904714932363971, 4.908042562689059],
            [12.901540190519235, 4.9116857359350075],
            [12.892200708809948, 4.910823291217894],
            [12.887310234267707, 4.913806393139508],
            [12.880138147470456, 4.927007556464042],
            [12.880433284469381, 4.934633220814574],
            [12.876606253429914, 4.933617305344102],
            [12.868877433135443, 4.941238694264549],
            [12.866627748473627, 4.9410866206001645],
            [12.86174405611513, 4.945791798363036],
            [12.861718938779536, 4.949130375773775],
            [12.858041786708197, 4.950069182267757],
            [12.857749356210736, 4.956113584937118],
            [12.854477706746742, 4.959916286329952],
            [12.852115849508719, 4.965423484260928],
            [12.84904830600446, 4.967465750714309],
            [12.845494343648465, 4.966855077324491],
            [12.839114782576683, 4.969748962786171],
            [12.835485138467659, 4.967960675490525],
            [12.819778207354943, 4.973897972156256],
            [12.815931199917863, 4.96750060414464],
            [12.807462221185544, 4.967452444834182],
            [12.806099008196092, 4.9642747769788365],
            [12.800803430923875, 4.964961303031986],
            [12.78735506912939, 4.970575256878064],
            [12.783221734777284, 4.97048324095653],
            [12.779244796018041, 4.975466773029764],
            [12.78322841052513, 4.978156778664053],
            [12.78120712961086, 4.980593672711385],
            [12.776724538659133, 4.979094780030502],
            [12.772326698253385, 4.983427498840317],
            [12.770794062998602, 4.986711915842138],
            [12.767207299546344, 4.9839388846668005],
            [12.763434548429073, 4.98500430548323],
            [12.764104430749839, 4.989284945421089],
            [12.760617370439705, 4.990710182693965],
            [12.75605506910466, 4.989736103004942],
            [12.751559476946364, 4.984264305479718],
            [12.74910622947139, 4.983447866272399],
            [12.740277522698197, 4.986664064985879]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.73224926122961, "lat": 42.76393709934152 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36029"],
        "coty_name": ["Erie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Erie County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "00974113"
      },
      "bbox": [
        12.735978820573226, 4.88942802101884, 13.230934295089664,
        5.585765602912019
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.705599611182143, 7.238300604616591],
            [14.726798617630104, 7.272291468955173],
            [14.727555063054815, 7.312538804785268],
            [14.747096238481948, 7.3616940114230065],
            [14.768610934401217, 7.393734978544954],
            [14.784516278785105, 7.422349176144014],
            [14.803090171735189, 7.451114879579901],
            [14.827739518404861, 7.484606775666895],
            [14.84755545804289, 7.518264189812637],
            [14.887446793682773, 7.584425030023154],
            [14.903775954823171, 7.603370604060133],
            [14.93319776451978, 7.646486725530812],
            [14.936734951341164, 7.663733951868476],
            [14.94814827687137, 7.667176709812681],
            [14.953402088985206, 7.674992354119103],
            [14.964837706581207, 7.680391298088123],
            [14.9638054288294, 7.685434333564047],
            [14.97674857001298, 7.709690377171076],
            [14.984809518300754, 7.708647694487738],
            [15.002392585582598, 7.7330970190621295],
            [14.996282240883808, 7.742102600382957],
            [15.010537823378368, 7.757777127199569],
            [15.019531511497272, 7.765813537751478],
            [15.027779813614284, 7.770199632064709],
            [15.035579872857861, 7.7813757742082075],
            [15.044125785379743, 7.784213316932482],
            [15.048973030455128, 7.795109604961904],
            [15.059726202254666, 7.797456483366467],
            [15.064795716163205, 7.803734941768632],
            [15.06866369744406, 7.805192501484501],
            [15.08245476893895, 7.818506630506066],
            [15.099158247424143, 7.825611610919043],
            [15.098903051220844, 7.844278994122189],
            [15.109162659409723, 7.852891118495981],
            [15.118173373588073, 7.853054263820519],
            [15.122343579275386, 7.861628428773853],
            [15.143783526708303, 7.868801541549533],
            [15.146015288507535, 7.874502725852026],
            [15.166037373800425, 7.8911454345169645],
            [15.178590855271729, 7.905966863003101],
            [15.180732551557377, 7.914087091772762],
            [15.179743229991066, 7.919678719579457],
            [15.18295754773988, 7.926301131034434],
            [15.195635555371927, 7.935175528871381],
            [15.213120897484124, 7.940357103066296],
            [15.240095459463337, 7.945051693392027],
            [15.243000900150543, 7.955252677017697],
            [15.250276424581767, 7.964292961475116],
            [15.257290841577651, 7.967200258968227],
            [15.264768825198109, 7.968034453686788],
            [15.266626298178748, 7.97257302329116],
            [15.270925685306262, 7.973467905128289],
            [15.276708537867156, 7.9806258631565274],
            [15.283660557172754, 7.986650687917971],
            [15.28897367876064, 7.9890288566253425],
            [15.296346636383559, 7.986492400943836],
            [15.298652378615882, 7.988855313498739],
            [15.306429558283183, 7.991644821378372],
            [15.30849197340083, 7.988181365970685],
            [15.314473531084325, 7.983363485319556],
            [15.334738713918059, 7.988902747177391],
            [15.33930372198392, 7.979082850435103],
            [15.350999733242025, 7.977273200283185],
            [15.360220392816913, 7.979193111393739],
            [15.36272682664123, 7.984274681351659],
            [15.376109335175478, 7.944724132240624],
            [15.430235375386621, 7.95655731878248],
            [15.473985721242189, 7.82656205275407],
            [15.504729227510543, 7.7352296567632495],
            [15.51877809839163, 7.695631084746509],
            [15.577719135988737, 7.5274564781962505],
            [15.614783629736106, 7.420277577878412],
            [15.625808481757717, 7.388855640786797],
            [15.670325029801198, 7.263887139566563],
            [15.685868556762752, 7.217508765749966],
            [15.67304100681405, 7.213336816500364],
            [15.695307187797354, 7.146744405761555],
            [15.618275119023725, 7.118089169529229],
            [15.557727664958657, 7.095685415443521],
            [15.550148463194862, 7.093297657258839],
            [15.47916579142866, 7.068061295137126],
            [15.408464459717097, 7.042225691006065],
            [15.337769162079201, 7.016376298079592],
            [15.254422239570161, 7.044373236095522],
            [15.254159242959522, 7.045198655510044],
            [15.190784009364616, 7.06495131016281],
            [15.170022777280469, 7.072594348523854],
            [15.141545226357474, 7.081597988741002],
            [15.123383962341002, 7.088692649723848],
            [15.03360353540669, 7.120088913157128],
            [15.003214583605981, 7.131578092612989],
            [14.961825713184199, 7.146443978214776],
            [14.906632645608111, 7.165723329926833],
            [14.863482291701422, 7.180270180324827],
            [14.84508901041782, 7.186260323658975],
            [14.829327161041071, 7.19188982849265],
            [14.804675273694938, 7.201565584948333],
            [14.79200672412076, 7.20585038394277],
            [14.765797679472682, 7.215369441897596],
            [14.705599611182143, 7.238300604616591]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -75.06908180597452,
          "lat": 44.496389353808695
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36089"],
        "coty_name": ["St. Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Lawrence County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00977309"
      },
      "bbox": [
        14.705599611182143, 7.016376298079592, 15.695307187797354,
        7.991644821378372
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.330355238042138, -1.0897126380768392],
            [15.324951836176204, -1.0864874026283489],
            [15.32541497151814, -1.0830723070129955],
            [15.321346676015793, -1.0780618948283107],
            [15.321074338759004, -1.0733383169329893],
            [15.323616203711842, -1.069893700645097],
            [15.322100423453167, -1.0656083171217305],
            [15.323228559445937, -1.0612455437443047],
            [15.319059404305202, -1.0569848287896317],
            [15.317307419020203, -1.0518038327636938],
            [15.321271049818343, -1.0479851217369978],
            [15.333339872694502, -1.041804042409498],
            [15.338949131422245, -1.0414398329164738],
            [15.342233667524292, -1.037080142208368],
            [15.349148474088802, -1.0343703221249896],
            [15.35493046102772, -1.0338107979518085],
            [15.358753381494957, -1.0359757018481286],
            [15.36511500502537, -1.0358100330801565],
            [15.370299411789398, -1.0343314170590365],
            [15.369833017934345, -1.0313535142133725],
            [15.379979108108516, -0.9992771158908302],
            [15.400562625325918, -0.9990144094715263],
            [15.538188271935006, -0.9750995645846507],
            [15.555268664023284, -0.968560812480692],
            [15.567349256741606, -0.9702010206092403],
            [15.588189807016915, -0.9626305750789379],
            [15.600753612482832, -0.9613536082445295],
            [15.619630351358301, -0.9545725551491321],
            [15.670960470916052, -0.943801220598295],
            [15.761269990521498, -0.924742455139236],
            [15.761661283636808, -0.9377359299142101],
            [15.75315948270747, -0.9347077203989986],
            [15.749274454282787, -0.9422217183619337],
            [15.749179163858486, -0.956860563346415],
            [15.74619686004793, -0.9612274280317802],
            [15.746931737738029, -0.9685843116647945],
            [15.750714634831388, -0.9747239167446868],
            [15.748298827880397, -0.9799623550676898],
            [15.7504534117793, -0.9961228633840846],
            [15.753344882912913, -1.0026452815176652],
            [15.752418233678323, -1.007579850875202],
            [15.753846067377014, -1.0173687558384898],
            [15.755815637288718, -1.0250714130895267],
            [15.762776086273067, -1.0400561367602676],
            [15.767965583894586, -1.0445279727914258],
            [15.772398745360928, -1.051924227269624],
            [15.777724521822945, -1.0589411690813109],
            [15.780316606840582, -1.0649361745677066],
            [15.783914565374037, -1.0663736575029974],
            [15.788281224609124, -1.0712341430120929],
            [15.788859364510156, -1.093258279815993],
            [15.796349373708127, -1.107948830717434],
            [15.80435727226154, -1.1175862858100922],
            [15.815223234102392, -1.1209614931177676],
            [15.814184473479253, -1.1256619956991172],
            [15.818946630188707, -1.1355737181240773],
            [15.823174759061494, -1.1523298123973298],
            [15.828742375076642, -1.151975929213607],
            [15.838029764663597, -1.1536288563544366],
            [15.840879196483106, -1.1591708480182974],
            [15.844610231891508, -1.1695083030430893],
            [15.833636195505763, -1.1880162732896897],
            [15.828987788971963, -1.1909551185806964],
            [15.820353373235076, -1.1997499094987214],
            [15.81719251614847, -1.2105714015402265],
            [15.818793990324355, -1.2232680367187623],
            [15.815636773154923, -1.2265179664542292],
            [15.815417923052173, -1.2299828547712894],
            [15.81957369162846, -1.2323684091358034],
            [15.827119427457509, -1.2271466939217028],
            [15.834278548930074, -1.217707810137675],
            [15.841965110117323, -1.2190049846660216],
            [15.845467110185536, -1.2179039938369325],
            [15.84602720765847, -1.2265253995482506],
            [15.842880240667496, -1.238450487866901],
            [15.83531596565967, -1.2402553761919772],
            [15.82942137083121, -1.247154033120151],
            [15.827958010219497, -1.2528248124123083],
            [15.828825125299941, -1.2587013804860303],
            [15.827068602528174, -1.266352306111086],
            [15.826573071338986, -1.2774407368153011],
            [15.82387840912863, -1.2879229449984284],
            [15.818866702775377, -1.297148134779112],
            [15.813716179422423, -1.3023554031287103],
            [15.8081269422906, -1.3054727876642946],
            [15.79997090377494, -1.3093622296853633],
            [15.792295559524666, -1.3097657879295814],
            [15.778520524138006, -1.3028338592933224],
            [15.771404160862392, -1.295716220598479],
            [15.767840209292201, -1.2940997110445074],
            [15.75792067085294, -1.2933065399778083],
            [15.749719022324198, -1.2956129208150684],
            [15.746090465829662, -1.2996149900240375],
            [15.74587084509023, -1.306672801165965],
            [15.750914375039502, -1.3165805079680881],
            [15.75403026379907, -1.3257564735074252],
            [15.753633374989338, -1.3297322253859007],
            [15.749735971560815, -1.3387657431501965],
            [15.746148250867899, -1.3438760804971175],
            [15.73871233269573, -1.3595219823426392],
            [15.735715822949542, -1.3629507261894762],
            [15.72826966184283, -1.3744985406720098],
            [15.722830976072983, -1.3775152992816198],
            [15.71242843446545, -1.3783099335726525],
            [15.710221609441763, -1.3772315222382325],
            [15.713270027013417, -1.372417005382052],
            [15.706442690044932, -1.3713952805323382],
            [15.703855154821811, -1.3672272499901026],
            [15.708891277702712, -1.3638438347643709],
            [15.710144178878815, -1.360698490279747],
            [15.708128720781168, -1.3580789011503747],
            [15.70314603309476, -1.3574731088628802],
            [15.701232663814832, -1.3555903871523156],
            [15.701175522722952, -1.3478943842063857],
            [15.70340746314697, -1.341324907733346],
            [15.699875106646596, -1.3342150356647873],
            [15.703751441266744, -1.3298505607801587],
            [15.702100785340114, -1.3262473873774778],
            [15.698157842096563, -1.3257150493603733],
            [15.694777177635642, -1.3233444284954312],
            [15.69149364536202, -1.3160672728995328],
            [15.68700531284369, -1.3137664392889006],
            [15.679857678763481, -1.3023372959678514],
            [15.673430641238518, -1.29855023638376],
            [15.66882892338448, -1.2977450270854103],
            [15.660370061370902, -1.297932563259885],
            [15.654825847894783, -1.3035613974060505],
            [15.655543753555369, -1.3069726978195686],
            [15.651471624406001, -1.3117120683436785],
            [15.64624626307689, -1.3204964743059762],
            [15.641231487349213, -1.3214709504358608],
            [15.633735542825963, -1.3301093307795617],
            [15.62703093868021, -1.331127857260816],
            [15.628044414058614, -1.3375675081654308],
            [15.626256003538538, -1.3423524192835983],
            [15.621627471293868, -1.3450927477592578],
            [15.616919613340844, -1.3510944722925287],
            [15.613490754140457, -1.3486326430555913],
            [15.608428134254433, -1.3484674957463911],
            [15.598520298016835, -1.3554767671585206],
            [15.593206150557423, -1.3568508508729848],
            [15.586492981055775, -1.3545680970762681],
            [15.58740054322665, -1.348801676539409],
            [15.58657680954684, -1.3405884265476005],
            [15.591964269950827, -1.3332181829491392],
            [15.586632157311183, -1.3280522159308097],
            [15.585100194939884, -1.3243937585857115],
            [15.592007652986231, -1.3206171705798306],
            [15.593515806216768, -1.3174586775209123],
            [15.592299054883398, -1.310431144391312],
            [15.587566587078157, -1.3087304335816856],
            [15.589816439062547, -1.3036668247513268],
            [15.587721606783289, -1.2959047512258668],
            [15.583904546797699, -1.2949648228662816],
            [15.585446794257544, -1.288126514296942],
            [15.585112835557815, -1.2841865587853512],
            [15.581284898956095, -1.2853384942146717],
            [15.575522658240391, -1.2843170112543094],
            [15.57053222376556, -1.2741691047687498],
            [15.568537187624415, -1.272891272586313],
            [15.559916829969387, -1.2741252088396455],
            [15.558340182347314, -1.2802481431539268],
            [15.554286453558875, -1.2801627752516427],
            [15.549554161096559, -1.2862017189425414],
            [15.546428719450642, -1.2866367359018596],
            [15.541915529181418, -1.2847329651864465],
            [15.541606637326142, -1.2909535525240112],
            [15.53783377648843, -1.291178037205274],
            [15.537083815732792, -1.29462601258672],
            [15.533819870128237, -1.2995790359623638],
            [15.52662991521706, -1.293011924555027],
            [15.523159823976513, -1.2933125922905904],
            [15.520424307141317, -1.2990549358795844],
            [15.51536796567913, -1.2989211906367264],
            [15.513200613198205, -1.3023307961293598],
            [15.509128262388925, -1.3026006521132447],
            [15.504999979353247, -1.2938534960855557],
            [15.50163928758946, -1.2896253775851232],
            [15.495192178735453, -1.2978522277229452],
            [15.491446538062377, -1.2966877678836828],
            [15.477121154638533, -1.2977325189079003],
            [15.474233579932486, -1.3003200202025538],
            [15.472775003715613, -1.3067647434706977],
            [15.467040100323745, -1.3086317302511707],
            [15.460390039657206, -1.3080792602867934],
            [15.450169089083207, -1.3030648086901222],
            [15.444155977026153, -1.2943085774801282],
            [15.445625156867804, -1.290455768910202],
            [15.445214432517947, -1.2863220425123063],
            [15.447048422341464, -1.2805169386022726],
            [15.444744510013603, -1.2734407433921389],
            [15.448394082143965, -1.2664359010965316],
            [15.444665250179758, -1.2642196049208405],
            [15.441632076403831, -1.2584811496850168],
            [15.444459633639182, -1.25589943941839],
            [15.439548958800756, -1.2484101206754317],
            [15.43409678215662, -1.2489016204839338],
            [15.427577678426845, -1.2528901243545876],
            [15.42653610776425, -1.2487683937380771],
            [15.428879562978453, -1.243261785190117],
            [15.42924298048606, -1.2362066584985272],
            [15.418975105100728, -1.2296102813160894],
            [15.408453096505749, -1.2313176732751363],
            [15.398151758664909, -1.227087264720157],
            [15.38676167171122, -1.2250962061510848],
            [15.37870066453926, -1.221905925135066],
            [15.370329752416767, -1.2202893447334373],
            [15.35368718294869, -1.211891282387046],
            [15.331330465805186, -1.2057032537464158],
            [15.3273882665023, -1.2032264265309542],
            [15.32118556635302, -1.191329228946036],
            [15.320182496027135, -1.1865078732366763],
            [15.324975129424473, -1.183809031452455],
            [15.326409867772282, -1.181063303308745],
            [15.327610118145753, -1.1732844287138346],
            [15.328940771259367, -1.1714647434946208],
            [15.344946903298142, -1.1659046645602762],
            [15.350414197060001, -1.1596118085134808],
            [15.356782078356629, -1.1557369069093553],
            [15.363284502258356, -1.1533554037374625],
            [15.37618886354219, -1.1521516522706081],
            [15.381252419591968, -1.152908627410086],
            [15.38414662872962, -1.1513904611479029],
            [15.390822275675006, -1.1434999183046568],
            [15.390583922010881, -1.140787478656165],
            [15.386156124527496, -1.137437282219317],
            [15.381614367481596, -1.138138658611118],
            [15.374120993593964, -1.137140956967208],
            [15.37183178932889, -1.1342065252681817],
            [15.38030346206972, -1.130752384282952],
            [15.379162195607915, -1.1284129183526708],
            [15.370319397197223, -1.129690513548454],
            [15.36770612092102, -1.1262928307424107],
            [15.369573530239197, -1.1186192641927915],
            [15.368211886661728, -1.1159182654416622],
            [15.357297652539758, -1.1144759877986758],
            [15.352908090721467, -1.1030950049715955],
            [15.354918900581112, -1.096258564387935],
            [15.353352795469926, -1.0943968098316617],
            [15.346122477085567, -1.0983058886963126],
            [15.342643584809606, -1.0969821016443402],
            [15.340389085850282, -1.0928381572982975],
            [15.335696455172185, -1.0886382061816373],
            [15.330355238042138, -1.0897126380768392]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.97885517060341, "lat": 36.06625511478342 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37015"],
        "coty_name": ["Bertie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bertie County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01026334"
      },
      "bbox": [
        15.317307419020203, -1.3783099335726525, 15.84602720765847,
        -0.924742455139236
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.98877593967337, -2.324302978118789],
            [10.995326583454036, -2.318027118143465],
            [10.997502992631345, -2.312209620729281],
            [11.000640748453089, -2.3117553726164353],
            [11.00816943637619, -2.3060282286353337],
            [11.009607801104462, -2.299810873982938],
            [11.01320051162198, -2.2972312967359576],
            [11.01703406648251, -2.297493865828516],
            [11.022307866556021, -2.303881618808171],
            [11.032871426577293, -2.3056054642616197],
            [11.03514278452302, -2.3075081280253182],
            [11.041544183090327, -2.305883443826663],
            [11.04898480939592, -2.308146633439086],
            [11.055937273497781, -2.3037856301659976],
            [11.05741360476376, -2.296796965257698],
            [11.062776144969728, -2.2957858265441766],
            [11.067154767718721, -2.292241429021755],
            [11.073334606746982, -2.2904421959519023],
            [11.076492230198443, -2.291593582381876],
            [11.088773616577875, -2.2846145521880046],
            [11.089616455386917, -2.2773987996770186],
            [11.094672081442502, -2.2723432594820308],
            [11.101177647625049, -2.2743587903467364],
            [11.100901342917357, -2.2696476807145416],
            [11.10384583319475, -2.2673883392552914],
            [11.107860524831276, -2.2670720044101684],
            [11.1138048598069, -2.2688506656050786],
            [11.11885812802768, -2.2658279619610147],
            [11.120971423733994, -2.256321751522115],
            [11.11823406317597, -2.2504240516799396],
            [11.1221097480135, -2.2507292039773756],
            [11.126754980938369, -2.2474851044427284],
            [11.133294052693461, -2.2471541074555295],
            [11.13595345980694, -2.2512753219514092],
            [11.142193086898963, -2.2528828852409566],
            [11.152784346269197, -2.252957695251417],
            [11.1517763983562, -2.247968560608187],
            [11.15274135961786, -2.2407346483102866],
            [11.188131988008847, -2.215183986291559],
            [11.246858404466915, -2.1724873830816076],
            [11.2502841214088, -2.172630778422321],
            [11.25129690061173, -2.1691402494137817],
            [11.255189940534269, -2.1652563324467144],
            [11.2620403240672, -2.162333539145894],
            [11.264103719716877, -2.1589056666273803],
            [11.27193626061349, -2.1576895418224793],
            [11.277597491719893, -2.1580705474219273],
            [11.28132970858292, -2.1596529286138955],
            [11.286660801367425, -2.156881744893172],
            [11.289011091628327, -2.158218275220834],
            [11.296899791081405, -2.158575638486945],
            [11.304867481086413, -2.153901536701515],
            [11.304181011056977, -2.148330539194416],
            [11.306809238775513, -2.145441656803734],
            [11.312711347829316, -2.1471210828555702],
            [11.318108748018297, -2.143211112795643],
            [11.32100420382294, -2.1444511774360326],
            [11.328174284548028, -2.143065283840869],
            [11.333214765283307, -2.137639413146429],
            [11.340817444267527, -2.1369613146810016],
            [11.34521157343859, -2.134771554185018],
            [11.347503851292998, -2.131089738050437],
            [11.352365212572847, -2.1310462537362516],
            [11.357438559752325, -2.1293366307049757],
            [11.36779076264325, -2.122271564580738],
            [11.375305409610721, -2.127373662950825],
            [11.381334467048143, -2.122539000706258],
            [11.384062812142465, -2.1226780213240155],
            [11.387708244376887, -2.1266206733724204],
            [11.395950980723551, -2.130724234279309],
            [11.400152485808972, -2.1376989076281094],
            [11.40579681123212, -2.1394525105637845],
            [11.406598524119628, -2.145010064327871],
            [11.40307462529149, -2.1499510214254154],
            [11.40176108749363, -2.1558682997247005],
            [11.404854703750498, -2.161061798341313],
            [11.405217070061918, -2.1660499755923186],
            [11.411097712911735, -2.1728811435934663],
            [11.41095480268485, -2.175456216894378],
            [11.414129032410218, -2.1826062394354677],
            [11.415939763907966, -2.1912963028398864],
            [11.423118815612098, -2.1925641671006963],
            [11.427873786574619, -2.1989917133872026],
            [11.435728737354692, -2.204522582014595],
            [11.441166140512825, -2.204166504313076],
            [11.448475631528705, -2.2059869526247597],
            [11.453590495812435, -2.2056747596202673],
            [11.459455166714383, -2.209310775831988],
            [11.464691599599782, -2.2164144392020027],
            [11.468067082661264, -2.219390475811],
            [11.46994848908791, -2.2292738311646754],
            [11.465643697784627, -2.2322101179785405],
            [11.4642093102872, -2.2359571085034333],
            [11.460517287724043, -2.2389446222344542],
            [11.457397502582463, -2.2520671718599288],
            [11.467137338037649, -2.258209365949206],
            [11.471248279569119, -2.2669859596281783],
            [11.468117065667057, -2.27381873165333],
            [11.468396452094767, -2.2818392686326305],
            [11.470163678921484, -2.2868459993074604],
            [11.472239979221097, -2.2875979853937385],
            [11.4743193663183, -2.295022827329708],
            [11.479063793060346, -2.2959586844627404],
            [11.484187356088995, -2.3013648365339288],
            [11.481973417830817, -2.304799112284054],
            [11.486633508260255, -2.311529703018114],
            [11.491245137318668, -2.3147755933356913],
            [11.491150430243657, -2.3188432561762764],
            [11.479828432113113, -2.32532180015768],
            [11.479141903079633, -2.3312652344462523],
            [11.475302890727622, -2.333842851685621],
            [11.472658009929555, -2.340418732599773],
            [11.473910084321522, -2.3439452674663626],
            [11.497942297855708, -2.3620476529900465],
            [11.510196103488987, -2.370639040048018],
            [11.512943203579042, -2.3712905189676],
            [11.536135526178974, -2.3737889856289947],
            [11.547416867921184, -2.37759306104355],
            [11.580477237096916, -2.3931150752655292],
            [11.572725196213721, -2.395482598402332],
            [11.540536766185166, -2.4068849354132786],
            [11.531763918676718, -2.4082456672432966],
            [11.530778635245559, -2.413223164878325],
            [11.531817465466853, -2.418747090193861],
            [11.537439820767275, -2.422948805321552],
            [11.540657181703773, -2.429031059676111],
            [11.530582569772575, -2.4614987950169893],
            [11.524483989952316, -2.469672938366363],
            [11.511977180156197, -2.464226423192423],
            [11.453746760165894, -2.4396674522351516],
            [11.449956260094021, -2.4419737082479935],
            [11.44914675233971, -2.446021269896684],
            [11.450427079487557, -2.4496698564985184],
            [11.445938675262466, -2.4532479917983734],
            [11.436387769609366, -2.4518616217062092],
            [11.434261557389759, -2.457179583292536],
            [11.42671752797708, -2.458546414338264],
            [11.425489998736824, -2.4644350011728657],
            [11.427835745271645, -2.468596117695352],
            [11.427578804921128, -2.4721732952314044],
            [11.429900615074768, -2.4747001444245056],
            [11.43147726223809, -2.479750193958852],
            [11.430580976581487, -2.4832382965871975],
            [11.41951724912141, -2.481442395538399],
            [11.418445774554005, -2.479054871777098],
            [11.413841876924945, -2.4762251277572918],
            [11.402968760130802, -2.477948657327095],
            [11.397956416662135, -2.474808180845477],
            [11.394958561264524, -2.476726227090362],
            [11.389627595842615, -2.475197335865049],
            [11.38616591000675, -2.4794342859320815],
            [11.382673398798639, -2.4803260974436614],
            [11.380121220786164, -2.48650125990716],
            [11.369124840054383, -2.4921283533714083],
            [11.368644101543515, -2.4946911237958997],
            [11.363401861277499, -2.498504844358464],
            [11.3625163605516, -2.504305599218509],
            [11.358007366046749, -2.503812337027496],
            [11.351623762277395, -2.5104237645022214],
            [11.301064852472777, -2.5184052328318054],
            [11.301010530485907, -2.526657758003082],
            [11.306156577942064, -2.5261513941305243],
            [11.307414020587407, -2.539387889835196],
            [11.301215465475217, -2.541632382143935],
            [11.293407156618388, -2.5391138469706296],
            [11.29627064552787, -2.5324743921371455],
            [11.289183218100368, -2.520222656749526],
            [11.279460055675498, -2.5227523955985234],
            [11.279717787910327, -2.5282938206473053],
            [11.274810920235726, -2.528771516130944],
            [11.273748321001987, -2.5358596042672175],
            [11.26355345794839, -2.5339980332483125],
            [11.259516753438932, -2.530729997433922],
            [11.254290213253237, -2.533904699174796],
            [11.241431374123913, -2.5280509133844236],
            [11.237298199400744, -2.5321668830927346],
            [11.234395419014884, -2.532149388567011],
            [11.231557803927698, -2.536806297317805],
            [11.219068742201726, -2.5310880281208714],
            [11.214723165973973, -2.53079739125104],
            [11.211947590245439, -2.526031648567567],
            [11.206720658723944, -2.5241488713894773],
            [11.204352621561222, -2.521330710404114],
            [11.199531325526687, -2.5242834905330023],
            [11.19478017439553, -2.520899537000108],
            [11.187578844789227, -2.519161785982145],
            [11.182769965229564, -2.525402637499536],
            [11.173114773592339, -2.527295092959432],
            [11.166318153956796, -2.5274181110323135],
            [11.162626978270215, -2.5296504881855753],
            [11.158171252163516, -2.5345602346472518],
            [11.155217498929046, -2.5356054927539176],
            [11.15266679007118, -2.5415701932236017],
            [11.149141366354609, -2.5465693026250222],
            [11.145267812250157, -2.5494623333260407],
            [11.145298786780687, -2.552766858159176],
            [11.138947812843197, -2.5560479291824083],
            [11.135216475245374, -2.563696720698159],
            [11.132138484242173, -2.561520792938794],
            [11.12656941750134, -2.562785791066976],
            [11.117208400276036, -2.5565381383250902],
            [11.115149719358072, -2.5568670532488054],
            [11.103660530602431, -2.551246573081818],
            [11.100760486481215, -2.545841850914823],
            [11.097329136809144, -2.5339407425374123],
            [11.094312212761738, -2.532108118278872],
            [11.086250767874937, -2.522879830985894],
            [11.088095718519641, -2.508105743323081],
            [11.092623905295568, -2.496292428476227],
            [11.091641229598663, -2.493773327730365],
            [11.093999851849231, -2.4866944046377153],
            [11.09188442950302, -2.4848069647975044],
            [11.092761729458267, -2.4786363414034995],
            [11.095354222016098, -2.4708729850223388],
            [11.093322345775762, -2.463000078537098],
            [11.096772970307697, -2.4582280060764656],
            [11.100679391431475, -2.4551935485971725],
            [11.102153837111535, -2.4485020867565557],
            [11.09419087283773, -2.4368704983920826],
            [11.090752465087816, -2.434906576700756],
            [11.093523734686224, -2.4277506785409204],
            [11.098342548626007, -2.421668838375596],
            [11.09347762994181, -2.4138480317028805],
            [11.086670498094433, -2.4122679201097346],
            [11.08728101956945, -2.4081219307769137],
            [11.08334990960917, -2.40217324110651],
            [11.08018351465369, -2.3999490180599072],
            [11.067393968897301, -2.3949497056684135],
            [11.064733916647599, -2.3908015555563695],
            [11.062091027202486, -2.382481429190988],
            [11.056351643311482, -2.3760521146726896],
            [11.05533290880309, -2.3692304733611276],
            [11.05160437068552, -2.366780346925473],
            [11.046468955472822, -2.3723359298306845],
            [11.042463606166521, -2.373132510212201],
            [11.03848183573281, -2.3770414324412132],
            [11.035442855320518, -2.3757526425671327],
            [11.028498373730505, -2.3816115795604076],
            [11.022965565004117, -2.381606834466197],
            [11.021420605985488, -2.366177775381882],
            [11.018735415830392, -2.3622974750382246],
            [11.009961234041928, -2.365704802746573],
            [11.007693217363101, -2.3627077606819884],
            [11.00575494015903, -2.3561775610901154],
            [10.999832925141366, -2.349646861818993],
            [11.000989551790978, -2.343654684650936],
            [10.995635517599975, -2.3393412077049116],
            [10.994812729000373, -2.3341317840569373],
            [10.986153839991212, -2.329986377026492],
            [10.98877593967337, -2.324302978118789]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.53002674612199,
          "lat": 35.611163427690826
        },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37021"],
        "coty_name": ["Buncombe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buncombe County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01008538"
      },
      "bbox": [
        10.986153839991212, -2.563696720698159, 11.580477237096916,
        -2.122271564580738
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.538305548570372, -2.6330238205411205],
            [12.547638946783472, -2.632365035565626],
            [12.552894190109873, -2.631088368431094],
            [12.558124185419139, -2.624706830822112],
            [12.562788495972695, -2.625578067288563],
            [12.566746059400588, -2.620577317008169],
            [12.564253609057928, -2.6126558556427617],
            [12.566138481254765, -2.6070180039987134],
            [12.56571128973216, -2.5964642099732904],
            [12.56044745153679, -2.5827454859762433],
            [12.559147590399803, -2.5700912878943916],
            [12.549799978156933, -2.557011453781511],
            [12.549311833170146, -2.5546604550768786],
            [12.55023028097777, -2.542653355726723],
            [12.549570339963415, -2.5353764522504805],
            [12.550350926167795, -2.530295143334945],
            [12.544022943537055, -2.5206296800146792],
            [12.541665911698091, -2.5106546039454907],
            [12.542352121393227, -2.5044207511903447],
            [12.54438060372689, -2.498271519916984],
            [12.54473822477022, -2.488819968023735],
            [12.547175430493267, -2.472302113510083],
            [12.550909082084251, -2.4675312716506355],
            [12.554082730503858, -2.4555612575603556],
            [12.558484429487082, -2.449637291379166],
            [12.55933314471554, -2.445454423266985],
            [12.554562174362966, -2.4386337394111948],
            [12.55675846760699, -2.4327359895972127],
            [12.561942732211588, -2.429116939213973],
            [12.562578116918628, -2.4240481819196016],
            [12.566949446030304, -2.4228036061079794],
            [12.571494817195266, -2.4259046399749553],
            [12.574123329014029, -2.4229542752266564],
            [12.578933700798013, -2.420712179366967],
            [12.586555931141742, -2.419569373982828],
            [12.591685693680532, -2.4129699311138584],
            [12.596893051378075, -2.411162260047702],
            [12.60066010647069, -2.4081114503715315],
            [12.595076546339605, -2.405863832662428],
            [12.590065467868731, -2.407565586873805],
            [12.584992603599208, -2.405508273475098],
            [12.576682491958854, -2.4044173069898864],
            [12.570137097468555, -2.3976047009685097],
            [12.566431797823435, -2.398069893013029],
            [12.563464962966851, -2.4061296730237176],
            [12.559885988867249, -2.410255969807437],
            [12.553362694428, -2.4095402648467252],
            [12.550899624109329, -2.407439891599961],
            [12.547273201655871, -2.4005263605153226],
            [12.546704983800995, -2.3972240523242148],
            [12.548715256847943, -2.3940135009190238],
            [12.554304549708926, -2.3925050269154933],
            [12.562323395406219, -2.3849633008521],
            [12.56817087328978, -2.3815455621053387],
            [12.569890746793202, -2.3760031297243693],
            [12.56887426894784, -2.3721914032623928],
            [12.566577286813168, -2.3686706365495356],
            [12.56398071700611, -2.3613114794612384],
            [12.565294927899759, -2.3535255981019727],
            [12.564170530554197, -2.3472606027768776],
            [12.560641349674395, -2.3402714654805234],
            [12.563963472018289, -2.32737938728262],
            [12.569858316220753, -2.318096251856903],
            [12.569568360982254, -2.313230091397635],
            [12.561884733349352, -2.306737496094021],
            [12.560388470143728, -2.3032775806909824],
            [12.561630674531424, -2.2910471698827535],
            [12.563187321243998, -2.287818712588896],
            [12.560805532801382, -2.2832412914971387],
            [12.588977953214124, -2.251875373454875],
            [12.643583780267893, -2.2479558724982005],
            [12.68800483329862, -2.2449160215100266],
            [12.687278603498324, -2.248165310237775],
            [12.688013939563426, -2.2582251777182036],
            [12.693127463529578, -2.2662295100485306],
            [12.697327687908825, -2.2781379657419802],
            [12.703659114336881, -2.286653825322523],
            [12.704936536651038, -2.2919129711185833],
            [12.72831469634324, -2.3323217618198404],
            [12.719552384142247, -2.3357302321041007],
            [12.718977725247985, -2.34666845388248],
            [12.728907147019186, -2.351859514388593],
            [12.739883076869631, -2.364539677433748],
            [12.750589107578383, -2.3717277230115417],
            [12.772320249407025, -2.385138439352361],
            [12.78639319305525, -2.3920161879497757],
            [12.799383668949027, -2.4212890592852947],
            [12.8153110366755, -2.456276389570349],
            [12.82065567639112, -2.4667437642812806],
            [12.85423877157692, -2.480757197967496],
            [12.920874121579498, -2.50967866229523],
            [12.922797079398594, -2.510662612366333],
            [12.865392098217342, -2.5905266503689406],
            [12.823510588935253, -2.648186833014004],
            [12.794325339377883, -2.687263653060026],
            [12.776854983027329, -2.7101210206434074],
            [12.772898330810591, -2.7141652970810997],
            [12.766594332064455, -2.7148437666048704],
            [12.748611713252961, -2.7233878761936987],
            [12.744278190205298, -2.730510436462559],
            [12.737054424591374, -2.7358843461075835],
            [12.7346668861846, -2.7417316391887665],
            [12.730384604586822, -2.7466660969292915],
            [12.725389585510127, -2.7503097099054483],
            [12.724052876472614, -2.754004803867855],
            [12.680062901627961, -2.7081130758938903],
            [12.659302333141527, -2.68806150036512],
            [12.631360046299788, -2.6609069327987585],
            [12.615351088264704, -2.6785312247532773],
            [12.555938745674784, -2.7368787596156823],
            [12.54743528390055, -2.7274719260014306],
            [12.540184110817714, -2.7212893033864485],
            [12.538180053201046, -2.7106338601864266],
            [12.536772211202527, -2.697657984438779],
            [12.539302204599041, -2.686906287098344],
            [12.543065842276699, -2.6818816110094836],
            [12.550095766997819, -2.678804471550897],
            [12.552879835020924, -2.672743878110264],
            [12.551819115368447, -2.667099165399],
            [12.545058235712842, -2.6553659815969897],
            [12.535136601965648, -2.652093643482451],
            [12.534162924367719, -2.6500147302933357],
            [12.535207701359571, -2.6391310620248114],
            [12.538305548570372, -2.6330238205411205]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.83279470404008, "lat": 35.24672005807842 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37119"],
        "coty_name": ["Mecklenburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mecklenburg County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01008570"
      },
      "bbox": [
        12.534162924367719, -2.754004803867855, 12.922797079398594,
        -2.2449160215100266
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.824747564912018, -1.93106626690244],
            [15.871458447430781, -1.9597314964292671],
            [15.872550594457222, -1.9602215719398755],
            [15.9276362546067, -1.9420821172837375],
            [16.037376723551606, -1.9065665980319413],
            [16.04441488525578, -1.8689704978657955],
            [16.04454210173984, -1.8597901228830538],
            [16.041526762334986, -1.854144299621099],
            [16.040348882519254, -1.8480454399479407],
            [16.034999285511162, -1.8403233824642118],
            [16.034021978749845, -1.8365181240292896],
            [16.03438917741527, -1.8277171904563025],
            [16.03020611751632, -1.8117122031605795],
            [16.030938426039413, -1.8073732070974504],
            [16.03385847802497, -1.8041575291851175],
            [16.038577039325826, -1.8095149670639876],
            [16.04510579045122, -1.805968034709699],
            [16.063560275094034, -1.803145956761211],
            [16.077707135532425, -1.8032083746719778],
            [16.08852519119556, -1.8023628320841119],
            [16.10598492030731, -1.8051280370920988],
            [16.132875099769652, -1.8041316712839157],
            [16.138919961914194, -1.8048706105320602],
            [16.141600235581873, -1.8083077839578245],
            [16.140624597811904, -1.812107443077284],
            [16.13371712846679, -1.8119466068051395],
            [16.128869642259982, -1.8149438390708759],
            [16.130798776876745, -1.8243399404439349],
            [16.13673089177886, -1.8283006044978982],
            [16.1348463094718, -1.8408215667671748],
            [16.141177894746964, -1.8411623662512167],
            [16.149411598523887, -1.8382497080238602],
            [16.150190663240153, -1.8357135465141718],
            [16.146703177551903, -1.8312787815348686],
            [16.150085481382668, -1.830335581272947],
            [16.154149165485954, -1.8344761645312027],
            [16.153092247415287, -1.8398819382516725],
            [16.156612535112902, -1.847341721305739],
            [16.160525888230794, -1.8485843182497856],
            [16.16293250969479, -1.853737160628563],
            [16.157049659871014, -1.8525670446616385],
            [16.15387881010114, -1.848897693926425],
            [16.147136653332428, -1.8522653360807135],
            [16.14420392292599, -1.8562248098269598],
            [16.149385702123432, -1.858023811407595],
            [16.148767354202405, -1.8623378862051292],
            [16.152600793201614, -1.867766484283298],
            [16.15652440996827, -1.869546933764568],
            [16.145461780703858, -1.8730492434996084],
            [16.138667534677648, -1.880059510973121],
            [16.14984028388066, -1.8931300442065746],
            [16.15230457410181, -1.897752924590198],
            [16.149375099004597, -1.9022241271725442],
            [16.140868633788127, -1.8981945873110169],
            [16.1293799827449, -1.8977836166507338],
            [16.120270406407464, -1.8936786792908065],
            [16.107782279856988, -1.8950713493554188],
            [16.098419273494567, -1.8954144469944731],
            [16.091836024800475, -1.9015764176269374],
            [16.09717555020077, -1.9064672246566814],
            [16.105369297373585, -1.9061673351840323],
            [16.11475534642118, -1.907818527348682],
            [16.124823242092955, -1.9165257000311748],
            [16.131819311205103, -1.9170722641973879],
            [16.134501867832117, -1.920514321802586],
            [16.13260532075937, -1.9303084421173073],
            [16.13167960936658, -1.9391005720332528],
            [16.125497739592472, -1.9405849703525273],
            [16.122746503583436, -1.9377551606574475],
            [16.12145264645983, -1.9334242826916532],
            [16.115939063841523, -1.9332114423216165],
            [16.113486524747337, -1.9376771412945073],
            [16.10025299131592, -1.93531855655691],
            [16.09029020319936, -1.9310871263525142],
            [16.080813766201754, -1.931849182346279],
            [16.075168085428988, -1.9340185020119998],
            [16.0698890755063, -1.938909705374988],
            [16.070732757638094, -1.9439341790533484],
            [16.073908794995734, -1.9478759085148603],
            [16.068371061508397, -1.9496216100617059],
            [16.06957207930828, -1.952572849188938],
            [16.06539311451302, -1.9542369317795614],
            [16.064410467266757, -1.9580401259327047],
            [16.059933464686324, -1.9601648597992247],
            [16.057769703457467, -1.963012658283493],
            [16.048586376919488, -1.9671095191790502],
            [16.051740291075067, -1.980458958018777],
            [16.05755820570264, -1.9800571259717972],
            [16.067110316365547, -1.974882678353609],
            [16.0753212880052, -1.9755854706735214],
            [16.079610188398963, -1.9810994198874259],
            [16.09036359361653, -1.9788740162989988],
            [16.091553557765504, -1.9732259152361058],
            [16.090609967192812, -1.9696203789038462],
            [16.086289982501242, -1.9649142669037225],
            [16.091629028619096, -1.9584079711228997],
            [16.09791303573177, -1.9593064206893434],
            [16.10345208943795, -1.957558398599141],
            [16.10547956156328, -1.963539950387528],
            [16.108747169194768, -1.9650627749200071],
            [16.119185912426733, -1.972700613003717],
            [16.122753953342816, -1.9775633690494911],
            [16.12767469034255, -1.9709393484366253],
            [16.131179461669607, -1.975064381520539],
            [16.127512370494863, -1.9805780184286421],
            [16.125768825068093, -1.9873426483567738],
            [16.122813162168768, -1.993959046767801],
            [16.11984847751282, -2.003379353184623],
            [16.12030120108577, -2.014094194501549],
            [16.116379043304978, -2.0189098137541777],
            [16.116839547578515, -2.026821526969898],
            [16.115410505111747, -2.0313208878297324],
            [16.10063611197189, -2.0369830045538593],
            [16.09633439940929, -2.0418775689323083],
            [16.099316024275144, -2.0448643933013453],
            [16.100132535843507, -2.0497763815290644],
            [16.098333832227908, -2.060082853460443],
            [16.090093355475204, -2.068795861440594],
            [16.08376051023522, -2.0715058240728457],
            [16.075040665398607, -2.0779133178689757],
            [16.06758193973182, -2.0856606322567393],
            [16.067988300402078, -2.0885810098754667],
            [16.06082318476704, -2.0963900922555223],
            [16.056210813494488, -2.100223086917461],
            [16.049958235553415, -2.1119259305349463],
            [16.04585073921458, -2.116183850568109],
            [16.038953557609542, -2.117798086229548],
            [16.035060343053377, -2.1228055198244684],
            [16.025912948309177, -2.1316505298589528],
            [16.024460237337358, -2.140210177650795],
            [16.021831079695755, -2.1427543412833323],
            [16.021606854428047, -2.147407158598214],
            [16.015296320506543, -2.149305428937969],
            [16.007561538172755, -2.1528981497838613],
            [16.00294830282822, -2.1582535142067316],
            [15.994819282826668, -2.1647302821588563],
            [15.987561768945111, -2.166820202266078],
            [15.981671345498347, -2.178444972000789],
            [15.979849127344393, -2.1845200903337467],
            [15.96486873520405, -2.190703109982306],
            [15.957758751441487, -2.197367964630861],
            [15.956663234040363, -2.2026018911392558],
            [15.953375831752732, -2.1990661226921353],
            [15.949588860256458, -2.1997060133210393],
            [15.94177169106095, -2.198233894492889],
            [15.926820714004805, -2.1903801872479356],
            [15.919998076942708, -2.185253990704781],
            [15.907448183413232, -2.1788026937322567],
            [15.898698789226122, -2.175496808641442],
            [15.892233502148649, -2.1756968944323773],
            [15.878036265811957, -2.1659752634056564],
            [15.87058726486981, -2.1622865905939026],
            [15.866731941984542, -2.157865898668968],
            [15.860002762271971, -2.1558360080226855],
            [15.855933046957903, -2.157060976477114],
            [15.84701574224534, -2.1576360065447258],
            [15.838658133948485, -2.1542013833093074],
            [15.841568255200556, -2.1493725526113545],
            [15.840107586767472, -2.1460665341040315],
            [15.831819855315846, -2.144246338790855],
            [15.827192845790284, -2.14548845584145],
            [15.823456417197816, -2.139572715181377],
            [15.828198763933088, -2.138709014701825],
            [15.828354540503991, -2.1325320411135484],
            [15.831416989990279, -2.1272023640217985],
            [15.83003882372916, -2.1170097703829125],
            [15.828257298876082, -2.1154977145499174],
            [15.830019750856742, -2.108720379542306],
            [15.82389878339413, -2.1001206391354152],
            [15.822973270488665, -2.088185826502358],
            [15.821105707250277, -2.0780581336459822],
            [15.816034727721359, -2.0752083963427417],
            [15.816212451694451, -2.0714641812028907],
            [15.811530532114839, -2.070459708114935],
            [15.807215159948528, -2.0673048652435533],
            [15.793704327898597, -2.065492154034999],
            [15.785446442194297, -2.0627162792498774],
            [15.783355629894968, -2.0591164838766787],
            [15.778495493599092, -2.055671692878017],
            [15.772036357550135, -2.04425748795294],
            [15.773809990604088, -2.0426535340849323],
            [15.780262941724915, -2.0413506986074568],
            [15.78318560297317, -2.036767172201467],
            [15.783843882749919, -2.0322055517133704],
            [15.782186412880042, -2.02991978017178],
            [15.78315783113193, -2.0256834142695292],
            [15.7807383443534, -2.021134918652745],
            [15.780698032920853, -2.0169092822058645],
            [15.78316154301757, -2.012946184142307],
            [15.782485505173904, -2.006955681882029],
            [15.78283552232391, -1.99723068642687],
            [15.78457284845077, -1.9917491632516107],
            [15.79033094196619, -1.9846859116587923],
            [15.79318895940326, -1.983615914302335],
            [15.79584484434522, -1.9786786836922055],
            [15.794630536348329, -1.9723784084833125],
            [15.800403213594937, -1.960302641036016],
            [15.820237083076531, -1.9504714345186513],
            [15.824747564912018, -1.93106626690244]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.74075226082873, "lat": 35.14346044491895 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37137"],
        "coty_name": ["Pamlico"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pamlico County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "01023355"
      },
      "bbox": [
        15.772036357550135, -2.2026018911392558, 16.16293250969479,
        -1.8023628320841119
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.947957356367402, -2.7140633248469386],
            [14.074206495462017, -2.696580192390263],
            [14.115951403369579, -2.638741579254562],
            [14.175195991923605, -2.5566710490925466],
            [14.249380085255309, -2.5836584367345874],
            [14.25137904920656, -2.5872598177213266],
            [14.262375921284166, -2.5914382463189765],
            [14.265137537422138, -2.596726708816823],
            [14.268608246646517, -2.598655140833196],
            [14.276769001227132, -2.605896562857657],
            [14.278739684108752, -2.6111386876729554],
            [14.282222802101316, -2.616389944855088],
            [14.28367424145083, -2.62106165468937],
            [14.280539895534915, -2.6284963310519616],
            [14.291195487925998, -2.6408813525620043],
            [14.302539840884391, -2.6518111291174273],
            [14.305745806246629, -2.653293876848475],
            [14.307469221348216, -2.6555301647651333],
            [14.309402690011428, -2.66336349577591],
            [14.313268288257596, -2.6668700774890515],
            [14.317273349674348, -2.6731800151301055],
            [14.321225235440235, -2.674303475089558],
            [14.325795767848248, -2.681122499822064],
            [14.325693067007956, -2.683828739682883],
            [14.332861862740636, -2.6922911281036956],
            [14.3342022912394, -2.696500905046427],
            [14.341599545545442, -2.7046988908070317],
            [14.341481749140161, -2.706939966894646],
            [14.348286845805243, -2.712351894208921],
            [14.347339766160829, -2.7148309796504573],
            [14.351318369675377, -2.7220615622669455],
            [14.35145511883573, -2.7245398556335125],
            [14.358179165403815, -2.733021891928707],
            [14.361882764200416, -2.744976658091713],
            [14.369721153406442, -2.7499531448154246],
            [14.371824892596198, -2.7546609570183804],
            [14.378302067789251, -2.760191980237906],
            [14.387443279759758, -2.763313863273215],
            [14.39266526875215, -2.766000494605225],
            [14.397556919920323, -2.771005640472823],
            [14.403407639943113, -2.779720682640904],
            [14.409183412392977, -2.7836290331912035],
            [14.409456096833539, -2.7900485361230407],
            [14.411115927852627, -2.798651126604537],
            [14.40865921655679, -2.800259793558072],
            [14.410158270943365, -2.8052409205280298],
            [14.406894207729856, -2.806232192298985],
            [14.403910378563362, -2.8104317002616455],
            [14.403391256698361, -2.815031845683649],
            [14.405632616234353, -2.819997169876215],
            [14.409776509464336, -2.822418179478964],
            [14.406077646607715, -2.8249310398885417],
            [14.405949083846286, -2.8292509374915715],
            [14.403493184280043, -2.8326842190166],
            [14.400309217408743, -2.8439449626724276],
            [14.401840758914338, -2.846054738771642],
            [14.398551355748797, -2.855157987764853],
            [14.39943800585836, -2.8615463360617523],
            [14.403225551048253, -2.8673615263936285],
            [14.402523156523658, -2.8748942393925776],
            [14.40053853906016, -2.878488571725034],
            [14.402593602276847, -2.8805591250533373],
            [14.400674089488328, -2.8874035599052243],
            [14.397537914725515, -2.889891318737786],
            [14.399034257254984, -2.8990748907434853],
            [14.39588324838346, -2.902657207142168],
            [14.391996284455914, -2.903297815172724],
            [14.390196421800946, -2.9073030141625718],
            [14.390974704488519, -2.9163898439840574],
            [14.387169719150394, -2.9166006487937035],
            [14.386861263865974, -2.919923629640108],
            [14.39120794874611, -2.9224788409038736],
            [14.389927032979797, -2.927729972068422],
            [14.392192629607083, -2.93044195990374],
            [14.390923422585594, -2.935358261963179],
            [14.393207239396112, -2.942327330019924],
            [14.397118696261805, -2.9449257519800227],
            [14.400625567545726, -2.950806065856439],
            [14.398339578693488, -2.954928109400104],
            [14.40151608245785, -2.959844100710776],
            [14.399293950953645, -2.9625616225484466],
            [14.404485630123883, -2.9641120175479156],
            [14.411058438943007, -2.9690311170921757],
            [14.410187750050575, -2.973247446824914],
            [14.40706409248409, -2.9758489576728135],
            [14.402009170819488, -2.9775637683742904],
            [14.397617755144232, -2.981776103893791],
            [14.394805278698172, -2.9934327404734598],
            [14.395552024198931, -2.9957169151758305],
            [14.395415258752234, -2.9981741304317207],
            [14.387111911540241, -3.0069884897131995],
            [14.387345985157605, -3.0092113637824816],
            [14.38282331505766, -3.01268678404767],
            [14.37802000802063, -3.022093091126565],
            [14.374741542984024, -3.0246735851419313],
            [14.369509247884658, -3.0235968572987675],
            [14.369842302024015, -3.030179700802691],
            [14.36389249957315, -3.027682776989939],
            [14.358462469170037, -3.0292102617520507],
            [14.362523546767777, -3.0339481947946005],
            [14.356055775533731, -3.035586961120411],
            [14.352314470668297, -3.034013545858135],
            [14.345207792454463, -3.03879244418022],
            [14.34232909075217, -3.039142150987298],
            [14.335381229194823, -3.0434952444656687],
            [14.332981404779197, -3.049574772226688],
            [14.329943086164308, -3.0505400436307846],
            [14.329057109381166, -3.0560629394029584],
            [14.326182048434083, -3.0590065735309033],
            [14.326475167052921, -3.0630331710685215],
            [14.323647999413673, -3.067118768616181],
            [14.326460158467658, -3.0737738711979796],
            [14.324942399376086, -3.0759612711121305],
            [14.330534806044886, -3.091302269060493],
            [14.33145367387411, -3.096839788336525],
            [14.32417490390331, -3.10331641215497],
            [14.318661585750915, -3.103440339610265],
            [14.3106984048296, -3.10542910629788],
            [14.308182256013614, -3.1073931378731214],
            [14.306108465791066, -3.1149169766367644],
            [14.303317672727728, -3.1158256958279646],
            [14.300798630539783, -3.1197352112171552],
            [14.306776112349862, -3.1280047472404626],
            [14.31055904256503, -3.135193171807313],
            [14.305078211024226, -3.1445114935963834],
            [14.30513227692196, -3.1477724132918747],
            [14.293776367753201, -3.150153621503325],
            [14.291891164616459, -3.1556098761459586],
            [14.292352941113196, -3.1599558363383617],
            [14.288682598283472, -3.1646576629209378],
            [14.289880715130543, -3.1732968255634986],
            [14.288784786145166, -3.1772809984442305],
            [14.291479289988551, -3.1804893091489665],
            [14.288055208226131, -3.184151365383859],
            [14.290027481092553, -3.1900861187493694],
            [14.284726209156917, -3.1938333367835625],
            [14.277995204501497, -3.191032279397609],
            [14.275683672052782, -3.1932744615170963],
            [14.273215677621812, -3.1998423821280633],
            [14.268482481338822, -3.1992149826246727],
            [14.268178893442194, -3.2044853890239136],
            [14.265923571926416, -3.208880675624153],
            [14.26591277436081, -3.2088729176327306],
            [14.197345028194038, -3.1595450927373556],
            [14.14383268247501, -3.1209332061466304],
            [14.095301512155926, -3.0855353795506555],
            [14.040559355907924, -3.0434661106930783],
            [13.991080837060224, -3.006282659325382],
            [13.90406647968841, -2.944241713356288],
            [13.893181795155648, -2.936684346493202],
            [13.948977570223976, -2.8241579166127706],
            [13.972452751832785, -2.7767760652696434],
            [13.969529718821596, -2.7728244840946603],
            [13.964557325110292, -2.7630756754313093],
            [13.961711907645723, -2.7622820312318095],
            [13.959705820287759, -2.757465220494442],
            [13.954363786072449, -2.7514584491028793],
            [13.951985419334775, -2.7473189603135135],
            [13.95217489577, -2.743829136056835],
            [13.949444644917566, -2.7401056975705784],
            [13.945978687888312, -2.7382347546656636],
            [13.943343789796998, -2.733544022356451],
            [13.945572730862484, -2.7307718643473913],
            [13.946718650842193, -2.7251775527046136],
            [13.946099729445843, -2.7179566969785274],
            [13.947957356367402, -2.7140633248469386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.1039616800155, "lat": 34.640213085599584 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37155"],
        "coty_name": ["Robeson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Robeson County"],
        "coty_fp_code": "155",
        "coty_gnis_code": "01026130"
      },
      "bbox": [
        13.893181795155648, -3.208880675624153, 14.411115927852627,
        -2.5566710490925466
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.9286786292250393, 8.551032800430795],
            [-2.9117751568764727, 8.549975700624142],
            [-2.8247620934084536, 8.54569544735189],
            [-2.7811784712728445, 8.543681060762223],
            [-2.776595203546602, 8.629337935690865],
            [-2.772687021306194, 8.71106199449701],
            [-2.72085648435017, 8.708481945971837],
            [-2.5994271942586398, 8.702474764903762],
            [-2.51328251924517, 8.698434516416787],
            [-2.4264375848788897, 8.694570355195248],
            [-2.3395457433472897, 8.690669037059092],
            [-2.3394081581433883, 8.689915499063547],
            [-2.343414849386072, 8.607470887311457],
            [-2.3473368978942104, 8.522387168579884],
            [-2.349777363541102, 8.472349727999829],
            [-2.3534543631579172, 8.393779048795148],
            [-2.3553627712500633, 8.351008130133762],
            [-2.328395783288142, 8.349479318120215],
            [-2.334515211032331, 8.23474520109195],
            [-2.3391850752078316, 8.15074629390039],
            [-2.343165115940554, 8.083708306661473],
            [-2.344847355743949, 8.050316980593173],
            [-2.34735736202616, 8.006988787744843],
            [-2.376319893150691, 8.008486245519423],
            [-2.377639049304894, 8.008285145759807],
            [-2.43424863272641, 8.01118363015169],
            [-2.521002523421195, 8.015209180776427],
            [-2.5474385868463485, 8.01662918740061],
            [-2.60874765969553, 8.019605402835024],
            [-2.694135192022773, 8.024165733845912],
            [-2.747059862144836, 8.026396050214682],
            [-2.747949646055862, 8.031391224104542],
            [-2.7446019405098316, 8.041614024990704],
            [-2.7391766426726, 8.049304347455172],
            [-2.734722140941686, 8.052540071502662],
            [-2.7316458744421355, 8.05640082545691],
            [-2.7296683298856514, 8.066184261259203],
            [-2.7309253194339314, 8.06887453929033],
            [-2.737987520709598, 8.070705243028875],
            [-2.748287065530829, 8.066996630921924],
            [-2.754586290570809, 8.065425596492593],
            [-2.773210238286568, 8.053241049096771],
            [-2.780362973661036, 8.050657004693454],
            [-2.7914191964254687, 8.049412965285674],
            [-2.7974273613956244, 8.051997470050821],
            [-2.802135778125587, 8.056525643357151],
            [-2.802929942928849, 8.059945508326],
            [-2.800648302991194, 8.066821800818232],
            [-2.7975681043560257, 8.070182299585568],
            [-2.798091347791244, 8.07830613680362],
            [-2.800633548262196, 8.083607693729782],
            [-2.8035482099776243, 8.086410915980624],
            [-2.80904558176327, 8.086044216349128],
            [-2.818503220336971, 8.081934602514961],
            [-2.824383041603789, 8.081459746495076],
            [-2.829002182374843, 8.083708051365601],
            [-2.8314178866060207, 8.086961807211635],
            [-2.8332187532846613, 8.098405667037692],
            [-2.8365218377631933, 8.110815808947947],
            [-2.831578683686624, 8.113698494687874],
            [-2.822924829777628, 8.114517136146775],
            [-2.820467134560221, 8.116826184960168],
            [-2.8193247105606978, 8.122934659414518],
            [-2.822782949879951, 8.130846062707755],
            [-2.8333505468346445, 8.13188495562527],
            [-2.8434836670736003, 8.130898126418593],
            [-2.848926282537598, 8.132935923984663],
            [-2.8573409470179603, 8.140143169337396],
            [-2.860143593996389, 8.145120963342666],
            [-2.860779707013394, 8.153089990094742],
            [-2.8625827772759953, 8.159704599860707],
            [-2.8602061775821355, 8.16648533980374],
            [-2.855674508749758, 8.171273569252797],
            [-2.847468537045952, 8.1862629817666],
            [-2.847326260303609, 8.19232604331718],
            [-2.8453819071835893, 8.19972971707017],
            [-2.8509372228821754, 8.212773948993673],
            [-2.8546780048064817, 8.215336085440427],
            [-2.8596615904497047, 8.22155779478527],
            [-2.8686950117838075, 8.231396405087068],
            [-2.8750099187310165, 8.241994111977464],
            [-2.8821590079732697, 8.260749937884514],
            [-2.899786729348857, 8.292597594700695],
            [-2.9025262123065803, 8.301718752350634],
            [-2.89926468508079, 8.318317164764428],
            [-2.8983631653253052, 8.326811853044003],
            [-2.899195701259279, 8.339922166201271],
            [-2.9008818351049417, 8.346327860706614],
            [-2.9028813932290314, 8.348648393272457],
            [-2.91673686155012, 8.360448805699797],
            [-2.920306179464315, 8.368836823445701],
            [-2.917575321050959, 8.378669539305582],
            [-2.911988734288206, 8.385832619871985],
            [-2.904081539791716, 8.390348613360837],
            [-2.893186644959061, 8.394332119186634],
            [-2.8890059490080353, 8.396802707733835],
            [-2.879096053950907, 8.408525997705558],
            [-2.877072793397981, 8.415375762738314],
            [-2.875477156936975, 8.431163753659089],
            [-2.878866842225295, 8.44022774691789],
            [-2.8843223900084, 8.447774275131604],
            [-2.890353781387832, 8.453573230043505],
            [-2.9055205474776096, 8.470778973053815],
            [-2.9120066044089117, 8.483755704065619],
            [-2.91287640146143, 8.487645861711783],
            [-2.9128673909432456, 8.517228183840345],
            [-2.915445389635345, 8.532969491071677],
            [-2.920646696541545, 8.54210433088299],
            [-2.925574749721246, 8.546003819841403],
            [-2.9286786292250393, 8.551032800430795]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.46870461092585,
          "lat": 46.977456674271856
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38015"],
        "coty_name": ["Burleigh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Burleigh County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01035614"
      },
      "bbox": [
        -2.9286786292250393, 8.006988787744843, -2.328395783288142,
        8.71106199449701
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.366192074753894, -1.5923578697922016],
            [9.487842462945268, -1.5815271639072501],
            [9.552823997822793, -1.5770396789741397],
            [9.586879934092911, -1.5725005236724419],
            [9.632029277527971, -1.5676080105057397],
            [9.768042501620648, -1.5551360492288884],
            [9.775798767946213, -1.5540732718299262],
            [9.777933101024852, -1.573841778744248],
            [9.777050654877259, -1.5796469775084603],
            [9.78874855006243, -1.5802245055870265],
            [9.78748707363367, -1.589432766745066],
            [9.790262796695428, -1.5969202505010074],
            [9.788374456079879, -1.5997987301426793],
            [9.791044723989824, -1.610959055004604],
            [9.790436790419283, -1.6151021151788874],
            [9.784686104073566, -1.6191717273378121],
            [9.787038421486738, -1.6238573652777337],
            [9.786873823860121, -1.6320127306759686],
            [9.783941376060305, -1.635441416086958],
            [9.777806613558738, -1.6354813194312425],
            [9.769431338213396, -1.6436370025306573],
            [9.766843191921657, -1.644770968347219],
            [9.759754438417577, -1.6425979418990828],
            [9.75082539769492, -1.6437021864358656],
            [9.745600691966514, -1.645567957937692],
            [9.735501648292976, -1.6430528295711713],
            [9.731459355225613, -1.6434498849487298],
            [9.732979070532378, -1.6492612944158078],
            [9.725541247160843, -1.6553750233806577],
            [9.730155631751915, -1.6601745481699475],
            [9.727710401296738, -1.665602382684059],
            [9.729661715468414, -1.668917338811084],
            [9.728295507579224, -1.6733244799424816],
            [9.730025188350703, -1.677814617716763],
            [9.727331905510438, -1.6821493749781693],
            [9.728273030378265, -1.688478304308293],
            [9.72355474182424, -1.6883855286865035],
            [9.719228520457492, -1.6905490284099913],
            [9.717972125444309, -1.698796466037193],
            [9.72360301571175, -1.7009743309932572],
            [9.726144201313351, -1.7042980236673024],
            [9.729469670640308, -1.7134461593784174],
            [9.727768039889337, -1.7162188208710774],
            [9.731769077352139, -1.7387817819106879],
            [9.738683016859273, -1.7419312855748503],
            [9.747029634222052, -1.7496512854920077],
            [9.748250990548916, -1.7533415352993729],
            [9.752384921549057, -1.7594315190615566],
            [9.76142460521022, -1.7667454053517035],
            [9.759898831633311, -1.7690739519390777],
            [9.7555069182976, -1.7665419299735827],
            [9.750477155661974, -1.761686047797915],
            [9.746039384445952, -1.7628435331816983],
            [9.743303802064561, -1.7654174973743646],
            [9.745098802079047, -1.774752512400606],
            [9.747956442813901, -1.778364946406078],
            [9.745894833798902, -1.780550782682807],
            [9.752636704482814, -1.7863272378646098],
            [9.751181799279484, -1.7901665804397138],
            [9.747262901444433, -1.7890233426123603],
            [9.75965312674443, -1.86850921497932],
            [9.75723567856503, -1.8723651986728886],
            [9.757315465331512, -1.8756062063795036],
            [9.748244179594424, -1.877034163356965],
            [9.745806172968159, -1.8795747944607848],
            [9.742238357986725, -1.8800140463990278],
            [9.735585080364727, -1.8847969756616156],
            [9.734247862845077, -1.8883157921915057],
            [9.729073449100262, -1.8913914169332782],
            [9.726061539547585, -1.8976569143074413],
            [9.726704878657609, -1.905506120682699],
            [9.729542593062753, -1.9115620456974607],
            [9.72908803724364, -1.9196476664827768],
            [9.735810237198187, -1.928477601714525],
            [9.7331917893271, -1.933373282824157],
            [9.734092565943566, -1.9406823601978491],
            [9.732186645149127, -1.9454903156013748],
            [9.72690014594305, -1.9516280060059996],
            [9.721159669776448, -1.9553816112241755],
            [9.72031934396523, -1.9577206914168739],
            [9.722228449680104, -1.9627715416893468],
            [9.717876014623272, -1.9706230549220345],
            [9.713782309144701, -1.9746820342979123],
            [9.716504758883906, -1.9817675152497756],
            [9.714736806972088, -1.9857445685167772],
            [9.71103713526696, -1.9871125330027184],
            [9.706283955993522, -1.9936907479652062],
            [9.699608154513268, -1.9937963125606026],
            [9.69787573856796, -1.9980733117472873],
            [9.692788263875153, -1.9979839643725161],
            [9.686431388101703, -2.0006915991929404],
            [9.68082174274421, -1.9917222579203195],
            [9.669846281338328, -1.9843217607843704],
            [9.669289469095826, -1.9764629267792426],
            [9.66455780168697, -1.9766333527962963],
            [9.661468385730172, -1.9750790198582497],
            [9.657603638164414, -1.9691475555522986],
            [9.657688048828325, -1.9632430277331434],
            [9.605750956468865, -1.9466882833888612],
            [9.589448981660626, -1.9410415115592579],
            [9.587656572001986, -1.9468472349230526],
            [9.579421762797462, -1.9499765159392628],
            [9.573386074759517, -1.9470544708765898],
            [9.576117329795276, -1.9392996225946304],
            [9.573583217240582, -1.9283262855510936],
            [9.5721270652688, -1.9262665674398354],
            [9.56913466480776, -1.910165843241684],
            [9.557782693756959, -1.9114340436823276],
            [9.553053811725615, -1.9022489871023125],
            [9.545202382228357, -1.904516018223653],
            [9.538540937995146, -1.909992244672008],
            [9.525758372268719, -1.8966512775520186],
            [9.455345738566074, -1.8178969845576627],
            [9.459707454768335, -1.8161069718727032],
            [9.463900045574443, -1.8119509907913338],
            [9.462294483110856, -1.8035117039597044],
            [9.465063503990722, -1.799266498667605],
            [9.471972931408835, -1.796549071133737],
            [9.485442043460276, -1.789499674435215],
            [9.476762605060578, -1.7791100961952873],
            [9.480469453818076, -1.7785635217220288],
            [9.478700328852277, -1.771770673764066],
            [9.471056002811943, -1.7723738991894082],
            [9.45413530867017, -1.752352741305816],
            [9.428664917358683, -1.6909586906481424],
            [9.41237966773242, -1.6666803238125392],
            [9.394632669659, -1.6394742906906818],
            [9.360689326460527, -1.5928416280413753],
            [9.366192074753894, -1.5923578697922016]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.50349940589773,
          "lat": 36.428493222641194
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47151"],
        "coty_name": ["Scott"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Scott County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01639788"
      },
      "bbox": [
        9.360689326460527, -2.0006915991929404, 9.791044723989824,
        -1.5540732718299262
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.237198034996244, -3.3386192984884726],
            [-5.001255101438839, -3.353866580304099],
            [-4.996468500625987, -3.354359841104204],
            [-4.900113219797503, -3.358717087385267],
            [-4.860322194888043, -3.362015345824087],
            [-4.831700585806085, -3.3641324861114836],
            [-4.720982183709177, -3.3727388158107936],
            [-4.632097573132023, -3.379402441377629],
            [-4.614619344076055, -3.381577799608668],
            [-4.597064103248642, -3.382765251633843],
            [-4.590902113692731, -3.383903752739415],
            [-4.530004579707059, -3.387674449774063],
            [-4.535360773468132, -3.468916113485691],
            [-4.540190378048732, -3.541036078005453],
            [-4.5566768929968156, -3.7822464607664803],
            [-4.559618543789991, -3.825337938885201],
            [-4.5596703777270235, -3.8261461836108195],
            [-4.724009068441713, -3.8159062798146532],
            [-4.849384536493172, -3.8064915606547163],
            [-4.920005843794774, -3.8013576169490126],
            [-5.040798712267289, -3.792525483544769],
            [-5.133569464615611, -3.7858970797131133],
            [-5.134093923985778, -3.785772404374417],
            [-5.270052286213107, -3.776046320012268],
            [-5.262381589116484, -3.6728048862942138],
            [-5.258489853698454, -3.6233380046070303],
            [-5.254439233341931, -3.5685356120350944],
            [-5.2466468604177665, -3.463101900449124],
            [-5.242880962809674, -3.4121443463788377],
            [-5.242250612388868, -3.396900009054364],
            [-5.240336500395075, -3.37717446639794],
            [-5.237198034996244, -3.3386192984884726]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.60498749509675,
          "lat": 34.96603344209799
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48117"],
        "coty_name": ["Deaf Smith"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Deaf Smith County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "01383845"
      },
      "bbox": [
        -5.270052286213107, -3.8261461836108195, -4.530004579707059,
        -3.3386192984884726
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.500539497365573, -9.044956266577097],
            [-2.4493067368313812, -9.047063994434184],
            [-2.410857272387963, -9.048938821409832],
            [-2.371092441894398, -9.051235894211773],
            [-2.309943804896188, -9.053553180300874],
            [-2.3092837805034785, -9.053781647846316],
            [-2.201020373396076, -9.058738950228985],
            [-2.143272495468989, -9.061102320347239],
            [-2.1289139209762293, -9.061325495539407],
            [-2.12619237051304, -9.064525857214104],
            [-2.1225783383041863, -9.071588027251364],
            [-2.123189687210794, -9.079839382261001],
            [-2.1252281741794876, -9.085782382224084],
            [-2.1308662711747473, -9.093395158229741],
            [-2.132982981556342, -9.099527838234087],
            [-2.1319443391158677, -9.102261485645945],
            [-2.126857755826212, -9.10513238925209],
            [-2.1264974826674186, -9.108826989209497],
            [-2.132307934687469, -9.113931853781663],
            [-2.132007878846628, -9.119895842899492],
            [-2.12718604452505, -9.128617834197657],
            [-2.122799824009334, -9.132172744234419],
            [-2.117844325186149, -9.130427950437637],
            [-2.1143722579697175, -9.12555675545343],
            [-2.108354117990171, -9.12442105616359],
            [-2.101320635211397, -9.126519978473736],
            [-2.093823661653452, -9.126585442360017],
            [-2.0854858385503996, -9.121851694664295],
            [-2.0816114421856637, -9.123251018636497],
            [-2.02352198292558, -9.057344862666836],
            [-2.0219956387364943, -9.05587129701762],
            [-1.9729716502499497, -8.999539247539298],
            [-1.9741321304605821, -9.056274799645614],
            [-1.975627654287718, -9.10898712847256],
            [-1.977085800733664, -9.165422153276596],
            [-1.9784939375649362, -9.224293322901783],
            [-1.982109395749406, -9.362094457717326],
            [-1.982675113343639, -9.372078132724775],
            [-1.984401098284554, -9.433700640752585],
            [-1.9847819169995895, -9.448878802883526],
            [-1.9892459701282257, -9.591566401217099],
            [-2.0479854798353863, -9.590027339004388],
            [-2.0507930181146934, -9.58955332914469],
            [-2.077256323624624, -9.588801914128075],
            [-2.1208147169825375, -9.587199278386363],
            [-2.2277205104670394, -9.58378250543554],
            [-2.2653788905468892, -9.582516028973213],
            [-2.2693660078184528, -9.582779092677024],
            [-2.3269909693795694, -9.58045358039772],
            [-2.334971131186758, -9.580417573960045],
            [-2.376586081517666, -9.578819983759889],
            [-2.3811439206700835, -9.578163493800073],
            [-2.5215799595263584, -9.573499667647328],
            [-2.519685408078799, -9.54013937721817],
            [-2.5123470398638195, -9.354514639009887],
            [-2.5110664640436884, -9.323698350092632],
            [-2.5072402869626496, -9.20987058246622],
            [-2.506169433490345, -9.18645125680726],
            [-2.5056618708372747, -9.167331157514282],
            [-2.500539497365573, -9.044956266577097]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.11008652126768,
          "lat": 29.355702678747882
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48325"],
        "coty_name": ["Medina"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Medina County"],
        "coty_fp_code": "325",
        "coty_gnis_code": "01383948"
      },
      "bbox": [
        -2.5215799595263584, -9.591566401217099, -1.9729716502499497,
        -8.999539247539298
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.7831678637654096, -8.592431000369345],
            [-2.7246697779356563, -8.594880647606983],
            [-2.732251156237066, -8.75835967040364],
            [-2.65574876335752, -8.762156300190066],
            [-2.6617163888421045, -8.9120548108631],
            [-2.662568099022253, -8.927566446003889],
            [-2.666692547388723, -9.039227204464115],
            [-2.724835366433538, -9.037993933364522],
            [-2.790403759520437, -9.036441266309124],
            [-2.7958573519151497, -9.036670646478589],
            [-2.8388569693411885, -9.03522658288536],
            [-2.9031789687214586, -9.032806108834585],
            [-3.0237777133473918, -9.028731943382892],
            [-3.017496044480778, -9.02030747317106],
            [-3.018211259306951, -9.01555115238259],
            [-3.022537151161535, -9.011364971900756],
            [-3.0286762204356816, -8.999622734059292],
            [-3.032811972221681, -8.99509054508916],
            [-3.036083931157294, -8.988899164517242],
            [-3.033883304510001, -8.984785269325672],
            [-3.027954144072314, -8.982877421135212],
            [-3.024003891022567, -8.97662487971407],
            [-3.033346565644515, -8.969306855701552],
            [-3.0351000392892726, -8.963890423472424],
            [-3.0424985755939495, -8.962261539287548],
            [-3.043910974328293, -8.959215109392662],
            [-3.0481770932171592, -8.957070352391408],
            [-3.0494059958182818, -8.949656452686863],
            [-3.0480985624387213, -8.945636098509997],
            [-3.0530199480916185, -8.942304996646318],
            [-3.0558306346729975, -8.942980828608327],
            [-3.0630589575980607, -8.940481604402216],
            [-3.0417332886200867, -8.933805728807846],
            [-3.0399469831456085, -8.931464042662757],
            [-3.0337308474512694, -8.931832663523739],
            [-3.030131576818271, -8.92987339831329],
            [-3.0286101740276488, -8.923428723700649],
            [-3.031141288180355, -8.921943667297436],
            [-3.0323736507608574, -8.916635869795138],
            [-3.0308324908246713, -8.911936842775761],
            [-3.0257005253334066, -8.909558625244127],
            [-3.0274879022034713, -8.905059419649824],
            [-3.0268888578729953, -8.900244441179069],
            [-3.028179924670635, -8.895519412996956],
            [-3.030330158928467, -8.894994003778214],
            [-3.032626576342477, -8.882508831835453],
            [-3.035598276392893, -8.879853046754597],
            [-3.036189126245567, -8.874492811781453],
            [-3.0321773017826104, -8.87249507122589],
            [-3.029351672580122, -8.8686791143973],
            [-3.0293366979134206, -8.864406830352717],
            [-3.0202686087200643, -8.86245888416271],
            [-3.0157836847981474, -8.86007134804073],
            [-3.017827080830769, -8.853966282679677],
            [-3.0183154403666848, -8.842480871860666],
            [-3.0198587617147816, -8.839143495874445],
            [-3.022932693583858, -8.839187127534442],
            [-3.026620219871237, -8.829907588511364],
            [-3.0249276770297993, -8.825323711099005],
            [-3.0272075512643983, -8.818906522801067],
            [-3.029715435404214, -8.81728204730784],
            [-3.029496391832395, -8.813313201006585],
            [-3.0323323900805397, -8.810164353478449],
            [-3.0287359234000326, -8.806149994726784],
            [-3.022766722893401, -8.805478555657388],
            [-3.0209438900519876, -8.800734221175697],
            [-3.0206413583784446, -8.792742608832047],
            [-3.0180822509299916, -8.789631437443953],
            [-3.0180284020739645, -8.785497737602164],
            [-3.0215590921778137, -8.780564543389477],
            [-3.0209836419390736, -8.772318251914733],
            [-3.0183162366913487, -8.7701271044896],
            [-3.0147205905323573, -8.764293691404669],
            [-3.008996207062215, -8.76191009861573],
            [-3.007741190594719, -8.758670498459148],
            [-3.0019440625344687, -8.759202204985899],
            [-2.999471557882701, -8.74091189132342],
            [-2.999290925437526, -8.736672603172678],
            [-2.9855984168021137, -8.632204950885926],
            [-2.9712808823686276, -8.633943462146634],
            [-2.9641839863975554, -8.577004130557647],
            [-2.921040675777325, -8.582499543222516],
            [-2.921717690463755, -8.587386606734336],
            [-2.7831678637654096, -8.592431000369345]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.82217347364126,
          "lat": 29.831795194681433
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48385"],
        "coty_name": ["Real"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Real County"],
        "coty_fp_code": "385",
        "coty_gnis_code": "01383978"
      },
      "bbox": [
        -3.0630589575980607, -9.039227204464115, -2.65574876335752,
        -8.577004130557647
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.9987857811035927, -6.966990361777452],
            [-3.989643595737333, -6.817531151634844],
            [-3.9720630326136948, -6.532544855059834],
            [-3.9045314607339785, -6.53616436374762],
            [-3.8666492383956954, -6.538406232077589],
            [-3.747564790236767, -6.545027062708954],
            [-3.7449279724057103, -6.545005924418824],
            [-3.633727652528936, -6.551095481760377],
            [-3.599456567384266, -6.552730534313702],
            [-3.6133185032618407, -6.788385743826144],
            [-3.6225426368086797, -6.941615021027588],
            [-3.6522972412346664, -6.9308616866144135],
            [-3.6584692408503914, -7.010730365738351],
            [-3.663168069666102, -7.073149360511511],
            [-3.8042540436751175, -7.068379435392907],
            [-3.892777936583084, -7.064881306074146],
            [-4.004466274106275, -7.060896550431882],
            [-3.9990369969121278, -6.973627437386969],
            [-3.9987857811035927, -6.966990361777452]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.05005427505345,
          "lat": 31.827798032467474
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48431"],
        "coty_name": ["Sterling"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sterling County"],
        "coty_fp_code": "431",
        "coty_gnis_code": "01384001"
      },
      "bbox": [
        -4.004466274106275, -7.073149360511511, -3.599456567384266,
        -6.532544855059834
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.382909612164221, -5.136581486729395],
            [-5.185880099772262, -5.151047925094878],
            [-5.128885486254914, -5.155173865312464],
            [-5.000909289919493, -5.1638789387276995],
            [-5.001346002511414, -5.1773096445820554],
            [-5.00694184431031, -5.2536243324582115],
            [-5.008916474716388, -5.282800593944293],
            [-5.0193760300407035, -5.429400242372732],
            [-5.021043060372228, -5.455549597570246],
            [-5.03104898660057, -5.593399797304769],
            [-5.168687230201297, -5.5837664613111775],
            [-5.198122802354384, -5.581826238322375],
            [-5.2469820683105945, -5.578209694679719],
            [-5.365339001542913, -5.5692209795461025],
            [-5.368233402814036, -5.568677068603821],
            [-5.421618174809894, -5.5651511514174645],
            [-5.418542471584097, -5.524399452617093],
            [-5.415107476629476, -5.4856864042343325],
            [-5.405648691457897, -5.383717256143706],
            [-5.39840177245642, -5.305524882378409],
            [-5.395317564949961, -5.268526517304842],
            [-5.39461464654592, -5.264448287341675],
            [-5.387999688249681, -5.195466606617633],
            [-5.382909612164221, -5.136581486729395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.82778303220691,
          "lat": 33.17299375688937
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48501"],
        "coty_name": ["Yoakum"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yoakum County"],
        "coty_fp_code": "501",
        "coty_gnis_code": "01384036"
      },
      "bbox": [
        -5.421618174809894, -5.593399797304769, -5.000909289919493,
        -5.136581486729395
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.77007841343745, 4.576176516246913],
            [-12.732984971631494, 4.568287246827497],
            [-12.692008602564739, 4.557276499237713],
            [-12.669684077778056, 4.551585646452922],
            [-12.645206802023417, 4.546588664976128],
            [-12.57028302561319, 4.533697026735359],
            [-12.506360233156371, 4.523036145716788],
            [-12.396617268966326, 4.504521243288873],
            [-12.274628553262819, 4.483950402245014],
            [-12.226835903644034, 4.4759943086546015],
            [-12.149710750935595, 4.462943672006102],
            [-12.013808003898284, 4.439999505538162],
            [-11.92813365644475, 4.42553498793895],
            [-11.850117784938172, 4.412347996452412],
            [-11.75753580567266, 4.396423405234202],
            [-11.6563205188829, 4.379147551880236],
            [-11.606977446284226, 4.370539128869106],
            [-11.551781076518884, 4.361227831138835],
            [-11.421765169957467, 4.338964183070244],
            [-11.412345376920264, 4.337664450935757],
            [-11.402714980018285, 4.332851698826931],
            [-11.408062760132562, 4.331493649436899],
            [-11.402958721499811, 4.32577049358536],
            [-11.40111628305451, 4.318925587270794],
            [-11.401421121586388, 4.3042553270714805],
            [-11.397386283362872, 4.300206436396732],
            [-11.39672575941112, 4.296321084968322],
            [-11.393642267474977, 4.296545855280023],
            [-11.391243044783076, 4.290711517125749],
            [-11.390663597156129, 4.285579545651445],
            [-11.387173361042079, 4.271607335293764],
            [-11.388163780341216, 4.264846947483668],
            [-11.387563621421465, 4.258686062985845],
            [-11.383905497307017, 4.249189266944058],
            [-11.379927562675082, 4.245248167920811],
            [-11.379157947143812, 4.2411281190583505],
            [-11.365391357801572, 4.229716785885343],
            [-11.362041285770362, 4.221611894582963],
            [-11.359296740220666, 4.211256144328493],
            [-11.356131364115996, 4.206138368213784],
            [-11.354266372646343, 4.199645105988017],
            [-11.355580583543167, 4.19186351700978],
            [-11.351558867187016, 4.191721362850061],
            [-11.348184225405602, 4.185562505110672],
            [-11.345806292064001, 4.172703217641383],
            [-11.346974834965375, 4.1639872342402295],
            [-11.341768658559454, 4.144643921714948],
            [-11.338135372856778, 4.140893763155945],
            [-11.340367399503478, 4.135820054439934],
            [-11.340959310505617, 4.13036172386459],
            [-11.339248970667073, 4.126900428006243],
            [-11.332917136390314, 4.123412006424457],
            [-11.330654423950783, 4.120087578087376],
            [-11.327619050591679, 4.112391151354812],
            [-11.329019288666787, 4.108167423931569],
            [-11.334319202972239, 4.099281585175542],
            [-11.338345432360605, 4.099342067437103],
            [-11.343646586053726, 4.096534828748886],
            [-11.344240499093189, 4.092843815458529],
            [-11.350230602566107, 4.087879717674656],
            [-11.35016177117885, 4.080430799757646],
            [-11.353644550779096, 4.070956068541643],
            [-11.35714549647176, 4.065148027702722],
            [-11.361642698447417, 4.060930413015638],
            [-11.365563212229533, 4.050249367313909],
            [-11.367375411289975, 4.041609494155584],
            [-11.36679653365398, 4.033208274619565],
            [-11.373037468696216, 4.029786621653532],
            [-11.37520926417277, 4.023906227668408],
            [-11.372454070342815, 4.010126307261907],
            [-11.366968769584592, 4.005060595311049],
            [-11.362949454382191, 4.003401983120463],
            [-11.360997976330493, 3.9896641982806393],
            [-11.356918279289069, 3.9826746112827074],
            [-11.355948296732794, 3.978187938622297],
            [-11.35538348088022, 3.9676839812207683],
            [-11.358472006756788, 3.961827296376241],
            [-11.356948823697715, 3.954235576795562],
            [-11.35257302836254, 3.948402192708269],
            [-11.35471634233965, 3.946598969543615],
            [-11.356256620930235, 3.9334546355648894],
            [-11.354756996924364, 3.931328149096115],
            [-11.356453734330506, 3.9249573076573374],
            [-11.359517148891403, 3.9204884931363715],
            [-11.360092984326405, 3.911826696451585],
            [-11.357916580756756, 3.898325255364488],
            [-11.35815474956243, 3.890548093900423],
            [-11.355588249260888, 3.884162597455741],
            [-11.358861271797533, 3.8759951102236148],
            [-11.356474633154697, 3.8729808728827018],
            [-11.355142876329772, 3.86171465482958],
            [-11.35200442932537, 3.850897969028169],
            [-11.34887569924301, 3.8514409825314018],
            [-11.347423233618414, 3.8557679355732577],
            [-11.34361250754235, 3.8591316718732847],
            [-11.335846602415097, 3.8578502095552842],
            [-11.328630901464415, 3.8636061869020626],
            [-11.32059168420219, 3.8650181168475957],
            [-11.316174882628161, 3.861773708138174],
            [-11.315891275476826, 3.855155693718915],
            [-11.311146037979903, 3.846916627415156],
            [-11.304415265940413, 3.847911156127894],
            [-11.302437381440908, 3.8399806073336973],
            [-11.303639301982392, 3.8328941980607953],
            [-11.303403307134142, 3.826791965254784],
            [-11.300452658882373, 3.8232178816006646],
            [-11.303282063064591, 3.815124719527635],
            [-11.301654944615311, 3.8105489730742637],
            [-11.301344869881724, 3.8048389032753165],
            [-11.293638952236222, 3.8021291802097714],
            [-11.286848700061206, 3.801063358873152],
            [-11.284787170886966, 3.79568178818505],
            [-11.281609465060917, 3.793722485877999],
            [-11.280634636997837, 3.7889542310728745],
            [-11.283928116832202, 3.7874911798215476],
            [-11.283779434656845, 3.7839009818890554],
            [-11.286034345846657, 3.780385776991064],
            [-11.29634732144208, 3.7764873388956928],
            [-11.300137068349262, 3.7762730775551185],
            [-11.307162570963758, 3.7800535453929545],
            [-11.312535647540704, 3.778576057881769],
            [-11.31625879472675, 3.7730102485124117],
            [-11.3166046751319, 3.769722297188576],
            [-11.311071121831354, 3.764233223057035],
            [-11.305643808503222, 3.7610573382115735],
            [-11.30715726508214, 3.756976785990476],
            [-11.305086908564686, 3.7525279065274972],
            [-11.30101819890465, 3.747970980189051],
            [-11.294177976449209, 3.7461513188909543],
            [-11.295081493476994, 3.740605218040251],
            [-11.297918032365345, 3.733464925366308],
            [-11.299539861827114, 3.7321366642952003],
            [-11.304513086188736, 3.729346163817478],
            [-11.306410700801274, 3.72488115716483],
            [-11.314304513317643, 3.7270384360768727],
            [-11.318496548282207, 3.7245811375320135],
            [-11.325583937540795, 3.7223502798689423],
            [-11.332366298738782, 3.7238324775604226],
            [-11.335001475520667, 3.7277322273745193],
            [-11.33988348049646, 3.7281762686420765],
            [-11.34088361893921, 3.7331210629210503],
            [-11.343363078228803, 3.7370662911384955],
            [-11.34891967891159, 3.7427467193653285],
            [-11.35164006341282, 3.748608893958034],
            [-11.357117868312255, 3.740673360496127],
            [-11.364289263822203, 3.7366897852230454],
            [-11.364615417076168, 3.730918198710409],
            [-11.362619829961494, 3.7260521659120287],
            [-11.364801271901628, 3.7118580689086933],
            [-11.36613825077272, 3.7085934155458373],
            [-11.37115292002036, 3.7027531226773975],
            [-11.373513133206872, 3.695177980562349],
            [-11.366800372131655, 3.681413706314533],
            [-11.372197126367062, 3.680464160151554],
            [-11.378867472546185, 3.6762598329510676],
            [-11.390124894219763, 3.672906849614463],
            [-11.392975638528187, 3.6700548408479334],
            [-11.398806656697257, 3.6704825918307815],
            [-11.399943373605396, 3.667548175847245],
            [-11.403593523794964, 3.6655687436007027],
            [-11.412278821836402, 3.6674278222680816],
            [-11.414645535818467, 3.666685971026433],
            [-11.419730309971628, 3.6608235437862136],
            [-11.496407606656453, 3.6742627565732575],
            [-11.57353430601559, 3.687170710830733],
            [-11.665772635480318, 3.598147857640762],
            [-11.692435871769653, 3.572308248243131],
            [-11.806134132737068, 3.4623661303483217],
            [-11.938854701915819, 3.4421691999763233],
            [-12.005252283968852, 3.4321200470769817],
            [-12.044947851325775, 3.4259008677096534],
            [-12.140608297732214, 3.4430951426267726],
            [-12.236271248668904, 3.460275216787759],
            [-12.417082857268701, 3.4940542780809962],
            [-12.597903822035136, 3.527782440517172],
            [-12.778734083735479, 3.561459684345804],
            [-12.959573582221127, 3.5950859948170337],
            [-12.919519194158664, 3.800356979654098],
            [-12.91972655032272, 3.803644727123602],
            [-12.917160092315427, 3.8124069395824307],
            [-12.864631214677818, 4.080574848952529],
            [-12.863585088278239, 4.088799624167505],
            [-12.841265142270704, 4.2026856226024325],
            [-12.839109208499528, 4.21203777807266],
            [-12.814565005668276, 4.339174471633488],
            [-12.797072552848467, 4.4348463945105],
            [-12.789476815955162, 4.468387208877647],
            [-12.77007841343745, 4.576176516246913]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -113.0821516383438,
          "lat": 41.521010729578435
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49003"],
        "coty_name": ["Box Elder"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Box Elder County"],
        "coty_fp_code": "003",
        "coty_gnis_code": "01455966"
      },
      "bbox": [
        -12.959573582221127, 3.4259008677096534, -11.280634636997837,
        4.576176516246913
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.969011509413525, 3.6110047845069206],
            [-10.966750936044628, 3.6115610629567456],
            [-10.957003000571966, 3.609977764663603],
            [-10.955083560092719, 3.616871876649631],
            [-10.948983052519713, 3.619973072005174],
            [-10.940072787119407, 3.619176807774444],
            [-10.929519438525642, 3.608625260379595],
            [-10.929578002239014, 3.6049339826671076],
            [-10.919398955657176, 3.604461029610059],
            [-10.915336173411077, 3.603264282178631],
            [-10.914866198820063, 3.6001853146009517],
            [-10.910802648051842, 3.595560164659879],
            [-10.904382710551532, 3.5965678389242655],
            [-10.901517042998558, 3.5917964534477704],
            [-10.902587782265597, 3.5840236474893685],
            [-10.896920840558376, 3.5814568096893393],
            [-10.89531983657354, 3.5778041451762657],
            [-10.888669294865574, 3.569759352309618],
            [-10.881585220408667, 3.5648392146209615],
            [-10.882671797056325, 3.5545012303165024],
            [-10.884134911830788, 3.5477607287210993],
            [-10.883055888308224, 3.544122599079939],
            [-10.877000140763453, 3.542039099997942],
            [-10.878999653942573, 3.5395936241378423],
            [-10.871266120245046, 3.5337808468707936],
            [-10.871619936227786, 3.5323276138929423],
            [-10.862621521771581, 3.5278431684478675],
            [-10.861838792472044, 3.5217175672212213],
            [-10.863920739309535, 3.5181199247612502],
            [-10.870805381742697, 3.51573520998306],
            [-10.87712044372297, 3.5105190804066124],
            [-10.876984896247158, 3.4972535780457648],
            [-10.882371168185921, 3.4950816467661516],
            [-10.879958103031516, 3.4900644107624266],
            [-10.882296341076325, 3.478255703950967],
            [-10.878291263943757, 3.473133763766579],
            [-10.878060076272602, 3.4692656618890214],
            [-10.88301402921544, 3.4674494653231673],
            [-10.887590676201256, 3.464292135180966],
            [-10.889137781221084, 3.460347818594777],
            [-10.88456577752817, 3.459054247394676],
            [-10.867657422006422, 3.4596339414230415],
            [-10.868148861028148, 3.453308792720269],
            [-10.871230699852878, 3.448456190260606],
            [-10.867871190863749, 3.444850125942301],
            [-10.861713859972019, 3.444801574466714],
            [-10.854520601773075, 3.446613828372954],
            [-10.846478103309833, 3.442291109540698],
            [-10.846447926532191, 3.4396563931936712],
            [-10.854822501152215, 3.4318616514513574],
            [-10.85648782589295, 3.426078383031863],
            [-10.852986060709195, 3.4188365498346185],
            [-10.856488046343703, 3.4143840549564337],
            [-10.862199232725075, 3.410871269842636],
            [-10.860654776737986, 3.406202839317032],
            [-10.865259981178726, 3.3995307967752733],
            [-10.87322222082169, 3.391277432823243],
            [-10.878080080149612, 3.3877386073026474],
            [-10.889561791330529, 3.3766050140452064],
            [-10.896948156781285, 3.3763012175347225],
            [-10.9092263885346, 3.378665518821374],
            [-10.912079259446614, 3.3752359738455717],
            [-10.916562537879209, 3.3739702828327762],
            [-10.922372329555358, 3.368707867905648],
            [-10.925099002841897, 3.368538334874447],
            [-10.930876671171418, 3.3714651366588275],
            [-10.934518961522592, 3.3771505814239284],
            [-10.939919425880886, 3.3785925390314113],
            [-10.945093903035817, 3.3743838653102527],
            [-10.947406706378878, 3.3745435859829325],
            [-10.951632904867472, 3.3710437708936922],
            [-10.95368998483626, 3.372650870541812],
            [-10.967292434956102, 3.3743677675428265],
            [-10.969599760326924, 3.367126999969831],
            [-10.969154785859113, 3.364628540342589],
            [-10.97200167065158, 3.360777525763526],
            [-10.976177652991504, 3.3581587721679167],
            [-10.978547866772008, 3.3541098736493993],
            [-10.98068738006973, 3.3448549549740907],
            [-10.983232469680525, 3.3436992003476598],
            [-10.98411592466184, 3.3337814657746105],
            [-10.990896173262975, 3.33327137297883],
            [-10.993546807858083, 3.329822032289887],
            [-10.999530461278697, 3.3304892267848167],
            [-11.00481515649285, 3.326160516662079],
            [-11.013016422756214, 3.3252591304858083],
            [-11.016962569485914, 3.3285007005826186],
            [-11.0168666631821, 3.3317049614120045],
            [-11.021627442987898, 3.3339305282417646],
            [-11.024444036998606, 3.3336404548289886],
            [-11.033157090631327, 3.336838751505111],
            [-11.03749158166126, 3.334457844573293],
            [-11.040574750365947, 3.3304492975875335],
            [-11.04729554313484, 3.3294215654403696],
            [-11.050837775465183, 3.327722369355496],
            [-11.055152898279093, 3.323021580101924],
            [-11.069423699499348, 3.3213102338303204],
            [-11.07194301210245, 3.324833081101967],
            [-11.077179738260535, 3.3239416999556815],
            [-11.082056360336168, 3.3254560697303215],
            [-11.085482631715282, 3.32185006374676],
            [-11.094642655764087, 3.3205032063344024],
            [-11.102183771659833, 3.316534321164595],
            [-11.10928525667591, 3.31174073072111],
            [-11.11494295647339, 3.303730662025372],
            [-11.117941473349685, 3.3034616770265655],
            [-11.121781304978713, 3.3004585095137817],
            [-11.125006502963462, 3.2912488531788036],
            [-11.122423058729417, 3.288848700553909],
            [-11.123877684610669, 3.2849145707175897],
            [-11.12798099019293, 3.2798530544792412],
            [-11.131075431736594, 3.2783881161632964],
            [-11.136684950636624, 3.273003953484714],
            [-11.146043894872262, 3.267437106627414],
            [-11.151738417643902, 3.2687756741515446],
            [-11.156808164247362, 3.264836039224128],
            [-11.157830787070024, 3.259616345129796],
            [-11.15463205961623, 3.251314279159492],
            [-11.157032946394548, 3.2385883471636667],
            [-11.155116662164156, 3.2343410310888836],
            [-11.150705074315374, 3.230028649547494],
            [-11.147309639469778, 3.2320089242197936],
            [-11.142316760790328, 3.2296828412188696],
            [-11.136475656071518, 3.2284815379241105],
            [-11.132146452851698, 3.222447377107145],
            [-11.125419203100304, 3.2219520213077053],
            [-11.11857339022566, 3.2243764343958237],
            [-11.11235615492946, 3.2189553102294397],
            [-11.11269217652919, 3.2109272945407548],
            [-11.11605683018641, 3.2039097630512026],
            [-11.118982142894373, 3.1891984157967017],
            [-11.120936843189154, 3.184921089408024],
            [-11.116713048086211, 3.184344347266465],
            [-11.111031614042837, 3.1810301644254606],
            [-11.110521520558704, 3.177220749927371],
            [-11.107483992877205, 3.1728284621085074],
            [-11.109535834959418, 3.16862591454929],
            [-11.110361340679338, 3.1614226647364183],
            [-11.108057371628398, 3.1603071770554227],
            [-11.10409611189063, 3.151799877546482],
            [-11.104257669228094, 3.146868079046824],
            [-11.102253205861055, 3.141468206816534],
            [-11.096933047448212, 3.134055613414027],
            [-11.094988524710477, 3.1251034204820223],
            [-11.094509688400304, 3.118772467363212],
            [-11.096164157779715, 3.11497736334216],
            [-11.10080317803899, 3.1149856462144405],
            [-11.104972811334111, 3.1118770657646238],
            [-11.108443373263087, 3.1043941616753354],
            [-11.119234930407895, 3.088996550304238],
            [-11.123144272500966, 3.085238459843208],
            [-11.128295736062157, 3.084510838311006],
            [-11.129024355678428, 3.0777517744357525],
            [-11.126448748268146, 3.0723435049906636],
            [-11.12902840797322, 3.070275368377612],
            [-11.129661063927022, 3.065249723208854],
            [-11.132740910357544, 3.0634578217711144],
            [-11.134896385301477, 3.0571853166982765],
            [-11.13968790410215, 3.0552455223582227],
            [-11.144843479106852, 3.0513010735745176],
            [-11.152522206126585, 3.051142916462608],
            [-11.15868511782045, 3.049959922484573],
            [-11.16515596464709, 3.0509431898386725],
            [-11.165570645029575, 3.055097622593531],
            [-11.174118442901749, 3.057414550594909],
            [-11.18120864285224, 3.064706898101185],
            [-11.185282157795818, 3.067532745406906],
            [-11.184699960789509, 3.0713348434219534],
            [-11.188098968333733, 3.0795472770312764],
            [-11.199552655737033, 3.087623646606056],
            [-11.203749170807875, 3.0878875428330304],
            [-11.210442546620051, 3.082935526365606],
            [-11.220957858386543, 3.0810419519374777],
            [-11.223781469789051, 3.0792530512968734],
            [-11.223711724297328, 3.086200578900364],
            [-11.220584453500683, 3.0892998301548604],
            [-11.221456566627594, 3.09880332617845],
            [-11.223572640316105, 3.1012826912456006],
            [-11.223032032152018, 3.1047883190902543],
            [-11.227556663260351, 3.1055175538759077],
            [-11.227529518822152, 3.1088888901623366],
            [-11.230172186104651, 3.1125420405306206],
            [-11.236019478986929, 3.112903466665474],
            [-11.236858114727173, 3.115297762286035],
            [-11.233824246375717, 3.123758710058587],
            [-11.230534623842045, 3.1274885982064085],
            [-11.232287831833363, 3.133001066023664],
            [-11.238932309208012, 3.139295595848174],
            [-11.245575675541238, 3.1414462214312353],
            [-11.250748650951916, 3.144880043092322],
            [-11.25397993282075, 3.1484382787182676],
            [-11.258053757899887, 3.148555892158266],
            [-11.26084172401781, 3.1434983310985514],
            [-11.263907180555476, 3.1406736583117145],
            [-11.267825427474616, 3.140428951795093],
            [-11.27342192134735, 3.1455297367242854],
            [-11.276393854457917, 3.1449277169011465],
            [-11.282041888464583, 3.1506790134634994],
            [-11.2858899914673, 3.153133127272724],
            [-11.286248376938007, 3.157337749988062],
            [-11.289792841494103, 3.163717825281293],
            [-11.293980089952932, 3.1660024773019475],
            [-11.298799244072153, 3.1665114682812097],
            [-11.305214803267075, 3.171079346304822],
            [-11.302430415549914, 3.173380539629815],
            [-11.298770173815925, 3.1798782895599316],
            [-11.299837662118785, 3.183857443214559],
            [-11.30463526174486, 3.1835456906786725],
            [-11.305438113912473, 3.189181520281049],
            [-11.309012512924552, 3.194531615337533],
            [-11.306831056212149, 3.1967750535459616],
            [-11.309931144074339, 3.209899442626344],
            [-11.317310718648766, 3.214320917637173],
            [-11.315382033449605, 3.2229121761898836],
            [-11.313473483710496, 3.224975289958009],
            [-11.315933303478454, 3.232613774091061],
            [-11.320910886055483, 3.2414918869468767],
            [-11.321462968794089, 3.24893342112514],
            [-11.324858309567082, 3.2505029624859736],
            [-11.326353362518272, 3.25790968358961],
            [-11.317511247046125, 3.2586386629676767],
            [-11.313394011177321, 3.2576436922218304],
            [-11.307613732024699, 3.2585203126275983],
            [-11.303743580337407, 3.2541589063679144],
            [-11.296262738067774, 3.255051998682579],
            [-11.296348220916299, 3.2571537458165905],
            [-11.300382659620267, 3.2654761688966385],
            [-11.301277536006637, 3.2717228562561607],
            [-11.305149029426067, 3.283512319034118],
            [-11.308835964929747, 3.287812585332476],
            [-11.311827914684956, 3.294054447257193],
            [-11.312150041053446, 3.3009595712866635],
            [-11.314785722779172, 3.304872797814879],
            [-11.321593462703545, 3.307478005216173],
            [-11.321255205737762, 3.3118328881080417],
            [-11.323787466915894, 3.3200734045804667],
            [-11.325685447792429, 3.3227170969998596],
            [-11.330065667812255, 3.322983794599552],
            [-11.331743229759262, 3.3345485937787105],
            [-11.327402203719789, 3.3401511825678156],
            [-11.329009138385755, 3.347772041199801],
            [-11.332164558448193, 3.353483019215997],
            [-11.330931921380188, 3.359797114396823],
            [-11.331800039958177, 3.3649452683996874],
            [-11.334985021139632, 3.3711022808185267],
            [-11.330930472387667, 3.379696686099752],
            [-11.332454077195953, 3.3868114075093865],
            [-11.330713464662841, 3.392071120522528],
            [-11.333077298856576, 3.3973867725651283],
            [-11.329765009380703, 3.4019025152357814],
            [-11.33239060002468, 3.4076448217551305],
            [-11.329638566241039, 3.4125474955533566],
            [-11.330592264726857, 3.416557436297947],
            [-11.325229088243274, 3.419286270268504],
            [-11.320418022700775, 3.424927908229622],
            [-11.320544806484243, 3.4325307532043867],
            [-11.321697514486624, 3.4373586148980624],
            [-11.327082486007123, 3.441467035136658],
            [-11.32614044676384, 3.4435395516290948],
            [-11.325529539149368, 3.4528357975621797],
            [-11.322333217874009, 3.4584439660723807],
            [-11.32390339853741, 3.4609478611274374],
            [-11.332724522579428, 3.4667775824701987],
            [-11.333031722110341, 3.4711112718011234],
            [-11.335990414453013, 3.4764860926021783],
            [-11.330907698404001, 3.48219145787517],
            [-11.328374144156149, 3.486757326323168],
            [-11.330285096198034, 3.493925031612434],
            [-11.319931001872733, 3.4984183474000825],
            [-11.317788079371507, 3.501845839200107],
            [-11.303836167587662, 3.5013365221489665],
            [-11.29502145975986, 3.5054067081988705],
            [-11.286659229544188, 3.5039225262601223],
            [-11.278274918171626, 3.5106235080261374],
            [-11.276401573204609, 3.513556158670622],
            [-11.271641025970835, 3.5141044737363596],
            [-11.267169033648123, 3.5120405816651563],
            [-11.26385916466547, 3.5142636791409503],
            [-11.25624201227694, 3.511010050013316],
            [-11.252736176828922, 3.5119061810750876],
            [-11.244943395200218, 3.500619941847216],
            [-11.238726108489578, 3.506117956229974],
            [-11.23464350116166, 3.5052068044081537],
            [-11.232709159741614, 3.502748707373744],
            [-11.233812963737478, 3.494072567272951],
            [-11.228051025318196, 3.4905872654470502],
            [-11.225443260468154, 3.4867908258706817],
            [-11.218168942522693, 3.47902252450166],
            [-11.21539481342668, 3.4731370227198597],
            [-11.212984473895505, 3.4727784011425156],
            [-11.208032758532939, 3.468791359603312],
            [-11.200916887808573, 3.466856351460769],
            [-11.192924396734826, 3.463637886776856],
            [-11.183611655963768, 3.4646223459685577],
            [-11.178396617016354, 3.468345755453702],
            [-11.172836685425828, 3.4655162531781376],
            [-11.169118349475813, 3.468572595909046],
            [-11.16375092274927, 3.4701916640719226],
            [-11.157196130915533, 3.4764166211017984],
            [-11.151944283445282, 3.475099526613901],
            [-11.145683491233914, 3.4755599100274392],
            [-11.143105518090199, 3.481066395523593],
            [-11.134299458778408, 3.4837622969595765],
            [-11.128062143790345, 3.4979960491161615],
            [-11.129052312618395, 3.5028504393245687],
            [-11.118263776127915, 3.5105567635458343],
            [-11.112328398581312, 3.51183810157244],
            [-11.109237727374966, 3.5086627311918757],
            [-11.103182873869079, 3.5087318806937393],
            [-11.100041339155512, 3.507545430459322],
            [-11.090977284343092, 3.507410814600165],
            [-11.087321577877425, 3.50450135780731],
            [-11.074754876350559, 3.5010596520827915],
            [-11.070337851427077, 3.4965706435966246],
            [-11.068186723124237, 3.4921161513088785],
            [-11.06539598676875, 3.4931826589048507],
            [-11.05773971065374, 3.4906215270187495],
            [-11.053060732457512, 3.4918472371268012],
            [-11.047184250501763, 3.4867805786165733],
            [-11.046307787746995, 3.4904147778529233],
            [-11.041393060794041, 3.495983189126448],
            [-11.042989536077952, 3.5004525829734776],
            [-11.029745725462359, 3.5025784419474633],
            [-11.02934137565455, 3.507900027606759],
            [-11.02440233740993, 3.508082314949144],
            [-11.023286743607132, 3.5122716533989133],
            [-11.017979965195181, 3.5138102952157135],
            [-11.01875678711516, 3.518391266255259],
            [-11.015036688112275, 3.521915204298184],
            [-11.011756816042029, 3.522745218389504],
            [-11.01082192760647, 3.5281100718068656],
            [-11.000513608270186, 3.5312868091745018],
            [-11.000930646505715, 3.5349336426392144],
            [-10.99850978720524, 3.54056086574207],
            [-10.99494525183955, 3.542128856812311],
            [-10.99648768725378, 3.545210333208851],
            [-10.993339603250602, 3.5471370375178717],
            [-10.995331112485006, 3.551019848461628],
            [-10.995167295840673, 3.5591948144055556],
            [-10.997638868822479, 3.563966722274277],
            [-10.997527175270584, 3.569182406972878],
            [-10.993662198106732, 3.5711250427278665],
            [-10.991849479760617, 3.5748522053533085],
            [-10.987673968551311, 3.5752681209938575],
            [-10.98556681478307, 3.583071735056516],
            [-10.985496230079747, 3.5898738908896886],
            [-10.982131823387542, 3.5937325630058656],
            [-10.978559851199647, 3.592368770334522],
            [-10.97384915776307, 3.596956687383925],
            [-10.972234861339313, 3.606470466858269],
            [-10.969011509413525, 3.6110047845069206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -111.5730635718891, "lat": 41.08937968056251 },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49029"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01448028"
      },
      "bbox": [
        -11.335990414453013, 3.049959922484573, -10.846447926532191,
        3.619973072005174
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.981226530523154, 0.2598085191502242],
            [13.983610152077688, 0.26654358935996636],
            [13.988382850680043, 0.27116739789356575],
            [13.99178026715362, 0.27708084739546507],
            [14.00152090484405, 0.2874222058441422],
            [14.01475758654707, 0.28978306622544775],
            [14.025978511723068, 0.2896160069813969],
            [14.042685725019972, 0.3013183643877171],
            [14.051259453916874, 0.3045268898039263],
            [14.058501022719168, 0.3041303272306956],
            [14.067743240668358, 0.3016526668389362],
            [14.079470895020176, 0.3030918234122392],
            [14.087133280064537, 0.3087297536128709],
            [14.088882092951065, 0.3119058867492371],
            [14.088322467942659, 0.3200950831235671],
            [14.083582036149298, 0.3317641996012512],
            [14.082598269951136, 0.3363152140845612],
            [14.08335473312699, 0.3413310786909813],
            [14.086899302726902, 0.345009281354044],
            [14.090903934523933, 0.3444921112637214],
            [14.093195441158201, 0.3419095379568261],
            [14.097584803790024, 0.33333197654592767],
            [14.108953120665495, 0.3172087499183161],
            [14.114628971068731, 0.31242385878629636],
            [14.125169173384968, 0.30895538056548816],
            [14.128714028419369, 0.30626241564284645],
            [14.136698905144675, 0.30500334248638294],
            [14.14072141720942, 0.30228607886844355],
            [14.15057327631103, 0.2988799863665707],
            [14.161508758258881, 0.29856577855193195],
            [14.164586642582586, 0.29598708327186174],
            [14.175196173955026, 0.29789041871442296],
            [14.18139270131061, 0.29753041909857175],
            [14.185954216507369, 0.29891290545531113],
            [14.197107238286165, 0.29806205505227457],
            [14.208991877624202, 0.29039425435721505],
            [14.223940626720152, 0.28702256202714166],
            [14.23347776495192, 0.28717263597058035],
            [14.243830625581834, 0.2851141500585322],
            [14.249800527834015, 0.2868551953966915],
            [14.258316772443845, 0.28600323482807877],
            [14.2633991575449, 0.2840760247143021],
            [14.27992592111988, 0.27521946365303934],
            [14.286310339510482, 0.27421866077397017],
            [14.300367251155619, 0.2756941921804792],
            [14.303530320512513, 0.21982164415465186],
            [14.288295518277987, 0.17544572471842199],
            [14.273154333205364, 0.1329423876836334],
            [14.256281920169357, 0.0840523944893999],
            [14.24874469206506, 0.06343995487707434],
            [14.238430608324968, 0.03221593223072011],
            [14.23605932539011, 0.025769041446162738],
            [14.208082402946966, -0.056807836447604364],
            [14.191806115194707, -0.10514834119299184],
            [14.188245997400765, -0.10388663208523521],
            [14.18596688689495, -0.1118965650975562],
            [14.181971065068405, -0.11260271567477813],
            [14.17658417820993, -0.10827393568760717],
            [14.175836596818494, -0.1167425195591136],
            [14.174258728504045, -0.11875910153601132],
            [14.167401336652947, -0.11594243134769364],
            [14.161386015900042, -0.11804962980403697],
            [14.15726093970104, -0.12100110441754046],
            [14.148067395693246, -0.11400280826395778],
            [14.145802990272689, -0.11028890157658125],
            [14.134564612118137, -0.10473060139829345],
            [14.126313939372585, -0.11038184281014546],
            [14.123904341238868, -0.10385675435268667],
            [14.113202344140495, -0.0962088577540338],
            [14.108786125318856, -0.0937900877409248],
            [14.10322343214659, -0.09450654880792904],
            [14.096417350863101, -0.08418401371434792],
            [14.090317407712064, -0.08489858616838943],
            [14.086510625823093, -0.08309497321953264],
            [14.088765560786387, -0.07480861496059066],
            [14.092674491531389, -0.07034292672615557],
            [14.085494853958789, -0.06853597377136059],
            [14.080959035833478, -0.06588039204292018],
            [14.071643117131844, -0.072272557057649],
            [14.065290699259373, -0.07280811475576618],
            [14.065833397537999, -0.07839373903249194],
            [14.061722679065225, -0.07888595980790787],
            [14.055829601975313, -0.08462309578042485],
            [14.055024246005813, -0.0798932235119708],
            [14.048587064347332, -0.0772945348737866],
            [14.049431449146798, -0.07118575863422232],
            [14.044667009974518, -0.06653726595769462],
            [14.047399704097193, -0.0571243043779744],
            [14.045902183568375, -0.053898316601970364],
            [14.038200001014209, -0.052682962911839624],
            [14.032379741906112, -0.054511191489006336],
            [14.025722461957658, -0.04987851580721674],
            [14.021957638342043, -0.05180108879583876],
            [14.006547906918858, -0.04776010420654317],
            [13.99376241047442, -0.03484978898612777],
            [13.992585274580225, -0.0295065887369855],
            [13.984698989629823, -0.0234576340009604],
            [13.874323145513669, 0.054809210095589846],
            [13.873490868371674, 0.061539971015914734],
            [13.879908860098888, 0.06661163602925167],
            [13.880934294701284, 0.07102434734312137],
            [13.878192528438623, 0.07461696594565598],
            [13.872246364872696, 0.07752652637082943],
            [13.86523090298634, 0.0823013824879559],
            [13.861980849269202, 0.08781864828289877],
            [13.86155934372652, 0.09148534829599238],
            [13.863670770086683, 0.09607966449336512],
            [13.871307347076108, 0.10055350962883079],
            [13.87635057393053, 0.10568429389785858],
            [13.875650371674226, 0.11212619381490094],
            [13.865918159523721, 0.12017525869528511],
            [13.863074528895394, 0.1237894815815754],
            [13.861908402999354, 0.13148068200227359],
            [13.863015746363054, 0.13414670089883415],
            [13.8700220902664, 0.13943093950576693],
            [13.873114856649593, 0.14396212437051065],
            [13.87715018652531, 0.1470994128817296],
            [13.886705739396385, 0.14894694153520924],
            [13.891335385853532, 0.1463987547501141],
            [13.899023889363066, 0.1478217454064747],
            [13.905670358632188, 0.14677945018782365],
            [13.918471627828719, 0.14697173770001393],
            [13.926174738847726, 0.14540847838870663],
            [13.932620089002809, 0.1489537645575972],
            [13.93831016900174, 0.15010310932101129],
            [13.943451087913708, 0.15382248504023918],
            [13.945032728650151, 0.15863205697546487],
            [13.943583639475642, 0.16349825602734142],
            [13.940846151678304, 0.1666921444039515],
            [13.936429792630584, 0.17809523379085818],
            [13.938224029591627, 0.1843802334217783],
            [13.941071507765727, 0.19014035296610884],
            [13.94423809971082, 0.1923657199657656],
            [13.953772651122499, 0.1951474417018816],
            [13.957062084268754, 0.19893627183688584],
            [13.955309812679594, 0.20456895812997014],
            [13.950120681664448, 0.2089527146163418],
            [13.948759742650267, 0.21547892523287954],
            [13.951040181657314, 0.21867115551324504],
            [13.958553147184471, 0.21984869199317625],
            [13.962387933181349, 0.21849968969868258],
            [13.96894229407109, 0.21364659591233992],
            [13.975173605378556, 0.2043671612184526],
            [13.978691990521309, 0.2025281335776443],
            [13.985118622380355, 0.20399851078037223],
            [13.991707342025629, 0.21027444099731749],
            [13.992257012390516, 0.2136024510515257],
            [13.987910506486639, 0.22095219590631396],
            [13.979340052789773, 0.22594201354823001],
            [13.977311730861015, 0.22916171572486507],
            [13.977836392724363, 0.2341022556822306],
            [13.976553190401235, 0.23887961683692027],
            [13.977680050740863, 0.24442730470908103],
            [13.981045124369661, 0.24864464136712527],
            [13.981226530523154, 0.2598085191502242]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.52876223488344, "lat": 37.5721687113156 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51029"],
        "coty_name": ["Buckingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Buckingham County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01501502"
      },
      "bbox": [
        13.86155934372652, -0.12100110441754046, 14.303530320512513,
        0.345009281354044
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.606945993516256, 11.44669033957677],
            [-17.60840164397809, 11.443335899173666],
            [-17.613349903301764, 11.440057851426674],
            [-17.62526038656227, 11.42962693826284],
            [-17.627941378798145, 11.429092966761312],
            [-17.631255395279716, 11.423048973408525],
            [-17.64080328433877, 11.413582703643863],
            [-17.645728758821804, 11.410600795135423],
            [-17.64706705252131, 11.407241658815984],
            [-17.653364586812692, 11.405303286916558],
            [-17.651433027770008, 11.400438944047997],
            [-17.65743708802726, 11.393486377822896],
            [-17.663855202220358, 11.39382219847566],
            [-17.6674578220391, 11.389644515550481],
            [-17.672032188101596, 11.38672264284396],
            [-17.67215903237415, 11.381221311830574],
            [-17.67648950145814, 11.37855411787899],
            [-17.682502600402863, 11.369688590714821],
            [-17.68120037837373, 11.366912681072424],
            [-17.685697153900872, 11.361805338768276],
            [-17.693559393355418, 11.358031153617858],
            [-17.70131641535229, 11.35292178183421],
            [-17.702841458640727, 11.347815898029213],
            [-17.706736038651623, 11.348270293289898],
            [-17.712524461600214, 11.344725796714993],
            [-17.72479413616552, 11.335063544842734],
            [-17.73255576658092, 11.33276208768391],
            [-17.74093899860466, 11.317595726464505],
            [-17.744432719528877, 11.316267865410284],
            [-17.745569992068972, 11.311254973312675],
            [-17.75549993475473, 11.301181397203441],
            [-17.757385203742107, 11.297345049656213],
            [-17.767740543257624, 11.286723964980702],
            [-17.774910970952813, 11.272093593869307],
            [-17.77985698565889, 11.265616294813519],
            [-17.779631136076308, 11.261298926722572],
            [-17.78756783404621, 11.25936221263701],
            [-17.788933104101773, 11.256110603073243],
            [-17.788756232180848, 11.249609838771306],
            [-17.793373580615143, 11.24407959224125],
            [-17.79167207430567, 11.239295530714745],
            [-17.78669768515974, 11.233840084518452],
            [-17.784362799770275, 11.228683727412076],
            [-17.778492992340446, 11.226882964802702],
            [-17.77697834847187, 11.222861483303582],
            [-17.77416316358095, 11.221688456970643],
            [-17.768058518121833, 11.224902540678643],
            [-17.76422424121262, 11.2234967445107],
            [-17.75743478159904, 11.23607650235489],
            [-17.74256643282432, 11.230739956032917],
            [-17.74219610547188, 11.227428838592195],
            [-17.738578616389624, 11.22679712237732],
            [-17.73640153643195, 11.22288381451755],
            [-17.721211234304768, 11.218359782750959],
            [-17.709768917433085, 11.216549939887935],
            [-17.70229642028536, 11.217843658874914],
            [-17.690075434106582, 11.224318767424883],
            [-17.679286376452765, 11.228260263523056],
            [-17.676013562267585, 11.23075648012651],
            [-17.672860429825555, 11.230017478346257],
            [-17.66247943683637, 11.231461276799338],
            [-17.65546176928722, 11.23010835031943],
            [-17.647392819658688, 11.231723824074079],
            [-17.64090908179539, 11.229707554087573],
            [-17.631482708743132, 11.233061307615506],
            [-17.626485551633547, 11.232288445582038],
            [-17.62142451136875, 11.2300264081679],
            [-17.60276714970007, 11.243489606162623],
            [-17.596635790981853, 11.24484403963921],
            [-17.59343824691183, 11.244259528562639],
            [-17.583679580451516, 11.252743789585136],
            [-17.58638586304786, 11.254984673214421],
            [-17.590050042035962, 11.254558967953658],
            [-17.59666142682807, 11.258402708570667],
            [-17.60145973847677, 11.256995535383037],
            [-17.60572055610832, 11.258537670159502],
            [-17.60745947739369, 11.253809560981054],
            [-17.613323544502922, 11.252386178428615],
            [-17.61800757562944, 11.25404275747943],
            [-17.629626056085105, 11.251808381156806],
            [-17.636961610333927, 11.24867673010823],
            [-17.651885722475104, 11.24951233337931],
            [-17.65473586822199, 11.246732552170059],
            [-17.66266167744465, 11.248980428679866],
            [-17.667130379935987, 11.247010390786341],
            [-17.66971727901779, 11.242848499118278],
            [-17.674893114940573, 11.24302295681296],
            [-17.684050718993536, 11.241721794540458],
            [-17.69085605307872, 11.239258068260613],
            [-17.70300832377157, 11.225080868044056],
            [-17.707101781233497, 11.223801025262185],
            [-17.715385442027344, 11.226013158789549],
            [-17.72011995074486, 11.23276927141464],
            [-17.722280776100607, 11.237969218228846],
            [-17.73230128015054, 11.245097845154485],
            [-17.73933212657623, 11.249237822379357],
            [-17.743694029368317, 11.247062361147071],
            [-17.745750829149014, 11.24977995505881],
            [-17.753213434834684, 11.250780359120721],
            [-17.75745384090684, 11.254408840122986],
            [-17.75534263547199, 11.261829944188705],
            [-17.758571425142893, 11.265701970820283],
            [-17.75726577605115, 11.271379298836553],
            [-17.75512711873524, 11.271576786853334],
            [-17.7502002455784, 11.275827262703078],
            [-17.737807373567023, 11.290675916273766],
            [-17.73774922543318, 11.292294467024911],
            [-17.726915397517597, 11.304864058366263],
            [-17.72140509346612, 11.309380189767108],
            [-17.71662739609468, 11.315059260514209],
            [-17.713376068878404, 11.315928915028127],
            [-17.71083773693497, 11.31918141441914],
            [-17.70472882173952, 11.32101791130905],
            [-17.704807258322266, 11.324141246330674],
            [-17.69507035327169, 11.33402944065683],
            [-17.683477802341695, 11.340856553460338],
            [-17.672157548564567, 11.351142439425631],
            [-17.668212972735837, 11.358160874930068],
            [-17.665912755262877, 11.36687513362677],
            [-17.658271161339822, 11.373751301822098],
            [-17.638641548030503, 11.368106591081874],
            [-17.624170031487825, 11.365147979312049],
            [-17.602812348774385, 11.360125359749668],
            [-17.554281025863638, 11.345039909491668],
            [-17.539540453051693, 11.340944649694704],
            [-17.51289412425668, 11.332378563119619],
            [-17.521263700258615, 11.304762282255345],
            [-17.522884532863852, 11.298389330871299],
            [-17.53352260315547, 11.261625310231393],
            [-17.537315796274118, 11.250268703342421],
            [-17.545322473681388, 11.223053519771437],
            [-17.55766712984148, 11.180911084122776],
            [-17.56175890366706, 11.182156286455378],
            [-17.560097669752157, 11.1862551948775],
            [-17.5625429324295, 11.19135286422026],
            [-17.562823400744563, 11.201779509734372],
            [-17.55908947897589, 11.206833607036721],
            [-17.556139895650045, 11.213823123024483],
            [-17.55574644929243, 11.221139032150054],
            [-17.55644208257959, 11.22716249381497],
            [-17.56323252663973, 11.226923485992085],
            [-17.56169081620591, 11.220772783428544],
            [-17.5661037784627, 11.211628389936529],
            [-17.573587129175674, 11.203469639424545],
            [-17.571350661111595, 11.20066053980489],
            [-17.570095620208015, 11.19573045658939],
            [-17.57180297072594, 11.18975536895423],
            [-17.574791285132715, 11.184741492509692],
            [-17.574355973158205, 11.173661834493915],
            [-17.5783493227135, 11.166887881411444],
            [-17.5828354674117, 11.16380742701689],
            [-17.582971103768415, 11.161065294918084],
            [-17.578451546345907, 11.155533238800182],
            [-17.582661351323576, 11.149019953726173],
            [-17.589902926529934, 11.145036946028876],
            [-17.590816681247173, 11.148393977633262],
            [-17.587829286390797, 11.150339038838604],
            [-17.586972348015053, 11.1536003242659],
            [-17.59145033120978, 11.15464219752867],
            [-17.597686897141134, 11.146106857814747],
            [-17.601358743144402, 11.144533653559032],
            [-17.60614023838747, 11.144913133554919],
            [-17.60511109818913, 11.131848554551285],
            [-17.61103093007706, 11.130095738561337],
            [-17.61595775324678, 11.123145974286798],
            [-17.623461227476813, 11.120041462269965],
            [-17.626424964491626, 11.117445786322142],
            [-17.626675524180268, 11.113748455802511],
            [-17.622783429105173, 11.111491957575286],
            [-17.631470021580267, 11.092986472672763],
            [-17.62893633546799, 11.090133200822095],
            [-17.632489988144982, 11.080978903731328],
            [-17.628144266841087, 11.0755978588231],
            [-17.62996899106969, 11.068942194184835],
            [-17.629041711306495, 11.062936290293493],
            [-17.62637342963547, 11.05938709344465],
            [-17.626757461380034, 11.055229446345878],
            [-17.62392102331338, 11.04847528557217],
            [-17.62851579939104, 11.040138082890635],
            [-17.631414695882782, 11.038336957467157],
            [-17.638808186425162, 11.026485882131391],
            [-17.64617515947527, 11.01873004598538],
            [-17.650481364807465, 11.016179078270111],
            [-17.64806669507692, 11.012798900953992],
            [-17.653106486820317, 11.01174670606623],
            [-17.658511577008404, 11.008972248022525],
            [-17.664878453802068, 11.007925551393978],
            [-17.6805710293695, 11.01159048794798],
            [-17.68124676952508, 11.023276147706833],
            [-17.68058305391235, 11.030329037954582],
            [-17.686814899512385, 11.03564793441665],
            [-17.691785197036726, 11.037598003116582],
            [-17.69478344432347, 11.041965326069178],
            [-17.69355885261624, 11.04866018609631],
            [-17.70131313050868, 11.04610199522579],
            [-17.7037869767875, 11.038962778012037],
            [-17.709424603792026, 11.032620294791903],
            [-17.71651717160792, 11.028886822215137],
            [-17.722510221992305, 11.02764017911596],
            [-17.733311717043083, 11.028018129130407],
            [-17.741607231777103, 11.026381670361978],
            [-17.74721714648765, 11.024318044242433],
            [-17.754705113156053, 11.018350443624776],
            [-17.762141460118002, 11.003075740856676],
            [-17.764619799336163, 10.999679870382407],
            [-17.76890143476804, 10.996749297065344],
            [-17.773414089984794, 10.995712676958577],
            [-17.778123702323466, 10.99628874247887],
            [-17.78708819207554, 10.999843216834792],
            [-17.795786480230035, 11.000326598430823],
            [-17.806542773237304, 10.995496678034023],
            [-17.807754464276588, 10.994020113814619],
            [-17.813443194833955, 10.975642549825972],
            [-17.827099761269366, 10.980156419753104],
            [-17.882569398951087, 10.995267802540027],
            [-17.896662327402876, 10.999901327134596],
            [-17.91068844462599, 11.004107547993105],
            [-17.924698782947324, 11.007755498793852],
            [-17.93494367720956, 11.010960035568493],
            [-17.980535440540482, 11.022923451559844],
            [-18.00687013986878, 11.029180283840642],
            [-18.02003004090772, 11.033017791202553],
            [-18.03349123850387, 11.037785402950549],
            [-18.047509148650448, 11.041442824680301],
            [-18.060849221345933, 11.045427488517051],
            [-18.076005438683612, 11.049127043636023],
            [-18.085694658411942, 11.052350309000879],
            [-18.083907935771133, 11.060103290036002],
            [-18.06692457234314, 11.116683764984858],
            [-18.06449411782664, 11.127603900961649],
            [-18.06183385379353, 11.133612734748807],
            [-18.05753022437156, 11.147191171757477],
            [-18.045673136163543, 11.188595265039917],
            [-18.037101442216915, 11.21694876623629],
            [-18.04630725592253, 11.219969527824366],
            [-18.026385354719544, 11.286213964432202],
            [-18.022066697793203, 11.299921911381483],
            [-17.973370404918313, 11.462236595307141],
            [-17.948734994737684, 11.543309819543932],
            [-17.864850294946187, 11.518896869658386],
            [-17.864203310058734, 11.521036522646883],
            [-17.85793095833911, 11.519747746299053],
            [-17.797483233733672, 11.50219606505629],
            [-17.737039180637336, 11.484631222677288],
            [-17.676598820756382, 11.46705322480191],
            [-17.61616217579232, 11.449462077083895],
            [-17.606945993516256, 11.44669033957677]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.19299816373653,
          "lat": 47.34833967948533
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53045"],
        "coty_name": ["Mason"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mason County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "01529221"
      },
      "bbox": [
        -18.085694658411942, 10.975642549825972, -17.51289412425668,
        11.543309819543932
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-18.56870706478832, 10.900552655233147],
            [-18.55767863660119, 10.897433353360883],
            [-18.51634163360356, 10.883604512181284],
            [-18.502557126423042, 10.879987556546533],
            [-18.436768339358757, 10.859634494387928],
            [-18.42979125441014, 10.857970579430093],
            [-18.423762590372462, 10.855123372215699],
            [-18.410359439539757, 10.850860133648615],
            [-18.371822798240814, 10.840480726122264],
            [-18.333058053424306, 10.829210815832015],
            [-18.30355983809721, 10.82115697519013],
            [-18.275808672836952, 10.81281543190649],
            [-18.262032023165553, 10.809112132582671],
            [-18.24828633013341, 10.804673553176505],
            [-18.233123287880062, 10.800750535685308],
            [-18.196195469441523, 10.79027603417987],
            [-18.16401264382983, 10.779688770183508],
            [-18.09044055557299, 10.75746731787648],
            [-18.107851090903793, 10.703897928144515],
            [-18.106350091479012, 10.703495744566602],
            [-18.11666428882578, 10.663098271257788],
            [-18.132935985818495, 10.601901511305526],
            [-18.135469670896676, 10.59487320324346],
            [-18.14319513379181, 10.56734058883995],
            [-18.147736172501954, 10.55456795939255],
            [-18.15138072305512, 10.541139654477755],
            [-18.147821359010127, 10.539785581267877],
            [-18.153080838755066, 10.519616641788165],
            [-18.167222127046454, 10.472808596176877],
            [-18.168638184127676, 10.46621339216968],
            [-18.181308667532736, 10.425433468338452],
            [-18.185054961615936, 10.41228478828474],
            [-18.197606539804863, 10.371618801703871],
            [-18.285538943321612, 10.39684004940642],
            [-18.30673195300675, 10.403418648039816],
            [-18.395682638129433, 10.430076925873736],
            [-18.44141516679306, 10.443988928376564],
            [-18.462093154982647, 10.378164236423512],
            [-18.469612049496703, 10.354803756628364],
            [-18.478452651518662, 10.358019424358126],
            [-18.48376208497096, 10.36139361242269],
            [-18.489082863225377, 10.351857769246024],
            [-18.493629612406494, 10.351143457171972],
            [-18.494813202136932, 10.347278100506754],
            [-18.499990359337964, 10.347196368602395],
            [-18.505228295250404, 10.349873762158467],
            [-18.50865190884836, 10.35665557049534],
            [-18.51598056260586, 10.363206239037549],
            [-18.5232623746415, 10.364427541924206],
            [-18.527906299221158, 10.36248980502036],
            [-18.533716848362527, 10.354770174924933],
            [-18.535634185493983, 10.35385418742032],
            [-18.54245732452571, 10.355853670589376],
            [-18.545941783379927, 10.355671285189434],
            [-18.551169404254683, 10.35071212660041],
            [-18.55830826878228, 10.351163426107101],
            [-18.560615954565584, 10.347955443372527],
            [-18.568534318906035, 10.342780363676294],
            [-18.57283054131921, 10.34362342486663],
            [-18.578379876711193, 10.337725833694963],
            [-18.5819119373163, 10.336923191178869],
            [-18.602678185755078, 10.34894595278446],
            [-18.607840231730034, 10.356353741900712],
            [-18.610006192843006, 10.357576703795722],
            [-18.61043557303607, 10.363607146937357],
            [-18.61745823970709, 10.37556487733781],
            [-18.621388520325993, 10.380852627179863],
            [-18.624368057613392, 10.391847859554359],
            [-18.62388812623383, 10.396756920038124],
            [-18.629273503231225, 10.403939985075358],
            [-18.627586820072402, 10.411592748047758],
            [-18.62926576155558, 10.415898205618447],
            [-18.634622908605362, 10.423622898268853],
            [-18.644041366790656, 10.430760641076],
            [-18.656101200492056, 10.436900687969251],
            [-18.66446342235971, 10.431785014838391],
            [-18.66790377346204, 10.427696995182252],
            [-18.676393088769995, 10.42678436168378],
            [-18.680953775754002, 10.423880566230014],
            [-18.683727874053428, 10.42030624181372],
            [-18.678775094871195, 10.41637338576291],
            [-18.678719706105685, 10.412951901778843],
            [-18.68184265569201, 10.403894819525922],
            [-18.68884113231815, 10.405423074101462],
            [-18.693603642220108, 10.410190142383156],
            [-18.705118287446062, 10.406189672958039],
            [-18.7057199680522, 10.410920014848866],
            [-18.69859232012899, 10.429874696365335],
            [-18.700109381138425, 10.433498905307514],
            [-18.692745115461527, 10.437361287667313],
            [-18.68205555898262, 10.45610316923025],
            [-18.660603212092166, 10.510793331251488],
            [-18.653371194923967, 10.532011659289108],
            [-18.628729655069613, 10.610734145629575],
            [-18.613759886175423, 10.670602177677921],
            [-18.60490555404011, 10.714263449136286],
            [-18.597186338177494, 10.74189914157291],
            [-18.590655160226788, 10.750800544177196],
            [-18.585208517530525, 10.753266541428196],
            [-18.580567971872057, 10.75212899769747],
            [-18.581191380685077, 10.748760166104354],
            [-18.579747089862074, 10.744531196932257],
            [-18.573054770460512, 10.740114875966817],
            [-18.573637194232262, 10.735376657190589],
            [-18.581271997123892, 10.733815342710622],
            [-18.5833540698445, 10.731242999157265],
            [-18.58714137094366, 10.731921798993815],
            [-18.58891775738046, 10.728553005074662],
            [-18.585326202366986, 10.713373261966042],
            [-18.585870502918052, 10.705712681743982],
            [-18.582866789525596, 10.701355166031504],
            [-18.58077874310373, 10.687773903893191],
            [-18.585846047697395, 10.67040282180506],
            [-18.597163460116843, 10.640480185133589],
            [-18.601262186981362, 10.621759339413183],
            [-18.604452630294773, 10.620313270324647],
            [-18.61114406486935, 10.60859124634746],
            [-18.61705284078222, 10.576146060049005],
            [-18.624688614653437, 10.53068507951788],
            [-18.6343541726413, 10.494933792178182],
            [-18.631095805790157, 10.486566221979517],
            [-18.62236001620184, 10.486481015099098],
            [-18.61421789075731, 10.488925960073757],
            [-18.608427315683205, 10.488207984640576],
            [-18.60094254995004, 10.482953072878155],
            [-18.593560247094953, 10.482937708385931],
            [-18.588873502822175, 10.493134688962732],
            [-18.585586807355522, 10.504921062761492],
            [-18.581943899114712, 10.511728668916],
            [-18.592640424785454, 10.513235429606567],
            [-18.591234651886666, 10.528934075349365],
            [-18.585532214538368, 10.536297669438424],
            [-18.586970093449537, 10.542767236231786],
            [-18.597366950926002, 10.551906314459174],
            [-18.59847646067065, 10.556096202591219],
            [-18.593011459182396, 10.571800002468464],
            [-18.594294053901987, 10.575388561163237],
            [-18.58758569651547, 10.593615903704967],
            [-18.58232000142131, 10.600639528064642],
            [-18.578772105419592, 10.601152888128805],
            [-18.57604643350387, 10.599148484729756],
            [-18.578301318726286, 10.592212390179897],
            [-18.574636635825758, 10.587221477554593],
            [-18.576978272390953, 10.576886796764779],
            [-18.569504512626224, 10.568258271530594],
            [-18.561212207387545, 10.561765411255706],
            [-18.558602239388033, 10.56300114641274],
            [-18.558495710380754, 10.573253931767162],
            [-18.554703028639604, 10.583016258384568],
            [-18.54613943600919, 10.585991634275747],
            [-18.537864443230635, 10.591947144804832],
            [-18.534823491645675, 10.597477975640162],
            [-18.53172052625953, 10.600356876980129],
            [-18.527039613196155, 10.601751078553141],
            [-18.52572856508132, 10.594704528782842],
            [-18.519900988741078, 10.595899830593313],
            [-18.516043660624863, 10.598388222060937],
            [-18.511754178330612, 10.618414971744938],
            [-18.50719379022211, 10.621901960992547],
            [-18.507933548176364, 10.62515252838619],
            [-18.506032053377794, 10.632451644763492],
            [-18.51303881386882, 10.637657281495574],
            [-18.516142478452416, 10.648126148306497],
            [-18.517704208602233, 10.65631162100538],
            [-18.5155638345079, 10.662716555667762],
            [-18.51646132148884, 10.675077889752433],
            [-18.521091983050766, 10.684080195994925],
            [-18.528149725182683, 10.69520814683072],
            [-18.529325201368625, 10.704187559012077],
            [-18.5250065817469, 10.717584394979228],
            [-18.523708880249316, 10.725827459065622],
            [-18.518514782548635, 10.724244645066749],
            [-18.518580794761686, 10.719588581904661],
            [-18.51555914302105, 10.713846931208664],
            [-18.51022964306492, 10.71226158077041],
            [-18.508642925381626, 10.717968257787163],
            [-18.509204956073713, 10.72611338405916],
            [-18.502811804644637, 10.729457040403117],
            [-18.494159760542026, 10.731255898485243],
            [-18.492546129397248, 10.734166277374753],
            [-18.488175643587745, 10.747766484409484],
            [-18.488576409718693, 10.752555781723034],
            [-18.48180528014988, 10.756619762930752],
            [-18.474195813525267, 10.754800932242933],
            [-18.467179258018316, 10.757412380029823],
            [-18.442623379494734, 10.765477464800112],
            [-18.432581777935127, 10.766462242445028],
            [-18.425144944749878, 10.7631878852956],
            [-18.42051732211924, 10.762792326842618],
            [-18.417295599206238, 10.764194644487294],
            [-18.414979817800607, 10.772284427649307],
            [-18.416262076352766, 10.777740874502134],
            [-18.42516553997591, 10.780623078851649],
            [-18.428326366866187, 10.78850437193866],
            [-18.43244135987688, 10.792172715485702],
            [-18.43796106033191, 10.7944005067471],
            [-18.441174532550512, 10.797735708451855],
            [-18.4437446685619, 10.813818040826309],
            [-18.443446161968783, 10.818574773427592],
            [-18.45000281844266, 10.820339083263098],
            [-18.458958776874933, 10.81943096931807],
            [-18.466559676588574, 10.813626988423117],
            [-18.46701951115401, 10.8094849873439],
            [-18.46499771933447, 10.804797827357538],
            [-18.466576487273286, 10.801210928651807],
            [-18.477230073009668, 10.802943340633588],
            [-18.490117503570808, 10.806868620911699],
            [-18.500106215462043, 10.820819779514446],
            [-18.50512410406269, 10.819537542971105],
            [-18.51071725762308, 10.812272942857629],
            [-18.5108445310479, 10.801381889721833],
            [-18.50793663999395, 10.791529760088366],
            [-18.512929629623937, 10.791143720813185],
            [-18.52085607713666, 10.797753018074925],
            [-18.525160438369152, 10.799467125425958],
            [-18.528768001121456, 10.79852636498005],
            [-18.532052312557827, 10.803982056577205],
            [-18.531540973772128, 10.807475762354382],
            [-18.5369207106343, 10.814571017763267],
            [-18.545294164821303, 10.815499919969147],
            [-18.54968065707259, 10.821515757395689],
            [-18.559782265226918, 10.83145591070601],
            [-18.563054293687557, 10.837094033869661],
            [-18.574424598086196, 10.841861341699373],
            [-18.579869522401943, 10.850261260715234],
            [-18.581396041560343, 10.855400092221496],
            [-18.577347004193797, 10.865040342292584],
            [-18.57041002072754, 10.891150940584305],
            [-18.56870706478832, 10.900552655233147]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -123.70387143425002,
          "lat": 46.55561898542494
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53049"],
        "coty_name": ["Pacific"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pacific County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01513274"
      },
      "bbox": [
        -18.7057199680522, 10.336923191178869, -18.09044055557299,
        10.900552655233147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.282459937069829, 1.9998585873123231],
            [12.366593939844414, 2.013892875710069],
            [12.46811974777636, 2.030930056802647],
            [12.542071970722152, 2.0434193440654673],
            [12.662186184111713, 2.0633576993852127],
            [12.709738530141058, 2.071309054919308],
            [12.776667140409213, 2.082879555602098],
            [12.780770337647768, 2.0591143950214383],
            [12.771328458831507, 2.016974033691637],
            [12.774132126042842, 1.9831596061471484],
            [12.751031101570682, 1.9219078169985757],
            [12.724885412546717, 1.8529279520298052],
            [12.715190677479876, 1.8278642362318467],
            [12.726889838047638, 1.78241273184441],
            [12.690698053110168, 1.7935075217546423],
            [12.666988284394769, 1.8002282787053792],
            [12.664223330656599, 1.8034524608378075],
            [12.659890556810304, 1.8042596409474643],
            [12.65703693390805, 1.8101258149419743],
            [12.64743901429237, 1.8132436339123086],
            [12.64703027941853, 1.8165074726382562],
            [12.641303549645032, 1.8206524053154582],
            [12.630646723357474, 1.8187494597037137],
            [12.62968123710265, 1.822441684773496],
            [12.624265561161916, 1.8252128766168347],
            [12.624619619027772, 1.8324907524282092],
            [12.614015452815242, 1.8352602347176308],
            [12.609905072651529, 1.8338573212334504],
            [12.60577820692841, 1.8352158479332172],
            [12.599235040640725, 1.843539206693103],
            [12.604584064850854, 1.8440841406886976],
            [12.600116912787927, 1.8502417485048923],
            [12.55344356144373, 1.8829913843954955],
            [12.547017352352116, 1.886410674313113],
            [12.54685930460449, 1.8889418463222125],
            [12.54085204682062, 1.8901557727705536],
            [12.540213621536775, 1.895267016241855],
            [12.53466563577631, 1.8946312732389725],
            [12.530726553297187, 1.897347616437452],
            [12.528101896603522, 1.8959364614908973],
            [12.52297499189866, 1.9019846600286736],
            [12.519507321354055, 1.9046151156864175],
            [12.520246878660997, 1.91009229187915],
            [12.513223903658531, 1.9105876455518924],
            [12.508514653201386, 1.9203629763785857],
            [12.503235517807697, 1.919335697929392],
            [12.502352538684491, 1.9232464656626505],
            [12.468893903035404, 1.9180493581823925],
            [12.432456986642986, 1.9120766758271188],
            [12.370841501525483, 1.9027082485427451],
            [12.362557799648009, 1.9006929019749497],
            [12.359792394301474, 1.9019964573575683],
            [12.355985842248327, 1.9002381218571471],
            [12.344754407466572, 1.9077357267381794],
            [12.344179640969934, 1.9127269031988667],
            [12.341511418312749, 1.913409012763021],
            [12.337304578923964, 1.91934171011178],
            [12.332296422154, 1.9164219662412056],
            [12.325885564803938, 1.9179505307389877],
            [12.32421653205765, 1.916211675356602],
            [12.315521632323732, 1.9196010789268843],
            [12.318986851890456, 1.9271804834816402],
            [12.313672875769425, 1.9353530232986984],
            [12.308247552028645, 1.936958013372783],
            [12.309138293672733, 1.9420145869665506],
            [12.305253570830496, 1.9480332823440747],
            [12.308189598691557, 1.952109292863922],
            [12.305489981264243, 1.9563189142399355],
            [12.308824347865922, 1.9626235219690935],
            [12.303843712230359, 1.9716721737678113],
            [12.299289007221635, 1.9737526829637186],
            [12.296858856743777, 1.9809219611162925],
            [12.298887981975465, 1.9837985424615738],
            [12.298424263684726, 1.988266647645884],
            [12.294782706412459, 1.9937630089299772],
            [12.290751144636587, 1.9953434113204234],
            [12.289379978095857, 1.9912191145623728],
            [12.28515880249134, 1.9915793934731754],
            [12.282459937069829, 1.9998585873123231]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.04661647185938, "lat": 39.63033502786877 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54061"],
        "coty_name": ["Monongalia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monongalia County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01550037"
      },
      "bbox": [
        12.282459937069829, 1.78241273184441, 12.780770337647768,
        2.082879555602098
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.770264764171811, 0.14560454264761458],
            [11.771127431953015, 0.14205924090787328],
            [11.769598135075782, 0.137124325751017],
            [11.774812991466705, 0.13762209514901896],
            [11.777728041609498, 0.13459781654123462],
            [11.782017994786898, 0.13444246450769506],
            [11.784501251433023, 0.1306364875740841],
            [11.789037339161577, 0.1288846235659192],
            [11.7913523983215, 0.13281851835409483],
            [11.79379032611657, 0.13339954185686181],
            [11.798851125363054, 0.12978788446251513],
            [11.803341365168059, 0.13089085621570123],
            [11.805022914278585, 0.13687317872291768],
            [11.813154236233718, 0.13639423680656512],
            [11.818864862178067, 0.13268002515306423],
            [11.831547910473924, 0.136485650473798],
            [11.835983036279314, 0.1389811476733525],
            [11.83978995191861, 0.1391139076067942],
            [11.842141507547495, 0.14200702022943565],
            [11.845414139778939, 0.14089422874811558],
            [11.85110282823009, 0.144135153778158],
            [11.853803621074828, 0.14757350617817813],
            [11.86143895376612, 0.14149409057290557],
            [11.864897607204522, 0.1427247390254026],
            [11.868084483002528, 0.14037421288157997],
            [11.872299211261236, 0.14033088991276088],
            [11.872869642908652, 0.13440020944418035],
            [11.87492103607858, 0.13067239265854882],
            [11.879366035142564, 0.12675304522196884],
            [11.883844659819012, 0.1270916572688036],
            [11.890353185422583, 0.1256169486931894],
            [11.90070683651329, 0.1213011583536315],
            [11.90204916004238, 0.11646983778691887],
            [11.89843324182835, 0.11062212993318746],
            [11.903037302440268, 0.09172011886226629],
            [11.908284951904259, 0.08301722301983624],
            [11.906558206981133, 0.07867410104672469],
            [11.905318970747247, 0.07070017413711448],
            [11.910024846502889, 0.06719664604919245],
            [11.932017371376977, 0.06836408438189931],
            [11.991017185963017, 0.0729968052481372],
            [12.04764926347778, 0.0783285614149348],
            [12.083499052710415, 0.08065664603529092],
            [12.087061959927704, 0.07189242268682029],
            [12.086180002468359, 0.0654812708757965],
            [12.079349191228252, 0.06445406006118734],
            [12.064927214183136, 0.060870539918076366],
            [12.066002301136846, 0.05628239355466312],
            [12.073894508529925, 0.05235911133231318],
            [12.076489567892084, 0.052909669550472195],
            [12.08505225974638, 0.05804054087788444],
            [12.095709765989385, 0.06129609927471048],
            [12.102427668462783, 0.06574944964344338],
            [12.104492050201536, 0.06532126200698864],
            [12.106175820158994, 0.058553875247415454],
            [12.100059396865412, 0.049552737372348735],
            [12.100694015938595, 0.04471497726842561],
            [12.104388919522492, 0.04107296673037119],
            [12.116120752303706, 0.04275513555689498],
            [12.125853619049854, 0.03998670900020986],
            [12.134763006231326, 0.04148836452645422],
            [12.14629070099378, 0.04507037360129258],
            [12.153737041835015, 0.045925445783748645],
            [12.16386286844129, 0.04969722165105663],
            [12.17450999602924, 0.04957681803059791],
            [12.179281361191466, 0.04766505693238742],
            [12.187542922193147, 0.04148817715075433],
            [12.191454114309199, 0.03981501077938717],
            [12.195934242007803, 0.039104218737627164],
            [12.202260532800137, 0.03481502802599613],
            [12.207467162473263, 0.032760654106357534],
            [12.209583321671783, 0.029556638367334506],
            [12.210520243299852, 0.023798586743846148],
            [12.213845756925314, 0.01708910383204689],
            [12.231648944873216, 0.0072745360971313185],
            [12.23756325612911, 0.001635036799604795],
            [12.239060001936368, -0.0061104011326245595],
            [12.234781875792489, -0.01706085270879864],
            [12.226498714790944, -0.02063829009452735],
            [12.223132775079467, -0.023833944477572058],
            [12.220191669671175, -0.030628703025138152],
            [12.220547527334496, -0.034211428523366234],
            [12.225894604661917, -0.038282053852437624],
            [12.233328115637994, -0.04047917224647142],
            [12.241640754857526, -0.04401051777097077],
            [12.246307596336134, -0.04924337815391245],
            [12.248748551409754, -0.05432053215700505],
            [12.252849493353917, -0.07064523799560318],
            [12.261443582152374, -0.07600252955053616],
            [12.264805317798881, -0.08290658599794853],
            [12.263931917263118, -0.08814301306099123],
            [12.26208908024252, -0.09038082345711634],
            [12.254319791064512, -0.09537596713378138],
            [12.253836665650427, -0.10018649195317725],
            [12.248914006298826, -0.09707887007774672],
            [12.249437291889718, -0.09397397874121907],
            [12.24866611887664, -0.08311375992212006],
            [12.245033360972057, -0.0807289787339104],
            [12.240943838325252, -0.07553527828654914],
            [12.23338194739773, -0.07203249953253923],
            [12.224706169198225, -0.07235403666930534],
            [12.219299058006193, -0.066409919909459],
            [12.206494215234303, -0.06381033849523711],
            [12.195521056779716, -0.06911152523592685],
            [12.189533308830336, -0.06806751661483658],
            [12.183371025105062, -0.06844975062123036],
            [12.18215975537641, -0.0769521498125515],
            [12.184239159462646, -0.07986432462320339],
            [12.189293526297531, -0.08335543824748871],
            [12.188257006753748, -0.0868225731406335],
            [12.181099837340884, -0.08971995367718712],
            [12.178879180497312, -0.09441441590476742],
            [12.178769995726686, -0.09855675122146602],
            [12.167839027452455, -0.10661190952009553],
            [12.166032682125289, -0.11345152536725393],
            [12.163363385722871, -0.11288626882043609],
            [12.161361627189311, -0.11629456136704389],
            [12.155982832489071, -0.11873131929082122],
            [12.151597886731274, -0.1264023008637956],
            [12.153199078830639, -0.1304709827097891],
            [12.146106738920444, -0.1343272003706216],
            [12.144608287398126, -0.1377898716114074],
            [12.136923753480925, -0.14381966948855804],
            [12.133614262907628, -0.14766633157166617],
            [12.131137969623053, -0.14778590666980554],
            [12.124543795879333, -0.15305235662826605],
            [12.127548401812621, -0.15769961969838459],
            [12.126768917208274, -0.1599763012496177],
            [12.122139102492719, -0.16164614418352288],
            [12.126038811274123, -0.16591862718086114],
            [12.126980201242947, -0.17168613167439348],
            [12.129046421269697, -0.17319913168620266],
            [12.12968305749962, -0.17872148088390924],
            [12.132223647466166, -0.1825251208474763],
            [12.128774676306676, -0.18518073354893422],
            [12.129011905214554, -0.18876448123558084],
            [12.12429369816648, -0.19510102650518343],
            [12.121140157792155, -0.19500110123796333],
            [12.116394268960772, -0.1982517707035812],
            [12.114636343184612, -0.20491652337396055],
            [12.112289584354318, -0.20842320390955704],
            [12.106084648542629, -0.20841650988899116],
            [12.101007237736171, -0.2048299192552095],
            [12.096538930263122, -0.2102383311441242],
            [12.093115159019858, -0.21169896132409904],
            [12.088562876313997, -0.20802256754880322],
            [12.083554371063055, -0.20850606337875596],
            [12.079218257706723, -0.20418071353315792],
            [12.072153996792611, -0.20723659321249177],
            [12.069870870128867, -0.21291207902125012],
            [12.064595077009836, -0.21169853526125584],
            [12.063376296405751, -0.21454725539700356],
            [12.05809479610256, -0.21834410691062117],
            [12.052282716281251, -0.22028071872113625],
            [12.04980568377235, -0.2227146939267975],
            [12.049689223761755, -0.2270262807042371],
            [12.03865048371577, -0.23008994092705978],
            [12.036722907919643, -0.23365957298524714],
            [12.033544414312194, -0.23424759571998874],
            [12.035211647739676, -0.24310051560621146],
            [12.033367738168561, -0.2445143725563941],
            [12.036163409454934, -0.25037713219287194],
            [12.034765908760756, -0.25645862525682134],
            [12.035496923073717, -0.2639712315686153],
            [12.038184457842675, -0.2695678288424117],
            [12.03618441426127, -0.27708694680389073],
            [12.031640720653792, -0.2804564544495145],
            [12.035038968538348, -0.2855471249464827],
            [12.034859201761524, -0.2904816206060385],
            [12.031968534298326, -0.2941824230636988],
            [12.032437540401869, -0.30274383451512105],
            [12.025698382619773, -0.3020373263807942],
            [12.022649422792366, -0.2962813228721216],
            [12.019373999046195, -0.29618130681416155],
            [12.009200083803622, -0.2901089399414773],
            [12.00512918546211, -0.2854313035545377],
            [12.001144799293968, -0.2858759065797411],
            [11.998483395351277, -0.28331903577919393],
            [11.99167413794902, -0.29008789241916194],
            [11.984982008696333, -0.2848123352536583],
            [11.980846571861633, -0.28480727432045744],
            [11.97575221894992, -0.27674075215445904],
            [11.972241410459246, -0.27959855093920205],
            [11.960610386961683, -0.27570198541864316],
            [11.956427929146928, -0.27591965719865347],
            [11.948083305661156, -0.2688273920185054],
            [11.944354058348086, -0.26139086595819516],
            [11.946256769798097, -0.25496983975952586],
            [11.944657956665749, -0.2513353747444368],
            [11.946952077039278, -0.24668569646250196],
            [11.94560074156154, -0.2410709363602138],
            [11.941395985818977, -0.23549184265482723],
            [11.938309898066466, -0.23556363741422365],
            [11.934694442323794, -0.23019910949720696],
            [11.93501914400311, -0.22725027026636424],
            [11.86014969976802, -0.12825879565749465],
            [11.829283889205573, -0.0885207848870376],
            [11.820864053454947, -0.08588244671199277],
            [11.816209595815634, -0.07985729894879688],
            [11.810800429915112, -0.07098528032945607],
            [11.801896450959369, -0.06204004753750826],
            [11.800446131461594, -0.057257078909195194],
            [11.795627225261507, -0.056186426578377184],
            [11.789038932694723, -0.059413735291715744],
            [11.786580795047861, -0.06286777204436711],
            [11.78268881394857, -0.06143383800710333],
            [11.778352582699897, -0.061886745349069794],
            [11.772328888501136, -0.054129069821877616],
            [11.76703079771076, -0.05739595072645753],
            [11.761068766428274, -0.05402133734352806],
            [11.75905308649123, -0.057906937655495004],
            [11.755899914639281, -0.056961000317002075],
            [11.750802175241713, -0.05212575286407586],
            [11.749198338731855, -0.04889836427447786],
            [11.749338610303337, -0.03692341778641],
            [11.747750980823469, -0.033284887229576586],
            [11.749796136183711, -0.030110181775188895],
            [11.746907308473213, -0.02779529938703133],
            [11.740984402572826, -0.02890879749151069],
            [11.736600068475802, -0.02457545023448359],
            [11.731279037937579, -0.02651533305950245],
            [11.724974812693416, -0.02411138710961778],
            [11.721721612356605, -0.028185496311191608],
            [11.715752620944619, -0.020211802143606437],
            [11.715450419333951, -0.016171688339281034],
            [11.712180143446856, -0.012381730088565995],
            [11.709890828311707, -0.004150838975400604],
            [11.710621434147388, -0.0016893250761982526],
            [11.707631298497972, 0.00285872081833428],
            [11.707502601629805, 0.008866398804796324],
            [11.702936089495413, 0.012865747286632062],
            [11.70460174791093, 0.0200674507052812],
            [11.708769871463652, 0.023430169039724925],
            [11.706748261888452, 0.028773112168323078],
            [11.70387762345943, 0.029524810730295385],
            [11.704534074036696, 0.03497231286821407],
            [11.70660474659188, 0.03539049224003427],
            [11.709502147708703, 0.04125076132177001],
            [11.70018448940034, 0.04840442632557897],
            [11.701369109725231, 0.05512394593762195],
            [11.698533684149645, 0.058673081905202464],
            [11.699286063798104, 0.06563290391299297],
            [11.694840367774495, 0.06628051495708834],
            [11.690750822782052, 0.07260254288122421],
            [11.694486277852809, 0.07685079614363155],
            [11.69422983998216, 0.08059141386952894],
            [11.699235134055685, 0.08248140707880809],
            [11.695349292363327, 0.08566638034021416],
            [11.700731656377823, 0.09282442479926283],
            [11.698882851291929, 0.09509527463485447],
            [11.698783337551747, 0.10090315445797875],
            [11.70654171612053, 0.10903881168795483],
            [11.705034282161579, 0.11268991464923628],
            [11.708992993516054, 0.11932434979382021],
            [11.71902547423294, 0.12137418097794349],
            [11.723568466237424, 0.12779284509439762],
            [11.725565187846879, 0.13433162376718344],
            [11.730785070756117, 0.14044625824943657],
            [11.738510874408524, 0.13693413410986185],
            [11.743355624310354, 0.13778145389301039],
            [11.74775221342424, 0.13641453192933348],
            [11.749791974674647, 0.14163271927508184],
            [11.759712421649281, 0.14387573233726514],
            [11.765761118025436, 0.14766885235894178],
            [11.770264764171811, 0.14560454264761458]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.24860371247925, "lat": 37.77129593820265 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54081"],
        "coty_name": ["Raleigh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Raleigh County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01550047"
      },
      "bbox": [
        11.690750822782052, -0.30274383451512105, 12.264805317798881,
        0.14766885235894178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.5007316817423755, 4.6490303097503505],
            [4.507503850395445, 4.650253689656502],
            [4.515295363820113, 4.649085638362691],
            [4.526403009447283, 4.652659116222298],
            [4.531535673951031, 4.653188219833974],
            [4.543054455700455, 4.657058635182085],
            [4.55371543914944, 4.659619571716215],
            [4.556080326901618, 4.660961129507618],
            [4.568490563701382, 4.661805466545417],
            [4.578699209617189, 4.659889098676515],
            [4.586467156515994, 4.659795603027398],
            [4.594401923923509, 4.661999381414579],
            [4.599758236916485, 4.660833674244631],
            [4.604855495206587, 4.655300700768515],
            [4.606128531655516, 4.650546117903569],
            [4.610783019331816, 4.648678567547215],
            [4.617369018052229, 4.6517776399881035],
            [4.623365208536779, 4.653129409779494],
            [4.630305090546257, 4.648117596462536],
            [4.637405944510595, 4.645349498843664],
            [4.649608560802737, 4.634139886441133],
            [4.655435797328639, 4.630439877203187],
            [4.67381109878951, 4.622753790846029],
            [4.6786736176713895, 4.620431229099315],
            [4.681896997076078, 4.615888546144169],
            [4.685219150748214, 4.616872593721397],
            [4.694078050486743, 4.624350784072915],
            [4.698891521029634, 4.626626552216984],
            [4.716275440340255, 4.626640838040843],
            [4.725440292214753, 4.623216206766765],
            [4.732390034306096, 4.6222369122253],
            [4.743309354829757, 4.622880626555641],
            [4.750613307671748, 4.625385776332356],
            [4.754711211150056, 4.624399393573269],
            [4.760152497910363, 4.6184136153713045],
            [4.7645345330711635, 4.615699461888162],
            [4.7703258062093195, 4.610128582845821],
            [4.77659040702666, 4.6112504309491795],
            [4.776731829182938, 4.619041452518167],
            [4.779025927927207, 4.624448767238041],
            [4.778808412351613, 4.631662866573864],
            [4.787916938329755, 4.637905149862727],
            [4.792145252700584, 4.643192915120304],
            [4.7949232980038285, 4.649176974256953],
            [4.812160347419036, 4.661607066003858],
            [4.824699026743867, 4.663406115942106],
            [4.828796569131335, 4.661948428793383],
            [4.841575948233661, 4.661023019501776],
            [4.848626560775992, 4.662729542121823],
            [4.855511011211798, 4.661342075303962],
            [4.861967827897969, 4.661290400144021],
            [4.8692206529182815, 4.659709870367564],
            [4.882202899205156, 4.659545770731765],
            [4.88943744031448, 4.662327500696663],
            [4.897356688921431, 4.66770712476089],
            [4.901568280287232, 4.669197656640343],
            [4.909130992085884, 4.667812946343094],
            [4.914316949134958, 4.669079898082309],
            [4.92611052079785, 4.67676200792309],
            [4.928654461200951, 4.680523827252244],
            [4.934476632552169, 4.59306045054984],
            [4.9366023982820035, 4.557673449115408],
            [4.939916568420779, 4.506191880384687],
            [4.945363528286173, 4.419129384711837],
            [4.949746625577455, 4.358728592942684],
            [4.951344540436659, 4.331753613826223],
            [4.954008819959456, 4.2881043372322],
            [4.927324809540237, 4.285862335135504],
            [4.872027932160296, 4.282428532645046],
            [4.828735507289458, 4.28027474573298],
            [4.810818649410921, 4.278931535040005],
            [4.7992341883274765, 4.27850203971745],
            [4.770317491196824, 4.2765299668996315],
            [4.693532518399646, 4.2727544595893],
            [4.6546484641281785, 4.2703001446010225],
            [4.563382339023799, 4.263441332958576],
            [4.525717193807661, 4.260762822219859],
            [4.52341219334573, 4.294286684691264],
            [4.520618823258293, 4.340710202284009],
            [4.516441667464533, 4.399467268390863],
            [4.513459550254736, 4.4505368304543005],
            [4.511605709253507, 4.479418429259163],
            [4.505533762247031, 4.5663761240104925],
            [4.5024092335866115, 4.624112599133457],
            [4.5007316817423755, 4.6490303097503505]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.13536630912985, "lat": 43.00046019294578 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55049"],
        "coty_name": ["Iowa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Iowa County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "01581084"
      },
      "bbox": [
        4.5007316817423755, 4.260762822219859, 4.954008819959456,
        4.680523827252244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.267636288615279, 6.1810711041326405],
            [5.29540794347193, 6.18285090553783],
            [5.3250854972178665, 6.184367531222134],
            [5.3534111290018425, 6.186429785603824],
            [5.381415788364684, 6.188029105738675],
            [5.464401346490761, 6.193574034480311],
            [5.515161384438113, 6.1974883444199],
            [5.569123878539469, 6.201014177936053],
            [5.609005335494208, 6.203940242583313],
            [5.653614589560418, 6.2069387982110475],
            [5.676623331559196, 6.208227631170563],
            [5.7055591716525775, 6.210556996804468],
            [5.707202403216209, 6.188005097067255],
            [5.710240549218477, 6.14004674737],
            [5.711745437226276, 6.123269231299034],
            [5.705106844948333, 6.122673047883248],
            [5.619139998360107, 6.116245221872773],
            [5.623100155807847, 6.06457610217142],
            [5.625695816591821, 6.028501856732194],
            [5.63254185159366, 5.942832835039392],
            [5.635714754569969, 5.900770715185753],
            [5.63890332771017, 5.843153622525953],
            [5.64361380228831, 5.770718135443144],
            [5.615933667639764, 5.768607960513416],
            [5.59561303111176, 5.766622506931893],
            [5.564955782322523, 5.764064450882377],
            [5.539053463147091, 5.762155103589821],
            [5.485653818052347, 5.75846455676595],
            [5.471036278810039, 5.757265037477784],
            [5.411325053189055, 5.7530167391647655],
            [5.366803768470797, 5.749958999422617],
            [5.298156671684351, 5.745383251442096],
            [5.296195185328999, 5.776403441978896],
            [5.287393912704952, 5.905441436932022],
            [5.282058757515902, 5.983639135889221],
            [5.27750161224866, 6.0495855290705824],
            [5.2730597249950275, 6.106300873714683],
            [5.267636288615279, 6.1810711041326405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.96479569827363, "lat": 44.47048006629573 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55135"],
        "coty_name": ["Waupaca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Waupaca County"],
        "coty_fp_code": "135",
        "coty_gnis_code": "01581127"
      },
      "bbox": [
        5.267636288615279, 5.745383251442096, 5.711745437226276,
        6.210556996804468
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": { "lon": -66.05077753794305, "lat": 18.21176686156405 },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72025"],
        "coty_name": ["Caguas"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Caguas Municipio"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01804492"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.36015771424233,
          "lat": 18.097358857433843
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72043"],
        "coty_name": ["Coamo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Coamo Municipio"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01804501"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.49028539898764,
          "lat": 18.420442480039142
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72091"],
        "coty_name": ["Manatí"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Manatí Municipio"],
        "coty_fp_code": "091",
        "coty_gnis_code": "01804526"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.221980310775838, 7.6551690609115415],
            [-2.2195108827426973, 7.65518694964366],
            [-2.1492314872290073, 7.651936663985779],
            [-2.020107511845923, 7.647462081483277],
            [-1.9005129644848373, 7.643475720732146],
            [-1.8054293834505373, 7.64015640368249],
            [-1.7744078854355223, 7.638906380774081],
            [-1.7170396562678576, 7.636884269952215],
            [-1.640289185782253, 7.634321402346639],
            [-1.6397758341106208, 7.634208176260762],
            [-1.6161173124354231, 7.633489503540138],
            [-1.6165094746346491, 7.6285598359269535],
            [-1.6172893685859888, 7.596213403308543],
            [-1.620820663845233, 7.497612021220204],
            [-1.6217080746186638, 7.477340778433618],
            [-1.6255807220243008, 7.369150280352827],
            [-1.6287675290213584, 7.294269011786387],
            [-1.689384299095329, 7.296436291510898],
            [-1.8041251463868824, 7.3001171119652275],
            [-1.8881315286119738, 7.303367301293458],
            [-1.9659038750547453, 7.306115343629835],
            [-2.034429902213906, 7.3093833229887055],
            [-2.12439406536905, 7.312619777790694],
            [-2.1468812302931313, 7.313524315062611],
            [-2.208287560025362, 7.316312177015984],
            [-2.2370614263411186, 7.317845374857636],
            [-2.231877130201313, 7.43251908319501],
            [-2.2267908115284896, 7.546710960774701],
            [-2.226449622755367, 7.548857821190248],
            [-2.2245475458270705, 7.602346917803237],
            [-2.2238645269607873, 7.612224271381121],
            [-2.221980310775838, 7.6551690609115415]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.44121061902963, "lat": 46.11181820637765 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38051"],
        "coty_name": ["McIntosh"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McIntosh County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "01034211"
      },
      "bbox": [
        -2.2370614263411186, 7.294269011786387, -1.6161173124354231,
        7.65518694964366
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.6827579266928503, 9.688509578680566],
            [-1.5952934025871308, 9.6855815880251],
            [-1.528912254856654, 9.683346167520382],
            [-1.5260325781342692, 9.768119088847252],
            [-1.5232339115338815, 9.852822807211215],
            [-1.4617401126254979, 9.850601983980335],
            [-1.3488397961719027, 9.847351495257485],
            [-1.2616918480487023, 9.844715076096836],
            [-1.1743189244306929, 9.84240824466173],
            [-1.086965468813101, 9.840413378618372],
            [-1.0891050703402085, 9.755525735928822],
            [-1.091397877219496, 9.670666577151145],
            [-1.0736073913733748, 9.670213806272914],
            [-1.075851981660482, 9.584804223449694],
            [-1.0765196490933822, 9.563637525538898],
            [-1.0779990099437344, 9.499802862548504],
            [-1.1653440734751859, 9.50155360128005],
            [-1.1676583492009254, 9.416713293142429],
            [-1.1700120572878305, 9.331774897935887],
            [-1.2395515438248064, 9.333570305762267],
            [-1.2423102784515492, 9.229782057547826],
            [-1.280670196554389, 9.230848719526216],
            [-1.2812401297056593, 9.23228928716557],
            [-1.3096926426870577, 9.232900326138862],
            [-1.3138196926469476, 9.239967857802348],
            [-1.3144733631815353, 9.245568964052717],
            [-1.3094921827612664, 9.254541934198095],
            [-1.3156000265513168, 9.260781198412484],
            [-1.3241150455773345, 9.267871442751748],
            [-1.3323611841049485, 9.277206508911958],
            [-1.334094534771182, 9.280880720955897],
            [-1.3352847770290062, 9.290801028731241],
            [-1.3385513061943108, 9.296381856494289],
            [-1.3345381911188698, 9.301318187686977],
            [-1.3335443164221497, 9.307666668586704],
            [-1.3388891705111872, 9.315966460174746],
            [-1.3466913190631324, 9.316904996839757],
            [-1.353513521934658, 9.319595942871384],
            [-1.3619382164202762, 9.319547293026853],
            [-1.3671995561841108, 9.314995971949253],
            [-1.37370265915654, 9.314200530038862],
            [-1.3771706221311564, 9.306368030587734],
            [-1.3823573539934333, 9.2975069788088],
            [-1.3950867845172512, 9.28884247431338],
            [-1.4015977478591428, 9.288644205796736],
            [-1.4065075844519035, 9.285705535588725],
            [-1.408002114596721, 9.28259917156041],
            [-1.41269367379501, 9.279257907095667],
            [-1.4197911298304142, 9.26989586036116],
            [-1.4229111980162095, 9.270579862358009],
            [-1.4245020541434608, 9.27526633200952],
            [-1.4210742822281253, 9.277756230301282],
            [-1.4158292329283813, 9.284159866248865],
            [-1.4154575340983637, 9.287716640003309],
            [-1.412544267387664, 9.291108819513754],
            [-1.4047740778682323, 9.293113656267652],
            [-1.3985543517642531, 9.291644471081732],
            [-1.3944862642197957, 9.295402778220225],
            [-1.392363019084516, 9.299903160400326],
            [-1.394045431122224, 9.310598418308617],
            [-1.3992321134841945, 9.314764173200986],
            [-1.4005840553734392, 9.318295297273464],
            [-1.3975746877774744, 9.321929357803903],
            [-1.4004611974526828, 9.324753402285229],
            [-1.4042683111001297, 9.321534097603452],
            [-1.4044451508095903, 9.316140673061994],
            [-1.413785750804927, 9.319262983539044],
            [-1.4137399438733123, 9.32307993419072],
            [-1.416126938527833, 9.32451961560637],
            [-1.4163419760673972, 9.328637681484803],
            [-1.4142580675077336, 9.330633265819985],
            [-1.4155752102999102, 9.34310390738408],
            [-1.4143216558814153, 9.346689517040222],
            [-1.4183904793435398, 9.350527007280595],
            [-1.421662622611389, 9.356201286559893],
            [-1.4247901100580072, 9.364416120343382],
            [-1.424172452683795, 9.371543903887696],
            [-1.4213425911872384, 9.373712676788308],
            [-1.4285385270908684, 9.376662387806212],
            [-1.4402539092064426, 9.379548571182706],
            [-1.4414881884147004, 9.374397762691908],
            [-1.447589924487487, 9.366649428588417],
            [-1.452076967123993, 9.36325812097284],
            [-1.456091785284274, 9.362104302138574],
            [-1.46687350184094, 9.355865952192884],
            [-1.4702134778316753, 9.352539366509264],
            [-1.4765408287567312, 9.34846119537169],
            [-1.480316763356152, 9.344371667257038],
            [-1.4823315231184921, 9.335867128692849],
            [-1.4848348533570543, 9.329089129294971],
            [-1.4907502494458404, 9.336413653254477],
            [-1.4926602477244448, 9.344498639558509],
            [-1.4956256993699042, 9.342434382547204],
            [-1.5040460837003895, 9.34073108890067],
            [-1.5055471394792685, 9.338035462825482],
            [-1.5032214641166375, 9.32602089180843],
            [-1.5082771606266447, 9.320169466102477],
            [-1.5124700959302377, 9.31767482642849],
            [-1.5230360563575216, 9.323588841461307],
            [-1.5291296272212975, 9.324265068239539],
            [-1.5358158333713412, 9.319857003793079],
            [-1.54224092511948, 9.319454905890886],
            [-1.5484493404152402, 9.317528076156195],
            [-1.554453153536622, 9.312377873582296],
            [-1.555795996039123, 9.31855309958333],
            [-1.5523046895029602, 9.323608556936037],
            [-1.5510543278074245, 9.328954755657495],
            [-1.5513288241962153, 9.33728514972056],
            [-1.5554402072120852, 9.33956667943362],
            [-1.557432560971751, 9.344817291459027],
            [-1.557384285571888, 9.34843793099649],
            [-1.5616254970809444, 9.36318796637935],
            [-1.5593014400330152, 9.37100675384746],
            [-1.5660600053743807, 9.373468960186216],
            [-1.569074514013685, 9.370947966355224],
            [-1.57532829758557, 9.372802198815622],
            [-1.5801216967223848, 9.368517972605508],
            [-1.5833926268866254, 9.36922693477284],
            [-1.5869755915669275, 9.364018073637105],
            [-1.5923886758730441, 9.360473495466136],
            [-1.5931025240507344, 9.353111206517323],
            [-1.5999505166233061, 9.344861426396713],
            [-1.6067868788902917, 9.34505751957381],
            [-1.6049069457240372, 9.410542338049623],
            [-1.6040979018484447, 9.42904526443021],
            [-1.6302718486511827, 9.429695164689148],
            [-1.6354874377781943, 9.433223688389555],
            [-1.6361933310355954, 9.436212100472572],
            [-1.6342568577928445, 9.44017744381423],
            [-1.638215386606724, 9.450360016373084],
            [-1.6421832225043564, 9.453784633791928],
            [-1.6443423336079315, 9.45848494233401],
            [-1.6424387218306615, 9.462072893143311],
            [-1.6459150227936123, 9.465543159107547],
            [-1.6493192297717205, 9.465544463233792],
            [-1.6562206108456643, 9.460636998582856],
            [-1.6729719251068471, 9.469886230512664],
            [-1.6805879679434228, 9.472356233867622],
            [-1.6849807786551398, 9.471662404077872],
            [-1.6896745985812591, 9.478252554322163],
            [-1.6861861300433951, 9.583114838617972],
            [-1.6857094656978209, 9.601751930136261],
            [-1.6827579266928503, 9.688509578680566]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.72010054823191, "lat": 48.26889497703902 },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38071"],
        "coty_name": ["Ramsey"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ramsey County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "01034215"
      },
      "bbox": [
        -1.6896745985812591, 9.229782057547826, -1.0736073913733748,
        9.852822807211215
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.267405177303335, 3.7232394614728426],
            [11.298276520204132, 3.728451737592212],
            [11.337155510367845, 3.7342968326007564],
            [11.33355018208375, 3.760431320841883],
            [11.327028216099194, 3.8049096390922625],
            [11.402746029315226, 3.817185018226912],
            [11.468532947295314, 3.827656086433899],
            [11.456462315612908, 3.899895203940058],
            [11.501836129028522, 3.907252997247397],
            [11.529055960670417, 3.9119705428054607],
            [11.54070416645266, 3.8396283914127176],
            [11.551794666673175, 3.7698219631549312],
            [11.562702148593289, 3.7000481535600405],
            [11.569312922104979, 3.657646093252356],
            [11.574683821267156, 3.6245395347385547],
            [11.586983035083497, 3.5474435105781064],
            [11.549900845289898, 3.541472986310708],
            [11.50575699208325, 3.5340781302638558],
            [11.44855641664807, 3.5253050711378706],
            [11.369752197114655, 3.512740578320861],
            [11.301067064378215, 3.5030554941018335],
            [11.293241850430928, 3.552252214038653],
            [11.289288761307036, 3.578597632435633],
            [11.301756922677914, 3.5806874283228054],
            [11.298373027025033, 3.601395883476795],
            [11.286236577768555, 3.5994531345255854],
            [11.283150597797821, 3.621194008911652],
            [11.273002972349493, 3.6885154230820962],
            [11.267405177303335, 3.7232394614728426]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.17861518782047,
          "lat": 41.499571505638556
        },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39055"],
        "coty_name": ["Geauga"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Geauga County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01074040"
      },
      "bbox": [
        11.267405177303335, 3.5030554941018335, 11.586983035083497,
        3.9119705428054607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.069750699194865, -1.5138966209814764],
            [-5.057859590965613, -1.516372094707364],
            [-4.971703826062074, -1.52157321779406],
            [-4.920104333883186, -1.525171146670728],
            [-4.864700174011532, -1.5311873921836439],
            [-4.830228801763204, -1.536198028501368],
            [-4.559765402927883, -1.5553742726339366],
            [-4.485129036329445, -1.5605225288881228],
            [-4.443754140747618, -1.5639050411649273],
            [-4.312581802134678, -1.5730893088079339],
            [-4.301615725541687, -1.5736760782677106],
            [-4.310905397470378, -1.718472183889541],
            [-4.313894999214296, -1.7184653665962097],
            [-4.319257563220053, -1.8059701077408654],
            [-4.323118974626819, -1.8645239127309858],
            [-4.336416546021332, -2.069464138179698],
            [-4.407712779967507, -2.0648274027969094],
            [-4.410425175820797, -2.065016457255979],
            [-4.4398360036543405, -2.0631117966593675],
            [-4.505385172664488, -2.058447761581952],
            [-4.509748029033519, -2.058499441021239],
            [-4.614751432485739, -2.0515102102233453],
            [-4.764168514292834, -2.0413119556687644],
            [-4.940111874323867, -2.0289224054741464],
            [-5.107072791315379, -2.0167843711479536],
            [-5.1052305197532055, -1.990424123892198],
            [-5.09927421921763, -1.9138445552714696],
            [-5.0941503071790395, -1.8408990602975206],
            [-5.090609088714052, -1.7963958083015077],
            [-5.087289822950848, -1.7520298129289635],
            [-5.076293330059413, -1.6050361162961084],
            [-5.076367158846497, -1.6029924642311797],
            [-5.069750699194865, -1.5138966209814764]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.51775513167529,
          "lat": 36.74826602027608
        },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40025"],
        "coty_name": ["Cimarron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cimarron County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01101800"
      },
      "bbox": [
        -5.107072791315379, -2.069464138179698, -4.301615725541687,
        -1.5138966209814764
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.2694189719597917, -1.668703914386186],
            [-2.2305340660186603, -1.669998821269258],
            [-2.2055148702144103, -1.670287592949194],
            [-2.128159497691037, -1.6735988322060642],
            [-2.007512836557319, -1.6778227358926956],
            [-1.9480789764314839, -1.679954118273105],
            [-1.9319725039910007, -1.6800915045461733],
            [-1.9090216299155904, -1.680904969774108],
            [-1.805576025609537, -1.6843254214081393],
            [-1.7442933338419653, -1.6861816612700755],
            [-1.7203012040052064, -1.6867108574161602],
            [-1.6830842192240065, -1.688151383151602],
            [-1.5487884446850195, -1.6919307311075726],
            [-1.5505827919269968, -1.7491823570502545],
            [-1.5468228982610093, -1.7492960435396645],
            [-1.5479030481569331, -1.7857120514481],
            [-1.5489934005319965, -1.8297060093583581],
            [-1.552939144698908, -1.9687574246869612],
            [-1.5564218539817156, -2.1003323608315996],
            [-1.5507772067646473, -2.100475900426841],
            [-1.5544743548452797, -2.2325650551975125],
            [-1.5562657935754527, -2.298473296293428],
            [-1.5648162490078317, -2.29512712304541],
            [-1.5711971229440385, -2.293581825745883],
            [-1.5769555513174405, -2.293837717934412],
            [-1.580413921597524, -2.2954891643813045],
            [-1.6040826955719487, -2.303071943330092],
            [-1.6115812871376105, -2.304060758182655],
            [-1.6227528615732, -2.3022093315866328],
            [-1.6295064003938275, -2.301805232522907],
            [-1.6444482221744419, -2.296777882098395],
            [-1.6589964105269754, -2.2889008592144293],
            [-1.6729929822527367, -2.2826055628548674],
            [-1.6879261239089691, -2.2765393207207625],
            [-1.695509201244366, -2.2703245894624606],
            [-1.7024842017668906, -2.254444945635472],
            [-1.708844522393571, -2.2463563208240833],
            [-1.72191544012411, -2.2426653452305003],
            [-1.7387913899765048, -2.2441454418970603],
            [-1.749291908114043, -2.2420471871132817],
            [-1.7609098166731443, -2.2368417540212007],
            [-1.7729111288613706, -2.2289387375332277],
            [-1.7818736572403295, -2.218328382077254],
            [-1.7846478081976052, -2.2115480301515222],
            [-1.7891807942596847, -2.204822176518506],
            [-1.7961315044659223, -2.1885976815009025],
            [-1.8001092645501078, -2.1821398187487184],
            [-1.892910836416613, -2.1787028815457274],
            [-1.8930447205594452, -2.1786280633564448],
            [-1.8897290734671846, -2.085865848221971],
            [-1.898836531337083, -2.0842402876590165],
            [-1.9024055105429036, -2.0813689931372195],
            [-1.9121174744559117, -2.0683893265600704],
            [-1.9137347710635335, -2.0647328578120043],
            [-1.9208674413296283, -2.054067704396376],
            [-1.9284656375484148, -2.050050245705158],
            [-1.93052341408705, -2.0429462644964875],
            [-1.9380648426380696, -2.04049317776768],
            [-1.939622643976988, -2.0324578712322925],
            [-1.9373969020453228, -2.0238806250073273],
            [-1.93873324881253, -2.021133774269706],
            [-1.9439654656721879, -2.0175894717508087],
            [-1.948151051531594, -2.0129243803923162],
            [-1.950392493281809, -2.0086240431540143],
            [-1.9507318757563612, -2.003633397866225],
            [-1.9525717169693648, -2.000058486709294],
            [-1.9571976583713158, -1.995072793333281],
            [-1.9536895489726296, -1.9869829952442641],
            [-1.957680357415505, -1.98206698438645],
            [-1.9596098234530912, -1.9764638304021802],
            [-1.9666508402450376, -1.9658695958041164],
            [-1.9732161385711413, -1.9649956262657688],
            [-1.9798467940933182, -1.9629802027947694],
            [-1.9846823379349625, -1.9590962323700458],
            [-1.9930970081761954, -1.9435077444733564],
            [-1.9942917312181085, -1.9381110483912924],
            [-1.998127091113583, -1.9361334163178994],
            [-2.00149816828506, -1.9324463925884818],
            [-2.0021881437699025, -1.929387019055378],
            [-2.0070632531188894, -1.9256242716246181],
            [-2.016703986849953, -1.9166737710687236],
            [-2.017835074441047, -1.9097258138709823],
            [-2.0212830292094224, -1.9049458426234942],
            [-2.0228785513549075, -1.900497370485731],
            [-2.0265649302803923, -1.895677930637515],
            [-2.03627752268166, -1.890728344453576],
            [-2.040906178653781, -1.8903949960815505],
            [-2.0464648266566035, -1.8873427391798598],
            [-2.0589099458585554, -1.890189484195285],
            [-2.065453591402093, -1.8900187031617026],
            [-2.073238713909991, -1.8862011248785007],
            [-2.0823634293291096, -1.8860903781278837],
            [-2.0882005291603374, -1.8898094772627179],
            [-2.0977269820530497, -1.8881233576921563],
            [-2.1077597704190474, -1.8902120716129323],
            [-2.114125937409316, -1.890740801733471],
            [-2.129686358524912, -1.8854495233265378],
            [-2.1350591338074594, -1.8791144974836291],
            [-2.1423070593332776, -1.8725536678135517],
            [-2.1481779025990533, -1.868441888216195],
            [-2.148435688918129, -1.8546736199317766],
            [-2.151370731345519, -1.8501865985008996],
            [-2.158605334309391, -1.844913777501807],
            [-2.160235927722083, -1.838965204941704],
            [-2.16525111236482, -1.831102173684882],
            [-2.1656352475311595, -1.8233247958807088],
            [-2.161677914877514, -1.8195278298468816],
            [-2.162282980625287, -1.8172105487265193],
            [-2.168441208636039, -1.8159625867103844],
            [-2.1746867906093073, -1.8099298023625634],
            [-2.190168143916991, -1.8020547941695881],
            [-2.1950829590541243, -1.8000809576494434],
            [-2.201925407898698, -1.7942306317431558],
            [-2.2089089806500515, -1.791935174618872],
            [-2.2114467483246156, -1.7854327756045119],
            [-2.2159865075651672, -1.7800738039400665],
            [-2.219275181746809, -1.769368676901511],
            [-2.2180648045871796, -1.765074605221572],
            [-2.2225856532843493, -1.7579939845991046],
            [-2.2262973339661647, -1.7489616440077513],
            [-2.2315580463561067, -1.7451328666589574],
            [-2.2383742103010182, -1.734473684352823],
            [-2.243331635980724, -1.7285593908205377],
            [-2.2477618676322604, -1.7185050295768425],
            [-2.2489052915890735, -1.714023330921333],
            [-2.2479446481588607, -1.7093932974986017],
            [-2.2529838088169143, -1.6989983257445516],
            [-2.256669268967093, -1.6884498927778404],
            [-2.256890182098385, -1.6779821902342247],
            [-2.2594562390310386, -1.6730850612643995],
            [-2.2669400925849947, -1.6727549702248568],
            [-2.2694189719597917, -1.668703914386186]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.86509726337607, "lat": 36.76694044304763 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40151"],
        "coty_name": ["Woods"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Woods County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01101863"
      },
      "bbox": [
        -2.2694189719597917, -2.304060758182655, -1.5468228982610093,
        -1.668703914386186
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.510321228318585, 2.7488143520375696],
            [13.518186007763823, 2.766564394117194],
            [13.508190600611265, 2.7876604196303636],
            [13.514625773408138, 2.7904325066128792],
            [13.514650203545397, 2.8044192184655037],
            [13.515199788569529, 2.8135294236466017],
            [13.521898425103336, 2.8237798244128736],
            [13.524371363622773, 2.836706992904649],
            [13.578593580549205, 2.8208115558911167],
            [13.596835233277288, 2.815690394773382],
            [13.615697015431733, 2.813494104259641],
            [13.657000729504897, 2.784930711912557],
            [13.666610225852839, 2.7789858473573728],
            [13.667720562001652, 2.7899752899910117],
            [13.666772863333868, 2.8010992939236186],
            [13.664730929029465, 2.8124617603691155],
            [13.665938435702158, 2.8310367506553327],
            [13.665992252409579, 2.83823522507673],
            [13.690311894176027, 2.8294997670711206],
            [13.71595277090355, 2.8210976590339465],
            [13.756380637487284, 2.8090379682858404],
            [13.770887148741354, 2.8023609666156015],
            [13.785355438053237, 2.7988982126688806],
            [13.786004084917323, 2.809281797169897],
            [13.791684873315534, 2.8253154755393366],
            [13.79434953343095, 2.8373189394595904],
            [13.797022461849474, 2.8549099966203055],
            [13.798297633988707, 2.858536736840681],
            [13.808354558057587, 2.8346648500109572],
            [13.826417093736913, 2.7908930649973054],
            [13.82773486516093, 2.7888383345545855],
            [13.900379680222763, 2.7518862206448835],
            [13.91426602506343, 2.7443245820688147],
            [13.90525244644484, 2.7014053712403534],
            [13.904921087045302, 2.698511837230233],
            [13.886234637184394, 2.6739513621207798],
            [13.875591885350282, 2.656245694673891],
            [13.878319994324952, 2.6533271203089726],
            [13.879355196547348, 2.643018310500087],
            [13.881845149233039, 2.6394452074187997],
            [13.885118085843596, 2.6383780537029025],
            [13.891225148628953, 2.6387978255430964],
            [13.896434265640462, 2.6334664608857996],
            [13.89951608703982, 2.6325596082749567],
            [13.899222810461021, 2.624269125842793],
            [13.897006370832221, 2.6199041109100683],
            [13.888710819106931, 2.6171778406203328],
            [13.885796797059603, 2.612626872373802],
            [13.886361324476104, 2.604299894218195],
            [13.889174113384415, 2.6006583913411703],
            [13.890413136572151, 2.5886687144892737],
            [13.89363247889041, 2.5843119983789418],
            [13.891351445470152, 2.581562387088197],
            [13.883309926460546, 2.562145744130717],
            [13.880847493192976, 2.551952191802551],
            [13.876584155051683, 2.5238451518944203],
            [13.876537537610165, 2.515942787521375],
            [13.874184816429965, 2.5111838076015007],
            [13.871524611236548, 2.5011359800394475],
            [13.864542142171537, 2.466473969863011],
            [13.864212347612455, 2.455943605212103],
            [13.86178802323826, 2.442557728659591],
            [13.861024412393288, 2.428560368237593],
            [13.858505819734148, 2.403767913220071],
            [13.855588909529583, 2.38474935057971],
            [13.843856174138386, 2.348866428273164],
            [13.84151913952258, 2.3367312640279527],
            [13.837816010992544, 2.3286934406749653],
            [13.832415224551056, 2.311114284779003],
            [13.830347331215076, 2.3085681239969857],
            [13.822479185108163, 2.2905178173587313],
            [13.817183818434337, 2.2771673648928044],
            [13.813725867120258, 2.2712122863901785],
            [13.77010882421888, 2.2630167777885193],
            [13.753120269211392, 2.2602442333722683],
            [13.69604434239877, 2.2492338193896826],
            [13.689446492944667, 2.2483978094390396],
            [13.667416808448854, 2.2439969706082437],
            [13.55669321969784, 2.224066591119978],
            [13.493117446043144, 2.212306949207511],
            [13.495880783046513, 2.2247326421915057],
            [13.498445236411477, 2.231961300417544],
            [13.50867265165114, 2.2830785780700307],
            [13.510914126460893, 2.289845871232444],
            [13.513135228362843, 2.3190630089015514],
            [13.505144565407518, 2.3583885076403237],
            [13.504706356679726, 2.361723156081942],
            [13.496389027950789, 2.401505237583173],
            [13.495746218696713, 2.4055372193883406],
            [13.477893309828636, 2.4945195855762266],
            [13.475088770515862, 2.507897554329017],
            [13.473986883329383, 2.5079314295414883],
            [13.46616459227858, 2.549837599752958],
            [13.471250634157789, 2.5691279822758557],
            [13.48130108123602, 2.5654916956631593],
            [13.492584518494244, 2.6446510346807885],
            [13.495228592642196, 2.662217936664932],
            [13.50230292679465, 2.714513811441626],
            [13.510231785156867, 2.736365558602242],
            [13.510321228318585, 2.7488143520375696]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.49025494804793, "lat": 40.00644199763834 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42009"],
        "coty_name": ["Bedford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bedford County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01209171"
      },
      "bbox": [
        13.46616459227858, 2.212306949207511, 13.91426602506343,
        2.858536736840681
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.707192065586309, 3.3857358046673434],
            [14.714708158361836, 3.3950344593973205],
            [14.718205195267851, 3.4061871422134935],
            [14.718962449669139, 3.4112297894436874],
            [14.721801288678815, 3.419013420389491],
            [14.72651957709224, 3.4266038914840515],
            [14.737158065060127, 3.437494278570629],
            [14.74156257246899, 3.4431203481524193],
            [14.744410733029193, 3.4494656071406866],
            [14.74879997996414, 3.462487316192478],
            [14.750388977890804, 3.469995403629863],
            [14.751617944731816, 3.4815812328217977],
            [14.74991198432219, 3.4939876759959327],
            [14.745417881487679, 3.508475340973666],
            [14.745284793467812, 3.51333058118437],
            [14.7386085059078, 3.5348359474765965],
            [14.73807309302093, 3.5492825778487402],
            [14.740372764940442, 3.564933487453143],
            [14.739323973461605, 3.5684971828821284],
            [14.743369369646352, 3.5812987005659824],
            [14.749452173283458, 3.5925099219360277],
            [14.755542978266897, 3.606352443867163],
            [14.758459197621239, 3.610815911418053],
            [14.758977362014349, 3.6186338747573235],
            [14.762423849878823, 3.6384563400852157],
            [14.76264376634065, 3.643791863698369],
            [14.760781992808905, 3.6471804367048355],
            [14.755376842768491, 3.650194199542587],
            [14.742744680977564, 3.6514109981330742],
            [14.714471615601424, 3.6720699374850323],
            [14.708474150270392, 3.6796315226789895],
            [14.698914072712268, 3.694315258568193],
            [14.691046571798152, 3.703926303560219],
            [14.688676442725177, 3.712070433021098],
            [14.683134131812622, 3.7203791405593294],
            [14.682454048233703, 3.723015515465409],
            [14.684637961515557, 3.736490492632156],
            [14.687295321621578, 3.7451080705891195],
            [14.687832918844377, 3.7519272898179636],
            [14.686066487870171, 3.7612932136351414],
            [14.685596819269788, 3.772126489862077],
            [14.686424520956884, 3.7824680531594037],
            [14.684462115882546, 3.7918961288827004],
            [14.686144459747096, 3.801841614155079],
            [14.683704664622763, 3.8095117125837272],
            [14.681851790464247, 3.8206700772957936],
            [14.68010826940794, 3.825915850489707],
            [14.673681024387148, 3.8326317193230883],
            [14.667504123221232, 3.833852579311897],
            [14.656319876616845, 3.8433495696658424],
            [14.6491221149346, 3.8531128836502933],
            [14.647271608913552, 3.8584383583617683],
            [14.642618777215908, 3.867486151391359],
            [14.641851739475108, 3.8716602586526427],
            [14.638317369519907, 3.8812164755204805],
            [14.63860598722928, 3.886269197734517],
            [14.640964712033547, 3.900009296768432],
            [14.643662502774614, 3.9058044548377766],
            [14.653299550558783, 3.910799834082326],
            [14.66234084267836, 3.9163221029327966],
            [14.682941686809086, 3.922717670238266],
            [14.684374839938535, 3.9239247780872257],
            [14.708259334312586, 3.9381050404915117],
            [14.751527289447575, 3.9431731089771884],
            [14.75658128778733, 3.9252855701410336],
            [14.755785340483738, 3.9195302379087695],
            [14.756178782503655, 3.9090026097274553],
            [14.759913810493495, 3.8993498893815155],
            [14.7621458436904, 3.8817454811639984],
            [14.764262849444911, 3.8757130387110608],
            [14.766218180752496, 3.863027627305442],
            [14.762989708523412, 3.8360054083514106],
            [14.758737923809502, 3.8198453703226702],
            [14.758803914125142, 3.807743185701213],
            [14.757109255273893, 3.7980553295444324],
            [14.75971801357178, 3.7948110083020326],
            [14.754849621394289, 3.7864144365689527],
            [14.753410675883734, 3.7816307066708563],
            [14.753194899799606, 3.7751797819058224],
            [14.755939071329959, 3.767504235682255],
            [14.754847991260423, 3.7332098577524326],
            [14.754004778935851, 3.731226564876992],
            [14.756075455300579, 3.7252242883314977],
            [14.752309819549106, 3.7210050638922567],
            [14.754664343566578, 3.717904851392039],
            [14.752128619822454, 3.7154121824131296],
            [14.753117831484346, 3.711960840449921],
            [14.765137171402491, 3.717385845791231],
            [14.771182152247354, 3.7189446839941183],
            [14.788100275499003, 3.7272385519077784],
            [14.794117558542531, 3.7284353613728336],
            [14.827406132343466, 3.7438027273563854],
            [14.830642913774929, 3.746737710552309],
            [14.83585549559834, 3.7483646977603047],
            [14.84525866044589, 3.7528622323802963],
            [14.853078506124984, 3.747945544427707],
            [14.857734822227949, 3.751762093833911],
            [14.867635015747178, 3.753040487183734],
            [14.872281183095971, 3.7513653153533566],
            [14.882218667720412, 3.745113605049968],
            [14.894468932793453, 3.736491059116679],
            [14.901241658300338, 3.736106385478997],
            [14.916272306525743, 3.7380404490322436],
            [14.922898112845152, 3.7396991324690996],
            [14.927812924483007, 3.739710401614423],
            [14.928306237018358, 3.7314750649772077],
            [14.927203119043597, 3.7253704633975273],
            [14.92508403770528, 3.721199362144501],
            [14.924386502406838, 3.7152054496145777],
            [14.92911743561376, 3.7046525901527194],
            [14.933520929390339, 3.700043060736028],
            [14.937757547954625, 3.690604578396218],
            [14.944034271918738, 3.6854909903350395],
            [14.960537515574561, 3.688940868242772],
            [14.976194556461703, 3.6924421801153957],
            [14.97912122270076, 3.6883841810939098],
            [14.976033006796456, 3.6832789248232403],
            [14.97923037293528, 3.67373753742085],
            [14.983568750234303, 3.672294565879264],
            [14.988435328136338, 3.665396154226358],
            [14.988277425965247, 3.6614766242316517],
            [14.982555946889503, 3.656529400081329],
            [14.983510006443373, 3.6520954530155922],
            [14.989681983549502, 3.6426539702518275],
            [14.991819244629237, 3.63596854633426],
            [14.994305731170714, 3.6355926132366823],
            [15.002049001529993, 3.6396963645992946],
            [15.01612951891222, 3.644231933086568],
            [15.022822281504217, 3.647961434668412],
            [15.042927024558896, 3.65426388875209],
            [15.047517322739003, 3.6564351149338488],
            [15.056208324232632, 3.658341432293836],
            [15.070919122608897, 3.63612469326317],
            [15.07745125303072, 3.625750918740577],
            [15.091083868682757, 3.6059376996593806],
            [15.056709401906309, 3.579639277867179],
            [14.964245348920022, 3.507529529457929],
            [14.945581072261026, 3.495108465569524],
            [14.891041077686063, 3.4531911279263987],
            [14.882841850953735, 3.4470209860216054],
            [14.878517421423862, 3.446388030051783],
            [14.878746854555322, 3.441262606881084],
            [14.877604081466576, 3.438239990608015],
            [14.869636090706086, 3.44094606860243],
            [14.866419577175828, 3.4390458754838247],
            [14.865250237114871, 3.4344094329703405],
            [14.862702469392403, 3.4328060930906923],
            [14.856489506509934, 3.4332497160427535],
            [14.846867546841898, 3.4309997271685972],
            [14.844331475270193, 3.4291292059613925],
            [14.840543997441808, 3.4231499715146123],
            [14.824722638085452, 3.41774926980491],
            [14.820004260892272, 3.4124114350966064],
            [14.814356539128791, 3.410004318322184],
            [14.810304650190817, 3.413531476161996],
            [14.805974695586395, 3.4151858804716015],
            [14.802555947788221, 3.410578641008545],
            [14.803477591049123, 3.402024884150633],
            [14.801551894309313, 3.3999818742321377],
            [14.790954026236127, 3.3984722112688344],
            [14.787992159079298, 3.391347735725681],
            [14.783311416966631, 3.388169676689895],
            [14.771701359532775, 3.386241963368311],
            [14.765074205515003, 3.386656948992076],
            [14.762046781586491, 3.381822676203886],
            [14.763041660793023, 3.376786272598657],
            [14.761107640732288, 3.374265085879341],
            [14.750718844271564, 3.373635089103472],
            [14.748183041486206, 3.3715992165051087],
            [14.749539787883254, 3.365762864073992],
            [14.743003620353107, 3.364557623696568],
            [14.73941501937061, 3.3653076685380268],
            [14.727587954229552, 3.3610964756288135],
            [14.728396358270665, 3.354990335046939],
            [14.723680348972882, 3.359026538766191],
            [14.714429964049375, 3.361207406717268],
            [14.702364679901779, 3.3745072576032413],
            [14.707192065586309, 3.3857358046673434]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.70943684040704,
          "lat": 40.851959015378846
        },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42097"],
        "coty_name": ["Northumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Northumberland County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01209186"
      },
      "bbox": [
        14.638317369519907, 3.354990335046939, 15.091083868682757,
        3.9431731089771884
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.075586823550925, 2.995052925445875],
            [16.08382756768717, 3.0027595911701415],
            [16.08977518506754, 3.0099048260815673],
            [16.115481810098757, 3.0350695421003886],
            [16.12041117716407, 3.0407772753952433],
            [16.114794874167096, 3.0434863328992514],
            [16.10927046997454, 3.0479193832016542],
            [16.097328423103935, 3.0525489474923666],
            [16.085213051922945, 3.059835706567433],
            [16.08174786653618, 3.0633959090758487],
            [16.07410728182152, 3.067651899535059],
            [16.067672959085925, 3.072918617882858],
            [16.072177966918723, 3.081127649601351],
            [16.08940754285198, 3.1177955983799963],
            [16.119837570959202, 3.10374517308474],
            [16.12612735137376, 3.1174262658401846],
            [16.137466635945238, 3.1120005903324923],
            [16.16190062454042, 3.100963030586086],
            [16.184244851399722, 3.0903389719005534],
            [16.184875032615608, 3.092875978843952],
            [16.1926215592117, 3.1027574081943943],
            [16.196632845758902, 3.1114051545410333],
            [16.1885569572371, 3.1151672145628226],
            [16.19606211032944, 3.1311895219512262],
            [16.1988675840841, 3.134796045539923],
            [16.208829942009668, 3.157798972187786],
            [16.230937308207736, 3.18998765674339],
            [16.233743573623418, 3.1965205956333245],
            [16.248694781796782, 3.189365085488934],
            [16.255639498837287, 3.189120127182951],
            [16.260230004551033, 3.187673033651047],
            [16.26363026526405, 3.1845245954215975],
            [16.26868498132643, 3.1856677888657225],
            [16.27157268687316, 3.1835383996391515],
            [16.275448603029435, 3.1856183426958804],
            [16.277233346400955, 3.1825143184906546],
            [16.277301581765684, 3.1750930733312552],
            [16.281247064868577, 3.1715068087635503],
            [16.28214650232077, 3.165882200859975],
            [16.287073696171163, 3.16420003402285],
            [16.287599478538944, 3.151305324288289],
            [16.285272000120617, 3.145207406386341],
            [16.279987824739234, 3.1428708963247685],
            [16.279809931072162, 3.1389508637547143],
            [16.27494466833988, 3.131448095047273],
            [16.276571720128285, 3.125948331589013],
            [16.274663717739898, 3.1208736249747466],
            [16.28419854081896, 3.1151006239360255],
            [16.27537987484431, 3.1018650745121454],
            [16.263772366568393, 3.0854161246787766],
            [16.261776809074167, 3.0816794295880143],
            [16.246694796231132, 3.072642119772083],
            [16.238325584566226, 3.0653180744873927],
            [16.234833850440694, 3.058988169806526],
            [16.232944545160937, 3.051167375363145],
            [16.23277814109803, 3.0451568709427588],
            [16.230944802394667, 3.0389712402613696],
            [16.224236174874903, 3.0292245988919073],
            [16.217305982789807, 3.024641270757715],
            [16.211613192237937, 3.022657452663565],
            [16.205710799384793, 3.0192384730490174],
            [16.19469319549888, 3.009588432061576],
            [16.18808670320575, 3.0011972303810275],
            [16.186305865772663, 2.996158880060883],
            [16.18648466804691, 2.9888621644658806],
            [16.18908895005114, 2.9758120601338547],
            [16.19135518245112, 2.9695017263207846],
            [16.200028175375625, 2.9554296543965926],
            [16.200426932171645, 2.943539523850772],
            [16.19787415078612, 2.932388782829693],
            [16.196490152156972, 2.930293989567743],
            [16.194179484091762, 2.926435367054352],
            [16.190639103134664, 2.9243343626200224],
            [16.165685791676054, 2.9170124390411356],
            [16.161294973996014, 2.914694118610729],
            [16.155117792265276, 2.90558667574211],
            [16.147814449500622, 2.8975935553826284],
            [16.14356688758557, 2.900846381774176],
            [16.142713615762112, 2.905790725349188],
            [16.139841850436685, 2.9045256294849016],
            [16.128815620574528, 2.9038370335271346],
            [16.125153020168952, 2.898069098110286],
            [16.118345678173256, 2.900797579889779],
            [16.10786390946274, 2.898554201190317],
            [16.103603925070818, 2.9085348473366506],
            [16.106931267894147, 2.914737158072652],
            [16.11012258787631, 2.9277988047523715],
            [16.108732267409923, 2.9333217446498687],
            [16.111150372542806, 2.937498780398352],
            [16.108958330865235, 2.9454063524033187],
            [16.11050472356861, 2.950438118576749],
            [16.109984944532535, 2.9561641145701354],
            [16.114116429596447, 2.9577179375581455],
            [16.115284203024924, 2.9619071437272715],
            [16.111462137331745, 2.962821027737952],
            [16.10996740905999, 2.966755440746382],
            [16.10475543102345, 2.966883533834523],
            [16.101686425471073, 2.969874526665064],
            [16.099477255018222, 2.974708812203475],
            [16.100338986342443, 2.979834238126066],
            [16.099476736345384, 2.987041809097905],
            [16.08976755116221, 2.9872024559982084],
            [16.086322832245017, 2.9853496667792423],
            [16.08176117022724, 2.987852703871557],
            [16.078005451977905, 2.9879660639198904],
            [16.073216927178052, 2.99246931533978],
            [16.075586823550925, 2.995052925445875]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.13392668270266, "lat": 40.00765248840211 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42101"],
        "coty_name": ["Philadelphia"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Philadelphia County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01209187"
      },
      "bbox": [
        16.067672959085925, 2.8975935553826284, 16.287599478538944,
        3.1965205956333245
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.60776769933029, 4.342709091685529],
            [14.623517904278563, 4.343655319572958],
            [14.708889897472309, 4.351630979668414],
            [14.800134882870948, 4.360143143580888],
            [14.863817490869286, 4.366167485524526],
            [14.97700401751685, 4.377427395969121],
            [15.049321143473323, 4.384211098699397],
            [15.050048270185002, 4.367179216566104],
            [15.049738480914106, 4.353345293541932],
            [15.037784108103828, 4.213310486189577],
            [15.031677020391951, 4.1431551844465915],
            [14.967372806041553, 4.12794849934416],
            [14.96080760779566, 4.126508027460941],
            [14.938626289174463, 4.088208176798117],
            [14.898582434473639, 4.090001306282051],
            [14.882993929123064, 4.089587391941339],
            [14.861397611348298, 4.0901549395633054],
            [14.8613544084348, 4.092802503554766],
            [14.82696324220479, 4.094531311873974],
            [14.739830265159137, 4.144133938475485],
            [14.695289064716288, 4.168397271951883],
            [14.691867651595107, 4.170664198321922],
            [14.661787868240214, 4.2323346370916],
            [14.630718634195853, 4.295680309043829],
            [14.619550992864962, 4.318959526187282],
            [14.60776769933029, 4.342709091685529]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.5122253394097, "lat": 41.44614741859588 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42113"],
        "coty_name": ["Sullivan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sullivan County"],
        "coty_fp_code": "113",
        "coty_gnis_code": "01213687"
      },
      "bbox": [
        14.60776769933029, 4.088208176798117, 15.050048270185002,
        4.384211098699397
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.149562697205756, -3.534324060043206],
            [13.16027842380478, -3.5224483031475926],
            [13.162549894097742, -3.51728390827458],
            [13.166859764275689, -3.5005925149092447],
            [13.163344502974935, -3.4960842006318678],
            [13.163623818245268, -3.4919784390287267],
            [13.171533887239374, -3.4926294740392843],
            [13.179720357291707, -3.4699181944476702],
            [13.176324657550087, -3.458223500566316],
            [13.174355565153201, -3.4485149863167655],
            [13.1812803508375, -3.4454889412028304],
            [13.175980478155898, -3.4397438416913335],
            [13.171371527869345, -3.420684346154471],
            [13.164963813608669, -3.413716137013833],
            [13.176054743028446, -3.401893420644192],
            [13.177202734555202, -3.4029551479783824],
            [13.192673102083324, -3.398235149569144],
            [13.198729981433122, -3.3913225555320454],
            [13.206323727669995, -3.3857866388505102],
            [13.21295153424456, -3.386150745617763],
            [13.221899248521854, -3.3840920790166478],
            [13.23005570019495, -3.3837495418052974],
            [13.227683788202013, -3.375182748559944],
            [13.219736187776268, -3.366921040979228],
            [13.215657299362087, -3.360818425097148],
            [13.215403495699903, -3.3492389471916364],
            [13.231606652343563, -3.3465670847513587],
            [13.241161541773955, -3.346225289870682],
            [13.246681374579383, -3.3443097427285347],
            [13.245037586756684, -3.3395406868232995],
            [13.271985946203273, -3.314752410075794],
            [13.27907866290546, -3.3214496853171975],
            [13.281682374941965, -3.325783083424182],
            [13.28375288613574, -3.3249952472928106],
            [13.291310828367429, -3.3265896159009105],
            [13.294037477993324, -3.3309725739601346],
            [13.298115035500485, -3.3297108219957905],
            [13.300065486050084, -3.3334283876561583],
            [13.304816432604719, -3.333176147927901],
            [13.31246583329183, -3.3416101629637476],
            [13.315312144530578, -3.348010840745498],
            [13.342716668050898, -3.328532376711391],
            [13.350225162279326, -3.299076712889904],
            [13.355008377822417, -3.2970044932922593],
            [13.361673786617294, -3.297654955232116],
            [13.370112267390128, -3.3369843014108915],
            [13.372732835955212, -3.338534228003979],
            [13.374835953868597, -3.34476234909839],
            [13.377008467106705, -3.347705588642714],
            [13.381077396726527, -3.349676398982251],
            [13.381772800745525, -3.355427430727868],
            [13.38563271518021, -3.3590105229588216],
            [13.391839734367126, -3.36208286800525],
            [13.393251234923984, -3.364884190206947],
            [13.398661774783495, -3.36895611527507],
            [13.409113460844974, -3.372999291982408],
            [13.412680761912256, -3.3796474932691694],
            [13.410826823818281, -3.3850720292879704],
            [13.424229847455484, -3.4021786993155585],
            [13.423308433320287, -3.404749774091532],
            [13.437636722966216, -3.425271484646529],
            [13.442130421210454, -3.4567479548876916],
            [13.422371944904851, -3.4826090793993907],
            [13.41093707537713, -3.4980998289883476],
            [13.41536223454208, -3.5006757262061994],
            [13.417197561594607, -3.505718354974418],
            [13.420589014688582, -3.507602686434608],
            [13.421093814207191, -3.5114203665655954],
            [13.425980154043186, -3.51564714784204],
            [13.42751076671404, -3.5150634747537945],
            [13.432221382058007, -3.5197407136699326],
            [13.43400990876692, -3.5243705838810753],
            [13.438432428972531, -3.5270947269909807],
            [13.439703128580128, -3.529676748186521],
            [13.447201906174644, -3.532316398134667],
            [13.447613144980387, -3.534607430515118],
            [13.452981430249322, -3.5355458026795503],
            [13.461370830083167, -3.538871682996012],
            [13.467293593629757, -3.5444373231812336],
            [13.47105034214825, -3.5453442611023007],
            [13.471894227186551, -3.5491045069428115],
            [13.474613958296837, -3.5521496236301795],
            [13.477851671699346, -3.550130726166765],
            [13.483043009864389, -3.5578760313224267],
            [13.487514726404394, -3.5589431753288414],
            [13.489887089291956, -3.5618363404352023],
            [13.495437545316209, -3.560811524447115],
            [13.498025089536517, -3.560158278818335],
            [13.500807122106915, -3.5638469531987385],
            [13.50565911842322, -3.5641726285893216],
            [13.50670486689716, -3.5661450864685627],
            [13.511832990139922, -3.5635033820852158],
            [13.518848178719502, -3.5665705647045005],
            [13.520986710946548, -3.564293124805409],
            [13.52777178756106, -3.564922815235925],
            [13.528451806092999, -3.5674476266159],
            [13.533236090172185, -3.5676443943130365],
            [13.534134313089952, -3.569828240165428],
            [13.539386005424989, -3.573193412957901],
            [13.54008501239459, -3.57690635542145],
            [13.546504340386713, -3.5786258234643613],
            [13.553019305096928, -3.5815904234950753],
            [13.552557501854007, -3.5841444367303525],
            [13.558048706578791, -3.589296889146766],
            [13.552176106521877, -3.6086052501430532],
            [13.543465464423978, -3.6318887180001056],
            [13.508200365570739, -3.638486931135724],
            [13.499423151367923, -3.6478841734946843],
            [13.482184531720687, -3.663662710105933],
            [13.440139193248918, -3.7015553983644636],
            [13.428288522319518, -3.7089496452469297],
            [13.426669668750398, -3.7009651113511026],
            [13.424408229011647, -3.6963924277954003],
            [13.422716574943056, -3.686471518600435],
            [13.41938610462691, -3.678271837022411],
            [13.415944166625694, -3.6733593601038264],
            [13.415276051719902, -3.6627046004038095],
            [13.413030533998143, -3.657550629751413],
            [13.3707949062026, -3.678191657256635],
            [13.365238329085475, -3.67855042265099],
            [13.36190862158637, -3.6761507211087214],
            [13.358576087238946, -3.6688426901604068],
            [13.358387671262559, -3.6656515952568056],
            [13.354264906316654, -3.6601960382462084],
            [13.354426442973839, -3.6534669990559565],
            [13.35303518889341, -3.650359216251927],
            [13.348272919558053, -3.6462935474876685],
            [13.342478071119544, -3.638576618713539],
            [13.320772248039928, -3.637770523206374],
            [13.310093250854761, -3.6160410254111164],
            [13.31008780742105, -3.615299731622869],
            [13.297718438062565, -3.6029181482578836],
            [13.292269266632529, -3.6007936835560828],
            [13.253473563432664, -3.6064494243041962],
            [13.245978234207978, -3.6081186282971713],
            [13.23082748810244, -3.6016656691561217],
            [13.224148418704521, -3.6110479361996006],
            [13.221402085396651, -3.610553692442748],
            [13.18468894371234, -3.5983096450434457],
            [13.157564652273942, -3.5901664397365445],
            [13.156285310714747, -3.57724634525535],
            [13.153304825311325, -3.559508935391408],
            [13.149562697205756, -3.534324060043206]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.25449909397571, "lat": 34.16335665505131 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45061"],
        "coty_name": ["Lee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lee County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01245652"
      },
      "bbox": [
        13.149562697205756, -3.7089496452469297, 13.558048706578791,
        -3.2970044932922593
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.359312100304258, -3.7538744517644056],
            [12.361026672888126, -3.75093112715864],
            [12.361007925941554, -3.745639612186426],
            [12.362746876772311, -3.7421562424688455],
            [12.367918998979587, -3.744650866714864],
            [12.381284153535189, -3.749138356378668],
            [12.384209393661553, -3.748165815776569],
            [12.392161824605763, -3.7417482464715506],
            [12.396674489799194, -3.7413881146056025],
            [12.401023663005216, -3.7440412199600965],
            [12.406174731440052, -3.7490590347965176],
            [12.414803981472284, -3.749482819127618],
            [12.41636969913402, -3.750894354621701],
            [12.4233585442172, -3.7490961110866317],
            [12.425990103806953, -3.7449144174881184],
            [12.426905343738873, -3.740609276895757],
            [12.421021174522249, -3.7356458795199337],
            [12.418752401192902, -3.7351214610032764],
            [12.41501323476702, -3.7297243947752303],
            [12.412071073998064, -3.7277684133757893],
            [12.41184571056962, -3.724058748906904],
            [12.407694609723299, -3.7242572422480777],
            [12.398782649220767, -3.7139528552731904],
            [12.394629615675385, -3.7143972757958124],
            [12.3947966943868, -3.7087893533364515],
            [12.389606070624284, -3.707685202523236],
            [12.384742670591816, -3.704477940479897],
            [12.380895598079587, -3.697291928318685],
            [12.37936891005721, -3.6964445638455117],
            [12.399177704230254, -3.6446309304502953],
            [12.412763599478104, -3.643674873402822],
            [12.422452504469302, -3.6398787029750665],
            [12.432752597795838, -3.6280486927132527],
            [12.437902043663323, -3.6194906871871053],
            [12.448620513935708, -3.616914123386008],
            [12.453478163601986, -3.618813737364116],
            [12.457481165518004, -3.622837763671344],
            [12.464360772094901, -3.623518892940837],
            [12.466632707384127, -3.6262714076345985],
            [12.470149691105478, -3.6244432927758616],
            [12.483840772660647, -3.647262168426174],
            [12.477467408284632, -3.656324780194282],
            [12.476000417465354, -3.665025031320205],
            [12.47931229872475, -3.669559465120513],
            [12.499994847572127, -3.690792931892905],
            [12.502131864334945, -3.6900805707398994],
            [12.515384503033879, -3.708522036645798],
            [12.520592964282214, -3.7053987928901657],
            [12.529114146033564, -3.701752182165957],
            [12.540706116716958, -3.699668720689324],
            [12.557528941695677, -3.698485640363746],
            [12.57195797707554, -3.6989817921324253],
            [12.578716977347801, -3.6997715487545304],
            [12.593802603823178, -3.703221759995856],
            [12.600046712018568, -3.7023315640971783],
            [12.600541807699477, -3.705208889872058],
            [12.61119421498731, -3.70919288693604],
            [12.618303242845572, -3.712544610040941],
            [12.630809245590692, -3.7200073266466678],
            [12.644177289754062, -3.73073041155839],
            [12.653100777395574, -3.7400427006393753],
            [12.661661879715576, -3.7512973973612223],
            [12.666684600326347, -3.7601888615879133],
            [12.670323574756063, -3.7598612930068116],
            [12.672595458210159, -3.764660644406598],
            [12.676850806839022, -3.7674165233203185],
            [12.682538973989283, -3.767277055144384],
            [12.687833449984431, -3.768519600772026],
            [12.693844683882753, -3.772901839543325],
            [12.698939223758344, -3.769622089888494],
            [12.710161943226279, -3.7762523752453228],
            [12.718867842225213, -3.7878644739378324],
            [12.721172256475986, -3.799087616914745],
            [12.72847539776945, -3.806654614434762],
            [12.731549765943623, -3.811749767843124],
            [12.751835214388318, -3.840836426694006],
            [12.752463370818232, -3.8458260114090557],
            [12.751417183616887, -3.8507757223639922],
            [12.744188375785294, -3.856706374342932],
            [12.745092407448285, -3.861059694949064],
            [12.750625579179037, -3.8630334669958666],
            [12.75766153774886, -3.8630240091478982],
            [12.76278697928295, -3.8663288284717847],
            [12.76190504482278, -3.872544990220444],
            [12.756951805574857, -3.8749459293592987],
            [12.755254941450534, -3.8785176526655976],
            [12.755012816598594, -3.8838747911618707],
            [12.758468215354776, -3.8893447549361935],
            [12.763678036523201, -3.890636309359942],
            [12.744319765150427, -3.903079826444436],
            [12.743206721861679, -3.915493328261958],
            [12.748147157145732, -3.9294960334151385],
            [12.748119386300585, -3.9702553296110445],
            [12.749193379477257, -3.9770612372825864],
            [12.749348951730932, -3.9851570207368514],
            [12.742752092575113, -4.005138850694962],
            [12.7430122093325, -4.0135073703088695],
            [12.747063599220203, -4.028627573428215],
            [12.765614713489816, -4.027565940630479],
            [12.765293372509907, -4.008445026732284],
            [12.773041351619973, -4.007813546333072],
            [12.772219317990398, -3.998057279716306],
            [12.778581932410063, -3.995187468140902],
            [12.777950852990294, -3.9889526644134046],
            [12.816900031312418, -3.9868962910886108],
            [12.820656938101141, -3.9844983013711626],
            [12.826915162648467, -3.98645906862137],
            [12.831237986807814, -3.9898267089900696],
            [12.840214960487588, -3.9913757641027776],
            [12.846068761644224, -3.9948405373416698],
            [12.853478942348607, -4.003045925858002],
            [12.847124360316364, -4.006617737639242],
            [12.842618709893879, -4.007994443680991],
            [12.838763406873435, -4.011788732937976],
            [12.832318812326028, -4.024495437777581],
            [12.825413438143698, -4.026619270373909],
            [12.81789688432771, -4.031479945745962],
            [12.8149544944343, -4.0347223852819605],
            [12.806391292123593, -4.035522705473662],
            [12.803655460707446, -4.034798460697219],
            [12.798160310212817, -4.041302406305084],
            [12.78321632952498, -4.05050074578577],
            [12.766138986477722, -4.066222370951705],
            [12.733780481191822, -4.082634031063341],
            [12.715787869647182, -4.096082108127679],
            [12.657091207673492, -4.138534653240006],
            [12.656795280381264, -4.138562726986061],
            [12.654440524487232, -4.136419057730411],
            [12.64258865456397, -4.134127510160913],
            [12.639437114356873, -4.135242088273624],
            [12.634952843084408, -4.13160084194664],
            [12.630286454623738, -4.1313474832281285],
            [12.62642133592881, -4.127899785895175],
            [12.618524428889405, -4.127141083422683],
            [12.615929536005536, -4.123969305380963],
            [12.611994944910967, -4.123082033371903],
            [12.60635282701514, -4.119493051407411],
            [12.599701105900879, -4.11832976469339],
            [12.59498199330728, -4.115826376137239],
            [12.587563490781873, -4.114626151848937],
            [12.584089188653211, -4.112063355600047],
            [12.58326666086846, -4.109171619517172],
            [12.57854529215622, -4.106848686510697],
            [12.575221381709893, -4.10947220385139],
            [12.570004512849327, -4.111278871979957],
            [12.558739315577958, -4.107137410372583],
            [12.55463405253593, -4.102822071630519],
            [12.551510823170533, -4.102820581109914],
            [12.546723489792097, -4.099030822342673],
            [12.536972022575974, -4.097924271479906],
            [12.532275299906665, -4.094718533146398],
            [12.528263083216967, -4.094693503353599],
            [12.518052920047793, -4.090929004599562],
            [12.513772511650759, -4.092114093372612],
            [12.507073591105707, -4.090787106274095],
            [12.49858445788059, -4.0863673131363445],
            [12.491606277767382, -4.0911795021399735],
            [12.479917696317756, -4.090616929772217],
            [12.477259064769587, -4.091327687053098],
            [12.467913541739193, -4.08728422186627],
            [12.462195489767605, -4.089411256932038],
            [12.455807153471724, -4.086925037944123],
            [12.446865782116179, -4.077748960667053],
            [12.447745556291965, -4.0756908412888055],
            [12.444330777220587, -4.0693547538585095],
            [12.441154025060062, -4.065668885077986],
            [12.439295780014502, -4.054339589405238],
            [12.435080503784597, -4.048666202958733],
            [12.429136127924142, -4.045708144452769],
            [12.418485691272004, -4.035146070027044],
            [12.412861608899442, -4.031769574696628],
            [12.402457509769777, -4.029006500939288],
            [12.399755500692741, -4.030518730019272],
            [12.395760723064887, -4.027187648139884],
            [12.392095536568874, -4.028131804246881],
            [12.386259356090166, -4.026174948822363],
            [12.383206796803142, -4.021831444216971],
            [12.375476513322626, -4.024505696607344],
            [12.372626008806343, -4.021436279115742],
            [12.367131963277723, -4.020912025300496],
            [12.365096245021094, -4.017852713672894],
            [12.361320561589848, -4.016747572685794],
            [12.35867585891775, -4.01082999873894],
            [12.352195099952972, -4.005918528684365],
            [12.346649465675958, -4.004446248332649],
            [12.345084031247598, -3.9992241976411087],
            [12.337456634316652, -3.9907415993321824],
            [12.337638290224003, -3.985660824761487],
            [12.331650287517604, -3.9796953885272695],
            [12.31912599778774, -3.977186482683268],
            [12.311553519556611, -3.969383535128463],
            [12.308814966025555, -3.9642370896535195],
            [12.308795543260329, -3.9544672975985478],
            [12.311247348658663, -3.9486706820776525],
            [12.320656127103904, -3.912047303543934],
            [12.32983483164475, -3.8712948477106215],
            [12.34735097186305, -3.8056018803751335],
            [12.355281077171094, -3.7745250305108438],
            [12.359312100304258, -3.7538744517644056]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.27222214835903, "lat": 33.9022718423837 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45063"],
        "coty_name": ["Lexington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lexington County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01244251"
      },
      "bbox": [
        12.308795543260329, -4.138562726986061, 12.853478942348607,
        -3.616914123386008
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.893095132186824, -3.3448146785081354],
            [13.893554907727976, -3.3415201649568234],
            [13.888907275157852, -3.336156126006948],
            [13.885067444101695, -3.329167848111722],
            [13.890223520142206, -3.3270453848099333],
            [13.895277600749807, -3.3265419257400786],
            [13.908496530815576, -3.321009702730559],
            [13.909272531357676, -3.3144122405958076],
            [13.915705856934487, -3.3142228627022647],
            [13.91954627964358, -3.3110912140321944],
            [13.92330273459671, -3.304468129326347],
            [13.927179928794745, -3.294006973125843],
            [13.932466442285344, -3.2903687142770917],
            [13.940401967628969, -3.2878327832236907],
            [13.937446904875355, -3.278659771818324],
            [13.943054974241003, -3.2772310784172802],
            [13.945497047078677, -3.2747012497325234],
            [13.948488452310164, -3.2757896709694236],
            [13.978786292521056, -3.26477690353974],
            [13.991580575744369, -3.256796617717703],
            [14.016351334282026, -3.2520228560691486],
            [14.029780070322024, -3.2544885662101173],
            [14.082291198103155, -3.2723150897742794],
            [14.089806579819163, -3.263127156938045],
            [14.093259204140297, -3.2650892652944767],
            [14.100273133258245, -3.265648822437593],
            [14.105336818251262, -3.268026684834496],
            [14.109279094190416, -3.26707131364705],
            [14.121119212971978, -3.2759272937276482],
            [14.124069374934194, -3.2743053730486453],
            [14.12830405473054, -3.276411244665257],
            [14.138170127714746, -3.277690040421721],
            [14.146681837650188, -3.272356808151684],
            [14.15357053086002, -3.270401342765651],
            [14.158242328466178, -3.272890876790382],
            [14.185537880261107, -3.2353167328883377],
            [14.225511362099489, -3.260929717212877],
            [14.228129269796959, -3.2623346805009517],
            [14.23022136005026, -3.2674526048277523],
            [14.2269594392784, -3.276438696040066],
            [14.23109931221458, -3.2803096383280117],
            [14.232126420931227, -3.285037500025783],
            [14.227283238003288, -3.2840075665986075],
            [14.228929316801883, -3.2988598539573326],
            [14.225825208012605, -3.3015436966551026],
            [14.224796692642048, -3.30837387597322],
            [14.21897670779394, -3.3118008303069826],
            [14.215576311837745, -3.3120573742559856],
            [14.214544177269063, -3.3169457187811515],
            [14.211489931079257, -3.3217038194876873],
            [14.208925845868135, -3.3231668111939037],
            [14.20595985215507, -3.3398084849539935],
            [14.200981353504785, -3.3375743237085183],
            [14.198919429710859, -3.341453136741909],
            [14.196107582733696, -3.3423056477234985],
            [14.194092718841707, -3.345941794342833],
            [14.190555175008122, -3.348000737336313],
            [14.190867296390593, -3.353210269432996],
            [14.187588297708762, -3.3565810309401303],
            [14.189820664600555, -3.3637882030217625],
            [14.183931094378371, -3.3753007747766035],
            [14.181682223583506, -3.375959132635231],
            [14.184918299936419, -3.3845323035531565],
            [14.18685681703539, -3.3930514751910352],
            [14.185139055344766, -3.3983248528316485],
            [14.179169298412171, -3.3992709979699005],
            [14.17675163185257, -3.4060297171346146],
            [14.176597450297594, -3.415183830738227],
            [14.179769818191856, -3.4153198355654855],
            [14.179084106608153, -3.420215714699925],
            [14.17145545687893, -3.4204764725150634],
            [14.169272717933756, -3.4290797239595867],
            [14.165561327229893, -3.4300454972916734],
            [14.162922999794825, -3.4335349307500866],
            [14.163018172787126, -3.4379174469027634],
            [14.158510284631717, -3.4416266372257147],
            [14.161696522175967, -3.444400054319239],
            [14.160056709365154, -3.446775789037486],
            [14.164577457404809, -3.4531757926943367],
            [14.168878968417598, -3.4519173513819172],
            [14.168274543962351, -3.4627890199107796],
            [14.164244393450742, -3.465052353945919],
            [14.166313914910724, -3.4742498454376998],
            [14.15843617798014, -3.4787412414577332],
            [14.15953747360075, -3.4819617278769672],
            [14.151283605201783, -3.4902067193002138],
            [14.147256119587434, -3.4909431206939083],
            [14.144883557524732, -3.4959487391744895],
            [14.141088470281119, -3.4980010887952804],
            [14.1380086969883, -3.50381001365117],
            [14.132684903176344, -3.502038890891168],
            [14.131073309964401, -3.5047321436199512],
            [14.126507076123097, -3.506711923551055],
            [14.12723089851828, -3.5096827151846908],
            [14.123237206335599, -3.5136536624190366],
            [14.126622557820996, -3.516281651330577],
            [14.127058474515934, -3.522613761165447],
            [14.125772610092268, -3.5345128672039587],
            [14.122268029644237, -3.5397407727071837],
            [14.112270564767847, -3.543989856760091],
            [14.108660747005585, -3.547888351355497],
            [14.109969756774731, -3.551411120976038],
            [14.112413777296716, -3.56356712305892],
            [14.109195430800112, -3.5687124545969255],
            [14.10830465390304, -3.574889081357711],
            [14.116364420410896, -3.583770133637216],
            [14.115296852255799, -3.5898931657441646],
            [14.12076642317684, -3.589160664395334],
            [14.12440337795464, -3.5921149375812806],
            [14.13449107283493, -3.595203658786606],
            [14.132699820387998, -3.598469055504936],
            [14.133805991812462, -3.6057045280687556],
            [14.139063641542554, -3.6050329709105786],
            [14.137447216872369, -3.60924062384976],
            [14.138465397696622, -3.612511956978953],
            [14.138465588867806, -3.6210111671879246],
            [14.146330740639545, -3.6239643510166797],
            [14.151179792437395, -3.630153357612317],
            [14.154966648528935, -3.6322598442330936],
            [14.154816559675872, -3.636019817725226],
            [14.158869114431942, -3.6356068198782916],
            [14.163581060406818, -3.6400344646830565],
            [14.16547057524162, -3.6388640563431465],
            [14.165295082532493, -3.6341334252090647],
            [14.174765336378904, -3.636614527094484],
            [14.177394850389456, -3.638728363683475],
            [14.182546988906008, -3.639504745047085],
            [14.183425085730626, -3.645622044419213],
            [14.189123192530237, -3.6547218545385625],
            [14.191598289867338, -3.6572129707814773],
            [14.192679991108237, -3.666853619693307],
            [14.19117683004845, -3.674250227363821],
            [14.193577221865517, -3.68099117087843],
            [14.192707336875554, -3.6868802111883],
            [14.190974961050992, -3.6890043661572918],
            [14.194217631596114, -3.6925363823601534],
            [14.201304720032267, -3.6935657124701504],
            [14.202404744473554, -3.698148977971868],
            [14.205525272822655, -3.6994569161222737],
            [14.202969485540503, -3.703985205497399],
            [14.199054896451605, -3.704729652851909],
            [14.19773966997061, -3.711975843707276],
            [14.198935775993682, -3.715845533569656],
            [14.202773470105354, -3.7176113078184243],
            [14.206229387301697, -3.7213071235622595],
            [14.205008368396747, -3.726367802286746],
            [14.208640895769918, -3.7266985007546523],
            [14.207881511401865, -3.7312238079902977],
            [14.214209754607872, -3.7442105249863906],
            [14.219975043755191, -3.750101889509011],
            [14.224108145598919, -3.7516182679032037],
            [14.228245850694348, -3.758466240531812],
            [14.228001143148068, -3.7621975192254684],
            [14.233122713708838, -3.7636673609407865],
            [14.23449846380835, -3.767523821604559],
            [14.243658108547573, -3.768902361137434],
            [14.243327091869505, -3.773409681625947],
            [14.250611848198155, -3.7813216415217985],
            [14.252826944202596, -3.7807892692543694],
            [14.26068887647902, -3.786917098650123],
            [14.266620548879358, -3.792596124060656],
            [14.270679958899116, -3.7987250235318704],
            [14.26931363393642, -3.803597613770572],
            [14.270217861492709, -3.808998442825231],
            [14.275117906914067, -3.8136428143514127],
            [14.268728337853632, -3.819521044004341],
            [14.265095428872312, -3.8182093964191663],
            [14.258681588053722, -3.8207067273483757],
            [14.254619709758611, -3.8183929916046955],
            [14.253750739714572, -3.8222881441189402],
            [14.245183136960952, -3.8265059551664096],
            [14.241017557587965, -3.8315088387600538],
            [14.231331427911325, -3.8320957838848297],
            [14.228665197517882, -3.830907764496509],
            [14.229588686703131, -3.826821800942028],
            [14.233737001891301, -3.8253719505804384],
            [14.230708921417651, -3.8216207827290085],
            [14.22715145512288, -3.824593694328621],
            [14.22049246290439, -3.8264727921250157],
            [14.214229235277275, -3.824258199579764],
            [14.213549148921278, -3.820016149451711],
            [14.209993343988964, -3.8200164710848705],
            [14.205631468296811, -3.822873845830443],
            [14.204766663074473, -3.8174467814708417],
            [14.208407611230317, -3.8142549017837437],
            [14.20574853797367, -3.8096044757054153],
            [14.19792181059218, -3.8169735616114115],
            [14.194833581863003, -3.8158624180013234],
            [14.192267671149594, -3.81026525140656],
            [14.188654665221248, -3.8053374142549847],
            [14.18820335196977, -3.8019355548591225],
            [14.191503334802636, -3.796252755641061],
            [14.184557939661888, -3.7936477338406025],
            [14.18410645646743, -3.78451704210261],
            [14.181585429654167, -3.780720282577911],
            [14.177918326365118, -3.778612818910672],
            [14.169818632381807, -3.770650821355227],
            [14.16706003113959, -3.7652766749839857],
            [14.158997718528932, -3.7586341518449737],
            [14.155889427682737, -3.7535124162238884],
            [14.152372663679015, -3.7507587002561626],
            [14.154363650883663, -3.7485995489531816],
            [14.150700650222515, -3.7447007224040725],
            [14.149702277040431, -3.7406325980363397],
            [14.151679279910116, -3.7362228230849515],
            [14.156219698578028, -3.7314562024406044],
            [14.154910532313885, -3.721749329101031],
            [14.150080705813528, -3.7195474831453526],
            [14.149272073529918, -3.713776330029371],
            [14.146462417388543, -3.7090309624526703],
            [14.140682643541274, -3.7120319404468414],
            [14.1336368170072, -3.7093461549421156],
            [14.131055309330895, -3.70166672008152],
            [14.125382879154637, -3.7005507217988307],
            [14.118993890225028, -3.7048022216421863],
            [14.114684103936854, -3.702676083714802],
            [14.106258170426536, -3.7035853093996915],
            [14.103181194764497, -3.7007867984261833],
            [14.09934631983381, -3.694832566925815],
            [14.09553222185881, -3.692775298451221],
            [14.092349012198076, -3.6886628920342064],
            [14.08897080988139, -3.6873299013214225],
            [14.084617015183067, -3.682752805581682],
            [14.083762156775466, -3.676653517613962],
            [14.07751151691926, -3.6757455410317856],
            [14.074301616244398, -3.6703661703058894],
            [14.067928663482881, -3.6700824054746364],
            [14.065154463992483, -3.6675804898938393],
            [14.071679140605786, -3.663215065097091],
            [14.070730736604478, -3.658929838639425],
            [14.061701547202576, -3.660989791043051],
            [14.047419085107196, -3.657921472616978],
            [14.043859380208527, -3.6522605591812387],
            [14.040497537237748, -3.653028957286608],
            [14.036916280123712, -3.6485792651507007],
            [14.0291570176594, -3.647351987399764],
            [14.025615773591278, -3.6443720366288073],
            [14.026691962763396, -3.6386724202735143],
            [14.024065745533829, -3.634628268110437],
            [14.017351555221767, -3.634542708947011],
            [14.013970158931693, -3.6291270160060387],
            [14.010390687638106, -3.6334728522651134],
            [14.00554662803153, -3.632384576289603],
            [14.003717247377164, -3.6277673443013065],
            [13.99696775324337, -3.6261673115029907],
            [13.993266957695, -3.6217583074538613],
            [13.988046190120158, -3.618610667077075],
            [13.986749663950821, -3.6126338967342213],
            [13.992580584112833, -3.604225416468185],
            [13.993169253813083, -3.5991667553012205],
            [13.988604992428728, -3.59592968635771],
            [13.980535669365592, -3.596715946780068],
            [13.977199186768006, -3.59524899894226],
            [13.970996599478976, -3.5882539869133634],
            [13.966482725395773, -3.5803312156402],
            [13.959336745534829, -3.575184906014597],
            [13.960247314490433, -3.571149249672762],
            [13.962855617379526, -3.5682581627979397],
            [13.963636206469575, -3.561781524152309],
            [13.95923199226118, -3.5550079849748957],
            [13.959845493881083, -3.5487605286849955],
            [13.955401468507857, -3.5361862288109145],
            [13.956312654942957, -3.530827843214049],
            [13.953669019701287, -3.5262085704212383],
            [13.95331403584156, -3.5223651939971163],
            [13.949979667196514, -3.5218465970235417],
            [13.944950449364535, -3.514860802263473],
            [13.944349954959424, -3.510092312307448],
            [13.939287800836683, -3.508346853044113],
            [13.939048695981144, -3.5039194882754456],
            [13.936791716082974, -3.500520649541433],
            [13.930464719064906, -3.4989957163386283],
            [13.930343708874878, -3.4952971373495596],
            [13.933705956330803, -3.492590041117039],
            [13.930589437705098, -3.4775873839920184],
            [13.931047494999639, -3.471626738260854],
            [13.942189456368505, -3.4715242511589084],
            [13.938164409780189, -3.468150610355556],
            [13.94191501388989, -3.4643904486445583],
            [13.93699693598966, -3.463356176212018],
            [13.937562744733995, -3.459088856485497],
            [13.934309593091585, -3.458741611908083],
            [13.93217764644205, -3.4529270091821194],
            [13.936032543166522, -3.443673008557521],
            [13.93433325541798, -3.442439353138643],
            [13.928366953771112, -3.447030934801102],
            [13.923754049515606, -3.446287820856803],
            [13.922033677998536, -3.442658869091532],
            [13.922515741781453, -3.438935149104406],
            [13.920539775939588, -3.436140171608463],
            [13.914121727986023, -3.434840830006983],
            [13.910995214834848, -3.4306779967504646],
            [13.910058877724289, -3.422754600355792],
            [13.908289584093195, -3.4209495717802385],
            [13.899358144422946, -3.4166454695988424],
            [13.892348766800772, -3.407086194707892],
            [13.885758954869466, -3.40310867976614],
            [13.881963165885521, -3.3949858183354955],
            [13.883089576474124, -3.3878870023403374],
            [13.889344564672994, -3.378618106945171],
            [13.896007329572418, -3.3744888235706076],
            [13.898363111186143, -3.3644282618626464],
            [13.898192880001009, -3.355401761116865],
            [13.897232984015412, -3.349941676786812],
            [13.893095132186824, -3.3448146785081354]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.3624812981273, "lat": 34.080098771919296 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45067"],
        "coty_name": ["Marion"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Marion County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "01248010"
      },
      "bbox": [
        13.881963165885521, -3.8320957838848297, 14.275117906914067,
        -3.2353167328883377
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.56602029456761, -1.66400075805306],
            [8.611029002213094, -1.6605723122319063],
            [8.654013654563341, -1.6582061439249378],
            [8.754100111857024, -1.6496975201035344],
            [8.804068408187419, -1.6449117835608063],
            [8.844699097212882, -1.6368069160384657],
            [8.84963666805424, -1.6358204002571692],
            [8.92502940333219, -1.6233050983633641],
            [8.932329455373296, -1.6208585084919906],
            [8.951499764523577, -1.6188093364738303],
            [8.954858398866412, -1.6170065776759353],
            [8.970311191429019, -1.6145746894835407],
            [8.970989553731693, -1.6233683015511353],
            [8.968010476503851, -1.6299262668514898],
            [8.969120026482551, -1.6334121424926213],
            [8.97197769396187, -1.633907122034503],
            [8.973951213163616, -1.6551665659797374],
            [8.983663863899118, -1.6671661485905918],
            [8.976966280342165, -1.6859707379806452],
            [8.977577434877622, -1.689003042232256],
            [8.974947138957216, -1.6940668414205173],
            [8.975168576791084, -1.7027510686854102],
            [8.973561912031244, -1.7074256309764313],
            [8.974341245267267, -1.7108196860940297],
            [8.968941826115296, -1.7110415908253869],
            [8.96843037925279, -1.713670721922343],
            [8.963157566221001, -1.7163018887922143],
            [8.96403236065661, -1.7210327588354926],
            [8.950182233026167, -1.7173020229323344],
            [8.932782213418776, -1.71901253670277],
            [8.91499301404584, -1.7295126356117656],
            [8.911335444822765, -1.7359072933001984],
            [8.908252462912793, -1.7367469088582346],
            [8.901173075856095, -1.7432081105986559],
            [8.894130775999479, -1.7459023779344074],
            [8.90193382017127, -1.756346068086398],
            [8.901370898414367, -1.762204903591048],
            [8.894099253178172, -1.7597402410589795],
            [8.887171623676918, -1.7612490701911216],
            [8.883915724691317, -1.7586801169545954],
            [8.88483304362685, -1.7551516938996345],
            [8.89213846895776, -1.747298334468195],
            [8.870000812870398, -1.7525142370636708],
            [8.867086324769888, -1.7521229575253494],
            [8.855967790868656, -1.7547751052192688],
            [8.850332316616065, -1.7585833043896297],
            [8.845612909050992, -1.7649855735940898],
            [8.843892748376913, -1.7756648866563793],
            [8.835182036576699, -1.78875721329638],
            [8.827212675490275, -1.8054823683271497],
            [8.82270682372789, -1.8332058596845309],
            [8.821745653187754, -1.8513294989641589],
            [8.822079566015177, -1.8580644710442475],
            [8.814071524295406, -1.854161883574339],
            [8.809674912854877, -1.8496180043083823],
            [8.806804324170223, -1.8444450799762369],
            [8.801111999390118, -1.839895016606673],
            [8.800598008029358, -1.8369998975530821],
            [8.792527968152179, -1.8301288603212866],
            [8.79086829393158, -1.8263695901719148],
            [8.778567437374981, -1.8200298166224536],
            [8.764111158999823, -1.806833239814928],
            [8.75946788686239, -1.791739509396451],
            [8.757247573864609, -1.790855310770471],
            [8.750681119189123, -1.7963737656147891],
            [8.7392091604901, -1.7935315114544474],
            [8.732452766067079, -1.793433350698254],
            [8.72444043507717, -1.791273750343457],
            [8.7234664632048, -1.7888622054317287],
            [8.718040226082504, -1.789429935589049],
            [8.710520170885511, -1.7883152994138245],
            [8.697403075650024, -1.7830994428420177],
            [8.675638677297904, -1.779813989788581],
            [8.652882857204517, -1.782355926687878],
            [8.65043539441271, -1.7803292884795734],
            [8.651970467414067, -1.7759115449763714],
            [8.648832282201452, -1.7744319735161929],
            [8.648723108303916, -1.7677195153667937],
            [8.645059547200464, -1.7640355442150484],
            [8.64369080645594, -1.7565342859065127],
            [8.618494556344752, -1.7627827258006576],
            [8.634941360839465, -1.7789739578518036],
            [8.637124933727431, -1.7824983567407922],
            [8.607040514083454, -1.784201857104984],
            [8.594356757314706, -1.7671562588981236],
            [8.559259847205558, -1.788926900922271],
            [8.559364915622904, -1.7716183623868689],
            [8.558868669737006, -1.7351784177185923],
            [8.55921092113661, -1.731639133622353],
            [8.560758566279576, -1.6823463739521634],
            [8.560714722686143, -1.6730011702042482],
            [8.56720821177095, -1.6705190569649193],
            [8.56602029456761, -1.66400075805306]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.54388662751056, "lat": 36.55111531058657 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47027"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01648573"
      },
      "bbox": [
        8.558868669737006, -1.8580644710442475, 8.983663863899118,
        -1.6145746894835407
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.966319441083563, -3.13699635425831],
            [5.964861512452527, -3.101054530497316],
            [6.048473792032745, -3.096411709934071],
            [6.186578205952355, -3.0888492421672575],
            [6.239846156294107, -3.0858704072138115],
            [6.2427935183712995, -3.129472315474519],
            [6.256070790863038, -3.1420037612417837],
            [6.261958133795982, -3.148293092797938],
            [6.281587021350574, -3.1728299877822943],
            [6.284725869480538, -3.1821543004274844],
            [6.284992140774864, -3.187435432915911],
            [6.301449403157091, -3.2627990401695275],
            [6.301833831273002, -3.263251622018057],
            [6.307063210002155, -3.383517996666713],
            [6.3129041096750695, -3.46212692141819],
            [6.317235935829962, -3.5120072878379545],
            [6.317221874903126, -3.516890598977505],
            [6.287717937047429, -3.5192195730425095],
            [6.265054351061265, -3.521000866707888],
            [6.235883332572271, -3.5223990768129703],
            [6.2049685912831904, -3.5257421234045467],
            [6.1305296762288, -3.5311423754268434],
            [6.031847106356529, -3.538949507502817],
            [6.017431371180028, -3.5403963522748367],
            [5.983800402242607, -3.5422468502892053],
            [5.9812077562666905, -3.4797397233010194],
            [5.979596297624909, -3.4368317215611977],
            [5.976041682890315, -3.3580587620885853],
            [5.972628537132343, -3.283948321898087],
            [5.968371369503634, -3.190258227887196],
            [5.966319441083563, -3.13699635425831]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.99309775418699, "lat": 35.20682535304653 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47069"],
        "coty_name": ["Hardeman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardeman County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "01639750"
      },
      "bbox": [
        5.964861512452527, -3.5422468502892053, 6.317235935829962,
        -3.0858704072138115
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.57590461191668, -1.651342053262803],
            [10.577064076659504, -1.6515932711286232],
            [10.590472421839857, -1.6454092151522608],
            [10.614455777835596, -1.6311748079152881],
            [10.619483657886176, -1.6296806307682605],
            [10.629544170440111, -1.6218537205261523],
            [10.634225624264138, -1.6161997616414852],
            [10.640403270530955, -1.6124912982485042],
            [10.638315430594448, -1.6107375626844243],
            [10.636556568765421, -1.6054769487297562],
            [10.633694015225908, -1.6051498259157588],
            [10.627761639043664, -1.5966182108894016],
            [10.631234675094376, -1.5938455707279842],
            [10.63223957924849, -1.5890557348305894],
            [10.635847054153652, -1.5889743761521968],
            [10.638337012509126, -1.5859892836990226],
            [10.644262516022385, -1.582843751594407],
            [10.648648235940422, -1.5839352661945936],
            [10.648396327278691, -1.579533446363702],
            [10.66034420782927, -1.5715974058166746],
            [10.655105315867674, -1.562634185575964],
            [10.658331053929542, -1.55975189689324],
            [10.657365487006444, -1.5556057429213086],
            [10.66139628818441, -1.5533267773001875],
            [10.664000568635599, -1.5483094334908616],
            [10.66962490490085, -1.5422589093251793],
            [10.669664181792289, -1.5391880334588515],
            [10.677421221332095, -1.5331093122075448],
            [10.682223785974633, -1.5272600033068984],
            [10.684753375233699, -1.5217190078237044],
            [10.682712046224099, -1.5192533209386716],
            [10.686969986568473, -1.5145053385759586],
            [10.69006302406745, -1.514796618193691],
            [10.698894484105276, -1.5076894875723328],
            [10.69826578880304, -1.5054275591157804],
            [10.744048157832834, -1.4684008600255931],
            [10.749492463311746, -1.4706080672424828],
            [10.754629153869542, -1.4676618905390881],
            [10.757294307224857, -1.462508066175401],
            [10.765838410221841, -1.4533880892654716],
            [10.770683842745298, -1.4524161665286117],
            [10.776286902240397, -1.4564740874270743],
            [10.782345014100674, -1.4529465997824182],
            [10.7896937130421, -1.4696667235422853],
            [10.796652567550836, -1.4644401192042988],
            [10.79927680098951, -1.4604983210037996],
            [10.80643808698626, -1.456491686195567],
            [10.816198425275955, -1.4675223784560165],
            [10.834249703397845, -1.4533856505166474],
            [10.843014626926085, -1.4476371879933827],
            [10.86442279463705, -1.430109375530189],
            [10.88073363433674, -1.4194916122509986],
            [10.900949286103396, -1.4052491273014533],
            [10.903780411732477, -1.4036530619023277],
            [11.022361487382051, -1.387089465935186],
            [11.077979299903916, -1.3788157787861406],
            [11.081126771715187, -1.3831655604851436],
            [11.087688281918433, -1.3953091540811091],
            [11.081494337494854, -1.4013150640090428],
            [11.077527323995369, -1.3948837416770297],
            [11.074665419714732, -1.3938908316466316],
            [11.074246521462252, -1.4008297055146572],
            [11.075431464081356, -1.4049878459365825],
            [11.079650706383307, -1.409774994227906],
            [11.077567699940136, -1.4165286853667869],
            [11.082073177800947, -1.42515982587847],
            [11.087795829100493, -1.4536690197280548],
            [11.082035843054472, -1.4578490584778736],
            [11.076803288570538, -1.4595076171659322],
            [11.074275907154279, -1.462627704044128],
            [11.074065398782217, -1.474391197441424],
            [11.078094692751995, -1.4794042172668267],
            [11.072296371964649, -1.4838942605626166],
            [11.068366819480326, -1.4885271271785745],
            [11.059363676012708, -1.4965278001852982],
            [11.057011885536262, -1.496962017538068],
            [11.050303655605857, -1.5030053325567696],
            [11.04333910699232, -1.5077530158007573],
            [11.029170903348776, -1.5237185003505513],
            [11.02413556675947, -1.5273829756743311],
            [11.027928000503367, -1.5303139236056733],
            [11.029430583111262, -1.5346892813712156],
            [11.03219382253934, -1.5376681933130791],
            [11.035969037121806, -1.5376407425908944],
            [11.038142602513263, -1.5416228237552223],
            [11.038009608871896, -1.5458270277357404],
            [11.042284787969734, -1.5498990425930472],
            [11.04456247704954, -1.5489623565608892],
            [11.049298663547912, -1.556854900648987],
            [11.046164269956074, -1.559742814083265],
            [11.04158268116757, -1.5615097319866753],
            [11.040314065159947, -1.5639305178971459],
            [11.030298534981537, -1.5727681966604463],
            [11.026227139100941, -1.5765125071550061],
            [11.021264753180114, -1.5830190899012986],
            [11.017983269074415, -1.581442467595537],
            [11.01193528649949, -1.5813754247206824],
            [11.009661655913778, -1.5835290785444602],
            [10.995134542533433, -1.6027889359410206],
            [10.991838157884244, -1.6056966511194455],
            [10.988149063599485, -1.605806192918817],
            [10.983360718804969, -1.6084141082851038],
            [10.976841121830395, -1.6072892632088709],
            [10.972491028571628, -1.6034719845524819],
            [10.967825028327278, -1.611361055080784],
            [10.96200592759817, -1.6192478012650808],
            [10.952304992827962, -1.6293652424252834],
            [10.948039073358403, -1.6316927805381038],
            [10.943265698031036, -1.6280797480582678],
            [10.93902277412188, -1.6282640255667933],
            [10.93547697347199, -1.6317129744677592],
            [10.932386671790939, -1.6291901687192567],
            [10.930132661657941, -1.6309305862464298],
            [10.926705200109344, -1.6279573784641768],
            [10.917225114109518, -1.6394517685289203],
            [10.912586923917685, -1.636225682874094],
            [10.91009847565912, -1.6420730414014235],
            [10.907937205234777, -1.6421697653431082],
            [10.902686649135099, -1.6490118896447887],
            [10.894110309651941, -1.6498972801794882],
            [10.887467337524367, -1.6574213050512911],
            [10.881305437291388, -1.666750150469876],
            [10.878854740165194, -1.6728961893004812],
            [10.87304735440477, -1.6780808492926653],
            [10.86297158630235, -1.6739758734698575],
            [10.859064605780274, -1.6754687246988782],
            [10.855508407535021, -1.6741931548376077],
            [10.851877724325325, -1.6776489844460458],
            [10.841828413864123, -1.6923804820870216],
            [10.838223745103786, -1.6960355110181098],
            [10.83401530931559, -1.695903091379936],
            [10.831450333771633, -1.7027744817729662],
            [10.832113692376316, -1.706249936599741],
            [10.828625823340943, -1.708060962600112],
            [10.828846467458217, -1.711588260897048],
            [10.818656364616041, -1.7265380153761445],
            [10.804085906717663, -1.7424951494540217],
            [10.797968382060166, -1.748427810345393],
            [10.795246648939338, -1.744269613493074],
            [10.791629211336977, -1.7456298814517104],
            [10.788760523454487, -1.7425640612382265],
            [10.785943725000894, -1.7455627840020236],
            [10.781507685087151, -1.7530301085670783],
            [10.776361248651206, -1.7554668435891825],
            [10.777952394798225, -1.7594251236119738],
            [10.773759915756836, -1.7659061175905129],
            [10.768698391422802, -1.7701645569299882],
            [10.768979395118357, -1.7745039275134815],
            [10.76510901169643, -1.7748952349728622],
            [10.760445299409202, -1.7817074197606482],
            [10.753422315405025, -1.7824355519183854],
            [10.75239588140321, -1.7782989850420374],
            [10.742570011141309, -1.7725357527273504],
            [10.733896599189663, -1.76094329927136],
            [10.733679546290931, -1.7534650090612012],
            [10.731080055795498, -1.7508575148334067],
            [10.726453091787562, -1.7503187141213714],
            [10.726450647010685, -1.7452825483193464],
            [10.722523365815336, -1.744138966044244],
            [10.716693581693871, -1.7446037146980289],
            [10.716365675021237, -1.7399367856687165],
            [10.71126137735234, -1.7392117113239844],
            [10.704785084493965, -1.734093907617659],
            [10.695225520865993, -1.7226571821620504],
            [10.694239798780371, -1.7237077081415524],
            [10.688172528228671, -1.7140465845606092],
            [10.689971884248422, -1.7089131747700015],
            [10.679688174834839, -1.7002300263505543],
            [10.679817982914226, -1.6934917400382667],
            [10.6828371780541, -1.6902302136562952],
            [10.6758668713793, -1.6881235007203896],
            [10.673994469362267, -1.6915344825609888],
            [10.66748451825015, -1.6957785497503592],
            [10.663669599269976, -1.6939623397959347],
            [10.661366902709428, -1.6993577915358378],
            [10.664765678209328, -1.71192925744967],
            [10.67007504574641, -1.7172165039168084],
            [10.6703809504114, -1.7212479338764013],
            [10.665983147785843, -1.7232701069710343],
            [10.65203581284219, -1.7148777698822468],
            [10.649464152175248, -1.7149206465427071],
            [10.648596087217236, -1.7192128309550072],
            [10.652697749753928, -1.7227300987074847],
            [10.653728064617516, -1.7267641228552069],
            [10.65124838609931, -1.7304600327246062],
            [10.64379148890059, -1.733099641500306],
            [10.642312531696886, -1.7364560873052977],
            [10.642308760334133, -1.7429728295995246],
            [10.638440024484426, -1.7459396777715248],
            [10.633724854938244, -1.744439072822083],
            [10.627720087724184, -1.744130557847499],
            [10.623333563456141, -1.7462501935190426],
            [10.623057726038537, -1.7507671528917421],
            [10.628646506513574, -1.7528590285521575],
            [10.629646291831104, -1.7559860216071346],
            [10.627835975211783, -1.7592849047482544],
            [10.62244977501151, -1.7587904744522134],
            [10.613820248577573, -1.7545590343155815],
            [10.610151186326698, -1.7542393855829812],
            [10.601225758131156, -1.7388486498290434],
            [10.591549789406677, -1.726209221710237],
            [10.591060816511568, -1.722604836833629],
            [10.596741674283216, -1.716600535645609],
            [10.595353547735623, -1.699566056154726],
            [10.594178536883856, -1.6931696397267264],
            [10.592103730421206, -1.6915147190874387],
            [10.586040708679104, -1.6787901132606555],
            [10.584975205230858, -1.6750646539756247],
            [10.577053026453754, -1.6748074026944662],
            [10.573090265637472, -1.6716762487278203],
            [10.571484769006185, -1.6681251083604942],
            [10.57605876948188, -1.6638445300343943],
            [10.582388920468944, -1.6606507527438343],
            [10.579123372284446, -1.6573232090339272],
            [10.57590461191668, -1.651342053262803]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -82.94470042050949,
          "lat": 36.441134461688435
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47073"],
        "coty_name": ["Hawkins"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hawkins County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "01639752"
      },
      "bbox": [
        10.571484769006185, -1.7824355519183854, 11.087795829100493,
        -1.3788157787861406
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.6109402428503135, -2.2122445026181405],
            [5.621269634512791, -2.20907781600894],
            [5.628154931994634, -2.2030043239448234],
            [5.63083429973198, -2.1989684021036804],
            [5.634691072294093, -2.1872830794823015],
            [5.636496080695368, -2.173278599670051],
            [5.635646700161906, -2.168554172496187],
            [5.63235139272771, -2.1621717739665853],
            [5.622262264309475, -2.14713251586788],
            [5.607356713852394, -2.128271979676771],
            [5.604558171772922, -2.121408657444726],
            [5.6041756209068465, -2.113511453353006],
            [5.607054146414669, -2.1065977190493834],
            [5.617176130883975, -2.0958111179719485],
            [5.619888741419043, -2.0905430153087416],
            [5.622118055139882, -2.079844309394402],
            [5.621713196147591, -2.0713607320982645],
            [5.6187870087722835, -2.0656084658349783],
            [5.608675708768697, -2.0560571101470293],
            [5.604489220131763, -2.049767203232579],
            [5.6372205967241324, -2.047580621708009],
            [5.647265000096341, -2.04729262884135],
            [5.64215309939818, -2.06664521002877],
            [5.642981349451292, -2.0752606443404136],
            [5.645307936959833, -2.079748708325017],
            [5.64911882847234, -2.0834391831528603],
            [5.65707629070764, -2.0867092232757907],
            [5.666961267617542, -2.0866938572349545],
            [5.67547720814589, -2.0819652258720467],
            [5.678925632552353, -2.078557158166368],
            [5.687530911819314, -2.0678382660408032],
            [5.6974702501913885, -2.0520330140540164],
            [5.701299804083866, -2.0420288825828727],
            [5.72213220532714, -2.040512978416927],
            [5.730743666994013, -2.0385609426598124],
            [5.757579104899267, -2.0338594463861477],
            [5.758437076903327, -2.035791694609503],
            [5.760835321473441, -2.051762727408003],
            [5.7641019679235335, -2.059737652470198],
            [5.760834223865053, -2.066604145570647],
            [5.749753849577577, -2.08165962792366],
            [5.74612463927369, -2.0908834794659494],
            [5.744014116033977, -2.1045092016924465],
            [5.745812615919574, -2.114403190917987],
            [5.753024958050018, -2.1291731074079623],
            [5.7389631199137305, -2.162689908687897],
            [5.722268224877142, -2.189234066231581],
            [5.721403867293305, -2.190087852095132],
            [5.726280317734598, -2.2095794894389744],
            [5.72646263873488, -2.2175789544240216],
            [5.72462715143057, -2.222603300896975],
            [5.72459278522764, -2.2278260320044643],
            [5.71659585893168, -2.2499757389545056],
            [5.714051556637415, -2.2635546776640885],
            [5.708818300131895, -2.2834552717647423],
            [5.698543179435781, -2.3075175232059015],
            [5.691993049015889, -2.3160581939079803],
            [5.687852998932661, -2.3179711426118996],
            [5.6767971777840565, -2.3197933999197184],
            [5.666073710649155, -2.3256298884678],
            [5.668915884409067, -2.3337972730994943],
            [5.668194238301899, -2.343396894038222],
            [5.666820841020962, -2.3475620080305415],
            [5.667956584753821, -2.35118097289574],
            [5.666415291385835, -2.3593576277717463],
            [5.55741833224921, -2.368745296229107],
            [5.553942306386672, -2.369170564169594],
            [5.547764680374699, -2.3659772049302763],
            [5.5325709041989, -2.354279090317962],
            [5.524842581653358, -2.3497512157413767],
            [5.511926080653077, -2.34111957271344],
            [5.50088711839723, -2.3327078733400617],
            [5.490047859287221, -2.321692797514984],
            [5.489763214897093, -2.3183457501486213],
            [5.49443778533812, -2.307227355028995],
            [5.496949226540447, -2.3048621868704733],
            [5.504346680602963, -2.307665030479472],
            [5.5109520107936225, -2.3084618871360414],
            [5.531140154388708, -2.3046813562770536],
            [5.543854036763058, -2.30647196090993],
            [5.554041110674966, -2.310614593423192],
            [5.564894310948805, -2.3139630756273104],
            [5.571966001977369, -2.314664708343779],
            [5.583869181422427, -2.3124689951318946],
            [5.594253115678757, -2.307360717837162],
            [5.600947610242076, -2.300615628271224],
            [5.6064657811550225, -2.2992609612238994],
            [5.617268950121859, -2.3021192148397045],
            [5.621572581641504, -2.300474978303164],
            [5.624889142454886, -2.29645325623423],
            [5.624445814459654, -2.2871565425429856],
            [5.623031799363688, -2.2784181376808457],
            [5.61940972154432, -2.2717628252481483],
            [5.614967032851681, -2.2689410628474396],
            [5.607589249732522, -2.272178801670497],
            [5.587584010100187, -2.262852369199148],
            [5.577980865380313, -2.254911141824003],
            [5.559623738103991, -2.2437397429240273],
            [5.551962072435008, -2.2301844273464804],
            [5.551881580288233, -2.2235781998332858],
            [5.554591048046633, -2.2167854372084728],
            [5.558397720343885, -2.2121246354392836],
            [5.56630212905212, -2.2090215040120036],
            [5.581398178817175, -2.2086376741504288],
            [5.598588820890136, -2.212135700146745],
            [5.6109402428503135, -2.2122445026181405]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.49344163473873, "lat": 36.33534646178648 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47095"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01639762"
      },
      "bbox": [
        5.489763214897093, -2.369170564169594, 5.7641019679235335,
        -2.0338594463861477
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.243878416469126, -3.196717297247745],
            [5.248797114430625, -3.198186940055868],
            [5.259318848261103, -3.1954796440037785],
            [5.265145297301785, -3.191993807674837],
            [5.272546612224816, -3.1878093260652176],
            [5.27497115941908, -3.1839674343282955],
            [5.331063848981748, -3.1835035724645024],
            [5.367613404377715, -3.181277221639756],
            [5.402387503912338, -3.18136127398595],
            [5.4229651739858795, -3.1806068926704407],
            [5.438575171857116, -3.1785933900793726],
            [5.43968325675766, -3.17950778162026],
            [5.446901449030559, -3.1774678067960167],
            [5.453905823751885, -3.1786228134879924],
            [5.460774002666483, -3.178456612614736],
            [5.469745356594992, -3.176868622608108],
            [5.487463465359602, -3.179237078943152],
            [5.487945999462666, -3.161687828918144],
            [5.519955499085155, -3.1633963778846916],
            [5.525236576932164, -3.1633379741856382],
            [5.525291666703878, -3.1576355026975644],
            [5.533032202069656, -3.15729715945139],
            [5.541653013170332, -3.158949182914551],
            [5.542038302960152, -3.153775947885316],
            [5.547579747448186, -3.1543165917999954],
            [5.548550981124206, -3.1739636984301165],
            [5.597078832717231, -3.17181960489594],
            [5.595948987538754, -3.176914752004234],
            [5.596752866721336, -3.185059632017623],
            [5.605978887794004, -3.183499219236142],
            [5.607526450606593, -3.2422127180711287],
            [5.610067344854035, -3.263948436323581],
            [5.611050214964957, -3.2936940793404124],
            [5.612454093577943, -3.327519868658383],
            [5.612024180628965, -3.328223870098218],
            [5.614501755184974, -3.3624308623089423],
            [5.61928567188928, -3.4796232493396455],
            [5.620220616787393, -3.516575364882346],
            [5.622537635230394, -3.566429618902783],
            [5.557483665342933, -3.5708315920474405],
            [5.543333230500684, -3.571782062243129],
            [5.5001096760977966, -3.575523445496771],
            [5.456913130702542, -3.578430726464815],
            [5.369823608351954, -3.5836473027882074],
            [5.284776652518507, -3.58866426738309],
            [5.222441401702568, -3.592281746706728],
            [5.084008686486994, -3.6001347696913455],
            [5.0818900148426955, -3.593200885754378],
            [5.082444262511433, -3.5862138870195577],
            [5.085425572802295, -3.5819978197231643],
            [5.084720589290648, -3.576507885453509],
            [5.089127411009082, -3.56493942568079],
            [5.090676677103929, -3.556896935251568],
            [5.094227878609702, -3.5534759922361636],
            [5.116590517840582, -3.5530464695369712],
            [5.119371528849919, -3.557136543877159],
            [5.123907061584616, -3.5583664171811282],
            [5.127680133143332, -3.5612899706228895],
            [5.134760873089856, -3.559784646983592],
            [5.1434605855225, -3.560707775814591],
            [5.159306246260683, -3.5655320010651286],
            [5.164085706532367, -3.5649677541886766],
            [5.17624227514991, -3.5496633318566824],
            [5.179704977468133, -3.544197247059446],
            [5.183546194066888, -3.5353694072146524],
            [5.185804353557856, -3.5252472585564694],
            [5.187167475270384, -3.5128366220647576],
            [5.181767710016467, -3.504161183634135],
            [5.180897696807684, -3.49511649504401],
            [5.183450086056181, -3.4767286335934644],
            [5.186679804433768, -3.469645457172735],
            [5.190416893029014, -3.4647046792258496],
            [5.200209252869586, -3.4567004002749373],
            [5.203363788227599, -3.454939862471702],
            [5.210510934427265, -3.4539309789645856],
            [5.221077311032408, -3.4578943793255785],
            [5.23965751381092, -3.4658450455993033],
            [5.249351225469259, -3.4671704272555575],
            [5.253642519657908, -3.466381300949876],
            [5.259138397995525, -3.4627378345783337],
            [5.266412987271671, -3.4543134144910006],
            [5.271172835894298, -3.4463335555097196],
            [5.272735276112156, -3.4383773508836364],
            [5.271201220062128, -3.4316644952417446],
            [5.2682475505382325, -3.427191973667393],
            [5.259780133597883, -3.424277506419882],
            [5.240807009459782, -3.413675380239237],
            [5.236266121526672, -3.4089681620571817],
            [5.234723118345286, -3.403477728438342],
            [5.23015793392875, -3.4020231980659146],
            [5.226716882068638, -3.3954101441850755],
            [5.227254308359868, -3.386770128917239],
            [5.233157468827383, -3.3857256348834173],
            [5.243331133302493, -3.3895489326323567],
            [5.24537482253682, -3.3809129077013873],
            [5.248628345520016, -3.371594080161885],
            [5.255238269787353, -3.37499865580138],
            [5.259104639420192, -3.3691975901748332],
            [5.258076801608323, -3.3617651063063523],
            [5.250702075585718, -3.3525805429749758],
            [5.248790909315324, -3.345487256202738],
            [5.241673716818943, -3.3352272548261843],
            [5.232589783395723, -3.330113320597124],
            [5.22264512553767, -3.329337819053689],
            [5.204787835288581, -3.333966912065266],
            [5.194558566566675, -3.3308756222742724],
            [5.188699348576936, -3.3242768873509876],
            [5.18169233468895, -3.3128999220747706],
            [5.1793947882551965, -3.3055651846170324],
            [5.181672028249333, -3.2941335940954835],
            [5.184520336870508, -3.2881436855567014],
            [5.187512122861303, -3.285395923033083],
            [5.194552175715823, -3.2835533389182556],
            [5.202067676051611, -3.2871882282572136],
            [5.209718436192346, -3.2843570790992382],
            [5.214468193103517, -3.280669161233282],
            [5.219821509093775, -3.281514700257578],
            [5.225534372772084, -3.2795222567668207],
            [5.226237436016731, -3.2724352255109297],
            [5.2293213317467, -3.2598410496536574],
            [5.233916760835127, -3.234737854376367],
            [5.235846520187151, -3.229333927432289],
            [5.242808880886856, -3.217284134455101],
            [5.246738159599175, -3.2076224504275745],
            [5.246098549732954, -3.201921748893601],
            [5.243878416469126, -3.196717297247745]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.89374383890842, "lat": 35.18431273874514 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47157"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "157",
        "coty_gnis_code": "01639790"
      },
      "bbox": [
        5.0818900148426955, -3.6001347696913455, 5.622537635230394,
        -3.153775947885316
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.82315641178245, -1.9597116380221264],
            [7.826583270257852, -1.954257234127761],
            [7.828078333395436, -1.9484326240924488],
            [7.82700113546432, -1.9461464451138526],
            [7.837223926004233, -1.945380207465872],
            [7.839440816052116, -1.9491352441067147],
            [7.844027224229447, -1.94908515247508],
            [7.845690642101437, -1.9460323101454189],
            [7.849658872214791, -1.9441791102980528],
            [7.85091401317939, -1.948412216019609],
            [7.8568428303687075, -1.947674376895228],
            [7.860150125926565, -1.9508891857992867],
            [7.865240776735399, -1.9509455240313847],
            [7.86743976588239, -1.9534496546200013],
            [7.871787066208597, -1.9531942960060966],
            [7.873548978840799, -1.9504757679958051],
            [7.8696987141230155, -1.9426312453530035],
            [7.869249172726265, -1.936736772373864],
            [7.87474347836288, -1.9263950158545835],
            [7.878268498895562, -1.9213719785529604],
            [7.881881788121427, -1.9088429220999092],
            [7.890748921519649, -1.8962634241035994],
            [7.898386238836369, -1.8868899212914645],
            [7.902080408676904, -1.8754733255411942],
            [7.902045419359843, -1.868913941534908],
            [7.904618442775415, -1.8596849918248677],
            [7.9024259327086295, -1.8487546388704963],
            [7.902447090918731, -1.8430432287841143],
            [7.906017800779477, -1.8189027711563066],
            [7.920388072808849, -1.7899062388749873],
            [7.927107507686846, -1.7799125449990614],
            [7.932852643779759, -1.763026957961466],
            [7.9465651330602585, -1.7306715982440548],
            [7.9517867259280095, -1.715810710025047],
            [7.96132714558006, -1.7103643802278667],
            [7.961621600597138, -1.7034064488719018],
            [7.966986117987263, -1.7038114602456274],
            [7.967014830537305, -1.707210033970697],
            [7.9942910363541335, -1.6924054978905971],
            [8.021469157947969, -1.6904633317393674],
            [8.025405357510055, -1.6898951160449942],
            [8.070686547542557, -1.686589532974843],
            [8.099542329131689, -1.684468746409321],
            [8.112122945906595, -1.6831472266105498],
            [8.132805069859938, -1.6821224527939969],
            [8.16453832926142, -1.6823496658933685],
            [8.23459774690345, -1.6807933546532998],
            [8.233956945066641, -1.6958138461933843],
            [8.234195449653859, -1.7061330480905947],
            [8.231568222134772, -1.7719941552489689],
            [8.230579758475754, -1.7938207079470778],
            [8.23621986185581, -1.7928318851326064],
            [8.239151851407119, -1.7968576084113885],
            [8.239633793294518, -1.8150009893863293],
            [8.238115149294808, -1.8164784975253585],
            [8.238649056287962, -1.8241245265743482],
            [8.236744407430965, -1.8243474811409173],
            [8.23669350811629, -1.8315273377677654],
            [8.232222577793891, -1.8355489243639627],
            [8.228197981701763, -1.8353024882621762],
            [8.224916780436823, -1.8386927525446501],
            [8.22420435754581, -1.8419399955883409],
            [8.228860166474929, -1.8421784223850142],
            [8.228942319398506, -1.8719484046076647],
            [8.21877009475821, -1.8724895915412056],
            [8.218914719620969, -1.873893701896547],
            [8.203820635482272, -1.8735414377001287],
            [8.20846910579855, -1.9397591344362783],
            [8.210562227018778, -1.9680448051490014],
            [8.202945422020205, -1.9663912623502502],
            [8.20131233777332, -1.9773036230179935],
            [8.203211487110504, -1.9804981830013315],
            [8.20014532162381, -1.9821572413788684],
            [8.19517912305649, -1.9899363036729538],
            [8.194079051268924, -1.9944796226499042],
            [8.19502051095336, -2.005103343549881],
            [8.194633282742421, -2.015720995111885],
            [8.187884781663998, -2.0171619330526838],
            [8.17659699384667, -2.014233949159725],
            [8.168694810016849, -2.013161543230681],
            [8.164056186065501, -2.0145422399449613],
            [8.150274305161988, -2.024226738801372],
            [8.144367216891721, -2.0230085227206125],
            [8.144554973920693, -2.019005366325651],
            [8.147823860196889, -2.0117602357627016],
            [8.155140080327394, -2.003311726299715],
            [8.154361538329168, -1.9921938207382788],
            [8.153241928088372, -1.988026486772492],
            [8.148928869542095, -1.9811846991843418],
            [8.140203856801492, -1.976604679929907],
            [8.133150603075153, -1.9788934563906313],
            [8.128539998971354, -1.984647973302957],
            [8.121865866584102, -2.0011197008026045],
            [8.120659889263774, -2.014082286161118],
            [8.122241635205285, -2.0192311521804975],
            [8.121935226580758, -2.0266135964450354],
            [8.118206846738458, -2.0305708375808855],
            [8.113929300443175, -2.031791012427988],
            [8.10838842656736, -2.03051467993712],
            [8.101720470721132, -2.025109566717836],
            [8.098398400510092, -2.016956609124249],
            [8.097431616622584, -2.006136977484021],
            [8.089225672365904, -2.001263566427385],
            [8.084576454382615, -2.000155231368654],
            [8.070685202310397, -2.006005177309951],
            [8.058688418347675, -2.01677803279135],
            [8.042244915103153, -2.0322642225850727],
            [8.034111026556124, -2.037265013465158],
            [8.027746027008025, -2.0439450687926257],
            [8.025444336857365, -2.048391989229029],
            [8.023932159148345, -2.0618770208960573],
            [8.021215609856482, -2.069115571682438],
            [8.017180827349165, -2.0692837297315054],
            [8.010878180166026, -2.0643659450954694],
            [8.00681967976394, -2.0579341701317224],
            [8.0037930085024, -2.047753619652744],
            [8.003403457339076, -2.040579283902557],
            [8.00135479560545, -2.0318946242143734],
            [7.9968057530528185, -2.027983953551962],
            [7.992049943509872, -2.0306773266870417],
            [7.983520386273396, -2.044365512741312],
            [7.984437256587389, -2.0527443278077713],
            [7.989551645602465, -2.0602438900252964],
            [7.9923915387052125, -2.0691254348108816],
            [7.990683408930638, -2.077831348571691],
            [7.981837535947808, -2.0978872392180037],
            [7.975818659476765, -2.103132277301509],
            [7.96642306101607, -2.1079282618381048],
            [7.951425129541362, -2.1107234587176538],
            [7.938970466054655, -2.104801363960463],
            [7.930266905799069, -2.10236292170846],
            [7.927182752068149, -2.095810157210257],
            [7.9246487077330245, -2.082840290324231],
            [7.924602744523736, -2.0692140979915488],
            [7.922109633095835, -2.0659579411199007],
            [7.906923755678466, -2.05901538625428],
            [7.898203658047662, -2.050031192807942],
            [7.895296324722311, -2.0430076817207596],
            [7.89113456929186, -2.043914650921717],
            [7.884276383628066, -2.0404852942719516],
            [7.877381084281024, -2.039291066149032],
            [7.876884844534655, -2.034297858640004],
            [7.8719443361805626, -2.0342929383468853],
            [7.8660237007036935, -2.0283931069377625],
            [7.861667527906691, -2.026213801259929],
            [7.856170113123086, -2.0207725662088842],
            [7.853680319764765, -2.0153357535214083],
            [7.850231493075552, -2.002199685340028],
            [7.8506012260174005, -1.9997550530301524],
            [7.8448566698097, -1.9821610529229408],
            [7.842041631901276, -1.9777976729443376],
            [7.836178541755702, -1.9734218009270839],
            [7.834369065975447, -1.9668879705869704],
            [7.830661987709255, -1.9649113653158483],
            [7.8306143622280855, -1.961415768079964],
            [7.82315641178245, -1.9597116380221264]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.46055181521986, "lat": 36.46903997025254 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47165"],
        "coty_name": ["Sumner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sumner County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "01639794"
      },
      "bbox": [
        7.82315641178245, -2.1107234587176538, 8.239633793294518,
        -1.6807933546532998
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.96642306101607, -2.1079282618381048],
            [7.975818659476765, -2.103132277301509],
            [7.981837535947808, -2.0978872392180037],
            [7.990683408930638, -2.077831348571691],
            [7.9923915387052125, -2.0691254348108816],
            [7.989551645602465, -2.0602438900252964],
            [7.984437256587389, -2.0527443278077713],
            [7.983520386273396, -2.044365512741312],
            [7.992049943509872, -2.0306773266870417],
            [7.9968057530528185, -2.027983953551962],
            [8.00135479560545, -2.0318946242143734],
            [8.003403457339076, -2.040579283902557],
            [8.0037930085024, -2.047753619652744],
            [8.00681967976394, -2.0579341701317224],
            [8.010878180166026, -2.0643659450954694],
            [8.017180827349165, -2.0692837297315054],
            [8.021215609856482, -2.069115571682438],
            [8.023932159148345, -2.0618770208960573],
            [8.025444336857365, -2.048391989229029],
            [8.027746027008025, -2.0439450687926257],
            [8.034111026556124, -2.037265013465158],
            [8.042244915103153, -2.0322642225850727],
            [8.058688418347675, -2.01677803279135],
            [8.070685202310397, -2.006005177309951],
            [8.084576454382615, -2.000155231368654],
            [8.089225672365904, -2.001263566427385],
            [8.097431616622584, -2.006136977484021],
            [8.098398400510092, -2.016956609124249],
            [8.101720470721132, -2.025109566717836],
            [8.10838842656736, -2.03051467993712],
            [8.113929300443175, -2.031791012427988],
            [8.118206846738458, -2.0305708375808855],
            [8.121935226580758, -2.0266135964450354],
            [8.122241635205285, -2.0192311521804975],
            [8.120659889263774, -2.014082286161118],
            [8.121865866584102, -2.0011197008026045],
            [8.128539998971354, -1.984647973302957],
            [8.133150603075153, -1.9788934563906313],
            [8.140203856801492, -1.976604679929907],
            [8.148928869542095, -1.9811846991843418],
            [8.153241928088372, -1.988026486772492],
            [8.154361538329168, -1.9921938207382788],
            [8.155140080327394, -2.003311726299715],
            [8.147823860196889, -2.0117602357627016],
            [8.144554973920693, -2.019005366325651],
            [8.144367216891721, -2.0230085227206125],
            [8.150274305161988, -2.024226738801372],
            [8.164056186065501, -2.0145422399449613],
            [8.168694810016849, -2.013161543230681],
            [8.17659699384667, -2.014233949159725],
            [8.187884781663998, -2.0171619330526838],
            [8.194633282742421, -2.015720995111885],
            [8.19502051095336, -2.005103343549881],
            [8.194079051268924, -1.9944796226499042],
            [8.19517912305649, -1.9899363036729538],
            [8.20014532162381, -1.9821572413788684],
            [8.203211487110504, -1.9804981830013315],
            [8.206396856427418, -1.9791340441032146],
            [8.211531126354144, -1.9795645802244788],
            [8.214695819535367, -1.9819951431973801],
            [8.218143268855542, -1.9892401379264213],
            [8.21996766312702, -1.998258134030175],
            [8.214991658780257, -2.0118016781378563],
            [8.215765991763314, -2.019992295728911],
            [8.223895509403045, -2.027106070570639],
            [8.228124021647805, -2.0257131783369924],
            [8.23401074849658, -2.0204570127020687],
            [8.23539196575439, -2.013680402623922],
            [8.233015768909194, -1.9978060103042636],
            [8.23515519711234, -1.9884684600600102],
            [8.24523186552241, -1.9744822178642598],
            [8.24830579333384, -1.9743832987697116],
            [8.248363660547607, -1.9807313210274995],
            [8.255706791119918, -1.9810558338121569],
            [8.259778959226358, -1.977543020832604],
            [8.264587659701405, -1.9790898649260855],
            [8.265350049496877, -1.9852485320898952],
            [8.267638480442498, -1.9892595394654438],
            [8.27341185869682, -1.9948360690524027],
            [8.280673661705658, -2.000317966993413],
            [8.284706067043075, -2.0007127820888866],
            [8.287207324494197, -1.9981209287067885],
            [8.290349642556835, -1.9904430361956786],
            [8.30060087896217, -1.9974297117558641],
            [8.31770467111817, -2.0122833202893715],
            [8.32484659243725, -2.0203064427923985],
            [8.325884861688383, -2.0214722703169787],
            [8.336125655715637, -2.045707068403525],
            [8.340771677705597, -2.0447562678589004],
            [8.344505687768347, -2.045615404805226],
            [8.339442117274844, -2.054146735992701],
            [8.348665570061218, -2.076844733420108],
            [8.343948526681299, -2.078250458512299],
            [8.343856752314013, -2.083713387754612],
            [8.347596668809798, -2.0856114667548304],
            [8.352173955951988, -2.0857090092728203],
            [8.361367326730171, -2.10850075512179],
            [8.368177838947556, -2.107250611145605],
            [8.371374053351296, -2.114708529520739],
            [8.36513218160045, -2.1173436729596324],
            [8.389066811588622, -2.1766036066355983],
            [8.391683803483216, -2.1767017306024172],
            [8.395488786387043, -2.1837276088099795],
            [8.399047165050602, -2.1866739421821286],
            [8.39959138906322, -2.1996240914448197],
            [8.408181893203093, -2.2244086744313805],
            [8.407218986880702, -2.232073762308099],
            [8.408102424010062, -2.2365830203027155],
            [8.413615978741936, -2.2378806602060193],
            [8.41264780288749, -2.2441843650090227],
            [8.413590871911182, -2.250951689505027],
            [8.421011761150858, -2.2519949929041068],
            [8.421131934656035, -2.259577756706126],
            [8.417668776900609, -2.26073028163183],
            [8.417626447694289, -2.266243069080964],
            [8.42371329761323, -2.2674090050700793],
            [8.424528525359184, -2.2729452928885427],
            [8.42737323398168, -2.2766053021876136],
            [8.433004983817069, -2.2771957654695667],
            [8.434590669937274, -2.2822838582049654],
            [8.435099501722851, -2.2922643203152835],
            [8.431435553520512, -2.3003124811426807],
            [8.434888081949813, -2.304759096774684],
            [8.43743179386048, -2.3038720757530537],
            [8.443859284612012, -2.3093530665669566],
            [8.44447083076678, -2.315353568019286],
            [8.457126658852268, -2.3459823270375164],
            [8.450502052817066, -2.343010390401994],
            [8.402022051044758, -2.3478044449611137],
            [8.397879944930631, -2.3461886068664835],
            [8.397823637685201, -2.339008874237262],
            [8.395378272696691, -2.3388853826247233],
            [8.395213505863916, -2.348268104545802],
            [8.392631378388915, -2.352926140307548],
            [8.373841793705324, -2.356634156811744],
            [8.34551866024872, -2.3555929767194437],
            [8.34834840535336, -2.3598500650855203],
            [8.347456307237929, -2.364209925908278],
            [8.340792119891024, -2.3625174689631407],
            [8.337405441918865, -2.3594300931234136],
            [8.3333867395211, -2.3627677389531088],
            [8.320543389332526, -2.363475061110713],
            [8.320552458658655, -2.3591077419767537],
            [8.307251775605147, -2.359235755989359],
            [8.301004918224349, -2.360357664752167],
            [8.300972797315945, -2.3562988236557514],
            [8.290243062309711, -2.355050316723783],
            [8.289223533788345, -2.361600893198959],
            [8.279732220814363, -2.362207026278778],
            [8.279484783705673, -2.3661465188245168],
            [8.268161320119503, -2.3655713056756285],
            [8.268381355932055, -2.3589189654079754],
            [8.238358623555392, -2.356918261242283],
            [8.238508929131044, -2.3545815156006897],
            [8.21959454617001, -2.352890296306221],
            [8.219131496655015, -2.3452509495444125],
            [8.207732048414574, -2.3453388559745085],
            [8.206259617468193, -2.34771918619422],
            [8.18875574281454, -2.3342440181566877],
            [8.172835221173395, -2.3251961035938153],
            [8.172860563309923, -2.3214095748068333],
            [8.169982348113066, -2.3180782795546158],
            [8.166106197841833, -2.3175323956778673],
            [8.163024901701622, -2.3247157264179656],
            [8.152423199815008, -2.310434678472306],
            [8.156070745907044, -2.3105675245602315],
            [8.15625013403987, -2.301878547305542],
            [8.146875265170388, -2.3016157550240988],
            [8.146642580673495, -2.3071312468611693],
            [8.127219375838717, -2.2980168450943212],
            [8.11068168067702, -2.2874472558044476],
            [8.098079969608879, -2.279938526482262],
            [8.088327190943312, -2.2748598368743167],
            [8.081207164113982, -2.2721264680105002],
            [8.063094982126778, -2.2598031069402826],
            [8.043605682030488, -2.246978079681912],
            [8.036814606672678, -2.24155237047478],
            [8.02663462663971, -2.241015495921838],
            [8.026720227112161, -2.2366181507583547],
            [8.03003602539001, -2.236740110666126],
            [8.030350235180457, -2.224243528800266],
            [8.028408250459707, -2.2200496199322863],
            [8.029615344631107, -2.21046897178867],
            [8.023712228664609, -2.210547668728583],
            [8.021789398985963, -2.21390004053055],
            [8.017985406670055, -2.209009862877414],
            [8.014966956916819, -2.2128990746469337],
            [8.012829392648031, -2.212332735031746],
            [8.007288027665494, -2.2157868374725207],
            [8.007125168272136, -2.205240407938959],
            [7.998053190310191, -2.18762718940783],
            [7.992250300687628, -2.1780379922936883],
            [7.98639590301184, -2.157417092957915],
            [7.969855676332238, -2.1160730781638253],
            [7.967780272776129, -2.1161736173932733],
            [7.96642306101607, -2.1079282618381048]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.29724153711972, "lat": 36.15467564693651 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47189"],
        "coty_name": ["Wilson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilson County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "01639802"
      },
      "bbox": [
        7.96642306101607, -2.3661465188245168, 8.457126658852268,
        -1.9743832987697116
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2984804938775207, -10.00272613579978],
            [-1.2928139642002525, -10.0009107599075],
            [-1.227782772112546, -9.97827145911967],
            [-1.218679474349281, -9.975430923708126],
            [-1.2117803806863983, -9.981806578111684],
            [-1.2074721702143583, -9.982179718036472],
            [-1.2037331762251964, -9.989476328693398],
            [-1.1985498861455448, -9.992102052882261],
            [-1.1915513776980735, -9.999754528790225],
            [-1.1899280951921867, -9.99871551885934],
            [-1.184702577657428, -10.003845178365076],
            [-1.1777134607807338, -10.005739597213106],
            [-1.1695306023261944, -10.011103232625576],
            [-1.1663324658457137, -10.010217040224761],
            [-1.158739015841297, -10.012583485102764],
            [-1.152350994830811, -10.016051884097203],
            [-1.1494411342391766, -10.01560885514991],
            [-1.148482331004011, -10.019931951727843],
            [-1.1440166298053884, -10.018160690535037],
            [-1.1417957714509044, -10.020452983672252],
            [-1.1407505603068633, -10.02541844065543],
            [-1.1142542220342964, -10.022910336851991],
            [-1.1112501422934695, -10.019474390250249],
            [-1.1078550379502548, -10.02063641336011],
            [-1.1050249969304848, -10.02543193972961],
            [-1.0996762009716308, -10.028460061030078],
            [-1.09393466220512, -10.028273725761984],
            [-1.0921247053759342, -10.031968590002379],
            [-1.082309240742206, -10.04062603754475],
            [-1.0795855486981825, -10.041596628639317],
            [-1.0771330256413185, -10.048926517042128],
            [-1.0783601305473283, -10.052271572204212],
            [-1.0755535204413407, -10.057201423871707],
            [-1.0684738241223457, -10.060828411296102],
            [-1.0646652457229868, -10.06613445620766],
            [-1.0591562954061073, -10.068477169074374],
            [-1.059530951868594, -10.072940068915248],
            [-1.0564132182582668, -10.075557975211076],
            [-1.0576812827984803, -10.083715399703403],
            [-1.0537668942502323, -10.091683189468489],
            [-1.0501262583766051, -10.095103889785511],
            [-1.051070525457912, -10.100320471629887],
            [-1.0464970511328504, -10.104919869820199],
            [-1.04358869613235, -10.109689804203224],
            [-1.04249236804418, -10.117931043753103],
            [-1.03967710767418, -10.121185814267758],
            [-1.0403621566879901, -10.127221775772613],
            [-1.0364049585684778, -10.129523857105216],
            [-1.0340037824302564, -10.135396903364441],
            [-1.0355791241247607, -10.137833966681288],
            [-1.0329290216662406, -10.14087990726762],
            [-1.0314707474150204, -10.150320431373846],
            [-1.0298919919542382, -10.154012224709486],
            [-1.020704779549149, -10.155659389694742],
            [-1.0195813287605, -10.158455925363278],
            [-1.0150048584998195, -10.160519851799599],
            [-1.0080175020332025, -10.160052738230856],
            [-1.005370807843449, -10.16141180760895],
            [-1.0050568187326894, -10.16533542469932],
            [-0.9927693518335117, -10.170601343691821],
            [-0.9862538143857493, -10.175010795242526],
            [-0.9777362588428857, -10.17116007425174],
            [-0.9749969146679092, -10.171397021719237],
            [-0.9684698157833251, -10.168105840307513],
            [-0.9594668628049549, -10.169861963184156],
            [-0.9543454465369798, -10.173285042056172],
            [-0.9525530550965386, -10.170412535956928],
            [-0.946499678522491, -10.173228924587303],
            [-0.9408068311108082, -10.171695673740258],
            [-0.9330792138161275, -10.172518373950712],
            [-0.9312290412055998, -10.174353018173347],
            [-0.9249983763005607, -10.174443229409556],
            [-0.9201885752189802, -10.177481902477751],
            [-0.9179795336561654, -10.181575073713779],
            [-0.9127420461027533, -10.180671988521812],
            [-0.9088888841086439, -10.182862556080645],
            [-0.9068522550528406, -10.192966821879578],
            [-0.9049567832085095, -10.194099226193876],
            [-0.905835776668803, -10.20452803604644],
            [-0.9039047493222364, -10.214736320001498],
            [-0.9035592923443102, -10.22880871974163],
            [-0.9062179450865261, -10.233297240008355],
            [-0.9057188164706177, -10.24081329635754],
            [-0.9035531136630357, -10.245597040921238],
            [-0.9005936992687309, -10.244785471699581],
            [-0.8952065251583354, -10.249414295934109],
            [-0.889473705473119, -10.248115456898143],
            [-0.8864684105677921, -10.249934270169284],
            [-0.8808120822507903, -10.248993944415561],
            [-0.876347672100919, -10.250382838393662],
            [-0.8794821853006858, -10.25550618972444],
            [-0.8743106641243985, -10.264193165463269],
            [-0.8658070833011052, -10.263611725455046],
            [-0.8619667610837709, -10.259353183678467],
            [-0.8531869104558235, -10.257774423782855],
            [-0.8454679866377418, -10.260303539856029],
            [-0.8413553479289659, -10.262822848179953],
            [-0.8359644742091145, -10.270237270726136],
            [-0.8324462806994725, -10.271580757543495],
            [-0.8325199119078173, -10.27704915678461],
            [-0.8284523366107343, -10.279821130664045],
            [-0.8273561889217553, -10.285226529079901],
            [-0.8230418261252489, -10.289005952486542],
            [-0.8143555654394887, -10.288320111915787],
            [-0.8125017864794559, -10.29333694103558],
            [-0.8101623268464669, -10.293593780038826],
            [-0.808646257053802, -10.28816806549784],
            [-0.801286385139786, -10.28625770553974],
            [-0.7981282605813902, -10.283950814968708],
            [-0.794418946429004, -10.28532881616792],
            [-0.7889522656263244, -10.29276981390107],
            [-0.7798043855971665, -10.289136832883486],
            [-0.77630375561608, -10.291289287065636],
            [-0.7712204713327382, -10.291542756475337],
            [-0.7689836422447758, -10.294183974417095],
            [-0.7721601846727402, -10.299163096663934],
            [-0.7721946409062215, -10.303168875488645],
            [-0.7672862152747546, -10.30478570210953],
            [-0.7644309586383352, -10.301059167956362],
            [-0.7604208324924937, -10.30151241141721],
            [-0.760789597644084, -10.305912769638486],
            [-0.7568952558697154, -10.307471204473428],
            [-0.7539105265109827, -10.306419637356093],
            [-0.7495243071094178, -10.308551029614556],
            [-0.7792111698279794, -10.351859187510659],
            [-0.8420785441554525, -10.442958444359128],
            [-0.8566450047471381, -10.464758778215264],
            [-0.8621480979702004, -10.472268641095],
            [-0.8990982510189542, -10.526008515434391],
            [-0.9231515599185856, -10.5599117243985],
            [-0.9985270610577405, -10.542918185212176],
            [-1.1174171937896276, -10.515728186350287],
            [-1.1434881137917159, -10.509823690717875],
            [-1.1354579563936442, -10.503536385428237],
            [-1.1495959457341787, -10.475688641533065],
            [-1.1664658859439294, -10.441364065562324],
            [-1.1673311742370505, -10.44052176574902],
            [-1.224667627013807, -10.325768141099282],
            [-1.2579015314539945, -10.259276535997937],
            [-1.2848771771848608, -10.204138705750939],
            [-1.3073662613232653, -10.159130467016606],
            [-1.3346739406178496, -10.10492138299288],
            [-1.373336318908165, -10.02793770210734],
            [-1.2984804938775207, -10.00272613579978]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.74116392506893, "lat": 28.41736867878567 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48025"],
        "coty_name": ["Bee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bee County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01383798"
      },
      "bbox": [
        -1.373336318908165, -10.5599117243985, -0.7495243071094178,
        -9.975430923708126
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.023231129150111, -7.08523221998391],
            [-2.9932393851767567, -7.086870952432042],
            [-2.9352504351850754, -7.090362694573346],
            [-2.874512227531857, -7.093676618125279],
            [-2.7573913112261224, -7.099477492768308],
            [-2.724535936238482, -7.101022499353585],
            [-2.6931591323693946, -7.102235452332824],
            [-2.6940188687756956, -7.1161599318447175],
            [-2.690150674775347, -7.118597586140849],
            [-2.6842804176630173, -7.117841186962395],
            [-2.685794039563972, -7.113555769529456],
            [-2.6835321774730585, -7.103383939984002],
            [-2.6782990183943185, -7.103813948325817],
            [-2.6750875985776488, -7.108873982736169],
            [-2.672537815307938, -7.110526014438073],
            [-2.6705720347255477, -7.1154678082506],
            [-2.67096399216238, -7.121416276752712],
            [-2.6679782203573277, -7.125849754225962],
            [-2.664081187182481, -7.126776612496923],
            [-2.6559210568679865, -7.123845988696621],
            [-2.6530645586817245, -7.125190004914113],
            [-2.651603825087092, -7.130273144342579],
            [-2.6531803336406137, -7.133348330939535],
            [-2.662543707372404, -7.139768252412903],
            [-2.670318193607166, -7.141524546002893],
            [-2.6689159198159946, -7.14751867134775],
            [-2.652793400385826, -7.147072882194028],
            [-2.641447614114551, -7.14608558048931],
            [-2.6383690079736195, -7.148169185926206],
            [-2.6364432340780053, -7.153566386864063],
            [-2.640160853514379, -7.1614656641304055],
            [-2.644822427149037, -7.165581157112805],
            [-2.6522936336323357, -7.169450103768103],
            [-2.658615127588761, -7.178616940660863],
            [-2.6578057575242973, -7.182858672764935],
            [-2.652050369775739, -7.183850001287037],
            [-2.645553141480638, -7.182048278236468],
            [-2.637715955716907, -7.1844130541168],
            [-2.6324681240971057, -7.189764561203409],
            [-2.6252643622083607, -7.201147538364556],
            [-2.6248117252278464, -7.204574572602376],
            [-2.6215595807826095, -7.20926299934152],
            [-2.616391308003219, -7.214079596565885],
            [-2.607752834221117, -7.213787329708356],
            [-2.604223611439394, -7.212035788332273],
            [-2.600399722629349, -7.203137791625808],
            [-2.6010013716504528, -7.200312305973784],
            [-2.6048116520388374, -7.195462957005232],
            [-2.6095007608394676, -7.19365715164828],
            [-2.614096304308878, -7.188274147707865],
            [-2.6113332124022675, -7.180579692086165],
            [-2.604966116710228, -7.1805830413439296],
            [-2.594774720122488, -7.19055027951073],
            [-2.599100798608266, -7.28915558549037],
            [-2.608753123583619, -7.55872364619691],
            [-2.6113324449475983, -7.592949699810976],
            [-2.667382726810996, -7.591094828525066],
            [-2.797835799795716, -7.585813310492168],
            [-2.9020596342674487, -7.581469748376483],
            [-3.047992526419169, -7.574669957744364],
            [-3.040266473261772, -7.425230331345927],
            [-3.032515357664534, -7.265274341169738],
            [-3.0278634249487535, -7.175873926551585],
            [-3.026153087131896, -7.137784599403218],
            [-3.023231129150111, -7.08523221998391]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.86405498333399, "lat": 31.32655491723713 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48095"],
        "coty_name": ["Concho"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Concho County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01383833"
      },
      "bbox": [
        -3.047992526419169, -7.592949699810976, -2.594774720122488,
        -7.08523221998391
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5808682453999221, -5.331566227896967],
            [0.5816062163970891, -5.279238380551387],
            [0.585157044871509, -5.27965011362756],
            [0.5888960233577379, -5.283199685127233],
            [0.6019819655134436, -5.280206037198816],
            [0.6080178192585456, -5.281575908714671],
            [0.6075172431867106, -5.278338242802866],
            [0.6130422453262812, -5.276868128007158],
            [0.6180330303077297, -5.271790040847069],
            [0.6212947180856818, -5.270615485675183],
            [0.6229384526532514, -5.265787250798121],
            [0.6311412307430301, -5.262779251646644],
            [0.6391511529527925, -5.254561663952632],
            [0.6446025215321418, -5.254465150561492],
            [0.6476820031350919, -5.249886571365427],
            [0.65245335591785, -5.249216521855065],
            [0.6528561650369668, -5.246939321469425],
            [0.6613515146623139, -5.245257979093508],
            [0.6696347519544723, -5.247455929309318],
            [0.681674877415925, -5.251620136430145],
            [0.6843551967194397, -5.25403530991665],
            [0.6884769341624877, -5.253866270689908],
            [0.6897401145222772, -5.256484805178301],
            [0.6935087001748885, -5.254758274816541],
            [0.6991294334015914, -5.254805912902101],
            [0.7018031895566123, -5.257027971198787],
            [0.7085747504252661, -5.253945959384313],
            [0.7103506721636976, -5.2595206038783315],
            [0.7145342390224716, -5.263845171067753],
            [0.7245756584901866, -5.26410547099996],
            [0.728097616616084, -5.268455511355906],
            [0.7357577034068937, -5.267915147808266],
            [0.7389052840220731, -5.264981390812467],
            [0.7478233980158321, -5.261508556839045],
            [0.7584181834041861, -5.254328379860241],
            [0.7639560285975284, -5.256295958817606],
            [0.7649710092220315, -5.258322617074932],
            [0.770253374072338, -5.255211907365941],
            [0.777622305562815, -5.25329684796329],
            [0.7816074735528038, -5.256469615622259],
            [0.7872964787120755, -5.25594717679385],
            [0.7889524181362659, -5.2581925075388245],
            [0.7946921469251768, -5.256716739783643],
            [0.7953045062648294, -5.259909855523308],
            [0.8009050312898645, -5.2601538951151685],
            [0.8008162429505359, -5.2680165059706745],
            [0.8033594277753138, -5.270494307631006],
            [0.8072090816184678, -5.269149112480656],
            [0.810015275219124, -5.271098136483626],
            [0.8149265107869375, -5.267817723306247],
            [0.8207085548206398, -5.266487317458966],
            [0.8233796393646038, -5.263129179784374],
            [0.8309581452706237, -5.268751600026335],
            [0.8335852221642622, -5.271769490303535],
            [0.8372320250566888, -5.2722807649803185],
            [0.8393692501364788, -5.281059077147144],
            [0.847101625650067, -5.28637915218735],
            [0.851942371531632, -5.28788758054557],
            [0.8557416626502947, -5.2941954582795585],
            [0.861947817908447, -5.296005271797207],
            [0.8692984222238462, -5.295188888673905],
            [0.87209214253152, -5.297924697907064],
            [0.8773443609913945, -5.296611052214426],
            [0.878887503136201, -5.291770312093929],
            [0.8861933019070669, -5.286278263386623],
            [0.8998266750777798, -5.2918280837668314],
            [0.9024082087002221, -5.295719046172323],
            [0.9027264108185676, -5.300452636323901],
            [0.9055561017211199, -5.301681118562727],
            [0.9074824752571885, -5.305981515151133],
            [0.919992937158948, -5.305018042813112],
            [0.9240028671940884, -5.306734316842417],
            [0.9279132504754227, -5.310507265672707],
            [0.9338477622905658, -5.31254455686324],
            [0.9356609333419624, -5.316740548159411],
            [0.9419183914202306, -5.323913350682897],
            [0.9475212061641953, -5.323427147425377],
            [0.9471517276813698, -5.327505732795187],
            [0.9505211513270552, -5.327795863841611],
            [0.9571282154236448, -5.330742484912691],
            [0.9613815295318829, -5.329839644907153],
            [0.9642168170496555, -5.338781246465432],
            [0.9692059211735896, -5.337357062148604],
            [0.9732029279434515, -5.341511865107827],
            [0.9769125325625676, -5.341978121022786],
            [0.9834972042070507, -5.34709495828588],
            [0.9867741074836797, -5.3452989795443875],
            [0.9915659756408146, -5.345738339351727],
            [0.9982728212580322, -5.349366418375325],
            [0.9995624218450708, -5.352531519340312],
            [1.0089657976439355, -5.350687931724364],
            [1.016004102147586, -5.354806393571639],
            [1.0194733192498526, -5.353873886106777],
            [1.0215210801588503, -5.3585569946167375],
            [1.0291562411416444, -5.357372068686891],
            [1.0353141111523718, -5.359722705113737],
            [1.0371333078541796, -5.358515633824528],
            [1.0388088770049342, -5.361144929034582],
            [1.0371952289397057, -5.361995677040614],
            [1.0337381291192218, -5.3681595308406775],
            [1.0333918795832369, -5.371083068998448],
            [1.0274307659030597, -5.370834026182351],
            [1.022670519542803, -5.372403464030735],
            [1.0196008554864777, -5.375631762275816],
            [1.014236567572708, -5.377959708085786],
            [1.0071876482296962, -5.377624477749366],
            [0.9995331236893226, -5.374969164939407],
            [0.9976072796108323, -5.372833020287515],
            [0.9915147613273526, -5.374134884381963],
            [0.9865890532420744, -5.369554479057412],
            [0.9820521311084827, -5.371635239814458],
            [0.9711817255769543, -5.371331748292146],
            [0.9632681771250727, -5.372517791054253],
            [0.9611633206615959, -5.368015181183615],
            [0.9555585476227522, -5.370274547896407],
            [0.9490957624414834, -5.368650421047505],
            [0.9467377182672126, -5.371108717186101],
            [0.9423647060765035, -5.369916341341894],
            [0.9325591690616283, -5.375473175729943],
            [0.9272197318827277, -5.377233729718499],
            [0.9212446304913855, -5.375727801368584],
            [0.9170344492719362, -5.37254033527091],
            [0.9120038612475493, -5.3753867088656495],
            [0.9138924863198581, -5.377363734025268],
            [0.9104486739313776, -5.38155012965664],
            [0.9049052305476719, -5.382894310445828],
            [0.8997756528223247, -5.385742371773691],
            [0.8971306177674258, -5.383626865790057],
            [0.8948963943581487, -5.388461414309222],
            [0.8902884006953165, -5.390163295978249],
            [0.8855507381284188, -5.38599081157872],
            [0.8826715380352315, -5.387185868161112],
            [0.8808557928909247, -5.391325132337288],
            [0.876051132007989, -5.389952016578256],
            [0.8698788571780142, -5.3907366677874595],
            [0.8670464838755633, -5.394019770208894],
            [0.8568902553915702, -5.391346474722455],
            [0.8533601950213565, -5.383736010180775],
            [0.8498049843613678, -5.380825502267701],
            [0.8454698623318776, -5.379885240082439],
            [0.8391794880238316, -5.3846645291419515],
            [0.8351336872639931, -5.382817204026873],
            [0.8343370631965817, -5.386117701439731],
            [0.8312153102029118, -5.387946506725784],
            [0.8197634764366794, -5.384341216020626],
            [0.8185204232653478, -5.386488832091667],
            [0.8124489186986911, -5.386109842553697],
            [0.811197594639505, -5.381566624343729],
            [0.7989312403561631, -5.385322216244052],
            [0.7958952911637093, -5.388398194792089],
            [0.7872172354821476, -5.39071444411494],
            [0.783238863593809, -5.395420509305836],
            [0.7824971425209707, -5.402389595045396],
            [0.7764885296212272, -5.408059484637392],
            [0.7744303949965341, -5.408056557211875],
            [0.767655186090625, -5.416418768538206],
            [0.7605591976277649, -5.419793211817921],
            [0.7590277694957077, -5.42860862910622],
            [0.7538520553072202, -5.430851680194174],
            [0.7485068425890496, -5.429700470888769],
            [0.7426022469007064, -5.430638500765558],
            [0.7346173942537628, -5.438855240118553],
            [0.7307865234790631, -5.437307816398178],
            [0.7266802626198607, -5.440991583817419],
            [0.7207919619395546, -5.439887441774902],
            [0.7188019749785975, -5.4337674108112335],
            [0.7107709182168058, -5.434781027483407],
            [0.704199538413563, -5.439460466397755],
            [0.7021129292131817, -5.43827415683614],
            [0.698386536656032, -5.44062639964027],
            [0.6908577612947318, -5.436222631764978],
            [0.6845772911863905, -5.439708984286724],
            [0.680070808453329, -5.439081010584603],
            [0.6779600240802389, -5.444112707704248],
            [0.6707860715444007, -5.442983271892217],
            [0.6645042087852545, -5.44453276588604],
            [0.6659598508821443, -5.452991344716404],
            [0.6601235729534102, -5.4541043736070085],
            [0.6608364006082419, -5.456569885823179],
            [0.6577506159756619, -5.461932897677778],
            [0.6533394021216908, -5.464397764540206],
            [0.6526620195998022, -5.46762518355443],
            [0.6483488133129776, -5.473123844377014],
            [0.6473218965125822, -5.481157898375694],
            [0.6426217376570914, -5.485758077544948],
            [0.632793183162115, -5.487440033980341],
            [0.6242903210690102, -5.4920931451831185],
            [0.6230993551178216, -5.496775015866385],
            [0.6132148300054182, -5.500109925669207],
            [0.6011036908723648, -5.50924497869735],
            [0.5956991784186502, -5.506751189151789],
            [0.58584659925184, -5.518293658332511],
            [0.5808509809073559, -5.51926005808586],
            [0.5786139176406915, -5.522193023893225],
            [0.5788709248299398, -5.462781142041735],
            [0.5801585348293054, -5.3880167858884604],
            [0.5804816791877813, -5.382709871860617],
            [0.5808682453999221, -5.331566227896967]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -95.67215119148743,
          "lat": 33.386307822196805
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48119"],
        "coty_name": ["Delta"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Delta County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "01383846"
      },
      "bbox": [
        0.5786139176406915, -5.522193023893225, 1.0388088770049342,
        -5.245257979093508
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.5901390107823459, -10.072431088341462],
            [-1.5219930558490826, -10.019049282298113],
            [-1.4726657382374937, -9.980340698983134],
            [-1.4233475803909148, -9.941617745184637],
            [-1.4022452059990405, -9.925487313553646],
            [-1.3904664975926808, -9.915559367803736],
            [-1.3781203066185859, -9.905922984607928],
            [-1.3391588501995488, -9.953795358534334],
            [-1.2984804938775207, -10.00272613579978],
            [-1.373336318908165, -10.02793770210734],
            [-1.3346739406178496, -10.10492138299288],
            [-1.3073662613232653, -10.159130467016606],
            [-1.2848771771848608, -10.204138705750939],
            [-1.2579015314539945, -10.259276535997937],
            [-1.224667627013807, -10.325768141099282],
            [-1.1673311742370505, -10.44052176574902],
            [-1.1664658859439294, -10.441364065562324],
            [-1.1495959457341787, -10.475688641533065],
            [-1.1354579563936442, -10.503536385428237],
            [-1.1434881137917159, -10.509823690717875],
            [-1.1619618184918794, -10.523844434574253],
            [-1.1932680070713242, -10.548418574175585],
            [-1.221092651766471, -10.5697078219486],
            [-1.2157520514460503, -10.57036262691188],
            [-1.2170302650039981, -10.579467938589378],
            [-1.2161094215673809, -10.58429161989396],
            [-1.2208090161192975, -10.584326609463929],
            [-1.2242769935291438, -10.585953515188402],
            [-1.2255934040195293, -10.590893657762075],
            [-1.2252550719492126, -10.5953940248192],
            [-1.2224189797936695, -10.59598887537529],
            [-1.217347809762685, -10.601792274423742],
            [-1.2142109249159085, -10.607430873285132],
            [-1.2192355762895384, -10.607318502050857],
            [-1.2194880244263095, -10.615196734587805],
            [-1.2144099753212276, -10.621822373860988],
            [-1.2106159339036544, -10.619725626957752],
            [-1.2081593124366705, -10.6228842072487],
            [-1.2044295777323355, -10.623135269744768],
            [-1.2037044385885933, -10.626220711801334],
            [-1.2631730692658025, -10.625035940713573],
            [-1.3931667363972065, -10.621706638294976],
            [-1.5156159528075974, -10.618532865203248],
            [-1.603105409746373, -10.616627820059458],
            [-1.6005609276158543, -10.51508775896586],
            [-1.5980261712850443, -10.41248792773513],
            [-1.5974118782116016, -10.38382551720095],
            [-1.5950779444119652, -10.297785609982492],
            [-1.5935488571510246, -10.233992047343456],
            [-1.5901390107823459, -10.072431088341462]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.12481669191646,
          "lat": 28.351396362586808
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48297"],
        "coty_name": ["Live Oak"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Live Oak County"],
        "coty_fp_code": "297",
        "coty_gnis_code": "01383934"
      },
      "bbox": [
        -1.603105409746373, -10.626220711801334, -1.1354579563936442,
        -9.905922984607928
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.6176564755321566, -6.98820341480049],
            [-0.6076515392411416, -6.982858585653932],
            [-0.5409607567972631, -6.944643217063609],
            [-0.4621456086363966, -6.900554622757523],
            [-0.4131812670954279, -6.873414616229486],
            [-0.3849242340732516, -6.924362180266687],
            [-0.35313032642469894, -6.981115165219669],
            [-0.32589155347766996, -7.0280619028472255],
            [-0.28656842868742366, -7.095143123693918],
            [-0.27725999007946195, -7.110656002326463],
            [-0.24409759137818238, -7.1678677287083845],
            [-0.21643261890966156, -7.215010342488742],
            [-0.25977770107973985, -7.240493725738825],
            [-0.2906772607372602, -7.259288782973904],
            [-0.3219507030549371, -7.277888955288746],
            [-0.36906309860906883, -7.30562684202208],
            [-0.4338907652912712, -7.342766176711679],
            [-0.4496181926990635, -7.351479074964385],
            [-0.4791705688364707, -7.368509812667846],
            [-0.49905883288373665, -7.380224218442017],
            [-0.5555884670707315, -7.412522954500803],
            [-0.5812621748680274, -7.427714075482288],
            [-0.594293070111185, -7.434569776588985],
            [-0.6246616615844353, -7.451993897709129],
            [-0.6807813306416675, -7.486636984345376],
            [-0.7436875287460799, -7.410106873204758],
            [-0.7790096951298972, -7.3486411916106045],
            [-0.7812158656534285, -7.345825704177713],
            [-0.7912616292708927, -7.327318180580147],
            [-0.811256468596446, -7.292861969894292],
            [-0.8255296698423766, -7.267362903306251],
            [-0.8679341535414165, -7.193075845349585],
            [-0.8979795501493995, -7.141201181337014],
            [-0.8765914644351543, -7.130561548629392],
            [-0.8244013745133767, -7.101721413483688],
            [-0.7913868149857799, -7.083647033129584],
            [-0.7870545318708491, -7.080616202464211],
            [-0.7271605586606045, -7.048272635958492],
            [-0.710920964527183, -7.0396486373302105],
            [-0.6681348530039317, -7.015912186267266],
            [-0.6176564755321566, -6.98820341480049]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.20178491670724, "lat": 31.55235480930432 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48309"],
        "coty_name": ["McLennan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McLennan County"],
        "coty_fp_code": "309",
        "coty_gnis_code": "01383946"
      },
      "bbox": [
        -0.8979795501493995, -7.486636984345376, -0.21643261890966156,
        -6.873414616229486
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.029874858313747, -7.712681796381014],
            [-5.980787205166179, -7.661509147786096],
            [-5.931708212758936, -7.610320304277817],
            [-5.882637828675568, -7.559115387933883],
            [-5.833576000331589, -7.507894520960796],
            [-5.77664308140417, -7.447456559233531],
            [-5.7197216846868875, -7.3869969749950455],
            [-5.62326504134478, -7.285484614411536],
            [-5.5268405772969285, -7.183912523312294],
            [-5.49464386768569, -7.150074051994881],
            [-5.489325302990865, -7.15623497700815],
            [-5.484894428165936, -7.158111282687279],
            [-5.483990798471891, -7.162525336338578],
            [-5.477984204800214, -7.1663708424245085],
            [-5.469462557542394, -7.167461681143034],
            [-5.464275268609996, -7.165762167655291],
            [-5.457629074270647, -7.172748164871164],
            [-5.451833992826233, -7.16965826643398],
            [-5.45052507347145, -7.17195129037041],
            [-5.4404916735211435, -7.17257485102384],
            [-5.43931037233028, -7.176267268317963],
            [-5.430482480371427, -7.175947288493717],
            [-5.42848163566687, -7.186094074548218],
            [-5.424121655507715, -7.189155664349786],
            [-5.421185772144059, -7.187811649771654],
            [-5.413239526510987, -7.190737725203437],
            [-5.407889219730252, -7.193639279238755],
            [-5.4035884989415734, -7.199293132752524],
            [-5.403695889880293, -7.203470570586399],
            [-5.400349163797348, -7.206094049700732],
            [-5.38640538150581, -7.210946843753522],
            [-5.383552211891158, -7.213070783571552],
            [-5.381887529804456, -7.217809581543365],
            [-5.385226456721928, -7.218020783434259],
            [-5.3859656900432835, -7.2239563150472],
            [-5.374750487336201, -7.233291990779009],
            [-5.371074634532262, -7.23460282603127],
            [-5.370208332264773, -7.237276262979075],
            [-5.362730934474486, -7.240125872928963],
            [-5.359318289727406, -7.244017504322237],
            [-5.354729256549595, -7.245541569451977],
            [-5.352306857042183, -7.251332297675753],
            [-5.3477485476208955, -7.2562283259487295],
            [-5.3471771591754935, -7.2600389514107375],
            [-5.344427712053277, -7.26516172687657],
            [-5.341813252950947, -7.262703350753333],
            [-5.335360399699521, -7.259873690880076],
            [-5.323868413858675, -7.252454453477548],
            [-5.319089071556262, -7.252372008825756],
            [-5.310878207873021, -7.249987691773245],
            [-5.306541570023381, -7.246093258346956],
            [-5.300558177044443, -7.242475932491545],
            [-5.293445298491992, -7.241946446317892],
            [-5.291059469892922, -7.241708982208623],
            [-5.283709853666051, -7.245179868755257],
            [-5.285304369236401, -7.253050961875732],
            [-5.282499758952068, -7.257344094113771],
            [-5.279126532806629, -7.2549622864311205],
            [-5.272728212182784, -7.254013253740858],
            [-5.262123893865013, -7.250244805224278],
            [-5.264034022968758, -7.245692882185371],
            [-5.263326793358932, -7.242261303663971],
            [-5.257610882998113, -7.233678380175184],
            [-5.256321440447821, -7.229977114977923],
            [-5.242081702824733, -7.228270114333893],
            [-5.235914543853431, -7.2252528405454015],
            [-5.230946625989827, -7.221441453166558],
            [-5.224654106395374, -7.218554853315472],
            [-5.211091306595908, -7.213494228817662],
            [-5.206652424825792, -7.215087464939307],
            [-5.204048629420754, -7.220741841348466],
            [-5.2043572475744835, -7.225113138802622],
            [-5.201470432238949, -7.227909343347987],
            [-5.194749426520589, -7.22993414761116],
            [-5.18922343817442, -7.229513845158596],
            [-5.1850139296751765, -7.233697779846267],
            [-5.182809078582987, -7.23865053802118],
            [-5.1812071276351, -7.245513448956412],
            [-5.18162030525708, -7.249667488076294],
            [-5.1785000503418495, -7.249900852980829],
            [-5.1760832869325615, -7.2529366324003615],
            [-5.171442578756965, -7.251966702200694],
            [-5.170249638026363, -7.254555247676398],
            [-5.165513892097886, -7.255305097513597],
            [-5.166125549833772, -7.258821549947218],
            [-5.160747474869332, -7.261562525945415],
            [-5.156320029088848, -7.268865837068581],
            [-5.1563773993242865, -7.274197669536796],
            [-5.151986243987048, -7.276981441969486],
            [-5.150082925629806, -7.281716871057413],
            [-5.141657293666678, -7.2829948936576105],
            [-5.1383447864364475, -7.28155847506053],
            [-5.131489098968461, -7.274375337398663],
            [-5.128244972507742, -7.277236601936097],
            [-5.121094561538471, -7.27870034153892],
            [-5.1196432231259035, -7.280231796300593],
            [-5.11335287808046, -7.279791830302443],
            [-5.099076143131396, -7.283864800235882],
            [-5.096800923781823, -7.288626065758176],
            [-5.088084118916917, -7.287254237003407],
            [-5.078185552152171, -7.291119447289167],
            [-5.074821361480211, -7.294216897577577],
            [-5.074760017939471, -7.296862105607723],
            [-5.07092419997643, -7.300418400622136],
            [-5.066390548363638, -7.30650111834018],
            [-5.064780085754954, -7.311107018557854],
            [-5.0623502188013, -7.31094267694688],
            [-5.055140944010817, -7.31622721315778],
            [-5.050785914158267, -7.323161384218202],
            [-5.041648750891132, -7.326805098916245],
            [-5.044561897648009, -7.329385485879205],
            [-5.042502731894066, -7.333442159317176],
            [-5.034876002266975, -7.330883705482964],
            [-5.031399784303592, -7.333677985643921],
            [-5.031631983522296, -7.337451027007348],
            [-5.029482994496223, -7.340483797105007],
            [-5.026444017137787, -7.339355905474233],
            [-5.020464309945705, -7.346373084430926],
            [-5.01862602468508, -7.357144825570324],
            [-5.013425246397229, -7.36364965460468],
            [-5.012654379633251, -7.368802212137306],
            [-5.0139158831108785, -7.371532111014629],
            [-5.010941231134042, -7.375200816534721],
            [-5.013904194243013, -7.380118285900679],
            [-5.013493828240339, -7.386673455446663],
            [-5.011956141152092, -7.388375437579019],
            [-5.010667028646573, -7.39910514233899],
            [-5.0127753455987, -7.402576703795906],
            [-5.011409831776572, -7.405052819164961],
            [-5.016490761648618, -7.410898487456045],
            [-5.013898310238419, -7.420400499603222],
            [-5.015964712212083, -7.422335878272663],
            [-5.016829911906922, -7.428604804354745],
            [-5.014581012377547, -7.435095655716246],
            [-5.010408651974976, -7.436630042682245],
            [-5.008385270976732, -7.441673510806656],
            [-5.006590096048177, -7.449893125436437],
            [-5.003731686801983, -7.454580347517774],
            [-5.003072008011065, -7.460154044338019],
            [-5.000410427307848, -7.46052865879064],
            [-5.00054809261501, -7.467539303054543],
            [-4.9949281962743415, -7.469518393621665],
            [-4.988685824447637, -7.468005395254241],
            [-4.985820269080015, -7.469235564562918],
            [-4.970736800131042, -7.472291702881065],
            [-4.9668315034019495, -7.4760657353152284],
            [-4.964488849671971, -7.474863702383376],
            [-4.9590778907971425, -7.483687970674098],
            [-4.952766398956705, -7.485957062553888],
            [-4.945228910136052, -7.491409038243312],
            [-4.939058238543906, -7.492324884233204],
            [-4.927665035962694, -7.499499258338539],
            [-4.926825630602825, -7.507965487989017],
            [-4.920305914288515, -7.507614002322781],
            [-4.915716649671481, -7.509171262411812],
            [-4.914473145333808, -7.515894379756487],
            [-4.9072997642102125, -7.524755478244856],
            [-4.896817184800489, -7.527736192144338],
            [-4.895898861537657, -7.529214670845696],
            [-4.8879198354221405, -7.526470606985899],
            [-4.884685165933837, -7.528633839708945],
            [-4.880390790913551, -7.524497651398755],
            [-4.875652523300651, -7.522625730932318],
            [-4.870635084504325, -7.523686005015465],
            [-4.866050245967926, -7.522805164439423],
            [-4.860789063220905, -7.5274198031064055],
            [-4.851129950463177, -7.530341865434719],
            [-4.846225800800164, -7.5310144874362175],
            [-4.8409045976744105, -7.533940284690009],
            [-4.836835080589884, -7.532670590345108],
            [-4.831071901605743, -7.537442125122883],
            [-4.828674491523215, -7.544165717795997],
            [-4.829469419794511, -7.547212471677094],
            [-4.824226075998462, -7.556587182817511],
            [-4.825443624952433, -7.560058874204538],
            [-4.821642218290238, -7.563529284879405],
            [-4.817432745404922, -7.559859317526952],
            [-4.8175694887668294, -7.5520669389005075],
            [-4.813644675347252, -7.550789801181283],
            [-4.8098296950598, -7.553270163056077],
            [-4.810008166777599, -7.558662559528144],
            [-4.808146781289928, -7.560817394949423],
            [-4.799226775905973, -7.562892773986148],
            [-4.797981122398781, -7.561667610982661],
            [-4.789239183069498, -7.561702666866913],
            [-4.782437594903414, -7.572621679919484],
            [-4.779353865446923, -7.574669761369514],
            [-4.773237438458697, -7.573288170605766],
            [-4.7690217231250545, -7.56909624525219],
            [-4.764934916429831, -7.570996759247898],
            [-4.759564999852049, -7.575885425330718],
            [-4.757911307586935, -7.579179374282151],
            [-4.751444571420082, -7.579495403514873],
            [-4.748115973578097, -7.576792314752461],
            [-4.743289393424716, -7.576301729621576],
            [-4.738064215269648, -7.579573490920412],
            [-4.736303619844462, -7.58362492275058],
            [-4.732593603112668, -7.583201186063134],
            [-4.730700618944021, -7.585978593321316],
            [-4.723380606451221, -7.584093928010172],
            [-4.715866136701729, -7.579823805681088],
            [-4.7097695869145175, -7.574980041233483],
            [-4.708554443560234, -7.576761630815227],
            [-4.703477555414111, -7.5716516031408245],
            [-4.701719985890251, -7.574173787712571],
            [-4.69434153452005, -7.575401752410292],
            [-4.689038794368509, -7.578382279866002],
            [-4.683927858344889, -7.577612228800857],
            [-4.68390513390217, -7.5826977447496535],
            [-4.679783868857721, -7.5881745138055985],
            [-4.672939453436301, -7.59345138612638],
            [-4.670936032298071, -7.597080889104078],
            [-4.6667383379088125, -7.59544251746064],
            [-4.665200767746559, -7.591225291571303],
            [-4.659220825561854, -7.591781386253296],
            [-4.65487280172878, -7.58812347704419],
            [-4.647003621690782, -7.5907744278353215],
            [-4.643214952414859, -7.595611587435534],
            [-4.638764810226108, -7.598064007377324],
            [-4.633709884424064, -7.60354333577776],
            [-4.632819526303634, -7.60614299271536],
            [-4.628831562004444, -7.608305930953813],
            [-4.621894353530385, -7.6237118434116296],
            [-4.608361129956935, -7.622474033196055],
            [-4.607732917514004, -7.626448387413172],
            [-4.60937676502175, -7.6299890159547985],
            [-4.602188037953253, -7.630685338871074],
            [-4.59613122754535, -7.634543106700239],
            [-4.593699398355772, -7.640299854861683],
            [-4.595470306967879, -7.645798711453883],
            [-4.581712718565916, -7.6544250717130335],
            [-4.577970349174201, -7.6525662088558315],
            [-4.571939629964586, -7.655419200147494],
            [-4.565345059550219, -7.657114253121462],
            [-4.560741953034849, -7.662924981178974],
            [-4.561025799270439, -7.665671062267475],
            [-4.558370860868589, -7.671302084507963],
            [-4.564778800614887, -7.675169945844509],
            [-4.567451221492634, -7.681675669390798],
            [-4.570996821837188, -7.685278588714092],
            [-4.5740879105985774, -7.691913458578594],
            [-4.570647315587733, -7.697132535432055],
            [-4.563790063358262, -7.699235433563171],
            [-4.559154935708669, -7.70416667261139],
            [-4.5523038163430165, -7.706752021660758],
            [-4.547013827870552, -7.713413042976737],
            [-4.545265254330674, -7.721085665020505],
            [-4.542352969435698, -7.726093234545857],
            [-4.543663081332596, -7.732482386124053],
            [-4.5419641472160155, -7.7383612863646345],
            [-4.537827539045023, -7.743049809907166],
            [-4.540307081187406, -7.7497892692680175],
            [-4.540412954501696, -7.755452968364433],
            [-4.534565539573029, -7.762564659106269],
            [-4.53099305459164, -7.7705792972096415],
            [-4.531289099979585, -7.775489341282601],
            [-4.528599924413105, -7.782733943448576],
            [-4.529237008901233, -7.788966631139915],
            [-4.532437673931894, -7.795648187619626],
            [-4.5368162855742575, -7.798605081294346],
            [-4.533107275889954, -7.810010544964139],
            [-4.534852397282008, -7.815968000438454],
            [-4.537353915175612, -7.819832130286137],
            [-4.529393559740829, -7.828798468766028],
            [-4.524293873235845, -7.827181985586946],
            [-4.518274604067752, -7.832838599664079],
            [-4.517091408369864, -7.84169001206808],
            [-4.518787866052159, -7.844151329822156],
            [-4.517358513293726, -7.850511781719382],
            [-4.5131739534699085, -7.8597643348970045],
            [-4.515385553324408, -7.875093762535802],
            [-4.514295751589145, -7.885327620477697],
            [-4.509458439413172, -7.888444031463597],
            [-4.502395638955052, -7.889116031593043],
            [-4.50306219197144, -7.894564235633008],
            [-4.499070508311626, -7.895224275270239],
            [-4.4963000855505895, -7.898120338727624],
            [-4.492749604986374, -7.898690741642748],
            [-4.488612508204614, -7.904919840509769],
            [-4.486590684311246, -7.912949923010287],
            [-4.487303297188277, -7.915581811415348],
            [-4.484701844857137, -7.921669918384375],
            [-4.484609307067871, -7.930458445880887],
            [-4.483729642984123, -7.933357077583748],
            [-4.4845111205010975, -7.933019605150559],
            [-4.582248882851846, -7.926671687404449],
            [-4.679985416080404, -7.920306218056709],
            [-4.682324879913625, -7.919317151909424],
            [-4.711403845981241, -7.9171579457840995],
            [-4.799906185096734, -7.910826662290769],
            [-4.804225955931099, -7.968707888726736],
            [-4.864457679952024, -7.964390154124737],
            [-4.979456773238871, -7.9560649741277665],
            [-4.988684020179085, -8.093510032861],
            [-4.988643270008656, -8.093991959070348],
            [-5.000566496361857, -8.267476736285001],
            [-5.134722186156324, -8.258894119831544],
            [-5.13591795755982, -8.258691847280808],
            [-5.1931626263843516, -8.2553536574332],
            [-5.209192744546373, -8.483134441192316],
            [-5.255937030389001, -8.439230867625412],
            [-5.291912133599244, -8.405572809840805],
            [-5.3634870180351175, -8.33861117600404],
            [-5.435041038003579, -8.271620128955846],
            [-5.506574335990197, -8.204599931883912],
            [-5.578087054817015, -8.137550848086875],
            [-5.666089398628629, -8.055021895114562],
            [-5.7176862419673355, -8.00657579271462],
            [-5.72223407283486, -8.001669122347028],
            [-5.761718678556998, -7.964992777849195],
            [-5.821929698362363, -7.908572052623734],
            [-5.838108003361263, -7.893019106138172],
            [-5.913785101933905, -7.821965491091961],
            [-5.971836470539567, -7.767332621756938],
            [-6.029874858313747, -7.712681796381014]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -102.7235343030058, "lat": 30.78101357957335 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48371"],
        "coty_name": ["Pecos"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pecos County"],
        "coty_fp_code": "371",
        "coty_gnis_code": "01383971"
      },
      "bbox": [
        -6.029874858313747, -8.483134441192316, -4.483729642984123,
        -7.150074051994881
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1486976460757734, -7.908963552748191],
            [1.1700349951571651, -7.887876414977049],
            [1.221592259520116, -7.836486323042089],
            [1.3030629446036475, -7.755773977961334],
            [1.3697179578438197, -7.690773616473513],
            [1.4506835608117308, -7.5858255208189505],
            [1.4518264101022107, -7.5891347526117885],
            [1.4596093872487896, -7.59045369898186],
            [1.462348993568301, -7.593563245053943],
            [1.4680835916488968, -7.593745657028208],
            [1.4717490434819158, -7.599891862206416],
            [1.476606600349054, -7.598619469740684],
            [1.48526636153659, -7.601817743366474],
            [1.490833542331017, -7.601064762530053],
            [1.4940067163322235, -7.6055232614686465],
            [1.5041788030722925, -7.609746651581356],
            [1.5108563407178643, -7.6148061442263675],
            [1.5137256347982597, -7.614298965049774],
            [1.521265346406524, -7.620271336318785],
            [1.5265194593446505, -7.622099757166131],
            [1.5279102112511553, -7.624519160038619],
            [1.5343932132717322, -7.624507189762369],
            [1.540260675122236, -7.62734998497127],
            [1.5572630618044894, -7.623838792389419],
            [1.5691458524213338, -7.631625947616901],
            [1.5760783911085008, -7.631853222674063],
            [1.5801781008178928, -7.634736987818055],
            [1.5909896073780263, -7.634278521051575],
            [1.5914548632713086, -7.637080411547594],
            [1.5966890015304416, -7.637716161017423],
            [1.5984190747801539, -7.641809111648001],
            [1.6047886884665858, -7.641940328173291],
            [1.6088827908058936, -7.645099074441065],
            [1.6119626700448826, -7.641125015502193],
            [1.6116992873905447, -7.6362510261624985],
            [1.6156751168307564, -7.63145361684347],
            [1.6219488816525254, -7.641753001551061],
            [1.6246980480684914, -7.642892438533079],
            [1.6285324595223403, -7.6407367516159015],
            [1.6329933459203738, -7.6459833215691555],
            [1.6397623259267426, -7.642275637889932],
            [1.6444480800935917, -7.645859665504028],
            [1.6507555166312056, -7.647528535451804],
            [1.652643033742087, -7.651500587000129],
            [1.6554665211190032, -7.653337916140605],
            [1.6566622181928223, -7.656985745088488],
            [1.659975555461953, -7.6606214811716855],
            [1.6630414312493358, -7.658580965029198],
            [1.6680630610945189, -7.6629619261064414],
            [1.676888215081916, -7.660162815628261],
            [1.6832262701207836, -7.664234955776407],
            [1.6884561940326295, -7.664419398027843],
            [1.692630633494345, -7.667676915242448],
            [1.691688043877072, -7.669705544150335],
            [1.6103429551496384, -7.717557638604109],
            [1.6126598621667605, -7.729731430255878],
            [1.627173164234465, -7.796272769281158],
            [1.6392682043445845, -7.853114002810814],
            [1.6618539951899722, -7.958553679707745],
            [1.668474825301575, -7.989829107721516],
            [1.6927346403074437, -8.10057364642426],
            [1.6926037719288738, -8.101847926693848],
            [1.713703531382038, -8.197722738813857],
            [1.7196973494383112, -8.225260077545125],
            [1.7209530902378556, -8.233241550430483],
            [1.640780324517396, -8.234868658646892],
            [1.5534666198841407, -8.236606659577385],
            [1.5169002779077525, -8.238122534464404],
            [1.4530943597261152, -8.23441175503313],
            [1.4495305858484009, -8.2330608542091],
            [1.4433575302548405, -8.23402002785661],
            [1.4388753701022319, -8.23215586753725],
            [1.437430078005473, -8.217535892445625],
            [1.4466161509240292, -8.210131452314805],
            [1.4499986586093245, -8.203897357899907],
            [1.4626035692370558, -8.199525899490459],
            [1.466431251408358, -8.19758081150715],
            [1.4694615584657653, -8.188625709352324],
            [1.4688255163274506, -8.186549180935375],
            [1.4580741823239072, -8.182176508573777],
            [1.450302461545374, -8.18406344377802],
            [1.4456095247811016, -8.181898203646183],
            [1.4302922712196944, -8.182590964509988],
            [1.427840433371827, -8.179062101197546],
            [1.4213200786632305, -8.175836393560804],
            [1.4178342293165822, -8.172523500578649],
            [1.4080028452070745, -8.171542328086739],
            [1.399831238356473, -8.167617401057505],
            [1.3853606156832137, -8.171279519962862],
            [1.3793905204981445, -8.171741849591932],
            [1.374240292870817, -8.169931712990689],
            [1.3656536179681404, -8.158672076910676],
            [1.3593365509354978, -8.157517579763267],
            [1.352177245242371, -8.153190763414184],
            [1.3352929945409222, -8.153809462725466],
            [1.327300220907967, -8.15091501232351],
            [1.3184428788073963, -8.150037915469609],
            [1.3108590148777164, -8.152622422593165],
            [1.303328291702756, -8.153007998259334],
            [1.2981295923173946, -8.151871137046331],
            [1.2921617690616132, -8.144825196020864],
            [1.2922550140036622, -8.142190915087715],
            [1.2976831136237938, -8.138825122011918],
            [1.2951935802099674, -8.133190465816591],
            [1.3010689479995394, -8.133193518541296],
            [1.3031630737517532, -8.1301606825945],
            [1.308765245501272, -8.12943564840296],
            [1.3114619819617737, -8.125106381127905],
            [1.3151048318974707, -8.12429087522385],
            [1.3145176591380268, -8.10286907918276],
            [1.308580345099438, -8.103547430760214],
            [1.308175779553972, -8.09638438069533],
            [1.3040598208295267, -8.094269902952746],
            [1.3008020227139492, -8.081096330420602],
            [1.3036418511533527, -8.07999950090696],
            [1.3106670177601674, -8.082224213022684],
            [1.3140978899492548, -8.076214991575997],
            [1.3106371059929296, -8.072661675028579],
            [1.3048555643764697, -8.076384316458164],
            [1.3008804889434689, -8.070451775152303],
            [1.2883823818828704, -8.068216582430948],
            [1.286332411861709, -8.065704080675042],
            [1.2924577996067994, -8.061199930147838],
            [1.292345391503653, -8.056935901316884],
            [1.2885726564291073, -8.055426306888325],
            [1.2817182827158076, -8.059689382551316],
            [1.2757214748391876, -8.060045507170443],
            [1.2748053248416602, -8.051188600251173],
            [1.269665639160079, -8.053031730614766],
            [1.2638324831210004, -8.057907697847146],
            [1.2582824840455222, -8.058842848931413],
            [1.2533262242300909, -8.062156102917033],
            [1.2459297963240183, -8.059518927989584],
            [1.2437236482273606, -8.06084013139792],
            [1.2432065390664475, -8.067360210831083],
            [1.2398746919672934, -8.07087052841374],
            [1.231916646044058, -8.073729161959168],
            [1.2283344448129714, -8.073538179841133],
            [1.223165522827644, -8.07070667782031],
            [1.2220990700352923, -8.067351794836304],
            [1.2262201678020113, -8.061757400676516],
            [1.2257229264336298, -8.057985235879201],
            [1.2196710418532848, -8.056220594715963],
            [1.2191327731348567, -8.05453811537508],
            [1.2228929217628655, -8.043636256884556],
            [1.227548271628014, -8.039157992562947],
            [1.2265326430594445, -8.036983521806],
            [1.2191573303878545, -8.035434443234081],
            [1.2077118733179806, -8.038689427521092],
            [1.2053793216936763, -8.038300498411484],
            [1.2054166569065916, -8.032934702504857],
            [1.2025127640929931, -8.025021092296164],
            [1.1965857349381588, -8.018541816899495],
            [1.1951410702317256, -8.014989644368246],
            [1.195885566842155, -8.009994281294363],
            [1.1981680080600359, -8.007139493997922],
            [1.1987867220902757, -8.00041355020104],
            [1.1958292898939025, -7.991978797740665],
            [1.1968746484230612, -7.98851922462793],
            [1.2035978521131157, -7.985475382958637],
            [1.2059760471152263, -7.982326292635023],
            [1.2082760549321119, -7.973140694695913],
            [1.2048981275180126, -7.964184763881597],
            [1.2012022035667738, -7.956545975687491],
            [1.208158404210362, -7.95101561020698],
            [1.2020652540515275, -7.948133079244155],
            [1.199766201704008, -7.943896381844559],
            [1.1929110094303135, -7.940406174233208],
            [1.1864545698654512, -7.932971136908714],
            [1.1767948318116908, -7.930099926352161],
            [1.171231104337871, -7.9256400922417365],
            [1.1667295515613312, -7.919345250992922],
            [1.165711977627722, -7.914918333931853],
            [1.1581164311869725, -7.914603457535766],
            [1.1548499887719075, -7.909633124335545],
            [1.1486976460757734, -7.908963552748191]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.83007190325803,
          "lat": 30.792640873280785
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48373"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "373",
        "coty_gnis_code": "01383972"
      },
      "bbox": [
        1.1486976460757734, -8.238122534464404, 1.7209530902378556,
        -7.5858255208189505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.3919770838870766, -4.60119030087619],
            [-2.388090733142411, -4.49320537849396],
            [-2.3857337241190204, -4.436374321213127],
            [-2.3861321175587005, -4.436025967429125],
            [-2.385082088897261, -4.412038326814179],
            [-2.38036713619649, -4.289536182775941],
            [-2.3732554675488924, -4.289894194834903],
            [-2.370222684704021, -4.294795246077942],
            [-2.3694542176807647, -4.305355009289895],
            [-2.365598112855991, -4.305770589183179],
            [-2.3646886792554205, -4.300065480411541],
            [-2.3622992582867477, -4.297984589599858],
            [-2.3566268429928328, -4.306723154616705],
            [-2.355383722865009, -4.310098252608284],
            [-2.351157960890333, -4.3155744334564785],
            [-2.345246344209119, -4.315834823646556],
            [-2.343668098287994, -4.3111474400254455],
            [-2.344040875294764, -4.305919055143154],
            [-2.3418350233318637, -4.301857606185964],
            [-2.338692023885617, -4.3014405635478985],
            [-2.3364574876463955, -4.306828366729546],
            [-2.330304444885321, -4.310442525789457],
            [-2.3256545880581028, -4.315041354382004],
            [-2.322179430402352, -4.314284514386775],
            [-2.3169566572153824, -4.308500690375713],
            [-2.315618240738987, -4.292145028779767],
            [-2.311638712706732, -4.282324177991885],
            [-2.3082702483747806, -4.27605396462691],
            [-2.31327694372936, -4.272566535646649],
            [-2.3157583118471057, -4.268318881028041],
            [-2.3153132814025628, -4.2630096879061465],
            [-2.312331607844268, -4.260188848039317],
            [-2.3119664482708093, -4.255868507464],
            [-2.3143637442818, -4.252716118066138],
            [-2.31315941863665, -4.245587947700931],
            [-2.301226012689425, -4.231087409020301],
            [-2.2965423705174324, -4.229333154850699],
            [-2.291843277249514, -4.229646378844128],
            [-2.2831037359292985, -4.232807845296943],
            [-2.2798758265589596, -4.236951316595322],
            [-2.281780965636057, -4.242230635655345],
            [-2.2818900899911507, -4.246650748851321],
            [-2.269711134417617, -4.258227072867056],
            [-2.2638662882336824, -4.261977501332522],
            [-2.259662445812562, -4.26730763139588],
            [-2.256300811635838, -4.275396208428964],
            [-2.2527220430812034, -4.281142478747345],
            [-2.25010087549472, -4.281901619390225],
            [-2.2434125558905427, -4.280314658414635],
            [-2.232079691021595, -4.275317265111212],
            [-2.2254456098819553, -4.277908029598355],
            [-2.22269894693485, -4.283579852324616],
            [-2.2231242768179262, -4.288125409002224],
            [-2.219665513822627, -4.290940997230468],
            [-2.2120314212024703, -4.289548865388568],
            [-2.210436216850673, -4.286541019882054],
            [-2.2052315191343177, -4.288183763113262],
            [-2.2059340702460144, -4.296671450526275],
            [-2.2035695904656594, -4.299727357919296],
            [-2.208372201134675, -4.303578854131662],
            [-2.216069565852956, -4.303825644823122],
            [-2.2169505186918315, -4.30646559142683],
            [-2.2141387513886457, -4.309899185845961],
            [-2.2043704201844867, -4.315053336409297],
            [-2.2040764164704947, -4.319249117864225],
            [-2.2008313337959486, -4.3195923519312265],
            [-2.1960748398682868, -4.316169383453909],
            [-2.191185215912778, -4.3196628007032265],
            [-2.195674566137923, -4.324782679539758],
            [-2.1928025633302872, -4.328633708389893],
            [-2.1870586281332987, -4.325812082618867],
            [-2.186485693195027, -4.334009601540455],
            [-2.1848036772256982, -4.339205573540427],
            [-2.18037405220812, -4.3442783813516535],
            [-2.1852388351272642, -4.351855651652567],
            [-2.1812851229681436, -4.356363127113989],
            [-2.17136285521028, -4.3516667541607665],
            [-2.162933861006973, -4.3552120689497515],
            [-2.1655512453326686, -4.355699132295031],
            [-2.16635403833948, -4.362431631364241],
            [-2.165695995066877, -4.368535492872917],
            [-2.1626672472488324, -4.373517422769146],
            [-2.1633957929032643, -4.376632224671009],
            [-2.1692544603446566, -4.382757670813732],
            [-2.16694338916621, -4.392619265652414],
            [-2.168204484272586, -4.400813799840499],
            [-2.165490833782765, -4.4098810844177025],
            [-2.1594003945782734, -4.412771449627594],
            [-2.156143530108194, -4.412568064051989],
            [-2.1549923859352456, -4.422240811431883],
            [-2.1582185497566413, -4.431340236468933],
            [-2.153339913292077, -4.437816714913498],
            [-2.1581349880062253, -4.449867298042145],
            [-2.153609531922207, -4.462040946094134],
            [-2.1528795072368507, -4.467246841834445],
            [-2.1547211876323673, -4.472205714065485],
            [-2.1549302082608515, -4.477725864426431],
            [-2.1528843618603726, -4.480188969490654],
            [-2.1280579245619244, -4.486476552467244],
            [-2.1263151076580877, -4.488209067986054],
            [-2.11887973256649, -4.486213284525082],
            [-2.1155342410180777, -4.480976709413758],
            [-2.1106601922411588, -4.476718164241657],
            [-2.1027139095255505, -4.4773745044715945],
            [-2.102068502840736, -4.482417009898577],
            [-2.1042244554217446, -4.483933536563639],
            [-2.1058562692596716, -4.488715201506443],
            [-2.1042385061211655, -4.491762973751747],
            [-2.0956420596251655, -4.494714716225993],
            [-2.090291047018151, -4.490797364624497],
            [-2.084961433311748, -4.492097125789917],
            [-2.081560482980486, -4.491418795375924],
            [-2.0798605410895483, -4.4880723907408475],
            [-2.0756801593750254, -4.4852176732949856],
            [-2.0705842346457817, -4.488767657632908],
            [-2.062785148270187, -4.4859611184804935],
            [-2.052167167393413, -4.489433787550844],
            [-2.0472650746333567, -4.493253380133294],
            [-2.0455472974271767, -4.497522360674708],
            [-2.038001717519769, -4.500136383398174],
            [-2.0336370001534356, -4.500276893602916],
            [-2.0274523810890845, -4.491724877906332],
            [-2.0085432271335333, -4.496034196028455],
            [-2.0000333512877386, -4.490713876500079],
            [-2.000276399553516, -4.484992597948715],
            [-1.997983947726425, -4.481871222298249],
            [-1.989731105603958, -4.4781197864982545],
            [-1.9868263355467501, -4.478623035419562],
            [-1.9820784303996142, -4.482430723113869],
            [-1.980113554673471, -4.4898824519126785],
            [-1.9765894335741196, -4.4966921000492315],
            [-1.9702374024871454, -4.499144672015174],
            [-1.9669890443402738, -4.495883395574738],
            [-1.966646685006082, -4.489215573371837],
            [-1.963424023961537, -4.48675945875753],
            [-1.958446753868543, -4.488196670741622],
            [-1.9640059050054528, -4.650844379073666],
            [-1.9688895780544717, -4.802634496353969],
            [-1.9709892071960635, -4.868148273462713],
            [-1.9748171923769222, -4.867861920965782],
            [-2.065460412028579, -4.865084331640257],
            [-2.1701737126352927, -4.861658616129999],
            [-2.401537874008945, -4.853653803772014],
            [-2.3986715879345573, -4.785285666913415],
            [-2.3951084219504777, -4.684242479827722],
            [-2.3919770838870766, -4.60119030087619]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.24099471630991, "lat": 34.08075660123538 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48487"],
        "coty_name": ["Wilbarger"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilbarger County"],
        "coty_fp_code": "487",
        "coty_gnis_code": "01384029"
      },
      "bbox": [
        -2.401537874008945, -4.868148273462713, -1.958446753868543,
        -4.229333154850699
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.299143297430852, 8.464220036684507],
            [17.388436509767626, 8.490507354700332],
            [17.44005634612085, 8.503816846630723],
            [17.495774897993396, 8.519571830351419],
            [17.52946470883964, 8.528166169271808],
            [17.569869189169268, 8.539499711586219],
            [17.594735643485485, 8.546282501950733],
            [17.58956672070357, 8.541808559668087],
            [17.58681624884461, 8.537916009103657],
            [17.58670276624255, 8.532610164914209],
            [17.58077859639753, 8.529841809729184],
            [17.569018023609978, 8.534028652406816],
            [17.566443227118906, 8.533064646509182],
            [17.563064319540242, 8.528417715185585],
            [17.556598663985536, 8.524339171080953],
            [17.55068610497688, 8.51529448561505],
            [17.550876490502258, 8.50783162771065],
            [17.553263361179038, 8.5044754713885],
            [17.56317807410218, 8.49465804252767],
            [17.572087208845147, 8.489629287965476],
            [17.574410287339166, 8.484756941084996],
            [17.57524390377228, 8.478845895476477],
            [17.573779246594086, 8.475757031685752],
            [17.578069347865828, 8.470774066966962],
            [17.578717316056782, 8.462458143392618],
            [17.583000028564733, 8.456333764925818],
            [17.582122699160557, 8.4541740752985],
            [17.587273329442397, 8.45193712908048],
            [17.591617594185294, 8.448595799122977],
            [17.59749643439751, 8.441784057540334],
            [17.60000103014472, 8.440368708902295],
            [17.598653323392448, 8.435791869698603],
            [17.591662052354664, 8.42205823485958],
            [17.594695822996776, 8.42006309451829],
            [17.592586021226513, 8.414329543373675],
            [17.59060691644432, 8.41323484215742],
            [17.588890202853456, 8.407033110285298],
            [17.585677097138387, 8.403878270004414],
            [17.58664736857534, 8.400612333452624],
            [17.58385767076881, 8.395757310303988],
            [17.577048347171278, 8.390563985047542],
            [17.57535324455657, 8.385338561791437],
            [17.578076622751418, 8.381220073873449],
            [17.57542068966127, 8.375518986696928],
            [17.575106686282545, 8.370465281766428],
            [17.57911936264209, 8.366543567159866],
            [17.580584274757634, 8.363173103118777],
            [17.577382894200962, 8.357935389017465],
            [17.576446805393246, 8.346501798775007],
            [17.569515520424016, 8.341995483830715],
            [17.568567808975768, 8.33616675699393],
            [17.569830741887163, 8.333658321066373],
            [17.576150171196687, 8.330205975265454],
            [17.575519109470537, 8.320294798026012],
            [17.57793529088291, 8.316200149487537],
            [17.574370142702424, 8.306443878999808],
            [17.566146080485684, 8.302198915126018],
            [17.564951442467173, 8.299308632611924],
            [17.566203809947005, 8.294768378932751],
            [17.562686087283613, 8.290433030790608],
            [17.561632389010914, 8.285722051521537],
            [17.55759307735648, 8.281195193627678],
            [17.558206191054065, 8.275873527399844],
            [17.556278497007536, 8.272606453222025],
            [17.54682303376789, 8.266220532792968],
            [17.548391964828014, 8.262574550847397],
            [17.551565225886467, 8.26186544434204],
            [17.55390917697015, 8.258102744567696],
            [17.55663927545912, 8.244756696831782],
            [17.563156652588148, 8.245638475561433],
            [17.56346405165643, 8.239793637126747],
            [17.568540952936733, 8.237743892858456],
            [17.569204699698965, 8.235339791215228],
            [17.58202493858263, 8.224931766066522],
            [17.58201026062656, 8.220275867931736],
            [17.586833201666977, 8.21967828583651],
            [17.585527236479656, 8.214042681247895],
            [17.590111133959436, 8.20707960272127],
            [17.59040352438849, 8.200820195694272],
            [17.598053267913876, 8.199437758357513],
            [17.5984899491625, 8.195572200922467],
            [17.601636571854566, 8.188844180964601],
            [17.60252563797863, 8.183729917828579],
            [17.6061927359542, 8.182170689026224],
            [17.611035522903336, 8.182796404920552],
            [17.60905035124526, 8.178331268051656],
            [17.61594444199903, 8.17941491152762],
            [17.61968746166272, 8.182508016868065],
            [17.621879780030344, 8.177402334931358],
            [17.6259178408963, 8.172705176474116],
            [17.6233658676122, 8.167353174770327],
            [17.632688616385188, 8.163044741616922],
            [17.63235176905536, 8.152178445696713],
            [17.63722882308121, 8.141880223968904],
            [17.637205413724498, 8.137498495717495],
            [17.63285412775287, 8.135436195783734],
            [17.63472847883984, 8.132477950528054],
            [17.639497132677707, 8.13186453260324],
            [17.641253676272775, 8.127407418966241],
            [17.65134196831882, 8.126749820331575],
            [17.654396113402075, 8.122712847781775],
            [17.653268702112424, 8.117885818020547],
            [17.649868201575547, 8.113899065279462],
            [17.645244757913446, 8.116346697098793],
            [17.643668498487134, 8.114140610065553],
            [17.650056254769027, 8.108670778582548],
            [17.650001406435855, 8.105542206552535],
            [17.644023997139964, 8.104628996387667],
            [17.644675873857025, 8.098824652202227],
            [17.637849084457677, 8.095335056933283],
            [17.63429697989765, 8.096185911071233],
            [17.624661065930223, 8.095004142007246],
            [17.622173332078987, 8.093697534232064],
            [17.62008371680186, 8.088786370827615],
            [17.621191937389813, 8.081841631613921],
            [17.629573548015475, 8.07742903732646],
            [17.640159295093284, 8.073214919787718],
            [17.642812983066108, 8.070147421626151],
            [17.64236529697286, 8.064665721940589],
            [17.638714217519038, 8.055102421417088],
            [17.631359435750888, 8.051473857851327],
            [17.6339208792506, 8.048267746031632],
            [17.637929012430558, 8.046608858242216],
            [17.642644233162166, 8.040553517262685],
            [17.64784486884509, 8.037699456067797],
            [17.64092354826392, 8.029862858667933],
            [17.636874230148653, 8.031715531833395],
            [17.637901050916884, 8.024159499778781],
            [17.636879779869677, 8.016579853572146],
            [17.63039423691967, 8.012756232571679],
            [17.624252071627428, 8.012844785660182],
            [17.622341271734303, 8.001409253184999],
            [17.61765743867633, 7.99900247798229],
            [17.6154581445099, 8.002730036769494],
            [17.61983091930277, 8.005932444734041],
            [17.61791381733373, 8.00952165056886],
            [17.614456306709236, 8.00829865820378],
            [17.61217673684272, 8.001551925482877],
            [17.608333062678817, 7.997788455891401],
            [17.607410102062627, 7.9943970329375],
            [17.609471762525946, 7.991646496848295],
            [17.615145752691323, 7.988484665188862],
            [17.612993200737346, 7.984005098756448],
            [17.606792804485586, 7.982321550881948],
            [17.60552482580458, 7.976492099212158],
            [17.60679056975498, 7.970094094467121],
            [17.60670532927549, 7.962741962461825],
            [17.605057996685826, 7.958540407846258],
            [17.595029928142374, 7.952398783183976],
            [17.598723624593617, 7.947581928463137],
            [17.594449924037953, 7.945066197599551],
            [17.594447242862998, 7.9416143985750365],
            [17.588046020149243, 7.934104325720512],
            [17.58445000823221, 7.928606342688342],
            [17.576965458747242, 7.922288177176569],
            [17.57111815184325, 7.922122290941529],
            [17.561824005698206, 7.918254338681437],
            [17.559933873992545, 7.909518153446134],
            [17.554821149256277, 7.908756475889765],
            [17.549175009625383, 7.911861531598237],
            [17.542581874994937, 7.910063227050892],
            [17.53531725852972, 7.901507676159574],
            [17.52687505499472, 7.8998030093929055],
            [17.5248936572319, 7.898276958798915],
            [17.520569386734866, 7.891115717039513],
            [17.52054262308735, 7.888033784717647],
            [17.524138092935978, 7.884410624677021],
            [17.522342140493215, 7.881262538057625],
            [17.5185074047687, 7.880815082643135],
            [17.51515979817159, 7.8779715076167545],
            [17.51583720201952, 7.871507198819054],
            [17.51888758144973, 7.869283646262321],
            [17.51751606213594, 7.863665567881113],
            [17.522734461598866, 7.854665181229907],
            [17.519408321037567, 7.849305855744402],
            [17.510162716236657, 7.8440474002940075],
            [17.507663966714883, 7.840924019877905],
            [17.41830896584053, 7.913835124032463],
            [17.435538611574938, 7.932209545865303],
            [17.45716862337482, 7.980370285661506],
            [17.40820369203417, 8.0207578516455],
            [17.438145979686873, 8.09299204263198],
            [17.382476018833938, 8.11556033310241],
            [17.41520026714007, 8.195235286931997],
            [17.331709817112664, 8.22817387287523],
            [17.302874541975566, 8.239017129258114],
            [17.323442703461783, 8.287704923554175],
            [17.328040015041243, 8.296312309250435],
            [17.346354612970018, 8.34387545232282],
            [17.311679875298978, 8.358287353847327],
            [17.30648027238618, 8.401045899509816],
            [17.299143297430852, 8.464220036684507]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.73597918926491, "lat": 44.72758569966711 },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50009"],
        "coty_name": ["Essex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Essex County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "01461761"
      },
      "bbox": [
        17.299143297430852, 7.840924019877905, 17.654396113402075,
        8.546282501950733
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [16.19312116765949, 0.7807783967190964],
              [16.195797221920433, 0.7820652513049505],
              [16.201392918997993, 0.7768743278608083],
              [16.2003697913509, 0.774130952827236],
              [16.196099396746455, 0.7740795787013769],
              [16.19665971325873, 0.7780812387935871],
              [16.19312116765949, 0.7807783967190964]
            ]
          ],
          [
            [
              [16.128284399883224, 0.6578211201030187],
              [16.132094204143907, 0.6613594591690733],
              [16.133728602181684, 0.6559818486578092],
              [16.128284399883224, 0.6578211201030187]
            ]
          ],
          [
            [
              [16.12462897010213, 0.6367351401474669],
              [16.12574293539444, 0.6448419034816885],
              [16.13073700490537, 0.644654068322784],
              [16.13141802254994, 0.6383896039470578],
              [16.125077072424812, 0.6342080824371625],
              [16.12462897010213, 0.6367351401474669]
            ]
          ],
          [
            [
              [16.231133183951425, 0.9527044303573903],
              [16.23316066795938, 0.9562534518126236],
              [16.234046114397216, 0.9628400634103238],
              [16.237922672658172, 0.9673712285577405],
              [16.24151960087189, 0.9645207515126061],
              [16.243544147929892, 0.9667986051293197],
              [16.238710306421858, 0.9711809001855596],
              [16.23882942772716, 0.9749639576060183],
              [16.242839013121625, 0.9781088759455115],
              [16.243460592026274, 0.9837355661074115],
              [16.304899382437046, 1.0045354839611844],
              [16.306275092982958, 1.0048083296320691],
              [16.38307062930287, 1.0308087872666714],
              [16.412612017289597, 1.0406485820668787],
              [16.50359027287353, 1.07227651778363],
              [16.52734479588741, 1.0800627457493506],
              [16.519380887192703, 1.058280361715836],
              [16.50661795072779, 1.0199838308912057],
              [16.50017833610827, 1.0013733411596641],
              [16.496069763860014, 0.9863696070361713],
              [16.48990550490202, 0.9592240606447573],
              [16.48502235812501, 0.9347332139985004],
              [16.480532113268275, 0.9158984986186314],
              [16.47830603495567, 0.9090169251343487],
              [16.474119286549815, 0.9007288863050574],
              [16.466903338728216, 0.893395579648264],
              [16.459585035802714, 0.8832914770386812],
              [16.45709535999266, 0.8829878928390132],
              [16.452819685151216, 0.8869053364712454],
              [16.450092946294074, 0.8945243253831949],
              [16.445132699842702, 0.9017640795409506],
              [16.44872352199026, 0.9067806124492607],
              [16.45235289502321, 0.9069898807420878],
              [16.462112293264763, 0.9024689203403358],
              [16.465012738685694, 0.9001016756957253],
              [16.47071392922822, 0.9022079406918385],
              [16.47787915148737, 0.9153304482442107],
              [16.477302328170882, 0.9223005597688498],
              [16.479103795153247, 0.9248603625801799],
              [16.477913932940282, 0.9288133548271907],
              [16.4736761794591, 0.9293286323796062],
              [16.471276516178595, 0.9268541034455524],
              [16.46148678328508, 0.9268678912801049],
              [16.450603501082036, 0.9244686073984043],
              [16.445479173378555, 0.930029978350254],
              [16.43558606395323, 0.9265906960527339],
              [16.430152633840393, 0.9266548816683008],
              [16.426732104895876, 0.9231871885501388],
              [16.42444691326163, 0.9162858859192186],
              [16.416277178400613, 0.8985672190607956],
              [16.410809073928633, 0.8946506377678125],
              [16.401944318753, 0.8834365428750062],
              [16.38141901898491, 0.8467017965018502],
              [16.369309884661046, 0.8181401749680242],
              [16.36217171490222, 0.7972624688013321],
              [16.356292183627765, 0.7736466766281419],
              [16.35507549714142, 0.765709445172425],
              [16.351750412998204, 0.7530377680905491],
              [16.345806011319493, 0.739695255720993],
              [16.34432574268559, 0.729463523399604],
              [16.342605732521708, 0.7063526424575646],
              [16.34094120384139, 0.6975249682993397],
              [16.337765966198393, 0.6950701111414982],
              [16.33534621710537, 0.6906253878467469],
              [16.33741521023839, 0.6847145004055833],
              [16.337376012381075, 0.6752774639037188],
              [16.339400218947315, 0.666872285520869],
              [16.339403653720947, 0.6353675060066698],
              [16.33784672158002, 0.6258850982689745],
              [16.33364699663378, 0.6149507027010577],
              [16.33367635962357, 0.6056179224447072],
              [16.336731856343462, 0.5907147737013632],
              [16.341833683726914, 0.5743082996543578],
              [16.349417226606327, 0.5758635940083234],
              [16.35286106443503, 0.5705787869297968],
              [16.352222825044095, 0.5660587909856937],
              [16.349276248178754, 0.5616196903765608],
              [16.340849392739567, 0.5371405702340217],
              [16.330236142437737, 0.508085831198735],
              [16.32240093252353, 0.48058287150983814],
              [16.318279787646045, 0.47315898372485365],
              [16.315866390544144, 0.4719527999069627],
              [16.308180866968705, 0.4755734111395631],
              [16.305892205303834, 0.47356698214403914],
              [16.307143196301634, 0.46903377856276646],
              [16.306644407631833, 0.4646890881483614],
              [16.304063774946485, 0.45896375376836174],
              [16.30713870594243, 0.4560569560550684],
              [16.3090164388695, 0.45155953686547196],
              [16.316564266125162, 0.4475403187557785],
              [16.314094920317412, 0.4416522754256068],
              [16.29918307399766, 0.43402464146356223],
              [16.295580925175035, 0.43124847449156883],
              [16.292076601897907, 0.4318465036719094],
              [16.28520685769687, 0.43612308577831166],
              [16.27824709414697, 0.43907780191508367],
              [16.27433995354265, 0.43914400941652587],
              [16.254046658030965, 0.43574791959859727],
              [16.25030151971865, 0.4366810242426371],
              [16.242440207179822, 0.42597467517090387],
              [16.236850888487005, 0.432299308584265],
              [16.23226891757238, 0.4340969476342819],
              [16.220901067183675, 0.4294274236824119],
              [16.216058230794953, 0.43064804400830836],
              [16.21049072952136, 0.43902202213712993],
              [16.211193332850677, 0.44323109356817875],
              [16.215685580694064, 0.44630325503535706],
              [16.218841534690508, 0.4530365915195008],
              [16.222112804754907, 0.45696461010316125],
              [16.22200272397883, 0.45967526335936426],
              [16.21849904577433, 0.4678556647695411],
              [16.220354660301457, 0.4720525783044752],
              [16.214963923326653, 0.47300362279737634],
              [16.211106555277066, 0.47155354935991256],
              [16.207938615169446, 0.48064949603016544],
              [16.216119520967645, 0.4891646430548095],
              [16.217759006809512, 0.4973685976059778],
              [16.176433324449913, 0.5145195230071293],
              [16.171237161734712, 0.5148899213642879],
              [16.16636934827505, 0.5108299820140201],
              [16.161865990247662, 0.511351222886547],
              [16.159710404759494, 0.5085045509171146],
              [16.15376920269243, 0.5059179072511177],
              [16.15039141786157, 0.5066055148932337],
              [16.145386009691236, 0.5051452193219875],
              [16.13938362310276, 0.5018516266740122],
              [16.132979989784854, 0.5029743944865362],
              [16.129026495948732, 0.5062142017279508],
              [16.125499201229786, 0.5068459711590643],
              [16.119949661565787, 0.5022467220604725],
              [16.115106692625346, 0.500317415065911],
              [16.103805840261405, 0.4997839503163826],
              [16.100837061774776, 0.49640427214114535],
              [16.096497481935984, 0.49832097144733023],
              [16.093977475410792, 0.5012952973067512],
              [16.09281226554436, 0.5066252472012664],
              [16.09469476805675, 0.5181857384177951],
              [16.096532882177954, 0.5236533048051475],
              [16.102236878937905, 0.5297226340028902],
              [16.10627455417425, 0.5322419432266182],
              [16.098043703005683, 0.5412719369006028],
              [16.099084361660832, 0.5505933350979693],
              [16.10205033651228, 0.5563517932789768],
              [16.10459854829121, 0.5699089720800851],
              [16.107036522033884, 0.5740199468387156],
              [16.109656930471978, 0.5738047188137353],
              [16.1125562001027, 0.5691785711930257],
              [16.112936532178306, 0.5643018843550865],
              [16.116942230088792, 0.5571888531089142],
              [16.121307271280813, 0.5546260736458842],
              [16.129002968505933, 0.559195898310878],
              [16.131710290932052, 0.564347944605966],
              [16.13192217359513, 0.5677966487629567],
              [16.128707739921154, 0.5725497875554065],
              [16.126437830387182, 0.5715765654559067],
              [16.124484735048746, 0.5784475147702116],
              [16.12183759283026, 0.5832255961641171],
              [16.116267273032168, 0.5847504312720376],
              [16.114644038680474, 0.5873597156337],
              [16.11476843355132, 0.595704526921195],
              [16.113539459473746, 0.5995851526462194],
              [16.115251223378003, 0.6036781352010816],
              [16.12316707892176, 0.6058644991573531],
              [16.121484854762734, 0.6127502423122213],
              [16.12644948761773, 0.6216494907414769],
              [16.128705968857123, 0.6226511540379004],
              [16.13657791551442, 0.6201665847828467],
              [16.140993454511815, 0.6226712654370471],
              [16.143421818851, 0.6268855149437592],
              [16.14113123124688, 0.6330969147534051],
              [16.13692488113084, 0.6331624803327451],
              [16.13518627888328, 0.641240349354076],
              [16.140891266833282, 0.6461598775411052],
              [16.13695195552558, 0.647643087243369],
              [16.13663644355087, 0.650877303683348],
              [16.139836123424235, 0.6528283099322265],
              [16.137589085776046, 0.6557448258559081],
              [16.143179405367388, 0.6598613253435002],
              [16.14190700146095, 0.6644440223041097],
              [16.142552270380364, 0.6680783570424323],
              [16.147415066751627, 0.6729136280026219],
              [16.150663951651495, 0.6790511041755284],
              [16.153400504363095, 0.6782815992267233],
              [16.15821527799221, 0.6846600613612072],
              [16.161116040355417, 0.6800423001016788],
              [16.16563830704093, 0.6824742842214473],
              [16.164774114232983, 0.6847153546978254],
              [16.170254762982104, 0.6915298667718969],
              [16.164546190180733, 0.6968037556452772],
              [16.146298037072462, 0.6878197949870823],
              [16.141679502666875, 0.686791638003599],
              [16.141981905058223, 0.6939550033367049],
              [16.146016757468924, 0.7019330867209956],
              [16.152309423135236, 0.7111700535059899],
              [16.155870822693128, 0.7083289416561872],
              [16.16492725663372, 0.7148776202567526],
              [16.166988055771693, 0.7154835752804442],
              [16.169699390044663, 0.7227659141287784],
              [16.1686199293296, 0.7286472541990255],
              [16.165703787254056, 0.7302499942866186],
              [16.158552647732225, 0.7250188024469241],
              [16.1576025568209, 0.7347128827106749],
              [16.151512233501293, 0.7439744909579329],
              [16.147978541598974, 0.7444735118686561],
              [16.146364071553677, 0.7400503117645209],
              [16.1405833644203, 0.7497965138418387],
              [16.142570089413, 0.7557666411484817],
              [16.145428618619295, 0.7558563007973376],
              [16.15124633987362, 0.7619611302026438],
              [16.15494769684159, 0.7685436096981269],
              [16.16118057339599, 0.7722992487315735],
              [16.172355392505406, 0.77241577950558],
              [16.17827227650414, 0.7680892621994613],
              [16.184627370988693, 0.7650975181582773],
              [16.189697784511516, 0.7596939417226225],
              [16.19653161801214, 0.758455346420165],
              [16.198766083663134, 0.7608801218994626],
              [16.204823335711378, 0.7601529618865842],
              [16.208128898267518, 0.7629071157287283],
              [16.20832137686253, 0.7716809648520424],
              [16.21434663293003, 0.7697844495524876],
              [16.213506328969302, 0.7762962676239061],
              [16.21080813961895, 0.7825997703620087],
              [16.207577121693078, 0.7817055935950381],
              [16.209381386779558, 0.7883046874227363],
              [16.208048654030804, 0.7966490262352838],
              [16.210733445707252, 0.7965519717079288],
              [16.20836419141423, 0.8040972681721118],
              [16.210340606614015, 0.8057126686890316],
              [16.216456019857272, 0.8061331803924257],
              [16.21267611101173, 0.8099682550598385],
              [16.211499179773444, 0.8132042527330813],
              [16.213684518957837, 0.8189141489819326],
              [16.211103214697673, 0.8202938402408193],
              [16.21447744838151, 0.8280830777806575],
              [16.21889980110289, 0.8281897666304184],
              [16.221575584706574, 0.820237942474821],
              [16.227819015494415, 0.8173252852568073],
              [16.23595376272211, 0.8201572510768641],
              [16.23218461453554, 0.8261274215239147],
              [16.237618568341027, 0.8343850607573826],
              [16.232000996406367, 0.8361709933031877],
              [16.227917622067398, 0.8387748600860786],
              [16.2227841758915, 0.8400847385317816],
              [16.218248669534013, 0.8476360672908189],
              [16.220777841592664, 0.8519457310871125],
              [16.226398287221084, 0.8571538716186948],
              [16.224556763525747, 0.8616971101898744],
              [16.224512905774898, 0.8702159191273221],
              [16.21917868684695, 0.8698329733540869],
              [16.217485403194683, 0.8674393689692379],
              [16.209046247023092, 0.8705421020826021],
              [16.21474665616373, 0.8753639334837096],
              [16.214962330957817, 0.8791891879914635],
              [16.20791647107164, 0.8805669895974351],
              [16.205843457381963, 0.878675049549402],
              [16.199888611156734, 0.8772764333312261],
              [16.189869426876264, 0.8767499230248976],
              [16.18388276157169, 0.8717742721791614],
              [16.178542816504557, 0.8692296425474136],
              [16.17139997705492, 0.8706219143288979],
              [16.169953715206773, 0.8685713652321856],
              [16.163541157823268, 0.8669849557184437],
              [16.162145150825516, 0.8703638493285102],
              [16.167206126705036, 0.8706836317191631],
              [16.172230170539397, 0.87293280196367],
              [16.174466112336702, 0.8713825155561619],
              [16.17779705911243, 0.8744279416852798],
              [16.178387219940973, 0.8787211723624537],
              [16.172943847781834, 0.8784148714751732],
              [16.170157947082593, 0.882946430422815],
              [16.174189918327663, 0.8888946232655399],
              [16.179244632622773, 0.8945016005190477],
              [16.1813771961948, 0.8991279460141629],
              [16.183787246164542, 0.9090442370191387],
              [16.188431239413447, 0.9138514786706479],
              [16.19055013135342, 0.9098320260486708],
              [16.196423093550823, 0.9061522257683232],
              [16.204054095586578, 0.9092040727005739],
              [16.213042321886988, 0.9239106533190693],
              [16.224244833854247, 0.9204365083891604],
              [16.236075173492996, 0.921070181607561],
              [16.241617814666853, 0.9235339977073016],
              [16.244432747855917, 0.9337344415243714],
              [16.242189100106682, 0.943607388635608],
              [16.237205081380907, 0.950366007541898],
              [16.231133183951425, 0.9527044303573903]
            ]
          ],
          [
            [
              [15.992151819780261, 0.7596217603644255],
              [15.989247626515242, 0.7751726612131927],
              [15.989615965299423, 0.7804737948669008],
              [15.993229414657119, 0.7796649471984676],
              [15.9983466346197, 0.7727005091127158],
              [16.006513113478775, 0.7682023013990869],
              [16.0110115212677, 0.7676132975757158],
              [16.010399207705383, 0.7618341918186076],
              [16.005398805383635, 0.7542982171065725],
              [16.003543627355633, 0.749636259520695],
              [15.998431027785868, 0.7433099575782212],
              [15.994651294001132, 0.7486905017699449],
              [15.992151819780261, 0.7596217603644255]
            ]
          ],
          [
            [
              [15.97629726006036, 0.8007494183375669],
              [15.979763782842884, 0.7991106753485041],
              [15.984277879812671, 0.7931001095532341],
              [15.983018564872, 0.7909902195805822],
              [15.97629726006036, 0.8007494183375669]
            ]
          ],
          [
            [
              [15.929920303076974, 0.8742523110628564],
              [15.933748077041924, 0.875501546873165],
              [15.970127637938052, 0.8827301716042092],
              [15.968547327355013, 0.8800663777502076],
              [15.968885832155427, 0.874415583309898],
              [15.96424160357927, 0.8758025941067498],
              [15.963461582815386, 0.8781088181801692],
              [15.954126788548916, 0.8720524879270044],
              [15.952414969910627, 0.8653986401933368],
              [15.95819855911961, 0.8557289910769842],
              [15.952099862526664, 0.8517239038106712],
              [15.952161882561297, 0.8465698036646498],
              [15.94971812418525, 0.8455644301857473],
              [15.947680601905555, 0.8520017564877397],
              [15.945000317612118, 0.8565593098955941],
              [15.948345786767144, 0.8680140545720655],
              [15.943901694723785, 0.874612246842965],
              [15.937501282612342, 0.8739249152212923],
              [15.93432504635057, 0.8710231460561559],
              [15.929920303076974, 0.8742523110628564]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.63314975068693, "lat": 37.76431584374514 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51001"],
        "coty_name": ["Accomack"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Accomack County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01480091"
      },
      "bbox": [
        15.929920303076974, 0.42597467517090387, 16.52734479588741,
        1.0800627457493506
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.253118704000999, -0.554329343262862],
            [14.253588244019797, -0.5264932623558446],
            [14.254388493352911, -0.4480702372735135],
            [14.255373112148082, -0.4095301421865561],
            [14.256865825960443, -0.36310878793207024],
            [14.25668061440038, -0.36041831100540167],
            [14.272091400347481, -0.35608576130491537],
            [14.281970214140502, -0.34886667952869904],
            [14.291366964683146, -0.34707086999011977],
            [14.302422364359277, -0.34145769295859524],
            [14.309935545957696, -0.3325007334430769],
            [14.310310032596881, -0.32706986125202653],
            [14.316779272097026, -0.321695827394574],
            [14.325794192426535, -0.32377617166722017],
            [14.330814163994958, -0.3217664380422917],
            [14.335864255666872, -0.3221660757929058],
            [14.339661749363946, -0.32052012422899334],
            [14.352732839065444, -0.3187171571525895],
            [14.355046090326583, -0.3211420578172345],
            [14.363711250954706, -0.31948746039111686],
            [14.367192013614375, -0.31565873776033115],
            [14.36958033775339, -0.3174896218560595],
            [14.376244194873054, -0.31520165730527394],
            [14.383727748508068, -0.311418475947594],
            [14.388727114121343, -0.302483754400895],
            [14.393265813524835, -0.3013472828047594],
            [14.40070187288654, -0.29736030367822913],
            [14.407678748501919, -0.29020381553920194],
            [14.4112537622054, -0.2916200095462704],
            [14.414257413095052, -0.29704702298684516],
            [14.417246130473726, -0.2963388241423699],
            [14.420692250104572, -0.3009533852227619],
            [14.421594171729256, -0.30510800371168284],
            [14.418408031423981, -0.30634691612030196],
            [14.419338599506343, -0.3118607865929469],
            [14.42266877023707, -0.31271153154812803],
            [14.42507872993388, -0.3181561170255876],
            [14.430328610168662, -0.3185949852848046],
            [14.436427242469302, -0.3224232976875839],
            [14.439903267492975, -0.3193190995890929],
            [14.444201355247696, -0.3211612956958032],
            [14.44392459569864, -0.3256337324697988],
            [14.452127184824073, -0.3246905740413438],
            [14.451968201942835, -0.32784795866695604],
            [14.45567309808359, -0.3289789092511297],
            [14.459704135294817, -0.32722782573301806],
            [14.464785791145212, -0.3276275272097092],
            [14.465267775036292, -0.3244796360682976],
            [14.469201091161725, -0.3236642674565732],
            [14.468303770573772, -0.32898349434378377],
            [14.471859602470353, -0.3321183302672543],
            [14.473352512767645, -0.33999508510748033],
            [14.472743715515781, -0.3452595426166843],
            [14.478793986836022, -0.3474982890369101],
            [14.482036519373056, -0.346554648357564],
            [14.482551766356362, -0.35108881623806854],
            [14.488892317752759, -0.3521443125744899],
            [14.498053855102011, -0.35134744580067767],
            [14.507117806849035, -0.35397825339602085],
            [14.51243116690256, -0.3564247221700902],
            [14.516338987095141, -0.35654630225424033],
            [14.51998523180091, -0.361447553727954],
            [14.523787252657886, -0.3597100656689139],
            [14.52599984953254, -0.3610749952814861],
            [14.525735657346821, -0.36594587818623436],
            [14.529252291494908, -0.3680028265073899],
            [14.533423336960569, -0.3638664890995385],
            [14.536057474772312, -0.3661149716141061],
            [14.539902190713864, -0.36603984436311177],
            [14.54871716523998, -0.3697416406700667],
            [14.549387384658374, -0.37469360283875625],
            [14.552608331228624, -0.375324868070047],
            [14.555459500603494, -0.37209896489949457],
            [14.560614293432849, -0.37323140438380553],
            [14.56568932540169, -0.3720268559744484],
            [14.57138093981998, -0.36863486836324044],
            [14.569823588769289, -0.36517016244227646],
            [14.57771114605352, -0.3638980157080817],
            [14.588748478979713, -0.36433024890408977],
            [14.590680130234121, -0.36038421526914644],
            [14.602473890097517, -0.35418374638259076],
            [14.609035036550933, -0.3519161035195586],
            [14.621781996335681, -0.46447686042956593],
            [14.6299316788516, -0.5361946733909616],
            [14.636501194580704, -0.5924101526956076],
            [14.637052683605752, -0.5983003256182637],
            [14.631284564290075, -0.5987677077949247],
            [14.625597269902743, -0.5956915525513509],
            [14.620206790114642, -0.5948874339291179],
            [14.618179631115883, -0.603152316496369],
            [14.613313666123226, -0.603893978691318],
            [14.60675151294559, -0.5994799422962199],
            [14.597865457091855, -0.5964967406727788],
            [14.588010185583562, -0.5915597126754195],
            [14.577343425264608, -0.5911504244423191],
            [14.57211189690588, -0.5872120851772978],
            [14.567043392803367, -0.5907427997600129],
            [14.570172196296959, -0.5934140182136776],
            [14.570645844498856, -0.6000965323738237],
            [14.563658223613393, -0.6028412703895006],
            [14.559279086408278, -0.6025515299137536],
            [14.545958533469337, -0.5988258729996143],
            [14.53579648655432, -0.598401016283309],
            [14.522132147738338, -0.595372962634653],
            [14.51467114047666, -0.5965987958286566],
            [14.509372645622161, -0.5960285885635469],
            [14.501805812975638, -0.5988751511063771],
            [14.497695606749177, -0.5980316141217913],
            [14.489445952275542, -0.5986079704657438],
            [14.481204383627624, -0.5968083450601968],
            [14.474948322389032, -0.6003934260501363],
            [14.469772920494268, -0.5968370387866483],
            [14.464549682759444, -0.6001785863555142],
            [14.461856013757767, -0.5939640535045263],
            [14.457889565556195, -0.5952099419061047],
            [14.447909004413685, -0.5918039529238315],
            [14.440143272298025, -0.5914093515933362],
            [14.434254560841396, -0.5936701628785555],
            [14.430209160678492, -0.5919387142627555],
            [14.419256604183547, -0.5847387536282425],
            [14.418312354829323, -0.5803325988276773],
            [14.41367552082734, -0.581440577976487],
            [14.409807205067288, -0.5797940445137475],
            [14.408434647589695, -0.5745757680467705],
            [14.403390043001659, -0.5725392629744481],
            [14.399605567573644, -0.5734160992269944],
            [14.396360432739439, -0.5706880669658669],
            [14.39122326761204, -0.5718200722777599],
            [14.386398305625447, -0.5707058740760851],
            [14.381399749147382, -0.5768427638287007],
            [14.377532139106792, -0.5789811541881189],
            [14.373307211713145, -0.5782484707153202],
            [14.368339645531037, -0.5707662876106807],
            [14.362803421181907, -0.5662371841786787],
            [14.35513145141877, -0.5662236895292597],
            [14.350929929608723, -0.5701213621215803],
            [14.346924935280672, -0.5663805544295357],
            [14.340116416723385, -0.5697443397996311],
            [14.334835565066895, -0.569249713455688],
            [14.331098861414686, -0.5755426534052105],
            [14.32677053487621, -0.5751062675832858],
            [14.320300958745731, -0.5780768432423996],
            [14.316848770107189, -0.5815895270344371],
            [14.313875240770603, -0.5758793732663018],
            [14.306879084800926, -0.5717236126252844],
            [14.30583853204737, -0.5651721516861067],
            [14.303014563122987, -0.5649246810870026],
            [14.299153429491604, -0.5679727723064978],
            [14.294314148483206, -0.5693463939013027],
            [14.2887660756587, -0.5674216541525776],
            [14.2798258982396, -0.5692098173031974],
            [14.275715617694656, -0.5656653049550677],
            [14.269760889422688, -0.5625478439429316],
            [14.268524220501366, -0.560475902019377],
            [14.262351021504323, -0.5613475616524451],
            [14.253118704000999, -0.554329343262862]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.24052999117019,
          "lat": 36.946186167604374
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51111"],
        "coty_name": ["Lunenburg"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lunenburg County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01492239"
      },
      "bbox": [
        14.253118704000999, -0.603893978691318, 14.637052683605752,
        -0.29020381553920194
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.244915395542735, -0.9705741853573536],
            [11.268703456777745, -0.9458552131438429],
            [11.274733485432458, -0.9382075788518194],
            [11.278687021626112, -0.937323924724791],
            [11.282298646271975, -0.9340127691031632],
            [11.28776524090784, -0.9402661729053093],
            [11.293836420126585, -0.944631670747402],
            [11.296801283126902, -0.9443888400970089],
            [11.30331011168113, -0.9387479990264868],
            [11.307212117840503, -0.9340607958024811],
            [11.308644965343946, -0.9294037381075071],
            [11.311435756971413, -0.9288091469036924],
            [11.315542075248837, -0.9248720328625049],
            [11.339038644796535, -0.8956146313640659],
            [11.340391426091397, -0.8986022307958704],
            [11.349363046440729, -0.898423101158998],
            [11.351076316044397, -0.8897636139329411],
            [11.359153994885595, -0.8823510762284988],
            [11.363918404919781, -0.882416993377524],
            [11.366215205505567, -0.885389337058361],
            [11.369205957812564, -0.8818109923190437],
            [11.374284643733963, -0.8796240454229369],
            [11.382246547467638, -0.8793725387363148],
            [11.384204987687461, -0.8759848457277022],
            [11.393527600706394, -0.8789996652835511],
            [11.397686079472617, -0.8763503577235789],
            [11.402676718865749, -0.877478536274201],
            [11.407945151401659, -0.8717385525618729],
            [11.406128222246872, -0.8691935968360214],
            [11.41016300703651, -0.8648370332911726],
            [11.414132617489152, -0.8656095967248687],
            [11.423659255435973, -0.8732135682979651],
            [11.432657464813078, -0.8745591581329634],
            [11.438097871471397, -0.8672258309117974],
            [11.44197822950771, -0.8665069095037303],
            [11.446599950478934, -0.8622563160183476],
            [11.449511637348586, -0.8643641672557668],
            [11.457491033195065, -0.8603655712569612],
            [11.460999476634857, -0.8521686397125919],
            [11.463141314859318, -0.8424100715185875],
            [11.473078955837853, -0.8376182858391282],
            [11.472202462957195, -0.8337738140056008],
            [11.469569861124722, -0.8317541186031268],
            [11.473755685171012, -0.8268237898039584],
            [11.47302078498847, -0.8229328066501822],
            [11.468383578132396, -0.8228094900979813],
            [11.467830331786086, -0.8154101880913812],
            [11.4701171237238, -0.8148519461418103],
            [11.470104027818603, -0.8090627459603552],
            [11.472155099657003, -0.8072012643476437],
            [11.46894385771573, -0.8037833790976637],
            [11.470472767455393, -0.7988260762863956],
            [11.473445850774551, -0.797961798789952],
            [11.471390469034171, -0.7931192930013293],
            [11.474829363279145, -0.7889483019548411],
            [11.480284071411063, -0.7854201185742934],
            [11.485783101343145, -0.774322494224668],
            [11.489025453200775, -0.7791099479495557],
            [11.495347630248464, -0.7790578341850566],
            [11.49619378150904, -0.7809265934426628],
            [11.504767206488351, -0.7782302455049431],
            [11.506416780337377, -0.7718777909580679],
            [11.511596909620062, -0.7710621523039944],
            [11.515140806707823, -0.7728865036766492],
            [11.51986714014942, -0.7679302132745355],
            [11.525680153337893, -0.7688444548852836],
            [11.527298890843783, -0.7705243491527829],
            [11.532548320918144, -0.7690752360501931],
            [11.532579740957916, -0.7645004141247821],
            [11.539575058237098, -0.7608824477884413],
            [11.544741521564372, -0.7614057475327125],
            [11.547158118942217, -0.7536724379639772],
            [11.553537130269977, -0.7500847146566608],
            [11.553279481282658, -0.7529754862262403],
            [11.56276062861575, -0.7673520604430862],
            [11.565765553119975, -0.7752768694027646],
            [11.565622931171813, -0.778316882484091],
            [11.583054827672397, -0.7955980999188297],
            [11.590099509344807, -0.8005406816872533],
            [11.59140535946146, -0.8029003231216515],
            [11.597544631203341, -0.8082699869227342],
            [11.62437402140909, -0.8300302694923327],
            [11.632985923754761, -0.840171724857496],
            [11.6466894869235, -0.8626055064863923],
            [11.675173459598666, -0.919600099446202],
            [11.669188722765334, -0.9236861779650123],
            [11.656500289932916, -0.9291235615786816],
            [11.646998567759596, -0.9354496498330448],
            [11.645660713524112, -0.9433389877885039],
            [11.642050689998259, -0.9473625455371926],
            [11.637696238065232, -0.9554565109951801],
            [11.635352167685623, -0.9557982012302768],
            [11.631066827923238, -0.9608564506557742],
            [11.62065106215222, -0.9800794110998061],
            [11.60354509820907, -1.0008807082789128],
            [11.589412709012263, -1.0095697970303257],
            [11.572482726319395, -1.0228709832954255],
            [11.568175811516621, -1.0244429380899163],
            [11.559702569463424, -1.0328774757369004],
            [11.553953435083786, -1.0315636500984144],
            [11.549762015338226, -1.034383805946172],
            [11.544267290171472, -1.029323564042755],
            [11.539118816581057, -1.0297053862476837],
            [11.535385084695744, -1.0314993451264012],
            [11.530566935728954, -1.024024063332727],
            [11.531172636996805, -1.0212928111034971],
            [11.521866324298639, -1.0260692774772802],
            [11.520792101657541, -1.027994290922099],
            [11.515757777743415, -1.0290127782113754],
            [11.494463280531894, -1.0399428763845007],
            [11.492098326026285, -1.0401460013972468],
            [11.484279281822326, -1.0452806818632907],
            [11.470752231431684, -1.0524189446575176],
            [11.467455143330811, -1.0529619704561513],
            [11.45704375395718, -1.0581780949969415],
            [11.452238770141859, -1.0623815368835692],
            [11.445446034030743, -1.0698763431235216],
            [11.44144055972312, -1.0763017801412875],
            [11.43703210997118, -1.0808771194936466],
            [11.435946431713447, -1.087218131718169],
            [11.432968936670324, -1.0908621190192134],
            [11.432563703582126, -1.0993322565507289],
            [11.437727557470001, -1.1091502186512188],
            [11.445702443058956, -1.1175593008273432],
            [11.443303512996538, -1.1195276261261766],
            [11.438457661757905, -1.11988874244872],
            [11.435083729374629, -1.1231868176965218],
            [11.429745222126234, -1.1255083504440282],
            [11.428690809599384, -1.1278243060215365],
            [11.421505095724383, -1.132232722792656],
            [11.418379960955228, -1.1325549513256252],
            [11.39798770596528, -1.144245745303421],
            [11.390860970398602, -1.1462946222850723],
            [11.384882306367388, -1.1509016956201246],
            [11.379008788887953, -1.1524506710829012],
            [11.37616069166274, -1.155678750761537],
            [11.373164199074695, -1.1558485429008871],
            [11.363447216501026, -1.16350641620208],
            [11.355980755874945, -1.1668498233023799],
            [11.349908682676144, -1.1731911113507871],
            [11.346356074526124, -1.1739661802429484],
            [11.344277362350683, -1.1779363669499794],
            [11.339533420370309, -1.1790897315829831],
            [11.337068440848725, -1.183836058147975],
            [11.334509982985233, -1.1838301935772673],
            [11.328050923607886, -1.187616290164284],
            [11.324328444286422, -1.1911965156468411],
            [11.313613879338204, -1.1982958765896252],
            [11.30738435412092, -1.204011995073894],
            [11.301136169631585, -1.20736791904061],
            [11.289241103696865, -1.2193311648041063],
            [11.283062638550748, -1.2270893312238966],
            [11.279500497130417, -1.232816833218576],
            [11.259643687347882, -1.1861726869647673],
            [11.25018305564952, -1.1647637465999918],
            [11.219169803811079, -1.1095815247747718],
            [11.196818908815821, -1.0740368512859326],
            [11.20687137898504, -1.067542251629276],
            [11.208731868847398, -1.0628710628758526],
            [11.213409173867307, -1.061222581931976],
            [11.223327678348086, -1.052849526165666],
            [11.226187033834611, -1.052366264010735],
            [11.230582099279552, -1.0561907449980614],
            [11.231284681809191, -1.0523632622422456],
            [11.234321835822918, -1.0494284661798166],
            [11.238288155131073, -1.051696801365191],
            [11.244116268060035, -1.0467076055560398],
            [11.246687450681408, -1.0480328912364993],
            [11.247982311935647, -1.0533178793078488],
            [11.255706739933725, -1.0504758393016707],
            [11.254025641406846, -1.0431914701794096],
            [11.257336378421455, -1.0431240649155515],
            [11.258936464291887, -1.0475936251380071],
            [11.263148954920782, -1.0532758929389294],
            [11.264541902706622, -1.0526201067536787],
            [11.264075269664168, -1.038168374401902],
            [11.269550233026553, -1.0372480624664961],
            [11.272446252203547, -1.0342186508540019],
            [11.277286040182203, -1.0326676513116448],
            [11.244915395542735, -0.9705741853573536]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.09534857948755, "lat": 36.93386836712342 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51167"],
        "coty_name": ["Russell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Russell County"],
        "coty_fp_code": "167",
        "coty_gnis_code": "01497573"
      },
      "bbox": [
        11.196818908815821, -1.232816833218576, 11.675173459598666,
        -0.7500847146566608
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.115924242980167, -0.5772964004087916],
            [15.173540378302866, -0.519625924795113],
            [15.255172724975376, -0.44727911003977655],
            [15.326127808554947, -0.38083167268398715],
            [15.361068308476304, -0.3461608464679355],
            [15.389755118129715, -0.316558154927766],
            [15.406471565209724, -0.29970994997007083],
            [15.419835741038804, -0.2878715172043843],
            [15.439388009811529, -0.26861318759272323],
            [15.509487237458714, -0.20099950559835716],
            [15.509679007187117, -0.20776082644516006],
            [15.511064165415581, -0.21045099095657802],
            [15.509526511244184, -0.2190927105602499],
            [15.512772313756987, -0.22305996752161267],
            [15.511029578568678, -0.23045534832337308],
            [15.51188260584502, -0.23406314289411137],
            [15.5097684708699, -0.24032747031341012],
            [15.515342959986176, -0.24410577883761062],
            [15.519409229127003, -0.2522912685910213],
            [15.522494939301932, -0.2535622548071464],
            [15.525413738387142, -0.2575033315072129],
            [15.52610760624123, -0.2631613593189306],
            [15.530574411548375, -0.26588122801603264],
            [15.537106733987747, -0.26401005706679725],
            [15.534649903664594, -0.27021535851458545],
            [15.536121330717421, -0.2739027683576545],
            [15.53995831909893, -0.27552567781949405],
            [15.542093214471917, -0.2720891820585113],
            [15.545133105535022, -0.27500640529055814],
            [15.55248577248754, -0.2766454039910012],
            [15.553095235304705, -0.2817488213240613],
            [15.555793906876533, -0.2902038332499044],
            [15.55312249534081, -0.29475009341199865],
            [15.553855910833304, -0.298405920128742],
            [15.549365488568823, -0.30104652585664726],
            [15.550340143693516, -0.30753956723632514],
            [15.55735006142806, -0.30885614721452975],
            [15.553005573472745, -0.31609207901750774],
            [15.549821869789556, -0.3168596199236334],
            [15.55009253396424, -0.3225969016467225],
            [15.544182671037415, -0.3273149805739468],
            [15.548723589170645, -0.3304109533532106],
            [15.545014262598153, -0.33468421932231257],
            [15.54473068416654, -0.3385447278714123],
            [15.539905680642073, -0.34114947003645996],
            [15.540097730250793, -0.3492768048760056],
            [15.53613885897768, -0.35493470481340783],
            [15.536440560978072, -0.35798509031506875],
            [15.534150306807092, -0.36136990377527006],
            [15.53902213136961, -0.36912582433834096],
            [15.53412996467332, -0.3705367742048291],
            [15.534576432863906, -0.3747971851447962],
            [15.533263758047909, -0.3809499006700101],
            [15.534143314622195, -0.38430785495710185],
            [15.532511535988395, -0.3897836787524249],
            [15.537348270370563, -0.39242473486832274],
            [15.54008617817897, -0.39936224785010194],
            [15.537821772175231, -0.4020377686600073],
            [15.538879306487484, -0.40793334569352885],
            [15.53420597673482, -0.41017596632101355],
            [15.534328061829244, -0.4137028445080742],
            [15.52946910746986, -0.4185228225947017],
            [15.526695364853213, -0.4190667665384314],
            [15.524632117491976, -0.4238664472426845],
            [15.524020110691229, -0.4295510011446352],
            [15.528613863961796, -0.43397244169412924],
            [15.525325781534459, -0.4405414535589673],
            [15.523203402633921, -0.4390163325542687],
            [15.51752848309212, -0.4454447185453517],
            [15.5247471076062, -0.4546472363464085],
            [15.520160577681477, -0.46021908333131906],
            [15.519503826410048, -0.46367971196064106],
            [15.51444881265511, -0.46251968800885673],
            [15.514361119206162, -0.4652915121007043],
            [15.51088029783366, -0.4683707610593591],
            [15.510175567863058, -0.47132787376739066],
            [15.51366458331939, -0.4752158549233086],
            [15.514696417956598, -0.4823382952093695],
            [15.509406895672267, -0.4898250112658455],
            [15.50946558297938, -0.49825388242571883],
            [15.508679152908798, -0.49747119357257247],
            [15.487634725800312, -0.5017119325338023],
            [15.477361319204748, -0.5100736654891626],
            [15.476928014647772, -0.5168101322678958],
            [15.480587975368449, -0.5180008645976828],
            [15.48127923567894, -0.5225198855490332],
            [15.480160139483175, -0.5275557088693753],
            [15.484235805659814, -0.5331111702347148],
            [15.49234388828302, -0.5323991653738822],
            [15.496075921732835, -0.5308509268567063],
            [15.498119396422632, -0.5333717440280739],
            [15.49704371820018, -0.536703465697232],
            [15.488199078536011, -0.5440038069368295],
            [15.502333357049963, -0.5472706610881737],
            [15.509672530841208, -0.5474962894877652],
            [15.533006195684655, -0.5558782500856808],
            [15.533099525726433, -0.5547991295160646],
            [15.543337811742367, -0.5569637952847899],
            [15.545225011018633, -0.5586346893698424],
            [15.546987982208252, -0.5648104825512523],
            [15.55094555707779, -0.5694304674596333],
            [15.549925187593491, -0.574514665547875],
            [15.540376655669059, -0.5824422721599511],
            [15.537652316016635, -0.5858815600463039],
            [15.542202777501803, -0.590094898294177],
            [15.542180678397719, -0.5939431684433537],
            [15.540083319882237, -0.6002496065777616],
            [15.544591875242663, -0.6104116752520732],
            [15.544516549919416, -0.6129994429100771],
            [15.547151822393937, -0.6230318020758925],
            [15.54524908386741, -0.6255557903688617],
            [15.540517574553819, -0.6256967012574142],
            [15.53500407402047, -0.6361908764476265],
            [15.536358399240848, -0.6425094298344678],
            [15.534367547738768, -0.645822428173705],
            [15.540955243306788, -0.6483702828883069],
            [15.546255419990484, -0.6486269196747875],
            [15.547598331292933, -0.6508322070743178],
            [15.54770779057388, -0.6570393590446441],
            [15.549133414768741, -0.6590252854452887],
            [15.409359452626994, -0.6865219955595218],
            [15.386277823009708, -0.6918295763885933],
            [15.364508549983675, -0.6961122226458403],
            [15.354953579577684, -0.6957382625548776],
            [15.350625644734434, -0.6955675079522897],
            [15.334847787968851, -0.6999180638597761],
            [15.323472582710401, -0.7038278213103734],
            [15.251866393202851, -0.7179755930715447],
            [15.249393161287456, -0.7156103334759816],
            [15.241879071695433, -0.717978448985763],
            [15.238425536683794, -0.7152038300796665],
            [15.232406556089511, -0.7157200005857345],
            [15.227457831467422, -0.7135256910074892],
            [15.219490600533979, -0.7144296230837028],
            [15.220054250054103, -0.7181802470324841],
            [15.216787177526594, -0.7188784314496057],
            [15.214034103577127, -0.7162702870983816],
            [15.208766952593857, -0.7188272867622567],
            [15.204468532620373, -0.7173524563725941],
            [15.203895211310435, -0.7133207528166114],
            [15.197952164478584, -0.7080978474661367],
            [15.198584007586327, -0.7051461492971061],
            [15.195756896098164, -0.6989222510445975],
            [15.19876940183113, -0.6917491589225112],
            [15.196536721970304, -0.6871290399594501],
            [15.195137640886394, -0.6802230772730133],
            [15.192900905556233, -0.676735846988708],
            [15.193592157135646, -0.6718867320451024],
            [15.188448846386779, -0.6722991725945203],
            [15.185658053929586, -0.6675303614365046],
            [15.181507303625885, -0.6677215967249117],
            [15.182448838571016, -0.661126826889559],
            [15.179210526601858, -0.6565424561217317],
            [15.175563113684348, -0.6549786032340128],
            [15.17710979182079, -0.6488606868968823],
            [15.175001301911449, -0.6453229868174181],
            [15.171220255339549, -0.6431237801212932],
            [15.165169992037548, -0.6476650148237654],
            [15.16347695811775, -0.636435932063927],
            [15.160280170017666, -0.638999744800232],
            [15.157583031983219, -0.6374608359615407],
            [15.154354814893527, -0.6326586802215531],
            [15.145761199098464, -0.6331815562175089],
            [15.1450386728503, -0.6310400180608198],
            [15.13662890999653, -0.6287704989186088],
            [15.130432776169979, -0.6296669522657827],
            [15.126635969806333, -0.6315247161625533],
            [15.114528757698343, -0.6353325518599394],
            [15.107539946232533, -0.6361737993106225],
            [15.106167571286335, -0.6329596346731292],
            [15.102579172854972, -0.6365664223763716],
            [15.09803838148432, -0.6348979955076852],
            [15.094665641629552, -0.6305259758087316],
            [15.089945385395787, -0.6314363025282574],
            [15.088974720995699, -0.6258346075574067],
            [15.086371599170041, -0.6227932175374982],
            [15.081883436822896, -0.6262719859069784],
            [15.078703582083877, -0.6228749657437405],
            [15.074605518132202, -0.6226254943096946],
            [15.067252410371646, -0.6251402400921527],
            [15.094898701756627, -0.5985952857312034],
            [15.115924242980167, -0.5772964004087916]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.10605262981362, "lat": 36.72045688147708 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51175"],
        "coty_name": ["Southampton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Southampton County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "01480171"
      },
      "bbox": [
        15.067252410371646, -0.7188784314496057, 15.55735006142806,
        -0.20099950559835716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.363679698092056, 0.02928495135030728],
            [15.37086297105855, 0.02582607573216964],
            [15.384321659802405, 0.021971241356716156],
            [15.38848862364173, 0.020091084570862273],
            [15.385807110690024, 0.015610588052926954],
            [15.387388462675197, 0.013007665630077917],
            [15.39951731830018, 0.0065024096492827445],
            [15.405969468029609, 0.004400876398502875],
            [15.413537639527847, 0.0002115293778005871],
            [15.417909400227941, -0.003506822841653381],
            [15.427508519308224, -0.007892681303435154],
            [15.436528801634516, -0.006385621490033629],
            [15.44396360903389, -0.0013197810634174548],
            [15.454102760151088, 0.007007159105170928],
            [15.47545134840786, 0.009400912282118425],
            [15.47751799001222, 0.008652537601715301],
            [15.489635013463925, 0.011159270598833647],
            [15.491335871928271, 0.01079506497772751],
            [15.504689714181035, 0.014276863462161735],
            [15.503926615115038, 0.009451516008984596],
            [15.505106760737453, 0.00638979006568145],
            [15.511243384502452, -0.0015307651545192885],
            [15.517129229306423, -0.0020709120310183635],
            [15.521183942344544, -0.0048000693472471075],
            [15.524467953600485, -0.010325758413517388],
            [15.542600355706446, -0.017050294695910455],
            [15.544221838089513, -0.019353229749069875],
            [15.552828535771722, -0.02676353972239225],
            [15.557217980693121, -0.032152111941997054],
            [15.566113384275088, -0.034843785450166906],
            [15.571651561304456, -0.034498228469494456],
            [15.57835818991449, -0.03216052024429831],
            [15.58273231962594, -0.029497959869501864],
            [15.586380015567224, -0.01770753537083926],
            [15.586172109781991, -0.011024713453364927],
            [15.58773758438588, -0.005137602480165256],
            [15.591026392588459, -0.0006532450477812866],
            [15.592263835743074, 0.011754262466408791],
            [15.591177418511508, 0.020677000007128393],
            [15.594900190665541, 0.023765668048400378],
            [15.603562162498006, 0.016572204237136966],
            [15.6105932990774, 0.012876318391344871],
            [15.617294457042474, 0.004261993400433114],
            [15.617492140570418, 0.0013664809611831572],
            [15.614959534912071, -0.0035438390089280692],
            [15.61443331946865, -0.011933242740871146],
            [15.61678758755774, -0.018776996126832462],
            [15.617743466092884, -0.028446356081771252],
            [15.61539418417814, -0.0320412081186565],
            [15.618625440993965, -0.03670302032570507],
            [15.614990501630313, -0.04103196055562016],
            [15.614232549432339, -0.045427492907193154],
            [15.616234701398744, -0.053889255320813734],
            [15.619191681034836, -0.05715610173498795],
            [15.6179802374158, -0.05997909426135077],
            [15.621790456604192, -0.06206379319234745],
            [15.620534571437027, -0.0669248989451898],
            [15.617351602434585, -0.06494175783719307],
            [15.615778383634883, -0.06820210998714117],
            [15.61847862117413, -0.07303950828095984],
            [15.617217645297, -0.07499836941893284],
            [15.61876065327546, -0.08380108530775553],
            [15.612324242108246, -0.08877247318102935],
            [15.613422518625791, -0.09285134790869683],
            [15.612899391510211, -0.10109089237438806],
            [15.610307672816804, -0.10818932372144327],
            [15.61380053567533, -0.11255036115123333],
            [15.613340139106453, -0.11558115158837863],
            [15.608529495693716, -0.11932192698863317],
            [15.604310216803114, -0.1205737531706343],
            [15.562969230272387, -0.15429364379307645],
            [15.517648566585663, -0.19312182909812778],
            [15.509487237458714, -0.20099950559835716],
            [15.439388009811529, -0.26861318759272323],
            [15.418452003572114, -0.21522820428180867],
            [15.409775307654167, -0.1822162546523935],
            [15.407746027929305, -0.17642681334574722],
            [15.411721038375232, -0.1719634556662154],
            [15.408584303610146, -0.16616290912271905],
            [15.408242572648785, -0.16153926887770026],
            [15.405130256460106, -0.16186498866039195],
            [15.399407925481544, -0.1672502343103118],
            [15.3973949781067, -0.16482943823300727],
            [15.392621651173377, -0.16967124202923092],
            [15.387943379951759, -0.17042081940288925],
            [15.377918178520282, -0.17029078350729665],
            [15.37531238611211, -0.16430971689172555],
            [15.369242832519845, -0.16595910263474703],
            [15.36772109768872, -0.16343723789080136],
            [15.355035271433954, -0.15979854798672807],
            [15.343578510433398, -0.15848179817236127],
            [15.343969366242886, -0.16193922945410563],
            [15.341719271409854, -0.1664959214982509],
            [15.333279465152257, -0.16650434922113352],
            [15.325447591000534, -0.16447834342447504],
            [15.320310936015131, -0.16697671079694174],
            [15.317661391870196, -0.16548415516911844],
            [15.319259948024547, -0.16120103780765402],
            [15.315360505344778, -0.15637708393813574],
            [15.315635399440493, -0.1522662821324583],
            [15.311964819140355, -0.14982494336494262],
            [15.310287329859445, -0.15212142582176302],
            [15.30554971318119, -0.15317259191316104],
            [15.302344908602779, -0.15018887205538164],
            [15.298282446609194, -0.15367337549193236],
            [15.294586171572256, -0.14928049834170523],
            [15.29046575779199, -0.14792080687645415],
            [15.287578809253896, -0.1404652411394888],
            [15.285791849335528, -0.13879811322064436],
            [15.280987673803372, -0.1392968424484991],
            [15.27826675933674, -0.14269966355060124],
            [15.270352284841564, -0.1444518976373077],
            [15.26959634996728, -0.14137508311834715],
            [15.265056051454307, -0.14157867069491073],
            [15.25698243126836, -0.14378787379603053],
            [15.252789415032524, -0.1417055800561055],
            [15.249430910787364, -0.13436054707348896],
            [15.248623025181889, -0.1325526610825972],
            [15.268778510017675, -0.10359069094081444],
            [15.290415806308411, -0.06736393122421229],
            [15.296495469079119, -0.062498406314907315],
            [15.299149974022571, -0.0564919870447794],
            [15.298737671345203, -0.050232883760804564],
            [15.305326639122791, -0.043526637775672554],
            [15.30874090965923, -0.041163175285371625],
            [15.319611049609595, -0.03741232949745594],
            [15.32010258502454, -0.03491062185146462],
            [15.316514729289556, -0.031199933482347664],
            [15.317251114226055, -0.028496291908845867],
            [15.323084361399438, -0.027020312558473304],
            [15.326205548414391, -0.028111591734714787],
            [15.333296298216096, -0.025781892439326482],
            [15.332029670327556, -0.02029785689954893],
            [15.336895730410651, -0.01894422685534887],
            [15.34051668430107, -0.01259432559105653],
            [15.333642627825773, -0.006585790213957839],
            [15.335626566947571, 0.0021153810586602177],
            [15.336011402721214, 0.0075855814541776045],
            [15.342912156867998, 0.008762706247639949],
            [15.34301733583587, 0.014990335303333989],
            [15.349822780213538, 0.014130603803428421],
            [15.363679698092056, 0.02928495135030728]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.90027493400555,
          "lat": 37.109850410822354
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51181"],
        "coty_name": ["Surry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Surry County"],
        "coty_fp_code": "181",
        "coty_gnis_code": "01480174"
      },
      "bbox": [
        15.248623025181889, -0.26861318759272323, 15.621790456604192,
        0.02928495135030728
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.553537130269977, -0.7500847146566608],
            [11.554927106858651, -0.7400001357438014],
            [11.561241499822101, -0.7422759172890617],
            [11.566299294225079, -0.738386242026341],
            [11.569353876758493, -0.7385467804393742],
            [11.577627788249629, -0.7309558407988437],
            [11.57243455781109, -0.7250241300979674],
            [11.57421231059346, -0.7214583061046436],
            [11.580696781771021, -0.7181887386560563],
            [11.58266095799817, -0.7133154371424175],
            [11.586292787613045, -0.7123870697909164],
            [11.589985739970917, -0.7137812154605275],
            [11.593465932813485, -0.7121717946566162],
            [11.59707106687486, -0.7073345119797896],
            [11.60429048291462, -0.7035193402615699],
            [11.609537703246756, -0.7047893182164803],
            [11.61251549383552, -0.7026550566456629],
            [11.616303204062827, -0.6973072096442722],
            [11.627778755460481, -0.6945850520276486],
            [11.636910691242932, -0.6857538770375932],
            [11.636296053872183, -0.6812996560238727],
            [11.641270198927424, -0.6786486922131535],
            [11.64343578589945, -0.6739968339261919],
            [11.65091083556735, -0.6761449477447278],
            [11.656130695517636, -0.6683838847209416],
            [11.656397270588347, -0.6551751638203235],
            [11.665738145436563, -0.6482711956104035],
            [11.66591456643492, -0.644421310861243],
            [11.66299632431276, -0.6420347998188951],
            [11.66517444803888, -0.6349986213543111],
            [11.669925294634442, -0.6350052834482782],
            [11.677565323485924, -0.6314332997332632],
            [11.683809349985667, -0.6367908940558575],
            [11.685052264586027, -0.6422703544078134],
            [11.699731363351267, -0.6508404680865694],
            [11.703427474041817, -0.6550093404377769],
            [11.710044920334601, -0.6544804081816907],
            [11.712458309583614, -0.6561638100622178],
            [11.713864147042246, -0.6615152087383233],
            [11.71844009559674, -0.6650750950722253],
            [11.809342957517694, -0.6459254133078308],
            [11.814548078907475, -0.6433101556490385],
            [11.819807563405616, -0.6299218230971882],
            [11.828262072105753, -0.6259154787042078],
            [11.83226841581191, -0.6228461400814178],
            [11.837345162324382, -0.6209463165010799],
            [11.845787238797298, -0.6138780405042275],
            [11.846726950077388, -0.6068810865878106],
            [11.84579888779354, -0.6017146971338315],
            [11.847077765207272, -0.5932332972506447],
            [11.850767155301575, -0.5905412239199075],
            [11.855821134530341, -0.5935427325409136],
            [11.865257337103607, -0.5919260569746209],
            [11.867534467880617, -0.5874828701138418],
            [11.877959574906933, -0.5810013970616076],
            [11.87827924992561, -0.5752023405943921],
            [11.883026955532449, -0.5729663468842452],
            [11.889434999133586, -0.566562841135085],
            [11.893551616323903, -0.5673812028009734],
            [11.89521135310994, -0.5638667865159424],
            [11.902856155547147, -0.565802005136564],
            [11.911304391370223, -0.5622492957665638],
            [11.911154871630783, -0.5562197606314477],
            [11.914154335321994, -0.5545379106790669],
            [11.917738251093986, -0.5373627250245826],
            [11.916389927350187, -0.5353266417193191],
            [11.921925758346283, -0.5286415218588353],
            [11.919629965791977, -0.5227264838108602],
            [11.922053905265022, -0.5164493835429341],
            [11.927309675443446, -0.5114836302666215],
            [11.93282916007563, -0.5133215139383841],
            [11.93714840605732, -0.5118588045042839],
            [11.93874059421497, -0.5059908620937892],
            [11.941097590737352, -0.5020958101633394],
            [11.939337601583391, -0.4993044726933147],
            [11.940802449732686, -0.4936012311424831],
            [11.943765857877846, -0.49134285508592646],
            [11.982442533090225, -0.5245327498355998],
            [12.066462314835409, -0.5772730707336866],
            [12.053779232721972, -0.590309332948939],
            [12.039976418085828, -0.5985080820689129],
            [12.03203222532085, -0.6004115965493118],
            [12.023014920553342, -0.6036282946996963],
            [12.045913971252812, -0.643704528582528],
            [12.02627722549535, -0.6541693788244757],
            [12.015203882661153, -0.6596033198820783],
            [12.009119337255164, -0.6633133403313154],
            [11.99570754655823, -0.6759358808818229],
            [12.001087087656774, -0.685509164117701],
            [12.010484571109918, -0.683808249873131],
            [12.014692432560835, -0.6870511627810061],
            [12.019358055558293, -0.686194441465083],
            [12.028970582205902, -0.6895067168980823],
            [12.036799133671533, -0.6882178753301543],
            [12.044449109080459, -0.6897203062729965],
            [12.048677107684039, -0.6894921515029709],
            [12.053455733568944, -0.6924028590914466],
            [12.05698978244667, -0.7015422982435745],
            [12.056745335794771, -0.7100368035806349],
            [12.054232754697248, -0.7154592446518049],
            [12.05353909802323, -0.7242720909296309],
            [12.048503478268199, -0.7297142459776431],
            [12.039800138104797, -0.736458854935039],
            [12.02512339077062, -0.7462155244798532],
            [12.022035272568388, -0.7504475985554461],
            [12.013316255015376, -0.7568668779079402],
            [12.00703884846054, -0.7596938435889614],
            [12.000773073548526, -0.7641051784163331],
            [11.990290647909058, -0.769596782311362],
            [11.983342687042883, -0.7710962162251485],
            [11.977875192540703, -0.7733696912613385],
            [11.975443753487442, -0.7767270154228398],
            [11.97277035572581, -0.7750174237637283],
            [11.965527975633467, -0.7766424675362144],
            [11.958143388216145, -0.775211582243482],
            [11.942824394278333, -0.787268693097622],
            [11.939499636236402, -0.7909179003012573],
            [11.92825874764486, -0.7978039741266404],
            [11.923495017743885, -0.7980713522152305],
            [11.915445027781601, -0.8008668820949238],
            [11.912363483567345, -0.8050409573241545],
            [11.936219921230473, -0.8271717048246154],
            [11.933988464505235, -0.8278738009125078],
            [11.92716783021615, -0.8358004559097224],
            [11.920845870727229, -0.8413703419675485],
            [11.91774732801454, -0.846413151447353],
            [11.90565711080622, -0.8562411268393186],
            [11.902495712245361, -0.8526919249120976],
            [11.910195686503304, -0.8435285334525211],
            [11.907056755084742, -0.8402130559040002],
            [11.909337661666253, -0.838219189153711],
            [11.90639744039126, -0.833423596209323],
            [11.91067259393261, -0.8267177396819286],
            [11.909965479927624, -0.8245436130396371],
            [11.905385645914631, -0.8234063124084131],
            [11.901880776295886, -0.8265569673782195],
            [11.889909395619219, -0.8293531533549077],
            [11.885327101577895, -0.8359351819232306],
            [11.881076643830337, -0.8374290769555668],
            [11.879671026658023, -0.8427317995864684],
            [11.874552905393305, -0.8461807515968082],
            [11.867297808254152, -0.8478939859259477],
            [11.862505697794523, -0.8528883856093353],
            [11.856263200734087, -0.8536729502106606],
            [11.850046927163136, -0.8565763789926775],
            [11.84146019986461, -0.8620165589937617],
            [11.830364500187118, -0.8643187834888177],
            [11.826771112634365, -0.8691852540810082],
            [11.820497987204666, -0.8736714301228425],
            [11.815473512604656, -0.8822239995804455],
            [11.81134589480712, -0.8851029077995961],
            [11.796591200913, -0.9000674861304607],
            [11.795257675404105, -0.9029207373925465],
            [11.789472752319826, -0.9082543535852778],
            [11.786074153031107, -0.9131383955174681],
            [11.773747981357348, -0.9227887254108103],
            [11.768069521626645, -0.9250538528571751],
            [11.762288052061352, -0.9310173353602877],
            [11.755563724017229, -0.9336770831389265],
            [11.728544559628629, -0.8927671055745384],
            [11.71472449749869, -0.9022783788885201],
            [11.711398663822012, -0.9024434837801256],
            [11.690951966612872, -0.9154488798686313],
            [11.681868296565847, -0.9164263036952857],
            [11.675173459598666, -0.919600099446202],
            [11.6466894869235, -0.8626055064863923],
            [11.632985923754761, -0.840171724857496],
            [11.62437402140909, -0.8300302694923327],
            [11.597544631203341, -0.8082699869227342],
            [11.59140535946146, -0.8029003231216515],
            [11.590099509344807, -0.8005406816872533],
            [11.583054827672397, -0.7955980999188297],
            [11.565622931171813, -0.778316882484091],
            [11.565765553119975, -0.7752768694027646],
            [11.56276062861575, -0.7673520604430862],
            [11.553279481282658, -0.7529754862262403],
            [11.553537130269977, -0.7500847146566608]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.56056706315628, "lat": 37.12493104162973 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51185"],
        "coty_name": ["Tazewell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tazewell County"],
        "coty_fp_code": "185",
        "coty_gnis_code": "01497748"
      },
      "bbox": [
        11.553279481282658, -0.9336770831389265, 12.066462314835409,
        -0.49134285508592646
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.135558837440838, 1.0417974743493044],
            [15.14030567800854, 1.0398201314713316],
            [15.150895565373448, 1.0429341257703122],
            [15.160394587066317, 1.0362607124624992],
            [15.16910275555424, 1.0283643941580185],
            [15.171365683886004, 1.022421799848696],
            [15.175094259507885, 1.0158753059285346],
            [15.177014241688816, 1.0097126719523086],
            [15.174234167852882, 1.002214578148256],
            [15.171037044644951, 0.9985696848700146],
            [15.177501309214424, 0.9863750652274964],
            [15.188773095088997, 0.9828357338701738],
            [15.199050570936643, 0.9787073141601074],
            [15.210654729737406, 0.9795256867042178],
            [15.220177637619134, 0.9775327285598924],
            [15.227928414560413, 0.972320560404426],
            [15.24389989294221, 0.9634899658250033],
            [15.24573799046956, 0.9614967099362574],
            [15.252313459329802, 0.9584580684010734],
            [15.264929434085097, 0.9598173067786644],
            [15.269492729598328, 0.9568608224661668],
            [15.273112203701144, 0.9572464885555186],
            [15.281902681537758, 0.9555014011086442],
            [15.292946666624921, 0.9579271277774488],
            [15.310476207166824, 0.9669704983486777],
            [15.319149162299098, 0.9690212264244128],
            [15.330508751414579, 0.9692564408541149],
            [15.341191044303757, 0.9708427479316176],
            [15.34571077024252, 0.9694471263847012],
            [15.355581457674166, 0.9625053458817956],
            [15.361728407873947, 0.9555796399286487],
            [15.364463997800554, 0.9422684377287907],
            [15.36603747658382, 0.941050710539551],
            [15.372412382232703, 0.9413001754904051],
            [15.376455668527067, 0.9482503523604661],
            [15.384972092102783, 0.9576623360182189],
            [15.387571337185214, 0.962524762569024],
            [15.3879458468595, 0.9738298890845369],
            [15.396310115398018, 0.9755461238405315],
            [15.400708350162782, 0.9726863987497542],
            [15.410216990174412, 0.9704555235404025],
            [15.417589280368192, 0.9670335050735099],
            [15.426611859391816, 0.956221457100589],
            [15.430524551212386, 0.955583532017762],
            [15.434322828149432, 0.9518374825198933],
            [15.43756678571928, 0.9507731316340823],
            [15.442215171717342, 0.9456605167376393],
            [15.446566647295034, 0.9520536603288808],
            [15.445788217177531, 0.9553621870686598],
            [15.441659854676919, 0.9593282400861224],
            [15.441654879626395, 0.9634708111261326],
            [15.437423153348805, 0.9651989801084819],
            [15.433998788080217, 0.9710509579494527],
            [15.436745072574979, 0.9749440788854509],
            [15.443673630937488, 0.977998275080055],
            [15.447800180507867, 0.9764735935876713],
            [15.45785194966972, 0.976400204153143],
            [15.457645786214014, 0.9708311323035245],
            [15.460723461283614, 0.9652545666980685],
            [15.467520579401011, 0.9594340420885905],
            [15.473374316385941, 0.9444873468227448],
            [15.474231212450501, 0.9400175729109826],
            [15.48118149788476, 0.9358574390165526],
            [15.485557815317785, 0.9343075447476844],
            [15.493706983902973, 0.9283632074226684],
            [15.505015197132726, 0.924553112274834],
            [15.51221104065388, 0.923202488680251],
            [15.52002248627151, 0.9190959488812924],
            [15.531718007149559, 0.9143415143932805],
            [15.533361191778054, 0.9067803229425276],
            [15.535577731243583, 0.9036044913107483],
            [15.54801073908111, 0.8896471663004787],
            [15.542299713846877, 0.8883366835974508],
            [15.53507335402916, 0.8794612934211202],
            [15.527000699293243, 0.8792984365289739],
            [15.527987626047024, 0.8722640454738455],
            [15.52604599188574, 0.8643042767998121],
            [15.522123413431851, 0.8646023512003984],
            [15.517988876358356, 0.8625930841113548],
            [15.512913969548702, 0.8622638540698847],
            [15.514488112966985, 0.858106571999327],
            [15.514325616026897, 0.8530108203272174],
            [15.512153892100084, 0.8524411034051697],
            [15.508995990587561, 0.8474414076011421],
            [15.5077107354075, 0.8422925989124694],
            [15.503657485203128, 0.8364406866401599],
            [15.499223741075166, 0.8354288667415557],
            [15.494751734691846, 0.8327039414294664],
            [15.485594424198124, 0.831194087793093],
            [15.483809371193894, 0.8289102074863494],
            [15.48224767703186, 0.8178186835125726],
            [15.47938837778443, 0.8117382198356548],
            [15.477659716299119, 0.8043223122229841],
            [15.478140871253611, 0.7929140544474804],
            [15.47527333483507, 0.7912205048056841],
            [15.467313348622392, 0.7923563964270118],
            [15.462136398752305, 0.8013391622476544],
            [15.458101385957136, 0.8047974710371328],
            [15.445896545326235, 0.80520067176441],
            [15.438765317490363, 0.8012480801746331],
            [15.432336784696997, 0.8023493343752778],
            [15.423769584462724, 0.8001705883296913],
            [15.399064568913847, 0.8101854479240364],
            [15.387982216400225, 0.8074061874346653],
            [15.38473923617682, 0.8028169113226954],
            [15.377183023112337, 0.8043023545620036],
            [15.371188926891653, 0.8073355816643154],
            [15.373909701853336, 0.8168059302648032],
            [15.37117824918966, 0.8249986736426437],
            [15.373198124629107, 0.8303393030492969],
            [15.371006045331079, 0.8368780120699072],
            [15.364400722851203, 0.8381210988226953],
            [15.358975420357085, 0.8431462837279279],
            [15.348036106769268, 0.8495706895697401],
            [15.337836170702882, 0.8545182501651037],
            [15.33492280081068, 0.8579576532357149],
            [15.329638388423822, 0.8589079996392158],
            [15.323032233581637, 0.8558386932458006],
            [15.31953306168133, 0.8598739186470934],
            [15.31396443825658, 0.860750652260494],
            [15.286813289203293, 0.8820380384656041],
            [15.283229215822262, 0.8845101453438096],
            [15.281133426656503, 0.8882332592680225],
            [15.274369332146788, 0.8929378502463151],
            [15.268445728684021, 0.9051484229433497],
            [15.260719120633157, 0.9109537457920177],
            [15.24706641843998, 0.8915167809176702],
            [15.24339869213831, 0.8873137167914886],
            [15.23982287456357, 0.8788647308765507],
            [15.232274748772964, 0.8723466734037398],
            [15.231502729854979, 0.8693591325954485],
            [15.226882831317686, 0.8650213167498415],
            [15.220916749870357, 0.8622752223352738],
            [15.224894184032363, 0.860160607816245],
            [15.224394655123087, 0.8547464726110228],
            [15.186353391116151, 0.8577590418701997],
            [15.181500277684465, 0.8610321522470782],
            [15.179699929110551, 0.8652641856323465],
            [15.180535010489264, 0.8718869413867437],
            [15.178220657686005, 0.8760271145700795],
            [15.173297809737143, 0.8778388433064505],
            [15.167548968017629, 0.8772706175224418],
            [15.165529085936857, 0.8723285756543585],
            [15.164360994463138, 0.8646982447903594],
            [15.161711200310101, 0.8589870837917761],
            [15.152015119532988, 0.8542445489370831],
            [15.146787637590458, 0.8568948265889043],
            [15.145353748435735, 0.8631978407952072],
            [15.142289120226458, 0.8657716296239583],
            [15.131713661755475, 0.8697119357387532],
            [15.1288443744197, 0.8740767775987197],
            [15.128826261711222, 0.8804597899124256],
            [15.124550182314946, 0.8925752364404497],
            [15.12290498119941, 0.9034699282515216],
            [15.115056842154075, 0.9175420782754807],
            [15.112194717582524, 0.919127285404036],
            [15.109274889902444, 0.9224819079604075],
            [15.108209328742323, 0.9286593592379094],
            [15.109303421645263, 0.9310639859236556],
            [15.117699258802434, 0.937013927289764],
            [15.116064140278054, 0.9395286871835036],
            [15.117890081852822, 0.9440189865300264],
            [15.105520341308672, 1.0195696027657473],
            [15.109740540796908, 1.0209201403214028],
            [15.113383314609573, 1.0193832349627043],
            [15.114047118756373, 1.0247493063754152],
            [15.116357121334302, 1.0300816545267568],
            [15.126937627405779, 1.0334587668316917],
            [15.130178517818562, 1.0378233956818836],
            [15.130331176638505, 1.0417688438549517],
            [15.135558837440838, 1.0417974743493044]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.80425456199892, "lat": 38.11199479799442 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51193"],
        "coty_name": ["Westmoreland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Westmoreland County"],
        "coty_fp_code": "193",
        "coty_gnis_code": "01480179"
      },
      "bbox": [
        15.105520341308672, 0.7912205048056841, 15.54801073908111,
        1.0429341257703122
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.923568643439419, 0.10299864040905234],
            [12.92700210529711, 0.10610270350645722],
            [12.928516934930716, 0.10984681638924877],
            [12.929487068387479, 0.11707937753796746],
            [12.92855173650932, 0.12152669761060834],
            [12.93030780045448, 0.12385741979595648],
            [12.924841279067829, 0.13070993269176637],
            [12.925363919455155, 0.13320688214891108],
            [12.929385853430764, 0.13783924529364755],
            [12.930330079128824, 0.14186964854921025],
            [12.924840538121655, 0.14515451434948348],
            [12.924082004295295, 0.14772155701702924],
            [12.933624313386375, 0.15531896977044837],
            [12.936490345859465, 0.14515248406937367],
            [12.94899273510129, 0.14872802855252557],
            [12.951321811845336, 0.13793763493517613],
            [12.946009565652878, 0.13292543540962115],
            [12.947026567755508, 0.12967006663861022],
            [12.94280424321347, 0.12478848060947684],
            [12.948080433749631, 0.11818111047724211],
            [12.946908741937708, 0.10900739896060957],
            [12.951989085667517, 0.10468077587945801],
            [12.957275550692058, 0.10271480945355832],
            [12.948196765286813, 0.09783183664117368],
            [12.945353448176125, 0.09460178395167394],
            [12.938664660501884, 0.0904669654224942],
            [12.933727839438154, 0.09507291600613371],
            [12.93075867858439, 0.09548708741385462],
            [12.924176519820833, 0.10118238204278159],
            [12.923568643439419, 0.10299864040905234]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.9868917118045, "lat": 37.77850237587617 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51580"],
        "coty_name": ["Covington"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Covington city"],
        "coty_fp_code": "580",
        "coty_gnis_code": "01789069"
      },
      "bbox": [
        12.923568643439419, 0.0904669654224942, 12.957275550692058,
        0.15531896977044837
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.808407803580169, -0.038395626695031104],
            [15.813588058803546, -0.03520033926852094],
            [15.818277604273993, -0.0381363780475038],
            [15.823516310024006, -0.03721400203397654],
            [15.827764315791818, -0.03487263438772509],
            [15.830605836580428, -0.03596823455982245],
            [15.838327829311273, -0.02943568105460712],
            [15.836399584792018, -0.023123487344632345],
            [15.838133884276179, -0.01864253857848709],
            [15.844824468067548, -0.016449996976177706],
            [15.847957222096712, -0.011460276294654292],
            [15.853036547478197, -0.01433323287406419],
            [15.858817549839985, -0.008255812437422475],
            [15.872877967684568, -0.011807693494129287],
            [15.879800477637394, -0.020569385511073082],
            [15.899619990377024, -0.010011457393919558],
            [15.904181004915067, -0.010130207185598403],
            [15.91179154533584, -0.007246765769759487],
            [15.914725754122589, 0.00008869508239387168],
            [15.918153826870357, -0.0004647293485177713],
            [15.92450612867826, -0.005582212807375158],
            [15.928955448541538, -0.005716758085545527],
            [15.934549180029117, -0.011434941293664453],
            [15.938402493761467, -0.01781764139222745],
            [15.938138340637837, -0.0249250423452507],
            [15.936150223313325, -0.032183838254159186],
            [15.935498075373298, -0.03986495844645825],
            [15.936017809610638, -0.048108295321775865],
            [15.932672501991128, -0.07311988594876115],
            [15.932342232490418, -0.1003203388752896],
            [15.93086061289983, -0.10834129340228722],
            [15.925050821857845, -0.11060151400445814],
            [15.920858818828403, -0.1007718603186061],
            [15.9167403527281, -0.09919710401745752],
            [15.914324542906716, -0.1013532816376847],
            [15.899813699019566, -0.10055456490424161],
            [15.895848183444453, -0.11015480207690187],
            [15.890210886405441, -0.1152573622319772],
            [15.885848772312915, -0.11674234420592312],
            [15.875101113503206, -0.1245753157686786],
            [15.86869197848737, -0.13346095082151324],
            [15.861578394044821, -0.12895358316052713],
            [15.85663179838915, -0.12817707047418084],
            [15.854474569423406, -0.13238308596823012],
            [15.832664352772245, -0.10414290017945077],
            [15.823324378492817, -0.11164087563631052],
            [15.821125426626587, -0.11075799396974523],
            [15.818008681255689, -0.10344980586054212],
            [15.811332782048748, -0.09619012270086824],
            [15.80766005977265, -0.08298440359864935],
            [15.808364962429351, -0.07844538905820041],
            [15.805658593212945, -0.07421587780518792],
            [15.80682768030124, -0.06501989833188898],
            [15.806130434616358, -0.06258777013376945],
            [15.801431579813942, -0.05740317429196115],
            [15.806514551852766, -0.047941157466372154],
            [15.808240274093317, -0.04786458829055746],
            [15.808407803580169, -0.038395626695031104]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -76.36319375231608, "lat": 37.05563917239505 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51650"],
        "coty_name": ["Hampton"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Hampton city"],
        "coty_fp_code": "650",
        "coty_gnis_code": "01498554"
      },
      "bbox": [
        15.801431579813942, -0.13346095082151324, 15.938402493761467,
        0.00008869508239387168
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.675019220656571, 1.4695977594001841],
            [14.689532220596151, 1.4634161973287818],
            [14.688519591858624, 1.4609495067826979],
            [14.69238431354077, 1.4574213363580633],
            [14.70005494887882, 1.4537327714591837],
            [14.70016302635066, 1.4461564617957798],
            [14.70119388084985, 1.441580769041405],
            [14.701528620750864, 1.4308214150410912],
            [14.700212492564491, 1.4281186414954639],
            [14.688811508240793, 1.4173290138453734],
            [14.677212655225953, 1.4203957032072032],
            [14.672011060020123, 1.411736758211879],
            [14.665991483268717, 1.420097969773834],
            [14.665545826034151, 1.42248554090423],
            [14.659211988053391, 1.424735515659217],
            [14.654000804518413, 1.4188654128197171],
            [14.65617602876649, 1.4144356978067696],
            [14.66209532592626, 1.4073123341476714],
            [14.661389512788176, 1.405363567513203],
            [14.667423121505214, 1.400601474610422],
            [14.666443528929978, 1.3907362032377488],
            [14.659089523210675, 1.3996346929120096],
            [14.654663795799241, 1.3986449214031762],
            [14.651376847945182, 1.4011182634870303],
            [14.645673895533493, 1.4145225167775617],
            [14.650383031967973, 1.4176335512654215],
            [14.647282035286741, 1.4227123820278973],
            [14.6539917343854, 1.4274418776078157],
            [14.65352951171944, 1.4306183542101318],
            [14.659428588939136, 1.4461602977928472],
            [14.66194022267961, 1.4560608773081138],
            [14.668101475753897, 1.4558877920168614],
            [14.670350502907253, 1.4620661925780818],
            [14.675019220656571, 1.4695977594001841]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.4837272235708, "lat": 38.74789789739539 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51683"],
        "coty_name": ["Manassas"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Manassas city"],
        "coty_fp_code": "683",
        "coty_gnis_code": "01498430"
      },
      "bbox": [
        14.645673895533493, 1.3907362032377488, 14.701528620750864,
        1.4695977594001841
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.050528993335158, 1.759044413607133],
            [14.053049205291009, 1.7691690916303564],
            [14.051274228066053, 1.7730530152317172],
            [14.055404538501676, 1.785229970049197],
            [14.074275793009805, 1.7826477687358677],
            [14.076808953280572, 1.7875853084606974],
            [14.080613279241758, 1.7861208836150526],
            [14.080599783178673, 1.7810452902410476],
            [14.09784042575424, 1.7723441636919137],
            [14.089112314641193, 1.7591760576923778],
            [14.087095279633614, 1.750246922693097],
            [14.081829447800498, 1.7391306841237641],
            [14.078639543803364, 1.724483099727652],
            [14.072856632128136, 1.7128467177761835],
            [14.072291726686025, 1.7185224350411958],
            [14.065392979459455, 1.7216118329387775],
            [14.060593583385549, 1.721909269321634],
            [14.056022625688504, 1.732331215002138],
            [14.058789597480772, 1.73469183779494],
            [14.058507438054914, 1.7454578180582245],
            [14.059838882715251, 1.7554932079625352],
            [14.050528993335158, 1.759044413607133]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.17449263210136, "lat": 39.17343143915714 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51840"],
        "coty_name": ["Winchester"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Winchester city"],
        "coty_fp_code": "840",
        "coty_gnis_code": "01789077"
      },
      "bbox": [
        14.050528993335158, 1.7128467177761835, 14.09784042575424,
        1.7875853084606974
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.04960476231871, -0.09638407706386892],
            [11.054571171860726, -0.1028148983473274],
            [11.05824451562671, -0.10186968196414567],
            [11.062425830383225, -0.1076255570429617],
            [11.067209713304116, -0.1072024697709907],
            [11.069240515898224, -0.1038173055840529],
            [11.067997578466342, -0.10043474972698282],
            [11.061402271900839, -0.09848669530888267],
            [11.061902086125253, -0.09493765896462056],
            [11.057065277117733, -0.0877754710872465],
            [11.120684604132853, 0.003808365165583382],
            [11.205568308033676, 0.04795229102835166],
            [11.2064032723243, 0.04433812302091667],
            [11.202188031428005, 0.03539866872521579],
            [11.207056075542909, 0.0319121436902482],
            [11.20890922523628, 0.02864188859220227],
            [11.21323516361271, 0.029036228004579258],
            [11.216433154368627, 0.024544362405340876],
            [11.212415796769099, 0.019429920304570986],
            [11.221723956695206, 0.0118125921369958],
            [11.22552343894082, 0.011551708763239976],
            [11.225543045356872, 0.005195164346099609],
            [11.227709040642145, 0.0018240498238711335],
            [11.234079245645647, -0.00023773923021427434],
            [11.233829384307457, -0.005658157234708823],
            [11.235547182601625, -0.011348376113604678],
            [11.239099453438158, -0.015578501726821374],
            [11.245046691097787, -0.015611367608800436],
            [11.25138728755789, -0.020468814196393136],
            [11.254418660440768, -0.020798384185789023],
            [11.26363468355435, -0.018728890188816395],
            [11.267735356727387, -0.02042666687659822],
            [11.272122665001067, -0.026370014052780458],
            [11.271398002378637, -0.03191074748358591],
            [11.274932692534648, -0.03677908858273187],
            [11.271830550736277, -0.03775283873008235],
            [11.267571866960214, -0.04188194976506903],
            [11.272022175241291, -0.047620213925177346],
            [11.277187135363535, -0.058820039003472435],
            [11.281932214819076, -0.06082067295085027],
            [11.282608643399366, -0.06565928501853137],
            [11.27701198785916, -0.06744613169746798],
            [11.275182416870337, -0.06973613414632615],
            [11.267517986924602, -0.07373995385636041],
            [11.267542713131565, -0.07666257223213124],
            [11.263795727402709, -0.07762226842163425],
            [11.260006478186696, -0.08380757022229587],
            [11.266060566110271, -0.08708488729574201],
            [11.266488372454594, -0.0904065580736703],
            [11.271411726356728, -0.09398332989416004],
            [11.270818569449379, -0.09906154039350029],
            [11.273894314695802, -0.10410385222232058],
            [11.273881762716746, -0.10980306588749594],
            [11.28047508595258, -0.10838790026040639],
            [11.283105441762027, -0.1143477217938643],
            [11.286381254706896, -0.11297791593510284],
            [11.289512853597383, -0.11573441249998555],
            [11.296634066603009, -0.11590190326911333],
            [11.300020834463542, -0.11874907262638362],
            [11.300694278913957, -0.12229588532938833],
            [11.298233553511196, -0.12469151378918679],
            [11.29776830864426, -0.1288918428164279],
            [11.303307389391078, -0.12937142000214197],
            [11.30363657046147, -0.13409274625971696],
            [11.301304095263106, -0.13714728409222818],
            [11.30387530643915, -0.13910808736029653],
            [11.302337863361863, -0.14239971820181485],
            [11.302773485108256, -0.14653987710667382],
            [11.305891129461296, -0.14944192609325804],
            [11.302389733565688, -0.15160704726637214],
            [11.297977101039152, -0.15091544757515635],
            [11.297484698740238, -0.15504825556534396],
            [11.299763880560546, -0.15722167408886495],
            [11.29611834586566, -0.16605335323509318],
            [11.296742006074982, -0.17161008927288446],
            [11.304229612954476, -0.1664619949722501],
            [11.30735950628826, -0.17100665106273438],
            [11.310919021492525, -0.17023941307753468],
            [11.316652659954817, -0.1731068802758026],
            [11.31787672003207, -0.17599272180027584],
            [11.315132992973338, -0.18000434385583974],
            [11.316711165958484, -0.18193059949137766],
            [11.321828514560282, -0.18233987194136986],
            [11.323135668585554, -0.18774177789169258],
            [11.319324343846999, -0.19150670816473764],
            [11.323961622226161, -0.19299415451931806],
            [11.32251304377899, -0.19738967038494387],
            [11.326503470941786, -0.2005606429659485],
            [11.325870089374712, -0.20759094979069853],
            [11.331553399124532, -0.213869331117134],
            [11.336904792401791, -0.21174253704550472],
            [11.342850305783239, -0.20668985316393304],
            [11.346905928871232, -0.2064480642006925],
            [11.350153815123003, -0.20968481354303606],
            [11.354064975070397, -0.2101571219853883],
            [11.356850698248145, -0.20718511111432006],
            [11.361323553772577, -0.20797412318550743],
            [11.36586269465637, -0.21640914278971568],
            [11.36801359259281, -0.2155222379482646],
            [11.370992796997491, -0.2226495699166244],
            [11.374871661866905, -0.2230195281939681],
            [11.37802213672394, -0.22620544664973916],
            [11.378025938295272, -0.23143049382857214],
            [11.380583415845505, -0.23286261219983626],
            [11.380693100930026, -0.2392408326895918],
            [11.386541186246333, -0.23837431431450576],
            [11.391126683525012, -0.24144513799243503],
            [11.393507918876915, -0.24033252415706552],
            [11.398298042469596, -0.24243955555285315],
            [11.398136651109583, -0.25070591161513595],
            [11.40057025410451, -0.2514239101064863],
            [11.401936457656163, -0.26054063325518695],
            [11.408428174328979, -0.2611023108501025],
            [11.407624499743207, -0.2567195776922001],
            [11.410669061285757, -0.2527046445298285],
            [11.40682998033547, -0.24980371471842858],
            [11.40603720758961, -0.24553165126561569],
            [11.409973897543141, -0.245355448500017],
            [11.41134397586899, -0.23963916840857183],
            [11.413855260200181, -0.23467205928383333],
            [11.418865369984232, -0.23372325193424215],
            [11.42493811325066, -0.2361892511197329],
            [11.425932611434584, -0.2332848424143528],
            [11.430252011981763, -0.23163553695264075],
            [11.431781484930857, -0.2246554471138364],
            [11.435776721874351, -0.22487738625508022],
            [11.440575897933211, -0.22721320154935443],
            [11.444551920750634, -0.2236722567472254],
            [11.444665999006693, -0.2201839817760592],
            [11.450278169236277, -0.21474886173710162],
            [11.455981802848967, -0.21635253993761827],
            [11.458533908221236, -0.21433813332097976],
            [11.463071505371923, -0.21447761290893497],
            [11.466548118654572, -0.21865511772263255],
            [11.465290079840742, -0.22190599450522666],
            [11.469871046028597, -0.22551010121888063],
            [11.47174406721883, -0.23115116929999188],
            [11.475006590602103, -0.2322973623122221],
            [11.482097676874272, -0.23042060323091426],
            [11.484282057376511, -0.22488664681960271],
            [11.490523116310815, -0.22262555779715312],
            [11.495560922553347, -0.21921667757747215],
            [11.49453584821539, -0.21395850685235565],
            [11.496462903111803, -0.20989198326673805],
            [11.501290313175007, -0.2102910306987445],
            [11.505966516925639, -0.2164591358472205],
            [11.511940034054113, -0.22171163726775103],
            [11.517873935399312, -0.22196015784351283],
            [11.52322555551864, -0.21394589666988978],
            [11.527683771934734, -0.214603980778049],
            [11.530743751556724, -0.22012110563522233],
            [11.536894171088864, -0.22261480054404012],
            [11.544041842369142, -0.22797256315878997],
            [11.547748323533972, -0.22083164089010385],
            [11.552177046976528, -0.22143970168046484],
            [11.555258848776457, -0.22505956394085852],
            [11.555995386248359, -0.22995249706155058],
            [11.55462341633572, -0.23506066796970648],
            [11.555299700094075, -0.23955419040244566],
            [11.559513008797602, -0.24331106613486211],
            [11.562273864853914, -0.24953309823727893],
            [11.561509357679089, -0.25393718479098243],
            [11.558582635817723, -0.25662434472793666],
            [11.560980391402536, -0.2609608515957944],
            [11.558892407164887, -0.26975086565159284],
            [11.553700259630702, -0.2758420493959142],
            [11.552580786382732, -0.2699866109463537],
            [11.550136587160218, -0.26924724702592984],
            [11.546970254751933, -0.27276937207202767],
            [11.547017673457947, -0.2757235635575015],
            [11.552876592153089, -0.2801771683525942],
            [11.552191234621112, -0.2832170626366284],
            [11.543450489934907, -0.2852456495077857],
            [11.540728478796117, -0.28810424677227],
            [11.543445891414494, -0.29841890069850496],
            [11.541975294654916, -0.3039496246031152],
            [11.537762216764786, -0.31183212273952443],
            [11.54155666050004, -0.3159595506440697],
            [11.537594198081013, -0.3202304024712686],
            [11.532646526246863, -0.32005386419109394],
            [11.525942238452894, -0.32616476350532103],
            [11.525512356883986, -0.33388725972271427],
            [11.527795867698567, -0.33905770145235675],
            [11.521039354223756, -0.3458903644490987],
            [11.519162020559838, -0.3513789536779802],
            [11.513798507592872, -0.35320314000805225],
            [11.508432391018633, -0.3528831394600115],
            [11.506233072096316, -0.3547090117974002],
            [11.505007046261998, -0.3634250477898533],
            [11.502154424227635, -0.3670504567253412],
            [11.498833865635131, -0.3684239013553304],
            [11.489512445030947, -0.36715181320770346],
            [11.488336997610133, -0.37322860029949917],
            [11.484889117954125, -0.3767786850185643],
            [11.481525156921172, -0.3837515567261226],
            [11.47749511298369, -0.38405205276481036],
            [11.477468505869183, -0.3808671098845206],
            [11.471520631604307, -0.37753039922548154],
            [11.468853085542014, -0.384632493577123],
            [11.464073669613974, -0.3845738209793592],
            [11.463775375603376, -0.37690518765323805],
            [11.460738464766116, -0.37460005432812127],
            [11.460399478387023, -0.36665775140562623],
            [11.455120376440586, -0.3712069753614937],
            [11.451616561387771, -0.3699061984046419],
            [11.451064123546335, -0.36451942993812925],
            [11.4434923472917, -0.3680787265065221],
            [11.442383717567298, -0.3629145599698426],
            [11.444004139886783, -0.3575782762387501],
            [11.439467614494799, -0.35470229437478373],
            [11.434782282600208, -0.3564993281199791],
            [11.430587218075337, -0.36081722523825893],
            [11.425346101817944, -0.3608739152620449],
            [11.423245271621825, -0.36546422300599635],
            [11.419859066841843, -0.36571264309275636],
            [11.416985461693887, -0.3620485474033038],
            [11.412426018780012, -0.3718123121152906],
            [11.405721606577728, -0.372148814130014],
            [11.404314010588585, -0.3680342791473378],
            [11.40085250005438, -0.3665361750104742],
            [11.395201165980605, -0.37029162514303054],
            [11.388156237419514, -0.36616719161410594],
            [11.385803573111199, -0.361210315811209],
            [11.3814717404563, -0.3630892880100694],
            [11.382172201727379, -0.36798643580557233],
            [11.384940374753521, -0.373746535102619],
            [11.384395298974633, -0.380720393617584],
            [11.381431864757014, -0.3812045442911004],
            [11.380494410426246, -0.37624956334886966],
            [11.375169112712133, -0.37418474670352414],
            [11.367670618873584, -0.37517614615966616],
            [11.366542599551442, -0.36753819062982734],
            [11.358136211291619, -0.3580544341450198],
            [11.356632570151602, -0.3574587356389678],
            [11.345617884435683, -0.3588995627457692],
            [11.337661888322547, -0.36333813102345486],
            [11.33330984994069, -0.36249090211842244],
            [11.335392033682583, -0.3582608042968671],
            [11.332862512951081, -0.35650519259028307],
            [11.328524927588823, -0.35862065749333905],
            [11.323299346228678, -0.3588976288106401],
            [11.319386764394743, -0.3674719033946018],
            [11.311855494214504, -0.36710615257699347],
            [11.309578852905238, -0.3628284430660652],
            [11.310535837978895, -0.3596320762366727],
            [11.30801225247869, -0.35641023963026025],
            [11.302239139382834, -0.3553108004252562],
            [11.302532500288113, -0.3499880711867367],
            [11.31187456588337, -0.34756842828605644],
            [11.315285495549562, -0.34253738197771955],
            [11.311489162922596, -0.33262674885841326],
            [11.306658118086835, -0.3265393293827684],
            [11.299190933097918, -0.32575932637928895],
            [11.294780445323857, -0.3308843120490941],
            [11.287767725281935, -0.32986088282976733],
            [11.286492271180208, -0.32598292350670477],
            [11.286458220950326, -0.3176475657099072],
            [11.285344507047238, -0.31346623096472725],
            [11.27897227042183, -0.3159009491672999],
            [11.276265521900017, -0.31531793922051976],
            [11.274851451848319, -0.31093867623351923],
            [11.277952024575246, -0.3033339524780059],
            [11.273558631431529, -0.302155162640708],
            [11.268549138834606, -0.3067428236040739],
            [11.264331581758606, -0.3036456050816405],
            [11.263352906258191, -0.29837479851123105],
            [11.269151214801267, -0.29353714973740846],
            [11.269277619758196, -0.29050485270932097],
            [11.26459796997099, -0.28331763398570925],
            [11.265950407824466, -0.27821360347889357],
            [11.26331665524371, -0.27612244967830096],
            [11.257244731404047, -0.27703498768081003],
            [11.253531989402257, -0.28260052093138116],
            [11.256663643506824, -0.2867521042784561],
            [11.259817473404505, -0.29759932180721627],
            [11.255272271045552, -0.301130183591956],
            [11.248103070755485, -0.2998427136872785],
            [11.244899221461438, -0.3031991766474443],
            [11.238993100369836, -0.3039039970140301],
            [11.232480936236833, -0.29598476300766857],
            [11.233960478715701, -0.28792506842792515],
            [11.228358212075088, -0.28595194480221753],
            [11.225096888436314, -0.2774893749092981],
            [11.218382434827971, -0.27523302305370445],
            [11.212768809680844, -0.2706389686672653],
            [11.204541783443213, -0.276654498957527],
            [11.200514105503478, -0.2773410875239569],
            [11.187924431223696, -0.2719964953054909],
            [11.178203449011402, -0.26111989146148273],
            [11.176429396817317, -0.26193791683771933],
            [11.174748233766021, -0.269376070120121],
            [11.16960168259837, -0.2678572594110479],
            [11.168512790124684, -0.26035321190928296],
            [11.16271828129557, -0.2636463865583425],
            [11.161100569068767, -0.26098529224605393],
            [11.165981791277616, -0.2523361084926233],
            [11.161137359257014, -0.24834451063855156],
            [11.15999047417719, -0.24295187967002757],
            [11.163226918444385, -0.23617605246867354],
            [11.159335975686222, -0.23293275766542762],
            [11.154243638036668, -0.23210641187399958],
            [11.150768061521232, -0.2268647962645641],
            [11.149171168311039, -0.22151390802648135],
            [11.145285205568102, -0.21925093803116846],
            [11.14198573853033, -0.2079827505014529],
            [11.134908871608852, -0.20573900282010466],
            [11.129418478854099, -0.20171598258109874],
            [11.128319122987227, -0.19958150867251964],
            [11.132511737515776, -0.19270325880776668],
            [11.136934664255392, -0.19012782648373064],
            [11.136439984637944, -0.18447628035413016],
            [11.13882664087001, -0.18074271793070204],
            [11.14352219087416, -0.17751704088303327],
            [11.13968740239013, -0.17518340926803894],
            [11.130743771547754, -0.17983756653222466],
            [11.12518878347837, -0.17773710009307095],
            [11.12655582372085, -0.1743954577420471],
            [11.132278866153252, -0.16941359237392958],
            [11.13172665113204, -0.16663964578564405],
            [11.126963345445743, -0.16664705427598844],
            [11.122286461406544, -0.16854561561483078],
            [11.119688152673724, -0.166516766568541],
            [11.119572859680408, -0.16288981218182663],
            [11.11714895485911, -0.1574960956680822],
            [11.110818208269873, -0.15768244390833494],
            [11.105426553190291, -0.1520024032366826],
            [11.097706517095736, -0.1511815200272718],
            [11.092020820308552, -0.14511875189279513],
            [11.08718197585871, -0.14553061352661917],
            [11.085332078150444, -0.14344889981548223],
            [11.083260175242282, -0.13703952849099163],
            [11.077925250047, -0.13117431197461957],
            [11.07489395190184, -0.13181960165481318],
            [11.07006083725403, -0.14087427154942242],
            [11.065490273069296, -0.13779460637529067],
            [11.067106032961343, -0.12841018098780008],
            [11.064955667499497, -0.12026519108255716],
            [11.056820662433905, -0.11459205874075647],
            [11.053317895085888, -0.10770268466714475],
            [11.04729511056081, -0.10662485022458255],
            [11.046189575526718, -0.10468427916446323],
            [11.04960476231871, -0.09638407706386892]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.13470780167113, "lat": 37.72645585883613 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54059"],
        "coty_name": ["Mingo"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mingo County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01550036"
      },
      "bbox": [
        11.046189575526718, -0.384632493577123, 11.562273864853914,
        0.04795229102835166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.575892471777163, 0.5185525426387397],
            [12.562161193284057, 0.638582823756502],
            [12.580530622933209, 0.631831680673128],
            [12.617775642467238, 0.6741021108376694],
            [12.636683352159507, 0.695146738968675],
            [12.720763325918423, 0.7968054416695464],
            [12.790308680752192, 0.7934447971210403],
            [12.798736058268757, 0.8018009569236212],
            [12.901334341499325, 0.9060594878784336],
            [12.900928746843164, 0.9087322038608133],
            [12.90299579946753, 0.915936534789169],
            [12.902243941637881, 0.9212368002087499],
            [12.903079607744965, 0.9328530639684118],
            [12.901104643734232, 0.9397874063265244],
            [12.904820218050615, 0.9529210203904621],
            [12.904271675402285, 0.9579477543759977],
            [12.90774465009368, 0.9665348908016135],
            [12.90526022514758, 0.9736888851401553],
            [12.902925431787075, 0.9767710800898864],
            [12.90082707372616, 0.9871668497191053],
            [12.9072254409546, 0.9869333410987515],
            [12.909662805859568, 0.989195711513847],
            [12.912149109207524, 0.9973353105179968],
            [12.90999498566577, 0.9995990186439215],
            [12.90756965148551, 1.0068643171728058],
            [12.910854603840798, 1.0137796848759457],
            [12.91495978840462, 1.0159191799804987],
            [12.91479318617594, 1.0232784573433924],
            [12.918026757102904, 1.035500108459845],
            [12.917141750788279, 1.0379089327947657],
            [12.921134151812758, 1.0452540872851177],
            [12.918875259862181, 1.0533680756915225],
            [12.921639081879343, 1.0559947294876806],
            [12.925013063231614, 1.0669207662453097],
            [12.921679486762507, 1.0693527002422716],
            [12.920759972168439, 1.0729499288349187],
            [12.92648534374101, 1.0797744269870166],
            [12.925535347024994, 1.0848353599469407],
            [12.9312969249092, 1.0937155225903785],
            [12.931811509138207, 1.1021019628010837],
            [12.935348936205486, 1.1056823305731716],
            [12.944041219328678, 1.1016488855572704],
            [12.948791043056046, 1.1041072959037834],
            [12.953483533065807, 1.1023558379816776],
            [12.953583263526836, 1.0963286665914815],
            [12.957692590046241, 1.0947840765616954],
            [12.957615856996979, 1.0915959590697306],
            [12.96076186498949, 1.0892705063354735],
            [12.967432871393525, 1.0887833864704644],
            [12.971172084590645, 1.0834872199748264],
            [12.97439986605547, 1.0825082163355433],
            [12.970754397502729, 1.078190017547059],
            [12.972704611783504, 1.0673596805775838],
            [12.972898311588906, 1.0612460000671233],
            [12.96934470753543, 1.0568414713060175],
            [12.974263404129958, 1.0506228598895881],
            [12.978770422328187, 1.0499672360742873],
            [12.985809484529486, 1.0528233072163444],
            [12.989627673410716, 1.0593236582431238],
            [12.995136699343218, 1.0605842139320125],
            [13.002459134553732, 1.0559091682403425],
            [13.00446792854326, 1.0524659956298579],
            [13.007960804011567, 1.0427223729616495],
            [13.021588223779945, 1.0433420259103325],
            [13.020579917946433, 1.051874615074624],
            [13.021541275713043, 1.0558324952109062],
            [13.019864992893142, 1.0609724079672416],
            [13.029336360459089, 1.0674323506816445],
            [13.031549941116177, 1.071402881793118],
            [13.034353039477558, 1.0710697898420927],
            [13.041102031402009, 1.0660948194427493],
            [13.046655539171567, 1.0643955085274477],
            [13.053895115958998, 1.0669861269041703],
            [13.05961095971889, 1.0648036015568123],
            [13.059911982414206, 1.0590149764922874],
            [13.05585644034311, 1.0516499228197018],
            [13.056368147268772, 1.0460004191100194],
            [13.060157406909477, 1.045429685770784],
            [13.062385239391892, 1.0502235917602536],
            [13.066602270051193, 1.0480880290302155],
            [13.069372371811935, 1.0443143040093714],
            [13.066632798369383, 1.03302944650683],
            [13.063144502165855, 1.0300657044597608],
            [13.06144766308843, 1.0214640192775966],
            [13.065121001184767, 1.0200594976025297],
            [13.0678640060677, 1.0160287288489076],
            [13.067918931843279, 1.012554095961391],
            [13.075275834018138, 1.0099513553057788],
            [13.074258154238048, 1.0011661048433655],
            [13.070768902811917, 0.9979858129635784],
            [13.071901384011245, 0.9941862137518509],
            [13.066295700982845, 0.9916863967330803],
            [13.060650604407654, 0.9869718875486786],
            [13.061795609490439, 0.9845383105268484],
            [13.058983511934075, 0.9812828075239876],
            [13.057961738989155, 0.9749568292812449],
            [13.05452080578686, 0.9640103433054159],
            [13.055243577046884, 0.958790838424038],
            [13.0510814186148, 0.9521411731929293],
            [13.05520977638079, 0.9446600012935407],
            [13.051043681774162, 0.9423997186119676],
            [13.049807382138422, 0.9305033010358593],
            [13.050555279952544, 0.9243822394487768],
            [13.053573365405434, 0.9196808436537834],
            [13.050574809468346, 0.9093231554656546],
            [13.056067155731744, 0.905767279637115],
            [13.061174917670385, 0.8976360306095804],
            [13.052893740170822, 0.890972829389437],
            [13.048049060485372, 0.8903375739495698],
            [13.047668219528632, 0.8807416225312527],
            [13.044452147930642, 0.8749232532084338],
            [13.040083391866157, 0.8721670504734593],
            [13.0389498789731, 0.8647885527368159],
            [13.043076996928544, 0.8563712908088765],
            [13.039935613042571, 0.8525859894426393],
            [13.040904225759379, 0.8473443246378852],
            [13.04359645316092, 0.8469796119621288],
            [13.047950600187288, 0.8422886339800282],
            [13.051216479852362, 0.8358106118198145],
            [13.052441408089102, 0.8294707580947528],
            [13.050663427899536, 0.8248649152218444],
            [13.052791682206777, 0.8213694437218485],
            [13.052225031278171, 0.8150459843163071],
            [13.05460081472038, 0.8103370600754208],
            [13.04434383912084, 0.7924630523755505],
            [13.043625580039535, 0.786009059149701],
            [13.03857837962346, 0.776947238698712],
            [13.036607434396942, 0.7642638277781613],
            [13.034200803050462, 0.7613402461526653],
            [13.032645097904943, 0.7541864108040726],
            [13.032465589532409, 0.7470081960646501],
            [13.036658041344323, 0.7451261325053751],
            [13.038775888428278, 0.7383153295885372],
            [13.034461155564852, 0.7338190351902595],
            [13.033108437534924, 0.7300603219754137],
            [13.026309435271102, 0.7260576049133203],
            [13.016958757914184, 0.7279311701609272],
            [13.0103168595575, 0.7259060510075864],
            [13.01000991757848, 0.7209061880359074],
            [13.007284134143376, 0.7164544238296409],
            [13.009987493287916, 0.7131089787550497],
            [13.00729161632683, 0.7038825533261497],
            [13.003231664275898, 0.6991662615415708],
            [12.998227877527336, 0.6975551525615733],
            [12.99139725652075, 0.6887989772105797],
            [12.990133468462208, 0.6820948103342345],
            [12.984491650232584, 0.6732143597229179],
            [12.984168285460706, 0.6686588427400049],
            [12.98993008570652, 0.663077411355476],
            [12.992007516033345, 0.6567248905405481],
            [12.997938225534963, 0.6558552939029278],
            [13.003824410658977, 0.6475848795114192],
            [13.006896203400975, 0.6400512462771772],
            [13.005877656632945, 0.6340928915559476],
            [13.001518832492962, 0.6320712531148591],
            [12.998400379139712, 0.6264735864256818],
            [12.994914215593202, 0.623536640254295],
            [12.990374603740705, 0.6239934820532639],
            [12.98843621765476, 0.6181930343877547],
            [12.989680731029516, 0.6148240889653979],
            [12.985534034828035, 0.6107393578664291],
            [12.981880788943796, 0.6123768202697528],
            [12.977726375710565, 0.6108424099023393],
            [12.976365749430267, 0.6036541151763034],
            [12.974095898816973, 0.6016015095308604],
            [12.967451796215284, 0.5991567982088313],
            [12.965617863102407, 0.5920044973570494],
            [12.960913477423416, 0.5888883210764545],
            [12.95702150474675, 0.5809163497177354],
            [12.947369310661957, 0.5660170695691926],
            [12.938863434630798, 0.5580413396490989],
            [12.93866192651779, 0.553105909057225],
            [12.935597022288917, 0.5455918196583427],
            [12.930406090909706, 0.5405593081797581],
            [12.92412174332929, 0.538890023293255],
            [12.923454098819278, 0.5346455344154363],
            [12.920282320247303, 0.5299979069401478],
            [12.924197439780714, 0.5282245219395628],
            [12.923562562835867, 0.5226631449790727],
            [12.924830046283176, 0.5185034044191839],
            [12.92731186597984, 0.5180310651844569],
            [12.926930201826858, 0.5133539488153069],
            [12.92458677526288, 0.5125715075809503],
            [12.926577849313666, 0.5048608048610029],
            [12.922093806423726, 0.4994308676045224],
            [12.920561852184244, 0.49373079185299035],
            [12.921171067844023, 0.4885519964833316],
            [12.918271512873678, 0.48369009915364575],
            [12.911563831796487, 0.48134202468306025],
            [12.910421003444325, 0.47833214492193904],
            [12.918335349853757, 0.45922948139018377],
            [12.925862923623683, 0.45803304837659825],
            [12.928789081879662, 0.45643669348478505],
            [12.924322387006463, 0.44749643143959084],
            [12.923854513045427, 0.4447255066689936],
            [12.919115979746921, 0.43884328109360937],
            [12.915178384122516, 0.43064263526860364],
            [12.911791588445045, 0.4261307058336454],
            [12.90938108369227, 0.41371448449102305],
            [12.910417140001522, 0.40878973690987197],
            [12.873598328920169, 0.400139453308241],
            [12.7987033575578, 0.38180234777325045],
            [12.7610614878488, 0.35730218738460184],
            [12.754120802895823, 0.35408393057159016],
            [12.746433524625163, 0.3567751807497766],
            [12.741253764233376, 0.3565429897537136],
            [12.738642921630078, 0.35455737402452325],
            [12.735017555325804, 0.3570410223843952],
            [12.73079245272282, 0.35716742922567274],
            [12.727189560900955, 0.3522276698410677],
            [12.722283880601342, 0.34972470482155965],
            [12.717162993916359, 0.3539017601174899],
            [12.712077808754778, 0.3548536815523808],
            [12.710709666731562, 0.35289104270985966],
            [12.70364001040197, 0.35245858694872373],
            [12.67892344971885, 0.35223669139001],
            [12.591829872827958, 0.40716132296917895],
            [12.580889180837142, 0.4842255233452449],
            [12.575892471777163, 0.5185525426387397]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -80.00780889890375,
          "lat": 38.331790939559994
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54075"],
        "coty_name": ["Pocahontas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Pocahontas County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01550044"
      },
      "bbox": [
        12.562161193284057, 0.34972470482155965, 13.075275834018138,
        1.1056823305731716
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.70618182417804, 1.359940345360997],
            [11.707999885283034, 1.361575225881236],
            [11.700827848740493, 1.3754342708220704],
            [11.70301072240074, 1.3793047302799462],
            [11.704783983345664, 1.388128921717869],
            [11.704243267401663, 1.3931029570072033],
            [11.7052663741793, 1.399128828879472],
            [11.714438641164818, 1.4105929954802334],
            [11.71273344738308, 1.416245290779286],
            [11.715079507466696, 1.4247660530379669],
            [11.718188019512546, 1.4322875122822711],
            [11.717357535859273, 1.4376901359615122],
            [11.722543175126395, 1.4455118652232837],
            [11.729509353938148, 1.4506175360587859],
            [11.732038776191564, 1.4478465182341786],
            [11.737663882557962, 1.4493937421834941],
            [11.742718085054587, 1.4569760965910796],
            [11.74244676655913, 1.4631649089875693],
            [11.73981893841564, 1.4675535208867339],
            [11.739677363248001, 1.4719238598151285],
            [11.743168454117777, 1.4838094445323826],
            [11.746634751713714, 1.487927887336366],
            [11.74521013630993, 1.49107563627444],
            [11.758839372451984, 1.4932137608028306],
            [11.763332668348346, 1.4917736390152503],
            [11.767366376752607, 1.492909490946767],
            [11.769092098113578, 1.495638367483476],
            [11.767087304396188, 1.4984924268056043],
            [11.775425256920112, 1.4982688047715191],
            [11.776471359508989, 1.4962541667365008],
            [11.782186841815879, 1.495131880463085],
            [11.787512840452129, 1.5018876336037703],
            [11.792524908930194, 1.5000395061959615],
            [11.793346528796887, 1.5022120519048476],
            [11.805789040150367, 1.5060657057626492],
            [11.809553479688885, 1.5037442347366434],
            [11.81147972831474, 1.5087474985427252],
            [11.816589862604129, 1.5083273708570353],
            [11.821721026993922, 1.510683733851683],
            [11.821847587513119, 1.514244829378291],
            [11.824772245862295, 1.5200998971831077],
            [11.830513897324796, 1.5195986937131305],
            [11.834662137228506, 1.523945430450541],
            [11.84017480567287, 1.5248279879087026],
            [11.848020848170242, 1.5309741584213326],
            [11.851614286446042, 1.527245395461458],
            [11.855281275918044, 1.5295627912656122],
            [11.857177189705881, 1.526899910944444],
            [11.863460361477408, 1.5254428285870998],
            [11.867285253176407, 1.526764116842546],
            [11.869276832060628, 1.530349437302338],
            [11.875850560354172, 1.532924443967525],
            [11.87780901559543, 1.54355514217459],
            [11.87720717288216, 1.5472382022348952],
            [11.882652018888871, 1.5561611405958755],
            [11.886107315844448, 1.5528422709495284],
            [11.888862569583429, 1.5530754845795676],
            [11.893031628378441, 1.5590512096293085],
            [11.900032126875148, 1.5593935129211418],
            [11.902117130997588, 1.553139363162909],
            [11.906312333947215, 1.551149809943523],
            [11.911671410049594, 1.5511625288108983],
            [11.916056860297463, 1.554886336645212],
            [11.915993256720363, 1.5581870449563886],
            [11.93063727087573, 1.5573594981176806],
            [11.935859966870273, 1.5534884693250213],
            [11.939673169492137, 1.5546199545798636],
            [11.938964073378804, 1.558303241173395],
            [11.942037212144646, 1.5606667810108037],
            [11.944842496517085, 1.5654342052689183],
            [11.946074947092885, 1.572930565017918],
            [11.945201663473714, 1.5754348365375994],
            [11.948036390604488, 1.579177072126068],
            [11.947582773425653, 1.5871338449926842],
            [11.945012470774053, 1.5898677734855544],
            [11.944813714812584, 1.5946144734590395],
            [11.946667066748148, 1.5970197007118019],
            [11.947631759663185, 1.603401313772472],
            [11.951203625413426, 1.6065820105194408],
            [11.954303001976001, 1.6036713424375253],
            [11.961362900630961, 1.603350106531004],
            [11.96963801191889, 1.5951822325874216],
            [11.972178709583117, 1.5983369803372807],
            [11.97520864962329, 1.5943918469455287],
            [11.97865022363462, 1.5953896129897935],
            [11.986555999450756, 1.5885232502411466],
            [11.990414686152336, 1.5835002552160542],
            [11.99365680413822, 1.5819790935208689],
            [11.994505822955345, 1.5775682355491243],
            [11.992366392983827, 1.5746956852152212],
            [11.997021865999193, 1.5695041561393472],
            [11.994466581160152, 1.5646618341752463],
            [11.996378587063843, 1.5541040710901415],
            [11.993145212363812, 1.5533046755147175],
            [11.991422371349094, 1.5476730711640738],
            [11.99388724632015, 1.544444950599637],
            [11.993823463143153, 1.5375645126649118],
            [11.996837017157258, 1.5360228301807768],
            [12.000638092627447, 1.5313542747879445],
            [11.998431274233498, 1.528000702261282],
            [11.997490278121361, 1.52214060070314],
            [11.999164405117067, 1.517351727151824],
            [11.98357526885907, 1.4930329674046496],
            [11.998406457231253, 1.4720367119879356],
            [12.001973154979737, 1.4662404013151027],
            [12.020330837012125, 1.4401803822265544],
            [12.058401325300915, 1.3848251836245136],
            [12.086216685828623, 1.3423364270216973],
            [12.089476205370005, 1.3327085412728914],
            [12.08425619225742, 1.3285612503812956],
            [12.084641238609573, 1.3238815548956728],
            [12.080876784300687, 1.3248559188697213],
            [12.077706761236055, 1.3234213895414089],
            [12.075179637852836, 1.3194344244930059],
            [12.076272806625473, 1.3166445173598067],
            [12.073817642368669, 1.3127111343667965],
            [12.069236572202533, 1.3121582827997866],
            [12.067386814114753, 1.3141978716243186],
            [12.058724771528254, 1.3118629971207407],
            [12.06149323311556, 1.3080018755875864],
            [12.057064537243557, 1.3043971812426263],
            [12.057186193114791, 1.3014305599279508],
            [12.054408978380529, 1.2982365612068685],
            [12.050825995677092, 1.3001158160746],
            [12.042363978980914, 1.2979655842108253],
            [12.043833316382976, 1.2938719449187734],
            [12.040900979195808, 1.2929599548414497],
            [12.038482871549029, 1.2880557739232155],
            [12.03118134970536, 1.286844528729823],
            [12.029191813247767, 1.2830613460365263],
            [12.030230765202175, 1.2783823009949458],
            [12.026724758094792, 1.2754705529743646],
            [12.021440744353857, 1.26736456180241],
            [12.019228096086481, 1.2680715207781366],
            [12.016278896142909, 1.2636906090279874],
            [12.010702791854692, 1.2644537313682667],
            [12.00880655114701, 1.2623943733321839],
            [12.0045113038117, 1.2631818228260665],
            [11.998398847414933, 1.2600013687756866],
            [11.996163387605092, 1.2570786531747609],
            [11.988512131936167, 1.2526895424553004],
            [11.985843778815783, 1.253275741473893],
            [11.982112267607095, 1.2499012761649437],
            [11.984045349805863, 1.246497086454641],
            [11.979848962353875, 1.2416329671612878],
            [11.975745400448163, 1.2420081627670234],
            [11.971078846221369, 1.238769554950526],
            [11.97229081392406, 1.2340594174113593],
            [11.966124214993258, 1.2325192147054413],
            [11.962999711642288, 1.227513213960723],
            [11.961125932115657, 1.2220001338948336],
            [11.956208284181052, 1.2215325814562488],
            [11.954752292075606, 1.2184391033619317],
            [11.946834530980988, 1.2192245545713467],
            [11.942761496338994, 1.2159189315069798],
            [11.936989646306403, 1.217393892887558],
            [11.934558758643403, 1.216047208207741],
            [11.930631497742818, 1.2187210272224378],
            [11.925120603266954, 1.2141417620742994],
            [11.911241298746386, 1.2117362696779164],
            [11.908008200320957, 1.2129615827704816],
            [11.903020213919987, 1.2114584421848995],
            [11.897103769812842, 1.2173653008452971],
            [11.890181907271085, 1.2144318653482473],
            [11.886414939414683, 1.221396730525421],
            [11.880310349647871, 1.2196133296276714],
            [11.877587072357205, 1.225009145070618],
            [11.871487009650151, 1.2276224536174758],
            [11.869281469746785, 1.2332023553571172],
            [11.864678968289313, 1.2376875573794992],
            [11.862273214243917, 1.2351619266935365],
            [11.855981204613586, 1.2399941287968936],
            [11.852800464809944, 1.2374488166735929],
            [11.837628022247086, 1.2322840416452014],
            [11.832618146135573, 1.2258590361843436],
            [11.833330302927445, 1.2215332701995383],
            [11.828858756384747, 1.2215736680191758],
            [11.824221194157738, 1.2234275004644664],
            [11.819435496238322, 1.2296919062755833],
            [11.81048663736565, 1.2275348545608662],
            [11.801037665980397, 1.2242368313192427],
            [11.800298961990714, 1.2278064136693425],
            [11.796712230028216, 1.2301291247641029],
            [11.792102426005329, 1.2297433129878537],
            [11.78711060420892, 1.227324956216581],
            [11.784384744582233, 1.224343467666748],
            [11.783068788062359, 1.2153504469580803],
            [11.774473070103944, 1.2195216784437142],
            [11.766160040798066, 1.215316190480281],
            [11.76307272941406, 1.2180720891588077],
            [11.765978298381247, 1.2214434353455657],
            [11.763589399784287, 1.230300670916805],
            [11.760107041590473, 1.2359136796722041],
            [11.750096179583181, 1.2353103118033795],
            [11.746463450199657, 1.2373112440375387],
            [11.744546454228969, 1.2416092032678885],
            [11.752653725466487, 1.2450212558715714],
            [11.754850085721241, 1.2516211564062025],
            [11.752605504203217, 1.2609615967071908],
            [11.750347597374963, 1.2632730956305656],
            [11.749944960194817, 1.2724058835799505],
            [11.746532466095776, 1.2766700955742025],
            [11.74712154308546, 1.2820776528291438],
            [11.744725340771293, 1.2856609207127812],
            [11.741767661198482, 1.2864277894910767],
            [11.735237104915006, 1.284950167082351],
            [11.734000633095032, 1.2909683846166475],
            [11.730695649778891, 1.2979957968857045],
            [11.723514002649239, 1.3018828114239698],
            [11.723509297827965, 1.307099177107915],
            [11.720076640783448, 1.308436205572563],
            [11.715331546224391, 1.306977094815898],
            [11.713515991096925, 1.3041392038271702],
            [11.693113016300671, 1.3139766845471368],
            [11.688090802500296, 1.32085947543245],
            [11.687961053301514, 1.3234062514080913],
            [11.694120351135423, 1.324397344573777],
            [11.69354241055221, 1.3284678900343365],
            [11.69846325560752, 1.3305854117076934],
            [11.695107574632834, 1.3341539851974638],
            [11.694722950792524, 1.3397766014833956],
            [11.702657609151512, 1.3460922671202946],
            [11.707524213349222, 1.352629343342805],
            [11.707969859865411, 1.3578676115805193],
            [11.70618182417804, 1.359940345360997]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.06303717814687, "lat": 39.17825309517343 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54085"],
        "coty_name": ["Ritchie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ritchie County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01689049"
      },
      "bbox": [
        11.687961053301514, 1.2114584421848995, 12.089476205370005,
        1.6065820105194408
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.085151223682826, 4.166282647639188],
            [6.143590882431903, 4.171400613466592],
            [6.170912365810832, 4.1739188378120495],
            [6.166003375507208, 4.23216917784773],
            [6.180196445958495, 4.232729515535847],
            [6.22274009866867, 4.236542405964162],
            [6.241971304116197, 4.238650252901445],
            [6.2834945223107646, 4.241840776371339],
            [6.33707017234351, 4.246291742571945],
            [6.387132160604754, 4.249791480253022],
            [6.422808684119783, 4.251867076486596],
            [6.4446604205966915, 4.253791302338483],
            [6.440305738798855, 4.229376759959756],
            [6.439261868444657, 4.220657348500902],
            [6.439103170940146, 4.20086990636686],
            [6.440117583115206, 4.191690381689166],
            [6.442727501187968, 4.1870850915206965],
            [6.443947001235608, 4.179485213666655],
            [6.447165187662067, 4.174392306153115],
            [6.446420805915144, 4.164863171869033],
            [6.448228597010808, 4.1546469414158365],
            [6.450255748928907, 4.135052997256711],
            [6.4498212359255875, 4.128121562067723],
            [6.453080506984935, 4.106113466671235],
            [6.454362550005831, 4.100960549501688],
            [6.459637751439727, 4.088272538975383],
            [6.459370169654182, 4.085632763030633],
            [6.462599189360064, 4.078734046600045],
            [6.348244859021664, 4.071116624212366],
            [6.281549007312277, 4.066119032861935],
            [6.233650651343308, 4.063036370704713],
            [6.172258719212667, 4.0577691354837],
            [6.135255569205299, 4.054546553027343],
            [6.1195646489034665, 4.052256991302082],
            [6.095470056078049, 4.050256931797395],
            [6.085151223682826, 4.166282647639188]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.04246707454594, "lat": 42.57691761759688 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55059"],
        "coty_name": ["Kenosha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kenosha County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "01581089"
      },
      "bbox": [
        6.085151223682826, 4.050256931797395, 6.462599189360064,
        4.253791302338483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.6405141140408395, 7.003554383106797],
            [2.733205503019735, 7.005831820405404],
            [2.8049867820862073, 7.008220754159851],
            [2.8300565075070203, 7.008946509881949],
            [2.8907941216584327, 7.010104803349502],
            [2.8882682879100297, 7.095974736229951],
            [2.917097965042369, 7.096551112968702],
            [2.973179565192214, 7.096987231164404],
            [3.001528810411714, 7.097573042783448],
            [3.033820440220472, 7.099270107834346],
            [3.052282246481045, 7.099384938593237],
            [3.084394955777251, 7.100687668983429],
            [3.1492679244648922, 7.102908929866523],
            [3.149253434461372, 7.089037516261975],
            [3.152428757960113, 7.017786745809572],
            [3.1525937137013713, 7.010463391472067],
            [3.155351558519811, 6.9464766528019375],
            [3.156590170325509, 6.914519231104621],
            [3.1577873589542, 6.868654232998251],
            [3.15879913787539, 6.839542680705267],
            [3.1615941369352845, 6.77138823447655],
            [3.1630110387849792, 6.72643500842954],
            [3.1650638037418344, 6.675612833887108],
            [3.166061306657225, 6.655375359455146],
            [3.1687221089990443, 6.590848200410024],
            [3.11032077136752, 6.588293352832992],
            [3.034933609268264, 6.585303358569437],
            [2.9747133676949424, 6.58309636163618],
            [2.913891924699515, 6.581167148973995],
            [2.8848293910142755, 6.580896410357306],
            [2.826444149813182, 6.578676330726599],
            [2.745550506656694, 6.575183091145432],
            [2.748255379537107, 6.578458104254366],
            [2.7496717212363073, 6.584375217029252],
            [2.745223390658556, 6.596021507932815],
            [2.744924705587627, 6.6037518427176884],
            [2.742608467161443, 6.61490457323647],
            [2.743422190700533, 6.618718518118899],
            [2.748200670291432, 6.627094662614746],
            [2.7472578908252476, 6.634918358518333],
            [2.7413545299070896, 6.6439290376147495],
            [2.7402656013983275, 6.6499691956534095],
            [2.7422793128462897, 6.656030728816301],
            [2.7477554034218508, 6.6582202282392915],
            [2.7513423926490614, 6.6611896781809214],
            [2.7571231022685616, 6.665976056065657],
            [2.7634128709013974, 6.674969971636768],
            [2.7754795473259066, 6.687329382619776],
            [2.7789324316508655, 6.692642258784895],
            [2.782682676449083, 6.702562720576488],
            [2.7820815098110634, 6.708553855493035],
            [2.7785109629861378, 6.719604007979656],
            [2.7792804955368484, 6.724414194998777],
            [2.7834716822090453, 6.729585904790674],
            [2.7952982594839715, 6.739121838061411],
            [2.7966050144007077, 6.746549833049336],
            [2.801522692297968, 6.755640882103469],
            [2.805166319842896, 6.759940465470505],
            [2.814580973213269, 6.765435910977094],
            [2.814307942352204, 6.770198149744248],
            [2.816689569165979, 6.780139905076643],
            [2.8139600989524864, 6.785948726696574],
            [2.814375053614345, 6.796348533676488],
            [2.815739168612731, 6.8083382624829865],
            [2.811011329738532, 6.820983410480354],
            [2.80496842473596, 6.824499461424058],
            [2.791366929931451, 6.830053516800189],
            [2.7864937030908923, 6.83776076759838],
            [2.7829724721556963, 6.841615142471452],
            [2.774959282622702, 6.858002575432256],
            [2.767833633421741, 6.867925183664177],
            [2.757090981439768, 6.878663877182908],
            [2.755763191060256, 6.889733768933423],
            [2.7577429068062917, 6.900818853596903],
            [2.756589937277816, 6.905117847636456],
            [2.742524920221835, 6.916461072343984],
            [2.7344521552875882, 6.92063931226557],
            [2.724810935001761, 6.929688231592435],
            [2.720724394082949, 6.931078797391434],
            [2.7139193144908043, 6.930263990843465],
            [2.703058466322997, 6.924900936988229],
            [2.695712096678673, 6.9229357816734405],
            [2.6878615955584007, 6.922488042788071],
            [2.680198025006599, 6.924381169210913],
            [2.6714826622128545, 6.927488756899478],
            [2.654207340956972, 6.927980360528395],
            [2.6450837257656334, 6.935529619346417],
            [2.644131278763841, 6.938810272264847],
            [2.644943686585215, 6.94977225553953],
            [2.6425788174754996, 6.954709567223678],
            [2.6433112740066727, 6.964781442776568],
            [2.6447986464380513, 6.9700075954690845],
            [2.641590762341582, 6.979378627380664],
            [2.6402983235466184, 6.9878913109973],
            [2.641033634501049, 6.99290472205617],
            [2.6400798319832917, 6.998435872468748],
            [2.6405141140408395, 7.003554383106797]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.44138434271628, "lat": 45.4614436013274 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55095"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "01581108"
      },
      "bbox": [
        2.6400798319832917, 6.575183091145432, 3.1687221089990443,
        7.102908929866523
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2044908832055303, 7.533438014622991],
            [3.2923073500503386, 7.536969097441472],
            [3.316781670723712, 7.5382309403358265],
            [3.378930609113347, 7.541129556001912],
            [3.4608580407796263, 7.544821655514348],
            [3.5427863555321557, 7.548494346550796],
            [3.550034802884403, 7.548037121104734],
            [3.5545230755912334, 7.462345298723603],
            [3.5577863280350743, 7.37625700351162],
            [3.5647708802633957, 7.375834238666484],
            [3.565173580408431, 7.361953339331229],
            [3.5670451289026492, 7.322996288118985],
            [3.56862822847184, 7.301479938501219],
            [3.5709846584795546, 7.250289091266658],
            [3.5738473860532936, 7.208123677294124],
            [3.57528742082631, 7.162016919665662],
            [3.579923018037536, 7.072217151114774],
            [3.5819891790422798, 7.034302820616423],
            [3.5620497700795997, 7.033451033558697],
            [3.5428741154306036, 7.033203462324921],
            [3.5140513767796877, 7.031691625074567],
            [3.4843388087312923, 7.0310140902170035],
            [3.4124554164567824, 7.027669740914337],
            [3.3673248379615868, 7.025926640927205],
            [3.324530341365024, 7.024080481276684],
            [3.252728308517129, 7.022043491092358],
            [3.2387085038695087, 7.021493438638384],
            [3.237422169680252, 7.049905821564653],
            [3.2351453122864076, 7.106264195067848],
            [3.2320720369105236, 7.170477799305353],
            [3.2310087563103522, 7.195266780208402],
            [3.227653340721682, 7.266189407767288],
            [3.225408789783095, 7.310124912189148],
            [3.2229850998143452, 7.362028610443266],
            [3.2109927207847844, 7.361629183408166],
            [3.2106401725609066, 7.377478834336527],
            [3.2091436807210765, 7.415110207307396],
            [3.207073665954056, 7.45639605038363],
            [3.205398523073384, 7.50118165745918],
            [3.2044908832055303, 7.533438014622991]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.79123230571405, "lat": 45.89922838694345 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55129"],
        "coty_name": ["Washburn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washburn County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01581124"
      },
      "bbox": [
        3.2044908832055303, 7.021493438638384, 3.5819891790422798,
        7.548494346550796
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.952702059044354, 5.129760689590224],
            [-5.8451449405330695, 5.121286205217869],
            [-5.843724883607499, 5.121439014533992],
            [-5.72571480016897, 5.111191543375849],
            [-5.607707358362058, 5.1009129425860875],
            [-5.485266774332036, 5.0906378417500315],
            [-5.348058607851036, 5.079323553012314],
            [-5.344658077640066, 5.079298887503976],
            [-5.346785900119545, 5.0538585826508164],
            [-5.353536078436803, 4.973391876649692],
            [-5.36120008335653, 4.880149806124605],
            [-5.362021683704941, 4.868517876976407],
            [-5.366501778048347, 4.815366882103244],
            [-5.376673106016143, 4.690666703740471],
            [-5.383704213613649, 4.607507429095052],
            [-5.38610727169448, 4.577472383580555],
            [-5.40692803365175, 4.331651547327991],
            [-5.41562199630612, 4.227160630645238],
            [-5.41902148141272, 4.188881028717365],
            [-5.419328303652183, 4.188766653974675],
            [-5.5425667126028415, 4.199572858702659],
            [-5.643013696038163, 4.207690409439579],
            [-5.65428312439193, 4.208112279568894],
            [-5.694523330765151, 4.21099572412777],
            [-5.702093339877525, 4.211325026280913],
            [-5.82662883728418, 4.221609279580634],
            [-5.836540662426793, 4.22298171577014],
            [-5.858465341958809, 4.22518762344488],
            [-5.946121514051488, 4.233688210909114],
            [-6.016691437557745, 4.240204049589627],
            [-6.030977565173371, 4.2405819696054765],
            [-6.022933460056225, 4.328188721321147],
            [-6.02070494711975, 4.3554149209685935],
            [-6.015390582915837, 4.4143318527179884],
            [-6.019003543213292, 4.4148815562040475],
            [-6.017520467744962, 4.4292285210887],
            [-6.017630640443169, 4.436404953129743],
            [-6.01645813000779, 4.443316093327295],
            [-6.01585199519342, 4.454976994743142],
            [-6.011149898761747, 4.496083630536157],
            [-6.008361447724252, 4.5264420432587755],
            [-6.007751270043953, 4.530015282998141],
            [-5.987617744708616, 4.748974108688852],
            [-5.98529955697272, 4.76276704637116],
            [-5.975051116199809, 4.877896884037339],
            [-5.9749109312137465, 4.880797871557016],
            [-5.96358818584731, 4.9990327421695815],
            [-5.963497516092502, 5.005444303281276],
            [-5.954631796811264, 5.10821024499923],
            [-5.952702059044354, 5.129760689590224]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.47540772211015,
          "lat": 43.05643181639772
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56027"],
        "coty_name": ["Niobrara"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Niobrara County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "01605078"
      },
      "bbox": [
        -6.030977565173371, 4.188766653974675, -5.344658077640066,
        5.129760689590224
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-10.116225224486602, 7.162299677319227],
            [-10.07791571755218, 7.156102499536067],
            [-10.00816253065303, 7.145222779505354],
            [-9.938411368329165, 7.1343299780456855],
            [-9.880003726127113, 7.116505903548283],
            [-9.791002784111896, 7.10310950575381],
            [-9.728865541987334, 7.093991184240547],
            [-9.699187851365464, 7.090288757096232],
            [-9.671342462016028, 7.091906392499655],
            [-9.614126079913653, 7.083439994173625],
            [-9.586249846965135, 7.076914903445543],
            [-9.542189163838868, 7.069703047851841],
            [-9.515396190140608, 7.065896914407765],
            [-9.460334365955456, 7.064315940003274],
            [-9.366591731235713, 7.050290687899535],
            [-9.264712855845099, 7.035271077254399],
            [-9.245864727604461, 7.031559371986253],
            [-9.219811266666012, 7.027329686697665],
            [-9.10570924734232, 7.012005182372292],
            [-9.034047614259174, 7.002751082129807],
            [-8.962387592851487, 6.9934832859419584],
            [-8.897997405359439, 6.9850807588664],
            [-8.835495008635469, 6.976718193839018],
            [-8.75932810005148, 6.966330868063272],
            [-8.74593521903593, 6.958202286419536],
            [-8.66349814383012, 6.947070688730585],
            [-8.661118645598515, 6.946535819875665],
            [-8.619974112775589, 6.941333208092057],
            [-8.578042598277067, 6.935739726458469],
            [-8.466672587969116, 6.9210127927581615],
            [-8.422891210419161, 6.915274836049984],
            [-8.425746783162174, 6.898470900681748],
            [-8.42635675609581, 6.890415745513866],
            [-8.430505635139172, 6.860062887018098],
            [-8.432896066358452, 6.837280758507563],
            [-8.439369614709035, 6.7882832356220195],
            [-8.419621323938559, 6.785629730847005],
            [-8.434102011522052, 6.677573212828891],
            [-8.43477056245612, 6.673597820385332],
            [-8.447742577701032, 6.575829551223173],
            [-8.463412832198948, 6.460579007612955],
            [-8.466160575227445, 6.439803251860992],
            [-8.452729144532633, 6.437906275013641],
            [-8.469440176650792, 6.3135301384844835],
            [-8.476419874748505, 6.2623344050819805],
            [-8.499606813540822, 6.089758359488936],
            [-8.483141722720369, 6.087568624518341],
            [-8.495045743109864, 5.999503668076506],
            [-8.569225158955357, 6.009653950832697],
            [-8.572205595287292, 6.009812408176818],
            [-8.66638201770277, 6.02257121549545],
            [-8.677954862653406, 5.934926667541508],
            [-8.766201784654115, 5.946669678081786],
            [-8.775633319149144, 5.861186967101643],
            [-8.838109668165398, 5.869661877100266],
            [-8.842304634379387, 5.8706345653764735],
            [-8.903723252574327, 5.878446297040186],
            [-8.912534965459376, 5.812702336774831],
            [-8.916213429077322, 5.792593501468942],
            [-8.944602565186756, 5.794882579607555],
            [-9.043786256730055, 5.808799870942018],
            [-9.044173045835983, 5.806262592382035],
            [-9.07293376592573, 5.810030453072952],
            [-9.074834864083092, 5.815522525817872],
            [-9.074800311712863, 5.822400299946629],
            [-9.07722749340382, 5.826572062496629],
            [-9.07618667387477, 5.831408985312446],
            [-9.078648874821402, 5.835503941178263],
            [-9.085290878863885, 5.840822619391332],
            [-9.089096274115542, 5.839412656278397],
            [-9.095075198230447, 5.839987038889258],
            [-9.09870200454609, 5.842137425341132],
            [-9.10704350104, 5.8448005498925015],
            [-9.107303109324516, 5.850821802381996],
            [-9.10950966640027, 5.855216855943847],
            [-9.108472403613451, 5.858757456293227],
            [-9.10980164050454, 5.868795318655013],
            [-9.107360533043485, 5.879581465606552],
            [-9.11097805652755, 5.885489297607494],
            [-9.11920572551236, 5.886530642423838],
            [-9.123764784553542, 5.888848336817601],
            [-9.126062650777524, 5.893264648024844],
            [-9.125024515478412, 5.896759058116697],
            [-9.12723565083464, 5.904166592422429],
            [-9.125887104239633, 5.90694025949273],
            [-9.129856290264469, 5.909524088511327],
            [-9.1308767109402, 5.914977210449262],
            [-9.140317940313265, 5.917105810530841],
            [-9.144752766038291, 5.921768489029576],
            [-9.146968549731596, 5.9278932796665185],
            [-9.14844427520241, 5.938824619119796],
            [-9.155092864125299, 5.938868962783407],
            [-9.157620259819712, 5.937324137111426],
            [-9.169528116712645, 5.943571697265507],
            [-9.16727352110759, 5.9499370603130535],
            [-9.167931553091488, 5.956406040221369],
            [-9.17153293318847, 5.9599074200715805],
            [-9.177810507316364, 5.961526235771136],
            [-9.186623775205435, 5.95633685202064],
            [-9.190451068601508, 5.953244524241351],
            [-9.196862247345315, 5.954468563969793],
            [-9.202038858791948, 5.95886068611308],
            [-9.203734778265408, 5.961857606841869],
            [-9.209372275793918, 5.966664944000194],
            [-9.210910953689666, 5.971894661998405],
            [-9.213772121700794, 5.974844183478659],
            [-9.215040564400605, 5.979471624424451],
            [-9.222478257806467, 5.979746591106989],
            [-9.228479700214379, 5.974617138890023],
            [-9.233443383261367, 5.975512040027903],
            [-9.2352987596342, 5.9718539640858515],
            [-9.240293185240548, 5.967416288354949],
            [-9.243432503554317, 5.962671007368938],
            [-9.248195160206226, 5.960539453590994],
            [-9.25058944226987, 5.961353229082586],
            [-9.254680881254748, 5.969240658724369],
            [-9.25834116063909, 5.97313388170573],
            [-9.263432439336619, 5.970516008595235],
            [-9.262837029941194, 5.964407978911216],
            [-9.264055132696114, 5.961504143322095],
            [-9.270562026516101, 5.953250031929118],
            [-9.275413446897264, 5.952183866893287],
            [-9.279117136747608, 5.954277041823469],
            [-9.285031862029271, 5.953213909051133],
            [-9.287411792504638, 5.950903802270053],
            [-9.29118696554472, 5.95147662836235],
            [-9.295254910220596, 5.947042747919845],
            [-9.297066308412528, 5.9424478120973685],
            [-9.302356278919476, 5.93727578068193],
            [-9.30333545596511, 5.930807561716348],
            [-9.305166084306995, 5.926434109826204],
            [-9.304323292813677, 5.917027757099695],
            [-9.307377848335872, 5.911956414769088],
            [-9.311469814250943, 5.909794958840765],
            [-9.315026133286374, 5.912327028435677],
            [-9.316717423191076, 5.9063804707800305],
            [-9.320840401519922, 5.900568181120716],
            [-9.319979236040755, 5.892234496652805],
            [-9.31763445709378, 5.889044130703979],
            [-9.31937567952814, 5.877784218691639],
            [-9.323865310965147, 5.8778073452942685],
            [-9.327374956442007, 5.875878101982452],
            [-9.33366911239124, 5.878343747220984],
            [-9.336704949792514, 5.874205157622962],
            [-9.340963743930491, 5.874421093637073],
            [-9.346179151848823, 5.876911876144767],
            [-9.349427811354476, 5.872967910970393],
            [-9.35912325630266, 5.875170508660743],
            [-9.361455834876303, 5.8709834720943475],
            [-9.368011939251303, 5.872145965659185],
            [-9.371695221432349, 5.86667198588597],
            [-9.375716743842004, 5.8678608938267685],
            [-9.38325875812351, 5.862062092100139],
            [-9.38518958358774, 5.858731580545729],
            [-9.38836936314789, 5.859081557398617],
            [-9.392706186434163, 5.863027270675026],
            [-9.394676063891026, 5.8591020587475455],
            [-9.39900751113072, 5.856458285072372],
            [-9.404915372792432, 5.856205771259649],
            [-9.40651705683389, 5.85142974129438],
            [-9.413694275579173, 5.848563113532835],
            [-9.419701727121764, 5.852479089072182],
            [-9.421770651919827, 5.8553985493793865],
            [-9.42654584041313, 5.856747576606707],
            [-9.429118082504008, 5.861545426514527],
            [-9.437424290269256, 5.86505996456862],
            [-9.436918779464825, 5.872757887237626],
            [-9.443072259537537, 5.872059097893927],
            [-9.44716002866145, 5.8699096661992005],
            [-9.44989411202722, 5.871060640131663],
            [-9.454885337811021, 5.876007719212994],
            [-9.457383785011363, 5.880283168028045],
            [-9.455622293605515, 5.886490255862677],
            [-9.453921823784563, 5.888122453086],
            [-9.455449204202003, 5.893453048069827],
            [-9.453548738844768, 5.899795966301919],
            [-9.450618153183292, 5.900403640855375],
            [-9.4475232426338, 5.903902405353105],
            [-9.442978969970861, 5.902753794571524],
            [-9.440316433071438, 5.904298245534546],
            [-9.431602862653886, 5.903738443653319],
            [-9.426400932441302, 5.907289185884446],
            [-9.424151950940331, 5.910600014263637],
            [-9.426768002864215, 5.915134087627649],
            [-9.432033642741482, 5.915242330612302],
            [-9.433601226036279, 5.920213278170998],
            [-9.430855824718117, 5.9236905384809715],
            [-9.421426764229718, 5.927689831911248],
            [-9.4217446386712, 5.930504294149549],
            [-9.425443434169935, 5.934980845089495],
            [-9.430175586077981, 5.938305400204821],
            [-9.430679583812706, 5.943708222549714],
            [-9.433956473992863, 5.943788427144426],
            [-9.440730168049729, 5.950381479699861],
            [-9.448810092668063, 5.952094060595543],
            [-9.439645283240784, 5.958187209618417],
            [-9.440590671205639, 5.96284096013088],
            [-9.43885220373376, 5.966993916235468],
            [-9.438944747379756, 5.971134540960016],
            [-9.441800323429389, 5.974586683295586],
            [-9.446363501115341, 5.977345917324113],
            [-9.454226795359155, 5.980320493278971],
            [-9.454438352503697, 5.9860566617085995],
            [-9.44684276349429, 5.991592926009062],
            [-9.441876679362425, 5.993381905557816],
            [-9.44081640770879, 5.999614921097283],
            [-9.438505762687445, 6.000539717745676],
            [-9.440093192992322, 6.008567668737935],
            [-9.449338735322907, 6.005194668253532],
            [-9.453875821416432, 6.004539316702223],
            [-9.457818162998885, 6.0021666880783355],
            [-9.466345633245039, 6.001372537896846],
            [-9.479127155379459, 6.002258429109884],
            [-9.486752489948234, 6.0033879449294165],
            [-9.490119888538526, 6.00782253345465],
            [-9.494114407520705, 6.010173850300053],
            [-9.497249184564202, 6.017125525821018],
            [-9.501395177467876, 6.017784184570589],
            [-9.510149977164527, 6.02547898753559],
            [-9.516254420082861, 6.02317052351267],
            [-9.520764783980106, 6.018016201746832],
            [-9.528183978750539, 6.017704461755956],
            [-9.533092840105516, 6.014000964093499],
            [-9.537197544342979, 6.014312592623234],
            [-9.540942592584669, 6.0176523564463515],
            [-9.54212310052019, 6.020985188362368],
            [-9.540116803305828, 6.02630694505047],
            [-9.540357779945632, 6.0323295354725035],
            [-9.55122544736551, 6.033833304155844],
            [-9.552011934800953, 6.035362265968936],
            [-9.550516429391434, 6.046342224197713],
            [-9.553487416042671, 6.050716626849313],
            [-9.553018099378354, 6.053371712082468],
            [-9.55775195944094, 6.064363774385059],
            [-9.55749132164699, 6.0707233610006535],
            [-9.564638796149302, 6.073810993522899],
            [-9.567535276390846, 6.078560322428219],
            [-9.570629205896717, 6.078249637628482],
            [-9.552333622873922, 6.201236842228523],
            [-9.599203752730833, 6.208143393101018],
            [-9.600875428378982, 6.216432538081593],
            [-9.600376635368246, 6.232976918059278],
            [-9.601074234768324, 6.235228862580404],
            [-9.595770708808294, 6.237012200405591],
            [-9.595283801481788, 6.241542391585398],
            [-9.591683823600537, 6.244105792450062],
            [-9.594397144421029, 6.248856798243005],
            [-9.59252405964014, 6.252185229347922],
            [-9.588892313743543, 6.2539693877876665],
            [-9.585037969902064, 6.252233607650296],
            [-9.581495884217567, 6.258839335237887],
            [-9.588057173967107, 6.259071634235651],
            [-9.587802108092255, 6.264761190448524],
            [-9.592941860241439, 6.266833641458086],
            [-9.591265511999465, 6.269822009974385],
            [-9.584962350376081, 6.265503541925217],
            [-9.5825857587594, 6.266948076687636],
            [-9.58340982949484, 6.273155783436785],
            [-9.589033785591916, 6.273284333828704],
            [-9.591067380859778, 6.276847784568381],
            [-9.590916523668223, 6.280521782795055],
            [-9.585407401089853, 6.2842848665173365],
            [-9.581323306643478, 6.282648136282256],
            [-9.58345088550896, 6.290424546670355],
            [-9.586296939072723, 6.290132999259409],
            [-9.589223622782578, 6.286600901748109],
            [-9.59226604614341, 6.298745362860453],
            [-9.594858285603642, 6.301598431652895],
            [-9.592924842032835, 6.305268822669481],
            [-9.59673975169838, 6.312910443197389],
            [-9.59287458824535, 6.3157757342070155],
            [-9.593147156954926, 6.319457799402348],
            [-9.590362223807356, 6.324429636079953],
            [-9.594279263106959, 6.324823388437073],
            [-9.597967870646082, 6.330384301260974],
            [-9.598321252203297, 6.334512776744548],
            [-9.594268839957033, 6.339601712321976],
            [-9.597654458777239, 6.341244270493932],
            [-9.600400861536585, 6.348212131827201],
            [-9.59429697584548, 6.348796407238104],
            [-9.592810358958975, 6.351900448519842],
            [-9.595789779764031, 6.35454690327623],
            [-9.594625706884232, 6.359320779585206],
            [-9.597484735894717, 6.3666304780000225],
            [-9.60721987975115, 6.378203541364265],
            [-9.609784479522109, 6.374812453543884],
            [-9.61409011542642, 6.377376499842632],
            [-9.611305581076389, 6.3812617433615015],
            [-9.612362197472795, 6.383483807420005],
            [-9.624085101863898, 6.3811660674271256],
            [-9.628886551230659, 6.387926924106374],
            [-9.631662969687634, 6.387217346145654],
            [-9.635025939183773, 6.39740624489572],
            [-9.630093537994458, 6.4017582297484115],
            [-9.62870897439081, 6.409340236015624],
            [-9.63909387084561, 6.415018124575905],
            [-9.642424863022375, 6.419210067387202],
            [-9.64307683936508, 6.425944664670383],
            [-9.640797534274972, 6.431455735813143],
            [-9.642273868248365, 6.4356972211962065],
            [-9.642156510261703, 6.4426698400433065],
            [-9.640783389118466, 6.445218354035776],
            [-9.64127903629432, 6.454771723728796],
            [-9.64008009912371, 6.457484253074579],
            [-9.643843715522358, 6.466297707188617],
            [-9.64841472547969, 6.472355392712123],
            [-9.65558678433621, 6.476420659703205],
            [-9.654289702820929, 6.483281749338098],
            [-9.654099275590227, 6.490702775087632],
            [-9.657039102601498, 6.49590736428543],
            [-9.665008648588278, 6.500903687373842],
            [-9.669086491435246, 6.502303802307742],
            [-9.674465965410564, 6.508761864985357],
            [-9.674695552268691, 6.512496386113129],
            [-9.678290170378732, 6.518037210572491],
            [-9.679522236395423, 6.522143264081686],
            [-9.678563073469391, 6.525460862347188],
            [-9.675299823894882, 6.528075858274714],
            [-9.674910864668478, 6.532789014265512],
            [-9.67098466762644, 6.5403971650317745],
            [-9.66967435368902, 6.559263940090884],
            [-9.665108891432384, 6.560869767360864],
            [-9.662017168276092, 6.56655169049767],
            [-9.662067665584797, 6.577666218042804],
            [-9.65632832328552, 6.585507040651603],
            [-9.656574711532864, 6.592677489438471],
            [-9.652561990371042, 6.603228035155993],
            [-9.656239101544552, 6.611592682587293],
            [-9.660690380458997, 6.6165478761465515],
            [-9.664199531580715, 6.616407314617784],
            [-9.665935357343034, 6.618880395283032],
            [-9.662768726179795, 6.623532038054375],
            [-9.659433840718217, 6.6257483209645445],
            [-9.658138337097238, 6.630074268057372],
            [-9.661163062223775, 6.635305138672176],
            [-9.668865208410384, 6.643154105796798],
            [-9.6741269933778, 6.646207981710462],
            [-9.676315191789833, 6.645067554808254],
            [-9.685604495903519, 6.645268397044108],
            [-9.687833606613003, 6.639872312050043],
            [-9.705796263590987, 6.648419546701513],
            [-9.70775428838789, 6.651318142612066],
            [-9.721319052037314, 6.662523313979111],
            [-9.713747892982349, 6.664648922101045],
            [-9.711347010949801, 6.670476069741795],
            [-9.713522306188167, 6.676438856567271],
            [-9.712023569700342, 6.679038740933512],
            [-9.814771639601528, 6.69465404241749],
            [-9.91752379106493, 6.710242161989268],
            [-9.904637381735727, 6.792357120137671],
            [-9.959199879624695, 6.800964307459302],
            [-9.962685836550154, 6.801867364202123],
            [-10.068870655770077, 6.818279492886561],
            [-10.175059913337176, 6.834662304207684],
            [-10.165843306793162, 6.8936286777377545],
            [-10.144936273838875, 7.025408051675661],
            [-10.12283903070833, 7.163371842579349],
            [-10.116225224486602, 7.162299677319227]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -109.58792698579745,
          "lat": 44.52045675770591
        },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56029"],
        "coty_name": ["Park"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Park County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01605079"
      },
      "bbox": [
        -10.175059913337176, 5.792593501468942, -8.419621323938559,
        7.163371842579349
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.11396624202543,
          "lat": 18.343350598292915
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72061"],
        "coty_name": ["Guaynabo"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Guaynabo Municipio"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01804511"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9743219153793532, -1.0567674175439568],
            [1.9743847535358907, -1.0388664854139333],
            [1.9757144907284816, -0.9397493611724337],
            [1.972090533910063, -0.9396835464433251],
            [1.9720185316737766, -0.9347809546804591],
            [1.9732356529613262, -0.8661734319345712],
            [1.9751064792545412, -0.7929003557003791],
            [2.011160289680004, -0.793887846169286],
            [2.0611852203332086, -0.7949696890918081],
            [2.061715437714537, -0.7952006728172634],
            [2.1045210579635714, -0.795860960706317],
            [2.143619300618881, -0.796236154175852],
            [2.147218485798855, -0.7953567577745414],
            [2.1675935043003514, -0.7969979039399216],
            [2.1760897603677085, -0.7968317721809837],
            [2.1761893329732476, -0.8016916040786114],
            [2.1750597166252024, -0.8554238072744748],
            [2.1817511749285226, -0.8557451320701969],
            [2.2325526793344896, -0.8569491665174386],
            [2.2683875427033873, -0.8570017544332792],
            [2.318502412293345, -0.8573870850998967],
            [2.3181779264161477, -0.9012179433010423],
            [2.3175390023887688, -0.9454165652610869],
            [2.33551895997229, -0.9455189465937375],
            [2.3352497561103687, -1.0133779365711386],
            [2.334761799890031, -1.0734791103901706],
            [2.3346778986238315, -1.1162917063796152],
            [2.303429277025962, -1.116291336967896],
            [2.2631046528071868, -1.1160237360010459],
            [2.2106816692095577, -1.115307727382334],
            [2.160696148859287, -1.1149186014922914],
            [2.0748232490561715, -1.1156009396679607],
            [1.9812777505196526, -1.1157077629006098],
            [1.9740519138926431, -1.1154969487150572],
            [1.9743219153793532, -1.0567674175439568]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.8565921235529, "lat": 37.723862684261796 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29039"],
        "coty_name": ["Cedar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cedar County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00758474"
      },
      "bbox": [
        1.9720185316737766, -1.1162917063796152, 2.33551895997229,
        -0.7929003557003791
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.546693777634085, 1.0415873789218595],
            [2.601299334325644, 1.04387095700773],
            [2.6146672173367618, 1.0446937910616252],
            [2.629485610647944, 1.0448961129787928],
            [2.646948296507417, 1.0456950272590062],
            [2.686916220665056, 1.0489331899388994],
            [2.706940862645662, 1.0487570908147537],
            [2.7722080415659023, 1.047196515221264],
            [2.791591862053376, 1.0474019852426388],
            [2.858458876464467, 1.0476132096208937],
            [2.9293532781873726, 1.0495427938984387],
            [2.986963869530067, 1.0500669856017777],
            [2.987414880157199, 1.0163697034809431],
            [2.987292866048315, 1.0060714194837126],
            [2.9879017508975125, 0.9614083882591634],
            [2.9845090256052207, 0.9613974022555325],
            [2.984396748648223, 0.919448573592477],
            [2.9846181180872873, 0.8753255186640405],
            [2.985209145962294, 0.8679746176014576],
            [2.985202592125142, 0.8372016032226774],
            [2.985653457909328, 0.7789521076902162],
            [2.9859601961622833, 0.7638239271543156],
            [2.9864676517403863, 0.7129810606871589],
            [2.9863862333838513, 0.6698289519433656],
            [2.950465633969904, 0.6807771339261498],
            [2.9220699369412064, 0.6898208014065728],
            [2.904929110694053, 0.6389626675376697],
            [2.886195954899183, 0.5840095782701722],
            [2.8809354676505814, 0.5698969965878653],
            [2.8809065308492277, 0.5743342829584059],
            [2.8762444687513042, 0.5791543937708399],
            [2.8683380700121046, 0.5792638040054603],
            [2.8627792658325957, 0.5761282166189508],
            [2.8541923014851274, 0.5679817772490136],
            [2.8450566170030975, 0.5643515925337436],
            [2.8374124431994345, 0.5645487275718033],
            [2.8303391783195035, 0.5682811753033952],
            [2.826808818844061, 0.5735734135505752],
            [2.826223294743616, 0.5822337134775367],
            [2.828189491138175, 0.5872820129172805],
            [2.8292422696347805, 0.5956348214469227],
            [2.8281116442709937, 0.6002048735214236],
            [2.8226692004670664, 0.6055189642271355],
            [2.8125698916194755, 0.6083701889903583],
            [2.8042189208927173, 0.6117091936943955],
            [2.797308453467191, 0.618627239858621],
            [2.794929066944294, 0.6244878398140328],
            [2.7955270127807057, 0.6295791887880452],
            [2.7988021081529477, 0.6401819999764186],
            [2.7977685226863205, 0.648116664478358],
            [2.7933464056475703, 0.6542167407096998],
            [2.786626570051456, 0.6566825191477242],
            [2.7802278866913026, 0.6567816422920686],
            [2.7610578655348537, 0.6536644691204238],
            [2.744322008452138, 0.653259530565803],
            [2.728108862316099, 0.657349784811611],
            [2.7150107936854475, 0.664922126412399],
            [2.709913597572464, 0.6695396463411833],
            [2.7059839491443505, 0.6746963898412517],
            [2.702678648383068, 0.681649978445667],
            [2.7016627602951098, 0.6871440073440915],
            [2.7025635342498484, 0.7000107564538215],
            [2.701861518672386, 0.7048468200320028],
            [2.699213554451826, 0.7110793331923497],
            [2.6932745093349157, 0.7181279481124776],
            [2.6895053677787297, 0.7206867220570131],
            [2.680327623880249, 0.7225232073461942],
            [2.6748847764627914, 0.7242005924230003],
            [2.6715787593803753, 0.728113433115112],
            [2.6690380305549906, 0.7411990387152259],
            [2.6690838774845664, 0.7444340242721798],
            [2.6715636561820975, 0.7498979117740165],
            [2.670924632937375, 0.7529131482357263],
            [2.6669119656761278, 0.7567208116584953],
            [2.652604230513736, 0.7618983833273096],
            [2.6447812093183383, 0.7587761298233832],
            [2.6407099084362886, 0.7597689799500822],
            [2.6381937310281116, 0.7631887433004393],
            [2.6368383997541436, 0.7685508502115597],
            [2.6320091881667604, 0.7742646857047588],
            [2.6255304369683508, 0.7703091009769532],
            [2.618369225493407, 0.7699591571607293],
            [2.6118299528493116, 0.7737907853604767],
            [2.607772942709038, 0.7740608004983129],
            [2.6067279027738244, 0.7707985595103587],
            [2.601315921867515, 0.766644367959964],
            [2.5954499888836984, 0.7672981581686213],
            [2.5972945620538366, 0.7753106380003074],
            [2.5969230254894753, 0.7783463396402788],
            [2.592131353724419, 0.7801154226713023],
            [2.5886542284182723, 0.7766671817592387],
            [2.592640739068559, 0.7727324615329784],
            [2.5933620385721543, 0.768255869315858],
            [2.5911464043404986, 0.7670660605944312],
            [2.583674238598964, 0.7728006250157807],
            [2.582468887789405, 0.7767330203007531],
            [2.583676290298743, 0.7809427620913836],
            [2.5902888621577773, 0.7876320035932021],
            [2.5860055240428887, 0.7973058732878185],
            [2.588225994097975, 0.8046059174696772],
            [2.5858142055315216, 0.8090411105181302],
            [2.5830922457401253, 0.8100633356035504],
            [2.575434031112664, 0.8079197461020268],
            [2.576512359341423, 0.8019873071561734],
            [2.572203085367301, 0.7989377976297917],
            [2.5687667043408187, 0.7943759201718964],
            [2.5707976787468882, 0.7868219545742803],
            [2.569581852197831, 0.7791314429719327],
            [2.565912517959906, 0.7782961535342112],
            [2.563576925451851, 0.7828969323112642],
            [2.5668616970246356, 0.7867261271202389],
            [2.5665832267714297, 0.7958980712752535],
            [2.5604964140280773, 0.7989474391273891],
            [2.5581452961995805, 0.7955998634819494],
            [2.550243419589574, 0.7926744180755443],
            [2.5462842053850396, 0.7955104194803878],
            [2.550870844835056, 0.7974697083264032],
            [2.5557509663335325, 0.7971202930733815],
            [2.557892452868579, 0.8030174949401944],
            [2.55668253301633, 0.8091897242803138],
            [2.5537111058996107, 0.8144054829512759],
            [2.5462042565202734, 0.8202616250300887],
            [2.545383632154235, 0.8326924354695067],
            [2.5504309538921826, 0.8323758082836494],
            [2.553439369621649, 0.8341354623953381],
            [2.552178188576177, 0.8391913633772714],
            [2.547742372506194, 0.8428626090461384],
            [2.544569553780134, 0.8513029276003062],
            [2.5397842118174543, 0.8555259883592373],
            [2.540035820162684, 0.8587572536312782],
            [2.5441356542037727, 0.8604669542802508],
            [2.544257742629594, 0.8673022697360135],
            [2.5394515455098694, 0.8689226217998741],
            [2.5371047770806174, 0.87200487672203],
            [2.5378492731605684, 0.8749189852277808],
            [2.5436115677892954, 0.8758199407159566],
            [2.548426671224323, 0.8708175674318536],
            [2.5505740766880027, 0.8768669202510515],
            [2.554003308838902, 0.8789688722937994],
            [2.56039777752503, 0.8790563582527597],
            [2.55814022697575, 0.8826534413601056],
            [2.5538950682400907, 0.8812144002678705],
            [2.551924426559141, 0.8863274250916938],
            [2.5577651500478917, 0.8905921125783491],
            [2.5566345778012938, 0.89378451858417],
            [2.548528940055673, 0.8968913234879362],
            [2.547846585853909, 0.9018394573608772],
            [2.5505863486439075, 0.9082419382877125],
            [2.5473130436977867, 0.9138970590442334],
            [2.5482893656638765, 0.921257455901588],
            [2.54428392170385, 0.9254356400202027],
            [2.5443487432302496, 0.9295388123209283],
            [2.547359241198489, 0.9343818080635419],
            [2.547167629006772, 0.9380737245562398],
            [2.5434851965156864, 0.9441744630956656],
            [2.5407548786925096, 0.9526409707204645],
            [2.538411114765799, 0.9561036288422001],
            [2.541162976590789, 0.9599534669515796],
            [2.5436747344334405, 0.9577143793450728],
            [2.5482832648774045, 0.9567714361171713],
            [2.5529796898073, 0.9601475984636264],
            [2.552958842561526, 0.9666976252940696],
            [2.5475690835538765, 0.97128179262549],
            [2.535663695646138, 0.9886414387329745],
            [2.54304672197649, 0.9901603335372238],
            [2.5422174317395636, 0.9946223083076362],
            [2.535240698446471, 0.9992717543178609],
            [2.533333880008337, 1.0041088488369148],
            [2.5361837209404814, 1.0082075350575235],
            [2.5351526475116715, 1.0107555797040497],
            [2.5379614514149065, 1.019177274942887],
            [2.5332708673884428, 1.0196377908623788],
            [2.5382238590218758, 1.028310527451595],
            [2.54849817123937, 1.0356484009085911],
            [2.546693777634085, 1.0415873789218595]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.96261060826806, "lat": 39.51506194487484 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29041"],
        "coty_name": ["Chariton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chariton County"],
        "coty_fp_code": "041",
        "coty_gnis_code": "00758475"
      },
      "bbox": [
        2.5332708673884428, 0.5643515925337436, 2.9879017508975125,
        1.0500669856017777
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.814775533254694, 1.4612597099661786],
            [1.9004040760774104, 1.4609333902667667],
            [1.9864750835338087, 1.462023766650068],
            [2.071496506608577, 1.4634266540992331],
            [2.1577545837161822, 1.46476024335573],
            [2.157805773342859, 1.4335935925495338],
            [2.158690809581083, 1.4060034718973824],
            [2.159312688105104, 1.3988859181884739],
            [2.159593527621258, 1.3620924955648652],
            [2.1604190229823033, 1.3622330072260211],
            [2.1616449731173137, 1.3306686474922091],
            [2.1621042566467703, 1.3266428126891854],
            [2.163424847364129, 1.2899578118488508],
            [2.1659857486930036, 1.2165666509155502],
            [2.1668376971880154, 1.2019783404582634],
            [2.169243161456111, 1.1388908103324402],
            [2.169849459481429, 1.113606384689772],
            [2.084903686400267, 1.1137972219147891],
            [1.9988283188239466, 1.1108954817333987],
            [1.9663526995954315, 1.110010951073082],
            [1.915421906741462, 1.1092437996069846],
            [1.863671725087304, 1.110265921494003],
            [1.8296189523024693, 1.1107041468537078],
            [1.8278818038733355, 1.2245598296299913],
            [1.8267513534150268, 1.3584828210754394],
            [1.8151056659056757, 1.3586127884960688],
            [1.8151481105521663, 1.4495673333731638],
            [1.814775533254694, 1.4612597099661786]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.98548027201706, "lat": 39.96074739358975 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29061"],
        "coty_name": ["Daviess"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Daviess County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00758485"
      },
      "bbox": [
        1.814775533254694, 1.1092437996069846, 2.169849459481429,
        1.46476024335573
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.9615431987543643, -0.8390843556410523],
            [4.047585711604402, -0.8355269578149382],
            [4.133981473074488, -0.8325892795537417],
            [4.135259035886703, -0.8828053280740179],
            [4.136489043065414, -0.9205562536183883],
            [4.1651883737638125, -0.919831290683487],
            [4.259730354644671, -0.9171069581767921],
            [4.260417915863617, -0.9471217741524111],
            [4.26235721220935, -0.9900614409944676],
            [4.262995214251929, -0.9979155014312528],
            [4.263999357418592, -1.027336981212582],
            [4.245722037501257, -1.0276837764578968],
            [4.22135711636743, -1.0287731457082658],
            [4.192833403407408, -1.028665734957882],
            [4.164669241814332, -1.0281181404870092],
            [4.140416076971994, -1.028754962236104],
            [4.143386576060418, -1.1172524129146268],
            [4.224564450383456, -1.11645955428833],
            [4.225852935169014, -1.1436581267595731],
            [4.228280108399992, -1.2038478257347256],
            [4.1321199766443115, -1.2064509031840054],
            [4.103240980873338, -1.2070754614044035],
            [4.058880133418887, -1.2093989635564195],
            [4.042143757779531, -1.2093254307229193],
            [4.028583066230291, -1.209806162251745],
            [3.9467675526199106, -1.2113601300555241],
            [3.886366133659458, -1.2127659239668396],
            [3.801126196583849, -1.2152297926880178],
            [3.7985337738881286, -1.159788833241174],
            [3.797373336568491, -1.1271263939105556],
            [3.7934436004370786, -1.0390616134515334],
            [3.7508694080884384, -1.0408559827976387],
            [3.746902530985554, -0.9345259250775958],
            [3.748054049560426, -0.9344781351599764],
            [3.745012215467443, -0.8548695759765592],
            [3.7445603599211736, -0.8466594213927899],
            [3.776976497899729, -0.8451150824371989],
            [3.8186043918026766, -0.8435789090471691],
            [3.886184249792612, -0.8418222302450118],
            [3.8900633370137068, -0.8412371307207255],
            [3.9615431987543643, -0.8390843556410523]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.50793047312848, "lat": 37.60663169764937 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29065"],
        "coty_name": ["Dent"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dent County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "00758487"
      },
      "bbox": [
        3.7445603599211736, -1.2152297926880178, 4.263999357418592,
        -0.8325892795537417
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3343316696356444, -1.263004174320076],
            [2.4133005110042793, -1.2631461306644711],
            [2.4222863387968396, -1.26281323820024],
            [2.4595872667336205, -1.262746472548231],
            [2.47531712783055, -1.263116531697108],
            [2.547433626572412, -1.2633797603056556],
            [2.5653109106644885, -1.2638134103168952],
            [2.6065639222168917, -1.2638105713695114],
            [2.6349361659317148, -1.2634401676877225],
            [2.67948506567363, -1.2638890975042487],
            [2.698524563476437, -1.263731274453758],
            [2.7291737374317933, -1.2639973287845743],
            [2.7653327345448977, -1.2635319132214098],
            [2.7656361241901366, -1.307599294689579],
            [2.766313513190565, -1.358685442122617],
            [2.767150735082751, -1.409495454109078],
            [2.779171319240886, -1.4097105346547785],
            [2.7800529955018543, -1.463587759040821],
            [2.7814513448615887, -1.571117380771967],
            [2.7818774516313693, -1.5925537762769848],
            [2.6966079536247927, -1.592925636757865],
            [2.6751648190144235, -1.5928080076981375],
            [2.6248137788133463, -1.592132480991962],
            [2.598203091563759, -1.5921869006722433],
            [2.540333099704873, -1.5931140908970474],
            [2.478542950505672, -1.5936566957908578],
            [2.445957272056401, -1.594128261235281],
            [2.425039842075645, -1.5940758168769438],
            [2.3523292039665096, -1.5950363156609608],
            [2.3513959826146085, -1.491945498558679],
            [2.351185965198278, -1.4488006383780987],
            [2.3506690899727882, -1.4099679939991223],
            [2.3343111703136588, -1.409844185745928],
            [2.3343583100100247, -1.3666877908443062],
            [2.334166467723723, -1.36607256846744],
            [2.334318955881799, -1.3218248136920472],
            [2.334152045233455, -1.307131917499646],
            [2.3343316696356444, -1.263004174320076]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -93.34199540155363,
          "lat": 37.258068465596885
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29077"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00758493"
      },
      "bbox": [
        2.334152045233455, -1.5950363156609608, 2.7818774516313693,
        -1.262746472548231
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.361701251293527, -0.8577105500778873],
            [2.3624067715205763, -0.8577935346258467],
            [2.36279143736984, -0.7840104454970434],
            [2.36297025835254, -0.7699215249459407],
            [2.407215237755341, -0.770173307799566],
            [2.4081037124033764, -0.6842881202682654],
            [2.4086825840257715, -0.6602991155445989],
            [2.409353962332745, -0.6089173197324019],
            [2.4149950521368555, -0.6093224761867603],
            [2.48035763086555, -0.6101304739721035],
            [2.49428817119961, -0.6106186317806123],
            [2.5492247680308036, -0.611369196920678],
            [2.5992157870089807, -0.6115783320820762],
            [2.6284592096580477, -0.6114305755273802],
            [2.665795096092155, -0.6109452819768298],
            [2.7087198005191944, -0.6109771392242351],
            [2.7515779423756808, -0.6098900810720314],
            [2.750967901303478, -0.6687132049931578],
            [2.7509009152354436, -0.7713988218821319],
            [2.7324648364028152, -0.7717483464520775],
            [2.66478367959666, -0.7723806888394813],
            [2.663702093115211, -0.8749394161269655],
            [2.58089125997842, -0.8752690557697838],
            [2.5143613612677687, -0.8745319368961446],
            [2.4829666981509244, -0.8737579884181846],
            [2.45201768814779, -0.8733255462173308],
            [2.361375569452649, -0.8725654375191367],
            [2.361701251293527, -0.8577105500778873]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.32071951381873, "lat": 37.94079145559743 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29085"],
        "coty_name": ["Hickory"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hickory County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00758497"
      },
      "bbox": [
        2.361375569452649, -0.8752690557697838, 2.7515779423756808,
        -0.6089173197324019
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.2236967239073997, 1.669165958319526],
            [3.2973979530575126, 1.6727749090342696],
            [3.3029599576540862, 1.6733367367383005],
            [3.3514432620610277, 1.675641346826499],
            [3.4397535297845687, 1.6777630416412663],
            [3.467416833592747, 1.6782092498755479],
            [3.524414569945995, 1.67941075188859],
            [3.5254847848329036, 1.6354222495471111],
            [3.526700336042832, 1.5918030042871536],
            [3.5300504765687113, 1.5917933723741957],
            [3.530777743163631, 1.5592007841751423],
            [3.5311685116732887, 1.5303402496655045],
            [3.531885127059009, 1.5003679035426953],
            [3.534661738312909, 1.4128170821739128],
            [3.5360470608186074, 1.3571723282940225],
            [3.537259896003982, 1.3251674668948732],
            [3.472646363014342, 1.323633594770184],
            [3.409879998216115, 1.3232912146989975],
            [3.366585063237884, 1.3232166285658726],
            [3.282755317301403, 1.3178694225633456],
            [3.2395912804171614, 1.317010879023259],
            [3.238032850391835, 1.3905686205284922],
            [3.237677537017921, 1.4016098262711],
            [3.236065420670254, 1.4015952515420786],
            [3.2358909554216577, 1.4023406714460518],
            [3.2320170314535726, 1.4892285884400167],
            [3.2315223691882697, 1.506754009337775],
            [3.2280817785786695, 1.5816579976450864],
            [3.226449622291695, 1.5815407624071738],
            [3.223981703040089, 1.647355572417732],
            [3.2236967239073997, 1.669165958319526]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.14807423247771, "lat": 40.12823818216234 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29103"],
        "coty_name": ["Knox"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Knox County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00758506"
      },
      "bbox": [
        3.2236967239073997, 1.317010879023259, 3.537259896003982,
        1.67941075188859
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.556862308451191, -1.711009596695432],
            [1.556082678433758, -1.6525852007666537],
            [1.5846964062009523, -1.6527028153765486],
            [1.609572398430288, -1.6531290725798051],
            [1.6520891535084283, -1.653140986547286],
            [1.667210602349295, -1.652564189216348],
            [1.7538199333714803, -1.6525211715955108],
            [1.8396672178131181, -1.651823984912197],
            [1.8830275190496863, -1.6524337795665995],
            [1.9977409679533678, -1.6536198454222693],
            [1.9972811228777942, -1.7499448262671793],
            [1.9973464377548011, -1.771079565249968],
            [1.9969482008701918, -1.7952071073718054],
            [1.996936712620518, -1.829555090104322],
            [1.9964588430511947, -1.861977665020249],
            [1.996552604340886, -1.8735930031279553],
            [1.9976361471528465, -1.873612341666983],
            [1.9965808977296613, -1.945936525739409],
            [1.9962456549884013, -1.956773486076901],
            [1.9479961568377533, -1.9554843612334682],
            [1.8274417121722033, -1.952881892746584],
            [1.6921512494820068, -1.9491496624867544],
            [1.6911165737571072, -1.9489666852998568],
            [1.635754241142065, -1.9473876386361486],
            [1.56000124691184, -1.9454585288513584],
            [1.5587580774469383, -1.8639748924909074],
            [1.5580572896219667, -1.8309386541783772],
            [1.5581370503878265, -1.8138174522147437],
            [1.5576170825134414, -1.7809023070911627],
            [1.5575289167708957, -1.76020178651948],
            [1.556862308451191, -1.711009596695432]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.33925589406715, "lat": 36.90548443121705 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29145"],
        "coty_name": ["Newton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Newton County"],
        "coty_fp_code": "145",
        "coty_gnis_code": "00758527"
      },
      "bbox": [
        1.556082678433758, -1.956773486076901, 1.9977409679533678,
        -1.651823984912197
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.3921215076406375, 0.2691287548395498],
            [2.3927076368110183, 0.31153893849403663],
            [2.3936824117312177, 0.35743297339069624],
            [2.39401703208184, 0.4015710890230806],
            [2.3945314900631467, 0.4356702907517434],
            [2.3951259372679035, 0.4897784593413889],
            [2.3962077277494345, 0.5486444770717633],
            [2.3961978784159346, 0.5615251489739272],
            [2.39748627147583, 0.6227038466022466],
            [2.406883831754956, 0.6225237482677916],
            [2.4140568790718016, 0.6156081847808756],
            [2.4183453648981548, 0.6032444100957371],
            [2.4234356472205763, 0.5988872830301079],
            [2.4321102868039772, 0.5978456531935467],
            [2.446689749490207, 0.5987368100929925],
            [2.451960774464328, 0.5962113631962215],
            [2.45535068627999, 0.5911980182942763],
            [2.454288613176626, 0.585279399442451],
            [2.4464011287369747, 0.572516643582723],
            [2.4465929033498504, 0.5655799138405102],
            [2.4496227330397944, 0.561759171258989],
            [2.4570520021491546, 0.5577678431645658],
            [2.4613184541739908, 0.5573140282029639],
            [2.4673662384471804, 0.5585767387392643],
            [2.4789726174249846, 0.5628403131589014],
            [2.4827529029484707, 0.5649435096080572],
            [2.490665969012373, 0.5726242619850084],
            [2.5089686799872877, 0.5825417756782544],
            [2.5126150460185728, 0.5897791438690887],
            [2.511884373274458, 0.5982477882263358],
            [2.5089121683213964, 0.6040438848279157],
            [2.5048147504656435, 0.6095792922957763],
            [2.4999134683215702, 0.6197469440176874],
            [2.499378682156507, 0.6299064615791012],
            [2.5046576964191583, 0.6400044311482335],
            [2.508112147924929, 0.6427007214582589],
            [2.513820236792451, 0.6438801515344205],
            [2.5247650799556673, 0.6443193795929698],
            [2.537305811360956, 0.6431302978829612],
            [2.5455270759450794, 0.6440616826404413],
            [2.549830269851963, 0.645846085556969],
            [2.556068332470041, 0.6510754773446683],
            [2.5581891947723796, 0.6547710078171626],
            [2.5570438770032515, 0.6597551326496337],
            [2.559922665392405, 0.6657881374646504],
            [2.565767267862612, 0.6728520702569404],
            [2.5719812320085853, 0.6738719947316163],
            [2.5777860384198057, 0.6717428900255593],
            [2.585851017890066, 0.6633764068335533],
            [2.5921905451113294, 0.6670445746032836],
            [2.5968303105286146, 0.6740284049806587],
            [2.6029894025796487, 0.6886332678102964],
            [2.613859536593572, 0.702400097773056],
            [2.615609165762065, 0.7071759915304863],
            [2.6158959833862356, 0.7145716438816443],
            [2.6147864901794313, 0.718673203424118],
            [2.6092568965318916, 0.7272370737823892],
            [2.6068418570015592, 0.73277761028162],
            [2.606149231563711, 0.7386102674712824],
            [2.6090303201578267, 0.7437938935698435],
            [2.614514751860837, 0.7476418168164172],
            [2.621199040618785, 0.7491718111943608],
            [2.6259509205748506, 0.7485262857871026],
            [2.6338917021206103, 0.7426845510732034],
            [2.6377773171981755, 0.7366859315754092],
            [2.6402173383087626, 0.7306946964599783],
            [2.6438649106932384, 0.7249578208901979],
            [2.648544024921694, 0.7198862633050188],
            [2.6535829525123633, 0.7166506501875919],
            [2.6595644063386, 0.7155029569137742],
            [2.664658002782001, 0.7160073092319794],
            [2.6768447283710195, 0.7218152682907231],
            [2.680327623880249, 0.7225232073461942],
            [2.6895053677787297, 0.7206867220570131],
            [2.6932745093349157, 0.7181279481124776],
            [2.699213554451826, 0.7110793331923497],
            [2.701861518672386, 0.7048468200320028],
            [2.7025635342498484, 0.7000107564538215],
            [2.7016627602951098, 0.6871440073440915],
            [2.702678648383068, 0.681649978445667],
            [2.7059839491443505, 0.6746963898412517],
            [2.709913597572464, 0.6695396463411833],
            [2.7150107936854475, 0.664922126412399],
            [2.728108862316099, 0.657349784811611],
            [2.744322008452138, 0.653259530565803],
            [2.7610578655348537, 0.6536644691204238],
            [2.7802278866913026, 0.6567816422920686],
            [2.786626570051456, 0.6566825191477242],
            [2.7933464056475703, 0.6542167407096998],
            [2.7977685226863205, 0.648116664478358],
            [2.7988021081529477, 0.6401819999764186],
            [2.7955270127807057, 0.6295791887880452],
            [2.794929066944294, 0.6244878398140328],
            [2.797308453467191, 0.618627239858621],
            [2.8042189208927173, 0.6117091936943955],
            [2.8125698916194755, 0.6083701889903583],
            [2.8226692004670664, 0.6055189642271355],
            [2.8281116442709937, 0.6002048735214236],
            [2.8292422696347805, 0.5956348214469227],
            [2.828189491138175, 0.5872820129172805],
            [2.826223294743616, 0.5822337134775367],
            [2.826808818844061, 0.5735734135505752],
            [2.8303391783195035, 0.5682811753033952],
            [2.8374124431994345, 0.5645487275718033],
            [2.8450566170030975, 0.5643515925337436],
            [2.8541923014851274, 0.5679817772490136],
            [2.8627792658325957, 0.5761282166189508],
            [2.8683380700121046, 0.5792638040054603],
            [2.8762444687513042, 0.5791543937708399],
            [2.8809065308492277, 0.5743342829584059],
            [2.8809354676505814, 0.5698969965878653],
            [2.8795436844235507, 0.5614379614837905],
            [2.8769355963955774, 0.5524548281302715],
            [2.8727144337448784, 0.5432952270244745],
            [2.866919921958293, 0.5348324689369642],
            [2.8623265621190637, 0.5296762854671831],
            [2.8545465976450144, 0.5253007078660523],
            [2.846152854019509, 0.517933258021952],
            [2.840287048948336, 0.5078925894827369],
            [2.840105444629263, 0.4929676510325815],
            [2.839115552759023, 0.48598091706984214],
            [2.8359133783373944, 0.4794858723000286],
            [2.8318824864403385, 0.47441861582274786],
            [2.8279897540243453, 0.4719035327830623],
            [2.816853044794915, 0.46842750197044236],
            [2.813312144639399, 0.46634981379445545],
            [2.8117574140054833, 0.46210385119581115],
            [2.810859537722769, 0.45495075882094993],
            [2.811171271290905, 0.4472880524813013],
            [2.8131657761992943, 0.44375825143260317],
            [2.8200114674337358, 0.43973436207637],
            [2.825062953507912, 0.4384894431049961],
            [2.8333750824386494, 0.43875365714791736],
            [2.8394058891951723, 0.4365424953675383],
            [2.84137894810747, 0.42963584622043266],
            [2.8410138203578774, 0.4251389982861151],
            [2.838547109639699, 0.42056671219592184],
            [2.833369994855069, 0.4141610286617366],
            [2.823758944733417, 0.40874671946088637],
            [2.8207474612517167, 0.4046241359249502],
            [2.772857476962442, 0.3508140462407013],
            [2.736253444997274, 0.3090682245511403],
            [2.7359927027007083, 0.30493777515229287],
            [2.7359436315609407, 0.2642548409185548],
            [2.7209736850424266, 0.26560789282289815],
            [2.6930842482369863, 0.2662299300321987],
            [2.6782779352604256, 0.2655945877423497],
            [2.6482842906066213, 0.26610639673405084],
            [2.6482253541592313, 0.26549857132630045],
            [2.5677487072672682, 0.2665823327426257],
            [2.5637506282767397, 0.2660574214878216],
            [2.534993565549098, 0.26625209834715036],
            [2.3921215076406375, 0.2691287548395498]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.20185771877321, "lat": 39.1368176098564 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29195"],
        "coty_name": ["Saline"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Saline County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "00758550"
      },
      "bbox": [
        2.3921215076406375, 0.2642548409185548, 2.8809354676505814,
        0.7491718111943608
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.777398588790313, 9.384893710428347],
            [-5.777567612457486, 9.38221210585136],
            [-5.785934591952827, 9.300169178014578],
            [-5.712064996510685, 9.293184592780856],
            [-5.612615207225674, 9.283446733513879],
            [-5.621078858642073, 9.19856350495638],
            [-5.548946814298642, 9.19173999685668],
            [-5.463101914843471, 9.183866680486794],
            [-5.458061196775649, 9.183592847780126],
            [-5.360962524664799, 9.174779821117255],
            [-5.369020826822217, 9.089865577286902],
            [-5.314186616540112, 9.085084853762842],
            [-5.31537208687466, 9.071675273001743],
            [-5.329884078745005, 8.914280376767028],
            [-5.266822889834541, 8.908435705209671],
            [-5.269205630183598, 8.899323724961183],
            [-5.279517528432687, 8.885562958874505],
            [-5.287974319250237, 8.880795156856836],
            [-5.290890899771592, 8.874255789595333],
            [-5.276618892058683, 8.873315807010039],
            [-5.27745656990973, 8.866252741651229],
            [-5.270043553585192, 8.865478494162936],
            [-5.270601385802097, 8.858381631794039],
            [-5.263286069563524, 8.857630595024698],
            [-5.263924279478287, 8.850567078871242],
            [-5.2567020874393995, 8.849936460694247],
            [-5.25736272980786, 8.84283512023835],
            [-5.250126531722017, 8.842160664595044],
            [-5.251324465197656, 8.828001442183822],
            [-5.242044986703779, 8.827225353612777],
            [-5.243330104648124, 8.813078364331133],
            [-5.236095143746253, 8.812461054088104],
            [-5.236737191180341, 8.805384064398577],
            [-5.229506835941073, 8.804752162568365],
            [-5.2301588052787436, 8.797677678151928],
            [-5.222927315750001, 8.797049427721488],
            [-5.2255304533655895, 8.768767578446614],
            [-5.21830273829423, 8.768145337273138],
            [-5.220279994368133, 8.746957419617404],
            [-5.213021344880262, 8.746362860664515],
            [-5.214320651379668, 8.732302775189618],
            [-5.211215321829685, 8.732035425398829],
            [-5.215151349357872, 8.689261572075733],
            [-5.2079200145714335, 8.6885875004884],
            [-5.21636535880709, 8.595730331157139],
            [-5.230843034401821, 8.596908118105521],
            [-5.233968064362575, 8.561451200623347],
            [-5.241225512776035, 8.562050376035202],
            [-5.2425398266717735, 8.54773725560301],
            [-5.24979390139181, 8.548284597541201],
            [-5.251072823069859, 8.53407784027296],
            [-5.258315414591825, 8.534695170730082],
            [-5.259602783204251, 8.520473110434791],
            [-5.266843426884227, 8.521084181044376],
            [-5.2681270416862445, 8.506883312190075],
            [-5.275341598740294, 8.5075117095025],
            [-5.275986018226494, 8.500394743474311],
            [-5.283201109834719, 8.501033883120172],
            [-5.28384674737046, 8.49392760130591],
            [-5.291062692584135, 8.494550821825403],
            [-5.292355002590306, 8.48034437006267],
            [-5.299566128104796, 8.480977876807023],
            [-5.300854376259662, 8.466672969834812],
            [-5.315279202176481, 8.468031636157622],
            [-5.316551827332723, 8.453821071569823],
            [-5.331026301402439, 8.455145831598053],
            [-5.331664281507539, 8.448039767322635],
            [-5.338861802413879, 8.448692934005138],
            [-5.339507735597941, 8.441599145575422],
            [-5.353920292987357, 8.442935151136497],
            [-5.354560605037228, 8.435829708331987],
            [-5.3617726914642, 8.436499433126215],
            [-5.362417235365246, 8.429394072835878],
            [-5.435710732353531, 8.435973529554875],
            [-5.504230674895679, 8.442420876949125],
            [-5.572752048595172, 8.448853794395937],
            [-5.641274828374861, 8.455272280132839],
            [-5.70979898915237, 8.461676332424597],
            [-5.72536472798868, 8.46322240362347],
            [-5.722625125850708, 8.491779004487551],
            [-5.7371315798660465, 8.493248406144772],
            [-5.735783388246748, 8.507511002656384],
            [-5.7499534758279305, 8.508896344508093],
            [-5.748594788169785, 8.522514694925635],
            [-5.8356465632183125, 8.530832867885193],
            [-5.829881400213079, 8.587627374055538],
            [-5.917209290405548, 8.596091300650926],
            [-5.9059090284935785, 8.709745735755542],
            [-5.897360639641051, 8.796094819124747],
            [-5.9527378797339745, 8.801590930539911],
            [-5.948444492179471, 8.843984357953733],
            [-5.936755729983763, 8.960913918264787],
            [-5.930160106874956, 9.026883625378028],
            [-5.929938491323264, 9.027985458927814],
            [-5.918743455781814, 9.141615321787267],
            [-5.889609694373241, 9.138789435773788],
            [-5.876810649421788, 9.266018881527842],
            [-5.866701585928241, 9.36480988657711],
            [-5.86396563636064, 9.393195021658789],
            [-5.777398588790313, 9.384893710428347]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.8994836967296,
          "lat": 47.266379152486714
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30021"],
        "coty_name": ["Dawson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dawson County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "01715632"
      },
      "bbox": [
        -5.9527378797339745, 8.429394072835878, -5.2079200145714335,
        9.393195021658789
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.435710732353531, 8.435973529554875],
            [-5.362417235365246, 8.429394072835878],
            [-5.3617726914642, 8.436499433126215],
            [-5.354560605037228, 8.435829708331987],
            [-5.353920292987357, 8.442935151136497],
            [-5.339507735597941, 8.441599145575422],
            [-5.338861802413879, 8.448692934005138],
            [-5.331664281507539, 8.448039767322635],
            [-5.331026301402439, 8.455145831598053],
            [-5.316551827332723, 8.453821071569823],
            [-5.315279202176481, 8.468031636157622],
            [-5.300854376259662, 8.466672969834812],
            [-5.299566128104796, 8.480977876807023],
            [-5.292355002590306, 8.48034437006267],
            [-5.291062692584135, 8.494550821825403],
            [-5.28384674737046, 8.49392760130591],
            [-5.283201109834719, 8.501033883120172],
            [-5.275986018226494, 8.500394743474311],
            [-5.275341598740294, 8.5075117095025],
            [-5.2681270416862445, 8.506883312190075],
            [-5.266843426884227, 8.521084181044376],
            [-5.259602783204251, 8.520473110434791],
            [-5.258315414591825, 8.534695170730082],
            [-5.251072823069859, 8.53407784027296],
            [-5.24979390139181, 8.548284597541201],
            [-5.2425398266717735, 8.54773725560301],
            [-5.241225512776035, 8.562050376035202],
            [-5.233968064362575, 8.561451200623347],
            [-5.230843034401821, 8.596908118105521],
            [-5.21636535880709, 8.595730331157139],
            [-5.2079200145714335, 8.6885875004884],
            [-5.215151349357872, 8.689261572075733],
            [-5.211215321829685, 8.732035425398829],
            [-5.214320651379668, 8.732302775189618],
            [-5.213021344880262, 8.746362860664515],
            [-5.220279994368133, 8.746957419617404],
            [-5.21830273829423, 8.768145337273138],
            [-5.2255304533655895, 8.768767578446614],
            [-5.222927315750001, 8.797049427721488],
            [-5.2301588052787436, 8.797677678151928],
            [-5.229506835941073, 8.804752162568365],
            [-5.236737191180341, 8.805384064398577],
            [-5.236095143746253, 8.812461054088104],
            [-5.243330104648124, 8.813078364331133],
            [-5.242044986703779, 8.827225353612777],
            [-5.251324465197656, 8.828001442183822],
            [-5.250126531722017, 8.842160664595044],
            [-5.25736272980786, 8.84283512023835],
            [-5.2567020874393995, 8.849936460694247],
            [-5.263924279478287, 8.850567078871242],
            [-5.263286069563524, 8.857630595024698],
            [-5.270601385802097, 8.858381631794039],
            [-5.270043553585192, 8.865478494162936],
            [-5.27745656990973, 8.866252741651229],
            [-5.276618892058683, 8.873315807010039],
            [-5.290890899771592, 8.874255789595333],
            [-5.287974319250237, 8.880795156856836],
            [-5.279517528432687, 8.885562958874505],
            [-5.269205630183598, 8.899323724961183],
            [-5.266822889834541, 8.908435705209671],
            [-5.243029668120384, 8.906316583609895],
            [-5.243113956657834, 8.905398100910274],
            [-5.157068531502793, 8.898221947489219],
            [-5.071025026957593, 8.891022309795074],
            [-5.067088749474142, 8.933567419782444],
            [-5.008462402212574, 8.928294857945263],
            [-5.0101782140896605, 8.906706328820587],
            [-5.014251260967113, 8.862812064769981],
            [-5.018594992909768, 8.81074705524677],
            [-5.024018989322198, 8.750732442092186],
            [-5.030943725876586, 8.664236913858169],
            [-5.035439529645382, 8.616379972978487],
            [-5.0384064965837325, 8.579388166446224],
            [-5.047142461313571, 8.481691014186739],
            [-5.0566700652987775, 8.373313634066358],
            [-5.065525325174718, 8.265781869498058],
            [-5.0721828180787645, 8.187332179407631],
            [-5.118400062618565, 8.191342968950234],
            [-5.201530236084001, 8.198395955682054],
            [-5.284662172806513, 8.205428071592351],
            [-5.28203556504951, 8.233884613159493],
            [-5.3254506284278555, 8.237739250007616],
            [-5.324174316811864, 8.251940106461035],
            [-5.388938796230838, 8.257718161358131],
            [-5.453704428991274, 8.263483497732],
            [-5.4407418843392765, 8.407761911662133],
            [-5.43806654741432, 8.407511736990145],
            [-5.435710732353531, 8.435973529554875]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.24897761546272,
          "lat": 46.96525127400961
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30109"],
        "coty_name": ["Wibaux"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wibaux County"],
        "coty_fp_code": "109",
        "coty_gnis_code": "01696629"
      },
      "bbox": [
        -5.453704428991274, 8.187332179407631, -5.008462402212574,
        8.933567419782444
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.6803036443266643, 3.482600496838964],
            [-2.6066800895828917, 3.479036455527443],
            [-2.501183277292419, 3.47423901166824],
            [-2.4635577514616913, 3.4723642062766644],
            [-2.299495775417107, 3.4658886993566864],
            [-2.2907229365058477, 3.466181301501102],
            [-2.252751762256486, 3.4646587267939797],
            [-2.2557473488456137, 3.3792195179229334],
            [-2.2603466847235705, 3.2561238980891303],
            [-2.2625144218625013, 3.20526357319225],
            [-2.266165495631819, 3.1172361202026737],
            [-2.313183378019239, 3.1192611779394785],
            [-2.357360335209524, 3.120574593836672],
            [-2.427591610397321, 3.123064953985711],
            [-2.4704314318712606, 3.1247076042288358],
            [-2.498269576874521, 3.1254055766840607],
            [-2.5012088837975095, 3.1251939546513587],
            [-2.575855707949865, 3.128590240179898],
            [-2.6797261273441766, 3.134221004195477],
            [-2.683829148070835, 3.1341494926882016],
            [-2.6943708885901914, 3.134660688186018],
            [-2.690602813592067, 3.2356680327895444],
            [-2.6886922715870076, 3.2702536395441117],
            [-2.6874832352287457, 3.3017142741342416],
            [-2.6812771276517, 3.468432770955828],
            [-2.6803036443266643, 3.482600496838964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.97681504175866, "lat": 41.91277338979125 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31009"],
        "coty_name": ["Blaine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Blaine County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00835827"
      },
      "bbox": [
        -2.6943708885901914, 3.1172361202026737, -2.252751762256486,
        3.482600496838964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.9891864199355975, 3.9781102525246954],
            [-4.8933540524309835, 3.9708776600769013],
            [-4.883585124353938, 3.97039688221934],
            [-4.847475529810951, 3.9675958112480414],
            [-4.74818475022582, 3.9600727711369075],
            [-4.747567452314593, 3.959901730983039],
            [-4.664663119504132, 3.9539909596932006],
            [-4.598936898254499, 3.9499519655265627],
            [-4.498427910296543, 3.9440882957668566],
            [-4.480921810447105, 3.942855840317687],
            [-4.4848320535617665, 3.8964941748044977],
            [-4.485309267215926, 3.895330984040127],
            [-4.488376136249233, 3.8600025055932967],
            [-4.485944659765727, 3.8546525297770926],
            [-4.488351944049156, 3.817799174660469],
            [-4.489246338145527, 3.8076989666816696],
            [-4.492317317046294, 3.7523850420088034],
            [-4.492924224189729, 3.7136445142055727],
            [-4.49388848921863, 3.679726575206887],
            [-4.5004839346331975, 3.59422536959041],
            [-4.471139885268036, 3.5925122258008866],
            [-4.473871031641807, 3.5509666487803435],
            [-4.473211133293376, 3.5260509974855734],
            [-4.474030114035166, 3.504140418975417],
            [-4.51284735810849, 3.5058380364146324],
            [-4.532821919148998, 3.505508762804232],
            [-4.570070862367972, 3.506962991203628],
            [-4.595387580605668, 3.5085854993538033],
            [-4.613462366760465, 3.5103200413275335],
            [-4.66151779414465, 3.5145107421249118],
            [-4.685840904142513, 3.5168544345952792],
            [-4.793375647123074, 3.5257605449391782],
            [-4.873767160202537, 3.5314377919879028],
            [-4.892686389739962, 3.5320056752112747],
            [-4.963862352861026, 3.5384438483456964],
            [-4.99190463260439, 3.541234242580234],
            [-4.99028595515605, 3.5585688883236495],
            [-4.98514906642063, 3.628290524922953],
            [-5.016361902848401, 3.6310276930024012],
            [-5.009647639299276, 3.718476179826643],
            [-5.006030851589688, 3.7613832101139746],
            [-5.000491759470575, 3.8340826205325023],
            [-4.9891864199355975, 3.9781102525246954]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.08567250815605,
          "lat": 42.21975703735334
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31013"],
        "coty_name": ["Box Butte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Box Butte County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00835991"
      },
      "bbox": [
        -5.016361902848401, 3.504140418975417, -4.471139885268036,
        3.9781102525246954
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.126079933094492, 2.1070073105513116],
            [-3.0006137151787953, 2.1007853591517933],
            [-2.9554771134198172, 2.0987913991899547],
            [-2.830197431008406, 2.0928229757725085],
            [-2.709727337774703, 2.0874104245115954],
            [-2.613767153341667, 2.083106069288424],
            [-2.5283290857605154, 2.0793275080110263],
            [-2.5311591614490423, 2.0057160337428064],
            [-2.532053467415793, 1.9913073950203302],
            [-2.5356343970461253, 1.9035040167128063],
            [-2.538970985942594, 1.8157007247061099],
            [-2.6102319006631913, 1.818937418643916],
            [-2.624810312489246, 1.8197165345871071],
            [-2.628158125134156, 1.7392805054341542],
            [-2.628384615408858, 1.7316453072700901],
            [-2.7061745926834173, 1.73381007319564],
            [-2.7390122443706755, 1.7350229330084177],
            [-2.7598819975239692, 1.73540732273512],
            [-2.790898023890177, 1.7374656143625022],
            [-2.805715609119071, 1.7390134633592071],
            [-2.832842764700402, 1.7409643560439763],
            [-2.9332402405378057, 1.7444350586326842],
            [-2.9345287719827557, 1.7442134005575156],
            [-2.9738593625390624, 1.746161792878661],
            [-3.002713493850653, 1.7471695050483511],
            [-3.0467053123407664, 1.7493630918077345],
            [-3.1079253076551994, 1.7521183061054335],
            [-3.129218243740198, 1.753222975919068],
            [-3.143510106956352, 1.7538988024184756],
            [-3.1433761000654505, 1.7661921530335822],
            [-3.14387090626621, 1.779703300582264],
            [-3.141577380425495, 1.8425613591051058],
            [-3.139361296925067, 1.894545579351194],
            [-3.138681768612486, 1.9314131668655459],
            [-3.138013343028031, 1.94765588151173],
            [-3.135619736297165, 1.9752075790463235],
            [-3.133578131014767, 2.019423010119441],
            [-3.128555826126176, 2.0891406134101027],
            [-3.126079933094492, 2.1070073105513116]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.39413682335929,
          "lat": 40.530073187231345
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31063"],
        "coty_name": ["Frontier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Frontier County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00835853"
      },
      "bbox": [
        -3.14387090626621, 1.7316453072700901, -2.5283290857605154,
        2.1070073105513116
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.532938316826724, 3.532125684851934],
            [-3.495361893819666, 3.529598472317113],
            [-3.4909020509392064, 3.5296043016306724],
            [-3.4024892802616233, 3.5240982567149652],
            [-3.3140774533291606, 3.5185779428898054],
            [-3.2256665827700317, 3.513043362113855],
            [-3.1372566811825373, 3.507494516594826],
            [-3.1276117807313435, 3.506183354859327],
            [-3.106050526638178, 3.5050223779400165],
            [-3.110507552648489, 3.4170791549628126],
            [-3.111261717318341, 3.3895606088407293],
            [-3.1164634388970605, 3.2664296310492764],
            [-3.12118857952651, 3.1556481841748147],
            [-3.1456019335215033, 3.156390830856714],
            [-3.1959989397623207, 3.159087149026172],
            [-3.330374903999908, 3.1686568413917695],
            [-3.366406710932008, 3.1706080972269546],
            [-3.513787896706185, 3.1799415536435442],
            [-3.5381424334080482, 3.1809331653115995],
            [-3.552534829325025, 3.1816108948573523],
            [-3.5378780983698497, 3.439576121207522],
            [-3.5379689580690425, 3.4458626780373014],
            [-3.532938316826724, 3.532125684851934]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.13528154766927,
          "lat": 41.91604847946313
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31091"],
        "coty_name": ["Hooker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hooker County"],
        "coty_fp_code": "091",
        "coty_gnis_code": "00835867"
      },
      "bbox": [
        -3.552534829325025, 3.1556481841748147, -3.106050526638178,
        3.532125684851934
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.2700763915604725, -2.2074501475026973],
            [-6.001145643659988, -2.2313670212412196],
            [-5.929915831063925, -2.23735387329372],
            [-5.933651480904607, -2.281157530457152],
            [-5.762449439166779, -2.295973568053951],
            [-5.770170532505747, -2.3846232877078135],
            [-5.7415451540732265, -2.387150785278818],
            [-5.427309989879654, -2.4116849960780313],
            [-5.434205588312036, -2.4995322239413325],
            [-5.442039833436955, -2.49893117098954],
            [-5.460894799834797, -2.738633991160603],
            [-5.4625150745328055, -2.759376129583604],
            [-5.469380556738185, -2.846790520345418],
            [-5.472753186780379, -2.846526511394471],
            [-5.479817365238697, -2.9362151606012468],
            [-5.485234240579611, -3.0050514775302757],
            [-5.493037469958135, -3.1033971886137066],
            [-5.501028405600336, -3.1100248517398628],
            [-5.607627890987336, -3.101747347761579],
            [-5.700881732774678, -3.094176637147985],
            [-5.698213833344073, -3.061365059959655],
            [-5.765488133243671, -3.0558418088038275],
            [-5.767884038872271, -3.055280077313446],
            [-5.838321860354369, -2.8927692266424394],
            [-5.90874049412372, -2.730218423391284],
            [-5.939719526158592, -2.6578610447032074],
            [-5.977321283464305, -2.6751807960674543],
            [-6.01300692837393, -2.67226689148644],
            [-6.04596628131355, -2.6690976167721625],
            [-6.256571110391921, -2.65328428653132],
            [-6.24985903784293, -2.6499505655323987],
            [-6.248997560653654, -2.6466009405825903],
            [-6.251795518279447, -2.643396341654135],
            [-6.25025064856003, -2.63676838156296],
            [-6.255128072457854, -2.6278395218696553],
            [-6.254050094240947, -2.6246344309368577],
            [-6.250783764978736, -2.6243445984783116],
            [-6.248808365484277, -2.6202379075457047],
            [-6.254261962058022, -2.6148021542104747],
            [-6.2569895357380885, -2.613482657520324],
            [-6.259046026518997, -2.6082348519020218],
            [-6.251781638703203, -2.6053661059672146],
            [-6.249555722094686, -2.6032043335942596],
            [-6.257642457581881, -2.5989061957003474],
            [-6.259076514249141, -2.595234324914004],
            [-6.248295706366421, -2.5935157468487384],
            [-6.246859208861338, -2.5904908358632386],
            [-6.252204336261951, -2.5840098000251395],
            [-6.254839321540266, -2.5844189325264635],
            [-6.254874876995837, -2.5895712976659753],
            [-6.2572804636535935, -2.590803178082385],
            [-6.260491543026953, -2.58794185706148],
            [-6.255339037274181, -2.5816907883552043],
            [-6.256486560757683, -2.5786665817015155],
            [-6.260290160712463, -2.577659645723372],
            [-6.265779581506366, -2.5725117366169457],
            [-6.265743177167996, -2.5709633927149276],
            [-6.258672394221199, -2.569447675315211],
            [-6.256983956994662, -2.566565544270726],
            [-6.256226635940545, -2.557633728010123],
            [-6.255073085634807, -2.554016049388934],
            [-6.249576013473264, -2.562148763855435],
            [-6.245282716496143, -2.5590457648438445],
            [-6.2502672886945065, -2.553875498156589],
            [-6.249341089799241, -2.5489057242761692],
            [-6.243252944222159, -2.5492250511880084],
            [-6.238498367102992, -2.5464548606913455],
            [-6.23924954709396, -2.543096257411206],
            [-6.243231730971529, -2.5400530272823536],
            [-6.2430817725645715, -2.5341320991170355],
            [-6.23515543030805, -2.535978296873859],
            [-6.229866488710667, -2.5329287635289393],
            [-6.232292685277733, -2.530161618358259],
            [-6.232346582430919, -2.525447399960242],
            [-6.228349054349241, -2.5257698797549186],
            [-6.223701261170951, -2.5220309560920597],
            [-6.225620042861836, -2.5185272106164565],
            [-6.230443813330269, -2.5164337269191828],
            [-6.230318078194071, -2.5109619480467806],
            [-6.222631064097425, -2.5090056363540643],
            [-6.218265585866185, -2.5104905885571913],
            [-6.2213650654514785, -2.5032201220444037],
            [-6.228879660456975, -2.504744324035562],
            [-6.230940543790152, -2.5033897941408676],
            [-6.230757484786469, -2.4962751295712184],
            [-6.228454097546522, -2.4928047101289614],
            [-6.221684746308606, -2.494050113059515],
            [-6.218475110059, -2.4930852955121625],
            [-6.217381476324064, -2.4895547950337273],
            [-6.225199941503621, -2.483535039003276],
            [-6.226643693996807, -2.4790696963312344],
            [-6.220261371531272, -2.478177690700454],
            [-6.218872212146236, -2.484445854953293],
            [-6.21675440482042, -2.4846279569276972],
            [-6.213564513540215, -2.4785942286006106],
            [-6.206292267033717, -2.474627309273918],
            [-6.207909982556403, -2.470199707896803],
            [-6.211346371417644, -2.4696003794869354],
            [-6.217406914459086, -2.4587979139387754],
            [-6.227023229871758, -2.4500684821681222],
            [-6.225610929777564, -2.4455365078312736],
            [-6.220948939388589, -2.4456411462833056],
            [-6.219034795213208, -2.442542018998676],
            [-6.214584766028747, -2.4418340421638765],
            [-6.2125953426610625, -2.433754040312078],
            [-6.219223968779806, -2.4282809073468274],
            [-6.2199131545362, -2.4230192177718597],
            [-6.225867956474138, -2.4227915532381568],
            [-6.23193690319573, -2.4184900208129374],
            [-6.227218104692255, -2.40828084476009],
            [-6.227904465347378, -2.4014763591390493],
            [-6.226698221413028, -2.397042423374243],
            [-6.227539080860918, -2.3902687568518988],
            [-6.229541952181892, -2.3874581024086226],
            [-6.235319133943, -2.386297562590614],
            [-6.240292370018769, -2.381468954842929],
            [-6.2393969144552255, -2.3759831017892368],
            [-6.236849679155873, -2.3713486781037663],
            [-6.231161497933838, -2.3655233875663506],
            [-6.236792311270274, -2.363572657624407],
            [-6.239047849105071, -2.3542903441297294],
            [-6.245741847691431, -2.3476364388369912],
            [-6.2413498349495375, -2.3422904390723716],
            [-6.253541840612329, -2.3374972915522196],
            [-6.249972577738, -2.3301562380945433],
            [-6.252850868936506, -2.320375305671663],
            [-6.252745732042287, -2.311789848033848],
            [-6.255224694656072, -2.309021857680251],
            [-6.260312600903516, -2.3070268341868543],
            [-6.261409727811526, -2.3041826697839074],
            [-6.256479367178908, -2.2962668010684744],
            [-6.263850271376967, -2.289401382538182],
            [-6.26389114651586, -2.2837074386685132],
            [-6.258208519390104, -2.282749503789992],
            [-6.257139274081612, -2.2880566939092306],
            [-6.253630180015621, -2.2856795327729316],
            [-6.253868389262346, -2.2810697521877996],
            [-6.249920518919621, -2.2755074927812937],
            [-6.2504705435601275, -2.2731168283128143],
            [-6.261708380949746, -2.2590799854714807],
            [-6.25758239304976, -2.254375247170735],
            [-6.256579867161066, -2.2508716471911963],
            [-6.261583634176695, -2.246360214321597],
            [-6.263676481027135, -2.243001022869279],
            [-6.2665791310551064, -2.2428991498369877],
            [-6.2665990040244335, -2.248861414585188],
            [-6.271439583684211, -2.2506396811257035],
            [-6.273889069304193, -2.2487724207380646],
            [-6.2720319673758, -2.2421897418501735],
            [-6.269867211743513, -2.239326216557284],
            [-6.2706521289915695, -2.2358349222467426],
            [-6.274758226057688, -2.232412756827181],
            [-6.27322611415908, -2.2300003330392917],
            [-6.265933592765881, -2.2311781693622876],
            [-6.269943112014345, -2.224959923016171],
            [-6.266066623863586, -2.2128048852107662],
            [-6.2700763915604725, -2.2074501475026973]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.82026233261186,
          "lat": 35.85791467905081
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35021"],
        "coty_name": ["Harding"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harding County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00933055"
      },
      "bbox": [
        -6.274758226057688, -3.1100248517398628, -5.427309989879654,
        -2.2074501475026973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.38178138176281, 4.729382328997134],
            [16.38798054868988, 4.730930096449798],
            [16.392201640568455, 4.733520350085662],
            [16.39080783924342, 4.735995064710434],
            [16.392840744221374, 4.739815931252179],
            [16.398175610037196, 4.739201358936556],
            [16.400078034038746, 4.737112330710224],
            [16.407012419838747, 4.743092544041598],
            [16.4064452523408, 4.7459767061122875],
            [16.41294627847463, 4.748984423655189],
            [16.41516747381061, 4.751997220064315],
            [16.415646468262047, 4.756398621857767],
            [16.422245218393293, 4.760564049728418],
            [16.42132226500207, 4.763546153350098],
            [16.427177141001255, 4.769466751405366],
            [16.42925850222687, 4.7684983710611535],
            [16.436296110347236, 4.777287720640404],
            [16.439854256975345, 4.778548581315251],
            [16.444356729104662, 4.782663708942067],
            [16.44668131979016, 4.787450315266058],
            [16.45750875594286, 4.786442929195968],
            [16.46196057721761, 4.762783544081684],
            [16.511622851000034, 4.759292865253918],
            [16.512407872195563, 4.762914766672991],
            [16.55768483606277, 4.7615248749378],
            [16.544200242051666, 4.792566835396313],
            [16.572044634570236, 4.790370521990504],
            [16.57551933739641, 4.789319204253388],
            [16.580364047418712, 4.783386985530579],
            [16.59441838193929, 4.794307354611405],
            [16.609330658638235, 4.777235818303124],
            [16.610462655542364, 4.771991507447913],
            [16.62952297614903, 4.7787860903393975],
            [16.648565763739903, 4.78617143743028],
            [16.6604914889649, 4.790323110150115],
            [16.681031300010808, 4.798109522578961],
            [16.681978649862803, 4.79141343969158],
            [16.680873895558634, 4.77894939806643],
            [16.678454035757614, 4.772052987545695],
            [16.67523055431742, 4.768163168416919],
            [16.671313619407677, 4.759976069360751],
            [16.66670318194419, 4.744431477558071],
            [16.666305685905765, 4.732577314384762],
            [16.665370460459407, 4.7249572088254945],
            [16.666108299186423, 4.718778452473814],
            [16.669057442642444, 4.7053252467795685],
            [16.67226956555431, 4.701445623825295],
            [16.672965798953715, 4.68623341402198],
            [16.675608490156336, 4.6782890037071825],
            [16.67806949790758, 4.659729883292374],
            [16.680758857891984, 4.655866204172863],
            [16.69055540793444, 4.65063446878673],
            [16.69563075264267, 4.6456475208262535],
            [16.7052388227305, 4.633131117068425],
            [16.710375775220047, 4.628479970705424],
            [16.71558685027383, 4.620862279959831],
            [16.717634282422317, 4.6144849605313185],
            [16.72072020746096, 4.611849257935849],
            [16.72898795068879, 4.6108414946018605],
            [16.73078308663986, 4.606862562992798],
            [16.729780341802304, 4.599915397265199],
            [16.730150975656176, 4.593820129172717],
            [16.728952812270293, 4.586906358682156],
            [16.729671677758752, 4.573277280317349],
            [16.73120608354075, 4.560736919429333],
            [16.72960337474391, 4.555128601069882],
            [16.72242383984262, 4.5348027958607995],
            [16.69820790901486, 4.497101236751827],
            [16.655788449539276, 4.432153271962266],
            [16.607438543380916, 4.356756307720159],
            [16.580224655095414, 4.313391977008803],
            [16.572917569497598, 4.315532594425661],
            [16.524257425474094, 4.330795696351163],
            [16.488600856266185, 4.342622165761066],
            [16.469669051446356, 4.350049934406317],
            [16.438592101713446, 4.362257101353275],
            [16.393944835200873, 4.378751175940339],
            [16.359082224677692, 4.390462580729339],
            [16.269433634895496, 4.421945685687195],
            [16.241202665258353, 4.431078640229874],
            [16.196942500218572, 4.446304334048551],
            [16.199752837566507, 4.451205122328824],
            [16.197471907840598, 4.456629453910387],
            [16.182299431351893, 4.465113235600495],
            [16.17626128692106, 4.474988610588784],
            [16.169741437472204, 4.478533232805168],
            [16.162635124201636, 4.477920008202417],
            [16.157872397956343, 4.479660987351045],
            [16.15284262532469, 4.485447042510429],
            [16.151346492365764, 4.4915924060571015],
            [16.15263098631297, 4.493996143799353],
            [16.153433696336744, 4.503695376560046],
            [16.15055407052377, 4.509769801227424],
            [16.147043579550395, 4.510964356238263],
            [16.14068220774348, 4.506249545858463],
            [16.138428172933544, 4.502657174093497],
            [16.136511909626353, 4.505330143464778],
            [16.13881645782618, 4.510456130249206],
            [16.135413140338112, 4.511199454284586],
            [16.13103416790065, 4.519110402740107],
            [16.128590522800298, 4.520374268162884],
            [16.12732136051964, 4.525416545355948],
            [16.129038958100434, 4.530715062733579],
            [16.126690245747604, 4.536778827563998],
            [16.132588226529453, 4.541227867449766],
            [16.130070936529123, 4.545163790502814],
            [16.12949669991809, 4.549727559162567],
            [16.126550826521278, 4.555453702979726],
            [16.12214372781388, 4.557553029286448],
            [16.119021712809946, 4.563242356774756],
            [16.119419171764537, 4.566139694929935],
            [16.123373954884336, 4.5676693256539815],
            [16.12474253593225, 4.570388104867891],
            [16.21929015259682, 4.596704173420611],
            [16.261939765057267, 4.60869125648995],
            [16.264367549438415, 4.60991652715146],
            [16.31685119335596, 4.625042824551186],
            [16.322962208022727, 4.626133734577036],
            [16.32350560719405, 4.629295285051084],
            [16.32119006859097, 4.632206311249628],
            [16.32727901639461, 4.640452598435635],
            [16.325829699311765, 4.646283672644162],
            [16.32941096665901, 4.648955878901624],
            [16.330814446672353, 4.656728947873032],
            [16.334607210180298, 4.658704897041307],
            [16.337881564743824, 4.663867596875003],
            [16.337635275007734, 4.667614534446218],
            [16.340225006830945, 4.670374892783612],
            [16.339925468667357, 4.674745538936428],
            [16.34377231003092, 4.686621813660693],
            [16.348157397917088, 4.689575253304196],
            [16.35016538157552, 4.6926629675216605],
            [16.350333232617114, 4.698355391609927],
            [16.35596919413075, 4.69996893467262],
            [16.357165883871854, 4.704474956340091],
            [16.360155390829753, 4.708267506526466],
            [16.36329065801913, 4.708744801510754],
            [16.36359956789585, 4.714587380183362],
            [16.36797559834713, 4.718636125048571],
            [16.371492099697573, 4.719691434843895],
            [16.380130250658798, 4.726540655147542],
            [16.38178138176281, 4.729382328997134]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.30563815634922,
          "lat": 41.402161518636156
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36071"],
        "coty_name": ["Orange"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orange County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00974134"
      },
      "bbox": [
        16.119021712809946, 4.313391977008803, 16.73120608354075,
        4.798109522578961
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.458497566598565, 5.706650137159867],
            [15.461816784869592, 5.714265923649843],
            [15.464754414564158, 5.714866059160244],
            [15.467498628924005, 5.719337127987874],
            [15.467632718048314, 5.724966608485216],
            [15.465692823729048, 5.728589700184501],
            [15.468245666052988, 5.731818055299961],
            [15.468328443065213, 5.7368834675267575],
            [15.471632547266449, 5.741705753830235],
            [15.477742474158186, 5.744609867695664],
            [15.477686120815482, 5.750790774462195],
            [15.4811282149128, 5.752490533132486],
            [15.479321709136538, 5.758685932207386],
            [15.480752658826878, 5.760817393486696],
            [15.478015855726293, 5.766272130027464],
            [15.47840114361963, 5.776063345591008],
            [15.477217863014411, 5.782561857293626],
            [15.480110461121871, 5.784228659321655],
            [15.4736626218733, 5.791731852181927],
            [15.476086176524559, 5.799450588308748],
            [15.478997610362379, 5.803566389290261],
            [15.470113300733287, 5.817621999124997],
            [15.469166050074055, 5.823047261797442],
            [15.469885995620858, 5.829297607579491],
            [15.46761502543505, 5.832531202080093],
            [15.467762835738137, 5.836345870686277],
            [15.464865453759142, 5.8387513485525],
            [15.46721198012587, 5.845690450255654],
            [15.48850787792014, 5.852552240631423],
            [15.494592361409863, 5.830306099003691],
            [15.495394973929827, 5.830128926376719],
            [15.544341475889501, 5.844200309499239],
            [15.54931797459526, 5.861001432873562],
            [15.552750232614839, 5.870362645195056],
            [15.561326247187363, 5.897798076070405],
            [15.642110829103544, 5.872658232271053],
            [15.656184611984933, 5.868563170327554],
            [15.665651561815901, 5.864759361652494],
            [15.678882608747404, 5.860516288081587],
            [15.717829769775772, 5.84721713655277],
            [15.724837777760344, 5.85608216645379],
            [15.725477074923534, 5.865770812786329],
            [15.725306393256725, 5.876607680306457],
            [15.721428317918283, 5.923241745932975],
            [15.757375572298127, 5.917199299894635],
            [15.811297024954571, 5.907556475625255],
            [15.900557413788782, 5.89322845903898],
            [15.896888045247287, 5.854088571528615],
            [15.90107622090489, 5.826662519887973],
            [15.904553713479006, 5.813201637731066],
            [15.915601864787353, 5.791845359280967],
            [15.951024370170025, 5.718107223599631],
            [15.958583808495195, 5.698219334468181],
            [15.942963118838133, 5.631052618518492],
            [15.925246434460895, 5.578713824282713],
            [15.922621754878397, 5.576160812638429],
            [15.91332844088639, 5.575770325845843],
            [15.910543864958743, 5.571477462682908],
            [15.90228601479533, 5.571486414387683],
            [15.89731374403787, 5.568977392840179],
            [15.894214650539228, 5.564517673449359],
            [15.891614131473425, 5.563609948005689],
            [15.885439241131126, 5.555924115334585],
            [15.880528662021225, 5.556806834434756],
            [15.83174088315068, 5.5522318036739335],
            [15.805200773142195, 5.52733264980317],
            [15.775385294606432, 5.499625898786364],
            [15.775845591156397, 5.498488605624037],
            [15.761443389424475, 5.485259720780809],
            [15.758627766423427, 5.491316122897614],
            [15.748231651309858, 5.487160094359888],
            [15.747573883568048, 5.4658773542881285],
            [15.743338447436479, 5.464727330560244],
            [15.741760101591039, 5.457851299691943],
            [15.734609070443895, 5.458986733859905],
            [15.73364967548159, 5.4631056753384515],
            [15.722753148785522, 5.464102023451466],
            [15.720388338825657, 5.467332907818434],
            [15.724591573186823, 5.442514216315081],
            [15.696173813302883, 5.437692907667116],
            [15.673796954292461, 5.422433962839047],
            [15.65475973929597, 5.39555158855224],
            [15.65901316586465, 5.391870281644298],
            [15.646846496016272, 5.376158885116863],
            [15.64300217620351, 5.379680393073357],
            [15.61308943665887, 5.344983314168888],
            [15.611505863403224, 5.364495379161033],
            [15.601355513265684, 5.361439823169434],
            [15.599501290970439, 5.359444263930315],
            [15.599311408708813, 5.353849016782351],
            [15.597100393315912, 5.350917323244095],
            [15.589878174295633, 5.349214018187245],
            [15.583956089912558, 5.344670744414997],
            [15.574023914673425, 5.345274561407798],
            [15.569736979260894, 5.341632901699416],
            [15.56516934017201, 5.342953703955204],
            [15.562080046542368, 5.338104906086349],
            [15.559773785327598, 5.330370868370101],
            [15.562922008388215, 5.326395579751552],
            [15.556789176766225, 5.320652713279572],
            [15.556419855420366, 5.316924746695591],
            [15.548756704976034, 5.311425306280354],
            [15.546493247050352, 5.302238280614877],
            [15.542455854879014, 5.297167305029425],
            [15.54332153484895, 5.292688965195837],
            [15.53055642827459, 5.2883771676074165],
            [15.519242212626267, 5.279579627994292],
            [15.514278172019864, 5.279830898367635],
            [15.508776015637931, 5.281781202968645],
            [15.497062392902315, 5.2759550300379345],
            [15.491698701519686, 5.281074950332207],
            [15.489625641433772, 5.273658376764769],
            [15.483106688302906, 5.276888151425127],
            [15.478417034680595, 5.270853557000113],
            [15.470515326189402, 5.270570576076521],
            [15.466335166408953, 5.267303014406018],
            [15.465626521551425, 5.273334928815977],
            [15.470179302116614, 5.273410929910452],
            [15.46767146522414, 5.2782139959205585],
            [15.46950597550445, 5.282131466313736],
            [15.46979002334769, 5.287363631817894],
            [15.47377756121014, 5.291426852714513],
            [15.472933158398215, 5.295775195262394],
            [15.469148073304405, 5.300400363928499],
            [15.468255997786914, 5.303605050505319],
            [15.472956835907858, 5.3091753249794165],
            [15.472534752103758, 5.314984143474492],
            [15.46793004005987, 5.314885707946808],
            [15.463760646715548, 5.319678820979467],
            [15.46160055889127, 5.324604515530509],
            [15.462012746616905, 5.329745066255415],
            [15.458106214366358, 5.33388345696245],
            [15.459736672766653, 5.343819545658745],
            [15.463668827024353, 5.3512248074676485],
            [15.463857704562859, 5.355804067945614],
            [15.471032853881875, 5.359740459639552],
            [15.4711958773527, 5.364321275099237],
            [15.474383025454374, 5.368243052492978],
            [15.470104927199442, 5.373214875013055],
            [15.469862584924119, 5.381622359490192],
            [15.466569972893911, 5.382794011813967],
            [15.461802542107431, 5.388563446743179],
            [15.458879638421953, 5.399940716871542],
            [15.454692549970252, 5.404803030857682],
            [15.448968308156813, 5.413358465622089],
            [15.446145430821858, 5.413643447981455],
            [15.442036505568238, 5.423730787843607],
            [15.442395979475332, 5.426237989026823],
            [15.438421229431647, 5.430468706032478],
            [15.44340385950664, 5.439665666922653],
            [15.440710027442664, 5.446965184806958],
            [15.438064633345187, 5.4512560610703735],
            [15.439731791680881, 5.454241605528738],
            [15.43878111399731, 5.457595954960002],
            [15.433139322420795, 5.462013582801467],
            [15.441931862765404, 5.463450949344335],
            [15.443984634615077, 5.474560627174424],
            [15.441432621054954, 5.477026974476891],
            [15.44323816585873, 5.480147577418226],
            [15.44313302496924, 5.48571613090346],
            [15.44843458429534, 5.491347849336414],
            [15.449728006851974, 5.500887415595864],
            [15.448739232423417, 5.507549115752182],
            [15.45508432545474, 5.5105785094150255],
            [15.46076159591701, 5.516211934595681],
            [15.461106456933967, 5.518827523397834],
            [15.466558702234146, 5.520271047695397],
            [15.470666775390395, 5.526996645044814],
            [15.472120426543437, 5.537794589565176],
            [15.46935181451333, 5.541964581721432],
            [15.471168262333137, 5.550195576113506],
            [15.46595073259234, 5.553811338520115],
            [15.46217945855985, 5.5538569656805],
            [15.459795317158408, 5.562205814541518],
            [15.458036600361625, 5.564685840331348],
            [15.45757211155302, 5.572580533172991],
            [15.464729719937479, 5.580588315660135],
            [15.465444902416914, 5.583903522740952],
            [15.461687180911932, 5.586073723403323],
            [15.459366160051461, 5.589700447095374],
            [15.462542647024172, 5.594583495140726],
            [15.460950084435154, 5.6043461831776265],
            [15.45647804874118, 5.607798930610418],
            [15.456016414831966, 5.612574730193112],
            [15.451413501879712, 5.619950922918587],
            [15.453004196046479, 5.623351506353924],
            [15.449886078710488, 5.626594305590771],
            [15.449315700973493, 5.630096887006566],
            [15.451356606550153, 5.633635349243278],
            [15.450467136161052, 5.639989087882085],
            [15.45350079600538, 5.641983284743977],
            [15.45790112747336, 5.650780559467352],
            [15.457794598026215, 5.658595260925883],
            [15.460350259473326, 5.674190854534619],
            [15.463578192732081, 5.681672108312656],
            [15.462331382817272, 5.690198944990437],
            [15.4585854528022, 5.691274881162295],
            [15.462054775895202, 5.700918064673774],
            [15.458497566598565, 5.706650137159867]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -75.03254799538205, "lat": 42.63375754275518 },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36077"],
        "coty_name": ["Otsego"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Otsego County"],
        "coty_fp_code": "077",
        "coty_gnis_code": "00974137"
      },
      "bbox": [
        15.433139322420795, 5.267303014406018, 15.958583808495195,
        5.923241745932975
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.213512905283132, 5.719070355589856],
            [14.273440534225779, 5.735769493301422],
            [14.331016969773762, 5.7509649927736755],
            [14.389500318416067, 5.7659666663675155],
            [14.392569305816115, 5.7604735637926145],
            [14.388588487879458, 5.75280990953041],
            [14.387219439320795, 5.747886217357095],
            [14.390419317266705, 5.7369319264452505],
            [14.38615743191742, 5.7282331569591625],
            [14.388954265277652, 5.718978191540641],
            [14.388636304725082, 5.71679649510218],
            [14.384047935727109, 5.709947353322675],
            [14.385621173609572, 5.7053726920183925],
            [14.38538051692202, 5.6940655501567585],
            [14.390911542315743, 5.6853950641106055],
            [14.392107771797209, 5.665099809058521],
            [14.393128031220964, 5.6571959286408955],
            [14.397336615359263, 5.643006935498478],
            [14.399648728546948, 5.638781532556091],
            [14.411031835313032, 5.622494154936557],
            [14.41549436071219, 5.6134836401904185],
            [14.418757168207517, 5.598490938461529],
            [14.423003192544655, 5.589061351021419],
            [14.42561701226438, 5.577722307988118],
            [14.425674034912522, 5.570462902851442],
            [14.423048568969513, 5.554701230205481],
            [14.418476123944455, 5.537550539841595],
            [14.418293642351887, 5.532128452876234],
            [14.422623303942759, 5.513272066862104],
            [14.435474901959447, 5.472748019196776],
            [14.44173381443132, 5.4586955002436675],
            [14.447483301661684, 5.450899126718639],
            [14.450885429673672, 5.447805257705221],
            [14.47183608811434, 5.434013851446112],
            [14.478838033806161, 5.427323860637734],
            [14.481604647064477, 5.423286293038584],
            [14.49836330431833, 5.391348660775586],
            [14.504555089077007, 5.380106556334542],
            [14.511636006164675, 5.368641786407671],
            [14.51573893917099, 5.363317478112222],
            [14.526217619520615, 5.352080438565697],
            [14.543146609472409, 5.337311417867993],
            [14.550724407273623, 5.331488465764695],
            [14.560981633782035, 5.3261944268243955],
            [14.57725511507004, 5.319825447081343],
            [14.52301881634588, 5.306321039977049],
            [14.498549418817456, 5.300446572119991],
            [14.356925259878583, 5.266185166318094],
            [14.350540141680785, 5.302990622581065],
            [14.341176574495451, 5.34651107352583],
            [14.33405485913009, 5.378844271621932],
            [14.329573471112413, 5.388550734002074],
            [14.298651511637177, 5.424825308542913],
            [14.289921490684264, 5.436618647916434],
            [14.282265298736604, 5.451185145135995],
            [14.275981859613951, 5.472278611643849],
            [14.27508163931995, 5.4774623250819925],
            [14.257984976427833, 5.473795012688374],
            [14.256297967069736, 5.477237969529011],
            [14.251535582302354, 5.481705896992412],
            [14.250613645563165, 5.4886117183651875],
            [14.25184977218706, 5.491645592011762],
            [14.250214851983893, 5.498625854492321],
            [14.247159942320334, 5.506569739347883],
            [14.24786604842857, 5.509849903406432],
            [14.245669502456309, 5.516628452056231],
            [14.24644880207466, 5.520369757781398],
            [14.243992604022711, 5.522395141495631],
            [14.242481582467665, 5.5275710097340625],
            [14.243349702498382, 5.530525072912894],
            [14.24008136411885, 5.53633995277172],
            [14.242603924270513, 5.541720191818572],
            [14.242189530906838, 5.545540913149459],
            [14.23911524366529, 5.550594754443772],
            [14.232801792942917, 5.563559829379453],
            [14.231481586156741, 5.567531392133277],
            [14.232355579951738, 5.5751552278675565],
            [14.235275908010724, 5.578909328144399],
            [14.241967402600098, 5.581632818013372],
            [14.235959902696147, 5.611137698549792],
            [14.220658724068942, 5.685082160528239],
            [14.213512905283132, 5.719070355589856]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.82376545874564,
          "lat": 42.780993540862326
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36099"],
        "coty_name": ["Seneca"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Seneca County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00974147"
      },
      "bbox": [
        14.213512905283132, 5.266185166318094, 14.57725511507004,
        5.7659666663675155
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.996434828768185, -2.2258279699466392],
            [14.062510272789007, -2.1037512365607456],
            [14.128174038861683, -1.9823938596885244],
            [14.159433356687725, -1.9127409999287244],
            [14.248803864110595, -1.9302050099130164],
            [14.335487212842462, -1.9468385737855467],
            [14.350835106907947, -1.947724817187956],
            [14.352960606270502, -1.9493811679464812],
            [14.354988139214457, -1.9588869675708165],
            [14.366214667918584, -1.964849975723192],
            [14.378091986472194, -1.962795323864078],
            [14.383014965139887, -1.9679792138547114],
            [14.385994520478683, -1.9739417651139697],
            [14.388580877421113, -1.9745966604954321],
            [14.390631410465069, -1.9849159832412018],
            [14.396410305136346, -1.990261227019029],
            [14.402068503573314, -1.9939098996932882],
            [14.411492495853366, -1.995569642874285],
            [14.41759079640418, -2.0024060143747078],
            [14.419828575645926, -2.007181928602124],
            [14.43221673908844, -2.0185548235499384],
            [14.430926803990488, -2.023844434418336],
            [14.441440839153202, -2.031058251187409],
            [14.44735978253968, -2.0466889283777627],
            [14.451435109286262, -2.0508235667313186],
            [14.455919129973157, -2.0508710547681552],
            [14.468152955671753, -2.058696605953472],
            [14.46970175717356, -2.0646245062709876],
            [14.474053535432544, -2.0709987254668776],
            [14.474244485928494, -2.075207414922813],
            [14.478997685483336, -2.077447487378497],
            [14.480436283399273, -2.0812945995587553],
            [14.48978490678537, -2.0852402105972274],
            [14.501500982649192, -2.0928500175790727],
            [14.50543364850139, -2.0942833390826356],
            [14.511544334771132, -2.10350190705394],
            [14.506799472155864, -2.1124593183088303],
            [14.509743614087178, -2.1192184523322477],
            [14.508202328794805, -2.123118116364202],
            [14.500844172006504, -2.1304085539726203],
            [14.495825570472848, -2.132446035948611],
            [14.494382661581104, -2.135436940974279],
            [14.485382471764964, -2.142076317069811],
            [14.484476132980497, -2.146614035525996],
            [14.481786221208242, -2.148977431118176],
            [14.477036076668682, -2.1476028225308057],
            [14.475220234954115, -2.1528879915867596],
            [14.477024556782938, -2.1544884877554686],
            [14.4766401281234, -2.162004945193427],
            [14.479479129140078, -2.1670933485913744],
            [14.479311340593986, -2.172663686277533],
            [14.469172023136801, -2.1840573281414173],
            [14.469927305060654, -2.1893642946666567],
            [14.463542945351671, -2.1953274910339533],
            [14.458531060471632, -2.20479636596481],
            [14.386379553559477, -2.2065400232047523],
            [14.384452649994147, -2.204836220240807],
            [14.375512008202076, -2.205743481131414],
            [14.37314755514083, -2.2013464077372067],
            [14.368016776890382, -2.199755206189878],
            [14.365542192640545, -2.203814173856913],
            [14.360577670259918, -2.2064934047022917],
            [14.356520563496856, -2.2050292777132263],
            [14.35296896453496, -2.2058499275383436],
            [14.347213404342714, -2.210873628319271],
            [14.346369414316124, -2.207756036668561],
            [14.334400235324974, -2.2134481327421014],
            [14.332872079709105, -2.211097339723571],
            [14.327400325900836, -2.21065124085681],
            [14.322802867295401, -2.2125319175083846],
            [14.314450090520246, -2.2105246573411903],
            [14.308904401969405, -2.2145966464817786],
            [14.307049661293634, -2.220866893206536],
            [14.30220775844506, -2.2215550019132873],
            [14.297721665470219, -2.2195053588538083],
            [14.290528092472229, -2.2214164000357055],
            [14.289027006802122, -2.225731788446126],
            [14.279023476487588, -2.2305070475636515],
            [14.273817538517747, -2.2314379195549305],
            [14.273604928540333, -2.2342800794533257],
            [14.269021651489902, -2.2368471025195076],
            [14.266248712364026, -2.2430092244685147],
            [14.259273673943296, -2.242072708995408],
            [14.253092545478117, -2.2467624789164313],
            [14.25560683731995, -2.2511735463049924],
            [14.254912569537069, -2.2544668128349334],
            [14.25163205793148, -2.25839664649572],
            [14.245718082703915, -2.2590729268181318],
            [14.241860839566186, -2.2620129170888243],
            [14.237255618653052, -2.260447637546179],
            [14.232319449727951, -2.2654610447547836],
            [14.228266638607517, -2.2667955489572726],
            [14.22611382887951, -2.2696800573406866],
            [14.220194054792612, -2.2722914529416465],
            [14.21386515921705, -2.273581281344601],
            [14.209821921816081, -2.27798411875689],
            [14.204718391989097, -2.27835426959892],
            [14.181410888614693, -2.2861538744641616],
            [14.16271683626707, -2.291487644026433],
            [14.150832514304259, -2.2962787559805458],
            [14.086844800717186, -2.3274910259260984],
            [14.082425221604572, -2.3241035806947306],
            [14.061302489390776, -2.317583798139428],
            [14.053252973734343, -2.318407099018295],
            [14.049801416259172, -2.3143336462259447],
            [14.03842492191011, -2.3137157870778893],
            [14.035273524177102, -2.3077398446721964],
            [14.034261917843784, -2.299788565217885],
            [14.029025116187864, -2.295938652323894],
            [14.022898440587703, -2.288922794871857],
            [14.017844574883446, -2.2877540720932736],
            [14.011746484530404, -2.2843664171966624],
            [14.004132853474122, -2.2856366661188527],
            [13.99841960578375, -2.2837694966418227],
            [13.990591561391435, -2.277480281535597],
            [13.980930946434457, -2.27418967893438],
            [13.971920786801794, -2.270165684651279],
            [13.996434828768185, -2.2258279699466392]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.86936066735329, "lat": 35.36889870274768 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37085"],
        "coty_name": ["Harnett"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harnett County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01008560"
      },
      "bbox": [
        13.971920786801794, -2.3274910259260984, 14.511544334771132,
        -1.9127409999287244
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.705611125629511, -1.6611748207442698],
            [14.713822719817873, -1.651355494108903],
            [14.73823473383525, -1.6393537863236092],
            [14.75977372613974, -1.6235430748508841],
            [14.827567970894965, -1.5734370703617386],
            [14.85040102612042, -1.5560561664369201],
            [14.916863825448452, -1.504429408687717],
            [14.92766669990109, -1.499917619035669],
            [14.934266759006963, -1.4950337120766268],
            [14.95146615888808, -1.4976183765097548],
            [14.959559510221625, -1.5025943032044133],
            [14.96673502458747, -1.4708014325655097],
            [14.974337353965756, -1.475453488090435],
            [14.985817151815427, -1.477115733204672],
            [15.035107468981693, -1.498046711856067],
            [15.037681911456934, -1.5038225775023784],
            [15.037741897882338, -1.5077254248545067],
            [15.080169712063826, -1.59101443254333],
            [15.122253855152534, -1.623608674791868],
            [15.132662338296205, -1.6361385772708616],
            [15.129142179891643, -1.639633531017699],
            [15.117211090016411, -1.6535288932391319],
            [15.108935702093548, -1.6640331594269613],
            [15.074182941684207, -1.7081338268168982],
            [15.038721412085584, -1.7483855784391915],
            [15.030813488263917, -1.7449788332806535],
            [15.025472082777613, -1.7489898236260237],
            [15.023800843119943, -1.7482068784802953],
            [14.886186902720185, -1.7755746637429684],
            [14.836729363366707, -1.7725160235941981],
            [14.83373835957179, -1.7859656924074945],
            [14.7906103406787, -1.7786112376708747],
            [14.782231753801069, -1.7774561396864583],
            [14.741481935674516, -1.700861393661811],
            [14.736032978335754, -1.6886601121611957],
            [14.734424937396868, -1.675757123205682],
            [14.733330578037938, -1.6740624275221616],
            [14.728050490009249, -1.6746190531120877],
            [14.725126109960534, -1.671312643317572],
            [14.720633983632823, -1.6707768000329335],
            [14.719088098600949, -1.6644541645732878],
            [14.71596310156535, -1.6645478881147449],
            [14.713680990786688, -1.6613636953687856],
            [14.705611125629511, -1.6611748207442698]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.91861800358399, "lat": 35.70514798264654 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37195"],
        "coty_name": ["Wilson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wilson County"],
        "coty_fp_code": "195",
        "coty_gnis_code": "01008596"
      },
      "bbox": [
        14.705611125629511, -1.7859656924074945, 15.132662338296205,
        -1.4708014325655097
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.2380134908212856, 2.73616005328844],
            [-1.2285705170406203, 2.7358904144766836],
            [-1.232823621566649, 2.6055506896884637],
            [-1.157922865417342, 2.6045087156389806],
            [-1.111263654267363, 2.6027622472687724],
            [-1.1032193135136767, 2.602266790389969],
            [-1.1029786004202495, 2.6169801639899792],
            [-1.0668116621744184, 2.6160674704139586],
            [-1.0664969460518947, 2.6307566518639196],
            [-1.0001141291864142, 2.629952270396017],
            [-0.950834087086125, 2.6288653447327572],
            [-0.9507824914443702, 2.64356241717322],
            [-0.9355246240429013, 2.6432787393932267],
            [-0.9281708085870295, 2.6426404805680543],
            [-0.8784127086623672, 2.642316439896041],
            [-0.8710466258356652, 2.642031332860827],
            [-0.807136152724165, 2.6417581298376906],
            [-0.8061695813662357, 2.6527108236090657],
            [-0.8048959495587092, 2.697099456985165],
            [-0.8042965183022553, 2.728049200507247],
            [-0.725927808907141, 2.7268824967911987],
            [-0.7268229619077115, 2.664517674592567],
            [-0.727056219971439, 2.648537994192697],
            [-0.7326144688313194, 2.6447272469282685],
            [-0.7380301892560448, 2.644033348526779],
            [-0.7516638055294151, 2.6383794840566104],
            [-0.7598259210792156, 2.6378260102774718],
            [-0.7602171814850867, 2.6414904504455503],
            [-0.7722346261327074, 2.6368388046547926],
            [-0.7708659329595723, 2.633390871587548],
            [-0.7768184021002477, 2.6267331407188808],
            [-0.7798730111702415, 2.6301876227755483],
            [-0.787795228458711, 2.6247255151338154],
            [-0.7933391680270063, 2.6197920421096987],
            [-0.8157368445865305, 2.596708996301606],
            [-0.8351695806105187, 2.582438829513369],
            [-0.8375449923061563, 2.582423941070756],
            [-0.8536055321442629, 2.5678306097172814],
            [-0.872776795544641, 2.539098274906667],
            [-0.8832847809825628, 2.5301223718873556],
            [-0.880787092641637, 2.525744579202135],
            [-0.8884301212760174, 2.5183710297712563],
            [-0.901202719286956, 2.5088965186938728],
            [-0.9012320400761077, 2.5068309914711624],
            [-0.9159052184485654, 2.483362400773054],
            [-0.9350013643369312, 2.4602747307692576],
            [-0.9364342089399645, 2.456852406978861],
            [-0.9453273115874139, 2.4484646813214477],
            [-0.9643475703152312, 2.43862632487828],
            [-0.9744776482936963, 2.435291190980191],
            [-0.9891704688454367, 2.4267781854462194],
            [-0.9982009757516697, 2.42473464343375],
            [-1.0064843365583047, 2.420453124139949],
            [-1.00905461527103, 2.425770729664757],
            [-1.0317776272240102, 2.413594218762332],
            [-1.0394585080952563, 2.408190339910175],
            [-1.0431226196516283, 2.401730673365943],
            [-1.047813087305842, 2.3963871696740986],
            [-1.0516214207609809, 2.3890511939589567],
            [-1.0588013067185953, 2.3820151165639656],
            [-1.0728290465676042, 2.3736641111236083],
            [-1.089258977867408, 2.3547189152504457],
            [-1.095454486416033, 2.351185380739682],
            [-1.0994704967673594, 2.345899407605575],
            [-1.1082385554869867, 2.3451493136630694],
            [-1.132599824639687, 2.3269749097404566],
            [-1.1429280916687437, 2.321294742265318],
            [-1.1471620416960417, 2.312504891452837],
            [-1.1612029993689243, 2.2919624512431622],
            [-1.1894540878354398, 2.274297073787945],
            [-1.195986873816247, 2.268329215188029],
            [-1.2047372270740853, 2.2559279985617837],
            [-1.2119655985909383, 2.2514572440771254],
            [-1.2418987519648994, 2.2180677328814165],
            [-1.2477483768096655, 2.207218917705169],
            [-1.2465082681895991, 2.258400945372421],
            [-1.2432822182038006, 2.3861827253844208],
            [-1.2468780785203337, 2.3862771698789627],
            [-1.245901973589699, 2.4227913100981477],
            [-1.2429733588486507, 2.539431910936976],
            [-1.2409119766121024, 2.62137852790262],
            [-1.2380134908212856, 2.73616005328844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -98.03806324578396,
          "lat": 41.169017336437975
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31121"],
        "coty_name": ["Merrick"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Merrick County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00835882"
      },
      "bbox": [
        -1.2477483768096655, 2.207218917705169, -0.725927808907141,
        2.73616005328844
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9115764096936968, 1.6775175014653736],
            [-0.8971274017352235, 1.6771111064986968],
            [-0.8548660632259013, 1.676448751393523],
            [-0.741952804361366, 1.6744491209947447],
            [-0.625006394833607, 1.6726586059777369],
            [-0.5701004158784942, 1.671635411006606],
            [-0.5702305637675105, 1.6500141785508855],
            [-0.5708813874346624, 1.6317525252101794],
            [-0.5718599109961064, 1.569149785195173],
            [-0.5717063689383916, 1.5611132212818923],
            [-0.572271365029497, 1.5437491343301373],
            [-0.5734298828312608, 1.4666708829332498],
            [-0.5742236502151301, 1.4080666598318314],
            [-0.5755492061096577, 1.320321012418645],
            [-0.5755496678444934, 1.3203210182940965],
            [-0.6834666479880754, 1.3217937563465365],
            [-0.8032736327756533, 1.3238573081904599],
            [-0.880336634816931, 1.3252711653259925],
            [-0.8851743554570384, 1.3255531671865362],
            [-0.9188296066337726, 1.3260235623718557],
            [-0.9170094193268004, 1.3992047638035627],
            [-0.9149221518712077, 1.5018180833902468],
            [-0.9131363817258483, 1.589739454556607],
            [-0.9115764096936968, 1.6775175014653736]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -97.59495182961068,
          "lat": 40.176241260138774
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31169"],
        "coty_name": ["Thayer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Thayer County"],
        "coty_fp_code": "169",
        "coty_gnis_code": "00835906"
      },
      "bbox": [
        -0.9188296066337726, 1.320321012418645, -0.5701004158784942,
        1.6775175014653736
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.457151463233764, 3.001127773523641],
            [-14.423429507186176, 2.994194970324053],
            [-14.412334663737838, 2.99239362595591],
            [-14.302120971720022, 2.9685183265102717],
            [-14.29960243505346, 2.96848569567066],
            [-14.209386651024708, 2.9492446552487106],
            [-14.207905041650044, 2.948060800576956],
            [-14.021265574173126, 2.904677534217954],
            [-13.932202528721001, 2.8864420621507616],
            [-13.927907372860819, 2.8858119151767854],
            [-13.845172191029668, 2.8687388616362415],
            [-13.839283345141068, 2.868038407290194],
            [-13.752561974454508, 2.8491991390257487],
            [-13.73793742894122, 2.8472898793390655],
            [-13.653954249261883, 2.8287073706656884],
            [-13.653821534033483, 2.8293705125008204],
            [-13.63231283089888, 2.824694441622016],
            [-13.48990573754841, 2.794464556585527],
            [-13.359662318553848, 2.7675314357500636],
            [-13.245334894075928, 2.7449805081359546],
            [-13.131010705382673, 2.7224128323091557],
            [-13.134416067988495, 2.703524649239783],
            [-13.147656825792009, 2.6365085349848667],
            [-13.153777663565723, 2.603569801140969],
            [-13.171504577034153, 2.5137541948860767],
            [-13.187770128693506, 2.4295277132252417],
            [-13.193312965880958, 2.4030072866207464],
            [-13.199550955208803, 2.36852441473509],
            [-13.206199464911439, 2.3342550963391036],
            [-13.241170788499485, 2.1539887019575263],
            [-13.257888977144537, 2.0678562557251015],
            [-13.344581058517775, 1.6218690454812061],
            [-13.369737743118526, 1.492516830268885],
            [-13.393337118046217, 1.3685698937609734],
            [-13.397731176564784, 1.3480941476532184],
            [-13.40771527878534, 1.296718899298638],
            [-13.490184361429272, 1.3125671880695875],
            [-13.491526122591427, 1.3129747068789002],
            [-13.669529168270595, 1.347834676069965],
            [-13.847537116386246, 1.382669127250275],
            [-13.929417346232253, 1.3989152120499335],
            [-14.00434771376764, 1.413906542565188],
            [-14.12903139965285, 1.439036930752514],
            [-14.208153226810825, 1.523183705024267],
            [-14.21584797958238, 1.531488264202367],
            [-14.365891657561312, 1.6913188394205456],
            [-14.51595456246916, 1.8511080244415872],
            [-14.517240630975984, 1.8513769336432089],
            [-14.607933812684125, 1.947447701291901],
            [-14.613059673946452, 1.953672374916912],
            [-14.689249558042654, 2.0347916119436835],
            [-14.693333374845526, 2.038496101721932],
            [-14.713328278353792, 2.059676780080388],
            [-14.668701107988076, 2.269965018742882],
            [-14.650254236085132, 2.35833883706497],
            [-14.648305773945545, 2.3546965307160814],
            [-14.64872525740057, 2.3490153511228984],
            [-14.645493872815276, 2.3464577422769275],
            [-14.641326457402833, 2.3529838010258595],
            [-14.63321735858432, 2.3538830889867715],
            [-14.63004913802239, 2.3556835778927883],
            [-14.6262154741995, 2.354563288829118],
            [-14.624841362668588, 2.3579703560604446],
            [-14.621105818575977, 2.357942391425036],
            [-14.61630060979007, 2.366944561377807],
            [-14.617524028555602, 2.374795369709606],
            [-14.613114158761583, 2.375699001188238],
            [-14.61252141022352, 2.379768584508081],
            [-14.607439526368958, 2.38094657989638],
            [-14.600803567589844, 2.385491811424369],
            [-14.60320413399193, 2.389096273685857],
            [-14.598704279235992, 2.393144462460582],
            [-14.593629370230328, 2.391820447837391],
            [-14.591454629182795, 2.3941364247411414],
            [-14.587519719244584, 2.4045891690707872],
            [-14.585746114261825, 2.4059509103392833],
            [-14.578340865333297, 2.4176218352330836],
            [-14.5764086537144, 2.422026267410018],
            [-14.577207836385025, 2.4250240588804335],
            [-14.57632154865044, 2.433029932651918],
            [-14.579077422855637, 2.437848911922942],
            [-14.575807671522087, 2.4442906130376327],
            [-14.571228981114563, 2.450670839814284],
            [-14.56220708959593, 2.4569279599287923],
            [-14.558487555176756, 2.462760363944979],
            [-14.556328893778865, 2.4636966498668564],
            [-14.552823192629578, 2.470781372450175],
            [-14.552377284736007, 2.4778066532982845],
            [-14.553470415526048, 2.4795529337999853],
            [-14.553214026404863, 2.489899149137156],
            [-14.551278827660154, 2.4996914154344823],
            [-14.553721651276225, 2.507412840961092],
            [-14.551614353309118, 2.5202668913694226],
            [-14.55232521676368, 2.524813303500875],
            [-14.547010689281908, 2.5337080882621743],
            [-14.545850509495997, 2.5436440819027197],
            [-14.543570041699361, 2.547910309018545],
            [-14.542969109000028, 2.558413734747281],
            [-14.541373636144938, 2.5636193509237306],
            [-14.543299062266453, 2.5751711696417483],
            [-14.541030002566693, 2.582138839465296],
            [-14.542271605564606, 2.589668609025373],
            [-14.540078393621057, 2.5941610939841],
            [-14.541753489266798, 2.5966921492590824],
            [-14.539065550738464, 2.607935706920051],
            [-14.53370701929741, 2.6162304320502816],
            [-14.530908444236847, 2.61761841564309],
            [-14.528191064166014, 2.6218618869725634],
            [-14.523651698999027, 2.62298922367564],
            [-14.520375766243335, 2.6272147328546094],
            [-14.515109361549305, 2.6363053764169],
            [-14.516172292202695, 2.641399248593654],
            [-14.514471487294031, 2.653514386904098],
            [-14.511385080512673, 2.6564278070058607],
            [-14.511077646487738, 2.6627200397098787],
            [-14.508057700867807, 2.669827172399348],
            [-14.508644772893758, 2.675891966591074],
            [-14.507361035102836, 2.6850547446299435],
            [-14.508303915023257, 2.6889482399682056],
            [-14.50630722315833, 2.6907067725538347],
            [-14.50381811459694, 2.6985120770601116],
            [-14.501047643650915, 2.699279718313984],
            [-14.49590833026947, 2.7051835608573924],
            [-14.491375623140943, 2.7067581057057875],
            [-14.491337280603123, 2.7128994595728204],
            [-14.488189273430878, 2.721256881413825],
            [-14.484747824913752, 2.723922335044282],
            [-14.485431580708733, 2.736294060761416],
            [-14.488688071205525, 2.7399801009501235],
            [-14.488457923386228, 2.7430061134787924],
            [-14.484237417765693, 2.748826571666826],
            [-14.485000366659644, 2.7526134807494613],
            [-14.483965178856778, 2.757375553930755],
            [-14.485179200495374, 2.761911984935834],
            [-14.48474368409506, 2.7713938757741334],
            [-14.482262137210869, 2.7757864374565915],
            [-14.479740781654316, 2.7768189970340535],
            [-14.47785949500461, 2.7839965232472785],
            [-14.479532988849996, 2.7863476908801648],
            [-14.480519388974962, 2.795674186708048],
            [-14.48285114390415, 2.7974711486417894],
            [-14.485364446100698, 2.8061467680456174],
            [-14.484109464963785, 2.8079246359292127],
            [-14.479555229649767, 2.8215284260334816],
            [-14.47936777271902, 2.829022127179265],
            [-14.480741691329504, 2.83811813369313],
            [-14.482202039616555, 2.841322878468134],
            [-14.480728616002626, 2.8481696253375834],
            [-14.48209845507708, 2.8561572411677676],
            [-14.485828984948643, 2.8600059580059645],
            [-14.485497662173307, 2.8699571209511334],
            [-14.48171719924738, 2.872628439359123],
            [-14.479634652579346, 2.8823563378843584],
            [-14.481053335511806, 2.8853071131010117],
            [-14.48049387390065, 2.8922663436224223],
            [-14.473202069090263, 2.896939541674053],
            [-14.472174395291088, 2.8994532771204677],
            [-14.473462311373895, 2.9069666788649933],
            [-14.471795423534305, 2.911591990388193],
            [-14.473568232334665, 2.917411284397809],
            [-14.468151511218093, 2.922504506643366],
            [-14.466585426190763, 2.92615077129946],
            [-14.46507661969158, 2.9355695716547627],
            [-14.467504916610192, 2.944595918898197],
            [-14.46641678127439, 2.9485470417301496],
            [-14.469260497639162, 2.9590035607113543],
            [-14.464149811606218, 2.9614682194123048],
            [-14.463956169284916, 2.966328426541087],
            [-14.466799671152735, 2.973023859418393],
            [-14.457471473258977, 2.9759285007736764],
            [-14.454574162089434, 2.978159969103425],
            [-14.457118077061828, 2.9854816611814536],
            [-14.450739417277045, 2.9904812781126107],
            [-14.450448975762242, 2.9928713320539755],
            [-14.456736639237251, 2.9993693383829685],
            [-14.457151463233764, 3.001127773523641]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.90163075637929,
          "lat": 39.442166783117706
        },
        "year": "2023",
        "ste_code": ["32"],
        "ste_name": ["Nevada"],
        "coty_code": ["32033"],
        "coty_name": ["White Pine"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["White Pine County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00858615"
      },
      "bbox": [
        -14.713328278353792, 1.296718899298638, -13.131010705382673,
        3.001127773523641
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.78314565694813, -6.873440515636404],
            [8.773149193638165, -6.784398032563329],
            [8.805399155947592, -6.780821359115004],
            [8.804464156553856, -6.773576404852008],
            [8.815271250765274, -6.772311895533937],
            [8.805308686008516, -6.693070147735791],
            [8.823871917224139, -6.690722422117831],
            [8.879314033485267, -6.684332818416294],
            [8.924806861193208, -6.679301317648295],
            [8.928235383406237, -6.678697069747381],
            [8.990039282615697, -6.672536593851881],
            [9.030402274067894, -6.6686817279714425],
            [9.106136235411796, -6.661189863589041],
            [9.114465664614482, -6.737879304243742],
            [9.11999559345396, -6.7906222619337555],
            [9.130577288336907, -6.891704015622324],
            [9.13215724065357, -6.904334826841349],
            [9.136301862419863, -6.946599190020802],
            [9.13930333246189, -6.98288216627863],
            [9.143471875207373, -7.023950760537191],
            [9.149601181010922, -7.079151419574467],
            [9.08692282092503, -7.0858086093856825],
            [9.036360873197658, -7.091397672151169],
            [9.025097053585064, -7.092381935813654],
            [9.0064580900746, -7.0947277232856845],
            [8.972903868631048, -7.098553497429129],
            [8.92339255043758, -7.105306678083233],
            [8.874158624870907, -7.111488738840165],
            [8.875293867577623, -7.122299045936659],
            [8.868341190686422, -7.1230948287963916],
            [8.866768266532027, -7.1125150322891555],
            [8.809168761582018, -7.118995582636434],
            [8.806854961536137, -7.100944257776994],
            [8.806961570431715, -7.098385543065035],
            [8.804593043415805, -7.077968580984466],
            [8.803297417340929, -7.061577839415371],
            [8.790834120118985, -6.956610348140391],
            [8.782618231382827, -6.888164239489466],
            [8.78314565694813, -6.873440515636404]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.98817380695934, "lat": 31.40265772960832 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01031"],
        "coty_name": ["Coffee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Coffee County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00161541"
      },
      "bbox": [
        8.773149193638165, -7.1230948287963916, 9.149601181010922,
        -6.661189863589041
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.41810798664737, -4.234829994921245],
            [8.494253295109399, -4.148251123921117],
            [8.503780056495938, -4.140536344238282],
            [8.509278172301382, -4.141284713967694],
            [8.520369209379473, -4.135005490029184],
            [8.57074826246026, -4.131019017288178],
            [8.568839534020324, -4.11653935750674],
            [8.59900703150885, -4.114095247752686],
            [8.648558172388116, -4.109525007581148],
            [8.73029691356013, -4.1003332684607035],
            [8.78312647850507, -4.09466860942884],
            [8.789443248067885, -4.142230074256726],
            [8.794565611648068, -4.1837271072190925],
            [8.801312674864736, -4.183763926307227],
            [8.817029254344572, -4.166763150096719],
            [8.828785123129888, -4.161847321200804],
            [8.834393262393348, -4.1653687258823595],
            [8.8345587826751, -4.168535153730931],
            [8.832108730715357, -4.175261980676833],
            [8.830820706568476, -4.18493153568042],
            [8.831885987094665, -4.190354264260133],
            [8.837491896637077, -4.199861577873177],
            [8.89290256708919, -4.295941812113144],
            [8.893650794348629, -4.316823497177787],
            [8.895618904532798, -4.350118513986573],
            [8.888027536215507, -4.348837626273395],
            [8.836667245939688, -4.344507585697319],
            [8.818145702926099, -4.340568832544198],
            [8.807122151843577, -4.33744307841103],
            [8.80772558574681, -4.344693745191702],
            [8.778730612690378, -4.347506876163665],
            [8.779419538517933, -4.354707801546822],
            [8.764856293313139, -4.356359217247114],
            [8.768849444662358, -4.392909541743149],
            [8.740423495660519, -4.395928699798655],
            [8.738704813479375, -4.381362291504896],
            [8.724546032018416, -4.38296271874769],
            [8.725322126326576, -4.390254795820168],
            [8.710962226304396, -4.390762698121262],
            [8.713265230749402, -4.412438798953684],
            [8.699005388444691, -4.4131355418950164],
            [8.700320828557983, -4.425545658140434],
            [8.699662318859687, -4.427704828948994],
            [8.693533281109136, -4.427953784231914],
            [8.69492631666662, -4.442655002746872],
            [8.673239982275101, -4.443723423034222],
            [8.674945309719286, -4.458289242299063],
            [8.65227206576642, -4.459456103183111],
            [8.653194717999078, -4.470568960152497],
            [8.639847943961419, -4.471360156829791],
            [8.648141740559417, -4.466814375058793],
            [8.647668338557388, -4.46220241931356],
            [8.645008850481583, -4.455084519683391],
            [8.639622898063042, -4.4501695271735136],
            [8.635044505713145, -4.448142853816162],
            [8.630933157318111, -4.448474685943829],
            [8.625344498968479, -4.452579980855568],
            [8.617354722821188, -4.45284441031611],
            [8.611463944941187, -4.454914972572446],
            [8.608006544346816, -4.447747932050914],
            [8.608097549043594, -4.4434313788655695],
            [8.605791287356523, -4.439888741194497],
            [8.599999244600458, -4.4361304255631975],
            [8.597362035102105, -4.423482423787469],
            [8.598628865882695, -4.417695978812128],
            [8.594676897905837, -4.41366276499721],
            [8.589651349852982, -4.418076973515009],
            [8.585521297871193, -4.4183782454744],
            [8.580619082043118, -4.4166730767594355],
            [8.578706429728935, -4.422442394354855],
            [8.570376662084863, -4.420841125609681],
            [8.569613948712085, -4.412670458103093],
            [8.565740042548432, -4.403454002368419],
            [8.562855500803964, -4.40023765605598],
            [8.558963227701616, -4.400823016271072],
            [8.553939161125527, -4.399193535779686],
            [8.547719464211308, -4.394095239970398],
            [8.548133614944947, -4.3839529638650205],
            [8.545536413661916, -4.38044563274545],
            [8.546946249458665, -4.3747862576386956],
            [8.544950656982602, -4.370567139507256],
            [8.545059794529122, -4.364946346568999],
            [8.542698214574735, -4.357265300905366],
            [8.536416777298054, -4.356796187203109],
            [8.532982249178577, -4.352641669219512],
            [8.521729580600542, -4.350816768198957],
            [8.523656505963126, -4.347030202006795],
            [8.523094954303792, -4.3408361343014485],
            [8.516655909586214, -4.339246566243456],
            [8.51515645797962, -4.336214653732025],
            [8.50891896794456, -4.339091240808106],
            [8.504203831851342, -4.33853897784008],
            [8.497174470300367, -4.340987116200592],
            [8.495687775467301, -4.343600522024563],
            [8.490057953148227, -4.3449150858942165],
            [8.483269507801296, -4.353312004757055],
            [8.477750659513962, -4.357534916095359],
            [8.47422746954753, -4.363812744275563],
            [8.469940850154245, -4.359392841758589],
            [8.46383100279648, -4.3583105764853505],
            [8.45996058852891, -4.355335101655296],
            [8.45325937493613, -4.3427923589169515],
            [8.450401784149157, -4.342404197702184],
            [8.447415934743235, -4.348334065452851],
            [8.44100213231208, -4.349004123870432],
            [8.436657225558251, -4.356186210577647],
            [8.428528449380627, -4.3721640994580975],
            [8.42444226931852, -4.377997620882097],
            [8.42027110004136, -4.37981133742937],
            [8.415552838160844, -4.392904285775116],
            [8.4163079462001, -4.395524473967942],
            [8.379867285910318, -4.399607704455247],
            [8.386583257703554, -4.391725235069194],
            [8.387987307806611, -4.385503064020748],
            [8.391683234013264, -4.384271585188386],
            [8.395006040932241, -4.380418077410611],
            [8.393052941383564, -4.377719413658459],
            [8.398232498105747, -4.3727439947163536],
            [8.397901289506283, -4.369779547571571],
            [8.401869111447676, -4.365349991876245],
            [8.399345082119936, -4.359900101068939],
            [8.403175027885194, -4.359660050093901],
            [8.403615448067534, -4.3527745153643185],
            [8.405788851505108, -4.350182195079885],
            [8.402555865648843, -4.3148411103714235],
            [8.399886396756434, -4.289811628764113],
            [8.405186650377471, -4.263278109990221],
            [8.41810798664737, -4.234829994921245]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.03471727405356, "lat": 34.04527686055144 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01055"],
        "coty_name": ["Etowah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Etowah County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "00161553"
      },
      "bbox": [
        8.379867285910318, -4.471360156829791, 8.895618904532798,
        -4.09466860942884
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.428750431556878, -4.9483783749403845],
            [8.431295646295778, -4.9432014710987175],
            [8.436216873684732, -4.937161587754222],
            [8.438961251248424, -4.932042661131171],
            [8.445542311628728, -4.930213791951476],
            [8.452303455566517, -4.927132863835465],
            [8.455087588987954, -4.923523612240083],
            [8.459679695557604, -4.911914536704365],
            [8.46528527319895, -4.903536446205551],
            [8.467322971581185, -4.89432681930457],
            [8.469117824498387, -4.890318053274506],
            [8.475842595873996, -4.883336242442284],
            [8.48024318819979, -4.880003416404492],
            [8.483912380951208, -4.872425374981976],
            [8.483137479815438, -4.866002361888939],
            [8.484646114340487, -4.858868195043641],
            [8.488488432068461, -4.849112271574388],
            [8.49421688555103, -4.8446137270837575],
            [8.494747307151187, -4.841629458054549],
            [8.49293566507095, -4.836395161861569],
            [8.49325285447892, -4.8273523962023],
            [8.49709184688759, -4.82059414833583],
            [8.502409288419852, -4.817165328926799],
            [8.508488715424425, -4.815552435007644],
            [8.511773794871338, -4.818076694638988],
            [8.512506807065783, -4.823914675916238],
            [8.510744042712808, -4.828799800128988],
            [8.511174792696476, -4.833726470148911],
            [8.514737327159086, -4.838504758016819],
            [8.519326250643465, -4.840276746455512],
            [8.524681172360236, -4.838524286158914],
            [8.53630396042656, -4.832984666525942],
            [8.539853860574285, -4.8274340562218745],
            [8.538273228218166, -4.818767030822237],
            [8.540821958527127, -4.80627468141905],
            [8.544872490447794, -4.801099533175364],
            [8.555560477561528, -4.79085095890142],
            [8.564211757444944, -4.785572462924548],
            [8.568132387265718, -4.780077057016704],
            [8.568330570329069, -4.776516365538018],
            [8.565363167243339, -4.770868032822897],
            [8.562820087223619, -4.76910855694532],
            [8.551560181751592, -4.76551136573788],
            [8.54773200192804, -4.760691588903178],
            [8.548023333408514, -4.754124686223686],
            [8.5463155934261, -4.750008495824077],
            [8.539963353469203, -4.743590648802807],
            [8.538547045028638, -4.739312059992475],
            [8.539396657208732, -4.735353162010236],
            [8.542373405410705, -4.732126706869355],
            [8.547611478836133, -4.731071609840925],
            [8.566322244029635, -4.731930568345895],
            [8.568410085238126, -4.728306406352531],
            [8.566290298827857, -4.724777755092746],
            [8.557856945677624, -4.721211497729013],
            [8.55339521105586, -4.717365082308747],
            [8.554149320250792, -4.711809102579277],
            [8.559041419378879, -4.709469862410976],
            [8.57015082913877, -4.708450657406471],
            [8.575732602615508, -4.70605718095297],
            [8.577581547581358, -4.702913245224486],
            [8.57984554265552, -4.6916278622314245],
            [8.580017418100924, -4.687462403989759],
            [8.577956053015397, -4.681086823622823],
            [8.57248247371867, -4.669120897777723],
            [8.570929606657547, -4.66263377488049],
            [8.56322240459632, -4.6559380167584665],
            [8.545863607835742, -4.648076661797265],
            [8.541309245576636, -4.641504729978898],
            [8.541099090819705, -4.635749389390821],
            [8.54418701912555, -4.630214038855983],
            [8.549480060274798, -4.626477572365909],
            [8.555157906738247, -4.624266375856022],
            [8.560147880957452, -4.624210079630451],
            [8.564128479093545, -4.626742796040546],
            [8.56819317362244, -4.632832523545553],
            [8.570189254992053, -4.6430288545935605],
            [8.571907553621115, -4.64589709307424],
            [8.577430350995526, -4.6488660374567665],
            [8.583937797364209, -4.649378961652539],
            [8.58663121082503, -4.647787768952534],
            [8.591012169079479, -4.641108171074462],
            [8.66946320405879, -4.637482334392218],
            [8.672850696218418, -4.642590473363241],
            [8.674774884989885, -4.6486713962631985],
            [8.683288126401873, -4.6544036449424295],
            [8.686191231145854, -4.658349659913903],
            [8.692887394075807, -4.6635972248351045],
            [8.694032922187734, -4.677976351989697],
            [8.700063877637378, -4.693542637016058],
            [8.7010173743049, -4.697425165823215],
            [8.701110323299659, -4.70827620619166],
            [8.722525653708752, -4.706304799157368],
            [8.722335682279283, -4.709965295047947],
            [8.724585106319902, -4.720631553355626],
            [8.762923063530902, -4.717266352899643],
            [8.81335715124795, -4.711869892870638],
            [8.831832316393966, -4.70964470461103],
            [8.889496985032656, -4.704009395360872],
            [8.891434100155255, -4.733424005433457],
            [8.892328179295138, -4.747834105060115],
            [8.85356824698998, -4.7941157547805675],
            [8.85166201603376, -4.795696933324813],
            [8.808013799181472, -4.800434319076431],
            [8.812351563047896, -4.844316983168086],
            [8.797964401527882, -4.84597921969195],
            [8.803404912511398, -4.904292039235246],
            [8.789310361761606, -4.905938493079567],
            [8.790512696310525, -4.920241832587575],
            [8.775371719749323, -4.922127317262874],
            [8.761417132788825, -4.923193757498871],
            [8.762676568413648, -4.936468534771736],
            [8.767598223914652, -5.010975212519137],
            [8.736173697042979, -5.0140907390521035],
            [8.667863184096014, -5.019520678794366],
            [8.653501563655468, -5.020770840532549],
            [8.657299534710509, -5.066962402346414],
            [8.662179140359433, -5.122507769923463],
            [8.658496925393662, -5.122489103324473],
            [8.61884225978287, -5.1258193848671345],
            [8.625167597947568, -5.195112745572746],
            [8.627050755937793, -5.216970757542641],
            [8.565197611413057, -5.223702695900899],
            [8.563530183238816, -5.223590506674615],
            [8.510403445186645, -5.229562328365342],
            [8.4556185462128, -5.235910426160973],
            [8.441378769653657, -5.23650691758236],
            [8.365003596853404, -5.24506647409208],
            [8.366721023010891, -5.239318404478752],
            [8.369671852256845, -5.234283879530994],
            [8.372654236214215, -5.2318368414302325],
            [8.384043967302187, -5.227010231558809],
            [8.387687986777737, -5.223594593211443],
            [8.388524935303568, -5.220375693746086],
            [8.38637104709647, -5.214656148372196],
            [8.381695817675768, -5.209758404718399],
            [8.371741442074285, -5.205202645333671],
            [8.367103766739762, -5.19918707405994],
            [8.36557310900709, -5.18801658617862],
            [8.361335907421, -5.180944892905297],
            [8.35797345060877, -5.178266735236037],
            [8.348182739724697, -5.175132407187329],
            [8.347333718468825, -5.170068938512501],
            [8.35363361180599, -5.151405920543317],
            [8.359098951255259, -5.145998928746012],
            [8.363500758017178, -5.145839604143749],
            [8.371352121269418, -5.150245485275242],
            [8.377292292413646, -5.1489599751254875],
            [8.379806422006693, -5.142853707909128],
            [8.378420831265954, -5.13519771380666],
            [8.375260613778755, -5.129469777198776],
            [8.373078564189145, -5.1218046255869085],
            [8.373992662216853, -5.115172150707511],
            [8.378363249428794, -5.104199215508954],
            [8.382371346848602, -5.10134211655354],
            [8.391538738550798, -5.103100866933223],
            [8.396905525797735, -5.101772229890998],
            [8.40190336063095, -5.093087301772485],
            [8.404248292124276, -5.082320689596686],
            [8.401306467497504, -5.076382445771286],
            [8.394698182654269, -5.068214690514161],
            [8.39444901675541, -5.061072841014666],
            [8.398538872036173, -5.060547399373782],
            [8.404746397640036, -5.065729748003471],
            [8.41463422659626, -5.068798957095805],
            [8.419436887276271, -5.06850597743792],
            [8.42838101439577, -5.064901771374182],
            [8.439145807224019, -5.053078007765197],
            [8.453442090852835, -5.0452527158881875],
            [8.455863784990955, -5.04183602540295],
            [8.455560886185262, -5.038855826710809],
            [8.450438741613564, -5.027117547382715],
            [8.4465648442851, -5.022494097659575],
            [8.445241365397093, -5.017776414425565],
            [8.447104817492733, -5.010338543405484],
            [8.443182337623915, -5.001986722452103],
            [8.443378459559867, -4.9940299436353435],
            [8.446811519169609, -4.99096913321809],
            [8.456680422225707, -4.989720119372535],
            [8.460936773772966, -4.98793807404247],
            [8.463648295058082, -4.9842973755819715],
            [8.463027046651263, -4.980688671859156],
            [8.451924084392683, -4.964628002115758],
            [8.445617742814203, -4.960523960351149],
            [8.433804238221517, -4.955904474925473],
            [8.429286943215816, -4.952144306283651],
            [8.428750431556878, -4.9483783749403845]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.16586688240108, "lat": 33.3800756993842 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01121"],
        "coty_name": ["Talladega"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Talladega County"],
        "coty_fp_code": "121",
        "coty_gnis_code": "00161586"
      },
      "bbox": [
        8.347333718468825, -5.24506647409208, 8.892328179295138,
        -4.624210079630451
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.898301160253697, -10.683816047725646],
            [-13.899016489566389, -10.682710747061126],
            [-13.955291410893658, -10.698736579433513],
            [-13.956067754963117, -10.693208865879967],
            [-13.956733740401159, -10.690999582677799],
            [-13.956086799681081, -10.688951011799892],
            [-13.9565418629838, -10.687595876745867],
            [-13.956069400248237, -10.685119150400299],
            [-13.9570234386786, -10.679477309959204],
            [-13.95802260001191, -10.675328059733078],
            [-13.95883983375528, -10.673128814807004],
            [-13.958722761869156, -10.66697003415234],
            [-13.957825692770584, -10.664501185031767],
            [-13.95987242344869, -10.663953452121044],
            [-13.961191657046392, -10.662895109023887],
            [-13.961330576305, -10.661676169028553],
            [-13.964317835858788, -10.660309910829833],
            [-13.964805030288254, -10.658799517972689],
            [-13.964826434161123, -10.65663642540446],
            [-13.965312134444543, -10.655429569733373],
            [-13.968113290510617, -10.655139010504522],
            [-13.96848114872598, -10.65567687033716],
            [-13.96760564491248, -10.660156729457027],
            [-13.966223297343387, -10.663974178588997],
            [-13.964602655788287, -10.666510074968347],
            [-13.964378055861808, -10.670266596251086],
            [-13.963863278979366, -10.671423504387336],
            [-13.96423587571315, -10.673743842121228],
            [-13.963605197220774, -10.679038769230111],
            [-13.961858520802744, -10.683888719165399],
            [-13.960957591941991, -10.689060562288551],
            [-13.961103240982343, -10.692372405194968],
            [-13.960320381046126, -10.696132786854108],
            [-14.052268788271865, -10.589555317142457],
            [-14.018591203273399, -10.555714838410362],
            [-13.992640359697209, -10.57009847054698],
            [-13.970670191098653, -10.577994679680321],
            [-13.967234258052597, -10.577782642330142],
            [-13.961627869400754, -10.588180954690046],
            [-13.94745618991448, -10.597453507021376],
            [-13.940466019828795, -10.596401082830939],
            [-13.919536036581444, -10.61175126526338],
            [-13.910505723704858, -10.641143401240143],
            [-13.916687841405839, -10.651189091849094],
            [-13.918335335458746, -10.660382213720725],
            [-13.895389956290721, -10.668301474956529],
            [-13.898301160253697, -10.683816047725646]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -135.336245417636, "lat": 59.562990113041835 },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02230"],
        "coty_name": ["Skagway"],
        "coty_area_code": "USA",
        "coty_type": "municipality",
        "coty_name_long": ["Skagway Municipality"],
        "coty_fp_code": "230",
        "coty_gnis_code": "02339479"
      },
      "bbox": [
        -14.052268788271865, -10.698736579433513, -13.895389956290721,
        -10.555714838410362
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-14.69690690224086, -10.75875143309598],
              [-14.694915671272739, -10.758465725141027],
              [-14.694963703106021, -10.759959948685465],
              [-14.69665859143466, -10.759756840813873],
              [-14.69690690224086, -10.75875143309598]
            ]
          ],
          [
            [
              [-14.723107767415161, -10.669449785801893],
              [-14.721860037637045, -10.668106067736543],
              [-14.720829747503524, -10.667966135055037],
              [-14.71996226054593, -10.669459896875972],
              [-14.719671692514117, -10.672446590004382],
              [-14.721589908899364, -10.671475168719969],
              [-14.723107767415161, -10.669449785801893]
            ]
          ],
          [
            [
              [-14.71288392607712, -10.756902361549217],
              [-14.711679544165765, -10.751495975467776],
              [-14.708584543306527, -10.748517209372219],
              [-14.705680694269859, -10.75125333325643],
              [-14.703581730178094, -10.751453722620816],
              [-14.701796712946463, -10.753014105670433],
              [-14.699429676276395, -10.75326160850867],
              [-14.698857623584763, -10.753899963514783],
              [-14.699243084995253, -10.756271801581805],
              [-14.700573110828364, -10.75768423788144],
              [-14.701885827531745, -10.758223817965996],
              [-14.703057629030363, -10.759389725107278],
              [-14.70487875754238, -10.759954860256737],
              [-14.709746080699873, -10.759251690105643],
              [-14.711394650412633, -10.759248623861394],
              [-14.71288392607712, -10.756902361549217]
            ]
          ],
          [
            [
              [-14.718749539032828, -10.776903576368909],
              [-14.718397551404264, -10.774834576803803],
              [-14.716700363055258, -10.773514129224454],
              [-14.716671029429543, -10.776328177507903],
              [-14.71784638076387, -10.77749361541166],
              [-14.718749539032828, -10.776903576368909]
            ]
          ],
          [
            [
              [-14.718928228268048, -10.78387866809679],
              [-14.717566579964602, -10.783351765267941],
              [-14.716228062982971, -10.785312797211466],
              [-14.716036328537976, -10.786650801560747],
              [-14.717404722918673, -10.7868609215515],
              [-14.718928228268048, -10.78387866809679]
            ]
          ],
          [
            [
              [-14.719258362426947, -10.79095339287806],
              [-14.71856485428052, -10.789254598653079],
              [-14.716758216988154, -10.787931329751045],
              [-14.713188805644156, -10.789794210197124],
              [-14.71491547561185, -10.790803287567572],
              [-14.715713863585895, -10.792992728471358],
              [-14.718066047173446, -10.791970674546954],
              [-14.719258362426947, -10.79095339287806]
            ]
          ],
          [
            [
              [-14.73856514051488, -10.808765131841158],
              [-14.738165901159007, -10.807851605976342],
              [-14.736714443422889, -10.807329393331196],
              [-14.736083210454174, -10.805622895697294],
              [-14.734779003892823, -10.80559936068278],
              [-14.734145980391247, -10.804678383870268],
              [-14.734103331580737, -10.802545429350381],
              [-14.732613535640732, -10.797746634439195],
              [-14.73163297916068, -10.796751334793257],
              [-14.731201386805317, -10.795215462067741],
              [-14.731416348593953, -10.793860371061662],
              [-14.72975994361302, -10.791468278195174],
              [-14.729309769091133, -10.7883796768762],
              [-14.728379888151188, -10.788222654741935],
              [-14.726492620932419, -10.78890003000336],
              [-14.72762507452287, -10.790267722681426],
              [-14.727902657609302, -10.79143073926847],
              [-14.726308350030527, -10.793296398831274],
              [-14.727472877417359, -10.793461078381219],
              [-14.727141624549112, -10.794854838965248],
              [-14.728330552611732, -10.795683015011091],
              [-14.730473871026616, -10.79520801466948],
              [-14.730939717158353, -10.79687876840893],
              [-14.729656814608452, -10.797729312186243],
              [-14.727790336068951, -10.798114905783642],
              [-14.727034356292604, -10.799779280324376],
              [-14.726847624878843, -10.80264893165696],
              [-14.72332962750527, -10.80495393034613],
              [-14.722649002132757, -10.806082968921093],
              [-14.72254418640022, -10.80829207270106],
              [-14.723824247621849, -10.808523951368905],
              [-14.725078820596009, -10.807517926329584],
              [-14.725451715148495, -10.809319317187896],
              [-14.729187646495072, -10.80835567403115],
              [-14.730671449188373, -10.80650579478676],
              [-14.732480449222841, -10.806382695417845],
              [-14.731456470326432, -10.808097277071639],
              [-14.73060109542108, -10.811569487986013],
              [-14.731787675796856, -10.812418199176596],
              [-14.733225602573102, -10.81125886091295],
              [-14.733609047387521, -10.812339767840022],
              [-14.732136811615948, -10.814235881945045],
              [-14.731376985525733, -10.816114281853814],
              [-14.732984441878948, -10.818073514704409],
              [-14.73426009067646, -10.815900860572894],
              [-14.736122476772522, -10.813598720712347],
              [-14.73701012377721, -10.810069463698532],
              [-14.73856514051488, -10.808765131841158]
            ]
          ],
          [
            [
              [-15.171345379754767, -10.564660991762299],
              [-15.142248578944148, -10.559379698376112],
              [-15.136679529782414, -10.588804897625474],
              [-15.039144615344245, -10.570535421268394],
              [-15.036212878373648, -10.585312222748357],
              [-15.000467410260946, -10.578400262266388],
              [-14.99464054105502, -10.607302738834056],
              [-14.981684124980337, -10.609320928147403],
              [-14.95204881111773, -10.615149331834209],
              [-14.906985394926714, -10.620388615378461],
              [-14.902712404299669, -10.588398963950825],
              [-14.856014605261246, -10.60195635662215],
              [-14.812794941772832, -10.614300228950913],
              [-14.78937742727947, -10.575436752227438],
              [-14.775485095944367, -10.552202374011816],
              [-14.67273866624533, -10.52348860849616],
              [-14.669695904554736, -10.534524614521656],
              [-14.673079398308092, -10.617149457582471],
              [-14.641140681436589, -10.643097356228989],
              [-14.631424068157783, -10.645849446879712],
              [-14.592196565811745, -10.656860647942155],
              [-14.575219861733418, -10.65945833781383],
              [-14.565570938115387, -10.678849685012118],
              [-14.560857266942477, -10.690426313790002],
              [-14.55030148516416, -10.702552757873445],
              [-14.517773346874536, -10.722697974237127],
              [-14.466340817669655, -10.754232310867398],
              [-14.418500700224387, -10.783291944708836],
              [-14.374368333347798, -10.810436031646578],
              [-14.331480338061061, -10.83654306058979],
              [-14.308220606923207, -10.880007217661818],
              [-14.290599160281547, -10.91833358601835],
              [-14.28841106460954, -10.944939215670875],
              [-14.353313236941657, -10.996601967292246],
              [-14.353378627561868, -10.995509669514997],
              [-14.351504381026867, -10.992411683310948],
              [-14.35153283653394, -10.99045229185216],
              [-14.352533471187842, -10.9875274260191],
              [-14.352347550698092, -10.984665126425995],
              [-14.353323279465808, -10.982805248432543],
              [-14.355198275740474, -10.980705432254497],
              [-14.356895343859494, -10.97816995432363],
              [-14.356211152625022, -10.976236758319926],
              [-14.357710107783433, -10.973785368165116],
              [-14.359054229095452, -10.972387720189131],
              [-14.368017070384319, -10.96516146048986],
              [-14.373150087107947, -10.961276690736073],
              [-14.378735281967705, -10.9575266700447],
              [-14.388364398228852, -10.951484468664423],
              [-14.394211424861517, -10.948289567696145],
              [-14.401719964429468, -10.944465244915843],
              [-14.409658680881096, -10.940856406663185],
              [-14.412679321451806, -10.937111470591137],
              [-14.417263226815937, -10.934880925565754],
              [-14.423757714640448, -10.932151317684948],
              [-14.429497503575707, -10.930129856462534],
              [-14.436396520176345, -10.927918517576835],
              [-14.443567093063821, -10.926390482533943],
              [-14.45285339389119, -10.924873828605612],
              [-14.461507767372376, -10.9235600363622],
              [-14.467459145169196, -10.922519625775031],
              [-14.476624441638942, -10.921263841068999],
              [-14.481648730704528, -10.920293697034648],
              [-14.490127190605834, -10.919576482252861],
              [-14.495491632763889, -10.918731128938646],
              [-14.501942785015082, -10.915794532989077],
              [-14.503993472747437, -10.915166905194186],
              [-14.51003016608487, -10.912478705739154],
              [-14.515725705377264, -10.909560461692484],
              [-14.527351553861337, -10.903149654193566],
              [-14.535535456086652, -10.89888096281541],
              [-14.544562845497016, -10.894695582279285],
              [-14.552681087074841, -10.891494568399409],
              [-14.559390532415478, -10.889308139489493],
              [-14.566332642869689, -10.887244167362876],
              [-14.583549895698178, -10.883114864147212],
              [-14.625963554538727, -10.8741270507533],
              [-14.63673195989602, -10.871471785715526],
              [-14.640939828469856, -10.869829542194127],
              [-14.65627293270072, -10.864550070040382],
              [-14.66586104616936, -10.860979373247929],
              [-14.678165997293885, -10.855859055793708],
              [-14.692017204515588, -10.85051342539871],
              [-14.696603419081324, -10.847471291726722],
              [-14.698923066190623, -10.847417222587776],
              [-14.701998890098842, -10.845136848284978],
              [-14.706546778285125, -10.842917882713076],
              [-14.72210087247941, -10.836517498721884],
              [-14.72970744561514, -10.833756519328034],
              [-14.73264168534452, -10.832551831659325],
              [-14.740241965356299, -10.829786407050321],
              [-14.740916646667246, -10.829164130213298],
              [-14.74369899162541, -10.828244767484323],
              [-14.74565690010916, -10.82608734329659],
              [-14.745334079539099, -10.82435116120493],
              [-14.74369309765419, -10.820251255982479],
              [-14.74212416028307, -10.819298422193583],
              [-14.739205260871556, -10.82035641198811],
              [-14.73713134694397, -10.820212632079405],
              [-14.73480611102921, -10.821205173067536],
              [-14.734015757091457, -10.822738155127153],
              [-14.730954759775184, -10.82268010645188],
              [-14.728780372844477, -10.821917784681489],
              [-14.728010398790666, -10.82122132170459],
              [-14.725699236797858, -10.821173539062935],
              [-14.72374726730026, -10.819798431203374],
              [-14.72428512687558, -10.81882873025969],
              [-14.725874206338084, -10.818254369009168],
              [-14.727456492408429, -10.816934284231952],
              [-14.727383614767186, -10.81338921092835],
              [-14.725555121081898, -10.813593080478693],
              [-14.725918757609707, -10.811374975853605],
              [-14.723331053337136, -10.811032907597065],
              [-14.72280939107881, -10.813089295380546],
              [-14.72176800763445, -10.81390783865047],
              [-14.721363261883946, -10.812056386041112],
              [-14.721835892969867, -10.810414386531],
              [-14.720604772787727, -10.80600539008869],
              [-14.721292352521148, -10.803687887950757],
              [-14.72442068696667, -10.802171231231705],
              [-14.725443937317335, -10.800755005841443],
              [-14.724781291150833, -10.797172468465238],
              [-14.7252841106459, -10.795008416275472],
              [-14.723842873179954, -10.795314701976583],
              [-14.72235663336323, -10.793318215301905],
              [-14.720283238451941, -10.793572969925549],
              [-14.717800415982266, -10.795565706684771],
              [-14.718373950671145, -10.797324432650338],
              [-14.716921197243918, -10.79960337419368],
              [-14.71634597345472, -10.80160447354445],
              [-14.71682830099754, -10.804640706281813],
              [-14.716110273761833, -10.80554915734897],
              [-14.716032214516519, -10.808210742714806],
              [-14.714624635791694, -10.809608754556413],
              [-14.71283931346368, -10.809713254960629],
              [-14.709527593193737, -10.809339652384445],
              [-14.708522332454711, -10.808357188445099],
              [-14.711902627386031, -10.807172405651382],
              [-14.711006342690363, -10.805703822816897],
              [-14.710020077610773, -10.805214476244943],
              [-14.708488208120094, -10.802843173346117],
              [-14.708969121084024, -10.801504059569991],
              [-14.708715357245069, -10.79923677485758],
              [-14.70498038638526, -10.797218261188329],
              [-14.704235621569708, -10.795956411155625],
              [-14.702402018515347, -10.794641382409536],
              [-14.701794517968757, -10.79361749327433],
              [-14.702257719008768, -10.791495052080233],
              [-14.704380664369811, -10.791946691251908],
              [-14.705336124488225, -10.792663389377497],
              [-14.706288804628162, -10.79214722178745],
              [-14.705660353023307, -10.78920763959177],
              [-14.704960238437678, -10.788272658667585],
              [-14.704784312406968, -10.783837372037876],
              [-14.705483923798585, -10.780529164785221],
              [-14.704381894989059, -10.780948088745667],
              [-14.703539012048033, -10.780022537795578],
              [-14.702282628759448, -10.779792511350584],
              [-14.70122210812916, -10.778119377643232],
              [-14.701384981497652, -10.773677723355462],
              [-14.699197797666649, -10.770444948320943],
              [-14.697854804388777, -10.768986131290132],
              [-14.697765334349533, -10.766664779365314],
              [-14.697156930187179, -10.764790381834942],
              [-14.695781372386522, -10.763169856288489],
              [-14.69577373484261, -10.761874689838441],
              [-14.692469786327202, -10.760476093854127],
              [-14.691337558810648, -10.760462403424711],
              [-14.692274997052646, -10.758589516560372],
              [-14.692499406802334, -10.755798063203937],
              [-14.693916048748623, -10.754645206704467],
              [-14.696018520171542, -10.754340681384837],
              [-14.697036440010423, -10.752486206643132],
              [-14.698832896915105, -10.751542960112065],
              [-14.699757640622774, -10.75161738355711],
              [-14.703356878099815, -10.74884268893343],
              [-14.70570682958973, -10.747339912629014],
              [-14.706351906536751, -10.74551393142709],
              [-14.708744881742241, -10.743239966731492],
              [-14.710806702771967, -10.73958315502428],
              [-14.712667853704465, -10.737575793669468],
              [-14.714377025423305, -10.737184231614712],
              [-14.715766286367094, -10.734526062699269],
              [-14.71930128810423, -10.728951222878852],
              [-14.719900072205457, -10.726947015113407],
              [-14.719618879617801, -10.723253250570123],
              [-14.720310372303514, -10.722072518875596],
              [-14.723574606244025, -10.718260943654032],
              [-14.726022861696782, -10.716848409722031],
              [-14.72729100017489, -10.71480136292051],
              [-14.728388715875724, -10.71189497667737],
              [-14.731038786840497, -10.705761391507226],
              [-14.731328341433212, -10.700849473080176],
              [-14.731793784029454, -10.699053704540397],
              [-14.731739669782339, -10.69577638206862],
              [-14.728307174420143, -10.694109193292928],
              [-14.725549806403443, -10.691404210916437],
              [-14.724412242857687, -10.688588926413786],
              [-14.723044119038692, -10.687596425445403],
              [-14.721233420697416, -10.68486602694131],
              [-14.720251280275832, -10.684316087461287],
              [-14.718329078515175, -10.68075980665179],
              [-14.718429114220964, -10.677773142420882],
              [-14.717536836543834, -10.675979595200799],
              [-14.717690009473058, -10.673508976383344],
              [-14.718293175901957, -10.671115787191436],
              [-14.71722519354806, -10.670294078710882],
              [-14.716988644939033, -10.668517868379922],
              [-14.716296529635754, -10.667631119208723],
              [-14.716377560191145, -10.66586109144912],
              [-14.717707568378774, -10.663354659878372],
              [-14.717071051356145, -10.662177606052284],
              [-14.71568364483282, -10.661504783053902],
              [-14.715151976026632, -10.65942874121453],
              [-14.716000097699794, -10.65878866860365],
              [-14.717432789564942, -10.656579492209369],
              [-14.719565262425421, -10.655027425673815],
              [-14.720389118002624, -10.653820604034967],
              [-14.722839861445133, -10.652169838506437],
              [-14.723556402979188, -10.649931990707778],
              [-14.725882295922492, -10.645442213018073],
              [-14.72684352551445, -10.64493766236535],
              [-14.730278562560267, -10.644551239972474],
              [-14.731122220670432, -10.6456998080045],
              [-14.729936415058857, -10.646449394973091],
              [-14.729234640110295, -10.64919341445859],
              [-14.73032101582299, -10.651150652475097],
              [-14.731034656823187, -10.653824867498152],
              [-14.731159793989162, -10.657044149852739],
              [-14.73232845809955, -10.659775680039841],
              [-14.733506171001178, -10.660199138258823],
              [-14.735309467788346, -10.66218581883356],
              [-14.735755630834253, -10.664929589077273],
              [-14.73514725033036, -10.667266998661882],
              [-14.73406635289436, -10.669912953758944],
              [-14.73390502932716, -10.671959226834497],
              [-14.733309096293167, -10.672818381568787],
              [-14.733494987037862, -10.676160066509194],
              [-14.733024890333198, -10.677025942119394],
              [-14.732731049418692, -10.679570916914617],
              [-14.733418452507978, -10.68077122656416],
              [-14.737452737033115, -10.682589629565424],
              [-14.739814912349756, -10.686570690027722],
              [-14.745338256410221, -10.689443319819972],
              [-14.747269864281614, -10.691173708878697],
              [-14.748682759567865, -10.693423783886868],
              [-14.74895694251572, -10.695880159068524],
              [-14.750341802990345, -10.698684855161357],
              [-14.751689600171554, -10.703058821708325],
              [-14.751809835566878, -10.704243090845184],
              [-14.753398753520905, -10.707153111693776],
              [-14.754766529899008, -10.71202838360722],
              [-14.754288238354592, -10.713611973411087],
              [-14.754292188657223, -10.71647958354651],
              [-14.7534627591361, -10.718495046941168],
              [-14.751736365288568, -10.721289156337471],
              [-14.75161801702694, -10.724132706321283],
              [-14.752218602731428, -10.727003714583148],
              [-14.756755231889137, -10.731938928816835],
              [-14.7617836569174, -10.73562659482296],
              [-14.766544197899455, -10.738410953891393],
              [-14.772331187359043, -10.74255026766285],
              [-14.774550517267556, -10.743906199037324],
              [-14.778856023650324, -10.74604437538303],
              [-14.780031966799573, -10.747512429061702],
              [-14.782576094140339, -10.749146364040296],
              [-14.78541975366167, -10.7515605376278],
              [-14.788635030322737, -10.753840730966946],
              [-14.790569781068148, -10.754753623428508],
              [-14.79415390445344, -10.757701071671164],
              [-14.795401206158854, -10.759229440072268],
              [-14.801093746004684, -10.763291516522642],
              [-14.80682098391188, -10.766217675460053],
              [-14.808908042297983, -10.767623503233768],
              [-14.814072023947727, -10.771991523130474],
              [-14.815005214036749, -10.773410435329964],
              [-14.815466053229336, -10.777138252155785],
              [-14.819759576780301, -10.782700443842824],
              [-14.827865425173524, -10.788347597488551],
              [-14.832718484426612, -10.791037256815383],
              [-14.834224516061832, -10.791388908455518],
              [-14.841892637605774, -10.791692480440291],
              [-14.847574102578166, -10.792092873907949],
              [-14.85210523343611, -10.792679105295695],
              [-14.859400298338722, -10.793318224276158],
              [-14.867509463274626, -10.79376914904164],
              [-14.878195451029272, -10.794881656349306],
              [-14.884680730352343, -10.7950885859023],
              [-14.887511453884393, -10.795531975782856],
              [-14.890452873897228, -10.796669205464417],
              [-14.898454367404351, -10.7969613108754],
              [-14.912639474354265, -10.796641354189893],
              [-14.91905894962581, -10.795868501693368],
              [-14.92693443382919, -10.795906706741015],
              [-14.929745118607713, -10.795477469027793],
              [-14.93397434630473, -10.795227483147245],
              [-14.936900087328842, -10.794664446160702],
              [-14.947641520812525, -10.790828878724252],
              [-14.94982810977643, -10.789908721527807],
              [-14.954519266974744, -10.788382412293196],
              [-14.963488380985893, -10.786087616942613],
              [-14.966572272988492, -10.785129498227395],
              [-14.974202388416964, -10.783326736158859],
              [-14.986698456910911, -10.77989348244422],
              [-14.991743175161307, -10.77832566032246],
              [-15.006179572344875, -10.774778680807644],
              [-15.011620439581659, -10.772987584456473],
              [-15.015076129260061, -10.772341610982785],
              [-15.02180722507956, -10.770558936101601],
              [-15.027995711892913, -10.769255829730584],
              [-15.037661373427271, -10.76645356261684],
              [-15.042342822321304, -10.764539787935695],
              [-15.04446856194767, -10.76296988774958],
              [-15.04677226628791, -10.760770732882298],
              [-15.050443319377607, -10.756174994873284],
              [-15.051635550817284, -10.7533006417151],
              [-15.050552652654632, -10.751256136110792],
              [-15.049343076915738, -10.750736270519969],
              [-15.046588756890426, -10.754028555654891],
              [-15.04299774174401, -10.754442485653449],
              [-15.044295134620802, -10.755816873407936],
              [-15.045619760687126, -10.75640059450233],
              [-15.045110547437439, -10.758147710983426],
              [-15.045807487325613, -10.758697438729433],
              [-15.04343086052952, -10.761560198593251],
              [-15.043191925692962, -10.762353044522241],
              [-15.041650410968751, -10.763529723417127],
              [-15.040179581459512, -10.759566356096753],
              [-15.040053790286208, -10.757824905303302],
              [-15.037535894567108, -10.755549832004721],
              [-15.035448147305468, -10.754109089000755],
              [-15.034793011039676, -10.7509701638471],
              [-15.034920893402637, -10.749235869707903],
              [-15.033998858331856, -10.74768037693782],
              [-15.032566101899356, -10.747870037550308],
              [-15.030834009311993, -10.746998296857967],
              [-15.030776782453326, -10.74556420407689],
              [-15.028188124199545, -10.74582730433792],
              [-15.025800645238975, -10.7457096980057],
              [-15.024737240758732, -10.744880074018608],
              [-15.023505633838505, -10.74297179135139],
              [-15.022158888081206, -10.744013554385054],
              [-15.020424742000781, -10.742511727085994],
              [-15.018402592488918, -10.743759702655808],
              [-15.018299558273535, -10.740851417215215],
              [-15.020209030717858, -10.738243240644831],
              [-15.019990102408784, -10.735686271218972],
              [-15.019142396888071, -10.734650781814064],
              [-15.021013812458103, -10.731481222147213],
              [-15.021146468030132, -10.729845851526271],
              [-15.020375948070313, -10.728611963907944],
              [-15.0176891020425, -10.726176146937593],
              [-15.018438373699452, -10.72396274366867],
              [-15.017256537493134, -10.721955168606486],
              [-15.017622823587777, -10.720102261847858],
              [-15.02042116931557, -10.71683371084175],
              [-15.022720768515203, -10.715016209078705],
              [-15.024629717004016, -10.711711186636188],
              [-15.025186501876572, -10.708929952668221],
              [-15.02798924495492, -10.705832381500896],
              [-15.032656517180236, -10.703241442899007],
              [-15.033448771344972, -10.702071559538082],
              [-15.032676176633318, -10.700568047993618],
              [-15.031538874248008, -10.701500407456686],
              [-15.029899776179182, -10.701480760072211],
              [-15.026999599354141, -10.700804199926456],
              [-15.027120667543693, -10.698908332778895],
              [-15.026395827745082, -10.698311399846546],
              [-15.025675400188963, -10.693211868082805],
              [-15.020191517193965, -10.688579882871398],
              [-15.020758420969848, -10.686354306513701],
              [-15.02001411031749, -10.684586700811218],
              [-15.018360778786244, -10.682311902198139],
              [-15.015994372589374, -10.682150203866062],
              [-15.0149202771609, -10.680777512738738],
              [-15.01463245141422, -10.679472498844756],
              [-15.012854510315725, -10.678256437984425],
              [-15.010491016020454, -10.678927423660701],
              [-15.008180398393325, -10.675108204071721],
              [-15.007538823403502, -10.67115302626398],
              [-15.007467149674751, -10.668349216597386],
              [-15.007813645385706, -10.66429491428247],
              [-15.008459229906219, -10.663586844651503],
              [-15.00907615094264, -10.661126001847938],
              [-15.010416845752413, -10.66030229751674],
              [-15.01047761918872, -10.658733198617105],
              [-15.011356499889835, -10.657695958933935],
              [-15.014015375706714, -10.657209355270991],
              [-15.01423156915853, -10.659288998444021],
              [-15.012174917890688, -10.66138932312192],
              [-15.01111284832678, -10.66355697982904],
              [-15.011792858676529, -10.6666842096097],
              [-15.011610306598316, -10.668022924647207],
              [-15.012005809987583, -10.670471885818475],
              [-15.013394582348605, -10.674694588134631],
              [-15.014263906550207, -10.675611113826502],
              [-15.016673007827928, -10.676822816606665],
              [-15.019136490463827, -10.679460794565356],
              [-15.02068698317953, -10.68034066539903],
              [-15.023179199564916, -10.683691610012104],
              [-15.024087864541908, -10.683989986854169],
              [-15.026012287497707, -10.686815502252482],
              [-15.0275693620041, -10.68702898973325],
              [-15.029952322574275, -10.68881632045555],
              [-15.03128884578087, -10.690256358860806],
              [-15.034627184943234, -10.691580292958701],
              [-15.037130427211977, -10.691263498441838],
              [-15.037652197514996, -10.691820935447051],
              [-15.037774161679001, -10.693897393001052],
              [-15.039436674215917, -10.693450879731628],
              [-15.040457087901448, -10.692010319002211],
              [-15.041014841339704, -10.690124903890668],
              [-15.044987806090436, -10.68580193551839],
              [-15.045929402176311, -10.67985338761107],
              [-15.04589804893256, -10.673148611127338],
              [-15.046337559029844, -10.672191744696494],
              [-15.048328002308708, -10.670821472383832],
              [-15.048943650388212, -10.669607086730059],
              [-15.050284086734502, -10.66919518284997],
              [-15.05274136267318, -10.671446823531014],
              [-15.05396757494188, -10.674630772859874],
              [-15.054327812922846, -10.677735293818444],
              [-15.05592249266562, -10.680115966452206],
              [-15.057163354310688, -10.680432773052722],
              [-15.059394568810673, -10.679978438308652],
              [-15.061586982573564, -10.678642970554158],
              [-15.066759411287185, -10.67665958308621],
              [-15.071842419936651, -10.67274812649034],
              [-15.072206410371038, -10.671735470641561],
              [-15.07353271518299, -10.670736788021106],
              [-15.07596707250445, -10.670734204200452],
              [-15.07651315625943, -10.670296324010915],
              [-15.078526126087453, -10.671170097745614],
              [-15.079256496671135, -10.672386467891723],
              [-15.079473568685415, -10.674089065260919],
              [-15.078001594410102, -10.676932106369367],
              [-15.075706143461074, -10.678166626825075],
              [-15.074965612445611, -10.679608436999345],
              [-15.073816122840064, -10.68055816184567],
              [-15.072574232014734, -10.68307125484299],
              [-15.072104970034218, -10.685063689726887],
              [-15.068282098579065, -10.68701201809648],
              [-15.065959289251193, -10.686203028007974],
              [-15.064158024346929, -10.687904769344795],
              [-15.062406085079868, -10.688700350616902],
              [-15.061327989542685, -10.689705444241508],
              [-15.06032918375192, -10.691599813832237],
              [-15.058524656345522, -10.693093324666366],
              [-15.057033292200687, -10.695353714565556],
              [-15.055669894564604, -10.696305913366457],
              [-15.056559601498911, -10.69713952238068],
              [-15.057864924625413, -10.697134787716031],
              [-15.058859540375675, -10.697863104905348],
              [-15.05738951560315, -10.70087901183735],
              [-15.055655276075202, -10.702220340974783],
              [-15.05432720363306, -10.702554221048315],
              [-15.05241048141221, -10.702235588003944],
              [-15.049062222839815, -10.702564044913727],
              [-15.047194215008401, -10.703504438701499],
              [-15.043256339017946, -10.708349880190513],
              [-15.041426200189088, -10.709088993407924],
              [-15.03895769298061, -10.711849456492372],
              [-15.037953322156243, -10.714953098402926],
              [-15.040812300836802, -10.71631860798845],
              [-15.0420256095508, -10.719386565833943],
              [-15.042462574773594, -10.721682459897842],
              [-15.04650681829543, -10.723655926390869],
              [-15.052036041900067, -10.7277172683556],
              [-15.054783385092932, -10.728385214318301],
              [-15.0554629955481, -10.72901372341866],
              [-15.058988155495268, -10.730634531515133],
              [-15.059485002152938, -10.731771782175747],
              [-15.06138306646901, -10.734173665548948],
              [-15.0629612882582, -10.73517847704483],
              [-15.063842785784425, -10.736512969868008],
              [-15.064451816992316, -10.73925915883179],
              [-15.072787715625825, -10.743305885659746],
              [-15.087675384256757, -10.746699021943124],
              [-15.091083019915073, -10.747201267499769],
              [-15.096951225654465, -10.747766286633002],
              [-15.104811286094296, -10.745792986452706],
              [-15.111389434968444, -10.743570447342714],
              [-15.124200878391603, -10.739557341742582],
              [-15.13818611390166, -10.737080628209764],
              [-15.144416527118365, -10.736408825600511],
              [-15.151111074594915, -10.736400854779156],
              [-15.15683239135498, -10.736888670564579],
              [-15.163465702655415, -10.737021721173315],
              [-15.16832402445182, -10.73638709293079],
              [-15.174419550675855, -10.7352608241298],
              [-15.182412570893394, -10.734092258048392],
              [-15.199103903763307, -10.732905022756187],
              [-15.214424447132524, -10.733204533706926],
              [-15.220287453823907, -10.733763521926555],
              [-15.222677956058728, -10.734717520776499],
              [-15.22350818979611, -10.733364457895934],
              [-15.225729760595415, -10.73221066423927],
              [-15.230657766833941, -10.731647427269742],
              [-15.24194647765412, -10.73067858399334],
              [-15.251133558783685, -10.730766795554771],
              [-15.27007159862674, -10.73217541284001],
              [-15.289277498336745, -10.734741860463918],
              [-15.300322131086634, -10.737558722254498],
              [-15.305961181370476, -10.739229255602897],
              [-15.307140174772956, -10.740369574470694],
              [-15.310186316066714, -10.741072471772283],
              [-15.319565647970546, -10.74515699945062],
              [-15.332094410730933, -10.75011339984036],
              [-15.34227904628733, -10.753845511878145],
              [-15.353298477312277, -10.756880447432618],
              [-15.390369155240172, -10.766318796771987],
              [-15.40852527039805, -10.771159364158773],
              [-15.412736352254987, -10.77260973805096],
              [-15.416700732808613, -10.773719903630065],
              [-15.419903825857762, -10.774383728384445],
              [-15.425668796242226, -10.776314116791783],
              [-15.431237260556621, -10.778958019722777],
              [-15.437466671447387, -10.782198261873456],
              [-15.442113935635138, -10.7849272270852],
              [-15.455994269991109, -10.793575660270905],
              [-15.462401372814538, -10.798846967512617],
              [-15.467322500184261, -10.801017731506729],
              [-15.469392578533522, -10.801509390081815],
              [-15.471420073479743, -10.788522298391115],
              [-15.449427629242445, -10.744319868257966],
              [-15.379340714453948, -10.600198717714386],
              [-15.324484000145148, -10.591205317681585],
              [-15.171345379754767, -10.564660991762299]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -140.35767672558623,
          "lat": 59.88890082028773
        },
        "year": "2023",
        "ste_code": ["02"],
        "ste_name": ["Alaska"],
        "coty_code": ["02282"],
        "coty_name": ["Yakutat"],
        "coty_area_code": "USA",
        "coty_type": "city and borough",
        "coty_name_long": ["Yakutat City and Borough"],
        "coty_fp_code": "282",
        "coty_gnis_code": "01419986"
      },
      "bbox": [
        -15.471420073479743, -10.996601967292246, -14.28841106460954,
        -10.52348860849616
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.449829777348367, -2.7384121639995143],
            [4.578091819769739, -2.7357975268467376],
            [4.5762438609359, -2.691965753397994],
            [4.584812932273845, -2.69179983072881],
            [4.586456934615229, -2.686683186268459],
            [4.583380263490367, -2.68542195609799],
            [4.583047140699399, -2.6770612980656625],
            [4.584846374992076, -2.6730952146692846],
            [4.581404701388326, -2.6703200447275224],
            [4.5819259885483765, -2.6662392765320932],
            [4.586721104433156, -2.6659174061154345],
            [4.585750512990046, -2.661334717600826],
            [4.586336565350816, -2.655240160826231],
            [4.590204996138889, -2.6521966914397455],
            [4.590063430654728, -2.6473095800788715],
            [4.616556150116999, -2.6468707009210006],
            [4.672714162239309, -2.6437060809364517],
            [4.732963815903823, -2.640874571113906],
            [4.7895244432030255, -2.6384139021698805],
            [4.832892311971507, -2.636261009888968],
            [4.860737330116725, -2.634671951970611],
            [4.962284604663213, -2.629457466799329],
            [4.961450173906787, -2.627724190139841],
            [4.961750306072589, -2.61726757741353],
            [4.963039563883577, -2.615437110864811],
            [4.961904574756852, -2.6054771608621827],
            [4.968006811350228, -2.597783024385927],
            [5.039013252175863, -2.592842479549336],
            [5.047227826054165, -2.7046161555905397],
            [5.051836328293874, -2.774093453917919],
            [5.051882022935281, -2.7814520989816565],
            [5.056698159388567, -2.8622002908563156],
            [5.058819521520806, -2.891077842536347],
            [5.016267729625323, -2.8927735603214186],
            [4.987339668663539, -2.8943089931709687],
            [4.9696346846346575, -2.8946226109490003],
            [4.928620053296039, -2.894589888505165],
            [4.886635820840942, -2.8938049437192634],
            [4.852920279506581, -2.8967261931955206],
            [4.800529785331809, -2.901625712139397],
            [4.771705551389481, -2.9028130676984127],
            [4.744922404019871, -2.9042447145606767],
            [4.715694593786125, -2.9054557159628227],
            [4.699689853737208, -2.9066437979440014],
            [4.688386938661785, -2.907031922191958],
            [4.595377548624965, -2.9117273515176705],
            [4.542120311675981, -2.91371021402825],
            [4.499512775588537, -2.9150613611397036],
            [4.474718169654497, -2.916057021661362],
            [4.455564430990546, -2.9163628835433206],
            [4.454964358539103, -2.9015251161646045],
            [4.453916643328545, -2.8622882226286896],
            [4.454026174355131, -2.8573513339740897],
            [4.452512571825612, -2.8275620131667134],
            [4.449829777348367, -2.7384121639995143]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.63282655148384, "lat": 35.83079832904488 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05031"],
        "coty_name": ["Craighead"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Craighead County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00066847"
      },
      "bbox": [
        4.449829777348367, -2.9163628835433206, 5.058819521520806,
        -2.592842479549336
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.786442453343052, -4.965819373457286],
            [3.7827315626986366, -4.8782773307587775],
            [3.8675304290899897, -4.8747434228921644],
            [3.9531811892837236, -4.87052949795602],
            [3.980638677768462, -4.869388391946814],
            [4.03969867698322, -4.866488025335633],
            [4.070253740708033, -4.868055234426354],
            [4.127815455597032, -4.871396046087994],
            [4.144815226820164, -4.8723663321407775],
            [4.17347254941964, -4.871948781029572],
            [4.2164437026362735, -4.870007863791444],
            [4.217615039609845, -4.913880576341582],
            [4.21783380954573, -4.915714784555679],
            [4.222236791982656, -5.044440488994943],
            [4.222902047839286, -5.044621684908934],
            [4.22426916249639, -5.0874861121330985],
            [4.225606278807488, -5.130825822805366],
            [4.228594127336658, -5.139147928711138],
            [4.228828665377092, -5.143369967755845],
            [4.225969437013783, -5.146007462197593],
            [4.228147699324292, -5.226062614705276],
            [4.2294439114712326, -5.262637193816258],
            [4.1927084119269376, -5.263192965079223],
            [4.142852784335634, -5.2642519629016],
            [4.142876042985282, -5.264836028737257],
            [4.106127374772194, -5.265955393676057],
            [4.057298793549893, -5.2669351816026575],
            [3.9768333500275004, -5.269473440938176],
            [3.971633857959233, -5.2697885866906935],
            [3.9215058890462613, -5.270304583313852],
            [3.885192861328401, -5.270901749534074],
            [3.8293138661622637, -5.27246898840097],
            [3.787645075395431, -5.273092590717414],
            [3.783452068317557, -5.265933246114504],
            [3.7786687461485053, -5.260121949681986],
            [3.777119293757328, -5.256268169725433],
            [3.779316245533986, -5.249770507027575],
            [3.777902773907433, -5.244636415241543],
            [3.781514283336725, -5.23821260453562],
            [3.7812852372768035, -5.229960677559734],
            [3.7784597266850266, -5.230226774436156],
            [3.769191934773698, -5.226681868043814],
            [3.765181823177066, -5.220641174030623],
            [3.764440433667624, -5.215523543630393],
            [3.769002071855815, -5.208242075641798],
            [3.770383636873902, -5.203037464587369],
            [3.77628635800451, -5.1986409364379025],
            [3.7743445274179748, -5.19265701374079],
            [3.7712474272302683, -5.191289243208216],
            [3.7683678436240435, -5.18503318418718],
            [3.768685939340461, -5.17775886226224],
            [3.7730305307113907, -5.1728813485759195],
            [3.7759908055856424, -5.171519583794219],
            [3.774494813996756, -5.163130525994682],
            [3.769785018396441, -5.159793545296284],
            [3.7719712556955676, -5.152518713905541],
            [3.767259011620387, -5.149165552090787],
            [3.767140718752952, -5.142061344108415],
            [3.793660216615471, -5.140962967142544],
            [3.792842735462749, -5.126748371968443],
            [3.7905865487315604, -5.06900519685762],
            [3.786442453343052, -4.965819373457286]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.7199788467256, "lat": 33.589434752977915 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05043"],
        "coty_name": ["Drew"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Drew County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "00066851"
      },
      "bbox": [
        3.764440433667624, -5.273092590717414, 4.2294439114712326,
        -4.866488025335633
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.257475709579481, -3.569196227668209],
            [3.2577707374569784, -3.5648095787958805],
            [3.2662654305950385, -3.5561292671514346],
            [3.2740408370667966, -3.567241933047191],
            [3.2839780813685615, -3.5670446506691347],
            [3.288148495625215, -3.552334389747296],
            [3.2909572290766946, -3.5468126812933214],
            [3.29592452345062, -3.541318374240047],
            [3.292987842515891, -3.5369581803510663],
            [3.2970157970550114, -3.5333780094630103],
            [3.2965538325478656, -3.5209579689413686],
            [3.298519157738545, -3.517466409063825],
            [3.2942553446346325, -3.5158075497730064],
            [3.2955532658781492, -3.5117017808919546],
            [3.29571901354734, -3.505374714874728],
            [3.290141326723685, -3.5001408972427757],
            [3.2797482673288196, -3.495079659265915],
            [3.2798071301974385, -3.4917537360026523],
            [3.275963125323069, -3.491922260740324],
            [3.276995260269711, -3.4878293575045776],
            [3.274852864119487, -3.4857544402553726],
            [3.276159732162592, -3.4797351556713028],
            [3.278223901976064, -3.475874494347134],
            [3.2759670546919804, -3.4724153532639743],
            [3.277534526117254, -3.466905268004213],
            [3.27735486493216, -3.462201473281449],
            [3.2736540277222352, -3.4618125697355495],
            [3.2720961745046506, -3.458039589291118],
            [3.273514063678662, -3.45258526934383],
            [3.2788979588232294, -3.4517711036260152],
            [3.2796080750007173, -3.449216105737699],
            [3.2848915156317244, -3.44759406234151],
            [3.286867497836975, -3.441241287774716],
            [3.291911288750135, -3.440961578369402],
            [3.2937572767548633, -3.4358063235325194],
            [3.2927286946538943, -3.432385931675474],
            [3.2883198631157056, -3.431368796855526],
            [3.28460961648644, -3.424228634010655],
            [3.2877716407117727, -3.4217982035560097],
            [3.2905086680704896, -3.4224364029180405],
            [3.3006818969706098, -3.412779788482024],
            [3.2987718278525913, -3.4107773528216128],
            [3.3004812960252226, -3.406170785449975],
            [3.304415182243965, -3.406226290729521],
            [3.3078061330565536, -3.4040655953062866],
            [3.307996613038523, -3.398805456086414],
            [3.3071235526303537, -3.3536628035224565],
            [3.306737649983099, -3.324492025514637],
            [3.307098188896947, -3.310441442621051],
            [3.3501325273271263, -3.309504382623103],
            [3.382801427964392, -3.3093254490629485],
            [3.4492562997314504, -3.308729417799734],
            [3.491948900238958, -3.308188914450585],
            [3.512258100518562, -3.30793779751697],
            [3.577335426648624, -3.3060902735154336],
            [3.5915786222161197, -3.3058781214688913],
            [3.6061242462953134, -3.3046328829842735],
            [3.6079053176035143, -3.385614534824268],
            [3.609108422808389, -3.451987828480574],
            [3.6108468195387142, -3.5477216119586097],
            [3.611680393211277, -3.602770220005574],
            [3.6124639442122417, -3.6574967008552726],
            [3.526658312673504, -3.6585368122350945],
            [3.52770118329591, -3.724245086248668],
            [3.5279372158150744, -3.746192655948134],
            [3.4562070961099947, -3.7474562244366934],
            [3.4135265241078043, -3.7480054744725475],
            [3.3993011934172914, -3.7477519107419184],
            [3.3784543771070625, -3.748040523628642],
            [3.3750061652908934, -3.7508460760536475],
            [3.3792258307229446, -3.7545613072899546],
            [3.375757903328518, -3.766498294196285],
            [3.3707716287712057, -3.769779282139002],
            [3.3675719140633684, -3.7688259258507326],
            [3.360896810666531, -3.773410206740995],
            [3.3586363437588034, -3.7773142981695553],
            [3.350350307546, -3.7774032114844367],
            [3.350245453388823, -3.779905439290274],
            [3.353095184376244, -3.7898416230346843],
            [3.3525444451285495, -3.79536617731973],
            [3.3565029443068037, -3.803719978586376],
            [3.357614817930812, -3.8122181496899272],
            [3.354029467412157, -3.823911257985233],
            [3.356162950892719, -3.827885339248343],
            [3.361680902426996, -3.833715334857281],
            [3.36335769948267, -3.8376780502136376],
            [3.3502388002161245, -3.8314128965111043],
            [3.3447994327944746, -3.827483180038771],
            [3.3397177204690727, -3.818631212103811],
            [3.339126487274974, -3.810528479109387],
            [3.3403199007945363, -3.806554173422204],
            [3.3457190377029886, -3.7967342129312196],
            [3.349249409725638, -3.7841899850214165],
            [3.349077909761047, -3.7755222762718694],
            [3.3458708457455884, -3.768538437965486],
            [3.3384096203390965, -3.759955293807703],
            [3.335611192575497, -3.753678728682822],
            [3.3333833780462525, -3.7401724195262203],
            [3.3292645087784583, -3.734185072058169],
            [3.32358047225773, -3.729833415093859],
            [3.3141683660083534, -3.7281163301188442],
            [3.303854329193644, -3.728832069846975],
            [3.2849975000165736, -3.731980321707001],
            [3.2716602403127393, -3.7303588593309915],
            [3.25780524317088, -3.726707506746166],
            [3.2471875991260757, -3.7206139962694467],
            [3.238338964870352, -3.7127969352671775],
            [3.2328025569574903, -3.705141237133006],
            [3.226612513822729, -3.6915182191515497],
            [3.2252441512721775, -3.6838929417705186],
            [3.226188627041406, -3.6780299732745974],
            [3.2301943936595277, -3.670098515655373],
            [3.2366757712617233, -3.663249241159565],
            [3.248922982837618, -3.6544543001724232],
            [3.2531285933345195, -3.6506575769752057],
            [3.262336702907197, -3.6382965031253756],
            [3.266336776299219, -3.629256616395772],
            [3.2684695408226325, -3.6223953781280884],
            [3.269764174379793, -3.6107567090721013],
            [3.26954707671483, -3.594635782783678],
            [3.2631251078431927, -3.576693725496885],
            [3.2609530152441537, -3.5722041553727237],
            [3.257475709579481, -3.569196227668209]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.33207269419805,
          "lat": 35.147006011713266
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05045"],
        "coty_name": ["Faulkner"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Faulkner County"],
        "coty_fp_code": "045",
        "coty_gnis_code": "00066852"
      },
      "bbox": [
        3.2252441512721775, -3.8376780502136376, 3.6124639442122417,
        -3.3046328829842735
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.5868450845134037, -3.963051439820331],
            [2.5859735626007767, -3.933864676341654],
            [2.6016635080043775, -3.932661991424921],
            [2.6153282219558402, -3.932108088308278],
            [2.6728373309570013, -3.930612492503371],
            [2.6873335854243616, -3.931489532235987],
            [2.845994792601462, -3.9268467454739597],
            [2.932177471969678, -3.9237786557223893],
            [2.9331954576058803, -3.967935672769142],
            [2.9346339234552374, -4.011755162837439],
            [2.9270494163690444, -4.011878357623313],
            [2.927372833262897, -4.042102717699461],
            [2.9278221349506075, -4.059788980799037],
            [2.987404440743589, -4.059518157668153],
            [3.0131916246629684, -4.059101124548266],
            [3.0134085100681456, -4.10339260821923],
            [3.06965323686737, -4.102296856514579],
            [3.0698521079313514, -4.130620967304939],
            [3.0841102460588283, -4.130406619164534],
            [3.0847162242504123, -4.189151272387991],
            [3.0277424678912337, -4.189911586858811],
            [3.0137578495120763, -4.189508759072053],
            [2.985057860529318, -4.189868036384521],
            [2.985197059038304, -4.204395051499292],
            [2.988257639260933, -4.247874565135745],
            [2.9601399015769565, -4.2481367138946435],
            [2.9619717736061735, -4.278645029248647],
            [2.9618649376268467, -4.30816944441781],
            [2.93313736450873, -4.308367298138929],
            [2.8740279386051446, -4.3093516002072345],
            [2.8190297289550315, -4.310147948232719],
            [2.731305061183714, -4.3101393092531195],
            [2.7096001539413446, -4.309950821091162],
            [2.657841870484315, -4.310267680026126],
            [2.6093110749727217, -4.310950169334553],
            [2.5859304013347035, -4.311066984757237],
            [2.5851309199658945, -4.249553920068445],
            [2.5842477437081475, -4.193899254664702],
            [2.5843303823550365, -4.183719357125967],
            [2.5833915768799782, -4.109584645963526],
            [2.5824332039555165, -4.060566927257539],
            [2.5820587040707736, -4.021706548250792],
            [2.588824695937282, -4.021533806967837],
            [2.5868450845134037, -3.963051439820331]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.15040501650138, "lat": 34.57671594699329 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05051"],
        "coty_name": ["Garland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garland County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00066855"
      },
      "bbox": [
        2.5820587040707736, -4.311066984757237, 3.0847162242504123,
        -3.9237786557223893
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.228135752027637, -3.7302516778457138],
            [4.288200407878341, -3.727511870112133],
            [4.2858430879966605, -3.6542974428715356],
            [4.330487341246058, -3.6525045737512305],
            [4.330136924372269, -3.63289061008744],
            [4.347955107919933, -3.632914840762263],
            [4.401295215945792, -3.63113046355795],
            [4.402221364435248, -3.6649164716919835],
            [4.403186908123345, -3.7086180110423306],
            [4.403758888963386, -3.7223295340302913],
            [4.411223750544686, -3.7223822096048527],
            [4.432373322728962, -3.720901876722148],
            [4.43293588181072, -3.7220540118431793],
            [4.434532422275229, -3.765806260058958],
            [4.4486581277913, -3.765091312967215],
            [4.451012250945924, -3.8242034242840046],
            [4.453485622690405, -3.898092962760886],
            [4.4967146125591135, -3.896541535011254],
            [4.497774093128641, -3.926847111132726],
            [4.499291336189532, -3.9855166948683114],
            [4.501315367637541, -4.02993095713981],
            [4.5035576512376645, -4.088975676329094],
            [4.506208729719355, -4.161263902586766],
            [4.550761816883005, -4.160389802804603],
            [4.553878222845574, -4.245119500586944],
            [4.555844582995198, -4.2940311973285565],
            [4.5119648550219, -4.296029731114395],
            [4.506465399224338, -4.296394552954001],
            [4.502350399931091, -4.295242026747144],
            [4.492328333327181, -4.28570390283133],
            [4.490197828902473, -4.288886701872337],
            [4.4863892360619, -4.288250946572781],
            [4.4807763233049585, -4.289596104664084],
            [4.479351341453682, -4.284160139361423],
            [4.4767325591005935, -4.28246622587828],
            [4.469023032755634, -4.281387200536035],
            [4.467388501189615, -4.278449734693273],
            [4.470488152449028, -4.274094466423326],
            [4.469853659261034, -4.268640689007764],
            [4.46095416121976, -4.265541621590003],
            [4.453564749034439, -4.2575964311505095],
            [4.4488399427290055, -4.254570017401839],
            [4.44946881494729, -4.249948104956868],
            [4.443831724917329, -4.240256403320157],
            [4.444218304539202, -4.236197352877088],
            [4.440709342896015, -4.233098179698224],
            [4.433837190609534, -4.23468674572048],
            [4.430397792772025, -4.233240372829547],
            [4.42640841443176, -4.2283451594600985],
            [4.420893174384851, -4.226425156547719],
            [4.41801808314601, -4.223964138615397],
            [4.418528061510626, -4.218623516328657],
            [4.425825386903231, -4.219172689027148],
            [4.427743318406995, -4.214440747154282],
            [4.4231901448329385, -4.2095557841678195],
            [4.422765492890394, -4.20422923061544],
            [4.420776409760387, -4.2012973719085505],
            [4.413718157026839, -4.202510331443982],
            [4.413998307041236, -4.197048263973609],
            [4.410758483128057, -4.193048107699088],
            [4.409171813340738, -4.186569220071206],
            [4.406286466607093, -4.185223524482917],
            [4.403419210303811, -4.187161512905652],
            [4.398488012620349, -4.196716206415274],
            [4.395553480303314, -4.198115664964389],
            [4.3877146046595925, -4.193070300427163],
            [4.3841522925992455, -4.1931853197057105],
            [4.377951649225031, -4.197175440436654],
            [4.373665444993442, -4.195221535306108],
            [4.371928314115786, -4.185488141660229],
            [4.381357349767297, -4.187743240123864],
            [4.382631165569041, -4.181758069830032],
            [4.37684374827634, -4.178105134333686],
            [4.371067284338881, -4.178601645935489],
            [4.369436714436346, -4.175272936107331],
            [4.374338979443688, -4.169406605783648],
            [4.375695752705845, -4.163003392143932],
            [4.379674727028266, -4.157604718098346],
            [4.378615184082687, -4.1543489852436934],
            [4.374055698953453, -4.151592323693733],
            [4.371048889974223, -4.152618187107291],
            [4.368509963673809, -4.158279456122772],
            [4.361344010474606, -4.159232613628587],
            [4.355097256682029, -4.152967491359222],
            [4.352345632224573, -4.151825525640462],
            [4.3458457239397, -4.153168830968806],
            [4.342342690549834, -4.150947577494001],
            [4.341485642295808, -4.147370203086385],
            [4.344374063780084, -4.141124528713059],
            [4.343715593425052, -4.137900622782098],
            [4.339610274028351, -4.1368931489527565],
            [4.333294795901966, -4.138382354760238],
            [4.331284699549587, -4.135567846905238],
            [4.335352775453665, -4.127246188757853],
            [4.334400855800356, -4.118817700176559],
            [4.335355544040663, -4.115198172807671],
            [4.333099703153739, -4.1127783964352425],
            [4.326327926715721, -4.113300248097292],
            [4.32024692634646, -4.110330008821134],
            [4.310511958194082, -4.112070585727099],
            [4.305500066144545, -4.111023620041436],
            [4.3015031017376275, -4.106765009352389],
            [4.306509670067532, -4.099476342561351],
            [4.307831170587891, -4.095811731082121],
            [4.306694548428871, -4.090534869851642],
            [4.308253200173103, -4.084832721345461],
            [4.308231991277681, -4.079749277211689],
            [4.237810873278997, -4.0814702550785125],
            [4.2370539963266705, -4.051918473245664],
            [4.207943153539454, -4.052363020439983],
            [4.207518064463196, -4.037525347170279],
            [4.178439830521923, -4.038364309909238],
            [4.177319799715527, -3.9942300205357877],
            [4.176358406672515, -3.97966393219312],
            [4.235277089937396, -3.9784016936222297],
            [4.234631156275953, -3.949066509843773],
            [4.2329774148125585, -3.9063742035644298],
            [4.232105988136961, -3.8609899082324204],
            [4.230859957364908, -3.8185942702906783],
            [4.226258303588401, -3.814802619615814],
            [4.225092597822009, -3.809350956739007],
            [4.227941164769597, -3.801231047942384],
            [4.236784608053798, -3.7998637574747054],
            [4.238527436389637, -3.7966165707351904],
            [4.23715020371448, -3.7889225769890356],
            [4.235149779218747, -3.7859363242897675],
            [4.237095889848642, -3.780940323618178],
            [4.2335239631629, -3.7758827047729118],
            [4.238077289614757, -3.7730343814438787],
            [4.243203877283275, -3.7752383903651947],
            [4.249799918891038, -3.7706353244339677],
            [4.248945004789037, -3.7652035348464987],
            [4.245532828744479, -3.7676039158223316],
            [4.23648720833895, -3.7623854056481587],
            [4.230310543841621, -3.7553890852625993],
            [4.225909845254509, -3.7467362036921648],
            [4.216974139151736, -3.7479066545442463],
            [4.214221608553283, -3.741628390072153],
            [4.2188516393543445, -3.7389152477266294],
            [4.2224980159248915, -3.7435641614441972],
            [4.225669680709399, -3.7441857930998506],
            [4.228947167601791, -3.742089924123152],
            [4.228135752027637, -3.7302516778457138]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -91.20390238987265,
          "lat": 34.677846375670555
        },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05095"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00069167"
      },
      "bbox": [
        4.176358406672515, -4.296394552954001, 4.555844582995198,
        -3.63113046355795
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.908728464737311, -2.571120457268264],
            [2.951882702251577, -2.570738773014704],
            [2.9949465577052354, -2.56977268454929],
            [2.9956840216848466, -2.613804410893347],
            [3.1250107500103406, -2.6128307683781804],
            [3.1587921175450564, -2.612443757862029],
            [3.1679101563380487, -2.6120771320440195],
            [3.251162901420208, -2.6105885768886643],
            [3.279788776625971, -2.6099722131959076],
            [3.337115235483447, -2.6091200720558065],
            [3.3381580987683086, -2.6968149653805518],
            [3.338672178994784, -2.7405280379052743],
            [3.3391960196204504, -2.755183027443103],
            [3.339284288535833, -2.7843597758461276],
            [3.3412006132754364, -2.7843480862276966],
            [3.343314368511572, -2.885418205119605],
            [3.3002741831832005, -2.8864605934926444],
            [3.2583051435635726, -2.887742147669466],
            [3.2459887007008654, -2.8876286463724448],
            [3.197547005473903, -2.8891786862793314],
            [3.1721414099005583, -2.889464792646137],
            [3.17312339243686, -2.937639226173656],
            [3.1734521317834665, -2.9624715135171367],
            [3.158943135432157, -2.962338538754974],
            [3.088647714238535, -2.962631245661645],
            [3.0299324276825157, -2.9633492163107626],
            [3.0010756429702705, -2.963667145254434],
            [2.9159772309546894, -2.9648493074789863],
            [2.9146291557959882, -2.8757959671839317],
            [2.9170595966719612, -2.875770429839742],
            [2.9165639667383534, -2.8170018315874725],
            [2.916463685751782, -2.7456787182988647],
            [2.915831108356648, -2.6971959791023985],
            [2.9150738484085608, -2.614888344797653],
            [2.9094490553061734, -2.615060116913995],
            [2.908728464737311, -2.571120457268264]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.699541966107, "lat": 35.910974979796556 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05129"],
        "coty_name": ["Searcy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Searcy County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00069180"
      },
      "bbox": [
        2.908728464737311, -2.9648493074789863, 3.343314368511572,
        -2.56977268454929
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-19.149670260662027, 3.2963408944354775],
            [-19.06861318045296, 3.2735083084531227],
            [-18.99973824407035, 3.255465889565975],
            [-18.943800976705692, 3.241079887711494],
            [-18.946204722887757, 3.238998250132404],
            [-18.94365566543507, 3.2315729628315686],
            [-18.941781681497183, 3.230016485830086],
            [-18.943956103689654, 3.2273297365450047],
            [-18.948583952987192, 3.227853840063305],
            [-18.947996703955575, 3.221321168482465],
            [-18.948577112915, 3.2149914823914525],
            [-18.946069460191868, 3.210333137596009],
            [-18.94818919008285, 3.206982838006954],
            [-18.953087262382567, 3.209935433787152],
            [-18.954881569291135, 3.2072389645467285],
            [-18.953024964676402, 3.202633476303288],
            [-18.949224777170677, 3.197655011480219],
            [-18.95395531048405, 3.1955039616673573],
            [-18.95785458821845, 3.1992509537936975],
            [-18.96001070152508, 3.198964484905883],
            [-18.962152645181128, 3.1892975118454805],
            [-18.964425898369402, 3.184453345817403],
            [-18.964641321656643, 3.1779607801108987],
            [-18.961365762127485, 3.173996708796616],
            [-18.96305124570482, 3.167815720251587],
            [-18.960807329619406, 3.164220157427891],
            [-18.955426508624992, 3.1649234950307235],
            [-18.952772692713932, 3.1631133150635846],
            [-18.9577722665448, 3.156022486973356],
            [-18.956137836085496, 3.1491703644543114],
            [-18.970140902560157, 3.142378746083814],
            [-18.968121814952077, 3.136622679168507],
            [-18.968672852483497, 3.133621494605019],
            [-18.962143835399562, 3.1258235946537862],
            [-18.967958340630567, 3.119892133340279],
            [-18.967679442705826, 3.114566079888166],
            [-18.964699601830482, 3.1109340369720537],
            [-18.96663965027166, 3.1068087898783223],
            [-18.97011572330308, 3.1041844241601106],
            [-18.9689718271297, 3.0994919911543173],
            [-18.96783792900599, 3.08330314616975],
            [-18.970420593623597, 3.080505348600331],
            [-18.971401865064596, 3.0763748921443668],
            [-18.968914278910503, 3.06976624421233],
            [-18.967591431747792, 3.0616203284830634],
            [-18.970654423555487, 3.0564341393436343],
            [-18.976780369367674, 3.048434903689963],
            [-18.976655435334273, 3.039419253661253],
            [-18.978721165314663, 3.035786284399417],
            [-18.973690738854124, 3.0336559467717694],
            [-18.970188259173526, 3.0356913206037404],
            [-18.967001048595954, 3.034078863632203],
            [-18.96910748077402, 3.022189231769915],
            [-18.973709213012246, 3.0174035599160938],
            [-18.981624592071654, 3.011046214514347],
            [-18.988464014276865, 3.002399022535832],
            [-18.99309639296979, 2.999028064848396],
            [-18.995956055220375, 2.9953001316392474],
            [-18.999188291028585, 2.9752285575539497],
            [-18.999058325604945, 2.970759713862348],
            [-18.993284568763002, 2.959837592162755],
            [-18.99393862571245, 2.956818169515188],
            [-19.000420382002194, 2.9496688676075755],
            [-18.996256557500278, 2.9466570743389977],
            [-18.98926252563411, 2.9439274595968703],
            [-18.98627628743631, 2.9410295709611978],
            [-18.98838017246209, 2.937146996426862],
            [-18.99576646305088, 2.9303559392899197],
            [-18.998373792126575, 2.926341215334855],
            [-18.999042280450574, 2.915680257054886],
            [-19.001425574914858, 2.909430042174163],
            [-18.999199270676797, 2.9003615505572977],
            [-18.999539927159457, 2.8962733682890915],
            [-19.002625512354886, 2.891268765296454],
            [-19.001582835063104, 2.881646632025622],
            [-19.007703835013622, 2.871699700266668],
            [-19.00958272404671, 2.860550494418166],
            [-19.005804489466225, 2.8593695409703797],
            [-18.99874200156545, 2.872649666184],
            [-18.98754864806171, 2.8847548175161934],
            [-18.981558732596504, 2.8834388432764855],
            [-18.968976097249918, 2.8994827600321],
            [-18.955377715323195, 2.8947700378641517],
            [-18.94074757043966, 2.902586898927644],
            [-18.928956285165608, 2.9009293081918752],
            [-18.922932803875756, 2.905900836718946],
            [-18.91785497929287, 2.90750136931465],
            [-18.91253719423121, 2.9046549104384756],
            [-18.90451770483126, 2.906478436565355],
            [-18.897498376903453, 2.906823294190919],
            [-18.89207500789317, 2.904160769897645],
            [-18.889527031551285, 2.899552134480793],
            [-18.8847699016264, 2.8985659508723907],
            [-18.872571634786212, 2.898053489329199],
            [-18.867128320647936, 2.8966893712400266],
            [-18.885583970535848, 2.8283010882735486],
            [-18.92647971814554, 2.8392716668157636],
            [-18.93432941666981, 2.8110498485029236],
            [-18.948330107862144, 2.76165720957566],
            [-18.961649222837227, 2.7121291956228455],
            [-18.97334536639548, 2.67009004490466],
            [-18.98440306615044, 2.6725120391179047],
            [-18.988852678270764, 2.656206284678038],
            [-19.016207038968773, 2.6656056403852584],
            [-19.043431602668427, 2.672998348905089],
            [-19.05044366399123, 2.674384993379469],
            [-19.076777339212512, 2.6816935548696983],
            [-19.07415311497, 2.6859923418077765],
            [-19.06777816151317, 2.6928228565723424],
            [-19.064837122503736, 2.6973890594453342],
            [-19.061869463239436, 2.705856908684979],
            [-19.06401249133838, 2.7190201218280317],
            [-19.06856068441621, 2.726535621081171],
            [-19.072579945913155, 2.7285484439815333],
            [-19.08013676036025, 2.734415386899361],
            [-19.08484039417357, 2.733441151622628],
            [-19.083771238295547, 2.7289855620475247],
            [-19.087227246558577, 2.7267262455039383],
            [-19.090727811020802, 2.719701428436946],
            [-19.093166003542976, 2.7192487749698953],
            [-19.094766009864845, 2.7252942525784962],
            [-19.099693282022553, 2.7250469822425343],
            [-19.095099052914303, 2.72009446624999],
            [-19.105893609177127, 2.719772987027397],
            [-19.1084469379469, 2.7210290709082594],
            [-19.10941047504809, 2.7260568699809498],
            [-19.11179059628635, 2.7269251537875405],
            [-19.114566928304527, 2.722911265857915],
            [-19.11246029167705, 2.717911621213237],
            [-19.112916896782554, 2.7120058416707566],
            [-19.116960960615398, 2.7136093693058245],
            [-19.12132541819916, 2.7122553176400315],
            [-19.124321756133458, 2.704226050817837],
            [-19.127979386976012, 2.7040539918222946],
            [-19.12872226293824, 2.710102398797951],
            [-19.12729958052485, 2.712600482946667],
            [-19.120433709720373, 2.718311955425863],
            [-19.12579984380402, 2.721218379157349],
            [-19.126955387848767, 2.724446403460683],
            [-19.131232268112992, 2.725549175947475],
            [-19.134699472104046, 2.7305411770747203],
            [-19.12832850964288, 2.737292847879149],
            [-19.128089704498944, 2.744311923944665],
            [-19.129586168891603, 2.752769918084451],
            [-19.126134293254697, 2.7570587706901044],
            [-19.13002047973643, 2.7607864175548693],
            [-19.13188676546403, 2.7672339748401433],
            [-19.137064212182096, 2.766583970833255],
            [-19.14812234637333, 2.772496400232607],
            [-19.144958221936797, 2.7869284254012316],
            [-19.14227231484848, 2.793752092893754],
            [-19.143371520179763, 2.8002086725785014],
            [-19.145197769991025, 2.8040211221842397],
            [-19.143428506232354, 2.8083513598279417],
            [-19.139951773951044, 2.8094746151339796],
            [-19.140020760480443, 2.81589364110317],
            [-19.135847149095728, 2.817936323991754],
            [-19.138300311597746, 2.8217371156026676],
            [-19.13846977476483, 2.8277265895872254],
            [-19.143465913340215, 2.8309338359376572],
            [-19.147762444243078, 2.8356084697480175],
            [-19.148122363479047, 2.8418205563110326],
            [-19.14952072194384, 2.843514645043502],
            [-19.15840163221629, 2.841739954176984],
            [-19.15804795208057, 2.836846009110888],
            [-19.16298051273374, 2.839864587538572],
            [-19.16720926648026, 2.838264843393379],
            [-19.17225333543043, 2.8394592883186176],
            [-19.179103874693006, 2.8364895956909706],
            [-19.17814841496626, 2.8424124786553344],
            [-19.18041853420216, 2.844743102375468],
            [-19.183907406020857, 2.844405192344619],
            [-19.185106263883384, 2.84859778442314],
            [-19.190020765733294, 2.847475679758875],
            [-19.19007839329943, 2.853501275624148],
            [-19.193907445504557, 2.8567579453022254],
            [-19.19641202747436, 2.862128478358075],
            [-19.19650719007888, 2.8687414451324273],
            [-19.195266115099326, 2.8705746158627665],
            [-19.189188595202726, 2.871798595535745],
            [-19.182064086834906, 2.879950319183514],
            [-19.18156485278683, 2.8843135766690713],
            [-19.174898771590247, 2.88122131443889],
            [-19.171543295823334, 2.8832060416605376],
            [-19.171837562265146, 2.8864687490365704],
            [-19.175477798310048, 2.886542565014396],
            [-19.182939157759517, 2.8901492323542413],
            [-19.183012972010555, 2.8935978578384436],
            [-19.17870453388911, 2.8969176335714497],
            [-19.184687886350208, 2.8994690642611327],
            [-19.18862833129694, 2.902762256442046],
            [-19.196185260302904, 2.9065303729758782],
            [-19.198782413805326, 2.9129290172810234],
            [-19.199694566725814, 2.916189375125055],
            [-19.19507360764403, 2.921971034597098],
            [-19.191029183965917, 2.9253674685057267],
            [-19.194340809579398, 2.931932413752521],
            [-19.19292447329362, 2.9370986528690715],
            [-19.194264175205735, 2.9431158643639486],
            [-19.18663058285843, 2.9469533111479977],
            [-19.187093452674688, 2.952307536453504],
            [-19.183604842473706, 2.957566778727314],
            [-19.174937201664207, 2.9586541312901193],
            [-19.171381185052912, 2.968835223752854],
            [-19.169638410539736, 2.9715993317998337],
            [-19.156325266289485, 2.969454729205298],
            [-19.15041784856793, 2.972852290041968],
            [-19.149636932032706, 2.9748289536811154],
            [-19.153727269679564, 2.9796959298141648],
            [-19.15512029940084, 2.983219899787442],
            [-19.160108964610238, 2.987435004037424],
            [-19.16529006292708, 2.989454847934729],
            [-19.16835507235829, 2.9946574988584596],
            [-19.167465140286254, 2.998010428011758],
            [-19.16206162945601, 3.0029848759621083],
            [-19.161458627841668, 3.014855601457154],
            [-19.16485304815193, 3.016158024230536],
            [-19.163911731041793, 3.0227139593468846],
            [-19.168499532502604, 3.030745981740932],
            [-19.168296043113077, 3.03758474543911],
            [-19.163263564579385, 3.0479837362609317],
            [-19.168354298217572, 3.0576319222776003],
            [-19.170930889318882, 3.059073772925205],
            [-19.177583873565037, 3.057734642681527],
            [-19.185254524216013, 3.0582581082038267],
            [-19.189379968737533, 3.062715748531011],
            [-19.198400137657806, 3.0676344776498454],
            [-19.20059281842818, 3.0741395018583413],
            [-19.196483714411926, 3.076303096619589],
            [-19.198898415778746, 3.0837472128619487],
            [-19.19638192202055, 3.0873693206919977],
            [-19.195848408858982, 3.09178643629928],
            [-19.198764137368634, 3.0931892844334814],
            [-19.198931145830432, 3.0967676788876797],
            [-19.202209824481073, 3.102007967833421],
            [-19.199382665193134, 3.1052625831106724],
            [-19.199048781704214, 3.1121910942934434],
            [-19.20248247709908, 3.1113501507990713],
            [-19.20068271450661, 3.119348571901887],
            [-19.201580556231498, 3.122433873288002],
            [-19.209159132058687, 3.123247901904699],
            [-19.209771570923746, 3.1292444055776376],
            [-19.215906374660744, 3.132888638004706],
            [-19.21807902465248, 3.1365943898601167],
            [-19.21698642516663, 3.144994455111266],
            [-19.214142072989407, 3.1472300855705044],
            [-19.210922937467874, 3.144442137879478],
            [-19.20152742027239, 3.1416554789526434],
            [-19.198852351656285, 3.146168445456309],
            [-19.19945197864722, 3.1523170346048004],
            [-19.207969733681285, 3.16402104385643],
            [-19.207927670269942, 3.176896209932992],
            [-19.210923018124966, 3.183628922980875],
            [-19.208728862851743, 3.1871859684792],
            [-19.204433497590678, 3.1901850542790013],
            [-19.200691582126243, 3.1907189287903943],
            [-19.200834020249808, 3.195702508016139],
            [-19.193081464870875, 3.198412150837396],
            [-19.193914219856165, 3.209675055952449],
            [-19.192607432242728, 3.211721568010352],
            [-19.19640335089578, 3.2232598689617125],
            [-19.19359302607904, 3.2298987708301428],
            [-19.196410948717702, 3.2429464993064725],
            [-19.190808779833805, 3.254688186845223],
            [-19.187764231092377, 3.2569730716062995],
            [-19.185359427689605, 3.262854149008148],
            [-19.18059196693562, 3.2673747530537853],
            [-19.174447601514007, 3.2684400682718935],
            [-19.171981939974856, 3.272601318811071],
            [-19.164966917584305, 3.2773288231766275],
            [-19.16455467178458, 3.282821231678024],
            [-19.15909566868968, 3.286653249352544],
            [-19.158243400643265, 3.290201698965088],
            [-19.149670260662027, 3.2963408944354775]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.69483215893013,
          "lat": 39.03453674142288
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06101"],
        "coty_name": ["Sutter"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sutter County"],
        "coty_fp_code": "101",
        "coty_gnis_code": "00277315"
      },
      "bbox": [
        -19.21807902465248, 2.656206284678038, -18.867128320647936,
        3.2963408944354775
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-8.55568756830938, 0.1493008358515986],
            [-8.451531358659393, 0.1365918221173796],
            [-8.435891867159171, 0.26766949452515054],
            [-8.434335010916989, 0.28183511213223567],
            [-8.407333313373782, 0.5041500994500081],
            [-8.39137519728179, 0.6350988156052262],
            [-8.376965960000973, 0.7537490114932206],
            [-8.340342068121204, 1.0547090070827696],
            [-8.33601095491262, 1.0544967740895457],
            [-8.32961422170348, 1.0612278991707613],
            [-8.325885608882531, 1.070544633833021],
            [-8.321783525462196, 1.068352767408503],
            [-8.319254219186758, 1.0634652552836685],
            [-8.310788463123208, 1.0617962564439638],
            [-8.301060603662131, 1.0629149575345034],
            [-8.282998394250455, 1.0724811745075808],
            [-8.283487472903454, 1.077027068502109],
            [-8.282140630711528, 1.0808763211978558],
            [-8.282275443726565, 1.0869075086827558],
            [-8.277467907319531, 1.0874370320805897],
            [-8.275859267811589, 1.0851870100717838],
            [-8.270431981140325, 1.0845532973714276],
            [-8.26486835555554, 1.0816617597993232],
            [-8.259690779728142, 1.0805638699067135],
            [-8.254860720420703, 1.0833908849100593],
            [-8.252454970860272, 1.0772980280750482],
            [-8.242122208201021, 1.071134106108383],
            [-8.242276566411826, 1.0682450303440607],
            [-8.2394277425855, 1.0641968294594242],
            [-8.242902436763064, 1.0623352147067855],
            [-8.246257497293286, 1.056980308627289],
            [-8.245757828155705, 1.0457612162610574],
            [-8.249860016159284, 1.0359505502882633],
            [-8.247905772040086, 1.0295187884440755],
            [-8.247521102096554, 1.0231660122856303],
            [-8.24159244298868, 1.0164651181558426],
            [-8.239712279407541, 1.0104268707973676],
            [-8.237084723475215, 1.0086696579761225],
            [-8.233772633845918, 0.9993059638955571],
            [-8.233610662333678, 0.9961907377545937],
            [-8.226082978497073, 0.9906222583920214],
            [-8.221621201121073, 0.9907116815888879],
            [-8.219700055323006, 0.9878137745050948],
            [-8.21534985802073, 0.9861703559521946],
            [-8.208092281091355, 0.985275268597037],
            [-8.203133863952411, 0.9787623577724468],
            [-8.19766801657892, 0.9741574377064751],
            [-8.195150744307403, 0.974852002213898],
            [-8.191908948550166, 0.9714841351429322],
            [-8.191567362776047, 0.9623537315560187],
            [-8.187856151499824, 0.9568836223869644],
            [-8.186861833171161, 0.9478004254593851],
            [-8.185708170013484, 0.9449657206901356],
            [-8.187470116756728, 0.941813896312762],
            [-8.185219968670681, 0.9357853272854557],
            [-8.179869970886076, 0.9345396386096074],
            [-8.021039922794031, 0.9158728885087325],
            [-8.017163789047682, 0.9084606977634562],
            [-8.01201552436088, 0.9064514934080549],
            [-8.009210124599887, 0.899731030901595],
            [-8.003811861152082, 0.8938169785030883],
            [-8.000942470222236, 0.8892583444942747],
            [-7.9959012949443435, 0.8856063322262262],
            [-7.988790853652056, 0.882193427549476],
            [-7.982941746580043, 0.875087393038861],
            [-7.979556965497353, 0.8672491366305065],
            [-7.973861449955006, 0.8601080226484673],
            [-7.967602525219163, 0.8607671732418515],
            [-7.966597694928654, 0.8522741730267749],
            [-7.970280102830423, 0.8502331823679707],
            [-7.9703833110456985, 0.8420527124377304],
            [-7.976099980323408, 0.8400368071863581],
            [-7.979034448607304, 0.8336996035795687],
            [-7.980581135623398, 0.8333722588087819],
            [-7.977339854628765, 0.8247652857511076],
            [-7.971516378871883, 0.8206556904863805],
            [-7.965036478824851, 0.819867991271667],
            [-7.960867266919567, 0.8174757581734526],
            [-7.955710225626236, 0.8188789952811457],
            [-7.953388208801727, 0.8162317978379384],
            [-7.954975718166928, 0.811142183928309],
            [-7.955237654510224, 0.8052993459774177],
            [-7.9504377903172925, 0.8026772329174529],
            [-7.944863283635908, 0.8031376505214959],
            [-7.94026727538704, 0.8003975695243507],
            [-7.933916685848384, 0.7911785484639616],
            [-7.928990677581611, 0.7890658012861043],
            [-7.92157148675744, 0.7827470479158443],
            [-7.91551230428114, 0.7828683677896178],
            [-7.913633832540956, 0.7746235152522379],
            [-7.9089272770403785, 0.7744877448017333],
            [-7.903767412526314, 0.7708794687979518],
            [-7.902114743006034, 0.7722105465189613],
            [-7.89695097584148, 0.7709904676985294],
            [-7.891677562746721, 0.774315866309463],
            [-7.889942566665233, 0.779925082935837],
            [-7.8911699287367085, 0.7829836779037974],
            [-7.889031308606104, 0.7868819354757701],
            [-7.882359438532297, 0.7860331482157084],
            [-7.877424963045991, 0.7880884121784993],
            [-7.874886531970274, 0.7781962731628868],
            [-7.871091021779389, 0.7713925841773747],
            [-7.868696389403099, 0.7642924234314713],
            [-7.860691282166218, 0.7598919702918981],
            [-7.8597448339965235, 0.7570044064447384],
            [-7.854732816676275, 0.7532563393892713],
            [-7.846419862196158, 0.7560279143953555],
            [-7.841951582078452, 0.7527727725606996],
            [-7.835255563175003, 0.7516231021026085],
            [-7.8335667708565095, 0.7553658155301319],
            [-7.828949369788269, 0.7575307283867614],
            [-7.823685287933138, 0.7564265317201764],
            [-7.818794024276585, 0.7623864238746323],
            [-7.819366246993719, 0.7676042340579932],
            [-7.81445824603758, 0.7725970742874952],
            [-7.811527750589524, 0.7771883419846541],
            [-7.807338244204515, 0.778035442227484],
            [-7.800126911758085, 0.7861118226878265],
            [-7.791186649699026, 0.7948599807078062],
            [-7.786440023637376, 0.7953613634242653],
            [-7.785872503242249, 0.7981702639887908],
            [-7.786385540792533, 0.8087687687163414],
            [-7.780756077136096, 0.814110027359162],
            [-7.776217915187094, 0.8125883171530986],
            [-7.772131413375122, 0.8137119528910326],
            [-7.767057245867967, 0.8117958110324608],
            [-7.7625401609654245, 0.8144744122273735],
            [-7.757346236081701, 0.8131509254651431],
            [-7.754794923833164, 0.8188412609328687],
            [-7.7508428226137385, 0.820892520654476],
            [-7.743259377532318, 0.8191698043373653],
            [-7.738484898203667, 0.808794196966589],
            [-7.729829495223591, 0.808252428106194],
            [-7.727611223182691, 0.8059978753171197],
            [-7.721714100015765, 0.8033654552739087],
            [-7.7157979349553765, 0.8052583221784371],
            [-7.713918610352322, 0.7994521635053161],
            [-7.71119512889441, 0.7962320939843732],
            [-7.710476755221583, 0.790870587090873],
            [-7.713435997979081, 0.7876569345820198],
            [-7.712884170643281, 0.7823080184168556],
            [-7.705523506298589, 0.7785047470819297],
            [-7.705691293926122, 0.7739327132871247],
            [-7.6999721061143935, 0.7707565268746484],
            [-7.696450890807403, 0.7616498452563598],
            [-7.692848591214423, 0.7601870508134881],
            [-7.689168249747615, 0.7560144452221541],
            [-7.687755826727277, 0.7523431375782453],
            [-7.677993143395466, 0.7538499794722916],
            [-7.675913445100584, 0.7467935251113033],
            [-7.669093242965883, 0.7474699054692079],
            [-7.661969886386804, 0.7443878991102503],
            [-7.659836671647644, 0.7465642373746231],
            [-7.653154695767242, 0.7468044577917009],
            [-7.64829539619373, 0.7507724967830651],
            [-7.6437270197341505, 0.7507962936749101],
            [-7.642520820227531, 0.7452972686782557],
            [-7.638641599908691, 0.7424290165166753],
            [-7.63129576485353, 0.7339040255928775],
            [-7.625739996965072, 0.7304782004574993],
            [-7.6237800925384, 0.7204740353398529],
            [-7.6220900918149495, 0.7178208190869106],
            [-7.624267719225786, 0.7135313985439964],
            [-7.628159898524654, 0.7095738805167019],
            [-7.627259769553269, 0.7049310626262172],
            [-7.622210762662549, 0.7029049841259462],
            [-7.619633792004626, 0.6972298192933721],
            [-7.612127739985646, 0.6920650493801778],
            [-7.612247440814646, 0.6844080667095984],
            [-7.606411386894446, 0.6803283530459666],
            [-7.602587122562769, 0.6760596817716387],
            [-7.602367550645825, 0.6726131717673165],
            [-7.596302521447944, 0.6641472896525505],
            [-7.589943747655049, 0.6606847206664068],
            [-7.585064903484813, 0.6544843210959185],
            [-7.579564169595665, 0.6535960895158393],
            [-7.576201119945019, 0.6559438128510124],
            [-7.566959085711623, 0.6577871839594023],
            [-7.563222297312903, 0.6566965914640259],
            [-7.556820908079837, 0.6661513433695725],
            [-7.550014690801903, 0.6686103888816847],
            [-7.547413377038412, 0.6668634861418642],
            [-7.547244567675501, 0.6610229047056292],
            [-7.5439243833777585, 0.6553424822722275],
            [-7.540585464256929, 0.654058159850086],
            [-7.536846388668978, 0.6494371615818447],
            [-7.530411662856628, 0.6503880064822046],
            [-7.52845545372405, 0.6568015643666114],
            [-7.518605004061841, 0.6619123797696028],
            [-7.516259414232604, 0.6594238390541975],
            [-7.5171222846813945, 0.6461777389103267],
            [-7.515313373061004, 0.6430026035471819],
            [-7.51071482355926, 0.6428127120921463],
            [-7.505569909603879, 0.6477563030425172],
            [-7.50207823829803, 0.6479897153112874],
            [-7.493658736699429, 0.641099279016684],
            [-7.48802794589464, 0.6421630262119832],
            [-7.485296408907404, 0.6448568005121169],
            [-7.478562009649353, 0.6434496382000493],
            [-7.478389478907301, 0.63522981685672],
            [-7.47620775403431, 0.6278126228302363],
            [-7.476909438982358, 0.6245772270832646],
            [-7.481613493984349, 0.6197267460894005],
            [-7.482782507087342, 0.6147548472272446],
            [-7.487918465771635, 0.6143118427489768],
            [-7.492612837269591, 0.6050885218791316],
            [-7.501094629209574, 0.5993008051402109],
            [-7.502429750676412, 0.5893806006109007],
            [-7.508266711114584, 0.5901377448803429],
            [-7.5145807897177646, 0.5885566995068378],
            [-7.5150452919560875, 0.5818411101072706],
            [-7.52029850576743, 0.5745956175088556],
            [-7.527453693716589, 0.5717364317795564],
            [-7.530997239803512, 0.5680652300248495],
            [-7.532097079100169, 0.5617533736847955],
            [-7.538210125653237, 0.5603500251628571],
            [-7.542970261520791, 0.5612525567275531],
            [-7.549540261477318, 0.5682720128422676],
            [-7.557259721316217, 0.5635506725057129],
            [-7.557271675898311, 0.5548490377945485],
            [-7.561900851866929, 0.5516275927017461],
            [-7.563926635887826, 0.5485656331326689],
            [-7.56108168647123, 0.5404473589408534],
            [-7.558705280896499, 0.5386084066607693],
            [-7.558293931827655, 0.5302065061331475],
            [-7.561508384722747, 0.5272203143275324],
            [-7.560324657583541, 0.5184255977653034],
            [-7.562350063231115, 0.5118915283295361],
            [-7.5659481763755645, 0.5057448722787083],
            [-7.564496850032196, 0.5039954599084892],
            [-7.563738429484219, 0.4964562111555762],
            [-7.568079590437458, 0.4912800974132072],
            [-7.567150874565816, 0.4887613294991615],
            [-7.567638131268877, 0.48158053089870534],
            [-7.569559794506826, 0.4785181457156504],
            [-7.567585037719323, 0.47317209522505077],
            [-7.568999010260351, 0.46511908836861665],
            [-7.574168187992182, 0.4607838266681209],
            [-7.574497330301364, 0.4560650986455239],
            [-7.576721844867528, 0.45035845386084106],
            [-7.581800253962845, 0.44929361941676543],
            [-7.590835021113141, 0.45082105937135014],
            [-7.595014156736227, 0.4469110895939577],
            [-7.5984740145112255, 0.44060372758870475],
            [-7.598179409153508, 0.4375460204221146],
            [-7.594971258198988, 0.43071389809407135],
            [-7.590762276706318, 0.4280980303635185],
            [-7.589467084090183, 0.42351601278365053],
            [-7.590278309542054, 0.41764759676080393],
            [-7.58922142097106, 0.41195921830864046],
            [-7.586736454959661, 0.4084051958766136],
            [-7.585476722588696, 0.39780231375614594],
            [-7.586759166338821, 0.3937258704159852],
            [-7.581074281950841, 0.38631502757583924],
            [-7.577758829185409, 0.38405051241467203],
            [-7.570320064417446, 0.38603594592639884],
            [-7.56574319814279, 0.38360692708308913],
            [-7.5660063335214165, 0.3774587342158973],
            [-7.557382213095818, 0.3778647290836421],
            [-7.550282993556979, 0.3730461399057161],
            [-7.55450022517835, 0.3687395601727796],
            [-7.55546063599691, 0.36136159517760763],
            [-7.551214377129505, 0.35594190182235863],
            [-7.5483476198640345, 0.3567511067594204],
            [-7.540988400578879, 0.35053593174128744],
            [-7.5403774379818165, 0.34470454239795767],
            [-7.541662340507144, 0.3404418395098559],
            [-7.5382369801633695, 0.3334684625233891],
            [-7.540098595604241, 0.33010378965579357],
            [-7.53381428529246, 0.3168309428953992],
            [-7.53566782639716, 0.3149787384276199],
            [-7.534824106050304, 0.31025254105831424],
            [-7.5303100423783755, 0.3012866236062194],
            [-7.532419968850381, 0.2980026615961175],
            [-7.532930583941978, 0.2917200890301776],
            [-7.539212230563208, 0.2833756292952056],
            [-7.541473576010628, 0.2759010114063683],
            [-7.540525923981149, 0.2725966340502995],
            [-7.541535489846562, 0.2667789499717782],
            [-7.536610511155724, 0.261544526646086],
            [-7.533910925915129, 0.25391158048787316],
            [-7.535209944482791, 0.24991219748617977],
            [-7.539147277226035, 0.24530321618213596],
            [-7.536131859485999, 0.2352029088655304],
            [-7.533254121679498, 0.23254212976852556],
            [-7.531794626079071, 0.2284009308039276],
            [-7.527242493259488, 0.2250396009017764],
            [-7.524695855000288, 0.22857899523475603],
            [-7.519199479814313, 0.2280842454569589],
            [-7.518098536678542, 0.22538829518120498],
            [-7.512806884791107, 0.22430082325257716],
            [-7.511932308519834, 0.21741127393055518],
            [-7.509278046185392, 0.2073610372829427],
            [-7.505966612496851, 0.20432422193622918],
            [-7.4990553865549865, 0.20134820987617744],
            [-7.4990760830952885, 0.18960462396561925],
            [-7.493490564493769, 0.18125094004318462],
            [-7.48726456948667, 0.18144761554095132],
            [-7.4876493055526865, 0.17496851681539355],
            [-7.4836537707362085, 0.16738354392587704],
            [-7.479932691121639, 0.1676098728642649],
            [-7.468120517974119, 0.1628264733589066],
            [-7.471785777676078, 0.15747341706212584],
            [-7.4709620567479265, 0.1467439381046161],
            [-7.711468048632128, 0.17486177171205242],
            [-7.951978645876826, 0.20293910381234362],
            [-8.011070567403824, 0.20978434233078258],
            [-8.051707331579024, 0.2148267632537607],
            [-8.056548225868372, 0.17319604623669627],
            [-8.084591373050252, -0.06452297020501453],
            [-8.128817277331521, -0.05931558773243264],
            [-8.323825634255273, -0.0359921211624054],
            [-8.518836766194367, -0.012691858359971761],
            [-8.52341349044877, -0.011975490337473946],
            [-8.520095603559168, -0.009781962000821626],
            [-8.517219584545925, -0.0019155354146154406],
            [-8.517690466298461, 0.007058001047936686],
            [-8.519961658435376, 0.012223076220718793],
            [-8.518224282354108, 0.017277367498419727],
            [-8.520499780192342, 0.022345369747391337],
            [-8.521365577655928, 0.028638814008450295],
            [-8.520759565245262, 0.03530866709834971],
            [-8.522213694037916, 0.040987439662902116],
            [-8.521119117046407, 0.051358641421836874],
            [-8.524814645935967, 0.05452028526539398],
            [-8.52419004036624, 0.060171523706277145],
            [-8.522196303259383, 0.06457977029742941],
            [-8.522142952756267, 0.07287587131897506],
            [-8.52657588337901, 0.08298609335444058],
            [-8.525591022436359, 0.08571607833049859],
            [-8.527610784535804, 0.09513613174041713],
            [-8.534683943736928, 0.09788449308117432],
            [-8.542638499844193, 0.10591320343161373],
            [-8.545430875522475, 0.11832143082274159],
            [-8.550273233473417, 0.12606371468544258],
            [-8.551106844702211, 0.1325341461341206],
            [-8.552940613501395, 0.1346835426765297],
            [-8.552464715555093, 0.14103064338850893],
            [-8.55568756830938, 0.1493008358515986]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -107.03158176500159,
          "lat": 38.66672426384473
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08051"],
        "coty_name": ["Gunnison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gunnison County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00198141"
      },
      "bbox": [
        -8.55568756830938, -0.06452297020501453, -7.468120517974119,
        1.0874370320805897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.645155652885323, 2.784908548505112],
            [-7.494980508764134, 2.767730701451386],
            [-7.344809283207848, 2.7505186576008445],
            [-7.29468959523666, 2.744082912496167],
            [-7.246406076305771, 2.7367605669255215],
            [-7.1694706294964305, 2.7270175767608134],
            [-7.149376741244706, 2.7247257458641587],
            [-7.153790358195556, 2.717431602591621],
            [-7.153792898159523, 2.7143907915090866],
            [-7.151040868635628, 2.7056907864844475],
            [-7.151409045805245, 2.700106999896556],
            [-7.1496561812963915, 2.6979715167097353],
            [-7.150781278613715, 2.691749745096821],
            [-7.148770009246961, 2.6904445641345367],
            [-7.151217782457827, 2.685529871537442],
            [-7.149239894835666, 2.6817584148922298],
            [-7.154018042638846, 2.6728361196382737],
            [-7.15233507264253, 2.6605790830047034],
            [-7.14860530434196, 2.657694244990421],
            [-7.144481773574488, 2.6504251702227157],
            [-7.141446518199383, 2.6481593410707234],
            [-7.14124688788995, 2.643609302227918],
            [-7.134788341289434, 2.6387305475434597],
            [-7.134916900753576, 2.635049483433489],
            [-7.132096395757923, 2.633533526630356],
            [-7.127608788345085, 2.6282071452313134],
            [-7.124739829925213, 2.6281654734140996],
            [-7.119711537385344, 2.624717844172903],
            [-7.115811255474215, 2.617681137489151],
            [-7.116612081652993, 2.6151032401496925],
            [-7.114626080316843, 2.6068112871965448],
            [-7.117103133352782, 2.600311252184106],
            [-7.119104055551055, 2.5988433011003726],
            [-7.115730136408532, 2.591393652059348],
            [-7.110228423892617, 2.5869763049118832],
            [-7.102618526967223, 2.5836131596461773],
            [-7.099971511541422, 2.579283366814994],
            [-7.102020507509187, 2.5742455506140485],
            [-7.096690446859133, 2.56928131132834],
            [-7.0993989217820515, 2.563315618564424],
            [-7.093293869365396, 2.5599053538232988],
            [-7.090528654683538, 2.552076976943702],
            [-7.085533801417107, 2.549012587029182],
            [-7.082517450080031, 2.545674592110609],
            [-7.079326935560978, 2.5396677483825965],
            [-7.074569510383058, 2.5383883218704617],
            [-7.069733421893853, 2.5333693552857652],
            [-7.065946521968548, 2.5248834556202504],
            [-7.066928501020687, 2.521665353898451],
            [-7.0637899547885254, 2.5200974763463417],
            [-7.062235445237247, 2.512879863736575],
            [-7.063209750863303, 2.507081215887878],
            [-7.059588806097668, 2.5005200109395735],
            [-7.056295484530616, 2.49995947990466],
            [-7.052593631032381, 2.4955259511889087],
            [-7.053129799042047, 2.4873492954204135],
            [-7.049806806193608, 2.4847970345967094],
            [-7.05040769580591, 2.4747931404686576],
            [-7.048320256215801, 2.471635030451471],
            [-7.049898829453829, 2.468012412492804],
            [-7.044877311453063, 2.465583798410305],
            [-7.04456989880169, 2.4592975553796736],
            [-7.03957273575224, 2.449625158269343],
            [-7.032773082757532, 2.444355091289878],
            [-7.029150926321442, 2.4379483460649762],
            [-7.027896986940515, 2.431927102406915],
            [-7.02971335364073, 2.4290229966048655],
            [-7.029634775805611, 2.420191072073551],
            [-7.025240767441955, 2.416776428502649],
            [-7.021659537526661, 2.412301613860989],
            [-7.018832825224485, 2.404062974721664],
            [-7.020455441146946, 2.398623077938962],
            [-7.018113092098898, 2.3953275993891667],
            [-7.019959774727365, 2.391054195051306],
            [-7.01671678719119, 2.38445584614436],
            [-7.016290561652645, 2.37683744336995],
            [-7.012052383869729, 2.3711256971181487],
            [-7.010382999600736, 2.3667388998703234],
            [-7.011440286732378, 2.3629080813048406],
            [-7.010156571300883, 2.3546796373648093],
            [-7.006638441303449, 2.3495890338406156],
            [-7.006989247797187, 2.3432092696748663],
            [-7.008799729922757, 2.3346174438019993],
            [-7.006339152890751, 2.328148176398677],
            [-7.0082437086485525, 2.323785773012506],
            [-7.005335418306231, 2.315766632954767],
            [-7.000110124780619, 2.3125362229085753],
            [-6.996763885825294, 2.311942319124265],
            [-6.995854061464912, 2.3056328560032298],
            [-6.996407979783387, 2.2972299530476574],
            [-6.993592257167107, 2.2775280235990616],
            [-6.98912969869605, 2.275201359273286],
            [-6.986480962354083, 2.2705624937101443],
            [-6.986547811595845, 2.262853153249641],
            [-6.988627718921238, 2.2568703669434074],
            [-6.986072415236632, 2.2466712561777813],
            [-6.985400500644843, 2.2389726223628683],
            [-6.98843668959559, 2.230015595538124],
            [-6.991338076814897, 2.2262355891933523],
            [-6.98955339085597, 2.2192706440364494],
            [-6.987186625993623, 2.217630688081767],
            [-6.982711413273638, 2.2213245504238115],
            [-6.976418930744589, 2.2234830247517974],
            [-6.969367381125412, 2.224622346071176],
            [-6.961876459761395, 2.2227217865671114],
            [-6.9588722476271085, 2.2203475471360257],
            [-6.955215269612251, 2.214631024341987],
            [-6.952274305824562, 2.207643291399871],
            [-6.948845691467608, 2.2059662309448265],
            [-6.949575786312026, 2.1969371011146586],
            [-6.952905966709242, 2.192330459856624],
            [-6.952931743997922, 2.1858163747969828],
            [-6.959221533128541, 2.180363286181147],
            [-6.964150170327636, 2.1816466412503424],
            [-6.973982275150933, 2.177481898694356],
            [-6.977180697220426, 2.1793124759440357],
            [-6.981553148827573, 2.1790774899980923],
            [-6.984212042769137, 2.1721446016866954],
            [-6.988401437820284, 2.1686271571919264],
            [-6.9885081108025116, 2.1602782756851218],
            [-6.989929704601963, 2.1574903995344643],
            [-6.990010371816884, 2.1490920351941263],
            [-6.991362442717577, 2.143722279233418],
            [-6.9947919752228715, 2.135964544241927],
            [-6.991899443435332, 2.1296251490994424],
            [-6.9921693658105, 2.120450510701506],
            [-6.995999349424005, 2.115964823356059],
            [-6.996342298168089, 2.1094959906643473],
            [-6.998192138845576, 2.1038718339513713],
            [-7.000311985479634, 2.102979367936471],
            [-7.005818830958642, 2.105547132698781],
            [-7.011179993335318, 2.1060554825230144],
            [-7.014823261723592, 2.0979188358646255],
            [-7.027784970090375, 2.090520877898693],
            [-7.03234405236134, 2.091529469139716],
            [-7.033244833788323, 2.0837177783492353],
            [-7.0267445446900645, 2.077655775871328],
            [-7.028407237273535, 2.071866208068399],
            [-7.037080477573363, 2.0696225608130776],
            [-7.0407632486860505, 2.0673228199452103],
            [-7.042165283723518, 2.061907427481137],
            [-7.048110131292961, 2.055678897627919],
            [-7.055181804228854, 2.059982280116582],
            [-7.0572110634680465, 2.0669519662765734],
            [-7.0610539032516195, 2.068782077427173],
            [-7.064579287729672, 2.074172945137796],
            [-7.0703947137214564, 2.074771900662346],
            [-7.0735781905910695, 2.073004051794398],
            [-7.0832492955298045, 2.073777811647133],
            [-7.084675077000463, 2.0846904058399027],
            [-7.087663912247056, 2.085443324038721],
            [-7.094506105856155, 2.083705470416891],
            [-7.096600217197253, 2.0814583715101342],
            [-7.101180877147412, 2.0826196416406333],
            [-7.10736508412275, 2.076985851860667],
            [-7.116324925258001, 2.0726030335503594],
            [-7.123816848140696, 2.0723490442879764],
            [-7.125087402289074, 2.070208786683274],
            [-7.133641771203495, 2.066651706119907],
            [-7.1408098190673295, 2.0646067699654127],
            [-7.1417925331011105, 2.0679519645989806],
            [-7.147369892411556, 2.069319630410762],
            [-7.1503273622974195, 2.0730122862494125],
            [-7.155044274722768, 2.0691531606112257],
            [-7.167306071450684, 2.0639917254353044],
            [-7.173502526792086, 2.058825387028096],
            [-7.178890331298451, 2.0567620426270863],
            [-7.1807001467489044, 2.0517344437440417],
            [-7.185411319539455, 2.0521270925527295],
            [-7.190295629332155, 2.0544622375367334],
            [-7.195016646497907, 2.0601215086871467],
            [-7.198635727041235, 2.0661506849353937],
            [-7.204854453359882, 2.0682315550259145],
            [-7.208130936633896, 2.0677487938540438],
            [-7.212011467577669, 2.063177481015835],
            [-7.212949328420481, 2.0589451395502847],
            [-7.220523790993521, 2.053359517977196],
            [-7.22669828909891, 2.0519317477707855],
            [-7.233427494452099, 2.054961413449817],
            [-7.241452096250987, 2.0570331608387393],
            [-7.245305309880452, 2.0541133547269235],
            [-7.252228468225268, 2.0535372155255716],
            [-7.258041049858708, 2.0576842497854106],
            [-7.2605450122642585, 2.065802358690262],
            [-7.265497036882153, 2.072513079977527],
            [-7.266968047098242, 2.077583730430968],
            [-7.266570723472308, 2.081291999089997],
            [-7.2687607370204494, 2.0836303410004224],
            [-7.270802938772667, 2.0897263183757326],
            [-7.274493775278077, 2.0929251397868778],
            [-7.284505014903117, 2.086681430403426],
            [-7.288997130150396, 2.0892651871983947],
            [-7.290463986556647, 2.0925307972732434],
            [-7.293871595676647, 2.09224269835646],
            [-7.3004403462116425, 2.0845936907785685],
            [-7.301059301499998, 2.0749562347561707],
            [-7.298217571856014, 2.0718441599397135],
            [-7.3032824998127825, 2.0649565347666736],
            [-7.307936103180752, 2.0638490202022624],
            [-7.312828578063079, 2.0658865281153074],
            [-7.318793012734955, 2.07377864362113],
            [-7.324796537992556, 2.076281936685618],
            [-7.330386898281642, 2.0773958054955894],
            [-7.330372244380619, 2.0804511090946285],
            [-7.334809856853947, 2.0848626228108222],
            [-7.335410063916147, 2.088498263199245],
            [-7.338957473404566, 2.0919893075572453],
            [-7.341013054110078, 2.096701910019751],
            [-7.345683923112181, 2.0980381631861054],
            [-7.350613084312644, 2.0961148236473304],
            [-7.353218396675362, 2.0979740856797164],
            [-7.365236140085058, 2.0941169002556337],
            [-7.369325425827444, 2.0877970300254933],
            [-7.373758512340267, 2.089614142250891],
            [-7.380133897837942, 2.0882246332930388],
            [-7.384299718462639, 2.093960748135397],
            [-7.3893906119880945, 2.0944433275485035],
            [-7.394019886356499, 2.0974325679509573],
            [-7.401416496100285, 2.0952393977021555],
            [-7.403642576177699, 2.0962920228241604],
            [-7.409547312841521, 2.0930649796864125],
            [-7.419302257364258, 2.103863730774896],
            [-7.417386116522803, 2.105544973545127],
            [-7.417241358981979, 2.1109587525566846],
            [-7.41853330007221, 2.1143381204193994],
            [-7.422114839997236, 2.1152053107190145],
            [-7.422039643084443, 2.1242438356735973],
            [-7.426372036056794, 2.13117776786234],
            [-7.428279733974356, 2.1371784389377217],
            [-7.433213505691974, 2.1391919125393315],
            [-7.42891955675755, 2.1491501370275996],
            [-7.429229615253476, 2.15434520742262],
            [-7.434004573264212, 2.1602666155040984],
            [-7.437174963903415, 2.16209445380942],
            [-7.441493043601073, 2.1578065157325463],
            [-7.4425186886878905, 2.1545789905920545],
            [-7.446532060334169, 2.1540206316390877],
            [-7.454681547232968, 2.1455824119454348],
            [-7.456785750151608, 2.1390876737207125],
            [-7.461261790106599, 2.1439149117525242],
            [-7.467919382337768, 2.1376177980850968],
            [-7.468106121844996, 2.134055734065505],
            [-7.473309609327192, 2.120502498644305],
            [-7.476178501618826, 2.1192572968618766],
            [-7.478608177714509, 2.1254812175454507],
            [-7.481999825158762, 2.126989756835222],
            [-7.4891547656042174, 2.1255558397486607],
            [-7.491150210469404, 2.1332961580823837],
            [-7.495389881670519, 2.134900922119447],
            [-7.5059161305596644, 2.136243947098231],
            [-7.512158609083398, 2.1406968094388747],
            [-7.5208699930328615, 2.1382146259276205],
            [-7.524604875271965, 2.1355394256862663],
            [-7.52633780903997, 2.1383000482664847],
            [-7.532663422471777, 2.1400727115226754],
            [-7.531571063107713, 2.1475061941586953],
            [-7.535104594180411, 2.154361374148225],
            [-7.535159849209003, 2.166588857286543],
            [-7.537819761047862, 2.172626951898078],
            [-7.53831489798355, 2.1768458119037657],
            [-7.540841441857778, 2.181103911100411],
            [-7.537961497837729, 2.1889267358814952],
            [-7.535526433922216, 2.191319502336491],
            [-7.541821289291073, 2.1950508780918723],
            [-7.546425909602062, 2.1952422911895706],
            [-7.5532213907670185, 2.2023969148967435],
            [-7.55509089081942, 2.2093906940914],
            [-7.554310257556655, 2.2139155321348376],
            [-7.557300226741731, 2.214670808633721],
            [-7.557156150965968, 2.2205910433963894],
            [-7.55862517292517, 2.2241374199368136],
            [-7.5571584506264164, 2.2270704133982875],
            [-7.556443422454617, 2.236250512747774],
            [-7.5621205322525205, 2.235839631624126],
            [-7.5628153128169044, 2.241534665061844],
            [-7.559505852101318, 2.2454336662010523],
            [-7.553586828758523, 2.250180304500465],
            [-7.555271692516262, 2.2551973135093513],
            [-7.550255751572395, 2.2590607289592],
            [-7.5518578157722756, 2.2645622760352366],
            [-7.5506483831608655, 2.2737207153369767],
            [-7.554299108305811, 2.2769747275985663],
            [-7.552439874353533, 2.279130930785262],
            [-7.557863332648661, 2.285692607053069],
            [-7.561458730578193, 2.2871839677170342],
            [-7.561724516863344, 2.293012898489407],
            [-7.558256553602883, 2.298251719923325],
            [-7.559523588213461, 2.3018056212849682],
            [-7.563019894045787, 2.3044220056473432],
            [-7.563634315291513, 2.3107709177114466],
            [-7.567292379134684, 2.3114937924885144],
            [-7.567815248433476, 2.3160046109758867],
            [-7.573012379426268, 2.3244195597081996],
            [-7.57173504071936, 2.331272053180082],
            [-7.575439339249059, 2.3434673118385025],
            [-7.577690877368326, 2.346639779001273],
            [-7.57430363363582, 2.351804240758781],
            [-7.574808697828988, 2.354425376669742],
            [-7.57043939259603, 2.3600043483979434],
            [-7.5701089942083755, 2.366241216377411],
            [-7.575863977384227, 2.3762132360584705],
            [-7.575051010347804, 2.3793334711276652],
            [-7.576166544080945, 2.3855895788184776],
            [-7.571263680722333, 2.3945286771656455],
            [-7.565391327979746, 2.4009091187545684],
            [-7.561251403279415, 2.402628435448699],
            [-7.560738351959485, 2.4063432886612097],
            [-7.55340425898331, 2.4161708282314236],
            [-7.558627349563635, 2.417357272259256],
            [-7.560988027771732, 2.4256080971906915],
            [-7.555748643786431, 2.4296616593305473],
            [-7.5557556701579625, 2.439416323429913],
            [-7.550777670578101, 2.4421243736030056],
            [-7.554657062184834, 2.4480786503651095],
            [-7.5431661338531315, 2.454620041058186],
            [-7.539202024735115, 2.460559104999737],
            [-7.540603586050156, 2.4747565171426453],
            [-7.537747559575663, 2.476238787260025],
            [-7.5387503009656145, 2.4825596284940827],
            [-7.537312935692338, 2.4858545339138276],
            [-7.539838100116587, 2.4904353940134625],
            [-7.536098595778633, 2.4948469176719303],
            [-7.5385994638679685, 2.5015351003755812],
            [-7.529094948151823, 2.510259871840688],
            [-7.53059871323597, 2.514574242206049],
            [-7.528701657106983, 2.5196525505280434],
            [-7.531802462675635, 2.5289609297328415],
            [-7.5284205120078225, 2.5312386929454944],
            [-7.525812392972286, 2.5360583808927637],
            [-7.518021054297037, 2.540295093704551],
            [-7.515202895206852, 2.5445195234607283],
            [-7.5049225327617535, 2.552884945728111],
            [-7.503756992449407, 2.5629970640920563],
            [-7.50217068251597, 2.5680544512043855],
            [-7.502863241209185, 2.5726468001280676],
            [-7.501380151026007, 2.5746661107116813],
            [-7.503821952081163, 2.57814090963793],
            [-7.502920401666427, 2.580555974761016],
            [-7.5059799549881445, 2.584309067048365],
            [-7.5118672118691405, 2.58770495003224],
            [-7.517102710616454, 2.589168677770996],
            [-7.520380547280575, 2.5933535698156382],
            [-7.520018368741999, 2.6006883548891553],
            [-7.517307564265677, 2.606403265336417],
            [-7.518031338177745, 2.608955347578273],
            [-7.511691236702351, 2.6104744594982785],
            [-7.511339472224659, 2.6140581608181757],
            [-7.51311790210692, 2.6184369764238764],
            [-7.517916218004668, 2.622544386749799],
            [-7.519691003092581, 2.625818970132107],
            [-7.519681059776593, 2.631244566354932],
            [-7.526695108047199, 2.6347982494977256],
            [-7.5276934267951185, 2.6414323490004095],
            [-7.531344715829625, 2.6482429293368783],
            [-7.530547731898945, 2.6534316593629206],
            [-7.535239025946679, 2.656413204550812],
            [-7.540564728292581, 2.6541059633159425],
            [-7.544258236616898, 2.6495181549051656],
            [-7.545490399088141, 2.645826276930957],
            [-7.55253547114316, 2.6439259159408692],
            [-7.563826801254947, 2.64241059715357],
            [-7.569769044227605, 2.6449684584871114],
            [-7.57309728350571, 2.6445610081076873],
            [-7.573493255390926, 2.6494510117333006],
            [-7.576338925891903, 2.655073017624035],
            [-7.571044564746276, 2.6620437945691213],
            [-7.5728113642375865, 2.664468411219088],
            [-7.578481608059631, 2.66716359780014],
            [-7.586029640429299, 2.6681787382936686],
            [-7.589914743839244, 2.6731489106178086],
            [-7.590378321567005, 2.678774546517279],
            [-7.599190284593628, 2.6826468807023374],
            [-7.606024357628552, 2.677149281443821],
            [-7.615150075339715, 2.6734808192573576],
            [-7.618637821051542, 2.6757653517640385],
            [-7.617891081939163, 2.684449028376179],
            [-7.619252059780049, 2.6865326262148823],
            [-7.620908554886534, 2.6947370903416976],
            [-7.625953564437867, 2.6975262520740584],
            [-7.625912707117228, 2.704287934916367],
            [-7.627989409432305, 2.709565910849572],
            [-7.633020347233903, 2.7040345053541675],
            [-7.638909847404211, 2.7040996655267766],
            [-7.647230714318605, 2.707735706320355],
            [-7.649530638231442, 2.71146957645764],
            [-7.648958889643369, 2.7155233821701743],
            [-7.651702647799673, 2.717037130806034],
            [-7.655629428919886, 2.7245355482541203],
            [-7.654816142051102, 2.729867383166668],
            [-7.655410953885839, 2.7364474506061067],
            [-7.659452905442546, 2.7399718426859474],
            [-7.658949914324907, 2.7458794835447],
            [-7.660227330036422, 2.7500367351917507],
            [-7.659873134991439, 2.757938268203437],
            [-7.657148766870161, 2.7645488332614603],
            [-7.650707200742096, 2.7663241708026307],
            [-7.645851082867305, 2.7660169518127717],
            [-7.645202862602418, 2.76912183351802],
            [-7.641153364829876, 2.7722729867780638],
            [-7.648681162937936, 2.7793711300475237],
            [-7.648202620285324, 2.7825257827350947],
            [-7.645155652885323, 2.784908548505112]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -106.34275294183114,
          "lat": 40.66644919825534
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08057"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00198144"
      },
      "bbox": [
        -7.660227330036422, 2.0517344437440417, -6.948845691467608,
        2.784908548505112
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.198971342171543, 2.5462750103555147],
            [-5.142029450509161, 2.5416692392524842],
            [-5.133986284346009, 2.5413164417795233],
            [-5.085685831710738, 2.5376181135075244],
            [-5.066999843821619, 2.536716576949158],
            [-5.056206586290335, 2.5355472529077927],
            [-5.043418021419805, 2.534163915028209],
            [-4.999332100024179, 2.5308470066567086],
            [-4.828814117902616, 2.5182990331582498],
            [-4.799633522206911, 2.516082610583537],
            [-4.772238923230431, 2.514294754578625],
            [-4.75693262275376, 2.5127900476539944],
            [-4.729558797852682, 2.510975820333266],
            [-4.670575084492804, 2.5063688140816587],
            [-4.601685438218434, 2.5018522394577456],
            [-4.576373512180967, 2.499865687856714],
            [-4.512038247859891, 2.495432581892836],
            [-4.519331093302493, 2.37707402793186],
            [-4.52529766983684, 2.2848917970539615],
            [-4.5282660418404586, 2.2410973313245766],
            [-4.531051090267341, 2.1967767520458343],
            [-4.541415293351947, 2.1973508571508056],
            [-4.54595099259291, 2.1372086144333418],
            [-4.548579518945682, 2.104900787874915],
            [-4.557946258507788, 1.9648803993639072],
            [-4.560352175935081, 1.9291517184992704],
            [-4.647015483751041, 1.9352608289965698],
            [-4.760604384021689, 1.9430237095076177],
            [-4.875534751843472, 1.950271111989044],
            [-4.933390325602865, 1.954506889997911],
            [-4.989597362677429, 1.95816753071375],
            [-5.094260388854112, 1.9654246987320145],
            [-5.11896501563252, 1.9684204430792727],
            [-5.162837183598685, 1.9718438332729633],
            [-5.160350830394377, 2.0083027087617955],
            [-5.157327427943572, 2.0592984523463205],
            [-5.24343553616359, 2.066256878265002],
            [-5.236129616175452, 2.1539798471938183],
            [-5.227972890626688, 2.245659246168137],
            [-5.223422003923354, 2.2453323332634585],
            [-5.2121470249695765, 2.377791377349071],
            [-5.205320842015557, 2.467281757451933],
            [-5.204959718063595, 2.469429918166971],
            [-5.202132202782118, 2.508150947979281],
            [-5.2005063378614365, 2.5229657241479035],
            [-5.198971342171543, 2.5462750103555147]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.11011746870064,
          "lat": 40.72466550774872
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08075"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00198153"
      },
      "bbox": [
        -5.24343553616359, 1.9291517184992704, -4.512038247859891,
        2.5462750103555147
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-9.626302244904604, 0.49089603178816926],
            [-9.45007347177734, 0.4669731054193822],
            [-9.273847757867642, 0.4430275743524728],
            [-9.10336082665726, 0.4204929122690576],
            [-9.102709051094275, 0.4226581515003031],
            [-9.080977920585063, 0.5887555265613252],
            [-8.941962272766723, 0.5710418720664506],
            [-8.86401731550341, 0.5610863987581857],
            [-8.835673648173218, 0.5573473030563122],
            [-8.789656584535853, 0.5515767621274659],
            [-8.67437531189489, 0.536668984247401],
            [-8.5996733148918, 0.5272839285543133],
            [-8.598101097148838, 0.5273012185586667],
            [-8.481162647625524, 0.5130837836749678],
            [-8.407333313373782, 0.5041500994500081],
            [-8.434335010916989, 0.28183511213223567],
            [-8.435891867159171, 0.26766949452515054],
            [-8.451531358659393, 0.1365918221173796],
            [-8.55568756830938, 0.1493008358515986],
            [-8.553165116702127, 0.15674525839276063],
            [-8.555053008304888, 0.16372909086755888],
            [-8.549610467856512, 0.1727504091487406],
            [-8.552463749473358, 0.17968303141502048],
            [-8.66611079417725, 0.19384106852932317],
            [-8.730453537773514, 0.20186031925115444],
            [-8.737334466306185, 0.20330740742036316],
            [-8.833709392513565, 0.21518869914265218],
            [-8.842299647091773, 0.21573608178718368],
            [-8.935355055502367, 0.2272244877754015],
            [-8.936258578996576, 0.21632788817506476],
            [-8.930021450099742, 0.21570278690864325],
            [-8.930639246520172, 0.20835724336230851],
            [-8.916409053087863, 0.20661811889392853],
            [-8.919690458328699, 0.17696622994338077],
            [-8.905937665471468, 0.17536434210007062],
            [-8.909396581523826, 0.15363296706756213],
            [-8.909864468843315, 0.14620926203829285],
            [-8.851946370452447, 0.13888723779301812],
            [-8.852844711188638, 0.1318168465302608],
            [-8.831645642955158, 0.12931276461914315],
            [-8.833557825553788, 0.11484662510487585],
            [-8.819067024794965, 0.1130915828270672],
            [-8.820010251053851, 0.10557084543248435],
            [-8.805916814398278, 0.10375594139220969],
            [-8.806775954177317, 0.09620014407046946],
            [-8.799489865855573, 0.0953255962980192],
            [-8.805619700713049, 0.050240058532299264],
            [-8.813054945725362, 0.05100728620995736],
            [-8.815145282440385, 0.02961565845109127],
            [-8.8297103263543, 0.03129173992258835],
            [-8.87767599659491, 0.037692077546140415],
            [-8.945863665572148, 0.04600894450591565],
            [-8.953478229396584, 0.04744246631979478],
            [-9.042852849826279, 0.058770400464790394],
            [-9.049668699294143, 0.05993963400488428],
            [-9.107622280410263, 0.0671730260822664],
            [-9.16441150513558, 0.0752513755397657],
            [-9.25878038688436, 0.08786480308925178],
            [-9.27279321442564, 0.08905785075800308],
            [-9.339134353107294, 0.09855343509795671],
            [-9.3596681635933, 0.1010669272477267],
            [-9.555831937740178, 0.12952894419378375],
            [-9.55605983446707, 0.12786107618605996],
            [-9.66031166310965, 0.14191647559182485],
            [-9.658643807393803, 0.15357022278633936],
            [-9.657489058390011, 0.23519831223593585],
            [-9.65743180599137, 0.26635161200307717],
            [-9.626302244904604, 0.49089603178816926]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -108.26924566085405, "lat": 38.4022312201656 },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08085"],
        "coty_name": ["Montrose"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Montrose County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "00198158"
      },
      "bbox": [
        -9.66031166310965, 0.02961565845109127, -8.407333313373782,
        0.5887555265613252
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.774065582905656, -0.25286495960563504],
            [-4.677893320488708, -0.2591052876323757],
            [-4.570335867315742, -0.26608799885323003],
            [-4.560989494737798, -0.26702214761048587],
            [-4.397260661087979, -0.27748118361364743],
            [-4.361885690374169, -0.27978346590436914],
            [-4.289198155687, -0.28426752936467403],
            [-4.232665114260226, -0.28753924424205474],
            [-4.233027387542904, -0.29392876350903857],
            [-4.233735993570824, -0.30642703614386174],
            [-4.240568073376113, -0.41551071517525706],
            [-4.241906755819321, -0.43238895224121565],
            [-4.242417330665691, -0.4445005205287958],
            [-4.2470506188801975, -0.5124830493818544],
            [-4.253963696632358, -0.6308610846471108],
            [-4.2573375088297825, -0.6915296136018942],
            [-4.2612616564715315, -0.7564329882277453],
            [-4.263423296503944, -0.8001770765158012],
            [-4.264679190840023, -0.8219749070736424],
            [-4.2680813557071815, -0.8805458359628718],
            [-4.270409138989302, -0.916975968024429],
            [-4.360200468493222, -0.9110631813315891],
            [-4.391373718490023, -0.9093090414702575],
            [-4.515674245165442, -0.901077570864889],
            [-4.566052407641742, -0.8979443587570596],
            [-4.660408300085167, -0.8916824854159553],
            [-4.723410864707701, -0.8875651071152277],
            [-4.727277305452232, -0.8871586340945075],
            [-4.822814728052786, -0.8804057805205302],
            [-4.810242516238928, -0.6995215547943144],
            [-4.804311218555807, -0.6990846833056591],
            [-4.792326756389413, -0.5239604083278184],
            [-4.792378280851829, -0.5218227559149852],
            [-4.785754487310742, -0.4245492427071196],
            [-4.777245559343475, -0.29673784875203907],
            [-4.774945171755049, -0.2699829966436166],
            [-4.774065582905656, -0.25286495960563504]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -102.39335938583044,
          "lat": 37.95518157039474
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08099"],
        "coty_name": ["Prowers"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Prowers County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "00198165"
      },
      "bbox": [
        -4.822814728052786, -0.916975968024429, -4.232665114260226,
        -0.25286495960563504
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.723597761589126, -8.860047013387277],
            [12.774060260390652, -8.852748399046],
            [12.792341299464539, -8.849637850427714],
            [12.80971527693607, -8.847608556975025],
            [12.820552078439658, -8.8458895640743],
            [12.820488095216357, -8.844768379223638],
            [12.86975644721538, -8.837600195168578],
            [12.927109954804068, -8.828807645762902],
            [12.947209605861667, -8.82683233780697],
            [12.979533495494996, -8.821705647305736],
            [12.973136861548124, -8.782813657599647],
            [12.965976350182236, -8.736457426929126],
            [12.983712882082566, -8.733790069985883],
            [12.969530482917106, -8.652170366550596],
            [12.95046245734515, -8.536249788508211],
            [12.946489208838095, -8.510540719278513],
            [12.948245988615568, -8.513184860204218],
            [12.95678880031037, -8.531412016423534],
            [12.95814135934803, -8.54076705109249],
            [12.973256077081254, -8.554673704426332],
            [12.978683461457864, -8.565150550016536],
            [12.978111037282895, -8.57201335941863],
            [12.984991834889609, -8.57891934348039],
            [12.99017205106531, -8.5801708478492],
            [13.00034035805002, -8.580166984344368],
            [13.009235401397445, -8.577566421584859],
            [13.01468273448006, -8.57412975713606],
            [13.027960070753211, -8.574799858106473],
            [13.038080662446196, -8.588999594901276],
            [13.042760910591246, -8.58817354466269],
            [13.045391846835567, -8.591261487995329],
            [13.048987877884487, -8.592602656697379],
            [13.055840827208588, -8.593141843499795],
            [13.057586757305168, -8.598155913664236],
            [13.06463746087998, -8.600254793703247],
            [13.066866427001681, -8.602915231542447],
            [13.066111111127672, -8.60818663998764],
            [13.067729065596904, -8.61291278871788],
            [13.07349420310522, -8.619789839505135],
            [13.079221357614342, -8.631630468719493],
            [13.08215198089399, -8.633983775456135],
            [13.088241395597606, -8.642100373945848],
            [13.088085356074119, -8.653643907329988],
            [13.095106837811388, -8.662253385189521],
            [13.094317044922336, -8.667069131273447],
            [13.098592814522654, -8.668548679222113],
            [13.103352042207417, -8.667958914540039],
            [13.106439828370418, -8.669831596820643],
            [13.11794847323203, -8.666831952854015],
            [13.12189343900519, -8.663878742218005],
            [13.125347013060479, -8.66344556729469],
            [13.13194198751675, -8.664917897220478],
            [13.137514087650816, -8.67482318184686],
            [13.136857660454112, -8.677894189620408],
            [13.133226276407964, -8.680676159363596],
            [13.13358466947829, -8.684216882882742],
            [13.138329032002272, -8.686604330818373],
            [13.14003066511241, -8.694815346840443],
            [13.142865080369377, -8.69580602231472],
            [13.147572580251477, -8.694412532550597],
            [13.15872520004274, -8.706987045799567],
            [13.162831961376227, -8.709971996181983],
            [13.168324692106017, -8.70874136576949],
            [13.175452806974983, -8.714472425779205],
            [13.178309403420428, -8.71366606418144],
            [13.183085867843186, -8.718935639726723],
            [13.190046465438963, -8.717752969058813],
            [13.20562251997245, -8.731632325426627],
            [13.206063579111177, -8.737061797731673],
            [13.212984656447757, -8.739292451517308],
            [13.216543904122554, -8.747194058612218],
            [13.221937454953368, -8.7522066290335],
            [13.229388081244307, -8.751431613280062],
            [13.235108841684584, -8.753910580295654],
            [13.239020088060352, -8.757865805174843],
            [13.237873585728458, -8.762932927216323],
            [13.233709889520446, -8.769096179855305],
            [13.233221574704315, -8.774903995586653],
            [13.228948719868734, -8.77675404213711],
            [13.232559309581257, -8.781332639872197],
            [13.23192994004192, -8.788322349497292],
            [13.237214840049402, -8.78581663348873],
            [13.239933541091418, -8.791383641387666],
            [13.243381564523313, -8.790841501799985],
            [13.246417001913358, -8.795249912080203],
            [13.244948858928916, -8.800543272039862],
            [13.24979777825108, -8.80811982889642],
            [13.247456938721426, -8.809837485825597],
            [13.249143992804397, -8.814612204189885],
            [13.249299781887846, -8.820117200982612],
            [13.245669729675624, -8.827609118880835],
            [13.248685332631783, -8.83056478129728],
            [13.246245972165049, -8.834821768985595],
            [13.24898147489722, -8.837326000015365],
            [13.249239526654218, -8.840593778619455],
            [13.252795917628198, -8.841997260075566],
            [13.25302044698616, -8.84780547699839],
            [13.251835633760148, -8.853437361561028],
            [13.24497591961964, -8.851381256675596],
            [13.243983164392962, -8.854036801614141],
            [13.24538455995789, -8.85871056979628],
            [13.244582127731611, -8.86246010554512],
            [13.246001585875648, -8.867858771654472],
            [13.24352813548204, -8.871299204250315],
            [13.239813292235432, -8.872639392996396],
            [13.238765701556996, -8.876656742851283],
            [13.240179255967393, -8.880047272097485],
            [13.236567913324945, -8.88477571001262],
            [13.234861827454152, -8.89113877387099],
            [13.229113744189364, -8.894994791778435],
            [13.226235577633759, -8.90233022328169],
            [13.223219021622594, -8.904227215491131],
            [13.216408195162762, -8.911157168217667],
            [13.20967759659166, -8.922366787697568],
            [13.208760805052298, -8.931876735871189],
            [13.211275714690371, -8.940182375209957],
            [13.2140206891604, -8.943653212699704],
            [13.217230535665788, -8.953114491365726],
            [13.217506821098114, -8.960097663291222],
            [13.170041329368498, -8.967121400235191],
            [13.163025684476606, -8.967778811503154],
            [13.09140127395844, -8.978762251048666],
            [13.016297824899837, -8.990283255488016],
            [13.019296349173407, -8.999652193817836],
            [13.01944508687797, -9.002963128487092],
            [13.017018888458104, -9.009051671158627],
            [13.008726248809104, -9.010800081906059],
            [13.022291332140528, -9.098147291521965],
            [13.025196329568072, -9.115510490695009],
            [13.033981671722328, -9.165159327075491],
            [13.036029976798789, -9.180034237606106],
            [13.03960338158409, -9.181611193563034],
            [13.045155560870933, -9.186722049101],
            [13.042441921266041, -9.191443039190293],
            [13.043689974425497, -9.196272377007181],
            [13.043034104752632, -9.200525651717387],
            [13.039436110806063, -9.202180714744687],
            [13.046297961763353, -9.248398687916547],
            [13.057066708145353, -9.31829574085218],
            [13.067243990276802, -9.382986596769971],
            [13.072783955291262, -9.418958277509619],
            [13.030273299497063, -9.425816925176228],
            [12.956438249315042, -9.437010335071951],
            [12.95400746647455, -9.422025574811435],
            [12.929582240626726, -9.425775706840847],
            [12.895773549022492, -9.430627144163486],
            [12.89822259519167, -9.446085427800826],
            [12.826094057900217, -9.457495465534661],
            [12.810945370890224, -9.45972577622305],
            [12.80182449588493, -9.390695900966579],
            [12.787172635762154, -9.285443070442382],
            [12.779467234229692, -9.229978042331389],
            [12.769650070346115, -9.169927894005367],
            [12.768076338155211, -9.15694416921984],
            [12.761614522975377, -9.113132891196713],
            [12.754157535369494, -9.059706252378215],
            [12.743375323577558, -8.987971538341403],
            [12.736332898253565, -8.939521220782852],
            [12.727354582468475, -8.884322385236796],
            [12.723597761589126, -8.860047013387277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.71129933374904,
          "lat": 28.761547516547502
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12069"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00308551"
      },
      "bbox": [
        12.723597761589126, -9.45972577622305, 13.25302044698616,
        -8.510540719278513
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.924392806068045, -6.567511511963917],
            [9.957698908161458, -6.563724203519309],
            [10.039646654443112, -6.553637038028116],
            [10.06021334912987, -6.551235665773029],
            [10.058248569146771, -6.533472753270016],
            [10.06390594711386, -6.532747263189168],
            [10.063458122662619, -6.527045843366142],
            [10.07446541859394, -6.525855389437876],
            [10.075141890958816, -6.53130849400605],
            [10.086942325571757, -6.530117207546936],
            [10.087818903615682, -6.539417004645987],
            [10.100968342078334, -6.538055571186955],
            [10.099951974194429, -6.5285875372464846],
            [10.108077489333892, -6.527800649634926],
            [10.109812274393228, -6.543927371614349],
            [10.119020348991327, -6.543023994643245],
            [10.116988142516858, -6.5269600137203305],
            [10.12426328168983, -6.52622317103045],
            [10.126164290684272, -6.54222854299551],
            [10.133895774451954, -6.541298596121459],
            [10.133003191987676, -6.5338417701416205],
            [10.142863371198318, -6.532836111668836],
            [10.14389329281491, -6.540031244568443],
            [10.15239278769847, -6.538976022563514],
            [10.233566282462647, -6.529112703705714],
            [10.233506815118323, -6.528503805058207],
            [10.238192654148055, -6.545992938726062],
            [10.236320425762534, -6.549933626573752],
            [10.237459292680255, -6.552580291231495],
            [10.234353377326375, -6.557728717039779],
            [10.231993882590876, -6.566702618797128],
            [10.234986207986918, -6.569332442436406],
            [10.23800973992229, -6.576477432607622],
            [10.238227643872104, -6.583063149698987],
            [10.237227360777801, -6.586888396620965],
            [10.237303070402223, -6.593912109877435],
            [10.23864536091313, -6.601780822250404],
            [10.24553046646973, -6.605098468420353],
            [10.246189976180558, -6.609515869288137],
            [10.249528612876915, -6.617532646346223],
            [10.252373431456851, -6.620829536069595],
            [10.25478366913465, -6.626515069034887],
            [10.25637434737266, -6.635562207644882],
            [10.25773877065244, -6.638585394195336],
            [10.262347080077513, -6.639979760840167],
            [10.26622828392145, -6.647270227899974],
            [10.26942647966113, -6.649033479342477],
            [10.271544605934332, -6.652925166138978],
            [10.279117225873964, -6.675936844922929],
            [10.285528238753738, -6.687912493164982],
            [10.278702983965994, -6.6973381888712975],
            [10.275207060199525, -6.698253360597808],
            [10.274549512965025, -6.707322054837367],
            [10.273361468680315, -6.709751473676851],
            [10.25796427707483, -6.7116659662141505],
            [10.257385238713255, -6.70681164941876],
            [10.26756732921945, -6.70553865040452],
            [10.266983931035067, -6.700869574489895],
            [10.256808560956408, -6.702122685564869],
            [10.255975594037084, -6.693700050482339],
            [10.246533971788061, -6.694826819694514],
            [10.247355379170017, -6.7012891968555195],
            [10.239204798416457, -6.702331828504835],
            [10.240401441664178, -6.711597995293439],
            [10.229134836138, -6.712904226149597],
            [10.22952685905693, -6.716296672895272],
            [10.222076304750129, -6.717193431470877],
            [10.223014626309096, -6.724669564780818],
            [10.213570982284965, -6.725714880399456],
            [10.212587007688564, -6.723440480132811],
            [10.203282736204608, -6.723935526779816],
            [10.202449356756253, -6.715377099445746],
            [10.193292609601968, -6.716054179132183],
            [10.194258668161805, -6.724522275047697],
            [10.184986945589817, -6.7254360846631425],
            [10.184235052647463, -6.71679962067525],
            [10.174891415384632, -6.717515178120131],
            [10.175421127274056, -6.726381173733338],
            [10.098437340463882, -6.733558574982799],
            [10.027773612024907, -6.74052924098295],
            [10.009832086966226, -6.742193814487862],
            [9.970326818990983, -6.746298657747492],
            [9.96993461531542, -6.7432558506193585],
            [9.966540546029238, -6.737755292619686],
            [9.96644584720634, -6.727787354356491],
            [9.96352337025757, -6.724298090090483],
            [9.95634996037394, -6.722268321499984],
            [9.955102085931877, -6.718244525153182],
            [9.950504029786284, -6.711864429788691],
            [9.95912778973721, -6.710239232237735],
            [9.956265640505336, -6.6827632570186655],
            [9.947389823414067, -6.683747499318051],
            [9.948724867140877, -6.69324590014907],
            [9.937878713725638, -6.694686355798229],
            [9.936712111987424, -6.685155134595584],
            [9.935066999467097, -6.672105039080895],
            [9.945147736698997, -6.670919150565296],
            [9.94295385538256, -6.666590926632655],
            [9.941488940816624, -6.654835289231833],
            [9.933422532555896, -6.6556972093182845],
            [9.93194341932093, -6.638812003994043],
            [9.939238975264225, -6.6381661064455],
            [9.93831067334148, -6.629444451312462],
            [9.94658479783015, -6.619663851767186],
            [9.93029051480283, -6.621099470210866],
            [9.927267232674131, -6.593888199702323],
            [9.91900039612955, -6.595554469305269],
            [9.917992003797897, -6.586231095052587],
            [9.926354539251856, -6.585169273611343],
            [9.924392806068045, -6.567511511963917]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.6245141918715, "lat": 31.52922453753118 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13037"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "00344074"
      },
      "bbox": [
        9.917992003797897, -6.746298657747492, 10.285528238753738,
        -6.525855389437876
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.539566173643266, -5.337734638030256],
            [12.544386000768524, -5.31696998863335],
            [12.553776930697039, -5.308354295336899],
            [12.654831952944116, -5.212548736759786],
            [12.662554500824715, -5.217165047859299],
            [12.666973706739892, -5.216663023332541],
            [12.669995514593237, -5.21361776400582],
            [12.672571948119302, -5.215517400246004],
            [12.671880115268337, -5.218716632793254],
            [12.678176689079061, -5.222718988021427],
            [12.682964392890753, -5.22164630492577],
            [12.686967812702683, -5.225292120428741],
            [12.683800701914702, -5.2301198744812885],
            [12.710343694726806, -5.238719829274931],
            [12.716213083098646, -5.239383155992819],
            [12.729629353918474, -5.23530029788637],
            [12.735424222206115, -5.232869140489605],
            [12.738085205169366, -5.236461642200318],
            [12.73653704861369, -5.2399921684613595],
            [12.73947640251851, -5.241813205904529],
            [12.74195065219228, -5.237740421804831],
            [12.744485309308137, -5.23867239810706],
            [12.750238351696188, -5.237242774909365],
            [12.75297580192725, -5.240973254632241],
            [12.751505612346058, -5.243900032369592],
            [12.753661637236481, -5.2469704902879695],
            [12.757293587703794, -5.247923046250097],
            [12.757199545960841, -5.254285710673393],
            [12.754470643121772, -5.256702690593129],
            [12.759654796580243, -5.258752744841041],
            [12.761621258949827, -5.261844307027828],
            [12.767403790339966, -5.264096777767947],
            [12.779690765095092, -5.271287547161283],
            [12.782517155480681, -5.271326674673779],
            [12.787482880118887, -5.268145665029286],
            [12.79050492934549, -5.27159406363479],
            [12.795870522062419, -5.269137713946234],
            [12.797232586619268, -5.275282409731139],
            [12.7929447755187, -5.277470376211336],
            [12.79435797247965, -5.282392751604162],
            [12.797547268442692, -5.284298515631728],
            [12.798764308455455, -5.288425325073841],
            [12.806909927077932, -5.293845819011534],
            [12.81510317221698, -5.301771607759135],
            [12.819758576864327, -5.304906052638509],
            [12.831325458174103, -5.314256282716997],
            [12.836087891742293, -5.316449822766627],
            [12.841175397108247, -5.315426087710925],
            [12.841851893310555, -5.319460390397403],
            [12.837845228044607, -5.321656946710035],
            [12.840296435373784, -5.325823067283677],
            [12.835234048941881, -5.327942285326826],
            [12.8353940174903, -5.333347285979284],
            [12.830963237349236, -5.329506725815878],
            [12.828924850440307, -5.334791018228357],
            [12.833868511802411, -5.335913573376183],
            [12.835760584485465, -5.340310947728507],
            [12.829180132664257, -5.345990696665003],
            [12.83379162956159, -5.356947183158258],
            [12.833701996753947, -5.358853097269877],
            [12.844364262913276, -5.369471184140406],
            [12.84921917447858, -5.373193872000936],
            [12.854088159050278, -5.379528410668488],
            [12.860602854359149, -5.385012272592128],
            [12.862364973707729, -5.388649766788488],
            [12.862217432616037, -5.394057402004295],
            [12.860236496106014, -5.399556301410832],
            [12.865839634607733, -5.402262124969294],
            [12.873528513275021, -5.408665487622564],
            [12.873121597855652, -5.4119563500945755],
            [12.875675473896662, -5.418041905754286],
            [12.8811996711326, -5.42002655870838],
            [12.8815508071376, -5.425528921033886],
            [12.887303589688914, -5.425501649225842],
            [12.887970047362955, -5.43086028402297],
            [12.893085140633858, -5.428885972671341],
            [12.893458070490663, -5.423959031717254],
            [12.898246442201831, -5.423008214067657],
            [12.90085945688048, -5.427911487656018],
            [12.905898329298843, -5.431042706740271],
            [12.909644862795785, -5.430106903556877],
            [12.908917864052242, -5.4359730536469355],
            [12.904614513636709, -5.443956678344643],
            [12.90654304823104, -5.447365182845018],
            [12.911166781913966, -5.446224900861501],
            [12.911257766299052, -5.452191271167659],
            [12.91370261729506, -5.457416107018276],
            [12.911738783890518, -5.462747500936524],
            [12.921207045890792, -5.464923908735887],
            [12.922162650959041, -5.476476068888041],
            [12.925551261764186, -5.479898718750392],
            [12.92626327230846, -5.483572665864941],
            [12.921800387310844, -5.486854017542252],
            [12.921052969273179, -5.489878813896974],
            [12.924877593215735, -5.493138716317788],
            [12.919476107279102, -5.495181391915777],
            [12.915363197345007, -5.499194268492435],
            [12.910203258574429, -5.500743458483866],
            [12.915234333818871, -5.505653965046536],
            [12.91290938280557, -5.5085886703434275],
            [12.908581717186804, -5.508847215216554],
            [12.909900421302064, -5.5139278712992095],
            [12.907482085897897, -5.5180296100517285],
            [12.909367568972606, -5.5233392925444145],
            [12.904832782932916, -5.525829960581935],
            [12.902372745003005, -5.530162680194332],
            [12.907060430784961, -5.537135642669017],
            [12.913172347516701, -5.54018506524551],
            [12.915011527528145, -5.545977376408107],
            [12.914522132444933, -5.545756599655811],
            [12.870884325828497, -5.541615508811167],
            [12.850355904606744, -5.565899158823379],
            [12.835849014230273, -5.582595973252687],
            [12.77567802270293, -5.653358575477745],
            [12.766568197153898, -5.663772833321759],
            [12.729695879542806, -5.706860586860482],
            [12.729453543629907, -5.702909952483856],
            [12.721794151483653, -5.69925032667911],
            [12.719437380961516, -5.694227881513985],
            [12.715566852495172, -5.6890448230508115],
            [12.71298569587692, -5.675629839372193],
            [12.710585800804294, -5.667479283739583],
            [12.710975407944504, -5.662578703713086],
            [12.713164416250322, -5.654702648741513],
            [12.709415579734024, -5.653722534760185],
            [12.705407575427074, -5.648733838857832],
            [12.702651157348248, -5.641502729508449],
            [12.703288007262255, -5.637732714801543],
            [12.699466051011779, -5.632931545512384],
            [12.696655118427087, -5.623711368784856],
            [12.699048049163908, -5.621126342043014],
            [12.695397976270977, -5.617924953131876],
            [12.69333206572477, -5.608605802591664],
            [12.694821105421358, -5.602209101148167],
            [12.693278245925171, -5.598557574805721],
            [12.682916105428045, -5.592133041404621],
            [12.678348692209784, -5.586862157726701],
            [12.68076550076095, -5.580669854815884],
            [12.677614909409956, -5.574643323311218],
            [12.67062426558944, -5.5687888968186385],
            [12.668962462115623, -5.567072335266554],
            [12.671153354092327, -5.563063831958244],
            [12.667482721153045, -5.555982837005431],
            [12.668370776222815, -5.55049292157368],
            [12.665426495976066, -5.544990654912426],
            [12.661732705587394, -5.542988878193278],
            [12.663991153925164, -5.5402596171237555],
            [12.662155891120069, -5.536049599893387],
            [12.655494007733125, -5.5333656891966685],
            [12.65390230816188, -5.529427852070802],
            [12.655244204894741, -5.527023731787552],
            [12.653274363370029, -5.5226113547373075],
            [12.648710493272892, -5.521690303328435],
            [12.65118544671104, -5.5163815739769335],
            [12.648219596824603, -5.5139555518898895],
            [12.646703969338548, -5.507777230836264],
            [12.638483493069666, -5.500838905906799],
            [12.634759590462425, -5.500970877465936],
            [12.634179451767277, -5.489935357205131],
            [12.628068859661305, -5.48596292269553],
            [12.62298405914527, -5.485093174986054],
            [12.620567026877426, -5.487758058441336],
            [12.613221773678667, -5.483850290115641],
            [12.613771675067149, -5.478799581040916],
            [12.609937886902683, -5.47573662347089],
            [12.60932106446026, -5.470365328066807],
            [12.60208487818085, -5.467947598763784],
            [12.593046585216367, -5.462586026621879],
            [12.590460291451834, -5.453309511461013],
            [12.58572649043572, -5.449908180242896],
            [12.584762692264421, -5.445931227752825],
            [12.57952187544843, -5.445541595922408],
            [12.576511805125028, -5.441706150029355],
            [12.576025952854168, -5.432752855676862],
            [12.574234557075329, -5.43139018456837],
            [12.56939938770124, -5.433371374976165],
            [12.565019020362906, -5.430777647449855],
            [12.563503410028277, -5.422115039966098],
            [12.564966160896086, -5.417852153154075],
            [12.557168768575862, -5.411454649948237],
            [12.555200565520451, -5.408397997450285],
            [12.560359560191625, -5.402260327448333],
            [12.555724350151415, -5.388825142558166],
            [12.560297828710146, -5.386927668512476],
            [12.563641639249445, -5.377979309081299],
            [12.56259496367375, -5.370814513329207],
            [12.557942422147395, -5.36554751356509],
            [12.557907282020157, -5.361160150088916],
            [12.555728905498672, -5.358955670087428],
            [12.547067421267931, -5.359067724465827],
            [12.548491433809083, -5.349221053647481],
            [12.551662976382158, -5.350178152102384],
            [12.550709071987756, -5.344068175723143],
            [12.541803836052516, -5.339933568093376],
            [12.539566173643266, -5.337734638030256]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.34135789017878, "lat": 32.3675063866126 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13103"],
        "coty_name": ["Effingham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Effingham County"],
        "coty_fp_code": "103",
        "coty_gnis_code": "00350219"
      },
      "bbox": [
        12.539566173643266, -5.706860586860482, 12.92626327230846,
        -5.212548736759786
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.684760971513402, -3.1940353546854263],
            [9.774797855427016, -3.183491229025209],
            [9.86751110131576, -3.172168113691386],
            [9.926347655403003, -3.164552685089192],
            [9.975126806557348, -3.158810614467525],
            [10.081568778468622, -3.1461712204341126],
            [10.078700936860416, -3.150906822170143],
            [10.072657588569136, -3.15546165817775],
            [10.07140619659812, -3.158575751567179],
            [10.06757542392825, -3.1595119862293926],
            [10.065883590447415, -3.164397199185088],
            [10.059557607403793, -3.1711456410172647],
            [10.055218711153644, -3.1739652958641504],
            [10.053999202694976, -3.1770941747414843],
            [10.050479981958935, -3.1786551800779734],
            [10.048803941237654, -3.1837974770495205],
            [10.04607131965811, -3.187189115715268],
            [10.047026374214893, -3.192108318653776],
            [10.052628540848803, -3.196471573024412],
            [10.053737846534128, -3.1999902891647247],
            [10.057189048104492, -3.20154507202438],
            [10.060748299204187, -3.200902393576412],
            [10.061206405598082, -3.2058236514109195],
            [10.063879222265316, -3.2098896010854827],
            [10.069374967640899, -3.209684357033256],
            [10.072032438561923, -3.2110252672770967],
            [10.074229715609253, -3.2159967251164416],
            [10.083464777909434, -3.2191472268690564],
            [10.087190513712498, -3.217553029889272],
            [10.098809001972262, -3.2319250435539497],
            [10.101434498618245, -3.2371231729372667],
            [10.108403228628392, -3.2436929740423217],
            [10.111885865985824, -3.2442795991537823],
            [10.110677134822389, -3.254417654116373],
            [10.108967676002411, -3.261606568937242],
            [10.105365657268475, -3.26700839921236],
            [10.0982292501083, -3.2693117832848433],
            [10.092215510688701, -3.2767461030865563],
            [10.087826617838106, -3.2808217277430236],
            [10.088621774438675, -3.284768623020967],
            [10.085049114936954, -3.2905752030430055],
            [10.085712606115802, -3.297100451420815],
            [10.088238508497192, -3.302516910018866],
            [10.088453541874, -3.3089652307138633],
            [10.093188404435137, -3.31524233284791],
            [10.095686451170808, -3.3276859076966585],
            [10.109826745211764, -3.3368734475115476],
            [10.117785580269308, -3.3331042008470972],
            [10.120320635481976, -3.33366261722475],
            [10.125776133473519, -3.3318249727246942],
            [10.12869089538695, -3.3287802046238677],
            [10.134242280428317, -3.3284020692601923],
            [10.139496137960737, -3.368389139318916],
            [10.143537985350001, -3.4019374211796154],
            [10.135071578404013, -3.4029424644965354],
            [10.101045105056858, -3.4879426145289685],
            [10.082026303553137, -3.5365132405224116],
            [10.080628125329552, -3.5304295388809352],
            [10.073483445683713, -3.522131141587927],
            [10.073543082547365, -3.5170439787103858],
            [10.075226053633939, -3.5145392735886745],
            [10.073600257543932, -3.508551575727336],
            [10.07148652710206, -3.5058090317592416],
            [10.073193612565383, -3.500961617332338],
            [10.069972805242484, -3.4986764427119197],
            [10.066080595486069, -3.4987545966856537],
            [10.053651326374139, -3.493215700325065],
            [10.049243976602082, -3.4898147063782328],
            [10.044934091379261, -3.4892217177525287],
            [10.041908507576272, -3.4858990972656287],
            [10.037895205864476, -3.477500487292032],
            [10.035774904297028, -3.4782435186304435],
            [10.029737421907539, -3.4738380945133356],
            [10.026803952230145, -3.475562090910401],
            [10.022694376579345, -3.4810989289302454],
            [10.016138594449163, -3.4276013296404813],
            [10.009074885602708, -3.428525694853616],
            [10.00815151991472, -3.4211936231641458],
            [10.011072657635864, -3.4208660541449416],
            [9.993891195957461, -3.3979786843134887],
            [9.954560436818463, -3.3447773595897763],
            [9.949817247617515, -3.3474345742938043],
            [9.943836340385769, -3.3470377565119374],
            [9.938353435508066, -3.3429814385346526],
            [9.94031570068621, -3.3366954584989985],
            [9.93719421887011, -3.3366143552143885],
            [9.932636184596303, -3.33384149119122],
            [9.928969382416643, -3.334318121384632],
            [9.928965544547122, -3.330227870148341],
            [9.920406639561598, -3.3310391770753927],
            [9.90962973487894, -3.326956143718982],
            [9.906228928187248, -3.328283526071366],
            [9.901126892057407, -3.3246933077728538],
            [9.896813150237163, -3.3253857806380687],
            [9.892599793731344, -3.3203543013653647],
            [9.889647653085623, -3.3253554546270876],
            [9.882520474178676, -3.318401473071846],
            [9.871137543365618, -3.313603633797167],
            [9.866299443986494, -3.312521792547464],
            [9.863852271994679, -3.308071176036568],
            [9.856612928088012, -3.308429398526282],
            [9.800405038784717, -3.315379755028067],
            [9.799008431541294, -3.3153748646458765],
            [9.703949095325823, -3.3264588282933563],
            [9.703071407472873, -3.3266433542855274],
            [9.699538146755657, -3.3253104545051326],
            [9.684760971513402, -3.1940353546854263]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.31985754876972, "lat": 34.86408072703218 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13111"],
        "coty_name": ["Fannin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fannin County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00351094"
      },
      "bbox": [
        9.684760971513402, -3.5365132405224116, 10.143537985350001,
        -3.1461712204341126
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.56142493003402, -6.506167844389724],
            [12.567286899976112, -6.508152956579743],
            [12.579200435614629, -6.484073281414704],
            [12.583956141368109, -6.4695398932881085],
            [12.583972417473982, -6.464616793381084],
            [12.577292164098123, -6.458567734676912],
            [12.57846806704369, -6.450327423950422],
            [12.581062484826424, -6.440343667862186],
            [12.584233262130336, -6.4316233740620845],
            [12.606985311580988, -6.428841310376214],
            [12.631772202091723, -6.371491721198894],
            [12.63320338893858, -6.371312283556559],
            [12.633040352729378, -6.373668239309309],
            [12.64035408480737, -6.376923898596014],
            [12.644068820967188, -6.376000543424543],
            [12.649961262139879, -6.383324965016649],
            [12.647571184288735, -6.38796226299025],
            [12.65193709887881, -6.389780725572121],
            [12.653894098610182, -6.395860742087235],
            [12.660280664523686, -6.398782039384085],
            [12.663810037925556, -6.40343233349017],
            [12.670521759147746, -6.404025902888874],
            [12.669666726333544, -6.409092392524447],
            [12.674098002593905, -6.4093165020962815],
            [12.67734199114852, -6.412232482280462],
            [12.680571863484548, -6.418168701500192],
            [12.691749636808735, -6.423457368857298],
            [12.699624064138698, -6.427833618079966],
            [12.706197879106387, -6.42670378611214],
            [12.709609521712137, -6.42847895512489],
            [12.712215092500418, -6.434900528404117],
            [12.719102809723003, -6.435543342407058],
            [12.7198527598793, -6.4418074221894],
            [12.721796356848074, -6.443805808375974],
            [12.728789518287801, -6.444233036298349],
            [12.734056752284975, -6.450232713277815],
            [12.739302722007864, -6.452860000814035],
            [12.747794710634324, -6.4521447510680625],
            [12.757386294128272, -6.458404775175059],
            [12.760396538610648, -6.458542031960189],
            [12.764112119105274, -6.463578274780173],
            [12.76685491580619, -6.462754220672371],
            [12.769703756981698, -6.467744144688664],
            [12.773381960708322, -6.468971482671597],
            [12.776134799863517, -6.4644393472783035],
            [12.778203455563512, -6.470490866175032],
            [12.78365974451634, -6.4662802232661125],
            [12.791032182307411, -6.4702255174063295],
            [12.796433133801088, -6.474252416303894],
            [12.80135197635471, -6.4715729998524765],
            [12.804430862693502, -6.467916119742931],
            [12.808580352865665, -6.466844586382601],
            [12.811115451076544, -6.468993450066163],
            [12.810984053391724, -6.482476688967453],
            [12.812867473901244, -6.484913105213579],
            [12.820862329680487, -6.485465787866139],
            [12.82791966878106, -6.488776213461399],
            [12.833367648279948, -6.488772494415325],
            [12.834076832448632, -6.485227614643755],
            [12.838196984554228, -6.483618364283734],
            [12.840990222812934, -6.486237231491211],
            [12.835736462309828, -6.498121411394611],
            [12.836029409847875, -6.501098389628221],
            [12.839163599274386, -6.503160292644799],
            [12.843697822583328, -6.501166455884864],
            [12.845593265061927, -6.491988231023077],
            [12.847631003830228, -6.486252910212556],
            [12.851378201258692, -6.479892952826319],
            [12.856759765002591, -6.474284969918328],
            [12.868450988125002, -6.470873669064481],
            [12.879499584922902, -6.474122573864116],
            [12.894789972485095, -6.472417600283025],
            [12.897167317603108, -6.47341170073629],
            [12.9003565642047, -6.478331247475914],
            [12.911709421906403, -6.473811403391058],
            [12.915503805185214, -6.474323351345863],
            [12.920628560057995, -6.4801759937148935],
            [12.925311515869877, -6.483921813154387],
            [12.931865451020922, -6.487561192316479],
            [12.938450630638158, -6.4871744639051965],
            [12.944095567218733, -6.484716102385135],
            [12.950802278875262, -6.505528044012227],
            [12.958693555045386, -6.510207247861472],
            [12.96121627285705, -6.517034212430956],
            [12.955684516681572, -6.521936295247314],
            [12.952261616775736, -6.532965882736904],
            [12.949878502984477, -6.552348508782782],
            [12.949962902677335, -6.5602013639708],
            [12.945968412752244, -6.563487006113976],
            [12.939480960426042, -6.562645542749086],
            [12.929866331216642, -6.571927513233091],
            [12.918936406600945, -6.585923411464576],
            [12.903496212851463, -6.618317993305974],
            [12.900254716547773, -6.630216301160727],
            [12.897247539500368, -6.638706117033539],
            [12.889923503542784, -6.6475076001315685],
            [12.88083774186543, -6.654860693691329],
            [12.870825610750622, -6.656723833265531],
            [12.864595936464323, -6.671296836391268],
            [12.871550388276438, -6.683836306844643],
            [12.876897293666666, -6.704159722770426],
            [12.878899280344426, -6.717323586839706],
            [12.874271545964246, -6.764469927235464],
            [12.871289079778018, -6.775022558468962],
            [12.86815737561832, -6.778552253947862],
            [12.861724531402984, -6.780231767342781],
            [12.858920484633098, -6.775810878261508],
            [12.852148598613512, -6.777998065557346],
            [12.848758760017894, -6.766090363050899],
            [12.8412180611647, -6.759791171024074],
            [12.837404756592363, -6.759561854801481],
            [12.825419405663878, -6.765398860654657],
            [12.819581216040238, -6.767337990099678],
            [12.812979049330899, -6.7659213205756785],
            [12.809558994026084, -6.758869724414094],
            [12.807913445044907, -6.751567893551902],
            [12.804322276401104, -6.746898509798883],
            [12.791728272471854, -6.746320818313671],
            [12.774629954390536, -6.742949552747626],
            [12.771740355784154, -6.74058489604325],
            [12.768535419951563, -6.729865025179703],
            [12.765100336731589, -6.725933170690499],
            [12.760360548307768, -6.724378056937143],
            [12.753950922165581, -6.725924308854204],
            [12.749816884197262, -6.729407820381318],
            [12.746507094534273, -6.729478877622461],
            [12.737728864752704, -6.719592269549812],
            [12.731620650817305, -6.718259700121355],
            [12.730528123043864, -6.715315159482274],
            [12.73242970575518, -6.710642595377582],
            [12.736539735311425, -6.706105916052668],
            [12.737879599675788, -6.700655501692322],
            [12.739347968707838, -6.689159169976029],
            [12.737651196714877, -6.684049168889092],
            [12.733175632230829, -6.6812870574633525],
            [12.72760239946776, -6.68362210377753],
            [12.724603974772691, -6.688016195353697],
            [12.724228448069464, -6.693374553916789],
            [12.722504926149702, -6.697603905492904],
            [12.718746867371486, -6.698880132438807],
            [12.71469426233609, -6.696744441802496],
            [12.709169509595021, -6.700183342310532],
            [12.705009368922962, -6.700366756376385],
            [12.698600867726535, -6.704091011388417],
            [12.693293154425113, -6.703929629123975],
            [12.6899250270713, -6.701462334204336],
            [12.685137207958215, -6.702706398525808],
            [12.68063916962995, -6.710087806281123],
            [12.675891407641739, -6.710132815798169],
            [12.66783945132333, -6.70387585789321],
            [12.663478103256622, -6.7062252818416335],
            [12.660156074626245, -6.702163507772889],
            [12.648228499183695, -6.6997386071697695],
            [12.630945097991255, -6.705035381097116],
            [12.621432271831042, -6.6997402418910745],
            [12.61571746232221, -6.695750991523576],
            [12.608279868360551, -6.693948601212215],
            [12.604168725977127, -6.690736219558422],
            [12.601564790515559, -6.686695283381775],
            [12.59706003749592, -6.683743301848107],
            [12.591541652811232, -6.683767462657149],
            [12.58341246947427, -6.6824679958720905],
            [12.56956721271526, -6.686159498534269],
            [12.56041829894399, -6.683298461599656],
            [12.558985402900564, -6.678977012667136],
            [12.559937492782499, -6.673895871554409],
            [12.558800129623654, -6.669833340620403],
            [12.556369005346287, -6.6686415731801],
            [12.54867755853477, -6.675011511342697],
            [12.543800523558856, -6.674398315159971],
            [12.542123482191109, -6.667898857504553],
            [12.547103717972876, -6.662985640155663],
            [12.551092171796887, -6.6369870748917466],
            [12.54991541309719, -6.615674123988061],
            [12.551093438647195, -6.612564992555796],
            [12.55253755729035, -6.600467742271336],
            [12.552584053037707, -6.592394450022532],
            [12.55420772859001, -6.566581008376745],
            [12.555663451832453, -6.5560303502337005],
            [12.562300092959664, -6.5473309606980825],
            [12.56439656984982, -6.540233528271182],
            [12.564867121863049, -6.533476947196695],
            [12.560971444974957, -6.510539428562132],
            [12.56142493003402, -6.506167844389724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -81.54075181267018,
          "lat": 31.230975982693042
        },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13127"],
        "coty_name": ["Glynn"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Glynn County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "01671513"
      },
      "bbox": [
        12.542123482191109, -6.780231767342781, 12.96121627285705,
        -6.371312283556559
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [10.454256647420985, -5.594801740742709],
              [10.491570907792596, -5.590354364999815],
              [10.490866256565315, -5.597300489102957],
              [10.487999689132634, -5.597735892492964],
              [10.486085572804107, -5.6011632679909304],
              [10.485480634515719, -5.606621584785338],
              [10.482140484339157, -5.607821604830364],
              [10.487348340502633, -5.615724343965558],
              [10.47333151963706, -5.617188538782828],
              [10.471127003621657, -5.60129658245076],
              [10.455090095255972, -5.603489489513077],
              [10.454256647420985, -5.594801740742709]
            ]
          ],
          [
            [
              [10.211682642061328, -5.750316195865531],
              [10.212939630545122, -5.758427195507258],
              [10.204782648002606, -5.759525243620454],
              [10.203692612827082, -5.7513958273512324],
              [10.211682642061328, -5.750316195865531]
            ]
          ],
          [
            [
              [10.123997822383496, -5.595243531989489],
              [10.129932330637862, -5.5942887222630455],
              [10.153536724186367, -5.591807266867726],
              [10.14799861599568, -5.543491298912077],
              [10.155011442443765, -5.537219419140017],
              [10.159068319790826, -5.534804638976146],
              [10.165764584420211, -5.5237508915597875],
              [10.170279196264822, -5.519284239252563],
              [10.172877571181248, -5.513048463163866],
              [10.172271975605067, -5.503958524287433],
              [10.176229120357545, -5.470580980215548],
              [10.197329856589358, -5.468317544651087],
              [10.192991749244845, -5.426874379083237],
              [10.205939078545413, -5.4247671519819285],
              [10.211871175073346, -5.419710881967538],
              [10.213790865805851, -5.416256810154614],
              [10.21944156466858, -5.410443218820995],
              [10.228312736405469, -5.409103158229717],
              [10.231899232351614, -5.406444021998451],
              [10.230920076157469, -5.39985301413932],
              [10.232563808869738, -5.394781170237059],
              [10.234592887076134, -5.397668382947229],
              [10.239156135822954, -5.397846115866769],
              [10.253126434629358, -5.400638971623208],
              [10.254578519192378, -5.404337742799927],
              [10.259285902271703, -5.4099682088340195],
              [10.26281959427935, -5.411482936016813],
              [10.267365393594117, -5.408217049995246],
              [10.271295985033532, -5.400075913430597],
              [10.275576997034461, -5.398892829659409],
              [10.281721669976388, -5.403807290559889],
              [10.27850684118318, -5.4087762397639025],
              [10.277303244605307, -5.41607828885979],
              [10.280749369705859, -5.414304172839041],
              [10.290579206690419, -5.414608497443951],
              [10.296445999960723, -5.423769519790315],
              [10.298222679363851, -5.429018629970268],
              [10.30162546106005, -5.434339283083132],
              [10.30814976938765, -5.436920862750153],
              [10.309115326823395, -5.44344092034653],
              [10.315077758831265, -5.448983834818472],
              [10.317839460593309, -5.448876718642972],
              [10.3249763853796, -5.451735039980916],
              [10.334246028899699, -5.452788369218607],
              [10.343868670168192, -5.451427238441539],
              [10.35086059762996, -5.449320338536536],
              [10.35694307354975, -5.4422975962043045],
              [10.362400370689002, -5.442949411242564],
              [10.36254407928315, -5.447777519214514],
              [10.367772707387479, -5.450538461569074],
              [10.37287339270576, -5.451298757999318],
              [10.376658620312709, -5.448163314769719],
              [10.382557103331656, -5.445822889829417],
              [10.382418084090517, -5.440921402501086],
              [10.38875886189694, -5.438355487509215],
              [10.391647076112964, -5.439981970786908],
              [10.392282349848262, -5.449853281827623],
              [10.3979749116858, -5.453281898105198],
              [10.402026723826804, -5.460247136779818],
              [10.417832886546996, -5.473035709936706],
              [10.422456117267743, -5.48005519743263],
              [10.422237290408072, -5.483569239371261],
              [10.427128228437873, -5.48197611695358],
              [10.42899087067305, -5.478962902524407],
              [10.432795554202643, -5.483224736967537],
              [10.435961584499296, -5.484385860323694],
              [10.436420207417203, -5.48780065216647],
              [10.42818018022005, -5.491185462261378],
              [10.42697269059178, -5.5025471388916],
              [10.432144915908438, -5.507649129678229],
              [10.431305931457938, -5.511285220999066],
              [10.433122651480518, -5.513701693219568],
              [10.429733134230014, -5.520961620112437],
              [10.430831517245473, -5.525103889184517],
              [10.433746482935842, -5.528482140860306],
              [10.437976299659304, -5.530694129326273],
              [10.436777953443347, -5.5364324603055985],
              [10.441232330663814, -5.540650138822776],
              [10.447668896831216, -5.540758993530661],
              [10.451598007194583, -5.5423633771350005],
              [10.44908404552921, -5.549756470937493],
              [10.454313419973879, -5.548879613494387],
              [10.456298462201785, -5.55458459298724],
              [10.455857742866755, -5.558024017329248],
              [10.460430089309252, -5.558034652469544],
              [10.465526258826998, -5.560470105333634],
              [10.468443490917707, -5.558657779850309],
              [10.473309733744916, -5.5636914961035675],
              [10.473583109536587, -5.566669689037688],
              [10.480072395218121, -5.5626591260724325],
              [10.481089541466412, -5.5671699092915885],
              [10.484408082239845, -5.5702451330834775],
              [10.485815516223353, -5.57495876033565],
              [10.491532661321056, -5.5729880314239875],
              [10.495232142745254, -5.578336235704007],
              [10.494802764349654, -5.581715820807689],
              [10.453472585816323, -5.586243728232089],
              [10.454256647420985, -5.594801740742709],
              [10.438590819739733, -5.596888347880807],
              [10.439429953824048, -5.604574624571339],
              [10.407068197773837, -5.608687643133124],
              [10.408042322426956, -5.617039588721171],
              [10.398843707290535, -5.617990444438305],
              [10.349119630077592, -5.729991329030178],
              [10.322440027811577, -5.733354697712827],
              [10.316765589305696, -5.733722595492616],
              [10.314018490547008, -5.736157462304482],
              [10.31158330982398, -5.734608870104384],
              [10.306852941949241, -5.736376456968606],
              [10.302703592083477, -5.7412131271793],
              [10.305368348922038, -5.764591989122618],
              [10.247626965039084, -5.771306452024257],
              [10.244914242458188, -5.746037903953947],
              [10.227924682101758, -5.748223143763128],
              [10.229665077460659, -5.760912289630511],
              [10.221649290300062, -5.76179414275134],
              [10.220005110743799, -5.749195009686414],
              [10.211682642061328, -5.750316195865531],
              [10.208616365491565, -5.720051112792658],
              [10.192451763078601, -5.7220287597123844],
              [10.193894533984192, -5.735762480143313],
              [10.185419034495895, -5.737000618518036],
              [10.18297556709002, -5.7158281969881175],
              [10.175663465100623, -5.716565671907703],
              [10.174830812471624, -5.71135409663885],
              [10.170405759357878, -5.707641193607156],
              [10.168366113165185, -5.70893730896133],
              [10.163795665367111, -5.6678459232624245],
              [10.149979867947, -5.669653901693415],
              [10.149406694856285, -5.661558817932454],
              [10.141330860465063, -5.66254208926993],
              [10.138287992589364, -5.637253311829439],
              [10.130402315465503, -5.638381044006858],
              [10.128321228728531, -5.6228704651905295],
              [10.120058395809426, -5.623699430349953],
              [10.119013849690203, -5.615722011812478],
              [10.12700511803791, -5.6149028782416925],
              [10.123997822383496, -5.595243531989489]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.2504874408133, "lat": 32.55550332608758 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13269"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "269",
        "coty_gnis_code": "00344156"
      },
      "bbox": [
        10.119013849690203, -5.771306452024257, 10.495232142745254,
        -5.394781170237059
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.754717204414268, 10.227554717960142],
            [-13.66944480389758, 10.208823450756622],
            [-13.65884236744146, 10.206652129396472],
            [-13.602219097245305, 10.194247860604804],
            [-13.59913169522061, 10.20793051529236],
            [-13.570784111578451, 10.201803891173109],
            [-13.569657842376046, 10.206699762421616],
            [-13.547727078649647, 10.201987987576727],
            [-13.550958334113048, 10.188200446505448],
            [-13.480226445193457, 10.172790184774444],
            [-13.474073689607787, 10.200403718960867],
            [-13.44574105193366, 10.194203876041568],
            [-13.442702882846739, 10.207988605295366],
            [-13.40042598494099, 10.198527679400351],
            [-13.400670305695341, 10.197387656556382],
            [-13.375969259860208, 10.191841673353977],
            [-13.315125470293614, 10.178898799226392],
            [-13.314974839517003, 10.179475247705989],
            [-13.271818567958686, 10.170531534446177],
            [-13.2919261491358, 10.079392030291766],
            [-13.343810861995038, 9.844159188505044],
            [-13.354608746973287, 9.795203125827237],
            [-13.440768489022162, 9.813887212579434],
            [-13.43761844150381, 9.827764604281624],
            [-13.452263887444476, 9.831111108130962],
            [-13.56592574787248, 9.855882655014435],
            [-13.565776851932753, 9.85641260825323],
            [-13.646715950356823, 9.873963815958612],
            [-13.647817737999517, 9.869300316332208],
            [-13.690708986749268, 9.878640642259178],
            [-13.68783544733721, 9.890859684879304],
            [-13.691750822332706, 9.89586865498593],
            [-13.69622730785268, 9.894632777677137],
            [-13.705996178471501, 9.907350240891407],
            [-13.709630537637508, 9.909549447726866],
            [-13.711101936585777, 9.913954066344264],
            [-13.715302911271696, 9.91813745937687],
            [-13.716381862146033, 9.92361989750349],
            [-13.721565013405472, 9.931070156463583],
            [-13.731640492129442, 9.93335310227064],
            [-13.733067629261232, 9.935270534045593],
            [-13.740131977980282, 9.938845185709374],
            [-13.7514711670641, 9.932245241361496],
            [-13.756062063993905, 9.927956227049764],
            [-13.762102706889063, 9.930975028161388],
            [-13.763997998036167, 9.93339450817846],
            [-13.764010022493045, 9.93755793281346],
            [-13.76585291296738, 9.943268681153405],
            [-13.770134612483348, 9.947234946267416],
            [-13.773381112804945, 9.953773228348355],
            [-13.770563344883493, 9.962467679021378],
            [-13.764351004084519, 9.97041266026051],
            [-13.761213622603048, 9.977310194044714],
            [-13.762473387467193, 9.982341651258745],
            [-13.767485538331385, 9.9856674743662],
            [-13.77029552999329, 9.990590734602353],
            [-13.777326015015129, 9.99212111548401],
            [-13.780098567010556, 9.996804609217614],
            [-13.78984118735371, 9.999304092506646],
            [-13.793416528836921, 9.997043664225094],
            [-13.806688641007309, 9.999460592349191],
            [-13.785281770844492, 10.093357655598144],
            [-13.777990188821239, 10.125620287421322],
            [-13.758676266950426, 10.209551315505918],
            [-13.754717204414268, 10.227554717960142]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -116.6587224889921, "lat": 47.21757685506097 },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16009"],
        "coty_name": ["Benewah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Benewah County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00395190"
      },
      "bbox": [
        -13.806688641007309, 9.795203125827237, -13.271818567958686,
        10.227554717960142
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.806688641007309, 9.999460592349191],
            [-13.793416528836921, 9.997043664225094],
            [-13.78984118735371, 9.999304092506646],
            [-13.780098567010556, 9.996804609217614],
            [-13.777326015015129, 9.99212111548401],
            [-13.77029552999329, 9.990590734602353],
            [-13.767485538331385, 9.9856674743662],
            [-13.762473387467193, 9.982341651258745],
            [-13.761213622603048, 9.977310194044714],
            [-13.764351004084519, 9.97041266026051],
            [-13.770563344883493, 9.962467679021378],
            [-13.773381112804945, 9.953773228348355],
            [-13.770134612483348, 9.947234946267416],
            [-13.76585291296738, 9.943268681153405],
            [-13.764010022493045, 9.93755793281346],
            [-13.763997998036167, 9.93339450817846],
            [-13.762102706889063, 9.930975028161388],
            [-13.756062063993905, 9.927956227049764],
            [-13.7514711670641, 9.932245241361496],
            [-13.740131977980282, 9.938845185709374],
            [-13.733067629261232, 9.935270534045593],
            [-13.731640492129442, 9.93335310227064],
            [-13.721565013405472, 9.931070156463583],
            [-13.716381862146033, 9.92361989750349],
            [-13.715302911271696, 9.91813745937687],
            [-13.711101936585777, 9.913954066344264],
            [-13.709630537637508, 9.909549447726866],
            [-13.705996178471501, 9.907350240891407],
            [-13.69622730785268, 9.894632777677137],
            [-13.691750822332706, 9.89586865498593],
            [-13.68783544733721, 9.890859684879304],
            [-13.690708986749268, 9.878640642259178],
            [-13.647817737999517, 9.869300316332208],
            [-13.646715950356823, 9.873963815958612],
            [-13.565776851932753, 9.85641260825323],
            [-13.56592574787248, 9.855882655014435],
            [-13.452263887444476, 9.831111108130962],
            [-13.43761844150381, 9.827764604281624],
            [-13.440768489022162, 9.813887212579434],
            [-13.354608746973287, 9.795203125827237],
            [-13.37305624118643, 9.711562029569782],
            [-13.420691767231014, 9.49556501449837],
            [-13.437978789949758, 9.417168979266512],
            [-13.48045496236734, 9.4273020459614],
            [-13.522942638638678, 9.43658113702022],
            [-13.607836402530161, 9.454325698086475],
            [-13.619324510180212, 9.455598809562735],
            [-13.62301180848405, 9.45928681234533],
            [-13.627233783837044, 9.461321600446745],
            [-13.63004107137404, 9.460024189362391],
            [-13.633808349003747, 9.461185474705472],
            [-13.637667344638876, 9.460326414041493],
            [-13.645792536282558, 9.456288362621146],
            [-13.651842789248478, 9.451508240229884],
            [-13.652879516086946, 9.44805408430583],
            [-13.662912128892877, 9.449800938504064],
            [-13.668385457840902, 9.44547591119695],
            [-13.674665063446705, 9.442972119476016],
            [-13.687686080382246, 9.431504803551725],
            [-13.693534885658975, 9.431864761568757],
            [-13.697446996618027, 9.428424597406895],
            [-13.6985566083156, 9.424145950929976],
            [-13.702625753819385, 9.420112574307451],
            [-13.703286644246527, 9.416254402330265],
            [-13.707179725685359, 9.411450222047838],
            [-13.707459344923508, 9.408586294293716],
            [-13.710835250491632, 9.404495944693428],
            [-13.713392921085097, 9.398411598256434],
            [-13.718506076541198, 9.392223625456078],
            [-13.742284752159629, 9.396849646948597],
            [-13.780570377519014, 9.405377111452363],
            [-13.85759565569282, 9.422025962159092],
            [-13.934624825991362, 9.438656021291399],
            [-13.917235811518388, 9.514466886238834],
            [-13.899771877959695, 9.590588318581467],
            [-13.874850292503766, 9.701085392241012],
            [-13.872471193276516, 9.710977718958892],
            [-13.853572396806129, 9.79388272612484],
            [-13.82377452694876, 9.92455684056673],
            [-13.806688641007309, 9.999460592349191]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -116.71166315825015, "lat": 46.8161924039355 },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16057"],
        "coty_name": ["Latah"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Latah County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00395613"
      },
      "bbox": [
        -13.934624825991362, 9.392223625456078, -13.354608746973287,
        9.999460592349191
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.337675523227268, 0.8079412951531604],
            [4.357230811437468, 0.8091457295743766],
            [4.3593756521942515, 0.8098752889859768],
            [4.410984398531938, 0.8122736551572106],
            [4.470701689588213, 0.8147693508239753],
            [4.479850735247557, 0.8147023465353939],
            [4.528442727656004, 0.8152150376015459],
            [4.584785469971563, 0.8174227383210095],
            [4.582646224649589, 0.8074703185186298],
            [4.580229104043556, 0.8027473619204677],
            [4.5810304030284055, 0.7972685436578985],
            [4.580008855967055, 0.7864907690433801],
            [4.582950088158488, 0.7704879061569823],
            [4.585805960952482, 0.7590106121481233],
            [4.588270410769422, 0.7518070821007895],
            [4.591475609539293, 0.7329536238399391],
            [4.594246935311493, 0.7251254766529279],
            [4.599342332794411, 0.7143911268356383],
            [4.59966936584608, 0.7091388991137588],
            [4.5970980548848885, 0.7011982535761074],
            [4.596867640757589, 0.6909639708174087],
            [4.595586151357645, 0.6809318315391267],
            [4.599986336517818, 0.6713082488212841],
            [4.605572270625805, 0.6648341684978122],
            [4.606624856214259, 0.6565997894781578],
            [4.611378862540241, 0.6397852684493498],
            [4.611302181834446, 0.6314146901559187],
            [4.613316041597252, 0.6200710318089186],
            [4.609160966443457, 0.6086177128810429],
            [4.607604633406937, 0.6006674160919488],
            [4.601614394618207, 0.5937231088040938],
            [4.599153431386134, 0.5875670068807096],
            [4.597934116779512, 0.5738612773795858],
            [4.598672872700292, 0.5622757361082411],
            [4.601749329621593, 0.5532708276686535],
            [4.606962316135655, 0.5431799727560135],
            [4.60850233643161, 0.5378596382369965],
            [4.6091338180252714, 0.5309213169059349],
            [4.615029614336635, 0.5176802354603232],
            [4.619021722441042, 0.5072857479065899],
            [4.621860119011813, 0.49659807858734895],
            [4.62849279402605, 0.4865040536552713],
            [4.6268496543828945, 0.47936401608393764],
            [4.623137355203591, 0.4747282002794283],
            [4.622748506652992, 0.47100694212008365],
            [4.624503254303866, 0.4661195208008615],
            [4.6302898600828755, 0.4613094326209126],
            [4.633733962113412, 0.45672692240861945],
            [4.635999994414661, 0.4506371782905062],
            [4.636824297549137, 0.4442648233715902],
            [4.635475763570932, 0.43829818742503507],
            [4.635807743176905, 0.4299914268354521],
            [4.637452190279868, 0.4237700251951919],
            [4.64129343861548, 0.41403061387966694],
            [4.645938357033168, 0.40744295802701236],
            [4.6552536001033475, 0.3972005189682044],
            [4.663697893134692, 0.3864003185784179],
            [4.670604125772451, 0.38052846612260677],
            [4.674405192797459, 0.3785568653138227],
            [4.682412457741228, 0.37660159036445534],
            [4.6895979611747824, 0.3798868749324607],
            [4.696894606127666, 0.3866633765909686],
            [4.703079731134438, 0.39061218896246974],
            [4.711100807936022, 0.39307438618659407],
            [4.721405628565874, 0.39430116885305044],
            [4.7345257672704895, 0.3936011050871203],
            [4.725809494803341, 0.38961644975357046],
            [4.718665606624931, 0.38365386599492096],
            [4.7115909835593035, 0.36870111958258994],
            [4.711926688252035, 0.35886196063266607],
            [4.70916971565093, 0.34987266981746895],
            [4.6999693989776015, 0.3335882046089059],
            [4.694772351807941, 0.325559582953628],
            [4.687683079622606, 0.3211559759881316],
            [4.677472302169452, 0.3086938235447548],
            [4.66823141981752, 0.2959977071192803],
            [4.659500037872121, 0.29118311420398935],
            [4.651248423449588, 0.2887504406529392],
            [4.6434545909468055, 0.28778803271161185],
            [4.638280458561846, 0.2881945143338114],
            [4.628722851727923, 0.29373795811899456],
            [4.605030894884782, 0.3061507172355879],
            [4.60227350684617, 0.30899110737389623],
            [4.595867792925572, 0.3210919614484054],
            [4.586636528864503, 0.328816869079193],
            [4.573323864577809, 0.3435285833859758],
            [4.572963497543947, 0.35042255533844036],
            [4.56972973619908, 0.35644855811954096],
            [4.56771368850457, 0.36423918851640835],
            [4.561756244365112, 0.3780257561088539],
            [4.5601707374662945, 0.40013923526104017],
            [4.558351996567697, 0.407879242962137],
            [4.55498255465162, 0.41469509897383866],
            [4.549315896201569, 0.4230378514849806],
            [4.546032324288015, 0.4322725083784866],
            [4.539039341935073, 0.4444388153691629],
            [4.53269803817094, 0.4574205138969255],
            [4.529605297783899, 0.4618348540469672],
            [4.527628664073336, 0.46898392538182],
            [4.528290898878193, 0.4721422532750935],
            [4.535802762773253, 0.48115989810866844],
            [4.536767357760245, 0.48750213955617777],
            [4.549406353431996, 0.5049546037593039],
            [4.549987669921868, 0.5173657742079554],
            [4.545207174908425, 0.5344848319082999],
            [4.537713117579751, 0.5460932597509014],
            [4.533155210990953, 0.5516618250088183],
            [4.529113247820807, 0.5592351157699704],
            [4.525390324177041, 0.5711195076680139],
            [4.52317365916344, 0.5924870159553933],
            [4.519689568279962, 0.6013341939160866],
            [4.516684857502168, 0.6134071787715476],
            [4.515982564902251, 0.630048840126024],
            [4.51179292646561, 0.6401246801938111],
            [4.511495166764472, 0.648825485979489],
            [4.5063351429003875, 0.6671855814941439],
            [4.503789475577125, 0.6718173741004222],
            [4.496464745968765, 0.6774763817475289],
            [4.48668630854281, 0.6805132642173681],
            [4.473586420303169, 0.694543972240079],
            [4.466733445097182, 0.7070932132237885],
            [4.460279978458786, 0.7111392412452828],
            [4.4546917020478745, 0.7166395120704092],
            [4.452195173837, 0.7231648790764833],
            [4.447493330536048, 0.7265355678427031],
            [4.433689949251461, 0.7332710024699685],
            [4.4301071926460285, 0.736273140456336],
            [4.414803278770332, 0.752402431898396],
            [4.408882629963024, 0.756967710467962],
            [4.399666709300718, 0.7626327241159466],
            [4.372287254365065, 0.7773023502506667],
            [4.367184491893761, 0.7820935903398624],
            [4.364755489857822, 0.7871994362763752],
            [4.360683372061157, 0.7902945582900596],
            [4.35060643023391, 0.7926610955309517],
            [4.3444589770637005, 0.7962313641595382],
            [4.340189624075161, 0.8006361388570603],
            [4.337675523227268, 0.8079412951531604]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.66757092025622, "lat": 39.16933193925635 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17013"],
        "coty_name": ["Calhoun"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calhoun County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00424208"
      },
      "bbox": [
        4.337675523227268, 0.28778803271161185, 4.7345257672704895,
        0.8174227383210095
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.171804546848111, 3.7133214844033633],
            [6.200322017168499, 3.715667544048396],
            [6.257588187174493, 3.720324229308788],
            [6.290520953248128, 3.7227660022692683],
            [6.37223264002689, 3.72930673114469],
            [6.38452043810905, 3.7299424924908107],
            [6.409311102258334, 3.7320314350022628],
            [6.498128297819533, 3.7390267219983677],
            [6.5236163225209935, 3.7409352930852173],
            [6.543221556611228, 3.7109233616457042],
            [6.546644904316722, 3.707489131171717],
            [6.552806861221332, 3.69856006333869],
            [6.563950162694717, 3.6870242969047164],
            [6.576976607241022, 3.6771190061102095],
            [6.587087739510299, 3.672011397373503],
            [6.58667004005198, 3.669238894138361],
            [6.596204274606397, 3.6525252585433834],
            [6.597373910515733, 3.6472262345937314],
            [6.595871767674621, 3.6420500450784763],
            [6.597855416067573, 3.636939273007693],
            [6.600599287725384, 3.6234583512077387],
            [6.607884280717178, 3.607152795223072],
            [6.610878442938586, 3.6019882342272584],
            [6.6151575682437835, 3.5842094331957415],
            [6.61908787273275, 3.5740008766928724],
            [6.622848158452184, 3.5671799917538665],
            [6.6280483214247035, 3.562363862867272],
            [6.633116711686995, 3.561886828174338],
            [6.630877301919413, 3.557776110921786],
            [6.626797169545887, 3.557701511927694],
            [6.628011728236498, 3.549893598550817],
            [6.634498966846868, 3.5388884734359594],
            [6.641291980429354, 3.5139323192098044],
            [6.646369186927021, 3.510499431537111],
            [6.643033474991179, 3.507436758665379],
            [6.645694805953488, 3.4991419098346874],
            [6.648026373479496, 3.4987137545380107],
            [6.652818471062404, 3.49131448836658],
            [6.655656463512473, 3.494315563991643],
            [6.66134420007734, 3.4947859511489114],
            [6.661688866359202, 3.4917550951855842],
            [6.656239346197772, 3.491147279048222],
            [6.6544329865404945, 3.485612970309019],
            [6.654518521274191, 3.4813247139250953],
            [6.65215197349779, 3.4799045393790493],
            [6.653557226502978, 3.466439372959746],
            [6.661397917964638, 3.46502837349509],
            [6.6621184343954605, 3.4513164850683045],
            [6.659302764210819, 3.4497594604406476],
            [6.660670287934206, 3.4431442476392258],
            [6.668863022607322, 3.4252940629812754],
            [6.68439466196526, 3.403985980552857],
            [6.686381254419433, 3.398574069757505],
            [6.689821375524406, 3.3963168217911],
            [6.68735093406367, 3.3932122756511895],
            [6.693501158200758, 3.379532294628762],
            [6.703688646220698, 3.369436828069704],
            [6.703868759576886, 3.366500531785063],
            [6.708940005926445, 3.3619564724770146],
            [6.714048175451466, 3.3603522034826137],
            [6.716601293953098, 3.362020374643584],
            [6.7191540954945, 3.3595164718474897],
            [6.71661471895131, 3.356828598258134],
            [6.717769645324647, 3.3540789727307683],
            [6.727123260412538, 3.3509453459084804],
            [6.729828271255439, 3.3357270839496804],
            [6.734075045082084, 3.32677954073887],
            [6.734173191072331, 3.320758675708961],
            [6.73156188335349, 3.3183292865552345],
            [6.735776846418827, 3.311573963954939],
            [6.738721428503893, 3.273020664860563],
            [6.745881545319041, 3.188579114565485],
            [6.748327145274226, 3.161732465804101],
            [6.755997958770866, 3.072941189770175],
            [6.7322130041168755, 3.0706026890010047],
            [6.665122035514926, 3.0643572586998316],
            [6.6031232432716145, 3.058882110659265],
            [6.560065784009774, 3.0552830496627714],
            [6.553898327247513, 3.1251987906637733],
            [6.552760082822137, 3.123803555878311],
            [6.550512662645434, 3.144041976167199],
            [6.464407503973352, 3.134914356727501],
            [6.455057590004381, 3.2220816583755063],
            [6.390704330381662, 3.2146979938432274],
            [6.369716264212603, 3.212415064015748],
            [6.365075099053587, 3.256177709968618],
            [6.399627274039007, 3.260027028121809],
            [6.410960999758277, 3.261558194259785],
            [6.418746122606399, 3.2686588795891645],
            [6.424151823657514, 3.2711450978675107],
            [6.42796838813314, 3.275476555235422],
            [6.427755221885381, 3.2791078254778343],
            [6.432748634062522, 3.2848668801983725],
            [6.439703205649072, 3.29067389925362],
            [6.4421036313032225, 3.294140717132941],
            [6.447111756324579, 3.2947657923681635],
            [6.436973477303744, 3.383784797336173],
            [6.433679712454516, 3.411263969763499],
            [6.4324268499384, 3.4186265341901665],
            [6.43222582355134, 3.425805973827403],
            [6.430253726711193, 3.43968277232649],
            [6.428222728481151, 3.4608055534532216],
            [6.422089077002329, 3.5364276093825624],
            [6.4188100278141995, 3.572186658552217],
            [6.375465601668459, 3.5674908843652573],
            [6.3373242976187765, 3.5639332777612367],
            [6.25429426986842, 3.552708659895764],
            [6.167627426457318, 3.5437051484837014],
            [6.160472617090667, 3.624299148855791],
            [6.179165798331686, 3.6259365081853145],
            [6.171804546848111, 3.7133214844033633]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.81681981254044,
          "lat": 41.840116764256166
        },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17031"],
        "coty_name": ["Cook"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cook County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01784766"
      },
      "bbox": [
        6.160472617090667, 3.0552830496627714, 6.755997958770866,
        3.7409352930852173
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.964077503551906, 2.993444887015452],
            [5.996396095437926, 2.996434031422965],
            [6.048736772017983, 3.0008768392575513],
            [6.099040108620376, 3.006552937002893],
            [6.134804616207871, 3.0103589285827166],
            [6.166469536406824, 3.013511414227738],
            [6.215282721893849, 3.019129616699471],
            [6.218388306927072, 3.019725229480694],
            [6.227817003070512, 2.932258116566991],
            [6.236294588696024, 2.8478565259051583],
            [6.245866875994295, 2.757843359076788],
            [6.2554556084828015, 2.670538286769677],
            [6.247565496962641, 2.669727140517607],
            [6.212617139345961, 2.6658396218023426],
            [6.12899063922194, 2.6562643461694324],
            [6.0844996616554505, 2.6512542474512863],
            [5.998685320053413, 2.6438682318597806],
            [5.990729356987326, 2.738196029019329],
            [5.984482109586897, 2.8040245536409594],
            [5.979639378689574, 2.8476005486524145],
            [5.972716013539522, 2.9058380582429564],
            [5.967506910731501, 2.956731556612165],
            [5.964077503551906, 2.993444887015452]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.41849054093692, "lat": 41.28510394241111 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17063"],
        "coty_name": ["Grundy"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grundy County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00424233"
      },
      "bbox": [
        5.964077503551906, 2.6438682318597806, 6.2554556084828015,
        3.019725229480694
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.4103893802364516, -0.8751077211905447],
            [6.439564517839653, -0.8733780238297794],
            [6.439534654150255, -0.8728010164837753],
            [6.5075090997515606, -0.8678273150414777],
            [6.592425027716978, -0.860724455708969],
            [6.602564555075918, -0.8665125846651806],
            [6.606813509762393, -0.871452158595497],
            [6.611434824451808, -0.881153884619951],
            [6.615875976583777, -0.8845361515784101],
            [6.620588299750775, -0.8847782876625161],
            [6.623654414096021, -0.8826793862836371],
            [6.630198018507552, -0.8825158756022808],
            [6.639512495994929, -0.8871034142558771],
            [6.656291829979532, -0.9013209338494518],
            [6.66556882247064, -0.9150343631006476],
            [6.669676443945786, -0.919264261854644],
            [6.677764578066598, -0.9217248699854718],
            [6.682576182578709, -0.9245680450423311],
            [6.685396361395257, -0.9279078074969186],
            [6.690666639677592, -0.9371348148720742],
            [6.691687561565606, -0.9447820765623457],
            [6.693093297756991, -0.9475120229602856],
            [6.692920308372296, -0.9570114640556164],
            [6.68963434061762, -0.9675033446041331],
            [6.685283242938456, -0.9684476933166039],
            [6.679812613342853, -0.9813392985655934],
            [6.6742063340834195, -0.9832154536264386],
            [6.671256531270693, -0.9814077961703087],
            [6.665639364280288, -0.9819620463991529],
            [6.643802099933592, -0.9868841225542617],
            [6.638122375914613, -0.9862216645484241],
            [6.621344065450426, -0.9923615241215824],
            [6.60993674662258, -0.994646297079139],
            [6.607331413431567, -0.9967071116500855],
            [6.597044378654231, -0.9994738298672147],
            [6.582842922214956, -1.0023723816153334],
            [6.568902095473269, -1.0063509819470822],
            [6.55894314750819, -1.0077532288708155],
            [6.545308386102053, -1.0089316530061168],
            [6.524905721451061, -1.0148006863602892],
            [6.512720353749106, -1.0216461526477905],
            [6.501658497692073, -1.0288491432592721],
            [6.49814674294723, -1.0336037544442207],
            [6.488440240470808, -1.0413399467917168],
            [6.486604166660964, -1.0436215803636917],
            [6.476010611734261, -1.0611736936136904],
            [6.468570871276018, -1.0677581704340042],
            [6.463364155450919, -1.071372461363351],
            [6.458774307618736, -1.0706610053000407],
            [6.453265633199516, -1.0639175566480497],
            [6.444759910573154, -1.0578579683595632],
            [6.436761103398081, -1.0532710959871108],
            [6.427482679744922, -1.0503962821458728],
            [6.422560454244739, -1.0525350585150655],
            [6.422417804122918, -1.052214351788876],
            [6.417609449050382, -0.9781831136324849],
            [6.416505820141355, -0.963973575676671],
            [6.41117171162839, -0.8845118629159051],
            [6.4103893802364516, -0.8751077211905447]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.26686521741442, "lat": 37.51816567857925 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17069"],
        "coty_name": ["Hardin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hardin County"],
        "coty_fp_code": "069",
        "coty_gnis_code": "00424236"
      },
      "bbox": [
        6.4103893802364516, -1.071372461363351, 6.693093297756991,
        -0.860724455708969
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.5950515857774095, 2.58577703284121],
            [7.5874147849397025, 2.665775294662601],
            [7.58015013076774, 2.7423933768236752],
            [7.56973573433448, 2.847983615285481],
            [7.672819937742804, 2.859139537195284],
            [7.737411664192044, 2.865962371508035],
            [7.74067624254518, 2.8657862272802657],
            [7.753989127935317, 2.8676622354646604],
            [7.803042285063373, 2.8726743562758252],
            [7.858886129750128, 2.8790881881506034],
            [7.865988737604462, 2.820259782964585],
            [7.869329110872442, 2.7910944061245613],
            [7.91196720786859, 2.796826068952668],
            [7.916457101326788, 2.752499153352775],
            [7.928023595403849, 2.7543498126482753],
            [7.9371456413323775, 2.7549173720087787],
            [7.970731299355388, 2.759245165218758],
            [7.975493713815328, 2.715571601924734],
            [7.974730593688753, 2.7154288808723885],
            [7.892612913644111, 2.705161759272138],
            [7.838398968885614, 2.697949328138327],
            [7.80977913840773, 2.6949918658899317],
            [7.81538809088332, 2.63731044360116],
            [7.818348564315462, 2.6085241823063985],
            [7.763695590571512, 2.602096159033748],
            [7.726357583647577, 2.5986450202823104],
            [7.679085346449167, 2.5938329212704785],
            [7.5950515857774095, 2.58577703284121]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.26349770517164, "lat": 41.04697756685618 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18049"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "049",
        "coty_gnis_code": "00450353"
      },
      "bbox": [
        7.56973573433448, 2.58577703284121, 7.975493713815328,
        2.8790881881506034
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.6058632918014515, 2.486908379674082],
            [1.7145859615585373, 2.488611685086442],
            [1.7768403607811363, 2.4894279400626766],
            [1.8333173640926628, 2.4904117843309748],
            [1.847456976921057, 2.4904289261004373],
            [1.9466772159844414, 2.4923957608085416],
            [1.947400916815149, 2.448969140789449],
            [1.9483307844769135, 2.4052563137670346],
            [1.9496337377902617, 2.3345018664547403],
            [1.9494993776107055, 2.3324776105916345],
            [1.9516884038349598, 2.230781832937118],
            [1.8877804330684285, 2.2297616738431647],
            [1.7948993796996382, 2.2286116801413955],
            [1.7811079202977502, 2.228332288801931],
            [1.7379144864429128, 2.2283876514444385],
            [1.6949693536016954, 2.2280582487757297],
            [1.63457000796397, 2.22712727900018],
            [1.6099182707852848, 2.226957426345764],
            [1.609929049122798, 2.2378778718278896],
            [1.6087209081693, 2.3136781477445867],
            [1.6073660297522532, 2.3731313623212005],
            [1.6073164693618802, 2.4001269218207795],
            [1.6062453712968798, 2.45817851850715],
            [1.6058632918014515, 2.486908379674082]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.2423622374021, "lat": 41.027732904176524 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19175"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00465276"
      },
      "bbox": [
        1.6058632918014515, 2.226957426345764, 1.9516884038349598,
        2.4923957608085416
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4364406956964809, 0.5200438502563958],
            [0.536464357987821, 0.5201507103470046],
            [0.5794881846894177, 0.5201164468862465],
            [0.6788810132566357, 0.520294441411829],
            [0.7513347582667256, 0.5205784550116043],
            [0.7787876463588971, 0.5202759347360133],
            [0.7789636752180555, 0.46192145636360327],
            [0.7792950052561288, 0.43252501194211335],
            [0.7751408647951026, 0.43262429172946265],
            [0.7753894002748802, 0.3847997692666092],
            [0.7725843290721751, 0.37631723468909045],
            [0.7738440343358222, 0.36739556309386834],
            [0.7795789483149594, 0.3611211140411753],
            [0.7849761032645411, 0.3566669657074421],
            [0.7939200587675245, 0.3588250014813886],
            [0.8107458279966143, 0.3712435138877351],
            [0.8152821002503731, 0.37205673117522453],
            [0.821720223269955, 0.3690510515825443],
            [0.8313970193720343, 0.3679521593225547],
            [0.8375501507732809, 0.3701964547364737],
            [0.8423742868595622, 0.3676528137642205],
            [0.8481011023372165, 0.35965519442758775],
            [0.8481465819191013, 0.35100596312726917],
            [0.8472192612046496, 0.34653853097259096],
            [0.8479465316192649, 0.2965277349848924],
            [0.8484782945445916, 0.28821400828032606],
            [0.8482176060624226, 0.24417610714050478],
            [0.8485806647929028, 0.207916348892794],
            [0.849021912460339, 0.18556208254311335],
            [0.8487306006300872, 0.1710118149368648],
            [0.8167394263508189, 0.17039839810836116],
            [0.786589668451304, 0.17057238649531734],
            [0.7049600988296447, 0.1706389050945735],
            [0.6193994914831198, 0.16923397673280616],
            [0.5762512620747199, 0.1696679570456801],
            [0.5451697343822116, 0.17016903427199945],
            [0.5049267970489213, 0.1701717184133523],
            [0.5045890870372106, 0.26544796371640955],
            [0.5047521737483801, 0.28774105041761205],
            [0.5047832561167148, 0.3749613889758587],
            [0.5046686557178095, 0.4010886864342219],
            [0.4973584398740198, 0.40144639031612417],
            [0.4926983302250409, 0.4045347487456519],
            [0.4905115704031914, 0.40872168546376214],
            [0.4847924863289412, 0.41408777989465617],
            [0.47840179246456727, 0.4157903950553675],
            [0.47110736666066916, 0.41262424881867965],
            [0.46582668174202996, 0.4122392552091817],
            [0.4566823017684304, 0.41871099669137496],
            [0.45972734994539666, 0.4244118669088901],
            [0.4649603054834287, 0.4252668801463043],
            [0.4704333034015341, 0.42990012762815094],
            [0.46908052385833215, 0.43611192943205973],
            [0.46641602650486014, 0.43689319263896076],
            [0.4608296809731958, 0.4347115137051273],
            [0.45691935283061225, 0.4307703939987708],
            [0.4540926429116535, 0.42553807418711387],
            [0.44811304678689196, 0.422835455769708],
            [0.44113396473251915, 0.4249917247890007],
            [0.4337273697545176, 0.42919221732134455],
            [0.436157442167999, 0.4324794477730341],
            [0.43634265080362067, 0.44691523921930093],
            [0.4364406956964809, 0.5200438502563958]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.75647526493043, "lat": 39.04151094084511 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20177"],
        "coty_name": ["Shawnee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shawnee County"],
        "coty_fp_code": "177",
        "coty_gnis_code": "00485051"
      },
      "bbox": [
        0.4337273697545176, 0.16923397673280616, 0.849021912460339,
        0.5205784550116043
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.036739570403844, 0.91269942906734],
            [9.041496975874667, 0.9142904329846572],
            [9.043483216860372, 0.9172190636035262],
            [9.05595606100471, 0.9225549743348268],
            [9.062848621776903, 0.9285773960441345],
            [9.073565937470798, 0.9506860872684736],
            [9.081984037185729, 0.9599202206820416],
            [9.089745290657879, 0.9616563934461148],
            [9.099333756164285, 0.9597479849210537],
            [9.104132897849107, 0.9577782094720911],
            [9.110515947085473, 0.9535587139049777],
            [9.125347138266863, 0.936927510838128],
            [9.136429994573914, 0.9232051778528851],
            [9.140613223567861, 0.9199436892895788],
            [9.146677459139065, 0.918433539718457],
            [9.15518524312892, 0.9191472766200591],
            [9.162279125131363, 0.9174556944875434],
            [9.168002487569066, 0.9142785673423077],
            [9.18345981552524, 0.900984959084298],
            [9.190590085794453, 0.8994020997556008],
            [9.20518690153873, 0.8317347419394897],
            [9.225742711125704, 0.73651888057701],
            [9.233651795459503, 0.7063728714363727],
            [9.229387408768465, 0.6273991582291418],
            [9.226951199702537, 0.6281798838804711],
            [9.218321238766967, 0.6267027636507072],
            [9.20850993502591, 0.6205352333698442],
            [9.208066814843292, 0.6152510912472259],
            [9.199811592684897, 0.6114804595573917],
            [9.199150322715974, 0.6070620966241559],
            [9.200859072937137, 0.6036865156101091],
            [9.19833301470326, 0.5982625775325858],
            [9.12296233782042, 0.6435152341086497],
            [9.118517846975061, 0.6525239198186524],
            [9.115407222837955, 0.6541134884924769],
            [9.113412540609058, 0.6591980745666862],
            [9.108775884350019, 0.6604225534712955],
            [9.10368616401664, 0.6563106771901656],
            [9.099791663387752, 0.6576380335601147],
            [9.098243468784732, 0.6627860158586737],
            [9.097711844475945, 0.669709754213052],
            [9.09383916822434, 0.6660916458003285],
            [9.090046712256868, 0.664591907280202],
            [9.085554156987891, 0.6660693464185605],
            [9.088087407732742, 0.6698010774741631],
            [9.091011388509243, 0.679220505764099],
            [9.091253295135147, 0.685170372969672],
            [9.08903432585285, 0.6919224698223899],
            [9.077386898802278, 0.6995403483667345],
            [9.067336831459034, 0.7024809505704102],
            [9.064135320622327, 0.7020384133407895],
            [9.053516005476311, 0.7030073462545985],
            [9.030284094228964, 0.7006730567108006],
            [9.024736394026595, 0.701523637891168],
            [9.021847846265112, 0.7037747286606186],
            [9.01648949095186, 0.7106004325004004],
            [9.013938853864339, 0.7175181315721312],
            [9.014591503340217, 0.7219060266532118],
            [9.018904066315168, 0.7314339949482882],
            [9.022848395012428, 0.7376538015955137],
            [9.030305558791005, 0.7467131453315882],
            [9.033061606670064, 0.7524500903380297],
            [9.036685602870575, 0.7556301612536276],
            [9.042743868018707, 0.7634486054076413],
            [9.044274754109118, 0.7671862924167326],
            [9.045447414033651, 0.7753811227244074],
            [9.044212055346351, 0.7808396776787879],
            [9.03768378804248, 0.7934482900139521],
            [9.028391398609408, 0.8024661509044767],
            [9.025406710979611, 0.8089099524447189],
            [9.006468527034421, 0.8301243378099757],
            [9.001781401790218, 0.8334808578657289],
            [8.99474923288385, 0.8386453983153123],
            [8.984432732405807, 0.8535044286572327],
            [8.983800691680253, 0.8576688443533016],
            [8.988892289909252, 0.86731493387318],
            [8.994739975490626, 0.8716550025525747],
            [9.00036070678087, 0.8744503220811698],
            [9.009028988567831, 0.8816402316959966],
            [9.016337722807435, 0.8909917584444157],
            [9.019694462060707, 0.8969445515262958],
            [9.027958583696153, 0.9065890821458579],
            [9.036739570403844, 0.91269942906734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.72788413193757, "lat": 38.96988922541981 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21015"],
        "coty_name": ["Boone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boone County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00516854"
      },
      "bbox": [
        8.983800691680253, 0.5982625775325858, 9.233651795459503,
        0.9616563934461148
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.190590085794453, 0.8994020997556008],
            [9.19327396988393, 0.8988065024375219],
            [9.202602000617354, 0.89970653889469],
            [9.207264388869515, 0.9011598906691596],
            [9.21386389933272, 0.9059951716345218],
            [9.228851346928382, 0.9118429422862444],
            [9.234468035544127, 0.9179109586222208],
            [9.238443276459448, 0.9260179987265551],
            [9.243010365260325, 0.9311464165498884],
            [9.250283984116287, 0.9318237566215811],
            [9.263878592503707, 0.9263536041201664],
            [9.26778353689285, 0.9267257383192645],
            [9.277687960306576, 0.93100031982101],
            [9.28022599351302, 0.9276796490248165],
            [9.280120541094265, 0.9219090465330265],
            [9.290484613756945, 0.9076894800901788],
            [9.288510284929217, 0.8951412846347905],
            [9.289322775061228, 0.8918119609983186],
            [9.293119704195574, 0.8864090120114867],
            [9.29739385895669, 0.8833920874878092],
            [9.30020456488842, 0.8787581782631014],
            [9.297769431933538, 0.8680185179176282],
            [9.299576264418906, 0.8585486471007008],
            [9.303311416188246, 0.8530834086038629],
            [9.306735524866943, 0.8510605572637172],
            [9.313741031970865, 0.8432806468979058],
            [9.320955174854868, 0.8437187576153949],
            [9.328733714557393, 0.8406271907401512],
            [9.332087557446533, 0.8372868197374796],
            [9.330945220789499, 0.8318383828973751],
            [9.32519393052019, 0.8237284096062923],
            [9.323188612025895, 0.8195478919147587],
            [9.322965013348405, 0.8117464033921508],
            [9.325662365460843, 0.8071538944052604],
            [9.329234522195264, 0.8052809664309043],
            [9.333904609955807, 0.8083010232452366],
            [9.334954205334595, 0.8165015531297496],
            [9.337544857009448, 0.8218615431946492],
            [9.341387138582611, 0.8262233048032173],
            [9.345615403126358, 0.8275711340652527],
            [9.35182136945361, 0.8238805096792934],
            [9.350788488481866, 0.8159409149109574],
            [9.345591087755706, 0.8080606853299831],
            [9.343204384584718, 0.8015190443526847],
            [9.342925672428187, 0.7968542392551691],
            [9.340163512344851, 0.7915880539838305],
            [9.331384399025128, 0.7897118076475796],
            [9.32839257703222, 0.7860647796243425],
            [9.331866502218313, 0.7787344911509065],
            [9.339359640672805, 0.7695891646627292],
            [9.342856601970901, 0.7616699861871349],
            [9.347077847543368, 0.7572313666951273],
            [9.34702984269791, 0.7529862354388475],
            [9.352244633594637, 0.7466502260423287],
            [9.352614460345064, 0.7389501238635094],
            [9.351042277435928, 0.730407491044017],
            [9.350617475336723, 0.7217060486619866],
            [9.346411381965664, 0.7066893374577358],
            [9.349531643249854, 0.7019796686818727],
            [9.347586832602437, 0.6988444257377052],
            [9.339967955346742, 0.6914265274711374],
            [9.34161552716806, 0.6866538391300085],
            [9.348662657804624, 0.6798508413989102],
            [9.35014979825634, 0.6761174730532468],
            [9.350621205295756, 0.6682973554821039],
            [9.352954763811857, 0.6607533800907598],
            [9.356381282940744, 0.658113292312037],
            [9.360290180782064, 0.65910450606998],
            [9.36242776157938, 0.6663301936674618],
            [9.36818234318901, 0.6709621413286051],
            [9.37541419969749, 0.6671478150108018],
            [9.380066154256385, 0.6555183752496119],
            [9.377911019985898, 0.6514542879481177],
            [9.380168119469646, 0.6501214667633637],
            [9.380014691073372, 0.6493743729064015],
            [9.294530759647483, 0.6247524018165571],
            [9.283278113407755, 0.6215136216203317],
            [9.244481398478959, 0.6179208740509357],
            [9.238692679587045, 0.6189155416948953],
            [9.229387408768465, 0.6273991582291418],
            [9.233651795459503, 0.7063728714363727],
            [9.225742711125704, 0.73651888057701],
            [9.20518690153873, 0.8317347419394897],
            [9.190590085794453, 0.8994020997556008]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.53333108262652, "lat": 38.93339823772598 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21117"],
        "coty_name": ["Kenton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kenton County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00516905"
      },
      "bbox": [
        9.190590085794453, 0.6179208740509357, 9.380168119469646,
        0.9318237566215811
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.236501932767133, -0.027022902224731655],
            [10.237005172152926, -0.02180839167024362],
            [10.234141224679242, -0.018382322412472292],
            [10.248273267976236, -0.011505853876374322],
            [10.251766634598608, -0.014065192199447863],
            [10.257070147885923, -0.013498029444902393],
            [10.260552729744143, -0.018787711318560118],
            [10.2631245806338, -0.018484488188054652],
            [10.265406016377021, -0.014889551093722775],
            [10.264237314064241, -0.011460399950460142],
            [10.267311950132406, -0.008028501681867374],
            [10.267797910071938, -0.001872375884031039],
            [10.275514283875328, -0.0037966279625177663],
            [10.27290962493855, 0.0014160815405557389],
            [10.27394809147642, 0.006675208293108291],
            [10.279467747129518, 0.0043501076287994515],
            [10.281556308857217, 0.005297571317952127],
            [10.280119606114601, 0.01504602413804654],
            [10.286287142650952, 0.01248001804314324],
            [10.290826862487027, 0.01254222686999583],
            [10.301649544326976, 0.01718316131971038],
            [10.299399725288277, 0.01998622645780305],
            [10.300443281445162, 0.024602797166530726],
            [10.30448033089382, 0.03136377978384886],
            [10.311159977775635, 0.035659255901903684],
            [10.313439721854447, 0.035050105604890504],
            [10.316918629503395, 0.03952310708262947],
            [10.321217458069233, 0.03927995837418568],
            [10.327098769757947, 0.043127550342669546],
            [10.329433849275823, 0.0422767039229851],
            [10.33308419774629, 0.045606009599882466],
            [10.33161565114783, 0.05247063397059372],
            [10.336068548666951, 0.05527634040954522],
            [10.34140953126261, 0.05648191964608905],
            [10.344608501432898, 0.06133871424890238],
            [10.347633790482183, 0.06251942305173064],
            [10.349783422932079, 0.0668266255041324],
            [10.357446403991625, 0.07211748067768206],
            [10.353438796424893, 0.06514976535603255],
            [10.3607730386884, 0.05922374966822937],
            [10.361305206185195, 0.0556211314752216],
            [10.35973177582703, 0.05125775192295265],
            [10.360771158898313, 0.04641210997121009],
            [10.359271161896402, 0.044313625986394434],
            [10.359412911951358, 0.037631062578845],
            [10.357368191472698, 0.032352455716628266],
            [10.3578388933536, 0.0251110269076755],
            [10.361202488582634, 0.01894822776479977],
            [10.361772849410308, 0.015194845560617207],
            [10.371023575089168, 0.011970926497985977],
            [10.376462440681069, 0.008278336212157683],
            [10.38357388078449, 0.010245204838994592],
            [10.384880971340168, 0.01271449384591427],
            [10.389546869384985, 0.011714513438820713],
            [10.391972653955682, 0.006371596714907638],
            [10.398305853238298, 0.0048484993133422905],
            [10.40072031671277, -0.00046316336169653063],
            [10.401826720768526, -0.011761205037934031],
            [10.408701890801158, -0.010895090823679196],
            [10.410029335696771, -0.015694410368951035],
            [10.417998042253318, -0.023152842819708152],
            [10.42269927848016, -0.0228979770911082],
            [10.42480754819826, -0.025504309990020627],
            [10.432549436469854, -0.02194955360716519],
            [10.438403501067832, -0.02142211576424987],
            [10.439882698399517, -0.017059333706454263],
            [10.446063540287614, -0.02155894279190277],
            [10.45279028205236, -0.0242004836444606],
            [10.457669570430348, -0.021250124411167182],
            [10.46294836816433, -0.03109935013013336],
            [10.467375908455887, -0.03337891442304196],
            [10.470584041988978, -0.025770422945609404],
            [10.475223918076827, -0.025740749336174974],
            [10.4831376195773, -0.024082241332239733],
            [10.491151271977374, -0.023359089728700096],
            [10.494878957595036, -0.020511259462726444],
            [10.49664054044864, -0.016646485944730033],
            [10.500345998804457, -0.015726617952838733],
            [10.503417411998068, -0.017635890084803364],
            [10.51584467775354, -0.016634943345849102],
            [10.518182555300264, -0.020747722925576608],
            [10.52498605575336, -0.014607061614962044],
            [10.530121305209457, -0.016018631566805507],
            [10.536011822658987, -0.022219861175885466],
            [10.539442456681469, -0.02400926288679917],
            [10.548207574276864, -0.018543176814058347],
            [10.550694213543084, -0.011704838919279668],
            [10.553988525832894, -0.008647128656813918],
            [10.558524582696586, -0.010925974177353217],
            [10.5574032763165, -0.014292906294843949],
            [10.561832069885124, -0.018367095752002884],
            [10.558271671428125, -0.026898688442851332],
            [10.561057979716043, -0.030097756991224744],
            [10.561971817864947, -0.035785346452424725],
            [10.56872190486161, -0.03789107264524722],
            [10.567721022033883, -0.04312224121619451],
            [10.572366000243118, -0.04685751617377043],
            [10.577995659233016, -0.049532542652376395],
            [10.58188104927934, -0.047719566627366136],
            [10.582744530582348, -0.05153641396161042],
            [10.58755742921637, -0.053539355401943996],
            [10.590047870366442, -0.0505011398383213],
            [10.591747605507265, -0.05184393054117494],
            [10.592382829909505, -0.05845670658192455],
            [10.595086101045679, -0.06279065068192018],
            [10.597987964134646, -0.06363944445346796],
            [10.599052431366271, -0.0731635283665003],
            [10.602648767214621, -0.07399700550406318],
            [10.605191241662526, -0.0822347098097052],
            [10.611522676675035, -0.08825751264816269],
            [10.611723710422448, -0.09239501522878733],
            [10.609263535310735, -0.09870292166298157],
            [10.611828948663376, -0.10132055936211323],
            [10.618258429090314, -0.09868704224665184],
            [10.61963897926612, -0.10432234352170852],
            [10.617541604696479, -0.10855592830376684],
            [10.619116162698486, -0.11446009095172191],
            [10.617324378624495, -0.11855051433335943],
            [10.613613105769534, -0.11469347219650926],
            [10.608897282454727, -0.11978329552957091],
            [10.604557329666704, -0.11485249744700178],
            [10.600338404697206, -0.11747159034526596],
            [10.600694763529214, -0.12290972850525486],
            [10.605716775827487, -0.12985278538397743],
            [10.606240350226644, -0.13807727495128908],
            [10.602896932157869, -0.14493751033148314],
            [10.600327953468883, -0.14357067971733145],
            [10.595367784623393, -0.14762358857471597],
            [10.592369546496762, -0.15692892770593822],
            [10.584345527744585, -0.15366062288901142],
            [10.57812434809769, -0.1500510934460593],
            [10.576469193283186, -0.1431046010384385],
            [10.568419641300316, -0.13808111539109508],
            [10.565589493237555, -0.13307349590599757],
            [10.561738433977226, -0.13565079120878154],
            [10.561939368540335, -0.14162885105231646],
            [10.558806364134373, -0.14215751287889103],
            [10.561238508074167, -0.147941611241751],
            [10.550484060032563, -0.15156677094552637],
            [10.544986882352172, -0.14942312821240764],
            [10.535005468144279, -0.14239405914422543],
            [10.534886332542, -0.1401282952062119],
            [10.526242406740606, -0.13746509028203502],
            [10.522463402832429, -0.13482314040435656],
            [10.513999827763758, -0.13586733436032472],
            [10.508382095044752, -0.13267576717720225],
            [10.50631553670792, -0.1350675178557271],
            [10.493163252362143, -0.13440389116327758],
            [10.48968305007113, -0.13687767531034023],
            [10.507560808691414, -0.16358039407333136],
            [10.477803237405027, -0.1905650568729444],
            [10.464980407218468, -0.2024524462761472],
            [10.465470547714915, -0.2051496563037348],
            [10.462862358104914, -0.21311523643606245],
            [10.460416009326812, -0.215541420097027],
            [10.452762625762064, -0.21898853486723216],
            [10.447169759825004, -0.21699821476418038],
            [10.440399373078478, -0.21858584376759768],
            [10.437132758730783, -0.22645273215245618],
            [10.434766074188518, -0.22882839198690988],
            [10.434472037803822, -0.23574043979767215],
            [10.429707977444222, -0.24364731404088674],
            [10.431970478983597, -0.24772410420575228],
            [10.424598963442975, -0.2480634157562655],
            [10.423216983897731, -0.2513122348006014],
            [10.419339404348191, -0.2525676865840057],
            [10.418283018200947, -0.25573876741918367],
            [10.414334891381888, -0.25642670469773987],
            [10.413116146248031, -0.26331233050963077],
            [10.407093120894674, -0.2685930540751087],
            [10.40496745018533, -0.26879614973057175],
            [10.40318272246735, -0.2743465064860867],
            [10.398965339076252, -0.2774337104787781],
            [10.422528638368238, -0.29674989829089227],
            [10.424545454097471, -0.3030540160467724],
            [10.417857329814971, -0.3076882988182639],
            [10.419660121358888, -0.3128719977685494],
            [10.417639434902984, -0.31796331344206524],
            [10.41199792838407, -0.31741285388533585],
            [10.411396018682455, -0.3243382499081232],
            [10.412650293008845, -0.3308034660213724],
            [10.409875776108613, -0.3286342286401507],
            [10.40383979397596, -0.32969518596827385],
            [10.396995317019364, -0.32653001927526726],
            [10.395778027641779, -0.3198773563126456],
            [10.396356431748256, -0.313754257871463],
            [10.393840829561876, -0.308833273300621],
            [10.389397261128835, -0.31129181970807007],
            [10.38933334893595, -0.30375235150108243],
            [10.384572378316607, -0.3025037924787019],
            [10.371821071763392, -0.30353912770118435],
            [10.36916950783764, -0.2987794832473341],
            [10.364382763568118, -0.29686685148749536],
            [10.35733139715978, -0.29702038019389326],
            [10.35616627603807, -0.29348739527842393],
            [10.350646697825388, -0.29240073917158815],
            [10.349967602609635, -0.2872467691870318],
            [10.353101955217133, -0.27655343534029625],
            [10.352991355106099, -0.27061815696758384],
            [10.348780511581444, -0.2669943413813563],
            [10.346555123527976, -0.2722595500299206],
            [10.342586266862542, -0.2677165920285607],
            [10.336705581344223, -0.2665583618489826],
            [10.334192312179148, -0.2608206522939367],
            [10.332316331553251, -0.2610208647214684],
            [10.325700405702666, -0.2561427956177978],
            [10.321698230796374, -0.25478211980931936],
            [10.310540186767703, -0.255252637012828],
            [10.307080665059605, -0.2564206932497676],
            [10.305280600304561, -0.25408964828614566],
            [10.304429225509896, -0.24754154073567528],
            [10.302667712776833, -0.2426359685710828],
            [10.285022499064581, -0.2436884669994322],
            [10.279228797418615, -0.24196947794799226],
            [10.274936340561517, -0.24444094209619632],
            [10.274207436669132, -0.24122406083471418],
            [10.270264842508398, -0.24263606768303161],
            [10.265798522862388, -0.24200979381832305],
            [10.262608428846029, -0.23828583883431137],
            [10.258070598307903, -0.23565774784505686],
            [10.25617614566033, -0.23255290773447929],
            [10.25820576552893, -0.22810854582538104],
            [10.253304894969249, -0.22594312280973988],
            [10.248538604758867, -0.22680846278507993],
            [10.24539570954448, -0.22071333453723635],
            [10.238070032670178, -0.2208064091526154],
            [10.229923425927382, -0.22291755417168657],
            [10.222798945964701, -0.2224558021262463],
            [10.221426185791394, -0.21189506286311532],
            [10.215756473142644, -0.2092700585366216],
            [10.212025223971436, -0.20555087086828716],
            [10.214132586093324, -0.20310330462261705],
            [10.20959291374565, -0.19972023850413417],
            [10.205450667470295, -0.20029874537788273],
            [10.20456045681873, -0.19439646901654364],
            [10.20722567869972, -0.19331256816001938],
            [10.207486434548676, -0.17689454783274283],
            [10.240631736754867, -0.11969194411974945],
            [10.236501932767133, -0.027022902224731655]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -83.25885662836372,
          "lat": 37.922348598472034
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21175"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "175",
        "coty_gnis_code": "00516934"
      },
      "bbox": [
        10.20456045681873, -0.3308034660213724, 10.61963897926612,
        0.07211748067768206
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4707052699800767, -6.479425480190625],
            [2.567035611510334, -6.476995082114026],
            [2.592896851656225, -6.476629635755701],
            [2.6015213959796752, -6.47843218854664],
            [2.627266124684433, -6.47761918647735],
            [2.6327769397807246, -6.47658358268154],
            [2.688251080830166, -6.475120969813164],
            [2.6887266042613764, -6.475297662917473],
            [2.8078219258692028, -6.4717092455562195],
            [2.8107164778114475, -6.4767048310651845],
            [2.8097690180066364, -6.478433091217688],
            [2.8119307785446903, -6.485373288107368],
            [2.808682200584444, -6.500204334993571],
            [2.811488366994721, -6.515459529040894],
            [2.8203766315859298, -6.5217416357618925],
            [2.8280948423925807, -6.528829262879551],
            [2.8274696495170746, -6.5349175823119845],
            [2.829513789108538, -6.538659712340172],
            [2.8266516739016523, -6.542348041297642],
            [2.8308022520703022, -6.548626493499749],
            [2.8329918789029973, -6.5585074706233675],
            [2.83439960894805, -6.564028949683995],
            [2.8404498105933054, -6.5668573527250285],
            [2.844622719610512, -6.575972697971248],
            [2.848775473422109, -6.578960306783119],
            [2.8524483887506866, -6.585384887171368],
            [2.8541689089194646, -6.590651554294985],
            [2.8592098446801346, -6.59506838833827],
            [2.863571546879096, -6.601548561870262],
            [2.863294087177738, -6.603560341493398],
            [2.8538721072184474, -6.613017669172769],
            [2.8574207879606095, -6.624951742593329],
            [2.8702513028298253, -6.633121463397169],
            [2.8724778688704813, -6.637256303801834],
            [2.8729203499203693, -6.642202292234744],
            [2.8760710242249505, -6.645162895197379],
            [2.8777293916199933, -6.649238522461469],
            [2.877604498290868, -6.65636017732576],
            [2.873079202028021, -6.661023933464064],
            [2.8715580923898822, -6.666840921614575],
            [2.8640601056014807, -6.676682986927149],
            [2.86163105615299, -6.684590260994904],
            [2.863375095198165, -6.690249582761161],
            [2.861624016921452, -6.696577763982407],
            [2.86450435460082, -6.697772122429343],
            [2.8660069750501225, -6.703026965216703],
            [2.8703050756453172, -6.703879376925383],
            [2.8781029272449983, -6.715753861683383],
            [2.8823686478488377, -6.717180633405578],
            [2.8809715459767937, -6.722123326762427],
            [2.8865840160667275, -6.725247612968901],
            [2.8905293591356216, -6.732714306779939],
            [2.8555566331426605, -6.733759588089248],
            [2.7948978202996098, -6.735096937321906],
            [2.7960478024241864, -6.804110318098789],
            [2.791715814974978, -6.798801012602135],
            [2.7866685750955016, -6.79729447591306],
            [2.7837553605678846, -6.794784262886491],
            [2.7798764753935195, -6.799147067888872],
            [2.775181834352225, -6.807285371948516],
            [2.773379486501311, -6.812712951347461],
            [2.767251088772827, -6.814298881632131],
            [2.7623417933548593, -6.818119007268383],
            [2.760296673616538, -6.821263716089917],
            [2.755127637985071, -6.818367659576689],
            [2.7523016092028145, -6.819590320214661],
            [2.745222324523078, -6.815810598318052],
            [2.7419010377352064, -6.811627034452257],
            [2.7373909781151253, -6.814360623973809],
            [2.7325854064791573, -6.819525187778536],
            [2.727647725120678, -6.8208930090770385],
            [2.724258777632515, -6.816890339927253],
            [2.7101986296421368, -6.814778361496561],
            [2.7024418467788847, -6.811615468754749],
            [2.7028555805957972, -6.808286825770809],
            [2.706058184548683, -6.804905787168686],
            [2.701770406295542, -6.801732275987506],
            [2.7000334777971475, -6.79185524643994],
            [2.695968529850759, -6.790297918215859],
            [2.69369059667608, -6.786724979541692],
            [2.698996644609993, -6.781315719377585],
            [2.697306733471341, -6.778338315346594],
            [2.696594966473761, -6.773684997351007],
            [2.6878765856140747, -6.77483865975857],
            [2.684649635927163, -6.766746059753126],
            [2.683999193689226, -6.758716090670819],
            [2.6809885463660708, -6.756691699315663],
            [2.681797033451077, -6.749076532816429],
            [2.6788791887788217, -6.745575141006021],
            [2.6749970808115857, -6.746305366437451],
            [2.6657060336455385, -6.737518544276945],
            [2.657958898200206, -6.73341609972349],
            [2.65443391897617, -6.729488934846761],
            [2.6526050908850967, -6.723908425919867],
            [2.6457190577065797, -6.723301171233903],
            [2.643036744704743, -6.726957311567039],
            [2.6388096413981152, -6.7285426734057],
            [2.6390825019611905, -6.723908472090911],
            [2.6368903972993096, -6.721835223903079],
            [2.628361882575108, -6.72425345423486],
            [2.6228794231543864, -6.723331105591418],
            [2.618152706683922, -6.713789162873187],
            [2.613006884955537, -6.711637239502103],
            [2.6085097678314524, -6.706445892073572],
            [2.6081070981107204, -6.699550221269668],
            [2.605379033200239, -6.696168399534095],
            [2.6062083639758855, -6.692262809335563],
            [2.603243077021845, -6.691380044842694],
            [2.6018870370029186, -6.687778931019189],
            [2.5931756271836828, -6.686819180870519],
            [2.5884866166118985, -6.681642352228552],
            [2.5884306633618785, -6.672842865182852],
            [2.58952866800736, -6.666308139570169],
            [2.5885515497400173, -6.6566677391435745],
            [2.586107674544762, -6.654399606778801],
            [2.5704868226106905, -6.651218488217434],
            [2.566270436496977, -6.648056405458883],
            [2.5665718181290114, -6.641009978510957],
            [2.564573796514785, -6.6377598789114405],
            [2.5597521643884806, -6.63415874328288],
            [2.5593544836984408, -6.628858705240275],
            [2.551831808143794, -6.624526280212392],
            [2.544561121526518, -6.617189778370901],
            [2.538197195046986, -6.613502096340096],
            [2.5358188500721393, -6.609273133678456],
            [2.539758975310819, -6.601878592736356],
            [2.5450520691900542, -6.599021710354694],
            [2.551078389063209, -6.5891045920326885],
            [2.5574094755905477, -6.589030256886943],
            [2.560988108097885, -6.5868049354363025],
            [2.5619608457564924, -6.582332241823839],
            [2.5521756632642356, -6.570159810486822],
            [2.551255512638258, -6.562717634719562],
            [2.550767913389047, -6.547803619765953],
            [2.5483117673401927, -6.544292263885609],
            [2.5490701464318035, -6.537907709629235],
            [2.5442173044948895, -6.529548445807569],
            [2.539834260349474, -6.527013400035445],
            [2.538640815746296, -6.522370098499014],
            [2.5274080106612873, -6.52181766835868],
            [2.5204909800168354, -6.523546024295801],
            [2.511818035877026, -6.520781250632631],
            [2.5017050894419817, -6.515138016149432],
            [2.4894443904829924, -6.510772257588723],
            [2.4852018184339495, -6.505038808444559],
            [2.485683302147086, -6.49676086439847],
            [2.4804435959064746, -6.4915714510214],
            [2.47778875922506, -6.484880305750792],
            [2.4719798454991437, -6.482163137496608],
            [2.4707052699800767, -6.479425480190625]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.3398535063843, "lat": 32.093095536966985 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22081"],
        "coty_name": ["Red River"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Red River Parish"],
        "coty_fp_code": "081",
        "coty_gnis_code": "00559472"
      },
      "bbox": [
        2.4707052699800767, -6.821263716089917, 2.8905293591356216,
        -6.4717092455562195
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.192318703534295, -5.680807246558839],
            [3.2429860242610893, -5.679583854522751],
            [3.376404087668829, -5.676469420308467],
            [3.404733433216322, -5.6755782165335225],
            [3.469619845518046, -5.674166768400905],
            [3.5162680583761765, -5.673040095193557],
            [3.5522731652278887, -5.671896513990493],
            [3.610465673893632, -5.670640504476521],
            [3.7386158464577264, -5.666386428540216],
            [3.7386414301000075, -5.666385568120356],
            [3.7407427128391966, -5.673030076933279],
            [3.7365458111103265, -5.677653844588227],
            [3.737439630633514, -5.68687655987957],
            [3.731735859317745, -5.690032495160255],
            [3.7290111621092863, -5.693374424985854],
            [3.7346584221898, -5.701005466270734],
            [3.734281976979272, -5.705202921415227],
            [3.728532118408574, -5.70563146809179],
            [3.7265271088872174, -5.7099467234217585],
            [3.7284578716735894, -5.712982129300016],
            [3.7274634758865632, -5.718087581167878],
            [3.731304702691831, -5.717557173162243],
            [3.731298859106086, -5.723655163482775],
            [3.7338534861654002, -5.728377257781025],
            [3.7336550368693664, -5.732767441033078],
            [3.735262032394524, -5.740975302589511],
            [3.7390213788047073, -5.749477184532225],
            [3.738543987738376, -5.751792412276676],
            [3.734039162586406, -5.7524274651760985],
            [3.7347684309119478, -5.75919698275543],
            [3.7328565763443495, -5.762124093816286],
            [3.735113084750626, -5.765007251142564],
            [3.732861734737377, -5.770162541651568],
            [3.7325971831061047, -5.774739202911216],
            [3.736474737935868, -5.781717610859042],
            [3.7342000852550257, -5.784731567939017],
            [3.731068083109942, -5.792943249381076],
            [3.731678627591161, -5.7999762734625415],
            [3.736732506564171, -5.809989495966781],
            [3.7476836284347224, -5.824791287857584],
            [3.755073558155694, -5.8295914756055724],
            [3.7564969913611725, -5.836623064436815],
            [3.7501150924990965, -5.838403033199013],
            [3.7474876536727484, -5.840583869113177],
            [3.747614014203065, -5.84482492791769],
            [3.7528300633364124, -5.847348577527119],
            [3.7524608633515713, -5.850163548062344],
            [3.748863060614367, -5.853061488232456],
            [3.753550095600294, -5.865724588053128],
            [3.759035220809186, -5.874035038473686],
            [3.7610464998329287, -5.879302519263035],
            [3.759966087007982, -5.896209661779221],
            [3.7566287536120506, -5.906142410729619],
            [3.753711804774304, -5.912210637760092],
            [3.755869153718476, -5.924183407355],
            [3.7629993182707633, -5.929992826354281],
            [3.7635099753576555, -5.937067822425112],
            [3.7559992859545703, -5.942361881896031],
            [3.7579796018468112, -5.947220037294929],
            [3.7536382342194408, -5.9514455655657885],
            [3.7481967086547354, -5.958495763325733],
            [3.7444088579831223, -5.967026507948011],
            [3.7404366972827328, -5.970831291536959],
            [3.7366930078760223, -5.979029044469116],
            [3.735320113602688, -5.985144866545284],
            [3.7332506475835316, -5.988720897023934],
            [3.7295573732041056, -5.991086660498237],
            [3.7204347011091112, -5.99239917259414],
            [3.712238588870824, -6.001161877987228],
            [3.7097029184628356, -6.002660558906233],
            [3.7017395310588572, -6.000556793060667],
            [3.6949405816944307, -6.00143972024499],
            [3.6923986109294082, -6.003160352671121],
            [3.692241504564749, -6.008479830121921],
            [3.6951950729482954, -6.016065193035568],
            [3.6298132390856654, -6.067751002441946],
            [3.627368737165536, -6.069334087953689],
            [3.6258359573697874, -6.0755052132574665],
            [3.627045533191587, -6.085776429639293],
            [3.624400882868445, -6.089059658210165],
            [3.618796978544122, -6.092043150658743],
            [3.6153562662984564, -6.090595427343781],
            [3.606082135398751, -6.091404560054428],
            [3.5994122705646068, -6.097339863893626],
            [3.594119408018987, -6.098832127200524],
            [3.5890670076125315, -6.097331253959475],
            [3.586604124726847, -6.100211628347543],
            [3.581649485214139, -6.100231690387916],
            [3.574527642185092, -6.097485465744659],
            [3.5733086495181294, -6.098341487385993],
            [3.565953438655181, -6.094206447833376],
            [3.5585434952741304, -6.099689496095852],
            [3.4971728624320786, -6.102116438701678],
            [3.4664238943134755, -6.103045920882695],
            [3.465923352814056, -6.093302398726923],
            [3.4631584725345963, -6.0156917373426655],
            [3.4558897853316433, -6.016219444180065],
            [3.376303252393805, -6.018350419870682],
            [3.374612078789598, -5.972880176694505],
            [3.372970768414758, -5.969106637048042],
            [3.3657867448162384, -5.969771441698878],
            [3.361385360701687, -5.968334430248441],
            [3.3577777714886223, -5.970833905303221],
            [3.3506446549600244, -5.971362342978627],
            [3.347138073049137, -5.967009959514586],
            [3.3476665721521406, -5.962390625928679],
            [3.343306131251084, -5.955948324647353],
            [3.3401697942022204, -5.954129096809675],
            [3.3351461795586053, -5.948448978036296],
            [3.3332140992126735, -5.944459582716367],
            [3.329744580078059, -5.942177300385649],
            [3.324668256629378, -5.9453940056562775],
            [3.316538736976807, -5.942663270092775],
            [3.310272566883476, -5.935792340532501],
            [3.3060944386204154, -5.935871121917998],
            [3.298992108056812, -5.93891705848197],
            [3.2944047477650353, -5.9394853268653485],
            [3.2830863470906966, -5.9355055497210785],
            [3.28172942917044, -5.932783092864321],
            [3.274427405475337, -5.93345202158968],
            [3.200600318063293, -5.935831953301513],
            [3.1990525694530922, -5.891962161039587],
            [3.19185574191304, -5.892159513292077],
            [3.1913518845696704, -5.877361890745763],
            [3.1985004078631003, -5.877136148594715],
            [3.195147586703627, -5.7712773390470105],
            [3.192318703534295, -5.680807246558839]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.37478821161092, "lat": 32.83179629999422 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22111"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Union Parish"],
        "coty_fp_code": "111",
        "coty_gnis_code": "00559528"
      },
      "bbox": [
        3.1913518845696704, -6.103045920882695, 3.7635099753576555,
        -5.666385568120356
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.684705226192923, 2.4373481286593126],
            [14.802818313525426, 2.4611843426147186],
            [14.847378827352832, 2.469912567503313],
            [14.89404425567405, 2.4802714676781505],
            [14.928829273454939, 2.4870370720836705],
            [15.005653313253067, 2.503136435987833],
            [15.001326699745764, 2.4493298415890745],
            [14.99561042244224, 2.363811840009629],
            [14.9950517989529, 2.351501493679922],
            [14.991893326170068, 2.305566965811899],
            [14.990603486006167, 2.273700454801583],
            [14.99142488578898, 2.2620911411055604],
            [14.99341081044525, 2.260596750421575],
            [14.992371524414077, 2.255074921193403],
            [14.98835299395134, 2.253778046086761],
            [14.987852746434788, 2.2481891580294233],
            [14.983448888889475, 2.2453214330662057],
            [14.984128105451399, 2.2373797684852335],
            [14.983060167252411, 2.2333944706848285],
            [14.97953605389124, 2.231194325824115],
            [14.985346194627875, 2.226818751831349],
            [14.980096863744151, 2.2246172179377144],
            [14.987865630268425, 2.2213611831019393],
            [14.990774474709943, 2.224321648280961],
            [14.993446575511706, 2.222704330215677],
            [14.990386793968852, 2.217036373521784],
            [14.98532439868653, 2.2162109531045346],
            [14.987353021471337, 2.2108591885807507],
            [14.983979315868927, 2.2076818021658444],
            [14.983162492670022, 2.2038650191488536],
            [14.98395467625988, 2.197694116445457],
            [14.986473414019699, 2.199139712208972],
            [14.990974949701846, 2.1949153746606505],
            [14.991740924713323, 2.1924431305332153],
            [14.997272903544706, 2.191982771887509],
            [14.996412990063513, 2.1889249311423296],
            [14.997323395211748, 2.1802566689242977],
            [14.996745495752153, 2.1758149754711256],
            [15.001011545374977, 2.174341047900738],
            [14.997336712659257, 2.1687473481356907],
            [15.002055161495706, 2.166880641588382],
            [15.004108312243773, 2.160204506954092],
            [15.001971383662156, 2.1593809106359814],
            [14.996078017787019, 2.1526445791187196],
            [15.000216737435013, 2.141483184622312],
            [15.004386689778064, 2.136592916044255],
            [15.006671558657608, 2.1363810071135623],
            [15.009896361296649, 2.129326674456799],
            [15.00933661734895, 2.1223545954478915],
            [15.002548693540193, 2.1240450253322503],
            [14.997316294719964, 2.1213940236795334],
            [14.994233234328108, 2.12339583319833],
            [14.990878640115508, 2.1226729165675673],
            [14.986180448093746, 2.1184462026226387],
            [14.983358328980675, 2.11753756905108],
            [14.973271774430842, 2.1188923379350197],
            [14.96913056158974, 2.12195448418197],
            [14.963510784812405, 2.120533794356792],
            [14.957182403054842, 2.122232990442785],
            [14.956657464905385, 2.1196599078027547],
            [14.947640218460513, 2.117947176787717],
            [14.941496056296678, 2.1226023232981968],
            [14.937915824796315, 2.119374919343619],
            [14.92668345210528, 2.1170428228939375],
            [14.92164823383698, 2.1104779186782325],
            [14.91317542328943, 2.107604693463322],
            [14.90867644580655, 2.1043640249584112],
            [14.904578314355112, 2.1045180379400468],
            [14.903894883929782, 2.1015369399239456],
            [14.897824158270808, 2.1008612052754203],
            [14.894781840312493, 2.104332434097244],
            [14.884689400326499, 2.1071966146359102],
            [14.880582422982576, 2.1053884385320463],
            [14.873830415824283, 2.104743816568839],
            [14.869845748670345, 2.106165874493583],
            [14.86265999662006, 2.1054501969914146],
            [14.859459143511337, 2.1084098941201046],
            [14.852844912452184, 2.1089218368468403],
            [14.840124098148387, 2.107467647673085],
            [14.83724676196985, 2.104558488294611],
            [14.83009536177068, 2.1027806777589864],
            [14.82282435612258, 2.0983493194668914],
            [14.817093993137957, 2.093739694590419],
            [14.811802793241558, 2.0834367814159602],
            [14.807530263523054, 2.0800039953886036],
            [14.804060231453954, 2.080144830250513],
            [14.794008660638962, 2.082697147068824],
            [14.793469836495694, 2.0881125694465994],
            [14.793971689728052, 2.0972815898183024],
            [14.79756364691118, 2.1034694735011965],
            [14.797172050087067, 2.113113616982828],
            [14.797844189595894, 2.1189953577674703],
            [14.79686822576938, 2.1216938745030745],
            [14.798615102812747, 2.1364429410808228],
            [14.798232461516672, 2.1436511033364285],
            [14.796770945520716, 2.150183598545359],
            [14.800788597850877, 2.156270283178564],
            [14.804399111050856, 2.1655002275982387],
            [14.807180416790144, 2.177822470569801],
            [14.80781875677567, 2.1858038549049428],
            [14.811881429185867, 2.195757218518948],
            [14.807912463596402, 2.200351524542184],
            [14.807013815751299, 2.213582002179602],
            [14.811153334514211, 2.222013674754762],
            [14.812544727189827, 2.228114469884728],
            [14.809017451779747, 2.2333919126486905],
            [14.807190653348153, 2.233038685925144],
            [14.791806370052228, 2.242359093964911],
            [14.789162155984224, 2.240789423781104],
            [14.784295927672437, 2.247513492213992],
            [14.783082737378002, 2.2518799759142483],
            [14.774238013526618, 2.2515703595624186],
            [14.770321635705015, 2.2616420041115575],
            [14.767370677904085, 2.262275866443984],
            [14.763026195516076, 2.2601271305119166],
            [14.756085648728105, 2.2611048953978714],
            [14.754659275360254, 2.265427620740672],
            [14.755895829863906, 2.26882159750897],
            [14.752970317493578, 2.27271394180261],
            [14.753932387437215, 2.276205076276716],
            [14.74827061613889, 2.28500602807535],
            [14.745594884562259, 2.285866475429377],
            [14.742228566394099, 2.2836217801866314],
            [14.738119955892632, 2.2866034506870543],
            [14.737523972458586, 2.2899723010187136],
            [14.733626721801544, 2.293874942553497],
            [14.730875925852187, 2.294615849665936],
            [14.7253820121345, 2.3000443357282],
            [14.717118745038233, 2.2986811154663966],
            [14.714574815205946, 2.293687240580613],
            [14.709360980213804, 2.2945851620763187],
            [14.710894944989388, 2.2985579610022597],
            [14.70772668174933, 2.3011529703402602],
            [14.702060071087466, 2.3003612738258092],
            [14.69781915309885, 2.3042757535719427],
            [14.694385763320303, 2.3045275933520517],
            [14.68597730952843, 2.309115626706426],
            [14.682854892488248, 2.315197969112199],
            [14.678185183840153, 2.3165097485866304],
            [14.67570375506513, 2.31471849272185],
            [14.674581938080234, 2.3065299370963794],
            [14.671764533899578, 2.310047741531901],
            [14.667901785961881, 2.3118369637998506],
            [14.666424541796083, 2.3166825654119694],
            [14.655460193392786, 2.3160636238077754],
            [14.65465536074507, 2.3125823983345155],
            [14.647317778043702, 2.318201004634533],
            [14.644122615435963, 2.3184726342664788],
            [14.637055022942121, 2.3240757950414492],
            [14.640847201193829, 2.3269925324598235],
            [14.640997484786922, 2.331087658271304],
            [14.637156213174807, 2.3316215712244963],
            [14.633148729634913, 2.3352919824575276],
            [14.630183483700144, 2.343925003347132],
            [14.63289423915179, 2.3458847592858203],
            [14.64002185874546, 2.3442416531736407],
            [14.641322375782291, 2.3412171060007734],
            [14.646732989019176, 2.3378081939497957],
            [14.657261073428828, 2.3406359593191817],
            [14.654765750633338, 2.3452722396894643],
            [14.659583783727959, 2.3521146258230448],
            [14.655316835576828, 2.356534183371983],
            [14.656796913217654, 2.361374926894465],
            [14.660831794255056, 2.365807071316894],
            [14.65923792670522, 2.3720071060220116],
            [14.661823193348907, 2.376387744771374],
            [14.666930820740667, 2.3753946548947686],
            [14.667220160082731, 2.3801893367331752],
            [14.670989960273237, 2.38059244794098],
            [14.675064813200422, 2.38392502527881],
            [14.68006406575797, 2.392819380984873],
            [14.677441713132835, 2.400118628957321],
            [14.669705469338133, 2.405844834742283],
            [14.670246525933555, 2.4087625353429165],
            [14.683203447635668, 2.4101448705033635],
            [14.688825868056435, 2.413843615452007],
            [14.690190106776427, 2.4170795457858336],
            [14.686870635320046, 2.4202639238781845],
            [14.682319037987062, 2.4209589507660088],
            [14.680200925917235, 2.426006632998774],
            [14.687273088979158, 2.4306710532126092],
            [14.687142555394523, 2.4346105998177525],
            [14.684705226192923, 2.4373481286593126]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -77.02254383583137,
          "lat": 39.562954102284074
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24013"],
        "coty_name": ["Carroll"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Carroll County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "01696228"
      },
      "bbox": [
        14.630183483700144, 2.0800039953886036, 15.009896361296649,
        2.503136435987833
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.338955677105156, 1.313661704076329],
            [15.3462239637054, 1.309766302697942],
            [15.351913699173336, 1.303702746071429],
            [15.360917495137562, 1.2915261862961938],
            [15.361817525562138, 1.2873474734374488],
            [15.360995899812508, 1.2826990419640423],
            [15.362891939779397, 1.280253513331658],
            [15.368108125533203, 1.2784139595894475],
            [15.37887835157156, 1.2722510934643192],
            [15.387917848530414, 1.2660914550252018],
            [15.391270076213958, 1.2618886401497398],
            [15.396039765571988, 1.2584325689924352],
            [15.398866947589012, 1.2541213707297623],
            [15.404238083790267, 1.249646714193692],
            [15.412686180807535, 1.2503432139101325],
            [15.418069651944197, 1.2467451027745389],
            [15.42953057719714, 1.2413131991732298],
            [15.44180484700206, 1.238412411114025],
            [15.446582987517683, 1.230452730078929],
            [15.452006680608294, 1.2292289928466826],
            [15.466159875973531, 1.2349744141307746],
            [15.474850829910276, 1.2291257358662229],
            [15.482699941047878, 1.2218117701449287],
            [15.490269013136205, 1.2190906845187777],
            [15.496129736204638, 1.2151475889395669],
            [15.506288089091598, 1.2056593166526517],
            [15.511522902999118, 1.198778689980695],
            [15.516261200354908, 1.1883483893933218],
            [15.516422227617017, 1.1829822918237929],
            [15.514480535525122, 1.1730854046137178],
            [15.516213921489872, 1.171643642222015],
            [15.523297373238897, 1.1739468174542649],
            [15.528316944221627, 1.1728821353943553],
            [15.526210159990477, 1.1642686668130444],
            [15.527391754385684, 1.1608609868001756],
            [15.532472545892103, 1.1573035015131459],
            [15.539824816833976, 1.1487372839820058],
            [15.54435020995941, 1.1446788241614267],
            [15.558128712412957, 1.1446672935838085],
            [15.567135256187175, 1.1494333250672193],
            [15.56991340883692, 1.156458773587009],
            [15.56996973426246, 1.1607023819717488],
            [15.58051413378422, 1.1626171361863602],
            [15.58551331764667, 1.1657789458684913],
            [15.586219208106293, 1.1689466590598176],
            [15.589707287349777, 1.1688036656673761],
            [15.601672847245299, 1.1656325922389468],
            [15.607362344527973, 1.1629960148869356],
            [15.607159184999656, 1.1579052608754714],
            [15.60103027048095, 1.147417057742049],
            [15.597178996455991, 1.1390111800195863],
            [15.59594059882835, 1.1271624596550658],
            [15.597179320132522, 1.1194657981660654],
            [15.60164418211225, 1.1094774046710942],
            [15.605601813676532, 1.1025382632059302],
            [15.616486783259203, 1.0806644298572332],
            [15.639605605759117, 1.058992563063322],
            [15.645075823570165, 1.0505783265095416],
            [15.64885807163381, 1.0465794641069162],
            [15.667278669844375, 1.0314006939915747],
            [15.674072623330058, 1.0217776616328687],
            [15.676416050427488, 1.0208686713031732],
            [15.682550413571061, 1.012594176537874],
            [15.674753952017547, 0.997812451562],
            [15.671308886863038, 0.9876373427867584],
            [15.681597298531209, 0.9724313262579253],
            [15.68331003354602, 0.9678696933967966],
            [15.685530725756442, 0.9576392571614527],
            [15.688892922101857, 0.9459027840575125],
            [15.699686597534194, 0.9247070087700667],
            [15.701675391957028, 0.9188590183075385],
            [15.700348885671692, 0.9164333875476987],
            [15.696214532725099, 0.9228759938895355],
            [15.692977596484473, 0.9248767784317629],
            [15.686948845947752, 0.9259863514624741],
            [15.675340083198575, 0.9232261942239446],
            [15.672782779798318, 0.9264772012634841],
            [15.667545300845743, 0.9281533766572443],
            [15.662604817020046, 0.9347500148755781],
            [15.655345843520255, 0.9462533414446159],
            [15.655022877446967, 0.948429433000512],
            [15.643302624315293, 0.9564921826009499],
            [15.637945128637716, 0.9575701408581294],
            [15.63777147503401, 0.9614083415013583],
            [15.634844913999212, 0.9660290094922394],
            [15.624061175815621, 0.9679799024506507],
            [15.618136726729517, 0.9666484793811335],
            [15.616052110104732, 0.9637113959041197],
            [15.612168272973053, 0.9645295963780973],
            [15.607151837971937, 0.9723729930737159],
            [15.60238762454458, 0.9762506100903315],
            [15.601190575167047, 0.9828268445810355],
            [15.593487128074681, 0.9916422714199806],
            [15.592939361370078, 1.002380745684872],
            [15.58741307354743, 1.0057582757848489],
            [15.59149461079663, 1.0106586405640636],
            [15.587380846390749, 1.015871918914189],
            [15.579193932541969, 1.012524600664615],
            [15.571351203262488, 1.006167284404319],
            [15.565459934489398, 1.0035892273233846],
            [15.566980033980725, 0.9994721810942063],
            [15.570449861990634, 0.9964360382265961],
            [15.57209873172768, 0.9921529863690243],
            [15.574782246850347, 0.991073562394936],
            [15.575929750009045, 0.9831142980489144],
            [15.572384298340193, 0.9698687332265938],
            [15.573198620676068, 0.9661914026123647],
            [15.576595128883863, 0.9626273132765036],
            [15.578287104763186, 0.9580396427949971],
            [15.573082665302557, 0.9532760750922029],
            [15.568413479623421, 0.9583069049561095],
            [15.564511452293825, 0.9647311696285314],
            [15.547563453426816, 0.9800690430729245],
            [15.543700086374475, 0.9841288364022984],
            [15.53820691009499, 0.9848745114694005],
            [15.530789615205682, 0.9835777751464533],
            [15.523522639231171, 0.9749850683247847],
            [15.518578096574005, 0.9868906598851829],
            [15.516765248860676, 0.9863130588726811],
            [15.511623703055907, 0.9920122433885181],
            [15.50530418347915, 1.0034686563509043],
            [15.501667062674084, 1.013334982220363],
            [15.499575415653181, 1.0145559425288024],
            [15.49786337601632, 1.0202412957554023],
            [15.49501328876205, 1.023849866738074],
            [15.488156891644831, 1.0294064263736133],
            [15.476693708981331, 1.036970853603642],
            [15.469855429506795, 1.0391441240564014],
            [15.46076560863049, 1.0445944902273114],
            [15.43691573790225, 1.0485194608916417],
            [15.426496445420497, 1.049306399677549],
            [15.415362852076504, 1.046459570159455],
            [15.410923041674156, 1.0468451957464275],
            [15.404650600650031, 1.049830257719112],
            [15.393538582879106, 1.0515188877159363],
            [15.38562026580202, 1.049593110396689],
            [15.382792049419205, 1.0504876411767612],
            [15.38170340461464, 1.0562289080694105],
            [15.37278333157087, 1.0537187386557392],
            [15.370613712916512, 1.050962030869088],
            [15.369752591585, 1.0458296536091083],
            [15.36725924996862, 1.0460710828573265],
            [15.36256967009054, 1.0433703567280526],
            [15.358445598980959, 1.043007619631331],
            [15.35796216479731, 1.047781736866026],
            [15.355053001319224, 1.0504551821661585],
            [15.346532351463962, 1.0538027680084054],
            [15.344208657116853, 1.0499578108987069],
            [15.342634794042104, 1.0418946291371574],
            [15.339666832859285, 1.0385380934640538],
            [15.340544133325125, 1.0337769553756198],
            [15.335977464784941, 1.0270187538003672],
            [15.326333950682185, 1.029040778793324],
            [15.314616589683343, 1.0291803568643687],
            [15.313231327082233, 1.0350370117065968],
            [15.315339621227517, 1.0367204742374647],
            [15.31232296707785, 1.0436051537055508],
            [15.305907915963495, 1.0449843407157868],
            [15.305132152429211, 1.0487685666194928],
            [15.300841746742648, 1.049909479425739],
            [15.293338509590944, 1.046929822167131],
            [15.28924600137591, 1.0499319193220338],
            [15.287103142514608, 1.0584541938412246],
            [15.283262867395747, 1.0644998299286854],
            [15.286917445938338, 1.0732143323897658],
            [15.28594876476453, 1.0771805876995517],
            [15.281420343021304, 1.0810673587710378],
            [15.276460265650272, 1.0814568932580475],
            [15.274901228753238, 1.0858485466732966],
            [15.263866593319728, 1.0955600434036772],
            [15.264437637048635, 1.1019692008365143],
            [15.259280440367329, 1.1055261993967727],
            [15.25318342903367, 1.1178278132647426],
            [15.252847341865612, 1.1213132903155174],
            [15.250284819326458, 1.124632221893689],
            [15.24472547330527, 1.1264742745054128],
            [15.249552355839722, 1.13235955447837],
            [15.25264198183975, 1.1333744669274888],
            [15.253609659839997, 1.1392400422674627],
            [15.236180756443133, 1.1439844510900254],
            [15.235685515088957, 1.1483869220819454],
            [15.232515428529913, 1.1539221530530406],
            [15.224982529941428, 1.1584647114764561],
            [15.213872491880192, 1.1623048606441075],
            [15.210553786640794, 1.166710838097389],
            [15.211269081387199, 1.1744413587602263],
            [15.2216858964929, 1.1814469876292446],
            [15.225651352202156, 1.186031059208069],
            [15.225740290883653, 1.1940319070979482],
            [15.227672312724406, 1.1977362554499578],
            [15.231056489369657, 1.2002401683176729],
            [15.233424324135896, 1.207814509802722],
            [15.236828146539711, 1.211791230241164],
            [15.23770345195456, 1.2161610519210908],
            [15.240575181761116, 1.2200375147348699],
            [15.24110339426793, 1.2270259753734063],
            [15.250727943960651, 1.2669463220202155],
            [15.256673811502498, 1.2893793497518289],
            [15.260743933207275, 1.307241928813772],
            [15.264761045552312, 1.312141447070496],
            [15.27692834556604, 1.3154459962282843],
            [15.280220539393989, 1.3148192356575799],
            [15.296625267622618, 1.3174679847444264],
            [15.30521905621494, 1.3168696807072422],
            [15.309084709927966, 1.31759992046576],
            [15.31485998217695, 1.3108232180496484],
            [15.317220024187266, 1.3112934725211476],
            [15.320335943455955, 1.3072524302244786],
            [15.331940714551026, 1.3074613008978195],
            [15.338955677105156, 1.313661704076329]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.60576268625105,
          "lat": 38.302412851396504
        },
        "year": "2023",
        "ste_code": ["24"],
        "ste_name": ["Maryland"],
        "coty_code": ["24037"],
        "coty_name": ["St. Mary's"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["St. Mary's County"],
        "coty_fp_code": "037",
        "coty_gnis_code": "01697853"
      },
      "bbox": [
        15.210553786640794, 0.9164333875476987, 15.701675391957028,
        1.31759992046576
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.459986316877579, 6.982114191246001],
              [9.467853463496146, 6.9769580191652905],
              [9.475758531339599, 6.967789856067548],
              [9.472356067946576, 6.966240884754518],
              [9.466525025373269, 6.971396950982056],
              [9.465426273887728, 6.974986975389184],
              [9.459986316877579, 6.982114191246001]
            ]
          ],
          [
            [
              [9.448987655207032, 6.974934266844561],
              [9.45192486416927, 6.975636333359248],
              [9.45259327889588, 6.979510737162497],
              [9.45615785544731, 6.9788110420677],
              [9.457062971780266, 6.970911794135016],
              [9.451148699986764, 6.969064775237266],
              [9.448420412702829, 6.9709159868074995],
              [9.448987655207032, 6.974934266844561]
            ]
          ],
          [
            [
              [9.397565745269256, 6.987228905744855],
              [9.402728019712214, 6.990259170514082],
              [9.40323315357229, 6.982560901062954],
              [9.398027799158442, 6.98470569345466],
              [9.397565745269256, 6.987228905744855]
            ]
          ],
          [
            [
              [9.35456351707912, 7.107647441970348],
              [9.358252304309797, 7.114286507569065],
              [9.362454546033371, 7.1131183783872105],
              [9.365766954355953, 7.110105468963741],
              [9.366350870358524, 7.10706989368297],
              [9.36316252550203, 7.104266485055709],
              [9.357917448260286, 7.105082513915091],
              [9.35456351707912, 7.107647441970348]
            ]
          ],
          [
            [
              [8.972805855807268, 7.068464155954314],
              [9.000564002691844, 7.073193258415091],
              [9.06258960005891, 7.082919703880205],
              [9.128723501987649, 7.091031731886569],
              [9.143072858915417, 7.09293901761242],
              [9.181900214459029, 7.09862291697324],
              [9.228604476134693, 7.1065661861925715],
              [9.28435686663326, 7.113701595171822],
              [9.316129158873096, 7.118085430134602],
              [9.319542915156386, 7.114894771964491],
              [9.322284765495674, 7.115542647554389],
              [9.3283163798746, 7.1067938480010096],
              [9.33264611441718, 7.097830218961278],
              [9.334971651477694, 7.0858847815573975],
              [9.341917455515913, 7.077328775013621],
              [9.349945102501747, 7.0768878168059555],
              [9.354042382226469, 7.069591415172781],
              [9.357476108827449, 7.066840907846528],
              [9.362115758291909, 7.059285813308483],
              [9.365728852762208, 7.063164212044232],
              [9.37528824096483, 7.060658651534591],
              [9.375685579153918, 7.0587411020721955],
              [9.371332930749569, 7.055242657808206],
              [9.372020276205358, 7.051762987222254],
              [9.377808776184093, 7.045022572197898],
              [9.375084834613043, 7.0395807169419475],
              [9.376167582833082, 7.0348453297977125],
              [9.378967328810113, 7.031662775346513],
              [9.38249720021034, 7.031802382711803],
              [9.383570148990103, 7.0283837565541925],
              [9.38188620917643, 7.025850677470918],
              [9.382751904013517, 7.020393360252673],
              [9.391284230585788, 7.015702499868949],
              [9.387644627345699, 7.009837562126388],
              [9.380281127846347, 7.00868777661556],
              [9.379973019072374, 7.006235653590801],
              [9.384994484231017, 7.004995901371718],
              [9.384673229592442, 7.001437116736743],
              [9.381779300068406, 6.999693031332336],
              [9.381961683724628, 6.995039306496785],
              [9.388210057591971, 6.991650025733647],
              [9.385993616722645, 6.98848810837567],
              [9.389202026249206, 6.986039197394419],
              [9.386785572250336, 6.979491624104745],
              [9.387749895100423, 6.972709640122594],
              [9.392996494758092, 6.96990956569298],
              [9.41041815308876, 6.968460476359184],
              [9.414512078745615, 6.969476843352369],
              [9.420119839513225, 6.963683345353108],
              [9.421659437015482, 6.95894631769462],
              [9.4273546094078, 6.948900321303834],
              [9.421472191951468, 6.9480412097132715],
              [9.418231156598129, 6.949254599703981],
              [9.410501178970911, 6.949783149288629],
              [9.404367849500327, 6.952534320187566],
              [9.39977005151256, 6.952864418050557],
              [9.398362482529654, 6.955233805372263],
              [9.39033139282667, 6.955192848212874],
              [9.386575516408467, 6.958227150897052],
              [9.380873735604492, 6.957674349060496],
              [9.371267658409138, 6.960239558933114],
              [9.368064279514511, 6.9621388649991784],
              [9.364601522056201, 6.966833361092096],
              [9.358294756161929, 6.9671956062184695],
              [9.352672451312998, 6.973168738497425],
              [9.35001801083161, 6.977396314241367],
              [9.352059482372715, 6.980898612092583],
              [9.348579322159464, 6.991156992456302],
              [9.344491095876327, 6.991546896722411],
              [9.33331128217209, 6.9895224537126674],
              [9.331921596122115, 6.981851593285355],
              [9.326787762860105, 6.982712691492342],
              [9.31863812019838, 6.976703047333768],
              [9.313841210551974, 6.975875385558006],
              [9.314382732236465, 6.971965937653876],
              [9.310131398714741, 6.971536509599568],
              [9.30171196184861, 6.963748977080988],
              [9.296050241926455, 6.952878286896127],
              [9.29284094515898, 6.940493205246096],
              [9.294617903903925, 6.9359598885279885],
              [9.292214700828406, 6.932146918675104],
              [9.293678415188893, 6.9247956690416546],
              [9.298106558215112, 6.925851628841736],
              [9.309243834662395, 6.921498133416734],
              [9.312552805621356, 6.9180393065574535],
              [9.31091412186766, 6.915271893639958],
              [9.29621668663447, 6.919097900815176],
              [9.291075095130878, 6.913283429597808],
              [9.29108665039019, 6.903341583975203],
              [9.294328976001372, 6.899615108658417],
              [9.301197328049719, 6.897908993977943],
              [9.305858778204367, 6.889862084875601],
              [9.308376822252463, 6.872819729501583],
              [9.311182851897478, 6.8619464755976445],
              [9.316093742515488, 6.851155870982361],
              [9.32122427561931, 6.843855634637788],
              [9.327446816089706, 6.838509347019344],
              [9.331000353432428, 6.838181480439352],
              [9.335919998713912, 6.834922606701535],
              [9.343019030694498, 6.832563341427967],
              [9.345927699227314, 6.8269179843186025],
              [9.347829458973019, 6.825972913176379],
              [9.348581834599706, 6.82045627864382],
              [9.355311830834223, 6.817164057122498],
              [9.365203586467379, 6.817228457356246],
              [9.367100117785146, 6.813851005060689],
              [9.373649191183544, 6.808265594120674],
              [9.383712933797218, 6.804707887166006],
              [9.389198319763663, 6.803666139476102],
              [9.398782254564715, 6.804929410885588],
              [9.400961901532597, 6.803233786092569],
              [9.407038170272925, 6.8027477433597685],
              [9.410758869470104, 6.800896484494571],
              [9.408776930133477, 6.796865130084004],
              [9.411800069221595, 6.791521875565096],
              [9.4119650739465, 6.788205050694682],
              [9.409312736785441, 6.78088875256113],
              [9.35129521897715, 6.77348912358744],
              [9.337352497318152, 6.771562594356467],
              [9.265615868866577, 6.762952018581798],
              [9.222747865761175, 6.75686401928975],
              [9.180488803576493, 6.751154762704934],
              [9.096986949566569, 6.738249730726952],
              [9.011712723637444, 6.727066403779766],
              [9.011691595382606, 6.727241231656815],
              [9.00037759029885, 6.813002208016262],
              [8.98819700461117, 6.898525409462305],
              [8.995323839269947, 6.899573464580983],
              [8.989800021838104, 6.941742256146918],
              [8.983750340621105, 6.983698408222428],
              [8.977043749731466, 7.026376759369711],
              [8.975068655803922, 7.054696020054161],
              [8.972805855807268, 7.068464155954314]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.6283629733189, "lat": 45.03482706789379 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26007"],
        "coty_name": ["Alpena"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Alpena County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "01622946"
      },
      "bbox": [
        8.972805855807268, 6.727066403779766, 9.475758531339599,
        7.118085430134602
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.36753629100977, 7.081555811137963],
            [8.357631912246768, 7.179829967108015],
            [8.356284922913614, 7.191906993048167],
            [8.344932832880454, 7.282594967704863],
            [8.334686283690607, 7.367375819521834],
            [8.327635160271344, 7.424271885683529],
            [8.32387826324732, 7.451956713721209],
            [8.318668049480875, 7.494990587292516],
            [8.308745984435022, 7.572804717971079],
            [8.31320095139115, 7.572029663479782],
            [8.315741102656622, 7.5692175958081895],
            [8.315010787166111, 7.559905134887877],
            [8.319035344578287, 7.552265430357228],
            [8.322720203542282, 7.5524746088234815],
            [8.335244291399418, 7.548348052971879],
            [8.34789587002708, 7.545215382702544],
            [8.349438527810804, 7.538960135385373],
            [8.356909700566915, 7.535977598681836],
            [8.36299024098096, 7.534800117433356],
            [8.371717283925875, 7.53495866810097],
            [8.384626351462625, 7.526348547115151],
            [8.389713622161105, 7.525046902961083],
            [8.404506415346358, 7.517864668628131],
            [8.426524077993106, 7.509302155712773],
            [8.439337395943134, 7.509335653488464],
            [8.441638322209583, 7.502869572159854],
            [8.444906361123357, 7.49794069914401],
            [8.454305166782522, 7.49292655093143],
            [8.455849366943529, 7.4903381137542615],
            [8.466150781824112, 7.487919219007456],
            [8.47144386740229, 7.482770352582772],
            [8.48106704234418, 7.478635525356938],
            [8.491795465853837, 7.469817072750489],
            [8.49694011834302, 7.4691860772599545],
            [8.500044976987844, 7.464502109313969],
            [8.506707699062124, 7.465669604580551],
            [8.514357281624735, 7.461341893348999],
            [8.525663257063128, 7.465572417178769],
            [8.528209170489474, 7.461687318418036],
            [8.533866639854368, 7.456746606303416],
            [8.539340319426405, 7.458764677949827],
            [8.544442011636828, 7.466079128976032],
            [8.543435884887014, 7.468691830919028],
            [8.537209342674348, 7.47397870537096],
            [8.53176311921444, 7.4748496173159635],
            [8.533860265442799, 7.480642252626216],
            [8.54432848113634, 7.482232528597198],
            [8.55403849873595, 7.47758975766114],
            [8.571811607172753, 7.471852317203208],
            [8.576633608210429, 7.474844640933242],
            [8.587129848295302, 7.477225876783674],
            [8.599528307742833, 7.483964447893845],
            [8.603006568735086, 7.484596653663856],
            [8.621642747313949, 7.479633840512493],
            [8.628308956112349, 7.4771162534529205],
            [8.633664582432411, 7.47652644868278],
            [8.646098358138586, 7.470138976761973],
            [8.655263782943978, 7.468821933160025],
            [8.668017110441236, 7.466102664861535],
            [8.675889776962139, 7.466556523718163],
            [8.685525013677545, 7.4652194779639816],
            [8.694486515542366, 7.45776726892107],
            [8.661524399634148, 7.453449678217123],
            [8.665650122754522, 7.424495433006372],
            [8.685313368488064, 7.285292864080311],
            [8.6930797063926, 7.2281985316475845],
            [8.696444659680303, 7.2001983981575],
            [8.701016670995475, 7.1576241020212725],
            [8.705775052743771, 7.115088860509076],
            [8.707705959644256, 7.1153269906389385],
            [8.717979054860239, 7.033187906902728],
            [8.634140811622487, 7.0229086835044],
            [8.609703011248579, 7.019973562533807],
            [8.51013594518512, 7.0092247619100485],
            [8.4771152277633, 7.005481437653232],
            [8.441314688119617, 7.002033522598296],
            [8.376755988845927, 6.995185316914391],
            [8.373413331998249, 7.023917986028973],
            [8.36753629100977, 7.081555811137963]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.49989508180522, "lat": 45.44629739810647 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26031"],
        "coty_name": ["Cheboygan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cheboygan County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "01622958"
      },
      "bbox": [
        8.308745984435022, 6.995185316914391, 8.717979054860239,
        7.572804717971079
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [8.982673791712621, 7.919691530852848],
              [8.98915843791648, 7.919787089826664],
              [8.989131507745023, 7.916822814361301],
              [8.984626048060242, 7.9162422771089345],
              [8.982673791712621, 7.919691530852848]
            ]
          ],
          [
            [
              [8.971099350485416, 7.912034074728131],
              [8.97422395588171, 7.916794857745191],
              [8.977617209888415, 7.911885364592888],
              [8.971099350485416, 7.912034074728131]
            ]
          ],
          [
            [
              [8.935492676801323, 7.951856492222693],
              [8.939673293640721, 7.953624528633206],
              [8.942470009659342, 7.950696167546664],
              [8.939451263214451, 7.947680123928101],
              [8.935492676801323, 7.951856492222693]
            ]
          ],
          [
            [
              [8.938748823887709, 7.91289835709726],
              [8.941727691721184, 7.916240603668066],
              [8.944536577937026, 7.9259746046987605],
              [8.950137407528443, 7.928995328599718],
              [8.952938313447763, 7.927956856528197],
              [8.957037870484779, 7.920178069033552],
              [8.965425560434483, 7.918459563143139],
              [8.965467050969837, 7.9114067014194065],
              [8.96305233406526, 7.9105060546603845],
              [8.95957290171268, 7.904629201681937],
              [8.959354610617364, 7.89889985918091],
              [8.952378709501748, 7.899757654294827],
              [8.950097440134119, 7.9012749945084115],
              [8.948164251535568, 7.90650677158752],
              [8.944480667989666, 7.911741341572877],
              [8.938748823887709, 7.91289835709726]
            ]
          ],
          [
            [
              [8.895387292252805, 7.957490931146707],
              [8.904901035574486, 7.96560494063753],
              [8.908913263135862, 7.962913642023249],
              [8.918166510157386, 7.965985400055221],
              [8.919516890836642, 7.960737284509968],
              [8.926326700403818, 7.9576660039934115],
              [8.930872972822348, 7.952167935060554],
              [8.927920525527092, 7.950557696362095],
              [8.923301841480914, 7.953417904315447],
              [8.91879370293894, 7.954155140681232],
              [8.917794047408364, 7.950330808096781],
              [8.913430916492192, 7.9505945128157895],
              [8.913283694883722, 7.957476090208834],
              [8.910812094089327, 7.958556839166889],
              [8.906077033101479, 7.95721234683185],
              [8.905941617547349, 7.951855879308471],
              [8.902637590446087, 7.9510233723736565],
              [8.900925513467289, 7.954583956487656],
              [8.895742380497772, 7.955401019627568],
              [8.895387292252805, 7.957490931146707]
            ]
          ],
          [
            [
              [8.88393143473882, 7.921355075781097],
              [8.883671889627845, 7.925925034033484],
              [8.890215926818714, 7.922977931894322],
              [8.88856054674914, 7.918410189705521],
              [8.88393143473882, 7.921355075781097]
            ]
          ],
          [
            [
              [8.880501582360033, 7.911783043066434],
              [8.88364946583959, 7.913262422504033],
              [8.887840343924408, 7.910160799058476],
              [8.887777110553275, 7.907127683769594],
              [8.882610772627663, 7.907786122533607],
              [8.880501582360033, 7.911783043066434]
            ]
          ],
          [
            [
              [8.869820368165804, 7.930656019760139],
              [8.872380950036083, 7.934022065405769],
              [8.877308947179058, 7.930047120095376],
              [8.881158037872902, 7.930536906515904],
              [8.88139519694399, 7.926786710281692],
              [8.876568657423611, 7.924199644697102],
              [8.873372229480966, 7.9244501313326],
              [8.869820368165804, 7.930656019760139]
            ]
          ],
          [
            [
              [8.873351197559764, 7.828749521185434],
              [8.87643960044943, 7.83194257428728],
              [8.874194002092453, 7.837091185724656],
              [8.874901231830064, 7.8425369403565615],
              [8.877777223142648, 7.847238873676924],
              [8.880958014529932, 7.849286821551799],
              [8.87906764078143, 7.852206057169252],
              [8.880005334291372, 7.861051666742619],
              [8.884666419903207, 7.862385449392184],
              [8.88775758621781, 7.870680142503975],
              [8.889856141720243, 7.8733187290559385],
              [8.892928416157927, 7.882201308670676],
              [8.899573493985862, 7.881073569979736],
              [8.905818376271986, 7.877261652513441],
              [8.908013734279882, 7.873837869083934],
              [8.902458885208455, 7.867203493427707],
              [8.903248197610042, 7.8643401244624505],
              [8.907179046242524, 7.862948499719003],
              [8.911142155448154, 7.855550061940343],
              [8.911181107917756, 7.8501202262933605],
              [8.916373943799618, 7.851853251770642],
              [8.918207325299639, 7.8467341605381105],
              [8.92065452696953, 7.847788808031572],
              [8.92526366116616, 7.843764463377639],
              [8.928684492355476, 7.8450256505132945],
              [8.931704629822985, 7.849365827908679],
              [8.932050885506273, 7.8565258730942125],
              [8.935089629083834, 7.859845095925254],
              [8.940615149431494, 7.8603060932077025],
              [8.941398887995614, 7.864931732881604],
              [8.944090700574545, 7.870713344198395],
              [8.93908302561405, 7.874598924538858],
              [8.946013524113457, 7.877051660543982],
              [8.949013979188756, 7.881203272342988],
              [8.947489220310906, 7.887446470515671],
              [8.95474850320521, 7.889282134097443],
              [8.959769462698919, 7.887210906622268],
              [8.967018633788637, 7.889129421189912],
              [8.970527966714176, 7.89287269090683],
              [8.97270471060247, 7.900761068622616],
              [8.975799778843625, 7.903506825474597],
              [8.983088557181478, 7.907437891517616],
              [8.985177225753796, 7.905701352009189],
              [8.999527724864206, 7.904918450515467],
              [9.001593144073354, 7.910121723002582],
              [8.994889472110497, 7.914850640158341],
              [8.996062362208162, 7.9224045329941655],
              [8.999191939359095, 7.920066893669249],
              [9.004241614872761, 7.921651157731409],
              [9.008833412227172, 7.925369630342071],
              [9.008016583834511, 7.9309383590487945],
              [9.003734278928102, 7.93309863747542],
              [9.004911521251252, 7.937443848280071],
              [9.002571070073415, 7.942568141534891],
              [8.996544103657303, 7.943434410507316],
              [8.98676647870405, 7.942909274750845],
              [8.97247474260088, 7.947002266952521],
              [8.963029695811858, 7.951363859745185],
              [8.968262057775743, 7.958908002026086],
              [8.969750526988953, 7.966298579050595],
              [8.980059140557593, 7.9678382196129895],
              [8.98293865613479, 7.970823293689707],
              [8.991691895443658, 7.970509409052108],
              [9.01022990041992, 7.9707481883396945],
              [9.017960886604932, 7.975094237064478],
              [9.022449426375069, 7.974962428329169],
              [9.027785249708154, 7.976705438466153],
              [9.034499950937958, 7.975837971773359],
              [9.042344156602828, 7.970640832009263],
              [9.05195815275777, 7.968257753367381],
              [9.058928504251918, 7.965406474235222],
              [9.062678660751452, 7.968448913644073],
              [9.066607504055064, 7.967449415325954],
              [9.071001392320525, 7.961934548175929],
              [9.07188711359908, 7.957516515975216],
              [9.07449533913742, 7.9538233128965485],
              [9.075196152585837, 7.948904302928121],
              [9.079379011524397, 7.946858242085396],
              [9.081211196978105, 7.941709476616262],
              [9.08721697298226, 7.941069213309872],
              [9.091415594294629, 7.936413597860788],
              [9.093210035226951, 7.930823891804557],
              [9.095547586835023, 7.929585925912256],
              [9.0995849621094, 7.919470039191845],
              [9.103401517408027, 7.904058672915203],
              [9.103009887125024, 7.901267157117482],
              [9.109389283553082, 7.8972740269532435],
              [9.109602372753482, 7.891307017826712],
              [9.11156750379264, 7.890327709900951],
              [9.119868214766923, 7.893691778045155],
              [9.13057476250145, 7.881613051259203],
              [9.134562750226095, 7.881724379219421],
              [9.142440590437873, 7.8875124265805],
              [9.148203044149282, 7.884895966087312],
              [9.153815163075274, 7.878047339853457],
              [9.154858411742538, 7.874054252265726],
              [9.150609747709666, 7.8609760429482884],
              [9.144499614264536, 7.856356467208407],
              [9.142828930061372, 7.851556903717785],
              [9.139743358567165, 7.847638691736097],
              [9.14214582706847, 7.8375934771636775],
              [9.138574461575308, 7.833924862485049],
              [9.13873337483973, 7.828761882677314],
              [9.133908784462822, 7.8250261163962636],
              [9.135595673100568, 7.814338889987735],
              [9.133249689447787, 7.812730240247794],
              [9.12999538430592, 7.8071680206597085],
              [9.125566074577637, 7.8036970811263044],
              [9.118713314450687, 7.807840906198876],
              [9.116474193229807, 7.812746437413865],
              [9.113256425358898, 7.8086961412909455],
              [9.114485026498608, 7.80448289203606],
              [9.110789544999218, 7.801589953131398],
              [9.10174191168242, 7.804883048516098],
              [9.097820748638705, 7.804866894771927],
              [9.09949665136843, 7.79790705594745],
              [9.097207536454208, 7.796178406383314],
              [9.095003855581602, 7.802189258330582],
              [9.088716918740824, 7.801122895799378],
              [9.0885742699759, 7.796790613147461],
              [9.083363227705181, 7.798468874812885],
              [9.073103695778551, 7.803719859643077],
              [9.069137784030664, 7.804633702688403],
              [9.068617897093949, 7.807914452342704],
              [9.070440748011633, 7.817472307000027],
              [9.062250351984284, 7.8175630991994565],
              [9.062594690290608, 7.811174065847197],
              [9.060957906588209, 7.808404819891589],
              [9.057503788292426, 7.809276904364246],
              [9.05231823715726, 7.806547560960671],
              [9.051413570573873, 7.81368329038947],
              [9.058367932683948, 7.821677498634424],
              [9.055988315770932, 7.8270576324442915],
              [9.050105625677745, 7.833054981581207],
              [9.046261375235296, 7.83247480104689],
              [9.045187927196833, 7.827966219293159],
              [9.047912923167576, 7.826917425896888],
              [9.050506166773973, 7.8218122758307285],
              [9.044656712525635, 7.816188470786862],
              [9.04293041986184, 7.822314305722358],
              [9.038129367961437, 7.8201259218270796],
              [9.0362965113542, 7.816943969823597],
              [9.032657359311324, 7.819249083565796],
              [9.027448870209724, 7.814804542760981],
              [9.021524358350394, 7.813383217743613],
              [9.019238942473395, 7.81049554935035],
              [9.013224688022524, 7.806688508096618],
              [9.006243754711292, 7.811965503517028],
              [9.003156748901555, 7.811503586585679],
              [9.000956645638517, 7.803933800224444],
              [8.996300693938316, 7.805076153392535],
              [8.991478076808471, 7.802576222438815],
              [8.99001678191004, 7.807813276931076],
              [8.987081725007718, 7.812382590468528],
              [8.98331776963283, 7.811815534895291],
              [8.976025309520471, 7.803798735271792],
              [8.968734014958505, 7.807220480857386],
              [8.964057894368151, 7.813628348239751],
              [8.962884566073132, 7.81941309838082],
              [8.954775474336472, 7.8176317127361665],
              [8.953409643970504, 7.81353473232885],
              [8.95012028435149, 7.811759336480937],
              [8.949979382404937, 7.803248725881091],
              [8.945537725106092, 7.795527018507134],
              [8.940802244804082, 7.796051384517325],
              [8.939953171208387, 7.7996134401264365],
              [8.934670877502944, 7.798782149081444],
              [8.933148406708435, 7.802374810522628],
              [8.92268828082667, 7.809733957686907],
              [8.920929822238977, 7.813630620746134],
              [8.91745881877629, 7.8114566561989935],
              [8.91669040792299, 7.805176244257294],
              [8.918313964010201, 7.801673131307022],
              [8.914893116203098, 7.797221983142685],
              [8.909012681347269, 7.797547598310432],
              [8.912793065005834, 7.807564202127389],
              [8.908603831177183, 7.808348847228794],
              [8.908338395161197, 7.811035486850883],
              [8.902988078876568, 7.81011018225904],
              [8.901536432335087, 7.817173616765291],
              [8.895288408635217, 7.81584225210722],
              [8.891044932810834, 7.81896911675365],
              [8.888301634656179, 7.816972206588396],
              [8.883579331816895, 7.816946283408765],
              [8.87363505975805, 7.822689171653792],
              [8.873351197559764, 7.828749521185434]
            ]
          ],
          [
            [
              [8.859801203687564, 7.920589594831972],
              [8.863855027417683, 7.921433291192843],
              [8.866182908735759, 7.916960565536927],
              [8.863770759733749, 7.915010209502264],
              [8.859695201384136, 7.918192469647121],
              [8.859801203687564, 7.920589594831972]
            ]
          ],
          [
            [
              [8.769840976520882, 7.931416363488615],
              [8.775097739525968, 7.935855155446315],
              [8.78072877427136, 7.9360697675049225],
              [8.787482470558253, 7.926240807827018],
              [8.793238465197298, 7.919652233140321],
              [8.796118348189683, 7.91861845805403],
              [8.797000106476538, 7.9124007918363795],
              [8.782748911221622, 7.917559637500694],
              [8.77404926750297, 7.924551576858916],
              [8.769724730459266, 7.9271609029775725],
              [8.769840976520882, 7.931416363488615]
            ]
          ],
          [
            [
              [7.849283476151675, 8.482098259871096],
              [7.863235536024729, 8.48473022009714],
              [7.880665325284737, 8.491215868545085],
              [7.894209705355049, 8.495585550489135],
              [7.902912256199728, 8.497541948676616],
              [7.911640971301035, 8.497563738407703],
              [7.934334221612791, 8.496446984161375],
              [7.955429750680046, 8.49639029002569],
              [7.968137228379758, 8.497734516322382],
              [7.986470748220147, 8.502390748638035],
              [7.993952826283253, 8.505679579989089],
              [8.01177837062241, 8.516088996594272],
              [8.01705343348135, 8.517772958175684],
              [8.028749989924172, 8.520024645820163],
              [8.039818767635076, 8.519892037549727],
              [8.042293704266436, 8.516231167882106],
              [8.03538649540463, 8.509638444365343],
              [8.034366147654652, 8.507423880803062],
              [8.021490953517246, 8.491582097423102],
              [8.015266425588582, 8.482487596281468],
              [8.009744844579036, 8.473224219444948],
              [8.002995991859386, 8.45669880564018],
              [7.999691828692054, 8.441425291723231],
              [7.999393278786426, 8.428807458147592],
              [8.001722258238056, 8.419504794597271],
              [8.002536090195797, 8.369871228342681],
              [8.004229693096525, 8.346215212406065],
              [8.007542929121756, 8.327286971293523],
              [8.01496117696542, 8.306480081635021],
              [8.018419104510201, 8.29363182458221],
              [8.017713807699133, 8.290215124538719],
              [8.008296911554089, 8.28591856633025],
              [8.001152491877784, 8.278176259407854],
              [7.999695728363615, 8.271745786799737],
              [8.001859855854594, 8.260303681740812],
              [8.006590379665605, 8.25013108521087],
              [8.012655630310345, 8.245235643275489],
              [8.019488570419782, 8.23542488433124],
              [8.025624554502862, 8.231517532747251],
              [8.033131096401668, 8.229085346546182],
              [8.039969070177975, 8.228818297289033],
              [8.053282110388867, 8.229867842187515],
              [8.06838503238283, 8.230239462992925],
              [8.074159842013989, 8.234365794687468],
              [8.078848622188431, 8.241991340890433],
              [8.081848149785104, 8.24010481236472],
              [8.085393201746127, 8.241571004697615],
              [8.088428624481145, 8.239694851922787],
              [8.088473583360045, 8.236066724038695],
              [8.09262345744817, 8.233283377639383],
              [8.098248895686249, 8.226912397349075],
              [8.103161458395437, 8.225050472348416],
              [8.11833560886799, 8.224716138748931],
              [8.13076651176125, 8.227527919893094],
              [8.139744319770603, 8.231702457053109],
              [8.145478171648794, 8.227079398592824],
              [8.152049676828733, 8.217615348244358],
              [8.152812701702864, 8.214094956766626],
              [8.1577248058132, 8.210309474278702],
              [8.164722309398128, 8.20933399539925],
              [8.17302125479039, 8.210136425601945],
              [8.184605300965407, 8.213381067821812],
              [8.2049833631986, 8.22303132267208],
              [8.234673357822905, 8.241179137649167],
              [8.244468959849456, 8.248587654821815],
              [8.256930899170278, 8.259895665711658],
              [8.259095582411929, 8.25960530052874],
              [8.263176677251353, 8.263855917960187],
              [8.269765317071865, 8.26307640678663],
              [8.273853296595727, 8.261055782321296],
              [8.280650507245689, 8.260517666730408],
              [8.288840322738798, 8.263426317052874],
              [8.296013288719763, 8.264944961644833],
              [8.303302403586407, 8.259178375062575],
              [8.307524614660718, 8.253396729289499],
              [8.315186796893656, 8.23927796783662],
              [8.32179689862439, 8.23514573349794],
              [8.3275737565926, 8.229400472497431],
              [8.33652449673085, 8.222106923005255],
              [8.337296017980197, 8.218230423172136],
              [8.332843883394512, 8.216070100061032],
              [8.33161102666758, 8.22211149761461],
              [8.328023803532412, 8.225753155100472],
              [8.323386189305465, 8.225119208043322],
              [8.320260731815395, 8.217500281274756],
              [8.321894495912945, 8.214275228622908],
              [8.32208303378527, 8.209329822603692],
              [8.328165397842156, 8.199466941090584],
              [8.337251831132908, 8.198922253461047],
              [8.353282132709833, 8.203854036186478],
              [8.364248628182592, 8.210323246823133],
              [8.37964527606123, 8.225127307085128],
              [8.38466601772033, 8.224151899172146],
              [8.389110151194835, 8.232107299711817],
              [8.387843561615266, 8.236740994245752],
              [8.392391699552004, 8.2386721776037],
              [8.396262182286545, 8.231670664650444],
              [8.398083465458281, 8.231833327843797],
              [8.403709492882346, 8.226861815972947],
              [8.406185979589752, 8.226154119222615],
              [8.411237389606939, 8.228469488566569],
              [8.416780518124584, 8.235751325023417],
              [8.42006451445418, 8.249030035845694],
              [8.419176463983712, 8.25775887413567],
              [8.413084112516868, 8.261645821398243],
              [8.42293485485816, 8.284288516681073],
              [8.438522936236787, 8.29816355268054],
              [8.456253554614618, 8.298490246359126],
              [8.46927849425957, 8.309869943864316],
              [8.491745360117733, 8.311206287587538],
              [8.50368250628958, 8.305041247543006],
              [8.526735921426564, 8.300685992170525],
              [8.538521202090328, 8.302148708327046],
              [8.54547029749121, 8.304564469726781],
              [8.552188032198249, 8.311780165661412],
              [8.567501464610837, 8.346566955618174],
              [8.588719930735826, 8.355376101606318],
              [8.601716061514063, 8.343832726333238],
              [8.60960925725681, 8.344113835332314],
              [8.618251789448703, 8.347272255657659],
              [8.622356231141438, 8.350563679059533],
              [8.627081203353328, 8.352243424543877],
              [8.634531985756551, 8.351080966546139],
              [8.639509504386131, 8.342553364511575],
              [8.643617658177034, 8.339783271165388],
              [8.649885235203183, 8.327140663989763],
              [8.636565142630653, 8.240357506412797],
              [8.647296556060764, 8.195628728821232],
              [8.665253976679253, 8.162826046770558],
              [8.67596933312312, 8.149180072545212],
              [8.667642129317173, 8.14122624948378],
              [8.6762569664573, 8.095722572695928],
              [8.689950669848637, 8.085766165126723],
              [8.684755185065882, 8.069910417694658],
              [8.678612611309505, 8.066900360963391],
              [8.677684922371176, 8.063151417135954],
              [8.672457057151847, 8.066307948312158],
              [8.668418478251358, 8.06286450483149],
              [8.669110565555927, 8.05997320817382],
              [8.66606698044328, 8.056110834532417],
              [8.663817403299955, 8.057620811355351],
              [8.65984201833095, 8.056435156358098],
              [8.660071843366378, 8.042533464896053],
              [8.654200755600767, 8.042753067841668],
              [8.657010611957556, 8.04691061502465],
              [8.656340317453802, 8.053289112259954],
              [8.65316313008791, 8.054572836156192],
              [8.647707059448706, 8.060885372072491],
              [8.637536466919071, 8.068740809483938],
              [8.63405822431874, 8.070194980228656],
              [8.632251032043468, 8.067209449547196],
              [8.634453589108354, 8.063599954515823],
              [8.634450420212627, 8.058467831590056],
              [8.631027525460114, 8.056828594013531],
              [8.628946515466229, 8.065449574050211],
              [8.614423841336809, 8.067049072185098],
              [8.611827199280262, 8.064601927297467],
              [8.614100081382919, 8.060257804428236],
              [8.614718337715024, 8.054687778122911],
              [8.613622481695863, 8.051523664916507],
              [8.606346559412772, 8.050626038955704],
              [8.605054271806514, 8.046842424835088],
              [8.600885924088335, 8.042393676183947],
              [8.598972810869856, 8.03838622768908],
              [8.594687469413417, 8.04100391987863],
              [8.584541665477577, 8.034516201703301],
              [8.581163734579066, 8.030334168033546],
              [8.581811982231779, 8.026483680841986],
              [8.57775078307563, 8.023773126079037],
              [8.579238436706532, 8.020516526175092],
              [8.576207576577087, 8.016868145715451],
              [8.584861871256525, 8.006791199683283],
              [8.591974923213208, 8.00438848845265],
              [8.59642388613235, 8.010510871814546],
              [8.597962270640474, 8.00963169952284],
              [8.598338135774204, 7.998698197658602],
              [8.594215311107154, 7.993624418380815],
              [8.606195137885164, 7.988305910698503],
              [8.609852666496316, 7.988396108763856],
              [8.616743880453907, 7.983625318305302],
              [8.633117269175736, 7.988723105868363],
              [8.636365653062759, 7.994311179432783],
              [8.639630028500362, 7.997401294989617],
              [8.64449885194398, 7.999643372324292],
              [8.641649664564795, 8.003404202157606],
              [8.642775355490944, 8.009346157533669],
              [8.649815972965353, 8.006243151104746],
              [8.651677874724657, 8.000040554746995],
              [8.653763413583171, 7.998659530802734],
              [8.660391681883501, 8.00276043819121],
              [8.661896063593064, 8.007946179533615],
              [8.666650329584158, 8.00583205250716],
              [8.669257090136023, 7.999680330109305],
              [8.67337863926072, 7.997323535663102],
              [8.678328443725063, 7.998266421009743],
              [8.67564889755957, 8.003015417823756],
              [8.679504543823631, 8.003413056713077],
              [8.682377326367726, 8.007512609154],
              [8.688397743241348, 8.00351342724224],
              [8.69020975280436, 7.998505389615267],
              [8.690122040644958, 7.993092352621443],
              [8.694541573952378, 7.988394788400841],
              [8.700710743507432, 7.986293344695347],
              [8.70150592956298, 7.981891465950507],
              [8.704851240566928, 7.979282877692268],
              [8.709496038479324, 7.978566041888126],
              [8.714840264324689, 7.982397197715683],
              [8.722096829458204, 7.9776435633126255],
              [8.729452915099877, 7.98076597685775],
              [8.752081997288693, 7.9720429390559415],
              [8.754578287760095, 7.969475336447125],
              [8.752385941406324, 7.965762682073474],
              [8.752539718016207, 7.960787701603667],
              [8.746958063440593, 7.962513485809412],
              [8.73858967752927, 7.955676070362141],
              [8.7381658322513, 7.949452791683861],
              [8.732640684247627, 7.946462659218487],
              [8.72868652782228, 7.938660832150094],
              [8.72895974263666, 7.927690919743876],
              [8.735267291386512, 7.921125410840809],
              [8.740302361479742, 7.919005493788583],
              [8.748440803353295, 7.911972030932755],
              [8.755051741511855, 7.90396311561296],
              [8.758876114541733, 7.904569115056163],
              [8.75911790925131, 7.899421087316931],
              [8.763969390715747, 7.894686545572284],
              [8.764217768424533, 7.8927439440157015],
              [8.7696535355978, 7.888000072468885],
              [8.773311474732523, 7.888047606099254],
              [8.777241156039045, 7.884676162086699],
              [8.78111102591974, 7.886971872820615],
              [8.784559998617402, 7.882800612625093],
              [8.789185429384943, 7.880504128695587],
              [8.793068575463955, 7.874905106035558],
              [8.798896047317083, 7.871032485615756],
              [8.798839635734035, 7.868227654791638],
              [8.802353821454227, 7.8635692425237425],
              [8.804876719892768, 7.862735467133518],
              [8.810183566141017, 7.864227024729618],
              [8.812319232212374, 7.867705025584067],
              [8.81087150696541, 7.873078140434837],
              [8.814077457467969, 7.875413861423692],
              [8.821529264699539, 7.875121119513173],
              [8.824122148626147, 7.878372025905014],
              [8.82919024303559, 7.877734217718029],
              [8.831359918317386, 7.868238848086203],
              [8.836182786665171, 7.865741625036141],
              [8.842349784228883, 7.864834767969863],
              [8.85103669736502, 7.861840448144486],
              [8.858180506835524, 7.850227481679182],
              [8.863262812858292, 7.8384234666323644],
              [8.860545461398631, 7.834290826793752],
              [8.856522959115225, 7.831227594627484],
              [8.858220647623886, 7.825182110381638],
              [8.856547439803355, 7.809246205511814],
              [8.852912931922232, 7.806081592369249],
              [8.849050982753011, 7.808334701423424],
              [8.854048853874417, 7.81163583671226],
              [8.851260063177005, 7.815155773742112],
              [8.84714057995081, 7.817353244971768],
              [8.842580340327709, 7.815210227180928],
              [8.840861823931354, 7.817547244966542],
              [8.832765699517347, 7.8137220151178965],
              [8.82675959063718, 7.812920511140408],
              [8.82271646480268, 7.81665502969417],
              [8.821152749026865, 7.81390340416817],
              [8.814905124504838, 7.811225348926651],
              [8.80808340568266, 7.8137387225003305],
              [8.800263906687025, 7.809151637420739],
              [8.796688732844501, 7.805104275652353],
              [8.795181314581093, 7.79499652474012],
              [8.793825432521235, 7.791364941798192],
              [8.790035878827322, 7.7963195496173014],
              [8.782426101987861, 7.800903046942322],
              [8.77536141887997, 7.802504683530833],
              [8.770355467558923, 7.801828914847243],
              [8.763592569685793, 7.8029130587935995],
              [8.757049918004249, 7.8050566120218],
              [8.751991494289314, 7.805444724297868],
              [8.746520081240137, 7.803943606442994],
              [8.73768726498831, 7.80602798775076],
              [8.728415886203472, 7.802894093100259],
              [8.72720605695103, 7.80821290601754],
              [8.722594188047587, 7.808295883672131],
              [8.715021309556846, 7.8119141765860585],
              [8.712913030622898, 7.814658380637061],
              [8.712447577262438, 7.818185680846209],
              [8.642506479404299, 7.80933169378107],
              [8.638092548584364, 7.808762376968031],
              [8.626072190650358, 7.807247931836356],
              [8.620904193510867, 7.848920299808002],
              [8.615715780100906, 7.892233856925276],
              [8.530043619352082, 7.881851642526455],
              [8.519224425702161, 7.966610622649689],
              [8.433252633746948, 7.956493326083902],
              [8.303879569388602, 7.940365142464355],
              [8.225853899360732, 7.931512159069083],
              [8.131635896192064, 7.9209447332440925],
              [8.110113048640105, 7.9186332980247345],
              [8.00303133860618, 7.906023842076104],
              [7.992493102990351, 7.991835507850097],
              [7.9067907412911325, 7.981837199139387],
              [7.8993551436773615, 8.038901238062243],
              [7.896009952714849, 8.066659617501589],
              [7.887036580902831, 8.146055510120005],
              [7.873075814499996, 8.264282657810378],
              [7.870122661913329, 8.294721546860014],
              [7.859335090450222, 8.387049740628935],
              [7.849283476151675, 8.482098259871096]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.57894629280504, "lat": 46.30561742617735 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26033"],
        "coty_name": ["Chippewa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chippewa County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01622959"
      },
      "bbox": [
        7.849283476151675, 7.791364941798192, 9.154858411742538,
        8.520024645820163
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [5.744193079666398, 8.592481774998522],
              [5.748733504512808, 8.596302842198966],
              [5.749760741503884, 8.591597626956057],
              [5.744193079666398, 8.592481774998522]
            ]
          ],
          [
            [
              [5.298808570694474, 8.517279847370308],
              [5.304013050258819, 8.528491276313122],
              [5.309781322675147, 8.545783481076155],
              [5.31090260861779, 8.551639415833487],
              [5.3103965992771585, 8.560180388973874],
              [5.312580615328181, 8.560831239299405],
              [5.316006074899779, 8.569482884248057],
              [5.314939478292346, 8.572724324987153],
              [5.322109203648574, 8.582904925430304],
              [5.3238064997492005, 8.587602851548679],
              [5.334736157255889, 8.595524476782904],
              [5.341843699078632, 8.598748299710612],
              [5.345819700838529, 8.602742977841272],
              [5.352302481708679, 8.60361180636014],
              [5.355515591771929, 8.606770763281027],
              [5.361779805118959, 8.616263442591872],
              [5.366929413834492, 8.626953378964043],
              [5.371428430399916, 8.631425342593177],
              [5.377954890034136, 8.633823175024842],
              [5.380666373714323, 8.63740705871744],
              [5.387767529299725, 8.642047694349754],
              [5.397757888440506, 8.642247777439902],
              [5.406752428127059, 8.649222880219703],
              [5.41125206059773, 8.655301219250916],
              [5.413338549006491, 8.660914275578584],
              [5.426094821726245, 8.679371074076647],
              [5.445100189664552, 8.69954853979238],
              [5.462571590241655, 8.714987352612377],
              [5.467648490100913, 8.71748638449284],
              [5.47477875314673, 8.722496654057446],
              [5.484273742645461, 8.723654127930153],
              [5.4936250524117245, 8.727542171814777],
              [5.501519942980294, 8.73690912005007],
              [5.515220907666236, 8.740299054379728],
              [5.525555515049507, 8.744346422894463],
              [5.535058071428176, 8.75431074564276],
              [5.540912865698105, 8.76275563069274],
              [5.558440974716653, 8.779712573246645],
              [5.566538714507377, 8.788895881985912],
              [5.635057446124331, 8.794494453171586],
              [5.653260271910269, 8.795680061063436],
              [5.696528230695166, 8.79941287445845],
              [5.711370095542974, 8.8004908023603],
              [5.713668753087987, 8.772040757001621],
              [5.718696601478769, 8.715956880633488],
              [5.767325449466238, 8.720025093595927],
              [5.766038219387934, 8.719044291816138],
              [5.760252064612374, 8.70594439789277],
              [5.7591437263813425, 8.694537485834774],
              [5.760023648686941, 8.678485287349588],
              [5.762788203343336, 8.671516444119817],
              [5.768139926531855, 8.670441802507973],
              [5.768185036645509, 8.666859417732619],
              [5.76344806575527, 8.66002314473063],
              [5.7584586585140585, 8.65621013591488],
              [5.754916894908665, 8.66154603362167],
              [5.750893723794634, 8.664237895217374],
              [5.743994342989382, 8.663711017878851],
              [5.735058702129836, 8.656524850721476],
              [5.730744649443643, 8.647767002132966],
              [5.732764676648114, 8.638781834763801],
              [5.732438029222819, 8.632959244384896],
              [5.727405230951298, 8.61672129979108],
              [5.723886251814999, 8.613526009873674],
              [5.716906070379173, 8.609323975381232],
              [5.710275570239681, 8.603867415112127],
              [5.698551139792875, 8.595865437221855],
              [5.695466293100052, 8.595278656312603],
              [5.693493826489073, 8.59216481760497],
              [5.691869308557707, 8.584815123833783],
              [5.692642569000578, 8.5708343918878],
              [5.690213039817829, 8.555732280644483],
              [5.685648184827158, 8.543003643180807],
              [5.686002478266564, 8.535129259654306],
              [5.682226971785972, 8.527964832639045],
              [5.674895341137216, 8.51973876104988],
              [5.668384739772593, 8.508170170184009],
              [5.664217731217325, 8.499467765557206],
              [5.660122610728541, 8.494339490219415],
              [5.656570365099586, 8.491783797300794],
              [5.64968751327815, 8.491207182726221],
              [5.6452054066909065, 8.488835470255141],
              [5.6439900880090965, 8.494985594069968],
              [5.64038493575882, 8.494701231103702],
              [5.636054834183115, 8.48273202502353],
              [5.636457992190805, 8.459656647393633],
              [5.635528427677991, 8.45194591090692],
              [5.56627010796877, 8.446031261509317],
              [5.567538549315416, 8.431785942737992],
              [5.573196861466118, 8.360865321237638],
              [5.558709569010337, 8.359360891606691],
              [5.515407536877795, 8.356405089293714],
              [5.486231314979647, 8.354027337502687],
              [5.4930716328495475, 8.2686917064217],
              [5.494757418244747, 8.268812580402763],
              [5.497515199670114, 8.234737876492742],
              [5.496500200602997, 8.227278650296844],
              [5.506195232010998, 8.099319344469603],
              [5.519041471575199, 7.929559212566369],
              [5.433077312549333, 7.923004764776776],
              [5.404310130595569, 7.920700130650289],
              [5.304126393980851, 7.9130514485399575],
              [5.299773332345935, 7.97142822363023],
              [5.291698809826224, 8.083861268320822],
              [5.286172215585518, 8.169486314527575],
              [5.372097098566303, 8.175028321518694],
              [5.366081427278213, 8.259328638753592],
              [5.319076591125608, 8.255622867557648],
              [5.317642002059466, 8.270348152117275],
              [5.317133763089135, 8.284616578578394],
              [5.312151179399721, 8.346996876881592],
              [5.309480031030537, 8.382854821300706],
              [5.298808570694474, 8.517279847370308]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.6875356273257, "lat": 46.8976288493241 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26061"],
        "coty_name": ["Houghton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Houghton County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01622973"
      },
      "bbox": [
        5.286172215585518, 7.9130514485399575, 5.768185036645509,
        8.8004908023603
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [9.461067758269818, 5.8055639437389255],
              [9.466695769958873, 5.806212211326451],
              [9.472117864042911, 5.800709594137296],
              [9.464182276775041, 5.802552469837641],
              [9.461067758269818, 5.8055639437389255]
            ]
          ],
          [
            [
              [9.457246674170541, 5.739136234069874],
              [9.458079055512805, 5.745841080948275],
              [9.468460934940058, 5.7437020775242456],
              [9.457246674170541, 5.739136234069874]
            ]
          ],
          [
            [
              [9.451062877417698, 5.7777665943562635],
              [9.451553269333639, 5.7811867744350325],
              [9.454367908369393, 5.7841987367575465],
              [9.460247546197841, 5.785432704751377],
              [9.464539849282046, 5.78067225951799],
              [9.460256985204495, 5.778915585516498],
              [9.459997416029996, 5.773683783260118],
              [9.462173126856314, 5.763100676149951],
              [9.451062877417698, 5.7777665943562635]
            ]
          ],
          [
            [
              [9.449134461453601, 5.738064621574049],
              [9.44992121248672, 5.744639296837806],
              [9.452063793893428, 5.7479656603943114],
              [9.451384605044117, 5.75156725103062],
              [9.45335709043181, 5.7574901826938945],
              [9.457252955960508, 5.753672887561444],
              [9.454629444613168, 5.752095720163086],
              [9.453634011739817, 5.745080336210338],
              [9.451091445930059, 5.736633015242318],
              [9.449134461453601, 5.738064621574049]
            ]
          ],
          [
            [
              [9.45593552817417, 5.650556688293434],
              [9.459365389799386, 5.657702655484384],
              [9.45788696849047, 5.660543731212614],
              [9.463534361030957, 5.671542476279673],
              [9.468559028094074, 5.679847437350144],
              [9.471680932984393, 5.692923753207365],
              [9.46986723661068, 5.694829803252787],
              [9.47404498062828, 5.709110743220586],
              [9.47964352300648, 5.709395373122969],
              [9.478615117574835, 5.716839735471281],
              [9.482982368743306, 5.722765178191179],
              [9.48165398443779, 5.72437313038095],
              [9.484720410991565, 5.730611071618736],
              [9.491383339948458, 5.735214627019746],
              [9.495048600223086, 5.747147138299807],
              [9.496164991369739, 5.753770595351003],
              [9.496014160913903, 5.760505857930591],
              [9.497899895887606, 5.77120584449732],
              [9.494960648601921, 5.776406477949099],
              [9.498874003595404, 5.779533201546109],
              [9.498177389729532, 5.781516573150329],
              [9.507575225031516, 5.781691340719647],
              [9.512090140349821, 5.783539441143311],
              [9.51881875369426, 5.789454546551033],
              [9.528069524817976, 5.804749767805271],
              [9.529039122418423, 5.808706266747503],
              [9.534008015354797, 5.813114570263842],
              [9.536718827724627, 5.81785265293682],
              [9.535315678015678, 5.82085062773096],
              [9.534229087292994, 5.830187531713435],
              [9.531078968963717, 5.836486948914842],
              [9.520698581216852, 5.837409195946419],
              [9.506484451613922, 5.8369340982032965],
              [9.49646017823618, 5.838503739131764],
              [9.486357118851465, 5.836478642862768],
              [9.482796453596585, 5.83457137186146],
              [9.477115550064733, 5.837678403304776],
              [9.475949283145574, 5.841297686152149],
              [9.478340870484686, 5.843407141131571],
              [9.48831422014765, 5.841572418530908],
              [9.496498834782322, 5.841515268061275],
              [9.503164481411746, 5.8426232096862565],
              [9.531173796853674, 5.848845376207361],
              [9.543133117637947, 5.855242284866972],
              [9.551594269728927, 5.863617753090803],
              [9.557499442242673, 5.871405269935164],
              [9.561921716737347, 5.878907991294298],
              [9.560545136990532, 5.883003479315742],
              [9.565107968733754, 5.89007272574199],
              [9.566954929110329, 5.894575818392369],
              [9.570293924290983, 5.908008440073466],
              [9.569008522989607, 5.914176685127189],
              [9.579457319682238, 5.916136879864807],
              [9.591841986010111, 5.922345363601811],
              [9.597869239782197, 5.9234562675350055],
              [9.613514648577654, 5.92850493907335],
              [9.623117853516089, 5.9277730161335525],
              [9.629634584414159, 5.93022026729667],
              [9.633033948293507, 5.934551090847868],
              [9.637230950767156, 5.934342428211632],
              [9.646334591112904, 5.937133997319877],
              [9.657244508740451, 5.944034224701922],
              [9.666287392088286, 5.953121228824408],
              [9.671648874994123, 5.957624539549581],
              [9.675093326238715, 5.956628163735627],
              [9.683596275335603, 5.956338193475618],
              [9.69564183012304, 5.957238412587131],
              [9.70475404702262, 5.960782992733402],
              [9.709537446514235, 5.964314160860174],
              [9.716880567157375, 5.974872602373126],
              [9.718437832734711, 5.978385615762191],
              [9.721568418225152, 5.991841537827686],
              [9.723791280130683, 5.996000512845073],
              [9.726135078710168, 6.006857301240815],
              [9.7284548496035, 6.006136552609744],
              [9.744296254979929, 6.010239012671455],
              [9.746238977040873, 6.0099145615213425],
              [9.751989177764973, 6.013055367169925],
              [9.758200898878052, 6.020321976628656],
              [9.764992193530004, 6.031221836620177],
              [9.768386469895505, 6.034868035443039],
              [9.77202982308148, 6.035203010640069],
              [9.77332367274655, 6.030793883899923],
              [9.780919574061544, 6.030465291318581],
              [9.786967707191147, 6.035321596118848],
              [9.792401115144395, 6.03813338164808],
              [9.79845517842067, 6.038629325830517],
              [9.799725653412162, 6.036399467872867],
              [9.805905881509418, 6.034057188512627],
              [9.814140870515299, 6.033070760234674],
              [9.823280460627169, 6.024980931912042],
              [9.833986376793801, 6.020508882948143],
              [9.846981590096775, 6.019597588246798],
              [9.854438546799306, 6.01797479975214],
              [9.865474726573996, 6.016610124939427],
              [9.870268203288475, 6.014111744582714],
              [9.879726214984062, 6.014076136150951],
              [9.882115138385963, 6.010389999094672],
              [9.88658656361683, 6.009956067667891],
              [9.895671341306116, 6.007094183582271],
              [9.90047912911259, 5.998153375475289],
              [9.904703002306698, 5.994361043443796],
              [9.908119490702385, 5.993592973047577],
              [9.916817107654609, 5.99524511437997],
              [9.922075822023093, 5.990332914604756],
              [9.924916843257213, 5.989682908740563],
              [9.932010364470258, 5.979930786725073],
              [9.936783415280187, 5.979705073061248],
              [9.940797523170692, 5.9757306620608865],
              [9.944021772921806, 5.968607693100024],
              [9.946521064460843, 5.966629333810996],
              [9.950727893448157, 5.958784691151744],
              [9.953024598955379, 5.9567780842379],
              [9.956817492843873, 5.947223050213654],
              [9.959777409861035, 5.943086209604025],
              [9.964807591423357, 5.940512523822345],
              [9.969170140814052, 5.932208526703471],
              [9.973460709664716, 5.928803642857923],
              [9.975074857288744, 5.920525835181335],
              [9.97995546367407, 5.917115984973746],
              [9.982605644196845, 5.910389716903641],
              [9.990296529935563, 5.9033659289468705],
              [9.98855039898403, 5.8987495123258515],
              [9.989814487976576, 5.893406663447012],
              [9.993639718089462, 5.8880246763231225],
              [9.997245060472578, 5.877464410320002],
              [10.003058143059686, 5.873515182456829],
              [10.015265155504917, 5.86705693277831],
              [10.016631662156326, 5.8614566208649075],
              [10.023355891428395, 5.8526780143842965],
              [10.022035087218795, 5.849701216239901],
              [10.02460639910205, 5.841646398798123],
              [10.02696729197533, 5.838258419020816],
              [10.032595339114778, 5.836307826246463],
              [10.03487946757363, 5.832790116787902],
              [10.03616125620521, 5.826959315959284],
              [10.039015346976907, 5.822279966839768],
              [10.042756189466434, 5.811378868715649],
              [10.049140595504975, 5.800130621301841],
              [10.047770678467723, 5.793373456105014],
              [10.048764009196063, 5.790242465051125],
              [10.05649732393577, 5.783573853342862],
              [10.058298103907356, 5.776115014518269],
              [10.055741190612345, 5.7723388429804015],
              [10.057483535601225, 5.763203437910579],
              [10.056599363552586, 5.759904223122705],
              [10.059809327649713, 5.750534363642052],
              [10.063742829289634, 5.746799429613806],
              [10.06576691758372, 5.7408676455033225],
              [10.066124445173058, 5.7306335280541445],
              [10.071967395419737, 5.716965550403343],
              [10.070924980549469, 5.71329810462908],
              [10.0714034538437, 5.703983291514884],
              [10.074763633560908, 5.696554153705714],
              [10.050881397075164, 5.692393406529288],
              [10.009236664885155, 5.684496231639652],
              [9.967423913452507, 5.676875303513845],
              [9.882275764203822, 5.661894528026274],
              [9.797472476224803, 5.646726158706038],
              [9.712439259103773, 5.63128691458079],
              [9.652432200636083, 5.6204313429280095],
              [9.62869475481792, 5.616329601572156],
              [9.586391610468645, 5.6094838753928675],
              [9.464569832210254, 5.590167340459799],
              [9.45593552817417, 5.650556688293434]
            ]
          ],
          [
            [
              [9.442180727864928, 5.67855914927771],
              [9.44471504222604, 5.682231660488865],
              [9.451518448633236, 5.6790630618152],
              [9.446955761819693, 5.677038824295167],
              [9.442180727864928, 5.67855914927771]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.01867957866237, "lat": 43.83324848019397 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26063"],
        "coty_name": ["Huron"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Huron County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01622974"
      },
      "bbox": [
        9.442180727864928, 5.590167340459799, 10.074763633560908,
        6.038629325830517
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.5691961080459516, 5.868329846966724],
            [7.588437367959087, 5.870275816003755],
            [7.63837819038712, 5.873664229742025],
            [7.656316395113369, 5.875167760482815],
            [7.727565251414825, 5.882178395206605],
            [7.768264314101143, 5.887075161146469],
            [7.799711931538037, 5.890291969239278],
            [7.876160345181131, 5.899033783493509],
            [7.879946485656563, 5.899680083177646],
            [7.9099030713556955, 5.902591851656483],
            [7.923125946642154, 5.7918517532354725],
            [7.928935805299706, 5.742038840634499],
            [7.938817000218895, 5.656146884030677],
            [7.946605205330832, 5.584686173196534],
            [7.949842201125833, 5.555950339134277],
            [7.841910481152875, 5.544281197473941],
            [7.781836587716604, 5.53647837679636],
            [7.744396085597489, 5.532325358678397],
            [7.695299026375488, 5.5276442621776605],
            [7.6825326519437045, 5.526704621150645],
            [7.6385656454834505, 5.5221311807739415],
            [7.610102300093039, 5.519649153384055],
            [7.603438580389224, 5.577045344258523],
            [7.600376750731679, 5.605979473390449],
            [7.590237047136092, 5.692424671203301],
            [7.5861178077541505, 5.735415063330644],
            [7.582915895613354, 5.7654371728229785],
            [7.577158917254991, 5.8120913083575045],
            [7.5691961080459516, 5.868329846966724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.80162908790064,
          "lat": 43.990113534203935
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26085"],
        "coty_name": ["Lake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lake County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01622985"
      },
      "bbox": [
        7.5691961080459516, 5.519649153384055, 7.949842201125833,
        5.902591851656483
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.715868654584462, 6.339739687568188],
            [8.844604044891007, 6.355971681267443],
            [8.887053227349778, 6.361782611607876],
            [8.939880495667122, 6.368630971666542],
            [8.972177430963695, 6.373204020832743],
            [9.057271251423307, 6.384101854577924],
            [9.070172803631618, 6.298463583145967],
            [9.072580886571638, 6.281231612150684],
            [9.08558523618749, 6.183386670723502],
            [9.09279885408582, 6.12641256936959],
            [9.103414147846927, 6.040993066181721],
            [9.022615531654859, 6.03093325203235],
            [8.987403216282617, 6.02640533650438],
            [8.903286289306946, 6.015785990171754],
            [8.846193549697556, 6.008578429325503],
            [8.760154104826636, 5.996867002618385],
            [8.759537378877114, 6.011840990247653],
            [8.751875876943176, 6.062645010013575],
            [8.749136497592971, 6.082499919513993],
            [8.737825298883822, 6.168543790910378],
            [8.726980065931771, 6.254261011955651],
            [8.715868654584462, 6.339739687568188]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.12645278100591, "lat": 44.33495606962516 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26129"],
        "coty_name": ["Ogemaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ogemaw County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "01623007"
      },
      "bbox": [
        8.715868654584462, 5.996867002618385, 9.103414147846927,
        6.384101854577924
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.3329479251310878, 6.657970394798913],
            [1.4193726978999566, 6.65864725848864],
            [1.4778183276921748, 6.659792539757213],
            [1.4936780002330916, 6.660263184954193],
            [1.5208777614393485, 6.660461721637384],
            [1.571140703216015, 6.661503343179033],
            [1.5995750102449633, 6.662477594234981],
            [1.6004362199472768, 6.618918935300542],
            [1.671943058213373, 6.62035405976202],
            [1.6864153077756519, 6.621563890019011],
            [1.6878254063061515, 6.577180523608259],
            [1.690314514429548, 6.5772258363496565],
            [1.6913776247404362, 6.549430323552902],
            [1.692353048580131, 6.505281748364639],
            [1.6939740186315242, 6.405263884143585],
            [1.6955626202333152, 6.31884618125885],
            [1.6598154128376759, 6.3180762237204595],
            [1.60893686961727, 6.3166578024961595],
            [1.5657915039463355, 6.3163521160882015],
            [1.5219444847775845, 6.3162202689489675],
            [1.5224465504453402, 6.281576950238726],
            [1.5229648269091323, 6.229131268553664],
            [1.4938907151710537, 6.228463986288822],
            [1.42894091266486, 6.227286591528809],
            [1.3421373981112195, 6.226343229753461],
            [1.3413258275146531, 6.3132267667018755],
            [1.3405597186051919, 6.399738875828074],
            [1.3395476597543825, 6.486379971470936],
            [1.3388450365233568, 6.515141867649872],
            [1.3379773350935182, 6.571554603141101],
            [1.3337783944432606, 6.5714912530590555],
            [1.3329479251310878, 6.657970394798913]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.52732232483096, "lat": 45.12311643942675 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27093"],
        "coty_name": ["Meeker"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Meeker County"],
        "coty_fp_code": "093",
        "coty_gnis_code": "00659492"
      },
      "bbox": [
        1.3329479251310878, 6.226343229753461, 1.6955626202333152,
        6.662477594234981
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.30764289299549835, 9.46459398915466],
            [-0.222916892869296, 9.463632485322334],
            [-0.13555726159512313, 9.462688883693547],
            [-0.03382364090883713, 9.462079572770392],
            [0.039160967062205586, 9.461831339611612],
            [0.10472393267921568, 9.461528015288298],
            [0.12672841351624206, 9.461746191055989],
            [0.1262621344124777, 9.397785891053152],
            [0.12589288322393646, 9.312639038070206],
            [0.13824594254808956, 9.312592602769284],
            [0.13797778350291023, 9.255748191175398],
            [0.13770239129110043, 9.14198120405888],
            [0.17328405602108565, 9.14193324305883],
            [0.22520363851662106, 9.141503833344313],
            [0.22543429259786563, 9.106011174575885],
            [0.22554744246725386, 9.056214724133119],
            [0.3265913453899227, 9.055212091478523],
            [0.41319358172323617, 9.055569693361653],
            [0.4508534609092133, 9.055951320968466],
            [0.48607910609293525, 9.056047981920525],
            [0.5740044178912709, 9.056455034721427],
            [0.5740926443249997, 9.14203329988224],
            [0.6604395719927924, 9.142604313603336],
            [0.6598566832184527, 9.228019792093432],
            [0.6765683214529343, 9.227418263803658],
            [0.6957590740012141, 9.227352693489834],
            [0.7459504751957247, 9.226535743049645],
            [0.7469663525133444, 9.155872596074486],
            [0.7482349473247883, 9.077631887041502],
            [0.7481424062111661, 9.056706811892546],
            [0.7491883731953967, 8.99987455188701],
            [0.7493348025988175, 8.971465922968209],
            [0.7665909328277525, 8.971478019747842],
            [0.7664966235983924, 8.943099253641952],
            [0.7668976074599085, 8.88630604838857],
            [0.7668197372369755, 8.80099566377642],
            [0.7471474015387889, 8.800926102409214],
            [0.6821197533612368, 8.80013851319653],
            [0.6334990311872016, 8.799742846610743],
            [0.6075274112062864, 8.800001672426081],
            [0.5527057358145734, 8.799810826717671],
            [0.548633244644675, 8.799557967949278],
            [0.4831975703549664, 8.799568855495048],
            [0.41776188867356306, 8.799566160289258],
            [0.38672140769007096, 8.799673905863871],
            [0.3833499005266316, 8.799920498890218],
            [0.3308078841218013, 8.800312558906075],
            [0.24404343039287463, 8.80036680378671],
            [0.12753170406022277, 8.80023261835764],
            [0.12353932163833947, 8.800541955714458],
            [0.040012331359685606, 8.800913976050461],
            [0.03854559632893505, 8.801209241562578],
            [-0.004137335223645183, 8.800722022396007],
            [-0.019675009522318078, 8.801014735777729],
            [-0.09098499197295672, 8.80182823385508],
            [-0.11360929082006971, 8.801940142122131],
            [-0.11620454568443724, 8.80382338950527],
            [-0.11620715555886568, 8.809674722470522],
            [-0.10986089490413614, 8.810151916483102],
            [-0.11116646925463183, 8.813224934691371],
            [-0.10858632069388735, 8.817865204834964],
            [-0.1111933096356409, 8.819605336658395],
            [-0.11692299177696715, 8.817084498184537],
            [-0.1230424811554649, 8.819984549409154],
            [-0.12509277997704038, 8.827491340318053],
            [-0.12715644814648533, 8.831371327095889],
            [-0.12108258561965093, 8.832013760700864],
            [-0.11642502276065197, 8.838285879299287],
            [-0.12284341060746874, 8.841124379515223],
            [-0.11768792163060415, 8.84437584410413],
            [-0.11411438766444719, 8.840243579384106],
            [-0.11070424509356094, 8.841765602210133],
            [-0.1139588990278621, 8.845333297088072],
            [-0.11984291133249438, 8.847321441441514],
            [-0.11364892096855471, 8.854507057878022],
            [-0.11877718286780337, 8.857251035217471],
            [-0.12164318801668318, 8.861429776241415],
            [-0.11630660211290104, 8.862370633600133],
            [-0.11184029454109058, 8.866708897616403],
            [-0.11304760154607936, 8.868486318510861],
            [-0.1220996306125316, 8.864396252974538],
            [-0.1260871740047446, 8.86762610249051],
            [-0.1235367210144847, 8.871218107868565],
            [-0.11934447079905086, 8.868918139469846],
            [-0.11473764160159348, 8.870204215260895],
            [-0.11631936130911458, 8.873665316475352],
            [-0.12022770801519017, 8.875794648959682],
            [-0.11570939855527936, 8.880994500225434],
            [-0.11404948520636363, 8.88992648929813],
            [-0.11484319335659803, 8.900932639591712],
            [-0.11796983895580382, 8.90343530587855],
            [-0.11651467600612135, 8.907346580099302],
            [-0.1180361996084824, 8.911709123794651],
            [-0.12332008317694214, 8.913319554413262],
            [-0.12730877696046905, 8.918937772417436],
            [-0.1331389978429796, 8.921477190766558],
            [-0.13297883156821297, 8.925462290234163],
            [-0.1302565627223938, 8.929412150069735],
            [-0.13439834177077833, 8.930764700316944],
            [-0.13498595798732346, 8.934163814652356],
            [-0.13913306189422417, 8.939069237772351],
            [-0.1352249103714755, 8.942235495972414],
            [-0.13483118628053295, 8.949404295780925],
            [-0.1379102039380814, 8.953380184392515],
            [-0.13828845643557328, 8.959077265322104],
            [-0.13686644658282035, 8.963566697002332],
            [-0.13956802779804012, 8.968637439364107],
            [-0.1376465899666373, 8.972019128929466],
            [-0.14432296301551908, 8.974734578900206],
            [-0.1438050963241947, 8.97819214747974],
            [-0.14596668394674173, 8.989182576407545],
            [-0.15128906006784543, 8.993648867237505],
            [-0.15411523553327838, 9.000085545928235],
            [-0.15843568523252724, 8.998865433873831],
            [-0.16039195480225898, 9.001017143945672],
            [-0.15503825359285983, 9.004221993241133],
            [-0.15487246218255396, 9.007748830669016],
            [-0.15984404486119694, 9.009820221286468],
            [-0.15909154482578058, 9.013784548621167],
            [-0.16125958268584833, 9.01723248142622],
            [-0.16394672199515195, 9.014404755793246],
            [-0.1669158625081499, 9.016927063277107],
            [-0.15928837276140653, 9.021711502340008],
            [-0.16229504209819057, 9.025291838599262],
            [-0.163208065730496, 9.029316828694926],
            [-0.16818335196796141, 9.036136106053165],
            [-0.16829280679059438, 9.038892249541504],
            [-0.16519330342003596, 9.04370070171916],
            [-0.16550959832346784, 9.049043983001763],
            [-0.17174681248642845, 9.060947035926477],
            [-0.16922756979516423, 9.064888777443132],
            [-0.1763777114836066, 9.07075685493046],
            [-0.1772675537998691, 9.07343085423467],
            [-0.18329511851038588, 9.07315420964411],
            [-0.18121536268260494, 9.078063069632744],
            [-0.18535081754100458, 9.078651082617661],
            [-0.1845345098740055, 9.082413703471351],
            [-0.1897453233447015, 9.083205782835861],
            [-0.18460434463681746, 9.090097725868718],
            [-0.188411355623745, 9.092664403519587],
            [-0.19079283638301212, 9.097834705592078],
            [-0.19543853409620912, 9.095755769787667],
            [-0.19887479800176497, 9.101996379521518],
            [-0.20362693697164003, 9.104921288144743],
            [-0.19799929696818638, 9.109439523581258],
            [-0.1996122894809973, 9.113417987030445],
            [-0.19938048545883832, 9.11999791307091],
            [-0.20212255286577846, 9.122853923621122],
            [-0.20036357913564937, 9.127888262653652],
            [-0.20364437055541798, 9.134994349890256],
            [-0.2078877766251374, 9.135304495806972],
            [-0.2074278416881719, 9.139458066667286],
            [-0.21081936008000163, 9.147149052069436],
            [-0.21117347155749908, 9.1558849444722],
            [-0.21613223525950276, 9.160927981764768],
            [-0.21339164853074866, 9.164230205998177],
            [-0.215931268305995, 9.166999627889679],
            [-0.22665446115285431, 9.16946453841429],
            [-0.225287448423272, 9.176992793819558],
            [-0.2293001440576591, 9.180953563354352],
            [-0.22900197485992338, 9.183497135554425],
            [-0.2249022032084708, 9.187567498772713],
            [-0.22891531100253648, 9.191430028562863],
            [-0.22566253650718304, 9.198447400524469],
            [-0.22826458686909668, 9.201511166952438],
            [-0.22209529505969222, 9.203306662227343],
            [-0.22351905237093925, 9.209099899905658],
            [-0.2278803777977575, 9.211888250179515],
            [-0.22378566632015853, 9.215664140957163],
            [-0.23174036229651493, 9.223387024702943],
            [-0.23583233061343783, 9.225977909013706],
            [-0.23687940146552833, 9.229024759938639],
            [-0.23593546759699208, 9.234987649507163],
            [-0.241927099187115, 9.236716974608747],
            [-0.24835257273766, 9.241878565368205],
            [-0.24870815493179155, 9.246288460226824],
            [-0.246908747723774, 9.250185099228615],
            [-0.24786755466262358, 9.254992951686885],
            [-0.2528199862168584, 9.258866531364218],
            [-0.2498404914088569, 9.265588788884497],
            [-0.25128674289298436, 9.269031029341997],
            [-0.24720774375883833, 9.282659539435597],
            [-0.24810307534286094, 9.287540031169373],
            [-0.25300325582753047, 9.290553819487195],
            [-0.2543458332741955, 9.293074352083993],
            [-0.2558913252522027, 9.303906619144566],
            [-0.25348830545428425, 9.309195331936035],
            [-0.25751874517104373, 9.310401639421984],
            [-0.2594790922213938, 9.313291884611862],
            [-0.2570038296293182, 9.321667792710718],
            [-0.25799313211499975, 9.33544790575077],
            [-0.2591672525845058, 9.341628321067864],
            [-0.2613963640317538, 9.346209786846456],
            [-0.2689818577538855, 9.351673267447135],
            [-0.274388453856529, 9.360163123476408],
            [-0.27610498233503933, 9.364333686794206],
            [-0.2796565094442859, 9.36495048301992],
            [-0.2803656585342578, 9.367804470728526],
            [-0.2780529066846726, 9.370589567607924],
            [-0.27730051478188567, 9.378829484274045],
            [-0.278858095697079, 9.382014699414942],
            [-0.28401413381867696, 9.384297308403713],
            [-0.2800586473401009, 9.386610215575127],
            [-0.27882763424504226, 9.3894210130059],
            [-0.28295395404577406, 9.392529905152239],
            [-0.2836429584136842, 9.397329563814395],
            [-0.2860905396539417, 9.398790691335162],
            [-0.2928280960969447, 9.39931881409259],
            [-0.291304001517154, 9.404810453300197],
            [-0.29161740310807815, 9.409356036577318],
            [-0.29600401386472347, 9.419441262460456],
            [-0.29672444644630425, 9.425266368855867],
            [-0.29239750812191345, 9.428966957158117],
            [-0.29472256704438127, 9.433444337646938],
            [-0.30229907327528355, 9.43521232933992],
            [-0.30613455617769, 9.433067379975627],
            [-0.3076459293068175, 9.437101306314068],
            [-0.3038128487301351, 9.442717300294605],
            [-0.29253484393942664, 9.448575534822787],
            [-0.29081870772954355, 9.452545641444317],
            [-0.2949886607263394, 9.454203606069937],
            [-0.3021554210033387, 9.451151357711076],
            [-0.3063311541723964, 9.454085072200632],
            [-0.3084124122131996, 9.463805398272827],
            [-0.30764289299549835, 9.46459398915466]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.40172716489134, "lat": 47.77385566916849 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27119"],
        "coty_name": ["Polk"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Polk County"],
        "coty_fp_code": "119",
        "coty_gnis_code": "00659505"
      },
      "bbox": [
        -0.3084124122131996, 8.799557967949278, 0.7668976074599085,
        9.46459398915466
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.098624688167854, -4.461963801309943],
            [6.212631311477004, -4.453221912741274],
            [6.213333130398236, -4.452959749196002],
            [6.3564942686844965, -4.442107081521715],
            [6.431040619406022, -4.436563367046902],
            [6.443047546985592, -4.43596181237178],
            [6.445142705452947, -4.474745905135875],
            [6.449173905186128, -4.524547989135676],
            [6.452605804095266, -4.572566606987439],
            [6.4561852610634745, -4.620527823780191],
            [6.462506600929791, -4.699573727943935],
            [6.458118464283806, -4.700244549562075],
            [6.432008026413785, -4.702400979750582],
            [6.396713712172772, -4.704770678746253],
            [6.355717965469917, -4.707302215419343],
            [6.288727086894249, -4.711621130888932],
            [6.292720719915126, -4.769773038021459],
            [6.207805350428595, -4.776188765450264],
            [6.209119487958808, -4.790913886304249],
            [6.166715238996206, -4.794302663443066],
            [6.079671433252398, -4.801110531723688],
            [6.075833050788875, -4.727808382344346],
            [6.118715465437987, -4.724292390522547],
            [6.1169292280077805, -4.696568819909904],
            [6.114019187628474, -4.662708870169951],
            [6.1109991171084515, -4.617604758601778],
            [6.102763461835896, -4.5131905307403475],
            [6.098624688167854, -4.461963801309943]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.94786290669022, "lat": 33.92077862445124 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28017"],
        "coty_name": ["Chickasaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chickasaw County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00695733"
      },
      "bbox": [
        6.075833050788875, -4.801110531723688, 6.462506600929791,
        -4.43596181237178
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.526256225296178, -5.001837671693716],
            [6.577280759594806, -4.997307147638175],
            [6.584368572475907, -4.995512991203273],
            [6.588355788300091, -4.990995024495027],
            [6.596741156486545, -4.9869594801308414],
            [6.598776227762416, -4.982743756092058],
            [6.60202827495937, -4.979932395485672],
            [6.606665358187795, -4.982680146868226],
            [6.613360178986376, -4.97410833011517],
            [6.61786832922664, -4.9783166133699615],
            [6.621872019834775, -4.9789414541128485],
            [6.623700437811005, -4.972039113832986],
            [6.6297931425049725, -4.9730324167074835],
            [6.631796206048382, -4.969805239551899],
            [6.6307326046612225, -4.966492203426591],
            [6.633937948231547, -4.9631948566386574],
            [6.63920305654895, -4.9616538855671894],
            [6.64239445402175, -4.955835243815919],
            [6.641669972148479, -4.950411361546914],
            [6.644121655818921, -4.947612325443014],
            [6.64924638206095, -4.949838452246485],
            [6.652413351681177, -4.9528864527842575],
            [6.655569092434412, -4.952500392642259],
            [6.659946334285641, -4.9555827060366475],
            [6.66086819590673, -4.960317631047777],
            [6.6676713198408315, -4.962006875497219],
            [6.67040123778919, -4.967074145868053],
            [6.677357377840986, -4.967856862325526],
            [6.68257087392472, -4.972972191915667],
            [6.687937341433721, -4.971439115993976],
            [6.689165485168166, -4.968050157182321],
            [6.677981263658247, -4.96158516861061],
            [6.6713257388672, -4.954056107821203],
            [6.6690320446918765, -4.947694284102921],
            [6.668380636039282, -4.942200223190013],
            [6.665069579098275, -4.933316640264696],
            [6.667493607111548, -4.930854988194578],
            [6.67024674391604, -4.933644191075658],
            [6.6742037102568545, -4.930065994794226],
            [6.674189278547524, -4.927786453979612],
            [6.666040022466881, -4.917130414054163],
            [6.671134416384431, -4.913370880668039],
            [6.6769179721724425, -4.9013742951783374],
            [6.681206206317388, -4.89724167339053],
            [6.6798810362167975, -4.890497638633441],
            [6.6728520763634505, -4.885472381316966],
            [6.662830483253214, -4.881731365585831],
            [6.659109318752231, -4.883945225141202],
            [6.655373653774089, -4.883918359469113],
            [6.653031755782864, -4.88078702062868],
            [6.654025007794962, -4.877131374326496],
            [6.658643700543779, -4.87084667314421],
            [6.6559209582029615, -4.8610632425160425],
            [6.658043871821548, -4.855161031591855],
            [6.656998626990536, -4.8531595864357495],
            [6.650217934177752, -4.854668033402988],
            [6.646390745718238, -4.853509508999647],
            [6.644725623971836, -4.847655814925759],
            [6.652159910185961, -4.8386739121517595],
            [6.65770401280694, -4.83508809159814],
            [6.663174746522046, -4.835321111456498],
            [6.668838207640953, -4.830117231396558],
            [6.6735464520802985, -4.828990201641727],
            [6.679740299455782, -4.831757300656033],
            [6.68112009577964, -4.827434834125043],
            [6.685532726263638, -4.828039950187058],
            [6.687110449043272, -4.831690375054845],
            [6.691353367595254, -4.8303937508903045],
            [6.693040435767145, -4.8253388873369385],
            [6.697919417012581, -4.825731156014993],
            [6.70197244006479, -4.823702936077139],
            [6.709562568979062, -4.82471179403313],
            [6.7155580748339565, -4.8166707087887035],
            [6.722567483526069, -4.82199547395713],
            [6.725106435646012, -4.814011338762877],
            [6.728028281410246, -4.8140844751053775],
            [6.73131956296479, -4.817507005682399],
            [6.733531307987172, -4.807960703421657],
            [6.737711122533008, -4.805169164647673],
            [6.736403810209106, -4.799899818932796],
            [6.739730365591186, -4.797561863270471],
            [6.748260862888694, -4.795962409809402],
            [6.748079931488182, -4.79974374408229],
            [6.752496384860513, -4.802919441608144],
            [6.75688764578359, -4.803559519694667],
            [6.759812872970021, -4.799795858445574],
            [6.76458255246445, -4.798524238076372],
            [6.766689338966346, -4.793305412086923],
            [6.771427201571591, -4.788480317518745],
            [6.776126192585135, -4.785751456353327],
            [6.780486932384654, -4.7806307038310445],
            [6.77966501458108, -4.777061577727595],
            [6.7841834258749305, -4.769173562896777],
            [6.790305407592197, -4.767205135974374],
            [6.790266472348061, -4.764316057859647],
            [6.793198148345531, -4.759854138218692],
            [6.790771077768285, -4.756753703629285],
            [6.792351447517297, -4.752609088552541],
            [6.790380152900234, -4.7456207387373786],
            [6.792270900097576, -4.742986797091758],
            [6.7985064377687845, -4.739976985834493],
            [6.854368963903019, -4.735625641840414],
            [6.855257254799804, -4.735381387636008],
            [6.854609678634387, -4.761021399884054],
            [6.8543219235299375, -4.798824702834076],
            [6.852393547494841, -4.908888739578774],
            [6.852136169492191, -4.910998538524307],
            [6.85137829409133, -4.948115531989753],
            [6.8508297221097845, -4.96987349185781],
            [6.84957194690626, -5.041221418609288],
            [6.8479073644772, -5.1344856603181865],
            [6.846802077649493, -5.19570655326713],
            [6.7317974198224375, -5.204841617477175],
            [6.638094588911466, -5.213610421703416],
            [6.545060841359112, -5.220914396952798],
            [6.537512494532819, -5.133239165573743],
            [6.5373148562670345, -5.13281485587362],
            [6.533061330967978, -5.081942877800317],
            [6.526256225296178, -5.001837671693716]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.4433136089754, "lat": 33.47291545371086 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28087"],
        "coty_name": ["Lowndes"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lowndes County"],
        "coty_fp_code": "087",
        "coty_gnis_code": "00695767"
      },
      "bbox": [
        6.526256225296178, -5.220914396952798, 6.855257254799804,
        -4.735381387636008
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.443021463330971, -4.415673559557906],
            [5.482036633825081, -4.4132320496649715],
            [5.504513587534984, -4.412104869275903],
            [5.543574423134146, -4.409615451727169],
            [5.615178989655738, -4.405303939363258],
            [5.613559685810807, -4.376175465062891],
            [5.678897371399599, -4.372666680129676],
            [5.695577327922703, -4.37195137254094],
            [5.761357010664919, -4.367886482872316],
            [5.786959828561747, -4.366139600675851],
            [5.788693373340714, -4.395106296933435],
            [5.790906967245827, -4.432189294529855],
            [5.791547626233886, -4.435622903091195],
            [5.793432915811421, -4.464149437404138],
            [5.795325408269309, -4.486462935158283],
            [5.7965355355338986, -4.486398533236501],
            [5.798746205592682, -4.515801438090262],
            [5.8035802276485455, -4.584371620663339],
            [5.810917862256217, -4.69019675806442],
            [5.6382649391015836, -4.702107913999865],
            [5.595715188569018, -4.704710421378877],
            [5.593545976945309, -4.674863893107955],
            [5.583647287939076, -4.675583406032325],
            [5.523361853442906, -4.678585446394403],
            [5.464573683189312, -4.682371186585332],
            [5.4605604099870515, -4.609368025666682],
            [5.458489001183518, -4.595088231427781],
            [5.454873751202912, -4.5323626208407495],
            [5.453643407148867, -4.514235685454293],
            [5.449456623715134, -4.439174218257125],
            [5.444092472541474, -4.435736950014115],
            [5.443021463330971, -4.415673559557906]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.70765422492576, "lat": 34.02819910630979 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28161"],
        "coty_name": ["Yalobusha"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Yalobusha County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "00695801"
      },
      "bbox": [
        5.443021463330971, -4.704710421378877, 5.810917862256217,
        -4.366139600675851
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5400946663926867, -0.30793228093954966],
            [1.539808516512156, -0.29308743417362665],
            [1.5391032683771961, -0.2181840949627819],
            [1.5609160629715015, -0.21873842233100552],
            [1.6179388919089732, -0.21896191916881488],
            [1.6248895501036782, -0.21911628953807014],
            [1.728111253790992, -0.22013996277203282],
            [1.7723204473670018, -0.22068903499318857],
            [1.7738768220109578, -0.22679673259172783],
            [1.7769681375849482, -0.22667100830496564],
            [1.7838941967570447, -0.23311386385543695],
            [1.7908527846306093, -0.22751399119837773],
            [1.7921670705511044, -0.23068373957271535],
            [1.800015125506164, -0.23500679736432986],
            [1.8029447894701454, -0.2333508360980576],
            [1.809051786973002, -0.23827417647911184],
            [1.8132545379351899, -0.23858414646789844],
            [1.8153406653552315, -0.2414384046891309],
            [1.8200889621652074, -0.23580655735066164],
            [1.8247623092959369, -0.2356466699493871],
            [1.828591521654766, -0.23103511674981084],
            [1.832145700523301, -0.23310524747378047],
            [1.838463185873555, -0.23373604011438978],
            [1.841868078889532, -0.23808694997076893],
            [1.8415958388777034, -0.24273479747909477],
            [1.8461939157152263, -0.24114385972034288],
            [1.8482342052813572, -0.24272350879302862],
            [1.8538270267220975, -0.24000345607749293],
            [1.859349353805987, -0.24537912337191709],
            [1.8650132851715961, -0.2429810681333883],
            [1.87983698675908, -0.24489339959185685],
            [1.8810834764347912, -0.2404084277048698],
            [1.8848740864555704, -0.2426472415523969],
            [1.891381563912525, -0.23935623891599914],
            [1.8942912150124043, -0.23999568492286158],
            [1.9038366290143338, -0.23858266907210737],
            [1.9074211255180917, -0.23636534025944309],
            [1.9117198326107865, -0.23580833674322396],
            [1.9229927556184505, -0.23761400961527823],
            [1.929432856232842, -0.236652977676623],
            [1.9307911627511478, -0.23459185646311992],
            [1.946926459764332, -0.2331962756953801],
            [1.9506723535418944, -0.23597600830803103],
            [1.955220371131956, -0.2370183151126413],
            [1.9557587280876223, -0.24115744357701813],
            [1.963854486602637, -0.2415799066660489],
            [1.9633340892727866, -0.300804113259532],
            [1.961512705395307, -0.4325196728562254],
            [1.9612431723257897, -0.47654145756272104],
            [1.9809495769569967, -0.47666186938209],
            [1.9804121534518062, -0.5143677984911372],
            [1.9793449394970049, -0.5729497096304215],
            [1.978081656922136, -0.655849233045522],
            [1.9758094033820337, -0.6610222280227741],
            [1.9728140897543205, -0.6607802788456306],
            [1.9719535023087131, -0.6567518613265348],
            [1.9678576792849984, -0.656281628958186],
            [1.9657243653334557, -0.6590295809969234],
            [1.9607371511213507, -0.6612816975819098],
            [1.95714778962263, -0.6604774518033651],
            [1.9515626172925837, -0.6534806392257984],
            [1.9490499612417604, -0.6523120105600825],
            [1.9461781145840817, -0.6462471133405979],
            [1.9422151634624119, -0.6454769016211321],
            [1.9424555189923127, -0.6525579987487168],
            [1.9411262503107483, -0.655451786036902],
            [1.937810055371679, -0.6559611849200505],
            [1.9308168558538144, -0.651212748290633],
            [1.9338789032987242, -0.6462376088606473],
            [1.9288842823608428, -0.644565053382578],
            [1.9245801401867637, -0.6415464224193698],
            [1.9225105049463918, -0.6366909156402583],
            [1.9176481781925532, -0.6353543594309468],
            [1.9061728292760958, -0.6398254894406683],
            [1.9019479689020906, -0.6366888876712031],
            [1.8982654209490357, -0.6381014874665896],
            [1.8946869323688977, -0.6427689819989315],
            [1.8798582494607172, -0.6491528950546287],
            [1.875588187687645, -0.6489313801696475],
            [1.8691357310464358, -0.6544269110378718],
            [1.8668443373650008, -0.6480218483292969],
            [1.8709616273129583, -0.6437363591397743],
            [1.8708647866800192, -0.6407315947110308],
            [1.8664546651604084, -0.6399224157899395],
            [1.8598340236309794, -0.6424854424585414],
            [1.8584656250655822, -0.6453642914554204],
            [1.8591883317269573, -0.6521405123831472],
            [1.8566144542658973, -0.6551399688744088],
            [1.8562324286555456, -0.6598837545607137],
            [1.8501809582272828, -0.6544950598404423],
            [1.8469897477066695, -0.6568755177442598],
            [1.8465596628868153, -0.6605405172613761],
            [1.8481042217067376, -0.6680973033006877],
            [1.83924008418841, -0.6693368731335854],
            [1.833195176770502, -0.6676521222564251],
            [1.8346701656136928, -0.6626570099393931],
            [1.840563678122287, -0.6636869812267718],
            [1.836018798977177, -0.6572107399760034],
            [1.8380680715786448, -0.6513232358333206],
            [1.835612608677107, -0.6442880801578093],
            [1.8045585157204218, -0.6436627113288536],
            [1.6764022924387538, -0.6415088653612154],
            [1.63416770402785, -0.6410185138062715],
            [1.6203016985442775, -0.640674725645387],
            [1.5443291624115925, -0.6397817111526356],
            [1.5431630179551517, -0.5491995823839299],
            [1.543095332199839, -0.4806496108103408],
            [1.5416512416102148, -0.3825266346412428],
            [1.5404244287840794, -0.33247924933005335],
            [1.5400946663926867, -0.30793228093954966]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.33999673755577,
          "lat": 38.257256532002515
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29013"],
        "coty_name": ["Bates"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bates County"],
        "coty_fp_code": "013",
        "coty_gnis_code": "00758461"
      },
      "bbox": [
        1.5391032683771961, -0.6693368731335854, 1.9809495769569967,
        -0.2181840949627819
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.952759485704732, -5.552769561567799],
            [7.96866326023336, -5.550889549186035],
            [7.984350941780015, -5.549549841199523],
            [8.010158060527639, -5.546708536639759],
            [8.071748541337781, -5.542229944070124],
            [8.065329781800225, -5.476780349088705],
            [8.055675059324733, -5.378886221136938],
            [8.050521363869175, -5.329247801285791],
            [8.046945522452646, -5.32961469078322],
            [8.044450426648003, -5.307746689003491],
            [8.059525837087676, -5.306372167587478],
            [8.091698556227369, -5.305170302707306],
            [8.091851387755737, -5.306543927174215],
            [8.11545581581934, -5.303840502035322],
            [8.153436277684412, -5.299836452701504],
            [8.2119395567583, -5.293909965661999],
            [8.269622937320756, -5.287718511884869],
            [8.270848886660184, -5.29118256034812],
            [8.26625560204377, -5.29383817147855],
            [8.263832822639582, -5.299607610155968],
            [8.267336061804915, -5.304554856365206],
            [8.276168134421209, -5.30209307633103],
            [8.278654178758986, -5.303525189432433],
            [8.281821285779115, -5.310437448899351],
            [8.285994708859539, -5.312729693084164],
            [8.293059291865324, -5.314875656150316],
            [8.297720136117327, -5.320592133722871],
            [8.309213382878148, -5.326685506219293],
            [8.313502564204928, -5.334191965463003],
            [8.324165369402646, -5.333859670025322],
            [8.3349025591196, -5.32713931207433],
            [8.34654224134963, -5.327308945123544],
            [8.35146834523262, -5.329383946897351],
            [8.34899378166944, -5.3459143400965585],
            [8.35093951827503, -5.350024172831994],
            [8.358617602822578, -5.359699679957379],
            [8.360570552452312, -5.363907133074231],
            [8.360082181196516, -5.372534555567285],
            [8.355752296430026, -5.37940911145329],
            [8.359931310636451, -5.395834810312586],
            [8.360186356171626, -5.406438042986081],
            [8.362652209442885, -5.413853690048462],
            [8.361759567807423, -5.420189487634886],
            [8.365997474525456, -5.426873438143424],
            [8.370201174532761, -5.4310538161708095],
            [8.373405821002128, -5.436208481036134],
            [8.37807607777387, -5.436388572441699],
            [8.38526744684472, -5.441744562684949],
            [8.387772958600767, -5.451353499347477],
            [8.394040135858004, -5.462707947019859],
            [8.39584917573798, -5.469335775735628],
            [8.39838078494319, -5.473612225980228],
            [8.404759400790415, -5.475861692280789],
            [8.415820630453416, -5.4762239739716465],
            [8.421865981941588, -5.480285217770973],
            [8.426704560684612, -5.489548430816203],
            [8.426212193034718, -5.492648784997537],
            [8.42120709670111, -5.497448019554355],
            [8.419100875019312, -5.501547525511548],
            [8.41729879951647, -5.511169320226965],
            [8.420400900960164, -5.525599210053209],
            [8.422326480090682, -5.53035686245064],
            [8.432364682315505, -5.5299072038818],
            [8.435724635341042, -5.532439187261874],
            [8.433292762437564, -5.536156643743456],
            [8.434232986591562, -5.538639710564438],
            [8.444184598436438, -5.545168911224172],
            [8.449320653550133, -5.549980392906587],
            [8.456383925007062, -5.54999622946657],
            [8.461180564760046, -5.552334167293553],
            [8.466250612048402, -5.563366731068342],
            [8.46895356691155, -5.5668470779136765],
            [8.474839502439021, -5.57114750502822],
            [8.477596531621856, -5.576076263360528],
            [8.485397246612225, -5.58072609279111],
            [8.496648079174232, -5.5835771839708075],
            [8.500128217704317, -5.586196904968953],
            [8.465044182122792, -5.589774923539653],
            [8.46960279515645, -5.632789881278031],
            [8.44745098207548, -5.634185888366557],
            [8.376770181828222, -5.642416416192034],
            [8.351784947476713, -5.645024251087335],
            [8.29705250353121, -5.651112908356277],
            [8.293357417517688, -5.651343099133498],
            [8.219135822332552, -5.659320418810822],
            [8.224139811815462, -5.703046037023283],
            [8.17580541563881, -5.708766206064328],
            [8.13834034555859, -5.712991740695725],
            [8.05625573299985, -5.716604525713534],
            [8.053786665938594, -5.717027062903713],
            [8.04979579861873, -5.717319116314396],
            [7.9704995922567266, -5.725831362899703],
            [7.964124818715846, -5.6598109529270095],
            [7.962260510704951, -5.63927747607696],
            [7.952759485704732, -5.552769561567799]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.71876817691776, "lat": 32.84787029676901 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01021"],
        "coty_name": ["Chilton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Chilton County"],
        "coty_fp_code": "021",
        "coty_gnis_code": "00161536"
      },
      "bbox": [
        7.952759485704732, -5.725831362899703, 8.500128217704317,
        -5.287718511884869
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.345685358092599, -6.833214076377936],
            [8.367464336533006, -6.8313522036676435],
            [8.493393170841466, -6.818251768599003],
            [8.516497933315005, -6.814998350214566],
            [8.587286952232631, -6.807675766475296],
            [8.600173799008509, -6.804820743730472],
            [8.609034623204835, -6.879876572075872],
            [8.613869014725248, -6.8765318427859645],
            [8.623825040323233, -6.863703160285215],
            [8.624844364191699, -6.857256602705769],
            [8.630635568782964, -6.855294673195362],
            [8.63259721007887, -6.848610343219069],
            [8.634438404357061, -6.847796207285037],
            [8.634701981819793, -6.841802091394875],
            [8.641191374045178, -6.840424926538775],
            [8.643465037168856, -6.842955421965398],
            [8.648428672525078, -6.841386277068199],
            [8.648948105502454, -6.83732184295794],
            [8.653785588565107, -6.839557553691071],
            [8.656066066235493, -6.838825636015563],
            [8.663835111131597, -6.822904936691829],
            [8.670601898059266, -6.819088058598644],
            [8.669676370069556, -6.816009411448287],
            [8.673320933761094, -6.810568861604836],
            [8.68585810862678, -6.799737469829019],
            [8.685384115087087, -6.794827926054856],
            [8.701202728225754, -6.793204471761964],
            [8.70450889723564, -6.808064567368272],
            [8.711315986585362, -6.865232657490861],
            [8.72554062119483, -6.86366735972622],
            [8.725608380451556, -6.878236435968351],
            [8.768818839103291, -6.873270787546377],
            [8.78314565694813, -6.873440515636404],
            [8.782618231382827, -6.888164239489466],
            [8.790834120118985, -6.956610348140391],
            [8.803297417340929, -7.061577839415371],
            [8.804593043415805, -7.077968580984466],
            [8.806961570431715, -7.098385543065035],
            [8.806854961536137, -7.100944257776994],
            [8.809168761582018, -7.118995582636434],
            [8.809622397596149, -7.120886914777252],
            [8.816271929585037, -7.185416401705636],
            [8.826944695042133, -7.269946554232717],
            [8.829450379807973, -7.291862925445437],
            [8.831465396726943, -7.305976889103357],
            [8.834272367435288, -7.305667445418829],
            [8.83493980297823, -7.314632906189453],
            [8.791477915225688, -7.318766763985248],
            [8.776132892293043, -7.320851091763553],
            [8.748254724006893, -7.323745919031073],
            [8.680150766559208, -7.3299637505343895],
            [8.66370664191346, -7.331916378406946],
            [8.607578476351739, -7.33793564813345],
            [8.604483798081816, -7.338037911130002],
            [8.569149670881727, -7.342218143343954],
            [8.552162120586528, -7.344001025710874],
            [8.514975122591439, -7.345705964867014],
            [8.511457325179288, -7.34616740537005],
            [8.42894058564234, -7.354848691551729],
            [8.40883552890311, -7.356748903849944],
            [8.408023736386717, -7.351009477172126],
            [8.398137989139054, -7.351971501111843],
            [8.385683460411487, -7.230684615497383],
            [8.38572340269807, -7.228445499207146],
            [8.379287492183861, -7.16201012117918],
            [8.366466985309106, -7.039736379035614],
            [8.363892177668511, -7.018127419056101],
            [8.36575802261083, -7.0148777117520895],
            [8.362146242532162, -7.010405892832735],
            [8.364723743586644, -7.007455141972961],
            [8.368642737308917, -7.007798917095848],
            [8.372822271099153, -7.005954930823452],
            [8.374911816608927, -7.001681956462068],
            [8.377730217041325, -7.001515026920058],
            [8.381340845360924, -6.996282438202757],
            [8.380308928447532, -6.99232290147051],
            [8.384628163378375, -6.990984025271423],
            [8.389741181249233, -6.984061239561719],
            [8.389201226129352, -6.979524894945124],
            [8.385906694776558, -6.9709397863369915],
            [8.381659556000228, -6.968624664371568],
            [8.380996671817469, -6.964447451919723],
            [8.388854980991026, -6.961062188868551],
            [8.388128147842474, -6.953722253561666],
            [8.390966708912334, -6.950117454195986],
            [8.386254444439027, -6.945414905348805],
            [8.383971035097517, -6.939648552445742],
            [8.386615375313664, -6.934547689817405],
            [8.379537981093327, -6.9290174758760745],
            [8.377828033271786, -6.924185929647035],
            [8.379760347680156, -6.919728322931928],
            [8.376842820953147, -6.917695298736814],
            [8.354529168300239, -6.919788433454939],
            [8.345685358092599, -6.833214076377936]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.4512638382709, "lat": 31.248492491954465 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01039"],
        "coty_name": ["Covington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Covington County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00161545"
      },
      "bbox": [
        8.345685358092599, -7.356748903849944, 8.83493980297823,
        -6.793204471761964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.496648079174232, -5.5835771839708075],
            [8.528403801712383, -5.5801548438497],
            [8.527000455725002, -5.565858185373152],
            [8.541608074717631, -5.5646684167985825],
            [8.542790695513254, -5.578778227292919],
            [8.615914080304107, -5.571522231057448],
            [8.636362951877206, -5.569372082757798],
            [8.643810115215539, -5.568108056502436],
            [8.69509302932202, -5.562529756154686],
            [8.757593199105438, -5.55539555147258],
            [8.802338649987517, -5.550652165491964],
            [8.831465471322762, -5.547641830062556],
            [8.829448981823875, -5.533461002209756],
            [8.843757666742528, -5.53205122911443],
            [8.845858949035078, -5.546230092618314],
            [8.908237331925122, -5.539916894039873],
            [8.906844509352531, -5.543389058851269],
            [8.908946233744093, -5.549587852997699],
            [8.908389549924282, -5.556988613464073],
            [8.899848521954326, -5.567859752515248],
            [8.89990092187877, -5.5710540156098105],
            [8.903307629944257, -5.578223330077016],
            [8.900931604211236, -5.586108540450526],
            [8.89789214932473, -5.590714278234485],
            [8.89388212681013, -5.592711538889067],
            [8.891173707901006, -5.597335090221081],
            [8.889322554834996, -5.612555003634008],
            [8.889930362017349, -5.619073389235142],
            [8.894403328561486, -5.623505598041756],
            [8.895872479648109, -5.628727401656817],
            [8.900733480320474, -5.635712181445972],
            [8.910959619040886, -5.643153433121211],
            [8.913102203823193, -5.647044879655635],
            [8.912035994222967, -5.669784269696853],
            [8.910941326598431, -5.680369476490333],
            [8.912179349272199, -5.691912324776087],
            [8.91607648673323, -5.704681963109017],
            [8.91945961497502, -5.719720673721097],
            [8.91925707702855, -5.7258589699077795],
            [8.925561858391081, -5.745940734986888],
            [8.926251976192557, -5.750798260118521],
            [8.92474778962203, -5.7609826216234215],
            [8.92427188847094, -5.777384394706425],
            [8.925380787467722, -5.7798515198905855],
            [8.925660154813697, -5.789991265744032],
            [8.928861746340882, -5.798759789767361],
            [8.930942635032965, -5.800691798738033],
            [8.93772995214691, -5.804688976391239],
            [8.94042935763985, -5.807858884835425],
            [8.945394615117584, -5.810804658742217],
            [8.950426726564674, -5.812093997926945],
            [8.95793329852149, -5.810566788834321],
            [8.960542389146346, -5.813679275780795],
            [8.959192139309351, -5.816003476166837],
            [8.954514893150856, -5.814989757438476],
            [8.944214346897688, -5.818581631901326],
            [8.94321001497173, -5.823547827124973],
            [8.940399736647878, -5.828758302065681],
            [8.940916825041207, -5.833813970208035],
            [8.938286523162859, -5.838207238904199],
            [8.941801231722973, -5.840976303403006],
            [8.940837786866595, -5.843430775580237],
            [8.932890601133767, -5.846292366118076],
            [8.928896391471861, -5.846659204444529],
            [8.923319614692446, -5.844404231191354],
            [8.91897937056248, -5.845116130539982],
            [8.905094592526758, -5.844896410617104],
            [8.90045367824604, -5.843151429999222],
            [8.897089095901569, -5.8440445761965165],
            [8.889196830110304, -5.852912236451855],
            [8.880046315591036, -5.85832458038153],
            [8.874235837064186, -5.857982048794215],
            [8.870609309411943, -5.850830472784178],
            [8.862315735628613, -5.847790597985278],
            [8.858761922147034, -5.847693104842232],
            [8.856637572212653, -5.851323645062831],
            [8.86233378262492, -5.85500885777636],
            [8.858561496771411, -5.860841677066974],
            [8.853835251027693, -5.861740389499684],
            [8.849799917554764, -5.856981792262343],
            [8.84936841907781, -5.851349153003314],
            [8.845798770700037, -5.851484087523529],
            [8.843936806196448, -5.857456347739187],
            [8.845008838051879, -5.860652850836149],
            [8.849444079264936, -5.866023346360729],
            [8.85012052168206, -5.869593223663511],
            [8.846687300859712, -5.874978036464772],
            [8.842993039971649, -5.876461492186173],
            [8.836638910323865, -5.875399841875157],
            [8.829717285292498, -5.88405735403982],
            [8.824484879273454, -5.885434622895326],
            [8.81963586847612, -5.883488743601386],
            [8.81514690990085, -5.8836108455441165],
            [8.808390254489339, -5.8891834342359815],
            [8.807082697799316, -5.894184614771279],
            [8.808405238965472, -5.898454089923856],
            [8.806409622853867, -5.901237212752259],
            [8.798973987999824, -5.90007141541758],
            [8.794418841286836, -5.900373154005194],
            [8.780265142241568, -5.898165048096956],
            [8.769765235860687, -5.889480141760358],
            [8.76578522226781, -5.892786584072801],
            [8.753339906143262, -5.894704104779597],
            [8.750470736156434, -5.896875570131995],
            [8.746876498365156, -5.896498620190718],
            [8.745778293289527, -5.890955162949295],
            [8.742827504334704, -5.890336277578567],
            [8.739319213538613, -5.894503403899145],
            [8.734510244449048, -5.891432248142859],
            [8.738642584930512, -5.882099083613215],
            [8.737484957848446, -5.880354730098634],
            [8.731703106412779, -5.884568397982629],
            [8.726303507600006, -5.885964500914511],
            [8.72337561748433, -5.889302558731492],
            [8.71710440450288, -5.891931542094801],
            [8.714076179014828, -5.8902044605415265],
            [8.712743393929529, -5.886665905222384],
            [8.713416050429869, -5.882547856531045],
            [8.708088542343212, -5.882500305911834],
            [8.703591562503709, -5.878864152744882],
            [8.69356871944249, -5.878470938703244],
            [8.6900480531131, -5.883966534767687],
            [8.683688643259577, -5.887499947985504],
            [8.67915178659554, -5.881645408770594],
            [8.679494006105399, -5.878966539299074],
            [8.683477586140052, -5.8774590601360135],
            [8.689090331685103, -5.873359896805651],
            [8.68221804316387, -5.863695489135771],
            [8.680130679466535, -5.863774813427448],
            [8.675056173363611, -5.86937777445702],
            [8.672024829940595, -5.869126678266678],
            [8.668591913414843, -5.862943520354331],
            [8.665157308680193, -5.859539847632785],
            [8.661928522017257, -5.8542172331193285],
            [8.661751807672912, -5.849447547884633],
            [8.657761507595499, -5.848294949917784],
            [8.654974248995297, -5.853513988367891],
            [8.649501795208481, -5.854701462601112],
            [8.647412814771137, -5.8479790795510835],
            [8.648893944563977, -5.844500367294755],
            [8.652654189107098, -5.8430582931352735],
            [8.644934942978969, -5.834291941419328],
            [8.641983053527225, -5.833628380984995],
            [8.640793916155527, -5.8379470365703785],
            [8.637134615427048, -5.836975715165154],
            [8.638010382167254, -5.829338309856568],
            [8.630081953695369, -5.829713503386953],
            [8.625351090849128, -5.825608111974321],
            [8.616513466339063, -5.8247918468084805],
            [8.614887305791912, -5.834846842019545],
            [8.618955863903427, -5.836487267986128],
            [8.61805911285565, -5.839885536500858],
            [8.61097685438837, -5.843325793006196],
            [8.6047197702791, -5.841740558197158],
            [8.60064219706729, -5.848416649889788],
            [8.597305456281411, -5.851626003838201],
            [8.595930424733908, -5.85613942711196],
            [8.58892950786282, -5.852649901208104],
            [8.581640686805306, -5.8413395989504755],
            [8.578161057259543, -5.840161328945872],
            [8.575063142618735, -5.841808976460864],
            [8.57562369940297, -5.847261447273073],
            [8.580041216185853, -5.853186085066729],
            [8.581816273222014, -5.861956614731035],
            [8.580342302146502, -5.870628242029404],
            [8.576814344683289, -5.8811855749422355],
            [8.571579196794625, -5.885236850517656],
            [8.57082475192721, -5.891042362308028],
            [8.577392124909379, -5.893882594423657],
            [8.582272978722195, -5.900157422344431],
            [8.587636695026442, -5.910535877054306],
            [8.586385002092866, -5.916720469195931],
            [8.584157780619597, -5.919109562271283],
            [8.58052660823658, -5.918105660342222],
            [8.578082156730785, -5.912108125411679],
            [8.565239039183778, -5.906437942531067],
            [8.560467012801242, -5.902816454509945],
            [8.55475426754862, -5.900516605923675],
            [8.547161654899364, -5.90103882828422],
            [8.543916401607774, -5.903625499740262],
            [8.531335540642488, -5.9049999834671345],
            [8.523120103537197, -5.908845018689081],
            [8.51729070615404, -5.910261878561722],
            [8.511746956064982, -5.910285338028165],
            [8.509496033596447, -5.913823634516299],
            [8.513483173505938, -5.921399207576495],
            [8.512181571007265, -5.924741157676094],
            [8.501349348003545, -5.928731647510955],
            [8.492389710513539, -5.84739488343104],
            [8.490869071548591, -5.835440976742061],
            [8.488495712429323, -5.811120575750162],
            [8.479674636228504, -5.72744391714834],
            [8.477087065556933, -5.703975466025286],
            [8.46960279515645, -5.632789881278031],
            [8.465044182122792, -5.589774923539653],
            [8.500128217704317, -5.586196904968953],
            [8.496648079174232, -5.5835771839708075]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.1491360544763, "lat": 32.59662584431652 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01051"],
        "coty_name": ["Elmore"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Elmore County"],
        "coty_fp_code": "051",
        "coty_gnis_code": "00161551"
      },
      "bbox": [
        8.465044182122792, -5.928731647510955, 8.960542389146346,
        -5.53205122911443
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.980728153467694, -5.478857865554115],
            [6.979994305626445, -5.47124899724576],
            [6.9830395291443565, -5.461903985305889],
            [6.986545582014896, -5.4583919964393255],
            [6.985700688762398, -5.455052882068974],
            [6.992798214182549, -5.454010312946882],
            [7.002532984607948, -5.4469263035345055],
            [6.995426023399448, -5.4379754119255965],
            [7.00113554956957, -5.432256137583437],
            [7.005384821958648, -5.431953771142103],
            [7.007471664254029, -5.435743336574405],
            [7.012986988070845, -5.435083714205566],
            [7.014528371119684, -5.431455888328804],
            [7.019816812470242, -5.429223103389985],
            [7.023944723988863, -5.429109719379926],
            [7.031947854093449, -5.434246516441244],
            [7.0343288053870845, -5.432551245877389],
            [7.037797747977485, -5.434059077480105],
            [7.042039625264866, -5.433405517873087],
            [7.0437680409947285, -5.430429023686008],
            [7.048593606771241, -5.432652150526858],
            [7.053348319095831, -5.430529792403583],
            [7.052186952017347, -5.42618170867325],
            [7.058262008762933, -5.423533977260991],
            [7.052347286069156, -5.4191660111671345],
            [7.053840842453432, -5.41583966697218],
            [7.059486433976127, -5.417004683780318],
            [7.064824050831238, -5.416123854299246],
            [7.0655017376076525, -5.4193138078873],
            [7.070643544647091, -5.42395240337859],
            [7.07239316397439, -5.4271926164652955],
            [7.076497661102592, -5.429498376834275],
            [7.081392328023971, -5.429828760252336],
            [7.085242548593476, -5.428309762698411],
            [7.085208183872636, -5.4246500190520655],
            [7.09157557765334, -5.424396222413476],
            [7.09338769380096, -5.4227013510786835],
            [7.0858994914312206, -5.4120618243955],
            [7.088525678825409, -5.407606367323449],
            [7.091283750587181, -5.412282249794948],
            [7.093993052159587, -5.411249214824977],
            [7.092518844911723, -5.406696240021331],
            [7.095499231769787, -5.4005045133283485],
            [7.106486842812772, -5.396526214414154],
            [7.107625381922542, -5.392492166571872],
            [7.110989967851426, -5.392763919399079],
            [7.112928491244678, -5.389862178020146],
            [7.118077954505383, -5.391574513078008],
            [7.119738113368864, -5.389453126495642],
            [7.125238441457584, -5.388365272226252],
            [7.128124214351469, -5.383813725255813],
            [7.142395173013644, -5.383180726353412],
            [7.143255847470382, -5.3772797816249005],
            [7.153241800084667, -5.368279305878687],
            [7.155729473144262, -5.361202567296956],
            [7.155545653125357, -5.356127444979943],
            [7.1579892523089645, -5.351196173881809],
            [7.162751950026518, -5.348926706879207],
            [7.164949491228824, -5.345376617591962],
            [7.168528532065388, -5.345212327826193],
            [7.172384699431545, -5.341382657315572],
            [7.175970952034631, -5.340249886513707],
            [7.185223683537446, -5.3333154614598115],
            [7.19147450948664, -5.3335678311755705],
            [7.1931477860559, -5.328101957663153],
            [7.197421299819084, -5.325966219141021],
            [7.203261697212657, -5.325401637540616],
            [7.207440127811682, -5.322950541555601],
            [7.213466479444904, -5.315252011383973],
            [7.221079546242658, -5.313493722192263],
            [7.225602495621699, -5.309278939356758],
            [7.2299061832594855, -5.312758481218893],
            [7.236939666002797, -5.3052401400257345],
            [7.243073800146023, -5.301762345358847],
            [7.244770141469402, -5.298042887007384],
            [7.246614214600322, -5.330237122829404],
            [7.248707950344678, -5.357730145927771],
            [7.254958552919115, -5.357298809546647],
            [7.258097445979745, -5.394198466114326],
            [7.260979539785748, -5.433473015803589],
            [7.30407618207997, -5.4301673300096125],
            [7.361532570765924, -5.424660241094795],
            [7.359031459780798, -5.428696351688894],
            [7.358574326022677, -5.435876100627823],
            [7.360879070385412, -5.440879626487361],
            [7.366300318009067, -5.444519637391312],
            [7.366809311035549, -5.452149964395784],
            [7.363069955931547, -5.456416290855103],
            [7.350322310037923, -5.457721675695331],
            [7.345106483808042, -5.469476574698909],
            [7.3403859286334265, -5.466024958701844],
            [7.332893864464197, -5.466327449687669],
            [7.332776766336977, -5.46898908152422],
            [7.336021822879654, -5.473111945379068],
            [7.33611464763876, -5.479302625915964],
            [7.343668178063082, -5.485357150829131],
            [7.336382645680359, -5.490416698033161],
            [7.337044296213186, -5.495838894925362],
            [7.347469965129568, -5.491388727200401],
            [7.351793425216222, -5.4943494386030425],
            [7.3502953227103305, -5.498184483837768],
            [7.343427223890271, -5.508541735646212],
            [7.336076274638082, -5.509958953376787],
            [7.3317126902570235, -5.508618623734998],
            [7.329888349650846, -5.510420282194849],
            [7.33622876193756, -5.513647472826787],
            [7.332577119000954, -5.517218964019424],
            [7.32908709176812, -5.510477552036069],
            [7.3247897204505, -5.514585128150681],
            [7.3245364288536825, -5.521718706012021],
            [7.320373896941426, -5.519624497947045],
            [7.316269029182995, -5.519927802227291],
            [7.3168881551489955, -5.526771714833346],
            [7.32160913484695, -5.529313433025325],
            [7.325613005976409, -5.535572065872134],
            [7.328775897794192, -5.537189483634513],
            [7.3261943981638415, -5.541313122894928],
            [7.324307823919989, -5.5472995663913505],
            [7.319593582619243, -5.543992495722991],
            [7.315476486284555, -5.545092838983183],
            [7.312452186896252, -5.551923913331728],
            [7.3099436191891325, -5.552637851078628],
            [7.303182927441058, -5.549641039843486],
            [7.298070926199757, -5.553658761215507],
            [7.294566287563879, -5.551305670649336],
            [7.29286260357039, -5.554826640322026],
            [7.294414590674647, -5.559454633805837],
            [7.293276353973193, -5.561897584657645],
            [7.288265027314502, -5.5611232794145895],
            [7.285590116432383, -5.557702413084],
            [7.28335445354877, -5.561267765558655],
            [7.290716721448999, -5.565415590070967],
            [7.290989905114074, -5.569972504547496],
            [7.289253522910265, -5.571782230227677],
            [7.285675819826331, -5.568745608102535],
            [7.281148500497764, -5.569547511832085],
            [7.282310122042269, -5.578629427499915],
            [7.284212148738933, -5.583520688557592],
            [7.282888188299115, -5.58588874461516],
            [7.274633000363855, -5.585842227092487],
            [7.274575397155729, -5.594169967094754],
            [7.277326659001316, -5.597025517916652],
            [7.28500030030922, -5.598315759740076],
            [7.285314264712317, -5.601492825506814],
            [7.2789896545409745, -5.601644665549942],
            [7.275737869503488, -5.604869216073449],
            [7.2766012660288695, -5.6101568261738874],
            [7.28684446345237, -5.61341041353047],
            [7.289677218484166, -5.616719734951899],
            [7.287196827109867, -5.622957512798154],
            [7.292004627370668, -5.627585409040819],
            [7.290368126436679, -5.633840998098795],
            [7.294677506644564, -5.639084237180855],
            [7.290013259826915, -5.644853058180878],
            [7.291199379194795, -5.650446846779008],
            [7.288999498401708, -5.655369617970058],
            [7.28211971650928, -5.6585935692988825],
            [7.27949469223974, -5.662461111567156],
            [7.277000525412355, -5.669463310761991],
            [7.270391416028262, -5.6737509585307455],
            [7.265228809750943, -5.679496745690518],
            [7.254771463920051, -5.679158483036329],
            [7.2514001254563505, -5.69176608421259],
            [7.2600593349644145, -5.695760908993957],
            [7.268186005164879, -5.692268141419459],
            [7.2800132066211525, -5.69094013834164],
            [7.281596254108782, -5.689435032768537],
            [7.279720605643829, -5.683651727411353],
            [7.284011963706448, -5.6807940922714915],
            [7.290183766446719, -5.683965180417073],
            [7.3037566720825104, -5.696386442118537],
            [7.306633527623818, -5.700688450572718],
            [7.307859084331593, -5.705522202013775],
            [7.30609118865582, -5.714832980833],
            [7.304381472496026, -5.715751554384541],
            [7.294924593088748, -5.716060570542268],
            [7.290830410319262, -5.7189285572529105],
            [7.288205852671473, -5.724967465576283],
            [7.287283481635155, -5.733025142105188],
            [7.2884398360957015, -5.737401447631981],
            [7.294467818981152, -5.743010338845436],
            [7.302397234605565, -5.742459172199775],
            [7.305906815635551, -5.736801134383953],
            [7.310072793750656, -5.733592867121701],
            [7.317138631909542, -5.732146963866599],
            [7.3202527033586575, -5.739840368121345],
            [7.318239012683855, -5.745417482440789],
            [7.318221595605552, -5.749320758256851],
            [7.32181398401464, -5.758393983018276],
            [7.3279097487615354, -5.764521813221573],
            [7.328880408963251, -5.768058447573879],
            [7.32734276407588, -5.774246147927387],
            [7.3240576490920395, -5.778031822382434],
            [7.3231992033861, -5.781354225643009],
            [7.325872405405358, -5.788798048084988],
            [7.3294592544014305, -5.7928342224483185],
            [7.333670368545254, -5.794252069467464],
            [7.344849844428413, -5.795919919136746],
            [7.353010185024172, -5.7923188517185515],
            [7.358475729050205, -5.785070812856185],
            [7.3638161310079875, -5.78687855834068],
            [7.366782581254705, -5.792038739375202],
            [7.365519892685438, -5.799011631820244],
            [7.3601069981109815, -5.810857458990018],
            [7.35165260378462, -5.808764289132222],
            [7.342099060635525, -5.804256126702235],
            [7.326837894242394, -5.809935100564691],
            [7.312038305266762, -5.810428948540214],
            [7.309748712329203, -5.814906225655906],
            [7.31407359175058, -5.821333949993909],
            [7.316557572285689, -5.828972159323589],
            [7.3242629057595625, -5.837187334494867],
            [7.32801677010269, -5.839113788778779],
            [7.33736964687635, -5.841296677688499],
            [7.342539709775022, -5.838080913560959],
            [7.349049163353075, -5.835863862313432],
            [7.353211732951281, -5.832584661372576],
            [7.360883254902115, -5.830002967154989],
            [7.365265583261259, -5.830887122143633],
            [7.366320529224105, -5.834921599419637],
            [7.371137889726458, -5.846004770213026],
            [7.376760408082965, -5.852653972360436],
            [7.3768842963161765, -5.855018349542704],
            [7.372013304327545, -5.85608122075214],
            [7.363557395657426, -5.861502171450893],
            [7.360817078080112, -5.865721994052295],
            [7.358453821797301, -5.873992120985641],
            [7.355342473085421, -5.877208289397277],
            [7.352329071242939, -5.877212521590011],
            [7.3504408114310404, -5.87310679946595],
            [7.350862306647865, -5.867681882135702],
            [7.347697163469176, -5.8634643156934345],
            [7.340772941741151, -5.860939610002579],
            [7.335664210976357, -5.8644830060688244],
            [7.338146445634591, -5.8791952183080705],
            [7.3365645749169035, -5.886443862767539],
            [7.334437076582707, -5.886935388862892],
            [7.330680385753618, -5.882730223035427],
            [7.328056148419931, -5.884037530310267],
            [7.326625127277984, -5.888756510420855],
            [7.3284411672387035, -5.89338884817002],
            [7.330599628683371, -5.9036586185437665],
            [7.328215051646, -5.913412267867925],
            [7.319910039798499, -5.92380376242589],
            [7.317114879124474, -5.930568622525776],
            [7.311224142005611, -5.928682714910685],
            [7.310067906626914, -5.9204719937761725],
            [7.310802268598156, -5.916130968360307],
            [7.315379549705006, -5.911104600175938],
            [7.310100629127427, -5.905380860536297],
            [7.305406518097747, -5.904319574986953],
            [7.296894818047862, -5.904678416170734],
            [7.2912446675021805, -5.903687135293202],
            [7.285081263006977, -5.916618657852495],
            [7.285129123995586, -5.91922791019989],
            [7.279959389458802, -5.9196675728995185],
            [7.275745867571532, -5.917799510882804],
            [7.2670490566270125, -5.9085226838330955],
            [7.2660554172313665, -5.902399672025833],
            [7.266689363599677, -5.895308445362066],
            [7.265169890378226, -5.885444702436242],
            [7.263679712388296, -5.881160858083015],
            [7.258909952650898, -5.874474464369861],
            [7.24900859185108, -5.8657754162281],
            [7.242437576399381, -5.862388035568875],
            [7.2416249329339735, -5.85724367235905],
            [7.244383985719351, -5.851772471809132],
            [7.249902711646819, -5.84983387513534],
            [7.25407150109127, -5.843923808546346],
            [7.267392039836736, -5.84373112577492],
            [7.271106684522559, -5.84513324557757],
            [7.270056518585231, -5.853941281896648],
            [7.275711494949859, -5.8621052696992635],
            [7.278475273542404, -5.861549819806261],
            [7.282342639293588, -5.851814106468523],
            [7.286278221111585, -5.850658029566117],
            [7.289242840213737, -5.84489718996128],
            [7.284990139796536, -5.839892548071578],
            [7.278425994350722, -5.837529595282149],
            [7.27478085023459, -5.831877910768892],
            [7.272139825684896, -5.8308341530166725],
            [7.254763373494362, -5.831942842507817],
            [7.247773543044022, -5.836941520908787],
            [7.235119708193585, -5.840662386255927],
            [7.232831960101894, -5.8360013978839],
            [7.228424285079141, -5.831000043478008],
            [7.222513538493606, -5.8266631332253365],
            [7.213708876513077, -5.82469584881624],
            [7.211188710933251, -5.825559966829213],
            [7.204978917870626, -5.83121686545256],
            [7.198648935100054, -5.831449679436209],
            [7.181435169983077, -5.843126404009373],
            [7.1752223981052845, -5.849537751289018],
            [7.156583974892865, -5.857828664733197],
            [7.148630146106075, -5.861872419476833],
            [7.141605284100773, -5.863521221850771],
            [7.128240656751636, -5.865501630290153],
            [7.121341740892989, -5.867941250903798],
            [7.112679796761734, -5.872577323744071],
            [7.10858873341036, -5.871423358329529],
            [7.103821525543081, -5.861522598259312],
            [7.089221259447481, -5.847791376628561],
            [7.086869828593248, -5.8409625126876215],
            [7.087750997487758, -5.82893085754058],
            [7.092379425887857, -5.825091989682307],
            [7.10248641434678, -5.825494897060348],
            [7.107128493608365, -5.819393624927087],
            [7.108078868508641, -5.808586995164595],
            [7.107527097828326, -5.803403218788134],
            [7.1029886209472135, -5.796853554885213],
            [7.102297581555934, -5.7917775835784395],
            [7.106772554931209, -5.7860630126206205],
            [7.113477952129636, -5.780169898201138],
            [7.11543089746044, -5.777341474477938],
            [7.114698684012111, -5.774076412223507],
            [7.1114100689460304, -5.7714495529762],
            [7.104842477350912, -5.7685246007189965],
            [7.100243230014705, -5.774914645709559],
            [7.084610729862954, -5.783590854133043],
            [7.0720590615254215, -5.784836972487121],
            [7.060066663132614, -5.780384070116818],
            [7.055166100184584, -5.777161488305515],
            [7.051663151212589, -5.7729071444785705],
            [7.051809321480162, -5.769201434822275],
            [7.056767230706551, -5.767535822635261],
            [7.0621842393316845, -5.767536088323087],
            [7.067585287178293, -5.765310830340377],
            [7.076552687465123, -5.759101296799],
            [7.076807432356404, -5.754093704463015],
            [7.078832161826572, -5.74735613400448],
            [7.071190035276295, -5.737218990285398],
            [7.0606537103665845, -5.730081939392183],
            [7.055279334256176, -5.719608341773554],
            [7.054837309403642, -5.711927906623002],
            [7.0520245940732735, -5.704535024493726],
            [7.051169095533236, -5.698998886135062],
            [7.056006288784679, -5.690123240084315],
            [7.0602551716914705, -5.689085937356624],
            [7.068941523530718, -5.690783051982446],
            [7.0762389619693735, -5.6949513135147924],
            [7.078986629019432, -5.693153815871156],
            [7.082377671921074, -5.685470281575858],
            [7.085553615691497, -5.682578017703749],
            [7.087005779016817, -5.674726847756916],
            [7.078668487347904, -5.662989733183899],
            [7.0765724909305385, -5.662370412305226],
            [7.071603794541227, -5.664722370637923],
            [7.058203543193407, -5.673408310185624],
            [7.052400238637154, -5.671349739514008],
            [7.047142885660426, -5.6630211480963615],
            [7.040987027110312, -5.6586652950710805],
            [7.0365856697332765, -5.6534285552186265],
            [7.0339437193208365, -5.647262530881323],
            [7.026821822668546, -5.638865280700028],
            [7.022784550892108, -5.637844238757183],
            [7.017089594694229, -5.641602144949051],
            [7.015338931506854, -5.647836487205939],
            [7.011457214200722, -5.649171939723121],
            [7.007119372998648, -5.648166834240465],
            [7.003284463885135, -5.6437506600846845],
            [6.995590102213413, -5.646990187336806],
            [6.989176332802616, -5.646302336553066],
            [6.985844604189563, -5.641006229306314],
            [6.988623750706005, -5.6367034225119035],
            [6.9977974389492195, -5.636467245643518],
            [7.004228354028038, -5.627727288981243],
            [7.006610252024877, -5.6204170676670655],
            [7.005486861987617, -5.614370804919445],
            [7.003513168127216, -5.612667507879501],
            [6.996098557217396, -5.612496735373825],
            [6.990085009181346, -5.605804137236755],
            [6.984258212361719, -5.603364817929674],
            [6.981103785935486, -5.596841663414685],
            [6.97980121569186, -5.5821562847745865],
            [6.9728895500411125, -5.565054361921889],
            [6.963787088524032, -5.56174245435346],
            [6.959774187786266, -5.5587960670346375],
            [6.95739316193088, -5.554280075766335],
            [6.957825616990184, -5.551316520526308],
            [6.9623411763943865, -5.547334467258244],
            [6.963177960009986, -5.541458651460014],
            [6.965388153604966, -5.540627475660499],
            [6.971775809162555, -5.54348355221441],
            [6.979571111523142, -5.5438057812043615],
            [6.983116769696919, -5.542748916595071],
            [6.985901712319813, -5.535367001994169],
            [6.984741675948188, -5.53176308307208],
            [6.9761462092591335, -5.529657975190906],
            [6.971601392844183, -5.523641220425373],
            [6.969783088142298, -5.516694135106089],
            [6.974947881957736, -5.5133308650755435],
            [6.979749968927071, -5.518223994981569],
            [6.986018191475229, -5.5201160106764355],
            [6.9896321169979965, -5.519875174750706],
            [6.995078418531432, -5.512805033727045],
            [6.995368848824717, -5.509090638842998],
            [6.986574082506941, -5.503815070212396],
            [6.985185074348944, -5.501179437135607],
            [6.984612429372071, -5.493389994731738],
            [6.981199869296995, -5.488156555927906],
            [6.980728153467694, -5.478857865554115]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.9522714168748, "lat": 32.85306165498415 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01063"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00161557"
      },
      "bbox": [
        6.95739316193088, -5.930568622525776, 7.3768842963161765,
        -5.298042887007384
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.420141595210819, -6.625426246624574],
            [9.416894666377944, -6.593012532203536],
            [9.415706319883038, -6.585501428759477],
            [9.413697607807796, -6.5637316148236176],
            [9.410746429922611, -6.538936252309221],
            [9.463271620003411, -6.533615799088418],
            [9.469430074351116, -6.533461504577949],
            [9.479768114505848, -6.531968329042564],
            [9.499308602896775, -6.530640684421857],
            [9.550882802155483, -6.526055046114887],
            [9.579546151945507, -6.524277275129486],
            [9.58415247925288, -6.515656000625221],
            [9.581843152091107, -6.509475878482892],
            [9.581292550136363, -6.500910899433703],
            [9.583283986703538, -6.485037791523026],
            [9.584845921349482, -6.482928238816202],
            [9.589628461453492, -6.482201182796584],
            [9.594976490426232, -6.477245161751791],
            [9.604609811828391, -6.470457853672662],
            [9.607843705146227, -6.469378167831688],
            [9.612285368304068, -6.461717890729123],
            [9.618453373508345, -6.456913531369953],
            [9.617665309605988, -6.453424889299521],
            [9.61950873444121, -6.449772311551152],
            [9.628346045911012, -6.447359356232094],
            [9.640296567367843, -6.451225850145348],
            [9.647684587396748, -6.456342798270544],
            [9.646190207408202, -6.460197558771037],
            [9.65192125919462, -6.470693081657049],
            [9.657836391033511, -6.484985100166565],
            [9.656195719364748, -6.49511705518342],
            [9.653265709710777, -6.501478420848916],
            [9.653907413176082, -6.509238751802612],
            [9.656606621314289, -6.522992130590153],
            [9.659724317194465, -6.52635227622656],
            [9.667299634378459, -6.529905972642253],
            [9.67216681716903, -6.538790394043919],
            [9.688491135061923, -6.554496819781917],
            [9.699558160293158, -6.557927794389862],
            [9.701161865625354, -6.5613613473153745],
            [9.698152524358049, -6.563030981267728],
            [9.696426320489191, -6.569520462381988],
            [9.6975745899728, -6.574485348896147],
            [9.701591205104801, -6.576193077978113],
            [9.707653908642188, -6.582828573931993],
            [9.713372600139316, -6.586490463349858],
            [9.720599932565992, -6.589225545265439],
            [9.722692858856032, -6.592091089524659],
            [9.721298465549081, -6.602694540208397],
            [9.725505218700507, -6.6052699269178206],
            [9.725073202341363, -6.6172032257749605],
            [9.72590766592549, -6.626799668132795],
            [9.729328669584774, -6.633031344936328],
            [9.727794363167602, -6.639484723695298],
            [9.732950700736328, -6.646874067751094],
            [9.73556209072228, -6.653942088482505],
            [9.743660413693995, -6.662646829962586],
            [9.745281236228177, -6.667445881627422],
            [9.744534703847766, -6.6733413413737015],
            [9.74173578748193, -6.680217497899116],
            [9.741921730176566, -6.685135070676572],
            [9.744858614145182, -6.687651310219742],
            [9.744502459545762, -6.691485457765414],
            [9.742412446961472, -6.695184139331264],
            [9.73561483406636, -6.713726697951303],
            [9.733849244000021, -6.721930941193914],
            [9.73127570412409, -6.726135649567162],
            [9.728081153388596, -6.742297310957207],
            [9.731784956222207, -6.756837721470815],
            [9.73466298228488, -6.762715395289142],
            [9.736525260454286, -6.770271887622765],
            [9.737286378352026, -6.7791727128313415],
            [9.734919380208401, -6.782421521768053],
            [9.731798511302687, -6.7821181900317695],
            [9.729810344486259, -6.785875226972534],
            [9.729789437753281, -6.794697580008427],
            [9.727692676022254, -6.8004554604624525],
            [9.730759081387587, -6.807757605385399],
            [9.73101346545776, -6.8117056540071745],
            [9.729237026211118, -6.816873618102442],
            [9.728604345577281, -6.82636891945482],
            [9.725977692373673, -6.836768363038525],
            [9.722673250177543, -6.847076264466299],
            [9.723107542789304, -6.854150978362618],
            [9.727857787319197, -6.856662774502074],
            [9.729654402498635, -6.860708319083442],
            [9.729776261899096, -6.870598010653271],
            [9.728845876301792, -6.876748031546925],
            [9.73361777820804, -6.8821988709607975],
            [9.735097740141914, -6.892162906987077],
            [9.732917199491638, -6.901974018228901],
            [9.689113016786349, -6.9076318195045046],
            [9.6556638855269, -6.911785823818749],
            [9.612987371343065, -6.914914147325118],
            [9.569708345932082, -6.918377398642044],
            [9.539825478197992, -6.920084560576735],
            [9.489264959919517, -6.9235853891093315],
            [9.453267251285776, -6.927187882131571],
            [9.45090896714775, -6.907024427762242],
            [9.451061235608048, -6.905061467929378],
            [9.447477205380173, -6.869119155415268],
            [9.445728780491265, -6.85468871960161],
            [9.442973356205416, -6.83629158713702],
            [9.438729297766237, -6.802656639837086],
            [9.434381819747808, -6.743555830277183],
            [9.427028146681662, -6.683450928165721],
            [9.420141595210819, -6.625426246624574]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.24138750546115, "lat": 31.51474833241569 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01067"],
        "coty_name": ["Henry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Henry County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00161559"
      },
      "bbox": [
        9.410746429922611, -6.927187882131571, 9.745281236228177,
        -6.447359356232094
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.855257254799804, -4.735381387636008],
            [6.856189429845277, -4.698340630563504],
            [6.855957749670964, -4.68425021835443],
            [6.857151928151749, -4.668842231111383],
            [6.857916178003979, -4.632186568797967],
            [6.859994597426343, -4.567182978492048],
            [6.863242942819726, -4.4483523561897345],
            [6.863717624873123, -4.41894679955899],
            [6.982400747930732, -4.4129681137523455],
            [7.016023628986991, -4.410946155675524],
            [7.030061686578386, -4.410883306765083],
            [7.044748573095411, -4.410185570566166],
            [7.0468162977192454, -4.439449420681409],
            [7.075973838361509, -4.437694125387384],
            [7.07728934755329, -4.454115685123108],
            [7.084807013628707, -4.540042635890051],
            [7.089980350054037, -4.601106947293674],
            [7.099814667004079, -4.692397625237206],
            [7.10329436401499, -4.725411900640921],
            [7.104143526539204, -4.7307097104054145],
            [7.111652923692158, -4.801895667946247],
            [7.112768234280895, -4.818415463322034],
            [7.122874927018694, -4.935620995314469],
            [7.077465298869124, -4.937082420673227],
            [7.036751939056514, -4.939452510314038],
            [7.0108806829892485, -4.94012714504401],
            [6.874827356652329, -4.947169234166837],
            [6.871698014081738, -4.94691674832923],
            [6.85137829409133, -4.948115531989753],
            [6.852136169492191, -4.910998538524307],
            [6.852393547494841, -4.908888739578774],
            [6.8543219235299375, -4.798824702834076],
            [6.854609678634387, -4.761021399884054],
            [6.855257254799804, -4.735381387636008]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.09695685636565, "lat": 33.77913353236229 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01075"],
        "coty_name": ["Lamar"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lamar County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "00161563"
      },
      "bbox": [
        6.85137829409133, -4.948115531989753, 7.122874927018694,
        -4.410185570566166
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.907523985350712, -5.144960085222561],
            [7.943924576951496, -5.141973854041603],
            [7.943376545387952, -5.134988924098371],
            [7.946694078574521, -5.131423318280578],
            [7.950099511358374, -5.1307256554509255],
            [7.949882587099417, -5.127200985838262],
            [7.953529619630696, -5.126806555404784],
            [7.952884218458481, -5.11950321387007],
            [7.970914268166626, -5.118151310047916],
            [7.970201790052049, -5.110836042622713],
            [7.981053879647198, -5.10959016183841],
            [7.980781594430506, -5.10608663419971],
            [7.987748863789463, -5.105422396813256],
            [7.986012542910412, -5.087084714800007],
            [7.9894639328742265, -5.086755429363274],
            [7.989177719489652, -5.08298201976618],
            [7.992462716626261, -5.082710771542115],
            [7.992640782853373, -5.079135764574206],
            [7.99986589902635, -5.0782803700596695],
            [8.001168135883924, -5.0743802179343485],
            [8.006472564269618, -5.073813529097055],
            [8.006028230872916, -5.066497913671869],
            [8.009217239621943, -5.062540831946335],
            [8.012617944149184, -5.062249521175209],
            [8.01199512540542, -5.055122007692988],
            [8.019212975921823, -5.054575583873649],
            [8.018530918649406, -5.047273252497465],
            [8.061452924195441, -5.044100445576381],
            [8.058901489237192, -5.01537520932593],
            [8.07293911276753, -5.014264460655634],
            [8.073205396356581, -5.0111260984616965],
            [8.079968846625272, -5.0107153359729795],
            [8.079686265166638, -5.00658298321463],
            [8.101041587771546, -5.005144154333455],
            [8.099095773872692, -4.983453831232786],
            [8.113494340316342, -4.982326470200807],
            [8.112620510741202, -4.975467637305728],
            [8.11615293873714, -4.974368539510255],
            [8.119588780116938, -4.9709747782375135],
            [8.117947408944863, -4.953966646328308],
            [8.118533448091728, -4.952730439047856],
            [8.146356750864527, -4.950918662502252],
            [8.145044185838211, -4.936461943402478],
            [8.159404233317076, -4.935207087034889],
            [8.158137203593085, -4.924764228694459],
            [8.161687004132936, -4.924416997962368],
            [8.161362378257303, -4.920853169245241],
            [8.16483902991847, -4.920576439370449],
            [8.164182067203702, -4.913238744973859],
            [8.178691445008583, -4.912042917680196],
            [8.177259638914075, -4.897280810139562],
            [8.234739397023342, -4.891011243317946],
            [8.234072386879442, -4.8839673330780045],
            [8.24132932313855, -4.883102686230832],
            [8.240579489681636, -4.87596095284774],
            [8.247794260103223, -4.875156255408141],
            [8.246378490106395, -4.8606754996180435],
            [8.253915668235505, -4.8598794986032],
            [8.256752146322816, -4.856147905585795],
            [8.256293052963665, -4.852450538672465],
            [8.259988199145011, -4.851987298846455],
            [8.259370767386438, -4.844741100164634],
            [8.266591610077727, -4.843991222538026],
            [8.265983762236152, -4.837113986278824],
            [8.280242064885533, -4.83592286371985],
            [8.279688633019235, -4.828621566697185],
            [8.30109395320449, -4.826940085674046],
            [8.299241415296613, -4.80505532199743],
            [8.328250934385965, -4.802102514850798],
            [8.332312161125138, -4.845594517419454],
            [8.365720978164422, -4.842487466065294],
            [8.417776914987831, -4.837124822940617],
            [8.426350856056642, -4.921034542540077],
            [8.428750431556878, -4.9483783749403845],
            [8.429286943215816, -4.952144306283651],
            [8.433804238221517, -4.955904474925473],
            [8.445617742814203, -4.960523960351149],
            [8.451924084392683, -4.964628002115758],
            [8.463027046651263, -4.980688671859156],
            [8.463648295058082, -4.9842973755819715],
            [8.460936773772966, -4.98793807404247],
            [8.456680422225707, -4.989720119372535],
            [8.446811519169609, -4.99096913321809],
            [8.443378459559867, -4.9940299436353435],
            [8.443182337623915, -5.001986722452103],
            [8.447104817492733, -5.010338543405484],
            [8.445241365397093, -5.017776414425565],
            [8.4465648442851, -5.022494097659575],
            [8.450438741613564, -5.027117547382715],
            [8.455560886185262, -5.038855826710809],
            [8.455863784990955, -5.04183602540295],
            [8.453442090852835, -5.0452527158881875],
            [8.439145807224019, -5.053078007765197],
            [8.42838101439577, -5.064901771374182],
            [8.419436887276271, -5.06850597743792],
            [8.41463422659626, -5.068798957095805],
            [8.404746397640036, -5.065729748003471],
            [8.398538872036173, -5.060547399373782],
            [8.39444901675541, -5.061072841014666],
            [8.394698182654269, -5.068214690514161],
            [8.401306467497504, -5.076382445771286],
            [8.404248292124276, -5.082320689596686],
            [8.40190336063095, -5.093087301772485],
            [8.396905525797735, -5.101772229890998],
            [8.391538738550798, -5.103100866933223],
            [8.382371346848602, -5.10134211655354],
            [8.378363249428794, -5.104199215508954],
            [8.373992662216853, -5.115172150707511],
            [8.373078564189145, -5.1218046255869085],
            [8.375260613778755, -5.129469777198776],
            [8.378420831265954, -5.13519771380666],
            [8.379806422006693, -5.142853707909128],
            [8.377292292413646, -5.1489599751254875],
            [8.371352121269418, -5.150245485275242],
            [8.363500758017178, -5.145839604143749],
            [8.359098951255259, -5.145998928746012],
            [8.35363361180599, -5.151405920543317],
            [8.347333718468825, -5.170068938512501],
            [8.348182739724697, -5.175132407187329],
            [8.35797345060877, -5.178266735236037],
            [8.361335907421, -5.180944892905297],
            [8.36557310900709, -5.18801658617862],
            [8.367103766739762, -5.19918707405994],
            [8.371741442074285, -5.205202645333671],
            [8.381695817675768, -5.209758404718399],
            [8.38637104709647, -5.214656148372196],
            [8.388524935303568, -5.220375693746086],
            [8.387687986777737, -5.223594593211443],
            [8.384043967302187, -5.227010231558809],
            [8.372654236214215, -5.2318368414302325],
            [8.369671852256845, -5.234283879530994],
            [8.366721023010891, -5.239318404478752],
            [8.365003596853404, -5.24506647409208],
            [8.363346732744759, -5.249044610906569],
            [8.351287858348893, -5.2585685819744],
            [8.349260403539814, -5.263830068387035],
            [8.351272304383789, -5.271728242750891],
            [8.354893340632355, -5.277444274021119],
            [8.356116184407952, -5.281404278243734],
            [8.354838669630269, -5.284900684742942],
            [8.345566000615856, -5.293294153251578],
            [8.345275480652749, -5.295725049677904],
            [8.34767893455613, -5.303948125824309],
            [8.350042028111947, -5.307719740879414],
            [8.35146834523262, -5.329383946897351],
            [8.34654224134963, -5.327308945123544],
            [8.3349025591196, -5.32713931207433],
            [8.324165369402646, -5.333859670025322],
            [8.313502564204928, -5.334191965463003],
            [8.309213382878148, -5.326685506219293],
            [8.297720136117327, -5.320592133722871],
            [8.293059291865324, -5.314875656150316],
            [8.285994708859539, -5.312729693084164],
            [8.281821285779115, -5.310437448899351],
            [8.278654178758986, -5.303525189432433],
            [8.276168134421209, -5.30209307633103],
            [8.267336061804915, -5.304554856365206],
            [8.263832822639582, -5.299607610155968],
            [8.26625560204377, -5.29383817147855],
            [8.270848886660184, -5.29118256034812],
            [8.269622937320756, -5.287718511884869],
            [8.2119395567583, -5.293909965661999],
            [8.153436277684412, -5.299836452701504],
            [8.11545581581934, -5.303840502035322],
            [8.091851387755737, -5.306543927174215],
            [8.091698556227369, -5.305170302707306],
            [8.059525837087676, -5.306372167587478],
            [8.044450426648003, -5.307746689003491],
            [8.046945522452646, -5.32961469078322],
            [8.03258097600253, -5.3310814318713495],
            [8.031819602190803, -5.323857000208374],
            [8.017203562780493, -5.3251659325865734],
            [8.016753955160416, -5.321286930282597],
            [8.013311793665148, -5.318317604667755],
            [8.001821914336746, -5.3196737727941334],
            [8.000392633540539, -5.304973644418642],
            [7.985755698851699, -5.30642308822041],
            [7.98450600308018, -5.286564942632813],
            [7.969265301416267, -5.2882020014286715],
            [7.963335733703225, -5.228620626693651],
            [7.959257585292379, -5.22890787206215],
            [7.959015543904757, -5.225433915522068],
            [7.9345629831369555, -5.227446445983531],
            [7.93422912587872, -5.223664008117529],
            [7.916213336565755, -5.225366197442679],
            [7.913747665558925, -5.199781263514649],
            [7.917336237837656, -5.19943164669933],
            [7.915526735692893, -5.1811409378164575],
            [7.9119427294617894, -5.181538465949718],
            [7.909653100682398, -5.159716105895913],
            [7.907523985350712, -5.144960085222561]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -86.66067162680295, "lat": 33.26427942612558 },
        "year": "2023",
        "ste_code": ["01"],
        "ste_name": ["Alabama"],
        "coty_code": ["01117"],
        "coty_name": ["Shelby"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Shelby County"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00161584"
      },
      "bbox": [
        7.907523985350712, -5.334191965463003, 8.463648295058082,
        -4.802102514850798
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.900674069979148, -3.1610781459588297],
            [4.9854663129912105, -3.157702716344898],
            [5.031029381792799, -3.1560436665026597],
            [5.074558310311618, -3.154064007767712],
            [5.193050105311221, -3.1486406786781815],
            [5.170735120254985, -3.164938515675903],
            [5.169567299286747, -3.168568734471542],
            [5.169998328371839, -3.176905835853632],
            [5.16462779140876, -3.2023347840508847],
            [5.165564659418008, -3.2054078864634867],
            [5.170852514903217, -3.2097251047176236],
            [5.176600403308095, -3.212915756040929],
            [5.184030178924826, -3.2118024520344433],
            [5.191717539934712, -3.2119774324011128],
            [5.200450511966576, -3.2087376523275],
            [5.193346097601285, -3.1981409813993986],
            [5.1904186364279985, -3.186345901661368],
            [5.192330580995959, -3.1786286120482594],
            [5.199159116710158, -3.1718967735950656],
            [5.203111718869364, -3.171068433305277],
            [5.214754031542673, -3.172796093207268],
            [5.2176620635855, -3.1744488589164366],
            [5.225770516586712, -3.1839399630377305],
            [5.233222248329701, -3.189890155454956],
            [5.241091979388252, -3.1940736760327786],
            [5.243878416469126, -3.196717297247745],
            [5.246098549732954, -3.201921748893601],
            [5.246738159599175, -3.2076224504275745],
            [5.242808880886856, -3.217284134455101],
            [5.235846520187151, -3.229333927432289],
            [5.233916760835127, -3.234737854376367],
            [5.2293213317467, -3.2598410496536574],
            [5.226237436016731, -3.2724352255109297],
            [5.225534372772084, -3.2795222567668207],
            [5.219821509093775, -3.281514700257578],
            [5.214468193103517, -3.280669161233282],
            [5.209718436192346, -3.2843570790992382],
            [5.202067676051611, -3.2871882282572136],
            [5.194552175715823, -3.2835533389182556],
            [5.187512122861303, -3.285395923033083],
            [5.184520336870508, -3.2881436855567014],
            [5.181672028249333, -3.2941335940954835],
            [5.1793947882551965, -3.3055651846170324],
            [5.18169233468895, -3.3128999220747706],
            [5.188699348576936, -3.3242768873509876],
            [5.194558566566675, -3.3308756222742724],
            [5.204787835288581, -3.333966912065266],
            [5.22264512553767, -3.329337819053689],
            [5.232589783395723, -3.330113320597124],
            [5.241673716818943, -3.3352272548261843],
            [5.248790909315324, -3.345487256202738],
            [5.250702075585718, -3.3525805429749758],
            [5.258076801608323, -3.3617651063063523],
            [5.259104639420192, -3.3691975901748332],
            [5.255238269787353, -3.37499865580138],
            [5.248628345520016, -3.371594080161885],
            [5.24537482253682, -3.3809129077013873],
            [5.243331133302493, -3.3895489326323567],
            [5.233157468827383, -3.3857256348834173],
            [5.227254308359868, -3.386770128917239],
            [5.226716882068638, -3.3954101441850755],
            [5.23015793392875, -3.4020231980659146],
            [5.234723118345286, -3.403477728438342],
            [5.236266121526672, -3.4089681620571817],
            [5.240807009459782, -3.413675380239237],
            [5.259780133597883, -3.424277506419882],
            [5.2682475505382325, -3.427191973667393],
            [5.271201220062128, -3.4316644952417446],
            [5.272735276112156, -3.4383773508836364],
            [5.271172835894298, -3.4463335555097196],
            [5.266412987271671, -3.4543134144910006],
            [5.259138397995525, -3.4627378345783337],
            [5.253642519657908, -3.466381300949876],
            [5.249351225469259, -3.4671704272555575],
            [5.23965751381092, -3.4658450455993033],
            [5.221077311032408, -3.4578943793255785],
            [5.210510934427265, -3.4539309789645856],
            [5.203363788227599, -3.454939862471702],
            [5.200209252869586, -3.4567004002749373],
            [5.190416893029014, -3.4647046792258496],
            [5.186679804433768, -3.469645457172735],
            [5.183450086056181, -3.4767286335934644],
            [5.180897696807684, -3.49511649504401],
            [5.181767710016467, -3.504161183634135],
            [5.187167475270384, -3.5128366220647576],
            [5.185804353557856, -3.5252472585564694],
            [5.183546194066888, -3.5353694072146524],
            [5.179704977468133, -3.544197247059446],
            [5.17624227514991, -3.5496633318566824],
            [5.164085706532367, -3.5649677541886766],
            [5.159306246260683, -3.5655320010651286],
            [5.1434605855225, -3.560707775814591],
            [5.134760873089856, -3.559784646983592],
            [5.127680133143332, -3.5612899706228895],
            [5.123907061584616, -3.5583664171811282],
            [5.119371528849919, -3.557136543877159],
            [5.116590517840582, -3.5530464695369712],
            [5.094227878609702, -3.5534759922361636],
            [5.090676677103929, -3.556896935251568],
            [5.089127411009082, -3.56493942568079],
            [5.084720589290648, -3.576507885453509],
            [5.085425572802295, -3.5819978197231643],
            [5.082444262511433, -3.5862138870195577],
            [5.0818900148426955, -3.593200885754378],
            [5.084008686486994, -3.6001347696913455],
            [5.085067168203861, -3.603869937555396],
            [5.090543996559918, -3.6135882156831007],
            [5.09514745774498, -3.6188511154665925],
            [5.116782988365072, -3.635412394437943],
            [5.137488602624768, -3.6442820493381003],
            [5.139466180385362, -3.6476420961626626],
            [5.141715543274487, -3.6613660501744163],
            [5.143034164312738, -3.6738805868874116],
            [5.142119652714725, -3.683950907648612],
            [5.137907823556775, -3.6932363892205533],
            [5.1311854202850125, -3.700455966997771],
            [5.116247822577703, -3.7095789024351493],
            [5.1059379089043215, -3.7121220491085705],
            [5.094278531637375, -3.71840211281803],
            [5.083913728363234, -3.7258035852674714],
            [5.086654841661207, -3.73280039433307],
            [5.095085708369334, -3.7358649937359303],
            [5.097162348477207, -3.741838406745451],
            [5.093825635125262, -3.7502751647294015],
            [5.090753569961798, -3.75244683242496],
            [5.084308962106933, -3.752195844457329],
            [5.076412300779983, -3.747748670867475],
            [5.067849168096867, -3.7394038597318198],
            [5.0494515678811425, -3.756375186691486],
            [5.028125675875347, -3.7698327171583568],
            [5.019880926752839, -3.773307124008814],
            [5.0132755537029645, -3.774571868152046],
            [5.011237734077033, -3.7409084206840406],
            [5.008218393176945, -3.6970583008988],
            [5.0030457341121926, -3.5980813338988793],
            [5.007129981142203, -3.5978340501497423],
            [5.005045927904597, -3.550581771521286],
            [5.004624361690616, -3.546198807795904],
            [5.000292081658741, -3.451272818507306],
            [4.978750647542915, -3.4537030007799485],
            [4.946768131865285, -3.457757912839065],
            [4.928732172358541, -3.4597137606821677],
            [4.917502856424007, -3.460152800823954],
            [4.916145387390233, -3.4253322398456723],
            [4.912661957744533, -3.4256021078172076],
            [4.9093354287196185, -3.3454132784203243],
            [4.9051949642006525, -3.249289233360123],
            [4.900674069979148, -3.1610781459588297]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.30783977433137, "lat": 35.20569228200352 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05035"],
        "coty_name": ["Crittenden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Crittenden County"],
        "coty_fp_code": "035",
        "coty_gnis_code": "00069162"
      },
      "bbox": [
        4.900674069979148, -3.774571868152046, 5.272735276112156,
        -3.1486406786781815
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.018489115510275, -3.270134979243458],
            [2.0236375125630204, -3.268055001464703],
            [2.0356578846168616, -3.2600866994796944],
            [2.0433544667050967, -3.251581724712532],
            [2.0462687251588525, -3.2498684314282875],
            [2.037004714518859, -3.2424690636321936],
            [2.032308978903682, -3.242778675893105],
            [2.0338982030312063, -3.2372823981334817],
            [2.041902010163529, -3.233098316580544],
            [2.0441588858092556, -3.2331647606743523],
            [2.04591378858296, -3.2285110567203894],
            [2.040982813526529, -3.2263716792031056],
            [2.038200161545618, -3.2211391069491824],
            [2.045270021829151, -3.2148154490872956],
            [2.050502284916588, -3.2126732229920356],
            [2.0538923619630984, -3.2060900800581122],
            [2.0508886326172986, -3.194020740293743],
            [2.0474816791041643, -3.1887769509409147],
            [2.0463696417369084, -3.184160801194464],
            [2.043600117660044, -3.182756795520706],
            [2.044425374137781, -3.169322108194834],
            [2.048385532883547, -3.167091121256235],
            [2.047590304103786, -3.1615613895556947],
            [2.0573435539721623, -3.1568007712692565],
            [2.0574015842729096, -3.1391499202924433],
            [2.014508351398105, -3.138621245585309],
            [2.0143377481135234, -3.1264697925921947],
            [2.0144296230406114, -3.0510864666248594],
            [2.0866951684818296, -3.0514079671101855],
            [2.0868854975372577, -3.0076968780536215],
            [2.101229840156606, -3.008107098414936],
            [2.101252882557221, -2.979163362511777],
            [2.143556734923932, -2.9794804057954685],
            [2.143620916625547, -2.9648489760918415],
            [2.1583624746224728, -2.9647799901332084],
            [2.158531752346334, -2.9503061053610606],
            [2.1435838391032287, -2.9503010888628167],
            [2.1434629611461, -2.935640807485896],
            [2.232218800929877, -2.936000255954902],
            [2.316194590434821, -2.9373767624039195],
            [2.3164611473261005, -2.9520329256163476],
            [2.315893716663671, -2.9958934139599918],
            [2.3156935667575858, -3.0545171659648793],
            [2.315477142585937, -3.1416039744567894],
            [2.314998980761373, -3.207798191359242],
            [2.3147235576407774, -3.2296927917773517],
            [2.314353335369694, -3.3338633043220405],
            [2.311077266284112, -3.3352638070836687],
            [2.307689135984871, -3.339943012725946],
            [2.298866147672409, -3.339619041867731],
            [2.2944777191918435, -3.3405396123500197],
            [2.28532927247763, -3.3450272070551788],
            [2.2821354143220622, -3.3451954422202297],
            [2.2782395775606163, -3.3428635908244493],
            [2.275188504556888, -3.3349728485896475],
            [2.272753094754384, -3.331668370503376],
            [2.25873850395514, -3.322450225622992],
            [2.252141593424067, -3.316720415067683],
            [2.245574558317106, -3.3088958049689046],
            [2.241678603243884, -3.30298147399055],
            [2.237399570313182, -3.2938618590633526],
            [2.2349161290100965, -3.286431420566841],
            [2.234837721136712, -3.3547487409194403],
            [2.2349647243204656, -3.3983958930523714],
            [2.2203195597801093, -3.3980877444678774],
            [2.179996373278528, -3.3961878130026033],
            [2.148270124917448, -3.3942826587115666],
            [2.1480973930768505, -3.4554433602460706],
            [2.147794700349988, -3.4843983766319457],
            [2.104533699515096, -3.4846696458758255],
            [2.060338172342013, -3.4845613631823804],
            [2.0601031720608893, -3.5017822621179935],
            [2.045778087507038, -3.5021731801696094],
            [2.0457109381618293, -3.5168925320012527],
            [2.0313207904984005, -3.516772477166056],
            [2.031396267135441, -3.50200870769783],
            [2.0168916852796923, -3.50205450182974],
            [2.017457064568994, -3.3949345575819456],
            [2.0168376279113405, -3.384916778942336],
            [2.017139607177014, -3.3028910163602565],
            [2.0182620319365063, -3.3027776649490757],
            [2.018489115510275, -3.270134979243458]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.89058744676316, "lat": 35.51235715045268 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05047"],
        "coty_name": ["Franklin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Franklin County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "00066853"
      },
      "bbox": [
        2.0143377481135234, -3.5168925320012527, 2.3164611473261005,
        -2.935640807485896
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.789339540152792, -4.604213885235985],
            [3.7880989512788745, -4.574838383109303],
            [3.7973470145227672, -4.574375759026975],
            [3.8734791754426525, -4.571397428713922],
            [3.9158764527549113, -4.567985830325152],
            [3.9593136607367003, -4.566793177252528],
            [3.960921370006879, -4.595919483775345],
            [3.975711737622909, -4.595122854530841],
            [3.9719225189040994, -4.507853229293333],
            [3.9710304614744594, -4.5078861974623825],
            [3.9701743577529442, -4.484596236170058],
            [3.978910657621427, -4.483285748892109],
            [3.9915824372400053, -4.484478003888073],
            [3.99674712639924, -4.487416782836029],
            [4.027907824229056, -4.508965487308155],
            [4.032855319206069, -4.5163094444210525],
            [4.036262105334535, -4.518843019903356],
            [4.043474605760902, -4.521665981523798],
            [4.047535789785363, -4.52223929344217],
            [4.05618086146504, -4.526987615129395],
            [4.065045159046822, -4.527780800333914],
            [4.0782448497039745, -4.52228864120261],
            [4.084833215372198, -4.521516319987236],
            [4.090788575036698, -4.526565387642191],
            [4.09142518002915, -4.529493483917047],
            [4.085561116010901, -4.534671662190233],
            [4.076418954002128, -4.53670330779771],
            [4.072792879485953, -4.541151531274708],
            [4.0726301693871525, -4.545230712244755],
            [4.069877193470801, -4.554383730757118],
            [4.069603321907524, -4.5593175825338745],
            [4.073387278054588, -4.566667707502542],
            [4.080452054869416, -4.569725259834132],
            [4.087251687540805, -4.5687562032391495],
            [4.0918888918180825, -4.5660044108615185],
            [4.096630028221377, -4.561239372800406],
            [4.102902177344568, -4.552953626456433],
            [4.107791810045316, -4.549300029536249],
            [4.115521083973476, -4.547848652396266],
            [4.122409069851142, -4.54867936427295],
            [4.1329978390936875, -4.552866758325652],
            [4.136879927252183, -4.556384284540308],
            [4.150179178850966, -4.574009434741987],
            [4.1550985918109085, -4.577549500718131],
            [4.160965150890275, -4.57880917263012],
            [4.169372124351737, -4.576761575785075],
            [4.169822033937981, -4.58812417223133],
            [4.1733901140243495, -4.591664644117826],
            [4.177119377026909, -4.592383818212706],
            [4.189239863233464, -4.588790469553105],
            [4.192930243966569, -4.585228085189446],
            [4.194299685220075, -4.5778453061550515],
            [4.189717918656411, -4.570143485220436],
            [4.1919071892120074, -4.564657249430435],
            [4.199181200631843, -4.564195819947016],
            [4.206256585188791, -4.56889297126535],
            [4.212368196323012, -4.575123908994956],
            [4.214377448264591, -4.578750385463344],
            [4.216704728462128, -4.587891198916165],
            [4.217269996526632, -4.601725621407062],
            [4.214161196341632, -4.615439942166526],
            [4.213953652079101, -4.61919835139982],
            [4.216349297801037, -4.626069700024636],
            [4.2193412426038615, -4.63021967709875],
            [4.228553724804693, -4.637067117261616],
            [4.228958852025794, -4.6502982482596575],
            [4.210046890633614, -4.650627449130263],
            [4.209876650806847, -4.645172183027993],
            [4.193351368301292, -4.645769369576399],
            [4.194349134929859, -4.674852487295049],
            [4.126107083903429, -4.677008417416203],
            [4.126656437265823, -4.742891997361891],
            [4.126828024866401, -4.783409231707405],
            [4.125366801739473, -4.783479395998826],
            [4.127815455597032, -4.871396046087994],
            [4.070253740708033, -4.868055234426354],
            [4.03969867698322, -4.866488025335633],
            [3.980638677768462, -4.869388391946814],
            [3.9531811892837236, -4.87052949795602],
            [3.8675304290899897, -4.8747434228921644],
            [3.7827315626986366, -4.8782773307587775],
            [3.7801515663908805, -4.819556456506826],
            [3.7797983518121243, -4.805407341503751],
            [3.778788220562048, -4.790398188419421],
            [3.7743459404238453, -4.692192062115716],
            [3.793605482747267, -4.691459025314245],
            [3.789339540152792, -4.604213885235985]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -91.73441439350373, "lat": 33.95698790387454 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05079"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00066873"
      },
      "bbox": [
        3.7743459404238453, -4.8782773307587775, 4.228958852025794,
        -4.483285748892109
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9720000805468394, -3.618851427869681],
            [1.9720458695918834, -3.57470264665296],
            [2.0164137138072054, -3.5753453388343086],
            [2.0597197009895893, -3.575570667684451],
            [2.0601031720608893, -3.5017822621179935],
            [2.060338172342013, -3.4845613631823804],
            [2.104533699515096, -3.4846696458758255],
            [2.147794700349988, -3.4843983766319457],
            [2.1480973930768505, -3.4554433602460706],
            [2.148270124917448, -3.3942826587115666],
            [2.179996373278528, -3.3961878130026033],
            [2.2203195597801093, -3.3980877444678774],
            [2.2349647243204656, -3.3983958930523714],
            [2.234837721136712, -3.3547487409194403],
            [2.2349161290100965, -3.286431420566841],
            [2.237399570313182, -3.2938618590633526],
            [2.241678603243884, -3.30298147399055],
            [2.245574558317106, -3.3088958049689046],
            [2.252141593424067, -3.316720415067683],
            [2.25873850395514, -3.322450225622992],
            [2.272753094754384, -3.331668370503376],
            [2.275188504556888, -3.3349728485896475],
            [2.2782395775606163, -3.3428635908244493],
            [2.2821354143220622, -3.3451954422202297],
            [2.28532927247763, -3.3450272070551788],
            [2.2944777191918435, -3.3405396123500197],
            [2.298866147672409, -3.339619041867731],
            [2.307689135984871, -3.339943012725946],
            [2.311077266284112, -3.3352638070836687],
            [2.314353335369694, -3.3338633043220405],
            [2.322069970729929, -3.3348932547621177],
            [2.3312535329681867, -3.331678738366116],
            [2.3372398007408366, -3.325151940751864],
            [2.3410866235952934, -3.3113141608947094],
            [2.3465002310444913, -3.3038814922219055],
            [2.352087366137364, -3.3047479567508624],
            [2.3605218508782375, -3.31292878762775],
            [2.364179924114208, -3.317390304923983],
            [2.3726750622595305, -3.320433077537195],
            [2.382300639245372, -3.326528591573688],
            [2.3871877231802863, -3.327535913734056],
            [2.3961263014447747, -3.3266610395571434],
            [2.406803299940381, -3.3241463771039967],
            [2.422719564650809, -3.3192895099867883],
            [2.4349092030170643, -3.313362202615935],
            [2.439864540080063, -3.308801943210083],
            [2.448286494711094, -3.2979051774896804],
            [2.451427209851885, -3.2955469877321666],
            [2.461996690721691, -3.293408017705373],
            [2.4686395238196672, -3.295576634930377],
            [2.4803407454868336, -3.307715848583091],
            [2.485008071693123, -3.30913987686543],
            [2.492397061058324, -3.3054612177628355],
            [2.5071212732682784, -3.2912546262610722],
            [2.5169775136214803, -3.2797543797942774],
            [2.5237839396600585, -3.2741604122928343],
            [2.5274644481928346, -3.273213266469932],
            [2.535334187790531, -3.274186509483004],
            [2.5414046921411932, -3.277776012571152],
            [2.5450072710314777, -3.28451918431661],
            [2.5425691984794017, -3.3100748284235926],
            [2.5463058568725403, -3.3187232686359316],
            [2.55042534173943, -3.334248440586693],
            [2.5535491861776283, -3.342001045165398],
            [2.5597694111071476, -3.3484470574711596],
            [2.565520356823725, -3.352812795552061],
            [2.5681694840214933, -3.356214192306487],
            [2.5640216001302485, -3.359809356670013],
            [2.5580458673540822, -3.362361937419733],
            [2.554315740611376, -3.361785336869891],
            [2.5475599541259446, -3.366725793583617],
            [2.5485261796664367, -3.374090269365459],
            [2.5516718670431704, -3.3768046773052536],
            [2.561562771804408, -3.374245816567974],
            [2.5773925891058855, -3.371270924451363],
            [2.583589669413995, -3.372536114219478],
            [2.593945143368119, -3.3704428118710203],
            [2.612351398982713, -3.3636535710154893],
            [2.619059836065325, -3.3619819519873206],
            [2.625728502234566, -3.362409457751298],
            [2.631514516281132, -3.3649759752959203],
            [2.647909920198174, -3.373588830706122],
            [2.6596545305553794, -3.3817375785564754],
            [2.665058463783369, -3.3878990148747476],
            [2.6665557549886953, -3.4884718878906007],
            [2.580842615073611, -3.489516610542171],
            [2.52373416777054, -3.4890704477021273],
            [2.523241769941471, -3.4963909561697584],
            [2.509060979744446, -3.495594047120611],
            [2.5090946380655326, -3.5037967853590586],
            [2.5016915479887323, -3.503745033778557],
            [2.5020964359855142, -3.5251789618649765],
            [2.49419023898102, -3.5251518214536346],
            [2.4943170368408545, -3.532097744051017],
            [2.4804850044298963, -3.532184658664574],
            [2.4806060982701945, -3.546777599501085],
            [2.466162233698948, -3.5468798854719914],
            [2.4660582807460485, -3.5614721756532703],
            [2.4088004684838467, -3.561292048925024],
            [2.3580892157494473, -3.561457880940207],
            [2.358137233201754, -3.575945713386459],
            [2.322788189425051, -3.5757468343122567],
            [2.3231320861075173, -3.6644464023335375],
            [2.32690998314419, -3.664644374686929],
            [2.3271175422798382, -3.691605471192176],
            [2.241187777908974, -3.6925736825768],
            [2.1982271066842545, -3.6916023842937107],
            [2.155869279075591, -3.6918001105646985],
            [2.141571941247867, -3.6920845285230977],
            [2.070683383282087, -3.6918468135670928],
            [2.0270329938010607, -3.691494465373523],
            [2.02721171154008, -3.6635534011188136],
            [1.9718115752342376, -3.6631422069307757],
            [1.9720000805468394, -3.618851427869681]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.7166069956839, "lat": 35.21492675077023 },
        "year": "2023",
        "ste_code": ["05"],
        "ste_name": ["Arkansas"],
        "coty_code": ["05083"],
        "coty_name": ["Logan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Logan County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00082850"
      },
      "bbox": [
        1.9718115752342376, -3.6925736825768, 2.6665557549886953,
        -3.273213266469932
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-18.43915047734066, -2.960074253359736],
              [-18.43257699770469, -2.9630920892733292],
              [-18.424726550257283, -2.958958924856902],
              [-18.425523824085197, -2.965420720270551],
              [-18.425050387792588, -2.970768644981391],
              [-18.428393103106966, -2.9726077871735783],
              [-18.430014340110525, -2.978120201034708],
              [-18.432752940154206, -2.9803683304056996],
              [-18.43668465601705, -2.9794618122926475],
              [-18.439061906006103, -2.9738393980958904],
              [-18.43760609041778, -2.9675713597859557],
              [-18.44042198205523, -2.961580259979018],
              [-18.43915047734066, -2.960074253359736]
            ]
          ],
          [
            [
              [-19.00365613482785, -2.2201248237387485],
              [-18.997195657424985, -2.2209555257119615],
              [-18.993928612484964, -2.2168826826531647],
              [-18.996023012524475, -2.21207781985762],
              [-18.991705429921495, -2.208242626867237],
              [-18.990706360424014, -2.2052108851469363],
              [-18.985635298878307, -2.2062765533117825],
              [-18.969503685201914, -2.2152543003684433],
              [-18.963291422412205, -2.2151724091880114],
              [-18.942960024280897, -2.223680188417152],
              [-18.92079989421667, -2.2413116777986892],
              [-18.916825004135216, -2.2493929419141705],
              [-18.913782926750017, -2.249061038697989],
              [-18.908346101719832, -2.2524654574561533],
              [-18.90235200663075, -2.251953483579879],
              [-18.89775016563909, -2.2500824402236077],
              [-18.892704394132366, -2.2511284695682714],
              [-18.878064907350137, -2.2571624423356287],
              [-18.87428253867462, -2.2577963120373745],
              [-18.8681186248306, -2.2557684355132848],
              [-18.865534308401244, -2.25862965906515],
              [-18.865932591736502, -2.26154051681078],
              [-18.860310361659522, -2.2636425508103026],
              [-18.851439647775045, -2.2732678646601796],
              [-18.84823773426514, -2.2716617639233725],
              [-18.844555975621677, -2.2731297225136604],
              [-18.83466629170415, -2.28047252972228],
              [-18.829721335367715, -2.287532897876525],
              [-18.82749196989905, -2.292241470359946],
              [-18.82265631278428, -2.29805131670358],
              [-18.82064299103656, -2.302791721504926],
              [-18.819721737311298, -2.308648413788733],
              [-18.809454452414318, -2.3115214845997487],
              [-18.805999136936236, -2.3154370778271742],
              [-18.794206696463796, -2.315005620131171],
              [-18.792743813039632, -2.3197492469532985],
              [-18.78582634878184, -2.3205839455032966],
              [-18.782487985171187, -2.3249908696977233],
              [-18.767001669557978, -2.3255016902058654],
              [-18.760140526807525, -2.3222679436825486],
              [-18.751258167263742, -2.3138156529729064],
              [-18.753771983744983, -2.3071658175948446],
              [-18.74419148501309, -2.301859444687275],
              [-18.74108028884795, -2.3016441994789534],
              [-18.739395770894372, -2.298184222216467],
              [-18.73461608198731, -2.300008492456938],
              [-18.734064414192606, -2.2971309349390836],
              [-18.729859364366288, -2.2963000848658095],
              [-18.726960479059414, -2.3000853647611144],
              [-18.722052430820543, -2.30194542836511],
              [-18.72122120066077, -2.299197839650752],
              [-18.715877271981366, -2.300036787480352],
              [-18.71195477519681, -2.299127306318298],
              [-18.708260467773343, -2.3034046540118704],
              [-18.708590598387318, -2.306710990371157],
              [-18.70176185092178, -2.3127522721124323],
              [-18.697026267750825, -2.3138752142195056],
              [-18.689342222826205, -2.319514225851094],
              [-18.683897243694798, -2.328046942639264],
              [-18.69131634833555, -2.3342910376060035],
              [-18.700952699835288, -2.3344084937772545],
              [-18.70652803697291, -2.3393062369942976],
              [-18.706075800403674, -2.342403959843102],
              [-18.7119761380318, -2.3463366273841655],
              [-18.712087460152098, -2.350825701771947],
              [-18.719880367161263, -2.3567988540854716],
              [-18.72522623574316, -2.3578251994677806],
              [-18.737210275433853, -2.354296193979927],
              [-18.75038591757249, -2.3575005127840694],
              [-18.755984716173757, -2.3572260326695678],
              [-18.77403981342727, -2.3540869619973552],
              [-18.77522636896144, -2.3519560727155895],
              [-18.785719269254507, -2.3511092242239675],
              [-18.79673605744181, -2.347749362104661],
              [-18.809262475515016, -2.346538778715387],
              [-18.820691904295852, -2.3513836374176904],
              [-18.834419907881713, -2.354337853583124],
              [-18.841346372810644, -2.3541205945818864],
              [-18.84414769451749, -2.357609815883652],
              [-18.848472828874623, -2.3550132405948974],
              [-18.853862260585267, -2.3564576444495025],
              [-18.85671420336327, -2.3598692562219705],
              [-18.86236923553269, -2.3603573357401335],
              [-18.867331528200726, -2.356788091808062],
              [-18.87865780655942, -2.3517459474014517],
              [-18.884647118538123, -2.3503414587603126],
              [-18.891924449408368, -2.353209491803431],
              [-18.900759247776048, -2.3477883474279038],
              [-18.917103225017033, -2.346733191399752],
              [-18.919183658477063, -2.342510936877261],
              [-18.927229095391457, -2.3392267038233046],
              [-18.93970468077674, -2.340333590283724],
              [-18.940076027807766, -2.3365558663418864],
              [-18.947801561586783, -2.329141254642938],
              [-18.956340266500863, -2.3253197839025312],
              [-18.961713857543984, -2.326617692493624],
              [-18.972559169357204, -2.3117521825430916],
              [-18.978514043622045, -2.309073030148816],
              [-18.981930274196213, -2.2957619856369917],
              [-18.98232080028453, -2.2787765397494986],
              [-18.977985423828077, -2.2766768369457737],
              [-18.970542222020416, -2.266265427597742],
              [-18.96793051514705, -2.258037552240458],
              [-18.97117649307063, -2.2525628308331864],
              [-18.974550042088936, -2.2511818528336405],
              [-18.974124318555706, -2.2459397632388884],
              [-18.993115720639917, -2.224271176340887],
              [-18.99817384734332, -2.22450922965982],
              [-19.00365613482785, -2.2201248237387485]
            ]
          ],
          [
            [
              [-19.272626494422273, -2.2100571344193107],
              [-19.269384371362637, -2.2108947764185367],
              [-19.261152143384646, -2.205964293405976],
              [-19.24813112528436, -2.208228213744031],
              [-19.239129574961815, -2.2154732153894936],
              [-19.229367059250833, -2.219438770761964],
              [-19.218870097366683, -2.218575279856272],
              [-19.213775852059225, -2.2213762654511777],
              [-19.20569649799255, -2.221496342728991],
              [-19.199542362731012, -2.2195387659831307],
              [-19.19073083186348, -2.2150759114390044],
              [-19.185835208324466, -2.209371559521789],
              [-19.17612742941644, -2.210583445775684],
              [-19.167144516874576, -2.216792473488948],
              [-19.164258901416346, -2.216616750522096],
              [-19.16114434044042, -2.220938535202377],
              [-19.141350983043377, -2.2261270292717055],
              [-19.12697391226735, -2.2249890316902032],
              [-19.123367388586313, -2.2211158854760753],
              [-19.119991296562254, -2.2220877331691344],
              [-19.115294706990323, -2.2181300901335477],
              [-19.108896731308175, -2.215880778698761],
              [-19.099948036362523, -2.220192819170456],
              [-19.102588468313424, -2.2237890786388297],
              [-19.101996173701682, -2.2282640805114613],
              [-19.107239480794345, -2.23347048867184],
              [-19.111289152782543, -2.240635459030646],
              [-19.110447525607658, -2.2481344221160935],
              [-19.111618700295974, -2.2544113007832105],
              [-19.10881087590296, -2.260850752999579],
              [-19.103553216183148, -2.2669990893187437],
              [-19.099189574728946, -2.2695761679508326],
              [-19.098547304939235, -2.2722042219019554],
              [-19.08987161363016, -2.2772753043820972],
              [-19.089594176987625, -2.2799057300602],
              [-19.0827033436086, -2.2831438029692555],
              [-19.066056683397544, -2.2828587777802984],
              [-19.062525582356077, -2.2866181663047374],
              [-19.066150852267466, -2.297727635509396],
              [-19.06696667434717, -2.3109598216258433],
              [-19.06399172889171, -2.3182670431374186],
              [-19.06801626234779, -2.32546413721989],
              [-19.089992123632086, -2.320765350752021],
              [-19.10465766039618, -2.322376671297452],
              [-19.115532844338794, -2.328421044177114],
              [-19.124743800389197, -2.3294479373847894],
              [-19.127623325620807, -2.3323776311448228],
              [-19.132140720586232, -2.332716300256025],
              [-19.13564400790422, -2.3370452923418177],
              [-19.141674771091168, -2.336979991914215],
              [-19.155181479661323, -2.3345423214834984],
              [-19.159494746056133, -2.336782140047843],
              [-19.16976276036834, -2.333763382862083],
              [-19.1763493609237, -2.3334943545376836],
              [-19.182745344332915, -2.335553592269362],
              [-19.188665971360667, -2.3430244402497378],
              [-19.19354416512381, -2.3430708874183512],
              [-19.19793345127868, -2.3405285218701914],
              [-19.223136403528258, -2.3129810688692016],
              [-19.22734474354385, -2.3114588748440683],
              [-19.231605233999066, -2.3035687945491823],
              [-19.237212221520526, -2.2997676475388644],
              [-19.235388788070036, -2.2972343481189754],
              [-19.23899038077494, -2.2757972414994225],
              [-19.24033146956132, -2.272782495850759],
              [-19.24482828753011, -2.2695899791772454],
              [-19.2448189513629, -2.2647104403032654],
              [-19.248290156056157, -2.2477119779378523],
              [-19.25449198104006, -2.2391776665567993],
              [-19.254576625832456, -2.230280124691905],
              [-19.260122542745112, -2.225008483625191],
              [-19.26695314851225, -2.22131598297032],
              [-19.26596678345986, -2.2180145720717133],
              [-19.268983293438346, -2.2142258406885427],
              [-19.27258942336645, -2.2133422919074777],
              [-19.272626494422273, -2.2100571344193107]
            ]
          ],
          [
            [
              [-19.424101780339303, -2.137394177036526],
              [-19.42253840914987, -2.134524453539994],
              [-19.415596141669695, -2.136793712045608],
              [-19.403922346298472, -2.1287851113930114],
              [-19.394625517520335, -2.1265029578519985],
              [-19.39112320037811, -2.1244375743879553],
              [-19.38299543328158, -2.131274233445774],
              [-19.37715535939554, -2.1330717513584503],
              [-19.372492200849724, -2.1324135888568314],
              [-19.35648826058283, -2.1255075845876577],
              [-19.34875821604733, -2.119034303979089],
              [-19.348241856040875, -2.113295274240182],
              [-19.344320463028563, -2.1178711894751325],
              [-19.342064669506275, -2.132827008643058],
              [-19.347163986384707, -2.135068342611407],
              [-19.34725274240678, -2.1408586794915547],
              [-19.343451885514643, -2.145020324740749],
              [-19.3389105647563, -2.1468513342167164],
              [-19.32571037422604, -2.1476811373927203],
              [-19.31787690831301, -2.1571380025200293],
              [-19.314594618558647, -2.163619245628363],
              [-19.311755427086418, -2.171656797507739],
              [-19.313475353752164, -2.17869123269557],
              [-19.317253551818364, -2.180246438140119],
              [-19.322202687044296, -2.1800925208323543],
              [-19.336006782161192, -2.1744408127086947],
              [-19.34093433940283, -2.1744016172311533],
              [-19.346271104365723, -2.1724679108288547],
              [-19.35140140430845, -2.1722573606304096],
              [-19.355705521704813, -2.175290686850815],
              [-19.362436943239253, -2.17268147208736],
              [-19.368445580925837, -2.168054246737249],
              [-19.373350128818686, -2.1608365272320547],
              [-19.379719327859675, -2.157590577920353],
              [-19.392241883917475, -2.1478407825727337],
              [-19.396889020301646, -2.146572114614546],
              [-19.400752552096794, -2.148989176963445],
              [-19.408326962236476, -2.1506689293244925],
              [-19.413816114162668, -2.1451188275344286],
              [-19.42890634161829, -2.1424956206869887],
              [-19.424101780339303, -2.137394177036526]
            ]
          ],
          [
            [
              [-19.339410937137053, -1.1795258793168921],
              [-19.33139391386207, -1.1974538609386285],
              [-19.326397671424605, -1.195320190540245],
              [-19.315730684765175, -1.1949421160742684],
              [-19.31187307478034, -1.1904115058087115],
              [-19.302896060866257, -1.1912479633437518],
              [-19.299250324653656, -1.1987435134036413],
              [-19.2912186495248, -1.2001041829306387],
              [-19.28740334316967, -1.1958566947154705],
              [-19.280253359129933, -1.191458387857312],
              [-19.27289616333332, -1.1944203585715987],
              [-19.265467852417018, -1.1999658851982167],
              [-19.25805041683008, -1.196783689514209],
              [-19.25564041901074, -1.1969393870647238],
              [-19.25008204223341, -1.1937328300683496],
              [-19.214401102556888, -1.1933411199369939],
              [-19.185358232073455, -1.204906370379179],
              [-19.174862007450347, -1.2082417396420673],
              [-19.168311686598177, -1.2121554167776571],
              [-19.162218176513996, -1.2196681654502772],
              [-19.1392880545631, -1.24441778258073],
              [-19.120301597452176, -1.2667438820250698],
              [-19.115677625136264, -1.2754378812630733],
              [-19.110848451730742, -1.2811561585369367],
              [-19.106996127168106, -1.283455029968567],
              [-19.0996737803905, -1.2936621776173616],
              [-19.09754040530057, -1.2979721717904902],
              [-19.098305476225548, -1.3007828646856547],
              [-19.096597108255636, -1.3140419464036057],
              [-19.0915951217628, -1.318739931031134],
              [-19.08401297282051, -1.3188606801403755],
              [-19.08084901560254, -1.316336169291165],
              [-19.080461242736764, -1.3102787678182908],
              [-19.077766158930455, -1.3062290099062903],
              [-19.07256783839138, -1.3018025833095137],
              [-19.07011544383189, -1.296711776580801],
              [-19.06782569500499, -1.2803403648794214],
              [-19.068437761126827, -1.2762193362542793],
              [-19.071695094427593, -1.2723949177656029],
              [-19.07268392832897, -1.268123143377604],
              [-19.069363649010768, -1.2624440923001221],
              [-19.072614344138266, -1.2543460750694184],
              [-19.076794414472797, -1.2496179572016186],
              [-19.077110683859935, -1.246637891279659],
              [-19.07463241791738, -1.2421822127474564],
              [-19.077433401618535, -1.23664500244847],
              [-19.08323840227178, -1.2346949534538947],
              [-19.086087999709616, -1.2253702918232456],
              [-19.085375154389695, -1.216430461114305],
              [-19.0840251739938, -1.2138621895894217],
              [-19.07279070487614, -1.2053375432873366],
              [-19.063938689771856, -1.2160886765242245],
              [-19.04687724397437, -1.2140700461042013],
              [-19.038743833247025, -1.2202325773906342],
              [-19.036052621826318, -1.2146656090695542],
              [-19.0324996756266, -1.2122280201273201],
              [-19.026824476466036, -1.2132381918861137],
              [-19.022126545920017, -1.2120733883235437],
              [-19.021626051163274, -1.2182773783202179],
              [-19.01760923498285, -1.2158862323483286],
              [-19.013504189553323, -1.2086211479043738],
              [-19.00616657630407, -1.2174036668180837],
              [-19.00042303378733, -1.2175969980180972],
              [-19.000060472494315, -1.2207477568486749],
              [-18.993434259079162, -1.2204035918123652],
              [-18.991476030459708, -1.222471444827836],
              [-18.982226436350096, -1.2226813639881646],
              [-18.976484567712063, -1.2212230110058024],
              [-18.97203756626321, -1.2187719911039043],
              [-18.96305574687515, -1.2203468948600462],
              [-18.959930846042962, -1.2147268142155598],
              [-18.954469816298246, -1.213306574846285],
              [-18.95572320783863, -1.2034253008093252],
              [-18.95060765118751, -1.1979777345023037],
              [-18.948285571191363, -1.1914359464742987],
              [-18.942255835888307, -1.1902172718985287],
              [-18.940570744188218, -1.1848684614393028],
              [-18.935341564225286, -1.180750084977886],
              [-18.92524999704794, -1.1804867068727092],
              [-18.923256264359473, -1.1767526028622288],
              [-18.919461721953972, -1.1784443340390867],
              [-18.917599132734225, -1.1758044347039793],
              [-18.91419151542495, -1.1790342652557668],
              [-18.91142329085011, -1.174974899894541],
              [-18.91460127217737, -1.1734467293057975],
              [-18.91020585753977, -1.1656579489595755],
              [-18.907780243266405, -1.1682586911274953],
              [-18.90472840766821, -1.1652000226543462],
              [-18.90052470204308, -1.1698944013648989],
              [-18.895716920800364, -1.1669138385584814],
              [-18.892140403380857, -1.168393535151872],
              [-18.889980290591023, -1.1630643979204125],
              [-18.886667027690795, -1.1606928764427622],
              [-18.885053310947644, -1.1644053660093574],
              [-18.880995886877844, -1.1647340879130965],
              [-18.879818518541253, -1.160118959329208],
              [-18.875494075071092, -1.1614719460433378],
              [-18.872265892332802, -1.158924752863627],
              [-18.867114917661347, -1.1579183157278141],
              [-18.863776938612915, -1.1600349822855598],
              [-18.85727005801429, -1.160329067109355],
              [-18.862235058760454, -1.1660490770715233],
              [-18.85962458920341, -1.1695531329365163],
              [-18.853135300138835, -1.1714254590414697],
              [-18.853525772001067, -1.1743285664672134],
              [-18.851137487344044, -1.1802214514103617],
              [-18.846707477325452, -1.1828340650186675],
              [-18.846304756705102, -1.1854193601658267],
              [-18.838111970596962, -1.1907365617080161],
              [-18.83557748614015, -1.195462140241721],
              [-18.831261223797494, -1.1932873488786913],
              [-18.826301583728483, -1.1959519522036297],
              [-18.824622290039198, -1.2008153286367973],
              [-18.82039173474674, -1.201419472160456],
              [-18.820738456444854, -1.2052136730943919],
              [-18.816248790729038, -1.2042409821742024],
              [-18.81316733058387, -1.2059852357565068],
              [-18.81428023977565, -1.2118103109243543],
              [-18.81138939063243, -1.212856368370351],
              [-18.808958544905426, -1.2171193130507463],
              [-18.805792191005814, -1.2164720133675857],
              [-18.800949224669466, -1.2284205349713067],
              [-18.797301915088926, -1.2272803539329598],
              [-18.793445813730084, -1.232167068316934],
              [-18.791082782844203, -1.2320742754803415],
              [-18.788890946069134, -1.2363869028078727],
              [-18.78034260979793, -1.2380071255571226],
              [-18.777720401206494, -1.241923994258805],
              [-18.773496250112792, -1.241484141487473],
              [-18.767980881593, -1.242906031194691],
              [-18.763917216113324, -1.2468027361216203],
              [-18.754707645441815, -1.247189501953896],
              [-18.751330814621156, -1.2444647881055266],
              [-18.747942613667743, -1.2528855425144068],
              [-18.74531340201099, -1.257274160421359],
              [-18.739879485519495, -1.2618190022164544],
              [-18.742120715466754, -1.2678833562874],
              [-18.737418998478383, -1.2705946608919025],
              [-18.72771222457878, -1.2721369881509574],
              [-18.725666584893435, -1.271012098590329],
              [-18.7207459252938, -1.2736909764654338],
              [-18.716984072347408, -1.2741951717825417],
              [-18.71545289606889, -1.2787760330107394],
              [-18.70845679568712, -1.2812014244856953],
              [-18.707275373488873, -1.2853122688856153],
              [-18.70016405318207, -1.2863817918758655],
              [-18.698921769251402, -1.2914864202279825],
              [-18.696708732592935, -1.2942738457741534],
              [-18.69620140577494, -1.3047524965110804],
              [-18.693964816503865, -1.3058053419676519],
              [-18.68812987947225, -1.3169110784957778],
              [-18.683251160780657, -1.3190240262580641],
              [-18.677298808233555, -1.324547262193958],
              [-18.67262638320776, -1.3247133911480158],
              [-18.6679959179543, -1.330386589084253],
              [-18.666220123297595, -1.3355604539392283],
              [-18.65972662219297, -1.3419859186505927],
              [-18.655771442076574, -1.342988386546361],
              [-18.65221584126126, -1.3417624520622755],
              [-18.645650731551427, -1.3480370432306374],
              [-18.639595953703395, -1.354983839064778],
              [-18.634928944812778, -1.357334272586968],
              [-18.62905065151771, -1.3654219773063667],
              [-18.624871071145133, -1.3671123761382962],
              [-18.616025998401188, -1.3677309147754102],
              [-18.607321590978238, -1.3729385401211016],
              [-18.60009344503924, -1.3712349613741626],
              [-18.592874165110825, -1.3715219970284884],
              [-18.587828151639073, -1.375894417970585],
              [-18.57681804979837, -1.3807046718762361],
              [-18.572385388691746, -1.3799593444906548],
              [-18.565986383615552, -1.3854343895040988],
              [-18.56041851954812, -1.3931691782282098],
              [-18.55919253768562, -1.3975054787572645],
              [-18.555391281313756, -1.4016667393838387],
              [-18.554502902873775, -1.405129595432726],
              [-18.546799321600638, -1.4069534879827355],
              [-18.54045746402391, -1.413347931744516],
              [-18.5328087610349, -1.4139361521153506],
              [-18.52813217160428, -1.4189706532042288],
              [-18.518056345132766, -1.4337966215486748],
              [-18.514944830029247, -1.4426982998209854],
              [-18.510213810089244, -1.4495125744596526],
              [-18.4990597169747, -1.4604477289464013],
              [-18.489062466286967, -1.4726476715205286],
              [-18.482641827983233, -1.481756786061412],
              [-18.455432463419942, -1.4883194943536049],
              [-18.446944790156337, -1.4908746540574749],
              [-18.44595332780682, -1.4872787982194666],
              [-18.431818588568447, -1.490630448786399],
              [-18.40915535906521, -1.4965537370411237],
              [-18.437478143411447, -1.6085914000771544],
              [-18.450018210767155, -1.6608036094006566],
              [-18.491986691803067, -1.8298657793314292],
              [-18.509088019918202, -1.8977428814948767],
              [-18.517607544751858, -1.9320038254734409],
              [-18.51963552304013, -1.9461088697867448],
              [-18.523493297507837, -1.9505113024792522],
              [-18.526084776766204, -1.9572975967007766],
              [-18.533214404998333, -1.956438052148392],
              [-18.53425988529322, -1.9619688095942796],
              [-18.536463720354874, -1.966470287018423],
              [-18.534088388448794, -1.9735009805643995],
              [-18.531713150221726, -1.977311977777234],
              [-18.53335844311499, -1.9818989362604695],
              [-18.53986790215479, -1.9876955532297509],
              [-18.545907292432517, -1.9898557031931372],
              [-18.559370763383672, -1.9963722650467746],
              [-18.561574255573394, -2.000715406913823],
              [-18.564710517358694, -1.9996113375596767],
              [-18.564979800251066, -2.005060865226224],
              [-18.566853951793284, -2.0054520189498932],
              [-18.568968100635853, -1.997884744236979],
              [-18.578862129208318, -1.9904362193913385],
              [-18.584278869271223, -1.9894593223555288],
              [-18.594795061251084, -1.9817731724244003],
              [-18.59761109719371, -1.977003612288262],
              [-18.603035763496273, -1.9728550112555465],
              [-18.607521649040482, -1.971662417444264],
              [-18.61375547304965, -1.9604781385666785],
              [-18.621102772679194, -1.9500689302101817],
              [-18.624218353502734, -1.9472803462291155],
              [-18.63463386762473, -1.9475336408547812],
              [-18.638888901275614, -1.944854959645751],
              [-18.644333941372274, -1.9394052462838802],
              [-18.656686627618505, -1.9337321782196266],
              [-18.664759400533725, -1.9311138762943967],
              [-18.668546788480274, -1.9326364255472603],
              [-18.67516866147659, -1.9298600488587148],
              [-18.683525989023767, -1.9318604051764667],
              [-18.690877445156165, -1.9282269335527489],
              [-18.709603283657025, -1.9248205767209685],
              [-18.723426917105275, -1.9250466359883944],
              [-18.721694217852225, -1.9298534859013268],
              [-18.728591314593114, -1.9334453815569377],
              [-18.73535740231937, -1.9329097730926004],
              [-18.737521073543675, -1.935768879345665],
              [-18.74425858744309, -1.9375217368163056],
              [-18.760238777786554, -1.9329312990583523],
              [-18.76811365662803, -1.9248896450106765],
              [-18.774974302492062, -1.9210096148825175],
              [-18.800036750528147, -1.9018773605111923],
              [-18.80556651447476, -1.8980810044168146],
              [-18.812615658441015, -1.8965921281903166],
              [-18.816708222083463, -1.8970961901436243],
              [-18.8309229815174, -1.8928201938184248],
              [-18.839650289317532, -1.8919547731199455],
              [-18.84376782683344, -1.892794247007196],
              [-18.8494352118091, -1.901403740836065],
              [-18.85587298260485, -1.8959115767790102],
              [-18.87168775410362, -1.8910263476002085],
              [-18.87549156072861, -1.8916170858169161],
              [-18.880311033596428, -1.8800656043168524],
              [-18.88282614766731, -1.8768155578762746],
              [-18.889479991156705, -1.8735086399552616],
              [-18.89774625915929, -1.8626840778177927],
              [-18.902408056527726, -1.8578130486032036],
              [-18.908240632307862, -1.8539086965641023],
              [-18.91669454920838, -1.8511012367743849],
              [-18.92478973481414, -1.8503783674464473],
              [-18.929598580310444, -1.8485113674383018],
              [-18.940337708726744, -1.8360922637028219],
              [-18.949037342834924, -1.8274113664363154],
              [-18.953354045830704, -1.827331941699184],
              [-18.958016665854522, -1.8203476456342669],
              [-18.964973666794968, -1.8132953368841385],
              [-18.973800761914255, -1.8102651683875277],
              [-18.977846700211142, -1.8122312537283876],
              [-18.983595953173815, -1.807189883668564],
              [-18.988573089602237, -1.8040946245532408],
              [-18.99840980495303, -1.8034083803221082],
              [-19.005872887790662, -1.8017100865642746],
              [-19.014319752915416, -1.798358786612594],
              [-19.015969772492454, -1.799735564870466],
              [-19.02879189897816, -1.7970510311321428],
              [-19.03521311600975, -1.79372196819467],
              [-19.04994284133711, -1.7814555579501599],
              [-19.060963143724877, -1.7754615238487883],
              [-19.07533676818722, -1.771382864874811],
              [-19.08486864459884, -1.7704110125333457],
              [-19.08985873489887, -1.7712999491930737],
              [-19.09444643177147, -1.7691074646483251],
              [-19.101356127815286, -1.7676457466263622],
              [-19.134536654146252, -1.7587884423490479],
              [-19.141689742590614, -1.7578477336346974],
              [-19.14506507329178, -1.7586374243660146],
              [-19.160873632226156, -1.7551900952335355],
              [-19.180609694383023, -1.7490998600454764],
              [-19.189566318097135, -1.7443978759875696],
              [-19.1958278637776, -1.7464549894061916],
              [-19.212895664006272, -1.745852043560435],
              [-19.223225902623305, -1.74396524140065],
              [-19.225620769358162, -1.7463621685014077],
              [-19.229234845184422, -1.7463505932785468],
              [-19.24876738881653, -1.742992731787611],
              [-19.281872079173215, -1.7361488810320471],
              [-19.290787521874886, -1.736273101825473],
              [-19.29481410693307, -1.7378940781290402],
              [-19.29854723896739, -1.7374104521242768],
              [-19.310695732609002, -1.732563663041025],
              [-19.319304880952195, -1.734903058019505],
              [-19.32159463111936, -1.7391476606809297],
              [-19.32594107752601, -1.7349829850826035],
              [-19.328265160687845, -1.7308978630422702],
              [-19.334895577296138, -1.730017832431448],
              [-19.332245780931974, -1.7103378958104698],
              [-19.332030845331982, -1.7023420646028233],
              [-19.333483593856116, -1.695782611599696],
              [-19.33705493586679, -1.6903270589728445],
              [-19.340339432446452, -1.6797197381257576],
              [-19.34260821015649, -1.6784321231697594],
              [-19.34277525019367, -1.665531775219911],
              [-19.34726258558935, -1.6484948542858922],
              [-19.355671004719692, -1.6375874377748927],
              [-19.367195526999325, -1.6257400012565741],
              [-19.376068551165368, -1.6212225940380611],
              [-19.383319587961054, -1.6119134433198163],
              [-19.393704599268695, -1.6007871370879343],
              [-19.415153804756383, -1.5954274063931342],
              [-19.41883433798722, -1.5976763232313107],
              [-19.427064370463395, -1.595024253848169],
              [-19.432793178777924, -1.5867723404848286],
              [-19.436439710438474, -1.5852939042085836],
              [-19.43799340022052, -1.5822056562681797],
              [-19.43647084767835, -1.577935253886893],
              [-19.436549973029692, -1.573038966141721],
              [-19.438663955194965, -1.5679627735981465],
              [-19.43615646154397, -1.5569697440037649],
              [-19.43291899505776, -1.555835662103166],
              [-19.42920310400972, -1.5468196330302355],
              [-19.430968595263554, -1.544760410914699],
              [-19.42734914069566, -1.54086014494052],
              [-19.408293576568063, -1.5160963632099458],
              [-19.375025014666022, -1.462961205452295],
              [-19.37072297938185, -1.4529003513956227],
              [-19.37037478466081, -1.447694528701572],
              [-19.37370105245173, -1.442091458843584],
              [-19.373821356748238, -1.434960609878008],
              [-19.375550038339068, -1.4316508910320738],
              [-19.375342400157603, -1.424494068517338],
              [-19.377909561368472, -1.4188973195834607],
              [-19.38247544111042, -1.4149262412645514],
              [-19.38285161571899, -1.3988209820543147],
              [-19.38660909877082, -1.3952438428390355],
              [-19.381811976324542, -1.3849822602962087],
              [-19.3718659536237, -1.3718165039813657],
              [-19.365569842694864, -1.3618107101225823],
              [-19.354373816398926, -1.340781744350405],
              [-19.342510939529408, -1.3163458815457738],
              [-19.338816539418396, -1.3012328504214759],
              [-19.341371825153896, -1.2916294355695082],
              [-19.35589237099323, -1.2735191271413946],
              [-19.353918148389397, -1.2640563021896583],
              [-19.356859830225417, -1.2516499154411078],
              [-19.361415446175762, -1.2512832477308042],
              [-19.365030891369575, -1.2491243692365677],
              [-19.373863697531178, -1.2466860864196898],
              [-19.374565269124332, -1.2438407655952408],
              [-19.365028822065327, -1.2289042839298765],
              [-19.362950133045615, -1.2216561145113511],
              [-19.364687204664246, -1.2196802976472683],
              [-19.359744042193242, -1.2147008495504272],
              [-19.339410937137053, -1.1795258793168921]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -120.01686225355692,
          "lat": 34.67299193458193
        },
        "year": "2023",
        "ste_code": ["06"],
        "ste_name": ["California"],
        "coty_code": ["06083"],
        "coty_name": ["Santa Barbara"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Santa Barbara County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00277306"
      },
      "bbox": [
        -19.438663955194965, -2.9803683304056996, -18.40915535906521,
        -1.1579183157278141
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.192558396493509, -0.9650028523689594],
            [-7.088600276792722, -0.8733395278540593],
            [-7.070991464940174, -0.8583406490482735],
            [-7.065415887129134, -0.8527658106649322],
            [-7.046780833212552, -0.8366441530077057],
            [-6.978242558161003, -0.7766340053724664],
            [-6.97742199336952, -0.7704165286153192],
            [-6.972667043252939, -0.7654112025952902],
            [-6.968398417340742, -0.7633657220865723],
            [-6.955769320909469, -0.7605985389814163],
            [-6.942908710480078, -0.7531440373338403],
            [-6.94313605958532, -0.7496387609786966],
            [-6.9367435197810465, -0.7438461184798055],
            [-6.933789109706636, -0.736405383457444],
            [-6.931232419294848, -0.7326256576642229],
            [-6.928014551288289, -0.731488136986298],
            [-6.920278860096024, -0.7316323168792183],
            [-6.916086188628302, -0.7291321534442915],
            [-6.910941485296944, -0.7290013943394558],
            [-6.90946603196941, -0.7307005353971328],
            [-6.904172397147266, -0.7290782906233606],
            [-6.897879917353281, -0.7335201664637492],
            [-6.89084005712706, -0.7300408636126268],
            [-6.886277573376967, -0.7222913609508014],
            [-6.881635869860862, -0.7212138640670596],
            [-6.877940108629926, -0.7149853756033412],
            [-6.872816977108447, -0.7116395697429878],
            [-6.867515000745644, -0.7119557814597679],
            [-6.86540914908145, -0.7139780860244735],
            [-6.855502846943504, -0.7138482228558747],
            [-6.852651333789672, -0.7098010887129049],
            [-6.844332300589556, -0.7093620432654956],
            [-6.840144144489374, -0.7100627229427354],
            [-6.830829830421706, -0.7050692064394357],
            [-6.824027219441379, -0.7039918029002665],
            [-6.8231728796227795, -0.7011262972907529],
            [-6.817447749773387, -0.7015171178973105],
            [-6.813740001098873, -0.6972747898576563],
            [-6.8125189633377765, -0.7011759762838388],
            [-6.808314787068727, -0.705620273279966],
            [-6.806163837016386, -0.7053126852852317],
            [-6.805035952019054, -0.7105640854265286],
            [-6.800117462593509, -0.7105731224628258],
            [-6.796182061946204, -0.7163832695625983],
            [-6.791744573690282, -0.7195080226047691],
            [-6.782476050101184, -0.7184812399772702],
            [-6.78250746354878, -0.7255616900202289],
            [-6.781034903738478, -0.7287663573536118],
            [-6.774238078798534, -0.7304746987236251],
            [-6.7733758438681635, -0.736143757065836],
            [-6.769302766423886, -0.7395347455703942],
            [-6.761665929265929, -0.7406886106740966],
            [-6.757739480947202, -0.7402571985398317],
            [-6.756106124070257, -0.737304671019044],
            [-6.752009396612406, -0.7354844723072919],
            [-6.750406889738754, -0.7385752177685906],
            [-6.7425459068144225, -0.7437398660644093],
            [-6.73160230981492, -0.7443199030873795],
            [-6.7328402027433, -0.748795387720262],
            [-6.738969703542131, -0.7544904582683232],
            [-6.740082403995118, -0.7602288483725828],
            [-6.738530314469427, -0.762551436984577],
            [-6.738725029058595, -0.7715277804949109],
            [-6.746728634474654, -0.7684368211881657],
            [-6.748596846306348, -0.7719480177103039],
            [-6.753894879866886, -0.7762214474422225],
            [-6.758121248295575, -0.7770592729684102],
            [-6.759276331591799, -0.7794009402402403],
            [-6.749906615067073, -0.7886082182663475],
            [-6.747040228856452, -0.7891280694327188],
            [-6.741400481521756, -0.79688017149101],
            [-6.740576817518313, -0.8015910422895146],
            [-6.735063279970291, -0.8087347502177192],
            [-6.732105583232084, -0.8162897594773706],
            [-6.734898748641205, -0.8179414781797183],
            [-6.735985716370065, -0.8265430054180816],
            [-6.7322543869967815, -0.8310575669795632],
            [-6.731986546523014, -0.8391582940786049],
            [-6.72899757220903, -0.8475853001927514],
            [-6.729285890615378, -0.8525036531566199],
            [-6.73186234493505, -0.8562581215290046],
            [-6.732646995093968, -0.8630649135062325],
            [-6.7315599611538754, -0.8665115972866353],
            [-6.7362006269523445, -0.873707836437535],
            [-6.734323426864852, -0.8786644110473234],
            [-6.739806058172596, -0.8865478815689649],
            [-6.737144302327131, -0.8899371604766811],
            [-6.737436057505938, -0.8929328260431139],
            [-6.73604019150339, -0.9047507443588105],
            [-6.738102053814677, -0.9091848473634156],
            [-6.728098283782116, -0.9119411681224641],
            [-6.7229067899581985, -0.9100845496279353],
            [-6.7203175267517405, -0.9159502068616834],
            [-6.719074407074044, -0.9245624661456227],
            [-6.717134389709085, -0.9268697522663244],
            [-6.717344156049079, -0.9320125510989814],
            [-6.713785535261578, -0.9405548725789504],
            [-6.714431870912552, -0.950422894300713],
            [-6.712258077619169, -0.9557315798269186],
            [-6.706831450291413, -0.9601577231301249],
            [-6.709687671924192, -0.9656113868519368],
            [-6.714588674626032, -0.9680956630629464],
            [-6.7246267537888125, -0.967633112703777],
            [-6.728547834869203, -0.9682301462574527],
            [-6.7344562647749795, -0.9767151262226057],
            [-6.737865113293236, -0.9783187950746325],
            [-6.737433222956548, -0.9856861825690979],
            [-6.740761641173754, -0.9909796133179292],
            [-6.738875245307056, -0.9970605031400284],
            [-6.742156532001279, -1.005171215945684],
            [-6.7409718555912, -1.008701100326645],
            [-6.741157426148979, -1.0196673482107717],
            [-6.739988080488745, -1.021912555701123],
            [-6.7437877863761875, -1.029847283958833],
            [-6.740773820321306, -1.038377106914441],
            [-6.744095529836225, -1.043303932001252],
            [-6.743789545882473, -1.0503880891419208],
            [-6.745240335340669, -1.053278526545174],
            [-6.743821923347679, -1.0674598043070778],
            [-6.745804956966518, -1.0720535075829],
            [-6.745788956849258, -1.078253437463233],
            [-6.74020705091089, -1.0749640913514025],
            [-6.737256609977008, -1.0750087682882907],
            [-6.766854837337173, -1.3741684298891101],
            [-6.818412965649006, -1.369342474181656],
            [-6.842610356350481, -1.3665424176336427],
            [-6.974846053798887, -1.3532612065712877],
            [-6.996825933589092, -1.3509097536230035],
            [-7.045307364546682, -1.3461840481557277],
            [-7.138695027911062, -1.336972436981272],
            [-7.1679886440838185, -1.3337920949300923],
            [-7.210287255460195, -1.3294935541745416],
            [-7.210066128678054, -1.3254308784213313],
            [-7.213171324921715, -1.3241787122273736],
            [-7.213020765417209, -1.3208851230929952],
            [-7.215398565574594, -1.316532371342681],
            [-7.212936149118369, -1.3140686931462446],
            [-7.216182776807337, -1.309470413091827],
            [-7.2247599976663075, -1.3105699281642305],
            [-7.230067908023099, -1.3088520125854906],
            [-7.232191662491805, -1.304739821264707],
            [-7.231433061546079, -1.2992559111215929],
            [-7.233312324143794, -1.2945568696041025],
            [-7.240585457535542, -1.2956303795877573],
            [-7.243456590331897, -1.2864286167913253],
            [-7.245627478149153, -1.284652139510611],
            [-7.243401634580951, -1.2810182688003695],
            [-7.246558887407804, -1.2793216948068098],
            [-7.245754420196312, -1.2737359128262495],
            [-7.240075470742657, -1.2656721639215858],
            [-7.244011734645081, -1.2564546249839534],
            [-7.240937738137271, -1.254912448476842],
            [-7.237079211134727, -1.2480328694902967],
            [-7.232098828504153, -1.2437265864985447],
            [-7.229129237317195, -1.238586864016565],
            [-7.224253943430148, -1.233563006469825],
            [-7.223462144843057, -1.2301687285044747],
            [-7.21686537397078, -1.2211080669543706],
            [-7.219342919132214, -1.2178605608760595],
            [-7.222411037385686, -1.210202600183389],
            [-7.222191825834714, -1.2026067813760548],
            [-7.2196359097558425, -1.193826564239297],
            [-7.2197930954073835, -1.1873042162287286],
            [-7.215194594471059, -1.1791612824510347],
            [-7.206711819926422, -1.1735414272592763],
            [-7.203910844001293, -1.1673738019245596],
            [-7.204253175345012, -1.1641733403264916],
            [-7.2080891803198135, -1.1578057291282062],
            [-7.206738614711827, -1.1524024336160996],
            [-7.201492286336021, -1.147552641205365],
            [-7.200144968275751, -1.1429709523608098],
            [-7.201742785104659, -1.1351486982114376],
            [-7.205119833569177, -1.1333585111063988],
            [-7.205904437583173, -1.128147687329413],
            [-7.203054695772302, -1.1237559729921147],
            [-7.204700735975133, -1.1220725871211514],
            [-7.204082818310887, -1.115508965465305],
            [-7.205591804026841, -1.1092736591333383],
            [-7.2087906506525075, -1.1040701244506845],
            [-7.206739699002292, -1.1008730965504947],
            [-7.208253858301886, -1.0917070739494001],
            [-7.20398610213356, -1.088548262347918],
            [-7.202601975894568, -1.0815731142195149],
            [-7.205988709952519, -1.0742736758327793],
            [-7.20260121288179, -1.0668986788984383],
            [-7.198285675122857, -1.0650253838692685],
            [-7.198617618918742, -1.0590073629504504],
            [-7.193705363844951, -1.0566572987179226],
            [-7.190678710132314, -1.051929224846621],
            [-7.185823513755269, -1.0491090376423093],
            [-7.186912318705883, -1.037150280198002],
            [-7.1816738375775575, -1.0381325226612041],
            [-7.181440372200036, -1.0327947500853796],
            [-7.186396853633591, -1.024414301432781],
            [-7.186817550586172, -1.0182957935096426],
            [-7.191271675833505, -1.0200426040756143],
            [-7.196178162697637, -1.0000067370327095],
            [-7.198961040322769, -0.9945462190061894],
            [-7.197953443731674, -0.9906022685658498],
            [-7.2006350695727175, -0.9877158162982899],
            [-7.199166273628505, -0.9823374996120448],
            [-7.201653063158203, -0.9769407043208344],
            [-7.1971176000164006, -0.9734390608264045],
            [-7.198265796107061, -0.970424178914089],
            [-7.192558396493509, -0.9650028523689594]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.4282191441713,
          "lat": 37.278083906820925
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08023"],
        "coty_name": ["Costilla"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Costilla County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "00198127"
      },
      "bbox": [
        -7.246558887407804, -1.3741684298891101, -6.706831450291413,
        -0.6972747898576563
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-5.804389675014668, -0.29450723636150056],
            [-5.79830413818079, -0.29496641093980175],
            [-5.79613666550258, -0.30037974452909044],
            [-5.7854055286660335, -0.30211259597233536],
            [-5.777201693135724, -0.30246565393486197],
            [-5.771194337039393, -0.301053278690809],
            [-5.767193968586048, -0.2984240732761342],
            [-5.760212884753357, -0.30145070843077265],
            [-5.755063567764224, -0.29851854820623086],
            [-5.747414756428103, -0.30497985464818406],
            [-5.742388106468159, -0.3052468804911448],
            [-5.739781301992833, -0.3079397949785477],
            [-5.742339206297047, -0.3120608672093362],
            [-5.740526086942788, -0.3144721793736452],
            [-5.7296312757891545, -0.3171285560879748],
            [-5.722751099451537, -0.31790543857226145],
            [-5.717859255406614, -0.32187940581384716],
            [-5.709824147575211, -0.32485243831106275],
            [-5.7010978974644475, -0.3194950069502433],
            [-5.697850463785117, -0.3247133182690642],
            [-5.691781731832305, -0.3241852635355081],
            [-5.693332378447613, -0.3189274898057384],
            [-5.692313588616102, -0.31625426032140597],
            [-5.684238626575782, -0.31730355065311155],
            [-5.681719770099858, -0.32039422996192624],
            [-5.683868583196869, -0.3260143577799162],
            [-5.666339761881698, -0.32824281289657237],
            [-5.658749831651209, -0.3246577433992491],
            [-5.654788511050306, -0.3257331218560219],
            [-5.651012777602223, -0.32872823953743346],
            [-5.644827942201045, -0.32962250875984633],
            [-5.641763048800555, -0.33154094901685754],
            [-5.638754949988527, -0.3379290727785168],
            [-5.634374268111784, -0.34235025608220376],
            [-5.62892289832568, -0.3417163234737041],
            [-5.622793962726302, -0.3426850890848535],
            [-5.617068725590671, -0.33964518758336476],
            [-5.6121457314391545, -0.3410831332216412],
            [-5.609140304919807, -0.3452486151228171],
            [-5.568425431774659, -0.3478974813051683],
            [-5.566080640219575, -0.34822788390827275],
            [-5.508698439724857, -0.3530665807500385],
            [-5.466290376397136, -0.356030838860361],
            [-5.461678220272403, -0.2975427052903237],
            [-5.447527033512981, -0.29841076380708176],
            [-5.433579939692685, -0.29847974879824074],
            [-5.376290480630369, -0.30328005378822964],
            [-5.369390774954455, -0.21106205678410983],
            [-5.3630270820084585, -0.21062866822460447],
            [-5.284064903318246, -0.2164070917954293],
            [-5.294194201089242, -0.3578494299824916],
            [-5.300633227883785, -0.44199954041697853],
            [-5.3049611254974165, -0.4942405445253805],
            [-5.305098280743035, -0.5021007526693245],
            [-5.306581169946755, -0.523380619862016],
            [-5.308977156127768, -0.5439348984873729],
            [-5.318764680161651, -0.6620148740578464],
            [-5.32175153351528, -0.6618020657104611],
            [-5.334502755862806, -0.8223284519008237],
            [-5.3363485243230055, -0.8421736373353386],
            [-5.456584078971108, -0.8327860652076534],
            [-5.592527768374616, -0.821675561362985],
            [-5.606928142469997, -0.8205761512743688],
            [-5.847320204785176, -0.8000421063390741],
            [-5.840467120823648, -0.7092964742403935],
            [-5.841859019450202, -0.708639037511736],
            [-5.841013783376655, -0.6931989435864998],
            [-5.834921633638449, -0.6200385784648048],
            [-5.833569682377963, -0.6201666861540579],
            [-5.8181662467230595, -0.4456924113973042],
            [-5.808672097772651, -0.3374873918701922],
            [-5.804627619180356, -0.2995785742769633],
            [-5.804389675014668, -0.29450723636150056]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.71651496714054,
          "lat": 37.90257910872236
        },
        "year": "2023",
        "ste_code": ["08"],
        "ste_name": ["Colorado"],
        "coty_code": ["08089"],
        "coty_name": ["Otero"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Otero County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "00198160"
      },
      "bbox": [
        -5.847320204785176, -0.8421736373353386, -5.284064903318246,
        -0.21062866822460447
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.991459177131954, -7.470374028573082],
            [9.992513176963932, -7.470287242027358],
            [10.015718860641094, -7.4683730149498],
            [10.110994860154202, -7.4622346598438005],
            [10.179847566014896, -7.457729325621546],
            [10.212942920458575, -7.45590573022403],
            [10.270265413231582, -7.452139766706247],
            [10.326061570282386, -7.449404102355674],
            [10.406189458158783, -7.442510188479222],
            [10.411149663721917, -7.442080828925933],
            [10.490318990170298, -7.436871580640386],
            [10.484788739978093, -7.439447409438933],
            [10.482759712352395, -7.442415906685],
            [10.477947840721443, -7.441194621217286],
            [10.47817055572843, -7.444863165221152],
            [10.474171356992395, -7.449401132292963],
            [10.472798932604396, -7.454159534349244],
            [10.475691452025835, -7.45644383230073],
            [10.479104149954926, -7.46234777683029],
            [10.476570001315313, -7.464788832152155],
            [10.47991501903591, -7.469988821204178],
            [10.480787366224167, -7.480804634183181],
            [10.477408926545154, -7.4891501351593535],
            [10.46956555545376, -7.498830275161537],
            [10.470556691751115, -7.500522261933876],
            [10.462510672110907, -7.5084245716836415],
            [10.459089640505043, -7.521849438857208],
            [10.45830456893335, -7.5292862794909405],
            [10.449754849220232, -7.529219254809317],
            [10.445571627989187, -7.53605964978174],
            [10.439815189358995, -7.537319182992525],
            [10.438932601181902, -7.542023027822448],
            [10.435958703244237, -7.5448636455183244],
            [10.430070149389977, -7.546576961290019],
            [10.42742742837906, -7.5489233064695895],
            [10.427143375094095, -7.55480402995168],
            [10.422409741885703, -7.557182680847044],
            [10.422640928013939, -7.560772155921362],
            [10.420611223235758, -7.567854077276347],
            [10.423566931843407, -7.571237669461869],
            [10.422346487412025, -7.575506200477349],
            [10.418150120521373, -7.578808723225597],
            [10.41691730507093, -7.582016546160925],
            [10.418138870757524, -7.586216722358239],
            [10.416277587876571, -7.59994265894981],
            [10.41972324545795, -7.604801620705411],
            [10.418294473473257, -7.609760246172187],
            [10.412698890471136, -7.619730804160172],
            [10.40848933792811, -7.622509145164759],
            [10.410019513295083, -7.630165563100324],
            [10.413210194149668, -7.637741953654902],
            [10.417311303749957, -7.641442980678908],
            [10.417339486767073, -7.648018597730643],
            [10.413069736128893, -7.651765561833244],
            [10.41340102550745, -7.656053757573226],
            [10.404822608178902, -7.6623486659269355],
            [10.39797671052187, -7.670184035784048],
            [10.393726837501312, -7.667840164658476],
            [10.391173429424269, -7.668651022073396],
            [10.385322269762526, -7.673997308072912],
            [10.382438492944782, -7.673459263079295],
            [10.377248209577553, -7.675518383416],
            [10.372607846840074, -7.674396293766854],
            [10.366654440517493, -7.681591044901225],
            [10.360094786348293, -7.678992664508865],
            [10.352594892970249, -7.681789322050442],
            [10.34875402418701, -7.680534373986647],
            [10.345064502243211, -7.68368457959966],
            [10.340726520301475, -7.680878681424787],
            [10.336404128136607, -7.680851665151664],
            [10.33398394694367, -7.688395776977749],
            [10.329787436806658, -7.691044021971054],
            [10.323931029567994, -7.692370395343214],
            [10.321165086497622, -7.690874786841468],
            [10.316231364003766, -7.692106565560622],
            [10.311037397406595, -7.6977974357904],
            [10.309659777144052, -7.703544299760737],
            [10.305741001864098, -7.705363451025009],
            [10.298745062478327, -7.7048923296291605],
            [10.29521492411889, -7.70606317613367],
            [10.293298996872794, -7.709060556838513],
            [10.278907496385639, -7.714382359286375],
            [10.276856887033995, -7.72215978216196],
            [10.269156966491478, -7.731887976060957],
            [10.260881354767545, -7.738305684605545],
            [10.25388537922658, -7.737761598468337],
            [10.246377327130244, -7.735820066775123],
            [10.241769911524845, -7.742515654644],
            [10.237171909891888, -7.742241040444438],
            [10.230970209482077, -7.745339074288209],
            [10.224104945851574, -7.7550588471915916],
            [10.214125711061982, -7.761184481773656],
            [10.215958662422453, -7.767296385979606],
            [10.19848003848144, -7.7698550638806765],
            [10.186737800151041, -7.771074163948749],
            [10.183341794703521, -7.742186054702392],
            [10.154635851398243, -7.745654688139422],
            [10.149530846122467, -7.703059320236223],
            [10.12619982392017, -7.705905347931533],
            [10.092357867318567, -7.710405501046534],
            [10.08480791563962, -7.652391103572202],
            [10.055973610321368, -7.655976779479361],
            [10.054086575087958, -7.641593662634889],
            [9.997068275647356, -7.648253341884434],
            [9.993066547856833, -7.619615130094929],
            [9.987991832286884, -7.576798124567083],
            [9.963403175513069, -7.579454247241057],
            [9.945934525361563, -7.580881477136683],
            [9.949488260905593, -7.574367232445232],
            [9.958934040524337, -7.5701697134053045],
            [9.96521573804653, -7.565538383571183],
            [9.967914427806138, -7.55912206201031],
            [9.966579895706285, -7.548572184653683],
            [9.968732380372021, -7.544120782106584],
            [9.973709220801624, -7.539439662175452],
            [9.975499944485348, -7.53412843024399],
            [9.975999705270777, -7.523764171013375],
            [9.980414858792548, -7.51654577925739],
            [9.987378954654773, -7.510430685838182],
            [9.991019415202734, -7.49880316246448],
            [9.995010863614743, -7.492005650563828],
            [9.998766871914155, -7.4826650703127475],
            [9.991459177131954, -7.470374028573082]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.61354542960495,
          "lat": 30.579475626048467
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12039"],
        "coty_name": ["Gadsden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Gadsden County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00306918"
      },
      "bbox": [
        9.945934525361563, -7.771074163948749, 10.490318990170298,
        -7.436871580640386
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.215958662422453, -7.767296385979606],
            [10.214125711061982, -7.761184481773656],
            [10.224104945851574, -7.7550588471915916],
            [10.230970209482077, -7.745339074288209],
            [10.237171909891888, -7.742241040444438],
            [10.241769911524845, -7.742515654644],
            [10.246377327130244, -7.735820066775123],
            [10.25388537922658, -7.737761598468337],
            [10.260881354767545, -7.738305684605545],
            [10.269156966491478, -7.731887976060957],
            [10.276856887033995, -7.72215978216196],
            [10.278907496385639, -7.714382359286375],
            [10.293298996872794, -7.709060556838513],
            [10.29521492411889, -7.70606317613367],
            [10.298745062478327, -7.7048923296291605],
            [10.305741001864098, -7.705363451025009],
            [10.309659777144052, -7.703544299760737],
            [10.311037397406595, -7.6977974357904],
            [10.316231364003766, -7.692106565560622],
            [10.321165086497622, -7.690874786841468],
            [10.323931029567994, -7.692370395343214],
            [10.329787436806658, -7.691044021971054],
            [10.33398394694367, -7.688395776977749],
            [10.336404128136607, -7.680851665151664],
            [10.340726520301475, -7.680878681424787],
            [10.345064502243211, -7.68368457959966],
            [10.34875402418701, -7.680534373986647],
            [10.352594892970249, -7.681789322050442],
            [10.360094786348293, -7.678992664508865],
            [10.366654440517493, -7.681591044901225],
            [10.372607846840074, -7.674396293766854],
            [10.377248209577553, -7.675518383416],
            [10.382438492944782, -7.673459263079295],
            [10.385322269762526, -7.673997308072912],
            [10.391173429424269, -7.668651022073396],
            [10.393726837501312, -7.667840164658476],
            [10.39797671052187, -7.670184035784048],
            [10.404822608178902, -7.6623486659269355],
            [10.41340102550745, -7.656053757573226],
            [10.413069736128893, -7.651765561833244],
            [10.417339486767073, -7.648018597730643],
            [10.417311303749957, -7.641442980678908],
            [10.413210194149668, -7.637741953654902],
            [10.410019513295083, -7.630165563100324],
            [10.40848933792811, -7.622509145164759],
            [10.412698890471136, -7.619730804160172],
            [10.418294473473257, -7.609760246172187],
            [10.41972324545795, -7.604801620705411],
            [10.416277587876571, -7.59994265894981],
            [10.418138870757524, -7.586216722358239],
            [10.41691730507093, -7.582016546160925],
            [10.418150120521373, -7.578808723225597],
            [10.422346487412025, -7.575506200477349],
            [10.423566931843407, -7.571237669461869],
            [10.420611223235758, -7.567854077276347],
            [10.422640928013939, -7.560772155921362],
            [10.422409741885703, -7.557182680847044],
            [10.427143375094095, -7.55480402995168],
            [10.42742742837906, -7.5489233064695895],
            [10.430070149389977, -7.546576961290019],
            [10.435958703244237, -7.5448636455183244],
            [10.438932601181902, -7.542023027822448],
            [10.439815189358995, -7.537319182992525],
            [10.445571627989187, -7.53605964978174],
            [10.449754849220232, -7.529219254809317],
            [10.45830456893335, -7.5292862794909405],
            [10.459089640505043, -7.521849438857208],
            [10.462510672110907, -7.5084245716836415],
            [10.470556691751115, -7.500522261933876],
            [10.46956555545376, -7.498830275161537],
            [10.477408926545154, -7.4891501351593535],
            [10.480787366224167, -7.480804634183181],
            [10.47991501903591, -7.469988821204178],
            [10.476570001315313, -7.464788832152155],
            [10.479104149954926, -7.46234777683029],
            [10.475691452025835, -7.45644383230073],
            [10.472798932604396, -7.454159534349244],
            [10.474171356992395, -7.449401132292963],
            [10.47817055572843, -7.444863165221152],
            [10.477947840721443, -7.441194621217286],
            [10.482759712352395, -7.442415906685],
            [10.484788739978093, -7.439447409438933],
            [10.490318990170298, -7.436871580640386],
            [10.518270196253502, -7.434610737632301],
            [10.62544432673048, -7.427443673252156],
            [10.640236010756974, -7.426830389653627],
            [10.660742266332962, -7.425274359898971],
            [10.692569422907969, -7.422909056292304],
            [10.726159123816904, -7.4207945629824845],
            [10.731585461479204, -7.46606509351881],
            [10.73388266676612, -7.482742314787685],
            [10.737014485971965, -7.486863205474435],
            [10.738491065512427, -7.492320126494762],
            [10.740475317615731, -7.494559703578507],
            [10.742483251540518, -7.507127465427721],
            [10.74715219066789, -7.511382785831284],
            [10.748126265034806, -7.519340213374535],
            [10.754291652538726, -7.528447575506161],
            [10.764280867486342, -7.53516443825082],
            [10.759278752413636, -7.539381263462796],
            [10.76115209258612, -7.546676607847828],
            [10.763481398380012, -7.549411625619585],
            [10.763780932999738, -7.555788302978596],
            [10.765862590550979, -7.557373672221066],
            [10.7696039491798, -7.5649937295299825],
            [10.716367378322518, -7.572473841787263],
            [10.721103735997577, -7.60986098475267],
            [10.723448991503137, -7.630248952052465],
            [10.69874975565139, -7.6623754526965495],
            [10.705574597152802, -7.720667470246467],
            [10.705870936143521, -7.72601678386452],
            [10.718169317583047, -7.820720461097944],
            [10.675942908666546, -7.825923678411024],
            [10.57634573551904, -7.837689868244132],
            [10.567212621758086, -7.809565976231663],
            [10.561839651959572, -7.81051940063702],
            [10.528594856272793, -7.814373855418119],
            [10.512278438465666, -7.816539468833557],
            [10.455285523631238, -7.823335195045484],
            [10.4553742255635, -7.824043285371787],
            [10.35168351620292, -7.83740008623202],
            [10.24242749523512, -7.85189999123569],
            [10.241959714920116, -7.852108619053059],
            [10.169186514783231, -7.8609145753727185],
            [10.172196787473634, -7.850583190650015],
            [10.176938882586727, -7.844244796676579],
            [10.177501321540545, -7.841078052843742],
            [10.174520574801658, -7.8387552404378695],
            [10.169717579168642, -7.837548289592247],
            [10.164100862578124, -7.831563953378397],
            [10.166350789128531, -7.826974326542934],
            [10.168896961288297, -7.826682279686382],
            [10.174368086289185, -7.8218412344621955],
            [10.173926967416417, -7.818434098420319],
            [10.187224738903126, -7.809052932172311],
            [10.186507164576122, -7.803454259530098],
            [10.189370506706718, -7.797196093688497],
            [10.188615879258107, -7.791220650742685],
            [10.190144247866154, -7.7904026548036525],
            [10.198256621764342, -7.793530033941798],
            [10.203372221019876, -7.78462734401625],
            [10.201509819168674, -7.783312905650596],
            [10.202459060376318, -7.778777391785953],
            [10.215958662422453, -7.767296385979606]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.27790704730327,
          "lat": 30.457992507302738
        },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12073"],
        "coty_name": ["Leon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Leon County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00306916"
      },
      "bbox": [
        10.164100862578124, -7.8609145753727185, 10.7696039491798,
        -7.4207945629824845
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.932696786378894, -7.763686126595817],
            [11.020528299819123, -7.752417315447048],
            [11.089398147980587, -7.743056168346631],
            [11.132299115697707, -7.73789913972509],
            [11.138851689481054, -7.7367306469032435],
            [11.232979333445483, -7.724113860356154],
            [11.238328555403191, -7.767325155592362],
            [11.268680741793858, -7.763513522410558],
            [11.274081972530976, -7.762163853039998],
            [11.325512748688658, -7.755733187257751],
            [11.333800886947298, -7.814053926178687],
            [11.334115965736121, -7.827898998689086],
            [11.341982320699708, -7.885451014462448],
            [11.35651254189168, -8.00622374715317],
            [11.371822841281444, -8.122277698093612],
            [11.387205625094765, -8.120315696169124],
            [11.396028882868308, -8.184750352844684],
            [11.4251918598322, -8.180480399207475],
            [11.430569829521435, -8.22402996184266],
            [11.428762889182096, -8.224419846031976],
            [11.426038875996303, -8.232236387570902],
            [11.422709846297417, -8.238506223022572],
            [11.422255112560675, -8.241571886935317],
            [11.418209709529153, -8.243262558885103],
            [11.415195902827692, -8.252858610363836],
            [11.41480928353035, -8.259030868890443],
            [11.412660134212192, -8.261212858255039],
            [11.41557703191764, -8.267179710000855],
            [11.412248527096084, -8.270891463728594],
            [11.415541261031475, -8.277492522391222],
            [11.414152385974267, -8.280973986799378],
            [11.415327282495687, -8.28924780882192],
            [11.412948036521996, -8.292234989216954],
            [11.41264577594454, -8.297970333982585],
            [11.414702091452321, -8.309077082530465],
            [11.40696288985038, -8.326974035022523],
            [11.404634672121745, -8.329851657090192],
            [11.407561703702664, -8.337049915530516],
            [11.40515086437483, -8.339902363413216],
            [11.399131525643739, -8.340448845001491],
            [11.391343137673951, -8.337841471581037],
            [11.387816120056867, -8.339010438740871],
            [11.38376363088382, -8.337057188366323],
            [11.379791490107948, -8.337452779410627],
            [11.37641277976044, -8.335477150910393],
            [11.367571657152034, -8.342125962327156],
            [11.362924408908258, -8.340650000974563],
            [11.35978979233238, -8.342476952813444],
            [11.354210374385788, -8.34279943684588],
            [11.350231341194272, -8.337859393313954],
            [11.34346000486701, -8.336369997370406],
            [11.336279797654429, -8.337547958007635],
            [11.33346618046055, -8.339815975362127],
            [11.32714336457623, -8.339458545512565],
            [11.323915046087244, -8.335854602213445],
            [11.305764461051028, -8.331159887666344],
            [11.301202531293018, -8.331114858730547],
            [11.299951863419812, -8.320961008795697],
            [11.296142853311393, -8.319704697334213],
            [11.292345632910754, -8.312152701049902],
            [11.288319657596656, -8.31326412495903],
            [11.285486372164854, -8.311617944991317],
            [11.290016111411264, -8.308138910298448],
            [11.280266787247742, -8.308384640420565],
            [11.275747696059351, -8.310286965855214],
            [11.27251033182464, -8.306641130795215],
            [11.26027041318047, -8.303577362168632],
            [11.24536448994469, -8.298530966171185],
            [11.240690858917697, -8.29921139211138],
            [11.240799133251521, -8.29506111440069],
            [11.233864311312027, -8.28707749254042],
            [11.228368959776063, -8.285885145140702],
            [11.226847805461396, -8.27988471886909],
            [11.220769786756104, -8.268499369614982],
            [11.214278544614983, -8.26753168581386],
            [11.209142615023355, -8.272240529867316],
            [11.205492697532772, -8.27341421866883],
            [11.203889494859665, -8.270737498866778],
            [11.205369430406067, -8.266217792902637],
            [11.208735965500818, -8.263130412585872],
            [11.200468774247918, -8.253667778854082],
            [11.197973585656163, -8.24966547930012],
            [11.202750567011654, -8.24500339375825],
            [11.20311258906969, -8.24020598550056],
            [11.19898107487734, -8.232375961084797],
            [11.195302646752685, -8.227968712794214],
            [11.19711014280994, -8.221317897299475],
            [11.19536797913533, -8.214365156784774],
            [11.191980982966578, -8.21233304803243],
            [11.188949150093961, -8.215587963181727],
            [11.186748530815438, -8.206451845929086],
            [11.180320347364269, -8.204795316235558],
            [11.180988275847078, -8.20209728039725],
            [11.17727365787416, -8.199287924449061],
            [11.17262963123273, -8.199603948970656],
            [11.17012329680118, -8.196739381619597],
            [11.165048817042898, -8.194931057923746],
            [11.163446574727155, -8.1898790759988],
            [11.15310743715668, -8.175394384372508],
            [11.148924104027884, -8.165512826835153],
            [11.14478972626208, -8.16346657226371],
            [11.144399649531993, -8.157255526574655],
            [11.142688563240844, -8.154131931742757],
            [11.128184760207892, -8.147436898694684],
            [11.119685411828792, -8.140729029923673],
            [11.113717361915763, -8.137967918154807],
            [11.110708079832754, -8.134571567742432],
            [11.105713315924607, -8.133424822678474],
            [11.101321264009114, -8.124006330129074],
            [11.098080295557823, -8.122563874862758],
            [11.094331319735122, -8.124320451554441],
            [11.086320083712245, -8.119682453762477],
            [11.07323194172752, -8.11594112868141],
            [11.067728236086765, -8.112683311587928],
            [11.058380965743636, -8.110155116437404],
            [11.047633044147048, -8.10330007903906],
            [11.04038683463897, -8.095617504145208],
            [11.037601994157328, -8.094945617099773],
            [11.035288323578477, -8.098413244365275],
            [11.026531860544958, -8.094403786245863],
            [11.021110441250203, -8.087800652852875],
            [11.015308195000351, -8.08859488052339],
            [11.013237463758625, -8.084693890770062],
            [11.008973056847738, -8.085314764843925],
            [11.007103173068119, -8.0821873591267],
            [11.001526797001704, -8.081458784837917],
            [10.995653889442115, -8.083445920678868],
            [10.989501591353022, -8.08238045528208],
            [10.98525544979562, -8.083809213715913],
            [10.980431245582226, -8.079218817755498],
            [10.974226868085198, -8.077747193441313],
            [10.972284008469787, -8.080026627465204],
            [10.966437983540025, -8.079738855968142],
            [10.950174524538257, -8.066940100471248],
            [10.937775676992628, -8.061828228594807],
            [10.933881196248896, -8.059229455782887],
            [10.923965678555183, -8.057218588336752],
            [10.888135882262825, -8.043912709757425],
            [10.887105592639656, -8.040484398047298],
            [10.881543404993543, -8.039131664305492],
            [10.876951290083815, -8.039755558748709],
            [10.868993820555783, -8.03418176707001],
            [10.870144982711533, -8.031015105133555],
            [10.863213868435288, -8.025969525379365],
            [10.859032276719507, -8.025822097998796],
            [10.856928494619817, -8.02185722242639],
            [10.852679630326334, -8.023994657496605],
            [10.851349209416123, -8.01893959532573],
            [10.843673528008397, -8.01360151379361],
            [10.83684876884322, -8.013641430015172],
            [10.834504178542144, -8.009290483667156],
            [10.830792821622525, -8.007666236184752],
            [10.822454536559542, -8.008140541491771],
            [10.816716738258645, -8.004259122297118],
            [10.818580796860738, -7.9971211972926834],
            [10.813826489952307, -7.996292942681529],
            [10.811856917191509, -7.986359807939733],
            [10.814523154941163, -7.978627664706213],
            [10.817200971971491, -7.977091166708759],
            [10.819261750388065, -7.97143390337977],
            [10.819507328167866, -7.963320938134944],
            [10.820858971450628, -7.958351323229284],
            [10.823587177477032, -7.954440767061524],
            [10.82689462663683, -7.943873737749147],
            [10.823872245672046, -7.941857231645908],
            [10.821775994564897, -7.935710827589206],
            [10.831352745277542, -7.928967600429301],
            [10.829184546178382, -7.922570099372691],
            [10.83300548090291, -7.9178856604283245],
            [10.8321861573631, -7.905628121094118],
            [10.836561746276907, -7.898223118350795],
            [10.835498453758232, -7.893327398759479],
            [10.843725955801473, -7.886480105168927],
            [10.855498353782998, -7.886191771633921],
            [10.857011174741961, -7.873843254333207],
            [10.855016112437855, -7.872559508340534],
            [10.858398740102578, -7.863376134160819],
            [10.860349582198905, -7.861654907257175],
            [10.858957912978454, -7.856747119043882],
            [10.860524227751648, -7.853018050964401],
            [10.856184359991502, -7.846876937527799],
            [10.858632334798365, -7.8449746189337475],
            [10.859204634534642, -7.834475204328991],
            [10.858614602494889, -7.831290905273883],
            [10.862956004483177, -7.828447208568373],
            [10.866072876570191, -7.828727466020801],
            [10.873333020375133, -7.822682104342846],
            [10.873168699007106, -7.818356252733399],
            [10.876464215559185, -7.813631372205001],
            [10.884001094209205, -7.808457733007276],
            [10.886739171433362, -7.80393397993114],
            [10.891788612225378, -7.803601502558517],
            [10.907371290012286, -7.796412653499483],
            [10.90742793623145, -7.793437802574923],
            [10.91496981581682, -7.7920720592971024],
            [10.920044557624115, -7.788456596915078],
            [10.9233100013302, -7.781729364590435],
            [10.926812064104965, -7.780124940396212],
            [10.926436908457037, -7.776248230730908],
            [10.928763277211779, -7.770642802499816],
            [10.933165237955919, -7.7675021118915275],
            [10.932696786378894, -7.763686126595817]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.60353788018838, "lat": 30.04703448472064 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12123"],
        "coty_name": ["Taylor"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Taylor County"],
        "coty_fp_code": "123",
        "coty_gnis_code": "00295728"
      },
      "bbox": [
        10.811856917191509, -8.34279943684588, 11.430569829521435,
        -7.724113860356154
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [12.119508453508118, -7.7709268081028],
            [12.131839812600457, -7.767532314138195],
            [12.2037155509721, -7.756061775894874],
            [12.20345337323428, -7.754347916128448],
            [12.265215351397952, -7.744785433221805],
            [12.32594053553437, -7.735052360625606],
            [12.329104796103213, -7.734765822933247],
            [12.388440059157205, -7.725563335150074],
            [12.38685105188756, -7.730921430625418],
            [12.387392686146217, -7.7368278724935005],
            [12.391667251123637, -7.735517945509404],
            [12.394466981762449, -7.739022708101522],
            [12.394378838015886, -7.743940540759009],
            [12.39251704895852, -7.751861071697851],
            [12.389189680767707, -7.758680766899655],
            [12.37145312626268, -7.772069765674305],
            [12.368995437025793, -7.780412784039005],
            [12.368394787915415, -7.796536598395782],
            [12.367134944789946, -7.800748665997545],
            [12.362312097796156, -7.807838305113001],
            [12.345932748568472, -7.822374450506495],
            [12.342597696868221, -7.8292705124263],
            [12.33926532208355, -7.830795187828099],
            [12.338842276969272, -7.8343686297493855],
            [12.333207673516837, -7.842711961837104],
            [12.32025446659633, -7.849500812640223],
            [12.31833526663033, -7.848775705343023],
            [12.311156243577273, -7.852038907119526],
            [12.304719787576582, -7.853013507052425],
            [12.300348352315076, -7.871665500676824],
            [12.297736593295397, -7.875403899099448],
            [12.297542467731086, -7.882958402267941],
            [12.295216306549596, -7.887068155758049],
            [12.291411365280647, -7.898196132121268],
            [12.28602525212416, -7.908079912958836],
            [12.278375408452197, -7.9176660306136],
            [12.27642232059668, -7.9269281875029405],
            [12.27446048856819, -7.929447123617924],
            [12.264806457353464, -7.932487597904933],
            [12.259277187656743, -7.9320750772192],
            [12.252433177152335, -7.928985729665715],
            [12.243635392032322, -7.928931706759096],
            [12.241987956511013, -7.933411148129835],
            [12.243693012367883, -7.9384559045228436],
            [12.23913538512492, -7.9532102504246724],
            [12.2321759484256, -7.958396278629269],
            [12.223764129397834, -7.957538387257149],
            [12.217683824447006, -7.960509980793096],
            [12.212637115872987, -7.966346001439944],
            [12.207708192119583, -7.96964287868647],
            [12.198311398256696, -7.969598010874585],
            [12.195762817341961, -7.971641069353178],
            [12.19186849437825, -7.970421840482794],
            [12.185475336031283, -7.972460851290671],
            [12.183810959436904, -7.975534128967255],
            [12.181116351133847, -7.97909255162002],
            [12.177146045363628, -7.977481918276492],
            [12.170389539896767, -7.97126453020756],
            [12.16493767741925, -7.970319841788746],
            [12.163254198597185, -7.9724330048553105],
            [12.156711681700523, -7.970956940060621],
            [12.155457769934053, -7.975987028000811],
            [12.150647010752113, -7.975771428683819],
            [12.146124222996479, -7.972355252613621],
            [12.137549949248967, -7.978653589290262],
            [12.131700143349383, -7.971126129571205],
            [12.125049016068644, -7.967225676413622],
            [12.119841337401729, -7.968673872297853],
            [12.112371683815113, -7.9685575229665275],
            [12.101614335743545, -7.965060536158949],
            [12.097196262761567, -7.967532112702128],
            [12.09035476418325, -7.966605989939679],
            [12.086172226153494, -7.9715759791234095],
            [12.083901541956115, -7.964354750453916],
            [12.084379036380941, -7.961187066428658],
            [12.08062002775798, -7.954860711837152],
            [12.071086012795945, -7.951155050412569],
            [12.06519484210782, -7.952657387830017],
            [12.060965725701834, -7.952009250919538],
            [12.059094361855662, -7.947481526706792],
            [12.047446769785456, -7.942894659524241],
            [12.046195377696108, -7.938642718178803],
            [12.042383408235178, -7.934592156501171],
            [12.042605029871677, -7.931795953468617],
            [12.039459867183533, -7.928119935575727],
            [12.041217105143815, -7.925519987056451],
            [12.041453762592, -7.9160014274234],
            [12.039264249853023, -7.911523532702118],
            [12.040440093289863, -7.908102846560027],
            [12.047359872371583, -7.901695060680609],
            [12.051137081313685, -7.901625205114384],
            [12.05496879077687, -7.8979727030905815],
            [12.061923009351098, -7.895769290551271],
            [12.068357943409596, -7.889523685402399],
            [12.069545110990939, -7.884112055479312],
            [12.064509303105302, -7.88057410902524],
            [12.063498581986346, -7.871240325855879],
            [12.065486375483063, -7.863863865406883],
            [12.0651396719829, -7.860188097801802],
            [12.076206842339761, -7.837633988090481],
            [12.081547400261725, -7.8318103437863495],
            [12.088344641037343, -7.827368998916691],
            [12.091485748722096, -7.82263436005228],
            [12.099139787895501, -7.820663731155233],
            [12.106646816675287, -7.815086637654568],
            [12.116733043829143, -7.810890073959759],
            [12.123656367377915, -7.805284611577373],
            [12.125931592180502, -7.800948507256329],
            [12.126293133087112, -7.782553194909459],
            [12.120660667445824, -7.7782402553764545],
            [12.119508453508118, -7.7709268081028]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.37138863948607, "lat": 30.04390008683947 },
        "year": "2023",
        "ste_code": ["12"],
        "ste_name": ["Florida"],
        "coty_code": ["12125"],
        "coty_name": ["Union"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Union County"],
        "coty_fp_code": "125",
        "coty_gnis_code": "00306913"
      },
      "bbox": [
        12.039264249853023, -7.97909255162002, 12.394466981762449,
        -7.725563335150074
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.633837579126029, -6.439708633491747],
            [9.662266525605178, -6.437138247478769],
            [9.665685807517212, -6.437157980155772],
            [9.69043163410804, -6.434638961822204],
            [9.691215639473791, -6.442207120132368],
            [9.73105211230224, -6.438106617161164],
            [9.730222175979842, -6.430265314409686],
            [9.787408970288315, -6.424667207934412],
            [9.794339777863454, -6.488648593735886],
            [9.80270215748379, -6.487655491591117],
            [9.806264443871694, -6.520884054489184],
            [9.81404630518499, -6.520038962852129],
            [9.814849463084247, -6.5275472237660885],
            [9.82296293001755, -6.5265844903777985],
            [9.824637680400373, -6.543350354112401],
            [9.81522568232051, -6.544316144818688],
            [9.819658114856809, -6.5808474229741565],
            [9.886181127755442, -6.572730536631205],
            [9.924392806068045, -6.567511511963917],
            [9.926354539251856, -6.585169273611343],
            [9.917992003797897, -6.586231095052587],
            [9.91900039612955, -6.595554469305269],
            [9.927267232674131, -6.593888199702323],
            [9.93029051480283, -6.621099470210866],
            [9.94658479783015, -6.619663851767186],
            [9.93831067334148, -6.629444451312462],
            [9.939238975264225, -6.6381661064455],
            [9.93194341932093, -6.638812003994043],
            [9.933422532555896, -6.6556972093182845],
            [9.941488940816624, -6.654835289231833],
            [9.94295385538256, -6.666590926632655],
            [9.945147736698997, -6.670919150565296],
            [9.935066999467097, -6.672105039080895],
            [9.936712111987424, -6.685155134595584],
            [9.890173115098113, -6.690227483708372],
            [9.883259500801127, -6.690674183553179],
            [9.837750580112203, -6.695317606351692],
            [9.832918039527499, -6.696981963646505],
            [9.82138144745855, -6.704048277378341],
            [9.819549838356814, -6.707272132167814],
            [9.809276654920321, -6.703905541580232],
            [9.803584835211034, -6.710227851054753],
            [9.797677695305236, -6.713735685388186],
            [9.788769325544793, -6.716307832461911],
            [9.784672112855844, -6.716253929459202],
            [9.78099176228894, -6.718659117259231],
            [9.761815411834426, -6.720668788665463],
            [9.757855201858357, -6.688510769144457],
            [9.751301154439401, -6.69193440339506],
            [9.749440535146627, -6.690360659233889],
            [9.744502459545762, -6.691485457765414],
            [9.744858614145182, -6.687651310219742],
            [9.741921730176566, -6.685135070676572],
            [9.74173578748193, -6.680217497899116],
            [9.744534703847766, -6.6733413413737015],
            [9.745281236228177, -6.667445881627422],
            [9.743660413693995, -6.662646829962586],
            [9.73556209072228, -6.653942088482505],
            [9.732950700736328, -6.646874067751094],
            [9.727794363167602, -6.639484723695298],
            [9.729328669584774, -6.633031344936328],
            [9.72590766592549, -6.626799668132795],
            [9.725073202341363, -6.6172032257749605],
            [9.725505218700507, -6.6052699269178206],
            [9.721298465549081, -6.602694540208397],
            [9.722692858856032, -6.592091089524659],
            [9.720599932565992, -6.589225545265439],
            [9.713372600139316, -6.586490463349858],
            [9.707653908642188, -6.582828573931993],
            [9.701591205104801, -6.576193077978113],
            [9.6975745899728, -6.574485348896147],
            [9.696426320489191, -6.569520462381988],
            [9.698152524358049, -6.563030981267728],
            [9.701161865625354, -6.5613613473153745],
            [9.699558160293158, -6.557927794389862],
            [9.688491135061923, -6.554496819781917],
            [9.67216681716903, -6.538790394043919],
            [9.667299634378459, -6.529905972642253],
            [9.659724317194465, -6.52635227622656],
            [9.656606621314289, -6.522992130590153],
            [9.653907413176082, -6.509238751802612],
            [9.653265709710777, -6.501478420848916],
            [9.656195719364748, -6.49511705518342],
            [9.657836391033511, -6.484985100166565],
            [9.65192125919462, -6.470693081657049],
            [9.646190207408202, -6.460197558771037],
            [9.647684587396748, -6.456342798270544],
            [9.64746040048309, -6.449805418596528],
            [9.633837579126029, -6.439708633491747]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.98009394417859, "lat": 31.62624000584455 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13061"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "00344805"
      },
      "bbox": [
        9.633837579126029, -6.720668788665463, 9.94658479783015,
        -6.424667207934412
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.473535845910003, -6.809374958964413],
            [11.537381831232556, -6.8003455811684566],
            [11.540326489212276, -6.817439209280609],
            [11.561528540042914, -6.966734326057373],
            [11.570117734885692, -7.031286338175827],
            [11.580430688407375, -7.1106698260339956],
            [11.570866020431758, -7.109108609500011],
            [11.565992899988863, -7.117639152347417],
            [11.562504551924025, -7.1217661296358346],
            [11.560249760455346, -7.1213399424266],
            [11.551491491143736, -7.124923506022271],
            [11.548266722229712, -7.137525821307509],
            [11.542382125123694, -7.135895909090785],
            [11.537109418989452, -7.13404559803264],
            [11.537427713673942, -7.126870093596643],
            [11.535123222623076, -7.124828902089462],
            [11.536296522380857, -7.1197794760330275],
            [11.536502046733567, -7.111423603572965],
            [11.535313243164698, -7.108059995716687],
            [11.536579193651642, -7.104226039850031],
            [11.532877983781587, -7.099018057277224],
            [11.53560063940598, -7.095425342443127],
            [11.533163630384783, -7.0898328560231265],
            [11.534385745492584, -7.084843305098341],
            [11.52559501149884, -7.076518217026678],
            [11.526362224860979, -7.07205365727588],
            [11.518929647553687, -7.072235536352025],
            [11.51953410625894, -7.0690208156878],
            [11.517571040202752, -7.06447201232898],
            [11.514079503430073, -7.061923536134273],
            [11.517033304512253, -7.058311396948981],
            [11.514495189620657, -7.052985704810069],
            [11.510790726435285, -7.051547073449126],
            [11.50911002560782, -7.042141798589127],
            [11.432334392620653, -7.050834361314507],
            [11.393043117737951, -7.055014019545562],
            [11.385203993136441, -7.000265645868371],
            [11.381898272394391, -6.980804556315956],
            [11.367222983666394, -6.982863311362687],
            [11.362345294328675, -6.946536100511984],
            [11.38813702332514, -6.94289649994914],
            [11.38792430495172, -6.9398308608724815],
            [11.3813341504411, -6.878514597211741],
            [11.378622560547496, -6.85892073818791],
            [11.485877059632216, -6.844875504156576],
            [11.483273030692194, -6.837265440719978],
            [11.483493772496251, -6.831530819269896],
            [11.480172186760017, -6.828163131432754],
            [11.48149179507187, -6.824170163836779],
            [11.477006898435603, -6.822167501736027],
            [11.471695049033082, -6.812696823500638],
            [11.473535845910003, -6.809374958964413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.0627492428193, "lat": 31.037950637418756 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13173"],
        "coty_name": ["Lanier"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lanier County"],
        "coty_fp_code": "173",
        "coty_gnis_code": "00348102"
      },
      "bbox": [
        11.362345294328675, -7.137525821307509, 11.580430688407375,
        -6.8003455811684566
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [10.335616923578627, -3.3832172749470355],
            [10.339953648520138, -3.378600639730234],
            [10.348890672780792, -3.3780623306243096],
            [10.34954208011717, -3.37452104544016],
            [10.355326249601886, -3.372866547055205],
            [10.355659032439457, -3.360869398525113],
            [10.358271456334817, -3.358802106671863],
            [10.357596218613901, -3.3548231822565535],
            [10.354437501975898, -3.349475691479921],
            [10.350824817725213, -3.3369042210252107],
            [10.351273510778892, -3.331893582815171],
            [10.353059369695444, -3.3287053866965612],
            [10.35310541413185, -3.3238164321173693],
            [10.357830158273103, -3.319062546188567],
            [10.364556324539828, -3.314542894604366],
            [10.388047425625917, -3.3047007676459508],
            [10.417309329200188, -3.2922856250117176],
            [10.43277966589125, -3.2936352172374908],
            [10.440112848067313, -3.2968766542212555],
            [10.443032442626173, -3.299469171102606],
            [10.455734465548753, -3.2954185432000744],
            [10.458823974243067, -3.2896190747807883],
            [10.464165582023172, -3.2861172846619477],
            [10.466760779617006, -3.2864019685957713],
            [10.47007586000311, -3.2910355425617723],
            [10.472874499204227, -3.2973717405879945],
            [10.478217695686036, -3.296777477590452],
            [10.488815588780662, -3.3043304476006514],
            [10.494588851226315, -3.3076384763306415],
            [10.499228473418475, -3.31170219006436],
            [10.504603477053276, -3.31008683953763],
            [10.509469215751093, -3.3114818533345147],
            [10.509914036669208, -3.3148755845902245],
            [10.514705742287225, -3.3182089446928402],
            [10.515246878075782, -3.3210824235349645],
            [10.51238038385368, -3.3280559655637085],
            [10.516259657081097, -3.334452561456364],
            [10.519487121145131, -3.3352489872408877],
            [10.519073602531234, -3.3414958058833895],
            [10.522615215875982, -3.3484437751755207],
            [10.52215829597923, -3.351853625681332],
            [10.517999838877797, -3.355240620632782],
            [10.516832051641295, -3.3613826451659894],
            [10.5125738554162, -3.372190650718997],
            [10.513108163702272, -3.3756098574125923],
            [10.516419953689349, -3.382748111224462],
            [10.515682195544752, -3.4028273765500923],
            [10.512694589147259, -3.4038060715523697],
            [10.5121116023669, -3.414480198533667],
            [10.50681249300883, -3.4201470346991005],
            [10.503666951272391, -3.4249865980036915],
            [10.50034120923169, -3.425613897957693],
            [10.50326385619645, -3.4353848391431017],
            [10.505416861239766, -3.434759125484718],
            [10.508668468221419, -3.4396049390588854],
            [10.51309309324, -3.4420362716834765],
            [10.516291119532177, -3.446083906861388],
            [10.5164409160508, -3.4493396460678754],
            [10.52511010587234, -3.459992792361507],
            [10.524782419315898, -3.4669594986075665],
            [10.519738836947846, -3.471016720110744],
            [10.52278852088357, -3.4819309238625222],
            [10.528729580950266, -3.4894481476299415],
            [10.530399371770322, -3.5026681009239247],
            [10.535630844707017, -3.509112309161376],
            [10.534322053745349, -3.5108785839644794],
            [10.540014882390228, -3.51422683646329],
            [10.540198401515196, -3.517202744996719],
            [10.545968093991313, -3.521369688855007],
            [10.548511565095364, -3.5246104235404796],
            [10.549556639526488, -3.5307525541690907],
            [10.552252415061638, -3.5338575508570393],
            [10.546624218563004, -3.5402174607447328],
            [10.546669694127285, -3.5441570461406844],
            [10.542467033521497, -3.5460061069953777],
            [10.540395561250598, -3.548862322129682],
            [10.541991804395233, -3.552595203872094],
            [10.535004325865739, -3.557524920961427],
            [10.531668399071384, -3.5630724441497845],
            [10.528124679060161, -3.56463158297884],
            [10.52334143018632, -3.569796010170716],
            [10.51945444572153, -3.571185316442696],
            [10.516839269617753, -3.5775866499600033],
            [10.51780529881851, -3.581481947370345],
            [10.445673371548889, -3.5899994634426573],
            [10.427434225074116, -3.591986245920522],
            [10.42636318530919, -3.5830963859966545],
            [10.417395508667072, -3.5838474123250497],
            [10.418703529469164, -3.593156117647386],
            [10.374077106160238, -3.5981465143492675],
            [10.37303174779862, -3.5882755649413984],
            [10.375733771288541, -3.584636865690807],
            [10.377523903821789, -3.57940477655468],
            [10.38030208576548, -3.5790570464568665],
            [10.379199234864446, -3.570288707105103],
            [10.370307178304492, -3.571339254924291],
            [10.369173729624297, -3.5623190482349734],
            [10.361097308942442, -3.5633299086770074],
            [10.359937344040388, -3.55410903657495],
            [10.351225527846916, -3.555327277420463],
            [10.342876795687143, -3.4904648273938856],
            [10.3361186079367, -3.491284892832003],
            [10.334128927741677, -3.483557880590232],
            [10.330699623794866, -3.4778037899671035],
            [10.333435305518384, -3.476240071925221],
            [10.331144715263711, -3.470542033293709],
            [10.334377041946768, -3.466904648971316],
            [10.330870573284631, -3.4600797271215495],
            [10.331523599994254, -3.4493969840852134],
            [10.327452153148991, -3.446964615650168],
            [10.328464829666704, -3.443177058394024],
            [10.331084445096527, -3.4419364914579083],
            [10.330859107818279, -3.4382576748457345],
            [10.327186788098302, -3.434018757507149],
            [10.327696584939558, -3.4239088678159972],
            [10.334190552682003, -3.4174948452867615],
            [10.332950424165508, -3.4155238239752057],
            [10.335700205522588, -3.4087784026629113],
            [10.333607518527977, -3.4052920158529036],
            [10.336503226764876, -3.4009631509972875],
            [10.334649411192869, -3.39805499675596],
            [10.33432391541627, -3.3897753910837327],
            [10.335616923578627, -3.3832172749470355]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.74713830649507, "lat": 34.64647723268628 },
        "year": "2023",
        "ste_code": ["13"],
        "ste_name": ["Georgia"],
        "coty_code": ["13311"],
        "coty_name": ["White"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["White County"],
        "coty_fp_code": "311",
        "coty_gnis_code": "00326781"
      },
      "bbox": [
        10.327186788098302, -3.5981465143492675, 10.552252415061638,
        -3.2861172846619477
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-13.88293731365753, 7.0042412763690685],
            [-13.842295470101147, 6.995506494476842],
            [-13.843045991465088, 6.991915062896308],
            [-13.812810473186712, 6.9856348920579565],
            [-13.811812031236379, 6.9869427700083495],
            [-13.814408784716578, 6.992821735945896],
            [-13.812585275726326, 7.00291691051291],
            [-13.813715967149577, 7.0081040910113614],
            [-13.811790626319915, 7.013193391596102],
            [-13.80756676588539, 7.015374531546269],
            [-13.808404572617032, 7.019468205053469],
            [-13.804950866803482, 7.027789758892948],
            [-13.80194717462934, 7.031508120218521],
            [-13.802946758905868, 7.033461682508719],
            [-13.795769817991403, 7.044827192822091],
            [-13.792211577594918, 7.058403345209481],
            [-13.789949795989783, 7.060590172763148],
            [-13.787570635658376, 7.070454816017326],
            [-13.74143662203275, 7.060719922018935],
            [-13.741547134934567, 7.059777240597946],
            [-13.68180120050165, 7.047146933921939],
            [-13.587857379484552, 7.027472180399712],
            [-13.493918165682361, 7.007774899652001],
            [-13.380556930775544, 6.983938066752168],
            [-13.375818813447884, 6.990128703964541],
            [-13.369090016365776, 6.98963203208623],
            [-13.36818880737938, 6.9804736243528565],
            [-13.36306982063688, 6.977764685461096],
            [-13.35450200000796, 6.984514389000346],
            [-13.346254962585391, 6.979678556077339],
            [-13.345621426071423, 6.9827675924029755],
            [-13.334966003851974, 6.982252789515854],
            [-13.32765794194832, 6.986040007445272],
            [-13.324284734776402, 6.985353384328808],
            [-13.322388296884741, 6.991889666279095],
            [-13.316495637548645, 6.995043701846706],
            [-13.311124692143364, 6.996310498200392],
            [-13.30839924091817, 7.000695293463569],
            [-13.301569421601007, 6.999842566993319],
            [-13.296266744723885, 6.995182621170833],
            [-13.2954610101703, 6.990513859336503],
            [-13.292488212265281, 6.990462163728179],
            [-13.291287985750186, 6.996499937228064],
            [-13.285608524067875, 6.996598988564681],
            [-13.282737213639038, 6.9988743189736535],
            [-13.27953586626494, 7.005227829857355],
            [-13.27790249407103, 7.010945460583838],
            [-13.278716899915478, 7.01301068658526],
            [-13.275774349343454, 7.017362433130402],
            [-13.270115403067965, 7.0177582810208845],
            [-13.266893820881553, 7.021808914569448],
            [-13.255691399461913, 7.025585947684249],
            [-13.250044604638182, 7.026721619085675],
            [-13.248615557691682, 7.0347106841918325],
            [-13.245050050174871, 7.036130786190852],
            [-13.244874361857716, 7.042620007344586],
            [-13.243571841810134, 7.048306975604222],
            [-13.24690523528471, 7.051394769213534],
            [-13.24601387618231, 7.055604703187464],
            [-13.241097508329261, 7.057887051983632],
            [-13.244714411765862, 7.065883588465869],
            [-13.242694806723385, 7.068345735621257],
            [-13.237823718880142, 7.070383181245123],
            [-13.235131633776307, 7.067514668187413],
            [-13.231428240493306, 7.066651554621456],
            [-13.224524667081255, 7.07011305622556],
            [-13.219481865822832, 7.068416539588686],
            [-13.217714500195044, 7.065359021206832],
            [-13.207828746802795, 7.059410041655612],
            [-13.207228367723475, 7.057265120864277],
            [-13.201672138339752, 7.052991810485179],
            [-13.201816576310218, 7.048051101756692],
            [-13.199840197234336, 7.037618336731752],
            [-13.195503379793733, 7.035419858709521],
            [-13.19035548183214, 7.02605837462127],
            [-13.187232091236279, 7.026281891946254],
            [-13.185450241332527, 7.023325997008426],
            [-13.176043311594768, 7.0189446769573305],
            [-13.175761678981413, 7.014951403727811],
            [-13.177328603607553, 7.010303304103505],
            [-13.177628538750202, 7.004645848633926],
            [-13.172817781164696, 7.001031408448221],
            [-13.17272086580794, 7.007488363049032],
            [-13.170609500730492, 7.011977881464906],
            [-13.167634419377237, 7.014023209939993],
            [-13.165275894464536, 7.011666952392386],
            [-13.156782027712447, 7.011631875577604],
            [-13.15158228255628, 7.006720548876531],
            [-13.152182219400764, 6.990679591563793],
            [-13.149629536579456, 6.985289568527211],
            [-13.145522314027044, 6.983985073686536],
            [-13.137299476840319, 6.986980686991201],
            [-13.129509697612631, 6.994676354570247],
            [-13.127624188867177, 6.990695301622023],
            [-13.12748961844362, 6.984161389830423],
            [-13.125105599656205, 6.980100495941881],
            [-13.124727083756568, 6.971981372763625],
            [-13.127548787981326, 6.966881334386173],
            [-13.12591255404181, 6.959244360512642],
            [-13.129278649249523, 6.955309391641087],
            [-13.127459334724755, 6.949177704784738],
            [-13.124436764168028, 6.945567359627178],
            [-13.12439462293372, 6.9413461063877016],
            [-13.128056709519823, 6.936558984785939],
            [-13.133559555068443, 6.93644985770156],
            [-13.138892571382959, 6.9345299831908065],
            [-13.137280046258256, 6.924141959336704],
            [-13.138402296384845, 6.919546648578546],
            [-13.134820280137285, 6.911587416813261],
            [-13.139871245514568, 6.9054287958077865],
            [-13.14044704311591, 6.90168383800502],
            [-13.131215245745215, 6.893534639968334],
            [-13.126148415220603, 6.886047096992081],
            [-13.116520821828086, 6.886024496670249],
            [-13.11322161134454, 6.883163624618135],
            [-13.112000901211323, 6.876770485555646],
            [-13.108814059978272, 6.870602414472081],
            [-13.104912508079074, 6.86698475733526],
            [-13.105178610069068, 6.861213688056639],
            [-13.099877654114156, 6.861240222977962],
            [-13.097702188355864, 6.863188121515971],
            [-13.091541989307506, 6.860835630569621],
            [-13.086045153496952, 6.863545825276172],
            [-13.082492267696658, 6.859427846605876],
            [-13.076817269085117, 6.849500186055847],
            [-13.07338685125616, 6.847827811138415],
            [-13.066450146011393, 6.848521119808019],
            [-13.062393196247088, 6.841839738022233],
            [-13.053573719378395, 6.840454262645545],
            [-13.049413150392775, 6.835132322983631],
            [-13.04988183570628, 6.828924471533519],
            [-13.048543738516717, 6.8275805097798195],
            [-13.04730055191041, 6.820344641118854],
            [-13.054525912518393, 6.811163647672853],
            [-13.057777149991583, 6.808269734504853],
            [-13.066502492040012, 6.806124510163949],
            [-13.072007420593172, 6.806096979645107],
            [-13.072303460125536, 6.803650596961198],
            [-13.068943351468354, 6.795644733556439],
            [-13.062217655585208, 6.79182153203662],
            [-13.06120799765706, 6.78518545769681],
            [-13.058238744811582, 6.778870324481126],
            [-13.053734493881056, 6.776192119998541],
            [-13.049633433563033, 6.777490394963096],
            [-13.045660423691732, 6.7745303298475505],
            [-13.041778463044638, 6.774143779723203],
            [-13.043230866664143, 6.7678833631804265],
            [-13.046132987560753, 6.7635493489103595],
            [-13.055586475831177, 6.756783069176328],
            [-13.064208267113534, 6.759633840305815],
            [-13.065143010313257, 6.756470728638893],
            [-13.068754317939701, 6.753594701265846],
            [-13.072369082829024, 6.753609385122484],
            [-13.075993405322127, 6.750636564559762],
            [-13.076245599383443, 6.744002342637897],
            [-13.082297281381033, 6.743487755323606],
            [-13.08684781446334, 6.7361022442054255],
            [-13.087422991230817, 6.730256718056791],
            [-13.0897067100433, 6.723608520283105],
            [-13.08539473690143, 6.713091171389518],
            [-13.086606752639154, 6.709444315330043],
            [-13.082852227104928, 6.708273338334525],
            [-13.082283183939115, 6.703488253199357],
            [-13.076918730485273, 6.699012133804195],
            [-13.073837321603852, 6.698709675341183],
            [-13.070200488571869, 6.695548428423713],
            [-13.06596022660581, 6.693930853680859],
            [-13.058348594190868, 6.699857798734667],
            [-13.0575313506334, 6.693265822699564],
            [-13.055290782171083, 6.689431439742109],
            [-13.051574462222218, 6.6878887213549785],
            [-13.050816179202124, 6.678084521141567],
            [-13.056162582092483, 6.6705113099447],
            [-13.055063563261278, 6.666836201870697],
            [-13.049100214237024, 6.660717618210282],
            [-13.044072292809522, 6.657755497813138],
            [-13.046428558142582, 6.653540973449099],
            [-13.046734439852798, 6.649714921503528],
            [-13.054358881790698, 6.647688116165637],
            [-13.062274747276037, 6.638768908254673],
            [-13.063827987850285, 6.634229015191181],
            [-13.066679225801437, 6.632863614208713],
            [-13.066986414073094, 6.629440202875364],
            [-13.071475208396016, 6.629412490545712],
            [-13.077525218403132, 6.633010709920378],
            [-13.081853887636555, 6.632534370324464],
            [-13.086164048300024, 6.637052718995254],
            [-13.094605296311386, 6.639372427249716],
            [-13.098911891713882, 6.6439601987170525],
            [-13.106781716492016, 6.637236821622825],
            [-13.111425048362364, 6.637751655798348],
            [-13.113231634656925, 6.635189211301401],
            [-13.117881298328914, 6.636096428241882],
            [-13.122700079302703, 6.6315367358676465],
            [-13.126961529506003, 6.635746169882756],
            [-13.124839387664224, 6.644939376259409],
            [-13.127054840829787, 6.647019030410772],
            [-13.132733467812287, 6.645887838128958],
            [-13.136744639101392, 6.652352929073271],
            [-13.136369753638425, 6.6544635816356115],
            [-13.127457283556433, 6.66315394456462],
            [-13.12835918668683, 6.669011131300002],
            [-13.132116477735531, 6.667440081718535],
            [-13.142720847357403, 6.666222914473403],
            [-13.146184150053548, 6.667072462311592],
            [-13.149659314406003, 6.673902964319818],
            [-13.14915100352174, 6.675848066854724],
            [-13.154473963905412, 6.678132855807799],
            [-13.162354556044958, 6.683427179517611],
            [-13.161987633388156, 6.689477590721682],
            [-13.163708014273283, 6.696259341216491],
            [-13.166361442467652, 6.700076455033598],
            [-13.166713091643352, 6.703624125386913],
            [-13.16282103899136, 6.7058471465703215],
            [-13.16549727228457, 6.71036160238205],
            [-13.162300421321152, 6.713836426056258],
            [-13.162637038520312, 6.7198284318635855],
            [-13.161602070005523, 6.72514234039467],
            [-13.163161519149817, 6.734351487900897],
            [-13.159916767552902, 6.741229874747674],
            [-13.16065363548324, 6.745637329929408],
            [-13.160042257613703, 6.7524331525724826],
            [-13.162372270458677, 6.755919734822512],
            [-13.160502130473507, 6.762657217419839],
            [-13.164053305554907, 6.768275324953491],
            [-13.163654001643165, 6.777272925808185],
            [-13.168460053279759, 6.781247059931133],
            [-13.16777351494713, 6.786021142485226],
            [-13.173008809559317, 6.794102266430062],
            [-13.179387647739409, 6.794549320476934],
            [-13.180963450900958, 6.797158069813411],
            [-13.191671039835828, 6.803993049532085],
            [-13.195532755685141, 6.8046060235271515],
            [-13.205424891839508, 6.80907040661306],
            [-13.207674733680916, 6.806554655161297],
            [-13.1985851941866, 6.800801923574375],
            [-13.195585419461636, 6.79468768742362],
            [-13.192236306018694, 6.790652727443521],
            [-13.191262882550046, 6.783381470852796],
            [-13.188047560745582, 6.774801771760551],
            [-13.192680083401946, 6.770179849485731],
            [-13.195472039388601, 6.769259602666152],
            [-13.199488667456256, 6.764643770945615],
            [-13.200200621704973, 6.759843725435837],
            [-13.205018906713358, 6.752494689763918],
            [-13.208495680720224, 6.742388052888187],
            [-13.214796519677524, 6.737833175351289],
            [-13.218811809010019, 6.732272749398925],
            [-13.223715975361142, 6.727776558663601],
            [-13.226574036615029, 6.719841516560752],
            [-13.241209846986777, 6.7115345976440475],
            [-13.2458599440716, 6.704643525289791],
            [-13.252890496372896, 6.698083511469889],
            [-13.257264455039385, 6.692255512314476],
            [-13.2579178775635, 6.688988710052698],
            [-13.265173393977673, 6.680774140307306],
            [-13.265426493619188, 6.676719055318428],
            [-13.26923285996433, 6.6691392287174756],
            [-13.26916353294035, 6.665474065057873],
            [-13.27760732887292, 6.66135569050582],
            [-13.277632996521183, 6.658063962004391],
            [-13.293992909298638, 6.654950498337614],
            [-13.299000129682842, 6.657353530065198],
            [-13.304531785767992, 6.654863951856977],
            [-13.315078376505161, 6.65360776447799],
            [-13.316662605070368, 6.650904704517078],
            [-13.320653035281211, 6.652733527928337],
            [-13.325079344780294, 6.651333036367095],
            [-13.329649064643107, 6.651964810000396],
            [-13.33079952116361, 6.6565450432630575],
            [-13.334632454961373, 6.655553884132236],
            [-13.336297634848139, 6.6588939455891785],
            [-13.34105478986594, 6.659320705003113],
            [-13.34757385502556, 6.657468630717638],
            [-13.354889349647571, 6.653734187702457],
            [-13.359501138283926, 6.654514093462322],
            [-13.367975441832513, 6.651843746073745],
            [-13.380452473418503, 6.65219155931505],
            [-13.384273484002676, 6.649774785245266],
            [-13.399133473623003, 6.6477693068439505],
            [-13.405614680871317, 6.650139362209731],
            [-13.411014940989045, 6.647750108297317],
            [-13.415763194974218, 6.643822177209176],
            [-13.424548362967565, 6.645314053053613],
            [-13.437262078093037, 6.6440594132726245],
            [-13.438419694335204, 6.641348072837825],
            [-13.444161920370474, 6.640345465638711],
            [-13.448925305410237, 6.636772619603797],
            [-13.449672213706672, 6.634210579296497],
            [-13.455816058525269, 6.626199147746767],
            [-13.456139727046041, 6.620486343402755],
            [-13.460045566681234, 6.619681092031099],
            [-13.459512102353253, 6.61663180659188],
            [-13.47040669423887, 6.614410214076969],
            [-13.469971586245046, 6.607813441535109],
            [-13.473181893168668, 6.608208380455009],
            [-13.472152832268927, 6.600528695207256],
            [-13.470134139505213, 6.595198080940719],
            [-13.474517779015242, 6.586626820115683],
            [-13.475343571237131, 6.579050508543628],
            [-13.472884658794696, 6.57665949282633],
            [-13.478015962612629, 6.572721443793666],
            [-13.480480988248067, 6.569011716870455],
            [-13.487725786201043, 6.5657696468524955],
            [-13.490345214828315, 6.555988272177277],
            [-13.49539772557893, 6.558659923257458],
            [-13.507447209928564, 6.56060193400073],
            [-13.511459487717218, 6.564979945990157],
            [-13.514967553262672, 6.566195394473387],
            [-13.5167529064948, 6.563476365842631],
            [-13.522116671076414, 6.56478409099218],
            [-13.526597098710281, 6.564360686050059],
            [-13.534903127133866, 6.556489156182241],
            [-13.540675242793984, 6.554203976270372],
            [-13.541899929330988, 6.550066021215273],
            [-13.546527636661983, 6.544096037371862],
            [-13.54495396438827, 6.53757575327886],
            [-13.550295564035407, 6.5327926534743455],
            [-13.554423292853327, 6.530813961823472],
            [-13.556998811717202, 6.524061909489881],
            [-13.56030123044052, 6.519796377186391],
            [-13.556407341416254, 6.518431275588963],
            [-13.5591210332189, 6.5101459194514675],
            [-13.557159157945383, 6.509461327402185],
            [-13.550739605567243, 6.5034272931856085],
            [-13.552541683166842, 6.500736845564622],
            [-13.558548961928386, 6.504504759295143],
            [-13.565800791094679, 6.501146662710264],
            [-13.56650872593233, 6.497971681111964],
            [-13.569843648947073, 6.493847130909797],
            [-13.568815596335776, 6.488994355409399],
            [-13.574438587165593, 6.486750135379562],
            [-13.578536380972267, 6.480126535197934],
            [-13.583883374725968, 6.482497980486542],
            [-13.589737048977122, 6.4783879595574065],
            [-13.59234128402726, 6.480016932056808],
            [-13.597114000270912, 6.473778214027789],
            [-13.601805326563788, 6.471287151865079],
            [-13.603732969614576, 6.465669210085589],
            [-13.606383108748961, 6.467661128703581],
            [-13.610095769409847, 6.462870580679548],
            [-13.615832516034736, 6.458992220865072],
            [-13.619232140778665, 6.459828787491523],
            [-13.62217396840801, 6.453657740146601],
            [-13.624485342789415, 6.457074678183009],
            [-13.627737094047125, 6.454160481130768],
            [-13.63302159793127, 6.452263865461508],
            [-13.633600331109873, 6.4548314750625435],
            [-13.63944956610769, 6.455777451122738],
            [-13.641987302555693, 6.460467351082648],
            [-13.6459524151994, 6.4581162017044536],
            [-13.642885417481642, 6.454256678275679],
            [-13.647868731967623, 6.447148558780724],
            [-13.652959524140847, 6.449794109005172],
            [-13.655117827424165, 6.448979297503463],
            [-13.659234320407963, 6.442126513292879],
            [-13.666106809578928, 6.44012181397426],
            [-13.667846020293593, 6.44748649683927],
            [-13.672309707369706, 6.4474848382950505],
            [-13.6764109335276, 6.449609640641088],
            [-13.685267726690995, 6.449527654446713],
            [-13.68656917675568, 6.446792678424736],
            [-13.69035782781594, 6.445923172199917],
            [-13.693616010633555, 6.44297777947726],
            [-13.697927630685397, 6.4422275846148],
            [-13.6972980034137, 6.437466091739842],
            [-13.702390368687414, 6.432005774884767],
            [-13.706668885849167, 6.4311142840018265],
            [-13.707923090643659, 6.4282458836559],
            [-13.712925031685659, 6.425657071897339],
            [-13.719243598687765, 6.427733388341045],
            [-13.721749003631702, 6.424257927431764],
            [-13.721206285974006, 6.419088423180665],
            [-13.727489977504417, 6.414812931969164],
            [-13.73099786889261, 6.418386472073523],
            [-13.735571611111112, 6.417743207737765],
            [-13.73962295316677, 6.4197614233544655],
            [-13.744861151864717, 6.415506862663054],
            [-13.75301719446067, 6.416756059638395],
            [-13.755203550567945, 6.413404731259629],
            [-13.763359609193978, 6.407695743504074],
            [-13.767580195692002, 6.410891216824845],
            [-13.768634437374153, 6.415067877293574],
            [-13.77679086322948, 6.418222123461003],
            [-13.782319220463037, 6.414763710037853],
            [-13.788879933279858, 6.413932103341905],
            [-13.794700373008698, 6.415923521693834],
            [-13.795197232250025, 6.418932972838521],
            [-13.800514603105764, 6.419932800642346],
            [-13.80156372426971, 6.433083636661525],
            [-13.806072177985218, 6.433028215597279],
            [-13.808294405661249, 6.435056816850599],
            [-13.812985231050881, 6.433772961176753],
            [-13.817502394557874, 6.429753210370637],
            [-13.817601430952639, 6.421302358097205],
            [-13.820546178329897, 6.418028254678129],
            [-13.825562030179901, 6.418721226531179],
            [-13.833701825211344, 6.4227457061914786],
            [-13.83806718545547, 6.418065748210989],
            [-13.892112559309268, 6.503810370951239],
            [-13.936612974699864, 6.5744430064118164],
            [-14.003696363343376, 6.679414487741638],
            [-13.99807986057633, 6.678200814848414],
            [-13.979325962745778, 6.762097822008145],
            [-13.975749169952168, 6.779031171757659],
            [-13.933501807186282, 6.971938404694621],
            [-13.924348536663487, 7.012967419671313],
            [-13.88293731365753, 7.0042412763690685]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -115.73028960584192,
          "lat": 43.98912843225362
        },
        "year": "2023",
        "ste_code": ["16"],
        "ste_name": ["Idaho"],
        "coty_code": ["16015"],
        "coty_name": ["Boise"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Boise County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00395157"
      },
      "bbox": [
        -14.003696363343376, 6.407695743504074, -13.041778463044638,
        7.070454816017326
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.657892664685836, 1.711942657980293],
            [4.655757883641154, 1.7636246836701612],
            [4.653381568807889, 1.8154557931057558],
            [4.649629569228551, 1.8889564374847911],
            [4.647886772743844, 1.9184537906057668],
            [4.642680302722216, 2.021905167026717],
            [4.6406656429361295, 2.065747683182332],
            [4.639185660786156, 2.0989149924691657],
            [4.636493122217773, 2.1535772147522887],
            [4.701126807793639, 2.156644212829099],
            [4.808381538334888, 2.162589813004776],
            [4.9018382969214445, 2.167710187172051],
            [4.944527998229459, 2.1702131005845278],
            [4.980412834255255, 2.17198932423897],
            [4.9810794208252025, 2.1512355579756783],
            [4.983713086943468, 2.084810792923055],
            [4.9995611633192825, 2.0855286856399067],
            [5.0703786471391865, 2.0894797030918766],
            [5.072720612372375, 2.04506681800801],
            [5.074404266605911, 2.044897636331832],
            [5.07633557759681, 2.0155288162107006],
            [5.078555642555503, 1.9771193946430075],
            [5.071743961747209, 1.9687769202621235],
            [5.070464135755596, 1.9632763954724537],
            [5.070361933358447, 1.9561675396814435],
            [5.06867004924423, 1.935912268945083],
            [5.0618968317006505, 1.9274377007693866],
            [5.0582716497855165, 1.9197234802844625],
            [5.057225533631098, 1.9096065925574282],
            [5.051810478649292, 1.901768703830304],
            [5.044264118263092, 1.8968157735007058],
            [5.033570642460609, 1.8903038503274634],
            [5.02725914888233, 1.8846132328679432],
            [5.01522397432473, 1.8714464019435808],
            [5.008120773698677, 1.8627398344179504],
            [5.0050340563193165, 1.8546259352545513],
            [5.002544034768169, 1.8504266975744477],
            [4.994266439857075, 1.8479154083810194],
            [4.985925331017251, 1.8418759623860612],
            [4.97470196118371, 1.8358954864929264],
            [4.96636275922498, 1.8331603712055924],
            [4.962826904477001, 1.8301446772299463],
            [4.959291241132118, 1.8248558813925273],
            [4.953945601996085, 1.8064868161208025],
            [4.953377483404949, 1.801701454976488],
            [4.955900573712612, 1.794430137140201],
            [4.9559083795375845, 1.7884753603427528],
            [4.952696585257818, 1.7791917204390417],
            [4.945865117991022, 1.7726555157311845],
            [4.943486540228204, 1.764362984243092],
            [4.944707405223981, 1.757348097561138],
            [4.944589414845315, 1.7492411041503744],
            [4.9399051097647835, 1.7420544725386968],
            [4.932835551094679, 1.7291105515906335],
            [4.925351170524266, 1.7183200490964219],
            [4.920977759935103, 1.7158303663526182],
            [4.917702021110338, 1.7119994789909743],
            [4.9153507469619635, 1.7061495723037012],
            [4.911338218693192, 1.688189325874644],
            [4.9095709317991405, 1.683827766989708],
            [4.9045756966241445, 1.676900997518285],
            [4.896948037559619, 1.6720068189920199],
            [4.886048596496799, 1.6697433260511023],
            [4.882009781934165, 1.6681174651416901],
            [4.874365934433674, 1.661377634168913],
            [4.8726369906687514, 1.6587998539880617],
            [4.870365241263414, 1.6492882048073487],
            [4.866211312464175, 1.6432585692905428],
            [4.862842548502113, 1.6408170091984937],
            [4.856843485982287, 1.6387048283631922],
            [4.852737259238791, 1.6301041812250205],
            [4.777948411214576, 1.6280800289751243],
            [4.748292546538832, 1.6277728259721707],
            [4.661770280907939, 1.6237372204723677],
            [4.657892664685836, 1.711942657980293]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -90.20747405792872, "lat": 40.47277226530588 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17057"],
        "coty_name": ["Fulton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fulton County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00424230"
      },
      "bbox": [
        4.636493122217773, 1.6237372204723677, 5.078555642555503,
        2.17198932423897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.095470056078049, 4.050256931797395],
            [6.1195646489034665, 4.052256991302082],
            [6.135255569205299, 4.054546553027343],
            [6.172258719212667, 4.0577691354837],
            [6.177292839990176, 4.002771687289454],
            [6.1808879105775105, 3.958364197247762],
            [6.185533574554134, 3.904848469964684],
            [6.187238731516263, 3.8793788686069863],
            [6.189651236557006, 3.85391016964611],
            [6.194097461735651, 3.8031613147298144],
            [6.193968607847838, 3.7975917405644832],
            [6.198999684769208, 3.730141286070418],
            [6.200322017168499, 3.715667544048396],
            [6.171804546848111, 3.7133214844033633],
            [6.164965232231627, 3.7121361572620266],
            [6.157667164329145, 3.7119968912063475],
            [6.114734916406931, 3.708273565520295],
            [6.075601422262175, 3.705298011770438],
            [6.024209152398331, 3.700916644050499],
            [5.914837968220349, 3.6921451703449697],
            [5.829010927546597, 3.6854524012166867],
            [5.826609187061588, 3.715728828510794],
            [5.823900342501081, 3.752909890442665],
            [5.81553427441159, 3.8600845673590642],
            [5.808569398158768, 3.9472871313547264],
            [5.805488627281549, 3.9836212997163383],
            [5.801423424050136, 4.025886483980116],
            [5.851543209743163, 4.031215503809351],
            [5.947779634142451, 4.038571486346149],
            [5.981042599290867, 4.040933928142193],
            [6.016304318794681, 4.043744611744654],
            [6.095470056078049, 4.050256931797395]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.45234571435608, "lat": 42.32442372854522 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17111"],
        "coty_name": ["McHenry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McHenry County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01784815"
      },
      "bbox": [
        5.801423424050136, 3.6854524012166867, 6.200322017168499,
        4.0577691354837
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.981133267067336, 1.3116519418626413],
            [6.062239413203757, 1.3179928631813513],
            [6.187978136693823, 1.3274516603589672],
            [6.1926208953358435, 1.2745190480766702],
            [6.200020049948706, 1.1864396702291464],
            [6.207783682609496, 1.0959504183682531],
            [6.217552370191354, 0.9807457201678154],
            [6.160138363439813, 0.9768238224402694],
            [6.1307495890096915, 0.9744556571248719],
            [6.128230016227164, 1.0040290372717282],
            [6.114015262284699, 1.0029628273633595],
            [6.1128521247546646, 1.0176201523850226],
            [6.098328378567688, 1.016797956006464],
            [6.097068010352397, 1.031471849238635],
            [6.082741236880474, 1.0305615838896802],
            [6.081400639352834, 1.044895048754497],
            [6.049126021447341, 1.0422521266915286],
            [6.023927236542511, 1.0407141382142966],
            [6.018992446565269, 1.0991710742598066],
            [5.949188022237989, 1.094763758204072],
            [5.942460679086786, 1.1681165092150325],
            [5.934183297270461, 1.255800978214114],
            [5.968962542024117, 1.2583183455798495],
            [5.975909525813498, 1.258387797646888],
            [5.971279489266892, 1.3108193046518746],
            [5.981133267067336, 1.3116519418626413]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.61929991810497, "lat": 39.64146020351287 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17139"],
        "coty_name": ["Moultrie"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Moultrie County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01784885"
      },
      "bbox": [
        5.934183297270461, 0.9744556571248719, 6.217552370191354,
        1.3274516603589672
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.2938461824206815, 3.99571102311372],
            [5.319887838640564, 3.997348768855447],
            [5.323002235882701, 3.997316071896722],
            [5.3747249947238105, 3.999778606665876],
            [5.404116889606898, 4.000993420864787],
            [5.422014938289979, 4.002228506703694],
            [5.4655747277560485, 4.004638782309965],
            [5.496006398980967, 4.006530844860217],
            [5.53549641065349, 4.008642611691469],
            [5.592853350582467, 4.012660740881042],
            [5.631114578023775, 4.014504836612266],
            [5.637732020147312, 3.9220338384819806],
            [5.641106477177965, 3.8820203464482397],
            [5.643818845180483, 3.845891495871949],
            [5.646094046690969, 3.809576638278352],
            [5.649771196988793, 3.758427858531702],
            [5.6548852187741545, 3.700384575348707],
            [5.657201587419065, 3.671253656897992],
            [5.572383671455054, 3.663640798635937],
            [5.517532866120095, 3.659078347898823],
            [5.486194475835429, 3.6568460840457484],
            [5.484371717614358, 3.685369709488504],
            [5.482160334206561, 3.7107789105983096],
            [5.4039136198160795, 3.7040310958261013],
            [5.333237385302204, 3.697912499841241],
            [5.318526507319295, 3.696880222714553],
            [5.311913770495373, 3.779360040658565],
            [5.3099845402205395, 3.802284035134675],
            [5.308353628217406, 3.827192721254494],
            [5.305085320196417, 3.8704096841928726],
            [5.300166871000966, 3.9280372682601277],
            [5.2938461824206815, 3.99571102311372]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.16085351419217, "lat": 42.33626837014171 },
        "year": "2023",
        "ste_code": ["17"],
        "ste_name": ["Illinois"],
        "coty_code": ["17201"],
        "coty_name": ["Winnebago"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Winnebago County"],
        "coty_fp_code": "201",
        "coty_gnis_code": "01785216"
      },
      "bbox": [
        5.2938461824206815, 3.6568460840457484, 5.657201587419065,
        4.014504836612266
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.095601501434311, 1.641493278419472],
            [8.121764771964875, 1.6457118022727681],
            [8.152221387888899, 1.6493625698411234],
            [8.150573710642016, 1.664074559181029],
            [8.193358708324277, 1.6696292652970828],
            [8.278879534374926, 1.6797770119044024],
            [8.366565038621362, 1.6896887781632202],
            [8.374164984978524, 1.616491265525726],
            [8.359124914636984, 1.6149572223900415],
            [8.368471298816944, 1.5282848537604177],
            [8.340828032262163, 1.5249063283660547],
            [8.343830417658824, 1.5025899642908391],
            [8.346311329213806, 1.4807062407529286],
            [8.350664448840318, 1.4369518863585606],
            [8.295729380189952, 1.4313732139280737],
            [8.2659218279832, 1.4281108500162485],
            [8.248404107795078, 1.4264454656416545],
            [8.20997783539004, 1.421989675168914],
            [8.181026237374786, 1.4184438610550956],
            [8.151601245135515, 1.415422532021448],
            [8.10941761058609, 1.4096045923034142],
            [8.104680486950121, 1.4535377233610725],
            [8.099809612520948, 1.495376782205944],
            [8.089310955584274, 1.582501625769968],
            [8.101352107429308, 1.5839480654692537],
            [8.095646231699439, 1.637500015094149],
            [8.095601501434311, 1.641493278419472]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.77325443980428, "lat": 39.8235630423725 },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18059"],
        "coty_name": ["Hancock"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hancock County"],
        "coty_fp_code": "059",
        "coty_gnis_code": "00450357"
      },
      "bbox": [
        8.089310955584274, 1.4096045923034142, 8.374164984978524,
        1.6896887781632202
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.121437825211688, 1.9402281370799905],
            [8.121312144303326, 1.9466790711991124],
            [8.11749946882593, 1.9839315421673769],
            [8.113366375203833, 2.0273498977553124],
            [8.112599037474594, 2.027267777643593],
            [8.104017114494479, 2.1000388566939496],
            [8.17631405208537, 2.108486871339839],
            [8.233236911038912, 2.1140969506952705],
            [8.247032922751838, 2.1164891230428293],
            [8.316859219586785, 2.1243068774233973],
            [8.317390041634757, 2.117288656624862],
            [8.327973783858459, 2.0364841637196918],
            [8.332172082593129, 2.0005069780459133],
            [8.33340604665645, 1.9928923305211954],
            [8.33682216727161, 1.9635886140286447],
            [8.341187536048249, 1.9236106799290003],
            [8.352048908082121, 1.8214182280037468],
            [8.360149967046587, 1.7487448988621956],
            [8.361535993631373, 1.734139444921763],
            [8.366565038621362, 1.6896887781632202],
            [8.278879534374926, 1.6797770119044024],
            [8.193358708324277, 1.6696292652970828],
            [8.150573710642016, 1.664074559181029],
            [8.149457504174778, 1.6790095597662857],
            [8.146344642761163, 1.7052886633318811],
            [8.141196278805715, 1.7522820054985515],
            [8.139373718195621, 1.7660199516456376],
            [8.129407980826102, 1.853919243152947],
            [8.129613648146128, 1.8570997604342425],
            [8.123681605590356, 1.9134073215065295],
            [8.121726246589255, 1.9334081597347683],
            [8.121437825211688, 1.9402281370799905]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.71935164636994,
          "lat": 40.161610638542385
        },
        "year": "2023",
        "ste_code": ["18"],
        "ste_name": ["Indiana"],
        "coty_code": ["18095"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "095",
        "coty_gnis_code": "00450370"
      },
      "bbox": [
        8.104017114494479, 1.664074559181029, 8.366565038621362,
        2.1243068774233973
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.429320284927833, 2.8332873748953866],
            [1.5145770466935515, 2.8342916075000124],
            [1.5571782665788487, 2.8346184471908535],
            [1.5679221840441044, 2.835014924367145],
            [1.6990415682656754, 2.8369746914510694],
            [1.7704110695179693, 2.8382958569672057],
            [1.7713231071950206, 2.79488569234268],
            [1.7726674306636931, 2.722081082948007],
            [1.774201359625501, 2.63489136111466],
            [1.7751745221131159, 2.57663303429676],
            [1.7768403607811363, 2.4894279400626766],
            [1.7145859615585373, 2.488611685086442],
            [1.6058632918014515, 2.486908379674082],
            [1.5484726371926003, 2.486250611838232],
            [1.4630170955476347, 2.4851452119347717],
            [1.4341188207980184, 2.484877554656901],
            [1.4329695947885936, 2.571683292637105],
            [1.432486279883695, 2.628940635156537],
            [1.432101675582436, 2.6590437728539813],
            [1.4304623927458997, 2.74615457035348],
            [1.429320284927833, 2.8332873748953866]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.47097583753894,
          "lat": 41.330745176889565
        },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19001"],
        "coty_name": ["Adair"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Adair County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00465190"
      },
      "bbox": [
        1.429320284927833, 2.484877554656901, 1.7768403607811363,
        2.8382958569672057
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9516884038349598, 2.230781832937118],
            [2.0304842612506966, 2.2321396321603677],
            [2.1223247647236483, 2.236885481440688],
            [2.1668503329686177, 2.23785790396341],
            [2.215955221419487, 2.2391227889735363],
            [2.237570438064472, 2.239496196034358],
            [2.2950651480658695, 2.2400512091310105],
            [2.2969837624440435, 2.1534746082907543],
            [2.2987052673636335, 2.108928073170308],
            [2.299512047329132, 2.0655164615758643],
            [2.3002831343116843, 2.0365128962811356],
            [2.3030410294189423, 1.9195771516645355],
            [2.2283357995545727, 1.9157975954479307],
            [2.2026627578170115, 1.9146882976968225],
            [2.1632078624400553, 1.9133807139159187],
            [2.139430247470023, 1.9128870946434975],
            [2.046134741381181, 1.9091774341921868],
            [1.9968261133907879, 1.9068369609287636],
            [1.9579760623949924, 1.9051685117877724],
            [1.956989468477328, 1.9554832849895254],
            [1.9571171231939781, 1.9566858303956804],
            [1.9548534789659233, 2.0570882886759327],
            [1.9531355655027578, 2.14367610568842],
            [1.9520101775822922, 2.2164664756196357],
            [1.9516884038349598, 2.230781832937118]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.78628224461112, "lat": 40.73768433132119 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19053"],
        "coty_name": ["Decatur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Decatur County"],
        "coty_fp_code": "053",
        "coty_gnis_code": "00465215"
      },
      "bbox": [
        1.9516884038349598, 1.9051685117877724, 2.3030410294189423,
        2.2400512091310105
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5882075645494297, 2.1012363482313736],
            [0.5869945402160829, 2.108133885492293],
            [0.5810196480218682, 2.1213797986663665],
            [0.5798086209272162, 2.128977734964327],
            [0.5808645232595976, 2.135391093692921],
            [0.5848422041669374, 2.143952859725454],
            [0.5858880715068198, 2.1531979601982894],
            [0.5827776036716651, 2.1635292963019785],
            [0.5784317504031808, 2.1721585481533086],
            [0.5773700817251247, 2.1766241336028775],
            [0.5778895799343003, 2.18239016148217],
            [0.5806651514964346, 2.1873526251640563],
            [0.5846629218500847, 2.190324983635643],
            [0.59496498773588, 2.193173841702149],
            [0.6017457908448178, 2.1980699556322723],
            [0.6046235969615288, 2.202502376456379],
            [0.6065654633011129, 2.209548937774636],
            [0.6063313075265792, 2.213799845741943],
            [0.6035583896550408, 2.2200883299698067],
            [0.6534660265657658, 2.2202146650911665],
            [0.6849371299898479, 2.2200292656164438],
            [0.82124044768283, 2.2208293601061007],
            [0.8678004149819456, 2.22094302110381],
            [0.9247237394763104, 2.2212974480193477],
            [0.9251588379535653, 2.1920899891046393],
            [0.9255962825342291, 2.104412475124133],
            [0.925441437943792, 2.050250491621997],
            [0.925635975155905, 2.046777334045596],
            [0.9366336447759044, 2.0467111793037547],
            [0.9346631613904338, 1.973243279453283],
            [0.9351320205061773, 1.8977695691884187],
            [0.82107962269591, 1.8987111233883225],
            [0.7565667103123276, 1.8998346790926994],
            [0.733396490277555, 1.900488693731867],
            [0.6990626776108124, 1.9005148048042038],
            [0.6401822948134792, 1.9011802407597256],
            [0.649571076347882, 1.9088981788157735],
            [0.651889824300515, 1.9131505183405517],
            [0.6529471931313852, 1.9195075594909974],
            [0.6509412763254722, 1.9252506018374098],
            [0.6410308855593735, 1.933323534384843],
            [0.6367453074453652, 1.9407074667787043],
            [0.6357744186304455, 1.9557941347357923],
            [0.6320493867684678, 1.9639203773622247],
            [0.6220678322856148, 1.9759186098347412],
            [0.6175457445976692, 1.9789288326765073],
            [0.6109088438833448, 1.9814369752314678],
            [0.6035051839336049, 1.9821116186786139],
            [0.5969119980789673, 1.983782451107418],
            [0.5899382933846296, 1.9877615941977953],
            [0.5819388449886975, 1.994094416312047],
            [0.579499589165144, 1.9992403536122887],
            [0.5780546217175551, 2.010922744163268],
            [0.5745209154712547, 2.0190465654859895],
            [0.5694289152010591, 2.024878040252835],
            [0.5561651518627576, 2.031141284438439],
            [0.5515294853359836, 2.0344536301045992],
            [0.5498937472225263, 2.037993577266327],
            [0.5472074272121549, 2.0488378327216887],
            [0.5473599655804526, 2.0533101859269407],
            [0.5511426936709565, 2.0649450476366407],
            [0.5546033032593264, 2.0702408523850604],
            [0.561387973914065, 2.076865615505528],
            [0.5743009000107475, 2.0829176271938623],
            [0.5817654391381518, 2.0884345845360803],
            [0.5862022681018685, 2.0938684073982787],
            [0.5882075645494297, 2.1012363482313736]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.60470635411625, "lat": 40.74555813724967 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19071"],
        "coty_name": ["Fremont"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fremont County"],
        "coty_fp_code": "071",
        "coty_gnis_code": "00465224"
      },
      "bbox": [
        0.5472074272121549, 1.8977695691884187, 0.9366336447759044,
        2.2212974480193477
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.4724406045203122, 3.5432671992103284],
            [1.4725999200887652, 3.543443362099252],
            [1.5575490381706587, 3.5444671242713452],
            [1.6425676763459836, 3.545687559806595],
            [1.656426518260857, 3.5458256861374364],
            [1.7135493504139523, 3.5473694158432876],
            [1.8138037822533457, 3.5495416587094897],
            [1.814785107107363, 3.490946151925237],
            [1.8166642293768476, 3.402462228157275],
            [1.8184391429616573, 3.3175848709356126],
            [1.8189570589892008, 3.288485979924458],
            [1.8207491406167289, 3.2010845428401558],
            [1.7925117901866023, 3.2006291389463333],
            [1.7350713625591352, 3.1992389640066783],
            [1.6779579753610823, 3.1982735257790798],
            [1.5631090834344026, 3.1965967557830646],
            [1.477537345223931, 3.194820060331184],
            [1.4758048469541463, 3.2828650919484033],
            [1.4745548983806513, 3.3820964936041724],
            [1.4730053061025226, 3.492690470645009],
            [1.4724406045203122, 3.5432671992103284]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.39683751555678, "lat": 42.03624445311111 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19073"],
        "coty_name": ["Greene"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greene County"],
        "coty_fp_code": "073",
        "coty_gnis_code": "00465225"
      },
      "bbox": [
        1.4724406045203122, 3.194820060331184, 1.8207491406167289,
        3.5495416587094897
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.5526554151339262, 2.480505645711642],
            [0.6072225017767185, 2.480590897150194],
            [0.6174222036286465, 2.480197258546973],
            [0.6320197671684206, 2.480488181688086],
            [0.6672092565338327, 2.480462405866047],
            [0.7126320081382513, 2.48069565276451],
            [0.780687166366098, 2.480882066628804],
            [0.8518748613024044, 2.4814347557288188],
            [0.9234966313292444, 2.4816778360580978],
            [0.9237873106603559, 2.3942888311558823],
            [0.9244060704637859, 2.33297917316542],
            [0.9243264301149826, 2.307846264906011],
            [0.9248424075154232, 2.228549427571942],
            [0.9247237394763104, 2.2212974480193477],
            [0.8678004149819456, 2.22094302110381],
            [0.82124044768283, 2.2208293601061007],
            [0.6849371299898479, 2.2200292656164438],
            [0.6534660265657658, 2.2202146650911665],
            [0.6035583896550408, 2.2200883299698067],
            [0.5996125837253204, 2.225244837493951],
            [0.5906117204379067, 2.233476827496303],
            [0.5862994838928105, 2.2401579436342245],
            [0.5838040631418218, 2.251376535282043],
            [0.583393353986226, 2.258592288038466],
            [0.5851159537094388, 2.269352197599485],
            [0.5911754830821726, 2.2827019537934947],
            [0.5922832627160881, 2.29128926265016],
            [0.5907989525296143, 2.2972854677048398],
            [0.5883654805673065, 2.3016417446414206],
            [0.5802580644242779, 2.3085436163243607],
            [0.5741191245991067, 2.3107644612694864],
            [0.5659179062161446, 2.316396249065262],
            [0.563072057924844, 2.3206831384553586],
            [0.5614146324502871, 2.3285392164751233],
            [0.5641034108887465, 2.3366067452926704],
            [0.5685513805583982, 2.3446728045043557],
            [0.569152661328895, 2.3509158139725908],
            [0.5671361470882116, 2.3587990292759144],
            [0.5538739242988121, 2.3727558174587045],
            [0.5516751496035153, 2.379917650405145],
            [0.5524468753264005, 2.3847459893281755],
            [0.5548879800517587, 2.389165408431194],
            [0.5643240904284111, 2.4000374883184197],
            [0.5664625674618242, 2.408131542674806],
            [0.5643039802736902, 2.421089729685191],
            [0.5639529539442313, 2.4378426520395786],
            [0.5618512314709782, 2.4446892183888354],
            [0.5542129812883564, 2.4581763797678606],
            [0.5518151435239407, 2.4641161026592493],
            [0.5507551875728017, 2.475093581425278],
            [0.5526554151339262, 2.480505645711642]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.62131451815013, "lat": 41.03343694736274 },
        "year": "2023",
        "ste_code": ["19"],
        "ste_name": ["Iowa"],
        "coty_code": ["19129"],
        "coty_name": ["Mills"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mills County"],
        "coty_fp_code": "129",
        "coty_gnis_code": "00465253"
      },
      "bbox": [
        0.5507551875728017, 2.2200292656164438, 0.9248424075154232,
        2.4816778360580978
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.4366323579401937, -0.7909603705439012],
            [-0.4358175361013859, -0.7024720156282643],
            [-0.43483048207495684, -0.6142922335149247],
            [-0.348563879617762, -0.6164800269890417],
            [-0.2627801616400057, -0.6181283637358052],
            [-0.19157657544816417, -0.6189459362299472],
            [-0.14875127704890573, -0.619010454791983],
            [-0.03464077546081795, -0.6194348287437885],
            [-0.02112588464131967, -0.6197688846481666],
            [0.05627288906302525, -0.6199684413608026],
            [0.05524205771079962, -0.7178359408925199],
            [0.05478847473294672, -0.7517058277982628],
            [0.05319165340564491, -0.8250299059038659],
            [0.05220885906639943, -0.9098252832989793],
            [0.05214993028402429, -0.9653253429214173],
            [0.05235778010480394, -0.9720641733257489],
            [0.05171423229482631, -0.9967908862360216],
            [0.05198217746227237, -1.0047193760019653],
            [0.051573431560297665, -1.0232214520803795],
            [0.05166635150431094, -1.054736685140062],
            [0.051419627893715264, -1.0599350646995],
            [0.05172817674800684, -1.0892217229333816],
            [0.05163494915502262, -1.1039579490853084],
            [0.051221823318157944, -1.14773420915787],
            [0.050679624497615594, -1.1770473318079633],
            [0.05087207879603144, -1.1839924523719452],
            [0.050230966348672225, -1.211969841040754],
            [0.05059950372971992, -1.2358172059459775],
            [0.035749859901132774, -1.2354933349677646],
            [-0.09827999123538393, -1.235885462963804],
            [-0.19253820583007947, -1.2343244031409146],
            [-0.27119273627507984, -1.2341049490932732],
            [-0.35664270834043676, -1.2330610179083337],
            [-0.40687008644203854, -1.2328146521134464],
            [-0.4426574246612262, -1.2323304747304713],
            [-0.44113000692409887, -1.1440049070734941],
            [-0.440576198205596, -1.0781825768435986],
            [-0.43966576695604337, -1.0038648056498696],
            [-0.43908869613811846, -0.9674735120774062],
            [-0.4385803841530435, -0.9086115509347769],
            [-0.4384663896141036, -0.8793627335435702],
            [-0.43744558351974694, -0.8793660261706173],
            [-0.4373311667691318, -0.8574803380597142],
            [-0.4366323579401937, -0.7909603705439012]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.83905567633417, "lat": 37.78124673558648 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20015"],
        "coty_name": ["Butler"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Butler County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00484977"
      },
      "bbox": [
        -0.4426574246612262, -1.235885462963804, 0.05627288906302525,
        -0.6142922335149247
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.8376105913316834, -0.7217013366049992],
            [-2.7806581178049945, -0.7244726224399626],
            [-2.7388377695916586, -0.7266707183946655],
            [-2.66769249797266, -0.7301260592654075],
            [-2.582112625439766, -0.7333318423272204],
            [-2.546359212350365, -0.7347969737357977],
            [-2.4966607002787393, -0.7371006390635225],
            [-2.410288633364776, -0.7402072561255357],
            [-2.3526268530770302, -0.7428910246377329],
            [-2.324631466181476, -0.7437653433813793],
            [-2.328489852113893, -0.8319149781830883],
            [-2.3204375623934896, -0.8322646484853878],
            [-2.3233260981361417, -0.9237999467717829],
            [-2.323494482551601, -0.9267874484412115],
            [-2.3258734530432084, -1.0292406610500695],
            [-2.3264850902266874, -1.0434112322355158],
            [-2.3307093841646807, -1.1934531280882696],
            [-2.3667035694359293, -1.192216572204177],
            [-2.4164153608497028, -1.1908227222894987],
            [-2.4737514966712104, -1.1884030692822243],
            [-2.539335435047594, -1.1845410284418882],
            [-2.663146186568718, -1.175515182120397],
            [-2.763232612914343, -1.1688222336392362],
            [-2.848785241827129, -1.164716726255668],
            [-2.8444040912937854, -1.076569377628318],
            [-2.8401107954757863, -0.9884642361017184],
            [-2.8359513068613054, -0.900701876443501],
            [-2.8317951896451325, -0.8101057757171561],
            [-2.8417793181010453, -0.8096277537266667],
            [-2.8376105913316834, -0.7217013366049992]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.88795470706454, "lat": 37.69172758126941 },
        "year": "2023",
        "ste_code": ["20"],
        "ste_name": ["Kansas"],
        "coty_code": ["20057"],
        "coty_name": ["Ford"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ford County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "00484997"
      },
      "bbox": [
        -2.848785241827129, -1.1934531280882696, -2.3204375623934896,
        -0.7217013366049992
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.907789911633934, -1.056783578276964],
            [6.905106094837004, -1.0652644307916517],
            [6.900958880860415, -1.072937159199135],
            [6.894122761317778, -1.071554175124658],
            [6.888268591605648, -1.0792851013402136],
            [6.889040494317223, -1.0852145125692132],
            [6.891507815547319, -1.086173260418261],
            [6.896387858014431, -1.083528084649473],
            [6.900595864168853, -1.0865900264281303],
            [6.900188018652453, -1.0947695140156994],
            [6.893793172283155, -1.0924960400425525],
            [6.894302360273906, -1.0960808956868089],
            [6.88939574114191, -1.096200881574946],
            [6.885575167758431, -1.0987725005246658],
            [6.883944701763169, -1.107800737416664],
            [6.877225975171078, -1.1138658810484012],
            [6.873853546986321, -1.1182819566738682],
            [6.873308856743193, -1.1213433285598977],
            [6.87997584780408, -1.1241728377258924],
            [6.885154342039785, -1.1292740932805652],
            [6.889456227422863, -1.1284973429250693],
            [6.891914813032223, -1.1320084489936826],
            [6.896467545762032, -1.1343580686043218],
            [6.900344842687073, -1.1335595607874323],
            [6.900735298799447, -1.1287308274309662],
            [6.897665384123508, -1.1215933231969444],
            [6.898098715215973, -1.1199548895711737],
            [6.906426675029145, -1.119906879316952],
            [6.908750029138114, -1.115937555310023],
            [6.911454794092026, -1.1184661706244279],
            [6.917148280060062, -1.1171063728948984],
            [6.9164333661404145, -1.120419047311015],
            [6.912448163690015, -1.1258577506382048],
            [6.913921594712112, -1.1326099279932809],
            [6.910416074227311, -1.1371597968234288],
            [6.91065167894606, -1.143810182136939],
            [6.915976921377628, -1.145172874279482],
            [6.918173671955038, -1.1436635270115734],
            [6.921543658127269, -1.1469196401127841],
            [6.920250726838796, -1.1499174990651808],
            [6.922618848823644, -1.153738548593396],
            [6.920225015733668, -1.159453137115701],
            [6.922750872595227, -1.1671770463108597],
            [6.920160716593596, -1.1684904595073804],
            [6.921262506764156, -1.1754356983938743],
            [6.923892022818962, -1.178476143733968],
            [6.927678979695697, -1.1771836535512625],
            [6.9296854455438766, -1.1812293758115067],
            [6.923873411121085, -1.1814964286019076],
            [6.921256943983088, -1.1879891112525736],
            [6.922156838499772, -1.1909360036446623],
            [6.917394547511344, -1.1940168175682389],
            [6.924212776264637, -1.2033535447031716],
            [6.930080857878342, -1.2037870236305812],
            [6.932446431652874, -1.2069645844735688],
            [6.931598326400268, -1.211856314132609],
            [6.932928405590322, -1.2155410135318505],
            [6.937430718126192, -1.2115496105719537],
            [6.942546003728218, -1.2165060141136366],
            [6.945353675684957, -1.2210543944986574],
            [6.948243909280636, -1.2178446521799249],
            [6.953438295730432, -1.2183146309679163],
            [6.954399994732085, -1.220871796043522],
            [6.947421970260002, -1.2261836528973655],
            [6.941175607886998, -1.2292709614704478],
            [6.944945300585915, -1.2323933051897265],
            [6.9442750285900186, -1.2373609076290302],
            [6.9529931264471205, -1.2398852988228601],
            [6.957541388419744, -1.2302304212061803],
            [6.956904908089731, -1.2262983187864287],
            [6.9643079619015, -1.2244009726639067],
            [6.966421068388329, -1.2407951488051772],
            [6.968213189881795, -1.244332729764383],
            [6.974526689201325, -1.2421899051986134],
            [6.978104663069418, -1.2448866379737042],
            [6.980776080823603, -1.24935354664347],
            [6.981877818886024, -1.2542369814222112],
            [6.984748519172377, -1.2526337323205299],
            [6.989314824339269, -1.256596548599792],
            [6.993931775603507, -1.2527336917161958],
            [7.001229133947645, -1.263693478766652],
            [7.006288507538705, -1.2654882514225738],
            [7.007723064988981, -1.271926150007953],
            [7.014599527517034, -1.2751614058232537],
            [7.017429817575301, -1.2737884909559813],
            [7.022721156179585, -1.2780314698469668],
            [7.022523314155902, -1.2800745396848354],
            [7.009859089130629, -1.4105937282654015],
            [6.993946607465598, -1.4316646759572074],
            [6.971516815110774, -1.461342963099577],
            [6.900106767256988, -1.491846413799775],
            [6.893424505481616, -1.4891921921329776],
            [6.889816396007783, -1.4850603431087914],
            [6.884385671664114, -1.4836697565361774],
            [6.823412516595332, -1.4127306756989133],
            [6.797908263919864, -1.382359014675568],
            [6.776909844985654, -1.3467665469390642],
            [6.763974364399278, -1.325619878733035],
            [6.735919272007209, -1.2787984209169367],
            [6.716743827389244, -1.2777436157092972],
            [6.7087268018702675, -1.279234318794892],
            [6.693440086426791, -1.2773765889129325],
            [6.698934362439092, -1.2771960774749822],
            [6.702659045159455, -1.2721140641788076],
            [6.701867496069763, -1.2640477056081378],
            [6.697207299059498, -1.256766025857359],
            [6.696050905648451, -1.2496903525659437],
            [6.701001124589434, -1.2474356567078992],
            [6.702753207966668, -1.2437275951570999],
            [6.7002679920092705, -1.23914954131839],
            [6.695126511791013, -1.2376446717647087],
            [6.694826786306286, -1.2343277105898809],
            [6.701347993281391, -1.232485838566884],
            [6.702784432491299, -1.2289266405807757],
            [6.715142024146457, -1.2230055758210157],
            [6.721942305689008, -1.2245078662287594],
            [6.723569219981707, -1.2197985816184453],
            [6.722596249200113, -1.2162057289823895],
            [6.758547687588335, -1.1853702860536963],
            [6.902398454208085, -1.061803637027142],
            [6.907789911633934, -1.056783578276964]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.8678604321042, "lat": 37.14540144215586 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21033"],
        "coty_name": ["Caldwell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Caldwell County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "00516863"
      },
      "bbox": [
        6.693440086426791, -1.491846413799775, 7.022721156179585,
        -1.056783578276964
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.304864601880638, -0.0610889273432837],
            [9.306742617551569, -0.04749020953318242],
            [9.369345527726242, -0.008332190614847324],
            [9.466270856413072, 0.05158260829775445],
            [9.470177006287111, 0.049719734269741855],
            [9.477372955364501, 0.05539898184194283],
            [9.483890098466844, 0.05727394620531282],
            [9.486895868504199, 0.05418009832426383],
            [9.48812630593053, 0.04936228976577604],
            [9.494539332675027, 0.04354071578783881],
            [9.501262699164851, 0.04258959098764946],
            [9.502916466244562, 0.03446848279096822],
            [9.501514631873542, 0.031413513557256335],
            [9.506020359662962, 0.0260945296103158],
            [9.500816713434547, 0.01814367275376017],
            [9.501216151543034, 0.014170901842819062],
            [9.49746216286845, 0.008581219345756863],
            [9.494561180132958, 0.008880717919889813],
            [9.494167226988045, 0.003815369559407408],
            [9.497564508743881, -0.000046193293151095985],
            [9.497134993401072, -0.0032143738837431403],
            [9.499324442637953, -0.01004371574350564],
            [9.498798221729048, -0.013198360755367306],
            [9.50248355219589, -0.023171724564661055],
            [9.502063947338863, -0.027436521621501436],
            [9.495541929320417, -0.03291140819198806],
            [9.496196790875926, -0.036298292968706215],
            [9.494046418606192, -0.04104832775159924],
            [9.495549205116706, -0.0432739389237111],
            [9.50312684286022, -0.04449732556398742],
            [9.503427470216524, -0.04831438006359726],
            [9.511626247421484, -0.053927169019093536],
            [9.51626061166991, -0.05369950354413715],
            [9.524431057840227, -0.05618179040425926],
            [9.525705639105885, -0.05999890835210561],
            [9.539341738785199, -0.06474734529550748],
            [9.54388766854362, -0.05971314573636792],
            [9.545167923695516, -0.055715987856620096],
            [9.548055167705366, -0.05523105375045207],
            [9.550871955157339, -0.06124743398411981],
            [9.556361854677451, -0.06159228745343676],
            [9.562349851492632, -0.06672259957080143],
            [9.571188160687306, -0.07009330226283814],
            [9.57421833687841, -0.0762536047392815],
            [9.572868649053627, -0.07859936776490667],
            [9.574757894719053, -0.08072907599270267],
            [9.574597052203428, -0.09081454215771419],
            [9.576516837417508, -0.09643572890344772],
            [9.576066673747729, -0.0999124795426127],
            [9.577585961076448, -0.10542047275925111],
            [9.572238281611742, -0.1129501423287318],
            [9.577214020614583, -0.11986579235605976],
            [9.577521180875044, -0.12356415650220938],
            [9.581784871723281, -0.12626054257701871],
            [9.553200418094368, -0.14834276964616797],
            [9.555694509252367, -0.15191445803476009],
            [9.555672237104636, -0.15515284857232595],
            [9.552401823614813, -0.15852166671551268],
            [9.553313021769439, -0.16344981603022204],
            [9.557135954769997, -0.16954464531523822],
            [9.557405536000928, -0.17647203317730267],
            [9.555870224675969, -0.18147333659588727],
            [9.559291409344782, -0.183003426365434],
            [9.565100274995556, -0.18126822884507215],
            [9.566108036189867, -0.18483925540403764],
            [9.564400720931689, -0.1876001237741373],
            [9.559814109962355, -0.1892290234921169],
            [9.558179643827064, -0.19218115432795457],
            [9.559326725871328, -0.1953412674286077],
            [9.5673743323217, -0.19397664358652209],
            [9.562569170397806, -0.20108137868783227],
            [9.555704826712994, -0.20398734375865216],
            [9.552200137650903, -0.20396094988046415],
            [9.55385916408137, -0.21499633762249123],
            [9.549237908991211, -0.21526825817407413],
            [9.54824593535086, -0.21993662833969663],
            [9.55439383280906, -0.2221809142242794],
            [9.55672999410882, -0.2254355111826299],
            [9.556275185753034, -0.22997159338592013],
            [9.547456377246446, -0.23131155043530852],
            [9.549605594177207, -0.23362586301593752],
            [9.549203925306038, -0.24329753906671084],
            [9.551001311641516, -0.2449267171368747],
            [9.547071381717569, -0.24928359208143566],
            [9.546806527326755, -0.25398330032935496],
            [9.550067773074053, -0.254245771026594],
            [9.550798486798048, -0.25809123496504727],
            [9.555093537927325, -0.25888131506405404],
            [9.554801006124102, -0.26572322146340166],
            [9.553425592643345, -0.26929622262564595],
            [9.549309177725023, -0.2693528707871239],
            [9.545980123397523, -0.2648375606548342],
            [9.53765492353067, -0.26011315037063126],
            [9.53394219472986, -0.2569306919471588],
            [9.527032218816252, -0.25362340097688973],
            [9.5219504561957, -0.25325912282470986],
            [9.518663625044677, -0.2580337373093467],
            [9.519041789801395, -0.2614841128375301],
            [9.5227373051936, -0.2659797973172991],
            [9.5246248773919, -0.27079929561833427],
            [9.529741395555968, -0.2780716184936672],
            [9.536119117874172, -0.2903835310019959],
            [9.537242620632123, -0.2949122522843734],
            [9.53503408101916, -0.2999230730767119],
            [9.528834779440581, -0.30285638544183136],
            [9.523675724553682, -0.3096505893071748],
            [9.517432845857137, -0.30880346203643644],
            [9.512719948469988, -0.3020789625476923],
            [9.508097391895703, -0.2981918341301882],
            [9.500803009803002, -0.2866638828736537],
            [9.495309484610036, -0.286808861207398],
            [9.492670670796945, -0.2896346770936789],
            [9.489091684932937, -0.30627092994140714],
            [9.484316500152953, -0.31315740755814275],
            [9.48247144167913, -0.3119841615587063],
            [9.484005639748663, -0.3043537722206674],
            [9.48102826738567, -0.2983950912174649],
            [9.482812171568185, -0.29195393321789176],
            [9.480105323396012, -0.2892613920886276],
            [9.474079684167585, -0.2799527648697731],
            [9.473690001934116, -0.2737224588389103],
            [9.46891830270239, -0.2677182426287086],
            [9.464424918251687, -0.25686995434813664],
            [9.463634592670898, -0.253008071309978],
            [9.455616704154098, -0.2484493911386828],
            [9.452197458243587, -0.2442906253922652],
            [9.447483846535262, -0.24348078502947315],
            [9.444471254504931, -0.23189580242550983],
            [9.440428992422655, -0.22775357363053644],
            [9.438876375497815, -0.22407600726308574],
            [9.345907713546744, -0.1883400624870748],
            [9.331395078960185, -0.1856634332389907],
            [9.291287685269936, -0.17729468386102493],
            [9.291636714625492, -0.1629225405930952],
            [9.296898254319617, -0.12166867552366789],
            [9.304864601880638, -0.0610889273432837]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -84.45868422123364,
          "lat": 38.042240930985514
        },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21067"],
        "coty_name": ["Fayette"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Fayette County"],
        "coty_fp_code": "067",
        "coty_gnis_code": "00516880"
      },
      "bbox": [
        9.291287685269936, -0.31315740755814275, 9.581784871723281,
        0.05727394620531282
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.837897936771729, -0.18399570382540023],
            [9.842496903574858, -0.18035925903025976],
            [9.8795049694569, -0.19014658073038598],
            [9.884751075972956, -0.19232114275688686],
            [9.901763881208163, -0.19035676073702396],
            [9.909107522582653, -0.20106736572518458],
            [9.91846650917432, -0.19815522379869463],
            [9.929574270828253, -0.20078782763602113],
            [9.936113741041497, -0.19984330778184686],
            [9.936092880865905, -0.19672234429577243],
            [9.940546965948906, -0.1960730345838444],
            [9.945211673863767, -0.19875522633612178],
            [9.947977753121716, -0.19472966836883204],
            [9.952595254297227, -0.194804886479966],
            [9.954228096428286, -0.1966247383427647],
            [9.960615518226703, -0.19625554564780742],
            [9.969174095702416, -0.19292981352307018],
            [9.98333697538968, -0.18842366668160027],
            [9.987449689811971, -0.1846061096501906],
            [9.992533200822242, -0.1767699152995802],
            [9.997421270722205, -0.17723997504425257],
            [10.002907363951945, -0.17970441549811078],
            [10.003237280439809, -0.18628953041104998],
            [10.001853649362168, -0.18952453016900242],
            [10.004553024195149, -0.19405642251234745],
            [10.011112656261455, -0.19803198604182254],
            [10.071399912738801, -0.22952708478237788],
            [10.074516559863346, -0.23298334223490966],
            [10.07888683632033, -0.23283994576777098],
            [10.082900116040275, -0.24190528973110065],
            [10.086080221361085, -0.244529031686205],
            [10.085004701620468, -0.24929188327533186],
            [10.090744282040733, -0.2517554884941574],
            [10.094456013015948, -0.24811358214447155],
            [10.097486553530603, -0.2495150277503274],
            [10.101907990580616, -0.2566606443619398],
            [10.105890081337328, -0.2555807730866509],
            [10.111411339844286, -0.2560030734010506],
            [10.065938961998592, -0.3728448950868645],
            [10.062170308207884, -0.3695957365485825],
            [10.05497119289164, -0.37431425079819886],
            [10.052913621349113, -0.3618254814651089],
            [10.050258283482588, -0.36316928532772774],
            [10.044380293438707, -0.35898050576766094],
            [10.041200077923326, -0.3618298922023634],
            [10.036625910652369, -0.36039991579020375],
            [10.032500245280794, -0.36153252163676053],
            [10.027974653738308, -0.35686078815108513],
            [10.01536753155909, -0.35432151606062295],
            [10.010893253273501, -0.34843468777896547],
            [10.00450003519819, -0.3359564547409949],
            [10.000613758738162, -0.3364934130306906],
            [9.996891353565328, -0.3420999724146295],
            [9.990754295062576, -0.3400944826817234],
            [9.986187597996029, -0.34215615074039696],
            [9.981513439464084, -0.34751800667253524],
            [9.981339827181126, -0.34964901451957814],
            [9.976375405761603, -0.3515769668935098],
            [9.972985372782604, -0.3545062164418697],
            [9.966434643563279, -0.3450004528694017],
            [9.968356893816715, -0.3386084223061973],
            [9.964579548660653, -0.33628780414021714],
            [9.95511292985749, -0.3400746919684653],
            [9.94969640982319, -0.34482523222367],
            [9.94289243988897, -0.34580326275198187],
            [9.938408108779297, -0.3527075149228797],
            [9.932423819886322, -0.3526711394115285],
            [9.930152325257607, -0.3541078260836574],
            [9.926216316110743, -0.34879322469915486],
            [9.921936988788726, -0.3506438229250155],
            [9.918771286376053, -0.34842181113727444],
            [9.914503014076812, -0.3478811880647189],
            [9.90667564719182, -0.34997741846698066],
            [9.903949566094775, -0.34399906792876284],
            [9.901151221364684, -0.34291440482583424],
            [9.85692136302002, -0.31455297991186515],
            [9.855222456990086, -0.3087673778747334],
            [9.857262451137897, -0.30627421965231816],
            [9.854821262140105, -0.30240122250613183],
            [9.855093485686421, -0.29577524330615373],
            [9.856421456773344, -0.2928464256698552],
            [9.853541139942418, -0.28806127145057076],
            [9.853430750491935, -0.283875198307304],
            [9.851125236012146, -0.2752727328561096],
            [9.851793709032112, -0.26989826316310156],
            [9.847837973564118, -0.26790376806652605],
            [9.845808323419154, -0.269546501155454],
            [9.838058790435142, -0.2685981308972666],
            [9.838090856447057, -0.272638348595543],
            [9.834289851154171, -0.27280697155515554],
            [9.831106744744282, -0.2676637073046294],
            [9.827593085447463, -0.2684103399539245],
            [9.822115659356152, -0.2808494966144223],
            [9.811323311543768, -0.26803395838206867],
            [9.8123445136305, -0.2636374311650138],
            [9.805467297093406, -0.2636684121420607],
            [9.798364156773022, -0.2514283150014689],
            [9.80147982692029, -0.24981119804394233],
            [9.804884638222504, -0.2511417567963508],
            [9.806406622904476, -0.25687708687837923],
            [9.80968442129891, -0.2614604935707586],
            [9.815895291307385, -0.25815351375046464],
            [9.815731072973959, -0.2546788410739672],
            [9.819156986024657, -0.24750346023046993],
            [9.818589814053572, -0.24293577153516355],
            [9.821155113902371, -0.23971310205567467],
            [9.820988246981539, -0.23489303273385653],
            [9.81863038839594, -0.2306249613537432],
            [9.821399179910554, -0.22637881168260768],
            [9.823391205473586, -0.21736036952683524],
            [9.82078071640603, -0.21019691501657378],
            [9.82202445697811, -0.20422142191550025],
            [9.819824504694234, -0.19951910345631335],
            [9.824276736722938, -0.1942932963494714],
            [9.831303312385172, -0.19103727100225779],
            [9.829562903509029, -0.18644165079207076],
            [9.837897936771729, -0.18399570382540023]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.82362303480345, "lat": 37.8311224137899 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21197"],
        "coty_name": ["Powell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Powell County"],
        "coty_fp_code": "197",
        "coty_gnis_code": "00516945"
      },
      "bbox": [
        9.798364156773022, -0.37431425079819886, 10.111411339844286,
        -0.1767699152995802
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.110812270951701, -1.3625864862000723],
            [9.143890638860602, -1.3297298721877637],
            [9.173647014716265, -1.30389493945677],
            [9.179656210262738, -1.300804587678665],
            [9.185490299633962, -1.2953906269818014],
            [9.188445373460327, -1.284852698901812],
            [9.187569660735715, -1.273215869573446],
            [9.187975560380803, -1.261473052000347],
            [9.189126647721624, -1.2552002361554349],
            [9.194061778550003, -1.2494772639791856],
            [9.198049862627991, -1.2481300715785446],
            [9.205577313796672, -1.24871130869071],
            [9.211724428469516, -1.2511588345355498],
            [9.218631234203908, -1.2563240527054087],
            [9.223767189686566, -1.2613314391529313],
            [9.274311190431998, -1.2023664896119601],
            [9.317367643300418, -1.2167193951015978],
            [9.330469919876967, -1.2361435746459053],
            [9.34577044809453, -1.2301927890342148],
            [9.360475811777995, -1.2237361308811376],
            [9.373020799355935, -1.215365561310823],
            [9.377295499019816, -1.2070661182322504],
            [9.383008293551514, -1.2047503074713126],
            [9.39927680622151, -1.2044931719202974],
            [9.455773604805046, -1.2837195859284192],
            [9.460706549140081, -1.2880153900956393],
            [9.469358294467778, -1.2979663604408818],
            [9.473033730904044, -1.2985820048634489],
            [9.477353263503144, -1.2918737256437263],
            [9.47980592330778, -1.2839962987593696],
            [9.485103031251997, -1.2828743356821781],
            [9.48606544275983, -1.286992902288362],
            [9.48274093905015, -1.290300843619203],
            [9.48126527955423, -1.2946097754209507],
            [9.483132844638083, -1.297918647815512],
            [9.488713476493153, -1.303511388955844],
            [9.492391856693038, -1.3089826914624247],
            [9.490999185765201, -1.3134444187630372],
            [9.482319294880694, -1.3149012943435907],
            [9.484772914480535, -1.3216552214657362],
            [9.488363417939688, -1.326429672266574],
            [9.49799916962975, -1.3281215048703157],
            [9.498560432458284, -1.3314647994636586],
            [9.49293743559789, -1.3358942905907591],
            [9.485135256000321, -1.3374282334183774],
            [9.482419585743026, -1.3405504972352271],
            [9.489658996214054, -1.3459281113180124],
            [9.494221875528524, -1.350585055455569],
            [9.497831282268969, -1.3512118279821819],
            [9.49857383313544, -1.357458203548888],
            [9.497845433386154, -1.3619412706065743],
            [9.4916012220619, -1.3683138828987105],
            [9.485984600694708, -1.3723084742073017],
            [9.482902525137122, -1.369608601390188],
            [9.48013492246298, -1.372226445071748],
            [9.486329733088951, -1.3781177111427405],
            [9.483465213649346, -1.3797286365251682],
            [9.477049422635575, -1.3789103527559365],
            [9.477367741771365, -1.3848549074967116],
            [9.47064416457124, -1.3842489748317215],
            [9.46628742414485, -1.3865480070796519],
            [9.463995190454474, -1.3931743300080648],
            [9.466796349689094, -1.3957714798403589],
            [9.466317917366826, -1.4013318550232585],
            [9.46022755344324, -1.4013298325206098],
            [9.459933519553312, -1.411866441590388],
            [9.45506885797872, -1.4120023212265107],
            [9.454232135327072, -1.4155479092475336],
            [9.447462254239595, -1.4150051799876866],
            [9.444446478802107, -1.416164847759368],
            [9.440878917991256, -1.4220930285860183],
            [9.436347900750564, -1.4226288133427],
            [9.436376895534304, -1.4282050510993656],
            [9.43136771092127, -1.4268135226481784],
            [9.430675512344308, -1.434132934879282],
            [9.427103196363658, -1.4377685074224786],
            [9.427735385352978, -1.441106272442926],
            [9.432160951214998, -1.4463219208073792],
            [9.366192074753894, -1.5923578697922016],
            [9.360689326460527, -1.5928416280413753],
            [9.34609783190828, -1.5936646791742597],
            [9.314924409532289, -1.596470106834591],
            [9.30161680785989, -1.5966475790466974],
            [9.23440174404528, -1.598357300014822],
            [9.209629364380968, -1.5982162282175043],
            [9.20567223189542, -1.5934363527065825],
            [9.197742191814706, -1.595945204491612],
            [9.196097601586825, -1.5932856407257836],
            [9.189161328515375, -1.5914505116179687],
            [9.188478209499065, -1.5846344463826627],
            [9.18504312136746, -1.5827374762954414],
            [9.18313538715183, -1.57351350250408],
            [9.187543139835304, -1.5682850881791524],
            [9.186300648344336, -1.563669538898576],
            [9.18570951120643, -1.5526932329613357],
            [9.182740453650771, -1.5501081060166402],
            [9.179759103488186, -1.550312230949215],
            [9.178371217997238, -1.5456453705752922],
            [9.181558975364606, -1.5391017360183046],
            [9.176637109233555, -1.5359548795855775],
            [9.177704342758663, -1.533330501853966],
            [9.173808653505406, -1.5304564774206113],
            [9.166525848835322, -1.5277172523908682],
            [9.164447323560761, -1.5234086842236292],
            [9.164907997119165, -1.5163162963451622],
            [9.162547436852535, -1.5139698122261642],
            [9.165228383525317, -1.510475610071242],
            [9.166237920824422, -1.5014641349994535],
            [9.16207854175737, -1.499710455972519],
            [9.16299782963024, -1.489261564599409],
            [9.170154764104899, -1.4598660511625072],
            [9.146699772108393, -1.411097878603194],
            [9.117832723993661, -1.3878335359948064],
            [9.110812270951701, -1.3625864862000723]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.82862936417034, "lat": 36.80125443147445 },
        "year": "2023",
        "ste_code": ["21"],
        "ste_name": ["Kentucky"],
        "coty_code": ["21231"],
        "coty_name": ["Wayne"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wayne County"],
        "coty_fp_code": "231",
        "coty_gnis_code": "00516962"
      },
      "bbox": [
        9.110812270951701, -1.598357300014822, 9.49857383313544,
        -1.2023664896119601
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.097157669834274, -5.844268422978633],
            [2.096386187959325, -5.815317624118338],
            [2.0942305385462805, -5.706011006132126],
            [2.198135723361512, -5.703742297720631],
            [2.284456668415284, -5.701732201672718],
            [2.2806595136536036, -5.707038417237612],
            [2.2777328312496143, -5.70781934125258],
            [2.27757459259787, -5.711626038228759],
            [2.2821816006326157, -5.716290472577908],
            [2.287843590489588, -5.719582292176021],
            [2.2884642461219165, -5.723633434645088],
            [2.2850712003155706, -5.72918464463269],
            [2.280226046042954, -5.731985500844057],
            [2.282623783063546, -5.740868325604842],
            [2.282888338004038, -5.74539407083765],
            [2.2790549237841566, -5.754117321758568],
            [2.2862562930838823, -5.752350461282744],
            [2.2932496260945725, -5.747166640435487],
            [2.2973385696424073, -5.750119097918769],
            [2.297098280218206, -5.755277216146552],
            [2.29452720687193, -5.758334746475014],
            [2.2885686347087337, -5.759293713815222],
            [2.2848827941496372, -5.75668318192657],
            [2.27567295479393, -5.75465202346866],
            [2.2731817818086157, -5.757845236580905],
            [2.271309615546722, -5.7648367513271],
            [2.2616481292690316, -5.768880886408436],
            [2.2607471786119477, -5.772499279980354],
            [2.265769187029907, -5.7753259192855],
            [2.2786647229131134, -5.7749530010080345],
            [2.2866716904703432, -5.778613500433431],
            [2.295137781566785, -5.785521088845037],
            [2.297015708820505, -5.789140885536808],
            [2.2925130958409117, -5.797216083634433],
            [2.289117550133575, -5.80510123458073],
            [2.2857266488473607, -5.810688977669399],
            [2.281957297610466, -5.819359985297118],
            [2.282051023835977, -5.831067357366413],
            [2.28281207603073, -5.836993192766917],
            [2.2884443405557593, -5.846322716037084],
            [2.2937961861913694, -5.846386271635517],
            [2.2991064359563342, -5.84961413032074],
            [2.300076616248718, -5.852696397173054],
            [2.29796501451787, -5.86075114869762],
            [2.289135606467063, -5.86704054424039],
            [2.288213874483208, -5.869654495787456],
            [2.2961490082775486, -5.87335583345494],
            [2.3010069004556097, -5.874078990435182],
            [2.3026303508447445, -5.872095453793291],
            [2.3062806987209803, -5.861916982049841],
            [2.311137305174042, -5.8594349367399605],
            [2.3127591366638707, -5.863322791311087],
            [2.3130798941628763, -5.875658004062863],
            [2.3125250869552665, -5.88488673752124],
            [2.3101519840708313, -5.897752959363017],
            [2.3082826255306825, -5.903675100963137],
            [2.3036304438326884, -5.912471012772892],
            [2.3007688975029073, -5.914650964622672],
            [2.2875408615581976, -5.920145254883865],
            [2.2841263452346756, -5.922948741960601],
            [2.281640659798802, -5.929005889181206],
            [2.2824987893678177, -5.935310008958558],
            [2.285543230217766, -5.938975881868127],
            [2.2899053764043975, -5.937794271890217],
            [2.2925903911525474, -5.9327063414464885],
            [2.299095300938638, -5.923975216294975],
            [2.3024838553637346, -5.921512005296336],
            [2.309278642220584, -5.922732471653336],
            [2.312475193343766, -5.926434002714537],
            [2.3161550839354588, -5.937544826991577],
            [2.314666408336764, -5.952355104861804],
            [2.3082881941830826, -5.963753902403974],
            [2.2981872668490357, -5.972269039906063],
            [2.283823061465705, -5.986311827679831],
            [2.2831045071214624, -5.987871301682381],
            [2.284776923832364, -5.995691720482623],
            [2.2817025110315865, -6.00492190129691],
            [2.2831741872006575, -6.008449734783225],
            [2.2873817763539424, -6.010517227453174],
            [2.2916460110119075, -6.006811467569571],
            [2.2928199083353364, -6.00309116501914],
            [2.2974571257506256, -5.997461142776061],
            [2.3013026099702745, -5.994900087745532],
            [2.307075203265626, -5.994062628200402],
            [2.314241389333648, -5.996121535306183],
            [2.3175793723416547, -5.999694682223248],
            [2.3187286310084283, -6.008454907487937],
            [2.3176981620928263, -6.018386160340412],
            [2.3143274626888126, -6.042514294166014],
            [2.314927773660121, -6.050887840123546],
            [2.31836928435688, -6.053996727534738],
            [2.3209813398712287, -6.052219231026142],
            [2.325276439452911, -6.046055181836208],
            [2.32947686323348, -6.04296666501675],
            [2.3373457488756233, -6.042850699642761],
            [2.3401496996351345, -6.044748017702219],
            [2.3422580050554145, -6.049986340898836],
            [2.3405087641758575, -6.055222098676727],
            [2.3358938405693137, -6.057823521748187],
            [2.328936282508985, -6.057559880546063],
            [2.3247097719783443, -6.0608198934774],
            [2.324557222364879, -6.06444217774115],
            [2.3293931718802368, -6.071890016946195],
            [2.3351917692906032, -6.079176825610842],
            [2.33170359325173, -6.081187165857049],
            [2.3277184231250003, -6.080203665045452],
            [2.321300574503566, -6.0747605426323945],
            [2.3166624673458083, -6.074587988829196],
            [2.3166717637080625, -6.079381833535737],
            [2.3226511883978334, -6.083166751816936],
            [2.32991183003158, -6.083937104700551],
            [2.3386166355482336, -6.082310992401229],
            [2.341683952091404, -6.083425544665012],
            [2.3449097915936092, -6.0896883280764325],
            [2.3464240061232764, -6.089825780771212],
            [2.346487268324533, -6.099206849381598],
            [2.344247845798518, -6.105781801712965],
            [2.340710261951955, -6.111048564692584],
            [2.34159448832051, -6.115830334558616],
            [2.353589719008498, -6.1170594798828795],
            [2.3567969690029997, -6.120105632217234],
            [2.355744626906874, -6.123401462967062],
            [2.3524078049517434, -6.124584571547416],
            [2.345762120752839, -6.120245805208933],
            [2.3399533837419644, -6.122941901215921],
            [2.332354087261739, -6.124735101559534],
            [2.332755770538189, -6.129254933430971],
            [2.3427316378629466, -6.1326383422760395],
            [2.349205712002477, -6.128613132143027],
            [2.3572873819457127, -6.129046553002362],
            [2.360267661475097, -6.133681227809749],
            [2.3599476877160286, -6.13991430835062],
            [2.3547174071608876, -6.1494320038745185],
            [2.3499246709665167, -6.153161719589357],
            [2.3389035970800824, -6.157686269775103],
            [2.335615116896005, -6.1610207135444135],
            [2.335605648643696, -6.167002791614363],
            [2.3383703100022677, -6.170709618426953],
            [2.3415533946077103, -6.172003228424643],
            [2.351716295672013, -6.170753225779547],
            [2.3574682875642123, -6.168950235998805],
            [2.3630714646678306, -6.179338799311177],
            [2.3677012114678413, -6.184793410969221],
            [2.3669421755440987, -6.186218555539335],
            [2.3597395135940866, -6.186670340600547],
            [2.357969288374185, -6.177837435196093],
            [2.3557067203792434, -6.174244507239998],
            [2.3508810989088054, -6.173667251883958],
            [2.3444425814235372, -6.1828055410971645],
            [2.335444421203401, -6.178270844007551],
            [2.3358153454831587, -6.182859578942951],
            [2.3442724928639906, -6.1897680220236575],
            [2.3485476308134876, -6.191666686126641],
            [2.351065225027445, -6.186952139656698],
            [2.3552112000097005, -6.190674620623839],
            [2.3545612614461633, -6.203567425649655],
            [2.3563236295241694, -6.205573850059315],
            [2.3627116050160026, -6.206964759171419],
            [2.3776137713862693, -6.216407222819482],
            [2.3856057900934338, -6.218193957794438],
            [2.388090876938033, -6.221171242783513],
            [2.383362454859558, -6.2250134435107505],
            [2.3777450511491987, -6.227258635441816],
            [2.3780355773542468, -6.230879458349095],
            [2.382519385273836, -6.2302153144231776],
            [2.3879737748263943, -6.225330871556778],
            [2.3922177711721977, -6.224101946823715],
            [2.395982195338678, -6.228430073530157],
            [2.3947272850909678, -6.234191909779819],
            [2.39203189943087, -6.237425507174267],
            [2.3934720888442924, -6.241397469036992],
            [2.400731628092114, -6.245507969640338],
            [2.403204905157821, -6.255558847770029],
            [2.408264519502024, -6.2540575392588265],
            [2.4066112004094937, -6.259849721091597],
            [2.4000918089178103, -6.267892955426339],
            [2.399638136245297, -6.270765337501088],
            [2.4066229386668634, -6.27621929299214],
            [2.4157738795121677, -6.2777437777373954],
            [2.4201261480511937, -6.2847481051510705],
            [2.4243523816163948, -6.2869313805370375],
            [2.426521081585121, -6.29167211554165],
            [2.422376729237579, -6.29563731060118],
            [2.415764493550372, -6.29690310263488],
            [2.4147339920641238, -6.294612822236852],
            [2.415186379632768, -6.287404756983559],
            [2.410916022143959, -6.2849531453916105],
            [2.407238313441085, -6.2929322272100165],
            [2.401473242026333, -6.295290014642757],
            [2.4038552169095504, -6.298945376544028],
            [2.4084889351177017, -6.30112553332374],
            [2.4171065237407032, -6.302018917299455],
            [2.4226491902908696, -6.300513238845517],
            [2.4261901827016037, -6.304020637079804],
            [2.4153143929364838, -6.304990601825639],
            [2.4095558220547, -6.307435671370921],
            [2.406002617306081, -6.311599364370999],
            [2.4052171174304724, -6.317871157108555],
            [2.407213790162245, -6.323115870049413],
            [2.4122353482167727, -6.327823275318857],
            [2.422133968190628, -6.330156413065831],
            [2.426063457314005, -6.330333362123116],
            [2.427550501435327, -6.326329569716948],
            [2.4225348656553916, -6.320298426075485],
            [2.4217783562842534, -6.314189072914967],
            [2.426060510212856, -6.311813282098199],
            [2.434087684527279, -6.313057156744341],
            [2.4384911982509747, -6.315166187697874],
            [2.447169233282992, -6.324374851808273],
            [2.4431652557021435, -6.325379327987244],
            [2.4384462402960034, -6.329824851055205],
            [2.4373567840159476, -6.335235450024927],
            [2.4408904190359113, -6.338462126160569],
            [2.45040840823086, -6.323930898091871],
            [2.4509566307221684, -6.319022113596489],
            [2.4562073569094625, -6.317772358118608],
            [2.4583914065120847, -6.3202102388113675],
            [2.4544209382773525, -6.327891967755994],
            [2.4532290847620066, -6.332927533749043],
            [2.4535265127034163, -6.342105312327699],
            [2.455908065667521, -6.351349075310792],
            [2.458390600678911, -6.3554294999049326],
            [2.462650360503376, -6.354915796248461],
            [2.4659269081626696, -6.351842595087906],
            [2.468945469950002, -6.34276233204812],
            [2.472169645613048, -6.338380587053177],
            [2.4755983859283517, -6.337308164695742],
            [2.476326086499932, -6.3417480568802675],
            [2.4713906157228114, -6.349299311425756],
            [2.4680916569807305, -6.357460907862],
            [2.4670400313311647, -6.362311761961645],
            [2.462486695854537, -6.361596603976837],
            [2.4625760661109903, -6.366311979465062],
            [2.467540364078905, -6.368777958780864],
            [2.4732245030787596, -6.367558540112622],
            [2.4792197727377654, -6.3683688532221465],
            [2.489933764740154, -6.367614592057535],
            [2.492957433294149, -6.368540756328932],
            [2.495333784270075, -6.374780378910541],
            [2.492071423857947, -6.379227421347372],
            [2.496036052239549, -6.3797498944924405],
            [2.5021718664006127, -6.374986972906124],
            [2.5025506989116044, -6.378083677714513],
            [2.496513916237124, -6.382553230875476],
            [2.4945241951263593, -6.38611253799644],
            [2.4986038761168414, -6.388812703028401],
            [2.5105638227273905, -6.384363342111642],
            [2.511631914554794, -6.383007877338037],
            [2.5117282446225144, -6.372895922754796],
            [2.5167923775696828, -6.37026997053759],
            [2.5179004712014637, -6.375050126543525],
            [2.5167720914712963, -6.379558547190966],
            [2.518217281519928, -6.384397894634631],
            [2.5230052461567043, -6.3875994433326895],
            [2.5272200834426197, -6.388113965101956],
            [2.525036845395464, -6.393435915119273],
            [2.521299316116178, -6.393276844771098],
            [2.516636716208487, -6.389568343856847],
            [2.5131803217554096, -6.389249804655021],
            [2.51053251175905, -6.392636330416923],
            [2.5120590880046003, -6.395618620874346],
            [2.5207409093440205, -6.39518800411709],
            [2.52527962807963, -6.401326883320501],
            [2.5260388832277068, -6.407634400097359],
            [2.5294724516150833, -6.40765616292375],
            [2.530053829568452, -6.399621264070436],
            [2.532387335149375, -6.397069756052538],
            [2.5415115103901185, -6.401999232156536],
            [2.5413721595665786, -6.407149596847518],
            [2.534208385015295, -6.410533374245034],
            [2.532645084111584, -6.413477714827353],
            [2.5333124523034822, -6.420429833113602],
            [2.520926733154888, -6.422025825931121],
            [2.5241625153238405, -6.42419139360858],
            [2.5327145297850904, -6.42550270133309],
            [2.536339576351759, -6.424322100159087],
            [2.540362798338481, -6.4189439225378635],
            [2.5500132759253686, -6.416226725255786],
            [2.5534974502033907, -6.417803114931669],
            [2.5531353003579684, -6.4260638610329055],
            [2.5471099311127685, -6.4363339171185885],
            [2.545469526298625, -6.441764361579015],
            [2.5502925090613995, -6.442475738056629],
            [2.5602586380093513, -6.433132273729948],
            [2.5570915311761238, -6.440039752309342],
            [2.5585732529974434, -6.4424982874489505],
            [2.5661999170626086, -6.4447953712377615],
            [2.572995825714867, -6.448776229836602],
            [2.5738513123763775, -6.451837381990716],
            [2.572534219276213, -6.456110556856099],
            [2.5750982721454627, -6.466362841168875],
            [2.575247970623252, -6.470696246202052],
            [2.583595953529899, -6.471987436292028],
            [2.5843069881835476, -6.467407561050055],
            [2.5796285705552435, -6.464264466498515],
            [2.5783938638034627, -6.457024868536566],
            [2.584587422381201, -6.4589031656155464],
            [2.58764808893933, -6.463806345428636],
            [2.5910769467563375, -6.465441319661501],
            [2.596945758013969, -6.462774981236087],
            [2.5984917180428604, -6.466653738480156],
            [2.5936047899956636, -6.468938459377084],
            [2.5895673299415853, -6.474164881051947],
            [2.592896851656225, -6.476629635755701],
            [2.567035611510334, -6.476995082114026],
            [2.4707052699800767, -6.479425480190625],
            [2.4692346865554, -6.474055036153666],
            [2.469271291150837, -6.46857097655789],
            [2.4672720306231164, -6.460047169724385],
            [2.470453687967904, -6.4518805768978345],
            [2.470253385431062, -6.447383211457093],
            [2.4664193279192657, -6.443354047154737],
            [2.4616802114137397, -6.433666481124605],
            [2.4562133269117514, -6.431435905731678],
            [2.449801114450612, -6.42718181324439],
            [2.4469396231779066, -6.419915743075397],
            [2.444254374188324, -6.418716833653643],
            [2.4423777254692056, -6.4133098435889515],
            [2.4311278032343404, -6.406947469035112],
            [2.4292333266660298, -6.402947492800277],
            [2.42517322195788, -6.400693209045647],
            [2.420604064630666, -6.40169000875052],
            [2.417881925362934, -6.399872462719791],
            [2.4119628632525925, -6.4016460962135895],
            [2.406220172850513, -6.401737121512526],
            [2.400211437571584, -6.394783701304499],
            [2.3967723923188773, -6.395537066868066],
            [2.395743523567318, -6.400246781710638],
            [2.3925048742140382, -6.399845880414564],
            [2.3884651753012647, -6.403026686830214],
            [2.383460349709276, -6.40247582581456],
            [2.380195723557298, -6.396541675086899],
            [2.375122358207483, -6.390890169249596],
            [2.3713809117433824, -6.393649382086571],
            [2.3649316544102463, -6.393418455640603],
            [2.3573193150041334, -6.378585405437914],
            [2.3536315116580933, -6.380066407447086],
            [2.3503797313809454, -6.376450001831242],
            [2.3365159677773333, -6.375665999275594],
            [2.332884942258542, -6.380672634483913],
            [2.3278657424873392, -6.377172397224867],
            [2.3186458256992055, -6.383699961567955],
            [2.316345338900184, -6.383031478055012],
            [2.311087530361886, -6.389946263283275],
            [2.3067534629414936, -6.393195741180964],
            [2.308214501894622, -6.397276509908894],
            [2.3049451244213537, -6.400775170044076],
            [2.306529638772335, -6.407493190638421],
            [2.303769427390665, -6.411466645008821],
            [2.294901296648031, -6.416038965960362],
            [2.2934673806004753, -6.418773613425544],
            [2.288553355637268, -6.419357949782147],
            [2.2838566180213196, -6.422782909778434],
            [2.278299391198007, -6.428504195198104],
            [2.2719050622547976, -6.430301940731768],
            [2.271056064665546, -6.435720700908648],
            [2.2662169586416314, -6.440768258674909],
            [2.2670713557685196, -6.4440153756955585],
            [2.264768504797035, -6.45535325179341],
            [2.2664100627133683, -6.459357889160632],
            [2.265248732292407, -6.464507268706938],
            [2.2624100714158653, -6.469879877846804],
            [2.2515346849187385, -6.476261455146869],
            [2.252327977562017, -6.480208994478497],
            [2.2438408711049194, -6.485878793625148],
            [2.233247576358304, -6.495753630374772],
            [2.227854313072733, -6.4974264113082025],
            [2.2254190429645457, -6.500581504658927],
            [2.216493304793954, -6.505822996300086],
            [2.207033412788192, -6.51252036222007],
            [2.1885158266231137, -6.527824356456363],
            [2.111565330245728, -6.5289963997223674],
            [2.1099491001767774, -6.455551543926677],
            [2.107998551383809, -6.361723263946872],
            [2.1072678456825904, -6.333029731733072],
            [2.105649182479005, -6.2549876595892995],
            [2.1051582929457764, -6.238825852925727],
            [2.1035546051056366, -6.161161408248145],
            [2.1021681465082636, -6.081966671290902],
            [2.1008346045909247, -6.032408022657316],
            [2.09944930998283, -5.957426832945579],
            [2.0987725794534184, -5.927931570797418],
            [2.09744066216796, -5.853875934858309],
            [2.097157669834274, -5.844268422978633]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.88240261204655, "lat": 32.58057201550829 },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22017"],
        "coty_name": ["Caddo"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Caddo Parish"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00558458"
      },
      "bbox": [
        2.0942305385462805, -6.5289963997223674, 2.5984917180428604,
        -5.701732201672718
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.366207627151411, -7.59008863711887],
            [5.44745215392851, -7.58481173974444],
            [5.562329462500551, -7.577565691802591],
            [5.608473476746252, -7.5741753233557425],
            [5.610733741582462, -7.574331974528482],
            [5.6531000447209685, -7.571600345278755],
            [5.709561151920781, -7.5673706022274265],
            [5.727430443565947, -7.566237789894349],
            [5.7984454146307725, -7.5618403253479824],
            [5.803171040801341, -7.563194977120438],
            [5.807567462220962, -7.559662108957013],
            [5.815419798420064, -7.557763275472113],
            [5.819303776484411, -7.56003148895388],
            [5.817890851264538, -7.5626657693946155],
            [5.813169172428398, -7.5630087405961515],
            [5.8145605452460085, -7.567016268743787],
            [5.820278416085138, -7.568906869738835],
            [5.81878877675873, -7.5825781112046995],
            [5.814295386577325, -7.584707621941424],
            [5.814372825886357, -7.58810925908833],
            [5.821162615969189, -7.590957853522743],
            [5.821759254906159, -7.595525032698558],
            [5.81523410439384, -7.595897410611055],
            [5.803000567980282, -7.61177519469205],
            [5.799140438083661, -7.619938381273235],
            [5.799825797179948, -7.623833829515657],
            [5.80499186248931, -7.627262536305496],
            [5.806228948342618, -7.630117636979877],
            [5.803379965150862, -7.634944871634246],
            [5.805246636097004, -7.6397153065873304],
            [5.81006395665808, -7.640227600267563],
            [5.810611197502528, -7.643661494494099],
            [5.806496630221407, -7.649910001751501],
            [5.800091843884683, -7.648272765405224],
            [5.794503126441137, -7.651711924360833],
            [5.795272713132611, -7.655819543517345],
            [5.798632668143751, -7.657110738512321],
            [5.801645270786148, -7.662041211146388],
            [5.79851801318968, -7.666989268936339],
            [5.79014624998297, -7.664462476314505],
            [5.787508426376093, -7.667152039578318],
            [5.791478508729814, -7.681443583349388],
            [5.785506447928894, -7.682993174807976],
            [5.784113956526986, -7.688962786265493],
            [5.785245781001222, -7.690656061500965],
            [5.794049308561689, -7.697074081911203],
            [5.794456673122112, -7.699571215487911],
            [5.791841992265779, -7.708884535018373],
            [5.789358131818884, -7.710463134944424],
            [5.785760414772361, -7.708161450509868],
            [5.781059305798277, -7.710514168267132],
            [5.785129363223944, -7.717727677670861],
            [5.781294559363216, -7.717981603402847],
            [5.776863203776195, -7.7131385588829415],
            [5.774398835044965, -7.714290171766398],
            [5.7790556530329615, -7.720235994569058],
            [5.777217632935868, -7.726458409305154],
            [5.777016292784923, -7.732298689844492],
            [5.783154949088849, -7.73662632902143],
            [5.780366288347965, -7.739985632880682],
            [5.785122801694813, -7.745868330383539],
            [5.7822719909584475, -7.748057670243342],
            [5.776981740200021, -7.743994769267548],
            [5.7710465771685575, -7.743913263243421],
            [5.770547207611543, -7.7496040835087205],
            [5.77292200874477, -7.752854516961685],
            [5.767171730966641, -7.758024715339481],
            [5.7671358030852575, -7.762430696225752],
            [5.7615774478127495, -7.767285158473888],
            [5.767556478261321, -7.772321614621777],
            [5.766191827808279, -7.775874430196338],
            [5.761673566927419, -7.776795620010407],
            [5.759743309700926, -7.771599015647985],
            [5.755188092547876, -7.770452472373494],
            [5.753466553343486, -7.774591589330649],
            [5.756015291367691, -7.78120879351289],
            [5.751731728853362, -7.786205806304179],
            [5.748355785672137, -7.782653386291273],
            [5.7465678044698905, -7.786326510864867],
            [5.749256594468716, -7.7911576298333545],
            [5.748711438476972, -7.797244197331489],
            [5.745863067511768, -7.801634379592098],
            [5.7515975762134355, -7.806735841597275],
            [5.751140188244455, -7.809698783558016],
            [5.746210611433357, -7.810088953874113],
            [5.7493373231815, -7.8145420407258],
            [5.755015238515132, -7.810881371663179],
            [5.752656438703773, -7.818322615141403],
            [5.753572292465849, -7.823465304673229],
            [5.758414389981871, -7.824554507811191],
            [5.7604028703659615, -7.8277765008876505],
            [5.751976196208706, -7.829420696928822],
            [5.746447161184199, -7.829007369244411],
            [5.743986247082126, -7.831465877202465],
            [5.744341752363787, -7.83787256502436],
            [5.752150085199131, -7.8405378476435414],
            [5.751005985346357, -7.849278156605032],
            [5.745711102534938, -7.849743374254467],
            [5.738119341340926, -7.8590598167963535],
            [5.740310435475056, -7.863698840660396],
            [5.744953002005083, -7.8618827720219855],
            [5.747141604363888, -7.866201303629335],
            [5.748003372480612, -7.874494035306297],
            [5.746912825508441, -7.875154294512434],
            [5.739338561783306, -7.896074711941672],
            [5.742319763071452, -7.897153861209854],
            [5.744265151090563, -7.900217324618261],
            [5.743770356048721, -7.899792941795812],
            [5.719554067987744, -7.90146695310574],
            [5.715810740004403, -7.902319219074496],
            [5.691365318208335, -7.9040970114398155],
            [5.6124261910822195, -7.908723941644147],
            [5.605815710331967, -7.9075311407319235],
            [5.512323265378988, -7.8943447512846925],
            [5.503024652351273, -7.89267319148461],
            [5.449581440342035, -7.884790555458471],
            [5.420811266541506, -7.880786386456156],
            [5.386911087098538, -7.875760694855472],
            [5.3856340865117796, -7.871915392840343],
            [5.386951301042543, -7.864803423197727],
            [5.385100998189898, -7.855648415352007],
            [5.386346319773209, -7.8511192611966845],
            [5.380819202656769, -7.848667482069807],
            [5.379779068336236, -7.839208499676979],
            [5.374913955394624, -7.837344468004973],
            [5.3750126230422905, -7.833399175352225],
            [5.377428847372859, -7.827034380248975],
            [5.377672569280095, -7.823161813065399],
            [5.366497382149518, -7.814065123688033],
            [5.3641157319117925, -7.810025803238113],
            [5.363488429796596, -7.804893404413298],
            [5.36156956430291, -7.803404748768878],
            [5.3621295081634965, -7.795719271307566],
            [5.358188655437068, -7.793550051029815],
            [5.357065692744428, -7.790253186089732],
            [5.354102259387867, -7.789136109343595],
            [5.349069812045741, -7.784439869859512],
            [5.347629216053976, -7.778402798416656],
            [5.350750558243635, -7.771527495940222],
            [5.350851573795172, -7.7687535062115165],
            [5.344676312194449, -7.761161623074058],
            [5.345445360119991, -7.7553258150179145],
            [5.342730110449074, -7.749873471157914],
            [5.342916212847936, -7.746080850497367],
            [5.339718107792133, -7.740904816538793],
            [5.33321214841418, -7.737322759164254],
            [5.329110151977609, -7.729251278434757],
            [5.326426733133863, -7.72141474506423],
            [5.324259259005951, -7.7192735662947625],
            [5.325905944962785, -7.715208700130629],
            [5.324341863454079, -7.710989797465598],
            [5.3237654836378, -7.701661626359948],
            [5.312673691918283, -7.702326856567538],
            [5.311999992487804, -7.691362300273327],
            [5.308299270620935, -7.688207062396429],
            [5.2974476657882805, -7.688814338611899],
            [5.294983914528858, -7.652744867532464],
            [5.291941867283725, -7.601696778071508],
            [5.2913744904907265, -7.59483694474046],
            [5.366207627151411, -7.59008863711887]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -90.04052358375816,
          "lat": 30.853322957283012
        },
        "year": "2023",
        "ste_code": ["22"],
        "ste_name": ["Louisiana"],
        "coty_code": ["22117"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "parish",
        "coty_name_long": ["Washington Parish"],
        "coty_fp_code": "117",
        "coty_gnis_code": "00559557"
      },
      "bbox": [
        5.2913744904907265, -7.908723941644147, 5.821759254906159,
        -7.557763275472113
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.87793468343578, 6.250945853170399],
            [17.987098409640016, 6.274888380341702],
            [18.11425554838685, 6.303824457527825],
            [18.210409702690704, 6.325713292005042],
            [18.26771719617815, 6.338826529903477],
            [18.2832645557439, 6.341930729586304],
            [18.30873265850484, 6.3484506519775055],
            [18.315824878876764, 6.365088688000709],
            [18.319817792096508, 6.381284134143938],
            [18.325999720543344, 6.394041023253082],
            [18.35489870404585, 6.333528482637399],
            [18.354215799033717, 6.324636549847473],
            [18.34918506884023, 6.321897548437912],
            [18.345888985714403, 6.317048555805908],
            [18.416064627318775, 6.293637384751835],
            [18.41348803206143, 6.29095053978198],
            [18.4114110533567, 6.283940688645402],
            [18.425740177411427, 6.277030512439663],
            [18.425429768677866, 6.280914466482215],
            [18.42702359794157, 6.287350457318251],
            [18.426284330586334, 6.292629805279275],
            [18.428647076718477, 6.2956600216830925],
            [18.433267055896174, 6.294714503418123],
            [18.439496942158858, 6.2869198173484415],
            [18.446247971626107, 6.283618872117899],
            [18.486831161003753, 6.299631222948379],
            [18.497834440930315, 6.307684725388984],
            [18.4981383276593, 6.304917955808695],
            [18.521492008556354, 6.289579138728918],
            [18.528491954494367, 6.279631097162824],
            [18.524439416738876, 6.274587985691235],
            [18.519304035351656, 6.276562260076066],
            [18.514120514579698, 6.272692684638746],
            [18.508108668515394, 6.2740597103161635],
            [18.505731226104174, 6.261156674703223],
            [18.503085732377507, 6.254000944403585],
            [18.506620553762055, 6.229200654771046],
            [18.51377496343797, 6.224841112211587],
            [18.520885017565107, 6.225900348391424],
            [18.532029912783074, 6.231041566900503],
            [18.536154342987942, 6.219996126985457],
            [18.538773645511363, 6.218519565133504],
            [18.541428496903812, 6.213347774485406],
            [18.53978061239683, 6.208723868878542],
            [18.536603243423286, 6.206298978995087],
            [18.540709959365987, 6.201957258734547],
            [18.53884779712324, 6.19397003695902],
            [18.534292838814444, 6.189994145507614],
            [18.535561649275866, 6.18084896339578],
            [18.564061384064317, 6.15510771569937],
            [18.56961534592024, 6.149899903279356],
            [18.56712138342616, 6.12905794083049],
            [18.566864600812888, 6.123390971863872],
            [18.564795243171126, 6.111025375548748],
            [18.560824151631273, 6.104421609425793],
            [18.558248697753317, 6.093849624985985],
            [18.551009393934674, 6.091396954855657],
            [18.544123877120214, 6.094947650460985],
            [18.54182457045307, 6.083186211249992],
            [18.54561954003781, 6.083325386039184],
            [18.549848522702295, 6.076642081580981],
            [18.55386126584049, 6.076840761142792],
            [18.55051846489301, 6.067612517708633],
            [18.54959284160433, 6.0621439993612265],
            [18.541321935733126, 6.055380035685041],
            [18.532550959032655, 6.051035599662506],
            [18.526069795136408, 6.050040711664439],
            [18.52288451998959, 6.051549553492439],
            [18.519494737427703, 6.063063381528084],
            [18.514850065352242, 6.063453935547725],
            [18.51009909412005, 6.066990475061551],
            [18.506892696295658, 6.064857887370963],
            [18.50836163793355, 6.061677123607596],
            [18.50418927056378, 6.055953931076221],
            [18.500828186968054, 6.05545512356143],
            [18.49906897204313, 6.051149780245119],
            [18.488713022082695, 6.045704808889509],
            [18.485659838165965, 6.04649900705137],
            [18.482920518926164, 6.038853123366057],
            [18.483122614823323, 6.035661479741255],
            [18.491533841221468, 6.0272702228157815],
            [18.490352629613653, 6.025339573091374],
            [18.492627418290006, 6.020754828119596],
            [18.497292135910527, 6.022200586556232],
            [18.500890537507857, 6.019790842402073],
            [18.489532073681872, 6.000112811473611],
            [18.50235933325829, 5.992656135375351],
            [18.494870329244133, 5.981093971777434],
            [18.488932847813246, 5.967491017779021],
            [18.477290222543576, 5.971213897544386],
            [18.473444871616373, 5.978057531340169],
            [18.470161732234946, 5.979852354591336],
            [18.467278540063244, 5.985751288808921],
            [18.462080696827076, 5.984626821941275],
            [18.457215904381695, 5.985245942812306],
            [18.453354136446897, 5.995201056200772],
            [18.45098055690678, 5.99652053871687],
            [18.445376300969574, 5.99613691006885],
            [18.439619715962408, 5.993854567149304],
            [18.433787550626096, 5.998209614365675],
            [18.431212367198643, 5.995171299327037],
            [18.421363617533643, 5.996296834317729],
            [18.382826817653843, 5.970467746839899],
            [18.391174542349106, 5.956536654847256],
            [18.408875730972408, 5.933545703477117],
            [18.418612972508654, 5.9128738408032175],
            [18.397390840058915, 5.908095190094667],
            [18.400540292389604, 5.905017688123163],
            [18.401291373312475, 5.897219974662126],
            [18.403450411462778, 5.893379227602953],
            [18.397693934947277, 5.882682414716746],
            [18.397159369752874, 5.878542580223414],
            [18.40134981212028, 5.875795330072486],
            [18.401183883979645, 5.872621061754539],
            [18.395866128694628, 5.872995267135349],
            [18.3940330986248, 5.870814115192493],
            [18.394186946861904, 5.864036415581245],
            [18.40158775948291, 5.859080278262574],
            [18.390193341651006, 5.850951995686662],
            [18.37911587311749, 5.845658697613474],
            [18.36189472418879, 5.835899804064488],
            [18.365895211599323, 5.82696570947785],
            [18.350943054240595, 5.822342487099105],
            [18.34590683430306, 5.822317793634785],
            [18.337178328128754, 5.815362928318737],
            [18.327280410717375, 5.795469218074229],
            [18.317597799946565, 5.791458243045264],
            [18.315328165693575, 5.800279077602575],
            [18.301356385589877, 5.797412257304982],
            [18.291262675656572, 5.820428186443792],
            [18.28886449097204, 5.817220970117147],
            [18.26561461497095, 5.811960656979252],
            [18.255751062615403, 5.801893080220217],
            [18.252460564264176, 5.811334917205448],
            [18.241365292126304, 5.808725889313754],
            [18.24138840812776, 5.8107205020074835],
            [18.233070761485163, 5.809484414208626],
            [18.213565138533504, 5.827733507424751],
            [18.21396525754468, 5.870753617291102],
            [18.227871563112693, 5.881969577267115],
            [18.233219730953955, 5.884681539585492],
            [18.23636549283654, 5.884776639813962],
            [18.24663865519595, 5.8826626678601945],
            [18.251033608501537, 5.887244334926271],
            [18.256291269071127, 5.888413328193677],
            [18.26371412136684, 5.892098176743248],
            [18.269825780371427, 5.890273357718462],
            [18.268026813030122, 5.898772354070219],
            [18.27227590771689, 5.9387324900672045],
            [18.269892326788177, 5.95127375904185],
            [18.266889788035986, 5.957760279340238],
            [18.252259925530787, 5.951582475859447],
            [18.245740181045957, 5.952367045176937],
            [18.222177872252416, 5.942117014715382],
            [18.210963220154028, 5.932949102896676],
            [18.201918038125864, 5.920831433834202],
            [18.19496036741208, 5.926207915163863],
            [18.190710655948383, 5.928322788374909],
            [18.18275949553919, 5.9357126650498016],
            [18.18189943171933, 5.942329568707868],
            [18.176053982987078, 5.9431059600739795],
            [18.17035479469503, 5.945341104675437],
            [18.163160082784547, 5.950849624405246],
            [18.17243128929524, 5.9612167644103495],
            [18.174839582830643, 5.972055280889828],
            [18.170803164541624, 5.973853207122915],
            [18.18604042454702, 5.995380608244988],
            [18.166219907645473, 6.001306605249983],
            [18.177293843821076, 6.013920809577561],
            [18.194613089452012, 6.023463313330243],
            [18.19179249753457, 6.079139235657979],
            [18.177740064359686, 6.083636561624474],
            [18.185834260212367, 6.126089282354932],
            [18.18649846263561, 6.133528966341918],
            [18.17544628943954, 6.154100367943157],
            [18.144155220004357, 6.1536130620323535],
            [18.135815922244518, 6.14410183936971],
            [18.125937338040586, 6.143594554095079],
            [18.115568209692764, 6.148256792037437],
            [18.11066428490634, 6.1423224167928705],
            [18.107458161663835, 6.133211693166856],
            [18.108670264904312, 6.126417144399377],
            [18.10741344779471, 6.123844961103446],
            [18.111546188617694, 6.117750294975249],
            [18.079380623633252, 6.116001216376458],
            [18.077998243505846, 6.124930614293836],
            [18.06887326972385, 6.197210058608597],
            [17.98193491687151, 6.208374756336365],
            [17.98415877602402, 6.2011288829050875],
            [17.934634493279013, 6.189686534727768],
            [17.92603646551989, 6.1831569782042815],
            [17.91896203631697, 6.2162904390466],
            [17.916141671005853, 6.2231464334923565],
            [17.910745159853054, 6.22647517700559],
            [17.9081802623648, 6.23052533575062],
            [17.905449583011258, 6.229341435281715],
            [17.881055292672247, 6.243800929580024],
            [17.87793468343578, 6.250945853170399]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -71.39177386859377, "lat": 42.48553185989491 },
        "year": "2023",
        "ste_code": ["25"],
        "ste_name": ["Massachusetts"],
        "coty_code": ["25017"],
        "coty_name": ["Middlesex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Middlesex County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "00606935"
      },
      "bbox": [
        17.87793468343578, 5.791458243045264, 18.56961534592024,
        6.394041023253082
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.077443917128, 4.515062704713531],
            [8.127094432336841, 4.521188953327694],
            [8.193804403451033, 4.529147525668067],
            [8.248358111599362, 4.5358488366465295],
            [8.276186774689439, 4.538851808100215],
            [8.333050759586541, 4.545316730955115],
            [8.418908056632992, 4.556180461845094],
            [8.427999549873913, 4.46919584843011],
            [8.4332121763156, 4.42549053609713],
            [8.440245220909945, 4.367888502315843],
            [8.446860264032145, 4.3152532641218295],
            [8.453319251736893, 4.265994805058415],
            [8.461151080981143, 4.208202509075379],
            [8.421268541197412, 4.203157615557958],
            [8.359199495489312, 4.19564627779428],
            [8.29572406044678, 4.187752706074181],
            [8.266957134933781, 4.184392508962164],
            [8.203641686162838, 4.17778201696858],
            [8.181898038364366, 4.175914113845737],
            [8.13048475379536, 4.1709933747382095],
            [8.117471388302377, 4.169482646497287],
            [8.112446889605707, 4.2132206005764585],
            [8.104882019647142, 4.284267870073356],
            [8.09870954211686, 4.338536439859412],
            [8.096219623397792, 4.35688665917161],
            [8.087352048086656, 4.42865496178307],
            [8.077443917128, 4.515062704713531]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -85.3089660890553, "lat": 42.59503140315926 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26015"],
        "coty_name": ["Barry"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Barry County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01622950"
      },
      "bbox": [
        8.077443917128, 4.169482646497287, 8.461151080981143, 4.556180461845094
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [8.71835525587027, 4.2384029141611155],
            [8.804292589099012, 4.249146690551254],
            [8.890289660393123, 4.2596649170775205],
            [8.944015347653982, 4.266147966158363],
            [8.975811435508403, 4.270140856527429],
            [8.975482367778573, 4.272676254118391],
            [9.024650457197017, 4.278688061978073],
            [9.095230817865787, 4.287648319473487],
            [9.138583995216338, 4.292798125980379],
            [9.145558467101006, 4.293626319267234],
            [9.156219385617028, 4.206481855031285],
            [9.167707985220245, 4.119804414307779],
            [9.169965673251207, 4.09817938069391],
            [9.175433280339032, 4.039004539554648],
            [9.179870335040203, 4.006426794287434],
            [9.182562410164056, 3.988616794558427],
            [9.189218071350732, 3.9418446484269833],
            [9.153927630785825, 3.93967606840475],
            [9.104407165357369, 3.932986439946789],
            [9.019767541831705, 3.922736094635244],
            [8.977994526415934, 3.9172289049308238],
            [8.935957400840591, 3.9119711114961695],
            [8.925224538150212, 3.9103769741255268],
            [8.865046595452586, 3.9022646315961844],
            [8.766762378192793, 3.889015315467996],
            [8.756054979160927, 3.9687659401567705],
            [8.754760207455352, 3.9774078863320512],
            [8.740296486310971, 4.064467370150098],
            [8.728644421047894, 4.151684081526358],
            [8.71835525587027, 4.2384029141611155]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.42342690254013, "lat": 42.2484904527144 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26075"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01622980"
      },
      "bbox": [
        8.71835525587027, 3.889015315467996, 9.189218071350732,
        4.293626319267234
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.665365767419031, 8.211364555907954],
            [4.68832756207108, 8.242126004517921],
            [4.701427268755158, 8.252261053467368],
            [4.7282490732629, 8.267395733590039],
            [4.748783306846564, 8.27432348247179],
            [4.753741994096631, 8.276452964809975],
            [4.774387068868872, 8.282559358593467],
            [4.783321285879925, 8.283922304916157],
            [4.788950967640664, 8.283271610577751],
            [4.797220823806869, 8.284376498669902],
            [4.806348491400881, 8.287441400613853],
            [4.815231392947239, 8.28588161495945],
            [4.8304465707242965, 8.279885722864226],
            [4.832237576988158, 8.27626663458628],
            [4.837223687252386, 8.274956860555235],
            [4.848511171408435, 8.27666286665553],
            [4.856723598428036, 8.28059368791633],
            [4.860401237999915, 8.28427979403655],
            [4.868213119454936, 8.287671591818349],
            [4.8865915812762255, 8.294141191679861],
            [4.88964467218491, 8.296431632808504],
            [4.89458863174651, 8.29509784934173],
            [4.900537038848292, 8.29633915447535],
            [4.910805611102209, 8.300281980746501],
            [4.915034072611798, 8.303202237465754],
            [4.9228824954521775, 8.301963400434907],
            [4.927541510342496, 8.303211696813658],
            [4.930809676325782, 8.300925404050274],
            [4.937956664806635, 8.301858342668698],
            [4.9443915607558395, 8.300772877997519],
            [4.967879516319181, 8.30450289063804],
            [4.982572373347766, 8.309926684430424],
            [4.996986721440679, 8.317586778643195],
            [4.99989797120037, 8.31970767345906],
            [5.024320900525209, 8.331565067785707],
            [5.029954401310648, 8.335925562628988],
            [5.036932211136877, 8.342743517974496],
            [5.041540348356376, 8.345792063410418],
            [5.050778930218609, 8.349501447673989],
            [5.06194479708441, 8.358768090461517],
            [5.069509441290679, 8.361275659199912],
            [5.087050977093767, 8.37451591479894],
            [5.092113781471769, 8.376155941194767],
            [5.105961253195837, 8.386640393979134],
            [5.111837575175176, 8.392559064619741],
            [5.1227347973761495, 8.405794465216319],
            [5.1347275729343425, 8.42670365247035],
            [5.137264435842727, 8.435003734026344],
            [5.139743548810392, 8.439324739803082],
            [5.1500186359486175, 8.445400917072702],
            [5.155579884800355, 8.453065872978526],
            [5.155677658643191, 8.455999914134852],
            [5.1591855687131005, 8.461417493040656],
            [5.168128116171577, 8.469697960288393],
            [5.175091215491563, 8.471797257617883],
            [5.178982565633581, 8.467275068376859],
            [5.183893013738522, 8.464788695101584],
            [5.192428108341555, 8.464082777911162],
            [5.203190898779161, 8.465459764888227],
            [5.213253810728111, 8.468921259851728],
            [5.220750305174987, 8.475351401857164],
            [5.2255079579526935, 8.477690291894268],
            [5.228598493049894, 8.480790053659367],
            [5.2356889130013045, 8.483003828249274],
            [5.2401845070667346, 8.477387964898938],
            [5.244774326878465, 8.476655811717082],
            [5.256965266008197, 8.47880221958046],
            [5.26449119696868, 8.481252357164276],
            [5.273970503637548, 8.486740853753002],
            [5.282650002065045, 8.49369513417909],
            [5.288110543440508, 8.499631014022057],
            [5.298808570694474, 8.517279847370308],
            [5.309480031030537, 8.382854821300706],
            [5.312151179399721, 8.346996876881592],
            [5.317133763089135, 8.284616578578394],
            [5.317642002059466, 8.270348152117275],
            [5.319076591125608, 8.255622867557648],
            [5.366081427278213, 8.259328638753592],
            [5.372097098566303, 8.175028321518694],
            [5.286172215585518, 8.169486314527575],
            [5.291698809826224, 8.083861268320822],
            [5.299773332345935, 7.97142822363023],
            [5.304126393980851, 7.9130514485399575],
            [5.310703407438049, 7.826947557595075],
            [5.296073094549465, 7.826415470862248],
            [5.224133707081458, 7.8210200611373955],
            [5.138119110645098, 7.815166204208307],
            [5.052105961112863, 7.809290585032261],
            [5.050502967120996, 7.823511730740987],
            [5.049523913337051, 7.8381523612480155],
            [5.049334869964767, 7.8520125234690346],
            [5.045988077726956, 7.894242709568185],
            [5.040849925705468, 7.969715922788075],
            [5.040365661768871, 7.979662533176164],
            [4.912127826801852, 7.971141081058442],
            [4.8469520093427665, 7.966557087227449],
            [4.781777158077595, 7.961960433740438],
            [4.779261484223817, 8.005536686978889],
            [4.776469262594993, 8.047537102377744],
            [4.690863456910083, 8.042149203125495],
            [4.680188227680405, 8.21224220734846],
            [4.665365767419031, 8.211364555907954]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.3147481780313, "lat": 46.664397375444146 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26131"],
        "coty_name": ["Ontonagon"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ontonagon County"],
        "coty_fp_code": "131",
        "coty_gnis_code": "01623008"
      },
      "bbox": [
        4.665365767419031, 7.809290585032261, 5.372097098566303,
        8.517279847370308
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.852523722406783, 4.931183419069549],
            [7.862952869480446, 4.844521845449262],
            [7.864985073766044, 4.828782552857867],
            [7.870992188013366, 4.778562056977827],
            [7.8728704614093035, 4.7577564341871925],
            [7.879945228294969, 4.714201484568964],
            [7.883967105282989, 4.683364602025741],
            [7.890294454175106, 4.63953851752161],
            [7.896333088094028, 4.584274178994264],
            [7.899061585229625, 4.554805441938036],
            [7.9021840714686284, 4.5254944325844235],
            [7.905557234771552, 4.49641555993039],
            [7.876987946923037, 4.492913096196008],
            [7.839344556377231, 4.488626991059452],
            [7.8193251032695335, 4.4866548183271036],
            [7.776331277356154, 4.483173006221931],
            [7.720575196342672, 4.477506964332538],
            [7.630255079852818, 4.467370148822184],
            [7.596208733963303, 4.463166774642402],
            [7.593194064642193, 4.468327055290333],
            [7.593623450617254, 4.471947556690466],
            [7.592627457008423, 4.486682923660456],
            [7.587949304309302, 4.526562704777398],
            [7.58610821097749, 4.550933893032031],
            [7.5840931605135635, 4.564333012311639],
            [7.580386924929323, 4.578490700671557],
            [7.578690984320827, 4.592449680225747],
            [7.575222187654238, 4.61368934662704],
            [7.564976465404976, 4.663683701010179],
            [7.560757915652016, 4.6820102960138525],
            [7.553291001820328, 4.70892734674568],
            [7.541427787204812, 4.74187940882328],
            [7.535276337480973, 4.751751685416759],
            [7.535134163333912, 4.758672411320768],
            [7.530460424920576, 4.774728372607288],
            [7.51433249377861, 4.808283049246345],
            [7.562594469839937, 4.8126333176545755],
            [7.605306556977176, 4.816677807398305],
            [7.6983670132056705, 4.8275444849417815],
            [7.777522230719946, 4.836278352008571],
            [7.767564207869043, 4.922867357007848],
            [7.7882997627419455, 4.925128753645278],
            [7.852523722406783, 4.931183419069549]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -85.99604861485693,
          "lat": 42.959878939478955
        },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26139"],
        "coty_name": ["Ottawa"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ottawa County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01623012"
      },
      "bbox": [
        7.51433249377861, 4.463166774642402, 7.905557234771552,
        4.931183419069549
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.757911990698066, 5.285753608359301],
            [9.769752840766392, 5.287681424255454],
            [9.75618661407398, 5.373673007150959],
            [9.74207678411685, 5.459323994171254],
            [9.726618683990356, 5.544935689357781],
            [9.712439259103773, 5.63128691458079],
            [9.797472476224803, 5.646726158706038],
            [9.882275764203822, 5.661894528026274],
            [9.967423913452507, 5.676875303513845],
            [10.009236664885155, 5.684496231639652],
            [10.050881397075164, 5.692393406529288],
            [10.074763633560908, 5.696554153705714],
            [10.0751221771856, 5.6908064565728065],
            [10.077759292075184, 5.685103313712386],
            [10.079272187739424, 5.667807561578768],
            [10.081198790376732, 5.6641224882550585],
            [10.082500843972149, 5.655964990526658],
            [10.085518649747243, 5.649289223833487],
            [10.084450923553725, 5.6473152364482475],
            [10.085598603756955, 5.641404906409317],
            [10.088722125539423, 5.635839121406876],
            [10.092484624700305, 5.622913586726029],
            [10.090252141924081, 5.61900594240992],
            [10.09103246295841, 5.612078871115003],
            [10.095360604207626, 5.598054723041842],
            [10.098611077845106, 5.593250245411367],
            [10.102339792180006, 5.582698036299546],
            [10.105153548246244, 5.571389008829175],
            [10.109668468333462, 5.563030586561883],
            [10.110771940846224, 5.553197784226206],
            [10.119299924078371, 5.539114663329036],
            [10.120100995062117, 5.535308276175574],
            [10.124436145263681, 5.527780205674041],
            [10.125170744186955, 5.521623979522568],
            [10.130204931608812, 5.514962323663591],
            [10.132932366440858, 5.502959669269768],
            [10.137746889447769, 5.495861620887271],
            [10.141675758371406, 5.492394938232629],
            [10.1413285388125, 5.48936565567833],
            [10.14487104117154, 5.477899789560515],
            [10.150634674114867, 5.470871470791391],
            [10.150202303154883, 5.466259816387124],
            [10.151525076859372, 5.462107185566424],
            [10.15582605689006, 5.457479869546408],
            [10.158833683478527, 5.452253813833215],
            [10.160028975727737, 5.447751532275907],
            [10.160121857990537, 5.439044031803808],
            [10.161693170346664, 5.43534261439712],
            [10.16379107400601, 5.423968794601268],
            [10.164523669807409, 5.413759821442594],
            [10.170399708389782, 5.400103120854814],
            [10.170356480832234, 5.39446914383184],
            [10.171883772564179, 5.38934205129221],
            [10.171128503653268, 5.384209080243522],
            [10.17207579341895, 5.369651989098631],
            [10.173246684328081, 5.365115595456724],
            [10.178996822896021, 5.355430041879959],
            [10.183112597542289, 5.333903338490188],
            [10.18246335113882, 5.323224836875168],
            [10.18781815413458, 5.307377075899534],
            [10.190684372076005, 5.290032487516695],
            [10.192149871075932, 5.288145022405057],
            [10.192532221234648, 5.2781653572420755],
            [10.195938776664425, 5.270330867914263],
            [10.195313265489464, 5.268459510491434],
            [10.198094242727706, 5.259916077856749],
            [10.200558387059472, 5.244504385172884],
            [10.205196204010962, 5.232399061304989],
            [10.212266676134714, 5.2225890527226575],
            [10.214821231762887, 5.217600129537397],
            [10.215786459687054, 5.211634596778789],
            [10.22269289345894, 5.190592320571129],
            [10.12293494726228, 5.171471829570044],
            [10.080758268305804, 5.163823931104952],
            [10.017528091841523, 5.152153166842827],
            [9.985993326566811, 5.146514686133891],
            [9.90826581856195, 5.133019967214327],
            [9.870646779977694, 5.126394278587764],
            [9.858702419624287, 5.197886546922923],
            [9.849717912696125, 5.255714098086846],
            [9.764783037984003, 5.242881360384526],
            [9.757911990698066, 5.285753608359301]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.8202365362128, "lat": 43.423579774095415 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26151"],
        "coty_name": ["Sanilac"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sanilac County"],
        "coty_fp_code": "151",
        "coty_gnis_code": "01623016"
      },
      "bbox": [
        9.712439259103773, 5.126394278587764, 10.22269289345894,
        5.696554153705714
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.145558467101006, 4.293626319267234],
            [9.230094621658772, 4.303589971899478],
            [9.281295557860528, 4.310329586749468],
            [9.309423472273494, 4.3149493865002295],
            [9.377431437531213, 4.32636754302574],
            [9.411243800567691, 4.332255623588821],
            [9.426088153338688, 4.333277626051202],
            [9.483925196257212, 4.343512731040269],
            [9.565490212851092, 4.3582125438761095],
            [9.570304936182392, 4.330414365649167],
            [9.58725208255074, 4.230112065779267],
            [9.594155592614738, 4.187113894303229],
            [9.595437605208598, 4.173457979739375],
            [9.600011676558129, 4.143618396506473],
            [9.611714339506634, 4.069335273526271],
            [9.620593280305828, 4.011426366460528],
            [9.542516237493587, 3.9994703962715255],
            [9.535068624894084, 3.999199717996842],
            [9.449618609260321, 3.9859410090046206],
            [9.365260788012119, 3.9730332819990877],
            [9.285253473897338, 3.960460627545074],
            [9.278814060054698, 3.959632309656975],
            [9.279507795984314, 3.955257223503284],
            [9.189218071350732, 3.9418446484269833],
            [9.182562410164056, 3.988616794558427],
            [9.179870335040203, 4.006426794287434],
            [9.175433280339032, 4.039004539554648],
            [9.169965673251207, 4.09817938069391],
            [9.167707985220245, 4.119804414307779],
            [9.156219385617028, 4.206481855031285],
            [9.145558467101006, 4.293626319267234]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.8387468395243, "lat": 42.253209525333354 },
        "year": "2023",
        "ste_code": ["26"],
        "ste_name": ["Michigan"],
        "coty_code": ["26161"],
        "coty_name": ["Washtenaw"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washtenaw County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01623021"
      },
      "bbox": [
        9.145558467101006, 3.9418446484269833, 9.620593280305828,
        4.3582125438761095
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9919772774118727, 8.132126531272055],
            [1.9906117889816974, 8.217374664199836],
            [1.988744039241633, 8.302432955688749],
            [1.9872602229853087, 8.347762593822544],
            [1.9872019470641715, 8.356276631140146],
            [2.0043451864666264, 8.356267190948873],
            [2.0706696026928157, 8.35684459313713],
            [2.1267837361250925, 8.358711387862746],
            [2.2140972995082473, 8.359965565447487],
            [2.2578012016700075, 8.360956084144084],
            [2.302366354440334, 8.362171137600882],
            [2.3226061697937763, 8.361533348171575],
            [2.3871497111519275, 8.361611178703699],
            [2.479199958982909, 8.365561815415349],
            [2.480605303309133, 8.280127832941535],
            [2.48143496107447, 8.251499993155482],
            [2.482268123058573, 8.19474870580411],
            [2.4840698124561, 8.10951118563626],
            [2.484428784911675, 8.02059263913288],
            [2.486460234175823, 7.973924942587081],
            [2.4884788697397724, 7.938629374076283],
            [2.493933864728943, 7.93872649991217],
            [2.4936282135344827, 7.924707652290459],
            [2.4963228672815383, 7.853494103225762],
            [2.4992512715084803, 7.766983633910506],
            [2.502730999294304, 7.680869645807373],
            [2.5046521833164563, 7.608962360131359],
            [2.506710252135211, 7.543294803780211],
            [2.507918078394822, 7.509025221158868],
            [2.4507569826023827, 7.507415405921127],
            [2.4211976302608353, 7.506758513621995],
            [2.349097641341649, 7.50548510382113],
            [2.333923139463277, 7.504616102216844],
            [2.2543392317319197, 7.4977700399704155],
            [2.2459217702313263, 7.497156882144734],
            [2.24674589851935, 7.504996354273526],
            [2.2454154234234287, 7.558092751889336],
            [2.244249246406674, 7.588689472426011],
            [2.172670037649311, 7.58753970400957],
            [2.067842199737159, 7.58256306247984],
            [1.9909964471872328, 7.57920563256473],
            [1.9890057556199612, 7.584617265468061],
            [1.985353673406026, 7.583048488750956],
            [1.9824328804008435, 7.584575508963884],
            [1.9807074844881603, 7.588928759615459],
            [1.978107626179319, 7.708605211496006],
            [1.9773714839195877, 7.751237923869796],
            [1.9770024314206485, 7.758188012634536],
            [1.97399254329138, 7.837014268522701],
            [1.97426479346456, 7.8485012920277395],
            [1.97264482182977, 7.915889785428839],
            [1.982743696799065, 7.917766141824927],
            [1.9903315854683905, 7.921697325747063],
            [1.9956515773954253, 7.921783789733705],
            [1.9944606536292964, 7.961335803767999],
            [1.9925482985601766, 8.078985643083833],
            [1.9921672175855798, 8.079915079225927],
            [1.9919772774118727, 8.132126531272055]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.41551763970021, "lat": 46.60817489614443 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27001"],
        "coty_name": ["Aitkin"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Aitkin County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "00663198"
      },
      "bbox": [
        1.97264482182977, 7.497156882144734, 2.507918078394822,
        8.365561815415349
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.1006542361900549, 5.528536834504751],
            [1.1007641781076725, 5.615126434121564],
            [1.1766324127746464, 5.6166913102432],
            [1.2012208719412845, 5.616743281414973],
            [1.2729178904998826, 5.617555750741939],
            [1.2724653889440256, 5.653995311455983],
            [1.2713688116248685, 5.79083336396677],
            [1.2706454799753386, 5.832912676117576],
            [1.2759169990223798, 5.829561258505065],
            [1.2788710857583012, 5.8249445248265355],
            [1.2848307441903586, 5.827393184355372],
            [1.2948747262860738, 5.823989244621159],
            [1.2973678794051686, 5.819020428808145],
            [1.3007416975761936, 5.820581051793376],
            [1.3045589770928274, 5.818191303859881],
            [1.3066964185615308, 5.8145908716908705],
            [1.3097784695634611, 5.816660070977901],
            [1.3106771086655549, 5.806556423288511],
            [1.3226665677807992, 5.7963072425993],
            [1.3250113461200408, 5.791765928737771],
            [1.3317879016416894, 5.792201252965808],
            [1.3316990773966793, 5.78528564098832],
            [1.3345218057378492, 5.7824056320604384],
            [1.3404627878042714, 5.782552788733706],
            [1.3412389212152924, 5.778729821946684],
            [1.3445705953387448, 5.778804812232384],
            [1.3478703753988226, 5.782501029935635],
            [1.3542755028210187, 5.785617421868461],
            [1.366540130422703, 5.777934587435277],
            [1.3708173213772477, 5.7698853028811445],
            [1.384490950467791, 5.7706197448608965],
            [1.3936672700568782, 5.762295877214908],
            [1.392271141893016, 5.7581650974121015],
            [1.3877560733326515, 5.7529930802694285],
            [1.3905070745213963, 5.749594138038754],
            [1.3932558190399666, 5.753916100901608],
            [1.3977683791060715, 5.753841205604179],
            [1.4005328365340146, 5.7482287580131],
            [1.3976612636466064, 5.744456502014538],
            [1.3920112426878575, 5.743269623906765],
            [1.3949884797194392, 5.738702352488389],
            [1.3981788974137386, 5.743556596821381],
            [1.4029203531078225, 5.745614502325823],
            [1.4078290075504079, 5.744211657031871],
            [1.411382142543097, 5.739555308161101],
            [1.406320720361267, 5.7335129118749055],
            [1.4122892979872845, 5.73109619277928],
            [1.4166174004024983, 5.731881104680052],
            [1.4172177658736334, 5.7361373920599315],
            [1.4211191504207177, 5.734631523675635],
            [1.4238415236340753, 5.730662452511073],
            [1.4293917022591587, 5.734579765343096],
            [1.434401947860595, 5.732603426922751],
            [1.431620168742587, 5.727969587448357],
            [1.4379737569720543, 5.729191838245027],
            [1.441605497804038, 5.728452599474023],
            [1.4424882260198215, 5.721748427302831],
            [1.446197033433649, 5.719371927317186],
            [1.4506112551492807, 5.722773816744876],
            [1.45582675024992, 5.7222588712157165],
            [1.4609311017121516, 5.723481060577505],
            [1.4655262725098033, 5.720588715341807],
            [1.4668882864714539, 5.714319780965475],
            [1.4716810800679063, 5.7118567711997414],
            [1.4751849503507282, 5.714693035310145],
            [1.4767582297603379, 5.709802477108577],
            [1.4826684398532133, 5.713920453294961],
            [1.4876275818351046, 5.7141575299083485],
            [1.4895846125453935, 5.709453647858329],
            [1.4953623106124418, 5.709980065266482],
            [1.4977719515380679, 5.708485726562887],
            [1.4994830367404695, 5.702816198334687],
            [1.516628603291566, 5.703751848185869],
            [1.5204430892653478, 5.696461530739137],
            [1.5333684830451348, 5.690870681088121],
            [1.5357284735138776, 5.692776155406201],
            [1.5330725029638406, 5.698246576298188],
            [1.5346996809984896, 5.700395951543845],
            [1.5398254398696767, 5.697399846564025],
            [1.5391276236764526, 5.690992330407286],
            [1.54427602813789, 5.687752260174774],
            [1.5467808604852757, 5.683070110725215],
            [1.550728107820113, 5.6829942651179435],
            [1.5527687319049253, 5.67971316470103],
            [1.5610736002680214, 5.671550032381342],
            [1.5667677543516096, 5.673218076217914],
            [1.5683398533200066, 5.6710835705864575],
            [1.5666097495609568, 5.664035460965632],
            [1.5681223582750323, 5.655828871263474],
            [1.5738032648182505, 5.648530345214651],
            [1.5856117292279048, 5.630339467386592],
            [1.590549997216053, 5.62958035864203],
            [1.5955962887307316, 5.6264304041176],
            [1.5957407815636298, 5.622964570875415],
            [1.5982545629871054, 5.619459216563948],
            [1.5971791023181183, 5.613401166424732],
            [1.6054771835884027, 5.61086696032211],
            [1.6071637211807341, 5.608159605683911],
            [1.6261529545219071, 5.604769645384629],
            [1.6265387434345833, 5.589952141664434],
            [1.6274373769100212, 5.536676720531977],
            [1.629166616830121, 5.536413617415294],
            [1.629591961407368, 5.521694697865152],
            [1.6308910373544896, 5.449298190392496],
            [1.5449901191520097, 5.448028348597132],
            [1.4798677232957933, 5.447040597814761],
            [1.4514792257859535, 5.446759084887199],
            [1.408543747962958, 5.446037878752714],
            [1.366518915287513, 5.445492553163486],
            [1.3377199985116337, 5.444644522322467],
            [1.2796238492792404, 5.443518388789068],
            [1.2498626693882675, 5.4429916177973405],
            [1.1935245341542904, 5.442253668250488],
            [1.1075950679868838, 5.441698445044777],
            [1.1062143537879443, 5.528483104740684],
            [1.1006542361900549, 5.528536834504751]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -94.72770318982872,
          "lat": 44.242104327292324
        },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27015"],
        "coty_name": ["Brown"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Brown County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "00659453"
      },
      "bbox": [
        1.1006542361900549, 5.441698445044777, 1.6308910373544896,
        5.832912676117576
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.8570207090126011, 5.179869546646525],
            [0.8832925907839512, 5.179986308013927],
            [0.9839611507063671, 5.1808403320253005],
            [1.0234055607517354, 5.1810390310949925],
            [1.0522839444048322, 5.180974914996492],
            [1.0810324959659754, 5.181472745055826],
            [1.1574346216849154, 5.182275322818587],
            [1.207811094753102, 5.182596644324089],
            [1.283051575858747, 5.183777629012912],
            [1.2866026498277958, 5.183826164592582],
            [1.2875698494700276, 5.097844701235465],
            [1.2885764269111193, 5.010486465396096],
            [1.289612696330548, 4.923751271481368],
            [1.2907245832660252, 4.836538285512279],
            [1.247395182709142, 4.83594860625554],
            [1.1335721625459236, 4.834862495204533],
            [1.096249143734209, 4.83440845196643],
            [1.0738677923766726, 4.833769021055918],
            [1.0648585338776928, 4.8342394099698325],
            [1.0331859053846078, 4.833787012124928],
            [1.0089506027737247, 4.833972299078611],
            [1.004534338463844, 4.833204652931773],
            [0.9646570865137672, 4.83293207340431],
            [0.9057558766931442, 4.832266868832983],
            [0.8725357611642535, 4.8319431815262055],
            [0.8576367296028983, 4.832202654228327],
            [0.8572867524939477, 4.878209257707528],
            [0.8571167870475233, 4.955011433297768],
            [0.8575928636137996, 5.005725626099833],
            [0.8574092350387202, 5.0781143753754625],
            [0.8578632793125494, 5.092888366264569],
            [0.8573590129645998, 5.136416896959332],
            [0.8570207090126011, 5.179869546646525]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.15410528937996, "lat": 43.67418911585512 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27063"],
        "coty_name": ["Jackson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Jackson County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "00659477"
      },
      "bbox": [
        0.8570207090126011, 4.8319431815262055, 1.2907245832660252,
        5.183826164592582
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.9338066432189975, 5.802562342281167],
            [1.9412550846379366, 5.806965142904578],
            [1.944974562705851, 5.806292791638714],
            [1.9465105314354516, 5.809325419357647],
            [1.9433315680016565, 5.813496408718263],
            [1.9390811352588901, 5.815901254496263],
            [1.9422464095407612, 5.8198849082422415],
            [1.951184375993071, 5.81772038641546],
            [1.953227942600664, 5.8199550346686255],
            [1.9546583541846148, 5.825984334351935],
            [1.9550760875720838, 5.833759079593543],
            [1.9629081771572228, 5.840082633203895],
            [1.9648793687293933, 5.844650198763087],
            [1.9640809330281657, 5.8502947462082],
            [1.9665791783847204, 5.850936513468726],
            [1.9660030695724489, 5.858663654842174],
            [1.96759577865959, 5.865421085484636],
            [1.9654422926854627, 5.872937315597969],
            [1.9604776483019695, 5.872723014788366],
            [1.956257804185539, 5.875678385031932],
            [1.956299030246924, 5.882085803178708],
            [1.9536394208600407, 5.884697488659302],
            [1.9481207832280438, 5.88406997449488],
            [1.9492844841616392, 5.88924298874852],
            [1.9924644919378995, 5.890124394664188],
            [2.0786822169838204, 5.892260455134622],
            [2.136482263065945, 5.894274919406816],
            [2.2059101381205712, 5.89566539601263],
            [2.223705930093765, 5.896201060538505],
            [2.2265205741741823, 5.781166424917247],
            [2.2279783186640287, 5.723420524765746],
            [2.2291284455813973, 5.665393630989027],
            [2.2321359331645074, 5.549569766277667],
            [2.138822208789838, 5.546996990795163],
            [2.098108835891612, 5.546226237839041],
            [2.0587218363489015, 5.544997396823788],
            [2.0576531451835933, 5.58846487335607],
            [1.9811002123955412, 5.5866224741222945],
            [1.942648552968758, 5.586307912791394],
            [1.9358176593545773, 5.585661796595162],
            [1.8835462525002968, 5.584753086484751],
            [1.8783685322219426, 5.584588553902932],
            [1.8767214007138011, 5.587620046436238],
            [1.8809314354852404, 5.593583972208639],
            [1.885780801026786, 5.592926040700758],
            [1.884623179714819, 5.5975671223738575],
            [1.8801276696762195, 5.602516143994557],
            [1.874187991732769, 5.600910195910355],
            [1.8761125746855143, 5.6066515405555695],
            [1.8812831271157655, 5.6101038224235245],
            [1.8834158596650337, 5.621930103434378],
            [1.8878393922593169, 5.624305820247375],
            [1.8925221436036985, 5.624168199251241],
            [1.8952954740578627, 5.634482141420965],
            [1.898118749459855, 5.638441223537218],
            [1.8971664506513024, 5.640899156853721],
            [1.9043220067157627, 5.645208260369621],
            [1.9096639289630162, 5.646087156224727],
            [1.9147745720353162, 5.652835797022506],
            [1.9192773492185855, 5.653181432799742],
            [1.9235323124132937, 5.66402029794969],
            [1.9254236028899232, 5.666370890301656],
            [1.9239239676452213, 5.670582384706182],
            [1.926701247981978, 5.676545652663897],
            [1.9302865642271716, 5.677343491922607],
            [1.928997503443594, 5.685024034077018],
            [1.9318286664489877, 5.687283058234299],
            [1.935514331187775, 5.685840354087022],
            [1.9377867719430553, 5.69110010050909],
            [1.9351819753355786, 5.696231288171533],
            [1.929823532201092, 5.700996678747375],
            [1.9223592437873103, 5.702868569085549],
            [1.919730526508137, 5.708983691096989],
            [1.9164025605887778, 5.71160448148492],
            [1.9163395897378597, 5.716444864559427],
            [1.9207603067245975, 5.719498633660192],
            [1.9195744344870898, 5.725153198581946],
            [1.9152947234167796, 5.7272514905934555],
            [1.9157160617395976, 5.72992920930687],
            [1.9229645514619595, 5.731522387695494],
            [1.9214237782486618, 5.7351969864725305],
            [1.9251058609326364, 5.742792823917801],
            [1.9236083612586141, 5.752564598878152],
            [1.921149004381868, 5.755372938489037],
            [1.9258345968703616, 5.758928263338015],
            [1.9304503928299304, 5.758272197044291],
            [1.9324640479772248, 5.766536334935323],
            [1.9347485236386184, 5.77163992496492],
            [1.935424827160461, 5.7791573738321524],
            [1.9390369608653037, 5.790566769340983],
            [1.9354613671298664, 5.795534053463148],
            [1.9359029895132265, 5.80012032556309],
            [1.9338066432189975, 5.802562342281167]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.7301708174919, "lat": 44.37140801701109 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27079"],
        "coty_name": ["Le Sueur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Le Sueur County"],
        "coty_fp_code": "079",
        "coty_gnis_code": "00659485"
      },
      "bbox": [
        1.874187991732769, 5.544997396823788, 2.2321359331645074,
        5.896201060538505
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.571191166726915, 6.25214211220875],
            [2.596535523511121, 6.2530007894852835],
            [2.5932970186616906, 6.343103860919467],
            [2.5905294433268624, 6.427138661081103],
            [2.589767331419424, 6.45773978681111],
            [2.5888391328681157, 6.484547061304791],
            [2.563539884481058, 6.483996832065587],
            [2.5621741130648976, 6.534101035273199],
            [2.5608683206045955, 6.59337274724842],
            [2.5588687840833653, 6.655996022337723],
            [2.6236187975995193, 6.65739844740912],
            [2.647808701729599, 6.6581132183824945],
            [2.7023915120742426, 6.660027697243599],
            [2.7513423926490614, 6.6611896781809214],
            [2.7477554034218508, 6.6582202282392915],
            [2.7422793128462897, 6.656030728816301],
            [2.7402656013983275, 6.6499691956534095],
            [2.7413545299070896, 6.6439290376147495],
            [2.7472578908252476, 6.634918358518333],
            [2.748200670291432, 6.627094662614746],
            [2.743422190700533, 6.618718518118899],
            [2.742608467161443, 6.61490457323647],
            [2.744924705587627, 6.6037518427176884],
            [2.745223390658556, 6.596021507932815],
            [2.7496717212363073, 6.584375217029252],
            [2.748255379537107, 6.578458104254366],
            [2.745550506656694, 6.575183091145432],
            [2.7415596403306206, 6.570372429676684],
            [2.7397639656154675, 6.560607243599377],
            [2.739880633685698, 6.553416383909497],
            [2.7416325163813378, 6.548434544675781],
            [2.7507121497380447, 6.539891494283466],
            [2.750963305384832, 6.5321821229722055],
            [2.7529133643045385, 6.5294047107676105],
            [2.7522771218169906, 6.523704602325994],
            [2.7539379264007016, 6.514678342150677],
            [2.7520138198237167, 6.508247475894252],
            [2.754032994994097, 6.50438346558479],
            [2.7571763494196575, 6.489558298377986],
            [2.761746562243024, 6.48314871324133],
            [2.758216318978694, 6.474861618893018],
            [2.751734821728617, 6.469502798421723],
            [2.7440844575309824, 6.461862575975033],
            [2.7383828002167836, 6.455108890689632],
            [2.726356268637587, 6.445257451813903],
            [2.720126813563063, 6.434925703730473],
            [2.7188115998722586, 6.43082641187625],
            [2.7196832140609786, 6.422911979415102],
            [2.7234199689609584, 6.416292754341062],
            [2.730128984873743, 6.409417903909499],
            [2.736685905808898, 6.405468229646877],
            [2.7428361569032966, 6.400176269260663],
            [2.747069514465347, 6.395305655619384],
            [2.749015868621495, 6.390944096648585],
            [2.7488106843006705, 6.387184642800235],
            [2.7433258745642273, 6.367909104824772],
            [2.74385255874923, 6.360710833497439],
            [2.745314484107574, 6.35484939634757],
            [2.74456455588857, 6.3499765755986255],
            [2.745580968320661, 6.338880639226186],
            [2.747291827013915, 6.334889334715068],
            [2.751999436480982, 6.331956521187979],
            [2.7566203686406534, 6.32293902309245],
            [2.759790794886202, 6.308904180911191],
            [2.760047797265192, 6.304662008511522],
            [2.7560560800251936, 6.278544194480954],
            [2.754758000743028, 6.275156181778214],
            [2.7454045081719896, 6.268374757045561],
            [2.7444206388299013, 6.259804334363578],
            [2.7485045905120846, 6.250149460092524],
            [2.7526126444521997, 6.243252884855632],
            [2.7530433247203905, 6.239505520400202],
            [2.749580833904714, 6.22929361087799],
            [2.750205858749822, 6.22171378702566],
            [2.7529903839404426, 6.208557966846044],
            [2.752615464439982, 6.202463042235007],
            [2.7484897836761264, 6.195428049781835],
            [2.7484340871678756, 6.1888274123281795],
            [2.743237541921643, 6.179847854291902],
            [2.7419349958668606, 6.165395566248177],
            [2.7405446387760937, 6.159540510373456],
            [2.7381698273707014, 6.154966832951132],
            [2.7303527641818817, 6.1443243454656775],
            [2.7271342197409045, 6.13522837812159],
            [2.725789593026267, 6.118347192815585],
            [2.7298121803337465, 6.112826907463895],
            [2.7226400990747313, 6.114037543747779],
            [2.713649088250953, 6.116719653408794],
            [2.7060565734975732, 6.113602019047281],
            [2.696239336562282, 6.112436358107687],
            [2.692398284319979, 6.113497025938721],
            [2.688148357377806, 6.121381345025812],
            [2.6794619037115948, 6.132743343140191],
            [2.6722195445360652, 6.139141660460538],
            [2.6655035458701026, 6.13925777449738],
            [2.656271709685098, 6.138116955208538],
            [2.6504190246626393, 6.1390199984183536],
            [2.6416931516957463, 6.144807279604865],
            [2.6369521873835993, 6.1449648565308665],
            [2.631679621774787, 6.1393900144111235],
            [2.6216659010261396, 6.134568170144316],
            [2.61478147879953, 6.1332617172950465],
            [2.598875572201757, 6.137989627978029],
            [2.59273370506736, 6.137187247991763],
            [2.588602383214385, 6.134279804862452],
            [2.5848921363369017, 6.133935222429357],
            [2.5776998872096475, 6.1375762163939305],
            [2.5734111113811715, 6.1485934219546685],
            [2.574004079620197, 6.156062215188467],
            [2.5771942930029597, 6.1645286328020035],
            [2.58442612053827, 6.1769598732253295],
            [2.5786678034453456, 6.1985442993347],
            [2.5800142457285413, 6.209749433582446],
            [2.580413332563701, 6.220512943569518],
            [2.5771077465362486, 6.230761568553246],
            [2.5739137172263225, 6.246111726139981],
            [2.571191166726915, 6.25214211220875]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -92.88373369686353, "lat": 45.03877643635928 },
        "year": "2023",
        "ste_code": ["27"],
        "ste_name": ["Minnesota"],
        "coty_code": ["27163"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "163",
        "coty_gnis_code": "00659526"
      },
      "bbox": [
        2.5588687840833653, 6.112436358107687, 2.761746562243024,
        6.6611896781809214
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.209119487958808, -4.790913886304249],
            [6.207805350428595, -4.776188765450264],
            [6.292720719915126, -4.769773038021459],
            [6.288727086894249, -4.711621130888932],
            [6.355717965469917, -4.707302215419343],
            [6.396713712172772, -4.704770678746253],
            [6.432008026413785, -4.702400979750582],
            [6.458118464283806, -4.700244549562075],
            [6.462506600929791, -4.699573727943935],
            [6.464164241173319, -4.717747237198131],
            [6.47290060905178, -4.830739867890145],
            [6.530423143050366, -4.826338594459337],
            [6.550822562157265, -4.824908768501382],
            [6.557802476871459, -4.82404655387403],
            [6.653797960209954, -4.817006660052624],
            [6.6609121431707905, -4.81912278658698],
            [6.661756785237914, -4.822639242175265],
            [6.653317956457679, -4.822969280969121],
            [6.653335656123539, -4.830891967748178],
            [6.644564264399456, -4.837110307657677],
            [6.644725623971836, -4.847655814925759],
            [6.646390745718238, -4.853509508999647],
            [6.650217934177752, -4.854668033402988],
            [6.656998626990536, -4.8531595864357495],
            [6.658043871821548, -4.855161031591855],
            [6.6559209582029615, -4.8610632425160425],
            [6.658643700543779, -4.87084667314421],
            [6.654025007794962, -4.877131374326496],
            [6.653031755782864, -4.88078702062868],
            [6.655373653774089, -4.883918359469113],
            [6.659109318752231, -4.883945225141202],
            [6.662830483253214, -4.881731365585831],
            [6.6728520763634505, -4.885472381316966],
            [6.6798810362167975, -4.890497638633441],
            [6.681206206317388, -4.89724167339053],
            [6.6769179721724425, -4.9013742951783374],
            [6.671134416384431, -4.913370880668039],
            [6.666040022466881, -4.917130414054163],
            [6.674189278547524, -4.927786453979612],
            [6.6742037102568545, -4.930065994794226],
            [6.67024674391604, -4.933644191075658],
            [6.667493607111548, -4.930854988194578],
            [6.665069579098275, -4.933316640264696],
            [6.668380636039282, -4.942200223190013],
            [6.6690320446918765, -4.947694284102921],
            [6.6713257388672, -4.954056107821203],
            [6.677981263658247, -4.96158516861061],
            [6.689165485168166, -4.968050157182321],
            [6.687937341433721, -4.971439115993976],
            [6.68257087392472, -4.972972191915667],
            [6.677357377840986, -4.967856862325526],
            [6.67040123778919, -4.967074145868053],
            [6.6676713198408315, -4.962006875497219],
            [6.66086819590673, -4.960317631047777],
            [6.659946334285641, -4.9555827060366475],
            [6.655569092434412, -4.952500392642259],
            [6.652413351681177, -4.9528864527842575],
            [6.64924638206095, -4.949838452246485],
            [6.644121655818921, -4.947612325443014],
            [6.641669972148479, -4.950411361546914],
            [6.64239445402175, -4.955835243815919],
            [6.63920305654895, -4.9616538855671894],
            [6.633937948231547, -4.9631948566386574],
            [6.6307326046612225, -4.966492203426591],
            [6.631796206048382, -4.969805239551899],
            [6.6297931425049725, -4.9730324167074835],
            [6.623700437811005, -4.972039113832986],
            [6.621872019834775, -4.9789414541128485],
            [6.61786832922664, -4.9783166133699615],
            [6.613360178986376, -4.97410833011517],
            [6.606665358187795, -4.982680146868226],
            [6.60202827495937, -4.979932395485672],
            [6.598776227762416, -4.982743756092058],
            [6.596741156486545, -4.9869594801308414],
            [6.588355788300091, -4.990995024495027],
            [6.584368572475907, -4.995512991203273],
            [6.577280759594806, -4.997307147638175],
            [6.526256225296178, -5.001837671693716],
            [6.521454245576302, -4.942873520948379],
            [6.502312808094434, -4.944316362746972],
            [6.4985528387584255, -4.948636889987669],
            [6.490094809416873, -4.951438331430626],
            [6.485774962139827, -4.95154456636965],
            [6.475800530575332, -4.949207854635771],
            [6.470936484360837, -4.946691332092902],
            [6.439716204266281, -4.9490448834831655],
            [6.409212615744311, -4.95171116753916],
            [6.26323620471371, -4.96331578496914],
            [6.249513748740189, -4.966413968676526],
            [6.235304568797948, -4.967414690452392],
            [6.229950221701674, -4.894102571665876],
            [6.216981354719274, -4.895015138076692],
            [6.2151509226921755, -4.878441211725576],
            [6.213140989762172, -4.846889123701496],
            [6.210311910399711, -4.8095481637450055],
            [6.209119487958808, -4.790913886304249]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.78152538029123, "lat": 33.65564011582909 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28025"],
        "coty_name": ["Clay"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clay County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00695737"
      },
      "bbox": [
        6.207805350428595, -5.001837671693716, 6.689165485168166,
        -4.699573727943935
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.327234927140625, -6.5452631667411865],
            [5.4068971270105965, -6.5405373060800045],
            [5.455435458401827, -6.537737518922403],
            [5.533779893011403, -6.532892267466455],
            [5.574045870915895, -6.530549097383301],
            [5.574223213132391, -6.531769342006875],
            [5.620623461580018, -6.529237397562019],
            [5.708010371508735, -6.5239535358900005],
            [5.748517676852118, -6.5213750174583],
            [5.805720712206502, -6.517432828500908],
            [5.814417358518208, -6.5504353436159475],
            [5.815246158190477, -6.565627568095763],
            [5.820740616763383, -6.648981547906799],
            [5.825525406864251, -6.720033760963501],
            [5.829764694266331, -6.7793586190979624],
            [5.831218925389576, -6.782362982002885],
            [5.805801058346587, -6.785505440551424],
            [5.779455110089638, -6.789651431745964],
            [5.745415017183898, -6.794011863648116],
            [5.640638406795189, -6.808533133481516],
            [5.592686921727096, -6.814638171097928],
            [5.560865874825987, -6.818848798611539],
            [5.436403560167453, -6.835565471080849],
            [5.436857214587933, -6.832367180756053],
            [5.430018113978269, -6.820436245734809],
            [5.433711968604146, -6.814119928482596],
            [5.4357995418129885, -6.813545921949949],
            [5.437829663803318, -6.820125007805202],
            [5.443848825045663, -6.818095803620136],
            [5.447584625755923, -6.809891517144792],
            [5.44465513339247, -6.804331129969993],
            [5.443916277533431, -6.798544680034069],
            [5.4400358220697385, -6.796807983801444],
            [5.433353835860401, -6.799317595326384],
            [5.418762164423967, -6.8000034152159134],
            [5.415766265823367, -6.795259414437945],
            [5.409712684625347, -6.7900458303746465],
            [5.410905620684524, -6.7820060437749445],
            [5.420925452294691, -6.770274874390524],
            [5.419713742075225, -6.763302259319111],
            [5.4269515850334376, -6.7614087910947545],
            [5.420897496178728, -6.757035051317429],
            [5.418477325916418, -6.7565568471808595],
            [5.412968251938936, -6.759810915367809],
            [5.410783923775465, -6.756416628362813],
            [5.402495116480622, -6.7494447539365465],
            [5.399794899997342, -6.745807755556462],
            [5.405750158865325, -6.745467622349289],
            [5.41668507681828, -6.741414536410541],
            [5.418637596615206, -6.739448667298457],
            [5.418403024167172, -6.735119079374139],
            [5.4215045386979694, -6.7323039353770975],
            [5.42092174550899, -6.729337029051009],
            [5.417179647680853, -6.725187518757161],
            [5.416982982202005, -6.7187432218452985],
            [5.411854486838473, -6.702439805701716],
            [5.408172764010943, -6.697191206006629],
            [5.399656753019937, -6.693398771783518],
            [5.396362684822579, -6.690247178460682],
            [5.386741183804162, -6.6868997994859605],
            [5.38634343257045, -6.673759657217602],
            [5.388629848203339, -6.667660549134993],
            [5.386780160794507, -6.660826907978341],
            [5.377289347152581, -6.649293733972415],
            [5.376172532713823, -6.653107112292627],
            [5.372942456992618, -6.654491527154856],
            [5.370383408927811, -6.650770916880098],
            [5.364130607475954, -6.653128645069765],
            [5.3611399018125745, -6.65003086455477],
            [5.366099063216233, -6.648529834670985],
            [5.3647504979583305, -6.639603157034775],
            [5.366989533016095, -6.6373983373752745],
            [5.359992718886812, -6.6351417515495426],
            [5.360491790669281, -6.627896234793008],
            [5.356710263105853, -6.625334035032784],
            [5.356053106763191, -6.621869196752351],
            [5.352619919345457, -6.619242637474619],
            [5.351268361777967, -6.615870794604058],
            [5.35250606866395, -6.609834022225768],
            [5.351417769975033, -6.605542126228342],
            [5.3477135513912035, -6.604520655483409],
            [5.344807353358277, -6.6074896076088825],
            [5.342112459545706, -6.604295819241914],
            [5.3371470001924735, -6.605238141958189],
            [5.336932357395235, -6.599595212068126],
            [5.332845506545779, -6.592660160450441],
            [5.328464366843895, -6.587454589061048],
            [5.330250648666629, -6.584508632727766],
            [5.33403503673071, -6.584802040686244],
            [5.337033487149484, -6.575498177745803],
            [5.3299005479047405, -6.57395209598974],
            [5.326544773595548, -6.577921964570415],
            [5.317725082664412, -6.572962340262705],
            [5.31729922985977, -6.569267674903946],
            [5.313533997731217, -6.5642988902758255],
            [5.3175322420452895, -6.558214392451885],
            [5.322585847970244, -6.557793726446959],
            [5.32766877768544, -6.548307525580705],
            [5.327234927140625, -6.5452631667411865]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.91963967888184, "lat": 31.91319612086041 },
        "year": "2023",
        "ste_code": ["28"],
        "ste_name": ["Mississippi"],
        "coty_code": ["28127"],
        "coty_name": ["Simpson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Simpson County"],
        "coty_fp_code": "127",
        "coty_gnis_code": "00695784"
      },
      "bbox": [
        5.313533997731217, -6.835565471080849, 5.831218925389576,
        -6.517432828500908
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [3.286529287288143, 0.9674539942371908],
            [3.287715458586599, 0.9674961468618964],
            [3.373664747902047, 0.9696202777921032],
            [3.372581412790334, 1.0290171701952016],
            [3.4156203885081573, 1.0297724038145593],
            [3.4298576694929754, 1.0301893275239375],
            [3.486733977983328, 1.0311668542926917],
            [3.5445087019067754, 1.0326292513644404],
            [3.5873785346897655, 1.0342611734586773],
            [3.6305195889915782, 1.035370732827367],
            [3.660357099815601, 1.0365530680746409],
            [3.694208418545616, 1.0375801197433903],
            [3.716005821056376, 1.0379989383749848],
            [3.730755429002973, 1.0389445655375922],
            [3.731039848632312, 1.024144450091386],
            [3.732627089462179, 0.980238808806254],
            [3.7359452005095597, 0.9800298696394389],
            [3.7392706886536793, 0.879249837641266],
            [3.740725640264625, 0.8058105023244252],
            [3.742216609106267, 0.7606776219219563],
            [3.743163212350993, 0.7176862588500954],
            [3.7280571093857815, 0.7172240899968952],
            [3.713586669813827, 0.7160962470471313],
            [3.668059209806563, 0.7131117320504398],
            [3.637190580021424, 0.7117303873535997],
            [3.5982333871008, 0.7104891185813391],
            [3.5333526901947994, 0.7094100544709449],
            [3.530473328589701, 0.7096483068070056],
            [3.4941565398195644, 0.7080932201644304],
            [3.4501107422385817, 0.7068963401695699],
            [3.3872779046529273, 0.7068337511495539],
            [3.353156883319153, 0.7070890998946426],
            [3.3350718922709994, 0.7074510426235205],
            [3.289636357326278, 0.7074187679620272],
            [3.2895611971332075, 0.723026361648239],
            [3.288431868358295, 0.8193078571428919],
            [3.2877552568360877, 0.859523204140983],
            [3.2867543862595836, 0.941562841366428],
            [3.286529287288143, 0.9674539942371908]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -92.00075407509716,
          "lat": 39.495432218730095
        },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29137"],
        "coty_name": ["Monroe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monroe County"],
        "coty_fp_code": "137",
        "coty_gnis_code": "00758523"
      },
      "bbox": [
        3.286529287288143, 0.7068337511495539, 3.743163212350993,
        1.0389445655375922
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.0643928447470592, 1.8967475000682272],
            [1.1257181911476972, 1.8961643129507606],
            [1.164806744586338, 1.8959989974043012],
            [1.222991167928384, 1.895394578798959],
            [1.2419411246812018, 1.8957462371701153],
            [1.2807978325091274, 1.8954017539723231],
            [1.2944261983981658, 1.8952258506317883],
            [1.3494332896986883, 1.8950825868759145],
            [1.3589029999130962, 1.8947869711033698],
            [1.4300917869643817, 1.8943703709722384],
            [1.4938309381590524, 1.894235577991261],
            [1.4937225443351667, 1.8879554900615851],
            [1.4953713575405472, 1.794761732950887],
            [1.5130763543986798, 1.7949480788016143],
            [1.5142304587060398, 1.7301826809440746],
            [1.514165179765317, 1.7086136241569432],
            [1.5218328320226122, 1.7086213526712648],
            [1.5208823272417258, 1.6215249534421252],
            [1.5199663264932035, 1.6213531280378797],
            [1.519873418915862, 1.5921399479612062],
            [1.5205749369131538, 1.5376263450734613],
            [1.5198849243094144, 1.5337960869227694],
            [1.5202953560759935, 1.4459566992615118],
            [1.5200612971203824, 1.4457424164946093],
            [1.4705082631650328, 1.4453011725687102],
            [1.4276002290011445, 1.4451369742641922],
            [1.384395831467258, 1.444778654705158],
            [1.2472084764341789, 1.4454974171634274],
            [1.1888016243562447, 1.4456505214819766],
            [1.1836261711298461, 1.4513325676673448],
            [1.178947419238282, 1.4514846894037652],
            [1.1751201148748185, 1.458405350863553],
            [1.1766345127054296, 1.4660617687426185],
            [1.1718838571324957, 1.468308829761234],
            [1.1749926077184814, 1.4714595688573857],
            [1.1731374989718617, 1.4745371496309874],
            [1.1724765079616644, 1.4814315175285542],
            [1.1701552433636437, 1.483428217397314],
            [1.1735591032403054, 1.4886163735159779],
            [1.1728349006050294, 1.4920197810155218],
            [1.1670101781312863, 1.4954135212442123],
            [1.1650889041575068, 1.5114294179060785],
            [1.168581743985195, 1.5160097957143277],
            [1.1689498988291331, 1.5204617901390654],
            [1.1723123832482334, 1.5219160804568768],
            [1.1696144854482298, 1.5289464050003696],
            [1.1690949430763535, 1.53762005101084],
            [1.1698335938632802, 1.5444741994569346],
            [1.1746647560193972, 1.549644819622972],
            [1.1764986457756377, 1.5554688404480743],
            [1.1711746885911294, 1.55982915863546],
            [1.1645661211905618, 1.5596857870350682],
            [1.1652653625729739, 1.5649365807413909],
            [1.1630039046382807, 1.5678436648686966],
            [1.1679059515273713, 1.570529097081594],
            [1.1651083732862966, 1.5740451068694805],
            [1.1659091464279259, 1.5773219069538902],
            [1.1263562221704408, 1.576646995671878],
            [1.0834495943262854, 1.5774223239953074],
            [1.084257981478763, 1.650494583624271],
            [1.084579371639346, 1.709030260096235],
            [1.0837515771017496, 1.7964641477484469],
            [1.0654209644256252, 1.7965419071826165],
            [1.0646715755509095, 1.8834186020578327],
            [1.0643928447470592, 1.8967475000682272]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.88346608402183, "lat": 40.36073476155275 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29147"],
        "coty_name": ["Nodaway"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Nodaway County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "00758528"
      },
      "bbox": [
        1.0643928447470592, 1.444778654705158, 1.5218328320226122,
        1.8967475000682272
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [1.5324945759488344, 0.8445099957092228],
            [1.5330965693147778, 0.8061066038092713],
            [1.5338969828988318, 0.7698158808483054],
            [1.5345995052041848, 0.7305235343886424],
            [1.5348224692217212, 0.6967139268592941],
            [1.5354899707600256, 0.6670866265242873],
            [1.5357733354953673, 0.638057837611085],
            [1.536619142040143, 0.6089358424214454],
            [1.5368933259012398, 0.5580760292889049],
            [1.5375411765561415, 0.5070808936180067],
            [1.5376022141535408, 0.47047765686301174],
            [1.5322637007603697, 0.47185423858185316],
            [1.5267676042479696, 0.47072292398089344],
            [1.5205970066870678, 0.4672004555445047],
            [1.5084702843360063, 0.4641018953794403],
            [1.5000503201109736, 0.4643817006662901],
            [1.4934882473298419, 0.46806294753597055],
            [1.4917390214989732, 0.47298662589432977],
            [1.4932931716436744, 0.48450243461233766],
            [1.489634640708219, 0.4894759348284467],
            [1.4855246227699304, 0.49234624212954325],
            [1.4768932608434289, 0.4945480660541426],
            [1.4716073774196936, 0.4936671486594094],
            [1.4646928200403133, 0.48858433738473606],
            [1.4511344823290935, 0.4801609327950538],
            [1.4438589992524675, 0.4786493597299806],
            [1.4339509937631076, 0.4787189005788825],
            [1.4217651251119585, 0.48259647846957393],
            [1.4133847231737757, 0.4892514996263099],
            [1.4077250692236425, 0.4993743119465004],
            [1.4035954968837356, 0.5100230031930181],
            [1.3989339500831768, 0.5155604159470958],
            [1.3944438842104614, 0.5170376042061762],
            [1.3850099072718969, 0.5152540023140879],
            [1.3757930071505864, 0.515719716408046],
            [1.3664442218471873, 0.5189149442248675],
            [1.3603154777343887, 0.5249616036013713],
            [1.3576656759764985, 0.52969440105697],
            [1.3577490427018593, 0.5329099891149565],
            [1.363074094043627, 0.543231957835003],
            [1.364610244462434, 0.5510530478562997],
            [1.363109442665782, 0.5592727513980922],
            [1.3599744554218027, 0.5656793178617757],
            [1.3550024800658158, 0.571821205089865],
            [1.3484365852923652, 0.5778632680042114],
            [1.340126966014009, 0.5831580095164188],
            [1.3237478503792082, 0.5903437940382458],
            [1.3169869710109958, 0.5956593903899442],
            [1.3106398768258052, 0.6033871614607278],
            [1.3068660363022488, 0.609384522635139],
            [1.3026822960208502, 0.6212084259560454],
            [1.3004497280521459, 0.6330053904956525],
            [1.2981904522972778, 0.6578863786975109],
            [1.2990655499347528, 0.663872722067159],
            [1.304288047749972, 0.6701191018385202],
            [1.3085942789659863, 0.6729471146452771],
            [1.3131050605781285, 0.673904126775193],
            [1.320356752586872, 0.6804014789237803],
            [1.3220331557559495, 0.6857917730675227],
            [1.320487853620406, 0.6940473949410955],
            [1.3173196279142072, 0.6999681777793002],
            [1.3142678189385595, 0.7025884029328816],
            [1.3096561769809925, 0.7036783891132413],
            [1.304426135466352, 0.7028434974472655],
            [1.2985329749326127, 0.698805340860709],
            [1.2882260316767573, 0.6942733408828518],
            [1.280143293476362, 0.6952462097466027],
            [1.2736779968357579, 0.69916444991041],
            [1.2709208001952692, 0.7035270702645818],
            [1.2702407067757047, 0.7154262829461125],
            [1.2690052673670487, 0.7183986078612061],
            [1.263625749640293, 0.7236288585458783],
            [1.2549793343931173, 0.7270108781631466],
            [1.252830411397797, 0.7287893206252553],
            [1.2496617049551806, 0.7314120030374841],
            [1.2468113812639137, 0.7364244931535524],
            [1.2450307188255596, 0.7460354853047965],
            [1.242424289335977, 0.7503592400845761],
            [1.236222418286702, 0.7559863270340819],
            [1.231920698157645, 0.7579414532086657],
            [1.2165303335985187, 0.7624591898944387],
            [1.2029988412156005, 0.7704633688303409],
            [1.1973047129406682, 0.7759685950959669],
            [1.1923595399195872, 0.7845836620421329],
            [1.1900896345104124, 0.8041877698206585],
            [1.1882508062590063, 0.809802835313955],
            [1.1826217355675848, 0.8159516299954113],
            [1.1688069331067261, 0.823294748677786],
            [1.1570395243250613, 0.833970673134524],
            [1.1491710139714197, 0.8430872619758811],
            [1.150302639981585, 0.8430050901184704],
            [1.2323623605792644, 0.8436960126155886],
            [1.318312494554594, 0.8439388887821491],
            [1.411074321292068, 0.8441903281340878],
            [1.5324945759488344, 0.8445099957092228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -94.77378353374003, "lat": 39.38027416881939 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29165"],
        "coty_name": ["Platte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Platte County"],
        "coty_fp_code": "165",
        "coty_gnis_code": "00758537"
      },
      "bbox": [
        1.1491710139714197, 0.4641018953794403, 1.5376022141535408,
        0.8445099957092228
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [2.4515326376073174, 1.7246011929763203],
            [2.4946294590002402, 1.726317305434873],
            [2.580300798678801, 1.7307511166999066],
            [2.599958920745097, 1.7314224077632991],
            [2.6650131098700443, 1.7343146896204396],
            [2.751518874424637, 1.735551630366457],
            [2.7628014053860497, 1.735860784639924],
            [2.837547822546875, 1.7392531734958907],
            [2.838749616093096, 1.6957471002067324],
            [2.8432145243965685, 1.5637281687260216],
            [2.8457013496651293, 1.4762736911372603],
            [2.8485191772798837, 1.3877756938173897],
            [2.770232798289926, 1.3843574692718794],
            [2.7334052055451026, 1.3832159292627435],
            [2.706165181960211, 1.382964077462148],
            [2.657223446413208, 1.3814463446619616],
            [2.548482494090543, 1.376110755411981],
            [2.465092385276453, 1.3719191951304102],
            [2.461599675124199, 1.3718233475161814],
            [2.459017331046452, 1.4599661258584582],
            [2.4585327900005813, 1.470062097425887],
            [2.4566623790133497, 1.5482183689008533],
            [2.4545827452702778, 1.606964661393974],
            [2.452890946763005, 1.6657890783711964],
            [2.4515326376073174, 1.7246011929763203]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -93.11150516788044, "lat": 40.21059950349247 },
        "year": "2023",
        "ste_code": ["29"],
        "ste_name": ["Missouri"],
        "coty_code": ["29211"],
        "coty_name": ["Sullivan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sullivan County"],
        "coty_fp_code": "211",
        "coty_gnis_code": "00758558"
      },
      "bbox": [
        2.4515326376073174, 1.3718233475161814, 2.8485191772798837,
        1.7392531734958907
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-6.450411775421382, 8.520154038053596],
            [-6.448975080938738, 8.53427397183163],
            [-6.362253978040511, 8.52552795917443],
            [-6.275535161463296, 8.516758777894273],
            [-6.278473937547895, 8.488481920896179],
            [-6.20518581189241, 8.481140097641475],
            [-6.1318993387358764, 8.47378176730076],
            [-6.140634153819014, 8.388280744209268],
            [-6.112086585369629, 8.38550734856501],
            [-6.120581018985852, 8.300134172255714],
            [-6.062964072643282, 8.294508708115991],
            [-6.068673597724832, 8.237553389073122],
            [-6.039519819216224, 8.234595394984394],
            [-6.042249215177711, 8.206070242541484],
            [-5.970170503593963, 8.198693558722809],
            [-5.898093504493646, 8.191301209769977],
            [-5.901030323219449, 8.162757736363456],
            [-5.814310487640682, 8.154046609369425],
            [-5.726297842472673, 8.145332113387338],
            [-5.723587215241925, 8.17381928058861],
            [-5.637102046522482, 8.165491038123792],
            [-5.6330644239857595, 8.20816347237028],
            [-5.546801699152261, 8.200375991494685],
            [-5.558471680096662, 8.072118403183966],
            [-5.677642414472999, 8.083146954675716],
            [-5.677691755767572, 8.081735630365019],
            [-5.692940515494369, 7.917003817257874],
            [-5.679334657686541, 7.915751741234053],
            [-5.69574350753541, 7.741775060345361],
            [-5.732867987686559, 7.7452148008341615],
            [-5.745242242593442, 7.615544345387346],
            [-5.765716853258817, 7.400645553602174],
            [-5.795348723735435, 7.403442089196602],
            [-5.916177631883217, 7.41540966524951],
            [-6.026627742363775, 7.426785800918902],
            [-6.144819276309392, 7.438658428718995],
            [-6.263014856087097, 7.450491473884241],
            [-6.313215818645523, 7.455554041920471],
            [-6.432396667279096, 7.467932787626986],
            [-6.504914846591234, 7.4755799191738195],
            [-6.577434619958929, 7.4832121290914335],
            [-6.63518289263513, 7.48933715423407],
            [-6.625661724523879, 7.575545110260929],
            [-6.597851968386951, 7.832362488486862],
            [-6.571479413891446, 7.8296320051967125],
            [-6.560979023363634, 7.91504569831049],
            [-6.563257199943627, 7.915288667361385],
            [-6.55359660403264, 8.003593269543556],
            [-6.535808670783482, 8.16999475860064],
            [-6.511927560915783, 8.167477632291993],
            [-6.508038018690023, 8.203130294878749],
            [-6.507062725824651, 8.209481499592414],
            [-6.496983121575606, 8.305967967147126],
            [-6.475273206588735, 8.508471269567584],
            [-6.451849561769682, 8.506023101751165],
            [-6.450411775421382, 8.520154038053596]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.57173588941104,
          "lat": 46.25266932750285
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30017"],
        "coty_name": ["Custer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Custer County"],
        "coty_fp_code": "017",
        "coty_gnis_code": "01720109"
      },
      "bbox": [
        -6.63518289263513, 7.400645553602174, -5.546801699152261,
        8.53427397183163
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-12.084163241196121, 9.17437809605724],
            [-12.052690388875295, 9.168179408558345],
            [-11.97474108313786, 9.153182397421556],
            [-11.974622113058356, 9.153749891195053],
            [-11.883317613131247, 9.136102707029288],
            [-11.833381768479741, 9.126769984507156],
            [-11.745765288369194, 9.110471898868731],
            [-11.742631105111704, 9.109764256372198],
            [-11.740781595477477, 9.102236711746288],
            [-11.742010160035527, 9.094588548112743],
            [-11.739405511035374, 9.092357810358974],
            [-11.740183119193466, 9.085678453331052],
            [-11.731790021866034, 9.07670275406464],
            [-11.732953069628186, 9.069609185293825],
            [-11.735493199415743, 9.066355271354059],
            [-11.740518400824117, 9.066460720421098],
            [-11.74351008945454, 9.06376934536319],
            [-11.740185151359775, 9.057024765596301],
            [-11.742787010442498, 9.043060464462021],
            [-11.7466223071941, 9.03876823314411],
            [-11.75268921830691, 9.039961970341569],
            [-11.756138131896696, 9.037133620791664],
            [-11.76200591278061, 9.036397140311939],
            [-11.763075069606272, 9.034501484284357],
            [-11.760343035714126, 9.028712615066855],
            [-11.759906998168825, 9.023465391008777],
            [-11.766410821587703, 9.016309555498363],
            [-11.768009771213498, 9.011678001753344],
            [-11.771274117862054, 9.008928124899336],
            [-11.771783458219193, 9.004928787401088],
            [-11.775436633769532, 9.00201431770048],
            [-11.777846339792044, 8.994843491147122],
            [-11.777457250292247, 8.992419146901995],
            [-11.780998535075717, 8.98593938545702],
            [-11.77988497155635, 8.982365559460066],
            [-11.781116032772665, 8.97740841564881],
            [-11.784892789333709, 8.97134014287705],
            [-11.796251079386884, 8.97130909294984],
            [-11.802800956632055, 8.96818535219595],
            [-11.806271269248857, 8.963694919830196],
            [-11.807292743056172, 8.958095271602604],
            [-11.799903548583664, 8.951393705349375],
            [-11.802599236110847, 8.944666525391941],
            [-11.800040212360404, 8.93933394241316],
            [-11.801941805532962, 8.934799265439283],
            [-11.797742954567008, 8.929306910831928],
            [-11.799249650086013, 8.917506094248095],
            [-11.79759825944689, 8.914539655011245],
            [-11.796778695860326, 8.906608161831663],
            [-11.798091323766592, 8.899769638498041],
            [-11.803823517489757, 8.893813933179446],
            [-11.804740728816649, 8.889237418488026],
            [-11.808154534847228, 8.880805950925417],
            [-11.8045956091636, 8.87753272853865],
            [-11.794306828059026, 8.872523237186236],
            [-11.79269230930744, 8.86641702048449],
            [-11.787946733915266, 8.866874002560323],
            [-11.784684892498525, 8.863449056256425],
            [-11.786416036203045, 8.859729459505834],
            [-11.784070781732364, 8.856549566325675],
            [-11.784229802136421, 8.853166028577114],
            [-11.7804023564563, 8.850049494345903],
            [-11.780043039695993, 8.843144249385155],
            [-11.775717822865161, 8.839601717413647],
            [-11.774668500057711, 8.827110965704396],
            [-11.768358140487917, 8.823118053594342],
            [-11.769699919203603, 8.81979384229979],
            [-11.767269775842989, 8.816987706706636],
            [-11.76758926295611, 8.812346499768967],
            [-11.771477817171656, 8.80695834534144],
            [-11.773738132119586, 8.793011153371548],
            [-11.773023056971073, 8.78424550548406],
            [-11.771423062226733, 8.778485756975376],
            [-11.767828563551673, 8.774047741993993],
            [-11.772415409356814, 8.7642188157671],
            [-11.777981450919908, 8.759283177587674],
            [-11.777799495525617, 8.756222480771845],
            [-11.781373569830972, 8.75192865211015],
            [-11.780893391489094, 8.749453285307487],
            [-11.783406373194424, 8.743620909860608],
            [-11.782891696836375, 8.740368167271269],
            [-11.779943070662597, 8.738511724619354],
            [-11.77244575485016, 8.730860895281534],
            [-11.765449511496493, 8.727493859419477],
            [-11.76235573537721, 8.723696202378568],
            [-11.76200055732229, 8.716956430735744],
            [-11.767501946382696, 8.71483644156061],
            [-11.77221227939802, 8.711427671159669],
            [-11.776184698818211, 8.70021100085552],
            [-11.783105510224518, 8.700481177103194],
            [-11.787129342286871, 8.694411563359036],
            [-11.787187820045231, 8.684421434441653],
            [-11.79751928793042, 8.681487577989069],
            [-11.803176369230433, 8.68092441734728],
            [-11.80613921779419, 8.678547638006954],
            [-11.811682467020663, 8.678731882948025],
            [-11.818600464445787, 8.67734291978137],
            [-11.823383956711547, 8.671607904662508],
            [-11.825240784045, 8.665196236764162],
            [-11.824012060682785, 8.662951359685186],
            [-11.823366516003952, 8.65387375713859],
            [-11.820220085853693, 8.651601672781604],
            [-11.816070128776497, 8.653493950640204],
            [-11.812704441709077, 8.65200763618739],
            [-11.811777699691582, 8.646839036602424],
            [-11.803327941849163, 8.638655806302898],
            [-11.80849947592482, 8.634328617058879],
            [-11.809601651163256, 8.622463169873315],
            [-11.815002459573924, 8.613529310105058],
            [-11.814321500238801, 8.610830458266836],
            [-11.809906641966501, 8.605063964254036],
            [-11.806358202710795, 8.6037498713562],
            [-11.805473981302175, 8.598492872511837],
            [-11.806122174234881, 8.593367828068052],
            [-11.803114822471361, 8.592416399712596],
            [-11.800731448804925, 8.58857239865808],
            [-11.79950074766193, 8.580040970794007],
            [-11.796574660114832, 8.576229144129533],
            [-11.793738810670941, 8.569558264356544],
            [-11.795409631750374, 8.563996741497204],
            [-11.798019517654446, 8.561322052998296],
            [-11.805211189473672, 8.560402325456353],
            [-11.810899606727979, 8.54613275527851],
            [-11.813200205637825, 8.543480624703939],
            [-11.824206125609765, 8.53672173730956],
            [-11.824069261145974, 8.532091902983241],
            [-11.830055924811957, 8.526584969822972],
            [-11.8303918071332, 8.522017227772347],
            [-11.833272671601096, 8.518023632519377],
            [-11.839881847973501, 8.514128792578036],
            [-11.839473154102075, 8.509375855430259],
            [-11.842117778266815, 8.503126721705476],
            [-11.840106441421586, 8.500557658094873],
            [-11.834457441698985, 8.49929713898122],
            [-11.8287312282633, 8.494924085535597],
            [-11.82362306153173, 8.492891445990239],
            [-11.820275444106645, 8.489112158695601],
            [-11.814222256454666, 8.49024329159847],
            [-11.812245407625696, 8.495668573629487],
            [-11.809358446944728, 8.49887841848368],
            [-11.80801617169133, 8.503258356224197],
            [-11.804231396079615, 8.506278229337084],
            [-11.79993480232813, 8.506390853994102],
            [-11.79693805103634, 8.503275580409516],
            [-11.7930120252148, 8.49470805333258],
            [-11.776793424298958, 8.492455010313488],
            [-11.767060744609495, 8.48872188063941],
            [-11.763028555359377, 8.485898821019118],
            [-11.76718247277381, 8.477343803260391],
            [-11.763664639999798, 8.473843691983575],
            [-11.754821459179428, 8.470819996391475],
            [-11.759245954022353, 8.465379413694931],
            [-11.75674119204361, 8.461789836569118],
            [-11.758608236066115, 8.457372524932483],
            [-11.756383470108972, 8.452099303112167],
            [-11.756497368469155, 8.44754652652313],
            [-11.758860914866437, 8.444978063128717],
            [-11.756175536031138, 8.436120146649127],
            [-11.757127030880783, 8.429818035280471],
            [-11.753363346646752, 8.425039245215727],
            [-11.749583825116622, 8.413054533736476],
            [-11.746725931712524, 8.410516109835955],
            [-11.742601621887403, 8.412380608257097],
            [-11.73633963192946, 8.41140486754554],
            [-11.733356362409284, 8.414637579280404],
            [-11.726350065092381, 8.413799018219331],
            [-11.725207443861757, 8.409429859062774],
            [-11.72655174187529, 8.40325919668658],
            [-11.72517672291781, 8.393037628112857],
            [-11.723091604086008, 8.390980367612258],
            [-11.719339820479998, 8.39197475253605],
            [-11.714577444434708, 8.39041384391229],
            [-11.712125625352238, 8.387290881806377],
            [-11.708636095513398, 8.38719958304798],
            [-11.706109940038004, 8.383737423999573],
            [-11.706903958012182, 8.378418994721255],
            [-11.700203387984116, 8.379828815528578],
            [-11.695437198796581, 8.37963680291968],
            [-11.688547488586964, 8.383548710936077],
            [-11.683507084877421, 8.382140836570956],
            [-11.677532540694205, 8.378787808913234],
            [-11.669601671870387, 8.37797615002263],
            [-11.668782976432984, 8.375413795447852],
            [-11.664373671478202, 8.371992077907828],
            [-11.663741149371793, 8.370593878060037],
            [-11.663800598120014, 8.367793462402375],
            [-11.670155701944694, 8.363265422035852],
            [-11.675140361081136, 8.35720706716348],
            [-11.676338876770764, 8.353413309780313],
            [-11.681416103842173, 8.348105787558547],
            [-11.68273516292134, 8.3411461917744],
            [-11.68504460236107, 8.336927888928459],
            [-11.685943496724038, 8.32951724675106],
            [-11.683421230881665, 8.32756854335631],
            [-11.685014306862701, 8.318849916080593],
            [-11.682814685242878, 8.316153404862394],
            [-11.685915238792939, 8.313955691270934],
            [-11.698115942903815, 8.313182799565904],
            [-11.70484480304671, 8.315265344758053],
            [-11.709143787527028, 8.312735045717183],
            [-11.715030824964318, 8.312624614446689],
            [-11.719097769935098, 8.314546910538548],
            [-11.729205505378122, 8.306368552125866],
            [-11.734528200222403, 8.295265204704936],
            [-11.739704858292633, 8.296899617710583],
            [-11.744893513284321, 8.296762517523677],
            [-11.754519748818407, 8.289345509538217],
            [-11.758084456466415, 8.288726806307679],
            [-11.761012968925098, 8.290449455800902],
            [-11.7678513178775, 8.290680712840276],
            [-11.770834091015598, 8.289604483649208],
            [-11.77672626938723, 8.292533627888627],
            [-11.782738181245401, 8.289254965892544],
            [-11.786683458770293, 8.289356322167853],
            [-11.788639900592282, 8.294350786788728],
            [-11.798449999000951, 8.29485375928837],
            [-11.805570694682068, 8.301094812871527],
            [-11.808672713739618, 8.300909623403678],
            [-11.812252650437731, 8.297016112006451],
            [-11.816724349291016, 8.297983058927162],
            [-11.820178169806544, 8.290781502942654],
            [-11.826449153152405, 8.2903101372927],
            [-11.830702627474006, 8.287545868433808],
            [-11.831815075052301, 8.281839665983902],
            [-11.835867029999417, 8.27955496417253],
            [-11.842648920251522, 8.279372426644775],
            [-11.848364847565554, 8.27255641626709],
            [-11.855104595281757, 8.26844159994317],
            [-11.858772866495647, 8.269898807868877],
            [-11.862084327479725, 8.268363133649157],
            [-11.870465817287304, 8.261361608581831],
            [-11.879789248660394, 8.263235405297944],
            [-11.88174203397072, 8.259248792411217],
            [-11.881558663565151, 8.254855595889573],
            [-11.879054327630055, 8.249274480119041],
            [-11.885821479199247, 8.245660592003981],
            [-11.888937769187095, 8.245496129757113],
            [-11.893663867957102, 8.23658198188606],
            [-11.898230607291678, 8.234591224190513],
            [-11.902870563265168, 8.23038477216985],
            [-11.911090625270335, 8.23009828319037],
            [-11.913721942018917, 8.227921927439118],
            [-11.919332880343312, 8.230394768303468],
            [-11.926411533801373, 8.232233110625744],
            [-11.924877872432143, 8.236437490639418],
            [-11.926610127412852, 8.244987660872033],
            [-11.926464504997263, 8.252889368208777],
            [-11.930505115421575, 8.259634855493307],
            [-11.935409937148151, 8.26314409350436],
            [-11.941850497605177, 8.25758468220077],
            [-11.946081734903585, 8.257349086299259],
            [-11.955468998711199, 8.253645433716981],
            [-11.958580311034233, 8.248973175092441],
            [-11.965128157591268, 8.242037656253425],
            [-11.96916842373045, 8.23945557910965],
            [-11.972781657403129, 8.232533072789742],
            [-11.970039471006684, 8.229552689032193],
            [-11.968255972328572, 8.2183347741615],
            [-11.972489159214527, 8.214790778644767],
            [-11.969129829717042, 8.208942897055627],
            [-11.974720361646645, 8.203789888088645],
            [-11.976721975922908, 8.19895339887739],
            [-11.974251372518841, 8.198264533383249],
            [-11.97476393948965, 8.192553690205218],
            [-11.980162817781213, 8.18840245873208],
            [-11.985630331251905, 8.194404898146184],
            [-11.990622039559446, 8.191487754265376],
            [-11.997227785998447, 8.189846833521923],
            [-11.998143474256235, 8.188176403136618],
            [-12.012375917028882, 8.185554299612223],
            [-12.015469012410367, 8.185687570033622],
            [-12.019846401399539, 8.189576393850658],
            [-12.01963654814375, 8.199564258588465],
            [-12.026366631331953, 8.200824296683349],
            [-12.030441573896612, 8.204642454746939],
            [-12.034961059873773, 8.202983498788873],
            [-12.038692237511334, 8.197092897176832],
            [-12.04447070619292, 8.195654046726371],
            [-12.048951985077801, 8.196295164462086],
            [-12.051098821733852, 8.198671018737828],
            [-12.054127223996293, 8.196073182104037],
            [-12.052980943202062, 8.186544801827617],
            [-12.063074469877094, 8.180649972298488],
            [-12.061500209885377, 8.175160632295565],
            [-12.05906407497119, 8.174426835972103],
            [-12.057109097356392, 8.167093129303625],
            [-12.058215527137031, 8.158849537259162],
            [-12.062293619121803, 8.153040965189355],
            [-12.072352396851263, 8.154645109384832],
            [-12.080567085531339, 8.148422566590432],
            [-12.082316335299028, 8.145425098252261],
            [-12.087975642929072, 8.142012793571796],
            [-12.092761413613282, 8.141882816471453],
            [-12.099259587371327, 8.139386698945865],
            [-12.104300027941076, 8.133581918220592],
            [-12.106629310167948, 8.1272382875298],
            [-12.112483356017757, 8.124881099147817],
            [-12.115023452820266, 8.117369992685754],
            [-12.115673798002808, 8.111066599403184],
            [-12.119695081349283, 8.106206070759812],
            [-12.1225528008033, 8.106638221481798],
            [-12.128231830868875, 8.103380342842662],
            [-12.145065976246183, 8.104133312291705],
            [-12.151476032949832, 8.098405742691892],
            [-12.154585745411485, 8.093718753315903],
            [-12.15292933984741, 8.090884757373873],
            [-12.153727424803709, 8.086701271161385],
            [-12.157815208652135, 8.083320085323269],
            [-12.160260566537994, 8.079515967888918],
            [-12.169904104463532, 8.082120250695638],
            [-12.173234809964221, 8.077713532068552],
            [-12.181280688379372, 8.078793588559524],
            [-12.186030439814246, 8.077876614403376],
            [-12.192038832896731, 8.079224962195871],
            [-12.197019727662424, 8.074981093682114],
            [-12.2025866859851, 8.067520031448877],
            [-12.210741094032882, 8.067561330420352],
            [-12.22494910243761, 8.08066568187739],
            [-12.233015253233516, 8.082833963173023],
            [-12.239596341320182, 8.083029264854138],
            [-12.243329632737474, 8.075776706842449],
            [-12.241925371246886, 8.072548402523296],
            [-12.24344038755784, 8.067514896703347],
            [-12.242573276448521, 8.06317757819801],
            [-12.24891055261578, 8.054205495426944],
            [-12.253098064409155, 8.051160803588681],
            [-12.257365004080935, 8.037331150780329],
            [-12.260901832690331, 8.033417572798506],
            [-12.264913217315556, 8.03289424356791],
            [-12.266438396082336, 8.026686397979432],
            [-12.27313096961187, 8.023602205197497],
            [-12.283906173400723, 8.025130967253078],
            [-12.288195944361618, 8.022731478096802],
            [-12.289687984694835, 8.020037129975673],
            [-12.296231184623037, 8.017183138112397],
            [-12.298974885726818, 8.018295340988246],
            [-12.303166519539337, 8.015337706424368],
            [-12.306748349124932, 8.015939207136736],
            [-12.315301602313474, 8.01056516658213],
            [-12.317137813288177, 8.01246828332082],
            [-12.321921796816222, 8.012440392852728],
            [-12.325070468367665, 8.019899452839288],
            [-12.324607490128363, 8.023894455700983],
            [-12.330736232931168, 8.02900648136476],
            [-12.329446126358414, 8.03261106708187],
            [-12.331390490473716, 8.040429120360676],
            [-12.33102160520019, 8.045783908672425],
            [-12.337308685746514, 8.051120971888158],
            [-12.343812447845444, 8.059415585554122],
            [-12.363120419898625, 8.070895665569726],
            [-12.367649055033452, 8.071990667920248],
            [-12.369514468151406, 8.080049565687473],
            [-12.367923540379117, 8.091817823735331],
            [-12.372114997536515, 8.093903085072402],
            [-12.372923004604587, 8.10032933162287],
            [-12.378980727709438, 8.104280353135454],
            [-12.37906653791214, 8.106788905924974],
            [-12.387801692951157, 8.111681700769791],
            [-12.385136139356758, 8.116711113188195],
            [-12.385334426651257, 8.119861904982702],
            [-12.379568791728188, 8.125839955823919],
            [-12.385781958277839, 8.126573772567331],
            [-12.389467833582557, 8.132039112363119],
            [-12.39108904450443, 8.13039298669965],
            [-12.397576723040428, 8.129305116292736],
            [-12.399303431052369, 8.130484151840657],
            [-12.404758745496315, 8.126828905168477],
            [-12.409428572359277, 8.126110753576267],
            [-12.41229326361043, 8.13039958218045],
            [-12.414601225867898, 8.130971199437788],
            [-12.419177517250242, 8.138440483704574],
            [-12.426589931280418, 8.144933939698142],
            [-12.431292994739657, 8.140756629344805],
            [-12.437901305904964, 8.140043326784113],
            [-12.444796963999162, 8.137138982942062],
            [-12.446492640882168, 8.134900094284301],
            [-12.451877069695703, 8.13817794235485],
            [-12.454814756018042, 8.137323573874685],
            [-12.454239581209256, 8.142047817020497],
            [-12.448783427673565, 8.144458115682825],
            [-12.445782719429454, 8.15124661006875],
            [-12.442913347611936, 8.153956660926395],
            [-12.443160041094483, 8.159605959011932],
            [-12.445112000023459, 8.16212978271172],
            [-12.441252433251096, 8.165554707879812],
            [-12.44088232346015, 8.168329024085446],
            [-12.43675073865043, 8.17165028895161],
            [-12.434457916614384, 8.175975946359097],
            [-12.431373500727673, 8.176792794586806],
            [-12.42696848083826, 8.182278832065037],
            [-12.42959613763551, 8.192232554163585],
            [-12.434960316633223, 8.195035100412705],
            [-12.437347841847778, 8.205108325222191],
            [-12.439346956666332, 8.209438206023638],
            [-12.438650495776665, 8.214670351552972],
            [-12.435102352418193, 8.216968969638613],
            [-12.425261868679671, 8.2174626566526],
            [-12.42294414009364, 8.215973608037583],
            [-12.420328179664079, 8.219620927549725],
            [-12.419916236630739, 8.223762709896421],
            [-12.411168788819102, 8.223742812153631],
            [-12.408294486325149, 8.220563382640153],
            [-12.397251922291224, 8.225923279773912],
            [-12.388267787524999, 8.237074134127901],
            [-12.389192420287255, 8.24116755298698],
            [-12.386140160808326, 8.245870227226447],
            [-12.386723703368537, 8.249568222282267],
            [-12.395306444880747, 8.252757736996408],
            [-12.395857492827057, 8.254110463304137],
            [-12.384849495789291, 8.260706653274113],
            [-12.378927907184375, 8.268976202506252],
            [-12.379208253593157, 8.277737405315236],
            [-12.381357072431214, 8.28820344525805],
            [-12.387840293513124, 8.295227480166496],
            [-12.391232786336722, 8.294796276904536],
            [-12.395606760924816, 8.297008419413443],
            [-12.399590372883337, 8.30939969486458],
            [-12.406249396568262, 8.31456813198414],
            [-12.404615826826271, 8.324000268269222],
            [-12.40159221462451, 8.32923550786627],
            [-12.405425959131982, 8.335491185633963],
            [-12.409651039431598, 8.336701807288618],
            [-12.414027763744167, 8.346648105624471],
            [-12.409314383176401, 8.352879803392845],
            [-12.402097425131657, 8.358450312217578],
            [-12.39570112845275, 8.359908053933195],
            [-12.3945430828382, 8.36761397682113],
            [-12.39185587554503, 8.368436817512219],
            [-12.388407033277854, 8.373070783397605],
            [-12.382684792848774, 8.377357225440878],
            [-12.38266519743623, 8.383048031132189],
            [-12.379878545761606, 8.386289842218279],
            [-12.367964589915935, 8.391875033506185],
            [-12.366249563412227, 8.394061885159246],
            [-12.368635890089076, 8.398428372614351],
            [-12.366061109361608, 8.404270283440079],
            [-12.360919479573184, 8.409035925995251],
            [-12.357214628795784, 8.40864352489287],
            [-12.352870544322203, 8.412664523297067],
            [-12.34864834927765, 8.410907546333048],
            [-12.34363686110571, 8.411793206177741],
            [-12.337174172658125, 8.40546871026734],
            [-12.332914885037653, 8.409567747545617],
            [-12.329326712624162, 8.409512841036278],
            [-12.326399189196243, 8.41198179475252],
            [-12.323284209614709, 8.410920427149904],
            [-12.315396204784111, 8.415900485341075],
            [-12.309097280151601, 8.41609096778472],
            [-12.29901789823385, 8.406715489189843],
            [-12.291407820663485, 8.402371003891343],
            [-12.283755924574644, 8.42055726541216],
            [-12.278946684276914, 8.418722289669624],
            [-12.273997684430425, 8.426337103660922],
            [-12.271266440058394, 8.42852037157611],
            [-12.269338815289217, 8.433746163754739],
            [-12.269450510444166, 8.438161802474125],
            [-12.272719524065302, 8.439656314072394],
            [-12.272160521080579, 8.447415435319801],
            [-12.277946486998326, 8.451269974133126],
            [-12.282464477843908, 8.460182905274284],
            [-12.283121258143346, 8.467585368693843],
            [-12.281638416171324, 8.470380259139214],
            [-12.290196493730217, 8.486410791449059],
            [-12.28428828236767, 8.492859697328523],
            [-12.27527205726319, 8.497371738294428],
            [-12.273093783365601, 8.5002738092869],
            [-12.266259195452637, 8.503813740499712],
            [-12.264924543715484, 8.50952955417953],
            [-12.266408918756317, 8.515957947245859],
            [-12.268735633503026, 8.518676832889856],
            [-12.268733875592275, 8.524348811971791],
            [-12.279116461958306, 8.535158230041318],
            [-12.284938448061029, 8.537444486652841],
            [-12.291394552729827, 8.538294595509642],
            [-12.295288650564617, 8.543959086051531],
            [-12.296209759052903, 8.549310179873137],
            [-12.300802608581535, 8.55035156862359],
            [-12.308531432889396, 8.54655284812359],
            [-12.312427098936586, 8.547970590114852],
            [-12.315113856462128, 8.552484480363642],
            [-12.315671523120253, 8.559415740608689],
            [-12.312259481808596, 8.563340290536358],
            [-12.30409049102296, 8.566631534546895],
            [-12.303634441687109, 8.570122284393598],
            [-12.305537907061218, 8.584389738484953],
            [-12.312040088875069, 8.583085158256232],
            [-12.319278840025666, 8.585116715311125],
            [-12.323621285139165, 8.58935963957055],
            [-12.321445198360552, 8.596041608891616],
            [-12.315452532617456, 8.597988635910417],
            [-12.310164797036876, 8.6051787908557],
            [-12.310143377222202, 8.60740125566267],
            [-12.301248986975136, 8.608591581888305],
            [-12.291932419971696, 8.61334079958506],
            [-12.28960760001037, 8.616611837600317],
            [-12.291950402893065, 8.620206535438072],
            [-12.290241261647704, 8.628396796777842],
            [-12.283977710603288, 8.628470865868435],
            [-12.279242008492146, 8.642652613105055],
            [-12.278891132470822, 8.646977962722671],
            [-12.282661874075028, 8.654989627872514],
            [-12.284494956226425, 8.65626761850773],
            [-12.285944581739113, 8.663828708592654],
            [-12.295819382519769, 8.666062163620603],
            [-12.298825206859481, 8.67086002769885],
            [-12.304833410324374, 8.672723953645034],
            [-12.314566227755176, 8.681205035532866],
            [-12.310750540070469, 8.690636977117837],
            [-12.312618837890172, 8.692004178045204],
            [-12.314930734135752, 8.702706528724844],
            [-12.310201667807576, 8.7065123810831],
            [-12.305050378715407, 8.708183539315788],
            [-12.303272812253828, 8.720455005216909],
            [-12.297582462526702, 8.717844173138994],
            [-12.288446087488524, 8.71945740643673],
            [-12.284812415773613, 8.718272042486197],
            [-12.279650371105912, 8.711012727564032],
            [-12.277327906948917, 8.709846788537984],
            [-12.267025671952021, 8.715362634842657],
            [-12.262243369726086, 8.71662265461452],
            [-12.254998012794688, 8.712885039527922],
            [-12.254337880475024, 8.71874399116821],
            [-12.24815236878806, 8.743657452378967],
            [-12.246888123378936, 8.746492914075779],
            [-12.24969580308669, 8.753186214563977],
            [-12.249972804134416, 8.759737523815708],
            [-12.24546971622394, 8.762894276719512],
            [-12.244749453102376, 8.776252786193325],
            [-12.245501840338399, 8.784146828419697],
            [-12.25422501300172, 8.792276619389442],
            [-12.252289126902072, 8.79717840031325],
            [-12.253513822175819, 8.804732670837627],
            [-12.25344549862711, 8.811185072451206],
            [-12.2481205604755, 8.817362592194664],
            [-12.24090114875177, 8.8136762898774],
            [-12.232169004808267, 8.814757429919691],
            [-12.227428097032698, 8.816749896916324],
            [-12.220552640020514, 8.82246295330656],
            [-12.218469537794931, 8.826310771489707],
            [-12.219739467269465, 8.831190815323751],
            [-12.21996043557088, 8.844929065242816],
            [-12.217601890386042, 8.849943394031897],
            [-12.20952451140946, 8.860938076321432],
            [-12.207466752540979, 8.867219722240717],
            [-12.201721435556472, 8.870906893389785],
            [-12.199135938618065, 8.881699922209242],
            [-12.193468426596782, 8.899095402087863],
            [-12.195795237861537, 8.909887763385264],
            [-12.1971613241061, 8.92209203343545],
            [-12.191988064187802, 8.926574435468336],
            [-12.187464384953897, 8.929038194111495],
            [-12.18640824470531, 8.932117756653746],
            [-12.180180215050225, 8.933096935423263],
            [-12.178058713917617, 8.936214090003535],
            [-12.173280335514752, 8.939524583187248],
            [-12.16734553247693, 8.940310472197064],
            [-12.164942242897931, 8.947780245100798],
            [-12.164127737636194, 8.956072046493379],
            [-12.160525785734892, 8.961728230544773],
            [-12.151482756907225, 8.962618310764885],
            [-12.15268580900441, 8.969176417671383],
            [-12.15530087080069, 8.96968110355914],
            [-12.15991742168419, 8.974295903779383],
            [-12.154311899605958, 8.98746560128001],
            [-12.155508922503772, 8.993243103539013],
            [-12.16271333146453, 8.997829739729836],
            [-12.16296163468786, 9.001841976751258],
            [-12.165294242045638, 9.008031996303615],
            [-12.163527424416866, 9.017552485292647],
            [-12.163912182941544, 9.022780871453433],
            [-12.162159306569704, 9.028611621927979],
            [-12.159995853201256, 9.030185497403707],
            [-12.148114336729085, 9.030555095160738],
            [-12.143599762529549, 9.026572531021307],
            [-12.13806276224237, 9.028726914806631],
            [-12.132212610223617, 9.027553324918639],
            [-12.12641304485442, 9.029261509532775],
            [-12.12304559306693, 9.032162949648017],
            [-12.121673425559763, 9.035908074534582],
            [-12.11822056135098, 9.03822721596504],
            [-12.117637381298191, 9.042656186098647],
            [-12.120412119818468, 9.049943204178328],
            [-12.11927216050074, 9.05401461217107],
            [-12.114620153004381, 9.0606169253452],
            [-12.114685433585086, 9.07181561649985],
            [-12.111047793037272, 9.073925990222438],
            [-12.107259423810929, 9.082035195584293],
            [-12.10000779252977, 9.089123044904522],
            [-12.09814442098025, 9.093496235416694],
            [-12.100458909152696, 9.09572665067382],
            [-12.103262409054913, 9.104577879021589],
            [-12.105242940065152, 9.107416899247632],
            [-12.099515548204538, 9.11014352604583],
            [-12.094209073394817, 9.115056358560581],
            [-12.093171485131993, 9.118771858046422],
            [-12.086731912170146, 9.125453521099143],
            [-12.088694883837501, 9.131727307363322],
            [-12.083548973495105, 9.140259885628172],
            [-12.082066102022434, 9.147816808559995],
            [-12.080040507672301, 9.151479494318933],
            [-12.08105195505896, 9.155171989627584],
            [-12.07885476397248, 9.160256937965762],
            [-12.080216574104128, 9.166655074099323],
            [-12.084163241196121, 9.17437809605724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -114.12074757355708,
          "lat": 46.08170379478144
        },
        "year": "2023",
        "ste_code": ["30"],
        "ste_name": ["Montana"],
        "coty_code": ["30081"],
        "coty_name": ["Ravalli"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ravalli County"],
        "coty_fp_code": "081",
        "coty_gnis_code": "01719582"
      },
      "bbox": [
        -12.454814756018042, 8.01056516658213, -11.663741149371793,
        9.17437809605724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.2874325568037227, 3.4206041110630228],
            [-0.20190195611919412, 3.4196450184577505],
            [-0.14323348198869318, 3.4190415715606277],
            [-0.035822909839695084, 3.4178960242071175],
            [0.05437104019551242, 3.4171539928080885],
            [0.054410806846936374, 3.342677149426017],
            [0.05406146330450183, 3.3294979751705633],
            [0.05360927388150875, 3.242121294744806],
            [0.05295819841127226, 3.1429706075320203],
            [0.05257374603021461, 3.067259996231964],
            [-0.06863487761465237, 3.0684484837997785],
            [-0.20718195416166515, 3.0700032824172374],
            [-0.29159632192582347, 3.0710756314211842],
            [-0.29041436236538865, 3.1586149657784794],
            [-0.28960499819739494, 3.2461118999168717],
            [-0.28848244252207844, 3.333670273476907],
            [-0.2874325568037227, 3.4206041110630228]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.78737840446858,
          "lat": 41.916385923678924
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31039"],
        "coty_name": ["Cuming"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cuming County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "00835841"
      },
      "bbox": [
        -0.29159632192582347, 3.067259996231964, 0.054410806846936374,
        3.4206041110630228
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.277932337805775, 1.7172751617655133],
            [-2.2514749422007165, 1.7163107677969909],
            [-2.2020268534116796, 1.714195827943782],
            [-2.179483458561467, 1.7134751304054345],
            [-2.130425380728774, 1.7112867210839497],
            [-2.1225837564470664, 1.7116505794647288],
            [-2.108525499111581, 1.7104531694280898],
            [-2.0228707116939226, 1.7074802478558866],
            [-1.9374519899915634, 1.7046346982704363],
            [-1.9403061244811304, 1.616760243189347],
            [-1.9424960749253473, 1.5506179128489785],
            [-1.9460873061481925, 1.4410461882724006],
            [-1.9490158902136328, 1.353098492400973],
            [-2.033657220280097, 1.355951401610649],
            [-2.1191407868654344, 1.358982373168501],
            [-2.1344351007163915, 1.3598356126945867],
            [-2.1778095129551174, 1.3610801687933856],
            [-2.193784799608751, 1.3617518933960748],
            [-2.287495234443632, 1.3651044363423661],
            [-2.2897181131635413, 1.3651893887571895],
            [-2.2879762833413473, 1.434647387835162],
            [-2.2876256591887683, 1.4531323142522412],
            [-2.2860544842120913, 1.4900910004584325],
            [-2.2849456235400405, 1.526121970157253],
            [-2.2842053747431095, 1.5406302027574255],
            [-2.2822122385273786, 1.603568611007252],
            [-2.2821239151360726, 1.6120768304835174],
            [-2.277932337805775, 1.7172751617655133]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.40464598128094,
          "lat": 40.176499797376636
        },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31083"],
        "coty_name": ["Harlan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Harlan County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "00835863"
      },
      "bbox": [
        -2.2897181131635413, 1.353098492400973, -1.9374519899915634,
        1.7172751617655133
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.8918622465114399, 3.079317934967707],
            [-0.807488782993227, 3.0780213029530734],
            [-0.6711313036892175, 3.0761113667920776],
            [-0.5494207316582581, 3.0745384643526172],
            [-0.46378354257383314, 3.073236768373625],
            [-0.46511295569177874, 2.985815933071868],
            [-0.46598175808100334, 2.9128447783683393],
            [-0.4673131039805814, 2.810657008741277],
            [-0.46782219860775026, 2.7669432578848485],
            [-0.46849890138270384, 2.723155421002902],
            [-0.46936310087602856, 2.7121065226988357],
            [-0.4752866036208441, 2.714312313087555],
            [-0.4841924794923881, 2.7232469661830048],
            [-0.4899214753496518, 2.727188148228004],
            [-0.49462655013121637, 2.728982425634286],
            [-0.5073618412908676, 2.7295063180838404],
            [-0.5116749337286047, 2.7285456735022424],
            [-0.5228418173991366, 2.7243387217029187],
            [-0.5312977611714149, 2.720479953775776],
            [-0.5381186691173948, 2.7208520024454077],
            [-0.5450427998816397, 2.7242095023078488],
            [-0.5519489899455436, 2.7264920918397553],
            [-0.5545370058032505, 2.7255677147863953],
            [-0.5673028979371412, 2.722292864486849],
            [-0.5725035633307013, 2.716382923640423],
            [-0.5764491298328941, 2.714162194383534],
            [-0.5921138313264145, 2.7099777783109484],
            [-0.5987277015500666, 2.7063008108074795],
            [-0.604599895930555, 2.705283556490899],
            [-0.6159586266475671, 2.6986510552346137],
            [-0.6355009977008002, 2.6952380586207627],
            [-0.6498769770219988, 2.6959801571836026],
            [-0.6559824584619494, 2.6953413356592124],
            [-0.6698675891129876, 2.6925997398190615],
            [-0.6790470694857705, 2.685794192828286],
            [-0.6921177410799091, 2.6775557046044614],
            [-0.6956259829924681, 2.6746192521551833],
            [-0.7061526499389535, 2.668365611423532],
            [-0.7175351082043203, 2.665142687958406],
            [-0.7268229619077115, 2.664517674592567],
            [-0.725927808907141, 2.7268824967911987],
            [-0.8042965183022553, 2.728049200507247],
            [-0.8034028033246963, 2.786709645961032],
            [-0.8018108407697445, 2.8608190546173318],
            [-0.8319534693386672, 2.8614809304541353],
            [-0.8670679338219216, 2.8615736307723614],
            [-0.8955743648458606, 2.861933883921358],
            [-0.8953566978452331, 2.9192420398318055],
            [-0.8940769265224401, 2.9922631988309853],
            [-0.8929709024480981, 3.0324104520168462],
            [-0.8918622465114399, 3.079317934967707]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.52112106533717, "lat": 41.57127763526968 },
        "year": "2023",
        "ste_code": ["31"],
        "ste_name": ["Nebraska"],
        "coty_code": ["31141"],
        "coty_name": ["Platte"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Platte County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "00835892"
      },
      "bbox": [
        -0.8955743648458606, 2.664517674592567, -0.46378354257383314,
        3.079317934967707
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [17.397321500153428, 7.220480817599085],
            [17.393729965238776, 7.233269528179928],
            [17.399083308565295, 7.2425899513795295],
            [17.399988574558165, 7.251537345760813],
            [17.40313338470395, 7.256336162377644],
            [17.40164662559704, 7.264004667926647],
            [17.398161304258387, 7.268067953095978],
            [17.39594687681213, 7.273623744233123],
            [17.397670807456073, 7.2851064915394765],
            [17.39445292688822, 7.2956764062219],
            [17.388194881406424, 7.305412356987714],
            [17.389382961792236, 7.315374012619989],
            [17.394781571842678, 7.317819031323456],
            [17.39888293981293, 7.3214716698890685],
            [17.392309138564467, 7.330657024518264],
            [17.39278307195145, 7.3374726115546425],
            [17.398848303862, 7.339601468191785],
            [17.39947349568685, 7.3459334135990515],
            [17.402293772160945, 7.355840823441295],
            [17.411347470572284, 7.366225709475083],
            [17.412316939404818, 7.370011002852746],
            [17.41750885398705, 7.375472049613799],
            [17.41989356598095, 7.382828455060747],
            [17.418049773039176, 7.393445365895496],
            [17.41421901308478, 7.401738004760336],
            [17.414790581655257, 7.406078459776873],
            [17.418945943126705, 7.407301884633168],
            [17.422609460567408, 7.411556338405209],
            [17.424703115792273, 7.418764393960622],
            [17.422278095742772, 7.424112122818591],
            [17.42801777519732, 7.427903180908156],
            [17.422678802763333, 7.429718172094509],
            [17.417372892028194, 7.4297466872078415],
            [17.414556356409644, 7.426320687121473],
            [17.41110714011881, 7.426555364648749],
            [17.41077980609033, 7.432214081070491],
            [17.408254232789194, 7.4448519050247395],
            [17.403012513368225, 7.451362323921326],
            [17.40988701895734, 7.463131356055014],
            [17.40668013467539, 7.4693700038725375],
            [17.40799171086401, 7.4735917334343265],
            [17.412600013840088, 7.476598504513554],
            [17.411378276533856, 7.479385894829064],
            [17.412108090933085, 7.4840255646412945],
            [17.418194686544002, 7.482745113845137],
            [17.420240376104804, 7.485708710172969],
            [17.41972329349204, 7.491302598109199],
            [17.42264408634342, 7.495926688786636],
            [17.4175603089687, 7.502429253314174],
            [17.41763331468301, 7.505324406478145],
            [17.424997299096116, 7.513127954883316],
            [17.42645771975408, 7.516197249515472],
            [17.421134446074255, 7.517968629629853],
            [17.4213967888818, 7.521340350746872],
            [17.428476890603996, 7.52345986961243],
            [17.429520958213768, 7.530291799465899],
            [17.431605311852, 7.535222638890552],
            [17.427207423192364, 7.542014213239488],
            [17.433112573574597, 7.546141036532394],
            [17.437274357423533, 7.544406455141872],
            [17.441068675172833, 7.547429058766524],
            [17.439352251633082, 7.550039592953343],
            [17.430508393686065, 7.552389491639387],
            [17.430405008296667, 7.555348183559584],
            [17.435562082082104, 7.55672765513158],
            [17.437458426354812, 7.559845789031736],
            [17.43642059753305, 7.567995578728613],
            [17.43441502482496, 7.569601366982258],
            [17.42916790730259, 7.5698750939080925],
            [17.428561369780365, 7.5634432479143285],
            [17.425040016998253, 7.562199223172009],
            [17.42118168764428, 7.565511064994785],
            [17.416942283837685, 7.5740111659204485],
            [17.416511908724388, 7.583631773561857],
            [17.419602235085268, 7.5885491993793925],
            [17.42584899157346, 7.591540782534457],
            [17.426821391887295, 7.597775785064293],
            [17.41932232476904, 7.60256022237098],
            [17.415327890054215, 7.615244290947889],
            [17.416667657328865, 7.621188181109981],
            [17.413284520603657, 7.62099818831582],
            [17.41296595956938, 7.625664166133298],
            [17.409316797190705, 7.6248354356629715],
            [17.404032026926362, 7.629752693981187],
            [17.398047550292166, 7.640076189149753],
            [17.38946352283596, 7.648492004714369],
            [17.3887694699874, 7.655682500596923],
            [17.391016460186684, 7.659845799699323],
            [17.39099573019798, 7.665611327142827],
            [17.388916360310056, 7.6694420849218545],
            [17.391169340505567, 7.672601789995038],
            [17.391642407753956, 7.678926261079287],
            [17.389103596400933, 7.685632975416045],
            [17.389926915056368, 7.6986265258825455],
            [17.387000524831315, 7.703580017192844],
            [17.383598323372865, 7.7056683115435485],
            [17.377104303348705, 7.714234214034476],
            [17.374517468522665, 7.720237843207105],
            [17.374900455049893, 7.726185768366358],
            [17.36918129047577, 7.723865350633273],
            [17.367520108895455, 7.726581399771431],
            [17.368108394830106, 7.732826611948052],
            [17.370387778271844, 7.742649500342744],
            [17.373141034283094, 7.7477246303360126],
            [17.377644796284887, 7.750394529503178],
            [17.378140586711776, 7.753579316024906],
            [17.38135068127581, 7.755404264159132],
            [17.384402920646195, 7.762882827153609],
            [17.38167267678819, 7.775713529825992],
            [17.37984184259412, 7.780164640333249],
            [17.381947154185966, 7.782705222470954],
            [17.38951142810794, 7.78239784319395],
            [17.398915767453527, 7.788776381191877],
            [17.40914428627896, 7.798706696885035],
            [17.409173692378825, 7.803870983034908],
            [17.411273244635368, 7.8056980485037615],
            [17.42392998314504, 7.807968669850047],
            [17.4360393169458, 7.812289572739901],
            [17.44327934157271, 7.812119194505007],
            [17.4471646261475, 7.814969893316009],
            [17.448823759604277, 7.819959449451408],
            [17.45297358498963, 7.825653617500769],
            [17.45803978845486, 7.828865563157408],
            [17.463155702542664, 7.82925595731868],
            [17.48650399394592, 7.824095331349379],
            [17.492896425624956, 7.829311978804083],
            [17.499132117216256, 7.83170006868544],
            [17.507663966714883, 7.840924019877905],
            [17.510162716236657, 7.8440474002940075],
            [17.519408321037567, 7.849305855744402],
            [17.522734461598866, 7.854665181229907],
            [17.51751606213594, 7.863665567881113],
            [17.51888758144973, 7.869283646262321],
            [17.51583720201952, 7.871507198819054],
            [17.51515979817159, 7.8779715076167545],
            [17.5185074047687, 7.880815082643135],
            [17.522342140493215, 7.881262538057625],
            [17.524138092935978, 7.884410624677021],
            [17.52054262308735, 7.888033784717647],
            [17.520569386734866, 7.891115717039513],
            [17.5248936572319, 7.898276958798915],
            [17.52687505499472, 7.8998030093929055],
            [17.53531725852972, 7.901507676159574],
            [17.542581874994937, 7.910063227050892],
            [17.55513613528927, 7.898524819803804],
            [17.55804085836568, 7.896454391711062],
            [17.570097525506128, 7.885100790204886],
            [17.60882865865539, 7.851025727523489],
            [17.61457141515751, 7.857096398110348],
            [17.691608868725854, 7.844414098464776],
            [17.712115669498818, 7.798212468061727],
            [17.757230057446794, 7.818505644596543],
            [17.76019185354915, 7.8117356418529065],
            [17.784017918757684, 7.822462638657936],
            [17.804978651401957, 7.816883750029741],
            [17.833416884735943, 7.7862940874801145],
            [17.826413724576454, 7.783157000737076],
            [17.846774224197812, 7.743825983002012],
            [17.867916808385726, 7.736763373108123],
            [17.884596448179206, 7.703773810216115],
            [17.88842197050153, 7.689552709325857],
            [17.886457226529185, 7.682663641502754],
            [17.904572717343285, 7.657225956133362],
            [17.91812899328826, 7.661096404994546],
            [17.91713788855302, 7.655678522624029],
            [17.90759097397109, 7.618083484562518],
            [17.90442927541922, 7.609943471985117],
            [17.91266202701709, 7.590424849390851],
            [17.946867630425277, 7.511290627592345],
            [17.938253569459345, 7.507675583901593],
            [17.81208280680015, 7.452567193669692],
            [17.851337790256, 7.362815511677038],
            [17.855247662428418, 7.364283955097457],
            [17.868746686438715, 7.331251599371573],
            [17.89194676360342, 7.272433132679772],
            [17.824927212590442, 7.244459423096485],
            [17.807032665234857, 7.236419741253009],
            [17.80612752374126, 7.231759932244067],
            [17.80956924095701, 7.2254807013514135],
            [17.81002189596735, 7.21886326647816],
            [17.808228683926473, 7.212786878660858],
            [17.810840886918154, 7.205560163281978],
            [17.815406664222532, 7.197952959629761],
            [17.81434508072189, 7.193708142750956],
            [17.816508409776475, 7.1896018568846465],
            [17.814546002416286, 7.184250348371062],
            [17.821210701457108, 7.1748070603282645],
            [17.813438227731176, 7.165013856436852],
            [17.816249681464065, 7.1600461070590775],
            [17.816089058395043, 7.156302804483098],
            [17.81199286299613, 7.155364629818923],
            [17.80210336559214, 7.14288575063286],
            [17.795564477949323, 7.140513465707917],
            [17.790502995099665, 7.140300984803967],
            [17.786883387177287, 7.145194119110862],
            [17.78311143596687, 7.14372282305988],
            [17.779680588158694, 7.137354376726292],
            [17.77614792770532, 7.137036479719041],
            [17.773029750876063, 7.132942622927976],
            [17.773467828074136, 7.128813021824294],
            [17.782726614866405, 7.125348184164769],
            [17.78716630282645, 7.1214446928882005],
            [17.786275102541918, 7.116836309845513],
            [17.782674692548408, 7.1127518560890675],
            [17.784161377983935, 7.108790527397659],
            [17.782568250733807, 7.105328238595253],
            [17.779396958748823, 7.108955222605819],
            [17.775192441269777, 7.109500113033171],
            [17.771457601383755, 7.107763418630637],
            [17.770054681631517, 7.1039500866130165],
            [17.766167058209973, 7.10541102945429],
            [17.76257334770523, 7.102248595062913],
            [17.75812895087979, 7.103449481637225],
            [17.750482885233655, 7.0857848346014665],
            [17.746624577644987, 7.091514299622167],
            [17.742552879907784, 7.09307120520254],
            [17.737910414213918, 7.088571143802524],
            [17.73477816785187, 7.088846682862809],
            [17.731724120029583, 7.0811892204126545],
            [17.727609041903012, 7.077839887790019],
            [17.724600059955844, 7.077471064141882],
            [17.72323542631503, 7.074258300423666],
            [17.724358417426846, 7.070493669527277],
            [17.68559671941338, 7.129493998049911],
            [17.664879166418217, 7.086488380311719],
            [17.65952257419551, 7.069725298993297],
            [17.649091272164124, 7.043459895548103],
            [17.646228885703398, 7.0345917815912316],
            [17.550309465012138, 7.0255688494068105],
            [17.546363866122658, 7.034033741408709],
            [17.53750756608322, 7.006741648222614],
            [17.523309930175387, 7.008792913162608],
            [17.514679418669008, 7.010645523317096],
            [17.52050532356548, 7.027759339127497],
            [17.470129324413175, 7.036036476702688],
            [17.4413973396776, 7.040287693721351],
            [17.42930058244425, 7.039342947995264],
            [17.393124513826795, 7.0359135290276695],
            [17.352886970422443, 7.033295274858875],
            [17.35224895118968, 7.03998018135564],
            [17.348267464986495, 7.042548655754405],
            [17.345797724669016, 7.046251634122153],
            [17.34485194074621, 7.056865284212689],
            [17.34707793153998, 7.063047032151673],
            [17.34436654385945, 7.066593973672652],
            [17.345421926589577, 7.069046960822617],
            [17.352817567932508, 7.07542939958387],
            [17.34996001887239, 7.090128792320916],
            [17.353147183935054, 7.101606001218947],
            [17.35215647630822, 7.113226608762503],
            [17.348878431896544, 7.117522800395696],
            [17.34645947506667, 7.129519071174957],
            [17.347810950283915, 7.136136250050148],
            [17.347629483062832, 7.141080661973957],
            [17.35150235006145, 7.147258398493017],
            [17.35443216541009, 7.157281190833127],
            [17.359301753600032, 7.165887274020519],
            [17.360281138103414, 7.172175902688783],
            [17.365256027997308, 7.17393643209772],
            [17.376496269353364, 7.186239871749619],
            [17.383373706934908, 7.1909352759360115],
            [17.385138134617424, 7.194865109905401],
            [17.38878414769414, 7.210466374790795],
            [17.390593731934217, 7.213887496206463],
            [17.394252943556825, 7.216038037682491],
            [17.397321500153428, 7.220480817599085]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -71.82080624529263,
          "lat": 43.940673196155444
        },
        "year": "2023",
        "ste_code": ["33"],
        "ste_name": ["New Hampshire"],
        "coty_code": ["33009"],
        "coty_name": ["Grafton"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Grafton County"],
        "coty_fp_code": "009",
        "coty_gnis_code": "00873178"
      },
      "bbox": [
        17.34436654385945, 7.006741648222614, 17.946867630425277,
        7.910063227050892
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.23277814109803, 3.0451568709427588],
            [16.240722438739194, 3.0465634423088352],
            [16.241229981587193, 3.049592377851274],
            [16.2502156418901, 3.0534399366281506],
            [16.252798957388272, 3.0520179753101715],
            [16.264220522063653, 3.049442718372722],
            [16.26756891221178, 3.0464750660136404],
            [16.2695021360442, 3.0416999081350276],
            [16.270075061146002, 3.031519707451888],
            [16.267454175562754, 3.029931542522615],
            [16.271332290984308, 3.020571447707379],
            [16.275337294296037, 3.0183932892937984],
            [16.274488946239714, 3.0126845652174215],
            [16.275983227885188, 3.008554415412436],
            [16.280652774745636, 3.007908323582701],
            [16.28518130129815, 3.005113431212281],
            [16.292939004428128, 3.0046638347314816],
            [16.306727212802905, 3.0081690122218694],
            [16.30762174754461, 3.006354577894892],
            [16.30351755110899, 2.9940858197287215],
            [16.311191032718256, 2.9904569099908804],
            [16.32048442790738, 2.9911346456974948],
            [16.32278980406604, 2.9880805031026543],
            [16.32728927684255, 2.985367719145365],
            [16.335292617847703, 2.971750561411416],
            [16.352002977776273, 2.9627137146729488],
            [16.3748335247337, 2.9145684936828413],
            [16.393672048381138, 2.874146144062646],
            [16.397202122598255, 2.8734797106859262],
            [16.401347012474073, 2.8679328761823872],
            [16.405511672387593, 2.867375746086771],
            [16.41570441247565, 2.8691443454896723],
            [16.420042802485508, 2.873094861283032],
            [16.430919804018266, 2.878368803873004],
            [16.43831009063647, 2.88299382072126],
            [16.456401795836438, 2.8851037852740515],
            [16.45790952677639, 2.883399609311472],
            [16.467103044730045, 2.882588088165501],
            [16.48143741035965, 2.873514823959815],
            [16.486853413160404, 2.868864055603308],
            [16.491348840109083, 2.8626175294899316],
            [16.49469630880344, 2.8625528019668653],
            [16.49994048536449, 2.856140367033801],
            [16.505044576714337, 2.8532937205163504],
            [16.513896805760375, 2.850800948174439],
            [16.531214143018794, 2.8418821819699023],
            [16.49601607784474, 2.7771279156944724],
            [16.453418175913676, 2.698739068372052],
            [16.450065986537517, 2.6999671415690782],
            [16.447079972837656, 2.7033618339002605],
            [16.44005775412617, 2.706272950867356],
            [16.438416195981354, 2.71256550430006],
            [16.429397463046993, 2.7174363431731585],
            [16.42374963121672, 2.7255337374178663],
            [16.42286269662578, 2.7304293405402467],
            [16.419481907504824, 2.738492957552384],
            [16.416863797793496, 2.746916483460037],
            [16.407247975285216, 2.7600997808743695],
            [16.399309065109513, 2.765733294163921],
            [16.390084654603303, 2.773949944605947],
            [16.384004467654563, 2.776125399447721],
            [16.37685412305872, 2.7752549548344403],
            [16.371311244499914, 2.778125675726916],
            [16.362228363179504, 2.775237086456892],
            [16.34952910675084, 2.7769957600333806],
            [16.344164243961586, 2.779618866381997],
            [16.342384219891212, 2.7850212165467796],
            [16.337663490795443, 2.7880557190314046],
            [16.32434310822325, 2.7913225010623863],
            [16.31695833455733, 2.7943652597210673],
            [16.31869442920822, 2.8007116323257746],
            [16.316965686618964, 2.8020392625147905],
            [16.315019796481156, 2.810270404169726],
            [16.303586680250376, 2.816438004489253],
            [16.29804478596181, 2.8214793349229277],
            [16.294037482454502, 2.8268396002015166],
            [16.289606466927893, 2.830253847835828],
            [16.28603549907659, 2.8387067122057825],
            [16.275278204915782, 2.8409250938460393],
            [16.274588502459135, 2.838331931493075],
            [16.27060770841074, 2.8348222054021273],
            [16.27313369999425, 2.831583409837436],
            [16.27010047390227, 2.828693674952506],
            [16.265924206241213, 2.834889962607185],
            [16.259457999791568, 2.832114731210694],
            [16.259567883261088, 2.8391912922905287],
            [16.260680794892895, 2.844529317528141],
            [16.2648256342475, 2.844139553841863],
            [16.265482809839977, 2.8494409526514812],
            [16.263100145062943, 2.852930764087102],
            [16.264071218488507, 2.857442845155501],
            [16.25349601582691, 2.8648926100370726],
            [16.24934713001232, 2.8720772611049075],
            [16.25218713620066, 2.8795350220032985],
            [16.249807473065417, 2.882584432733141],
            [16.250487362103744, 2.8859506788039946],
            [16.246592446741612, 2.8900611312658278],
            [16.2485089165458, 2.8942406610059472],
            [16.24371113702187, 2.895387530799299],
            [16.24226866923788, 2.8985884393392287],
            [16.23828044666357, 2.9021380111702264],
            [16.226327841299508, 2.9077025762096618],
            [16.222595742489705, 2.9062874131799528],
            [16.22173501857821, 2.910609679525127],
            [16.218411137488697, 2.912426419852578],
            [16.214517109003875, 2.911604478025808],
            [16.210281079579755, 2.9188072969824352],
            [16.205031718309634, 2.9209460008623593],
            [16.207021262123586, 2.9256638713056873],
            [16.196490152156972, 2.930293989567743],
            [16.19787415078612, 2.932388782829693],
            [16.200426932171645, 2.943539523850772],
            [16.200028175375625, 2.9554296543965926],
            [16.19135518245112, 2.9695017263207846],
            [16.18908895005114, 2.9758120601338547],
            [16.18648466804691, 2.9888621644658806],
            [16.186305865772663, 2.996158880060883],
            [16.18808670320575, 3.0011972303810275],
            [16.19469319549888, 3.009588432061576],
            [16.205710799384793, 3.0192384730490174],
            [16.211613192237937, 3.022657452663565],
            [16.217305982789807, 3.024641270757715],
            [16.224236174874903, 3.0292245988919073],
            [16.230944802394667, 3.0389712402613696],
            [16.23277814109803, 3.0451568709427588]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -74.9597282148102, "lat": 39.80349857402721 },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34007"],
        "coty_name": ["Camden"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Camden County"],
        "coty_fp_code": "007",
        "coty_gnis_code": "00882273"
      },
      "bbox": [
        16.186305865772663, 2.698739068372052, 16.531214143018794,
        3.0534399366281506
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.599251531041194, 3.3986383780351326],
            [16.615510533272897, 3.401123693471049],
            [16.61752468430105, 3.4008089641243457],
            [16.660763730723605, 3.4400090511932793],
            [16.658149431066693, 3.4484535596897303],
            [16.666561772501396, 3.4680133785888216],
            [16.702648171806455, 3.528547656031643],
            [16.73194027540995, 3.5774779676946946],
            [16.738861475535273, 3.5893618124922835],
            [16.733459210511917, 3.6138745670761874],
            [16.7389245680297, 3.6274610197342367],
            [16.7425260034837, 3.6306135109699103],
            [16.745918770001637, 3.6303516044378323],
            [16.747171253476857, 3.6380965078117935],
            [16.757517170756156, 3.635885515823952],
            [16.762224736212797, 3.6285850401709077],
            [16.770653653432436, 3.6323169944655214],
            [16.773678871065616, 3.639651520586546],
            [16.774051583853346, 3.645435159432878],
            [16.776334515530333, 3.6506810148939497],
            [16.77906903387797, 3.6510303403344304],
            [16.79002665059774, 3.644395426250689],
            [16.795590622005967, 3.643945801245008],
            [16.806099018464916, 3.650331259284276],
            [16.808056958223585, 3.655718835417918],
            [16.81036778317717, 3.6565277158765217],
            [16.83081486012199, 3.6489204715911665],
            [16.848982661969824, 3.6479432880865623],
            [16.873979834737973, 3.6375669497489667],
            [16.883011279529406, 3.6357558082024792],
            [16.915301511128362, 3.6352736912748083],
            [16.9193042213917, 3.636672265595347],
            [16.921370348319535, 3.6453528464187737],
            [16.91873841593926, 3.6689753848080655],
            [16.915553228768847, 3.6726385100570678],
            [16.909408989485627, 3.673360141055327],
            [16.908962131348083, 3.6757839691058436],
            [16.903143867496063, 3.6877696286833817],
            [16.89799980145966, 3.691045863468457],
            [16.893317167042625, 3.6915286771723532],
            [16.891000879429495, 3.6953167852705433],
            [16.89213887325178, 3.698327013702516],
            [16.89641055965751, 3.700137786620324],
            [16.903060302777764, 3.6998396796093203],
            [16.920199578182004, 3.6812340404595756],
            [16.924764841759306, 3.6698868669311002],
            [16.93111984405395, 3.648186269646667],
            [16.938588547593962, 3.635513143312329],
            [16.945104263636225, 3.614982823829242],
            [16.95386467097822, 3.5855513215958292],
            [16.962448562589977, 3.530775001985679],
            [16.963954092608166, 3.5104750827438536],
            [16.965073935763844, 3.467547142942558],
            [16.963896721777008, 3.424277494438631],
            [16.965073956049984, 3.414784822812806],
            [16.964238270088586, 3.348344279084004],
            [16.96597582534889, 3.3290504213096757],
            [16.96665382613032, 3.3275044481136664],
            [16.96295480766672, 3.3290589978418317],
            [16.957044885380316, 3.328678069669272],
            [16.95042000737964, 3.3225085521180753],
            [16.95013582435484, 3.3187878142115506],
            [16.942610159461957, 3.308848122855932],
            [16.931401608757742, 3.3125895246049697],
            [16.920744551744765, 3.3224557942335835],
            [16.91899086337261, 3.328505893259674],
            [16.912517941148234, 3.3415047566206533],
            [16.90781340646597, 3.3472640816816606],
            [16.904026740814018, 3.3490655940154177],
            [16.881334782664766, 3.304304545486597],
            [16.87812308356796, 3.304425389070971],
            [16.872088722584888, 3.3105696281064554],
            [16.863369818932114, 3.3092469056271514],
            [16.85705213154496, 3.3111038736793974],
            [16.854573159750302, 3.3097403306365467],
            [16.84597712467667, 3.309821191921249],
            [16.84007485898111, 3.3087484215005882],
            [16.833049832228486, 3.304654653437902],
            [16.82432340821013, 3.301461737396259],
            [16.81856283771945, 3.3010145470199994],
            [16.812329839096286, 3.3021884494686073],
            [16.807337273765, 3.3069819968678384],
            [16.806430797208435, 3.3200306335821037],
            [16.801963462606864, 3.323855037595898],
            [16.798203181887484, 3.3313989366382684],
            [16.79395637981276, 3.334425635462485],
            [16.789024111360785, 3.3346971183318055],
            [16.787238258050664, 3.34154782780109],
            [16.787397708206385, 3.3460260227951313],
            [16.78369744267032, 3.352056227550515],
            [16.675317920552764, 3.3325079261541637],
            [16.638882169127704, 3.2788116119120985],
            [16.604879307070064, 3.231393332200516],
            [16.588345617448553, 3.216079438635202],
            [16.54935046452786, 3.268261413824241],
            [16.531221049101188, 3.2922465887517514],
            [16.525901340366527, 3.2977861220862628],
            [16.519667266755956, 3.3070799588266673],
            [16.529838087373903, 3.313896032098179],
            [16.531724571053473, 3.3137208125343194],
            [16.535760851349046, 3.307698226963687],
            [16.541953967297722, 3.314666845187917],
            [16.5483476365889, 3.318454582324122],
            [16.551496113196087, 3.317811274638396],
            [16.556575318615057, 3.3239229520549576],
            [16.558012531480003, 3.3334565575496176],
            [16.562645268414347, 3.3430642641603323],
            [16.56287069343741, 3.348252430028465],
            [16.564544322274966, 3.3528083550980314],
            [16.604184536944093, 3.3889872270072128],
            [16.603251031251034, 3.3919291526319943],
            [16.59975791711874, 3.394098566785112],
            [16.599251531041194, 3.3986383780351326]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -74.22159351077016,
          "lat": 40.260021970974435
        },
        "year": "2023",
        "ste_code": ["34"],
        "ste_name": ["New Jersey"],
        "coty_code": ["34025"],
        "coty_name": ["Monmouth"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Monmouth County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "00882910"
      },
      "bbox": [
        16.519667266755956, 3.216079438635202, 16.96665382613032,
        3.700137786620324
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.0661270473866535, -3.323962710981844],
            [-7.049257504435014, -3.1490821828676108],
            [-6.948890983516152, -3.1588762844250997],
            [-6.833369775022739, -3.1699923386329574],
            [-6.726764633430614, -3.1800960665794324],
            [-6.516794844821753, -3.199556582112158],
            [-6.294518571738948, -3.21967432749599],
            [-6.209138016018343, -3.2272034188651832],
            [-6.108915248920274, -3.2361487496775263],
            [-6.115245390732076, -3.310036633831942],
            [-6.120307013789654, -3.368848571152375],
            [-6.1323294110685165, -3.4980166353522755],
            [-6.134545087037829, -3.4978209905087243],
            [-6.141913662961403, -3.581707782263251],
            [-6.1497440541277415, -3.673555415147751],
            [-6.320728165450482, -3.6590125116815564],
            [-6.328325889081418, -3.746050606320182],
            [-6.364044779398681, -3.743014810871697],
            [-6.4138389618589775, -3.7390811037202556],
            [-6.4214553813353445, -3.825976365832395],
            [-6.511244166407525, -3.8182084121017144],
            [-6.756769840145144, -3.795896441832872],
            [-6.78512870103774, -3.7933203239013826],
            [-6.787092823469438, -3.8148172481317046],
            [-6.809140981993235, -4.051061744094826],
            [-6.980903937463695, -4.034530036027303],
            [-7.152665066696915, -4.017979325165258],
            [-7.146807110179924, -3.959525591756384],
            [-7.126799409130062, -3.7580172310757365],
            [-7.1086435252775795, -3.759982953857153],
            [-7.089952612445517, -3.5699184269229423],
            [-7.074734328092802, -3.4110914160206667],
            [-7.0661270473866535, -3.323962710981844]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -104.79065634721641,
          "lat": 34.863294932446266
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35019"],
        "coty_name": ["Guadalupe"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Guadalupe County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "00929111"
      },
      "bbox": [
        -7.152665066696915, -4.051061744094826, -6.108915248920274,
        -3.1490821828676108
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.661299478398621, -4.0545873922220315],
            [-7.59106692665958, -4.061827689019666],
            [-7.398147164390458, -4.081580810966613],
            [-7.3071529095913474, -4.091019172505891],
            [-7.2795943654267, -4.093543312805329],
            [-7.190692801876016, -4.102168702238851],
            [-7.1613798498828825, -4.105188877074318],
            [-7.156953920353157, -4.062294075173696],
            [-7.152665066696915, -4.017979325165258],
            [-6.980903937463695, -4.034530036027303],
            [-6.809140981993235, -4.051061744094826],
            [-6.817772024704348, -4.1382264417140275],
            [-6.834826249133632, -4.3097609018990815],
            [-6.838955246346983, -4.350570344263377],
            [-6.852644584839049, -4.486306826903684],
            [-6.8606583946207635, -4.573671676926582],
            [-6.858003011247475, -4.576110673952675],
            [-6.8802104235652495, -4.803492156228119],
            [-6.885969921066611, -4.864284223117536],
            [-6.8911218237447285, -4.9173732334655185],
            [-6.8990052036702965, -4.9997288718774655],
            [-6.893404602196546, -5.005216709511722],
            [-6.89798607833458, -5.0510869373135465],
            [-6.901657440391426, -5.092526191434039],
            [-6.91711298438633, -5.091003747388645],
            [-6.925121391546254, -5.175817339516651],
            [-6.92643202596444, -5.1756946876673],
            [-6.93415199269014, -5.257566798188705],
            [-7.017879026383765, -5.24971216485573],
            [-7.018280643762646, -5.254182582982443],
            [-7.096495981035088, -5.24775459452749],
            [-7.103129784152822, -5.248783220865428],
            [-7.275607576043281, -5.231517142815771],
            [-7.258834511542548, -5.058201839366575],
            [-7.343311471281884, -5.050763100264893],
            [-7.438120301054635, -5.040923833645484],
            [-7.519272509987304, -5.033102766517959],
            [-7.533122852659595, -5.031615764960363],
            [-7.596440671343201, -5.025549446716272],
            [-7.590544713899401, -4.965998481757332],
            [-7.588621041581814, -4.939895869878477],
            [-7.730133191924191, -4.925975205593573],
            [-7.757347832552904, -4.923134275100118],
            [-7.874438316104517, -4.9112691849653665],
            [-8.098698766133793, -4.8860149288449435],
            [-8.120273881963536, -4.883642493273142],
            [-8.111236385293973, -4.794538256144966],
            [-8.092132141560546, -4.614247700930531],
            [-8.00553918461906, -4.623626165805233],
            [-7.9160627277093845, -4.641434530798993],
            [-7.916291760114455, -4.643577689563632],
            [-7.829518146494135, -4.6527901895058115],
            [-7.819069986704844, -4.554990269241417],
            [-7.81082995363792, -4.477756372035113],
            [-7.705872986284595, -4.488775639530635],
            [-7.696931980915372, -4.403460427266923],
            [-7.6975898516083205, -4.403391680483382],
            [-7.692823687029191, -4.357964695360292],
            [-7.679328443940013, -4.229326538989414],
            [-7.678616513364334, -4.228984657845404],
            [-7.669821010711252, -4.142056850182084],
            [-7.661299478398621, -4.0545873922220315]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -105.45928628391641,
          "lat": 33.74529671045551
        },
        "year": "2023",
        "ste_code": ["35"],
        "ste_name": ["New Mexico"],
        "coty_code": ["35027"],
        "coty_name": ["Lincoln"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lincoln County"],
        "coty_fp_code": "027",
        "coty_gnis_code": "00929116"
      },
      "bbox": [
        -8.120273881963536, -5.257566798188705, -6.809140981993235,
        -4.017979325165258
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.867077901946702, 7.207907183312214],
            [15.90380526928671, 7.220998671775945],
            [15.90891577752324, 7.223158210481694],
            [15.994409103607483, 7.2548586415158995],
            [15.950576284097659, 7.371054046171508],
            [15.93557814089829, 7.414327935336561],
            [15.928082143523055, 7.432298947858333],
            [15.920425655670927, 7.451917475338851],
            [15.899369386730445, 7.508272088298778],
            [15.977125830855837, 7.537882223367695],
            [16.054890328431007, 7.567474771619244],
            [16.10214752256318, 7.5845099534988485],
            [16.16285552385686, 7.605942129673855],
            [16.1957141595137, 7.616865043659123],
            [16.197321087132657, 7.612417632129543],
            [16.20070466548643, 7.614862487015285],
            [16.207594253163087, 7.614879984145106],
            [16.210279483754043, 7.616931959287186],
            [16.215294687458055, 7.616504783446929],
            [16.224943369398808, 7.621679100517723],
            [16.22713726398334, 7.627194987481501],
            [16.23711222346334, 7.633848907688636],
            [16.242605307933704, 7.641120201657392],
            [16.253646333001242, 7.6396526042637944],
            [16.261149447194875, 7.645261924850338],
            [16.2637992653168, 7.6509830141697925],
            [16.268020489624636, 7.649944030480899],
            [16.274466338731276, 7.654933461486191],
            [16.280947488839292, 7.6573392456015865],
            [16.284933715303826, 7.66218117377592],
            [16.286482756497076, 7.665975194664062],
            [16.286302874384802, 7.673229228113924],
            [16.288215137213225, 7.67666732595867],
            [16.293306960418967, 7.678028015477833],
            [16.297091960714432, 7.68265213952196],
            [16.306343818469088, 7.686592974921371],
            [16.30827385067123, 7.6918122725207585],
            [16.313016497477765, 7.688418711379612],
            [16.320499140432194, 7.689141783659888],
            [16.324461673146743, 7.691380882724268],
            [16.328294605885812, 7.691244652969391],
            [16.329622479450634, 7.69800424280586],
            [16.329293125599513, 7.70218735979502],
            [16.333492064979644, 7.706603382750858],
            [16.334855591610626, 7.71265193735682],
            [16.340753149318317, 7.7159072520897105],
            [16.338576707866803, 7.720878494420522],
            [16.341259726871534, 7.726581731625724],
            [16.345362113949648, 7.729424179109097],
            [16.34178981189544, 7.732583979826038],
            [16.341908069614934, 7.738257554194319],
            [16.33844779823436, 7.741058815808777],
            [16.338277012530593, 7.744971677236413],
            [16.42263157291528, 7.7745931293722865],
            [16.423217984125756, 7.771113932781639],
            [16.430077725660873, 7.765224588763172],
            [16.43397156586432, 7.758551258232361],
            [16.439208985654588, 7.756553389435814],
            [16.442793670225026, 7.745499427134616],
            [16.449812072113502, 7.740663703636761],
            [16.455711438788548, 7.735019577816192],
            [16.460754674476743, 7.721313287013017],
            [16.466044092718995, 7.713297736575931],
            [16.469857516821932, 7.701236246619402],
            [16.47108996804971, 7.692078393166891],
            [16.476572169327895, 7.684374203124228],
            [16.47894458170484, 7.679500844438936],
            [16.480170894760555, 7.667298737295178],
            [16.47626753915969, 7.640031414551223],
            [16.4764749617763, 7.625670847406849],
            [16.473748504858573, 7.619035381195456],
            [16.468811800260017, 7.611010046642283],
            [16.467467686335652, 7.606902219675848],
            [16.46838181178454, 7.599095193660827],
            [16.47038288047774, 7.59183932303149],
            [16.47840558081169, 7.5809763776744985],
            [16.483213510401157, 7.571364955605299],
            [16.488698371397472, 7.548315449812622],
            [16.492073438389376, 7.540431287935133],
            [16.499119104044734, 7.527967323731439],
            [16.50408288964863, 7.521327459206827],
            [16.50633853579713, 7.515951026913406],
            [16.50705729403936, 7.505847772069287],
            [16.506105590315435, 7.4906213676155],
            [16.504812541913502, 7.484526396854399],
            [16.499937091047094, 7.483716278099042],
            [16.496693482815477, 7.478126785070662],
            [16.492573060474115, 7.475590349643743],
            [16.494043513995397, 7.472343752912808],
            [16.48977334536018, 7.467041611778762],
            [16.490181848871817, 7.462622935317909],
            [16.488001161255553, 7.459698436023662],
            [16.488591621938387, 7.455700158753661],
            [16.486520345820136, 7.443932311098917],
            [16.481449950858476, 7.438618303177776],
            [16.4793546729921, 7.433325480935707],
            [16.47515527053232, 7.429561604221375],
            [16.474900945472964, 7.4253853244761725],
            [16.47196366306136, 7.423819057995311],
            [16.471131467633015, 7.420296137965728],
            [16.47377771017703, 7.4129241186139465],
            [16.470759392361657, 7.406604869475464],
            [16.47069136634418, 7.402300131319017],
            [16.47327270507033, 7.3973166701532485],
            [16.471967566881677, 7.393036859404506],
            [16.47297390662998, 7.386192100241025],
            [16.473302707204272, 7.376575560956839],
            [16.470846754796234, 7.369347784022415],
            [16.468708524086033, 7.367249128386499],
            [16.467080034544182, 7.361739661778362],
            [16.473498990983952, 7.347630257432169],
            [16.474928006240287, 7.343003312728261],
            [16.474581638499814, 7.329337911960827],
            [16.470318032960364, 7.307824978254805],
            [16.472171468527346, 7.2919211164433175],
            [16.472523095133, 7.273115699142031],
            [16.473694826738896, 7.270910138958387],
            [16.481035738690093, 7.267684388843632],
            [16.485592945724928, 7.26370962741786],
            [16.492453115414147, 7.26204598197542],
            [16.495561438250604, 7.260148042028212],
            [16.50142000422044, 7.250579910172317],
            [16.502556538043265, 7.245993280730847],
            [16.50537901496644, 7.214395239417815],
            [16.512406315877406, 7.203109975793897],
            [16.517684793195905, 7.185418660462113],
            [16.519302188210133, 7.169534784001336],
            [16.528401066040466, 7.155443416844371],
            [16.53523348420735, 7.142734210788473],
            [16.54673539733991, 7.133106847312393],
            [16.55426684852433, 7.123994049028384],
            [16.557226326749436, 7.118423940142755],
            [16.555629724711906, 7.102736665270816],
            [16.5575510281508, 7.0964311110517135],
            [16.565379252939778, 7.090836148926981],
            [16.56375747988856, 7.0843147785199685],
            [16.5605635336882, 7.0814523105426375],
            [16.557170494803877, 7.075600728285725],
            [16.556539613612305, 7.064983138445782],
            [16.55939150346686, 7.060722388084385],
            [16.56527150864994, 7.057973794964955],
            [16.569160004100308, 7.053953741718329],
            [16.529223792644302, 7.039440823923486],
            [16.49015974739907, 7.025594873823281],
            [16.48746726648534, 7.024317588763652],
            [16.407343144946225, 6.992960230671545],
            [16.29419687532075, 6.949581269334622],
            [16.23772061517139, 6.928229386463916],
            [16.228651703737754, 6.924645407295341],
            [16.17162345905921, 6.903147233273309],
            [16.110106530904886, 6.879582551350165],
            [16.10817789997375, 6.881950860024218],
            [16.108385372143957, 6.890983677683214],
            [16.106409040001086, 6.900159894078598],
            [16.106203355432903, 6.905112250721574],
            [16.109280721018788, 6.916966734292169],
            [16.104088825430885, 6.9229543035192425],
            [16.105547436970664, 6.9261004222353515],
            [16.105155420511366, 6.931502355113318],
            [16.093376282344174, 6.931982878787553],
            [16.081921563147908, 6.934617267272557],
            [16.076986424754512, 6.937077960472829],
            [16.074006704876254, 6.935679227791875],
            [16.07209883885876, 6.931969830964032],
            [16.068108198865904, 6.932804263511991],
            [16.063950166229354, 6.9308797609646575],
            [16.058833896910013, 6.932855163743841],
            [16.053603432847748, 6.932477347171487],
            [16.04872256924638, 6.93501896080259],
            [16.042876689542975, 6.936093639739527],
            [16.0400944274435, 6.938043738897365],
            [16.036144375249528, 6.937310734600833],
            [16.035610512621687, 6.941942444961847],
            [16.032088379911478, 6.946405627445944],
            [16.02614653557508, 6.947162179427468],
            [16.01967105916656, 6.944495342223398],
            [16.017302669154212, 6.941308730757673],
            [16.01286703004567, 6.941026227903408],
            [16.009107864146223, 6.937210126478738],
            [15.99896396130763, 6.935326932131094],
            [15.990659857232147, 6.929411319773235],
            [15.986749927441252, 6.919835313165351],
            [15.98518203329791, 6.918480345128881],
            [15.931716166930642, 6.9617782334966885],
            [15.928545808864618, 6.964631165975252],
            [15.873493840501398, 7.009113165372941],
            [15.873074863680792, 7.009585360790517],
            [15.91941739240763, 7.065862719627167],
            [15.908773991707877, 7.094355742807845],
            [15.867077901946702, 7.207907183312214]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.77261791743624,
          "lat": 44.117190448305465
        },
        "year": "2023",
        "ste_code": ["36"],
        "ste_name": ["New York"],
        "coty_code": ["36031"],
        "coty_name": ["Essex"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Essex County"],
        "coty_fp_code": "031",
        "coty_gnis_code": "00974114"
      },
      "bbox": [
        15.867077901946702, 6.879582551350165, 16.569160004100308,
        7.7745931293722865
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.923117922349025, -2.9434238755383277],
            [9.922448870585814, -2.924338422515646],
            [9.924400443861243, -2.925217742020559],
            [9.928367253148332, -2.921266380459989],
            [9.93321661396611, -2.9136615620006356],
            [9.944468630518408, -2.9050595843977014],
            [9.946023107528601, -2.900501476877236],
            [9.949549457260646, -2.896713861041344],
            [9.956961885611916, -2.8920364491344808],
            [9.958962216418328, -2.889757547090688],
            [9.964514744047861, -2.879321174859834],
            [9.970484521104115, -2.874213182018785],
            [9.976564978856231, -2.8745734441012982],
            [9.980416244950767, -2.876023074220672],
            [9.988882792595156, -2.8854321472708793],
            [9.990814520788632, -2.893306641285881],
            [9.993415419971049, -2.897145144051768],
            [9.999033752698637, -2.897053809036052],
            [10.002474231091503, -2.8997720443398323],
            [10.010341167974154, -2.898079446562966],
            [10.016209957136953, -2.892168277337469],
            [10.023808366271561, -2.8935527136819146],
            [10.025435552565964, -2.8909124032349376],
            [10.0379960487215, -2.8883259992275017],
            [10.043648923166273, -2.8897490684655853],
            [10.047130101079068, -2.892056287592966],
            [10.052495526335363, -2.890669688790715],
            [10.05174622121167, -2.884062103411491],
            [10.056764014094826, -2.880487867792288],
            [10.060781073750771, -2.8832329306016162],
            [10.066671408032057, -2.880026699063986],
            [10.070657190778192, -2.882973228952813],
            [10.07414652776925, -2.8834545872808905],
            [10.07850006176489, -2.8800923077837717],
            [10.085074014468539, -2.8720542944010004],
            [10.086003653012746, -2.867810368116665],
            [10.094107025531683, -2.8641128044720845],
            [10.099281523110688, -2.8605155532014974],
            [10.105515821727595, -2.8582058942706965],
            [10.114663983843398, -2.8466913623577916],
            [10.118738586458765, -2.835716075239757],
            [10.123854140439285, -2.8315093044857607],
            [10.129785298076518, -2.8361156439896367],
            [10.132851175751117, -2.842909991317525],
            [10.135955395232891, -2.846133593927395],
            [10.141773291514934, -2.8484842603256895],
            [10.142803628011084, -2.864681351825756],
            [10.147439207625615, -2.8682213880405087],
            [10.150779160935755, -2.8681830087581948],
            [10.151867488585616, -2.871186232621031],
            [10.148461614740832, -2.8796814543985803],
            [10.151157181850309, -2.884806590483495],
            [10.156944450220415, -2.8883606164119695],
            [10.166056629565693, -2.888465973666052],
            [10.172560859516823, -2.892538285553363],
            [10.175181746847061, -2.8967663099625938],
            [10.183048705876557, -2.899490719449793],
            [10.189673902715215, -2.8996109934693917],
            [10.196040067941516, -2.894655233633975],
            [10.199657986383, -2.8953808123696683],
            [10.201485994309024, -2.8923824938007217],
            [10.208653472468132, -2.891023331907087],
            [10.214788843900273, -2.8851373920307486],
            [10.219991492365581, -2.8833695299061977],
            [10.231885179047053, -2.875608146457494],
            [10.23332828164214, -2.8721927644500735],
            [10.240392867882637, -2.8765629409874123],
            [10.25064605530054, -2.86992222229549],
            [10.255123314122773, -2.8635274953379093],
            [10.264725672301573, -2.8577814307358334],
            [10.272247432511522, -2.855988407318029],
            [10.276233618219978, -2.8496215052187615],
            [10.279460424755309, -2.850132425950609],
            [10.287136420114185, -2.8473255195294436],
            [10.295360795105815, -2.8521513643675576],
            [10.30171614549134, -2.8468401997839337],
            [10.305589466254789, -2.848657503171456],
            [10.312145731394953, -2.8456590136405073],
            [10.316081566464492, -2.8422308822198428],
            [10.320149858460145, -2.8434138236309043],
            [10.322495796342015, -2.8461090271023304],
            [10.326355955308983, -2.845592519940096],
            [10.335147557007424, -2.8516334415721643],
            [10.33972493517483, -2.848623030875172],
            [10.345655204483297, -2.849004227718409],
            [10.349798217859904, -2.852491326732432],
            [10.35756655377228, -2.8493238801080496],
            [10.366545721435797, -2.848379016676453],
            [10.374953075056343, -2.839051263098144],
            [10.377936659374164, -2.838498502992424],
            [10.381890684083523, -2.833485351833802],
            [10.390529446967442, -2.8385294044436327],
            [10.391513654986758, -2.8416100730721308],
            [10.395331242518155, -2.8423564551724545],
            [10.400923251635732, -2.8460347413572267],
            [10.40306991381028, -2.8539750426116273],
            [10.399230271371772, -2.864053158231408],
            [10.391374180365787, -2.8713456635890076],
            [10.389463484012564, -2.871869156265217],
            [10.387853926728022, -2.877818242310708],
            [10.380487560312575, -2.8823635681063813],
            [10.376674971875257, -2.8922602459769653],
            [10.384453829866196, -2.894976490359224],
            [10.386915837637932, -2.8917230364819337],
            [10.391396641586121, -2.8954070994999808],
            [10.391283820156831, -2.90177011910578],
            [10.388700683582302, -2.904955037711453],
            [10.38180127233616, -2.9088409946304803],
            [10.377400101122227, -2.9144381611086194],
            [10.378969274204108, -2.921493951648394],
            [10.375038010450435, -2.9377313885311964],
            [10.368113256679864, -2.933699637665214],
            [10.362657654738307, -2.9343712943814184],
            [10.360401962567547, -2.938334191561282],
            [10.353667303557126, -2.940987820477671],
            [10.350963197594865, -2.939760898655421],
            [10.347066923890889, -2.941443656790319],
            [10.343740500481292, -2.947717878180409],
            [10.338399336097531, -2.95075779999535],
            [10.33063662675557, -2.951445408000062],
            [10.32904334556908, -2.954876712599727],
            [10.321014204215079, -2.9572308554456845],
            [10.314146892387402, -2.9625851218087553],
            [10.310002628149075, -2.963181437632507],
            [10.302638800274886, -2.9624608856418257],
            [10.294116187243917, -2.9604707050273427],
            [10.29082575703212, -2.9636273844013146],
            [10.287093454999546, -2.964356418438015],
            [10.281807534884813, -2.9689316062951856],
            [10.277875965743315, -2.974126845580904],
            [10.27704736036845, -2.97844669326196],
            [10.278781345796386, -2.9850855033464905],
            [10.276361766644307, -2.9888607537560166],
            [10.270325738040722, -2.9948591150498296],
            [10.270201876412342, -2.9971924002580694],
            [10.264888878909552, -3.002551164238159],
            [10.262164139891437, -3.0098661512720106],
            [10.256367655778723, -3.0180926194005084],
            [10.249551648404355, -3.0242898353443066],
            [10.248690642893392, -3.0329304115760247],
            [10.241896933756456, -3.037515316796615],
            [10.237141541219456, -3.038612596554311],
            [10.23426967898493, -3.046423650346684],
            [10.23095718180912, -3.0441258600628136],
            [10.222677622461152, -3.0587407839444083],
            [10.216192326727624, -3.0621412657703355],
            [10.210957758464685, -3.0635799001479196],
            [10.207178822412791, -3.0688251893959984],
            [10.206040323998756, -3.0729883742470867],
            [10.211893443808291, -3.0761052330276693],
            [10.21309636609696, -3.08104482004364],
            [10.212031949276605, -3.0856737255116857],
            [10.216040796490502, -3.089696936123454],
            [10.210579956068802, -3.09825441309304],
            [10.207560900511817, -3.099370129427432],
            [10.204578728853754, -3.1033327512381153],
            [10.205850155138405, -3.105151885992484],
            [10.199803822190338, -3.112615003705391],
            [10.196429515630513, -3.1140706880793516],
            [10.185858601177548, -3.124043315156231],
            [10.182632520343546, -3.1247892030438646],
            [10.181669024788935, -3.1336205402144235],
            [10.161782986596053, -3.136258475787936],
            [10.081568778468622, -3.1461712204341126],
            [9.975126806557348, -3.158810614467525],
            [9.926347655403003, -3.164552685089192],
            [9.924703364991016, -3.0729462816601214],
            [9.923600023596203, -3.0296264094813514],
            [9.923405570556843, -2.983199523891536],
            [9.923776430695854, -2.967954702063638],
            [9.923117922349025, -2.9434238755383277]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -84.06340268841902, "lat": 35.13387109431473 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37039"],
        "coty_name": ["Cherokee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Cherokee County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01008545"
      },
      "bbox": [
        9.922448870585814, -3.164552685089192, 10.40306991381028,
        -2.8315093044857607
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.01406571931118, -1.2673215345704325],
            [14.049171697839947, -1.261833822752838],
            [14.131256979525599, -1.249598264276079],
            [14.140985782434763, -1.3060999676849345],
            [14.155058225559994, -1.3901374121830397],
            [14.157252324054461, -1.3948557555661214],
            [14.15417545744497, -1.3977417325816517],
            [14.162281273709024, -1.399011390847141],
            [14.166661829670284, -1.3974846489845647],
            [14.169700581060974, -1.4035612092035272],
            [14.174095826472806, -1.4053036572021778],
            [14.171920042365649, -1.4084387544625903],
            [14.17736026728554, -1.4095774114201756],
            [14.201443384391512, -1.4059707600753655],
            [14.201711895120539, -1.4207920883906324],
            [14.206787244077661, -1.4454594570624577],
            [14.218792527799035, -1.4512815610817027],
            [14.233641210432635, -1.4423694076868734],
            [14.246878519401516, -1.4588980146378079],
            [14.252802580465326, -1.4574789154178727],
            [14.249865501250996, -1.5015955902106772],
            [14.248426280758311, -1.5097425310137615],
            [14.233934869267665, -1.5404682247621013],
            [14.22834366468745, -1.5419096272877186],
            [14.223160475670484, -1.5551101725048586],
            [14.223001263227106, -1.558377430833204],
            [14.185270599588534, -1.5559003289576094],
            [14.176420486619495, -1.6196379909117886],
            [14.116095615569602, -1.6294802970139923],
            [14.029873984023594, -1.650108071519549],
            [14.026794969020486, -1.5755426255218996],
            [14.022450413286574, -1.4709528035514372],
            [14.020761067380363, -1.4287219682667003],
            [14.015816130912167, -1.3104221908951332],
            [14.01406571931118, -1.2673215345704325]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.87660506714981, "lat": 36.03599966555343 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37063"],
        "coty_name": ["Durham"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Durham County"],
        "coty_fp_code": "063",
        "coty_gnis_code": "01008550"
      },
      "bbox": [
        14.01406571931118, -1.650108071519549, 14.252802580465326,
        -1.249598264276079
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.46994848908791, -2.2292738311646754],
            [11.473464720508987, -2.229061368179563],
            [11.477687947676298, -2.232302040710547],
            [11.485181319711286, -2.2322575586258506],
            [11.48818657700177, -2.2246548894732174],
            [11.493564761660608, -2.221390651035971],
            [11.494770082933767, -2.217500893179016],
            [11.498541001354257, -2.216071120864946],
            [11.502743978282732, -2.2117086216399855],
            [11.508143198657445, -2.209287857466138],
            [11.509078634184917, -2.2071418853710147],
            [11.518932210197281, -2.199482559565573],
            [11.52004603848686, -2.196424741900483],
            [11.527444227870387, -2.1883071538226306],
            [11.530414630494286, -2.1892059643457724],
            [11.532096106305572, -2.184310960481445],
            [11.535329127359553, -2.1702276729756],
            [11.541175157122245, -2.1658113013981204],
            [11.54591108037292, -2.160429733939948],
            [11.544921274952694, -2.1589450200392064],
            [11.548613894178793, -2.148506805166236],
            [11.551238015626833, -2.1462602108138578],
            [11.552201496944878, -2.140644802604281],
            [11.54466164385783, -2.136376280798428],
            [11.543157118202812, -2.1322782445056827],
            [11.547323465137191, -2.1251101596962716],
            [11.549313766269682, -2.1186846652943783],
            [11.553067034003762, -2.1157666851305192],
            [11.556907613234312, -2.1150872301958343],
            [11.555515276814788, -2.1083950650493257],
            [11.560932994702583, -2.105577919500534],
            [11.565564806358056, -2.096462231228172],
            [11.565511264243387, -2.09417051792357],
            [11.567807520885113, -2.0918710970497063],
            [11.572688345651494, -2.09247409063139],
            [11.575699059373354, -2.0905556279307693],
            [11.57705549626163, -2.0830108037286656],
            [11.582594256037936, -2.0797192327229737],
            [11.588617248243416, -2.0709837175976045],
            [11.58842970333073, -2.0618897104244187],
            [11.591011539198051, -2.0610376003541],
            [11.609339820659423, -2.0622400133158645],
            [11.610736733341346, -2.0599288041484254],
            [11.617033013124288, -2.057402260911746],
            [11.620409321601613, -2.0577133074585996],
            [11.629012939724193, -2.054315874663085],
            [11.637231250963751, -2.046850378995646],
            [11.638978345129429, -2.041100789068835],
            [11.641365306215508, -2.0379632935064578],
            [11.641103946630793, -2.0310873804048217],
            [11.644545911268057, -2.0197165067317204],
            [11.651945617720383, -2.0184340931437195],
            [11.659687058738012, -2.0223634814389024],
            [11.661368704476773, -2.0267482764366807],
            [11.666266242427744, -2.0275881776089855],
            [11.670855721870263, -2.0240911730154902],
            [11.671386103840788, -2.0205151603585185],
            [11.678214919690479, -2.0145878155539996],
            [11.676885728778684, -2.0101620919218535],
            [11.676680906590127, -1.9980921753689944],
            [11.672893901891415, -1.9885454715535034],
            [11.676998520075891, -1.9839030286528074],
            [11.679836661308618, -1.9840024510614829],
            [11.685076193233572, -1.9771289376257353],
            [11.688612235766795, -1.9760973827275858],
            [11.692334127694723, -1.9700667753598298],
            [11.691414345047015, -1.9644145182443795],
            [11.684280339951037, -1.959586545199014],
            [11.683431982158895, -1.955957985241758],
            [11.69642502397324, -1.9353964771883592],
            [11.702034484201066, -1.939919086652728],
            [11.702618065600381, -1.9422878410075906],
            [11.708270512872934, -1.9484679946321184],
            [11.708011449807673, -1.9529396776991046],
            [11.713780350673037, -1.9563007570357713],
            [11.71234503495386, -1.9621083152683045],
            [11.718716190163235, -1.9698236064401315],
            [11.720432000084534, -1.9735938590443858],
            [11.725370271711087, -1.9755576231677385],
            [11.73062583815105, -1.9859033853148862],
            [11.728075505167572, -1.990494661312835],
            [11.732495171915293, -1.9933676221817571],
            [11.732700374072598, -1.9967665176112435],
            [11.735255279379837, -2.001251531733758],
            [11.736838924722607, -2.0075620638382166],
            [11.733737696645667, -2.016876462804855],
            [11.733358543561888, -2.0250981240053303],
            [11.731242418804955, -2.0322174500425856],
            [11.732884896450908, -2.040479949557194],
            [11.728283767701972, -2.0499396070053755],
            [11.720987161658506, -2.056774949813196],
            [11.717090388406637, -2.057407375631854],
            [11.711120535586224, -2.071903191948375],
            [11.705680582392228, -2.0775271218022326],
            [11.697023995873217, -2.0784807102454477],
            [11.69294989610668, -2.0775179547406615],
            [11.689372333073454, -2.0822367302884808],
            [11.688781547443382, -2.0856992135251526],
            [11.684420046611098, -2.093320412782903],
            [11.740843713804407, -2.130933054428229],
            [11.770910481437271, -2.1527895821984644],
            [11.790904442593243, -2.1664578486339368],
            [11.82108343479626, -2.2395351965015196],
            [11.84860881493879, -2.3052780006613407],
            [11.845377356113644, -2.306848880080829],
            [11.845518994038525, -2.3125897645270572],
            [11.842694865706475, -2.3185279076427756],
            [11.843704238369341, -2.3220434750384316],
            [11.839220888685489, -2.3260486330001675],
            [11.837118830641334, -2.3362054934002887],
            [11.838719479383261, -2.3401196545009992],
            [11.789099039391042, -2.347894923561898],
            [11.777610599032792, -2.35802416040787],
            [11.767501908798893, -2.357071203894854],
            [11.749426118276315, -2.3682212162374463],
            [11.741476417275196, -2.371203877817244],
            [11.73250561787738, -2.36781759007831],
            [11.72485526599645, -2.3613715680553047],
            [11.725131820648478, -2.3594419927513255],
            [11.717391767122763, -2.356399444558612],
            [11.70963963398107, -2.3496298832683955],
            [11.702154784055148, -2.354821625363942],
            [11.697152740308784, -2.364964770338146],
            [11.682860646976524, -2.3730660918563187],
            [11.648625824882448, -2.377408546298672],
            [11.638207727071837, -2.380775160531058],
            [11.596687266215117, -2.4007338557608833],
            [11.580477237096916, -2.3931150752655292],
            [11.547416867921184, -2.37759306104355],
            [11.536135526178974, -2.3737889856289947],
            [11.512943203579042, -2.3712905189676],
            [11.510196103488987, -2.370639040048018],
            [11.497942297855708, -2.3620476529900465],
            [11.473910084321522, -2.3439452674663626],
            [11.472658009929555, -2.340418732599773],
            [11.475302890727622, -2.333842851685621],
            [11.479141903079633, -2.3312652344462523],
            [11.479828432113113, -2.32532180015768],
            [11.491150430243657, -2.3188432561762764],
            [11.491245137318668, -2.3147755933356913],
            [11.486633508260255, -2.311529703018114],
            [11.481973417830817, -2.304799112284054],
            [11.484187356088995, -2.3013648365339288],
            [11.479063793060346, -2.2959586844627404],
            [11.4743193663183, -2.295022827329708],
            [11.472239979221097, -2.2875979853937385],
            [11.470163678921484, -2.2868459993074604],
            [11.468396452094767, -2.2818392686326305],
            [11.468117065667057, -2.27381873165333],
            [11.471248279569119, -2.2669859596281783],
            [11.467137338037649, -2.258209365949206],
            [11.457397502582463, -2.2520671718599288],
            [11.460517287724043, -2.2389446222344542],
            [11.4642093102872, -2.2359571085034333],
            [11.465643697784627, -2.2322101179785405],
            [11.46994848908791, -2.2292738311646754]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.04928737340015, "lat": 35.68168518919984 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37111"],
        "coty_name": ["McDowell"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McDowell County"],
        "coty_fp_code": "111",
        "coty_gnis_code": "01025836"
      },
      "bbox": [
        11.457397502582463, -2.4007338557608833, 11.84860881493879,
        -1.9353964771883592
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.116095615569602, -1.6294802970139923],
            [14.176420486619495, -1.6196379909117886],
            [14.185270599588534, -1.5559003289576094],
            [14.223001263227106, -1.558377430833204],
            [14.223160475670484, -1.5551101725048586],
            [14.22834366468745, -1.5419096272877186],
            [14.233934869267665, -1.5404682247621013],
            [14.248426280758311, -1.5097425310137615],
            [14.249865501250996, -1.5015955902106772],
            [14.252802580465326, -1.4574789154178727],
            [14.246878519401516, -1.4588980146378079],
            [14.233641210432635, -1.4423694076868734],
            [14.218792527799035, -1.4512815610817027],
            [14.206787244077661, -1.4454594570624577],
            [14.201711895120539, -1.4207920883906324],
            [14.201443384391512, -1.4059707600753655],
            [14.226102637398203, -1.3962271457075015],
            [14.236391668268263, -1.3937966660263557],
            [14.254373476281176, -1.3924967160382493],
            [14.302583799176269, -1.4069909393491622],
            [14.32296276375806, -1.4127662126947313],
            [14.365370072287933, -1.4233782622927358],
            [14.371807942226772, -1.4248123556347727],
            [14.417004125054557, -1.4360689092919574],
            [14.474674491121107, -1.4536923062777771],
            [14.507404556629721, -1.486711167769915],
            [14.540860036777538, -1.4864108867806154],
            [14.546576303345958, -1.506824636706801],
            [14.552772674956541, -1.5090749633633196],
            [14.559577702462308, -1.5088011664181977],
            [14.564193307865867, -1.516027787402121],
            [14.575917516594819, -1.5172832009581076],
            [14.578925543852035, -1.513885856046891],
            [14.583637241280025, -1.5155140764666328],
            [14.589907459594029, -1.5216221959849738],
            [14.594809193627004, -1.5236688393833737],
            [14.596102651968083, -1.5272882547128215],
            [14.599149294792177, -1.5271587223525955],
            [14.600981290343967, -1.5310071711240132],
            [14.60579698880765, -1.5321722029035694],
            [14.609461368718993, -1.537674910049472],
            [14.612124385527325, -1.5384149567460321],
            [14.617898037715062, -1.547182557393984],
            [14.62147591454028, -1.5539906039377236],
            [14.62319302985078, -1.5598294046879029],
            [14.626798318594433, -1.5640994367457453],
            [14.634939178599414, -1.5716637583345405],
            [14.637891119817874, -1.5727951689474897],
            [14.63873472371489, -1.5839184244730236],
            [14.63044358401934, -1.5934518344311892],
            [14.592124910067543, -1.632857230485981],
            [14.563786844839013, -1.661549804286802],
            [14.530660784592442, -1.6942682626607295],
            [14.498401803999542, -1.7256488206725955],
            [14.49481757837358, -1.7238098455280126],
            [14.48941224844099, -1.7281371761115432],
            [14.488336817602429, -1.7318056440569483],
            [14.48245439250612, -1.7403744348933572],
            [14.40786967086719, -1.846098166657277],
            [14.345080717622162, -1.9341840587214478],
            [14.335487212842462, -1.9468385737855467],
            [14.248803864110595, -1.9302050099130164],
            [14.159433356687725, -1.9127409999287244],
            [14.130419874124508, -1.9059146965719163],
            [14.09211496922307, -1.8982249713683166],
            [14.095459240172179, -1.8624808009150116],
            [14.099180548378307, -1.829050699907899],
            [14.10406381115708, -1.7875076214302648],
            [14.109571523811562, -1.7292903848062129],
            [14.109775472002587, -1.7062086714865043],
            [14.111872477726147, -1.6984969249153552],
            [14.114928557444017, -1.6792410144905676],
            [14.117982408370757, -1.654867379429125],
            [14.116095615569602, -1.6294802970139923]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.65029703156338, "lat": 35.79031280213838 },
        "year": "2023",
        "ste_code": ["37"],
        "ste_name": ["North Carolina"],
        "coty_code": ["37183"],
        "coty_name": ["Wake"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wake County"],
        "coty_fp_code": "183",
        "coty_gnis_code": "01008592"
      },
      "bbox": [
        14.09211496922307, -1.9468385737855467, 14.63873472371489,
        -1.3924967160382493
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.636000218375561, 9.215318312964238],
            [-2.5487554601083855, 9.211043561989117],
            [-2.493399729756393, 9.208262229590654],
            [-2.4619064649508493, 9.206848947666563],
            [-2.374433934087187, 9.203272773034133],
            [-2.345709139662123, 9.201836657876548],
            [-2.2874961945317276, 9.199321271697954],
            [-2.291259711534287, 9.114108237609752],
            [-2.2950831039275688, 9.02911025027219],
            [-2.270151529380227, 9.028081673035032],
            [-2.2738116632780248, 8.94443313586892],
            [-2.2774661916067354, 8.859126047561672],
            [-2.2813239569587034, 8.773746944564747],
            [-2.285082091714311, 8.688264848053329],
            [-2.3395457433472897, 8.690669037059092],
            [-2.4264375848788897, 8.694570355195248],
            [-2.51328251924517, 8.698434516416787],
            [-2.5994271942586398, 8.702474764903762],
            [-2.72085648435017, 8.708481945971837],
            [-2.7184767173323228, 8.752336462310177],
            [-2.712288177758068, 8.87924406513095],
            [-2.707963713883188, 8.964711259237628],
            [-2.703430941612505, 9.047992928880863],
            [-2.644266476563506, 9.045302198087219],
            [-2.6412902115765613, 9.103291425160855],
            [-2.6389310287704992, 9.158690876810596],
            [-2.6373064543797673, 9.187115451417492],
            [-2.636000218375561, 9.215318312964238]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.34558229031522,
          "lat": 47.575454861711975
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38083"],
        "coty_name": ["Sheridan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Sheridan County"],
        "coty_fp_code": "083",
        "coty_gnis_code": "01034203"
      },
      "bbox": [
        -2.72085648435017, 8.688264848053329, -2.270151529380227,
        9.215318312964238
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.906442846433892, 10.133658451760127],
            [-4.826823867368673, 10.126847632389975],
            [-4.740107060891566, 10.119606990454296],
            [-4.654502884046574, 10.112759161008533],
            [-4.6280626560396, 10.110876600946035],
            [-4.5523616829356515, 10.10487531296916],
            [-4.466671721691142, 10.097778863331646],
            [-4.405205934238718, 10.093154028222587],
            [-4.343741135736575, 10.0885163113951],
            [-4.281455768681091, 10.08392851185419],
            [-4.21917140254863, 10.07932748942123],
            [-4.14726861222064, 10.074058584429302],
            [-4.132679865888291, 10.073091599835482],
            [-4.138895759409813, 9.988644485099405],
            [-4.14511788950942, 9.904108730358892],
            [-4.151407389871608, 9.819722931868498],
            [-4.112806659724847, 9.816914386104731],
            [-4.116084503913682, 9.773109643402798],
            [-4.123093115804195, 9.6750736405097],
            [-4.12695758583491, 9.623428064656585],
            [-4.127009818804898, 9.620549667578475],
            [-4.130415981432041, 9.57571246227887],
            [-4.130724043439139, 9.574405491331797],
            [-4.138066658437681, 9.580959602194534],
            [-4.147723600659109, 9.58644845075858],
            [-4.15421457444643, 9.589067001919645],
            [-4.160792803942525, 9.58865473101684],
            [-4.173536516496206, 9.580006965003662],
            [-4.18352248835485, 9.576337502041012],
            [-4.192258370886188, 9.576942653701817],
            [-4.198018350025806, 9.57918199775599],
            [-4.203955143825466, 9.588309306953088],
            [-4.209728370638728, 9.59211560025151],
            [-4.214036174470252, 9.59370465168651],
            [-4.226672374175309, 9.595346267697538],
            [-4.240879354325815, 9.594286115642554],
            [-4.247836248998187, 9.59128668354308],
            [-4.251306541774395, 9.591206178470172],
            [-4.26350037160698, 9.595554102797465],
            [-4.274733830118564, 9.59602470285133],
            [-4.291673414232729, 9.594608235270073],
            [-4.302914435955716, 9.5881863451961],
            [-4.30549992867569, 9.588010226884506],
            [-4.308166618460174, 9.591243161523012],
            [-4.306163041791803, 9.601131392354606],
            [-4.306308124384531, 9.606190160082251],
            [-4.309295739616143, 9.608988812605952],
            [-4.316147736533341, 9.610206042342584],
            [-4.322562088136121, 9.609454182793785],
            [-4.328753969636572, 9.607602557853474],
            [-4.3330470940298405, 9.607929460294637],
            [-4.342425228439703, 9.604253281515842],
            [-4.350498263931916, 9.602656975099078],
            [-4.369268334532639, 9.602080087854446],
            [-4.380636000875598, 9.603940522311563],
            [-4.384393641312113, 9.602276347144102],
            [-4.389125464021678, 9.598087947963617],
            [-4.399070636304658, 9.587105041534207],
            [-4.40636672442395, 9.580105276617761],
            [-4.4183144315093426, 9.564509163529575],
            [-4.416901763052156, 9.559240529942482],
            [-4.407275130133729, 9.55527125016675],
            [-4.403977232362102, 9.552473971403444],
            [-4.4013231051443364, 9.546588470361021],
            [-4.402992729008925, 9.539849943835002],
            [-4.406916407924326, 9.535437957296848],
            [-4.411250065087368, 9.53272398937906],
            [-4.415760844695776, 9.532965561080555],
            [-4.425250196456053, 9.536132727520856],
            [-4.434542840952327, 9.53487347044074],
            [-4.43709238775646, 9.53251655016406],
            [-4.439658271333466, 9.523001556756684],
            [-4.442525083122993, 9.518314722379023],
            [-4.447915566282342, 9.515094160940325],
            [-4.451530841089839, 9.515564495308249],
            [-4.459744876215128, 9.51864023415457],
            [-4.4690556060787525, 9.517191618948008],
            [-4.492638168577005, 9.508005355466787],
            [-4.503911862345324, 9.505729618495703],
            [-4.508515028432212, 9.505690287033534],
            [-4.519468874412906, 9.509180391769233],
            [-4.531592314239672, 9.516686326674842],
            [-4.540358189340353, 9.518736100146043],
            [-4.544231390749413, 9.517662056261821],
            [-4.551202438259164, 9.512512606534006],
            [-4.562137021256509, 9.509435799675222],
            [-4.5671471301861395, 9.50599851767364],
            [-4.573792531429782, 9.498098964476178],
            [-4.580754598192507, 9.493222624579237],
            [-4.588538804301757, 9.492357220562335],
            [-4.591645079838209, 9.49328627750487],
            [-4.597117275530713, 9.499306035497902],
            [-4.600936716387309, 9.507355348663657],
            [-4.605838623009164, 9.521277343946663],
            [-4.6099454215513775, 9.524051372892995],
            [-4.6203640866355915, 9.523199469924622],
            [-4.627011230477228, 9.523819571791092],
            [-4.63516183835893, 9.525932127006522],
            [-4.643240393272412, 9.532258405594742],
            [-4.644774508549249, 9.535028056028423],
            [-4.644059181218951, 9.544683058839432],
            [-4.64125286366699, 9.549268204094918],
            [-4.635292361996823, 9.55438952295314],
            [-4.624876166077853, 9.561122378438323],
            [-4.619815653042918, 9.566020968912618],
            [-4.616297220457587, 9.573590482172941],
            [-4.617088138623778, 9.575515831317126],
            [-4.623643349899727, 9.57554028399426],
            [-4.630237639526679, 9.576745292580007],
            [-4.640956342716687, 9.582100699150812],
            [-4.643805234906913, 9.584482860030956],
            [-4.655064035270155, 9.599787191830472],
            [-4.65502718110833, 9.604392851597334],
            [-4.65150778121733, 9.606958081409408],
            [-4.643912688052478, 9.609789894205003],
            [-4.639122709729284, 9.613362273752642],
            [-4.639477114147941, 9.619760048819662],
            [-4.641386565783249, 9.622907748983382],
            [-4.6463332840359275, 9.623577668189052],
            [-4.65254055988866, 9.6200603178028],
            [-4.657425406152199, 9.613112986665925],
            [-4.666631105771546, 9.605449981729825],
            [-4.672453101911505, 9.602831857235069],
            [-4.6766236700979436, 9.60306394724539],
            [-4.682705875293454, 9.605609482411564],
            [-4.68980008814743, 9.612152477758775],
            [-4.699344807644012, 9.616051046073855],
            [-4.704636462949254, 9.61578713091884],
            [-4.713292148764779, 9.613243263068753],
            [-4.728540121739495, 9.605308069095448],
            [-4.732438369590804, 9.601287425746365],
            [-4.742827530187129, 9.593332266543353],
            [-4.7466840296243, 9.591386868598809],
            [-4.748273440129266, 9.585785097533861],
            [-4.746218619484294, 9.581542435144197],
            [-4.734205702197553, 9.569422470256912],
            [-4.729031839528156, 9.566492289413567],
            [-4.726928585292767, 9.562394100603123],
            [-4.728588490517117, 9.55523772184654],
            [-4.731326476376282, 9.552193557945216],
            [-4.739476132674832, 9.547231452224924],
            [-4.748773283813622, 9.542823521132151],
            [-4.750441585648785, 9.540485429797133],
            [-4.754487608553631, 9.540382530180986],
            [-4.75920685552502, 9.5431921562324],
            [-4.7686743477251206, 9.556939848373737],
            [-4.777756663256147, 9.560631185011879],
            [-4.782237716082923, 9.557243568544942],
            [-4.786306017614116, 9.549505862330795],
            [-4.788688818564455, 9.538023407032044],
            [-4.786115066477958, 9.529975850875532],
            [-4.785718553354169, 9.521016149483897],
            [-4.786343755751271, 9.516021873837676],
            [-4.7910021482, 9.503352080019326],
            [-4.794092415805253, 9.497956492309424],
            [-4.806169643833959, 9.486608643402159],
            [-4.81096022146592, 9.484332380697408],
            [-4.8140853286306875, 9.485694980704142],
            [-4.811639810192337, 9.49214689353635],
            [-4.811130624756268, 9.502107882861694],
            [-4.812952928620296, 9.505135836307662],
            [-4.829704276025033, 9.521272389984727],
            [-4.832030822546758, 9.52145565878129],
            [-4.835652828132784, 9.515466021309237],
            [-4.831563429731634, 9.508336235086798],
            [-4.831092324505162, 9.501822944652753],
            [-4.83728319699629, 9.495304301235793],
            [-4.841943054142505, 9.480773092745661],
            [-4.846540160832145, 9.475486245245863],
            [-4.855407119740422, 9.471309522309678],
            [-4.860665721850428, 9.471049080009495],
            [-4.877259801983705, 9.467140960815758],
            [-4.883029662202785, 9.474165071876186],
            [-4.886976328486489, 9.481951962589111],
            [-4.891027837240698, 9.48768591508866],
            [-4.898467077892813, 9.494191009465307],
            [-4.906827855219188, 9.498613597547212],
            [-4.916404956374856, 9.498921100009033],
            [-4.920046823486165, 9.496729147594339],
            [-4.920366226596772, 9.490379577513496],
            [-4.923120280960915, 9.486566635012707],
            [-4.92982436351634, 9.483036099721398],
            [-4.934034444796983, 9.482777857966568],
            [-4.937717872695658, 9.487331877942696],
            [-4.938725423173109, 9.495423892979925],
            [-4.942978563238628, 9.505221410742623],
            [-4.946879351227969, 9.508165062208663],
            [-4.957543507839851, 9.513205784949491],
            [-4.957541286682093, 9.513229177883794],
            [-4.948481399494417, 9.625405310270207],
            [-4.943367876358376, 9.688766662048272],
            [-4.938038133148849, 9.752196281475715],
            [-4.936984965080938, 9.767146073595049],
            [-4.927375147087052, 9.881325015571035],
            [-4.926467674971928, 9.896075836445027],
            [-4.92384088857678, 9.926950717391074],
            [-4.918120655516769, 9.997975189517724],
            [-4.917960941379184, 10.003718590343258],
            [-4.915433278593126, 10.02882826948576],
            [-4.914456344202568, 10.042265890828633],
            [-4.9102430821538645, 10.092627414727234],
            [-4.909778323417601, 10.099870093006622],
            [-4.906442846433892, 10.133658451760127]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -103.48020671836704,
          "lat": 48.34367010287069
        },
        "year": "2023",
        "ste_code": ["38"],
        "ste_name": ["North Dakota"],
        "coty_code": ["38105"],
        "coty_name": ["Williams"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Williams County"],
        "coty_fp_code": "105",
        "coty_gnis_code": "01035306"
      },
      "bbox": [
        -4.957543507839851, 9.467140960815758, -4.112806659724847,
        10.133658451760127
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.595875023754958, 3.0940871707040354],
            [11.636379697556448, 3.100355287780114],
            [11.664376580268298, 3.104867694806476],
            [11.737090224952903, 3.1159150991280318],
            [11.732593844206749, 3.1449639820135236],
            [11.787532133111478, 3.1533574570333793],
            [11.791943713350056, 3.1246540212626845],
            [11.820490997445859, 3.1290736795056304],
            [11.897589437653382, 3.140698718005952],
            [11.932601169382027, 3.1462432816471364],
            [12.015572947204685, 3.160360397499572],
            [12.019871887583495, 3.137819625966491],
            [12.02414436814603, 3.1117810272119137],
            [12.043367184572318, 2.9949151444975346],
            [12.058926407137232, 2.9005546949258045],
            [12.054422430192162, 2.8970255704068495],
            [12.049246579853982, 2.8956886573085785],
            [12.040441502188822, 2.8882346099338263],
            [12.03669486438637, 2.886748041298525],
            [12.030414128881745, 2.880444998862051],
            [12.026126220854435, 2.8734876254565833],
            [12.020061964044274, 2.86909844151106],
            [12.014728489250004, 2.869549546342933],
            [12.0073422715234, 2.8754638174597376],
            [12.001905242392713, 2.877400405592308],
            [11.998141414944408, 2.8765828517015484],
            [11.989683900887607, 2.8717650916060755],
            [11.981674920566059, 2.8686629139505566],
            [11.976963005209537, 2.8639745831489263],
            [11.974012969819462, 2.8585793223111824],
            [11.971103466436649, 2.8503154149598955],
            [11.967044246251204, 2.8436284057119456],
            [11.959980321114157, 2.836208119983583],
            [11.95744809286186, 2.826503759972248],
            [11.898332429215538, 2.817769013871071],
            [11.896284582300675, 2.8313832614283765],
            [11.834034296690605, 2.8229152736918723],
            [11.810522859209247, 2.820032988056947],
            [11.804487775214685, 2.86310911912759],
            [11.761781243456772, 2.8571822665665523],
            [11.757591280964832, 2.8863450598325553],
            [11.749184832879417, 2.9403204374354264],
            [11.691943959870946, 2.9312923439209375],
            [11.622811263263145, 2.9211375249500935],
            [11.609633497263676, 3.0068734965277066],
            [11.609398354233017, 3.0078253927090826],
            [11.595875023754958, 3.0940871707040354]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -80.7772125070893, "lat": 40.76841811248814 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39029"],
        "coty_name": ["Columbiana"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Columbiana County"],
        "coty_fp_code": "029",
        "coty_gnis_code": "01074027"
      },
      "bbox": [
        11.595875023754958, 2.817769013871071, 12.058926407137232,
        3.160360397499572
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [9.84405349092339, 1.6920025825454332],
            [9.887842110019541, 1.6934462792436777],
            [9.891086794644004, 1.7175039852210545],
            [9.896861198889653, 1.775675401589774],
            [9.90060297193565, 1.8091748399532002],
            [9.902551422771204, 1.8366546821603948],
            [9.905536115203738, 1.8643805294337608],
            [9.913383742481116, 1.9333515681298628],
            [9.914301766829267, 1.9423449943941367],
            [9.911605249289718, 1.9427976896295804],
            [9.910339534015517, 1.9798456759499172],
            [9.90758608951862, 2.044655061097486],
            [9.991219249924583, 2.05467618168952],
            [10.07725549662567, 2.0649825136040145],
            [10.106623699400929, 2.067977065877813],
            [10.131534249048824, 2.0708077662857174],
            [10.131396582669757, 2.0687813595297104],
            [10.135161702952828, 2.0105809074610965],
            [10.12869036296016, 2.0095164653799538],
            [10.103708169523708, 2.0075021397190165],
            [10.102840695903103, 2.003625009958493],
            [10.105890461684748, 1.9990151640441696],
            [10.104208539250585, 1.9908425580743856],
            [10.107322131055541, 1.9868518276050038],
            [10.10925768303512, 1.978142071145139],
            [10.108838904732645, 1.972684768584239],
            [10.110836117412125, 1.9668998759393337],
            [10.109472776960654, 1.963326095196942],
            [10.104669184543637, 1.960400978812621],
            [10.108820310798048, 1.9568052688087063],
            [10.113574971503946, 1.9499285990610122],
            [10.117866710545936, 1.946422407328682],
            [10.11541149313116, 1.9418482900560385],
            [10.117241115350573, 1.9321691243312753],
            [10.119430144207998, 1.9301622942447787],
            [10.121621324613356, 1.9224675639180235],
            [10.12601287272277, 1.9198349567759734],
            [10.12588327666378, 1.9121159738760982],
            [10.134325102113811, 1.9054310837260109],
            [10.140713442623886, 1.8934677616713638],
            [10.13746970756569, 1.8892533437160128],
            [10.122854565259011, 1.8758922769964799],
            [10.134056566512552, 1.8198076537333607],
            [10.143288728979055, 1.7719147890929348],
            [10.145707924697007, 1.7420689945852268],
            [10.145970499011678, 1.7357502176352633],
            [10.148736382713818, 1.704274394412864],
            [10.1525016545205, 1.6539853490228047],
            [10.126994600316804, 1.652496076837477],
            [10.088280095023652, 1.6496543496876288],
            [10.065392357984315, 1.6476492594765877],
            [9.993937302864559, 1.6425492507873498],
            [9.988811890280306, 1.6429656735838178],
            [9.98061716090548, 1.6419448358618713],
            [9.931601729732598, 1.6397106607211123],
            [9.848244571346918, 1.6354235802248562],
            [9.846743191887985, 1.6352203798954557],
            [9.844318278969144, 1.6799153906180468],
            [9.843537247279883, 1.6873047862399597],
            [9.84405349092339, 1.6920025825454332]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -83.40044470020796, "lat": 39.89415850301473 },
        "year": "2023",
        "ste_code": ["39"],
        "ste_name": ["Ohio"],
        "coty_code": ["39097"],
        "coty_name": ["Madison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Madison County"],
        "coty_fp_code": "097",
        "coty_gnis_code": "01074061"
      },
      "bbox": [
        9.843537247279883, 1.6352203798954557, 10.1525016545205,
        2.0708077662857174
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.0681205646965366, -4.056905027067605],
            [-1.984827406550054, -4.0596524752877405],
            [-1.9862790849197063, -4.103380400058672],
            [-1.843375223375317, -4.10770395564867],
            [-1.8460951606722202, -4.195183669255806],
            [-1.7668455293288559, -4.19734834580165],
            [-1.711957574020818, -4.198956604476109],
            [-1.714343272139456, -4.279159848612747],
            [-1.7148019693230467, -4.300965147370325],
            [-1.7168882244369406, -4.373820646417688],
            [-1.6740125858242503, -4.374715997717956],
            [-1.6749038718725895, -4.412342014389406],
            [-1.679166432214752, -4.552051333131109],
            [-1.6887518037979843, -4.551747133596193],
            [-1.7062408394504336, -4.543891769168692],
            [-1.710223993715362, -4.543871660745412],
            [-1.7166209780854522, -4.549907389083944],
            [-1.7348984684134157, -4.5651947915493505],
            [-1.740539266413161, -4.568801600405215],
            [-1.7460212616771034, -4.574493635519455],
            [-1.7508687701772863, -4.573804961874719],
            [-1.7538063289912413, -4.571235647667692],
            [-1.7587204423115628, -4.5721102532974465],
            [-1.7619621473188203, -4.575472046564953],
            [-1.765360725861676, -4.574777429466168],
            [-1.7668802335088498, -4.570912444310946],
            [-1.772328947793752, -4.5714262768560365],
            [-1.781814527659367, -4.570675407399647],
            [-1.786305443179626, -4.578951608590864],
            [-1.7884165270515335, -4.580764058374209],
            [-1.7944690101810787, -4.581888061779353],
            [-1.8008180825315188, -4.5813077438446665],
            [-1.8028995200907967, -4.578957317810775],
            [-1.8034823770050479, -4.57343748555116],
            [-1.8074806071359377, -4.569313906348879],
            [-1.8187421536222943, -4.565111268025689],
            [-1.8259242245195508, -4.558433550910425],
            [-1.8324410121608141, -4.562154995891289],
            [-1.8388492591826293, -4.55075514233741],
            [-1.8457252988858524, -4.546016938087855],
            [-1.8476356201119069, -4.546305256670983],
            [-1.8605199271194082, -4.541850284265379],
            [-1.8652574505203068, -4.547396845728426],
            [-1.8820607399715108, -4.542272831690533],
            [-1.8832144764013765, -4.55064224933656],
            [-1.8867151659508965, -4.554176332771763],
            [-1.8912681199813197, -4.5535128399296365],
            [-1.8953789455320873, -4.549408164548207],
            [-1.8966564909455412, -4.5459173779691255],
            [-1.8943150861949787, -4.5425557767150515],
            [-1.893612605954502, -4.537972839420344],
            [-1.896249751341338, -4.535385737107027],
            [-1.9054192103762946, -4.534712634472128],
            [-1.910296769206324, -4.530113341743998],
            [-1.9242545987492004, -4.524508341977679],
            [-1.9333880564392674, -4.5182627106962885],
            [-1.9392059538401096, -4.50878277413101],
            [-1.9487692072393377, -4.497434688526267],
            [-1.958446753868543, -4.488196670741622],
            [-1.963424023961537, -4.48675945875753],
            [-1.966646685006082, -4.489215573371837],
            [-1.9669890443402738, -4.495883395574738],
            [-1.9702374024871454, -4.499144672015174],
            [-1.9765894335741196, -4.4966921000492315],
            [-1.980113554673471, -4.4898824519126785],
            [-1.9820784303996142, -4.482430723113869],
            [-1.9868263355467501, -4.478623035419562],
            [-1.989731105603958, -4.4781197864982545],
            [-1.997983947726425, -4.481871222298249],
            [-2.000276399553516, -4.484992597948715],
            [-2.0000333512877386, -4.490713876500079],
            [-2.0085432271335333, -4.496034196028455],
            [-2.0274523810890845, -4.491724877906332],
            [-2.0336370001534356, -4.500276893602916],
            [-2.038001717519769, -4.500136383398174],
            [-2.0455472974271767, -4.497522360674708],
            [-2.0472650746333567, -4.493253380133294],
            [-2.052167167393413, -4.489433787550844],
            [-2.062785148270187, -4.4859611184804935],
            [-2.0705842346457817, -4.488767657632908],
            [-2.0756801593750254, -4.4852176732949856],
            [-2.0798605410895483, -4.4880723907408475],
            [-2.081560482980486, -4.491418795375924],
            [-2.084961433311748, -4.492097125789917],
            [-2.090291047018151, -4.490797364624497],
            [-2.0956420596251655, -4.494714716225993],
            [-2.1042385061211655, -4.491762973751747],
            [-2.1058562692596716, -4.488715201506443],
            [-2.1042244554217446, -4.483933536563639],
            [-2.102068502840736, -4.482417009898577],
            [-2.1027139095255505, -4.4773745044715945],
            [-2.1106601922411588, -4.476718164241657],
            [-2.1155342410180777, -4.480976709413758],
            [-2.11887973256649, -4.486213284525082],
            [-2.1263151076580877, -4.488209067986054],
            [-2.1280579245619244, -4.486476552467244],
            [-2.1528843618603726, -4.480188969490654],
            [-2.1549302082608515, -4.477725864426431],
            [-2.1547211876323673, -4.472205714065485],
            [-2.1528795072368507, -4.467246841834445],
            [-2.153609531922207, -4.462040946094134],
            [-2.1581349880062253, -4.449867298042145],
            [-2.153339913292077, -4.437816714913498],
            [-2.1582185497566413, -4.431340236468933],
            [-2.1549923859352456, -4.422240811431883],
            [-2.156143530108194, -4.412568064051989],
            [-2.1594003945782734, -4.412771449627594],
            [-2.165490833782765, -4.4098810844177025],
            [-2.168204484272586, -4.400813799840499],
            [-2.16694338916621, -4.392619265652414],
            [-2.1692544603446566, -4.382757670813732],
            [-2.1633957929032643, -4.376632224671009],
            [-2.1626672472488324, -4.373517422769146],
            [-2.165695995066877, -4.368535492872917],
            [-2.16635403833948, -4.362431631364241],
            [-2.1655512453326686, -4.355699132295031],
            [-2.162933861006973, -4.3552120689497515],
            [-2.1558272762281345, -4.354098408415719],
            [-2.153410566425283, -4.352315118349486],
            [-2.1507081791881926, -4.347134334455985],
            [-2.150780450042866, -4.3389431675584555],
            [-2.152553887004797, -4.335128688997614],
            [-2.1558259629403724, -4.333476244055031],
            [-2.1585949223647356, -4.328337879690701],
            [-2.158479719288381, -4.323572906668714],
            [-2.1623117590977543, -4.319069318112127],
            [-2.1716003258599454, -4.319311191607259],
            [-2.172779175983239, -4.316004885314799],
            [-2.1630687884876916, -4.304580909544614],
            [-2.163743703154886, -4.299743795577753],
            [-2.166706045787534, -4.298308320345952],
            [-2.169920306648016, -4.303015242420326],
            [-2.1745356641111155, -4.305648096821026],
            [-2.179220077762688, -4.304961483672152],
            [-2.1795178043690884, -4.301703914119204],
            [-2.177285931546319, -4.297262794138653],
            [-2.1769290704041473, -4.291378209082684],
            [-2.183899758713269, -4.291352024548872],
            [-2.183755031630859, -4.283708122261508],
            [-2.1854642204869528, -4.267223493313357],
            [-2.1820448987277983, -4.263814262841313],
            [-2.1774413200710923, -4.272975356178242],
            [-2.1737138252472716, -4.271165410529118],
            [-2.172021117898136, -4.267281943354288],
            [-2.1728544590131493, -4.259767492485556],
            [-2.176843379966884, -4.258573312532138],
            [-2.1789418680276698, -4.250992613875545],
            [-2.176773274864054, -4.241019644229709],
            [-2.1720571217097095, -4.2387582047452215],
            [-2.1650953834020172, -4.237700865497164],
            [-2.164135223340039, -4.233377820745658],
            [-2.170303120423651, -4.228333221644844],
            [-2.1668831530130483, -4.221535234432381],
            [-2.164579344639094, -4.211589030496408],
            [-2.169114481340036, -4.214525058002119],
            [-2.172536132172556, -4.2112999901134165],
            [-2.1695368364732697, -4.207598010170687],
            [-2.170115145532358, -4.201242992590246],
            [-2.1688996068502053, -4.197901056793652],
            [-2.159993321915233, -4.190984852797004],
            [-2.158014816522403, -4.187340445640694],
            [-2.1584539499795143, -4.179560410322225],
            [-2.151869823527555, -4.1648254973948005],
            [-2.149446505046651, -4.162071896196359],
            [-2.1477420343005176, -4.150423731582323],
            [-2.1448207969943165, -4.14835465277249],
            [-2.1411104139835597, -4.152418674665725],
            [-2.1324483288457547, -4.1532383296254105],
            [-2.1308652009698883, -4.148568712493009],
            [-2.127216704190758, -4.147077567696305],
            [-2.1336163261588874, -4.142876157558898],
            [-2.1335136946456763, -4.138477992126966],
            [-2.136291555462256, -4.135642616680206],
            [-2.137032171616692, -4.130732258494013],
            [-2.1313753580923644, -4.1267277263256466],
            [-2.1255531147790894, -4.115099842677819],
            [-2.1188699229297505, -4.105458854848219],
            [-2.1131985764166323, -4.105717421897993],
            [-2.100498215277513, -4.101534106769233],
            [-2.0933483273184135, -4.102233381852458],
            [-2.0937707976575286, -4.106240039354699],
            [-2.091190579585292, -4.110072700066016],
            [-2.0874287366455686, -4.111580621648038],
            [-2.084985944482977, -4.106726655021412],
            [-2.0764807800265213, -4.102644340467013],
            [-2.0734680212781083, -4.10324878428759],
            [-2.0667213212202893, -4.101045835908785],
            [-2.065733184161419, -4.105479824994344],
            [-2.06229386865338, -4.108263886582875],
            [-2.056287856707814, -4.1072815735072625],
            [-2.0533234482284035, -4.105187245413292],
            [-2.0526886621966547, -4.0995613771928],
            [-2.0555572695857753, -4.086079596785749],
            [-2.059684431993774, -4.083550048954912],
            [-2.056880410114304, -4.080113349696366],
            [-2.0515241290772734, -4.08173774809866],
            [-2.0492369104121217, -4.077478094999316],
            [-2.0519057123992543, -4.0711473351424585],
            [-2.0578110463238577, -4.06970527557895],
            [-2.060712948557451, -4.066393217405964],
            [-2.062461896029549, -4.060989331400077],
            [-2.067664562007921, -4.058862924196221],
            [-2.0681205646965366, -4.056905027067605]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.92421062223997, "lat": 34.37285474470131 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40141"],
        "coty_name": ["Tillman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Tillman County"],
        "coty_fp_code": "141",
        "coty_gnis_code": "01101858"
      },
      "bbox": [
        -2.1854642204869528, -4.581888061779353, -1.6740125858242503,
        -4.056905027067605
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.4630993689258249, -1.7189991781328489],
            [0.4920017041977629, -1.7187581050751781],
            [0.5347853294197329, -1.7184852270425186],
            [0.6156232044380163, -1.7185793827572624],
            [0.6324056774728494, -1.718355900009323],
            [0.6326163798043233, -1.7762543699464857],
            [0.6142833636115356, -1.7763033608782692],
            [0.6144439943695205, -1.873958791777002],
            [0.614736420599105, -1.9483089532636688],
            [0.6151023259024648, -2.0508329132669973],
            [0.6152017770644757, -2.1238037367267735],
            [0.6129782844615679, -2.1238081566971143],
            [0.6131643839585782, -2.2115448400926563],
            [0.6130926907481903, -2.228055406320715],
            [0.6133202571788673, -2.2992933542688188],
            [0.5703617128751365, -2.2991924435724536],
            [0.4628066709728013, -2.299333979222858],
            [0.46297917841434344, -2.186744026964836],
            [0.4632348196092242, -2.0445504932840843],
            [0.4632313653310919, -1.9678283786148492],
            [0.4631339050875564, -1.850367916426757],
            [0.4630993689258249, -1.7189991781328489]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -95.90436190880561, "lat": 36.71524195200159 },
        "year": "2023",
        "ste_code": ["40"],
        "ste_name": ["Oklahoma"],
        "coty_code": ["40147"],
        "coty_name": ["Washington"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Washington County"],
        "coty_fp_code": "147",
        "coty_gnis_code": "01101861"
      },
      "bbox": [
        0.4628066709728013, -2.299333979222858, 0.6326163798043233,
        -1.718355900009323
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-17.393212591708636, 8.990767323664674],
            [-17.352116747940716, 8.979673795022547],
            [-17.33782903163779, 8.975074478397918],
            [-17.247640193619528, 8.951303278900808],
            [-17.242912646773256, 8.964968653495355],
            [-17.237374753045188, 8.985567949391811],
            [-17.231250243234246, 9.005701288161408],
            [-17.22409205859308, 9.03479504960378],
            [-17.20901843586055, 9.089914001122072],
            [-17.200520314194673, 9.120251320621685],
            [-17.188228111295963, 9.16530793847648],
            [-17.182115246485616, 9.1864827929751],
            [-17.17854166854641, 9.200407382203128],
            [-17.150540392010416, 9.19260515320402],
            [-17.146941308834506, 9.205311107555834],
            [-17.103889493208356, 9.361989302928055],
            [-17.092881079840783, 9.35562326201908],
            [-17.078442517864914, 9.350592742810063],
            [-17.056086921421283, 9.355009663807259],
            [-17.032143188213507, 9.350432106863794],
            [-17.01622673759806, 9.34100967232865],
            [-17.002847729042763, 9.324217060609389],
            [-16.980740008627333, 9.309455416493421],
            [-16.95873295001043, 9.296239480036432],
            [-16.953942765841205, 9.273071086842949],
            [-16.955798506344628, 9.252799436099194],
            [-16.9600505559015, 9.24082777400013],
            [-16.954147679707074, 9.228768449909357],
            [-16.943438736460806, 9.225550418983994],
            [-16.927897243891245, 9.223220459859439],
            [-16.92274493675936, 9.226009841569406],
            [-16.918233952559603, 9.222554948343657],
            [-16.90999966032033, 9.226800114017571],
            [-16.905987445100415, 9.227823932780955],
            [-16.9067114986604, 9.233145773885369],
            [-16.87652901024885, 9.250395301641612],
            [-16.861432611872527, 9.25112866963465],
            [-16.841049489142577, 9.244115270461505],
            [-16.822826853200862, 9.241535267107015],
            [-16.807906049420506, 9.232591316995467],
            [-16.8039317841607, 9.232558605172725],
            [-16.78519512659164, 9.235146163501861],
            [-16.779127627767465, 9.233230499224364],
            [-16.764018160973976, 9.213755322485435],
            [-16.76474869854616, 9.208885407567223],
            [-16.761663646625017, 9.193049925162184],
            [-16.762288336521973, 9.188617619604154],
            [-16.76937783694778, 9.182008196823311],
            [-16.770574442276224, 9.178652772261147],
            [-16.768058400027243, 9.172979597365572],
            [-16.764154298965938, 9.167913879839277],
            [-16.763688871508503, 9.160579549768471],
            [-16.765573629852284, 9.157575454695094],
            [-16.773494044411827, 9.149610536826476],
            [-16.777347690163808, 9.139996222552153],
            [-16.780447224052484, 9.136203632497917],
            [-16.780575983236492, 9.133266621217434],
            [-16.77674417642958, 9.123073733507848],
            [-16.777490924707624, 9.117872680657086],
            [-16.769503480306692, 9.110446721502928],
            [-16.771427719114847, 9.103712012500957],
            [-16.771061542034836, 9.099392574042318],
            [-16.765968316854707, 9.097411480427846],
            [-16.75817956740162, 9.097193751759761],
            [-16.75305263731799, 9.090421323367712],
            [-16.752924782092904, 9.088752126250421],
            [-16.74436303416698, 9.080459650241686],
            [-16.736615762367116, 9.07776091141992],
            [-16.73707014167213, 9.073954904671892],
            [-16.743647938538707, 9.071885091657677],
            [-16.74814885261711, 9.067041812741438],
            [-16.746330428467814, 9.061965686556498],
            [-16.746626360359866, 9.057649245073035],
            [-16.751785719318306, 9.051445958318387],
            [-16.754038233854647, 9.045805808991487],
            [-16.753744278557523, 9.037242647550979],
            [-16.756377772000175, 9.033950898511526],
            [-16.764344733476623, 9.030534571630175],
            [-16.770477657397276, 9.03174646251179],
            [-16.774829912428316, 9.027477834745657],
            [-16.776964994548802, 9.022009417504941],
            [-16.78097854787965, 9.017651113293327],
            [-16.781668293619735, 9.013231826589472],
            [-16.7791566818087, 9.007761413385191],
            [-16.774439471141136, 9.004263640328732],
            [-16.77446958960785, 8.999056201053302],
            [-16.77827373997561, 8.998425465007024],
            [-16.783591166470107, 9.000241425646367],
            [-16.78389986217689, 8.995618690608394],
            [-16.789876262748574, 8.98697184926976],
            [-16.79041692669151, 8.983637414253309],
            [-16.794232906371974, 8.976259706445752],
            [-16.794892802571788, 8.966292623095518],
            [-16.800230290627525, 8.964620504793709],
            [-16.804929889872472, 8.970299419199003],
            [-16.80790997055386, 8.965693247406692],
            [-16.812795641063428, 8.962758678897886],
            [-16.82122106205757, 8.956089548401158],
            [-16.82339445699387, 8.952368350205829],
            [-16.82467764567402, 8.946569689425631],
            [-16.829179999302344, 8.944181472828483],
            [-16.835267821342583, 8.94773867630955],
            [-16.8401939151727, 8.94566700406024],
            [-16.841783244611317, 8.938210704707613],
            [-16.845544418301337, 8.934807988286725],
            [-16.852564770861775, 8.93707920479185],
            [-16.855716420565344, 8.936994370799841],
            [-16.857705417881785, 8.93261124709411],
            [-16.854138612286697, 8.925931260451256],
            [-16.85531278517476, 8.92214933279284],
            [-16.85973803385826, 8.922199684637471],
            [-16.863698088299135, 8.92877680011863],
            [-16.86852171942742, 8.93056894812387],
            [-16.870402336640176, 8.928202762056545],
            [-16.86516771734292, 8.92364059428417],
            [-16.867692905025894, 8.916225824269295],
            [-16.874183562156475, 8.911091683549094],
            [-16.87740678759641, 8.905397045905135],
            [-16.88320409487429, 8.903354290686247],
            [-16.887058750149087, 8.904984273110815],
            [-16.8888883009875, 8.911108258601407],
            [-16.886096109100027, 8.917909800215567],
            [-16.8899393798645, 8.92132314841124],
            [-16.894533028158655, 8.920091856976041],
            [-16.90074696252401, 8.91057469157547],
            [-16.90636231692064, 8.909201968168455],
            [-16.910818343378423, 8.913616074680801],
            [-16.918434207348934, 8.913032605847421],
            [-16.921870527426506, 8.908169575331762],
            [-16.922966115635717, 8.903872839102293],
            [-16.928865255307734, 8.897973073322058],
            [-16.934508220357777, 8.895515889022812],
            [-16.93301837840336, 8.893553575704821],
            [-16.92732050016472, 8.893932298587517],
            [-16.926167486474103, 8.889313967540255],
            [-16.932994913553905, 8.884176877768672],
            [-16.93302801368316, 8.880694204255786],
            [-16.93054639505309, 8.878712540994238],
            [-16.932248953246056, 8.874871591413386],
            [-16.935305079127357, 8.873458377391469],
            [-16.93516691596728, 8.87024220694261],
            [-16.938176012834667, 8.861033076928251],
            [-16.938565745843178, 8.855274310504104],
            [-16.942489834148237, 8.850223176408665],
            [-16.940437065831986, 8.845373254523414],
            [-16.943789518245858, 8.843041186941285],
            [-16.941407312119996, 8.837916999546012],
            [-16.9451998985911, 8.836270410894658],
            [-16.943838922977786, 8.833542139934886],
            [-16.947091817644363, 8.830948842261622],
            [-16.943223231331526, 8.827952125985643],
            [-16.945221431851483, 8.823431876452174],
            [-16.938077430965205, 8.819883967659177],
            [-16.936818339003917, 8.816628860311363],
            [-16.932133382076316, 8.815534746615388],
            [-16.930929524168, 8.810036140950825],
            [-16.928166089008606, 8.810275033784709],
            [-16.927354170500323, 8.80458269827998],
            [-16.924022022678898, 8.804877457237772],
            [-16.914764762392757, 8.80241038628974],
            [-16.912682914311993, 8.799914322558195],
            [-16.905210446712598, 8.795947471280602],
            [-16.90075095483657, 8.799067579228256],
            [-16.886939239891724, 8.794731874580611],
            [-16.87868959354664, 8.790913443631462],
            [-16.872955509244374, 8.791592779124754],
            [-16.87135274192767, 8.793993139427949],
            [-16.859833548590473, 8.79013087979447],
            [-16.857834563387332, 8.787038465328108],
            [-16.85053969921951, 8.783403100773162],
            [-16.847454210430726, 8.783459813234412],
            [-16.843651697067816, 8.778008680276882],
            [-16.840556381618523, 8.777662815680097],
            [-16.8377767828124, 8.77139735815303],
            [-16.829860753238982, 8.763679866617611],
            [-16.82986321259161, 8.760637379181139],
            [-16.824082369012757, 8.75370225764308],
            [-16.82025807096506, 8.752641790193417],
            [-16.81894964401262, 8.749116870913292],
            [-16.814184020936924, 8.745976403054323],
            [-16.806198171183038, 8.737223172778126],
            [-16.798834186932492, 8.734974261411676],
            [-16.7966558627219, 8.732888464617742],
            [-16.79015238204104, 8.731159384268148],
            [-16.78802948397889, 8.726548279344613],
            [-16.79010705059569, 8.723714939667243],
            [-16.78812204503862, 8.717820259660355],
            [-16.786195531150348, 8.71637364084139],
            [-16.787634079326377, 8.711826516917956],
            [-16.782147150279414, 8.709933445958836],
            [-16.78002139340589, 8.70757446499145],
            [-16.778833593664842, 8.702449094454098],
            [-16.775553246574987, 8.698757177743506],
            [-16.770928538975795, 8.697818270975286],
            [-16.765269807683644, 8.691665123628516],
            [-16.767074533546808, 8.687600779255394],
            [-16.76499458286309, 8.680438700274106],
            [-16.766829447242507, 8.672142558723325],
            [-16.76932181170095, 8.668230987967984],
            [-16.773650465372853, 8.666318168510829],
            [-16.77741861461559, 8.660876362133603],
            [-16.777577304973914, 8.65452544607829],
            [-16.780328728623925, 8.652866332051415],
            [-16.781833100897405, 8.648106526870563],
            [-16.71127783879034, 8.629431004711686],
            [-16.627778474703206, 8.607490588333876],
            [-16.623766682061955, 8.597408844423125],
            [-16.62580982388217, 8.591419298010823],
            [-16.627281245269604, 8.586961545830631],
            [-16.62403980285207, 8.585707294012622],
            [-16.623959240339897, 8.580260416158442],
            [-16.62064094824765, 8.578474499271028],
            [-16.62173836557554, 8.575177209640067],
            [-16.62750785295115, 8.570230512946571],
            [-16.627367589631596, 8.566098643346818],
            [-16.623661777944804, 8.560833032099811],
            [-16.626524088207624, 8.556664165269424],
            [-16.63155361874534, 8.552855167296153],
            [-16.632089406970444, 8.550844558103055],
            [-16.628132817117567, 8.543772496325005],
            [-16.628750144082343, 8.537892007756192],
            [-16.631170419825878, 8.532147192181297],
            [-16.63578252493308, 8.530405835097572],
            [-16.637409280241638, 8.526221561622737],
            [-16.635425731394157, 8.524130745916304],
            [-16.6355706151455, 8.505492155821612],
            [-16.641721432874874, 8.500494961278811],
            [-16.638307296110764, 8.49413224359275],
            [-16.639616805568725, 8.490638762663144],
            [-16.646471233227405, 8.488742572283355],
            [-16.647458520532002, 8.482570551058659],
            [-16.651546004236288, 8.478337127427952],
            [-16.645895212144197, 8.472806270817077],
            [-16.647933927514448, 8.471462950353732],
            [-16.64448177647276, 8.460269992414485],
            [-16.648181741809662, 8.457893343548808],
            [-16.648557701599174, 8.455221335852432],
            [-16.645642686874226, 8.449349227838237],
            [-16.647974928657785, 8.442178196786346],
            [-16.647385659449316, 8.438417615909678],
            [-16.651917215436306, 8.435779734496725],
            [-16.642570416309592, 8.427275580019932],
            [-16.63634423276264, 8.43070250386304],
            [-16.630759540148713, 8.419994539355333],
            [-16.629905351015413, 8.414071171766418],
            [-16.63325590865656, 8.408743434350239],
            [-16.639692224755116, 8.40691202082901],
            [-16.648660845975577, 8.40577104680244],
            [-16.650989922288076, 8.399293222678205],
            [-16.64807333250885, 8.396819706625784],
            [-16.650199617886646, 8.390195520210856],
            [-16.644376958595636, 8.386068178228195],
            [-16.63808791140663, 8.383671680708076],
            [-16.637581702782995, 8.37783679077325],
            [-16.63431002591553, 8.373846394572075],
            [-16.62806946335034, 8.372301878606136],
            [-16.62444875547892, 8.369733751348896],
            [-16.625725185203187, 8.357981554965173],
            [-16.622724265621216, 8.355456826505948],
            [-16.623955530706432, 8.350756683697748],
            [-16.621788628187595, 8.346433083373057],
            [-16.612823102652005, 8.343231966525968],
            [-16.608747281612068, 8.339730163556492],
            [-16.60401172567724, 8.333272403177864],
            [-16.71281677525083, 8.3620778445774],
            [-16.821630364241575, 8.390849930751846],
            [-16.90150184342626, 8.412222180928632],
            [-16.98137797568948, 8.433576413360296],
            [-17.094912472073297, 8.464108122387609],
            [-17.096087177541023, 8.466296403701145],
            [-17.177378085847884, 8.488052545779723],
            [-17.27388456848637, 8.51368043307813],
            [-17.40110866806232, 8.548769409628225],
            [-17.52834496507132, 8.58381234778453],
            [-17.52716646074324, 8.58801198925563],
            [-17.54621654670867, 8.593241595172774],
            [-17.539901513250303, 8.599184230927435],
            [-17.533939794256366, 8.607837873675187],
            [-17.532721285976802, 8.613633604429165],
            [-17.537721954586143, 8.618443901289963],
            [-17.537663529582506, 8.623487992965705],
            [-17.534907285646074, 8.625756982168184],
            [-17.52940726988712, 8.635368452562464],
            [-17.52477056248263, 8.635410019170452],
            [-17.518968943306017, 8.639352983018684],
            [-17.51846191248604, 8.642976192940674],
            [-17.51842642044981, 8.645795627536502],
            [-17.51285464965954, 8.647221240924155],
            [-17.509261956688572, 8.650373852751056],
            [-17.504413443913858, 8.651176262037964],
            [-17.501934955934058, 8.653135383275249],
            [-17.49959555717816, 8.658774227265805],
            [-17.50530069170332, 8.660528906680172],
            [-17.509783688469923, 8.66021633522737],
            [-17.519623005977945, 8.673009478586941],
            [-17.516383458842906, 8.6774571632558],
            [-17.51695166342504, 8.685534229972493],
            [-17.51960962502931, 8.690884689591611],
            [-17.52288910457305, 8.70123508739363],
            [-17.529851897417053, 8.701716883229384],
            [-17.536239985813133, 8.69865672224113],
            [-17.54313082232784, 8.700067394376418],
            [-17.5467687746778, 8.703887610035013],
            [-17.538280476987822, 8.709564801410659],
            [-17.536119679107795, 8.714266321639219],
            [-17.538215134762062, 8.721204555731711],
            [-17.537826564763105, 8.735397319321045],
            [-17.5390161380604, 8.741852856007055],
            [-17.541028609350565, 8.743075326447476],
            [-17.53834227752441, 8.748130564019492],
            [-17.537067566046908, 8.757467479209645],
            [-17.534859933206327, 8.76450408246714],
            [-17.534815215442343, 8.771179121179369],
            [-17.532157680166023, 8.777384706666874],
            [-17.52330176354652, 8.779667664078438],
            [-17.518037139813504, 8.775817744328597],
            [-17.51558100771473, 8.775746564365917],
            [-17.513995997242205, 8.781233183435187],
            [-17.511144956878322, 8.785329225627802],
            [-17.511201927261073, 8.793007622350096],
            [-17.50809439441695, 8.795829244040407],
            [-17.502012879138018, 8.796787309083026],
            [-17.499196660747746, 8.795749766860903],
            [-17.49035944745237, 8.789812986345993],
            [-17.48907025284925, 8.787339493807881],
            [-17.48127504556381, 8.784705298669712],
            [-17.475714346394977, 8.785814896967285],
            [-17.466521034597196, 8.784715182228792],
            [-17.46614847422623, 8.789499744189103],
            [-17.467769732869, 8.793134564356212],
            [-17.456961328480315, 8.800932364369162],
            [-17.448870246872477, 8.801393166701228],
            [-17.446487417505047, 8.803929341792903],
            [-17.438568136118608, 8.80738976105211],
            [-17.43500432440022, 8.807341146869753],
            [-17.41874412608336, 8.801191320145769],
            [-17.41908100735663, 8.804484199456688],
            [-17.415829844422312, 8.81402644390876],
            [-17.40876169380141, 8.81935188765064],
            [-17.40647318007935, 8.830915686242346],
            [-17.405102879834825, 8.834040938016724],
            [-17.410314528126015, 8.838989355632597],
            [-17.408691760786542, 8.846679212228752],
            [-17.40992911569169, 8.854375118007006],
            [-17.42129891969859, 8.860740467069514],
            [-17.42879867238457, 8.85585970663673],
            [-17.431771889618112, 8.861657908133024],
            [-17.43072319983663, 8.866785664430461],
            [-17.434180300212738, 8.8749055766044],
            [-17.4340077393026, 8.881359878569887],
            [-17.431715066510964, 8.889293808317143],
            [-17.431830444423866, 8.894139447233645],
            [-17.438508816559843, 8.90102896385889],
            [-17.439820782422228, 8.904674562324423],
            [-17.439316382293892, 8.911758623762939],
            [-17.440459928352457, 8.918556515367737],
            [-17.442191027708418, 8.920467850941217],
            [-17.443201977537026, 8.92681372839992],
            [-17.44625405991101, 8.931881694628485],
            [-17.44628372466592, 8.937482147952403],
            [-17.44244755048155, 8.950076301982381],
            [-17.433852310883953, 8.94958502691943],
            [-17.42867220184459, 8.952908780135244],
            [-17.4187343853892, 8.949567478678487],
            [-17.41656257249783, 8.950436426256637],
            [-17.412015794648827, 8.956999867867644],
            [-17.404279013135408, 8.959060307591253],
            [-17.402189959159127, 8.961911417284195],
            [-17.397152965263786, 8.96275541116321],
            [-17.39337034520625, 8.960541616753181],
            [-17.39286363748692, 8.965420854768992],
            [-17.39005983345366, 8.971593529940067],
            [-17.386936226677474, 8.974254874841312],
            [-17.38461021041017, 8.98088617393112],
            [-17.39007538947853, 8.983168239421223],
            [-17.393212591708636, 8.990767323664674]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -121.16782594237623,
          "lat": 45.160003007979284
        },
        "year": "2023",
        "ste_code": ["41"],
        "ste_name": ["Oregon"],
        "coty_code": ["41065"],
        "coty_name": ["Wasco"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Wasco County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01155136"
      },
      "bbox": [
        -17.5467687746778, 8.333272403177864, -16.60401172567724,
        9.361989302928055
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.28076054520659, 3.385428268750172],
            [13.269463550587076, 3.451764948849018],
            [13.25712910409945, 3.5184043697665643],
            [13.247956988400023, 3.5670440938599857],
            [13.240199768341952, 3.6095256499160793],
            [13.243323252270027, 3.624346605228819],
            [13.255396660215851, 3.6844199819943038],
            [13.296762726892458, 3.691080253851629],
            [13.339635189823396, 3.714923370126389],
            [13.333927667353258, 3.751022735282467],
            [13.422475237349385, 3.759681641708591],
            [13.560459763018269, 3.77512052627586],
            [13.638753212564522, 3.784016462094147],
            [13.638796895071073, 3.783729877156505],
            [13.704120982449478, 3.7880233423350598],
            [13.746440736563068, 3.7905528174526153],
            [13.778187801659316, 3.7531853621274673],
            [13.798899842148536, 3.735693048827152],
            [13.796378083917377, 3.727944713804009],
            [13.789785707379817, 3.725467298730277],
            [13.789206855393761, 3.722640613154651],
            [13.790350764751093, 3.714164854968619],
            [13.788027999940285, 3.7103746915106406],
            [13.782807513618181, 3.7108463759591173],
            [13.779888864852053, 3.706848776785817],
            [13.782073581866747, 3.7024786852689795],
            [13.778776338077671, 3.69954287513548],
            [13.775296475547592, 3.702067561530915],
            [13.770403992328674, 3.7019328699439344],
            [13.768558572051864, 3.6914345239750057],
            [13.765141842500219, 3.6911059620525566],
            [13.763796036594316, 3.6942441940123847],
            [13.759294863863083, 3.695556223925066],
            [13.75357705490416, 3.6897115879537523],
            [13.752092743176057, 3.685846794253394],
            [13.757029903682358, 3.678458440913066],
            [13.767682335811587, 3.6605408908331376],
            [13.772900297980213, 3.6548992376635994],
            [13.772272487662528, 3.645910198533162],
            [13.78012754517728, 3.6450972528600807],
            [13.778189425367929, 3.6352653569660633],
            [13.780488897222872, 3.63337974397696],
            [13.789229032723032, 3.637618199215695],
            [13.7926828274623, 3.630352381697714],
            [13.796467284593621, 3.629062509956509],
            [13.800139045167807, 3.633113203518386],
            [13.80278010047608, 3.6311621422779967],
            [13.800261646177033, 3.625640786659505],
            [13.806515500339236, 3.6201105570683954],
            [13.80693959249392, 3.618328936517451],
            [13.801046645265957, 3.6154096515136938],
            [13.798943698311337, 3.6118750742727594],
            [13.793545220568605, 3.6126475852632436],
            [13.791218955740769, 3.6082870754615217],
            [13.796283606699586, 3.600574526513078],
            [13.802461059451973, 3.598984364905352],
            [13.801939439534022, 3.5939776428934627],
            [13.803586489443276, 3.592393100107681],
            [13.807963303123657, 3.5936678570493648],
            [13.81335322341662, 3.58957494956787],
            [13.81418361213, 3.586236547738367],
            [13.807536916186672, 3.583410000915075],
            [13.81098287232435, 3.578495422372633],
            [13.806424950079426, 3.577365410130892],
            [13.803087351767303, 3.572930489199464],
            [13.797691551973184, 3.571310576238899],
            [13.79379821117808, 3.5717054641487826],
            [13.79864881856319, 3.563352985583496],
            [13.797607928848423, 3.5584593302662366],
            [13.793116774623236, 3.5576556101214254],
            [13.795381831103162, 3.5531730653129294],
            [13.792708071639387, 3.546931862405784],
            [13.796858301704965, 3.5475486135714975],
            [13.800361921413597, 3.5455620143495095],
            [13.806686145066168, 3.5376404068934777],
            [13.804626265791129, 3.533395599981424],
            [13.798809559800848, 3.531667260768384],
            [13.795646269400901, 3.526944349782709],
            [13.792218461243596, 3.527473501025443],
            [13.788966627323664, 3.5247330692983043],
            [13.784757624350664, 3.5243578935934394],
            [13.784556855423087, 3.5193926081905875],
            [13.778230807906052, 3.515043857730882],
            [13.776488110880152, 3.519911292475566],
            [13.772899029040978, 3.517747998828371],
            [13.767403687672362, 3.5188405557892373],
            [13.769192762927554, 3.52284291384201],
            [13.764076445017302, 3.5266661700605764],
            [13.767697181550812, 3.5333162010690353],
            [13.763104881946957, 3.5332208129292746],
            [13.761465394565628, 3.527278017626707],
            [13.761794370624871, 3.5199046894073507],
            [13.757051726383294, 3.518481249733651],
            [13.756639183146028, 3.5252393456842857],
            [13.745872126848946, 3.5285429463035083],
            [13.739492901014227, 3.526313536700128],
            [13.741406307866537, 3.5182818963667253],
            [13.745218169617472, 3.521800045845816],
            [13.752396606410107, 3.5108817650376927],
            [13.747513697284083, 3.509230665798953],
            [13.745577294154128, 3.5033488937890116],
            [13.742015966281775, 3.502757047487561],
            [13.7426851112634, 3.4984283911983955],
            [13.738889364921386, 3.495446300737991],
            [13.738171736829866, 3.4884976306678346],
            [13.730914713038349, 3.4821766062877564],
            [13.726981824687654, 3.4827252799994306],
            [13.72360521492803, 3.4778053370445092],
            [13.716892209852622, 3.4781576772621765],
            [13.712367394560681, 3.4736493457695],
            [13.707286906499005, 3.466102469887573],
            [13.706369975860063, 3.4580862564292087],
            [13.713959701085184, 3.451150081737845],
            [13.714029775359796, 3.448020244722828],
            [13.709692148075924, 3.4453845219932004],
            [13.709350542933736, 3.438728574929734],
            [13.701429601204238, 3.43860297645901],
            [13.696432948090449, 3.4355303697868327],
            [13.699446330825843, 3.4332488654460747],
            [13.703963444903106, 3.433754012775448],
            [13.706426781746377, 3.4313166656931764],
            [13.697418190418716, 3.425432782958005],
            [13.698879522249744, 3.417084459926247],
            [13.70103006641924, 3.4146871652198927],
            [13.699884638525717, 3.411416064699523],
            [13.696104125792555, 3.4090362150129736],
            [13.691650679260425, 3.409147272028112],
            [13.686012917842977, 3.4001584901863557],
            [13.681459658129466, 3.402520632424083],
            [13.674887039992159, 3.402265445923503],
            [13.670472757873368, 3.3970285435757726],
            [13.671790424153127, 3.3929452076542006],
            [13.669821279470218, 3.387861246771193],
            [13.66508413049326, 3.382438064898101],
            [13.666956478290423, 3.380660401964335],
            [13.668669517122378, 3.3739589886046444],
            [13.664798940548883, 3.369213178687594],
            [13.66395958497138, 3.3640170998929406],
            [13.66162808533639, 3.3617061140116107],
            [13.661060573340107, 3.356134992994082],
            [13.656247501895896, 3.3551035587137363],
            [13.651838888893318, 3.351678502702496],
            [13.649236750583341, 3.3462961334619066],
            [13.644216262574913, 3.3423398553764376],
            [13.644765394558794, 3.3257597899439677],
            [13.642467293488984, 3.324466038291293],
            [13.639462860425072, 3.3147090327492346],
            [13.640191280141673, 3.3116011576052933],
            [13.635155293995743, 3.309615060318751],
            [13.631259487920353, 3.305452976753105],
            [13.629991436177356, 3.3015816428399116],
            [13.62517484396242, 3.2940194435710715],
            [13.635688602367464, 3.2771385978280687],
            [13.640519111481025, 3.2750564286616033],
            [13.651157347741545, 3.2670742449481494],
            [13.610772322303832, 3.2613508056620653],
            [13.562998409702507, 3.252681212991281],
            [13.515345711504033, 3.244257046939176],
            [13.487986128904705, 3.238914499190877],
            [13.439336325436692, 3.227301005216407],
            [13.397988402526382, 3.2209517552282665],
            [13.316213674274545, 3.2062724332192776],
            [13.311922250540691, 3.2107341231394035],
            [13.297985513451268, 3.2859427230504026],
            [13.290936421643123, 3.3249144114048375],
            [13.28076054520659, 3.385428268750172]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.47424512248513, "lat": 41.00002598555352 },
        "year": "2023",
        "ste_code": ["42"],
        "ste_name": ["Pennsylvania"],
        "coty_code": ["42033"],
        "coty_name": ["Clearfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Clearfield County"],
        "coty_fp_code": "033",
        "coty_gnis_code": "01209175"
      },
      "bbox": [
        13.240199768341952, 3.2062724332192776, 13.81418361213,
        3.7905528174526153
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.681404714345724, -3.516484493587724],
            [11.683719842242615, -3.5225002515722417],
            [11.697013032842374, -3.5215840898022757],
            [11.695783144801863, -3.5306799801405413],
            [11.698640496025533, -3.532817886440058],
            [11.704945890806039, -3.532779778957642],
            [11.705470878099318, -3.537703557895],
            [11.716454523709473, -3.5458506728066985],
            [11.723020961461433, -3.5437264880347135],
            [11.726506968698873, -3.545181007911565],
            [11.727295929915012, -3.5507117839347546],
            [11.731181019884612, -3.5491837257009116],
            [11.737645167681098, -3.5537126436847823],
            [11.741449529030197, -3.5587813381782873],
            [11.744278412216598, -3.5597211422852544],
            [11.749271294665906, -3.566413335945652],
            [11.753285517142032, -3.5766747193521944],
            [11.755333149270644, -3.5859505587192846],
            [11.758086098131994, -3.5866641760704137],
            [11.7667552672268, -3.5833344622561265],
            [11.77681942797026, -3.5878690899173997],
            [11.78494242927269, -3.588682286149159],
            [11.787203978210973, -3.5918024435699585],
            [11.792567130057153, -3.5950043312413564],
            [11.793262526855578, -3.6006976749346573],
            [11.79671864819283, -3.606552139137941],
            [11.79923701302036, -3.606895219667469],
            [11.806155641529351, -3.6015622019908937],
            [11.814386245631828, -3.60348027836198],
            [11.820254299925164, -3.606377459336309],
            [11.824125824522097, -3.6055141393839176],
            [11.829374583495198, -3.6071200063737714],
            [11.832452194542393, -3.6103019457467624],
            [11.836515128941144, -3.6120148395893428],
            [11.839815085217829, -3.6165231998688125],
            [11.845931471427551, -3.6189661971513374],
            [11.848731749197077, -3.6221142089402463],
            [11.859078742849448, -3.6282203032697695],
            [11.86056783009307, -3.633578620260887],
            [11.867914761200076, -3.636736335684173],
            [11.87742016693394, -3.637534898761368],
            [11.882513795957932, -3.640760882115218],
            [11.891196250978458, -3.6509668260449395],
            [11.899931117585803, -3.655394941036815],
            [11.908549454958269, -3.652507334807721],
            [11.91345631883868, -3.6531561444029204],
            [11.918322581203805, -3.655553497030471],
            [11.92380435828774, -3.65532640034122],
            [11.92395458989801, -3.6611528426712985],
            [11.93013545859381, -3.6662331634022216],
            [11.932088520078825, -3.6703176689573715],
            [11.941055675489375, -3.6726623597817043],
            [11.948696637689338, -3.67920736220763],
            [11.95087910658551, -3.6831587353969186],
            [11.956059302999568, -3.6860859044662706],
            [11.962021278505707, -3.6930114904310964],
            [11.971973829712205, -3.6911331028604244],
            [11.978645442995349, -3.695360098456307],
            [11.97687611883909, -3.700194147705598],
            [11.979327758514673, -3.702469709517429],
            [11.982703890592019, -3.7087275592900224],
            [11.9896225363359, -3.705607124134079],
            [11.992951337725502, -3.7077830830954874],
            [11.993460156216853, -3.7113535040226706],
            [11.991711945332796, -3.716882141257476],
            [11.992496500041726, -3.7226005150250043],
            [12.000680661396778, -3.7269288009995165],
            [12.002323964446965, -3.73566584699991],
            [12.005581768006717, -3.737651620830313],
            [12.014950523238005, -3.7388369426496917],
            [12.020801379950605, -3.7438380838435505],
            [12.026999556178922, -3.7444412244164775],
            [12.027504438136974, -3.749874659394359],
            [12.021830527330888, -3.7551279855834796],
            [12.02044686559474, -3.760767062000982],
            [12.015412438535183, -3.7638998524217886],
            [12.014055182831507, -3.77207029907655],
            [12.010557724334753, -3.774044970705879],
            [12.01152010248939, -3.782991430935734],
            [12.008489393532185, -3.7882582934355966],
            [12.004861802678104, -3.7891976772163476],
            [11.99648032027525, -3.7941125464659526],
            [11.995507328927909, -3.8018178530531377],
            [11.996212429282089, -3.806242706569553],
            [11.99164402852208, -3.8097387814798664],
            [11.99304715228537, -3.812902821504213],
            [11.987524748053684, -3.8169430816729957],
            [11.979545953828604, -3.849529618140965],
            [11.974844607951182, -3.8591512310565252],
            [11.954923454858777, -3.89070581336657],
            [11.95080406614503, -3.894996157557411],
            [11.949732440637773, -3.9017585134485744],
            [11.947296350005887, -3.905715766511479],
            [11.946478034341075, -3.911495248309282],
            [11.943843769472064, -3.9167701082614372],
            [11.94420617043387, -3.919749792259554],
            [11.940794359630706, -3.924074513586263],
            [11.94038861633961, -3.933890650600841],
            [11.910136602672882, -3.9469315389102957],
            [11.909238883561246, -3.943407171336527],
            [11.908553981707, -3.929916107574828],
            [11.907188998568841, -3.916694639682551],
            [11.88864679285703, -3.9224916777563945],
            [11.882646699796247, -3.9249988918522543],
            [11.858473014260577, -3.922806037656596],
            [11.852802771335448, -3.925780565482435],
            [11.820477872245808, -3.926268021346673],
            [11.819327350326535, -3.9284835952074166],
            [11.808889826497802, -3.9416429657147702],
            [11.803181705164775, -3.943106256367555],
            [11.795105164252874, -3.9423022195125355],
            [11.781556008017187, -3.940002091856841],
            [11.769347050653867, -3.9341836603868234],
            [11.762993683283872, -3.9300057036037996],
            [11.754329497410504, -3.922320720513607],
            [11.752643119621744, -3.9181807362358176],
            [11.748360682251873, -3.91228007713534],
            [11.740529736702495, -3.906065311493194],
            [11.726820231891484, -3.923080665070053],
            [11.707292994151645, -3.949076360672414],
            [11.69653895561956, -3.959271105565715],
            [11.69349705709743, -3.951421512704452],
            [11.666042046720598, -3.8698972098643596],
            [11.683511879750217, -3.850622239607895],
            [11.707076394436816, -3.8202612333558523],
            [11.709494326645412, -3.814818804833965],
            [11.718584750401696, -3.7907559729461817],
            [11.721880128786477, -3.760884101783759],
            [11.718065817392091, -3.7322505515504965],
            [11.71005128755938, -3.7128851988417586],
            [11.70734720029389, -3.7049629184909505],
            [11.689988189546234, -3.683119808589915],
            [11.677384669941322, -3.67044288847704],
            [11.662576108042865, -3.6599680201809397],
            [11.65088824101966, -3.655237606823063],
            [11.644219127950333, -3.628751775481673],
            [11.644701746869048, -3.6269611479290327],
            [11.64229292791404, -3.617696564914172],
            [11.641875066920731, -3.612935107001525],
            [11.630846743428807, -3.6096233191538816],
            [11.628202254125005, -3.6022137536570136],
            [11.619894664089616, -3.5935601760343365],
            [11.681404714345724, -3.516484493587724]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -82.12588958095115, "lat": 34.15369218785744 },
        "year": "2023",
        "ste_code": ["45"],
        "ste_name": ["South Carolina"],
        "coty_code": ["45047"],
        "coty_name": ["Greenwood"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Greenwood County"],
        "coty_fp_code": "047",
        "coty_gnis_code": "01248003"
      },
      "bbox": [
        11.619894664089616, -3.959271105565715, 12.027504438136974,
        -3.516484493587724
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-0.9492526781599879, 5.196038221207237],
            [-0.8658417034958377, 5.193540317262847],
            [-0.8081590821948063, 5.192373615316001],
            [-0.7665101940231264, 5.191322389379515],
            [-0.6916278462608085, 5.189584233636274],
            [-0.6934675992180038, 5.100882194455223],
            [-0.6925621797125853, 5.0718421965662905],
            [-0.6931468857866866, 5.013807603741015],
            [-0.6946956058858391, 4.941062799680374],
            [-0.6964770678432217, 4.840216430298394],
            [-0.7912427372341085, 4.841932478079502],
            [-0.8688666522130485, 4.843107670611748],
            [-0.9546182432456073, 4.844263983951895],
            [-0.9539180369520022, 4.94602247477097],
            [-0.9533868215376347, 4.960628957507156],
            [-0.9523032990340162, 5.018867761921661],
            [-0.9517779071158636, 5.106874951570417],
            [-0.9505407572876144, 5.157068867358845],
            [-0.9492526781599879, 5.196038221207237]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -97.78727254111219, "lat": 43.67479295888802 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46061"],
        "coty_name": ["Hanson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hanson County"],
        "coty_fp_code": "061",
        "coty_gnis_code": "01266979"
      },
      "bbox": [
        -0.9546182432456073, 4.840216430298394, -0.6916278462608085,
        5.196038221207237
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.12439406536905, 7.312619777790694],
            [-2.034429902213906, 7.3093833229887055],
            [-1.9659038750547453, 7.306115343629835],
            [-1.8881315286119738, 7.303367301293458],
            [-1.8041251463868824, 7.3001171119652275],
            [-1.689384299095329, 7.296436291510898],
            [-1.6287675290213584, 7.294269011786387],
            [-1.5589928028480151, 7.291695499892934],
            [-1.432972564874115, 7.287165971235719],
            [-1.435647240146834, 7.201491191398417],
            [-1.4396323927184729, 7.072177904714861],
            [-1.4407687110563703, 7.029007843318133],
            [-1.443361813392192, 6.942818683892637],
            [-1.5249519646139242, 6.946194942371713],
            [-1.612179000355193, 6.94899327889475],
            [-1.7001857997556198, 6.951752762726306],
            [-1.8283832172072767, 6.956291192662205],
            [-1.8722849123225722, 6.957974828257561],
            [-1.9033241706601125, 6.958951424202218],
            [-1.9582243432716981, 6.961160517955283],
            [-2.0512806829499515, 6.9647314560403],
            [-2.130723784112959, 6.968041121705096],
            [-2.1375491113699336, 6.968342642822882],
            [-2.132992576377515, 7.0837450872260295],
            [-2.1331391196443508, 7.085809304436458],
            [-2.1310251949447867, 7.140665286212871],
            [-2.12439406536905, 7.312619777790694]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -99.22140910022463, "lat": 45.76639779332859 },
        "year": "2023",
        "ste_code": ["46"],
        "ste_name": ["South Dakota"],
        "coty_code": ["46089"],
        "coty_name": ["McPherson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["McPherson County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01265762"
      },
      "bbox": [
        -2.1375491113699336, 6.942818683892637, -1.432972564874115,
        7.312619777790694
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.740946392593154, -2.653154760338839],
            [6.739591342929428, -2.6238756773771894],
            [6.7520627525643215, -2.623426620877695],
            [6.77148792540773, -2.6217960144608163],
            [6.811328736741369, -2.6212839847495233],
            [6.814809221753389, -2.6208299392463186],
            [6.816304550373051, -2.623917133353299],
            [6.821185516164742, -2.620535674754338],
            [6.822010710816267, -2.617854745249612],
            [6.832395432702994, -2.616984992525902],
            [6.832383714440201, -2.6116323039035576],
            [6.840170782152036, -2.6113387763346343],
            [6.848109432950811, -2.6179434702982887],
            [6.855284635887661, -2.6164604492680046],
            [6.859780379359931, -2.622650786920318],
            [6.8599928622055115, -2.6271682424537977],
            [6.862017499707732, -2.63014041649643],
            [6.862334377514479, -2.648887935383157],
            [6.871022616712864, -2.6480707733669493],
            [6.875360433677309, -2.643002680994798],
            [6.881565027417002, -2.641848966641169],
            [6.882625095589856, -2.6445477974151115],
            [6.887861219395024, -2.6464565485769644],
            [6.892579155715365, -2.641099363888249],
            [6.896896244040493, -2.6399700950525404],
            [6.907944196958332, -2.640304988524481],
            [6.9071271397817116, -2.660640019889852],
            [6.903780824473249, -2.67787705229977],
            [6.899680884426942, -2.6906955811489013],
            [6.897129444329602, -2.6958202367012136],
            [6.887677557043345, -2.708419293667692],
            [6.88210321646364, -2.714038532888257],
            [6.8789663233441996, -2.7158056454566006],
            [6.873841079481114, -2.72215106669355],
            [6.8662888722292506, -2.735249285453396],
            [6.86497494477446, -2.743510175700272],
            [6.866260317564172, -2.750373459011742],
            [6.872071429824235, -2.766629497391766],
            [6.875934004796556, -2.7715332797951753],
            [6.881589396721429, -2.776588564783346],
            [6.882883119592073, -2.7821327611918343],
            [6.882515010695412, -2.7997272025222832],
            [6.873337800343685, -2.8333639300672444],
            [6.8721927904818125, -2.8394158127087072],
            [6.874211171855391, -2.8473897460715483],
            [6.887279737351663, -2.8708632416881135],
            [6.891289388599572, -2.876048863181341],
            [6.897169141760476, -2.887525909974081],
            [6.908044518209997, -2.9059284280338358],
            [6.918526872874577, -2.9165413928569706],
            [6.923315001022246, -2.922640525050461],
            [6.927331179547805, -2.92995741821521],
            [6.929906023135984, -2.936508052927233],
            [6.930722312465745, -2.943493416050918],
            [6.928332770810409, -2.9641935571079006],
            [6.927142401540039, -2.9679626855626213],
            [6.92153207751236, -2.9759907456105656],
            [6.9145165942034055, -2.980547059859177],
            [6.9089674068978235, -2.9817657964053708],
            [6.892121581117811, -2.9892126631542446],
            [6.889563957441087, -2.9965718218896877],
            [6.8874360515799955, -2.9998392640122757],
            [6.882624965488785, -3.0029079591031445],
            [6.880923194838654, -3.008918843954765],
            [6.881932521940491, -3.017805355797152],
            [6.8881176293537045, -3.027977559979506],
            [6.892585148940876, -3.0337498210525493],
            [6.900331447612312, -3.037628751277294],
            [6.911591231918199, -3.0367849606564614],
            [6.92064277290584, -3.039266004662973],
            [6.928212418525509, -3.0428780917382223],
            [6.9381075134023895, -3.043289131496768],
            [6.940365196684018, -3.0482799883322182],
            [6.939851331803839, -3.0560488487416877],
            [6.935927312618443, -3.0634434573257123],
            [6.9328853538177775, -3.0666009242689016],
            [6.925300207848, -3.069796657376069],
            [6.910783843963452, -3.0736911904732183],
            [6.907094671078963, -3.07330486094063],
            [6.900510351024555, -3.0691328265060793],
            [6.895654238563206, -3.065090213560354],
            [6.880319800300467, -3.054363314114304],
            [6.868444916481051, -3.046802947950305],
            [6.864560049558632, -3.046758601479104],
            [6.84817869575179, -3.0602588458240816],
            [6.842058347038363, -3.0671312920059917],
            [6.8349986794884545, -3.076375913869175],
            [6.828806069479413, -3.081690107395935],
            [6.820450304915732, -3.0842697791115974],
            [6.80718100202714, -3.083852714927131],
            [6.790587887035784, -3.0783442576192077],
            [6.787420666372013, -3.0785763107556927],
            [6.776941430922645, -3.0842911077565893],
            [6.76837043863888, -3.0882068539152234],
            [6.7632852594243404, -3.093418101780615],
            [6.760474248821065, -3.0906075557683383],
            [6.7623479358011265, -3.0854582518525056],
            [6.760501018882845, -3.0802142867556226],
            [6.753645689631325, -3.078958692829349],
            [6.751193113657186, -3.075922292554932],
            [6.752387689060056, -3.071996326753119],
            [6.749980111909321, -3.0664493330679963],
            [6.745062633941112, -3.063959563191421],
            [6.73882636718578, -3.0636658571625923],
            [6.736293659393592, -3.0605193019456958],
            [6.7317476985312386, -3.0609367654171877],
            [6.730886794812889, -3.055767076617558],
            [6.724481646554436, -3.0556366868214933],
            [6.723270971223481, -3.052522194915916],
            [6.718170948314729, -3.0526788889884857],
            [6.713488645174967, -2.9468844748908984],
            [6.721505806355746, -2.927313927010123],
            [6.727392956994971, -2.9269705536558064],
            [6.7329641880428905, -2.9247518416667035],
            [6.7327647531194375, -2.919617856489238],
            [6.724723118942958, -2.919964197625909],
            [6.749108560094538, -2.862534889630133],
            [6.7486007672706645, -2.847279422917318],
            [6.7419005347696865, -2.8476887315098356],
            [6.741401852995499, -2.841595792849534],
            [6.748480128368277, -2.8402887760565205],
            [6.746773510794174, -2.799955228588657],
            [6.742482825103526, -2.6930540436151884],
            [6.739200557409246, -2.691442012875496],
            [6.739103007328087, -2.687561053061217],
            [6.742339119649783, -2.6849318387986716],
            [6.740946392593154, -2.653154760338839]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -88.1087870762052, "lat": 35.60306682612366 },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47039"],
        "coty_name": ["Decatur"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Decatur County"],
        "coty_fp_code": "039",
        "coty_gnis_code": "01639739"
      },
      "bbox": [
        6.713488645174967, -3.093418101780615, 6.940365196684018,
        -2.6113387763346343
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [7.261734807664656, -3.031718795880365],
            [7.299016187457917, -3.0282978144212143],
            [7.308885085445866, -3.027788707684087],
            [7.308768582658232, -3.014044715234106],
            [7.31318059395231, -3.0107238874501223],
            [7.33834633919244, -3.00842827172809],
            [7.337540666812373, -3.0004698002792494],
            [7.350722371608501, -2.9997404516915434],
            [7.350996022157598, -3.0012817698583043],
            [7.361552599250939, -3.0003698910228143],
            [7.361543820761737, -2.997498750691993],
            [7.3584478034594305, -2.962994794584071],
            [7.416860211787756, -2.9576973434851195],
            [7.422720713683912, -2.9577068798395203],
            [7.43324224971686, -2.958979178161216],
            [7.457225061702339, -2.9554767224918432],
            [7.457100193137203, -2.9643067717348996],
            [7.483442612183553, -2.9649535614126186],
            [7.4831084224141335, -2.967562266810699],
            [7.520259997044284, -2.972673321743884],
            [7.538422274157334, -2.975416331143371],
            [7.539792514624722, -2.9708699149641666],
            [7.53872717153003, -2.9641808797469165],
            [7.54610559239149, -2.96552716931743],
            [7.555234001771643, -2.969939518364773],
            [7.553392553294285, -2.9966386646250474],
            [7.553003088303823, -3.0118022579770845],
            [7.5532995872384525, -3.0226373266491082],
            [7.554808770320746, -3.0320223982570806],
            [7.557372043803741, -3.0577179777577426],
            [7.561193059166058, -3.108440597629112],
            [7.555280202893072, -3.108728675767459],
            [7.555269434366545, -3.1123532870312576],
            [7.547804944630624, -3.1127791765107786],
            [7.547960142793929, -3.1178572379472915],
            [7.561868815159074, -3.1176283097477646],
            [7.564312789248055, -3.1585469767943675],
            [7.56433165709441, -3.177159260505869],
            [7.568972413404492, -3.1767156420627782],
            [7.569101504976609, -3.182765643059059],
            [7.5673251203318745, -3.1866988784969905],
            [7.5670285624009335, -3.195010357972759],
            [7.573761508668203, -3.1949049947526045],
            [7.573173756232157, -3.201249789378133],
            [7.566044075350465, -3.2011884475647996],
            [7.565941963380722, -3.2053135131423796],
            [7.569046481677135, -3.205961897111948],
            [7.568847403867449, -3.2225598405204985],
            [7.5673665757642175, -3.2317277290805464],
            [7.568658263147929, -3.236105971299246],
            [7.57362295494543, -3.236289879795657],
            [7.573457569785289, -3.2390582190289288],
            [7.582278596768261, -3.238389002829173],
            [7.5867805165837146, -3.240725780319442],
            [7.588189416288179, -3.2438397338067406],
            [7.587850196541235, -3.2517267153971208],
            [7.58270932547894, -3.251525571643918],
            [7.581201889767072, -3.2700417257949925],
            [7.588423498657834, -3.2705306013136926],
            [7.5875240106066055, -3.282120021252681],
            [7.578136303368417, -3.28131065938041],
            [7.577628085977497, -3.3003206373965717],
            [7.582144855737948, -3.300530609942879],
            [7.581748377949775, -3.3096283835495544],
            [7.577482898904431, -3.3097439861584963],
            [7.576399375743043, -3.3567354338395514],
            [7.581767283337066, -3.403563105573853],
            [7.581536298149538, -3.406368311999101],
            [7.5206247309084455, -3.4103685914379556],
            [7.415766968814657, -3.4180052465150386],
            [7.339869662369716, -3.42436644377393],
            [7.2720516020298955, -3.4299867773330206],
            [7.26813345133084, -3.423283504702333],
            [7.268336340651326, -3.419834243735303],
            [7.266036792660412, -3.414989899547488],
            [7.269331240459095, -3.411326061052178],
            [7.2695453162034225, -3.397639938743126],
            [7.285305766860056, -3.3975632128205566],
            [7.291535563753828, -3.3966986702528312],
            [7.289744916829555, -3.386668730091478],
            [7.288079700571052, -3.3825063270688718],
            [7.290957407798176, -3.3776307380800143],
            [7.285821417902744, -3.3779314635578737],
            [7.285573879964224, -3.3734259727978775],
            [7.281199964602013, -3.3737993705948632],
            [7.272436723671747, -3.2893322936445624],
            [7.278032805214658, -3.2884795848290107],
            [7.276925479295387, -3.276028375452324],
            [7.282607089164774, -3.2758915275286555],
            [7.281109484787768, -3.2717366998629864],
            [7.28339801745218, -3.266503856366144],
            [7.281723992203823, -3.2644615030061543],
            [7.282487224957041, -3.2402206325891405],
            [7.279846193942815, -3.2401749367826023],
            [7.277724208009525, -3.244179939823171],
            [7.272781582105926, -3.186281305491432],
            [7.2708451418196685, -3.1616861490643737],
            [7.261734807664656, -3.031718795880365]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -87.39556692428532,
          "lat": 35.217331862102675
        },
        "year": "2023",
        "ste_code": ["47"],
        "ste_name": ["Tennessee"],
        "coty_code": ["47099"],
        "coty_name": ["Lawrence"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lawrence County"],
        "coty_fp_code": "099",
        "coty_gnis_code": "01639764"
      },
      "bbox": [
        7.261734807664656, -3.4299867773330206, 7.588423498657834,
        -2.9554767224918432
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-2.65574876335752, -8.762156300190066],
            [-2.54181721648859, -8.767589852891854],
            [-2.4149209822754796, -8.773494562188535],
            [-2.375331101736906, -8.775660900754449],
            [-2.2876457697529866, -8.787624219148087],
            [-2.2858234934522828, -8.78832670778645],
            [-2.228162033964411, -8.8184846926937],
            [-2.128032038239628, -8.87344833821459],
            [-2.066679764486946, -8.907079983453482],
            [-1.9927652025257703, -8.947107689337916],
            [-1.9499245626095032, -8.970371600587328],
            [-1.948006488510994, -8.971141838153468],
            [-1.9729716502499497, -8.999539247539298],
            [-2.0219956387364943, -9.05587129701762],
            [-2.02352198292558, -9.057344862666836],
            [-2.0816114421856637, -9.123251018636497],
            [-2.0854858385503996, -9.121851694664295],
            [-2.093823661653452, -9.126585442360017],
            [-2.101320635211397, -9.126519978473736],
            [-2.108354117990171, -9.12442105616359],
            [-2.1143722579697175, -9.12555675545343],
            [-2.117844325186149, -9.130427950437637],
            [-2.122799824009334, -9.132172744234419],
            [-2.12718604452505, -9.128617834197657],
            [-2.132007878846628, -9.119895842899492],
            [-2.132307934687469, -9.113931853781663],
            [-2.1264974826674186, -9.108826989209497],
            [-2.126857755826212, -9.10513238925209],
            [-2.1319443391158677, -9.102261485645945],
            [-2.132982981556342, -9.099527838234087],
            [-2.1308662711747473, -9.093395158229741],
            [-2.1252281741794876, -9.085782382224084],
            [-2.123189687210794, -9.079839382261001],
            [-2.1225783383041863, -9.071588027251364],
            [-2.12619237051304, -9.064525857214104],
            [-2.1289139209762293, -9.061325495539407],
            [-2.143272495468989, -9.061102320347239],
            [-2.201020373396076, -9.058738950228985],
            [-2.3092837805034785, -9.053781647846316],
            [-2.309943804896188, -9.053553180300874],
            [-2.371092441894398, -9.051235894211773],
            [-2.410857272387963, -9.048938821409832],
            [-2.4493067368313812, -9.047063994434184],
            [-2.500539497365573, -9.044956266577097],
            [-2.568833276906257, -9.042331227422475],
            [-2.666692547388723, -9.039227204464115],
            [-2.662568099022253, -8.927566446003889],
            [-2.6617163888421045, -8.9120548108631],
            [-2.65574876335752, -8.762156300190066]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -99.24630270907213,
          "lat": 29.747204723097866
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48019"],
        "coty_name": ["Bandera"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Bandera County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01383795"
      },
      "bbox": [
        -2.666692547388723, -9.132172744234419, -1.948006488510994,
        -8.762156300190066
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.709489721485852, -5.614862469866761],
            [-4.599350078119387, -5.621207509093254],
            [-4.534554477185506, -5.624673952916903],
            [-4.507187450297219, -5.6262689692286285],
            [-4.3885908295773906, -5.632863427673276],
            [-4.301724409685748, -5.637350314031416],
            [-4.278869604964729, -5.638833557392039],
            [-4.286480963497763, -5.772410291062276],
            [-4.290585536152582, -5.848868245248189],
            [-4.297103775162499, -5.96929860083344],
            [-4.30302532172462, -6.075099107972644],
            [-4.356379124118721, -6.071954033061861],
            [-4.474715894288257, -6.065583927869305],
            [-4.603974522206675, -6.057930608315166],
            [-4.733232040669349, -6.050256692103914],
            [-4.723397387263106, -5.871283077157687],
            [-4.720145373029584, -5.814521791360511],
            [-4.716515860489319, -5.755078299118613],
            [-4.710345164303283, -5.629745630340637],
            [-4.709489721485852, -5.614862469866761]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -101.94764590959709, "lat": 32.7425567884688 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48115"],
        "coty_name": ["Dawson"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Dawson County"],
        "coty_fp_code": "115",
        "coty_gnis_code": "01383843"
      },
      "bbox": [
        -4.733232040669349, -6.075099107972644, -4.278869604964729,
        -5.614862469866761
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.41751379585690823, -6.7290584542462515],
            [0.41919273795908885, -6.735676473165868],
            [0.4224231971989535, -6.743964524808724],
            [0.41585867009259975, -6.750668415185774],
            [0.4160492673469184, -6.75376478527741],
            [0.41243001006640717, -6.754597742901376],
            [0.4090331857626256, -6.760846773796282],
            [0.41197598204223324, -6.766122009232166],
            [0.4175319327269063, -6.7661762640411816],
            [0.41681239439803064, -6.769451526654962],
            [0.4204642256687451, -6.771979890081675],
            [0.42452989542549113, -6.771314466789595],
            [0.4238067782991553, -6.775473727628342],
            [0.42750439145388647, -6.7786881774898],
            [0.42674160200628036, -6.781186134366978],
            [0.421187569386841, -6.780313387689873],
            [0.41654655128897333, -6.777827466135548],
            [0.41543075332172164, -6.781249007636143],
            [0.4114852522772745, -6.781913029026281],
            [0.4117557645836127, -6.7866313678055485],
            [0.41572872390511295, -6.78843167461766],
            [0.4175542546620276, -6.793217632552998],
            [0.4259071369404514, -6.790486333549144],
            [0.4278190865531708, -6.796124070206357],
            [0.43185817123883424, -6.793058925513172],
            [0.42925356450598895, -6.78932352900304],
            [0.4355892033807963, -6.788577715410631],
            [0.4392726927844426, -6.783558478471548],
            [0.4452215613714886, -6.784175647500673],
            [0.4473928065058323, -6.787327859698486],
            [0.4462511454264056, -6.790890373875073],
            [0.451483875954906, -6.795349949465001],
            [0.4460964079461098, -6.803206467322209],
            [0.44988653770702947, -6.806704902745859],
            [0.4549494044069155, -6.807782047278186],
            [0.45238525067513524, -6.811493851056139],
            [0.4585277335378803, -6.8171069614511115],
            [0.4567033328169965, -6.822864831477891],
            [0.4596796182914741, -6.825021762962413],
            [0.4626069614392457, -6.834187255287271],
            [0.457553284277444, -6.833295239555825],
            [0.45226682403510127, -6.830252189786687],
            [0.4496790355852774, -6.838604033977518],
            [0.4472861691018929, -6.837576148912555],
            [0.4440403347557613, -6.845141432711937],
            [0.44115999969763037, -6.855129279343443],
            [0.4403918362739892, -6.863404732415135],
            [0.44322820962758663, -6.868148161582226],
            [0.44689323541523096, -6.86962016265469],
            [0.4522997447751138, -6.865818030385069],
            [0.4581158137116322, -6.860270023176859],
            [0.4603825849875207, -6.864331634792437],
            [0.4596562640306651, -6.8686304051763525],
            [0.462668981554982, -6.871979729812487],
            [0.46870509160975765, -6.874994652247296],
            [0.47294026361659264, -6.872582629164781],
            [0.4732035988291448, -6.869030907045519],
            [0.48295919227364603, -6.863737957075504],
            [0.48885344072344694, -6.864090423678287],
            [0.49069014448711656, -6.868804554156626],
            [0.4854145172290614, -6.869174177102504],
            [0.4824236490322958, -6.872511178859788],
            [0.48057869095544065, -6.878842874565358],
            [0.4753440489767289, -6.881061904619725],
            [0.47146196107545946, -6.892698167144444],
            [0.4683547263067982, -6.897832474313097],
            [0.47048605779578045, -6.901564137137354],
            [0.47387968493161736, -6.900855720272382],
            [0.47693736460920516, -6.904305822174889],
            [0.4819293370925085, -6.906905696314031],
            [0.4836823194354185, -6.919518205237801],
            [0.4863830401903095, -6.9219855605086185],
            [0.4833676907372952, -6.926541487785477],
            [0.4849274626684641, -6.929156675083428],
            [0.4838927536435024, -6.938878134572174],
            [0.4819083963871421, -6.944959029705506],
            [0.4777456080703871, -6.951061080221271],
            [0.48018463857150934, -6.956462764083701],
            [0.48236295731540335, -6.956627805102555],
            [0.48682913746878165, -6.952305352136452],
            [0.49133546764691033, -6.9529291102552175],
            [0.494994028695602, -6.951607649227703],
            [0.4981696364219073, -6.9589387960521885],
            [0.5033500706359112, -6.961246592274359],
            [0.5035024377980513, -6.964707237301679],
            [0.5161076720176734, -6.966818755930242],
            [0.5180384996025886, -6.970922199723535],
            [0.5226226952666734, -6.96863284913469],
            [0.5278670517257307, -6.975094443924865],
            [0.532699213046152, -6.9737864074350036],
            [0.5362455730497258, -6.975372521461056],
            [0.5425201118155967, -6.975070558968385],
            [0.5450630087052479, -6.973534668360046],
            [0.5501074363343472, -6.973964140850328],
            [0.5467655255781357, -6.9860529490509],
            [0.5525021715196627, -6.982458819955671],
            [0.5572772588899444, -6.98442145112476],
            [0.5599558961001195, -6.983116286736206],
            [0.5687680197558797, -6.98536744556393],
            [0.5705391768220608, -6.987365012819402],
            [0.5710582637468042, -6.993759657884544],
            [0.5747952325042711, -6.994843261266677],
            [0.565110409720627, -7.000374825335582],
            [0.5643786956311913, -7.004968397601686],
            [0.5677793746639569, -7.008232850659136],
            [0.5695508096567464, -7.002405803517704],
            [0.5733859311832002, -7.001307118936702],
            [0.576385963622181, -7.013341207401797],
            [0.5762702172352852, -7.02255506065147],
            [0.5727115341586655, -7.020885271281159],
            [0.5688215994780287, -7.023531958354675],
            [0.5690541048401765, -7.0290020800693505],
            [0.5673445625820815, -7.032091311754427],
            [0.5697577435286478, -7.037754797335257],
            [0.5650218112598733, -7.037361149931505],
            [0.5648629242616108, -7.040332656622127],
            [0.5679191529509627, -7.042052152945093],
            [0.5717517123504011, -7.0476607013713926],
            [0.5777828676595962, -7.0486501583941035],
            [0.5804913289769343, -7.053173330217982],
            [0.583354608286147, -7.0505348840306254],
            [0.5864475354537745, -7.044188158464893],
            [0.5903957922721098, -7.042792647277372],
            [0.5946066885176808, -7.044596027290329],
            [0.6032539662452787, -7.045032138951329],
            [0.6067477790796879, -7.04689391339785],
            [0.6126207398787343, -7.053717760036628],
            [0.616347513998755, -7.053908181734326],
            [0.6192591189264324, -7.059280747442102],
            [0.6256031004968415, -7.068401677107605],
            [0.6293147590781349, -7.069130703123647],
            [0.6329559692696318, -7.065372833882662],
            [0.6370892485950824, -7.065560450262762],
            [0.6394680414850028, -7.0586574452168955],
            [0.6410052789946862, -7.051082257806155],
            [0.6434476584241241, -7.053209821652205],
            [0.6504229685995858, -7.055919024464039],
            [0.6464815514524499, -7.064584058417352],
            [0.6425686128820473, -7.06855742318682],
            [0.6411458204544283, -7.077378629757454],
            [0.6382718649339786, -7.080133473162593],
            [0.6412172158887565, -7.08739612130245],
            [0.6419850456951742, -7.094174965813527],
            [0.6374533987132567, -7.102117098600112],
            [0.636084617300195, -7.108218559862626],
            [0.6370216461700351, -7.111407282736738],
            [0.6433608208009582, -7.114140763326545],
            [0.6426879667076041, -7.118113109239417],
            [0.6441134815997418, -7.121899405193893],
            [0.5789883274069513, -7.156768964117577],
            [0.5560354660106237, -7.168769435495444],
            [0.47015001602927353, -7.214691505811101],
            [0.3857108009760865, -7.260155451524808],
            [0.33906670985918796, -7.285116760899483],
            [0.3231238594084977, -7.2932590959405825],
            [0.31868193734305517, -7.29597965731616],
            [0.2625620521763206, -7.326029621551566],
            [0.25451465233613135, -7.311848168001639],
            [0.2503744999142482, -7.302768589526504],
            [0.21353802906180697, -7.239936499088426],
            [0.17718161914975794, -7.176529667713832],
            [0.14737038094618843, -7.1243134139597215],
            [0.14551866266344715, -7.121433472386726],
            [0.10661212896401748, -7.053671452525955],
            [0.07213028098020652, -6.99346708380276],
            [0.043453342428858795, -6.943778147047301],
            [0.14420631098096764, -6.885734892433052],
            [0.17997541735525627, -6.864815610811149],
            [0.25366297557120493, -6.822688043535242],
            [0.33406275572077343, -6.776639696991603],
            [0.41751379585690823, -6.7290584542462515]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -96.14911277261702, "lat": 31.70487698851124 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48161"],
        "coty_name": ["Freestone"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Freestone County"],
        "coty_fp_code": "161",
        "coty_gnis_code": "01383866"
      },
      "bbox": [
        0.043453342428858795, -7.326029621551566, 0.6504229685995858,
        -6.7290584542462515
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-4.523880890359155, -4.26527067083033],
            [-4.448323054707809, -4.270162520649849],
            [-4.348052868524908, -4.276446648474319],
            [-4.255501258826166, -4.282133405773372],
            [-4.0940379776562335, -4.292229658435438],
            [-4.101424683409307, -4.4153077410424455],
            [-4.104726080177498, -4.473990449073612],
            [-4.110887097258885, -4.584302677194296],
            [-4.1169106828761866, -4.695854736012979],
            [-4.121410943712244, -4.775667043140814],
            [-4.176947927896434, -4.772869542445425],
            [-4.262659945126497, -4.769108786645718],
            [-4.375013384757314, -4.764020925440806],
            [-4.460096593870179, -4.7596876012321525],
            [-4.551545772903932, -4.755174163443257],
            [-4.548373145238813, -4.697339602163298],
            [-4.542154039187142, -4.5874093658015385],
            [-4.539278351842119, -4.538103710426673],
            [-4.532658932287063, -4.4196397431164005],
            [-4.523880890359155, -4.26527067083033]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -101.82689820776127,
          "lat": 34.07049064690273
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48189"],
        "coty_name": ["Hale"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hale County"],
        "coty_fp_code": "189",
        "coty_gnis_code": "01383880"
      },
      "bbox": [
        -4.551545772903932, -4.775667043140814, -4.0940379776562335,
        -4.26527067083033
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-3.5639479038714, -3.882615497740889],
            [-3.4908854182761764, -3.886308475291284],
            [-3.405641832073186, -3.8907034702023706],
            [-3.397178278961373, -3.89125131183313],
            [-3.310332062731458, -3.89563308859941],
            [-3.2349833828751997, -3.8995691534607455],
            [-3.1666735740293515, -3.903023003416685],
            [-3.1334019207404613, -3.90454735699182],
            [-3.139292037893474, -4.03171467121739],
            [-3.142251072552923, -4.094951364160137],
            [-3.1492959060847636, -4.228936887176221],
            [-3.1552683881211325, -4.340397994391492],
            [-3.218315038192039, -4.337327509150369],
            [-3.236736172265214, -4.335995181717023],
            [-3.3240675957912247, -4.331714599876868],
            [-3.325224512255342, -4.332455346647469],
            [-3.4434596282863863, -4.326766268546912],
            [-3.58775738749559, -4.319906470854069],
            [-3.578205552803171, -4.1475303105313195],
            [-3.5706802894126928, -4.009461696225212],
            [-3.569978462281351, -3.9951254847492845],
            [-3.5639479038714, -3.882615497740889]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -100.68111659551617,
          "lat": 34.53078224600419
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48191"],
        "coty_name": ["Hall"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Hall County"],
        "coty_fp_code": "191",
        "coty_gnis_code": "01383881"
      },
      "bbox": [
        -3.58775738749559, -4.340397994391492, -3.1334019207404613,
        -3.882615497740889
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [0.030205911974445363, -5.927347008585061],
            [0.05404129053533335, -5.927821144726482],
            [0.07566207612228897, -5.927820111525723],
            [0.14205157989062087, -5.92730871617096],
            [0.1547731120921883, -5.927637161190799],
            [0.21532078498464274, -5.92756836451527],
            [0.21545256455078676, -5.900010739736999],
            [0.25446350113401817, -5.90095523366726],
            [0.2737719303825061, -5.900844416926541],
            [0.3237209640332012, -5.901874408757172],
            [0.3996023969205446, -5.903607723257616],
            [0.39974235509731, -5.918454701121824],
            [0.4000263485813459, -6.029364505440059],
            [0.40018636435771576, -6.091523844490708],
            [0.40015182502507557, -6.1512003519377885],
            [0.4003928951948953, -6.235280811281213],
            [0.40002850021182124, -6.2420761240454326],
            [0.40007397714897575, -6.361007549628027],
            [0.39996936577973047, -6.384573265121955],
            [0.36692925145223626, -6.384473308424163],
            [0.2993841108315927, -6.383739073370357],
            [0.2982747185863859, -6.387120895554299],
            [0.28943439419623573, -6.386833437792837],
            [0.2692184377423773, -6.387156724978113],
            [0.25390176472416864, -6.386834432541172],
            [0.25394352717233776, -6.383114720212291],
            [0.18620551177081424, -6.382776420013944],
            [0.08498046825425494, -6.382661779786971],
            [0.08366190057753826, -6.382546644984214],
            [0.0818854864367153, -6.380149217025977],
            [0.08873944859232272, -6.372191027567468],
            [0.08788406761111404, -6.368501966682255],
            [0.09046837225043271, -6.362902397596737],
            [0.09637096353735589, -6.362729762889004],
            [0.09510602736171778, -6.3587330160072115],
            [0.09883736909692044, -6.35209601421823],
            [0.09647976645218638, -6.347937282160171],
            [0.09439580498695359, -6.34115451740071],
            [0.09698848462406724, -6.337631838403689],
            [0.09573329492998388, -6.3290828098409975],
            [0.09321355254412096, -6.324769002271199],
            [0.08653189246740978, -6.319163393277736],
            [0.08534518596024797, -6.316618369824046],
            [0.08000990881053732, -6.316838893354725],
            [0.07511860132233664, -6.314509761658708],
            [0.06873031518608655, -6.309586484771232],
            [0.06334960727137165, -6.307083262915407],
            [0.05732728936537702, -6.297012604539918],
            [0.057282747853235824, -6.2896572681066845],
            [0.05432755529486856, -6.290039039780754],
            [0.04942264974520211, -6.284829498265011],
            [0.048478506308783725, -6.281159423535823],
            [0.049665167714929154, -6.27406692395873],
            [0.04279065284863706, -6.2704547765994265],
            [0.04074394744551802, -6.263914871204013],
            [0.03678034766834012, -6.260406338848173],
            [0.03592943246726876, -6.257500993304674],
            [0.042424931305059685, -6.253708902208645],
            [0.037013095192833786, -6.249121040779091],
            [0.03979283136274732, -6.243012024738947],
            [0.03691104626525265, -6.239413988509691],
            [0.035123855993651164, -6.232270815179358],
            [0.039048806748739784, -6.227848085325615],
            [0.04098435158318675, -6.217453294456872],
            [0.036647378652726575, -6.214584054220764],
            [0.03586585292625665, -6.210723858283194],
            [0.03804263513271175, -6.207855142753459],
            [0.03278335650450902, -6.204666763661965],
            [0.03173961997974107, -6.2088211801100055],
            [0.028505701238371373, -6.209491519307476],
            [0.027426169896259112, -6.205632552773992],
            [0.024436552964968782, -6.2044434860310895],
            [0.024911214726915026, -6.200629915168277],
            [0.0201065087533537, -6.200570468504786],
            [0.019756620853350202, -6.195693515281385],
            [0.025254882584007137, -6.195789776993351],
            [0.027118282754772897, -6.096158642815204],
            [0.028089985312785067, -6.056846892947967],
            [0.028134652477501704, -6.040841397300004],
            [0.02933767435602069, -5.986513583888875],
            [0.030205911974445363, -5.927347008585061]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -96.28778063890088,
          "lat": 32.599279803286336
        },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48257"],
        "coty_name": ["Kaufman"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Kaufman County"],
        "coty_fp_code": "257",
        "coty_gnis_code": "01383914"
      },
      "bbox": [
        0.019756620853350202, -6.387156724978113, 0.4003928951948953,
        -5.900010739736999
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-1.719740393723106, -7.479171075945969],
            [-1.6914820308843463, -7.460290698044473],
            [-1.580338908319723, -7.385268509063618],
            [-1.501211070275909, -7.332217996630552],
            [-1.463338222251546, -7.3063420616185955],
            [-1.4668317495657066, -7.300406086357384],
            [-1.4483560517451624, -7.2891779817492255],
            [-1.3883452509449343, -7.255097395834657],
            [-1.3461593830123157, -7.3302667059528615],
            [-1.3039616545913015, -7.405410749875322],
            [-1.2526529176213348, -7.495834593815278],
            [-1.245310167885544, -7.508586523632856],
            [-1.2146083483551606, -7.563424081582236],
            [-1.199874723117063, -7.589078265445129],
            [-1.1817118474643307, -7.621189258183438],
            [-1.164463920819545, -7.652360549088659],
            [-1.1702939925681488, -7.655717017368162],
            [-1.1690746435580968, -7.686440901837641],
            [-1.242066581882809, -7.685871977128879],
            [-1.244773197702437, -7.686030337866654],
            [-1.3296381840030238, -7.68518952918868],
            [-1.3631748901743737, -7.685036985499202],
            [-1.4526991099078659, -7.683983495951199],
            [-1.5343091837604055, -7.682945052471808],
            [-1.6201193103328129, -7.681538523503276],
            [-1.6242866098795157, -7.6725786526534305],
            [-1.6274126287041046, -7.668918707648535],
            [-1.6316702910550998, -7.6664031550960665],
            [-1.640812961613239, -7.663175159034086],
            [-1.650301129740228, -7.65719220340451],
            [-1.6555939348194435, -7.651217231487282],
            [-1.656890525086225, -7.643181103722866],
            [-1.650621092246369, -7.640447954533321],
            [-1.6473335099240236, -7.634814648030292],
            [-1.638574399334513, -7.635005305319233],
            [-1.6327582361820736, -7.631526014749695],
            [-1.6330992697759963, -7.624563516112894],
            [-1.6347521933602231, -7.621805628695189],
            [-1.6431788187779326, -7.618823795312531],
            [-1.6435094648999828, -7.614304206806554],
            [-1.6368303776428432, -7.609970780306643],
            [-1.63136402897407, -7.603170495196259],
            [-1.631580152761341, -7.600425329008636],
            [-1.635786098604151, -7.599606208715407],
            [-1.6403796818565741, -7.6035210384060266],
            [-1.6457030345660515, -7.60308550551354],
            [-1.6516364638001952, -7.592780308628303],
            [-1.6538866585542717, -7.591618815267202],
            [-1.658635252609664, -7.596439001785221],
            [-1.6638069146412213, -7.591937373033874],
            [-1.670250680337626, -7.5934159461443365],
            [-1.6731548425823228, -7.600389376355338],
            [-1.679666339438469, -7.603766451458775],
            [-1.6855456876090267, -7.617134976454472],
            [-1.6900578192986027, -7.620810213801803],
            [-1.6931187089647919, -7.618950025840435],
            [-1.6950265890280123, -7.61482725812345],
            [-1.6961354964994402, -7.6069065423039515],
            [-1.7009944104416552, -7.5991768733261535],
            [-1.7018166340571685, -7.5959816362656225],
            [-1.707319912904284, -7.5899691756562495],
            [-1.7103708768833534, -7.584992405590407],
            [-1.7079690456227747, -7.5794987970328425],
            [-1.702288803062286, -7.578157106247665],
            [-1.6956960940711507, -7.575056245683808],
            [-1.6916707195846308, -7.569530203774079],
            [-1.6934261248233597, -7.557518540336377],
            [-1.6910622307359042, -7.554194936468024],
            [-1.68132584618138, -7.5558061872353175],
            [-1.6779004064575425, -7.555206475366645],
            [-1.6713554695099744, -7.5471181647753705],
            [-1.6730423161997343, -7.54321436738493],
            [-1.6813316201923039, -7.545670886383381],
            [-1.68603280001303, -7.5444160176724795],
            [-1.691671784878225, -7.537739968625644],
            [-1.6951278629805238, -7.536074544796015],
            [-1.7035956350816022, -7.535279236668444],
            [-1.7057643067457393, -7.5310910851081605],
            [-1.6977633300202835, -7.524145306168724],
            [-1.7000510668045263, -7.518648335676467],
            [-1.7046768596111035, -7.515175009850542],
            [-1.7119924102623516, -7.517354960186849],
            [-1.7180491497820336, -7.516505784675447],
            [-1.7252968752180877, -7.511485324717341],
            [-1.7263660698713985, -7.506038833511464],
            [-1.7242177134392929, -7.497514610323809],
            [-1.720655900829143, -7.488287376560028],
            [-1.719740393723106, -7.479171075945969]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -98.24145440517572, "lat": 31.19621396545213 },
        "year": "2023",
        "ste_code": ["48"],
        "ste_name": ["Texas"],
        "coty_code": ["48281"],
        "coty_name": ["Lampasas"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Lampasas County"],
        "coty_fp_code": "281",
        "coty_gnis_code": "01383927"
      },
      "bbox": [
        -1.7263660698713985, -7.686440901837641, -1.164463920819545,
        -7.255097395834657
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-11.223781469789051, 3.0792530512968734],
            [-11.220957858386543, 3.0810419519374777],
            [-11.210442546620051, 3.082935526365606],
            [-11.203749170807875, 3.0878875428330304],
            [-11.199552655737033, 3.087623646606056],
            [-11.188098968333733, 3.0795472770312764],
            [-11.184699960789509, 3.0713348434219534],
            [-11.185282157795818, 3.067532745406906],
            [-11.18120864285224, 3.064706898101185],
            [-11.174118442901749, 3.057414550594909],
            [-11.165570645029575, 3.055097622593531],
            [-11.16515596464709, 3.0509431898386725],
            [-11.15868511782045, 3.049959922484573],
            [-11.152522206126585, 3.051142916462608],
            [-11.144843479106852, 3.0513010735745176],
            [-11.13968790410215, 3.0552455223582227],
            [-11.134896385301477, 3.0571853166982765],
            [-11.132740910357544, 3.0634578217711144],
            [-11.129661063927022, 3.065249723208854],
            [-11.12902840797322, 3.070275368377612],
            [-11.126448748268146, 3.0723435049906636],
            [-11.129024355678428, 3.0777517744357525],
            [-11.128295736062157, 3.084510838311006],
            [-11.123144272500966, 3.085238459843208],
            [-11.119234930407895, 3.088996550304238],
            [-11.108443373263087, 3.1043941616753354],
            [-11.104972811334111, 3.1118770657646238],
            [-11.10080317803899, 3.1149856462144405],
            [-11.096164157779715, 3.11497736334216],
            [-11.094509688400304, 3.118772467363212],
            [-11.094988524710477, 3.1251034204820223],
            [-11.096933047448212, 3.134055613414027],
            [-11.102253205861055, 3.141468206816534],
            [-11.104257669228094, 3.146868079046824],
            [-11.10409611189063, 3.151799877546482],
            [-11.108057371628398, 3.1603071770554227],
            [-11.110361340679338, 3.1614226647364183],
            [-11.109535834959418, 3.16862591454929],
            [-11.107483992877205, 3.1728284621085074],
            [-11.110521520558704, 3.177220749927371],
            [-11.111031614042837, 3.1810301644254606],
            [-11.116713048086211, 3.184344347266465],
            [-11.120936843189154, 3.184921089408024],
            [-11.118982142894373, 3.1891984157967017],
            [-11.11605683018641, 3.2039097630512026],
            [-11.11269217652919, 3.2109272945407548],
            [-11.11235615492946, 3.2189553102294397],
            [-11.11857339022566, 3.2243764343958237],
            [-11.125419203100304, 3.2219520213077053],
            [-11.132146452851698, 3.222447377107145],
            [-11.136475656071518, 3.2284815379241105],
            [-11.142316760790328, 3.2296828412188696],
            [-11.147309639469778, 3.2320089242197936],
            [-11.150705074315374, 3.230028649547494],
            [-11.155116662164156, 3.2343410310888836],
            [-11.157032946394548, 3.2385883471636667],
            [-11.15463205961623, 3.251314279159492],
            [-11.157830787070024, 3.259616345129796],
            [-11.156808164247362, 3.264836039224128],
            [-11.151738417643902, 3.2687756741515446],
            [-11.146043894872262, 3.267437106627414],
            [-11.136684950636624, 3.273003953484714],
            [-11.131075431736594, 3.2783881161632964],
            [-11.12798099019293, 3.2798530544792412],
            [-11.123877684610669, 3.2849145707175897],
            [-11.122423058729417, 3.288848700553909],
            [-11.125006502963462, 3.2912488531788036],
            [-11.121781304978713, 3.3004585095137817],
            [-11.117941473349685, 3.3034616770265655],
            [-11.11494295647339, 3.303730662025372],
            [-11.10928525667591, 3.31174073072111],
            [-11.102183771659833, 3.316534321164595],
            [-11.094642655764087, 3.3205032063344024],
            [-11.085482631715282, 3.32185006374676],
            [-11.082056360336168, 3.3254560697303215],
            [-11.077179738260535, 3.3239416999556815],
            [-11.07194301210245, 3.324833081101967],
            [-11.069423699499348, 3.3213102338303204],
            [-11.055152898279093, 3.323021580101924],
            [-11.050837775465183, 3.327722369355496],
            [-11.04729554313484, 3.3294215654403696],
            [-11.040574750365947, 3.3304492975875335],
            [-11.03749158166126, 3.334457844573293],
            [-11.033157090631327, 3.336838751505111],
            [-11.024444036998606, 3.3336404548289886],
            [-11.021627442987898, 3.3339305282417646],
            [-11.0168666631821, 3.3317049614120045],
            [-11.016962569485914, 3.3285007005826186],
            [-11.013016422756214, 3.3252591304858083],
            [-11.00481515649285, 3.326160516662079],
            [-10.999530461278697, 3.3304892267848167],
            [-10.993546807858083, 3.329822032289887],
            [-10.990896173262975, 3.33327137297883],
            [-10.98411592466184, 3.3337814657746105],
            [-10.983232469680525, 3.3436992003476598],
            [-10.98068738006973, 3.3448549549740907],
            [-10.978547866772008, 3.3541098736493993],
            [-10.976177652991504, 3.3581587721679167],
            [-10.97200167065158, 3.360777525763526],
            [-10.969154785859113, 3.364628540342589],
            [-10.969599760326924, 3.367126999969831],
            [-10.967292434956102, 3.3743677675428265],
            [-10.95368998483626, 3.372650870541812],
            [-10.951632904867472, 3.3710437708936922],
            [-10.947406706378878, 3.3745435859829325],
            [-10.945093903035817, 3.3743838653102527],
            [-10.939919425880886, 3.3785925390314113],
            [-10.934518961522592, 3.3771505814239284],
            [-10.930876671171418, 3.3714651366588275],
            [-10.925099002841897, 3.368538334874447],
            [-10.922372329555358, 3.368707867905648],
            [-10.916562537879209, 3.3739702828327762],
            [-10.912079259446614, 3.3752359738455717],
            [-10.9092263885346, 3.378665518821374],
            [-10.896948156781285, 3.3763012175347225],
            [-10.889561791330529, 3.3766050140452064],
            [-10.888334165938055, 3.373370296082834],
            [-10.874301815197414, 3.3753132729887994],
            [-10.87233108165349, 3.371738724239039],
            [-10.866042701861112, 3.3716197705128783],
            [-10.860345815313039, 3.3754483449700565],
            [-10.857300950527817, 3.37928384786524],
            [-10.843281522318392, 3.3877129443550715],
            [-10.83507560556476, 3.3901174104685046],
            [-10.828779267616925, 3.3928696717086853],
            [-10.819572077126232, 3.3920769706947502],
            [-10.81247002242858, 3.396883347419044],
            [-10.807783902682411, 3.396061278283372],
            [-10.80377880811458, 3.398878676560845],
            [-10.791313519754004, 3.4046483067749813],
            [-10.791383222873357, 3.407973060191124],
            [-10.781107191754133, 3.4136996584416104],
            [-10.78240963452668, 3.423300363268642],
            [-10.773641771916145, 3.4239878252518112],
            [-10.764226132548988, 3.42845253684332],
            [-10.758879615511653, 3.4204855034080937],
            [-10.755373771931788, 3.424439565220811],
            [-10.747895325789676, 3.4370212638355135],
            [-10.74040794727047, 3.4447570172661837],
            [-10.734279343225202, 3.4527957108403307],
            [-10.724935019586121, 3.4583170563145322],
            [-10.71974478737603, 3.4589014467300303],
            [-10.711381273537787, 3.4576535933130446],
            [-10.72662032966022, 3.3626749712446173],
            [-10.751826998256716, 3.2055539859608855],
            [-10.62280747701241, 3.184440520515068],
            [-10.53316231276618, 3.169913326128231],
            [-10.506837657521542, 3.165296477642414],
            [-10.377241535326565, 3.1452218166728487],
            [-10.34855963881364, 3.1391822968128413],
            [-10.256036263351195, 3.1252436885990353],
            [-10.16335239739199, 3.112363147647572],
            [-10.153933148089273, 3.1102688247926493],
            [-10.070758524146637, 3.098926857059707],
            [-10.067663375503251, 3.099025127996892],
            [-10.013437520958417, 3.091403348659782],
            [-9.98231258624934, 3.087047720782087],
            [-9.978096430940214, 3.085951609559799],
            [-10.005284366394816, 2.902989290706283],
            [-10.016525315491986, 2.9054981276977765],
            [-10.019417850174587, 2.9102528696715226],
            [-10.022779226747042, 2.9126141988648837],
            [-10.031423824849448, 2.9115815321354757],
            [-10.035591603349147, 2.9145368505723868],
            [-10.043046644980127, 2.9074470362662153],
            [-10.052488181405476, 2.9105464763023945],
            [-10.061395163206084, 2.9076214811016983],
            [-10.07071988774264, 2.9100501950861446],
            [-10.081965077939971, 2.908528344967964],
            [-10.08787996658026, 2.9130666842066946],
            [-10.093615816384482, 2.9134277866239295],
            [-10.097337174896401, 2.915341651435316],
            [-10.09847515943603, 2.9181423937415794],
            [-10.107466493325074, 2.91539139438797],
            [-10.11339432753881, 2.9189481972649447],
            [-10.114280743374284, 2.922950040092909],
            [-10.121522430666268, 2.9277860306366748],
            [-10.127990341250577, 2.9275998291205747],
            [-10.131315170724532, 2.924922941681995],
            [-10.139204891923841, 2.9295668433046442],
            [-10.142714473071258, 2.9344143317844535],
            [-10.153955009855496, 2.933455435492049],
            [-10.159098403722528, 2.9387380014718767],
            [-10.162877855095958, 2.940458650456586],
            [-10.167216922388624, 2.9392855666242057],
            [-10.171802431560883, 2.9420091279115663],
            [-10.172431056232474, 2.945407986061886],
            [-10.179366856385021, 2.9437875957369957],
            [-10.185953591709056, 2.9493653819394434],
            [-10.191596917975552, 2.9502810406276283],
            [-10.195700867007346, 2.952989674002214],
            [-10.203090134497023, 2.9519707730501867],
            [-10.210557697390522, 2.9488864358170366],
            [-10.21758220662755, 2.950008933677285],
            [-10.219265513729118, 2.9551194831066963],
            [-10.222107571373316, 2.9547876759132925],
            [-10.226538554346208, 2.9490786686466497],
            [-10.23608747112337, 2.9477136340891823],
            [-10.237750711424423, 2.9461279998497276],
            [-10.246876253605414, 2.945127976226084],
            [-10.25764442874825, 2.9507068590897396],
            [-10.265193536932225, 2.9438361077028032],
            [-10.26447688581199, 2.9367955539732202],
            [-10.267941020047425, 2.931493511265866],
            [-10.275006715282947, 2.925813988099798],
            [-10.280159396975868, 2.9227220828324922],
            [-10.29001646159467, 2.9187734727374623],
            [-10.302981373708738, 2.9209809690312776],
            [-10.309474137929413, 2.9188338728526237],
            [-10.314363193590749, 2.9196215528047404],
            [-10.323128058142816, 2.928681019516249],
            [-10.325486544271278, 2.9262137976174634],
            [-10.331316249517734, 2.9160032672389504],
            [-10.3355255568152, 2.9169269363638772],
            [-10.34054703238516, 2.9203156699246935],
            [-10.346707257008658, 2.9215772381297427],
            [-10.34887173690125, 2.9235684979112255],
            [-10.35254082379026, 2.9180448963467676],
            [-10.358465671469697, 2.914357741801925],
            [-10.361864054207633, 2.914123412299962],
            [-10.367580044374108, 2.9182198491101414],
            [-10.37144951728386, 2.924069541377725],
            [-10.375869985758452, 2.918356405298233],
            [-10.381051649742426, 2.9138078454208096],
            [-10.387512271901851, 2.9117784826028816],
            [-10.39118995362379, 2.9119053393961356],
            [-10.401539074076558, 2.909701294960021],
            [-10.403354001655593, 2.9110291645095545],
            [-10.407180129443667, 2.9203049405351984],
            [-10.411982778425754, 2.92131846403091],
            [-10.416802409571867, 2.924489402181609],
            [-10.422322956600285, 2.9156092288071447],
            [-10.43036017875805, 2.9104448714444486],
            [-10.436104676974463, 2.9097625036634005],
            [-10.44098496169419, 2.9107419943263535],
            [-10.443745950810685, 2.913231177596575],
            [-10.445323076658788, 2.9176616778009192],
            [-10.449649701658105, 2.9174830939965033],
            [-10.45456555448329, 2.9141454973557654],
            [-10.458183068093549, 2.9138078322737195],
            [-10.463926937400979, 2.916318884330436],
            [-10.471514873959386, 2.924289739420323],
            [-10.472720544723781, 2.927781906884775],
            [-10.475865753232402, 2.9292699685711807],
            [-10.482428951880399, 2.926171104110555],
            [-10.48357791673862, 2.9236582672056457],
            [-10.49031080039883, 2.916585435560302],
            [-10.493762350491386, 2.915705983362864],
            [-10.495402482725378, 2.9104539856095024],
            [-10.5033968570806, 2.9037753088938687],
            [-10.511791887016596, 2.906527655814223],
            [-10.517884147533652, 2.9046823425563746],
            [-10.523119187549113, 2.907703365208729],
            [-10.528282292111664, 2.9089123188567214],
            [-10.531644962520257, 2.9144909798211813],
            [-10.53425569660077, 2.915605935445911],
            [-10.54224347697604, 2.9224927304077446],
            [-10.548470922492495, 2.91954673788302],
            [-10.550906293280406, 2.916476644575238],
            [-10.555707264823242, 2.9168819332098614],
            [-10.559590155965495, 2.9191995298704585],
            [-10.566726041232583, 2.9181767554486537],
            [-10.57200345649902, 2.9220402855049556],
            [-10.577142302617357, 2.918038458719124],
            [-10.584578618925505, 2.917563918206968],
            [-10.584419999591784, 2.913101039861886],
            [-10.59227933126222, 2.9085447399199063],
            [-10.598726203314966, 2.9091503077540537],
            [-10.608407063686386, 2.8984867552838174],
            [-10.614811450980357, 2.8937766853876954],
            [-10.619200132602419, 2.8925867713759015],
            [-10.631765849089401, 2.8934424340552036],
            [-10.636823355677707, 2.90193449967977],
            [-10.642123551586888, 2.904771224730292],
            [-10.647315620855117, 2.9109686317575028],
            [-10.652911147634676, 2.908707292303483],
            [-10.659391030244079, 2.909231761888729],
            [-10.667455874540991, 2.917255902470134],
            [-10.674900127000605, 2.917056901714284],
            [-10.680384703150885, 2.917903686715902],
            [-10.682451230042766, 2.914770708902641],
            [-10.678232606411907, 2.9107419319530172],
            [-10.676686528931299, 2.9064801857272156],
            [-10.68508962946138, 2.9046394427100393],
            [-10.689022705573144, 2.8997971594187226],
            [-10.691501958404865, 2.898656823497426],
            [-10.69274994009187, 2.8913020663814653],
            [-10.694839133342388, 2.8872150517549184],
            [-10.693395481056525, 2.8808149829442655],
            [-10.694531078596155, 2.8744774051362105],
            [-10.701440656578272, 2.8753657445691028],
            [-10.711769618326846, 2.8750830080386707],
            [-10.718271246877675, 2.8763419473026492],
            [-10.722994762053876, 2.8719194890639494],
            [-10.727591319688154, 2.8699311051889267],
            [-10.732634168760429, 2.859231746676788],
            [-10.731219765519665, 2.853684480979102],
            [-10.734122874556853, 2.8400806173208677],
            [-10.737501857684437, 2.8365735387873627],
            [-10.739944060844728, 2.8308321523923814],
            [-10.744200906511644, 2.8275530535516817],
            [-10.750403133251108, 2.815032684133332],
            [-10.750199940672172, 2.8072345816845417],
            [-10.753190696613476, 2.803137730989201],
            [-10.761535542260562, 2.7971849273320406],
            [-10.76343565327235, 2.7945596864056745],
            [-10.768180359619357, 2.793392894221162],
            [-10.776284352264522, 2.796010255978448],
            [-10.786815325898264, 2.797899480609398],
            [-10.794147913627773, 2.795089230402854],
            [-10.796466801219848, 2.7897715828844705],
            [-10.802451953124887, 2.7848070094240267],
            [-10.807357643678609, 2.784015066504867],
            [-10.816050940410932, 2.787780698168512],
            [-10.81928413723483, 2.790560218487344],
            [-10.824578333017723, 2.7927943489768934],
            [-10.834313334596892, 2.802198500832333],
            [-10.837291477244785, 2.8066390944851536],
            [-10.840039064881866, 2.8081953472551646],
            [-10.847422355897864, 2.8069748375037196],
            [-10.851927796277373, 2.8092545065785903],
            [-10.860619495442128, 2.8109914277969867],
            [-10.871736702543933, 2.809090730703704],
            [-10.876822586205327, 2.8012224337630944],
            [-10.881370416592425, 2.798291446010546],
            [-10.883532324818443, 2.792633006085657],
            [-10.886544053083622, 2.7886588592185175],
            [-10.888899428305775, 2.7791251257917198],
            [-10.897859944774678, 2.7715912162403904],
            [-10.901142057180309, 2.7708426053417434],
            [-10.908846367203719, 2.774840764343353],
            [-10.91063266917163, 2.7809284414862794],
            [-10.915956452280142, 2.783940779563824],
            [-10.922101885549482, 2.78483654619633],
            [-10.926629089235053, 2.792091515727466],
            [-10.929423944374221, 2.7949418316776584],
            [-10.93418673404686, 2.7960529304423454],
            [-10.940755207070163, 2.8006467049375425],
            [-10.943816967380066, 2.8044786148232426],
            [-10.949135404336877, 2.8050793223702066],
            [-10.955464623403842, 2.8104259935456577],
            [-10.961121185155438, 2.8103076286744137],
            [-10.97112123288275, 2.8162979188132966],
            [-10.97379122538507, 2.819988449873525],
            [-10.979627012355646, 2.823193147261025],
            [-10.98814077375612, 2.833215009415655],
            [-10.992936296799472, 2.835617701195656],
            [-10.996310009198039, 2.8396356012507042],
            [-10.997694411767176, 2.847464727212682],
            [-11.000716355702897, 2.848228242969128],
            [-11.004510861552491, 2.8462992232113122],
            [-11.006594720692105, 2.851250604556406],
            [-11.011593780309298, 2.858310320447522],
            [-11.016433244366048, 2.8608138939715535],
            [-11.01908453264597, 2.8660079523582334],
            [-11.024453283515317, 2.866592560101656],
            [-11.036431929059168, 2.8709504654389018],
            [-11.041879202775439, 2.8768548010902917],
            [-11.04760439627479, 2.8784097847244587],
            [-11.053739280937679, 2.8815998505093017],
            [-11.053152142857202, 2.8916397731097576],
            [-11.056211674026713, 2.895818184814222],
            [-11.055642612239602, 2.901094261171856],
            [-11.058840484927046, 2.9034438408142966],
            [-11.058638480560955, 2.908290825844665],
            [-11.06047482326605, 2.911237038839448],
            [-11.059596051862172, 2.921714875837465],
            [-11.057260914406111, 2.9282631999763558],
            [-11.059605612518471, 2.9349381114193007],
            [-11.05817618835349, 2.941193112514697],
            [-11.062391504251645, 2.9419668304223783],
            [-11.066502934359574, 2.938010419986357],
            [-11.073459894647435, 2.9342893361787734],
            [-11.081774044011363, 2.935735994553954],
            [-11.084183946209533, 2.9402935357614934],
            [-11.091597911006064, 2.9405000263015846],
            [-11.09241536447022, 2.930200887459878],
            [-11.089567447548205, 2.920530884919908],
            [-11.093525103773505, 2.9169942952372336],
            [-11.101458724323557, 2.9167300957476905],
            [-11.1066337311227, 2.911467143878685],
            [-11.113942550655706, 2.9115050740973256],
            [-11.117661318845506, 2.904577880109508],
            [-11.123491586485319, 2.905583976256438],
            [-11.125311637396443, 2.903931678768988],
            [-11.128497687132384, 2.8958249884883163],
            [-11.127400043907528, 2.8934081573591777],
            [-11.131550223731136, 2.888008708404496],
            [-11.13874593853645, 2.883420720732136],
            [-11.139415986795544, 2.8782984977729007],
            [-11.137514777698375, 2.871165526841861],
            [-11.140912087069493, 2.8643622511046867],
            [-11.144017197503667, 2.862432032812318],
            [-11.15126779729343, 2.870416692571332],
            [-11.159318498506014, 2.8723313932377685],
            [-11.165560713137042, 2.876246684236077],
            [-11.168910782045227, 2.876270188152921],
            [-11.170674630850083, 2.879692998459155],
            [-11.179408878276634, 2.8823128669013918],
            [-11.184853647520288, 2.8799673909217045],
            [-11.189929205423235, 2.880070094715413],
            [-11.193401972805983, 2.8856348228588447],
            [-11.19144579142618, 2.8908216874113752],
            [-11.198142071577932, 2.895687145458487],
            [-11.198285956178111, 2.9019607184034757],
            [-11.203320381676782, 2.907204952584712],
            [-11.202337868138265, 2.916080918796657],
            [-11.203476889317653, 2.9190513701943237],
            [-11.208856611506482, 2.924418530955613],
            [-11.213105062483162, 2.9271312698016954],
            [-11.213893860456926, 2.935543345852809],
            [-11.215784847293559, 2.940344557113611],
            [-11.218558412709887, 2.9432651059632753],
            [-11.216045258966316, 2.9485037695989473],
            [-11.213553820188547, 2.9609604082014065],
            [-11.210378056224606, 2.967928137074776],
            [-11.204435770956625, 2.9741586589074953],
            [-11.204748999723105, 2.9779450903723665],
            [-11.212690241641011, 2.9910628625734708],
            [-11.217342342107788, 2.9969825517021746],
            [-11.216799810284552, 3.0020995757428466],
            [-11.214969005216213, 3.005323835346323],
            [-11.22150721748405, 3.0085821348388087],
            [-11.219517210280303, 3.01606985642163],
            [-11.221389657858515, 3.0187159129624312],
            [-11.214966843326538, 3.0241891066570026],
            [-11.218266052677716, 3.032193232262102],
            [-11.215897685942341, 3.0363909106341676],
            [-11.218438645881026, 3.039669289528911],
            [-11.222156697683753, 3.0400638099552424],
            [-11.226870733848566, 3.044005923970128],
            [-11.22612825025917, 3.0482655706940873],
            [-11.228649792342036, 3.051829081427117],
            [-11.233974592558555, 3.0549297637493438],
            [-11.230242862239024, 3.0600205800012095],
            [-11.23051160752432, 3.0631952158160165],
            [-11.227399443548153, 3.0666002121308256],
            [-11.230580642711935, 3.073561479874835],
            [-11.228027666109368, 3.078574061060209],
            [-11.223781469789051, 3.0792530512968734]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -110.95579973850225,
          "lat": 40.86827335535393
        },
        "year": "2023",
        "ste_code": ["49"],
        "ste_name": ["Utah"],
        "coty_code": ["49043"],
        "coty_name": ["Summit"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Summit County"],
        "coty_fp_code": "043",
        "coty_gnis_code": "01448035"
      },
      "bbox": [
        -11.233974592558555, 2.7708426053417434, -9.978096430940214,
        3.4589014467300303
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.50705729403936, 7.505847772069287],
            [16.537887428161646, 7.509103332207416],
            [16.564480017184675, 7.518965354296292],
            [16.58736439303138, 7.527765591084073],
            [16.61045122080564, 7.538383641464899],
            [16.61690511454542, 7.540892570039993],
            [16.66435274771099, 7.562543149444333],
            [16.670751828378123, 7.565655861324774],
            [16.67208757909472, 7.561980005111411],
            [16.707855963496833, 7.576277204969165],
            [16.700770615033374, 7.593372758224948],
            [16.73368334672151, 7.592509729928339],
            [16.756233851897992, 7.5328468965421544],
            [16.78227503183799, 7.467528641870084],
            [16.7945161876359, 7.471979219008677],
            [16.797622201275264, 7.465233757032749],
            [16.81949312193353, 7.40830810727722],
            [16.82846626301226, 7.387102030787466],
            [16.84184886577681, 7.392210490555151],
            [16.878565010566323, 7.387734086033986],
            [16.96000514269131, 7.376220700048738],
            [16.956038301127354, 7.357161693830175],
            [16.942435853658115, 7.302733076970489],
            [16.937786089587206, 7.284570207444768],
            [16.9355894485848, 7.274204933831414],
            [16.930764002077826, 7.274774232485357],
            [16.915107572997673, 7.192769647788145],
            [16.908327511890185, 7.193566683039043],
            [16.897308253151262, 7.2305713893916215],
            [16.881432029893848, 7.216464025720735],
            [16.850646553814876, 7.1904664693953775],
            [16.829910980094493, 7.1936565348431705],
            [16.834419950300227, 7.175311146841014],
            [16.838859645883556, 7.179274495376102],
            [16.85783379713741, 7.14217415640871],
            [16.83988281025179, 7.126005854245075],
            [16.822930463452696, 7.11184783863781],
            [16.807167659415896, 7.146243066119322],
            [16.80231988177821, 7.147160687284463],
            [16.80390629437974, 7.150141334822969],
            [16.751362176531003, 7.1347770119958795],
            [16.716899620211063, 7.124405622822734],
            [16.71794624624464, 7.121944047418678],
            [16.674287310295778, 7.108905209644645],
            [16.699922307924336, 7.042791653456804],
            [16.683380065828555, 7.036473089848232],
            [16.59369933138028, 7.003159998060776],
            [16.596935478439434, 7.015206888130045],
            [16.59789161853208, 7.02340826927932],
            [16.59384779886077, 7.027337645188328],
            [16.589716105458585, 7.035788905350227],
            [16.585243476318265, 7.039098095303555],
            [16.573532601612982, 7.045049805044073],
            [16.569160004100308, 7.053953741718329],
            [16.56527150864994, 7.057973794964955],
            [16.55939150346686, 7.060722388084385],
            [16.556539613612305, 7.064983138445782],
            [16.557170494803877, 7.075600728285725],
            [16.5605635336882, 7.0814523105426375],
            [16.56375747988856, 7.0843147785199685],
            [16.565379252939778, 7.090836148926981],
            [16.5575510281508, 7.0964311110517135],
            [16.555629724711906, 7.102736665270816],
            [16.557226326749436, 7.118423940142755],
            [16.55426684852433, 7.123994049028384],
            [16.54673539733991, 7.133106847312393],
            [16.53523348420735, 7.142734210788473],
            [16.528401066040466, 7.155443416844371],
            [16.519302188210133, 7.169534784001336],
            [16.517684793195905, 7.185418660462113],
            [16.512406315877406, 7.203109975793897],
            [16.50537901496644, 7.214395239417815],
            [16.502556538043265, 7.245993280730847],
            [16.50142000422044, 7.250579910172317],
            [16.495561438250604, 7.260148042028212],
            [16.492453115414147, 7.26204598197542],
            [16.485592945724928, 7.26370962741786],
            [16.481035738690093, 7.267684388843632],
            [16.473694826738896, 7.270910138958387],
            [16.472523095133, 7.273115699142031],
            [16.472171468527346, 7.2919211164433175],
            [16.470318032960364, 7.307824978254805],
            [16.474581638499814, 7.329337911960827],
            [16.474928006240287, 7.343003312728261],
            [16.473498990983952, 7.347630257432169],
            [16.467080034544182, 7.361739661778362],
            [16.468708524086033, 7.367249128386499],
            [16.470846754796234, 7.369347784022415],
            [16.473302707204272, 7.376575560956839],
            [16.47297390662998, 7.386192100241025],
            [16.471967566881677, 7.393036859404506],
            [16.47327270507033, 7.3973166701532485],
            [16.47069136634418, 7.402300131319017],
            [16.470759392361657, 7.406604869475464],
            [16.47377771017703, 7.4129241186139465],
            [16.471131467633015, 7.420296137965728],
            [16.47196366306136, 7.423819057995311],
            [16.474900945472964, 7.4253853244761725],
            [16.47515527053232, 7.429561604221375],
            [16.4793546729921, 7.433325480935707],
            [16.481449950858476, 7.438618303177776],
            [16.486520345820136, 7.443932311098917],
            [16.488591621938387, 7.455700158753661],
            [16.488001161255553, 7.459698436023662],
            [16.490181848871817, 7.462622935317909],
            [16.48977334536018, 7.467041611778762],
            [16.494043513995397, 7.472343752912808],
            [16.492573060474115, 7.475590349643743],
            [16.496693482815477, 7.478126785070662],
            [16.499937091047094, 7.483716278099042],
            [16.504812541913502, 7.484526396854399],
            [16.506105590315435, 7.4906213676155],
            [16.50705729403936, 7.505847772069287]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -73.14080912844582,
          "lat": 44.030872205057676
        },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50001"],
        "coty_name": ["Addison"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Addison County"],
        "coty_fp_code": "001",
        "coty_gnis_code": "01461757"
      },
      "bbox": [
        16.467080034544182, 7.003159998060776, 16.96000514269131,
        7.593372758224948
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [16.85132877788677, 8.351129753822859],
            [16.866064758970786, 8.35438867250424],
            [16.901054921616666, 8.36415636803278],
            [16.923157077569147, 8.369344332844593],
            [16.95619478101063, 8.375631570130178],
            [16.992510764170486, 8.3837656546322],
            [17.01930959832569, 8.388665634628723],
            [17.03160194886879, 8.39245132871082],
            [17.046045883769402, 8.395776296326378],
            [17.12105220481655, 8.41678603725287],
            [17.160490538550675, 8.426194397003679],
            [17.214739192382154, 8.441223574172774],
            [17.23948407866711, 8.448642436068877],
            [17.26636837865347, 8.456011914036212],
            [17.28851629877422, 8.461100289825495],
            [17.299143297430852, 8.464220036684507],
            [17.30648027238618, 8.401045899509816],
            [17.311679875298978, 8.358287353847327],
            [17.346354612970018, 8.34387545232282],
            [17.328040015041243, 8.296312309250435],
            [17.323442703461783, 8.287704923554175],
            [17.302874541975566, 8.239017129258114],
            [17.331709817112664, 8.22817387287523],
            [17.304977213075137, 8.161520424280772],
            [17.29986797680157, 8.147707936183187],
            [17.21647207907618, 8.178676919739743],
            [17.24982516637741, 8.120866745947962],
            [17.20605479398245, 8.129630042222082],
            [17.204957835208052, 8.122549709011851],
            [17.18835642995597, 8.047082917156665],
            [17.185815237317883, 8.03460935061402],
            [17.165844207668005, 7.953497779885557],
            [17.134886938768076, 7.961043509625445],
            [17.084985060859502, 7.972343233110832],
            [17.079093838167896, 7.9743247000646],
            [17.080722540142144, 7.983627564319192],
            [17.078760281710252, 7.983624758610932],
            [16.991799652506142, 8.003568076690906],
            [17.01270566371551, 8.091207675734891],
            [17.01501933146681, 8.100260352842621],
            [17.010774960656704, 8.10095913767856],
            [16.95028864145129, 8.114469119779299],
            [16.88962871795713, 8.128262086300664],
            [16.908069595256787, 8.18724625721825],
            [16.880018628118602, 8.274195231224969],
            [16.88333388524588, 8.27516194950433],
            [16.854489762016442, 8.344066644605547],
            [16.85132877788677, 8.351129753822859]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -72.24361928842026,
          "lat": 44.829015027816155
        },
        "year": "2023",
        "ste_code": ["50"],
        "ste_name": ["Vermont"],
        "coty_code": ["50019"],
        "coty_name": ["Orleans"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Orleans County"],
        "coty_fp_code": "019",
        "coty_gnis_code": "01461766"
      },
      "bbox": [
        16.85132877788677, 7.953497779885557, 17.346354612970018,
        8.464220036684507
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [14.395541199688731, 0.5143741319048916],
            [14.401705056610002, 0.5142470085221875],
            [14.406544184523218, 0.5120659941276097],
            [14.412936841329905, 0.5069674615619665],
            [14.41624801868905, 0.506768928064114],
            [14.426528013425568, 0.5014926446617082],
            [14.441919476810979, 0.4960645511217096],
            [14.450961477766878, 0.4922523876096129],
            [14.461324956868083, 0.48529640662550183],
            [14.46022335231075, 0.4778291357863513],
            [14.475555193779375, 0.4757440687338974],
            [14.482372279820279, 0.4761626918175478],
            [14.486940895874469, 0.47784138228850837],
            [14.492823702559019, 0.47783983610693753],
            [14.494903482513067, 0.47947564986278307],
            [14.497179304447377, 0.4702442207242424],
            [14.502740136084073, 0.465967447687934],
            [14.504979177400743, 0.4667024950662963],
            [14.516015162145594, 0.45994659041463454],
            [14.522417306831768, 0.4569455497346825],
            [14.531251655302324, 0.4548403485817456],
            [14.531871750156078, 0.45086177669101296],
            [14.534753650234071, 0.4486775463468364],
            [14.533503429479342, 0.4453340087617619],
            [14.5349319768998, 0.44198530252032586],
            [14.542075578442098, 0.4390985704675129],
            [14.541882790053693, 0.43388653706922237],
            [14.537393129779826, 0.4285281768582087],
            [14.536570259439367, 0.4251641698504987],
            [14.53814373498331, 0.41833044858721236],
            [14.536362760346284, 0.41707101894418047],
            [14.538488216972885, 0.4093368616690632],
            [14.542397576328657, 0.41083679493942543],
            [14.543258987658339, 0.4068265539028027],
            [14.549911428879959, 0.4047965152445611],
            [14.563147406985054, 0.3975242151833724],
            [14.566127584932692, 0.3937789200639918],
            [14.574419448171565, 0.39518440079840295],
            [14.58099157220759, 0.4003025149578568],
            [14.581097469909167, 0.394695150595362],
            [14.591056808073562, 0.39474519591135215],
            [14.593305859285271, 0.3919773190322742],
            [14.598517583239598, 0.39326406185314416],
            [14.598567325122612, 0.3957688775959723],
            [14.610905396326052, 0.3936785270439429],
            [14.614792643628125, 0.3905782901161875],
            [14.618619254683955, 0.3900944494099123],
            [14.623062587655562, 0.38451024132902434],
            [14.633560926781197, 0.3807366663211663],
            [14.633421373304774, 0.3794238496568993],
            [14.645162962043612, 0.3737336111358519],
            [14.654791523184768, 0.37486399222149425],
            [14.673040319794625, 0.37394105456875165],
            [14.703686648047357, 0.36934545173485084],
            [14.716473182361474, 0.3728336671746209],
            [14.726338212860776, 0.37267575795912566],
            [14.738346306770792, 0.37701818956368427],
            [14.743185190257535, 0.3810841284957455],
            [14.766001974090123, 0.38090764626320367],
            [14.764361454626888, 0.3610108995738136],
            [14.760927079765791, 0.3615902826639528],
            [14.76358515148053, 0.35201428791443573],
            [14.762632845381589, 0.34286501156283994],
            [14.763192648975076, 0.33253602566628193],
            [14.761811611335846, 0.3298840369573881],
            [14.761900783613967, 0.32144788445055616],
            [14.760414492854316, 0.3129641309579228],
            [14.766567985114074, 0.2969985640084299],
            [14.766890128544407, 0.2897089207267119],
            [14.77170382210425, 0.2874542251819521],
            [14.774005089730665, 0.2882304227014482],
            [14.777355635029092, 0.28250636491083336],
            [14.77872287354408, 0.2774089302982378],
            [14.790171118954145, 0.2756527297845856],
            [14.789469166009075, 0.271180297036587],
            [14.793334614247245, 0.26717185697578344],
            [14.798263864458049, 0.26712044914496297],
            [14.79861851258402, 0.2629782811351731],
            [14.801936557326693, 0.256089802488884],
            [14.796514103373523, 0.25317885703548937],
            [14.790045416253392, 0.25168526662089236],
            [14.786872932303504, 0.24201289779536195],
            [14.780474451908931, 0.24038900804163463],
            [14.774549891887595, 0.2367696611356251],
            [14.770440269181055, 0.23890304209904162],
            [14.74973329962031, 0.24637794916905034],
            [14.745157475354993, 0.24913859957684448],
            [14.731001463493142, 0.2542004767699318],
            [14.720181005904795, 0.25023449216072985],
            [14.71408865890229, 0.24996599677733747],
            [14.707551086025418, 0.25183447129355935],
            [14.692608647135861, 0.2607032134826878],
            [14.688009486989499, 0.26559881695420384],
            [14.684469903447495, 0.26771727981517746],
            [14.678894323715737, 0.2683963027004138],
            [14.658993871308045, 0.2642367534386375],
            [14.654534211100584, 0.26180954663362493],
            [14.649053879445214, 0.2565331593705114],
            [14.64393238758396, 0.2550029484876306],
            [14.637038646264124, 0.2574087653938577],
            [14.634381982542553, 0.26057355311539004],
            [14.634744193382977, 0.2671626450874112],
            [14.633564278116983, 0.27185377483129414],
            [14.626295054785809, 0.2790000610044234],
            [14.614515500648743, 0.2847334309603201],
            [14.607958777039707, 0.2848264655451998],
            [14.60168554370606, 0.2867849579293704],
            [14.595799181113124, 0.29007129767182305],
            [14.589675835397344, 0.2950431308885516],
            [14.584284853577103, 0.29791261180655715],
            [14.568230167964433, 0.3038986047521431],
            [14.563476991265007, 0.308073896155817],
            [14.554821369799203, 0.3218264896507308],
            [14.551625424389819, 0.3238218353239608],
            [14.545298002696427, 0.32362238146004374],
            [14.541740237272162, 0.32159238973260396],
            [14.52911552998821, 0.3087384963531686],
            [14.52778801233822, 0.3062991508350607],
            [14.52423317790857, 0.29258641926591256],
            [14.524419240977647, 0.2878879741076156],
            [14.5267538501232, 0.2832959865088378],
            [14.53019532255722, 0.28085921555301757],
            [14.536708895896572, 0.2727282796720321],
            [14.537961983422154, 0.26357877317361667],
            [14.535161899384565, 0.25663827075117807],
            [14.53067836219983, 0.25237809948251966],
            [14.516757947359805, 0.24813037182212916],
            [14.510320156678068, 0.247959122504438],
            [14.500842470321366, 0.25154759352886336],
            [14.493196093011687, 0.2552073374106457],
            [14.488185185333347, 0.25864774301583215],
            [14.480581758607217, 0.26071591429815083],
            [14.472016960068576, 0.25824561935159224],
            [14.461088478921349, 0.2568542104088185],
            [14.457142366460623, 0.25709598302731573],
            [14.444136708057773, 0.25973585595156756],
            [14.440662982021202, 0.2618122419008507],
            [14.435645268269086, 0.2673617741190014],
            [14.432558501377255, 0.27057528578059087],
            [14.424248071134135, 0.27649927342585534],
            [14.417892318834486, 0.2779167389601887],
            [14.410868105381834, 0.2758478479635858],
            [14.4057789533402, 0.2763748695916094],
            [14.402307987446642, 0.28205929621338494],
            [14.403532664591955, 0.2873614790660668],
            [14.406730925680295, 0.2908121711898946],
            [14.41384927059708, 0.3035078275703856],
            [14.413788555294602, 0.30826412330158043],
            [14.410181652470003, 0.3147815902535131],
            [14.404159507051268, 0.3200698044677955],
            [14.396173622344497, 0.32456172798723737],
            [14.389638271879669, 0.32498024431441214],
            [14.38021166141321, 0.33343227103371564],
            [14.372286430769476, 0.3381721095345909],
            [14.36177094597119, 0.34123093574116636],
            [14.351350459705296, 0.34500085831876465],
            [14.352293726345824, 0.3604356064548393],
            [14.395570048566698, 0.5114867394960411],
            [14.395541199688731, 0.5143741319048916]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -77.91577936773496, "lat": 37.72209838593166 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51075"],
        "coty_name": ["Goochland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Goochland County"],
        "coty_fp_code": "075",
        "coty_gnis_code": "01674271"
      },
      "bbox": [
        14.351350459705296, 0.2367696611356251, 14.801936557326693,
        0.5143741319048916
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.52604599188574, 0.8643042767998121],
            [15.529382691679686, 0.8616390456671317],
            [15.532287785545137, 0.8634072140865029],
            [15.53593033381201, 0.861911071852976],
            [15.541654809081463, 0.8620694394332313],
            [15.54347375109294, 0.8676767594372552],
            [15.551157264052144, 0.8667042092139146],
            [15.556094906444171, 0.8704974938996245],
            [15.568846570978497, 0.8673690079454587],
            [15.573487130793806, 0.8656170729660404],
            [15.588728867372648, 0.8649777947358419],
            [15.591499899934968, 0.8611458914634184],
            [15.59739760882464, 0.8572508816579777],
            [15.600932272088599, 0.8580743291118295],
            [15.602845940223537, 0.849413216172409],
            [15.597422566396162, 0.8499464369162832],
            [15.59427290054, 0.8433873667052905],
            [15.597783016213636, 0.8405490454574864],
            [15.597885849798915, 0.8358785777199826],
            [15.602509516410771, 0.8355487717111783],
            [15.606741104163447, 0.8400244446560013],
            [15.614266783007217, 0.839508393658932],
            [15.618399639468292, 0.8415238525334746],
            [15.622476193803061, 0.8402642169460921],
            [15.62175922156908, 0.8365714351536849],
            [15.624179629465354, 0.8337242939282427],
            [15.6327201169174, 0.836282130355598],
            [15.644678824453827, 0.8277246879273573],
            [15.651886016384973, 0.8250576200370195],
            [15.66534853763322, 0.8237060793718718],
            [15.670724097705497, 0.8224193004030945],
            [15.67537392403794, 0.8231173957072571],
            [15.690541571404967, 0.8223666044317508],
            [15.70408003270927, 0.8200636814083906],
            [15.726955587706641, 0.8124047421874244],
            [15.732909648752747, 0.8097608441156942],
            [15.751204639955446, 0.8032896856724804],
            [15.77105942651482, 0.7970352733354519],
            [15.783334889011696, 0.7885217048664687],
            [15.786245644657209, 0.7841098168636558],
            [15.797608721810917, 0.7810864208024056],
            [15.798081487197704, 0.7720656738900867],
            [15.796086773811007, 0.7585989777945487],
            [15.797168337372021, 0.7554484550315839],
            [15.797735312110888, 0.7424137445216735],
            [15.796028328940888, 0.7408681314386633],
            [15.796728352527971, 0.7325909350686162],
            [15.798463131072069, 0.7314097882700379],
            [15.798814202046787, 0.7240744372984409],
            [15.795196790590365, 0.7173432093666745],
            [15.79057790888559, 0.7041685615453631],
            [15.7845813196511, 0.6980185846896948],
            [15.778604965700053, 0.6982515756302717],
            [15.778246171238392, 0.702261257346049],
            [15.775129868455254, 0.7059805426403009],
            [15.76844573668843, 0.7049962576672091],
            [15.758601426134758, 0.7020945662072219],
            [15.755944370262588, 0.6934962179806149],
            [15.759915483981285, 0.6925055471362825],
            [15.762365748188282, 0.6805345136957076],
            [15.760273401922465, 0.6756115064583421],
            [15.760650901115389, 0.6720082942846742],
            [15.757094852385853, 0.6717460365516897],
            [15.760247532465597, 0.6612638976847824],
            [15.764492956533832, 0.6632219108654787],
            [15.765713142862575, 0.6680390429441578],
            [15.772769652804751, 0.6654469288251488],
            [15.776740375255061, 0.6689411642927046],
            [15.782587055824669, 0.668110663805544],
            [15.782902610057171, 0.6618723194331774],
            [15.780539838214164, 0.6619447638843513],
            [15.777983855998892, 0.6659616786038901],
            [15.773901415012556, 0.6627771951004002],
            [15.769668550451993, 0.6625660843733382],
            [15.76889473357283, 0.6573567082529904],
            [15.765898189926085, 0.6551822041429145],
            [15.769446460205888, 0.6448627054069274],
            [15.763524424930635, 0.6429557742359666],
            [15.766675499836888, 0.6367852104123005],
            [15.770244482410977, 0.6331272982891958],
            [15.766685530109008, 0.6292715883380934],
            [15.76928089882152, 0.6223507142398542],
            [15.77394339721493, 0.6213886751875282],
            [15.77697702893123, 0.6124282354773609],
            [15.765592082298008, 0.6168242410403197],
            [15.764401205099297, 0.6157011948637289],
            [15.7656884870656, 0.6068566587207473],
            [15.768518643997036, 0.6069661895448009],
            [15.769318966931483, 0.5990841594534753],
            [15.772904479204463, 0.5960537570719645],
            [15.776532143458251, 0.5975775102469859],
            [15.778331528734524, 0.5919566289514572],
            [15.786090300990557, 0.5844681930842841],
            [15.789065460811646, 0.5780111402720921],
            [15.789001194295595, 0.5733398573304218],
            [15.781241526587554, 0.5753954868127601],
            [15.779484142045872, 0.5701745612864318],
            [15.782578578466342, 0.5654180447604695],
            [15.777739588635276, 0.5653443968431147],
            [15.77294773199345, 0.5668616739944039],
            [15.76770348265953, 0.5630089334094066],
            [15.757257898150517, 0.5661466503152096],
            [15.751961693108747, 0.5701149660653766],
            [15.750737555249934, 0.5755348603564422],
            [15.740456146775445, 0.5812016685090641],
            [15.72787901474256, 0.5834896500738198],
            [15.733775490008945, 0.6003541397862445],
            [15.733950856443215, 0.6090995370177399],
            [15.730596911131663, 0.6179316132348976],
            [15.729840169607778, 0.6233204872283932],
            [15.724809999428919, 0.6273320163384677],
            [15.724188424692034, 0.6323365100865579],
            [15.72639113326415, 0.6372106693623856],
            [15.72156498141712, 0.6442981358377204],
            [15.715108885384145, 0.6470651427002121],
            [15.709714783844817, 0.6481164742062414],
            [15.703589916295714, 0.6457459352572612],
            [15.69490481506125, 0.6457547340405226],
            [15.692573743112005, 0.6504613386036846],
            [15.688380077838024, 0.6515051908364432],
            [15.684232264870568, 0.6549768806832805],
            [15.681054158692026, 0.6632801144187649],
            [15.675335060106093, 0.6686291599937528],
            [15.673415656919964, 0.675537773406813],
            [15.672542901941314, 0.6851130018809644],
            [15.66293480738253, 0.6894075094231882],
            [15.661497099024528, 0.6861797448342933],
            [15.655669644465679, 0.6809741760207557],
            [15.641172603774205, 0.6759115022121392],
            [15.635752873230903, 0.6765423084422155],
            [15.624460010526212, 0.6899959782372376],
            [15.614826516754494, 0.6896327529304103],
            [15.610507846533368, 0.691019337516116],
            [15.606534828003195, 0.6841094122169565],
            [15.601978774907668, 0.6810772113917936],
            [15.601053618355664, 0.686588248144665],
            [15.596215940218277, 0.6967590004964119],
            [15.591876939406239, 0.6986404064199143],
            [15.577586012652661, 0.7002930403876712],
            [15.571374820512453, 0.7034583473389662],
            [15.56392926864832, 0.7099845362380659],
            [15.564807298791807, 0.7191223837810149],
            [15.566240981749354, 0.7238091574726374],
            [15.565021310999645, 0.7322310819074611],
            [15.560180971756052, 0.7397249592407453],
            [15.55956782062819, 0.7456378423891603],
            [15.556198386279181, 0.7533690469254382],
            [15.551194431606486, 0.7612931930340102],
            [15.548069216112099, 0.7640581421641977],
            [15.545116241424378, 0.7705806542734747],
            [15.538681340050251, 0.7730800331512584],
            [15.531004809751934, 0.7727919220543751],
            [15.526346544823644, 0.774390070053913],
            [15.521585882905596, 0.7792628947854335],
            [15.513163873314356, 0.7814061174606091],
            [15.503773256284221, 0.7800614691617146],
            [15.5016176349458, 0.7836151823327614],
            [15.49195390841971, 0.7868791269290183],
            [15.48914539630816, 0.7896494863220399],
            [15.485485191693078, 0.7905209218020565],
            [15.483897585935607, 0.7946295035888993],
            [15.48047141289423, 0.7955969215310171],
            [15.478140871253611, 0.7929140544474804],
            [15.477659716299119, 0.8043223122229841],
            [15.47938837778443, 0.8117382198356548],
            [15.48224767703186, 0.8178186835125726],
            [15.483809371193894, 0.8289102074863494],
            [15.485594424198124, 0.831194087793093],
            [15.494751734691846, 0.8327039414294664],
            [15.499223741075166, 0.8354288667415557],
            [15.503657485203128, 0.8364406866401599],
            [15.5077107354075, 0.8422925989124694],
            [15.508995990587561, 0.8474414076011421],
            [15.512153892100084, 0.8524411034051697],
            [15.514325616026897, 0.8530108203272174],
            [15.514488112966985, 0.858106571999327],
            [15.512913969548702, 0.8622638540698847],
            [15.517988876358356, 0.8625930841113548],
            [15.522123413431851, 0.8646023512003984],
            [15.52604599188574, 0.8643042767998121]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.41961510774149,
          "lat": 37.887420826979266
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51133"],
        "coty_name": ["Northumberland"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Northumberland County"],
        "coty_fp_code": "133",
        "coty_gnis_code": "01480152"
      },
      "bbox": [
        15.477659716299119, 0.5630089334094066, 15.798814202046787,
        0.8704974938996245
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.823021640996284, 1.1255890015035062],
            [13.82332359560489, 1.1271836902780976],
            [13.831693485045824, 1.1396431981355097],
            [13.833837412007076, 1.1469725110212383],
            [13.836074139251233, 1.1590192029863258],
            [13.838557090014943, 1.1678149831333047],
            [13.843282498422761, 1.1957105123231861],
            [13.847476237846855, 1.213976633425337],
            [13.854769544467723, 1.2334430718971134],
            [13.863272713537311, 1.2504484004615297],
            [13.868269381510153, 1.2635845197274524],
            [13.868990801428955, 1.271494947994476],
            [13.90151353116646, 1.2642781649717254],
            [13.90801846233943, 1.2785708857663536],
            [13.910612992762303, 1.282366672460657],
            [13.914973188979443, 1.2836523218245115],
            [13.919576560567593, 1.2882726306403396],
            [13.92627272461488, 1.296571688393173],
            [13.930657754458261, 1.3067426256957013],
            [13.934148698849851, 1.3118631898991089],
            [13.938494363018174, 1.3221682708538403],
            [13.94674901585683, 1.3356349894824506],
            [13.951960639373402, 1.348559712727325],
            [13.963650422571767, 1.368077780074045],
            [13.970449737940243, 1.3769270668145506],
            [14.007395813717405, 1.3673804609681335],
            [14.011638020373322, 1.367409080465642],
            [14.015650234612663, 1.3652449927394867],
            [14.01914385066629, 1.3604445703801982],
            [14.027475742475014, 1.3557096681309764],
            [14.032379171780695, 1.3543969282700568],
            [14.052298823317171, 1.3522973395552582],
            [14.05747784809503, 1.3497129325134158],
            [14.059199624710635, 1.3455238393543467],
            [14.059175514277888, 1.3379681829481376],
            [14.065665201601414, 1.3296248337646703],
            [14.062985534872984, 1.3199341504622082],
            [14.058684640894644, 1.3199054263640038],
            [14.056576954669566, 1.3166680923226348],
            [14.057069715405541, 1.312777349005276],
            [14.054368450221943, 1.3057755430676574],
            [14.047901467992382, 1.30353802767219],
            [14.043890356931058, 1.3034909207443257],
            [14.043084772531003, 1.29453223940244],
            [14.043231592618296, 1.2863084475218196],
            [14.040502939981634, 1.2757503899121734],
            [14.040647845919276, 1.2666993718645612],
            [14.042844420257486, 1.2671504173661383],
            [14.050422951737415, 1.2640151787197782],
            [14.054563505037901, 1.2569032168963656],
            [14.057563478733726, 1.2492006777555067],
            [14.053494025601957, 1.2439644013822468],
            [14.052327262968987, 1.2375148000742844],
            [14.057592636349751, 1.2358418478090036],
            [14.057605717089206, 1.2267984714162148],
            [14.062436022988798, 1.218329728927711],
            [14.060326211957118, 1.2126557350205796],
            [14.060892051702163, 1.2094616605486337],
            [14.058507339432968, 1.1961765907743258],
            [14.054900707181472, 1.192684718752082],
            [14.049786365625708, 1.1910380903601028],
            [14.045847428600919, 1.1855500866236173],
            [14.046403465212094, 1.182671539320708],
            [14.041303632516106, 1.177365390293451],
            [14.039698710150077, 1.173389719885367],
            [14.035699208617123, 1.17449495901717],
            [14.03319915275073, 1.1700135343382285],
            [14.031932007884453, 1.1619404408571712],
            [14.028583661158269, 1.1533383482914088],
            [14.022812183507096, 1.145921586792144],
            [14.021987391570093, 1.1399502098323864],
            [14.025734827852048, 1.1332191739090014],
            [14.025517391491741, 1.1281956494135998],
            [14.027805574585756, 1.1263114537186178],
            [14.029640045308293, 1.1196644839202636],
            [14.024649335235045, 1.1119383584122275],
            [14.020401470857104, 1.111951791458704],
            [14.013675612027042, 1.1071288995966095],
            [14.007193861474304, 1.1007624827665665],
            [14.005008630093075, 1.0872014265988652],
            [13.996273185480591, 1.0775729304014539],
            [13.991426741105302, 1.0809839483855583],
            [13.988713006372931, 1.0773545910154845],
            [13.994706731299784, 1.0726931714260546],
            [13.994851129245376, 1.069639931766274],
            [13.992149121190483, 1.0660126863328403],
            [13.991667803152238, 1.0616624418660698],
            [13.993114528359587, 1.0554991103711497],
            [13.990944252256185, 1.0485111431781535],
            [13.995369314344398, 1.0443163847179135],
            [13.994593419322765, 1.0390842734655448],
            [13.990756740947619, 1.024073842095246],
            [13.989258702288591, 1.0207180661828033],
            [13.98900193010415, 1.012732926737252],
            [13.986208619528615, 1.0067927768478224],
            [13.987514871535376, 1.0020984149571879],
            [13.985194067353886, 0.9943239147428404],
            [13.98079550010955, 0.9933770946596648],
            [13.978607102889153, 0.9838539683845615],
            [13.980675524859723, 0.9776377858271106],
            [13.977086284252517, 0.975383893221993],
            [13.97563454014695, 0.9658453193633746],
            [13.934257813577974, 0.9664583486469135],
            [13.932217842009292, 0.9622684470546464],
            [13.927415937189963, 0.9616117894726903],
            [13.921188576084605, 0.971262765164773],
            [13.919261349435336, 0.9772871724934777],
            [13.915460736075946, 0.9808515944314808],
            [13.910404248450842, 0.9804525405700594],
            [13.903405361379235, 0.98201231209252],
            [13.900726601026081, 0.9845181877965176],
            [13.893840422498204, 0.9857340868034479],
            [13.88575072046089, 0.9843126566492963],
            [13.881947242887353, 0.9883142685566122],
            [13.86316631159568, 0.9903853627828557],
            [13.865538111014533, 0.9963200953694713],
            [13.86460763482264, 1.0007663595088354],
            [13.856020404669632, 1.0051277983160134],
            [13.852596091461281, 1.0083123693773874],
            [13.850613540392658, 1.0123855881010144],
            [13.851607399430195, 1.018331151072318],
            [13.847700217730555, 1.020225322153065],
            [13.84029982151936, 1.0126861517114643],
            [13.836161995559472, 1.0133207063281553],
            [13.802635790838089, 1.024598351357543],
            [13.80754500163057, 1.0406910241927834],
            [13.810113818313656, 1.0505896303161428],
            [13.812334875769018, 1.0710025693819092],
            [13.811982145884874, 1.079447128458696],
            [13.812732289584353, 1.0900250882637568],
            [13.815794387488289, 1.1109375072573253],
            [13.818126619688366, 1.1191866703183049],
            [13.823021640996284, 1.1255890015035062]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -78.4843200679753, "lat": 38.619490333940774 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51139"],
        "coty_name": ["Page"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Page County"],
        "coty_fp_code": "139",
        "coty_gnis_code": "01500440"
      },
      "bbox": [
        13.802635790838089, 0.9616117894726903, 14.065665201601414,
        1.3769270668145506
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.188064598465159, -0.95694697123741],
            [13.201258308469173, -0.926618177361817],
            [13.205697649986403, -0.9219660891364129],
            [13.236879986469157, -0.9280898157362799],
            [13.237277148467284, -0.9586388005322932],
            [13.239070845204713, -0.9639548769581875],
            [13.24308784020926, -0.9632468688225571],
            [13.246023210859311, -0.9684907612433205],
            [13.252926395950876, -0.9712432014655008],
            [13.25162433590356, -0.9777935227445592],
            [13.254365935148199, -0.9829557749338228],
            [13.25139996427321, -0.9848131224946752],
            [13.250558315870087, -0.979271238093469],
            [13.244440056408767, -0.9797636250228045],
            [13.244804288719903, -0.9847678172348586],
            [13.243369725052432, -0.9887687555137077],
            [13.239802984318196, -0.9857470413297604],
            [13.228520921142259, -0.9845942562161852],
            [13.227534299564908, -0.9797767553843524],
            [13.22824748231314, -0.9745336341224292],
            [13.226527897732392, -0.9731467778477377],
            [13.209699332003817, -0.9706481900655287],
            [13.205169353369632, -0.96640240236822],
            [13.19787135892078, -0.967652289902197],
            [13.196245749192931, -0.9646521952629936],
            [13.188064598465159, -0.95694697123741]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -79.86366802421726, "lat": 36.68261121415347 },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51690"],
        "coty_name": ["Martinsville"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Martinsville city"],
        "coty_fp_code": "690",
        "coty_gnis_code": "01789072"
      },
      "bbox": [
        13.188064598465159, -0.9887687555137077, 13.254365935148199,
        -0.9219660891364129
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [15.661861808954674, 0.008279782275070549],
            [15.667325783484616, 0.019108382384217974],
            [15.67251204926152, 0.023543857921853515],
            [15.675336467682222, 0.022792463422295475],
            [15.679322446018377, 0.025991007975213837],
            [15.680298719183703, 0.034185073995356974],
            [15.67566442803983, 0.03601622874756128],
            [15.67228587442949, 0.04341522514823662],
            [15.668382058245546, 0.046402376398221215],
            [15.665514340462153, 0.051253066754718024],
            [15.665246137125193, 0.05472619822843404],
            [15.677738547348874, 0.0570906507886401],
            [15.683909229862277, 0.06615675705986061],
            [15.722662918558946, 0.029376459510038606],
            [15.72956300756065, 0.032542282260906476],
            [15.732318117878211, 0.027373682262112852],
            [15.743564493136816, 0.014573669723575261],
            [15.74317100167025, 0.00993528165712085],
            [15.790470444537988, -0.034993512775789555],
            [15.802826337180406, -0.03891603491910505],
            [15.808407803580169, -0.038395626695031104],
            [15.808240274093317, -0.04786458829055746],
            [15.806514551852766, -0.047941157466372154],
            [15.801431579813942, -0.05740317429196115],
            [15.806130434616358, -0.06258777013376945],
            [15.80682768030124, -0.06501989833188898],
            [15.805658593212945, -0.07421587780518792],
            [15.808364962429351, -0.07844538905820041],
            [15.80766005977265, -0.08298440359864935],
            [15.811332782048748, -0.09619012270086824],
            [15.818008681255689, -0.10344980586054212],
            [15.821125426626587, -0.11075799396974523],
            [15.823324378492817, -0.11164087563631052],
            [15.832664352772245, -0.10414290017945077],
            [15.854474569423406, -0.13238308596823012],
            [15.85663179838915, -0.12817707047418084],
            [15.861578394044821, -0.12895358316052713],
            [15.86869197848737, -0.13346095082151324],
            [15.8635036477126, -0.14210228705141612],
            [15.861087653573703, -0.1503247163095763],
            [15.856783901580641, -0.15712411305137053],
            [15.856177188575632, -0.16359479204277208],
            [15.848801036814343, -0.16415664848238923],
            [15.844424526839829, -0.16252538798732866],
            [15.834819113753834, -0.15424783764494168],
            [15.817067695406292, -0.1354900067810778],
            [15.819592124959462, -0.1309912347668598],
            [15.818109442420953, -0.1254306852672235],
            [15.81138287232184, -0.12017507946166527],
            [15.8101835956897, -0.11734951038116065],
            [15.80144704673509, -0.10844048036811245],
            [15.788237293255463, -0.10307946067611305],
            [15.773854278988015, -0.09668186253440757],
            [15.758817841190373, -0.0891493957010783],
            [15.75372540599876, -0.08931204744230796],
            [15.74633467998981, -0.08340229652898977],
            [15.7439305438164, -0.07843608117595527],
            [15.744643959650404, -0.07643152669288833],
            [15.742911100615991, -0.06804219803433811],
            [15.727915762674593, -0.0602688042516338],
            [15.726502865720585, -0.05577198359339702],
            [15.7187816191626, -0.052291681121558214],
            [15.713548149939918, -0.04370158192626958],
            [15.710129583733782, -0.04108818021053294],
            [15.704536148221301, -0.04000021139417769],
            [15.703176253770616, -0.04546190347244737],
            [15.709298729539759, -0.04771077177368001],
            [15.711628013935615, -0.055242231754716535],
            [15.716188255640423, -0.057814751589972534],
            [15.723772532222796, -0.06894981509746537],
            [15.717148262841825, -0.0698355266490475],
            [15.719743627658758, -0.07522761454924601],
            [15.714432319922011, -0.07431025759951256],
            [15.710441342791341, -0.07171534492451002],
            [15.710435254003011, -0.06937063731810764],
            [15.704044231820099, -0.06532726555540455],
            [15.698247205069134, -0.058649498240567755],
            [15.683228429332814, -0.051598341408250786],
            [15.680701023908462, -0.04708861477047949],
            [15.675520535719526, -0.04535726510840203],
            [15.671620210105567, -0.04623342526009651],
            [15.663505540690757, -0.041331450111366644],
            [15.660343191960807, -0.03558850092075445],
            [15.656405436514758, -0.03573035384254411],
            [15.65787193218332, -0.026604188842474938],
            [15.655646783404567, -0.024580358058822693],
            [15.655869899682108, -0.020485152937514305],
            [15.659827360936069, -0.01799436958316951],
            [15.666028918753357, 0.00008965572573075294],
            [15.661861808954674, 0.008279782275070549]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -76.51805023274072,
          "lat": 37.104833491137136
        },
        "year": "2023",
        "ste_code": ["51"],
        "ste_name": ["Virginia"],
        "coty_code": ["51700"],
        "coty_name": ["Newport News"],
        "coty_area_code": "USA",
        "coty_type": "city",
        "coty_name_long": ["Newport News city"],
        "coty_fp_code": "700",
        "coty_gnis_code": "01498555"
      },
      "bbox": [
        15.655646783404567, -0.16415664848238923, 15.86869197848737,
        0.06615675705986061
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-14.461958032791753, 9.641700280650202],
            [-14.447280724803957, 9.635675552978562],
            [-14.441065466851327, 9.634431931429713],
            [-14.42742459331802, 9.63472521284859],
            [-14.418993205556177, 9.638218190496627],
            [-14.4106888023972, 9.643787101150682],
            [-14.404003641836436, 9.649248458355334],
            [-14.398657588498573, 9.65526688263786],
            [-14.395049793581514, 9.660741482484523],
            [-14.389039200470368, 9.676235536307999],
            [-14.384248697521773, 9.684054031304605],
            [-14.379687952802193, 9.688367003222272],
            [-14.371685061302363, 9.691453282352574],
            [-14.366522562289811, 9.689470026818423],
            [-14.36015445709303, 9.690411475779726],
            [-14.340539674719869, 9.689350986345012],
            [-14.334084097857655, 9.690912965039029],
            [-14.31922056027735, 9.687504190069882],
            [-14.308411092238106, 9.682229394131912],
            [-14.303911768179422, 9.674735657353624],
            [-14.301910875207772, 9.667607975201092],
            [-14.29831869348976, 9.659145921535963],
            [-14.292798426034345, 9.653065310734002],
            [-14.289465099212485, 9.651090832689006],
            [-14.280693344308022, 9.648415996396501],
            [-14.267654168042842, 9.648310367797327],
            [-14.25919495824646, 9.64890580579132],
            [-14.246639294509235, 9.648481695414448],
            [-14.243005778569673, 9.647495107609084],
            [-14.23440760763974, 9.642753181077763],
            [-14.225606603835622, 9.640339603144032],
            [-14.21986712958854, 9.640660537716062],
            [-14.213386467693853, 9.642695793680836],
            [-14.209149136589089, 9.64967762822029],
            [-14.203269520842404, 9.653829377890135],
            [-14.19248470393594, 9.656404861168692],
            [-14.18539205086163, 9.654062159294357],
            [-14.182853349327951, 9.650909044697395],
            [-14.180223756408969, 9.644733955144526],
            [-14.179895463482314, 9.627860207785075],
            [-14.17737051947182, 9.618864838181],
            [-14.172855257471234, 9.610731597049135],
            [-14.165388587443296, 9.604648110428268],
            [-14.158522453556406, 9.604543913374417],
            [-14.147404869070856, 9.599502838280456],
            [-14.143505957972765, 9.592482921137597],
            [-14.145685656034905, 9.584167433316546],
            [-14.149622174711244, 9.576301459708985],
            [-14.150891346501865, 9.57112371064944],
            [-14.150642921597603, 9.564814809026007],
            [-14.14924385804087, 9.560263514569321],
            [-14.14261762298623, 9.553083108560225],
            [-14.136100134113564, 9.544780574244706],
            [-14.134819811417442, 9.541582119910716],
            [-14.132952512560804, 9.530197055289003],
            [-14.129117785790141, 9.524465879994498],
            [-14.126130550654183, 9.52206980360095],
            [-14.119181488201217, 9.519304309100542],
            [-14.108858577021138, 9.51696645265534],
            [-14.102809311990521, 9.51230095191011],
            [-14.098364607402264, 9.505781428183118],
            [-14.095319274368835, 9.496754226627901],
            [-14.092736522075505, 9.492321133336345],
            [-14.085975198247185, 9.485848827031036],
            [-14.081057003674994, 9.479128359054748],
            [-14.077987669038908, 9.473219283941871],
            [-14.076319959559532, 9.458821877147573],
            [-14.076945504828716, 9.451295565777821],
            [-14.075433636746412, 9.446633015387311],
            [-14.072703844264343, 9.42798870376671],
            [-14.076477281773496, 9.419013134520545],
            [-14.081990553336881, 9.410504790517727],
            [-14.083241708134768, 9.406693738578793],
            [-14.083645328761635, 9.397884544658455],
            [-14.081862935439105, 9.393114696829606],
            [-14.07900537388657, 9.390726927018662],
            [-14.09071283511696, 9.341953197921075],
            [-14.176247740766568, 9.362072659239182],
            [-14.179332264406037, 9.348088918395444],
            [-14.20801288686392, 9.354917897559318],
            [-14.211190826936443, 9.34095728305383],
            [-14.225414211438054, 9.343852142834963],
            [-14.236297102413774, 9.301397823848733],
            [-14.246207628821773, 9.258685818750829],
            [-14.245402072565104, 9.25850454768622],
            [-14.24900565918272, 9.242583705513676],
            [-14.265062603194337, 9.174428097427226],
            [-14.283750469930524, 9.093135637397966],
            [-14.32469018520555, 9.10245535105088],
            [-14.352423765564994, 8.983174700631904],
            [-14.36920335315343, 8.987440696037554],
            [-14.435905567152039, 9.003222220380689],
            [-14.408275030211984, 9.120799028809257],
            [-14.414569057310622, 9.122246839130785],
            [-14.366164854706184, 9.326891729408235],
            [-14.365245117907602, 9.330523127339829],
            [-14.4079371235222, 9.339449969724699],
            [-14.396972708969047, 9.383044382064973],
            [-14.411124583525956, 9.386256097852558],
            [-14.407965277292819, 9.400104276105699],
            [-14.422371123598793, 9.4033359553194],
            [-14.412509881364734, 9.445707023423966],
            [-14.426459337931103, 9.449109575558339],
            [-14.41971919741701, 9.477312536402675],
            [-14.448120060280942, 9.483832931878968],
            [-14.504676896629336, 9.496082438548363],
            [-14.483139783829682, 9.581546164524033],
            [-14.477489635978868, 9.580205493552215],
            [-14.461958032791753, 9.641700280650202]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -117.54516116844609,
          "lat": 46.43162503004784
        },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53023"],
        "coty_name": ["Garfield"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Garfield County"],
        "coty_fp_code": "023",
        "coty_gnis_code": "01533500"
      },
      "bbox": [
        -14.504676896629336, 8.983174700631904, -14.072703844264343,
        9.691453282352574
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [-17.110909580550715, 12.070581034505553],
              [-17.104989844435284, 12.071780551913145],
              [-17.10219588421154, 12.067594610943871],
              [-17.1048673487151, 12.065680708329086],
              [-17.110909580550715, 12.070581034505553]
            ]
          ],
          [
            [
              [-17.074833313978555, 12.22583627412986],
              [-17.07075175421477, 12.223413265084742],
              [-17.070618164730874, 12.220736601145738],
              [-17.075664451640048, 12.220362107585286],
              [-17.074833313978555, 12.22583627412986]
            ]
          ],
          [
            [
              [-17.12818396507555, 12.108526912597352],
              [-17.124462398067124, 12.112727706149757],
              [-17.114184784424097, 12.111591687391634],
              [-17.115611505427996, 12.107859546821855],
              [-17.125618579297107, 12.1072607140894],
              [-17.12818396507555, 12.108526912597352]
            ]
          ],
          [
            [
              [-17.091648442343295, 12.317051790160978],
              [-17.08856448415196, 12.318787996322694],
              [-17.08321543508753, 12.31556800235593],
              [-17.08286905599298, 12.309081878594188],
              [-17.086269119490552, 12.307642147096137],
              [-17.09103703081734, 12.312201616166847],
              [-17.091648442343295, 12.317051790160978]
            ]
          ],
          [
            [
              [-17.13435560104078, 12.264507087739783],
              [-17.125697464511543, 12.274056491542495],
              [-17.125422935062684, 12.277959486735774],
              [-17.127528111715712, 12.282947507883375],
              [-17.125100202566333, 12.289553200618029],
              [-17.124130992749738, 12.296297362259338],
              [-17.1208405053977, 12.30042640495068],
              [-17.116498855631715, 12.299086268303054],
              [-17.114090389487313, 12.294365014931541],
              [-17.114690932223787, 12.288847221473912],
              [-17.112384699279474, 12.281693943953275],
              [-17.107915673261456, 12.276019175966805],
              [-17.103530347415415, 12.268084546858306],
              [-17.09865610803659, 12.263579363846835],
              [-17.09657797944402, 12.259312494859389],
              [-17.088891961320673, 12.254303365256902],
              [-17.08652390734852, 12.25021406037471],
              [-17.086269142674194, 12.240498957493276],
              [-17.089292600094215, 12.236942381773641],
              [-17.089758950556934, 12.232180078057997],
              [-17.09718822038225, 12.238813540515094],
              [-17.097057921725174, 12.241227078885498],
              [-17.103154340391885, 12.243588108268629],
              [-17.118052517018636, 12.240068311366498],
              [-17.12914769196854, 12.23994267609121],
              [-17.132198960575963, 12.240638985087266],
              [-17.1370886046558, 12.24494244118058],
              [-17.138178389618954, 12.24782551387273],
              [-17.137842868753488, 12.254400243890691],
              [-17.13435560104078, 12.264507087739783]
            ]
          ],
          [
            [
              [-17.14391500497803, 12.33977431770261],
              [-17.14260182826795, 12.341380543334914],
              [-17.133198745303126, 12.343373340941008],
              [-17.125384560570126, 12.343433196421994],
              [-17.125081270639907, 12.338201698351078],
              [-17.120774519961163, 12.332515827092232],
              [-17.122098827482667, 12.326815935927474],
              [-17.119860512416338, 12.321710250198311],
              [-17.12621987230228, 12.321686819908077],
              [-17.132518618925054, 12.3254389330335],
              [-17.137636142719188, 12.330111238195215],
              [-17.140537808241785, 12.334575964173913],
              [-17.144411694923942, 12.335629559725694],
              [-17.14391500497803, 12.33977431770261]
            ]
          ],
          [
            [
              [-17.002130158399282, 12.324395230676048],
              [-16.91716490078555, 12.300369729302684],
              [-16.898199361327567, 12.295414807211529],
              [-16.861173251830458, 12.28501551467846],
              [-16.85422643009549, 12.283525545124803],
              [-16.784010012773795, 12.263937858028449],
              [-16.74893366367149, 12.253961280823503],
              [-16.684542049782273, 12.236076840446698],
              [-16.665644138370087, 12.230206167333463],
              [-16.63686092333635, 12.22272785263185],
              [-16.520156161240422, 12.189780305592732],
              [-16.488138458491708, 12.180654985534876],
              [-16.425350957562987, 12.163695157217933],
              [-16.36256735225134, 12.1467205071533],
              [-16.29978767203978, 12.129731042086602],
              [-16.237011946412267, 12.11272676875831],
              [-16.174240204851955, 12.095707693903378],
              [-16.11147247683947, 12.07867382425065],
              [-16.0487087918511, 12.06162516652265],
              [-15.985949179357108, 12.04456172743491],
              [-15.981822208620903, 12.059605309990271],
              [-15.880879057639444, 12.033210415262046],
              [-15.880887823893726, 12.02993106039074],
              [-15.88772932702357, 12.022540657535618],
              [-15.893453020236581, 12.02383583851229],
              [-15.89731271633319, 12.023103375763244],
              [-15.900144050842181, 12.018767511576828],
              [-15.902911655687761, 12.01724965245123],
              [-15.907738614359042, 12.011775143513661],
              [-15.912503425507657, 12.009531931009441],
              [-15.911563678486672, 11.998095303424984],
              [-15.91485929679517, 11.993296893190244],
              [-15.915432759120545, 11.987010484532634],
              [-15.911325629151326, 11.977140446652426],
              [-15.907211963631797, 11.97199157988171],
              [-15.905316305185346, 11.965236721703198],
              [-15.901613978846905, 11.962062615364514],
              [-15.89410890916572, 11.958425606547465],
              [-15.886180158809712, 11.95979166677621],
              [-15.88043294562309, 11.964949566576665],
              [-15.877441143338395, 11.97137662218423],
              [-15.875188626622283, 11.971079631967816],
              [-15.871961593375323, 11.965219121422962],
              [-15.86840931076228, 11.963633743163351],
              [-15.86607186031678, 11.956035950549989],
              [-15.862934706175631, 11.948943187068243],
              [-15.860624336825557, 11.946531553411837],
              [-15.86140174612613, 11.937509757715569],
              [-15.863597086642983, 11.934530638303631],
              [-15.872609277438636, 11.93293683428667],
              [-15.875587446357867, 11.925750553198059],
              [-15.882276754720003, 11.918202085223191],
              [-15.882757150808862, 11.913350626770054],
              [-15.880602019914264, 11.907533630941899],
              [-15.882202628907079, 11.90414863552331],
              [-15.88749438960013, 11.901061839345907],
              [-15.893386223426036, 11.90198742738928],
              [-15.902718874973742, 11.899537935659913],
              [-15.909755541806117, 11.901619076244652],
              [-15.915823957704669, 11.900624462932136],
              [-15.91759298618853, 11.898439929564224],
              [-15.92749266913495, 11.896987053014954],
              [-15.942371710743869, 11.899093823630295],
              [-15.950502436838473, 11.90457858580439],
              [-15.95782757323543, 11.915640334724586],
              [-15.957715021342887, 11.918185788392378],
              [-15.951534841609364, 11.922038472633087],
              [-15.950904587463894, 11.92485932808784],
              [-15.953574076223157, 11.930208299283127],
              [-15.953375556393816, 11.93267484883517],
              [-15.958392252918092, 11.938250820313279],
              [-15.957154971593038, 11.942464874599683],
              [-15.967943418805755, 11.949327990420025],
              [-15.976932940815649, 11.948799253328461],
              [-15.980597021791572, 11.94413049772367],
              [-15.979751344861441, 11.939244606210334],
              [-15.985176932384093, 11.93331688623387],
              [-15.990493798587842, 11.935691148768097],
              [-15.992526351565747, 11.940678117675565],
              [-15.997440972852422, 11.94466261993136],
              [-16.003798015671723, 11.944013258745741],
              [-16.007031016245406, 11.941774014027454],
              [-16.01066206877749, 11.943333081224235],
              [-16.011339537121422, 11.937366088996399],
              [-16.01357206008082, 11.934325039560806],
              [-16.02490496571176, 11.938861792852343],
              [-16.031982365341385, 11.944830974497627],
              [-16.041721588913713, 11.947661256985684],
              [-16.046024649511246, 11.941562247363558],
              [-16.045096145810096, 11.934206666457511],
              [-16.04695299155121, 11.924497765740007],
              [-16.049778081065703, 11.919756635118997],
              [-16.055421706083024, 11.921619826155757],
              [-16.058279894045242, 11.92092667096953],
              [-16.061138630265706, 11.923216057880246],
              [-16.070070492474855, 11.92496321017341],
              [-16.072335384590797, 11.923849708628918],
              [-16.07699514868549, 11.926325366553666],
              [-16.083515938749084, 11.92318725412809],
              [-16.092863448548506, 11.92575817407774],
              [-16.097768990975727, 11.92818698730099],
              [-16.105954980759076, 11.930200953876895],
              [-16.11722119354283, 11.923246640504422],
              [-16.123959323196612, 11.915968765141569],
              [-16.125377092052897, 11.911367446273177],
              [-16.12859466614372, 11.907980710203624],
              [-16.132225213404585, 11.901933970684839],
              [-16.131649049976605, 11.89398397021646],
              [-16.125739689227043, 11.887149767525957],
              [-16.12180802900313, 11.884668006941926],
              [-16.122018368336608, 11.877035612057247],
              [-16.12318377502801, 11.871328641331369],
              [-16.126413335051005, 11.870861557075495],
              [-16.13212985354639, 11.860454960414186],
              [-16.131078983771225, 11.85252911412927],
              [-16.13482177096743, 11.852695330872793],
              [-16.139704609696025, 11.856178839676463],
              [-16.146056611762756, 11.850473911131122],
              [-16.14934890819529, 11.845289340717288],
              [-16.151755062259696, 11.83843592395192],
              [-16.148954143760722, 11.833754764190104],
              [-16.14968094846905, 11.828464734798253],
              [-16.152346013577034, 11.826404202039132],
              [-16.14790319336309, 11.819194885363547],
              [-16.14451224873004, 11.808618192258331],
              [-16.144740882260734, 11.801068192958212],
              [-16.14640230208576, 11.79880198869702],
              [-16.146801722089638, 11.79306473758495],
              [-16.148918143316358, 11.79144066213917],
              [-16.156066114968077, 11.7926277597523],
              [-16.159307616705615, 11.795143070980945],
              [-16.163019796822287, 11.793010189261423],
              [-16.16551080232605, 11.78830916120809],
              [-16.167584703149423, 11.789659754852446],
              [-16.170382344018336, 11.781726577716345],
              [-16.1683077228683, 11.778822057700507],
              [-16.172304958730898, 11.771767732829272],
              [-16.172485118952594, 11.766942084078753],
              [-16.16741375391134, 11.766952523421914],
              [-16.16421211182654, 11.764038480339092],
              [-16.16065496387848, 11.757840775670905],
              [-16.15229644382423, 11.757945579228965],
              [-16.149575859999583, 11.75334954997049],
              [-16.150307664057056, 11.749780278017974],
              [-16.135389292944144, 11.741376040510728],
              [-16.134913320735297, 11.737816533957956],
              [-16.206731568848163, 11.756963443207198],
              [-16.278554761321683, 11.776091388226614],
              [-16.350382856941177, 11.795200359691187],
              [-16.422215814493878, 11.814290348279867],
              [-16.507735732739825, 11.838644968576132],
              [-16.507271595786204, 11.840133794544217],
              [-16.545543285915446, 11.84998016828162],
              [-16.577558043452438, 11.859169380888149],
              [-16.627071739187098, 11.872485457199739],
              [-16.674250706113597, 11.884457339316828],
              [-16.689175420334347, 11.888017690269136],
              [-16.7194627658672, 11.896456871271676],
              [-16.745312442271302, 11.903308210681722],
              [-16.780140091762103, 11.912940890931997],
              [-16.87165328182167, 11.938445358959187],
              [-16.885733862716773, 11.941756407395257],
              [-16.906612698753285, 11.94797243717129],
              [-16.94382830265925, 11.95806820621536],
              [-17.022011310743096, 11.980003130088152],
              [-17.023363181732485, 11.983320444161805],
              [-17.028512281554843, 11.98507591362892],
              [-17.02695825819708, 11.988293951114736],
              [-17.029622614603717, 11.991055686526167],
              [-17.028576449228495, 11.994131018899393],
              [-17.03370311260852, 12.001510545683436],
              [-17.032227622595936, 12.003894679051804],
              [-17.037303544744884, 12.013230729627312],
              [-17.04307244144715, 12.017332787904245],
              [-17.045078168356063, 12.02339190598898],
              [-17.056091705683407, 12.030081898900187],
              [-17.059656115611958, 12.035574660672522],
              [-17.064898595694903, 12.046585438564328],
              [-17.07138783717166, 12.049354830930703],
              [-17.071169728495363, 12.055904831919763],
              [-17.076800475940523, 12.060462560797038],
              [-17.078031425054423, 12.065416304800255],
              [-17.084693263035074, 12.063343307292458],
              [-17.087609128784525, 12.0604344691388],
              [-17.092052210391003, 12.062831971886112],
              [-17.08603064575432, 12.067716708740061],
              [-17.07875059861176, 12.068564796566609],
              [-17.08029076669465, 12.073310857661145],
              [-17.086262169336695, 12.072955921374623],
              [-17.096276644128647, 12.073862941376495],
              [-17.09723835247183, 12.080947712858514],
              [-17.104125915412542, 12.080851264433472],
              [-17.102257469820064, 12.088807802520115],
              [-17.102362941791192, 12.102717592239005],
              [-17.106810559418907, 12.106682991414688],
              [-17.109076874355566, 12.113887157979205],
              [-17.10686580558533, 12.117324582976718],
              [-17.106695698346055, 12.132767015797226],
              [-17.094857887810207, 12.149213202250632],
              [-17.099378386747436, 12.149052246067441],
              [-17.10363148257662, 12.152626452714323],
              [-17.10793280839635, 12.152414712717444],
              [-17.11270150474895, 12.153902125438396],
              [-17.11654422481223, 12.148154075687888],
              [-17.117204656006248, 12.144211006616182],
              [-17.124431956014394, 12.13766368912403],
              [-17.131768712969823, 12.13638908566565],
              [-17.13778761285576, 12.139034106514059],
              [-17.143761921523474, 12.135629407323743],
              [-17.146238503304026, 12.131717817838636],
              [-17.151900403401754, 12.132198001403856],
              [-17.1535062715478, 12.135191924077544],
              [-17.159545049774533, 12.132060046926068],
              [-17.164618579629916, 12.131803610709348],
              [-17.174678041528022, 12.13368177372122],
              [-17.174021410001952, 12.137970417321517],
              [-17.170471632690973, 12.137264950735544],
              [-17.169301141372973, 12.140113383084476],
              [-17.177545525269753, 12.141958771596538],
              [-17.181626383678182, 12.152731146081189],
              [-17.179470259798606, 12.164023821981544],
              [-17.180655875813514, 12.167303918423144],
              [-17.176848377313885, 12.168761878784847],
              [-17.1723031027243, 12.168009001118229],
              [-17.167093904626302, 12.172161216419305],
              [-17.165923901770434, 12.176327102714637],
              [-17.161141434502234, 12.17653115612734],
              [-17.157848235471477, 12.194587372961447],
              [-17.16084787956119, 12.200655579648037],
              [-17.160964155188164, 12.208886704105128],
              [-17.16525685310107, 12.213426427965873],
              [-17.172101641518953, 12.217734446523135],
              [-17.174784823303114, 12.217063228725792],
              [-17.18168135412413, 12.220505078828104],
              [-17.17734736087047, 12.227458799532915],
              [-17.17238133959131, 12.226077695093572],
              [-17.168640457847875, 12.231205249773637],
              [-17.165152313031776, 12.23307192721765],
              [-17.162043258267513, 12.230860995016972],
              [-17.16153646763958, 12.227383194201664],
              [-17.15811354488557, 12.225911531760975],
              [-17.11718457172883, 12.231955690564625],
              [-17.111697850750836, 12.231143457826082],
              [-17.107518576409944, 12.228755715328887],
              [-17.108964587166945, 12.220328924217197],
              [-17.112843952470218, 12.221032243927208],
              [-17.115402512373848, 12.216837635651718],
              [-17.113099641562396, 12.213972378183712],
              [-17.115690855469033, 12.202429846832661],
              [-17.113487724366333, 12.190962911174203],
              [-17.113204941552098, 12.175309139616688],
              [-17.110680119140625, 12.172061272682388],
              [-17.10713679929164, 12.17059045370564],
              [-17.10432916017735, 12.172817580881164],
              [-17.103210069353345, 12.176627907230605],
              [-17.10117239227854, 12.190330880638863],
              [-17.102537232654736, 12.193651085959186],
              [-17.101836191932126, 12.198415512890508],
              [-17.092517639122384, 12.202730069582353],
              [-17.086751626035245, 12.20166315328111],
              [-17.083889440975977, 12.186834649033255],
              [-17.08356563654036, 12.175821018943557],
              [-17.082020770974523, 12.166637711030699],
              [-17.078084022682898, 12.163423667312195],
              [-17.07635973051111, 12.156973262242264],
              [-17.073089336457326, 12.158485196220182],
              [-17.06241425486733, 12.152441190886272],
              [-17.052083405472484, 12.150771499870608],
              [-17.05279611678865, 12.154885331645785],
              [-17.038252866765646, 12.1568423171283],
              [-17.035850006750834, 12.160651278271002],
              [-17.035950173142254, 12.164293226182306],
              [-17.040280555921868, 12.170453164941305],
              [-17.039411154662055, 12.173874188427197],
              [-17.04036313000084, 12.181237907101115],
              [-17.038183820540013, 12.187082665853099],
              [-17.0366456756282, 12.197495350958889],
              [-17.037742551816144, 12.201723073254394],
              [-17.032644413895756, 12.205161959544283],
              [-17.031418369013455, 12.222758556560269],
              [-17.03512929544268, 12.22773278570137],
              [-17.035425980539127, 12.238442265178644],
              [-17.033138694869947, 12.241901250012551],
              [-17.034127214819517, 12.252275154519452],
              [-17.04507742005402, 12.257556907662337],
              [-17.05219875338785, 12.266984206516439],
              [-17.0589706972681, 12.26959083117748],
              [-17.064177469356693, 12.273139410715466],
              [-17.065792346848163, 12.278113232012666],
              [-17.059923890218705, 12.28325970984688],
              [-17.05858387977852, 12.279572247182811],
              [-17.059542096143943, 12.27638409215969],
              [-17.05469760619164, 12.272476814124833],
              [-17.053830399738253, 12.269422715659108],
              [-17.043575963806163, 12.26583742780813],
              [-17.031050686150234, 12.263164326699648],
              [-17.025609962199187, 12.261108277029193],
              [-17.02494900979321, 12.252758155121356],
              [-17.02136089507978, 12.243553006245572],
              [-17.01709421876395, 12.239487874106649],
              [-17.01329743034511, 12.238901561671957],
              [-17.010650252885476, 12.24116807615977],
              [-17.008699922503563, 12.24626316003617],
              [-17.001510869118945, 12.24415156142303],
              [-16.999695292651243, 12.246224043549917],
              [-16.99502862934818, 12.246344077942798],
              [-16.99159191161579, 12.251503680383536],
              [-16.987804657073905, 12.251705619799372],
              [-16.98366037807584, 12.255103145658007],
              [-16.97779229069604, 12.265940405892811],
              [-16.9737888515476, 12.270359180183672],
              [-16.976991640489018, 12.276297228165754],
              [-16.978413849797732, 12.285283095425468],
              [-16.98209325181411, 12.288362616344665],
              [-16.98089974510108, 12.291144730761884],
              [-16.98257145402154, 12.296033249976992],
              [-16.99172003691806, 12.301696835297651],
              [-16.99700607189144, 12.314881938365902],
              [-17.002130158399282, 12.324395230676048]
            ]
          ],
          [
            [
              [-17.194826890197156, 12.199326650262838],
              [-17.18569078682019, 12.199198305034876],
              [-17.184015013624176, 12.193647472739569],
              [-17.18596779678659, 12.189277835786614],
              [-17.188964468293292, 12.188080664158576],
              [-17.194625131841303, 12.193555754435232],
              [-17.194826890197156, 12.199326650262838]
            ]
          ],
          [
            [
              [-17.192390289550993, 12.209789414834388],
              [-17.187872996054924, 12.214251238785836],
              [-17.17883078471618, 12.212335218558737],
              [-17.174382138792712, 12.213936338913935],
              [-17.176739312265152, 12.202009043411337],
              [-17.18747255890014, 12.203826401499756],
              [-17.192643237464626, 12.207698870997696],
              [-17.192390289550993, 12.209789414834388]
            ]
          ],
          [
            [
              [-17.18029972018171, 12.313693992133723],
              [-17.175376963973623, 12.314090094840704],
              [-17.17183403531356, 12.316062158711942],
              [-17.170396724038977, 12.32167593520739],
              [-17.16685357048826, 12.32196779847754],
              [-17.165292375071846, 12.327846083372265],
              [-17.159816523750873, 12.330401477404187],
              [-17.1547214130492, 12.330950059730332],
              [-17.148980202852186, 12.320161162567816],
              [-17.147176796143075, 12.315067628600916],
              [-17.14732765964501, 12.309699870586888],
              [-17.151231051247873, 12.308618975185867],
              [-17.147353514246284, 12.299257258556564],
              [-17.142367835246503, 12.29465926079495],
              [-17.138968631160985, 12.28337304418998],
              [-17.145495497300963, 12.28292931847804],
              [-17.153342001448344, 12.278947785145096],
              [-17.16017792538508, 12.277183504674253],
              [-17.15174914881108, 12.272656494869125],
              [-17.15379826448874, 12.266295277317353],
              [-17.164858398912084, 12.267512658640811],
              [-17.17028560134763, 12.266508924793495],
              [-17.17781491592093, 12.267459389590066],
              [-17.180873859731427, 12.26919519689441],
              [-17.17856698797495, 12.275405170690254],
              [-17.179364132091123, 12.278129070620317],
              [-17.175096379854338, 12.286075648875215],
              [-17.172791438956423, 12.288275166481844],
              [-17.174501070079646, 12.291448427568556],
              [-17.179198235696255, 12.29387804376656],
              [-17.18193812772145, 12.298075966596604],
              [-17.18267765544285, 12.303203452893117],
              [-17.179527256936268, 12.31007497071152],
              [-17.18029972018171, 12.313693992133723]
            ]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -121.72880474857395, "lat": 48.4794592097513 },
        "year": "2023",
        "ste_code": ["53"],
        "ste_name": ["Washington"],
        "coty_code": ["53057"],
        "coty_name": ["Skagit"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Skagit County"],
        "coty_fp_code": "057",
        "coty_gnis_code": "01531402"
      },
      "bbox": [
        -17.194826890197156, 11.737816533957956, -15.860624336825557,
        12.343433196421994
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [11.969914690942316, -0.39855407136571386],
            [11.974347112729957, -0.39929824528749225],
            [11.977198707895749, -0.4031153451847748],
            [11.985884580773394, -0.40764440800208585],
            [11.990039247853492, -0.40175652562009256],
            [11.992874153846584, -0.3997892664638111],
            [11.987756544731472, -0.39195420930099845],
            [11.986672172180617, -0.38661695724447354],
            [11.98129170906469, -0.38196626340120027],
            [11.980899033245095, -0.3799488083694341],
            [11.97039495238324, -0.372495079959547],
            [11.970433410766178, -0.3687599480245688],
            [11.967420701882789, -0.3635442851630202],
            [11.97530940404194, -0.35911885353090783],
            [11.975630496759198, -0.3517513934152062],
            [11.985698740239839, -0.34874244724044323],
            [11.991828721162756, -0.339906489448348],
            [11.991208691006767, -0.33389572174072923],
            [11.99631439034247, -0.327226350241107],
            [11.995827900786113, -0.3225314972966839],
            [11.999244849102006, -0.31801850378794644],
            [12.005376395063367, -0.3139647241421058],
            [12.011036937365699, -0.3120006303384722],
            [12.014122357347592, -0.3068160027413571],
            [12.018764361438558, -0.3067543892499029],
            [12.020963495380599, -0.3034335042862128],
            [12.025698382619773, -0.3020373263807942],
            [12.032437540401869, -0.30274383451512105],
            [12.031968534298326, -0.2941824230636988],
            [12.034859201761524, -0.2904816206060385],
            [12.035038968538348, -0.2855471249464827],
            [12.031640720653792, -0.2804564544495145],
            [12.03618441426127, -0.27708694680389073],
            [12.038184457842675, -0.2695678288424117],
            [12.035496923073717, -0.2639712315686153],
            [12.034765908760756, -0.25645862525682134],
            [12.036163409454934, -0.25037713219287194],
            [12.033367738168561, -0.2445143725563941],
            [12.035211647739676, -0.24310051560621146],
            [12.033544414312194, -0.23424759571998874],
            [12.036722907919643, -0.23365957298524714],
            [12.03865048371577, -0.23008994092705978],
            [12.049689223761755, -0.2270262807042371],
            [12.04980568377235, -0.2227146939267975],
            [12.052282716281251, -0.22028071872113625],
            [12.05809479610256, -0.21834410691062117],
            [12.063376296405751, -0.21454725539700356],
            [12.064595077009836, -0.21169853526125584],
            [12.069870870128867, -0.21291207902125012],
            [12.072153996792611, -0.20723659321249177],
            [12.079218257706723, -0.20418071353315792],
            [12.083554371063055, -0.20850606337875596],
            [12.088562876313997, -0.20802256754880322],
            [12.093115159019858, -0.21169896132409904],
            [12.096538930263122, -0.2102383311441242],
            [12.101007237736171, -0.2048299192552095],
            [12.106084648542629, -0.20841650988899116],
            [12.112289584354318, -0.20842320390955704],
            [12.221430620318298, -0.276802333419172],
            [12.29872970335798, -0.32432424799664356],
            [12.319934915515473, -0.33801133194537236],
            [12.317140694441727, -0.3483101618843307],
            [12.320291188513607, -0.356086056369286],
            [12.308841386645344, -0.38645281020300365],
            [12.34103378088475, -0.41914731759721174],
            [12.32718339206886, -0.4298977230974388],
            [12.320087641019402, -0.44092573962912807],
            [12.306421857646065, -0.45733439420778366],
            [12.29326988754013, -0.4684768852907301],
            [12.284570310637115, -0.47323363543732666],
            [12.272633787470172, -0.4822988018221335],
            [12.25870746967145, -0.4883190645915589],
            [12.253115666482817, -0.48994079598011736],
            [12.248040989148322, -0.4894214445634638],
            [12.245942742043166, -0.48640209148318947],
            [12.246958923893668, -0.47984359370117663],
            [12.23461589340481, -0.4846048930758311],
            [12.225485210027738, -0.4896076172160047],
            [12.215302947251061, -0.4931996035248666],
            [12.20405012971003, -0.4989659036742577],
            [12.168538677724504, -0.5105745922984],
            [12.160404870252178, -0.5136613881089321],
            [12.147222313685106, -0.5199796948410735],
            [12.125487422342555, -0.5329479257793219],
            [12.113189388820556, -0.5387518899912608],
            [12.107302803205114, -0.5422347078593605],
            [12.09941198130791, -0.5484862168403428],
            [12.081024203467987, -0.5666710473470038],
            [12.066462314835409, -0.5772730707336866],
            [11.982442533090225, -0.5245327498355998],
            [11.943765857877846, -0.49134285508592646],
            [11.969914690942316, -0.39855407136571386]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -81.11139685690586, "lat": 37.40545657819267 },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54055"],
        "coty_name": ["Mercer"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Mercer County"],
        "coty_fp_code": "055",
        "coty_gnis_code": "01557645"
      },
      "bbox": [
        11.943765857877846, -0.5772730707336866, 12.34103378088475,
        -0.20418071353315792
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [13.864763389142148, 2.1925042624185025],
            [13.885339570716567, 2.1893124234080656],
            [13.905879132298056, 2.1838033501774965],
            [13.918341254495434, 2.1844573916693877],
            [13.920402357250346, 2.1877788372959777],
            [13.919642636360782, 2.196657054217456],
            [13.923921300012246, 2.2073442283347906],
            [13.928559819072662, 2.213012605719201],
            [13.933680220242833, 2.2214967069251226],
            [13.94057681775035, 2.2276400514953765],
            [13.942343817885783, 2.2339390921515125],
            [13.934013248694194, 2.2404364201828697],
            [13.933467881118043, 2.2428009603268753],
            [13.937208365747484, 2.2468399195607174],
            [13.95264460198437, 2.249625550192939],
            [13.955380514019724, 2.2508240467067013],
            [13.959039545327078, 2.2570816619988543],
            [13.960908018622174, 2.264666377603837],
            [13.96703166384969, 2.2719776791592268],
            [13.97547393908384, 2.2740936921913795],
            [13.98276129948229, 2.273454923737814],
            [13.989310821089513, 2.271503367592213],
            [13.997336812010133, 2.272905432049929],
            [14.006052569304519, 2.2710352187309892],
            [14.012868955138996, 2.270970946246459],
            [14.025595189949088, 2.2697836158190925],
            [14.034372887090175, 2.2673728583504786],
            [14.0410557094621, 2.261979484133767],
            [14.046824937482084, 2.262563653482929],
            [14.050804336607866, 2.26097520257711],
            [14.073892483507846, 2.244153948015947],
            [14.078050933880759, 2.2397112426111745],
            [14.0882037823868, 2.234065738656491],
            [14.094155717763421, 2.2267234575781405],
            [14.10144709249488, 2.220044744401493],
            [14.098879046625196, 2.2209938404244225],
            [14.091649850242913, 2.2190395560757694],
            [14.092267169796209, 2.2147110192847888],
            [14.089935920147116, 2.2107215579367607],
            [14.087572597839124, 2.2107720997773863],
            [14.085551964016737, 2.205157038918387],
            [14.077577737272938, 2.1936825728025253],
            [14.072835056273108, 2.1937744862847026],
            [14.062065208076682, 2.1921082923661848],
            [14.058392950424071, 2.1887640762048197],
            [14.057232281228442, 2.185431522525406],
            [14.055701392101266, 2.173590887577423],
            [14.054252628292357, 2.1726330383256296],
            [14.04224050825218, 2.175884222999237],
            [14.036121256373029, 2.1811843360147285],
            [14.01895683232708, 2.177819791751284],
            [14.01726508783815, 2.1693326655687346],
            [14.01525811568404, 2.153737123504627],
            [14.013120631089249, 2.1458339166447065],
            [14.011657738966889, 2.1348482263463917],
            [14.01179801660586, 2.1282810421927847],
            [14.006884552434776, 2.1043740409914866],
            [14.006222965727348, 2.097188562661634],
            [14.007285063743742, 2.0934554313251166],
            [14.004803285462344, 2.0789263351838496],
            [14.002570428562814, 2.0579769027778374],
            [14.00273578128421, 2.04939355571952],
            [14.001660857695818, 2.0400792492527877],
            [14.00195857448315, 2.025620938966429],
            [14.001593336307437, 2.018238918526387],
            [13.997987244814027, 2.007201906761487],
            [13.99672020249154, 1.9970308999938633],
            [13.995207556128946, 1.9918232003527683],
            [13.992777465877774, 1.9774493092811127],
            [13.989991227311462, 1.9682140895204936],
            [13.989592239760087, 1.9642676209418606],
            [13.95967686167564, 1.9823245383807173],
            [13.9380297148285, 1.9930595283862362],
            [13.886638285955508, 2.021639097559692],
            [13.875696786657228, 2.0235412876116396],
            [13.855879194587137, 2.0284217495846075],
            [13.812226198366577, 2.0426701680650874],
            [13.78586598079146, 2.0548969448443337],
            [13.789427963005428, 2.0597183298148094],
            [13.789937988758084, 2.065095304210201],
            [13.786981932368226, 2.072407613293573],
            [13.787852693221195, 2.076455165351072],
            [13.79563722950959, 2.0784310834190562],
            [13.79625701797732, 2.082799357422895],
            [13.79437479361093, 2.084399849741225],
            [13.786881109895605, 2.0849061443981953],
            [13.785816893151358, 2.090183273412079],
            [13.79286458505379, 2.0904803620036727],
            [13.795655659441671, 2.088976671575413],
            [13.801377154928021, 2.0828656049787924],
            [13.805926098968383, 2.0817438585698023],
            [13.806272714598249, 2.0866175123570976],
            [13.801609377702134, 2.093907916201905],
            [13.806873399795666, 2.0954239124238536],
            [13.811650084616769, 2.0903008157082974],
            [13.817104305753208, 2.090097166413935],
            [13.81834417561278, 2.0946362022581595],
            [13.80963214992599, 2.102810033153759],
            [13.800081443221421, 2.10550903641006],
            [13.789686581377016, 2.111125964240752],
            [13.785921484473421, 2.113943016380711],
            [13.781816141140133, 2.119443697329776],
            [13.781391983678171, 2.1264992786839985],
            [13.785374288881822, 2.13012994475234],
            [13.791207921321533, 2.1322061284684457],
            [13.803234736491053, 2.1298986637357697],
            [13.811462012226976, 2.125683787971276],
            [13.819914469749328, 2.1246807868760493],
            [13.824938190795605, 2.127284498641008],
            [13.828411449771762, 2.1320407788685505],
            [13.825676541862336, 2.1377036527097886],
            [13.82112610743845, 2.1403041027150085],
            [13.812620661096933, 2.143551270794985],
            [13.805883127230272, 2.147290895005991],
            [13.795623294517426, 2.156969946351698],
            [13.793348387260785, 2.1604186039391213],
            [13.794945231124998, 2.16587947404793],
            [13.802086145833979, 2.1679643257159054],
            [13.808397565224215, 2.166137945352703],
            [13.822105192250897, 2.1635568645222625],
            [13.82663244149472, 2.160341839640081],
            [13.832616959766979, 2.1581738291869104],
            [13.836811978048452, 2.158206703502283],
            [13.84029694369006, 2.1602474883093032],
            [13.84037902396045, 2.1631025553112924],
            [13.830610586802315, 2.1714817754111233],
            [13.829853998965605, 2.1774665974959975],
            [13.836426958597205, 2.18100041088922],
            [13.845258266549362, 2.1781308431384967],
            [13.848451798130453, 2.1782497177563873],
            [13.851401449551284, 2.1810005318977868],
            [13.85098408090934, 2.184067744683615],
            [13.846293537052672, 2.1881156480399557],
            [13.845888365329941, 2.19221753034405],
            [13.850502509118563, 2.193931188737016],
            [13.864763389142148, 2.1925042624185025]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -78.25775160912887,
          "lat": 39.560400933678224
        },
        "year": "2023",
        "ste_code": ["54"],
        "ste_name": ["West Virginia"],
        "coty_code": ["54065"],
        "coty_name": ["Morgan"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Morgan County"],
        "coty_fp_code": "065",
        "coty_gnis_code": "01557950"
      },
      "bbox": [
        13.781391983678171, 1.9642676209418606, 14.10144709249488,
        2.2740936921913795
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [5.882559028573592, 5.790135597809408],
            [5.926115156740909, 5.793200764113278],
            [5.996895523566061, 5.797980084462617],
            [6.033253134809193, 5.800153273706313],
            [6.061810577122268, 5.80181747048722],
            [6.139640303341567, 5.8080207095265255],
            [6.144189476376125, 5.749499221535572],
            [6.146690180639521, 5.7209430039973865],
            [6.156987311642717, 5.606760700656675],
            [6.162397908312482, 5.5475491060182325],
            [6.168298736916271, 5.4812876314952925],
            [6.169987565729391, 5.460471210045583],
            [6.14118785378117, 5.458147387350345],
            [6.0838125585163025, 5.453144700268392],
            [6.08043800338057, 5.499161840395703],
            [6.030532536495243, 5.494920677272864],
            [5.970835974785637, 5.490214452874775],
            [5.906981586713951, 5.485630067410584],
            [5.904260535472512, 5.527296554474222],
            [5.893857206234982, 5.645061163943413],
            [5.893178071831316, 5.656969931428636],
            [5.889360319269803, 5.701739410958498],
            [5.885686594086213, 5.747213406964155],
            [5.883402582155032, 5.7809385455337425],
            [5.882559028573592, 5.790135597809408]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": {
          "lon": -88.21804747683863,
          "lat": 44.081593950012746
        },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55015"],
        "coty_name": ["Calumet"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Calumet County"],
        "coty_fp_code": "015",
        "coty_gnis_code": "01581067"
      },
      "bbox": [
        5.882559028573592, 5.453144700268392, 6.169987565729391,
        5.8080207095265255
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [4.611553949235287, 7.348136078103758],
            [4.6542405723009495, 7.3509080677505],
            [4.667657084253037, 7.352077756978828],
            [4.740100459938869, 7.35720691742551],
            [4.782990454725654, 7.360049954757482],
            [4.845569238039759, 7.364475819833461],
            [4.939855598406331, 7.370865192636971],
            [5.040830524115228, 7.377320541221301],
            [5.077052341258074, 7.380913628516505],
            [5.0844112291551715, 7.380986787524618],
            [5.1273535617713115, 7.386416548561766],
            [5.129895371378803, 7.346100123984433],
            [5.137064217084694, 7.346071093480127],
            [5.159662981201074, 7.3494198500468055],
            [5.1892954171297205, 7.34985887324724],
            [5.204329545958223, 7.348266621876213],
            [5.217594376002866, 7.3482162829047875],
            [5.212816199710709, 7.390307593662939],
            [5.228102697825605, 7.389135011336108],
            [5.25207591532208, 7.389307895386644],
            [5.296449668515143, 7.392613327757877],
            [5.303518050329954, 7.392919034613265],
            [5.309877494325176, 7.309907890113918],
            [5.31670459370139, 7.216528488114404],
            [5.317633229755912, 7.209410260995673],
            [5.322836255912979, 7.137766658405566],
            [5.327838197539597, 7.073148123652458],
            [5.335772421049259, 6.966798113840051],
            [5.3208805319693555, 6.9668242130657125],
            [5.246266642831899, 6.9640470319352845],
            [5.231476459267302, 6.96320347295883],
            [5.216953521938813, 6.961735244611858],
            [5.19481362147267, 6.960848341557369],
            [5.127096104064537, 6.957492339079374],
            [5.070936383394703, 6.9507706998030745],
            [5.070157398069814, 6.961648225156353],
            [5.067303955008408, 6.988072279506148],
            [5.066033198383617, 6.995107535961109],
            [5.062766606647495, 7.0315338436221815],
            [5.062441431177329, 7.037924363619819],
            [4.9639924537906115, 7.031726688582977],
            [4.891906582634978, 7.026769257807957],
            [4.86253585447413, 7.024646155947833],
            [4.7905024987693965, 7.019925173454747],
            [4.71889490803329, 7.014955074632526],
            [4.656988411320683, 7.010957343443955],
            [4.632584211505431, 7.009495499771037],
            [4.630705681538991, 7.036720649911798],
            [4.628245041602878, 7.078296321764666],
            [4.625600015856157, 7.115989990316851],
            [4.622757857219199, 7.168867861595061],
            [4.621561788313133, 7.183019291717742],
            [4.614908704314353, 7.269257689888385],
            [4.612161713739295, 7.338796404542128],
            [4.611553949235287, 7.348136078103758]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -89.52174531331332, "lat": 45.70553578135528 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55085"],
        "coty_name": ["Oneida"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Oneida County"],
        "coty_fp_code": "085",
        "coty_gnis_code": "01581103"
      },
      "bbox": [
        4.611553949235287, 6.9507706998030745, 5.335772421049259,
        7.392919034613265
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [6.200237739608334, 5.112452570181029],
            [6.250212999289943, 5.117031798428308],
            [6.2860565924937335, 5.120702990459525],
            [6.34371180796607, 5.125322184668921],
            [6.378921821350868, 5.128289452446704],
            [6.378937245950656, 5.109875802380007],
            [6.381484341742592, 5.08530952723246],
            [6.383482229615713, 5.0776820980480375],
            [6.378377288595272, 5.059311574304631],
            [6.37711599903829, 5.0481327341896725],
            [6.372161531083146, 5.038933247492888],
            [6.372092209500397, 5.034688857266066],
            [6.369291894675054, 5.032273033314845],
            [6.362803091042808, 5.01824533712685],
            [6.3449631611659125, 4.987170047066179],
            [6.339182771049672, 4.974748308830299],
            [6.339028990190459, 4.971527941377296],
            [6.336451527510312, 4.968105464873813],
            [6.337496911509597, 4.9658777424175575],
            [6.334960223701805, 4.960931472104516],
            [6.332336079156287, 4.949711687382126],
            [6.330241706742272, 4.9323136396829],
            [6.329936527165994, 4.919949317037781],
            [6.330204193416407, 4.9008758556023375],
            [6.329135857434096, 4.8875517610581865],
            [6.3277736637559165, 4.881545112741978],
            [6.322030259104747, 4.863292281879869],
            [6.317736913405027, 4.829042324451622],
            [6.320203332421692, 4.814677143669511],
            [6.325715761805456, 4.803209331963459],
            [6.3316885353484516, 4.793935017374232],
            [6.332851872537713, 4.7884825683517604],
            [6.332076168122943, 4.783857174578832],
            [6.3334912716810745, 4.776802273726497],
            [6.336957098678693, 4.772005780273774],
            [6.256173171746015, 4.765709408146525],
            [6.213182729238676, 4.76164356516031],
            [6.209133128845224, 4.805051352990202],
            [6.203812700978815, 4.877191784082441],
            [6.199165915369154, 4.936520201724203],
            [6.2152946631065, 4.93846403005565],
            [6.2097799377120095, 4.995560120414778],
            [6.200237739608334, 5.112452570181029]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -87.95092905739276, "lat": 43.38403727636232 },
        "year": "2023",
        "ste_code": ["55"],
        "ste_name": ["Wisconsin"],
        "coty_code": ["55089"],
        "coty_name": ["Ozaukee"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Ozaukee County"],
        "coty_fp_code": "089",
        "coty_gnis_code": "01581105"
      },
      "bbox": [
        6.199165915369154, 4.76164356516031, 6.383482229615713,
        5.128289452446704
      ]
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [-7.843908861537985, 5.334739075789842],
            [-7.8193590724119755, 5.331697832679678],
            [-7.782748336419392, 5.3278787996715895],
            [-7.765568156510742, 5.325553309851073],
            [-7.625790279539857, 5.308727854415462],
            [-7.623144780025498, 5.307377591166338],
            [-7.539964445606257, 5.297429452521153],
            [-7.5410263762428285, 5.289572063819663],
            [-7.391638681029316, 5.27225374205083],
            [-7.242256851946154, 5.254885257176567],
            [-7.114736961985079, 5.24048526400151],
            [-7.103168841908655, 5.239745904230349],
            [-7.0645200472045495, 5.235883978594321],
            [-6.932071921821014, 5.222489453230722],
            [-6.799627593078929, 5.209055617054081],
            [-6.802084651805711, 5.187207413373226],
            [-6.798940552093497, 5.186945651256193],
            [-6.8356466409477825, 4.84256461791809],
            [-6.836996316346322, 4.8429081884970255],
            [-6.8623443113991724, 4.586540914433048],
            [-6.871927103196414, 4.495127561924886],
            [-6.875140788472374, 4.495266745423684],
            [-6.878777819657094, 4.455006419347497],
            [-6.877471073734815, 4.454867794195355],
            [-6.8791421512839515, 4.439208893914475],
            [-6.880458820684852, 4.435817105274836],
            [-6.881768107845718, 4.423549683018551],
            [-6.8803155038334785, 4.423395587297774],
            [-6.881465009401004, 4.412622921304994],
            [-6.883001128135195, 4.412685002028124],
            [-6.8844640709621725, 4.399459527914666],
            [-6.905947034047049, 4.194136294149057],
            [-6.908631454375516, 4.165810221542215],
            [-6.910964619231034, 4.151204843442771],
            [-7.033179186304111, 4.164498477809458],
            [-7.172366982399546, 4.178333343642515],
            [-7.3115582764259335, 4.192130647359585],
            [-7.312001943140462, 4.1923257790866035],
            [-7.416500258648185, 4.205490712110986],
            [-7.5210013890645016, 4.218634356723441],
            [-7.541457461715312, 4.22115182420169],
            [-7.6473636337073945, 4.233977752349947],
            [-7.753272489684498, 4.246781827714456],
            [-7.85918400398693, 4.259564046686085],
            [-7.9650981508847, 4.272324406166469],
            [-7.979002267161736, 4.274015130976602],
            [-7.977155293508004, 4.289505379067606],
            [-7.937791059174064, 4.619697584823414],
            [-7.907287243803242, 4.616094346479277],
            [-7.897025792236656, 4.7031520080949525],
            [-7.896457865403688, 4.70867847227493],
            [-7.865859634227306, 4.96097991413116],
            [-7.876249448949613, 4.962138644285614],
            [-7.866041002123449, 5.046854122635911],
            [-7.865189486289344, 5.046649968933883],
            [-7.834590425890108, 5.304682417080044],
            [-7.847484771733168, 5.3063478882071164],
            [-7.843908861537985, 5.334739075789842]
          ]
        ]
      },
      "properties": {
        "geo_point_2d": { "lon": -106.79861238121448, "lat": 42.9621708042333 },
        "year": "2023",
        "ste_code": ["56"],
        "ste_name": ["Wyoming"],
        "coty_code": ["56025"],
        "coty_name": ["Natrona"],
        "coty_area_code": "USA",
        "coty_type": "county",
        "coty_name_long": ["Natrona County"],
        "coty_fp_code": "025",
        "coty_gnis_code": "01605077"
      },
      "bbox": [
        -7.979002267161736, 4.151204843442771, -6.798940552093497,
        5.334739075789842
      ]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -168.14474033333335,
          "lat": -14.54686866620736
        },
        "year": "2023",
        "ste_code": ["60"],
        "ste_name": ["American Samoa"],
        "coty_code": ["60030"],
        "coty_name": ["Rose Island"],
        "coty_area_code": "ASM",
        "coty_type": null,
        "coty_name_long": ["Rose Island"],
        "coty_fp_code": "030",
        "coty_gnis_code": "01805243"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -66.42032280982299,
          "lat": 18.317129233003097
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72101"],
        "coty_name": ["Morovis"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["Morovis Municipio"],
        "coty_fp_code": "101",
        "coty_gnis_code": "01804531"
      },
      "bbox": [null, null, null, null]
    },
    {
      "type": "Feature",
      "geometry": null,
      "properties": {
        "geo_point_2d": {
          "lon": -67.03843058844521,
          "lat": 18.111106935559242
        },
        "year": "2023",
        "ste_code": ["72"],
        "ste_name": ["Puerto Rico"],
        "coty_code": ["72125"],
        "coty_name": ["San Germán"],
        "coty_area_code": "PRI",
        "coty_type": "municipio",
        "coty_name_long": ["San Germán Municipio"],
        "coty_fp_code": "125",
        "coty_gnis_code": "01804543"
      },
      "bbox": [null, null, null, null]
    }
  ]
}
